// Generated from groups.csv and values.csv by scripts/generate-localization-catalogs.js.
export const supportedLocales = [
  {
    "code": "en",
    "label": "English",
    "nativeLabel": "English"
  },
  {
    "code": "fr",
    "label": "French",
    "nativeLabel": "Français"
  },
  {
    "code": "ar",
    "label": "Arabic",
    "nativeLabel": "العربية"
  },
  {
    "code": "es",
    "label": "Spanish",
    "nativeLabel": "Español"
  },
  {
    "code": "pt",
    "label": "Portuguese",
    "nativeLabel": "Português"
  },
  {
    "code": "ta",
    "label": "Tamil",
    "nativeLabel": "தமிழ்"
  },
  {
    "code": "ru",
    "label": "Russian",
    "nativeLabel": "Русский"
  },
  {
    "code": "id",
    "label": "Indonesian",
    "nativeLabel": "Bahasa Indonesia"
  },
  {
    "code": "it",
    "label": "Italian",
    "nativeLabel": "Italiano"
  },
  {
    "code": "tr",
    "label": "Turkish",
    "nativeLabel": "Türkçe"
  }
];

export const messages = {
  "en": {
    "0": "0",
    "6100": "6100",
    "common.language": "Language",
    "Language": "Language",
    "common.english": "English",
    "English": "English",
    "common.french": "French",
    "French": "French",
    "common.arabic": "Arabic",
    "Arabic": "Arabic",
    "navigation.get_started": "Get Started",
    "Get Started": "Get Started",
    "navigation.dashboard": "Dashboard",
    "Dashboard": "Dashboard",
    "navigation.orders": "Orders",
    "Orders": "Orders",
    "navigation.schedule": "Schedule",
    "Schedule": "Schedule",
    "navigation.accounts": "Accounts",
    "Accounts": "Accounts",
    "navigation.account_categories": "Account Categories",
    "Account Categories": "Account Categories",
    "navigation.account_attributes": "Account Attributes",
    "Account Attributes": "Account Attributes",
    "navigation.account_configuration": "Account Configuration",
    "Account Configuration": "Account Configuration",
    "navigation.agents": "Agents",
    "Agents": "Agents",
    "navigation.listings": "Listings",
    "Listings": "Listings",
    "navigation.categories": "Categories",
    "Categories": "Categories",
    "navigation.custom_attributes": "Custom Attributes",
    "Custom Attributes": "Custom Attributes",
    "navigation.variant_types": "Variant Types",
    "Variant Types": "Variant Types",
    "navigation.additional_features": "Additional Features",
    "Additional Features": "Additional Features",
    "navigation.reported_listings": "Reported Listings",
    "Reported Listings": "Reported Listings",
    "navigation.report_accounts": "Report Accounts",
    "Report Accounts": "Report Accounts",
    "navigation.users": "Users",
    "Users": "Users",
    "navigation.user_attributes": "User Attributes",
    "User Attributes": "User Attributes",
    "navigation.reviews_ratings": "Reviews & Ratings",
    "Reviews & Ratings": "Reviews & Ratings",
    "navigation.report": "Report",
    "Report": "Report",
    "navigation.reports": "Reports",
    "Reports": "Reports",
    "navigation.platform_health": "Platform Health",
    "Platform Health": "Platform Health",
    "navigation.promotions": "Promotions",
    "Promotions": "Promotions",
    "navigation.collections": "Collections",
    "Collections": "Collections",
    "navigation.promotion_ads": "Promotion / Ads",
    "Promotion / Ads": "Promotion / Ads",
    "navigation.coupons": "Coupons",
    "Coupons": "Coupons",
    "navigation.finance": "Finance",
    "Finance": "Finance",
    "navigation.transactions": "Transactions",
    "Transactions": "Transactions",
    "navigation.settlement": "Settlement",
    "Settlement": "Settlement",
    "navigation.expenses": "Expenses",
    "Expenses": "Expenses",
    "navigation.recurring_payments": "Recurring payments",
    "Recurring payments": "Recurring payments",
    "navigation.media": "Media",
    "Media": "Media",
    "navigation.communication": "Communication",
    "Communication": "Communication",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Website Editor",
    "Website Editor": "Website Editor",
    "navigation.change_templates": "Change Templates",
    "Change Templates": "Change Templates",
    "navigation.pages": "Pages",
    "Pages": "Pages",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Customise texts",
    "Customise texts": "Customise texts",
    "navigation.add_integrations": "Add Integrations",
    "Add Integrations": "Add Integrations",
    "navigation.domain": "Domain",
    "Domain": "Domain",
    "navigation.customise_seo": "Customise SEO",
    "Customise SEO": "Customise SEO",
    "navigation.app": "App",
    "App": "App",
    "navigation.apps": "Apps",
    "Apps": "Apps",
    "navigation.buy_app_templates": "Buy App Templates",
    "Buy App Templates": "Buy App Templates",
    "navigation.customisation": "Customisation",
    "Customisation": "Customisation",
    "navigation.integrations": "Integrations",
    "Integrations": "Integrations",
    "navigation.invite_team": "Invite Team",
    "Invite Team": "Invite Team",
    "navigation.help": "Help",
    "Help": "Help",
    "navigation.documentation": "Documentation",
    "Documentation": "Documentation",
    "navigation.community": "Community",
    "Community": "Community",
    "navigation.api_reference": "API Reference",
    "API Reference": "API Reference",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Channels",
    "Channels": "Channels",
    "navigation.coding_kits": "Coding Kits",
    "Coding Kits": "Coding Kits",
    "navigation.vibe_coding": "Vibe Coding",
    "Vibe Coding": "Vibe Coding",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Settings",
    "Settings": "Settings",
    "navigation.more": "More",
    "More": "More",
    "navigation.marketplace": "Marketplace",
    "Marketplace": "Marketplace",
    "navigation.commerce": "Commerce",
    "Commerce": "Commerce",
    "navigation.marketing": "Marketing",
    "Marketing": "Marketing",
    "navigation.intelligence": "Intelligence",
    "Intelligence": "Intelligence",
    "navigation.subscription": "Subscription",
    "Subscription": "Subscription",
    "navigation.membership": "Membership",
    "Membership": "Membership",
    "navigation.rewards": "Rewards",
    "Rewards": "Rewards",
    "navigation.bundles": "Bundles",
    "Bundles": "Bundles",
    "navigation.supply_chain": "Supply Chain",
    "Supply Chain": "Supply Chain",
    "navigation.people": "People",
    "People": "People",
    "navigation.workforce": "Workforce",
    "Workforce": "Workforce",
    "navigation.payroll": "Payroll",
    "Payroll": "Payroll",
    "navigation.inventory": "Inventory",
    "Inventory": "Inventory",
    "navigation.inventory_operations": "Inventory Operations",
    "Inventory Operations": "Inventory Operations",
    "navigation.purchase_orders": "Purchase Orders",
    "Purchase Orders": "Purchase Orders",
    "navigation.stock_locations": "Stock Locations",
    "Stock Locations": "Stock Locations",
    "navigation.purchase_orders_2": "Purchase orders",
    "Purchase orders": "Purchase orders",
    "navigation.suppliers": "Suppliers",
    "Suppliers": "Suppliers",
    "navigation.locations": "Locations",
    "Locations": "Locations",
    "navigation.maps": "Maps",
    "Maps": "Maps",
    "navigation.accounting": "Accounting",
    "Accounting": "Accounting",
    "navigation.invoices": "Invoices",
    "Invoices": "Invoices",
    "navigation.plans": "Plans",
    "Plans": "Plans",
    "navigation.countries": "Countries",
    "Countries": "Countries",
    "navigation.currency": "Currency",
    "Currency": "Currency",
    "navigation.languages": "Languages",
    "Languages": "Languages",
    "navigation.payments": "Payments",
    "Payments": "Payments",
    "navigation.commissions": "Commissions",
    "Commissions": "Commissions",
    "navigation.taxes": "Taxes",
    "Taxes": "Taxes",
    "navigation.special_fees": "Special Fees",
    "Special Fees": "Special Fees",
    "navigation.service_shipping": "Service / Shipping",
    "Service / Shipping": "Service / Shipping",
    "navigation.checkout_cart_attributes": "Checkout & Cart Attributes",
    "Checkout & Cart Attributes": "Checkout & Cart Attributes",
    "navigation.dark_mode_background_color": "Dark Mode Background Color",
    "Dark Mode Background Color": "Dark Mode Background Color",
    "navigation.dark_mode_text_color": "Dark Mode Text Color",
    "Dark Mode Text Color": "Dark Mode Text Color",
    "navigation.light_mode_background_color": "Light Mode Background Color",
    "Light Mode Background Color": "Light Mode Background Color",
    "navigation.light_mode_text_color": "Light Mode Text Color",
    "Light Mode Text Color": "Light Mode Text Color",
    "navigation.workspace": "Workspace",
    "Workspace": "Workspace",
    "navigation.user_management": "User Management",
    "User Management": "User Management",
    "navigation.privacy": "Privacy",
    "Privacy": "Privacy",
    "common.search": "Search...",
    "Search...": "Search...",
    "common.search_2": "Search",
    "Search": "Search",
    "common.no_results_found": "No results found",
    "No results found": "No results found",
    "common.no_record_found": "No Record Found",
    "No Record Found": "No Record Found",
    "common.open_in_a_new_tab": "Open in a new tab",
    "Open in a new tab": "Open in a new tab",
    "common.open": "Open",
    "Open": "Open",
    "common.in_a_new_tab": "in a new tab",
    "in a new tab": "in a new tab",
    "common.loading_page": "Loading page…",
    "Loading page…": "Loading page…",
    "common.close": "Close",
    "Close": "Close",
    "common.save": "Save",
    "Save": "Save",
    "common.cancel": "Cancel",
    "Cancel": "Cancel",
    "common.delete": "Delete",
    "Delete": "Delete",
    "common.edit": "Edit",
    "Edit": "Edit",
    "common.add": "Add",
    "Add": "Add",
    "common.create": "Create",
    "Create": "Create",
    "common.update": "Update",
    "Update": "Update",
    "common.back": "Back",
    "Back": "Back",
    "common.next": "Next",
    "Next": "Next",
    "common.previous": "Previous",
    "Previous": "Previous",
    "common.done": "Done",
    "Done": "Done",
    "common.yes": "Yes",
    "Yes": "Yes",
    "common.no": "No",
    "No": "No",
    "common.name": "Name",
    "Name": "Name",
    "common.status": "Status",
    "Status": "Status",
    "common.date": "Date",
    "Date": "Date",
    "common.actions": "Actions",
    "Actions": "Actions",
    "common.action": "Action",
    "Action": "Action",
    "orders.scan_order": "Scan order",
    "Scan order": "Scan order",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Scan a barcode/QR reference or enter it manually.",
    "Scan a barcode/QR reference or enter it manually.": "Scan a barcode/QR reference or enter it manually.",
    "orders.camera_scanner": "Camera scanner",
    "Camera scanner": "Camera scanner",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "Camera scanning is not supported here. Enter the order reference below.",
    "Camera scanning is not supported here. Enter the order reference below.": "Camera scanning is not supported here. Enter the order reference below.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "Camera access is unavailable. Enter the order reference below.",
    "Camera access is unavailable. Enter the order reference below.": "Camera access is unavailable. Enter the order reference below.",
    "orders.order_reference_number": "Order reference number",
    "Order reference number": "Order reference number",
    "orders.find_order": "Find order",
    "Find order": "Find order",
    "common.your_orders_will_be_shown_here": "Your orders will be shown here.",
    "Your orders will be shown here.": "Your orders will be shown here.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.",
    "common.reference": "Reference #",
    "Reference #": "Reference #",
    "common.amount": "Amount",
    "Amount": "Amount",
    "orders.order_status": "Order Status",
    "Order Status": "Order Status",
    "orders.payment_status": "Payment Status",
    "Payment Status": "Payment Status",
    "common.payment_method": "Payment Method",
    "Payment Method": "Payment Method",
    "common.shipping_method": "Shipping Method",
    "Shipping Method": "Shipping Method",
    "common.paid": "Paid",
    "Paid": "Paid",
    "common.not_paid": "Not Paid",
    "Not Paid": "Not Paid",
    "common.unpaid": "UnPaid",
    "UnPaid": "UnPaid",
    "common.failed": "Failed",
    "Failed": "Failed",
    "common.incomplete": "Incomplete",
    "Incomplete": "Incomplete",
    "common.order_placed": "Order placed",
    "Order placed": "Order placed",
    "common.order_in_progress": "Order in progress",
    "Order in progress": "Order in progress",
    "common.shipped": "Shipped",
    "Shipped": "Shipped",
    "common.delivered": "Delivered",
    "Delivered": "Delivered",
    "common.cancelled_by_customer": "Cancelled by customer",
    "Cancelled by customer": "Cancelled by customer",
    "common.order_completed": "Order completed",
    "Order completed": "Order completed",
    "common.n_a": "N/A",
    "N/A": "N/A",
    "orders.total_orders": "Total Orders",
    "Total Orders": "Total Orders",
    "orders.page_revenue": "Page Revenue",
    "Page Revenue": "Page Revenue",
    "orders.pending_payment": "Pending Payment",
    "Pending Payment": "Pending Payment",
    "common.failed_payments": "Failed payments",
    "Failed payments": "Failed payments",
    "common.abandoned": "Abandoned",
    "Abandoned": "Abandoned",
    "orders.search_orders_by_reference_number": "Search orders by reference number",
    "Search orders by reference number": "Search orders by reference number",
    "orders.search_by_reference_number": "Search by reference number…",
    "Search by reference number…": "Search by reference number…",
    "orders.export_orders_as_csv": "Export orders as CSV",
    "Export orders as CSV": "Export orders as CSV",
    "orders.manual_order": "Manual Order",
    "Manual Order": "Manual Order",
    "orders.scan_order_reference": "Scan order reference",
    "Scan order reference": "Scan order reference",
    "orders.change_status_to": "Change status to…",
    "Change status to…": "Change status to…",
    "common.apply": "Apply",
    "Apply": "Apply",
    "common.clear": "Clear",
    "Clear": "Clear",
    "orders.pay": "Pay",
    "Pay": "Pay",
    "orders.clear_selection": "Clear selection",
    "Clear selection": "Clear selection",
    "orders.list": "List",
    "List": "List",
    "orders.board": "Board",
    "Board": "Board",
    "orders.filter_orders": "Filter orders",
    "Filter orders": "Filter orders",
    "orders.start_date": "Start Date",
    "Start Date": "Start Date",
    "orders.end_date": "End Date",
    "End Date": "End Date",
    "orders.select_date": "Select Date",
    "Select Date": "Select Date",
    "orders.show_rows": "Show rows",
    "Show rows": "Show rows",
    "common.order_selected": "order selected",
    "order selected": "order selected",
    "common.orders_selected": "orders selected",
    "orders selected": "orders selected",
    "common.order_updated": "order updated",
    "order updated": "order updated",
    "common.orders_updated": "orders updated",
    "orders updated": "orders updated",
    "orders.order_archived_successfully": "Order archived successfully",
    "Order archived successfully": "Order archived successfully",
    "orders.failed_to_archive_order": "Failed to archive order",
    "Failed to archive order": "Failed to archive order",
    "orders.loading_order": "Loading order…",
    "Loading order…": "Loading order…",
    "orders.order_created_successfully": "Order created successfully",
    "Order created successfully": "Order created successfully",
    "orders.the_order_has_been_created_and_is_ready_to_review": "The order has been created and is ready to review.",
    "The order has been created and is ready to review.": "The order has been created and is ready to review.",
    "orders.order_reference": "Order reference",
    "Order reference": "Order reference",
    "common.created": "Created",
    "Created": "Created",
    "common.total": "Total",
    "Total": "Total",
    "common.items": "Items",
    "Items": "Items",
    "orders.print_save_pdf": "Print / Save PDF",
    "Print / Save PDF": "Print / Save PDF",
    "orders.view_order_details": "View order details",
    "View order details": "View order details",
    "orders.create_another_order": "Create another order",
    "Create another order": "Create another order",
    "orders.confirmed": "Confirmed",
    "Confirmed": "Confirmed",
    "orders.in_progress": "In progress",
    "In progress": "In progress",
    "orders.customer_unreachable": "Customer unreachable",
    "Customer unreachable": "Customer unreachable",
    "orders.out_for_delivery": "Out for delivery",
    "Out for delivery": "Out for delivery",
    "orders.returned": "Returned",
    "Returned": "Returned",
    "orders.return_confirmed": "Return confirmed",
    "Return confirmed": "Return confirmed",
    "orders.delivery_confirmed": "Delivery confirmed",
    "Delivery confirmed": "Delivery confirmed",
    "orders.return_initiated": "Return initiated",
    "Return initiated": "Return initiated",
    "orders.return_picked": "Return picked",
    "Return picked": "Return picked",
    "orders.return_disputed": "Return disputed",
    "Return disputed": "Return disputed",
    "orders.canceled_by_seller": "Canceled by seller",
    "Canceled by seller": "Canceled by seller",
    "orders.canceled_by_customer": "Canceled by customer",
    "Canceled by customer": "Canceled by customer",
    "orders.ready_for_pickup": "Ready for pickup",
    "Ready for pickup": "Ready for pickup",
    "orders.arrived_at_customer_location": "Arrived at customer location",
    "Arrived at customer location": "Arrived at customer location",
    "orders.undelivered_returned": "Undelivered - Returned",
    "Undelivered - Returned": "Undelivered - Returned",
    "orders.undelivered_return_confirmed": "Undelivered - Return confirmed",
    "Undelivered - Return confirmed": "Undelivered - Return confirmed",
    "orders.disputed": "Disputed",
    "Disputed": "Disputed",
    "orders.completed": "Completed",
    "Completed": "Completed",
    "orders.detail_legacy.order_number": "Order Number:",
    "Order Number:": "Order Number:",
    "orders.detail_legacy.order_date": "Order Date:",
    "Order Date:": "Order Date:",
    "orders.detail_legacy.buyer_details": "Buyer Details:",
    "Buyer Details:": "Buyer Details:",
    "orders.detail_legacy.delivery_address": "Delivery Address:",
    "Delivery Address:": "Delivery Address:",
    "orders.detail_legacy.pickup_address": "Pickup Address:",
    "Pickup Address:": "Pickup Address:",
    "orders.detail_legacy.total_amount": "Total Amount:",
    "Total Amount:": "Total Amount:",
    "orders.detail_legacy.amount_in_words": "Amount in Words:",
    "Amount in Words:": "Amount in Words:",
    "orders.detail_legacy.amount_words_only": "Only",
    "Only": "Only",
    "orders.detail_legacy.payout_date": "Payout Date:",
    "Payout Date:": "Payout Date:",
    "orders.detail_legacy.change": "Change",
    "Change": "Change",
    "orders.detail_legacy.select_date_time": "Select Date & Time",
    "Select Date & Time": "Select Date & Time",
    "orders.detail_legacy.change_payout_date_time": "Change Payout Date and Time",
    "Change Payout Date and Time": "Change Payout Date and Time",
    "orders.detail_legacy.update_payout": "Update",
    "orders.detail_legacy.update_status": "Update Status",
    "Update Status": "Update Status",
    "orders.detail_legacy.change_order_status": "Change Order Status",
    "Change Order Status": "Change Order Status",
    "orders.detail_legacy.column_description": "Description",
    "Description": "Description",
    "orders.detail_legacy.column_unit_price": "Unit Price",
    "Unit Price": "Unit Price",
    "orders.detail_legacy.column_discount": "Discount",
    "Discount": "Discount",
    "orders.detail_legacy.column_tax_rate": "Tax Rate",
    "Tax Rate": "Tax Rate",
    "orders.item": "Item",
    "Item": "Item",
    "orders.order_details": "Order Details",
    "Order Details": "Order Details",
    "orders.copy_order_reference": "Copy order reference",
    "Copy order reference": "Copy order reference",
    "orders.order_summary": "Order Summary",
    "Order Summary": "Order Summary",
    "orders.order_created": "Order created",
    "Order created": "Order created",
    "orders.order_time": "Order time",
    "Order time": "Order time",
    "orders.total_earnings": "Total earnings",
    "Total earnings": "Total earnings",
    "orders.total_price": "Total price",
    "Total price": "Total price",
    "orders.delivery_fee": "Delivery fee",
    "Delivery fee": "Delivery fee",
    "orders.sub_total": "Sub total",
    "Sub total": "Sub total",
    "orders.customer_information": "Customer Information",
    "Customer Information": "Customer Information",
    "common.customer_name": "Customer Name",
    "Customer Name": "Customer Name",
    "common.phone": "Phone",
    "Phone": "Phone",
    "common.email": "Email",
    "Email": "Email",
    "orders.seller_details": "Seller Details",
    "Seller Details": "Seller Details",
    "common.seller_name": "Seller Name",
    "Seller Name": "Seller Name",
    "common.mobile": "Mobile",
    "Mobile": "Mobile",
    "orders.generate": "Generate",
    "Generate": "Generate",
    "orders.cancel_order": "Cancel Order",
    "Cancel Order": "Cancel Order",
    "orders.mark_as_paid": "Mark as Paid",
    "Mark as Paid": "Mark as Paid",
    "orders.failed_to_mark_as_paid": "Failed to mark as paid",
    "Failed to mark as paid": "Failed to mark as paid",
    "orders.order_cancelled_successfully": "Order cancelled successfully",
    "Order cancelled successfully": "Order cancelled successfully",
    "orders.failed_to_cancel_order_by_admin": "Failed to cancel order by admin",
    "Failed to cancel order by admin": "Failed to cancel order by admin",
    "orders.no_transactions_found": "No transactions found",
    "No transactions found": "No transactions found",
    "orders.transaction_no": "Transaction No",
    "Transaction No": "Transaction No",
    "orders.entity": "Entity",
    "Entity": "Entity",
    "orders.transaction_type": "Transaction Type",
    "Transaction Type": "Transaction Type",
    "common.seller": "Seller",
    "Seller": "Seller",
    "common.customer": "Customer",
    "Customer": "Customer",
    "common.platform_owner": "Platform Owner",
    "Platform Owner": "Platform Owner",
    "orders.items_summary": "Items Summary",
    "Items Summary": "Items Summary",
    "orders.qty": "QTY",
    "QTY": "QTY",
    "orders.price": "Price",
    "Price": "Price",
    "orders.total_price_2": "Total Price",
    "Total Price": "Total Price",
    "orders.membership_purchase": "Membership purchase",
    "Membership purchase": "Membership purchase",
    "orders.member_id": "Member ID",
    "Member ID": "Member ID",
    "orders.period": "Period",
    "Period": "Period",
    "orders.start_date_2": "Start date",
    "Start date": "Start date",
    "common.next_renewal": "Next renewal",
    "Next renewal": "Next renewal",
    "common.expiry_date": "Expiry date",
    "Expiry date": "Expiry date",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "This order is managed as a membership contribution, not a shipment.",
    "This order is managed as a membership contribution, not a shipment.": "This order is managed as a membership contribution, not a shipment.",
    "orders.months": "months",
    "months": "months",
    "orders.days": "days",
    "days": "days",
    "orders.address": "Address",
    "Address": "Address",
    "orders.address_1": "Address 1",
    "Address 1": "Address 1",
    "orders.address_2": "Address 2",
    "Address 2": "Address 2",
    "orders.zip_code": "Zip code",
    "Zip code": "Zip code",
    "orders.full_address": "Full Address",
    "Full Address": "Full Address",
    "orders.formatted_address": "Formatted Address",
    "Formatted Address": "Formatted Address",
    "orders.phone_number": "Phone Number",
    "Phone Number": "Phone Number",
    "orders.address_not_found": "Address not found",
    "Address not found": "Address not found",
    "orders.address_not_applicable": "Address not applicable",
    "Address not applicable": "Address not applicable",
    "orders.address_is_not_available": "Address is not available",
    "Address is not available": "Address is not available",
    "orders.add_pickup_address": "Add Pickup Address",
    "Add Pickup Address": "Add Pickup Address",
    "orders.edit_pickup_address": "Edit Pickup Address",
    "Edit Pickup Address": "Edit Pickup Address",
    "orders.discard_and_close": "Discard and close",
    "Discard and close": "Discard and close",
    "orders.state": "State",
    "State": "State",
    "common.country": "Country",
    "Country": "Country",
    "orders.sales_payout": "Sales Payout",
    "Sales Payout": "Sales Payout",
    "orders.sales_no_payout": "Sales (No Payout)",
    "Sales (No Payout)": "Sales (No Payout)",
    "orders.sales_payout_reversal": "Sales Payout Reversal",
    "Sales Payout Reversal": "Sales Payout Reversal",
    "orders.sales_no_payout_reversal": "Sales no payout reversal",
    "Sales no payout reversal": "Sales no payout reversal",
    "orders.seller_commission": "Seller Commission",
    "Seller Commission": "Seller Commission",
    "orders.seller_commission_reversal": "Seller Commission Reversal",
    "Seller Commission Reversal": "Seller Commission Reversal",
    "orders.seller_transfer": "Seller Transfer",
    "Seller Transfer": "Seller Transfer",
    "orders.seller_transfer_reversal": "Seller Transfer Reversal",
    "Seller Transfer Reversal": "Seller Transfer Reversal",
    "orders.seller_payout": "Seller Payout",
    "Seller Payout": "Seller Payout",
    "orders.seller_subscription": "Seller Subscription",
    "Seller Subscription": "Seller Subscription",
    "orders.seller_payment_processing_fee": "Seller Payment processing fee",
    "Seller Payment processing fee": "Seller Payment processing fee",
    "orders.seller_payment_processing_fee_reversal": "Seller Payment processing fee reversal",
    "Seller Payment processing fee reversal": "Seller Payment processing fee reversal",
    "orders.sub_total_2": "Sub Total",
    "Sub Total": "Sub Total",
    "orders.customer_commission": "Customer Commission",
    "Customer Commission": "Customer Commission",
    "orders.tax": "Tax",
    "Tax": "Tax",
    "orders.shipping_charge": "Shipping Charge",
    "Shipping Charge": "Shipping Charge",
    "orders.refund": "Refund",
    "Refund": "Refund",
    "orders.special_fee": "Special Fee",
    "Special Fee": "Special Fee",
    "orders.coupon": "Coupon",
    "Coupon": "Coupon",
    "orders.shipment": "Shipment",
    "Shipment": "Shipment",
    "orders.fulfilled_by_platform": "Fulfilled by platform",
    "Fulfilled by platform": "Fulfilled by platform",
    "orders.fulfilled_by": "Fulfilled by",
    "Fulfilled by": "Fulfilled by",
    "orders.fulfilled_by_seller": "Fulfilled by seller",
    "Fulfilled by seller": "Fulfilled by seller",
    "orders.on_seller_protection_policy": "On Seller Protection Policy",
    "On Seller Protection Policy": "On Seller Protection Policy",
    "orders.product_image": "Product image",
    "Product image": "Product image",
    "orders.status_changed_successfully": "Status changed successfully",
    "Status changed successfully": "Status changed successfully",
    "orders.pickup_address_not_available_please_add_pickup_address": "Pickup Address not available. Please Add Pickup Address",
    "Pickup Address not available. Please Add Pickup Address": "Pickup Address not available. Please Add Pickup Address",
    "orders.failed_to_save_pickup_address_please_try_again": "Failed to save pickup address. Please try again.",
    "Failed to save pickup address. Please try again.": "Failed to save pickup address. Please try again.",
    "orders.change_shipment_status": "Change shipment status",
    "Change shipment status": "Change shipment status",
    "orders.not_available": "Not available",
    "Not available": "Not available",
    "orders.shipment_created": "Shipment created",
    "Shipment created": "Shipment created",
    "orders.shipment_in_progress": "Shipment in progress",
    "Shipment in progress": "Shipment in progress",
    "orders.ship": "Ship",
    "Ship": "Ship",
    "orders.undelivered_return": "Undelivered return",
    "Undelivered return": "Undelivered return",
    "orders.shipment_deliver": "Shipment deliver",
    "Shipment deliver": "Shipment deliver",
    "orders.shipment_delivery_confirm": "Shipment delivery confirm",
    "Shipment delivery confirm": "Shipment delivery confirm",
    "orders.return_initiate": "Return initiate",
    "Return initiate": "Return initiate",
    "orders.return_for_pickup": "Return for pickup",
    "Return for pickup": "Return for pickup",
    "orders.shipment_return_confirm": "Shipment return confirm",
    "Shipment return confirm": "Shipment return confirm",
    "orders.cancel_by_seller": "Cancel by seller",
    "Cancel by seller": "Cancel by seller",
    "orders.cancel_by_customer": "Cancel by customer",
    "Cancel by customer": "Cancel by customer",
    "orders.arrive_at_customer_location": "Arrive at customer location",
    "Arrive at customer location": "Arrive at customer location",
    "orders.shipment_delivered": "Shipment delivered",
    "Shipment delivered": "Shipment delivered",
    "orders.shipment_delivery_confirmed": "Shipment delivery confirmed",
    "Shipment delivery confirmed": "Shipment delivery confirmed",
    "orders.returned_for_pickup": "Returned for pickup",
    "Returned for pickup": "Returned for pickup",
    "orders.shipment_return_confirmed": "Shipment return confirmed",
    "Shipment return confirmed": "Shipment return confirmed",
    "orders.cancelled_by_seller": "Cancelled by seller",
    "Cancelled by seller": "Cancelled by seller",
    "common.cancelled_by_admin": "Cancelled by admin",
    "Cancelled by admin": "Cancelled by admin",
    "orders.invoice": "Invoice",
    "Invoice": "Invoice",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Please select a valid file type (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Please select a valid file type (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "File size must be less than 5MB",
    "File size must be less than 5MB": "File size must be less than 5MB",
    "orders.please_upload_a_file_first": "Please upload a file first",
    "Please upload a file first": "Please upload a file first",
    "orders.invoice_uploaded_successfully": "Invoice uploaded successfully!",
    "Invoice uploaded successfully!": "Invoice uploaded successfully!",
    "orders.failed_to_upload_invoice_please_try_again": "Failed to upload invoice. Please try again.",
    "Failed to upload invoice. Please try again.": "Failed to upload invoice. Please try again.",
    "orders.upload_invoice": "Upload Invoice",
    "Upload Invoice": "Upload Invoice",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)",
    "orders.uploading": "Uploading...",
    "Uploading...": "Uploading...",
    "orders.choose_file": "Choose File",
    "Choose File": "Choose File",
    "common.download": "Download",
    "Download": "Download",
    "common.remove": "Remove",
    "Remove": "Remove",
    "orders.upload_new_file": "Upload New File",
    "Upload New File": "Upload New File",
    "orders.saving": "Saving...",
    "Saving...": "Saving...",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?",
    "common.showing": "Showing",
    "Showing": "Showing",
    "common.of": "of",
    "of": "of",
    "common.all": "All",
    "All": "All",
    "common.active": "Active",
    "Active": "Active",
    "common.inactive": "Inactive",
    "Inactive": "Inactive",
    "common.enabled": "Enabled",
    "Enabled": "Enabled",
    "common.disabled": "Disabled",
    "Disabled": "Disabled",
    "common.success": "Success",
    "Success": "Success",
    "common.error": "Error",
    "Error": "Error",
    "common.warning": "Warning",
    "Warning": "Warning",
    "common.required": "Required",
    "Required": "Required",
    "users.title": "Users",
    "users.import": "Import",
    "Import": "Import",
    "users.import_users": "Import users",
    "Import users": "Import users",
    "users.smart_upload_users": "Smart Upload Users",
    "Smart Upload Users": "Smart Upload Users",
    "users.smart_upload_beta": "Smart upload users (Beta)",
    "Smart upload users (Beta)": "Smart upload users (Beta)",
    "users.export": "Export",
    "Export": "Export",
    "users.export_users": "Export users",
    "Export users": "Export users",
    "users.search_users": "Search users",
    "Search users": "Search users",
    "users.verified": "Verified",
    "Verified": "Verified",
    "users.not_verified": "Non Verified",
    "Non Verified": "Non Verified",
    "users.block": "Block",
    "Block": "Block",
    "users.unblock": "Unblock",
    "Unblock": "Unblock",
    "users.confirm_block": "Do you want to block this user?",
    "Do you want to block this user?": "Do you want to block this user?",
    "users.confirm_unblock": "Do you want to unblock this user?",
    "Do you want to unblock this user?": "Do you want to unblock this user?",
    "users.import_export": "User import and export",
    "User import and export": "User import and export",
    "users.user_id": "User ID",
    "User ID": "User ID",
    "users.first_name": "First Name",
    "First Name": "First Name",
    "users.last_name": "Last Name",
    "Last Name": "Last Name",
    "users.email": "Email",
    "users.phone_number": "Phone No",
    "Phone No": "Phone No",
    "users.country": "Country",
    "users.profile": "Profile",
    "Profile": "Profile",
    "users.email_verified": "Email Verified",
    "Email Verified": "Email Verified",
    "users.blocked": "Blocked",
    "Blocked": "Blocked",
    "users.action": "Action",
    "users.join_date": "Join Date",
    "Join Date": "Join Date",
    "users.last_login": "Last Login",
    "Last Login": "Last Login",
    "users.customer_type": "Customer Type",
    "Customer Type": "Customer Type",
    "common.and": "and",
    "and": "and",
    "users.import_failed": "User import failed.",
    "User import failed.": "User import failed.",
    "users.smart_upload.paid_title": "Smart user upload is a paid feature",
    "Smart user upload is a paid feature": "Smart user upload is a paid feature",
    "users.smart_upload.paid_description": "Upgrade your workspace to Starter or Go to upload users from a CSV file.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Upgrade your workspace to Starter or Go to upload users from a CSV file.",
    "users.smart_upload.view_plans": "View plans",
    "View plans": "View plans",
    "users.smart_upload.csv_needs_user": "The CSV must contain a header row and at least one user.",
    "The CSV must contain a header row and at least one user.": "The CSV must contain a header row and at least one user.",
    "users.smart_upload.unique_headers": "Every user column needs a unique, non-empty header.",
    "Every user column needs a unique, non-empty header.": "Every user column needs a unique, non-empty header.",
    "users.smart_upload.csv_read_error": "Unable to read this CSV.",
    "Unable to read this CSV.": "Unable to read this CSV.",
    "users.smart_upload.map_required": "Map {fields} before continuing.",
    "Map {fields} before continuing.": "Map {fields} before continuing.",
    "users.smart_upload.map_contact": "Map an Email or Phone column. Each row needs at least one contact method.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Map an Email or Phone column. Each row needs at least one contact method.",
    "users.smart_upload.invalid_row": "Row {row} is missing a required name or contact value.",
    "Row {row} is missing a required name or contact value.": "Row {row} is missing a required name or contact value.",
    "users.smart_upload.attribute_name_required": "Enter an attribute name for “{header}”.",
    "Enter an attribute name for “{header}”.": "Enter an attribute name for “{header}”.",
    "users.smart_upload.attribute_create_error": "Could not create the “{name}” attribute.",
    "Could not create the “{name}” attribute.": "Could not create the “{name}” attribute.",
    "users.smart_upload.attribute_missing": "The attribute mapped from “{header}” is no longer available.",
    "The attribute mapped from “{header}” is no longer available.": "The attribute mapped from “{header}” is no longer available.",
    "users.smart_upload.prepare_error": "Could not prepare the import file.",
    "Could not prepare the import file.": "Could not prepare the import file.",
    "users.smart_upload.upload_error": "The import file could not be uploaded.",
    "The import file could not be uploaded.": "The import file could not be uploaded.",
    "users.smart_upload.all_duplicates": "Every row is a duplicate of another row in this file.",
    "Every row is a duplicate of another row in this file.": "Every row is a duplicate of another row in this file.",
    "users.smart_upload.source_attribute_error": "Could not create the contact_source attribute.",
    "Could not create the contact_source attribute.": "Could not create the contact_source attribute.",
    "users.smart_upload.duplicates_skipped": "Duplicate rows to skip: {count}.",
    "Duplicate rows to skip: {count}.": "Duplicate rows to skip: {count}.",
    "users.smart_upload.preparing_attributes": "Preparing attributes",
    "Preparing attributes": "Preparing attributes",
    "users.smart_upload.checking_users": "Checking existing users",
    "Checking existing users": "Checking existing users",
    "users.smart_upload.uploading_file": "Uploading import file",
    "Uploading import file": "Uploading import file",
    "users.smart_upload.importing_users": "Tradly is importing users",
    "Tradly is importing users": "Tradly is importing users",
    "users.smart_upload.import_stopped": "Import stopped",
    "Import stopped": "Import stopped",
    "users.smart_upload.title": "Smart user upload",
    "Smart user upload": "Smart user upload",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Start over",
    "Start over": "Start over",
    "users.smart_upload.description": "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.",
    "users.smart_upload.step_upload": "Upload",
    "Upload": "Upload",
    "users.smart_upload.step_match": "Match columns",
    "Match columns": "Match columns",
    "users.smart_upload.step_review": "Review",
    "Review": "Review",
    "users.smart_upload.step_import": "Import",
    "users.smart_upload.choose_csv": "Choose a CSV file",
    "Choose a CSV file": "Choose a CSV file",
    "users.smart_upload.required_fields": "First name, last name, and email or phone are required. Passwords are generated automatically.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "First name, last name, and email or phone are required. Passwords are generated automatically.",
    "users.smart_upload.select_csv": "Select CSV file",
    "Select CSV file": "Select CSV file",
    "users.smart_upload.match_columns": "Match user columns",
    "Match user columns": "Match user columns",
    "users.smart_upload.first_name": "First name",
    "First name": "First name",
    "users.smart_upload.last_name": "Last name",
    "Last name": "Last name",
    "users.smart_upload.email": "Email",
    "users.smart_upload.phone": "Phone",
    "users.smart_upload.username": "Username",
    "Username": "Username",
    "users.smart_upload.do_not_import": "Do not import",
    "Do not import": "Do not import",
    "users.smart_upload.additional_attributes": "Additional user attributes",
    "Additional user attributes": "Additional user attributes",
    "users.smart_upload.ignore_column": "Ignore this column",
    "Ignore this column": "Ignore this column",
    "users.smart_upload.create_attribute": "Create a new user attribute",
    "Create a new user attribute": "Create a new user attribute",
    "users.smart_upload.attribute_name": "Attribute name",
    "Attribute name": "Attribute name",
    "users.smart_upload.type_text": "Text",
    "Text": "Text",
    "users.smart_upload.type_long_text": "Long text",
    "Long text": "Long text",
    "users.smart_upload.type_number": "Number",
    "Number": "Number",
    "users.smart_upload.type_single_select": "Single select",
    "Single select": "Single select",
    "users.smart_upload.type_multi_select": "Multi select",
    "Multi select": "Multi select",
    "users.smart_upload.review_import": "Review import",
    "Review import": "Review import",
    "users.smart_upload.review_description": "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.",
    "users.smart_upload.contact_classification": "Contact classification",
    "Contact classification": "Contact classification",
    "users.smart_upload.outbound": "Outbound (not opted in)",
    "Outbound (not opted in)": "Outbound (not opted in)",
    "users.smart_upload.signed_up": "Signed-up (opted in)",
    "Signed-up (opted in)": "Signed-up (opted in)",
    "users.smart_upload.contact_source_help": "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.",
    "users.smart_upload.import_complete": "User import complete",
    "User import complete": "User import complete",
    "users.smart_upload.imported_summary": "{imported} of {total} users imported.",
    "{imported} of {total} users imported.": "{imported} of {total} users imported.",
    "users.smart_upload.selected_file": "Selected: {name}",
    "Selected: {name}": "Selected: {name}",
    "users.smart_upload.review_action": "Review",
    "users.smart_upload.importing_action": "Importing…",
    "Importing…": "Importing…",
    "users.smart_upload.import_users_action": "Import users",
    "users.import.uploading": "Uploading…",
    "Uploading…": "Uploading…",
    "users.import.please_wait": "Please wait…",
    "Please wait…": "Please wait…",
    "users.import.error_prefix": "Error",
    "users.import.select_file_error": "Please select a file",
    "Please select a file": "Please select a file",
    "users.import.download": "Download",
    "users.import.file_label": "File:",
    "File:": "File:",
    "users.import.select_file": "Select File",
    "Select File": "Select File",
    "users.import.upload": "Upload",
    "users.create.button": "Create User",
    "Create User": "Create User",
    "users.create.title": "Create New User",
    "Create New User": "Create New User",
    "users.create.please_wait": "Please wait…",
    "users.create.email": "Email",
    "users.create.first_name": "First Name",
    "users.create.last_name": "Last Name",
    "users.create.email_required": "Email is required",
    "Email is required": "Email is required",
    "users.create.first_name_required": "First Name is required",
    "First Name is required": "First Name is required",
    "users.create.last_name_required": "Last Name is required",
    "Last Name is required": "Last Name is required",
    "users.create.session_expired": "Your admin session has expired. Please sign in again before creating a user.",
    "Your admin session has expired. Please sign in again before creating a user.": "Your admin session has expired. Please sign in again before creating a user.",
    "users.create.unable_to_create": "Unable to create this user.",
    "Unable to create this user.": "Unable to create this user.",
    "users.create.success": "User created successfully",
    "User created successfully": "User created successfully",
    "users.create.failed": "User creation failed. Please try again.",
    "User creation failed. Please try again.": "User creation failed. Please try again.",
    "common.feature_flow.eyebrow": "SEE HOW IT WORKS",
    "SEE HOW IT WORKS": "SEE HOW IT WORKS",
    "common.feature_flow.open_guide": "Open flow guide",
    "Open flow guide": "Open flow guide",
    "common.feature_flow.close_guide": "Close section guide",
    "Close section guide": "Close section guide",
    "common.feature_flow.section_guide": "Section guide",
    "Section guide": "Section guide",
    "users.flow.title": "Everything you need to manage your users",
    "Everything you need to manage your users": "Everything you need to manage your users",
    "users.flow.description": "Build user profiles, personalize user data, and understand customer feedback in one place.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Build user profiles, personalize user data, and understand customer feedback in one place.",
    "users.flow.lane_title": "User management",
    "User management": "User management",
    "users.flow.badge": "Core tools",
    "Core tools": "Core tools",
    "users.flow.attributes": "Attributes",
    "Attributes": "Attributes",
    "users.flow.reviews": "Reviews",
    "Reviews": "Reviews",
    "users.flow.lane_description": "Manage people, add the profile fields you need, and learn from their experience.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Manage people, add the profile fields you need, and learn from their experience.",
    "users.flow.primary_action": "Add your first user",
    "Add your first user": "Add your first user",
    "users.tooltip.title": "Every individual is a unique user",
    "Every individual is a unique user": "Every individual is a unique user",
    "users.tooltip.description": "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.",
    "workspace.loading": "Loading workspace settings…",
    "Loading workspace settings…": "Loading workspace settings…",
    "workspace.kicker": "WORKSPACE",
    "WORKSPACE": "WORKSPACE",
    "workspace.fallback_name": "Workspace",
    "workspace.members.title": "Invite Team Member",
    "Invite Team Member": "Invite Team Member",
    "workspace.members.description": "Add teammates and give each person only the access they need.",
    "Add teammates and give each person only the access they need.": "Add teammates and give each person only the access they need.",
    "workspace.members.enter_name_email": "Enter a member name and email address.",
    "Enter a member name and email address.": "Enter a member name and email address.",
    "workspace.members.invitation_sent": "Invitation sent.",
    "Invitation sent.": "Invitation sent.",
    "workspace.members.confirm_remove": "Remove {name} from this workspace?",
    "Remove {name} from this workspace?": "Remove {name} from this workspace?",
    "workspace.members.removed": "Team member removed.",
    "Team member removed.": "Team member removed.",
    "workspace.members.roles_saved": "Member roles saved.",
    "Member roles saved.": "Member roles saved.",
    "workspace.members.read": "Read",
    "Read": "Read",
    "workspace.members.write": "Write",
    "Write": "Write",
    "workspace.members.delete": "Delete",
    "workspace.members.select_all_permission": "Select all {permission} in {group}",
    "Select all {permission} in {group}": "Select all {permission} in {group}",
    "workspace.members.member_name": "Member Name",
    "Member Name": "Member Name",
    "workspace.members.email_address": "Email Address",
    "Email Address": "Email Address",
    "workspace.members.sending": "Sending…",
    "Sending…": "Sending…",
    "workspace.members.send_invitation": "Send invitation",
    "Send invitation": "Send invitation",
    "workspace.members.team_members": "Team members",
    "Team members": "Team members",
    "workspace.members.search_members": "Search members",
    "Search members": "Search members",
    "workspace.members.search": "Search",
    "workspace.members.member": "Member",
    "Member": "Member",
    "workspace.members.email": "Email",
    "workspace.members.status": "Status",
    "workspace.members.actions": "Actions",
    "workspace.members.unnamed": "Unnamed member",
    "Unnamed member": "Unnamed member",
    "workspace.members.roles": "Roles",
    "Roles": "Roles",
    "workspace.members.empty": "No team members found.",
    "No team members found.": "No team members found.",
    "workspace.members.page_of": "Page {page} of {pages}",
    "Page {page} of {pages}": "Page {page} of {pages}",
    "workspace.members.assign_roles": "Assign roles",
    "Assign roles": "Assign roles",
    "workspace.members.save_roles": "Save roles",
    "Save roles": "Save roles",
    "workspace.members.saving": "Saving…",
    "Saving…": "Saving…",
    "workspace.error.generic": "Something went wrong. Please try again.",
    "Something went wrong. Please try again.": "Something went wrong. Please try again.",
    "workspace.billing.view_label": "Billing workspace view",
    "Billing workspace view": "Billing workspace view",
    "workspace.billing.tab_usage": "Usage",
    "Usage": "Usage",
    "workspace.billing.tab_plans": "Plans",
    "workspace.billing.tab_invoices": "Paid invoices",
    "Paid invoices": "Paid invoices",
    "workspace.billing.tab_account": "Account",
    "Account": "Account",
    "workspace.account.title": "Business Settings",
    "Business Settings": "Business Settings",
    "workspace.account.description": "Manage your business profile, enabled products, and account privacy.",
    "Manage your business profile, enabled products, and account privacy.": "Manage your business profile, enabled products, and account privacy.",
    "workspace.account.profile_updated": "Business profile updated.",
    "Business profile updated.": "Business profile updated.",
    "workspace.account.logo_updated": "Logo updated.",
    "Logo updated.": "Logo updated.",
    "workspace.account.logo_upload_error": "Unable to upload logo.",
    "Unable to upload logo.": "Unable to upload logo.",
    "workspace.account.confirm_delete": "Delete this Tradly account permanently? This cannot be undone.",
    "Delete this Tradly account permanently? This cannot be undone.": "Delete this Tradly account permanently? This cannot be undone.",
    "workspace.account.business_profile": "Business Profile",
    "Business Profile": "Business Profile",
    "workspace.account.logo": "Logo",
    "Logo": "Logo",
    "workspace.account.logo_alt": "Business logo",
    "Business logo": "Business logo",
    "workspace.account.add_photo": "Add photo",
    "Add photo": "Add photo",
    "workspace.account.logo_formats": "PNG, JPG, SVG or ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG or ICO",
    "workspace.account.business_name": "Business Name",
    "Business Name": "Business Name",
    "workspace.account.contact_name": "Business Contact Name",
    "Business Contact Name": "Business Contact Name",
    "workspace.account.business_address": "Business Address",
    "Business Address": "Business Address",
    "workspace.account.products_of_interest": "Products of Interest",
    "Products of Interest": "Products of Interest",
    "workspace.account.marketplace": "Marketplace",
    "workspace.account.single_store": "Single Store Commerce",
    "Single Store Commerce": "Single Store Commerce",
    "workspace.account.alacarte_products": "À la carte Products",
    "À la carte Products": "À la carte Products",
    "workspace.account.alacarte_description": "Individual products enabled for this workspace are managed from Plans & Billing.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Individual products enabled for this workspace are managed from Plans & Billing.",
    "workspace.account.manage_alacarte": "Manage à la carte products",
    "Manage à la carte products": "Manage à la carte products",
    "workspace.account.delete_irreversible": "Delete your Account: Irreversible",
    "Delete your Account: Irreversible": "Delete your Account: Irreversible",
    "workspace.account.delete_description": "This permanently deletes the Tradly tenant and all associated data.",
    "This permanently deletes the Tradly tenant and all associated data.": "This permanently deletes the Tradly tenant and all associated data.",
    "workspace.account.deleting": "Deleting…",
    "Deleting…": "Deleting…",
    "workspace.account.delete_button": "Delete Account With Tradly",
    "Delete Account With Tradly": "Delete Account With Tradly",
    "workspace.privacy.title": "Privacy & Data Processors",
    "Privacy & Data Processors": "Privacy & Data Processors",
    "workspace.privacy.description": "Understand which processors help operate Tradly and how retention works after a deletion request.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Understand which processors help operate Tradly and how retention works after a deletion request.",
    "workspace.privacy.processor_retention": "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.",
    "workspace.privacy.read_more": "Read more.",
    "Read more.": "Read more.",
    "workspace.privacy.tool": "Tool",
    "Tool": "Tool",
    "workspace.privacy.purpose": "Purpose",
    "Purpose": "Purpose",
    "workspace.privacy.data_category": "Data Category",
    "Data Category": "Data Category",
    "workspace.privacy.deletion_requests": "Account deletion and data requests",
    "Account deletion and data requests": "Account deletion and data requests",
    "workspace.privacy.deletion_description": "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.",
    "workspace.privacy.open_account": "Open account settings",
    "Open account settings": "Open account settings",
    "workspace.privacy.core_operations": "Core product operations",
    "Core product operations": "Core product operations",
    "workspace.privacy.user_data_retention": "User data (retention: 90–180 days)",
    "User data (retention: 90–180 days)": "User data (retention: 90–180 days)",
    "workspace.privacy.crm_support_lifecycle": "CRM, support, lifecycle communication",
    "CRM, support, lifecycle communication": "CRM, support, lifecycle communication",
    "workspace.privacy.personal_data": "Personal data",
    "Personal data": "Personal data",
    "workspace.privacy.product_analytics": "Product analytics and engagement funnels",
    "Product analytics and engagement funnels": "Product analytics and engagement funnels",
    "workspace.privacy.usage_events": "Usage and event analytics",
    "Usage and event analytics": "Usage and event analytics",
    "workspace.privacy.billing_payments": "Billing and payment processing",
    "Billing and payment processing": "Billing and payment processing",
    "workspace.privacy.billing_data": "Billing data",
    "Billing data": "Billing data",
    "workspace.privacy.traffic_analytics": "Traffic and behavior analytics",
    "Traffic and behavior analytics": "Traffic and behavior analytics",
    "workspace.privacy.usage_analytics": "Usage analytics",
    "Usage analytics": "Usage analytics",
    "workspace.privacy.session_diagnostics": "Session insights and broken-button diagnostics",
    "Session insights and broken-button diagnostics": "Session insights and broken-button diagnostics",
    "workspace.privacy.ux_telemetry": "UX/session telemetry",
    "UX/session telemetry": "UX/session telemetry",
    "workspace.privacy.error_monitoring": "Code error and stability monitoring",
    "Code error and stability monitoring": "Code error and stability monitoring",
    "workspace.privacy.error_logs": "Error logs and diagnostics",
    "Error logs and diagnostics": "Error logs and diagnostics",
    "workspace.privacy.email_delivery": "Transactional email delivery",
    "Transactional email delivery": "Transactional email delivery",
    "workspace.privacy.email_metadata": "Email metadata",
    "Email metadata": "Email metadata",
    "workspace.privacy.hosting_infrastructure": "Hosting and infrastructure",
    "Hosting and infrastructure": "Hosting and infrastructure",
    "workspace.privacy.infrastructure_logs": "Infrastructure and service logs",
    "Infrastructure and service logs": "Infrastructure and service logs",
    "workspace.domain.title": "Domains",
    "Domains": "Domains",
    "workspace.domain.description": "Connect your own domain to replace the default hosted Tradly URL.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Connect your own domain to replace the default hosted Tradly URL.",
    "workspace.domain.invalid": "Enter a valid domain, such as example.com.",
    "Enter a valid domain, such as example.com.": "Enter a valid domain, such as example.com.",
    "workspace.domain.reserved": "tradly.co is reserved for hosted workspace domains.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co is reserved for hosted workspace domains.",
    "workspace.domain.missing_primary": "No primary workspace domain is available.",
    "No primary workspace domain is available.": "No primary workspace domain is available.",
    "workspace.domain.saved": "Custom domain saved. Update your DNS records, then refresh its status.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Custom domain saved. Update your DNS records, then refresh its status.",
    "workspace.domain.reset_success": "Domain reset to the Tradly-hosted URL.",
    "Domain reset to the Tradly-hosted URL.": "Domain reset to the Tradly-hosted URL.",
    "workspace.domain.current": "CURRENT DOMAIN",
    "CURRENT DOMAIN": "CURRENT DOMAIN",
    "workspace.domain.hosted": "Tradly-hosted domain",
    "Tradly-hosted domain": "Tradly-hosted domain",
    "workspace.domain.dns_status": "DNS status: {status}",
    "DNS status: {status}": "DNS status: {status}",
    "workspace.domain.checking": "Checking DNS status…",
    "Checking DNS status…": "Checking DNS status…",
    "workspace.domain.refresh": "Refresh status",
    "Refresh status": "Refresh status",
    "workspace.domain.reset": "Reset domain",
    "Reset domain": "Reset domain",
    "workspace.domain.connect_title": "Connect a custom domain",
    "Connect a custom domain": "Connect a custom domain",
    "workspace.domain.connect_description": "Enter a domain you already own. We’ll show the DNS records required to connect it.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Enter a domain you already own. We’ll show the DNS records required to connect it.",
    "workspace.domain.saving": "Saving…",
    "workspace.domain.add": "Add domain",
    "Add domain": "Add domain",
    "workspace.domain.dns_title": "DNS setup",
    "DNS setup": "DNS setup",
    "workspace.domain.a_record": "A record",
    "A record": "A record",
    "workspace.domain.root_description": "Use this for a root domain such as",
    "Use this for a root domain such as": "Use this for a root domain such as",
    "workspace.domain.cname_record": "CNAME record",
    "CNAME record": "CNAME record",
    "workspace.domain.subdomain_description": "Use this for a subdomain such as",
    "Use this for a subdomain such as": "Use this for a subdomain such as",
    "workspace.domain.host": "Host",
    "Host": "Host",
    "workspace.domain.value": "Value",
    "Value": "Value",
    "workspace.domain.need_domain": "Need a domain?",
    "Need a domain?": "Need a domain?",
    "workspace.domain.buy_domain": "Buy a domain from Google Domains or GoDaddy, then return here to connect it.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Buy a domain from Google Domains or GoDaddy, then return here to connect it.",
    "workspace.billing.title": "Billing & Usage",
    "Billing & Usage": "Billing & Usage",
    "workspace.billing.description": "Manage workspace plans, usage, and billing.",
    "Manage workspace plans, usage, and billing.": "Manage workspace plans, usage, and billing.",
    "workspace.billing.invoice_description": "Manage workspace plans, usage, and paid invoices.",
    "Manage workspace plans, usage, and paid invoices.": "Manage workspace plans, usage, and paid invoices.",
    "workspace.billing.usage_description": "See current usage and the limits applied to this workspace.",
    "See current usage and the limits applied to this workspace.": "See current usage and the limits applied to this workspace.",
    "workspace.invoices.loading": "Loading invoices…",
    "Loading invoices…": "Loading invoices…",
    "workspace.invoices.description": "Download invoices or complete payment for an outstanding balance.",
    "Download invoices or complete payment for an outstanding balance.": "Download invoices or complete payment for an outstanding balance.",
    "workspace.invoices.payment_failed": "Payment failed — service access may be affected.",
    "Payment failed — service access may be affected.": "Payment failed — service access may be affected.",
    "workspace.invoices.awaiting_payment": "Invoice {invoice} is awaiting payment.",
    "Invoice {invoice} is awaiting payment.": "Invoice {invoice} is awaiting payment.",
    "workspace.invoices.outstanding": "outstanding",
    "outstanding": "outstanding",
    "workspace.invoices.pay_invoice": "Pay invoice",
    "Pay invoice": "Pay invoice",
    "workspace.invoices.invoice": "Invoice",
    "workspace.invoices.date": "Date",
    "workspace.invoices.amount": "Amount",
    "workspace.invoices.paid": "Paid",
    "workspace.invoices.unpaid": "Unpaid",
    "Unpaid": "Unpaid",
    "workspace.invoices.download_invoice": "Download invoice",
    "Download invoice": "Download invoice",
    "workspace.invoices.empty_title": "No invoices available",
    "No invoices available": "No invoices available",
    "workspace.invoices.empty_description": "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.",
    "workspace.plans.heading": "Plans",
    "workspace.plans.tab_marketplace": "Marketplace",
    "workspace.plans.tab_marketplace_description": "Multi-vendor",
    "Multi-vendor": "Multi-vendor",
    "workspace.plans.tab_single": "Single Store",
    "Single Store": "Single Store",
    "workspace.plans.tab_single_description": "Indie & Creators",
    "Indie & Creators": "Indie & Creators",
    "workspace.plans.tab_alacarte": "A la carte",
    "A la carte": "A la carte",
    "workspace.plans.tab_alacarte_description": "Credits & add-ons",
    "Credits & add-ons": "Credits & add-ons",
    "workspace.plans.tab_services": "Services",
    "Services": "Services",
    "workspace.plans.tab_services_description": "Additional services",
    "Additional services": "Additional services",
    "workspace.plans.selected": "Selected",
    "Selected": "Selected",
    "workspace.plans.try_again": "Try again",
    "Try again": "Try again",
    "workspace.plans.bill_yearly": "Bill Yearly",
    "Bill Yearly": "Bill Yearly",
    "workspace.plans.bill_monthly": "Bill Monthly",
    "Bill Monthly": "Bill Monthly",
    "workspace.plans.compare": "Compare Plans",
    "Compare Plans": "Compare Plans",
    "workspace.plans.community": "Community",
    "workspace.plans.community_description": "Free forever. Perfect for hobbyists and community projects.",
    "Free forever. Perfect for hobbyists and community projects.": "Free forever. Perfect for hobbyists and community projects.",
    "workspace.plans.different_configurations": "Looking for different configurations?",
    "Looking for different configurations?": "Looking for different configurations?",
    "workspace.plans.contact_us": "Contact Us",
    "Contact Us": "Contact Us",
    "workspace.plans.see_alacarte_pricing": "See à la carte pricing",
    "See à la carte pricing": "See à la carte pricing",
    "workspace.plans.available": "Available",
    "Available": "Available",
    "workspace.plans.used_90d": "Used (90d)",
    "Used (90d)": "Used (90d)",
    "workspace.plans.expired_90d": "Expired (90d)",
    "Expired (90d)": "Expired (90d)",
    "workspace.plans.expires_on": "Expires {date}",
    "Expires {date}": "Expires {date}",
    "workspace.plans.top_up_credits": "Top Up Credits",
    "Top Up Credits": "Top Up Credits",
    "workspace.plans.credits_description": "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.",
    "workspace.plans.credits": "credits",
    "credits": "credits",
    "workspace.plans.custom_amount": "Custom amount",
    "Custom amount": "Custom amount",
    "workspace.plans.amount_example": "e.g. 2500",
    "e.g. 2500": "e.g. 2500",
    "workspace.plans.opening_checkout": "Opening checkout…",
    "Opening checkout…": "Opening checkout…",
    "workspace.plans.buy_credits": "Buy {count} credits",
    "Buy {count} credits": "Buy {count} credits",
    "workspace.plans.select_amount": "Select an amount",
    "Select an amount": "Select an amount",
    "workspace.plans.alacarte_products": "A la carte Products",
    "A la carte Products": "A la carte Products",
    "workspace.plans.products_description": "Select the products you use. This helps us tailor your experience. Usage is paid with credits.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Select the products you use. This helps us tailor your experience. Usage is paid with credits.",
    "workspace.plans.enabled": "Enabled",
    "workspace.plans.enable": "Enable",
    "Enable": "Enable",
    "workspace.plans.open_here": "Open here",
    "Open here": "Open here",
    "workspace.plans.open_marketing": "Open marketing.tradly.app",
    "Open marketing.tradly.app": "Open marketing.tradly.app",
    "workspace.plans.open_analytics": "Open analytics.tradly.app",
    "Open analytics.tradly.app": "Open analytics.tradly.app",
    "workspace.plans.open_external": "Open external",
    "Open external": "Open external",
    "workspace.plans.coming_soon": "Coming soon",
    "Coming soon": "Coming soon",
    "workspace.plans.services_title": "One-Time Setup & Custom Services",
    "One-Time Setup & Custom Services": "One-Time Setup & Custom Services",
    "workspace.plans.service_app_launch": "White-Label App Launch",
    "White-Label App Launch": "White-Label App Launch",
    "workspace.plans.service_frontend": "Frontend Customization",
    "Frontend Customization": "Frontend Customization",
    "workspace.plans.service_multilanguage": "Multi-Language Support",
    "Multi-Language Support": "Multi-Language Support",
    "workspace.plans.view_docs": "View Docs",
    "View Docs": "View Docs",
    "workspace.plans.confirm_change": "Confirm your plan change",
    "Confirm your plan change": "Confirm your plan change",
    "workspace.plans.confirm_charge": "Charges are prepaid and billed on your subscription date.",
    "Charges are prepaid and billed on your subscription date.": "Charges are prepaid and billed on your subscription date.",
    "workspace.plans.confirm_promo": "Promotional codes can be entered during Stripe checkout where available.",
    "Promotional codes can be entered during Stripe checkout where available.": "Promotional codes can be entered during Stripe checkout where available.",
    "workspace.plans.confirm_delay": "Plan changes may take a moment to appear in your workspace.",
    "Plan changes may take a moment to appear in your workspace.": "Plan changes may take a moment to appear in your workspace.",
    "workspace.plans.payment_active": "Payment received. Your plan is active.",
    "Payment received. Your plan is active.": "Payment received. Your plan is active.",
    "workspace.plans.payment_method_updated": "Payment method updated.",
    "Payment method updated.": "Payment method updated.",
    "workspace.plans.payment_cancelled": "Payment was not completed, so your plan has not changed.",
    "Payment was not completed, so your plan has not changed.": "Payment was not completed, so your plan has not changed.",
    "workspace.plans.activating": "Payment received. Activating your plan…",
    "Payment received. Activating your plan…": "Payment received. Activating your plan…",
    "workspace.plans.activation_delayed": "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.",
    "workspace.plans.card_saved": "Card saved and subscription updated.",
    "Card saved and subscription updated.": "Card saved and subscription updated.",
    "workspace.plans.subscription_updated": "Subscription updated.",
    "Subscription updated.": "Subscription updated.",
    "workspace.plans.products_saved": "À la carte products saved.",
    "À la carte products saved.": "À la carte products saved.",
    "workspace.plans.minimum_credits": "Enter at least 100 credits.",
    "Enter at least 100 credits.": "Enter at least 100 credits.",
    "workspace.plans.credit_topup_description": "Credit Top-Up ({count} credits)",
    "Credit Top-Up ({count} credits)": "Credit Top-Up ({count} credits)",
    "workspace.plans.billing_details": "Current billing details",
    "Current billing details": "Current billing details",
    "workspace.plans.current_plan": "Current Plan",
    "Current Plan": "Current Plan",
    "workspace.plans.renews": "Renews",
    "Renews": "Renews",
    "workspace.plans.payment_method": "Payment method",
    "Payment method": "Payment method",
    "workspace.plans.opening": "Opening…",
    "Opening…": "Opening…",
    "workspace.plans.manage_payment_method": "Manage payment method",
    "Manage payment method": "Manage payment method",
    "workspace.plans.upgrade": "Upgrade",
    "Upgrade": "Upgrade",
    "workspace.plans.downgrade": "Downgrade",
    "Downgrade": "Downgrade",
    "workspace.plans.custom_price": "Custom",
    "Custom": "Custom",
    "workspace.plans.per_month_short": "/month",
    "/month": "/month",
    "workspace.plans.per_year_amount": "per year ({amount})",
    "per year ({amount})": "per year ({amount})",
    "workspace.plans.per_month_amount": "per month ({amount})",
    "per month ({amount})": "per month ({amount})",
    "workspace.plans.yearly_savings": "Save {amount} yearly",
    "Save {amount} yearly": "Save {amount} yearly",
    "workspace.plans.billed_yearly": "billed yearly",
    "billed yearly": "billed yearly",
    "workspace.plans.billed_monthly": "billed monthly",
    "billed monthly": "billed monthly",
    "workspace.plans.free_trial": "You are on a free trial.",
    "You are on a free trial.": "You are on a free trial.",
    "workspace.plans.updating": "Updating…",
    "Updating…": "Updating…",
    "workspace.plans.temporarily_unavailable": "Temporarily unavailable",
    "Temporarily unavailable": "Temporarily unavailable",
    "workspace.plans.whats_included": "What's included",
    "What's included": "What's included",
    "workspace.plans.products.auth.title": "Auth",
    "Auth": "Auth",
    "workspace.plans.products.auth.description": "Identity, SSO, permissions, and user management.",
    "Identity, SSO, permissions, and user management.": "Identity, SSO, permissions, and user management.",
    "workspace.plans.products.email.title": "Email",
    "workspace.plans.products.email.description": "Transactional and marketing email, built in.",
    "Transactional and marketing email, built in.": "Transactional and marketing email, built in.",
    "workspace.plans.products.analytics.title": "Analytics",
    "Analytics": "Analytics",
    "workspace.plans.products.analytics.description": "Free analytics for web, app, and agents.",
    "Free analytics for web, app, and agents.": "Free analytics for web, app, and agents.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "A CRM that fills itself from user activity.",
    "A CRM that fills itself from user activity.": "A CRM that fills itself from user activity.",
    "workspace.plans.products.subscription.title": "Subscriptions",
    "Subscriptions": "Subscriptions",
    "workspace.plans.products.subscription.description": "Recurring billing, trials, and dunning — handled.",
    "Recurring billing, trials, and dunning — handled.": "Recurring billing, trials, and dunning — handled.",
    "workspace.plans.products.recommendation.title": "Recommendations",
    "Recommendations": "Recommendations",
    "workspace.plans.products.recommendation.description": "Show each user what they will actually want.",
    "Show each user what they will actually want.": "Show each user what they will actually want.",
    "workspace.plans.marketplace.2025-superstarter.title": "Basic",
    "Basic": "Basic",
    "workspace.plans.marketplace.2025-superstarter.description": "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).",
    "workspace.plans.marketplace.2025-superstarter.button": "Start 7 Days Trial",
    "Start 7 Days Trial": "Start 7 Days Trial",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "No transaction fee",
    "No transaction fee": "No transaction fee",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Free Tradly hosted website",
    "Free Tradly hosted website": "Free Tradly hosted website",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Add your custom domain",
    "Add your custom domain": "Add your custom domain",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Editor - 3 Day page history",
    "Editor - 3 Day page history": "Editor - 3 Day page history",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.",
    "workspace.plans.marketplace.2025-starter.button": "Start 7 Days Trial",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "No transaction fee",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Unlimited Custom Attributes",
    "Unlimited Custom Attributes": "Unlimited Custom Attributes",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "30 Day page history",
    "30 Day page history": "30 Day page history",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Gated Subscription",
    "Gated Subscription": "Gated Subscription",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Social Logins",
    "Social Logins": "Social Logins",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhooks",
    "Webhooks": "Webhooks",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.",
    "workspace.plans.marketplace.2025-growth.button": "Start 7 Days Trial",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "No transaction fee",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Custom 'From Email'",
    "Custom 'From Email'": "Custom 'From Email'",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Additional Mini Tools & Integrations",
    "Additional Mini Tools & Integrations": "Additional Mini Tools & Integrations",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Personalised Onboarding calls*",
    "Personalised Onboarding calls*": "Personalised Onboarding calls*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "90 Day page history",
    "90 Day page history": "90 Day page history",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Multi Currencies & Multi Languages",
    "Multi Currencies & Multi Languages": "Multi Currencies & Multi Languages",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Role-based access control (RBAC)",
    "Role-based access control (RBAC)": "Role-based access control (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Inbuilt Chat for Apps",
    "Inbuilt Chat for Apps": "Inbuilt Chat for Apps",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.",
    "workspace.plans.marketplace.2025-scale.button": "Start 7 Days Trial",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "No transaction fee",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Priority Support",
    "Priority Support": "Priority Support",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Multiple Channels (App Support)",
    "Multiple Channels (App Support)": "Multiple Channels (App Support)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Single Sign-on (SSO)",
    "Single Sign-on (SSO)": "Single Sign-on (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Unlimited page history",
    "Unlimited page history": "Unlimited page history",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "In-built Chat for Apps",
    "In-built Chat for Apps": "In-built Chat for Apps",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Everything a growing store needs — remove branding, add your domain, and unlock more tools.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Everything a growing store needs — remove branding, add your domain, and unlock more tools.",
    "workspace.plans.indie.go.button": "Start 7-day trial",
    "Start 7-day trial": "Start 7-day trial",
    "workspace.plans.indie.go.feature_1.title": "No Tradly branding",
    "No Tradly branding": "No Tradly branding",
    "workspace.plans.indie.go.feature_2.title": "Custom domain",
    "Custom domain": "Custom domain",
    "workspace.plans.indie.go.feature_3.title": "Unlimited products",
    "Unlimited products": "Unlimited products",
    "workspace.plans.indie.go.feature_4.title": "Email campaigns",
    "Email campaigns": "Email campaigns",
    "workspace.plans.indie.go.feature_5.title": "AI Recommendations",
    "AI Recommendations": "AI Recommendations",
    "workspace.plans.indie.go.feature_6.title": "Ticket-based support",
    "Ticket-based support": "Ticket-based support",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Full AI stack, advanced marketing, and everything unlocked for stores serious about growth.",
    "Full AI stack, advanced marketing, and everything unlocked for stores serious about growth.": "Full AI stack, advanced marketing, and everything unlocked for stores serious about growth.",
    "workspace.plans.indie.genius.button": "Start 7-day trial",
    "workspace.plans.indie.genius.feature_1.title": "Everything in Pro",
    "Everything in Pro": "Everything in Pro",
    "workspace.plans.indie.genius.feature_2.title": "AI Agents (Shopping Assistant, etc.)",
    "AI Agents (Shopping Assistant, etc.)": "AI Agents (Shopping Assistant, etc.)",
    "workspace.plans.indie.genius.feature_3.title": "Natural language search",
    "Natural language search": "Natural language search",
    "workspace.plans.indie.genius.feature_4.title": "Advanced email automation",
    "Advanced email automation": "Advanced email automation",
    "workspace.plans.indie.genius.feature_5.title": "Unlimited recommendation requests",
    "Unlimited recommendation requests": "Unlimited recommendation requests",
    "workspace.plans.indie.genius.feature_6.title": "Ticket-based support",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Subscription charges for people to open accounts & submit listings",
    "Subscription charges for people to open accounts & submit listings": "Subscription charges for people to open accounts & submit listings",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Signup/in via Google, Meta",
    "Signup/in via Google, Meta": "Signup/in via Google, Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "To connect with Zapier & Make",
    "To connect with Zapier & Make": "To connect with Zapier & Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Native in-app messaging for your users",
    "Native in-app messaging for your users": "Native in-app messaging for your users",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "24 hour response time for non-critical",
    "24 hour response time for non-critical": "24 hour response time for non-critical",
    "common.continue": "Continue",
    "Continue": "Continue",
    "workspace.plans.free_plan": "Free",
    "Free": "Free",
    "workspace.usage.group_platform": "Platform & workspace",
    "Platform & workspace": "Platform & workspace",
    "workspace.usage.group_ai": "AI & usage",
    "AI & usage": "AI & usage",
    "workspace.usage.group_storage": "Content & storage",
    "Content & storage": "Content & storage",
    "workspace.usage.group_alacarte": "A la carte",
    "workspace.usage.accounts": "Accounts",
    "workspace.usage.listings": "Listings",
    "workspace.usage.sites": "Sites under workspace",
    "Sites under workspace": "Sites under workspace",
    "workspace.usage.external_users": "External users",
    "External users": "External users",
    "workspace.usage.internal_users": "Internal users",
    "Internal users": "Internal users",
    "workspace.usage.ai_credits": "AI credits",
    "AI credits": "AI credits",
    "workspace.usage.storage": "Storage",
    "Storage": "Storage",
    "workspace.usage.email": "Email",
    "workspace.usage.maps": "Maps",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analytics",
    "workspace.usage.recommendations": "Recommendations",
    "workspace.usage.ai_agents": "AI agents",
    "AI agents": "AI agents",
    "workspace.usage.status_not_reported": "Not reported",
    "Not reported": "Not reported",
    "workspace.usage.status_nearly_full": "Nearly full",
    "Nearly full": "Nearly full",
    "workspace.usage.status_on_track": "On track",
    "On track": "On track",
    "workspace.usage.workspace_files": "Workspace files",
    "Workspace files": "Workspace files",
    "workspace.usage.workspace_usage": "Workspace usage",
    "Workspace usage": "Workspace usage",
    "workspace.usage.of_limit": "of {limit}",
    "of {limit}": "of {limit}",
    "workspace.usage.no_cap": "No cap configured",
    "No cap configured": "No cap configured",
    "workspace.usage.trend": "Usage trend",
    "Usage trend": "Usage trend",
    "workspace.usage.unavailable": "Usage data is temporarily unavailable.",
    "Usage data is temporarily unavailable.": "Usage data is temporarily unavailable.",
    "workspace.usage.loading": "Loading workspace usage…",
    "Loading workspace usage…": "Loading workspace usage…",
    "workspace.usage.overview": "Workspace overview",
    "Workspace overview": "Workspace overview",
    "workspace.usage.title": "Usage breakdown",
    "Usage breakdown": "Usage breakdown",
    "workspace.usage.description": "See what your workspace has used and how much room remains on your current plan.",
    "See what your workspace has used and how much room remains on your current plan.": "See what your workspace has used and how much room remains on your current plan.",
    "workspace.usage.view_plans": "View plans",
    "workspace.usage.showing_available_limits": "Showing the limits that are already available in this workspace.",
    "Showing the limits that are already available in this workspace.": "Showing the limits that are already available in this workspace.",
    "workspace.usage.summary": "Usage summary",
    "Usage summary": "Usage summary",
    "workspace.usage.metrics_tracked": "Metrics tracked",
    "Metrics tracked": "Metrics tracked",
    "workspace.usage.metrics_count": "{count} of {total}",
    "{count} of {total}": "{count} of {total}",
    "workspace.usage.next_reset": "Next reset",
    "Next reset": "Next reset",
    "workspace.usage.not_provided": "Not provided",
    "Not provided": "Not provided",
    "workspace.usage.data_source": "Data source",
    "Data source": "Data source",
    "workspace.usage.clear_view": "A clear view of your workspace",
    "A clear view of your workspace": "A clear view of your workspace",
    "workspace.usage.by_resource": "Usage by resource",
    "Usage by resource": "Usage by resource",
    "workspace.usage.live_summary": "Live summary",
    "Live summary": "Live summary",
    "workspace.usage.resource": "Resource",
    "Resource": "Resource",
    "workspace.usage.used_limit": "Used / limit",
    "Used / limit": "Used / limit",
    "workspace.usage.progress": "Progress",
    "Progress": "Progress",
    "workspace.usage.cost": "Cost",
    "Cost": "Cost",
    "workspace.usage.footnote": "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.",
    "workspace.usage.refresh": "Refresh",
    "Refresh": "Refresh",
    "maps.title": "Maps",
    "maps.tab.analysis": "Market scan",
    "Market scan": "Market scan",
    "maps.tab.usage": "Usage",
    "maps.tab.settings": "Settings",
    "maps.action.save": "Save",
    "maps.action.saving": "Saving…",
    "maps.action.analyze_area": "Analyze area",
    "Analyze area": "Analyze area",
    "maps.action.analyzing": "Analyzing…",
    "Analyzing…": "Analyzing…",
    "maps.action.refresh": "Refresh",
    "maps.action.loading": "Loading…",
    "Loading…": "Loading…",
    "maps.action.open_in_maps": "Open in Maps",
    "Open in Maps": "Open in Maps",
    "maps.analysis.title": "Explore a local market",
    "Explore a local market": "Explore a local market",
    "maps.analysis.description": "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.",
    "maps.analysis.address_label": "Address or locality",
    "Address or locality": "Address or locality",
    "maps.analysis.address_placeholder": "Street, suburb, or city",
    "Street, suburb, or city": "Street, suburb, or city",
    "maps.analysis.category_label": "Business type",
    "Business type": "Business type",
    "maps.analysis.radius_label": "Search radius",
    "Search radius": "Search radius",
    "maps.analysis.places_listings": "Places listings",
    "Places listings": "Places listings",
    "maps.analysis.within_radius": "{category} within {radius}",
    "{category} within {radius}": "{category} within {radius}",
    "maps.analysis.results_description": "Results are filtered by category and radius, then ordered by distance.",
    "Results are filtered by category and radius, then ordered by distance.": "Results are filtered by category and radius, then ordered by distance.",
    "maps.analysis.result_limit_notice": "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.",
    "maps.analysis.limitations": "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.",
    "maps.analysis.nearby_businesses": "Nearby businesses ({count})",
    "Nearby businesses ({count})": "Nearby businesses ({count})",
    "maps.analysis.businesses": "Businesses",
    "Businesses": "Businesses",
    "maps.analysis.no_listings": "No matching Google Maps listings were returned for this area and category.",
    "No matching Google Maps listings were returned for this area and category.": "No matching Google Maps listings were returned for this area and category.",
    "maps.category.retail": "Retail",
    "Retail": "Retail",
    "maps.category.grocery": "Grocery",
    "Grocery": "Grocery",
    "maps.category.clothing": "Clothing",
    "Clothing": "Clothing",
    "maps.category.pharmacy": "Pharmacy",
    "Pharmacy": "Pharmacy",
    "maps.category.restaurant": "Restaurant / café",
    "Restaurant / café": "Restaurant / café",
    "maps.competition.limited": "Limited listed competition",
    "Limited listed competition": "Limited listed competition",
    "maps.competition.some": "Some listed competition",
    "Some listed competition": "Some listed competition",
    "maps.competition.many": "Many listed competitors",
    "Many listed competitors": "Many listed competitors",
    "maps.competition.limit_reached": "At least 20 listings (result limit reached)",
    "At least 20 listings (result limit reached)": "At least 20 listings (result limit reached)",
    "maps.competition.default": "Listed competition",
    "Listed competition": "Listed competition",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Operational",
    "Operational": "Operational",
    "maps.usage.title": "Provider usage",
    "Provider usage": "Provider usage",
    "maps.usage.description": "Request counts recorded by the Maps service. Charges are reconciled separately.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Request counts recorded by the Maps service. Charges are reconciled separately.",
    "maps.usage.days": "{count} days",
    "{count} days": "{count} days",
    "maps.usage.provider_requests": "Provider requests",
    "Provider requests": "Provider requests",
    "maps.usage.range_detail": "{count} day window",
    "{count} day window": "{count} day window",
    "maps.usage.successful": "Successful",
    "Successful": "Successful",
    "maps.usage.completed_calls": "Completed provider calls",
    "Completed provider calls": "Completed provider calls",
    "maps.usage.errors": "Errors",
    "Errors": "Errors",
    "maps.usage.failed_calls": "Failed provider calls",
    "Failed provider calls": "Failed provider calls",
    "maps.usage.metered_units": "Metered units",
    "Metered units": "Metered units",
    "maps.usage.unit_detail": "One unit per recorded request",
    "One unit per recorded request": "One unit per recorded request",
    "maps.usage.by_operation": "Usage by operation",
    "Usage by operation": "Usage by operation",
    "maps.usage.group_description": "Counts are grouped by provider, operation, and outcome.",
    "Counts are grouped by provider, operation, and outcome.": "Counts are grouped by provider, operation, and outcome.",
    "maps.usage.empty": "No map requests in this date range.",
    "No map requests in this date range.": "No map requests in this date range.",
    "maps.usage.provider": "Provider",
    "Provider": "Provider",
    "maps.usage.operation": "Operation",
    "Operation": "Operation",
    "maps.usage.outcome": "Outcome",
    "Outcome": "Outcome",
    "maps.usage.requests": "Requests",
    "Requests": "Requests",
    "maps.usage.units": "Units",
    "Units": "Units",
    "maps.settings.provider_title": "Map provider",
    "Map provider": "Map provider",
    "maps.settings.provider_description": "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.",
    "maps.settings.selected": "Selected",
    "maps.settings.available": "Available",
    "maps.settings.planned": "Planned",
    "Planned": "Planned",
    "maps.settings.origins_title": "Allowed website origins",
    "Allowed website origins": "Allowed website origins",
    "maps.settings.origins_description": "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.",
    "maps.settings.registered_domains": "Registered domains",
    "Registered domains": "Registered domains",
    "maps.settings.no_domains": "No registered domains were loaded.",
    "No registered domains were loaded.": "No registered domains were loaded.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Add origin",
    "Add origin": "Add origin",
    "maps.settings.remove_origin": "Remove",
    "maps.settings.no_origins": "No extra origins added.",
    "No extra origins added.": "No extra origins added.",
    "maps.error.session_not_ready": "Your admin session is not ready yet.",
    "Your admin session is not ready yet.": "Your admin session is not ready yet.",
    "maps.error.load_data": "Unable to load Maps data ({status}).",
    "Unable to load Maps data ({status}).": "Unable to load Maps data ({status}).",
    "maps.error.load_usage": "Unable to load Maps usage.",
    "Unable to load Maps usage.": "Unable to load Maps usage.",
    "maps.error.load_settings": "Unable to load Maps settings.",
    "Unable to load Maps settings.": "Unable to load Maps settings.",
    "maps.error.save_settings": "Unable to save Maps settings.",
    "Unable to save Maps settings.": "Unable to save Maps settings.",
    "maps.error.invalid_origin": "Enter a complete origin, such as https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Enter a complete origin, such as https://staging.example.com.",
    "maps.error.registered_origin": "This origin is already covered by a registered domain.",
    "This origin is already covered by a registered domain.": "This origin is already covered by a registered domain.",
    "maps.error.address_required": "Enter an address or locality to scan.",
    "Enter an address or locality to scan.": "Enter an address or locality to scan.",
    "maps.error.location_not_found": "Unable to find that location.",
    "Unable to find that location.": "Unable to find that location.",
    "maps.error.no_coordinates": "No coordinates were found for that address. Try a nearby street, suburb, or city.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "No coordinates were found for that address. Try a nearby street, suburb, or city.",
    "maps.error.analyze_area": "Unable to analyze this area.",
    "Unable to analyze this area.": "Unable to analyze this area.",
    "maps.notice.settings_saved": "Maps settings saved.",
    "Maps settings saved.": "Maps settings saved.",
    "maps.status.success": "Success",
    "maps.status.error": "Error",
    "maps.operation.geocode": "Geocode",
    "Geocode": "Geocode",
    "maps.operation.maps_geocode": "Maps geocode",
    "Maps geocode": "Maps geocode",
    "maps.operation.market_analysis": "Market analysis",
    "Market analysis": "Market analysis",
    "maps.operation.maps_market_analysis": "Maps market analysis",
    "Maps market analysis": "Maps market analysis",
    "maps.operation.places_search": "Places search",
    "Places search": "Places search",
    "maps.operation.places_nearby": "Nearby places",
    "Nearby places": "Nearby places",
    "maps.operation.place_details": "Place details",
    "Place details": "Place details",
    "common.loading": "Loading…",
    "common.saving": "Saving…",
    "common.searching": "Searching…",
    "Searching…": "Searching…",
    "common.no_matches": "No matches found.",
    "No matches found.": "No matches found.",
    "common.select": "Select…",
    "Select…": "Select…",
    "common.search_users": "Search users by name or email",
    "Search users by name or email": "Search users by name or email",
    "common.reset": "Reset",
    "Reset": "Reset",
    "common.validation.email": "Enter a valid email address.",
    "Enter a valid email address.": "Enter a valid email address.",
    "common.validation.phone": "Enter a valid phone number.",
    "Enter a valid phone number.": "Enter a valid phone number.",
    "common.validation.currency": "Use a 3-letter currency code, such as USD.",
    "Use a 3-letter currency code, such as USD.": "Use a 3-letter currency code, such as USD.",
    "common.validation.location": "Enter a valid address or location.",
    "Enter a valid address or location.": "Enter a valid address or location.",
    "common.validation.required": "{label} is required.",
    "{label} is required.": "{label} is required.",
    "common.validation.invalid": "{label} is invalid.",
    "{label} is invalid.": "{label} is invalid.",
    "common.status.active": "Active",
    "common.status.inactive": "Inactive",
    "common.status.open": "Open",
    "common.status.closed": "Closed",
    "Closed": "Closed",
    "common.status.posted": "Posted",
    "Posted": "Posted",
    "common.status.voided": "Voided",
    "Voided": "Voided",
    "common.status.draft": "Draft",
    "Draft": "Draft",
    "common.status.success": "Success",
    "common.status.error": "Error",
    "accounting.title": "Accounting",
    "accounting.description": "Manage accounts, mappings, periods, journals, and financial reports.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Manage accounts, mappings, periods, journals, and financial reports.",
    "accounting.tab.overview": "Overview",
    "Overview": "Overview",
    "accounting.tab.accounts": "Chart of accounts",
    "Chart of accounts": "Chart of accounts",
    "accounting.tab.mappings": "Account mappings",
    "Account mappings": "Account mappings",
    "accounting.tab.periods": "Accounting periods",
    "Accounting periods": "Accounting periods",
    "accounting.tab.journals": "Journals",
    "Journals": "Journals",
    "accounting.tab.reports": "Reports",
    "accounting.account.edit_title": "Edit account",
    "Edit account": "Edit account",
    "accounting.account.new_title": "New account",
    "New account": "New account",
    "accounting.account.save": "Save account",
    "Save account": "Save account",
    "accounting.account.create": "Create account",
    "Create account": "Create account",
    "accounting.account.code": "Account code",
    "Account code": "Account code",
    "accounting.account.name": "Account name",
    "Account name": "Account name",
    "accounting.account.type": "Account type",
    "Account type": "Account type",
    "accounting.account.currency_id": "Currency ID",
    "Currency ID": "Currency ID",
    "accounting.account.active": "Active",
    "accounting.account.unnamed": "Unnamed account",
    "Unnamed account": "Unnamed account",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Payroll expense",
    "Payroll expense": "Payroll expense",
    "accounting.type.asset": "Asset",
    "Asset": "Asset",
    "accounting.type.liability": "Liability",
    "Liability": "Liability",
    "accounting.type.equity": "Equity",
    "Equity": "Equity",
    "accounting.type.revenue": "Revenue",
    "Revenue": "Revenue",
    "accounting.type.expense": "Expense",
    "Expense": "Expense",
    "accounting.toast.account_updated": "Account updated",
    "Account updated": "Account updated",
    "accounting.toast.account_created": "Account created",
    "Account created": "Account created",
    "accounting.toast.defaults_created": "Default accounts created",
    "Default accounts created": "Default accounts created",
    "accounting.toast.mapping_saved": "Mapping saved",
    "Mapping saved": "Mapping saved",
    "accounting.toast.period_closed": "Accounting period closed",
    "Accounting period closed": "Accounting period closed",
    "accounting.toast.period_created": "Period created",
    "Period created": "Period created",
    "accounting.toast.journal_created": "Journal created",
    "Journal created": "Journal created",
    "accounting.toast.journal_voided": "Journal voided",
    "Journal voided": "Journal voided",
    "accounting.validation.journal_balanced": "Journal must have a date, description, and balanced debit and credit totals.",
    "Journal must have a date, description, and balanced debit and credit totals.": "Journal must have a date, description, and balanced debit and credit totals.",
    "accounting.filter.all_types": "All account types",
    "All account types": "All account types",
    "accounting.filter.all_statuses": "All statuses",
    "All statuses": "All statuses",
    "accounting.action.bootstrap": "Bootstrap defaults",
    "Bootstrap defaults": "Bootstrap defaults",
    "accounting.action.new_account": "New account",
    "accounting.empty.accounts": "No accounts found.",
    "No accounts found.": "No accounts found.",
    "accounting.column.code": "Code",
    "Code": "Code",
    "accounting.column.account": "Account",
    "accounting.column.type": "Type",
    "Type": "Type",
    "accounting.column.currency": "Currency",
    "accounting.column.status": "Status",
    "accounting.action.edit": "Edit",
    "accounting.mapping.edit_title": "Edit account mapping",
    "Edit account mapping": "Edit account mapping",
    "accounting.mapping.new_title": "New account mapping",
    "New account mapping": "New account mapping",
    "accounting.mapping.save": "Save mapping",
    "Save mapping": "Save mapping",
    "accounting.mapping.create": "Create mapping",
    "Create mapping": "Create mapping",
    "accounting.mapping.source_type": "Source type",
    "Source type": "Source type",
    "accounting.mapping.event_key": "Event key",
    "Event key": "Event key",
    "accounting.mapping.debit_account": "Debit account",
    "Debit account": "Debit account",
    "accounting.mapping.credit_account": "Credit account",
    "Credit account": "Credit account",
    "accounting.mapping.tax_account": "Tax account",
    "Tax account": "Tax account",
    "accounting.mapping.none": "None",
    "None": "None",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filter source type",
    "Filter source type": "Filter source type",
    "accounting.action.new_mapping": "New mapping",
    "New mapping": "New mapping",
    "accounting.empty.mappings": "No account mappings found.",
    "No account mappings found.": "No account mappings found.",
    "accounting.column.source": "Source",
    "Source": "Source",
    "accounting.column.event": "Event",
    "Event": "Event",
    "accounting.column.debit": "Debit",
    "Debit": "Debit",
    "accounting.column.credit": "Credit",
    "Credit": "Credit",
    "accounting.period.close_confirm": "Close {period}? This cannot be reversed.",
    "Close {period}? This cannot be reversed.": "Close {period}? This cannot be reversed.",
    "accounting.period.this": "this accounting period",
    "this accounting period": "this accounting period",
    "accounting.period.new_title": "New accounting period",
    "New accounting period": "New accounting period",
    "accounting.period.create": "Create period",
    "Create period": "Create period",
    "accounting.period.name": "Period name",
    "Period name": "Period name",
    "accounting.period.start": "Start date",
    "accounting.period.end": "End date",
    "End date": "End date",
    "accounting.period.name_placeholder": "January 2027",
    "January 2027": "January 2027",
    "accounting.period.open": "Open",
    "accounting.period.closed": "Closed",
    "accounting.action.new_period": "New period",
    "New period": "New period",
    "accounting.empty.periods": "No accounting periods found.",
    "No accounting periods found.": "No accounting periods found.",
    "accounting.column.period": "Period",
    "accounting.column.start": "Start",
    "Start": "Start",
    "accounting.column.end": "End",
    "End": "End",
    "accounting.action.close_period": "Close period",
    "Close period": "Close period",
    "accounting.journal.new_title": "New journal",
    "New journal": "New journal",
    "accounting.journal.balance_help": "Debits and credits must balance before saving.",
    "Debits and credits must balance before saving.": "Debits and credits must balance before saving.",
    "accounting.journal.close": "Close",
    "accounting.journal.entry_date": "Entry date",
    "Entry date": "Entry date",
    "accounting.journal.description": "Description",
    "accounting.journal.source_type": "Source type",
    "accounting.journal.source_id": "Source ID",
    "Source ID": "Source ID",
    "accounting.journal.account": "Account",
    "accounting.journal.select_account": "Select account",
    "Select account": "Select account",
    "accounting.journal.debit_total": "Debit: {debit} · Credit: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Debit: {debit} · Credit: {credit} · {status}",
    "accounting.journal.balanced": "Balanced",
    "Balanced": "Balanced",
    "accounting.journal.unbalanced": "Unbalanced",
    "Unbalanced": "Unbalanced",
    "accounting.journal.add_line": "Add line",
    "Add line": "Add line",
    "accounting.journal.save": "Save journal",
    "Save journal": "Save journal",
    "accounting.journal.empty": "No journal lines.",
    "No journal lines.": "No journal lines.",
    "accounting.journal.reason_prompt": "Reason for voiding this journal:",
    "Reason for voiding this journal:": "Reason for voiding this journal:",
    "accounting.journal.details_title": "Journal #{id}",
    "Journal #{id}": "Journal #{id}",
    "accounting.action.view": "View",
    "View": "View",
    "accounting.action.void": "Void",
    "Void": "Void",
    "accounting.filter.all_accounts": "All accounts",
    "All accounts": "All accounts",
    "accounting.empty.journals": "No journals found.",
    "No journals found.": "No journals found.",
    "accounting.column.date": "Date",
    "accounting.column.description": "Description",
    "accounting.column.account_source": "Source",
    "accounting.empty.journal_lines": "No journal lines.",
    "accounting.report.trial_balance": "Trial balance",
    "Trial balance": "Trial balance",
    "accounting.report.general_ledger": "General ledger",
    "General ledger": "General ledger",
    "accounting.action.run_report": "Run report",
    "Run report": "Run report",
    "accounting.report.loading": "Loading report…",
    "Loading report…": "Loading report…",
    "accounting.empty.report": "No report rows found.",
    "No report rows found.": "No report rows found.",
    "accounting.report.choose_run": "Choose a report and run it.",
    "Choose a report and run it.": "Choose a report and run it.",
    "accounting.column.balance": "Balance",
    "Balance": "Balance",
    "accounting.overview.chart_title": "Chart of accounts",
    "accounting.overview.chart_description": "Define the accounts used by your ledger.",
    "Define the accounts used by your ledger.": "Define the accounts used by your ledger.",
    "accounting.overview.journals_title": "Journals",
    "accounting.overview.journals_description": "Create and review balanced journal entries.",
    "Create and review balanced journal entries.": "Create and review balanced journal entries.",
    "accounting.overview.reports_title": "Reports",
    "accounting.overview.reports_description": "Run trial balance and general ledger reports.",
    "Run trial balance and general ledger reports.": "Run trial balance and general ledger reports.",
    "common.refresh": "Refresh",
    "reports.search.title": "Search analytics",
    "Search analytics": "Search analytics",
    "reports.search.back_to_report": "Back to report",
    "Back to report": "Back to report",
    "reports.search.description": "Search demand shows what visitors are looking for and where your catalog needs coverage.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "Search demand shows what visitors are looking for and where your catalog needs coverage.",
    "reports.search.metric.searches": "Searches",
    "Searches": "Searches",
    "reports.search.metric.unique_keywords": "Unique keywords",
    "Unique keywords": "Unique keywords",
    "reports.search.metric.with_listings": "With listings",
    "With listings": "With listings",
    "reports.search.metric.no_matches": "No listing matches",
    "No listing matches": "No listing matches",
    "reports.search.metric.coverage": "Coverage",
    "Coverage": "Coverage",
    "reports.search.insights.title": "Admin insights",
    "Admin insights": "Admin insights",
    "reports.search.insights.no_results_one": "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.",
    "reports.search.insights.no_results_many": "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.",
    "reports.search.insights.all_covered": "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.",
    "reports.search.insights.empty": "Search data will appear after visitors search the marketplace.",
    "Search data will appear after visitors search the marketplace.": "Search data will appear after visitors search the marketplace.",
    "reports.search.insights.total_matches": "{count} total listing matches were returned across the loaded search records.",
    "{count} total listing matches were returned across the loaded search records.": "{count} total listing matches were returned across the loaded search records.",
    "reports.search.coverage_title": "Keyword coverage",
    "Keyword coverage": "Keyword coverage",
    "reports.search.loading": "Loading search analytics…",
    "Loading search analytics…": "Loading search analytics…",
    "reports.search.empty": "No search phrases found.",
    "No search phrases found.": "No search phrases found.",
    "reports.search.error.load": "Unable to load search analytics.",
    "Unable to load search analytics.": "Unable to load search analytics.",
    "reports.search.unknown": "Unknown search",
    "Unknown search": "Unknown search",
    "reports.search.column.keyword": "Keyword",
    "Keyword": "Keyword",
    "reports.search.column.listings": "Listings",
    "reports.search.column.coverage": "Coverage",
    "reports.search.column.last_searched": "Last searched",
    "Last searched": "Last searched",
    "reports.search.column.suggested_action": "Suggested action",
    "Suggested action": "Suggested action",
    "reports.search.status.covered": "Covered",
    "Covered": "Covered",
    "reports.search.status.no_matches": "No matches",
    "No matches": "No matches",
    "reports.search.action.review_ranking": "Review ranking",
    "Review ranking": "Review ranking",
    "reports.search.action.add_listing": "Add listing or category",
    "Add listing or category": "Add listing or category",
    "platform_health.title": "Platform health",
    "Platform health": "Platform health",
    "platform_health.tab.health": "Health",
    "Health": "Health",
    "platform_health.tab.configuration": "Configuration",
    "Configuration": "Configuration",
    "platform_health.action.refreshing": "Refreshing…",
    "Refreshing…": "Refreshing…",
    "platform_health.window_note": "The current view loads the first {count} records for each event type.",
    "The current view loads the first {count} records for each event type.": "The current view loads the first {count} records for each event type.",
    "platform_health.error.title": "Unable to load authentication audits",
    "Unable to load authentication audits": "Unable to load authentication audits",
    "platform_health.error.proxy_note": "The API may require this admin request to be proxied server-side rather than sent directly by the browser.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "The API may require this admin request to be proxied server-side rather than sent directly by the browser.",
    "platform_health.error.session": "Your admin session is not ready yet. Please sign in again.",
    "Your admin session is not ready yet. Please sign in again.": "Your admin session is not ready yet. Please sign in again.",
    "platform_health.error.load": "Unable to load authentication audits ({status}).",
    "Unable to load authentication audits ({status}).": "Unable to load authentication audits ({status}).",
    "platform_health.error.load_generic": "Unable to load platform health audits.",
    "Unable to load platform health audits.": "Unable to load platform health audits.",
    "platform_health.metric.login_attempts": "Login attempts",
    "Login attempts": "Login attempts",
    "platform_health.metric.signup_attempts": "Signup attempts",
    "Signup attempts": "Signup attempts",
    "platform_health.metric.audit_records": "Audit records",
    "Audit records": "Audit records",
    "platform_health.metric.successful": "Successful",
    "platform_health.metric.failed": "Failed",
    "platform_health.metric.outcome_returned": "Only when outcome is returned",
    "Only when outcome is returned": "Only when outcome is returned",
    "platform_health.metric.failure_rate": "Failure rate",
    "Failure rate": "Failure rate",
    "platform_health.metric.classified_records": "Classified records",
    "Classified records": "Classified records",
    "platform_health.activity.title": "Authentication activity",
    "Authentication activity": "Authentication activity",
    "platform_health.activity.description": "Attempts returned by the selected audit window",
    "Attempts returned by the selected audit window": "Attempts returned by the selected audit window",
    "platform_health.activity.no_timestamps": "No timestamped audit records returned.",
    "No timestamped audit records returned.": "No timestamped audit records returned.",
    "platform_health.event.login": "login",
    "login": "login",
    "platform_health.event.signup": "signup",
    "signup": "signup",
    "platform_health.status.success": "Success",
    "platform_health.status.failed": "Failed",
    "platform_health.status.recorded": "Recorded",
    "Recorded": "Recorded",
    "platform_health.unknown_day": "Unknown",
    "Unknown": "Unknown",
    "platform_health.failure_reasons": "Failure reasons",
    "Failure reasons": "Failure reasons",
    "platform_health.no_failures": "No classified failures returned.",
    "No classified failures returned.": "No classified failures returned.",
    "platform_health.unspecified_failure": "Unspecified failure",
    "Unspecified failure": "Unspecified failure",
    "platform_health.recent_records": "Recent audit records",
    "Recent audit records": "Recent audit records",
    "platform_health.normalized_note": "Raw fields are normalized only for display.",
    "Raw fields are normalized only for display.": "Raw fields are normalized only for display.",
    "platform_health.loaded_count": "{count} loaded",
    "{count} loaded": "{count} loaded",
    "platform_health.loading_records": "Loading audit records…",
    "Loading audit records…": "Loading audit records…",
    "platform_health.no_records": "No audit records returned.",
    "No audit records returned.": "No audit records returned.",
    "platform_health.column.event": "Event",
    "platform_health.column.status": "Status",
    "platform_health.column.user": "User",
    "User": "User",
    "platform_health.column.time": "Time",
    "Time": "Time",
    "platform_health.column.reason": "Reason",
    "Reason": "Reason",
    "platform_health.config.sign_in": "Sign-in method",
    "Sign-in method": "Sign-in method",
    "platform_health.config.facebook": "Facebook Auth",
    "Facebook Auth": "Facebook Auth",
    "platform_health.config.google": "Google Auth",
    "Google Auth": "Google Auth",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "These settings apply immediately. After you save them, they appear in apps and API responses.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "These settings apply immediately. After you save them, they appear in apps and API responses.",
    "integrations.note.mobile_release": "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.",
    "integrations.toast.saved": "Integration settings saved.",
    "Integration settings saved.": "Integration settings saved.",
    "integrations.error.save": "Unable to save integration settings.",
    "Unable to save integration settings.": "Unable to save integration settings.",
    "integrations.twilio.title": "Twilio integration",
    "Twilio integration": "Twilio integration",
    "integrations.twilio.account_sid": "Account SID",
    "Account SID": "Account SID",
    "integrations.twilio.account_sid_placeholder": "Enter account SID",
    "Enter account SID": "Enter account SID",
    "integrations.twilio.auth_token": "Auth token",
    "Auth token": "Auth token",
    "integrations.twilio.auth_token_placeholder": "Enter auth token",
    "Enter auth token": "Enter auth token",
    "integrations.twilio.source_phone": "Source phone number",
    "Source phone number": "Source phone number",
    "integrations.twilio.source_phone_placeholder": "Enter source phone number",
    "Enter source phone number": "Enter source phone number",
    "integrations.facebook.title": "Facebook Auth",
    "integrations.facebook.enable_login": "Enable Facebook login",
    "Enable Facebook login": "Enable Facebook login",
    "integrations.facebook.app_id": "App ID",
    "App ID": "App ID",
    "integrations.facebook.app_id_placeholder": "Enter app ID",
    "Enter app ID": "Enter app ID",
    "integrations.google.title": "Google Auth",
    "integrations.google.enable_sign_in": "Enable Google sign-in",
    "Enable Google sign-in": "Enable Google sign-in",
    "integrations.google.client_id": "Client ID",
    "Client ID": "Client ID",
    "integrations.google.client_id_placeholder": "Enter client ID",
    "Enter client ID": "Enter client ID",
    "integrations.auth.title": "Sign-in method",
    "integrations.auth.description": "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.",
    "integrations.auth.empty": "No supported sign-in method is currently configured. Select one to continue.",
    "No supported sign-in method is currently configured. Select one to continue.": "No supported sign-in method is currently configured. Select one to continue.",
    "integrations.auth.save_note": "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.",
    "integrations.auth.error.load": "Unable to load the current sign-in method.",
    "Unable to load the current sign-in method.": "Unable to load the current sign-in method.",
    "integrations.auth.error.save": "Unable to save the sign-in method.",
    "Unable to save the sign-in method.": "Unable to save the sign-in method.",
    "integrations.auth.toast.saved": "Sign-in method saved.",
    "Sign-in method saved.": "Sign-in method saved.",
    "integrations.auth.email_password": "Email and password",
    "Email and password": "Email and password",
    "integrations.auth.email_password_help": "Users verify their email during sign-up, then sign in with a password.",
    "Users verify their email during sign-up, then sign in with a password.": "Users verify their email during sign-up, then sign in with a password.",
    "integrations.auth.email_code": "Email one-time code",
    "Email one-time code": "Email one-time code",
    "integrations.auth.email_code_help": "Users receive a verification code by email for sign-up and sign-in.",
    "Users receive a verification code by email for sign-up and sign-in.": "Users receive a verification code by email for sign-up and sign-in.",
    "integrations.auth.phone_code": "Phone one-time code",
    "Phone one-time code": "Phone one-time code",
    "integrations.auth.phone_code_help": "Users receive a verification code by SMS for sign-up and sign-in.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Users receive a verification code by SMS for sign-up and sign-in.",
    "integrations.auth.phone_password": "Phone and password",
    "Phone and password": "Phone and password",
    "integrations.auth.phone_password_help": "Users verify their phone during sign-up, then sign in with a password.",
    "Users verify their phone during sign-up, then sign in with a password.": "Users verify their phone during sign-up, then sign in with a password.",
    "integrations.auth.email_password_unverified": "Email and password without sign-up verification",
    "Email and password without sign-up verification": "Email and password without sign-up verification",
    "integrations.auth.email_password_unverified_help": "Users can sign up with an email and password without an email verification code.",
    "Users can sign up with an email and password without an email verification code.": "Users can sign up with an email and password without an email verification code.",
    "integrations.auth.phone_password_unverified": "Phone and password without sign-up verification",
    "Phone and password without sign-up verification": "Phone and password without sign-up verification",
    "integrations.auth.phone_password_unverified_help": "Users can sign up with a phone and password without an SMS verification code.",
    "Users can sign up with a phone and password without an SMS verification code.": "Users can sign up with a phone and password without an SMS verification code.",
    "integrations.page.title": "App Integrations",
    "App Integrations": "App Integrations",
    "integrations.generic.id_placeholder": "Enter {name} ID",
    "Enter {name} ID": "Enter {name} ID",
    "integrations.generic.enable": "Enable {name} integration",
    "Enable {name} integration": "Enable {name} integration",
    "integrations.menu.map": "Maps",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Maps integration",
    "Maps integration": "Maps integration",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "API key",
    "API key": "API key",
    "integrations.maps.api_key_placeholder": "Enter API key",
    "Enter API key": "Enter API key",
    "integrations.maps.reverse_geocode_key": "Google Maps reverse geocoding API key",
    "Google Maps reverse geocoding API key": "Google Maps reverse geocoding API key",
    "integrations.maps.reverse_geocode_key_placeholder": "Enter Google Maps reverse geocoding API key",
    "Enter Google Maps reverse geocoding API key": "Enter Google Maps reverse geocoding API key",
    "integrations.maps.places_key": "Google Maps Places API key",
    "Google Maps Places API key": "Google Maps Places API key",
    "integrations.maps.places_key_placeholder": "Enter Google Maps Places API key",
    "Enter Google Maps Places API key": "Enter Google Maps Places API key",
    "integrations.maps.nearby_accounts": "Activate nearby accounts on the home page",
    "Activate nearby accounts on the home page": "Activate nearby accounts on the home page",
    "integrations.maps.listing_location": "Activate location in listing submission",
    "Activate location in listing submission": "Activate location in listing submission",
    "integrations.maps.account_location": "Activate location in account submission",
    "Activate location in account submission": "Activate location in account submission",
    "integrations.playstore.title": "Google Play integration",
    "Google Play integration": "Google Play integration",
    "integrations.playstore.application_id": "Application ID",
    "Application ID": "Application ID",
    "integrations.playstore.application_id_placeholder": "Enter application ID (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Enter application ID (com.tenantname.app)",
    "integrations.playstore.first_name": "First name",
    "integrations.playstore.first_name_placeholder": "Enter first name",
    "Enter first name": "Enter first name",
    "integrations.playstore.last_name": "Last name",
    "integrations.playstore.last_name_placeholder": "Enter last name",
    "Enter last name": "Enter last name",
    "integrations.playstore.unit": "Organizational unit",
    "Organizational unit": "Organizational unit",
    "integrations.playstore.unit_placeholder": "Enter organizational unit",
    "Enter organizational unit": "Enter organizational unit",
    "integrations.playstore.organization": "Organization",
    "Organization": "Organization",
    "integrations.playstore.organization_placeholder": "Enter organization name",
    "Enter organization name": "Enter organization name",
    "integrations.playstore.city": "City or locality",
    "City or locality": "City or locality",
    "integrations.playstore.city_placeholder": "Enter city or locality",
    "Enter city or locality": "Enter city or locality",
    "integrations.playstore.state": "State or province",
    "State or province": "State or province",
    "integrations.playstore.state_placeholder": "Enter state or province",
    "Enter state or province": "Enter state or province",
    "integrations.playstore.country_code": "Country code (XX)",
    "Country code (XX)": "Country code (XX)",
    "integrations.playstore.country_code_placeholder": "Enter country code",
    "Enter country code": "Enter country code",
    "integrations.playstore.link": "Google Play link",
    "Google Play link": "Google Play link",
    "integrations.playstore.link_placeholder": "Enter your app Google Play link",
    "Enter your app Google Play link": "Enter your app Google Play link",
    "integrations.admob.title": "AdMob integration",
    "AdMob integration": "AdMob integration",
    "integrations.admob.app_id": "App ID",
    "integrations.admob.app_id_placeholder": "Enter App ID",
    "Enter App ID": "Enter App ID",
    "integrations.admob.unit_id": "Unit ID",
    "Unit ID": "Unit ID",
    "integrations.admob.unit_id_placeholder": "Enter AdMob unit ID",
    "Enter AdMob unit ID": "Enter AdMob unit ID",
    "integrations.admob.listings_id": "Listings ID",
    "Listings ID": "Listings ID",
    "integrations.admob.listings_id_placeholder": "Enter listings ID",
    "Enter listings ID": "Enter listings ID",
    "integrations.admob.listing_detail_id": "Listing detail ID",
    "Listing detail ID": "Listing detail ID",
    "integrations.admob.listing_detail_id_placeholder": "Enter listing detail ID",
    "Enter listing detail ID": "Enter listing detail ID",
    "integrations.admob.home_id": "Home ID",
    "Home ID": "Home ID",
    "integrations.admob.home_id_placeholder": "Enter home ID",
    "Enter home ID": "Enter home ID",
    "integrations.admob.enable_ads": "Enable ads",
    "Enable ads": "Enable ads",
    "integrations.admob.enable_listing_ads": "Enable ads on the listings feed",
    "Enable ads on the listings feed": "Enable ads on the listings feed",
    "integrations.admob.enable_listing_detail_ads": "Enable ads on listing details",
    "Enable ads on listing details": "Enable ads on listing details",
    "integrations.admob.enable_home_ads": "Enable ads in the home bottom navigation",
    "Enable ads in the home bottom navigation": "Enable ads in the home bottom navigation",
    "integrations.save_success": "Saved successfully",
    "Saved successfully": "Saved successfully",
    "integrations.note.release": "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.",
    "integrations.action.download": "Download",
    "integrations.branch.title": "Branch integration",
    "Branch integration": "Branch integration",
    "integrations.branch.app_id": "App ID",
    "integrations.branch.app_id_placeholder": "Enter app ID",
    "integrations.branch.live_key": "Live key",
    "Live key": "Live key",
    "integrations.branch.live_key_placeholder": "Enter live key",
    "Enter live key": "Enter live key",
    "integrations.branch.live_secret": "Live secret",
    "Live secret": "Live secret",
    "integrations.branch.live_secret_placeholder": "Enter live secret",
    "Enter live secret": "Enter live secret",
    "integrations.branch.uri_scheme": "URI scheme",
    "URI scheme": "URI scheme",
    "integrations.branch.uri_scheme_placeholder": "Enter URI scheme",
    "Enter URI scheme": "Enter URI scheme",
    "integrations.branch.link_domain": "Link domain",
    "Link domain": "Link domain",
    "integrations.branch.link_domain_placeholder": "Enter link domain",
    "Enter link domain": "Enter link domain",
    "integrations.branch.alternate_domain": "Alternate link domain",
    "Alternate link domain": "Alternate link domain",
    "integrations.branch.alternate_domain_placeholder": "Enter alternate link domain",
    "Enter alternate link domain": "Enter alternate link domain",
    "integrations.branch.link_description": "Link description",
    "Link description": "Link description",
    "integrations.branch.link_description_placeholder": "Enter link description",
    "Enter link description": "Enter link description",
    "integrations.branch.invite_friends": "Invite friends",
    "Invite friends": "Invite friends",
    "integrations.branch.invite_title": "Title",
    "Title": "Title",
    "integrations.branch.invite_description": "Description",
    "integrations.branch.destination_link": "Branch destination link (optional)",
    "Branch destination link (optional)": "Branch destination link (optional)",
    "integrations.branch.web_app_note": "Applies to web app users",
    "Applies to web app users": "Applies to web app users",
    "integrations.branch.destination_placeholder": "Enter branch destination link",
    "Enter branch destination link": "Enter branch destination link",
    "integrations.ios.title": "App Store provisioning",
    "App Store provisioning": "App Store provisioning",
    "integrations.ios.bundle_id": "Bundle ID",
    "Bundle ID": "Bundle ID",
    "integrations.ios.bundle_id_placeholder": "Enter bundle ID",
    "Enter bundle ID": "Enter bundle ID",
    "integrations.ios.certificate_password": "Distribution certificate password",
    "Distribution certificate password": "Distribution certificate password",
    "integrations.ios.certificate_password_placeholder": "Enter distribution certificate password",
    "Enter distribution certificate password": "Enter distribution certificate password",
    "integrations.ios.push_key_id": "Push key ID",
    "Push key ID": "Push key ID",
    "integrations.ios.push_key_id_placeholder": "Enter push key ID",
    "Enter push key ID": "Enter push key ID",
    "integrations.ios.team_id": "Team ID",
    "Team ID": "Team ID",
    "integrations.ios.team_id_placeholder": "Enter team ID",
    "Enter team ID": "Enter team ID",
    "integrations.ios.apple_id": "Apple ID",
    "Apple ID": "Apple ID",
    "integrations.ios.apple_id_placeholder": "Enter Apple ID",
    "Enter Apple ID": "Enter Apple ID",
    "integrations.ios.distribution_certificate": "Distribution certificate",
    "Distribution certificate": "Distribution certificate",
    "integrations.ios.provisioning_profile": "Distribution provisioning profile",
    "Distribution provisioning profile": "Distribution provisioning profile",
    "integrations.ios.push_key": "Push key",
    "Push key": "Push key",
    "integrations.ios.app_store_link": "Your App Store link",
    "Your App Store link": "Your App Store link",
    "integrations.ios.app_store_link_placeholder": "Enter your app App Store link",
    "Enter your app App Store link": "Enter your app App Store link",
    "integrations.firebase.title": "Firebase integration",
    "Firebase integration": "Firebase integration",
    "integrations.firebase.choose_file": "Choose file",
    "Choose file": "Choose file",
    "integrations.firebase.service_account": "Firebase service account",
    "Firebase service account": "Firebase service account",
    "integrations.firebase.android_json": "Android app JSON file",
    "Android app JSON file": "Android app JSON file",
    "integrations.firebase.ios_plist": "iOS app plist file",
    "iOS app plist file": "iOS app plist file",
    "integrations.firebase.create_project": "Create Firebase project",
    "Create Firebase project": "Create Firebase project",
    "integrations.firebase.create_android": "Create Android app",
    "Create Android app": "Create Android app",
    "integrations.firebase.create_ios": "Create iOS app",
    "Create iOS app": "Create iOS app",
    "integrations.firebase.create_database": "Create realtime database",
    "Create realtime database": "Create realtime database",
    "integrations.firebase.apply_rules": "Apply Firebase database rules",
    "Apply Firebase database rules": "Apply Firebase database rules",
    "bundles.listing_number": "Listing #{id}",
    "Listing #{id}": "Listing #{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Configure bundle",
    "Configure bundle": "Configure bundle",
    "bundles.configure.subtitle": "Bundle listing #{id} · add existing listings below.",
    "Bundle listing #{id} · add existing listings below.": "Bundle listing #{id} · add existing listings below.",
    "bundles.back": "Back to bundles",
    "Back to bundles": "Back to bundles",
    "bundles.fixed_components": "Fixed components",
    "Fixed components": "Fixed components",
    "bundles.selection_pool": "Mix-and-match pool",
    "Mix-and-match pool": "Mix-and-match pool",
    "bundles.available_listings": "Available listings",
    "Available listings": "Available listings",
    "bundles.available_description": "Search and add products already in your catalogue.",
    "Search and add products already in your catalogue.": "Search and add products already in your catalogue.",
    "bundles.search_listings": "Search listings",
    "Search listings": "Search listings",
    "bundles.quantity_per_component": "Quantity per component",
    "Quantity per component": "Quantity per component",
    "bundles.loading_listings": "Loading listings…",
    "Loading listings…": "Loading listings…",
    "bundles.added": "Added",
    "Added": "Added",
    "bundles.adding": "Adding…",
    "Adding…": "Adding…",
    "bundles.add": "Add",
    "bundles.no_matching_listings": "No matching listings found.",
    "No matching listings found.": "No matching listings found.",
    "bundles.one_listing_added": "1 listing added",
    "1 listing added": "1 listing added",
    "bundles.many_listings_added": "{count} listings added",
    "{count} listings added": "{count} listings added",
    "bundles.quantity_short": "Qty {count}",
    "Qty {count}": "Qty {count}",
    "bundles.removing": "Removing…",
    "Removing…": "Removing…",
    "bundles.remove": "Remove",
    "bundles.no_components": "No components added yet.",
    "No components added yet.": "No components added yet.",
    "bundles.pool_remove_note": "Pool removal needs the backend delete endpoint; additions are enabled now.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "Pool removal needs the backend delete endpoint; additions are enabled now.",
    "bundles.error.load_components": "Unable to load bundle components.",
    "Unable to load bundle components.": "Unable to load bundle components.",
    "bundles.error.add_listing": "Unable to add listing to the bundle.",
    "Unable to add listing to the bundle.": "Unable to add listing to the bundle.",
    "bundles.error.remove_component": "Unable to remove bundle component.",
    "Unable to remove bundle component.": "Unable to remove bundle component.",
    "bundles.error.load_listings": "Unable to load listings.",
    "Unable to load listings.": "Unable to load listings.",
    "bundles.components": "Bundle components",
    "Bundle components": "Bundle components",
    "bundles.picker_description": "Select listings that already exist in your catalogue. They will be linked after the bundle is created.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Select listings that already exist in your catalogue. They will be linked after the bundle is created.",
    "bundles.fixed_bundle": "Fixed bundle",
    "Fixed bundle": "Fixed bundle",
    "bundles.mix_match": "Mix and match",
    "Mix and match": "Mix and match",
    "bundles.quantity_per_selected": "Quantity per selected listing",
    "Quantity per selected listing": "Quantity per selected listing",
    "bundles.search_existing": "Search existing listings",
    "Search existing listings": "Search existing listings",
    "bundles.selected_count": "Selected ({count})",
    "Selected ({count})": "Selected ({count})",
    "bundles.choose_component_hint": "Choose at least one existing listing, or create the bundle first.",
    "Choose at least one existing listing, or create the bundle first.": "Choose at least one existing listing, or create the bundle first.",
    "bundles.error.attach_components": "The bundle was created, but components could not be attached.",
    "The bundle was created, but components could not be attached.": "The bundle was created, but components could not be attached.",
    "bundles.continue_configure_hint": "You can continue from the bundle configuration page.",
    "You can continue from the bundle configuration page.": "You can continue from the bundle configuration page.",
    "bundles.title": "Bundles",
    "bundles.create": "Create bundle",
    "Create bundle": "Create bundle",
    "bundles.subtitle": "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.",
    "bundles.workflow": "Bundle workflow",
    "Bundle workflow": "Bundle workflow",
    "bundles.how_it_works": "How bundles work",
    "How bundles work": "How bundles work",
    "bundles.parent_description": "One parent listing controls the customer-facing bundle.",
    "One parent listing controls the customer-facing bundle.": "One parent listing controls the customer-facing bundle.",
    "bundles.flow": "Bundle flow",
    "Bundle flow": "Bundle flow",
    "bundles.parent_listing": "Parent listing",
    "Parent listing": "Parent listing",
    "bundles.name_price_category": "Name, price, category",
    "Name, price, category": "Name, price, category",
    "bundles.fixed_or_pool": "Fixed items or a pool",
    "Fixed items or a pool": "Fixed items or a pool",
    "bundles.checkout_stock": "Checkout stock",
    "Checkout stock": "Checkout stock",
    "bundles.selection_availability": "Selection + availability",
    "Selection + availability": "Selection + availability",
    "bundles.fixed_bundles": "Fixed bundles",
    "Fixed bundles": "Fixed bundles",
    "bundles.fixed_description": "Sell a defined group of existing listings together.",
    "Sell a defined group of existing listings together.": "Sell a defined group of existing listings together.",
    "bundles.fixed_detail": "Add existing listings as fixed components.",
    "Add existing listings as fixed components.": "Add existing listings as fixed components.",
    "bundles.pool_description": "Let customers choose eligible items from a bundle pool.",
    "Let customers choose eligible items from a bundle pool.": "Let customers choose eligible items from a bundle pool.",
    "bundles.pool_detail": "Set the minimum and maximum selections at checkout.",
    "Set the minimum and maximum selections at checkout.": "Set the minimum and maximum selections at checkout.",
    "channels.opensource.title": "Open-source starter kits",
    "Open-source starter kits": "Open-source starter kits",
    "channels.opensource.view_org": "View GitHub organization",
    "View GitHub organization": "View GitHub organization",
    "channels.opensource.description": "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.",
    "channels.opensource.loading": "Loading repositories…",
    "Loading repositories…": "Loading repositories…",
    "channels.opensource.error.http": "GitHub returned {status}.",
    "GitHub returned {status}.": "GitHub returned {status}.",
    "channels.opensource.error.load": "Unable to load repositories. Try again later.",
    "Unable to load repositories. Try again later.": "Unable to load repositories. Try again later.",
    "channels.opensource.empty": "No public repositories found.",
    "No public repositories found.": "No public repositories found.",
    "channels.opensource.repo_fallback": "Open-source Tradly repository.",
    "Open-source Tradly repository.": "Open-source Tradly repository.",
    "channels.opensource.language_code": "Code",
    "channels.opensource.view_repo": "View repository",
    "View repository": "View repository",
    "developer.mcp.select_all": "Select all",
    "Select all": "Select all",
    "developer.mcp.read": "Read",
    "developer.mcp.write": "Write",
    "developer.mcp.delete": "Delete",
    "developer.mcp.export": "Export",
    "developer.mcp.copy": "Copy",
    "Copy": "Copy",
    "developer.mcp.copied": "Copied",
    "Copied": "Copied",
    "developer.mcp.connection_created": "Connection created",
    "Connection created": "Connection created",
    "developer.mcp.save_secret_warning": "Save your client secret now — it will not be shown again.",
    "Save your client secret now — it will not be shown again.": "Save your client secret now — it will not be shown again.",
    "developer.mcp.client_id": "Client ID",
    "developer.mcp.client_secret": "Client secret",
    "Client secret": "Client secret",
    "developer.mcp.new_connection": "New MCP connection",
    "New MCP connection": "New MCP connection",
    "developer.mcp.platform": "Platform",
    "Platform": "Platform",
    "developer.mcp.platform_custom": "Custom",
    "developer.mcp.connection_name": "Connection name",
    "Connection name": "Connection name",
    "developer.mcp.connection_name_placeholder": "e.g. ChatGPT",
    "e.g. ChatGPT": "e.g. ChatGPT",
    "developer.mcp.redirect_uris": "Redirect URIs",
    "Redirect URIs": "Redirect URIs",
    "developer.mcp.one_per_line": "(one per line)",
    "(one per line)": "(one per line)",
    "developer.mcp.permissions": "Permissions",
    "Permissions": "Permissions",
    "developer.mcp.error.connection_name": "Enter a connection name",
    "Enter a connection name": "Enter a connection name",
    "developer.mcp.error.redirect_uri": "Enter at least one redirect URI",
    "Enter at least one redirect URI": "Enter at least one redirect URI",
    "developer.mcp.error.create": "Failed to create connection",
    "Failed to create connection": "Failed to create connection",
    "developer.mcp.creating": "Creating…",
    "Creating…": "Creating…",
    "developer.mcp.edit_permissions": "Edit permissions",
    "Edit permissions": "Edit permissions",
    "developer.mcp.permissions_updated": "Permissions updated",
    "Permissions updated": "Permissions updated",
    "developer.mcp.error.update_permissions": "Failed to update permissions",
    "Failed to update permissions": "Failed to update permissions",
    "developer.mcp.saving": "Saving…",
    "developer.mcp.error.load": "MCP connections could not be loaded.",
    "MCP connections could not be loaded.": "MCP connections could not be loaded.",
    "developer.mcp.confirm_delete": "Delete this connection? It will be removed from the list and its access revoked.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Delete this connection? It will be removed from the list and its access revoked.",
    "developer.mcp.connection_removed": "Connection removed",
    "Connection removed": "Connection removed",
    "developer.mcp.error.remove_connection": "Failed to remove connection",
    "Failed to remove connection": "Failed to remove connection",
    "developer.mcp.connection_deactivated": "Connection deactivated",
    "Connection deactivated": "Connection deactivated",
    "developer.mcp.error.deactivate_connection": "Failed to deactivate connection",
    "Failed to deactivate connection": "Failed to deactivate connection",
    "developer.mcp.title": "MCP connections",
    "MCP connections": "MCP connections",
    "developer.mcp.description": "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.",
    "developer.mcp.empty": "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.",
    "developer.mcp.status.connected_one": "Connected · 1 user",
    "Connected · 1 user": "Connected · 1 user",
    "developer.mcp.status.connected_many": "Connected · {count} users",
    "Connected · {count} users": "Connected · {count} users",
    "developer.mcp.status.deactivated": "Deactivated",
    "Deactivated": "Deactivated",
    "developer.mcp.status.previously_connected": "Previously connected",
    "Previously connected": "Previously connected",
    "developer.mcp.status.registered": "Registered · not connected",
    "Registered · not connected": "Registered · not connected",
    "developer.mcp.oauth_app": "OAuth app",
    "OAuth app": "OAuth app",
    "developer.mcp.created": "Created",
    "developer.mcp.updated": "Updated",
    "Updated": "Updated",
    "developer.mcp.edit_scopes": "Edit scopes",
    "Edit scopes": "Edit scopes",
    "developer.mcp.edit_scopes_for": "Edit scopes for {name}",
    "Edit scopes for {name}": "Edit scopes for {name}",
    "developer.mcp.deactivate_hint": "Deactivate (keeps it listed and logged)",
    "Deactivate (keeps it listed and logged)": "Deactivate (keeps it listed and logged)",
    "developer.mcp.deactivate_named": "Deactivate {name}",
    "Deactivate {name}": "Deactivate {name}",
    "developer.mcp.delete_connection": "Delete connection",
    "Delete connection": "Delete connection",
    "developer.mcp.delete_named": "Delete {name}",
    "Delete {name}": "Delete {name}",
    "developer.mcp.resource.listings": "Listings",
    "developer.mcp.resource.orders": "Orders",
    "developer.mcp.resource.users": "Users",
    "developer.mcp.resource.accounts": "Accounts",
    "developer.mcp.resource.categories": "Categories",
    "developer.mcp.resource.attributes": "Attributes",
    "developer.mcp.resource.analytics": "Analytics",
    "developer.mcp.resource.attribution": "Attribution",
    "Attribution": "Attribution",
    "developer.mcp.resource.rewards": "Rewards",
    "developer.mcp.resource.layers": "Layers / CMS",
    "Layers / CMS": "Layers / CMS",
    "developer.mcp.resource.settings": "Store settings",
    "Store settings": "Store settings",
    "developer.mcp.resource.marketing": "Marketing",
    "developer.mcp.resource.market_research": "Market research",
    "Market research": "Market research",
    "developer.mcp.resource.audiences": "Marketing audiences",
    "Marketing audiences": "Marketing audiences",
    "developer.mcp.resource.agents": "AI agents",
    "developer.mcp.resource.assets": "File uploads",
    "File uploads": "File uploads",
    "developer.mcp.resource.workforce": "Workforce",
    "developer.mcp.resource.inventory": "Inventory",
    "developer.mcp.resource.memberships": "Memberships",
    "Memberships": "Memberships",
    "developer.mcp.resource.bundles": "Bundles",
    "developer.mcp.resource.rentals": "Rentals",
    "Rentals": "Rentals",
    "developer.mcp.resource.accounting": "Accounting",
    "developer.mcp.nav.label": "MCP navigation",
    "MCP navigation": "MCP navigation",
    "developer.mcp.nav.connections": "Connections",
    "Connections": "Connections",
    "developer.mcp.nav.logs": "Logs",
    "Logs": "Logs",
    "developer.mcp.unknown_provider": "Unknown provider",
    "Unknown provider": "Unknown provider",
    "developer.mcp.tenant_user": "Tenant #{tenant} · User #{user}",
    "Tenant #{tenant} · User #{user}": "Tenant #{tenant} · User #{user}",
    "developer.mcp.logs.title": "MCP logs",
    "MCP logs": "MCP logs",
    "developer.mcp.logs.heading": "Recent agent activity",
    "Recent agent activity": "Recent agent activity",
    "developer.mcp.logs.description": "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.",
    "developer.mcp.logs.error.audit": "MCP audit logs could not be loaded.",
    "MCP audit logs could not be loaded.": "MCP audit logs could not be loaded.",
    "developer.mcp.logs.error.load": "MCP logs could not be loaded.",
    "MCP logs could not be loaded.": "MCP logs could not be loaded.",
    "developer.mcp.logs.unknown_agent": "Unknown agent",
    "Unknown agent": "Unknown agent",
    "developer.mcp.logs.all_agents": "All agents",
    "All agents": "All agents",
    "developer.mcp.logs.updated": "Updated {time}",
    "Updated {time}": "Updated {time}",
    "developer.mcp.logs.loading": "Loading MCP activity…",
    "Loading MCP activity…": "Loading MCP activity…",
    "developer.mcp.logs.empty": "No recent MCP events found for this tenant.",
    "No recent MCP events found for this tenant.": "No recent MCP events found for this tenant.",
    "developer.mcp.logs.empty_agent": "No recent MCP events found for this tenant and agent.",
    "No recent MCP events found for this tenant and agent.": "No recent MCP events found for this tenant and agent.",
    "developer.mcp.logs.time": "Time",
    "developer.mcp.logs.event": "Event",
    "developer.mcp.logs.tool": "Tool",
    "developer.mcp.logs.agent": "Agent",
    "Agent": "Agent",
    "developer.mcp.logs.tenant_user": "Tenant / user",
    "Tenant / user": "Tenant / user",
    "developer.mcp.logs.scope": "Scope",
    "Scope": "Scope",
    "developer.mcp.logs.result": "Result",
    "Result": "Result",
    "developer.mcp.logs.duration": "Duration",
    "Duration": "Duration",
    "developer.mcp.logs.view_details": "View details for {event}",
    "View details for {event}": "View details for {event}",
    "developer.mcp.logs.tenant": "Tenant #{id}",
    "Tenant #{id}": "Tenant #{id}",
    "developer.mcp.logs.user": "User #{id}",
    "User #{id}": "User #{id}",
    "developer.mcp.logs.view_granted_scopes": "View granted scopes",
    "View granted scopes": "View granted scopes",
    "developer.mcp.logs.succeeded": "Succeeded",
    "Succeeded": "Succeeded",
    "developer.mcp.logs.failed": "Failed",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "MCP event details",
    "MCP event details": "MCP event details",
    "developer.mcp.logs.required_scope": "Required scope",
    "Required scope": "Required scope",
    "developer.mcp.logs.granted_scopes": "Granted scopes",
    "Granted scopes": "Granted scopes",
    "developer.mcp.logs.event_generic": "Event",
    "developer.mcp.logs.event.tool_called": "Tool called",
    "Tool called": "Tool called",
    "developer.mcp.logs.event.connection_requested": "Connection requested",
    "Connection requested": "Connection requested",
    "developer.mcp.logs.event.connection_connected": "Connection connected",
    "Connection connected": "Connection connected",
    "developer.mcp.logs.event.connection_deactivated": "Connection deactivated",
    "developer.mcp.logs.event.connection_deleted": "Connection deleted",
    "Connection deleted": "Connection deleted",
    "developer.mcp.logs.event.permissions_updated": "Permissions updated",
    "common.status.label": "Status",
    "suppliers.title": "Suppliers",
    "suppliers.search": "Search suppliers",
    "Search suppliers": "Search suppliers",
    "suppliers.add": "Add supplier",
    "Add supplier": "Add supplier",
    "suppliers.deactivate": "Deactivate",
    "Deactivate": "Deactivate",
    "suppliers.empty": "No suppliers found.",
    "No suppliers found.": "No suppliers found.",
    "suppliers.add_title": "Add supplier",
    "suppliers.edit_title": "Edit supplier",
    "Edit supplier": "Edit supplier",
    "suppliers.save_changes": "Save changes",
    "Save changes": "Save changes",
    "suppliers.confirm_deactivate": "Deactivate {name}?",
    "Deactivate {name}?": "Deactivate {name}?",
    "suppliers.toast.updated": "Supplier updated",
    "Supplier updated": "Supplier updated",
    "suppliers.toast.added": "Supplier added",
    "Supplier added": "Supplier added",
    "suppliers.toast.deactivated": "Supplier deactivated",
    "Supplier deactivated": "Supplier deactivated",
    "suppliers.column.name": "Name",
    "suppliers.column.code": "Code",
    "suppliers.column.contact": "Contact",
    "Contact": "Contact",
    "suppliers.field.name": "Name",
    "suppliers.field.code": "Code",
    "suppliers.field.contact_name": "Contact name",
    "Contact name": "Contact name",
    "suppliers.field.email": "Email",
    "suppliers.field.phone": "Phone",
    "suppliers.field.currency": "Currency",
    "suppliers.field.payment_terms": "Payment terms",
    "Payment terms": "Payment terms",
    "suppliers.field.address": "Address",
    "suppliers.field.note": "Note",
    "Note": "Note",
    "suppliers.placeholder.name": "Company or supplier name",
    "Company or supplier name": "Company or supplier name",
    "suppliers.placeholder.code": "Supplier code",
    "Supplier code": "Supplier code",
    "suppliers.placeholder.contact_name": "Contact name",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Cash on delivery",
    "Cash on delivery": "Cash on delivery",
    "suppliers.payment_terms.payment_on_receipt": "Payment on receipt",
    "Payment on receipt": "Payment on receipt",
    "suppliers.payment_terms.payment_in_advance": "Payment in advance",
    "Payment in advance": "Payment in advance",
    "suppliers.payment_terms.net_7": "Net 7 days",
    "Net 7 days": "Net 7 days",
    "suppliers.payment_terms.net_15": "Net 15 days",
    "Net 15 days": "Net 15 days",
    "suppliers.payment_terms.net_30": "Net 30 days",
    "Net 30 days": "Net 30 days",
    "suppliers.payment_terms.net_45": "Net 45 days",
    "Net 45 days": "Net 45 days",
    "suppliers.payment_terms.net_60": "Net 60 days",
    "Net 60 days": "Net 60 days",
    "suppliers.detail_title": "Supplier details",
    "Supplier details": "Supplier details",
    "suppliers.edit": "Edit supplier",
    "suppliers.back": "Back to suppliers",
    "Back to suppliers": "Back to suppliers",
    "suppliers.loading": "Loading supplier…",
    "Loading supplier…": "Loading supplier…",
    "suppliers.unnamed": "Unnamed supplier",
    "Unnamed supplier": "Unnamed supplier",
    "suppliers.profile_description": "Supplier profile and contact information",
    "Supplier profile and contact information": "Supplier profile and contact information",
    "suppliers.total_spend": "Total spend",
    "Total spend": "Total spend",
    "suppliers.outstanding": "Outstanding",
    "Outstanding": "Outstanding",
    "suppliers.paid": "Paid",
    "suppliers.draft": "Draft",
    "suppliers.purchase_history": "Purchase history",
    "Purchase history": "Purchase history",
    "suppliers.bill.reference": "Reference",
    "Reference": "Reference",
    "suppliers.bill.date": "Date",
    "suppliers.bill.amount": "Amount",
    "suppliers.bill.number": "Bill #{id}",
    "Bill #{id}": "Bill #{id}",
    "suppliers.bills_empty": "No bills found for this supplier.",
    "No bills found for this supplier.": "No bills found for this supplier.",
    "inventory.locations.title": "Locations",
    "inventory.locations.add": "Add location",
    "Add location": "Add location",
    "inventory.locations.description": "Warehouses and stores that hold stock. Purchase orders are received into a location.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Warehouses and stores that hold stock. Purchase orders are received into a location.",
    "inventory.locations.field.name": "Name",
    "inventory.locations.field.code": "Code",
    "inventory.locations.field.address": "Address",
    "inventory.locations.field.linked_store": "Linked store (optional)",
    "Linked store (optional)": "Linked store (optional)",
    "inventory.locations.field.linked_store_short": "Linked store",
    "Linked store": "Linked store",
    "inventory.locations.placeholder.name": "Main warehouse",
    "Main warehouse": "Main warehouse",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Search an address or place",
    "Search an address or place": "Search an address or place",
    "inventory.locations.placeholder.linked_store": "Search seller or store accounts",
    "Search seller or store accounts": "Search seller or store accounts",
    "inventory.locations.confirm_deactivate": "Deactivate {name}? It will no longer be available for new purchase orders.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Deactivate {name}? It will no longer be available for new purchase orders.",
    "inventory.locations.toast.deactivated": "Location deactivated",
    "Location deactivated": "Location deactivated",
    "inventory.locations.deactivate": "Deactivate",
    "inventory.locations.empty": "No locations yet. Add a warehouse or store to start receiving stock.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "No locations yet. Add a warehouse or store to start receiving stock.",
    "inventory.locations.edit_title": "Edit location",
    "Edit location": "Edit location",
    "inventory.locations.add_title": "Add location",
    "inventory.locations.form_description": "Link a store account only if this location belongs to a specific seller.",
    "Link a store account only if this location belongs to a specific seller.": "Link a store account only if this location belongs to a specific seller.",
    "inventory.locations.save_changes": "Save changes",
    "inventory.locations.toast.updated": "Location updated",
    "Location updated": "Location updated",
    "inventory.locations.toast.added": "Location added",
    "Location added": "Location added",
    "inventory.operations.title": "Inventory operations",
    "Inventory operations": "Inventory operations",
    "inventory.operations.tab.movements": "Movement history",
    "Movement history": "Movement history",
    "inventory.operations.tab.batches": "Batches & expiry",
    "Batches & expiry": "Batches & expiry",
    "inventory.operations.tab.transfers": "Transfer orders",
    "Transfer orders": "Transfer orders",
    "inventory.operations.tab.requisitions": "Requisitions",
    "Requisitions": "Requisitions",
    "inventory.operations.tab.receipts": "Goods received",
    "Goods received": "Goods received",
    "inventory.operations.description.movements": "An immutable trail of every receive, sale, transfer, return, and adjustment.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "An immutable trail of every receive, sale, transfer, return, and adjustment.",
    "inventory.operations.description.batches": "Track lots, expiry dates, condition, and units without changing the stock ledger here.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Track lots, expiry dates, condition, and units without changing the stock ledger here.",
    "inventory.operations.description.transfers": "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.",
    "inventory.operations.description.requisitions": "Review internal stock requests. Approval creates a transfer order automatically.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Review internal stock requests. Approval creates a transfer order automatically.",
    "inventory.operations.description.receipts": "Create receipts and track open, partial, and closed receiving work.",
    "Create receipts and track open, partial, and closed receiving work.": "Create receipts and track open, partial, and closed receiving work.",
    "inventory.operations.overview": "Overview",
    "inventory.operations.new_transfer": "New transfer",
    "New transfer": "New transfer",
    "inventory.operations.new_requisition": "New requisition",
    "New requisition": "New requisition",
    "inventory.operations.new_receipt": "New receipt",
    "New receipt": "New receipt",
    "inventory.operations.search": "Search",
    "inventory.operations.search_view": "Search this view",
    "Search this view": "Search this view",
    "inventory.operations.search_products": "Search products",
    "Search products": "Search products",
    "inventory.operations.search_purchase_order": "Search purchase orders (optional)",
    "Search purchase orders (optional)": "Search purchase orders (optional)",
    "inventory.operations.listing_number": "Listing #{id}",
    "inventory.operations.location_number": "Location #{id}",
    "Location #{id}": "Location #{id}",
    "inventory.operations.no_sku": "No SKU",
    "No SKU": "No SKU",
    "inventory.operations.order_status": "Status: {status}",
    "Status: {status}": "Status: {status}",
    "inventory.operations.field.receiving_location": "Receiving location",
    "Receiving location": "Receiving location",
    "inventory.operations.field.purchase_order": "Purchase order",
    "Purchase order": "Purchase order",
    "inventory.operations.field.reference": "Reference",
    "inventory.operations.field.note": "Note",
    "inventory.operations.field.from_location": "From location",
    "From location": "From location",
    "inventory.operations.field.supplying_location": "Supplying location",
    "Supplying location": "Supplying location",
    "inventory.operations.field.to_location": "To location",
    "To location": "To location",
    "inventory.operations.field.requesting_location": "Requesting location",
    "Requesting location": "Requesting location",
    "inventory.operations.field.product": "Product",
    "Product": "Product",
    "inventory.operations.field.quantity": "Quantity",
    "Quantity": "Quantity",
    "inventory.operations.field.location": "Location",
    "Location": "Location",
    "inventory.operations.placeholder.delivery_note": "Supplier delivery note",
    "Supplier delivery note": "Supplier delivery note",
    "inventory.operations.placeholder.receiving_note": "Optional receiving note",
    "Optional receiving note": "Optional receiving note",
    "inventory.operations.placeholder.transfer_reference": "Transfer reference",
    "Transfer reference": "Transfer reference",
    "inventory.operations.placeholder.request_reference": "Request reference",
    "Request reference": "Request reference",
    "inventory.operations.placeholder.context": "Optional context",
    "Optional context": "Optional context",
    "inventory.operations.create.transfer_title": "New transfer order",
    "New transfer order": "New transfer order",
    "inventory.operations.create.requisition_title": "New requisition",
    "inventory.operations.create.receipt_title": "New goods receipt",
    "New goods receipt": "New goods receipt",
    "inventory.operations.create.transfer_description": "Move stock between two locations.",
    "Move stock between two locations.": "Move stock between two locations.",
    "inventory.operations.create.requisition_description": "Request stock from another location.",
    "Request stock from another location.": "Request stock from another location.",
    "inventory.operations.create.receipt_description": "Create a receipt before scanning or adding boxes.",
    "Create a receipt before scanning or adding boxes.": "Create a receipt before scanning or adding boxes.",
    "inventory.operations.toast.transfer_created": "Transfer order created",
    "Transfer order created": "Transfer order created",
    "inventory.operations.toast.requisition_created": "Requisition created",
    "Requisition created": "Requisition created",
    "inventory.operations.toast.receipt_created": "Goods receipt created",
    "Goods receipt created": "Goods receipt created",
    "inventory.operations.toast.transfer_dispatched": "Transfer dispatched",
    "Transfer dispatched": "Transfer dispatched",
    "inventory.operations.toast.transfer_received": "Transfer received",
    "Transfer received": "Transfer received",
    "inventory.operations.toast.transfer_cancelled": "Transfer cancelled",
    "Transfer cancelled": "Transfer cancelled",
    "inventory.operations.toast.requisition_approved": "Requisition approved",
    "Requisition approved": "Requisition approved",
    "inventory.operations.toast.requisition_rejected": "Requisition rejected",
    "Requisition rejected": "Requisition rejected",
    "inventory.operations.action.dispatch": "Dispatch",
    "Dispatch": "Dispatch",
    "inventory.operations.action.receive": "Receive",
    "Receive": "Receive",
    "inventory.operations.action.approve": "Approve",
    "Approve": "Approve",
    "inventory.operations.action.reject": "Reject",
    "Reject": "Reject",
    "inventory.operations.column.when": "When",
    "When": "When",
    "inventory.operations.column.event": "Event",
    "inventory.operations.column.change": "Change",
    "inventory.operations.column.after": "After",
    "After": "After",
    "inventory.operations.column.order": "Order",
    "Order": "Order",
    "inventory.operations.column.route": "Route",
    "Route": "Route",
    "inventory.operations.column.lines": "Lines",
    "Lines": "Lines",
    "inventory.operations.column.expected": "Expected",
    "Expected": "Expected",
    "inventory.operations.column.request": "Request",
    "Request": "Request",
    "inventory.operations.column.request_supply": "Request / supply",
    "Request / supply": "Request / supply",
    "inventory.operations.column.created": "Created",
    "inventory.operations.column.receipt": "Receipt",
    "Receipt": "Receipt",
    "inventory.operations.empty.movements": "No stock movements recorded yet.",
    "No stock movements recorded yet.": "No stock movements recorded yet.",
    "inventory.operations.empty.batches": "No inventory batches have been recorded yet.",
    "No inventory batches have been recorded yet.": "No inventory batches have been recorded yet.",
    "inventory.operations.empty.transfers": "No transfer orders yet.",
    "No transfer orders yet.": "No transfer orders yet.",
    "inventory.operations.empty.requisitions": "No requisitions yet.",
    "No requisitions yet.": "No requisitions yet.",
    "inventory.operations.empty.receipts": "No goods receipts yet.",
    "No goods receipts yet.": "No goods receipts yet.",
    "inventory.operations.batch.edit_title": "Edit batch",
    "Edit batch": "Edit batch",
    "inventory.operations.batch.edit_description": "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.",
    "inventory.operations.batch.save": "Save batch",
    "Save batch": "Save batch",
    "inventory.operations.batch.lot_number": "Lot number",
    "Lot number": "Lot number",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Expiry date",
    "inventory.operations.batch.condition": "Condition",
    "Condition": "Condition",
    "inventory.operations.batch.condition_placeholder": "good",
    "good": "good",
    "inventory.operations.batch.unit": "Unit of measure",
    "Unit of measure": "Unit of measure",
    "inventory.operations.batch.unit_placeholder": "box, piece, kg",
    "box, piece, kg": "box, piece, kg",
    "inventory.operations.batch.no_expiry": "No expiry",
    "No expiry": "No expiry",
    "inventory.operations.batch.updated": "Batch updated",
    "Batch updated": "Batch updated",
    "common.status.in_transit": "In transit",
    "In transit": "In transit",
    "common.status.pending": "Pending",
    "Pending": "Pending",
    "common.status.approved": "Approved",
    "Approved": "Approved",
    "common.status.rejected": "Rejected",
    "Rejected": "Rejected",
    "common.status.cancelled": "Cancelled",
    "Cancelled": "Cancelled",
    "common.status.received": "Received",
    "Received": "Received",
    "common.status.sent": "Sent",
    "Sent": "Sent",
    "common.note": "Note",
    "common.optional": "Optional",
    "Optional": "Optional",
    "common.error.generic": "Something went wrong.",
    "Something went wrong.": "Something went wrong.",
    "purchase_orders.title": "Purchase orders",
    "purchase_orders.title_singular": "Purchase order",
    "purchase_orders.tab.all": "All",
    "purchase_orders.tab.partial": "Partially received",
    "Partially received": "Partially received",
    "purchase_orders.create.new": "New purchase order",
    "New purchase order": "New purchase order",
    "purchase_orders.create.title": "New purchase order",
    "purchase_orders.create.subtitle": "Saved as a draft. Mark it as sent once it’s with the supplier.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Saved as a draft. Mark it as sent once it’s with the supplier.",
    "purchase_orders.create.submit": "Create draft",
    "Create draft": "Create draft",
    "purchase_orders.field.location": "Receiving location",
    "purchase_orders.field.supplier": "Supplier",
    "Supplier": "Supplier",
    "purchase_orders.field.reference": "Supplier reference",
    "Supplier reference": "Supplier reference",
    "purchase_orders.field.expected_delivery": "Expected delivery",
    "Expected delivery": "Expected delivery",
    "purchase_orders.field.products": "Products",
    "Products": "Products",
    "purchase_orders.select_location": "Select location",
    "Select location": "Select location",
    "purchase_orders.no_locations": "No locations set up",
    "No locations set up": "No locations set up",
    "purchase_orders.add_location": "Add a location first →",
    "Add a location first →": "Add a location first →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "All locations",
    "All locations": "All locations",
    "purchase_orders.location_number": "Location #{id}",
    "purchase_orders.search_products": "Search products to add",
    "Search products to add": "Search products to add",
    "purchase_orders.in_stock": "In stock: {count}",
    "In stock: {count}": "In stock: {count}",
    "purchase_orders.column.order": "Order",
    "purchase_orders.column.product": "Product",
    "purchase_orders.column.quantity": "Quantity",
    "purchase_orders.column.ordered": "Ordered",
    "Ordered": "Ordered",
    "purchase_orders.column.received": "Received",
    "purchase_orders.column.remaining": "Remaining",
    "Remaining": "Remaining",
    "purchase_orders.column.unit_cost": "Unit cost",
    "Unit cost": "Unit cost",
    "purchase_orders.column.supplier": "Supplier",
    "purchase_orders.column.location": "Location",
    "purchase_orders.column.progress": "Received",
    "purchase_orders.column.value": "Value",
    "purchase_orders.column.expected": "Expected",
    "purchase_orders.column.status": "Status",
    "purchase_orders.action.mark_sent": "Mark as sent",
    "Mark as sent": "Mark as sent",
    "purchase_orders.action.receive": "Receive",
    "purchase_orders.action.receive_stock": "Receive stock",
    "Receive stock": "Receive stock",
    "purchase_orders.action.cancel_order": "Cancel order",
    "Cancel order": "Cancel order",
    "purchase_orders.action.close_order": "Close order",
    "Close order": "Close order",
    "purchase_orders.receive.subtitle": "Enter what arrived. Stock at the receiving location updates on confirm.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Enter what arrived. Stock at the receiving location updates on confirm.",
    "purchase_orders.receive.now": "Receive now",
    "Receive now": "Receive now",
    "purchase_orders.receive.confirm": "Confirm receipt",
    "Confirm receipt": "Confirm receipt",
    "purchase_orders.confirm.cancel": "Cancel this purchase order?",
    "Cancel this purchase order?": "Cancel this purchase order?",
    "purchase_orders.empty.all": "No purchase orders yet. Create one to restock inventory.",
    "No purchase orders yet. Create one to restock inventory.": "No purchase orders yet. Create one to restock inventory.",
    "purchase_orders.empty.filtered": "No purchase orders with this status.",
    "No purchase orders with this status.": "No purchase orders with this status.",
    "purchase_orders.error.location_required": "Choose a receiving location.",
    "Choose a receiving location.": "Choose a receiving location.",
    "purchase_orders.error.product_required": "Add at least one product.",
    "Add at least one product.": "Add at least one product.",
    "purchase_orders.error.quantity_positive": "Every quantity must be greater than 0.",
    "Every quantity must be greater than 0.": "Every quantity must be greater than 0.",
    "purchase_orders.error.receive_quantity": "Enter a quantity for at least one item.",
    "Enter a quantity for at least one item.": "Enter a quantity for at least one item.",
    "purchase_orders.toast.created": "Purchase order created as draft",
    "Purchase order created as draft": "Purchase order created as draft",
    "purchase_orders.toast.sent": "Marked as sent",
    "Marked as sent": "Marked as sent",
    "purchase_orders.toast.received": "Stock received and inventory updated",
    "Stock received and inventory updated": "Stock received and inventory updated",
    "purchase_orders.toast.cancelled": "Purchase order cancelled",
    "Purchase order cancelled": "Purchase order cancelled",
    "purchase_orders.toast.closed": "Purchase order closed",
    "Purchase order closed": "Purchase order closed",
    "schedule.title": "Schedule",
    "schedule.view.month": "Month",
    "Month": "Month",
    "schedule.view.week": "Week",
    "Week": "Week",
    "schedule.view.day": "Day",
    "Day": "Day",
    "schedule.today": "Today",
    "Today": "Today",
    "schedule.order_number": "Order #{number}",
    "Order #{number}": "Order #{number}",
    "schedule.customer": "Customer",
    "schedule.more_events": "+{count} more",
    "+{count} more": "+{count} more",
    "schedule.payment.paid": "Paid",
    "schedule.payment.pending": "Pending",
    "schedule.payment.failed": "Failed",
    "schedule.booking_details": "Booking details",
    "Booking details": "Booking details",
    "schedule.order_reference": "Order reference",
    "schedule.amount": "Amount",
    "schedule.start": "Start",
    "schedule.end": "End",
    "schedule.item_number": "Item {number}",
    "Item {number}": "Item {number}",
    "schedule.view_order": "View full order",
    "View full order": "View full order",
    "onboarding.greeting.morning": "Good morning",
    "Good morning": "Good morning",
    "onboarding.greeting.morning_named": "Good morning {name}",
    "Good morning {name}": "Good morning {name}",
    "onboarding.greeting.afternoon": "Good afternoon",
    "Good afternoon": "Good afternoon",
    "onboarding.greeting.afternoon_named": "Good afternoon {name}",
    "Good afternoon {name}": "Good afternoon {name}",
    "onboarding.greeting.evening": "Good evening",
    "Good evening": "Good evening",
    "onboarding.greeting.evening_named": "Good evening {name}",
    "Good evening {name}": "Good evening {name}",
    "onboarding.greeting.night": "Hello",
    "Hello": "Hello",
    "onboarding.greeting.night_named": "Hello {name}",
    "Hello {name}": "Hello {name}",
    "onboarding.encouragement": "Build the platform you wish existed.",
    "Build the platform you wish existed.": "Build the platform you wish existed.",
    "onboarding.plan.personalized": "Personalized launch plan",
    "Personalized launch plan": "Personalized launch plan",
    "onboarding.plan.label": "Launch plan",
    "Launch plan": "Launch plan",
    "onboarding.plan.refining": "Refining your path…",
    "Refining your path…": "Refining your path…",
    "onboarding.plan.getting_ready": "Your personalized plan is getting ready.",
    "Your personalized plan is getting ready.": "Your personalized plan is getting ready.",
    "onboarding.checklist.preview": "Checklist preview",
    "Checklist preview": "Checklist preview",
    "onboarding.workspace.live": "Live workspace",
    "Live workspace": "Live workspace",
    "onboarding.workspace.no_tenant": "No live tenant connected",
    "No live tenant connected": "No live tenant connected",
    "onboarding.workspace.domain_pending": "Domain pending",
    "Domain pending": "Domain pending",
    "onboarding.progress.summary": "{completed} of {total} launch actions done",
    "{completed} of {total} launch actions done": "{completed} of {total} launch actions done",
    "onboarding.progress.auto_detected": "{count} auto-detected",
    "{count} auto-detected": "{count} auto-detected",
    "onboarding.progress.auto_detected_short": "Auto-detected",
    "Auto-detected": "Auto-detected",
    "onboarding.progress.saving": "Saving progress…",
    "Saving progress…": "Saving progress…",
    "onboarding.progress.checking": "Checking…",
    "Checking…": "Checking…",
    "onboarding.progress.mark_done": "Mark done",
    "Mark done": "Mark done",
    "onboarding.progress.unlocked": "Unlocked: {impact}",
    "Unlocked: {impact}": "Unlocked: {impact}",
    "onboarding.next_task": "Next best task",
    "Next best task": "Next best task",
    "onboarding.upcoming.title": "Upcoming tasks",
    "Upcoming tasks": "Upcoming tasks",
    "onboarding.upcoming.summary_one": "{count} task queued after the current action.",
    "{count} task queued after the current action.": "{count} task queued after the current action.",
    "onboarding.upcoming.summary_other": "{count} tasks queued after the current action.",
    "{count} tasks queued after the current action.": "{count} tasks queued after the current action.",
    "onboarding.upcoming.hide": "Hide tasks",
    "Hide tasks": "Hide tasks",
    "onboarding.upcoming.view_all": "View all tasks",
    "View all tasks": "View all tasks",
    "onboarding.complete.title": "Great start. Your foundation is live.",
    "Great start. Your foundation is live.": "Great start. Your foundation is live.",
    "onboarding.complete.description": "Keep going to unlock growth essentials like promotions and communications.",
    "Keep going to unlock growth essentials like promotions and communications.": "Keep going to unlock growth essentials like promotions and communications.",
    "onboarding.full_checklist.title": "Full checklist",
    "Full checklist": "Full checklist",
    "onboarding.full_checklist.description": "Continue setup in the same experience.",
    "Continue setup in the same experience.": "Continue setup in the same experience.",
    "onboarding.full_checklist.back": "Back to launch path",
    "Back to launch path": "Back to launch path",
    "onboarding.completed.title": "Completed",
    "onboarding.completed.summary_one": "{count} task completed",
    "{count} task completed": "{count} task completed",
    "onboarding.completed.summary_other": "{count} tasks completed",
    "{count} tasks completed": "{count} tasks completed",
    "onboarding.completed.open_again": "Open again",
    "Open again": "Open again",
    "onboarding.plan.marketplace.eyebrow": "Marketplace launch path",
    "Marketplace launch path": "Marketplace launch path",
    "onboarding.plan.marketplace.title": "Launch your marketplace",
    "Launch your marketplace": "Launch your marketplace",
    "onboarding.plan.marketplace.title_named": "Turn {project} into a working marketplace",
    "Turn {project} into a working marketplace": "Turn {project} into a working marketplace",
    "onboarding.plan.marketplace.subtitle": "Open the live site create the first listing and test the buyer journey.",
    "Open the live site create the first listing and test the buyer journey.": "Open the live site create the first listing and test the buyer journey.",
    "onboarding.plan.marketplace.value_moment": "First value moment: a seller can publish and a buyer can act.",
    "First value moment: a seller can publish and a buyer can act.": "First value moment: a seller can publish and a buyer can act.",
    "onboarding.plan.marketplace.why_title": "Why teams finish this",
    "Why teams finish this": "Why teams finish this",
    "onboarding.plan.marketplace.why_body": "Real buyer and seller outcomes make every next step useful and keep momentum.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Real buyer and seller outcomes make every next step useful and keep momentum.",
    "onboarding.plan.store.eyebrow": "Store launch path",
    "Store launch path": "Store launch path",
    "onboarding.plan.store.title": "Get your store ready for the first order",
    "Get your store ready for the first order": "Get your store ready for the first order",
    "onboarding.plan.store.title_named": "Make {project} ready for the first order",
    "Make {project} ready for the first order": "Make {project} ready for the first order",
    "onboarding.plan.store.subtitle": "Add a product check the storefront and complete checkout essentials.",
    "Add a product check the storefront and complete checkout essentials.": "Add a product check the storefront and complete checkout essentials.",
    "onboarding.plan.store.value_moment": "First value moment: a product is visible and checkout can be tested.",
    "First value moment: a product is visible and checkout can be tested.": "First value moment: a product is visible and checkout can be tested.",
    "onboarding.plan.store.why_title": "Why teams finish this",
    "onboarding.plan.store.why_body": "Move from product to checkout quickly so the store feels real and progress stays motivating.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Move from product to checkout quickly so the store feels real and progress stays motivating.",
    "onboarding.plan.booking.eyebrow": "Booking launch path",
    "Booking launch path": "Booking launch path",
    "onboarding.plan.booking.title": "Make your platform bookable",
    "Make your platform bookable": "Make your platform bookable",
    "onboarding.plan.booking.title_named": "Make {project} bookable",
    "Make {project} bookable": "Make {project} bookable",
    "onboarding.plan.booking.subtitle": "Create the first service open the customer experience and test a reservation.",
    "Create the first service open the customer experience and test a reservation.": "Create the first service open the customer experience and test a reservation.",
    "onboarding.plan.booking.value_moment": "First value moment: a customer can request a time or slot.",
    "First value moment: a customer can request a time or slot.": "First value moment: a customer can request a time or slot.",
    "onboarding.plan.booking.why_title": "Why teams finish this",
    "onboarding.plan.booking.why_body": "Validate the full booking journey early to build confidence before expanding.",
    "Validate the full booking journey early to build confidence before expanding.": "Validate the full booking journey early to build confidence before expanding.",
    "onboarding.plan.digital.eyebrow": "Digital launch path",
    "Digital launch path": "Digital launch path",
    "onboarding.plan.digital.title": "Start selling your digital products",
    "Start selling your digital products": "Start selling your digital products",
    "onboarding.plan.digital.title_named": "Make {project} ready to sell digital products",
    "Make {project} ready to sell digital products": "Make {project} ready to sell digital products",
    "onboarding.plan.digital.subtitle": "Upload a digital product preview the customer flow and confirm payment readiness.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Upload a digital product preview the customer flow and confirm payment readiness.",
    "onboarding.plan.digital.value_moment": "First value moment: a buyer can discover and purchase a file.",
    "First value moment: a buyer can discover and purchase a file.": "First value moment: a buyer can discover and purchase a file.",
    "onboarding.plan.digital.why_title": "Why teams finish this",
    "onboarding.plan.digital.why_body": "Prove discovery and purchase quickly so expanding the catalog feels like growth.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Prove discovery and purchase quickly so expanding the catalog feels like growth.",
    "onboarding.plan.campaign.eyebrow": "Campaign launch path",
    "Campaign launch path": "Campaign launch path",
    "onboarding.plan.campaign.title": "Launch your campaign platform",
    "Launch your campaign platform": "Launch your campaign platform",
    "onboarding.plan.campaign.title_named": "Make {project} ready for supporters",
    "Make {project} ready for supporters": "Make {project} ready for supporters",
    "onboarding.plan.campaign.subtitle": "Create a campaign preview the public page and test the contribution journey.",
    "Create a campaign preview the public page and test the contribution journey.": "Create a campaign preview the public page and test the contribution journey.",
    "onboarding.plan.campaign.value_moment": "First value moment: a supporter can understand and contribute.",
    "First value moment: a supporter can understand and contribute.": "First value moment: a supporter can understand and contribute.",
    "onboarding.plan.campaign.why_title": "Why teams finish this",
    "onboarding.plan.campaign.why_body": "Clarify the story and contribution flow early so supporters can trust and act.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Clarify the story and contribution flow early so supporters can trust and act.",
    "onboarding.plan.creator.eyebrow": "Creator launch path",
    "Creator launch path": "Creator launch path",
    "onboarding.plan.creator.title": "Get ready for your first audience",
    "Get ready for your first audience": "Get ready for your first audience",
    "onboarding.plan.creator.title_named": "Make {project} ready for its first audience",
    "Make {project} ready for its first audience": "Make {project} ready for its first audience",
    "onboarding.plan.creator.subtitle": "Publish one clear offer shape the experience and make it easy to discover and support your work.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Publish one clear offer shape the experience and make it easy to discover and support your work.",
    "onboarding.plan.creator.value_moment": "First value moment: your work is visible and ready to share.",
    "First value moment: your work is visible and ready to share.": "First value moment: your work is visible and ready to share.",
    "onboarding.plan.creator.why_title": "Why this works",
    "Why this works": "Why this works",
    "onboarding.plan.creator.why_body": "Focus on publishing something real before adding more tools or complexity.",
    "Focus on publishing something real before adding more tools or complexity.": "Focus on publishing something real before adding more tools or complexity.",
    "onboarding.step.open_live_site.title": "Open the live experience",
    "Open the live experience": "Open the live experience",
    "onboarding.step.open_live_site.description": "Start with what customers see. This makes the product feel real before setup becomes abstract.",
    "Start with what customers see. This makes the product feel real before setup becomes abstract.": "Start with what customers see. This makes the product feel real before setup becomes abstract.",
    "onboarding.step.open_live_site.description_domain": "Open {domain} and see what your customers see. This makes the build feel real before the next step.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Open {domain} and see what your customers see. This makes the build feel real before the next step.",
    "onboarding.step.open_live_site.cta": "Open site",
    "Open site": "Open site",
    "onboarding.step.open_live_site.cta_domain": "Open {domain}",
    "Open {domain}": "Open {domain}",
    "onboarding.step.open_live_site.impact": "Confirms the project is already live.",
    "Confirms the project is already live.": "Confirms the project is already live.",
    "onboarding.step.create_supply_shape.title": "Create the first category",
    "Create the first category": "Create the first category",
    "onboarding.step.create_supply_shape.description": "Give sellers and buyers a clear place to start. Categories create structure for discovery.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Give sellers and buyers a clear place to start. Categories create structure for discovery.",
    "onboarding.step.create_supply_shape.cta": "Add category",
    "Add category": "Add category",
    "onboarding.step.create_supply_shape.impact": "Turns a blank marketplace into a browsable one.",
    "Turns a blank marketplace into a browsable one.": "Turns a blank marketplace into a browsable one.",
    "onboarding.step.post_first_listing.title": "Post one test listing",
    "Post one test listing": "Post one test listing",
    "onboarding.step.post_first_listing.description": "Experience the seller path and publish the first item buyers can inspect.",
    "Experience the seller path and publish the first item buyers can inspect.": "Experience the seller path and publish the first item buyers can inspect.",
    "onboarding.step.post_first_listing.cta": "Post listing",
    "Post listing": "Post listing",
    "onboarding.step.post_first_listing.impact": "Creates supply the core marketplace activation event.",
    "Creates supply the core marketplace activation event.": "Creates supply the core marketplace activation event.",
    "onboarding.step.test_buyer_action.title": "Act like a buyer",
    "Act like a buyer": "Act like a buyer",
    "onboarding.step.test_buyer_action.description": "Browse add interest and test the order path to experience what customers will see.",
    "Browse add interest and test the order path to experience what customers will see.": "Browse add interest and test the order path to experience what customers will see.",
    "onboarding.step.test_buyer_action.cta": "Test buyer flow",
    "Test buyer flow": "Test buyer flow",
    "onboarding.step.test_buyer_action.impact": "Validates the buyer journey end to end.",
    "Validates the buyer journey end to end.": "Validates the buyer journey end to end.",
    "onboarding.step.add_first_product.title": "Add one real product",
    "Add one real product": "Add one real product",
    "onboarding.step.add_first_product.description": "One complete product teaches the system your catalog shape better than a long settings tour.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "One complete product teaches the system your catalog shape better than a long settings tour.",
    "onboarding.step.add_first_product.cta": "Add product",
    "Add product": "Add product",
    "onboarding.step.add_first_product.impact": "Creates the first sellable item.",
    "Creates the first sellable item.": "Creates the first sellable item.",
    "onboarding.step.setup_payments.title": "Connect payments",
    "Connect payments": "Connect payments",
    "onboarding.step.setup_payments.description": "Enable real transactions so users can complete purchases without friction.",
    "Enable real transactions so users can complete purchases without friction.": "Enable real transactions so users can complete purchases without friction.",
    "onboarding.step.setup_payments.cta": "Set up payments",
    "Set up payments": "Set up payments",
    "onboarding.step.setup_payments.impact": "Unlocks the path to revenue.",
    "Unlocks the path to revenue.": "Unlocks the path to revenue.",
    "onboarding.step.setup_delivery.title": "Set shipping or service method",
    "Set shipping or service method": "Set shipping or service method",
    "onboarding.step.setup_delivery.description": "Define how the order is fulfilled so checkout is predictable for users.",
    "Define how the order is fulfilled so checkout is predictable for users.": "Define how the order is fulfilled so checkout is predictable for users.",
    "onboarding.step.setup_delivery.cta": "Configure delivery",
    "Configure delivery": "Configure delivery",
    "onboarding.step.setup_delivery.impact": "Makes fulfillment clear at checkout.",
    "Makes fulfillment clear at checkout.": "Makes fulfillment clear at checkout.",
    "onboarding.step.create_bookable_listing.title": "Create one bookable offer",
    "Create one bookable offer": "Create one bookable offer",
    "onboarding.step.create_bookable_listing.description": "Add the service event rental or appointment customers should book first.",
    "Add the service event rental or appointment customers should book first.": "Add the service event rental or appointment customers should book first.",
    "onboarding.step.create_bookable_listing.cta": "Create offer",
    "Create offer": "Create offer",
    "onboarding.step.create_bookable_listing.impact": "Creates the first bookable unit.",
    "Creates the first bookable unit.": "Creates the first bookable unit.",
    "onboarding.step.shape_details.title": "Add booking details",
    "Add booking details": "Add booking details",
    "onboarding.step.shape_details.description": "Use categories and fields to capture what customers need before they commit.",
    "Use categories and fields to capture what customers need before they commit.": "Use categories and fields to capture what customers need before they commit.",
    "onboarding.step.shape_details.cta": "Set up fields",
    "Set up fields": "Set up fields",
    "onboarding.step.shape_details.impact": "Makes the offer easier to compare and trust.",
    "Makes the offer easier to compare and trust.": "Makes the offer easier to compare and trust.",
    "onboarding.step.test_booking.title": "Test the customer path",
    "Test the customer path": "Test the customer path",
    "onboarding.step.test_booking.description": "Open the public flow and verify customers can move from interest to action.",
    "Open the public flow and verify customers can move from interest to action.": "Open the public flow and verify customers can move from interest to action.",
    "onboarding.step.test_booking.cta": "Test booking",
    "Test booking": "Test booking",
    "onboarding.step.test_booking.impact": "Validates the booking journey.",
    "Validates the booking journey.": "Validates the booking journey.",
    "onboarding.step.upload_digital_product.title": "Upload one digital product",
    "Upload one digital product": "Upload one digital product",
    "onboarding.step.upload_digital_product.description": "Make the first downloadable item complete enough to preview and sell.",
    "Make the first downloadable item complete enough to preview and sell.": "Make the first downloadable item complete enough to preview and sell.",
    "onboarding.step.upload_digital_product.cta": "Add digital product",
    "Add digital product": "Add digital product",
    "onboarding.step.upload_digital_product.impact": "Creates your first sellable digital asset.",
    "Creates your first sellable digital asset.": "Creates your first sellable digital asset.",
    "onboarding.step.test_purchase.title": "Test purchase flow",
    "Test purchase flow": "Test purchase flow",
    "onboarding.step.test_purchase.description": "Preview what buyers see from discovery through checkout.",
    "Preview what buyers see from discovery through checkout.": "Preview what buyers see from discovery through checkout.",
    "onboarding.step.test_purchase.cta": "Test checkout",
    "Test checkout": "Test checkout",
    "onboarding.step.test_purchase.impact": "Confirms the buyer journey.",
    "Confirms the buyer journey.": "Confirms the buyer journey.",
    "onboarding.step.create_campaign.title": "Create the first campaign",
    "Create the first campaign": "Create the first campaign",
    "onboarding.step.create_campaign.description": "Add the campaign or cause page supporters should understand first.",
    "Add the campaign or cause page supporters should understand first.": "Add the campaign or cause page supporters should understand first.",
    "onboarding.step.create_campaign.cta": "Create campaign",
    "Create campaign": "Create campaign",
    "onboarding.step.create_campaign.impact": "Creates the first public reason to act.",
    "Creates the first public reason to act.": "Creates the first public reason to act.",
    "onboarding.step.setup_payments_campaign.title": "Connect contribution payments",
    "Connect contribution payments": "Connect contribution payments",
    "onboarding.step.setup_payments_campaign.description": "Supporter intent matters when they can complete a contribution.",
    "Supporter intent matters when they can complete a contribution.": "Supporter intent matters when they can complete a contribution.",
    "onboarding.step.setup_payments_campaign.cta": "Set up payments",
    "onboarding.step.setup_payments_campaign.impact": "Enables real contributions.",
    "Enables real contributions.": "Enables real contributions.",
    "onboarding.step.test_supporter_flow.title": "Test supporter flow",
    "Test supporter flow": "Test supporter flow",
    "onboarding.step.test_supporter_flow.description": "Open the public journey and make sure the story and action are clear.",
    "Open the public journey and make sure the story and action are clear.": "Open the public journey and make sure the story and action are clear.",
    "onboarding.step.test_supporter_flow.cta": "Test flow",
    "Test flow": "Test flow",
    "onboarding.step.test_supporter_flow.impact": "Validates the public path.",
    "Validates the public path.": "Validates the public path.",
    "onboarding.step.set_account_categories.title": "Define supplier account categories",
    "Define supplier account categories": "Define supplier account categories",
    "onboarding.step.set_account_categories.description": "Separate supplier profiles by type to improve trust and buyer navigation.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Separate supplier profiles by type to improve trust and buyer navigation.",
    "onboarding.step.set_account_categories.cta": "Account categories",
    "Account categories": "Account categories",
    "onboarding.step.set_account_categories.impact": "Supplier structure established.",
    "Supplier structure established.": "Supplier structure established.",
    "onboarding.step.set_account_attributes.title": "Add supplier profile attributes",
    "Add supplier profile attributes": "Add supplier profile attributes",
    "onboarding.step.set_account_attributes.description": "Capture details buyers need before contacting or ordering from suppliers.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Capture details buyers need before contacting or ordering from suppliers.",
    "onboarding.step.set_account_attributes.cta": "Supplier attributes",
    "Supplier attributes": "Supplier attributes",
    "onboarding.step.set_account_attributes.impact": "Higher buyer confidence.",
    "Higher buyer confidence.": "Higher buyer confidence.",
    "onboarding.step.add_promotion.title": "Add a launch promotion",
    "Add a launch promotion": "Add a launch promotion",
    "onboarding.step.add_promotion.description": "Create your first promotion to encourage action during the first visit.",
    "Create your first promotion to encourage action during the first visit.": "Create your first promotion to encourage action during the first visit.",
    "onboarding.step.add_promotion.cta": "Add promotion",
    "Add promotion": "Add promotion",
    "onboarding.step.add_promotion.impact": "Strengthens launch conversion.",
    "Strengthens launch conversion.": "Strengthens launch conversion.",
    "onboarding.step.create_coupon.title": "Create your first coupon",
    "Create your first coupon": "Create your first coupon",
    "onboarding.step.create_coupon.description": "Test discounts for first-time buyers or members.",
    "Test discounts for first-time buyers or members.": "Test discounts for first-time buyers or members.",
    "onboarding.step.create_coupon.cta": "Create coupon",
    "Create coupon": "Create coupon",
    "onboarding.step.create_coupon.impact": "Unlocks your first offer loop.",
    "Unlocks your first offer loop.": "Unlocks your first offer loop.",
    "onboarding.step.collections_setup.title": "Create a collection",
    "Create a collection": "Create a collection",
    "onboarding.step.collections_setup.description": "Organize important listings to improve discovery and browsing.",
    "Organize important listings to improve discovery and browsing.": "Organize important listings to improve discovery and browsing.",
    "onboarding.step.collections_setup.cta": "Create collection",
    "Create collection": "Create collection",
    "onboarding.step.collections_setup.impact": "Improves navigation and discovery.",
    "Improves navigation and discovery.": "Improves navigation and discovery.",
    "onboarding.step.configure_comms.title": "Review communication templates",
    "Review communication templates": "Review communication templates",
    "onboarding.step.configure_comms.description": "Prepare signup and order notifications before growth.",
    "Prepare signup and order notifications before growth.": "Prepare signup and order notifications before growth.",
    "onboarding.step.configure_comms.cta": "Open communications",
    "Open communications": "Open communications",
    "onboarding.step.configure_comms.impact": "Prepares customer communications.",
    "Prepares customer communications.": "Prepares customer communications.",
    "onboarding.step.customize_attributes.title": "Add listing attributes",
    "Add listing attributes": "Add listing attributes",
    "onboarding.step.customize_attributes.description": "Add structured fields so users can filter and compare what matters.",
    "Add structured fields so users can filter and compare what matters.": "Add structured fields so users can filter and compare what matters.",
    "onboarding.step.customize_attributes.cta": "Add attributes",
    "Add attributes": "Add attributes",
    "onboarding.step.customize_attributes.impact": "Makes listings easier to compare.",
    "Makes listings easier to compare.": "Makes listings easier to compare.",
    "onboarding.step.add_digital_asset.title": "Add another digital item",
    "Add another digital item": "Add another digital item",
    "onboarding.step.add_digital_asset.description": "Expand the catalog so users can evaluate quality and assortment.",
    "Expand the catalog so users can evaluate quality and assortment.": "Expand the catalog so users can evaluate quality and assortment.",
    "onboarding.step.add_digital_asset.cta": "Add digital listing",
    "Add digital listing": "Add digital listing",
    "onboarding.step.add_digital_asset.impact": "Improves digital catalog credibility.",
    "Improves digital catalog credibility.": "Improves digital catalog credibility.",
    "personal_assistant.title": "Personal assistant",
    "Personal assistant": "Personal assistant",
    "personal_assistant.heading": "Grow your platform one step at a time",
    "Grow your platform one step at a time": "Grow your platform one step at a time",
    "personal_assistant.subtitle": "Built for {launchType}. We prioritize actions by impact and readiness.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Built for {launchType}. We prioritize actions by impact and readiness.",
    "personal_assistant.launch.store": "a store",
    "a store": "a store",
    "personal_assistant.launch.marketplace": "a marketplace",
    "a marketplace": "a marketplace",
    "personal_assistant.launch.booking": "a booking platform",
    "a booking platform": "a booking platform",
    "personal_assistant.launch.digital": "a digital business",
    "a digital business": "a digital business",
    "personal_assistant.launch.campaign": "a campaign platform",
    "a campaign platform": "a campaign platform",
    "personal_assistant.metric.tasks_completed": "Tasks completed",
    "Tasks completed": "Tasks completed",
    "personal_assistant.metric.recommendation_clicks": "Recommendation clicks",
    "Recommendation clicks": "Recommendation clicks",
    "personal_assistant.metric.completed_by_recommendation": "Completed via recommendations",
    "Completed via recommendations": "Completed via recommendations",
    "personal_assistant.metric.assist_rate": "Assist rate",
    "Assist rate": "Assist rate",
    "personal_assistant.personalizing": "Personalizing your recommendations…",
    "Personalizing your recommendations…": "Personalizing your recommendations…",
    "personal_assistant.do_this_now": "Do this now",
    "Do this now": "Do this now",
    "personal_assistant.estimated_time": "Estimated time: {minutes} min",
    "Estimated time: {minutes} min": "Estimated time: {minutes} min",
    "personal_assistant.minutes_short": "{minutes} min",
    "{minutes} min": "{minutes} min",
    "personal_assistant.open": "Open",
    "personal_assistant.mark_done": "Mark done",
    "personal_assistant.up_next": "Up next",
    "Up next": "Up next",
    "personal_assistant.coming_after": "Coming after this",
    "Coming after this": "Coming after this",
    "personal_assistant.completed_count": "Completed ({count})",
    "Completed ({count})": "Completed ({count})",
    "personal_assistant.hide": "Hide",
    "Hide": "Hide",
    "personal_assistant.show": "Show",
    "Show": "Show",
    "personal_assistant.feature.open_live_site.name": "Open the live experience",
    "personal_assistant.feature.open_live_site.outcome": "You confirm customers can reach the live platform.",
    "You confirm customers can reach the live platform.": "You confirm customers can reach the live platform.",
    "personal_assistant.feature.create_supply_shape.name": "Create the first category",
    "personal_assistant.feature.create_supply_shape.outcome": "Customers can browse with a clear structure.",
    "Customers can browse with a clear structure.": "Customers can browse with a clear structure.",
    "personal_assistant.feature.post_first_listing.name": "Post one test listing",
    "personal_assistant.feature.post_first_listing.outcome": "The platform now has first supply to evaluate.",
    "The platform now has first supply to evaluate.": "The platform now has first supply to evaluate.",
    "personal_assistant.feature.test_buyer_action.name": "Act like a buyer",
    "personal_assistant.feature.test_buyer_action.outcome": "You validate buyer-side experience end to end.",
    "You validate buyer-side experience end to end.": "You validate buyer-side experience end to end.",
    "personal_assistant.feature.setup_payments.name": "Connect payments",
    "personal_assistant.feature.setup_payments.outcome": "Customers can complete real transactions.",
    "Customers can complete real transactions.": "Customers can complete real transactions.",
    "personal_assistant.feature.setup_delivery.name": "Set shipping or service method",
    "personal_assistant.feature.setup_delivery.outcome": "Customers can understand fulfillment clearly.",
    "Customers can understand fulfillment clearly.": "Customers can understand fulfillment clearly.",
    "personal_assistant.feature.add_promotion.name": "Add a launch promotion",
    "personal_assistant.feature.add_promotion.outcome": "You create an early conversion incentive.",
    "You create an early conversion incentive.": "You create an early conversion incentive.",
    "personal_assistant.feature.configure_comms.name": "Review communication templates",
    "personal_assistant.feature.configure_comms.outcome": "Users receive clear lifecycle communication.",
    "Users receive clear lifecycle communication.": "Users receive clear lifecycle communication.",
    "personal_assistant.feature.view_orders.name": "Open orders",
    "Open orders": "Open orders",
    "personal_assistant.feature.view_orders.outcome": "You can monitor and process incoming demand.",
    "You can monitor and process incoming demand.": "You can monitor and process incoming demand.",
    "personal_assistant.feature.view_accounts.name": "Open accounts",
    "Open accounts": "Open accounts",
    "personal_assistant.feature.view_accounts.outcome": "You can review suppliers or members efficiently.",
    "You can review suppliers or members efficiently.": "You can review suppliers or members efficiently.",
    "personal_assistant.feature.configure_account_categories.name": "Configure account categories",
    "Configure account categories": "Configure account categories",
    "personal_assistant.feature.configure_account_categories.outcome": "Supplier and member structure is clearer for onboarding and trust.",
    "Supplier and member structure is clearer for onboarding and trust.": "Supplier and member structure is clearer for onboarding and trust.",
    "personal_assistant.feature.configure_account_attributes.name": "Configure account attributes",
    "Configure account attributes": "Configure account attributes",
    "personal_assistant.feature.configure_account_attributes.outcome": "Profiles capture decision-critical info for buyers.",
    "Profiles capture decision-critical info for buyers.": "Profiles capture decision-critical info for buyers.",
    "personal_assistant.feature.review_account_config.name": "Review account configuration",
    "Review account configuration": "Review account configuration",
    "personal_assistant.feature.review_account_config.outcome": "Account behavior matches your marketplace policy.",
    "Account behavior matches your marketplace policy.": "Account behavior matches your marketplace policy.",
    "personal_assistant.feature.view_listings.name": "Open listings",
    "Open listings": "Open listings",
    "personal_assistant.feature.view_listings.outcome": "You can monitor catalog quality and readiness.",
    "You can monitor catalog quality and readiness.": "You can monitor catalog quality and readiness.",
    "personal_assistant.feature.configure_listing_categories.name": "Configure listing categories",
    "Configure listing categories": "Configure listing categories",
    "personal_assistant.feature.configure_listing_categories.outcome": "The catalog becomes easier to navigate and discover.",
    "The catalog becomes easier to navigate and discover.": "The catalog becomes easier to navigate and discover.",
    "personal_assistant.feature.configure_listing_attributes.name": "Configure listing attributes",
    "Configure listing attributes": "Configure listing attributes",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Users can compare listings with structured details.",
    "Users can compare listings with structured details.": "Users can compare listings with structured details.",
    "personal_assistant.feature.configure_variant_types.name": "Configure variant types",
    "Configure variant types": "Configure variant types",
    "personal_assistant.feature.configure_variant_types.outcome": "The catalog supports product and service variations clearly.",
    "The catalog supports product and service variations clearly.": "The catalog supports product and service variations clearly.",
    "personal_assistant.feature.review_listing_configs.name": "Review listing additional features",
    "Review listing additional features": "Review listing additional features",
    "personal_assistant.feature.review_listing_configs.outcome": "Listing behavior matches your operating model.",
    "Listing behavior matches your operating model.": "Listing behavior matches your operating model.",
    "personal_assistant.feature.manage_collections.name": "Manage collections",
    "Manage collections": "Manage collections",
    "personal_assistant.feature.manage_collections.outcome": "High-intent browsing paths are easier to discover.",
    "High-intent browsing paths are easier to discover.": "High-intent browsing paths are easier to discover.",
    "personal_assistant.feature.manage_coupons.name": "Manage coupons",
    "Manage coupons": "Manage coupons",
    "personal_assistant.feature.manage_coupons.outcome": "You can run targeted offers for activation.",
    "You can run targeted offers for activation.": "You can run targeted offers for activation.",
    "personal_assistant.feature.view_transactions.name": "View transactions",
    "View transactions": "View transactions",
    "personal_assistant.feature.view_transactions.outcome": "Payment activity can be monitored for trust and operations.",
    "Payment activity can be monitored for trust and operations.": "Payment activity can be monitored for trust and operations.",
    "personal_assistant.feature.view_users.name": "Open users",
    "Open users": "Open users",
    "personal_assistant.feature.view_users.outcome": "You can monitor customer and member growth quality.",
    "You can monitor customer and member growth quality.": "You can monitor customer and member growth quality.",
    "personal_assistant.feature.configure_user_attributes.name": "Configure user attributes",
    "Configure user attributes": "Configure user attributes",
    "personal_assistant.feature.configure_user_attributes.outcome": "You can capture profile signals to improve engagement.",
    "You can capture profile signals to improve engagement.": "You can capture profile signals to improve engagement.",
    "personal_assistant.feature.review_ratings.name": "Review ratings and reviews",
    "Review ratings and reviews": "Review ratings and reviews",
    "personal_assistant.feature.review_ratings.outcome": "Trust signals are monitored and improved.",
    "Trust signals are monitored and improved.": "Trust signals are monitored and improved.",
    "personal_assistant.feature.view_reports.name": "Open reports",
    "Open reports": "Open reports",
    "personal_assistant.feature.view_reports.outcome": "You can track performance with a data view.",
    "You can track performance with a data view.": "You can track performance with a data view.",
    "personal_assistant.feature.manage_media.name": "Manage media library",
    "Manage media library": "Manage media library",
    "personal_assistant.feature.manage_media.outcome": "Brand and listing visuals are easier to maintain.",
    "Brand and listing visuals are easier to maintain.": "Brand and listing visuals are easier to maintain.",
    "personal_assistant.feature.manage_reported_listings.name": "Review reported listings",
    "Review reported listings": "Review reported listings",
    "personal_assistant.feature.manage_reported_listings.outcome": "Risky or low-quality content can be handled quickly.",
    "Risky or low-quality content can be handled quickly.": "Risky or low-quality content can be handled quickly.",
    "personal_assistant.feature.app_customization.name": "Customize app experience",
    "Customize app experience": "Customize app experience",
    "personal_assistant.feature.app_customization.outcome": "The mobile app experience aligns with your brand.",
    "The mobile app experience aligns with your brand.": "The mobile app experience aligns with your brand.",
    "personal_assistant.feature.app_integrations.name": "Configure app integrations",
    "Configure app integrations": "Configure app integrations",
    "personal_assistant.feature.app_integrations.outcome": "Core platform services connect with app workflows.",
    "Core platform services connect with app workflows.": "Core platform services connect with app workflows.",
    "personal_assistant.feature.customize_strings.name": "Customize interface text",
    "Customize interface text": "Customize interface text",
    "personal_assistant.feature.customize_strings.outcome": "Product copy matches your audience and tone.",
    "Product copy matches your audience and tone.": "Product copy matches your audience and tone.",
    "personal_assistant.feature.review_settings_home.name": "Open settings",
    "Open settings": "Open settings",
    "personal_assistant.feature.review_settings_home.outcome": "Configuration is easy to find for team operations.",
    "Configuration is easy to find for team operations.": "Configuration is easy to find for team operations.",
    "personal_assistant.feature.configure_commission.name": "Configure commission",
    "Configure commission": "Configure commission",
    "personal_assistant.feature.configure_commission.outcome": "Revenue sharing aligns with your business model.",
    "Revenue sharing aligns with your business model.": "Revenue sharing aligns with your business model.",
    "personal_assistant.feature.configure_taxes.name": "Configure taxes",
    "Configure taxes": "Configure taxes",
    "personal_assistant.feature.configure_taxes.outcome": "Checkout pricing is predictable and tax settings are ready.",
    "Checkout pricing is predictable and tax settings are ready.": "Checkout pricing is predictable and tax settings are ready.",
    "personal_assistant.feature.configure_languages.name": "Configure languages",
    "Configure languages": "Configure languages",
    "personal_assistant.feature.configure_languages.outcome": "The experience supports a multilingual audience.",
    "The experience supports a multilingual audience.": "The experience supports a multilingual audience.",
    "personal_assistant.feature.configure_currency.name": "Configure currency",
    "Configure currency": "Configure currency",
    "personal_assistant.feature.configure_currency.outcome": "Prices align with the expectations of your target market.",
    "Prices align with the expectations of your target market.": "Prices align with the expectations of your target market.",
    "personal_assistant.feature.configure_countries.name": "Configure countries",
    "Configure countries": "Configure countries",
    "personal_assistant.feature.configure_countries.outcome": "Geographic coverage is controlled for launch.",
    "Geographic coverage is controlled for launch.": "Geographic coverage is controlled for launch.",
    "personal_assistant.feature.review_checkout_settings.name": "Review checkout settings",
    "Review checkout settings": "Review checkout settings",
    "personal_assistant.feature.review_checkout_settings.outcome": "Checkout is cleaner and more reliable.",
    "Checkout is cleaner and more reliable.": "Checkout is cleaner and more reliable.",
    "personal_assistant.feature.api_configuration.name": "Review API configuration",
    "Review API configuration": "Review API configuration",
    "personal_assistant.feature.api_configuration.outcome": "Integrations and developer access are ready.",
    "Integrations and developer access are ready.": "Integrations and developer access are ready.",
    "personal_assistant.feature.workspace_website_editor.name": "Open website editor",
    "Open website editor": "Open website editor",
    "personal_assistant.feature.workspace_website_editor.outcome": "The storefront can be refined for conversion.",
    "The storefront can be refined for conversion.": "The storefront can be refined for conversion.",
    "personal_assistant.feature.workspace_domain_setup.name": "Review domain setup",
    "Review domain setup": "Review domain setup",
    "personal_assistant.feature.workspace_domain_setup.outcome": "A clean domain improves brand trust.",
    "A clean domain improves brand trust.": "A clean domain improves brand trust.",
    "personal_assistant.feature.workspace_pages.name": "Review site pages",
    "Review site pages": "Review site pages",
    "personal_assistant.feature.workspace_pages.outcome": "Core landing and content pages support user trust.",
    "Core landing and content pages support user trust.": "Core landing and content pages support user trust.",
    "reports.title": "Reports",
    "reports.metric.0": "Users",
    "reports.metric.1": "Accounts",
    "reports.metric.2": "Listings",
    "reports.metric.3": "Listings Sold",
    "Listings Sold": "Listings Sold",
    "reports.metric.4": "Total Sales",
    "Total Sales": "Total Sales",
    "reports.metric.5": "Total Orders",
    "reports.metric.6": "Total Earnings",
    "Total Earnings": "Total Earnings",
    "reports.chart.activity": "Daily marketplace activity",
    "Daily marketplace activity": "Daily marketplace activity",
    "reports.chart.activity_description": "Listings and new users over time",
    "Listings and new users over time": "Listings and new users over time",
    "reports.chart.listings_monthly": "Listings monthly",
    "Listings monthly": "Listings monthly",
    "reports.chart.listings_daily": "Listings daily",
    "Listings daily": "Listings daily",
    "reports.chart.users_daily": "Users daily",
    "Users daily": "Users daily",
    "reports.chart.users_monthly": "Users monthly",
    "Users monthly": "Users monthly",
    "reports.series.listings": "Listings",
    "reports.series.new_users": "New users",
    "New users": "New users",
    "reports.top_sold_listings": "Top sold listings",
    "Top sold listings": "Top sold listings",
    "reports.view_more_insights": "View more insights",
    "View more insights": "View more insights",
    "reports.ai.title": "AI sales reports",
    "AI sales reports": "AI sales reports",
    "reports.ai.generating": "Generating reports…",
    "Generating reports…": "Generating reports…",
    "reports.ai.value": "Value",
    "reports.ai.more_info": "More information about {label}",
    "More information about {label}": "More information about {label}",
    "reports.ai.saved_snapshot": "Saved snapshot",
    "Saved snapshot": "Saved snapshot",
    "reports.ai.no_data": "No data available",
    "No data available": "No data available",
    "reports.ai.showing_top": "Showing the top {shown} of {total} results",
    "Showing the top {shown} of {total} results": "Showing the top {shown} of {total} results",
    "reports.ai.saved_report": "Saved AI report",
    "Saved AI report": "Saved AI report",
    "reports.ai.template.country": "Sales by country",
    "Sales by country": "Sales by country",
    "reports.ai.template.state": "Sales by state",
    "Sales by state": "Sales by state",
    "reports.ai.template.city": "Sales by city",
    "Sales by city": "Sales by city",
    "reports.ai.template.category": "Sales by category",
    "Sales by category": "Sales by category",
    "reports.ai.template.country_all_time": "Sales by country (all time)",
    "Sales by country (all time)": "Sales by country (all time)",
    "reports.ai.template.top_listings_all_time": "Top sold listings (all time)",
    "Top sold listings (all time)": "Top sold listings (all time)",
    "reports.ai.template.listings_by_category_all_time": "Listings by category (all time)",
    "Listings by category (all time)": "Listings by category (all time)",
    "reports.search_table.title": "Listing search",
    "Listing search": "Listing search",
    "reports.search_table.phrase": "Phrase",
    "Phrase": "Phrase",
    "reports.search_table.result": "Result",
    "reports.search_table.created_at": "Created at",
    "Created at": "Created at",
    "reports.search_table.user_first_name": "User first name",
    "User first name": "User first name",
    "reports.search_table.user_last_name": "User last name",
    "User last name": "User last name",
    "reports.search_table.user_email": "User email",
    "User email": "User email",
    "intelligence.title": "Intelligence",
    "intelligence.description": "Generate AI reports save chart snapshots and pin useful reports to your dashboard.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Generate AI reports save chart snapshots and pin useful reports to your dashboard.",
    "intelligence.dashboard.label": "Dashboard",
    "intelligence.dashboard.pinned_title": "Pinned intelligence widgets",
    "Pinned intelligence widgets": "Pinned intelligence widgets",
    "intelligence.dashboard.pinned_count": "{count} pinned",
    "{count} pinned": "{count} pinned",
    "intelligence.dashboard.empty": "Pin saved reports to build a reusable dashboard grid.",
    "Pin saved reports to build a reusable dashboard grid.": "Pin saved reports to build a reusable dashboard grid.",
    "intelligence.action.open": "Open",
    "intelligence.action.pin": "Pin",
    "Pin": "Pin",
    "intelligence.action.unpin": "Unpin",
    "Unpin": "Unpin",
    "intelligence.action.generate": "Generate",
    "intelligence.action.save_snapshot": "Save snapshot",
    "Save snapshot": "Save snapshot",
    "intelligence.action.discard_draft": "Discard draft",
    "Discard draft": "Discard draft",
    "intelligence.action.load": "Load",
    "Load": "Load",
    "intelligence.action.refresh": "Refresh",
    "intelligence.action.delete": "Delete",
    "intelligence.table.no_rows": "No structured rows were returned for this report.",
    "No structured rows were returned for this report.": "No structured rows were returned for this report.",
    "intelligence.table.no_rows_short": "No rows available.",
    "No rows available.": "No rows available.",
    "intelligence.field.template": "Report template",
    "Report template": "Report template",
    "intelligence.field.date_filter": "Date filter",
    "Date filter": "Date filter",
    "intelligence.field.prompt": "Prompt preview",
    "Prompt preview": "Prompt preview",
    "intelligence.field.report_name": "Report name",
    "Report name": "Report name",
    "intelligence.field.report_name_placeholder": "For example: Top Selling Products – Last 30 Days",
    "For example: Top Selling Products – Last 30 Days": "For example: Top Selling Products – Last 30 Days",
    "intelligence.field.chart": "Chart",
    "Chart": "Chart",
    "intelligence.field.prompt_label": "Prompt",
    "Prompt": "Prompt",
    "intelligence.date.relative": "Relative",
    "Relative": "Relative",
    "intelligence.date.absolute": "Absolute",
    "Absolute": "Absolute",
    "intelligence.date.last_n_days": "Last N days",
    "Last N days": "Last N days",
    "intelligence.date.last_days": "Last {days} days",
    "Last {days} days": "Last {days} days",
    "intelligence.date.from": "From",
    "From": "From",
    "intelligence.date.to": "To",
    "To": "To",
    "intelligence.saved_reports.title": "Saved reports",
    "Saved reports": "Saved reports",
    "intelligence.saved_reports.empty": "No saved intelligence reports yet.",
    "No saved intelligence reports yet.": "No saved intelligence reports yet.",
    "intelligence.active_report": "Active report",
    "Active report": "Active report",
    "intelligence.no_report_selected": "No report selected",
    "No report selected": "No report selected",
    "intelligence.active_report.empty_description": "Generate a report or load a saved one to inspect the data.",
    "Generate a report or load a saved one to inspect the data.": "Generate a report or load a saved one to inspect the data.",
    "intelligence.chart.value": "Value",
    "intelligence.chart.unknown": "Unknown",
    "intelligence.chart_type.bar": "Barres",
    "Barres": "Barres",
    "intelligence.chart_type.line": "Line",
    "Line": "Line",
    "intelligence.chart_type.area": "Area",
    "Area": "Area",
    "intelligence.chart_type.pie": "Pie",
    "Pie": "Pie",
    "intelligence.chart.no_rows": "This report did not return rows to plot.",
    "This report did not return rows to plot.": "This report did not return rows to plot.",
    "intelligence.empty_report": "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.",
    "intelligence.error.update": "Unable to update the saved report.",
    "Unable to update the saved report.": "Unable to update the saved report.",
    "intelligence.error.prompt_required": "Enter a prompt to generate a report.",
    "Enter a prompt to generate a report.": "Enter a prompt to generate a report.",
    "intelligence.error.invalid_response": "The AI response did not include a normalized report.",
    "The AI response did not include a normalized report.": "The AI response did not include a normalized report.",
    "intelligence.error.generate": "Unable to generate the report right now.",
    "Unable to generate the report right now.": "Unable to generate the report right now.",
    "intelligence.error.generate_before_save": "Generate a report before saving.",
    "Generate a report before saving.": "Generate a report before saving.",
    "intelligence.error.save": "Unable to save the report.",
    "Unable to save the report.": "Unable to save the report.",
    "intelligence.error.load": "Unable to load the saved report.",
    "Unable to load the saved report.": "Unable to load the saved report.",
    "intelligence.error.refresh": "Unable to refresh the saved report.",
    "Unable to refresh the saved report.": "Unable to refresh the saved report.",
    "intelligence.error.delete": "Unable to delete the saved report.",
    "Unable to delete the saved report.": "Unable to delete the saved report.",
    "intelligence.template.top_selling_products": "Top selling products",
    "Top selling products": "Top selling products",
    "intelligence.template.revenue_trend": "Revenue trend",
    "Revenue trend": "Revenue trend",
    "intelligence.template.low_stock_products": "Low stock products",
    "Low stock products": "Low stock products",
    "intelligence.template.top_categories_by_sales": "Top categories by sales",
    "Top categories by sales": "Top categories by sales",
    "intelligence.template.order_status_breakdown": "Order status breakdown",
    "Order status breakdown": "Order status breakdown",
    "intelligence.template.sales_by_day": "Sales by day",
    "Sales by day": "Sales by day",
    "intelligence.template.sales_by_country": "Sales by country",
    "intelligence.template.sales_by_state": "Sales by state",
    "intelligence.template.sales_by_city": "Sales by city",
    "intelligence.template.sales_by_category": "Sales by category",
    "intelligence.template.sales_by_subcategory": "Sales by subcategory",
    "Sales by subcategory": "Sales by subcategory",
    "intelligence.prompt.top_selling_products.relative": "Show me top selling products for the last {days} days",
    "Show me top selling products for the last {days} days": "Show me top selling products for the last {days} days",
    "intelligence.prompt.top_selling_products.absolute": "Show me top selling products from {from} to {to}",
    "Show me top selling products from {from} to {to}": "Show me top selling products from {from} to {to}",
    "intelligence.prompt.revenue_trend.relative": "What is my revenue trend for the last {days} days?",
    "What is my revenue trend for the last {days} days?": "What is my revenue trend for the last {days} days?",
    "intelligence.prompt.revenue_trend.absolute": "What is my revenue trend from {from} to {to}?",
    "What is my revenue trend from {from} to {to}?": "What is my revenue trend from {from} to {to}?",
    "intelligence.prompt.low_stock_products": "Show me low stock products",
    "Show me low stock products": "Show me low stock products",
    "intelligence.prompt.top_categories_by_sales.relative": "Show me top categories by sales for the last {days} days",
    "Show me top categories by sales for the last {days} days": "Show me top categories by sales for the last {days} days",
    "intelligence.prompt.top_categories_by_sales.absolute": "Show me top categories by sales from {from} to {to}",
    "Show me top categories by sales from {from} to {to}": "Show me top categories by sales from {from} to {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Show me order status breakdown for the last {days} days",
    "Show me order status breakdown for the last {days} days": "Show me order status breakdown for the last {days} days",
    "intelligence.prompt.order_status_breakdown.absolute": "Show me order status breakdown from {from} to {to}",
    "Show me order status breakdown from {from} to {to}": "Show me order status breakdown from {from} to {to}",
    "intelligence.prompt.sales_by_day.relative": "Show me sales by day for the last {days} days",
    "Show me sales by day for the last {days} days": "Show me sales by day for the last {days} days",
    "intelligence.prompt.sales_by_day.absolute": "Show me sales by day from {from} to {to}",
    "Show me sales by day from {from} to {to}": "Show me sales by day from {from} to {to}",
    "intelligence.prompt.sales_by_country.relative": "Show me total sales revenue and order count grouped by country for the last {days} days",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Show me total sales revenue and order count grouped by country for the last {days} days",
    "intelligence.prompt.sales_by_country.absolute": "Show me total sales revenue and order count grouped by country from {from} to {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Show me total sales revenue and order count grouped by country from {from} to {to}",
    "intelligence.prompt.sales_by_state.relative": "Show me total sales revenue and order count grouped by state or province for the last {days} days",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Show me total sales revenue and order count grouped by state or province for the last {days} days",
    "intelligence.prompt.sales_by_state.absolute": "Show me total sales revenue and order count grouped by state or province from {from} to {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Show me total sales revenue and order count grouped by state or province from {from} to {to}",
    "intelligence.prompt.sales_by_city.relative": "Show me total sales revenue and order count grouped by city for the last {days} days",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Show me total sales revenue and order count grouped by city for the last {days} days",
    "intelligence.prompt.sales_by_city.absolute": "Show me total sales revenue and order count grouped by city from {from} to {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Show me total sales revenue and order count grouped by city from {from} to {to}",
    "intelligence.prompt.sales_by_category.relative": "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days",
    "intelligence.prompt.sales_by_category.absolute": "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days",
    "intelligence.prompt.sales_by_subcategory.absolute": "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}",
    "common.status.partial": "Partial",
    "Partial": "Partial",
    "common.status.dispatched": "Dispatched",
    "Dispatched": "Dispatched",
    "common.status.sale": "Sale",
    "Sale": "Sale",
    "common.status.transfer_in": "Transfer in",
    "Transfer in": "Transfer in",
    "common.status.transfer_out": "Transfer out",
    "Transfer out": "Transfer out",
    "common.status.return": "Return",
    "Return": "Return",
    "common.status.adjustment": "Adjustment",
    "Adjustment": "Adjustment",
    "common.status.receipt": "Receipt",
    "inventory.overview.title": "Inventory",
    "inventory.overview.tab.all": "All stock",
    "All stock": "All stock",
    "inventory.overview.tab.low": "Low stock",
    "Low stock": "Low stock",
    "inventory.overview.tab.expiring": "Expiring batches",
    "Expiring batches": "Expiring batches",
    "inventory.overview.manage_locations": "Manage locations",
    "Manage locations": "Manage locations",
    "inventory.overview.purchase_orders": "Purchase orders",
    "inventory.overview.operations": "Operations",
    "Operations": "Operations",
    "inventory.overview.adjust_stock": "Adjust stock",
    "Adjust stock": "Adjust stock",
    "inventory.overview.description": "A live view of stock across your locations.",
    "A live view of stock across your locations.": "A live view of stock across your locations.",
    "inventory.overview.adjustment_hint": "Use adjustments for counts, damage, returns, or other corrections.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Use adjustments for counts, damage, returns, or other corrections.",
    "inventory.overview.units_on_hand": "Units on hand",
    "Units on hand": "Units on hand",
    "inventory.overview.one_stock_row": "1 stock row",
    "1 stock row": "1 stock row",
    "inventory.overview.stock_rows": "{count} stock rows",
    "{count} stock rows": "{count} stock rows",
    "inventory.overview.low_stock": "Low stock",
    "inventory.overview.reorder_point_hint": "At or below reorder point",
    "At or below reorder point": "At or below reorder point",
    "inventory.overview.expiring_soon": "Expiring soon",
    "Expiring soon": "Expiring soon",
    "inventory.overview.next_90_days": "Within the next 90 days",
    "Within the next 90 days": "Within the next 90 days",
    "inventory.overview.stock_value": "Stock value",
    "Stock value": "Stock value",
    "inventory.overview.one_active_location": "1 active location",
    "1 active location": "1 active location",
    "inventory.overview.active_locations": "{count} active locations",
    "{count} active locations": "{count} active locations",
    "inventory.overview.search": "Search inventory",
    "Search inventory": "Search inventory",
    "inventory.overview.search_placeholder": "Search product, SKU, or location",
    "Search product, SKU, or location": "Search product, SKU, or location",
    "inventory.overview.filter_location": "Filter by location",
    "Filter by location": "Filter by location",
    "inventory.overview.all_locations": "All locations",
    "inventory.overview.empty.all": "No inventory stock has been recorded yet.",
    "No inventory stock has been recorded yet.": "No inventory stock has been recorded yet.",
    "inventory.overview.empty.low": "Great — no stock is below its reorder point.",
    "Great — no stock is below its reorder point.": "Great — no stock is below its reorder point.",
    "inventory.overview.empty.expiring": "No batches are expiring within 90 days.",
    "No batches are expiring within 90 days.": "No batches are expiring within 90 days.",
    "inventory.overview.adjust": "Adjust",
    "Adjust": "Adjust",
    "inventory.overview.adjust_title": "Adjust stock",
    "inventory.overview.adjust_description": "Record a correction with a reason so the inventory history stays trustworthy.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Record a correction with a reason so the inventory history stays trustworthy.",
    "inventory.overview.save_adjustment": "Save adjustment",
    "Save adjustment": "Save adjustment",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Unassigned",
    "Unassigned": "Unassigned",
    "inventory.overview.quantity_change": "Quantity change",
    "Quantity change": "Quantity change",
    "inventory.overview.quantity_placeholder": "e.g. 5 or -2",
    "e.g. 5 or -2": "e.g. 5 or -2",
    "inventory.overview.reason": "Reason",
    "inventory.overview.reason_placeholder": "Cycle count, damage, return…",
    "Cycle count, damage, return…": "Cycle count, damage, return…",
    "inventory.overview.reason.cycle_count": "Cycle count",
    "Cycle count": "Cycle count",
    "inventory.overview.reason.damage": "Damage",
    "Damage": "Damage",
    "inventory.overview.reason.return": "Return",
    "inventory.overview.reason.stocktake": "Stocktake",
    "Stocktake": "Stocktake",
    "inventory.overview.note_placeholder": "Optional context for the next person",
    "Optional context for the next person": "Optional context for the next person",
    "inventory.overview.adjustment_saved": "Inventory adjustment saved",
    "Inventory adjustment saved": "Inventory adjustment saved",
    "inventory.overview.on_hand": "On hand",
    "On hand": "On hand",
    "inventory.overview.reorder_at": "Reorder at",
    "Reorder at": "Reorder at",
    "orders.create_order.payment_reference_missing": "The order was created, but no order reference was returned.",
    "The order was created, but no order reference was returned.": "The order was created, but no order reference was returned.",
    "orders.create_order.payment_domain_missing": "The tenant domain is not available for payment links.",
    "The tenant domain is not available for payment links.": "The tenant domain is not available for payment links.",
    "orders.create_order.payment_link_failed": "Unable to create payment link.",
    "Unable to create payment link.": "Unable to create payment link.",
    "orders.create_order.admin_session_expired": "Your admin session has expired. Please sign in again before creating an order.",
    "Your admin session has expired. Please sign in again before creating an order.": "Your admin session has expired. Please sign in again before creating an order.",
    "orders.create_order.user": "User",
    "orders.create_order.add_new_user": "Add New User",
    "Add New User": "Add New User",
    "orders.create_order.choose_existing_user": "Choose Existing User",
    "Choose Existing User": "Choose Existing User",
    "orders.create_order.preparing_customer": "Preparing customer…",
    "Preparing customer…": "Preparing customer…",
    "orders.create_order.select_user": "Select user",
    "Select user": "Select user",
    "orders.create_order.search_listing": "Search Listing",
    "Search Listing": "Search Listing",
    "orders.create_order.listings": "Listings",
    "orders.create_order.no_image": "No image",
    "No image": "No image",
    "orders.create_order.add_to_cart": "Add to Cart",
    "Add to Cart": "Add to Cart",
    "orders.create_order.select_rental_dates": "Select rental start and end dates first.",
    "Select rental start and end dates first.": "Select rental start and end dates first.",
    "orders.create_order.rental_end_after_start": "Rental end must be after the start date.",
    "Rental end must be after the start date.": "Rental end must be after the start date.",
    "orders.create_order.cart_type_conflict": "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.",
    "orders.create_order.rental_period": "Rental period",
    "Rental period": "Rental period",
    "orders.create_order.select_start_end": "Select start and end",
    "Select start and end": "Select start and end",
    "orders.create_order.membership_no_shipping": "Membership orders do not require shipping or delivery.",
    "Membership orders do not require shipping or delivery.": "Membership orders do not require shipping or delivery.",
    "orders.create_order.preparing_payment_link": "Preparing payment link…",
    "Preparing payment link…": "Preparing payment link…",
    "orders.create_order.payment_link_ready": "Payment link ready",
    "Payment link ready": "Payment link ready",
    "orders.create_order.copy_payment_link": "Copy payment link",
    "Copy payment link": "Copy payment link",
    "orders.create_order.payment_method": "Payment Method",
    "orders.create_order.no_payment_methods": "No active payment methods are configured for this project.",
    "No active payment methods are configured for this project.": "No active payment methods are configured for this project.",
    "orders.create_order.shipping_method": "Shipping Method",
    "orders.create_order.no_shipping_methods": "No active shipping methods are configured for this project.",
    "No active shipping methods are configured for this project.": "No active shipping methods are configured for this project.",
    "orders.create_order.shipping_address": "Shipping address",
    "Shipping address": "Shipping address",
    "orders.create_order.loading_addresses": "Loading saved addresses…",
    "Loading saved addresses…": "Loading saved addresses…",
    "orders.create_order.no_saved_shipping_address": "This user has no saved shipping address. Add one to the user before creating a delivery order.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "This user has no saved shipping address. Add one to the user before creating a delivery order.",
    "orders.create_order.no_items": "No items",
    "No items": "No items",
    "orders.create_order.cart_empty": "Your cart is empty",
    "Your cart is empty": "Your cart is empty",
    "orders.create_order.create_order": "Create Order",
    "Create Order": "Create Order",
    "orders.create_order.create_payment_link": "Create payment link",
    "Create payment link": "Create payment link",
    "orders.create_order.order_summary": "Order Summary",
    "orders.create_order.coupon_value": "Coupon value",
    "Coupon value": "Coupon value",
    "orders.create_order.remove_coupon": "Remove Coupon",
    "Remove Coupon": "Remove Coupon",
    "orders.create_order.apply_coupon": "Apply Coupon",
    "Apply Coupon": "Apply Coupon",
    "orders.create_order.grand_amount": "Grand Amount",
    "Grand Amount": "Grand Amount",
    "orders.create_order.total": "Total",
    "orders.create_order.shipping": "Shipping",
    "Shipping": "Shipping",
    "orders.create_order.subtotal": "Subtotal",
    "Subtotal": "Subtotal",
    "orders.create_order.stock_unavailable": "Stock is not available",
    "Stock is not available": "Stock is not available",
    "orders.create_order.max_quantity": "Max quantity is {quantity}",
    "Max quantity is {quantity}": "Max quantity is {quantity}",
    "orders.create_order.items_in_cart": "Items in the cart",
    "Items in the cart": "Items in the cart",
    "orders.create_order.products_in_stock": "{count} Products in Stock",
    "{count} Products in Stock": "{count} Products in Stock",
    "orders.create_order.order_items": "Order Items",
    "Order Items": "Order Items",
    "orders.create_order.sold_by": "by {name}",
    "by {name}": "by {name}",
    "common.first_name": "First Name",
    "common.last_name": "Last Name",
    "common.unlimited": "unlimited",
    "unlimited": "unlimited",
    "orders.reference": "Reference",
    "orders.amount": "Amount",
    "orders.currency": "Currency",
    "orders.transaction_date": "Transaction Date",
    "Transaction Date": "Transaction Date",
    "orders.volume_this_page": "Volume (this page)",
    "Volume (this page)": "Volume (this page)",
    "orders.seller_entries": "Seller Entries",
    "Seller Entries": "Seller Entries",
    "orders.customer_entries": "Customer Entries",
    "Customer Entries": "Customer Entries",
    "orders.filter_transactions": "Filter Transactions",
    "Filter Transactions": "Filter Transactions",
    "orders.reset_filters": "Reset filters",
    "Reset filters": "Reset filters",
    "orders.manage_transactions": "Manage your Transactions",
    "Manage your Transactions": "Manage your Transactions",
    "orders.empty_transactions_message": "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.",
    "orders.super_type": "Super Type",
    "Super Type": "Super Type",
    "orders.exporting": "Exporting…",
    "Exporting…": "Exporting…",
    "orders.export_as_csv": "Export as CSV",
    "Export as CSV": "Export as CSV",
    "orders.search_transactions": "Search transactions",
    "Search transactions": "Search transactions",
    "orders.filter": "Filter",
    "Filter": "Filter",
    "orders.transaction_status": "Transaction Status",
    "Transaction Status": "Transaction Status",
    "orders.seller_protection_fee": "Seller Protection Fee",
    "Seller Protection Fee": "Seller Protection Fee",
    "common.show_rows": "Show rows",
    "common.clear_all": "Clear All",
    "Clear All": "Clear All",
    "orders.order_number_value": "Order #{number}",
    "orders.transactions": "Transactions",
    "reported_listings.report_detail": "Report Detail",
    "Report Detail": "Report Detail",
    "reported_listings.reported_listing": "Reported Listing",
    "Reported Listing": "Reported Listing",
    "reported_listings.pending": "Pending",
    "reported_listings.approved": "Approved",
    "reported_listings.rejected": "Rejected",
    "reported_listings.view_marketplace": "View on marketplace",
    "View on marketplace": "View on marketplace",
    "reported_listings.approve_listing": "Approve listing",
    "Approve listing": "Approve listing",
    "reported_listings.reject_listing": "Reject listing",
    "Reject listing": "Reject listing",
    "reported_listings.reported_by": "Reported By",
    "Reported By": "Reported By",
    "reported_listings.blocked": "Blocked",
    "reported_listings.unblock_user": "Unblock user",
    "Unblock user": "Unblock user",
    "reported_listings.block_user": "Block user",
    "Block user": "Block user",
    "reported_listings.report_info": "Report Info",
    "Report Info": "Report Info",
    "reported_listings.reason": "Reason",
    "reported_listings.reported_on": "Reported on",
    "Reported on": "Reported on",
    "reported_listings.listing_id": "Listing ID",
    "Listing ID": "Listing ID",
    "reported_listings.reporter": "Reporter",
    "Reporter": "Reporter",
    "reported_listings.listing": "Listing",
    "Listing": "Listing",
    "reported_listings.status": "Status",
    "reported_listings.title": "Reported Listings",
    "reported_listings.report_count": "Reports: {count}",
    "Reports: {count}": "Reports: {count}",
    "reported_listings.empty_title": "Viewing Reported listings",
    "Viewing Reported listings": "Viewing Reported listings",
    "reported_listings.empty_message": "You will find your users reported listings here",
    "You will find your users reported listings here": "You will find your users reported listings here",
    "common.page_of": "Page {page} of {total}",
    "Page {page} of {total}": "Page {page} of {total}",
    "common.view": "View",
    "reviews.empty_title": "Viewing Rate & Reviews",
    "Viewing Rate & Reviews": "Viewing Rate & Reviews",
    "reviews.empty_message": "You will find your users ratings and reviews here",
    "You will find your users ratings and reviews here": "You will find your users ratings and reviews here",
    "reviews.list": "List",
    "reviews.grid": "Grid",
    "Grid": "Grid",
    "reviews.title": "Reviews & Ratings",
    "reviews.review": "Review",
    "reviews.name": "Name",
    "reviews.rating": "Rating",
    "Rating": "Rating",
    "reviews.title_column": "Title",
    "reviews.content": "Content",
    "Content": "Content",
    "reviews.image": "Image",
    "Image": "Image",
    "reviews.images": "Images",
    "Images": "Images",
    "reviews.accounts": "Accounts",
    "reviews.listings": "Listings",
    "reviews.star": "Star",
    "Star": "Star",
    "reviews.review_image": "Review image",
    "Review image": "Review image",
    "reviews.title_required": "Title is required",
    "Title is required": "Title is required",
    "reviews.content_required": "Content is required",
    "Content is required": "Content is required",
    "reviews.updated_successfully": "Review updated successfully",
    "Review updated successfully": "Review updated successfully",
    "reviews.edit_review": "Edit Review",
    "Edit Review": "Edit Review",
    "common.not_available": "N/A",
    "common.something_went_wrong": "Something went wrong",
    "Something went wrong": "Something went wrong",
    "media.load_failed": "Unable to load media.",
    "Unable to load media.": "Unable to load media.",
    "media.load_failed_retry": "Unable to load media. Please try again.",
    "Unable to load media. Please try again.": "Unable to load media. Please try again.",
    "media.update_failed": "Media update failed",
    "Media update failed": "Media update failed",
    "media.renamed": "Media renamed",
    "Media renamed": "Media renamed",
    "media.moved": "Media moved",
    "Media moved": "Media moved",
    "media.rename_failed": "Unable to rename media",
    "Unable to rename media": "Unable to rename media",
    "media.move_failed": "Unable to move media",
    "Unable to move media": "Unable to move media",
    "media.deleted": "Media deleted",
    "Media deleted": "Media deleted",
    "media.delete_failed": "Unable to delete media",
    "Unable to delete media": "Unable to delete media",
    "media.confirm_delete": "Are you sure you want to delete this media?",
    "Are you sure you want to delete this media?": "Are you sure you want to delete this media?",
    "media.delete_media": "Delete media",
    "Delete media": "Delete media",
    "media.folder_creation_web_only": "Folder creation is available on web",
    "Folder creation is available on web": "Folder creation is available on web",
    "media.no_create_folder_permission": "You do not have permission to create folders",
    "You do not have permission to create folders": "You do not have permission to create folders",
    "media.folder_name": "Folder name",
    "Folder name": "Folder name",
    "media.folder_created": "Folder created",
    "Folder created": "Folder created",
    "media.folder_create_failed": "Unable to create folder",
    "Unable to create folder": "Unable to create folder",
    "media.link_copied": "Link copied",
    "Link copied": "Link copied",
    "media.copy_link_failed": "Unable to copy link",
    "Unable to copy link": "Unable to copy link",
    "media.urls_copied": "{count} URLs copied",
    "{count} URLs copied": "{count} URLs copied",
    "media.clipboard_unavailable": "Clipboard is not available",
    "Clipboard is not available": "Clipboard is not available",
    "media.copy_urls_failed": "Unable to copy URLs",
    "Unable to copy URLs": "Unable to copy URLs",
    "media.upload_failed": "Media upload failed",
    "Media upload failed": "Media upload failed",
    "media.replace_success": "Media replaced. The media ID and stable link are unchanged.",
    "Media replaced. The media ID and stable link are unchanged.": "Media replaced. The media ID and stable link are unchanged.",
    "media.replace_failed": "Unable to replace media",
    "Unable to replace media": "Unable to replace media",
    "media.csv_upload_failed": "CSV upload failed",
    "CSV upload failed": "CSV upload failed",
    "media.csv_metadata_failed": "Unable to save CSV metadata",
    "Unable to save CSV metadata": "Unable to save CSV metadata",
    "media.csv_saved_version": "CSV saved as a new version",
    "CSV saved as a new version": "CSV saved as a new version",
    "media.csv_save_failed": "Unable to save CSV",
    "Unable to save CSV": "Unable to save CSV",
    "media.uploading_files": "Uploading {count} files…",
    "Uploading {count} files…": "Uploading {count} files…",
    "media.upload_progress": "Uploading {count} files · {progress}%",
    "Uploading {count} files · {progress}%": "Uploading {count} files · {progress}%",
    "media.upload_success": "{count} files uploaded successfully.",
    "{count} files uploaded successfully.": "{count} files uploaded successfully.",
    "media.upload_failed_retry": "Unable to upload media. Please try again.",
    "Unable to upload media. Please try again.": "Unable to upload media. Please try again.",
    "media.register_failed": "Unable to register media",
    "Unable to register media": "Unable to register media",
    "media.list_view": "List view",
    "List view": "List view",
    "media.grid_view": "Grid view",
    "Grid view": "Grid view",
    "media.copy_uploaded_urls": "Copy uploaded URLs",
    "Copy uploaded URLs": "Copy uploaded URLs",
    "media.copy_visible_urls": "Copy visible URLs",
    "Copy visible URLs": "Copy visible URLs",
    "media.copy_all_urls": "Copy all URLs",
    "Copy all URLs": "Copy all URLs",
    "media.new_folder": "New folder",
    "New folder": "New folder",
    "media.uploading_progress": "Uploading {progress}%",
    "Uploading {progress}%": "Uploading {progress}%",
    "media.upload_media": "Upload media",
    "Upload media": "Upload media",
    "media.manager_title": "Media Manager",
    "Media Manager": "Media Manager",
    "media.search": "Search media",
    "Search media": "Search media",
    "media.location": "Location",
    "media.media_root": "Media",
    "media.show_type": "Show {type} media",
    "Show {type} media": "Show {type} media",
    "media.type_all": "all",
    "all": "all",
    "media.type_image": "image",
    "image": "image",
    "media.type_video": "video",
    "video": "video",
    "media.type_audio": "audio",
    "audio": "audio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "folder",
    "folder": "folder",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Oldest",
    "Oldest": "Oldest",
    "media.newest": "Newest",
    "Newest": "Newest",
    "media.sort_current": "Sort media, currently {sort}",
    "Sort media, currently {sort}": "Sort media, currently {sort}",
    "media.loading": "Loading media…",
    "Loading media…": "Loading media…",
    "media.no_filter_matches": "No media matches these filters.",
    "No media matches these filters.": "No media matches these filters.",
    "media.empty_title": "Your media library is empty",
    "Your media library is empty": "Your media library is empty",
    "media.empty_message": "Upload images, PDF, videos to be re-used in different cases like promo, article, etc",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Upload images, PDF, videos to be re-used in different cases like promo, article, etc",
    "media.empty_hint": "Upload files or create a folder to get started.",
    "Upload files or create a folder to get started.": "Upload files or create a folder to get started.",
    "media.folder": "Folder",
    "Folder": "Folder",
    "media.file_folder_name": "File or folder name",
    "File or folder name": "File or folder name",
    "media.rename_media": "Rename media",
    "Rename media": "Rename media",
    "media.move_media": "Move media",
    "Move media": "Move media",
    "media.pdf_preview": "PDF preview: {name}",
    "PDF preview: {name}": "PDF preview: {name}",
    "media.pdf_preview_web": "PDF preview is available in the web app.",
    "PDF preview is available in the web app.": "PDF preview is available in the web app.",
    "media.csv_preview_web": "CSV preview is available in the web app.",
    "CSV preview is available in the web app.": "CSV preview is available in the web app.",
    "media.media_file": "Media file",
    "Media file": "Media file",
    "media.share_link": "Share link",
    "Share link": "Share link",
    "media.copy_link": "Copy link",
    "Copy link": "Copy link",
    "media.replace_media": "Replace media",
    "Replace media": "Replace media",
    "media.folders": "Folders",
    "Folders": "Folders",
    "media.create_new_folder": "Create new folder",
    "Create new folder": "Create new folder",
    "media.go_to_all_media": "Go to all media",
    "Go to all media": "Go to all media",
    "media.all_media": "All media",
    "All media": "All media",
    "media.open_folder_name": "Open folder {name}",
    "Open folder {name}": "Open folder {name}",
    "media.no_subfolders": "No subfolders",
    "No subfolders": "No subfolders",
    "media.no_files_in_folder": "No files in this folder.",
    "No files in this folder.": "No files in this folder.",
    "media.upload_folder": "Upload media to this folder",
    "Upload media to this folder": "Upload media to this folder",
    "media.discard_csv_confirm": "Discard your CSV changes?",
    "Discard your CSV changes?": "Discard your CSV changes?",
    "media.unsaved_changes": "Unsaved changes",
    "Unsaved changes": "Unsaved changes",
    "media.find_csv": "Find in CSV",
    "Find in CSV": "Find in CSV",
    "media.save_csv": "Save CSV",
    "Save CSV": "Save CSV",
    "media.loading_csv": "Loading CSV…",
    "Loading CSV…": "Loading CSV…",
    "media.prepare_folder_failed": "Unable to prepare the upload folder",
    "Unable to prepare the upload folder": "Unable to prepare the upload folder",
    "media.add_file_required": "Please add a file",
    "Please add a file": "Please add a file",
    "media.add_media": "Add Media",
    "Add Media": "Add Media",
    "media.store_uploaded_media_in": "Store uploaded media in",
    "Store uploaded media in": "Store uploaded media in",
    "media.destination_business_cards": "Business Cards",
    "Business Cards": "Business Cards",
    "media.destination_listings": "Listings",
    "media.destination_accounts": "Accounts",
    "media.destination_users": "Users",
    "media.upload_media_title": "Upload Media",
    "Upload Media": "Upload Media",
    "media.media_files": "Media",
    "media.open_folder": "Open folder",
    "Open folder": "Open folder",
    "common.show": "Show",
    "common.share": "Share",
    "Share": "Share",
    "common.copy": "Copy",
    "common.rename": "Rename",
    "Rename": "Rename",
    "common.move": "Move",
    "Move": "Move",
    "common.type": "Type",
    "common.size": "Size",
    "Size": "Size",
    "common.preview": "Preview",
    "Preview": "Preview",
    "common.undo": "Undo",
    "Undo": "Undo",
    "common.redo": "Redo",
    "Redo": "Redo",
    "common.discard": "Discard",
    "Discard": "Discard",
    "common.try_again": "Try again",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Spreadsheet",
    "Spreadsheet": "Spreadsheet",
    "media.type_file": "File",
    "File": "File",
    "media.csv_load_failed": "Unable to load CSV. Please try again.",
    "Unable to load CSV. Please try again.": "Unable to load CSV. Please try again.",
    "workspace.settings_section.customisation": "Customisation",
    "workspace.settings_section.integrations": "Integrations",
    "workspace.settings_section.platform_setup": "Platform Setup",
    "Platform Setup": "Platform Setup",
    "workspace.settings_section.business_operations": "Business Operations",
    "Business Operations": "Business Operations",
    "workspace.settings_section.system_setup": "System Setup",
    "System Setup": "System Setup",
    "workspace.settings_item.app_customisation": "App Customisation",
    "App Customisation": "App Customisation",
    "workspace.settings_item.web_customisation": "Web Customisation",
    "Web Customisation": "Web Customisation",
    "workspace.settings_item.communications": "Communications",
    "Communications": "Communications",
    "workspace.settings_item.strings_customisation": "Strings Customisation",
    "Strings Customisation": "Strings Customisation",
    "workspace.settings_item.app_integrations": "App Integrations",
    "workspace.settings_item.web_integrations": "Web Integrations",
    "Web Integrations": "Web Integrations",
    "workspace.settings_item.accounts": "Accounts",
    "workspace.settings_item.listings": "Listings",
    "workspace.settings_item.checkout_and_cart_attributes": "Checkout & Cart Attributes",
    "workspace.settings_item.service_shipping": "Service / Shipping",
    "workspace.settings_item.payments": "Payments",
    "workspace.settings_item.commissions": "Commissions",
    "workspace.settings_item.taxes": "Taxes",
    "workspace.settings_item.special_fees": "Special Fees",
    "workspace.settings_item.languages": "Languages",
    "workspace.settings_item.currency": "Currency",
    "workspace.settings_item.countries": "Countries",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Extensions",
    "Extensions": "Extensions",
    "workspace.settings_item.manage_features": "Manage Features",
    "Manage Features": "Manage Features",
    "workspace.settings_item.audit_logs": "Audit Logs",
    "Audit Logs": "Audit Logs",
    "workspace.settings_item.auth": "Auth",
    "workspace.settings_item.maps": "Maps",
    "workspace.settings_hint.accounts": "Example: Store",
    "Example: Store": "Example: Store",
    "workspace.settings_hint.listings": "Example: Products, Events",
    "Example: Products, Events": "Example: Products, Events",
    "workspace.settings_hint.audit_logs": "Compliance & security trail",
    "Compliance & security trail": "Compliance & security trail",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Provider usage and privacy settings",
    "Provider usage and privacy settings": "Provider usage and privacy settings",
    "workspace.settings_access_denied": "You don't have access of {name}",
    "You don't have access of {name}": "You don't have access of {name}",
    "app_customization.title": "App Customisation",
    "app_customization.tab_0": "General",
    "General": "General",
    "app_customization.tab_1": "Splash",
    "Splash": "Splash",
    "app_customization.tab_2": "Onboarding",
    "Onboarding": "Onboarding",
    "app_customization.tab_3": "Registration",
    "Registration": "Registration",
    "app_customization.tab_4": "Home",
    "Home": "Home",
    "app_customization.tab_5": "Push Notification",
    "Push Notification": "Push Notification",
    "app_customization.tab_6": "Chat",
    "Chat": "Chat",
    "app_customization.tab_7": "More Menu",
    "More Menu": "More Menu",
    "app_customization.tab_8": "Force Update",
    "Force Update": "Force Update",
    "app_customization.tab_9": "Address",
    "app_customization.hide_balances": "Hide balances & payouts in more section",
    "Hide balances & payouts in more section": "Hide balances & payouts in more section",
    "app_customization.more": "More",
    "app_customization.force_update": "Force To Update",
    "Force To Update": "Force To Update",
    "app_customization.android_version": "Android app version",
    "Android app version": "Android app version",
    "app_customization.enter_android_version": "Enter android app version",
    "Enter android app version": "Enter android app version",
    "app_customization.ios_version": "iOS app version",
    "iOS app version": "iOS app version",
    "app_customization.enter_ios_version": "Enter iOS app version",
    "Enter iOS app version": "Enter iOS app version",
    "app_customization.chat": "Chat",
    "app_customization.chat_send_listing": "Enable automatic send of listings when chat clicked ( Default shows preview on top)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Enable automatic send of listings when chat clicked ( Default shows preview on top)",
    "app_customization.make_offer": "Make Offer / Negotiation",
    "Make Offer / Negotiation": "Make Offer / Negotiation",
    "app_customization.negotiation_button_name": "Negotiation button name:",
    "Negotiation button name:": "Negotiation button name:",
    "app_customization.negotiation_button_example": "(example: Make Offer, Negotiate, Quote)",
    "(example: Make Offer, Negotiate, Quote)": "(example: Make Offer, Negotiate, Quote)",
    "app_customization.enter_negotiation_button_name": "Enter negotiation button name",
    "Enter negotiation button name": "Enter negotiation button name",
    "app_customization.address": "Address",
    "app_customization.address_option_0": "Show Address 2",
    "Show Address 2": "Show Address 2",
    "app_customization.address_option_1": "Show Country",
    "Show Country": "Show Country",
    "app_customization.address_option_2": "Show Zipcode",
    "Show Zipcode": "Show Zipcode",
    "app_customization.address_option_3": "Show State",
    "Show State": "Show State",
    "app_customization.address_option_4": "Show Landmark",
    "Show Landmark": "Show Landmark",
    "app_customization.address_option_5": "Show City",
    "Show City": "Show City",
    "app_customization.persistent_notification": "Persistent Notification",
    "Persistent Notification": "Persistent Notification",
    "app_customization.account_follow_content": "Account follow notification content",
    "Account follow notification content": "Account follow notification content",
    "app_customization.enter_account_follow_content": "Enter Account follow notification content",
    "Enter Account follow notification content": "Enter Account follow notification content",
    "app_customization.listing_like_content": "Listing like notification content",
    "Listing like notification content": "Listing like notification content",
    "app_customization.enter_listing_like_content": "Enter Listing like  notification content",
    "Enter Listing like  notification content": "Enter Listing like  notification content",
    "app_customization.order_status_content": "Order status notification content",
    "Order status notification content": "Order status notification content",
    "app_customization.enter_order_status_content": "Order status follow notification content",
    "Order status follow notification content": "Order status follow notification content",
    "app_customization.account_follow_required": "Account follow notification should contain {account_name}",
    "Account follow notification should contain {account_name}": "Account follow notification should contain {account_name}",
    "app_customization.listing_like_required": "Listing like notification content should contain {user_name}",
    "Listing like notification content should contain {user_name}": "Listing like notification content should contain {user_name}",
    "app_customization.order_number_required": "Order status notification content should contain #{order_number}",
    "Order status notification content should contain #{order_number}": "Order status notification content should contain #{order_number}",
    "app_customization.order_status_required": "Order status notification content should contain {order_status}",
    "Order status notification content should contain {order_status}": "Order status notification content should contain {order_status}",
    "app_customization.preview": "Preview",
    "app_customization.splash": "Splash",
    "app_customization.splash_image": "Splash Screen Image",
    "Splash Screen Image": "Splash Screen Image",
    "app_customization.registration": "Registration",
    "app_customization.registration_text": "Registration text",
    "Registration text": "Registration text",
    "app_customization.otp_note": "OTP Verification note",
    "OTP Verification note": "OTP Verification note",
    "app_customization.get_signup_first": "Get sign up first",
    "Get sign up first": "Get sign up first",
    "app_customization.mobile_in_email_signup": "Mobile number in email signup",
    "Mobile number in email signup": "Mobile number in email signup",
    "app_customization.preview_field_first_name": "First Name",
    "app_customization.preview_field_last_name": "Last Name",
    "app_customization.preview_field_email": "Email",
    "app_customization.preview_field_password": "Password",
    "Password": "Password",
    "app_customization.preview_field_confirm_password": "Confirm Password",
    "Confirm Password": "Confirm Password",
    "app_customization.preview_field_dob": "DOB",
    "DOB": "DOB",
    "app_customization.preview_field_mobile_no": "Mobile No",
    "Mobile No": "Mobile No",
    "app_customization.create": "Create",
    "app_customization.login": "Login",
    "Login": "Login",
    "app_customization.create_account": "Create your account",
    "Create your account": "Create your account",
    "app_customization.login_account": "Login to your account",
    "Login to your account": "Login to your account",
    "app_customization.onboarding_settings": "Onboarding Settings",
    "Onboarding Settings": "Onboarding Settings",
    "app_customization.onboarding_images": "Onboarding Images",
    "Onboarding Images": "Onboarding Images",
    "app_customization.onboarding_text_1": "Onboarding text 1",
    "Onboarding text 1": "Onboarding text 1",
    "app_customization.onboarding_text_2": "Onboarding text 2",
    "Onboarding text 2": "Onboarding text 2",
    "app_customization.onboarding_text_3": "Onboarding text 3",
    "Onboarding text 3": "Onboarding text 3",
    "app_customization.see_how_it_works": "See how it works",
    "See how it works": "See how it works",
    "app_customization.sell_icon_text": "Sell icon text",
    "Sell icon text": "Sell icon text",
    "app_customization.enter_sell_icon_text": "Enter sell icon text",
    "Enter sell icon text": "Enter sell icon text",
    "app_customization.sell_icon": "Sell Icon",
    "Sell Icon": "Sell Icon",
    "app_customization.enter_home_title": "Enter app title in home",
    "Enter app title in home": "Enter app title in home",
    "app_customization.app_details": "App Details",
    "App Details": "App Details",
    "app_customization.app_name": "App Name",
    "App Name": "App Name",
    "app_customization.primary_colour": "App Primary Colour",
    "App Primary Colour": "App Primary Colour",
    "app_customization.secondary_colour": "App Secondary Colour",
    "App Secondary Colour": "App Secondary Colour",
    "app_customization.android_app_icon": "App Icon Android",
    "App Icon Android": "App Icon Android",
    "app_customization.ios_app_icon": "App Icon iOS",
    "App Icon iOS": "App Icon iOS",
    "app_customization.screen_number": "Screen {number}",
    "Screen {number}": "Screen {number}",
    "app_customization.upload_here": "Upload here",
    "Upload here": "Upload here",
    "app_customization.next": "Next",
    "app_customization.get_started": "Get Start",
    "Get Start": "Get Start",
    "app_customization.select": "Select",
    "Select": "Select",
    "app_customization.app_title_home_icon": "App Title Home Icon",
    "App Title Home Icon": "App Title Home Icon",
    "app_customization.home_icon_hint": "(icon should be white and in png format)",
    "(icon should be white and in png format)": "(icon should be white and in png format)",
    "app_customization.home_title": "App title in home screen",
    "App title in home screen": "App title in home screen",
    "app_customization.default_collection_widgets": "Default Collection Widgets",
    "Default Collection Widgets": "Default Collection Widgets",
    "app_customization.accounts_follow_title": "Accounts to follow collection title",
    "Accounts to follow collection title": "Accounts to follow collection title",
    "app_customization.enter_accounts_follow_title": "Enter accounts to follow collection title",
    "Enter accounts to follow collection title": "Enter accounts to follow collection title",
    "app_customization.nearby_accounts_title": "Nearby accounts collection title",
    "Nearby accounts collection title": "Nearby accounts collection title",
    "app_customization.enter_nearby_accounts_title": "Enter near by accounts collection title",
    "Enter near by accounts collection title": "Enter near by accounts collection title",
    "app_customization.latest_listings_title": "Latest listings collection title",
    "Latest listings collection title": "Latest listings collection title",
    "app_customization.enter_latest_listings_title": "Enter latest listings collection title",
    "Enter latest listings collection title": "Enter latest listings collection title",
    "app_customization.enable_appearance_sections": "Select to enable appearance sections",
    "Select to enable appearance sections": "Select to enable appearance sections",
    "app_customization.choose_photo": "Choose photo",
    "Choose photo": "Choose photo",
    "app_customization.choose_icon": "Choose icon",
    "Choose icon": "Choose icon",
    "app_customization.enable_home_icon": "Enable app title icon instead of text",
    "Enable app title icon instead of text": "Enable app title icon instead of text",
    "app_customization.account_name": "Account Name",
    "Account Name": "Account Name",
    "app_customization.product_name": "Product Name",
    "Product Name": "Product Name",
    "app_customization.home_option_0": "Show nearby collection",
    "Show nearby collection": "Show nearby collection",
    "app_customization.home_option_1": "Show category section",
    "Show category section": "Show category section",
    "app_customization.home_option_2": "Show promo banners",
    "Show promo banners": "Show promo banners",
    "app_customization.home_option_3": "Show invite friends",
    "Show invite friends": "Show invite friends",
    "app_customization.home_option_4": "Show review reminders",
    "Show review reminders": "Show review reminders",
    "app_customization.home_option_5": "Accounts to follow",
    "Accounts to follow": "Accounts to follow",
    "app_customization.download": "Download",
    "app_customization.cancel": "Cancel",
    "app_customization.uploaded_successfully": "Uploaded successfully",
    "Uploaded successfully": "Uploaded successfully",
    "app_customization.image_limit": "You cannot select more images",
    "You cannot select more images": "You cannot select more images",
    "app_customization.choose_zip_file": "Choose zip file",
    "Choose zip file": "Choose zip file",
    "app_translation.title": "Strings Customisation",
    "app_translation.search": "Type to search...",
    "Type to search...": "Type to search...",
    "app_translation.default_language": "Default",
    "Default": "Default",
    "app_translation.default_text": "Default text",
    "Default text": "Default text",
    "communications.title": "Communications",
    "communications.tab_0": "Email Notification",
    "Email Notification": "Email Notification",
    "communications.tab_1": "Email Configuration",
    "Email Configuration": "Email Configuration",
    "communications.tab_2": "Order Notification",
    "Order Notification": "Order Notification",
    "communications.tab_3": "Feedback Form",
    "Feedback Form": "Feedback Form",
    "communications.translate": "Translate",
    "Translate": "Translate",
    "communications.edit_email_template": "Edit email template",
    "Edit email template": "Edit email template",
    "communications.feedback_email": "Email",
    "communications.feedback_phone": "Phone",
    "communications.feedback_email_or_phone": "Email or Phone",
    "Email or Phone": "Email or Phone",
    "communications.select_type": "Select type",
    "Select type": "Select type",
    "communications.form_required_field": "Form Required Field",
    "Form Required Field": "Form Required Field",
    "communications.feedback_recipient_label": "Email to receive feedback (For more than one email, enter as comma separated)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Email to receive feedback (For more than one email, enter as comma separated)",
    "communications.enter_email": "Enter email",
    "Enter email": "Enter email",
    "communications.enable_feedback_form": "Enable feedback Form",
    "Enable feedback Form": "Enable feedback Form",
    "communications.feedback": "Feedback",
    "Feedback": "Feedback",
    "communications.realtime_config_notice": "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.",
    "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.": "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.",
    "communications.uploaded_successfully": "Uploaded successfully",
    "communications.email_whitelabeling": "Email Whitelabelling",
    "Email Whitelabelling": "Email Whitelabelling",
    "communications.from_name": "From name",
    "From name": "From name",
    "communications.enter_from_name": "Enter from name",
    "Enter from name": "Enter from name",
    "communications.from_email_address": "From email address",
    "From email address": "From email address",
    "communications.from_email_domain_hint": "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.",
    "communications.reset": "Reset",
    "communications.enter_from_email": "Enter from email address",
    "Enter from email address": "Enter from email address",
    "communications.email_header_logo": "Email Header Logo",
    "Email Header Logo": "Email Header Logo",
    "communications.choose_logo": "Choose file 50*50",
    "Choose file 50*50": "Choose file 50*50",
    "communications.list_view": "List view",
    "communications.gallery_view": "Gallery view",
    "Gallery view": "Gallery view",
    "communications.grid_view": "Grid view",
    "communications.search": "Search communications",
    "Search communications": "Search communications",
    "communications.email_settings": "Email settings",
    "Email settings": "Email settings",
    "communications.category_all": "All",
    "communications.category_buyer": "Buyer",
    "Buyer": "Buyer",
    "communications.category_seller": "Seller",
    "communications.category_transactional": "Transactional",
    "Transactional": "Transactional",
    "communications.category_engagement": "Engagement",
    "Engagement": "Engagement",
    "communications.category_retention": "Retention",
    "Retention": "Retention",
    "communications.category_membership": "Membership",
    "communications.audience_buyer": "Buyer",
    "communications.audience_seller": "Seller",
    "communications.system_notification": "System notification",
    "System notification": "System notification",
    "communications.template": "template",
    "template": "template",
    "communications.edit": "Edit",
    "communications.sent": "sent",
    "sent": "sent",
    "communications.open": "open",
    "open": "open",
    "communications.clicks": "clicks",
    "clicks": "clicks",
    "communications.no_email_matches": "No emails match your filter.",
    "No emails match your filter.": "No emails match your filter.",
    "communications.buyer_order_confirmation": "Order confirmation email for buyer",
    "Order confirmation email for buyer": "Order confirmation email for buyer",
    "communications.seller_order_confirmation": "Order confirmation email for seller",
    "Order confirmation email for seller": "Order confirmation email for seller",
    "communications.email_card_0": "Welcome Message",
    "Welcome Message": "Welcome Message",
    "communications.email_card_1": "OTP / Verification",
    "OTP / Verification": "OTP / Verification",
    "communications.email_card_2": "Subscription Link",
    "Subscription Link": "Subscription Link",
    "communications.email_card_3": "Subscription Success",
    "Subscription Success": "Subscription Success",
    "communications.email_card_4": "Order confirmation — buyer",
    "Order confirmation — buyer": "Order confirmation — buyer",
    "communications.email_card_5": "Order confirmation — seller",
    "Order confirmation — seller": "Order confirmation — seller",
    "communications.email_card_6": "Shipment shipped — buyer",
    "Shipment shipped — buyer": "Shipment shipped — buyer",
    "communications.email_card_7": "Shipment delivered — buyer",
    "Shipment delivered — buyer": "Shipment delivered — buyer",
    "communications.email_card_8": "Order cancelled — buyer",
    "Order cancelled — buyer": "Order cancelled — buyer",
    "communications.email_card_9": "Refund processed — buyer",
    "Refund processed — buyer": "Refund processed — buyer",
    "communications.email_card_10": "New listing from followed store — buyer",
    "New listing from followed store — buyer": "New listing from followed store — buyer",
    "communications.email_card_11": "Back in stock — buyer",
    "Back in stock — buyer": "Back in stock — buyer",
    "communications.email_card_12": "Listing expiry warning — seller",
    "Listing expiry warning — seller": "Listing expiry warning — seller",
    "communications.email_card_13": "Listing likes milestone — seller",
    "Listing likes milestone — seller": "Listing likes milestone — seller",
    "communications.email_card_14": "Account verified — seller",
    "Account verified — seller": "Account verified — seller",
    "communications.email_card_15": "Seller win-back — seller",
    "Seller win-back — seller": "Seller win-back — seller",
    "communications.email_card_16": "Low stock warning — seller",
    "Low stock warning — seller": "Low stock warning — seller",
    "communications.email_card_17": "Seller onboarded — seller",
    "Seller onboarded — seller": "Seller onboarded — seller",
    "communications.email_card_18": "Review request — buyer",
    "Review request — buyer": "Review request — buyer",
    "communications.email_card_19": "First sale — seller",
    "First sale — seller": "First sale — seller",
    "communications.email_card_20": "Sales milestone — seller",
    "Sales milestone — seller": "Sales milestone — seller",
    "communications.email_card_21": "Win-back — buyer",
    "Win-back — buyer": "Win-back — buyer",
    "communications.email_card_22": "First purchase — buyer",
    "First purchase — buyer": "First purchase — buyer",
    "communications.email_card_23": "Customer question — seller",
    "Customer question — seller": "Customer question — seller",
    "communications.email_card_24": "Seller answer — buyer",
    "Seller answer — buyer": "Seller answer — buyer",
    "communications.email_card_25": "Negotiation offer — seller",
    "Negotiation offer — seller": "Negotiation offer — seller",
    "communications.email_card_26": "Offer accepted — buyer",
    "Offer accepted — buyer": "Offer accepted — buyer",
    "communications.email_card_27": "Offer rejected — buyer",
    "Offer rejected — buyer": "Offer rejected — buyer",
    "communications.email_card_28": "New follower — seller",
    "New follower — seller": "New follower — seller",
    "communications.email_card_29": "Listing liked — seller",
    "Listing liked — seller": "Listing liked — seller",
    "communications.email_card_30": "Listing approved — seller",
    "Listing approved — seller": "Listing approved — seller",
    "communications.email_card_31": "Listing rejected — seller",
    "Listing rejected — seller": "Listing rejected — seller",
    "communications.email_card_32": "First listing — seller",
    "First listing — seller": "First listing — seller",
    "communications.email_card_33": "Abandoned cart — buyer",
    "Abandoned cart — buyer": "Abandoned cart — buyer",
    "communications.email_card_34": "Listing review — seller",
    "Listing review — seller": "Listing review — seller",
    "communications.email_card_35": "Fulfillment reminder — seller",
    "Fulfillment reminder — seller": "Fulfillment reminder — seller",
    "communications.email_card_36": "Price drop — buyer",
    "Price drop — buyer": "Price drop — buyer",
    "communications.email_card_37": "Membership payment due soon",
    "Membership payment due soon": "Membership payment due soon",
    "communications.email_card_38": "Membership payment overdue",
    "Membership payment overdue": "Membership payment overdue",
    "communications.order_status_notification": "Order Status Notification",
    "Order Status Notification": "Order Status Notification",
    "communications.order_group_lifecycle": "Order lifecycle",
    "Order lifecycle": "Order lifecycle",
    "communications.order_group_returns": "Returns and delivery issues",
    "Returns and delivery issues": "Returns and delivery issues",
    "communications.order_group_cancellations": "Cancellations and pickup",
    "Cancellations and pickup": "Cancellations and pickup",
    "communications.notification_settings_count": "{count} notification settings",
    "{count} notification settings": "{count} notification settings",
    "communications.enter_order_field": "Enter {field}",
    "Enter {field}": "Enter {field}",
    "communications.order_field_0": "Order status confirmed",
    "Order status confirmed": "Order status confirmed",
    "communications.order_field_1": "Order status in progress",
    "Order status in progress": "Order status in progress",
    "communications.order_field_2": "Order status shipped",
    "Order status shipped": "Order status shipped",
    "communications.order_field_3": "Order status customer unreachable",
    "Order status customer unreachable": "Order status customer unreachable",
    "communications.order_field_4": "Order status out for delivery",
    "Order status out for delivery": "Order status out for delivery",
    "communications.order_field_5": "Order status undelivered returned",
    "Order status undelivered returned": "Order status undelivered returned",
    "communications.order_field_6": "Order status undelivered return confirmed",
    "Order status undelivered return confirmed": "Order status undelivered return confirmed",
    "communications.order_field_7": "Order status delivered",
    "Order status delivered": "Order status delivered",
    "communications.order_field_8": "Order status delivered confirmed",
    "Order status delivered confirmed": "Order status delivered confirmed",
    "communications.order_field_9": "Order status customer return initiated",
    "Order status customer return initiated": "Order status customer return initiated",
    "communications.order_field_10": "Order status customer return picked",
    "Order status customer return picked": "Order status customer return picked",
    "communications.order_field_11": "Order status customer return confirmed",
    "Order status customer return confirmed": "Order status customer return confirmed",
    "communications.order_field_12": "Order status customer return disputed",
    "Order status customer return disputed": "Order status customer return disputed",
    "communications.order_field_13": "Order status cancelled by account",
    "Order status cancelled by account": "Order status cancelled by account",
    "communications.order_field_14": "Order status cancelled by customer",
    "Order status cancelled by customer": "Order status cancelled by customer",
    "communications.order_field_15": "Order status ready for pickup",
    "Order status ready for pickup": "Order status ready for pickup",
    "communications.order_field_16": "Order status completed",
    "Order status completed": "Order status completed",
    "communications.update": "Update",
    "communications.download_template": "Download Template",
    "Download Template": "Download Template",
    "communications.reset_to_default": "Reset to default",
    "Reset to default": "Reset to default",
    "communications.send_test_email": "Send test email",
    "Send test email": "Send test email",
    "communications.enter_test_emails": "Enter email(s), comma-separated",
    "Enter email(s), comma-separated": "Enter email(s), comma-separated",
    "communications.send_test": "Send test",
    "Send test": "Send test",
    "communications.subject_required": "Subject should not be empty",
    "Subject should not be empty": "Subject should not be empty",
    "communications.body_required": "Body should not be empty",
    "Body should not be empty": "Body should not be empty",
    "communications.code_merge_tag_required": "{code} merge tag is mandatory",
    "{code} merge tag is mandatory": "{code} merge tag is mandatory",
    "communications.edit_template_named": "Edit {name}",
    "Edit {name}": "Edit {name}",
    "communications.subject": "Subject",
    "Subject": "Subject",
    "communications.enter_subject": "Enter the Subject",
    "Enter the Subject": "Enter the Subject",
    "communications.available_merge_tags": "Available merge tags:",
    "Available merge tags:": "Available merge tags:",
    "communications.body": "Body",
    "Body": "Body",
    "communications.write_here": "Write here...",
    "Write here...": "Write here...",
    "communications.subject_line": "Subject Line",
    "Subject Line": "Subject Line",
    "communications.enter_subject_line": "Enter the subject…",
    "Enter the subject…": "Enter the subject…",
    "communications.merge_tags": "Merge tags",
    "Merge tags": "Merge tags",
    "communications.loading_templates": "Loading templates…",
    "Loading templates…": "Loading templates…",
    "communications.hide_templates": "Hide templates",
    "Hide templates": "Hide templates",
    "communications.load_template": "Load template",
    "Load template": "Load template",
    "communications.html_body": "HTML Body",
    "HTML Body": "HTML Body",
    "communications.enter_html_body": "Paste or type your HTML here…",
    "Paste or type your HTML here…": "Paste or type your HTML here…",
    "communications.live_preview": "Live Preview",
    "Live Preview": "Live Preview",
    "communications.desktop": "Desktop",
    "Desktop": "Desktop",
    "communications.mobile": "Mobile",
    "communications.email_preview": "Email preview",
    "Email preview": "Email preview",
    "communications.start_typing_preview": "Start typing to see a preview",
    "Start typing to see a preview": "Start typing to see a preview",
    "communications.translations": "translations",
    "translations": "translations",
    "communications.validation_account_follow_tag": "Account follow notification should contain {account_name}",
    "communications.validation_listing_like_tag": "Listing follow notification should contain {user_name}",
    "Listing follow notification should contain {user_name}": "Listing follow notification should contain {user_name}",
    "communications.validation_order_number_tag": "Order status follow notification should contain #{order_number}",
    "Order status follow notification should contain #{order_number}": "Order status follow notification should contain #{order_number}",
    "communications.validation_order_status_tag": "Order status follow notification should contain {order_status}",
    "Order status follow notification should contain {order_status}": "Order status follow notification should contain {order_status}",
    "communications.journey_title": "Email Journey Map",
    "Email Journey Map": "Email Journey Map",
    "communications.journey_subtitle": "Where each email fires in the user lifecycle",
    "Where each email fires in the user lifecycle": "Where each email fires in the user lifecycle",
    "communications.journey_buyer": "Buyer Journey",
    "Buyer Journey": "Buyer Journey",
    "communications.journey_seller": "Seller Journey",
    "Seller Journey": "Seller Journey",
    "communications.journey_buyer_stage_0": "Sign Up",
    "Sign Up": "Sign Up",
    "communications.journey_buyer_stage_1": "Browse",
    "Browse": "Browse",
    "communications.journey_buyer_stage_2": "Cart",
    "Cart": "Cart",
    "communications.journey_buyer_stage_3": "Order Placed",
    "Order Placed": "Order Placed",
    "communications.journey_buyer_stage_4": "Shipped",
    "communications.journey_buyer_stage_5": "Delivered",
    "communications.journey_buyer_stage_6": "Negotiate",
    "Negotiate": "Negotiate",
    "communications.journey_buyer_stage_7": "Inactive",
    "communications.journey_seller_stage_0": "Onboard",
    "Onboard": "Onboard",
    "communications.journey_seller_stage_1": "List",
    "communications.journey_seller_stage_2": "Manage",
    "Manage": "Manage",
    "communications.journey_seller_stage_3": "Order In",
    "Order In": "Order In",
    "communications.journey_seller_stage_4": "Ship",
    "communications.journey_seller_stage_5": "Complete",
    "Complete": "Complete",
    "communications.journey_seller_stage_6": "Inactive",
    "accounts.title": "Accounts",
    "accounts.status_pending": "Pending",
    "accounts.status_approved": "Approved",
    "accounts.status_rejected": "Rejected",
    "accounts.show_rows": "Show rows",
    "accounts.next": "Next",
    "accounts.previous": "Previous",
    "accounts.view_list": "List",
    "accounts.view_map": "Map",
    "Map": "Map",
    "accounts.view_board": "Board",
    "accounts.view_grid": "Grid",
    "accounts.view_list_accessibility": "List view",
    "accounts.view_map_accessibility": "Map view",
    "Map view": "Map view",
    "accounts.view_board_accessibility": "Board view",
    "Board view": "Board view",
    "accounts.view_grid_accessibility": "Grid view",
    "accounts.column_name": "Name",
    "accounts.column_account_id": "Account ID",
    "Account ID": "Account ID",
    "accounts.column_description": "Description",
    "accounts.column_image": "Image",
    "accounts.column_user_name": "User Name",
    "User Name": "User Name",
    "accounts.column_email": "Email",
    "accounts.column_status": "Status",
    "accounts.column_account_status": "Account Status",
    "Account Status": "Account Status",
    "accounts.column_location": "Location",
    "accounts.search": "Search accounts",
    "Search accounts": "Search accounts",
    "accounts.export": "Export",
    "accounts.import": "Import",
    "accounts.export_accounts": "Export accounts",
    "Export accounts": "Export accounts",
    "accounts.import_accounts": "Import accounts",
    "Import accounts": "Import accounts",
    "accounts.smart_upload_accounts": "Smart Upload accounts",
    "Smart Upload accounts": "Smart Upload accounts",
    "accounts.export_all_question": "Export all accounts?",
    "Export all accounts?": "Export all accounts?",
    "accounts.export_all_description": "This will prepare a file containing all accounts. You can review this workflow before upgrading.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "This will prepare a file containing all accounts. You can review this workflow before upgrading.",
    "accounts.export_all": "Export all accounts",
    "Export all accounts": "Export all accounts",
    "accounts.cancel": "Cancel",
    "accounts.active": "Active",
    "accounts.inactive": "Inactive",
    "accounts.not_available": "N/A",
    "accounts.approve": "Approve",
    "accounts.reject": "Reject",
    "accounts.manage": "Manage",
    "accounts.tooltip_title": "Accounts are like shops.",
    "Accounts are like shops.": "Accounts are like shops.",
    "accounts.tooltip_description": "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.",
    "accounts.create_account": "Create Account",
    "Create Account": "Create Account",
    "accounts.create_new_account": "Create New Account",
    "Create New Account": "Create New Account",
    "accounts.save": "Save",
    "accounts.please_wait": "Please wait...",
    "Please wait...": "Please wait...",
    "accounts.account_name": "Account Name",
    "accounts.slug": "Slug",
    "Slug": "Slug",
    "accounts.account_slug": "Account Slug",
    "Account Slug": "Account Slug",
    "accounts.account_description": "Account Description",
    "Account Description": "Account Description",
    "accounts.enter_name_first": "Please enter a title first",
    "Please enter a title first": "Please enter a title first",
    "accounts.user": "User",
    "accounts.select_user": "Select user",
    "accounts.category": "Category",
    "Category": "Category",
    "accounts.select_type": "Select Type",
    "Select Type": "Select Type",
    "accounts.smart_upload_title": "Smart account upload",
    "Smart account upload": "Smart account upload",
    "accounts.start_over": "Start over",
    "accounts.smart_upload_description": "Upload accounts and match your CSV columns to account fields.",
    "Upload accounts and match your CSV columns to account fields.": "Upload accounts and match your CSV columns to account fields.",
    "accounts.smart_upload_step_0": "Upload",
    "accounts.smart_upload_step_1": "Match columns",
    "accounts.smart_upload_step_2": "Review",
    "accounts.smart_upload_step_3": "Import",
    "accounts.choose_csv": "Choose a CSV file",
    "accounts.smart_upload_required_note": "Name is required. Address, slug, category, owner, and coordinates are optional.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Name is required. Address, slug, category, owner, and coordinates are optional.",
    "accounts.select_csv": "Select CSV file",
    "accounts.match_columns": "Match account columns",
    "Match account columns": "Match account columns",
    "accounts.import_field_name": "Name",
    "accounts.import_field_description": "Description",
    "accounts.import_field_slug": "Slug",
    "accounts.import_field_category_id": "Category ID",
    "Category ID": "Category ID",
    "accounts.import_field_user_id": "Owner User ID",
    "Owner User ID": "Owner User ID",
    "accounts.import_field_location": "Address",
    "accounts.import_field_latitude": "Latitude",
    "Latitude": "Latitude",
    "accounts.import_field_longitude": "Longitude",
    "Longitude": "Longitude",
    "accounts.do_not_import": "Do not import",
    "accounts.review_import": "Review import",
    "accounts.import_count": "{count} accounts will be imported.",
    "{count} accounts will be imported.": "{count} accounts will be imported.",
    "accounts.smart_upload_complete": "Smart Upload complete",
    "Smart Upload complete": "Smart Upload complete",
    "accounts.imported_count": "{imported} of {total} accounts imported.",
    "{imported} of {total} accounts imported.": "{imported} of {total} accounts imported.",
    "accounts.selected_file": "Selected: {filename}",
    "Selected: {filename}": "Selected: {filename}",
    "accounts.review": "Review",
    "accounts.importing": "Importing…",
    "accounts.uploading": "Uploading...",
    "accounts.download": "Download",
    "accounts.file_label": "File:",
    "accounts.select_file": "Select File",
    "accounts.upload": "Upload",
    "accounts.download_template": "Download {type} template",
    "Download {type} template": "Download {type} template",
    "accounts.import_stage_prepare": "Preparing import file",
    "Preparing import file": "Preparing import file",
    "accounts.import_prepare_failed": "Could not prepare the import file.",
    "accounts.import_stage_upload": "Uploading import file",
    "accounts.import_upload_failed": "The import file could not be uploaded.",
    "accounts.import_stage_server": "Tradly is importing accounts",
    "Tradly is importing accounts": "Tradly is importing accounts",
    "accounts.import_stage_complete": "Import complete",
    "Import complete": "Import complete",
    "accounts.import_stage_stopped": "Import stopped",
    "accounts.confirm_approve": "Approve this account?",
    "Approve this account?": "Approve this account?",
    "accounts.confirm_reject": "Reject this account?",
    "Reject this account?": "Reject this account?",
    "accounts.name_required": "Name is required",
    "Name is required": "Name is required",
    "accounts.user_required": "User is required",
    "User is required": "User is required",
    "accounts.attribute_required": "{attribute} is required",
    "{attribute} is required": "{attribute} is required",
    "accounts.overview": "Account Overview",
    "Account Overview": "Account Overview",
    "accounts.section_listings": "Listings",
    "accounts.loading": "Loading…",
    "accounts.no_listings_owned": "No listings yet",
    "No listings yet": "No listings yet",
    "accounts.page_analytics": "Page Analytics",
    "Page Analytics": "Page Analytics",
    "accounts.analytics_key_missing": "Analytics API key not configured for this tenant.",
    "Analytics API key not configured for this tenant.": "Analytics API key not configured for this tenant.",
    "accounts.storefront_url_missing": "No storefront URL available for this account.",
    "No storefront URL available for this account.": "No storefront URL available for this account.",
    "accounts.no_analytics_loaded": "No analytics loaded yet.",
    "No analytics loaded yet.": "No analytics loaded yet.",
    "accounts.load_analytics": "Load Analytics",
    "Load Analytics": "Load Analytics",
    "accounts.attributes": "Attributes",
    "accounts.shipping": "Shipping",
    "accounts.commission": "Commission",
    "Commission": "Commission",
    "accounts.detail_title": "Title",
    "accounts.detail_description": "Description",
    "accounts.detail_descriptions": "Descriptions",
    "Descriptions": "Descriptions",
    "accounts.detail_listings": "Listings",
    "accounts.detail_categories": "Categories",
    "accounts.detail_location": "Location",
    "accounts.detail_account_status": "Account Status",
    "accounts.detail_status": "Status",
    "accounts.detail_shipping_method": "Shipping Method",
    "accounts.detail_shipping_methods": "Shipping Methods",
    "Shipping Methods": "Shipping Methods",
    "accounts.detail_account_user": "Account User",
    "Account User": "Account User",
    "accounts.detail_pending": "Pending",
    "accounts.detail_approved": "Approved",
    "accounts.detail_rejected": "Rejected",
    "accounts.detail_active": "Active",
    "accounts.detail_inactive": "Inactive",
    "accounts.detail_joined": "Joined",
    "Joined": "Joined",
    "accounts.detail_account_age": "Account Age",
    "Account Age": "Account Age",
    "accounts.detail_less_than_a_month": "Less than a month",
    "Less than a month": "Less than a month",
    "accounts.detail_page_views": "Page Views",
    "Page Views": "Page Views",
    "accounts.detail_unique_visitors": "Unique Visitors",
    "Unique Visitors": "Unique Visitors",
    "accounts.detail_sessions": "Sessions",
    "Sessions": "Sessions",
    "accounts.detail_clicks": "Clicks",
    "Clicks": "Clicks",
    "accounts.detail_goals": "Goals",
    "Goals": "Goals",
    "accounts.detail_bot_views": "Bot Views",
    "Bot Views": "Bot Views",
    "accounts.detail_followers": "Followers",
    "Followers": "Followers",
    "accounts.detail_total_orders": "Total Orders",
    "accounts.detail_revenue": "Revenue",
    "accounts.detail_avg_order": "Avg Order",
    "Avg Order": "Avg Order",
    "accounts.detail_paid_orders": "Paid Orders",
    "Paid Orders": "Paid Orders",
    "accounts.detail_owner": "Owner",
    "Owner": "Owner",
    "accounts.detail_account_id": "Account ID",
    "accounts.detail_category": "Category",
    "accounts.detail_profile_completeness": "Profile Completeness",
    "Profile Completeness": "Profile Completeness",
    "accounts.detail_total_listings": "Total Listings",
    "Total Listings": "Total Listings",
    "accounts.detail_loaded_listings": "Loaded Listings",
    "Loaded Listings": "Loaded Listings",
    "accounts.detail_active_listings": "Active Listings",
    "Active Listings": "Active Listings",
    "accounts.detail_last_updated": "Last Updated",
    "Last Updated": "Last Updated",
    "accounts.detail_last_activity": "Last Activity",
    "Last Activity": "Last Activity",
    "accounts.detail_verification": "Verification",
    "Verification": "Verification",
    "accounts.detail_subscription": "Subscription",
    "accounts.detail_attributes": "Attributes",
    "accounts.detail_shipping_charge_split": "Shipping Charge Split",
    "Shipping Charge Split": "Shipping Charge Split",
    "accounts.detail_value_type": "Value Type",
    "Value Type": "Value Type",
    "accounts.detail_value": "Value",
    "accounts.detail_enter_value": "Enter Value",
    "Enter Value": "Enter Value",
    "accounts.detail_commission_percentage": "Commission Percentage",
    "Commission Percentage": "Commission Percentage",
    "accounts.detail_commission_percent": "Commission Percent",
    "Commission Percent": "Commission Percent",
    "accounts.detail_share": "Share",
    "accounts.detail_view_account": "View Account",
    "View Account": "View Account",
    "accounts.detail_add_listing": "Add Listing",
    "Add Listing": "Add Listing",
    "accounts.detail_edit_account": "Edit Account",
    "Edit Account": "Edit Account",
    "accounts.no_attribute_values": "No attribute values for {name}",
    "No attribute values for {name}": "No attribute values for {name}",
    "accounts.no_attributes_yet": "No attributes yet",
    "No attributes yet": "No attributes yet",
    "accounts.edit_account": "Edit Account",
    "accounts.detail_preview": "Preview",
    "accounts.detail_fixed": "Fixed",
    "Fixed": "Fixed",
    "accounts.detail_percentage": "Percentage",
    "Percentage": "Percentage",
    "accounts.detail_select_value_type": "Select Value Type",
    "Select Value Type": "Select Value Type",
    "accounts.detail_approve": "Approve",
    "accounts.detail_reject": "Reject",
    "accounts.detail_section": "Details",
    "Details": "Details",
    "category.add_child": "Add Child Category",
    "Add Child Category": "Add Child Category",
    "category.add_listing": "Add Listing",
    "category.manage": "Manage Categories",
    "Manage Categories": "Manage Categories",
    "category.account_overview_eyebrow": "ACCOUNT CATEGORY OVERVIEW",
    "ACCOUNT CATEGORY OVERVIEW": "ACCOUNT CATEGORY OVERVIEW",
    "category.overview_eyebrow": "CATEGORY OVERVIEW",
    "CATEGORY OVERVIEW": "CATEGORY OVERVIEW",
    "category.category": "Category",
    "category.active": "Active",
    "category.inactive": "Inactive",
    "category.accounts": "Accounts",
    "category.listings": "Listings",
    "category.child_categories": "Child Categories",
    "Child Categories": "Child Categories",
    "category.attributes": "Attributes",
    "category.category_age": "Category age",
    "Category age": "Category age",
    "category.category_overview": "Category Overview",
    "Category Overview": "Category Overview",
    "category.category_id": "Category ID",
    "category.name": "Name",
    "category.slug": "Slug",
    "category.description": "Description",
    "category.parent_category": "Parent Category",
    "Parent Category": "Parent Category",
    "category.hierarchy": "Hierarchy",
    "Hierarchy": "Hierarchy",
    "category.status": "Status",
    "category.display_order": "Display Order",
    "Display Order": "Display Order",
    "category.created": "Joined / Created",
    "Joined / Created": "Joined / Created",
    "category.configured": "Configured",
    "Configured": "Configured",
    "category.no_attributes": "No attributes assigned.",
    "No attributes assigned.": "No attributes assigned.",
    "category.no_child_categories": "No child categories.",
    "No child categories.": "No child categories.",
    "category.no_accounts": "No accounts in this category.",
    "No accounts in this category.": "No accounts in this category.",
    "category.no_listings": "No listings in this category.",
    "No listings in this category.": "No listings in this category.",
    "category.detail_title": "Category Detail",
    "Category Detail": "Category Detail",
    "category.age_less_month": "Less than a month",
    "category.age_month": "{count} month",
    "{count} month": "{count} month",
    "category.age_months": "{count} months",
    "{count} months": "{count} months",
    "category.age_year": "{count} year",
    "{count} year": "{count} year",
    "category.age_years": "{count} years",
    "{count} years": "{count} years",
    "category.header_name": "Name",
    "category.header_category_id": "Category ID",
    "category.header_image": "Image",
    "category.header_order": "Order",
    "category.header_parent": "Parent",
    "Parent": "Parent",
    "category.header_active": "Active",
    "category.header_action": "Action",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Categories",
    "category.translate": "Translate",
    "category.import": "Import",
    "category.export": "Export",
    "category.add_category": "Add Category",
    "Add Category": "Add Category",
    "category.import_categories": "Import Categories",
    "Import Categories": "Import Categories",
    "category.delete_warning": "Existing listings will not open in website or app, you will see an error.",
    "Existing listings will not open in website or app, you will see an error.": "Existing listings will not open in website or app, you will see an error.",
    "category.editor_edit_category": "Edit Category",
    "Edit Category": "Edit Category",
    "category.editor_add_category": "Add Category",
    "category.editor_save": "Save",
    "category.editor_select_category_level": "Select Category Level",
    "Select Category Level": "Select Category Level",
    "category.editor_parent_category": "Parent Category",
    "category.editor_select": "Select",
    "category.editor_category_name": "Category Name",
    "Category Name": "Category Name",
    "category.editor_enter_category_name": "Enter category name",
    "Enter category name": "Enter category name",
    "category.editor_slug": "Slug",
    "category.editor_enter_slug": "Enter slug",
    "Enter slug": "Enter slug",
    "category.editor_category_description": "Category Description",
    "Category Description": "Category Description",
    "category.editor_order": "Order",
    "category.editor_enter_order": "Enter order",
    "Enter order": "Enter order",
    "category.editor_status_not_active_active": "Status (Not Active / Active)",
    "Status (Not Active / Active)": "Status (Not Active / Active)",
    "category.editor_upload_media": "Upload Media",
    "category.editor_meta_title": "Meta Title",
    "Meta Title": "Meta Title",
    "category.editor_enter_meta_title": "Enter meta title",
    "Enter meta title": "Enter meta title",
    "category.editor_meta_description": "Meta Description",
    "Meta Description": "Meta Description",
    "category.editor_category": "Category",
    "category.editor_name": "Name",
    "category.editor_status": "Status",
    "category.editor_action": "Action",
    "category.editor_add_attribute": "Add Attribute",
    "Add Attribute": "Add Attribute",
    "category.editor_attributes_list": "Attributes List",
    "Attributes List": "Attributes List",
    "category.editor_please_enter_a_category_name_first": "Please enter a category name first",
    "Please enter a category name first": "Please enter a category name first",
    "category.editor_successfully_added_category": "Successfully added category",
    "Successfully added category": "Successfully added category",
    "category.deleted": "Category deleted",
    "Category deleted": "Category deleted",
    "attributes.title": "Attributes",
    "attributes.cart_checkout": "Cart & Checkout",
    "Cart & Checkout": "Cart & Checkout",
    "attributes.cart_settings": "Cart settings",
    "Cart settings": "Cart settings",
    "attributes.order_status_notifications": "Order status notifications",
    "Order status notifications": "Order status notifications",
    "attributes.groups": "Attribute Groups",
    "Attribute Groups": "Attribute Groups",
    "attributes.add_attribute": "Add Attribute",
    "attributes.edit_bulk": "Edit Bulk",
    "Edit Bulk": "Edit Bulk",
    "attributes.confirm_delete": "Do you want to delete this attribute?",
    "Do you want to delete this attribute?": "Do you want to delete this attribute?",
    "attributes.header_attribute_name": "Attribute Name",
    "Attribute Name": "Attribute Name",
    "attributes.header_action": "Action",
    "attributes.header_manage_attribute_values": "Manage Attribute Values",
    "Manage Attribute Values": "Manage Attribute Values",
    "attributes.header_type": "Type",
    "attributes.header_optional": "Optional",
    "attributes.header_icon": "Icon",
    "Icon": "Icon",
    "attributes.header_categories": "Categories",
    "attributes.header_hidden_field": "Hidden Field",
    "Hidden Field": "Hidden Field",
    "attributes.header_values": "Values",
    "Values": "Values",
    "attributes.header_status": "Status",
    "attributes.type_single_select": "Single Select",
    "Single Select": "Single Select",
    "attributes.type_multi_select": "Multi Select",
    "Multi Select": "Multi Select",
    "attributes.type_open_single_value": "Open (Single Value)",
    "Open (Single Value)": "Open (Single Value)",
    "attributes.type_open_multiple_value": "Open (Multiple Value)",
    "Open (Multiple Value)": "Open (Multiple Value)",
    "attributes.type_attachment": "Attachment",
    "Attachment": "Attachment",
    "attributes.type_text_area": "Text Area",
    "Text Area": "Text Area",
    "attributes.type_date_time": "Date Time",
    "Date Time": "Date Time",
    "attributes.type_number": "Number",
    "attributes.type_boolean": "Boolean",
    "Boolean": "Boolean",
    "attributes.type_color": "Color",
    "Color": "Color",
    "attributes.type_json": "Json",
    "Json": "Json",
    "attributes.type_location": "Location",
    "attributes.type_audio": "Audio",
    "Audio": "Audio",
    "attributes.type_video": "Video",
    "Video": "Video",
    "attributes.type_open_multi_value": "Open (Multi Value)",
    "Open (Multi Value)": "Open (Multi Value)",
    "attributes.editor_edit_attribute": "Edit Attribute",
    "Edit Attribute": "Edit Attribute",
    "attributes.editor_add_attribute": "Add Attribute",
    "attributes.editor_attribute_name": "Attribute name",
    "attributes.editor_select_type": "Select type",
    "attributes.prefill_user": "User",
    "common.search_placeholder": "Type to search...",
    "attributes.prefill_accounts": "Accounts",
    "attributes.prefill_listings": "Listings",
    "listings.detail_nav_gallery": "Gallery",
    "Gallery": "Gallery",
    "listings.detail_nav_details": "Details",
    "listings.detail_nav_inventory": "Inventory",
    "listings.detail_nav_social": "Social",
    "Social": "Social",
    "listings.detail_nav_orders": "Orders",
    "listings.detail_nav_analytics": "Analytics",
    "listings.detail_nav_schedule": "Schedule",
    "listings.detail_nav_rental": "Rental",
    "Rental": "Rental",
    "listings.detail_nav_attributes": "Attributes",
    "listings.detail_nav_seller": "Seller",
    "attributes.editor_icon": "Icon",
    "attributes.editor_tool_tip": "Tool tip",
    "Tool tip": "Tool tip",
    "attributes.editor_enter_attribute_name": "Enter attribute name",
    "Enter attribute name": "Enter attribute name",
    "attributes.editor_enter_attribute_tool_tip": "Enter attribute tool tip",
    "Enter attribute tool tip": "Enter attribute tool tip",
    "attributes.editor_optional": "Optional",
    "attributes.editor_private": "Private",
    "Private": "Private",
    "attributes.editor_hidden_field": "Hidden field",
    "Hidden field": "Hidden field",
    "attributes.editor_show_in_filter": "Show in filter",
    "Show in filter": "Show in filter",
    "attributes.editor_status_not_active_active": "Status (Not Active / Active)",
    "attributes.editor_add_meta_data": "Add meta data",
    "Add meta data": "Add meta data",
    "attributes.editor_select": "Select",
    "attributes.editor_select_category": "Select category",
    "Select category": "Select category",
    "attributes.editor_select_all": "Select All",
    "Select All": "Select All",
    "attributes.editor_unselect_all": "UnSelect All",
    "UnSelect All": "UnSelect All",
    "attributes.editor_create_categories_in_this_configuration_first": "Create categories in this configuration first",
    "Create categories in this configuration first": "Create categories in this configuration first",
    "attributes.editor_please_enter_attribute_name": "Please enter attribute name",
    "Please enter attribute name": "Please enter attribute name",
    "attributes.editor_please_select_type": "Please select type",
    "Please select type": "Please select type",
    "attributes.editor_select_single_attribute_values": "Select Single Attribute Values",
    "Select Single Attribute Values": "Select Single Attribute Values",
    "attributes.editor_select_multiple_attribute_values": "Select Multiple Attribute Values",
    "Select Multiple Attribute Values": "Select Multiple Attribute Values",
    "attributes.editor_enter_value": "Enter Value",
    "attributes.editor_enter_multiple_tag": "Enter Multiple Tag",
    "Enter Multiple Tag": "Enter Multiple Tag",
    "attributes.editor_upload_file": "Upload file",
    "Upload file": "Upload file",
    "attributes.editor_enter_text": "Enter Text",
    "Enter Text": "Enter Text",
    "attributes.editor_select_date": "Select Date",
    "attributes.editor_enter_number": "Enter Number",
    "Enter Number": "Enter Number",
    "attributes.editor_select_color": "Select Color",
    "Select Color": "Select Color",
    "attributes.editor_upload_json": "Upload Json",
    "Upload Json": "Upload Json",
    "attributes.editor_select_location": "Select Location",
    "Select Location": "Select Location",
    "attributes.editor_category": "Category",
    "attributes.editor_price": "Price",
    "attributes.editor_enter_price": "Enter Price",
    "Enter Price": "Enter Price",
    "attributes.editor_preview": "Preview",
    "attributes.editor_title": "Title",
    "attributes.editor_enter_title": "Enter Title",
    "Enter Title": "Enter Title",
    "attributes.editor_description": "Description",
    "attributes.editor_add_listing": "Add Listing",
    "attributes.editor_add_account": "Add Account",
    "Add Account": "Add Account",
    "attributes.editor_successfully_added_attributes": "Successfully added attributes",
    "Successfully added attributes": "Successfully added attributes",
    "attributes.editor_add_attribute_values": "Add Attribute Values",
    "Add Attribute Values": "Add Attribute Values",
    "common.image": "Image",
    "common.please_wait": "Please wait...",
    "attribute_groups.title": "Attribute Groups",
    "attribute_groups.title_singular": "Attribute Group",
    "Attribute Group": "Attribute Group",
    "attribute_groups.add": "Add Attribute Group",
    "Add Attribute Group": "Add Attribute Group",
    "attribute_groups.image_path": "Image Path",
    "Image Path": "Image Path",
    "attribute_groups.name_placeholder": "Group Name",
    "Group Name": "Group Name",
    "attribute_groups.select_attributes": "Select Attributes",
    "Select Attributes": "Select Attributes",
    "attribute_groups.select_attributes_placeholder": "Select Attributes...",
    "Select Attributes...": "Select Attributes...",
    "attribute_groups.added_successfully": "Attribute Group Added Successfully",
    "Attribute Group Added Successfully": "Attribute Group Added Successfully",
    "attribute_groups.deleted_successfully": "Deleted successfully",
    "Deleted successfully": "Deleted successfully",
    "attribute_groups.name_required": "Name is required",
    "attribute_groups.save_attributes_failed": "The group was saved, but its attributes could not be assigned.",
    "The group was saved, but its attributes could not be assigned.": "The group was saved, but its attributes could not be assigned.",
    "attributes.editor_enter_description": "Enter Description",
    "Enter Description": "Enter Description",
    "account_config.title": "Account Configuration",
    "account_config.account_detail_note": "Account detail note",
    "Account detail note": "Account detail note",
    "account_config.enter_account_detail_note": "Enter account detail note",
    "Enter account detail note": "Enter account detail note",
    "account_config.address_label": "Address label",
    "Address label": "Address label",
    "account_config.enter_address_label": "Enter address label",
    "Enter address label": "Enter address label",
    "account_config.category_label": "Category label",
    "Category label": "Category label",
    "account_config.enter_category_label": "Enter category label",
    "Enter category label": "Enter category label",
    "account_config.nearby_accounts_radius_km": "Nearby accounts radius (km)",
    "Nearby accounts radius (km)": "Nearby accounts radius (km)",
    "account_config.nearby_accounts_radius_placeholder": "Account nearby radius in km",
    "Account nearby radius in km": "Account nearby radius in km",
    "account_config.account_limit": "Account Limit",
    "Account Limit": "Account Limit",
    "account_config.account_limit_placeholder": "Account limit",
    "Account limit": "Account limit",
    "account_config.shipping_preference_note": "Shipping method preference note",
    "Shipping method preference note": "Shipping method preference note",
    "account_config.option_accounts_auto_approved": "Accounts auto approved",
    "Accounts auto approved": "Accounts auto approved",
    "account_config.option_shipping_methods_preference_for_accounts": "Shipping methods preference for accounts",
    "Shipping methods preference for accounts": "Shipping methods preference for accounts",
    "account_config.option_account_map_location_selector": "Account map location selector",
    "Account map location selector": "Account map location selector",
    "account_config.option_account_geo_location": "Account Geo Location",
    "Account Geo Location": "Account Geo Location",
    "account_config.option_slug": "Slug",
    "account_config.option_show_description": "Show Description",
    "Show Description": "Show Description",
    "account_config.option_formatted_text_description": "Formatted Text Description",
    "Formatted Text Description": "Formatted Text Description",
    "account_config.option_hide_address_from_account_detail": "Hide Address from Account Detail",
    "Hide Address from Account Detail": "Hide Address from Account Detail",
    "account_config.option_get_account_pickup_address_always": "Get Account Pickup Address Always",
    "Get Account Pickup Address Always": "Get Account Pickup Address Always",
    "account_config.option_get_pickup_address_for_delivery": "Get Pickup Address for Delivery",
    "Get Pickup Address for Delivery": "Get Pickup Address for Delivery",
    "account_config.uploaded_successfully": "Uploaded successfully",
    "app_customization.realtime_config_notice": "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.",
    "app_customization.release_config_notice": "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)",
    "category.translation_title": "Translate Category",
    "Translate Category": "Translate Category",
    "category.translation_category_name": "Category Name",
    "category.translation_description": "Description",
    "listing_configs.title": "Listing Configuration",
    "Listing Configuration": "Listing Configuration",
    "listing_configs.rules": "RULES (Projects/Tenant level)",
    "RULES (Projects/Tenant level)": "RULES (Projects/Tenant level)",
    "listing_configs.features": "FEATURES (Only for mobile app)",
    "FEATURES (Only for mobile app)": "FEATURES (Only for mobile app)",
    "listing_configs.ui_customisation": "UI Customisation",
    "UI Customisation": "UI Customisation",
    "listing_configs.overridden_max_quantity": "Maximum quantity per listing",
    "Maximum quantity per listing": "Maximum quantity per listing",
    "listing_configs.overridden_max_quantity_example": "(Example: 100)",
    "(Example: 100)": "(Example: 100)",
    "listing_configs.listing_min_price": "Minimum listing price",
    "Minimum listing price": "Minimum listing price",
    "listing_configs.listing_min_price_example": "(Example: $5)",
    "(Example: $5)": "(Example: $5)",
    "listing_configs.auto_approval": "Auto approve listings?",
    "Auto approve listings?": "Auto approve listings?",
    "listing_configs.listing_pictures_count": "Number of uploadable pictures count",
    "Number of uploadable pictures count": "Number of uploadable pictures count",
    "listing_configs.seller_can_place_order": "Seller can place order",
    "Seller can place order": "Seller can place order",
    "listing_configs.hide_offer_percent": "Offer percent",
    "Offer percent": "Offer percent",
    "listing_configs.show_max_quantity": "Maximum quantity restrictions on listing level",
    "Maximum quantity restrictions on listing level": "Maximum quantity restrictions on listing level",
    "listing_configs.show_shipping_charges": "Shipping charges",
    "Shipping charges": "Shipping charges",
    "listing_configs.listing_address_label": "Address label",
    "listing_configs.listing_address_label_example": "(Example: Landmark)",
    "(Example: Landmark)": "(Example: Landmark)",
    "listing_configs.listing_map_location_selector_enabled": "Use map marker instead of searching address",
    "Use map marker instead of searching address": "Use map marker instead of searching address",
    "listing_configs.listing_hide_tags": "Tags",
    "Tags": "Tags",
    "listing_configs.enable_stock": "Stocks",
    "Stocks": "Stocks",
    "listing_configs.listing_address_enabled": "Geo address",
    "Geo address": "Geo address",
    "listing_configs.show_stock_out_listings": "Show out of stock listings in feed",
    "Show out of stock listings in feed": "Show out of stock listings in feed",
    "listing_configs.enable_slug": "Listing title slug",
    "Listing title slug": "Listing title slug",
    "listing_configs.show_variants": "Variants",
    "Variants": "Variants",
    "listing_configs.meta_title": "Meta title",
    "Meta title": "Meta title",
    "listing_configs.meta_description": "Meta description",
    "Meta description": "Meta description",
    "listing_configs.listing_enable_formatted_text_description": "Enable Composer",
    "Enable Composer": "Enable Composer",
    "listing_configs.listing_enable_weight": "Enable Weight",
    "Enable Weight": "Enable Weight",
    "listing_configs.listing_enable_dimensions": "Enable Dimensions",
    "Enable Dimensions": "Enable Dimensions",
    "listing_configs.enable_stocks_listing_schedules": "Stock Schedules",
    "Stock Schedules": "Stock Schedules",
    "listing_variants.title": "Variant Types",
    "listing_variants.add_type": "Add Variant Type",
    "Add Variant Type": "Add Variant Type",
    "listing_variants.edit_type": "Edit Variant Type",
    "Edit Variant Type": "Edit Variant Type",
    "listing_variants.name": "Name",
    "listing_variants.values": "Values",
    "listing_variants.status": "Status",
    "listing_variants.action": "Action",
    "listing_variants.add_value": "Add Value",
    "Add Value": "Add Value",
    "listing_variants.active": "Active",
    "listing_variants.inactive": "Inactive",
    "listing_variants.details": "Details",
    "listing_variants.translate": "Translate",
    "listing_variants.delete_confirm": "Do you want to delete this variant type?",
    "Do you want to delete this variant type?": "Do you want to delete this variant type?",
    "listing_variants.add_value_first": "Add a value before viewing variants.",
    "Add a value before viewing variants.": "Add a value before viewing variants.",
    "listing_variants.enter_name": "Enter name",
    "Enter name": "Enter name",
    "listing_variants.status_hint": "Status (Inactive / Active)",
    "Status (Inactive / Active)": "Status (Inactive / Active)",
    "listing_variants.total_values": "Total Values",
    "Total Values": "Total Values",
    "listing_variants.type_id": "Type ID",
    "Type ID": "Type ID",
    "listing_variants.total_count": "{count} total",
    "{count} total": "{count} total",
    "listing_variants.loading": "Loading…",
    "listing_variants.loading_values": "Loading values…",
    "Loading values…": "Loading values…",
    "listing_variants.no_values": "No values yet",
    "No values yet": "No values yet",
    "listing_variants.add_first_value": "Add First Value",
    "Add First Value": "Add First Value",
    "listing_variants.actions": "Actions",
    "listing_variants.edit": "Edit",
    "listing_variants.delete": "Delete",
    "listing_variants.edit_value": "Edit Value",
    "Edit Value": "Edit Value",
    "listing_variants.value_name_required": "Value Name *",
    "Value Name *": "Value Name *",
    "listing_variants.value_examples": "e.g. Red, XL, Cotton…",
    "e.g. Red, XL, Cotton…": "e.g. Red, XL, Cotton…",
    "listing_variants.saving": "Saving…",
    "listing_variants.save_changes": "Save Changes",
    "Save Changes": "Save Changes",
    "listing_variants.delete_value_confirm": "Do you want to delete this variant value?",
    "Do you want to delete this variant value?": "Do you want to delete this variant value?",
    "listing_variants.clear_all": "Clear All",
    "listing_variants.multiple_values_help": "You can add comma-separated values or paste a column from Excel.",
    "You can add comma-separated values or paste a column from Excel.": "You can add comma-separated values or paste a column from Excel.",
    "listing_variants.save": "Save",
    "listing_variants.close": "Close",
    "listing_variants.update": "Update",
    "listing_variants.default_text": "Default text",
    "listing_variants.enter_value": "Enter variant value",
    "Enter variant value": "Enter variant value",
    "listing_variants.add_values": "Add Values",
    "Add Values": "Add Values",
    "listing_variants.add_variant_values": "Add Variant Type Values",
    "Add Variant Type Values": "Add Variant Type Values",
    "listing_variants.values_list": "Variant Type Values List",
    "Variant Type Values List": "Variant Type Values List",
    "listing_variants.cancel_editing": "Cancel Editing",
    "Cancel Editing": "Cancel Editing",
    "listing_variants.value_name": "Variant Type Value",
    "Variant Type Value": "Variant Type Value",
    "common.default_text": "Default text",
    "common.translation_heading": "{title} Translations",
    "{title} Translations": "{title} Translations",
    "attributes.value_delete_confirm": "Do you want to delete this attribute value?",
    "Do you want to delete this attribute value?": "Do you want to delete this attribute value?",
    "attributes.value_clear_all": "Clear All",
    "attributes.value_multiple_help": "Add comma-separated values or paste a column from Excel.",
    "Add comma-separated values or paste a column from Excel.": "Add comma-separated values or paste a column from Excel.",
    "attributes.value_active": "Active",
    "attributes.value_inactive": "Inactive",
    "attributes.value_save": "Save",
    "attributes.value_close": "Close",
    "attributes.value_translate": "Translate",
    "attributes.value_update": "Update",
    "attributes.value_sort_alpha": "Sort Alphabetically",
    "Sort Alphabetically": "Sort Alphabetically",
    "attributes.value_default_text": "Default text",
    "attributes.value_add_metadata": "Add Metadata",
    "Add Metadata": "Add Metadata",
    "attributes.value_cancel_edit": "Cancel Editing",
    "attributes.value_success_help": "Great! You can now find this custom attribute on the Add Listing page.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Great! You can now find this custom attribute on the Add Listing page.",
    "attributes.value_add": "Add Attribute Values",
    "attributes.value_add_listing": "Add Listing Attribute Values",
    "Add Listing Attribute Values": "Add Listing Attribute Values",
    "attributes.value_metadata_for": "Metadata for",
    "Metadata for": "Metadata for",
    "attributes.value_enter": "Enter attribute value",
    "Enter attribute value": "Enter attribute value",
    "attributes.value_add_values": "Add Values",
    "attributes.value_status_hint": "Status (Inactive / Active)",
    "attributes.value_list": "Attribute Values List",
    "Attribute Values List": "Attribute Values List",
    "attributes.value_table_name": "Attribute Value",
    "Attribute Value": "Attribute Value",
    "attributes.value_table_status": "Status",
    "attributes.value_table_action": "Action",
    "attributes.metadata_key": "Key",
    "Key": "Key",
    "attributes.metadata_value": "Value",
    "attributes.metadata_add_row": "Add Row",
    "Add Row": "Add Row",
    "workspace.countries": "Countries",
    "workspace.country_add": "Add Country",
    "Add Country": "Add Country",
    "workspace.country_edit": "Edit Country",
    "Edit Country": "Edit Country",
    "workspace.country_name": "Country Name",
    "Country Name": "Country Name",
    "workspace.select_country": "Select country",
    "Select country": "Select country",
    "workspace.country_order": "Order",
    "workspace.country_order_placeholder": "Enter order",
    "workspace.country_status": "Status (Inactive / Active)",
    "workspace.country_default": "Default",
    "workspace.country_active": "Active",
    "workspace.country_inactive": "Inactive",
    "workspace.country_delete_confirm": "Do you want to delete this country?",
    "Do you want to delete this country?": "Do you want to delete this country?",
    "workspace.country_table_name": "Name",
    "workspace.country_table_default": "Default",
    "workspace.country_table_order": "Order",
    "workspace.country_table_status": "Status",
    "workspace.country_table_action": "Action",
    "workspace.languages": "Languages",
    "workspace.language_add": "Add Language",
    "Add Language": "Add Language",
    "workspace.language_edit": "Edit Language",
    "Edit Language": "Edit Language",
    "workspace.language_name": "Language",
    "workspace.language_select": "Select Language",
    "Select Language": "Select Language",
    "workspace.language_order": "Order",
    "workspace.language_order_placeholder": "Enter order",
    "workspace.language_status": "Status",
    "workspace.language_default": "Default",
    "workspace.language_default_warning": "Changing the default language changes the app language setting.",
    "Changing the default language changes the app language setting.": "Changing the default language changes the app language setting.",
    "workspace.language_active": "Active",
    "workspace.language_inactive": "Inactive",
    "workspace.language_delete_confirm": "Do you want to delete this language?",
    "Do you want to delete this language?": "Do you want to delete this language?",
    "workspace.language_table_name": "Name",
    "workspace.language_table_default": "Default",
    "workspace.language_table_order": "Order",
    "workspace.language_table_status": "Status",
    "workspace.language_table_action": "Action",
    "workspace.language_add_photo": "Add Photo",
    "Add Photo": "Add Photo",
    "workspace.currency": "Currency",
    "workspace.currency_add": "Add Currency",
    "Add Currency": "Add Currency",
    "workspace.currency_edit": "Edit Currency",
    "Edit Currency": "Edit Currency",
    "workspace.currency_delete_confirm": "Do you want to delete this currency?",
    "Do you want to delete this currency?": "Do you want to delete this currency?",
    "workspace.currency_show": "Show",
    "workspace.currency_entries": "entries",
    "entries": "entries",
    "workspace.currency_search": "Search:",
    "Search:": "Search:",
    "workspace.currency_search_placeholder": "Search currencies",
    "Search currencies": "Search currencies",
    "workspace.currency_empty": "No currencies found.",
    "No currencies found.": "No currencies found.",
    "workspace.currency_active": "Active",
    "workspace.currency_inactive": "Inactive",
    "workspace.currency_name": "Name",
    "workspace.currency_name_placeholder": "Currency Name",
    "Currency Name": "Currency Name",
    "workspace.currency_upload_media": "Upload Media",
    "workspace.currency_select_media": "Select from media",
    "Select from media": "Select from media",
    "workspace.currency_no_media": "You do not have any media files.",
    "You do not have any media files.": "You do not have any media files.",
    "workspace.currency_code": "Code",
    "workspace.currency_select_code": "Select",
    "workspace.currency_exchange_rate": "Exchange Rate",
    "Exchange Rate": "Exchange Rate",
    "workspace.currency_precision": "Precision",
    "Precision": "Precision",
    "workspace.currency_thousand_separator": "Thousand Separator",
    "Thousand Separator": "Thousand Separator",
    "workspace.currency_decimal_point": "Decimal Point",
    "Decimal Point": "Decimal Point",
    "workspace.currency_status_hint": "Status (Inactive / Active)",
    "workspace.currency_default": "Default",
    "workspace.currency_format": "Format",
    "Format": "Format",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Name",
    "workspace.currency_table_code": "Code",
    "workspace.currency_table_format": "Format",
    "workspace.currency_table_exchange": "Exchange",
    "Exchange": "Exchange",
    "workspace.currency_table_status": "Status",
    "workspace.currency_table_default": "Default",
    "workspace.currency_table_action": "Action",
    "commissions.title": "Commissions",
    "commissions.add": "Add Commission",
    "Add Commission": "Add Commission",
    "commissions.edit": "Edit Commission",
    "Edit Commission": "Edit Commission",
    "commissions.delete_confirm": "Do you want to delete this commission?",
    "Do you want to delete this commission?": "Do you want to delete this commission?",
    "commissions.yes": "Yes",
    "commissions.no": "No",
    "commissions.filter_all": "All",
    "commissions.filter_supply": "Supply",
    "Supply": "Supply",
    "commissions.filter_demand": "Demand",
    "Demand": "Demand",
    "commissions.filter_cart": "Cart",
    "commissions.table_title": "Title",
    "commissions.table_default_value": "Default Value",
    "Default Value": "Default Value",
    "commissions.table_status": "Status",
    "commissions.table_action": "Action",
    "commissions.active": "Active",
    "commissions.inactive": "Inactive",
    "commissions.type": "Type",
    "commissions.type_supply": "Supply",
    "commissions.type_demand": "Demand",
    "commissions.type_cart": "Cart",
    "commissions.select_category": "Select Category",
    "Select Category": "Select Category",
    "commissions.title_label": "Title",
    "commissions.enter_title": "Enter title",
    "Enter title": "Enter title",
    "commissions.description": "Description",
    "commissions.enter_description": "Enter description",
    "Enter description": "Enter description",
    "commissions.default_value_percent": "Default value (%)",
    "Default value (%)": "Default value (%)",
    "commissions.short_code": "Short Code",
    "Short Code": "Short Code",
    "commissions.short_code_tooltip_title": "Short code",
    "Short code": "Short code",
    "commissions.short_code_tooltip_description": "Enter a short code for this commission.",
    "Enter a short code for this commission.": "Enter a short code for this commission.",
    "commissions.enter_short_code": "Enter short code",
    "Enter short code": "Enter short code",
    "commissions.status_hint": "Status (Inactive / Active)",
    "commissions.optional": "Optional",
    "commissions.advanced": "Advanced",
    "Advanced": "Advanced",
    "commissions.add_by_category": "Add commission by category",
    "Add commission by category": "Add commission by category",
    "commissions.select_calculation_type": "Select Type",
    "commissions.calc_fixed": "Fixed",
    "commissions.calc_slab": "Slab",
    "Slab": "Slab",
    "commissions.value": "Value",
    "commissions.choose_category": "Choose category",
    "Choose category": "Choose category",
    "commissions.create_categories_first": "Create categories in Listing Configuration first",
    "Create categories in Listing Configuration first": "Create categories in Listing Configuration first",
    "commissions.select_type": "Select Type",
    "commissions.demand_fixed": "Fixed",
    "commissions.demand_percentage": "Percentage",
    "commissions.unlimited_hint": "* Enter -1 for unlimited",
    "* Enter -1 for unlimited": "* Enter -1 for unlimited",
    "commissions.from": "From",
    "commissions.enter_from": "Enter from",
    "Enter from": "Enter from",
    "commissions.to": "To",
    "commissions.enter_to": "Enter to",
    "Enter to": "Enter to",
    "commissions.enter_value": "Enter Value",
    "commissions.add_row": "Add Row",
    "commissions.minimum_amount": "Minimum amount",
    "Minimum amount": "Minimum amount",
    "commissions.enter_minimum_amount": "Enter minimum amount",
    "Enter minimum amount": "Enter minimum amount",
    "commissions.maximum_amount": "Maximum amount",
    "Maximum amount": "Maximum amount",
    "commissions.enter_maximum_amount": "Enter maximum amount",
    "Enter maximum amount": "Enter maximum amount",
    "commissions.notes": "Notes",
    "Notes": "Notes",
    "commissions.enter_note": "Enter note",
    "Enter note": "Enter note",
    "commissions.from_value": "From Value",
    "From Value": "From Value",
    "commissions.to_value": "To Value",
    "To Value": "To Value",
    "commissions.unlimited_short_hint": "(-1 for unlimited)",
    "(-1 for unlimited)": "(-1 for unlimited)",
    "commissions.value_percent": "Value (%)",
    "Value (%)": "Value (%)",
    "commissions.from_value_validation": "From value should be greater than the previous To value",
    "From value should be greater than the previous To value": "From value should be greater than the previous To value",
    "commissions.to_value_validation": "To value should be greater than From value",
    "To value should be greater than From value": "To value should be greater than From value",
    "taxes.title": "Tax",
    "taxes.title_plural": "Taxes",
    "taxes.add": "Add Tax",
    "Add Tax": "Add Tax",
    "taxes.edit": "Edit Tax",
    "Edit Tax": "Edit Tax",
    "taxes.delete_confirm": "Are you sure you want to delete this tax?",
    "Are you sure you want to delete this tax?": "Are you sure you want to delete this tax?",
    "taxes.table_title": "Title",
    "taxes.table_short_code": "Short Code",
    "taxes.table_default_value": "Default Value",
    "taxes.table_status": "Status",
    "taxes.table_action": "Action",
    "taxes.active": "Active",
    "taxes.inactive": "Inactive",
    "taxes.select_type": "Select Type",
    "taxes.type_order": "Order",
    "taxes.type_listing": "Listing",
    "taxes.type_tax": "Tax",
    "taxes.demand_fixed": "Fixed",
    "taxes.demand_percentage": "Percentage",
    "taxes.from": "From",
    "taxes.enter_from": "Enter from",
    "taxes.to": "To",
    "taxes.enter_to": "Enter to",
    "taxes.unlimited_hint": "(-1 for unlimited)",
    "taxes.value": "Value",
    "taxes.enter_value": "Enter Value",
    "taxes.add_row": "Add Row",
    "taxes.note": "Note",
    "taxes.note_placeholder": "Enter a note for users to see during checkout and in order details.",
    "Enter a note for users to see during checkout and in order details.": "Enter a note for users to see during checkout and in order details.",
    "taxes.inclusive": "Tax Inclusive",
    "Tax Inclusive": "Tax Inclusive",
    "taxes.inclusive_tooltip": "Enable this when the listed price already includes tax.",
    "Enable this when the listed price already includes tax.": "Enable this when the listed price already includes tax.",
    "taxes.title_placeholder": "Enter a name shown to users at checkout and in order details.",
    "Enter a name shown to users at checkout and in order details.": "Enter a name shown to users at checkout and in order details.",
    "taxes.default_value": "Default value (%)",
    "taxes.default_placeholder": "Default value in %. Example: 6.5",
    "Default value in %. Example: 6.5": "Default value in %. Example: 6.5",
    "taxes.short_code": "Short Code",
    "taxes.short_code_tooltip_title": "Short code",
    "taxes.short_code_tooltip_description": "Enter a short code for this tax.",
    "Enter a short code for this tax.": "Enter a short code for this tax.",
    "taxes.short_code_placeholder": "Use letters and numbers, up to 10 characters. Example: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Use letters and numbers, up to 10 characters. Example: GST10",
    "taxes.status_hint": "Status (Inactive / Active)",
    "taxes.advanced": "Advanced",
    "special_fees.title": "Special Fees",
    "special_fees.description": "Configure an additional fixed amount or percentage fee for each listing.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Configure an additional fixed amount or percentage fee for each listing.",
    "special_fees.fixed": "Special fees fixed",
    "Special fees fixed": "Special fees fixed",
    "special_fees.fixed_placeholder": "Enter special fee amount (example: 5)",
    "Enter special fee amount (example: 5)": "Enter special fee amount (example: 5)",
    "special_fees.percentage": "Special fees percentage",
    "Special fees percentage": "Special fees percentage",
    "special_fees.percentage_placeholder": "Enter special fee percentage (example: 10%)",
    "Enter special fee percentage (example: 10%)": "Enter special fee percentage (example: 10%)",
    "special_fees.example": "Example",
    "Example": "Example",
    "special_fees.example_description": "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.",
    "special_fees.example_fixed": "Additional fixed amount = $10",
    "Additional fixed amount = $10": "Additional fixed amount = $10",
    "special_fees.example_percentage": "Additional fixed percentage = 10%",
    "Additional fixed percentage = 10%": "Additional fixed percentage = 10%",
    "special_fees.example_total": "Final price = $120",
    "Final price = $120": "Final price = $120",
    "delivery.methods_title": "Service / Shipping Methods",
    "Service / Shipping Methods": "Service / Shipping Methods",
    "delivery.shipping_service": "Shipping / Service",
    "Shipping / Service": "Shipping / Service",
    "delivery.table_name": "Name",
    "delivery.table_default": "Default",
    "delivery.table_order": "Order",
    "delivery.table_status": "Status",
    "delivery.table_action": "Action",
    "delivery.yes": "Yes",
    "delivery.no": "No",
    "delivery.active": "Active",
    "delivery.inactive": "Inactive",
    "delivery.delete_confirm": "Do you want to delete this shipping method?",
    "Do you want to delete this shipping method?": "Do you want to delete this shipping method?",
    "delivery.schedule_time": "Schedule Time",
    "Schedule Time": "Schedule Time",
    "delivery.translate": "Translate",
    "delivery.config": "Config",
    "Config": "Config",
    "delivery.add": "Add Shipping/Service",
    "Add Shipping/Service": "Add Shipping/Service",
    "delivery.save": "Save",
    "delivery.edit": "Edit Shipping/Service",
    "Edit Shipping/Service": "Edit Shipping/Service",
    "delivery.stuart_config": "Stuart Configs",
    "Stuart Configs": "Stuart Configs",
    "delivery.shipping_configs": "Service / Shipping Configs",
    "Service / Shipping Configs": "Service / Shipping Configs",
    "delivery.settings": "Settings",
    "delivery.preview": "Preview",
    "delivery.shipment_option": "Shipment Option",
    "Shipment Option": "Shipment Option",
    "delivery.name": "Name",
    "delivery.enter_name": "Enter name",
    "delivery.note": "Note",
    "delivery.enter_note": "Enter note",
    "delivery.note_tooltip_title": "Note",
    "delivery.note_tooltip_description": "Add an optional note to explain this shipping or service option.",
    "Add an optional note to explain this shipping or service option.": "Add an optional note to explain this shipping or service option.",
    "delivery.order": "Order",
    "delivery.enter_order": "Enter order",
    "delivery.status_hint": "Status (Inactive / Active)",
    "delivery.default": "Default",
    "delivery.select_shipping_method": "Select shipping method",
    "Select shipping method": "Select shipping method",
    "delivery.select_extension": "Select extension",
    "Select extension": "Select extension",
    "delivery.add_photo": "Add Photo",
    "delivery.config.flat_shipping_fee.title": "Flat Shipping Fee",
    "Flat Shipping Fee": "Flat Shipping Fee",
    "delivery.config.flat_shipping_fee.placeholder": "Enter flat shipping fee",
    "Enter flat shipping fee": "Enter flat shipping fee",
    "delivery.config.schedule_time.title": "Schedule Time",
    "delivery.config.fulfillment_by_platform_enabled.title": "Fulfillment by platform",
    "Fulfillment by platform": "Fulfillment by platform",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Fulfillment by Platform Icon",
    "Fulfillment by Platform Icon": "Fulfillment by Platform Icon",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Seller Delivery Icon",
    "Seller Delivery Icon": "Seller Delivery Icon",
    "delivery.phone_number": "Phone number",
    "Phone number": "Phone number",
    "delivery.enter_phone_number": "Enter phone number",
    "Enter phone number": "Enter phone number",
    "delivery.address_line_1": "Address line 1",
    "Address line 1": "Address line 1",
    "delivery.enter_address_line_1": "Enter address line 1",
    "Enter address line 1": "Enter address line 1",
    "delivery.address_line_2": "Address line 2",
    "Address line 2": "Address line 2",
    "delivery.enter_address_line_2": "Enter address line 2",
    "Enter address line 2": "Enter address line 2",
    "delivery.landmark": "Landmark",
    "Landmark": "Landmark",
    "delivery.enter_landmark": "Enter landmark",
    "Enter landmark": "Enter landmark",
    "delivery.state": "State",
    "delivery.enter_state": "Enter state",
    "Enter state": "Enter state",
    "delivery.post_code": "Post code",
    "Post code": "Post code",
    "delivery.enter_post_code": "Enter post code",
    "Enter post code": "Enter post code",
    "delivery.country": "Country",
    "delivery.enter_country": "Enter country",
    "Enter country": "Enter country",
    "delivery.required_information": "Please fill the required information",
    "Please fill the required information": "Please fill the required information",
    "delivery.saved_successfully": "Uploaded successfully",
    "delivery.storage_hub.title": "Storage Hub Points",
    "Storage Hub Points": "Storage Hub Points",
    "delivery.storage_hub.add": "Add Storage Hub",
    "Add Storage Hub": "Add Storage Hub",
    "delivery.storage_hub.edit": "Edit Storage Hub",
    "Edit Storage Hub": "Edit Storage Hub",
    "delivery.storage_hub.delete_confirm": "Do you want to delete this storage hub point?",
    "Do you want to delete this storage hub point?": "Do you want to delete this storage hub point?",
    "delivery.storage_hub.table_name": "Name",
    "delivery.storage_hub.table_phone": "Phone No",
    "delivery.storage_hub.table_address": "Address",
    "delivery.storage_hub.table_landmark": "Landmark",
    "delivery.storage_hub.table_state": "State",
    "delivery.storage_hub.table_post_code": "Post Code",
    "Post Code": "Post Code",
    "delivery.storage_hub.table_country": "Country",
    "delivery.storage_hub.table_action": "Action",
    "delivery.select_environment": "Select environment",
    "Select environment": "Select environment",
    "delivery.environment_sandbox": "Sandbox",
    "Sandbox": "Sandbox",
    "delivery.environment_production": "Production",
    "Production": "Production",
    "delivery.stuart.client_id": "Client ID",
    "delivery.stuart.enter_client_id": "Enter client ID",
    "delivery.stuart.client_secret": "Client Secret",
    "Client Secret": "Client Secret",
    "delivery.stuart.enter_client_secret": "Enter client secret",
    "Enter client secret": "Enter client secret",
    "delivery.stuart.webhook_key": "Webhook Authentication Key",
    "Webhook Authentication Key": "Webhook Authentication Key",
    "delivery.stuart.enter_webhook_key": "Enter webhook authentication key",
    "Enter webhook authentication key": "Enter webhook authentication key",
    "delivery.sendcloud.public_key": "Public Key",
    "Public Key": "Public Key",
    "delivery.sendcloud.enter_public_key": "Enter API key",
    "delivery.sendcloud.secret_key": "Secret Key",
    "Secret Key": "Secret Key",
    "delivery.sendcloud.enter_secret_key": "Enter notification secret",
    "Enter notification secret": "Enter notification secret",
    "delivery.sendcloud.default_shipping_address": "Default Shipping Address",
    "Default Shipping Address": "Default Shipping Address",
    "delivery.sendcloud.add_new": "+ Add New",
    "+ Add New": "+ Add New",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Payment Methods",
    "Payment Methods": "Payment Methods",
    "payments.add": "Add Payment Method",
    "Add Payment Method": "Add Payment Method",
    "payments.edit": "Edit Payment Method",
    "Edit Payment Method": "Edit Payment Method",
    "payments.delete_confirm": "Do you want to delete this payment method?",
    "Do you want to delete this payment method?": "Do you want to delete this payment method?",
    "payments.save_continue": "Save and continue",
    "Save and continue": "Save and continue",
    "payments.translate": "Translate Payments",
    "Translate Payments": "Translate Payments",
    "payments.config": "Config",
    "payments.integration_settings": "Integration Settings",
    "Integration Settings": "Integration Settings",
    "payments.opp_integration": "OPP Integration",
    "OPP Integration": "OPP Integration",
    "payments.billplz_integration": "BillPlz Integration",
    "BillPlz Integration": "BillPlz Integration",
    "payments.stripe_integration": "Stripe Integration",
    "Stripe Integration": "Stripe Integration",
    "payments.stripe_web_integration": "Stripe Web Integration",
    "Stripe Web Integration": "Stripe Web Integration",
    "payments.pawapay_integration": "PawaPay Integration",
    "PawaPay Integration": "PawaPay Integration",
    "payments.korapay_integration": "KoraPay Integration",
    "KoraPay Integration": "KoraPay Integration",
    "payments.flutterwave_integration": "Flutterwave Integration",
    "Flutterwave Integration": "Flutterwave Integration",
    "payments.commercepay_integration": "CommercePay Integration",
    "CommercePay Integration": "CommercePay Integration",
    "payments.checkout_com_integration": "Checkout.com Integration",
    "Checkout.com Integration": "Checkout.com Integration",
    "payments.paystack_integration": "PayStack Integration",
    "PayStack Integration": "PayStack Integration",
    "payments.razorpay_settings": "Razorpay settings",
    "Razorpay settings": "Razorpay settings",
    "payments.paydunya_settings": "Pay Dunya settings",
    "Pay Dunya settings": "Pay Dunya settings",
    "payments.mangopay_settings": "MangoPay settings",
    "MangoPay settings": "MangoPay settings",
    "payments.payu_latam_integration": "PayU LATAM Integration",
    "PayU LATAM Integration": "PayU LATAM Integration",
    "payments.table_name": "Name",
    "payments.table_actions": "Actions",
    "payments.table_min_amount": "Minimum Amount",
    "Minimum Amount": "Minimum Amount",
    "payments.table_max_amount": "Maximum Amount",
    "Maximum Amount": "Maximum Amount",
    "payments.table_default": "Default",
    "payments.table_order_by": "Order",
    "payments.table_status": "Status",
    "payments.yes": "Yes",
    "payments.no": "No",
    "payments.active": "Active",
    "payments.inactive": "Inactive",
    "payments.settings": "Settings",
    "payments.not_available": "N/A",
    "payments.step_select_type": "Select Type",
    "payments.step_configure": "Configure",
    "Configure": "Configure",
    "payments.step_integration": "Integration",
    "Integration": "Integration",
    "payments.next": "Next →",
    "Next →": "Next →",
    "payments.save": "Save",
    "payments.choose_method": "Choose a payment method to configure",
    "Choose a payment method to configure": "Choose a payment method to configure",
    "payments.name": "Name",
    "payments.enter_name": "Enter name",
    "payments.maximum_amount": "Maximum amount",
    "payments.enter_maximum_amount": "Enter maximum amount",
    "payments.minimum_amount": "Minimum amount",
    "payments.enter_minimum_amount": "Enter minimum amount",
    "payments.note": "Note",
    "payments.enter_note": "Enter note",
    "payments.note_tooltip": "Add an optional note for customers at checkout.",
    "Add an optional note for customers at checkout.": "Add an optional note for customers at checkout.",
    "payments.order": "Order",
    "payments.enter_order": "Enter order",
    "payments.default": "Default",
    "payments.config_title": "Payment Methods Configuration",
    "Payment Methods Configuration": "Payment Methods Configuration",
    "payments.wallet_enable": "Wallet enabled",
    "Wallet enabled": "Wallet enabled",
    "payments.account_type": "Account type",
    "payments.select_account_type": "Select account type",
    "Select account type": "Select account type",
    "payments.connect_message_standard": "Connect message standard",
    "Connect message standard": "Connect message standard",
    "payments.enter_connect_message_standard": "Enter connect message standard",
    "Enter connect message standard": "Enter connect message standard",
    "payments.disconnect_message_standard": "Disconnect message standard",
    "Disconnect message standard": "Disconnect message standard",
    "payments.enter_disconnect_message_standard": "Enter disconnect message standard",
    "Enter disconnect message standard": "Enter disconnect message standard",
    "payments.connect_message_express": "Connect message express",
    "Connect message express": "Connect message express",
    "payments.enter_connect_message_express": "Enter connect message express",
    "Enter connect message express": "Enter connect message express",
    "payments.disconnect_message_express": "Disconnect message express",
    "Disconnect message express": "Disconnect message express",
    "payments.enter_disconnect_message_express": "Enter disconnect message express",
    "Enter disconnect message express": "Enter disconnect message express",
    "payments.enable_sandbox": "Enable sandbox",
    "Enable sandbox": "Enable sandbox",
    "payments.api_token": "API Token",
    "API Token": "API Token",
    "payments.enter_token": "Enter token",
    "Enter token": "Enter token",
    "payments.key_id": "Key ID",
    "Key ID": "Key ID",
    "payments.enter_key_id": "Enter key ID",
    "Enter key ID": "Enter key ID",
    "payments.key_secret": "Key Secret",
    "Key Secret": "Key Secret",
    "payments.enter_secret_key": "Enter secret key",
    "Enter secret key": "Enter secret key",
    "payments.webhook_secret_key": "Webhook Secret Key",
    "Webhook Secret Key": "Webhook Secret Key",
    "payments.enter_webhook_secret_key": "Enter webhook secret key",
    "Enter webhook secret key": "Enter webhook secret key",
    "payments.master_key": "Master Key",
    "Master Key": "Master Key",
    "payments.public_key": "Public Key",
    "payments.enter_public_key": "Enter public key",
    "Enter public key": "Enter public key",
    "payments.private_key": "Private Key",
    "Private Key": "Private Key",
    "payments.merchant_id": "Merchant ID",
    "Merchant ID": "Merchant ID",
    "payments.enter_merchant_id": "Enter merchant id",
    "Enter merchant id": "Enter merchant id",
    "payments.processing_channel_id": "Processing channel ID",
    "Processing channel ID": "Processing channel ID",
    "payments.enter_processing_channel_id": "Enter processing channel id",
    "Enter processing channel id": "Enter processing channel id",
    "payments.api_key": "API key",
    "payments.x_signature_key": "X Signature Key",
    "X Signature Key": "X Signature Key",
    "payments.account_id": "Account ID",
    "payments.login_api_key": "Login API key",
    "Login API key": "Login API key",
    "payments.client_id": "Client ID",
    "payments.client_api_key": "Client API Key",
    "Client API Key": "Client API Key",
    "payments.payin_fee": "PayIn fee (%)",
    "PayIn fee (%)": "PayIn fee (%)",
    "payments.withdraw_fee": "Withdraw fee (%)",
    "Withdraw fee (%)": "Withdraw fee (%)",
    "payments.enter_api_key": "Enter API key",
    "payments.enter_account_id": "Enter account ID",
    "Enter account ID": "Enter account ID",
    "payments.enter_login_api_key": "Enter login API key",
    "Enter login API key": "Enter login API key",
    "payments.enter_notification_secret": "Enter notification secret",
    "payments.enter_payin_fee": "Enter fee as a percentage",
    "Enter fee as a percentage": "Enter fee as a percentage",
    "payments.secret_key": "Secret key",
    "Secret key": "Secret key",
    "payments.publishable_key": "Publishable key",
    "Publishable key": "Publishable key",
    "payments.webhook_secret": "Webhook secret",
    "Webhook secret": "Webhook secret",
    "payments.enter_webhook_secret": "Enter webhook secret",
    "Enter webhook secret": "Enter webhook secret",
    "payments.enter_subscription_webhook_secret": "Enter subscription webhook secret",
    "Enter subscription webhook secret": "Enter subscription webhook secret",
    "payments.connect_client_id": "Connect client ID",
    "Connect client ID": "Connect client ID",
    "payments.enter_connect_client_id": "Enter Connect client ID",
    "Enter Connect client ID": "Enter Connect client ID",
    "payments.stripe_reminders": "Stripe reminders",
    "Stripe reminders": "Stripe reminders",
    "payments.stripe_sync_help": "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.",
    "payments.find_in_stripe": "Find in Stripe Dashboard",
    "Find in Stripe Dashboard": "Find in Stripe Dashboard",
    "payments.description": "Description",
    "payments.learn_more_stripe": "Learn more about Stripe Payments",
    "Learn more about Stripe Payments": "Learn more about Stripe Payments",
    "payments.learn_more_stripe_connect": "Learn more about Stripe Connect for marketplaces",
    "Learn more about Stripe Connect for marketplaces": "Learn more about Stripe Connect for marketplaces",
    "payments.token": "Token",
    "Token": "Token",
    "payments.payment_options": "Payment options",
    "Payment options": "Payment options",
    "payments.enable_integration": "Enable integration",
    "Enable integration": "Enable integration",
    "payments.enter_provider_id": "Enter {provider} ID",
    "Enter {provider} ID": "Enter {provider} ID",
    "payments.integration_status_help": "Configure this provider in its settings.",
    "Configure this provider in its settings.": "Configure this provider in its settings.",
    "listings.title": "Listings",
    "listings.manage": "Manage",
    "listings.show_rows": "Show rows",
    "listings.clear": "Clear",
    "listings.apply": "Apply",
    "listings.select_date": "Select date",
    "Select date": "Select date",
    "listings.start_date": "Start date",
    "listings.end_date": "End date",
    "listings.status_types": "Status types",
    "Status types": "Status types",
    "listings.categories": "Categories",
    "listings.attributes": "Attributes",
    "listings.clear_all_filters": "Clear all filters",
    "Clear all filters": "Clear all filters",
    "listings.import": "Import",
    "listings.export": "Export",
    "listings.smart_upload": "Smart Upload (Beta)",
    "Smart Upload (Beta)": "Smart Upload (Beta)",
    "listings.filter_listings": "Filter listings",
    "Filter listings": "Filter listings",
    "listings.sort_listings": "Sort listings",
    "Sort listings": "Sort listings",
    "listings.import_listings": "Import listings",
    "Import listings": "Import listings",
    "listings.export_listings": "Export listings",
    "Export listings": "Export listings",
    "listings.list_view": "List view",
    "listings.grid_view": "Grid view",
    "listings.map_view": "Map view",
    "listings.board_view": "Board view",
    "listings.export_all_title": "Export all listings?",
    "Export all listings?": "Export all listings?",
    "listings.export_all_message": "This will prepare a file containing all listings. Do you want to continue?",
    "This will prepare a file containing all listings. Do you want to continue?": "This will prepare a file containing all listings. Do you want to continue?",
    "listings.export_all": "Export all listings",
    "Export all listings": "Export all listings",
    "listings.cancel": "Cancel",
    "listings.status_all": "All",
    "listings.status_pending": "Pending",
    "listings.status_approved": "Approved",
    "listings.status_rejected": "Rejected",
    "listings.status_archived": "Archived",
    "Archived": "Archived",
    "listings.sort_newest_first": "Newest first",
    "Newest first": "Newest first",
    "listings.sort_price_high_to_low": "Price: high to low",
    "Price: high to low": "Price: high to low",
    "listings.sort_price_low_to_high": "Price: low to high",
    "Price: low to high": "Price: low to high",
    "listings.header_0": "Title",
    "listings.header_1": "Website",
    "Website": "Website",
    "listings.header_2": "List price",
    "List price": "List price",
    "listings.header_3": "Offer percent",
    "listings.header_4": "Image",
    "listings.header_5": "Offer price",
    "Offer price": "Offer price",
    "listings.header_6": "Status",
    "listings.header_7": "Listing ID",
    "listings.header_8": "Listing status",
    "Listing status": "Listing status",
    "listings.header_9": "Accounts",
    "listings.header_10": "Currency",
    "listings.header_11": "Sold",
    "Sold": "Sold",
    "listings.header_12": "Goal amount",
    "Goal amount": "Goal amount",
    "listings.filter_status": "Status",
    "listings.filter_price": "Price",
    "listings.filter_category": "Category",
    "listings.filter_clear_all": "Clear all filters",
    "listings.status_count": "Status ({count})",
    "Status ({count})": "Status ({count})",
    "listings.price_count": "Price ({count})",
    "Price ({count})": "Price ({count})",
    "listings.category_count": "Category ({count})",
    "Category ({count})": "Category ({count})",
    "listings.search": "Search listings",
    "listings.clear_search": "Clear listing search",
    "Clear listing search": "Clear listing search",
    "listings.active": "Active",
    "listings.inactive": "Inactive",
    "listings.approve": "Approve",
    "listings.reject": "Reject",
    "listings.delete_confirm": "Are you sure you want to delete this listing?",
    "Are you sure you want to delete this listing?": "Are you sure you want to delete this listing?",
    "listings.approve_confirm": "Do you want to approve this listing?",
    "Do you want to approve this listing?": "Do you want to approve this listing?",
    "listings.reject_confirm": "Do you want to reject this listing?",
    "Do you want to reject this listing?": "Do you want to reject this listing?",
    "listings.yes": "Yes",
    "listings.no": "No",
    "listings.confirm_delete": "Are you sure you want to delete this listing?",
    "listings.confirm_approve": "Do you want to approve this listing?",
    "listings.confirm_reject": "Do you want to reject this listing?",
    "listings.column.actions": "Actions",
    "listings.audio_episode": "Audio episode",
    "Audio episode": "Audio episode",
    "listings.video": "Video",
    "listings.seller": "Seller",
    "listings.rating": "Rating",
    "listings.followers": "Followers",
    "listings.view_seller_account": "View seller account",
    "View seller account": "View seller account",
    "listings.add_variant": "Add variant",
    "Add variant": "Add variant",
    "listings.edit": "Edit",
    "listings.preview": "Preview",
    "listings.share": "Share",
    "listings.view_listing": "View listing",
    "View listing": "View listing",
    "listings.stock": "Stock",
    "Stock": "Stock",
    "listings.variants": "Variants",
    "listings.campaign": "Campaign",
    "Campaign": "Campaign",
    "listings.rental_details": "Rental details",
    "Rental details": "Rental details",
    "listings.copy": "Copy",
    "listings.inventory": "Inventory",
    "listings.order_type": "Order type",
    "Order type": "Order type",
    "listings.stock_by_location": "Stock by location",
    "Stock by location": "Stock by location",
    "listings.loading_location_stock": "Loading location stock…",
    "Loading location stock…": "Loading location stock…",
    "listings.no_location_stock": "No stock assigned to a location.",
    "No stock assigned to a location.": "No stock assigned to a location.",
    "listings.page_analytics": "Page analytics",
    "Page analytics": "Page analytics",
    "listings.loading": "Loading…",
    "listings.analytics_key_missing": "Analytics API key is not configured for this tenant.",
    "Analytics API key is not configured for this tenant.": "Analytics API key is not configured for this tenant.",
    "listings.no_slug": "No slug is available for this listing.",
    "No slug is available for this listing.": "No slug is available for this listing.",
    "listings.no_analytics": "No analytics loaded yet.",
    "listings.load_analytics": "Load analytics",
    "Load analytics": "Load analytics",
    "listings.no_orders": "No orders yet for this listing",
    "No orders yet for this listing": "No orders yet for this listing",
    "listings.social_ratings": "Social and ratings",
    "Social and ratings": "Social and ratings",
    "listings.tags": "Tags",
    "listings.schedule": "Schedule",
    "listings.detail": "Detail",
    "Detail": "Detail",
    "listings.update_stock": "Update stock",
    "Update stock": "Update stock",
    "listings.new_stock_quantity": "New stock quantity",
    "New stock quantity": "New stock quantity",
    "listings.location": "Location",
    "listings.quantity": "Quantity",
    "listings.current_stock": "Current stock: {quantity}",
    "Current stock: {quantity}": "Current stock: {quantity}",
    "listings.loading_rental": "Loading rental settings…",
    "Loading rental settings…": "Loading rental settings…",
    "payments.enter_publishable_key": "Enter publishable key",
    "Enter publishable key": "Enter publishable key",
    "listings.add_listing": "Add listing",
    "Add listing": "Add listing",
    "listings.edit_listing": "Edit listing",
    "Edit listing": "Edit listing",
    "listings.enter_title": "Enter title",
    "listings.account": "Account",
    "listings.list_price": "List price",
    "listings.enter_list_price": "Enter list price",
    "Enter list price": "Enter list price",
    "listings.select_currency": "Select currency",
    "Select currency": "Select currency",
    "listings.select_category": "Select category",
    "listings.select_categories": "Select categories",
    "Select categories": "Select categories",
    "listings.add_category": "+ Add category",
    "+ Add category": "+ Add category",
    "listings.add_attribute": "Add attribute",
    "Add attribute": "Add attribute",
    "listings.enter_stock": "Enter stock",
    "Enter stock": "Enter stock",
    "listings.offer_percentage": "Offer percentage",
    "Offer percentage": "Offer percentage",
    "listings.enter_offer": "Enter offer",
    "Enter offer": "Enter offer",
    "listings.max_quantity_optional": "Max quantity (optional)",
    "Max quantity (optional)": "Max quantity (optional)",
    "listings.enter_max_quantity": "Enter max quantity",
    "Enter max quantity": "Enter max quantity",
    "listings.enter_slug": "Enter slug",
    "listings.enter_meta_title": "Enter meta title",
    "listings.repeat": "Repeat",
    "Repeat": "Repeat",
    "listings.start_time": "Start time",
    "Start time": "Start time",
    "listings.end_time": "End time",
    "End time": "End time",
    "listings.slot": "Slot",
    "Slot": "Slot",
    "listings.starts_from": "Starts from:",
    "Starts from:": "Starts from:",
    "listings.add_schedule": "+ Add schedule",
    "+ Add schedule": "+ Add schedule",
    "listings.upload_here": "Upload here",
    "listings.save": "Save",
    "listings.update": "Update",
    "listings.tax": "Tax",
    "listings.title_required": "Please enter a title",
    "Please enter a title": "Please enter a title",
    "listings.select_tax": "Please select a tax",
    "Please select a tax": "Please select a tax",
    "listings.select_item": "Please select {item}",
    "Please select {item}": "Please select {item}",
    "listings.offer_percentage_validation": "Offer percentage must be between 0 and 100",
    "Offer percentage must be between 0 and 100": "Offer percentage must be between 0 and 100",
    "listings.custom_seo": "Custom SEO",
    "Custom SEO": "Custom SEO",
    "listings.select_value": "Select value",
    "Select value": "Select value",
    "listings.add_schedule_title": "Add schedule",
    "Add schedule": "Add schedule",
    "listings.select_from_media": "Select from media",
    "listing_form.create_listing": "Create listing",
    "Create listing": "Create listing",
    "listing_form.update_listing": "Update listing",
    "Update listing": "Update listing",
    "listing_form.saving": "Saving…",
    "listing_form.main_information": "Main information",
    "Main information": "Main information",
    "listing_form.audio_listing": "Audio listing",
    "Audio listing": "Audio listing",
    "listing_form.basic_information": "Basic information",
    "Basic information": "Basic information",
    "listing_form.listing_type": "Listing type",
    "Listing type": "Listing type",
    "listing_form.title": "Title",
    "listing_form.enter_listing_title": "Enter listing title",
    "Enter listing title": "Enter listing title",
    "listing_form.description": "Description",
    "listing_form.enter_detailed_description": "Enter detailed description",
    "Enter detailed description": "Enter detailed description",
    "listing_form.tags": "Tags",
    "listing_form.tag_example": "e.g., electronics, gadgets, new",
    "e.g., electronics, gadgets, new": "e.g., electronics, gadgets, new",
    "listing_form.taxes": "Taxes",
    "listing_form.optional": "Optional",
    "listing_form.start_date": "Start date",
    "listing_form.end_date": "End date",
    "listing_form.currency": "Currency",
    "listing_form.select_currency": "Select currency",
    "listing_form.goal_price": "Goal price",
    "Goal price": "Goal price",
    "listing_form.set_fundraising_goal": "Set your fundraising goal",
    "Set your fundraising goal": "Set your fundraising goal",
    "listing_form.pricing": "Pricing",
    "Pricing": "Pricing",
    "listing_form.select": "Select",
    "listing_form.price": "Price",
    "listing_form.offer_percent": "Offer %",
    "Offer %": "Offer %",
    "listing_form.listing_price": "Listing price:",
    "Listing price:": "Listing price:",
    "listing_form.set_fundraising_goal_amount": "Set your fundraising goal amount",
    "Set your fundraising goal amount": "Set your fundraising goal amount",
    "listing_form.category": "Category",
    "listing_form.select_a_category": "Select a category",
    "Select a category": "Select a category",
    "listing_form.clear_selected_category": "Clear selected category",
    "Clear selected category": "Clear selected category",
    "listing_form.create_new_category": "Create a new category",
    "Create a new category": "Create a new category",
    "listing_form.search_categories": "Search categories…",
    "Search categories…": "Search categories…",
    "listing_form.no_categories_match": "No categories found",
    "No categories found": "No categories found",
    "listing_form.draft_found": "A saved draft was found.",
    "A saved draft was found.": "A saved draft was found.",
    "listing_form.restore": "Restore",
    "Restore": "Restore",
    "listing_form.discard": "Discard",
    "listing_form.characters": "characters",
    "characters": "characters",
    "listing_form.zero_amount": "0.00",
    "0.00": "0.00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Physical products",
    "Physical products": "Physical products",
    "listing_form.type_events": "Events",
    "Events": "Events",
    "listing_form.type_digital": "Digital products",
    "Digital products": "Digital products",
    "listing_form.type_appointments": "Appointments",
    "Appointments": "Appointments",
    "listing_form.type_rentals": "Rentals",
    "listing_form.type_donation": "Crowdfunding",
    "Crowdfunding": "Crowdfunding",
    "listing_form.type_information_listing": "Information",
    "Information": "Information",
    "listing_form.type_video_listing": "Video",
    "listing_form.type_audio_listing": "Audio",
    "listing_form.select_taxes": "Select taxes (optional)",
    "Select taxes (optional)": "Select taxes (optional)",
    "listing_form.no_taxes": "No taxes available",
    "No taxes available": "No taxes available",
    "listing_form.inventory_shipping": "Inventory & shipping",
    "Inventory & shipping": "Inventory & shipping",
    "listing_form.stock": "Stock",
    "listing_form.weight": "Weight",
    "Weight": "Weight",
    "listing_form.dimensions": "Dimensions (L×W×H)",
    "Dimensions (L×W×H)": "Dimensions (L×W×H)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Barcode",
    "Barcode": "Barcode",
    "listing_form.length": "Length",
    "Length": "Length",
    "listing_form.width": "Width",
    "Width": "Width",
    "listing_form.height": "Height",
    "Height": "Height",
    "listing_form.seo_settings": "SEO settings",
    "SEO settings": "SEO settings",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "URL-friendly version of the title",
    "URL-friendly version of the title": "URL-friendly version of the title",
    "listing_form.meta_title": "Meta title",
    "listing_form.recommended_meta_title": "Recommended: 50–60 chars",
    "Recommended: 50–60 chars": "Recommended: 50–60 chars",
    "listing_form.meta_keywords": "Meta keywords",
    "Meta keywords": "Meta keywords",
    "listing_form.separate_with_commas": "Separate with commas",
    "Separate with commas": "Separate with commas",
    "listing_form.meta_description": "Meta description",
    "listing_form.recommended_meta_description": "Recommended: 150–160 chars",
    "Recommended: 150–160 chars": "Recommended: 150–160 chars",
    "listing_form.hide": "Hide",
    "listing_form.show": "Show",
    "listing_form.seo_fields": "search engine optimization fields",
    "search engine optimization fields": "search engine optimization fields",
    "listing_form.auto_generated_slug": "Auto-generated from title",
    "Auto-generated from title": "Auto-generated from title",
    "listing_form.seo_title_optional": "SEO title (optional)",
    "SEO title (optional)": "SEO title (optional)",
    "listing_form.keywords_comma_separated": "Keywords separated by commas",
    "Keywords separated by commas": "Keywords separated by commas",
    "listing_form.search_description_optional": "Brief description for search results (optional)",
    "Brief description for search results (optional)": "Brief description for search results (optional)",
    "listing_form.account": "Account",
    "listing_form.loading_accounts": "Loading accounts…",
    "Loading accounts…": "Loading accounts…",
    "listing_form.clear_selected_account": "Clear selected account",
    "Clear selected account": "Clear selected account",
    "listing_form.search_accounts": "Search accounts…",
    "Search accounts…": "Search accounts…",
    "listing_form.create_account": "Create a new account",
    "Create a new account": "Create a new account",
    "listing_form.no_accounts_found": "No accounts found",
    "No accounts found": "No accounts found",
    "listing_form.rental_settings": "Rental settings",
    "Rental settings": "Rental settings",
    "listing_form.rental_price_help": "The listing price is calculated from the rental rate and duration.",
    "The listing price is calculated from the rental rate and duration.": "The listing price is calculated from the rental rate and duration.",
    "listing_form.rate_unit": "Rate unit",
    "Rate unit": "Rate unit",
    "listing_form.hour": "Hour",
    "Hour": "Hour",
    "listing_form.day": "Day",
    "listing_form.week": "Week",
    "listing_form.rental_rate_amount": "Rental rate",
    "Rental rate": "Rental rate",
    "listing_form.rental_min_duration": "Minimum duration",
    "Minimum duration": "Minimum duration",
    "listing_form.rental_max_duration": "Maximum duration",
    "Maximum duration": "Maximum duration",
    "listing_form.rental_buffer_time": "Buffer time (hours)",
    "Buffer time (hours)": "Buffer time (hours)",
    "listing_form.rental_deposit_amount": "Deposit amount",
    "Deposit amount": "Deposit amount",
    "listing_form.rental_max_units": "Maximum units",
    "Maximum units": "Maximum units",
    "listing_form.quick_create_title": "Create {entity}",
    "Create {entity}": "Create {entity}",
    "listing_form.close": "Close",
    "listing_form.account_name": "Account name",
    "listing_form.category_name": "Category name",
    "Category name": "Category name",
    "listing_form.account_example": "e.g. Acme Store",
    "e.g. Acme Store": "e.g. Acme Store",
    "listing_form.category_example": "e.g. Fresh Produce",
    "e.g. Fresh Produce": "e.g. Fresh Produce",
    "listing_form.creating": "Creating…",
    "listing_form.create_entity": "Create {entity}",
    "listing_form.cancel": "Cancel",
    "listing_form.go_back": "Go back",
    "Go back": "Go back",
    "listing_form.upgrade_plan": "Upgrade plan",
    "Upgrade plan": "Upgrade plan",
    "listing_form.close_upgrade_dialog": "Close upgrade dialog",
    "Close upgrade dialog": "Close upgrade dialog",
    "listing_form.loading_attributes": "Loading attributes…",
    "Loading attributes…": "Loading attributes…",
    "listing_form.no_attributes": "No attributes for this category",
    "No attributes for this category": "No attributes for this category",
    "listing_form.unsupported_field_type": "Unsupported field type",
    "Unsupported field type": "Unsupported field type",
    "listing_form.delete_schedule_confirm": "Are you sure you want to delete this schedule?",
    "Are you sure you want to delete this schedule?": "Are you sure you want to delete this schedule?",
    "listing_form.no_schedules_added": "No schedules added yet",
    "No schedules added yet": "No schedules added yet",
    "listing_form.stock_label": "Stock:",
    "Stock:": "Stock:",
    "listing_form.active": "Active",
    "listing_form.inactive": "Inactive",
    "listing_form.edit": "Edit",
    "listing_form.delete": "Delete",
    "listing_form.schedules": "Schedules",
    "Schedules": "Schedules",
    "listing_form.no_schedules_yet": "No schedules yet",
    "No schedules yet": "No schedules yet",
    "listing_form.dates_label": "Dates:",
    "Dates:": "Dates:",
    "listing_form.time_label": "Time:",
    "Time:": "Time:",
    "listing_form.repeat_label": "Repeat:",
    "Repeat:": "Repeat:",
    "listing_form.capacity_label": "Capacity:",
    "Capacity:": "Capacity:",
    "listing_form.edit_schedule": "Edit schedule",
    "Edit schedule": "Edit schedule",
    "listing_form.add_new_schedule": "Add new schedule",
    "Add new schedule": "Add new schedule",
    "listing_form.repeat_pattern": "Repeat pattern",
    "Repeat pattern": "Repeat pattern",
    "listing_form.select_days": "Select days",
    "Select days": "Select days",
    "listing_form.total_stocks_capacity": "Total stock (capacity)",
    "Total stock (capacity)": "Total stock (capacity)",
    "listing_form.select_at_least_one_day": "Please select at least one day",
    "Please select at least one day": "Please select at least one day",
    "listing_form.unlimited_capacity_help": "Leave empty for unlimited capacity",
    "Leave empty for unlimited capacity": "Leave empty for unlimited capacity",
    "listing_form.add_schedule": "+ Add schedule",
    "listing_form.schedule_number": "Schedule #{number}",
    "Schedule #{number}": "Schedule #{number}",
    "listing_form.update_action": "update",
    "update": "update",
    "listing_form.create_action": "create",
    "create": "create",
    "listing_form.a_schedule": "a schedule",
    "a schedule": "a schedule",
    "listing_form.daily": "Daily",
    "Daily": "Daily",
    "listing_form.weekdays": "Weekdays (Mon - Fri)",
    "Weekdays (Mon - Fri)": "Weekdays (Mon - Fri)",
    "listing_form.weekend": "Weekend (Sat - Sun)",
    "Weekend (Sat - Sun)": "Weekend (Sat - Sun)",
    "listing_form.custom": "Custom",
    "listing_form.weekday_0": "Monday",
    "Monday": "Monday",
    "listing_form.weekday_1": "Tuesday",
    "Tuesday": "Tuesday",
    "listing_form.weekday_2": "Wednesday",
    "Wednesday": "Wednesday",
    "listing_form.weekday_3": "Thursday",
    "Thursday": "Thursday",
    "listing_form.weekday_4": "Friday",
    "Friday": "Friday",
    "listing_form.weekday_5": "Saturday",
    "Saturday": "Saturday",
    "listing_form.weekday_6": "Sunday",
    "Sunday": "Sunday",
    "listing_form.media_max_files": "Maximum {count} {type} allowed",
    "Maximum {count} {type} allowed": "Maximum {count} {type} allowed",
    "listing_form.video_size_limit": "Each video must be 1GB or smaller",
    "Each video must be 1GB or smaller": "Each video must be 1GB or smaller",
    "listing_form.videos": "Videos",
    "Videos": "Videos",
    "listing_form.images": "Images",
    "listing_form.select_from_media": "Select from media",
    "listing_form.video_upload_help": "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)",
    "listing_form.image_upload_help": "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)",
    "listing_form.uploading_video": "Uploading video…",
    "Uploading video…": "Uploading video…",
    "listing_form.audio_episode": "Audio episode",
    "listing_form.audio_upload_help": "Upload an audio file or paste a public audio URL for the RSS feed.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Upload an audio file or paste a public audio URL for the RSS feed.",
    "listing_form.selected_file": "Selected: {name}",
    "listing_form.audio_url_help": "The URL is optional when a file is selected. Leave it blank to use the uploaded file.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "The URL is optional when a file is selected. Leave it blank to use the uploaded file.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Uploading audio…",
    "Uploading audio…": "Uploading audio…",
    "listing_form.validation_start_date": "Please select start date",
    "Please select start date": "Please select start date",
    "listing_form.validation_end_date": "Please select end date",
    "Please select end date": "Please select end date",
    "listing_form.validation_start_time": "Please select start time",
    "Please select start time": "Please select start time",
    "listing_form.validation_end_time": "Please select end time",
    "Please select end time": "Please select end time",
    "listing_form.weekdays_short": "Weekdays",
    "Weekdays": "Weekdays",
    "listing_form.weekend_short": "Weekend",
    "Weekend": "Weekend",
    "listing_form.click_add_schedule_help": "Click \"{action}\" to create your first schedule",
    "Click \"{action}\" to create your first schedule": "Click \"{action}\" to create your first schedule",
    "listing_form.schedule_form_intro": "Fill in the details below to",
    "Fill in the details below to": "Fill in the details below to",
    "listing_form.update": "Update",
    "listing_form.save": "Save",
    "listing_form.variant_value_required": "Please select at least one variant value (e.g., Color, Size)",
    "Please select at least one variant value (e.g., Color, Size)": "Please select at least one variant value (e.g., Color, Size)",
    "listing_form.valid_price_required": "Please enter a valid price",
    "Please enter a valid price": "Please enter a valid price",
    "listing_form.delete_variant_confirm": "Are you sure you want to delete this variant?",
    "Are you sure you want to delete this variant?": "Are you sure you want to delete this variant?",
    "listing_form.product_variants": "Product Variants",
    "Product Variants": "Product Variants",
    "listing_form.add_variant": "+ Add Variant",
    "+ Add Variant": "+ Add Variant",
    "listing_form.select_all_variants": "Select all variants",
    "Select all variants": "Select all variants",
    "listing_form.set_quantity_selected": "Set quantity for selected",
    "Set quantity for selected": "Set quantity for selected",
    "listing_form.quantity": "Quantity",
    "listing_form.apply_quantity": "Apply quantity",
    "Apply quantity": "Apply quantity",
    "listing_form.select_variant_number": "Select variant {number}",
    "Select variant {number}": "Select variant {number}",
    "listing_form.variant_number": "Variant #{number}",
    "Variant #{number}": "Variant #{number}",
    "listing_form.existing": "Existing",
    "Existing": "Existing",
    "listing_form.modified": "Modified",
    "Modified": "Modified",
    "listing_form.variant_name": "Variant Name",
    "Variant Name": "Variant Name",
    "listing_form.variant_values": "Variant Values",
    "Variant Values": "Variant Values",
    "listing_form.type": "Type",
    "listing_form.no_variant_values": "No variant values",
    "No variant values": "No variant values",
    "listing_form.no_variants_yet": "No variants yet",
    "No variants yet": "No variants yet",
    "listing_form.click_add_variant_help": "Click \"{action}\" to create your first variant",
    "Click \"{action}\" to create your first variant": "Click \"{action}\" to create your first variant",
    "listing_form.select_variant_type": "Select {type}",
    "Select {type}": "Select {type}",
    "listing_form.no_variant_types": "No variant types available. Please create variant types (like Color, Size) first.",
    "No variant types available. Please create variant types (like Color, Size) first.": "No variant types available. Please create variant types (like Color, Size) first.",
    "listing_form.generated_name": "Generated Name:",
    "Generated Name:": "Generated Name:",
    "listing_form.custom_title": "Custom Title",
    "Custom Title": "Custom Title",
    "listing_form.auto_generate_help": "Leave blank to auto-generate",
    "Leave blank to auto-generate": "Leave blank to auto-generate",
    "listing_form.save_variant": "Save Variant",
    "Save Variant": "Save Variant",
    "listing_form.start_time": "Start Time",
    "Start Time": "Start Time",
    "listing_form.end_time": "End Time",
    "End Time": "End Time",
    "listing_form.enter_capacity_limit": "Enter capacity limit",
    "Enter capacity limit": "Enter capacity limit",
    "collections.validation_title": "Title should not be empty",
    "Title should not be empty": "Title should not be empty",
    "collections.validation_platform": "Select at least one platform",
    "Select at least one platform": "Select at least one platform",
    "collections.validation_dates": "End Date must be later than start date",
    "End Date must be later than start date": "End Date must be later than start date",
    "collections.validation_minimum_selection": "Select at least one {type}",
    "Select at least one {type}": "Select at least one {type}",
    "collections.account": "account",
    "account": "account",
    "collections.listing": "listing",
    "listing": "listing",
    "collections.edit_title": "Edit Collection",
    "Edit Collection": "Edit Collection",
    "collections.create_title": "Create Collection",
    "Create Collection": "Create Collection",
    "collections.details": "Collection details",
    "Collection details": "Collection details",
    "collections.title_placeholder": "Enter title name",
    "Enter title name": "Enter title name",
    "collections.slug": "Slug",
    "collections.slug_placeholder": "Enter slug",
    "collections.enter_title_first": "Please enter a title first",
    "collections.scope": "Scope",
    "collections.accounts": "Accounts",
    "collections.listings": "Listings",
    "collections.choose_category": "Choose category",
    "collections.conditions": "Conditions",
    "Conditions": "Conditions",
    "collections.condition_type": "Condition type",
    "Condition type": "Condition type",
    "collections.manual": "Manual",
    "Manual": "Manual",
    "collections.automated": "Automated",
    "Automated": "Automated",
    "collections.availability": "Collections availability",
    "Collections availability": "Collections availability",
    "collections.schedule": "Schedule",
    "collections.applicable_channels": "Select applicable channel",
    "Select applicable channel": "Select applicable channel",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Search by name",
    "Search by name": "Search by name",
    "collections.not_found": "Collection not found.",
    "Collection not found.": "Collection not found.",
    "collections.featured_listings": "Featured listings",
    "Featured listings": "Featured listings",
    "collections.url_copied": "Public URL copied",
    "Public URL copied": "Public URL copied",
    "collections.url_copy_failed": "Unable to copy the public URL",
    "Unable to copy the public URL": "Unable to copy the public URL",
    "collections.collection": "Collection",
    "Collection": "Collection",
    "collections.this_collection": "this collection",
    "this collection": "this collection",
    "collections.share_text": "View {title}",
    "View {title}": "View {title}",
    "collections.public_url": "Public URL:",
    "Public URL:": "Public URL:",
    "collections.copy_url": "Copy URL",
    "Copy URL": "Copy URL",
    "collections.items": "Items",
    "collections.expires": "Expires",
    "Expires": "Expires",
    "collections.never": "Never",
    "Never": "Never",
    "collections.automatic_conditions": "Automatic Conditions",
    "Automatic Conditions": "Automatic Conditions",
    "collections.item_count": "{count} items",
    "{count} items": "{count} items",
    "collections.loading_items": "Loading items…",
    "Loading items…": "Loading items…",
    "collections.no_items": "No items in this collection yet.",
    "No items in this collection yet.": "No items in this collection yet.",
    "collections.delete_confirm": "Do you want to delete this collection?",
    "Do you want to delete this collection?": "Do you want to delete this collection?",
    "collections.title": "Collections",
    "collections.header_title": "Title",
    "collections.header_action": "Action",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Condition Type",
    "Condition Type": "Condition Type",
    "collections.header_scope": "Scope",
    "collections.header_start_date": "Start Date",
    "collections.header_end_date": "End Date",
    "collections.header_status": "Status",
    "collections.header_url": "URL",
    "common.calendar_view": "Calendar view",
    "Calendar view": "Calendar view",
    "common.deleted": "Deleted",
    "Deleted": "Deleted",
    "common.list_view": "List view",
    "common.description": "Description",
    "common.title": "Title",
    "common.end_date": "End Date",
    "common.start_date": "Start Date",
    "promotions.image_required": "Please add an image",
    "Please add an image": "Please add an image",
    "promotions.edit_title": "Edit Promotion",
    "Edit Promotion": "Edit Promotion",
    "promotions.add_title": "Add Promotion",
    "Add Promotion": "Add Promotion",
    "promotions.name": "Promotion Name",
    "Promotion Name": "Promotion Name",
    "promotions.select_medium": "Select Medium",
    "Select Medium": "Select Medium",
    "promotions.upload_media": "Upload Media",
    "promotions.schedule": "Schedule",
    "promotions.destination_type": "Destination Type",
    "Destination Type": "Destination Type",
    "promotions.placement": "Placement",
    "Placement": "Placement",
    "promotions.status": "Status (Inactive / Active)",
    "promotions.delete_confirm": "Do you want to delete this promotion?",
    "Do you want to delete this promotion?": "Do you want to delete this promotion?",
    "promotions.title": "Promotions",
    "promotions.header_image": "Image",
    "promotions.header_medium": "Medium",
    "Medium": "Medium",
    "promotions.header_placement": "Placement",
    "promotions.header_type": "Type",
    "promotions.header_value": "Value",
    "promotions.header_active": "Active",
    "promotions.header_action": "Action",
    "promotions.header_start_at": "Start At",
    "Start At": "Start At",
    "promotions.header_end_at": "End At",
    "End At": "End At",
    "common.grid_view": "Grid view",
    "promotions.type_general": "General",
    "promotions.type_listing": "Listing",
    "promotions.type_account": "Account",
    "promotions.type_external_link": "External link",
    "External link": "External link",
    "promotions.preview": "Preview",
    "promotions.select_listing": "Select Listing",
    "Select Listing": "Select Listing",
    "promotions.select_account": "Select Account",
    "Select Account": "Select Account",
    "promotions.home_placement": "Home",
    "promotions.footer_placement": "Footer",
    "Footer": "Footer",
    "promotions.web_only": "(Web Only)",
    "(Web Only)": "(Web Only)",
    "coupons.edit_title": "Edit Coupon",
    "Edit Coupon": "Edit Coupon",
    "coupons.add_title": "Add Coupon",
    "Add Coupon": "Add Coupon",
    "coupons.reference_name": "Reference Name",
    "Reference Name": "Reference Name",
    "coupons.enter_name": "Enter name",
    "coupons.coupon_type": "Coupon type",
    "Coupon type": "Coupon type",
    "coupons.discount_value": "Discount Value",
    "Discount Value": "Discount Value",
    "coupons.enter_discount_value": "Enter discount value",
    "Enter discount value": "Enter discount value",
    "coupons.code": "Code",
    "coupons.code_example": "Ex: HOLIDAY10",
    "Ex: HOLIDAY10": "Ex: HOLIDAY10",
    "coupons.short_code": "Short Code",
    "coupons.enter_short_code": "Enter short code",
    "coupons.advanced": "ADVANCED",
    "ADVANCED": "ADVANCED",
    "coupons.minimum_amount": "Minimum Amount",
    "coupons.enter_minimum_amount": "Enter minimum amount",
    "coupons.maximum_amount": "Maximum Amount",
    "coupons.enter_maximum_amount": "Enter maximum amount",
    "coupons.maximum_discount_amount": "Maximum Discount Amount",
    "Maximum Discount Amount": "Maximum Discount Amount",
    "coupons.enter_maximum_discount_amount": "Enter maximum discount amount",
    "Enter maximum discount amount": "Enter maximum discount amount",
    "coupons.maximum_uses": "Maximum Uses",
    "Maximum Uses": "Maximum Uses",
    "coupons.enter_maximum_uses": "Enter maximum uses",
    "Enter maximum uses": "Enter maximum uses",
    "coupons.maximum_uses_per_user": "Maximum Uses Per User",
    "Maximum Uses Per User": "Maximum Uses Per User",
    "coupons.enter_maximum_uses_per_user": "Enter maximum uses per user",
    "Enter maximum uses per user": "Enter maximum uses per user",
    "coupons.new_user_only": "New User",
    "New User": "New User",
    "coupons.enter_note": "Enter note",
    "coupons.start_date_time": "Start Date Time",
    "Start Date Time": "Start Date Time",
    "coupons.end_date_time": "End Date Time",
    "End Date Time": "End Date Time",
    "coupons.select_start_date_time": "Select start date time",
    "Select start date time": "Select start date time",
    "coupons.select_end_date_time": "Select end date time",
    "Select end date time": "Select end date time",
    "coupons.flat_example": "Flat (Ex: $10)",
    "Flat (Ex: $10)": "Flat (Ex: $10)",
    "coupons.percentage_example": "Percentage (Ex: 10%)",
    "Percentage (Ex: 10%)": "Percentage (Ex: 10%)",
    "coupons.delete_confirm": "Do you want to delete this coupon?",
    "Do you want to delete this coupon?": "Do you want to delete this coupon?",
    "coupons.title": "Coupons",
    "coupons.header_name": "Name",
    "coupons.header_code": "Code",
    "coupons.header_coupon_type": "Coupon Type",
    "Coupon Type": "Coupon Type",
    "coupons.header_start_date_time": "Start Date Time",
    "coupons.header_end_date_time": "End Date Time",
    "coupons.header_active": "Active",
    "coupons.header_action": "Action",
    "coupons.load_error": "Unable to load this coupon.",
    "Unable to load this coupon.": "Unable to load this coupon.",
    "coupons.expired": "Expired",
    "Expired": "Expired",
    "coupons.total_orders": "Total Orders",
    "coupons.unique_customers": "Unique Customers",
    "Unique Customers": "Unique Customers",
    "coupons.revenue": "Revenue",
    "coupons.average_transaction": "Avg Transaction",
    "Avg Transaction": "Avg Transaction",
    "coupons.paid_orders": "Paid Orders",
    "coupons.uses_remaining": "Uses Remaining",
    "Uses Remaining": "Uses Remaining",
    "coupons.unlimited": "Unlimited",
    "Unlimited": "Unlimited",
    "coupons.performance": "Performance",
    "Performance": "Performance",
    "coupons.usage_against_limit": "Usage against limit",
    "Usage against limit": "Usage against limit",
    "coupons.details": "Details",
    "coupons.discount": "Discount",
    "coupons.minimum_order": "Min order",
    "Min order": "Min order",
    "coupons.maximum_discount": "Max discount",
    "Max discount": "Max discount",
    "coupons.maximum_total_uses": "Max total uses",
    "Max total uses": "Max total uses",
    "coupons.maximum_per_user": "Max / user",
    "Max / user": "Max / user",
    "coupons.new_users_only": "New users only",
    "New users only": "New users only",
    "coupons.valid_from": "Valid from",
    "Valid from": "Valid from",
    "coupons.valid_until": "Valid until",
    "Valid until": "Valid until",
    "coupons.orders": "Orders",
    "coupons.no_orders": "No orders have used this coupon yet",
    "No orders have used this coupon yet": "No orders have used this coupon yet",
    "coupons.orders_header_order": "Order",
    "coupons.orders_header_customer": "Customer",
    "coupons.orders_header_date": "Date",
    "coupons.orders_header_amount": "Amount",
    "coupons.orders_header_status": "Status",
    "coupons.paid": "Paid",
    "coupons.pending": "Pending",
    "coupons.coupon": "Coupon",
    "coupons.detail_title": "Coupon Detail",
    "Coupon Detail": "Coupon Detail",
    "coupons.discount_percentage": "{value}% off",
    "{value}% off": "{value}% off",
    "coupons.discount_flat": "{value} flat off",
    "{value} flat off": "{value} flat off",
    "coupons.type_direct_discount": "Direct discount",
    "Direct discount": "Direct discount",
    "collections.condition_and": "AND",
    "AND": "AND",
    "collections.condition_or": "OR",
    "OR": "OR",
    "users.first_seen": "First seen",
    "First seen": "First seen",
    "users.last_seen": "Last seen",
    "Last seen": "Last seen",
    "users.avg_order": "Avg order",
    "Avg order": "Avg order",
    "users.purchase_value": "Purchase value",
    "Purchase value": "Purchase value",
    "users.price_range": "Price range",
    "Price range": "Price range",
    "users.attributes": "Attributes",
    "users.detail_title": "User Detail",
    "User Detail": "User Detail",
    "users.detail_orders_list": "User Orders List",
    "User Orders List": "User Orders List",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "As a Buyer",
    "As a Buyer": "As a Buyer",
    "users.as_seller": "As a Seller",
    "As a Seller": "As a Seller",
    "users.health": "Health",
    "users.no_listings": "No listings yet",
    "users.no_accounts": "No accounts yet",
    "No accounts yet": "No accounts yet",
    "users.top_categories": "Top categories",
    "Top categories": "Top categories",
    "users.top_listings": "Top listings",
    "Top listings": "Top listings",
    "users.recent_activity": "Recent activity",
    "Recent activity": "Recent activity",
    "users.acquisition": "Acquisition",
    "Acquisition": "Acquisition",
    "users.sent_emails": "Sent Emails",
    "Sent Emails": "Sent Emails",
    "users.no_emails_sent": "No emails sent",
    "No emails sent": "No emails sent",
    "users.load_more_emails": "Load More ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Load More ({loaded} / {total})",
    "users.email_to": "To: {email}",
    "To: {email}": "To: {email}",
    "users.sending_email": "Sending…",
    "users.send_email": "Send Email",
    "Send Email": "Send Email",
    "users.send_email_title": "Send Email — {name}",
    "Send Email — {name}": "Send Email — {name}",
    "users.customer": "Customer",
    "users.block_named": "Block {name}",
    "Block {name}": "Block {name}",
    "users.unblock_named": "Unblock {name}",
    "Unblock {name}": "Unblock {name}",
    "users.email_sent": "Email sent successfully",
    "Email sent successfully": "Email sent successfully",
    "users.email_send_failed": "Failed to send email",
    "Failed to send email": "Failed to send email",
    "common.value": "Value",
    "users.email_bounced": "Bounced",
    "Bounced": "Bounced",
    "users.email_complained": "Complained",
    "Complained": "Complained",
    "users.unverified": "Unverified",
    "Unverified": "Unverified",
    "users.otp_enabled": "OTP Enabled",
    "OTP Enabled": "OTP Enabled",
    "users.account_info": "Account Info",
    "Account Info": "Account Info",
    "users.mobile": "Mobile",
    "users.locale": "Locale",
    "Locale": "Locale",
    "users.joined": "Joined",
    "users.following": "Following",
    "Following": "Following",
    "users.email_health": "Email Health",
    "Email Health": "Email Health",
    "users.orders": "Orders",
    "users.no_orders": "No orders",
    "No orders": "No orders",
    "users.order_reference": "Order {number}",
    "Order {number}": "Order {number}",
    "users.order_ref": "Ref: {reference}",
    "Ref: {reference}": "Ref: {reference}",
    "users.unpaid": "Unpaid",
    "users.revenue_ltv": "Revenue & LTV",
    "Revenue & LTV": "Revenue & LTV",
    "users.total_spent": "Total Spent",
    "Total Spent": "Total Spent",
    "users.paid_order_count": "{count} paid orders",
    "{count} paid orders": "{count} paid orders",
    "users.average_order": "Avg Order",
    "users.of_total_orders": "of {count} total",
    "of {count} total": "of {count} total",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} active",
    "{count} active": "{count} active",
    "users.at_risk": "At Risk",
    "At Risk": "At Risk",
    "common.today": "Today",
    "common.yesterday": "Yesterday",
    "Yesterday": "Yesterday",
    "users.days_ago": "{count} days ago",
    "{count} days ago": "{count} days ago",
    "users.months_ago": "{count} months ago",
    "{count} months ago": "{count} months ago",
    "users.years_ago": "{count} years ago",
    "{count} years ago": "{count} years ago",
    "users.last_order": "Last order",
    "Last order": "Last order",
    "users.last_listing": "Last listing",
    "Last listing": "Last listing",
    "users.events": "Events",
    "users.viewed": "Viewed",
    "Viewed": "Viewed",
    "users.cart": "Cart",
    "users.checkouts": "Checkouts",
    "Checkouts": "Checkouts",
    "users.purchases": "Purchases",
    "Purchases": "Purchases",
    "users.last_30_days": "Last 30 days",
    "Last 30 days": "Last 30 days",
    "users.no_analytics": "No analytics data for this user yet.",
    "No analytics data for this user yet.": "No analytics data for this user yet.",
    "users.analytics_unavailable": "Analytics unavailable for this tenant.",
    "Analytics unavailable for this tenant.": "Analytics unavailable for this tenant.",
    "users.account_number": "Account #{number}",
    "Account #{number}": "Account #{number}",
    "users.no_subject": "No Subject",
    "No Subject": "No Subject",
    "common.unknown": "Unknown",
    "users.opened": "Opened",
    "Opened": "Opened",
    "users.not_opened": "Not opened",
    "Not opened": "Not opened",
    "users.user_action_success": "User action completed",
    "User action completed": "User action completed",
    "common.pending": "Pending",
    "common.never": "Never",
    "users.customer_analytics": "Customer Analytics",
    "Customer Analytics": "Customer Analytics",
    "users.analytics": "Analytics",
    "users.emails": "Emails",
    "Emails": "Emails",
    "users.first_visit": "First visit",
    "First visit": "First visit",
    "users.latest_visit": "Latest visit",
    "Latest visit": "Latest visit",
    "users.landing_page": "Landing page",
    "Landing page": "Landing page",
    "users.referrer": "Referrer",
    "Referrer": "Referrer",
    "users.utm_source": "UTM source",
    "UTM source": "UTM source",
    "users.utm_medium": "UTM medium",
    "UTM medium": "UTM medium",
    "users.utm_campaign": "UTM campaign",
    "UTM campaign": "UTM campaign",
    "users.utm_term": "UTM term",
    "UTM term": "UTM term",
    "users.utm_content": "UTM content",
    "UTM content": "UTM content",
    "users.ai_source": "AI source",
    "AI source": "AI source",
    "rewards.edit_scope": "Edit scope",
    "Edit scope": "Edit scope",
    "rewards.add_scope": "Add scope",
    "Add scope": "Add scope",
    "rewards.save_scope": "Save scope",
    "Save scope": "Save scope",
    "rewards.scope_type": "Scope type",
    "Scope type": "Scope type",
    "rewards.scope_reference": "Scope reference",
    "Scope reference": "Scope reference",
    "rewards.match_config": "Match config",
    "Match config": "Match config",
    "rewards.priority_order": "Priority order",
    "Priority order": "Priority order",
    "rewards.active": "Active",
    "rewards.scope_active": "Scope is active",
    "Scope is active": "Scope is active",
    "rewards.edit_rule": "Edit rule",
    "Edit rule": "Edit rule",
    "rewards.add_rule": "Add rule",
    "Add rule": "Add rule",
    "rewards.save_rule": "Save rule",
    "Save rule": "Save rule",
    "rewards.trigger_event": "Trigger event",
    "Trigger event": "Trigger event",
    "rewards.beneficiary_type": "Beneficiary type",
    "Beneficiary type": "Beneficiary type",
    "rewards.beneficiary_config": "Beneficiary config",
    "Beneficiary config": "Beneficiary config",
    "rewards.eligibility": "Eligibility",
    "Eligibility": "Eligibility",
    "rewards.conditions": "Conditions",
    "rewards.priority": "Priority",
    "Priority": "Priority",
    "rewards.edit_component": "Edit recipe component",
    "Edit recipe component": "Edit recipe component",
    "rewards.add_component": "Add recipe component",
    "Add recipe component": "Add recipe component",
    "rewards.save_component": "Save component",
    "Save component": "Save component",
    "rewards.rule": "Rule",
    "Rule": "Rule",
    "rewards.component_key": "Component key",
    "Component key": "Component key",
    "rewards.component_type": "Component type",
    "Component type": "Component type",
    "rewards.commission_definition": "Commission definition",
    "Commission definition": "Commission definition",
    "rewards.config": "Config",
    "rewards.position": "Position",
    "Position": "Position",
    "rewards.component": "Component",
    "Component": "Component",
    "rewards.status.draft": "Draft",
    "rewards.status.active": "Active",
    "rewards.status.paused": "Paused",
    "Paused": "Paused",
    "rewards.status.archived": "Archived",
    "rewards.configuration_updated": "Reward configuration updated",
    "Reward configuration updated": "Reward configuration updated",
    "rewards.configuration_added": "Reward configuration added",
    "Reward configuration added": "Reward configuration added",
    "rewards.archive_item_confirm": "Archive {name}?",
    "Archive {name}?": "Archive {name}?",
    "rewards.empty_scopes": "No scopes configured yet.",
    "No scopes configured yet.": "No scopes configured yet.",
    "rewards.empty_rules": "No rules configured yet.",
    "No rules configured yet.": "No rules configured yet.",
    "rewards.empty_components": "No components configured yet.",
    "No components configured yet.": "No components configured yet.",
    "rewards.edit_program": "Edit reward program",
    "Edit reward program": "Edit reward program",
    "rewards.new_program": "New reward program",
    "New reward program": "New reward program",
    "rewards.create_program": "Create program",
    "Create program": "Create program",
    "rewards.program_type": "Program type",
    "Program type": "Program type",
    "rewards.starts_at": "Starts at",
    "Starts at": "Starts at",
    "rewards.ends_at": "Ends at",
    "Ends at": "Ends at",
    "rewards.program_updated": "Reward program updated",
    "Reward program updated": "Reward program updated",
    "rewards.program_created": "Reward program created",
    "Reward program created": "Reward program created",
    "rewards.archive_program_confirm": "Archive {name}?",
    "rewards.program_archived": "Reward program archived",
    "Reward program archived": "Reward program archived",
    "rewards.tab.overview": "Overview",
    "rewards.tab.programs": "Programs",
    "Programs": "Programs",
    "rewards.tab.impact": "Impact",
    "Impact": "Impact",
    "rewards.tab.attribution": "Tracking",
    "Tracking": "Tracking",
    "rewards.page_description": "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.",
    "rewards.program": "Program",
    "Program": "Program",
    "rewards.starts": "Starts",
    "Starts": "Starts",
    "rewards.no_programs": "No reward programs yet.",
    "No reward programs yet.": "No reward programs yet.",
    "rewards.program_title": "Reward program",
    "Reward program": "Reward program",
    "rewards.back_to_rewards": "Back to rewards",
    "Back to rewards": "Back to rewards",
    "common.archive": "Archive",
    "Archive": "Archive",
    "common.save_changes": "Save changes",
    "common.none": "None",
    "common.this_item": "this item",
    "this item": "this item",
    "rewards.tab.scopes": "Scopes",
    "Scopes": "Scopes",
    "rewards.tab.rules": "Rules",
    "Rules": "Rules",
    "rewards.tab.components": "Recipe components",
    "Recipe components": "Recipe components",
    "rewards.reference": "Reference",
    "rewards.trigger": "Trigger",
    "Trigger": "Trigger",
    "rewards.beneficiary": "Beneficiary",
    "Beneficiary": "Beneficiary",
    "rewards.attributed_conversions": "Attributed conversions",
    "Attributed conversions": "Attributed conversions",
    "rewards.new_customers": "New customers",
    "New customers": "New customers",
    "rewards.revenue_influenced": "Revenue influenced",
    "Revenue influenced": "Revenue influenced",
    "rewards.rewards_issued": "Rewards issued",
    "Rewards issued": "Rewards issued",
    "rewards.live_business_results": "Live business results",
    "Live business results": "Live business results",
    "rewards.impact_at_a_glance": "Impact at a glance",
    "Impact at a glance": "Impact at a glance",
    "rewards.impact_last_30_days": "A live view of completed orders and partner results from the last 30 days.",
    "A live view of completed orders and partner results from the last 30 days.": "A live view of completed orders and partner results from the last 30 days.",
    "rewards.view_full_impact": "View full impact",
    "View full impact": "View full impact",
    "rewards.impact_load_error": "Impact data could not be loaded: {error}",
    "Impact data could not be loaded: {error}": "Impact data could not be loaded: {error}",
    "rewards.programs": "Programs",
    "rewards.programs_configured": "Reward programs configured for this workspace.",
    "Reward programs configured for this workspace.": "Reward programs configured for this workspace.",
    "rewards.programs_eligible": "Programs currently eligible for evaluation.",
    "Programs currently eligible for evaluation.": "Programs currently eligible for evaluation.",
    "rewards.drafts": "Drafts",
    "Drafts": "Drafts",
    "rewards.programs_being_configured": "Programs still being configured.",
    "Programs still being configured.": "Programs still being configured.",
    "rewards.clicks": "Clicks",
    "rewards.completed_orders": "Completed orders",
    "Completed orders": "Completed orders",
    "rewards.conversion_rate": "Conversion rate",
    "Conversion rate": "Conversion rate",
    "rewards.revenue": "Revenue",
    "rewards.live_connection": "Live connection",
    "Live connection": "Live connection",
    "rewards.attribution_activity": "Attribution activity",
    "Attribution activity": "Attribution activity",
    "rewards.connected_workspace": "Connected to {name}.",
    "Connected to {name}.": "Connected to {name}.",
    "rewards.your_attribution_workspace": "your Attribution workspace",
    "your Attribution workspace": "your Attribution workspace",
    "rewards.loading_workspace": "Loading your connected Attribution workspace.",
    "Loading your connected Attribution workspace.": "Loading your connected Attribution workspace.",
    "rewards.open_attribution": "Open Attribution",
    "Open Attribution": "Open Attribution",
    "rewards.connection_attention": "Connection needs attention",
    "Connection needs attention": "Connection needs attention",
    "rewards.open_attribution_workspace": "Open Attribution workspace",
    "Open Attribution workspace": "Open Attribution workspace",
    "rewards.workspace_connected": "Workspace connected",
    "Workspace connected": "Workspace connected",
    "rewards.workspace_not_linked": "Workspace not linked yet",
    "Workspace not linked yet": "Workspace not linked yet",
    "rewards.attribution_data_connected": "Live clicks, links, campaigns, and completed orders are being read from Attribution.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Live clicks, links, campaigns, and completed orders are being read from Attribution.",
    "rewards.connect_workspace_prompt": "Open Attribution to connect this workspace before tracking activity.",
    "Open Attribution to connect this workspace before tracking activity.": "Open Attribution to connect this workspace before tracking activity.",
    "rewards.successful_referrals": "Successful referrals",
    "Successful referrals": "Successful referrals",
    "rewards.new_customers_acquired": "New customers acquired",
    "New customers acquired": "New customers acquired",
    "rewards.gross_revenue_influenced": "Gross revenue influenced",
    "Gross revenue influenced": "Gross revenue influenced",
    "rewards.reward_cost": "Reward cost",
    "Reward cost": "Reward cost",
    "rewards.net_revenue": "Net revenue",
    "Net revenue": "Net revenue",
    "rewards.average_order_value": "Average order value",
    "Average order value": "Average order value",
    "rewards.cost_per_acquisition": "Cost per acquisition",
    "Cost per acquisition": "Cost per acquisition",
    "rewards.repeat_purchase_rate": "Repeat purchase rate",
    "Repeat purchase rate": "Repeat purchase rate",
    "rewards.business_outcome_reporting": "Business outcome reporting",
    "Business outcome reporting": "Business outcome reporting",
    "rewards.impact": "Impact",
    "rewards.impact_description": "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.",
    "rewards.from": "From",
    "rewards.to": "To",
    "rewards.trend": "Trend",
    "Trend": "Trend",
    "rewards.daily": "Daily",
    "rewards.weekly": "Weekly",
    "Weekly": "Weekly",
    "rewards.top_partners": "Top partners / referrers",
    "Top partners / referrers": "Top partners / referrers",
    "rewards.partner": "Partner",
    "Partner": "Partner",
    "rewards.conversions": "Conversions",
    "Conversions": "Conversions",
    "rewards.no_partner_data": "No attributed partner data for this period.",
    "No attributed partner data for this period.": "No attributed partner data for this period.",
    "rewards.period": "Period",
    "rewards.no_trend_data": "No trend data for this period.",
    "No trend data for this period.": "No trend data for this period.",
    "rewards.campaign_performance": "Campaign performance",
    "Campaign performance": "Campaign performance",
    "rewards.campaign_count": "{count} campaigns",
    "{count} campaigns": "{count} campaigns",
    "rewards.campaign": "Campaign",
    "rewards.orders": "Orders",
    "rewards.rate": "Rate",
    "Rate": "Rate",
    "rewards.no_campaign_activity": "No campaign activity yet. Create a tracking link in Attribution to start measuring results.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "No campaign activity yet. Create a tracking link in Attribution to start measuring results.",
    "rewards.recent_completed_orders": "Recent completed orders",
    "Recent completed orders": "Recent completed orders",
    "rewards.recent_events_count": "{count} recent events",
    "{count} recent events": "{count} recent events",
    "rewards.event": "Event",
    "rewards.completed_order": "Completed order",
    "Completed order": "Completed order",
    "rewards.no_completed_order_activity": "No completed order activity has arrived yet.",
    "No completed order activity has arrived yet.": "No completed order activity has arrived yet.",
    "rewards.impact_data_quality_note": "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.",
    "subscriptions.type.free": "Free Subscription",
    "Free Subscription": "Free Subscription",
    "subscriptions.form.title_placeholder": "Subscription Title",
    "Subscription Title": "Subscription Title",
    "subscriptions.form.title_help": "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).",
    "subscriptions.form.description_placeholder": "Subscription Description",
    "Subscription Description": "Subscription Description",
    "subscriptions.form.description_help": "Provide a detailed description of the subscription, outlining its features and benefits.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Provide a detailed description of the subscription, outlining its features and benefits.",
    "subscriptions.form.select_currency": "Select Currency",
    "Select Currency": "Select Currency",
    "subscriptions.form.currency_help": "Select the currency for the subscription from the dropdown menu (Your default currency)",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Select the currency for the subscription from the dropdown menu (Your default currency)",
    "subscriptions.form.amount_placeholder": "Subscription Amount",
    "Subscription Amount": "Subscription Amount",
    "subscriptions.form.amount_help": "Enter the subscription price.",
    "Enter the subscription price.": "Enter the subscription price.",
    "subscriptions.form.sku_placeholder": "Subscription SKU",
    "Subscription SKU": "Subscription SKU",
    "subscriptions.form.sku_help": "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).",
    "subscriptions.form.allowed_listings": "Allowed Listings",
    "Allowed Listings": "Allowed Listings",
    "subscriptions.form.allowed_listings_placeholder": "Subscription Allowed Listings",
    "Subscription Allowed Listings": "Subscription Allowed Listings",
    "subscriptions.form.allowed_listings_help": "Specify the number of listings allowed for this subscription.",
    "Specify the number of listings allowed for this subscription.": "Specify the number of listings allowed for this subscription.",
    "subscriptions.form.fixed_fee_per_order": "Fixed Fee Per Order",
    "Fixed Fee Per Order": "Fixed Fee Per Order",
    "subscriptions.form.fixed_fee_placeholder": "Subscription Fee Fixed Per Order",
    "Subscription Fee Fixed Per Order": "Subscription Fee Fixed Per Order",
    "subscriptions.form.fixed_fee_help": "Enter a fixed fee per order, if applicable.",
    "Enter a fixed fee per order, if applicable.": "Enter a fixed fee per order, if applicable.",
    "subscriptions.form.commission_percent_per_order": "Commission % Per Order",
    "Commission % Per Order": "Commission % Per Order",
    "subscriptions.form.commission_placeholder": "Subscription Commission Percent Per Order",
    "Subscription Commission Percent Per Order": "Subscription Commission Percent Per Order",
    "subscriptions.form.commission_help": "Enter the commission percentage per order, if applicable.",
    "Enter the commission percentage per order, if applicable.": "Enter the commission percentage per order, if applicable.",
    "subscriptions.form.expiry_days": "Expiry Days",
    "Expiry Days": "Expiry Days",
    "subscriptions.form.expiry_days_placeholder": "Subscription Expiry Days",
    "Subscription Expiry Days": "Subscription Expiry Days",
    "subscriptions.form.expiry_days_help": "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days",
    "subscriptions.form.payment_method": "Payment Method",
    "subscriptions.form.select_type": "Select Type",
    "subscriptions.form.payment_method_help": "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).",
    "subscriptions.form.active_placeholder": "Subscription Active",
    "Subscription Active": "Subscription Active",
    "subscriptions.form.active_help": "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.",
    "subscriptions.add_title": "Add new subscription product",
    "Add new subscription product": "Add new subscription product",
    "subscriptions.edit_title": "Edit subscription product",
    "Edit subscription product": "Edit subscription product",
    "subscriptions.added_success": "Subscription listing added successfully",
    "Subscription listing added successfully": "Subscription listing added successfully",
    "subscriptions.updated_success": "Subscription listing updated successfully",
    "Subscription listing updated successfully": "Subscription listing updated successfully",
    "common.currency": "Currency",
    "common.sku": "SKU",
    "subscriptions.title": "Subscriptions",
    "subscriptions.add_subscription": "Add subscription",
    "Add subscription": "Add subscription",
    "subscriptions.plans": "Plans",
    "subscriptions.active_subscribers": "Active Subscribers",
    "Active Subscribers": "Active Subscribers",
    "subscriptions.total_mrr": "Total MRR",
    "Total MRR": "Total MRR",
    "subscriptions.churn_rate": "Churn Rate",
    "Churn Rate": "Churn Rate",
    "subscriptions.new_this_month": "New This Month",
    "New This Month": "New This Month",
    "subscriptions.average_duration": "Avg Duration",
    "Avg Duration": "Avg Duration",
    "subscriptions.monthly_recurring_revenue": "Monthly Recurring Revenue",
    "Monthly Recurring Revenue": "Monthly Recurring Revenue",
    "subscriptions.annual_run_rate": "Annual Run Rate",
    "Annual Run Rate": "Annual Run Rate",
    "subscriptions.last_30_days": "Last 30 days",
    "subscriptions.subscriber_lifetime": "Subscriber lifetime",
    "Subscriber lifetime": "Subscriber lifetime",
    "subscriptions.subscriber_distribution": "Subscriber Distribution",
    "Subscriber Distribution": "Subscriber Distribution",
    "subscriptions.billing_period": "Billing Period",
    "Billing Period": "Billing Period",
    "subscriptions.allowed_listings": "Allowed Listings",
    "subscriptions.commission_per_order": "Commission per Order",
    "Commission per Order": "Commission per Order",
    "subscriptions.fixed_fee_per_order": "Fixed Fee per Order",
    "Fixed Fee per Order": "Fixed Fee per Order",
    "subscriptions.payment_provider": "Payment Provider",
    "Payment Provider": "Payment Provider",
    "subscriptions.sku_product_id": "SKU / Product ID",
    "SKU / Product ID": "SKU / Product ID",
    "subscriptions.revenue_over_time": "Revenue Over Time",
    "Revenue Over Time": "Revenue Over Time",
    "subscriptions.revenue": "Revenue",
    "subscriptions.subscriber_growth": "Subscriber Growth",
    "Subscriber Growth": "Subscriber Growth",
    "subscriptions.subscribers": "Subscribers",
    "Subscribers": "Subscribers",
    "subscriptions.set_inactive": "Set Inactive",
    "Set Inactive": "Set Inactive",
    "subscriptions.set_active": "Set Active",
    "Set Active": "Set Active",
    "subscriptions.plan_title": "Subscription Plan",
    "Subscription Plan": "Subscription Plan",
    "subscriptions.status.active": "Active",
    "subscriptions.status.cancelled": "Cancelled",
    "subscriptions.status.expired": "Expired",
    "subscriptions.status.trial": "Trial",
    "Trial": "Trial",
    "subscriptions.status.pending": "Pending",
    "subscriptions.period.lifetime": "Lifetime",
    "Lifetime": "Lifetime",
    "subscriptions.period.daily": "Daily",
    "subscriptions.period.weekly": "Weekly",
    "subscriptions.period.monthly": "Monthly",
    "Monthly": "Monthly",
    "subscriptions.period.quarterly": "Quarterly",
    "Quarterly": "Quarterly",
    "subscriptions.period.semi_annual": "Semi-annual",
    "Semi-annual": "Semi-annual",
    "subscriptions.period.annual": "Annual",
    "Annual": "Annual",
    "subscriptions.period.days": "{count} days",
    "subscriptions.period.day": "/ day",
    "/ day": "/ day",
    "subscriptions.period.week": "/ week",
    "/ week": "/ week",
    "subscriptions.period.month": "/ month",
    "/ month": "/ month",
    "subscriptions.period.quarter": "/ quarter",
    "/ quarter": "/ quarter",
    "subscriptions.period.six_months": "/ 6 months",
    "/ 6 months": "/ 6 months",
    "subscriptions.period.year": "/ year",
    "/ year": "/ year",
    "subscriptions.listings_count": "{count} listings",
    "{count} listings": "{count} listings",
    "subscriptions.commission_percentage": "{rate}% commission",
    "{rate}% commission": "{rate}% commission",
    "subscriptions.per_order": "/ order",
    "/ order": "/ order",
    "subscriptions.view_details_subscribers": "View details and subscribers",
    "View details and subscribers": "View details and subscribers",
    "subscriptions.edit_subscription": "Edit subscription",
    "Edit subscription": "Edit subscription",
    "subscriptions.delete_subscription": "Delete subscription",
    "Delete subscription": "Delete subscription",
    "subscriptions.deleted": "Subscription deleted",
    "Subscription deleted": "Subscription deleted",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Android IAP",
    "Android IAP": "Android IAP",
    "subscriptions.type.ios": "iOS IAP",
    "iOS IAP": "iOS IAP",
    "subscriptions.type.free_subscription": "Free",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "{count} loaded",
    "subscriptions.no_subscribers": "No {status} subscribers.",
    "No {status} subscribers.": "No {status} subscribers.",
    "subscriptions.billing_records": "Billing Records",
    "Billing Records": "Billing Records",
    "subscriptions.no_invoices": "No invoices found.",
    "No invoices found.": "No invoices found.",
    "subscriptions.column.account": "Account",
    "subscriptions.column.email": "Email",
    "subscriptions.column.status": "Status",
    "subscriptions.column.subscribed": "Subscribed",
    "Subscribed": "Subscribed",
    "subscriptions.column.expires": "Expires",
    "subscriptions.column.next_renewal": "Next Renewal",
    "Next Renewal": "Next Renewal",
    "subscriptions.column.amount_paid": "Amount Paid",
    "Amount Paid": "Amount Paid",
    "subscriptions.invoice_column.invoice_id": "Invoice ID",
    "Invoice ID": "Invoice ID",
    "subscriptions.invoice_column.account": "Account",
    "subscriptions.invoice_column.amount": "Amount",
    "subscriptions.invoice_column.status": "Status",
    "subscriptions.invoice_column.period": "Period",
    "subscriptions.invoice_column.paid_at": "Paid At",
    "Paid At": "Paid At",
    "subscriptions.validation.title_required": "Title is required",
    "subscriptions.validation.allowed_listings_positive": "Allowed listings should be greater than 0",
    "Allowed listings should be greater than 0": "Allowed listings should be greater than 0",
    "subscriptions.validation.currency_required": "Currency is required",
    "Currency is required": "Currency is required",
    "subscriptions.validation.expiry_required": "Expiry days are required",
    "Expiry days are required": "Expiry days are required",
    "subscriptions.validation.payment_method_required": "Payment method is required",
    "Payment method is required": "Payment method is required",
    "subscriptions.error.save": "Something went wrong while saving the subscription.",
    "Something went wrong while saving the subscription.": "Something went wrong while saving the subscription.",
    "subscriptions.error.delete": "Something went wrong while deleting the subscription.",
    "Something went wrong while deleting the subscription.": "Something went wrong while deleting the subscription.",
    "common.configuration": "Configuration",
    "subscriptions.per_period": "per {period}",
    "per {period}": "per {period}",
    "subscriptions.tab.subscribers": "Subscribers",
    "subscriptions.tab.invoices": "Invoices",
    "subscriptions.account_title": "Account Subscription",
    "Account Subscription": "Account Subscription",
    "subscriptions.config.description": "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.",
    "subscriptions.config.enable": "Enable subscriptions",
    "Enable subscriptions": "Enable subscriptions",
    "subscriptions.config.type": "Subscription type",
    "Subscription type": "Subscription type",
    "subscriptions.config.purchased_message": "Message when a subscription is already purchased",
    "Message when a subscription is already purchased": "Message when a subscription is already purchased",
    "subscriptions.config.purchased_placeholder": "Enter the already-purchased message",
    "Enter the already-purchased message": "Enter the already-purchased message",
    "subscriptions.config.listings_exhausted_message": "Message when the listing limit is reached",
    "Message when the listing limit is reached": "Message when the listing limit is reached",
    "subscriptions.config.listings_exhausted_placeholder": "Enter the listing limit message",
    "Enter the listing limit message": "Enter the listing limit message",
    "subscriptions.config.inactive_message": "Message when the subscription is inactive",
    "Message when the subscription is inactive": "Message when the subscription is inactive",
    "subscriptions.config.inactive_placeholder": "Enter the inactive subscription message",
    "Enter the inactive subscription message": "Enter the inactive subscription message",
    "subscriptions.config.saved": "Subscription settings saved successfully",
    "Subscription settings saved successfully": "Subscription settings saved successfully",
    "people.title": "People",
    "people.tab.staff": "Staff",
    "Staff": "Staff",
    "people.tab.departments": "Departments",
    "Departments": "Departments",
    "people.tab.job_profiles": "Job profiles",
    "Job profiles": "Job profiles",
    "people.tab.pay_grades": "Pay grades",
    "Pay grades": "Pay grades",
    "people.action.add_staff": "Add staff",
    "Add staff": "Add staff",
    "people.action.add_department": "Add department",
    "Add department": "Add department",
    "people.action.add_job_profile": "Add job profile",
    "Add job profile": "Add job profile",
    "people.action.add_pay_grade": "Add pay grade",
    "Add pay grade": "Add pay grade",
    "people.currency_id": "Currency ID",
    "people.onboarding.eyebrow": "Get started with People",
    "Get started with People": "Get started with People",
    "people.onboarding.title": "Build your team directory",
    "Build your team directory": "Build your team directory",
    "people.onboarding.description": "Add your first staff member, then organize your team with departments, job profiles, and pay grades.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Add your first staff member, then organize your team with departments, job profiles, and pay grades.",
    "people.onboarding.add_first": "Add your first staff member",
    "Add your first staff member": "Add your first staff member",
    "people.onboarding.step_staff": "Add staff",
    "people.onboarding.step_staff_description": "Link an existing user to your staff directory.",
    "Link an existing user to your staff directory.": "Link an existing user to your staff directory.",
    "people.onboarding.step_teams": "Organize teams",
    "Organize teams": "Organize teams",
    "people.onboarding.step_teams_description": "Create departments and job profiles as you grow.",
    "Create departments and job profiles as you grow.": "Create departments and job profiles as you grow.",
    "people.onboarding.step_pay": "Set compensation",
    "Set compensation": "Set compensation",
    "people.onboarding.step_pay_description": "Define pay grades for consistent payroll setup.",
    "Define pay grades for consistent payroll setup.": "Define pay grades for consistent payroll setup.",
    "people.staff_profile": "Staff profile",
    "Staff profile": "Staff profile",
    "people.field.employee_code": "Employee code",
    "Employee code": "Employee code",
    "people.field.job_title": "Job title",
    "Job title": "Job title",
    "people.field.department": "Department",
    "Department": "Department",
    "people.field.job_profile": "Job profile",
    "Job profile": "Job profile",
    "people.field.pay_grade": "Pay grade",
    "Pay grade": "Pay grade",
    "people.field.employment_type": "Employment type",
    "Employment type": "Employment type",
    "people.field.start_date": "Start date",
    "people.field.user_id": "User ID",
    "people.field.user": "User",
    "people.field.grade": "Grade",
    "Grade": "Grade",
    "people.field.salary_range": "Salary range",
    "Salary range": "Salary range",
    "people.field.minimum_salary": "Minimum salary",
    "Minimum salary": "Minimum salary",
    "people.field.maximum_salary": "Maximum salary",
    "Maximum salary": "Maximum salary",
    "people.field.currency_id": "Currency ID",
    "people.form.staff.edit": "Edit staff",
    "Edit staff": "Edit staff",
    "people.form.staff.add": "Add staff",
    "people.form.staff.description": "Link an existing user to a staff profile.",
    "Link an existing user to a staff profile.": "Link an existing user to a staff profile.",
    "people.form.department.edit": "Edit department",
    "Edit department": "Edit department",
    "people.form.department.add": "Add department",
    "people.form.job_profile.edit": "Edit job profile",
    "Edit job profile": "Edit job profile",
    "people.form.job_profile.add": "Add job profile",
    "people.form.pay_grade.edit": "Edit pay grade",
    "Edit pay grade": "Edit pay grade",
    "people.form.pay_grade.add": "Add pay grade",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Senior Engineer",
    "Senior Engineer": "Senior Engineer",
    "people.placeholder.department": "Engineering",
    "Engineering": "Engineering",
    "people.placeholder.department_description": "Product & Engineering team",
    "Product & Engineering team": "Product & Engineering team",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Full time",
    "Full time": "Full time",
    "people.employment.part_time": "Part time",
    "Part time": "Part time",
    "people.employment.contractor": "Contractor",
    "Contractor": "Contractor",
    "people.toast.staff_added": "Staff added",
    "Staff added": "Staff added",
    "people.toast.staff_updated": "Staff updated",
    "Staff updated": "Staff updated",
    "people.toast.department_added": "Department added",
    "Department added": "Department added",
    "people.toast.department_updated": "Department updated",
    "Department updated": "Department updated",
    "people.toast.job_profile_added": "Job profile added",
    "Job profile added": "Job profile added",
    "people.toast.job_profile_updated": "Job profile updated",
    "Job profile updated": "Job profile updated",
    "people.toast.pay_grade_added": "Pay grade added",
    "Pay grade added": "Pay grade added",
    "people.toast.pay_grade_updated": "Pay grade updated",
    "Pay grade updated": "Pay grade updated",
    "people.empty.staff": "No staff yet. Add a staff profile to get started.",
    "No staff yet. Add a staff profile to get started.": "No staff yet. Add a staff profile to get started.",
    "people.empty.departments": "No departments yet.",
    "No departments yet.": "No departments yet.",
    "people.empty.job_profiles": "No job profiles yet.",
    "No job profiles yet.": "No job profiles yet.",
    "people.empty.pay_grades": "No pay grades yet.",
    "No pay grades yet.": "No pay grades yet.",
    "people.pagination.page": "Page {page}",
    "Page {page}": "Page {page}",
    "workforce.title": "Workforce",
    "workforce.tab.shifts": "Shifts",
    "Shifts": "Shifts",
    "workforce.tab.attendance": "Attendance",
    "Attendance": "Attendance",
    "workforce.tab.leave_requests": "Leave requests",
    "Leave requests": "Leave requests",
    "workforce.tab.leave_balances": "Leave balances",
    "Leave balances": "Leave balances",
    "workforce.tab.leave_policies": "Leave policies",
    "Leave policies": "Leave policies",
    "workforce.action.add_shift": "Add shift",
    "Add shift": "Add shift",
    "workforce.action.new_leave_request": "New leave request",
    "New leave request": "New leave request",
    "workforce.action.set_balance": "Set balance",
    "Set balance": "Set balance",
    "workforce.action.add_policy": "Add policy",
    "Add policy": "Add policy",
    "workforce.action.create_request": "Create request",
    "Create request": "Create request",
    "workforce.action.save_balance": "Save balance",
    "Save balance": "Save balance",
    "workforce.action.clock_in": "Clock in",
    "Clock in": "Clock in",
    "workforce.action.clock_out": "Clock out",
    "Clock out": "Clock out",
    "workforce.action.clocking_in": "Clocking in…",
    "Clocking in…": "Clocking in…",
    "workforce.action.clocking_out": "Clocking out…",
    "Clocking out…": "Clocking out…",
    "workforce.field.staff": "Staff",
    "workforce.field.start_time": "Start",
    "workforce.field.end_time": "End",
    "workforce.field.location": "Location",
    "workforce.field.leave_type": "Leave type",
    "Leave type": "Leave type",
    "workforce.field.from": "From",
    "workforce.field.to": "To",
    "workforce.field.days": "Days",
    "Days": "Days",
    "workforce.field.total_days": "Total days",
    "Total days": "Total days",
    "workforce.field.days_per_year": "Days per year",
    "Days per year": "Days per year",
    "workforce.field.carry_over": "Carry over",
    "Carry over": "Carry over",
    "workforce.field.carry_over_hint": "Unused days carry over to next year",
    "Unused days carry over to next year": "Unused days carry over to next year",
    "workforce.field.reason": "Reason",
    "workforce.field.time": "Time",
    "workforce.field.clock_in": "Clock in",
    "workforce.field.clock_out": "Clock out",
    "workforce.field.hours": "Hours",
    "Hours": "Hours",
    "workforce.field.dates": "Dates",
    "Dates": "Dates",
    "workforce.field.used_days": "Used",
    "Used": "Used",
    "workforce.field.remaining_days": "Remaining",
    "workforce.field.policy": "Policy",
    "Policy": "Policy",
    "workforce.placeholder.location": "HQ",
    "HQ": "HQ",
    "workforce.placeholder.leave_note": "Family holiday",
    "Family holiday": "Family holiday",
    "workforce.placeholder.policy_name": "Annual Leave",
    "Annual Leave": "Annual Leave",
    "workforce.placeholder.reject_reason": "Busy period",
    "Busy period": "Busy period",
    "workforce.placeholder.optional_note": "Optional note",
    "Optional note": "Optional note",
    "workforce.select.all_staff": "All staff",
    "All staff": "All staff",
    "workforce.form.shift.add": "Add shift",
    "workforce.form.leave_request.add": "New leave request",
    "workforce.form.leave_balance.title": "Set leave balance",
    "Set leave balance": "Set leave balance",
    "workforce.form.leave_balance.description": "Initialize a staff member’s entitlement for a leave type and year.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Initialize a staff member’s entitlement for a leave type and year.",
    "workforce.form.leave_policy.add": "Add leave policy",
    "Add leave policy": "Add leave policy",
    "workforce.form.leave_request.reject": "Reject leave request",
    "Reject leave request": "Reject leave request",
    "workforce.form.clock_out": "Clock out",
    "workforce.toast.shift_added": "Shift added",
    "Shift added": "Shift added",
    "workforce.toast.leave_request_created": "Leave request created",
    "Leave request created": "Leave request created",
    "workforce.toast.leave_balance_saved": "Leave balance saved",
    "Leave balance saved": "Leave balance saved",
    "workforce.toast.leave_policy_added": "Leave policy added",
    "Leave policy added": "Leave policy added",
    "workforce.toast.leave_request_rejected": "Leave request rejected",
    "Leave request rejected": "Leave request rejected",
    "workforce.toast.leave_request_approved": "Leave request approved",
    "Leave request approved": "Leave request approved",
    "workforce.toast.clocked_in": "Clocked in",
    "Clocked in": "Clocked in",
    "workforce.toast.clocked_out": "Clocked out",
    "Clocked out": "Clocked out",
    "workforce.empty.shifts": "No shifts in this period.",
    "No shifts in this period.": "No shifts in this period.",
    "workforce.empty.attendance": "No attendance records.",
    "No attendance records.": "No attendance records.",
    "workforce.empty.leave_requests": "No leave requests.",
    "No leave requests.": "No leave requests.",
    "workforce.empty.leave_balances": "No leave balances. Use Set balance to add one.",
    "No leave balances. Use Set balance to add one.": "No leave balances. Use Set balance to add one.",
    "workforce.empty.leave_policies": "No leave policies yet.",
    "No leave policies yet.": "No leave policies yet.",
    "workforce.leave_type.annual": "Annual leave",
    "Annual leave": "Annual leave",
    "workforce.leave_type.sick": "Sick leave",
    "Sick leave": "Sick leave",
    "workforce.leave_type.unpaid": "Unpaid leave",
    "Unpaid leave": "Unpaid leave",
    "workforce.leave_type.parental": "Parental leave",
    "Parental leave": "Parental leave",
    "workforce.leave_type.compassionate": "Compassionate leave",
    "Compassionate leave": "Compassionate leave",
    "workforce.duration.hours_minutes": "{hours}h {minutes}m",
    "{hours}h {minutes}m": "{hours}h {minutes}m",
    "common.year": "Year",
    "Year": "Year",
    "common.approve": "Approve",
    "common.reject": "Reject",
    "payroll.title": "Payroll",
    "payroll.tab.runs": "Payroll runs",
    "Payroll runs": "Payroll runs",
    "payroll.tab.components": "Pay components",
    "Pay components": "Pay components",
    "payroll.tab.claims": "Expense claims",
    "Expense claims": "Expense claims",
    "payroll.tab.categories": "Expense categories",
    "Expense categories": "Expense categories",
    "payroll.action.new_run": "New payroll run",
    "New payroll run": "New payroll run",
    "payroll.action.add_component": "Add pay component",
    "Add pay component": "Add pay component",
    "payroll.action.new_claim": "New expense claim",
    "New expense claim": "New expense claim",
    "payroll.action.add_category": "Add category",
    "payroll.action.create_run": "Create run",
    "Create run": "Create run",
    "payroll.action.create_component": "Create component",
    "Create component": "Create component",
    "payroll.action.create_claim": "Create claim",
    "Create claim": "Create claim",
    "payroll.action.submit_claim": "Submit",
    "Submit": "Submit",
    "payroll.action.approve_claim": "Approve",
    "payroll.action.reimburse_claim": "Reimburse",
    "Reimburse": "Reimburse",
    "payroll.action.approve_payroll": "Approve payroll",
    "Approve payroll": "Approve payroll",
    "payroll.action.activate": "Activate",
    "Activate": "Activate",
    "payroll.action.deactivate": "Deactivate",
    "payroll.action.adjust": "Adjust",
    "payroll.action.save_adjustment": "Save adjustment",
    "payroll.action.export_csv": "Export CSV",
    "Export CSV": "Export CSV",
    "payroll.action.exporting": "Exporting…",
    "payroll.action.view_staff_items": "View staff items",
    "View staff items": "View staff items",
    "payroll.action.view_payslips": "View payslips",
    "View payslips": "View payslips",
    "payroll.type.addition": "Addition",
    "Addition": "Addition",
    "payroll.type.deduction": "Deduction",
    "Deduction": "Deduction",
    "payroll.calculation.fixed": "Fixed amount",
    "Fixed amount": "Fixed amount",
    "payroll.calculation.percentage": "Percentage",
    "payroll.applies_to.all": "All staff",
    "payroll.applies_to.hourly": "Hourly staff",
    "Hourly staff": "Hourly staff",
    "payroll.applies_to.salaried": "Salaried staff",
    "Salaried staff": "Salaried staff",
    "payroll.category.archive_confirm": "Archive {name}?",
    "payroll.components.description": "Active additions and deductions are applied automatically to new payroll runs.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Active additions and deductions are applied automatically to new payroll runs.",
    "payroll.empty.categories": "No expense categories yet.",
    "No expense categories yet.": "No expense categories yet.",
    "payroll.empty.claims": "No expense claims yet.",
    "No expense claims yet.": "No expense claims yet.",
    "payroll.empty.components": "No pay components configured yet.",
    "No pay components configured yet.": "No pay components configured yet.",
    "payroll.empty.runs": "No payroll runs yet.",
    "No payroll runs yet.": "No payroll runs yet.",
    "payroll.field.staff": "Staff",
    "payroll.field.base_pay": "Base pay",
    "Base pay": "Base pay",
    "payroll.field.allowances": "Allowances",
    "Allowances": "Allowances",
    "payroll.field.deductions": "Deductions",
    "Deductions": "Deductions",
    "payroll.field.commission": "Commission",
    "payroll.field.net_pay": "Net pay",
    "Net pay": "Net pay",
    "payroll.field.components": "Components",
    "Components": "Components",
    "payroll.field.commission_override": "Commission override",
    "Commission override": "Commission override",
    "payroll.field.calculation": "Calculation",
    "Calculation": "Calculation",
    "payroll.field.applies_to": "Applies to",
    "Applies to": "Applies to",
    "payroll.field.staff_optional_draft": "Staff (optional while drafting)",
    "Staff (optional while drafting)": "Staff (optional while drafting)",
    "payroll.field.category_optional_draft": "Category (optional while drafting)",
    "Category (optional while drafting)": "Category (optional while drafting)",
    "payroll.field.category": "Category",
    "payroll.field.period": "Period",
    "payroll.field.period_start": "Period start",
    "Period start": "Period start",
    "payroll.field.period_end": "Period end",
    "Period end": "Period end",
    "payroll.field.generate_email_payslips": "Generate and email payslips",
    "Generate and email payslips": "Generate and email payslips",
    "payroll.field.gl_code": "GL code",
    "GL code": "GL code",
    "payroll.field.maximum_per_claim": "Maximum per claim",
    "Maximum per claim": "Maximum per claim",
    "payroll.field.maximum_per_transaction": "Maximum per transaction",
    "Maximum per transaction": "Maximum per transaction",
    "payroll.field.spending_cap": "Spending cap",
    "Spending cap": "Spending cap",
    "payroll.field.tax_rate": "Tax rate (%)",
    "Tax rate (%)": "Tax rate (%)",
    "payroll.field.no_limit": "No limit",
    "No limit": "No limit",
    "payroll.form.run.title": "New payroll run",
    "payroll.form.run.description": "Pay is calculated from staff pay grades for the selected period.",
    "Pay is calculated from staff pay grades for the selected period.": "Pay is calculated from staff pay grades for the selected period.",
    "payroll.form.component.title": "Add pay component",
    "payroll.form.component.description": "Components are automatically included in future payroll runs.",
    "Components are automatically included in future payroll runs.": "Components are automatically included in future payroll runs.",
    "payroll.form.claim.title": "New expense claim",
    "payroll.form.claim.description": "Claims start as drafts until submitted for approval.",
    "Claims start as drafts until submitted for approval.": "Claims start as drafts until submitted for approval.",
    "payroll.form.category.add": "Add expense category",
    "Add expense category": "Add expense category",
    "payroll.form.category.edit": "Edit expense category",
    "Edit expense category": "Edit expense category",
    "payroll.form.claim.approve_title": "Approve expense claim",
    "Approve expense claim": "Approve expense claim",
    "payroll.form.run.approve_title": "Approve payroll run",
    "Approve payroll run": "Approve payroll run",
    "payroll.form.run.approve_description": "Approval locks the payroll run. You can also generate and email payslips now.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "Approval locks the payroll run. You can also generate and email payslips now.",
    "payroll.items.title": "Staff payroll items",
    "Staff payroll items": "Staff payroll items",
    "payroll.items.loading": "Loading payroll items…",
    "Loading payroll items…": "Loading payroll items…",
    "payroll.items.empty": "No payroll items found.",
    "No payroll items found.": "No payroll items found.",
    "payroll.items.adjust_title": "Adjust payroll item",
    "Adjust payroll item": "Adjust payroll item",
    "payroll.items.adjust_description": "Update deductions or override the commission amount for this staff member.",
    "Update deductions or override the commission amount for this staff member.": "Update deductions or override the commission amount for this staff member.",
    "payroll.payslips.title": "Payslips",
    "Payslips": "Payslips",
    "payroll.payslips.generate": "Generate payslips",
    "Generate payslips": "Generate payslips",
    "payroll.payslips.generating": "Generating…",
    "Generating…": "Generating…",
    "payroll.payslips.empty": "No payslips generated yet.",
    "No payslips generated yet.": "No payslips generated yet.",
    "payroll.payslips.generated": "Generated",
    "Generated": "Generated",
    "payroll.payslips.sent_at": "Sent {date}",
    "Sent {date}": "Sent {date}",
    "payroll.payslips.not_sent": "Not sent",
    "Not sent": "Not sent",
    "payroll.payslips.send_email": "Send email",
    "Send email": "Send email",
    "payroll.payslips.sending": "Sending…",
    "payroll.payslips.details": "Payslip details",
    "Payslip details": "Payslip details",
    "payroll.placeholder.approval_note": "Approved",
    "payroll.placeholder.category_name": "Travel",
    "Travel": "Travel",
    "payroll.placeholder.claim_description": "Flight to client",
    "Flight to client": "Flight to client",
    "payroll.placeholder.component_name": "Transport Allowance",
    "Transport Allowance": "Transport Allowance",
    "payroll.staff_number": "Staff #{id}",
    "Staff #{id}": "Staff #{id}",
    "payroll.toast.category_added": "Expense category added",
    "Expense category added": "Expense category added",
    "payroll.toast.category_archived": "Expense category archived",
    "Expense category archived": "Expense category archived",
    "payroll.toast.category_updated": "Expense category updated",
    "Expense category updated": "Expense category updated",
    "payroll.toast.claim_approved": "Claim approved",
    "Claim approved": "Claim approved",
    "payroll.toast.claim_created": "Expense claim created",
    "Expense claim created": "Expense claim created",
    "payroll.toast.claim_reimbursed": "Claim marked as reimbursed",
    "Claim marked as reimbursed": "Claim marked as reimbursed",
    "payroll.toast.claim_submitted": "Claim submitted",
    "Claim submitted": "Claim submitted",
    "payroll.toast.component_activated": "Pay component activated",
    "Pay component activated": "Pay component activated",
    "payroll.toast.component_created": "Pay component created",
    "Pay component created": "Pay component created",
    "payroll.toast.component_deactivated": "Pay component deactivated",
    "Pay component deactivated": "Pay component deactivated",
    "payroll.toast.item_updated": "Payroll item updated",
    "Payroll item updated": "Payroll item updated",
    "payroll.toast.payslip_email_sent": "Payslip email sent",
    "Payslip email sent": "Payslip email sent",
    "payroll.toast.payslips_generated": "Payslips generated",
    "Payslips generated": "Payslips generated",
    "payroll.toast.run_approved": "Payroll run approved",
    "Payroll run approved": "Payroll run approved",
    "payroll.toast.run_approved_payslips_queued": "Payroll approved and payslips queued",
    "Payroll approved and payslips queued": "Payroll approved and payslips queued",
    "payroll.toast.run_created": "Payroll run created",
    "Payroll run created": "Payroll run created",
    "payroll.toast.exported": "Payroll exported",
    "Payroll exported": "Payroll exported",
    "common.notes": "Notes",
    "expenses.title": "Expenses",
    "expenses.action.add": "Add expense",
    "Add expense": "Add expense",
    "expenses.action.create": "Create expense",
    "Create expense": "Create expense",
    "expenses.action.submit": "Submit",
    "expenses.action.approve": "Approve",
    "expenses.action.reimburse": "Reimburse",
    "expenses.action.pay": "Pay",
    "expenses.action.lifecycle": "Expense {action}d",
    "Expense {action}d": "Expense {action}d",
    "expenses.type.claim": "Claim",
    "Claim": "Claim",
    "expenses.type.claims": "Claims",
    "Claims": "Claims",
    "expenses.type.bill": "Bill",
    "Bill": "Bill",
    "expenses.type.bills": "Bills",
    "Bills": "Bills",
    "expenses.filter.all_types": "All types",
    "All types": "All types",
    "expenses.filter.all_statuses": "All statuses",
    "expenses.summary.title": "Summary",
    "Summary": "Summary",
    "expenses.summary.by_category": "By category",
    "By category": "By category",
    "expenses.summary.by_status": "By status",
    "By status": "By status",
    "expenses.summary.by_party": "By supplier / staff",
    "By supplier / staff": "By supplier / staff",
    "expenses.summary.heading": "Summary by {group}",
    "Summary by {group}": "Summary by {group}",
    "expenses.summary.group.category": "category",
    "category": "category",
    "expenses.summary.group.status": "status",
    "status": "status",
    "expenses.summary.group.party": "supplier / staff",
    "supplier / staff": "supplier / staff",
    "expenses.summary.empty": "No summary available.",
    "No summary available.": "No summary available.",
    "expenses.column.type": "Type",
    "expenses.column.party": "Staff / Supplier",
    "Staff / Supplier": "Staff / Supplier",
    "expenses.column.status": "Status",
    "expenses.field.staff_optional": "Staff (optional while drafting)",
    "expenses.field.supplier_optional": "Supplier (optional while drafting)",
    "Supplier (optional while drafting)": "Supplier (optional while drafting)",
    "expenses.field.category_optional": "Category (optional while drafting)",
    "expenses.field.amount": "Amount",
    "expenses.field.currency": "Currency",
    "expenses.field.description": "Description",
    "expenses.field.due_date": "Due date",
    "Due date": "Due date",
    "expenses.field.receipt_url": "Receipt URL",
    "Receipt URL": "Receipt URL",
    "expenses.empty": "No expenses found for the selected filters.",
    "No expenses found for the selected filters.": "No expenses found for the selected filters.",
    "expenses.modal.edit": "Edit expense",
    "Edit expense": "Edit expense",
    "expenses.modal.add": "Add {type}",
    "Add {type}": "Add {type}",
    "expenses.modal.bill_help": "Create the draft now and assign a supplier before submitting.",
    "Create the draft now and assign a supplier before submitting.": "Create the draft now and assign a supplier before submitting.",
    "expenses.modal.claim_help": "Create the draft now and assign a staff member before submitting.",
    "Create the draft now and assign a staff member before submitting.": "Create the draft now and assign a staff member before submitting.",
    "expenses.toast.updated": "Expense updated",
    "Expense updated": "Expense updated",
    "expenses.toast.created": "Expense created",
    "Expense created": "Expense created",
    "recurring_payments.title": "Recurring payments",
    "recurring_payments.action.add": "Add recurring payment",
    "Add recurring payment": "Add recurring payment",
    "recurring_payments.action.create": "Create recurring payment",
    "Create recurring payment": "Create recurring payment",
    "recurring_payments.action.pause": "Pause",
    "Pause": "Pause",
    "recurring_payments.action.resume": "Resume",
    "Resume": "Resume",
    "recurring_payments.action.remove": "Remove",
    "recurring_payments.description": "Automatically create draft expense bills for regular supplier payments.",
    "Automatically create draft expense bills for regular supplier payments.": "Automatically create draft expense bills for regular supplier payments.",
    "recurring_payments.field.name": "Name",
    "recurring_payments.field.supplier": "Supplier",
    "recurring_payments.field.supplier_optional": "Supplier (optional)",
    "Supplier (optional)": "Supplier (optional)",
    "recurring_payments.field.frequency": "Frequency",
    "Frequency": "Frequency",
    "recurring_payments.field.next_due": "Next due date",
    "Next due date": "Next due date",
    "recurring_payments.field.auto_create": "Auto-create draft bill",
    "Auto-create draft bill": "Auto-create draft bill",
    "recurring_payments.field.auto_create_help": "Create a draft expense bill automatically",
    "Create a draft expense bill automatically": "Create a draft expense bill automatically",
    "recurring_payments.field.one_time": "One-time payment",
    "One-time payment": "One-time payment",
    "recurring_payments.field.one_time_help": "End after the next generated bill",
    "End after the next generated bill": "End after the next generated bill",
    "recurring_payments.field.end_date": "End date",
    "recurring_payments.placeholder.name": "Office Rent",
    "Office Rent": "Office Rent",
    "recurring_payments.frequency.daily": "Daily",
    "recurring_payments.frequency.weekly": "Weekly",
    "recurring_payments.frequency.monthly": "Monthly",
    "recurring_payments.frequency.quarterly": "Quarterly",
    "recurring_payments.frequency.yearly": "Yearly",
    "Yearly": "Yearly",
    "recurring_payments.form.description": "Due payments automatically create draft bills in Expenses when auto-create is enabled.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Due payments automatically create draft bills in Expenses when auto-create is enabled.",
    "recurring_payments.empty": "No recurring payments yet.",
    "No recurring payments yet.": "No recurring payments yet.",
    "recurring_payments.this_payment": "this recurring payment",
    "this recurring payment": "this recurring payment",
    "recurring_payments.confirm_remove": "Remove {name}?",
    "Remove {name}?": "Remove {name}?",
    "recurring_payments.toast.pause": "Recurring payment paused",
    "Recurring payment paused": "Recurring payment paused",
    "recurring_payments.toast.resume": "Recurring payment resumed",
    "Recurring payment resumed": "Recurring payment resumed",
    "recurring_payments.toast.delete": "Recurring payment removed",
    "Recurring payment removed": "Recurring payment removed",
    "recurring_payments.toast.created": "Recurring payment created",
    "Recurring payment created": "Recurring payment created",
    "expenses.toast.submit": "Expense submitted",
    "Expense submitted": "Expense submitted",
    "expenses.toast.approve": "Expense approved",
    "Expense approved": "Expense approved",
    "expenses.toast.reimburse": "Expense reimbursed",
    "Expense reimbursed": "Expense reimbursed",
    "expenses.toast.pay": "Expense paid",
    "Expense paid": "Expense paid",
    "media_picker.title": "Select media",
    "Select media": "Select media",
    "media_picker.type.media": "Media",
    "media_picker.type.all": "All",
    "media_picker.type.image": "Image",
    "media_picker.type.video": "Video",
    "media_picker.type.audio": "Audio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Folder",
    "media_picker.label.show": "Show",
    "media_picker.label.media_type": "Media type",
    "Media type": "Media type",
    "media_picker.action.show_type": "Show {type} media",
    "media_picker.action.close": "Close media picker",
    "Close media picker": "Close media picker",
    "media_picker.action.upload": "Upload media",
    "media_picker.action.creating": "Creating…",
    "media_picker.action.create_folder": "Create folder",
    "Create folder": "Create folder",
    "media_picker.action.cancel": "Cancel",
    "media_picker.action.use_selected": "Use selected",
    "Use selected": "Use selected",
    "media_picker.placeholder.search": "Search media",
    "media_picker.placeholder.folder": "New folder name",
    "New folder name": "New folder name",
    "media_picker.loading": "Loading media…",
    "media_picker.empty": "No media found in this folder.",
    "No media found in this folder.": "No media found in this folder.",
    "media_picker.selection.count": "{count} selected",
    "{count} selected": "{count} selected",
    "media_picker.selection.prompt": "Select a file to continue",
    "Select a file to continue": "Select a file to continue",
    "media_picker.error.load": "Unable to load media",
    "Unable to load media": "Unable to load media",
    "media_picker.error.load_retry": "Unable to load media. Please try again.",
    "media_picker.error.create_folder": "Unable to create folder",
    "media_picker.error.create_folder_retry": "Unable to create folder. Please try again.",
    "Unable to create folder. Please try again.": "Unable to create folder. Please try again.",
    "media_picker.error.prepare_upload": "Unable to prepare upload",
    "Unable to prepare upload": "Unable to prepare upload",
    "media_picker.error.upload_url": "Upload URL missing",
    "Upload URL missing": "Upload URL missing",
    "media_picker.error.register_media": "Unable to register media",
    "media_picker.error.upload_retry": "Unable to upload media. Please try again.",
    "membership.title": "Membership",
    "membership.description": "Manage membership programs, member contributions, payment status, and reminder rules.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Manage membership programs, member contributions, payment status, and reminder rules.",
    "membership.action.settings": "Settings",
    "membership.action.manage_programs": "Manage programs",
    "Manage programs": "Manage programs",
    "membership.action.view_data": "View data",
    "View data": "View data",
    "membership.action.edit_listing": "Edit listing",
    "membership.action.go_to_listings": "Go to listings",
    "Go to listings": "Go to listings",
    "membership.action.view_order": "View order",
    "View order": "View order",
    "membership.action.configure_reminders": "Configure reminders",
    "Configure reminders": "Configure reminders",
    "membership.stat.programs": "Programs",
    "membership.stat.active_members": "Active members",
    "Active members": "Active members",
    "membership.stat.contributions": "Contributions",
    "Contributions": "Contributions",
    "membership.stat.units": "Units credited",
    "Units credited": "Units credited",
    "membership.programs.title": "Programs",
    "membership.programs.description": "Membership-type listings available to your customers.",
    "Membership-type listings available to your customers.": "Membership-type listings available to your customers.",
    "membership.programs.no_description": "No program description yet.",
    "No program description yet.": "No program description yet.",
    "membership.programs.empty_title": "No membership programs yet",
    "No membership programs yet": "No membership programs yet",
    "membership.programs.empty_description": "Create a listing with type membership to start accepting contributions.",
    "Create a listing with type membership to start accepting contributions.": "Create a listing with type membership to start accepting contributions.",
    "membership.programs.history_description": "Price history and enrolled members.",
    "Price history and enrolled members.": "Price history and enrolled members.",
    "membership.badge": "Membership",
    "membership.loading_program": "Loading program data…",
    "Loading program data…": "Loading program data…",
    "membership.price_logs.title": "Price logs",
    "Price logs": "Price logs",
    "membership.price_logs.empty": "No price logs recorded.",
    "No price logs recorded.": "No price logs recorded.",
    "membership.source.manual": "manual",
    "manual": "manual",
    "membership.members.title": "Members",
    "Members": "Members",
    "membership.members.empty_program": "No members enrolled in this program.",
    "No members enrolled in this program.": "No members enrolled in this program.",
    "membership.members.recent": "Recent members",
    "Recent members": "Recent members",
    "membership.members.empty_recent": "Members and contributions will appear here after enrolment.",
    "Members and contributions will appear here after enrolment.": "Members and contributions will appear here after enrolment.",
    "membership.member_heading": "Member: {member}",
    "Member: {member}": "Member: {member}",
    "membership.contributions.title": "Contributions",
    "membership.contributions.empty": "No contributions recorded yet.",
    "No contributions recorded yet.": "No contributions recorded yet.",
    "membership.payment_dues.title": "Payment dues",
    "Payment dues": "Payment dues",
    "membership.payment_dues.empty": "No scheduled payment dues.",
    "No scheduled payment dues.": "No scheduled payment dues.",
    "membership.unit": "unit",
    "unit": "unit",
    "membership.units": "units",
    "units": "units",
    "membership.months": "months",
    "membership.automation.label": "AUTOMATION",
    "AUTOMATION": "AUTOMATION",
    "membership.automation.description": "Daily worker checks scheduled membership payments.",
    "Daily worker checks scheduled membership payments.": "Daily worker checks scheduled membership payments.",
    "membership.reminders.title": "Payment reminders",
    "Payment reminders": "Payment reminders",
    "membership.reminders.due_soon": "Due-soon reminder",
    "Due-soon reminder": "Due-soon reminder",
    "membership.reminders.due_soon_short": "Due soon",
    "Due soon": "Due soon",
    "membership.reminders.due_soon_help": "Send one reminder before a scheduled payment is due.",
    "Send one reminder before a scheduled payment is due.": "Send one reminder before a scheduled payment is due.",
    "membership.reminders.days_before": "Days before due date",
    "Days before due date": "Days before due date",
    "membership.reminders.days_before_value": "{count} days before",
    "{count} days before": "{count} days before",
    "membership.reminders.overdue": "Overdue reminder",
    "Overdue reminder": "Overdue reminder",
    "membership.reminders.overdue_help": "Send one reminder after the due date and grace period.",
    "Send one reminder after the due date and grace period.": "Send one reminder after the due date and grace period.",
    "membership.settings.title": "Membership settings",
    "Membership settings": "Membership settings",
    "membership.settings.description": "Configure the payment reminder schedule.",
    "Configure the payment reminder schedule.": "Configure the payment reminder schedule.",
    "membership.email_copy.title": "Custom email copy",
    "Custom email copy": "Custom email copy",
    "membership.email_copy.description": "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.",
    "membership.toast.saved": "Membership reminder settings saved.",
    "Membership reminder settings saved.": "Membership reminder settings saved.",
    "membership.toast.save_failed": "Unable to save membership reminder settings.",
    "Unable to save membership reminder settings.": "Unable to save membership reminder settings.",
    "common.status.off": "Off",
    "Off": "Off",
    "common.status.on": "On",
    "On": "On",
    "common.save_settings": "Save settings",
    "Save settings": "Save settings",
    "developer.page.title": "API & Developer",
    "API & Developer": "API & Developer",
    "developer.api_keys.title": "API Keys",
    "API Keys": "API Keys",
    "developer.api_keys.description": "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.",
    "developer.api_keys.credentials_description": "Find below your production keys. You will need to use these keys to authorise and build your apps.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Find below your production keys. You will need to use these keys to authorise and build your apps.",
    "developer.api_keys.publishable": "Publishable Key",
    "Publishable Key": "Publishable Key",
    "developer.api_keys.publishable_placeholder": "Enter Publishable Key",
    "Enter Publishable Key": "Enter Publishable Key",
    "developer.api_keys.secret": "Secret Key",
    "developer.api_keys.secret_placeholder": "Enter Secret Key",
    "Enter Secret Key": "Enter Secret Key",
    "developer.api_keys.access_label": "API access",
    "API access": "API access",
    "developer.api_reference.title": "API Reference",
    "developer.api_reference.description": "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.",
    "developer.api_reference.card_description": "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.",
    "developer.api_reference.open_docs": "Open API Docs",
    "Open API Docs": "Open API Docs",
    "developer.ai_agents.title": "AI & Agents",
    "AI & Agents": "AI & Agents",
    "developer.ai_agents.description": "Connect your marketplace to AI tools and let customers build agents powered by your platform.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Connect your marketplace to AI tools and let customers build agents powered by your platform.",
    "developer.mcp.action.create": "Create",
    "developer.mcp.action.removing": "Removing…",
    "developer.mcp.scope.resource": "Resource",
    "developer.customer_agents.description": "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.",
    "whatsapp.title": "WhatsApp connector",
    "WhatsApp connector": "WhatsApp connector",
    "whatsapp.intro.title": "Send OTPs and marketing messages through WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Send OTPs and marketing messages through WhatsApp",
    "whatsapp.intro.help": "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.",
    "whatsapp.status.disabled": "Disabled",
    "whatsapp.status.sms_otp": "Connector on · SMS OTP",
    "Connector on · SMS OTP": "Connector on · SMS OTP",
    "whatsapp.status.needs_configuration": "Needs configuration",
    "Needs configuration": "Needs configuration",
    "whatsapp.status.auto_fallback": "WhatsApp with SMS fallback",
    "WhatsApp with SMS fallback": "WhatsApp with SMS fallback",
    "whatsapp.status.sms_whatsapp_backup": "SMS with WhatsApp backup",
    "SMS with WhatsApp backup": "SMS with WhatsApp backup",
    "whatsapp.status.enabled": "WhatsApp enabled",
    "WhatsApp enabled": "WhatsApp enabled",
    "whatsapp.draft.notice": "You have an unsaved WhatsApp settings draft.",
    "You have an unsaved WhatsApp settings draft.": "You have an unsaved WhatsApp settings draft.",
    "whatsapp.connect.title": "Connect your business WhatsApp",
    "Connect your business WhatsApp": "Connect your business WhatsApp",
    "whatsapp.connect.description": "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.",
    "whatsapp.field.business_number": "Business WhatsApp number",
    "Business WhatsApp number": "Business WhatsApp number",
    "whatsapp.field.business_number_help": "Use the number you want customers to message, including country code.",
    "Use the number you want customers to message, including country code.": "Use the number you want customers to message, including country code.",
    "whatsapp.placeholder.business_number": "e.g. +60 13 333 1671",
    "e.g. +60 13 333 1671": "e.g. +60 13 333 1671",
    "whatsapp.field.connection_name": "Connection name",
    "whatsapp.field.connection_name_help": "Use a clear name such as Kuala Lumpur, Retail brand, or Support.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Use a clear name such as Kuala Lumpur, Retail brand, or Support.",
    "whatsapp.placeholder.connection_name": "e.g. Kuala Lumpur support",
    "e.g. Kuala Lumpur support": "e.g. Kuala Lumpur support",
    "whatsapp.field.optional_details": "Optional connection details",
    "Optional connection details": "Optional connection details",
    "whatsapp.field.optional_details_help": "Use these only when this number belongs to a specific brand, account, or branch.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Use these only when this number belongs to a specific brand, account, or branch.",
    "whatsapp.field.brand_key": "Brand key",
    "Brand key": "Brand key",
    "whatsapp.field.brand_key_help": "Stable internal key for a brand, such as retail or wholesale.",
    "Stable internal key for a brand, such as retail or wholesale.": "Stable internal key for a brand, such as retail or wholesale.",
    "whatsapp.placeholder.brand_key": "e.g. retail",
    "e.g. retail": "e.g. retail",
    "whatsapp.field.account_id": "Account ID",
    "whatsapp.field.account_id_help": "Associate this number with an existing Tradly account.",
    "Associate this number with an existing Tradly account.": "Associate this number with an existing Tradly account.",
    "whatsapp.placeholder.account_id": "e.g. 123",
    "e.g. 123": "e.g. 123",
    "whatsapp.field.branch_id": "Branch ID",
    "Branch ID": "Branch ID",
    "whatsapp.field.branch_id_help": "Associate this number with an existing Tradly branch.",
    "Associate this number with an existing Tradly branch.": "Associate this number with an existing Tradly branch.",
    "whatsapp.placeholder.branch_id": "e.g. 456",
    "e.g. 456": "e.g. 456",
    "whatsapp.field.default_connection": "Use as default connection",
    "Use as default connection": "Use as default connection",
    "whatsapp.field.default_connection_help": "Legacy OTP flows use the selected default when no branch-specific connection is chosen.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Legacy OTP flows use the selected default when no branch-specific connection is chosen.",
    "whatsapp.field.uses_business_app": "I use the WhatsApp Business app on this number",
    "I use the WhatsApp Business app on this number": "I use the WhatsApp Business app on this number",
    "whatsapp.field.uses_business_app_help": "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.",
    "whatsapp.connected.business_account": "WhatsApp business account",
    "WhatsApp business account": "WhatsApp business account",
    "whatsapp.connected.template_ready": "Authentication template ready · Automatic OTP can use WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Authentication template ready · Automatic OTP can use WhatsApp.",
    "whatsapp.connected.template_pending": "Connected · SMS remains the safe fallback while the authentication template is approved.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Connected · SMS remains the safe fallback while the authentication template is approved.",
    "whatsapp.action.connect": "Connect WhatsApp",
    "Connect WhatsApp": "Connect WhatsApp",
    "whatsapp.action.reconnect": "Reconnect WhatsApp",
    "Reconnect WhatsApp": "Reconnect WhatsApp",
    "whatsapp.connections.title": "Connected WhatsApp numbers",
    "Connected WhatsApp numbers": "Connected WhatsApp numbers",
    "whatsapp.connections.description": "Each number can belong to a different brand, account, or branch. Select one before activating templates.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Each number can belong to a different brand, account, or branch. Select one before activating templates.",
    "whatsapp.connections.unnamed": "WhatsApp connection",
    "WhatsApp connection": "WhatsApp connection",
    "whatsapp.connections.default": "Default",
    "whatsapp.connections.account": "Account {id}",
    "Account {id}": "Account {id}",
    "whatsapp.connections.branch": "Branch {id}",
    "Branch {id}": "Branch {id}",
    "whatsapp.connections.tenant_wide": "Tenant-wide connection",
    "Tenant-wide connection": "Tenant-wide connection",
    "whatsapp.action.make_default": "Make default",
    "Make default": "Make default",
    "whatsapp.notice.default_updated": "Default WhatsApp connection updated.",
    "Default WhatsApp connection updated.": "Default WhatsApp connection updated.",
    "whatsapp.error.default_update": "Unable to change the default connection.",
    "Unable to change the default connection.": "Unable to change the default connection.",
    "whatsapp.templates.title": "Message templates",
    "Message templates": "Message templates",
    "whatsapp.templates.description": "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.",
    "whatsapp.template.status.not_activated": "Not activated",
    "Not activated": "Not activated",
    "whatsapp.template.status.approved": "Approved",
    "whatsapp.template.status.pending": "Pending",
    "whatsapp.template.status.submitted": "Submitted",
    "Submitted": "Submitted",
    "whatsapp.template.action.active": "Active",
    "whatsapp.template.action.submitted": "Submitted",
    "whatsapp.template.action.activate": "Activate template",
    "Activate template": "Activate template",
    "whatsapp.notice.template_active": "{name} is approved and active.",
    "{name} is approved and active.": "{name} is approved and active.",
    "whatsapp.notice.template_submitted": "{name} was sent to Meta for review. You can keep using SMS until it is approved.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} was sent to Meta for review. You can keep using SMS until it is approved.",
    "whatsapp.channel.title": "Delivery channel",
    "Delivery channel": "Delivery channel",
    "whatsapp.channel.help": "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.",
    "whatsapp.channel.primary_otp": "Primary OTP channel",
    "Primary OTP channel": "Primary OTP channel",
    "whatsapp.channel.sms_description": "Keep the existing SMS delivery path.",
    "Keep the existing SMS delivery path.": "Keep the existing SMS delivery path.",
    "whatsapp.channel.whatsapp_description": "Use Meta Cloud API for this tenant.",
    "Use Meta Cloud API for this tenant.": "Use Meta Cloud API for this tenant.",
    "whatsapp.channel.automatic": "Automatic",
    "Automatic": "Automatic",
    "whatsapp.channel.automatic_description": "Use WhatsApp when configured, otherwise SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Use WhatsApp when configured, otherwise SMS.",
    "whatsapp.channel.fallback": "Fallback after WhatsApp failure",
    "Fallback after WhatsApp failure": "Fallback after WhatsApp failure",
    "whatsapp.channel.no_fallback": "No fallback",
    "No fallback": "No fallback",
    "whatsapp.channel.no_fallback_description": "Return the configured delivery result.",
    "Return the configured delivery result.": "Return the configured delivery result.",
    "whatsapp.channel.sms_fallback_description": "Try SMS with the same OTP code.",
    "Try SMS with the same OTP code.": "Try SMS with the same OTP code.",
    "whatsapp.channel.sms_only": "SMS only",
    "SMS only": "SMS only",
    "whatsapp.channel.sms_only_description": "Codes are sent by text message.",
    "Codes are sent by text message.": "Codes are sent by text message.",
    "whatsapp.channel.whatsapp_only": "WhatsApp only",
    "WhatsApp only": "WhatsApp only",
    "whatsapp.channel.whatsapp_only_description": "Codes are sent from your WhatsApp number.",
    "Codes are sent from your WhatsApp number.": "Codes are sent from your WhatsApp number.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp as backup",
    "SMS, WhatsApp as backup": "SMS, WhatsApp as backup",
    "whatsapp.channel.sms_whatsapp_description": "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.",
    "whatsapp.advanced.title": "Technical recovery settings",
    "Technical recovery settings": "Technical recovery settings",
    "whatsapp.advanced.description": "For platform support only. Most businesses should use Connect WhatsApp above.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "For platform support only. Most businesses should use Connect WhatsApp above.",
    "whatsapp.field.phone_number_id": "WhatsApp phone number ID",
    "WhatsApp phone number ID": "WhatsApp phone number ID",
    "whatsapp.field.phone_number_id_help": "The phone number ID attached to your WhatsApp Business account.",
    "The phone number ID attached to your WhatsApp Business account.": "The phone number ID attached to your WhatsApp Business account.",
    "whatsapp.field.waba_id": "WhatsApp Business Account ID",
    "WhatsApp Business Account ID": "WhatsApp Business Account ID",
    "whatsapp.field.waba_id_help": "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.",
    "whatsapp.placeholder.phone_number_id": "e.g. 123456789012345",
    "e.g. 123456789012345": "e.g. 123456789012345",
    "whatsapp.field.access_token": "Meta access token",
    "Meta access token": "Meta access token",
    "whatsapp.field.access_token_saved_help": "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.",
    "whatsapp.field.access_token_help": "Use a system-user token with WhatsApp Business messaging permission.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Use a system-user token with WhatsApp Business messaging permission.",
    "whatsapp.placeholder.access_token_saved": "Saved securely · leave blank to keep",
    "Saved securely · leave blank to keep": "Saved securely · leave blank to keep",
    "whatsapp.placeholder.access_token": "Paste token",
    "Paste token": "Paste token",
    "whatsapp.token.saved": "Meta access token saved securely",
    "Meta access token saved securely": "Meta access token saved securely",
    "whatsapp.field.otp_template": "Approved OTP template name",
    "Approved OTP template name": "Approved OTP template name",
    "whatsapp.field.otp_template_help": "The template body must accept the OTP as one text parameter.",
    "The template body must accept the OTP as one text parameter.": "The template body must accept the OTP as one text parameter.",
    "whatsapp.placeholder.otp_template": "e.g. login_verification",
    "e.g. login_verification": "e.g. login_verification",
    "whatsapp.field.template_language": "Template language",
    "Template language": "Template language",
    "whatsapp.field.marketing_template": "Approved marketing template name (optional)",
    "Approved marketing template name (optional)": "Approved marketing template name (optional)",
    "whatsapp.field.marketing_template_help": "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.",
    "whatsapp.placeholder.marketing_template": "e.g. monthly_offer",
    "e.g. monthly_offer": "e.g. monthly_offer",
    "whatsapp.field.marketing_language": "Marketing template language",
    "Marketing template language": "Marketing template language",
    "whatsapp.info.title": "Before enabling WhatsApp",
    "Before enabling WhatsApp": "Before enabling WhatsApp",
    "whatsapp.info.description": "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.",
    "whatsapp.action.hide_token": "Hide Meta access token",
    "Hide Meta access token": "Hide Meta access token",
    "whatsapp.action.show_token": "Show Meta access token",
    "Show Meta access token": "Show Meta access token",
    "whatsapp.error.generic": "Unable to save WhatsApp settings.",
    "Unable to save WhatsApp settings.": "Unable to save WhatsApp settings.",
    "whatsapp.error.browser_required": "WhatsApp connection is only available in a browser.",
    "WhatsApp connection is only available in a browser.": "WhatsApp connection is only available in a browser.",
    "whatsapp.error.meta_load": "Meta could not load. Check the browser privacy settings and try again.",
    "Meta could not load. Check the browser privacy settings and try again.": "Meta could not load. Check the browser privacy settings and try again.",
    "whatsapp.error.load": "Unable to load WhatsApp settings.",
    "Unable to load WhatsApp settings.": "Unable to load WhatsApp settings.",
    "whatsapp.error.connect_before_template": "Connect WhatsApp before activating a template.",
    "Connect WhatsApp before activating a template.": "Connect WhatsApp before activating a template.",
    "whatsapp.error.template_submit": "Unable to submit the WhatsApp template.",
    "Unable to submit the WhatsApp template.": "Unable to submit the WhatsApp template.",
    "whatsapp.error.business_number_required": "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.",
    "whatsapp.error.signup_not_ready": "WhatsApp connection is still being prepared by the platform. Please try again shortly.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "WhatsApp connection is still being prepared by the platform. Please try again shortly.",
    "whatsapp.error.signup_cancelled": "Meta connection was cancelled or did not return an authorization code.",
    "Meta connection was cancelled or did not return an authorization code.": "Meta connection was cancelled or did not return an authorization code.",
    "whatsapp.error.phone_number_missing": "Meta did not return the selected WhatsApp business number. Please try the connection again.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta did not return the selected WhatsApp business number. Please try the connection again.",
    "whatsapp.notice.connected_auto": "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.",
    "whatsapp.notice.connected_sms": "WhatsApp is connected. SMS remains active until Meta approves an authentication template.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp is connected. SMS remains active until Meta approves an authentication template.",
    "whatsapp.error.connect": "Unable to connect WhatsApp.",
    "Unable to connect WhatsApp.": "Unable to connect WhatsApp.",
    "whatsapp.error.otp_configuration": "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.",
    "whatsapp.notice.saved": "WhatsApp connector settings saved for this tenant.",
    "WhatsApp connector settings saved for this tenant.": "WhatsApp connector settings saved for this tenant.",
    "whatsapp.error.save": "Unable to save WhatsApp settings.",
    "whatsapp.notice.discarded": "Draft discarded.",
    "Draft discarded.": "Draft discarded.",
    "whatsapp.test.title": "Send a test message",
    "Send a test message": "Send a test message",
    "whatsapp.test.description": "Send an approved template to any WhatsApp number to check that your connection works.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Send an approved template to any WhatsApp number to check that your connection works.",
    "whatsapp.test.refresh": "Refresh templates",
    "Refresh templates": "Refresh templates",
    "whatsapp.test.field.template": "Approved template",
    "Approved template": "Approved template",
    "whatsapp.test.field.parameter": "Value for {{{number}}}",
    "Value for {{{number}}}": "Value for {{{number}}}",
    "whatsapp.test.field.mobile": "Send to",
    "Send to": "Send to",
    "whatsapp.test.field.mobile_help": "WhatsApp number with country code.",
    "WhatsApp number with country code.": "WhatsApp number with country code.",
    "whatsapp.test.action.send": "Send test message",
    "Send test message": "Send test message",
    "whatsapp.test.sent": "Sent to {mobile}. Meta message ID: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Sent to {mobile}. Meta message ID: {id}",
    "whatsapp.test.no_templates": "No approved templates yet. Activate a template above and send once Meta approves it.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "No approved templates yet. Activate a template above and send once Meta approves it.",
    "common.discard_draft": "Discard draft",
    "common.status.connected": "Connected",
    "Connected": "Connected",
    "extensions.title": "Extensions",
    "extensions.action.add": "Add Extension",
    "Add Extension": "Add Extension",
    "extensions.action.add_new": "Add New Extension",
    "Add New Extension": "Add New Extension",
    "extensions.action.edit": "Edit Extension",
    "Edit Extension": "Edit Extension",
    "extensions.action.delete": "Delete extension",
    "Delete extension": "Delete extension",
    "extensions.field.name": "Name",
    "extensions.field.domain": "Domain",
    "extensions.field.configs": "Configs",
    "Configs": "Configs",
    "extensions.placeholder.name": "Extension Name",
    "Extension Name": "Extension Name",
    "extensions.placeholder.domain": "Extension Domain",
    "Extension Domain": "Extension Domain",
    "extensions.empty": "No extensions configured yet.",
    "No extensions configured yet.": "No extensions configured yet.",
    "extensions.toast.added": "Extension added successfully.",
    "Extension added successfully.": "Extension added successfully.",
    "extensions.toast.updated": "Extension updated successfully.",
    "Extension updated successfully.": "Extension updated successfully.",
    "extensions.toast.deleted": "Extension deleted successfully.",
    "Extension deleted successfully.": "Extension deleted successfully.",
    "extensions.error.name_required": "Name is required",
    "extensions.error.domain_required": "Domain is required",
    "Domain is required": "Domain is required",
    "extensions.error.configs_required": "Configs is required",
    "Configs is required": "Configs is required",
    "extensions.error.save_failed": "Unable to save the extension.",
    "Unable to save the extension.": "Unable to save the extension.",
    "extensions.error.delete_failed": "Unable to delete the extension.",
    "Unable to delete the extension.": "Unable to delete the extension.",
    "automation_rules.kicker": "Operations automation",
    "Operations automation": "Operations automation",
    "automation_rules.title": "Automation rules",
    "Automation rules": "Automation rules",
    "automation_rules.description": "Turn staff and expense events into clear approval and review steps.",
    "Turn staff and expense events into clear approval and review steps.": "Turn staff and expense events into clear approval and review steps.",
    "automation_rules.action.new_rule": "New rule",
    "New rule": "New rule",
    "automation_rules.action.create_rule": "Create rule",
    "Create rule": "Create rule",
    "automation_rules.action.create_help": "Save this trigger, conditions, and action as a rule",
    "Save this trigger, conditions, and action as a rule": "Save this trigger, conditions, and action as a rule",
    "automation_rules.action.add_condition": "Add condition",
    "Add condition": "Add condition",
    "automation_rules.action.add_condition_help": "Add another condition to this rule",
    "Add another condition to this rule": "Add another condition to this rule",
    "automation_rules.action.remove_condition": "Remove condition",
    "Remove condition": "Remove condition",
    "automation_rules.action.choose": "Choose an action",
    "Choose an action": "Choose an action",
    "automation_rules.action.require_second_approver": "Require second approver",
    "Require second approver": "Require second approver",
    "automation_rules.action.require_second_approver_help": "Route the claim to another approver.",
    "Route the claim to another approver.": "Route the claim to another approver.",
    "automation_rules.action.auto_reject_expense": "Auto-reject expense",
    "Auto-reject expense": "Auto-reject expense",
    "automation_rules.action.auto_reject_expense_help": "Reject the expense with a reason.",
    "Reject the expense with a reason.": "Reject the expense with a reason.",
    "automation_rules.action.notify_role": "Notify a role",
    "Notify a role": "Notify a role",
    "automation_rules.action.notify_role_help": "Send a notification to a staff role.",
    "Send a notification to a staff role.": "Send a notification to a staff role.",
    "automation_rules.action.flag_for_review": "Flag for review",
    "Flag for review": "Flag for review",
    "automation_rules.action.flag_for_review_help": "Mark a resource for manual review.",
    "Mark a resource for manual review.": "Mark a resource for manual review.",
    "automation_rules.field.rule_name": "Rule name",
    "Rule name": "Rule name",
    "automation_rules.field.priority": "Priority",
    "automation_rules.field.module": "Module",
    "Module": "Module",
    "automation_rules.field.event": "Event",
    "automation_rules.field.field": "Field",
    "Field": "Field",
    "automation_rules.field.operator": "Operator",
    "Operator": "Operator",
    "automation_rules.field.value": "Value",
    "automation_rules.field.action": "Action",
    "automation_rules.field.action_params": "Action parameters",
    "Action parameters": "Action parameters",
    "automation_rules.placeholder.rule_name": "Require second approver for large claims",
    "Require second approver for large claims": "Require second approver for large claims",
    "automation_rules.placeholder.field": "amount",
    "amount": "amount",
    "automation_rules.placeholder.value": "500 or false",
    "500 or false": "500 or false",
    "automation_rules.builder.description": "Build the trigger, conditions, and action below, then save them as one rule.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Build the trigger, conditions, and action below, then save them as one rule.",
    "automation_rules.error.load": "Unable to load automation rules.",
    "Unable to load automation rules.": "Unable to load automation rules.",
    "automation_rules.error.required_fields": "Name, module, event, and action are required.",
    "Name, module, event, and action are required.": "Name, module, event, and action are required.",
    "automation_rules.error.create": "Unable to create automation rule.",
    "Unable to create automation rule.": "Unable to create automation rule.",
    "automation_rules.error.valid_json": "Use valid JSON before saving.",
    "Use valid JSON before saving.": "Use valid JSON before saving.",
    "automation_rules.notice.created": "Automation rule created.",
    "Automation rule created.": "Automation rule created.",
    "automation_rules.notice.discarded": "Draft discarded.",
    "automation_rules.draft.restored": "Your unsaved automation rule draft was restored.",
    "Your unsaved automation rule draft was restored.": "Your unsaved automation rule draft was restored.",
    "automation_rules.list.title": "Rules",
    "automation_rules.list.count": "{count} configured",
    "{count} configured": "{count} configured",
    "automation_rules.list.loading": "Loading rules…",
    "Loading rules…": "Loading rules…",
    "automation_rules.list.unnamed": "Unnamed rule",
    "Unnamed rule": "Unnamed rule",
    "automation_rules.list.no_action": "No action configured",
    "No action configured": "No action configured",
    "automation_rules.list.empty": "No rules yet. Create the first one from the diagram.",
    "No rules yet. Create the first one from the diagram.": "No rules yet. Create the first one from the diagram.",
    "automation_rules.status.draft": "Draft",
    "automation_rules.status.active": "Active",
    "automation_rules.inspector.title": "Block settings",
    "Block settings": "Block settings",
    "automation_rules.inspector.diagram": "Diagram",
    "Diagram": "Diagram",
    "automation_rules.inspector.select_block": "Select a block on the diagram to configure it.",
    "Select a block on the diagram to configure it.": "Select a block on the diagram to configure it.",
    "automation_rules.inspector.no_configuration": "This block does not need configuration.",
    "This block does not need configuration.": "This block does not need configuration.",
    "automation_rules.node.trigger": "Trigger",
    "automation_rules.node.condition": "Condition",
    "automation_rules.node.action": "Action",
    "automation_rules.node.end": "End",
    "automation_rules.node.completed": "Completed",
    "automation_rules.node.finished": "Rule evaluation finished",
    "Rule evaluation finished": "Rule evaluation finished",
    "automation_rules.trigger.choose_event": "Choose an event",
    "Choose an event": "Choose an event",
    "automation_rules.trigger.module": "module",
    "module": "module",
    "automation_rules.trigger.module_event": "{module} event",
    "{module} event": "{module} event",
    "automation_rules.trigger.help": "The rule evaluates when this event is emitted by the module.",
    "The rule evaluates when this event is emitted by the module.": "The rule evaluates when this event is emitted by the module.",
    "automation_rules.condition.label": "Condition",
    "automation_rules.condition.none": "No conditions",
    "No conditions": "No conditions",
    "automation_rules.condition.always_fires": "Always fires",
    "Always fires": "Always fires",
    "automation_rules.condition.empty_help": "Add a condition to restrict this rule.",
    "Add a condition to restrict this rule.": "Add a condition to restrict this rule.",
    "automation_rules.condition.value_required": "Value required",
    "Value required": "Value required",
    "automation_rules.condition.value": "Value: {value}",
    "Value: {value}": "Value: {value}",
    "automation_rules.operator.equals": "Equals",
    "Equals": "Equals",
    "automation_rules.operator.gt": "Greater than",
    "Greater than": "Greater than",
    "automation_rules.operator.gte": "Greater than or equal",
    "Greater than or equal": "Greater than or equal",
    "automation_rules.operator.lt": "Less than",
    "Less than": "Less than",
    "automation_rules.operator.exists": "Exists",
    "Exists": "Exists",
    "automation_rules.module.expenses": "Expenses",
    "automation_rules.module.staff": "Staff",
    "automation_rules.event.expense.submitted": "Expense submitted",
    "automation_rules.event.leave.requested": "Leave requested",
    "Leave requested": "Leave requested",
    "automation_rules.event.payroll_run.created": "Payroll run created",
    "automation_rules.meta.conditions": "{count} condition(s) · all must match before the action runs",
    "{count} condition(s) · all must match before the action runs": "{count} condition(s) · all must match before the action runs",
    "automation_rules.meta.no_conditions": "No conditions · the action always runs after the trigger",
    "No conditions · the action always runs after the trigger": "No conditions · the action always runs after the trigger",
    "automation_rules.draft.unsaved": "You have an unsaved automation rule draft.",
    "You have an unsaved automation rule draft.": "You have an unsaved automation rule draft.",
    "automation_rules.meta.one_condition": "1 condition · all must match before the action runs",
    "1 condition · all must match before the action runs": "1 condition · all must match before the action runs",
    "automation_rules.meta.many_conditions": "{count} conditions · all must match before the action runs",
    "{count} conditions · all must match before the action runs": "{count} conditions · all must match before the action runs",
    "cms.type.page": "Page",
    "Page": "Page",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Docs",
    "Docs": "Docs",
    "cms.type.pages": "Pages",
    "cms.type.blogs": "Blogs",
    "Blogs": "Blogs",
    "cms.action.add_content": "Add content",
    "Add content": "Add content",
    "cms.action.add_type": "Add {type}",
    "cms.action.create_type": "Create {type}",
    "Create {type}": "Create {type}",
    "cms.action.edit": "Edit",
    "cms.action.duplicate": "Duplicate",
    "Duplicate": "Duplicate",
    "cms.action.open": "Open",
    "cms.field.title": "Title",
    "cms.field.slug": "Slug",
    "cms.field.content": "Content",
    "cms.field.meta_title": "Meta title",
    "cms.field.meta_description": "Meta description",
    "cms.placeholder.title": "e.g. About us",
    "e.g. About us": "e.g. About us",
    "cms.placeholder.slug": "about-us",
    "about-us": "about-us",
    "cms.placeholder.page_title": "Page title",
    "Page title": "Page title",
    "cms.placeholder.page_slug": "page-slug",
    "page-slug": "page-slug",
    "cms.placeholder.content": "Write your content here…",
    "Write your content here…": "Write your content here…",
    "cms.placeholder.meta_title": "Defaults to title",
    "Defaults to title": "Defaults to title",
    "cms.placeholder.meta_description": "Short description for search engines",
    "Short description for search engines": "Short description for search engines",
    "cms.section.seo_optional": "SEO (optional)",
    "SEO (optional)": "SEO (optional)",
    "cms.error.title_required": "Title is required.",
    "Title is required.": "Title is required.",
    "cms.error.content_required": "Add some content before saving.",
    "Add some content before saving.": "Add some content before saving.",
    "cms.error.create": "Failed to create. Please try again.",
    "Failed to create. Please try again.": "Failed to create. Please try again.",
    "cms.error.save": "Failed to save.",
    "Failed to save.": "Failed to save.",
    "cms.error.load_layer": "Could not load this layer.",
    "Could not load this layer.": "Could not load this layer.",
    "cms.toast.created": "{type} created successfully.",
    "{type} created successfully.": "{type} created successfully.",
    "cms.toast.saved": "Saved",
    "Saved": "Saved",
    "cms.toast.changes_saved": "Changes saved.",
    "Changes saved.": "Changes saved.",
    "cms.toast.deleted": "Deleted",
    "cms.toast.duplicated": "Duplicated",
    "Duplicated": "Duplicated",
    "cms.error.delete": "Failed to delete",
    "Failed to delete": "Failed to delete",
    "cms.error.duplicate": "Failed to duplicate",
    "Failed to duplicate": "Failed to duplicate",
    "cms.confirm.delete": "Delete \"{title}\"?",
    "Delete \"{title}\"?": "Delete \"{title}\"?",
    "cms.duplicate.title": "{title} (copy)",
    "{title} (copy)": "{title} (copy)",
    "cms.draft.restored": "Your unsaved content draft was restored.",
    "Your unsaved content draft was restored.": "Your unsaved content draft was restored.",
    "cms.search": "Search…",
    "Search…": "Search…",
    "cms.list.no_results": "No results found.",
    "No results found.": "No results found.",
    "cms.list.empty_type": "No {type} yet.",
    "No {type} yet.": "No {type} yet.",
    "cms.list.untitled": "Untitled",
    "Untitled": "Untitled",
    "cms.editor.placeholder": "Write your content here…",
    "cms.editor.normal_text": "Normal text",
    "Normal text": "Normal text",
    "cms.editor.heading": "Heading {level}",
    "Heading {level}": "Heading {level}",
    "cms.editor.align_left": "Align Left",
    "Align Left": "Align Left",
    "cms.editor.align_center": "Align Center",
    "Align Center": "Align Center",
    "cms.editor.align_right": "Align Right",
    "Align Right": "Align Right",
    "cms.editor.insert_table": "Insert table",
    "Insert table": "Insert table",
    "cms.editor.add_column": "Add column",
    "Add column": "Add column",
    "cms.editor.add_row": "Add row",
    "Add row": "Add row",
    "cms.editor.delete_table": "Delete table",
    "Delete table": "Delete table",
    "cms.editor.delete_column": "Delete column",
    "Delete column": "Delete column",
    "cms.editor.delete_row": "Delete row",
    "Delete row": "Delete row",
    "cms.editor.underline": "Underline",
    "Underline": "Underline",
    "cms.editor.strikethrough": "Strikethrough",
    "Strikethrough": "Strikethrough",
    "cms.editor.code": "Code",
    "cms.editor.code_block": "Code block",
    "Code block": "Code block",
    "cms.editor.subscript": "Subscript",
    "Subscript": "Subscript",
    "cms.editor.superscript": "Superscript",
    "Superscript": "Superscript",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "Image URL",
    "Image URL": "Image URL",
    "cms.editor.prompt.youtube_url": "YouTube URL",
    "YouTube URL": "YouTube URL",
    "cms.editor.undo": "Undo",
    "cms.editor.redo": "Redo",
    "cms.editor.table": "Table",
    "Table": "Table",
    "cms.editor.more": "More",
    "cms.editor.bold": "Bold",
    "Bold": "Bold",
    "cms.editor.italic": "Italic",
    "Italic": "Italic",
    "cms.editor.bullet_list": "Bullet list",
    "Bullet list": "Bullet list",
    "cms.editor.ordered_list": "Ordered list",
    "Ordered list": "Ordered list",
    "cms.editor.task_list": "Task list",
    "Task list": "Task list",
    "cms.editor.link": "Link",
    "Link": "Link",
    "cms.editor.image": "Image",
    "cms.editor.text_color": "Text color",
    "Text color": "Text color",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Pages",
    "cms.test.type.pages_description": "Landing pages and structured storefront content.",
    "Landing pages and structured storefront content.": "Landing pages and structured storefront content.",
    "cms.test.type.blogs": "Blogs",
    "cms.test.type.blogs_description": "Articles, stories, and updates for your audience.",
    "Articles, stories, and updates for your audience.": "Articles, stories, and updates for your audience.",
    "cms.test.type.docs": "Docs",
    "cms.test.type.docs_description": "Documentation, guides, and help content.",
    "Documentation, guides, and help content.": "Documentation, guides, and help content.",
    "cms.test.operation.list": "List content by type",
    "List content by type": "List content by type",
    "cms.test.operation.fetch": "Fetch one Layer",
    "Fetch one Layer": "Fetch one Layer",
    "cms.test.operation.create": "Create a Layer",
    "Create a Layer": "Create a Layer",
    "cms.test.operation.update": "Update a Layer",
    "Update a Layer": "Update a Layer",
    "cms.test.operation.delete": "Delete a Layer",
    "Delete a Layer": "Delete a Layer",
    "cms.test.operation.search": "Search content",
    "Search content": "Search content",
    "cms.test.operation.categories": "Load categories",
    "Load categories": "Load categories",
    "cms.test.operation.translations": "Save translations",
    "Save translations": "Save translations",
    "cms.test.editor.placeholder": "Write your page content...",
    "Write your page content...": "Write your page content...",
    "cms.test.error.load_type": "Unable to load {type} content",
    "Unable to load {type} content": "Unable to load {type} content",
    "cms.test.error.load": "Unable to load CMS content.",
    "Unable to load CMS content.": "Unable to load CMS content.",
    "cms.test.error.required": "Add a page title and content before saving.",
    "Add a page title and content before saving.": "Add a page title and content before saving.",
    "cms.test.error.create": "Unable to create this page.",
    "Unable to create this page.": "Unable to create this page.",
    "cms.test.toast.created": "Page created successfully.",
    "Page created successfully.": "Page created successfully.",
    "cms.test.hero.eyebrow": "CONTENT MANAGEMENT",
    "CONTENT MANAGEMENT": "CONTENT MANAGEMENT",
    "cms.test.hero.title": "Layers CMS",
    "Layers CMS": "Layers CMS",
    "cms.test.hero.description": "Create structured content once, then make it available across your storefront, applications, and custom experiences.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Create structured content once, then make it available across your storefront, applications, and custom experiences.",
    "cms.test.hero.live_workspace": "Live workspace: {tenant} · read-only preview",
    "Live workspace: {tenant} · read-only preview": "Live workspace: {tenant} · read-only preview",
    "cms.test.current_tenant": "current tenant",
    "current tenant": "current tenant",
    "cms.test.content.title": "Your content",
    "Your content": "Your content",
    "cms.test.content.description": "Pages, blogs, and docs are ready to manage from one place.",
    "Pages, blogs, and docs are ready to manage from one place.": "Pages, blogs, and docs are ready to manage from one place.",
    "cms.test.action.create_page": "Create Page",
    "Create Page": "Create Page",
    "cms.test.form.description": "Create structured page content in Layers. The page will be available through the API after saving.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Create structured page content in Layers. The page will be available through the API after saving.",
    "cms.test.placeholder.slug": "about-us (optional)",
    "about-us (optional)": "about-us (optional)",
    "cms.test.draft.unsaved": "You have an unsaved page draft.",
    "You have an unsaved page draft.": "You have an unsaved page draft.",
    "cms.test.loading": "Loading live Layers content…",
    "Loading live Layers content…": "Loading live Layers content…",
    "cms.test.content.empty_title": "No {type} yet",
    "No {type} yet": "No {type} yet",
    "cms.test.content.empty_description": "Create your first Layer in the workspace to see it here.",
    "Create your first Layer in the workspace to see it here.": "Create your first Layer in the workspace to see it here.",
    "cms.test.feature.types": "Custom content types",
    "Custom content types": "Custom content types",
    "cms.test.feature.types_description": "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.",
    "cms.test.feature.structured": "Structured and localized",
    "Structured and localized": "Structured and localized",
    "cms.test.feature.structured_description": "Use slugs, categories, images, SEO metadata, and translations for the same content source.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Use slugs, categories, images, SEO metadata, and translations for the same content source.",
    "cms.test.feature.headless": "Headless by default",
    "Headless by default": "Headless by default",
    "cms.test.feature.headless_description": "Use the Layers API in a website, mobile app, internal tool, or custom frontend.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Use the Layers API in a website, mobile app, internal tool, or custom frontend.",
    "cms.test.feature.ai": "AI knowledge source",
    "AI knowledge source": "AI knowledge source",
    "cms.test.feature.ai_description": "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.",
    "cms.test.community.eyebrow": "COMMUNITY CONTENT",
    "COMMUNITY CONTENT": "COMMUNITY CONTENT",
    "cms.test.community.title": "Turn Layers into a social feed",
    "Turn Layers into a social feed": "Turn Layers into a social feed",
    "cms.test.community.description": "Create a custom Post type, let users publish updates, and add interaction through your frontend.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Create a custom Post type, let users publish updates, and add interaction through your frontend.",
    "cms.test.community.share_placeholder": "Share an update…",
    "Share an update…": "Share an update…",
    "cms.test.community.post": "Post",
    "Post": "Post",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "A community update published from a custom Layer.",
    "A community update published from a custom Layer.": "A community update published from a custom Layer.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 comments   ·   ↗ Share",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 comments   ·   ↗ Share",
    "cms.test.community.endpoints": "Example endpoints",
    "Example endpoints": "Example endpoints",
    "cms.test.developer.eyebrow": "DEVELOPER ACCESS",
    "DEVELOPER ACCESS": "DEVELOPER ACCESS",
    "cms.test.developer.title": "Layers API",
    "Layers API": "Layers API",
    "cms.test.developer.docs": "Developer docs",
    "Developer docs": "Developer docs",
    "auth.title": "Auth",
    "auth.sign_in_method": "Sign-in method",
    "auth.facebook_auth": "Facebook Auth",
    "auth.google_auth": "Google Auth",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "Enterprise SSO",
    "Enterprise SSO": "Enterprise SSO",
    "auth.admob": "Admob",
    "Admob": "Admob",
    "checkout.title": "Checkout Settings",
    "Checkout Settings": "Checkout Settings",
    "checkout.orders": "Orders",
    "checkout.carts": "Carts",
    "Carts": "Carts",
    "audit_logs.action": "Action",
    "audit_logs.resource": "Resource",
    "audit_logs.resource_id": "Resource ID",
    "Resource ID": "Resource ID",
    "audit_logs.agent_id": "Agent ID",
    "Agent ID": "Agent ID",
    "audit_logs.result": "Result",
    "audit_logs.actor_id": "Actor ID",
    "Actor ID": "Actor ID",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Timestamp",
    "Timestamp": "Timestamp",
    "audit_logs.succeeded": "Succeeded",
    "audit_logs.failed": "Failed",
    "audit_logs.source": "Source",
    "audit_logs.all_sources": "All sources",
    "All sources": "All sources",
    "audit_logs.human_admin": "Human (admin)",
    "Human (admin)": "Human (admin)",
    "audit_logs.agent_mcp": "Agent (MCP)",
    "Agent (MCP)": "Agent (MCP)",
    "audit_logs.all_actions": "All actions",
    "All actions": "All actions",
    "audit_logs.from": "From",
    "audit_logs.to": "To",
    "audit_logs.apply": "Apply",
    "audit_logs.clear": "Clear",
    "audit_logs.export_csv": "Export CSV",
    "audit_logs.exporting": "Exporting…",
    "audit_logs.title": "Audit Logs",
    "audit_logs.empty_title": "No audit logs found",
    "No audit logs found": "No audit logs found",
    "audit_logs.empty_subtitle": "Try adjusting your filters",
    "Try adjusting your filters": "Try adjusting your filters",
    "audit_logs.restriction_notice": "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.",
    "audit_logs.extended_history": "Extended audit log history",
    "Extended audit log history": "Extended audit log history",
    "manage_features.title": "Manage Features",
    "manage_features.general": "General",
    "manage_features.apps": "Apps",
    "manage_features.marketplace": "Marketplace",
    "manage_features.commerce": "Commerce",
    "manage_features.channels": "Channels",
    "manage_features.left_menu": "Left Menu",
    "Left Menu": "Left Menu",
    "manage_features.right_sidepanel": "Right Sidepanel",
    "Right Sidepanel": "Right Sidepanel",
    "workflow.integration": "Integration",
    "workflow.no_url_title": "No Integration URL",
    "No Integration URL": "No Integration URL",
    "workflow.no_url_description": "Please configure the integration URL.",
    "Please configure the integration URL.": "Please configure the integration URL.",
    "workflow.back": "Go Back",
    "Go Back": "Go Back",
    "workflow.loading": "Loading integration...",
    "Loading integration...": "Loading integration...",
    "workflow.loading_hint": "Please wait while we connect",
    "Please wait while we connect": "Please wait while we connect",
    "workflow.error_title": "Integration Error",
    "Integration Error": "Integration Error",
    "workflow.error_description": "Unable to load the integration. Please check your connection and try again.",
    "Unable to load the integration. Please check your connection and try again.": "Unable to load the integration. Please check your connection and try again.",
    "workflow.retry": "Try Again",
    "Try Again": "Try Again",
    "upgrade_preview.eyebrow": "Component preview",
    "Component preview": "Component preview",
    "upgrade_preview.title": "Upgrade experience",
    "Upgrade experience": "Upgrade experience",
    "upgrade_preview.description": "A shared feature gate focused on what a customer can accomplish after upgrading.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "A shared feature gate focused on what a customer can accomplish after upgrading.",
    "upgrade_preview.feature": "Add a variant",
    "Add a variant": "Add a variant",
    "upgrade_preview.context": "This is the current point where a Basic-plan user reaches the feature boundary.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "This is the current point where a Basic-plan user reaches the feature boundary.",
    "upgrade_preview.button": "Preview upgrade panel",
    "Preview upgrade panel": "Preview upgrade panel",
    "upgrade_preview.listing_context": "For this listing",
    "For this listing": "For this listing",
    "gamification_test.eyebrow": "GROWTH GAMIFICATION · TEST ROUTE",
    "GROWTH GAMIFICATION · TEST ROUTE": "GROWTH GAMIFICATION · TEST ROUTE",
    "gamification_test.title": "Build momentum for your business",
    "Build momentum for your business": "Build momentum for your business",
    "gamification_test.subtitle": "Preview missions, coins, badges, and streaks for {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Preview missions, coins, badges, and streaks for {workspace}.",
    "gamification_test.this_workspace": "this workspace",
    "this workspace": "this workspace",
    "gamification_test.coins": "COINS",
    "COINS": "COINS",
    "gamification_test.points": "POINTS",
    "POINTS": "POINTS",
    "gamification_test.streak": "STREAK",
    "STREAK": "STREAK",
    "gamification_test.week": "1 week",
    "1 week": "1 week",
    "gamification_test.launch": "Launch path",
    "Launch path": "Launch path",
    "gamification_test.progress": "{completed} of {total} actions complete · up to {coins} coins",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} of {total} actions complete · up to {coins} coins",
    "gamification_test.done": "Done",
    "gamification_test.reward": "+{count} coins",
    "+{count} coins": "+{count} coins",
    "gamification_test.badges": "Badges",
    "Badges": "Badges",
    "gamification_test.mission_listing_created": "Create your first listing",
    "Create your first listing": "Create your first listing",
    "gamification_test.mission_collection_created": "Create your first collection",
    "Create your first collection": "Create your first collection",
    "gamification_test.mission_payment_configured": "Configure payments",
    "Configure payments": "Configure payments",
    "gamification_test.mission_publish_completed": "Publish your site",
    "Publish your site": "Publish your site",
    "gamification_test.mission_analytics_enabled": "Enable analytics",
    "Enable analytics": "Enable analytics",
    "gamification_test.badge_first_step": "First Step",
    "First Step": "First Step",
    "gamification_test.badge_catalog_builder": "Catalog Builder",
    "Catalog Builder": "Catalog Builder",
    "gamification_test.badge_ready_to_sell": "Ready to Sell",
    "Ready to Sell": "Ready to Sell",
    "gamification_test.badge_data_driven": "Data Driven",
    "Data Driven": "Data Driven",
    "gamification_test.badge_growth_operator": "Growth Operator",
    "Growth Operator": "Growth Operator",
    "sentry_check.title": "Sentry Configuration Check",
    "Sentry Configuration Check": "Sentry Configuration Check",
    "sentry_check.subtitle": "Test and verify Sentry error tracking setup",
    "Test and verify Sentry error tracking setup": "Test and verify Sentry error tracking setup",
    "sentry_check.configuration": "Configuration",
    "sentry_check.check_configuration": "Check Configuration",
    "Check Configuration": "Check Configuration",
    "sentry_check.status": "Status:",
    "Status:": "Status:",
    "sentry_check.enabled": "✓ Enabled",
    "✓ Enabled": "✓ Enabled",
    "sentry_check.disabled": "✗ Disabled",
    "✗ Disabled": "✗ Disabled",
    "sentry_check.environment": "Environment:",
    "Environment:": "Environment:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Traces Sample Rate:",
    "Traces Sample Rate:": "Traces Sample Rate:",
    "sentry_check.test_functions": "Test Functions",
    "Test Functions": "Test Functions",
    "sentry_check.test_hint": "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.",
    "sentry_check.test_results": "Test Results",
    "Test Results": "Test Results",
    "sentry_check.clear": "Clear",
    "sentry_check.no_tests": "No tests run yet",
    "No tests run yet": "No tests run yet",
    "sentry_check.important_notes": "⚠️ Important Notes",
    "⚠️ Important Notes": "⚠️ Important Notes",
    "sentry_check.warning_real_events": "• These tests will create real error events in your Sentry dashboard",
    "• These tests will create real error events in your Sentry dashboard": "• These tests will create real error events in your Sentry dashboard",
    "sentry_check.warning_dashboard": "• Check your Sentry dashboard to verify events are being captured",
    "• Check your Sentry dashboard to verify events are being captured": "• Check your Sentry dashboard to verify events are being captured",
    "sentry_check.warning_traces": "• Some tests may not show in Sentry if tracesSampleRate is 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Some tests may not show in Sentry if tracesSampleRate is 0.0",
    "sentry_check.warning_dsn": "• Make sure your DSN is correctly configured in environment variables",
    "• Make sure your DSN is correctly configured in environment variables": "• Make sure your DSN is correctly configured in environment variables",
    "sentry_check.normal_error": "Test Normal Error",
    "Test Normal Error": "Test Normal Error",
    "sentry_check.test_normal_error": "Test Normal Error",
    "sentry_check.test_message": "Test Message",
    "Test Message": "Test Message",
    "sentry_check.test_breadcrumb": "Test Breadcrumb",
    "Test Breadcrumb": "Test Breadcrumb",
    "sentry_check.test_user_context": "Test User Context",
    "Test User Context": "Test User Context",
    "sentry_check.test_custom_exception": "Test Custom Exception",
    "Test Custom Exception": "Test Custom Exception",
    "sentry_check.test_promise_rejection": "Test Promise Rejection",
    "Test Promise Rejection": "Test Promise Rejection",
    "sentry_check.configuration_check": "Configuration Check",
    "Configuration Check": "Configuration Check",
    "sentry_check.config_loaded": "Config loaded successfully",
    "Config loaded successfully": "Config loaded successfully",
    "sentry_check.error_captured": "Error captured and sent to Sentry",
    "Error captured and sent to Sentry": "Error captured and sent to Sentry",
    "sentry_check.error_capture_failed": "Failed to capture error: {message}",
    "Failed to capture error: {message}": "Failed to capture error: {message}",
    "sentry_check.message": "Message",
    "Message": "Message",
    "sentry_check.message_captured": "Message captured and sent to Sentry",
    "Message captured and sent to Sentry": "Message captured and sent to Sentry",
    "sentry_check.message_capture_failed": "Failed to capture message: {message}",
    "Failed to capture message: {message}": "Failed to capture message: {message}",
    "sentry_check.breadcrumb": "Breadcrumb",
    "Breadcrumb": "Breadcrumb",
    "sentry_check.breadcrumb_added": "Breadcrumb added to Sentry context",
    "Breadcrumb added to Sentry context": "Breadcrumb added to Sentry context",
    "sentry_check.breadcrumb_failed": "Failed to add breadcrumb: {message}",
    "Failed to add breadcrumb: {message}": "Failed to add breadcrumb: {message}",
    "sentry_check.user_context": "User Context",
    "User Context": "User Context",
    "sentry_check.user_set": "User context set in Sentry",
    "User context set in Sentry": "User context set in Sentry",
    "sentry_check.user_failed": "Failed to set user context: {message}",
    "Failed to set user context: {message}": "Failed to set user context: {message}",
    "sentry_check.custom_exception": "Custom Exception",
    "Custom Exception": "Custom Exception",
    "sentry_check.custom_sent": "Custom exception with context sent to Sentry",
    "Custom exception with context sent to Sentry": "Custom exception with context sent to Sentry",
    "sentry_check.custom_failed": "Failed to capture custom exception: {message}",
    "Failed to capture custom exception: {message}": "Failed to capture custom exception: {message}",
    "sentry_check.promise_rejection": "Promise Rejection",
    "Promise Rejection": "Promise Rejection",
    "sentry_check.promise_captured": "Promise rejection captured and sent to Sentry",
    "Promise rejection captured and sent to Sentry": "Promise rejection captured and sent to Sentry",
    "sentry_check.promise_failed": "Failed to handle promise rejection: {message}",
    "Failed to handle promise rejection: {message}": "Failed to handle promise rejection: {message}",
    "checkout_settings.orders": "Orders",
    "checkout_settings.return_policy_days": "Return policy days",
    "Return policy days": "Return policy days",
    "checkout_settings.enter_return_policy_days": "Enter return policy days",
    "Enter return policy days": "Enter return policy days",
    "checkout_settings.saved": "Uploaded successfully",
    "checkout_settings.cart": "Cart",
    "checkout_settings.hide_quantity_selection": "Hide quantity selection (Default: Shows field to select quantity)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Hide quantity selection (Default: Shows field to select quantity)",
    "checkout_settings.enable_coupon": "Enable Coupon",
    "Enable Coupon": "Enable Coupon",
    "upgrade_page.copy.a_practical_next_step": "A practical next step",
    "A practical next step": "A practical next step",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Add the structured information your workflow needs.",
    "Add the structured information your workflow needs.": "Add the structured information your workflow needs.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Assign roles and permissions to every teammate.",
    "Assign roles and permissions to every teammate.": "Assign roles and permissions to every teammate.",
    "upgrade_page.copy.audit_log_export": "Audit log export",
    "Audit log export": "Audit log export",
    "upgrade_page.copy.best_next_step": "Best next step",
    "Best next step": "Best next step",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Build beyond the standard interface",
    "Build beyond the standard interface": "Build beyond the standard interface",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Capture the details that make your catalogue useful.",
    "Capture the details that make your catalogue useful.": "Capture the details that make your catalogue useful.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Choose the flexibility to build your own customer-facing experiences on top of Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Choose the flexibility to build your own customer-facing experiences on top of Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Combine existing listings into curated bundles and let customers select eligible items at checkout.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Combine existing listings into curated bundles and let customers select eligible items at checkout.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Configure the currencies your business needs as you operate across regions.",
    "Configure the currencies your business needs as you operate across regions.": "Configure the currencies your business needs as you operate across regions.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Connect your marketplace with internal tools and automation when manual work no longer scales.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Connect your marketplace with internal tools and automation when manual work no longer scales.",
    "upgrade_page.copy.connect_your_own_tools": "Connect your own tools",
    "Connect your own tools": "Connect your own tools",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Control who can see and change what.",
    "Control who can see and change what.": "Control who can see and change what.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Create custom fields for the facts customers and your team need to see on every listing or account.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Create custom fields for the facts customers and your team need to see on every listing or account.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Create fixed and mix-and-match bundles.",
    "Create fixed and mix-and-match bundles.": "Create fixed and mix-and-match bundles.",
    "upgrade_page.copy.custom_attributes": "Custom attributes",
    "Custom attributes": "Custom attributes",
    "upgrade_page.copy.custom_email_templates": "Custom email templates",
    "Custom email templates": "Custom email templates",
    "upgrade_page.copy.email_whitelabelling": "Email whitelabelling",
    "Email whitelabelling": "Email whitelabelling",
    "upgrade_page.copy.everything_in_growth": "Everything in Growth",
    "Everything in Growth": "Everything in Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Everything in Growth, with the highest limits.",
    "Everything in Growth, with the highest limits.": "Everything in Growth, with the highest limits.",
    "upgrade_page.copy.everything_in_starter": "Everything in Starter",
    "Everything in Starter": "Everything in Starter",
    "upgrade_page.copy.expand_your_workspace": "Expand your workspace",
    "Expand your workspace": "Expand your workspace",
    "upgrade_page.copy.feature_access": "Feature access",
    "Feature access": "Feature access",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "For a growing catalogue that needs clearer product choices.",
    "For a growing catalogue that needs clearer product choices.": "For a growing catalogue that needs clearer product choices.",
    "upgrade_page.copy.for_established_businesses": "For established businesses",
    "For established businesses": "For established businesses",
    "upgrade_page.copy.for_growing_operations": "For growing operations",
    "For growing operations": "For growing operations",
    "upgrade_page.copy.for_growing_teams": "For growing teams",
    "For growing teams": "For growing teams",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "For high-volume teams that need room to operate at scale.",
    "For high-volume teams that need room to operate at scale.": "For high-volume teams that need room to operate at scale.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "For teams managing a larger catalogue and more workflows.",
    "For teams managing a larger catalogue and more workflows.": "For teams managing a larger catalogue and more workflows.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "For teams ready to work beyond one record at a time.",
    "For teams ready to work beyond one record at a time.": "For teams ready to work beyond one record at a time.",
    "upgrade_page.copy.full_audit_history": "Full audit history",
    "Full audit history": "Full audit history",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Growth and Scale plans can review the complete audit history and export it for compliance workflows.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Growth and Scale plans can review the complete audit history and export it for compliance workflows.",
    "upgrade_page.copy.higher_usage_limits": "Higher usage limits",
    "Higher usage limits": "Higher usage limits",
    "upgrade_page.copy.highest_usage_limits": "Highest usage limits",
    "Highest usage limits": "Highest usage limits",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Import and export records without repetitive manual work.",
    "Import and export records without repetitive manual work.": "Import and export records without repetitive manual work.",
    "upgrade_page.copy.import_and_export_tools": "Import and export tools",
    "Import and export tools": "Import and export tools",
    "upgrade_page.copy.improve_important_customer_messages": "Improve important customer messages",
    "Improve important customer messages": "Improve important customer messages",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Keep a longer compliance history",
    "Keep a longer compliance history": "Keep a longer compliance history",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Keep complete compliance visibility for high-volume operations.",
    "Keep complete compliance visibility for high-volume operations.": "Keep complete compliance visibility for high-volume operations.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Keep more data and workflows organised as the catalogue grows.",
    "Keep more data and workflows organised as the catalogue grows.": "Keep more data and workflows organised as the catalogue grows.",
    "upgrade_page.copy.keep_your_workspace_secure": "Keep your workspace secure",
    "Keep your workspace secure": "Keep your workspace secure",
    "upgrade_page.copy.large": "Large",
    "Large": "Large",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Let customers choose options from one listing.",
    "Let customers choose options from one listing.": "Let customers choose options from one listing.",
    "upgrade_page.copy.listing_variants": "Listing variants",
    "Listing variants": "Listing variants",
    "upgrade_page.copy.make_every_customer_email_yours": "Make every customer email yours",
    "Make every customer email yours": "Make every customer email yours",
    "upgrade_page.copy.make_one_listing_work_harder": "Make one listing work harder",
    "Make one listing work harder": "Make one listing work harder",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Make system emails match your workflow and tone.",
    "Make system emails match your workflow and tone.": "Make system emails match your workflow and tone.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Make your project available in more languages.",
    "Make your project available in more languages.": "Make your project available in more languages.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Manage the customer-facing language experience as you expand into new regions and audiences.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Manage the customer-facing language experience as you expand into new regions and audiences.",
    "upgrade_page.copy.medium": "Medium",
    "upgrade_page.copy.more_capacity": "More capacity",
    "More capacity": "More capacity",
    "upgrade_page.copy.more_storage": "More storage",
    "More storage": "More storage",
    "upgrade_page.copy.more_team_capacity": "More team capacity",
    "More team capacity": "More team capacity",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Move faster with your catalogue",
    "Move faster with your catalogue": "Move faster with your catalogue",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Move larger catalogues and teams through routine work faster.",
    "Move larger catalogues and teams through routine work faster.": "Move larger catalogues and teams through routine work faster.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Operate with the highest available limits.",
    "Operate with the highest available limits.": "Operate with the highest available limits.",
    "upgrade_page.copy.per_module_permissions": "Per-module permissions",
    "Per-module permissions": "Per-module permissions",
    "upgrade_page.copy.priority_support": "Priority support",
    "Priority support": "Priority support",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Review more than the latest five audit events.",
    "Review more than the latest five audit events.": "Review more than the latest five audit events.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Review the full audit history as your team and activity grow.",
    "Review the full audit history as your team and activity grow.": "Review the full audit history as your team and activity grow.",
    "upgrade_page.copy.role_based_access_control": "Role-based access control",
    "Role-based access control": "Role-based access control",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Roles let you give each teammate only the access they need. Available on Growth and above.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Roles let you give each teammate only the access they need. Available on Growth and above.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Run a stronger, more polished customer communication workflow.",
    "Run a stronger, more polished customer communication workflow.": "Run a stronger, more polished customer communication workflow.",
    "upgrade_page.copy.sell_across_markets": "Sell across markets",
    "Sell across markets": "Sell across markets",
    "upgrade_page.copy.sell_products_together": "Sell products together",
    "Sell products together": "Sell products together",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Send email from a brand your customers recognise.",
    "Send email from a brand your customers recognise.": "Send email from a brand your customers recognise.",
    "upgrade_page.copy.shape_the_information_you_collect": "Shape the information you collect",
    "Shape the information you collect": "Shape the information you collect",
    "upgrade_page.copy.small": "Small",
    "Small": "Small",
    "upgrade_page.copy.speak_to_more_customers": "Speak to more customers",
    "Speak to more customers": "Speak to more customers",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Standardise richer data across a high-volume operation.",
    "Standardise richer data across a high-volume operation.": "Standardise richer data across a high-volume operation.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Start presenting a more consistent customer experience.",
    "Start presenting a more consistent customer experience.": "Start presenting a more consistent customer experience.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Support a complete enterprise-ready customer experience.",
    "Support a complete enterprise-ready customer experience.": "Support a complete enterprise-ready customer experience.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Support customers who shop in different currencies.",
    "Support customers who shop in different currencies.": "Support customers who shop in different currencies.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Support high-volume operational workflows at scale.",
    "Support high-volume operational workflows at scale.": "Support high-volume operational workflows at scale.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Support larger workflows and teams.",
    "Support larger workflows and teams.": "Support larger workflows and teams.",
    "upgrade_page.copy.t_shirt": "T-shirt",
    "T-shirt": "T-shirt",
    "upgrade_page.copy.t_shirt_large": "T-shirt — Large",
    "T-shirt — Large": "T-shirt — Large",
    "upgrade_page.copy.t_shirt_medium": "T-shirt — Medium",
    "T-shirt — Medium": "T-shirt — Medium",
    "upgrade_page.copy.t_shirt_small": "T-shirt — Small",
    "T-shirt — Small": "T-shirt — Small",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Tailor the messages customers receive at key moments without changing your marketplace setup.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Tailor the messages customers receive at key moments without changing your marketplace setup.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Unlock more tools as your workspace begins to grow.",
    "Unlock more tools as your workspace begins to grow.": "Unlock more tools as your workspace begins to grow.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Unlock this feature when you are ready.",
    "Unlock this feature when you are ready.": "Unlock this feature when you are ready.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Use headless APIs for a fully custom experience.",
    "Use headless APIs for a fully custom experience.": "Use headless APIs for a fully custom experience.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Use the API when your workflow needs to go further.",
    "Use the API when your workflow needs to go further.": "Use the API when your workflow needs to go further.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Use your own sender identity and visual branding so marketplace communications stay consistent.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Use your own sender identity and visual branding so marketplace communications stay consistent.",
    "upgrade_page.copy.with_variants": "With variants",
    "With variants": "With variants",
    "upgrade_page.copy.without_variants": "Without variants",
    "Without variants": "Without variants",
    "upgrade_page.copy.workflow_tools": "Workflow tools",
    "Workflow tools": "Workflow tools",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Your current work remains unchanged while you compare the plan that includes this capability.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Your current work remains unchanged while you compare the plan that includes this capability.",
    "upgrade_page.copy.a_paid_plan": "a paid plan",
    "a paid plan": "a paid plan",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Everything a growing store needs: remove branding, add your domain, and unlock more tools.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Everything a growing store needs: remove branding, add your domain, and unlock more tools.",
    "upgrade_page.copy.everything_unlocked": "Everything unlocked",
    "Everything unlocked": "Everything unlocked",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Full AI stack, advanced marketing, and everything unlocked for stores serious about growth.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "A note from the Tradly team",
    "A note from the Tradly team": "A note from the Tradly team",
    "upgrade_page.copy.help_us_keep_tradly_going": "Help us keep Tradly going",
    "Help us keep Tradly going": "Help us keep Tradly going",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Choose the plan that fits you today. You can change it any time.",
    "Choose the plan that fits you today. You can change it any time.": "Choose the plan that fits you today. You can change it any time.",
    "upgrade_page.back_to_workspace": "Back to workspace",
    "Back to workspace": "Back to workspace",
    "upgrade_page.grow_when_ready": "Grow when the work calls for it",
    "Grow when the work calls for it": "Grow when the work calls for it",
    "upgrade_page.reassurance": "Your existing data, listings, and setup stay exactly as they are.",
    "Your existing data, listings, and setup stay exactly as they are.": "Your existing data, listings, and setup stay exactly as they are.",
    "upgrade_page.choose_plan": "Choose a plan",
    "Choose a plan": "Choose a plan",
    "upgrade_page.feature_availability": "Feature availability",
    "Feature availability": "Feature availability",
    "upgrade_page.available_from": "Available from",
    "Available from": "Available from",
    "upgrade_page.and_above": "and above",
    "and above": "and above",
    "upgrade_page.choose_when_useful": "Choose a plan only when this capability is useful to your team.",
    "Choose a plan only when this capability is useful to your team.": "Choose a plan only when this capability is useful to your team.",
    "upgrade_page.practical_difference": "The practical difference",
    "The practical difference": "The practical difference",
    "upgrade_page.keep_work_simple": "Keep the work simpler as you grow.",
    "Keep the work simpler as you grow.": "Keep the work simpler as you grow.",
    "upgrade_page.plan_path": "Plan path",
    "Plan path": "Plan path",
    "upgrade_page.plan_path_title": "Start with the plan that supports this next step.",
    "Start with the plan that supports this next step.": "Start with the plan that supports this next step.",
    "upgrade_page.best_next_step": "Best next step",
    "upgrade_page.includes_capability": "Includes this capability",
    "Includes this capability": "Includes this capability",
    "upgrade_page.not_included": "Not included",
    "Not included": "Not included",
    "upgrade_page.included": "✓ Included",
    "✓ Included": "✓ Included",
    "upgrade_page.ready_when_you_are": "Ready when you are.",
    "Ready when you are.": "Ready when you are.",
    "upgrade_page.billing_details": "Review the complete plan details and continue securely with Tradly billing.",
    "Review the complete plan details and continue securely with Tradly billing.": "Review the complete plan details and continue securely with Tradly billing.",
    "upgrade_page.panel.close": "Close upgrade panel",
    "Close upgrade panel": "Close upgrade panel",
    "upgrade_page.panel.show_less": "Show less",
    "Show less": "Show less",
    "upgrade_page.panel.see_more": "See more",
    "See more": "See more",
    "upgrade_page.panel.choose_to_continue": "Choose a plan to continue",
    "Choose a plan to continue": "Choose a plan to continue",
    "upgrade_page.panel.more_ways_to_grow": "More ways to grow",
    "More ways to grow": "More ways to grow",
    "upgrade_page.panel.plan_includes_feature": "Each plan includes this feature plus additional capacity for your next stage.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Each plan includes this feature plus additional capacity for your next stage.",
    "upgrade_page.panel.add_credits": "Add credits or products",
    "Add credits or products": "Add credits or products",
    "upgrade_page.panel.ala_carte_description": "Your workspace is billed à la carte. Top up credits or add the products you need.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Your workspace is billed à la carte. Top up credits or add the products you need.",
    "upgrade_page.panel.open_ala_carte": "Open à la carte",
    "Open à la carte": "Open à la carte",
    "upgrade_page.panel.recommended": "Recommended",
    "Recommended": "Recommended",
    "upgrade_page.panel.per_month": "/ month",
    "upgrade_page.panel.please_wait": "Please wait…",
    "upgrade_page.panel.unlock_plan": "Unlock {plan}",
    "Unlock {plan}": "Unlock {plan}",
    "upgrade_page.panel.choose_plan": "Choose {plan}",
    "Choose {plan}": "Choose {plan}",
    "upgrade_page.panel.compare_plans": "Compare all plan details",
    "Compare all plan details": "Compare all plan details",
    "workspace.usage.page_title": "Usage overview",
    "Usage overview": "Usage overview",
    "workspace.usage.page_description": "See current usage and the limits applied to this workspace.",
    "workspace.usage.not_available": "Not available",
    "workspace.usage.limit_not_configured": "Limit not configured",
    "Limit not configured": "Limit not configured",
    "workspace.usage.limit_value": "Limit: {limit}",
    "Limit: {limit}": "Limit: {limit}",
    "listings.photos": "Photos",
    "Photos": "Photos",
    "listings.listen_episode": "Listen to this episode",
    "Listen to this episode": "Listen to this episode",
    "listings.other_listings": "Other listings",
    "Other listings": "Other listings",
    "listings.delete": "Delete",
    "listings.fulfilled_by_platform": "Fulfilled by Platform",
    "Fulfilled by Platform": "Fulfilled by Platform",
    "listings.no_attributes_set": "No attributes set",
    "No attributes set": "No attributes set",
    "listings.campaign_raised": "{amount} raised",
    "{amount} raised": "{amount} raised",
    "listings.campaign_progress": "{percent}% of {goal}",
    "{percent}% of {goal}": "{percent}% of {goal}",
    "listings.seat": "seat",
    "seat": "seat",
    "listings.seats": "seats",
    "seats": "seats",
    "listings.per_slot": "per slot",
    "per slot": "per slot",
    "listings.total_value": "Total: {total}",
    "Total: {total}": "Total: {total}",
    "listings.orders": "Orders",
    "listings.total_orders": "Total orders",
    "Total orders": "Total orders",
    "listings.revenue": "Revenue",
    "listings.average_order": "Avg order",
    "listings.customers": "Customers",
    "Customers": "Customers",
    "listings.load_more": "Load more",
    "Load more": "Load more",
    "listings.filter": "Filter",
    "listings.sort": "Sort",
    "Sort": "Sort",
    "listings.value_price": "Value Price",
    "Value Price": "Value Price",
    "listings.detail_label_title": "Title",
    "listings.detail_label_slug": "Slug",
    "listings.detail_label_description": "Description",
    "listings.detail_label_categories": "Categories",
    "listings.detail_label_list_price": "List Price",
    "List Price": "List Price",
    "listings.detail_label_offer": "Offer",
    "Offer": "Offer",
    "listings.detail_label_currency": "Currency",
    "listings.detail_label_listing_status": "Listing Status",
    "Listing Status": "Listing Status",
    "listings.detail_label_active": "Active",
    "listings.detail_label_sold": "Sold",
    "listings.detail_label_meta_title": "Meta Title",
    "listings.detail_label_meta_description": "Meta Description",
    "listings.detail_label_goal": "Goal",
    "Goal": "Goal",
    "listings.detail_label_donors": "Donors",
    "Donors": "Donors",
    "listings.detail_label_start_date": "Start date",
    "listings.detail_label_end_date": "End date",
    "listings.detail_label_stock": "Stock",
    "listings.detail_label_max_qty_order": "Max qty / order",
    "Max qty / order": "Max qty / order",
    "listings.detail_label_weight": "Weight",
    "listings.detail_label_dimensions": "Dimensions",
    "Dimensions": "Dimensions",
    "listings.detail_label_listing_period": "Listing period",
    "Listing period": "Listing period",
    "listings.detail_label_max_tickets_booking": "Max tickets / booking",
    "Max tickets / booking": "Max tickets / booking",
    "listings.detail_label_rating": "Rating",
    "listings.detail_label_reviews": "Reviews",
    "listings.detail_label_likes": "Likes",
    "Likes": "Likes",
    "listings.detail_label_dislikes": "Dislikes",
    "Dislikes": "Dislikes",
    "listings.detail_label_barcode": "Barcode",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Basic Info",
    "Basic Info": "Basic Info",
    "listings.detail_section_pricing": "Pricing",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Select a listing type above to continue.",
    "Select a listing type above to continue.": "Select a listing type above to continue.",
    "listing_form.attributes": "Attributes",
    "category.status_active_help": "Status (Inactive / Active)",
    "promotions.medium": "Medium",
    "users.listings": "Listings",
    "users.accounts": "Accounts",
    "users.click_count_one": "{count} click",
    "{count} click": "{count} click",
    "users.click_count": "{count} clicks",
    "{count} clicks": "{count} clicks",
    "integrations.generic.provider_help": "Configure the selected provider using the fields below.",
    "Configure the selected provider using the fields below.": "Configure the selected provider using the fields below.",
    "attributes.editor_prefill_data_from": "Prefill Data From",
    "Prefill Data From": "Prefill Data From",
    "attributes.editor_select_attribute": "Select Attribute",
    "Select Attribute": "Select Attribute",
    "attributes.editor_select_attribute_group": "Select Attribute Group",
    "Select Attribute Group": "Select Attribute Group",
    "attributes.editor_attribute": "Attribute",
    "Attribute": "Attribute",
    "attributes.editor_attributes": "Attributes",
    "attributes.editor_cart_attributes": "Cart Attributes",
    "Cart Attributes": "Cart Attributes",
    "listings.add_photo": "Add Photo",
    "accounts.analytics": "Analytics",
    "listings.image_optional": "Listing Images (Optional)",
    "Listing Images (Optional)": "Listing Images (Optional)",
    "listings.currency": "Currency",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "Active",
    "listing_form.digital_deleted_item_cannot_edit": "This item is marked for deletion and cannot be edited",
    "This item is marked for deletion and cannot be edited": "This item is marked for deletion and cannot be edited",
    "listing_form.digital_max_files": "Maximum 10 files allowed",
    "Maximum 10 files allowed": "Maximum 10 files allowed",
    "listing_form.digital_title_required": "Please enter a title",
    "listing_form.digital_version_required": "Please enter a version name",
    "Please enter a version name": "Please enter a version name",
    "listing_form.digital_contents": "Digital Contents",
    "Digital Contents": "Digital Contents",
    "listing_form.digital_add_content": "+ Add Content",
    "+ Add Content": "+ Add Content",
    "listing_form.no_description": "No description",
    "No description": "No description",
    "listing_form.digital_file_count": "{count} file(s)",
    "{count} file(s)": "{count} file(s)",
    "listing_form.digital_empty": "No digital contents yet",
    "No digital contents yet": "No digital contents yet",
    "listing_form.digital_empty_help": "Click \"{action}\" to create your first digital content",
    "Click \"{action}\" to create your first digital content": "Click \"{action}\" to create your first digital content",
    "listing_form.digital_marked_for_deletion": "Marked for Deletion ({count})",
    "Marked for Deletion ({count})": "Marked for Deletion ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Will be deleted on submit",
    "✓ Will be deleted on submit": "✓ Will be deleted on submit",
    "listing_form.digital_edit_title": "Edit Digital Content",
    "Edit Digital Content": "Edit Digital Content",
    "listing_form.digital_add_title": "Add New Digital Content",
    "Add New Digital Content": "Add New Digital Content",
    "listing_form.digital_form_description": "Fill in the details below to {action} digital content",
    "Fill in the details below to {action} digital content": "Fill in the details below to {action} digital content",
    "listing_form.digital_title_placeholder": "Enter digital content title",
    "Enter digital content title": "Enter digital content title",
    "listing_form.description_optional_placeholder": "Enter description (optional)",
    "Enter description (optional)": "Enter description (optional)",
    "listing_form.version": "Version",
    "Version": "Version",
    "listing_form.files": "Files",
    "Files": "Files",
    "listing_form.max_files": "(Max {count})",
    "(Max {count})": "(Max {count})",
    "listing_form.click_to_upload_files": "Click to upload files",
    "Click to upload files": "Click to upload files",
    "listing_form.files_uploaded_count": "{count}/10 files uploaded",
    "{count}/10 files uploaded": "{count}/10 files uploaded",
    "listing_form.unknown_size": "Unknown size",
    "Unknown size": "Unknown size",
    "listing_form.no_accounts_available": "No accounts available",
    "No accounts available": "No accounts available",
    "listing_form.select_account": "Select an account",
    "Select an account": "Select an account",
    "listing_form.searching": "Searching...",
    "Searching...": "Searching...",
    "listing_form.location_enter_address": "Please enter an address to search",
    "Please enter an address to search": "Please enter an address to search",
    "listing_form.location_no_addresses_search": "No addresses found. Please try a different search.",
    "No addresses found. Please try a different search.": "No addresses found. Please try a different search.",
    "listing_form.location_search_failed": "Failed to search addresses. Please try again.",
    "Failed to search addresses. Please try again.": "Failed to search addresses. Please try again.",
    "listing_form.location_place_details_failed": "Failed to get place details. Please try again.",
    "Failed to get place details. Please try again.": "Failed to get place details. Please try again.",
    "listing_form.location_access_denied": "Location access denied. Please enable location permissions.",
    "Location access denied. Please enable location permissions.": "Location access denied. Please enable location permissions.",
    "listing_form.location_unavailable": "Unable to determine location. Please try again.",
    "Unable to determine location. Please try again.": "Unable to determine location. Please try again.",
    "listing_form.location_timeout": "Location request timed out. Please try again.",
    "Location request timed out. Please try again.": "Location request timed out. Please try again.",
    "listing_form.location_current_failed": "Failed to get current location. Please try again.",
    "Failed to get current location. Please try again.": "Failed to get current location. Please try again.",
    "listing_form.location": "Location",
    "listing_form.location_search_placeholder": "Search for a location...",
    "Search for a location...": "Search for a location...",
    "listing_form.location_searching": "Searching addresses...",
    "Searching addresses...": "Searching addresses...",
    "listing_form.location_no_addresses": "No addresses found",
    "No addresses found": "No addresses found",
    "listing_form.location_try_different_search": "Try a different search term",
    "Try a different search term": "Try a different search term",
    "listing_form.location_getting": "Getting location...",
    "Getting location...": "Getting location...",
    "listing_form.location_use_current": "Use Current Location",
    "Use Current Location": "Use Current Location",
    "listing_form.location_selected": "Selected Location",
    "Selected Location": "Selected Location",
    "listing_form.latitude": "Latitude:",
    "Latitude:": "Latitude:",
    "listing_form.longitude": "Longitude:",
    "Longitude:": "Longitude:",
    "listing_form.location_helper": "Search for an address or use your current location",
    "Search for an address or use your current location": "Search for an address or use your current location",
    "common.change": "Change",
    "listing_form.variant_id_tooltip": "Type ID: {typeId}, Value ID: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "Type ID: {typeId}, Value ID: {valueId}",
    "listing_form.variants_marked_for_deletion": "Marked for Deletion ({count} items):",
    "Marked for Deletion ({count} items):": "Marked for Deletion ({count} items):",
    "listing_form.add_new_variant": "Add New Variant",
    "Add New Variant": "Add New Variant",
    "listing_form.add_variant_description": "Fill in the details below to create a new variant",
    "Fill in the details below to create a new variant": "Fill in the details below to create a new variant",
    "listing_form.google_search_preview": "Google Search Preview",
    "Google Search Preview": "Google Search Preview",
    "listing_form.meta_title_preview": "Your Meta Title Here",
    "Your Meta Title Here": "Your Meta Title Here",
    "listing_form.meta_description_preview": "Your meta description will appear here. This helps users understand your page content in search results.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Your meta description will appear here. This helps users understand your page content in search results.",
    "listing_form.variant_name_placeholder": "Enter name",
    "listing_form.list_price_placeholder": "Enter list price",
    "listing_form.offer_percent_placeholder": "Enter Offer Percent",
    "Enter Offer Percent": "Enter Offer Percent",
    "attributes.select_all": "Select All",
    "attributes.unselect_all": "Unselect All",
    "Unselect All": "Unselect All",
    "attributes.select_category": "Select category",
    "attributes.create_category_configuration_first": "Create categories in {type} configuration first",
    "Create categories in {type} configuration first": "Create categories in {type} configuration first",
    "attributes.select_single_attribute_values": "Select Single Attribute Values",
    "attributes.select_multiple_attribute_values": "Select Multiple Attribute Values",
    "attributes.enter_value": "Enter Value",
    "attributes.enter_multiple_tags": "Enter Multiple Tags",
    "Enter Multiple Tags": "Enter Multiple Tags",
    "attributes.upload_file": "Upload file",
    "collections.add_condition": "+ Add another condition",
    "+ Add another condition": "+ Add another condition",
    "collections.add_photo": "Add Photo",
    "collections.status": "Status (Inactive / Active)",
    "collections.start_date_placeholder": "Select start date",
    "Select start date": "Select start date",
    "collections.end_date_placeholder": "Select end date",
    "Select end date": "Select end date",
    "navigation.editor": "Editor",
    "Editor": "Editor",
    "navigation.web_analytics": "Web Analytics",
    "Web Analytics": "Web Analytics",
    "navigation.ai_studio": "AI Studio",
    "AI Studio": "AI Studio",
    "navigation.docs": "Docs",
    "navigation.logout": "Logout",
    "Logout": "Logout",
    "navigation.tenant_name_placeholder": "(Tenant name)",
    "(Tenant name)": "(Tenant name)",
    "navigation.username_placeholder": "(Username)",
    "(Username)": "(Username)",
    "navigation.invite_description": "Send invitation links to team members",
    "Send invitation links to team members": "Send invitation links to team members",
    "navigation.invite": "Invite",
    "Invite": "Invite",
    "navigation.test_mode": "Test Mode",
    "Test Mode": "Test Mode",
    "navigation.upgrade": "Upgrade",
    "navigation.open_account_menu": "Open account menu",
    "Open account menu": "Open account menu",
    "navigation.invite_name_required": "Please fill in the name",
    "Please fill in the name": "Please fill in the name",
    "navigation.invite_email_required": "Please fill in the email",
    "Please fill in the email": "Please fill in the email",
    "navigation.open_url_failed": "Don't know how to open this URL: {url}",
    "Don't know how to open this URL: {url}": "Don't know how to open this URL: {url}",
    "navigation.no_code_editor": "No-code editor",
    "No-code editor": "No-code editor",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Marketing automation",
    "Marketing automation": "Marketing automation",
    "navigation.analytics_recommendation": "Analytics & Recommendation",
    "Analytics & Recommendation": "Analytics & Recommendation",
    "navigation.ai_studio_iryxo": "AI Studio (Iryxo)",
    "AI Studio (Iryxo)": "AI Studio (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Current project",
    "Current project": "Current project",
    "navigation.current_user": "Current user",
    "Current user": "Current user",
    "navigation.switch_to_light_mode": "Switch to light mode",
    "Switch to light mode": "Switch to light mode",
    "navigation.switch_to_dark_mode": "Switch to dark mode",
    "Switch to dark mode": "Switch to dark mode",
    "navigation.download_android_app": "Download Android app",
    "Download Android app": "Download Android app",
    "navigation.download_ios_app": "Download iOS app",
    "Download iOS app": "Download iOS app",
    "navigation.subscribe_youtube": "Subscribe on YouTube",
    "Subscribe on YouTube": "Subscribe on YouTube",
    "navigation.open_app_switcher": "Open app switcher",
    "Open app switcher": "Open app switcher",
    "navigation.open_android_app": "Open Android app",
    "Open Android app": "Open Android app",
    "navigation.open_ios_app": "Open iOS app",
    "Open iOS app": "Open iOS app",
    "navigation.open_ai_support": "Open Tradly ChatGPT support",
    "Open Tradly ChatGPT support": "Open Tradly ChatGPT support",
    "navigation.open_youtube_channel": "Open Tradly YouTube channel",
    "Open Tradly YouTube channel": "Open Tradly YouTube channel",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "Listing ID (optional — update existing)",
    "Listing ID (optional — update existing)": "Listing ID (optional — update existing)",
    "listings.smart_upload.category_id": "Category ID",
    "listings.smart_upload.list_price": "List price",
    "listings.smart_upload.stock": "Stock",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Barcode",
    "listings.smart_upload.account_id": "Account ID",
    "listings.smart_upload.slug": "Slug",
    "listings.smart_upload.text": "Text",
    "listings.smart_upload.long_text": "Long text",
    "listings.smart_upload.number": "Number",
    "listings.smart_upload.single_select": "Single select",
    "listings.smart_upload.multi_select": "Multi select",
    "listings.smart_upload.attribute_name_required": "Enter an attribute name for “{header}”.",
    "listings.smart_upload.attribute_create_failed": "Tradly did not return the new “{name}” attribute.",
    "Tradly did not return the new “{name}” attribute.": "Tradly did not return the new “{name}” attribute.",
    "listings.smart_upload.attribute_option_create_failed": "Could not create the “{value}” option for {name}.",
    "Could not create the “{value}” option for {name}.": "Could not create the “{value}” option for {name}.",
    "listings.smart_upload.attribute_no_longer_available": "The attribute mapped from “{header}” is no longer available.",
    "listings.smart_upload.csv_needs_header_and_listing": "The CSV must contain a header row and at least one listing.",
    "The CSV must contain a header row and at least one listing.": "The CSV must contain a header row and at least one listing.",
    "listings.smart_upload.unique_headers_required": "Every listing column needs a unique, non-empty header.",
    "Every listing column needs a unique, non-empty header.": "Every listing column needs a unique, non-empty header.",
    "listings.smart_upload.csv_read_failed": "Unable to read this CSV.",
    "listings.smart_upload.map_required_fields": "Map these required columns before continuing: {fields}",
    "Map these required columns before continuing: {fields}": "Map these required columns before continuing: {fields}",
    "listings.smart_upload.row_missing_required_value": "Row {row} is missing a required value.",
    "Row {row} is missing a required value.": "Row {row} is missing a required value.",
    "listings.smart_upload.invalid_category_id_row": "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.",
    "listings.smart_upload.invalid_listing_id_row": "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.",
    "listings.smart_upload.progress.checking_duplicates": "Checking for existing listings",
    "Checking for existing listings": "Checking for existing listings",
    "listings.smart_upload.duplicate_same_value_row": "Same {field} appears in row {row} of this file.",
    "Same {field} appears in row {row} of this file.": "Same {field} appears in row {row} of this file.",
    "listings.smart_upload.duplicate_same_value_multiple": "Same {field} appears more than once in this file.",
    "Same {field} appears more than once in this file.": "Same {field} appears more than once in this file.",
    "listings.smart_upload.duplicate_existing_listing": "Matches existing listing #{id} by {field}.",
    "Matches existing listing #{id} by {field}.": "Matches existing listing #{id} by {field}.",
    "listings.smart_upload.explicit_listing_update": "Explicit listing ID #{id} will be updated.",
    "Explicit listing ID #{id} will be updated.": "Explicit listing ID #{id} will be updated.",
    "listings.smart_upload.progress.duplicates_complete": "Duplicate check complete",
    "Duplicate check complete": "Duplicate check complete",
    "listings.smart_upload.duplicate_check_failed": "Could not check existing listings.",
    "Could not check existing listings.": "Could not check existing listings.",
    "listings.smart_upload.progress.duplicates_stopped": "Duplicate check stopped",
    "Duplicate check stopped": "Duplicate check stopped",
    "listings.smart_upload.prepare_file_failed": "Could not prepare the import file.",
    "listings.smart_upload.progress.uploading_file": "Uploading import file",
    "listings.smart_upload.upload_file_failed": "The import file could not be uploaded.",
    "listings.smart_upload.all_rows_duplicates": "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.",
    "listings.smart_upload.progress.preparing_attributes": "Preparing attributes",
    "listings.smart_upload.attribute_mapped_once": "Each listing attribute can be mapped only once. Review the column mappings before importing.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Each listing attribute can be mapped only once. Review the column mappings before importing.",
    "listings.smart_upload.progress.preparing_file": "Preparing import file",
    "listings.smart_upload.progress.tradly_importing": "Tradly is importing listings",
    "Tradly is importing listings": "Tradly is importing listings",
    "listings.smart_upload.progress.import_complete": "Import complete",
    "listings.smart_upload.progress.import_stopped": "Import stopped",
    "listings.smart_upload.progress.preparing_import": "Preparing import…",
    "Preparing import…": "Preparing import…",
    "listings.smart_upload.progress.rows_prepared": "{current} of {total} rows prepared",
    "{current} of {total} rows prepared": "{current} of {total} rows prepared",
    "listings.smart_upload.progress.remote_processing": "Tradly is processing the uploaded CSV. This may take a moment.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly is processing the uploaded CSV. This may take a moment.",
    "listings.smart_upload.progress.partial_import": "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.",
    "listings.smart_upload.title": "Smart Upload",
    "Smart Upload": "Smart Upload",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Start over",
    "listings.smart_upload.description": "Upload listings, map columns to existing fields, or create new listing attributes before importing.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Upload listings, map columns to existing fields, or create new listing attributes before importing.",
    "listings.smart_upload.step_upload": "Upload",
    "listings.smart_upload.step_match": "Match columns",
    "listings.smart_upload.step_preview": "Preview",
    "listings.smart_upload.step_import": "Import",
    "listings.smart_upload.choose_csv": "Choose a CSV file",
    "listings.smart_upload.required_columns_help": "Required columns are title and category_id. Any other columns can become listing attributes.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Required columns are title and category_id. Any other columns can become listing attributes.",
    "listings.smart_upload.select_csv_file": "Select CSV file",
    "listings.smart_upload.match_columns": "Match listing columns",
    "Match listing columns": "Match listing columns",
    "listings.smart_upload.core_fields_help": "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.",
    "listings.smart_upload.do_not_import": "Do not import",
    "listings.smart_upload.map_category_manually": "Map Category ID manually",
    "Map Category ID manually": "Map Category ID manually",
    "listings.smart_upload.category_assignment_help": "Choose the category to assign to every imported listing.",
    "Choose the category to assign to every imported listing.": "Choose the category to assign to every imported listing.",
    "listings.smart_upload.select_category": "Select a category",
    "listings.smart_upload.no_categories": "No listing categories were returned. Create a category first, then reopen Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "No listing categories were returned. Create a category first, then reopen Smart Upload.",
    "listings.smart_upload.additional_attributes": "Additional listing attributes",
    "Additional listing attributes": "Additional listing attributes",
    "listings.smart_upload.ignore_column": "Ignore this column",
    "listings.smart_upload.create_attribute": "＋ Create a new listing attribute",
    "＋ Create a new listing attribute": "＋ Create a new listing attribute",
    "listings.smart_upload.attribute_name": "Attribute name",
    "listings.smart_upload.review_import": "Review import",
    "listings.smart_upload.rows_scanned_help": "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.",
    "listings.smart_upload.duplicates_found": "Potential duplicates found",
    "Potential duplicates found": "Potential duplicates found",
    "listings.smart_upload.duplicate_rows_skipped": "{count} row(s) will be skipped by default.",
    "{count} row(s) will be skipped by default.": "{count} row(s) will be skipped by default.",
    "listings.smart_upload.row_label": "Row",
    "Row": "Row",
    "listings.smart_upload.explicit_ids_are_updates": "Rows with an explicit listing ID are treated as updates.",
    "Rows with an explicit listing ID are treated as updates.": "Rows with an explicit listing ID are treated as updates.",
    "listings.smart_upload.duplicate_action": "Duplicate action",
    "Duplicate action": "Duplicate action",
    "listings.smart_upload.skip_duplicates": "Skip potential duplicates (recommended)",
    "Skip potential duplicates (recommended)": "Skip potential duplicates (recommended)",
    "listings.smart_upload.import_all_anyway": "Import all rows anyway",
    "Import all rows anyway": "Import all rows anyway",
    "listings.smart_upload.untitled_listing": "Untitled listing",
    "Untitled listing": "Untitled listing",
    "listings.smart_upload.category_label": "Category:",
    "Category:": "Category:",
    "listings.smart_upload.complete": "Smart Upload complete",
    "listings.smart_upload.imported_count": "{imported} of {total} listings imported.",
    "{imported} of {total} listings imported.": "{imported} of {total} listings imported.",
    "listings.smart_upload.selected_file": "Selected: {name}",
    "listings.smart_upload.checking": "Checking…",
    "listings.smart_upload.check_duplicates": "Check duplicates",
    "Check duplicates": "Check duplicates",
    "listings.smart_upload.importing": "Importing…",
    "listings.smart_upload.import_listings": "Import listings",
    "listings.smart_upload.failed": "Smart Upload failed.",
    "Smart Upload failed.": "Smart Upload failed.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Status (Inactive / Active)",
    "listings.upload_media": "Upload Media",
    "listing_form.stock_placeholder": "Enter stock",
    "orders.create_order.order_items_alt": "Order Items",
    "orders.create_order.by": "by",
    "by": "by",
    "orders.create_order.decrease_quantity": "Decrease quantity",
    "Decrease quantity": "Decrease quantity",
    "orders.create_order.increase_quantity": "Increase quantity",
    "Increase quantity": "Increase quantity",
    "orders.create_order.remove_item": "Remove item",
    "Remove item": "Remove item",
    "orders.create_order.rental_period_label": "Rental period:",
    "Rental period:": "Rental period:",
    "attributes.enter_text": "Enter Text",
    "attributes.select_date": "Select Date",
    "attributes.enter_number": "Enter Number",
    "attributes.select_color": "Select Color",
    "attributes.upload_json": "Upload JSON",
    "Upload JSON": "Upload JSON",
    "attributes.select_location": "Select Location",
    "attributes.add_listing_preview": "Add Listing",
    "attributes.add_account_preview": "Add Account",
    "attributes.enter_price": "Enter Price",
    "attributes.preview": "Preview",
    "attributes.enter_title": "Enter Title",
    "attributes.enter_description": "Enter Description",
    "attributes.category": "Category",
    "attributes.attribute_name": "Attribute name",
    "attributes.enter_attribute_name": "Enter attribute name",
    "attributes.select_type": "Select type",
    "attributes.icon": "Icon",
    "attributes.tooltip": "Tooltip",
    "Tooltip": "Tooltip",
    "attributes.enter_tooltip": "Enter attribute tooltip",
    "Enter attribute tooltip": "Enter attribute tooltip",
    "listings.detail.images": "Images",
    "listings.detail.posted_by": "Posted by",
    "Posted by": "Posted by",
    "listings.detail.fulfilled_by_platform": "Fulfilled by Platform",
    "listings.detail.preview": "Preview",
    "listings.detail.view_listing": "View Listing",
    "View Listing": "View Listing",
    "listings.detail.variants": "Variants",
    "listings.detail.no_attribute_values": "No attribute values for {name}",
    "listings.detail.attributes": "Attributes",
    "listings.detail.starts_from": "Starts From:",
    "Starts From:": "Starts From:",
    "listings.detail.schedule": "Schedule",
    "listings.detail.detail": "Detail",
    "web_config.download": "Download",
    "web_config.cancel": "Cancel",
    "web_config.choose_file": "Choose file",
    "web_config.title": "Web Configs",
    "Web Configs": "Web Configs",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Logo Width",
    "Logo Width": "Logo Width",
    "web_config.width": "Width",
    "web_config.logo_height": "Logo Height",
    "Logo Height": "Logo Height",
    "web_config.height": "Height",
    "web_config.social_share_image": "Web Featured Image for Social Share - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Web Featured Image for Social Share - Open Graph",
    "web_config.business_name": "Business Name",
    "web_config.enter_web_name": "Enter web name",
    "Enter web name": "Enter web name",
    "web_config.title_font": "Title Font",
    "Title Font": "Title Font",
    "web_config.select_title_font": "Select title font",
    "Select title font": "Select title font",
    "web_config.body_font": "Body Font",
    "Body Font": "Body Font",
    "web_config.select_body_font": "Select body font",
    "Select body font": "Select body font",
    "web_config.primary_font": "Primary Font",
    "Primary Font": "Primary Font",
    "web_config.select_primary_font": "Select primary font",
    "Select primary font": "Select primary font",
    "web_config.uploaded_successfully": "Uploaded successfully",
    "web_config.ios_download_icon": "iOS app download icon",
    "iOS app download icon": "iOS app download icon",
    "web_config.ios_download_link": "iOS app download link",
    "iOS app download link": "iOS app download link",
    "web_config.enter_ios_download_link": "Enter iOS app download link",
    "Enter iOS app download link": "Enter iOS app download link",
    "web_config.android_download_icon": "Android app download icon",
    "Android app download icon": "Android app download icon",
    "web_config.android_download_link": "Android app download link",
    "Android app download link": "Android app download link",
    "web_config.enter_android_download_link": "Enter android app download link",
    "Enter android app download link": "Enter android app download link",
    "coupons.preview.customer_checkout": "CUSTOMER CHECKOUT",
    "CUSTOMER CHECKOUT": "CUSTOMER CHECKOUT",
    "coupons.preview.title": "Coupons in action",
    "Coupons in action": "Coupons in action",
    "coupons.preview.featured_product": "Your featured product",
    "Your featured product": "Your featured product",
    "coupons.preview.product_meta": "1 item · Standard delivery",
    "1 item · Standard delivery": "1 item · Standard delivery",
    "coupons.preview.coupon_applied": "Coupon applied",
    "Coupon applied": "Coupon applied",
    "coupons.preview.remove": "Remove",
    "coupons.preview.discount_applied": "Discount applied to the order",
    "Discount applied to the order": "Discount applied to the order",
    "coupons.preview.subtotal": "Subtotal",
    "coupons.preview.coupon_label": "Coupon · WELCOME10",
    "Coupon · WELCOME10": "Coupon · WELCOME10",
    "coupons.preview.grand_total": "Grand total",
    "Grand total": "Grand total",
    "coupons.preview.checkout": "CHECKOUT",
    "CHECKOUT": "CHECKOUT",
    "payments.stripe_get_keys": "Get Stripe keys",
    "Get Stripe keys": "Get Stripe keys",
    "payments.stripe_syncing": "Syncing with Stripe...",
    "Syncing with Stripe...": "Syncing with Stripe...",
    "payments.stripe_verifying_key": "Verifying secret key",
    "Verifying secret key": "Verifying secret key",
    "payments.stripe_creating_webhook": "Creating payment webhook",
    "Creating payment webhook": "Creating payment webhook",
    "payments.stripe_account_summary": "{country} · {mode} mode · {id}",
    "{country} · {mode} mode · {id}": "{country} · {mode} mode · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.",
    "payments.stripe_webhooks_error": "⚠ Webhook setup failed. Check your key permissions and try Sync again.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Webhook setup failed. Check your key permissions and try Sync again.",
    "payments.stripe_invalid_key": "Invalid secret key. Check and try again.",
    "Invalid secret key. Check and try again.": "Invalid secret key. Check and try again.",
    "payments.stripe_setup_failed": "Setup failed. Make sure your secret key is synced first.",
    "Setup failed. Make sure your secret key is synced first.": "Setup failed. Make sure your secret key is synced first.",
    "payments.stripe_marketplace_connect": "Marketplace Connect",
    "Marketplace Connect": "Marketplace Connect",
    "payments.stripe_marketplace_hint": "Only needed if you use Stripe Connect for marketplace payouts",
    "Only needed if you use Stripe Connect for marketplace payouts": "Only needed if you use Stripe Connect for marketplace payouts",
    "payments.stripe_subscription_hint": "Only needed if you sell subscription products on Tradly",
    "Only needed if you sell subscription products on Tradly": "Only needed if you sell subscription products on Tradly",
    "integrations.sso.title": "Enterprise single sign-on",
    "Enterprise single sign-on": "Enterprise single sign-on",
    "integrations.sso.description": "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.",
    "integrations.sso.issuer_url": "Issuer URL",
    "Issuer URL": "Issuer URL",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "Client ID",
    "integrations.sso.client_secret": "Client secret",
    "integrations.sso.secret_replace_placeholder": "Saved securely. Enter a value to replace it.",
    "Saved securely. Enter a value to replace it.": "Saved securely. Enter a value to replace it.",
    "integrations.sso.secret_placeholder": "Enter the client secret",
    "Enter the client secret": "Enter the client secret",
    "integrations.sso.email_domains": "Company email domains",
    "Company email domains": "Company email domains",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.",
    "integrations.sso.callback_url": "OIDC callback URL",
    "OIDC callback URL": "OIDC callback URL",
    "integrations.sso.loading_callback_url": "Loading callback URL…",
    "Loading callback URL…": "Loading callback URL…",
    "integrations.sso.callback_help": "Add this exact URL to the identity provider application as a Web redirect URI.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Add this exact URL to the identity provider application as a Web redirect URI.",
    "integrations.sso.enable": "Enable company SSO sign-in",
    "Enable company SSO sign-in": "Enable company SSO sign-in",
    "integrations.sso.checking": "Checking…",
    "integrations.sso.test_issuer": "Test issuer",
    "Test issuer": "Test issuer",
    "integrations.sso.saving": "Saving…",
    "integrations.sso.save": "Save SSO settings",
    "Save SSO settings": "Save SSO settings",
    "integrations.sso.security_help": "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.",
    "integrations.sso.load_error": "Unable to load enterprise SSO settings.",
    "Unable to load enterprise SSO settings.": "Unable to load enterprise SSO settings.",
    "integrations.sso.save_error": "Unable to save enterprise SSO settings.",
    "Unable to save enterprise SSO settings.": "Unable to save enterprise SSO settings.",
    "integrations.sso.saved": "Enterprise SSO settings saved.",
    "Enterprise SSO settings saved.": "Enterprise SSO settings saved.",
    "integrations.sso.connection_ok": "Identity provider discovery is reachable.",
    "Identity provider discovery is reachable.": "Identity provider discovery is reachable.",
    "integrations.sso.connection_error": "Unable to connect to the identity provider.",
    "Unable to connect to the identity provider.": "Unable to connect to the identity provider.",
    "listing_configs.maximum_quantity_per_listing": "Maximum quantity per listing",
    "listing_configs.example_quantity": "(Example: 100)",
    "listing_configs.enter_maximum_quantity": "Enter maximum quantity per listing",
    "Enter maximum quantity per listing": "Enter maximum quantity per listing",
    "listing_configs.minimum_listing_price": "Minimum listing price",
    "listing_configs.example_price": "(Example: $5)",
    "listing_configs.enter_minimum_price": "Enter minimum listing price",
    "Enter minimum listing price": "Enter minimum listing price",
    "listing_configs.picture_count": "Number of uploadable pictures count",
    "listing_configs.enter_picture_count": "Enter Pictures count",
    "Enter Pictures count": "Enter Pictures count",
    "listing_configs.feature_activation": "FEATURE ACTIVATION",
    "FEATURE ACTIVATION": "FEATURE ACTIVATION",
    "listing_configs.example_landmark": "(Example: Landmark)",
    "listing_configs.enter_address_label": "Enter address Label",
    "Enter address Label": "Enter address Label",
    "listing_configs.legacy_switch_0": "Auto approve listings?",
    "listing_configs.legacy_switch_1": "Offer percent",
    "listing_configs.legacy_switch_2": "Maximum quantity restrictions on listing level",
    "listing_configs.legacy_switch_3": "Shipping charges",
    "listing_configs.legacy_switch_4": "Use map marker instead \nof searching address",
    "Use map marker instead \nof searching address": "Use map marker instead \nof searching address",
    "listing_configs.legacy_switch_5": "Tags",
    "listing_configs.legacy_switch_6": "Stocks",
    "listing_configs.legacy_switch_7": "Geo address",
    "listing_configs.legacy_switch_8": "Show out of stock listings in feed",
    "listing_configs.legacy_switch_9": "Listing title slug",
    "listing_configs.legacy_switch_10": "Variants",
    "listing_configs.legacy_switch_11": "Meta title",
    "listing_configs.legacy_switch_12": "Meta description",
    "listing_configs.legacy_switch_13": "Digital Product",
    "Digital Product": "Digital Product",
    "listing_configs.legacy_switch_14": "Enable Composer",
    "listing_configs.legacy_switch_15": "Enable Weight",
    "listing_configs.legacy_switch_16": "Enable Dimensions",
    "navigation.app_download.close": "Close",
    "navigation.app_download.eyebrow": "Mobile companion",
    "Mobile companion": "Mobile companion",
    "navigation.app_download.title": "Keep your project moving.",
    "Keep your project moving.": "Keep your project moving.",
    "navigation.app_download.description": "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.",
    "navigation.app_download.approve_listings": "Approve listings",
    "Approve listings": "Approve listings",
    "navigation.app_download.manage_orders": "Manage orders",
    "Manage orders": "Manage orders",
    "navigation.app_download.check_performance": "Check performance",
    "Check performance": "Check performance",
    "navigation.app_download.download_title": "Download the SuperAdmin app",
    "Download the SuperAdmin app": "Download the SuperAdmin app",
    "navigation.app_download.download_on": "Download on the",
    "Download on the": "Download on the",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Get it on",
    "Get it on": "Get it on",
    "listing_configs.address_label": "Address label",
    "collections.add_another_condition": "+ Add another condition",
    "collections.search": "Search",
    "collections.status_inactive_active": "Status (Not Active / Active)",
    "media_picker.add_photo": "Add Photo",
    "payments.payment_intent_webhook_secret": "Payment Intent Webhook secret",
    "Payment Intent Webhook secret": "Payment Intent Webhook secret",
    "payments.subscription_webhook_secret": "Subscription Webhook secret",
    "Subscription Webhook secret": "Subscription Webhook secret",
    "payments.webhook_secret_autofilled": "Webhook secret auto-filled above — save the form to persist.",
    "Webhook secret auto-filled above — save the form to persist.": "Webhook secret auto-filled above — save the form to persist.",
    "app_customization.white_png_icon_help": "icon should be white and in png format",
    "icon should be white and in png format": "icon should be white and in png format",
    "app_customization.other_appearance": "Other appearance",
    "Other appearance": "Other appearance",
    "app_customization.notification_icon": "Notification icon",
    "Notification icon": "Notification icon",
    "app_customization.app_title_home": "App title in home screen",
    "app_customization.enable_app_title_icon": "Enable app title icon instead of text",
    "listings.quick_add.title": "Quick Add Listing",
    "Quick Add Listing": "Quick Add Listing",
    "listings.quick_add.success": "Listing Added Successfully",
    "Listing Added Successfully": "Listing Added Successfully",
    "listings.quick_add.image": "Image",
    "listings.quick_add.listing_name": "Listing Name",
    "Listing Name": "Listing Name",
    "listings.quick_add.title_placeholder": "e.g., Premium Wireless Headphones",
    "e.g., Premium Wireless Headphones": "e.g., Premium Wireless Headphones",
    "listings.quick_add.category": "Category",
    "listings.quick_add.select_category": "Select Category",
    "listings.quick_add.price": "Price",
    "listings.quick_add.stock": "Stock",
    "listings.quick_add.description": "Description",
    "listings.quick_add.description_placeholder": "Brief Description of your product...",
    "Brief Description of your product...": "Brief Description of your product...",
    "listings.quick_add.more_options": "Need more options? Use the full",
    "Need more options? Use the full": "Need more options? Use the full",
    "listings.quick_add.guided_form": "guided form",
    "guided form": "guided form",
    "listings.quick_add.instead": "instead",
    "instead": "instead",
    "listings.digital_product.title": "Add Digital Product",
    "Add Digital Product": "Add Digital Product",
    "listings.digital_product.select_file": "Select file",
    "Select file": "Select file",
    "listings.digital_product.name": "Title",
    "listings.digital_product.version": "Version",
    "listings.digital_product.description": "Description",
    "web_config.social_info": "Social Info",
    "Social Info": "Social Info",
    "web_config.social_facebook_pageurl": "Facebook page URL",
    "Facebook page URL": "Facebook page URL",
    "web_config.enter_social_facebook_pageurl": "Enter Facebook page URL",
    "Enter Facebook page URL": "Enter Facebook page URL",
    "web_config.social_twitter_handleurl": "Twitter handle URL",
    "Twitter handle URL": "Twitter handle URL",
    "web_config.enter_social_twitter_handleurl": "Enter Twitter handle URL",
    "Enter Twitter handle URL": "Enter Twitter handle URL",
    "web_config.social_instagram_url": "Instagram URL",
    "Instagram URL": "Instagram URL",
    "web_config.enter_social_instagram_url": "Enter Instagram URL",
    "Enter Instagram URL": "Enter Instagram URL",
    "web_config.social_youtube_channelurl": "Youtube channel URL",
    "Youtube channel URL": "Youtube channel URL",
    "web_config.enter_social_youtube_channelurl": "Enter Youtube channel URL",
    "Enter Youtube channel URL": "Enter Youtube channel URL",
    "web_config.social_tiktok_url": "Tiktok URL",
    "Tiktok URL": "Tiktok URL",
    "web_config.enter_social_tiktok_url": "Enter Tiktok URL",
    "Enter Tiktok URL": "Enter Tiktok URL",
    "web_config.social_spotify_url": "Spotify URL",
    "Spotify URL": "Spotify URL",
    "web_config.enter_social_spotify_url": "Enter Spotify URL",
    "Enter Spotify URL": "Enter Spotify URL",
    "web_config.social_whatsapp_number": "Whatsapp number",
    "Whatsapp number": "Whatsapp number",
    "web_config.enter_social_whatsapp_number": "Enter Whatsapp number",
    "Enter Whatsapp number": "Enter Whatsapp number",
    "web_config.social_telegram_url": "Telegram URL",
    "Telegram URL": "Telegram URL",
    "web_config.enter_social_telegram_url": "Enter Telegram URL",
    "Enter Telegram URL": "Enter Telegram URL",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Enter Snapchat",
    "Enter Snapchat": "Enter Snapchat",
    "payments.paydunya.title": "PayDunya Integration",
    "PayDunya Integration": "PayDunya Integration",
    "payments.paydunya.master_key": "Master key",
    "Master key": "Master key",
    "payments.paydunya.enter_master_key": "Enter master key",
    "Enter master key": "Enter master key",
    "payments.paydunya.public_key": "Public key",
    "Public key": "Public key",
    "payments.paydunya.enter_public_key": "Enter public key",
    "payments.paydunya.private_key": "Private key",
    "Private key": "Private key",
    "payments.paydunya.enter_private_key": "Enter private key",
    "Enter private key": "Enter private key",
    "payments.paydunya.token": "Token",
    "payments.paydunya.enter_token": "Enter token",
    "payments.paydunya.uploaded_successfully": "Uploaded successfully",
    "communications.email_stats_open": "{sent} sent · {openRate}% open",
    "{sent} sent · {openRate}% open": "{sent} sent · {openRate}% open",
    "communications.email_stats_full": "{sent} sent · {openRate}% open · {clicks} clicks",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} sent · {openRate}% open · {clicks} clicks",
    "navigation.mini_apps.title": "Mini Apps",
    "Mini Apps": "Mini Apps",
    "navigation.mini_apps.subtitle": "Tradly-built companion tools — tap a card to see details and pricing",
    "Tradly-built companion tools — tap a card to see details and pricing": "Tradly-built companion tools — tap a card to see details and pricing",
    "navigation.mini_apps.soon": "Soon",
    "Soon": "Soon",
    "navigation.mini_apps.included_in_paid_plan": "Included in a paid plan",
    "Included in a paid plan": "Included in a paid plan",
    "navigation.mini_apps.know_more": "Know more",
    "Know more": "Know more",
    "navigation.mini_apps.hide_details": "Hide details",
    "Hide details": "Hide details",
    "navigation.mini_apps.view_plans": "View plans",
    "navigation.mini_apps.remove": "Remove",
    "navigation.mini_apps.add_to_sidebar": "Add to sidebar",
    "Add to sidebar": "Add to sidebar",
    "navigation.mini_apps.why_heading": "Why your business needs it",
    "Why your business needs it": "Why your business needs it",
    "navigation.mini_apps.coming_soon": "Coming soon",
    "navigation.mini_apps.workflow.title": "Marketing",
    "navigation.mini_apps.workflow.description": "Run email campaigns, push notifications, and promotions to grow your audience.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Run email campaigns, push notifications, and promotions to grow your audience.",
    "navigation.mini_apps.workflow.why_1": "Send targeted email campaigns to buyers and sellers based on activity",
    "Send targeted email campaigns to buyers and sellers based on activity": "Send targeted email campaigns to buyers and sellers based on activity",
    "navigation.mini_apps.workflow.why_2": "Push notifications to re-engage users who haven't visited in 7+ days",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Push notifications to re-engage users who haven't visited in 7+ days",
    "navigation.mini_apps.workflow.why_3": "Run promotions with coupon drops timed to your seasonal events",
    "Run promotions with coupon drops timed to your seasonal events": "Run promotions with coupon drops timed to your seasonal events",
    "navigation.mini_apps.workflow.pricing_label": "Credits-based",
    "Credits-based": "Credits-based",
    "navigation.mini_apps.workflow.pricing_detail": "Pay per send — 1,000 emails costs 100 credits. Credits never expire.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Pay per send — 1,000 emails costs 100 credits. Credits never expire.",
    "navigation.mini_apps.intelligence_section.title": "Intelligence",
    "navigation.mini_apps.intelligence_section.description": "Understand your growth with analytics, funnels, and AI-powered insights.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Understand your growth with analytics, funnels, and AI-powered insights.",
    "navigation.mini_apps.intelligence_section.why_1": "See which listings, accounts, and categories drive the most GMV",
    "See which listings, accounts, and categories drive the most GMV": "See which listings, accounts, and categories drive the most GMV",
    "navigation.mini_apps.intelligence_section.why_2": "Drop-off funnels show exactly where buyers leave before checkout",
    "Drop-off funnels show exactly where buyers leave before checkout": "Drop-off funnels show exactly where buyers leave before checkout",
    "navigation.mini_apps.intelligence_section.why_3": "AI surfaces anomalies and opportunities you'd miss in raw data",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "AI surfaces anomalies and opportunities you'd miss in raw data",
    "navigation.mini_apps.intelligence_section.pricing_label": "Credits-based",
    "navigation.mini_apps.intelligence_section.pricing_detail": "AI analysis and generated reports consume credits. Data views are always free.",
    "AI analysis and generated reports consume credits. Data views are always free.": "AI analysis and generated reports consume credits. Data views are always free.",
    "navigation.mini_apps.subscription_section.title": "Subscription",
    "navigation.mini_apps.subscription_section.description": "Manage plans, billing cycles, and feature entitlements for your tenants.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Manage plans, billing cycles, and feature entitlements for your tenants.",
    "navigation.mini_apps.subscription_section.why_1": "Create tiered plans (Free / Pro / Enterprise) with per-feature gates",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Create tiered plans (Free / Pro / Enterprise) with per-feature gates",
    "navigation.mini_apps.subscription_section.why_2": "Automate billing cycles — monthly, annual, or custom durations",
    "Automate billing cycles — monthly, annual, or custom durations": "Automate billing cycles — monthly, annual, or custom durations",
    "navigation.mini_apps.subscription_section.why_3": "Entitlements unlock or restrict features across your tenant base",
    "Entitlements unlock or restrict features across your tenant base": "Entitlements unlock or restrict features across your tenant base",
    "navigation.mini_apps.subscription_section.pricing_label": "Connect",
    "Connect": "Connect",
    "navigation.mini_apps.subscription_section.pricing_detail": "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).",
    "navigation.mini_apps.membership_section.title": "Membership",
    "navigation.mini_apps.membership_section.description": "Manage membership programs, enrolled members, contributions, and payment dues.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Manage membership programs, enrolled members, contributions, and payment dues.",
    "navigation.mini_apps.membership_section.why_1": "Manage membership programs and enrolled members",
    "Manage membership programs and enrolled members": "Manage membership programs and enrolled members",
    "navigation.mini_apps.membership_section.why_2": "Track contributions, payment dues, and membership status",
    "Track contributions, payment dues, and membership status": "Track contributions, payment dues, and membership status",
    "navigation.mini_apps.membership_section.why_3": "Connect membership contributions back to their orders",
    "Connect membership contributions back to their orders": "Connect membership contributions back to their orders",
    "navigation.mini_apps.membership_section.pricing_label": "Pricing TBC",
    "Pricing TBC": "Pricing TBC",
    "navigation.mini_apps.membership_section.pricing_detail": "Manage membership programs and contribution history in one place.",
    "Manage membership programs and contribution history in one place.": "Manage membership programs and contribution history in one place.",
    "navigation.mini_apps.reward_programs.title": "Rewards",
    "navigation.mini_apps.reward_programs.description": "Create reward programs with scopes, rules, and reusable reward recipes.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Create reward programs with scopes, rules, and reusable reward recipes.",
    "navigation.mini_apps.reward_programs.why_1": "Define affiliate, referral, regional, or store reward programs",
    "Define affiliate, referral, regional, or store reward programs": "Define affiliate, referral, regional, or store reward programs",
    "navigation.mini_apps.reward_programs.why_2": "Build rules from reusable commission and reward components",
    "Build rules from reusable commission and reward components": "Build rules from reusable commission and reward components",
    "navigation.mini_apps.reward_programs.why_3": "Keep reward calculation and ledger delivery managed by the ERP backend",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Keep reward calculation and ledger delivery managed by the ERP backend",
    "navigation.mini_apps.reward_programs.pricing_label": "Pricing TBC",
    "navigation.mini_apps.reward_programs.pricing_detail": "Configure reward programs and connect them to attribution.",
    "Configure reward programs and connect them to attribution.": "Configure reward programs and connect them to attribution.",
    "navigation.mini_apps.bundles_app.title": "Bundles",
    "navigation.mini_apps.bundles_app.description": "Create fixed and mix-and-match bundles from existing listings.",
    "Create fixed and mix-and-match bundles from existing listings.": "Create fixed and mix-and-match bundles from existing listings.",
    "navigation.mini_apps.bundles_app.why_1": "Combine existing listings without duplicating product data",
    "Combine existing listings without duplicating product data": "Combine existing listings without duplicating product data",
    "navigation.mini_apps.bundles_app.why_2": "Support fixed bundles and customer-selected mix-and-match bundles",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Support fixed bundles and customer-selected mix-and-match bundles",
    "navigation.mini_apps.bundles_app.why_3": "Validate component stock before checkout and fulfilment",
    "Validate component stock before checkout and fulfilment": "Validate component stock before checkout and fulfilment",
    "navigation.mini_apps.bundles_app.pricing_label": "Paid package feature",
    "Paid package feature": "Paid package feature",
    "navigation.mini_apps.bundles_app.pricing_detail": "Available on plans that include bundle operations.",
    "Available on plans that include bundle operations.": "Available on plans that include bundle operations.",
    "navigation.mini_apps.inventory_section.title": "Supply Chain",
    "navigation.mini_apps.inventory_section.description": "Inventory, purchase orders, stock locations, suppliers, and operations.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Inventory, purchase orders, stock locations, suppliers, and operations.",
    "navigation.mini_apps.inventory_section.why_1": "Track stock levels across multiple warehouses and store locations",
    "Track stock levels across multiple warehouses and store locations": "Track stock levels across multiple warehouses and store locations",
    "navigation.mini_apps.inventory_section.why_2": "Raise purchase orders with suppliers and receive stock against them",
    "Raise purchase orders with suppliers and receive stock against them": "Raise purchase orders with suppliers and receive stock against them",
    "navigation.mini_apps.inventory_section.why_3": "Record inventory operations — adjustments, transfers, and write-offs",
    "Record inventory operations — adjustments, transfers, and write-offs": "Record inventory operations — adjustments, transfers, and write-offs",
    "navigation.mini_apps.inventory_section.pricing_label": "Included",
    "Included": "Included",
    "navigation.mini_apps.inventory_section.pricing_detail": "Supply Chain is included in your plan. No additional charge.",
    "Supply Chain is included in your plan. No additional charge.": "Supply Chain is included in your plan. No additional charge.",
    "navigation.mini_apps.people_app.title": "People",
    "navigation.mini_apps.people_app.description": "Staff directory, departments, job profiles, and pay grades.",
    "Staff directory, departments, job profiles, and pay grades.": "Staff directory, departments, job profiles, and pay grades.",
    "navigation.mini_apps.people_app.why_1": "Keep every staff profile, code, and employment type in one directory",
    "Keep every staff profile, code, and employment type in one directory": "Keep every staff profile, code, and employment type in one directory",
    "navigation.mini_apps.people_app.why_2": "Organise teams into departments with standard job profiles",
    "Organise teams into departments with standard job profiles": "Organise teams into departments with standard job profiles",
    "navigation.mini_apps.people_app.why_3": "Define pay grades once and assign them to staff",
    "Define pay grades once and assign them to staff": "Define pay grades once and assign them to staff",
    "navigation.mini_apps.people_app.pricing_label": "Pricing TBC",
    "navigation.mini_apps.people_app.pricing_detail": "Required by Workforce and Payroll.",
    "Required by Workforce and Payroll.": "Required by Workforce and Payroll.",
    "navigation.mini_apps.workforce_app.title": "Workforce",
    "navigation.mini_apps.workforce_app.description": "Shifts, attendance, and leave management for your team.",
    "Shifts, attendance, and leave management for your team.": "Shifts, attendance, and leave management for your team.",
    "navigation.mini_apps.workforce_app.why_1": "Roster staff into shifts by date, time, and location",
    "Roster staff into shifts by date, time, and location": "Roster staff into shifts by date, time, and location",
    "navigation.mini_apps.workforce_app.why_2": "Clock in and out with a full attendance history",
    "Clock in and out with a full attendance history": "Clock in and out with a full attendance history",
    "navigation.mini_apps.workforce_app.why_3": "Leave policies, balances, and an approve/reject workflow",
    "Leave policies, balances, and an approve/reject workflow": "Leave policies, balances, and an approve/reject workflow",
    "navigation.mini_apps.workforce_app.pricing_label": "Pricing TBC",
    "navigation.mini_apps.workforce_app.pricing_detail": "Turns on People automatically.",
    "Turns on People automatically.": "Turns on People automatically.",
    "navigation.mini_apps.payroll_app.title": "Payroll",
    "navigation.mini_apps.payroll_app.description": "Payroll runs, approvals, CSV export, and expense reimbursements.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Payroll runs, approvals, CSV export, and expense reimbursements.",
    "navigation.mini_apps.payroll_app.why_1": "Create payroll runs per period from staff pay grades",
    "Create payroll runs per period from staff pay grades": "Create payroll runs per period from staff pay grades",
    "navigation.mini_apps.payroll_app.why_2": "Approve runs and export them as CSV for your bank or accountant",
    "Approve runs and export them as CSV for your bank or accountant": "Approve runs and export them as CSV for your bank or accountant",
    "navigation.mini_apps.payroll_app.why_3": "Staff expense claims from submission to reimbursement",
    "Staff expense claims from submission to reimbursement": "Staff expense claims from submission to reimbursement",
    "navigation.mini_apps.payroll_app.pricing_label": "Pricing TBC",
    "navigation.mini_apps.payroll_app.pricing_detail": "Turns on People automatically.",
    "navigation.mini_apps.unified_inbox.title": "Unified Inbox",
    "Unified Inbox": "Unified Inbox",
    "navigation.mini_apps.unified_inbox.description": "All your customer communication — orders, support, and chat — from one place.",
    "All your customer communication — orders, support, and chat — from one place.": "All your customer communication — orders, support, and chat — from one place.",
    "navigation.mini_apps.unified_inbox.why_1": "Order queries, support tickets, and buyer messages in one thread view",
    "Order queries, support tickets, and buyer messages in one thread view": "Order queries, support tickets, and buyer messages in one thread view",
    "navigation.mini_apps.unified_inbox.why_2": "Reply with AI-suggested responses trained on your catalogue",
    "Reply with AI-suggested responses trained on your catalogue": "Reply with AI-suggested responses trained on your catalogue",
    "navigation.mini_apps.unified_inbox.why_3": "Tag, assign, and resolve conversations across your team",
    "Tag, assign, and resolve conversations across your team": "Tag, assign, and resolve conversations across your team",
    "navigation.mini_apps.unified_inbox.pricing_label": "Connect",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Task-based pricing per resolved conversation.",
    "Task-based pricing per resolved conversation.": "Task-based pricing per resolved conversation.",
    "navigation.mini_apps.social_connect.title": "Social Connect",
    "Social Connect": "Social Connect",
    "navigation.mini_apps.social_connect.description": "Share listings to social channels on a schedule you define.",
    "Share listings to social channels on a schedule you define.": "Share listings to social channels on a schedule you define.",
    "navigation.mini_apps.social_connect.why_1": "Schedule listing posts to Instagram, Facebook, and X automatically",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Schedule listing posts to Instagram, Facebook, and X automatically",
    "navigation.mini_apps.social_connect.why_2": "Define posting schedules per channel — daily drops, flash sales, or custom cadence",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Define posting schedules per channel — daily drops, flash sales, or custom cadence",
    "navigation.mini_apps.social_connect.why_3": "Track clicks and engagement back to each listing from the dashboard",
    "Track clicks and engagement back to each listing from the dashboard": "Track clicks and engagement back to each listing from the dashboard",
    "navigation.mini_apps.social_connect.pricing_label": "Connect",
    "navigation.mini_apps.social_connect.pricing_detail": "Task-based pricing per scheduled post delivered.",
    "Task-based pricing per scheduled post delivered.": "Task-based pricing per scheduled post delivered.",
    "navigation.mini_apps.shopping_channels.title": "Shopping Channels",
    "Shopping Channels": "Shopping Channels",
    "navigation.mini_apps.shopping_channels.description": "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.",
    "navigation.mini_apps.shopping_channels.why_1": "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly",
    "navigation.mini_apps.shopping_channels.why_2": "Connect food & beverage catalogues to Uber Eats and Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Connect food & beverage catalogues to Uber Eats and Grab",
    "navigation.mini_apps.shopping_channels.why_3": "Inventory and orders sync back automatically — no double-entry",
    "Inventory and orders sync back automatically — no double-entry": "Inventory and orders sync back automatically — no double-entry",
    "navigation.mini_apps.shopping_channels.pricing_label": "Connect",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Task-based pricing per order fulfilled through a connected channel.",
    "Task-based pricing per order fulfilled through a connected channel.": "Task-based pricing per order fulfilled through a connected channel.",
    "listing_configs.customize_table": "Customize table",
    "Customize table": "Customize table",
    "listing_configs.fields_visible": "Fields visible in table",
    "Fields visible in table": "Fields visible in table",
    "listing_configs.fields_hidden": "Fields not shown in table",
    "Fields not shown in table": "Fields not shown in table",
    "listing_configs.reset_default": "Reset to default",
    "listing_configs.column_title": "Title",
    "listing_configs.column_actions": "Actions",
    "listing_configs.column_website": "Website",
    "listing_configs.column_list_price": "List Price",
    "listing_configs.column_offer_percent": "Offer Percent",
    "Offer Percent": "Offer Percent",
    "listing_configs.column_image": "Image",
    "listing_configs.column_offer_price": "Offer Price",
    "Offer Price": "Offer Price",
    "listing_configs.column_status": "Status",
    "listing_configs.column_listing_id": "Listing ID",
    "listing_configs.column_listing_status": "Listing Status",
    "listing_configs.column_accounts": "Accounts",
    "listing_configs.column_currency": "Currency",
    "listing_configs.column_sold": "Sold",
    "listing_configs.column_goal_amount": "Goal Amount",
    "Goal Amount": "Goal Amount",
    "listing_configs.column_width": "Width",
    "listing_configs.column_height": "Height",
    "listing_configs.column_weight": "Weight",
    "listing_configs.column_volume": "Volume",
    "Volume": "Volume",
    "listing_configs.column_order_type": "Order Type",
    "Order Type": "Order Type",
    "navigation.apps_group": "Apps",
    "navigation.channels_group": "Channels",
    "navigation.manage_mini_apps": "Manage Mini Apps",
    "Manage Mini Apps": "Manage Mini Apps",
    "navigation.manage_channels": "Manage Channels",
    "Manage Channels": "Manage Channels",
    "listings.import.uploading": "Uploading...",
    "listings.import.complete": "Import complete",
    "listings.import.error": "Error: {message}",
    "Error: {message}": "Error: {message}",
    "listings.import.file_label": "File:",
    "listings.import.select_file": "Select File",
    "listings.import.response": "Import response",
    "Import response": "Import response",
    "listings.import.total_rows": "Total rows:",
    "Total rows:": "Total rows:",
    "listings.import.total_imported": "Total imported:",
    "Total imported:": "Total imported:",
    "listings.import.download_template": "Download listings template",
    "Download listings template": "Download listings template",
    "common.upload": "Upload",
    "common.kanban_unavailable": "Board view is temporarily unavailable",
    "Board view is temporarily unavailable": "Board view is temporarily unavailable",
    "common.retry": "Retry",
    "Retry": "Retry",
    "listings.digital_assets.title": "Digital assets",
    "Digital assets": "Digital assets",
    "listings.digital_assets.not_found": "Digital assets not found",
    "Digital assets not found": "Digital assets not found",
    "listings.addon.saved": "Add-on saved successfully.",
    "Add-on saved successfully.": "Add-on saved successfully.",
    "listings.addon.title_required": "Please enter a title.",
    "Please enter a title.": "Please enter a title.",
    "listings.addon.price_required": "Please enter a price.",
    "Please enter a price.": "Please enter a price.",
    "listings.addon.no_media": "You do not have any media files.",
    "listings.addon.price": "Price",
    "listings.addon.offer_percentage": "Offer Percentage",
    "Offer Percentage": "Offer Percentage",
    "listings.addon.maximum_quantity": "Maximum Quantity",
    "Maximum Quantity": "Maximum Quantity",
    "listings.addon.stock": "Stock",
    "listings.addon.enter_price": "Enter price",
    "Enter price": "Enter price",
    "listings.addon.enter_offer_percentage": "Enter offer percentage",
    "Enter offer percentage": "Enter offer percentage",
    "listings.addon.enter_maximum_quantity": "Enter maximum quantity",
    "Enter maximum quantity": "Enter maximum quantity",
    "listings.addon.enter_stock": "Enter stock",
    "listings.addon.edit_title": "Edit Add-on",
    "Edit Add-on": "Edit Add-on",
    "listings.addon.add_title": "Add Add-on",
    "Add Add-on": "Add Add-on",
    "listings.addon.title": "Title",
    "listings.addon.enter_title": "Enter title",
    "listings.addon.status": "Status (Not Active / Active)",
    "listings.addon.upload_media": "Upload Media",
    "attributes.prefill_for": "Prefill for",
    "Prefill for": "Prefill for",
    "attributes.first_item": "First Item",
    "First Item": "First Item",
    "attributes.all_items": "All Items",
    "All Items": "All Items",
    "common.uploading": "Uploading...",
    "common.uploading_named": "Uploading {title}",
    "Uploading {title}": "Uploading {title}",
    "common.please_wait_short": "Please wait",
    "Please wait": "Please wait",
    "attributes.select_option": "Select",
    "attributes.select_value": "Select value...",
    "Select value...": "Select value...",
    "attributes.type_placeholder": "Type {name}",
    "Type {name}": "Type {name}",
    "attributes.multiple_values_placeholder": "Using a comma, you can enter several values.",
    "Using a comma, you can enter several values.": "Using a comma, you can enter several values.",
    "attributes.upload_attachment": "Upload Attachment",
    "Upload Attachment": "Upload Attachment",
    "attributes.upload_json_file": "Upload JSON File",
    "Upload JSON File": "Upload JSON File",
    "attributes.copied_value": "Copied the value",
    "Copied the value": "Copied the value",
    "attributes.latitude_longitude_placeholder": "Enter latitude,longitude (e.g. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Enter latitude,longitude (e.g. 12.34,56.78)",
    "navigation.sidebar_label": "Side bar",
    "Side bar": "Side bar",
    "checkout_settings.orders_option_0": "Orders Calendar View",
    "Orders Calendar View": "Orders Calendar View",
    "checkout_settings.show_cart_attributes": "Show cart attributes",
    "Show cart attributes": "Show cart attributes",
    "checkout_settings.select_order_status": "Select order status",
    "Select order status": "Select order status",
    "checkout_settings.order_status_0": "Placed success",
    "Placed success": "Placed success",
    "checkout_settings.order_status_1": "In process",
    "In process": "In process",
    "checkout_settings.order_status_2": "Shipped",
    "checkout_settings.order_status_3": "Delivered",
    "checkout_settings.order_status_4": "Completed",
    "listing_form.no_categories_found": "No categories found. Use “{action}” above.",
    "No categories found. Use “{action}” above.": "No categories found. Use “{action}” above.",
    "common.learn_more": "Learn more",
    "Learn more": "Learn more",
    "common.show_information": "Show information",
    "Show information": "Show information",
    "common.paid_feature": "Paid Feature",
    "Paid Feature": "Paid Feature",
    "common.learn_more_about": "Learn more about",
    "Learn more about": "Learn more about",
    "attributes.categories": "Categories",
    "attributes.edit_bulk_title": "{title} Edit Bulk",
    "{title} Edit Bulk": "{title} Edit Bulk",
    "common.enter_description": "Enter description",
    "common.empty_fetch_message": "Nothing to show here yet. Once content is available, it will appear on this page.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Nothing to show here yet. Once content is available, it will appear on this page.",
    "common.ai_credits_and_top_up": "AI credits and top up",
    "AI credits and top up": "AI credits and top up",
    "common.ai_credits_loading": "Loading AI credits",
    "Loading AI credits": "Loading AI credits",
    "common.ai_credits_unavailable": "AI credits unavailable",
    "AI credits unavailable": "AI credits unavailable",
    "common.ai_credits_available": "Available AI credits: {count}",
    "Available AI credits: {count}": "Available AI credits: {count}",
    "common.ai_credits_unavailable_top_up": "AI credits unavailable — click to top up",
    "AI credits unavailable — click to top up": "AI credits unavailable — click to top up",
    "common.ai_credits_available_top_up": "Available AI credits: {count} — click to add credits",
    "Available AI credits: {count} — click to add credits": "Available AI credits: {count} — click to add credits",
    "common.ai_credits_add": "Add credits",
    "Add credits": "Add credits",
    "navigation.switch_project": "Switch Project",
    "Switch Project": "Switch Project",
    "navigation.tenant_switch_failed": "Tenant switch failed. Please try again.",
    "Tenant switch failed. Please try again.": "Tenant switch failed. Please try again.",
    "navigation.select_project": "Select Project",
    "Select Project": "Select Project",
    "navigation.collapse_sidebar": "Collapse sidebar",
    "Collapse sidebar": "Collapse sidebar",
    "navigation.expand_sidebar": "Expand sidebar",
    "Expand sidebar": "Expand sidebar",
    "navigation.search": "Search",
    "navigation.loading": "Loading navigation",
    "Loading navigation": "Loading navigation",
    "navigation.help_documentation": "Documentation",
    "navigation.help_community": "Community",
    "navigation.help_api_reference": "API Reference",
    "listings.quick_form": "Quick Form",
    "Quick Form": "Quick Form",
    "payments.notification_secret": "Notification Secret",
    "Notification Secret": "Notification Secret",
    "payments.user_type": "User Type",
    "User Type": "User Type",
    "payments.category_id": "Category ID",
    "app_customization.other_settings": "Other Settings",
    "Other Settings": "Other Settings",
    "app_customization.other_hide_balances": "Hide balances & payouts in more section",
    "app_customization.other_enable_logs": "Enable logs",
    "Enable logs": "Enable logs",
    "app_customization.other_signup_first": "Get sign up first",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Selected image",
    "Selected image": "Selected image",
    "common.ai_no_response_to_copy": "No response to copy",
    "No response to copy": "No response to copy",
    "common.copied_to_clipboard": "Copied to clipboard",
    "Copied to clipboard": "Copied to clipboard",
    "common.ai_suggestions": "Suggestions",
    "Suggestions": "Suggestions",
    "common.regenerate": "Regenerate",
    "Regenerate": "Regenerate",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "JSON icon",
    "JSON icon": "JSON icon",
    "collections.generator_title": "Collection Generator",
    "Collection Generator": "Collection Generator",
    "collections.generator_create": "Create Collection",
    "collections.generator_json_placeholder": "Enter JSON input",
    "Enter JSON input": "Enter JSON input",
    "collections.generator_invalid_data": "Please enter valid data",
    "Please enter valid data": "Please enter valid data",
    "category.editor_select_from_media": "Select from media",
    "payments.subscription": "Subscription",
    "payments.subscription_setting_up": "Setting up...",
    "Setting up...": "Setting up...",
    "payments.subscription_webhook_configured": "Subscription webhook configured",
    "Subscription webhook configured": "Subscription webhook configured",
    "payments.subscription_retry_setup": "Retry setup",
    "Retry setup": "Retry setup",
    "payments.setup_subscription_webhook": "Setup Subscription Webhook",
    "Setup Subscription Webhook": "Setup Subscription Webhook",
    "orders.shipment_number": "Shipment {number}",
    "Shipment {number}": "Shipment {number}",
    "orders.quantity_short": "QTY",
    "orders.shipment_status_1": "Shipment created",
    "orders.shipment_status_2": "Shipment in progress",
    "orders.shipment_status_3": "Shipped",
    "orders.shipment_status_4": "Ready for pickup",
    "orders.shipment_status_5": "Out for delivery",
    "orders.shipment_status_6": "Undelivered return",
    "orders.shipment_status_7": "Shipment delivered",
    "orders.shipment_status_8": "Shipment delivery confirmed",
    "orders.shipment_status_9": "Return initiated",
    "orders.shipment_status_10": "Returned for pickup",
    "orders.shipment_status_11": "Shipment return confirmed",
    "orders.shipment_status_12": "Cancelled by seller",
    "orders.shipment_status_13": "Cancelled by customer",
    "orders.shipment_status_14": "Arrived at customer location",
    "orders.shipment_status_15": "Cancelled by admin",
    "attributes.metadata_title": "Metadata",
    "Metadata": "Metadata",
    "common.add_row": "Add Row",
    "common.no_access": "You don't have access",
    "You don't have access": "You don't have access",
    "common.error_404_message": "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "Transaction direction",
    "Transaction direction": "Transaction direction",
    "category.default_text": "Default text",
    "collections.generator_open": "Open collection generator",
    "Open collection generator": "Open collection generator",
    "collections.duplicate_success": "Collection duplicated successfully",
    "Collection duplicated successfully": "Collection duplicated successfully",
    "collections.duplicate_failed": "Failed to duplicate collection",
    "Failed to duplicate collection": "Failed to duplicate collection",
    "listings.name_required": "Listing Name is required",
    "Listing Name is required": "Listing Name is required",
    "listings.category_required": "Category is required",
    "Category is required": "Category is required",
    "attribute_groups.edit_title": "Edit Attribute Group",
    "Edit Attribute Group": "Edit Attribute Group",
    "orders.create_order.validation.select_shipping_method": "Please select shipping method",
    "Please select shipping method": "Please select shipping method",
    "orders.create_order.validation.shipping_method_error": "Shipping Method Error",
    "Shipping Method Error": "Shipping Method Error",
    "orders.create_order.validation.select_shipping_address": "Please select shipping address",
    "Please select shipping address": "Please select shipping address",
    "orders.create_order.validation.shipping_address_error": "Shipping Address Error",
    "Shipping Address Error": "Shipping Address Error",
    "orders.create_order.validation.select_shipment_method": "Please select shipment method",
    "Please select shipment method": "Please select shipment method",
    "orders.create_order.validation.shipment_method_error": "Shipment Method Error",
    "Shipment Method Error": "Shipment Method Error",
    "orders.create_order.validation.select_payment_method": "Please select payment method",
    "Please select payment method": "Please select payment method",
    "orders.create_order.validation.payment_method_error": "Payment Method Error",
    "Payment Method Error": "Payment Method Error",
    "orders.create_order.validation.insufficient_balance": "Insufficient balance",
    "Insufficient balance": "Insufficient balance",
    "orders.create_order.validation.wallet_error": "Wallet Error",
    "Wallet Error": "Wallet Error",
    "attributes.value.preview_item": "Preview {count}",
    "Preview {count}": "Preview {count}",
    "attributes.value.click_to_upload": "Click to upload {type}",
    "Click to upload {type}": "Click to upload {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF up to 5 files",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF up to 5 files",
    "attributes.value.audio_upload_formats": "MP3, WAV up to 1 file",
    "MP3, WAV up to 1 file": "MP3, WAV up to 1 file",
    "attributes.value.video_upload_formats": "MP4, MOV up to 1 file",
    "MP4, MOV up to 1 file": "MP4, MOV up to 1 file",
    "attributes.value.upload_limit": "Upload {type} files (Max {count})",
    "Upload {type} files (Max {count})": "Upload {type} files (Max {count})",
    "attributes.value.json_format_failed": "Invalid JSON - cannot format",
    "Invalid JSON - cannot format": "Invalid JSON - cannot format",
    "attributes.value.json_file_invalid": "Please select a valid JSON file",
    "Please select a valid JSON file": "Please select a valid JSON file",
    "attributes.value.file_empty": "File is empty",
    "File is empty": "File is empty",
    "attributes.value.json_file_parse_failed": "Invalid JSON file: {message}",
    "Invalid JSON file: {message}": "Invalid JSON file: {message}",
    "attributes.value.file_read_failed": "Failed to read file",
    "Failed to read file": "Failed to read file",
    "attributes.value.invalid_json": "Invalid JSON",
    "Invalid JSON": "Invalid JSON",
    "attributes.value.json_editor_help": "Upload a JSON file or type/paste JSON directly",
    "Upload a JSON file or type/paste JSON directly": "Upload a JSON file or type/paste JSON directly",
    "attributes.value.hex_color_code": "Hex Color Code",
    "Hex Color Code": "Hex Color Code",
    "attributes.value.multi_text_placeholder": "Type and press Enter or comma to add",
    "Type and press Enter or comma to add": "Type and press Enter or comma to add",
    "attributes.value.multi_text_help": "Press Enter or comma to add each item",
    "Press Enter or comma to add each item": "Press Enter or comma to add each item",
    "attributes.value.item_count": "{count} item",
    "{count} item": "{count} item",
    "attributes.value.items_count": "{count} items",
    "attributes.value.search_options": "Search {name}...",
    "Search {name}...": "Search {name}...",
    "attributes.value.selected_count": "{count} selected",
    "attributes.value.no_options_found": "No options found",
    "No options found": "No options found",
    "attributes.value.select_named_option": "Select {name}",
    "Select {name}": "Select {name}",
    "attributes.value.enable_option": "Enable this option",
    "Enable this option": "Enable this option",
    "attributes.value.enter_named_value": "Enter {name}",
    "Enter {name}": "Enter {name}",
    "common.valid": "Valid",
    "Valid": "Valid",
    "common.invalid": "Invalid",
    "Invalid": "Invalid",
    "common.go_back_home": "Go back home",
    "Go back home": "Go back home",
    "attributes.value.enter_named_text": "Enter {name}...",
    "Enter {name}...": "Enter {name}...",
    "listings.analytics.page_views": "Page Views",
    "listings.analytics.unique_visitors": "Unique Visitors",
    "listings.analytics.sessions": "Sessions",
    "listings.analytics.clicks": "Clicks",
    "listings.analytics.goals": "Goals",
    "listings.analytics.bot_views": "Bot Views",
    "listings.detail_summary.buyers": "Buyers",
    "Buyers": "Buyers",
    "listings.detail_summary.orders": "Orders",
    "listings.detail_summary.revenue": "Revenue",
    "listings.detail_summary.average_order": "Avg Order",
    "listings.add_advanced": "Advanced",
    "listings.add_audio": "Add Audio",
    "Add Audio": "Add Audio",
    "payments.updated_successfully": "Updated successfully",
    "Updated successfully": "Updated successfully",
    "users.deleted_successfully": "User deleted successfully",
    "User deleted successfully": "User deleted successfully",
    "users.deletion_failed": "User deletion failed",
    "User deletion failed": "User deletion failed",
    "accounts.flow.title": "Shape the account experience",
    "Shape the account experience": "Shape the account experience",
    "accounts.flow.description": "Organize account types and define the information each account needs.",
    "Organize account types and define the information each account needs.": "Organize account types and define the information each account needs.",
    "accounts.flow.lane_title": "Account foundation",
    "Account foundation": "Account foundation",
    "accounts.flow.badge": "Structure",
    "Structure": "Structure",
    "accounts.flow.node_accounts": "Accounts",
    "accounts.flow.node_categories": "Categories",
    "accounts.flow.node_attributes": "Attributes",
    "accounts.flow.lane_description": "Give every account a clear place, type, and set of useful details.",
    "Give every account a clear place, type, and set of useful details.": "Give every account a clear place, type, and set of useful details.",
    "accounts.flow.primary_action": "Add your first account",
    "Add your first account": "Add your first account",
    "listings.flow.title": "Build your listing catalog",
    "Build your listing catalog": "Build your listing catalog",
    "listings.flow.description": "Create a structured catalog with categories, attributes, and variants.",
    "Create a structured catalog with categories, attributes, and variants.": "Create a structured catalog with categories, attributes, and variants.",
    "listings.flow.lane_title": "Catalog path",
    "Catalog path": "Catalog path",
    "listings.flow.badge": "Build",
    "Build": "Build",
    "listings.flow.node_listings": "Listings",
    "listings.flow.node_categories": "Categories",
    "listings.flow.node_attributes": "Attributes",
    "listings.flow.node_variants": "Variants",
    "listings.flow.lane_description": "Define what you sell and the information customers need to make a choice.",
    "Define what you sell and the information customers need to make a choice.": "Define what you sell and the information customers need to make a choice.",
    "listings.flow.primary_action": "Add your first listing",
    "Add your first listing": "Add your first listing",
    "collections.flow.title": "Bring your marketplace content together",
    "Bring your marketplace content together": "Bring your marketplace content together",
    "collections.flow.description": "Group listings and accounts into curated collections that are easy to discover and manage.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Group listings and accounts into curated collections that are easy to discover and manage.",
    "collections.flow.lane_title": "Collection path",
    "Collection path": "Collection path",
    "collections.flow.badge": "Curate",
    "Curate": "Curate",
    "collections.flow.node_collections": "Collections",
    "collections.flow.node_rules": "Rules",
    "collections.flow.node_listings": "Listings",
    "collections.flow.lane_description": "Choose what belongs together and make it easy for customers to find.",
    "Choose what belongs together and make it easy for customers to find.": "Choose what belongs together and make it easy for customers to find.",
    "collections.flow.audience_lane_title": "Audience path",
    "Audience path": "Audience path",
    "collections.flow.audience_badge": "Connect",
    "collections.flow.node_accounts": "Accounts",
    "collections.flow.node_users": "Users",
    "collections.flow.node_storefront": "Storefront",
    "Storefront": "Storefront",
    "collections.flow.audience_description": "Connect curated content to the people and storefronts it is meant for.",
    "Connect curated content to the people and storefronts it is meant for.": "Connect curated content to the people and storefronts it is meant for.",
    "collections.flow.primary_action": "Create your first collection",
    "listings.addon.image_limit": "You cannot select more images",
    "listings.schedule.start_time_before_end": "Start time must be before the end time",
    "Start time must be before the end time": "Start time must be before the end time",
    "listings.schedule.end_time_after_start": "End time must be after the start time",
    "End time must be after the start time": "End time must be after the start time",
    "listings.schedule.repeat_required": "Select a repeat pattern",
    "Select a repeat pattern": "Select a repeat pattern",
    "listing_variants.form.select_type": "Select variant type",
    "Select variant type": "Select variant type",
    "listing_variants.form.select_type_values": "Select variant values",
    "Select variant values": "Select variant values",
    "listing_variants.form.add_variant": "Add variant",
    "listing_variants.form.edit_variant": "Edit variant",
    "Edit variant": "Edit variant",
    "listing_variants.form.variant_type": "Variant type",
    "Variant type": "Variant type",
    "listing_variants.form.variant_type_value": "Variant value",
    "Variant value": "Variant value",
    "listing_variants.form.variant_name": "Variant name",
    "Variant name": "Variant name",
    "listing_variants.form.description_placeholder": "Enter description",
    "rewards.item_archived": "Archived",
    "listings.confirm_delete_variant": "Are you sure you want to delete this variant?",
    "listings.confirm_delete_listing": "Are you sure you want to delete this listing?",
    "listing_form.digital_delete_confirm": "Are you sure you want to delete this digital content?",
    "Are you sure you want to delete this digital content?": "Are you sure you want to delete this digital content?",
    "category.confirm_delete_attribute": "Do you want to delete this attribute?",
    "common.permission_required": "You do not have permission to perform this action.",
    "You do not have permission to perform this action.": "You do not have permission to perform this action.",
    "common.copied": "Copied",
    "attributes.editor_name_required": "Please enter attribute name",
    "onboarding.full_step.setup_payments.description": "Enable real transactions so users can complete intent without friction.",
    "Enable real transactions so users can complete intent without friction.": "Enable real transactions so users can complete intent without friction.",
    "onboarding.full_step.setup_payments.cta": "Setup payments",
    "Setup payments": "Setup payments",
    "onboarding.full_step.setup_payments.impact": "Revenue path enabled.",
    "Revenue path enabled.": "Revenue path enabled.",
    "onboarding.full_step.setup_payments.creator_description": "Prepare the path for your audience to purchase or support your work.",
    "Prepare the path for your audience to purchase or support your work.": "Prepare the path for your audience to purchase or support your work.",
    "onboarding.full_step.setup_delivery.description": "Define how the order is fulfilled so checkout is predictable for users.",
    "onboarding.full_step.setup_delivery.impact": "Fulfillment path clear.",
    "Fulfillment path clear.": "Fulfillment path clear.",
    "onboarding.full_step.add_promotion.description": "Create your first promotion to increase first-session action rate.",
    "Create your first promotion to increase first-session action rate.": "Create your first promotion to increase first-session action rate.",
    "onboarding.full_step.add_promotion.impact": "Stronger conversion during launch.",
    "Stronger conversion during launch.": "Stronger conversion during launch.",
    "onboarding.full_step.create_coupon.description": "Test discounts and improve activation for first-time buyers or members.",
    "Test discounts and improve activation for first-time buyers or members.": "Test discounts and improve activation for first-time buyers or members.",
    "onboarding.full_step.create_coupon.impact": "First-offer loop unlocked.",
    "First-offer loop unlocked.": "First-offer loop unlocked.",
    "onboarding.full_step.collections_setup.description": "Organize high-intent listings to improve discovery and browsing flow.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Organize high-intent listings to improve discovery and browsing flow.",
    "onboarding.full_step.collections_setup.impact": "Navigation and discovery improved.",
    "Navigation and discovery improved.": "Navigation and discovery improved.",
    "onboarding.full_step.configure_comms.description": "Make post-signup and order notifications production-ready before growth.",
    "Make post-signup and order notifications production-ready before growth.": "Make post-signup and order notifications production-ready before growth.",
    "onboarding.full_step.configure_comms.impact": "Lifecycle messaging ready.",
    "Lifecycle messaging ready.": "Lifecycle messaging ready.",
    "onboarding.full_step.customize_attributes.description": "Add structured fields so users can filter and compare what matters.",
    "onboarding.full_step.customize_attributes.impact": "Better search and conversion.",
    "Better search and conversion.": "Better search and conversion.",
    "onboarding.full_step.customize_attributes.creator_description": "Add the details that help people understand and compare what you create.",
    "Add the details that help people understand and compare what you create.": "Add the details that help people understand and compare what you create.",
    "onboarding.full_step.add_digital_asset.description": "Expand initial catalog so users can evaluate quality and assortment.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Expand initial catalog so users can evaluate quality and assortment.",
    "onboarding.full_step.add_digital_asset.impact": "Digital catalog credibility improved.",
    "Digital catalog credibility improved.": "Digital catalog credibility improved.",
    "onboarding.full_step.open_live_site.description": "Start with what customers see. This makes the product feel real before setup becomes abstract.",
    "onboarding.full_step.open_live_site.impact": "Confirms the project is already live.",
    "onboarding.full_step.add_first_product.description": "Publish the first product, service, or resource you want your audience to discover.",
    "Publish the first product, service, or resource you want your audience to discover.": "Publish the first product, service, or resource you want your audience to discover.",
    "onboarding.full_step.add_first_product.impact": "Creates your first audience-ready offer.",
    "Creates your first audience-ready offer.": "Creates your first audience-ready offer.",
    "onboarding.full_step.customize_attributes.creator_impact": "Makes your offer easier to understand.",
    "Makes your offer easier to understand.": "Makes your offer easier to understand.",
    "onboarding.full_step.setup_payments.creator_impact": "Unlocks the path to revenue.",
    "listings.detail_preview_fx.title": "Preview FX",
    "Preview FX": "Preview FX",
    "listings.detail_preview_fx.base": "Base",
    "Base": "Base",
    "listings.detail_preview_fx.description": "See this listing in each active currency.",
    "See this listing in each active currency.": "See this listing in each active currency.",
    "listings.detail_preview_fx.refresh": "Refresh preview",
    "Refresh preview": "Refresh preview",
    "listings.detail_preview_fx.loading_rates": "Loading exchange rates…",
    "Loading exchange rates…": "Loading exchange rates…",
    "listings.detail_preview_fx.load_hint": "Select Preview FX to load current rates.",
    "Select Preview FX to load current rates.": "Select Preview FX to load current rates.",
    "listings.detail_preview_fx.preview_note": "Preview only. Saved listing prices remain unchanged.",
    "Preview only. Saved listing prices remain unchanged.": "Preview only. Saved listing prices remain unchanged.",
    "listings.detail_preview_fx.listing": "Listing",
    "listings.detail_preview_fx.variant": "Variant",
    "Variant": "Variant",
    "listings.detail_event_booking.event_details": "Event Details",
    "Event Details": "Event Details",
    "listings.detail_event_booking.booking_details": "Booking Details",
    "Booking Details": "Booking Details",
    "listings.unassigned_location": "Unassigned location",
    "Unassigned location": "Unassigned location",
    "listings.no_ratings_yet": "No ratings yet",
    "No ratings yet": "No ratings yet",
    "listing_form.loading_listing": "Loading listing…",
    "Loading listing…": "Loading listing…",
    "listing_form.preparing_form": "Preparing form…",
    "Preparing form…": "Preparing form…",
    "listing_form.edit_listing": "Edit Listing",
    "Edit Listing": "Edit Listing",
    "listing_form.add_new_listing": "Add New Listing",
    "Add New Listing": "Add New Listing",
    "workspace.catalog.templates": "Templates",
    "Templates": "Templates",
    "workspace.catalog.integrations": "Integrations",
    "workspace.catalog.template": "Template",
    "Template": "Template",
    "workspace.catalog.integration": "Integration",
    "workspace.catalog.templates_heading": "Choose a template to kickstart your Idea",
    "Choose a template to kickstart your Idea": "Choose a template to kickstart your Idea",
    "workspace.catalog.integrations_heading": "Integrations for Hosted Web Apps",
    "Integrations for Hosted Web Apps": "Integrations for Hosted Web Apps",
    "workspace.catalog.templates_description": "Start with a prebuilt template and customise it for your marketplace.",
    "Start with a prebuilt template and customise it for your marketplace.": "Start with a prebuilt template and customise it for your marketplace.",
    "workspace.catalog.integrations_description": "Connect your workspace to the tools and services you already use.",
    "Connect your workspace to the tools and services you already use.": "Connect your workspace to the tools and services you already use.",
    "workspace.catalog.no_templates": "No templates available at the moment.",
    "No templates available at the moment.": "No templates available at the moment.",
    "workspace.catalog.no_integrations": "No integrations available at the moment.",
    "No integrations available at the moment.": "No integrations available at the moment.",
    "workspace.catalog.coming_soon": "Coming Soon",
    "Coming Soon": "Coming Soon",
    "workspace.catalog.configure": "Configure",
    "workspace.catalog.custom_development": "Custom {type} Development",
    "Custom {type} Development": "Custom {type} Development",
    "workspace.catalog.custom_help": "Looking for something custom? Contact us for a quote.",
    "Looking for something custom? Contact us for a quote.": "Looking for something custom? Contact us for a quote.",
    "workspace.catalog.contact_quote": "Contact for a Quote",
    "Contact for a Quote": "Contact for a Quote",
    "users.select_user": "Select User",
    "Select User": "Select User",
    "developer.api_keys.paid_feature_title": "API access is a paid feature",
    "API access is a paid feature": "API access is a paid feature",
    "developer.api_keys.paid_feature_description": "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.",
    "developer.api_keys.available_on_paid_plans": "Available on paid plans",
    "Available on paid plans": "Available on paid plans",
    "developer.api_keys.view_plans": "View plans",
    "currency.rates.title": "Current FX rates",
    "Current FX rates": "Current FX rates",
    "currency.rates.base": "Base:",
    "Base:": "Base:",
    "currency.rates.source": "· Source:",
    "· Source:": "· Source:",
    "currency.rates.cached_up_to": "Cached up to {hours}h",
    "Cached up to {hours}h": "Cached up to {hours}h",
    "currency.rates.refresh": "Refresh rates",
    "Refresh rates": "Refresh rates",
    "currency.rates.currency": "Currency",
    "currency.rates.one_base_equals": "1 {code} equals",
    "1 {code} equals": "1 {code} equals",
    "currency.rates.empty": "Add an active currency to see its exchange rate.",
    "Add an active currency to see its exchange rate.": "Add an active currency to see its exchange rate.",
    "currency.rates.manual": "Manual rates",
    "Manual rates": "Manual rates",
    "currency.rates.load_error": "Unable to load exchange rates.",
    "Unable to load exchange rates.": "Unable to load exchange rates.",
    "chats.title": "Customer chat",
    "Customer chat": "Customer chat",
    "chats.conversations": "Conversations",
    "Conversations": "Conversations",
    "chats.empty_conversations": "No customer conversations yet.",
    "No customer conversations yet.": "No customer conversations yet.",
    "chats.customer_id": "Customer {id}",
    "Customer {id}": "Customer {id}",
    "chats.no_messages_yet": "No messages yet",
    "No messages yet": "No messages yet",
    "chats.conversation_id": "Conversation #{id}",
    "Conversation #{id}": "Conversation #{id}",
    "chats.status.closed": "closed",
    "closed": "closed",
    "chats.status.open": "open",
    "chats.reopen": "Reopen",
    "Reopen": "Reopen",
    "chats.close_conversation": "Close conversation",
    "Close conversation": "Close conversation",
    "chats.your_team": "Your team",
    "Your team": "Your team",
    "chats.empty_messages": "No messages in this conversation yet.",
    "No messages in this conversation yet.": "No messages in this conversation yet.",
    "chats.write_reply": "Write a reply",
    "Write a reply": "Write a reply",
    "chats.send": "Send",
    "Send": "Send",
    "chats.select_conversation": "Select a conversation to view its messages.",
    "Select a conversation to view its messages.": "Select a conversation to view its messages.",
    "chats.error.session_not_ready": "Your session is not ready. Refresh the page and try again.",
    "Your session is not ready. Refresh the page and try again.": "Your session is not ready. Refresh the page and try again.",
    "chats.error.request_failed": "Chat request failed ({status})",
    "Chat request failed ({status})": "Chat request failed ({status})",
    "chats.error.load_conversations": "Could not load conversations.",
    "Could not load conversations.": "Could not load conversations.",
    "chats.error.load_messages": "Could not load messages.",
    "Could not load messages.": "Could not load messages.",
    "chats.error.send_message": "Message could not be sent.",
    "Message could not be sent.": "Message could not be sent.",
    "chats.error.update_status": "Conversation status could not be updated.",
    "Conversation status could not be updated.": "Conversation status could not be updated.",
    "accounts.select_account": "Select Account",
    "common.accounts": "Accounts",
    "common.listings": "Listings",
    "communications.loading_preview": "Loading preview…",
    "Loading preview…": "Loading preview…",
    "communications.no_preview": "No preview",
    "No preview": "No preview",
    "collections.choose_type": "Choose {type}",
    "Choose {type}": "Choose {type}",
    "collections.create_type_category_first": "Create {type} category first",
    "Create {type} category first": "Create {type} category first",
    "web_config.customisation": "Web Customisation",
    "web_config.configuration": "Web Configuration",
    "Web Configuration": "Web Configuration",
    "web_config.section_general": "General",
    "web_config.section_social": "Social",
    "web_config.section_footer": "Footer",
    "web_config.assets": "Assets",
    "Assets": "Assets",
    "web_config.small_logo": "Small logo",
    "Small logo": "Small logo",
    "attributes.edit_attribute": "Edit Attribute",
    "currency.rate_managed_automatically": "Rate is managed automatically.",
    "Rate is managed automatically.": "Rate is managed automatically.",
    "navigation.add_or_manage_mini_apps": "Add or manage Mini Apps",
    "Add or manage Mini Apps": "Add or manage Mini Apps",
    "listings.import.download_type_template": "Download {type} template",
    "navigation.promo_banner": "Get {percent}% OFF! Only for first-time customers. Use code: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Get {percent}% OFF! Only for first-time customers. Use code: {code}.",
    "orders.cash_refund_recorded": "Cash refund recorded. The accounting reversal has been queued.",
    "Cash refund recorded. The accounting reversal has been queued.": "Cash refund recorded. The accounting reversal has been queued.",
    "orders.cash_refund_failed": "Could not record the cash refund. Check the order payment status and refund history.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Could not record the cash refund. Check the order payment status and refund history.",
    "orders.recording_cash_refund": "Recording refund…",
    "Recording refund…": "Recording refund…",
    "orders.record_cash_refund": "Record cash refund",
    "Record cash refund": "Record cash refund",
    "orders.confirm_cash_refund": "Confirm cash refund",
    "Confirm cash refund": "Confirm cash refund",
    "orders.cash_refund_order_amount": "Record a full cash refund of {amount} for order {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "Record a full cash refund of {amount} for order {reference}?",
    "orders.cash_refund_manual_notice": "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.",
    "currency_conversion.title": "Currency conversion",
    "Currency conversion": "Currency conversion",
    "currency_conversion.open_settings": "Conversion settings",
    "Conversion settings": "Conversion settings",
    "currency_conversion.load_failed": "Could not load currency conversion settings.",
    "Could not load currency conversion settings.": "Could not load currency conversion settings.",
    "currency_conversion.interval_error": "Refresh interval must be between 5 minutes and 24 hours.",
    "Refresh interval must be between 5 minutes and 24 hours.": "Refresh interval must be between 5 minutes and 24 hours.",
    "currency_conversion.save_failed": "Could not save currency conversion settings.",
    "Could not save currency conversion settings.": "Could not save currency conversion settings.",
    "currency_conversion.saved": "Currency conversion settings saved.",
    "Currency conversion settings saved.": "Currency conversion settings saved.",
    "currency_conversion.description": "Choose how displayed currency conversions are calculated.",
    "Choose how displayed currency conversions are calculated.": "Choose how displayed currency conversions are calculated.",
    "currency_conversion.manual_title": "Manual rates",
    "currency_conversion.manual_help": "Use the exchange rate entered for each currency below.",
    "Use the exchange rate entered for each currency below.": "Use the exchange rate entered for each currency below.",
    "currency_conversion.frankfurter_title": "Frankfurter (default)",
    "Frankfurter (default)": "Frankfurter (default)",
    "currency_conversion.frankfurter_help": "Free daily exchange rates. No provider API key is required.",
    "Free daily exchange rates. No provider API key is required.": "Free daily exchange rates. No provider API key is required.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Use the platform-managed Fixer service. Rate updates depend on the provider plan.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Use the platform-managed Fixer service. Rate updates depend on the provider plan.",
    "currency_conversion.refresh_interval": "Rate re-check interval (minutes)",
    "Rate re-check interval (minutes)": "Rate re-check interval (minutes)",
    "workspace.currency_search_code": "Search or select",
    "Search or select": "Search or select",
    "workspace.currency_preset_hint": "Recommended defaults applied. You can edit any field.",
    "Recommended defaults applied. You can edit any field.": "Recommended defaults applied. You can edit any field.",
    "developer.api_keys.copy_unavailable": "Key is not available yet.",
    "Key is not available yet.": "Key is not available yet.",
    "developer.api_keys.copy_failed": "Unable to copy the key. Try again.",
    "Unable to copy the key. Try again.": "Unable to copy the key. Try again.",
    "payroll.action.export_pdf": "Export PDF",
    "Export PDF": "Export PDF",
    "cms.category.name_prompt": "Category name",
    "cms.field.cover_image": "Cover Image",
    "Cover Image": "Cover Image",
    "cms.action.add_cover_photo": "Add cover photo",
    "Add cover photo": "Add cover photo",
    "cms.field.category": "Category",
    "cms.category.none": "No category",
    "No category": "No category",
    "cms.advanced": "Advanced",
    "media_picker.action.select_image": "Select image",
    "Select image": "Select image",
    "orders.confirm_record_cash_refund": "Record refund",
    "Record refund": "Record refund",
    "listing_form.no_repeat": "No repeat",
    "No repeat": "No repeat",
    "listing_form.custom_repeat_days": "Custom: {days}",
    "Custom: {days}": "Custom: {days}",
    "common.sending": "Sending…",
    "listings.detail.unique_name": "Unique Name",
    "Unique Name": "Unique Name",
    "app_customization.username": "Username",
    "workspace.templates.name_required": "Template name is required.",
    "Template name is required.": "Template name is required.",
    "workspace.templates.saved": "Role template saved.",
    "Role template saved.": "Role template saved.",
    "workspace.templates.confirm_delete": "Delete template \"{name}\"?",
    "Delete template \"{name}\"?": "Delete template \"{name}\"?",
    "workspace.templates.deleted": "Template deleted.",
    "Template deleted.": "Template deleted.",
    "workspace.members.tab_members": "Members",
    "workspace.templates.tab": "Role Templates",
    "Role Templates": "Role Templates",
    "workspace.templates.title": "Role Templates",
    "workspace.templates.new": "New Template",
    "New Template": "New Template",
    "workspace.templates.name": "Name",
    "workspace.templates.empty": "No role templates yet.",
    "No role templates yet.": "No role templates yet.",
    "workspace.templates.edit": "Edit Template",
    "Edit Template": "Edit Template",
    "workspace.templates.name_label": "Template name",
    "Template name": "Template name",
    "workspace.templates.name_placeholder": "e.g. Content Manager",
    "e.g. Content Manager": "e.g. Content Manager",
    "listings.import.unknown_error": "The categories could not be imported. Please check the CSV and try again.",
    "The categories could not be imported. Please check the CSV and try again.": "The categories could not be imported. Please check the CSV and try again.",
    "common.no_access_to_page": "No access",
    "No access": "No access",
    "common.permission_to_view_page_denied": "You do not have permission to view this page.",
    "You do not have permission to view this page.": "You do not have permission to view this page.",
    "common.loading_permissions": "Loading permissions…",
    "Loading permissions…": "Loading permissions…",
    "attributes.added_successfully": "Nice 🎉, Successfully added attributes",
    "Nice 🎉, Successfully added attributes": "Nice 🎉, Successfully added attributes",
    "attributes.add_attribute_values": "Add Attribute Values",
    "attributes.attribute": "Attribute",
    "attributes.optional": "Optional",
    "attributes.private": "Private",
    "attributes.hidden_field": "Hidden field",
    "attributes.show_in_filter": "Show in filter",
    "attributes.status_not_active_active": "Status (Not Active / Active)",
    "attributes.add_metadata": "Add metadata",
    "Add metadata": "Add metadata",
    "attributes.select_date_time": "Select Date & Time",
    "listings.addons.column_title": "Title",
    "listings.addons.column_image": "Image",
    "listings.addons.column_price": "Price",
    "listings.addons.column_max_quantity": "Max Quantity",
    "Max Quantity": "Max Quantity",
    "listings.addons.column_offer": "Offer",
    "listings.addons.column_stock": "Stock",
    "listings.addons.column_action": "Action",
    "listings.addons.column_status": "Status",
    "listings.addons.confirm_delete": "Do you want to delete this add-on type?",
    "Do you want to delete this add-on type?": "Do you want to delete this add-on type?",
    "common.share_collection": "Share collection",
    "Share collection": "Share collection",
    "communications.view_modes": "Communication view modes",
    "Communication view modes": "Communication view modes",
    "payments.accessibility.gateway_logo": "Payment gateway logo",
    "Payment gateway logo": "Payment gateway logo",
    "common.build_version": "Build version",
    "Build version": "Build version",
    "common.build_label": "build",
    "build": "build",
    "listings.under_category_title": "Listings under {category}",
    "Listings under {category}": "Listings under {category}",
    "attributes.signup": "Signup",
    "Signup": "Signup",
    "common.toast.please_check_action": "Please check this action",
    "Please check this action": "Please check this action",
    "common.information": "Information",
    "listing_form.error.load_listing_data": "Failed to load listing data",
    "Failed to load listing data": "Failed to load listing data",
    "listing_form.error.load_digital_contents": "Failed to load digital contents",
    "Failed to load digital contents": "Failed to load digital contents",
    "listing_form.validation.audio_file_or_url_required": "Add an audio file or public audio URL before creating the episode.",
    "Add an audio file or public audio URL before creating the episode.": "Add an audio file or public audio URL before creating the episode.",
    "listing_form.validation.rental_rate_greater_than_zero": "Enter a rental rate greater than 0.",
    "Enter a rental rate greater than 0.": "Enter a rental rate greater than 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "Maximum duration must be greater than or equal to minimum duration.",
    "Maximum duration must be greater than or equal to minimum duration.": "Maximum duration must be greater than or equal to minimum duration.",
    "listing_form.updated_successfully": "Listing updated successfully!",
    "Listing updated successfully!": "Listing updated successfully!",
    "listing_form.created_successfully": "Listing created successfully!",
    "Listing created successfully!": "Listing created successfully!",
    "listing_form.error.save_failed": "Failed to save listing. Please try again.",
    "Failed to save listing. Please try again.": "Failed to save listing. Please try again.",
    "listing_form.error.delete_variant_failed": "Failed to delete variant: {title}",
    "Failed to delete variant: {title}": "Failed to delete variant: {title}",
    "listing_form.error.variant_action_failed": "Failed to {action} variant: {title}",
    "Failed to {action} variant: {title}": "Failed to {action} variant: {title}",
    "listing_form.error.digital_content_action_failed": "Failed to {action} digital content: {title}",
    "Failed to {action} digital content: {title}": "Failed to {action} digital content: {title}",
    "listing_form.action.create": "create",
    "listing_form.action.update": "update",
    "listing_form.action.delete": "delete",
    "delete": "delete",
    "listing_form.error.save_request_failed": "Failed to save listing",
    "Failed to save listing": "Failed to save listing",
    "listing_form.error.rental_settings_save_failed": "Listing saved, but rental settings could not be saved.",
    "Listing saved, but rental settings could not be saved.": "Listing saved, but rental settings could not be saved.",
    "users.action_failed": "Action failed. Please try again.",
    "Action failed. Please try again.": "Action failed. Please try again.",
    "common.successfully_added": "Successfully added",
    "Successfully added": "Successfully added",
    "listing_form.validation.title_min_length": "Title must be at least {count} characters",
    "Title must be at least {count} characters": "Title must be at least {count} characters",
    "listing_form.validation.title_max_length": "Title must not exceed {count} characters",
    "Title must not exceed {count} characters": "Title must not exceed {count} characters",
    "listing_form.validation.price_minimum": "Price must be at least {amount}",
    "Price must be at least {amount}": "Price must be at least {amount}",
    "listing_form.validation.attribute_required": "{attribute} is required",
    "listings.error.load_failed": "Unable to load listings",
    "Unable to load listings": "Unable to load listings",
    "communications.from_email_required_before_verification": "Please enter From email address before verifying.",
    "Please enter From email address before verifying.": "Please enter From email address before verifying.",
    "communications.verification_email_sent": "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.",
    "communications.verification_start_failed": "Unable to start verification. Please try again.",
    "Unable to start verification. Please try again.": "Unable to start verification. Please try again.",
    "common.uploaded_successfully": "Uploaded successfully",
    "upgrade_page.panel.yearly": "Yearly",
    "upgrade_page.panel.monthly": "Monthly",
    "orders.advance_paid": "Advance paid",
    "Advance paid": "Advance paid",
    "orders.balance_due": "Balance due",
    "Balance due": "Balance due",
    "orders.advance_invalid": "Enter an amount less than the order total.",
    "Enter an amount less than the order total.": "Enter an amount less than the order total.",
    "orders.advance_failed": "Could not save the advance.",
    "Could not save the advance.": "Could not save the advance.",
    "orders.edit_advance": "Edit advance",
    "Edit advance": "Edit advance",
    "orders.record_advance": "Record advance",
    "Record advance": "Record advance",
    "orders.advance_notice": "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.",
    "orders.save_advance": "Save",
    "common.hide": "Hide",
    "listings.repeat.daily": "Daily",
    "listings.repeat.weekdays": "Weekdays (Mon-Fri)",
    "Weekdays (Mon-Fri)": "Weekdays (Mon-Fri)",
    "listings.repeat.weekend": "Weekend (Sat-Sun)",
    "Weekend (Sat-Sun)": "Weekend (Sat-Sun)",
    "listings.repeat.custom": "Custom",
    "listings.weekday.sun": "Sun",
    "Sun": "Sun",
    "listings.weekday.mon": "Mon",
    "Mon": "Mon",
    "listings.weekday.tue": "Tue",
    "Tue": "Tue",
    "listings.weekday.wed": "Wed",
    "Wed": "Wed",
    "listings.weekday.thu": "Thu",
    "Thu": "Thu",
    "listings.weekday.fri": "Fri",
    "Fri": "Fri",
    "listings.weekday.sat": "Sat",
    "Sat": "Sat",
    "orders.pay_balance": "Pay balance {amount}",
    "Pay balance {amount}": "Pay balance {amount}",
    "orders.partially_paid": "Partially paid",
    "Partially paid": "Partially paid",
    "orders.balance_amount": "Balance {amount}",
    "Balance {amount}": "Balance {amount}",
    "delivery.get_started.add_branch": "Add branch",
    "Add branch": "Add branch",
    "delivery.get_started.add_fleet": "Add fleet",
    "Add fleet": "Add fleet",
    "delivery.get_started.api_documentation": "API Documentation",
    "API Documentation": "API Documentation",
    "delivery.get_started.add_driver": "Add driver",
    "Add driver": "Add driver",
    "delivery.get_started.branch_title": "Add your branch",
    "Add your branch": "Add your branch",
    "delivery.get_started.branch_description": "A branch can have many fleets and drivers",
    "A branch can have many fleets and drivers": "A branch can have many fleets and drivers",
    "delivery.get_started.fleet_title": "Add your fleet",
    "Add your fleet": "Add your fleet",
    "delivery.get_started.fleet_description": "A fleet can be assigned to a driver",
    "A fleet can be assigned to a driver": "A fleet can be assigned to a driver",
    "delivery.get_started.driver_title": "Add your driver",
    "Add your driver": "Add your driver",
    "delivery.get_started.driver_description": "The driver will deliver your order",
    "The driver will deliver your order": "The driver will deliver your order",
    "delivery.get_started.order_title": "Create your first order",
    "Create your first order": "Create your first order",
    "delivery.get_started.order_description": "Orders can be created through the API",
    "Orders can be created through the API": "Orders can be created through the API",
    "delivery.get_started.progress.branches": "Branches",
    "Branches": "Branches",
    "delivery.get_started.progress.fleets": "Fleets",
    "Fleets": "Fleets",
    "delivery.get_started.progress.drivers": "Drivers",
    "Drivers": "Drivers",
    "delivery.get_started.progress.orders": "Delivery Orders",
    "Delivery Orders": "Delivery Orders",
    "delivery.get_started.welcome": "Welcome to",
    "Welcome to": "Welcome to",
    "delivery.get_started.question": "What would you like to do?",
    "What would you like to do?": "What would you like to do?",
    "workspace.templates.built_in": "Built-in",
    "Built-in": "Built-in",
    "workspace.templates.copy_of": "Copy of {name}",
    "Copy of {name}": "Copy of {name}",
    "workspace.members.role": "Role",
    "Role": "Role",
    "workspace.members.role_full_access": "Full access",
    "Full access": "Full access",
    "workspace.templates.duplicate": "Duplicate",
    "workspace.members.role_custom": "Custom (set below)",
    "Custom (set below)": "Custom (set below)",
    "onboarding.trial_upgrade.first_order.eyebrow": "First order placed",
    "First order placed": "First order placed",
    "onboarding.trial_upgrade.first_order.title": "Your first order just came in",
    "Your first order just came in": "Your first order just came in",
    "onboarding.trial_upgrade.first_order.body": "Orders are flowing, so this is the moment to lock in a plan and keep everything live after your trial.",
    "Orders are flowing, so this is the moment to lock in a plan and keep everything live after your trial.": "Orders are flowing, so this is the moment to lock in a plan and keep everything live after your trial.",
    "onboarding.trial_upgrade.payments_connected.eyebrow": "Payments connected",
    "Payments connected": "Payments connected",
    "onboarding.trial_upgrade.payments_connected.title": "You are ready to get paid",
    "You are ready to get paid": "You are ready to get paid",
    "onboarding.trial_upgrade.payments_connected.body": "Online payments are on. Choose a plan now so checkout keeps working after your trial ends.",
    "Online payments are on. Choose a plan now so checkout keeps working after your trial ends.": "Online payments are on. Choose a plan now so checkout keeps working after your trial ends.",
    "onboarding.trial_upgrade.first_listing.eyebrow": "First listing added",
    "First listing added": "First listing added",
    "onboarding.trial_upgrade.first_listing.title": "Your first real listing is live",
    "Your first real listing is live": "Your first real listing is live",
    "onboarding.trial_upgrade.first_listing.body": "Customers now have something real to buy. Pick a plan to keep it open for them after your trial.",
    "Customers now have something real to buy. Pick a plan to keep it open for them after your trial.": "Customers now have something real to buy. Pick a plan to keep it open for them after your trial.",
    "onboarding.trial_upgrade.later": "Later",
    "Later": "Later",
    "onboarding.trial_upgrade.cta": "Choose a plan",
    "listings.rental_terms_missing": "This listing has no rental terms yet, so customers can't book it. Add the rate, minimum duration and deposit to start taking bookings.",
    "This listing has no rental terms yet, so customers can't book it. Add the rate, minimum duration and deposit to start taking bookings.": "This listing has no rental terms yet, so customers can't book it. Add the rate, minimum duration and deposit to start taking bookings.",
    "listings.set_up_rental_terms": "Set up rental terms",
    "Set up rental terms": "Set up rental terms",
    "workspace.plans.limit_listings": "Up to {count} listings",
    "Up to {count} listings": "Up to {count} listings",
    "workspace.plans.limit_accounts": "Up to {count} accounts",
    "Up to {count} accounts": "Up to {count} accounts",
    "workspace.plans.limit_users": "Up to {count} users",
    "Up to {count} users": "Up to {count} users",
    "workspace.plans.limit_storage": "{size} storage",
    "{size} storage": "{size} storage",
    "workspace.plans.kit_growth": "GrowthKit (Email, Forms, Analytics, Attribution)",
    "GrowthKit (Email, Forms, Analytics, Attribution)": "GrowthKit (Email, Forms, Analytics, Attribution)",
    "workspace.plans.kit_operate": "OperateKit (ERP + commerce)",
    "OperateKit (ERP + commerce)": "OperateKit (ERP + commerce)",
    "workspace.plans.kit_growth_basic": "GrowthKit (Email, Forms, Analytics)",
    "GrowthKit (Email, Forms, Analytics)": "GrowthKit (Email, Forms, Analytics)",
    "workspace.plans.attribution_from_starter": "Attribution: available from Starter",
    "Attribution: available from Starter": "Attribution: available from Starter",
    "templates.use_template": "Use this template",
    "Use this template": "Use this template",
    "templates.use_a_template": "Use a template",
    "Use a template": "Use a template",
    "templates.replace_draft_confirm": "You have an unsaved coupon draft. Replace it with this template?",
    "You have an unsaved coupon draft. Replace it with this template?": "You have an unsaved coupon draft. Replace it with this template?",
    "templates.replace_collection_draft_confirm": "You have an unsaved collection draft. Replace it with this template?",
    "You have an unsaved collection draft. Replace it with this template?": "You have an unsaved collection draft. Replace it with this template?",
    "templates.coupons.start_from_template": "Start from a template",
    "Start from a template": "Start from a template",
    "templates.coupons.picker_title": "Coupon templates",
    "Coupon templates": "Coupon templates",
    "templates.coupons.picker_subtitle": "Pick one to open the coupon form with the details filled in. You can change anything before saving.",
    "Pick one to open the coupon form with the details filled in. You can change anything before saving.": "Pick one to open the coupon form with the details filled in. You can change anything before saving.",
    "templates.coupons.chip_percent_off": "{value}% off",
    "templates.coupons.chip_flat_off": "{value} off",
    "{value} off": "{value} off",
    "templates.coupons.chip_new_customers": "New customers only",
    "New customers only": "New customers only",
    "templates.coupons.chip_min_spend": "Min. spend {value}",
    "Min. spend {value}": "Min. spend {value}",
    "templates.coupons.chip_valid_year": "Valid for 1 year",
    "Valid for 1 year": "Valid for 1 year",
    "templates.coupons.chip_valid_days": "Valid for {count} days",
    "Valid for {count} days": "Valid for {count} days",
    "templates.coupons.welcome.name": "Welcome offer",
    "Welcome offer": "Welcome offer",
    "templates.coupons.welcome.description": "Give first-time customers a reason to place their first order.",
    "Give first-time customers a reason to place their first order.": "Give first-time customers a reason to place their first order.",
    "templates.coupons.flash_sale.name": "Flash sale",
    "Flash sale": "Flash sale",
    "templates.coupons.flash_sale.description": "A short, high-urgency discount with a capped number of uses.",
    "A short, high-urgency discount with a capped number of uses.": "A short, high-urgency discount with a capped number of uses.",
    "templates.coupons.big_basket.name": "Big basket saver",
    "Big basket saver": "Big basket saver",
    "templates.coupons.big_basket.description": "Reward larger orders with a percentage off above a minimum spend.",
    "Reward larger orders with a percentage off above a minimum spend.": "Reward larger orders with a percentage off above a minimum spend.",
    "templates.coupons.flat_off.name": "Flat amount off",
    "Flat amount off": "Flat amount off",
    "templates.coupons.flat_off.description": "A fixed amount off orders above a minimum spend.",
    "A fixed amount off orders above a minimum spend.": "A fixed amount off orders above a minimum spend.",
    "templates.coupons.win_back.name": "Win-back offer",
    "Win-back offer": "Win-back offer",
    "templates.coupons.win_back.description": "Bring back customers who have not ordered in a while. One use per customer.",
    "Bring back customers who have not ordered in a while. One use per customer.": "Bring back customers who have not ordered in a while. One use per customer.",
    "templates.coupons.seasonal.name": "Seasonal sale",
    "Seasonal sale": "Seasonal sale",
    "templates.coupons.seasonal.description": "A two-week promotion for holidays and seasonal peaks.",
    "A two-week promotion for holidays and seasonal peaks.": "A two-week promotion for holidays and seasonal peaks.",
    "templates.collections.start_from_template": "Start from a template",
    "templates.collections.picker_title": "Collection templates",
    "Collection templates": "Collection templates",
    "templates.collections.picker_subtitle": "Pick one to open the collection form with the title, layout and schedule filled in. You then choose the items.",
    "Pick one to open the collection form with the title, layout and schedule filled in. You then choose the items.": "Pick one to open the collection form with the title, layout and schedule filled in. You then choose the items.",
    "templates.collections.chip_vertical": "Vertical layout",
    "Vertical layout": "Vertical layout",
    "templates.collections.chip_horizontal": "Horizontal layout",
    "Horizontal layout": "Horizontal layout",
    "templates.collections.chip_runs_days": "Runs for {count} days",
    "Runs for {count} days": "Runs for {count} days",
    "templates.collections.new_arrivals.name": "New arrivals",
    "New arrivals": "New arrivals",
    "templates.collections.new_arrivals.description": "Show your latest listings first so returning customers see what is new.",
    "Show your latest listings first so returning customers see what is new.": "Show your latest listings first so returning customers see what is new.",
    "templates.collections.new_arrivals.title": "New Arrivals",
    "New Arrivals": "New Arrivals",
    "templates.collections.new_arrivals.blurb": "The latest additions to our catalog.",
    "The latest additions to our catalog.": "The latest additions to our catalog.",
    "templates.collections.best_sellers.name": "Best sellers",
    "Best sellers": "Best sellers",
    "templates.collections.best_sellers.description": "Highlight the listings customers buy most to build trust with new visitors.",
    "Highlight the listings customers buy most to build trust with new visitors.": "Highlight the listings customers buy most to build trust with new visitors.",
    "templates.collections.best_sellers.title": "Best Sellers",
    "Best Sellers": "Best Sellers",
    "templates.collections.best_sellers.blurb": "Our most popular picks, loved by customers.",
    "Our most popular picks, loved by customers.": "Our most popular picks, loved by customers.",
    "templates.collections.featured.name": "Featured picks",
    "Featured picks": "Featured picks",
    "templates.collections.featured.description": "A hand-picked set of listings you want to put in front of everyone.",
    "A hand-picked set of listings you want to put in front of everyone.": "A hand-picked set of listings you want to put in front of everyone.",
    "templates.collections.featured.title": "Featured Picks",
    "Featured Picks": "Featured Picks",
    "templates.collections.featured.blurb": "Hand-picked favorites we think you will love.",
    "Hand-picked favorites we think you will love.": "Hand-picked favorites we think you will love.",
    "templates.collections.flash_sale.name": "Flash sale",
    "templates.collections.flash_sale.description": "A collection that switches itself off after 48 hours.",
    "A collection that switches itself off after 48 hours.": "A collection that switches itself off after 48 hours.",
    "templates.collections.flash_sale.title": "Flash Sale",
    "Flash Sale": "Flash Sale",
    "templates.collections.flash_sale.blurb": "Limited-time deals. Grab them before they are gone.",
    "Limited-time deals. Grab them before they are gone.": "Limited-time deals. Grab them before they are gone.",
    "templates.collections.seasonal.name": "Seasonal picks",
    "Seasonal picks": "Seasonal picks",
    "templates.collections.seasonal.description": "A 30-day collection for holidays and seasonal peaks.",
    "A 30-day collection for holidays and seasonal peaks.": "A 30-day collection for holidays and seasonal peaks.",
    "templates.collections.seasonal.title": "Seasonal Picks",
    "Seasonal Picks": "Seasonal Picks",
    "templates.collections.seasonal.blurb": "Top picks for the season.",
    "Top picks for the season.": "Top picks for the season.",
    "templates.collections.top_accounts.name": "Top accounts",
    "Top accounts": "Top accounts",
    "templates.collections.top_accounts.description": "Feature your best sellers or stores to drive follows and visits.",
    "Feature your best sellers or stores to drive follows and visits.": "Feature your best sellers or stores to drive follows and visits.",
    "templates.collections.top_accounts.title": "Top Accounts",
    "Top Accounts": "Top Accounts",
    "templates.collections.top_accounts.blurb": "Our best-rated sellers and stores.",
    "Our best-rated sellers and stores.": "Our best-rated sellers and stores."
  },
  "fr": {
    "0": "0",
    "6100": "6100",
    "common.language": "Langue",
    "Language": "Langue",
    "common.english": "Anglais",
    "English": "Anglais",
    "common.french": "Français",
    "French": "Français",
    "common.arabic": "Arabe",
    "Arabic": "Arabe",
    "navigation.get_started": "Commencer",
    "Get Started": "Commencer",
    "navigation.dashboard": "Tableau de bord",
    "Dashboard": "Tableau de bord",
    "navigation.orders": "Commandes",
    "Orders": "Commandes",
    "navigation.schedule": "Planning",
    "navigation.accounts": "Comptes",
    "Accounts": "Comptes",
    "navigation.account_categories": "Catégories de comptes",
    "Account Categories": "Catégories de comptes",
    "navigation.account_attributes": "Attributs des comptes",
    "Account Attributes": "Attributs des comptes",
    "navigation.account_configuration": "Configuration des comptes",
    "navigation.agents": "Agents",
    "Agents": "Agents",
    "navigation.listings": "Annonces",
    "Listings": "Annonces",
    "navigation.categories": "Catégories",
    "Categories": "Catégories",
    "navigation.custom_attributes": "Attributs personnalisés",
    "Custom Attributes": "Attributs personnalisés",
    "navigation.variant_types": "Types de variantes",
    "Variant Types": "Types de variantes",
    "navigation.additional_features": "Fonctionnalités supplémentaires",
    "Additional Features": "Fonctionnalités supplémentaires",
    "navigation.reported_listings": "Annonces signalées",
    "Reported Listings": "Annonces signalées",
    "navigation.report_accounts": "Signaler des comptes",
    "Report Accounts": "Signaler des comptes",
    "navigation.users": "Utilisateurs",
    "Users": "Utilisateurs",
    "navigation.user_attributes": "Attributs des utilisateurs",
    "User Attributes": "Attributs des utilisateurs",
    "navigation.reviews_ratings": "Avis et évaluations",
    "Reviews & Ratings": "Avis et évaluations",
    "navigation.report": "Rapports",
    "Report": "Rapports",
    "navigation.reports": "Rapports",
    "Reports": "Rapports",
    "navigation.platform_health": "État de la plateforme",
    "Platform Health": "État de la plateforme",
    "navigation.promotions": "Promotions",
    "Promotions": "Promotions",
    "navigation.collections": "Collections",
    "Collections": "Collections",
    "navigation.promotion_ads": "Promotions et publicités",
    "Promotion / Ads": "Promotions et publicités",
    "navigation.coupons": "Coupons",
    "Coupons": "Coupons",
    "navigation.finance": "Finance",
    "Finance": "Finance",
    "navigation.transactions": "Transactions",
    "Transactions": "Transactions",
    "navigation.settlement": "Règlements",
    "Settlement": "Règlements",
    "navigation.expenses": "Dépenses",
    "Expenses": "Dépenses",
    "navigation.recurring_payments": "Paiements récurrents",
    "Recurring payments": "Paiements récurrents",
    "navigation.media": "Médias",
    "Media": "Médias",
    "navigation.communication": "Communication",
    "Communication": "Communication",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Éditeur de site web",
    "Website Editor": "Éditeur de site web",
    "navigation.change_templates": "Changer de modèle",
    "Change Templates": "Changer de modèle",
    "navigation.pages": "Pages",
    "Pages": "Pages",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Personnaliser les textes",
    "Customise texts": "Personnaliser les textes",
    "navigation.add_integrations": "Ajouter des intégrations",
    "Add Integrations": "Ajouter des intégrations",
    "navigation.domain": "Domaine",
    "Domain": "Domaine",
    "navigation.customise_seo": "Personnaliser le référencement",
    "Customise SEO": "Personnaliser le référencement",
    "navigation.app": "Application",
    "App": "Application",
    "navigation.apps": "Applications",
    "Apps": "Applications",
    "navigation.buy_app_templates": "Acheter des modèles d’application",
    "Buy App Templates": "Acheter des modèles d’application",
    "navigation.customisation": "Personnalisation",
    "Customisation": "Personnalisation",
    "navigation.integrations": "Intégrations",
    "Integrations": "Intégrations",
    "navigation.invite_team": "Inviter l’équipe",
    "Invite Team": "Inviter l’équipe",
    "navigation.help": "Aide",
    "Help": "Aide",
    "navigation.documentation": "Documentation",
    "Documentation": "Documentation",
    "navigation.community": "Communauté",
    "Community": "Communauté",
    "navigation.api_reference": "Référence de l’API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Canaux",
    "Channels": "Canaux",
    "navigation.coding_kits": "Kits de développement",
    "Coding Kits": "Kits de développement",
    "navigation.vibe_coding": "Programmation assistée par IA",
    "Vibe Coding": "Programmation assistée par IA",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Paramètres",
    "Settings": "Paramètres",
    "navigation.more": "Plus",
    "More": "Plus",
    "navigation.marketplace": "Place de marché",
    "Marketplace": "Place de marché",
    "navigation.commerce": "Commerce",
    "Commerce": "Commerce",
    "navigation.marketing": "Marketing",
    "Marketing": "Marketing",
    "navigation.intelligence": "Analyse avancée",
    "navigation.subscription": "Abonnement",
    "navigation.membership": "Adhésion",
    "Membership": "Adhésion",
    "navigation.rewards": "Récompenses",
    "Rewards": "Récompenses",
    "navigation.bundles": "Lots",
    "Bundles": "Lots",
    "navigation.supply_chain": "Chaîne d’approvisionnement",
    "navigation.people": "Personnel",
    "People": "Personnel",
    "navigation.workforce": "Effectifs",
    "navigation.payroll": "Paie",
    "Payroll": "Paie",
    "navigation.inventory": "Inventaire",
    "Inventory": "Inventaire",
    "navigation.inventory_operations": "Opérations d’inventaire",
    "Inventory Operations": "Opérations d’inventaire",
    "navigation.purchase_orders": "Bons de commande",
    "Purchase Orders": "Bons de commande",
    "navigation.stock_locations": "Emplacements de stock",
    "Stock Locations": "Emplacements de stock",
    "navigation.purchase_orders_2": "Bons de commande",
    "navigation.suppliers": "Fournisseurs",
    "Suppliers": "Fournisseurs",
    "navigation.locations": "Emplacements",
    "Locations": "Emplacements",
    "navigation.maps": "Cartes",
    "Maps": "Cartes",
    "navigation.accounting": "Comptabilité",
    "Accounting": "Comptabilité",
    "navigation.invoices": "Factures",
    "Invoices": "Factures",
    "navigation.plans": "Forfaits",
    "navigation.countries": "Pays",
    "Countries": "Pays",
    "navigation.currency": "Devise",
    "Currency": "Devise",
    "navigation.languages": "Langues",
    "Languages": "Langues",
    "navigation.payments": "Paiements",
    "Payments": "Paiements",
    "navigation.commissions": "Commissions",
    "Commissions": "Commissions",
    "navigation.taxes": "Taxes",
    "Taxes": "Taxes",
    "navigation.special_fees": "Frais spéciaux",
    "Special Fees": "Frais spéciaux",
    "navigation.service_shipping": "Service et livraison",
    "navigation.checkout_cart_attributes": "Attributs de paiement et du panier",
    "navigation.dark_mode_background_color": "Couleur d’arrière-plan du mode sombre",
    "Dark Mode Background Color": "Couleur d’arrière-plan du mode sombre",
    "navigation.dark_mode_text_color": "Couleur du texte du mode sombre",
    "Dark Mode Text Color": "Couleur du texte du mode sombre",
    "navigation.light_mode_background_color": "Couleur d’arrière-plan du mode clair",
    "Light Mode Background Color": "Couleur d’arrière-plan du mode clair",
    "navigation.light_mode_text_color": "Couleur du texte du mode clair",
    "Light Mode Text Color": "Couleur du texte du mode clair",
    "navigation.workspace": "Espace de travail",
    "Workspace": "Espace de travail",
    "navigation.user_management": "Gestion des utilisateurs",
    "User Management": "Gestion des utilisateurs",
    "navigation.privacy": "Confidentialité",
    "Privacy": "Confidentialité",
    "common.search": "Rechercher…",
    "Search...": "Rechercher…",
    "common.search_2": "Rechercher",
    "Search": "Rechercher",
    "common.no_results_found": "Aucun résultat trouvé",
    "No results found": "Aucun résultat trouvé",
    "common.no_record_found": "Aucun enregistrement trouvé",
    "No Record Found": "Aucun enregistrement trouvé",
    "common.open_in_a_new_tab": "Ouvrir dans un nouvel onglet",
    "Open in a new tab": "Ouvrir dans un nouvel onglet",
    "common.open": "Ouvrir",
    "common.in_a_new_tab": "dans un nouvel onglet",
    "in a new tab": "dans un nouvel onglet",
    "common.loading_page": "Chargement de la page…",
    "Loading page…": "Chargement de la page…",
    "common.close": "Fermer",
    "Close": "Fermer",
    "common.save": "Enregistrer",
    "Save": "Enregistrer",
    "common.cancel": "Annuler",
    "Cancel": "Annuler",
    "common.delete": "Supprimer",
    "Delete": "Supprimer",
    "common.edit": "Modifier",
    "Edit": "Modifier",
    "common.add": "Ajouter",
    "Add": "Ajouter",
    "common.create": "Créer",
    "Create": "Créer",
    "common.update": "Mettre à jour",
    "Update": "Mettre à jour",
    "common.back": "Retour",
    "Back": "Retour",
    "common.next": "Suivant",
    "Next": "Suivant",
    "common.previous": "Précédent",
    "Previous": "Précédent",
    "common.done": "Terminé",
    "Done": "Terminé",
    "common.yes": "Oui",
    "Yes": "Oui",
    "common.no": "Non",
    "No": "Non",
    "common.name": "Nom",
    "Name": "Nom",
    "common.status": "Statut",
    "Status": "Statut",
    "common.date": "Date",
    "Date": "Date",
    "common.actions": "Actions",
    "Actions": "Actions",
    "common.action": "Action",
    "Action": "Action",
    "orders.scan_order": "Scanner une commande",
    "Scan order": "Scanner une commande",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Scannez un code-barres ou un QR code, ou saisissez la référence manuellement.",
    "Scan a barcode/QR reference or enter it manually.": "Scannez un code-barres ou un QR code, ou saisissez la référence manuellement.",
    "orders.camera_scanner": "Scanner de caméra",
    "Camera scanner": "Scanner de caméra",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "La lecture par caméra n’est pas prise en charge ici. Saisissez la référence de commande ci-dessous.",
    "Camera scanning is not supported here. Enter the order reference below.": "La lecture par caméra n’est pas prise en charge ici. Saisissez la référence de commande ci-dessous.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "La caméra est inaccessible. Saisissez la référence de commande ci-dessous.",
    "Camera access is unavailable. Enter the order reference below.": "La caméra est inaccessible. Saisissez la référence de commande ci-dessous.",
    "orders.order_reference_number": "Numéro de référence de commande",
    "Order reference number": "Numéro de référence de commande",
    "orders.find_order": "Rechercher la commande",
    "Find order": "Rechercher la commande",
    "common.your_orders_will_be_shown_here": "Vos commandes s’afficheront ici.",
    "Your orders will be shown here.": "Vos commandes s’afficheront ici.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Suivez ici les commandes, réservations et autres opérations effectuées avec d’autres comptes, ainsi que leur évolution.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Suivez ici les commandes, réservations et autres opérations effectuées avec d’autres comptes, ainsi que leur évolution.",
    "common.reference": "Référence n°",
    "Reference #": "Référence n°",
    "common.amount": "Montant",
    "Amount": "Montant",
    "orders.order_status": "Statut de la commande",
    "Order Status": "Statut de la commande",
    "orders.payment_status": "Statut du paiement",
    "Payment Status": "Statut du paiement",
    "common.payment_method": "Mode de paiement",
    "Payment Method": "Mode de paiement",
    "common.shipping_method": "Mode de livraison",
    "common.paid": "Payé",
    "common.not_paid": "Non payé",
    "Not Paid": "Non payé",
    "common.unpaid": "Non payé",
    "UnPaid": "Non payé",
    "common.failed": "Échoué",
    "common.incomplete": "Incomplète",
    "Incomplete": "Incomplète",
    "common.order_placed": "Commande passée",
    "Order placed": "Commande passée",
    "common.order_in_progress": "Commande en cours",
    "Order in progress": "Commande en cours",
    "common.shipped": "Expédiée",
    "Shipped": "Expédiée",
    "common.delivered": "Livrée",
    "Delivered": "Livrée",
    "common.cancelled_by_customer": "Annulée par le client",
    "Cancelled by customer": "Annulée par le client",
    "common.order_completed": "Commande terminée",
    "Order completed": "Commande terminée",
    "common.n_a": "S. O.",
    "orders.total_orders": "Nombre total de commandes",
    "orders.page_revenue": "Chiffre d’affaires de la page",
    "Page Revenue": "Chiffre d’affaires de la page",
    "orders.pending_payment": "Paiements en attente",
    "Pending Payment": "Paiements en attente",
    "common.failed_payments": "Paiements échoués",
    "Failed payments": "Paiements échoués",
    "common.abandoned": "Abandonnées",
    "Abandoned": "Abandonnées",
    "orders.search_orders_by_reference_number": "Rechercher des commandes par numéro de référence",
    "Search orders by reference number": "Rechercher des commandes par numéro de référence",
    "orders.search_by_reference_number": "Rechercher par numéro de référence…",
    "Search by reference number…": "Rechercher par numéro de référence…",
    "orders.export_orders_as_csv": "Exporter les commandes en CSV",
    "Export orders as CSV": "Exporter les commandes en CSV",
    "orders.manual_order": "Commande manuelle",
    "Manual Order": "Commande manuelle",
    "orders.scan_order_reference": "Scanner la référence de commande",
    "Scan order reference": "Scanner la référence de commande",
    "orders.change_status_to": "Changer le statut…",
    "Change status to…": "Changer le statut…",
    "common.apply": "Appliquer",
    "Apply": "Appliquer",
    "common.clear": "Effacer",
    "Clear": "Effacer",
    "orders.pay": "Payer",
    "Pay": "Payer",
    "orders.clear_selection": "Effacer la sélection",
    "Clear selection": "Effacer la sélection",
    "orders.list": "Liste",
    "orders.board": "Tableau",
    "Board": "Tableau",
    "orders.filter_orders": "Filtrer les commandes",
    "Filter orders": "Filtrer les commandes",
    "orders.start_date": "Date de début",
    "Start Date": "Date de début",
    "orders.end_date": "Date de fin",
    "End Date": "Date de fin",
    "orders.select_date": "Sélectionner une date",
    "orders.show_rows": "Afficher les lignes",
    "Show rows": "Afficher les lignes",
    "common.order_selected": "commande sélectionnée",
    "order selected": "commande sélectionnée",
    "common.orders_selected": "commandes sélectionnées",
    "orders selected": "commandes sélectionnées",
    "common.order_updated": "commande mise à jour",
    "order updated": "commande mise à jour",
    "common.orders_updated": "commandes mises à jour",
    "orders updated": "commandes mises à jour",
    "orders.order_archived_successfully": "Commande archivée avec succès",
    "Order archived successfully": "Commande archivée avec succès",
    "orders.failed_to_archive_order": "Échec de l’archivage de la commande",
    "Failed to archive order": "Échec de l’archivage de la commande",
    "orders.loading_order": "Chargement de la commande…",
    "Loading order…": "Chargement de la commande…",
    "orders.order_created_successfully": "Commande créée avec succès",
    "Order created successfully": "Commande créée avec succès",
    "orders.the_order_has_been_created_and_is_ready_to_review": "La commande a été créée et peut maintenant être consultée.",
    "The order has been created and is ready to review.": "La commande a été créée et peut maintenant être consultée.",
    "orders.order_reference": "Référence de la commande",
    "common.created": "Créée",
    "common.total": "Total",
    "Total": "Total",
    "common.items": "Articles",
    "orders.print_save_pdf": "Imprimer / Enregistrer en PDF",
    "Print / Save PDF": "Imprimer / Enregistrer en PDF",
    "orders.view_order_details": "Voir les détails de la commande",
    "View order details": "Voir les détails de la commande",
    "orders.create_another_order": "Créer une autre commande",
    "Create another order": "Créer une autre commande",
    "orders.confirmed": "Confirmée",
    "Confirmed": "Confirmée",
    "orders.in_progress": "En cours",
    "In progress": "En cours",
    "orders.customer_unreachable": "Client injoignable",
    "Customer unreachable": "Client injoignable",
    "orders.out_for_delivery": "En cours de livraison",
    "Out for delivery": "En cours de livraison",
    "orders.returned": "Retournée",
    "Returned": "Retournée",
    "orders.return_confirmed": "Retour confirmé",
    "Return confirmed": "Retour confirmé",
    "orders.delivery_confirmed": "Livraison confirmée",
    "Delivery confirmed": "Livraison confirmée",
    "orders.return_initiated": "Retour initié",
    "Return initiated": "Retour initié",
    "orders.return_picked": "Retour récupéré",
    "Return picked": "Retour récupéré",
    "orders.return_disputed": "Retour contesté",
    "Return disputed": "Retour contesté",
    "orders.canceled_by_seller": "Annulée par le vendeur",
    "Canceled by seller": "Annulée par le vendeur",
    "orders.canceled_by_customer": "Annulée par le client",
    "Canceled by customer": "Annulée par le client",
    "orders.ready_for_pickup": "Prête à être retirée",
    "orders.arrived_at_customer_location": "Arrivée chez le client",
    "Arrived at customer location": "Arrivée chez le client",
    "orders.undelivered_returned": "Non livré - retourné",
    "Undelivered - Returned": "Non livré - retourné",
    "orders.undelivered_return_confirmed": "Non livré - retour confirmé",
    "Undelivered - Return confirmed": "Non livré - retour confirmé",
    "orders.disputed": "Contestée",
    "Disputed": "Contestée",
    "orders.completed": "Terminée",
    "orders.detail_legacy.order_number": "N° de commande :",
    "Order Number:": "N° de commande :",
    "orders.detail_legacy.order_date": "Date de commande :",
    "Order Date:": "Date de commande :",
    "orders.detail_legacy.buyer_details": "Informations sur l’acheteur :",
    "Buyer Details:": "Informations sur l’acheteur :",
    "orders.detail_legacy.delivery_address": "Adresse de livraison :",
    "Delivery Address:": "Adresse de livraison :",
    "orders.detail_legacy.pickup_address": "Adresse de retrait :",
    "Pickup Address:": "Adresse de retrait :",
    "orders.detail_legacy.total_amount": "Montant total :",
    "Total Amount:": "Montant total :",
    "orders.detail_legacy.amount_in_words": "Montant en toutes lettres :",
    "Amount in Words:": "Montant en toutes lettres :",
    "orders.detail_legacy.amount_words_only": "uniquement",
    "Only": "uniquement",
    "orders.detail_legacy.payout_date": "Date de versement :",
    "Payout Date:": "Date de versement :",
    "orders.detail_legacy.change": "Modifier",
    "orders.detail_legacy.select_date_time": "Sélectionner la date et l’heure",
    "Select Date & Time": "Sélectionner la date et l’heure",
    "orders.detail_legacy.change_payout_date_time": "Modifier la date et l’heure du versement",
    "Change Payout Date and Time": "Modifier la date et l’heure du versement",
    "orders.detail_legacy.update_payout": "Mettre à jour",
    "orders.detail_legacy.update_status": "Mettre à jour le statut",
    "Update Status": "Mettre à jour le statut",
    "orders.detail_legacy.change_order_status": "Modifier le statut de la commande",
    "Change Order Status": "Modifier le statut de la commande",
    "orders.detail_legacy.column_description": "Description",
    "Description": "Description",
    "orders.detail_legacy.column_unit_price": "Prix unitaire",
    "Unit Price": "Prix unitaire",
    "orders.detail_legacy.column_discount": "Remise",
    "Discount": "Remise",
    "orders.detail_legacy.column_tax_rate": "Taux de taxe",
    "Tax Rate": "Taux de taxe",
    "orders.item": "Article",
    "Item": "Article",
    "orders.order_details": "Détails de la commande",
    "Order Details": "Détails de la commande",
    "orders.copy_order_reference": "Copier la référence de la commande",
    "Copy order reference": "Copier la référence de la commande",
    "orders.order_summary": "Récapitulatif de la commande",
    "Order Summary": "Récapitulatif de la commande",
    "orders.order_created": "Commande créée",
    "Order created": "Commande créée",
    "orders.order_time": "Heure de la commande",
    "Order time": "Heure de la commande",
    "orders.total_earnings": "Revenus totaux",
    "Total earnings": "Revenus totaux",
    "orders.total_price": "Prix total",
    "Total price": "Prix total",
    "orders.delivery_fee": "Frais de livraison",
    "Delivery fee": "Frais de livraison",
    "orders.sub_total": "Sous-total",
    "Sub total": "Sous-total",
    "orders.customer_information": "Informations client",
    "Customer Information": "Informations client",
    "common.customer_name": "Nom du client",
    "Customer Name": "Nom du client",
    "common.phone": "Téléphone",
    "Phone": "Téléphone",
    "common.email": "E-mail",
    "Email": "E-mail",
    "orders.seller_details": "Informations sur le vendeur",
    "Seller Details": "Informations sur le vendeur",
    "common.seller_name": "Nom du vendeur",
    "Seller Name": "Nom du vendeur",
    "common.mobile": "Téléphone portable",
    "orders.generate": "Générer",
    "Generate": "Générer",
    "orders.cancel_order": "Annuler la commande",
    "Cancel Order": "Annuler la commande",
    "orders.mark_as_paid": "Marquer comme payée",
    "Mark as Paid": "Marquer comme payée",
    "orders.failed_to_mark_as_paid": "Impossible de marquer la commande comme payée",
    "Failed to mark as paid": "Impossible de marquer la commande comme payée",
    "orders.order_cancelled_successfully": "Commande annulée avec succès",
    "Order cancelled successfully": "Commande annulée avec succès",
    "orders.failed_to_cancel_order_by_admin": "Impossible d’annuler la commande en tant qu’administrateur",
    "Failed to cancel order by admin": "Impossible d’annuler la commande en tant qu’administrateur",
    "orders.no_transactions_found": "Aucune transaction trouvée",
    "No transactions found": "Aucune transaction trouvée",
    "orders.transaction_no": "N° de transaction",
    "Transaction No": "N° de transaction",
    "orders.entity": "Entité",
    "Entity": "Entité",
    "orders.transaction_type": "Type de transaction",
    "Transaction Type": "Type de transaction",
    "common.seller": "Vendeur",
    "Seller": "Vendeur",
    "common.customer": "Client",
    "Customer": "Client",
    "common.platform_owner": "Propriétaire de la plateforme",
    "Platform Owner": "Propriétaire de la plateforme",
    "orders.items_summary": "Récapitulatif des articles",
    "Items Summary": "Récapitulatif des articles",
    "orders.qty": "Qté",
    "QTY": "Qté",
    "orders.price": "Prix",
    "Price": "Prix",
    "orders.total_price_2": "Prix total",
    "Total Price": "Prix total",
    "orders.membership_purchase": "Achat d’adhésion",
    "Membership purchase": "Achat d’adhésion",
    "orders.member_id": "Identifiant du membre",
    "Member ID": "Identifiant du membre",
    "orders.period": "Période",
    "Period": "Période",
    "orders.start_date_2": "Date de début",
    "Start date": "Date de début",
    "common.next_renewal": "Prochain renouvellement",
    "Next renewal": "Prochain renouvellement",
    "common.expiry_date": "Date d’expiration",
    "Expiry date": "Date d’expiration",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Cette commande correspond à une adhésion et ne nécessite pas de livraison.",
    "This order is managed as a membership contribution, not a shipment.": "Cette commande correspond à une adhésion et ne nécessite pas de livraison.",
    "orders.months": "mois",
    "months": "mois",
    "orders.days": "jours",
    "days": "jours",
    "orders.address": "Adresse",
    "Address": "Adresse",
    "orders.address_1": "Adresse 1",
    "Address 1": "Adresse 1",
    "orders.address_2": "Adresse 2",
    "Address 2": "Adresse 2",
    "orders.zip_code": "Code postal",
    "Zip code": "Code postal",
    "orders.full_address": "Adresse complète",
    "Full Address": "Adresse complète",
    "orders.formatted_address": "Adresse formatée",
    "Formatted Address": "Adresse formatée",
    "orders.phone_number": "Numéro de téléphone",
    "Phone Number": "Numéro de téléphone",
    "orders.address_not_found": "Adresse introuvable",
    "Address not found": "Adresse introuvable",
    "orders.address_not_applicable": "Adresse non applicable",
    "Address not applicable": "Adresse non applicable",
    "orders.address_is_not_available": "Adresse indisponible",
    "Address is not available": "Adresse indisponible",
    "orders.add_pickup_address": "Ajouter une adresse de retrait",
    "Add Pickup Address": "Ajouter une adresse de retrait",
    "orders.edit_pickup_address": "Modifier l’adresse de retrait",
    "Edit Pickup Address": "Modifier l’adresse de retrait",
    "orders.discard_and_close": "Abandonner et fermer",
    "Discard and close": "Abandonner et fermer",
    "orders.state": "Région",
    "State": "Région",
    "common.country": "Pays",
    "Country": "Pays",
    "orders.sales_payout": "Versement des ventes",
    "Sales Payout": "Versement des ventes",
    "orders.sales_no_payout": "Ventes (sans versement)",
    "Sales (No Payout)": "Ventes (sans versement)",
    "orders.sales_payout_reversal": "Annulation du versement des ventes",
    "Sales Payout Reversal": "Annulation du versement des ventes",
    "orders.sales_no_payout_reversal": "Annulation des ventes sans versement",
    "Sales no payout reversal": "Annulation des ventes sans versement",
    "orders.seller_commission": "Commission du vendeur",
    "Seller Commission": "Commission du vendeur",
    "orders.seller_commission_reversal": "Annulation de la commission du vendeur",
    "Seller Commission Reversal": "Annulation de la commission du vendeur",
    "orders.seller_transfer": "Virement au vendeur",
    "Seller Transfer": "Virement au vendeur",
    "orders.seller_transfer_reversal": "Annulation du virement au vendeur",
    "Seller Transfer Reversal": "Annulation du virement au vendeur",
    "orders.seller_payout": "Versement au vendeur",
    "Seller Payout": "Versement au vendeur",
    "orders.seller_subscription": "Abonnement du vendeur",
    "Seller Subscription": "Abonnement du vendeur",
    "orders.seller_payment_processing_fee": "Frais de traitement du paiement vendeur",
    "Seller Payment processing fee": "Frais de traitement du paiement vendeur",
    "orders.seller_payment_processing_fee_reversal": "Annulation des frais de traitement du paiement vendeur",
    "Seller Payment processing fee reversal": "Annulation des frais de traitement du paiement vendeur",
    "orders.sub_total_2": "Sous-total",
    "Sub Total": "Sous-total",
    "orders.customer_commission": "Commission client",
    "Customer Commission": "Commission client",
    "orders.tax": "Taxe",
    "Tax": "Taxe",
    "orders.shipping_charge": "Frais de livraison",
    "Shipping Charge": "Frais de livraison",
    "orders.refund": "Remboursement",
    "Refund": "Remboursement",
    "orders.special_fee": "Frais spécial",
    "Special Fee": "Frais spécial",
    "orders.coupon": "Code promo",
    "orders.shipment": "Expédition",
    "Shipment": "Expédition",
    "orders.fulfilled_by_platform": "Expédié par la plateforme",
    "Fulfilled by platform": "Expédié par la plateforme",
    "orders.fulfilled_by": "Expédié par",
    "Fulfilled by": "Expédié par",
    "orders.fulfilled_by_seller": "Expédié par le vendeur",
    "Fulfilled by seller": "Expédié par le vendeur",
    "orders.on_seller_protection_policy": "Couvert par la protection vendeur",
    "On Seller Protection Policy": "Couvert par la protection vendeur",
    "orders.product_image": "Image du produit",
    "Product image": "Image du produit",
    "orders.status_changed_successfully": "Statut modifié avec succès",
    "Status changed successfully": "Statut modifié avec succès",
    "orders.pickup_address_not_available_please_add_pickup_address": "Adresse de retrait indisponible. Veuillez en ajouter une.",
    "Pickup Address not available. Please Add Pickup Address": "Adresse de retrait indisponible. Veuillez en ajouter une.",
    "orders.failed_to_save_pickup_address_please_try_again": "Échec de l’enregistrement de l’adresse de retrait. Veuillez réessayer.",
    "Failed to save pickup address. Please try again.": "Échec de l’enregistrement de l’adresse de retrait. Veuillez réessayer.",
    "orders.change_shipment_status": "Modifier le statut de l’expédition",
    "Change shipment status": "Modifier le statut de l’expédition",
    "orders.not_available": "Indisponible",
    "orders.shipment_created": "Expédition créée",
    "Shipment created": "Expédition créée",
    "orders.shipment_in_progress": "Expédition en cours",
    "Shipment in progress": "Expédition en cours",
    "orders.ship": "Expédier",
    "Ship": "Expédier",
    "orders.undelivered_return": "Retour non livré",
    "Undelivered return": "Retour non livré",
    "orders.shipment_deliver": "Expédition livrée",
    "Shipment deliver": "Expédition livrée",
    "orders.shipment_delivery_confirm": "Livraison de l’expédition confirmée",
    "Shipment delivery confirm": "Livraison de l’expédition confirmée",
    "orders.return_initiate": "Initier le retour",
    "Return initiate": "Initier le retour",
    "orders.return_for_pickup": "Retour à récupérer",
    "Return for pickup": "Retour à récupérer",
    "orders.shipment_return_confirm": "Retour de l’expédition confirmé",
    "Shipment return confirm": "Retour de l’expédition confirmé",
    "orders.cancel_by_seller": "Annuler par le vendeur",
    "Cancel by seller": "Annuler par le vendeur",
    "orders.cancel_by_customer": "Annuler par le client",
    "Cancel by customer": "Annuler par le client",
    "orders.arrive_at_customer_location": "Arrivée chez le client",
    "Arrive at customer location": "Arrivée chez le client",
    "orders.shipment_delivered": "Expédition livrée",
    "Shipment delivered": "Expédition livrée",
    "orders.shipment_delivery_confirmed": "Livraison de l’expédition confirmée",
    "Shipment delivery confirmed": "Livraison de l’expédition confirmée",
    "orders.returned_for_pickup": "Retour à récupérer",
    "orders.shipment_return_confirmed": "Retour de l’expédition confirmé",
    "Shipment return confirmed": "Retour de l’expédition confirmé",
    "orders.cancelled_by_seller": "Annulée par le vendeur",
    "Cancelled by seller": "Annulée par le vendeur",
    "common.cancelled_by_admin": "Annulée par l’administrateur",
    "Cancelled by admin": "Annulée par l’administrateur",
    "orders.invoice": "Facture",
    "Invoice": "Facture",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Sélectionnez un type de fichier valide (PDF, JPG, PNG, DOC).",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Sélectionnez un type de fichier valide (PDF, JPG, PNG, DOC).",
    "orders.file_size_must_be_less_than_5mb": "La taille du fichier doit être inférieure à 5 Mo.",
    "File size must be less than 5MB": "La taille du fichier doit être inférieure à 5 Mo.",
    "orders.please_upload_a_file_first": "Veuillez d’abord importer un fichier.",
    "Please upload a file first": "Veuillez d’abord importer un fichier.",
    "orders.invoice_uploaded_successfully": "Facture importée avec succès !",
    "Invoice uploaded successfully!": "Facture importée avec succès !",
    "orders.failed_to_upload_invoice_please_try_again": "Échec de l’importation de la facture. Veuillez réessayer.",
    "Failed to upload invoice. Please try again.": "Échec de l’importation de la facture. Veuillez réessayer.",
    "orders.upload_invoice": "Importer une facture",
    "Upload Invoice": "Importer une facture",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Formats acceptés : PDF, JPG, PNG, DOC (taille max. : 5 Mo)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Formats acceptés : PDF, JPG, PNG, DOC (taille max. : 5 Mo)",
    "orders.uploading": "Importation…",
    "orders.choose_file": "Choisir un fichier",
    "Choose File": "Choisir un fichier",
    "common.download": "Télécharger",
    "Download": "Télécharger",
    "common.remove": "Supprimer",
    "orders.upload_new_file": "Importer un nouveau fichier",
    "Upload New File": "Importer un nouveau fichier",
    "orders.saving": "Enregistrement…",
    "Saving...": "Enregistrement…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "La suppression d’une commande la retirera immédiatement des espaces du vendeur et de l’acheteur. Aucune mise à jour de statut ne sera ensuite possible et la commande sera exclue des indicateurs et des rapports. Voulez-vous continuer ?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "La suppression d’une commande la retirera immédiatement des espaces du vendeur et de l’acheteur. Aucune mise à jour de statut ne sera ensuite possible et la commande sera exclue des indicateurs et des rapports. Voulez-vous continuer ?",
    "common.showing": "Affichage de",
    "Showing": "Affichage de",
    "common.of": "sur",
    "of": "sur",
    "common.all": "Tout",
    "common.active": "Actif",
    "common.inactive": "Inactif",
    "common.enabled": "Activé",
    "Enabled": "Activé",
    "common.disabled": "Désactivé",
    "Disabled": "Désactivé",
    "common.success": "Réussite",
    "Success": "Réussite",
    "common.error": "Erreur",
    "Error": "Erreur",
    "common.warning": "Avertissement",
    "Warning": "Avertissement",
    "common.required": "Obligatoire",
    "Required": "Obligatoire",
    "users.title": "Utilisateurs",
    "users.import": "Importer",
    "Import": "Importer",
    "users.import_users": "Importer des utilisateurs",
    "Import users": "Importer des utilisateurs",
    "users.smart_upload_users": "Import intelligent d’utilisateurs",
    "Smart Upload Users": "Import intelligent d’utilisateurs",
    "users.smart_upload_beta": "Import intelligent d’utilisateurs (bêta)",
    "Smart upload users (Beta)": "Import intelligent d’utilisateurs (bêta)",
    "users.export": "Exporter",
    "Export": "Exporter",
    "users.export_users": "Exporter des utilisateurs",
    "Export users": "Exporter des utilisateurs",
    "users.search_users": "Rechercher des utilisateurs",
    "Search users": "Rechercher des utilisateurs",
    "users.verified": "Vérifié",
    "Verified": "Vérifié",
    "users.not_verified": "Non vérifié",
    "Non Verified": "Non vérifié",
    "users.block": "Bloquer",
    "Block": "Bloquer",
    "users.unblock": "Débloquer",
    "Unblock": "Débloquer",
    "users.confirm_block": "Voulez-vous bloquer cet utilisateur ?",
    "Do you want to block this user?": "Voulez-vous bloquer cet utilisateur ?",
    "users.confirm_unblock": "Voulez-vous débloquer cet utilisateur ?",
    "Do you want to unblock this user?": "Voulez-vous débloquer cet utilisateur ?",
    "users.import_export": "Importation et exportation des utilisateurs",
    "User import and export": "Importation et exportation des utilisateurs",
    "users.user_id": "Identifiant utilisateur",
    "users.first_name": "Prénom",
    "First Name": "Prénom",
    "users.last_name": "Nom",
    "Last Name": "Nom",
    "users.email": "E-mail",
    "users.phone_number": "Téléphone",
    "Phone No": "Téléphone",
    "users.country": "Pays",
    "users.profile": "Profil",
    "Profile": "Profil",
    "users.email_verified": "E-mail vérifié",
    "Email Verified": "E-mail vérifié",
    "users.blocked": "Bloqué",
    "Blocked": "Bloqué",
    "users.action": "Action",
    "users.join_date": "Date d’inscription",
    "Join Date": "Date d’inscription",
    "users.last_login": "Dernière connexion",
    "Last Login": "Dernière connexion",
    "users.customer_type": "Type de client",
    "Customer Type": "Type de client",
    "common.and": "et",
    "and": "et",
    "users.import_failed": "L’importation des utilisateurs a échoué.",
    "User import failed.": "L’importation des utilisateurs a échoué.",
    "users.smart_upload.paid_title": "L’importation intelligente des utilisateurs est une fonctionnalité payante",
    "Smart user upload is a paid feature": "L’importation intelligente des utilisateurs est une fonctionnalité payante",
    "users.smart_upload.paid_description": "Passez votre espace de travail à Starter ou Go pour importer des utilisateurs depuis un fichier CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Passez votre espace de travail à Starter ou Go pour importer des utilisateurs depuis un fichier CSV.",
    "users.smart_upload.view_plans": "Voir les offres",
    "View plans": "Voir les offres",
    "users.smart_upload.csv_needs_user": "Le fichier CSV doit contenir une ligne d’en-tête et au moins un utilisateur.",
    "The CSV must contain a header row and at least one user.": "Le fichier CSV doit contenir une ligne d’en-tête et au moins un utilisateur.",
    "users.smart_upload.unique_headers": "Chaque colonne utilisateur doit avoir un en-tête unique et non vide.",
    "Every user column needs a unique, non-empty header.": "Chaque colonne utilisateur doit avoir un en-tête unique et non vide.",
    "users.smart_upload.csv_read_error": "Impossible de lire ce fichier CSV.",
    "Unable to read this CSV.": "Impossible de lire ce fichier CSV.",
    "users.smart_upload.map_required": "Associez {fields} avant de continuer.",
    "Map {fields} before continuing.": "Associez {fields} avant de continuer.",
    "users.smart_upload.map_contact": "Associez une colonne e-mail ou téléphone. Chaque ligne doit contenir au moins un moyen de contact.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Associez une colonne e-mail ou téléphone. Chaque ligne doit contenir au moins un moyen de contact.",
    "users.smart_upload.invalid_row": "Il manque un nom ou une coordonnée obligatoire à la ligne {row}.",
    "Row {row} is missing a required name or contact value.": "Il manque un nom ou une coordonnée obligatoire à la ligne {row}.",
    "users.smart_upload.attribute_name_required": "Saisissez un nom d’attribut pour « {header} ».",
    "Enter an attribute name for “{header}”.": "Saisissez un nom d’attribut pour « {header} ».",
    "users.smart_upload.attribute_create_error": "Impossible de créer l’attribut « {name} ».",
    "Could not create the “{name}” attribute.": "Impossible de créer l’attribut « {name} ».",
    "users.smart_upload.attribute_missing": "L’attribut associé à « {header} » n’est plus disponible.",
    "The attribute mapped from “{header}” is no longer available.": "L’attribut associé à « {header} » n’est plus disponible.",
    "users.smart_upload.prepare_error": "Impossible de préparer le fichier d’importation.",
    "Could not prepare the import file.": "Impossible de préparer le fichier d’importation.",
    "users.smart_upload.upload_error": "Le fichier d’importation n’a pas pu être téléversé.",
    "The import file could not be uploaded.": "Le fichier d’importation n’a pas pu être téléversé.",
    "users.smart_upload.all_duplicates": "Chaque ligne est un doublon d’une autre ligne de ce fichier.",
    "Every row is a duplicate of another row in this file.": "Chaque ligne est un doublon d’une autre ligne de ce fichier.",
    "users.smart_upload.source_attribute_error": "Impossible de créer l’attribut contact_source.",
    "Could not create the contact_source attribute.": "Impossible de créer l’attribut contact_source.",
    "users.smart_upload.duplicates_skipped": "Lignes en double à ignorer : {count}.",
    "Duplicate rows to skip: {count}.": "Lignes en double à ignorer : {count}.",
    "users.smart_upload.preparing_attributes": "Préparation des attributs",
    "Preparing attributes": "Préparation des attributs",
    "users.smart_upload.checking_users": "Vérification des utilisateurs existants",
    "Checking existing users": "Vérification des utilisateurs existants",
    "users.smart_upload.uploading_file": "Téléversement du fichier d’importation",
    "Uploading import file": "Téléversement du fichier d’importation",
    "users.smart_upload.importing_users": "Tradly importe les utilisateurs",
    "Tradly is importing users": "Tradly importe les utilisateurs",
    "users.smart_upload.import_stopped": "Importation interrompue",
    "Import stopped": "Importation interrompue",
    "users.smart_upload.title": "Importation intelligente des utilisateurs",
    "Smart user upload": "Importation intelligente des utilisateurs",
    "users.smart_upload.beta": "(Bêta)",
    "(Beta)": "(Bêta)",
    "users.smart_upload.start_over": "Recommencer",
    "Start over": "Recommencer",
    "users.smart_upload.description": "Importez des contacts, associez les colonnes aux attributs des utilisateurs et indiquez s’ils sont démarchés ou inscrits.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Importez des contacts, associez les colonnes aux attributs des utilisateurs et indiquez s’ils sont démarchés ou inscrits.",
    "users.smart_upload.step_upload": "Importer",
    "users.smart_upload.step_match": "Associer les colonnes",
    "Match columns": "Associer les colonnes",
    "users.smart_upload.step_review": "Vérifier",
    "users.smart_upload.step_import": "Importer",
    "users.smart_upload.choose_csv": "Choisir un fichier CSV",
    "users.smart_upload.required_fields": "Le prénom, le nom et l’adresse e-mail ou le téléphone sont obligatoires. Les mots de passe sont générés automatiquement.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Le prénom, le nom et l’adresse e-mail ou le téléphone sont obligatoires. Les mots de passe sont générés automatiquement.",
    "users.smart_upload.select_csv": "Sélectionner un fichier CSV",
    "Select CSV file": "Sélectionner un fichier CSV",
    "users.smart_upload.match_columns": "Associer les colonnes des utilisateurs",
    "Match user columns": "Associer les colonnes des utilisateurs",
    "users.smart_upload.first_name": "Prénom",
    "First name": "Prénom",
    "users.smart_upload.last_name": "Nom",
    "Last name": "Nom",
    "users.smart_upload.email": "E-mail",
    "users.smart_upload.phone": "Téléphone",
    "users.smart_upload.username": "Nom d’utilisateur",
    "Username": "Nom d’utilisateur",
    "users.smart_upload.do_not_import": "Ne pas importer",
    "Do not import": "Ne pas importer",
    "users.smart_upload.additional_attributes": "Attributs utilisateur supplémentaires",
    "Additional user attributes": "Attributs utilisateur supplémentaires",
    "users.smart_upload.ignore_column": "Ignorer cette colonne",
    "Ignore this column": "Ignorer cette colonne",
    "users.smart_upload.create_attribute": "Créer un nouvel attribut utilisateur",
    "Create a new user attribute": "Créer un nouvel attribut utilisateur",
    "users.smart_upload.attribute_name": "Nom de l’attribut",
    "Attribute name": "Nom de l’attribut",
    "users.smart_upload.type_text": "Texte",
    "Text": "Texte",
    "users.smart_upload.type_long_text": "Texte long",
    "Long text": "Texte long",
    "users.smart_upload.type_number": "Nombre",
    "Number": "Nombre",
    "users.smart_upload.type_single_select": "Sélection unique",
    "Single select": "Sélection unique",
    "users.smart_upload.type_multi_select": "Sélection multiple",
    "Multi select": "Sélection multiple",
    "users.smart_upload.review_import": "Vérifier l’importation",
    "Review import": "Vérifier l’importation",
    "users.smart_upload.review_description": "Contacts à importer : {count}. L’API peut rejeter les utilisateurs Tradly existants ; une nouvelle tentative après un import partiel peut créer des doublons.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Contacts à importer : {count}. L’API peut rejeter les utilisateurs Tradly existants ; une nouvelle tentative après un import partiel peut créer des doublons.",
    "users.smart_upload.contact_classification": "Classification du contact",
    "Contact classification": "Classification du contact",
    "users.smart_upload.outbound": "Démarché (non inscrit)",
    "Outbound (not opted in)": "Démarché (non inscrit)",
    "users.smart_upload.signed_up": "Inscrit",
    "Signed-up (opted in)": "Inscrit",
    "users.smart_upload.contact_source_help": "Cette valeur est enregistrée dans l’attribut contact_source. Le type utilisateur intégré de Tradly reste « client ».",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Cette valeur est enregistrée dans l’attribut contact_source. Le type utilisateur intégré de Tradly reste « client ».",
    "users.smart_upload.import_complete": "Importation des utilisateurs terminée",
    "User import complete": "Importation des utilisateurs terminée",
    "users.smart_upload.imported_summary": "{imported} utilisateur(s) importé(s) sur {total}.",
    "{imported} of {total} users imported.": "{imported} utilisateur(s) importé(s) sur {total}.",
    "users.smart_upload.selected_file": "Sélectionné : {name}",
    "users.smart_upload.review_action": "Vérifier",
    "users.smart_upload.importing_action": "Importation…",
    "Importing…": "Importation…",
    "users.smart_upload.import_users_action": "Importer des utilisateurs",
    "users.import.uploading": "Téléversement…",
    "Uploading…": "Téléversement…",
    "users.import.please_wait": "Veuillez patienter…",
    "Please wait…": "Veuillez patienter…",
    "users.import.error_prefix": "Erreur",
    "users.import.select_file_error": "Veuillez sélectionner un fichier",
    "Please select a file": "Veuillez sélectionner un fichier",
    "users.import.download": "Télécharger",
    "users.import.file_label": "Fichier :",
    "File:": "Fichier :",
    "users.import.select_file": "Sélectionner un fichier",
    "Select File": "Sélectionner un fichier",
    "users.import.upload": "Importer",
    "users.create.button": "Créer un utilisateur",
    "Create User": "Créer un utilisateur",
    "users.create.title": "Créer un nouvel utilisateur",
    "Create New User": "Créer un nouvel utilisateur",
    "users.create.please_wait": "Veuillez patienter…",
    "users.create.email": "E-mail",
    "users.create.first_name": "Prénom",
    "users.create.last_name": "Nom",
    "users.create.email_required": "L’adresse e-mail est obligatoire",
    "Email is required": "L’adresse e-mail est obligatoire",
    "users.create.first_name_required": "Le prénom est obligatoire",
    "First Name is required": "Le prénom est obligatoire",
    "users.create.last_name_required": "Le nom est obligatoire",
    "Last Name is required": "Le nom est obligatoire",
    "users.create.session_expired": "Votre session administrateur a expiré. Reconnectez-vous avant de créer un utilisateur.",
    "Your admin session has expired. Please sign in again before creating a user.": "Votre session administrateur a expiré. Reconnectez-vous avant de créer un utilisateur.",
    "users.create.unable_to_create": "Impossible de créer cet utilisateur.",
    "Unable to create this user.": "Impossible de créer cet utilisateur.",
    "users.create.success": "Utilisateur créé avec succès",
    "User created successfully": "Utilisateur créé avec succès",
    "users.create.failed": "La création de l’utilisateur a échoué. Veuillez réessayer.",
    "User creation failed. Please try again.": "La création de l’utilisateur a échoué. Veuillez réessayer.",
    "common.feature_flow.eyebrow": "DÉCOUVRIR LE FONCTIONNEMENT",
    "SEE HOW IT WORKS": "DÉCOUVRIR LE FONCTIONNEMENT",
    "common.feature_flow.open_guide": "Ouvrir le guide du parcours",
    "Open flow guide": "Ouvrir le guide du parcours",
    "common.feature_flow.close_guide": "Fermer le guide de la section",
    "Close section guide": "Fermer le guide de la section",
    "common.feature_flow.section_guide": "Guide de la section",
    "Section guide": "Guide de la section",
    "users.flow.title": "Tout ce qu’il vous faut pour gérer vos utilisateurs",
    "Everything you need to manage your users": "Tout ce qu’il vous faut pour gérer vos utilisateurs",
    "users.flow.description": "Créez des profils, personnalisez les données et comprenez les avis clients au même endroit.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Créez des profils, personnalisez les données et comprenez les avis clients au même endroit.",
    "users.flow.lane_title": "Gestion des utilisateurs",
    "User management": "Gestion des utilisateurs",
    "users.flow.badge": "Outils essentiels",
    "Core tools": "Outils essentiels",
    "users.flow.attributes": "Attributs",
    "Attributes": "Attributs",
    "users.flow.reviews": "Avis",
    "Reviews": "Avis",
    "users.flow.lane_description": "Gérez les personnes, ajoutez les champs de profil nécessaires et tirez parti de leur expérience.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Gérez les personnes, ajoutez les champs de profil nécessaires et tirez parti de leur expérience.",
    "users.flow.primary_action": "Ajouter votre premier utilisateur",
    "Add your first user": "Ajouter votre premier utilisateur",
    "users.tooltip.title": "Chaque personne est un utilisateur unique",
    "Every individual is a unique user": "Chaque personne est un utilisateur unique",
    "users.tooltip.description": "Imaginez que vous possédez un centre commercial.\n\nChaque personne qui entre dans une boutique est un utilisateur.\n\nChaque commerçant qui gère une boutique est également un utilisateur.\n\nDans Tradly, tous les utilisateurs, commerçants comme clients, sont regroupés dans la section Utilisateurs. Vous y trouverez leurs achats et les comptes qu’ils possèdent.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Imaginez que vous possédez un centre commercial.\n\nChaque personne qui entre dans une boutique est un utilisateur.\n\nChaque commerçant qui gère une boutique est également un utilisateur.\n\nDans Tradly, tous les utilisateurs, commerçants comme clients, sont regroupés dans la section Utilisateurs. Vous y trouverez leurs achats et les comptes qu’ils possèdent.",
    "workspace.loading": "Chargement des paramètres de l’espace de travail…",
    "Loading workspace settings…": "Chargement des paramètres de l’espace de travail…",
    "workspace.kicker": "ESPACE DE TRAVAIL",
    "WORKSPACE": "ESPACE DE TRAVAIL",
    "workspace.fallback_name": "Espace de travail",
    "workspace.members.title": "Inviter un membre de l’équipe",
    "Invite Team Member": "Inviter un membre de l’équipe",
    "workspace.members.description": "Ajoutez des collègues et accordez à chacun les accès nécessaires.",
    "Add teammates and give each person only the access they need.": "Ajoutez des collègues et accordez à chacun les accès nécessaires.",
    "workspace.members.enter_name_email": "Saisissez le nom du membre et son adresse e-mail.",
    "Enter a member name and email address.": "Saisissez le nom du membre et son adresse e-mail.",
    "workspace.members.invitation_sent": "Invitation envoyée.",
    "Invitation sent.": "Invitation envoyée.",
    "workspace.members.confirm_remove": "Retirer {name} de cet espace de travail ?",
    "Remove {name} from this workspace?": "Retirer {name} de cet espace de travail ?",
    "workspace.members.removed": "Membre de l’équipe retiré.",
    "Team member removed.": "Membre de l’équipe retiré.",
    "workspace.members.roles_saved": "Rôles du membre enregistrés.",
    "Member roles saved.": "Rôles du membre enregistrés.",
    "workspace.members.read": "Lecture",
    "Read": "Lecture",
    "workspace.members.write": "Écriture",
    "Write": "Écriture",
    "workspace.members.delete": "Supprimer",
    "workspace.members.select_all_permission": "Tout sélectionner pour {permission} dans {group}",
    "Select all {permission} in {group}": "Tout sélectionner pour {permission} dans {group}",
    "workspace.members.member_name": "Nom du membre",
    "Member Name": "Nom du membre",
    "workspace.members.email_address": "Adresse e-mail",
    "Email Address": "Adresse e-mail",
    "workspace.members.sending": "Envoi…",
    "Sending…": "Envoi…",
    "workspace.members.send_invitation": "Envoyer l’invitation",
    "Send invitation": "Envoyer l’invitation",
    "workspace.members.team_members": "Membres de l’équipe",
    "Team members": "Membres de l’équipe",
    "workspace.members.search_members": "Rechercher des membres",
    "Search members": "Rechercher des membres",
    "workspace.members.search": "Rechercher",
    "workspace.members.member": "Membre",
    "Member": "Membre",
    "workspace.members.email": "E-mail",
    "workspace.members.status": "Statut",
    "workspace.members.actions": "Actions",
    "workspace.members.unnamed": "Membre sans nom",
    "Unnamed member": "Membre sans nom",
    "workspace.members.roles": "Rôles",
    "Roles": "Rôles",
    "workspace.members.empty": "Aucun membre de l’équipe trouvé.",
    "No team members found.": "Aucun membre de l’équipe trouvé.",
    "workspace.members.page_of": "Page {page} sur {pages}",
    "Page {page} of {pages}": "Page {page} sur {pages}",
    "workspace.members.assign_roles": "Attribuer des rôles",
    "Assign roles": "Attribuer des rôles",
    "workspace.members.save_roles": "Enregistrer les rôles",
    "Save roles": "Enregistrer les rôles",
    "workspace.members.saving": "Enregistrement…",
    "Saving…": "Enregistrement…",
    "workspace.error.generic": "Une erreur s’est produite. Veuillez réessayer.",
    "Something went wrong. Please try again.": "Une erreur s’est produite. Veuillez réessayer.",
    "workspace.billing.view_label": "Vue de facturation de l’espace de travail",
    "Billing workspace view": "Vue de facturation de l’espace de travail",
    "workspace.billing.tab_usage": "Utilisation",
    "Usage": "Utilisation",
    "workspace.billing.tab_plans": "Forfaits",
    "workspace.billing.tab_invoices": "Factures payées",
    "Paid invoices": "Factures payées",
    "workspace.billing.tab_account": "Compte",
    "Account": "Compte",
    "workspace.account.title": "Paramètres de l’entreprise",
    "Business Settings": "Paramètres de l’entreprise",
    "workspace.account.description": "Gérez le profil de votre entreprise, ses produits activés et la confidentialité du compte.",
    "Manage your business profile, enabled products, and account privacy.": "Gérez le profil de votre entreprise, ses produits activés et la confidentialité du compte.",
    "workspace.account.profile_updated": "Profil de l’entreprise mis à jour.",
    "Business profile updated.": "Profil de l’entreprise mis à jour.",
    "workspace.account.logo_updated": "Logo mis à jour.",
    "Logo updated.": "Logo mis à jour.",
    "workspace.account.logo_upload_error": "Impossible de téléverser le logo.",
    "Unable to upload logo.": "Impossible de téléverser le logo.",
    "workspace.account.confirm_delete": "Supprimer définitivement ce compte Tradly ? Cette action est irréversible.",
    "Delete this Tradly account permanently? This cannot be undone.": "Supprimer définitivement ce compte Tradly ? Cette action est irréversible.",
    "workspace.account.business_profile": "Profil de l’entreprise",
    "Business Profile": "Profil de l’entreprise",
    "workspace.account.logo": "Logo",
    "Logo": "Logo",
    "workspace.account.logo_alt": "Logo de l’entreprise",
    "Business logo": "Logo de l’entreprise",
    "workspace.account.add_photo": "Ajouter une photo",
    "Add photo": "Ajouter une photo",
    "workspace.account.logo_formats": "PNG, JPG, SVG ou ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG ou ICO",
    "workspace.account.business_name": "Nom de l’entreprise",
    "Business Name": "Nom de l’entreprise",
    "workspace.account.contact_name": "Nom du contact de l’entreprise",
    "Business Contact Name": "Nom du contact de l’entreprise",
    "workspace.account.business_address": "Adresse de l’entreprise",
    "Business Address": "Adresse de l’entreprise",
    "workspace.account.products_of_interest": "Produits qui vous intéressent",
    "Products of Interest": "Produits qui vous intéressent",
    "workspace.account.marketplace": "Place de marché",
    "workspace.account.single_store": "Commerce à boutique unique",
    "Single Store Commerce": "Commerce à boutique unique",
    "workspace.account.alacarte_products": "Produits à la carte",
    "À la carte Products": "Produits à la carte",
    "workspace.account.alacarte_description": "Les produits activés individuellement pour cet espace se gèrent dans Offres et facturation.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Les produits activés individuellement pour cet espace se gèrent dans Offres et facturation.",
    "workspace.account.manage_alacarte": "Gérer les produits à la carte",
    "Manage à la carte products": "Gérer les produits à la carte",
    "workspace.account.delete_irreversible": "Supprimer votre compte : action irréversible",
    "Delete your Account: Irreversible": "Supprimer votre compte : action irréversible",
    "workspace.account.delete_description": "Cette action supprime définitivement l’espace Tradly et toutes les données associées.",
    "This permanently deletes the Tradly tenant and all associated data.": "Cette action supprime définitivement l’espace Tradly et toutes les données associées.",
    "workspace.account.deleting": "Suppression…",
    "Deleting…": "Suppression…",
    "workspace.account.delete_button": "Supprimer le compte Tradly",
    "Delete Account With Tradly": "Supprimer le compte Tradly",
    "workspace.privacy.title": "Confidentialité et sous-traitants",
    "Privacy & Data Processors": "Confidentialité et sous-traitants",
    "workspace.privacy.description": "Découvrez les sous-traitants de Tradly et les règles de conservation après une demande de suppression.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Découvrez les sous-traitants de Tradly et les règles de conservation après une demande de suppression.",
    "workspace.privacy.processor_retention": "Nous utilisons les sous-traitants et outils suivants pour exploiter le service, améliorer le produit, gérer la facturation et assurer sa fiabilité. Cette durée de conservation ne s’applique qu’après une demande de suppression du compte. Les données utilisateur de la plateforme Tradly sont conservées environ 90 à 180 jours selon les besoins opérationnels et réglementaires.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Nous utilisons les sous-traitants et outils suivants pour exploiter le service, améliorer le produit, gérer la facturation et assurer sa fiabilité. Cette durée de conservation ne s’applique qu’après une demande de suppression du compte. Les données utilisateur de la plateforme Tradly sont conservées environ 90 à 180 jours selon les besoins opérationnels et réglementaires.",
    "workspace.privacy.read_more": "En savoir plus.",
    "Read more.": "En savoir plus.",
    "workspace.privacy.tool": "Outil",
    "Tool": "Outil",
    "workspace.privacy.purpose": "Finalité",
    "Purpose": "Finalité",
    "workspace.privacy.data_category": "Catégorie de données",
    "Data Category": "Catégorie de données",
    "workspace.privacy.deletion_requests": "Suppression du compte et demandes de données",
    "Account deletion and data requests": "Suppression du compte et demandes de données",
    "workspace.privacy.deletion_description": "Pour demander la suppression du compte ou le retrait d’un outil de gestion de la relation client, contactez l’administrateur de votre espace ou le support. Ces actions nécessitent une confirmation du serveur avant d’être proposées ici.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Pour demander la suppression du compte ou le retrait d’un outil de gestion de la relation client, contactez l’administrateur de votre espace ou le support. Ces actions nécessitent une confirmation du serveur avant d’être proposées ici.",
    "workspace.privacy.open_account": "Ouvrir les paramètres du compte",
    "Open account settings": "Ouvrir les paramètres du compte",
    "workspace.privacy.core_operations": "Fonctionnement principal du produit",
    "Core product operations": "Fonctionnement principal du produit",
    "workspace.privacy.user_data_retention": "Données utilisateur (conservation : 90 à 180 jours)",
    "User data (retention: 90–180 days)": "Données utilisateur (conservation : 90 à 180 jours)",
    "workspace.privacy.crm_support_lifecycle": "CRM, assistance et communications de suivi",
    "CRM, support, lifecycle communication": "CRM, assistance et communications de suivi",
    "workspace.privacy.personal_data": "Données personnelles",
    "Personal data": "Données personnelles",
    "workspace.privacy.product_analytics": "Analyses produit et parcours d’engagement",
    "Product analytics and engagement funnels": "Analyses produit et parcours d’engagement",
    "workspace.privacy.usage_events": "Analyses d’utilisation et d’événements",
    "Usage and event analytics": "Analyses d’utilisation et d’événements",
    "workspace.privacy.billing_payments": "Facturation et traitement des paiements",
    "Billing and payment processing": "Facturation et traitement des paiements",
    "workspace.privacy.billing_data": "Données de facturation",
    "Billing data": "Données de facturation",
    "workspace.privacy.traffic_analytics": "Analyses du trafic et des comportements",
    "Traffic and behavior analytics": "Analyses du trafic et des comportements",
    "workspace.privacy.usage_analytics": "Analyses d’utilisation",
    "Usage analytics": "Analyses d’utilisation",
    "workspace.privacy.session_diagnostics": "Analyses de session et diagnostic des boutons défectueux",
    "Session insights and broken-button diagnostics": "Analyses de session et diagnostic des boutons défectueux",
    "workspace.privacy.ux_telemetry": "Télémétrie UX et de session",
    "UX/session telemetry": "Télémétrie UX et de session",
    "workspace.privacy.error_monitoring": "Surveillance des erreurs et de la stabilité du code",
    "Code error and stability monitoring": "Surveillance des erreurs et de la stabilité du code",
    "workspace.privacy.error_logs": "Journaux d’erreurs et diagnostics",
    "Error logs and diagnostics": "Journaux d’erreurs et diagnostics",
    "workspace.privacy.email_delivery": "Envoi d’e-mails transactionnels",
    "Transactional email delivery": "Envoi d’e-mails transactionnels",
    "workspace.privacy.email_metadata": "Métadonnées des e-mails",
    "Email metadata": "Métadonnées des e-mails",
    "workspace.privacy.hosting_infrastructure": "Hébergement et infrastructure",
    "Hosting and infrastructure": "Hébergement et infrastructure",
    "workspace.privacy.infrastructure_logs": "Journaux d’infrastructure et de service",
    "Infrastructure and service logs": "Journaux d’infrastructure et de service",
    "workspace.domain.title": "Domaines",
    "Domains": "Domaines",
    "workspace.domain.description": "Connectez votre domaine pour remplacer l’adresse Tradly hébergée par défaut.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Connectez votre domaine pour remplacer l’adresse Tradly hébergée par défaut.",
    "workspace.domain.invalid": "Saisissez un domaine valide, par exemple example.com.",
    "Enter a valid domain, such as example.com.": "Saisissez un domaine valide, par exemple example.com.",
    "workspace.domain.reserved": "tradly.co est réservé aux domaines hébergés des espaces de travail.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co est réservé aux domaines hébergés des espaces de travail.",
    "workspace.domain.missing_primary": "Aucun domaine principal n’est disponible pour cet espace de travail.",
    "No primary workspace domain is available.": "Aucun domaine principal n’est disponible pour cet espace de travail.",
    "workspace.domain.saved": "Domaine personnalisé enregistré. Mettez à jour vos enregistrements DNS, puis actualisez son état.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Domaine personnalisé enregistré. Mettez à jour vos enregistrements DNS, puis actualisez son état.",
    "workspace.domain.reset_success": "Le domaine a été réinitialisé à l’adresse hébergée par Tradly.",
    "Domain reset to the Tradly-hosted URL.": "Le domaine a été réinitialisé à l’adresse hébergée par Tradly.",
    "workspace.domain.current": "DOMAINE ACTUEL",
    "CURRENT DOMAIN": "DOMAINE ACTUEL",
    "workspace.domain.hosted": "Domaine hébergé par Tradly",
    "Tradly-hosted domain": "Domaine hébergé par Tradly",
    "workspace.domain.dns_status": "État DNS : {status}",
    "DNS status: {status}": "État DNS : {status}",
    "workspace.domain.checking": "Vérification de l’état DNS…",
    "Checking DNS status…": "Vérification de l’état DNS…",
    "workspace.domain.refresh": "Actualiser l’état",
    "Refresh status": "Actualiser l’état",
    "workspace.domain.reset": "Réinitialiser le domaine",
    "Reset domain": "Réinitialiser le domaine",
    "workspace.domain.connect_title": "Connecter un domaine personnalisé",
    "Connect a custom domain": "Connecter un domaine personnalisé",
    "workspace.domain.connect_description": "Saisissez un domaine que vous possédez. Les enregistrements DNS nécessaires s’afficheront.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Saisissez un domaine que vous possédez. Les enregistrements DNS nécessaires s’afficheront.",
    "workspace.domain.saving": "Enregistrement…",
    "workspace.domain.add": "Ajouter un domaine",
    "Add domain": "Ajouter un domaine",
    "workspace.domain.dns_title": "Configuration DNS",
    "DNS setup": "Configuration DNS",
    "workspace.domain.a_record": "Enregistrement A",
    "A record": "Enregistrement A",
    "workspace.domain.root_description": "À utiliser pour un domaine racine, tel que",
    "Use this for a root domain such as": "À utiliser pour un domaine racine, tel que",
    "workspace.domain.cname_record": "Enregistrement CNAME",
    "CNAME record": "Enregistrement CNAME",
    "workspace.domain.subdomain_description": "À utiliser pour un sous-domaine, tel que",
    "Use this for a subdomain such as": "À utiliser pour un sous-domaine, tel que",
    "workspace.domain.host": "Hôte",
    "Host": "Hôte",
    "workspace.domain.value": "Valeur",
    "Value": "Valeur",
    "workspace.domain.need_domain": "Besoin d’un domaine ?",
    "Need a domain?": "Besoin d’un domaine ?",
    "workspace.domain.buy_domain": "Achetez un domaine auprès de Google Domains ou GoDaddy, puis revenez le connecter ici.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Achetez un domaine auprès de Google Domains ou GoDaddy, puis revenez le connecter ici.",
    "workspace.billing.title": "Facturation et utilisation",
    "Billing & Usage": "Facturation et utilisation",
    "workspace.billing.description": "Gérez les offres, l’utilisation et la facturation de l’espace de travail.",
    "Manage workspace plans, usage, and billing.": "Gérez les offres, l’utilisation et la facturation de l’espace de travail.",
    "workspace.billing.invoice_description": "Gérez les offres, l’utilisation et les factures payées de l’espace de travail.",
    "Manage workspace plans, usage, and paid invoices.": "Gérez les offres, l’utilisation et les factures payées de l’espace de travail.",
    "workspace.billing.usage_description": "Consultez l’utilisation actuelle et les limites de cet espace de travail.",
    "workspace.invoices.loading": "Chargement des factures…",
    "Loading invoices…": "Chargement des factures…",
    "workspace.invoices.description": "Téléchargez vos factures ou réglez un solde restant dû.",
    "Download invoices or complete payment for an outstanding balance.": "Téléchargez vos factures ou réglez un solde restant dû.",
    "workspace.invoices.payment_failed": "Le paiement a échoué : l’accès au service peut être affecté.",
    "Payment failed — service access may be affected.": "Le paiement a échoué : l’accès au service peut être affecté.",
    "workspace.invoices.awaiting_payment": "La facture {invoice} est en attente de paiement.",
    "Invoice {invoice} is awaiting payment.": "La facture {invoice} est en attente de paiement.",
    "workspace.invoices.outstanding": "impayée",
    "outstanding": "impayée",
    "workspace.invoices.pay_invoice": "Payer la facture",
    "Pay invoice": "Payer la facture",
    "workspace.invoices.invoice": "Facture",
    "workspace.invoices.date": "Date",
    "workspace.invoices.amount": "Montant",
    "workspace.invoices.paid": "Payée",
    "workspace.invoices.unpaid": "Impayée",
    "workspace.invoices.download_invoice": "Télécharger la facture",
    "Download invoice": "Télécharger la facture",
    "workspace.invoices.empty_title": "Aucune facture disponible",
    "No invoices available": "Aucune facture disponible",
    "workspace.invoices.empty_description": "Les factures sont créées après votre abonnement et votre paiement. Contactez l’assistance si vous avez des questions.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Les factures sont créées après votre abonnement et votre paiement. Contactez l’assistance si vous avez des questions.",
    "workspace.plans.heading": "Forfaits",
    "workspace.plans.tab_marketplace": "Place de marché",
    "workspace.plans.tab_marketplace_description": "Multi-vendeurs",
    "Multi-vendor": "Multi-vendeurs",
    "workspace.plans.tab_single": "Boutique unique",
    "Single Store": "Boutique unique",
    "workspace.plans.tab_single_description": "Indépendants et créateurs",
    "Indie & Creators": "Indépendants et créateurs",
    "workspace.plans.tab_alacarte": "À la carte",
    "A la carte": "À la carte",
    "workspace.plans.tab_alacarte_description": "Crédits et options",
    "Credits & add-ons": "Crédits et options",
    "workspace.plans.tab_services": "Services",
    "Services": "Services",
    "workspace.plans.tab_services_description": "Services complémentaires",
    "Additional services": "Services complémentaires",
    "workspace.plans.selected": "Sélectionné",
    "Selected": "Sélectionné",
    "workspace.plans.try_again": "Réessayer",
    "Try again": "Réessayer",
    "workspace.plans.bill_yearly": "Facturation annuelle",
    "Bill Yearly": "Facturation annuelle",
    "workspace.plans.bill_monthly": "Facturation mensuelle",
    "Bill Monthly": "Facturation mensuelle",
    "workspace.plans.compare": "Comparer les offres",
    "Compare Plans": "Comparer les offres",
    "workspace.plans.community": "Communauté",
    "workspace.plans.community_description": "Gratuit à vie. Idéal pour les passionnés et les projets communautaires.",
    "Free forever. Perfect for hobbyists and community projects.": "Gratuit à vie. Idéal pour les passionnés et les projets communautaires.",
    "workspace.plans.different_configurations": "Vous recherchez une configuration différente ?",
    "Looking for different configurations?": "Vous recherchez une configuration différente ?",
    "workspace.plans.contact_us": "Nous contacter",
    "Contact Us": "Nous contacter",
    "workspace.plans.see_alacarte_pricing": "Voir les tarifs à la carte",
    "See à la carte pricing": "Voir les tarifs à la carte",
    "workspace.plans.available": "Disponible",
    "Available": "Disponible",
    "workspace.plans.used_90d": "Utilisés (90 j)",
    "Used (90d)": "Utilisés (90 j)",
    "workspace.plans.expired_90d": "Expirés (90 j)",
    "Expired (90d)": "Expirés (90 j)",
    "workspace.plans.expires_on": "Expire le {date}",
    "Expires {date}": "Expire le {date}",
    "workspace.plans.top_up_credits": "Recharger les crédits",
    "Top Up Credits": "Recharger les crédits",
    "workspace.plans.credits_description": "Les crédits alimentent les e-mails, la recherche IA, les recommandations et les actions des agents. 100 crédits = 5 $.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Les crédits alimentent les e-mails, la recherche IA, les recommandations et les actions des agents. 100 crédits = 5 $.",
    "workspace.plans.credits": "crédits",
    "credits": "crédits",
    "workspace.plans.custom_amount": "Montant personnalisé",
    "Custom amount": "Montant personnalisé",
    "workspace.plans.amount_example": "ex. 2500",
    "e.g. 2500": "ex. 2500",
    "workspace.plans.opening_checkout": "Ouverture du paiement…",
    "Opening checkout…": "Ouverture du paiement…",
    "workspace.plans.buy_credits": "Acheter {count} crédits",
    "Buy {count} credits": "Acheter {count} crédits",
    "workspace.plans.select_amount": "Sélectionner un montant",
    "Select an amount": "Sélectionner un montant",
    "workspace.plans.alacarte_products": "Produits à la carte",
    "A la carte Products": "Produits à la carte",
    "workspace.plans.products_description": "Sélectionnez les produits que vous utilisez pour personnaliser votre expérience. Leur utilisation est réglée avec des crédits.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Sélectionnez les produits que vous utilisez pour personnaliser votre expérience. Leur utilisation est réglée avec des crédits.",
    "workspace.plans.enabled": "Activé",
    "workspace.plans.enable": "Activer",
    "Enable": "Activer",
    "workspace.plans.open_here": "Ouvrir ici",
    "Open here": "Ouvrir ici",
    "workspace.plans.open_marketing": "Ouvrir marketing.tradly.app",
    "Open marketing.tradly.app": "Ouvrir marketing.tradly.app",
    "workspace.plans.open_analytics": "Ouvrir analytics.tradly.app",
    "Open analytics.tradly.app": "Ouvrir analytics.tradly.app",
    "workspace.plans.open_external": "Ouvrir le site externe",
    "Open external": "Ouvrir le site externe",
    "workspace.plans.coming_soon": "Bientôt disponible",
    "Coming soon": "Bientôt disponible",
    "workspace.plans.services_title": "Configuration ponctuelle et services personnalisés",
    "One-Time Setup & Custom Services": "Configuration ponctuelle et services personnalisés",
    "workspace.plans.service_app_launch": "Lancement d’une application en marque blanche",
    "White-Label App Launch": "Lancement d’une application en marque blanche",
    "workspace.plans.service_frontend": "Personnalisation de l’interface",
    "Frontend Customization": "Personnalisation de l’interface",
    "workspace.plans.service_multilanguage": "Prise en charge multilingue",
    "Multi-Language Support": "Prise en charge multilingue",
    "workspace.plans.view_docs": "Voir la documentation",
    "View Docs": "Voir la documentation",
    "workspace.plans.confirm_change": "Confirmer le changement d’offre",
    "Confirm your plan change": "Confirmer le changement d’offre",
    "workspace.plans.confirm_charge": "Les frais sont prépayés et facturés à la date de votre abonnement.",
    "Charges are prepaid and billed on your subscription date.": "Les frais sont prépayés et facturés à la date de votre abonnement.",
    "workspace.plans.confirm_promo": "Les codes promotionnels peuvent être saisis lors du paiement Stripe, lorsqu’ils sont disponibles.",
    "Promotional codes can be entered during Stripe checkout where available.": "Les codes promotionnels peuvent être saisis lors du paiement Stripe, lorsqu’ils sont disponibles.",
    "workspace.plans.confirm_delay": "Le changement d’offre peut prendre un peu de temps avant d’apparaître dans votre espace.",
    "Plan changes may take a moment to appear in your workspace.": "Le changement d’offre peut prendre un peu de temps avant d’apparaître dans votre espace.",
    "workspace.plans.payment_active": "Paiement reçu. Votre offre est active.",
    "Payment received. Your plan is active.": "Paiement reçu. Votre offre est active.",
    "workspace.plans.payment_method_updated": "Moyen de paiement mis à jour.",
    "Payment method updated.": "Moyen de paiement mis à jour.",
    "workspace.plans.payment_cancelled": "Le paiement n’a pas abouti ; votre offre n’a pas changé.",
    "Payment was not completed, so your plan has not changed.": "Le paiement n’a pas abouti ; votre offre n’a pas changé.",
    "workspace.plans.activating": "Paiement reçu. Activation de votre offre…",
    "Payment received. Activating your plan…": "Paiement reçu. Activation de votre offre…",
    "workspace.plans.activation_delayed": "Paiement reçu. L’activation de votre offre prend plus de temps que prévu. Actualisez la page dans une minute.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Paiement reçu. L’activation de votre offre prend plus de temps que prévu. Actualisez la page dans une minute.",
    "workspace.plans.card_saved": "Carte enregistrée et abonnement mis à jour.",
    "Card saved and subscription updated.": "Carte enregistrée et abonnement mis à jour.",
    "workspace.plans.subscription_updated": "Abonnement mis à jour.",
    "Subscription updated.": "Abonnement mis à jour.",
    "workspace.plans.products_saved": "Produits à la carte enregistrés.",
    "À la carte products saved.": "Produits à la carte enregistrés.",
    "workspace.plans.minimum_credits": "Saisissez au moins 100 crédits.",
    "Enter at least 100 credits.": "Saisissez au moins 100 crédits.",
    "workspace.plans.credit_topup_description": "Recharge de crédits ({count} crédits)",
    "Credit Top-Up ({count} credits)": "Recharge de crédits ({count} crédits)",
    "workspace.plans.billing_details": "Détails de facturation actuels",
    "Current billing details": "Détails de facturation actuels",
    "workspace.plans.current_plan": "Offre actuelle",
    "Current Plan": "Offre actuelle",
    "workspace.plans.renews": "Renouvellement",
    "Renews": "Renouvellement",
    "workspace.plans.payment_method": "Moyen de paiement",
    "Payment method": "Moyen de paiement",
    "workspace.plans.opening": "Ouverture…",
    "Opening…": "Ouverture…",
    "workspace.plans.manage_payment_method": "Gérer le moyen de paiement",
    "Manage payment method": "Gérer le moyen de paiement",
    "workspace.plans.upgrade": "Passer à une offre supérieure",
    "workspace.plans.downgrade": "Passer à une offre inférieure",
    "Downgrade": "Passer à une offre inférieure",
    "workspace.plans.custom_price": "Sur mesure",
    "workspace.plans.per_month_short": "/mois",
    "/month": "/mois",
    "workspace.plans.per_year_amount": "par an ({amount})",
    "per year ({amount})": "par an ({amount})",
    "workspace.plans.per_month_amount": "par mois ({amount})",
    "per month ({amount})": "par mois ({amount})",
    "workspace.plans.yearly_savings": "Économisez {amount} par an",
    "Save {amount} yearly": "Économisez {amount} par an",
    "workspace.plans.billed_yearly": "facturé annuellement",
    "billed yearly": "facturé annuellement",
    "workspace.plans.billed_monthly": "facturé mensuellement",
    "billed monthly": "facturé mensuellement",
    "workspace.plans.free_trial": "Vous bénéficiez d’une période d’essai gratuite.",
    "You are on a free trial.": "Vous bénéficiez d’une période d’essai gratuite.",
    "workspace.plans.updating": "Mise à jour…",
    "Updating…": "Mise à jour…",
    "workspace.plans.temporarily_unavailable": "Temporairement indisponible",
    "Temporarily unavailable": "Temporairement indisponible",
    "workspace.plans.whats_included": "Inclus dans l’offre",
    "What's included": "Inclus dans l’offre",
    "workspace.plans.products.auth.title": "Authentification",
    "Auth": "Authentification",
    "workspace.plans.products.auth.description": "Identité, authentification unique, autorisations et gestion des utilisateurs.",
    "Identity, SSO, permissions, and user management.": "Identité, authentification unique, autorisations et gestion des utilisateurs.",
    "workspace.plans.products.email.title": "E-mail",
    "workspace.plans.products.email.description": "E-mails transactionnels et marketing intégrés.",
    "Transactional and marketing email, built in.": "E-mails transactionnels et marketing intégrés.",
    "workspace.plans.products.analytics.title": "Analyses",
    "Analytics": "Analyses",
    "workspace.plans.products.analytics.description": "Analyses gratuites pour le web, les applications et les agents.",
    "Free analytics for web, app, and agents.": "Analyses gratuites pour le web, les applications et les agents.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "Un CRM qui se met à jour à partir de l’activité des utilisateurs.",
    "A CRM that fills itself from user activity.": "Un CRM qui se met à jour à partir de l’activité des utilisateurs.",
    "workspace.plans.products.subscription.title": "Abonnements",
    "Subscriptions": "Abonnements",
    "workspace.plans.products.subscription.description": "Facturation récurrente, périodes d’essai et relances gérées.",
    "Recurring billing, trials, and dunning — handled.": "Facturation récurrente, périodes d’essai et relances gérées.",
    "workspace.plans.products.recommendation.title": "Recommandations",
    "Recommendations": "Recommandations",
    "workspace.plans.products.recommendation.description": "Proposez à chaque utilisateur les contenus qui lui correspondent.",
    "Show each user what they will actually want.": "Proposez à chaque utilisateur les contenus qui lui correspondent.",
    "workspace.plans.marketplace.2025-superstarter.title": "Essentiel",
    "Basic": "Essentiel",
    "workspace.plans.marketplace.2025-superstarter.description": "Idéal pour les petites équipes. Toutes les fonctionnalités Communauté, avec une marque blanche qui supprime le badge « Built with Tradly ».",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Idéal pour les petites équipes. Toutes les fonctionnalités Communauté, avec une marque blanche qui supprime le badge « Built with Tradly ».",
    "workspace.plans.marketplace.2025-superstarter.button": "Commencer l’essai de 7 jours",
    "Start 7 Days Trial": "Commencer l’essai de 7 jours",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Aucun frais de transaction",
    "No transaction fee": "Aucun frais de transaction",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Site web Tradly hébergé gratuit",
    "Free Tradly hosted website": "Site web Tradly hébergé gratuit",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Ajouter votre domaine personnalisé",
    "Add your custom domain": "Ajouter votre domaine personnalisé",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Éditeur : historique des pages sur 3 jours",
    "Editor - 3 Day page history": "Éditeur : historique des pages sur 3 jours",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Pour les jeunes entreprises qui valident leur idée. Comprend l’essentiel pour tester le marché et acquérir les premiers clients.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Pour les jeunes entreprises qui valident leur idée. Comprend l’essentiel pour tester le marché et acquérir les premiers clients.",
    "workspace.plans.marketplace.2025-starter.button": "Commencer l’essai de 7 jours",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Aucun frais de transaction",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Attributs personnalisés illimités",
    "Unlimited Custom Attributes": "Attributs personnalisés illimités",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "Historique des pages sur 30 jours",
    "30 Day page history": "Historique des pages sur 30 jours",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Abonnement avec accès conditionnel",
    "Gated Subscription": "Abonnement avec accès conditionnel",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Connexion via les réseaux sociaux",
    "Social Logins": "Connexion via les réseaux sociaux",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhooks",
    "Webhooks": "Webhooks",
    "workspace.plans.marketplace.2025-growth.title": "Croissance",
    "Growth": "Croissance",
    "workspace.plans.marketplace.2025-growth.description": "Pour les idées éprouvées qui passent à la croissance, avec des besoins spécifiques et des intégrations supplémentaires.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Pour les idées éprouvées qui passent à la croissance, avec des besoins spécifiques et des intégrations supplémentaires.",
    "workspace.plans.marketplace.2025-growth.button": "Commencer l’essai de 7 jours",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Aucun frais de transaction",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Adresse e-mail d’expédition personnalisée",
    "Custom 'From Email'": "Adresse e-mail d’expédition personnalisée",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Outils et intégrations supplémentaires",
    "Additional Mini Tools & Integrations": "Outils et intégrations supplémentaires",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Appels d’accompagnement personnalisés*",
    "Personalised Onboarding calls*": "Appels d’accompagnement personnalisés*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "Historique des pages sur 90 jours",
    "90 Day page history": "Historique des pages sur 90 jours",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Devises et langues multiples",
    "Multi Currencies & Multi Languages": "Devises et langues multiples",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Contrôle d’accès basé sur les rôles (RBAC)",
    "Role-based access control (RBAC)": "Contrôle d’accès basé sur les rôles (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Messagerie intégrée aux applications",
    "Inbuilt Chat for Apps": "Messagerie intégrée aux applications",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Pour les entreprises en croissance qui recherchent une solution sur mesure et des fonctionnalités spécifiques.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Pour les entreprises en croissance qui recherchent une solution sur mesure et des fonctionnalités spécifiques.",
    "workspace.plans.marketplace.2025-scale.button": "Commencer l’essai de 7 jours",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Aucun frais de transaction",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Assistance prioritaire",
    "Priority Support": "Assistance prioritaire",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Plusieurs canaux (assistance applicative)",
    "Multiple Channels (App Support)": "Plusieurs canaux (assistance applicative)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Authentification unique (SSO)",
    "Single Sign-on (SSO)": "Authentification unique (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Historique des pages illimité",
    "Unlimited page history": "Historique des pages illimité",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Messagerie intégrée aux applications",
    "In-built Chat for Apps": "Messagerie intégrée aux applications",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Tout ce qu’il faut à une boutique en croissance : supprimer la marque, ajouter un domaine et débloquer des outils.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Tout ce qu’il faut à une boutique en croissance : supprimer la marque, ajouter un domaine et débloquer des outils.",
    "workspace.plans.indie.go.button": "Commencer l’essai de 7 jours",
    "Start 7-day trial": "Commencer l’essai de 7 jours",
    "workspace.plans.indie.go.feature_1.title": "Sans marque Tradly",
    "No Tradly branding": "Sans marque Tradly",
    "workspace.plans.indie.go.feature_2.title": "Domaine personnalisé",
    "Custom domain": "Domaine personnalisé",
    "workspace.plans.indie.go.feature_3.title": "Produits illimités",
    "Unlimited products": "Produits illimités",
    "workspace.plans.indie.go.feature_4.title": "Campagnes e-mail",
    "Email campaigns": "Campagnes e-mail",
    "workspace.plans.indie.go.feature_5.title": "Recommandations IA",
    "AI Recommendations": "Recommandations IA",
    "workspace.plans.indie.go.feature_6.title": "Assistance par tickets",
    "Ticket-based support": "Assistance par tickets",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Suite complète d’IA, marketing avancé et toutes les fonctionnalités pour les boutiques qui visent la croissance.",
    "workspace.plans.indie.genius.button": "Commencer l’essai de 7 jours",
    "workspace.plans.indie.genius.feature_1.title": "Tout ce qui est inclus dans Pro",
    "Everything in Pro": "Tout ce qui est inclus dans Pro",
    "workspace.plans.indie.genius.feature_2.title": "Agents IA (assistant d’achat, etc.)",
    "AI Agents (Shopping Assistant, etc.)": "Agents IA (assistant d’achat, etc.)",
    "workspace.plans.indie.genius.feature_3.title": "Recherche en langage naturel",
    "Natural language search": "Recherche en langage naturel",
    "workspace.plans.indie.genius.feature_4.title": "Automatisation avancée des e-mails",
    "Advanced email automation": "Automatisation avancée des e-mails",
    "workspace.plans.indie.genius.feature_5.title": "Demandes de recommandations illimitées",
    "Unlimited recommendation requests": "Demandes de recommandations illimitées",
    "workspace.plans.indie.genius.feature_6.title": "Assistance par tickets",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Frais d’abonnement pour permettre aux utilisateurs d’ouvrir des comptes et de publier des annonces.",
    "Subscription charges for people to open accounts & submit listings": "Frais d’abonnement pour permettre aux utilisateurs d’ouvrir des comptes et de publier des annonces.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Inscription ou connexion avec Google et Meta.",
    "Signup/in via Google, Meta": "Inscription ou connexion avec Google et Meta.",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Pour se connecter à Zapier et Make.",
    "To connect with Zapier & Make": "Pour se connecter à Zapier et Make.",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Messagerie native intégrée à l’application pour vos utilisateurs.",
    "Native in-app messaging for your users": "Messagerie native intégrée à l’application pour vos utilisateurs.",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Délai de réponse de 24 heures pour les demandes non critiques.",
    "24 hour response time for non-critical": "Délai de réponse de 24 heures pour les demandes non critiques.",
    "common.continue": "Continuer",
    "Continue": "Continuer",
    "workspace.plans.free_plan": "Gratuit",
    "Free": "Gratuit",
    "workspace.usage.group_platform": "Plateforme et espace de travail",
    "Platform & workspace": "Plateforme et espace de travail",
    "workspace.usage.group_ai": "IA et utilisation",
    "AI & usage": "IA et utilisation",
    "workspace.usage.group_storage": "Contenu et stockage",
    "Content & storage": "Contenu et stockage",
    "workspace.usage.group_alacarte": "À la carte",
    "workspace.usage.accounts": "Comptes",
    "workspace.usage.listings": "Annonces",
    "workspace.usage.sites": "Sites de l’espace de travail",
    "Sites under workspace": "Sites de l’espace de travail",
    "workspace.usage.external_users": "Utilisateurs externes",
    "External users": "Utilisateurs externes",
    "workspace.usage.internal_users": "Utilisateurs internes",
    "Internal users": "Utilisateurs internes",
    "workspace.usage.ai_credits": "Crédits IA",
    "AI credits": "Crédits IA",
    "workspace.usage.storage": "Stockage",
    "Storage": "Stockage",
    "workspace.usage.email": "E-mail",
    "workspace.usage.maps": "Cartes",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analyses",
    "workspace.usage.recommendations": "Recommandations",
    "workspace.usage.ai_agents": "Agents IA",
    "AI agents": "Agents IA",
    "workspace.usage.status_not_reported": "Non renseigné",
    "Not reported": "Non renseigné",
    "workspace.usage.status_nearly_full": "Presque plein",
    "Nearly full": "Presque plein",
    "workspace.usage.status_on_track": "Dans les limites",
    "On track": "Dans les limites",
    "workspace.usage.workspace_files": "Fichiers de l’espace de travail",
    "Workspace files": "Fichiers de l’espace de travail",
    "workspace.usage.workspace_usage": "Utilisation de l’espace de travail",
    "Workspace usage": "Utilisation de l’espace de travail",
    "workspace.usage.of_limit": "sur {limit}",
    "of {limit}": "sur {limit}",
    "workspace.usage.no_cap": "Aucune limite configurée",
    "No cap configured": "Aucune limite configurée",
    "workspace.usage.trend": "Tendance d’utilisation",
    "Usage trend": "Tendance d’utilisation",
    "workspace.usage.unavailable": "Les données d’utilisation sont temporairement indisponibles.",
    "Usage data is temporarily unavailable.": "Les données d’utilisation sont temporairement indisponibles.",
    "workspace.usage.loading": "Chargement de l’utilisation de l’espace de travail…",
    "Loading workspace usage…": "Chargement de l’utilisation de l’espace de travail…",
    "workspace.usage.overview": "Vue d’ensemble de l’espace de travail",
    "Workspace overview": "Vue d’ensemble de l’espace de travail",
    "workspace.usage.title": "Détail de l’utilisation",
    "Usage breakdown": "Détail de l’utilisation",
    "workspace.usage.description": "Consultez l’utilisation de votre espace et le volume restant dans votre offre actuelle.",
    "See what your workspace has used and how much room remains on your current plan.": "Consultez l’utilisation de votre espace et le volume restant dans votre offre actuelle.",
    "workspace.usage.view_plans": "Voir les offres",
    "workspace.usage.showing_available_limits": "Affichage des limites déjà disponibles dans cet espace de travail.",
    "Showing the limits that are already available in this workspace.": "Affichage des limites déjà disponibles dans cet espace de travail.",
    "workspace.usage.summary": "Résumé de l’utilisation",
    "Usage summary": "Résumé de l’utilisation",
    "workspace.usage.metrics_tracked": "Indicateurs suivis",
    "Metrics tracked": "Indicateurs suivis",
    "workspace.usage.metrics_count": "{count} sur {total}",
    "{count} of {total}": "{count} sur {total}",
    "workspace.usage.next_reset": "Prochaine réinitialisation",
    "Next reset": "Prochaine réinitialisation",
    "workspace.usage.not_provided": "Non indiqué",
    "Not provided": "Non indiqué",
    "workspace.usage.data_source": "Source des données",
    "Data source": "Source des données",
    "workspace.usage.clear_view": "Une vue claire de votre espace de travail",
    "A clear view of your workspace": "Une vue claire de votre espace de travail",
    "workspace.usage.by_resource": "Utilisation par ressource",
    "Usage by resource": "Utilisation par ressource",
    "workspace.usage.live_summary": "Résumé en direct",
    "Live summary": "Résumé en direct",
    "workspace.usage.resource": "Ressource",
    "Resource": "Ressource",
    "workspace.usage.used_limit": "Utilisé / limite",
    "Used / limit": "Utilisé / limite",
    "workspace.usage.progress": "Progression",
    "Progress": "Progression",
    "workspace.usage.cost": "Coût",
    "Cost": "Coût",
    "workspace.usage.footnote": "L’utilisation et les limites proviennent du service de l’espace de travail. Un tiret indique que l’API actuelle ne fournit pas encore cet indicateur.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "L’utilisation et les limites proviennent du service de l’espace de travail. Un tiret indique que l’API actuelle ne fournit pas encore cet indicateur.",
    "workspace.usage.refresh": "Actualiser",
    "Refresh": "Actualiser",
    "maps.title": "Cartes",
    "maps.tab.analysis": "Étude de marché",
    "Market scan": "Étude de marché",
    "maps.tab.usage": "Utilisation",
    "maps.tab.settings": "Paramètres",
    "maps.action.save": "Enregistrer",
    "maps.action.saving": "Enregistrement…",
    "maps.action.analyze_area": "Analyser la zone",
    "Analyze area": "Analyser la zone",
    "maps.action.analyzing": "Analyse…",
    "Analyzing…": "Analyse…",
    "maps.action.refresh": "Actualiser",
    "maps.action.loading": "Chargement…",
    "Loading…": "Chargement…",
    "maps.action.open_in_maps": "Ouvrir dans Maps",
    "Open in Maps": "Ouvrir dans Maps",
    "maps.analysis.title": "Explorer un marché local",
    "Explore a local market": "Explorer un marché local",
    "maps.analysis.description": "Découvrez les entreprises répertoriées par Google autour d’un lieu proposé. Cette première analyse porte sur la concurrence, pas sur la demande ni la viabilité.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Découvrez les entreprises répertoriées par Google autour d’un lieu proposé. Cette première analyse porte sur la concurrence, pas sur la demande ni la viabilité.",
    "maps.analysis.address_label": "Adresse ou localité",
    "Address or locality": "Adresse ou localité",
    "maps.analysis.address_placeholder": "Rue, quartier ou ville",
    "Street, suburb, or city": "Rue, quartier ou ville",
    "maps.analysis.category_label": "Type d’activité",
    "Business type": "Type d’activité",
    "maps.analysis.radius_label": "Rayon de recherche",
    "Search radius": "Rayon de recherche",
    "maps.analysis.places_listings": "Fiches Places",
    "Places listings": "Fiches Places",
    "maps.analysis.within_radius": "{category} dans un rayon de {radius}",
    "{category} within {radius}": "{category} dans un rayon de {radius}",
    "maps.analysis.results_description": "Les résultats sont filtrés par catégorie et par rayon, puis triés par distance.",
    "Results are filtered by category and radius, then ordered by distance.": "Les résultats sont filtrés par catégorie et par rayon, puis triés par distance.",
    "maps.analysis.result_limit_notice": "Google a renvoyé le maximum de 20 lieux. Le nombre réel peut être supérieur ; réduisez le rayon pour obtenir une analyse plus détaillée.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google a renvoyé le maximum de 20 lieux. Le nombre réel peut être supérieur ; réduisez le rayon pour obtenir une analyse plus détaillée.",
    "maps.analysis.limitations": "Les fiches peuvent être incomplètes et ne mesurent ni la demande, ni la fréquentation, ni la population, ni les loyers, ni la rentabilité. Utilisez ces données comme un élément de votre étude locale.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Les fiches peuvent être incomplètes et ne mesurent ni la demande, ni la fréquentation, ni la population, ni les loyers, ni la rentabilité. Utilisez ces données comme un élément de votre étude locale.",
    "maps.analysis.nearby_businesses": "Entreprises à proximité ({count})",
    "Nearby businesses ({count})": "Entreprises à proximité ({count})",
    "maps.analysis.businesses": "Entreprises",
    "Businesses": "Entreprises",
    "maps.analysis.no_listings": "Aucune fiche Google Maps correspondant à cette zone et à cette catégorie n’a été trouvée.",
    "No matching Google Maps listings were returned for this area and category.": "Aucune fiche Google Maps correspondant à cette zone et à cette catégorie n’a été trouvée.",
    "maps.category.retail": "Commerce de détail",
    "Retail": "Commerce de détail",
    "maps.category.grocery": "Épicerie",
    "Grocery": "Épicerie",
    "maps.category.clothing": "Vêtements",
    "Clothing": "Vêtements",
    "maps.category.pharmacy": "Pharmacie",
    "Pharmacy": "Pharmacie",
    "maps.category.restaurant": "Restaurant / café",
    "Restaurant / café": "Restaurant / café",
    "maps.competition.limited": "Peu de concurrence répertoriée",
    "Limited listed competition": "Peu de concurrence répertoriée",
    "maps.competition.some": "Quelques concurrents répertoriés",
    "Some listed competition": "Quelques concurrents répertoriés",
    "maps.competition.many": "De nombreux concurrents répertoriés",
    "Many listed competitors": "De nombreux concurrents répertoriés",
    "maps.competition.limit_reached": "Au moins 20 fiches (limite atteinte)",
    "At least 20 listings (result limit reached)": "Au moins 20 fiches (limite atteinte)",
    "maps.competition.default": "Concurrence répertoriée",
    "Listed competition": "Concurrence répertoriée",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "En activité",
    "Operational": "En activité",
    "maps.usage.title": "Utilisation du fournisseur",
    "Provider usage": "Utilisation du fournisseur",
    "maps.usage.description": "Nombre de requêtes enregistrées par le service Maps. Les frais sont rapprochés séparément.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Nombre de requêtes enregistrées par le service Maps. Les frais sont rapprochés séparément.",
    "maps.usage.days": "{count} jours",
    "{count} days": "{count} jours",
    "maps.usage.provider_requests": "Requêtes au fournisseur",
    "Provider requests": "Requêtes au fournisseur",
    "maps.usage.range_detail": "Période de {count} jours",
    "{count} day window": "Période de {count} jours",
    "maps.usage.successful": "Réussies",
    "Successful": "Réussies",
    "maps.usage.completed_calls": "Appels au fournisseur terminés",
    "Completed provider calls": "Appels au fournisseur terminés",
    "maps.usage.errors": "Erreurs",
    "Errors": "Erreurs",
    "maps.usage.failed_calls": "Appels au fournisseur échoués",
    "Failed provider calls": "Appels au fournisseur échoués",
    "maps.usage.metered_units": "Unités comptabilisées",
    "Metered units": "Unités comptabilisées",
    "maps.usage.unit_detail": "Une unité par requête enregistrée",
    "One unit per recorded request": "Une unité par requête enregistrée",
    "maps.usage.by_operation": "Utilisation par opération",
    "Usage by operation": "Utilisation par opération",
    "maps.usage.group_description": "Les nombres sont regroupés par fournisseur, opération et résultat.",
    "Counts are grouped by provider, operation, and outcome.": "Les nombres sont regroupés par fournisseur, opération et résultat.",
    "maps.usage.empty": "Aucune requête cartographique sur cette période.",
    "No map requests in this date range.": "Aucune requête cartographique sur cette période.",
    "maps.usage.provider": "Fournisseur",
    "Provider": "Fournisseur",
    "maps.usage.operation": "Opération",
    "Operation": "Opération",
    "maps.usage.outcome": "Résultat",
    "Outcome": "Résultat",
    "maps.usage.requests": "Requêtes",
    "Requests": "Requêtes",
    "maps.usage.units": "Unités",
    "Units": "Unités",
    "maps.settings.provider_title": "Fournisseur de cartes",
    "Map provider": "Fournisseur de cartes",
    "maps.settings.provider_description": "Choisissez le fournisseur autorisé par votre politique de confidentialité. Les identifiants du fournisseur sont gérés par Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Choisissez le fournisseur autorisé par votre politique de confidentialité. Les identifiants du fournisseur sont gérés par Tradly.",
    "maps.settings.selected": "Sélectionné",
    "maps.settings.available": "Disponible",
    "maps.settings.planned": "Prévu",
    "Planned": "Prévu",
    "maps.settings.origins_title": "Origines de sites autorisées",
    "Allowed website origins": "Origines de sites autorisées",
    "maps.settings.origins_description": "Les domaines enregistrés de l’espace de travail sont autorisés automatiquement. Ajoutez ici les origines exactes d’autres sites, comme un environnement de préproduction.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Les domaines enregistrés de l’espace de travail sont autorisés automatiquement. Ajoutez ici les origines exactes d’autres sites, comme un environnement de préproduction.",
    "maps.settings.registered_domains": "Domaines enregistrés",
    "Registered domains": "Domaines enregistrés",
    "maps.settings.no_domains": "Aucun domaine enregistré n’a été chargé.",
    "No registered domains were loaded.": "Aucun domaine enregistré n’a été chargé.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Ajouter une origine",
    "Add origin": "Ajouter une origine",
    "maps.settings.remove_origin": "Supprimer",
    "maps.settings.no_origins": "Aucune origine supplémentaire ajoutée.",
    "No extra origins added.": "Aucune origine supplémentaire ajoutée.",
    "maps.error.session_not_ready": "Votre session administrateur n’est pas encore prête.",
    "Your admin session is not ready yet.": "Votre session administrateur n’est pas encore prête.",
    "maps.error.load_data": "Impossible de charger les données Maps ({status}).",
    "Unable to load Maps data ({status}).": "Impossible de charger les données Maps ({status}).",
    "maps.error.load_usage": "Impossible de charger l’utilisation de Maps.",
    "Unable to load Maps usage.": "Impossible de charger l’utilisation de Maps.",
    "maps.error.load_settings": "Impossible de charger les paramètres Maps.",
    "Unable to load Maps settings.": "Impossible de charger les paramètres Maps.",
    "maps.error.save_settings": "Impossible d’enregistrer les paramètres Maps.",
    "Unable to save Maps settings.": "Impossible d’enregistrer les paramètres Maps.",
    "maps.error.invalid_origin": "Saisissez une origine complète, par exemple https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Saisissez une origine complète, par exemple https://staging.example.com.",
    "maps.error.registered_origin": "Cette origine est déjà couverte par un domaine enregistré.",
    "This origin is already covered by a registered domain.": "Cette origine est déjà couverte par un domaine enregistré.",
    "maps.error.address_required": "Saisissez une adresse ou une localité à analyser.",
    "Enter an address or locality to scan.": "Saisissez une adresse ou une localité à analyser.",
    "maps.error.location_not_found": "Impossible de trouver ce lieu.",
    "Unable to find that location.": "Impossible de trouver ce lieu.",
    "maps.error.no_coordinates": "Aucune coordonnée n’a été trouvée pour cette adresse. Essayez une rue, un quartier ou une ville à proximité.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Aucune coordonnée n’a été trouvée pour cette adresse. Essayez une rue, un quartier ou une ville à proximité.",
    "maps.error.analyze_area": "Impossible d’analyser cette zone.",
    "Unable to analyze this area.": "Impossible d’analyser cette zone.",
    "maps.notice.settings_saved": "Paramètres Maps enregistrés.",
    "Maps settings saved.": "Paramètres Maps enregistrés.",
    "maps.status.success": "Réussite",
    "maps.status.error": "Erreur",
    "maps.operation.geocode": "Géocodage",
    "Geocode": "Géocodage",
    "maps.operation.maps_geocode": "Géocodage Maps",
    "Maps geocode": "Géocodage Maps",
    "maps.operation.market_analysis": "Étude de marché",
    "Market analysis": "Étude de marché",
    "maps.operation.maps_market_analysis": "Étude de marché Maps",
    "Maps market analysis": "Étude de marché Maps",
    "maps.operation.places_search": "Recherche de lieux",
    "Places search": "Recherche de lieux",
    "maps.operation.places_nearby": "Lieux à proximité",
    "Nearby places": "Lieux à proximité",
    "maps.operation.place_details": "Détails du lieu",
    "Place details": "Détails du lieu",
    "common.loading": "Chargement…",
    "common.saving": "Enregistrement…",
    "common.searching": "Recherche…",
    "Searching…": "Recherche…",
    "common.no_matches": "Aucun résultat.",
    "No matches found.": "Aucun résultat.",
    "common.select": "Sélectionner…",
    "Select…": "Sélectionner…",
    "common.search_users": "Rechercher des utilisateurs par nom ou e-mail",
    "Search users by name or email": "Rechercher des utilisateurs par nom ou e-mail",
    "common.reset": "Réinitialiser",
    "Reset": "Réinitialiser",
    "common.validation.email": "Saisissez une adresse e-mail valide.",
    "Enter a valid email address.": "Saisissez une adresse e-mail valide.",
    "common.validation.phone": "Saisissez un numéro de téléphone valide.",
    "Enter a valid phone number.": "Saisissez un numéro de téléphone valide.",
    "common.validation.currency": "Utilisez un code de devise à 3 lettres, par exemple USD.",
    "Use a 3-letter currency code, such as USD.": "Utilisez un code de devise à 3 lettres, par exemple USD.",
    "common.validation.location": "Saisissez une adresse ou un lieu valide.",
    "Enter a valid address or location.": "Saisissez une adresse ou un lieu valide.",
    "common.validation.required": "{label} est obligatoire.",
    "{label} is required.": "{label} est obligatoire.",
    "common.validation.invalid": "{label} est invalide.",
    "{label} is invalid.": "{label} est invalide.",
    "common.status.active": "Actif",
    "common.status.inactive": "Inactif",
    "common.status.open": "Ouverte",
    "common.status.closed": "Clôturée",
    "Closed": "Clôturée",
    "common.status.posted": "Comptabilisé",
    "Posted": "Comptabilisé",
    "common.status.voided": "Annulé",
    "Voided": "Annulé",
    "common.status.draft": "Brouillon",
    "Draft": "Brouillon",
    "common.status.success": "Réussite",
    "common.status.error": "Erreur",
    "accounting.title": "Comptabilité",
    "accounting.description": "Gérez les comptes, les correspondances, les périodes, les journaux et les rapports financiers.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Gérez les comptes, les correspondances, les périodes, les journaux et les rapports financiers.",
    "accounting.tab.overview": "Vue d’ensemble",
    "Overview": "Vue d’ensemble",
    "accounting.tab.accounts": "Plan comptable",
    "Chart of accounts": "Plan comptable",
    "accounting.tab.mappings": "Correspondances de comptes",
    "Account mappings": "Correspondances de comptes",
    "accounting.tab.periods": "Périodes comptables",
    "Accounting periods": "Périodes comptables",
    "accounting.tab.journals": "Journaux",
    "Journals": "Journaux",
    "accounting.tab.reports": "Rapports",
    "accounting.account.edit_title": "Modifier le compte",
    "Edit account": "Modifier le compte",
    "accounting.account.new_title": "Nouveau compte",
    "New account": "Nouveau compte",
    "accounting.account.save": "Enregistrer le compte",
    "Save account": "Enregistrer le compte",
    "accounting.account.create": "Créer le compte",
    "Create account": "Créer le compte",
    "accounting.account.code": "Code du compte",
    "Account code": "Code du compte",
    "accounting.account.name": "Nom du compte",
    "Account name": "Nom du compte",
    "accounting.account.type": "Type de compte",
    "Account type": "Type de compte",
    "accounting.account.currency_id": "Identifiant de devise",
    "accounting.account.active": "Actif",
    "accounting.account.unnamed": "Compte sans nom",
    "Unnamed account": "Compte sans nom",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Frais de paie",
    "Payroll expense": "Frais de paie",
    "accounting.type.asset": "Actif",
    "Asset": "Actif",
    "accounting.type.liability": "Passif",
    "Liability": "Passif",
    "accounting.type.equity": "Capitaux propres",
    "Equity": "Capitaux propres",
    "accounting.type.revenue": "Revenu",
    "accounting.type.expense": "Dépense",
    "Expense": "Dépense",
    "accounting.toast.account_updated": "Compte mis à jour",
    "Account updated": "Compte mis à jour",
    "accounting.toast.account_created": "Compte créé",
    "Account created": "Compte créé",
    "accounting.toast.defaults_created": "Comptes par défaut créés",
    "Default accounts created": "Comptes par défaut créés",
    "accounting.toast.mapping_saved": "Correspondance enregistrée",
    "Mapping saved": "Correspondance enregistrée",
    "accounting.toast.period_closed": "Période comptable clôturée",
    "Accounting period closed": "Période comptable clôturée",
    "accounting.toast.period_created": "Période créée",
    "Period created": "Période créée",
    "accounting.toast.journal_created": "Journal créé",
    "Journal created": "Journal créé",
    "accounting.toast.journal_voided": "Journal annulé",
    "Journal voided": "Journal annulé",
    "accounting.validation.journal_balanced": "Le journal doit avoir une date, une description et des totaux débit/crédit équilibrés.",
    "Journal must have a date, description, and balanced debit and credit totals.": "Le journal doit avoir une date, une description et des totaux débit/crédit équilibrés.",
    "accounting.filter.all_types": "Tous les types de compte",
    "All account types": "Tous les types de compte",
    "accounting.filter.all_statuses": "Tous les statuts",
    "All statuses": "Tous les statuts",
    "accounting.action.bootstrap": "Créer les comptes par défaut",
    "Bootstrap defaults": "Créer les comptes par défaut",
    "accounting.action.new_account": "Nouveau compte",
    "accounting.empty.accounts": "Aucun compte trouvé.",
    "No accounts found.": "Aucun compte trouvé.",
    "accounting.column.code": "Code",
    "Code": "Code",
    "accounting.column.account": "Compte",
    "accounting.column.type": "Type",
    "Type": "Type",
    "accounting.column.currency": "Devise",
    "accounting.column.status": "Statut",
    "accounting.action.edit": "Modifier",
    "accounting.mapping.edit_title": "Modifier la correspondance de compte",
    "Edit account mapping": "Modifier la correspondance de compte",
    "accounting.mapping.new_title": "Nouvelle correspondance de compte",
    "New account mapping": "Nouvelle correspondance de compte",
    "accounting.mapping.save": "Enregistrer la correspondance",
    "Save mapping": "Enregistrer la correspondance",
    "accounting.mapping.create": "Créer la correspondance",
    "Create mapping": "Créer la correspondance",
    "accounting.mapping.source_type": "Type de source",
    "Source type": "Type de source",
    "accounting.mapping.event_key": "Clé d’événement",
    "Event key": "Clé d’événement",
    "accounting.mapping.debit_account": "Compte de débit",
    "Debit account": "Compte de débit",
    "accounting.mapping.credit_account": "Compte de crédit",
    "Credit account": "Compte de crédit",
    "accounting.mapping.tax_account": "Compte de taxe",
    "Tax account": "Compte de taxe",
    "accounting.mapping.none": "Aucun",
    "None": "Aucun",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filtrer par type de source",
    "Filter source type": "Filtrer par type de source",
    "accounting.action.new_mapping": "Nouvelle correspondance",
    "New mapping": "Nouvelle correspondance",
    "accounting.empty.mappings": "Aucune correspondance de compte trouvée.",
    "No account mappings found.": "Aucune correspondance de compte trouvée.",
    "accounting.column.source": "Source",
    "Source": "Source",
    "accounting.column.event": "Événement",
    "Event": "Événement",
    "accounting.column.debit": "Débit",
    "Debit": "Débit",
    "accounting.column.credit": "Crédit",
    "Credit": "Crédit",
    "accounting.period.close_confirm": "Clôturer {period} ? Cette action est irréversible.",
    "Close {period}? This cannot be reversed.": "Clôturer {period} ? Cette action est irréversible.",
    "accounting.period.this": "cette période comptable",
    "this accounting period": "cette période comptable",
    "accounting.period.new_title": "Nouvelle période comptable",
    "New accounting period": "Nouvelle période comptable",
    "accounting.period.create": "Créer la période",
    "Create period": "Créer la période",
    "accounting.period.name": "Nom de la période",
    "Period name": "Nom de la période",
    "accounting.period.start": "Date de début",
    "accounting.period.end": "Date de fin",
    "End date": "Date de fin",
    "accounting.period.name_placeholder": "Janvier 2027",
    "January 2027": "Janvier 2027",
    "accounting.period.open": "Ouverte",
    "accounting.period.closed": "Clôturée",
    "accounting.action.new_period": "Nouvelle période",
    "New period": "Nouvelle période",
    "accounting.empty.periods": "Aucune période comptable trouvée.",
    "No accounting periods found.": "Aucune période comptable trouvée.",
    "accounting.column.period": "Période",
    "accounting.column.start": "Début",
    "Start": "Début",
    "accounting.column.end": "Fin",
    "End": "Fin",
    "accounting.action.close_period": "Clôturer la période",
    "Close period": "Clôturer la période",
    "accounting.journal.new_title": "Nouveau journal",
    "New journal": "Nouveau journal",
    "accounting.journal.balance_help": "Les débits et les crédits doivent être équilibrés avant l’enregistrement.",
    "Debits and credits must balance before saving.": "Les débits et les crédits doivent être équilibrés avant l’enregistrement.",
    "accounting.journal.close": "Fermer",
    "accounting.journal.entry_date": "Date de saisie",
    "Entry date": "Date de saisie",
    "accounting.journal.description": "Description",
    "accounting.journal.source_type": "Type de source",
    "accounting.journal.source_id": "Identifiant de la source",
    "Source ID": "Identifiant de la source",
    "accounting.journal.account": "Compte",
    "accounting.journal.select_account": "Sélectionner un compte",
    "Select account": "Sélectionner un compte",
    "accounting.journal.debit_total": "Débit : {debit} · Crédit : {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Débit : {debit} · Crédit : {credit} · {status}",
    "accounting.journal.balanced": "Équilibré",
    "Balanced": "Équilibré",
    "accounting.journal.unbalanced": "Déséquilibré",
    "Unbalanced": "Déséquilibré",
    "accounting.journal.add_line": "Ajouter une ligne",
    "Add line": "Ajouter une ligne",
    "accounting.journal.save": "Enregistrer le journal",
    "Save journal": "Enregistrer le journal",
    "accounting.journal.empty": "Aucune ligne de journal.",
    "No journal lines.": "Aucune ligne de journal.",
    "accounting.journal.reason_prompt": "Motif de l’annulation de ce journal :",
    "Reason for voiding this journal:": "Motif de l’annulation de ce journal :",
    "accounting.journal.details_title": "Journal nº {id}",
    "Journal #{id}": "Journal nº {id}",
    "accounting.action.view": "Voir",
    "View": "Voir",
    "accounting.action.void": "Annuler",
    "Void": "Annuler",
    "accounting.filter.all_accounts": "Tous les comptes",
    "All accounts": "Tous les comptes",
    "accounting.empty.journals": "Aucun journal trouvé.",
    "No journals found.": "Aucun journal trouvé.",
    "accounting.column.date": "Date",
    "accounting.column.description": "Description",
    "accounting.column.account_source": "Source",
    "accounting.empty.journal_lines": "Aucune ligne de journal.",
    "accounting.report.trial_balance": "Balance de vérification",
    "Trial balance": "Balance de vérification",
    "accounting.report.general_ledger": "Grand livre",
    "General ledger": "Grand livre",
    "accounting.action.run_report": "Exécuter le rapport",
    "Run report": "Exécuter le rapport",
    "accounting.report.loading": "Chargement du rapport…",
    "Loading report…": "Chargement du rapport…",
    "accounting.empty.report": "Aucune ligne de rapport trouvée.",
    "No report rows found.": "Aucune ligne de rapport trouvée.",
    "accounting.report.choose_run": "Choisissez un rapport et exécutez-le.",
    "Choose a report and run it.": "Choisissez un rapport et exécutez-le.",
    "accounting.column.balance": "Solde",
    "Balance": "Solde",
    "accounting.overview.chart_title": "Plan comptable",
    "accounting.overview.chart_description": "Définissez les comptes utilisés dans votre grand livre.",
    "Define the accounts used by your ledger.": "Définissez les comptes utilisés dans votre grand livre.",
    "accounting.overview.journals_title": "Journaux",
    "accounting.overview.journals_description": "Créez et consultez des écritures comptables équilibrées.",
    "Create and review balanced journal entries.": "Créez et consultez des écritures comptables équilibrées.",
    "accounting.overview.reports_title": "Rapports",
    "accounting.overview.reports_description": "Exécutez des rapports de balance de vérification et de grand livre.",
    "Run trial balance and general ledger reports.": "Exécutez des rapports de balance de vérification et de grand livre.",
    "common.refresh": "Actualiser",
    "reports.search.title": "Analyse des recherches",
    "Search analytics": "Analyse des recherches",
    "reports.search.back_to_report": "Retour au rapport",
    "Back to report": "Retour au rapport",
    "reports.search.description": "La demande de recherche indique ce que les visiteurs recherchent et les domaines où votre catalogue doit être enrichi.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "La demande de recherche indique ce que les visiteurs recherchent et les domaines où votre catalogue doit être enrichi.",
    "reports.search.metric.searches": "Recherches",
    "Searches": "Recherches",
    "reports.search.metric.unique_keywords": "Mots-clés uniques",
    "Unique keywords": "Mots-clés uniques",
    "reports.search.metric.with_listings": "Avec annonces",
    "With listings": "Avec annonces",
    "reports.search.metric.no_matches": "Sans annonce correspondante",
    "No listing matches": "Sans annonce correspondante",
    "reports.search.metric.coverage": "Couverture",
    "Coverage": "Couverture",
    "reports.search.insights.title": "Informations pour l’administration",
    "Admin insights": "Informations pour l’administration",
    "reports.search.insights.no_results_one": "Le mot-clé {count} n’a renvoyé aucune annonce. Envisagez de créer une annonce, d’ajouter le terme comme catégorie ou étiquette, ou d’améliorer le titre et la description de l’annonce.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "Le mot-clé {count} n’a renvoyé aucune annonce. Envisagez de créer une annonce, d’ajouter le terme comme catégorie ou étiquette, ou d’améliorer le titre et la description de l’annonce.",
    "reports.search.insights.no_results_many": "{count} mots-clés n’ont renvoyé aucune annonce. Envisagez de créer des annonces, d’ajouter les termes comme catégories ou étiquettes, ou d’améliorer les titres et descriptions des annonces.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} mots-clés n’ont renvoyé aucune annonce. Envisagez de créer des annonces, d’ajouter les termes comme catégories ou étiquettes, ou d’améliorer les titres et descriptions des annonces.",
    "reports.search.insights.all_covered": "Chaque mot-clé suivi a renvoyé au moins une annonce. Examinez les termes les plus fréquents pour améliorer la présentation des produits et le classement par catégorie.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Chaque mot-clé suivi a renvoyé au moins une annonce. Examinez les termes les plus fréquents pour améliorer la présentation des produits et le classement par catégorie.",
    "reports.search.insights.empty": "Les données de recherche apparaîtront lorsque les visiteurs effectueront des recherches dans la marketplace.",
    "Search data will appear after visitors search the marketplace.": "Les données de recherche apparaîtront lorsque les visiteurs effectueront des recherches dans la marketplace.",
    "reports.search.insights.total_matches": "{count} correspondances d’annonces ont été renvoyées dans les données de recherche chargées.",
    "{count} total listing matches were returned across the loaded search records.": "{count} correspondances d’annonces ont été renvoyées dans les données de recherche chargées.",
    "reports.search.coverage_title": "Couverture des mots-clés",
    "Keyword coverage": "Couverture des mots-clés",
    "reports.search.loading": "Chargement de l’analyse des recherches…",
    "Loading search analytics…": "Chargement de l’analyse des recherches…",
    "reports.search.empty": "Aucune expression recherchée trouvée.",
    "No search phrases found.": "Aucune expression recherchée trouvée.",
    "reports.search.error.load": "Impossible de charger l’analyse des recherches.",
    "Unable to load search analytics.": "Impossible de charger l’analyse des recherches.",
    "reports.search.unknown": "Recherche inconnue",
    "Unknown search": "Recherche inconnue",
    "reports.search.column.keyword": "Mot-clé",
    "Keyword": "Mot-clé",
    "reports.search.column.listings": "Annonces",
    "reports.search.column.coverage": "Couverture",
    "reports.search.column.last_searched": "Dernière recherche",
    "Last searched": "Dernière recherche",
    "reports.search.column.suggested_action": "Action suggérée",
    "Suggested action": "Action suggérée",
    "reports.search.status.covered": "Couvert",
    "Covered": "Couvert",
    "reports.search.status.no_matches": "Aucun résultat",
    "No matches": "Aucun résultat",
    "reports.search.action.review_ranking": "Vérifier le classement",
    "Review ranking": "Vérifier le classement",
    "reports.search.action.add_listing": "Ajouter une annonce ou une catégorie",
    "Add listing or category": "Ajouter une annonce ou une catégorie",
    "platform_health.title": "État de la plateforme",
    "Platform health": "État de la plateforme",
    "platform_health.tab.health": "État de santé",
    "platform_health.tab.configuration": "Configuration",
    "Configuration": "Configuration",
    "platform_health.action.refreshing": "Actualisation…",
    "Refreshing…": "Actualisation…",
    "platform_health.window_note": "La vue actuelle charge les {count} premiers enregistrements pour chaque type d’événement.",
    "The current view loads the first {count} records for each event type.": "La vue actuelle charge les {count} premiers enregistrements pour chaque type d’événement.",
    "platform_health.error.title": "Impossible de charger les audits d’authentification",
    "Unable to load authentication audits": "Impossible de charger les audits d’authentification",
    "platform_health.error.proxy_note": "L’API peut exiger que cette requête d’administration passe par un serveur proxy au lieu d’être envoyée directement par le navigateur.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "L’API peut exiger que cette requête d’administration passe par un serveur proxy au lieu d’être envoyée directement par le navigateur.",
    "platform_health.error.session": "Votre session administrateur n’est pas encore prête. Veuillez vous reconnecter.",
    "Your admin session is not ready yet. Please sign in again.": "Votre session administrateur n’est pas encore prête. Veuillez vous reconnecter.",
    "platform_health.error.load": "Impossible de charger les audits d’authentification ({status}).",
    "Unable to load authentication audits ({status}).": "Impossible de charger les audits d’authentification ({status}).",
    "platform_health.error.load_generic": "Impossible de charger les audits de santé de la plateforme.",
    "Unable to load platform health audits.": "Impossible de charger les audits de santé de la plateforme.",
    "platform_health.metric.login_attempts": "Tentatives de connexion",
    "Login attempts": "Tentatives de connexion",
    "platform_health.metric.signup_attempts": "Tentatives d’inscription",
    "Signup attempts": "Tentatives d’inscription",
    "platform_health.metric.audit_records": "Enregistrements d’audit",
    "Audit records": "Enregistrements d’audit",
    "platform_health.metric.successful": "Réussies",
    "platform_health.metric.failed": "Échouées",
    "platform_health.metric.outcome_returned": "Uniquement si le résultat est fourni",
    "Only when outcome is returned": "Uniquement si le résultat est fourni",
    "platform_health.metric.failure_rate": "Taux d’échec",
    "Failure rate": "Taux d’échec",
    "platform_health.metric.classified_records": "Enregistrements classés",
    "Classified records": "Enregistrements classés",
    "platform_health.activity.title": "Activité d’authentification",
    "Authentication activity": "Activité d’authentification",
    "platform_health.activity.description": "Tentatives renvoyées pour la période d’audit sélectionnée",
    "Attempts returned by the selected audit window": "Tentatives renvoyées pour la période d’audit sélectionnée",
    "platform_health.activity.no_timestamps": "Aucun enregistrement d’audit horodaté n’a été renvoyé.",
    "No timestamped audit records returned.": "Aucun enregistrement d’audit horodaté n’a été renvoyé.",
    "platform_health.event.login": "connexion",
    "login": "connexion",
    "platform_health.event.signup": "inscription",
    "signup": "inscription",
    "platform_health.status.success": "Réussite",
    "platform_health.status.failed": "Échec",
    "platform_health.status.recorded": "Enregistré",
    "Recorded": "Enregistré",
    "platform_health.unknown_day": "Inconnu",
    "Unknown": "Inconnu",
    "platform_health.failure_reasons": "Motifs des échecs",
    "Failure reasons": "Motifs des échecs",
    "platform_health.no_failures": "Aucun échec classé n’a été renvoyé.",
    "No classified failures returned.": "Aucun échec classé n’a été renvoyé.",
    "platform_health.unspecified_failure": "Échec non précisé",
    "Unspecified failure": "Échec non précisé",
    "platform_health.recent_records": "Enregistrements d’audit récents",
    "Recent audit records": "Enregistrements d’audit récents",
    "platform_health.normalized_note": "Les champs bruts sont normalisés uniquement pour l’affichage.",
    "Raw fields are normalized only for display.": "Les champs bruts sont normalisés uniquement pour l’affichage.",
    "platform_health.loaded_count": "{count} chargés",
    "{count} loaded": "{count} chargés",
    "platform_health.loading_records": "Chargement des enregistrements d’audit…",
    "Loading audit records…": "Chargement des enregistrements d’audit…",
    "platform_health.no_records": "Aucun enregistrement d’audit n’a été renvoyé.",
    "No audit records returned.": "Aucun enregistrement d’audit n’a été renvoyé.",
    "platform_health.column.event": "Événement",
    "platform_health.column.status": "Statut",
    "platform_health.column.user": "Utilisateur",
    "User": "Utilisateur",
    "platform_health.column.time": "Heure",
    "Time": "Heure",
    "platform_health.column.reason": "Motif",
    "Reason": "Motif",
    "platform_health.config.sign_in": "Méthode de connexion",
    "Sign-in method": "Méthode de connexion",
    "platform_health.config.facebook": "Authentification Facebook",
    "Facebook Auth": "Authentification Facebook",
    "platform_health.config.google": "Authentification Google",
    "Google Auth": "Authentification Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Ces paramètres prennent effet immédiatement. Après leur enregistrement, ils apparaissent dans les applications et les réponses API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Ces paramètres prennent effet immédiatement. Après leur enregistrement, ils apparaissent dans les applications et les réponses API.",
    "integrations.note.mobile_release": "Les paramètres des canaux d’application mobile s’appliquent à la publication ou à la mise à jour d’un produit. Pour obtenir une nouvelle version, faites-en la demande sur le portail d’assistance. Cela concerne l’offre Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Les paramètres des canaux d’application mobile s’appliquent à la publication ou à la mise à jour d’un produit. Pour obtenir une nouvelle version, faites-en la demande sur le portail d’assistance. Cela concerne l’offre Starter.",
    "integrations.toast.saved": "Paramètres d’intégration enregistrés.",
    "Integration settings saved.": "Paramètres d’intégration enregistrés.",
    "integrations.error.save": "Impossible d’enregistrer les paramètres d’intégration.",
    "Unable to save integration settings.": "Impossible d’enregistrer les paramètres d’intégration.",
    "integrations.twilio.title": "Intégration Twilio",
    "Twilio integration": "Intégration Twilio",
    "integrations.twilio.account_sid": "SID du compte",
    "Account SID": "SID du compte",
    "integrations.twilio.account_sid_placeholder": "Saisissez le SID du compte",
    "Enter account SID": "Saisissez le SID du compte",
    "integrations.twilio.auth_token": "Jeton d’authentification",
    "Auth token": "Jeton d’authentification",
    "integrations.twilio.auth_token_placeholder": "Saisissez le jeton d’authentification",
    "Enter auth token": "Saisissez le jeton d’authentification",
    "integrations.twilio.source_phone": "Numéro de téléphone source",
    "Source phone number": "Numéro de téléphone source",
    "integrations.twilio.source_phone_placeholder": "Saisissez le numéro de téléphone source",
    "Enter source phone number": "Saisissez le numéro de téléphone source",
    "integrations.facebook.title": "Authentification Facebook",
    "integrations.facebook.enable_login": "Activer la connexion Facebook",
    "Enable Facebook login": "Activer la connexion Facebook",
    "integrations.facebook.app_id": "Identifiant de l’application",
    "App ID": "Identifiant de l’application",
    "integrations.facebook.app_id_placeholder": "Saisissez l’identifiant de l’application",
    "Enter app ID": "Saisissez l’identifiant de l’application",
    "integrations.google.title": "Authentification Google",
    "integrations.google.enable_sign_in": "Activer la connexion Google",
    "Enable Google sign-in": "Activer la connexion Google",
    "integrations.google.client_id": "Identifiant client",
    "integrations.google.client_id_placeholder": "Saisissez l’identifiant client",
    "integrations.auth.title": "Méthode de connexion",
    "integrations.auth.description": "Choisissez la méthode d’inscription et de connexion des utilisateurs. Les vérifications par e-mail et SMS utilisent les paramètres de distribution configurés pour l’espace de travail.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Choisissez la méthode d’inscription et de connexion des utilisateurs. Les vérifications par e-mail et SMS utilisent les paramètres de distribution configurés pour l’espace de travail.",
    "integrations.auth.empty": "Aucune méthode de connexion prise en charge n’est configurée. Sélectionnez-en une pour continuer.",
    "No supported sign-in method is currently configured. Select one to continue.": "Aucune méthode de connexion prise en charge n’est configurée. Sélectionnez-en une pour continuer.",
    "integrations.auth.save_note": "L’enregistrement applique cette méthode aux points de terminaison d’inscription et de connexion de l’espace de travail. Les utilisateurs créés directement sont gérés séparément.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "L’enregistrement applique cette méthode aux points de terminaison d’inscription et de connexion de l’espace de travail. Les utilisateurs créés directement sont gérés séparément.",
    "integrations.auth.error.load": "Impossible de charger la méthode de connexion actuelle.",
    "Unable to load the current sign-in method.": "Impossible de charger la méthode de connexion actuelle.",
    "integrations.auth.error.save": "Impossible d’enregistrer la méthode de connexion.",
    "Unable to save the sign-in method.": "Impossible d’enregistrer la méthode de connexion.",
    "integrations.auth.toast.saved": "Méthode de connexion enregistrée.",
    "Sign-in method saved.": "Méthode de connexion enregistrée.",
    "integrations.auth.email_password": "E-mail et mot de passe",
    "Email and password": "E-mail et mot de passe",
    "integrations.auth.email_password_help": "Les utilisateurs vérifient leur adresse e-mail lors de l’inscription, puis se connectent avec un mot de passe.",
    "Users verify their email during sign-up, then sign in with a password.": "Les utilisateurs vérifient leur adresse e-mail lors de l’inscription, puis se connectent avec un mot de passe.",
    "integrations.auth.email_code": "Code à usage unique par e-mail",
    "Email one-time code": "Code à usage unique par e-mail",
    "integrations.auth.email_code_help": "Les utilisateurs reçoivent un code de vérification par e-mail pour s’inscrire et se connecter.",
    "Users receive a verification code by email for sign-up and sign-in.": "Les utilisateurs reçoivent un code de vérification par e-mail pour s’inscrire et se connecter.",
    "integrations.auth.phone_code": "Code à usage unique par téléphone",
    "Phone one-time code": "Code à usage unique par téléphone",
    "integrations.auth.phone_code_help": "Les utilisateurs reçoivent un code de vérification par SMS pour s’inscrire et se connecter.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Les utilisateurs reçoivent un code de vérification par SMS pour s’inscrire et se connecter.",
    "integrations.auth.phone_password": "Téléphone et mot de passe",
    "Phone and password": "Téléphone et mot de passe",
    "integrations.auth.phone_password_help": "Les utilisateurs vérifient leur numéro de téléphone lors de l’inscription, puis se connectent avec un mot de passe.",
    "Users verify their phone during sign-up, then sign in with a password.": "Les utilisateurs vérifient leur numéro de téléphone lors de l’inscription, puis se connectent avec un mot de passe.",
    "integrations.auth.email_password_unverified": "E-mail et mot de passe sans vérification à l’inscription",
    "Email and password without sign-up verification": "E-mail et mot de passe sans vérification à l’inscription",
    "integrations.auth.email_password_unverified_help": "Les utilisateurs peuvent s’inscrire avec une adresse e-mail et un mot de passe sans code de vérification par e-mail.",
    "Users can sign up with an email and password without an email verification code.": "Les utilisateurs peuvent s’inscrire avec une adresse e-mail et un mot de passe sans code de vérification par e-mail.",
    "integrations.auth.phone_password_unverified": "Téléphone et mot de passe sans vérification à l’inscription",
    "Phone and password without sign-up verification": "Téléphone et mot de passe sans vérification à l’inscription",
    "integrations.auth.phone_password_unverified_help": "Les utilisateurs peuvent s’inscrire avec un numéro de téléphone et un mot de passe sans code de vérification par SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Les utilisateurs peuvent s’inscrire avec un numéro de téléphone et un mot de passe sans code de vérification par SMS.",
    "integrations.page.title": "Intégrations de l’application",
    "App Integrations": "Intégrations de l’application",
    "integrations.generic.id_placeholder": "Saisissez l’identifiant {name}",
    "Enter {name} ID": "Saisissez l’identifiant {name}",
    "integrations.generic.enable": "Activer l’intégration {name}",
    "Enable {name} integration": "Activer l’intégration {name}",
    "integrations.menu.map": "Cartes",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Intégration Maps",
    "Maps integration": "Intégration Maps",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Clé API",
    "API key": "Clé API",
    "integrations.maps.api_key_placeholder": "Saisissez la clé API",
    "integrations.maps.reverse_geocode_key": "Clé API de géocodage inversé Google Maps",
    "Google Maps reverse geocoding API key": "Clé API de géocodage inversé Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Saisissez la clé API de géocodage inversé Google Maps",
    "Enter Google Maps reverse geocoding API key": "Saisissez la clé API de géocodage inversé Google Maps",
    "integrations.maps.places_key": "Clé API Google Maps Places",
    "Google Maps Places API key": "Clé API Google Maps Places",
    "integrations.maps.places_key_placeholder": "Saisissez la clé API Google Maps Places",
    "Enter Google Maps Places API key": "Saisissez la clé API Google Maps Places",
    "integrations.maps.nearby_accounts": "Activer les comptes à proximité sur la page d’accueil",
    "Activate nearby accounts on the home page": "Activer les comptes à proximité sur la page d’accueil",
    "integrations.maps.listing_location": "Activer la localisation dans le formulaire d’annonce",
    "Activate location in listing submission": "Activer la localisation dans le formulaire d’annonce",
    "integrations.maps.account_location": "Activer la localisation dans le formulaire de compte",
    "Activate location in account submission": "Activer la localisation dans le formulaire de compte",
    "integrations.playstore.title": "Intégration Google Play",
    "Google Play integration": "Intégration Google Play",
    "integrations.playstore.application_id": "Identifiant de l’application",
    "Application ID": "Identifiant de l’application",
    "integrations.playstore.application_id_placeholder": "Saisissez l’identifiant de l’application (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Saisissez l’identifiant de l’application (com.tenantname.app)",
    "integrations.playstore.first_name": "Prénom",
    "integrations.playstore.first_name_placeholder": "Saisissez le prénom",
    "Enter first name": "Saisissez le prénom",
    "integrations.playstore.last_name": "Nom",
    "integrations.playstore.last_name_placeholder": "Saisissez le nom",
    "Enter last name": "Saisissez le nom",
    "integrations.playstore.unit": "Unité organisationnelle",
    "Organizational unit": "Unité organisationnelle",
    "integrations.playstore.unit_placeholder": "Saisissez l’unité organisationnelle",
    "Enter organizational unit": "Saisissez l’unité organisationnelle",
    "integrations.playstore.organization": "Organisation",
    "Organization": "Organisation",
    "integrations.playstore.organization_placeholder": "Saisissez le nom de l’organisation",
    "Enter organization name": "Saisissez le nom de l’organisation",
    "integrations.playstore.city": "Ville ou localité",
    "City or locality": "Ville ou localité",
    "integrations.playstore.city_placeholder": "Saisissez la ville ou la localité",
    "Enter city or locality": "Saisissez la ville ou la localité",
    "integrations.playstore.state": "État ou province",
    "State or province": "État ou province",
    "integrations.playstore.state_placeholder": "Saisissez l’État ou la province",
    "Enter state or province": "Saisissez l’État ou la province",
    "integrations.playstore.country_code": "Code pays (XX)",
    "Country code (XX)": "Code pays (XX)",
    "integrations.playstore.country_code_placeholder": "Saisissez le code pays",
    "Enter country code": "Saisissez le code pays",
    "integrations.playstore.link": "Lien Google Play",
    "Google Play link": "Lien Google Play",
    "integrations.playstore.link_placeholder": "Saisissez le lien Google Play de votre application",
    "Enter your app Google Play link": "Saisissez le lien Google Play de votre application",
    "integrations.admob.title": "Intégration AdMob",
    "AdMob integration": "Intégration AdMob",
    "integrations.admob.app_id": "Identifiant de l’application",
    "integrations.admob.app_id_placeholder": "Saisissez l’identifiant de l’application",
    "Enter App ID": "Saisissez l’identifiant de l’application",
    "integrations.admob.unit_id": "Identifiant de l’unité",
    "Unit ID": "Identifiant de l’unité",
    "integrations.admob.unit_id_placeholder": "Saisissez l’identifiant d’unité AdMob",
    "Enter AdMob unit ID": "Saisissez l’identifiant d’unité AdMob",
    "integrations.admob.listings_id": "Identifiant des annonces",
    "Listings ID": "Identifiant des annonces",
    "integrations.admob.listings_id_placeholder": "Saisissez l’identifiant des annonces",
    "Enter listings ID": "Saisissez l’identifiant des annonces",
    "integrations.admob.listing_detail_id": "Identifiant du détail de l’annonce",
    "Listing detail ID": "Identifiant du détail de l’annonce",
    "integrations.admob.listing_detail_id_placeholder": "Saisissez l’identifiant du détail de l’annonce",
    "Enter listing detail ID": "Saisissez l’identifiant du détail de l’annonce",
    "integrations.admob.home_id": "Identifiant de l’accueil",
    "Home ID": "Identifiant de l’accueil",
    "integrations.admob.home_id_placeholder": "Saisissez l’identifiant de l’accueil",
    "Enter home ID": "Saisissez l’identifiant de l’accueil",
    "integrations.admob.enable_ads": "Activer les annonces",
    "Enable ads": "Activer les annonces",
    "integrations.admob.enable_listing_ads": "Activer les annonces dans le fil des annonces",
    "Enable ads on the listings feed": "Activer les annonces dans le fil des annonces",
    "integrations.admob.enable_listing_detail_ads": "Activer les annonces dans le détail des annonces",
    "Enable ads on listing details": "Activer les annonces dans le détail des annonces",
    "integrations.admob.enable_home_ads": "Activer les annonces dans la barre de navigation en bas de l’accueil",
    "Enable ads in the home bottom navigation": "Activer les annonces dans la barre de navigation en bas de l’accueil",
    "integrations.save_success": "Enregistré avec succès",
    "Saved successfully": "Enregistré avec succès",
    "integrations.note.release": "Ces paramètres s’appliquent à la publication ou à la mise à jour de l’application mobile. Après vos modifications, demandez une nouvelle version depuis le portail d’assistance. Offre Starter applicable.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Ces paramètres s’appliquent à la publication ou à la mise à jour de l’application mobile. Après vos modifications, demandez une nouvelle version depuis le portail d’assistance. Offre Starter applicable.",
    "integrations.action.download": "Télécharger",
    "integrations.branch.title": "Intégration Branch",
    "Branch integration": "Intégration Branch",
    "integrations.branch.app_id": "Identifiant de l’application",
    "integrations.branch.app_id_placeholder": "Saisissez l’identifiant de l’application",
    "integrations.branch.live_key": "Clé Live",
    "Live key": "Clé Live",
    "integrations.branch.live_key_placeholder": "Saisissez la clé Live",
    "Enter live key": "Saisissez la clé Live",
    "integrations.branch.live_secret": "Secret Live",
    "Live secret": "Secret Live",
    "integrations.branch.live_secret_placeholder": "Saisissez le secret Live",
    "Enter live secret": "Saisissez le secret Live",
    "integrations.branch.uri_scheme": "Schéma URI",
    "URI scheme": "Schéma URI",
    "integrations.branch.uri_scheme_placeholder": "Saisissez le schéma URI",
    "Enter URI scheme": "Saisissez le schéma URI",
    "integrations.branch.link_domain": "Domaine du lien",
    "Link domain": "Domaine du lien",
    "integrations.branch.link_domain_placeholder": "Saisissez le domaine du lien",
    "Enter link domain": "Saisissez le domaine du lien",
    "integrations.branch.alternate_domain": "Domaine de lien secondaire",
    "Alternate link domain": "Domaine de lien secondaire",
    "integrations.branch.alternate_domain_placeholder": "Saisissez le domaine de lien secondaire",
    "Enter alternate link domain": "Saisissez le domaine de lien secondaire",
    "integrations.branch.link_description": "Description du lien",
    "Link description": "Description du lien",
    "integrations.branch.link_description_placeholder": "Saisissez la description du lien",
    "Enter link description": "Saisissez la description du lien",
    "integrations.branch.invite_friends": "Inviter des amis",
    "Invite friends": "Inviter des amis",
    "integrations.branch.invite_title": "Titre",
    "Title": "Titre",
    "integrations.branch.invite_description": "Description",
    "integrations.branch.destination_link": "Lien de destination Branch (facultatif)",
    "Branch destination link (optional)": "Lien de destination Branch (facultatif)",
    "integrations.branch.web_app_note": "S’applique aux utilisateurs de l’application web",
    "Applies to web app users": "S’applique aux utilisateurs de l’application web",
    "integrations.branch.destination_placeholder": "Saisissez le lien de destination Branch",
    "Enter branch destination link": "Saisissez le lien de destination Branch",
    "integrations.ios.title": "Provisionnement App Store",
    "App Store provisioning": "Provisionnement App Store",
    "integrations.ios.bundle_id": "Identifiant de bundle",
    "Bundle ID": "Identifiant de bundle",
    "integrations.ios.bundle_id_placeholder": "Saisissez l’identifiant de bundle",
    "Enter bundle ID": "Saisissez l’identifiant de bundle",
    "integrations.ios.certificate_password": "Mot de passe du certificat de distribution",
    "Distribution certificate password": "Mot de passe du certificat de distribution",
    "integrations.ios.certificate_password_placeholder": "Saisissez le mot de passe du certificat de distribution",
    "Enter distribution certificate password": "Saisissez le mot de passe du certificat de distribution",
    "integrations.ios.push_key_id": "Identifiant de la clé Push",
    "Push key ID": "Identifiant de la clé Push",
    "integrations.ios.push_key_id_placeholder": "Saisissez l’identifiant de la clé Push",
    "Enter push key ID": "Saisissez l’identifiant de la clé Push",
    "integrations.ios.team_id": "Identifiant de l’équipe",
    "Team ID": "Identifiant de l’équipe",
    "integrations.ios.team_id_placeholder": "Saisissez l’identifiant de l’équipe",
    "Enter team ID": "Saisissez l’identifiant de l’équipe",
    "integrations.ios.apple_id": "Identifiant Apple",
    "Apple ID": "Identifiant Apple",
    "integrations.ios.apple_id_placeholder": "Saisissez l’identifiant Apple",
    "Enter Apple ID": "Saisissez l’identifiant Apple",
    "integrations.ios.distribution_certificate": "Certificat de distribution",
    "Distribution certificate": "Certificat de distribution",
    "integrations.ios.provisioning_profile": "Profil de provisionnement",
    "Distribution provisioning profile": "Profil de provisionnement",
    "integrations.ios.push_key": "Clé Push",
    "Push key": "Clé Push",
    "integrations.ios.app_store_link": "Lien de votre application sur l’App Store",
    "Your App Store link": "Lien de votre application sur l’App Store",
    "integrations.ios.app_store_link_placeholder": "Saisissez le lien App Store de votre application",
    "Enter your app App Store link": "Saisissez le lien App Store de votre application",
    "integrations.firebase.title": "Intégration Firebase",
    "Firebase integration": "Intégration Firebase",
    "integrations.firebase.choose_file": "Choisir un fichier",
    "Choose file": "Choisir un fichier",
    "integrations.firebase.service_account": "Compte de service Firebase",
    "Firebase service account": "Compte de service Firebase",
    "integrations.firebase.android_json": "Fichier JSON de l’application Android",
    "Android app JSON file": "Fichier JSON de l’application Android",
    "integrations.firebase.ios_plist": "Fichier plist de l’application iOS",
    "iOS app plist file": "Fichier plist de l’application iOS",
    "integrations.firebase.create_project": "Créer un projet Firebase",
    "Create Firebase project": "Créer un projet Firebase",
    "integrations.firebase.create_android": "Créer une application Android",
    "Create Android app": "Créer une application Android",
    "integrations.firebase.create_ios": "Créer une application iOS",
    "Create iOS app": "Créer une application iOS",
    "integrations.firebase.create_database": "Créer une base de données en temps réel",
    "Create realtime database": "Créer une base de données en temps réel",
    "integrations.firebase.apply_rules": "Appliquer les règles de la base de données Firebase",
    "Apply Firebase database rules": "Appliquer les règles de la base de données Firebase",
    "bundles.listing_number": "Annonce n° {id}",
    "Listing #{id}": "Annonce n° {id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Configurer le lot",
    "Configure bundle": "Configurer le lot",
    "bundles.configure.subtitle": "Annonce du lot n° {id} · ajoutez des annonces existantes ci-dessous.",
    "Bundle listing #{id} · add existing listings below.": "Annonce du lot n° {id} · ajoutez des annonces existantes ci-dessous.",
    "bundles.back": "Retour aux lots",
    "Back to bundles": "Retour aux lots",
    "bundles.fixed_components": "Composants fixes",
    "Fixed components": "Composants fixes",
    "bundles.selection_pool": "Pool de sélection",
    "Mix-and-match pool": "Pool de sélection",
    "bundles.available_listings": "Annonces disponibles",
    "Available listings": "Annonces disponibles",
    "bundles.available_description": "Recherchez et ajoutez des produits déjà présents dans votre catalogue.",
    "Search and add products already in your catalogue.": "Recherchez et ajoutez des produits déjà présents dans votre catalogue.",
    "bundles.search_listings": "Rechercher des annonces",
    "Search listings": "Rechercher des annonces",
    "bundles.quantity_per_component": "Quantité par composant",
    "Quantity per component": "Quantité par composant",
    "bundles.loading_listings": "Chargement des annonces…",
    "Loading listings…": "Chargement des annonces…",
    "bundles.added": "Ajouté",
    "Added": "Ajouté",
    "bundles.adding": "Ajout…",
    "Adding…": "Ajout…",
    "bundles.add": "Ajouter",
    "bundles.no_matching_listings": "Aucune annonce correspondante trouvée.",
    "No matching listings found.": "Aucune annonce correspondante trouvée.",
    "bundles.one_listing_added": "1 annonce ajoutée",
    "1 listing added": "1 annonce ajoutée",
    "bundles.many_listings_added": "{count} annonces ajoutées",
    "{count} listings added": "{count} annonces ajoutées",
    "bundles.quantity_short": "Qté {count}",
    "Qty {count}": "Qté {count}",
    "bundles.removing": "Suppression…",
    "Removing…": "Suppression…",
    "bundles.remove": "Supprimer",
    "bundles.no_components": "Aucun composant ajouté pour le moment.",
    "No components added yet.": "Aucun composant ajouté pour le moment.",
    "bundles.pool_remove_note": "La suppression du pool nécessite l’API correspondante ; l’ajout est disponible.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "La suppression du pool nécessite l’API correspondante ; l’ajout est disponible.",
    "bundles.error.load_components": "Impossible de charger les composants du lot.",
    "Unable to load bundle components.": "Impossible de charger les composants du lot.",
    "bundles.error.add_listing": "Impossible d’ajouter l’annonce au lot.",
    "Unable to add listing to the bundle.": "Impossible d’ajouter l’annonce au lot.",
    "bundles.error.remove_component": "Impossible de supprimer le composant du lot.",
    "Unable to remove bundle component.": "Impossible de supprimer le composant du lot.",
    "bundles.error.load_listings": "Impossible de charger les annonces.",
    "Unable to load listings.": "Impossible de charger les annonces.",
    "bundles.components": "Composants du lot",
    "Bundle components": "Composants du lot",
    "bundles.picker_description": "Sélectionnez des annonces déjà présentes dans votre catalogue. Elles seront liées après la création du lot.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Sélectionnez des annonces déjà présentes dans votre catalogue. Elles seront liées après la création du lot.",
    "bundles.fixed_bundle": "Lot fixe",
    "Fixed bundle": "Lot fixe",
    "bundles.mix_match": "Composition au choix",
    "Mix and match": "Composition au choix",
    "bundles.quantity_per_selected": "Quantité par annonce sélectionnée",
    "Quantity per selected listing": "Quantité par annonce sélectionnée",
    "bundles.search_existing": "Rechercher des annonces existantes",
    "Search existing listings": "Rechercher des annonces existantes",
    "bundles.selected_count": "Sélectionnés ({count})",
    "Selected ({count})": "Sélectionnés ({count})",
    "bundles.choose_component_hint": "Choisissez au moins une annonce existante ou créez d’abord le lot.",
    "Choose at least one existing listing, or create the bundle first.": "Choisissez au moins une annonce existante ou créez d’abord le lot.",
    "bundles.error.attach_components": "Le lot a été créé, mais ses composants n’ont pas pu être ajoutés.",
    "The bundle was created, but components could not be attached.": "Le lot a été créé, mais ses composants n’ont pas pu être ajoutés.",
    "bundles.continue_configure_hint": "Vous pouvez continuer depuis la page de configuration du lot.",
    "You can continue from the bundle configuration page.": "Vous pouvez continuer depuis la page de configuration du lot.",
    "bundles.title": "Lots",
    "bundles.create": "Créer un lot",
    "Create bundle": "Créer un lot",
    "bundles.subtitle": "Créez une annonce de lot principale, puis ajoutez des composants fixes ou un pool de sélection au choix.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Créez une annonce de lot principale, puis ajoutez des composants fixes ou un pool de sélection au choix.",
    "bundles.workflow": "Étapes du lot",
    "Bundle workflow": "Étapes du lot",
    "bundles.how_it_works": "Comment fonctionnent les lots",
    "How bundles work": "Comment fonctionnent les lots",
    "bundles.parent_description": "Une annonce principale définit le lot présenté aux clients.",
    "One parent listing controls the customer-facing bundle.": "Une annonce principale définit le lot présenté aux clients.",
    "bundles.flow": "Parcours du lot",
    "Bundle flow": "Parcours du lot",
    "bundles.parent_listing": "Annonce principale",
    "Parent listing": "Annonce principale",
    "bundles.name_price_category": "Nom, prix, catégorie",
    "Name, price, category": "Nom, prix, catégorie",
    "bundles.fixed_or_pool": "Articles fixes ou pool",
    "Fixed items or a pool": "Articles fixes ou pool",
    "bundles.checkout_stock": "Stock à la commande",
    "Checkout stock": "Stock à la commande",
    "bundles.selection_availability": "Sélection et disponibilité",
    "Selection + availability": "Sélection et disponibilité",
    "bundles.fixed_bundles": "Lots fixes",
    "Fixed bundles": "Lots fixes",
    "bundles.fixed_description": "Vendez ensemble un groupe défini d’annonces existantes.",
    "Sell a defined group of existing listings together.": "Vendez ensemble un groupe défini d’annonces existantes.",
    "bundles.fixed_detail": "Ajoutez des annonces existantes comme composants fixes.",
    "Add existing listings as fixed components.": "Ajoutez des annonces existantes comme composants fixes.",
    "bundles.pool_description": "Laissez les clients choisir des articles admissibles dans le pool du lot.",
    "Let customers choose eligible items from a bundle pool.": "Laissez les clients choisir des articles admissibles dans le pool du lot.",
    "bundles.pool_detail": "Définissez le nombre minimal et maximal de choix à la commande.",
    "Set the minimum and maximum selections at checkout.": "Définissez le nombre minimal et maximal de choix à la commande.",
    "channels.opensource.title": "Kits de démarrage open source",
    "Open-source starter kits": "Kits de démarrage open source",
    "channels.opensource.view_org": "Voir l’organisation GitHub",
    "View GitHub organization": "Voir l’organisation GitHub",
    "channels.opensource.description": "Explorez les dépôts open source et les kits de démarrage Tradly de l’organisation TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Explorez les dépôts open source et les kits de démarrage Tradly de l’organisation TRADLY-PLATFORM.",
    "channels.opensource.loading": "Chargement des dépôts…",
    "Loading repositories…": "Chargement des dépôts…",
    "channels.opensource.error.http": "GitHub a renvoyé le code {status}.",
    "GitHub returned {status}.": "GitHub a renvoyé le code {status}.",
    "channels.opensource.error.load": "Impossible de charger les dépôts. Réessayez plus tard.",
    "Unable to load repositories. Try again later.": "Impossible de charger les dépôts. Réessayez plus tard.",
    "channels.opensource.empty": "Aucun dépôt public trouvé.",
    "No public repositories found.": "Aucun dépôt public trouvé.",
    "channels.opensource.repo_fallback": "Dépôt Tradly open source.",
    "Open-source Tradly repository.": "Dépôt Tradly open source.",
    "channels.opensource.language_code": "Code",
    "channels.opensource.view_repo": "Afficher le dépôt",
    "View repository": "Afficher le dépôt",
    "developer.mcp.select_all": "Tout sélectionner",
    "Select all": "Tout sélectionner",
    "developer.mcp.read": "Lecture",
    "developer.mcp.write": "Écriture",
    "developer.mcp.delete": "Supprimer",
    "developer.mcp.export": "Exporter",
    "developer.mcp.copy": "Copier",
    "Copy": "Copier",
    "developer.mcp.copied": "Copié",
    "Copied": "Copié",
    "developer.mcp.connection_created": "Connexion créée",
    "Connection created": "Connexion créée",
    "developer.mcp.save_secret_warning": "Enregistrez votre secret client maintenant : il ne sera plus affiché.",
    "Save your client secret now — it will not be shown again.": "Enregistrez votre secret client maintenant : il ne sera plus affiché.",
    "developer.mcp.client_id": "Identifiant client",
    "developer.mcp.client_secret": "Secret client",
    "Client secret": "Secret client",
    "developer.mcp.new_connection": "Nouvelle connexion MCP",
    "New MCP connection": "Nouvelle connexion MCP",
    "developer.mcp.platform": "Plateforme",
    "Platform": "Plateforme",
    "developer.mcp.platform_custom": "Personnalisée",
    "developer.mcp.connection_name": "Nom de la connexion",
    "Connection name": "Nom de la connexion",
    "developer.mcp.connection_name_placeholder": "ex. ChatGPT",
    "e.g. ChatGPT": "ex. ChatGPT",
    "developer.mcp.redirect_uris": "URI de redirection",
    "Redirect URIs": "URI de redirection",
    "developer.mcp.one_per_line": "(une par ligne)",
    "(one per line)": "(une par ligne)",
    "developer.mcp.permissions": "Autorisations",
    "Permissions": "Autorisations",
    "developer.mcp.error.connection_name": "Saisissez un nom de connexion",
    "Enter a connection name": "Saisissez un nom de connexion",
    "developer.mcp.error.redirect_uri": "Saisissez au moins une URI de redirection",
    "Enter at least one redirect URI": "Saisissez au moins une URI de redirection",
    "developer.mcp.error.create": "Échec de la création de la connexion",
    "Failed to create connection": "Échec de la création de la connexion",
    "developer.mcp.creating": "Création…",
    "Creating…": "Création…",
    "developer.mcp.edit_permissions": "Modifier les autorisations",
    "Edit permissions": "Modifier les autorisations",
    "developer.mcp.permissions_updated": "Autorisations mises à jour",
    "Permissions updated": "Autorisations mises à jour",
    "developer.mcp.error.update_permissions": "Échec de la mise à jour des autorisations",
    "Failed to update permissions": "Échec de la mise à jour des autorisations",
    "developer.mcp.saving": "Enregistrement…",
    "developer.mcp.error.load": "Impossible de charger les connexions MCP.",
    "MCP connections could not be loaded.": "Impossible de charger les connexions MCP.",
    "developer.mcp.confirm_delete": "Supprimer cette connexion ? Elle sera retirée de la liste et son accès sera révoqué.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Supprimer cette connexion ? Elle sera retirée de la liste et son accès sera révoqué.",
    "developer.mcp.connection_removed": "Connexion supprimée",
    "Connection removed": "Connexion supprimée",
    "developer.mcp.error.remove_connection": "Échec de la suppression de la connexion",
    "Failed to remove connection": "Échec de la suppression de la connexion",
    "developer.mcp.connection_deactivated": "Connexion désactivée",
    "Connection deactivated": "Connexion désactivée",
    "developer.mcp.error.deactivate_connection": "Échec de la désactivation de la connexion",
    "Failed to deactivate connection": "Échec de la désactivation de la connexion",
    "developer.mcp.title": "Connexions MCP",
    "MCP connections": "Connexions MCP",
    "developer.mcp.description": "Clients OAuth et applications d’IA enregistrés pour ce tenant et autorisés à utiliser son serveur MCP.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Clients OAuth et applications d’IA enregistrés pour ce tenant et autorisés à utiliser son serveur MCP.",
    "developer.mcp.empty": "Aucune connexion. Créez un client ou connectez une application d’IA au serveur MCP de ce tenant.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Aucune connexion. Créez un client ou connectez une application d’IA au serveur MCP de ce tenant.",
    "developer.mcp.status.connected_one": "Connecté · 1 utilisateur",
    "Connected · 1 user": "Connecté · 1 utilisateur",
    "developer.mcp.status.connected_many": "Connecté · {count} utilisateurs",
    "Connected · {count} users": "Connecté · {count} utilisateurs",
    "developer.mcp.status.deactivated": "Désactivée",
    "Deactivated": "Désactivée",
    "developer.mcp.status.previously_connected": "Précédemment connectée",
    "Previously connected": "Précédemment connectée",
    "developer.mcp.status.registered": "Enregistrée · non connectée",
    "Registered · not connected": "Enregistrée · non connectée",
    "developer.mcp.oauth_app": "Application OAuth",
    "OAuth app": "Application OAuth",
    "developer.mcp.created": "Créée",
    "developer.mcp.updated": "Mise à jour",
    "Updated": "Mise à jour",
    "developer.mcp.edit_scopes": "Modifier les autorisations",
    "Edit scopes": "Modifier les autorisations",
    "developer.mcp.edit_scopes_for": "Modifier les autorisations de {name}",
    "Edit scopes for {name}": "Modifier les autorisations de {name}",
    "developer.mcp.deactivate_hint": "Désactiver (conserver dans la liste et les journaux)",
    "Deactivate (keeps it listed and logged)": "Désactiver (conserver dans la liste et les journaux)",
    "developer.mcp.deactivate_named": "Désactiver {name}",
    "Deactivate {name}": "Désactiver {name}",
    "developer.mcp.delete_connection": "Supprimer la connexion",
    "Delete connection": "Supprimer la connexion",
    "developer.mcp.delete_named": "Supprimer {name}",
    "Delete {name}": "Supprimer {name}",
    "developer.mcp.resource.listings": "Annonces",
    "developer.mcp.resource.orders": "Commandes",
    "developer.mcp.resource.users": "Utilisateurs",
    "developer.mcp.resource.accounts": "Comptes",
    "developer.mcp.resource.categories": "Catégories",
    "developer.mcp.resource.attributes": "Attributs",
    "developer.mcp.resource.analytics": "Analyses",
    "developer.mcp.resource.attribution": "Attribution",
    "Attribution": "Attribution",
    "developer.mcp.resource.rewards": "Récompenses",
    "developer.mcp.resource.layers": "Couches / CMS",
    "Layers / CMS": "Couches / CMS",
    "developer.mcp.resource.settings": "Paramètres de la boutique",
    "Store settings": "Paramètres de la boutique",
    "developer.mcp.resource.marketing": "Marketing",
    "developer.mcp.resource.market_research": "Étude de marché",
    "Market research": "Étude de marché",
    "developer.mcp.resource.audiences": "Audiences marketing",
    "Marketing audiences": "Audiences marketing",
    "developer.mcp.resource.agents": "Agents IA",
    "developer.mcp.resource.assets": "Téléversements de fichiers",
    "File uploads": "Téléversements de fichiers",
    "developer.mcp.resource.workforce": "Effectifs",
    "developer.mcp.resource.inventory": "Inventaire",
    "developer.mcp.resource.memberships": "Adhésions",
    "Memberships": "Adhésions",
    "developer.mcp.resource.bundles": "Lots",
    "developer.mcp.resource.rentals": "Locations",
    "Rentals": "Locations",
    "developer.mcp.resource.accounting": "Comptabilité",
    "developer.mcp.nav.label": "Navigation MCP",
    "MCP navigation": "Navigation MCP",
    "developer.mcp.nav.connections": "Connexions",
    "Connections": "Connexions",
    "developer.mcp.nav.logs": "Journaux",
    "Logs": "Journaux",
    "developer.mcp.unknown_provider": "Fournisseur inconnu",
    "Unknown provider": "Fournisseur inconnu",
    "developer.mcp.tenant_user": "Tenant n° {tenant} · utilisateur n° {user}",
    "Tenant #{tenant} · User #{user}": "Tenant n° {tenant} · utilisateur n° {user}",
    "developer.mcp.logs.title": "Journaux MCP",
    "MCP logs": "Journaux MCP",
    "developer.mcp.logs.heading": "Activité récente des agents",
    "Recent agent activity": "Activité récente des agents",
    "developer.mcp.logs.description": "Événements MCP de ce tenant. L’activité est actualisée toutes les 15 secondes.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Événements MCP de ce tenant. L’activité est actualisée toutes les 15 secondes.",
    "developer.mcp.logs.error.audit": "Impossible de charger les journaux d’audit MCP",
    "MCP audit logs could not be loaded.": "Impossible de charger les journaux d’audit MCP",
    "developer.mcp.logs.error.load": "Impossible de charger les journaux MCP",
    "MCP logs could not be loaded.": "Impossible de charger les journaux MCP",
    "developer.mcp.logs.unknown_agent": "Agent inconnu",
    "Unknown agent": "Agent inconnu",
    "developer.mcp.logs.all_agents": "Tous les agents",
    "All agents": "Tous les agents",
    "developer.mcp.logs.updated": "Mis à jour à {time}",
    "Updated {time}": "Mis à jour à {time}",
    "developer.mcp.logs.loading": "Chargement de l’activité MCP…",
    "Loading MCP activity…": "Chargement de l’activité MCP…",
    "developer.mcp.logs.empty": "Aucun événement MCP récent trouvé pour ce tenant.",
    "No recent MCP events found for this tenant.": "Aucun événement MCP récent trouvé pour ce tenant.",
    "developer.mcp.logs.empty_agent": "Aucun événement MCP récent trouvé pour ce tenant et cet agent.",
    "No recent MCP events found for this tenant and agent.": "Aucun événement MCP récent trouvé pour ce tenant et cet agent.",
    "developer.mcp.logs.time": "Heure",
    "developer.mcp.logs.event": "Événement",
    "developer.mcp.logs.tool": "Outil",
    "developer.mcp.logs.agent": "Agent",
    "Agent": "Agent",
    "developer.mcp.logs.tenant_user": "Tenant / utilisateur",
    "Tenant / user": "Tenant / utilisateur",
    "developer.mcp.logs.scope": "Portée",
    "Scope": "Portée",
    "developer.mcp.logs.result": "Résultat",
    "developer.mcp.logs.duration": "Durée",
    "Duration": "Durée",
    "developer.mcp.logs.view_details": "Afficher les détails de {event}",
    "View details for {event}": "Afficher les détails de {event}",
    "developer.mcp.logs.tenant": "Tenant n° {id}",
    "Tenant #{id}": "Tenant n° {id}",
    "developer.mcp.logs.user": "Utilisateur n° {id}",
    "User #{id}": "Utilisateur n° {id}",
    "developer.mcp.logs.view_granted_scopes": "Afficher les portées accordées",
    "View granted scopes": "Afficher les portées accordées",
    "developer.mcp.logs.succeeded": "Réussi",
    "Succeeded": "Réussi",
    "developer.mcp.logs.failed": "Échec",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "Détails de l’événement MCP",
    "MCP event details": "Détails de l’événement MCP",
    "developer.mcp.logs.required_scope": "Portée requise",
    "Required scope": "Portée requise",
    "developer.mcp.logs.granted_scopes": "Portées accordées",
    "Granted scopes": "Portées accordées",
    "developer.mcp.logs.event_generic": "Événement",
    "developer.mcp.logs.event.tool_called": "Outil appelé",
    "Tool called": "Outil appelé",
    "developer.mcp.logs.event.connection_requested": "Connexion demandée",
    "Connection requested": "Connexion demandée",
    "developer.mcp.logs.event.connection_connected": "Connexion établie",
    "Connection connected": "Connexion établie",
    "developer.mcp.logs.event.connection_deactivated": "Connexion désactivée",
    "developer.mcp.logs.event.connection_deleted": "Connexion supprimée",
    "Connection deleted": "Connexion supprimée",
    "developer.mcp.logs.event.permissions_updated": "Autorisations mises à jour",
    "common.status.label": "Statut",
    "suppliers.title": "Fournisseurs",
    "suppliers.search": "Rechercher des fournisseurs",
    "Search suppliers": "Rechercher des fournisseurs",
    "suppliers.add": "Ajouter un fournisseur",
    "Add supplier": "Ajouter un fournisseur",
    "suppliers.deactivate": "Désactiver",
    "Deactivate": "Désactiver",
    "suppliers.empty": "Aucun fournisseur trouvé.",
    "No suppliers found.": "Aucun fournisseur trouvé.",
    "suppliers.add_title": "Ajouter un fournisseur",
    "suppliers.edit_title": "Modifier le fournisseur",
    "Edit supplier": "Modifier le fournisseur",
    "suppliers.save_changes": "Enregistrer les modifications",
    "Save changes": "Enregistrer les modifications",
    "suppliers.confirm_deactivate": "Désactiver {name} ?",
    "Deactivate {name}?": "Désactiver {name} ?",
    "suppliers.toast.updated": "Fournisseur mis à jour",
    "Supplier updated": "Fournisseur mis à jour",
    "suppliers.toast.added": "Fournisseur ajouté",
    "Supplier added": "Fournisseur ajouté",
    "suppliers.toast.deactivated": "Fournisseur désactivé",
    "Supplier deactivated": "Fournisseur désactivé",
    "suppliers.column.name": "Nom",
    "suppliers.column.code": "Code",
    "suppliers.column.contact": "Contact",
    "Contact": "Contact",
    "suppliers.field.name": "Nom",
    "suppliers.field.code": "Code",
    "suppliers.field.contact_name": "Nom du contact",
    "Contact name": "Nom du contact",
    "suppliers.field.email": "E-mail",
    "suppliers.field.phone": "Téléphone",
    "suppliers.field.currency": "Devise",
    "suppliers.field.payment_terms": "Conditions de paiement",
    "Payment terms": "Conditions de paiement",
    "suppliers.field.address": "Adresse",
    "suppliers.field.note": "Note",
    "suppliers.placeholder.name": "Nom de l’entreprise ou du fournisseur",
    "Company or supplier name": "Nom de l’entreprise ou du fournisseur",
    "suppliers.placeholder.code": "Code fournisseur",
    "Supplier code": "Code fournisseur",
    "suppliers.placeholder.contact_name": "Nom du contact",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Paiement à la livraison",
    "Cash on delivery": "Paiement à la livraison",
    "suppliers.payment_terms.payment_on_receipt": "Paiement à réception",
    "Payment on receipt": "Paiement à réception",
    "suppliers.payment_terms.payment_in_advance": "Paiement anticipé",
    "Payment in advance": "Paiement anticipé",
    "suppliers.payment_terms.net_7": "À 7 jours",
    "Net 7 days": "À 7 jours",
    "suppliers.payment_terms.net_15": "À 15 jours",
    "Net 15 days": "À 15 jours",
    "suppliers.payment_terms.net_30": "À 30 jours",
    "Net 30 days": "À 30 jours",
    "suppliers.payment_terms.net_45": "À 45 jours",
    "Net 45 days": "À 45 jours",
    "suppliers.payment_terms.net_60": "À 60 jours",
    "Net 60 days": "À 60 jours",
    "suppliers.detail_title": "Détails du fournisseur",
    "Supplier details": "Détails du fournisseur",
    "suppliers.edit": "Modifier le fournisseur",
    "suppliers.back": "Retour aux fournisseurs",
    "Back to suppliers": "Retour aux fournisseurs",
    "suppliers.loading": "Chargement du fournisseur…",
    "Loading supplier…": "Chargement du fournisseur…",
    "suppliers.unnamed": "Fournisseur sans nom",
    "Unnamed supplier": "Fournisseur sans nom",
    "suppliers.profile_description": "Profil et coordonnées du fournisseur",
    "Supplier profile and contact information": "Profil et coordonnées du fournisseur",
    "suppliers.total_spend": "Dépenses totales",
    "Total spend": "Dépenses totales",
    "suppliers.outstanding": "En attente",
    "Outstanding": "En attente",
    "suppliers.paid": "Payé",
    "suppliers.draft": "Brouillon",
    "suppliers.purchase_history": "Historique des achats",
    "Purchase history": "Historique des achats",
    "suppliers.bill.reference": "Référence",
    "Reference": "Référence",
    "suppliers.bill.date": "Date",
    "suppliers.bill.amount": "Montant",
    "suppliers.bill.number": "Facture n° {id}",
    "Bill #{id}": "Facture n° {id}",
    "suppliers.bills_empty": "Aucune facture trouvée pour ce fournisseur.",
    "No bills found for this supplier.": "Aucune facture trouvée pour ce fournisseur.",
    "inventory.locations.title": "Emplacements",
    "inventory.locations.add": "Ajouter un emplacement",
    "Add location": "Ajouter un emplacement",
    "inventory.locations.description": "Entrepôts et magasins qui détiennent du stock. Les commandes fournisseurs sont réceptionnées dans un emplacement.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Entrepôts et magasins qui détiennent du stock. Les commandes fournisseurs sont réceptionnées dans un emplacement.",
    "inventory.locations.field.name": "Nom",
    "inventory.locations.field.code": "Code",
    "inventory.locations.field.address": "Adresse",
    "inventory.locations.field.linked_store": "Magasin associé (facultatif)",
    "Linked store (optional)": "Magasin associé (facultatif)",
    "inventory.locations.field.linked_store_short": "Magasin associé",
    "Linked store": "Magasin associé",
    "inventory.locations.placeholder.name": "Entrepôt principal",
    "Main warehouse": "Entrepôt principal",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Rechercher une adresse ou un lieu",
    "Search an address or place": "Rechercher une adresse ou un lieu",
    "inventory.locations.placeholder.linked_store": "Rechercher des comptes vendeur ou magasin",
    "Search seller or store accounts": "Rechercher des comptes vendeur ou magasin",
    "inventory.locations.confirm_deactivate": "Désactiver {name} ? Il ne sera plus disponible pour les nouvelles commandes fournisseurs.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Désactiver {name} ? Il ne sera plus disponible pour les nouvelles commandes fournisseurs.",
    "inventory.locations.toast.deactivated": "Emplacement désactivé",
    "Location deactivated": "Emplacement désactivé",
    "inventory.locations.deactivate": "Désactiver",
    "inventory.locations.empty": "Aucun emplacement. Ajoutez un entrepôt ou un magasin pour commencer à réceptionner du stock.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Aucun emplacement. Ajoutez un entrepôt ou un magasin pour commencer à réceptionner du stock.",
    "inventory.locations.edit_title": "Modifier l’emplacement",
    "Edit location": "Modifier l’emplacement",
    "inventory.locations.add_title": "Ajouter un emplacement",
    "inventory.locations.form_description": "Associez un compte magasin uniquement si cet emplacement appartient à un vendeur précis.",
    "Link a store account only if this location belongs to a specific seller.": "Associez un compte magasin uniquement si cet emplacement appartient à un vendeur précis.",
    "inventory.locations.save_changes": "Enregistrer les modifications",
    "inventory.locations.toast.updated": "Emplacement mis à jour",
    "Location updated": "Emplacement mis à jour",
    "inventory.locations.toast.added": "Emplacement ajouté",
    "Location added": "Emplacement ajouté",
    "inventory.operations.title": "Opérations d’inventaire",
    "Inventory operations": "Opérations d’inventaire",
    "inventory.operations.tab.movements": "Historique des mouvements",
    "Movement history": "Historique des mouvements",
    "inventory.operations.tab.batches": "Lots et expiration",
    "Batches & expiry": "Lots et expiration",
    "inventory.operations.tab.transfers": "Ordres de transfert",
    "Transfer orders": "Ordres de transfert",
    "inventory.operations.tab.requisitions": "Demandes de stock",
    "Requisitions": "Demandes de stock",
    "inventory.operations.tab.receipts": "Réceptions de marchandises",
    "Goods received": "Réceptions de marchandises",
    "inventory.operations.description.movements": "Historique non modifiable des réceptions, ventes, transferts, retours et ajustements.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Historique non modifiable des réceptions, ventes, transferts, retours et ajustements.",
    "inventory.operations.description.batches": "Suivez les lots, dates d’expiration, états et unités sans modifier le registre de stock ici.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Suivez les lots, dates d’expiration, états et unités sans modifier le registre de stock ici.",
    "inventory.operations.description.transfers": "Déplacez le stock entre emplacements et suivez l’expédition, la réception et les écarts.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Déplacez le stock entre emplacements et suivez l’expédition, la réception et les écarts.",
    "inventory.operations.description.requisitions": "Examinez les demandes de stock internes. Leur approbation crée automatiquement un ordre de transfert.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Examinez les demandes de stock internes. Leur approbation crée automatiquement un ordre de transfert.",
    "inventory.operations.description.receipts": "Créez des réceptions et suivez les opérations en cours, partielles ou terminées.",
    "Create receipts and track open, partial, and closed receiving work.": "Créez des réceptions et suivez les opérations en cours, partielles ou terminées.",
    "inventory.operations.overview": "Vue d’ensemble",
    "inventory.operations.new_transfer": "Nouveau transfert",
    "New transfer": "Nouveau transfert",
    "inventory.operations.new_requisition": "Nouvelle demande de stock",
    "New requisition": "Nouvelle demande de stock",
    "inventory.operations.new_receipt": "Nouvelle réception",
    "New receipt": "Nouvelle réception",
    "inventory.operations.search": "Rechercher",
    "inventory.operations.search_view": "Rechercher dans cette vue",
    "Search this view": "Rechercher dans cette vue",
    "inventory.operations.search_products": "Rechercher des produits",
    "Search products": "Rechercher des produits",
    "inventory.operations.search_purchase_order": "Rechercher des commandes fournisseurs (facultatif)",
    "Search purchase orders (optional)": "Rechercher des commandes fournisseurs (facultatif)",
    "inventory.operations.listing_number": "Annonce n° {id}",
    "inventory.operations.location_number": "Emplacement n° {id}",
    "Location #{id}": "Emplacement n° {id}",
    "inventory.operations.no_sku": "Sans référence",
    "No SKU": "Sans référence",
    "inventory.operations.order_status": "Statut : {status}",
    "Status: {status}": "Statut : {status}",
    "inventory.operations.field.receiving_location": "Emplacement de réception",
    "Receiving location": "Emplacement de réception",
    "inventory.operations.field.purchase_order": "Commande fournisseur",
    "inventory.operations.field.reference": "Référence",
    "inventory.operations.field.note": "Note",
    "inventory.operations.field.from_location": "Emplacement de départ",
    "From location": "Emplacement de départ",
    "inventory.operations.field.supplying_location": "Emplacement fournisseur",
    "Supplying location": "Emplacement fournisseur",
    "inventory.operations.field.to_location": "Emplacement d’arrivée",
    "To location": "Emplacement d’arrivée",
    "inventory.operations.field.requesting_location": "Emplacement demandeur",
    "Requesting location": "Emplacement demandeur",
    "inventory.operations.field.product": "Produit",
    "Product": "Produit",
    "inventory.operations.field.quantity": "Quantité",
    "Quantity": "Quantité",
    "inventory.operations.field.location": "Emplacement",
    "inventory.operations.placeholder.delivery_note": "Bon de livraison fournisseur",
    "Supplier delivery note": "Bon de livraison fournisseur",
    "inventory.operations.placeholder.receiving_note": "Note de réception facultative",
    "Optional receiving note": "Note de réception facultative",
    "inventory.operations.placeholder.transfer_reference": "Référence du transfert",
    "Transfer reference": "Référence du transfert",
    "inventory.operations.placeholder.request_reference": "Référence de la demande",
    "Request reference": "Référence de la demande",
    "inventory.operations.placeholder.context": "Contexte facultatif",
    "Optional context": "Contexte facultatif",
    "inventory.operations.create.transfer_title": "Nouvel ordre de transfert",
    "New transfer order": "Nouvel ordre de transfert",
    "inventory.operations.create.requisition_title": "Nouvelle demande de stock",
    "inventory.operations.create.receipt_title": "Nouvelle réception de marchandises",
    "New goods receipt": "Nouvelle réception de marchandises",
    "inventory.operations.create.transfer_description": "Déplacez le stock entre deux emplacements.",
    "Move stock between two locations.": "Déplacez le stock entre deux emplacements.",
    "inventory.operations.create.requisition_description": "Demandez du stock à un autre emplacement.",
    "Request stock from another location.": "Demandez du stock à un autre emplacement.",
    "inventory.operations.create.receipt_description": "Créez une réception avant de scanner ou d’ajouter des colis.",
    "Create a receipt before scanning or adding boxes.": "Créez une réception avant de scanner ou d’ajouter des colis.",
    "inventory.operations.toast.transfer_created": "Ordre de transfert créé",
    "Transfer order created": "Ordre de transfert créé",
    "inventory.operations.toast.requisition_created": "Demande de stock créée",
    "Requisition created": "Demande de stock créée",
    "inventory.operations.toast.receipt_created": "Réception de marchandises créée",
    "Goods receipt created": "Réception de marchandises créée",
    "inventory.operations.toast.transfer_dispatched": "Transfert expédié",
    "Transfer dispatched": "Transfert expédié",
    "inventory.operations.toast.transfer_received": "Transfert réceptionné",
    "Transfer received": "Transfert réceptionné",
    "inventory.operations.toast.transfer_cancelled": "Transfert annulé",
    "Transfer cancelled": "Transfert annulé",
    "inventory.operations.toast.requisition_approved": "Demande de stock approuvée",
    "Requisition approved": "Demande de stock approuvée",
    "inventory.operations.toast.requisition_rejected": "Demande de stock refusée",
    "Requisition rejected": "Demande de stock refusée",
    "inventory.operations.action.dispatch": "Expédier",
    "Dispatch": "Expédier",
    "inventory.operations.action.receive": "Réceptionner",
    "Receive": "Réceptionner",
    "inventory.operations.action.approve": "Approuver",
    "Approve": "Approuver",
    "inventory.operations.action.reject": "Refuser",
    "Reject": "Refuser",
    "inventory.operations.column.when": "Date",
    "When": "Date",
    "inventory.operations.column.event": "Événement",
    "inventory.operations.column.change": "Variation",
    "inventory.operations.column.after": "Après",
    "After": "Après",
    "inventory.operations.column.order": "Ordre",
    "inventory.operations.column.route": "Trajet",
    "Route": "Trajet",
    "inventory.operations.column.lines": "Lignes",
    "Lines": "Lignes",
    "inventory.operations.column.expected": "Prévu",
    "inventory.operations.column.request": "Demande",
    "Request": "Demande",
    "inventory.operations.column.request_supply": "Demande / approvisionnement",
    "Request / supply": "Demande / approvisionnement",
    "inventory.operations.column.created": "Créé le",
    "inventory.operations.column.receipt": "Réception",
    "Receipt": "Réception",
    "inventory.operations.empty.movements": "Aucun mouvement de stock enregistré.",
    "No stock movements recorded yet.": "Aucun mouvement de stock enregistré.",
    "inventory.operations.empty.batches": "Aucun lot d’inventaire enregistré.",
    "No inventory batches have been recorded yet.": "Aucun lot d’inventaire enregistré.",
    "inventory.operations.empty.transfers": "Aucun ordre de transfert pour le moment.",
    "No transfer orders yet.": "Aucun ordre de transfert pour le moment.",
    "inventory.operations.empty.requisitions": "Aucune demande de stock pour le moment.",
    "No requisitions yet.": "Aucune demande de stock pour le moment.",
    "inventory.operations.empty.receipts": "Aucune réception de marchandises pour le moment.",
    "No goods receipts yet.": "Aucune réception de marchandises pour le moment.",
    "inventory.operations.batch.edit_title": "Modifier le lot",
    "Edit batch": "Modifier le lot",
    "inventory.operations.batch.edit_description": "La quantité du lot est modifiée par un ajustement de stock. Ce formulaire ne modifie que son identité et ses champs de suivi.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "La quantité du lot est modifiée par un ajustement de stock. Ce formulaire ne modifie que son identité et ses champs de suivi.",
    "inventory.operations.batch.save": "Enregistrer le lot",
    "Save batch": "Enregistrer le lot",
    "inventory.operations.batch.lot_number": "Numéro de lot",
    "Lot number": "Numéro de lot",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Date d’expiration",
    "inventory.operations.batch.condition": "État",
    "inventory.operations.batch.condition_placeholder": "bon",
    "good": "bon",
    "inventory.operations.batch.unit": "Unité de mesure",
    "Unit of measure": "Unité de mesure",
    "inventory.operations.batch.unit_placeholder": "boîte, pièce, kg",
    "box, piece, kg": "boîte, pièce, kg",
    "inventory.operations.batch.no_expiry": "Sans date d’expiration",
    "No expiry": "Sans date d’expiration",
    "inventory.operations.batch.updated": "Lot mis à jour",
    "Batch updated": "Lot mis à jour",
    "common.status.in_transit": "En transit",
    "In transit": "En transit",
    "common.status.pending": "En attente",
    "Pending": "En attente",
    "common.status.approved": "Approuvé",
    "common.status.rejected": "Refusé",
    "common.status.cancelled": "Annulé",
    "common.status.received": "Réceptionné",
    "common.status.sent": "Envoyée",
    "Sent": "Envoyée",
    "common.note": "Remarque",
    "common.optional": "Facultatif",
    "Optional": "Facultatif",
    "common.error.generic": "Une erreur s’est produite.",
    "Something went wrong.": "Une erreur s’est produite.",
    "purchase_orders.title": "Bons de commande",
    "purchase_orders.title_singular": "Bon de commande",
    "purchase_orders.tab.all": "Toutes",
    "purchase_orders.tab.partial": "Partiellement réceptionnée",
    "Partially received": "Partiellement réceptionnée",
    "purchase_orders.create.new": "Nouveau bon de commande",
    "New purchase order": "Nouveau bon de commande",
    "purchase_orders.create.title": "Nouveau bon de commande",
    "purchase_orders.create.subtitle": "Enregistré comme brouillon. Marquez-le comme envoyé une fois transmis au fournisseur.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Enregistré comme brouillon. Marquez-le comme envoyé une fois transmis au fournisseur.",
    "purchase_orders.create.submit": "Créer le brouillon",
    "Create draft": "Créer le brouillon",
    "purchase_orders.field.location": "Emplacement de réception",
    "purchase_orders.field.supplier": "Fournisseur",
    "Supplier": "Fournisseur",
    "purchase_orders.field.reference": "Référence fournisseur",
    "Supplier reference": "Référence fournisseur",
    "purchase_orders.field.expected_delivery": "Livraison prévue",
    "Expected delivery": "Livraison prévue",
    "purchase_orders.field.products": "Produits",
    "Products": "Produits",
    "purchase_orders.select_location": "Sélectionner un emplacement",
    "Select location": "Sélectionner un emplacement",
    "purchase_orders.no_locations": "Aucun emplacement configuré",
    "No locations set up": "Aucun emplacement configuré",
    "purchase_orders.add_location": "Ajoutez d’abord un emplacement →",
    "Add a location first →": "Ajoutez d’abord un emplacement →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Tous les emplacements",
    "All locations": "Tous les emplacements",
    "purchase_orders.location_number": "Emplacement n° {id}",
    "purchase_orders.search_products": "Rechercher des produits à ajouter",
    "Search products to add": "Rechercher des produits à ajouter",
    "purchase_orders.in_stock": "En stock : {count}",
    "In stock: {count}": "En stock : {count}",
    "purchase_orders.column.order": "Commande",
    "purchase_orders.column.product": "Produit",
    "purchase_orders.column.quantity": "Quantité",
    "purchase_orders.column.ordered": "Commandée",
    "Ordered": "Commandée",
    "purchase_orders.column.received": "Reçue",
    "purchase_orders.column.remaining": "Restant",
    "purchase_orders.column.unit_cost": "Coût unitaire",
    "Unit cost": "Coût unitaire",
    "purchase_orders.column.supplier": "Fournisseur",
    "purchase_orders.column.location": "Emplacement",
    "purchase_orders.column.progress": "Reçu",
    "purchase_orders.column.value": "Valeur",
    "purchase_orders.column.expected": "Prévue",
    "purchase_orders.column.status": "Statut",
    "purchase_orders.action.mark_sent": "Marquer comme envoyée",
    "Mark as sent": "Marquer comme envoyée",
    "purchase_orders.action.receive": "Réceptionner",
    "purchase_orders.action.receive_stock": "Réceptionner le stock",
    "Receive stock": "Réceptionner le stock",
    "purchase_orders.action.cancel_order": "Annuler la commande",
    "Cancel order": "Annuler la commande",
    "purchase_orders.action.close_order": "Clôturer la commande",
    "Close order": "Clôturer la commande",
    "purchase_orders.receive.subtitle": "Saisissez les articles reçus. Le stock de l’emplacement sera mis à jour à la confirmation.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Saisissez les articles reçus. Le stock de l’emplacement sera mis à jour à la confirmation.",
    "purchase_orders.receive.now": "À réceptionner",
    "Receive now": "À réceptionner",
    "purchase_orders.receive.confirm": "Confirmer la réception",
    "Confirm receipt": "Confirmer la réception",
    "purchase_orders.confirm.cancel": "Annuler ce bon de commande ?",
    "Cancel this purchase order?": "Annuler ce bon de commande ?",
    "purchase_orders.empty.all": "Aucun bon de commande. Créez-en un pour réapprovisionner le stock.",
    "No purchase orders yet. Create one to restock inventory.": "Aucun bon de commande. Créez-en un pour réapprovisionner le stock.",
    "purchase_orders.empty.filtered": "Aucun bon de commande avec ce statut.",
    "No purchase orders with this status.": "Aucun bon de commande avec ce statut.",
    "purchase_orders.error.location_required": "Choisissez un emplacement de réception.",
    "Choose a receiving location.": "Choisissez un emplacement de réception.",
    "purchase_orders.error.product_required": "Ajoutez au moins un produit.",
    "Add at least one product.": "Ajoutez au moins un produit.",
    "purchase_orders.error.quantity_positive": "Chaque quantité doit être supérieure à 0.",
    "Every quantity must be greater than 0.": "Chaque quantité doit être supérieure à 0.",
    "purchase_orders.error.receive_quantity": "Saisissez une quantité pour au moins un article.",
    "Enter a quantity for at least one item.": "Saisissez une quantité pour au moins un article.",
    "purchase_orders.toast.created": "Bon de commande créé comme brouillon",
    "Purchase order created as draft": "Bon de commande créé comme brouillon",
    "purchase_orders.toast.sent": "Marquée comme envoyée",
    "Marked as sent": "Marquée comme envoyée",
    "purchase_orders.toast.received": "Stock réceptionné et inventaire mis à jour",
    "Stock received and inventory updated": "Stock réceptionné et inventaire mis à jour",
    "purchase_orders.toast.cancelled": "Bon de commande annulé",
    "Purchase order cancelled": "Bon de commande annulé",
    "purchase_orders.toast.closed": "Bon de commande clôturé",
    "Purchase order closed": "Bon de commande clôturé",
    "schedule.title": "Planning",
    "schedule.view.month": "Mois",
    "Month": "Mois",
    "schedule.view.week": "Semaine",
    "Week": "Semaine",
    "schedule.view.day": "Jour",
    "Day": "Jour",
    "schedule.today": "Aujourd’hui",
    "Today": "Aujourd’hui",
    "schedule.order_number": "Commande n° {number}",
    "Order #{number}": "Commande n° {number}",
    "schedule.customer": "Client",
    "schedule.more_events": "+{count} de plus",
    "+{count} more": "+{count} de plus",
    "schedule.payment.paid": "Payé",
    "schedule.payment.pending": "En attente",
    "schedule.payment.failed": "Échoué",
    "schedule.booking_details": "Détails de la réservation",
    "Booking details": "Détails de la réservation",
    "schedule.order_reference": "Référence de commande",
    "schedule.amount": "Montant",
    "schedule.start": "Début",
    "schedule.end": "Fin",
    "schedule.item_number": "Article {number}",
    "Item {number}": "Article {number}",
    "schedule.view_order": "Voir la commande complète",
    "View full order": "Voir la commande complète",
    "onboarding.greeting.morning": "Bonjour",
    "Good morning": "Bonjour",
    "onboarding.greeting.morning_named": "Bonjour {name}",
    "Good morning {name}": "Bonjour {name}",
    "onboarding.greeting.afternoon": "Bon après-midi",
    "Good afternoon": "Bon après-midi",
    "onboarding.greeting.afternoon_named": "Bon après-midi {name}",
    "Good afternoon {name}": "Bon après-midi {name}",
    "onboarding.greeting.evening": "Bonsoir",
    "Good evening": "Bonsoir",
    "onboarding.greeting.evening_named": "Bonsoir {name}",
    "Good evening {name}": "Bonsoir {name}",
    "onboarding.greeting.night": "Bonjour",
    "Hello": "Bonjour",
    "onboarding.greeting.night_named": "Bonjour {name}",
    "Hello {name}": "Bonjour {name}",
    "onboarding.encouragement": "Créez la plateforme dont vous rêvez.",
    "Build the platform you wish existed.": "Créez la plateforme dont vous rêvez.",
    "onboarding.plan.personalized": "Parcours de lancement personnalisé",
    "Personalized launch plan": "Parcours de lancement personnalisé",
    "onboarding.plan.label": "Parcours de lancement",
    "Launch plan": "Parcours de lancement",
    "onboarding.plan.refining": "Amélioration de votre parcours…",
    "Refining your path…": "Amélioration de votre parcours…",
    "onboarding.plan.getting_ready": "Votre parcours personnalisé se prépare.",
    "Your personalized plan is getting ready.": "Votre parcours personnalisé se prépare.",
    "onboarding.checklist.preview": "Aperçu de la liste de contrôle",
    "Checklist preview": "Aperçu de la liste de contrôle",
    "onboarding.workspace.live": "Espace de travail actif",
    "Live workspace": "Espace de travail actif",
    "onboarding.workspace.no_tenant": "Aucun espace client actif connecté",
    "No live tenant connected": "Aucun espace client actif connecté",
    "onboarding.workspace.domain_pending": "Domaine en attente",
    "Domain pending": "Domaine en attente",
    "onboarding.progress.summary": "{completed} actions de lancement sur {total} terminées",
    "{completed} of {total} launch actions done": "{completed} actions de lancement sur {total} terminées",
    "onboarding.progress.auto_detected": "{count} détectées automatiquement",
    "{count} auto-detected": "{count} détectées automatiquement",
    "onboarding.progress.auto_detected_short": "Détectée automatiquement",
    "Auto-detected": "Détectée automatiquement",
    "onboarding.progress.saving": "Enregistrement de la progression…",
    "Saving progress…": "Enregistrement de la progression…",
    "onboarding.progress.checking": "Vérification…",
    "Checking…": "Vérification…",
    "onboarding.progress.mark_done": "Marquer comme terminé",
    "Mark done": "Marquer comme terminé",
    "onboarding.progress.unlocked": "Débloqué : {impact}",
    "Unlocked: {impact}": "Débloqué : {impact}",
    "onboarding.next_task": "Prochaine étape recommandée",
    "Next best task": "Prochaine étape recommandée",
    "onboarding.upcoming.title": "Prochaines tâches",
    "Upcoming tasks": "Prochaines tâches",
    "onboarding.upcoming.summary_one": "{count} tâche après l’action en cours.",
    "{count} task queued after the current action.": "{count} tâche après l’action en cours.",
    "onboarding.upcoming.summary_other": "{count} tâches après l’action en cours.",
    "{count} tasks queued after the current action.": "{count} tâches après l’action en cours.",
    "onboarding.upcoming.hide": "Masquer les tâches",
    "Hide tasks": "Masquer les tâches",
    "onboarding.upcoming.view_all": "Afficher toutes les tâches",
    "View all tasks": "Afficher toutes les tâches",
    "onboarding.complete.title": "Excellent début. Votre base est en ligne.",
    "Great start. Your foundation is live.": "Excellent début. Votre base est en ligne.",
    "onboarding.complete.description": "Continuez pour débloquer les outils de croissance comme les promotions et les communications.",
    "Keep going to unlock growth essentials like promotions and communications.": "Continuez pour débloquer les outils de croissance comme les promotions et les communications.",
    "onboarding.full_checklist.title": "Liste de contrôle complète",
    "Full checklist": "Liste de contrôle complète",
    "onboarding.full_checklist.description": "Poursuivez la configuration dans le même espace.",
    "Continue setup in the same experience.": "Poursuivez la configuration dans le même espace.",
    "onboarding.full_checklist.back": "Retour au parcours de lancement",
    "Back to launch path": "Retour au parcours de lancement",
    "onboarding.completed.title": "Terminé",
    "onboarding.completed.summary_one": "{count} tâche terminée",
    "{count} task completed": "{count} tâche terminée",
    "onboarding.completed.summary_other": "{count} tâches terminées",
    "{count} tasks completed": "{count} tâches terminées",
    "onboarding.completed.open_again": "Ouvrir à nouveau",
    "Open again": "Ouvrir à nouveau",
    "onboarding.plan.marketplace.eyebrow": "Parcours de lancement de la marketplace",
    "Marketplace launch path": "Parcours de lancement de la marketplace",
    "onboarding.plan.marketplace.title": "Lancez votre marketplace",
    "Launch your marketplace": "Lancez votre marketplace",
    "onboarding.plan.marketplace.title_named": "Faites de {project} une marketplace opérationnelle",
    "Turn {project} into a working marketplace": "Faites de {project} une marketplace opérationnelle",
    "onboarding.plan.marketplace.subtitle": "Ouvrez le site créez la première annonce et testez le parcours acheteur.",
    "Open the live site create the first listing and test the buyer journey.": "Ouvrez le site créez la première annonce et testez le parcours acheteur.",
    "onboarding.plan.marketplace.value_moment": "Premier résultat : un vendeur peut publier et un acheteur peut agir.",
    "First value moment: a seller can publish and a buyer can act.": "Premier résultat : un vendeur peut publier et un acheteur peut agir.",
    "onboarding.plan.marketplace.why_title": "Pourquoi les équipes terminent",
    "Why teams finish this": "Pourquoi les équipes terminent",
    "onboarding.plan.marketplace.why_body": "Les résultats réels des acheteurs et vendeurs donnent du sens à chaque étape et entretiennent la dynamique.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Les résultats réels des acheteurs et vendeurs donnent du sens à chaque étape et entretiennent la dynamique.",
    "onboarding.plan.store.eyebrow": "Parcours de lancement de la boutique",
    "Store launch path": "Parcours de lancement de la boutique",
    "onboarding.plan.store.title": "Préparez votre boutique pour la première commande",
    "Get your store ready for the first order": "Préparez votre boutique pour la première commande",
    "onboarding.plan.store.title_named": "Préparez {project} pour la première commande",
    "Make {project} ready for the first order": "Préparez {project} pour la première commande",
    "onboarding.plan.store.subtitle": "Ajoutez un produit vérifiez la boutique et configurez les éléments essentiels au paiement.",
    "Add a product check the storefront and complete checkout essentials.": "Ajoutez un produit vérifiez la boutique et configurez les éléments essentiels au paiement.",
    "onboarding.plan.store.value_moment": "Premier résultat : un produit est visible et le paiement peut être testé.",
    "First value moment: a product is visible and checkout can be tested.": "Premier résultat : un produit est visible et le paiement peut être testé.",
    "onboarding.plan.store.why_title": "Pourquoi les équipes terminent",
    "onboarding.plan.store.why_body": "Passez rapidement du produit au paiement pour concrétiser la boutique et garder votre motivation.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Passez rapidement du produit au paiement pour concrétiser la boutique et garder votre motivation.",
    "onboarding.plan.booking.eyebrow": "Parcours de lancement des réservations",
    "Booking launch path": "Parcours de lancement des réservations",
    "onboarding.plan.booking.title": "Rendez votre plateforme réservable",
    "Make your platform bookable": "Rendez votre plateforme réservable",
    "onboarding.plan.booking.title_named": "Rendez {project} réservable",
    "Make {project} bookable": "Rendez {project} réservable",
    "onboarding.plan.booking.subtitle": "Créez le premier service ouvrez l’expérience client et testez une réservation.",
    "Create the first service open the customer experience and test a reservation.": "Créez le premier service ouvrez l’expérience client et testez une réservation.",
    "onboarding.plan.booking.value_moment": "Premier résultat : un client peut demander un horaire ou un créneau.",
    "First value moment: a customer can request a time or slot.": "Premier résultat : un client peut demander un horaire ou un créneau.",
    "onboarding.plan.booking.why_title": "Pourquoi les équipes terminent",
    "onboarding.plan.booking.why_body": "Validez rapidement le parcours de réservation pour gagner en confiance avant de l’étendre.",
    "Validate the full booking journey early to build confidence before expanding.": "Validez rapidement le parcours de réservation pour gagner en confiance avant de l’étendre.",
    "onboarding.plan.digital.eyebrow": "Parcours de lancement numérique",
    "Digital launch path": "Parcours de lancement numérique",
    "onboarding.plan.digital.title": "Commencez à vendre vos produits numériques",
    "Start selling your digital products": "Commencez à vendre vos produits numériques",
    "onboarding.plan.digital.title_named": "Préparez {project} à vendre des produits numériques",
    "Make {project} ready to sell digital products": "Préparez {project} à vendre des produits numériques",
    "onboarding.plan.digital.subtitle": "Ajoutez un produit numérique prévisualisez le parcours client et vérifiez les paiements.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Ajoutez un produit numérique prévisualisez le parcours client et vérifiez les paiements.",
    "onboarding.plan.digital.value_moment": "Premier résultat : un acheteur peut découvrir et acheter un fichier.",
    "First value moment: a buyer can discover and purchase a file.": "Premier résultat : un acheteur peut découvrir et acheter un fichier.",
    "onboarding.plan.digital.why_title": "Pourquoi les équipes terminent",
    "onboarding.plan.digital.why_body": "Validez rapidement la découverte et l’achat pour faire de l’extension du catalogue une étape de croissance.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Validez rapidement la découverte et l’achat pour faire de l’extension du catalogue une étape de croissance.",
    "onboarding.plan.campaign.eyebrow": "Parcours de lancement de la campagne",
    "Campaign launch path": "Parcours de lancement de la campagne",
    "onboarding.plan.campaign.title": "Lancez votre plateforme de campagne",
    "Launch your campaign platform": "Lancez votre plateforme de campagne",
    "onboarding.plan.campaign.title_named": "Préparez {project} à accueillir des contributeurs",
    "Make {project} ready for supporters": "Préparez {project} à accueillir des contributeurs",
    "onboarding.plan.campaign.subtitle": "Créez une campagne prévisualisez la page publique et testez le parcours de contribution.",
    "Create a campaign preview the public page and test the contribution journey.": "Créez une campagne prévisualisez la page publique et testez le parcours de contribution.",
    "onboarding.plan.campaign.value_moment": "Premier résultat : un contributeur peut comprendre et participer.",
    "First value moment: a supporter can understand and contribute.": "Premier résultat : un contributeur peut comprendre et participer.",
    "onboarding.plan.campaign.why_title": "Pourquoi les équipes terminent",
    "onboarding.plan.campaign.why_body": "Clarifiez rapidement le projet et les contributions pour aider les soutiens à agir en confiance.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Clarifiez rapidement le projet et les contributions pour aider les soutiens à agir en confiance.",
    "onboarding.plan.creator.eyebrow": "Parcours de lancement créateur",
    "Creator launch path": "Parcours de lancement créateur",
    "onboarding.plan.creator.title": "Préparez-vous à rencontrer votre premier public",
    "Get ready for your first audience": "Préparez-vous à rencontrer votre premier public",
    "onboarding.plan.creator.title_named": "Préparez {project} à rencontrer son premier public",
    "Make {project} ready for its first audience": "Préparez {project} à rencontrer son premier public",
    "onboarding.plan.creator.subtitle": "Publiez une offre claire façonnez l’expérience et facilitez la découverte et le soutien de votre travail.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Publiez une offre claire façonnez l’expérience et facilitez la découverte et le soutien de votre travail.",
    "onboarding.plan.creator.value_moment": "Premier résultat : votre travail est visible et prêt à être partagé.",
    "First value moment: your work is visible and ready to share.": "Premier résultat : votre travail est visible et prêt à être partagé.",
    "onboarding.plan.creator.why_title": "Pourquoi cette méthode fonctionne",
    "Why this works": "Pourquoi cette méthode fonctionne",
    "onboarding.plan.creator.why_body": "Concentrez-vous sur une première publication réelle avant d’ajouter des outils ou de la complexité.",
    "Focus on publishing something real before adding more tools or complexity.": "Concentrez-vous sur une première publication réelle avant d’ajouter des outils ou de la complexité.",
    "onboarding.step.open_live_site.title": "Ouvrir le site actif",
    "Open the live experience": "Ouvrir le site actif",
    "onboarding.step.open_live_site.description": "Commencez par ce que voient les clients. Le projet devient concret avant la configuration.",
    "onboarding.step.open_live_site.description_domain": "Ouvrez {domain} pour voir ce que voient vos clients. Le projet devient concret avant la prochaine étape.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Ouvrez {domain} pour voir ce que voient vos clients. Le projet devient concret avant la prochaine étape.",
    "onboarding.step.open_live_site.cta": "Ouvrir le site",
    "Open site": "Ouvrir le site",
    "onboarding.step.open_live_site.cta_domain": "Ouvrir {domain}",
    "Open {domain}": "Ouvrir {domain}",
    "onboarding.step.open_live_site.impact": "Confirme que le projet est déjà en ligne.",
    "onboarding.step.create_supply_shape.title": "Créer la première catégorie",
    "Create the first category": "Créer la première catégorie",
    "onboarding.step.create_supply_shape.description": "Offrez un point de départ clair aux vendeurs et acheteurs. Les catégories organisent la découverte.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Offrez un point de départ clair aux vendeurs et acheteurs. Les catégories organisent la découverte.",
    "onboarding.step.create_supply_shape.cta": "Ajouter une catégorie",
    "Add category": "Ajouter une catégorie",
    "onboarding.step.create_supply_shape.impact": "Transforme une marketplace vide en espace consultable.",
    "Turns a blank marketplace into a browsable one.": "Transforme une marketplace vide en espace consultable.",
    "onboarding.step.post_first_listing.title": "Publier une annonce test",
    "Post one test listing": "Publier une annonce test",
    "onboarding.step.post_first_listing.description": "Suivez le parcours vendeur et publiez le premier article que les acheteurs pourront consulter.",
    "Experience the seller path and publish the first item buyers can inspect.": "Suivez le parcours vendeur et publiez le premier article que les acheteurs pourront consulter.",
    "onboarding.step.post_first_listing.cta": "Publier une annonce",
    "Post listing": "Publier une annonce",
    "onboarding.step.post_first_listing.impact": "Crée l’offre qui active la marketplace.",
    "Creates supply the core marketplace activation event.": "Crée l’offre qui active la marketplace.",
    "onboarding.step.test_buyer_action.title": "Agir comme un acheteur",
    "Act like a buyer": "Agir comme un acheteur",
    "onboarding.step.test_buyer_action.description": "Parcourez le site manifestez votre intérêt et testez la commande comme un client.",
    "Browse add interest and test the order path to experience what customers will see.": "Parcourez le site manifestez votre intérêt et testez la commande comme un client.",
    "onboarding.step.test_buyer_action.cta": "Tester le parcours acheteur",
    "Test buyer flow": "Tester le parcours acheteur",
    "onboarding.step.test_buyer_action.impact": "Valide l’ensemble du parcours acheteur.",
    "Validates the buyer journey end to end.": "Valide l’ensemble du parcours acheteur.",
    "onboarding.step.add_first_product.title": "Ajouter un vrai produit",
    "Add one real product": "Ajouter un vrai produit",
    "onboarding.step.add_first_product.description": "Un produit complet définit mieux votre catalogue qu’une longue visite des paramètres.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Un produit complet définit mieux votre catalogue qu’une longue visite des paramètres.",
    "onboarding.step.add_first_product.cta": "Ajouter un produit",
    "Add product": "Ajouter un produit",
    "onboarding.step.add_first_product.impact": "Crée le premier article à vendre.",
    "Creates the first sellable item.": "Crée le premier article à vendre.",
    "onboarding.step.setup_payments.title": "Connecter les paiements",
    "Connect payments": "Connecter les paiements",
    "onboarding.step.setup_payments.description": "Activez les transactions pour que les utilisateurs puissent finaliser leurs achats simplement.",
    "Enable real transactions so users can complete purchases without friction.": "Activez les transactions pour que les utilisateurs puissent finaliser leurs achats simplement.",
    "onboarding.step.setup_payments.cta": "Configurer les paiements",
    "Set up payments": "Configurer les paiements",
    "onboarding.step.setup_payments.impact": "Ouvre la voie aux revenus.",
    "onboarding.step.setup_delivery.title": "Définir le mode de livraison ou de service",
    "Set shipping or service method": "Définir le mode de livraison ou de service",
    "onboarding.step.setup_delivery.description": "Définissez l’exécution des commandes pour rendre le paiement prévisible.",
    "onboarding.step.setup_delivery.cta": "Configurer la livraison",
    "Configure delivery": "Configurer la livraison",
    "onboarding.step.setup_delivery.impact": "Clarifie l’exécution au moment du paiement.",
    "Makes fulfillment clear at checkout.": "Clarifie l’exécution au moment du paiement.",
    "onboarding.step.create_bookable_listing.title": "Créer une offre réservable",
    "Create one bookable offer": "Créer une offre réservable",
    "onboarding.step.create_bookable_listing.description": "Ajoutez le service l’événement la location ou le rendez-vous à réserver en premier.",
    "Add the service event rental or appointment customers should book first.": "Ajoutez le service l’événement la location ou le rendez-vous à réserver en premier.",
    "onboarding.step.create_bookable_listing.cta": "Créer une offre",
    "Create offer": "Créer une offre",
    "onboarding.step.create_bookable_listing.impact": "Crée la première offre réservable.",
    "Creates the first bookable unit.": "Crée la première offre réservable.",
    "onboarding.step.shape_details.title": "Ajouter les détails de réservation",
    "Add booking details": "Ajouter les détails de réservation",
    "onboarding.step.shape_details.description": "Utilisez des catégories et des champs pour recueillir les informations utiles aux clients.",
    "Use categories and fields to capture what customers need before they commit.": "Utilisez des catégories et des champs pour recueillir les informations utiles aux clients.",
    "onboarding.step.shape_details.cta": "Configurer les champs",
    "Set up fields": "Configurer les champs",
    "onboarding.step.shape_details.impact": "Facilite la comparaison et renforce la confiance.",
    "Makes the offer easier to compare and trust.": "Facilite la comparaison et renforce la confiance.",
    "onboarding.step.test_booking.title": "Tester le parcours client",
    "Test the customer path": "Tester le parcours client",
    "onboarding.step.test_booking.description": "Ouvrez le parcours public et vérifiez que les clients peuvent passer à l’action.",
    "Open the public flow and verify customers can move from interest to action.": "Ouvrez le parcours public et vérifiez que les clients peuvent passer à l’action.",
    "onboarding.step.test_booking.cta": "Tester la réservation",
    "Test booking": "Tester la réservation",
    "onboarding.step.test_booking.impact": "Valide le parcours de réservation.",
    "Validates the booking journey.": "Valide le parcours de réservation.",
    "onboarding.step.upload_digital_product.title": "Ajouter un produit numérique",
    "Upload one digital product": "Ajouter un produit numérique",
    "onboarding.step.upload_digital_product.description": "Complétez le premier article téléchargeable pour le prévisualiser et le vendre.",
    "Make the first downloadable item complete enough to preview and sell.": "Complétez le premier article téléchargeable pour le prévisualiser et le vendre.",
    "onboarding.step.upload_digital_product.cta": "Ajouter un produit numérique",
    "Add digital product": "Ajouter un produit numérique",
    "onboarding.step.upload_digital_product.impact": "Crée votre premier produit numérique à vendre.",
    "Creates your first sellable digital asset.": "Crée votre premier produit numérique à vendre.",
    "onboarding.step.test_purchase.title": "Tester le parcours d’achat",
    "Test purchase flow": "Tester le parcours d’achat",
    "onboarding.step.test_purchase.description": "Prévisualisez le parcours des acheteurs de la découverte au paiement.",
    "Preview what buyers see from discovery through checkout.": "Prévisualisez le parcours des acheteurs de la découverte au paiement.",
    "onboarding.step.test_purchase.cta": "Tester le paiement",
    "Test checkout": "Tester le paiement",
    "onboarding.step.test_purchase.impact": "Confirme le parcours acheteur.",
    "Confirms the buyer journey.": "Confirme le parcours acheteur.",
    "onboarding.step.create_campaign.title": "Créer la première campagne",
    "Create the first campaign": "Créer la première campagne",
    "onboarding.step.create_campaign.description": "Ajoutez la campagne ou la cause que les contributeurs doivent découvrir en premier.",
    "Add the campaign or cause page supporters should understand first.": "Ajoutez la campagne ou la cause que les contributeurs doivent découvrir en premier.",
    "onboarding.step.create_campaign.cta": "Créer une campagne",
    "Create campaign": "Créer une campagne",
    "onboarding.step.create_campaign.impact": "Crée une première raison d’agir publiquement.",
    "Creates the first public reason to act.": "Crée une première raison d’agir publiquement.",
    "onboarding.step.setup_payments_campaign.title": "Connecter les paiements de contribution",
    "Connect contribution payments": "Connecter les paiements de contribution",
    "onboarding.step.setup_payments_campaign.description": "L’intention des contributeurs compte lorsqu’ils peuvent finaliser leur participation.",
    "Supporter intent matters when they can complete a contribution.": "L’intention des contributeurs compte lorsqu’ils peuvent finaliser leur participation.",
    "onboarding.step.setup_payments_campaign.cta": "Configurer les paiements",
    "onboarding.step.setup_payments_campaign.impact": "Permet de recevoir de vraies contributions.",
    "Enables real contributions.": "Permet de recevoir de vraies contributions.",
    "onboarding.step.test_supporter_flow.title": "Tester le parcours contributeur",
    "Test supporter flow": "Tester le parcours contributeur",
    "onboarding.step.test_supporter_flow.description": "Ouvrez le parcours public et vérifiez que le message et l’action sont clairs.",
    "Open the public journey and make sure the story and action are clear.": "Ouvrez le parcours public et vérifiez que le message et l’action sont clairs.",
    "onboarding.step.test_supporter_flow.cta": "Tester le parcours",
    "Test flow": "Tester le parcours",
    "onboarding.step.test_supporter_flow.impact": "Valide le parcours public.",
    "Validates the public path.": "Valide le parcours public.",
    "onboarding.step.set_account_categories.title": "Définir les catégories de comptes fournisseurs",
    "Define supplier account categories": "Définir les catégories de comptes fournisseurs",
    "onboarding.step.set_account_categories.description": "Classez les profils fournisseurs par type pour renforcer la confiance et faciliter la navigation.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Classez les profils fournisseurs par type pour renforcer la confiance et faciliter la navigation.",
    "onboarding.step.set_account_categories.cta": "Catégories de comptes",
    "Account categories": "Catégories de comptes",
    "onboarding.step.set_account_categories.impact": "Structure fournisseurs définie.",
    "Supplier structure established.": "Structure fournisseurs définie.",
    "onboarding.step.set_account_attributes.title": "Ajouter des attributs au profil fournisseur",
    "Add supplier profile attributes": "Ajouter des attributs au profil fournisseur",
    "onboarding.step.set_account_attributes.description": "Recueillez les informations utiles aux acheteurs avant de contacter ou commander auprès des fournisseurs.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Recueillez les informations utiles aux acheteurs avant de contacter ou commander auprès des fournisseurs.",
    "onboarding.step.set_account_attributes.cta": "Attributs fournisseur",
    "Supplier attributes": "Attributs fournisseur",
    "onboarding.step.set_account_attributes.impact": "Renforce la confiance des acheteurs.",
    "Higher buyer confidence.": "Renforce la confiance des acheteurs.",
    "onboarding.step.add_promotion.title": "Ajouter une promotion de lancement",
    "Add a launch promotion": "Ajouter une promotion de lancement",
    "onboarding.step.add_promotion.description": "Créez votre première promotion pour encourager l’action dès la première visite.",
    "Create your first promotion to encourage action during the first visit.": "Créez votre première promotion pour encourager l’action dès la première visite.",
    "onboarding.step.add_promotion.cta": "Ajouter une promotion",
    "Add promotion": "Ajouter une promotion",
    "onboarding.step.add_promotion.impact": "Améliore la conversion au lancement.",
    "Strengthens launch conversion.": "Améliore la conversion au lancement.",
    "onboarding.step.create_coupon.title": "Créer votre premier coupon",
    "Create your first coupon": "Créer votre premier coupon",
    "onboarding.step.create_coupon.description": "Testez les réductions pour les nouveaux acheteurs ou les membres.",
    "Test discounts for first-time buyers or members.": "Testez les réductions pour les nouveaux acheteurs ou les membres.",
    "onboarding.step.create_coupon.cta": "Créer un coupon",
    "Create coupon": "Créer un coupon",
    "onboarding.step.create_coupon.impact": "Lance votre première offre promotionnelle.",
    "Unlocks your first offer loop.": "Lance votre première offre promotionnelle.",
    "onboarding.step.collections_setup.title": "Créer une collection",
    "Create a collection": "Créer une collection",
    "onboarding.step.collections_setup.description": "Organisez les annonces importantes pour faciliter la découverte et la navigation.",
    "Organize important listings to improve discovery and browsing.": "Organisez les annonces importantes pour faciliter la découverte et la navigation.",
    "onboarding.step.collections_setup.cta": "Créer une collection",
    "Create collection": "Créer une collection",
    "onboarding.step.collections_setup.impact": "Améliore la navigation et la découverte.",
    "Improves navigation and discovery.": "Améliore la navigation et la découverte.",
    "onboarding.step.configure_comms.title": "Vérifier les modèles de communication",
    "Review communication templates": "Vérifier les modèles de communication",
    "onboarding.step.configure_comms.description": "Préparez les notifications d’inscription et de commande avant la croissance.",
    "Prepare signup and order notifications before growth.": "Préparez les notifications d’inscription et de commande avant la croissance.",
    "onboarding.step.configure_comms.cta": "Ouvrir les communications",
    "Open communications": "Ouvrir les communications",
    "onboarding.step.configure_comms.impact": "Prépare les communications clients.",
    "Prepares customer communications.": "Prépare les communications clients.",
    "onboarding.step.customize_attributes.title": "Ajouter des attributs aux annonces",
    "Add listing attributes": "Ajouter des attributs aux annonces",
    "onboarding.step.customize_attributes.description": "Ajoutez des champs structurés pour aider les utilisateurs à filtrer et comparer.",
    "onboarding.step.customize_attributes.cta": "Ajouter des attributs",
    "Add attributes": "Ajouter des attributs",
    "onboarding.step.customize_attributes.impact": "Facilite la comparaison des annonces.",
    "Makes listings easier to compare.": "Facilite la comparaison des annonces.",
    "onboarding.step.add_digital_asset.title": "Ajouter un autre article numérique",
    "Add another digital item": "Ajouter un autre article numérique",
    "onboarding.step.add_digital_asset.description": "Élargissez le catalogue pour permettre aux utilisateurs d’évaluer la qualité et le choix.",
    "Expand the catalog so users can evaluate quality and assortment.": "Élargissez le catalogue pour permettre aux utilisateurs d’évaluer la qualité et le choix.",
    "onboarding.step.add_digital_asset.cta": "Ajouter une annonce numérique",
    "Add digital listing": "Ajouter une annonce numérique",
    "onboarding.step.add_digital_asset.impact": "Renforce la crédibilité du catalogue numérique.",
    "Improves digital catalog credibility.": "Renforce la crédibilité du catalogue numérique.",
    "personal_assistant.title": "Assistant personnel",
    "Personal assistant": "Assistant personnel",
    "personal_assistant.heading": "Faites grandir votre plateforme étape par étape",
    "Grow your platform one step at a time": "Faites grandir votre plateforme étape par étape",
    "personal_assistant.subtitle": "Conçu pour {launchType}. Nous priorisons les actions selon leur impact et leur préparation.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Conçu pour {launchType}. Nous priorisons les actions selon leur impact et leur préparation.",
    "personal_assistant.launch.store": "une boutique",
    "a store": "une boutique",
    "personal_assistant.launch.marketplace": "une marketplace",
    "a marketplace": "une marketplace",
    "personal_assistant.launch.booking": "une plateforme de réservation",
    "a booking platform": "une plateforme de réservation",
    "personal_assistant.launch.digital": "une activité numérique",
    "a digital business": "une activité numérique",
    "personal_assistant.launch.campaign": "une plateforme de campagne",
    "a campaign platform": "une plateforme de campagne",
    "personal_assistant.metric.tasks_completed": "Tâches terminées",
    "Tasks completed": "Tâches terminées",
    "personal_assistant.metric.recommendation_clicks": "Clics sur les recommandations",
    "Recommendation clicks": "Clics sur les recommandations",
    "personal_assistant.metric.completed_by_recommendation": "Terminées via les recommandations",
    "Completed via recommendations": "Terminées via les recommandations",
    "personal_assistant.metric.assist_rate": "Taux d’assistance",
    "Assist rate": "Taux d’assistance",
    "personal_assistant.personalizing": "Personnalisation de vos recommandations…",
    "Personalizing your recommendations…": "Personnalisation de vos recommandations…",
    "personal_assistant.do_this_now": "À faire maintenant",
    "Do this now": "À faire maintenant",
    "personal_assistant.estimated_time": "Durée estimée : {minutes} min",
    "Estimated time: {minutes} min": "Durée estimée : {minutes} min",
    "personal_assistant.minutes_short": "{minutes} min",
    "{minutes} min": "{minutes} min",
    "personal_assistant.open": "Ouvrir",
    "personal_assistant.mark_done": "Marquer comme terminé",
    "personal_assistant.up_next": "À suivre",
    "Up next": "À suivre",
    "personal_assistant.coming_after": "À venir ensuite",
    "Coming after this": "À venir ensuite",
    "personal_assistant.completed_count": "Terminées ({count})",
    "Completed ({count})": "Terminées ({count})",
    "personal_assistant.hide": "Masquer",
    "Hide": "Masquer",
    "personal_assistant.show": "Afficher",
    "Show": "Afficher",
    "personal_assistant.feature.open_live_site.name": "Ouvrir le site actif",
    "personal_assistant.feature.open_live_site.outcome": "Vous vérifiez que les clients peuvent accéder à la plateforme.",
    "You confirm customers can reach the live platform.": "Vous vérifiez que les clients peuvent accéder à la plateforme.",
    "personal_assistant.feature.create_supply_shape.name": "Créer la première catégorie",
    "personal_assistant.feature.create_supply_shape.outcome": "Les clients peuvent parcourir une structure claire.",
    "Customers can browse with a clear structure.": "Les clients peuvent parcourir une structure claire.",
    "personal_assistant.feature.post_first_listing.name": "Publier une annonce test",
    "personal_assistant.feature.post_first_listing.outcome": "La plateforme dispose d’une première offre à évaluer.",
    "The platform now has first supply to evaluate.": "La plateforme dispose d’une première offre à évaluer.",
    "personal_assistant.feature.test_buyer_action.name": "Agir comme un acheteur",
    "personal_assistant.feature.test_buyer_action.outcome": "Vous validez l’ensemble du parcours acheteur.",
    "You validate buyer-side experience end to end.": "Vous validez l’ensemble du parcours acheteur.",
    "personal_assistant.feature.setup_payments.name": "Connecter les paiements",
    "personal_assistant.feature.setup_payments.outcome": "Les clients peuvent effectuer de vraies transactions.",
    "Customers can complete real transactions.": "Les clients peuvent effectuer de vraies transactions.",
    "personal_assistant.feature.setup_delivery.name": "Définir le mode de livraison ou de service",
    "personal_assistant.feature.setup_delivery.outcome": "Les clients comprennent clairement la livraison ou le service.",
    "Customers can understand fulfillment clearly.": "Les clients comprennent clairement la livraison ou le service.",
    "personal_assistant.feature.add_promotion.name": "Ajouter une promotion de lancement",
    "personal_assistant.feature.add_promotion.outcome": "Vous créez une incitation à convertir dès le lancement.",
    "You create an early conversion incentive.": "Vous créez une incitation à convertir dès le lancement.",
    "personal_assistant.feature.configure_comms.name": "Vérifier les modèles de communication",
    "personal_assistant.feature.configure_comms.outcome": "Les utilisateurs reçoivent des communications claires à chaque étape.",
    "Users receive clear lifecycle communication.": "Les utilisateurs reçoivent des communications claires à chaque étape.",
    "personal_assistant.feature.view_orders.name": "Consulter les commandes",
    "Open orders": "Consulter les commandes",
    "personal_assistant.feature.view_orders.outcome": "Vous pouvez suivre et traiter les nouvelles demandes.",
    "You can monitor and process incoming demand.": "Vous pouvez suivre et traiter les nouvelles demandes.",
    "personal_assistant.feature.view_accounts.name": "Consulter les comptes",
    "Open accounts": "Consulter les comptes",
    "personal_assistant.feature.view_accounts.outcome": "Vous pouvez consulter efficacement les fournisseurs ou les membres.",
    "You can review suppliers or members efficiently.": "Vous pouvez consulter efficacement les fournisseurs ou les membres.",
    "personal_assistant.feature.configure_account_categories.name": "Configurer les catégories de comptes",
    "Configure account categories": "Configurer les catégories de comptes",
    "personal_assistant.feature.configure_account_categories.outcome": "La structure des fournisseurs et des membres facilite l’intégration et renforce la confiance.",
    "Supplier and member structure is clearer for onboarding and trust.": "La structure des fournisseurs et des membres facilite l’intégration et renforce la confiance.",
    "personal_assistant.feature.configure_account_attributes.name": "Configurer les attributs de compte",
    "Configure account attributes": "Configurer les attributs de compte",
    "personal_assistant.feature.configure_account_attributes.outcome": "Les profils recueillent les informations essentielles aux décisions des acheteurs.",
    "Profiles capture decision-critical info for buyers.": "Les profils recueillent les informations essentielles aux décisions des acheteurs.",
    "personal_assistant.feature.review_account_config.name": "Vérifier la configuration des comptes",
    "Review account configuration": "Vérifier la configuration des comptes",
    "personal_assistant.feature.review_account_config.outcome": "Le comportement des comptes respecte les règles de votre marketplace.",
    "Account behavior matches your marketplace policy.": "Le comportement des comptes respecte les règles de votre marketplace.",
    "personal_assistant.feature.view_listings.name": "Consulter les annonces",
    "Open listings": "Consulter les annonces",
    "personal_assistant.feature.view_listings.outcome": "Vous pouvez suivre la qualité et la préparation du catalogue.",
    "You can monitor catalog quality and readiness.": "Vous pouvez suivre la qualité et la préparation du catalogue.",
    "personal_assistant.feature.configure_listing_categories.name": "Configurer les catégories d’annonces",
    "Configure listing categories": "Configurer les catégories d’annonces",
    "personal_assistant.feature.configure_listing_categories.outcome": "Le catalogue devient plus facile à parcourir et à découvrir.",
    "The catalog becomes easier to navigate and discover.": "Le catalogue devient plus facile à parcourir et à découvrir.",
    "personal_assistant.feature.configure_listing_attributes.name": "Configurer les attributs des annonces",
    "Configure listing attributes": "Configurer les attributs des annonces",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Les utilisateurs peuvent comparer les annonces grâce à des détails structurés.",
    "Users can compare listings with structured details.": "Les utilisateurs peuvent comparer les annonces grâce à des détails structurés.",
    "personal_assistant.feature.configure_variant_types.name": "Configurer les types de variantes",
    "Configure variant types": "Configurer les types de variantes",
    "personal_assistant.feature.configure_variant_types.outcome": "Le catalogue gère clairement les variantes de produits et de services.",
    "The catalog supports product and service variations clearly.": "Le catalogue gère clairement les variantes de produits et de services.",
    "personal_assistant.feature.review_listing_configs.name": "Vérifier les options des annonces",
    "Review listing additional features": "Vérifier les options des annonces",
    "personal_assistant.feature.review_listing_configs.outcome": "Le fonctionnement des annonces correspond à votre modèle opérationnel.",
    "Listing behavior matches your operating model.": "Le fonctionnement des annonces correspond à votre modèle opérationnel.",
    "personal_assistant.feature.manage_collections.name": "Gérer les collections",
    "Manage collections": "Gérer les collections",
    "personal_assistant.feature.manage_collections.outcome": "Les parcours de navigation à forte intention sont plus faciles à trouver.",
    "High-intent browsing paths are easier to discover.": "Les parcours de navigation à forte intention sont plus faciles à trouver.",
    "personal_assistant.feature.manage_coupons.name": "Gérer les coupons",
    "Manage coupons": "Gérer les coupons",
    "personal_assistant.feature.manage_coupons.outcome": "Vous pouvez proposer des offres ciblées pour stimuler l’activité.",
    "You can run targeted offers for activation.": "Vous pouvez proposer des offres ciblées pour stimuler l’activité.",
    "personal_assistant.feature.view_transactions.name": "Consulter les transactions",
    "View transactions": "Consulter les transactions",
    "personal_assistant.feature.view_transactions.outcome": "Vous pouvez suivre les paiements pour renforcer la confiance et gérer les opérations.",
    "Payment activity can be monitored for trust and operations.": "Vous pouvez suivre les paiements pour renforcer la confiance et gérer les opérations.",
    "personal_assistant.feature.view_users.name": "Consulter les utilisateurs",
    "Open users": "Consulter les utilisateurs",
    "personal_assistant.feature.view_users.outcome": "Vous pouvez suivre la qualité de la croissance des clients et des membres.",
    "You can monitor customer and member growth quality.": "Vous pouvez suivre la qualité de la croissance des clients et des membres.",
    "personal_assistant.feature.configure_user_attributes.name": "Configurer les attributs utilisateur",
    "Configure user attributes": "Configurer les attributs utilisateur",
    "personal_assistant.feature.configure_user_attributes.outcome": "Vous pouvez recueillir des informations de profil pour améliorer l’engagement.",
    "You can capture profile signals to improve engagement.": "Vous pouvez recueillir des informations de profil pour améliorer l’engagement.",
    "personal_assistant.feature.review_ratings.name": "Vérifier les notes et avis",
    "Review ratings and reviews": "Vérifier les notes et avis",
    "personal_assistant.feature.review_ratings.outcome": "Les indicateurs de confiance sont suivis et améliorés.",
    "Trust signals are monitored and improved.": "Les indicateurs de confiance sont suivis et améliorés.",
    "personal_assistant.feature.view_reports.name": "Consulter les rapports",
    "Open reports": "Consulter les rapports",
    "personal_assistant.feature.view_reports.outcome": "Vous pouvez suivre les performances à l’aide des données.",
    "You can track performance with a data view.": "Vous pouvez suivre les performances à l’aide des données.",
    "personal_assistant.feature.manage_media.name": "Gérer la bibliothèque multimédia",
    "Manage media library": "Gérer la bibliothèque multimédia",
    "personal_assistant.feature.manage_media.outcome": "Les visuels de marque et des annonces sont plus faciles à gérer.",
    "Brand and listing visuals are easier to maintain.": "Les visuels de marque et des annonces sont plus faciles à gérer.",
    "personal_assistant.feature.manage_reported_listings.name": "Vérifier les annonces signalées",
    "Review reported listings": "Vérifier les annonces signalées",
    "personal_assistant.feature.manage_reported_listings.outcome": "Les contenus risqués ou de faible qualité peuvent être traités rapidement.",
    "Risky or low-quality content can be handled quickly.": "Les contenus risqués ou de faible qualité peuvent être traités rapidement.",
    "personal_assistant.feature.app_customization.name": "Personnaliser l’expérience de l’application",
    "Customize app experience": "Personnaliser l’expérience de l’application",
    "personal_assistant.feature.app_customization.outcome": "L’expérience de l’application mobile correspond à votre marque.",
    "The mobile app experience aligns with your brand.": "L’expérience de l’application mobile correspond à votre marque.",
    "personal_assistant.feature.app_integrations.name": "Configurer les intégrations de l’application",
    "Configure app integrations": "Configurer les intégrations de l’application",
    "personal_assistant.feature.app_integrations.outcome": "Les services essentiels de la plateforme sont reliés aux flux de l’application.",
    "Core platform services connect with app workflows.": "Les services essentiels de la plateforme sont reliés aux flux de l’application.",
    "personal_assistant.feature.customize_strings.name": "Personnaliser les textes de l’interface",
    "Customize interface text": "Personnaliser les textes de l’interface",
    "personal_assistant.feature.customize_strings.outcome": "Les textes du produit correspondent à votre public et à votre ton.",
    "Product copy matches your audience and tone.": "Les textes du produit correspondent à votre public et à votre ton.",
    "personal_assistant.feature.review_settings_home.name": "Consulter les paramètres",
    "Open settings": "Consulter les paramètres",
    "personal_assistant.feature.review_settings_home.outcome": "Les paramètres sont faciles à trouver pour les opérations de l’équipe.",
    "Configuration is easy to find for team operations.": "Les paramètres sont faciles à trouver pour les opérations de l’équipe.",
    "personal_assistant.feature.configure_commission.name": "Configurer les commissions",
    "Configure commission": "Configurer les commissions",
    "personal_assistant.feature.configure_commission.outcome": "Le partage des revenus correspond à votre modèle économique.",
    "Revenue sharing aligns with your business model.": "Le partage des revenus correspond à votre modèle économique.",
    "personal_assistant.feature.configure_taxes.name": "Configurer les taxes",
    "Configure taxes": "Configurer les taxes",
    "personal_assistant.feature.configure_taxes.outcome": "Les prix au paiement sont prévisibles et les taxes configurées.",
    "Checkout pricing is predictable and tax settings are ready.": "Les prix au paiement sont prévisibles et les taxes configurées.",
    "personal_assistant.feature.configure_languages.name": "Configurer les langues",
    "Configure languages": "Configurer les langues",
    "personal_assistant.feature.configure_languages.outcome": "L’expérience prend en charge un public multilingue.",
    "The experience supports a multilingual audience.": "L’expérience prend en charge un public multilingue.",
    "personal_assistant.feature.configure_currency.name": "Configurer la devise",
    "Configure currency": "Configurer la devise",
    "personal_assistant.feature.configure_currency.outcome": "Les prix correspondent aux attentes de votre marché cible.",
    "Prices align with the expectations of your target market.": "Les prix correspondent aux attentes de votre marché cible.",
    "personal_assistant.feature.configure_countries.name": "Configurer les pays",
    "Configure countries": "Configurer les pays",
    "personal_assistant.feature.configure_countries.outcome": "La couverture géographique est définie pour le lancement.",
    "Geographic coverage is controlled for launch.": "La couverture géographique est définie pour le lancement.",
    "personal_assistant.feature.review_checkout_settings.name": "Vérifier les paramètres de paiement",
    "Review checkout settings": "Vérifier les paramètres de paiement",
    "personal_assistant.feature.review_checkout_settings.outcome": "Le paiement est plus fluide et fiable.",
    "Checkout is cleaner and more reliable.": "Le paiement est plus fluide et fiable.",
    "personal_assistant.feature.api_configuration.name": "Vérifier la configuration API",
    "Review API configuration": "Vérifier la configuration API",
    "personal_assistant.feature.api_configuration.outcome": "Les intégrations et l’accès développeur sont prêts.",
    "Integrations and developer access are ready.": "Les intégrations et l’accès développeur sont prêts.",
    "personal_assistant.feature.workspace_website_editor.name": "Ouvrir l’éditeur de site",
    "Open website editor": "Ouvrir l’éditeur de site",
    "personal_assistant.feature.workspace_website_editor.outcome": "La boutique peut être optimisée pour la conversion.",
    "The storefront can be refined for conversion.": "La boutique peut être optimisée pour la conversion.",
    "personal_assistant.feature.workspace_domain_setup.name": "Vérifier la configuration du domaine",
    "Review domain setup": "Vérifier la configuration du domaine",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Un domaine soigné renforce la confiance envers la marque.",
    "A clean domain improves brand trust.": "Un domaine soigné renforce la confiance envers la marque.",
    "personal_assistant.feature.workspace_pages.name": "Vérifier les pages du site",
    "Review site pages": "Vérifier les pages du site",
    "personal_assistant.feature.workspace_pages.outcome": "Les pages d’accueil et de contenu renforcent la confiance des utilisateurs.",
    "Core landing and content pages support user trust.": "Les pages d’accueil et de contenu renforcent la confiance des utilisateurs.",
    "reports.title": "Rapports",
    "reports.metric.0": "Utilisateurs",
    "reports.metric.1": "Comptes",
    "reports.metric.2": "Annonces",
    "reports.metric.3": "Annonces vendues",
    "Listings Sold": "Annonces vendues",
    "reports.metric.4": "Ventes totales",
    "Total Sales": "Ventes totales",
    "reports.metric.5": "Commandes totales",
    "reports.metric.6": "Revenus totaux",
    "Total Earnings": "Revenus totaux",
    "reports.chart.activity": "Activité quotidienne de la marketplace",
    "Daily marketplace activity": "Activité quotidienne de la marketplace",
    "reports.chart.activity_description": "Annonces et nouveaux utilisateurs au fil du temps",
    "Listings and new users over time": "Annonces et nouveaux utilisateurs au fil du temps",
    "reports.chart.listings_monthly": "Annonces par mois",
    "Listings monthly": "Annonces par mois",
    "reports.chart.listings_daily": "Annonces par jour",
    "Listings daily": "Annonces par jour",
    "reports.chart.users_daily": "Utilisateurs par jour",
    "Users daily": "Utilisateurs par jour",
    "reports.chart.users_monthly": "Utilisateurs par mois",
    "Users monthly": "Utilisateurs par mois",
    "reports.series.listings": "Annonces",
    "reports.series.new_users": "Nouveaux utilisateurs",
    "New users": "Nouveaux utilisateurs",
    "reports.top_sold_listings": "Annonces les plus vendues",
    "Top sold listings": "Annonces les plus vendues",
    "reports.view_more_insights": "Afficher plus d’informations",
    "View more insights": "Afficher plus d’informations",
    "reports.ai.title": "Rapports de ventes IA",
    "AI sales reports": "Rapports de ventes IA",
    "reports.ai.generating": "Génération des rapports…",
    "Generating reports…": "Génération des rapports…",
    "reports.ai.value": "Valeur",
    "reports.ai.more_info": "Plus d’informations sur {label}",
    "More information about {label}": "Plus d’informations sur {label}",
    "reports.ai.saved_snapshot": "Instantané enregistré",
    "Saved snapshot": "Instantané enregistré",
    "reports.ai.no_data": "Aucune donnée disponible",
    "No data available": "Aucune donnée disponible",
    "reports.ai.showing_top": "Affichage des {shown} premiers résultats sur {total}",
    "Showing the top {shown} of {total} results": "Affichage des {shown} premiers résultats sur {total}",
    "reports.ai.saved_report": "Rapport IA enregistré",
    "Saved AI report": "Rapport IA enregistré",
    "reports.ai.template.country": "Ventes par pays",
    "Sales by country": "Ventes par pays",
    "reports.ai.template.state": "Ventes par région",
    "Sales by state": "Ventes par région",
    "reports.ai.template.city": "Ventes par ville",
    "Sales by city": "Ventes par ville",
    "reports.ai.template.category": "Ventes par catégorie",
    "Sales by category": "Ventes par catégorie",
    "reports.ai.template.country_all_time": "Ventes par pays (toutes périodes)",
    "Sales by country (all time)": "Ventes par pays (toutes périodes)",
    "reports.ai.template.top_listings_all_time": "Annonces les plus vendues (toutes périodes)",
    "Top sold listings (all time)": "Annonces les plus vendues (toutes périodes)",
    "reports.ai.template.listings_by_category_all_time": "Annonces par catégorie (toutes périodes)",
    "Listings by category (all time)": "Annonces par catégorie (toutes périodes)",
    "reports.search_table.title": "Recherche d’annonces",
    "Listing search": "Recherche d’annonces",
    "reports.search_table.phrase": "Expression",
    "Phrase": "Expression",
    "reports.search_table.result": "Résultats",
    "reports.search_table.created_at": "Créée le",
    "Created at": "Créée le",
    "reports.search_table.user_first_name": "Prénom de l’utilisateur",
    "User first name": "Prénom de l’utilisateur",
    "reports.search_table.user_last_name": "Nom de l’utilisateur",
    "User last name": "Nom de l’utilisateur",
    "reports.search_table.user_email": "E-mail de l’utilisateur",
    "User email": "E-mail de l’utilisateur",
    "intelligence.title": "Analyses",
    "intelligence.description": "Générez des rapports IA enregistrez des graphiques et épinglez les rapports utiles dans votre tableau de bord.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Générez des rapports IA enregistrez des graphiques et épinglez les rapports utiles dans votre tableau de bord.",
    "intelligence.dashboard.label": "Tableau de bord",
    "intelligence.dashboard.pinned_title": "Indicateurs épinglés",
    "Pinned intelligence widgets": "Indicateurs épinglés",
    "intelligence.dashboard.pinned_count": "{count} épinglé(s)",
    "{count} pinned": "{count} épinglé(s)",
    "intelligence.dashboard.empty": "Épinglez des rapports enregistrés pour créer un tableau de bord réutilisable.",
    "Pin saved reports to build a reusable dashboard grid.": "Épinglez des rapports enregistrés pour créer un tableau de bord réutilisable.",
    "intelligence.action.open": "Ouvrir",
    "intelligence.action.pin": "Épingler",
    "Pin": "Épingler",
    "intelligence.action.unpin": "Désépingler",
    "Unpin": "Désépingler",
    "intelligence.action.generate": "Générer",
    "intelligence.action.save_snapshot": "Enregistrer l’instantané",
    "Save snapshot": "Enregistrer l’instantané",
    "intelligence.action.discard_draft": "Effacer le brouillon",
    "intelligence.action.load": "Charger",
    "Load": "Charger",
    "intelligence.action.refresh": "Actualiser",
    "intelligence.action.delete": "Supprimer",
    "intelligence.table.no_rows": "Aucune ligne structurée n’a été renvoyée pour ce rapport.",
    "No structured rows were returned for this report.": "Aucune ligne structurée n’a été renvoyée pour ce rapport.",
    "intelligence.table.no_rows_short": "Aucune ligne disponible.",
    "No rows available.": "Aucune ligne disponible.",
    "intelligence.field.template": "Modèle de rapport",
    "Report template": "Modèle de rapport",
    "intelligence.field.date_filter": "Filtre de date",
    "Date filter": "Filtre de date",
    "intelligence.field.prompt": "Aperçu de la demande",
    "Prompt preview": "Aperçu de la demande",
    "intelligence.field.report_name": "Nom du rapport",
    "Report name": "Nom du rapport",
    "intelligence.field.report_name_placeholder": "Par exemple : produits les plus vendus – 30 derniers jours",
    "For example: Top Selling Products – Last 30 Days": "Par exemple : produits les plus vendus – 30 derniers jours",
    "intelligence.field.chart": "Graphique",
    "Chart": "Graphique",
    "intelligence.field.prompt_label": "Demande",
    "Prompt": "Demande",
    "intelligence.date.relative": "Relative",
    "Relative": "Relative",
    "intelligence.date.absolute": "Absolue",
    "Absolute": "Absolue",
    "intelligence.date.last_n_days": "N derniers jours",
    "Last N days": "N derniers jours",
    "intelligence.date.last_days": "{days} derniers jours",
    "Last {days} days": "{days} derniers jours",
    "intelligence.date.from": "Du",
    "intelligence.date.to": "Au",
    "intelligence.saved_reports.title": "Rapports enregistrés",
    "Saved reports": "Rapports enregistrés",
    "intelligence.saved_reports.empty": "Aucun rapport d’analyse enregistré pour le moment.",
    "No saved intelligence reports yet.": "Aucun rapport d’analyse enregistré pour le moment.",
    "intelligence.active_report": "Rapport actif",
    "Active report": "Rapport actif",
    "intelligence.no_report_selected": "Aucun rapport sélectionné",
    "No report selected": "Aucun rapport sélectionné",
    "intelligence.active_report.empty_description": "Générez un rapport ou chargez-en un pour examiner les données.",
    "Generate a report or load a saved one to inspect the data.": "Générez un rapport ou chargez-en un pour examiner les données.",
    "intelligence.chart.value": "Valeur",
    "intelligence.chart.unknown": "Inconnu",
    "intelligence.chart_type.bar": "Barres",
    "Barres": "Barres",
    "intelligence.chart_type.line": "Ligne",
    "Line": "Ligne",
    "intelligence.chart_type.area": "Aire",
    "Area": "Aire",
    "intelligence.chart_type.pie": "Circulaire",
    "Pie": "Circulaire",
    "intelligence.chart.no_rows": "Ce rapport n’a renvoyé aucune ligne à afficher.",
    "This report did not return rows to plot.": "Ce rapport n’a renvoyé aucune ligne à afficher.",
    "intelligence.empty_report": "Utilisez le modèle et les dates pour générer un rapport structuré puis enregistrez-le et épinglez-le dans votre tableau de bord.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Utilisez le modèle et les dates pour générer un rapport structuré puis enregistrez-le et épinglez-le dans votre tableau de bord.",
    "intelligence.error.update": "Impossible de mettre à jour le rapport enregistré.",
    "Unable to update the saved report.": "Impossible de mettre à jour le rapport enregistré.",
    "intelligence.error.prompt_required": "Saisissez une demande pour générer un rapport.",
    "Enter a prompt to generate a report.": "Saisissez une demande pour générer un rapport.",
    "intelligence.error.invalid_response": "La réponse IA ne contenait pas de rapport normalisé.",
    "The AI response did not include a normalized report.": "La réponse IA ne contenait pas de rapport normalisé.",
    "intelligence.error.generate": "Impossible de générer le rapport pour le moment.",
    "Unable to generate the report right now.": "Impossible de générer le rapport pour le moment.",
    "intelligence.error.generate_before_save": "Générez un rapport avant de l’enregistrer.",
    "Generate a report before saving.": "Générez un rapport avant de l’enregistrer.",
    "intelligence.error.save": "Impossible d’enregistrer le rapport.",
    "Unable to save the report.": "Impossible d’enregistrer le rapport.",
    "intelligence.error.load": "Impossible de charger le rapport enregistré.",
    "Unable to load the saved report.": "Impossible de charger le rapport enregistré.",
    "intelligence.error.refresh": "Impossible d’actualiser le rapport enregistré.",
    "Unable to refresh the saved report.": "Impossible d’actualiser le rapport enregistré.",
    "intelligence.error.delete": "Impossible de supprimer le rapport enregistré.",
    "Unable to delete the saved report.": "Impossible de supprimer le rapport enregistré.",
    "intelligence.template.top_selling_products": "Produits les plus vendus",
    "Top selling products": "Produits les plus vendus",
    "intelligence.template.revenue_trend": "Tendance des revenus",
    "Revenue trend": "Tendance des revenus",
    "intelligence.template.low_stock_products": "Produits avec peu de stock",
    "Low stock products": "Produits avec peu de stock",
    "intelligence.template.top_categories_by_sales": "Catégories les plus vendues",
    "Top categories by sales": "Catégories les plus vendues",
    "intelligence.template.order_status_breakdown": "Répartition des statuts de commande",
    "Order status breakdown": "Répartition des statuts de commande",
    "intelligence.template.sales_by_day": "Ventes par jour",
    "Sales by day": "Ventes par jour",
    "intelligence.template.sales_by_country": "Ventes par pays",
    "intelligence.template.sales_by_state": "Ventes par région",
    "intelligence.template.sales_by_city": "Ventes par ville",
    "intelligence.template.sales_by_category": "Ventes par catégorie",
    "intelligence.template.sales_by_subcategory": "Ventes par sous-catégorie",
    "Sales by subcategory": "Ventes par sous-catégorie",
    "intelligence.prompt.top_selling_products.relative": "Affichez les produits les plus vendus sur les {days} derniers jours",
    "Show me top selling products for the last {days} days": "Affichez les produits les plus vendus sur les {days} derniers jours",
    "intelligence.prompt.top_selling_products.absolute": "Affichez les produits les plus vendus du {from} au {to}",
    "Show me top selling products from {from} to {to}": "Affichez les produits les plus vendus du {from} au {to}",
    "intelligence.prompt.revenue_trend.relative": "Quelle est l’évolution de mes revenus sur les {days} derniers jours ?",
    "What is my revenue trend for the last {days} days?": "Quelle est l’évolution de mes revenus sur les {days} derniers jours ?",
    "intelligence.prompt.revenue_trend.absolute": "Quelle est l’évolution de mes revenus du {from} au {to} ?",
    "What is my revenue trend from {from} to {to}?": "Quelle est l’évolution de mes revenus du {from} au {to} ?",
    "intelligence.prompt.low_stock_products": "Affichez les produits avec peu de stock",
    "Show me low stock products": "Affichez les produits avec peu de stock",
    "intelligence.prompt.top_categories_by_sales.relative": "Affichez les catégories les plus vendues sur les {days} derniers jours",
    "Show me top categories by sales for the last {days} days": "Affichez les catégories les plus vendues sur les {days} derniers jours",
    "intelligence.prompt.top_categories_by_sales.absolute": "Affichez les catégories les plus vendues du {from} au {to}",
    "Show me top categories by sales from {from} to {to}": "Affichez les catégories les plus vendues du {from} au {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Affichez la répartition des statuts de commande sur les {days} derniers jours",
    "Show me order status breakdown for the last {days} days": "Affichez la répartition des statuts de commande sur les {days} derniers jours",
    "intelligence.prompt.order_status_breakdown.absolute": "Affichez la répartition des statuts de commande du {from} au {to}",
    "Show me order status breakdown from {from} to {to}": "Affichez la répartition des statuts de commande du {from} au {to}",
    "intelligence.prompt.sales_by_day.relative": "Affichez les ventes par jour sur les {days} derniers jours",
    "Show me sales by day for the last {days} days": "Affichez les ventes par jour sur les {days} derniers jours",
    "intelligence.prompt.sales_by_day.absolute": "Affichez les ventes par jour du {from} au {to}",
    "Show me sales by day from {from} to {to}": "Affichez les ventes par jour du {from} au {to}",
    "intelligence.prompt.sales_by_country.relative": "Affichez le chiffre d’affaires total et le nombre de commandes par pays sur les {days} derniers jours",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Affichez le chiffre d’affaires total et le nombre de commandes par pays sur les {days} derniers jours",
    "intelligence.prompt.sales_by_country.absolute": "Affichez le chiffre d’affaires total et le nombre de commandes par pays du {from} au {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Affichez le chiffre d’affaires total et le nombre de commandes par pays du {from} au {to}",
    "intelligence.prompt.sales_by_state.relative": "Affichez le chiffre d’affaires total et le nombre de commandes par région sur les {days} derniers jours",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Affichez le chiffre d’affaires total et le nombre de commandes par région sur les {days} derniers jours",
    "intelligence.prompt.sales_by_state.absolute": "Affichez le chiffre d’affaires total et le nombre de commandes par région du {from} au {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Affichez le chiffre d’affaires total et le nombre de commandes par région du {from} au {to}",
    "intelligence.prompt.sales_by_city.relative": "Affichez le chiffre d’affaires total et le nombre de commandes par ville sur les {days} derniers jours",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Affichez le chiffre d’affaires total et le nombre de commandes par ville sur les {days} derniers jours",
    "intelligence.prompt.sales_by_city.absolute": "Affichez le chiffre d’affaires total et le nombre de commandes par ville du {from} au {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Affichez le chiffre d’affaires total et le nombre de commandes par ville du {from} au {to}",
    "intelligence.prompt.sales_by_category.relative": "Affichez le chiffre d’affaires total et le nombre de commandes par catégorie principale sur les {days} derniers jours",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Affichez le chiffre d’affaires total et le nombre de commandes par catégorie principale sur les {days} derniers jours",
    "intelligence.prompt.sales_by_category.absolute": "Affichez le chiffre d’affaires total et le nombre de commandes par catégorie principale du {from} au {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Affichez le chiffre d’affaires total et le nombre de commandes par catégorie principale du {from} au {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Affichez le chiffre d’affaires total et le nombre de commandes par sous-catégorie sur les {days} derniers jours",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Affichez le chiffre d’affaires total et le nombre de commandes par sous-catégorie sur les {days} derniers jours",
    "intelligence.prompt.sales_by_subcategory.absolute": "Affichez le chiffre d’affaires total et le nombre de commandes par sous-catégorie du {from} au {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Affichez le chiffre d’affaires total et le nombre de commandes par sous-catégorie du {from} au {to}",
    "common.status.partial": "Partiel",
    "Partial": "Partiel",
    "common.status.dispatched": "Expédié",
    "Dispatched": "Expédié",
    "common.status.sale": "Vente",
    "Sale": "Vente",
    "common.status.transfer_in": "Transfert entrant",
    "Transfer in": "Transfert entrant",
    "common.status.transfer_out": "Transfert sortant",
    "Transfer out": "Transfert sortant",
    "common.status.return": "Retour",
    "Return": "Retour",
    "common.status.adjustment": "Ajustement",
    "Adjustment": "Ajustement",
    "common.status.receipt": "Réception",
    "inventory.overview.title": "Inventaire",
    "inventory.overview.tab.all": "Tout le stock",
    "All stock": "Tout le stock",
    "inventory.overview.tab.low": "Stock faible",
    "Low stock": "Stock faible",
    "inventory.overview.tab.expiring": "Lots arrivant à expiration",
    "Expiring batches": "Lots arrivant à expiration",
    "inventory.overview.manage_locations": "Gérer les emplacements",
    "Manage locations": "Gérer les emplacements",
    "inventory.overview.purchase_orders": "Commandes fournisseurs",
    "inventory.overview.operations": "Opérations",
    "Operations": "Opérations",
    "inventory.overview.adjust_stock": "Ajuster le stock",
    "Adjust stock": "Ajuster le stock",
    "inventory.overview.description": "Vue en direct du stock dans vos emplacements",
    "A live view of stock across your locations.": "Vue en direct du stock dans vos emplacements",
    "inventory.overview.adjustment_hint": "Utilisez les ajustements pour les inventaires, dommages, retours ou autres corrections.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Utilisez les ajustements pour les inventaires, dommages, retours ou autres corrections.",
    "inventory.overview.units_on_hand": "Unités en stock",
    "Units on hand": "Unités en stock",
    "inventory.overview.one_stock_row": "1 ligne de stock",
    "1 stock row": "1 ligne de stock",
    "inventory.overview.stock_rows": "{count} lignes de stock",
    "{count} stock rows": "{count} lignes de stock",
    "inventory.overview.low_stock": "Stock faible",
    "inventory.overview.reorder_point_hint": "Au seuil de réapprovisionnement ou en dessous",
    "At or below reorder point": "Au seuil de réapprovisionnement ou en dessous",
    "inventory.overview.expiring_soon": "Expiration prochaine",
    "Expiring soon": "Expiration prochaine",
    "inventory.overview.next_90_days": "Dans les 90 prochains jours",
    "Within the next 90 days": "Dans les 90 prochains jours",
    "inventory.overview.stock_value": "Valeur du stock",
    "Stock value": "Valeur du stock",
    "inventory.overview.one_active_location": "1 emplacement actif",
    "1 active location": "1 emplacement actif",
    "inventory.overview.active_locations": "{count} emplacements actifs",
    "{count} active locations": "{count} emplacements actifs",
    "inventory.overview.search": "Rechercher dans l’inventaire",
    "Search inventory": "Rechercher dans l’inventaire",
    "inventory.overview.search_placeholder": "Rechercher un produit, une référence ou un emplacement",
    "Search product, SKU, or location": "Rechercher un produit, une référence ou un emplacement",
    "inventory.overview.filter_location": "Filtrer par emplacement",
    "Filter by location": "Filtrer par emplacement",
    "inventory.overview.all_locations": "Tous les emplacements",
    "inventory.overview.empty.all": "Aucun stock d’inventaire enregistré pour le moment",
    "No inventory stock has been recorded yet.": "Aucun stock d’inventaire enregistré pour le moment",
    "inventory.overview.empty.low": "Aucun stock n’est inférieur à son seuil de réapprovisionnement",
    "Great — no stock is below its reorder point.": "Aucun stock n’est inférieur à son seuil de réapprovisionnement",
    "inventory.overview.empty.expiring": "Aucun lot n’arrive à expiration dans les 90 jours",
    "No batches are expiring within 90 days.": "Aucun lot n’arrive à expiration dans les 90 jours",
    "inventory.overview.adjust": "Ajuster",
    "Adjust": "Ajuster",
    "inventory.overview.adjust_title": "Ajuster le stock",
    "inventory.overview.adjust_description": "Enregistrez une correction avec un motif pour conserver un historique de stock fiable.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Enregistrez une correction avec un motif pour conserver un historique de stock fiable.",
    "inventory.overview.save_adjustment": "Enregistrer l’ajustement",
    "Save adjustment": "Enregistrer l’ajustement",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Non attribué",
    "Unassigned": "Non attribué",
    "inventory.overview.quantity_change": "Variation de quantité",
    "Quantity change": "Variation de quantité",
    "inventory.overview.quantity_placeholder": "ex. 5 ou -2",
    "e.g. 5 or -2": "ex. 5 ou -2",
    "inventory.overview.reason": "Motif",
    "inventory.overview.reason_placeholder": "Inventaire, dommage, retour…",
    "Cycle count, damage, return…": "Inventaire, dommage, retour…",
    "inventory.overview.reason.cycle_count": "Inventaire",
    "Cycle count": "Inventaire",
    "inventory.overview.reason.damage": "Dommage",
    "Damage": "Dommage",
    "inventory.overview.reason.return": "Retour",
    "inventory.overview.reason.stocktake": "Comptage du stock",
    "Stocktake": "Comptage du stock",
    "inventory.overview.note_placeholder": "Contexte facultatif pour la prochaine personne",
    "Optional context for the next person": "Contexte facultatif pour la prochaine personne",
    "inventory.overview.adjustment_saved": "Ajustement de stock enregistré",
    "Inventory adjustment saved": "Ajustement de stock enregistré",
    "inventory.overview.on_hand": "En stock",
    "On hand": "En stock",
    "inventory.overview.reorder_at": "Seuil de réapprovisionnement",
    "Reorder at": "Seuil de réapprovisionnement",
    "orders.create_order.payment_reference_missing": "La commande a été créée, mais aucune référence de commande n’a été renvoyée.",
    "The order was created, but no order reference was returned.": "La commande a été créée, mais aucune référence de commande n’a été renvoyée.",
    "orders.create_order.payment_domain_missing": "Le domaine du locataire n’est pas disponible pour les liens de paiement.",
    "The tenant domain is not available for payment links.": "Le domaine du locataire n’est pas disponible pour les liens de paiement.",
    "orders.create_order.payment_link_failed": "Impossible de créer le lien de paiement.",
    "Unable to create payment link.": "Impossible de créer le lien de paiement.",
    "orders.create_order.admin_session_expired": "Votre session administrateur a expiré. Reconnectez-vous avant de créer une commande.",
    "Your admin session has expired. Please sign in again before creating an order.": "Votre session administrateur a expiré. Reconnectez-vous avant de créer une commande.",
    "orders.create_order.user": "Utilisateur",
    "orders.create_order.add_new_user": "Ajouter un utilisateur",
    "Add New User": "Ajouter un utilisateur",
    "orders.create_order.choose_existing_user": "Choisir un utilisateur existant",
    "Choose Existing User": "Choisir un utilisateur existant",
    "orders.create_order.preparing_customer": "Préparation du client…",
    "Preparing customer…": "Préparation du client…",
    "orders.create_order.select_user": "Sélectionner un utilisateur",
    "Select user": "Sélectionner un utilisateur",
    "orders.create_order.search_listing": "Rechercher une annonce",
    "Search Listing": "Rechercher une annonce",
    "orders.create_order.listings": "Annonces",
    "orders.create_order.no_image": "Aucune image",
    "No image": "Aucune image",
    "orders.create_order.add_to_cart": "Ajouter au panier",
    "Add to Cart": "Ajouter au panier",
    "orders.create_order.select_rental_dates": "Sélectionnez d’abord les dates de début et de fin de location.",
    "Select rental start and end dates first.": "Sélectionnez d’abord les dates de début et de fin de location.",
    "orders.create_order.rental_end_after_start": "La fin de la location doit être postérieure à son début.",
    "Rental end must be after the start date.": "La fin de la location doit être postérieure à son début.",
    "orders.create_order.cart_type_conflict": "Ce client a déjà des articles d’un autre type. Retirez-les à l’étape de paiement avant d’ajouter cet article.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Ce client a déjà des articles d’un autre type. Retirez-les à l’étape de paiement avant d’ajouter cet article.",
    "orders.create_order.rental_period": "Période de location",
    "Rental period": "Période de location",
    "orders.create_order.select_start_end": "Sélectionner le début et la fin",
    "Select start and end": "Sélectionner le début et la fin",
    "orders.create_order.membership_no_shipping": "Les commandes d’adhésion ne nécessitent pas d’expédition ni de livraison.",
    "Membership orders do not require shipping or delivery.": "Les commandes d’adhésion ne nécessitent pas d’expédition ni de livraison.",
    "orders.create_order.preparing_payment_link": "Préparation du lien de paiement…",
    "Preparing payment link…": "Préparation du lien de paiement…",
    "orders.create_order.payment_link_ready": "Lien de paiement prêt",
    "Payment link ready": "Lien de paiement prêt",
    "orders.create_order.copy_payment_link": "Copier le lien de paiement",
    "Copy payment link": "Copier le lien de paiement",
    "orders.create_order.payment_method": "Mode de paiement",
    "orders.create_order.no_payment_methods": "Aucun mode de paiement actif n’est configuré pour ce projet.",
    "No active payment methods are configured for this project.": "Aucun mode de paiement actif n’est configuré pour ce projet.",
    "orders.create_order.shipping_method": "Mode d’expédition",
    "orders.create_order.no_shipping_methods": "Aucun mode d’expédition actif n’est configuré pour ce projet.",
    "No active shipping methods are configured for this project.": "Aucun mode d’expédition actif n’est configuré pour ce projet.",
    "orders.create_order.shipping_address": "Adresse de livraison",
    "Shipping address": "Adresse de livraison",
    "orders.create_order.loading_addresses": "Chargement des adresses enregistrées…",
    "Loading saved addresses…": "Chargement des adresses enregistrées…",
    "orders.create_order.no_saved_shipping_address": "Cet utilisateur n’a pas d’adresse de livraison enregistrée. Ajoutez-en une avant de créer une commande avec livraison.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "Cet utilisateur n’a pas d’adresse de livraison enregistrée. Ajoutez-en une avant de créer une commande avec livraison.",
    "orders.create_order.no_items": "Aucun article",
    "No items": "Aucun article",
    "orders.create_order.cart_empty": "Votre panier est vide",
    "Your cart is empty": "Votre panier est vide",
    "orders.create_order.create_order": "Créer la commande",
    "Create Order": "Créer la commande",
    "orders.create_order.create_payment_link": "Créer un lien de paiement",
    "Create payment link": "Créer un lien de paiement",
    "orders.create_order.order_summary": "Récapitulatif de la commande",
    "orders.create_order.coupon_value": "Code promo",
    "Coupon value": "Code promo",
    "orders.create_order.remove_coupon": "Supprimer le code promo",
    "Remove Coupon": "Supprimer le code promo",
    "orders.create_order.apply_coupon": "Appliquer le code promo",
    "Apply Coupon": "Appliquer le code promo",
    "orders.create_order.grand_amount": "Montant total",
    "Grand Amount": "Montant total",
    "orders.create_order.total": "Total",
    "orders.create_order.shipping": "Expédition",
    "orders.create_order.subtotal": "Sous-total",
    "Subtotal": "Sous-total",
    "orders.create_order.stock_unavailable": "Le stock n’est pas disponible",
    "Stock is not available": "Le stock n’est pas disponible",
    "orders.create_order.max_quantity": "La quantité maximale est de {quantity}",
    "Max quantity is {quantity}": "La quantité maximale est de {quantity}",
    "orders.create_order.items_in_cart": "Articles dans le panier",
    "Items in the cart": "Articles dans le panier",
    "orders.create_order.products_in_stock": "{count} produits en stock",
    "{count} Products in Stock": "{count} produits en stock",
    "orders.create_order.order_items": "Articles de la commande",
    "Order Items": "Articles de la commande",
    "orders.create_order.sold_by": "par {name}",
    "by {name}": "par {name}",
    "common.first_name": "Prénom",
    "common.last_name": "Nom",
    "common.unlimited": "illimité",
    "unlimited": "illimité",
    "orders.reference": "Référence",
    "orders.amount": "Montant",
    "orders.currency": "Devise",
    "orders.transaction_date": "Date de transaction",
    "Transaction Date": "Date de transaction",
    "orders.volume_this_page": "Volume (cette page)",
    "Volume (this page)": "Volume (cette page)",
    "orders.seller_entries": "Transactions du vendeur",
    "Seller Entries": "Transactions du vendeur",
    "orders.customer_entries": "Transactions du client",
    "Customer Entries": "Transactions du client",
    "orders.filter_transactions": "Filtrer les transactions",
    "Filter Transactions": "Filtrer les transactions",
    "orders.reset_filters": "Réinitialiser les filtres",
    "Reset filters": "Réinitialiser les filtres",
    "orders.manage_transactions": "Gérez vos transactions",
    "Manage your Transactions": "Gérez vos transactions",
    "orders.empty_transactions_message": "Suivez ici toutes les transactions entre les utilisateurs : commissions, prix des commandes, frais de paiement, frais spéciaux, etc.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Suivez ici toutes les transactions entre les utilisateurs : commissions, prix des commandes, frais de paiement, frais spéciaux, etc.",
    "orders.super_type": "Type principal",
    "Super Type": "Type principal",
    "orders.exporting": "Exportation…",
    "Exporting…": "Exportation…",
    "orders.export_as_csv": "Exporter au format CSV",
    "Export as CSV": "Exporter au format CSV",
    "orders.search_transactions": "Rechercher des transactions",
    "Search transactions": "Rechercher des transactions",
    "orders.filter": "Filtrer",
    "Filter": "Filtrer",
    "orders.transaction_status": "Statut de la transaction",
    "Transaction Status": "Statut de la transaction",
    "orders.seller_protection_fee": "Frais de protection du vendeur",
    "Seller Protection Fee": "Frais de protection du vendeur",
    "common.show_rows": "Afficher les lignes",
    "common.clear_all": "Tout effacer",
    "Clear All": "Tout effacer",
    "orders.order_number_value": "Commande n° {number}",
    "orders.transactions": "Transactions",
    "reported_listings.report_detail": "Détail du signalement",
    "Report Detail": "Détail du signalement",
    "reported_listings.reported_listing": "Annonce signalée",
    "Reported Listing": "Annonce signalée",
    "reported_listings.pending": "En attente",
    "reported_listings.approved": "Approuvée",
    "reported_listings.rejected": "Rejetée",
    "reported_listings.view_marketplace": "Voir sur la marketplace",
    "View on marketplace": "Voir sur la marketplace",
    "reported_listings.approve_listing": "Approuver l’annonce",
    "Approve listing": "Approuver l’annonce",
    "reported_listings.reject_listing": "Rejeter l’annonce",
    "Reject listing": "Rejeter l’annonce",
    "reported_listings.reported_by": "Signalé par",
    "Reported By": "Signalé par",
    "reported_listings.blocked": "Bloqué",
    "reported_listings.unblock_user": "Débloquer l’utilisateur",
    "Unblock user": "Débloquer l’utilisateur",
    "reported_listings.block_user": "Bloquer l’utilisateur",
    "Block user": "Bloquer l’utilisateur",
    "reported_listings.report_info": "Informations du signalement",
    "Report Info": "Informations du signalement",
    "reported_listings.reason": "Motif",
    "reported_listings.reported_on": "Signalé le",
    "Reported on": "Signalé le",
    "reported_listings.listing_id": "ID de l’annonce",
    "Listing ID": "ID de l’annonce",
    "reported_listings.reporter": "Auteur du signalement",
    "Reporter": "Auteur du signalement",
    "reported_listings.listing": "Annonce",
    "Listing": "Annonce",
    "reported_listings.status": "Statut",
    "reported_listings.title": "Annonces signalées",
    "reported_listings.report_count": "Signalements : {count}",
    "Reports: {count}": "Signalements : {count}",
    "reported_listings.empty_title": "Consultation des annonces signalées",
    "Viewing Reported listings": "Consultation des annonces signalées",
    "reported_listings.empty_message": "Vous trouverez ici les annonces signalées par vos utilisateurs",
    "You will find your users reported listings here": "Vous trouverez ici les annonces signalées par vos utilisateurs",
    "common.page_of": "Page {page} sur {total}",
    "Page {page} of {total}": "Page {page} sur {total}",
    "common.view": "Voir",
    "reviews.empty_title": "Consultation des avis et évaluations",
    "Viewing Rate & Reviews": "Consultation des avis et évaluations",
    "reviews.empty_message": "Vous trouverez ici les évaluations et avis de vos utilisateurs",
    "You will find your users ratings and reviews here": "Vous trouverez ici les évaluations et avis de vos utilisateurs",
    "reviews.list": "Liste",
    "reviews.grid": "Grille",
    "Grid": "Grille",
    "reviews.title": "Avis et évaluations",
    "reviews.review": "Avis",
    "reviews.name": "Nom",
    "reviews.rating": "Évaluation",
    "Rating": "Évaluation",
    "reviews.title_column": "Titre",
    "reviews.content": "Contenu",
    "Content": "Contenu",
    "reviews.image": "Image",
    "Image": "Image",
    "reviews.images": "Images",
    "Images": "Images",
    "reviews.accounts": "Comptes",
    "reviews.listings": "Annonces",
    "reviews.star": "Étoile",
    "Star": "Étoile",
    "reviews.review_image": "Image de l’avis",
    "Review image": "Image de l’avis",
    "reviews.title_required": "Le titre est obligatoire",
    "Title is required": "Le titre est obligatoire",
    "reviews.content_required": "Le contenu est obligatoire",
    "Content is required": "Le contenu est obligatoire",
    "reviews.updated_successfully": "Avis mis à jour",
    "Review updated successfully": "Avis mis à jour",
    "reviews.edit_review": "Modifier l’avis",
    "Edit Review": "Modifier l’avis",
    "common.not_available": "N/D",
    "common.something_went_wrong": "Une erreur est survenue",
    "Something went wrong": "Une erreur est survenue",
    "media.load_failed": "Impossible de charger les médias.",
    "Unable to load media.": "Impossible de charger les médias.",
    "media.load_failed_retry": "Impossible de charger les médias. Réessayez.",
    "Unable to load media. Please try again.": "Impossible de charger les médias. Réessayez.",
    "media.update_failed": "Échec de la mise à jour du média",
    "Media update failed": "Échec de la mise à jour du média",
    "media.renamed": "Média renommé",
    "Media renamed": "Média renommé",
    "media.moved": "Média déplacé",
    "Media moved": "Média déplacé",
    "media.rename_failed": "Impossible de renommer le média",
    "Unable to rename media": "Impossible de renommer le média",
    "media.move_failed": "Impossible de déplacer le média",
    "Unable to move media": "Impossible de déplacer le média",
    "media.deleted": "Média supprimé",
    "Media deleted": "Média supprimé",
    "media.delete_failed": "Impossible de supprimer le média",
    "Unable to delete media": "Impossible de supprimer le média",
    "media.confirm_delete": "Voulez-vous vraiment supprimer ce média ?",
    "Are you sure you want to delete this media?": "Voulez-vous vraiment supprimer ce média ?",
    "media.delete_media": "Supprimer le média",
    "Delete media": "Supprimer le média",
    "media.folder_creation_web_only": "La création de dossiers est disponible sur le Web",
    "Folder creation is available on web": "La création de dossiers est disponible sur le Web",
    "media.no_create_folder_permission": "Vous n’avez pas l’autorisation de créer des dossiers",
    "You do not have permission to create folders": "Vous n’avez pas l’autorisation de créer des dossiers",
    "media.folder_name": "Nom du dossier",
    "Folder name": "Nom du dossier",
    "media.folder_created": "Dossier créé",
    "Folder created": "Dossier créé",
    "media.folder_create_failed": "Impossible de créer le dossier",
    "Unable to create folder": "Impossible de créer le dossier",
    "media.link_copied": "Lien copié",
    "Link copied": "Lien copié",
    "media.copy_link_failed": "Impossible de copier le lien",
    "Unable to copy link": "Impossible de copier le lien",
    "media.urls_copied": "{count} URL copiées",
    "{count} URLs copied": "{count} URL copiées",
    "media.clipboard_unavailable": "Le presse-papiers est indisponible",
    "Clipboard is not available": "Le presse-papiers est indisponible",
    "media.copy_urls_failed": "Impossible de copier les URL",
    "Unable to copy URLs": "Impossible de copier les URL",
    "media.upload_failed": "Échec du téléversement du média",
    "Media upload failed": "Échec du téléversement du média",
    "media.replace_success": "Média remplacé. Son identifiant et son lien permanent restent inchangés.",
    "Media replaced. The media ID and stable link are unchanged.": "Média remplacé. Son identifiant et son lien permanent restent inchangés.",
    "media.replace_failed": "Impossible de remplacer le média",
    "Unable to replace media": "Impossible de remplacer le média",
    "media.csv_upload_failed": "Échec du téléversement du CSV",
    "CSV upload failed": "Échec du téléversement du CSV",
    "media.csv_metadata_failed": "Impossible d’enregistrer les métadonnées du CSV",
    "Unable to save CSV metadata": "Impossible d’enregistrer les métadonnées du CSV",
    "media.csv_saved_version": "CSV enregistré comme nouvelle version",
    "CSV saved as a new version": "CSV enregistré comme nouvelle version",
    "media.csv_save_failed": "Impossible d’enregistrer le CSV",
    "Unable to save CSV": "Impossible d’enregistrer le CSV",
    "media.uploading_files": "Téléversement de {count} fichiers…",
    "Uploading {count} files…": "Téléversement de {count} fichiers…",
    "media.upload_progress": "Téléversement de {count} fichiers · {progress} %",
    "Uploading {count} files · {progress}%": "Téléversement de {count} fichiers · {progress} %",
    "media.upload_success": "{count} fichiers téléversés.",
    "{count} files uploaded successfully.": "{count} fichiers téléversés.",
    "media.upload_failed_retry": "Impossible de téléverser le média. Réessayez.",
    "media.register_failed": "Impossible d’enregistrer le média",
    "Unable to register media": "Impossible d’enregistrer le média",
    "media.list_view": "Vue en liste",
    "media.grid_view": "Vue en grille",
    "media.copy_uploaded_urls": "Copier les URL téléversées",
    "Copy uploaded URLs": "Copier les URL téléversées",
    "media.copy_visible_urls": "Copier les URL visibles",
    "Copy visible URLs": "Copier les URL visibles",
    "media.copy_all_urls": "Copier toutes les URL",
    "Copy all URLs": "Copier toutes les URL",
    "media.new_folder": "Nouveau dossier",
    "New folder": "Nouveau dossier",
    "media.uploading_progress": "Téléversement : {progress} %",
    "Uploading {progress}%": "Téléversement : {progress} %",
    "media.upload_media": "Téléverser un média",
    "media.manager_title": "Gestionnaire de médias",
    "Media Manager": "Gestionnaire de médias",
    "media.search": "Rechercher des médias",
    "Search media": "Rechercher des médias",
    "media.location": "Emplacement",
    "media.media_root": "Médias",
    "media.show_type": "Afficher les médias : {type}",
    "Show {type} media": "Afficher les médias : {type}",
    "media.type_all": "tous",
    "all": "tous",
    "media.type_image": "image",
    "image": "image",
    "media.type_video": "vidéo",
    "video": "vidéo",
    "media.type_audio": "audio",
    "audio": "audio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "dossier",
    "folder": "dossier",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Plus ancien",
    "Oldest": "Plus ancien",
    "media.newest": "Plus récent",
    "Newest": "Plus récent",
    "media.sort_current": "Trier les médias, actuellement : {sort}",
    "Sort media, currently {sort}": "Trier les médias, actuellement : {sort}",
    "media.loading": "Chargement des médias…",
    "Loading media…": "Chargement des médias…",
    "media.no_filter_matches": "Aucun média ne correspond à ces filtres.",
    "No media matches these filters.": "Aucun média ne correspond à ces filtres.",
    "media.empty_title": "Votre bibliothèque de médias est vide",
    "Your media library is empty": "Votre bibliothèque de médias est vide",
    "media.empty_message": "Téléversez des images, PDF et vidéos pour les réutiliser dans des promotions, articles, etc.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Téléversez des images, PDF et vidéos pour les réutiliser dans des promotions, articles, etc.",
    "media.empty_hint": "Téléversez des fichiers ou créez un dossier pour commencer.",
    "Upload files or create a folder to get started.": "Téléversez des fichiers ou créez un dossier pour commencer.",
    "media.folder": "Dossier",
    "Folder": "Dossier",
    "media.file_folder_name": "Nom du fichier ou du dossier",
    "File or folder name": "Nom du fichier ou du dossier",
    "media.rename_media": "Renommer le média",
    "Rename media": "Renommer le média",
    "media.move_media": "Déplacer le média",
    "Move media": "Déplacer le média",
    "media.pdf_preview": "Aperçu PDF : {name}",
    "PDF preview: {name}": "Aperçu PDF : {name}",
    "media.pdf_preview_web": "L’aperçu PDF est disponible dans l’application Web.",
    "PDF preview is available in the web app.": "L’aperçu PDF est disponible dans l’application Web.",
    "media.csv_preview_web": "L’aperçu CSV est disponible dans l’application Web.",
    "CSV preview is available in the web app.": "L’aperçu CSV est disponible dans l’application Web.",
    "media.media_file": "Fichier média",
    "Media file": "Fichier média",
    "media.share_link": "Partager le lien",
    "Share link": "Partager le lien",
    "media.copy_link": "Copier le lien",
    "Copy link": "Copier le lien",
    "media.replace_media": "Remplacer le média",
    "Replace media": "Remplacer le média",
    "media.folders": "Dossiers",
    "Folders": "Dossiers",
    "media.create_new_folder": "Créer un dossier",
    "Create new folder": "Créer un dossier",
    "media.go_to_all_media": "Afficher tous les médias",
    "Go to all media": "Afficher tous les médias",
    "media.all_media": "Tous les médias",
    "All media": "Tous les médias",
    "media.open_folder_name": "Ouvrir le dossier {name}",
    "Open folder {name}": "Ouvrir le dossier {name}",
    "media.no_subfolders": "Aucun sous-dossier",
    "No subfolders": "Aucun sous-dossier",
    "media.no_files_in_folder": "Aucun fichier dans ce dossier.",
    "No files in this folder.": "Aucun fichier dans ce dossier.",
    "media.upload_folder": "Téléverser des médias dans ce dossier",
    "Upload media to this folder": "Téléverser des médias dans ce dossier",
    "media.discard_csv_confirm": "Abandonner les modifications du CSV ?",
    "Discard your CSV changes?": "Abandonner les modifications du CSV ?",
    "media.unsaved_changes": "Modifications non enregistrées",
    "Unsaved changes": "Modifications non enregistrées",
    "media.find_csv": "Rechercher dans le CSV",
    "Find in CSV": "Rechercher dans le CSV",
    "media.save_csv": "Enregistrer le CSV",
    "Save CSV": "Enregistrer le CSV",
    "media.loading_csv": "Chargement du CSV…",
    "Loading CSV…": "Chargement du CSV…",
    "media.prepare_folder_failed": "Impossible de préparer le dossier de téléversement",
    "Unable to prepare the upload folder": "Impossible de préparer le dossier de téléversement",
    "media.add_file_required": "Ajoutez un fichier",
    "Please add a file": "Ajoutez un fichier",
    "media.add_media": "Ajouter un média",
    "Add Media": "Ajouter un média",
    "media.store_uploaded_media_in": "Enregistrer le média téléversé dans",
    "Store uploaded media in": "Enregistrer le média téléversé dans",
    "media.destination_business_cards": "Cartes de visite",
    "Business Cards": "Cartes de visite",
    "media.destination_listings": "Annonces",
    "media.destination_accounts": "Comptes",
    "media.destination_users": "Utilisateurs",
    "media.upload_media_title": "Téléverser un média",
    "media.media_files": "Médias",
    "media.open_folder": "Ouvrir le dossier",
    "Open folder": "Ouvrir le dossier",
    "common.show": "Afficher",
    "common.share": "Partager",
    "Share": "Partager",
    "common.copy": "Copier",
    "common.rename": "Renommer",
    "Rename": "Renommer",
    "common.move": "Déplacer",
    "Move": "Déplacer",
    "common.type": "Type",
    "common.size": "Taille",
    "Size": "Taille",
    "common.preview": "Aperçu",
    "Preview": "Aperçu",
    "common.undo": "Annuler",
    "Undo": "Annuler",
    "common.redo": "Rétablir",
    "Redo": "Rétablir",
    "common.discard": "Abandonner",
    "common.try_again": "Réessayer",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Tableur",
    "Spreadsheet": "Tableur",
    "media.type_file": "Fichier",
    "File": "Fichier",
    "media.csv_load_failed": "Impossible de charger le CSV. Réessayez.",
    "Unable to load CSV. Please try again.": "Impossible de charger le CSV. Réessayez.",
    "workspace.settings_section.customisation": "Personnalisation",
    "workspace.settings_section.integrations": "Intégrations",
    "workspace.settings_section.platform_setup": "Configuration de la plateforme",
    "Platform Setup": "Configuration de la plateforme",
    "workspace.settings_section.business_operations": "Opérations commerciales",
    "Business Operations": "Opérations commerciales",
    "workspace.settings_section.system_setup": "Configuration du système",
    "System Setup": "Configuration du système",
    "workspace.settings_item.app_customisation": "Personnalisation de l’application",
    "App Customisation": "Personnalisation de l’application",
    "workspace.settings_item.web_customisation": "Personnalisation du site Web",
    "workspace.settings_item.communications": "Communications",
    "Communications": "Communications",
    "workspace.settings_item.strings_customisation": "Personnalisation des libellés",
    "workspace.settings_item.app_integrations": "Intégrations de l’application",
    "workspace.settings_item.web_integrations": "Intégrations Web",
    "Web Integrations": "Intégrations Web",
    "workspace.settings_item.accounts": "Comptes",
    "workspace.settings_item.listings": "Annonces",
    "workspace.settings_item.checkout_and_cart_attributes": "Attributs de paiement et de panier",
    "workspace.settings_item.service_shipping": "Service / Expédition",
    "workspace.settings_item.payments": "Paiements",
    "workspace.settings_item.commissions": "Commissions",
    "workspace.settings_item.taxes": "Taxes",
    "workspace.settings_item.special_fees": "Frais spéciaux",
    "workspace.settings_item.languages": "Langues",
    "workspace.settings_item.currency": "Devise",
    "workspace.settings_item.countries": "Pays",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Extensions",
    "Extensions": "Extensions",
    "workspace.settings_item.manage_features": "Gérer les fonctionnalités",
    "Manage Features": "Gérer les fonctionnalités",
    "workspace.settings_item.audit_logs": "Journaux d’audit",
    "Audit Logs": "Journaux d’audit",
    "workspace.settings_item.auth": "Authentification",
    "workspace.settings_item.maps": "Cartes",
    "workspace.settings_hint.accounts": "Exemple : boutique",
    "Example: Store": "Exemple : boutique",
    "workspace.settings_hint.listings": "Exemples : produits, événements",
    "Example: Products, Events": "Exemples : produits, événements",
    "workspace.settings_hint.audit_logs": "Suivi de conformité et de sécurité",
    "Compliance & security trail": "Suivi de conformité et de sécurité",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Utilisation du fournisseur et paramètres de confidentialité",
    "Provider usage and privacy settings": "Utilisation du fournisseur et paramètres de confidentialité",
    "workspace.settings_access_denied": "Vous n’avez pas accès à {name}",
    "You don't have access of {name}": "Vous n’avez pas accès à {name}",
    "app_customization.title": "Personnalisation de l’application",
    "app_customization.tab_0": "Général",
    "General": "Général",
    "app_customization.tab_1": "Écran de démarrage",
    "Splash": "Écran de démarrage",
    "app_customization.tab_2": "Présentation initiale",
    "Onboarding": "Présentation initiale",
    "app_customization.tab_3": "Inscription",
    "Registration": "Inscription",
    "app_customization.tab_4": "Accueil",
    "Home": "Accueil",
    "app_customization.tab_5": "Notification push",
    "Push Notification": "Notification push",
    "app_customization.tab_6": "Discussion",
    "Chat": "Discussion",
    "app_customization.tab_7": "Menu Plus",
    "More Menu": "Menu Plus",
    "app_customization.tab_8": "Mise à jour obligatoire",
    "Force Update": "Mise à jour obligatoire",
    "app_customization.tab_9": "Adresse",
    "app_customization.hide_balances": "Masquer les soldes et les versements dans la section Plus",
    "app_customization.more": "Plus",
    "app_customization.force_update": "Mise à jour obligatoire",
    "Force To Update": "Mise à jour obligatoire",
    "app_customization.android_version": "Version de l’application Android",
    "Android app version": "Version de l’application Android",
    "app_customization.enter_android_version": "Saisissez la version de l’application Android",
    "Enter android app version": "Saisissez la version de l’application Android",
    "app_customization.ios_version": "Version de l’application iOS",
    "iOS app version": "Version de l’application iOS",
    "app_customization.enter_ios_version": "Saisissez la version de l’application iOS",
    "Enter iOS app version": "Saisissez la version de l’application iOS",
    "app_customization.chat": "Discussion",
    "app_customization.chat_send_listing": "Envoyer automatiquement les annonces lorsque la discussion s’ouvre (l’aperçu s’affiche par défaut)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Envoyer automatiquement les annonces lorsque la discussion s’ouvre (l’aperçu s’affiche par défaut)",
    "app_customization.make_offer": "Faire une offre / Négociation",
    "Make Offer / Negotiation": "Faire une offre / Négociation",
    "app_customization.negotiation_button_name": "Libellé du bouton de négociation :",
    "Negotiation button name:": "Libellé du bouton de négociation :",
    "app_customization.negotiation_button_example": "(exemple : Faire une offre, Négocier, Devis)",
    "(example: Make Offer, Negotiate, Quote)": "(exemple : Faire une offre, Négocier, Devis)",
    "app_customization.enter_negotiation_button_name": "Saisissez le libellé du bouton de négociation",
    "Enter negotiation button name": "Saisissez le libellé du bouton de négociation",
    "app_customization.address": "Adresse",
    "app_customization.address_option_0": "Afficher la deuxième ligne d’adresse",
    "Show Address 2": "Afficher la deuxième ligne d’adresse",
    "app_customization.address_option_1": "Afficher le pays",
    "Show Country": "Afficher le pays",
    "app_customization.address_option_2": "Afficher le code postal",
    "Show Zipcode": "Afficher le code postal",
    "app_customization.address_option_3": "Afficher la région",
    "Show State": "Afficher la région",
    "app_customization.address_option_4": "Afficher le point de repère",
    "Show Landmark": "Afficher le point de repère",
    "app_customization.address_option_5": "Afficher la ville",
    "Show City": "Afficher la ville",
    "app_customization.persistent_notification": "Notification persistante",
    "Persistent Notification": "Notification persistante",
    "app_customization.account_follow_content": "Contenu de la notification d’abonnement",
    "Account follow notification content": "Contenu de la notification d’abonnement",
    "app_customization.enter_account_follow_content": "Saisissez le contenu de la notification d’abonnement",
    "Enter Account follow notification content": "Saisissez le contenu de la notification d’abonnement",
    "app_customization.listing_like_content": "Contenu de la notification « J’aime »",
    "Listing like notification content": "Contenu de la notification « J’aime »",
    "app_customization.enter_listing_like_content": "Saisissez le contenu de la notification « J’aime »",
    "Enter Listing like  notification content": "Saisissez le contenu de la notification « J’aime »",
    "app_customization.order_status_content": "Contenu de la notification sur le statut de la commande",
    "Order status notification content": "Contenu de la notification sur le statut de la commande",
    "app_customization.enter_order_status_content": "Saisissez le contenu de la notification sur le statut de la commande",
    "Order status follow notification content": "Saisissez le contenu de la notification sur le statut de la commande",
    "app_customization.account_follow_required": "La notification d’abonnement doit contenir {account_name}",
    "app_customization.listing_like_required": "La notification « J’aime » doit contenir {user_name}",
    "Listing like notification content should contain {user_name}": "La notification « J’aime » doit contenir {user_name}",
    "app_customization.order_number_required": "La notification de commande doit contenir #{order_number}",
    "Order status notification content should contain #{order_number}": "La notification de commande doit contenir #{order_number}",
    "app_customization.order_status_required": "La notification de commande doit contenir {order_status}",
    "Order status notification content should contain {order_status}": "La notification de commande doit contenir {order_status}",
    "app_customization.preview": "Aperçu",
    "app_customization.splash": "Écran de démarrage",
    "app_customization.splash_image": "Image de l’écran de démarrage",
    "Splash Screen Image": "Image de l’écran de démarrage",
    "app_customization.registration": "Inscription",
    "app_customization.registration_text": "Texte d’inscription",
    "Registration text": "Texte d’inscription",
    "app_customization.otp_note": "Note de vérification OTP",
    "OTP Verification note": "Note de vérification OTP",
    "app_customization.get_signup_first": "Afficher d’abord l’inscription",
    "app_customization.mobile_in_email_signup": "Numéro de téléphone lors de l’inscription par e-mail",
    "Mobile number in email signup": "Numéro de téléphone lors de l’inscription par e-mail",
    "app_customization.preview_field_first_name": "Prénom",
    "app_customization.preview_field_last_name": "Nom",
    "app_customization.preview_field_email": "E-mail",
    "app_customization.preview_field_password": "Mot de passe",
    "Password": "Mot de passe",
    "app_customization.preview_field_confirm_password": "Confirmer le mot de passe",
    "Confirm Password": "Confirmer le mot de passe",
    "app_customization.preview_field_dob": "Date de naissance",
    "DOB": "Date de naissance",
    "app_customization.preview_field_mobile_no": "Numéro de téléphone",
    "Mobile No": "Numéro de téléphone",
    "app_customization.create": "Créer",
    "app_customization.login": "Connexion",
    "Login": "Connexion",
    "app_customization.create_account": "Créer votre compte",
    "Create your account": "Créer votre compte",
    "app_customization.login_account": "Connectez-vous à votre compte",
    "Login to your account": "Connectez-vous à votre compte",
    "app_customization.onboarding_settings": "Paramètres de présentation initiale",
    "Onboarding Settings": "Paramètres de présentation initiale",
    "app_customization.onboarding_images": "Images de présentation",
    "Onboarding Images": "Images de présentation",
    "app_customization.onboarding_text_1": "Texte de présentation 1",
    "Onboarding text 1": "Texte de présentation 1",
    "app_customization.onboarding_text_2": "Texte de présentation 2",
    "Onboarding text 2": "Texte de présentation 2",
    "app_customization.onboarding_text_3": "Texte de présentation 3",
    "Onboarding text 3": "Texte de présentation 3",
    "app_customization.see_how_it_works": "Voir comment ça marche",
    "See how it works": "Voir comment ça marche",
    "app_customization.sell_icon_text": "Texte de l’icône Vendre",
    "Sell icon text": "Texte de l’icône Vendre",
    "app_customization.enter_sell_icon_text": "Saisissez le texte de l’icône Vendre",
    "Enter sell icon text": "Saisissez le texte de l’icône Vendre",
    "app_customization.sell_icon": "Icône Vendre",
    "Sell Icon": "Icône Vendre",
    "app_customization.enter_home_title": "Saisissez le titre de l’application sur l’accueil",
    "Enter app title in home": "Saisissez le titre de l’application sur l’accueil",
    "app_customization.app_details": "Détails de l’application",
    "App Details": "Détails de l’application",
    "app_customization.app_name": "Nom de l’application",
    "App Name": "Nom de l’application",
    "app_customization.primary_colour": "Couleur principale de l’application",
    "App Primary Colour": "Couleur principale de l’application",
    "app_customization.secondary_colour": "Couleur secondaire de l’application",
    "App Secondary Colour": "Couleur secondaire de l’application",
    "app_customization.android_app_icon": "Icône de l’application Android",
    "App Icon Android": "Icône de l’application Android",
    "app_customization.ios_app_icon": "Icône de l’application iOS",
    "App Icon iOS": "Icône de l’application iOS",
    "app_customization.screen_number": "Écran {number}",
    "Screen {number}": "Écran {number}",
    "app_customization.upload_here": "Téléverser ici",
    "Upload here": "Téléverser ici",
    "app_customization.next": "Suivant",
    "app_customization.get_started": "Commencer",
    "Get Start": "Commencer",
    "app_customization.select": "Sélectionner",
    "Select": "Sélectionner",
    "app_customization.app_title_home_icon": "Icône du titre sur l’accueil",
    "App Title Home Icon": "Icône du titre sur l’accueil",
    "app_customization.home_icon_hint": "(l’icône doit être blanche au format PNG)",
    "(icon should be white and in png format)": "(l’icône doit être blanche au format PNG)",
    "app_customization.home_title": "Titre de l’application sur l’écran d’accueil",
    "App title in home screen": "Titre de l’application sur l’écran d’accueil",
    "app_customization.default_collection_widgets": "Widgets de collection par défaut",
    "Default Collection Widgets": "Widgets de collection par défaut",
    "app_customization.accounts_follow_title": "Titre de la collection de comptes à suivre",
    "Accounts to follow collection title": "Titre de la collection de comptes à suivre",
    "app_customization.enter_accounts_follow_title": "Saisissez le titre de la collection de comptes à suivre",
    "Enter accounts to follow collection title": "Saisissez le titre de la collection de comptes à suivre",
    "app_customization.nearby_accounts_title": "Titre de la collection de comptes à proximité",
    "Nearby accounts collection title": "Titre de la collection de comptes à proximité",
    "app_customization.enter_nearby_accounts_title": "Saisissez le titre de la collection de comptes à proximité",
    "Enter near by accounts collection title": "Saisissez le titre de la collection de comptes à proximité",
    "app_customization.latest_listings_title": "Titre de la collection des annonces récentes",
    "Latest listings collection title": "Titre de la collection des annonces récentes",
    "app_customization.enter_latest_listings_title": "Saisissez le titre de la collection des annonces récentes",
    "Enter latest listings collection title": "Saisissez le titre de la collection des annonces récentes",
    "app_customization.enable_appearance_sections": "Sélectionnez les sections à afficher",
    "Select to enable appearance sections": "Sélectionnez les sections à afficher",
    "app_customization.choose_photo": "Choisir une photo",
    "Choose photo": "Choisir une photo",
    "app_customization.choose_icon": "Choisir une icône",
    "Choose icon": "Choisir une icône",
    "app_customization.enable_home_icon": "Afficher une icône pour le titre de l’application",
    "app_customization.account_name": "Nom du compte",
    "Account Name": "Nom du compte",
    "app_customization.product_name": "Nom du produit",
    "Product Name": "Nom du produit",
    "app_customization.home_option_0": "Afficher la collection à proximité",
    "Show nearby collection": "Afficher la collection à proximité",
    "app_customization.home_option_1": "Afficher la section des catégories",
    "Show category section": "Afficher la section des catégories",
    "app_customization.home_option_2": "Afficher les bannières promotionnelles",
    "Show promo banners": "Afficher les bannières promotionnelles",
    "app_customization.home_option_3": "Afficher l’invitation d’amis",
    "Show invite friends": "Afficher l’invitation d’amis",
    "app_customization.home_option_4": "Afficher les rappels d’avis",
    "Show review reminders": "Afficher les rappels d’avis",
    "app_customization.home_option_5": "Comptes à suivre",
    "Accounts to follow": "Comptes à suivre",
    "app_customization.download": "Télécharger",
    "app_customization.cancel": "Annuler",
    "app_customization.uploaded_successfully": "Téléversement réussi",
    "app_customization.image_limit": "Vous ne pouvez pas sélectionner d’autres images",
    "app_customization.choose_zip_file": "Choisir un fichier ZIP",
    "Choose zip file": "Choisir un fichier ZIP",
    "app_translation.title": "Personnalisation des chaînes",
    "app_translation.search": "Saisissez votre recherche...",
    "Type to search...": "Saisissez votre recherche...",
    "app_translation.default_language": "Par défaut",
    "Default": "Par défaut",
    "app_translation.default_text": "Texte par défaut",
    "Default text": "Texte par défaut",
    "communications.title": "Communications",
    "communications.tab_0": "Notification par e-mail",
    "Email Notification": "Notification par e-mail",
    "communications.tab_1": "Configuration de l’e-mail",
    "Email Configuration": "Configuration de l’e-mail",
    "communications.tab_2": "Notification de commande",
    "Order Notification": "Notification de commande",
    "communications.tab_3": "Formulaire de commentaires",
    "Feedback Form": "Formulaire de commentaires",
    "communications.translate": "Traduire",
    "Translate": "Traduire",
    "communications.edit_email_template": "Modifier le modèle d’e-mail",
    "Edit email template": "Modifier le modèle d’e-mail",
    "communications.feedback_email": "E-mail",
    "communications.feedback_phone": "Téléphone",
    "communications.feedback_email_or_phone": "E-mail ou téléphone",
    "Email or Phone": "E-mail ou téléphone",
    "communications.select_type": "Sélectionnez un type",
    "communications.form_required_field": "Champ obligatoire du formulaire",
    "Form Required Field": "Champ obligatoire du formulaire",
    "communications.feedback_recipient_label": "E-mail pour recevoir les commentaires (séparez plusieurs adresses par des virgules)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "E-mail pour recevoir les commentaires (séparez plusieurs adresses par des virgules)",
    "communications.enter_email": "Saisissez l’e-mail",
    "Enter email": "Saisissez l’e-mail",
    "communications.enable_feedback_form": "Activer le formulaire de commentaires",
    "Enable feedback Form": "Activer le formulaire de commentaires",
    "communications.feedback": "Commentaires",
    "Feedback": "Commentaires",
    "communications.realtime_config_notice": "Les paramètres ci-dessous sont appliqués en temps réel. Après avoir modifié ces paramètres et cliqué sur Enregistrer, les changements apparaissent dans les applications et les réponses API.",
    "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.": "Les paramètres ci-dessous sont appliqués en temps réel. Après avoir modifié ces paramètres et cliqué sur Enregistrer, les changements apparaissent dans les applications et les réponses API.",
    "communications.uploaded_successfully": "Téléversement réussi",
    "communications.email_whitelabeling": "Personnalisation de l’e-mail",
    "Email Whitelabelling": "Personnalisation de l’e-mail",
    "communications.from_name": "Nom de l’expéditeur",
    "From name": "Nom de l’expéditeur",
    "communications.enter_from_name": "Saisissez le nom de l’expéditeur",
    "Enter from name": "Saisissez le nom de l’expéditeur",
    "communications.from_email_address": "Adresse e-mail de l’expéditeur",
    "From email address": "Adresse e-mail de l’expéditeur",
    "communications.from_email_domain_hint": "Vous avez choisi un domaine personnalisé pour l’adresse e-mail de l’expéditeur. Pour assurer la distribution de vos e-mails, veuillez vérifier votre domaine auprès de nous. Contactez l’assistance pour obtenir de l’aide.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Vous avez choisi un domaine personnalisé pour l’adresse e-mail de l’expéditeur. Pour assurer la distribution de vos e-mails, veuillez vérifier votre domaine auprès de nous. Contactez l’assistance pour obtenir de l’aide.",
    "communications.reset": "Réinitialiser",
    "communications.enter_from_email": "Saisissez l’adresse e-mail de l’expéditeur",
    "Enter from email address": "Saisissez l’adresse e-mail de l’expéditeur",
    "communications.email_header_logo": "Logo d’en-tête de l’e-mail",
    "Email Header Logo": "Logo d’en-tête de l’e-mail",
    "communications.choose_logo": "Choisir un fichier 50 × 50",
    "Choose file 50*50": "Choisir un fichier 50 × 50",
    "communications.list_view": "Vue en liste",
    "communications.gallery_view": "Vue galerie",
    "Gallery view": "Vue galerie",
    "communications.grid_view": "Vue en grille",
    "communications.search": "Rechercher dans les communications",
    "Search communications": "Rechercher dans les communications",
    "communications.email_settings": "Paramètres des e-mails",
    "Email settings": "Paramètres des e-mails",
    "communications.category_all": "Tout",
    "communications.category_buyer": "Acheteur",
    "Buyer": "Acheteur",
    "communications.category_seller": "Vendeur",
    "communications.category_transactional": "Transactionnel",
    "Transactional": "Transactionnel",
    "communications.category_engagement": "Engagement",
    "Engagement": "Engagement",
    "communications.category_retention": "Fidélisation",
    "Retention": "Fidélisation",
    "communications.category_membership": "Adhésion",
    "communications.audience_buyer": "Acheteur",
    "communications.audience_seller": "Vendeur",
    "communications.system_notification": "Notification système",
    "System notification": "Notification système",
    "communications.template": "modèle",
    "template": "modèle",
    "communications.edit": "Modifier",
    "communications.sent": "envoyés",
    "sent": "envoyés",
    "communications.open": "ouverts",
    "communications.clicks": "clics",
    "clicks": "clics",
    "communications.no_email_matches": "Aucun e-mail ne correspond à ce filtre.",
    "No emails match your filter.": "Aucun e-mail ne correspond à ce filtre.",
    "communications.buyer_order_confirmation": "E-mail de confirmation de commande pour l’acheteur",
    "Order confirmation email for buyer": "E-mail de confirmation de commande pour l’acheteur",
    "communications.seller_order_confirmation": "E-mail de confirmation de commande pour le vendeur",
    "Order confirmation email for seller": "E-mail de confirmation de commande pour le vendeur",
    "communications.email_card_0": "Message de bienvenue",
    "Welcome Message": "Message de bienvenue",
    "communications.email_card_1": "Code OTP / Vérification",
    "OTP / Verification": "Code OTP / Vérification",
    "communications.email_card_2": "Lien d’abonnement",
    "Subscription Link": "Lien d’abonnement",
    "communications.email_card_3": "Abonnement réussi",
    "Subscription Success": "Abonnement réussi",
    "communications.email_card_4": "Confirmation de commande — acheteur",
    "Order confirmation — buyer": "Confirmation de commande — acheteur",
    "communications.email_card_5": "Confirmation de commande — vendeur",
    "Order confirmation — seller": "Confirmation de commande — vendeur",
    "communications.email_card_6": "Expédition envoyée — acheteur",
    "Shipment shipped — buyer": "Expédition envoyée — acheteur",
    "communications.email_card_7": "Expédition livrée — acheteur",
    "Shipment delivered — buyer": "Expédition livrée — acheteur",
    "communications.email_card_8": "Commande annulée — acheteur",
    "Order cancelled — buyer": "Commande annulée — acheteur",
    "communications.email_card_9": "Remboursement traité — acheteur",
    "Refund processed — buyer": "Remboursement traité — acheteur",
    "communications.email_card_10": "Nouvelle annonce d’une boutique suivie — acheteur",
    "New listing from followed store — buyer": "Nouvelle annonce d’une boutique suivie — acheteur",
    "communications.email_card_11": "De nouveau en stock — acheteur",
    "Back in stock — buyer": "De nouveau en stock — acheteur",
    "communications.email_card_12": "Alerte d’expiration d’annonce — vendeur",
    "Listing expiry warning — seller": "Alerte d’expiration d’annonce — vendeur",
    "communications.email_card_13": "Étape des mentions J’aime — vendeur",
    "Listing likes milestone — seller": "Étape des mentions J’aime — vendeur",
    "communications.email_card_14": "Compte vérifié — vendeur",
    "Account verified — seller": "Compte vérifié — vendeur",
    "communications.email_card_15": "Réactivation du vendeur — vendeur",
    "Seller win-back — seller": "Réactivation du vendeur — vendeur",
    "communications.email_card_16": "Alerte de stock faible — vendeur",
    "Low stock warning — seller": "Alerte de stock faible — vendeur",
    "communications.email_card_17": "Accueil du vendeur — vendeur",
    "Seller onboarded — seller": "Accueil du vendeur — vendeur",
    "communications.email_card_18": "Demande d’avis — acheteur",
    "Review request — buyer": "Demande d’avis — acheteur",
    "communications.email_card_19": "Première vente — vendeur",
    "First sale — seller": "Première vente — vendeur",
    "communications.email_card_20": "Étape des ventes — vendeur",
    "Sales milestone — seller": "Étape des ventes — vendeur",
    "communications.email_card_21": "Réactivation — acheteur",
    "Win-back — buyer": "Réactivation — acheteur",
    "communications.email_card_22": "Premier achat — acheteur",
    "First purchase — buyer": "Premier achat — acheteur",
    "communications.email_card_23": "Question du client — vendeur",
    "Customer question — seller": "Question du client — vendeur",
    "communications.email_card_24": "Réponse du vendeur — acheteur",
    "Seller answer — buyer": "Réponse du vendeur — acheteur",
    "communications.email_card_25": "Offre de négociation — vendeur",
    "Negotiation offer — seller": "Offre de négociation — vendeur",
    "communications.email_card_26": "Offre acceptée — acheteur",
    "Offer accepted — buyer": "Offre acceptée — acheteur",
    "communications.email_card_27": "Offre refusée — acheteur",
    "Offer rejected — buyer": "Offre refusée — acheteur",
    "communications.email_card_28": "Nouvel abonné — vendeur",
    "New follower — seller": "Nouvel abonné — vendeur",
    "communications.email_card_29": "Annonce aimée — vendeur",
    "Listing liked — seller": "Annonce aimée — vendeur",
    "communications.email_card_30": "Annonce approuvée — vendeur",
    "Listing approved — seller": "Annonce approuvée — vendeur",
    "communications.email_card_31": "Annonce refusée — vendeur",
    "Listing rejected — seller": "Annonce refusée — vendeur",
    "communications.email_card_32": "Première annonce — vendeur",
    "First listing — seller": "Première annonce — vendeur",
    "communications.email_card_33": "Panier abandonné — acheteur",
    "Abandoned cart — buyer": "Panier abandonné — acheteur",
    "communications.email_card_34": "Évaluation d’annonce — vendeur",
    "Listing review — seller": "Évaluation d’annonce — vendeur",
    "communications.email_card_35": "Rappel d’expédition — vendeur",
    "Fulfillment reminder — seller": "Rappel d’expédition — vendeur",
    "communications.email_card_36": "Baisse de prix — acheteur",
    "Price drop — buyer": "Baisse de prix — acheteur",
    "communications.email_card_37": "Paiement d’adhésion bientôt dû",
    "Membership payment due soon": "Paiement d’adhésion bientôt dû",
    "communications.email_card_38": "Paiement d’adhésion en retard",
    "Membership payment overdue": "Paiement d’adhésion en retard",
    "communications.order_status_notification": "Notification du statut de commande",
    "Order Status Notification": "Notification du statut de commande",
    "communications.order_group_lifecycle": "Cycle de commande",
    "Order lifecycle": "Cycle de commande",
    "communications.order_group_returns": "Retours et problèmes de livraison",
    "Returns and delivery issues": "Retours et problèmes de livraison",
    "communications.order_group_cancellations": "Annulations et retrait",
    "Cancellations and pickup": "Annulations et retrait",
    "communications.notification_settings_count": "{count} paramètres de notification",
    "{count} notification settings": "{count} paramètres de notification",
    "communications.enter_order_field": "Saisissez {field}",
    "Enter {field}": "Saisissez {field}",
    "communications.order_field_0": "Statut de commande confirmé",
    "Order status confirmed": "Statut de commande confirmé",
    "communications.order_field_1": "Statut de commande en cours",
    "Order status in progress": "Statut de commande en cours",
    "communications.order_field_2": "Statut de commande expédiée",
    "Order status shipped": "Statut de commande expédiée",
    "communications.order_field_3": "Client injoignable pour la commande",
    "Order status customer unreachable": "Client injoignable pour la commande",
    "communications.order_field_4": "Commande en cours de livraison",
    "Order status out for delivery": "Commande en cours de livraison",
    "communications.order_field_5": "Commande non livrée et retournée",
    "Order status undelivered returned": "Commande non livrée et retournée",
    "communications.order_field_6": "Retour de commande non livrée confirmé",
    "Order status undelivered return confirmed": "Retour de commande non livrée confirmé",
    "communications.order_field_7": "Commande livrée",
    "Order status delivered": "Commande livrée",
    "communications.order_field_8": "Livraison de la commande confirmée",
    "Order status delivered confirmed": "Livraison de la commande confirmée",
    "communications.order_field_9": "Retour client initié",
    "Order status customer return initiated": "Retour client initié",
    "communications.order_field_10": "Retour client récupéré",
    "Order status customer return picked": "Retour client récupéré",
    "communications.order_field_11": "Retour client confirmé",
    "Order status customer return confirmed": "Retour client confirmé",
    "communications.order_field_12": "Retour client contesté",
    "Order status customer return disputed": "Retour client contesté",
    "communications.order_field_13": "Commande annulée par le vendeur",
    "Order status cancelled by account": "Commande annulée par le vendeur",
    "communications.order_field_14": "Commande annulée par le client",
    "Order status cancelled by customer": "Commande annulée par le client",
    "communications.order_field_15": "Commande prête à être retirée",
    "Order status ready for pickup": "Commande prête à être retirée",
    "communications.order_field_16": "Commande terminée",
    "Order status completed": "Commande terminée",
    "communications.update": "Mettre à jour",
    "communications.download_template": "Télécharger le modèle",
    "Download Template": "Télécharger le modèle",
    "communications.reset_to_default": "Rétablir les valeurs par défaut",
    "Reset to default": "Rétablir les valeurs par défaut",
    "communications.send_test_email": "Envoyer un e-mail de test",
    "Send test email": "Envoyer un e-mail de test",
    "communications.enter_test_emails": "Saisissez une ou plusieurs adresses e-mail, séparées par des virgules",
    "Enter email(s), comma-separated": "Saisissez une ou plusieurs adresses e-mail, séparées par des virgules",
    "communications.send_test": "Envoyer un test",
    "Send test": "Envoyer un test",
    "communications.subject_required": "Le sujet ne doit pas être vide",
    "Subject should not be empty": "Le sujet ne doit pas être vide",
    "communications.body_required": "Le corps ne doit pas être vide",
    "Body should not be empty": "Le corps ne doit pas être vide",
    "communications.code_merge_tag_required": "La balise de fusion {code} est obligatoire",
    "{code} merge tag is mandatory": "La balise de fusion {code} est obligatoire",
    "communications.edit_template_named": "Modifier {name}",
    "Edit {name}": "Modifier {name}",
    "communications.subject": "Objet",
    "Subject": "Objet",
    "communications.enter_subject": "Saisissez l’objet",
    "Enter the Subject": "Saisissez l’objet",
    "communications.available_merge_tags": "Balises de fusion disponibles :",
    "Available merge tags:": "Balises de fusion disponibles :",
    "communications.body": "Corps",
    "Body": "Corps",
    "communications.write_here": "Écrivez ici…",
    "Write here...": "Écrivez ici…",
    "communications.subject_line": "Ligne d’objet",
    "Subject Line": "Ligne d’objet",
    "communications.enter_subject_line": "Saisissez l’objet…",
    "Enter the subject…": "Saisissez l’objet…",
    "communications.merge_tags": "Balises de fusion",
    "Merge tags": "Balises de fusion",
    "communications.loading_templates": "Chargement des modèles…",
    "Loading templates…": "Chargement des modèles…",
    "communications.hide_templates": "Masquer les modèles",
    "Hide templates": "Masquer les modèles",
    "communications.load_template": "Charger un modèle",
    "Load template": "Charger un modèle",
    "communications.html_body": "Corps HTML",
    "HTML Body": "Corps HTML",
    "communications.enter_html_body": "Collez ou saisissez votre code HTML ici…",
    "Paste or type your HTML here…": "Collez ou saisissez votre code HTML ici…",
    "communications.live_preview": "Aperçu en direct",
    "Live Preview": "Aperçu en direct",
    "communications.desktop": "Bureau",
    "Desktop": "Bureau",
    "communications.mobile": "Mobile",
    "communications.email_preview": "Aperçu de l’e-mail",
    "Email preview": "Aperçu de l’e-mail",
    "communications.start_typing_preview": "Commencez à écrire pour afficher l’aperçu",
    "Start typing to see a preview": "Commencez à écrire pour afficher l’aperçu",
    "communications.translations": "traductions",
    "translations": "traductions",
    "communications.validation_account_follow_tag": "La notification de suivi doit contenir {account_name}",
    "communications.validation_listing_like_tag": "La notification de mention J’aime doit contenir {user_name}",
    "Listing follow notification should contain {user_name}": "La notification de mention J’aime doit contenir {user_name}",
    "communications.validation_order_number_tag": "La notification de statut de commande doit contenir #{order_number}",
    "Order status follow notification should contain #{order_number}": "La notification de statut de commande doit contenir #{order_number}",
    "communications.validation_order_status_tag": "La notification de statut de commande doit contenir {order_status}",
    "Order status follow notification should contain {order_status}": "La notification de statut de commande doit contenir {order_status}",
    "communications.journey_title": "Parcours des e-mails",
    "Email Journey Map": "Parcours des e-mails",
    "communications.journey_subtitle": "À quel moment chaque e-mail est envoyé dans le parcours utilisateur",
    "Where each email fires in the user lifecycle": "À quel moment chaque e-mail est envoyé dans le parcours utilisateur",
    "communications.journey_buyer": "Parcours de l’acheteur",
    "Buyer Journey": "Parcours de l’acheteur",
    "communications.journey_seller": "Parcours du vendeur",
    "Seller Journey": "Parcours du vendeur",
    "communications.journey_buyer_stage_0": "Inscription",
    "Sign Up": "Inscription",
    "communications.journey_buyer_stage_1": "Navigation",
    "Browse": "Navigation",
    "communications.journey_buyer_stage_2": "Panier",
    "Cart": "Panier",
    "communications.journey_buyer_stage_3": "Commande passée",
    "Order Placed": "Commande passée",
    "communications.journey_buyer_stage_4": "Expédiée",
    "communications.journey_buyer_stage_5": "Livrée",
    "communications.journey_buyer_stage_6": "Négociation",
    "Negotiate": "Négociation",
    "communications.journey_buyer_stage_7": "Inactif",
    "communications.journey_seller_stage_0": "Intégration",
    "Onboard": "Intégration",
    "communications.journey_seller_stage_1": "Publier",
    "communications.journey_seller_stage_2": "Gérer",
    "Manage": "Gérer",
    "communications.journey_seller_stage_3": "Nouvelle commande",
    "Order In": "Nouvelle commande",
    "communications.journey_seller_stage_4": "Expédier",
    "communications.journey_seller_stage_5": "Terminé",
    "Complete": "Terminé",
    "communications.journey_seller_stage_6": "Inactif",
    "accounts.title": "Comptes",
    "accounts.status_pending": "En attente",
    "accounts.status_approved": "Approuvé",
    "accounts.status_rejected": "Refusé",
    "accounts.show_rows": "Afficher les lignes",
    "accounts.next": "Suivant",
    "accounts.previous": "Précédent",
    "accounts.view_list": "Liste",
    "accounts.view_map": "Carte",
    "Map": "Carte",
    "accounts.view_board": "Tableau",
    "accounts.view_grid": "Grille",
    "accounts.view_list_accessibility": "Vue en liste",
    "accounts.view_map_accessibility": "Vue carte",
    "Map view": "Vue carte",
    "accounts.view_board_accessibility": "Vue tableau",
    "Board view": "Vue tableau",
    "accounts.view_grid_accessibility": "Vue en grille",
    "accounts.column_name": "Nom",
    "accounts.column_account_id": "ID du compte",
    "accounts.column_description": "Description",
    "accounts.column_image": "Image",
    "accounts.column_user_name": "Nom d’utilisateur",
    "User Name": "Nom d’utilisateur",
    "accounts.column_email": "E-mail",
    "accounts.column_status": "Statut",
    "accounts.column_account_status": "Statut du compte",
    "Account Status": "Statut du compte",
    "accounts.column_location": "Emplacement",
    "accounts.search": "Rechercher des comptes",
    "Search accounts": "Rechercher des comptes",
    "accounts.export": "Exporter",
    "accounts.import": "Importer",
    "accounts.export_accounts": "Exporter des comptes",
    "Export accounts": "Exporter des comptes",
    "accounts.import_accounts": "Importer des comptes",
    "Import accounts": "Importer des comptes",
    "accounts.smart_upload_accounts": "Import intelligent de comptes",
    "Smart Upload accounts": "Import intelligent de comptes",
    "accounts.export_all_question": "Exporter tous les comptes ?",
    "Export all accounts?": "Exporter tous les comptes ?",
    "accounts.export_all_description": "Un fichier contenant tous les comptes sera préparé. Vous pouvez examiner ce processus avant de mettre à niveau votre offre.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Un fichier contenant tous les comptes sera préparé. Vous pouvez examiner ce processus avant de mettre à niveau votre offre.",
    "accounts.export_all": "Exporter tous les comptes",
    "Export all accounts": "Exporter tous les comptes",
    "accounts.cancel": "Annuler",
    "accounts.active": "Actif",
    "accounts.inactive": "Inactif",
    "accounts.not_available": "Indisponible",
    "accounts.approve": "Approuver",
    "accounts.reject": "Refuser",
    "accounts.manage": "Gérer",
    "accounts.tooltip_title": "Les comptes fonctionnent comme des boutiques.",
    "Accounts are like shops.": "Les comptes fonctionnent comme des boutiques.",
    "accounts.tooltip_description": "Les utilisateurs peuvent créer un espace sur votre plateforme pour gérer une activité : il s’agit d’un compte. Tous les utilisateurs n’en ont pas besoin. Les comptes peuvent être reliés à des comptes séquestres pour recevoir des paiements.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Les utilisateurs peuvent créer un espace sur votre plateforme pour gérer une activité : il s’agit d’un compte. Tous les utilisateurs n’en ont pas besoin. Les comptes peuvent être reliés à des comptes séquestres pour recevoir des paiements.",
    "accounts.create_account": "Créer un compte",
    "Create Account": "Créer un compte",
    "accounts.create_new_account": "Créer un nouveau compte",
    "Create New Account": "Créer un nouveau compte",
    "accounts.save": "Enregistrer",
    "accounts.please_wait": "Veuillez patienter…",
    "Please wait...": "Veuillez patienter…",
    "accounts.account_name": "Nom du compte",
    "accounts.slug": "Identifiant URL",
    "accounts.account_slug": "Identifiant URL du compte",
    "Account Slug": "Identifiant URL du compte",
    "accounts.account_description": "Description du compte",
    "Account Description": "Description du compte",
    "accounts.enter_name_first": "Veuillez d’abord saisir un nom",
    "accounts.user": "Utilisateur",
    "accounts.select_user": "Sélectionner un utilisateur",
    "accounts.category": "Catégorie",
    "Category": "Catégorie",
    "accounts.select_type": "Sélectionner un type",
    "accounts.smart_upload_title": "Import intelligent de comptes",
    "Smart account upload": "Import intelligent de comptes",
    "accounts.start_over": "Recommencer",
    "accounts.smart_upload_description": "Importez des comptes et associez les colonnes CSV aux champs du compte.",
    "Upload accounts and match your CSV columns to account fields.": "Importez des comptes et associez les colonnes CSV aux champs du compte.",
    "accounts.smart_upload_step_0": "Téléverser",
    "accounts.smart_upload_step_1": "Associer les colonnes",
    "accounts.smart_upload_step_2": "Vérifier",
    "accounts.smart_upload_step_3": "Importer",
    "accounts.choose_csv": "Choisir un fichier CSV",
    "accounts.smart_upload_required_note": "Le nom est obligatoire. L’adresse, l’identifiant URL, la catégorie, le propriétaire et les coordonnées sont facultatifs.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Le nom est obligatoire. L’adresse, l’identifiant URL, la catégorie, le propriétaire et les coordonnées sont facultatifs.",
    "accounts.select_csv": "Sélectionner un fichier CSV",
    "accounts.match_columns": "Associer les colonnes du compte",
    "Match account columns": "Associer les colonnes du compte",
    "accounts.import_field_name": "Nom",
    "accounts.import_field_description": "Description",
    "accounts.import_field_slug": "Identifiant URL",
    "accounts.import_field_category_id": "ID de catégorie",
    "Category ID": "ID de catégorie",
    "accounts.import_field_user_id": "ID utilisateur du propriétaire",
    "Owner User ID": "ID utilisateur du propriétaire",
    "accounts.import_field_location": "Adresse",
    "accounts.import_field_latitude": "Latitude",
    "Latitude": "Latitude",
    "accounts.import_field_longitude": "Longitude",
    "Longitude": "Longitude",
    "accounts.do_not_import": "Ne pas importer",
    "accounts.review_import": "Vérifier l’importation",
    "accounts.import_count": "{count} comptes seront importés.",
    "{count} accounts will be imported.": "{count} comptes seront importés.",
    "accounts.smart_upload_complete": "Import intelligent terminé",
    "accounts.imported_count": "{imported} comptes importés sur {total}.",
    "{imported} of {total} accounts imported.": "{imported} comptes importés sur {total}.",
    "accounts.selected_file": "Sélectionné : {filename}",
    "Selected: {filename}": "Sélectionné : {filename}",
    "accounts.review": "Vérifier",
    "accounts.importing": "Importation…",
    "accounts.uploading": "Téléversement…",
    "accounts.download": "Télécharger",
    "accounts.file_label": "Fichier :",
    "accounts.select_file": "Sélectionner un fichier",
    "accounts.upload": "Téléverser",
    "accounts.download_template": "Télécharger le modèle {type}",
    "accounts.import_stage_prepare": "Préparation du fichier d’importation",
    "Preparing import file": "Préparation du fichier d’importation",
    "accounts.import_prepare_failed": "Impossible de préparer le fichier d’importation.",
    "accounts.import_stage_upload": "Téléversement du fichier d’importation",
    "accounts.import_upload_failed": "Le fichier d’importation n’a pas pu être téléversé.",
    "accounts.import_stage_server": "Tradly importe les comptes",
    "Tradly is importing accounts": "Tradly importe les comptes",
    "accounts.import_stage_complete": "Importation terminée",
    "Import complete": "Importation terminée",
    "accounts.import_stage_stopped": "Importation interrompue",
    "accounts.confirm_approve": "Approuver ce compte ?",
    "Approve this account?": "Approuver ce compte ?",
    "accounts.confirm_reject": "Refuser ce compte ?",
    "Reject this account?": "Refuser ce compte ?",
    "accounts.name_required": "Le nom est obligatoire",
    "Name is required": "Le nom est obligatoire",
    "accounts.user_required": "L’utilisateur est obligatoire",
    "User is required": "L’utilisateur est obligatoire",
    "accounts.attribute_required": "{attribute} est obligatoire",
    "accounts.overview": "Aperçu du compte",
    "Account Overview": "Aperçu du compte",
    "accounts.section_listings": "Annonces",
    "accounts.loading": "Chargement…",
    "accounts.no_listings_owned": "Aucune annonce pour le moment",
    "No listings yet": "Aucune annonce pour le moment",
    "accounts.page_analytics": "Analyses de la page",
    "Page Analytics": "Analyses de la page",
    "accounts.analytics_key_missing": "La clé API d’analyse n’est pas configurée pour ce locataire.",
    "Analytics API key not configured for this tenant.": "La clé API d’analyse n’est pas configurée pour ce locataire.",
    "accounts.storefront_url_missing": "Aucune URL de boutique disponible pour ce compte.",
    "No storefront URL available for this account.": "Aucune URL de boutique disponible pour ce compte.",
    "accounts.no_analytics_loaded": "Aucune analyse chargée pour le moment.",
    "accounts.load_analytics": "Charger les analyses",
    "Load Analytics": "Charger les analyses",
    "accounts.attributes": "Attributs",
    "accounts.shipping": "Livraison",
    "accounts.commission": "Commission",
    "Commission": "Commission",
    "accounts.detail_title": "Titre",
    "accounts.detail_description": "Description",
    "accounts.detail_descriptions": "Descriptions",
    "Descriptions": "Descriptions",
    "accounts.detail_listings": "Annonces",
    "accounts.detail_categories": "Catégories",
    "accounts.detail_location": "Emplacement",
    "accounts.detail_account_status": "Statut du compte",
    "accounts.detail_status": "Statut",
    "accounts.detail_shipping_method": "Méthode de livraison",
    "accounts.detail_shipping_methods": "Méthodes de livraison",
    "Shipping Methods": "Méthodes de livraison",
    "accounts.detail_account_user": "Utilisateur du compte",
    "Account User": "Utilisateur du compte",
    "accounts.detail_pending": "En attente",
    "accounts.detail_approved": "Approuvé",
    "accounts.detail_rejected": "Refusé",
    "accounts.detail_active": "Actif",
    "accounts.detail_inactive": "Inactif",
    "accounts.detail_joined": "Inscrit",
    "accounts.detail_account_age": "Ancienneté du compte",
    "Account Age": "Ancienneté du compte",
    "accounts.detail_less_than_a_month": "Moins d’un mois",
    "Less than a month": "Moins d’un mois",
    "accounts.detail_page_views": "Vues de page",
    "Page Views": "Vues de page",
    "accounts.detail_unique_visitors": "Visiteurs uniques",
    "Unique Visitors": "Visiteurs uniques",
    "accounts.detail_sessions": "Sessions",
    "Sessions": "Sessions",
    "accounts.detail_clicks": "Clics",
    "Clicks": "Clics",
    "accounts.detail_goals": "Objectifs",
    "Goals": "Objectifs",
    "accounts.detail_bot_views": "Vues des robots",
    "Bot Views": "Vues des robots",
    "accounts.detail_followers": "Abonnés",
    "Followers": "Abonnés",
    "accounts.detail_total_orders": "Commandes totales",
    "accounts.detail_revenue": "Chiffre d’affaires",
    "accounts.detail_avg_order": "Commande moyenne",
    "Avg Order": "Commande moyenne",
    "accounts.detail_paid_orders": "Commandes payées",
    "Paid Orders": "Commandes payées",
    "accounts.detail_owner": "Propriétaire",
    "Owner": "Propriétaire",
    "accounts.detail_account_id": "ID du compte",
    "accounts.detail_category": "Catégorie",
    "accounts.detail_profile_completeness": "Profil complété",
    "Profile Completeness": "Profil complété",
    "accounts.detail_total_listings": "Nombre total d’annonces",
    "Total Listings": "Nombre total d’annonces",
    "accounts.detail_loaded_listings": "Annonces chargées",
    "Loaded Listings": "Annonces chargées",
    "accounts.detail_active_listings": "Annonces actives",
    "Active Listings": "Annonces actives",
    "accounts.detail_last_updated": "Dernière mise à jour",
    "Last Updated": "Dernière mise à jour",
    "accounts.detail_last_activity": "Dernière activité",
    "Last Activity": "Dernière activité",
    "accounts.detail_verification": "Vérification",
    "Verification": "Vérification",
    "accounts.detail_subscription": "Abonnement",
    "accounts.detail_attributes": "Attributs",
    "accounts.detail_shipping_charge_split": "Répartition des frais de livraison",
    "Shipping Charge Split": "Répartition des frais de livraison",
    "accounts.detail_value_type": "Type de valeur",
    "Value Type": "Type de valeur",
    "accounts.detail_value": "Valeur",
    "accounts.detail_enter_value": "Saisir une valeur",
    "accounts.detail_commission_percentage": "Pourcentage de commission",
    "Commission Percentage": "Pourcentage de commission",
    "accounts.detail_commission_percent": "Pourcentage de commission",
    "Commission Percent": "Pourcentage de commission",
    "accounts.detail_share": "Partager",
    "accounts.detail_view_account": "Afficher le compte",
    "View Account": "Afficher le compte",
    "accounts.detail_add_listing": "Ajouter une annonce",
    "Add Listing": "Ajouter une annonce",
    "accounts.detail_edit_account": "Modifier le compte",
    "Edit Account": "Modifier le compte",
    "accounts.no_attribute_values": "Aucune valeur d’attribut pour {name}",
    "No attribute values for {name}": "Aucune valeur d’attribut pour {name}",
    "accounts.no_attributes_yet": "Aucun attribut pour le moment",
    "No attributes yet": "Aucun attribut pour le moment",
    "accounts.edit_account": "Modifier le compte",
    "accounts.detail_preview": "Aperçu",
    "accounts.detail_fixed": "Fixe",
    "Fixed": "Fixe",
    "accounts.detail_percentage": "Pourcentage",
    "Percentage": "Pourcentage",
    "accounts.detail_select_value_type": "Sélectionner le type de valeur",
    "Select Value Type": "Sélectionner le type de valeur",
    "accounts.detail_approve": "Approuver",
    "accounts.detail_reject": "Refuser",
    "accounts.detail_section": "Détails",
    "Details": "Détails",
    "category.add_child": "Ajouter une catégorie enfant",
    "Add Child Category": "Ajouter une catégorie enfant",
    "category.add_listing": "Ajouter une annonce",
    "category.manage": "Gérer les catégories",
    "Manage Categories": "Gérer les catégories",
    "category.account_overview_eyebrow": "APERÇU DE LA CATÉGORIE DE COMPTE",
    "ACCOUNT CATEGORY OVERVIEW": "APERÇU DE LA CATÉGORIE DE COMPTE",
    "category.overview_eyebrow": "APERÇU DE LA CATÉGORIE",
    "CATEGORY OVERVIEW": "APERÇU DE LA CATÉGORIE",
    "category.category": "Catégorie",
    "category.active": "Actif",
    "category.inactive": "Inactif",
    "category.accounts": "Comptes",
    "category.listings": "Annonces",
    "category.child_categories": "Catégories enfants",
    "Child Categories": "Catégories enfants",
    "category.attributes": "Attributs",
    "category.category_age": "Ancienneté de la catégorie",
    "Category age": "Ancienneté de la catégorie",
    "category.category_overview": "Aperçu de la catégorie",
    "Category Overview": "Aperçu de la catégorie",
    "category.category_id": "ID de catégorie",
    "category.name": "Nom",
    "category.slug": "Identifiant URL",
    "category.description": "Description",
    "category.parent_category": "Catégorie parente",
    "Parent Category": "Catégorie parente",
    "category.hierarchy": "Hiérarchie",
    "Hierarchy": "Hiérarchie",
    "category.status": "Statut",
    "category.display_order": "Ordre d’affichage",
    "Display Order": "Ordre d’affichage",
    "category.created": "Date d’ajout / création",
    "Joined / Created": "Date d’ajout / création",
    "category.configured": "Configuré",
    "Configured": "Configuré",
    "category.no_attributes": "Aucun attribut associé.",
    "No attributes assigned.": "Aucun attribut associé.",
    "category.no_child_categories": "Aucune catégorie enfant.",
    "No child categories.": "Aucune catégorie enfant.",
    "category.no_accounts": "Aucun compte dans cette catégorie.",
    "No accounts in this category.": "Aucun compte dans cette catégorie.",
    "category.no_listings": "Aucune annonce dans cette catégorie.",
    "No listings in this category.": "Aucune annonce dans cette catégorie.",
    "category.detail_title": "Détail de la catégorie",
    "Category Detail": "Détail de la catégorie",
    "category.age_less_month": "Moins d’un mois",
    "category.age_month": "{count} mois",
    "{count} month": "{count} mois",
    "category.age_months": "{count} mois",
    "{count} months": "{count} mois",
    "category.age_year": "{count} an",
    "{count} year": "{count} an",
    "category.age_years": "{count} ans",
    "{count} years": "{count} ans",
    "category.header_name": "Nom",
    "category.header_category_id": "ID de catégorie",
    "category.header_image": "Image",
    "category.header_order": "Ordre",
    "category.header_parent": "Parent",
    "Parent": "Parent",
    "category.header_active": "Actif",
    "category.header_action": "Action",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Catégories",
    "category.translate": "Traduire",
    "category.import": "Importer",
    "category.export": "Exporter",
    "category.add_category": "Ajouter une catégorie",
    "Add Category": "Ajouter une catégorie",
    "category.import_categories": "Importer des catégories",
    "Import Categories": "Importer des catégories",
    "category.delete_warning": "Les annonces existantes ne s’ouvriront pas sur le site ou l’application et afficheront une erreur.",
    "Existing listings will not open in website or app, you will see an error.": "Les annonces existantes ne s’ouvriront pas sur le site ou l’application et afficheront une erreur.",
    "category.editor_edit_category": "Modifier la catégorie",
    "Edit Category": "Modifier la catégorie",
    "category.editor_add_category": "Ajouter une catégorie",
    "category.editor_save": "Enregistrer",
    "category.editor_select_category_level": "Sélectionner le niveau de catégorie",
    "Select Category Level": "Sélectionner le niveau de catégorie",
    "category.editor_parent_category": "Catégorie parente",
    "category.editor_select": "Sélectionner",
    "category.editor_category_name": "Nom de la catégorie",
    "Category Name": "Nom de la catégorie",
    "category.editor_enter_category_name": "Saisir le nom de la catégorie",
    "Enter category name": "Saisir le nom de la catégorie",
    "category.editor_slug": "Identifiant URL",
    "category.editor_enter_slug": "Saisir l’identifiant URL",
    "category.editor_category_description": "Description de la catégorie",
    "Category Description": "Description de la catégorie",
    "category.editor_order": "Ordre",
    "category.editor_enter_order": "Saisir l’ordre",
    "category.editor_status_not_active_active": "Statut (inactif / actif)",
    "category.editor_upload_media": "Téléverser un média",
    "category.editor_meta_title": "Méta-titre",
    "category.editor_enter_meta_title": "Saisir le méta-titre",
    "category.editor_meta_description": "Méta-description",
    "category.editor_category": "Catégorie",
    "category.editor_name": "Nom",
    "category.editor_status": "Statut",
    "category.editor_action": "Action",
    "category.editor_add_attribute": "Ajouter un attribut",
    "Add Attribute": "Ajouter un attribut",
    "category.editor_attributes_list": "Liste des attributs",
    "Attributes List": "Liste des attributs",
    "category.editor_please_enter_a_category_name_first": "Veuillez d’abord saisir un nom de catégorie",
    "Please enter a category name first": "Veuillez d’abord saisir un nom de catégorie",
    "category.editor_successfully_added_category": "Catégorie ajoutée avec succès",
    "Successfully added category": "Catégorie ajoutée avec succès",
    "category.deleted": "Catégorie supprimée",
    "Category deleted": "Catégorie supprimée",
    "attributes.title": "Attributs",
    "attributes.cart_checkout": "Panier et paiement",
    "Cart & Checkout": "Panier et paiement",
    "attributes.cart_settings": "Paramètres du panier",
    "Cart settings": "Paramètres du panier",
    "attributes.order_status_notifications": "Notifications de statut de commande",
    "Order status notifications": "Notifications de statut de commande",
    "attributes.groups": "Groupes d’attributs",
    "Attribute Groups": "Groupes d’attributs",
    "attributes.add_attribute": "Ajouter un attribut",
    "attributes.edit_bulk": "Modifier en masse",
    "Edit Bulk": "Modifier en masse",
    "attributes.confirm_delete": "Voulez-vous supprimer cet attribut ?",
    "Do you want to delete this attribute?": "Voulez-vous supprimer cet attribut ?",
    "attributes.header_attribute_name": "Nom de l’attribut",
    "Attribute Name": "Nom de l’attribut",
    "attributes.header_action": "Action",
    "attributes.header_manage_attribute_values": "Gérer les valeurs d’attribut",
    "Manage Attribute Values": "Gérer les valeurs d’attribut",
    "attributes.header_type": "Type",
    "attributes.header_optional": "Facultatif",
    "attributes.header_icon": "Icône",
    "Icon": "Icône",
    "attributes.header_categories": "Catégories",
    "attributes.header_hidden_field": "Champ masqué",
    "Hidden Field": "Champ masqué",
    "attributes.header_values": "Valeurs",
    "Values": "Valeurs",
    "attributes.header_status": "Statut",
    "attributes.type_single_select": "Sélection unique",
    "Single Select": "Sélection unique",
    "attributes.type_multi_select": "Sélection multiple",
    "Multi Select": "Sélection multiple",
    "attributes.type_open_single_value": "Ouvert (valeur unique)",
    "Open (Single Value)": "Ouvert (valeur unique)",
    "attributes.type_open_multiple_value": "Ouvert (valeurs multiples)",
    "Open (Multiple Value)": "Ouvert (valeurs multiples)",
    "attributes.type_attachment": "Pièce jointe",
    "Attachment": "Pièce jointe",
    "attributes.type_text_area": "Zone de texte",
    "Text Area": "Zone de texte",
    "attributes.type_date_time": "Date et heure",
    "Date Time": "Date et heure",
    "attributes.type_number": "Nombre",
    "attributes.type_boolean": "Booléen",
    "Boolean": "Booléen",
    "attributes.type_color": "Couleur",
    "Color": "Couleur",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "Emplacement",
    "attributes.type_audio": "Audio",
    "Audio": "Audio",
    "attributes.type_video": "Vidéo",
    "Video": "Vidéo",
    "attributes.type_open_multi_value": "Ouvert (valeurs multiples)",
    "Open (Multi Value)": "Ouvert (valeurs multiples)",
    "attributes.editor_edit_attribute": "Modifier l’attribut",
    "Edit Attribute": "Modifier l’attribut",
    "attributes.editor_add_attribute": "Ajouter un attribut",
    "attributes.editor_attribute_name": "Nom de l’attribut",
    "attributes.editor_select_type": "Sélectionner le type",
    "attributes.prefill_user": "Utilisateur",
    "common.search_placeholder": "Saisissez votre recherche...",
    "attributes.prefill_accounts": "Comptes",
    "attributes.prefill_listings": "Annonces",
    "listings.detail_nav_gallery": "Galerie",
    "Gallery": "Galerie",
    "listings.detail_nav_details": "Détails",
    "listings.detail_nav_inventory": "Inventaire",
    "listings.detail_nav_social": "Réseaux sociaux",
    "Social": "Réseaux sociaux",
    "listings.detail_nav_orders": "Commandes",
    "listings.detail_nav_analytics": "Analyses",
    "listings.detail_nav_schedule": "Calendrier",
    "listings.detail_nav_rental": "Location",
    "Rental": "Location",
    "listings.detail_nav_attributes": "Attributs",
    "listings.detail_nav_seller": "Vendeur",
    "attributes.editor_icon": "Icône",
    "attributes.editor_tool_tip": "Info-bulle",
    "Tool tip": "Info-bulle",
    "attributes.editor_enter_attribute_name": "Saisir le nom de l’attribut",
    "attributes.editor_enter_attribute_tool_tip": "Saisir l’info-bulle de l’attribut",
    "Enter attribute tool tip": "Saisir l’info-bulle de l’attribut",
    "attributes.editor_optional": "Facultatif",
    "attributes.editor_private": "Privé",
    "Private": "Privé",
    "attributes.editor_hidden_field": "Champ masqué",
    "Hidden field": "Champ masqué",
    "attributes.editor_show_in_filter": "Afficher dans le filtre",
    "attributes.editor_status_not_active_active": "Statut (inactif / actif)",
    "attributes.editor_add_meta_data": "Ajouter des métadonnées",
    "Add meta data": "Ajouter des métadonnées",
    "attributes.editor_select": "Sélectionner",
    "attributes.editor_select_category": "Sélectionner une catégorie",
    "attributes.editor_select_all": "Tout sélectionner",
    "Select All": "Tout sélectionner",
    "attributes.editor_unselect_all": "Tout désélectionner",
    "UnSelect All": "Tout désélectionner",
    "attributes.editor_create_categories_in_this_configuration_first": "Créez d’abord des catégories dans cette configuration",
    "Create categories in this configuration first": "Créez d’abord des catégories dans cette configuration",
    "attributes.editor_please_enter_attribute_name": "Veuillez saisir le nom de l’attribut",
    "Please enter attribute name": "Veuillez saisir le nom de l’attribut",
    "attributes.editor_please_select_type": "Veuillez sélectionner un type",
    "Please select type": "Veuillez sélectionner un type",
    "attributes.editor_select_single_attribute_values": "Sélectionner les valeurs d’attribut uniques",
    "attributes.editor_select_multiple_attribute_values": "Sélectionner plusieurs valeurs d’attribut",
    "attributes.editor_enter_value": "Saisir une valeur",
    "attributes.editor_enter_multiple_tag": "Saisir plusieurs balises",
    "Enter Multiple Tag": "Saisir plusieurs balises",
    "attributes.editor_upload_file": "Téléverser un fichier",
    "Upload file": "Téléverser un fichier",
    "attributes.editor_enter_text": "Saisir du texte",
    "attributes.editor_select_date": "Sélectionner une date",
    "attributes.editor_enter_number": "Saisir un nombre",
    "attributes.editor_select_color": "Sélectionner une couleur",
    "attributes.editor_upload_json": "Téléverser un fichier JSON",
    "Upload Json": "Téléverser un fichier JSON",
    "attributes.editor_select_location": "Sélectionner un emplacement",
    "attributes.editor_category": "Catégorie",
    "attributes.editor_price": "Prix",
    "attributes.editor_enter_price": "Saisir le prix",
    "attributes.editor_preview": "Aperçu",
    "attributes.editor_title": "Titre",
    "attributes.editor_enter_title": "Saisir le titre",
    "attributes.editor_description": "Description",
    "attributes.editor_add_listing": "Ajouter une annonce",
    "attributes.editor_add_account": "Ajouter un compte",
    "Add Account": "Ajouter un compte",
    "attributes.editor_successfully_added_attributes": "Attributs ajoutés avec succès",
    "Successfully added attributes": "Attributs ajoutés avec succès",
    "attributes.editor_add_attribute_values": "Ajouter des valeurs d’attribut",
    "Add Attribute Values": "Ajouter des valeurs d’attribut",
    "common.image": "Image",
    "common.please_wait": "Veuillez patienter…",
    "attribute_groups.title": "Groupes d’attributs",
    "attribute_groups.title_singular": "Groupe d’attributs",
    "Attribute Group": "Groupe d’attributs",
    "attribute_groups.add": "Ajouter un groupe d’attributs",
    "Add Attribute Group": "Ajouter un groupe d’attributs",
    "attribute_groups.image_path": "Chemin de l’image",
    "Image Path": "Chemin de l’image",
    "attribute_groups.name_placeholder": "Nom du groupe",
    "Group Name": "Nom du groupe",
    "attribute_groups.select_attributes": "Sélectionner des attributs",
    "Select Attributes": "Sélectionner des attributs",
    "attribute_groups.select_attributes_placeholder": "Sélectionner des attributs…",
    "Select Attributes...": "Sélectionner des attributs…",
    "attribute_groups.added_successfully": "Groupe d’attributs ajouté avec succès",
    "Attribute Group Added Successfully": "Groupe d’attributs ajouté avec succès",
    "attribute_groups.deleted_successfully": "Suppression réussie",
    "Deleted successfully": "Suppression réussie",
    "attribute_groups.name_required": "Le nom est obligatoire",
    "attribute_groups.save_attributes_failed": "Le groupe a été enregistré, mais ses attributs n’ont pas pu être associés.",
    "The group was saved, but its attributes could not be assigned.": "Le groupe a été enregistré, mais ses attributs n’ont pas pu être associés.",
    "attributes.editor_enter_description": "Saisir la description",
    "account_config.title": "Configuration du compte",
    "account_config.account_detail_note": "Note sur le compte",
    "Account detail note": "Note sur le compte",
    "account_config.enter_account_detail_note": "Saisir une note sur le compte",
    "Enter account detail note": "Saisir une note sur le compte",
    "account_config.address_label": "Libellé de l’adresse",
    "Address label": "Libellé de l’adresse",
    "account_config.enter_address_label": "Saisir le libellé de l’adresse",
    "Enter address label": "Saisir le libellé de l’adresse",
    "account_config.category_label": "Libellé de la catégorie",
    "Category label": "Libellé de la catégorie",
    "account_config.enter_category_label": "Saisir le libellé de la catégorie",
    "Enter category label": "Saisir le libellé de la catégorie",
    "account_config.nearby_accounts_radius_km": "Rayon des comptes à proximité (km)",
    "Nearby accounts radius (km)": "Rayon des comptes à proximité (km)",
    "account_config.nearby_accounts_radius_placeholder": "Rayon des comptes à proximité en km",
    "Account nearby radius in km": "Rayon des comptes à proximité en km",
    "account_config.account_limit": "Limite de comptes",
    "Account Limit": "Limite de comptes",
    "account_config.account_limit_placeholder": "Limite de comptes",
    "Account limit": "Limite de comptes",
    "account_config.shipping_preference_note": "Note sur les préférences de livraison",
    "Shipping method preference note": "Note sur les préférences de livraison",
    "account_config.option_accounts_auto_approved": "Approbation automatique des comptes",
    "Accounts auto approved": "Approbation automatique des comptes",
    "account_config.option_shipping_methods_preference_for_accounts": "Préférences de livraison des comptes",
    "Shipping methods preference for accounts": "Préférences de livraison des comptes",
    "account_config.option_account_map_location_selector": "Sélecteur de localisation sur la carte du compte",
    "Account map location selector": "Sélecteur de localisation sur la carte du compte",
    "account_config.option_account_geo_location": "Géolocalisation du compte",
    "Account Geo Location": "Géolocalisation du compte",
    "account_config.option_slug": "Identifiant URL",
    "account_config.option_show_description": "Afficher la description",
    "Show Description": "Afficher la description",
    "account_config.option_formatted_text_description": "Description au format enrichi",
    "Formatted Text Description": "Description au format enrichi",
    "account_config.option_hide_address_from_account_detail": "Masquer l’adresse dans le détail du compte",
    "Hide Address from Account Detail": "Masquer l’adresse dans le détail du compte",
    "account_config.option_get_account_pickup_address_always": "Toujours utiliser l’adresse de retrait du compte",
    "Get Account Pickup Address Always": "Toujours utiliser l’adresse de retrait du compte",
    "account_config.option_get_pickup_address_for_delivery": "Utiliser l’adresse de retrait pour la livraison",
    "Get Pickup Address for Delivery": "Utiliser l’adresse de retrait pour la livraison",
    "account_config.uploaded_successfully": "Enregistré avec succès",
    "app_customization.realtime_config_notice": "Les paramètres ci-dessous sont appliqués en temps réel. Après avoir modifié ces paramètres et cliqué sur Enregistrer, les changements apparaissent dans les applications et les réponses API.",
    "app_customization.release_config_notice": "Remarque pour les canaux d’applications mobiles : les paramètres ci-dessous s’appliquent uniquement lors d’une publication ou d’une mise à jour du produit. Ils ne sont jamais actualisés en temps réel. Après toute modification nécessitant une nouvelle compilation, demandez une compilation depuis le portail d’assistance. (Offre Starter uniquement)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Remarque pour les canaux d’applications mobiles : les paramètres ci-dessous s’appliquent uniquement lors d’une publication ou d’une mise à jour du produit. Ils ne sont jamais actualisés en temps réel. Après toute modification nécessitant une nouvelle compilation, demandez une compilation depuis le portail d’assistance. (Offre Starter uniquement)",
    "category.translation_title": "Traduire la catégorie",
    "Translate Category": "Traduire la catégorie",
    "category.translation_category_name": "Nom de la catégorie",
    "category.translation_description": "Description",
    "listing_configs.title": "Configuration des annonces",
    "Listing Configuration": "Configuration des annonces",
    "listing_configs.rules": "RÈGLES (niveau projet/locataire)",
    "RULES (Projects/Tenant level)": "RÈGLES (niveau projet/locataire)",
    "listing_configs.features": "FONCTIONNALITÉS (application mobile uniquement)",
    "FEATURES (Only for mobile app)": "FONCTIONNALITÉS (application mobile uniquement)",
    "listing_configs.ui_customisation": "Personnalisation de l’interface",
    "UI Customisation": "Personnalisation de l’interface",
    "listing_configs.overridden_max_quantity": "Quantité maximale par annonce",
    "Maximum quantity per listing": "Quantité maximale par annonce",
    "listing_configs.overridden_max_quantity_example": "(Exemple : 100)",
    "(Example: 100)": "(Exemple : 100)",
    "listing_configs.listing_min_price": "Prix minimum de l’annonce",
    "Minimum listing price": "Prix minimum de l’annonce",
    "listing_configs.listing_min_price_example": "(Exemple : 5 $)",
    "(Example: $5)": "(Exemple : 5 $)",
    "listing_configs.auto_approval": "Approuver automatiquement les annonces ?",
    "Auto approve listings?": "Approuver automatiquement les annonces ?",
    "listing_configs.listing_pictures_count": "Nombre d’images téléversables",
    "Number of uploadable pictures count": "Nombre d’images téléversables",
    "listing_configs.seller_can_place_order": "Le vendeur peut passer commande",
    "Seller can place order": "Le vendeur peut passer commande",
    "listing_configs.hide_offer_percent": "Pourcentage de l’offre",
    "listing_configs.show_max_quantity": "Limite de quantité maximale par annonce",
    "listing_configs.show_shipping_charges": "Frais de livraison",
    "Shipping charges": "Frais de livraison",
    "listing_configs.listing_address_label": "Libellé de l’adresse",
    "listing_configs.listing_address_label_example": "(Exemple : point de repère)",
    "(Example: Landmark)": "(Exemple : point de repère)",
    "listing_configs.listing_map_location_selector_enabled": "Utiliser un repère sur la carte au lieu de rechercher une adresse",
    "Use map marker instead of searching address": "Utiliser un repère sur la carte au lieu de rechercher une adresse",
    "listing_configs.listing_hide_tags": "Étiquettes",
    "listing_configs.enable_stock": "Stocks",
    "Stocks": "Stocks",
    "listing_configs.listing_address_enabled": "Adresse géographique",
    "Geo address": "Adresse géographique",
    "listing_configs.show_stock_out_listings": "Afficher les annonces en rupture de stock dans le fil",
    "Show out of stock listings in feed": "Afficher les annonces en rupture de stock dans le fil",
    "listing_configs.enable_slug": "Identifiant URL du titre de l’annonce",
    "Listing title slug": "Identifiant URL du titre de l’annonce",
    "listing_configs.show_variants": "Variantes",
    "Variants": "Variantes",
    "listing_configs.meta_title": "Méta-titre",
    "listing_configs.meta_description": "Méta-description",
    "listing_configs.listing_enable_formatted_text_description": "Activer l’éditeur de texte",
    "Enable Composer": "Activer l’éditeur de texte",
    "listing_configs.listing_enable_weight": "Activer le poids",
    "Enable Weight": "Activer le poids",
    "listing_configs.listing_enable_dimensions": "Activer les dimensions",
    "Enable Dimensions": "Activer les dimensions",
    "listing_configs.enable_stocks_listing_schedules": "Calendriers de stock",
    "Stock Schedules": "Calendriers de stock",
    "listing_variants.title": "Types de variantes",
    "listing_variants.add_type": "Ajouter un type de variante",
    "Add Variant Type": "Ajouter un type de variante",
    "listing_variants.edit_type": "Modifier le type de variante",
    "Edit Variant Type": "Modifier le type de variante",
    "listing_variants.name": "Nom",
    "listing_variants.values": "Valeurs",
    "listing_variants.status": "Statut",
    "listing_variants.action": "Action",
    "listing_variants.add_value": "Ajouter une valeur",
    "Add Value": "Ajouter une valeur",
    "listing_variants.active": "Actif",
    "listing_variants.inactive": "Inactif",
    "listing_variants.details": "Détails",
    "listing_variants.translate": "Traduire",
    "listing_variants.delete_confirm": "Voulez-vous supprimer ce type de variante ?",
    "Do you want to delete this variant type?": "Voulez-vous supprimer ce type de variante ?",
    "listing_variants.add_value_first": "Ajoutez une valeur avant d’afficher les variantes.",
    "Add a value before viewing variants.": "Ajoutez une valeur avant d’afficher les variantes.",
    "listing_variants.enter_name": "Saisissez un nom",
    "listing_variants.status_hint": "Statut (inactif / actif)",
    "listing_variants.total_values": "Nombre total de valeurs",
    "Total Values": "Nombre total de valeurs",
    "listing_variants.type_id": "ID du type",
    "Type ID": "ID du type",
    "listing_variants.total_count": "{count} au total",
    "{count} total": "{count} au total",
    "listing_variants.loading": "Chargement…",
    "listing_variants.loading_values": "Chargement des valeurs…",
    "Loading values…": "Chargement des valeurs…",
    "listing_variants.no_values": "Aucune valeur pour le moment",
    "No values yet": "Aucune valeur pour le moment",
    "listing_variants.add_first_value": "Ajouter la première valeur",
    "Add First Value": "Ajouter la première valeur",
    "listing_variants.actions": "Actions",
    "listing_variants.edit": "Modifier",
    "listing_variants.delete": "Supprimer",
    "listing_variants.edit_value": "Modifier la valeur",
    "Edit Value": "Modifier la valeur",
    "listing_variants.value_name_required": "Nom de la valeur *",
    "Value Name *": "Nom de la valeur *",
    "listing_variants.value_examples": "ex. Rouge, XL, Coton…",
    "e.g. Red, XL, Cotton…": "ex. Rouge, XL, Coton…",
    "listing_variants.saving": "Enregistrement…",
    "listing_variants.save_changes": "Enregistrer les modifications",
    "Save Changes": "Enregistrer les modifications",
    "listing_variants.delete_value_confirm": "Voulez-vous supprimer cette valeur de variante ?",
    "Do you want to delete this variant value?": "Voulez-vous supprimer cette valeur de variante ?",
    "listing_variants.clear_all": "Tout effacer",
    "listing_variants.multiple_values_help": "Vous pouvez saisir des valeurs séparées par des virgules ou coller une colonne depuis Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Vous pouvez saisir des valeurs séparées par des virgules ou coller une colonne depuis Excel.",
    "listing_variants.save": "Enregistrer",
    "listing_variants.close": "Fermer",
    "listing_variants.update": "Mettre à jour",
    "listing_variants.default_text": "Texte par défaut",
    "listing_variants.enter_value": "Saisissez la valeur de variante",
    "Enter variant value": "Saisissez la valeur de variante",
    "listing_variants.add_values": "Ajouter des valeurs",
    "Add Values": "Ajouter des valeurs",
    "listing_variants.add_variant_values": "Ajouter des valeurs de type de variante",
    "Add Variant Type Values": "Ajouter des valeurs de type de variante",
    "listing_variants.values_list": "Liste des valeurs du type de variante",
    "Variant Type Values List": "Liste des valeurs du type de variante",
    "listing_variants.cancel_editing": "Annuler la modification",
    "Cancel Editing": "Annuler la modification",
    "listing_variants.value_name": "Valeur du type de variante",
    "Variant Type Value": "Valeur du type de variante",
    "common.default_text": "Texte par défaut",
    "common.translation_heading": "Traductions : {title}",
    "{title} Translations": "Traductions : {title}",
    "attributes.value_delete_confirm": "Voulez-vous supprimer cette valeur d’attribut ?",
    "Do you want to delete this attribute value?": "Voulez-vous supprimer cette valeur d’attribut ?",
    "attributes.value_clear_all": "Tout effacer",
    "attributes.value_multiple_help": "Saisissez des valeurs séparées par des virgules ou collez une colonne depuis Excel.",
    "Add comma-separated values or paste a column from Excel.": "Saisissez des valeurs séparées par des virgules ou collez une colonne depuis Excel.",
    "attributes.value_active": "Actif",
    "attributes.value_inactive": "Inactif",
    "attributes.value_save": "Enregistrer",
    "attributes.value_close": "Fermer",
    "attributes.value_translate": "Traduire",
    "attributes.value_update": "Mettre à jour",
    "attributes.value_sort_alpha": "Trier par ordre alphabétique",
    "Sort Alphabetically": "Trier par ordre alphabétique",
    "attributes.value_default_text": "Texte par défaut",
    "attributes.value_add_metadata": "Ajouter des métadonnées",
    "Add Metadata": "Ajouter des métadonnées",
    "attributes.value_cancel_edit": "Annuler la modification",
    "attributes.value_success_help": "Super ! Vous trouverez cet attribut personnalisé sur la page d’ajout d’annonce.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Super ! Vous trouverez cet attribut personnalisé sur la page d’ajout d’annonce.",
    "attributes.value_add": "Ajouter des valeurs d’attribut",
    "attributes.value_add_listing": "Ajouter des valeurs d’attribut d’annonce",
    "Add Listing Attribute Values": "Ajouter des valeurs d’attribut d’annonce",
    "attributes.value_metadata_for": "Métadonnées pour",
    "Metadata for": "Métadonnées pour",
    "attributes.value_enter": "Saisissez la valeur de l’attribut",
    "Enter attribute value": "Saisissez la valeur de l’attribut",
    "attributes.value_add_values": "Ajouter des valeurs",
    "attributes.value_status_hint": "Statut (inactif / actif)",
    "attributes.value_list": "Liste des valeurs d’attribut",
    "Attribute Values List": "Liste des valeurs d’attribut",
    "attributes.value_table_name": "Valeur d’attribut",
    "Attribute Value": "Valeur d’attribut",
    "attributes.value_table_status": "Statut",
    "attributes.value_table_action": "Action",
    "attributes.metadata_key": "Clé",
    "Key": "Clé",
    "attributes.metadata_value": "Valeur",
    "attributes.metadata_add_row": "Ajouter une ligne",
    "Add Row": "Ajouter une ligne",
    "workspace.countries": "Pays",
    "workspace.country_add": "Ajouter un pays",
    "Add Country": "Ajouter un pays",
    "workspace.country_edit": "Modifier le pays",
    "Edit Country": "Modifier le pays",
    "workspace.country_name": "Nom du pays",
    "Country Name": "Nom du pays",
    "workspace.select_country": "Sélectionner un pays",
    "Select country": "Sélectionner un pays",
    "workspace.country_order": "Ordre",
    "workspace.country_order_placeholder": "Saisissez l’ordre",
    "workspace.country_status": "Statut (inactif / actif)",
    "workspace.country_default": "Par défaut",
    "workspace.country_active": "Actif",
    "workspace.country_inactive": "Inactif",
    "workspace.country_delete_confirm": "Voulez-vous supprimer ce pays ?",
    "Do you want to delete this country?": "Voulez-vous supprimer ce pays ?",
    "workspace.country_table_name": "Nom",
    "workspace.country_table_default": "Par défaut",
    "workspace.country_table_order": "Ordre",
    "workspace.country_table_status": "Statut",
    "workspace.country_table_action": "Action",
    "workspace.languages": "Langues",
    "workspace.language_add": "Ajouter une langue",
    "Add Language": "Ajouter une langue",
    "workspace.language_edit": "Modifier la langue",
    "Edit Language": "Modifier la langue",
    "workspace.language_name": "Langue",
    "workspace.language_select": "Sélectionner une langue",
    "Select Language": "Sélectionner une langue",
    "workspace.language_order": "Ordre",
    "workspace.language_order_placeholder": "Saisissez l’ordre",
    "workspace.language_status": "Statut",
    "workspace.language_default": "Par défaut",
    "workspace.language_default_warning": "La modification de la langue par défaut change la langue de l’application.",
    "Changing the default language changes the app language setting.": "La modification de la langue par défaut change la langue de l’application.",
    "workspace.language_active": "Actif",
    "workspace.language_inactive": "Inactif",
    "workspace.language_delete_confirm": "Voulez-vous supprimer cette langue ?",
    "Do you want to delete this language?": "Voulez-vous supprimer cette langue ?",
    "workspace.language_table_name": "Nom",
    "workspace.language_table_default": "Par défaut",
    "workspace.language_table_order": "Ordre",
    "workspace.language_table_status": "Statut",
    "workspace.language_table_action": "Action",
    "workspace.language_add_photo": "Ajouter une photo",
    "Add Photo": "Ajouter une photo",
    "workspace.currency": "Devise",
    "workspace.currency_add": "Ajouter une devise",
    "Add Currency": "Ajouter une devise",
    "workspace.currency_edit": "Modifier la devise",
    "Edit Currency": "Modifier la devise",
    "workspace.currency_delete_confirm": "Voulez-vous supprimer cette devise ?",
    "Do you want to delete this currency?": "Voulez-vous supprimer cette devise ?",
    "workspace.currency_show": "Afficher",
    "workspace.currency_entries": "entrées",
    "entries": "entrées",
    "workspace.currency_search": "Rechercher :",
    "Search:": "Rechercher :",
    "workspace.currency_search_placeholder": "Rechercher des devises",
    "Search currencies": "Rechercher des devises",
    "workspace.currency_empty": "Aucune devise trouvée.",
    "No currencies found.": "Aucune devise trouvée.",
    "workspace.currency_active": "Active",
    "workspace.currency_inactive": "Inactive",
    "workspace.currency_name": "Nom",
    "workspace.currency_name_placeholder": "Nom de la devise",
    "Currency Name": "Nom de la devise",
    "workspace.currency_upload_media": "Téléverser un média",
    "workspace.currency_select_media": "Choisir dans les médias",
    "workspace.currency_no_media": "Vous ne disposez d’aucun fichier média.",
    "You do not have any media files.": "Vous ne disposez d’aucun fichier média.",
    "workspace.currency_code": "Code",
    "workspace.currency_select_code": "Sélectionner",
    "workspace.currency_exchange_rate": "Taux de change",
    "Exchange Rate": "Taux de change",
    "workspace.currency_precision": "Précision",
    "Precision": "Précision",
    "workspace.currency_thousand_separator": "Séparateur des milliers",
    "Thousand Separator": "Séparateur des milliers",
    "workspace.currency_decimal_point": "Séparateur décimal",
    "Decimal Point": "Séparateur décimal",
    "workspace.currency_status_hint": "Statut (inactif / actif)",
    "workspace.currency_default": "Par défaut",
    "workspace.currency_format": "Format",
    "Format": "Format",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Nom",
    "workspace.currency_table_code": "Code",
    "workspace.currency_table_format": "Format",
    "workspace.currency_table_exchange": "Change",
    "Exchange": "Change",
    "workspace.currency_table_status": "Statut",
    "workspace.currency_table_default": "Par défaut",
    "workspace.currency_table_action": "Action",
    "commissions.title": "Commissions",
    "commissions.add": "Ajouter une commission",
    "Add Commission": "Ajouter une commission",
    "commissions.edit": "Modifier la commission",
    "Edit Commission": "Modifier la commission",
    "commissions.delete_confirm": "Voulez-vous supprimer cette commission ?",
    "Do you want to delete this commission?": "Voulez-vous supprimer cette commission ?",
    "commissions.yes": "Oui",
    "commissions.no": "Non",
    "commissions.filter_all": "Tout",
    "commissions.filter_supply": "Offre",
    "Supply": "Offre",
    "commissions.filter_demand": "Demande",
    "Demand": "Demande",
    "commissions.filter_cart": "Panier",
    "commissions.table_title": "Titre",
    "commissions.table_default_value": "Valeur par défaut",
    "Default Value": "Valeur par défaut",
    "commissions.table_status": "Statut",
    "commissions.table_action": "Action",
    "commissions.active": "Actif",
    "commissions.inactive": "Inactif",
    "commissions.type": "Type",
    "commissions.type_supply": "Offre",
    "commissions.type_demand": "Demande",
    "commissions.type_cart": "Panier",
    "commissions.select_category": "Sélectionner une catégorie",
    "commissions.title_label": "Titre",
    "commissions.enter_title": "Saisir le titre",
    "commissions.description": "Description",
    "commissions.enter_description": "Saisir une description",
    "commissions.default_value_percent": "Valeur par défaut (%)",
    "Default value (%)": "Valeur par défaut (%)",
    "commissions.short_code": "Code court",
    "Short Code": "Code court",
    "commissions.short_code_tooltip_title": "Code court",
    "Short code": "Code court",
    "commissions.short_code_tooltip_description": "Saisissez un code court pour cette commission.",
    "Enter a short code for this commission.": "Saisissez un code court pour cette commission.",
    "commissions.enter_short_code": "Saisir le code court",
    "commissions.status_hint": "Statut (Inactif / Actif)",
    "commissions.optional": "Facultatif",
    "commissions.advanced": "Avancé",
    "Advanced": "Avancé",
    "commissions.add_by_category": "Ajouter une commission par catégorie",
    "Add commission by category": "Ajouter une commission par catégorie",
    "commissions.select_calculation_type": "Sélectionner le type",
    "commissions.calc_fixed": "Fixe",
    "commissions.calc_slab": "Par tranche",
    "Slab": "Par tranche",
    "commissions.value": "Valeur",
    "commissions.choose_category": "Choisir une catégorie",
    "Choose category": "Choisir une catégorie",
    "commissions.create_categories_first": "Créez d’abord des catégories dans la configuration des annonces",
    "Create categories in Listing Configuration first": "Créez d’abord des catégories dans la configuration des annonces",
    "commissions.select_type": "Sélectionner le type",
    "commissions.demand_fixed": "Fixe",
    "commissions.demand_percentage": "Pourcentage",
    "commissions.unlimited_hint": "* Saisissez -1 pour illimité",
    "* Enter -1 for unlimited": "* Saisissez -1 pour illimité",
    "commissions.from": "De",
    "commissions.enter_from": "Saisir la valeur de départ",
    "Enter from": "Saisir la valeur de départ",
    "commissions.to": "À",
    "commissions.enter_to": "Saisir la valeur de fin",
    "Enter to": "Saisir la valeur de fin",
    "commissions.enter_value": "Saisir la valeur",
    "commissions.add_row": "Ajouter une ligne",
    "commissions.minimum_amount": "Montant minimum",
    "Minimum amount": "Montant minimum",
    "commissions.enter_minimum_amount": "Saisir le montant minimum",
    "commissions.maximum_amount": "Montant maximum",
    "Maximum amount": "Montant maximum",
    "commissions.enter_maximum_amount": "Saisir le montant maximum",
    "commissions.notes": "Remarques",
    "commissions.enter_note": "Saisir une remarque",
    "commissions.from_value": "Valeur de départ",
    "From Value": "Valeur de départ",
    "commissions.to_value": "Valeur de fin",
    "To Value": "Valeur de fin",
    "commissions.unlimited_short_hint": "(-1 pour illimité)",
    "(-1 for unlimited)": "(-1 pour illimité)",
    "commissions.value_percent": "Valeur (%)",
    "Value (%)": "Valeur (%)",
    "commissions.from_value_validation": "La valeur de départ doit dépasser la valeur de fin précédente",
    "From value should be greater than the previous To value": "La valeur de départ doit dépasser la valeur de fin précédente",
    "commissions.to_value_validation": "La valeur de fin doit être supérieure à la valeur de départ",
    "To value should be greater than From value": "La valeur de fin doit être supérieure à la valeur de départ",
    "taxes.title": "Taxe",
    "taxes.title_plural": "Taxes",
    "taxes.add": "Ajouter une taxe",
    "Add Tax": "Ajouter une taxe",
    "taxes.edit": "Modifier la taxe",
    "Edit Tax": "Modifier la taxe",
    "taxes.delete_confirm": "Voulez-vous vraiment supprimer cette taxe ?",
    "Are you sure you want to delete this tax?": "Voulez-vous vraiment supprimer cette taxe ?",
    "taxes.table_title": "Titre",
    "taxes.table_short_code": "Code court",
    "taxes.table_default_value": "Valeur par défaut",
    "taxes.table_status": "Statut",
    "taxes.table_action": "Action",
    "taxes.active": "Active",
    "taxes.inactive": "Inactive",
    "taxes.select_type": "Sélectionner le type",
    "taxes.type_order": "Commande",
    "taxes.type_listing": "Annonce",
    "taxes.type_tax": "Taxe",
    "taxes.demand_fixed": "Fixe",
    "taxes.demand_percentage": "Pourcentage",
    "taxes.from": "De",
    "taxes.enter_from": "Saisir la valeur de départ",
    "taxes.to": "À",
    "taxes.enter_to": "Saisir la valeur de fin",
    "taxes.unlimited_hint": "(-1 pour illimité)",
    "taxes.value": "Valeur",
    "taxes.enter_value": "Saisir la valeur",
    "taxes.add_row": "Ajouter une ligne",
    "taxes.note": "Remarque",
    "taxes.note_placeholder": "Saisissez une remarque que les utilisateurs verront au paiement et dans les détails de la commande.",
    "Enter a note for users to see during checkout and in order details.": "Saisissez une remarque que les utilisateurs verront au paiement et dans les détails de la commande.",
    "taxes.inclusive": "Taxe incluse",
    "Tax Inclusive": "Taxe incluse",
    "taxes.inclusive_tooltip": "Activez cette option si le prix affiché inclut déjà la taxe.",
    "Enable this when the listed price already includes tax.": "Activez cette option si le prix affiché inclut déjà la taxe.",
    "taxes.title_placeholder": "Saisissez un nom visible au paiement et dans les détails de la commande.",
    "Enter a name shown to users at checkout and in order details.": "Saisissez un nom visible au paiement et dans les détails de la commande.",
    "taxes.default_value": "Valeur par défaut (%)",
    "taxes.default_placeholder": "Valeur par défaut en %. Exemple : 6.5",
    "Default value in %. Example: 6.5": "Valeur par défaut en %. Exemple : 6.5",
    "taxes.short_code": "Code court",
    "taxes.short_code_tooltip_title": "Code court",
    "taxes.short_code_tooltip_description": "Saisissez un code court pour cette taxe.",
    "Enter a short code for this tax.": "Saisissez un code court pour cette taxe.",
    "taxes.short_code_placeholder": "Utilisez des lettres et des chiffres (10 caractères maximum). Exemple : GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Utilisez des lettres et des chiffres (10 caractères maximum). Exemple : GST10",
    "taxes.status_hint": "Statut (Inactif / Actif)",
    "taxes.advanced": "Avancé",
    "special_fees.title": "Frais spéciaux",
    "special_fees.description": "Configurez des frais supplémentaires fixes ou en pourcentage pour chaque annonce.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Configurez des frais supplémentaires fixes ou en pourcentage pour chaque annonce.",
    "special_fees.fixed": "Frais fixes",
    "Special fees fixed": "Frais fixes",
    "special_fees.fixed_placeholder": "Saisissez le montant des frais (exemple : 5)",
    "Enter special fee amount (example: 5)": "Saisissez le montant des frais (exemple : 5)",
    "special_fees.percentage": "Frais en pourcentage",
    "Special fees percentage": "Frais en pourcentage",
    "special_fees.percentage_placeholder": "Saisissez le pourcentage des frais (exemple : 10 %)",
    "Enter special fee percentage (example: 10%)": "Saisissez le pourcentage des frais (exemple : 10 %)",
    "special_fees.example": "Exemple",
    "Example": "Exemple",
    "special_fees.example_description": "Vous pouvez ajouter des frais au prix de l’annonce. Par exemple, un article coûte 100 $ et vous ajoutez deux frais par annonce.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "Vous pouvez ajouter des frais au prix de l’annonce. Par exemple, un article coûte 100 $ et vous ajoutez deux frais par annonce.",
    "special_fees.example_fixed": "Montant fixe supplémentaire = 10 $",
    "Additional fixed amount = $10": "Montant fixe supplémentaire = 10 $",
    "special_fees.example_percentage": "Pourcentage supplémentaire = 10 %",
    "Additional fixed percentage = 10%": "Pourcentage supplémentaire = 10 %",
    "special_fees.example_total": "Prix final = 120 $",
    "Final price = $120": "Prix final = 120 $",
    "delivery.methods_title": "Méthodes de service et de livraison",
    "Service / Shipping Methods": "Méthodes de service et de livraison",
    "delivery.shipping_service": "Livraison / Service",
    "Shipping / Service": "Livraison / Service",
    "delivery.table_name": "Nom",
    "delivery.table_default": "Par défaut",
    "delivery.table_order": "Ordre",
    "delivery.table_status": "Statut",
    "delivery.table_action": "Action",
    "delivery.yes": "Oui",
    "delivery.no": "Non",
    "delivery.active": "Actif",
    "delivery.inactive": "Inactif",
    "delivery.delete_confirm": "Voulez-vous supprimer cette méthode de livraison ?",
    "Do you want to delete this shipping method?": "Voulez-vous supprimer cette méthode de livraison ?",
    "delivery.schedule_time": "Planifier l’heure",
    "Schedule Time": "Planifier l’heure",
    "delivery.translate": "Traduire",
    "delivery.config": "Configuration",
    "Config": "Configuration",
    "delivery.add": "Ajouter un service ou une livraison",
    "Add Shipping/Service": "Ajouter un service ou une livraison",
    "delivery.save": "Enregistrer",
    "delivery.edit": "Modifier le service ou la livraison",
    "Edit Shipping/Service": "Modifier le service ou la livraison",
    "delivery.stuart_config": "Configuration Stuart",
    "Stuart Configs": "Configuration Stuart",
    "delivery.shipping_configs": "Configuration du service et de la livraison",
    "Service / Shipping Configs": "Configuration du service et de la livraison",
    "delivery.settings": "Paramètres",
    "delivery.preview": "Aperçu",
    "delivery.shipment_option": "Option de livraison",
    "Shipment Option": "Option de livraison",
    "delivery.name": "Nom",
    "delivery.enter_name": "Saisir le nom",
    "delivery.note": "Remarque",
    "delivery.enter_note": "Saisir une remarque",
    "delivery.note_tooltip_title": "Remarque",
    "delivery.note_tooltip_description": "Ajoutez une remarque facultative pour expliquer cette option de livraison ou de service.",
    "Add an optional note to explain this shipping or service option.": "Ajoutez une remarque facultative pour expliquer cette option de livraison ou de service.",
    "delivery.order": "Ordre",
    "delivery.enter_order": "Saisir l’ordre",
    "delivery.status_hint": "Statut (Inactif / Actif)",
    "delivery.default": "Par défaut",
    "delivery.select_shipping_method": "Sélectionner une méthode de livraison",
    "Select shipping method": "Sélectionner une méthode de livraison",
    "delivery.select_extension": "Sélectionner une extension",
    "Select extension": "Sélectionner une extension",
    "delivery.add_photo": "Ajouter une photo",
    "delivery.config.flat_shipping_fee.title": "Frais de livraison fixes",
    "Flat Shipping Fee": "Frais de livraison fixes",
    "delivery.config.flat_shipping_fee.placeholder": "Saisir les frais de livraison fixes",
    "Enter flat shipping fee": "Saisir les frais de livraison fixes",
    "delivery.config.schedule_time.title": "Planifier l’heure",
    "delivery.config.fulfillment_by_platform_enabled.title": "Fulfillment par la plateforme",
    "Fulfillment by platform": "Fulfillment par la plateforme",
    "delivery.config.fulfilled_by_platform_icon_path.title": "« Fulfillment » par l’icône de la plateforme",
    "Fulfillment by Platform Icon": "« Fulfillment » par l’icône de la plateforme",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Icône de livraison du vendeur",
    "Seller Delivery Icon": "Icône de livraison du vendeur",
    "delivery.phone_number": "Numéro de téléphone",
    "Phone number": "Numéro de téléphone",
    "delivery.enter_phone_number": "Saisir le numéro de téléphone",
    "Enter phone number": "Saisir le numéro de téléphone",
    "delivery.address_line_1": "Adresse ligne 1",
    "Address line 1": "Adresse ligne 1",
    "delivery.enter_address_line_1": "Saisir l’adresse ligne 1",
    "Enter address line 1": "Saisir l’adresse ligne 1",
    "delivery.address_line_2": "Adresse ligne 2",
    "Address line 2": "Adresse ligne 2",
    "delivery.enter_address_line_2": "Saisir l’adresse ligne 2",
    "Enter address line 2": "Saisir l’adresse ligne 2",
    "delivery.landmark": "Point de repère",
    "Landmark": "Point de repère",
    "delivery.enter_landmark": "Saisir un point de repère",
    "Enter landmark": "Saisir un point de repère",
    "delivery.state": "Région",
    "delivery.enter_state": "Saisir la région",
    "Enter state": "Saisir la région",
    "delivery.post_code": "Code postal",
    "Post code": "Code postal",
    "delivery.enter_post_code": "Saisir le code postal",
    "Enter post code": "Saisir le code postal",
    "delivery.country": "Pays",
    "delivery.enter_country": "Saisir le pays",
    "Enter country": "Saisir le pays",
    "delivery.required_information": "Veuillez renseigner les informations obligatoires",
    "Please fill the required information": "Veuillez renseigner les informations obligatoires",
    "delivery.saved_successfully": "Enregistré avec succès",
    "delivery.storage_hub.title": "Points du centre de stockage",
    "Storage Hub Points": "Points du centre de stockage",
    "delivery.storage_hub.add": "Ajouter un centre de stockage",
    "Add Storage Hub": "Ajouter un centre de stockage",
    "delivery.storage_hub.edit": "Modifier le centre de stockage",
    "Edit Storage Hub": "Modifier le centre de stockage",
    "delivery.storage_hub.delete_confirm": "Voulez-vous supprimer ce point du centre de stockage ?",
    "Do you want to delete this storage hub point?": "Voulez-vous supprimer ce point du centre de stockage ?",
    "delivery.storage_hub.table_name": "Nom",
    "delivery.storage_hub.table_phone": "Téléphone",
    "delivery.storage_hub.table_address": "Adresse",
    "delivery.storage_hub.table_landmark": "Point de repère",
    "delivery.storage_hub.table_state": "Région",
    "delivery.storage_hub.table_post_code": "Code postal",
    "Post Code": "Code postal",
    "delivery.storage_hub.table_country": "Pays",
    "delivery.storage_hub.table_action": "Action",
    "delivery.select_environment": "Sélectionner l’environnement",
    "Select environment": "Sélectionner l’environnement",
    "delivery.environment_sandbox": "Bac à sable",
    "Sandbox": "Bac à sable",
    "delivery.environment_production": "Production",
    "Production": "Production",
    "delivery.stuart.client_id": "Identifiant client",
    "delivery.stuart.enter_client_id": "Saisir l’identifiant client",
    "delivery.stuart.client_secret": "Secret client",
    "Client Secret": "Secret client",
    "delivery.stuart.enter_client_secret": "Saisir le secret client",
    "Enter client secret": "Saisir le secret client",
    "delivery.stuart.webhook_key": "Clé d’authentification du webhook",
    "Webhook Authentication Key": "Clé d’authentification du webhook",
    "delivery.stuart.enter_webhook_key": "Saisir la clé d’authentification du webhook",
    "Enter webhook authentication key": "Saisir la clé d’authentification du webhook",
    "delivery.sendcloud.public_key": "Clé publique",
    "Public Key": "Clé publique",
    "delivery.sendcloud.enter_public_key": "Saisir la clé API",
    "delivery.sendcloud.secret_key": "Clé secrète",
    "Secret Key": "Clé secrète",
    "delivery.sendcloud.enter_secret_key": "Saisir le secret de notification",
    "Enter notification secret": "Saisir le secret de notification",
    "delivery.sendcloud.default_shipping_address": "Adresse d’expédition par défaut",
    "Default Shipping Address": "Adresse d’expédition par défaut",
    "delivery.sendcloud.add_new": "+ Ajouter",
    "+ Add New": "+ Ajouter",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Méthodes de paiement",
    "Payment Methods": "Méthodes de paiement",
    "payments.add": "Ajouter un moyen de paiement",
    "Add Payment Method": "Ajouter un moyen de paiement",
    "payments.edit": "Modifier le moyen de paiement",
    "Edit Payment Method": "Modifier le moyen de paiement",
    "payments.delete_confirm": "Voulez-vous supprimer ce moyen de paiement ?",
    "Do you want to delete this payment method?": "Voulez-vous supprimer ce moyen de paiement ?",
    "payments.save_continue": "Enregistrer et continuer",
    "Save and continue": "Enregistrer et continuer",
    "payments.translate": "Traduire les paiements",
    "Translate Payments": "Traduire les paiements",
    "payments.config": "Configuration",
    "payments.integration_settings": "Paramètres d’intégration",
    "Integration Settings": "Paramètres d’intégration",
    "payments.opp_integration": "Intégration OPP",
    "OPP Integration": "Intégration OPP",
    "payments.billplz_integration": "Intégration BillPlz",
    "BillPlz Integration": "Intégration BillPlz",
    "payments.stripe_integration": "Intégration Stripe",
    "Stripe Integration": "Intégration Stripe",
    "payments.stripe_web_integration": "Intégration Stripe Web",
    "Stripe Web Integration": "Intégration Stripe Web",
    "payments.pawapay_integration": "Intégration PawaPay",
    "PawaPay Integration": "Intégration PawaPay",
    "payments.korapay_integration": "Intégration KoraPay",
    "KoraPay Integration": "Intégration KoraPay",
    "payments.flutterwave_integration": "Intégration Flutterwave",
    "Flutterwave Integration": "Intégration Flutterwave",
    "payments.commercepay_integration": "Intégration CommercePay",
    "CommercePay Integration": "Intégration CommercePay",
    "payments.checkout_com_integration": "Intégration Checkout.com",
    "Checkout.com Integration": "Intégration Checkout.com",
    "payments.paystack_integration": "Intégration PayStack",
    "PayStack Integration": "Intégration PayStack",
    "payments.razorpay_settings": "Paramètres Razorpay",
    "Razorpay settings": "Paramètres Razorpay",
    "payments.paydunya_settings": "Paramètres Pay Dunya",
    "Pay Dunya settings": "Paramètres Pay Dunya",
    "payments.mangopay_settings": "Paramètres MangoPay",
    "MangoPay settings": "Paramètres MangoPay",
    "payments.payu_latam_integration": "Intégration PayU LATAM",
    "PayU LATAM Integration": "Intégration PayU LATAM",
    "payments.table_name": "Nom",
    "payments.table_actions": "Actions",
    "payments.table_min_amount": "Montant minimum",
    "Minimum Amount": "Montant minimum",
    "payments.table_max_amount": "Montant maximum",
    "Maximum Amount": "Montant maximum",
    "payments.table_default": "Par défaut",
    "payments.table_order_by": "Ordre",
    "payments.table_status": "Statut",
    "payments.yes": "Oui",
    "payments.no": "Non",
    "payments.active": "Actif",
    "payments.inactive": "Inactif",
    "payments.settings": "Paramètres",
    "payments.not_available": "Indisponible",
    "payments.step_select_type": "Sélectionner le type",
    "payments.step_configure": "Configurer",
    "Configure": "Configurer",
    "payments.step_integration": "Intégration",
    "Integration": "Intégration",
    "payments.next": "Suivant →",
    "Next →": "Suivant →",
    "payments.save": "Enregistrer",
    "payments.choose_method": "Choisissez un moyen de paiement à configurer",
    "Choose a payment method to configure": "Choisissez un moyen de paiement à configurer",
    "payments.name": "Nom",
    "payments.enter_name": "Saisir le nom",
    "payments.maximum_amount": "Montant maximum",
    "payments.enter_maximum_amount": "Saisir le montant maximum",
    "payments.minimum_amount": "Montant minimum",
    "payments.enter_minimum_amount": "Saisir le montant minimum",
    "payments.note": "Remarque",
    "payments.enter_note": "Saisir une remarque",
    "payments.note_tooltip": "Ajoutez une remarque facultative visible par les clients au paiement.",
    "Add an optional note for customers at checkout.": "Ajoutez une remarque facultative visible par les clients au paiement.",
    "payments.order": "Ordre",
    "payments.enter_order": "Saisir l’ordre",
    "payments.default": "Par défaut",
    "payments.config_title": "Configuration des moyens de paiement",
    "Payment Methods Configuration": "Configuration des moyens de paiement",
    "payments.wallet_enable": "Portefeuille activé",
    "Wallet enabled": "Portefeuille activé",
    "payments.account_type": "Type de compte",
    "payments.select_account_type": "Sélectionner un type de compte",
    "Select account type": "Sélectionner un type de compte",
    "payments.connect_message_standard": "Message de connexion standard",
    "Connect message standard": "Message de connexion standard",
    "payments.enter_connect_message_standard": "Saisir le message de connexion standard",
    "Enter connect message standard": "Saisir le message de connexion standard",
    "payments.disconnect_message_standard": "Message de déconnexion standard",
    "Disconnect message standard": "Message de déconnexion standard",
    "payments.enter_disconnect_message_standard": "Saisir le message de déconnexion standard",
    "Enter disconnect message standard": "Saisir le message de déconnexion standard",
    "payments.connect_message_express": "Message de connexion express",
    "Connect message express": "Message de connexion express",
    "payments.enter_connect_message_express": "Saisir le message de connexion express",
    "Enter connect message express": "Saisir le message de connexion express",
    "payments.disconnect_message_express": "Message de déconnexion express",
    "Disconnect message express": "Message de déconnexion express",
    "payments.enter_disconnect_message_express": "Saisir le message de déconnexion express",
    "Enter disconnect message express": "Saisir le message de déconnexion express",
    "payments.enable_sandbox": "Activer le mode sandbox",
    "Enable sandbox": "Activer le mode sandbox",
    "payments.api_token": "Jeton API",
    "API Token": "Jeton API",
    "payments.enter_token": "Saisir le jeton",
    "payments.key_id": "ID de clé",
    "Key ID": "ID de clé",
    "payments.enter_key_id": "Saisir l’ID de la clé",
    "Enter key ID": "Saisir l’ID de la clé",
    "payments.key_secret": "Clé secrète",
    "Key Secret": "Clé secrète",
    "payments.enter_secret_key": "Saisir la clé secrète",
    "Enter secret key": "Saisir la clé secrète",
    "payments.webhook_secret_key": "Clé secrète du webhook",
    "Webhook Secret Key": "Clé secrète du webhook",
    "payments.enter_webhook_secret_key": "Saisir la clé secrète du webhook",
    "Enter webhook secret key": "Saisir la clé secrète du webhook",
    "payments.master_key": "Clé principale",
    "Master Key": "Clé principale",
    "payments.public_key": "Clé publique",
    "payments.enter_public_key": "Saisir la clé publique",
    "payments.private_key": "Clé privée",
    "Private Key": "Clé privée",
    "payments.merchant_id": "ID marchand",
    "Merchant ID": "ID marchand",
    "payments.enter_merchant_id": "Saisir l’ID marchand",
    "Enter merchant id": "Saisir l’ID marchand",
    "payments.processing_channel_id": "ID du canal de traitement",
    "Processing channel ID": "ID du canal de traitement",
    "payments.enter_processing_channel_id": "Saisir l’ID du canal de traitement",
    "Enter processing channel id": "Saisir l’ID du canal de traitement",
    "payments.api_key": "Clé API",
    "payments.x_signature_key": "Clé de signature X",
    "X Signature Key": "Clé de signature X",
    "payments.account_id": "ID de compte",
    "payments.login_api_key": "Clé API de connexion",
    "Login API key": "Clé API de connexion",
    "payments.client_id": "ID client",
    "payments.client_api_key": "Clé API client",
    "Client API Key": "Clé API client",
    "payments.payin_fee": "Frais PayIn (%)",
    "PayIn fee (%)": "Frais PayIn (%)",
    "payments.withdraw_fee": "Frais de retrait (%)",
    "Withdraw fee (%)": "Frais de retrait (%)",
    "payments.enter_api_key": "Saisir la clé API",
    "payments.enter_account_id": "Saisir l’ID de compte",
    "Enter account ID": "Saisir l’ID de compte",
    "payments.enter_login_api_key": "Saisir la clé API de connexion",
    "Enter login API key": "Saisir la clé API de connexion",
    "payments.enter_notification_secret": "Saisir le secret de notification",
    "payments.enter_payin_fee": "Saisir les frais en pourcentage",
    "Enter fee as a percentage": "Saisir les frais en pourcentage",
    "payments.secret_key": "Clé secrète",
    "Secret key": "Clé secrète",
    "payments.publishable_key": "Clé publiable",
    "Publishable key": "Clé publiable",
    "payments.webhook_secret": "Secret du webhook",
    "Webhook secret": "Secret du webhook",
    "payments.enter_webhook_secret": "Saisir le secret du webhook",
    "Enter webhook secret": "Saisir le secret du webhook",
    "payments.enter_subscription_webhook_secret": "Saisir le secret webhook de l’abonnement",
    "Enter subscription webhook secret": "Saisir le secret webhook de l’abonnement",
    "payments.connect_client_id": "ID client Connect",
    "Connect client ID": "ID client Connect",
    "payments.enter_connect_client_id": "Saisir l’ID client Connect",
    "Enter Connect client ID": "Saisir l’ID client Connect",
    "payments.stripe_reminders": "Rappels Stripe",
    "Stripe reminders": "Rappels Stripe",
    "payments.stripe_sync_help": "La synchronisation vérifie votre clé secrète auprès de Stripe, renseigne les informations de votre compte et crée les points de terminaison webhook nécessaires à Tradly. Les secrets webhook sont renseignés automatiquement. Enregistrez le formulaire une fois terminé.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "La synchronisation vérifie votre clé secrète auprès de Stripe, renseigne les informations de votre compte et crée les points de terminaison webhook nécessaires à Tradly. Les secrets webhook sont renseignés automatiquement. Enregistrez le formulaire une fois terminé.",
    "payments.find_in_stripe": "Voir dans le tableau de bord Stripe",
    "Find in Stripe Dashboard": "Voir dans le tableau de bord Stripe",
    "payments.description": "Description",
    "payments.learn_more_stripe": "En savoir plus sur les paiements Stripe",
    "Learn more about Stripe Payments": "En savoir plus sur les paiements Stripe",
    "payments.learn_more_stripe_connect": "En savoir plus sur Stripe Connect pour les places de marché",
    "Learn more about Stripe Connect for marketplaces": "En savoir plus sur Stripe Connect pour les places de marché",
    "payments.token": "Jeton",
    "Token": "Jeton",
    "payments.payment_options": "Options de paiement",
    "Payment options": "Options de paiement",
    "payments.enable_integration": "Activer l’intégration",
    "Enable integration": "Activer l’intégration",
    "payments.enter_provider_id": "Saisir l’ID de {provider}",
    "Enter {provider} ID": "Saisir l’ID de {provider}",
    "payments.integration_status_help": "Configurez ce fournisseur dans ses paramètres.",
    "Configure this provider in its settings.": "Configurez ce fournisseur dans ses paramètres.",
    "listings.title": "Annonces",
    "listings.manage": "Gérer",
    "listings.show_rows": "Afficher les lignes",
    "listings.clear": "Effacer",
    "listings.apply": "Appliquer",
    "listings.select_date": "Sélectionner une date",
    "Select date": "Sélectionner une date",
    "listings.start_date": "Date de début",
    "listings.end_date": "Date de fin",
    "listings.status_types": "Types de statut",
    "Status types": "Types de statut",
    "listings.categories": "Catégories",
    "listings.attributes": "Attributs",
    "listings.clear_all_filters": "Effacer tous les filtres",
    "Clear all filters": "Effacer tous les filtres",
    "listings.import": "Importer",
    "listings.export": "Exporter",
    "listings.smart_upload": "Import intelligent (bêta)",
    "Smart Upload (Beta)": "Import intelligent (bêta)",
    "listings.filter_listings": "Filtrer les annonces",
    "Filter listings": "Filtrer les annonces",
    "listings.sort_listings": "Trier les annonces",
    "Sort listings": "Trier les annonces",
    "listings.import_listings": "Importer des annonces",
    "listings.export_listings": "Exporter les annonces",
    "Export listings": "Exporter les annonces",
    "listings.list_view": "Vue liste",
    "listings.grid_view": "Vue grille",
    "listings.map_view": "Vue carte",
    "listings.board_view": "Vue tableau",
    "listings.export_all_title": "Exporter toutes les annonces ?",
    "Export all listings?": "Exporter toutes les annonces ?",
    "listings.export_all_message": "Un fichier contenant toutes les annonces sera préparé. Voulez-vous continuer ?",
    "This will prepare a file containing all listings. Do you want to continue?": "Un fichier contenant toutes les annonces sera préparé. Voulez-vous continuer ?",
    "listings.export_all": "Exporter toutes les annonces",
    "Export all listings": "Exporter toutes les annonces",
    "listings.cancel": "Annuler",
    "listings.status_all": "Tous",
    "listings.status_pending": "En attente",
    "listings.status_approved": "Approuvé",
    "listings.status_rejected": "Refusé",
    "listings.status_archived": "Archivé",
    "Archived": "Archivé",
    "listings.sort_newest_first": "Plus récent",
    "Newest first": "Plus récent",
    "listings.sort_price_high_to_low": "Prix : décroissant",
    "Price: high to low": "Prix : décroissant",
    "listings.sort_price_low_to_high": "Prix : croissant",
    "Price: low to high": "Prix : croissant",
    "listings.header_0": "Titre",
    "listings.header_1": "Site web",
    "Website": "Site web",
    "listings.header_2": "Prix catalogue",
    "listings.header_3": "Pourcentage de réduction",
    "listings.header_4": "Image",
    "listings.header_5": "Prix remisé",
    "Offer price": "Prix remisé",
    "listings.header_6": "Statut",
    "listings.header_7": "ID de l’annonce",
    "listings.header_8": "Statut de l’annonce",
    "Listing status": "Statut de l’annonce",
    "listings.header_9": "Comptes",
    "listings.header_10": "Devise",
    "listings.header_11": "Vendu",
    "Sold": "Vendu",
    "listings.header_12": "Montant de l’objectif",
    "Goal amount": "Montant de l’objectif",
    "listings.filter_status": "Statut",
    "listings.filter_price": "Prix",
    "listings.filter_category": "Catégorie",
    "listings.filter_clear_all": "Effacer tous les filtres",
    "listings.status_count": "Statut ({count})",
    "Status ({count})": "Statut ({count})",
    "listings.price_count": "Prix ({count})",
    "Price ({count})": "Prix ({count})",
    "listings.category_count": "Catégorie ({count})",
    "Category ({count})": "Catégorie ({count})",
    "listings.search": "Rechercher des annonces",
    "listings.clear_search": "Effacer la recherche d’annonces",
    "Clear listing search": "Effacer la recherche d’annonces",
    "listings.active": "Actif",
    "listings.inactive": "Inactif",
    "listings.approve": "Approuver",
    "listings.reject": "Refuser",
    "listings.delete_confirm": "Voulez-vous vraiment supprimer cette annonce ?",
    "Are you sure you want to delete this listing?": "Voulez-vous vraiment supprimer cette annonce ?",
    "listings.approve_confirm": "Voulez-vous approuver cette annonce ?",
    "Do you want to approve this listing?": "Voulez-vous approuver cette annonce ?",
    "listings.reject_confirm": "Voulez-vous refuser cette annonce ?",
    "Do you want to reject this listing?": "Voulez-vous refuser cette annonce ?",
    "listings.yes": "Oui",
    "listings.no": "Non",
    "listings.confirm_delete": "Voulez-vous vraiment supprimer cette annonce ?",
    "listings.confirm_approve": "Voulez-vous approuver cette annonce ?",
    "listings.confirm_reject": "Voulez-vous refuser cette annonce ?",
    "listings.column.actions": "Actions",
    "listings.audio_episode": "Épisode audio",
    "Audio episode": "Épisode audio",
    "listings.video": "Vidéo",
    "listings.seller": "Vendeur",
    "listings.rating": "Évaluation",
    "listings.followers": "Abonnés",
    "listings.view_seller_account": "Voir le compte vendeur",
    "View seller account": "Voir le compte vendeur",
    "listings.add_variant": "Ajouter une variante",
    "Add variant": "Ajouter une variante",
    "listings.edit": "Modifier",
    "listings.preview": "Aperçu",
    "listings.share": "Partager",
    "listings.view_listing": "Voir l’annonce",
    "View listing": "Voir l’annonce",
    "listings.stock": "Stock",
    "Stock": "Stock",
    "listings.variants": "Variantes",
    "listings.campaign": "Campagne",
    "Campaign": "Campagne",
    "listings.rental_details": "Détails de location",
    "Rental details": "Détails de location",
    "listings.copy": "Copier",
    "listings.inventory": "Inventaire",
    "listings.order_type": "Type de commande",
    "Order type": "Type de commande",
    "listings.stock_by_location": "Stock par emplacement",
    "Stock by location": "Stock par emplacement",
    "listings.loading_location_stock": "Chargement du stock par emplacement…",
    "Loading location stock…": "Chargement du stock par emplacement…",
    "listings.no_location_stock": "Aucun stock affecté à un emplacement.",
    "No stock assigned to a location.": "Aucun stock affecté à un emplacement.",
    "listings.page_analytics": "Statistiques de la page",
    "Page analytics": "Statistiques de la page",
    "listings.loading": "Chargement…",
    "listings.analytics_key_missing": "La clé API Analytics n’est pas configurée pour ce tenant.",
    "Analytics API key is not configured for this tenant.": "La clé API Analytics n’est pas configurée pour ce tenant.",
    "listings.no_slug": "Aucun slug n’est disponible pour cette annonce.",
    "No slug is available for this listing.": "Aucun slug n’est disponible pour cette annonce.",
    "listings.no_analytics": "Aucune statistique chargée pour le moment.",
    "listings.load_analytics": "Charger les statistiques",
    "Load analytics": "Charger les statistiques",
    "listings.no_orders": "Aucune commande pour cette annonce",
    "No orders yet for this listing": "Aucune commande pour cette annonce",
    "listings.social_ratings": "Réseaux sociaux et évaluations",
    "Social and ratings": "Réseaux sociaux et évaluations",
    "listings.tags": "Étiquettes",
    "listings.schedule": "Calendrier",
    "listings.detail": "Détail",
    "Detail": "Détail",
    "listings.update_stock": "Mettre à jour le stock",
    "Update stock": "Mettre à jour le stock",
    "listings.new_stock_quantity": "Nouvelle quantité en stock",
    "New stock quantity": "Nouvelle quantité en stock",
    "listings.location": "Emplacement",
    "listings.quantity": "Quantité",
    "listings.current_stock": "Stock actuel : {quantity}",
    "Current stock: {quantity}": "Stock actuel : {quantity}",
    "listings.loading_rental": "Chargement des paramètres de location…",
    "Loading rental settings…": "Chargement des paramètres de location…",
    "payments.enter_publishable_key": "Saisir la clé publiable",
    "Enter publishable key": "Saisir la clé publiable",
    "listings.add_listing": "Ajouter une annonce",
    "Add listing": "Ajouter une annonce",
    "listings.edit_listing": "Modifier l’annonce",
    "Edit listing": "Modifier l’annonce",
    "listings.enter_title": "Saisir le titre",
    "listings.account": "Compte",
    "listings.list_price": "Prix catalogue",
    "listings.enter_list_price": "Saisir le prix catalogue",
    "listings.select_currency": "Sélectionner une devise",
    "Select currency": "Sélectionner une devise",
    "listings.select_category": "Sélectionner une catégorie",
    "listings.select_categories": "Sélectionner des catégories",
    "Select categories": "Sélectionner des catégories",
    "listings.add_category": "+ Ajouter une catégorie",
    "+ Add category": "+ Ajouter une catégorie",
    "listings.add_attribute": "Ajouter un attribut",
    "Add attribute": "Ajouter un attribut",
    "listings.enter_stock": "Saisir le stock",
    "listings.offer_percentage": "Pourcentage de réduction",
    "Offer percentage": "Pourcentage de réduction",
    "listings.enter_offer": "Saisir la réduction",
    "Enter offer": "Saisir la réduction",
    "listings.max_quantity_optional": "Quantité max. (facultatif)",
    "Max quantity (optional)": "Quantité max. (facultatif)",
    "listings.enter_max_quantity": "Saisir la quantité maximale",
    "Enter max quantity": "Saisir la quantité maximale",
    "listings.enter_slug": "Saisir le slug",
    "listings.enter_meta_title": "Saisir le titre méta",
    "listings.repeat": "Répéter",
    "Repeat": "Répéter",
    "listings.start_time": "Heure de début",
    "Start time": "Heure de début",
    "listings.end_time": "Heure de fin",
    "End time": "Heure de fin",
    "listings.slot": "Créneau",
    "Slot": "Créneau",
    "listings.starts_from": "Commence le :",
    "Starts from:": "Commence le :",
    "listings.add_schedule": "+ Ajouter un horaire",
    "+ Add schedule": "+ Ajouter un horaire",
    "listings.upload_here": "Téléverser ici",
    "listings.save": "Enregistrer",
    "listings.update": "Mettre à jour",
    "listings.tax": "Taxe",
    "listings.title_required": "Veuillez saisir un titre",
    "Please enter a title": "Veuillez saisir un titre",
    "listings.select_tax": "Veuillez sélectionner une taxe",
    "Please select a tax": "Veuillez sélectionner une taxe",
    "listings.select_item": "Veuillez sélectionner {item}",
    "Please select {item}": "Veuillez sélectionner {item}",
    "listings.offer_percentage_validation": "Le pourcentage de réduction doit être compris entre 0 et 100",
    "Offer percentage must be between 0 and 100": "Le pourcentage de réduction doit être compris entre 0 et 100",
    "listings.custom_seo": "Référencement personnalisé",
    "Custom SEO": "Référencement personnalisé",
    "listings.select_value": "Sélectionner une valeur",
    "Select value": "Sélectionner une valeur",
    "listings.add_schedule_title": "Ajouter un horaire",
    "Add schedule": "Ajouter un horaire",
    "listings.select_from_media": "Sélectionner dans les médias",
    "listing_form.create_listing": "Créer une annonce",
    "Create listing": "Créer une annonce",
    "listing_form.update_listing": "Mettre à jour l’annonce",
    "Update listing": "Mettre à jour l’annonce",
    "listing_form.saving": "Enregistrement…",
    "listing_form.main_information": "Informations principales",
    "Main information": "Informations principales",
    "listing_form.audio_listing": "Annonce audio",
    "Audio listing": "Annonce audio",
    "listing_form.basic_information": "Informations de base",
    "Basic information": "Informations de base",
    "listing_form.listing_type": "Type d’annonce",
    "Listing type": "Type d’annonce",
    "listing_form.title": "Titre",
    "listing_form.enter_listing_title": "Saisir le titre de l’annonce",
    "Enter listing title": "Saisir le titre de l’annonce",
    "listing_form.description": "Description",
    "listing_form.enter_detailed_description": "Saisir une description détaillée",
    "Enter detailed description": "Saisir une description détaillée",
    "listing_form.tags": "Étiquettes",
    "listing_form.tag_example": "ex. : électronique, gadgets, neuf",
    "e.g., electronics, gadgets, new": "ex. : électronique, gadgets, neuf",
    "listing_form.taxes": "Taxes",
    "listing_form.optional": "Facultatif",
    "listing_form.start_date": "Date de début",
    "listing_form.end_date": "Date de fin",
    "listing_form.currency": "Devise",
    "listing_form.select_currency": "Sélectionner une devise",
    "listing_form.goal_price": "Prix objectif",
    "Goal price": "Prix objectif",
    "listing_form.set_fundraising_goal": "Définissez votre objectif de collecte",
    "Set your fundraising goal": "Définissez votre objectif de collecte",
    "listing_form.pricing": "Tarification",
    "Pricing": "Tarification",
    "listing_form.select": "Sélectionner",
    "listing_form.price": "Prix",
    "listing_form.offer_percent": "Réduction %",
    "Offer %": "Réduction %",
    "listing_form.listing_price": "Prix de l’annonce :",
    "Listing price:": "Prix de l’annonce :",
    "listing_form.set_fundraising_goal_amount": "Définissez le montant de votre objectif de collecte",
    "Set your fundraising goal amount": "Définissez le montant de votre objectif de collecte",
    "listing_form.category": "Catégorie",
    "listing_form.select_a_category": "Sélectionner une catégorie",
    "listing_form.clear_selected_category": "Effacer la catégorie sélectionnée",
    "Clear selected category": "Effacer la catégorie sélectionnée",
    "listing_form.create_new_category": "Créer une catégorie",
    "Create a new category": "Créer une catégorie",
    "listing_form.search_categories": "Rechercher des catégories…",
    "Search categories…": "Rechercher des catégories…",
    "listing_form.no_categories_match": "Aucune catégorie trouvée",
    "No categories found": "Aucune catégorie trouvée",
    "listing_form.draft_found": "Un brouillon enregistré a été trouvé.",
    "A saved draft was found.": "Un brouillon enregistré a été trouvé.",
    "listing_form.restore": "Restaurer",
    "Restore": "Restaurer",
    "listing_form.discard": "Supprimer",
    "listing_form.characters": "caractères",
    "characters": "caractères",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Produits physiques",
    "Physical products": "Produits physiques",
    "listing_form.type_events": "Événements",
    "Events": "Événements",
    "listing_form.type_digital": "Produits numériques",
    "Digital products": "Produits numériques",
    "listing_form.type_appointments": "Rendez-vous",
    "Appointments": "Rendez-vous",
    "listing_form.type_rentals": "Locations",
    "listing_form.type_donation": "Financement participatif",
    "Crowdfunding": "Financement participatif",
    "listing_form.type_information_listing": "Informations",
    "listing_form.type_video_listing": "Vidéo",
    "listing_form.type_audio_listing": "Audio",
    "listing_form.select_taxes": "Sélectionner des taxes (facultatif)",
    "Select taxes (optional)": "Sélectionner des taxes (facultatif)",
    "listing_form.no_taxes": "Aucune taxe disponible",
    "No taxes available": "Aucune taxe disponible",
    "listing_form.inventory_shipping": "Inventaire et expédition",
    "Inventory & shipping": "Inventaire et expédition",
    "listing_form.stock": "Stock",
    "listing_form.weight": "Poids",
    "Weight": "Poids",
    "listing_form.dimensions": "Dimensions (L×l×H)",
    "Dimensions (L×W×H)": "Dimensions (L×l×H)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Code-barres",
    "Barcode": "Code-barres",
    "listing_form.length": "Longueur",
    "Length": "Longueur",
    "listing_form.width": "Largeur",
    "Width": "Largeur",
    "listing_form.height": "Hauteur",
    "Height": "Hauteur",
    "listing_form.seo_settings": "Paramètres SEO",
    "SEO settings": "Paramètres SEO",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "Version du titre adaptée à l’URL",
    "URL-friendly version of the title": "Version du titre adaptée à l’URL",
    "listing_form.meta_title": "Titre méta",
    "listing_form.recommended_meta_title": "Recommandé : 50 à 60 caractères",
    "Recommended: 50–60 chars": "Recommandé : 50 à 60 caractères",
    "listing_form.meta_keywords": "Mots-clés méta",
    "Meta keywords": "Mots-clés méta",
    "listing_form.separate_with_commas": "Séparez par des virgules",
    "Separate with commas": "Séparez par des virgules",
    "listing_form.meta_description": "Description méta",
    "listing_form.recommended_meta_description": "Recommandé : 150 à 160 caractères",
    "Recommended: 150–160 chars": "Recommandé : 150 à 160 caractères",
    "listing_form.hide": "Masquer",
    "listing_form.show": "Afficher",
    "listing_form.seo_fields": "les champs de référencement",
    "search engine optimization fields": "les champs de référencement",
    "listing_form.auto_generated_slug": "Généré automatiquement à partir du titre",
    "Auto-generated from title": "Généré automatiquement à partir du titre",
    "listing_form.seo_title_optional": "Titre SEO (facultatif)",
    "SEO title (optional)": "Titre SEO (facultatif)",
    "listing_form.keywords_comma_separated": "Mots-clés séparés par des virgules",
    "Keywords separated by commas": "Mots-clés séparés par des virgules",
    "listing_form.search_description_optional": "Brève description pour les résultats de recherche (facultatif)",
    "Brief description for search results (optional)": "Brève description pour les résultats de recherche (facultatif)",
    "listing_form.account": "Compte",
    "listing_form.loading_accounts": "Chargement des comptes…",
    "Loading accounts…": "Chargement des comptes…",
    "listing_form.clear_selected_account": "Effacer le compte sélectionné",
    "Clear selected account": "Effacer le compte sélectionné",
    "listing_form.search_accounts": "Rechercher des comptes…",
    "Search accounts…": "Rechercher des comptes…",
    "listing_form.create_account": "Créer un compte",
    "Create a new account": "Créer un compte",
    "listing_form.no_accounts_found": "Aucun compte trouvé",
    "No accounts found": "Aucun compte trouvé",
    "listing_form.rental_settings": "Paramètres de location",
    "Rental settings": "Paramètres de location",
    "listing_form.rental_price_help": "Le prix de l’annonce est calculé à partir du tarif et de la durée de location.",
    "The listing price is calculated from the rental rate and duration.": "Le prix de l’annonce est calculé à partir du tarif et de la durée de location.",
    "listing_form.rate_unit": "Unité tarifaire",
    "Rate unit": "Unité tarifaire",
    "listing_form.hour": "Heure",
    "Hour": "Heure",
    "listing_form.day": "Jour",
    "listing_form.week": "Semaine",
    "listing_form.rental_rate_amount": "Tarif de location",
    "Rental rate": "Tarif de location",
    "listing_form.rental_min_duration": "Durée minimale",
    "Minimum duration": "Durée minimale",
    "listing_form.rental_max_duration": "Durée maximale",
    "Maximum duration": "Durée maximale",
    "listing_form.rental_buffer_time": "Temps tampon (heures)",
    "Buffer time (hours)": "Temps tampon (heures)",
    "listing_form.rental_deposit_amount": "Montant du dépôt",
    "Deposit amount": "Montant du dépôt",
    "listing_form.rental_max_units": "Nombre maximal d’unités",
    "Maximum units": "Nombre maximal d’unités",
    "listing_form.quick_create_title": "Créer {entity}",
    "Create {entity}": "Créer {entity}",
    "listing_form.close": "Fermer",
    "listing_form.account_name": "Nom du compte",
    "listing_form.category_name": "Nom de la catégorie",
    "Category name": "Nom de la catégorie",
    "listing_form.account_example": "ex. : Boutique Acme",
    "e.g. Acme Store": "ex. : Boutique Acme",
    "listing_form.category_example": "ex. : Produits frais",
    "e.g. Fresh Produce": "ex. : Produits frais",
    "listing_form.creating": "Création…",
    "listing_form.create_entity": "Créer {entity}",
    "listing_form.cancel": "Annuler",
    "listing_form.go_back": "Retour",
    "Go back": "Retour",
    "listing_form.upgrade_plan": "Mettre à niveau le forfait",
    "Upgrade plan": "Mettre à niveau le forfait",
    "listing_form.close_upgrade_dialog": "Fermer la fenêtre de mise à niveau",
    "Close upgrade dialog": "Fermer la fenêtre de mise à niveau",
    "listing_form.loading_attributes": "Chargement des attributs…",
    "Loading attributes…": "Chargement des attributs…",
    "listing_form.no_attributes": "Aucun attribut pour cette catégorie",
    "No attributes for this category": "Aucun attribut pour cette catégorie",
    "listing_form.unsupported_field_type": "Type de champ non pris en charge",
    "Unsupported field type": "Type de champ non pris en charge",
    "listing_form.delete_schedule_confirm": "Voulez-vous vraiment supprimer cet horaire ?",
    "Are you sure you want to delete this schedule?": "Voulez-vous vraiment supprimer cet horaire ?",
    "listing_form.no_schedules_added": "Aucun horaire ajouté pour le moment",
    "No schedules added yet": "Aucun horaire ajouté pour le moment",
    "listing_form.stock_label": "Stock :",
    "Stock:": "Stock :",
    "listing_form.active": "Actif",
    "listing_form.inactive": "Inactif",
    "listing_form.edit": "Modifier",
    "listing_form.delete": "Supprimer",
    "listing_form.schedules": "Horaires",
    "Schedules": "Horaires",
    "listing_form.no_schedules_yet": "Aucun horaire pour le moment",
    "No schedules yet": "Aucun horaire pour le moment",
    "listing_form.dates_label": "Dates :",
    "Dates:": "Dates :",
    "listing_form.time_label": "Heure :",
    "Time:": "Heure :",
    "listing_form.repeat_label": "Répétition :",
    "Repeat:": "Répétition :",
    "listing_form.capacity_label": "Capacité :",
    "Capacity:": "Capacité :",
    "listing_form.edit_schedule": "Modifier l’horaire",
    "Edit schedule": "Modifier l’horaire",
    "listing_form.add_new_schedule": "Ajouter un horaire",
    "Add new schedule": "Ajouter un horaire",
    "listing_form.repeat_pattern": "Récurrence",
    "Repeat pattern": "Récurrence",
    "listing_form.select_days": "Sélectionner les jours",
    "Select days": "Sélectionner les jours",
    "listing_form.total_stocks_capacity": "Stock total (capacité)",
    "Total stock (capacity)": "Stock total (capacité)",
    "listing_form.select_at_least_one_day": "Veuillez sélectionner au moins un jour",
    "Please select at least one day": "Veuillez sélectionner au moins un jour",
    "listing_form.unlimited_capacity_help": "Laissez vide pour une capacité illimitée",
    "Leave empty for unlimited capacity": "Laissez vide pour une capacité illimitée",
    "listing_form.add_schedule": "+ Ajouter un horaire",
    "listing_form.schedule_number": "Horaire n° {number}",
    "Schedule #{number}": "Horaire n° {number}",
    "listing_form.update_action": "mettre à jour",
    "update": "mettre à jour",
    "listing_form.create_action": "créer",
    "create": "créer",
    "listing_form.a_schedule": "un horaire",
    "a schedule": "un horaire",
    "listing_form.daily": "Tous les jours",
    "listing_form.weekdays": "Jours de semaine (lun. à ven.)",
    "Weekdays (Mon - Fri)": "Jours de semaine (lun. à ven.)",
    "listing_form.weekend": "Week-end (sam. et dim.)",
    "Weekend (Sat - Sun)": "Week-end (sam. et dim.)",
    "listing_form.custom": "Personnalisé",
    "listing_form.weekday_0": "Lundi",
    "Monday": "Lundi",
    "listing_form.weekday_1": "Mardi",
    "Tuesday": "Mardi",
    "listing_form.weekday_2": "Mercredi",
    "Wednesday": "Mercredi",
    "listing_form.weekday_3": "Jeudi",
    "Thursday": "Jeudi",
    "listing_form.weekday_4": "Vendredi",
    "Friday": "Vendredi",
    "listing_form.weekday_5": "Samedi",
    "Saturday": "Samedi",
    "listing_form.weekday_6": "Dimanche",
    "Sunday": "Dimanche",
    "listing_form.media_max_files": "Maximum {count} {type} autorisés",
    "Maximum {count} {type} allowed": "Maximum {count} {type} autorisés",
    "listing_form.video_size_limit": "Chaque vidéo doit faire 1 Go ou moins",
    "Each video must be 1GB or smaller": "Chaque vidéo doit faire 1 Go ou moins",
    "listing_form.videos": "Vidéos",
    "Videos": "Vidéos",
    "listing_form.images": "Images",
    "listing_form.select_from_media": "Sélectionner dans les médias",
    "listing_form.video_upload_help": "Importez des vidéos au format MP4, MOV, AVI, MKV ou WebM (1 Go max. chacune)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Importez des vidéos au format MP4, MOV, AVI, MKV ou WebM (1 Go max. chacune)",
    "listing_form.image_upload_help": "Importez des images au format JPG, PNG, GIF ou WebP (10 Mo max. chacune)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Importez des images au format JPG, PNG, GIF ou WebP (10 Mo max. chacune)",
    "listing_form.uploading_video": "Importation de la vidéo…",
    "Uploading video…": "Importation de la vidéo…",
    "listing_form.audio_episode": "Épisode audio",
    "listing_form.audio_upload_help": "Importez un fichier audio ou collez une URL audio publique pour le flux RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Importez un fichier audio ou collez une URL audio publique pour le flux RSS.",
    "listing_form.selected_file": "Sélectionné : {name}",
    "listing_form.audio_url_help": "L’URL est facultative si un fichier est sélectionné. Laissez ce champ vide pour utiliser le fichier importé.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "L’URL est facultative si un fichier est sélectionné. Laissez ce champ vide pour utiliser le fichier importé.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Importation de l’audio…",
    "Uploading audio…": "Importation de l’audio…",
    "listing_form.validation_start_date": "Veuillez sélectionner la date de début",
    "Please select start date": "Veuillez sélectionner la date de début",
    "listing_form.validation_end_date": "Veuillez sélectionner la date de fin",
    "Please select end date": "Veuillez sélectionner la date de fin",
    "listing_form.validation_start_time": "Veuillez sélectionner l’heure de début",
    "Please select start time": "Veuillez sélectionner l’heure de début",
    "listing_form.validation_end_time": "Veuillez sélectionner l’heure de fin",
    "Please select end time": "Veuillez sélectionner l’heure de fin",
    "listing_form.weekdays_short": "Jours de semaine",
    "Weekdays": "Jours de semaine",
    "listing_form.weekend_short": "Week-end",
    "Weekend": "Week-end",
    "listing_form.click_add_schedule_help": "Cliquez sur « {action} » pour créer votre premier horaire",
    "Click \"{action}\" to create your first schedule": "Cliquez sur « {action} » pour créer votre premier horaire",
    "listing_form.schedule_form_intro": "Renseignez les informations ci-dessous pour",
    "Fill in the details below to": "Renseignez les informations ci-dessous pour",
    "listing_form.update": "Mettre à jour",
    "listing_form.save": "Enregistrer",
    "listing_form.variant_value_required": "Veuillez sélectionner au moins une valeur de variante (par ex. couleur, taille)",
    "Please select at least one variant value (e.g., Color, Size)": "Veuillez sélectionner au moins une valeur de variante (par ex. couleur, taille)",
    "listing_form.valid_price_required": "Veuillez saisir un prix valide",
    "Please enter a valid price": "Veuillez saisir un prix valide",
    "listing_form.delete_variant_confirm": "Voulez-vous vraiment supprimer cette variante ?",
    "Are you sure you want to delete this variant?": "Voulez-vous vraiment supprimer cette variante ?",
    "listing_form.product_variants": "Variantes du produit",
    "Product Variants": "Variantes du produit",
    "listing_form.add_variant": "+ Ajouter une variante",
    "+ Add Variant": "+ Ajouter une variante",
    "listing_form.select_all_variants": "Sélectionner toutes les variantes",
    "Select all variants": "Sélectionner toutes les variantes",
    "listing_form.set_quantity_selected": "Définir la quantité des éléments sélectionnés",
    "Set quantity for selected": "Définir la quantité des éléments sélectionnés",
    "listing_form.quantity": "Quantité",
    "listing_form.apply_quantity": "Appliquer la quantité",
    "Apply quantity": "Appliquer la quantité",
    "listing_form.select_variant_number": "Sélectionner la variante {number}",
    "Select variant {number}": "Sélectionner la variante {number}",
    "listing_form.variant_number": "Variante nº {number}",
    "Variant #{number}": "Variante nº {number}",
    "listing_form.existing": "Existant",
    "Existing": "Existant",
    "listing_form.modified": "Modifié",
    "Modified": "Modifié",
    "listing_form.variant_name": "Nom de la variante",
    "Variant Name": "Nom de la variante",
    "listing_form.variant_values": "Valeurs de variante",
    "Variant Values": "Valeurs de variante",
    "listing_form.type": "Type",
    "listing_form.no_variant_values": "Aucune valeur de variante",
    "No variant values": "Aucune valeur de variante",
    "listing_form.no_variants_yet": "Aucune variante pour le moment",
    "No variants yet": "Aucune variante pour le moment",
    "listing_form.click_add_variant_help": "Cliquez sur « {action} » pour créer votre première variante",
    "Click \"{action}\" to create your first variant": "Cliquez sur « {action} » pour créer votre première variante",
    "listing_form.select_variant_type": "Sélectionner {type}",
    "Select {type}": "Sélectionner {type}",
    "listing_form.no_variant_types": "Aucun type de variante disponible. Créez d’abord des types de variante (comme couleur ou taille).",
    "No variant types available. Please create variant types (like Color, Size) first.": "Aucun type de variante disponible. Créez d’abord des types de variante (comme couleur ou taille).",
    "listing_form.generated_name": "Nom généré :",
    "Generated Name:": "Nom généré :",
    "listing_form.custom_title": "Titre personnalisé",
    "Custom Title": "Titre personnalisé",
    "listing_form.auto_generate_help": "Laissez vide pour générer automatiquement",
    "Leave blank to auto-generate": "Laissez vide pour générer automatiquement",
    "listing_form.save_variant": "Enregistrer la variante",
    "Save Variant": "Enregistrer la variante",
    "listing_form.start_time": "Heure de début",
    "Start Time": "Heure de début",
    "listing_form.end_time": "Heure de fin",
    "End Time": "Heure de fin",
    "listing_form.enter_capacity_limit": "Saisissez la capacité maximale",
    "Enter capacity limit": "Saisissez la capacité maximale",
    "collections.validation_title": "Le titre ne peut pas être vide",
    "Title should not be empty": "Le titre ne peut pas être vide",
    "collections.validation_platform": "Sélectionnez au moins une plateforme",
    "Select at least one platform": "Sélectionnez au moins une plateforme",
    "collections.validation_dates": "La date de fin doit être postérieure à la date de début",
    "End Date must be later than start date": "La date de fin doit être postérieure à la date de début",
    "collections.validation_minimum_selection": "Sélectionnez au moins {type}",
    "Select at least one {type}": "Sélectionnez au moins {type}",
    "collections.account": "compte",
    "account": "compte",
    "collections.listing": "annonce",
    "listing": "annonce",
    "collections.edit_title": "Modifier la collection",
    "Edit Collection": "Modifier la collection",
    "collections.create_title": "Créer une collection",
    "Create Collection": "Créer une collection",
    "collections.details": "Détails de la collection",
    "Collection details": "Détails de la collection",
    "collections.title_placeholder": "Saisissez le titre",
    "Enter title name": "Saisissez le titre",
    "collections.slug": "Identifiant URL",
    "collections.slug_placeholder": "Saisissez l’identifiant URL",
    "collections.enter_title_first": "Veuillez d’abord saisir un titre",
    "collections.scope": "Portée",
    "collections.accounts": "Comptes",
    "collections.listings": "Annonces",
    "collections.choose_category": "Choisir une catégorie",
    "collections.conditions": "Conditions",
    "Conditions": "Conditions",
    "collections.condition_type": "Type de condition",
    "Condition type": "Type de condition",
    "collections.manual": "Manuelle",
    "Manual": "Manuelle",
    "collections.automated": "Automatique",
    "Automated": "Automatique",
    "collections.availability": "Disponibilité de la collection",
    "Collections availability": "Disponibilité de la collection",
    "collections.schedule": "Planification",
    "collections.applicable_channels": "Sélectionner les canaux applicables",
    "Select applicable channel": "Sélectionner les canaux applicables",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Rechercher par nom",
    "Search by name": "Rechercher par nom",
    "collections.not_found": "Collection introuvable.",
    "Collection not found.": "Collection introuvable.",
    "collections.featured_listings": "Annonces à la une",
    "Featured listings": "Annonces à la une",
    "collections.url_copied": "URL publique copiée",
    "Public URL copied": "URL publique copiée",
    "collections.url_copy_failed": "Impossible de copier l’URL publique",
    "Unable to copy the public URL": "Impossible de copier l’URL publique",
    "collections.collection": "Collection",
    "Collection": "Collection",
    "collections.this_collection": "cette collection",
    "this collection": "cette collection",
    "collections.share_text": "Voir {title}",
    "View {title}": "Voir {title}",
    "collections.public_url": "URL publique :",
    "Public URL:": "URL publique :",
    "collections.copy_url": "Copier l’URL",
    "Copy URL": "Copier l’URL",
    "collections.items": "Éléments",
    "collections.expires": "Expire",
    "collections.never": "Jamais",
    "Never": "Jamais",
    "collections.automatic_conditions": "Conditions automatiques",
    "Automatic Conditions": "Conditions automatiques",
    "collections.item_count": "{count} éléments",
    "{count} items": "{count} éléments",
    "collections.loading_items": "Chargement des éléments…",
    "Loading items…": "Chargement des éléments…",
    "collections.no_items": "Cette collection ne contient encore aucun élément.",
    "No items in this collection yet.": "Cette collection ne contient encore aucun élément.",
    "collections.delete_confirm": "Voulez-vous supprimer cette collection ?",
    "Do you want to delete this collection?": "Voulez-vous supprimer cette collection ?",
    "collections.title": "Collections",
    "collections.header_title": "Titre",
    "collections.header_action": "Action",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Type de condition",
    "Condition Type": "Type de condition",
    "collections.header_scope": "Portée",
    "collections.header_start_date": "Date de début",
    "collections.header_end_date": "Date de fin",
    "collections.header_status": "Statut",
    "collections.header_url": "URL",
    "common.calendar_view": "Vue calendrier",
    "Calendar view": "Vue calendrier",
    "common.deleted": "Supprimé",
    "Deleted": "Supprimé",
    "common.list_view": "Vue liste",
    "common.description": "Description",
    "common.title": "Titre",
    "common.end_date": "Date de fin",
    "common.start_date": "Date de début",
    "promotions.image_required": "Veuillez ajouter une image",
    "Please add an image": "Veuillez ajouter une image",
    "promotions.edit_title": "Modifier la promotion",
    "Edit Promotion": "Modifier la promotion",
    "promotions.add_title": "Ajouter une promotion",
    "Add Promotion": "Ajouter une promotion",
    "promotions.name": "Nom de la promotion",
    "Promotion Name": "Nom de la promotion",
    "promotions.select_medium": "Sélectionner le support",
    "Select Medium": "Sélectionner le support",
    "promotions.upload_media": "Importer un média",
    "promotions.schedule": "Planification",
    "promotions.destination_type": "Type de destination",
    "Destination Type": "Type de destination",
    "promotions.placement": "Emplacement",
    "Placement": "Emplacement",
    "promotions.status": "Statut (inactif / actif)",
    "promotions.delete_confirm": "Voulez-vous supprimer cette promotion ?",
    "Do you want to delete this promotion?": "Voulez-vous supprimer cette promotion ?",
    "promotions.title": "Promotions",
    "promotions.header_image": "Image",
    "promotions.header_medium": "Support",
    "promotions.header_placement": "Emplacement",
    "promotions.header_type": "Type",
    "promotions.header_value": "Valeur",
    "promotions.header_active": "Actif",
    "promotions.header_action": "Action",
    "promotions.header_start_at": "Date de début",
    "Start At": "Date de début",
    "promotions.header_end_at": "Date de fin",
    "End At": "Date de fin",
    "common.grid_view": "Vue grille",
    "promotions.type_general": "Général",
    "promotions.type_listing": "Annonce",
    "promotions.type_account": "Compte",
    "promotions.type_external_link": "Lien externe",
    "External link": "Lien externe",
    "promotions.preview": "Aperçu",
    "promotions.select_listing": "Sélectionner une annonce",
    "Select Listing": "Sélectionner une annonce",
    "promotions.select_account": "Sélectionner un compte",
    "Select Account": "Sélectionner un compte",
    "promotions.home_placement": "Accueil",
    "promotions.footer_placement": "Pied de page",
    "Footer": "Pied de page",
    "promotions.web_only": "(Web uniquement)",
    "(Web Only)": "(Web uniquement)",
    "coupons.edit_title": "Modifier le coupon",
    "Edit Coupon": "Modifier le coupon",
    "coupons.add_title": "Ajouter un coupon",
    "Add Coupon": "Ajouter un coupon",
    "coupons.reference_name": "Nom de référence",
    "Reference Name": "Nom de référence",
    "coupons.enter_name": "Saisissez le nom",
    "coupons.coupon_type": "Type de coupon",
    "Coupon type": "Type de coupon",
    "coupons.discount_value": "Valeur de la remise",
    "Discount Value": "Valeur de la remise",
    "coupons.enter_discount_value": "Saisissez le montant de la remise",
    "Enter discount value": "Saisissez le montant de la remise",
    "coupons.code": "Code",
    "coupons.code_example": "Ex. : HOLIDAY10",
    "Ex: HOLIDAY10": "Ex. : HOLIDAY10",
    "coupons.short_code": "Code court",
    "coupons.enter_short_code": "Saisissez le code court",
    "coupons.advanced": "OPTIONS AVANCÉES",
    "ADVANCED": "OPTIONS AVANCÉES",
    "coupons.minimum_amount": "Montant minimum",
    "coupons.enter_minimum_amount": "Saisissez le montant minimum",
    "coupons.maximum_amount": "Montant maximum",
    "coupons.enter_maximum_amount": "Saisissez le montant maximum",
    "coupons.maximum_discount_amount": "Montant maximal de la remise",
    "Maximum Discount Amount": "Montant maximal de la remise",
    "coupons.enter_maximum_discount_amount": "Saisissez le montant maximal de la remise",
    "Enter maximum discount amount": "Saisissez le montant maximal de la remise",
    "coupons.maximum_uses": "Nombre maximal d’utilisations",
    "Maximum Uses": "Nombre maximal d’utilisations",
    "coupons.enter_maximum_uses": "Saisissez le nombre maximal d’utilisations",
    "Enter maximum uses": "Saisissez le nombre maximal d’utilisations",
    "coupons.maximum_uses_per_user": "Nombre maximal d’utilisations par utilisateur",
    "Maximum Uses Per User": "Nombre maximal d’utilisations par utilisateur",
    "coupons.enter_maximum_uses_per_user": "Saisissez le nombre maximal d’utilisations par utilisateur",
    "Enter maximum uses per user": "Saisissez le nombre maximal d’utilisations par utilisateur",
    "coupons.new_user_only": "Nouvel utilisateur",
    "New User": "Nouvel utilisateur",
    "coupons.enter_note": "Saisissez une note",
    "coupons.start_date_time": "Date et heure de début",
    "Start Date Time": "Date et heure de début",
    "coupons.end_date_time": "Date et heure de fin",
    "End Date Time": "Date et heure de fin",
    "coupons.select_start_date_time": "Sélectionnez la date et l’heure de début",
    "Select start date time": "Sélectionnez la date et l’heure de début",
    "coupons.select_end_date_time": "Sélectionnez la date et l’heure de fin",
    "Select end date time": "Sélectionnez la date et l’heure de fin",
    "coupons.flat_example": "Montant fixe (ex. : 10 $)",
    "Flat (Ex: $10)": "Montant fixe (ex. : 10 $)",
    "coupons.percentage_example": "Pourcentage (ex. : 10 %)",
    "Percentage (Ex: 10%)": "Pourcentage (ex. : 10 %)",
    "coupons.delete_confirm": "Voulez-vous supprimer ce coupon ?",
    "Do you want to delete this coupon?": "Voulez-vous supprimer ce coupon ?",
    "coupons.title": "Coupons",
    "coupons.header_name": "Nom",
    "coupons.header_code": "Code",
    "coupons.header_coupon_type": "Type de coupon",
    "Coupon Type": "Type de coupon",
    "coupons.header_start_date_time": "Date et heure de début",
    "coupons.header_end_date_time": "Date et heure de fin",
    "coupons.header_active": "Actif",
    "coupons.header_action": "Action",
    "coupons.load_error": "Impossible de charger ce coupon.",
    "Unable to load this coupon.": "Impossible de charger ce coupon.",
    "coupons.expired": "Expiré",
    "Expired": "Expiré",
    "coupons.total_orders": "Commandes totales",
    "coupons.unique_customers": "Clients uniques",
    "Unique Customers": "Clients uniques",
    "coupons.revenue": "Chiffre d’affaires",
    "coupons.average_transaction": "Transaction moyenne",
    "Avg Transaction": "Transaction moyenne",
    "coupons.paid_orders": "Commandes payées",
    "coupons.uses_remaining": "Utilisations restantes",
    "Uses Remaining": "Utilisations restantes",
    "coupons.unlimited": "Illimité",
    "Unlimited": "Illimité",
    "coupons.performance": "Performances",
    "Performance": "Performances",
    "coupons.usage_against_limit": "Utilisation par rapport à la limite",
    "Usage against limit": "Utilisation par rapport à la limite",
    "coupons.details": "Détails",
    "coupons.discount": "Remise",
    "coupons.minimum_order": "Commande minimale",
    "Min order": "Commande minimale",
    "coupons.maximum_discount": "Remise maximale",
    "Max discount": "Remise maximale",
    "coupons.maximum_total_uses": "Nombre total maximal d’utilisations",
    "Max total uses": "Nombre total maximal d’utilisations",
    "coupons.maximum_per_user": "Maximum par utilisateur",
    "Max / user": "Maximum par utilisateur",
    "coupons.new_users_only": "Nouveaux utilisateurs uniquement",
    "New users only": "Nouveaux utilisateurs uniquement",
    "coupons.valid_from": "Valide à partir du",
    "Valid from": "Valide à partir du",
    "coupons.valid_until": "Valide jusqu’au",
    "Valid until": "Valide jusqu’au",
    "coupons.orders": "Commandes",
    "coupons.no_orders": "Aucune commande n’a encore utilisé ce coupon",
    "No orders have used this coupon yet": "Aucune commande n’a encore utilisé ce coupon",
    "coupons.orders_header_order": "Commande",
    "coupons.orders_header_customer": "Client",
    "coupons.orders_header_date": "Date",
    "coupons.orders_header_amount": "Montant",
    "coupons.orders_header_status": "Statut",
    "coupons.paid": "Payé",
    "coupons.pending": "En attente",
    "coupons.coupon": "Coupon",
    "coupons.detail_title": "Détail du coupon",
    "Coupon Detail": "Détail du coupon",
    "coupons.discount_percentage": "Remise de {value} %",
    "{value}% off": "Remise de {value} %",
    "coupons.discount_flat": "Remise fixe de {value}",
    "{value} flat off": "Remise fixe de {value}",
    "coupons.type_direct_discount": "Remise directe",
    "Direct discount": "Remise directe",
    "collections.condition_and": "ET",
    "AND": "ET",
    "collections.condition_or": "OU",
    "OR": "OU",
    "users.first_seen": "Première visite",
    "First seen": "Première visite",
    "users.last_seen": "Dernière visite",
    "Last seen": "Dernière visite",
    "users.avg_order": "Commande moyenne",
    "Avg order": "Commande moyenne",
    "users.purchase_value": "Valeur des achats",
    "Purchase value": "Valeur des achats",
    "users.price_range": "Fourchette de prix",
    "Price range": "Fourchette de prix",
    "users.attributes": "Attributs",
    "users.detail_title": "Détail de l’utilisateur",
    "User Detail": "Détail de l’utilisateur",
    "users.detail_orders_list": "Liste des commandes de l’utilisateur",
    "User Orders List": "Liste des commandes de l’utilisateur",
    "users.confirm_user_action": "{action} {name} ?",
    "{action} {name}?": "{action} {name} ?",
    "users.as_buyer": "En tant qu’acheteur",
    "As a Buyer": "En tant qu’acheteur",
    "users.as_seller": "En tant que vendeur",
    "As a Seller": "En tant que vendeur",
    "users.health": "État",
    "users.no_listings": "Aucune annonce pour le moment",
    "users.no_accounts": "Aucun compte pour le moment",
    "No accounts yet": "Aucun compte pour le moment",
    "users.top_categories": "Principales catégories",
    "Top categories": "Principales catégories",
    "users.top_listings": "Principales annonces",
    "Top listings": "Principales annonces",
    "users.recent_activity": "Activité récente",
    "Recent activity": "Activité récente",
    "users.acquisition": "Acquisition",
    "Acquisition": "Acquisition",
    "users.sent_emails": "E-mails envoyés",
    "Sent Emails": "E-mails envoyés",
    "users.no_emails_sent": "Aucun e-mail envoyé",
    "No emails sent": "Aucun e-mail envoyé",
    "users.load_more_emails": "Afficher plus ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Afficher plus ({loaded} / {total})",
    "users.email_to": "À : {email}",
    "To: {email}": "À : {email}",
    "users.sending_email": "Envoi…",
    "users.send_email": "Envoyer un e-mail",
    "Send Email": "Envoyer un e-mail",
    "users.send_email_title": "Envoyer un e-mail — {name}",
    "Send Email — {name}": "Envoyer un e-mail — {name}",
    "users.customer": "Client",
    "users.block_named": "Bloquer {name}",
    "Block {name}": "Bloquer {name}",
    "users.unblock_named": "Débloquer {name}",
    "Unblock {name}": "Débloquer {name}",
    "users.email_sent": "E-mail envoyé",
    "Email sent successfully": "E-mail envoyé",
    "users.email_send_failed": "Échec de l’envoi de l’e-mail",
    "Failed to send email": "Échec de l’envoi de l’e-mail",
    "common.value": "Valeur",
    "users.email_bounced": "Rebondi",
    "Bounced": "Rebondi",
    "users.email_complained": "Signalé comme indésirable",
    "Complained": "Signalé comme indésirable",
    "users.unverified": "Non vérifié",
    "Unverified": "Non vérifié",
    "users.otp_enabled": "OTP activé",
    "OTP Enabled": "OTP activé",
    "users.account_info": "Informations du compte",
    "Account Info": "Informations du compte",
    "users.mobile": "Téléphone mobile",
    "users.locale": "Langue",
    "Locale": "Langue",
    "users.joined": "Inscription",
    "users.following": "Abonnements",
    "Following": "Abonnements",
    "users.email_health": "État des e-mails",
    "Email Health": "État des e-mails",
    "users.orders": "Commandes",
    "users.no_orders": "Aucune commande",
    "No orders": "Aucune commande",
    "users.order_reference": "Commande {number}",
    "Order {number}": "Commande {number}",
    "users.order_ref": "Réf. : {reference}",
    "Ref: {reference}": "Réf. : {reference}",
    "users.unpaid": "Non payé",
    "users.revenue_ltv": "Chiffre d’affaires et valeur vie client",
    "Revenue & LTV": "Chiffre d’affaires et valeur vie client",
    "users.total_spent": "Total dépensé",
    "Total Spent": "Total dépensé",
    "users.paid_order_count": "{count} commandes payées",
    "{count} paid orders": "{count} commandes payées",
    "users.average_order": "Commande moyenne",
    "users.of_total_orders": "sur {count} au total",
    "of {count} total": "sur {count} au total",
    "users.gmv": "Volume brut de marchandises",
    "GMV": "Volume brut de marchandises",
    "users.active_count": "{count} actif(s)",
    "{count} active": "{count} actif(s)",
    "users.at_risk": "À risque",
    "At Risk": "À risque",
    "common.today": "Aujourd’hui",
    "common.yesterday": "Hier",
    "Yesterday": "Hier",
    "users.days_ago": "Il y a {count} jours",
    "{count} days ago": "Il y a {count} jours",
    "users.months_ago": "Il y a {count} mois",
    "{count} months ago": "Il y a {count} mois",
    "users.years_ago": "Il y a {count} ans",
    "{count} years ago": "Il y a {count} ans",
    "users.last_order": "Dernière commande",
    "Last order": "Dernière commande",
    "users.last_listing": "Dernière annonce",
    "Last listing": "Dernière annonce",
    "users.events": "Événements",
    "users.viewed": "Consultations",
    "Viewed": "Consultations",
    "users.cart": "Panier",
    "users.checkouts": "Paiements",
    "Checkouts": "Paiements",
    "users.purchases": "Achats",
    "Purchases": "Achats",
    "users.last_30_days": "30 derniers jours",
    "Last 30 days": "30 derniers jours",
    "users.no_analytics": "Aucune donnée analytique pour cet utilisateur.",
    "No analytics data for this user yet.": "Aucune donnée analytique pour cet utilisateur.",
    "users.analytics_unavailable": "Les analyses ne sont pas disponibles pour ce tenant.",
    "Analytics unavailable for this tenant.": "Les analyses ne sont pas disponibles pour ce tenant.",
    "users.account_number": "Compte nº {number}",
    "Account #{number}": "Compte nº {number}",
    "users.no_subject": "Sans objet",
    "No Subject": "Sans objet",
    "common.unknown": "Inconnu",
    "users.opened": "Ouvert",
    "Opened": "Ouvert",
    "users.not_opened": "Non ouvert",
    "Not opened": "Non ouvert",
    "users.user_action_success": "Action utilisateur effectuée",
    "User action completed": "Action utilisateur effectuée",
    "common.pending": "En attente",
    "common.never": "Jamais",
    "users.customer_analytics": "Analyses client",
    "Customer Analytics": "Analyses client",
    "users.analytics": "Analyses",
    "users.emails": "E-mails",
    "Emails": "E-mails",
    "users.first_visit": "Première visite",
    "First visit": "Première visite",
    "users.latest_visit": "Dernière visite",
    "Latest visit": "Dernière visite",
    "users.landing_page": "Page de destination",
    "Landing page": "Page de destination",
    "users.referrer": "Référent",
    "Referrer": "Référent",
    "users.utm_source": "Source UTM",
    "UTM source": "Source UTM",
    "users.utm_medium": "Support UTM",
    "UTM medium": "Support UTM",
    "users.utm_campaign": "Campagne UTM",
    "UTM campaign": "Campagne UTM",
    "users.utm_term": "Terme UTM",
    "UTM term": "Terme UTM",
    "users.utm_content": "Contenu UTM",
    "UTM content": "Contenu UTM",
    "users.ai_source": "Source IA",
    "AI source": "Source IA",
    "rewards.edit_scope": "Modifier le périmètre",
    "Edit scope": "Modifier le périmètre",
    "rewards.add_scope": "Ajouter un périmètre",
    "Add scope": "Ajouter un périmètre",
    "rewards.save_scope": "Enregistrer le périmètre",
    "Save scope": "Enregistrer le périmètre",
    "rewards.scope_type": "Type de périmètre",
    "Scope type": "Type de périmètre",
    "rewards.scope_reference": "Référence du périmètre",
    "Scope reference": "Référence du périmètre",
    "rewards.match_config": "Configuration de correspondance",
    "Match config": "Configuration de correspondance",
    "rewards.priority_order": "Ordre de priorité",
    "Priority order": "Ordre de priorité",
    "rewards.active": "Actif",
    "rewards.scope_active": "Le périmètre est actif",
    "Scope is active": "Le périmètre est actif",
    "rewards.edit_rule": "Modifier la règle",
    "Edit rule": "Modifier la règle",
    "rewards.add_rule": "Ajouter une règle",
    "Add rule": "Ajouter une règle",
    "rewards.save_rule": "Enregistrer la règle",
    "Save rule": "Enregistrer la règle",
    "rewards.trigger_event": "Événement déclencheur",
    "Trigger event": "Événement déclencheur",
    "rewards.beneficiary_type": "Type de bénéficiaire",
    "Beneficiary type": "Type de bénéficiaire",
    "rewards.beneficiary_config": "Configuration du bénéficiaire",
    "Beneficiary config": "Configuration du bénéficiaire",
    "rewards.eligibility": "Admissibilité",
    "Eligibility": "Admissibilité",
    "rewards.conditions": "Conditions",
    "rewards.priority": "Priorité",
    "Priority": "Priorité",
    "rewards.edit_component": "Modifier le composant de la recette",
    "Edit recipe component": "Modifier le composant de la recette",
    "rewards.add_component": "Ajouter un composant de recette",
    "Add recipe component": "Ajouter un composant de recette",
    "rewards.save_component": "Enregistrer le composant",
    "Save component": "Enregistrer le composant",
    "rewards.rule": "Règle",
    "Rule": "Règle",
    "rewards.component_key": "Clé du composant",
    "Component key": "Clé du composant",
    "rewards.component_type": "Type de composant",
    "Component type": "Type de composant",
    "rewards.commission_definition": "Définition de commission",
    "Commission definition": "Définition de commission",
    "rewards.config": "Configuration",
    "rewards.position": "Position",
    "Position": "Position",
    "rewards.component": "Composant",
    "Component": "Composant",
    "rewards.status.draft": "Brouillon",
    "rewards.status.active": "Actif",
    "rewards.status.paused": "En pause",
    "Paused": "En pause",
    "rewards.status.archived": "Archivé",
    "rewards.configuration_updated": "Configuration des récompenses mise à jour",
    "Reward configuration updated": "Configuration des récompenses mise à jour",
    "rewards.configuration_added": "Configuration des récompenses ajoutée",
    "Reward configuration added": "Configuration des récompenses ajoutée",
    "rewards.archive_item_confirm": "Archiver {name} ?",
    "Archive {name}?": "Archiver {name} ?",
    "rewards.empty_scopes": "Aucun périmètre configuré.",
    "No scopes configured yet.": "Aucun périmètre configuré.",
    "rewards.empty_rules": "Aucune règle configurée.",
    "No rules configured yet.": "Aucune règle configurée.",
    "rewards.empty_components": "Aucun composant configuré.",
    "No components configured yet.": "Aucun composant configuré.",
    "rewards.edit_program": "Modifier le programme de récompenses",
    "Edit reward program": "Modifier le programme de récompenses",
    "rewards.new_program": "Nouveau programme de récompenses",
    "New reward program": "Nouveau programme de récompenses",
    "rewards.create_program": "Créer le programme",
    "Create program": "Créer le programme",
    "rewards.program_type": "Type de programme",
    "Program type": "Type de programme",
    "rewards.starts_at": "Date de début",
    "Starts at": "Date de début",
    "rewards.ends_at": "Date de fin",
    "Ends at": "Date de fin",
    "rewards.program_updated": "Programme de récompenses mis à jour",
    "Reward program updated": "Programme de récompenses mis à jour",
    "rewards.program_created": "Programme de récompenses créé",
    "Reward program created": "Programme de récompenses créé",
    "rewards.archive_program_confirm": "Archiver {name} ?",
    "rewards.program_archived": "Programme de récompenses archivé",
    "Reward program archived": "Programme de récompenses archivé",
    "rewards.tab.overview": "Vue d’ensemble",
    "rewards.tab.programs": "Programmes",
    "Programs": "Programmes",
    "rewards.tab.impact": "Impact",
    "rewards.tab.attribution": "Suivi",
    "Tracking": "Suivi",
    "rewards.page_description": "Créez et gérez les programmes de récompenses, les critères d’admissibilité, les règles et les recettes. Les commandes terminées sont automatiquement ajoutées aux rapports.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Créez et gérez les programmes de récompenses, les critères d’admissibilité, les règles et les recettes. Les commandes terminées sont automatiquement ajoutées aux rapports.",
    "rewards.program": "Programme",
    "Program": "Programme",
    "rewards.starts": "Début",
    "Starts": "Début",
    "rewards.no_programs": "Aucun programme de récompenses pour le moment.",
    "No reward programs yet.": "Aucun programme de récompenses pour le moment.",
    "rewards.program_title": "Programme de récompenses",
    "Reward program": "Programme de récompenses",
    "rewards.back_to_rewards": "Retour aux récompenses",
    "Back to rewards": "Retour aux récompenses",
    "common.archive": "Archiver",
    "Archive": "Archiver",
    "common.save_changes": "Enregistrer les modifications",
    "common.none": "Aucun",
    "common.this_item": "cet élément",
    "this item": "cet élément",
    "rewards.tab.scopes": "Périmètres",
    "Scopes": "Périmètres",
    "rewards.tab.rules": "Règles",
    "Rules": "Règles",
    "rewards.tab.components": "Composants de recette",
    "Recipe components": "Composants de recette",
    "rewards.reference": "Référence",
    "rewards.trigger": "Déclencheur",
    "Trigger": "Déclencheur",
    "rewards.beneficiary": "Bénéficiaire",
    "Beneficiary": "Bénéficiaire",
    "rewards.attributed_conversions": "Conversions attribuées",
    "Attributed conversions": "Conversions attribuées",
    "rewards.new_customers": "Nouveaux clients",
    "New customers": "Nouveaux clients",
    "rewards.revenue_influenced": "Chiffre d’affaires généré",
    "Revenue influenced": "Chiffre d’affaires généré",
    "rewards.rewards_issued": "Récompenses émises",
    "Rewards issued": "Récompenses émises",
    "rewards.live_business_results": "Résultats commerciaux en direct",
    "Live business results": "Résultats commerciaux en direct",
    "rewards.impact_at_a_glance": "Aperçu des résultats",
    "Impact at a glance": "Aperçu des résultats",
    "rewards.impact_last_30_days": "Vue en direct des commandes terminées et des résultats partenaires des 30 derniers jours.",
    "A live view of completed orders and partner results from the last 30 days.": "Vue en direct des commandes terminées et des résultats partenaires des 30 derniers jours.",
    "rewards.view_full_impact": "Voir tous les résultats",
    "View full impact": "Voir tous les résultats",
    "rewards.impact_load_error": "Impossible de charger les données d’impact : {error}",
    "Impact data could not be loaded: {error}": "Impossible de charger les données d’impact : {error}",
    "rewards.programs": "Programmes",
    "rewards.programs_configured": "Programmes de récompenses configurés pour cet espace de travail.",
    "Reward programs configured for this workspace.": "Programmes de récompenses configurés pour cet espace de travail.",
    "rewards.programs_eligible": "Programmes actuellement admissibles à l’évaluation.",
    "Programs currently eligible for evaluation.": "Programmes actuellement admissibles à l’évaluation.",
    "rewards.drafts": "Brouillons",
    "Drafts": "Brouillons",
    "rewards.programs_being_configured": "Programmes en cours de configuration.",
    "Programs still being configured.": "Programmes en cours de configuration.",
    "rewards.clicks": "Clics",
    "rewards.completed_orders": "Commandes terminées",
    "Completed orders": "Commandes terminées",
    "rewards.conversion_rate": "Taux de conversion",
    "Conversion rate": "Taux de conversion",
    "rewards.revenue": "Chiffre d’affaires",
    "rewards.live_connection": "Connexion en direct",
    "Live connection": "Connexion en direct",
    "rewards.attribution_activity": "Activité d’attribution",
    "Attribution activity": "Activité d’attribution",
    "rewards.connected_workspace": "Connecté à {name}.",
    "Connected to {name}.": "Connecté à {name}.",
    "rewards.your_attribution_workspace": "votre espace Attribution",
    "your Attribution workspace": "votre espace Attribution",
    "rewards.loading_workspace": "Chargement de votre espace Attribution connecté.",
    "Loading your connected Attribution workspace.": "Chargement de votre espace Attribution connecté.",
    "rewards.open_attribution": "Ouvrir Attribution",
    "Open Attribution": "Ouvrir Attribution",
    "rewards.connection_attention": "La connexion nécessite votre attention",
    "Connection needs attention": "La connexion nécessite votre attention",
    "rewards.open_attribution_workspace": "Ouvrir l’espace Attribution",
    "Open Attribution workspace": "Ouvrir l’espace Attribution",
    "rewards.workspace_connected": "Espace connecté",
    "Workspace connected": "Espace connecté",
    "rewards.workspace_not_linked": "Espace pas encore associé",
    "Workspace not linked yet": "Espace pas encore associé",
    "rewards.attribution_data_connected": "Les clics, liens, campagnes et commandes terminées sont récupérés depuis Attribution.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Les clics, liens, campagnes et commandes terminées sont récupérés depuis Attribution.",
    "rewards.connect_workspace_prompt": "Ouvrez Attribution pour connecter cet espace avant de suivre son activité.",
    "Open Attribution to connect this workspace before tracking activity.": "Ouvrez Attribution pour connecter cet espace avant de suivre son activité.",
    "rewards.successful_referrals": "Parrainages réussis",
    "Successful referrals": "Parrainages réussis",
    "rewards.new_customers_acquired": "Nouveaux clients acquis",
    "New customers acquired": "Nouveaux clients acquis",
    "rewards.gross_revenue_influenced": "Chiffre d’affaires brut généré",
    "Gross revenue influenced": "Chiffre d’affaires brut généré",
    "rewards.reward_cost": "Coût des récompenses",
    "Reward cost": "Coût des récompenses",
    "rewards.net_revenue": "Chiffre d’affaires net",
    "Net revenue": "Chiffre d’affaires net",
    "rewards.average_order_value": "Valeur moyenne des commandes",
    "Average order value": "Valeur moyenne des commandes",
    "rewards.cost_per_acquisition": "Coût par acquisition",
    "Cost per acquisition": "Coût par acquisition",
    "rewards.repeat_purchase_rate": "Taux de réachat",
    "Repeat purchase rate": "Taux de réachat",
    "rewards.business_outcome_reporting": "Rapport sur les résultats commerciaux",
    "Business outcome reporting": "Rapport sur les résultats commerciaux",
    "rewards.impact": "Résultats",
    "rewards.impact_description": "Conversions, acquisition de clients, chiffre d’affaires généré et coût des récompenses pour la période sélectionnée.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Conversions, acquisition de clients, chiffre d’affaires généré et coût des récompenses pour la période sélectionnée.",
    "rewards.from": "Du",
    "rewards.to": "Au",
    "rewards.trend": "Tendance",
    "Trend": "Tendance",
    "rewards.daily": "Quotidien",
    "rewards.weekly": "Hebdomadaire",
    "Weekly": "Hebdomadaire",
    "rewards.top_partners": "Principaux partenaires / parrains",
    "Top partners / referrers": "Principaux partenaires / parrains",
    "rewards.partner": "Partenaire",
    "Partner": "Partenaire",
    "rewards.conversions": "Conversions",
    "Conversions": "Conversions",
    "rewards.no_partner_data": "Aucune donnée partenaire attribuée pour cette période.",
    "No attributed partner data for this period.": "Aucune donnée partenaire attribuée pour cette période.",
    "rewards.period": "Période",
    "rewards.no_trend_data": "Aucune donnée de tendance pour cette période.",
    "No trend data for this period.": "Aucune donnée de tendance pour cette période.",
    "rewards.campaign_performance": "Performances des campagnes",
    "Campaign performance": "Performances des campagnes",
    "rewards.campaign_count": "{count} campagnes",
    "{count} campaigns": "{count} campagnes",
    "rewards.campaign": "Campagne",
    "rewards.orders": "Commandes",
    "rewards.rate": "Taux",
    "Rate": "Taux",
    "rewards.no_campaign_activity": "Aucune activité de campagne pour le moment. Créez un lien de suivi dans Attribution pour commencer à mesurer les résultats.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Aucune activité de campagne pour le moment. Créez un lien de suivi dans Attribution pour commencer à mesurer les résultats.",
    "rewards.recent_completed_orders": "Commandes récemment terminées",
    "Recent completed orders": "Commandes récemment terminées",
    "rewards.recent_events_count": "{count} événements récents",
    "{count} recent events": "{count} événements récents",
    "rewards.event": "Événement",
    "rewards.completed_order": "Commande terminée",
    "Completed order": "Commande terminée",
    "rewards.no_completed_order_activity": "Aucune activité de commande terminée reçue pour le moment.",
    "No completed order activity has arrived yet.": "Aucune activité de commande terminée reçue pour le moment.",
    "rewards.impact_data_quality_note": "Le volume de clics et le taux de conversion seront disponibles lorsque l’agrégat de clics Attribution sera connecté. Le coût des récompenses utilise les lignes approuvées ou émises du registre ; les remboursements ne sont pas encore inclus.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Le volume de clics et le taux de conversion seront disponibles lorsque l’agrégat de clics Attribution sera connecté. Le coût des récompenses utilise les lignes approuvées ou émises du registre ; les remboursements ne sont pas encore inclus.",
    "subscriptions.type.free": "Abonnement gratuit",
    "Free Subscription": "Abonnement gratuit",
    "subscriptions.form.title_placeholder": "Nom de l’abonnement",
    "Subscription Title": "Nom de l’abonnement",
    "subscriptions.form.title_help": "Saisissez un nom descriptif pour l’offre d’abonnement (par exemple « Offre Premium » ou « Offre de base »).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Saisissez un nom descriptif pour l’offre d’abonnement (par exemple « Offre Premium » ou « Offre de base »).",
    "subscriptions.form.description_placeholder": "Description de l’abonnement",
    "Subscription Description": "Description de l’abonnement",
    "subscriptions.form.description_help": "Décrivez l’abonnement en précisant ses fonctionnalités et ses avantages.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Décrivez l’abonnement en précisant ses fonctionnalités et ses avantages.",
    "subscriptions.form.select_currency": "Sélectionner une devise",
    "Select Currency": "Sélectionner une devise",
    "subscriptions.form.currency_help": "Sélectionnez la devise de l’abonnement dans la liste (devise par défaut).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Sélectionnez la devise de l’abonnement dans la liste (devise par défaut).",
    "subscriptions.form.amount_placeholder": "Montant de l’abonnement",
    "Subscription Amount": "Montant de l’abonnement",
    "subscriptions.form.amount_help": "Saisissez le prix de l’abonnement.",
    "Enter the subscription price.": "Saisissez le prix de l’abonnement.",
    "subscriptions.form.sku_placeholder": "SKU de l’abonnement",
    "Subscription SKU": "SKU de l’abonnement",
    "subscriptions.form.sku_help": "Saisissez un identifiant unique pour l’abonnement, utilisé pour le suivi et la gestion des données.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Saisissez un identifiant unique pour l’abonnement, utilisé pour le suivi et la gestion des données.",
    "subscriptions.form.allowed_listings": "Annonces autorisées",
    "Allowed Listings": "Annonces autorisées",
    "subscriptions.form.allowed_listings_placeholder": "Nombre d’annonces autorisées",
    "Subscription Allowed Listings": "Nombre d’annonces autorisées",
    "subscriptions.form.allowed_listings_help": "Indiquez le nombre d’annonces autorisées avec cet abonnement.",
    "Specify the number of listings allowed for this subscription.": "Indiquez le nombre d’annonces autorisées avec cet abonnement.",
    "subscriptions.form.fixed_fee_per_order": "Frais fixes par commande",
    "Fixed Fee Per Order": "Frais fixes par commande",
    "subscriptions.form.fixed_fee_placeholder": "Frais fixes par commande de l’abonnement",
    "Subscription Fee Fixed Per Order": "Frais fixes par commande de l’abonnement",
    "subscriptions.form.fixed_fee_help": "Saisissez les frais fixes par commande, le cas échéant.",
    "Enter a fixed fee per order, if applicable.": "Saisissez les frais fixes par commande, le cas échéant.",
    "subscriptions.form.commission_percent_per_order": "Commission par commande (%)",
    "Commission % Per Order": "Commission par commande (%)",
    "subscriptions.form.commission_placeholder": "Commission de l’abonnement par commande (%)",
    "Subscription Commission Percent Per Order": "Commission de l’abonnement par commande (%)",
    "subscriptions.form.commission_help": "Saisissez le pourcentage de commission par commande, le cas échéant.",
    "Enter the commission percentage per order, if applicable.": "Saisissez le pourcentage de commission par commande, le cas échéant.",
    "subscriptions.form.expiry_days": "Durée de validité en jours",
    "Expiry Days": "Durée de validité en jours",
    "subscriptions.form.expiry_days_placeholder": "Durée de validité de l’abonnement en jours",
    "Subscription Expiry Days": "Durée de validité de l’abonnement en jours",
    "subscriptions.form.expiry_days_help": "Indiquez le nombre de jours avant l’expiration de l’abonnement (par exemple 7 ou 30 jours).",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Indiquez le nombre de jours avant l’expiration de l’abonnement (par exemple 7 ou 30 jours).",
    "subscriptions.form.payment_method": "Mode de paiement",
    "subscriptions.form.select_type": "Sélectionner un type",
    "subscriptions.form.payment_method_help": "Sélectionnez les modes de paiement pris en charge (Stripe, Mangopay, Android, iOS ou abonnement gratuit).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Sélectionnez les modes de paiement pris en charge (Stripe, Mangopay, Android, iOS ou abonnement gratuit).",
    "subscriptions.form.active_placeholder": "Abonnement actif",
    "Subscription Active": "Abonnement actif",
    "subscriptions.form.active_help": "Activez ou désactivez l’abonnement. Un abonnement actif peut être acheté.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Activez ou désactivez l’abonnement. Un abonnement actif peut être acheté.",
    "subscriptions.add_title": "Ajouter un produit d’abonnement",
    "Add new subscription product": "Ajouter un produit d’abonnement",
    "subscriptions.edit_title": "Modifier le produit d’abonnement",
    "Edit subscription product": "Modifier le produit d’abonnement",
    "subscriptions.added_success": "Produit d’abonnement ajouté",
    "Subscription listing added successfully": "Produit d’abonnement ajouté",
    "subscriptions.updated_success": "Produit d’abonnement mis à jour",
    "Subscription listing updated successfully": "Produit d’abonnement mis à jour",
    "common.currency": "Devise",
    "common.sku": "SKU",
    "subscriptions.title": "Abonnements",
    "subscriptions.add_subscription": "Ajouter un abonnement",
    "Add subscription": "Ajouter un abonnement",
    "subscriptions.plans": "Offres",
    "subscriptions.active_subscribers": "Abonnés actifs",
    "Active Subscribers": "Abonnés actifs",
    "subscriptions.total_mrr": "MRR total",
    "Total MRR": "MRR total",
    "subscriptions.churn_rate": "Taux de résiliation",
    "Churn Rate": "Taux de résiliation",
    "subscriptions.new_this_month": "Nouveaux ce mois-ci",
    "New This Month": "Nouveaux ce mois-ci",
    "subscriptions.average_duration": "Durée moyenne",
    "Avg Duration": "Durée moyenne",
    "subscriptions.monthly_recurring_revenue": "Revenu mensuel récurrent",
    "Monthly Recurring Revenue": "Revenu mensuel récurrent",
    "subscriptions.annual_run_rate": "Revenu annuel estimé",
    "Annual Run Rate": "Revenu annuel estimé",
    "subscriptions.last_30_days": "30 derniers jours",
    "subscriptions.subscriber_lifetime": "Durée de vie des abonnés",
    "Subscriber lifetime": "Durée de vie des abonnés",
    "subscriptions.subscriber_distribution": "Répartition des abonnés",
    "Subscriber Distribution": "Répartition des abonnés",
    "subscriptions.billing_period": "Période de facturation",
    "Billing Period": "Période de facturation",
    "subscriptions.allowed_listings": "Annonces autorisées",
    "subscriptions.commission_per_order": "Commission par commande",
    "Commission per Order": "Commission par commande",
    "subscriptions.fixed_fee_per_order": "Frais fixes par commande",
    "Fixed Fee per Order": "Frais fixes par commande",
    "subscriptions.payment_provider": "Prestataire de paiement",
    "Payment Provider": "Prestataire de paiement",
    "subscriptions.sku_product_id": "SKU / ID du produit",
    "SKU / Product ID": "SKU / ID du produit",
    "subscriptions.revenue_over_time": "Revenus au fil du temps",
    "Revenue Over Time": "Revenus au fil du temps",
    "subscriptions.revenue": "Revenus",
    "subscriptions.subscriber_growth": "Évolution des abonnés",
    "Subscriber Growth": "Évolution des abonnés",
    "subscriptions.subscribers": "Abonnés",
    "Subscribers": "Abonnés",
    "subscriptions.set_inactive": "Désactiver",
    "Set Inactive": "Désactiver",
    "subscriptions.set_active": "Activer",
    "Set Active": "Activer",
    "subscriptions.plan_title": "Offre d’abonnement",
    "Subscription Plan": "Offre d’abonnement",
    "subscriptions.status.active": "Actif",
    "subscriptions.status.cancelled": "Résilié",
    "subscriptions.status.expired": "Expiré",
    "subscriptions.status.trial": "Essai",
    "Trial": "Essai",
    "subscriptions.status.pending": "En attente",
    "subscriptions.period.lifetime": "À vie",
    "Lifetime": "À vie",
    "subscriptions.period.daily": "Quotidien",
    "subscriptions.period.weekly": "Hebdomadaire",
    "subscriptions.period.monthly": "Mensuel",
    "Monthly": "Mensuel",
    "subscriptions.period.quarterly": "Trimestriel",
    "Quarterly": "Trimestriel",
    "subscriptions.period.semi_annual": "Semestriel",
    "Semi-annual": "Semestriel",
    "subscriptions.period.annual": "Annuel",
    "Annual": "Annuel",
    "subscriptions.period.days": "{count} jours",
    "subscriptions.period.day": "/ jour",
    "/ day": "/ jour",
    "subscriptions.period.week": "/ semaine",
    "/ week": "/ semaine",
    "subscriptions.period.month": "/ mois",
    "/ month": "/ mois",
    "subscriptions.period.quarter": "/ trimestre",
    "/ quarter": "/ trimestre",
    "subscriptions.period.six_months": "/ 6 mois",
    "/ 6 months": "/ 6 mois",
    "subscriptions.period.year": "/ an",
    "/ year": "/ an",
    "subscriptions.listings_count": "{count} annonces",
    "{count} listings": "{count} annonces",
    "subscriptions.commission_percentage": "Commission de {rate} %",
    "{rate}% commission": "Commission de {rate} %",
    "subscriptions.per_order": "/ commande",
    "/ order": "/ commande",
    "subscriptions.view_details_subscribers": "Voir les détails et les abonnés",
    "View details and subscribers": "Voir les détails et les abonnés",
    "subscriptions.edit_subscription": "Modifier l’abonnement",
    "Edit subscription": "Modifier l’abonnement",
    "subscriptions.delete_subscription": "Supprimer l’abonnement",
    "Delete subscription": "Supprimer l’abonnement",
    "subscriptions.deleted": "Abonnement supprimé",
    "Subscription deleted": "Abonnement supprimé",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Achats intégrés Android",
    "Android IAP": "Achats intégrés Android",
    "subscriptions.type.ios": "Achats intégrés iOS",
    "iOS IAP": "Achats intégrés iOS",
    "subscriptions.type.free_subscription": "Gratuit",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "{count} chargés",
    "subscriptions.no_subscribers": "Aucun abonné avec le statut « {status} ».",
    "No {status} subscribers.": "Aucun abonné avec le statut « {status} ».",
    "subscriptions.billing_records": "Historique de facturation",
    "Billing Records": "Historique de facturation",
    "subscriptions.no_invoices": "Aucune facture trouvée.",
    "No invoices found.": "Aucune facture trouvée.",
    "subscriptions.column.account": "Compte",
    "subscriptions.column.email": "E-mail",
    "subscriptions.column.status": "Statut",
    "subscriptions.column.subscribed": "Date d’abonnement",
    "Subscribed": "Date d’abonnement",
    "subscriptions.column.expires": "Expiration",
    "subscriptions.column.next_renewal": "Prochain renouvellement",
    "Next Renewal": "Prochain renouvellement",
    "subscriptions.column.amount_paid": "Montant payé",
    "Amount Paid": "Montant payé",
    "subscriptions.invoice_column.invoice_id": "Numéro de facture",
    "Invoice ID": "Numéro de facture",
    "subscriptions.invoice_column.account": "Compte",
    "subscriptions.invoice_column.amount": "Montant",
    "subscriptions.invoice_column.status": "Statut",
    "subscriptions.invoice_column.period": "Période",
    "subscriptions.invoice_column.paid_at": "Payée le",
    "Paid At": "Payée le",
    "subscriptions.validation.title_required": "Le titre est obligatoire",
    "subscriptions.validation.allowed_listings_positive": "Le nombre d’annonces autorisées doit être supérieur à 0",
    "Allowed listings should be greater than 0": "Le nombre d’annonces autorisées doit être supérieur à 0",
    "subscriptions.validation.currency_required": "La devise est obligatoire",
    "Currency is required": "La devise est obligatoire",
    "subscriptions.validation.expiry_required": "La durée de validité est obligatoire",
    "Expiry days are required": "La durée de validité est obligatoire",
    "subscriptions.validation.payment_method_required": "Le mode de paiement est obligatoire",
    "Payment method is required": "Le mode de paiement est obligatoire",
    "subscriptions.error.save": "Une erreur est survenue lors de l’enregistrement de l’abonnement.",
    "Something went wrong while saving the subscription.": "Une erreur est survenue lors de l’enregistrement de l’abonnement.",
    "subscriptions.error.delete": "Une erreur est survenue lors de la suppression de l’abonnement.",
    "Something went wrong while deleting the subscription.": "Une erreur est survenue lors de la suppression de l’abonnement.",
    "common.configuration": "Configuration",
    "subscriptions.per_period": "par {period}",
    "per {period}": "par {period}",
    "subscriptions.tab.subscribers": "Abonnés",
    "subscriptions.tab.invoices": "Factures",
    "subscriptions.account_title": "Abonnement du compte",
    "Account Subscription": "Abonnement du compte",
    "subscriptions.config.description": "Gérez les abonnements des comptes. Lorsqu’ils sont activés, les propriétaires doivent disposer d’un abonnement actif pour publier des annonces. Le moyen de paiement par défaut sélectionné dans les paramètres de paiement sera utilisé.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Gérez les abonnements des comptes. Lorsqu’ils sont activés, les propriétaires doivent disposer d’un abonnement actif pour publier des annonces. Le moyen de paiement par défaut sélectionné dans les paramètres de paiement sera utilisé.",
    "subscriptions.config.enable": "Activer les abonnements",
    "Enable subscriptions": "Activer les abonnements",
    "subscriptions.config.type": "Type d’abonnement",
    "Subscription type": "Type d’abonnement",
    "subscriptions.config.purchased_message": "Message lorsqu’un abonnement a déjà été acheté",
    "Message when a subscription is already purchased": "Message lorsqu’un abonnement a déjà été acheté",
    "subscriptions.config.purchased_placeholder": "Saisissez le message à afficher si l’abonnement a déjà été acheté",
    "Enter the already-purchased message": "Saisissez le message à afficher si l’abonnement a déjà été acheté",
    "subscriptions.config.listings_exhausted_message": "Message lorsque la limite d’annonces est atteinte",
    "Message when the listing limit is reached": "Message lorsque la limite d’annonces est atteinte",
    "subscriptions.config.listings_exhausted_placeholder": "Saisissez le message concernant la limite d’annonces",
    "Enter the listing limit message": "Saisissez le message concernant la limite d’annonces",
    "subscriptions.config.inactive_message": "Message lorsque l’abonnement est inactif",
    "Message when the subscription is inactive": "Message lorsque l’abonnement est inactif",
    "subscriptions.config.inactive_placeholder": "Saisissez le message à afficher lorsque l’abonnement est inactif",
    "Enter the inactive subscription message": "Saisissez le message à afficher lorsque l’abonnement est inactif",
    "subscriptions.config.saved": "Paramètres d’abonnement enregistrés",
    "Subscription settings saved successfully": "Paramètres d’abonnement enregistrés",
    "people.title": "Personnel",
    "people.tab.staff": "Personnel",
    "Staff": "Personnel",
    "people.tab.departments": "Départements",
    "Departments": "Départements",
    "people.tab.job_profiles": "Profils de poste",
    "Job profiles": "Profils de poste",
    "people.tab.pay_grades": "Niveaux de rémunération",
    "Pay grades": "Niveaux de rémunération",
    "people.action.add_staff": "Ajouter un membre du personnel",
    "people.action.add_department": "Ajouter un département",
    "Add department": "Ajouter un département",
    "people.action.add_job_profile": "Ajouter un profil de poste",
    "Add job profile": "Ajouter un profil de poste",
    "people.action.add_pay_grade": "Ajouter un niveau de rémunération",
    "Add pay grade": "Ajouter un niveau de rémunération",
    "people.currency_id": "ID de devise",
    "people.onboarding.eyebrow": "Bien démarrer avec le personnel",
    "Get started with People": "Bien démarrer avec le personnel",
    "people.onboarding.title": "Créez votre annuaire d’équipe",
    "Build your team directory": "Créez votre annuaire d’équipe",
    "people.onboarding.description": "Ajoutez un premier membre du personnel, puis organisez l’équipe avec des départements, des profils de poste et des niveaux de rémunération.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Ajoutez un premier membre du personnel, puis organisez l’équipe avec des départements, des profils de poste et des niveaux de rémunération.",
    "people.onboarding.add_first": "Ajouter votre premier membre du personnel",
    "Add your first staff member": "Ajouter votre premier membre du personnel",
    "people.onboarding.step_staff": "Ajouter le personnel",
    "people.onboarding.step_staff_description": "Associez un utilisateur existant à votre annuaire du personnel.",
    "Link an existing user to your staff directory.": "Associez un utilisateur existant à votre annuaire du personnel.",
    "people.onboarding.step_teams": "Organiser les équipes",
    "Organize teams": "Organiser les équipes",
    "people.onboarding.step_teams_description": "Créez des départements et des profils de poste à mesure que l’équipe grandit.",
    "Create departments and job profiles as you grow.": "Créez des départements et des profils de poste à mesure que l’équipe grandit.",
    "people.onboarding.step_pay": "Définir la rémunération",
    "Set compensation": "Définir la rémunération",
    "people.onboarding.step_pay_description": "Définissez des niveaux de rémunération pour structurer la paie.",
    "Define pay grades for consistent payroll setup.": "Définissez des niveaux de rémunération pour structurer la paie.",
    "people.staff_profile": "Profil du membre du personnel",
    "Staff profile": "Profil du membre du personnel",
    "people.field.employee_code": "Code employé",
    "Employee code": "Code employé",
    "people.field.job_title": "Intitulé du poste",
    "Job title": "Intitulé du poste",
    "people.field.department": "Département",
    "Department": "Département",
    "people.field.job_profile": "Profil de poste",
    "Job profile": "Profil de poste",
    "people.field.pay_grade": "Niveau de rémunération",
    "Pay grade": "Niveau de rémunération",
    "people.field.employment_type": "Type d’emploi",
    "Employment type": "Type d’emploi",
    "people.field.start_date": "Date de début",
    "people.field.user_id": "ID utilisateur",
    "people.field.user": "Utilisateur",
    "people.field.grade": "Niveau",
    "Grade": "Niveau",
    "people.field.salary_range": "Fourchette salariale",
    "Salary range": "Fourchette salariale",
    "people.field.minimum_salary": "Salaire minimum",
    "Minimum salary": "Salaire minimum",
    "people.field.maximum_salary": "Salaire maximum",
    "Maximum salary": "Salaire maximum",
    "people.field.currency_id": "ID de devise",
    "people.form.staff.edit": "Modifier le membre du personnel",
    "Edit staff": "Modifier le membre du personnel",
    "people.form.staff.add": "Ajouter un membre du personnel",
    "people.form.staff.description": "Associez un utilisateur existant à un profil du personnel.",
    "Link an existing user to a staff profile.": "Associez un utilisateur existant à un profil du personnel.",
    "people.form.department.edit": "Modifier le département",
    "Edit department": "Modifier le département",
    "people.form.department.add": "Ajouter un département",
    "people.form.job_profile.edit": "Modifier le profil de poste",
    "Edit job profile": "Modifier le profil de poste",
    "people.form.job_profile.add": "Ajouter un profil de poste",
    "people.form.pay_grade.edit": "Modifier le niveau de rémunération",
    "Edit pay grade": "Modifier le niveau de rémunération",
    "people.form.pay_grade.add": "Ajouter un niveau de rémunération",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Ingénieur senior",
    "Senior Engineer": "Ingénieur senior",
    "people.placeholder.department": "Ingénierie",
    "Engineering": "Ingénierie",
    "people.placeholder.department_description": "Équipe produit et ingénierie",
    "Product & Engineering team": "Équipe produit et ingénierie",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Temps plein",
    "Full time": "Temps plein",
    "people.employment.part_time": "Temps partiel",
    "Part time": "Temps partiel",
    "people.employment.contractor": "Prestataire",
    "Contractor": "Prestataire",
    "people.toast.staff_added": "Membre du personnel ajouté",
    "Staff added": "Membre du personnel ajouté",
    "people.toast.staff_updated": "Membre du personnel mis à jour",
    "Staff updated": "Membre du personnel mis à jour",
    "people.toast.department_added": "Département ajouté",
    "Department added": "Département ajouté",
    "people.toast.department_updated": "Département mis à jour",
    "Department updated": "Département mis à jour",
    "people.toast.job_profile_added": "Profil de poste ajouté",
    "Job profile added": "Profil de poste ajouté",
    "people.toast.job_profile_updated": "Profil de poste mis à jour",
    "Job profile updated": "Profil de poste mis à jour",
    "people.toast.pay_grade_added": "Niveau de rémunération ajouté",
    "Pay grade added": "Niveau de rémunération ajouté",
    "people.toast.pay_grade_updated": "Niveau de rémunération mis à jour",
    "Pay grade updated": "Niveau de rémunération mis à jour",
    "people.empty.staff": "Aucun membre du personnel. Ajoutez un profil pour commencer.",
    "No staff yet. Add a staff profile to get started.": "Aucun membre du personnel. Ajoutez un profil pour commencer.",
    "people.empty.departments": "Aucun département pour le moment.",
    "No departments yet.": "Aucun département pour le moment.",
    "people.empty.job_profiles": "Aucun profil de poste pour le moment.",
    "No job profiles yet.": "Aucun profil de poste pour le moment.",
    "people.empty.pay_grades": "Aucun niveau de rémunération pour le moment.",
    "No pay grades yet.": "Aucun niveau de rémunération pour le moment.",
    "people.pagination.page": "Page {page}",
    "Page {page}": "Page {page}",
    "workforce.title": "Effectifs",
    "workforce.tab.shifts": "Horaires",
    "Shifts": "Horaires",
    "workforce.tab.attendance": "Présences",
    "Attendance": "Présences",
    "workforce.tab.leave_requests": "Demandes de congé",
    "Leave requests": "Demandes de congé",
    "workforce.tab.leave_balances": "Soldes de congés",
    "Leave balances": "Soldes de congés",
    "workforce.tab.leave_policies": "Politiques de congés",
    "Leave policies": "Politiques de congés",
    "workforce.action.add_shift": "Ajouter un horaire",
    "Add shift": "Ajouter un horaire",
    "workforce.action.new_leave_request": "Nouvelle demande de congé",
    "New leave request": "Nouvelle demande de congé",
    "workforce.action.set_balance": "Définir le solde",
    "Set balance": "Définir le solde",
    "workforce.action.add_policy": "Ajouter une politique",
    "Add policy": "Ajouter une politique",
    "workforce.action.create_request": "Créer la demande",
    "Create request": "Créer la demande",
    "workforce.action.save_balance": "Enregistrer le solde",
    "Save balance": "Enregistrer le solde",
    "workforce.action.clock_in": "Pointer l’arrivée",
    "workforce.action.clock_out": "Pointer le départ",
    "workforce.action.clocking_in": "Pointage de l’arrivée…",
    "Clocking in…": "Pointage de l’arrivée…",
    "workforce.action.clocking_out": "Pointage du départ…",
    "Clocking out…": "Pointage du départ…",
    "workforce.field.staff": "Personnel",
    "workforce.field.start_time": "Début",
    "workforce.field.end_time": "Fin",
    "workforce.field.location": "Lieu",
    "workforce.field.leave_type": "Type de congé",
    "Leave type": "Type de congé",
    "workforce.field.from": "Du",
    "workforce.field.to": "Au",
    "workforce.field.days": "Jours",
    "Days": "Jours",
    "workforce.field.total_days": "Jours au total",
    "Total days": "Jours au total",
    "workforce.field.days_per_year": "Jours par an",
    "Days per year": "Jours par an",
    "workforce.field.carry_over": "Report",
    "Carry over": "Report",
    "workforce.field.carry_over_hint": "Les jours non utilisés sont reportés à l’année suivante",
    "Unused days carry over to next year": "Les jours non utilisés sont reportés à l’année suivante",
    "workforce.field.reason": "Motif",
    "workforce.field.time": "Heure",
    "workforce.field.clock_in": "Arrivée",
    "workforce.field.clock_out": "Départ",
    "workforce.field.hours": "Heures",
    "Hours": "Heures",
    "workforce.field.dates": "Dates",
    "Dates": "Dates",
    "workforce.field.used_days": "Utilisés",
    "Used": "Utilisés",
    "workforce.field.remaining_days": "Restants",
    "workforce.field.policy": "Politique",
    "Policy": "Politique",
    "workforce.placeholder.location": "Siège",
    "HQ": "Siège",
    "workforce.placeholder.leave_note": "Vacances en famille",
    "Family holiday": "Vacances en famille",
    "workforce.placeholder.policy_name": "Congé annuel",
    "Annual Leave": "Congé annuel",
    "workforce.placeholder.reject_reason": "Période chargée",
    "Busy period": "Période chargée",
    "workforce.placeholder.optional_note": "Note facultative",
    "Optional note": "Note facultative",
    "workforce.select.all_staff": "Tout le personnel",
    "All staff": "Tout le personnel",
    "workforce.form.shift.add": "Ajouter un horaire",
    "workforce.form.leave_request.add": "Nouvelle demande de congé",
    "workforce.form.leave_balance.title": "Définir le solde de congés",
    "Set leave balance": "Définir le solde de congés",
    "workforce.form.leave_balance.description": "Initialisez le droit à congé d’un membre du personnel pour un type de congé et une année.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Initialisez le droit à congé d’un membre du personnel pour un type de congé et une année.",
    "workforce.form.leave_policy.add": "Ajouter une politique de congés",
    "Add leave policy": "Ajouter une politique de congés",
    "workforce.form.leave_request.reject": "Refuser la demande de congé",
    "Reject leave request": "Refuser la demande de congé",
    "workforce.form.clock_out": "Pointer le départ",
    "workforce.toast.shift_added": "Horaire ajouté",
    "Shift added": "Horaire ajouté",
    "workforce.toast.leave_request_created": "Demande de congé créée",
    "Leave request created": "Demande de congé créée",
    "workforce.toast.leave_balance_saved": "Solde de congés enregistré",
    "Leave balance saved": "Solde de congés enregistré",
    "workforce.toast.leave_policy_added": "Politique de congés ajoutée",
    "Leave policy added": "Politique de congés ajoutée",
    "workforce.toast.leave_request_rejected": "Demande de congé refusée",
    "Leave request rejected": "Demande de congé refusée",
    "workforce.toast.leave_request_approved": "Demande de congé approuvée",
    "Leave request approved": "Demande de congé approuvée",
    "workforce.toast.clocked_in": "Arrivée pointée",
    "Clocked in": "Arrivée pointée",
    "workforce.toast.clocked_out": "Départ pointé",
    "Clocked out": "Départ pointé",
    "workforce.empty.shifts": "Aucun horaire pour cette période.",
    "No shifts in this period.": "Aucun horaire pour cette période.",
    "workforce.empty.attendance": "Aucun relevé de présence.",
    "No attendance records.": "Aucun relevé de présence.",
    "workforce.empty.leave_requests": "Aucune demande de congé.",
    "No leave requests.": "Aucune demande de congé.",
    "workforce.empty.leave_balances": "Aucun solde de congés. Utilisez « Définir le solde » pour en ajouter un.",
    "No leave balances. Use Set balance to add one.": "Aucun solde de congés. Utilisez « Définir le solde » pour en ajouter un.",
    "workforce.empty.leave_policies": "Aucune politique de congés pour le moment.",
    "No leave policies yet.": "Aucune politique de congés pour le moment.",
    "workforce.leave_type.annual": "Congé annuel",
    "Annual leave": "Congé annuel",
    "workforce.leave_type.sick": "Congé maladie",
    "Sick leave": "Congé maladie",
    "workforce.leave_type.unpaid": "Congé sans solde",
    "Unpaid leave": "Congé sans solde",
    "workforce.leave_type.parental": "Congé parental",
    "Parental leave": "Congé parental",
    "workforce.leave_type.compassionate": "Congé pour raisons familiales",
    "Compassionate leave": "Congé pour raisons familiales",
    "workforce.duration.hours_minutes": "{hours} h {minutes} min",
    "{hours}h {minutes}m": "{hours} h {minutes} min",
    "common.year": "Année",
    "Year": "Année",
    "common.approve": "Approuver",
    "common.reject": "Refuser",
    "payroll.title": "Paie",
    "payroll.tab.runs": "Cycles de paie",
    "Payroll runs": "Cycles de paie",
    "payroll.tab.components": "Éléments de paie",
    "Pay components": "Éléments de paie",
    "payroll.tab.claims": "Notes de frais",
    "Expense claims": "Notes de frais",
    "payroll.tab.categories": "Catégories de dépenses",
    "Expense categories": "Catégories de dépenses",
    "payroll.action.new_run": "Nouveau cycle de paie",
    "New payroll run": "Nouveau cycle de paie",
    "payroll.action.add_component": "Ajouter un élément de paie",
    "Add pay component": "Ajouter un élément de paie",
    "payroll.action.new_claim": "Nouvelle note de frais",
    "New expense claim": "Nouvelle note de frais",
    "payroll.action.add_category": "Ajouter une catégorie",
    "payroll.action.create_run": "Créer le cycle",
    "Create run": "Créer le cycle",
    "payroll.action.create_component": "Créer l’élément",
    "Create component": "Créer l’élément",
    "payroll.action.create_claim": "Créer la note de frais",
    "Create claim": "Créer la note de frais",
    "payroll.action.submit_claim": "Soumettre",
    "Submit": "Soumettre",
    "payroll.action.approve_claim": "Approuver",
    "payroll.action.reimburse_claim": "Rembourser",
    "Reimburse": "Rembourser",
    "payroll.action.approve_payroll": "Approuver la paie",
    "Approve payroll": "Approuver la paie",
    "payroll.action.activate": "Activer",
    "Activate": "Activer",
    "payroll.action.deactivate": "Désactiver",
    "payroll.action.adjust": "Ajuster",
    "payroll.action.save_adjustment": "Enregistrer l’ajustement",
    "payroll.action.export_csv": "Exporter le CSV",
    "payroll.action.exporting": "Exportation…",
    "payroll.action.view_staff_items": "Voir les éléments du personnel",
    "View staff items": "Voir les éléments du personnel",
    "payroll.action.view_payslips": "Voir les bulletins de paie",
    "View payslips": "Voir les bulletins de paie",
    "payroll.type.addition": "Ajout",
    "Addition": "Ajout",
    "payroll.type.deduction": "Retenue",
    "Deduction": "Retenue",
    "payroll.calculation.fixed": "Montant fixe",
    "Fixed amount": "Montant fixe",
    "payroll.calculation.percentage": "Pourcentage",
    "payroll.applies_to.all": "Tout le personnel",
    "payroll.applies_to.hourly": "Personnel rémunéré à l’heure",
    "Hourly staff": "Personnel rémunéré à l’heure",
    "payroll.applies_to.salaried": "Personnel salarié",
    "Salaried staff": "Personnel salarié",
    "payroll.category.archive_confirm": "Archiver {name} ?",
    "payroll.components.description": "Les ajouts et retenues actifs sont automatiquement appliqués aux prochains cycles de paie.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Les ajouts et retenues actifs sont automatiquement appliqués aux prochains cycles de paie.",
    "payroll.empty.categories": "Aucune catégorie de dépenses pour le moment.",
    "No expense categories yet.": "Aucune catégorie de dépenses pour le moment.",
    "payroll.empty.claims": "Aucune note de frais pour le moment.",
    "No expense claims yet.": "Aucune note de frais pour le moment.",
    "payroll.empty.components": "Aucun élément de paie configuré.",
    "No pay components configured yet.": "Aucun élément de paie configuré.",
    "payroll.empty.runs": "Aucun cycle de paie pour le moment.",
    "No payroll runs yet.": "Aucun cycle de paie pour le moment.",
    "payroll.field.staff": "Personnel",
    "payroll.field.base_pay": "Salaire de base",
    "Base pay": "Salaire de base",
    "payroll.field.allowances": "Indemnités",
    "Allowances": "Indemnités",
    "payroll.field.deductions": "Retenues",
    "Deductions": "Retenues",
    "payroll.field.commission": "Commission",
    "payroll.field.net_pay": "Salaire net",
    "Net pay": "Salaire net",
    "payroll.field.components": "Éléments",
    "Components": "Éléments",
    "payroll.field.commission_override": "Ajustement de commission",
    "Commission override": "Ajustement de commission",
    "payroll.field.calculation": "Calcul",
    "Calculation": "Calcul",
    "payroll.field.applies_to": "S’applique à",
    "Applies to": "S’applique à",
    "payroll.field.staff_optional_draft": "Personnel (facultatif pendant la préparation)",
    "payroll.field.category_optional_draft": "Catégorie (facultative pendant la préparation)",
    "payroll.field.category": "Catégorie",
    "payroll.field.period": "Période",
    "payroll.field.period_start": "Début de la période",
    "Period start": "Début de la période",
    "payroll.field.period_end": "Fin de la période",
    "Period end": "Fin de la période",
    "payroll.field.generate_email_payslips": "Générer et envoyer les bulletins par e-mail",
    "Generate and email payslips": "Générer et envoyer les bulletins par e-mail",
    "payroll.field.gl_code": "Code du grand livre",
    "GL code": "Code du grand livre",
    "payroll.field.maximum_per_claim": "Maximum par note de frais",
    "Maximum per claim": "Maximum par note de frais",
    "payroll.field.maximum_per_transaction": "Maximum par transaction",
    "Maximum per transaction": "Maximum par transaction",
    "payroll.field.spending_cap": "Plafond de dépenses",
    "Spending cap": "Plafond de dépenses",
    "payroll.field.tax_rate": "Taux de taxe (%)",
    "Tax rate (%)": "Taux de taxe (%)",
    "payroll.field.no_limit": "Aucune limite",
    "No limit": "Aucune limite",
    "payroll.form.run.title": "Nouveau cycle de paie",
    "payroll.form.run.description": "La paie est calculée à partir des niveaux de rémunération du personnel pour la période sélectionnée.",
    "Pay is calculated from staff pay grades for the selected period.": "La paie est calculée à partir des niveaux de rémunération du personnel pour la période sélectionnée.",
    "payroll.form.component.title": "Ajouter un élément de paie",
    "payroll.form.component.description": "Les éléments sont automatiquement inclus dans les prochains cycles de paie.",
    "Components are automatically included in future payroll runs.": "Les éléments sont automatiquement inclus dans les prochains cycles de paie.",
    "payroll.form.claim.title": "Nouvelle note de frais",
    "payroll.form.claim.description": "Les notes de frais restent en brouillon jusqu’à leur soumission pour approbation.",
    "Claims start as drafts until submitted for approval.": "Les notes de frais restent en brouillon jusqu’à leur soumission pour approbation.",
    "payroll.form.category.add": "Ajouter une catégorie de dépenses",
    "Add expense category": "Ajouter une catégorie de dépenses",
    "payroll.form.category.edit": "Modifier la catégorie de dépenses",
    "Edit expense category": "Modifier la catégorie de dépenses",
    "payroll.form.claim.approve_title": "Approuver la note de frais",
    "Approve expense claim": "Approuver la note de frais",
    "payroll.form.run.approve_title": "Approuver le cycle de paie",
    "Approve payroll run": "Approuver le cycle de paie",
    "payroll.form.run.approve_description": "L’approbation verrouille le cycle de paie. Vous pouvez également générer et envoyer les bulletins par e-mail maintenant.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "L’approbation verrouille le cycle de paie. Vous pouvez également générer et envoyer les bulletins par e-mail maintenant.",
    "payroll.items.title": "Éléments de paie du personnel",
    "Staff payroll items": "Éléments de paie du personnel",
    "payroll.items.loading": "Chargement des éléments de paie…",
    "Loading payroll items…": "Chargement des éléments de paie…",
    "payroll.items.empty": "Aucun élément de paie trouvé.",
    "No payroll items found.": "Aucun élément de paie trouvé.",
    "payroll.items.adjust_title": "Ajuster un élément de paie",
    "Adjust payroll item": "Ajuster un élément de paie",
    "payroll.items.adjust_description": "Modifiez les retenues ou le montant de commission de ce membre du personnel.",
    "Update deductions or override the commission amount for this staff member.": "Modifiez les retenues ou le montant de commission de ce membre du personnel.",
    "payroll.payslips.title": "Bulletins de paie",
    "Payslips": "Bulletins de paie",
    "payroll.payslips.generate": "Générer les bulletins de paie",
    "Generate payslips": "Générer les bulletins de paie",
    "payroll.payslips.generating": "Génération…",
    "Generating…": "Génération…",
    "payroll.payslips.empty": "Aucun bulletin de paie généré.",
    "No payslips generated yet.": "Aucun bulletin de paie généré.",
    "payroll.payslips.generated": "Généré",
    "Generated": "Généré",
    "payroll.payslips.sent_at": "Envoyé le {date}",
    "Sent {date}": "Envoyé le {date}",
    "payroll.payslips.not_sent": "Non envoyé",
    "Not sent": "Non envoyé",
    "payroll.payslips.send_email": "Envoyer un e-mail",
    "Send email": "Envoyer un e-mail",
    "payroll.payslips.sending": "Envoi…",
    "payroll.payslips.details": "Détails du bulletin de paie",
    "Payslip details": "Détails du bulletin de paie",
    "payroll.placeholder.approval_note": "Approuvé",
    "payroll.placeholder.category_name": "Déplacements",
    "Travel": "Déplacements",
    "payroll.placeholder.claim_description": "Vol pour rencontrer un client",
    "Flight to client": "Vol pour rencontrer un client",
    "payroll.placeholder.component_name": "Indemnité de transport",
    "Transport Allowance": "Indemnité de transport",
    "payroll.staff_number": "Personnel n° {id}",
    "Staff #{id}": "Personnel n° {id}",
    "payroll.toast.category_added": "Catégorie de dépenses ajoutée",
    "Expense category added": "Catégorie de dépenses ajoutée",
    "payroll.toast.category_archived": "Catégorie de dépenses archivée",
    "Expense category archived": "Catégorie de dépenses archivée",
    "payroll.toast.category_updated": "Catégorie de dépenses mise à jour",
    "Expense category updated": "Catégorie de dépenses mise à jour",
    "payroll.toast.claim_approved": "Note de frais approuvée",
    "Claim approved": "Note de frais approuvée",
    "payroll.toast.claim_created": "Note de frais créée",
    "Expense claim created": "Note de frais créée",
    "payroll.toast.claim_reimbursed": "Note de frais marquée comme remboursée",
    "Claim marked as reimbursed": "Note de frais marquée comme remboursée",
    "payroll.toast.claim_submitted": "Note de frais soumise",
    "Claim submitted": "Note de frais soumise",
    "payroll.toast.component_activated": "Élément de paie activé",
    "Pay component activated": "Élément de paie activé",
    "payroll.toast.component_created": "Élément de paie créé",
    "Pay component created": "Élément de paie créé",
    "payroll.toast.component_deactivated": "Élément de paie désactivé",
    "Pay component deactivated": "Élément de paie désactivé",
    "payroll.toast.item_updated": "Élément de paie mis à jour",
    "Payroll item updated": "Élément de paie mis à jour",
    "payroll.toast.payslip_email_sent": "E-mail du bulletin envoyé",
    "Payslip email sent": "E-mail du bulletin envoyé",
    "payroll.toast.payslips_generated": "Bulletins de paie générés",
    "Payslips generated": "Bulletins de paie générés",
    "payroll.toast.run_approved": "Cycle de paie approuvé",
    "Payroll run approved": "Cycle de paie approuvé",
    "payroll.toast.run_approved_payslips_queued": "Paie approuvée et bulletins mis en file d’envoi",
    "Payroll approved and payslips queued": "Paie approuvée et bulletins mis en file d’envoi",
    "payroll.toast.run_created": "Cycle de paie créé",
    "payroll.toast.exported": "Paie exportée",
    "Payroll exported": "Paie exportée",
    "common.notes": "Notes",
    "expenses.title": "Dépenses",
    "expenses.action.add": "Ajouter une dépense",
    "Add expense": "Ajouter une dépense",
    "expenses.action.create": "Créer la dépense",
    "Create expense": "Créer la dépense",
    "expenses.action.submit": "Soumettre",
    "expenses.action.approve": "Approuver",
    "expenses.action.reimburse": "Rembourser",
    "expenses.action.pay": "Payer",
    "expenses.action.lifecycle": "Dépense : {action}",
    "Expense {action}d": "Dépense : {action}",
    "expenses.type.claim": "Demande de remboursement",
    "Claim": "Demande de remboursement",
    "expenses.type.claims": "Demandes de remboursement",
    "Claims": "Demandes de remboursement",
    "expenses.type.bill": "Facture",
    "Bill": "Facture",
    "expenses.type.bills": "Factures",
    "Bills": "Factures",
    "expenses.filter.all_types": "Tous les types",
    "All types": "Tous les types",
    "expenses.filter.all_statuses": "Tous les statuts",
    "expenses.summary.title": "Résumé",
    "Summary": "Résumé",
    "expenses.summary.by_category": "Par catégorie",
    "By category": "Par catégorie",
    "expenses.summary.by_status": "Par statut",
    "By status": "Par statut",
    "expenses.summary.by_party": "Par fournisseur / employé",
    "By supplier / staff": "Par fournisseur / employé",
    "expenses.summary.heading": "Résumé par {group}",
    "Summary by {group}": "Résumé par {group}",
    "expenses.summary.group.category": "catégorie",
    "category": "catégorie",
    "expenses.summary.group.status": "statut",
    "status": "statut",
    "expenses.summary.group.party": "fournisseur / employé",
    "supplier / staff": "fournisseur / employé",
    "expenses.summary.empty": "Aucun résumé disponible.",
    "No summary available.": "Aucun résumé disponible.",
    "expenses.column.type": "Type",
    "expenses.column.party": "Employé / Fournisseur",
    "Staff / Supplier": "Employé / Fournisseur",
    "expenses.column.status": "Statut",
    "expenses.field.staff_optional": "Employé (facultatif pour le brouillon)",
    "expenses.field.supplier_optional": "Fournisseur (facultatif pour le brouillon)",
    "Supplier (optional while drafting)": "Fournisseur (facultatif pour le brouillon)",
    "expenses.field.category_optional": "Catégorie (facultative pour le brouillon)",
    "expenses.field.amount": "Montant",
    "expenses.field.currency": "Devise",
    "expenses.field.description": "Description",
    "expenses.field.due_date": "Date d’échéance",
    "Due date": "Date d’échéance",
    "expenses.field.receipt_url": "URL du reçu",
    "Receipt URL": "URL du reçu",
    "expenses.empty": "Aucune dépense ne correspond aux filtres sélectionnés.",
    "No expenses found for the selected filters.": "Aucune dépense ne correspond aux filtres sélectionnés.",
    "expenses.modal.edit": "Modifier la dépense",
    "Edit expense": "Modifier la dépense",
    "expenses.modal.add": "Ajouter : {type}",
    "Add {type}": "Ajouter : {type}",
    "expenses.modal.bill_help": "Créez le brouillon maintenant et attribuez un fournisseur avant de le soumettre.",
    "Create the draft now and assign a supplier before submitting.": "Créez le brouillon maintenant et attribuez un fournisseur avant de le soumettre.",
    "expenses.modal.claim_help": "Créez le brouillon maintenant et attribuez un employé avant de le soumettre.",
    "Create the draft now and assign a staff member before submitting.": "Créez le brouillon maintenant et attribuez un employé avant de le soumettre.",
    "expenses.toast.updated": "Dépense mise à jour",
    "Expense updated": "Dépense mise à jour",
    "expenses.toast.created": "Dépense créée",
    "Expense created": "Dépense créée",
    "recurring_payments.title": "Paiements récurrents",
    "recurring_payments.action.add": "Ajouter un paiement récurrent",
    "Add recurring payment": "Ajouter un paiement récurrent",
    "recurring_payments.action.create": "Créer le paiement récurrent",
    "Create recurring payment": "Créer le paiement récurrent",
    "recurring_payments.action.pause": "Mettre en pause",
    "Pause": "Mettre en pause",
    "recurring_payments.action.resume": "Reprendre",
    "Resume": "Reprendre",
    "recurring_payments.action.remove": "Supprimer",
    "recurring_payments.description": "Créez automatiquement des brouillons de factures pour les paiements réguliers aux fournisseurs.",
    "Automatically create draft expense bills for regular supplier payments.": "Créez automatiquement des brouillons de factures pour les paiements réguliers aux fournisseurs.",
    "recurring_payments.field.name": "Nom",
    "recurring_payments.field.supplier": "Fournisseur",
    "recurring_payments.field.supplier_optional": "Fournisseur (facultatif)",
    "Supplier (optional)": "Fournisseur (facultatif)",
    "recurring_payments.field.frequency": "Fréquence",
    "Frequency": "Fréquence",
    "recurring_payments.field.next_due": "Prochaine échéance",
    "Next due date": "Prochaine échéance",
    "recurring_payments.field.auto_create": "Créer automatiquement un brouillon de facture",
    "Auto-create draft bill": "Créer automatiquement un brouillon de facture",
    "recurring_payments.field.auto_create_help": "Créer automatiquement un brouillon de facture de dépense",
    "Create a draft expense bill automatically": "Créer automatiquement un brouillon de facture de dépense",
    "recurring_payments.field.one_time": "Paiement unique",
    "One-time payment": "Paiement unique",
    "recurring_payments.field.one_time_help": "Terminer après la prochaine facture générée",
    "End after the next generated bill": "Terminer après la prochaine facture générée",
    "recurring_payments.field.end_date": "Date de fin",
    "recurring_payments.placeholder.name": "Loyer du bureau",
    "Office Rent": "Loyer du bureau",
    "recurring_payments.frequency.daily": "Quotidien",
    "recurring_payments.frequency.weekly": "Hebdomadaire",
    "recurring_payments.frequency.monthly": "Mensuel",
    "recurring_payments.frequency.quarterly": "Trimestriel",
    "recurring_payments.frequency.yearly": "Annuel",
    "Yearly": "Annuel",
    "recurring_payments.form.description": "Les paiements dus créent automatiquement des brouillons de factures dans Dépenses lorsque cette option est activée.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Les paiements dus créent automatiquement des brouillons de factures dans Dépenses lorsque cette option est activée.",
    "recurring_payments.empty": "Aucun paiement récurrent pour le moment.",
    "No recurring payments yet.": "Aucun paiement récurrent pour le moment.",
    "recurring_payments.this_payment": "ce paiement récurrent",
    "this recurring payment": "ce paiement récurrent",
    "recurring_payments.confirm_remove": "Supprimer {name} ?",
    "Remove {name}?": "Supprimer {name} ?",
    "recurring_payments.toast.pause": "Paiement récurrent mis en pause",
    "Recurring payment paused": "Paiement récurrent mis en pause",
    "recurring_payments.toast.resume": "Paiement récurrent repris",
    "Recurring payment resumed": "Paiement récurrent repris",
    "recurring_payments.toast.delete": "Paiement récurrent supprimé",
    "Recurring payment removed": "Paiement récurrent supprimé",
    "recurring_payments.toast.created": "Paiement récurrent créé",
    "Recurring payment created": "Paiement récurrent créé",
    "expenses.toast.submit": "Dépense soumise",
    "Expense submitted": "Dépense soumise",
    "expenses.toast.approve": "Dépense approuvée",
    "Expense approved": "Dépense approuvée",
    "expenses.toast.reimburse": "Dépense remboursée",
    "Expense reimbursed": "Dépense remboursée",
    "expenses.toast.pay": "Dépense payée",
    "Expense paid": "Dépense payée",
    "media_picker.title": "Sélectionner un média",
    "Select media": "Sélectionner un média",
    "media_picker.type.media": "Médias",
    "media_picker.type.all": "Tout",
    "media_picker.type.image": "Image",
    "media_picker.type.video": "Vidéo",
    "media_picker.type.audio": "Audio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Dossier",
    "media_picker.label.show": "Afficher",
    "media_picker.label.media_type": "Type de média",
    "Media type": "Type de média",
    "media_picker.action.show_type": "Afficher les médias : {type}",
    "media_picker.action.close": "Fermer le sélecteur de médias",
    "Close media picker": "Fermer le sélecteur de médias",
    "media_picker.action.upload": "Importer un média",
    "media_picker.action.creating": "Création…",
    "media_picker.action.create_folder": "Créer un dossier",
    "Create folder": "Créer un dossier",
    "media_picker.action.cancel": "Annuler",
    "media_picker.action.use_selected": "Utiliser la sélection",
    "Use selected": "Utiliser la sélection",
    "media_picker.placeholder.search": "Rechercher des médias",
    "media_picker.placeholder.folder": "Nom du nouveau dossier",
    "New folder name": "Nom du nouveau dossier",
    "media_picker.loading": "Chargement des médias…",
    "media_picker.empty": "Aucun média dans ce dossier.",
    "No media found in this folder.": "Aucun média dans ce dossier.",
    "media_picker.selection.count": "{count} sélectionné(s)",
    "{count} selected": "{count} sélectionné(s)",
    "media_picker.selection.prompt": "Sélectionnez un fichier pour continuer",
    "Select a file to continue": "Sélectionnez un fichier pour continuer",
    "media_picker.error.load": "Impossible de charger les médias",
    "Unable to load media": "Impossible de charger les médias",
    "media_picker.error.load_retry": "Impossible de charger les médias. Réessayez.",
    "media_picker.error.create_folder": "Impossible de créer le dossier",
    "media_picker.error.create_folder_retry": "Impossible de créer le dossier. Réessayez.",
    "Unable to create folder. Please try again.": "Impossible de créer le dossier. Réessayez.",
    "media_picker.error.prepare_upload": "Impossible de préparer l’importation",
    "Unable to prepare upload": "Impossible de préparer l’importation",
    "media_picker.error.upload_url": "URL d’importation manquante",
    "Upload URL missing": "URL d’importation manquante",
    "media_picker.error.register_media": "Impossible d’enregistrer le média",
    "media_picker.error.upload_retry": "Impossible d’importer le média. Réessayez.",
    "membership.title": "Adhésion",
    "membership.description": "Gérez les programmes d’adhésion, les contributions, les paiements et les rappels.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Gérez les programmes d’adhésion, les contributions, les paiements et les rappels.",
    "membership.action.settings": "Paramètres",
    "membership.action.manage_programs": "Gérer les programmes",
    "Manage programs": "Gérer les programmes",
    "membership.action.view_data": "Voir les données",
    "View data": "Voir les données",
    "membership.action.edit_listing": "Modifier l’annonce",
    "membership.action.go_to_listings": "Accéder aux annonces",
    "Go to listings": "Accéder aux annonces",
    "membership.action.view_order": "Voir la commande",
    "View order": "Voir la commande",
    "membership.action.configure_reminders": "Configurer les rappels",
    "Configure reminders": "Configurer les rappels",
    "membership.stat.programs": "Programmes",
    "membership.stat.active_members": "Membres actifs",
    "Active members": "Membres actifs",
    "membership.stat.contributions": "Contributions",
    "Contributions": "Contributions",
    "membership.stat.units": "Unités créditées",
    "Units credited": "Unités créditées",
    "membership.programs.title": "Programmes",
    "membership.programs.description": "Les annonces de type adhésion proposées à vos clients.",
    "Membership-type listings available to your customers.": "Les annonces de type adhésion proposées à vos clients.",
    "membership.programs.no_description": "Aucune description du programme pour le moment.",
    "No program description yet.": "Aucune description du programme pour le moment.",
    "membership.programs.empty_title": "Aucun programme d’adhésion pour le moment",
    "No membership programs yet": "Aucun programme d’adhésion pour le moment",
    "membership.programs.empty_description": "Créez une annonce de type adhésion pour commencer à recevoir des contributions.",
    "Create a listing with type membership to start accepting contributions.": "Créez une annonce de type adhésion pour commencer à recevoir des contributions.",
    "membership.programs.history_description": "Historique des prix et membres inscrits.",
    "Price history and enrolled members.": "Historique des prix et membres inscrits.",
    "membership.badge": "Adhésion",
    "membership.loading_program": "Chargement des données du programme…",
    "Loading program data…": "Chargement des données du programme…",
    "membership.price_logs.title": "Historique des prix",
    "Price logs": "Historique des prix",
    "membership.price_logs.empty": "Aucun historique de prix enregistré.",
    "No price logs recorded.": "Aucun historique de prix enregistré.",
    "membership.source.manual": "manuel",
    "manual": "manuel",
    "membership.members.title": "Membres",
    "Members": "Membres",
    "membership.members.empty_program": "Aucun membre inscrit à ce programme.",
    "No members enrolled in this program.": "Aucun membre inscrit à ce programme.",
    "membership.members.recent": "Membres récents",
    "Recent members": "Membres récents",
    "membership.members.empty_recent": "Les membres et leurs contributions apparaîtront ici après leur inscription.",
    "Members and contributions will appear here after enrolment.": "Les membres et leurs contributions apparaîtront ici après leur inscription.",
    "membership.member_heading": "Membre : {member}",
    "Member: {member}": "Membre : {member}",
    "membership.contributions.title": "Contributions",
    "membership.contributions.empty": "Aucune contribution enregistrée pour le moment.",
    "No contributions recorded yet.": "Aucune contribution enregistrée pour le moment.",
    "membership.payment_dues.title": "Échéances de paiement",
    "Payment dues": "Échéances de paiement",
    "membership.payment_dues.empty": "Aucune échéance de paiement planifiée.",
    "No scheduled payment dues.": "Aucune échéance de paiement planifiée.",
    "membership.unit": "unité",
    "unit": "unité",
    "membership.units": "unités",
    "units": "unités",
    "membership.months": "mois",
    "membership.automation.label": "AUTOMATISATION",
    "AUTOMATION": "AUTOMATISATION",
    "membership.automation.description": "Un processus quotidien vérifie les paiements d’adhésion planifiés.",
    "Daily worker checks scheduled membership payments.": "Un processus quotidien vérifie les paiements d’adhésion planifiés.",
    "membership.reminders.title": "Rappels de paiement",
    "Payment reminders": "Rappels de paiement",
    "membership.reminders.due_soon": "Rappel avant échéance",
    "Due-soon reminder": "Rappel avant échéance",
    "membership.reminders.due_soon_short": "Bientôt dû",
    "Due soon": "Bientôt dû",
    "membership.reminders.due_soon_help": "Envoyer un rappel avant la date prévue du paiement.",
    "Send one reminder before a scheduled payment is due.": "Envoyer un rappel avant la date prévue du paiement.",
    "membership.reminders.days_before": "Jours avant l’échéance",
    "Days before due date": "Jours avant l’échéance",
    "membership.reminders.days_before_value": "{count} jours avant",
    "{count} days before": "{count} jours avant",
    "membership.reminders.overdue": "Rappel de retard",
    "Overdue reminder": "Rappel de retard",
    "membership.reminders.overdue_help": "Envoyer un rappel après la date d’échéance et le délai de grâce.",
    "Send one reminder after the due date and grace period.": "Envoyer un rappel après la date d’échéance et le délai de grâce.",
    "membership.settings.title": "Paramètres d’adhésion",
    "Membership settings": "Paramètres d’adhésion",
    "membership.settings.description": "Configurez le calendrier des rappels de paiement.",
    "Configure the payment reminder schedule.": "Configurez le calendrier des rappels de paiement.",
    "membership.email_copy.title": "Texte personnalisé des e-mails",
    "Custom email copy": "Texte personnalisé des e-mails",
    "membership.email_copy.description": "Dans Paramètres → Notifications → Adhésion, modifiez les sujets et modèles des rappels avant échéance et en retard.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Dans Paramètres → Notifications → Adhésion, modifiez les sujets et modèles des rappels avant échéance et en retard.",
    "membership.toast.saved": "Paramètres des rappels d’adhésion enregistrés.",
    "Membership reminder settings saved.": "Paramètres des rappels d’adhésion enregistrés.",
    "membership.toast.save_failed": "Impossible d’enregistrer les paramètres des rappels d’adhésion.",
    "Unable to save membership reminder settings.": "Impossible d’enregistrer les paramètres des rappels d’adhésion.",
    "common.status.off": "Désactivé",
    "Off": "Désactivé",
    "common.status.on": "Activé",
    "On": "Activé",
    "common.save_settings": "Enregistrer les paramètres",
    "Save settings": "Enregistrer les paramètres",
    "developer.page.title": "API et développeur",
    "API & Developer": "API et développeur",
    "developer.api_keys.title": "Clés API",
    "API Keys": "Clés API",
    "developer.api_keys.description": "Utilisez ces clés pour authentifier les requêtes vers l’API Tradly. Gardez votre clé secrète confidentielle et ne l’exposez jamais dans le code côté client.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Utilisez ces clés pour authentifier les requêtes vers l’API Tradly. Gardez votre clé secrète confidentielle et ne l’exposez jamais dans le code côté client.",
    "developer.api_keys.credentials_description": "Retrouvez ci-dessous vos clés de production. Utilisez-les pour autoriser et créer vos applications.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Retrouvez ci-dessous vos clés de production. Utilisez-les pour autoriser et créer vos applications.",
    "developer.api_keys.publishable": "Clé publique",
    "Publishable Key": "Clé publique",
    "developer.api_keys.publishable_placeholder": "Saisissez la clé publique",
    "Enter Publishable Key": "Saisissez la clé publique",
    "developer.api_keys.secret": "Clé secrète",
    "developer.api_keys.secret_placeholder": "Saisissez la clé secrète",
    "Enter Secret Key": "Saisissez la clé secrète",
    "developer.api_keys.access_label": "Accès à l’API",
    "API access": "Accès à l’API",
    "developer.api_reference.title": "Référence de l’API",
    "developer.api_reference.description": "Documentation complète de l’API REST, guides et exemples de code pour développer sur votre marketplace Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Documentation complète de l’API REST, guides et exemples de code pour développer sur votre marketplace Tradly.",
    "developer.api_reference.card_description": "Consultez la référence complète de l’API, les guides d’authentification, les webhooks et la documentation du SDK. Tout le nécessaire pour intégrer votre marketplace ou créer des interfaces personnalisées.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Consultez la référence complète de l’API, les guides d’authentification, les webhooks et la documentation du SDK. Tout le nécessaire pour intégrer votre marketplace ou créer des interfaces personnalisées.",
    "developer.api_reference.open_docs": "Ouvrir la documentation API",
    "Open API Docs": "Ouvrir la documentation API",
    "developer.ai_agents.title": "IA et agents",
    "AI & Agents": "IA et agents",
    "developer.ai_agents.description": "Connectez votre marketplace aux outils d’IA et permettez à vos clients de créer des agents basés sur votre plateforme.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Connectez votre marketplace aux outils d’IA et permettez à vos clients de créer des agents basés sur votre plateforme.",
    "developer.mcp.action.create": "Créer",
    "developer.mcp.action.removing": "Suppression…",
    "developer.mcp.scope.resource": "Ressource",
    "developer.customer_agents.description": "Permettez à vos clients de créer des agents IA qui interagissent avec votre marketplace. Compatibles avec ChatGPT, Claude et d’autres plateformes d’IA, ils peuvent automatiser les parcours d’achat, créer des vitrines personnalisées ou des assistants d’achat intelligents.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Permettez à vos clients de créer des agents IA qui interagissent avec votre marketplace. Compatibles avec ChatGPT, Claude et d’autres plateformes d’IA, ils peuvent automatiser les parcours d’achat, créer des vitrines personnalisées ou des assistants d’achat intelligents.",
    "whatsapp.title": "Connecteur WhatsApp",
    "WhatsApp connector": "Connecteur WhatsApp",
    "whatsapp.intro.title": "Envoyez des codes OTP et des messages marketing via WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Envoyez des codes OTP et des messages marketing via WhatsApp",
    "whatsapp.intro.help": "Connectez ce tenant à l’API WhatsApp Cloud de Meta. Les SMS restent disponibles comme canal par défaut ou de secours, et le connecteur peut envoyer des modèles de campagne WhatsApp approuvés.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Connectez ce tenant à l’API WhatsApp Cloud de Meta. Les SMS restent disponibles comme canal par défaut ou de secours, et le connecteur peut envoyer des modèles de campagne WhatsApp approuvés.",
    "whatsapp.status.disabled": "Désactivé",
    "whatsapp.status.sms_otp": "Connecteur activé · OTP par SMS",
    "Connector on · SMS OTP": "Connecteur activé · OTP par SMS",
    "whatsapp.status.needs_configuration": "Configuration requise",
    "Needs configuration": "Configuration requise",
    "whatsapp.status.auto_fallback": "WhatsApp avec secours par SMS",
    "WhatsApp with SMS fallback": "WhatsApp avec secours par SMS",
    "whatsapp.status.sms_whatsapp_backup": "SMS avec secours WhatsApp",
    "SMS with WhatsApp backup": "SMS avec secours WhatsApp",
    "whatsapp.status.enabled": "WhatsApp activé",
    "WhatsApp enabled": "WhatsApp activé",
    "whatsapp.draft.notice": "Vous avez un brouillon non enregistré des paramètres WhatsApp.",
    "You have an unsaved WhatsApp settings draft.": "Vous avez un brouillon non enregistré des paramètres WhatsApp.",
    "whatsapp.connect.title": "Connectez le WhatsApp de votre entreprise",
    "Connect your business WhatsApp": "Connectez le WhatsApp de votre entreprise",
    "whatsapp.connect.description": "Saisissez le numéro professionnel que vos clients connaissent. Meta ouvrira une fenêtre de vérification sécurisée ; vous n’avez pas besoin de rechercher un ID WABA, un ID de numéro, un jeton d’accès ou un paramètre d’API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Saisissez le numéro professionnel que vos clients connaissent. Meta ouvrira une fenêtre de vérification sécurisée ; vous n’avez pas besoin de rechercher un ID WABA, un ID de numéro, un jeton d’accès ou un paramètre d’API.",
    "whatsapp.field.business_number": "Numéro WhatsApp professionnel",
    "Business WhatsApp number": "Numéro WhatsApp professionnel",
    "whatsapp.field.business_number_help": "Utilisez le numéro auquel vos clients doivent écrire, avec l’indicatif du pays.",
    "Use the number you want customers to message, including country code.": "Utilisez le numéro auquel vos clients doivent écrire, avec l’indicatif du pays.",
    "whatsapp.placeholder.business_number": "ex. +60 13 333 1671",
    "e.g. +60 13 333 1671": "ex. +60 13 333 1671",
    "whatsapp.field.connection_name": "Nom de la connexion",
    "whatsapp.field.connection_name_help": "Utilisez un nom explicite, comme Kuala Lumpur, Marque de vente ou Assistance.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Utilisez un nom explicite, comme Kuala Lumpur, Marque de vente ou Assistance.",
    "whatsapp.placeholder.connection_name": "ex. Assistance Kuala Lumpur",
    "e.g. Kuala Lumpur support": "ex. Assistance Kuala Lumpur",
    "whatsapp.field.optional_details": "Détails facultatifs de la connexion",
    "Optional connection details": "Détails facultatifs de la connexion",
    "whatsapp.field.optional_details_help": "Renseignez ces champs uniquement si ce numéro appartient à une marque, un compte ou une agence précise.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Renseignez ces champs uniquement si ce numéro appartient à une marque, un compte ou une agence précise.",
    "whatsapp.field.brand_key": "Clé de marque",
    "Brand key": "Clé de marque",
    "whatsapp.field.brand_key_help": "Clé interne stable d’une marque, par exemple vente au détail ou gros.",
    "Stable internal key for a brand, such as retail or wholesale.": "Clé interne stable d’une marque, par exemple vente au détail ou gros.",
    "whatsapp.placeholder.brand_key": "ex. retail",
    "e.g. retail": "ex. retail",
    "whatsapp.field.account_id": "ID du compte",
    "whatsapp.field.account_id_help": "Associez ce numéro à un compte Tradly existant.",
    "Associate this number with an existing Tradly account.": "Associez ce numéro à un compte Tradly existant.",
    "whatsapp.placeholder.account_id": "ex. 123",
    "e.g. 123": "ex. 123",
    "whatsapp.field.branch_id": "ID de l’agence",
    "Branch ID": "ID de l’agence",
    "whatsapp.field.branch_id_help": "Associez ce numéro à une agence Tradly existante.",
    "Associate this number with an existing Tradly branch.": "Associez ce numéro à une agence Tradly existante.",
    "whatsapp.placeholder.branch_id": "ex. 456",
    "e.g. 456": "ex. 456",
    "whatsapp.field.default_connection": "Utiliser comme connexion par défaut",
    "Use as default connection": "Utiliser comme connexion par défaut",
    "whatsapp.field.default_connection_help": "Les anciens parcours OTP utilisent cette connexion par défaut lorsqu’aucune connexion d’agence n’est sélectionnée.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Les anciens parcours OTP utilisent cette connexion par défaut lorsqu’aucune connexion d’agence n’est sélectionnée.",
    "whatsapp.field.uses_business_app": "J’utilise l’application WhatsApp Business sur ce numéro",
    "I use the WhatsApp Business app on this number": "J’utilise l’application WhatsApp Business sur ce numéro",
    "whatsapp.field.uses_business_app_help": "Continuez à discuter dans l’application WhatsApp Business sur votre téléphone. Meta vous demandera de scanner un QR code depuis l’application, et vos contacts et discussions récentes seront synchronisés. Version 2.24.17 ou ultérieure requise.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Continuez à discuter dans l’application WhatsApp Business sur votre téléphone. Meta vous demandera de scanner un QR code depuis l’application, et vos contacts et discussions récentes seront synchronisés. Version 2.24.17 ou ultérieure requise.",
    "whatsapp.connected.business_account": "Compte WhatsApp professionnel",
    "WhatsApp business account": "Compte WhatsApp professionnel",
    "whatsapp.connected.template_ready": "Modèle d’authentification prêt · Les OTP automatiques peuvent utiliser WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Modèle d’authentification prêt · Les OTP automatiques peuvent utiliser WhatsApp.",
    "whatsapp.connected.template_pending": "Connecté · Les SMS restent le secours pendant l’approbation du modèle d’authentification.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Connecté · Les SMS restent le secours pendant l’approbation du modèle d’authentification.",
    "whatsapp.action.connect": "Connecter WhatsApp",
    "Connect WhatsApp": "Connecter WhatsApp",
    "whatsapp.action.reconnect": "Reconnecter WhatsApp",
    "Reconnect WhatsApp": "Reconnecter WhatsApp",
    "whatsapp.connections.title": "Numéros WhatsApp connectés",
    "Connected WhatsApp numbers": "Numéros WhatsApp connectés",
    "whatsapp.connections.description": "Chaque numéro peut appartenir à une marque, un compte ou une agence différente. Sélectionnez-en un avant d’activer les modèles.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Chaque numéro peut appartenir à une marque, un compte ou une agence différente. Sélectionnez-en un avant d’activer les modèles.",
    "whatsapp.connections.unnamed": "Connexion WhatsApp",
    "WhatsApp connection": "Connexion WhatsApp",
    "whatsapp.connections.default": "Par défaut",
    "whatsapp.connections.account": "Compte {id}",
    "Account {id}": "Compte {id}",
    "whatsapp.connections.branch": "Agence {id}",
    "Branch {id}": "Agence {id}",
    "whatsapp.connections.tenant_wide": "Connexion au niveau du tenant",
    "Tenant-wide connection": "Connexion au niveau du tenant",
    "whatsapp.action.make_default": "Définir par défaut",
    "Make default": "Définir par défaut",
    "whatsapp.notice.default_updated": "Connexion WhatsApp par défaut mise à jour.",
    "Default WhatsApp connection updated.": "Connexion WhatsApp par défaut mise à jour.",
    "whatsapp.error.default_update": "Impossible de modifier la connexion par défaut.",
    "Unable to change the default connection.": "Impossible de modifier la connexion par défaut.",
    "whatsapp.templates.title": "Modèles de messages",
    "Message templates": "Modèles de messages",
    "whatsapp.templates.description": "Choisissez un modèle prêt à l’emploi. Tradly l’envoie à Meta pour approbation et l’active automatiquement une fois approuvé.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Choisissez un modèle prêt à l’emploi. Tradly l’envoie à Meta pour approbation et l’active automatiquement une fois approuvé.",
    "whatsapp.template.status.not_activated": "Non activé",
    "Not activated": "Non activé",
    "whatsapp.template.status.approved": "Approuvé",
    "whatsapp.template.status.pending": "En attente",
    "whatsapp.template.status.submitted": "Envoyé",
    "Submitted": "Envoyé",
    "whatsapp.template.action.active": "Actif",
    "whatsapp.template.action.submitted": "Envoyé",
    "whatsapp.template.action.activate": "Activer le modèle",
    "Activate template": "Activer le modèle",
    "whatsapp.notice.template_active": "{name} est approuvé et actif.",
    "{name} is approved and active.": "{name} est approuvé et actif.",
    "whatsapp.notice.template_submitted": "{name} a été envoyé à Meta pour examen. Vous pouvez continuer à utiliser les SMS jusqu’à son approbation.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} a été envoyé à Meta pour examen. Vous pouvez continuer à utiliser les SMS jusqu’à son approbation.",
    "whatsapp.channel.title": "Canal de livraison",
    "Delivery channel": "Canal de livraison",
    "whatsapp.channel.help": "L’interrupteur active WhatsApp pour votre entreprise. Les codes de connexion peuvent partir par SMS uniquement, WhatsApp uniquement, ou SMS avec WhatsApp en secours ; les options WhatsApp nécessitent un modèle de code approuvé.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "L’interrupteur active WhatsApp pour votre entreprise. Les codes de connexion peuvent partir par SMS uniquement, WhatsApp uniquement, ou SMS avec WhatsApp en secours ; les options WhatsApp nécessitent un modèle de code approuvé.",
    "whatsapp.channel.primary_otp": "Canal OTP principal",
    "Primary OTP channel": "Canal OTP principal",
    "whatsapp.channel.sms_description": "Conserver le canal SMS existant.",
    "Keep the existing SMS delivery path.": "Conserver le canal SMS existant.",
    "whatsapp.channel.whatsapp_description": "Utiliser l’API Cloud Meta pour ce tenant.",
    "Use Meta Cloud API for this tenant.": "Utiliser l’API Cloud Meta pour ce tenant.",
    "whatsapp.channel.automatic": "Automatique",
    "Automatic": "Automatique",
    "whatsapp.channel.automatic_description": "Utiliser WhatsApp si configuré, sinon les SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Utiliser WhatsApp si configuré, sinon les SMS.",
    "whatsapp.channel.fallback": "Secours après échec de WhatsApp",
    "Fallback after WhatsApp failure": "Secours après échec de WhatsApp",
    "whatsapp.channel.no_fallback": "Aucun secours",
    "No fallback": "Aucun secours",
    "whatsapp.channel.no_fallback_description": "Renvoyer le résultat de livraison configuré.",
    "Return the configured delivery result.": "Renvoyer le résultat de livraison configuré.",
    "whatsapp.channel.sms_fallback_description": "Essayer les SMS avec le même code OTP.",
    "Try SMS with the same OTP code.": "Essayer les SMS avec le même code OTP.",
    "whatsapp.channel.sms_only": "SMS uniquement",
    "SMS only": "SMS uniquement",
    "whatsapp.channel.sms_only_description": "Les codes sont envoyés par SMS.",
    "Codes are sent by text message.": "Les codes sont envoyés par SMS.",
    "whatsapp.channel.whatsapp_only": "WhatsApp uniquement",
    "WhatsApp only": "WhatsApp uniquement",
    "whatsapp.channel.whatsapp_only_description": "Les codes sont envoyés depuis votre numéro WhatsApp.",
    "Codes are sent from your WhatsApp number.": "Les codes sont envoyés depuis votre numéro WhatsApp.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp en secours",
    "SMS, WhatsApp as backup": "SMS, WhatsApp en secours",
    "whatsapp.channel.sms_whatsapp_description": "Les codes partent par SMS ; en cas d’échec, le même code est envoyé sur WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Les codes partent par SMS ; en cas d’échec, le même code est envoyé sur WhatsApp.",
    "whatsapp.advanced.title": "Paramètres de récupération technique",
    "Technical recovery settings": "Paramètres de récupération technique",
    "whatsapp.advanced.description": "Réservé à l’assistance de la plateforme. La plupart des entreprises doivent utiliser la connexion WhatsApp ci-dessus.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Réservé à l’assistance de la plateforme. La plupart des entreprises doivent utiliser la connexion WhatsApp ci-dessus.",
    "whatsapp.field.phone_number_id": "ID du numéro de téléphone WhatsApp",
    "WhatsApp phone number ID": "ID du numéro de téléphone WhatsApp",
    "whatsapp.field.phone_number_id_help": "ID du numéro associé à votre compte WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "ID du numéro associé à votre compte WhatsApp Business.",
    "whatsapp.field.waba_id": "ID du compte WhatsApp Business",
    "WhatsApp Business Account ID": "ID du compte WhatsApp Business",
    "whatsapp.field.waba_id_help": "Affiché à côté de l’ID du numéro dans Meta (WhatsApp > Configuration de l’API). Nécessaire pour les modèles et les messages test.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Affiché à côté de l’ID du numéro dans Meta (WhatsApp > Configuration de l’API). Nécessaire pour les modèles et les messages test.",
    "whatsapp.placeholder.phone_number_id": "ex. 123456789012345",
    "e.g. 123456789012345": "ex. 123456789012345",
    "whatsapp.field.access_token": "Jeton d’accès Meta",
    "Meta access token": "Jeton d’accès Meta",
    "whatsapp.field.access_token_saved_help": "Enregistré de façon sécurisée sur le serveur. Laissez vide pour le conserver ou collez un nouveau jeton pour le remplacer.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Enregistré de façon sécurisée sur le serveur. Laissez vide pour le conserver ou collez un nouveau jeton pour le remplacer.",
    "whatsapp.field.access_token_help": "Utilisez un jeton utilisateur système autorisé à envoyer des messages WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Utilisez un jeton utilisateur système autorisé à envoyer des messages WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Enregistré de façon sécurisée · laisser vide pour conserver",
    "Saved securely · leave blank to keep": "Enregistré de façon sécurisée · laisser vide pour conserver",
    "whatsapp.placeholder.access_token": "Collez le jeton",
    "Paste token": "Collez le jeton",
    "whatsapp.token.saved": "Jeton d’accès Meta enregistré de façon sécurisée",
    "Meta access token saved securely": "Jeton d’accès Meta enregistré de façon sécurisée",
    "whatsapp.field.otp_template": "Nom du modèle OTP approuvé",
    "Approved OTP template name": "Nom du modèle OTP approuvé",
    "whatsapp.field.otp_template_help": "Le corps du modèle doit accepter le code OTP comme un paramètre texte.",
    "The template body must accept the OTP as one text parameter.": "Le corps du modèle doit accepter le code OTP comme un paramètre texte.",
    "whatsapp.placeholder.otp_template": "ex. login_verification",
    "e.g. login_verification": "ex. login_verification",
    "whatsapp.field.template_language": "Langue du modèle",
    "Template language": "Langue du modèle",
    "whatsapp.field.marketing_template": "Nom du modèle marketing approuvé (facultatif)",
    "Approved marketing template name (optional)": "Nom du modèle marketing approuvé (facultatif)",
    "whatsapp.field.marketing_template_help": "Utilisez un modèle marketing Meta approuvé. Une campagne peut remplacer ce nom dans content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Utilisez un modèle marketing Meta approuvé. Une campagne peut remplacer ce nom dans content.template_name.",
    "whatsapp.placeholder.marketing_template": "ex. monthly_offer",
    "e.g. monthly_offer": "ex. monthly_offer",
    "whatsapp.field.marketing_language": "Langue du modèle marketing",
    "Marketing template language": "Langue du modèle marketing",
    "whatsapp.info.title": "Avant d’activer WhatsApp",
    "Before enabling WhatsApp": "Avant d’activer WhatsApp",
    "whatsapp.info.description": "Meta doit approuver chaque modèle OTP ou marketing avant son envoi. Le contenu WhatsApp des campagnes utilise template_name, template_language et des paramètres de corps facultatifs ; les numéros doivent respecter le format E.164. Si le secours automatique est activé, ArcticOwl réessaie par SMS avec le même code OTP.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta doit approuver chaque modèle OTP ou marketing avant son envoi. Le contenu WhatsApp des campagnes utilise template_name, template_language et des paramètres de corps facultatifs ; les numéros doivent respecter le format E.164. Si le secours automatique est activé, ArcticOwl réessaie par SMS avec le même code OTP.",
    "whatsapp.action.hide_token": "Masquer le jeton d’accès Meta",
    "Hide Meta access token": "Masquer le jeton d’accès Meta",
    "whatsapp.action.show_token": "Afficher le jeton d’accès Meta",
    "Show Meta access token": "Afficher le jeton d’accès Meta",
    "whatsapp.error.generic": "Impossible d’enregistrer les paramètres WhatsApp.",
    "Unable to save WhatsApp settings.": "Impossible d’enregistrer les paramètres WhatsApp.",
    "whatsapp.error.browser_required": "La connexion WhatsApp est disponible uniquement dans un navigateur.",
    "WhatsApp connection is only available in a browser.": "La connexion WhatsApp est disponible uniquement dans un navigateur.",
    "whatsapp.error.meta_load": "Meta n’a pas pu se charger. Vérifiez les paramètres de confidentialité du navigateur et réessayez.",
    "Meta could not load. Check the browser privacy settings and try again.": "Meta n’a pas pu se charger. Vérifiez les paramètres de confidentialité du navigateur et réessayez.",
    "whatsapp.error.load": "Impossible de charger les paramètres WhatsApp.",
    "Unable to load WhatsApp settings.": "Impossible de charger les paramètres WhatsApp.",
    "whatsapp.error.connect_before_template": "Connectez WhatsApp avant d’activer un modèle.",
    "Connect WhatsApp before activating a template.": "Connectez WhatsApp avant d’activer un modèle.",
    "whatsapp.error.template_submit": "Impossible d’envoyer le modèle WhatsApp.",
    "Unable to submit the WhatsApp template.": "Impossible d’envoyer le modèle WhatsApp.",
    "whatsapp.error.business_number_required": "Saisissez le numéro WhatsApp professionnel avant la connexion. Meta le vérifiera à l’étape suivante.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Saisissez le numéro WhatsApp professionnel avant la connexion. Meta le vérifiera à l’étape suivante.",
    "whatsapp.error.signup_not_ready": "La connexion WhatsApp est en cours de préparation par la plateforme. Réessayez dans quelques instants.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "La connexion WhatsApp est en cours de préparation par la plateforme. Réessayez dans quelques instants.",
    "whatsapp.error.signup_cancelled": "La connexion Meta a été annulée ou n’a pas renvoyé de code d’autorisation.",
    "Meta connection was cancelled or did not return an authorization code.": "La connexion Meta a été annulée ou n’a pas renvoyé de code d’autorisation.",
    "whatsapp.error.phone_number_missing": "Meta n’a pas renvoyé le numéro WhatsApp professionnel sélectionné. Réessayez la connexion.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta n’a pas renvoyé le numéro WhatsApp professionnel sélectionné. Réessayez la connexion.",
    "whatsapp.notice.connected_auto": "WhatsApp est connecté. Les OTP automatiques utiliseront d’abord WhatsApp, puis les SMS en cas d’échec.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp est connecté. Les OTP automatiques utiliseront d’abord WhatsApp, puis les SMS en cas d’échec.",
    "whatsapp.notice.connected_sms": "WhatsApp est connecté. Les SMS restent actifs jusqu’à l’approbation d’un modèle d’authentification par Meta.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp est connecté. Les SMS restent actifs jusqu’à l’approbation d’un modèle d’authentification par Meta.",
    "whatsapp.error.connect": "Impossible de connecter WhatsApp.",
    "Unable to connect WhatsApp.": "Impossible de connecter WhatsApp.",
    "whatsapp.error.otp_configuration": "Les OTP WhatsApp ou automatiques nécessitent un ID de numéro, un nom de modèle OTP approuvé et un jeton d’accès Meta. Pour le marketing uniquement, choisissez les SMS comme canal OTP principal et laissez le connecteur activé.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "Les OTP WhatsApp ou automatiques nécessitent un ID de numéro, un nom de modèle OTP approuvé et un jeton d’accès Meta. Pour le marketing uniquement, choisissez les SMS comme canal OTP principal et laissez le connecteur activé.",
    "whatsapp.notice.saved": "Paramètres du connecteur WhatsApp enregistrés pour ce tenant.",
    "WhatsApp connector settings saved for this tenant.": "Paramètres du connecteur WhatsApp enregistrés pour ce tenant.",
    "whatsapp.error.save": "Impossible d’enregistrer les paramètres WhatsApp.",
    "whatsapp.notice.discarded": "Brouillon supprimé.",
    "Draft discarded.": "Brouillon supprimé.",
    "whatsapp.test.title": "Envoyer un message test",
    "Send a test message": "Envoyer un message test",
    "whatsapp.test.description": "Envoyez un modèle approuvé à un numéro WhatsApp pour vérifier que votre connexion fonctionne.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Envoyez un modèle approuvé à un numéro WhatsApp pour vérifier que votre connexion fonctionne.",
    "whatsapp.test.refresh": "Actualiser les modèles",
    "Refresh templates": "Actualiser les modèles",
    "whatsapp.test.field.template": "Modèle approuvé",
    "Approved template": "Modèle approuvé",
    "whatsapp.test.field.parameter": "Valeur pour {{{number}}}",
    "Value for {{{number}}}": "Valeur pour {{{number}}}",
    "whatsapp.test.field.mobile": "Envoyer à",
    "Send to": "Envoyer à",
    "whatsapp.test.field.mobile_help": "Numéro WhatsApp avec l’indicatif du pays.",
    "WhatsApp number with country code.": "Numéro WhatsApp avec l’indicatif du pays.",
    "whatsapp.test.action.send": "Envoyer le message test",
    "Send test message": "Envoyer le message test",
    "whatsapp.test.sent": "Envoyé à {mobile}. ID du message Meta : {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Envoyé à {mobile}. ID du message Meta : {id}",
    "whatsapp.test.no_templates": "Aucun modèle approuvé pour le moment. Activez un modèle ci-dessus et envoyez-le une fois approuvé par Meta.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Aucun modèle approuvé pour le moment. Activez un modèle ci-dessus et envoyez-le une fois approuvé par Meta.",
    "common.discard_draft": "Supprimer le brouillon",
    "common.status.connected": "Connecté",
    "Connected": "Connecté",
    "extensions.title": "Extensions",
    "extensions.action.add": "Ajouter une extension",
    "Add Extension": "Ajouter une extension",
    "extensions.action.add_new": "Ajouter une nouvelle extension",
    "Add New Extension": "Ajouter une nouvelle extension",
    "extensions.action.edit": "Modifier l’extension",
    "Edit Extension": "Modifier l’extension",
    "extensions.action.delete": "Supprimer l’extension",
    "Delete extension": "Supprimer l’extension",
    "extensions.field.name": "Nom",
    "extensions.field.domain": "Domaine",
    "extensions.field.configs": "Configuration",
    "Configs": "Configuration",
    "extensions.placeholder.name": "Nom de l’extension",
    "Extension Name": "Nom de l’extension",
    "extensions.placeholder.domain": "Domaine de l’extension",
    "Extension Domain": "Domaine de l’extension",
    "extensions.empty": "Aucune extension configurée pour le moment.",
    "No extensions configured yet.": "Aucune extension configurée pour le moment.",
    "extensions.toast.added": "Extension ajoutée avec succès.",
    "Extension added successfully.": "Extension ajoutée avec succès.",
    "extensions.toast.updated": "Extension mise à jour avec succès.",
    "Extension updated successfully.": "Extension mise à jour avec succès.",
    "extensions.toast.deleted": "Extension supprimée avec succès.",
    "Extension deleted successfully.": "Extension supprimée avec succès.",
    "extensions.error.name_required": "Le nom est obligatoire",
    "extensions.error.domain_required": "Le domaine est obligatoire",
    "Domain is required": "Le domaine est obligatoire",
    "extensions.error.configs_required": "La configuration est obligatoire",
    "Configs is required": "La configuration est obligatoire",
    "extensions.error.save_failed": "Impossible d’enregistrer l’extension.",
    "Unable to save the extension.": "Impossible d’enregistrer l’extension.",
    "extensions.error.delete_failed": "Impossible de supprimer l’extension.",
    "Unable to delete the extension.": "Impossible de supprimer l’extension.",
    "automation_rules.kicker": "Automatisation des opérations",
    "Operations automation": "Automatisation des opérations",
    "automation_rules.title": "Règles d’automatisation",
    "Automation rules": "Règles d’automatisation",
    "automation_rules.description": "Transformez les événements du personnel et des dépenses en étapes claires d’approbation et de vérification.",
    "Turn staff and expense events into clear approval and review steps.": "Transformez les événements du personnel et des dépenses en étapes claires d’approbation et de vérification.",
    "automation_rules.action.new_rule": "Nouvelle règle",
    "New rule": "Nouvelle règle",
    "automation_rules.action.create_rule": "Créer la règle",
    "Create rule": "Créer la règle",
    "automation_rules.action.create_help": "Enregistrer ce déclencheur, ses conditions et son action comme règle",
    "Save this trigger, conditions, and action as a rule": "Enregistrer ce déclencheur, ses conditions et son action comme règle",
    "automation_rules.action.add_condition": "Ajouter une condition",
    "Add condition": "Ajouter une condition",
    "automation_rules.action.add_condition_help": "Ajouter une autre condition à cette règle",
    "Add another condition to this rule": "Ajouter une autre condition à cette règle",
    "automation_rules.action.remove_condition": "Supprimer la condition",
    "Remove condition": "Supprimer la condition",
    "automation_rules.action.choose": "Choisir une action",
    "Choose an action": "Choisir une action",
    "automation_rules.action.require_second_approver": "Exiger un deuxième approbateur",
    "Require second approver": "Exiger un deuxième approbateur",
    "automation_rules.action.require_second_approver_help": "Transmettre la demande à un autre approbateur.",
    "Route the claim to another approver.": "Transmettre la demande à un autre approbateur.",
    "automation_rules.action.auto_reject_expense": "Rejeter automatiquement la dépense",
    "Auto-reject expense": "Rejeter automatiquement la dépense",
    "automation_rules.action.auto_reject_expense_help": "Rejeter la dépense en indiquant un motif.",
    "Reject the expense with a reason.": "Rejeter la dépense en indiquant un motif.",
    "automation_rules.action.notify_role": "Notifier un rôle",
    "Notify a role": "Notifier un rôle",
    "automation_rules.action.notify_role_help": "Envoyer une notification à un rôle du personnel.",
    "Send a notification to a staff role.": "Envoyer une notification à un rôle du personnel.",
    "automation_rules.action.flag_for_review": "Signaler pour vérification",
    "Flag for review": "Signaler pour vérification",
    "automation_rules.action.flag_for_review_help": "Marquer une ressource pour vérification manuelle.",
    "Mark a resource for manual review.": "Marquer une ressource pour vérification manuelle.",
    "automation_rules.field.rule_name": "Nom de la règle",
    "Rule name": "Nom de la règle",
    "automation_rules.field.priority": "Priorité",
    "automation_rules.field.module": "Module",
    "Module": "Module",
    "automation_rules.field.event": "Événement",
    "automation_rules.field.field": "Champ",
    "Field": "Champ",
    "automation_rules.field.operator": "Opérateur",
    "Operator": "Opérateur",
    "automation_rules.field.value": "Valeur",
    "automation_rules.field.action": "Action",
    "automation_rules.field.action_params": "Paramètres de l’action",
    "Action parameters": "Paramètres de l’action",
    "automation_rules.placeholder.rule_name": "Exiger un deuxième approbateur pour les demandes importantes",
    "Require second approver for large claims": "Exiger un deuxième approbateur pour les demandes importantes",
    "automation_rules.placeholder.field": "montant",
    "amount": "montant",
    "automation_rules.placeholder.value": "500 ou false",
    "500 or false": "500 ou false",
    "automation_rules.builder.description": "Définissez ci-dessous le déclencheur, les conditions et l’action, puis enregistrez-les dans une règle.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Définissez ci-dessous le déclencheur, les conditions et l’action, puis enregistrez-les dans une règle.",
    "automation_rules.error.load": "Impossible de charger les règles d’automatisation.",
    "Unable to load automation rules.": "Impossible de charger les règles d’automatisation.",
    "automation_rules.error.required_fields": "Le nom, le module, l’événement et l’action sont obligatoires.",
    "Name, module, event, and action are required.": "Le nom, le module, l’événement et l’action sont obligatoires.",
    "automation_rules.error.create": "Impossible de créer la règle d’automatisation.",
    "Unable to create automation rule.": "Impossible de créer la règle d’automatisation.",
    "automation_rules.error.valid_json": "Saisissez un JSON valide avant d’enregistrer.",
    "Use valid JSON before saving.": "Saisissez un JSON valide avant d’enregistrer.",
    "automation_rules.notice.created": "Règle d’automatisation créée.",
    "Automation rule created.": "Règle d’automatisation créée.",
    "automation_rules.notice.discarded": "Brouillon supprimé.",
    "automation_rules.draft.restored": "Votre brouillon de règle d’automatisation non enregistré a été restauré.",
    "Your unsaved automation rule draft was restored.": "Votre brouillon de règle d’automatisation non enregistré a été restauré.",
    "automation_rules.list.title": "Règles",
    "automation_rules.list.count": "{count} configurée(s)",
    "{count} configured": "{count} configurée(s)",
    "automation_rules.list.loading": "Chargement des règles…",
    "Loading rules…": "Chargement des règles…",
    "automation_rules.list.unnamed": "Règle sans nom",
    "Unnamed rule": "Règle sans nom",
    "automation_rules.list.no_action": "Aucune action configurée",
    "No action configured": "Aucune action configurée",
    "automation_rules.list.empty": "Aucune règle. Créez la première à partir du diagramme.",
    "No rules yet. Create the first one from the diagram.": "Aucune règle. Créez la première à partir du diagramme.",
    "automation_rules.status.draft": "Brouillon",
    "automation_rules.status.active": "Active",
    "automation_rules.inspector.title": "Paramètres du bloc",
    "Block settings": "Paramètres du bloc",
    "automation_rules.inspector.diagram": "Diagramme",
    "Diagram": "Diagramme",
    "automation_rules.inspector.select_block": "Sélectionnez un bloc du diagramme pour le configurer.",
    "Select a block on the diagram to configure it.": "Sélectionnez un bloc du diagramme pour le configurer.",
    "automation_rules.inspector.no_configuration": "Ce bloc ne nécessite aucune configuration.",
    "This block does not need configuration.": "Ce bloc ne nécessite aucune configuration.",
    "automation_rules.node.trigger": "Déclencheur",
    "automation_rules.node.condition": "Condition",
    "automation_rules.node.action": "Action",
    "automation_rules.node.end": "Fin",
    "automation_rules.node.completed": "Terminé",
    "automation_rules.node.finished": "Évaluation de la règle terminée",
    "Rule evaluation finished": "Évaluation de la règle terminée",
    "automation_rules.trigger.choose_event": "Choisir un événement",
    "Choose an event": "Choisir un événement",
    "automation_rules.trigger.module": "module",
    "module": "module",
    "automation_rules.trigger.module_event": "Événement du module {module}",
    "{module} event": "Événement du module {module}",
    "automation_rules.trigger.help": "La règle est évaluée lorsque le module émet cet événement.",
    "The rule evaluates when this event is emitted by the module.": "La règle est évaluée lorsque le module émet cet événement.",
    "automation_rules.condition.label": "Condition",
    "automation_rules.condition.none": "Aucune condition",
    "No conditions": "Aucune condition",
    "automation_rules.condition.always_fires": "Toujours déclenchée",
    "Always fires": "Toujours déclenchée",
    "automation_rules.condition.empty_help": "Ajoutez une condition pour limiter cette règle.",
    "Add a condition to restrict this rule.": "Ajoutez une condition pour limiter cette règle.",
    "automation_rules.condition.value_required": "Valeur requise",
    "Value required": "Valeur requise",
    "automation_rules.condition.value": "Valeur : {value}",
    "Value: {value}": "Valeur : {value}",
    "automation_rules.operator.equals": "Égal à",
    "Equals": "Égal à",
    "automation_rules.operator.gt": "Supérieur à",
    "Greater than": "Supérieur à",
    "automation_rules.operator.gte": "Supérieur ou égal à",
    "Greater than or equal": "Supérieur ou égal à",
    "automation_rules.operator.lt": "Inférieur à",
    "Less than": "Inférieur à",
    "automation_rules.operator.exists": "Existe",
    "Exists": "Existe",
    "automation_rules.module.expenses": "Dépenses",
    "automation_rules.module.staff": "Personnel",
    "automation_rules.event.expense.submitted": "Dépense soumise",
    "automation_rules.event.leave.requested": "Congé demandé",
    "Leave requested": "Congé demandé",
    "automation_rules.event.payroll_run.created": "Paie créée",
    "automation_rules.meta.conditions": "{count} condition(s) · toutes doivent correspondre avant l’action",
    "{count} condition(s) · all must match before the action runs": "{count} condition(s) · toutes doivent correspondre avant l’action",
    "automation_rules.meta.no_conditions": "Aucune condition · l’action s’exécute toujours après le déclencheur",
    "No conditions · the action always runs after the trigger": "Aucune condition · l’action s’exécute toujours après le déclencheur",
    "automation_rules.draft.unsaved": "Vous avez un brouillon de règle d’automatisation non enregistré.",
    "You have an unsaved automation rule draft.": "Vous avez un brouillon de règle d’automatisation non enregistré.",
    "automation_rules.meta.one_condition": "1 condition · elle doit correspondre avant l’action",
    "1 condition · all must match before the action runs": "1 condition · elle doit correspondre avant l’action",
    "automation_rules.meta.many_conditions": "{count} conditions · toutes doivent correspondre avant l’action",
    "{count} conditions · all must match before the action runs": "{count} conditions · toutes doivent correspondre avant l’action",
    "cms.type.page": "Page",
    "Page": "Page",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Documentation",
    "Docs": "Documentation",
    "cms.type.pages": "Pages",
    "cms.type.blogs": "Blogs",
    "Blogs": "Blogs",
    "cms.action.add_content": "Ajouter du contenu",
    "Add content": "Ajouter du contenu",
    "cms.action.add_type": "Ajouter : {type}",
    "cms.action.create_type": "Créer : {type}",
    "Create {type}": "Créer : {type}",
    "cms.action.edit": "Modifier",
    "cms.action.duplicate": "Dupliquer",
    "Duplicate": "Dupliquer",
    "cms.action.open": "Ouvrir",
    "cms.field.title": "Titre",
    "cms.field.slug": "Slug",
    "cms.field.content": "Contenu",
    "cms.field.meta_title": "Titre méta",
    "cms.field.meta_description": "Description méta",
    "cms.placeholder.title": "ex. À propos",
    "e.g. About us": "ex. À propos",
    "cms.placeholder.slug": "a-propos",
    "about-us": "a-propos",
    "cms.placeholder.page_title": "Titre de la page",
    "Page title": "Titre de la page",
    "cms.placeholder.page_slug": "slug-de-page",
    "page-slug": "slug-de-page",
    "cms.placeholder.content": "Rédigez votre contenu ici…",
    "Write your content here…": "Rédigez votre contenu ici…",
    "cms.placeholder.meta_title": "Par défaut, le titre",
    "Defaults to title": "Par défaut, le titre",
    "cms.placeholder.meta_description": "Brève description pour les moteurs de recherche",
    "Short description for search engines": "Brève description pour les moteurs de recherche",
    "cms.section.seo_optional": "Référencement (facultatif)",
    "SEO (optional)": "Référencement (facultatif)",
    "cms.error.title_required": "Le titre est obligatoire.",
    "Title is required.": "Le titre est obligatoire.",
    "cms.error.content_required": "Ajoutez du contenu avant d’enregistrer.",
    "Add some content before saving.": "Ajoutez du contenu avant d’enregistrer.",
    "cms.error.create": "Échec de la création. Réessayez.",
    "Failed to create. Please try again.": "Échec de la création. Réessayez.",
    "cms.error.save": "Échec de l’enregistrement.",
    "Failed to save.": "Échec de l’enregistrement.",
    "cms.error.load_layer": "Impossible de charger ce contenu.",
    "Could not load this layer.": "Impossible de charger ce contenu.",
    "cms.toast.created": "{type} créé avec succès.",
    "{type} created successfully.": "{type} créé avec succès.",
    "cms.toast.saved": "Enregistré",
    "Saved": "Enregistré",
    "cms.toast.changes_saved": "Modifications enregistrées.",
    "Changes saved.": "Modifications enregistrées.",
    "cms.toast.deleted": "Supprimé",
    "cms.toast.duplicated": "Dupliqué",
    "Duplicated": "Dupliqué",
    "cms.error.delete": "Échec de la suppression",
    "Failed to delete": "Échec de la suppression",
    "cms.error.duplicate": "Échec de la duplication",
    "Failed to duplicate": "Échec de la duplication",
    "cms.confirm.delete": "Supprimer « {title} » ?",
    "Delete \"{title}\"?": "Supprimer « {title} » ?",
    "cms.duplicate.title": "{title} (copie)",
    "{title} (copy)": "{title} (copie)",
    "cms.draft.restored": "Votre brouillon de contenu non enregistré a été restauré.",
    "Your unsaved content draft was restored.": "Votre brouillon de contenu non enregistré a été restauré.",
    "cms.search": "Rechercher…",
    "Search…": "Rechercher…",
    "cms.list.no_results": "Aucun résultat.",
    "No results found.": "Aucun résultat.",
    "cms.list.empty_type": "Aucun contenu de type {type} pour le moment.",
    "No {type} yet.": "Aucun contenu de type {type} pour le moment.",
    "cms.list.untitled": "Sans titre",
    "Untitled": "Sans titre",
    "cms.editor.placeholder": "Rédigez votre contenu ici…",
    "cms.editor.normal_text": "Texte normal",
    "Normal text": "Texte normal",
    "cms.editor.heading": "Titre {level}",
    "Heading {level}": "Titre {level}",
    "cms.editor.align_left": "Aligner à gauche",
    "Align Left": "Aligner à gauche",
    "cms.editor.align_center": "Centrer",
    "Align Center": "Centrer",
    "cms.editor.align_right": "Aligner à droite",
    "Align Right": "Aligner à droite",
    "cms.editor.insert_table": "Insérer un tableau",
    "Insert table": "Insérer un tableau",
    "cms.editor.add_column": "Ajouter une colonne",
    "Add column": "Ajouter une colonne",
    "cms.editor.add_row": "Ajouter une ligne",
    "Add row": "Ajouter une ligne",
    "cms.editor.delete_table": "Supprimer le tableau",
    "Delete table": "Supprimer le tableau",
    "cms.editor.delete_column": "Supprimer la colonne",
    "Delete column": "Supprimer la colonne",
    "cms.editor.delete_row": "Supprimer la ligne",
    "Delete row": "Supprimer la ligne",
    "cms.editor.underline": "Souligner",
    "Underline": "Souligner",
    "cms.editor.strikethrough": "Barré",
    "Strikethrough": "Barré",
    "cms.editor.code": "Code",
    "cms.editor.code_block": "Bloc de code",
    "Code block": "Bloc de code",
    "cms.editor.subscript": "Indice",
    "Subscript": "Indice",
    "cms.editor.superscript": "Exposant",
    "Superscript": "Exposant",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL de l’image",
    "Image URL": "URL de l’image",
    "cms.editor.prompt.youtube_url": "URL YouTube",
    "YouTube URL": "URL YouTube",
    "cms.editor.undo": "Annuler",
    "cms.editor.redo": "Rétablir",
    "cms.editor.table": "Tableau",
    "Table": "Tableau",
    "cms.editor.more": "Plus",
    "cms.editor.bold": "Gras",
    "Bold": "Gras",
    "cms.editor.italic": "Italique",
    "Italic": "Italique",
    "cms.editor.bullet_list": "Liste à puces",
    "Bullet list": "Liste à puces",
    "cms.editor.ordered_list": "Liste numérotée",
    "Ordered list": "Liste numérotée",
    "cms.editor.task_list": "Liste de tâches",
    "Task list": "Liste de tâches",
    "cms.editor.link": "Lien",
    "Link": "Lien",
    "cms.editor.image": "Image",
    "cms.editor.text_color": "Couleur du texte",
    "Text color": "Couleur du texte",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Pages",
    "cms.test.type.pages_description": "Pages d’accueil et contenu structuré de la boutique.",
    "Landing pages and structured storefront content.": "Pages d’accueil et contenu structuré de la boutique.",
    "cms.test.type.blogs": "Blogs",
    "cms.test.type.blogs_description": "Articles, récits et actualités pour votre audience.",
    "Articles, stories, and updates for your audience.": "Articles, récits et actualités pour votre audience.",
    "cms.test.type.docs": "Documentation",
    "cms.test.type.docs_description": "Documentation, guides et contenu d’assistance.",
    "Documentation, guides, and help content.": "Documentation, guides et contenu d’assistance.",
    "cms.test.operation.list": "Lister le contenu par type",
    "List content by type": "Lister le contenu par type",
    "cms.test.operation.fetch": "Récupérer un contenu",
    "Fetch one Layer": "Récupérer un contenu",
    "cms.test.operation.create": "Créer un contenu",
    "Create a Layer": "Créer un contenu",
    "cms.test.operation.update": "Modifier un contenu",
    "Update a Layer": "Modifier un contenu",
    "cms.test.operation.delete": "Supprimer un contenu",
    "Delete a Layer": "Supprimer un contenu",
    "cms.test.operation.search": "Rechercher du contenu",
    "Search content": "Rechercher du contenu",
    "cms.test.operation.categories": "Charger les catégories",
    "Load categories": "Charger les catégories",
    "cms.test.operation.translations": "Enregistrer les traductions",
    "Save translations": "Enregistrer les traductions",
    "cms.test.editor.placeholder": "Rédigez le contenu de votre page…",
    "Write your page content...": "Rédigez le contenu de votre page…",
    "cms.test.error.load_type": "Impossible de charger le contenu : {type}",
    "Unable to load {type} content": "Impossible de charger le contenu : {type}",
    "cms.test.error.load": "Impossible de charger le contenu du CMS.",
    "Unable to load CMS content.": "Impossible de charger le contenu du CMS.",
    "cms.test.error.required": "Ajoutez un titre et du contenu avant l’enregistrement.",
    "Add a page title and content before saving.": "Ajoutez un titre et du contenu avant l’enregistrement.",
    "cms.test.error.create": "Impossible de créer cette page.",
    "Unable to create this page.": "Impossible de créer cette page.",
    "cms.test.toast.created": "Page créée avec succès.",
    "Page created successfully.": "Page créée avec succès.",
    "cms.test.hero.eyebrow": "GESTION DE CONTENU",
    "CONTENT MANAGEMENT": "GESTION DE CONTENU",
    "cms.test.hero.title": "CMS Layers",
    "Layers CMS": "CMS Layers",
    "cms.test.hero.description": "Créez du contenu structuré une fois et rendez-le disponible dans votre boutique, vos applications et vos expériences personnalisées.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Créez du contenu structuré une fois et rendez-le disponible dans votre boutique, vos applications et vos expériences personnalisées.",
    "cms.test.hero.live_workspace": "Espace de travail actif : {tenant} · aperçu en lecture seule",
    "Live workspace: {tenant} · read-only preview": "Espace de travail actif : {tenant} · aperçu en lecture seule",
    "cms.test.current_tenant": "tenant actuel",
    "current tenant": "tenant actuel",
    "cms.test.content.title": "Votre contenu",
    "Your content": "Votre contenu",
    "cms.test.content.description": "Gérez vos pages, blogs et documents depuis un seul endroit.",
    "Pages, blogs, and docs are ready to manage from one place.": "Gérez vos pages, blogs et documents depuis un seul endroit.",
    "cms.test.action.create_page": "Créer une page",
    "Create Page": "Créer une page",
    "cms.test.form.description": "Créez une page structurée dans Layers. Elle sera disponible via l’API après l’enregistrement.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Créez une page structurée dans Layers. Elle sera disponible via l’API après l’enregistrement.",
    "cms.test.placeholder.slug": "a-propos (facultatif)",
    "about-us (optional)": "a-propos (facultatif)",
    "cms.test.draft.unsaved": "Vous avez un brouillon de page non enregistré.",
    "You have an unsaved page draft.": "Vous avez un brouillon de page non enregistré.",
    "cms.test.loading": "Chargement du contenu Layers…",
    "Loading live Layers content…": "Chargement du contenu Layers…",
    "cms.test.content.empty_title": "Aucun contenu de type {type} pour le moment",
    "No {type} yet": "Aucun contenu de type {type} pour le moment",
    "cms.test.content.empty_description": "Créez votre premier contenu dans l’espace de travail pour le voir ici.",
    "Create your first Layer in the workspace to see it here.": "Créez votre premier contenu dans l’espace de travail pour le voir ici.",
    "cms.test.feature.types": "Types de contenu personnalisés",
    "Custom content types": "Types de contenu personnalisés",
    "cms.test.feature.types_description": "Les pages, blogs et documents sont des points de départ. Définissez un modèle Post ou tout autre modèle nécessaire.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Les pages, blogs et documents sont des points de départ. Définissez un modèle Post ou tout autre modèle nécessaire.",
    "cms.test.feature.structured": "Structuré et localisé",
    "Structured and localized": "Structuré et localisé",
    "cms.test.feature.structured_description": "Utilisez des slugs, catégories, images, métadonnées SEO et traductions pour une même source de contenu.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Utilisez des slugs, catégories, images, métadonnées SEO et traductions pour une même source de contenu.",
    "cms.test.feature.headless": "Headless par défaut",
    "Headless by default": "Headless par défaut",
    "cms.test.feature.headless_description": "Utilisez l’API Layers sur un site web, une application mobile, un outil interne ou une interface personnalisée.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Utilisez l’API Layers sur un site web, une application mobile, un outil interne ou une interface personnalisée.",
    "cms.test.feature.ai": "Source de connaissances IA",
    "AI knowledge source": "Source de connaissances IA",
    "cms.test.feature.ai_description": "Envoyez le contenu du CMS Tradly à iRyxo Agent Builder comme source de connaissances.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Envoyez le contenu du CMS Tradly à iRyxo Agent Builder comme source de connaissances.",
    "cms.test.community.eyebrow": "CONTENU COMMUNAUTAIRE",
    "COMMUNITY CONTENT": "CONTENU COMMUNAUTAIRE",
    "cms.test.community.title": "Transformez Layers en fil social",
    "Turn Layers into a social feed": "Transformez Layers en fil social",
    "cms.test.community.description": "Créez un type Post personnalisé, permettez aux utilisateurs de publier des actualités et ajoutez des interactions via votre interface.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Créez un type Post personnalisé, permettez aux utilisateurs de publier des actualités et ajoutez des interactions via votre interface.",
    "cms.test.community.share_placeholder": "Partager une actualité…",
    "Share an update…": "Partager une actualité…",
    "cms.test.community.post": "Publier",
    "Post": "Publier",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Une actualité communautaire publiée depuis un contenu personnalisé.",
    "A community update published from a custom Layer.": "Une actualité communautaire publiée depuis un contenu personnalisé.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 commentaires   ·   ↗ Partager",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 commentaires   ·   ↗ Partager",
    "cms.test.community.endpoints": "Exemples de points de terminaison",
    "Example endpoints": "Exemples de points de terminaison",
    "cms.test.developer.eyebrow": "ACCÈS DÉVELOPPEUR",
    "DEVELOPER ACCESS": "ACCÈS DÉVELOPPEUR",
    "cms.test.developer.title": "API Layers",
    "Layers API": "API Layers",
    "cms.test.developer.docs": "Documentation développeur",
    "Developer docs": "Documentation développeur",
    "auth.title": "Authentification",
    "auth.sign_in_method": "Méthode de connexion",
    "auth.facebook_auth": "Authentification Facebook",
    "auth.google_auth": "Authentification Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "SSO d’entreprise",
    "Enterprise SSO": "SSO d’entreprise",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "Paramètres de paiement",
    "Checkout Settings": "Paramètres de paiement",
    "checkout.orders": "Commandes",
    "checkout.carts": "Paniers",
    "Carts": "Paniers",
    "audit_logs.action": "Action",
    "audit_logs.resource": "Ressource",
    "audit_logs.resource_id": "ID de la ressource",
    "Resource ID": "ID de la ressource",
    "audit_logs.agent_id": "ID de l’agent",
    "Agent ID": "ID de l’agent",
    "audit_logs.result": "Résultat",
    "audit_logs.actor_id": "ID de l’auteur",
    "Actor ID": "ID de l’auteur",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Horodatage",
    "Timestamp": "Horodatage",
    "audit_logs.succeeded": "Réussi",
    "audit_logs.failed": "Échec",
    "audit_logs.source": "Source",
    "audit_logs.all_sources": "Toutes les sources",
    "All sources": "Toutes les sources",
    "audit_logs.human_admin": "Humain (administrateur)",
    "Human (admin)": "Humain (administrateur)",
    "audit_logs.agent_mcp": "Agent (MCP)",
    "Agent (MCP)": "Agent (MCP)",
    "audit_logs.all_actions": "Toutes les actions",
    "All actions": "Toutes les actions",
    "audit_logs.from": "Du",
    "audit_logs.to": "Au",
    "audit_logs.apply": "Appliquer",
    "audit_logs.clear": "Effacer",
    "audit_logs.export_csv": "Exporter en CSV",
    "audit_logs.exporting": "Exportation…",
    "audit_logs.title": "Journaux d’audit",
    "audit_logs.empty_title": "Aucun journal d’audit trouvé",
    "No audit logs found": "Aucun journal d’audit trouvé",
    "audit_logs.empty_subtitle": "Essayez de modifier vos filtres",
    "Try adjusting your filters": "Essayez de modifier vos filtres",
    "audit_logs.restriction_notice": "Les 5 derniers journaux d’audit sont affichés. Passez à Growth pour consulter tout l’historique et exporter les journaux.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Les 5 derniers journaux d’audit sont affichés. Passez à Growth pour consulter tout l’historique et exporter les journaux.",
    "audit_logs.extended_history": "Historique étendu des journaux d’audit",
    "Extended audit log history": "Historique étendu des journaux d’audit",
    "manage_features.title": "Gérer les fonctionnalités",
    "manage_features.general": "Général",
    "manage_features.apps": "Applications",
    "manage_features.marketplace": "Place de marché",
    "manage_features.commerce": "Commerce",
    "manage_features.channels": "Canaux",
    "manage_features.left_menu": "Menu de gauche",
    "Left Menu": "Menu de gauche",
    "manage_features.right_sidepanel": "Panneau latéral droit",
    "Right Sidepanel": "Panneau latéral droit",
    "workflow.integration": "Intégration",
    "workflow.no_url_title": "Aucune URL d’intégration",
    "No Integration URL": "Aucune URL d’intégration",
    "workflow.no_url_description": "Veuillez configurer l’URL d’intégration.",
    "Please configure the integration URL.": "Veuillez configurer l’URL d’intégration.",
    "workflow.back": "Retour",
    "Go Back": "Retour",
    "workflow.loading": "Chargement de l’intégration…",
    "Loading integration...": "Chargement de l’intégration…",
    "workflow.loading_hint": "Veuillez patienter pendant la connexion",
    "Please wait while we connect": "Veuillez patienter pendant la connexion",
    "workflow.error_title": "Erreur d’intégration",
    "Integration Error": "Erreur d’intégration",
    "workflow.error_description": "Impossible de charger l’intégration. Vérifiez votre connexion et réessayez.",
    "Unable to load the integration. Please check your connection and try again.": "Impossible de charger l’intégration. Vérifiez votre connexion et réessayez.",
    "workflow.retry": "Réessayer",
    "Try Again": "Réessayer",
    "upgrade_preview.eyebrow": "Aperçu du composant",
    "Component preview": "Aperçu du composant",
    "upgrade_preview.title": "Expérience de mise à niveau",
    "Upgrade experience": "Expérience de mise à niveau",
    "upgrade_preview.description": "Une restriction de fonctionnalité partagée qui présente ce que le client peut accomplir après la mise à niveau.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Une restriction de fonctionnalité partagée qui présente ce que le client peut accomplir après la mise à niveau.",
    "upgrade_preview.feature": "Ajouter une variante",
    "Add a variant": "Ajouter une variante",
    "upgrade_preview.context": "C’est à cet endroit qu’un utilisateur du forfait Basic atteint la limite de la fonctionnalité.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "C’est à cet endroit qu’un utilisateur du forfait Basic atteint la limite de la fonctionnalité.",
    "upgrade_preview.button": "Prévisualiser le panneau de mise à niveau",
    "Preview upgrade panel": "Prévisualiser le panneau de mise à niveau",
    "upgrade_preview.listing_context": "Pour cette annonce",
    "For this listing": "Pour cette annonce",
    "gamification_test.eyebrow": "GAMIFICATION DE CROISSANCE · ROUTE DE TEST",
    "GROWTH GAMIFICATION · TEST ROUTE": "GAMIFICATION DE CROISSANCE · ROUTE DE TEST",
    "gamification_test.title": "Donnez de l’élan à votre activité",
    "Build momentum for your business": "Donnez de l’élan à votre activité",
    "gamification_test.subtitle": "Prévisualisez les missions, pièces, badges et séries pour {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Prévisualisez les missions, pièces, badges et séries pour {workspace}.",
    "gamification_test.this_workspace": "cet espace de travail",
    "this workspace": "cet espace de travail",
    "gamification_test.coins": "PIÈCES",
    "COINS": "PIÈCES",
    "gamification_test.points": "POINTS",
    "POINTS": "POINTS",
    "gamification_test.streak": "SÉRIE",
    "STREAK": "SÉRIE",
    "gamification_test.week": "1 semaine",
    "1 week": "1 semaine",
    "gamification_test.launch": "Parcours de lancement",
    "Launch path": "Parcours de lancement",
    "gamification_test.progress": "{completed} actions sur {total} terminées · jusqu’à {coins} pièces",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} actions sur {total} terminées · jusqu’à {coins} pièces",
    "gamification_test.done": "Terminé",
    "gamification_test.reward": "+{count} pièces",
    "+{count} coins": "+{count} pièces",
    "gamification_test.badges": "Badges",
    "Badges": "Badges",
    "gamification_test.mission_listing_created": "Créez votre première annonce",
    "Create your first listing": "Créez votre première annonce",
    "gamification_test.mission_collection_created": "Créez votre première collection",
    "Create your first collection": "Créez votre première collection",
    "gamification_test.mission_payment_configured": "Configurez les paiements",
    "Configure payments": "Configurez les paiements",
    "gamification_test.mission_publish_completed": "Publiez votre site",
    "Publish your site": "Publiez votre site",
    "gamification_test.mission_analytics_enabled": "Activez les statistiques",
    "Enable analytics": "Activez les statistiques",
    "gamification_test.badge_first_step": "Premier pas",
    "First Step": "Premier pas",
    "gamification_test.badge_catalog_builder": "Créateur de catalogue",
    "Catalog Builder": "Créateur de catalogue",
    "gamification_test.badge_ready_to_sell": "Prêt à vendre",
    "Ready to Sell": "Prêt à vendre",
    "gamification_test.badge_data_driven": "Piloté par les données",
    "Data Driven": "Piloté par les données",
    "gamification_test.badge_growth_operator": "Opérateur de croissance",
    "Growth Operator": "Opérateur de croissance",
    "sentry_check.title": "Vérification de la configuration Sentry",
    "Sentry Configuration Check": "Vérification de la configuration Sentry",
    "sentry_check.subtitle": "Testez et vérifiez le suivi des erreurs Sentry",
    "Test and verify Sentry error tracking setup": "Testez et vérifiez le suivi des erreurs Sentry",
    "sentry_check.configuration": "Configuration",
    "sentry_check.check_configuration": "Vérifier la configuration",
    "Check Configuration": "Vérifier la configuration",
    "sentry_check.status": "État :",
    "Status:": "État :",
    "sentry_check.enabled": "✓ Activé",
    "✓ Enabled": "✓ Activé",
    "sentry_check.disabled": "✗ Désactivé",
    "✗ Disabled": "✗ Désactivé",
    "sentry_check.environment": "Environnement :",
    "Environment:": "Environnement :",
    "sentry_check.dsn": "DSN :",
    "DSN:": "DSN :",
    "sentry_check.traces_sample_rate": "Taux d’échantillonnage des traces :",
    "Traces Sample Rate:": "Taux d’échantillonnage des traces :",
    "sentry_check.test_functions": "Fonctions de test",
    "Test Functions": "Fonctions de test",
    "sentry_check.test_hint": "Cliquez sur les boutons ci-dessous pour tester différentes fonctions Sentry. Vérifiez dans votre tableau de bord que les événements sont capturés.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Cliquez sur les boutons ci-dessous pour tester différentes fonctions Sentry. Vérifiez dans votre tableau de bord que les événements sont capturés.",
    "sentry_check.test_results": "Résultats des tests",
    "Test Results": "Résultats des tests",
    "sentry_check.clear": "Effacer",
    "sentry_check.no_tests": "Aucun test exécuté",
    "No tests run yet": "Aucun test exécuté",
    "sentry_check.important_notes": "⚠️ Remarques importantes",
    "⚠️ Important Notes": "⚠️ Remarques importantes",
    "sentry_check.warning_real_events": "• Ces tests créeront de vrais événements d’erreur dans votre tableau de bord Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Ces tests créeront de vrais événements d’erreur dans votre tableau de bord Sentry",
    "sentry_check.warning_dashboard": "• Vérifiez dans votre tableau de bord Sentry que les événements sont capturés",
    "• Check your Sentry dashboard to verify events are being captured": "• Vérifiez dans votre tableau de bord Sentry que les événements sont capturés",
    "sentry_check.warning_traces": "• Certains tests peuvent ne pas apparaître si tracesSampleRate est à 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Certains tests peuvent ne pas apparaître si tracesSampleRate est à 0.0",
    "sentry_check.warning_dsn": "• Vérifiez que votre DSN est correctement défini dans les variables d’environnement",
    "• Make sure your DSN is correctly configured in environment variables": "• Vérifiez que votre DSN est correctement défini dans les variables d’environnement",
    "sentry_check.normal_error": "Tester une erreur normale",
    "Test Normal Error": "Tester une erreur normale",
    "sentry_check.test_normal_error": "Tester une erreur normale",
    "sentry_check.test_message": "Tester un message",
    "Test Message": "Tester un message",
    "sentry_check.test_breadcrumb": "Tester un fil d’Ariane",
    "Test Breadcrumb": "Tester un fil d’Ariane",
    "sentry_check.test_user_context": "Tester le contexte utilisateur",
    "Test User Context": "Tester le contexte utilisateur",
    "sentry_check.test_custom_exception": "Tester une exception personnalisée",
    "Test Custom Exception": "Tester une exception personnalisée",
    "sentry_check.test_promise_rejection": "Tester un rejet de promesse",
    "Test Promise Rejection": "Tester un rejet de promesse",
    "sentry_check.configuration_check": "Vérification de la configuration",
    "Configuration Check": "Vérification de la configuration",
    "sentry_check.config_loaded": "Configuration chargée",
    "Config loaded successfully": "Configuration chargée",
    "sentry_check.error_captured": "Erreur capturée et envoyée à Sentry",
    "Error captured and sent to Sentry": "Erreur capturée et envoyée à Sentry",
    "sentry_check.error_capture_failed": "Échec de capture de l’erreur : {message}",
    "Failed to capture error: {message}": "Échec de capture de l’erreur : {message}",
    "sentry_check.message": "Message",
    "Message": "Message",
    "sentry_check.message_captured": "Message capturé et envoyé à Sentry",
    "Message captured and sent to Sentry": "Message capturé et envoyé à Sentry",
    "sentry_check.message_capture_failed": "Échec de capture du message : {message}",
    "Failed to capture message: {message}": "Échec de capture du message : {message}",
    "sentry_check.breadcrumb": "Fil d’Ariane",
    "Breadcrumb": "Fil d’Ariane",
    "sentry_check.breadcrumb_added": "Fil d’Ariane ajouté au contexte Sentry",
    "Breadcrumb added to Sentry context": "Fil d’Ariane ajouté au contexte Sentry",
    "sentry_check.breadcrumb_failed": "Échec d’ajout du fil d’Ariane : {message}",
    "Failed to add breadcrumb: {message}": "Échec d’ajout du fil d’Ariane : {message}",
    "sentry_check.user_context": "Contexte utilisateur",
    "User Context": "Contexte utilisateur",
    "sentry_check.user_set": "Contexte utilisateur défini dans Sentry",
    "User context set in Sentry": "Contexte utilisateur défini dans Sentry",
    "sentry_check.user_failed": "Échec de définition du contexte utilisateur : {message}",
    "Failed to set user context: {message}": "Échec de définition du contexte utilisateur : {message}",
    "sentry_check.custom_exception": "Exception personnalisée",
    "Custom Exception": "Exception personnalisée",
    "sentry_check.custom_sent": "Exception personnalisée avec contexte envoyée à Sentry",
    "Custom exception with context sent to Sentry": "Exception personnalisée avec contexte envoyée à Sentry",
    "sentry_check.custom_failed": "Échec de capture de l’exception personnalisée : {message}",
    "Failed to capture custom exception: {message}": "Échec de capture de l’exception personnalisée : {message}",
    "sentry_check.promise_rejection": "Rejet de promesse",
    "Promise Rejection": "Rejet de promesse",
    "sentry_check.promise_captured": "Rejet de promesse capturé et envoyé à Sentry",
    "Promise rejection captured and sent to Sentry": "Rejet de promesse capturé et envoyé à Sentry",
    "sentry_check.promise_failed": "Échec de traitement du rejet de promesse : {message}",
    "Failed to handle promise rejection: {message}": "Échec de traitement du rejet de promesse : {message}",
    "checkout_settings.orders": "Commandes",
    "checkout_settings.return_policy_days": "Délai de retour",
    "Return policy days": "Délai de retour",
    "checkout_settings.enter_return_policy_days": "Saisissez le délai de retour",
    "Enter return policy days": "Saisissez le délai de retour",
    "checkout_settings.saved": "Enregistré avec succès",
    "checkout_settings.cart": "Panier",
    "checkout_settings.hide_quantity_selection": "Masquer le choix de la quantité (par défaut : le champ de quantité est affiché)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Masquer le choix de la quantité (par défaut : le champ de quantité est affiché)",
    "checkout_settings.enable_coupon": "Activer les coupons",
    "Enable Coupon": "Activer les coupons",
    "upgrade_page.copy.a_practical_next_step": "Une étape concrète pour avancer",
    "A practical next step": "Une étape concrète pour avancer",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Ajoutez les informations structurées dont votre processus a besoin.",
    "Add the structured information your workflow needs.": "Ajoutez les informations structurées dont votre processus a besoin.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Attribuez des rôles et des autorisations à chaque membre de l’équipe.",
    "Assign roles and permissions to every teammate.": "Attribuez des rôles et des autorisations à chaque membre de l’équipe.",
    "upgrade_page.copy.audit_log_export": "Export des journaux d’audit",
    "Audit log export": "Export des journaux d’audit",
    "upgrade_page.copy.best_next_step": "Prochaine étape recommandée",
    "Best next step": "Prochaine étape recommandée",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Importez des données structurées, modifiez-les hors ligne et exportez-les lorsque votre équipe a besoin d’une copie complète.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Importez des données structurées, modifiez-les hors ligne et exportez-les lorsque votre équipe a besoin d’une copie complète.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Dépassez l’interface standard",
    "Build beyond the standard interface": "Dépassez l’interface standard",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Collectez les informations qui rendent votre catalogue utile.",
    "Capture the details that make your catalogue useful.": "Collectez les informations qui rendent votre catalogue utile.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Profitez de la flexibilité nécessaire pour créer vos propres expériences client avec Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Profitez de la flexibilité nécessaire pour créer vos propres expériences client avec Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Regroupez des annonces existantes et laissez les clients choisir les articles admissibles au paiement.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Regroupez des annonces existantes et laissez les clients choisir les articles admissibles au paiement.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Configurez les devises nécessaires à votre activité dans les différentes régions.",
    "Configure the currencies your business needs as you operate across regions.": "Configurez les devises nécessaires à votre activité dans les différentes régions.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Connectez votre marketplace aux outils internes et à l’automatisation lorsque le travail manuel ne suffit plus.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Connectez votre marketplace aux outils internes et à l’automatisation lorsque le travail manuel ne suffit plus.",
    "upgrade_page.copy.connect_your_own_tools": "Connectez vos propres outils",
    "Connect your own tools": "Connectez vos propres outils",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Contrôlez qui peut consulter et modifier chaque élément.",
    "Control who can see and change what.": "Contrôlez qui peut consulter et modifier chaque élément.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Créez des champs personnalisés pour les informations utiles aux clients et à votre équipe sur chaque annonce ou compte.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Créez des champs personnalisés pour les informations utiles aux clients et à votre équipe sur chaque annonce ou compte.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Créez des lots fixes ou personnalisables.",
    "Create fixed and mix-and-match bundles.": "Créez des lots fixes ou personnalisables.",
    "upgrade_page.copy.custom_attributes": "Attributs personnalisés",
    "Custom attributes": "Attributs personnalisés",
    "upgrade_page.copy.custom_email_templates": "Modèles d’e-mail personnalisés",
    "Custom email templates": "Modèles d’e-mail personnalisés",
    "upgrade_page.copy.email_whitelabelling": "Personnalisation de la marque des e-mails",
    "Email whitelabelling": "Personnalisation de la marque des e-mails",
    "upgrade_page.copy.everything_in_growth": "Tout ce qui est inclus dans Growth",
    "Everything in Growth": "Tout ce qui est inclus dans Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Tout ce qui est inclus dans Growth, avec les limites les plus élevées.",
    "Everything in Growth, with the highest limits.": "Tout ce qui est inclus dans Growth, avec les limites les plus élevées.",
    "upgrade_page.copy.everything_in_starter": "Tout ce qui est inclus dans Starter",
    "Everything in Starter": "Tout ce qui est inclus dans Starter",
    "upgrade_page.copy.expand_your_workspace": "Développez votre espace de travail",
    "Expand your workspace": "Développez votre espace de travail",
    "upgrade_page.copy.feature_access": "Accès aux fonctionnalités",
    "Feature access": "Accès aux fonctionnalités",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Pour un catalogue en pleine croissance qui nécessite des choix de produits plus clairs.",
    "For a growing catalogue that needs clearer product choices.": "Pour un catalogue en pleine croissance qui nécessite des choix de produits plus clairs.",
    "upgrade_page.copy.for_established_businesses": "Pour les entreprises établies",
    "For established businesses": "Pour les entreprises établies",
    "upgrade_page.copy.for_growing_operations": "Pour les activités en croissance",
    "For growing operations": "Pour les activités en croissance",
    "upgrade_page.copy.for_growing_teams": "Pour les équipes en croissance",
    "For growing teams": "Pour les équipes en croissance",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Pour les équipes à fort volume qui doivent pouvoir changer d’échelle.",
    "For high-volume teams that need room to operate at scale.": "Pour les équipes à fort volume qui doivent pouvoir changer d’échelle.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Pour les équipes qui gèrent un catalogue plus vaste et davantage de processus.",
    "For teams managing a larger catalogue and more workflows.": "Pour les équipes qui gèrent un catalogue plus vaste et davantage de processus.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Pour les équipes prêtes à traiter plusieurs enregistrements à la fois.",
    "For teams ready to work beyond one record at a time.": "Pour les équipes prêtes à traiter plusieurs enregistrements à la fois.",
    "upgrade_page.copy.full_audit_history": "Historique complet des audits",
    "Full audit history": "Historique complet des audits",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Les offres Growth et Scale donnent accès à l’historique complet des audits et à son export pour les processus de conformité.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Les offres Growth et Scale donnent accès à l’historique complet des audits et à son export pour les processus de conformité.",
    "upgrade_page.copy.higher_usage_limits": "Limites d’utilisation plus élevées",
    "Higher usage limits": "Limites d’utilisation plus élevées",
    "upgrade_page.copy.highest_usage_limits": "Limites d’utilisation maximales",
    "Highest usage limits": "Limites d’utilisation maximales",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Importez et exportez des données sans tâches manuelles répétitives.",
    "Import and export records without repetitive manual work.": "Importez et exportez des données sans tâches manuelles répétitives.",
    "upgrade_page.copy.import_and_export_tools": "Outils d’import et d’export",
    "Import and export tools": "Outils d’import et d’export",
    "upgrade_page.copy.improve_important_customer_messages": "Améliorez les messages importants envoyés aux clients",
    "Improve important customer messages": "Améliorez les messages importants envoyés aux clients",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Conservez un historique de conformité plus long",
    "Keep a longer compliance history": "Conservez un historique de conformité plus long",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Gardez une visibilité complète sur la conformité des activités à fort volume.",
    "Keep complete compliance visibility for high-volume operations.": "Gardez une visibilité complète sur la conformité des activités à fort volume.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Organisez davantage de données et de processus à mesure que le catalogue grandit.",
    "Keep more data and workflows organised as the catalogue grows.": "Organisez davantage de données et de processus à mesure que le catalogue grandit.",
    "upgrade_page.copy.keep_your_workspace_secure": "Sécurisez votre espace de travail",
    "Keep your workspace secure": "Sécurisez votre espace de travail",
    "upgrade_page.copy.large": "Grand",
    "Large": "Grand",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Laissez les clients choisir des options dans une seule annonce.",
    "Let customers choose options from one listing.": "Laissez les clients choisir des options dans une seule annonce.",
    "upgrade_page.copy.listing_variants": "Variantes d’annonce",
    "Listing variants": "Variantes d’annonce",
    "upgrade_page.copy.make_every_customer_email_yours": "Personnalisez chaque e-mail client à votre image",
    "Make every customer email yours": "Personnalisez chaque e-mail client à votre image",
    "upgrade_page.copy.make_one_listing_work_harder": "Tirez davantage parti d’une seule annonce",
    "Make one listing work harder": "Tirez davantage parti d’une seule annonce",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Adaptez les e-mails système à votre processus et à votre ton.",
    "Make system emails match your workflow and tone.": "Adaptez les e-mails système à votre processus et à votre ton.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Rendez votre projet disponible dans davantage de langues.",
    "Make your project available in more languages.": "Rendez votre projet disponible dans davantage de langues.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Gérez l’expérience linguistique des clients lorsque vous vous développez dans de nouvelles régions et auprès de nouveaux publics.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Gérez l’expérience linguistique des clients lorsque vous vous développez dans de nouvelles régions et auprès de nouveaux publics.",
    "upgrade_page.copy.medium": "Moyen",
    "upgrade_page.copy.more_capacity": "Plus de capacité",
    "More capacity": "Plus de capacité",
    "upgrade_page.copy.more_storage": "Plus d’espace de stockage",
    "More storage": "Plus d’espace de stockage",
    "upgrade_page.copy.more_team_capacity": "Plus de capacité pour votre équipe",
    "More team capacity": "Plus de capacité pour votre équipe",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Gagnez du temps dans la gestion de votre catalogue",
    "Move faster with your catalogue": "Gagnez du temps dans la gestion de votre catalogue",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Accélérez les tâches courantes pour les catalogues plus importants et les équipes plus nombreuses.",
    "Move larger catalogues and teams through routine work faster.": "Accélérez les tâches courantes pour les catalogues plus importants et les équipes plus nombreuses.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Proposez des tailles, des couleurs ou d’autres options sans dupliquer les annonces ni séparer la gestion des stocks.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Proposez des tailles, des couleurs ou d’autres options sans dupliquer les annonces ni séparer la gestion des stocks.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Travaillez avec les limites les plus élevées disponibles.",
    "Operate with the highest available limits.": "Travaillez avec les limites les plus élevées disponibles.",
    "upgrade_page.copy.per_module_permissions": "Autorisations par module",
    "Per-module permissions": "Autorisations par module",
    "upgrade_page.copy.priority_support": "Assistance prioritaire",
    "Priority support": "Assistance prioritaire",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Consultez plus que les cinq derniers événements d’audit.",
    "Review more than the latest five audit events.": "Consultez plus que les cinq derniers événements d’audit.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Consultez l’historique complet des audits à mesure que votre équipe et votre activité grandissent.",
    "Review the full audit history as your team and activity grow.": "Consultez l’historique complet des audits à mesure que votre équipe et votre activité grandissent.",
    "upgrade_page.copy.role_based_access_control": "Contrôle d’accès basé sur les rôles",
    "Role-based access control": "Contrôle d’accès basé sur les rôles",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Les rôles permettent d’accorder à chaque membre de l’équipe uniquement les accès nécessaires. Disponible avec Growth et les offres supérieures.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Les rôles permettent d’accorder à chaque membre de l’équipe uniquement les accès nécessaires. Disponible avec Growth et les offres supérieures.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Mettez en place des communications client plus abouties et cohérentes.",
    "Run a stronger, more polished customer communication workflow.": "Mettez en place des communications client plus abouties et cohérentes.",
    "upgrade_page.copy.sell_across_markets": "Vendez sur plusieurs marchés",
    "Sell across markets": "Vendez sur plusieurs marchés",
    "upgrade_page.copy.sell_products_together": "Vendez des produits groupés",
    "Sell products together": "Vendez des produits groupés",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Envoyez des e-mails avec une marque reconnue par vos clients.",
    "Send email from a brand your customers recognise.": "Envoyez des e-mails avec une marque reconnue par vos clients.",
    "upgrade_page.copy.shape_the_information_you_collect": "Structurez les informations collectées",
    "Shape the information you collect": "Structurez les informations collectées",
    "upgrade_page.copy.small": "Petit",
    "Small": "Petit",
    "upgrade_page.copy.speak_to_more_customers": "Touchez davantage de clients",
    "Speak to more customers": "Touchez davantage de clients",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Standardisez des données plus riches dans une activité à fort volume.",
    "Standardise richer data across a high-volume operation.": "Standardisez des données plus riches dans une activité à fort volume.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Commencez à offrir une expérience client plus cohérente.",
    "Start presenting a more consistent customer experience.": "Commencez à offrir une expérience client plus cohérente.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Offrez une expérience client complète, prête pour les grandes entreprises.",
    "Support a complete enterprise-ready customer experience.": "Offrez une expérience client complète, prête pour les grandes entreprises.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Acceptez les clients qui achètent dans différentes devises.",
    "Support customers who shop in different currencies.": "Acceptez les clients qui achètent dans différentes devises.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Gérez à grande échelle des processus opérationnels à fort volume.",
    "Support high-volume operational workflows at scale.": "Gérez à grande échelle des processus opérationnels à fort volume.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Prenez en charge des processus et des équipes plus importants.",
    "Support larger workflows and teams.": "Prenez en charge des processus et des équipes plus importants.",
    "upgrade_page.copy.t_shirt": "T-shirt",
    "T-shirt": "T-shirt",
    "upgrade_page.copy.t_shirt_large": "T-shirt — grand",
    "T-shirt — Large": "T-shirt — grand",
    "upgrade_page.copy.t_shirt_medium": "T-shirt — moyen",
    "T-shirt — Medium": "T-shirt — moyen",
    "upgrade_page.copy.t_shirt_small": "T-shirt — petit",
    "T-shirt — Small": "T-shirt — petit",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Adaptez les messages reçus par les clients aux moments clés sans modifier la configuration de votre marketplace.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Adaptez les messages reçus par les clients aux moments clés sans modifier la configuration de votre marketplace.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Accédez à davantage d’outils dès que votre espace de travail se développe.",
    "Unlock more tools as your workspace begins to grow.": "Accédez à davantage d’outils dès que votre espace de travail se développe.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Activez cette fonctionnalité lorsque vous serez prêt.",
    "Unlock this feature when you are ready.": "Activez cette fonctionnalité lorsque vous serez prêt.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Utilisez des API headless pour une expérience entièrement personnalisée.",
    "Use headless APIs for a fully custom experience.": "Utilisez des API headless pour une expérience entièrement personnalisée.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Utilisez l’API lorsque votre processus doit aller plus loin.",
    "Use the API when your workflow needs to go further.": "Utilisez l’API lorsque votre processus doit aller plus loin.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Utilisez votre propre identité d’expéditeur et votre image de marque pour harmoniser les communications de la marketplace.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Utilisez votre propre identité d’expéditeur et votre image de marque pour harmoniser les communications de la marketplace.",
    "upgrade_page.copy.with_variants": "Avec variantes",
    "With variants": "Avec variantes",
    "upgrade_page.copy.without_variants": "Sans variantes",
    "Without variants": "Sans variantes",
    "upgrade_page.copy.workflow_tools": "Outils de workflow",
    "Workflow tools": "Outils de workflow",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Votre travail actuel reste inchangé pendant que vous comparez les offres incluant cette fonctionnalité.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Votre travail actuel reste inchangé pendant que vous comparez les offres incluant cette fonctionnalité.",
    "upgrade_page.copy.a_paid_plan": "une offre payante",
    "a paid plan": "une offre payante",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Tout ce dont une boutique en croissance a besoin : supprimer la marque, ajouter un domaine et accéder à plus d’outils.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Tout ce dont une boutique en croissance a besoin : supprimer la marque, ajouter un domaine et accéder à plus d’outils.",
    "upgrade_page.copy.everything_unlocked": "Toutes les fonctionnalités débloquées",
    "Everything unlocked": "Toutes les fonctionnalités débloquées",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Toute la suite IA, des outils marketing avancés et toutes les fonctionnalités pour les boutiques axées sur la croissance.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Un message de l’équipe Tradly",
    "A note from the Tradly team": "Un message de l’équipe Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Aidez-nous à faire vivre Tradly",
    "Help us keep Tradly going": "Aidez-nous à faire vivre Tradly",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Nos coûts ont augmenté. Pour continuer à développer et à soutenir Tradly, nous avons besoin du soutien de notre communauté. Pour continuer à utiliser votre espace de travail, choisissez une offre. Votre boutique et vos données sont en sécurité. Merci de faire partie de Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Nos coûts ont augmenté. Pour continuer à développer et à soutenir Tradly, nous avons besoin du soutien de notre communauté. Pour continuer à utiliser votre espace de travail, choisissez une offre. Votre boutique et vos données sont en sécurité. Merci de faire partie de Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Depuis 2019, nous proposons une offre gratuite avec de nombreuses fonctionnalités, afin que chacun puisse se lancer. Nous l’avons fait avec plaisir, mais nous ne pouvons plus la financer seuls. Nous prévoyons de rétablir une offre gratuite lorsque l’entreprise aura atteint un certain stade, afin de soutenir la communauté qui nous a permis d’en arriver là.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Depuis 2019, nous proposons une offre gratuite avec de nombreuses fonctionnalités, afin que chacun puisse se lancer. Nous l’avons fait avec plaisir, mais nous ne pouvons plus la financer seuls. Nous prévoyons de rétablir une offre gratuite lorsque l’entreprise aura atteint un certain stade, afin de soutenir la communauté qui nous a permis d’en arriver là.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Choisissez l’offre qui vous convient aujourd’hui. Vous pourrez la modifier à tout moment.",
    "Choose the plan that fits you today. You can change it any time.": "Choisissez l’offre qui vous convient aujourd’hui. Vous pourrez la modifier à tout moment.",
    "upgrade_page.back_to_workspace": "Retour à l’espace de travail",
    "Back to workspace": "Retour à l’espace de travail",
    "upgrade_page.grow_when_ready": "Développez-vous lorsque votre activité le demande",
    "Grow when the work calls for it": "Développez-vous lorsque votre activité le demande",
    "upgrade_page.reassurance": "Vos données, annonces et paramètres actuels restent inchangés.",
    "Your existing data, listings, and setup stay exactly as they are.": "Vos données, annonces et paramètres actuels restent inchangés.",
    "upgrade_page.choose_plan": "Choisir une offre",
    "Choose a plan": "Choisir une offre",
    "upgrade_page.feature_availability": "Disponibilité de la fonctionnalité",
    "Feature availability": "Disponibilité de la fonctionnalité",
    "upgrade_page.available_from": "Disponible à partir de",
    "Available from": "Disponible à partir de",
    "upgrade_page.and_above": "et les offres supérieures",
    "and above": "et les offres supérieures",
    "upgrade_page.choose_when_useful": "Choisissez une offre lorsque cette fonctionnalité sera utile à votre équipe.",
    "Choose a plan only when this capability is useful to your team.": "Choisissez une offre lorsque cette fonctionnalité sera utile à votre équipe.",
    "upgrade_page.practical_difference": "La différence concrète",
    "The practical difference": "La différence concrète",
    "upgrade_page.keep_work_simple": "Simplifiez votre travail à mesure que vous grandissez.",
    "Keep the work simpler as you grow.": "Simplifiez votre travail à mesure que vous grandissez.",
    "upgrade_page.plan_path": "Parcours des offres",
    "Plan path": "Parcours des offres",
    "upgrade_page.plan_path_title": "Commencez avec l’offre qui répond à cette prochaine étape.",
    "Start with the plan that supports this next step.": "Commencez avec l’offre qui répond à cette prochaine étape.",
    "upgrade_page.best_next_step": "Prochaine étape recommandée",
    "upgrade_page.includes_capability": "Inclut cette fonctionnalité",
    "Includes this capability": "Inclut cette fonctionnalité",
    "upgrade_page.not_included": "Non inclus",
    "Not included": "Non inclus",
    "upgrade_page.included": "✓ Inclus",
    "✓ Included": "✓ Inclus",
    "upgrade_page.ready_when_you_are": "Prêt lorsque vous le serez.",
    "Ready when you are.": "Prêt lorsque vous le serez.",
    "upgrade_page.billing_details": "Consultez tous les détails des offres et poursuivez en toute sécurité avec la facturation Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Consultez tous les détails des offres et poursuivez en toute sécurité avec la facturation Tradly.",
    "upgrade_page.panel.close": "Fermer le panneau de mise à niveau",
    "Close upgrade panel": "Fermer le panneau de mise à niveau",
    "upgrade_page.panel.show_less": "Afficher moins",
    "Show less": "Afficher moins",
    "upgrade_page.panel.see_more": "Afficher plus",
    "See more": "Afficher plus",
    "upgrade_page.panel.choose_to_continue": "Choisissez une offre pour continuer",
    "Choose a plan to continue": "Choisissez une offre pour continuer",
    "upgrade_page.panel.more_ways_to_grow": "Plus de possibilités de croissance",
    "More ways to grow": "Plus de possibilités de croissance",
    "upgrade_page.panel.plan_includes_feature": "Chaque offre inclut cette fonctionnalité et une capacité supplémentaire pour votre prochaine étape.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Chaque offre inclut cette fonctionnalité et une capacité supplémentaire pour votre prochaine étape.",
    "upgrade_page.panel.add_credits": "Ajouter des crédits ou des produits",
    "Add credits or products": "Ajouter des crédits ou des produits",
    "upgrade_page.panel.ala_carte_description": "Votre espace de travail est facturé à la carte. Rechargez vos crédits ou ajoutez les produits nécessaires.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Votre espace de travail est facturé à la carte. Rechargez vos crédits ou ajoutez les produits nécessaires.",
    "upgrade_page.panel.open_ala_carte": "Ouvrir la facturation à la carte",
    "Open à la carte": "Ouvrir la facturation à la carte",
    "upgrade_page.panel.recommended": "Recommandé",
    "Recommended": "Recommandé",
    "upgrade_page.panel.per_month": "/ mois",
    "upgrade_page.panel.please_wait": "Veuillez patienter…",
    "upgrade_page.panel.unlock_plan": "Débloquer {plan}",
    "Unlock {plan}": "Débloquer {plan}",
    "upgrade_page.panel.choose_plan": "Choisir {plan}",
    "Choose {plan}": "Choisir {plan}",
    "upgrade_page.panel.compare_plans": "Comparer toutes les offres",
    "Compare all plan details": "Comparer toutes les offres",
    "workspace.usage.page_title": "Vue d’ensemble de l’utilisation",
    "Usage overview": "Vue d’ensemble de l’utilisation",
    "workspace.usage.page_description": "Consultez l’utilisation actuelle et les limites appliquées à cet espace de travail.",
    "workspace.usage.not_available": "Non disponible",
    "workspace.usage.limit_not_configured": "Limite non configurée",
    "Limit not configured": "Limite non configurée",
    "workspace.usage.limit_value": "Limite : {limit}",
    "Limit: {limit}": "Limite : {limit}",
    "listings.photos": "Photos",
    "Photos": "Photos",
    "listings.listen_episode": "Écouter cet épisode",
    "Listen to this episode": "Écouter cet épisode",
    "listings.other_listings": "Autres annonces",
    "Other listings": "Autres annonces",
    "listings.delete": "Supprimer",
    "listings.fulfilled_by_platform": "Expédié par la plateforme",
    "Fulfilled by Platform": "Expédié par la plateforme",
    "listings.no_attributes_set": "Aucun attribut défini",
    "No attributes set": "Aucun attribut défini",
    "listings.campaign_raised": "{amount} collectés",
    "{amount} raised": "{amount} collectés",
    "listings.campaign_progress": "{percent} % sur {goal}",
    "{percent}% of {goal}": "{percent} % sur {goal}",
    "listings.seat": "place",
    "seat": "place",
    "listings.seats": "places",
    "seats": "places",
    "listings.per_slot": "par créneau",
    "per slot": "par créneau",
    "listings.total_value": "Total : {total}",
    "Total: {total}": "Total : {total}",
    "listings.orders": "Commandes",
    "listings.total_orders": "Total des commandes",
    "Total orders": "Total des commandes",
    "listings.revenue": "Chiffre d’affaires",
    "listings.average_order": "Commande moyenne",
    "listings.customers": "Clients",
    "Customers": "Clients",
    "listings.load_more": "Charger plus",
    "Load more": "Charger plus",
    "listings.filter": "Filtrer",
    "listings.sort": "Trier",
    "Sort": "Trier",
    "listings.value_price": "Prix",
    "Value Price": "Prix",
    "listings.detail_label_title": "Titre",
    "listings.detail_label_slug": "Identifiant URL",
    "listings.detail_label_description": "Description",
    "listings.detail_label_categories": "Catégories",
    "listings.detail_label_list_price": "Prix catalogue",
    "List Price": "Prix catalogue",
    "listings.detail_label_offer": "Offre",
    "Offer": "Offre",
    "listings.detail_label_currency": "Devise",
    "listings.detail_label_listing_status": "Statut de l’annonce",
    "Listing Status": "Statut de l’annonce",
    "listings.detail_label_active": "Actif",
    "listings.detail_label_sold": "Vendu",
    "listings.detail_label_meta_title": "Titre méta",
    "listings.detail_label_meta_description": "Description méta",
    "listings.detail_label_goal": "Objectif",
    "Goal": "Objectif",
    "listings.detail_label_donors": "Donateurs",
    "Donors": "Donateurs",
    "listings.detail_label_start_date": "Date de début",
    "listings.detail_label_end_date": "Date de fin",
    "listings.detail_label_stock": "Stock",
    "listings.detail_label_max_qty_order": "Quantité max / commande",
    "Max qty / order": "Quantité max / commande",
    "listings.detail_label_weight": "Poids",
    "listings.detail_label_dimensions": "Dimensions",
    "Dimensions": "Dimensions",
    "listings.detail_label_listing_period": "Période de l’annonce",
    "Listing period": "Période de l’annonce",
    "listings.detail_label_max_tickets_booking": "Billets ou réservations max.",
    "Max tickets / booking": "Billets ou réservations max.",
    "listings.detail_label_rating": "Évaluation",
    "listings.detail_label_reviews": "Avis",
    "listings.detail_label_likes": "J’aime",
    "Likes": "J’aime",
    "listings.detail_label_dislikes": "Je n’aime pas",
    "Dislikes": "Je n’aime pas",
    "listings.detail_label_barcode": "Code-barres",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Informations de base",
    "Basic Info": "Informations de base",
    "listings.detail_section_pricing": "Tarification",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Sélectionnez un type d’annonce ci-dessus pour continuer.",
    "Select a listing type above to continue.": "Sélectionnez un type d’annonce ci-dessus pour continuer.",
    "listing_form.attributes": "Attributs",
    "category.status_active_help": "Statut (inactif / actif)",
    "promotions.medium": "Moyen",
    "users.listings": "Annonces",
    "users.accounts": "Comptes",
    "users.click_count_one": "{count} clic",
    "{count} click": "{count} clic",
    "users.click_count": "{count} clics",
    "{count} clicks": "{count} clics",
    "integrations.generic.provider_help": "Configurez le fournisseur sélectionné à l’aide des champs ci-dessous.",
    "Configure the selected provider using the fields below.": "Configurez le fournisseur sélectionné à l’aide des champs ci-dessous.",
    "attributes.editor_prefill_data_from": "Préremplir les données à partir de",
    "Prefill Data From": "Préremplir les données à partir de",
    "attributes.editor_select_attribute": "Sélectionnez un attribut",
    "Select Attribute": "Sélectionnez un attribut",
    "attributes.editor_select_attribute_group": "Sélectionnez un groupe d’attributs",
    "Select Attribute Group": "Sélectionnez un groupe d’attributs",
    "attributes.editor_attribute": "Attribut",
    "Attribute": "Attribut",
    "attributes.editor_attributes": "Attributs",
    "attributes.editor_cart_attributes": "Attributs du panier",
    "Cart Attributes": "Attributs du panier",
    "listings.add_photo": "Ajouter une photo",
    "accounts.analytics": "Analyses",
    "listings.image_optional": "Images des annonces (facultatif)",
    "Listing Images (Optional)": "Images des annonces (facultatif)",
    "listings.currency": "Devise",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "Actif",
    "listing_form.digital_deleted_item_cannot_edit": "Cet élément est marqué pour suppression et ne peut pas être modifié",
    "This item is marked for deletion and cannot be edited": "Cet élément est marqué pour suppression et ne peut pas être modifié",
    "listing_form.digital_max_files": "10 fichiers maximum sont autorisés",
    "Maximum 10 files allowed": "10 fichiers maximum sont autorisés",
    "listing_form.digital_title_required": "Veuillez saisir un titre",
    "listing_form.digital_version_required": "Veuillez saisir un nom de version",
    "Please enter a version name": "Veuillez saisir un nom de version",
    "listing_form.digital_contents": "Contenus numériques",
    "Digital Contents": "Contenus numériques",
    "listing_form.digital_add_content": "+ Ajouter un contenu",
    "+ Add Content": "+ Ajouter un contenu",
    "listing_form.no_description": "Aucune description",
    "No description": "Aucune description",
    "listing_form.digital_file_count": "{count} fichier(s)",
    "{count} file(s)": "{count} fichier(s)",
    "listing_form.digital_empty": "Aucun contenu numérique pour le moment",
    "No digital contents yet": "Aucun contenu numérique pour le moment",
    "listing_form.digital_empty_help": "Cliquez sur « {action} » pour créer votre premier contenu numérique",
    "Click \"{action}\" to create your first digital content": "Cliquez sur « {action} » pour créer votre premier contenu numérique",
    "listing_form.digital_marked_for_deletion": "Marqué pour suppression ({count})",
    "Marked for Deletion ({count})": "Marqué pour suppression ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Sera supprimé lors de l’enregistrement",
    "✓ Will be deleted on submit": "✓ Sera supprimé lors de l’enregistrement",
    "listing_form.digital_edit_title": "Modifier le contenu numérique",
    "Edit Digital Content": "Modifier le contenu numérique",
    "listing_form.digital_add_title": "Ajouter un contenu numérique",
    "Add New Digital Content": "Ajouter un contenu numérique",
    "listing_form.digital_form_description": "Renseignez les champs ci-dessous pour {action} le contenu numérique",
    "Fill in the details below to {action} digital content": "Renseignez les champs ci-dessous pour {action} le contenu numérique",
    "listing_form.digital_title_placeholder": "Saisissez le titre du contenu numérique",
    "Enter digital content title": "Saisissez le titre du contenu numérique",
    "listing_form.description_optional_placeholder": "Saisissez une description (facultatif)",
    "Enter description (optional)": "Saisissez une description (facultatif)",
    "listing_form.version": "Version",
    "Version": "Version",
    "listing_form.files": "Fichiers",
    "Files": "Fichiers",
    "listing_form.max_files": "(Max. {count})",
    "(Max {count})": "(Max. {count})",
    "listing_form.click_to_upload_files": "Cliquez pour téléverser des fichiers",
    "Click to upload files": "Cliquez pour téléverser des fichiers",
    "listing_form.files_uploaded_count": "{count}/10 fichiers téléversés",
    "{count}/10 files uploaded": "{count}/10 fichiers téléversés",
    "listing_form.unknown_size": "Taille inconnue",
    "Unknown size": "Taille inconnue",
    "listing_form.no_accounts_available": "Aucun compte disponible",
    "No accounts available": "Aucun compte disponible",
    "listing_form.select_account": "Sélectionnez un compte",
    "Select an account": "Sélectionnez un compte",
    "listing_form.searching": "Recherche en cours...",
    "Searching...": "Recherche en cours...",
    "listing_form.location_enter_address": "Saisissez une adresse à rechercher",
    "Please enter an address to search": "Saisissez une adresse à rechercher",
    "listing_form.location_no_addresses_search": "Aucune adresse trouvée. Essayez une autre recherche.",
    "No addresses found. Please try a different search.": "Aucune adresse trouvée. Essayez une autre recherche.",
    "listing_form.location_search_failed": "La recherche d’adresses a échoué. Veuillez réessayer.",
    "Failed to search addresses. Please try again.": "La recherche d’adresses a échoué. Veuillez réessayer.",
    "listing_form.location_place_details_failed": "Impossible de récupérer les détails du lieu. Veuillez réessayer.",
    "Failed to get place details. Please try again.": "Impossible de récupérer les détails du lieu. Veuillez réessayer.",
    "listing_form.location_access_denied": "Accès à la localisation refusé. Veuillez autoriser la localisation.",
    "Location access denied. Please enable location permissions.": "Accès à la localisation refusé. Veuillez autoriser la localisation.",
    "listing_form.location_unavailable": "Impossible de déterminer la position. Veuillez réessayer.",
    "Unable to determine location. Please try again.": "Impossible de déterminer la position. Veuillez réessayer.",
    "listing_form.location_timeout": "La demande de localisation a expiré. Veuillez réessayer.",
    "Location request timed out. Please try again.": "La demande de localisation a expiré. Veuillez réessayer.",
    "listing_form.location_current_failed": "Impossible d’obtenir la position actuelle. Veuillez réessayer.",
    "Failed to get current location. Please try again.": "Impossible d’obtenir la position actuelle. Veuillez réessayer.",
    "listing_form.location": "Emplacement",
    "listing_form.location_search_placeholder": "Rechercher un emplacement...",
    "Search for a location...": "Rechercher un emplacement...",
    "listing_form.location_searching": "Recherche d’adresses...",
    "Searching addresses...": "Recherche d’adresses...",
    "listing_form.location_no_addresses": "Aucune adresse trouvée",
    "No addresses found": "Aucune adresse trouvée",
    "listing_form.location_try_different_search": "Essayez un autre terme de recherche",
    "Try a different search term": "Essayez un autre terme de recherche",
    "listing_form.location_getting": "Récupération de la position...",
    "Getting location...": "Récupération de la position...",
    "listing_form.location_use_current": "Utiliser la position actuelle",
    "Use Current Location": "Utiliser la position actuelle",
    "listing_form.location_selected": "Emplacement sélectionné",
    "Selected Location": "Emplacement sélectionné",
    "listing_form.latitude": "Latitude :",
    "Latitude:": "Latitude :",
    "listing_form.longitude": "Longitude :",
    "Longitude:": "Longitude :",
    "listing_form.location_helper": "Recherchez une adresse ou utilisez votre position actuelle",
    "Search for an address or use your current location": "Recherchez une adresse ou utilisez votre position actuelle",
    "common.change": "Modifier",
    "listing_form.variant_id_tooltip": "ID du type : {typeId}, ID de la valeur : {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "ID du type : {typeId}, ID de la valeur : {valueId}",
    "listing_form.variants_marked_for_deletion": "Marqué pour suppression ({count} éléments) :",
    "Marked for Deletion ({count} items):": "Marqué pour suppression ({count} éléments) :",
    "listing_form.add_new_variant": "Ajouter une variante",
    "Add New Variant": "Ajouter une variante",
    "listing_form.add_variant_description": "Renseignez les champs ci-dessous pour créer une variante",
    "Fill in the details below to create a new variant": "Renseignez les champs ci-dessous pour créer une variante",
    "listing_form.google_search_preview": "Aperçu de la recherche Google",
    "Google Search Preview": "Aperçu de la recherche Google",
    "listing_form.meta_title_preview": "Votre titre méta apparaîtra ici",
    "Your Meta Title Here": "Votre titre méta apparaîtra ici",
    "listing_form.meta_description_preview": "Votre méta-description apparaîtra ici. Elle aide les utilisateurs à comprendre le contenu de votre page dans les résultats de recherche.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Votre méta-description apparaîtra ici. Elle aide les utilisateurs à comprendre le contenu de votre page dans les résultats de recherche.",
    "listing_form.variant_name_placeholder": "Saisissez un nom",
    "listing_form.list_price_placeholder": "Saisissez le prix de vente",
    "listing_form.offer_percent_placeholder": "Saisissez le pourcentage de remise",
    "Enter Offer Percent": "Saisissez le pourcentage de remise",
    "attributes.select_all": "Tout sélectionner",
    "attributes.unselect_all": "Tout désélectionner",
    "Unselect All": "Tout désélectionner",
    "attributes.select_category": "Sélectionnez une catégorie",
    "attributes.create_category_configuration_first": "Créez d’abord des catégories dans la configuration {type}",
    "Create categories in {type} configuration first": "Créez d’abord des catégories dans la configuration {type}",
    "attributes.select_single_attribute_values": "Sélectionnez les valeurs d’attribut unique",
    "attributes.select_multiple_attribute_values": "Sélectionnez les valeurs d’attribut multiples",
    "attributes.enter_value": "Saisissez une valeur",
    "attributes.enter_multiple_tags": "Saisissez plusieurs balises",
    "Enter Multiple Tags": "Saisissez plusieurs balises",
    "attributes.upload_file": "Téléverser un fichier",
    "collections.add_condition": "+ Ajouter une condition",
    "+ Add another condition": "+ Ajouter une condition",
    "collections.add_photo": "Ajouter une photo",
    "collections.status": "Statut (inactif / actif)",
    "collections.start_date_placeholder": "Sélectionner la date de début",
    "Select start date": "Sélectionner la date de début",
    "collections.end_date_placeholder": "Sélectionner la date de fin",
    "Select end date": "Sélectionner la date de fin",
    "navigation.editor": "Éditeur",
    "Editor": "Éditeur",
    "navigation.web_analytics": "Analytique web",
    "Web Analytics": "Analytique web",
    "navigation.ai_studio": "Studio IA",
    "AI Studio": "Studio IA",
    "navigation.docs": "Documentation",
    "navigation.logout": "Déconnexion",
    "Logout": "Déconnexion",
    "navigation.tenant_name_placeholder": "(Nom du locataire)",
    "(Tenant name)": "(Nom du locataire)",
    "navigation.username_placeholder": "(Nom d’utilisateur)",
    "(Username)": "(Nom d’utilisateur)",
    "navigation.invite_description": "Envoyez des liens d’invitation aux membres de l’équipe",
    "Send invitation links to team members": "Envoyez des liens d’invitation aux membres de l’équipe",
    "navigation.invite": "Inviter",
    "Invite": "Inviter",
    "navigation.test_mode": "Mode test",
    "Test Mode": "Mode test",
    "navigation.upgrade": "Mettre à niveau",
    "navigation.open_account_menu": "Ouvrir le menu du compte",
    "Open account menu": "Ouvrir le menu du compte",
    "navigation.invite_name_required": "Veuillez saisir le nom",
    "Please fill in the name": "Veuillez saisir le nom",
    "navigation.invite_email_required": "Veuillez saisir l’adresse e-mail",
    "Please fill in the email": "Veuillez saisir l’adresse e-mail",
    "navigation.open_url_failed": "Impossible d’ouvrir cette URL : {url}",
    "Don't know how to open this URL: {url}": "Impossible d’ouvrir cette URL : {url}",
    "navigation.no_code_editor": "Éditeur sans code",
    "No-code editor": "Éditeur sans code",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Automatisation marketing",
    "Marketing automation": "Automatisation marketing",
    "navigation.analytics_recommendation": "Analytique et recommandations",
    "Analytics & Recommendation": "Analytique et recommandations",
    "navigation.ai_studio_iryxo": "Studio IA (Iryxo)",
    "AI Studio (Iryxo)": "Studio IA (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Projet actuel",
    "Current project": "Projet actuel",
    "navigation.current_user": "Utilisateur actuel",
    "Current user": "Utilisateur actuel",
    "navigation.switch_to_light_mode": "Passer en mode clair",
    "Switch to light mode": "Passer en mode clair",
    "navigation.switch_to_dark_mode": "Passer en mode sombre",
    "Switch to dark mode": "Passer en mode sombre",
    "navigation.download_android_app": "Télécharger l’application Android",
    "Download Android app": "Télécharger l’application Android",
    "navigation.download_ios_app": "Télécharger l’application iOS",
    "Download iOS app": "Télécharger l’application iOS",
    "navigation.subscribe_youtube": "S’abonner sur YouTube",
    "Subscribe on YouTube": "S’abonner sur YouTube",
    "navigation.open_app_switcher": "Ouvrir le sélecteur d’applications",
    "Open app switcher": "Ouvrir le sélecteur d’applications",
    "navigation.open_android_app": "Ouvrir l’application Android",
    "Open Android app": "Ouvrir l’application Android",
    "navigation.open_ios_app": "Ouvrir l’application iOS",
    "Open iOS app": "Ouvrir l’application iOS",
    "navigation.open_ai_support": "Ouvrir l’assistance Tradly sur ChatGPT",
    "Open Tradly ChatGPT support": "Ouvrir l’assistance Tradly sur ChatGPT",
    "navigation.open_youtube_channel": "Ouvrir la chaîne YouTube de Tradly",
    "Open Tradly YouTube channel": "Ouvrir la chaîne YouTube de Tradly",
    "navigation.demo": "Démo",
    "Demo": "Démo",
    "listings.smart_upload.listing_id_optional": "ID de l’annonce (facultatif — mettre à jour une annonce existante)",
    "Listing ID (optional — update existing)": "ID de l’annonce (facultatif — mettre à jour une annonce existante)",
    "listings.smart_upload.category_id": "ID de catégorie",
    "listings.smart_upload.list_price": "Prix de vente",
    "listings.smart_upload.stock": "Stock",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Code-barres",
    "listings.smart_upload.account_id": "ID du compte",
    "listings.smart_upload.slug": "Identifiant URL",
    "listings.smart_upload.text": "Texte",
    "listings.smart_upload.long_text": "Texte long",
    "listings.smart_upload.number": "Nombre",
    "listings.smart_upload.single_select": "Sélection unique",
    "listings.smart_upload.multi_select": "Sélection multiple",
    "listings.smart_upload.attribute_name_required": "Saisissez un nom d’attribut pour « {header} ».",
    "listings.smart_upload.attribute_create_failed": "Tradly n’a pas renvoyé le nouvel attribut « {name} ».",
    "Tradly did not return the new “{name}” attribute.": "Tradly n’a pas renvoyé le nouvel attribut « {name} ».",
    "listings.smart_upload.attribute_option_create_failed": "Impossible de créer l’option « {value} » pour {name}.",
    "Could not create the “{value}” option for {name}.": "Impossible de créer l’option « {value} » pour {name}.",
    "listings.smart_upload.attribute_no_longer_available": "L’attribut associé à « {header} » n’est plus disponible.",
    "listings.smart_upload.csv_needs_header_and_listing": "Le fichier CSV doit contenir une ligne d’en-tête et au moins une annonce.",
    "The CSV must contain a header row and at least one listing.": "Le fichier CSV doit contenir une ligne d’en-tête et au moins une annonce.",
    "listings.smart_upload.unique_headers_required": "Chaque colonne d’annonce doit avoir un en-tête unique et non vide.",
    "Every listing column needs a unique, non-empty header.": "Chaque colonne d’annonce doit avoir un en-tête unique et non vide.",
    "listings.smart_upload.csv_read_failed": "Impossible de lire ce fichier CSV.",
    "listings.smart_upload.map_required_fields": "Associez ces colonnes obligatoires avant de continuer : {fields}",
    "Map these required columns before continuing: {fields}": "Associez ces colonnes obligatoires avant de continuer : {fields}",
    "listings.smart_upload.row_missing_required_value": "Une valeur obligatoire manque à la ligne {row}.",
    "Row {row} is missing a required value.": "Une valeur obligatoire manque à la ligne {row}.",
    "listings.smart_upload.invalid_category_id_row": "La ligne {row} doit contenir un ID de catégorie numérique valide, ou choisissez « Associer l’ID de catégorie manuellement ».",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "La ligne {row} doit contenir un ID de catégorie numérique valide, ou choisissez « Associer l’ID de catégorie manuellement ».",
    "listings.smart_upload.invalid_listing_id_row": "La ligne {row} doit contenir un ID d’annonce numérique valide, ou laissez-le vide pour créer une annonce.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "La ligne {row} doit contenir un ID d’annonce numérique valide, ou laissez-le vide pour créer une annonce.",
    "listings.smart_upload.progress.checking_duplicates": "Vérification des annonces existantes",
    "Checking for existing listings": "Vérification des annonces existantes",
    "listings.smart_upload.duplicate_same_value_row": "La même valeur de {field} apparaît à la ligne {row} de ce fichier.",
    "Same {field} appears in row {row} of this file.": "La même valeur de {field} apparaît à la ligne {row} de ce fichier.",
    "listings.smart_upload.duplicate_same_value_multiple": "La même valeur de {field} apparaît plusieurs fois dans ce fichier.",
    "Same {field} appears more than once in this file.": "La même valeur de {field} apparaît plusieurs fois dans ce fichier.",
    "listings.smart_upload.duplicate_existing_listing": "Correspond à l’annonce existante n° {id} selon {field}.",
    "Matches existing listing #{id} by {field}.": "Correspond à l’annonce existante n° {id} selon {field}.",
    "listings.smart_upload.explicit_listing_update": "L’annonce indiquée par l’ID {id} sera mise à jour.",
    "Explicit listing ID #{id} will be updated.": "L’annonce indiquée par l’ID {id} sera mise à jour.",
    "listings.smart_upload.progress.duplicates_complete": "Vérification des doublons terminée",
    "Duplicate check complete": "Vérification des doublons terminée",
    "listings.smart_upload.duplicate_check_failed": "Impossible de vérifier les annonces existantes.",
    "Could not check existing listings.": "Impossible de vérifier les annonces existantes.",
    "listings.smart_upload.progress.duplicates_stopped": "Vérification des doublons interrompue",
    "Duplicate check stopped": "Vérification des doublons interrompue",
    "listings.smart_upload.prepare_file_failed": "Impossible de préparer le fichier d’importation.",
    "listings.smart_upload.progress.uploading_file": "Téléversement du fichier d’importation",
    "listings.smart_upload.upload_file_failed": "Le fichier d’importation n’a pas pu être téléversé.",
    "listings.smart_upload.all_rows_duplicates": "Toutes les lignes sont des doublons. Choisissez « Importer quand même » pour les envoyer à Tradly, ou recommencez.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Toutes les lignes sont des doublons. Choisissez « Importer quand même » pour les envoyer à Tradly, ou recommencez.",
    "listings.smart_upload.progress.preparing_attributes": "Préparation des attributs",
    "listings.smart_upload.attribute_mapped_once": "Chaque attribut d’annonce ne peut être associé qu’une seule fois. Vérifiez les associations avant l’importation.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Chaque attribut d’annonce ne peut être associé qu’une seule fois. Vérifiez les associations avant l’importation.",
    "listings.smart_upload.progress.preparing_file": "Préparation du fichier d’importation",
    "listings.smart_upload.progress.tradly_importing": "Tradly importe les annonces",
    "Tradly is importing listings": "Tradly importe les annonces",
    "listings.smart_upload.progress.import_complete": "Importation terminée",
    "listings.smart_upload.progress.import_stopped": "Importation interrompue",
    "listings.smart_upload.progress.preparing_import": "Préparation de l’importation…",
    "Preparing import…": "Préparation de l’importation…",
    "listings.smart_upload.progress.rows_prepared": "{current} ligne(s) préparée(s) sur {total}",
    "{current} of {total} rows prepared": "{current} ligne(s) préparée(s) sur {total}",
    "listings.smart_upload.progress.remote_processing": "Tradly traite le fichier CSV téléversé. Cela peut prendre un moment.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly traite le fichier CSV téléversé. Cela peut prendre un moment.",
    "listings.smart_upload.progress.partial_import": "Tradly a importé {imported} ligne(s) sur {total}{ending} Vérifiez le résultat avant de réessayer ; une nouvelle tentative complète peut créer des doublons.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly a importé {imported} ligne(s) sur {total}{ending} Vérifiez le résultat avant de réessayer ; une nouvelle tentative complète peut créer des doublons.",
    "listings.smart_upload.title": "Importation intelligente",
    "Smart Upload": "Importation intelligente",
    "listings.smart_upload.beta": "(Bêta)",
    "listings.smart_upload.start_over": "Recommencer",
    "listings.smart_upload.description": "Téléversez des annonces, associez les colonnes aux champs existants ou créez des attributs avant l’importation.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Téléversez des annonces, associez les colonnes aux champs existants ou créez des attributs avant l’importation.",
    "listings.smart_upload.step_upload": "Téléverser",
    "listings.smart_upload.step_match": "Associer les colonnes",
    "listings.smart_upload.step_preview": "Aperçu",
    "listings.smart_upload.step_import": "Importer",
    "listings.smart_upload.choose_csv": "Choisissez un fichier CSV",
    "listings.smart_upload.required_columns_help": "Les colonnes obligatoires sont title et category_id. Les autres colonnes peuvent devenir des attributs d’annonce.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Les colonnes obligatoires sont title et category_id. Les autres colonnes peuvent devenir des attributs d’annonce.",
    "listings.smart_upload.select_csv_file": "Sélectionner un fichier CSV",
    "listings.smart_upload.match_columns": "Associez les colonnes de l’annonce",
    "Match listing columns": "Associez les colonnes de l’annonce",
    "listings.smart_upload.core_fields_help": "Les champs principaux sont envoyés à l’API des annonces. Les autres colonnes peuvent être enregistrées comme attributs.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Les champs principaux sont envoyés à l’API des annonces. Les autres colonnes peuvent être enregistrées comme attributs.",
    "listings.smart_upload.do_not_import": "Ne pas importer",
    "listings.smart_upload.map_category_manually": "Associer l’ID de catégorie manuellement",
    "Map Category ID manually": "Associer l’ID de catégorie manuellement",
    "listings.smart_upload.category_assignment_help": "Choisissez la catégorie à attribuer à chaque annonce importée.",
    "Choose the category to assign to every imported listing.": "Choisissez la catégorie à attribuer à chaque annonce importée.",
    "listings.smart_upload.select_category": "Sélectionnez une catégorie",
    "listings.smart_upload.no_categories": "Aucune catégorie d’annonce n’a été renvoyée. Créez une catégorie, puis rouvrez l’importation intelligente.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "Aucune catégorie d’annonce n’a été renvoyée. Créez une catégorie, puis rouvrez l’importation intelligente.",
    "listings.smart_upload.additional_attributes": "Attributs supplémentaires de l’annonce",
    "Additional listing attributes": "Attributs supplémentaires de l’annonce",
    "listings.smart_upload.ignore_column": "Ignorer cette colonne",
    "listings.smart_upload.create_attribute": "＋ Créer un attribut d’annonce",
    "＋ Create a new listing attribute": "＋ Créer un attribut d’annonce",
    "listings.smart_upload.attribute_name": "Nom de l’attribut",
    "listings.smart_upload.review_import": "Vérifier l’importation",
    "listings.smart_upload.rows_scanned_help": "{count} annonce(s) analysée(s) avant le téléversement. Les doublons sont détectés à partir du SKU, du code-barres, du slug et des valeurs répétées dans le CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} annonce(s) analysée(s) avant le téléversement. Les doublons sont détectés à partir du SKU, du code-barres, du slug et des valeurs répétées dans le CSV.",
    "listings.smart_upload.duplicates_found": "Doublons potentiels détectés",
    "Potential duplicates found": "Doublons potentiels détectés",
    "listings.smart_upload.duplicate_rows_skipped": "{count} ligne(s) seront ignorées par défaut.",
    "{count} row(s) will be skipped by default.": "{count} ligne(s) seront ignorées par défaut.",
    "listings.smart_upload.row_label": "Ligne",
    "Row": "Ligne",
    "listings.smart_upload.explicit_ids_are_updates": "Les lignes avec un ID d’annonce explicite seront traitées comme des mises à jour.",
    "Rows with an explicit listing ID are treated as updates.": "Les lignes avec un ID d’annonce explicite seront traitées comme des mises à jour.",
    "listings.smart_upload.duplicate_action": "Action en cas de doublon",
    "Duplicate action": "Action en cas de doublon",
    "listings.smart_upload.skip_duplicates": "Ignorer les doublons potentiels (recommandé)",
    "Skip potential duplicates (recommended)": "Ignorer les doublons potentiels (recommandé)",
    "listings.smart_upload.import_all_anyway": "Importer toutes les lignes quand même",
    "Import all rows anyway": "Importer toutes les lignes quand même",
    "listings.smart_upload.untitled_listing": "Annonce sans titre",
    "Untitled listing": "Annonce sans titre",
    "listings.smart_upload.category_label": "Catégorie :",
    "Category:": "Catégorie :",
    "listings.smart_upload.complete": "Importation intelligente terminée",
    "listings.smart_upload.imported_count": "{imported} annonce(s) importée(s) sur {total}.",
    "{imported} of {total} listings imported.": "{imported} annonce(s) importée(s) sur {total}.",
    "listings.smart_upload.selected_file": "Fichier sélectionné : {name}",
    "listings.smart_upload.checking": "Vérification…",
    "listings.smart_upload.check_duplicates": "Vérifier les doublons",
    "Check duplicates": "Vérifier les doublons",
    "listings.smart_upload.importing": "Importation…",
    "listings.smart_upload.import_listings": "Importer les annonces",
    "listings.smart_upload.failed": "L’importation intelligente a échoué.",
    "Smart Upload failed.": "L’importation intelligente a échoué.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Statut (inactif / actif)",
    "listings.upload_media": "Importer un média",
    "listing_form.stock_placeholder": "Saisissez le stock",
    "orders.create_order.order_items_alt": "Articles de la commande",
    "orders.create_order.by": "par",
    "by": "par",
    "orders.create_order.decrease_quantity": "Diminuer la quantité",
    "Decrease quantity": "Diminuer la quantité",
    "orders.create_order.increase_quantity": "Augmenter la quantité",
    "Increase quantity": "Augmenter la quantité",
    "orders.create_order.remove_item": "Supprimer l’article",
    "Remove item": "Supprimer l’article",
    "orders.create_order.rental_period_label": "Période de location :",
    "Rental period:": "Période de location :",
    "attributes.enter_text": "Saisissez du texte",
    "attributes.select_date": "Sélectionnez une date",
    "attributes.enter_number": "Saisissez un nombre",
    "attributes.select_color": "Sélectionnez une couleur",
    "attributes.upload_json": "Téléverser un fichier JSON",
    "Upload JSON": "Téléverser un fichier JSON",
    "attributes.select_location": "Sélectionnez un emplacement",
    "attributes.add_listing_preview": "Ajouter une annonce",
    "attributes.add_account_preview": "Ajouter un compte",
    "attributes.enter_price": "Saisissez un prix",
    "attributes.preview": "Aperçu",
    "attributes.enter_title": "Saisissez un titre",
    "attributes.enter_description": "Saisissez une description",
    "attributes.category": "Catégorie",
    "attributes.attribute_name": "Nom de l’attribut",
    "attributes.enter_attribute_name": "Saisissez le nom de l’attribut",
    "attributes.select_type": "Sélectionnez un type",
    "attributes.icon": "Icône",
    "attributes.tooltip": "Info-bulle",
    "Tooltip": "Info-bulle",
    "attributes.enter_tooltip": "Saisissez l’info-bulle de l’attribut",
    "Enter attribute tooltip": "Saisissez l’info-bulle de l’attribut",
    "listings.detail.images": "Images",
    "listings.detail.posted_by": "Publié par",
    "Posted by": "Publié par",
    "listings.detail.fulfilled_by_platform": "Expédié par la plateforme",
    "listings.detail.preview": "Aperçu",
    "listings.detail.view_listing": "Voir l’annonce",
    "View Listing": "Voir l’annonce",
    "listings.detail.variants": "Variantes",
    "listings.detail.no_attribute_values": "Aucune valeur d’attribut pour {name}",
    "listings.detail.attributes": "Attributs",
    "listings.detail.starts_from": "À partir de :",
    "Starts From:": "À partir de :",
    "listings.detail.schedule": "Planification",
    "listings.detail.detail": "Détail",
    "web_config.download": "Télécharger",
    "web_config.cancel": "Annuler",
    "web_config.choose_file": "Choisir un fichier",
    "web_config.title": "Configuration du site web",
    "Web Configs": "Configuration du site web",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Largeur du logo",
    "Logo Width": "Largeur du logo",
    "web_config.width": "Largeur",
    "web_config.logo_height": "Hauteur du logo",
    "Logo Height": "Hauteur du logo",
    "web_config.height": "Hauteur",
    "web_config.social_share_image": "Image mise en avant du site pour le partage social - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Image mise en avant du site pour le partage social - Open Graph",
    "web_config.business_name": "Nom de l’entreprise",
    "web_config.enter_web_name": "Saisissez le nom du site web",
    "Enter web name": "Saisissez le nom du site web",
    "web_config.title_font": "Police du titre",
    "Title Font": "Police du titre",
    "web_config.select_title_font": "Sélectionnez la police du titre",
    "Select title font": "Sélectionnez la police du titre",
    "web_config.body_font": "Police du corps",
    "Body Font": "Police du corps",
    "web_config.select_body_font": "Sélectionnez la police du corps",
    "Select body font": "Sélectionnez la police du corps",
    "web_config.primary_font": "Police principale",
    "Primary Font": "Police principale",
    "web_config.select_primary_font": "Sélectionnez la police principale",
    "Select primary font": "Sélectionnez la police principale",
    "web_config.uploaded_successfully": "Téléchargement réussi",
    "web_config.ios_download_icon": "Icône de téléchargement de l’application iOS",
    "iOS app download icon": "Icône de téléchargement de l’application iOS",
    "web_config.ios_download_link": "Lien de téléchargement de l’application iOS",
    "iOS app download link": "Lien de téléchargement de l’application iOS",
    "web_config.enter_ios_download_link": "Saisissez le lien de téléchargement de l’application iOS",
    "Enter iOS app download link": "Saisissez le lien de téléchargement de l’application iOS",
    "web_config.android_download_icon": "Icône de téléchargement de l’application Android",
    "Android app download icon": "Icône de téléchargement de l’application Android",
    "web_config.android_download_link": "Lien de téléchargement de l’application Android",
    "Android app download link": "Lien de téléchargement de l’application Android",
    "web_config.enter_android_download_link": "Saisissez le lien de téléchargement de l’application Android",
    "Enter android app download link": "Saisissez le lien de téléchargement de l’application Android",
    "coupons.preview.customer_checkout": "PAIEMENT CLIENT",
    "CUSTOMER CHECKOUT": "PAIEMENT CLIENT",
    "coupons.preview.title": "Les coupons en action",
    "Coupons in action": "Les coupons en action",
    "coupons.preview.featured_product": "Votre produit vedette",
    "Your featured product": "Votre produit vedette",
    "coupons.preview.product_meta": "1 article · Livraison standard",
    "1 item · Standard delivery": "1 article · Livraison standard",
    "coupons.preview.coupon_applied": "Coupon appliqué",
    "Coupon applied": "Coupon appliqué",
    "coupons.preview.remove": "Retirer",
    "coupons.preview.discount_applied": "Réduction appliquée à la commande",
    "Discount applied to the order": "Réduction appliquée à la commande",
    "coupons.preview.subtotal": "Sous-total",
    "coupons.preview.coupon_label": "Coupon · WELCOME10",
    "Coupon · WELCOME10": "Coupon · WELCOME10",
    "coupons.preview.grand_total": "Total général",
    "Grand total": "Total général",
    "coupons.preview.checkout": "PASSER À LA CAISSE",
    "CHECKOUT": "PASSER À LA CAISSE",
    "payments.stripe_get_keys": "Obtenir les clés Stripe",
    "Get Stripe keys": "Obtenir les clés Stripe",
    "payments.stripe_syncing": "Synchronisation avec Stripe…",
    "Syncing with Stripe...": "Synchronisation avec Stripe…",
    "payments.stripe_verifying_key": "Vérification de la clé secrète",
    "Verifying secret key": "Vérification de la clé secrète",
    "payments.stripe_creating_webhook": "Création du webhook de paiement",
    "Creating payment webhook": "Création du webhook de paiement",
    "payments.stripe_account_summary": "{country} · mode {mode} · {id}",
    "{country} · {mode} mode · {id}": "{country} · mode {mode} · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhooks configurés : les secrets ont été renseignés ci-dessous. Enregistrez le formulaire pour les conserver.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhooks configurés : les secrets ont été renseignés ci-dessous. Enregistrez le formulaire pour les conserver.",
    "payments.stripe_webhooks_error": "⚠ Échec de la configuration du webhook. Vérifiez les autorisations de votre clé et relancez la synchronisation.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Échec de la configuration du webhook. Vérifiez les autorisations de votre clé et relancez la synchronisation.",
    "payments.stripe_invalid_key": "Clé secrète invalide. Vérifiez-la et réessayez.",
    "Invalid secret key. Check and try again.": "Clé secrète invalide. Vérifiez-la et réessayez.",
    "payments.stripe_setup_failed": "Échec de la configuration. Synchronisez d’abord votre clé secrète.",
    "Setup failed. Make sure your secret key is synced first.": "Échec de la configuration. Synchronisez d’abord votre clé secrète.",
    "payments.stripe_marketplace_connect": "Stripe Connect pour la marketplace",
    "Marketplace Connect": "Stripe Connect pour la marketplace",
    "payments.stripe_marketplace_hint": "Nécessaire uniquement si vous utilisez Stripe Connect pour les versements de la marketplace",
    "Only needed if you use Stripe Connect for marketplace payouts": "Nécessaire uniquement si vous utilisez Stripe Connect pour les versements de la marketplace",
    "payments.stripe_subscription_hint": "Nécessaire uniquement si vous vendez des abonnements sur Tradly",
    "Only needed if you sell subscription products on Tradly": "Nécessaire uniquement si vous vendez des abonnements sur Tradly",
    "integrations.sso.title": "Authentification unique d’entreprise",
    "Enterprise single sign-on": "Authentification unique d’entreprise",
    "integrations.sso.description": "Connectez le fournisseur d’identité de votre entreprise pour permettre au personnel du tenant de se connecter à ArcticWhale avec OIDC. Okta, Microsoft Entra ID et les fournisseurs OIDC qui signent les jetons ID avec RS256 sont pris en charge.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Connectez le fournisseur d’identité de votre entreprise pour permettre au personnel du tenant de se connecter à ArcticWhale avec OIDC. Okta, Microsoft Entra ID et les fournisseurs OIDC qui signent les jetons ID avec RS256 sont pris en charge.",
    "integrations.sso.issuer_url": "URL de l’émetteur",
    "Issuer URL": "URL de l’émetteur",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID client",
    "integrations.sso.client_secret": "Secret client",
    "integrations.sso.secret_replace_placeholder": "Enregistré de façon sécurisée. Saisissez une valeur pour le remplacer.",
    "Saved securely. Enter a value to replace it.": "Enregistré de façon sécurisée. Saisissez une valeur pour le remplacer.",
    "integrations.sso.secret_placeholder": "Saisissez le secret client",
    "Enter the client secret": "Saisissez le secret client",
    "integrations.sso.email_domains": "Domaines e-mail de l’entreprise",
    "Company email domains": "Domaines e-mail de l’entreprise",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "Le personnel doit déjà disposer d’un compte ArcticWhale et d’un accès à ce tenant. Utilisez des domaines appartenant à votre organisation.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "Le personnel doit déjà disposer d’un compte ArcticWhale et d’un accès à ce tenant. Utilisez des domaines appartenant à votre organisation.",
    "integrations.sso.callback_url": "URL de rappel OIDC",
    "OIDC callback URL": "URL de rappel OIDC",
    "integrations.sso.loading_callback_url": "Chargement de l’URL de rappel…",
    "Loading callback URL…": "Chargement de l’URL de rappel…",
    "integrations.sso.callback_help": "Ajoutez cette URL exacte à l’application du fournisseur d’identité comme URI de redirection Web.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Ajoutez cette URL exacte à l’application du fournisseur d’identité comme URI de redirection Web.",
    "integrations.sso.enable": "Activer la connexion SSO de l’entreprise",
    "Enable company SSO sign-in": "Activer la connexion SSO de l’entreprise",
    "integrations.sso.checking": "Vérification…",
    "integrations.sso.test_issuer": "Tester l’émetteur",
    "Test issuer": "Tester l’émetteur",
    "integrations.sso.saving": "Enregistrement…",
    "integrations.sso.save": "Enregistrer les paramètres SSO",
    "Save SSO settings": "Enregistrer les paramètres SSO",
    "integrations.sso.security_help": "Le secret client est chiffré avant son stockage. Le SSO ajoute une option de connexion pour l’organisation ; la connexion par mot de passe reste inchangée.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "Le secret client est chiffré avant son stockage. Le SSO ajoute une option de connexion pour l’organisation ; la connexion par mot de passe reste inchangée.",
    "integrations.sso.load_error": "Impossible de charger les paramètres SSO de l’entreprise.",
    "Unable to load enterprise SSO settings.": "Impossible de charger les paramètres SSO de l’entreprise.",
    "integrations.sso.save_error": "Impossible d’enregistrer les paramètres SSO de l’entreprise.",
    "Unable to save enterprise SSO settings.": "Impossible d’enregistrer les paramètres SSO de l’entreprise.",
    "integrations.sso.saved": "Paramètres SSO de l’entreprise enregistrés.",
    "Enterprise SSO settings saved.": "Paramètres SSO de l’entreprise enregistrés.",
    "integrations.sso.connection_ok": "Le point de découverte du fournisseur d’identité est accessible.",
    "Identity provider discovery is reachable.": "Le point de découverte du fournisseur d’identité est accessible.",
    "integrations.sso.connection_error": "Impossible de se connecter au fournisseur d’identité.",
    "Unable to connect to the identity provider.": "Impossible de se connecter au fournisseur d’identité.",
    "listing_configs.maximum_quantity_per_listing": "Quantité maximale par annonce",
    "listing_configs.example_quantity": "(Exemple : 100)",
    "listing_configs.enter_maximum_quantity": "Saisissez la quantité maximale par annonce",
    "Enter maximum quantity per listing": "Saisissez la quantité maximale par annonce",
    "listing_configs.minimum_listing_price": "Prix minimum de l’annonce",
    "listing_configs.example_price": "(Exemple : 5 $)",
    "listing_configs.enter_minimum_price": "Saisissez le prix minimum de l’annonce",
    "Enter minimum listing price": "Saisissez le prix minimum de l’annonce",
    "listing_configs.picture_count": "Nombre d’images téléversables",
    "listing_configs.enter_picture_count": "Saisissez le nombre d’images",
    "Enter Pictures count": "Saisissez le nombre d’images",
    "listing_configs.feature_activation": "ACTIVATION DES FONCTIONNALITÉS",
    "FEATURE ACTIVATION": "ACTIVATION DES FONCTIONNALITÉS",
    "listing_configs.example_landmark": "(Exemple : point de repère)",
    "listing_configs.enter_address_label": "Saisissez le libellé de l’adresse",
    "Enter address Label": "Saisissez le libellé de l’adresse",
    "listing_configs.legacy_switch_0": "Approuver automatiquement les annonces ?",
    "listing_configs.legacy_switch_1": "Pourcentage de l’offre",
    "listing_configs.legacy_switch_2": "Restrictions de quantité maximale au niveau de l’annonce",
    "listing_configs.legacy_switch_3": "Frais de livraison",
    "listing_configs.legacy_switch_4": "Utiliser le marqueur sur la carte au lieu de rechercher une adresse",
    "Use map marker instead \nof searching address": "Utiliser le marqueur sur la carte au lieu de rechercher une adresse",
    "listing_configs.legacy_switch_5": "Tags",
    "listing_configs.legacy_switch_6": "Stocks",
    "listing_configs.legacy_switch_7": "Adresse géographique",
    "listing_configs.legacy_switch_8": "Afficher les annonces en rupture de stock dans le fil",
    "listing_configs.legacy_switch_9": "Identifiant URL du titre de l’annonce",
    "listing_configs.legacy_switch_10": "Variantes",
    "listing_configs.legacy_switch_11": "Titre meta",
    "listing_configs.legacy_switch_12": "Description meta",
    "listing_configs.legacy_switch_13": "Produit numérique",
    "Digital Product": "Produit numérique",
    "listing_configs.legacy_switch_14": "Activer l’éditeur de texte",
    "listing_configs.legacy_switch_15": "Activer le poids",
    "listing_configs.legacy_switch_16": "Activer les dimensions",
    "navigation.app_download.close": "Fermer",
    "navigation.app_download.eyebrow": "Application mobile complémentaire",
    "Mobile companion": "Application mobile complémentaire",
    "navigation.app_download.title": "Faites avancer votre projet.",
    "Keep your project moving.": "Faites avancer votre projet.",
    "navigation.app_download.description": "Gérez l’essentiel depuis votre téléphone : approuvez des annonces, consultez les commandes et suivez votre activité.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Gérez l’essentiel depuis votre téléphone : approuvez des annonces, consultez les commandes et suivez votre activité.",
    "navigation.app_download.approve_listings": "Approuver les annonces",
    "Approve listings": "Approuver les annonces",
    "navigation.app_download.manage_orders": "Gérer les commandes",
    "Manage orders": "Gérer les commandes",
    "navigation.app_download.check_performance": "Consulter les performances",
    "Check performance": "Consulter les performances",
    "navigation.app_download.download_title": "Téléchargez l’application SuperAdmin",
    "Download the SuperAdmin app": "Téléchargez l’application SuperAdmin",
    "navigation.app_download.download_on": "Télécharger dans l’",
    "Download on the": "Télécharger dans l’",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Télécharger sur",
    "Get it on": "Télécharger sur",
    "listing_configs.address_label": "Libellé de l’adresse",
    "collections.add_another_condition": "+ Ajouter une condition",
    "collections.search": "Rechercher",
    "collections.status_inactive_active": "Statut (Inactif / Actif)",
    "media_picker.add_photo": "Ajouter une photo",
    "payments.payment_intent_webhook_secret": "Secret de webhook Payment Intent",
    "Payment Intent Webhook secret": "Secret de webhook Payment Intent",
    "payments.subscription_webhook_secret": "Secret de webhook d’abonnement",
    "Subscription Webhook secret": "Secret de webhook d’abonnement",
    "payments.webhook_secret_autofilled": "Le secret du webhook a été renseigné ci-dessus : enregistrez le formulaire pour le conserver.",
    "Webhook secret auto-filled above — save the form to persist.": "Le secret du webhook a été renseigné ci-dessus : enregistrez le formulaire pour le conserver.",
    "app_customization.white_png_icon_help": "l’icône doit être blanche au format PNG",
    "icon should be white and in png format": "l’icône doit être blanche au format PNG",
    "app_customization.other_appearance": "Autres éléments d’apparence",
    "Other appearance": "Autres éléments d’apparence",
    "app_customization.notification_icon": "Icône de notification",
    "Notification icon": "Icône de notification",
    "app_customization.app_title_home": "Titre de l’application sur l’écran d’accueil",
    "app_customization.enable_app_title_icon": "Utiliser une icône à la place du titre de l’application",
    "listings.quick_add.title": "Ajout rapide d’annonce",
    "Quick Add Listing": "Ajout rapide d’annonce",
    "listings.quick_add.success": "Annonce ajoutée avec succès",
    "Listing Added Successfully": "Annonce ajoutée avec succès",
    "listings.quick_add.image": "Image",
    "listings.quick_add.listing_name": "Nom de l’annonce",
    "Listing Name": "Nom de l’annonce",
    "listings.quick_add.title_placeholder": "ex. : casque sans fil haut de gamme",
    "e.g., Premium Wireless Headphones": "ex. : casque sans fil haut de gamme",
    "listings.quick_add.category": "Catégorie",
    "listings.quick_add.select_category": "Sélectionnez une catégorie",
    "listings.quick_add.price": "Prix",
    "listings.quick_add.stock": "Stock",
    "listings.quick_add.description": "Description",
    "listings.quick_add.description_placeholder": "Brève description de votre produit…",
    "Brief Description of your product...": "Brève description de votre produit…",
    "listings.quick_add.more_options": "Besoin de plus d’options ? Utilisez le formulaire complet",
    "Need more options? Use the full": "Besoin de plus d’options ? Utilisez le formulaire complet",
    "listings.quick_add.guided_form": "formulaire guidé",
    "guided form": "formulaire guidé",
    "listings.quick_add.instead": "à la place",
    "instead": "à la place",
    "listings.digital_product.title": "Ajouter un produit numérique",
    "Add Digital Product": "Ajouter un produit numérique",
    "listings.digital_product.select_file": "Sélectionner un fichier",
    "Select file": "Sélectionner un fichier",
    "listings.digital_product.name": "Titre",
    "listings.digital_product.version": "Version",
    "listings.digital_product.description": "Description",
    "web_config.social_info": "Informations sur les réseaux sociaux",
    "Social Info": "Informations sur les réseaux sociaux",
    "web_config.social_facebook_pageurl": "URL de la page Facebook",
    "Facebook page URL": "URL de la page Facebook",
    "web_config.enter_social_facebook_pageurl": "Saisissez url de la page facebook",
    "Enter Facebook page URL": "Saisissez url de la page facebook",
    "web_config.social_twitter_handleurl": "URL du profil Twitter",
    "Twitter handle URL": "URL du profil Twitter",
    "web_config.enter_social_twitter_handleurl": "Saisissez url du profil twitter",
    "Enter Twitter handle URL": "Saisissez url du profil twitter",
    "web_config.social_instagram_url": "URL Instagram",
    "Instagram URL": "URL Instagram",
    "web_config.enter_social_instagram_url": "Saisissez url instagram",
    "Enter Instagram URL": "Saisissez url instagram",
    "web_config.social_youtube_channelurl": "URL de la chaîne YouTube",
    "Youtube channel URL": "URL de la chaîne YouTube",
    "web_config.enter_social_youtube_channelurl": "Saisissez url de la chaîne youtube",
    "Enter Youtube channel URL": "Saisissez url de la chaîne youtube",
    "web_config.social_tiktok_url": "URL TikTok",
    "Tiktok URL": "URL TikTok",
    "web_config.enter_social_tiktok_url": "Saisissez url tiktok",
    "Enter Tiktok URL": "Saisissez url tiktok",
    "web_config.social_spotify_url": "URL Spotify",
    "Spotify URL": "URL Spotify",
    "web_config.enter_social_spotify_url": "Saisissez url spotify",
    "Enter Spotify URL": "Saisissez url spotify",
    "web_config.social_whatsapp_number": "Numéro WhatsApp",
    "Whatsapp number": "Numéro WhatsApp",
    "web_config.enter_social_whatsapp_number": "Saisissez numéro whatsapp",
    "Enter Whatsapp number": "Saisissez numéro whatsapp",
    "web_config.social_telegram_url": "URL Telegram",
    "Telegram URL": "URL Telegram",
    "web_config.enter_social_telegram_url": "Saisissez url telegram",
    "Enter Telegram URL": "Saisissez url telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Saisissez snapchat",
    "Enter Snapchat": "Saisissez snapchat",
    "payments.paydunya.title": "Intégration PayDunya",
    "PayDunya Integration": "Intégration PayDunya",
    "payments.paydunya.master_key": "Clé principale",
    "Master key": "Clé principale",
    "payments.paydunya.enter_master_key": "Saisissez la clé principale",
    "Enter master key": "Saisissez la clé principale",
    "payments.paydunya.public_key": "Clé publique",
    "Public key": "Clé publique",
    "payments.paydunya.enter_public_key": "Saisissez la clé publique",
    "payments.paydunya.private_key": "Clé privée",
    "Private key": "Clé privée",
    "payments.paydunya.enter_private_key": "Saisissez la clé privée",
    "Enter private key": "Saisissez la clé privée",
    "payments.paydunya.token": "Jeton",
    "payments.paydunya.enter_token": "Saisissez le jeton",
    "payments.paydunya.uploaded_successfully": "Enregistrement réussi",
    "communications.email_stats_open": "{sent} envoyés · {openRate} % ouverts",
    "{sent} sent · {openRate}% open": "{sent} envoyés · {openRate} % ouverts",
    "communications.email_stats_full": "{sent} envoyés · {openRate} % ouverts · {clicks} clics",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} envoyés · {openRate} % ouverts · {clicks} clics",
    "navigation.mini_apps.title": "Mini-applications",
    "Mini Apps": "Mini-applications",
    "navigation.mini_apps.subtitle": "Outils complémentaires de Tradly : sélectionnez une carte pour voir les détails et les tarifs",
    "Tradly-built companion tools — tap a card to see details and pricing": "Outils complémentaires de Tradly : sélectionnez une carte pour voir les détails et les tarifs",
    "navigation.mini_apps.soon": "Bientôt",
    "Soon": "Bientôt",
    "navigation.mini_apps.included_in_paid_plan": "Inclus dans une offre payante",
    "Included in a paid plan": "Inclus dans une offre payante",
    "navigation.mini_apps.know_more": "En savoir plus",
    "Know more": "En savoir plus",
    "navigation.mini_apps.hide_details": "Masquer les détails",
    "Hide details": "Masquer les détails",
    "navigation.mini_apps.view_plans": "Voir les offres",
    "navigation.mini_apps.remove": "Retirer",
    "navigation.mini_apps.add_to_sidebar": "Ajouter à la barre latérale",
    "Add to sidebar": "Ajouter à la barre latérale",
    "navigation.mini_apps.why_heading": "Pourquoi votre entreprise en a besoin",
    "Why your business needs it": "Pourquoi votre entreprise en a besoin",
    "navigation.mini_apps.coming_soon": "Bientôt disponible",
    "navigation.mini_apps.workflow.title": "Marketing",
    "navigation.mini_apps.workflow.description": "Lancez des campagnes e-mail, des notifications push et des promotions pour développer votre audience.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Lancez des campagnes e-mail, des notifications push et des promotions pour développer votre audience.",
    "navigation.mini_apps.workflow.why_1": "Envoyez des campagnes e-mail ciblées selon l’activité des acheteurs et vendeurs",
    "Send targeted email campaigns to buyers and sellers based on activity": "Envoyez des campagnes e-mail ciblées selon l’activité des acheteurs et vendeurs",
    "navigation.mini_apps.workflow.why_2": "Relancez par notification les utilisateurs absents depuis plus de 7 jours",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Relancez par notification les utilisateurs absents depuis plus de 7 jours",
    "navigation.mini_apps.workflow.why_3": "Programmez des coupons pour vos événements saisonniers",
    "Run promotions with coupon drops timed to your seasonal events": "Programmez des coupons pour vos événements saisonniers",
    "navigation.mini_apps.workflow.pricing_label": "À base de crédits",
    "Credits-based": "À base de crédits",
    "navigation.mini_apps.workflow.pricing_detail": "Payez par envoi : 1 000 e-mails coûtent 100 crédits, qui n’expirent jamais.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Payez par envoi : 1 000 e-mails coûtent 100 crédits, qui n’expirent jamais.",
    "navigation.mini_apps.intelligence_section.title": "Intelligence",
    "navigation.mini_apps.intelligence_section.description": "Comprenez votre croissance grâce aux analyses, aux tunnels et aux informations issues de l’IA.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Comprenez votre croissance grâce aux analyses, aux tunnels et aux informations issues de l’IA.",
    "navigation.mini_apps.intelligence_section.why_1": "Identifiez les annonces, comptes et catégories qui génèrent le plus de volume",
    "See which listings, accounts, and categories drive the most GMV": "Identifiez les annonces, comptes et catégories qui génèrent le plus de volume",
    "navigation.mini_apps.intelligence_section.why_2": "Repérez où les acheteurs quittent le parcours avant le paiement",
    "Drop-off funnels show exactly where buyers leave before checkout": "Repérez où les acheteurs quittent le parcours avant le paiement",
    "navigation.mini_apps.intelligence_section.why_3": "L’IA révèle des anomalies et des opportunités dans vos données",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "L’IA révèle des anomalies et des opportunités dans vos données",
    "navigation.mini_apps.intelligence_section.pricing_label": "À base de crédits",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Les analyses IA et rapports utilisent des crédits. La consultation des données reste gratuite.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Les analyses IA et rapports utilisent des crédits. La consultation des données reste gratuite.",
    "navigation.mini_apps.subscription_section.title": "Abonnements",
    "navigation.mini_apps.subscription_section.description": "Gérez les offres, cycles de facturation et droits fonctionnels de vos tenants.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Gérez les offres, cycles de facturation et droits fonctionnels de vos tenants.",
    "navigation.mini_apps.subscription_section.why_1": "Créez des offres par niveau avec accès par fonctionnalité",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Créez des offres par niveau avec accès par fonctionnalité",
    "navigation.mini_apps.subscription_section.why_2": "Automatisez les cycles mensuels, annuels ou personnalisés",
    "Automate billing cycles — monthly, annual, or custom durations": "Automatisez les cycles mensuels, annuels ou personnalisés",
    "navigation.mini_apps.subscription_section.why_3": "Ouvrez ou restreignez les fonctionnalités selon les droits du tenant",
    "Entitlements unlock or restrict features across your tenant base": "Ouvrez ou restreignez les fonctionnalités selon les droits du tenant",
    "navigation.mini_apps.subscription_section.pricing_label": "Connecter",
    "Connect": "Connecter",
    "navigation.mini_apps.subscription_section.pricing_detail": "Tarification à la tâche par événement d’abonnement : mise à niveau, renouvellement ou annulation.",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Tarification à la tâche par événement d’abonnement : mise à niveau, renouvellement ou annulation.",
    "navigation.mini_apps.membership_section.title": "Adhésion",
    "navigation.mini_apps.membership_section.description": "Gérez les programmes d’adhésion, les membres, les contributions et les paiements dus.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Gérez les programmes d’adhésion, les membres, les contributions et les paiements dus.",
    "navigation.mini_apps.membership_section.why_1": "Gérez les programmes et membres inscrits",
    "Manage membership programs and enrolled members": "Gérez les programmes et membres inscrits",
    "navigation.mini_apps.membership_section.why_2": "Suivez les contributions, échéances et statuts d’adhésion",
    "Track contributions, payment dues, and membership status": "Suivez les contributions, échéances et statuts d’adhésion",
    "navigation.mini_apps.membership_section.why_3": "Reliez les contributions des membres à leurs commandes",
    "Connect membership contributions back to their orders": "Reliez les contributions des membres à leurs commandes",
    "navigation.mini_apps.membership_section.pricing_label": "Tarification à confirmer",
    "Pricing TBC": "Tarification à confirmer",
    "navigation.mini_apps.membership_section.pricing_detail": "Gérez les programmes et l’historique des contributions au même endroit.",
    "Manage membership programs and contribution history in one place.": "Gérez les programmes et l’historique des contributions au même endroit.",
    "navigation.mini_apps.reward_programs.title": "Récompenses",
    "navigation.mini_apps.reward_programs.description": "Créez des programmes de récompenses avec périmètres, règles et modèles réutilisables.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Créez des programmes de récompenses avec périmètres, règles et modèles réutilisables.",
    "navigation.mini_apps.reward_programs.why_1": "Définissez des programmes d’affiliation, de parrainage, régionaux ou par boutique",
    "Define affiliate, referral, regional, or store reward programs": "Définissez des programmes d’affiliation, de parrainage, régionaux ou par boutique",
    "navigation.mini_apps.reward_programs.why_2": "Créez des règles avec des composants réutilisables",
    "Build rules from reusable commission and reward components": "Créez des règles avec des composants réutilisables",
    "navigation.mini_apps.reward_programs.why_3": "Confiez le calcul et l’écriture des récompenses au système ERP",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Confiez le calcul et l’écriture des récompenses au système ERP",
    "navigation.mini_apps.reward_programs.pricing_label": "Tarification à confirmer",
    "navigation.mini_apps.reward_programs.pricing_detail": "Configurez les programmes de récompenses et reliez-les à l’attribution.",
    "Configure reward programs and connect them to attribution.": "Configurez les programmes de récompenses et reliez-les à l’attribution.",
    "navigation.mini_apps.bundles_app.title": "Lots",
    "navigation.mini_apps.bundles_app.description": "Créez des lots fixes ou personnalisables à partir des annonces existantes.",
    "Create fixed and mix-and-match bundles from existing listings.": "Créez des lots fixes ou personnalisables à partir des annonces existantes.",
    "navigation.mini_apps.bundles_app.why_1": "Combinez des annonces sans dupliquer les données produit",
    "Combine existing listings without duplicating product data": "Combinez des annonces sans dupliquer les données produit",
    "navigation.mini_apps.bundles_app.why_2": "Proposez des lots fixes ou personnalisables par le client",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Proposez des lots fixes ou personnalisables par le client",
    "navigation.mini_apps.bundles_app.why_3": "Vérifiez les stocks avant le paiement et l’exécution",
    "Validate component stock before checkout and fulfilment": "Vérifiez les stocks avant le paiement et l’exécution",
    "navigation.mini_apps.bundles_app.pricing_label": "Fonctionnalité d’une offre payante",
    "Paid package feature": "Fonctionnalité d’une offre payante",
    "navigation.mini_apps.bundles_app.pricing_detail": "Disponible dans les offres incluant la gestion des lots.",
    "Available on plans that include bundle operations.": "Disponible dans les offres incluant la gestion des lots.",
    "navigation.mini_apps.inventory_section.title": "Chaîne logistique",
    "navigation.mini_apps.inventory_section.description": "Stocks, commandes d’achat, emplacements, fournisseurs et opérations.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Stocks, commandes d’achat, emplacements, fournisseurs et opérations.",
    "navigation.mini_apps.inventory_section.why_1": "Suivez les stocks dans plusieurs entrepôts et magasins",
    "Track stock levels across multiple warehouses and store locations": "Suivez les stocks dans plusieurs entrepôts et magasins",
    "navigation.mini_apps.inventory_section.why_2": "Créez des commandes fournisseurs et réceptionnez les articles",
    "Raise purchase orders with suppliers and receive stock against them": "Créez des commandes fournisseurs et réceptionnez les articles",
    "navigation.mini_apps.inventory_section.why_3": "Enregistrez ajustements, transferts et sorties de stock",
    "Record inventory operations — adjustments, transfers, and write-offs": "Enregistrez ajustements, transferts et sorties de stock",
    "navigation.mini_apps.inventory_section.pricing_label": "Inclus",
    "Included": "Inclus",
    "navigation.mini_apps.inventory_section.pricing_detail": "La chaîne logistique est incluse sans frais supplémentaires.",
    "Supply Chain is included in your plan. No additional charge.": "La chaîne logistique est incluse sans frais supplémentaires.",
    "navigation.mini_apps.people_app.title": "Personnel",
    "navigation.mini_apps.people_app.description": "Annuaire du personnel, services, profils de poste et grilles salariales.",
    "Staff directory, departments, job profiles, and pay grades.": "Annuaire du personnel, services, profils de poste et grilles salariales.",
    "navigation.mini_apps.people_app.why_1": "Centralisez profils, codes et types d’emploi dans un annuaire",
    "Keep every staff profile, code, and employment type in one directory": "Centralisez profils, codes et types d’emploi dans un annuaire",
    "navigation.mini_apps.people_app.why_2": "Organisez les équipes en services avec des profils standardisés",
    "Organise teams into departments with standard job profiles": "Organisez les équipes en services avec des profils standardisés",
    "navigation.mini_apps.people_app.why_3": "Définissez les grilles salariales et attribuez-les au personnel",
    "Define pay grades once and assign them to staff": "Définissez les grilles salariales et attribuez-les au personnel",
    "navigation.mini_apps.people_app.pricing_label": "Tarification à confirmer",
    "navigation.mini_apps.people_app.pricing_detail": "Nécessaire pour Workforce et Payroll.",
    "Required by Workforce and Payroll.": "Nécessaire pour Workforce et Payroll.",
    "navigation.mini_apps.workforce_app.title": "Équipes",
    "navigation.mini_apps.workforce_app.description": "Gestion des équipes, présences et congés.",
    "Shifts, attendance, and leave management for your team.": "Gestion des équipes, présences et congés.",
    "navigation.mini_apps.workforce_app.why_1": "Planifiez les équipes par date, heure et lieu",
    "Roster staff into shifts by date, time, and location": "Planifiez les équipes par date, heure et lieu",
    "navigation.mini_apps.workforce_app.why_2": "Suivez les pointages et l’historique de présence",
    "Clock in and out with a full attendance history": "Suivez les pointages et l’historique de présence",
    "navigation.mini_apps.workforce_app.why_3": "Gérez congés, soldes et validations",
    "Leave policies, balances, and an approve/reject workflow": "Gérez congés, soldes et validations",
    "navigation.mini_apps.workforce_app.pricing_label": "Tarification à confirmer",
    "navigation.mini_apps.workforce_app.pricing_detail": "Active automatiquement People.",
    "Turns on People automatically.": "Active automatiquement People.",
    "navigation.mini_apps.payroll_app.title": "Paie",
    "navigation.mini_apps.payroll_app.description": "Cycles de paie, validations, export CSV et remboursements.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Cycles de paie, validations, export CSV et remboursements.",
    "navigation.mini_apps.payroll_app.why_1": "Créez les cycles de paie selon les grilles salariales",
    "Create payroll runs per period from staff pay grades": "Créez les cycles de paie selon les grilles salariales",
    "navigation.mini_apps.payroll_app.why_2": "Validez et exportez les cycles en CSV pour votre banque ou comptable",
    "Approve runs and export them as CSV for your bank or accountant": "Validez et exportez les cycles en CSV pour votre banque ou comptable",
    "navigation.mini_apps.payroll_app.why_3": "Gérez les frais du personnel jusqu’au remboursement",
    "Staff expense claims from submission to reimbursement": "Gérez les frais du personnel jusqu’au remboursement",
    "navigation.mini_apps.payroll_app.pricing_label": "Tarification à confirmer",
    "navigation.mini_apps.payroll_app.pricing_detail": "Active automatiquement People.",
    "navigation.mini_apps.unified_inbox.title": "Boîte de réception unifiée",
    "Unified Inbox": "Boîte de réception unifiée",
    "navigation.mini_apps.unified_inbox.description": "Toutes les communications clients — commandes, assistance et chat — au même endroit.",
    "All your customer communication — orders, support, and chat — from one place.": "Toutes les communications clients — commandes, assistance et chat — au même endroit.",
    "navigation.mini_apps.unified_inbox.why_1": "Regroupez questions de commande, tickets et messages dans un fil",
    "Order queries, support tickets, and buyer messages in one thread view": "Regroupez questions de commande, tickets et messages dans un fil",
    "navigation.mini_apps.unified_inbox.why_2": "Répondez avec des suggestions IA entraînées sur votre catalogue",
    "Reply with AI-suggested responses trained on your catalogue": "Répondez avec des suggestions IA entraînées sur votre catalogue",
    "navigation.mini_apps.unified_inbox.why_3": "Étiquetez, attribuez et résolvez les conversations en équipe",
    "Tag, assign, and resolve conversations across your team": "Étiquetez, attribuez et résolvez les conversations en équipe",
    "navigation.mini_apps.unified_inbox.pricing_label": "Connecter",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Tarification à la tâche par conversation résolue.",
    "Task-based pricing per resolved conversation.": "Tarification à la tâche par conversation résolue.",
    "navigation.mini_apps.social_connect.title": "Réseaux sociaux",
    "Social Connect": "Réseaux sociaux",
    "navigation.mini_apps.social_connect.description": "Partagez les annonces sur les réseaux sociaux selon un calendrier défini.",
    "Share listings to social channels on a schedule you define.": "Partagez les annonces sur les réseaux sociaux selon un calendrier défini.",
    "navigation.mini_apps.social_connect.why_1": "Planifiez les annonces sur Instagram, Facebook et X",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Planifiez les annonces sur Instagram, Facebook et X",
    "navigation.mini_apps.social_connect.why_2": "Définissez un calendrier par canal, quotidien ou personnalisé",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Définissez un calendrier par canal, quotidien ou personnalisé",
    "navigation.mini_apps.social_connect.why_3": "Suivez clics et engagement depuis le tableau de bord",
    "Track clicks and engagement back to each listing from the dashboard": "Suivez clics et engagement depuis le tableau de bord",
    "navigation.mini_apps.social_connect.pricing_label": "Connecter",
    "navigation.mini_apps.social_connect.pricing_detail": "Tarification à la tâche par publication programmée.",
    "Task-based pricing per scheduled post delivered.": "Tarification à la tâche par publication programmée.",
    "navigation.mini_apps.shopping_channels.title": "Canaux de vente",
    "Shopping Channels": "Canaux de vente",
    "navigation.mini_apps.shopping_channels.description": "Connectez votre catalogue à TikTok Shop, Shopee, Meta Catalog, Uber Eats et d’autres plateformes.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Connectez votre catalogue à TikTok Shop, Shopee, Meta Catalog, Uber Eats et d’autres plateformes.",
    "navigation.mini_apps.shopping_channels.why_1": "Synchronisez vos annonces avec TikTok Shop, Shopee et Meta Catalog",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Synchronisez vos annonces avec TikTok Shop, Shopee et Meta Catalog",
    "navigation.mini_apps.shopping_channels.why_2": "Connectez les catalogues alimentaires à Uber Eats et Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Connectez les catalogues alimentaires à Uber Eats et Grab",
    "navigation.mini_apps.shopping_channels.why_3": "Synchronisez automatiquement stocks et commandes, sans double saisie",
    "Inventory and orders sync back automatically — no double-entry": "Synchronisez automatiquement stocks et commandes, sans double saisie",
    "navigation.mini_apps.shopping_channels.pricing_label": "Connecter",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Tarification à la tâche par commande exécutée via un canal connecté.",
    "Task-based pricing per order fulfilled through a connected channel.": "Tarification à la tâche par commande exécutée via un canal connecté.",
    "listing_configs.customize_table": "Personnaliser le tableau",
    "Customize table": "Personnaliser le tableau",
    "listing_configs.fields_visible": "Champs affichés dans le tableau",
    "Fields visible in table": "Champs affichés dans le tableau",
    "listing_configs.fields_hidden": "Champs masqués dans le tableau",
    "Fields not shown in table": "Champs masqués dans le tableau",
    "listing_configs.reset_default": "Rétablir les valeurs par défaut",
    "listing_configs.column_title": "Titre",
    "listing_configs.column_actions": "Actions",
    "listing_configs.column_website": "Site web",
    "listing_configs.column_list_price": "Prix catalogue",
    "listing_configs.column_offer_percent": "Pourcentage de réduction",
    "Offer Percent": "Pourcentage de réduction",
    "listing_configs.column_image": "Image",
    "listing_configs.column_offer_price": "Prix promotionnel",
    "Offer Price": "Prix promotionnel",
    "listing_configs.column_status": "Statut",
    "listing_configs.column_listing_id": "ID de l’annonce",
    "listing_configs.column_listing_status": "Statut de l’annonce",
    "listing_configs.column_accounts": "Comptes",
    "listing_configs.column_currency": "Devise",
    "listing_configs.column_sold": "Vendu",
    "listing_configs.column_goal_amount": "Montant de l’objectif",
    "Goal Amount": "Montant de l’objectif",
    "listing_configs.column_width": "Largeur",
    "listing_configs.column_height": "Hauteur",
    "listing_configs.column_weight": "Poids",
    "listing_configs.column_volume": "Volume",
    "Volume": "Volume",
    "listing_configs.column_order_type": "Type de commande",
    "Order Type": "Type de commande",
    "navigation.apps_group": "Applications",
    "navigation.channels_group": "Canaux",
    "navigation.manage_mini_apps": "Gérer les mini-applications",
    "Manage Mini Apps": "Gérer les mini-applications",
    "navigation.manage_channels": "Gérer les canaux",
    "Manage Channels": "Gérer les canaux",
    "listings.import.uploading": "Téléversement…",
    "listings.import.complete": "Importation terminée",
    "listings.import.error": "Erreur : {message}",
    "Error: {message}": "Erreur : {message}",
    "listings.import.file_label": "Fichier :",
    "listings.import.select_file": "Sélectionner un fichier",
    "listings.import.response": "Résultat de l’importation",
    "Import response": "Résultat de l’importation",
    "listings.import.total_rows": "Nombre total de lignes :",
    "Total rows:": "Nombre total de lignes :",
    "listings.import.total_imported": "Total importé :",
    "Total imported:": "Total importé :",
    "listings.import.download_template": "Télécharger le modèle d’annonces",
    "Download listings template": "Télécharger le modèle d’annonces",
    "common.upload": "Téléverser",
    "common.kanban_unavailable": "La vue tableau est temporairement indisponible",
    "Board view is temporarily unavailable": "La vue tableau est temporairement indisponible",
    "common.retry": "Réessayer",
    "Retry": "Réessayer",
    "listings.digital_assets.title": "Ressources numériques",
    "Digital assets": "Ressources numériques",
    "listings.digital_assets.not_found": "Aucune ressource numérique trouvée",
    "Digital assets not found": "Aucune ressource numérique trouvée",
    "listings.addon.saved": "Option enregistrée avec succès.",
    "Add-on saved successfully.": "Option enregistrée avec succès.",
    "listings.addon.title_required": "Veuillez saisir un titre.",
    "Please enter a title.": "Veuillez saisir un titre.",
    "listings.addon.price_required": "Veuillez saisir un prix.",
    "Please enter a price.": "Veuillez saisir un prix.",
    "listings.addon.no_media": "Vous ne disposez d’aucun fichier média.",
    "listings.addon.price": "Prix",
    "listings.addon.offer_percentage": "Pourcentage de l’offre",
    "Offer Percentage": "Pourcentage de l’offre",
    "listings.addon.maximum_quantity": "Quantité maximale",
    "Maximum Quantity": "Quantité maximale",
    "listings.addon.stock": "Stock",
    "listings.addon.enter_price": "Saisissez le prix",
    "Enter price": "Saisissez le prix",
    "listings.addon.enter_offer_percentage": "Saisissez le pourcentage de l’offre",
    "Enter offer percentage": "Saisissez le pourcentage de l’offre",
    "listings.addon.enter_maximum_quantity": "Saisissez la quantité maximale",
    "Enter maximum quantity": "Saisissez la quantité maximale",
    "listings.addon.enter_stock": "Saisissez le stock",
    "listings.addon.edit_title": "Modifier l’option",
    "Edit Add-on": "Modifier l’option",
    "listings.addon.add_title": "Ajouter une option",
    "Add Add-on": "Ajouter une option",
    "listings.addon.title": "Titre",
    "listings.addon.enter_title": "Saisissez le titre",
    "listings.addon.status": "Statut (Inactif / Actif)",
    "listings.addon.upload_media": "Téléverser un média",
    "attributes.prefill_for": "Préremplir pour",
    "Prefill for": "Préremplir pour",
    "attributes.first_item": "Premier élément",
    "First Item": "Premier élément",
    "attributes.all_items": "Tous les éléments",
    "All Items": "Tous les éléments",
    "common.uploading": "Téléversement…",
    "common.uploading_named": "Téléversement de {title}",
    "Uploading {title}": "Téléversement de {title}",
    "common.please_wait_short": "Veuillez patienter",
    "Please wait": "Veuillez patienter",
    "attributes.select_option": "Sélectionner",
    "attributes.select_value": "Sélectionner une valeur…",
    "Select value...": "Sélectionner une valeur…",
    "attributes.type_placeholder": "Saisissez {name}",
    "Type {name}": "Saisissez {name}",
    "attributes.multiple_values_placeholder": "Vous pouvez saisir plusieurs valeurs en les séparant par une virgule.",
    "Using a comma, you can enter several values.": "Vous pouvez saisir plusieurs valeurs en les séparant par une virgule.",
    "attributes.upload_attachment": "Téléverser une pièce jointe",
    "Upload Attachment": "Téléverser une pièce jointe",
    "attributes.upload_json_file": "Téléverser un fichier JSON",
    "Upload JSON File": "Téléverser un fichier JSON",
    "attributes.copied_value": "Valeur copiée",
    "Copied the value": "Valeur copiée",
    "attributes.latitude_longitude_placeholder": "Saisissez latitude,longitude (ex. : 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Saisissez latitude,longitude (ex. : 12.34,56.78)",
    "navigation.sidebar_label": "Barre latérale",
    "Side bar": "Barre latérale",
    "checkout_settings.orders_option_0": "Vue calendrier des commandes",
    "Orders Calendar View": "Vue calendrier des commandes",
    "checkout_settings.show_cart_attributes": "Afficher les attributs du panier",
    "Show cart attributes": "Afficher les attributs du panier",
    "checkout_settings.select_order_status": "Sélectionnez le statut de commande",
    "Select order status": "Sélectionnez le statut de commande",
    "checkout_settings.order_status_0": "Commande passée",
    "Placed success": "Commande passée",
    "checkout_settings.order_status_1": "En cours",
    "In process": "En cours",
    "checkout_settings.order_status_2": "Expédiée",
    "checkout_settings.order_status_3": "Livrée",
    "checkout_settings.order_status_4": "Terminée",
    "listing_form.no_categories_found": "Aucune catégorie trouvée. Utilisez « {action} » ci-dessus.",
    "No categories found. Use “{action}” above.": "Aucune catégorie trouvée. Utilisez « {action} » ci-dessus.",
    "common.learn_more": "En savoir plus",
    "Learn more": "En savoir plus",
    "common.show_information": "Afficher les informations",
    "Show information": "Afficher les informations",
    "common.paid_feature": "Fonctionnalité payante",
    "Paid Feature": "Fonctionnalité payante",
    "common.learn_more_about": "En savoir plus sur",
    "Learn more about": "En savoir plus sur",
    "attributes.categories": "Catégories",
    "attributes.edit_bulk_title": "Modification groupée : {title}",
    "{title} Edit Bulk": "Modification groupée : {title}",
    "common.enter_description": "Saisissez une description",
    "common.empty_fetch_message": "Rien à afficher pour le moment. Le contenu apparaîtra sur cette page lorsqu’il sera disponible.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Rien à afficher pour le moment. Le contenu apparaîtra sur cette page lorsqu’il sera disponible.",
    "common.ai_credits_and_top_up": "Crédits IA et recharge",
    "AI credits and top up": "Crédits IA et recharge",
    "common.ai_credits_loading": "Chargement des crédits IA",
    "Loading AI credits": "Chargement des crédits IA",
    "common.ai_credits_unavailable": "Crédits IA indisponibles",
    "AI credits unavailable": "Crédits IA indisponibles",
    "common.ai_credits_available": "Crédits IA disponibles : {count}",
    "Available AI credits: {count}": "Crédits IA disponibles : {count}",
    "common.ai_credits_unavailable_top_up": "Crédits IA indisponibles — cliquez pour recharger",
    "AI credits unavailable — click to top up": "Crédits IA indisponibles — cliquez pour recharger",
    "common.ai_credits_available_top_up": "Crédits IA disponibles : {count} — cliquez pour en ajouter",
    "Available AI credits: {count} — click to add credits": "Crédits IA disponibles : {count} — cliquez pour en ajouter",
    "common.ai_credits_add": "Ajouter des crédits",
    "Add credits": "Ajouter des crédits",
    "navigation.switch_project": "Changer de projet",
    "Switch Project": "Changer de projet",
    "navigation.tenant_switch_failed": "Le changement d’espace a échoué. Réessayez.",
    "Tenant switch failed. Please try again.": "Le changement d’espace a échoué. Réessayez.",
    "navigation.select_project": "Sélectionner un projet",
    "Select Project": "Sélectionner un projet",
    "navigation.collapse_sidebar": "Réduire la barre latérale",
    "Collapse sidebar": "Réduire la barre latérale",
    "navigation.expand_sidebar": "Développer la barre latérale",
    "Expand sidebar": "Développer la barre latérale",
    "navigation.search": "Rechercher",
    "navigation.loading": "Chargement de la navigation",
    "Loading navigation": "Chargement de la navigation",
    "navigation.help_documentation": "Documentation",
    "navigation.help_community": "Communauté",
    "navigation.help_api_reference": "Référence API",
    "listings.quick_form": "Formulaire rapide",
    "Quick Form": "Formulaire rapide",
    "payments.notification_secret": "Secret de notification",
    "Notification Secret": "Secret de notification",
    "payments.user_type": "Type d’utilisateur",
    "User Type": "Type d’utilisateur",
    "payments.category_id": "ID de catégorie",
    "app_customization.other_settings": "Autres paramètres",
    "Other Settings": "Autres paramètres",
    "app_customization.other_hide_balances": "Masquer les soldes et les paiements dans la section Plus",
    "app_customization.other_enable_logs": "Activer les journaux",
    "Enable logs": "Activer les journaux",
    "app_customization.other_signup_first": "Afficher l’inscription en premier",
    "common.beta": "(bêta)",
    "(beta)": "(bêta)",
    "common.selected_image": "Image sélectionnée",
    "Selected image": "Image sélectionnée",
    "common.ai_no_response_to_copy": "Aucune réponse à copier",
    "No response to copy": "Aucune réponse à copier",
    "common.copied_to_clipboard": "Copié dans le presse-papiers",
    "Copied to clipboard": "Copié dans le presse-papiers",
    "common.ai_suggestions": "Suggestions",
    "Suggestions": "Suggestions",
    "common.regenerate": "Régénérer",
    "Regenerate": "Régénérer",
    "common.esc": "Échap",
    "ESC": "Échap",
    "common.json_icon_alt": "Icône JSON",
    "JSON icon": "Icône JSON",
    "collections.generator_title": "Générateur de collections",
    "Collection Generator": "Générateur de collections",
    "collections.generator_create": "Créer une collection",
    "collections.generator_json_placeholder": "Saisissez le JSON",
    "Enter JSON input": "Saisissez le JSON",
    "collections.generator_invalid_data": "Saisissez des données valides",
    "Please enter valid data": "Saisissez des données valides",
    "category.editor_select_from_media": "Sélectionner dans les médias",
    "payments.subscription": "Abonnement",
    "payments.subscription_setting_up": "Configuration en cours…",
    "Setting up...": "Configuration en cours…",
    "payments.subscription_webhook_configured": "Webhook d’abonnement configuré",
    "Subscription webhook configured": "Webhook d’abonnement configuré",
    "payments.subscription_retry_setup": "Réessayer la configuration",
    "Retry setup": "Réessayer la configuration",
    "payments.setup_subscription_webhook": "Configurer le webhook d’abonnement",
    "Setup Subscription Webhook": "Configurer le webhook d’abonnement",
    "orders.shipment_number": "Expédition {number}",
    "Shipment {number}": "Expédition {number}",
    "orders.quantity_short": "Qté",
    "orders.shipment_status_1": "Expédition créée",
    "orders.shipment_status_2": "Expédition en cours",
    "orders.shipment_status_3": "Expédiée",
    "orders.shipment_status_4": "Prête à être récupérée",
    "orders.shipment_status_5": "En cours de livraison",
    "orders.shipment_status_6": "Retour non livré",
    "orders.shipment_status_7": "Expédition livrée",
    "orders.shipment_status_8": "Livraison de l’expédition confirmée",
    "orders.shipment_status_9": "Retour initié",
    "orders.shipment_status_10": "Retour récupéré",
    "orders.shipment_status_11": "Retour de l’expédition confirmé",
    "orders.shipment_status_12": "Annulée par le vendeur",
    "orders.shipment_status_13": "Annulée par le client",
    "orders.shipment_status_14": "Arrivée chez le client",
    "orders.shipment_status_15": "Annulée par l’administrateur",
    "attributes.metadata_title": "Métadonnées",
    "Metadata": "Métadonnées",
    "common.add_row": "Ajouter une ligne",
    "common.no_access": "Vous n’avez pas accès",
    "You don't have access": "Vous n’avez pas accès",
    "common.error_404_message": "Désolé, la page recherchée est indisponible. Vérifiez l’URL et réessayez, ou revenez plus tard. Si le problème persiste, contactez notre équipe d’assistance. Merci de votre compréhension.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "Désolé, la page recherchée est indisponible. Vérifiez l’URL et réessayez, ou revenez plus tard. Si le problème persiste, contactez notre équipe d’assistance. Merci de votre compréhension.",
    "accounts.smart_upload_beta_label": "(Bêta)",
    "orders.transaction_direction": "Sens de la transaction",
    "Transaction direction": "Sens de la transaction",
    "category.default_text": "Texte par défaut",
    "collections.generator_open": "Ouvrir le générateur de collections",
    "Open collection generator": "Ouvrir le générateur de collections",
    "collections.duplicate_success": "Collection dupliquée avec succès",
    "Collection duplicated successfully": "Collection dupliquée avec succès",
    "collections.duplicate_failed": "Échec de la duplication de la collection",
    "Failed to duplicate collection": "Échec de la duplication de la collection",
    "listings.name_required": "Le nom de l’annonce est obligatoire",
    "Listing Name is required": "Le nom de l’annonce est obligatoire",
    "listings.category_required": "La catégorie est obligatoire",
    "Category is required": "La catégorie est obligatoire",
    "attribute_groups.edit_title": "Modifier le groupe d’attributs",
    "Edit Attribute Group": "Modifier le groupe d’attributs",
    "orders.create_order.validation.select_shipping_method": "Veuillez sélectionner un mode d’expédition",
    "Please select shipping method": "Veuillez sélectionner un mode d’expédition",
    "orders.create_order.validation.shipping_method_error": "Erreur de mode d’expédition",
    "Shipping Method Error": "Erreur de mode d’expédition",
    "orders.create_order.validation.select_shipping_address": "Veuillez sélectionner une adresse de livraison",
    "Please select shipping address": "Veuillez sélectionner une adresse de livraison",
    "orders.create_order.validation.shipping_address_error": "Erreur d’adresse de livraison",
    "Shipping Address Error": "Erreur d’adresse de livraison",
    "orders.create_order.validation.select_shipment_method": "Veuillez sélectionner un mode d’envoi",
    "Please select shipment method": "Veuillez sélectionner un mode d’envoi",
    "orders.create_order.validation.shipment_method_error": "Erreur de mode d’envoi",
    "Shipment Method Error": "Erreur de mode d’envoi",
    "orders.create_order.validation.select_payment_method": "Veuillez sélectionner un mode de paiement",
    "Please select payment method": "Veuillez sélectionner un mode de paiement",
    "orders.create_order.validation.payment_method_error": "Erreur de mode de paiement",
    "Payment Method Error": "Erreur de mode de paiement",
    "orders.create_order.validation.insufficient_balance": "Solde insuffisant",
    "Insufficient balance": "Solde insuffisant",
    "orders.create_order.validation.wallet_error": "Erreur de portefeuille",
    "Wallet Error": "Erreur de portefeuille",
    "attributes.value.preview_item": "Aperçu {count}",
    "Preview {count}": "Aperçu {count}",
    "attributes.value.click_to_upload": "Cliquez pour téléverser {type}",
    "Click to upload {type}": "Cliquez pour téléverser {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF, jusqu’à 5 fichiers",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF, jusqu’à 5 fichiers",
    "attributes.value.audio_upload_formats": "MP3, WAV, jusqu’à 1 fichier",
    "MP3, WAV up to 1 file": "MP3, WAV, jusqu’à 1 fichier",
    "attributes.value.video_upload_formats": "MP4, MOV, jusqu’à 1 fichier",
    "MP4, MOV up to 1 file": "MP4, MOV, jusqu’à 1 fichier",
    "attributes.value.upload_limit": "Téléversez des fichiers {type} (maximum : {count})",
    "Upload {type} files (Max {count})": "Téléversez des fichiers {type} (maximum : {count})",
    "attributes.value.json_format_failed": "JSON invalide : mise en forme impossible",
    "Invalid JSON - cannot format": "JSON invalide : mise en forme impossible",
    "attributes.value.json_file_invalid": "Veuillez sélectionner un fichier JSON valide",
    "Please select a valid JSON file": "Veuillez sélectionner un fichier JSON valide",
    "attributes.value.file_empty": "Le fichier est vide",
    "File is empty": "Le fichier est vide",
    "attributes.value.json_file_parse_failed": "Fichier JSON invalide : {message}",
    "Invalid JSON file: {message}": "Fichier JSON invalide : {message}",
    "attributes.value.file_read_failed": "Échec de la lecture du fichier",
    "Failed to read file": "Échec de la lecture du fichier",
    "attributes.value.invalid_json": "JSON invalide",
    "Invalid JSON": "JSON invalide",
    "attributes.value.json_editor_help": "Téléversez un fichier JSON ou saisissez/collez le contenu directement",
    "Upload a JSON file or type/paste JSON directly": "Téléversez un fichier JSON ou saisissez/collez le contenu directement",
    "attributes.value.hex_color_code": "Code couleur hexadécimal",
    "Hex Color Code": "Code couleur hexadécimal",
    "attributes.value.multi_text_placeholder": "Saisissez une valeur, puis appuyez sur Entrée ou une virgule pour l’ajouter",
    "Type and press Enter or comma to add": "Saisissez une valeur, puis appuyez sur Entrée ou une virgule pour l’ajouter",
    "attributes.value.multi_text_help": "Appuyez sur Entrée ou une virgule pour ajouter chaque élément",
    "Press Enter or comma to add each item": "Appuyez sur Entrée ou une virgule pour ajouter chaque élément",
    "attributes.value.item_count": "{count} élément",
    "{count} item": "{count} élément",
    "attributes.value.items_count": "{count} éléments",
    "attributes.value.search_options": "Rechercher {name}…",
    "Search {name}...": "Rechercher {name}…",
    "attributes.value.selected_count": "{count} sélectionné(s)",
    "attributes.value.no_options_found": "Aucune option trouvée",
    "No options found": "Aucune option trouvée",
    "attributes.value.select_named_option": "Sélectionnez {name}",
    "Select {name}": "Sélectionnez {name}",
    "attributes.value.enable_option": "Activer cette option",
    "Enable this option": "Activer cette option",
    "attributes.value.enter_named_value": "Saisissez {name}",
    "Enter {name}": "Saisissez {name}",
    "common.valid": "Valide",
    "Valid": "Valide",
    "common.invalid": "Invalide",
    "Invalid": "Invalide",
    "common.go_back_home": "Retour à l’accueil",
    "Go back home": "Retour à l’accueil",
    "attributes.value.enter_named_text": "Saisissez {name}…",
    "Enter {name}...": "Saisissez {name}…",
    "listings.analytics.page_views": "Vues de page",
    "listings.analytics.unique_visitors": "Visiteurs uniques",
    "listings.analytics.sessions": "Sessions",
    "listings.analytics.clicks": "Clics",
    "listings.analytics.goals": "Objectifs",
    "listings.analytics.bot_views": "Vues des robots",
    "listings.detail_summary.buyers": "Acheteurs",
    "Buyers": "Acheteurs",
    "listings.detail_summary.orders": "Commandes",
    "listings.detail_summary.revenue": "Revenus",
    "listings.detail_summary.average_order": "Commande moyenne",
    "listings.add_advanced": "Avancé",
    "listings.add_audio": "Ajouter un contenu audio",
    "Add Audio": "Ajouter un contenu audio",
    "payments.updated_successfully": "Mis à jour avec succès",
    "Updated successfully": "Mis à jour avec succès",
    "users.deleted_successfully": "Utilisateur supprimé avec succès",
    "User deleted successfully": "Utilisateur supprimé avec succès",
    "users.deletion_failed": "Échec de la suppression de l’utilisateur",
    "User deletion failed": "Échec de la suppression de l’utilisateur",
    "accounts.flow.title": "Définissez l’expérience de vos comptes",
    "Shape the account experience": "Définissez l’expérience de vos comptes",
    "accounts.flow.description": "Organisez les types de comptes et définissez les informations nécessaires pour chacun.",
    "Organize account types and define the information each account needs.": "Organisez les types de comptes et définissez les informations nécessaires pour chacun.",
    "accounts.flow.lane_title": "Fondations des comptes",
    "Account foundation": "Fondations des comptes",
    "accounts.flow.badge": "Structure",
    "Structure": "Structure",
    "accounts.flow.node_accounts": "Comptes",
    "accounts.flow.node_categories": "Catégories",
    "accounts.flow.node_attributes": "Attributs",
    "accounts.flow.lane_description": "Attribuez à chaque compte une catégorie, un type et les informations utiles.",
    "Give every account a clear place, type, and set of useful details.": "Attribuez à chaque compte une catégorie, un type et les informations utiles.",
    "accounts.flow.primary_action": "Ajoutez votre premier compte",
    "Add your first account": "Ajoutez votre premier compte",
    "listings.flow.title": "Créez votre catalogue d’annonces",
    "Build your listing catalog": "Créez votre catalogue d’annonces",
    "listings.flow.description": "Créez un catalogue structuré avec des catégories, des attributs et des variantes.",
    "Create a structured catalog with categories, attributes, and variants.": "Créez un catalogue structuré avec des catégories, des attributs et des variantes.",
    "listings.flow.lane_title": "Parcours du catalogue",
    "Catalog path": "Parcours du catalogue",
    "listings.flow.badge": "Créer",
    "Build": "Créer",
    "listings.flow.node_listings": "Annonces",
    "listings.flow.node_categories": "Catégories",
    "listings.flow.node_attributes": "Attributs",
    "listings.flow.node_variants": "Variantes",
    "listings.flow.lane_description": "Définissez votre offre et les informations dont les clients ont besoin pour choisir.",
    "Define what you sell and the information customers need to make a choice.": "Définissez votre offre et les informations dont les clients ont besoin pour choisir.",
    "listings.flow.primary_action": "Ajoutez votre première annonce",
    "Add your first listing": "Ajoutez votre première annonce",
    "collections.flow.title": "Rassemblez le contenu de votre marketplace",
    "Bring your marketplace content together": "Rassemblez le contenu de votre marketplace",
    "collections.flow.description": "Regroupez les annonces et les comptes dans des collections faciles à trouver et à gérer.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Regroupez les annonces et les comptes dans des collections faciles à trouver et à gérer.",
    "collections.flow.lane_title": "Parcours des collections",
    "Collection path": "Parcours des collections",
    "collections.flow.badge": "Organiser",
    "Curate": "Organiser",
    "collections.flow.node_collections": "Collections",
    "collections.flow.node_rules": "Règles",
    "collections.flow.node_listings": "Annonces",
    "collections.flow.lane_description": "Choisissez les éléments à regrouper et aidez vos clients à les trouver.",
    "Choose what belongs together and make it easy for customers to find.": "Choisissez les éléments à regrouper et aidez vos clients à les trouver.",
    "collections.flow.audience_lane_title": "Parcours de l’audience",
    "Audience path": "Parcours de l’audience",
    "collections.flow.audience_badge": "Connecter",
    "collections.flow.node_accounts": "Comptes",
    "collections.flow.node_users": "Utilisateurs",
    "collections.flow.node_storefront": "Vitrine",
    "Storefront": "Vitrine",
    "collections.flow.audience_description": "Reliez le contenu organisé aux personnes et aux vitrines auxquelles il est destiné.",
    "Connect curated content to the people and storefronts it is meant for.": "Reliez le contenu organisé aux personnes et aux vitrines auxquelles il est destiné.",
    "collections.flow.primary_action": "Créez votre première collection",
    "listings.addon.image_limit": "Vous ne pouvez pas sélectionner davantage d’images.",
    "listings.schedule.start_time_before_end": "L’heure de début doit précéder l’heure de fin.",
    "Start time must be before the end time": "L’heure de début doit précéder l’heure de fin.",
    "listings.schedule.end_time_after_start": "L’heure de fin doit suivre l’heure de début.",
    "End time must be after the start time": "L’heure de fin doit suivre l’heure de début.",
    "listings.schedule.repeat_required": "Sélectionnez une récurrence.",
    "Select a repeat pattern": "Sélectionnez une récurrence.",
    "listing_variants.form.select_type": "Sélectionnez un type de variante",
    "Select variant type": "Sélectionnez un type de variante",
    "listing_variants.form.select_type_values": "Sélectionnez les valeurs de variante",
    "Select variant values": "Sélectionnez les valeurs de variante",
    "listing_variants.form.add_variant": "Ajouter une variante",
    "listing_variants.form.edit_variant": "Modifier la variante",
    "Edit variant": "Modifier la variante",
    "listing_variants.form.variant_type": "Type de variante",
    "Variant type": "Type de variante",
    "listing_variants.form.variant_type_value": "Valeur de variante",
    "Variant value": "Valeur de variante",
    "listing_variants.form.variant_name": "Nom de la variante",
    "Variant name": "Nom de la variante",
    "listing_variants.form.description_placeholder": "Saisissez une description",
    "rewards.item_archived": "Archivé",
    "listings.confirm_delete_variant": "Voulez-vous vraiment supprimer cette variante ?",
    "listings.confirm_delete_listing": "Voulez-vous vraiment supprimer cette annonce ?",
    "listing_form.digital_delete_confirm": "Voulez-vous vraiment supprimer ce contenu numérique ?",
    "Are you sure you want to delete this digital content?": "Voulez-vous vraiment supprimer ce contenu numérique ?",
    "category.confirm_delete_attribute": "Voulez-vous supprimer cet attribut ?",
    "common.permission_required": "Vous n’avez pas l’autorisation d’effectuer cette action.",
    "You do not have permission to perform this action.": "Vous n’avez pas l’autorisation d’effectuer cette action.",
    "common.copied": "Copié",
    "attributes.editor_name_required": "Veuillez saisir le nom de l’attribut",
    "onboarding.full_step.setup_payments.description": "Activez les transactions réelles pour que les utilisateurs puissent concrétiser leur intention sans difficulté.",
    "Enable real transactions so users can complete intent without friction.": "Activez les transactions réelles pour que les utilisateurs puissent concrétiser leur intention sans difficulté.",
    "onboarding.full_step.setup_payments.cta": "Configurer les paiements",
    "Setup payments": "Configurer les paiements",
    "onboarding.full_step.setup_payments.impact": "Le parcours de revenus est activé.",
    "Revenue path enabled.": "Le parcours de revenus est activé.",
    "onboarding.full_step.setup_payments.creator_description": "Préparez le parcours qui permettra à votre public d’acheter ou de soutenir votre travail.",
    "Prepare the path for your audience to purchase or support your work.": "Préparez le parcours qui permettra à votre public d’acheter ou de soutenir votre travail.",
    "onboarding.full_step.setup_delivery.description": "Définissez le mode de traitement des commandes pour rendre le paiement prévisible.",
    "onboarding.full_step.setup_delivery.impact": "Le mode d’exécution des commandes est défini.",
    "Fulfillment path clear.": "Le mode d’exécution des commandes est défini.",
    "onboarding.full_step.add_promotion.description": "Créez votre première promotion pour encourager l’action dès la première visite.",
    "Create your first promotion to increase first-session action rate.": "Créez votre première promotion pour encourager l’action dès la première visite.",
    "onboarding.full_step.add_promotion.impact": "Améliorez la conversion au lancement.",
    "Stronger conversion during launch.": "Améliorez la conversion au lancement.",
    "onboarding.full_step.create_coupon.description": "Testez des réductions pour encourager les premiers achats ou l’adhésion.",
    "Test discounts and improve activation for first-time buyers or members.": "Testez des réductions pour encourager les premiers achats ou l’adhésion.",
    "onboarding.full_step.create_coupon.impact": "Votre première boucle promotionnelle est activée.",
    "First-offer loop unlocked.": "Votre première boucle promotionnelle est activée.",
    "onboarding.full_step.collections_setup.description": "Organisez les annonces qui suscitent le plus d’intérêt pour faciliter leur découverte et la navigation.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Organisez les annonces qui suscitent le plus d’intérêt pour faciliter leur découverte et la navigation.",
    "onboarding.full_step.collections_setup.impact": "La navigation et la découverte sont améliorées.",
    "Navigation and discovery improved.": "La navigation et la découverte sont améliorées.",
    "onboarding.full_step.configure_comms.description": "Préparez les notifications d’inscription et de commande avant le développement de votre activité.",
    "Make post-signup and order notifications production-ready before growth.": "Préparez les notifications d’inscription et de commande avant le développement de votre activité.",
    "onboarding.full_step.configure_comms.impact": "Les communications du cycle de vie sont prêtes.",
    "Lifecycle messaging ready.": "Les communications du cycle de vie sont prêtes.",
    "onboarding.full_step.customize_attributes.description": "Ajoutez des champs structurés pour aider les utilisateurs à filtrer et comparer les éléments importants.",
    "onboarding.full_step.customize_attributes.impact": "Améliorez la recherche et la conversion.",
    "Better search and conversion.": "Améliorez la recherche et la conversion.",
    "onboarding.full_step.customize_attributes.creator_description": "Ajoutez les détails qui aident votre public à comprendre et comparer vos créations.",
    "Add the details that help people understand and compare what you create.": "Ajoutez les détails qui aident votre public à comprendre et comparer vos créations.",
    "onboarding.full_step.add_digital_asset.description": "Élargissez votre catalogue initial pour permettre aux utilisateurs d’évaluer la qualité et le choix.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Élargissez votre catalogue initial pour permettre aux utilisateurs d’évaluer la qualité et le choix.",
    "onboarding.full_step.add_digital_asset.impact": "La crédibilité du catalogue numérique est renforcée.",
    "Digital catalog credibility improved.": "La crédibilité du catalogue numérique est renforcée.",
    "onboarding.full_step.open_live_site.description": "Commencez par ce que voient les clients. Le produit devient concret avant même la configuration.",
    "onboarding.full_step.open_live_site.impact": "Confirmez que le projet est déjà en ligne.",
    "onboarding.full_step.add_first_product.description": "Publiez le premier produit, service ou contenu que vous souhaitez faire découvrir à votre public.",
    "Publish the first product, service, or resource you want your audience to discover.": "Publiez le premier produit, service ou contenu que vous souhaitez faire découvrir à votre public.",
    "onboarding.full_step.add_first_product.impact": "Créez votre première offre prête à être présentée à votre public.",
    "Creates your first audience-ready offer.": "Créez votre première offre prête à être présentée à votre public.",
    "onboarding.full_step.customize_attributes.creator_impact": "Votre offre devient plus facile à comprendre.",
    "Makes your offer easier to understand.": "Votre offre devient plus facile à comprendre.",
    "onboarding.full_step.setup_payments.creator_impact": "Ouvrez la voie aux revenus.",
    "listings.detail_preview_fx.title": "Aperçu des devises",
    "Preview FX": "Aperçu des devises",
    "listings.detail_preview_fx.base": "Devise de base",
    "Base": "Devise de base",
    "listings.detail_preview_fx.description": "Affichez cette annonce dans chaque devise active.",
    "See this listing in each active currency.": "Affichez cette annonce dans chaque devise active.",
    "listings.detail_preview_fx.refresh": "Actualiser l’aperçu",
    "Refresh preview": "Actualiser l’aperçu",
    "listings.detail_preview_fx.loading_rates": "Chargement des taux de change…",
    "Loading exchange rates…": "Chargement des taux de change…",
    "listings.detail_preview_fx.load_hint": "Sélectionnez Aperçu des devises pour charger les taux actuels.",
    "Select Preview FX to load current rates.": "Sélectionnez Aperçu des devises pour charger les taux actuels.",
    "listings.detail_preview_fx.preview_note": "Aperçu uniquement. Les prix enregistrés de l’annonce restent inchangés.",
    "Preview only. Saved listing prices remain unchanged.": "Aperçu uniquement. Les prix enregistrés de l’annonce restent inchangés.",
    "listings.detail_preview_fx.listing": "Annonce",
    "listings.detail_preview_fx.variant": "Variante",
    "Variant": "Variante",
    "listings.detail_event_booking.event_details": "Détails de l’événement",
    "Event Details": "Détails de l’événement",
    "listings.detail_event_booking.booking_details": "Détails de la réservation",
    "Booking Details": "Détails de la réservation",
    "listings.unassigned_location": "Emplacement non attribué",
    "Unassigned location": "Emplacement non attribué",
    "listings.no_ratings_yet": "Aucune note pour le moment",
    "No ratings yet": "Aucune note pour le moment",
    "listing_form.loading_listing": "Chargement de l’annonce…",
    "Loading listing…": "Chargement de l’annonce…",
    "listing_form.preparing_form": "Préparation du formulaire…",
    "Preparing form…": "Préparation du formulaire…",
    "listing_form.edit_listing": "Modifier l’annonce",
    "Edit Listing": "Modifier l’annonce",
    "listing_form.add_new_listing": "Ajouter une annonce",
    "Add New Listing": "Ajouter une annonce",
    "workspace.catalog.templates": "Modèles",
    "Templates": "Modèles",
    "workspace.catalog.integrations": "Intégrations",
    "workspace.catalog.template": "Modèle",
    "Template": "Modèle",
    "workspace.catalog.integration": "Intégration",
    "workspace.catalog.templates_heading": "Choisissez un modèle pour lancer votre idée",
    "Choose a template to kickstart your Idea": "Choisissez un modèle pour lancer votre idée",
    "workspace.catalog.integrations_heading": "Intégrations pour les applications web hébergées",
    "Integrations for Hosted Web Apps": "Intégrations pour les applications web hébergées",
    "workspace.catalog.templates_description": "Commencez avec un modèle prêt à l’emploi et adaptez-le à votre marketplace.",
    "Start with a prebuilt template and customise it for your marketplace.": "Commencez avec un modèle prêt à l’emploi et adaptez-le à votre marketplace.",
    "workspace.catalog.integrations_description": "Connectez votre espace de travail aux outils et services que vous utilisez déjà.",
    "Connect your workspace to the tools and services you already use.": "Connectez votre espace de travail aux outils et services que vous utilisez déjà.",
    "workspace.catalog.no_templates": "Aucun modèle n’est disponible pour le moment.",
    "No templates available at the moment.": "Aucun modèle n’est disponible pour le moment.",
    "workspace.catalog.no_integrations": "Aucune intégration n’est disponible pour le moment.",
    "No integrations available at the moment.": "Aucune intégration n’est disponible pour le moment.",
    "workspace.catalog.coming_soon": "Bientôt disponible",
    "Coming Soon": "Bientôt disponible",
    "workspace.catalog.configure": "Configurer",
    "workspace.catalog.custom_development": "Développement personnalisé de {type}",
    "Custom {type} Development": "Développement personnalisé de {type}",
    "workspace.catalog.custom_help": "Vous recherchez une solution personnalisée ? Contactez-nous pour obtenir un devis.",
    "Looking for something custom? Contact us for a quote.": "Vous recherchez une solution personnalisée ? Contactez-nous pour obtenir un devis.",
    "workspace.catalog.contact_quote": "Demander un devis",
    "Contact for a Quote": "Demander un devis",
    "users.select_user": "Sélectionner un utilisateur",
    "Select User": "Sélectionner un utilisateur",
    "developer.api_keys.paid_feature_title": "L’accès à l’API est une fonctionnalité payante",
    "API access is a paid feature": "L’accès à l’API est une fonctionnalité payante",
    "developer.api_keys.paid_feature_description": "Choisissez une offre payante pour afficher et copier vos clés publiable et secrète et les utiliser.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Choisissez une offre payante pour afficher et copier vos clés publiable et secrète et les utiliser.",
    "developer.api_keys.available_on_paid_plans": "Disponible avec les offres payantes",
    "Available on paid plans": "Disponible avec les offres payantes",
    "developer.api_keys.view_plans": "Voir les offres",
    "currency.rates.title": "Taux de change actuels",
    "Current FX rates": "Taux de change actuels",
    "currency.rates.base": "Devise de base :",
    "Base:": "Devise de base :",
    "currency.rates.source": "· Source :",
    "· Source:": "· Source :",
    "currency.rates.cached_up_to": "Mis en cache pendant {hours} h au maximum",
    "Cached up to {hours}h": "Mis en cache pendant {hours} h au maximum",
    "currency.rates.refresh": "Actualiser les taux",
    "Refresh rates": "Actualiser les taux",
    "currency.rates.currency": "Devise",
    "currency.rates.one_base_equals": "1 {code} équivaut à",
    "1 {code} equals": "1 {code} équivaut à",
    "currency.rates.empty": "Ajoutez une devise active pour afficher son taux de change.",
    "Add an active currency to see its exchange rate.": "Ajoutez une devise active pour afficher son taux de change.",
    "currency.rates.manual": "Taux manuels",
    "Manual rates": "Taux manuels",
    "currency.rates.load_error": "Impossible de charger les taux de change.",
    "Unable to load exchange rates.": "Impossible de charger les taux de change.",
    "chats.title": "Chat client",
    "Customer chat": "Chat client",
    "chats.conversations": "Conversations",
    "Conversations": "Conversations",
    "chats.empty_conversations": "Aucune conversation client pour le moment.",
    "No customer conversations yet.": "Aucune conversation client pour le moment.",
    "chats.customer_id": "Client {id}",
    "Customer {id}": "Client {id}",
    "chats.no_messages_yet": "Aucun message pour le moment",
    "No messages yet": "Aucun message pour le moment",
    "chats.conversation_id": "Conversation n°{id}",
    "Conversation #{id}": "Conversation n°{id}",
    "chats.status.closed": "Fermée",
    "closed": "Fermée",
    "chats.status.open": "Ouverte",
    "chats.reopen": "Rouvrir",
    "Reopen": "Rouvrir",
    "chats.close_conversation": "Fermer la conversation",
    "Close conversation": "Fermer la conversation",
    "chats.your_team": "Votre équipe",
    "Your team": "Votre équipe",
    "chats.empty_messages": "Aucun message dans cette conversation pour le moment.",
    "No messages in this conversation yet.": "Aucun message dans cette conversation pour le moment.",
    "chats.write_reply": "Rédigez une réponse",
    "Write a reply": "Rédigez une réponse",
    "chats.send": "Envoyer",
    "Send": "Envoyer",
    "chats.select_conversation": "Sélectionnez une conversation pour afficher ses messages.",
    "Select a conversation to view its messages.": "Sélectionnez une conversation pour afficher ses messages.",
    "chats.error.session_not_ready": "Votre session n’est pas prête. Actualisez la page puis réessayez.",
    "Your session is not ready. Refresh the page and try again.": "Votre session n’est pas prête. Actualisez la page puis réessayez.",
    "chats.error.request_failed": "Échec de la requête de discussion ({status})",
    "Chat request failed ({status})": "Échec de la requête de discussion ({status})",
    "chats.error.load_conversations": "Impossible de charger les conversations.",
    "Could not load conversations.": "Impossible de charger les conversations.",
    "chats.error.load_messages": "Impossible de charger les messages.",
    "Could not load messages.": "Impossible de charger les messages.",
    "chats.error.send_message": "Le message n’a pas pu être envoyé.",
    "Message could not be sent.": "Le message n’a pas pu être envoyé.",
    "chats.error.update_status": "Impossible de mettre à jour le statut de la conversation.",
    "Conversation status could not be updated.": "Impossible de mettre à jour le statut de la conversation.",
    "accounts.select_account": "Sélectionner un compte",
    "common.accounts": "Comptes",
    "common.listings": "Annonces",
    "communications.loading_preview": "Chargement de l’aperçu…",
    "Loading preview…": "Chargement de l’aperçu…",
    "communications.no_preview": "Aucun aperçu",
    "No preview": "Aucun aperçu",
    "collections.choose_type": "Choisir {type}",
    "Choose {type}": "Choisir {type}",
    "collections.create_type_category_first": "Créez d’abord une catégorie {type}",
    "Create {type} category first": "Créez d’abord une catégorie {type}",
    "web_config.customisation": "Personnalisation du site web",
    "web_config.configuration": "Configuration du site web",
    "Web Configuration": "Configuration du site web",
    "web_config.section_general": "Général",
    "web_config.section_social": "Réseaux sociaux",
    "web_config.section_footer": "Pied de page",
    "web_config.assets": "Ressources",
    "Assets": "Ressources",
    "web_config.small_logo": "Petit logo",
    "Small logo": "Petit logo",
    "attributes.edit_attribute": "Modifier l’attribut",
    "currency.rate_managed_automatically": "Le taux est géré automatiquement.",
    "Rate is managed automatically.": "Le taux est géré automatiquement.",
    "navigation.add_or_manage_mini_apps": "Ajouter ou gérer les mini-applications",
    "Add or manage Mini Apps": "Ajouter ou gérer les mini-applications",
    "listings.import.download_type_template": "Télécharger le modèle de {type}",
    "navigation.promo_banner": "Profitez de {percent} % de réduction ! Offre réservée aux nouveaux clients. Utilisez le code : {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Profitez de {percent} % de réduction ! Offre réservée aux nouveaux clients. Utilisez le code : {code}.",
    "orders.cash_refund_recorded": "Remboursement en espèces enregistré. L’extourne comptable a été mise en file d’attente.",
    "Cash refund recorded. The accounting reversal has been queued.": "Remboursement en espèces enregistré. L’extourne comptable a été mise en file d’attente.",
    "orders.cash_refund_failed": "Impossible d’enregistrer le remboursement en espèces. Vérifiez le statut du paiement et l’historique des remboursements.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Impossible d’enregistrer le remboursement en espèces. Vérifiez le statut du paiement et l’historique des remboursements.",
    "orders.recording_cash_refund": "Enregistrement du remboursement…",
    "Recording refund…": "Enregistrement du remboursement…",
    "orders.record_cash_refund": "Enregistrer le remboursement en espèces",
    "Record cash refund": "Enregistrer le remboursement en espèces",
    "orders.confirm_cash_refund": "Confirmer le remboursement en espèces",
    "Confirm cash refund": "Confirmer le remboursement en espèces",
    "orders.cash_refund_order_amount": "Enregistrer un remboursement intégral de {amount} en espèces pour la commande {reference} ?",
    "Record a full cash refund of {amount} for order {reference}?": "Enregistrer un remboursement intégral de {amount} en espèces pour la commande {reference} ?",
    "orders.cash_refund_manual_notice": "Cette action enregistre un remboursement manuel en espèces ou contre remboursement et met l’extourne comptable en file d’attente. Aucun prestataire de paiement ne sera contacté.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Cette action enregistre un remboursement manuel en espèces ou contre remboursement et met l’extourne comptable en file d’attente. Aucun prestataire de paiement ne sera contacté.",
    "currency_conversion.title": "Conversion de devises",
    "Currency conversion": "Conversion de devises",
    "currency_conversion.open_settings": "Paramètres de conversion",
    "Conversion settings": "Paramètres de conversion",
    "currency_conversion.load_failed": "Impossible de charger les paramètres de conversion des devises.",
    "Could not load currency conversion settings.": "Impossible de charger les paramètres de conversion des devises.",
    "currency_conversion.interval_error": "L’intervalle d’actualisation doit être compris entre 5 minutes et 24 heures.",
    "Refresh interval must be between 5 minutes and 24 hours.": "L’intervalle d’actualisation doit être compris entre 5 minutes et 24 heures.",
    "currency_conversion.save_failed": "Impossible d’enregistrer les paramètres de conversion des devises.",
    "Could not save currency conversion settings.": "Impossible d’enregistrer les paramètres de conversion des devises.",
    "currency_conversion.saved": "Paramètres de conversion des devises enregistrés.",
    "Currency conversion settings saved.": "Paramètres de conversion des devises enregistrés.",
    "currency_conversion.description": "Choisissez le mode de calcul des conversions de devises affichées.",
    "Choose how displayed currency conversions are calculated.": "Choisissez le mode de calcul des conversions de devises affichées.",
    "currency_conversion.manual_title": "Taux manuels",
    "currency_conversion.manual_help": "Utilisez le taux de change saisi ci-dessous pour chaque devise.",
    "Use the exchange rate entered for each currency below.": "Utilisez le taux de change saisi ci-dessous pour chaque devise.",
    "currency_conversion.frankfurter_title": "Frankfurter (par défaut)",
    "Frankfurter (default)": "Frankfurter (par défaut)",
    "currency_conversion.frankfurter_help": "Taux de change quotidiens gratuits. Aucune clé API de prestataire n’est requise.",
    "Free daily exchange rates. No provider API key is required.": "Taux de change quotidiens gratuits. Aucune clé API de prestataire n’est requise.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Utilisez le service Fixer géré par la plateforme. La fréquence des mises à jour dépend de l’offre du prestataire.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Utilisez le service Fixer géré par la plateforme. La fréquence des mises à jour dépend de l’offre du prestataire.",
    "currency_conversion.refresh_interval": "Intervalle de vérification des taux (minutes)",
    "Rate re-check interval (minutes)": "Intervalle de vérification des taux (minutes)",
    "workspace.currency_search_code": "Rechercher ou sélectionner",
    "Search or select": "Rechercher ou sélectionner",
    "workspace.currency_preset_hint": "Les valeurs par défaut recommandées ont été appliquées. Vous pouvez modifier chaque champ.",
    "Recommended defaults applied. You can edit any field.": "Les valeurs par défaut recommandées ont été appliquées. Vous pouvez modifier chaque champ.",
    "developer.api_keys.copy_unavailable": "La clé n’est pas encore disponible.",
    "Key is not available yet.": "La clé n’est pas encore disponible.",
    "developer.api_keys.copy_failed": "Impossible de copier la clé. Réessayez.",
    "Unable to copy the key. Try again.": "Impossible de copier la clé. Réessayez.",
    "payroll.action.export_pdf": "Exporter en PDF",
    "Export PDF": "Exporter en PDF",
    "cms.category.name_prompt": "Nom de la catégorie",
    "cms.field.cover_image": "Image de couverture",
    "Cover Image": "Image de couverture",
    "cms.action.add_cover_photo": "Ajouter une photo de couverture",
    "Add cover photo": "Ajouter une photo de couverture",
    "cms.field.category": "Catégorie",
    "cms.category.none": "Aucune catégorie",
    "No category": "Aucune catégorie",
    "cms.advanced": "Avancé",
    "media_picker.action.select_image": "Sélectionner une image",
    "Select image": "Sélectionner une image",
    "orders.confirm_record_cash_refund": "Enregistrer le remboursement",
    "Record refund": "Enregistrer le remboursement",
    "listing_form.no_repeat": "Aucune répétition",
    "No repeat": "Aucune répétition",
    "listing_form.custom_repeat_days": "Personnalisé : {days}",
    "Custom: {days}": "Personnalisé : {days}",
    "common.sending": "Envoi…",
    "listings.detail.unique_name": "Nom unique",
    "Unique Name": "Nom unique",
    "app_customization.username": "Nom d’utilisateur",
    "workspace.templates.name_required": "Le nom du modèle est obligatoire.",
    "Template name is required.": "Le nom du modèle est obligatoire.",
    "workspace.templates.saved": "Modèle de rôles enregistré.",
    "Role template saved.": "Modèle de rôles enregistré.",
    "workspace.templates.confirm_delete": "Supprimer le modèle « {name} » ?",
    "Delete template \"{name}\"?": "Supprimer le modèle « {name} » ?",
    "workspace.templates.deleted": "Modèle supprimé.",
    "Template deleted.": "Modèle supprimé.",
    "workspace.members.tab_members": "Membres",
    "workspace.templates.tab": "Modèles de rôles",
    "Role Templates": "Modèles de rôles",
    "workspace.templates.title": "Modèles de rôles",
    "workspace.templates.new": "Nouveau modèle",
    "New Template": "Nouveau modèle",
    "workspace.templates.name": "Nom",
    "workspace.templates.empty": "Aucun modèle de rôles pour le moment.",
    "No role templates yet.": "Aucun modèle de rôles pour le moment.",
    "workspace.templates.edit": "Modifier le modèle",
    "Edit Template": "Modifier le modèle",
    "workspace.templates.name_label": "Nom du modèle",
    "Template name": "Nom du modèle",
    "workspace.templates.name_placeholder": "Ex. : Responsable de contenu",
    "e.g. Content Manager": "Ex. : Responsable de contenu",
    "listings.import.unknown_error": "Impossible d’importer les catégories. Vérifiez le fichier CSV et réessayez.",
    "The categories could not be imported. Please check the CSV and try again.": "Impossible d’importer les catégories. Vérifiez le fichier CSV et réessayez.",
    "common.no_access_to_page": "Accès refusé",
    "No access": "Accès refusé",
    "common.permission_to_view_page_denied": "Vous n’êtes pas autorisé à consulter cette page.",
    "You do not have permission to view this page.": "Vous n’êtes pas autorisé à consulter cette page.",
    "common.loading_permissions": "Chargement des autorisations…",
    "Loading permissions…": "Chargement des autorisations…",
    "attributes.added_successfully": "Attributs ajoutés avec succès 🎉",
    "Nice 🎉, Successfully added attributes": "Attributs ajoutés avec succès 🎉",
    "attributes.add_attribute_values": "Ajouter des valeurs d’attribut",
    "attributes.attribute": "Attribut",
    "attributes.optional": "Facultatif",
    "attributes.private": "Privé",
    "attributes.hidden_field": "Champ masqué",
    "attributes.show_in_filter": "Afficher dans les filtres",
    "attributes.status_not_active_active": "Statut (inactif / actif)",
    "attributes.add_metadata": "Ajouter des métadonnées",
    "Add metadata": "Ajouter des métadonnées",
    "attributes.select_date_time": "Sélectionner la date et l’heure",
    "listings.addons.column_title": "Titre",
    "listings.addons.column_image": "Image",
    "listings.addons.column_price": "Prix",
    "listings.addons.column_max_quantity": "Quantité maximale",
    "Max Quantity": "Quantité maximale",
    "listings.addons.column_offer": "Offre",
    "listings.addons.column_stock": "Stock",
    "listings.addons.column_action": "Action",
    "listings.addons.column_status": "Statut",
    "listings.addons.confirm_delete": "Voulez-vous supprimer ce type d’option ?",
    "Do you want to delete this add-on type?": "Voulez-vous supprimer ce type d’option ?",
    "common.share_collection": "Partager la collection",
    "Share collection": "Partager la collection",
    "communications.view_modes": "Modes d’affichage des communications",
    "Communication view modes": "Modes d’affichage des communications",
    "payments.accessibility.gateway_logo": "Logo de la passerelle de paiement",
    "Payment gateway logo": "Logo de la passerelle de paiement",
    "common.build_version": "Version de build",
    "Build version": "Version de build",
    "common.build_label": "compilation",
    "build": "compilation",
    "listings.under_category_title": "Annonces dans la catégorie {category}",
    "Listings under {category}": "Annonces dans la catégorie {category}",
    "attributes.signup": "Inscription",
    "Signup": "Inscription",
    "common.toast.please_check_action": "Veuillez vérifier cette action.",
    "Please check this action": "Veuillez vérifier cette action.",
    "common.information": "Information",
    "listing_form.error.load_listing_data": "Impossible de charger les données de l’annonce.",
    "Failed to load listing data": "Impossible de charger les données de l’annonce.",
    "listing_form.error.load_digital_contents": "Impossible de charger les contenus numériques.",
    "Failed to load digital contents": "Impossible de charger les contenus numériques.",
    "listing_form.validation.audio_file_or_url_required": "Ajoutez un fichier audio ou une URL audio publique avant de créer l’épisode.",
    "Add an audio file or public audio URL before creating the episode.": "Ajoutez un fichier audio ou une URL audio publique avant de créer l’épisode.",
    "listing_form.validation.rental_rate_greater_than_zero": "Saisissez un tarif de location supérieur à 0.",
    "Enter a rental rate greater than 0.": "Saisissez un tarif de location supérieur à 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "La durée maximale doit être supérieure ou égale à la durée minimale.",
    "Maximum duration must be greater than or equal to minimum duration.": "La durée maximale doit être supérieure ou égale à la durée minimale.",
    "listing_form.updated_successfully": "L’annonce a été mise à jour.",
    "Listing updated successfully!": "L’annonce a été mise à jour.",
    "listing_form.created_successfully": "L’annonce a été créée.",
    "Listing created successfully!": "L’annonce a été créée.",
    "listing_form.error.save_failed": "Impossible d’enregistrer l’annonce. Réessayez.",
    "Failed to save listing. Please try again.": "Impossible d’enregistrer l’annonce. Réessayez.",
    "listing_form.error.delete_variant_failed": "Impossible de supprimer la variante : {title}",
    "Failed to delete variant: {title}": "Impossible de supprimer la variante : {title}",
    "listing_form.error.variant_action_failed": "Impossible de {action} la variante : {title}",
    "Failed to {action} variant: {title}": "Impossible de {action} la variante : {title}",
    "listing_form.error.digital_content_action_failed": "Impossible de {action} le contenu numérique : {title}",
    "Failed to {action} digital content: {title}": "Impossible de {action} le contenu numérique : {title}",
    "listing_form.action.create": "créer",
    "listing_form.action.update": "mettre à jour",
    "listing_form.action.delete": "supprimer",
    "delete": "supprimer",
    "listing_form.error.save_request_failed": "Impossible d’enregistrer l’annonce.",
    "Failed to save listing": "Impossible d’enregistrer l’annonce.",
    "listing_form.error.rental_settings_save_failed": "L’annonce a été enregistrée, mais les paramètres de location n’ont pas pu être enregistrés.",
    "Listing saved, but rental settings could not be saved.": "L’annonce a été enregistrée, mais les paramètres de location n’ont pas pu être enregistrés.",
    "users.action_failed": "L’action a échoué. Réessayez.",
    "Action failed. Please try again.": "L’action a échoué. Réessayez.",
    "common.successfully_added": "Ajout effectué avec succès",
    "Successfully added": "Ajout effectué avec succès",
    "listing_form.validation.title_min_length": "Le titre doit comporter au moins {count} caractères.",
    "Title must be at least {count} characters": "Le titre doit comporter au moins {count} caractères.",
    "listing_form.validation.title_max_length": "Le titre ne doit pas dépasser {count} caractères.",
    "Title must not exceed {count} characters": "Le titre ne doit pas dépasser {count} caractères.",
    "listing_form.validation.price_minimum": "Le prix doit être d’au moins {amount}.",
    "Price must be at least {amount}": "Le prix doit être d’au moins {amount}.",
    "listing_form.validation.attribute_required": "{attribute} est obligatoire.",
    "listings.error.load_failed": "Impossible de charger les annonces.",
    "Unable to load listings": "Impossible de charger les annonces.",
    "communications.from_email_required_before_verification": "Saisissez l’adresse e-mail de l’expéditeur avant de lancer la vérification.",
    "Please enter From email address before verifying.": "Saisissez l’adresse e-mail de l’expéditeur avant de lancer la vérification.",
    "communications.verification_email_sent": "Un e-mail de vérification a été envoyé. Consultez votre boîte de réception et suivez les instructions pour vérifier cette adresse.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Un e-mail de vérification a été envoyé. Consultez votre boîte de réception et suivez les instructions pour vérifier cette adresse.",
    "communications.verification_start_failed": "Impossible de démarrer la vérification. Réessayez.",
    "Unable to start verification. Please try again.": "Impossible de démarrer la vérification. Réessayez.",
    "common.uploaded_successfully": "Opération effectuée avec succès",
    "upgrade_page.panel.yearly": "Annuel",
    "upgrade_page.panel.monthly": "Mensuel",
    "orders.advance_paid": "Acompte versé",
    "Advance paid": "Acompte versé",
    "orders.balance_due": "Solde dû",
    "Balance due": "Solde dû",
    "orders.advance_invalid": "Saisissez un montant inférieur au total de la commande.",
    "Enter an amount less than the order total.": "Saisissez un montant inférieur au total de la commande.",
    "orders.advance_failed": "Impossible d’enregistrer l’acompte.",
    "Could not save the advance.": "Impossible d’enregistrer l’acompte.",
    "orders.edit_advance": "Modifier l’acompte",
    "Edit advance": "Modifier l’acompte",
    "orders.record_advance": "Enregistrer un acompte",
    "Record advance": "Enregistrer un acompte",
    "orders.advance_notice": "Montant déjà payé par le client, inférieur au total de la commande ({total}). La commande reste impayée jusqu’à ce que vous marquiez le solde comme payé. Saisissez 0 pour supprimer l’acompte.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Montant déjà payé par le client, inférieur au total de la commande ({total}). La commande reste impayée jusqu’à ce que vous marquiez le solde comme payé. Saisissez 0 pour supprimer l’acompte.",
    "orders.save_advance": "Enregistrer",
    "common.hide": "Masquer",
    "listings.repeat.daily": "Tous les jours",
    "listings.repeat.weekdays": "Jours de semaine (lun.-ven.)",
    "Weekdays (Mon-Fri)": "Jours de semaine (lun.-ven.)",
    "listings.repeat.weekend": "Week-end (sam.-dim.)",
    "Weekend (Sat-Sun)": "Week-end (sam.-dim.)",
    "listings.repeat.custom": "Personnalisé",
    "listings.weekday.sun": "dim.",
    "Sun": "dim.",
    "listings.weekday.mon": "lun.",
    "Mon": "lun.",
    "listings.weekday.tue": "mar.",
    "Tue": "mar.",
    "listings.weekday.wed": "mer.",
    "Wed": "mer.",
    "listings.weekday.thu": "jeu.",
    "Thu": "jeu.",
    "listings.weekday.fri": "ven.",
    "Fri": "ven.",
    "listings.weekday.sat": "sam.",
    "Sat": "sam.",
    "orders.pay_balance": "Payer le solde de {amount}",
    "Pay balance {amount}": "Payer le solde de {amount}",
    "orders.partially_paid": "Partiellement payée",
    "Partially paid": "Partiellement payée",
    "orders.balance_amount": "Solde : {amount}",
    "Balance {amount}": "Solde : {amount}",
    "delivery.get_started.add_branch": "Ajouter une agence",
    "Add branch": "Ajouter une agence",
    "delivery.get_started.add_fleet": "Ajouter une flotte",
    "Add fleet": "Ajouter une flotte",
    "delivery.get_started.api_documentation": "Documentation de l’API",
    "API Documentation": "Documentation de l’API",
    "delivery.get_started.add_driver": "Ajouter un chauffeur",
    "Add driver": "Ajouter un chauffeur",
    "delivery.get_started.branch_title": "Ajouter votre agence",
    "Add your branch": "Ajouter votre agence",
    "delivery.get_started.branch_description": "Une agence peut compter plusieurs flottes et chauffeurs",
    "A branch can have many fleets and drivers": "Une agence peut compter plusieurs flottes et chauffeurs",
    "delivery.get_started.fleet_title": "Ajouter votre flotte",
    "Add your fleet": "Ajouter votre flotte",
    "delivery.get_started.fleet_description": "Une flotte peut être attribuée à un chauffeur",
    "A fleet can be assigned to a driver": "Une flotte peut être attribuée à un chauffeur",
    "delivery.get_started.driver_title": "Ajouter votre chauffeur",
    "Add your driver": "Ajouter votre chauffeur",
    "delivery.get_started.driver_description": "Le chauffeur livrera votre commande",
    "The driver will deliver your order": "Le chauffeur livrera votre commande",
    "delivery.get_started.order_title": "Créez votre première commande",
    "Create your first order": "Créez votre première commande",
    "delivery.get_started.order_description": "Les commandes peuvent être créées via l’API",
    "Orders can be created through the API": "Les commandes peuvent être créées via l’API",
    "delivery.get_started.progress.branches": "Agences",
    "Branches": "Agences",
    "delivery.get_started.progress.fleets": "Flottes",
    "Fleets": "Flottes",
    "delivery.get_started.progress.drivers": "Chauffeurs",
    "Drivers": "Chauffeurs",
    "delivery.get_started.progress.orders": "Commandes de livraison",
    "Delivery Orders": "Commandes de livraison",
    "delivery.get_started.welcome": "Bienvenue sur",
    "Welcome to": "Bienvenue sur",
    "delivery.get_started.question": "Que souhaitez-vous faire ?",
    "What would you like to do?": "Que souhaitez-vous faire ?",
    "workspace.templates.built_in": "Intégré",
    "Built-in": "Intégré",
    "workspace.templates.copy_of": "Copie de {name}",
    "Copy of {name}": "Copie de {name}",
    "workspace.members.role": "Rôle",
    "Role": "Rôle",
    "workspace.members.role_full_access": "Accès complet",
    "Full access": "Accès complet",
    "workspace.templates.duplicate": "Dupliquer",
    "workspace.members.role_custom": "Personnalisé (à définir ci-dessous)",
    "Custom (set below)": "Personnalisé (à définir ci-dessous)"
  },
  "ar": {
    "0": "0",
    "6100": "6100",
    "common.language": "اللغة",
    "Language": "اللغة",
    "common.english": "الإنجليزية",
    "English": "الإنجليزية",
    "common.french": "الفرنسية",
    "French": "الفرنسية",
    "common.arabic": "العربية",
    "Arabic": "العربية",
    "navigation.get_started": "البدء",
    "Get Started": "البدء",
    "navigation.dashboard": "لوحة القيادة",
    "navigation.orders": "الطلبات",
    "Orders": "الطلبات",
    "navigation.schedule": "الجدول",
    "navigation.accounts": "الحسابات",
    "Accounts": "الحسابات",
    "navigation.account_categories": "فئات الحسابات",
    "Account Categories": "فئات الحسابات",
    "navigation.account_attributes": "سمات الحسابات",
    "Account Attributes": "سمات الحسابات",
    "navigation.account_configuration": "إعدادات الحسابات",
    "navigation.agents": "الوكلاء",
    "Agents": "الوكلاء",
    "navigation.listings": "القوائم",
    "navigation.categories": "الفئات",
    "Categories": "الفئات",
    "navigation.custom_attributes": "سمات مخصصة",
    "Custom Attributes": "سمات مخصصة",
    "navigation.variant_types": "أنواع المتغيرات",
    "Variant Types": "أنواع المتغيرات",
    "navigation.additional_features": "ميزات إضافية",
    "Additional Features": "ميزات إضافية",
    "navigation.reported_listings": "الإعلانات المُبلّغ عنها",
    "Reported Listings": "الإعلانات المُبلّغ عنها",
    "navigation.report_accounts": "الحسابات المُبلّغ عنها",
    "Report Accounts": "الحسابات المُبلّغ عنها",
    "navigation.users": "المستخدمون",
    "Users": "المستخدمون",
    "navigation.user_attributes": "سمات المستخدمين",
    "User Attributes": "سمات المستخدمين",
    "navigation.reviews_ratings": "التقييمات والمراجعات",
    "navigation.report": "تقرير",
    "Report": "تقرير",
    "navigation.reports": "التقارير",
    "Reports": "التقارير",
    "navigation.platform_health": "سلامة المنصة",
    "Platform Health": "سلامة المنصة",
    "navigation.promotions": "العروض الترويجية",
    "Promotions": "العروض الترويجية",
    "navigation.collections": "المجموعات",
    "Collections": "المجموعات",
    "navigation.promotion_ads": "الترويج / الإعلانات",
    "Promotion / Ads": "الترويج / الإعلانات",
    "navigation.coupons": "القسائم",
    "Coupons": "القسائم",
    "navigation.finance": "المالية",
    "Finance": "المالية",
    "navigation.transactions": "المعاملات",
    "Transactions": "المعاملات",
    "navigation.settlement": "التسوية",
    "Settlement": "التسوية",
    "navigation.expenses": "المصروفات",
    "Expenses": "المصروفات",
    "navigation.recurring_payments": "المدفوعات المتكررة",
    "Recurring payments": "المدفوعات المتكررة",
    "navigation.media": "الوسائط",
    "Media": "الوسائط",
    "navigation.communication": "التواصل",
    "Communication": "التواصل",
    "navigation.web": "الويب",
    "Web": "الويب",
    "navigation.website_editor": "محرر الموقع",
    "Website Editor": "محرر الموقع",
    "navigation.change_templates": "تغيير القوالب",
    "Change Templates": "تغيير القوالب",
    "navigation.pages": "الصفحات",
    "navigation.blog": "المدونة",
    "navigation.customise_texts": "تخصيص النصوص",
    "Customise texts": "تخصيص النصوص",
    "navigation.add_integrations": "إضافة تكاملات",
    "Add Integrations": "إضافة تكاملات",
    "navigation.domain": "النطاق",
    "Domain": "النطاق",
    "navigation.customise_seo": "تخصيص تحسين محركات البحث",
    "Customise SEO": "تخصيص تحسين محركات البحث",
    "navigation.app": "التطبيق",
    "App": "التطبيق",
    "navigation.apps": "التطبيقات",
    "Apps": "التطبيقات",
    "navigation.buy_app_templates": "شراء قوالب التطبيقات",
    "Buy App Templates": "شراء قوالب التطبيقات",
    "navigation.customisation": "التخصيص",
    "Customisation": "التخصيص",
    "navigation.integrations": "التكاملات",
    "Integrations": "التكاملات",
    "navigation.invite_team": "دعوة الفريق",
    "Invite Team": "دعوة الفريق",
    "navigation.help": "المساعدة",
    "Help": "المساعدة",
    "navigation.documentation": "الوثائق",
    "navigation.community": "المجتمع",
    "Community": "المجتمع",
    "navigation.api_reference": "مرجع API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "القنوات",
    "Channels": "القنوات",
    "navigation.coding_kits": "حِزم البرمجة",
    "Coding Kits": "حِزم البرمجة",
    "navigation.vibe_coding": "البرمجة بالذكاء الاصطناعي",
    "Vibe Coding": "البرمجة بالذكاء الاصطناعي",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "الإعدادات",
    "Settings": "الإعدادات",
    "navigation.more": "المزيد",
    "More": "المزيد",
    "navigation.marketplace": "السوق",
    "navigation.commerce": "التجارة",
    "Commerce": "التجارة",
    "navigation.marketing": "التسويق",
    "Marketing": "التسويق",
    "navigation.intelligence": "الذكاء",
    "navigation.subscription": "الاشتراك",
    "navigation.membership": "العضوية",
    "navigation.rewards": "المكافآت",
    "Rewards": "المكافآت",
    "navigation.bundles": "الحِزم",
    "navigation.supply_chain": "سلسلة التوريد",
    "navigation.people": "الأفراد",
    "navigation.workforce": "القوى العاملة",
    "Workforce": "القوى العاملة",
    "navigation.payroll": "الرواتب",
    "navigation.inventory": "المخزون",
    "Inventory": "المخزون",
    "navigation.inventory_operations": "عمليات المخزون",
    "Inventory Operations": "عمليات المخزون",
    "navigation.purchase_orders": "أوامر الشراء",
    "Purchase Orders": "أوامر الشراء",
    "navigation.stock_locations": "مواقع المخزون",
    "Stock Locations": "مواقع المخزون",
    "navigation.purchase_orders_2": "أوامر الشراء",
    "Purchase orders": "أوامر الشراء",
    "navigation.suppliers": "المورّدون",
    "Suppliers": "المورّدون",
    "navigation.locations": "المواقع",
    "Locations": "المواقع",
    "navigation.maps": "الخرائط",
    "Maps": "الخرائط",
    "navigation.accounting": "المحاسبة",
    "Accounting": "المحاسبة",
    "navigation.invoices": "الفواتير",
    "Invoices": "الفواتير",
    "navigation.plans": "الخطط",
    "Plans": "الخطط",
    "navigation.countries": "الدول",
    "navigation.currency": "العملة",
    "Currency": "العملة",
    "navigation.languages": "اللغات",
    "Languages": "اللغات",
    "navigation.payments": "المدفوعات",
    "Payments": "المدفوعات",
    "navigation.commissions": "العمولات",
    "Commissions": "العمولات",
    "navigation.taxes": "الضرائب",
    "Taxes": "الضرائب",
    "navigation.special_fees": "رسوم خاصة",
    "Special Fees": "رسوم خاصة",
    "navigation.service_shipping": "الخدمة / الشحن",
    "Service / Shipping": "الخدمة / الشحن",
    "navigation.checkout_cart_attributes": "سمات الدفع والسلة",
    "Checkout & Cart Attributes": "سمات الدفع والسلة",
    "navigation.dark_mode_background_color": "لون خلفية الوضع الداكن",
    "Dark Mode Background Color": "لون خلفية الوضع الداكن",
    "navigation.dark_mode_text_color": "لون نص الوضع الداكن",
    "Dark Mode Text Color": "لون نص الوضع الداكن",
    "navigation.light_mode_background_color": "لون خلفية الوضع الفاتح",
    "Light Mode Background Color": "لون خلفية الوضع الفاتح",
    "navigation.light_mode_text_color": "لون نص الوضع الفاتح",
    "Light Mode Text Color": "لون نص الوضع الفاتح",
    "navigation.workspace": "مساحة العمل",
    "Workspace": "مساحة العمل",
    "navigation.user_management": "إدارة المستخدمين",
    "User Management": "إدارة المستخدمين",
    "navigation.privacy": "الخصوصية",
    "Privacy": "الخصوصية",
    "common.search": "بحث...",
    "Search...": "بحث...",
    "common.search_2": "بحث",
    "Search": "بحث",
    "common.no_results_found": "لم يتم العثور على نتائج",
    "No results found": "لم يتم العثور على نتائج",
    "common.no_record_found": "لم يتم العثور على سجلات",
    "No Record Found": "لم يتم العثور على سجلات",
    "common.open_in_a_new_tab": "فتح في علامة تبويب جديدة",
    "Open in a new tab": "فتح في علامة تبويب جديدة",
    "common.open": "فتح",
    "common.in_a_new_tab": "في علامة تبويب جديدة",
    "in a new tab": "في علامة تبويب جديدة",
    "common.loading_page": "جارٍ تحميل الصفحة…",
    "Loading page…": "جارٍ تحميل الصفحة…",
    "common.close": "إغلاق",
    "Close": "إغلاق",
    "common.save": "حفظ",
    "Save": "حفظ",
    "common.cancel": "إلغاء",
    "Cancel": "إلغاء",
    "common.delete": "حذف",
    "Delete": "حذف",
    "common.edit": "تعديل",
    "Edit": "تعديل",
    "common.add": "إضافة",
    "Add": "إضافة",
    "common.create": "إنشاء",
    "Create": "إنشاء",
    "common.update": "تحديث",
    "Update": "تحديث",
    "common.back": "رجوع",
    "Back": "رجوع",
    "common.next": "التالي",
    "Next": "التالي",
    "common.previous": "السابق",
    "Previous": "السابق",
    "common.done": "تم",
    "Done": "تم",
    "common.yes": "نعم",
    "Yes": "نعم",
    "common.no": "لا",
    "No": "لا",
    "common.name": "الاسم",
    "Name": "الاسم",
    "common.status": "الحالة",
    "Status": "الحالة",
    "common.date": "التاريخ",
    "Date": "التاريخ",
    "common.actions": "الإجراءات",
    "Actions": "الإجراءات",
    "common.action": "إجراء",
    "orders.scan_order": "مسح الطلب",
    "Scan order": "مسح الطلب",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "امسح رمزًا شريطيًا أو رمز QR أو مرجعًا، أو أدخله يدويًا.",
    "Scan a barcode/QR reference or enter it manually.": "امسح رمزًا شريطيًا أو رمز QR أو مرجعًا، أو أدخله يدويًا.",
    "orders.camera_scanner": "ماسح الكاميرا",
    "Camera scanner": "ماسح الكاميرا",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "مسح الكاميرا غير مدعوم هنا. أدخل مرجع الطلب أدناه.",
    "Camera scanning is not supported here. Enter the order reference below.": "مسح الكاميرا غير مدعوم هنا. أدخل مرجع الطلب أدناه.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "الكاميرا غير متاحة. أدخل مرجع الطلب أدناه.",
    "Camera access is unavailable. Enter the order reference below.": "الكاميرا غير متاحة. أدخل مرجع الطلب أدناه.",
    "orders.order_reference_number": "رقم مرجع الطلب",
    "Order reference number": "رقم مرجع الطلب",
    "orders.find_order": "البحث عن طلب",
    "Find order": "البحث عن طلب",
    "common.your_orders_will_be_shown_here": "ستظهر طلباتك هنا.",
    "Your orders will be shown here.": "ستظهر طلباتك هنا.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "هنا يمكنك متابعة الطلبات والحجوزات وغيرها التي أُجريت مع حسابات أخرى والاطلاع على تحديثات حالتها.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "هنا يمكنك متابعة الطلبات والحجوزات وغيرها التي أُجريت مع حسابات أخرى والاطلاع على تحديثات حالتها.",
    "common.reference": "رقم المرجع",
    "Reference #": "رقم المرجع",
    "common.amount": "المبلغ",
    "Amount": "المبلغ",
    "orders.order_status": "حالة الطلب",
    "Order Status": "حالة الطلب",
    "orders.payment_status": "حالة الدفع",
    "Payment Status": "حالة الدفع",
    "common.payment_method": "طريقة الدفع",
    "Payment Method": "طريقة الدفع",
    "common.shipping_method": "طريقة الشحن",
    "Shipping Method": "طريقة الشحن",
    "common.paid": "مدفوع",
    "Paid": "مدفوع",
    "common.not_paid": "غير مدفوع",
    "Not Paid": "غير مدفوع",
    "common.unpaid": "غير مدفوع",
    "UnPaid": "غير مدفوع",
    "common.failed": "فشل",
    "common.incomplete": "غير مكتمل",
    "Incomplete": "غير مكتمل",
    "common.order_placed": "تم تقديم الطلب",
    "Order placed": "تم تقديم الطلب",
    "common.order_in_progress": "الطلب قيد التنفيذ",
    "Order in progress": "الطلب قيد التنفيذ",
    "common.shipped": "تم الشحن",
    "Shipped": "تم الشحن",
    "common.delivered": "تم التسليم",
    "common.cancelled_by_customer": "ألغاه العميل",
    "common.order_completed": "اكتمل الطلب",
    "Order completed": "اكتمل الطلب",
    "common.n_a": "غير متاح",
    "N/A": "غير متاح",
    "orders.total_orders": "إجمالي الطلبات",
    "Total Orders": "إجمالي الطلبات",
    "orders.page_revenue": "إيرادات الصفحة",
    "Page Revenue": "إيرادات الصفحة",
    "orders.pending_payment": "الدفع معلّق",
    "Pending Payment": "الدفع معلّق",
    "common.failed_payments": "مدفوعات فاشلة",
    "Failed payments": "مدفوعات فاشلة",
    "common.abandoned": "متروك",
    "Abandoned": "متروك",
    "orders.search_orders_by_reference_number": "البحث عن الطلبات برقم المرجع",
    "Search orders by reference number": "البحث عن الطلبات برقم المرجع",
    "orders.search_by_reference_number": "البحث برقم المرجع…",
    "Search by reference number…": "البحث برقم المرجع…",
    "orders.export_orders_as_csv": "تصدير الطلبات بصيغة CSV",
    "Export orders as CSV": "تصدير الطلبات بصيغة CSV",
    "orders.manual_order": "طلب يدوي",
    "Manual Order": "طلب يدوي",
    "orders.scan_order_reference": "مسح مرجع الطلب",
    "Scan order reference": "مسح مرجع الطلب",
    "orders.change_status_to": "تغيير الحالة إلى…",
    "Change status to…": "تغيير الحالة إلى…",
    "common.apply": "تطبيق",
    "Apply": "تطبيق",
    "common.clear": "مسح",
    "Clear": "مسح",
    "orders.pay": "دفع",
    "Pay": "دفع",
    "orders.clear_selection": "مسح التحديد",
    "Clear selection": "مسح التحديد",
    "orders.list": "قائمة",
    "orders.board": "لوحة",
    "Board": "لوحة",
    "orders.filter_orders": "تصفية الطلبات",
    "Filter orders": "تصفية الطلبات",
    "orders.start_date": "تاريخ البدء",
    "Start Date": "تاريخ البدء",
    "orders.end_date": "تاريخ الانتهاء",
    "End Date": "تاريخ الانتهاء",
    "orders.select_date": "اختر التاريخ",
    "orders.show_rows": "عرض الصفوف",
    "common.order_selected": "طلب محدد",
    "order selected": "طلب محدد",
    "common.orders_selected": "طلبات محددة",
    "orders selected": "طلبات محددة",
    "common.order_updated": "تم تحديث الطلب",
    "order updated": "تم تحديث الطلب",
    "common.orders_updated": "تم تحديث الطلبات",
    "orders updated": "تم تحديث الطلبات",
    "orders.order_archived_successfully": "تمت أرشفة الطلب بنجاح",
    "Order archived successfully": "تمت أرشفة الطلب بنجاح",
    "orders.failed_to_archive_order": "تعذرت أرشفة الطلب",
    "Failed to archive order": "تعذرت أرشفة الطلب",
    "orders.loading_order": "جارٍ تحميل الطلب…",
    "Loading order…": "جارٍ تحميل الطلب…",
    "orders.order_created_successfully": "تم إنشاء الطلب بنجاح",
    "Order created successfully": "تم إنشاء الطلب بنجاح",
    "orders.the_order_has_been_created_and_is_ready_to_review": "تم إنشاء الطلب وأصبح جاهزًا للمراجعة.",
    "The order has been created and is ready to review.": "تم إنشاء الطلب وأصبح جاهزًا للمراجعة.",
    "orders.order_reference": "مرجع الطلب",
    "Order reference": "مرجع الطلب",
    "common.created": "تاريخ الإنشاء",
    "Created": "تاريخ الإنشاء",
    "common.total": "الإجمالي",
    "Total": "الإجمالي",
    "common.items": "العناصر",
    "Items": "العناصر",
    "orders.print_save_pdf": "طباعة / حفظ PDF",
    "Print / Save PDF": "طباعة / حفظ PDF",
    "orders.view_order_details": "عرض تفاصيل الطلب",
    "View order details": "عرض تفاصيل الطلب",
    "orders.create_another_order": "إنشاء طلب آخر",
    "Create another order": "إنشاء طلب آخر",
    "orders.confirmed": "مؤكد",
    "Confirmed": "مؤكد",
    "orders.in_progress": "قيد التنفيذ",
    "In progress": "قيد التنفيذ",
    "orders.customer_unreachable": "تعذر الوصول إلى العميل",
    "Customer unreachable": "تعذر الوصول إلى العميل",
    "orders.out_for_delivery": "خرج للتوصيل",
    "orders.returned": "مُعاد",
    "Returned": "مُعاد",
    "orders.return_confirmed": "تم تأكيد الإرجاع",
    "Return confirmed": "تم تأكيد الإرجاع",
    "orders.delivery_confirmed": "تم تأكيد التسليم",
    "Delivery confirmed": "تم تأكيد التسليم",
    "orders.return_initiated": "بدأ الإرجاع",
    "Return initiated": "بدأ الإرجاع",
    "orders.return_picked": "تم استلام المرتجع",
    "Return picked": "تم استلام المرتجع",
    "orders.return_disputed": "الإرجاع محل نزاع",
    "Return disputed": "الإرجاع محل نزاع",
    "orders.canceled_by_seller": "ألغاه البائع",
    "Canceled by seller": "ألغاه البائع",
    "orders.canceled_by_customer": "ألغاه العميل",
    "Canceled by customer": "ألغاه العميل",
    "orders.ready_for_pickup": "جاهز للاستلام",
    "orders.arrived_at_customer_location": "وصل إلى موقع العميل",
    "orders.undelivered_returned": "تعذر التسليم - أُعيد",
    "Undelivered - Returned": "تعذر التسليم - أُعيد",
    "orders.undelivered_return_confirmed": "تعذر التسليم - تأكيد الإرجاع",
    "Undelivered - Return confirmed": "تعذر التسليم - تأكيد الإرجاع",
    "orders.disputed": "متنازع عليه",
    "Disputed": "متنازع عليه",
    "orders.completed": "مكتمل",
    "Completed": "مكتمل",
    "orders.detail_legacy.order_number": "رقم الطلب:",
    "Order Number:": "رقم الطلب:",
    "orders.detail_legacy.order_date": "تاريخ الطلب:",
    "Order Date:": "تاريخ الطلب:",
    "orders.detail_legacy.buyer_details": "تفاصيل المشتري:",
    "Buyer Details:": "تفاصيل المشتري:",
    "orders.detail_legacy.delivery_address": "عنوان التوصيل:",
    "Delivery Address:": "عنوان التوصيل:",
    "orders.detail_legacy.pickup_address": "عنوان الاستلام:",
    "Pickup Address:": "عنوان الاستلام:",
    "orders.detail_legacy.total_amount": "المبلغ الإجمالي:",
    "Total Amount:": "المبلغ الإجمالي:",
    "orders.detail_legacy.amount_in_words": "المبلغ كتابةً:",
    "Amount in Words:": "المبلغ كتابةً:",
    "orders.detail_legacy.amount_words_only": "فقط",
    "Only": "فقط",
    "orders.detail_legacy.payout_date": "تاريخ الدفع:",
    "Payout Date:": "تاريخ الدفع:",
    "orders.detail_legacy.change": "تغيير",
    "orders.detail_legacy.select_date_time": "اختر التاريخ والوقت",
    "Select Date & Time": "اختر التاريخ والوقت",
    "orders.detail_legacy.change_payout_date_time": "تغيير تاريخ ووقت الدفع",
    "Change Payout Date and Time": "تغيير تاريخ ووقت الدفع",
    "orders.detail_legacy.update_payout": "تحديث",
    "orders.detail_legacy.update_status": "تحديث الحالة",
    "Update Status": "تحديث الحالة",
    "orders.detail_legacy.change_order_status": "تغيير حالة الطلب",
    "Change Order Status": "تغيير حالة الطلب",
    "orders.detail_legacy.column_description": "الوصف",
    "Description": "الوصف",
    "orders.detail_legacy.column_unit_price": "سعر الوحدة",
    "Unit Price": "سعر الوحدة",
    "orders.detail_legacy.column_discount": "الخصم",
    "Discount": "الخصم",
    "orders.detail_legacy.column_tax_rate": "معدل الضريبة",
    "Tax Rate": "معدل الضريبة",
    "orders.item": "العنصر",
    "Item": "العنصر",
    "orders.order_details": "تفاصيل الطلب",
    "Order Details": "تفاصيل الطلب",
    "orders.copy_order_reference": "نسخ مرجع الطلب",
    "Copy order reference": "نسخ مرجع الطلب",
    "orders.order_summary": "ملخص الطلب",
    "Order Summary": "ملخص الطلب",
    "orders.order_created": "تم إنشاء الطلب",
    "Order created": "تم إنشاء الطلب",
    "orders.order_time": "وقت الطلب",
    "Order time": "وقت الطلب",
    "orders.total_earnings": "إجمالي الأرباح",
    "Total earnings": "إجمالي الأرباح",
    "orders.total_price": "السعر الإجمالي",
    "Total price": "السعر الإجمالي",
    "orders.delivery_fee": "رسوم التوصيل",
    "Delivery fee": "رسوم التوصيل",
    "orders.sub_total": "المجموع الفرعي",
    "Sub total": "المجموع الفرعي",
    "orders.customer_information": "معلومات العميل",
    "Customer Information": "معلومات العميل",
    "common.customer_name": "اسم العميل",
    "Customer Name": "اسم العميل",
    "common.phone": "الهاتف",
    "Phone": "الهاتف",
    "common.email": "البريد الإلكتروني",
    "Email": "البريد الإلكتروني",
    "orders.seller_details": "تفاصيل البائع",
    "Seller Details": "تفاصيل البائع",
    "common.seller_name": "اسم البائع",
    "Seller Name": "اسم البائع",
    "common.mobile": "الهاتف المحمول",
    "Mobile": "الهاتف المحمول",
    "orders.generate": "إنشاء",
    "Generate": "إنشاء",
    "orders.cancel_order": "إلغاء الطلب",
    "Cancel Order": "إلغاء الطلب",
    "orders.mark_as_paid": "تحديد كمدفوع",
    "Mark as Paid": "تحديد كمدفوع",
    "orders.failed_to_mark_as_paid": "تعذر تحديد الطلب كمدفوع",
    "Failed to mark as paid": "تعذر تحديد الطلب كمدفوع",
    "orders.order_cancelled_successfully": "تم إلغاء الطلب بنجاح",
    "Order cancelled successfully": "تم إلغاء الطلب بنجاح",
    "orders.failed_to_cancel_order_by_admin": "تعذر على المسؤول إلغاء الطلب",
    "Failed to cancel order by admin": "تعذر على المسؤول إلغاء الطلب",
    "orders.no_transactions_found": "لم يتم العثور على معاملات",
    "No transactions found": "لم يتم العثور على معاملات",
    "orders.transaction_no": "رقم المعاملة",
    "Transaction No": "رقم المعاملة",
    "orders.entity": "الجهة",
    "Entity": "الجهة",
    "orders.transaction_type": "نوع المعاملة",
    "Transaction Type": "نوع المعاملة",
    "common.seller": "البائع",
    "Seller": "البائع",
    "common.customer": "العميل",
    "Customer": "العميل",
    "common.platform_owner": "مالك المنصة",
    "Platform Owner": "مالك المنصة",
    "orders.items_summary": "ملخص العناصر",
    "Items Summary": "ملخص العناصر",
    "orders.qty": "الكمية",
    "QTY": "الكمية",
    "orders.price": "السعر",
    "Price": "السعر",
    "orders.total_price_2": "السعر الإجمالي",
    "Total Price": "السعر الإجمالي",
    "orders.membership_purchase": "شراء عضوية",
    "Membership purchase": "شراء عضوية",
    "orders.member_id": "معرّف العضو",
    "Member ID": "معرّف العضو",
    "orders.period": "الفترة",
    "Period": "الفترة",
    "orders.start_date_2": "تاريخ البدء",
    "Start date": "تاريخ البدء",
    "common.next_renewal": "التجديد التالي",
    "Next renewal": "التجديد التالي",
    "common.expiry_date": "تاريخ الانتهاء",
    "Expiry date": "تاريخ الانتهاء",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "يُدار هذا الطلب كمساهمة عضوية وليس كشحنة.",
    "This order is managed as a membership contribution, not a shipment.": "يُدار هذا الطلب كمساهمة عضوية وليس كشحنة.",
    "orders.months": "أشهر",
    "months": "أشهر",
    "orders.days": "أيام",
    "days": "أيام",
    "orders.address": "العنوان",
    "Address": "العنوان",
    "orders.address_1": "العنوان 1",
    "Address 1": "العنوان 1",
    "orders.address_2": "العنوان 2",
    "Address 2": "العنوان 2",
    "orders.zip_code": "الرمز البريدي",
    "Zip code": "الرمز البريدي",
    "orders.full_address": "العنوان الكامل",
    "Full Address": "العنوان الكامل",
    "orders.formatted_address": "العنوان بالتنسيق المعتمد",
    "Formatted Address": "العنوان بالتنسيق المعتمد",
    "orders.phone_number": "رقم الهاتف",
    "Phone Number": "رقم الهاتف",
    "orders.address_not_found": "لم يتم العثور على العنوان",
    "Address not found": "لم يتم العثور على العنوان",
    "orders.address_not_applicable": "العنوان غير منطبق",
    "Address not applicable": "العنوان غير منطبق",
    "orders.address_is_not_available": "العنوان غير متاح",
    "Address is not available": "العنوان غير متاح",
    "orders.add_pickup_address": "إضافة عنوان الاستلام",
    "Add Pickup Address": "إضافة عنوان الاستلام",
    "orders.edit_pickup_address": "تعديل عنوان الاستلام",
    "Edit Pickup Address": "تعديل عنوان الاستلام",
    "orders.discard_and_close": "تجاهل وإغلاق",
    "Discard and close": "تجاهل وإغلاق",
    "orders.state": "الولاية / المنطقة",
    "common.country": "الدولة",
    "orders.sales_payout": "دفعة المبيعات",
    "Sales Payout": "دفعة المبيعات",
    "orders.sales_no_payout": "مبيعات بدون دفعة",
    "Sales (No Payout)": "مبيعات بدون دفعة",
    "orders.sales_payout_reversal": "عكس دفعة المبيعات",
    "Sales Payout Reversal": "عكس دفعة المبيعات",
    "orders.sales_no_payout_reversal": "عكس المبيعات بدون دفعة",
    "Sales no payout reversal": "عكس المبيعات بدون دفعة",
    "orders.seller_commission": "عمولة البائع",
    "Seller Commission": "عمولة البائع",
    "orders.seller_commission_reversal": "عكس عمولة البائع",
    "Seller Commission Reversal": "عكس عمولة البائع",
    "orders.seller_transfer": "تحويل إلى البائع",
    "Seller Transfer": "تحويل إلى البائع",
    "orders.seller_transfer_reversal": "عكس التحويل إلى البائع",
    "Seller Transfer Reversal": "عكس التحويل إلى البائع",
    "orders.seller_payout": "دفعة البائع",
    "Seller Payout": "دفعة البائع",
    "orders.seller_subscription": "اشتراك البائع",
    "Seller Subscription": "اشتراك البائع",
    "orders.seller_payment_processing_fee": "رسوم معالجة دفع البائع",
    "Seller Payment processing fee": "رسوم معالجة دفع البائع",
    "orders.seller_payment_processing_fee_reversal": "عكس رسوم معالجة دفع البائع",
    "Seller Payment processing fee reversal": "عكس رسوم معالجة دفع البائع",
    "orders.sub_total_2": "المجموع الفرعي",
    "Sub Total": "المجموع الفرعي",
    "orders.customer_commission": "عمولة العميل",
    "Customer Commission": "عمولة العميل",
    "orders.tax": "الضريبة",
    "Tax": "الضريبة",
    "orders.shipping_charge": "رسوم الشحن",
    "Shipping Charge": "رسوم الشحن",
    "orders.refund": "استرداد",
    "Refund": "استرداد",
    "orders.special_fee": "رسوم خاصة",
    "Special Fee": "رسوم خاصة",
    "orders.coupon": "قسيمة",
    "Coupon": "قسيمة",
    "orders.shipment": "الشحنة",
    "Shipment": "الشحنة",
    "orders.fulfilled_by_platform": "تتولى المنصة التنفيذ",
    "Fulfilled by platform": "تتولى المنصة التنفيذ",
    "orders.fulfilled_by": "تم التنفيذ بواسطة",
    "Fulfilled by": "تم التنفيذ بواسطة",
    "orders.fulfilled_by_seller": "يتولى البائع التنفيذ",
    "Fulfilled by seller": "يتولى البائع التنفيذ",
    "orders.on_seller_protection_policy": "ضمن سياسة حماية البائع",
    "On Seller Protection Policy": "ضمن سياسة حماية البائع",
    "orders.product_image": "صورة المنتج",
    "Product image": "صورة المنتج",
    "orders.status_changed_successfully": "تم تغيير الحالة بنجاح",
    "Status changed successfully": "تم تغيير الحالة بنجاح",
    "orders.pickup_address_not_available_please_add_pickup_address": "عنوان الاستلام غير متاح. يُرجى إضافته.",
    "Pickup Address not available. Please Add Pickup Address": "عنوان الاستلام غير متاح. يُرجى إضافته.",
    "orders.failed_to_save_pickup_address_please_try_again": "تعذر حفظ عنوان الاستلام. يُرجى المحاولة مرة أخرى.",
    "Failed to save pickup address. Please try again.": "تعذر حفظ عنوان الاستلام. يُرجى المحاولة مرة أخرى.",
    "orders.change_shipment_status": "تغيير حالة الشحنة",
    "Change shipment status": "تغيير حالة الشحنة",
    "orders.not_available": "غير متاح",
    "Not available": "غير متاح",
    "orders.shipment_created": "تم إنشاء الشحنة",
    "Shipment created": "تم إنشاء الشحنة",
    "orders.shipment_in_progress": "الشحنة قيد التنفيذ",
    "Shipment in progress": "الشحنة قيد التنفيذ",
    "orders.ship": "شحن",
    "orders.undelivered_return": "إرجاع تعذر تسليمه",
    "orders.shipment_deliver": "تسليم الشحنة",
    "Shipment deliver": "تسليم الشحنة",
    "orders.shipment_delivery_confirm": "تأكيد تسليم الشحنة",
    "Shipment delivery confirm": "تأكيد تسليم الشحنة",
    "orders.return_initiate": "بدء الإرجاع",
    "Return initiate": "بدء الإرجاع",
    "orders.return_for_pickup": "إرجاع للاستلام",
    "Return for pickup": "إرجاع للاستلام",
    "orders.shipment_return_confirm": "تأكيد إرجاع الشحنة",
    "Shipment return confirm": "تأكيد إرجاع الشحنة",
    "orders.cancel_by_seller": "إلغاء بواسطة البائع",
    "Cancel by seller": "إلغاء بواسطة البائع",
    "orders.cancel_by_customer": "إلغاء بواسطة العميل",
    "Cancel by customer": "إلغاء بواسطة العميل",
    "orders.arrive_at_customer_location": "الوصول إلى موقع العميل",
    "Arrive at customer location": "الوصول إلى موقع العميل",
    "orders.shipment_delivered": "تم تسليم الشحنة",
    "Shipment delivered": "تم تسليم الشحنة",
    "orders.shipment_delivery_confirmed": "تم تأكيد تسليم الشحنة",
    "Shipment delivery confirmed": "تم تأكيد تسليم الشحنة",
    "orders.returned_for_pickup": "تم إرجاعها للاستلام",
    "orders.shipment_return_confirmed": "تم تأكيد إرجاع الشحنة",
    "Shipment return confirmed": "تم تأكيد إرجاع الشحنة",
    "orders.cancelled_by_seller": "ألغاه البائع",
    "common.cancelled_by_admin": "ألغاه المشرف",
    "orders.invoice": "الفاتورة",
    "Invoice": "الفاتورة",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "يُرجى اختيار نوع ملف صالح (PDF أو JPG أو PNG أو DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "يُرجى اختيار نوع ملف صالح (PDF أو JPG أو PNG أو DOC)",
    "orders.file_size_must_be_less_than_5mb": "يجب أن يكون حجم الملف أقل من 5 ميغابايت",
    "File size must be less than 5MB": "يجب أن يكون حجم الملف أقل من 5 ميغابايت",
    "orders.please_upload_a_file_first": "يُرجى رفع ملف أولاً",
    "Please upload a file first": "يُرجى رفع ملف أولاً",
    "orders.invoice_uploaded_successfully": "تم رفع الفاتورة بنجاح!",
    "Invoice uploaded successfully!": "تم رفع الفاتورة بنجاح!",
    "orders.failed_to_upload_invoice_please_try_again": "تعذر رفع الفاتورة. يُرجى المحاولة مرة أخرى.",
    "Failed to upload invoice. Please try again.": "تعذر رفع الفاتورة. يُرجى المحاولة مرة أخرى.",
    "orders.upload_invoice": "رفع الفاتورة",
    "Upload Invoice": "رفع الفاتورة",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "التنسيقات المدعومة: PDF وJPG وPNG وDOC (الحد الأقصى للحجم: 5 ميغابايت)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "التنسيقات المدعومة: PDF وJPG وPNG وDOC (الحد الأقصى للحجم: 5 ميغابايت)",
    "orders.uploading": "جارٍ الرفع…",
    "Uploading...": "جارٍ الرفع…",
    "orders.choose_file": "اختيار ملف",
    "Choose File": "اختيار ملف",
    "common.download": "تنزيل",
    "Download": "تنزيل",
    "common.remove": "إزالة",
    "Remove": "إزالة",
    "orders.upload_new_file": "رفع ملف جديد",
    "Upload New File": "رفع ملف جديد",
    "orders.saving": "جارٍ الحفظ…",
    "Saving...": "جارٍ الحفظ…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "سيؤدي حذف الطلب إلى إزالته فورًا من عرض البائع والمشتري. وبعد حذفه، لن يُسمح بأي تحديثات للحالة، كما سيُستثنى من جميع المقاييس والتقارير. هل تريد المتابعة؟",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "سيؤدي حذف الطلب إلى إزالته فورًا من عرض البائع والمشتري. وبعد حذفه، لن يُسمح بأي تحديثات للحالة، كما سيُستثنى من جميع المقاييس والتقارير. هل تريد المتابعة؟",
    "common.showing": "عرض",
    "Showing": "عرض",
    "common.of": "من",
    "of": "من",
    "common.all": "الكل",
    "common.active": "نشط",
    "common.inactive": "غير نشط",
    "common.enabled": "مفعّل",
    "Enabled": "مفعّل",
    "common.disabled": "معطّل",
    "common.success": "نجاح",
    "Success": "نجاح",
    "common.error": "خطأ",
    "Error": "خطأ",
    "common.warning": "تحذير",
    "Warning": "تحذير",
    "common.required": "مطلوب",
    "Required": "مطلوب",
    "users.title": "المستخدمون",
    "users.import": "استيراد",
    "Import": "استيراد",
    "users.import_users": "استيراد المستخدمين",
    "Import users": "استيراد المستخدمين",
    "users.smart_upload_users": "رفع المستخدمين الذكي",
    "Smart Upload Users": "رفع المستخدمين الذكي",
    "users.smart_upload_beta": "رفع المستخدمين الذكي (تجريبي)",
    "Smart upload users (Beta)": "رفع المستخدمين الذكي (تجريبي)",
    "users.export": "تصدير",
    "Export": "تصدير",
    "users.export_users": "تصدير المستخدمين",
    "Export users": "تصدير المستخدمين",
    "users.search_users": "البحث عن المستخدمين",
    "Search users": "البحث عن المستخدمين",
    "users.verified": "تم التحقق",
    "Verified": "تم التحقق",
    "users.not_verified": "لم يتم التحقق",
    "Non Verified": "لم يتم التحقق",
    "users.block": "حظر",
    "Block": "حظر",
    "users.unblock": "إلغاء الحظر",
    "Unblock": "إلغاء الحظر",
    "users.confirm_block": "هل تريد حظر هذا المستخدم؟",
    "Do you want to block this user?": "هل تريد حظر هذا المستخدم؟",
    "users.confirm_unblock": "هل تريد إلغاء حظر هذا المستخدم؟",
    "Do you want to unblock this user?": "هل تريد إلغاء حظر هذا المستخدم؟",
    "users.import_export": "استيراد المستخدمين وتصديرهم",
    "User import and export": "استيراد المستخدمين وتصديرهم",
    "users.user_id": "معرّف المستخدم",
    "User ID": "معرّف المستخدم",
    "users.first_name": "الاسم الأول",
    "First Name": "الاسم الأول",
    "users.last_name": "اسم العائلة",
    "Last Name": "اسم العائلة",
    "users.email": "البريد الإلكتروني",
    "users.phone_number": "رقم الهاتف",
    "Phone No": "رقم الهاتف",
    "users.country": "البلد",
    "users.profile": "الملف الشخصي",
    "Profile": "الملف الشخصي",
    "users.email_verified": "تم التحقق من البريد الإلكتروني",
    "Email Verified": "تم التحقق من البريد الإلكتروني",
    "users.blocked": "محظور",
    "Blocked": "محظور",
    "users.action": "الإجراء",
    "users.join_date": "تاريخ الانضمام",
    "Join Date": "تاريخ الانضمام",
    "users.last_login": "آخر تسجيل دخول",
    "Last Login": "آخر تسجيل دخول",
    "users.customer_type": "نوع العميل",
    "Customer Type": "نوع العميل",
    "common.and": "و",
    "and": "و",
    "users.import_failed": "تعذر استيراد المستخدمين.",
    "User import failed.": "تعذر استيراد المستخدمين.",
    "users.smart_upload.paid_title": "رفع المستخدمين الذكي ميزة مدفوعة",
    "Smart user upload is a paid feature": "رفع المستخدمين الذكي ميزة مدفوعة",
    "users.smart_upload.paid_description": "رقِّ مساحة العمل إلى Starter أو Go لرفع المستخدمين من ملف CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "رقِّ مساحة العمل إلى Starter أو Go لرفع المستخدمين من ملف CSV.",
    "users.smart_upload.view_plans": "عرض الخطط",
    "View plans": "عرض الخطط",
    "users.smart_upload.csv_needs_user": "يجب أن يحتوي ملف CSV على صف عناوين ومستخدم واحد على الأقل.",
    "The CSV must contain a header row and at least one user.": "يجب أن يحتوي ملف CSV على صف عناوين ومستخدم واحد على الأقل.",
    "users.smart_upload.unique_headers": "يجب أن يكون لكل عمود مستخدم عنوان فريد وغير فارغ.",
    "Every user column needs a unique, non-empty header.": "يجب أن يكون لكل عمود مستخدم عنوان فريد وغير فارغ.",
    "users.smart_upload.csv_read_error": "تعذرت قراءة ملف CSV.",
    "users.smart_upload.map_required": "اربط الحقول التالية قبل المتابعة: {fields}.",
    "Map {fields} before continuing.": "اربط الحقول التالية قبل المتابعة: {fields}.",
    "users.smart_upload.map_contact": "اربط عمود البريد الإلكتروني أو الهاتف. يجب أن يتضمن كل صف طريقة اتصال واحدة على الأقل.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "اربط عمود البريد الإلكتروني أو الهاتف. يجب أن يتضمن كل صف طريقة اتصال واحدة على الأقل.",
    "users.smart_upload.invalid_row": "يفتقد الصف {row} اسمًا مطلوبًا أو وسيلة اتصال.",
    "Row {row} is missing a required name or contact value.": "يفتقد الصف {row} اسمًا مطلوبًا أو وسيلة اتصال.",
    "users.smart_upload.attribute_name_required": "أدخل اسم سمة لـ “{header}”.",
    "users.smart_upload.attribute_create_error": "تعذر إنشاء السمة “{name}”.",
    "Could not create the “{name}” attribute.": "تعذر إنشاء السمة “{name}”.",
    "users.smart_upload.attribute_missing": "السمة المرتبطة من “{header}” لم تعد متاحة.",
    "users.smart_upload.prepare_error": "تعذر تجهيز ملف الاستيراد.",
    "Could not prepare the import file.": "تعذر تجهيز ملف الاستيراد.",
    "users.smart_upload.upload_error": "تعذر رفع ملف الاستيراد.",
    "users.smart_upload.all_duplicates": "كل صف في هذا الملف مكرر لصف آخر.",
    "Every row is a duplicate of another row in this file.": "كل صف في هذا الملف مكرر لصف آخر.",
    "users.smart_upload.source_attribute_error": "تعذر إنشاء سمة contact_source.",
    "Could not create the contact_source attribute.": "تعذر إنشاء سمة contact_source.",
    "users.smart_upload.duplicates_skipped": "صفوف مكررة سيتم تخطيها: {count}.",
    "Duplicate rows to skip: {count}.": "صفوف مكررة سيتم تخطيها: {count}.",
    "users.smart_upload.preparing_attributes": "جارٍ تجهيز السمات",
    "users.smart_upload.checking_users": "جارٍ التحقق من المستخدمين الحاليين",
    "Checking existing users": "جارٍ التحقق من المستخدمين الحاليين",
    "users.smart_upload.uploading_file": "جارٍ رفع ملف الاستيراد",
    "users.smart_upload.importing_users": "يقوم Tradly باستيراد المستخدمين",
    "Tradly is importing users": "يقوم Tradly باستيراد المستخدمين",
    "users.smart_upload.import_stopped": "تم إيقاف الاستيراد",
    "users.smart_upload.title": "رفع المستخدمين الذكي",
    "Smart user upload": "رفع المستخدمين الذكي",
    "users.smart_upload.beta": "(تجريبي)",
    "(Beta)": "(تجريبي)",
    "users.smart_upload.start_over": "البدء من جديد",
    "Start over": "البدء من جديد",
    "users.smart_upload.description": "ارفع جهات الاتصال، واربط الأعمدة بسمات المستخدم، وصنّفها كجهات صادرة أو مسجلة.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "ارفع جهات الاتصال، واربط الأعمدة بسمات المستخدم، وصنّفها كجهات صادرة أو مسجلة.",
    "users.smart_upload.step_upload": "رفع الملف",
    "users.smart_upload.step_match": "مطابقة الأعمدة",
    "Match columns": "مطابقة الأعمدة",
    "users.smart_upload.step_review": "مراجعة",
    "Review": "مراجعة",
    "users.smart_upload.step_import": "استيراد",
    "users.smart_upload.choose_csv": "اختر ملف CSV",
    "Choose a CSV file": "اختر ملف CSV",
    "users.smart_upload.required_fields": "الاسم الأول واسم العائلة والبريد الإلكتروني أو الهاتف مطلوبة. تُنشأ كلمات المرور تلقائيًا.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "الاسم الأول واسم العائلة والبريد الإلكتروني أو الهاتف مطلوبة. تُنشأ كلمات المرور تلقائيًا.",
    "users.smart_upload.select_csv": "اختيار ملف CSV",
    "users.smart_upload.match_columns": "مطابقة أعمدة المستخدمين",
    "Match user columns": "مطابقة أعمدة المستخدمين",
    "users.smart_upload.first_name": "الاسم الأول",
    "First name": "الاسم الأول",
    "users.smart_upload.last_name": "اسم العائلة",
    "Last name": "اسم العائلة",
    "users.smart_upload.email": "البريد الإلكتروني",
    "users.smart_upload.phone": "الهاتف",
    "users.smart_upload.username": "اسم المستخدم",
    "Username": "اسم المستخدم",
    "users.smart_upload.do_not_import": "عدم الاستيراد",
    "Do not import": "عدم الاستيراد",
    "users.smart_upload.additional_attributes": "سمات مستخدم إضافية",
    "Additional user attributes": "سمات مستخدم إضافية",
    "users.smart_upload.ignore_column": "تجاهل هذا العمود",
    "Ignore this column": "تجاهل هذا العمود",
    "users.smart_upload.create_attribute": "إنشاء سمة مستخدم جديدة",
    "Create a new user attribute": "إنشاء سمة مستخدم جديدة",
    "users.smart_upload.attribute_name": "اسم السمة",
    "Attribute name": "اسم السمة",
    "users.smart_upload.type_text": "نص",
    "Text": "نص",
    "users.smart_upload.type_long_text": "نص طويل",
    "Long text": "نص طويل",
    "users.smart_upload.type_number": "رقم",
    "Number": "رقم",
    "users.smart_upload.type_single_select": "اختيار واحد",
    "Single select": "اختيار واحد",
    "users.smart_upload.type_multi_select": "اختيارات متعددة",
    "users.smart_upload.review_import": "مراجعة الاستيراد",
    "Review import": "مراجعة الاستيراد",
    "users.smart_upload.review_description": "جهات الاتصال المراد استيرادها: {count}. قد ترفض الواجهة المستخدمين المسجلين في Tradly؛ وقد يؤدي تكرار استيراد جزئي إلى تكرار الصفوف التي نجحت.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "جهات الاتصال المراد استيرادها: {count}. قد ترفض الواجهة المستخدمين المسجلين في Tradly؛ وقد يؤدي تكرار استيراد جزئي إلى تكرار الصفوف التي نجحت.",
    "users.smart_upload.contact_classification": "تصنيف جهة الاتصال",
    "Contact classification": "تصنيف جهة الاتصال",
    "users.smart_upload.outbound": "صادرة (لم توافق على الاشتراك)",
    "Outbound (not opted in)": "صادرة (لم توافق على الاشتراك)",
    "users.smart_upload.signed_up": "مسجلة (وافقت على الاشتراك)",
    "Signed-up (opted in)": "مسجلة (وافقت على الاشتراك)",
    "users.smart_upload.contact_source_help": "يُحفظ هذا ضمن سمة contact_source. يظل نوع المستخدم المدمج في Tradly هو العميل.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "يُحفظ هذا ضمن سمة contact_source. يظل نوع المستخدم المدمج في Tradly هو العميل.",
    "users.smart_upload.import_complete": "اكتمل استيراد المستخدمين",
    "User import complete": "اكتمل استيراد المستخدمين",
    "users.smart_upload.imported_summary": "تم استيراد {imported} من أصل {total} مستخدمين.",
    "{imported} of {total} users imported.": "تم استيراد {imported} من أصل {total} مستخدمين.",
    "users.smart_upload.selected_file": "المحدد: {name}",
    "Selected: {name}": "المحدد: {name}",
    "users.smart_upload.review_action": "مراجعة",
    "users.smart_upload.importing_action": "جارٍ الاستيراد…",
    "Importing…": "جارٍ الاستيراد…",
    "users.smart_upload.import_users_action": "استيراد المستخدمين",
    "users.import.uploading": "جارٍ الرفع…",
    "Uploading…": "جارٍ الرفع…",
    "users.import.please_wait": "يرجى الانتظار…",
    "Please wait…": "يرجى الانتظار…",
    "users.import.error_prefix": "خطأ",
    "users.import.select_file_error": "يرجى اختيار ملف",
    "Please select a file": "يرجى اختيار ملف",
    "users.import.download": "تنزيل",
    "users.import.file_label": "الملف:",
    "File:": "الملف:",
    "users.import.select_file": "اختيار ملف",
    "users.import.upload": "رفع",
    "users.create.button": "إنشاء مستخدم",
    "Create User": "إنشاء مستخدم",
    "users.create.title": "إنشاء مستخدم جديد",
    "Create New User": "إنشاء مستخدم جديد",
    "users.create.please_wait": "يرجى الانتظار…",
    "users.create.email": "البريد الإلكتروني",
    "users.create.first_name": "الاسم الأول",
    "users.create.last_name": "اسم العائلة",
    "users.create.email_required": "البريد الإلكتروني مطلوب",
    "Email is required": "البريد الإلكتروني مطلوب",
    "users.create.first_name_required": "الاسم الأول مطلوب",
    "First Name is required": "الاسم الأول مطلوب",
    "users.create.last_name_required": "اسم العائلة مطلوب",
    "Last Name is required": "اسم العائلة مطلوب",
    "users.create.session_expired": "انتهت جلسة المسؤول. يُرجى تسجيل الدخول مرة أخرى قبل إنشاء مستخدم.",
    "Your admin session has expired. Please sign in again before creating a user.": "انتهت جلسة المسؤول. يُرجى تسجيل الدخول مرة أخرى قبل إنشاء مستخدم.",
    "users.create.unable_to_create": "تعذر إنشاء هذا المستخدم.",
    "Unable to create this user.": "تعذر إنشاء هذا المستخدم.",
    "users.create.success": "تم إنشاء المستخدم بنجاح",
    "User created successfully": "تم إنشاء المستخدم بنجاح",
    "users.create.failed": "فشل إنشاء المستخدم. يُرجى المحاولة مرة أخرى.",
    "User creation failed. Please try again.": "فشل إنشاء المستخدم. يُرجى المحاولة مرة أخرى.",
    "common.feature_flow.eyebrow": "اكتشف طريقة العمل",
    "SEE HOW IT WORKS": "اكتشف طريقة العمل",
    "common.feature_flow.open_guide": "فتح دليل سير العمل",
    "Open flow guide": "فتح دليل سير العمل",
    "common.feature_flow.close_guide": "إغلاق دليل القسم",
    "Close section guide": "إغلاق دليل القسم",
    "common.feature_flow.section_guide": "دليل القسم",
    "Section guide": "دليل القسم",
    "users.flow.title": "كل ما تحتاج إليه لإدارة المستخدمين",
    "Everything you need to manage your users": "كل ما تحتاج إليه لإدارة المستخدمين",
    "users.flow.description": "أنشئ ملفات تعريف المستخدمين وخصص بياناتهم وافهم ملاحظات العملاء في مكان واحد.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "أنشئ ملفات تعريف المستخدمين وخصص بياناتهم وافهم ملاحظات العملاء في مكان واحد.",
    "users.flow.lane_title": "إدارة المستخدمين",
    "User management": "إدارة المستخدمين",
    "users.flow.badge": "الأدوات الأساسية",
    "Core tools": "الأدوات الأساسية",
    "users.flow.attributes": "السمات",
    "Attributes": "السمات",
    "users.flow.reviews": "المراجعات",
    "Reviews": "المراجعات",
    "users.flow.lane_description": "أدِر الأشخاص، وأضف حقول الملف الشخصي التي تحتاج إليها، وتعرّف على تجربتهم.",
    "Manage people, add the profile fields you need, and learn from their experience.": "أدِر الأشخاص، وأضف حقول الملف الشخصي التي تحتاج إليها، وتعرّف على تجربتهم.",
    "users.flow.primary_action": "أضف أول مستخدم لك",
    "Add your first user": "أضف أول مستخدم لك",
    "users.tooltip.title": "لكل شخص ملف مستخدم فريد",
    "Every individual is a unique user": "لكل شخص ملف مستخدم فريد",
    "users.tooltip.description": "تخيّل للحظة أنك تملك مركزًا تجاريًا.\n\nكل شخص يدخل متجرًا يُعد مستخدمًا.\n\nوكل تاجر يدير متجرًا يُعد مستخدمًا.\n\nفي Tradly، يُطلق اسم “المستخدمون” على جميع الأشخاص، سواء كانوا تجارًا أو عملاء، وتُحفظ تفاصيلهم الفريدة في قسم المستخدمين. يمكنك العثور على تفاصيل مشترياتهم أو الحسابات التي يملكونها.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "تخيّل للحظة أنك تملك مركزًا تجاريًا.\n\nكل شخص يدخل متجرًا يُعد مستخدمًا.\n\nوكل تاجر يدير متجرًا يُعد مستخدمًا.\n\nفي Tradly، يُطلق اسم “المستخدمون” على جميع الأشخاص، سواء كانوا تجارًا أو عملاء، وتُحفظ تفاصيلهم الفريدة في قسم المستخدمين. يمكنك العثور على تفاصيل مشترياتهم أو الحسابات التي يملكونها.",
    "workspace.loading": "جارٍ تحميل إعدادات مساحة العمل…",
    "Loading workspace settings…": "جارٍ تحميل إعدادات مساحة العمل…",
    "workspace.kicker": "مساحة العمل",
    "WORKSPACE": "مساحة العمل",
    "workspace.fallback_name": "مساحة العمل",
    "workspace.members.title": "دعوة عضو إلى الفريق",
    "Invite Team Member": "دعوة عضو إلى الفريق",
    "workspace.members.description": "أضف أعضاء الفريق وامنح كل شخص مستوى الوصول الذي يحتاجه فقط.",
    "Add teammates and give each person only the access they need.": "أضف أعضاء الفريق وامنح كل شخص مستوى الوصول الذي يحتاجه فقط.",
    "workspace.members.enter_name_email": "أدخل اسم العضو وعنوان بريده الإلكتروني.",
    "Enter a member name and email address.": "أدخل اسم العضو وعنوان بريده الإلكتروني.",
    "workspace.members.invitation_sent": "تم إرسال الدعوة.",
    "Invitation sent.": "تم إرسال الدعوة.",
    "workspace.members.confirm_remove": "هل تريد إزالة {name} من مساحة العمل هذه؟",
    "Remove {name} from this workspace?": "هل تريد إزالة {name} من مساحة العمل هذه؟",
    "workspace.members.removed": "تمت إزالة عضو الفريق.",
    "Team member removed.": "تمت إزالة عضو الفريق.",
    "workspace.members.roles_saved": "تم حفظ أدوار العضو.",
    "Member roles saved.": "تم حفظ أدوار العضو.",
    "workspace.members.read": "قراءة",
    "Read": "قراءة",
    "workspace.members.write": "كتابة",
    "Write": "كتابة",
    "workspace.members.delete": "حذف",
    "workspace.members.select_all_permission": "تحديد كل أذونات {permission} ضمن {group}",
    "Select all {permission} in {group}": "تحديد كل أذونات {permission} ضمن {group}",
    "workspace.members.member_name": "اسم العضو",
    "Member Name": "اسم العضو",
    "workspace.members.email_address": "عنوان البريد الإلكتروني",
    "Email Address": "عنوان البريد الإلكتروني",
    "workspace.members.sending": "جارٍ الإرسال…",
    "Sending…": "جارٍ الإرسال…",
    "workspace.members.send_invitation": "إرسال الدعوة",
    "Send invitation": "إرسال الدعوة",
    "workspace.members.team_members": "أعضاء الفريق",
    "Team members": "أعضاء الفريق",
    "workspace.members.search_members": "البحث عن الأعضاء",
    "Search members": "البحث عن الأعضاء",
    "workspace.members.search": "بحث",
    "workspace.members.member": "العضو",
    "Member": "العضو",
    "workspace.members.email": "البريد الإلكتروني",
    "workspace.members.status": "الحالة",
    "workspace.members.actions": "الإجراءات",
    "workspace.members.unnamed": "عضو بلا اسم",
    "Unnamed member": "عضو بلا اسم",
    "workspace.members.roles": "الأدوار",
    "Roles": "الأدوار",
    "workspace.members.empty": "لم يتم العثور على أعضاء الفريق.",
    "No team members found.": "لم يتم العثور على أعضاء الفريق.",
    "workspace.members.page_of": "الصفحة {page} من {pages}",
    "Page {page} of {pages}": "الصفحة {page} من {pages}",
    "workspace.members.assign_roles": "تعيين الأدوار",
    "Assign roles": "تعيين الأدوار",
    "workspace.members.save_roles": "حفظ الأدوار",
    "Save roles": "حفظ الأدوار",
    "workspace.members.saving": "جارٍ الحفظ…",
    "Saving…": "جارٍ الحفظ…",
    "workspace.error.generic": "حدث خطأ. يُرجى المحاولة مرة أخرى.",
    "Something went wrong. Please try again.": "حدث خطأ. يُرجى المحاولة مرة أخرى.",
    "workspace.billing.view_label": "عرض فوترة مساحة العمل",
    "Billing workspace view": "عرض فوترة مساحة العمل",
    "workspace.billing.tab_usage": "الاستخدام",
    "Usage": "الاستخدام",
    "workspace.billing.tab_plans": "الخطط",
    "workspace.billing.tab_invoices": "الفواتير المدفوعة",
    "Paid invoices": "الفواتير المدفوعة",
    "workspace.billing.tab_account": "الحساب",
    "workspace.account.title": "إعدادات النشاط التجاري",
    "Business Settings": "إعدادات النشاط التجاري",
    "workspace.account.description": "أدر ملف نشاطك التجاري والمنتجات المفعّلة وخصوصية الحساب.",
    "Manage your business profile, enabled products, and account privacy.": "أدر ملف نشاطك التجاري والمنتجات المفعّلة وخصوصية الحساب.",
    "workspace.account.profile_updated": "تم تحديث ملف النشاط التجاري.",
    "Business profile updated.": "تم تحديث ملف النشاط التجاري.",
    "workspace.account.logo_updated": "تم تحديث الشعار.",
    "Logo updated.": "تم تحديث الشعار.",
    "workspace.account.logo_upload_error": "تعذّر تحميل الشعار.",
    "Unable to upload logo.": "تعذّر تحميل الشعار.",
    "workspace.account.confirm_delete": "هل تريد حذف حساب Tradly نهائيًا؟ لا يمكن التراجع عن ذلك.",
    "Delete this Tradly account permanently? This cannot be undone.": "هل تريد حذف حساب Tradly نهائيًا؟ لا يمكن التراجع عن ذلك.",
    "workspace.account.business_profile": "ملف النشاط التجاري",
    "Business Profile": "ملف النشاط التجاري",
    "workspace.account.logo": "الشعار",
    "Logo": "الشعار",
    "workspace.account.logo_alt": "شعار النشاط التجاري",
    "Business logo": "شعار النشاط التجاري",
    "workspace.account.add_photo": "إضافة صورة",
    "Add photo": "إضافة صورة",
    "workspace.account.logo_formats": "PNG أو JPG أو SVG أو ICO",
    "PNG, JPG, SVG or ICO": "PNG أو JPG أو SVG أو ICO",
    "workspace.account.business_name": "اسم النشاط التجاري",
    "Business Name": "اسم النشاط التجاري",
    "workspace.account.contact_name": "اسم جهة الاتصال للنشاط التجاري",
    "Business Contact Name": "اسم جهة الاتصال للنشاط التجاري",
    "workspace.account.business_address": "عنوان النشاط التجاري",
    "Business Address": "عنوان النشاط التجاري",
    "workspace.account.products_of_interest": "المنتجات محل الاهتمام",
    "Products of Interest": "المنتجات محل الاهتمام",
    "workspace.account.marketplace": "السوق",
    "workspace.account.single_store": "تجارة المتجر الواحد",
    "Single Store Commerce": "تجارة المتجر الواحد",
    "workspace.account.alacarte_products": "المنتجات حسب الطلب",
    "À la carte Products": "المنتجات حسب الطلب",
    "workspace.account.alacarte_description": "تتم إدارة المنتجات الفردية المفعّلة لمساحة العمل هذه من «الخطط والفوترة».",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "تتم إدارة المنتجات الفردية المفعّلة لمساحة العمل هذه من «الخطط والفوترة».",
    "workspace.account.manage_alacarte": "إدارة المنتجات حسب الطلب",
    "Manage à la carte products": "إدارة المنتجات حسب الطلب",
    "workspace.account.delete_irreversible": "حذف حسابك: إجراء لا رجعة فيه",
    "Delete your Account: Irreversible": "حذف حسابك: إجراء لا رجعة فيه",
    "workspace.account.delete_description": "سيؤدي ذلك إلى حذف مستأجر Tradly وجميع البيانات المرتبطة به نهائيًا.",
    "This permanently deletes the Tradly tenant and all associated data.": "سيؤدي ذلك إلى حذف مستأجر Tradly وجميع البيانات المرتبطة به نهائيًا.",
    "workspace.account.deleting": "جارٍ الحذف…",
    "Deleting…": "جارٍ الحذف…",
    "workspace.account.delete_button": "حذف حساب Tradly",
    "Delete Account With Tradly": "حذف حساب Tradly",
    "workspace.privacy.title": "الخصوصية ومعالجو البيانات",
    "Privacy & Data Processors": "الخصوصية ومعالجو البيانات",
    "workspace.privacy.description": "تعرّف على الجهات التي تساعد في تشغيل Tradly وكيفية الاحتفاظ بالبيانات بعد طلب الحذف.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "تعرّف على الجهات التي تساعد في تشغيل Tradly وكيفية الاحتفاظ بالبيانات بعد طلب الحذف.",
    "workspace.privacy.processor_retention": "نستخدم الجهات والأدوات التالية لتشغيل الخدمة وتحسين جودة المنتج ودعم الفوترة والموثوقية. تنطبق مدة الاحتفاظ هذه فقط بعد طلب المستخدم حذف حسابه. نحتفظ ببيانات مستخدمي منصة Tradly لمدة تقارب 90–180 يومًا بحسب الاحتياجات التشغيلية ومتطلبات الامتثال.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "نستخدم الجهات والأدوات التالية لتشغيل الخدمة وتحسين جودة المنتج ودعم الفوترة والموثوقية. تنطبق مدة الاحتفاظ هذه فقط بعد طلب المستخدم حذف حسابه. نحتفظ ببيانات مستخدمي منصة Tradly لمدة تقارب 90–180 يومًا بحسب الاحتياجات التشغيلية ومتطلبات الامتثال.",
    "workspace.privacy.read_more": "اقرأ المزيد.",
    "Read more.": "اقرأ المزيد.",
    "workspace.privacy.tool": "الأداة",
    "Tool": "الأداة",
    "workspace.privacy.purpose": "الغرض",
    "Purpose": "الغرض",
    "workspace.privacy.data_category": "فئة البيانات",
    "Data Category": "فئة البيانات",
    "workspace.privacy.deletion_requests": "طلبات حذف الحساب والبيانات",
    "Account deletion and data requests": "طلبات حذف الحساب والبيانات",
    "workspace.privacy.deletion_description": "لطلب حذف الحساب أو الإزالة من أداة إدارة علاقات العملاء، تواصل مع مشرف مساحة العمل أو الدعم. تتطلب هذه الإجراءات تأكيدًا من الخادم قبل إتاحتها هنا.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "لطلب حذف الحساب أو الإزالة من أداة إدارة علاقات العملاء، تواصل مع مشرف مساحة العمل أو الدعم. تتطلب هذه الإجراءات تأكيدًا من الخادم قبل إتاحتها هنا.",
    "workspace.privacy.open_account": "فتح إعدادات الحساب",
    "Open account settings": "فتح إعدادات الحساب",
    "workspace.privacy.core_operations": "عمليات المنتج الأساسية",
    "Core product operations": "عمليات المنتج الأساسية",
    "workspace.privacy.user_data_retention": "بيانات المستخدم (الاحتفاظ: 90–180 يومًا)",
    "User data (retention: 90–180 days)": "بيانات المستخدم (الاحتفاظ: 90–180 يومًا)",
    "workspace.privacy.crm_support_lifecycle": "إدارة علاقات العملاء والدعم والتواصل خلال دورة حياة المستخدم",
    "CRM, support, lifecycle communication": "إدارة علاقات العملاء والدعم والتواصل خلال دورة حياة المستخدم",
    "workspace.privacy.personal_data": "بيانات شخصية",
    "Personal data": "بيانات شخصية",
    "workspace.privacy.product_analytics": "تحليلات المنتج ومسارات التفاعل",
    "Product analytics and engagement funnels": "تحليلات المنتج ومسارات التفاعل",
    "workspace.privacy.usage_events": "بيانات الاستخدام والأحداث التحليلية",
    "Usage and event analytics": "بيانات الاستخدام والأحداث التحليلية",
    "workspace.privacy.billing_payments": "الفوترة ومعالجة المدفوعات",
    "Billing and payment processing": "الفوترة ومعالجة المدفوعات",
    "workspace.privacy.billing_data": "بيانات الفوترة",
    "Billing data": "بيانات الفوترة",
    "workspace.privacy.traffic_analytics": "تحليلات الزيارات والسلوك",
    "Traffic and behavior analytics": "تحليلات الزيارات والسلوك",
    "workspace.privacy.usage_analytics": "تحليلات الاستخدام",
    "Usage analytics": "تحليلات الاستخدام",
    "workspace.privacy.session_diagnostics": "تحليلات الجلسات وتشخيص الأزرار المعطلة",
    "Session insights and broken-button diagnostics": "تحليلات الجلسات وتشخيص الأزرار المعطلة",
    "workspace.privacy.ux_telemetry": "قياس تجربة المستخدم والجلسات",
    "UX/session telemetry": "قياس تجربة المستخدم والجلسات",
    "workspace.privacy.error_monitoring": "مراقبة أخطاء الشفرة واستقرارها",
    "Code error and stability monitoring": "مراقبة أخطاء الشفرة واستقرارها",
    "workspace.privacy.error_logs": "سجلات الأخطاء والتشخيص",
    "Error logs and diagnostics": "سجلات الأخطاء والتشخيص",
    "workspace.privacy.email_delivery": "إرسال البريد الإلكتروني للمعاملات",
    "Transactional email delivery": "إرسال البريد الإلكتروني للمعاملات",
    "workspace.privacy.email_metadata": "بيانات البريد الإلكتروني الوصفية",
    "Email metadata": "بيانات البريد الإلكتروني الوصفية",
    "workspace.privacy.hosting_infrastructure": "الاستضافة والبنية التحتية",
    "Hosting and infrastructure": "الاستضافة والبنية التحتية",
    "workspace.privacy.infrastructure_logs": "سجلات البنية التحتية والخدمة",
    "Infrastructure and service logs": "سجلات البنية التحتية والخدمة",
    "workspace.domain.title": "النطاقات",
    "Domains": "النطاقات",
    "workspace.domain.description": "اربط نطاقك الخاص لاستبدال عنوان Tradly المستضاف الافتراضي.",
    "Connect your own domain to replace the default hosted Tradly URL.": "اربط نطاقك الخاص لاستبدال عنوان Tradly المستضاف الافتراضي.",
    "workspace.domain.invalid": "أدخل نطاقًا صالحًا، مثل example.com.",
    "Enter a valid domain, such as example.com.": "أدخل نطاقًا صالحًا، مثل example.com.",
    "workspace.domain.reserved": "النطاق tradly.co مخصص لنطاقات مساحات العمل المستضافة.",
    "tradly.co is reserved for hosted workspace domains.": "النطاق tradly.co مخصص لنطاقات مساحات العمل المستضافة.",
    "workspace.domain.missing_primary": "لا يتوفر نطاق أساسي لمساحة العمل.",
    "No primary workspace domain is available.": "لا يتوفر نطاق أساسي لمساحة العمل.",
    "workspace.domain.saved": "تم حفظ النطاق المخصص. حدّث سجلات DNS ثم أعد تحميل الحالة.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "تم حفظ النطاق المخصص. حدّث سجلات DNS ثم أعد تحميل الحالة.",
    "workspace.domain.reset_success": "تمت إعادة النطاق إلى عنوان Tradly المستضاف.",
    "Domain reset to the Tradly-hosted URL.": "تمت إعادة النطاق إلى عنوان Tradly المستضاف.",
    "workspace.domain.current": "النطاق الحالي",
    "CURRENT DOMAIN": "النطاق الحالي",
    "workspace.domain.hosted": "نطاق مستضاف لدى Tradly",
    "Tradly-hosted domain": "نطاق مستضاف لدى Tradly",
    "workspace.domain.dns_status": "حالة DNS: {status}",
    "DNS status: {status}": "حالة DNS: {status}",
    "workspace.domain.checking": "جارٍ التحقق من حالة DNS…",
    "Checking DNS status…": "جارٍ التحقق من حالة DNS…",
    "workspace.domain.refresh": "تحديث الحالة",
    "Refresh status": "تحديث الحالة",
    "workspace.domain.reset": "إعادة تعيين النطاق",
    "Reset domain": "إعادة تعيين النطاق",
    "workspace.domain.connect_title": "ربط نطاق مخصص",
    "Connect a custom domain": "ربط نطاق مخصص",
    "workspace.domain.connect_description": "أدخل نطاقًا تملكه بالفعل. سنعرض سجلات DNS اللازمة لربطه.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "أدخل نطاقًا تملكه بالفعل. سنعرض سجلات DNS اللازمة لربطه.",
    "workspace.domain.saving": "جارٍ الحفظ…",
    "workspace.domain.add": "إضافة نطاق",
    "Add domain": "إضافة نطاق",
    "workspace.domain.dns_title": "إعداد DNS",
    "DNS setup": "إعداد DNS",
    "workspace.domain.a_record": "سجل A",
    "A record": "سجل A",
    "workspace.domain.root_description": "استخدم هذا للنطاق الجذر، مثل",
    "Use this for a root domain such as": "استخدم هذا للنطاق الجذر، مثل",
    "workspace.domain.cname_record": "سجل CNAME",
    "CNAME record": "سجل CNAME",
    "workspace.domain.subdomain_description": "استخدم هذا للنطاق الفرعي، مثل",
    "Use this for a subdomain such as": "استخدم هذا للنطاق الفرعي، مثل",
    "workspace.domain.host": "المضيف",
    "Host": "المضيف",
    "workspace.domain.value": "القيمة",
    "Value": "القيمة",
    "workspace.domain.need_domain": "هل تحتاج إلى نطاق؟",
    "Need a domain?": "هل تحتاج إلى نطاق؟",
    "workspace.domain.buy_domain": "اشترِ نطاقًا من Google Domains أو GoDaddy، ثم عُد إلى هنا لربطه.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "اشترِ نطاقًا من Google Domains أو GoDaddy، ثم عُد إلى هنا لربطه.",
    "workspace.billing.title": "الفوترة والاستخدام",
    "Billing & Usage": "الفوترة والاستخدام",
    "workspace.billing.description": "أدر خطط مساحة العمل والاستخدام والفوترة.",
    "Manage workspace plans, usage, and billing.": "أدر خطط مساحة العمل والاستخدام والفوترة.",
    "workspace.billing.invoice_description": "أدر خطط مساحة العمل والاستخدام والفواتير المدفوعة.",
    "Manage workspace plans, usage, and paid invoices.": "أدر خطط مساحة العمل والاستخدام والفواتير المدفوعة.",
    "workspace.billing.usage_description": "اطّلع على الاستخدام الحالي والحدود المطبقة على مساحة العمل هذه.",
    "See current usage and the limits applied to this workspace.": "اطّلع على الاستخدام الحالي والحدود المطبقة على مساحة العمل هذه.",
    "workspace.invoices.loading": "جارٍ تحميل الفواتير…",
    "Loading invoices…": "جارٍ تحميل الفواتير…",
    "workspace.invoices.description": "نزّل الفواتير أو أكمل دفع الرصيد المستحق.",
    "Download invoices or complete payment for an outstanding balance.": "نزّل الفواتير أو أكمل دفع الرصيد المستحق.",
    "workspace.invoices.payment_failed": "فشل الدفع — قد يتأثر الوصول إلى الخدمة.",
    "Payment failed — service access may be affected.": "فشل الدفع — قد يتأثر الوصول إلى الخدمة.",
    "workspace.invoices.awaiting_payment": "الفاتورة {invoice} بانتظار الدفع.",
    "Invoice {invoice} is awaiting payment.": "الفاتورة {invoice} بانتظار الدفع.",
    "workspace.invoices.outstanding": "مستحق",
    "outstanding": "مستحق",
    "workspace.invoices.pay_invoice": "دفع الفاتورة",
    "Pay invoice": "دفع الفاتورة",
    "workspace.invoices.invoice": "الفاتورة",
    "workspace.invoices.date": "التاريخ",
    "workspace.invoices.amount": "المبلغ",
    "workspace.invoices.paid": "مدفوع",
    "workspace.invoices.unpaid": "غير مدفوع",
    "Unpaid": "غير مدفوع",
    "workspace.invoices.download_invoice": "تنزيل الفاتورة",
    "Download invoice": "تنزيل الفاتورة",
    "workspace.invoices.empty_title": "لا توجد فواتير",
    "No invoices available": "لا توجد فواتير",
    "workspace.invoices.empty_description": "تُنشأ الفواتير بعد الاشتراك وإجراء الدفع. تواصل مع الدعم إذا كانت لديك أسئلة.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "تُنشأ الفواتير بعد الاشتراك وإجراء الدفع. تواصل مع الدعم إذا كانت لديك أسئلة.",
    "workspace.plans.heading": "الخطط",
    "workspace.plans.tab_marketplace": "السوق متعدد البائعين",
    "workspace.plans.tab_marketplace_description": "متعدد البائعين",
    "Multi-vendor": "متعدد البائعين",
    "workspace.plans.tab_single": "متجر واحد",
    "Single Store": "متجر واحد",
    "workspace.plans.tab_single_description": "المستقلون وصنّاع المحتوى",
    "Indie & Creators": "المستقلون وصنّاع المحتوى",
    "workspace.plans.tab_alacarte": "حسب الطلب",
    "A la carte": "حسب الطلب",
    "workspace.plans.tab_alacarte_description": "أرصدة وإضافات",
    "Credits & add-ons": "أرصدة وإضافات",
    "workspace.plans.tab_services": "الخدمات",
    "Services": "الخدمات",
    "workspace.plans.tab_services_description": "خدمات إضافية",
    "Additional services": "خدمات إضافية",
    "workspace.plans.selected": "محدد",
    "Selected": "محدد",
    "workspace.plans.try_again": "حاول مرة أخرى",
    "Try again": "حاول مرة أخرى",
    "workspace.plans.bill_yearly": "الدفع سنويًا",
    "Bill Yearly": "الدفع سنويًا",
    "workspace.plans.bill_monthly": "الدفع شهريًا",
    "Bill Monthly": "الدفع شهريًا",
    "workspace.plans.compare": "مقارنة الخطط",
    "Compare Plans": "مقارنة الخطط",
    "workspace.plans.community": "المجتمع",
    "workspace.plans.community_description": "مجاني دائمًا. مثالي للهواة ومشاريع المجتمع.",
    "Free forever. Perfect for hobbyists and community projects.": "مجاني دائمًا. مثالي للهواة ومشاريع المجتمع.",
    "workspace.plans.different_configurations": "هل تبحث عن إعدادات مختلفة؟",
    "Looking for different configurations?": "هل تبحث عن إعدادات مختلفة؟",
    "workspace.plans.contact_us": "تواصل معنا",
    "Contact Us": "تواصل معنا",
    "workspace.plans.see_alacarte_pricing": "عرض أسعار المنتجات حسب الطلب",
    "See à la carte pricing": "عرض أسعار المنتجات حسب الطلب",
    "workspace.plans.available": "متاح",
    "Available": "متاح",
    "workspace.plans.used_90d": "المستخدم (90 يومًا)",
    "Used (90d)": "المستخدم (90 يومًا)",
    "workspace.plans.expired_90d": "منتهي (90 يومًا)",
    "Expired (90d)": "منتهي (90 يومًا)",
    "workspace.plans.expires_on": "ينتهي في {date}",
    "Expires {date}": "ينتهي في {date}",
    "workspace.plans.top_up_credits": "شحن الأرصدة",
    "Top Up Credits": "شحن الأرصدة",
    "workspace.plans.credits_description": "تُستخدم الأرصدة للبريد الإلكتروني والبحث بالذكاء الاصطناعي والتوصيات وإجراءات الوكلاء. 100 رصيد = 5 دولارات.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "تُستخدم الأرصدة للبريد الإلكتروني والبحث بالذكاء الاصطناعي والتوصيات وإجراءات الوكلاء. 100 رصيد = 5 دولارات.",
    "workspace.plans.credits": "أرصدة",
    "credits": "أرصدة",
    "workspace.plans.custom_amount": "مبلغ مخصص",
    "Custom amount": "مبلغ مخصص",
    "workspace.plans.amount_example": "مثال: 2500",
    "e.g. 2500": "مثال: 2500",
    "workspace.plans.opening_checkout": "جارٍ فتح صفحة الدفع…",
    "Opening checkout…": "جارٍ فتح صفحة الدفع…",
    "workspace.plans.buy_credits": "شراء {count} رصيدًا",
    "Buy {count} credits": "شراء {count} رصيدًا",
    "workspace.plans.select_amount": "اختر مبلغًا",
    "Select an amount": "اختر مبلغًا",
    "workspace.plans.alacarte_products": "المنتجات حسب الطلب",
    "A la carte Products": "المنتجات حسب الطلب",
    "workspace.plans.products_description": "اختر المنتجات التي تستخدمها لمساعدتنا على تخصيص تجربتك. يُدفع مقابل الاستخدام بالأرصدة.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "اختر المنتجات التي تستخدمها لمساعدتنا على تخصيص تجربتك. يُدفع مقابل الاستخدام بالأرصدة.",
    "workspace.plans.enabled": "مفعّل",
    "workspace.plans.enable": "تفعيل",
    "Enable": "تفعيل",
    "workspace.plans.open_here": "فتح هنا",
    "Open here": "فتح هنا",
    "workspace.plans.open_marketing": "فتح marketing.tradly.app",
    "Open marketing.tradly.app": "فتح marketing.tradly.app",
    "workspace.plans.open_analytics": "فتح analytics.tradly.app",
    "Open analytics.tradly.app": "فتح analytics.tradly.app",
    "workspace.plans.open_external": "فتح خارجيًا",
    "Open external": "فتح خارجيًا",
    "workspace.plans.coming_soon": "قريبًا",
    "Coming soon": "قريبًا",
    "workspace.plans.services_title": "إعداد لمرة واحدة وخدمات مخصصة",
    "One-Time Setup & Custom Services": "إعداد لمرة واحدة وخدمات مخصصة",
    "workspace.plans.service_app_launch": "إطلاق تطبيق بعلامة تجارية خاصة",
    "White-Label App Launch": "إطلاق تطبيق بعلامة تجارية خاصة",
    "workspace.plans.service_frontend": "تخصيص الواجهة الأمامية",
    "Frontend Customization": "تخصيص الواجهة الأمامية",
    "workspace.plans.service_multilanguage": "دعم لغات متعددة",
    "Multi-Language Support": "دعم لغات متعددة",
    "workspace.plans.view_docs": "عرض الوثائق",
    "View Docs": "عرض الوثائق",
    "workspace.plans.confirm_change": "تأكيد تغيير خطتك",
    "Confirm your plan change": "تأكيد تغيير خطتك",
    "workspace.plans.confirm_charge": "تُدفع الرسوم مقدمًا وتُحصّل في تاريخ اشتراكك.",
    "Charges are prepaid and billed on your subscription date.": "تُدفع الرسوم مقدمًا وتُحصّل في تاريخ اشتراكك.",
    "workspace.plans.confirm_promo": "يمكن إدخال الرموز الترويجية أثناء الدفع عبر Stripe عند توفرها.",
    "Promotional codes can be entered during Stripe checkout where available.": "يمكن إدخال الرموز الترويجية أثناء الدفع عبر Stripe عند توفرها.",
    "workspace.plans.confirm_delay": "قد يستغرق ظهور تغييرات الخطة في مساحة العمل بعض الوقت.",
    "Plan changes may take a moment to appear in your workspace.": "قد يستغرق ظهور تغييرات الخطة في مساحة العمل بعض الوقت.",
    "workspace.plans.payment_active": "تم استلام الدفعة. خطتك نشطة.",
    "Payment received. Your plan is active.": "تم استلام الدفعة. خطتك نشطة.",
    "workspace.plans.payment_method_updated": "تم تحديث طريقة الدفع.",
    "Payment method updated.": "تم تحديث طريقة الدفع.",
    "workspace.plans.payment_cancelled": "لم تكتمل عملية الدفع، لذلك لم تتغير خطتك.",
    "Payment was not completed, so your plan has not changed.": "لم تكتمل عملية الدفع، لذلك لم تتغير خطتك.",
    "workspace.plans.activating": "تم استلام الدفعة. جارٍ تفعيل خطتك…",
    "Payment received. Activating your plan…": "تم استلام الدفعة. جارٍ تفعيل خطتك…",
    "workspace.plans.activation_delayed": "تم استلام الدفعة. يستغرق تفعيل خطتك وقتًا أطول قليلًا. حدّث الصفحة بعد دقيقة.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "تم استلام الدفعة. يستغرق تفعيل خطتك وقتًا أطول قليلًا. حدّث الصفحة بعد دقيقة.",
    "workspace.plans.card_saved": "تم حفظ البطاقة وتحديث الاشتراك.",
    "Card saved and subscription updated.": "تم حفظ البطاقة وتحديث الاشتراك.",
    "workspace.plans.subscription_updated": "تم تحديث الاشتراك.",
    "Subscription updated.": "تم تحديث الاشتراك.",
    "workspace.plans.products_saved": "تم حفظ المنتجات حسب الطلب.",
    "À la carte products saved.": "تم حفظ المنتجات حسب الطلب.",
    "workspace.plans.minimum_credits": "أدخل 100 رصيد على الأقل.",
    "Enter at least 100 credits.": "أدخل 100 رصيد على الأقل.",
    "workspace.plans.credit_topup_description": "شحن الأرصدة ({count} رصيدًا)",
    "Credit Top-Up ({count} credits)": "شحن الأرصدة ({count} رصيدًا)",
    "workspace.plans.billing_details": "تفاصيل الفوترة الحالية",
    "Current billing details": "تفاصيل الفوترة الحالية",
    "workspace.plans.current_plan": "الخطة الحالية",
    "Current Plan": "الخطة الحالية",
    "workspace.plans.renews": "تتجدد",
    "Renews": "تتجدد",
    "workspace.plans.payment_method": "طريقة الدفع",
    "Payment method": "طريقة الدفع",
    "workspace.plans.opening": "جارٍ الفتح…",
    "Opening…": "جارٍ الفتح…",
    "workspace.plans.manage_payment_method": "إدارة طريقة الدفع",
    "Manage payment method": "إدارة طريقة الدفع",
    "workspace.plans.upgrade": "ترقية",
    "Upgrade": "ترقية",
    "workspace.plans.downgrade": "تخفيض",
    "Downgrade": "تخفيض",
    "workspace.plans.custom_price": "مخصص",
    "Custom": "مخصص",
    "workspace.plans.per_month_short": "/ شهر",
    "/month": "/ شهر",
    "workspace.plans.per_year_amount": "سنويًا ({amount})",
    "per year ({amount})": "سنويًا ({amount})",
    "workspace.plans.per_month_amount": "شهريًا ({amount})",
    "per month ({amount})": "شهريًا ({amount})",
    "workspace.plans.yearly_savings": "وفّر {amount} سنويًا",
    "Save {amount} yearly": "وفّر {amount} سنويًا",
    "workspace.plans.billed_yearly": "تُحصّل الفوترة سنويًا",
    "billed yearly": "تُحصّل الفوترة سنويًا",
    "workspace.plans.billed_monthly": "تُحصّل الفوترة شهريًا",
    "billed monthly": "تُحصّل الفوترة شهريًا",
    "workspace.plans.free_trial": "أنت تستخدم فترة تجريبية مجانية.",
    "You are on a free trial.": "أنت تستخدم فترة تجريبية مجانية.",
    "workspace.plans.updating": "جارٍ التحديث…",
    "Updating…": "جارٍ التحديث…",
    "workspace.plans.temporarily_unavailable": "غير متاح مؤقتًا",
    "Temporarily unavailable": "غير متاح مؤقتًا",
    "workspace.plans.whats_included": "ما الذي تتضمنه الخطة؟",
    "What's included": "ما الذي تتضمنه الخطة؟",
    "workspace.plans.products.auth.title": "المصادقة",
    "workspace.plans.products.auth.description": "الهوية وتسجيل الدخول الموحد والأذونات وإدارة المستخدمين.",
    "Identity, SSO, permissions, and user management.": "الهوية وتسجيل الدخول الموحد والأذونات وإدارة المستخدمين.",
    "workspace.plans.products.email.title": "البريد الإلكتروني",
    "workspace.plans.products.email.description": "بريد إلكتروني مدمج للمعاملات والتسويق.",
    "Transactional and marketing email, built in.": "بريد إلكتروني مدمج للمعاملات والتسويق.",
    "workspace.plans.products.analytics.title": "التحليلات",
    "Analytics": "التحليلات",
    "workspace.plans.products.analytics.description": "تحليلات مجانية للويب والتطبيقات والوكلاء.",
    "Free analytics for web, app, and agents.": "تحليلات مجانية للويب والتطبيقات والوكلاء.",
    "workspace.plans.products.crm.title": "إدارة علاقات العملاء",
    "CRM": "إدارة علاقات العملاء",
    "workspace.plans.products.crm.description": "نظام لإدارة علاقات العملاء يُحدّث بياناته تلقائيًا من نشاط المستخدمين.",
    "A CRM that fills itself from user activity.": "نظام لإدارة علاقات العملاء يُحدّث بياناته تلقائيًا من نشاط المستخدمين.",
    "workspace.plans.products.subscription.title": "الاشتراكات",
    "Subscriptions": "الاشتراكات",
    "workspace.plans.products.subscription.description": "فوترة متكررة وفترات تجريبية وإدارة حالات تعذّر الدفع.",
    "Recurring billing, trials, and dunning — handled.": "فوترة متكررة وفترات تجريبية وإدارة حالات تعذّر الدفع.",
    "workspace.plans.products.recommendation.title": "التوصيات",
    "Recommendations": "التوصيات",
    "workspace.plans.products.recommendation.description": "اعرض لكل مستخدم ما قد يرغب فيه فعلًا.",
    "Show each user what they will actually want.": "اعرض لكل مستخدم ما قد يرغب فيه فعلًا.",
    "workspace.plans.marketplace.2025-superstarter.title": "أساسي",
    "Basic": "أساسي",
    "workspace.plans.marketplace.2025-superstarter.description": "مثالي لفريق صغير. يشمل جميع ميزات المجتمع، إضافة إلى إزالة علامة «مدعوم من Tradly».",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "مثالي لفريق صغير. يشمل جميع ميزات المجتمع، إضافة إلى إزالة علامة «مدعوم من Tradly».",
    "workspace.plans.marketplace.2025-superstarter.button": "ابدأ تجربة لمدة 7 أيام",
    "Start 7 Days Trial": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "بلا رسوم على المعاملات",
    "No transaction fee": "بلا رسوم على المعاملات",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "موقع مجاني مستضاف لدى Tradly",
    "Free Tradly hosted website": "موقع مجاني مستضاف لدى Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "إضافة نطاقك المخصص",
    "Add your custom domain": "إضافة نطاقك المخصص",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "المحرر - سجل صفحات لمدة 3 أيام",
    "Editor - 3 Day page history": "المحرر - سجل صفحات لمدة 3 أيام",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "للشركات الناشئة التي تتحقق من جدوى فكرتها. يشمل الأساسيات لاختبار السوق واكتساب العملاء الأوائل.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "للشركات الناشئة التي تتحقق من جدوى فكرتها. يشمل الأساسيات لاختبار السوق واكتساب العملاء الأوائل.",
    "workspace.plans.marketplace.2025-starter.button": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "بلا رسوم على المعاملات",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "سمات مخصصة بلا حدود",
    "Unlimited Custom Attributes": "سمات مخصصة بلا حدود",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "سجل صفحات لمدة 30 يومًا",
    "30 Day page history": "سجل صفحات لمدة 30 يومًا",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "اشتراك إلزامي",
    "Gated Subscription": "اشتراك إلزامي",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "تسجيل الدخول عبر الشبكات الاجتماعية",
    "Social Logins": "تسجيل الدخول عبر الشبكات الاجتماعية",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "خطافات الويب",
    "Webhooks": "خطافات الويب",
    "workspace.plans.marketplace.2025-growth.title": "النمو",
    "Growth": "النمو",
    "workspace.plans.marketplace.2025-growth.description": "للأفكار التي أثبتت نجاحها وتدخل مرحلة النمو، مع احتياجات مخصصة وتكاملات إضافية للتوسع.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "للأفكار التي أثبتت نجاحها وتدخل مرحلة النمو، مع احتياجات مخصصة وتكاملات إضافية للتوسع.",
    "workspace.plans.marketplace.2025-growth.button": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "بلا رسوم على المعاملات",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "عنوان بريد إلكتروني مخصص للمرسل",
    "Custom 'From Email'": "عنوان بريد إلكتروني مخصص للمرسل",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "أدوات صغيرة وتكاملات إضافية",
    "Additional Mini Tools & Integrations": "أدوات صغيرة وتكاملات إضافية",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "مكالمات إعداد شخصية*",
    "Personalised Onboarding calls*": "مكالمات إعداد شخصية*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "سجل صفحات لمدة 90 يومًا",
    "90 Day page history": "سجل صفحات لمدة 90 يومًا",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "عملات ولغات متعددة",
    "Multi Currencies & Multi Languages": "عملات ولغات متعددة",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "التحكم بالوصول حسب الدور (RBAC)",
    "Role-based access control (RBAC)": "التحكم بالوصول حسب الدور (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "دردشة مدمجة للتطبيقات",
    "Inbuilt Chat for Apps": "دردشة مدمجة للتطبيقات",
    "workspace.plans.marketplace.2025-scale.title": "التوسع",
    "Scale": "التوسع",
    "workspace.plans.marketplace.2025-scale.description": "للشركات في مرحلة النمو التي تبحث عن حلول مصممة حسب احتياجاتها ومتطلبات مخصصة أخرى.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "للشركات في مرحلة النمو التي تبحث عن حلول مصممة حسب احتياجاتها ومتطلبات مخصصة أخرى.",
    "workspace.plans.marketplace.2025-scale.button": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "بلا رسوم على المعاملات",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "دعم ذو أولوية",
    "Priority Support": "دعم ذو أولوية",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "قنوات متعددة (دعم التطبيقات)",
    "Multiple Channels (App Support)": "قنوات متعددة (دعم التطبيقات)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "تسجيل دخول موحد (SSO)",
    "Single Sign-on (SSO)": "تسجيل دخول موحد (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "سجل صفحات بلا حدود",
    "Unlimited page history": "سجل صفحات بلا حدود",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "دردشة مدمجة للتطبيقات",
    "In-built Chat for Apps": "دردشة مدمجة للتطبيقات",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "كل ما يحتاجه المتجر النامي: أزل العلامة التجارية وأضف نطاقك وافتح أدوات إضافية.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "كل ما يحتاجه المتجر النامي: أزل العلامة التجارية وأضف نطاقك وافتح أدوات إضافية.",
    "workspace.plans.indie.go.button": "ابدأ تجربة لمدة 7 أيام",
    "Start 7-day trial": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.indie.go.feature_1.title": "بلا علامة Tradly التجارية",
    "No Tradly branding": "بلا علامة Tradly التجارية",
    "workspace.plans.indie.go.feature_2.title": "نطاق مخصص",
    "Custom domain": "نطاق مخصص",
    "workspace.plans.indie.go.feature_3.title": "منتجات بلا حدود",
    "Unlimited products": "منتجات بلا حدود",
    "workspace.plans.indie.go.feature_4.title": "حملات بريد إلكتروني",
    "Email campaigns": "حملات بريد إلكتروني",
    "workspace.plans.indie.go.feature_5.title": "توصيات بالذكاء الاصطناعي",
    "AI Recommendations": "توصيات بالذكاء الاصطناعي",
    "workspace.plans.indie.go.feature_6.title": "دعم عبر التذاكر",
    "Ticket-based support": "دعم عبر التذاكر",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "مجموعة متكاملة من الذكاء الاصطناعي والتسويق المتقدم وكل الميزات لمتاجر تسعى بجدية إلى النمو.",
    "workspace.plans.indie.genius.button": "ابدأ تجربة لمدة 7 أيام",
    "workspace.plans.indie.genius.feature_1.title": "كل ما تتضمنه Pro",
    "Everything in Pro": "كل ما تتضمنه Pro",
    "workspace.plans.indie.genius.feature_2.title": "وكلاء الذكاء الاصطناعي (مساعد التسوق وغيره)",
    "AI Agents (Shopping Assistant, etc.)": "وكلاء الذكاء الاصطناعي (مساعد التسوق وغيره)",
    "workspace.plans.indie.genius.feature_3.title": "البحث باللغة الطبيعية",
    "Natural language search": "البحث باللغة الطبيعية",
    "workspace.plans.indie.genius.feature_4.title": "أتمتة متقدمة للبريد الإلكتروني",
    "Advanced email automation": "أتمتة متقدمة للبريد الإلكتروني",
    "workspace.plans.indie.genius.feature_5.title": "طلبات توصية بلا حدود",
    "Unlimited recommendation requests": "طلبات توصية بلا حدود",
    "workspace.plans.indie.genius.feature_6.title": "دعم عبر التذاكر",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "رسوم اشتراك تتيح للمستخدمين فتح حسابات وإرسال إعلانات.",
    "Subscription charges for people to open accounts & submit listings": "رسوم اشتراك تتيح للمستخدمين فتح حسابات وإرسال إعلانات.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "التسجيل وتسجيل الدخول عبر Google وMeta.",
    "Signup/in via Google, Meta": "التسجيل وتسجيل الدخول عبر Google وMeta.",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "للاتصال بخدمتي Zapier وMake.",
    "To connect with Zapier & Make": "للاتصال بخدمتي Zapier وMake.",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "مراسلة أصلية داخل التطبيق للمستخدمين.",
    "Native in-app messaging for your users": "مراسلة أصلية داخل التطبيق للمستخدمين.",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "وقت استجابة 24 ساعة للطلبات غير الحرجة.",
    "24 hour response time for non-critical": "وقت استجابة 24 ساعة للطلبات غير الحرجة.",
    "common.continue": "متابعة",
    "Continue": "متابعة",
    "workspace.plans.free_plan": "مجاني",
    "Free": "مجاني",
    "workspace.usage.group_platform": "المنصة ومساحة العمل",
    "Platform & workspace": "المنصة ومساحة العمل",
    "workspace.usage.group_ai": "الذكاء الاصطناعي والاستخدام",
    "AI & usage": "الذكاء الاصطناعي والاستخدام",
    "workspace.usage.group_storage": "المحتوى والتخزين",
    "Content & storage": "المحتوى والتخزين",
    "workspace.usage.group_alacarte": "حسب الطلب",
    "workspace.usage.accounts": "الحسابات",
    "workspace.usage.listings": "الإعلانات",
    "workspace.usage.sites": "المواقع ضمن مساحة العمل",
    "Sites under workspace": "المواقع ضمن مساحة العمل",
    "workspace.usage.external_users": "المستخدمون الخارجيون",
    "External users": "المستخدمون الخارجيون",
    "workspace.usage.internal_users": "المستخدمون الداخليون",
    "Internal users": "المستخدمون الداخليون",
    "workspace.usage.ai_credits": "أرصدة الذكاء الاصطناعي",
    "AI credits": "أرصدة الذكاء الاصطناعي",
    "workspace.usage.storage": "التخزين",
    "Storage": "التخزين",
    "workspace.usage.email": "البريد الإلكتروني",
    "workspace.usage.maps": "الخرائط",
    "workspace.usage.sms": "الرسائل القصيرة",
    "SMS": "الرسائل القصيرة",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "التحليلات",
    "workspace.usage.recommendations": "التوصيات",
    "workspace.usage.ai_agents": "وكلاء الذكاء الاصطناعي",
    "AI agents": "وكلاء الذكاء الاصطناعي",
    "workspace.usage.status_not_reported": "غير مُبلّغ عنه",
    "Not reported": "غير مُبلّغ عنه",
    "workspace.usage.status_nearly_full": "يقترب من الحد",
    "Nearly full": "يقترب من الحد",
    "workspace.usage.status_on_track": "ضمن النطاق",
    "On track": "ضمن النطاق",
    "workspace.usage.workspace_files": "ملفات مساحة العمل",
    "Workspace files": "ملفات مساحة العمل",
    "workspace.usage.workspace_usage": "استخدام مساحة العمل",
    "Workspace usage": "استخدام مساحة العمل",
    "workspace.usage.of_limit": "من {limit}",
    "of {limit}": "من {limit}",
    "workspace.usage.no_cap": "لم يتم إعداد حد أقصى",
    "No cap configured": "لم يتم إعداد حد أقصى",
    "workspace.usage.trend": "اتجاه الاستخدام",
    "Usage trend": "اتجاه الاستخدام",
    "workspace.usage.unavailable": "بيانات الاستخدام غير متاحة مؤقتًا.",
    "Usage data is temporarily unavailable.": "بيانات الاستخدام غير متاحة مؤقتًا.",
    "workspace.usage.loading": "جارٍ تحميل استخدام مساحة العمل…",
    "Loading workspace usage…": "جارٍ تحميل استخدام مساحة العمل…",
    "workspace.usage.overview": "نظرة عامة على مساحة العمل",
    "Workspace overview": "نظرة عامة على مساحة العمل",
    "workspace.usage.title": "تفصيل الاستخدام",
    "Usage breakdown": "تفصيل الاستخدام",
    "workspace.usage.description": "اطّلع على استخدام مساحة العمل لديك والمساحة المتبقية ضمن خطتك الحالية.",
    "See what your workspace has used and how much room remains on your current plan.": "اطّلع على استخدام مساحة العمل لديك والمساحة المتبقية ضمن خطتك الحالية.",
    "workspace.usage.view_plans": "عرض الخطط",
    "workspace.usage.showing_available_limits": "تُعرض الحدود المتاحة بالفعل لمساحة العمل هذه.",
    "Showing the limits that are already available in this workspace.": "تُعرض الحدود المتاحة بالفعل لمساحة العمل هذه.",
    "workspace.usage.summary": "ملخص الاستخدام",
    "Usage summary": "ملخص الاستخدام",
    "workspace.usage.metrics_tracked": "المقاييس المتتبعة",
    "Metrics tracked": "المقاييس المتتبعة",
    "workspace.usage.metrics_count": "{count} من {total}",
    "{count} of {total}": "{count} من {total}",
    "workspace.usage.next_reset": "إعادة التعيين التالية",
    "Next reset": "إعادة التعيين التالية",
    "workspace.usage.not_provided": "غير متوفر",
    "Not provided": "غير متوفر",
    "workspace.usage.data_source": "مصدر البيانات",
    "Data source": "مصدر البيانات",
    "workspace.usage.clear_view": "عرض واضح لمساحة عملك",
    "A clear view of your workspace": "عرض واضح لمساحة عملك",
    "workspace.usage.by_resource": "الاستخدام حسب المورد",
    "Usage by resource": "الاستخدام حسب المورد",
    "workspace.usage.live_summary": "ملخص مباشر",
    "Live summary": "ملخص مباشر",
    "workspace.usage.resource": "المورد",
    "Resource": "المورد",
    "workspace.usage.used_limit": "المستخدم / الحد",
    "Used / limit": "المستخدم / الحد",
    "workspace.usage.progress": "التقدم",
    "Progress": "التقدم",
    "workspace.usage.cost": "التكلفة",
    "Cost": "التكلفة",
    "workspace.usage.footnote": "تأتي بيانات الاستخدام والحدود من خدمة استخدام مساحة العمل. تشير الشرطة إلى أن واجهة API الحالية لا تعرض هذا المقياس بعد.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "تأتي بيانات الاستخدام والحدود من خدمة استخدام مساحة العمل. تشير الشرطة إلى أن واجهة API الحالية لا تعرض هذا المقياس بعد.",
    "workspace.usage.refresh": "تحديث",
    "Refresh": "تحديث",
    "maps.title": "الخرائط",
    "maps.tab.analysis": "مسح السوق",
    "Market scan": "مسح السوق",
    "maps.tab.usage": "الاستخدام",
    "maps.tab.settings": "الإعدادات",
    "maps.action.save": "حفظ",
    "maps.action.saving": "جارٍ الحفظ…",
    "maps.action.analyze_area": "تحليل المنطقة",
    "Analyze area": "تحليل المنطقة",
    "maps.action.analyzing": "جارٍ التحليل…",
    "Analyzing…": "جارٍ التحليل…",
    "maps.action.refresh": "تحديث",
    "maps.action.loading": "جارٍ التحميل…",
    "Loading…": "جارٍ التحميل…",
    "maps.action.open_in_maps": "فتح في الخرائط",
    "Open in Maps": "فتح في الخرائط",
    "maps.analysis.title": "استكشف السوق المحلي",
    "Explore a local market": "استكشف السوق المحلي",
    "maps.analysis.description": "تعرّف على الأنشطة التجارية التي تعرضها Google حول موقع مقترح. هذا مسح أولي للمنافسة، وليس توقعًا للطلب أو الجدوى.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "تعرّف على الأنشطة التجارية التي تعرضها Google حول موقع مقترح. هذا مسح أولي للمنافسة، وليس توقعًا للطلب أو الجدوى.",
    "maps.analysis.address_label": "العنوان أو المنطقة",
    "Address or locality": "العنوان أو المنطقة",
    "maps.analysis.address_placeholder": "الشارع أو الحي أو المدينة",
    "Street, suburb, or city": "الشارع أو الحي أو المدينة",
    "maps.analysis.category_label": "نوع النشاط التجاري",
    "Business type": "نوع النشاط التجاري",
    "maps.analysis.radius_label": "نطاق البحث",
    "Search radius": "نطاق البحث",
    "maps.analysis.places_listings": "قوائم الأماكن",
    "Places listings": "قوائم الأماكن",
    "maps.analysis.within_radius": "{category} ضمن نطاق {radius}",
    "{category} within {radius}": "{category} ضمن نطاق {radius}",
    "maps.analysis.results_description": "تُصفّى النتائج حسب الفئة ونطاق البحث، ثم تُرتّب حسب المسافة.",
    "Results are filtered by category and radius, then ordered by distance.": "تُصفّى النتائج حسب الفئة ونطاق البحث، ثم تُرتّب حسب المسافة.",
    "maps.analysis.result_limit_notice": "أعادت Google الحد الأقصى البالغ 20 مكانًا. قد يكون العدد الفعلي أكبر؛ جرّب نطاقًا أصغر للحصول على مسح أكثر تفصيلًا.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "أعادت Google الحد الأقصى البالغ 20 مكانًا. قد يكون العدد الفعلي أكبر؛ جرّب نطاقًا أصغر للحصول على مسح أكثر تفصيلًا.",
    "maps.analysis.limitations": "قد تكون القوائم غير مكتملة، ولا تقيس طلب العملاء أو حركة الزوار أو عدد السكان أو الإيجار أو الربحية. استخدمها كأحد مصادر البحث المحلي.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "قد تكون القوائم غير مكتملة، ولا تقيس طلب العملاء أو حركة الزوار أو عدد السكان أو الإيجار أو الربحية. استخدمها كأحد مصادر البحث المحلي.",
    "maps.analysis.nearby_businesses": "الأنشطة التجارية القريبة ({count})",
    "Nearby businesses ({count})": "الأنشطة التجارية القريبة ({count})",
    "maps.analysis.businesses": "الأنشطة التجارية",
    "Businesses": "الأنشطة التجارية",
    "maps.analysis.no_listings": "لم تُعِد خرائط Google قوائم مطابقة لهذه المنطقة والفئة.",
    "No matching Google Maps listings were returned for this area and category.": "لم تُعِد خرائط Google قوائم مطابقة لهذه المنطقة والفئة.",
    "maps.category.retail": "البيع بالتجزئة",
    "Retail": "البيع بالتجزئة",
    "maps.category.grocery": "بقالة",
    "Grocery": "بقالة",
    "maps.category.clothing": "ملابس",
    "Clothing": "ملابس",
    "maps.category.pharmacy": "صيدلية",
    "Pharmacy": "صيدلية",
    "maps.category.restaurant": "مطعم / مقهى",
    "Restaurant / café": "مطعم / مقهى",
    "maps.competition.limited": "منافسة محدودة حسب القوائم",
    "Limited listed competition": "منافسة محدودة حسب القوائم",
    "maps.competition.some": "بعض المنافسين حسب القوائم",
    "Some listed competition": "بعض المنافسين حسب القوائم",
    "maps.competition.many": "عدد كبير من المنافسين حسب القوائم",
    "Many listed competitors": "عدد كبير من المنافسين حسب القوائم",
    "maps.competition.limit_reached": "20 قائمة على الأقل (تم بلوغ حد النتائج)",
    "At least 20 listings (result limit reached)": "20 قائمة على الأقل (تم بلوغ حد النتائج)",
    "maps.competition.default": "المنافسة حسب القوائم",
    "Listed competition": "المنافسة حسب القوائم",
    "maps.distance_km": "{value} كم",
    "{value} km": "{value} كم",
    "maps.distance_m": "{value} م",
    "{value} m": "{value} م",
    "maps.business_status.operational": "يعمل",
    "Operational": "يعمل",
    "maps.usage.title": "استخدام المزوّد",
    "Provider usage": "استخدام المزوّد",
    "maps.usage.description": "عدد الطلبات المسجلة بواسطة خدمة الخرائط. تتم تسوية الرسوم بشكل منفصل.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "عدد الطلبات المسجلة بواسطة خدمة الخرائط. تتم تسوية الرسوم بشكل منفصل.",
    "maps.usage.days": "{count} يومًا",
    "{count} days": "{count} يومًا",
    "maps.usage.provider_requests": "طلبات المزوّد",
    "Provider requests": "طلبات المزوّد",
    "maps.usage.range_detail": "فترة من {count} يومًا",
    "{count} day window": "فترة من {count} يومًا",
    "maps.usage.successful": "ناجحة",
    "Successful": "ناجحة",
    "maps.usage.completed_calls": "استدعاءات المزوّد المكتملة",
    "Completed provider calls": "استدعاءات المزوّد المكتملة",
    "maps.usage.errors": "الأخطاء",
    "Errors": "الأخطاء",
    "maps.usage.failed_calls": "استدعاءات المزوّد الفاشلة",
    "Failed provider calls": "استدعاءات المزوّد الفاشلة",
    "maps.usage.metered_units": "الوحدات المحتسبة",
    "Metered units": "الوحدات المحتسبة",
    "maps.usage.unit_detail": "وحدة واحدة لكل طلب مسجل",
    "One unit per recorded request": "وحدة واحدة لكل طلب مسجل",
    "maps.usage.by_operation": "الاستخدام حسب العملية",
    "Usage by operation": "الاستخدام حسب العملية",
    "maps.usage.group_description": "تُجمّع الأعداد حسب المزوّد والعملية والنتيجة.",
    "Counts are grouped by provider, operation, and outcome.": "تُجمّع الأعداد حسب المزوّد والعملية والنتيجة.",
    "maps.usage.empty": "لا توجد طلبات خرائط ضمن هذه الفترة.",
    "No map requests in this date range.": "لا توجد طلبات خرائط ضمن هذه الفترة.",
    "maps.usage.provider": "المزوّد",
    "Provider": "المزوّد",
    "maps.usage.operation": "العملية",
    "Operation": "العملية",
    "maps.usage.outcome": "النتيجة",
    "Outcome": "النتيجة",
    "maps.usage.requests": "الطلبات",
    "Requests": "الطلبات",
    "maps.usage.units": "الوحدات",
    "Units": "الوحدات",
    "maps.settings.provider_title": "مزوّد الخرائط",
    "Map provider": "مزوّد الخرائط",
    "maps.settings.provider_description": "اختر المزوّد المسموح به وفق سياسة خصوصية البيانات لديك. يدير Tradly بيانات اعتماد المزوّد.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "اختر المزوّد المسموح به وفق سياسة خصوصية البيانات لديك. يدير Tradly بيانات اعتماد المزوّد.",
    "maps.settings.selected": "محدد",
    "maps.settings.available": "متاح",
    "maps.settings.planned": "مخطط له",
    "Planned": "مخطط له",
    "maps.settings.origins_title": "أصول المواقع المسموح بها",
    "Allowed website origins": "أصول المواقع المسموح بها",
    "maps.settings.origins_description": "يُسمح تلقائيًا بنطاقات المستأجر المسجلة. أضف هنا الأصول الدقيقة لمواقع أخرى، مثل بيئة التجربة.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "يُسمح تلقائيًا بنطاقات المستأجر المسجلة. أضف هنا الأصول الدقيقة لمواقع أخرى، مثل بيئة التجربة.",
    "maps.settings.registered_domains": "النطاقات المسجلة",
    "Registered domains": "النطاقات المسجلة",
    "maps.settings.no_domains": "لم يتم تحميل أي نطاقات مسجلة.",
    "No registered domains were loaded.": "لم يتم تحميل أي نطاقات مسجلة.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "إضافة أصل",
    "Add origin": "إضافة أصل",
    "maps.settings.remove_origin": "إزالة",
    "maps.settings.no_origins": "لم تتم إضافة أصول إضافية.",
    "No extra origins added.": "لم تتم إضافة أصول إضافية.",
    "maps.error.session_not_ready": "جلسة المشرف غير جاهزة بعد.",
    "Your admin session is not ready yet.": "جلسة المشرف غير جاهزة بعد.",
    "maps.error.load_data": "تعذّر تحميل بيانات الخرائط ({status}).",
    "Unable to load Maps data ({status}).": "تعذّر تحميل بيانات الخرائط ({status}).",
    "maps.error.load_usage": "تعذّر تحميل استخدام الخرائط.",
    "Unable to load Maps usage.": "تعذّر تحميل استخدام الخرائط.",
    "maps.error.load_settings": "تعذّر تحميل إعدادات الخرائط.",
    "Unable to load Maps settings.": "تعذّر تحميل إعدادات الخرائط.",
    "maps.error.save_settings": "تعذّر حفظ إعدادات الخرائط.",
    "Unable to save Maps settings.": "تعذّر حفظ إعدادات الخرائط.",
    "maps.error.invalid_origin": "أدخل أصلًا كاملًا، مثل https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "أدخل أصلًا كاملًا، مثل https://staging.example.com.",
    "maps.error.registered_origin": "هذا الأصل مشمول بالفعل بنطاق مسجل.",
    "This origin is already covered by a registered domain.": "هذا الأصل مشمول بالفعل بنطاق مسجل.",
    "maps.error.address_required": "أدخل عنوانًا أو منطقة لمسحها.",
    "Enter an address or locality to scan.": "أدخل عنوانًا أو منطقة لمسحها.",
    "maps.error.location_not_found": "تعذّر العثور على هذا الموقع.",
    "Unable to find that location.": "تعذّر العثور على هذا الموقع.",
    "maps.error.no_coordinates": "لم يتم العثور على إحداثيات لهذا العنوان. جرّب شارعًا أو حيًا أو مدينة قريبة.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "لم يتم العثور على إحداثيات لهذا العنوان. جرّب شارعًا أو حيًا أو مدينة قريبة.",
    "maps.error.analyze_area": "تعذّر تحليل هذه المنطقة.",
    "Unable to analyze this area.": "تعذّر تحليل هذه المنطقة.",
    "maps.notice.settings_saved": "تم حفظ إعدادات الخرائط.",
    "Maps settings saved.": "تم حفظ إعدادات الخرائط.",
    "maps.status.success": "نجاح",
    "maps.status.error": "خطأ",
    "maps.operation.geocode": "الترميز الجغرافي",
    "Geocode": "الترميز الجغرافي",
    "maps.operation.maps_geocode": "الترميز الجغرافي للخرائط",
    "Maps geocode": "الترميز الجغرافي للخرائط",
    "maps.operation.market_analysis": "تحليل السوق",
    "Market analysis": "تحليل السوق",
    "maps.operation.maps_market_analysis": "تحليل سوق الخرائط",
    "Maps market analysis": "تحليل سوق الخرائط",
    "maps.operation.places_search": "البحث عن الأماكن",
    "Places search": "البحث عن الأماكن",
    "maps.operation.places_nearby": "الأماكن القريبة",
    "Nearby places": "الأماكن القريبة",
    "maps.operation.place_details": "تفاصيل المكان",
    "Place details": "تفاصيل المكان",
    "common.loading": "جارٍ التحميل…",
    "common.saving": "جارٍ الحفظ…",
    "common.searching": "جارٍ البحث…",
    "Searching…": "جارٍ البحث…",
    "common.no_matches": "لم يتم العثور على نتائج مطابقة.",
    "No matches found.": "لم يتم العثور على نتائج مطابقة.",
    "common.select": "اختر…",
    "Select…": "اختر…",
    "common.search_users": "ابحث عن المستخدمين بالاسم أو البريد الإلكتروني",
    "Search users by name or email": "ابحث عن المستخدمين بالاسم أو البريد الإلكتروني",
    "common.reset": "إعادة تعيين",
    "Reset": "إعادة تعيين",
    "common.validation.email": "أدخل عنوان بريد إلكتروني صالحًا.",
    "Enter a valid email address.": "أدخل عنوان بريد إلكتروني صالحًا.",
    "common.validation.phone": "أدخل رقم هاتف صالحًا.",
    "Enter a valid phone number.": "أدخل رقم هاتف صالحًا.",
    "common.validation.currency": "استخدم رمز عملة من 3 أحرف، مثل USD.",
    "Use a 3-letter currency code, such as USD.": "استخدم رمز عملة من 3 أحرف، مثل USD.",
    "common.validation.location": "أدخل عنوانًا أو موقعًا صالحًا.",
    "Enter a valid address or location.": "أدخل عنوانًا أو موقعًا صالحًا.",
    "common.validation.required": "حقل {label} مطلوب.",
    "{label} is required.": "حقل {label} مطلوب.",
    "common.validation.invalid": "حقل {label} غير صالح.",
    "{label} is invalid.": "حقل {label} غير صالح.",
    "common.status.active": "نشط",
    "common.status.inactive": "غير نشط",
    "common.status.open": "مفتوح",
    "common.status.closed": "مغلق",
    "common.status.posted": "مرحّل",
    "Posted": "مرحّل",
    "common.status.voided": "ملغى",
    "Voided": "ملغى",
    "common.status.draft": "مسودة",
    "Draft": "مسودة",
    "common.status.success": "نجاح",
    "common.status.error": "خطأ",
    "accounting.title": "المحاسبة",
    "accounting.description": "أدِر الحسابات وعمليات الربط والفترات وقيود اليومية والتقارير المالية.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "أدِر الحسابات وعمليات الربط والفترات وقيود اليومية والتقارير المالية.",
    "accounting.tab.overview": "نظرة عامة",
    "Overview": "نظرة عامة",
    "accounting.tab.accounts": "دليل الحسابات",
    "Chart of accounts": "دليل الحسابات",
    "accounting.tab.mappings": "ربط الحسابات",
    "Account mappings": "ربط الحسابات",
    "accounting.tab.periods": "الفترات المحاسبية",
    "Accounting periods": "الفترات المحاسبية",
    "accounting.tab.journals": "قيود اليومية",
    "Journals": "قيود اليومية",
    "accounting.tab.reports": "التقارير",
    "accounting.account.edit_title": "تعديل الحساب",
    "Edit account": "تعديل الحساب",
    "accounting.account.new_title": "حساب جديد",
    "New account": "حساب جديد",
    "accounting.account.save": "حفظ الحساب",
    "Save account": "حفظ الحساب",
    "accounting.account.create": "إنشاء حساب",
    "Create account": "إنشاء حساب",
    "accounting.account.code": "رمز الحساب",
    "Account code": "رمز الحساب",
    "accounting.account.name": "اسم الحساب",
    "Account name": "اسم الحساب",
    "accounting.account.type": "نوع الحساب",
    "Account type": "نوع الحساب",
    "accounting.account.currency_id": "معرّف العملة",
    "Currency ID": "معرّف العملة",
    "accounting.account.active": "نشط",
    "accounting.account.unnamed": "حساب بلا اسم",
    "Unnamed account": "حساب بلا اسم",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "مصروف الرواتب",
    "Payroll expense": "مصروف الرواتب",
    "accounting.type.asset": "أصل",
    "Asset": "أصل",
    "accounting.type.liability": "التزام",
    "Liability": "التزام",
    "accounting.type.equity": "حقوق الملكية",
    "Equity": "حقوق الملكية",
    "accounting.type.revenue": "إيراد",
    "accounting.type.expense": "مصروف",
    "Expense": "مصروف",
    "accounting.toast.account_updated": "تم تحديث الحساب",
    "Account updated": "تم تحديث الحساب",
    "accounting.toast.account_created": "تم إنشاء الحساب",
    "Account created": "تم إنشاء الحساب",
    "accounting.toast.defaults_created": "تم إنشاء الحسابات الافتراضية",
    "Default accounts created": "تم إنشاء الحسابات الافتراضية",
    "accounting.toast.mapping_saved": "تم حفظ الربط",
    "Mapping saved": "تم حفظ الربط",
    "accounting.toast.period_closed": "تم إغلاق الفترة المحاسبية",
    "Accounting period closed": "تم إغلاق الفترة المحاسبية",
    "accounting.toast.period_created": "تم إنشاء الفترة",
    "Period created": "تم إنشاء الفترة",
    "accounting.toast.journal_created": "تم إنشاء قيد اليومية",
    "Journal created": "تم إنشاء قيد اليومية",
    "accounting.toast.journal_voided": "تم إلغاء قيد اليومية",
    "Journal voided": "تم إلغاء قيد اليومية",
    "accounting.validation.journal_balanced": "يجب أن يتضمن قيد اليومية تاريخًا ووصفًا وأن يتوازن إجمالي المدين والدائن.",
    "Journal must have a date, description, and balanced debit and credit totals.": "يجب أن يتضمن قيد اليومية تاريخًا ووصفًا وأن يتوازن إجمالي المدين والدائن.",
    "accounting.filter.all_types": "كل أنواع الحسابات",
    "All account types": "كل أنواع الحسابات",
    "accounting.filter.all_statuses": "كل الحالات",
    "All statuses": "كل الحالات",
    "accounting.action.bootstrap": "إعداد الحسابات الافتراضية",
    "Bootstrap defaults": "إعداد الحسابات الافتراضية",
    "accounting.action.new_account": "حساب جديد",
    "accounting.empty.accounts": "لم يتم العثور على حسابات.",
    "No accounts found.": "لم يتم العثور على حسابات.",
    "accounting.column.code": "الرمز",
    "accounting.column.account": "الحساب",
    "accounting.column.type": "النوع",
    "Type": "النوع",
    "accounting.column.currency": "العملة",
    "accounting.column.status": "الحالة",
    "accounting.action.edit": "تعديل",
    "accounting.mapping.edit_title": "تعديل ربط الحسابات",
    "Edit account mapping": "تعديل ربط الحسابات",
    "accounting.mapping.new_title": "ربط حسابات جديد",
    "New account mapping": "ربط حسابات جديد",
    "accounting.mapping.save": "حفظ الربط",
    "Save mapping": "حفظ الربط",
    "accounting.mapping.create": "إنشاء ربط",
    "Create mapping": "إنشاء ربط",
    "accounting.mapping.source_type": "نوع المصدر",
    "Source type": "نوع المصدر",
    "accounting.mapping.event_key": "مفتاح الحدث",
    "Event key": "مفتاح الحدث",
    "accounting.mapping.debit_account": "حساب المدين",
    "Debit account": "حساب المدين",
    "accounting.mapping.credit_account": "حساب الدائن",
    "Credit account": "حساب الدائن",
    "accounting.mapping.tax_account": "حساب الضريبة",
    "Tax account": "حساب الضريبة",
    "accounting.mapping.none": "لا يوجد",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "تصفية حسب نوع المصدر",
    "Filter source type": "تصفية حسب نوع المصدر",
    "accounting.action.new_mapping": "ربط جديد",
    "New mapping": "ربط جديد",
    "accounting.empty.mappings": "لم يتم العثور على عمليات ربط للحسابات.",
    "No account mappings found.": "لم يتم العثور على عمليات ربط للحسابات.",
    "accounting.column.source": "المصدر",
    "Source": "المصدر",
    "accounting.column.event": "الحدث",
    "accounting.column.debit": "مدين",
    "Debit": "مدين",
    "accounting.column.credit": "دائن",
    "Credit": "دائن",
    "accounting.period.close_confirm": "إغلاق {period}؟ لا يمكن التراجع عن ذلك.",
    "Close {period}? This cannot be reversed.": "إغلاق {period}؟ لا يمكن التراجع عن ذلك.",
    "accounting.period.this": "هذه الفترة المحاسبية",
    "this accounting period": "هذه الفترة المحاسبية",
    "accounting.period.new_title": "فترة محاسبية جديدة",
    "New accounting period": "فترة محاسبية جديدة",
    "accounting.period.create": "إنشاء فترة",
    "Create period": "إنشاء فترة",
    "accounting.period.name": "اسم الفترة",
    "Period name": "اسم الفترة",
    "accounting.period.start": "تاريخ البدء",
    "accounting.period.end": "تاريخ الانتهاء",
    "End date": "تاريخ الانتهاء",
    "accounting.period.name_placeholder": "يناير 2027",
    "January 2027": "يناير 2027",
    "accounting.period.open": "مفتوحة",
    "accounting.period.closed": "مغلقة",
    "accounting.action.new_period": "فترة جديدة",
    "New period": "فترة جديدة",
    "accounting.empty.periods": "لم يتم العثور على فترات محاسبية.",
    "No accounting periods found.": "لم يتم العثور على فترات محاسبية.",
    "accounting.column.period": "الفترة",
    "accounting.column.start": "البداية",
    "Start": "البداية",
    "accounting.column.end": "النهاية",
    "accounting.action.close_period": "إغلاق الفترة",
    "Close period": "إغلاق الفترة",
    "accounting.journal.new_title": "قيد يومية جديد",
    "New journal": "قيد يومية جديد",
    "accounting.journal.balance_help": "يجب أن يتوازن المدين والدائن قبل الحفظ.",
    "Debits and credits must balance before saving.": "يجب أن يتوازن المدين والدائن قبل الحفظ.",
    "accounting.journal.close": "إغلاق",
    "accounting.journal.entry_date": "تاريخ القيد",
    "Entry date": "تاريخ القيد",
    "accounting.journal.description": "الوصف",
    "accounting.journal.source_type": "نوع المصدر",
    "accounting.journal.source_id": "معرّف المصدر",
    "Source ID": "معرّف المصدر",
    "accounting.journal.account": "الحساب",
    "accounting.journal.select_account": "اختر حسابًا",
    "Select account": "اختر حسابًا",
    "accounting.journal.debit_total": "المدين: {debit} · الدائن: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "المدين: {debit} · الدائن: {credit} · {status}",
    "accounting.journal.balanced": "متوازن",
    "Balanced": "متوازن",
    "accounting.journal.unbalanced": "غير متوازن",
    "Unbalanced": "غير متوازن",
    "accounting.journal.add_line": "إضافة بند",
    "Add line": "إضافة بند",
    "accounting.journal.save": "حفظ قيد اليومية",
    "Save journal": "حفظ قيد اليومية",
    "accounting.journal.empty": "لا توجد بنود في قيد اليومية.",
    "No journal lines.": "لا توجد بنود في قيد اليومية.",
    "accounting.journal.reason_prompt": "سبب إلغاء قيد اليومية:",
    "Reason for voiding this journal:": "سبب إلغاء قيد اليومية:",
    "accounting.journal.details_title": "قيد اليومية رقم {id}",
    "Journal #{id}": "قيد اليومية رقم {id}",
    "accounting.action.view": "عرض",
    "View": "عرض",
    "accounting.action.void": "إلغاء",
    "Void": "إلغاء",
    "accounting.filter.all_accounts": "كل الحسابات",
    "All accounts": "كل الحسابات",
    "accounting.empty.journals": "لم يتم العثور على قيود يومية.",
    "No journals found.": "لم يتم العثور على قيود يومية.",
    "accounting.column.date": "التاريخ",
    "accounting.column.description": "الوصف",
    "accounting.column.account_source": "المصدر",
    "accounting.empty.journal_lines": "لا توجد بنود في قيد اليومية.",
    "accounting.report.trial_balance": "ميزان المراجعة",
    "Trial balance": "ميزان المراجعة",
    "accounting.report.general_ledger": "دفتر الأستاذ العام",
    "General ledger": "دفتر الأستاذ العام",
    "accounting.action.run_report": "تشغيل التقرير",
    "Run report": "تشغيل التقرير",
    "accounting.report.loading": "جارٍ تحميل التقرير…",
    "Loading report…": "جارٍ تحميل التقرير…",
    "accounting.empty.report": "لم يتم العثور على صفوف في التقرير.",
    "No report rows found.": "لم يتم العثور على صفوف في التقرير.",
    "accounting.report.choose_run": "اختر تقريرًا ثم شغّله.",
    "Choose a report and run it.": "اختر تقريرًا ثم شغّله.",
    "accounting.column.balance": "الرصيد",
    "Balance": "الرصيد",
    "accounting.overview.chart_title": "دليل الحسابات",
    "accounting.overview.chart_description": "حدّد الحسابات المستخدمة في دفتر الأستاذ.",
    "Define the accounts used by your ledger.": "حدّد الحسابات المستخدمة في دفتر الأستاذ.",
    "accounting.overview.journals_title": "قيود اليومية",
    "accounting.overview.journals_description": "أنشئ قيود يومية متوازنة وراجعها.",
    "Create and review balanced journal entries.": "أنشئ قيود يومية متوازنة وراجعها.",
    "accounting.overview.reports_title": "التقارير",
    "accounting.overview.reports_description": "شغّل تقارير ميزان المراجعة ودفتر الأستاذ العام.",
    "Run trial balance and general ledger reports.": "شغّل تقارير ميزان المراجعة ودفتر الأستاذ العام.",
    "common.refresh": "تحديث",
    "reports.search.title": "تحليلات البحث",
    "Search analytics": "تحليلات البحث",
    "reports.search.back_to_report": "العودة إلى التقرير",
    "Back to report": "العودة إلى التقرير",
    "reports.search.description": "يوضح الطلب عبر البحث ما يبحث عنه الزوار وأين يحتاج الكتالوج إلى تغطية أكبر.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "يوضح الطلب عبر البحث ما يبحث عنه الزوار وأين يحتاج الكتالوج إلى تغطية أكبر.",
    "reports.search.metric.searches": "عمليات البحث",
    "Searches": "عمليات البحث",
    "reports.search.metric.unique_keywords": "الكلمات المفتاحية الفريدة",
    "Unique keywords": "الكلمات المفتاحية الفريدة",
    "reports.search.metric.with_listings": "تتضمن إعلانات",
    "With listings": "تتضمن إعلانات",
    "reports.search.metric.no_matches": "بلا إعلانات مطابقة",
    "No listing matches": "بلا إعلانات مطابقة",
    "reports.search.metric.coverage": "التغطية",
    "Coverage": "التغطية",
    "reports.search.insights.title": "رؤى المشرف",
    "Admin insights": "رؤى المشرف",
    "reports.search.insights.no_results_one": "لم تُظهر الكلمة المفتاحية ({count}) أي إعلانات. فكّر في إنشاء إعلان، أو إضافة المصطلح كفئة أو وسم، أو تحسين عنوان الإعلان ووصفه.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "لم تُظهر الكلمة المفتاحية ({count}) أي إعلانات. فكّر في إنشاء إعلان، أو إضافة المصطلح كفئة أو وسم، أو تحسين عنوان الإعلان ووصفه.",
    "reports.search.insights.no_results_many": "لم تُظهر الكلمات المفتاحية ({count}) أي إعلانات. فكّر في إنشاء إعلانات، أو إضافة المصطلحات كفئات أو وسوم، أو تحسين عناوين الإعلانات وأوصافها.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "لم تُظهر الكلمات المفتاحية ({count}) أي إعلانات. فكّر في إنشاء إعلانات، أو إضافة المصطلحات كفئات أو وسوم، أو تحسين عناوين الإعلانات وأوصافها.",
    "reports.search.insights.all_covered": "أظهرت كل كلمة مفتاحية متتبعة إعلانًا واحدًا على الأقل. راجع المصطلحات الأكثر تكرارًا لتحسين عرض المنتجات وتصنيف الفئات.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "أظهرت كل كلمة مفتاحية متتبعة إعلانًا واحدًا على الأقل. راجع المصطلحات الأكثر تكرارًا لتحسين عرض المنتجات وتصنيف الفئات.",
    "reports.search.insights.empty": "ستظهر بيانات البحث بعد أن يبحث الزوار في السوق.",
    "Search data will appear after visitors search the marketplace.": "ستظهر بيانات البحث بعد أن يبحث الزوار في السوق.",
    "reports.search.insights.total_matches": "ظهرت {count} مطابقة إجمالًا للإعلانات ضمن سجلات البحث المحمّلة.",
    "{count} total listing matches were returned across the loaded search records.": "ظهرت {count} مطابقة إجمالًا للإعلانات ضمن سجلات البحث المحمّلة.",
    "reports.search.coverage_title": "تغطية الكلمات المفتاحية",
    "Keyword coverage": "تغطية الكلمات المفتاحية",
    "reports.search.loading": "جارٍ تحميل تحليلات البحث…",
    "Loading search analytics…": "جارٍ تحميل تحليلات البحث…",
    "reports.search.empty": "لم يتم العثور على عبارات بحث.",
    "No search phrases found.": "لم يتم العثور على عبارات بحث.",
    "reports.search.error.load": "تعذّر تحميل تحليلات البحث.",
    "Unable to load search analytics.": "تعذّر تحميل تحليلات البحث.",
    "reports.search.unknown": "بحث غير معروف",
    "Unknown search": "بحث غير معروف",
    "reports.search.column.keyword": "الكلمة المفتاحية",
    "Keyword": "الكلمة المفتاحية",
    "reports.search.column.listings": "الإعلانات",
    "reports.search.column.coverage": "التغطية",
    "reports.search.column.last_searched": "آخر بحث",
    "Last searched": "آخر بحث",
    "reports.search.column.suggested_action": "الإجراء المقترح",
    "Suggested action": "الإجراء المقترح",
    "reports.search.status.covered": "مغطاة",
    "Covered": "مغطاة",
    "reports.search.status.no_matches": "لا توجد نتائج",
    "No matches": "لا توجد نتائج",
    "reports.search.action.review_ranking": "مراجعة الترتيب",
    "Review ranking": "مراجعة الترتيب",
    "reports.search.action.add_listing": "إضافة إعلان أو فئة",
    "Add listing or category": "إضافة إعلان أو فئة",
    "platform_health.title": "صحة المنصة",
    "Platform health": "صحة المنصة",
    "platform_health.tab.health": "الصحة",
    "platform_health.tab.configuration": "الإعدادات",
    "platform_health.action.refreshing": "جارٍ التحديث…",
    "Refreshing…": "جارٍ التحديث…",
    "platform_health.window_note": "يعرض العرض الحالي أول {count} سجل لكل نوع من الأحداث.",
    "The current view loads the first {count} records for each event type.": "يعرض العرض الحالي أول {count} سجل لكل نوع من الأحداث.",
    "platform_health.error.title": "تعذر تحميل سجلات تدقيق المصادقة",
    "Unable to load authentication audits": "تعذر تحميل سجلات تدقيق المصادقة",
    "platform_health.error.proxy_note": "قد تتطلب واجهة API تمرير طلب المسؤول هذا عبر الخادم بدلاً من إرساله مباشرةً من المتصفح.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "قد تتطلب واجهة API تمرير طلب المسؤول هذا عبر الخادم بدلاً من إرساله مباشرةً من المتصفح.",
    "platform_health.error.session": "جلسة المسؤول غير جاهزة بعد. يُرجى تسجيل الدخول مرة أخرى.",
    "Your admin session is not ready yet. Please sign in again.": "جلسة المسؤول غير جاهزة بعد. يُرجى تسجيل الدخول مرة أخرى.",
    "platform_health.error.load": "تعذر تحميل سجلات تدقيق المصادقة ({status}).",
    "Unable to load authentication audits ({status}).": "تعذر تحميل سجلات تدقيق المصادقة ({status}).",
    "platform_health.error.load_generic": "تعذر تحميل سجلات تدقيق صحة المنصة.",
    "Unable to load platform health audits.": "تعذر تحميل سجلات تدقيق صحة المنصة.",
    "platform_health.metric.login_attempts": "محاولات تسجيل الدخول",
    "Login attempts": "محاولات تسجيل الدخول",
    "platform_health.metric.signup_attempts": "محاولات إنشاء الحساب",
    "Signup attempts": "محاولات إنشاء الحساب",
    "platform_health.metric.audit_records": "سجلات التدقيق",
    "Audit records": "سجلات التدقيق",
    "platform_health.metric.successful": "ناجحة",
    "platform_health.metric.failed": "فاشلة",
    "platform_health.metric.outcome_returned": "فقط عند إرجاع النتيجة",
    "Only when outcome is returned": "فقط عند إرجاع النتيجة",
    "platform_health.metric.failure_rate": "معدل الإخفاق",
    "Failure rate": "معدل الإخفاق",
    "platform_health.metric.classified_records": "السجلات المصنفة",
    "Classified records": "السجلات المصنفة",
    "platform_health.activity.title": "نشاط المصادقة",
    "Authentication activity": "نشاط المصادقة",
    "platform_health.activity.description": "المحاولات التي أُعيدت ضمن فترة التدقيق المحددة",
    "Attempts returned by the selected audit window": "المحاولات التي أُعيدت ضمن فترة التدقيق المحددة",
    "platform_health.activity.no_timestamps": "لم تُرجع سجلات تدقيق مؤرخة.",
    "No timestamped audit records returned.": "لم تُرجع سجلات تدقيق مؤرخة.",
    "platform_health.event.login": "تسجيل الدخول",
    "login": "تسجيل الدخول",
    "platform_health.event.signup": "إنشاء الحساب",
    "signup": "إنشاء الحساب",
    "platform_health.status.success": "نجاح",
    "platform_health.status.failed": "فشل",
    "platform_health.status.recorded": "مسجل",
    "Recorded": "مسجل",
    "platform_health.unknown_day": "يوم غير معروف",
    "platform_health.failure_reasons": "أسباب الإخفاق",
    "Failure reasons": "أسباب الإخفاق",
    "platform_health.no_failures": "لم تُرجع إخفاقات مصنفة.",
    "No classified failures returned.": "لم تُرجع إخفاقات مصنفة.",
    "platform_health.unspecified_failure": "إخفاق غير محدد",
    "Unspecified failure": "إخفاق غير محدد",
    "platform_health.recent_records": "سجلات التدقيق الأخيرة",
    "Recent audit records": "سجلات التدقيق الأخيرة",
    "platform_health.normalized_note": "تُوحّد الحقول الخام للعرض فقط.",
    "Raw fields are normalized only for display.": "تُوحّد الحقول الخام للعرض فقط.",
    "platform_health.loaded_count": "تم تحميل {count}",
    "{count} loaded": "تم تحميل {count}",
    "platform_health.loading_records": "جارٍ تحميل سجلات التدقيق…",
    "Loading audit records…": "جارٍ تحميل سجلات التدقيق…",
    "platform_health.no_records": "لم تُرجع سجلات تدقيق.",
    "No audit records returned.": "لم تُرجع سجلات تدقيق.",
    "platform_health.column.event": "الحدث",
    "platform_health.column.status": "الحالة",
    "platform_health.column.user": "المستخدم",
    "User": "المستخدم",
    "platform_health.column.time": "الوقت",
    "Time": "الوقت",
    "platform_health.column.reason": "السبب",
    "Reason": "السبب",
    "platform_health.config.sign_in": "طريقة تسجيل الدخول",
    "Sign-in method": "طريقة تسجيل الدخول",
    "platform_health.config.facebook": "مصادقة Facebook",
    "Facebook Auth": "مصادقة Facebook",
    "platform_health.config.google": "مصادقة Google",
    "Google Auth": "مصادقة Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "تُطبّق هذه الإعدادات فورًا. بعد حفظها، تظهر في التطبيقات واستجابات API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "تُطبّق هذه الإعدادات فورًا. بعد حفظها، تظهر في التطبيقات واستجابات API.",
    "integrations.note.mobile_release": "تُطبّق إعدادات قناة تطبيق الهاتف عند إصدار المنتج أو تحديثه. لطلب إصدار جديد، تواصل مع بوابة الدعم. ينطبق ذلك على خطة Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "تُطبّق إعدادات قناة تطبيق الهاتف عند إصدار المنتج أو تحديثه. لطلب إصدار جديد، تواصل مع بوابة الدعم. ينطبق ذلك على خطة Starter.",
    "integrations.toast.saved": "تم حفظ إعدادات التكامل.",
    "Integration settings saved.": "تم حفظ إعدادات التكامل.",
    "integrations.error.save": "تعذّر حفظ إعدادات التكامل.",
    "Unable to save integration settings.": "تعذّر حفظ إعدادات التكامل.",
    "integrations.twilio.title": "تكامل Twilio",
    "Twilio integration": "تكامل Twilio",
    "integrations.twilio.account_sid": "معرّف حساب SID",
    "Account SID": "معرّف حساب SID",
    "integrations.twilio.account_sid_placeholder": "أدخل معرّف حساب SID",
    "Enter account SID": "أدخل معرّف حساب SID",
    "integrations.twilio.auth_token": "رمز المصادقة",
    "Auth token": "رمز المصادقة",
    "integrations.twilio.auth_token_placeholder": "أدخل رمز المصادقة",
    "Enter auth token": "أدخل رمز المصادقة",
    "integrations.twilio.source_phone": "رقم هاتف المصدر",
    "Source phone number": "رقم هاتف المصدر",
    "integrations.twilio.source_phone_placeholder": "أدخل رقم هاتف المصدر",
    "Enter source phone number": "أدخل رقم هاتف المصدر",
    "integrations.facebook.title": "مصادقة Facebook",
    "integrations.facebook.enable_login": "تفعيل تسجيل الدخول عبر Facebook",
    "Enable Facebook login": "تفعيل تسجيل الدخول عبر Facebook",
    "integrations.facebook.app_id": "معرّف التطبيق",
    "App ID": "معرّف التطبيق",
    "integrations.facebook.app_id_placeholder": "أدخل معرّف التطبيق",
    "Enter app ID": "أدخل معرّف التطبيق",
    "integrations.google.title": "مصادقة Google",
    "integrations.google.enable_sign_in": "تفعيل تسجيل الدخول عبر Google",
    "Enable Google sign-in": "تفعيل تسجيل الدخول عبر Google",
    "integrations.google.client_id": "معرّف العميل",
    "Client ID": "معرّف العميل",
    "integrations.google.client_id_placeholder": "أدخل معرّف العميل",
    "Enter client ID": "أدخل معرّف العميل",
    "integrations.auth.title": "طريقة تسجيل الدخول",
    "integrations.auth.description": "اختر كيفية تسجيل المستخدمين ودخولهم. يستخدم التحقق عبر البريد الإلكتروني والرسائل القصيرة إعدادات الإرسال المهيأة للمستأجر.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "اختر كيفية تسجيل المستخدمين ودخولهم. يستخدم التحقق عبر البريد الإلكتروني والرسائل القصيرة إعدادات الإرسال المهيأة للمستأجر.",
    "integrations.auth.empty": "لا توجد طريقة تسجيل دخول مدعومة ومهيأة حاليًا. اختر طريقة للمتابعة.",
    "No supported sign-in method is currently configured. Select one to continue.": "لا توجد طريقة تسجيل دخول مدعومة ومهيأة حاليًا. اختر طريقة للمتابعة.",
    "integrations.auth.save_note": "يؤدي الحفظ إلى تطبيق هذه الطريقة على نقاط التسجيل وتسجيل الدخول للمستأجر. تتم إدارة المستخدمين الذين أُنشئوا مباشرةً بشكل منفصل.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "يؤدي الحفظ إلى تطبيق هذه الطريقة على نقاط التسجيل وتسجيل الدخول للمستأجر. تتم إدارة المستخدمين الذين أُنشئوا مباشرةً بشكل منفصل.",
    "integrations.auth.error.load": "تعذّر تحميل طريقة تسجيل الدخول الحالية.",
    "Unable to load the current sign-in method.": "تعذّر تحميل طريقة تسجيل الدخول الحالية.",
    "integrations.auth.error.save": "تعذّر حفظ طريقة تسجيل الدخول.",
    "Unable to save the sign-in method.": "تعذّر حفظ طريقة تسجيل الدخول.",
    "integrations.auth.toast.saved": "تم حفظ طريقة تسجيل الدخول.",
    "Sign-in method saved.": "تم حفظ طريقة تسجيل الدخول.",
    "integrations.auth.email_password": "البريد الإلكتروني وكلمة المرور",
    "Email and password": "البريد الإلكتروني وكلمة المرور",
    "integrations.auth.email_password_help": "يتحقق المستخدمون من بريدهم الإلكتروني أثناء التسجيل، ثم يسجلون الدخول بكلمة مرور.",
    "Users verify their email during sign-up, then sign in with a password.": "يتحقق المستخدمون من بريدهم الإلكتروني أثناء التسجيل، ثم يسجلون الدخول بكلمة مرور.",
    "integrations.auth.email_code": "رمز لمرة واحدة عبر البريد الإلكتروني",
    "Email one-time code": "رمز لمرة واحدة عبر البريد الإلكتروني",
    "integrations.auth.email_code_help": "يتلقى المستخدمون رمز تحقق عبر البريد الإلكتروني للتسجيل وتسجيل الدخول.",
    "Users receive a verification code by email for sign-up and sign-in.": "يتلقى المستخدمون رمز تحقق عبر البريد الإلكتروني للتسجيل وتسجيل الدخول.",
    "integrations.auth.phone_code": "رمز لمرة واحدة عبر الهاتف",
    "Phone one-time code": "رمز لمرة واحدة عبر الهاتف",
    "integrations.auth.phone_code_help": "يتلقى المستخدمون رمز تحقق عبر الرسائل القصيرة للتسجيل وتسجيل الدخول.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "يتلقى المستخدمون رمز تحقق عبر الرسائل القصيرة للتسجيل وتسجيل الدخول.",
    "integrations.auth.phone_password": "الهاتف وكلمة المرور",
    "Phone and password": "الهاتف وكلمة المرور",
    "integrations.auth.phone_password_help": "يتحقق المستخدمون من رقم هاتفهم أثناء التسجيل، ثم يسجلون الدخول بكلمة مرور.",
    "Users verify their phone during sign-up, then sign in with a password.": "يتحقق المستخدمون من رقم هاتفهم أثناء التسجيل، ثم يسجلون الدخول بكلمة مرور.",
    "integrations.auth.email_password_unverified": "البريد الإلكتروني وكلمة المرور دون التحقق عند التسجيل",
    "Email and password without sign-up verification": "البريد الإلكتروني وكلمة المرور دون التحقق عند التسجيل",
    "integrations.auth.email_password_unverified_help": "يمكن للمستخدمين التسجيل باستخدام البريد الإلكتروني وكلمة المرور دون رمز تحقق عبر البريد الإلكتروني.",
    "Users can sign up with an email and password without an email verification code.": "يمكن للمستخدمين التسجيل باستخدام البريد الإلكتروني وكلمة المرور دون رمز تحقق عبر البريد الإلكتروني.",
    "integrations.auth.phone_password_unverified": "الهاتف وكلمة المرور دون التحقق عند التسجيل",
    "Phone and password without sign-up verification": "الهاتف وكلمة المرور دون التحقق عند التسجيل",
    "integrations.auth.phone_password_unverified_help": "يمكن للمستخدمين التسجيل باستخدام الهاتف وكلمة المرور دون رمز تحقق عبر الرسائل القصيرة.",
    "Users can sign up with a phone and password without an SMS verification code.": "يمكن للمستخدمين التسجيل باستخدام الهاتف وكلمة المرور دون رمز تحقق عبر الرسائل القصيرة.",
    "integrations.page.title": "تكاملات التطبيقات",
    "integrations.generic.id_placeholder": "أدخل معرّف {name}",
    "Enter {name} ID": "أدخل معرّف {name}",
    "integrations.generic.enable": "تفعيل تكامل {name}",
    "Enable {name} integration": "تفعيل تكامل {name}",
    "integrations.menu.map": "الخرائط",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "تكامل الخرائط",
    "Maps integration": "تكامل الخرائط",
    "integrations.maps.google": "خرائط Google",
    "Google Maps": "خرائط Google",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "مفتاح API",
    "API key": "مفتاح API",
    "integrations.maps.api_key_placeholder": "أدخل مفتاح API",
    "Enter API key": "أدخل مفتاح API",
    "integrations.maps.reverse_geocode_key": "مفتاح API للترميز الجغرافي العكسي في خرائط Google",
    "Google Maps reverse geocoding API key": "مفتاح API للترميز الجغرافي العكسي في خرائط Google",
    "integrations.maps.reverse_geocode_key_placeholder": "أدخل مفتاح API للترميز الجغرافي العكسي في خرائط Google",
    "Enter Google Maps reverse geocoding API key": "أدخل مفتاح API للترميز الجغرافي العكسي في خرائط Google",
    "integrations.maps.places_key": "مفتاح API للأماكن في خرائط Google",
    "Google Maps Places API key": "مفتاح API للأماكن في خرائط Google",
    "integrations.maps.places_key_placeholder": "أدخل مفتاح API للأماكن في خرائط Google",
    "Enter Google Maps Places API key": "أدخل مفتاح API للأماكن في خرائط Google",
    "integrations.maps.nearby_accounts": "تفعيل الحسابات القريبة في الصفحة الرئيسية",
    "Activate nearby accounts on the home page": "تفعيل الحسابات القريبة في الصفحة الرئيسية",
    "integrations.maps.listing_location": "تفعيل الموقع عند إضافة إعلان",
    "Activate location in listing submission": "تفعيل الموقع عند إضافة إعلان",
    "integrations.maps.account_location": "تفعيل الموقع عند إضافة حساب",
    "Activate location in account submission": "تفعيل الموقع عند إضافة حساب",
    "integrations.playstore.title": "تكامل Google Play",
    "Google Play integration": "تكامل Google Play",
    "integrations.playstore.application_id": "معرّف التطبيق",
    "Application ID": "معرّف التطبيق",
    "integrations.playstore.application_id_placeholder": "أدخل معرّف التطبيق (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "أدخل معرّف التطبيق (com.tenantname.app)",
    "integrations.playstore.first_name": "الاسم الأول",
    "integrations.playstore.first_name_placeholder": "أدخل الاسم الأول",
    "Enter first name": "أدخل الاسم الأول",
    "integrations.playstore.last_name": "اسم العائلة",
    "integrations.playstore.last_name_placeholder": "أدخل اسم العائلة",
    "Enter last name": "أدخل اسم العائلة",
    "integrations.playstore.unit": "الوحدة التنظيمية",
    "Organizational unit": "الوحدة التنظيمية",
    "integrations.playstore.unit_placeholder": "أدخل الوحدة التنظيمية",
    "Enter organizational unit": "أدخل الوحدة التنظيمية",
    "integrations.playstore.organization": "المؤسسة",
    "Organization": "المؤسسة",
    "integrations.playstore.organization_placeholder": "أدخل اسم المؤسسة",
    "Enter organization name": "أدخل اسم المؤسسة",
    "integrations.playstore.city": "المدينة أو المنطقة",
    "City or locality": "المدينة أو المنطقة",
    "integrations.playstore.city_placeholder": "أدخل المدينة أو المنطقة",
    "Enter city or locality": "أدخل المدينة أو المنطقة",
    "integrations.playstore.state": "الولاية أو المحافظة",
    "State or province": "الولاية أو المحافظة",
    "integrations.playstore.state_placeholder": "أدخل الولاية أو المحافظة",
    "Enter state or province": "أدخل الولاية أو المحافظة",
    "integrations.playstore.country_code": "رمز الدولة (XX)",
    "Country code (XX)": "رمز الدولة (XX)",
    "integrations.playstore.country_code_placeholder": "أدخل رمز الدولة",
    "Enter country code": "أدخل رمز الدولة",
    "integrations.playstore.link": "رابط Google Play",
    "Google Play link": "رابط Google Play",
    "integrations.playstore.link_placeholder": "أدخل رابط تطبيقك على Google Play",
    "Enter your app Google Play link": "أدخل رابط تطبيقك على Google Play",
    "integrations.admob.title": "تكامل AdMob",
    "AdMob integration": "تكامل AdMob",
    "integrations.admob.app_id": "معرّف التطبيق",
    "integrations.admob.app_id_placeholder": "أدخل معرّف التطبيق",
    "Enter App ID": "أدخل معرّف التطبيق",
    "integrations.admob.unit_id": "معرّف الوحدة",
    "Unit ID": "معرّف الوحدة",
    "integrations.admob.unit_id_placeholder": "أدخل معرّف وحدة AdMob",
    "Enter AdMob unit ID": "أدخل معرّف وحدة AdMob",
    "integrations.admob.listings_id": "معرّف الإعلانات",
    "Listings ID": "معرّف الإعلانات",
    "integrations.admob.listings_id_placeholder": "أدخل معرّف الإعلانات",
    "Enter listings ID": "أدخل معرّف الإعلانات",
    "integrations.admob.listing_detail_id": "معرّف تفاصيل الإعلان",
    "Listing detail ID": "معرّف تفاصيل الإعلان",
    "integrations.admob.listing_detail_id_placeholder": "أدخل معرّف تفاصيل الإعلان",
    "Enter listing detail ID": "أدخل معرّف تفاصيل الإعلان",
    "integrations.admob.home_id": "معرّف الصفحة الرئيسية",
    "Home ID": "معرّف الصفحة الرئيسية",
    "integrations.admob.home_id_placeholder": "أدخل معرّف الصفحة الرئيسية",
    "Enter home ID": "أدخل معرّف الصفحة الرئيسية",
    "integrations.admob.enable_ads": "تفعيل الإعلانات",
    "Enable ads": "تفعيل الإعلانات",
    "integrations.admob.enable_listing_ads": "تفعيل الإعلانات في موجز الإعلانات",
    "Enable ads on the listings feed": "تفعيل الإعلانات في موجز الإعلانات",
    "integrations.admob.enable_listing_detail_ads": "تفعيل الإعلانات في تفاصيل الإعلان",
    "Enable ads on listing details": "تفعيل الإعلانات في تفاصيل الإعلان",
    "integrations.admob.enable_home_ads": "تفعيل الإعلانات في شريط التنقل السفلي للصفحة الرئيسية",
    "Enable ads in the home bottom navigation": "تفعيل الإعلانات في شريط التنقل السفلي للصفحة الرئيسية",
    "integrations.save_success": "تم الحفظ بنجاح",
    "Saved successfully": "تم الحفظ بنجاح",
    "integrations.note.release": "تُطبّق هذه الإعدادات عند إصدار تطبيق الهاتف أو تحديثه. بعد إجراء التغييرات، اطلب إصدارًا جديدًا من بوابة الدعم. ينطبق ذلك على خطة Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "تُطبّق هذه الإعدادات عند إصدار تطبيق الهاتف أو تحديثه. بعد إجراء التغييرات، اطلب إصدارًا جديدًا من بوابة الدعم. ينطبق ذلك على خطة Starter.",
    "integrations.action.download": "تنزيل",
    "integrations.branch.title": "تكامل Branch",
    "Branch integration": "تكامل Branch",
    "integrations.branch.app_id": "معرّف التطبيق",
    "integrations.branch.app_id_placeholder": "أدخل معرّف التطبيق",
    "integrations.branch.live_key": "المفتاح المباشر",
    "Live key": "المفتاح المباشر",
    "integrations.branch.live_key_placeholder": "أدخل المفتاح المباشر",
    "Enter live key": "أدخل المفتاح المباشر",
    "integrations.branch.live_secret": "السر المباشر",
    "Live secret": "السر المباشر",
    "integrations.branch.live_secret_placeholder": "أدخل السر المباشر",
    "Enter live secret": "أدخل السر المباشر",
    "integrations.branch.uri_scheme": "مخطط URI",
    "URI scheme": "مخطط URI",
    "integrations.branch.uri_scheme_placeholder": "أدخل مخطط URI",
    "Enter URI scheme": "أدخل مخطط URI",
    "integrations.branch.link_domain": "نطاق الرابط",
    "Link domain": "نطاق الرابط",
    "integrations.branch.link_domain_placeholder": "أدخل نطاق الرابط",
    "Enter link domain": "أدخل نطاق الرابط",
    "integrations.branch.alternate_domain": "نطاق الرابط البديل",
    "Alternate link domain": "نطاق الرابط البديل",
    "integrations.branch.alternate_domain_placeholder": "أدخل نطاق الرابط البديل",
    "Enter alternate link domain": "أدخل نطاق الرابط البديل",
    "integrations.branch.link_description": "وصف الرابط",
    "Link description": "وصف الرابط",
    "integrations.branch.link_description_placeholder": "أدخل وصف الرابط",
    "Enter link description": "أدخل وصف الرابط",
    "integrations.branch.invite_friends": "دعوة الأصدقاء",
    "Invite friends": "دعوة الأصدقاء",
    "integrations.branch.invite_title": "العنوان",
    "Title": "العنوان",
    "integrations.branch.invite_description": "الوصف",
    "integrations.branch.destination_link": "رابط وجهة Branch (اختياري)",
    "Branch destination link (optional)": "رابط وجهة Branch (اختياري)",
    "integrations.branch.web_app_note": "ينطبق على مستخدمي تطبيق الويب",
    "Applies to web app users": "ينطبق على مستخدمي تطبيق الويب",
    "integrations.branch.destination_placeholder": "أدخل رابط وجهة Branch",
    "Enter branch destination link": "أدخل رابط وجهة Branch",
    "integrations.ios.title": "إعداد App Store",
    "App Store provisioning": "إعداد App Store",
    "integrations.ios.bundle_id": "معرّف الحزمة",
    "Bundle ID": "معرّف الحزمة",
    "integrations.ios.bundle_id_placeholder": "أدخل معرّف الحزمة",
    "Enter bundle ID": "أدخل معرّف الحزمة",
    "integrations.ios.certificate_password": "كلمة مرور شهادة التوزيع",
    "Distribution certificate password": "كلمة مرور شهادة التوزيع",
    "integrations.ios.certificate_password_placeholder": "أدخل كلمة مرور شهادة التوزيع",
    "Enter distribution certificate password": "أدخل كلمة مرور شهادة التوزيع",
    "integrations.ios.push_key_id": "معرّف مفتاح الإشعارات",
    "Push key ID": "معرّف مفتاح الإشعارات",
    "integrations.ios.push_key_id_placeholder": "أدخل معرّف مفتاح الإشعارات",
    "Enter push key ID": "أدخل معرّف مفتاح الإشعارات",
    "integrations.ios.team_id": "معرّف الفريق",
    "Team ID": "معرّف الفريق",
    "integrations.ios.team_id_placeholder": "أدخل معرّف الفريق",
    "Enter team ID": "أدخل معرّف الفريق",
    "integrations.ios.apple_id": "معرّف Apple",
    "Apple ID": "معرّف Apple",
    "integrations.ios.apple_id_placeholder": "أدخل معرّف Apple",
    "Enter Apple ID": "أدخل معرّف Apple",
    "integrations.ios.distribution_certificate": "شهادة التوزيع",
    "Distribution certificate": "شهادة التوزيع",
    "integrations.ios.provisioning_profile": "ملف تعريف التزويد للتوزيع",
    "Distribution provisioning profile": "ملف تعريف التزويد للتوزيع",
    "integrations.ios.push_key": "مفتاح الإشعارات",
    "Push key": "مفتاح الإشعارات",
    "integrations.ios.app_store_link": "رابطك في App Store",
    "Your App Store link": "رابطك في App Store",
    "integrations.ios.app_store_link_placeholder": "أدخل رابط تطبيقك في App Store",
    "Enter your app App Store link": "أدخل رابط تطبيقك في App Store",
    "integrations.firebase.title": "تكامل Firebase",
    "Firebase integration": "تكامل Firebase",
    "integrations.firebase.choose_file": "اختيار ملف",
    "integrations.firebase.service_account": "حساب خدمة Firebase",
    "Firebase service account": "حساب خدمة Firebase",
    "integrations.firebase.android_json": "ملف JSON لتطبيق Android",
    "Android app JSON file": "ملف JSON لتطبيق Android",
    "integrations.firebase.ios_plist": "ملف plist لتطبيق iOS",
    "iOS app plist file": "ملف plist لتطبيق iOS",
    "integrations.firebase.create_project": "إنشاء مشروع Firebase",
    "Create Firebase project": "إنشاء مشروع Firebase",
    "integrations.firebase.create_android": "إنشاء تطبيق Android",
    "Create Android app": "إنشاء تطبيق Android",
    "integrations.firebase.create_ios": "إنشاء تطبيق iOS",
    "Create iOS app": "إنشاء تطبيق iOS",
    "integrations.firebase.create_database": "إنشاء قاعدة بيانات آنية",
    "Create realtime database": "إنشاء قاعدة بيانات آنية",
    "integrations.firebase.apply_rules": "تطبيق قواعد قاعدة بيانات Firebase",
    "Apply Firebase database rules": "تطبيق قواعد قاعدة بيانات Firebase",
    "bundles.listing_number": "الإعلان رقم {id}",
    "Listing #{id}": "الإعلان رقم {id}",
    "bundles.listing_id": "المعرّف {id}",
    "ID {id}": "المعرّف {id}",
    "bundles.configure.title": "تهيئة الحزمة",
    "Configure bundle": "تهيئة الحزمة",
    "bundles.configure.subtitle": "إعلان الحزمة رقم {id} · أضف الإعلانات الموجودة أدناه.",
    "Bundle listing #{id} · add existing listings below.": "إعلان الحزمة رقم {id} · أضف الإعلانات الموجودة أدناه.",
    "bundles.back": "العودة إلى الحزم",
    "Back to bundles": "العودة إلى الحزم",
    "bundles.fixed_components": "المكونات الثابتة",
    "Fixed components": "المكونات الثابتة",
    "bundles.selection_pool": "مجموعة الاختيار المتنوع",
    "Mix-and-match pool": "مجموعة الاختيار المتنوع",
    "bundles.available_listings": "الإعلانات المتاحة",
    "Available listings": "الإعلانات المتاحة",
    "bundles.available_description": "ابحث عن المنتجات الموجودة في كتالوجك وأضفها.",
    "Search and add products already in your catalogue.": "ابحث عن المنتجات الموجودة في كتالوجك وأضفها.",
    "bundles.search_listings": "البحث في الإعلانات",
    "bundles.quantity_per_component": "الكمية لكل مكون",
    "Quantity per component": "الكمية لكل مكون",
    "bundles.loading_listings": "جارٍ تحميل الإعلانات…",
    "Loading listings…": "جارٍ تحميل الإعلانات…",
    "bundles.added": "تمت الإضافة",
    "Added": "تمت الإضافة",
    "bundles.adding": "جارٍ الإضافة…",
    "Adding…": "جارٍ الإضافة…",
    "bundles.add": "إضافة",
    "bundles.no_matching_listings": "لم يتم العثور على إعلانات مطابقة.",
    "No matching listings found.": "لم يتم العثور على إعلانات مطابقة.",
    "bundles.one_listing_added": "تمت إضافة إعلان واحد",
    "1 listing added": "تمت إضافة إعلان واحد",
    "bundles.many_listings_added": "تمت إضافة {count} إعلانات",
    "{count} listings added": "تمت إضافة {count} إعلانات",
    "bundles.quantity_short": "الكمية {count}",
    "Qty {count}": "الكمية {count}",
    "bundles.removing": "جارٍ الإزالة…",
    "Removing…": "جارٍ الإزالة…",
    "bundles.remove": "إزالة",
    "bundles.no_components": "لم تتم إضافة أي مكونات بعد.",
    "No components added yet.": "لم تتم إضافة أي مكونات بعد.",
    "bundles.pool_remove_note": "تتطلب إزالة عناصر المجموعة نقطة حذف في الواجهة الخلفية؛ الإضافة متاحة الآن.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "تتطلب إزالة عناصر المجموعة نقطة حذف في الواجهة الخلفية؛ الإضافة متاحة الآن.",
    "bundles.error.load_components": "تعذر تحميل مكونات الحزمة.",
    "Unable to load bundle components.": "تعذر تحميل مكونات الحزمة.",
    "bundles.error.add_listing": "تعذرت إضافة الإعلان إلى الحزمة.",
    "Unable to add listing to the bundle.": "تعذرت إضافة الإعلان إلى الحزمة.",
    "bundles.error.remove_component": "تعذرت إزالة المكون من الحزمة.",
    "Unable to remove bundle component.": "تعذرت إزالة المكون من الحزمة.",
    "bundles.error.load_listings": "تعذر تحميل الإعلانات.",
    "Unable to load listings.": "تعذر تحميل الإعلانات.",
    "bundles.components": "مكونات الحزمة",
    "Bundle components": "مكونات الحزمة",
    "bundles.picker_description": "حدد إعلانات موجودة في كتالوجك. سيتم ربطها بعد إنشاء الحزمة.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "حدد إعلانات موجودة في كتالوجك. سيتم ربطها بعد إنشاء الحزمة.",
    "bundles.fixed_bundle": "حزمة ثابتة",
    "Fixed bundle": "حزمة ثابتة",
    "bundles.mix_match": "اختيار متنوع",
    "Mix and match": "اختيار متنوع",
    "bundles.quantity_per_selected": "الكمية لكل إعلان محدد",
    "Quantity per selected listing": "الكمية لكل إعلان محدد",
    "bundles.search_existing": "البحث في الإعلانات الموجودة",
    "Search existing listings": "البحث في الإعلانات الموجودة",
    "bundles.selected_count": "المحدد ({count})",
    "Selected ({count})": "المحدد ({count})",
    "bundles.choose_component_hint": "اختر إعلانًا موجودًا واحدًا على الأقل، أو أنشئ الحزمة أولاً.",
    "Choose at least one existing listing, or create the bundle first.": "اختر إعلانًا موجودًا واحدًا على الأقل، أو أنشئ الحزمة أولاً.",
    "bundles.error.attach_components": "تم إنشاء الحزمة، لكن تعذر إرفاق مكوناتها.",
    "The bundle was created, but components could not be attached.": "تم إنشاء الحزمة، لكن تعذر إرفاق مكوناتها.",
    "bundles.continue_configure_hint": "يمكنك متابعة الإعداد من صفحة تهيئة الحزمة.",
    "You can continue from the bundle configuration page.": "يمكنك متابعة الإعداد من صفحة تهيئة الحزمة.",
    "bundles.title": "الحزم",
    "bundles.create": "إنشاء حزمة",
    "Create bundle": "إنشاء حزمة",
    "bundles.subtitle": "أنشئ إعلان الحزمة الرئيسي، ثم أرفق مكونات ثابتة أو مجموعة اختيار متنوع.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "أنشئ إعلان الحزمة الرئيسي، ثم أرفق مكونات ثابتة أو مجموعة اختيار متنوع.",
    "bundles.workflow": "سير عمل الحزم",
    "Bundle workflow": "سير عمل الحزم",
    "bundles.how_it_works": "طريقة عمل الحزم",
    "How bundles work": "طريقة عمل الحزم",
    "bundles.parent_description": "يتحكم إعلان رئيسي واحد في الحزمة التي يراها العملاء.",
    "One parent listing controls the customer-facing bundle.": "يتحكم إعلان رئيسي واحد في الحزمة التي يراها العملاء.",
    "bundles.flow": "مراحل الحزمة",
    "Bundle flow": "مراحل الحزمة",
    "bundles.parent_listing": "الإعلان الرئيسي",
    "Parent listing": "الإعلان الرئيسي",
    "bundles.name_price_category": "الاسم والسعر والفئة",
    "Name, price, category": "الاسم والسعر والفئة",
    "bundles.fixed_or_pool": "عناصر ثابتة أو مجموعة اختيار",
    "Fixed items or a pool": "عناصر ثابتة أو مجموعة اختيار",
    "bundles.checkout_stock": "مخزون إتمام الشراء",
    "Checkout stock": "مخزون إتمام الشراء",
    "bundles.selection_availability": "الاختيار والتوفر",
    "Selection + availability": "الاختيار والتوفر",
    "bundles.fixed_bundles": "الحزم الثابتة",
    "Fixed bundles": "الحزم الثابتة",
    "bundles.fixed_description": "بع مجموعة محددة من الإعلانات الموجودة معًا.",
    "Sell a defined group of existing listings together.": "بع مجموعة محددة من الإعلانات الموجودة معًا.",
    "bundles.fixed_detail": "أضف إعلانات موجودة كمكونات ثابتة.",
    "Add existing listings as fixed components.": "أضف إعلانات موجودة كمكونات ثابتة.",
    "bundles.pool_description": "اسمح للعملاء باختيار عناصر مؤهلة من مجموعة الحزمة.",
    "Let customers choose eligible items from a bundle pool.": "اسمح للعملاء باختيار عناصر مؤهلة من مجموعة الحزمة.",
    "bundles.pool_detail": "حدد الحد الأدنى والأقصى للاختيارات عند إتمام الشراء.",
    "Set the minimum and maximum selections at checkout.": "حدد الحد الأدنى والأقصى للاختيارات عند إتمام الشراء.",
    "channels.opensource.title": "حِزم بدء مفتوحة المصدر",
    "Open-source starter kits": "حِزم بدء مفتوحة المصدر",
    "channels.opensource.view_org": "عرض مؤسسة GitHub",
    "View GitHub organization": "عرض مؤسسة GitHub",
    "channels.opensource.description": "استكشف مستودعات Tradly مفتوحة المصدر وحِزم البدء التابعة لمؤسسة TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "استكشف مستودعات Tradly مفتوحة المصدر وحِزم البدء التابعة لمؤسسة TRADLY-PLATFORM.",
    "channels.opensource.loading": "جارٍ تحميل المستودعات…",
    "Loading repositories…": "جارٍ تحميل المستودعات…",
    "channels.opensource.error.http": "أعاد GitHub الحالة {status}.",
    "GitHub returned {status}.": "أعاد GitHub الحالة {status}.",
    "channels.opensource.error.load": "تعذّر تحميل المستودعات. حاول مرة أخرى لاحقًا.",
    "Unable to load repositories. Try again later.": "تعذّر تحميل المستودعات. حاول مرة أخرى لاحقًا.",
    "channels.opensource.empty": "لم يتم العثور على مستودعات عامة.",
    "No public repositories found.": "لم يتم العثور على مستودعات عامة.",
    "channels.opensource.repo_fallback": "مستودع Tradly مفتوح المصدر.",
    "Open-source Tradly repository.": "مستودع Tradly مفتوح المصدر.",
    "channels.opensource.language_code": "الرمز البرمجي",
    "channels.opensource.view_repo": "عرض المستودع",
    "View repository": "عرض المستودع",
    "developer.mcp.select_all": "تحديد الكل",
    "Select all": "تحديد الكل",
    "developer.mcp.read": "قراءة",
    "developer.mcp.write": "كتابة",
    "developer.mcp.delete": "حذف",
    "developer.mcp.export": "تصدير",
    "developer.mcp.copy": "نسخ",
    "Copy": "نسخ",
    "developer.mcp.copied": "تم النسخ",
    "Copied": "تم النسخ",
    "developer.mcp.connection_created": "تم إنشاء الاتصال",
    "Connection created": "تم إنشاء الاتصال",
    "developer.mcp.save_secret_warning": "احفظ سر العميل الآن؛ لن يظهر مرة أخرى.",
    "Save your client secret now — it will not be shown again.": "احفظ سر العميل الآن؛ لن يظهر مرة أخرى.",
    "developer.mcp.client_id": "معرّف العميل",
    "developer.mcp.client_secret": "سر العميل",
    "Client secret": "سر العميل",
    "developer.mcp.new_connection": "اتصال MCP جديد",
    "New MCP connection": "اتصال MCP جديد",
    "developer.mcp.platform": "المنصة",
    "Platform": "المنصة",
    "developer.mcp.platform_custom": "مخصص",
    "developer.mcp.connection_name": "اسم الاتصال",
    "Connection name": "اسم الاتصال",
    "developer.mcp.connection_name_placeholder": "مثال: ChatGPT",
    "e.g. ChatGPT": "مثال: ChatGPT",
    "developer.mcp.redirect_uris": "عناوين إعادة التوجيه URI",
    "Redirect URIs": "عناوين إعادة التوجيه URI",
    "developer.mcp.one_per_line": "(عنوان واحد في كل سطر)",
    "(one per line)": "(عنوان واحد في كل سطر)",
    "developer.mcp.permissions": "الأذونات",
    "Permissions": "الأذونات",
    "developer.mcp.error.connection_name": "أدخل اسمًا للاتصال",
    "Enter a connection name": "أدخل اسمًا للاتصال",
    "developer.mcp.error.redirect_uri": "أدخل عنوان إعادة توجيه واحدًا على الأقل",
    "Enter at least one redirect URI": "أدخل عنوان إعادة توجيه واحدًا على الأقل",
    "developer.mcp.error.create": "تعذّر إنشاء الاتصال",
    "Failed to create connection": "تعذّر إنشاء الاتصال",
    "developer.mcp.creating": "جارٍ الإنشاء…",
    "Creating…": "جارٍ الإنشاء…",
    "developer.mcp.edit_permissions": "تعديل الأذونات",
    "Edit permissions": "تعديل الأذونات",
    "developer.mcp.permissions_updated": "تم تحديث الأذونات",
    "Permissions updated": "تم تحديث الأذونات",
    "developer.mcp.error.update_permissions": "تعذّر تحديث الأذونات",
    "Failed to update permissions": "تعذّر تحديث الأذونات",
    "developer.mcp.saving": "جارٍ الحفظ…",
    "developer.mcp.error.load": "تعذّر تحميل اتصالات MCP.",
    "MCP connections could not be loaded.": "تعذّر تحميل اتصالات MCP.",
    "developer.mcp.confirm_delete": "هل تريد حذف هذا الاتصال؟ ستتم إزالته من القائمة وإلغاء صلاحية الوصول.",
    "Delete this connection? It will be removed from the list and its access revoked.": "هل تريد حذف هذا الاتصال؟ ستتم إزالته من القائمة وإلغاء صلاحية الوصول.",
    "developer.mcp.connection_removed": "تمت إزالة الاتصال",
    "Connection removed": "تمت إزالة الاتصال",
    "developer.mcp.error.remove_connection": "تعذّرت إزالة الاتصال",
    "Failed to remove connection": "تعذّرت إزالة الاتصال",
    "developer.mcp.connection_deactivated": "تم إلغاء تفعيل الاتصال",
    "Connection deactivated": "تم إلغاء تفعيل الاتصال",
    "developer.mcp.error.deactivate_connection": "تعذّر إلغاء تفعيل الاتصال",
    "Failed to deactivate connection": "تعذّر إلغاء تفعيل الاتصال",
    "developer.mcp.title": "اتصالات MCP",
    "MCP connections": "اتصالات MCP",
    "developer.mcp.description": "عملاء OAuth المسجلون لدى المستأجر وتطبيقات الذكاء الاصطناعي المصرّح لها باستخدام خادم MCP الخاص به.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "عملاء OAuth المسجلون لدى المستأجر وتطبيقات الذكاء الاصطناعي المصرّح لها باستخدام خادم MCP الخاص به.",
    "developer.mcp.empty": "لا توجد اتصالات بعد. أنشئ عميلًا أو اربط تطبيق ذكاء اصطناعي بخادم MCP لهذا المستأجر.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "لا توجد اتصالات بعد. أنشئ عميلًا أو اربط تطبيق ذكاء اصطناعي بخادم MCP لهذا المستأجر.",
    "developer.mcp.status.connected_one": "متصل · مستخدم واحد",
    "Connected · 1 user": "متصل · مستخدم واحد",
    "developer.mcp.status.connected_many": "متصل · {count} مستخدمين",
    "Connected · {count} users": "متصل · {count} مستخدمين",
    "developer.mcp.status.deactivated": "غير مفعّل",
    "Deactivated": "غير مفعّل",
    "developer.mcp.status.previously_connected": "متصل سابقًا",
    "Previously connected": "متصل سابقًا",
    "developer.mcp.status.registered": "مسجل · غير متصل",
    "Registered · not connected": "مسجل · غير متصل",
    "developer.mcp.oauth_app": "تطبيق OAuth",
    "OAuth app": "تطبيق OAuth",
    "developer.mcp.created": "تاريخ الإنشاء",
    "developer.mcp.updated": "تاريخ التحديث",
    "Updated": "تاريخ التحديث",
    "developer.mcp.edit_scopes": "تعديل النطاقات",
    "Edit scopes": "تعديل النطاقات",
    "developer.mcp.edit_scopes_for": "تعديل نطاقات {name}",
    "Edit scopes for {name}": "تعديل نطاقات {name}",
    "developer.mcp.deactivate_hint": "إلغاء التفعيل (مع إبقائه في القائمة والسجل)",
    "Deactivate (keeps it listed and logged)": "إلغاء التفعيل (مع إبقائه في القائمة والسجل)",
    "developer.mcp.deactivate_named": "إلغاء تفعيل {name}",
    "Deactivate {name}": "إلغاء تفعيل {name}",
    "developer.mcp.delete_connection": "حذف الاتصال",
    "Delete connection": "حذف الاتصال",
    "developer.mcp.delete_named": "حذف {name}",
    "Delete {name}": "حذف {name}",
    "developer.mcp.resource.listings": "الإعلانات",
    "developer.mcp.resource.orders": "الطلبات",
    "developer.mcp.resource.users": "المستخدمون",
    "developer.mcp.resource.accounts": "الحسابات",
    "developer.mcp.resource.categories": "الفئات",
    "developer.mcp.resource.attributes": "السمات",
    "developer.mcp.resource.analytics": "التحليلات",
    "developer.mcp.resource.attribution": "الإحالة",
    "Attribution": "الإحالة",
    "developer.mcp.resource.rewards": "المكافآت",
    "developer.mcp.resource.layers": "الطبقات / إدارة المحتوى",
    "Layers / CMS": "الطبقات / إدارة المحتوى",
    "developer.mcp.resource.settings": "إعدادات المتجر",
    "Store settings": "إعدادات المتجر",
    "developer.mcp.resource.marketing": "التسويق",
    "developer.mcp.resource.market_research": "أبحاث السوق",
    "Market research": "أبحاث السوق",
    "developer.mcp.resource.audiences": "جمهور التسويق",
    "Marketing audiences": "جمهور التسويق",
    "developer.mcp.resource.agents": "وكلاء الذكاء الاصطناعي",
    "developer.mcp.resource.assets": "تحميل الملفات",
    "File uploads": "تحميل الملفات",
    "developer.mcp.resource.workforce": "القوى العاملة",
    "developer.mcp.resource.inventory": "المخزون",
    "developer.mcp.resource.memberships": "العضويات",
    "Memberships": "العضويات",
    "developer.mcp.resource.bundles": "الحِزم",
    "developer.mcp.resource.rentals": "التأجير",
    "developer.mcp.resource.accounting": "المحاسبة",
    "developer.mcp.nav.label": "تنقل MCP",
    "MCP navigation": "تنقل MCP",
    "developer.mcp.nav.connections": "الاتصالات",
    "Connections": "الاتصالات",
    "developer.mcp.nav.logs": "السجلات",
    "Logs": "السجلات",
    "developer.mcp.unknown_provider": "مزوّد غير معروف",
    "Unknown provider": "مزوّد غير معروف",
    "developer.mcp.tenant_user": "المستأجر رقم {tenant} · المستخدم رقم {user}",
    "Tenant #{tenant} · User #{user}": "المستأجر رقم {tenant} · المستخدم رقم {user}",
    "developer.mcp.logs.title": "سجلات MCP",
    "MCP logs": "سجلات MCP",
    "developer.mcp.logs.heading": "نشاط الوكلاء الأخير",
    "Recent agent activity": "نشاط الوكلاء الأخير",
    "developer.mcp.logs.description": "عرض أحداث MCP لهذا المستأجر. يتم تحديث النشاط كل 15 ثانية.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "عرض أحداث MCP لهذا المستأجر. يتم تحديث النشاط كل 15 ثانية.",
    "developer.mcp.logs.error.audit": "تعذّر تحميل سجلات تدقيق MCP.",
    "MCP audit logs could not be loaded.": "تعذّر تحميل سجلات تدقيق MCP.",
    "developer.mcp.logs.error.load": "تعذّر تحميل سجلات MCP.",
    "MCP logs could not be loaded.": "تعذّر تحميل سجلات MCP.",
    "developer.mcp.logs.unknown_agent": "وكيل غير معروف",
    "Unknown agent": "وكيل غير معروف",
    "developer.mcp.logs.all_agents": "جميع الوكلاء",
    "All agents": "جميع الوكلاء",
    "developer.mcp.logs.updated": "تم التحديث {time}",
    "Updated {time}": "تم التحديث {time}",
    "developer.mcp.logs.loading": "جارٍ تحميل نشاط MCP…",
    "Loading MCP activity…": "جارٍ تحميل نشاط MCP…",
    "developer.mcp.logs.empty": "لم يتم العثور على أحداث MCP حديثة لهذا المستأجر.",
    "No recent MCP events found for this tenant.": "لم يتم العثور على أحداث MCP حديثة لهذا المستأجر.",
    "developer.mcp.logs.empty_agent": "لم يتم العثور على أحداث MCP حديثة لهذا المستأجر والوكيل.",
    "No recent MCP events found for this tenant and agent.": "لم يتم العثور على أحداث MCP حديثة لهذا المستأجر والوكيل.",
    "developer.mcp.logs.time": "الوقت",
    "developer.mcp.logs.event": "الحدث",
    "developer.mcp.logs.tool": "الأداة",
    "developer.mcp.logs.agent": "الوكيل",
    "Agent": "الوكيل",
    "developer.mcp.logs.tenant_user": "المستأجر / المستخدم",
    "Tenant / user": "المستأجر / المستخدم",
    "developer.mcp.logs.scope": "النطاق",
    "Scope": "النطاق",
    "developer.mcp.logs.result": "النتيجة",
    "Result": "النتيجة",
    "developer.mcp.logs.duration": "المدة",
    "Duration": "المدة",
    "developer.mcp.logs.view_details": "عرض تفاصيل {event}",
    "View details for {event}": "عرض تفاصيل {event}",
    "developer.mcp.logs.tenant": "المستأجر رقم {id}",
    "Tenant #{id}": "المستأجر رقم {id}",
    "developer.mcp.logs.user": "المستخدم رقم {id}",
    "User #{id}": "المستخدم رقم {id}",
    "developer.mcp.logs.view_granted_scopes": "عرض النطاقات الممنوحة",
    "View granted scopes": "عرض النطاقات الممنوحة",
    "developer.mcp.logs.succeeded": "نجح",
    "Succeeded": "نجح",
    "developer.mcp.logs.failed": "فشل",
    "developer.mcp.logs.duration_ms": "{count} مللي ثانية",
    "{count} ms": "{count} مللي ثانية",
    "developer.mcp.logs.details_title": "تفاصيل حدث MCP",
    "MCP event details": "تفاصيل حدث MCP",
    "developer.mcp.logs.required_scope": "النطاق المطلوب",
    "Required scope": "النطاق المطلوب",
    "developer.mcp.logs.granted_scopes": "النطاقات الممنوحة",
    "Granted scopes": "النطاقات الممنوحة",
    "developer.mcp.logs.event_generic": "حدث",
    "developer.mcp.logs.event.tool_called": "تم استدعاء الأداة",
    "Tool called": "تم استدعاء الأداة",
    "developer.mcp.logs.event.connection_requested": "تم طلب الاتصال",
    "Connection requested": "تم طلب الاتصال",
    "developer.mcp.logs.event.connection_connected": "تم الاتصال",
    "Connection connected": "تم الاتصال",
    "developer.mcp.logs.event.connection_deactivated": "تم إلغاء تفعيل الاتصال",
    "developer.mcp.logs.event.connection_deleted": "تم حذف الاتصال",
    "Connection deleted": "تم حذف الاتصال",
    "developer.mcp.logs.event.permissions_updated": "تم تحديث الأذونات",
    "common.status.label": "الحالة",
    "suppliers.title": "المورّدون",
    "suppliers.search": "البحث عن مورّدين",
    "Search suppliers": "البحث عن مورّدين",
    "suppliers.add": "إضافة مورّد",
    "Add supplier": "إضافة مورّد",
    "suppliers.deactivate": "إلغاء التفعيل",
    "suppliers.empty": "لم يتم العثور على مورّدين.",
    "No suppliers found.": "لم يتم العثور على مورّدين.",
    "suppliers.add_title": "إضافة مورّد",
    "suppliers.edit_title": "تعديل المورّد",
    "Edit supplier": "تعديل المورّد",
    "suppliers.save_changes": "حفظ التغييرات",
    "Save changes": "حفظ التغييرات",
    "suppliers.confirm_deactivate": "هل تريد إلغاء تفعيل {name}؟",
    "Deactivate {name}?": "هل تريد إلغاء تفعيل {name}؟",
    "suppliers.toast.updated": "تم تحديث المورّد",
    "Supplier updated": "تم تحديث المورّد",
    "suppliers.toast.added": "تمت إضافة المورّد",
    "Supplier added": "تمت إضافة المورّد",
    "suppliers.toast.deactivated": "تم إلغاء تفعيل المورّد",
    "Supplier deactivated": "تم إلغاء تفعيل المورّد",
    "suppliers.column.name": "الاسم",
    "suppliers.column.code": "الرمز",
    "suppliers.column.contact": "جهة الاتصال",
    "Contact": "جهة الاتصال",
    "suppliers.field.name": "الاسم",
    "suppliers.field.code": "الرمز",
    "suppliers.field.contact_name": "اسم جهة الاتصال",
    "Contact name": "اسم جهة الاتصال",
    "suppliers.field.email": "البريد الإلكتروني",
    "suppliers.field.phone": "الهاتف",
    "suppliers.field.currency": "العملة",
    "suppliers.field.payment_terms": "شروط الدفع",
    "Payment terms": "شروط الدفع",
    "suppliers.field.address": "العنوان",
    "suppliers.field.note": "ملاحظة",
    "Note": "ملاحظة",
    "suppliers.placeholder.name": "اسم الشركة أو المورّد",
    "Company or supplier name": "اسم الشركة أو المورّد",
    "suppliers.placeholder.code": "رمز المورّد",
    "Supplier code": "رمز المورّد",
    "suppliers.placeholder.contact_name": "اسم جهة الاتصال",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "الدفع عند الاستلام",
    "Cash on delivery": "الدفع عند الاستلام",
    "suppliers.payment_terms.payment_on_receipt": "الدفع عند استلام الفاتورة",
    "Payment on receipt": "الدفع عند استلام الفاتورة",
    "suppliers.payment_terms.payment_in_advance": "الدفع مقدمًا",
    "Payment in advance": "الدفع مقدمًا",
    "suppliers.payment_terms.net_7": "صافي 7 أيام",
    "Net 7 days": "صافي 7 أيام",
    "suppliers.payment_terms.net_15": "صافي 15 يومًا",
    "Net 15 days": "صافي 15 يومًا",
    "suppliers.payment_terms.net_30": "صافي 30 يومًا",
    "Net 30 days": "صافي 30 يومًا",
    "suppliers.payment_terms.net_45": "صافي 45 يومًا",
    "Net 45 days": "صافي 45 يومًا",
    "suppliers.payment_terms.net_60": "صافي 60 يومًا",
    "Net 60 days": "صافي 60 يومًا",
    "suppliers.detail_title": "تفاصيل المورّد",
    "Supplier details": "تفاصيل المورّد",
    "suppliers.edit": "تعديل المورّد",
    "suppliers.back": "العودة إلى المورّدين",
    "Back to suppliers": "العودة إلى المورّدين",
    "suppliers.loading": "جارٍ تحميل بيانات المورّد…",
    "Loading supplier…": "جارٍ تحميل بيانات المورّد…",
    "suppliers.unnamed": "مورّد بلا اسم",
    "Unnamed supplier": "مورّد بلا اسم",
    "suppliers.profile_description": "الملف التعريفي للمورّد ومعلومات الاتصال",
    "Supplier profile and contact information": "الملف التعريفي للمورّد ومعلومات الاتصال",
    "suppliers.total_spend": "إجمالي الإنفاق",
    "Total spend": "إجمالي الإنفاق",
    "suppliers.outstanding": "المستحق",
    "Outstanding": "المستحق",
    "suppliers.paid": "مدفوع",
    "suppliers.draft": "مسودة",
    "suppliers.purchase_history": "سجل المشتريات",
    "Purchase history": "سجل المشتريات",
    "suppliers.bill.reference": "المرجع",
    "Reference": "المرجع",
    "suppliers.bill.date": "التاريخ",
    "suppliers.bill.amount": "المبلغ",
    "suppliers.bill.number": "الفاتورة رقم {id}",
    "Bill #{id}": "الفاتورة رقم {id}",
    "suppliers.bills_empty": "لا توجد فواتير لهذا المورّد.",
    "No bills found for this supplier.": "لا توجد فواتير لهذا المورّد.",
    "inventory.locations.title": "المواقع",
    "inventory.locations.add": "إضافة موقع",
    "Add location": "إضافة موقع",
    "inventory.locations.description": "المستودعات والمتاجر التي تحتفظ بالمخزون. تُستلم أوامر الشراء في أحد هذه المواقع.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "المستودعات والمتاجر التي تحتفظ بالمخزون. تُستلم أوامر الشراء في أحد هذه المواقع.",
    "inventory.locations.field.name": "الاسم",
    "inventory.locations.field.code": "الرمز",
    "inventory.locations.field.address": "العنوان",
    "inventory.locations.field.linked_store": "المتجر المرتبط (اختياري)",
    "Linked store (optional)": "المتجر المرتبط (اختياري)",
    "inventory.locations.field.linked_store_short": "المتجر المرتبط",
    "Linked store": "المتجر المرتبط",
    "inventory.locations.placeholder.name": "المستودع الرئيسي",
    "Main warehouse": "المستودع الرئيسي",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "ابحث عن عنوان أو مكان",
    "Search an address or place": "ابحث عن عنوان أو مكان",
    "inventory.locations.placeholder.linked_store": "ابحث عن حساب بائع أو متجر",
    "Search seller or store accounts": "ابحث عن حساب بائع أو متجر",
    "inventory.locations.confirm_deactivate": "إلغاء تفعيل {name}؟ لن يكون متاحًا لأوامر الشراء الجديدة.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "إلغاء تفعيل {name}؟ لن يكون متاحًا لأوامر الشراء الجديدة.",
    "inventory.locations.toast.deactivated": "تم إلغاء تفعيل الموقع",
    "Location deactivated": "تم إلغاء تفعيل الموقع",
    "inventory.locations.deactivate": "إلغاء التفعيل",
    "inventory.locations.empty": "لا توجد مواقع بعد. أضف مستودعًا أو متجرًا لبدء استلام المخزون.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "لا توجد مواقع بعد. أضف مستودعًا أو متجرًا لبدء استلام المخزون.",
    "inventory.locations.edit_title": "تعديل الموقع",
    "Edit location": "تعديل الموقع",
    "inventory.locations.add_title": "إضافة موقع",
    "inventory.locations.form_description": "اربط حساب متجر فقط إذا كان هذا الموقع تابعًا لبائع محدد.",
    "Link a store account only if this location belongs to a specific seller.": "اربط حساب متجر فقط إذا كان هذا الموقع تابعًا لبائع محدد.",
    "inventory.locations.save_changes": "حفظ التغييرات",
    "inventory.locations.toast.updated": "تم تحديث الموقع",
    "Location updated": "تم تحديث الموقع",
    "inventory.locations.toast.added": "تمت إضافة الموقع",
    "Location added": "تمت إضافة الموقع",
    "inventory.operations.title": "عمليات المخزون",
    "Inventory operations": "عمليات المخزون",
    "inventory.operations.tab.movements": "سجل الحركة",
    "Movement history": "سجل الحركة",
    "inventory.operations.tab.batches": "الدفعات وتواريخ الانتهاء",
    "Batches & expiry": "الدفعات وتواريخ الانتهاء",
    "inventory.operations.tab.transfers": "أوامر النقل",
    "Transfer orders": "أوامر النقل",
    "inventory.operations.tab.requisitions": "طلبات الصرف",
    "Requisitions": "طلبات الصرف",
    "inventory.operations.tab.receipts": "استلام البضائع",
    "Goods received": "استلام البضائع",
    "inventory.operations.description.movements": "سجل ثابت لكل عملية استلام أو بيع أو نقل أو إرجاع أو تسوية.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "سجل ثابت لكل عملية استلام أو بيع أو نقل أو إرجاع أو تسوية.",
    "inventory.operations.description.batches": "تتبّع الدفعات وتواريخ الانتهاء والحالة والوحدات دون تغيير سجل المخزون هنا.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "تتبّع الدفعات وتواريخ الانتهاء والحالة والوحدات دون تغيير سجل المخزون هنا.",
    "inventory.operations.description.transfers": "انقل المخزون بين المواقع مع تتبّع الإرسال والاستلام وحالات الاختلاف.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "انقل المخزون بين المواقع مع تتبّع الإرسال والاستلام وحالات الاختلاف.",
    "inventory.operations.description.requisitions": "راجع طلبات المخزون الداخلية. تؤدي الموافقة تلقائيًا إلى إنشاء أمر نقل.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "راجع طلبات المخزون الداخلية. تؤدي الموافقة تلقائيًا إلى إنشاء أمر نقل.",
    "inventory.operations.description.receipts": "أنشئ إيصالات وتابع عمليات الاستلام المفتوحة والجزئية والمغلقة.",
    "Create receipts and track open, partial, and closed receiving work.": "أنشئ إيصالات وتابع عمليات الاستلام المفتوحة والجزئية والمغلقة.",
    "inventory.operations.overview": "نظرة عامة",
    "inventory.operations.new_transfer": "نقل جديد",
    "New transfer": "نقل جديد",
    "inventory.operations.new_requisition": "طلب صرف جديد",
    "inventory.operations.new_receipt": "إيصال استلام جديد",
    "New receipt": "إيصال استلام جديد",
    "inventory.operations.search": "بحث",
    "inventory.operations.search_view": "البحث في هذا العرض",
    "Search this view": "البحث في هذا العرض",
    "inventory.operations.search_products": "البحث عن المنتجات",
    "Search products": "البحث عن المنتجات",
    "inventory.operations.search_purchase_order": "البحث عن أوامر الشراء (اختياري)",
    "Search purchase orders (optional)": "البحث عن أوامر الشراء (اختياري)",
    "inventory.operations.listing_number": "الإعلان رقم {id}",
    "inventory.operations.location_number": "الموقع رقم {id}",
    "Location #{id}": "الموقع رقم {id}",
    "inventory.operations.no_sku": "لا يوجد SKU",
    "No SKU": "لا يوجد SKU",
    "inventory.operations.order_status": "الحالة: {status}",
    "Status: {status}": "الحالة: {status}",
    "inventory.operations.field.receiving_location": "موقع الاستلام",
    "Receiving location": "موقع الاستلام",
    "inventory.operations.field.purchase_order": "أمر الشراء",
    "inventory.operations.field.reference": "المرجع",
    "inventory.operations.field.note": "ملاحظة",
    "inventory.operations.field.from_location": "من الموقع",
    "From location": "من الموقع",
    "inventory.operations.field.supplying_location": "موقع التوريد",
    "Supplying location": "موقع التوريد",
    "inventory.operations.field.to_location": "إلى الموقع",
    "To location": "إلى الموقع",
    "inventory.operations.field.requesting_location": "الموقع الطالب",
    "Requesting location": "الموقع الطالب",
    "inventory.operations.field.product": "المنتج",
    "Product": "المنتج",
    "inventory.operations.field.quantity": "الكمية",
    "Quantity": "الكمية",
    "inventory.operations.field.location": "الموقع",
    "Location": "الموقع",
    "inventory.operations.placeholder.delivery_note": "إشعار تسليم المورد",
    "Supplier delivery note": "إشعار تسليم المورد",
    "inventory.operations.placeholder.receiving_note": "ملاحظة استلام اختيارية",
    "Optional receiving note": "ملاحظة استلام اختيارية",
    "inventory.operations.placeholder.transfer_reference": "مرجع النقل",
    "Transfer reference": "مرجع النقل",
    "inventory.operations.placeholder.request_reference": "مرجع الطلب",
    "Request reference": "مرجع الطلب",
    "inventory.operations.placeholder.context": "سياق اختياري",
    "Optional context": "سياق اختياري",
    "inventory.operations.create.transfer_title": "إنشاء أمر نقل",
    "New transfer order": "إنشاء أمر نقل",
    "inventory.operations.create.requisition_title": "إنشاء طلب صرف",
    "inventory.operations.create.receipt_title": "إنشاء إيصال استلام بضائع",
    "New goods receipt": "إنشاء إيصال استلام بضائع",
    "inventory.operations.create.transfer_description": "انقل المخزون بين موقعين.",
    "Move stock between two locations.": "انقل المخزون بين موقعين.",
    "inventory.operations.create.requisition_description": "اطلب مخزونًا من موقع آخر.",
    "Request stock from another location.": "اطلب مخزونًا من موقع آخر.",
    "inventory.operations.create.receipt_description": "أنشئ إيصالًا قبل مسح الصناديق أو إضافتها.",
    "Create a receipt before scanning or adding boxes.": "أنشئ إيصالًا قبل مسح الصناديق أو إضافتها.",
    "inventory.operations.toast.transfer_created": "تم إنشاء أمر النقل",
    "Transfer order created": "تم إنشاء أمر النقل",
    "inventory.operations.toast.requisition_created": "تم إنشاء طلب الصرف",
    "Requisition created": "تم إنشاء طلب الصرف",
    "inventory.operations.toast.receipt_created": "تم إنشاء إيصال استلام البضائع",
    "Goods receipt created": "تم إنشاء إيصال استلام البضائع",
    "inventory.operations.toast.transfer_dispatched": "تم إرسال النقل",
    "Transfer dispatched": "تم إرسال النقل",
    "inventory.operations.toast.transfer_received": "تم استلام النقل",
    "Transfer received": "تم استلام النقل",
    "inventory.operations.toast.transfer_cancelled": "تم إلغاء النقل",
    "Transfer cancelled": "تم إلغاء النقل",
    "inventory.operations.toast.requisition_approved": "تمت الموافقة على طلب الصرف",
    "Requisition approved": "تمت الموافقة على طلب الصرف",
    "inventory.operations.toast.requisition_rejected": "تم رفض طلب الصرف",
    "Requisition rejected": "تم رفض طلب الصرف",
    "inventory.operations.action.dispatch": "إرسال",
    "Dispatch": "إرسال",
    "inventory.operations.action.receive": "استلام",
    "Receive": "استلام",
    "inventory.operations.action.approve": "موافقة",
    "Approve": "موافقة",
    "inventory.operations.action.reject": "رفض",
    "Reject": "رفض",
    "inventory.operations.column.when": "الوقت",
    "When": "الوقت",
    "inventory.operations.column.event": "الحدث",
    "inventory.operations.column.change": "التغيير",
    "inventory.operations.column.after": "بعد التغيير",
    "After": "بعد التغيير",
    "inventory.operations.column.order": "الترتيب",
    "inventory.operations.column.route": "المسار",
    "Route": "المسار",
    "inventory.operations.column.lines": "البنود",
    "Lines": "البنود",
    "inventory.operations.column.expected": "المتوقع",
    "Expected": "المتوقع",
    "inventory.operations.column.request": "الطلب",
    "Request": "الطلب",
    "inventory.operations.column.request_supply": "الطلب / التوريد",
    "Request / supply": "الطلب / التوريد",
    "inventory.operations.column.created": "تاريخ الإنشاء",
    "inventory.operations.column.receipt": "الإيصال",
    "inventory.operations.empty.movements": "لم يتم تسجيل أي حركات للمخزون بعد.",
    "No stock movements recorded yet.": "لم يتم تسجيل أي حركات للمخزون بعد.",
    "inventory.operations.empty.batches": "لم يتم تسجيل أي دفعات للمخزون بعد.",
    "No inventory batches have been recorded yet.": "لم يتم تسجيل أي دفعات للمخزون بعد.",
    "inventory.operations.empty.transfers": "لا توجد أوامر نقل بعد.",
    "No transfer orders yet.": "لا توجد أوامر نقل بعد.",
    "inventory.operations.empty.requisitions": "لا توجد طلبات صرف بعد.",
    "No requisitions yet.": "لا توجد طلبات صرف بعد.",
    "inventory.operations.empty.receipts": "لا توجد إيصالات استلام بضائع بعد.",
    "No goods receipts yet.": "لا توجد إيصالات استلام بضائع بعد.",
    "inventory.operations.batch.edit_title": "تعديل الدفعة",
    "Edit batch": "تعديل الدفعة",
    "inventory.operations.batch.edit_description": "تُعدّل كمية الدفعة من خلال تسوية المخزون؛ يقتصر هذا النموذج على تحديث بيانات التعريف والتتبّع.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "تُعدّل كمية الدفعة من خلال تسوية المخزون؛ يقتصر هذا النموذج على تحديث بيانات التعريف والتتبّع.",
    "inventory.operations.batch.save": "حفظ الدفعة",
    "Save batch": "حفظ الدفعة",
    "inventory.operations.batch.lot_number": "رقم الدفعة",
    "Lot number": "رقم الدفعة",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "تاريخ الانتهاء",
    "inventory.operations.batch.condition": "الحالة",
    "inventory.operations.batch.condition_placeholder": "جيد",
    "good": "جيد",
    "inventory.operations.batch.unit": "وحدة القياس",
    "Unit of measure": "وحدة القياس",
    "inventory.operations.batch.unit_placeholder": "صندوق، قطعة، كجم",
    "box, piece, kg": "صندوق، قطعة، كجم",
    "inventory.operations.batch.no_expiry": "بلا تاريخ انتهاء",
    "No expiry": "بلا تاريخ انتهاء",
    "inventory.operations.batch.updated": "تم تحديث الدفعة",
    "Batch updated": "تم تحديث الدفعة",
    "common.status.in_transit": "قيد النقل",
    "In transit": "قيد النقل",
    "common.status.pending": "قيد الانتظار",
    "common.status.approved": "تمت الموافقة",
    "common.status.rejected": "مرفوض",
    "Rejected": "مرفوض",
    "common.status.cancelled": "ملغى",
    "Cancelled": "ملغى",
    "common.status.received": "تم الاستلام",
    "common.status.sent": "مرسل",
    "Sent": "مرسل",
    "common.note": "ملاحظة",
    "common.optional": "اختياري",
    "Optional": "اختياري",
    "common.error.generic": "حدث خطأ ما.",
    "Something went wrong.": "حدث خطأ ما.",
    "purchase_orders.title": "أوامر الشراء",
    "purchase_orders.title_singular": "أمر شراء",
    "purchase_orders.tab.all": "Tous",
    "purchase_orders.tab.partial": "مستلم جزئيًا",
    "Partially received": "مستلم جزئيًا",
    "purchase_orders.create.new": "أمر شراء جديد",
    "New purchase order": "أمر شراء جديد",
    "purchase_orders.create.title": "أمر شراء جديد",
    "purchase_orders.create.subtitle": "يُحفظ كمسودة. حدّده كمرسل بعد إرساله إلى المورد.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "يُحفظ كمسودة. حدّده كمرسل بعد إرساله إلى المورد.",
    "purchase_orders.create.submit": "إنشاء مسودة",
    "Create draft": "إنشاء مسودة",
    "purchase_orders.field.location": "موقع الاستلام",
    "purchase_orders.field.supplier": "المورد",
    "Supplier": "المورد",
    "purchase_orders.field.reference": "مرجع المورد",
    "Supplier reference": "مرجع المورد",
    "purchase_orders.field.expected_delivery": "التسليم المتوقع",
    "Expected delivery": "التسليم المتوقع",
    "purchase_orders.field.products": "المنتجات",
    "Products": "المنتجات",
    "purchase_orders.select_location": "اختر موقعًا",
    "Select location": "اختر موقعًا",
    "purchase_orders.no_locations": "لم يتم إعداد مواقع",
    "No locations set up": "لم يتم إعداد مواقع",
    "purchase_orders.add_location": "أضف موقعًا أولاً ←",
    "Add a location first →": "أضف موقعًا أولاً ←",
    "purchase_orders.supplier_placeholder": "شركة ACME",
    "ACME Ltd": "شركة ACME",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "كل المواقع",
    "All locations": "كل المواقع",
    "purchase_orders.location_number": "الموقع رقم {id}",
    "purchase_orders.search_products": "ابحث عن منتجات لإضافتها",
    "Search products to add": "ابحث عن منتجات لإضافتها",
    "purchase_orders.in_stock": "المخزون: {count}",
    "In stock: {count}": "المخزون: {count}",
    "purchase_orders.column.order": "الطلب",
    "purchase_orders.column.product": "المنتج",
    "purchase_orders.column.quantity": "الكمية",
    "purchase_orders.column.ordered": "مطلوب",
    "Ordered": "مطلوب",
    "purchase_orders.column.received": "مستلم",
    "purchase_orders.column.remaining": "المتبقي",
    "Remaining": "المتبقي",
    "purchase_orders.column.unit_cost": "تكلفة الوحدة",
    "Unit cost": "تكلفة الوحدة",
    "purchase_orders.column.supplier": "المورد",
    "purchase_orders.column.location": "الموقع",
    "purchase_orders.column.progress": "المستلم",
    "purchase_orders.column.value": "القيمة",
    "purchase_orders.column.expected": "المتوقع",
    "purchase_orders.column.status": "الحالة",
    "purchase_orders.action.mark_sent": "تحديد كمرسل",
    "Mark as sent": "تحديد كمرسل",
    "purchase_orders.action.receive": "استلام",
    "purchase_orders.action.receive_stock": "استلام المخزون",
    "Receive stock": "استلام المخزون",
    "purchase_orders.action.cancel_order": "إلغاء الطلب",
    "Cancel order": "إلغاء الطلب",
    "purchase_orders.action.close_order": "إغلاق الطلب",
    "Close order": "إغلاق الطلب",
    "purchase_orders.receive.subtitle": "أدخل ما تم استلامه. سيتم تحديث مخزون موقع الاستلام عند التأكيد.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "أدخل ما تم استلامه. سيتم تحديث مخزون موقع الاستلام عند التأكيد.",
    "purchase_orders.receive.now": "استلام الآن",
    "Receive now": "استلام الآن",
    "purchase_orders.receive.confirm": "تأكيد الاستلام",
    "Confirm receipt": "تأكيد الاستلام",
    "purchase_orders.confirm.cancel": "هل تريد إلغاء أمر الشراء هذا؟",
    "Cancel this purchase order?": "هل تريد إلغاء أمر الشراء هذا؟",
    "purchase_orders.empty.all": "لا توجد أوامر شراء بعد. أنشئ أمرًا لإعادة تزويد المخزون.",
    "No purchase orders yet. Create one to restock inventory.": "لا توجد أوامر شراء بعد. أنشئ أمرًا لإعادة تزويد المخزون.",
    "purchase_orders.empty.filtered": "لا توجد أوامر شراء بهذه الحالة.",
    "No purchase orders with this status.": "لا توجد أوامر شراء بهذه الحالة.",
    "purchase_orders.error.location_required": "اختر موقعًا للاستلام.",
    "Choose a receiving location.": "اختر موقعًا للاستلام.",
    "purchase_orders.error.product_required": "أضف منتجًا واحدًا على الأقل.",
    "Add at least one product.": "أضف منتجًا واحدًا على الأقل.",
    "purchase_orders.error.quantity_positive": "يجب أن تكون كل كمية أكبر من 0.",
    "Every quantity must be greater than 0.": "يجب أن تكون كل كمية أكبر من 0.",
    "purchase_orders.error.receive_quantity": "أدخل كمية لعنصر واحد على الأقل.",
    "Enter a quantity for at least one item.": "أدخل كمية لعنصر واحد على الأقل.",
    "purchase_orders.toast.created": "تم إنشاء أمر الشراء كمسودة",
    "Purchase order created as draft": "تم إنشاء أمر الشراء كمسودة",
    "purchase_orders.toast.sent": "تم تحديده كمرسل",
    "Marked as sent": "تم تحديده كمرسل",
    "purchase_orders.toast.received": "تم استلام المخزون وتحديثه",
    "Stock received and inventory updated": "تم استلام المخزون وتحديثه",
    "purchase_orders.toast.cancelled": "تم إلغاء أمر الشراء",
    "Purchase order cancelled": "تم إلغاء أمر الشراء",
    "purchase_orders.toast.closed": "تم إغلاق أمر الشراء",
    "Purchase order closed": "تم إغلاق أمر الشراء",
    "schedule.title": "الجدول",
    "schedule.view.month": "الشهر",
    "Month": "الشهر",
    "schedule.view.week": "الأسبوع",
    "schedule.view.day": "اليوم",
    "schedule.today": "اليوم",
    "Today": "اليوم",
    "schedule.order_number": "الطلب رقم {number}",
    "Order #{number}": "الطلب رقم {number}",
    "schedule.customer": "العميل",
    "schedule.more_events": "+{count} أخرى",
    "+{count} more": "+{count} أخرى",
    "schedule.payment.paid": "مدفوع",
    "schedule.payment.pending": "معلق",
    "schedule.payment.failed": "فشل",
    "schedule.booking_details": "تفاصيل الحجز",
    "Booking details": "تفاصيل الحجز",
    "schedule.order_reference": "مرجع الطلب",
    "schedule.amount": "المبلغ",
    "schedule.start": "البداية",
    "schedule.end": "النهاية",
    "schedule.item_number": "العنصر {number}",
    "Item {number}": "العنصر {number}",
    "schedule.view_order": "عرض الطلب بالكامل",
    "View full order": "عرض الطلب بالكامل",
    "onboarding.greeting.morning": "صباح الخير",
    "Good morning": "صباح الخير",
    "onboarding.greeting.morning_named": "صباح الخير {name}",
    "Good morning {name}": "صباح الخير {name}",
    "onboarding.greeting.afternoon": "مساء الخير",
    "Good afternoon": "مساء الخير",
    "onboarding.greeting.afternoon_named": "مساء الخير {name}",
    "Good afternoon {name}": "مساء الخير {name}",
    "onboarding.greeting.evening": "مساء الخير",
    "Good evening": "مساء الخير",
    "onboarding.greeting.evening_named": "مساء الخير {name}",
    "Good evening {name}": "مساء الخير {name}",
    "onboarding.greeting.night": "مرحبًا",
    "Hello": "مرحبًا",
    "onboarding.greeting.night_named": "مرحبًا {name}",
    "Hello {name}": "مرحبًا {name}",
    "onboarding.encouragement": "أنشئ المنصة التي تتمنى وجودها.",
    "Build the platform you wish existed.": "أنشئ المنصة التي تتمنى وجودها.",
    "onboarding.plan.personalized": "خطة إطلاق مخصصة",
    "Personalized launch plan": "خطة إطلاق مخصصة",
    "onboarding.plan.label": "خطة الإطلاق",
    "Launch plan": "خطة الإطلاق",
    "onboarding.plan.refining": "جارٍ تحسين مسارك…",
    "Refining your path…": "جارٍ تحسين مسارك…",
    "onboarding.plan.getting_ready": "يجري إعداد خطتك المخصصة.",
    "Your personalized plan is getting ready.": "يجري إعداد خطتك المخصصة.",
    "onboarding.checklist.preview": "معاينة قائمة التحقق",
    "Checklist preview": "معاينة قائمة التحقق",
    "onboarding.workspace.live": "مساحة العمل النشطة",
    "Live workspace": "مساحة العمل النشطة",
    "onboarding.workspace.no_tenant": "لا توجد مساحة عميل نشطة متصلة",
    "No live tenant connected": "لا توجد مساحة عميل نشطة متصلة",
    "onboarding.workspace.domain_pending": "النطاق قيد الانتظار",
    "Domain pending": "النطاق قيد الانتظار",
    "onboarding.progress.summary": "اكتمل {completed} من أصل {total} من إجراءات الإطلاق",
    "{completed} of {total} launch actions done": "اكتمل {completed} من أصل {total} من إجراءات الإطلاق",
    "onboarding.progress.auto_detected": "تم اكتشاف {count} تلقائيًا",
    "{count} auto-detected": "تم اكتشاف {count} تلقائيًا",
    "onboarding.progress.auto_detected_short": "تم اكتشافه تلقائيًا",
    "Auto-detected": "تم اكتشافه تلقائيًا",
    "onboarding.progress.saving": "جارٍ حفظ التقدم…",
    "Saving progress…": "جارٍ حفظ التقدم…",
    "onboarding.progress.checking": "جارٍ التحقق…",
    "Checking…": "جارٍ التحقق…",
    "onboarding.progress.mark_done": "تحديد كمكتمل",
    "Mark done": "تحديد كمكتمل",
    "onboarding.progress.unlocked": "تم إلغاء القفل: {impact}",
    "Unlocked: {impact}": "تم إلغاء القفل: {impact}",
    "onboarding.next_task": "أفضل مهمة تالية",
    "Next best task": "أفضل مهمة تالية",
    "onboarding.upcoming.title": "المهام القادمة",
    "Upcoming tasks": "المهام القادمة",
    "onboarding.upcoming.summary_one": "{count} مهمة بعد الإجراء الحالي.",
    "{count} task queued after the current action.": "{count} مهمة بعد الإجراء الحالي.",
    "onboarding.upcoming.summary_other": "{count} مهام بعد الإجراء الحالي.",
    "{count} tasks queued after the current action.": "{count} مهام بعد الإجراء الحالي.",
    "onboarding.upcoming.hide": "إخفاء المهام",
    "Hide tasks": "إخفاء المهام",
    "onboarding.upcoming.view_all": "عرض جميع المهام",
    "View all tasks": "عرض جميع المهام",
    "onboarding.complete.title": "بداية رائعة. أصبحت منصتك جاهزة.",
    "Great start. Your foundation is live.": "بداية رائعة. أصبحت منصتك جاهزة.",
    "onboarding.complete.description": "واصل لإتاحة أدوات النمو مثل العروض الترويجية والتواصل.",
    "Keep going to unlock growth essentials like promotions and communications.": "واصل لإتاحة أدوات النمو مثل العروض الترويجية والتواصل.",
    "onboarding.full_checklist.title": "قائمة التحقق الكاملة",
    "Full checklist": "قائمة التحقق الكاملة",
    "onboarding.full_checklist.description": "تابع الإعداد في التجربة نفسها.",
    "Continue setup in the same experience.": "تابع الإعداد في التجربة نفسها.",
    "onboarding.full_checklist.back": "العودة إلى مسار الإطلاق",
    "Back to launch path": "العودة إلى مسار الإطلاق",
    "onboarding.completed.title": "مكتمل",
    "onboarding.completed.summary_one": "اكتملت {count} مهمة",
    "{count} task completed": "اكتملت {count} مهمة",
    "onboarding.completed.summary_other": "اكتملت {count} مهام",
    "{count} tasks completed": "اكتملت {count} مهام",
    "onboarding.completed.open_again": "فتح مجددًا",
    "Open again": "فتح مجددًا",
    "onboarding.plan.marketplace.eyebrow": "مسار إطلاق السوق الإلكتروني",
    "Marketplace launch path": "مسار إطلاق السوق الإلكتروني",
    "onboarding.plan.marketplace.title": "أطلق سوقك الإلكتروني",
    "Launch your marketplace": "أطلق سوقك الإلكتروني",
    "onboarding.plan.marketplace.title_named": "حوّل {project} إلى سوق إلكتروني فعّال",
    "Turn {project} into a working marketplace": "حوّل {project} إلى سوق إلكتروني فعّال",
    "onboarding.plan.marketplace.subtitle": "افتح الموقع وأنشئ أول إعلان واختبر رحلة المشتري.",
    "Open the live site create the first listing and test the buyer journey.": "افتح الموقع وأنشئ أول إعلان واختبر رحلة المشتري.",
    "onboarding.plan.marketplace.value_moment": "أول قيمة: يمكن للبائع النشر وللمشتري التفاعل.",
    "First value moment: a seller can publish and a buyer can act.": "أول قيمة: يمكن للبائع النشر وللمشتري التفاعل.",
    "onboarding.plan.marketplace.why_title": "لماذا تُكمل الفرق هذه الخطوات",
    "Why teams finish this": "لماذا تُكمل الفرق هذه الخطوات",
    "onboarding.plan.marketplace.why_body": "تجعل نتائج المشترين والبائعين الحقيقية كل خطوة تالية مفيدة وتحافظ على الزخم.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "تجعل نتائج المشترين والبائعين الحقيقية كل خطوة تالية مفيدة وتحافظ على الزخم.",
    "onboarding.plan.store.eyebrow": "مسار إطلاق المتجر",
    "Store launch path": "مسار إطلاق المتجر",
    "onboarding.plan.store.title": "جهّز متجرك لاستقبال أول طلب",
    "Get your store ready for the first order": "جهّز متجرك لاستقبال أول طلب",
    "onboarding.plan.store.title_named": "جهّز {project} لاستقبال أول طلب",
    "Make {project} ready for the first order": "جهّز {project} لاستقبال أول طلب",
    "onboarding.plan.store.subtitle": "أضف منتجًا وتحقق من واجهة المتجر وأكمل أساسيات الدفع.",
    "Add a product check the storefront and complete checkout essentials.": "أضف منتجًا وتحقق من واجهة المتجر وأكمل أساسيات الدفع.",
    "onboarding.plan.store.value_moment": "أول قيمة: يظهر المنتج ويمكن اختبار الدفع.",
    "First value moment: a product is visible and checkout can be tested.": "أول قيمة: يظهر المنتج ويمكن اختبار الدفع.",
    "onboarding.plan.store.why_title": "لماذا تُكمل الفرق هذه الخطوات",
    "onboarding.plan.store.why_body": "انتقل من المنتج إلى الدفع بسرعة لتصبح المتجر واقعيًا ويظل التقدم محفزًا.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "انتقل من المنتج إلى الدفع بسرعة لتصبح المتجر واقعيًا ويظل التقدم محفزًا.",
    "onboarding.plan.booking.eyebrow": "مسار إطلاق الحجوزات",
    "Booking launch path": "مسار إطلاق الحجوزات",
    "onboarding.plan.booking.title": "اجعل منصتك قابلة للحجز",
    "Make your platform bookable": "اجعل منصتك قابلة للحجز",
    "onboarding.plan.booking.title_named": "اجعل {project} قابلاً للحجز",
    "Make {project} bookable": "اجعل {project} قابلاً للحجز",
    "onboarding.plan.booking.subtitle": "أنشئ أول خدمة وافتح تجربة العميل واختبر الحجز.",
    "Create the first service open the customer experience and test a reservation.": "أنشئ أول خدمة وافتح تجربة العميل واختبر الحجز.",
    "onboarding.plan.booking.value_moment": "أول قيمة: يمكن للعميل طلب موعد أو فترة زمنية.",
    "First value moment: a customer can request a time or slot.": "أول قيمة: يمكن للعميل طلب موعد أو فترة زمنية.",
    "onboarding.plan.booking.why_title": "لماذا تُكمل الفرق هذه الخطوات",
    "onboarding.plan.booking.why_body": "تحقق من رحلة الحجز كاملة مبكرًا لتعزيز الثقة قبل التوسع.",
    "Validate the full booking journey early to build confidence before expanding.": "تحقق من رحلة الحجز كاملة مبكرًا لتعزيز الثقة قبل التوسع.",
    "onboarding.plan.digital.eyebrow": "مسار الإطلاق الرقمي",
    "Digital launch path": "مسار الإطلاق الرقمي",
    "onboarding.plan.digital.title": "ابدأ ببيع منتجاتك الرقمية",
    "Start selling your digital products": "ابدأ ببيع منتجاتك الرقمية",
    "onboarding.plan.digital.title_named": "جهّز {project} لبيع المنتجات الرقمية",
    "Make {project} ready to sell digital products": "جهّز {project} لبيع المنتجات الرقمية",
    "onboarding.plan.digital.subtitle": "ارفع منتجًا رقميًا وعاين رحلة العميل وتأكد من جاهزية الدفع.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "ارفع منتجًا رقميًا وعاين رحلة العميل وتأكد من جاهزية الدفع.",
    "onboarding.plan.digital.value_moment": "أول قيمة: يمكن للمشتري اكتشاف ملف وشراؤه.",
    "First value moment: a buyer can discover and purchase a file.": "أول قيمة: يمكن للمشتري اكتشاف ملف وشراؤه.",
    "onboarding.plan.digital.why_title": "لماذا تُكمل الفرق هذه الخطوات",
    "onboarding.plan.digital.why_body": "تحقق من الاكتشاف والشراء بسرعة ليصبح توسيع الكتالوج خطوة نحو النمو.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "تحقق من الاكتشاف والشراء بسرعة ليصبح توسيع الكتالوج خطوة نحو النمو.",
    "onboarding.plan.campaign.eyebrow": "مسار إطلاق الحملة",
    "Campaign launch path": "مسار إطلاق الحملة",
    "onboarding.plan.campaign.title": "أطلق منصة حملتك",
    "Launch your campaign platform": "أطلق منصة حملتك",
    "onboarding.plan.campaign.title_named": "جهّز {project} لاستقبال الداعمين",
    "Make {project} ready for supporters": "جهّز {project} لاستقبال الداعمين",
    "onboarding.plan.campaign.subtitle": "أنشئ حملة وعاين الصفحة العامة واختبر رحلة المساهمة.",
    "Create a campaign preview the public page and test the contribution journey.": "أنشئ حملة وعاين الصفحة العامة واختبر رحلة المساهمة.",
    "onboarding.plan.campaign.value_moment": "أول قيمة: يستطيع الداعم الفهم والمساهمة.",
    "First value moment: a supporter can understand and contribute.": "أول قيمة: يستطيع الداعم الفهم والمساهمة.",
    "onboarding.plan.campaign.why_title": "لماذا تُكمل الفرق هذه الخطوات",
    "onboarding.plan.campaign.why_body": "وضّح القصة وطريقة المساهمة مبكرًا ليتمكن الداعمون من الثقة والتفاعل.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "وضّح القصة وطريقة المساهمة مبكرًا ليتمكن الداعمون من الثقة والتفاعل.",
    "onboarding.plan.creator.eyebrow": "مسار إطلاق المبدع",
    "Creator launch path": "مسار إطلاق المبدع",
    "onboarding.plan.creator.title": "استعد للوصول إلى جمهورك الأول",
    "Get ready for your first audience": "استعد للوصول إلى جمهورك الأول",
    "onboarding.plan.creator.title_named": "جهّز {project} للوصول إلى جمهوره الأول",
    "Make {project} ready for its first audience": "جهّز {project} للوصول إلى جمهوره الأول",
    "onboarding.plan.creator.subtitle": "انشر عرضًا واضحًا وصمّم التجربة واجعل اكتشاف عملك ودعمه سهلًا.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "انشر عرضًا واضحًا وصمّم التجربة واجعل اكتشاف عملك ودعمه سهلًا.",
    "onboarding.plan.creator.value_moment": "أول قيمة: عملك ظاهر وجاهز للمشاركة.",
    "First value moment: your work is visible and ready to share.": "أول قيمة: عملك ظاهر وجاهز للمشاركة.",
    "onboarding.plan.creator.why_title": "لماذا تنجح هذه الطريقة",
    "Why this works": "لماذا تنجح هذه الطريقة",
    "onboarding.plan.creator.why_body": "ركّز على نشر شيء فعلي قبل إضافة المزيد من الأدوات أو التعقيد.",
    "Focus on publishing something real before adding more tools or complexity.": "ركّز على نشر شيء فعلي قبل إضافة المزيد من الأدوات أو التعقيد.",
    "onboarding.step.open_live_site.title": "افتح التجربة المباشرة",
    "Open the live experience": "افتح التجربة المباشرة",
    "onboarding.step.open_live_site.description": "ابدأ بما يراه العملاء. هذا يجعل المنتج واقعيًا قبل أن يصبح الإعداد مجردًا.",
    "onboarding.step.open_live_site.description_domain": "افتح {domain} وشاهد ما يراه عملاؤك. هذا يجعل المشروع واقعيًا قبل الخطوة التالية.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "افتح {domain} وشاهد ما يراه عملاؤك. هذا يجعل المشروع واقعيًا قبل الخطوة التالية.",
    "onboarding.step.open_live_site.cta": "افتح الموقع",
    "Open site": "افتح الموقع",
    "onboarding.step.open_live_site.cta_domain": "افتح {domain}",
    "Open {domain}": "افتح {domain}",
    "onboarding.step.open_live_site.impact": "يؤكد أن المشروع يعمل بالفعل.",
    "onboarding.step.create_supply_shape.title": "أنشئ أول فئة",
    "Create the first category": "أنشئ أول فئة",
    "onboarding.step.create_supply_shape.description": "وفّر نقطة بداية واضحة للبائعين والمشترين. تنظم الفئات عملية الاكتشاف.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "وفّر نقطة بداية واضحة للبائعين والمشترين. تنظم الفئات عملية الاكتشاف.",
    "onboarding.step.create_supply_shape.cta": "أضف فئة",
    "onboarding.step.create_supply_shape.impact": "يحوّل السوق الفارغ إلى مساحة قابلة للتصفح.",
    "Turns a blank marketplace into a browsable one.": "يحوّل السوق الفارغ إلى مساحة قابلة للتصفح.",
    "onboarding.step.post_first_listing.title": "انشر إعلانًا تجريبيًا",
    "Post one test listing": "انشر إعلانًا تجريبيًا",
    "onboarding.step.post_first_listing.description": "جرّب مسار البائع وانشر أول عنصر يمكن للمشترين الاطلاع عليه.",
    "Experience the seller path and publish the first item buyers can inspect.": "جرّب مسار البائع وانشر أول عنصر يمكن للمشترين الاطلاع عليه.",
    "onboarding.step.post_first_listing.cta": "انشر إعلانًا",
    "Post listing": "انشر إعلانًا",
    "onboarding.step.post_first_listing.impact": "ينشئ المعروض الذي يفعّل السوق.",
    "Creates supply the core marketplace activation event.": "ينشئ المعروض الذي يفعّل السوق.",
    "onboarding.step.test_buyer_action.title": "تصرّف كمشترٍ",
    "Act like a buyer": "تصرّف كمشترٍ",
    "onboarding.step.test_buyer_action.description": "تصفح وأبدِ اهتمامًا واختبر الطلب لترى تجربة العملاء.",
    "Browse add interest and test the order path to experience what customers will see.": "تصفح وأبدِ اهتمامًا واختبر الطلب لترى تجربة العملاء.",
    "onboarding.step.test_buyer_action.cta": "اختبر مسار المشتري",
    "Test buyer flow": "اختبر مسار المشتري",
    "onboarding.step.test_buyer_action.impact": "يتحقق من رحلة المشتري كاملة.",
    "Validates the buyer journey end to end.": "يتحقق من رحلة المشتري كاملة.",
    "onboarding.step.add_first_product.title": "أضف منتجًا فعليًا",
    "Add one real product": "أضف منتجًا فعليًا",
    "onboarding.step.add_first_product.description": "يساعد منتج مكتمل النظام على فهم كتالوجك أكثر من جولة طويلة في الإعدادات.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "يساعد منتج مكتمل النظام على فهم كتالوجك أكثر من جولة طويلة في الإعدادات.",
    "onboarding.step.add_first_product.cta": "أضف منتجًا",
    "Add product": "أضف منتجًا",
    "onboarding.step.add_first_product.impact": "ينشئ أول عنصر قابل للبيع.",
    "Creates the first sellable item.": "ينشئ أول عنصر قابل للبيع.",
    "onboarding.step.setup_payments.title": "اربط وسائل الدفع",
    "Connect payments": "اربط وسائل الدفع",
    "onboarding.step.setup_payments.description": "فعّل المعاملات ليتمكن المستخدمون من إتمام الشراء بسهولة.",
    "Enable real transactions so users can complete purchases without friction.": "فعّل المعاملات ليتمكن المستخدمون من إتمام الشراء بسهولة.",
    "onboarding.step.setup_payments.cta": "إعداد الدفع",
    "Set up payments": "إعداد الدفع",
    "onboarding.step.setup_payments.impact": "يفتح الطريق لتحقيق الإيرادات.",
    "onboarding.step.setup_delivery.title": "حدّد طريقة الشحن أو الخدمة",
    "Set shipping or service method": "حدّد طريقة الشحن أو الخدمة",
    "onboarding.step.setup_delivery.description": "حدّد طريقة تنفيذ الطلب ليكون الدفع واضحًا للمستخدمين.",
    "onboarding.step.setup_delivery.cta": "إعداد التوصيل",
    "Configure delivery": "إعداد التوصيل",
    "onboarding.step.setup_delivery.impact": "يوضح تنفيذ الطلب عند الدفع.",
    "Makes fulfillment clear at checkout.": "يوضح تنفيذ الطلب عند الدفع.",
    "onboarding.step.create_bookable_listing.title": "أنشئ عرضًا قابلاً للحجز",
    "Create one bookable offer": "أنشئ عرضًا قابلاً للحجز",
    "onboarding.step.create_bookable_listing.description": "أضف الخدمة أو الفعالية أو الإيجار أو الموعد الذي ينبغي حجزه أولًا.",
    "Add the service event rental or appointment customers should book first.": "أضف الخدمة أو الفعالية أو الإيجار أو الموعد الذي ينبغي حجزه أولًا.",
    "onboarding.step.create_bookable_listing.cta": "أنشئ عرضًا",
    "Create offer": "أنشئ عرضًا",
    "onboarding.step.create_bookable_listing.impact": "ينشئ أول وحدة قابلة للحجز.",
    "Creates the first bookable unit.": "ينشئ أول وحدة قابلة للحجز.",
    "onboarding.step.shape_details.title": "أضف تفاصيل الحجز",
    "Add booking details": "أضف تفاصيل الحجز",
    "onboarding.step.shape_details.description": "استخدم الفئات والحقول لجمع ما يحتاجه العملاء قبل الحجز.",
    "Use categories and fields to capture what customers need before they commit.": "استخدم الفئات والحقول لجمع ما يحتاجه العملاء قبل الحجز.",
    "onboarding.step.shape_details.cta": "إعداد الحقول",
    "Set up fields": "إعداد الحقول",
    "onboarding.step.shape_details.impact": "يسهّل مقارنة العرض ويعزز الثقة به.",
    "Makes the offer easier to compare and trust.": "يسهّل مقارنة العرض ويعزز الثقة به.",
    "onboarding.step.test_booking.title": "اختبر مسار العميل",
    "Test the customer path": "اختبر مسار العميل",
    "onboarding.step.test_booking.description": "افتح المسار العام وتحقق من انتقال العملاء من الاهتمام إلى الإجراء.",
    "Open the public flow and verify customers can move from interest to action.": "افتح المسار العام وتحقق من انتقال العملاء من الاهتمام إلى الإجراء.",
    "onboarding.step.test_booking.cta": "اختبر الحجز",
    "Test booking": "اختبر الحجز",
    "onboarding.step.test_booking.impact": "يتحقق من رحلة الحجز.",
    "Validates the booking journey.": "يتحقق من رحلة الحجز.",
    "onboarding.step.upload_digital_product.title": "ارفع منتجًا رقميًا",
    "Upload one digital product": "ارفع منتجًا رقميًا",
    "onboarding.step.upload_digital_product.description": "أكمل أول عنصر قابل للتنزيل ليصبح جاهزًا للمعاينة والبيع.",
    "Make the first downloadable item complete enough to preview and sell.": "أكمل أول عنصر قابل للتنزيل ليصبح جاهزًا للمعاينة والبيع.",
    "onboarding.step.upload_digital_product.cta": "أضف منتجًا رقميًا",
    "Add digital product": "أضف منتجًا رقميًا",
    "onboarding.step.upload_digital_product.impact": "ينشئ أول أصل رقمي قابل للبيع.",
    "Creates your first sellable digital asset.": "ينشئ أول أصل رقمي قابل للبيع.",
    "onboarding.step.test_purchase.title": "اختبر مسار الشراء",
    "Test purchase flow": "اختبر مسار الشراء",
    "onboarding.step.test_purchase.description": "عاين ما يراه المشترون من الاكتشاف حتى الدفع.",
    "Preview what buyers see from discovery through checkout.": "عاين ما يراه المشترون من الاكتشاف حتى الدفع.",
    "onboarding.step.test_purchase.cta": "اختبر إتمام الشراء",
    "Test checkout": "اختبر إتمام الشراء",
    "onboarding.step.test_purchase.impact": "يؤكد رحلة المشتري.",
    "Confirms the buyer journey.": "يؤكد رحلة المشتري.",
    "onboarding.step.create_campaign.title": "أنشئ أول حملة",
    "Create the first campaign": "أنشئ أول حملة",
    "onboarding.step.create_campaign.description": "أضف الحملة أو القضية التي ينبغي للداعمين فهمها أولًا.",
    "Add the campaign or cause page supporters should understand first.": "أضف الحملة أو القضية التي ينبغي للداعمين فهمها أولًا.",
    "onboarding.step.create_campaign.cta": "أنشئ حملة",
    "Create campaign": "أنشئ حملة",
    "onboarding.step.create_campaign.impact": "ينشئ أول سبب للتفاعل علنًا.",
    "Creates the first public reason to act.": "ينشئ أول سبب للتفاعل علنًا.",
    "onboarding.step.setup_payments_campaign.title": "اربط مدفوعات المساهمة",
    "Connect contribution payments": "اربط مدفوعات المساهمة",
    "onboarding.step.setup_payments_campaign.description": "تكتسب رغبة الداعمين قيمة عندما يتمكنون من إتمام المساهمة.",
    "Supporter intent matters when they can complete a contribution.": "تكتسب رغبة الداعمين قيمة عندما يتمكنون من إتمام المساهمة.",
    "onboarding.step.setup_payments_campaign.cta": "إعداد الدفع",
    "onboarding.step.setup_payments_campaign.impact": "يتيح تلقي مساهمات فعلية.",
    "Enables real contributions.": "يتيح تلقي مساهمات فعلية.",
    "onboarding.step.test_supporter_flow.title": "اختبر مسار الداعم",
    "Test supporter flow": "اختبر مسار الداعم",
    "onboarding.step.test_supporter_flow.description": "افتح الرحلة العامة وتأكد من وضوح القصة والإجراء.",
    "Open the public journey and make sure the story and action are clear.": "افتح الرحلة العامة وتأكد من وضوح القصة والإجراء.",
    "onboarding.step.test_supporter_flow.cta": "اختبر المسار",
    "Test flow": "اختبر المسار",
    "onboarding.step.test_supporter_flow.impact": "يتحقق من المسار العام.",
    "Validates the public path.": "يتحقق من المسار العام.",
    "onboarding.step.set_account_categories.title": "حدّد فئات حسابات الموردين",
    "Define supplier account categories": "حدّد فئات حسابات الموردين",
    "onboarding.step.set_account_categories.description": "صنّف ملفات الموردين حسب النوع لتعزيز الثقة وتسهيل تصفح المشترين.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "صنّف ملفات الموردين حسب النوع لتعزيز الثقة وتسهيل تصفح المشترين.",
    "onboarding.step.set_account_categories.cta": "فئات الحسابات",
    "Account categories": "فئات الحسابات",
    "onboarding.step.set_account_categories.impact": "تم إنشاء هيكل الموردين.",
    "Supplier structure established.": "تم إنشاء هيكل الموردين.",
    "onboarding.step.set_account_attributes.title": "أضف سمات لملف المورد",
    "Add supplier profile attributes": "أضف سمات لملف المورد",
    "onboarding.step.set_account_attributes.description": "اجمع التفاصيل التي يحتاجها المشترون قبل التواصل مع الموردين أو الطلب منهم.",
    "Capture details buyers need before contacting or ordering from suppliers.": "اجمع التفاصيل التي يحتاجها المشترون قبل التواصل مع الموردين أو الطلب منهم.",
    "onboarding.step.set_account_attributes.cta": "سمات المورد",
    "Supplier attributes": "سمات المورد",
    "onboarding.step.set_account_attributes.impact": "يعزز ثقة المشترين.",
    "Higher buyer confidence.": "يعزز ثقة المشترين.",
    "onboarding.step.add_promotion.title": "أضف عرضًا ترويجيًا للإطلاق",
    "Add a launch promotion": "أضف عرضًا ترويجيًا للإطلاق",
    "onboarding.step.add_promotion.description": "أنشئ أول عرض ترويجي لتشجيع التفاعل في الزيارة الأولى.",
    "Create your first promotion to encourage action during the first visit.": "أنشئ أول عرض ترويجي لتشجيع التفاعل في الزيارة الأولى.",
    "onboarding.step.add_promotion.cta": "أضف عرضًا ترويجيًا",
    "Add promotion": "أضف عرضًا ترويجيًا",
    "onboarding.step.add_promotion.impact": "يعزز التحويل عند الإطلاق.",
    "Strengthens launch conversion.": "يعزز التحويل عند الإطلاق.",
    "onboarding.step.create_coupon.title": "أنشئ أول قسيمة",
    "Create your first coupon": "أنشئ أول قسيمة",
    "onboarding.step.create_coupon.description": "اختبر الخصومات للمشترين الجدد أو الأعضاء.",
    "Test discounts for first-time buyers or members.": "اختبر الخصومات للمشترين الجدد أو الأعضاء.",
    "onboarding.step.create_coupon.cta": "أنشئ قسيمة",
    "Create coupon": "أنشئ قسيمة",
    "onboarding.step.create_coupon.impact": "يفتح دورة العرض الأولى.",
    "Unlocks your first offer loop.": "يفتح دورة العرض الأولى.",
    "onboarding.step.collections_setup.title": "أنشئ مجموعة",
    "Create a collection": "أنشئ مجموعة",
    "onboarding.step.collections_setup.description": "نظّم الإعلانات المهمة لتحسين الاكتشاف والتصفح.",
    "Organize important listings to improve discovery and browsing.": "نظّم الإعلانات المهمة لتحسين الاكتشاف والتصفح.",
    "onboarding.step.collections_setup.cta": "أنشئ مجموعة",
    "Create collection": "أنشئ مجموعة",
    "onboarding.step.collections_setup.impact": "يحسن التصفح والاكتشاف.",
    "Improves navigation and discovery.": "يحسن التصفح والاكتشاف.",
    "onboarding.step.configure_comms.title": "راجع قوالب التواصل",
    "Review communication templates": "راجع قوالب التواصل",
    "onboarding.step.configure_comms.description": "جهّز إشعارات التسجيل والطلبات قبل التوسع.",
    "Prepare signup and order notifications before growth.": "جهّز إشعارات التسجيل والطلبات قبل التوسع.",
    "onboarding.step.configure_comms.cta": "افتح التواصل",
    "Open communications": "افتح التواصل",
    "onboarding.step.configure_comms.impact": "يجهز التواصل مع العملاء.",
    "Prepares customer communications.": "يجهز التواصل مع العملاء.",
    "onboarding.step.customize_attributes.title": "أضف سمات للإعلانات",
    "Add listing attributes": "أضف سمات للإعلانات",
    "onboarding.step.customize_attributes.description": "أضف حقولًا منظمة لمساعدة المستخدمين على التصفية والمقارنة.",
    "onboarding.step.customize_attributes.cta": "أضف سمات",
    "Add attributes": "أضف سمات",
    "onboarding.step.customize_attributes.impact": "يسهّل مقارنة الإعلانات.",
    "Makes listings easier to compare.": "يسهّل مقارنة الإعلانات.",
    "onboarding.step.add_digital_asset.title": "أضف عنصرًا رقميًا آخر",
    "Add another digital item": "أضف عنصرًا رقميًا آخر",
    "onboarding.step.add_digital_asset.description": "وسّع الكتالوج ليتمكن المستخدمون من تقييم الجودة والتنوع.",
    "Expand the catalog so users can evaluate quality and assortment.": "وسّع الكتالوج ليتمكن المستخدمون من تقييم الجودة والتنوع.",
    "onboarding.step.add_digital_asset.cta": "أضف إعلانًا رقميًا",
    "Add digital listing": "أضف إعلانًا رقميًا",
    "onboarding.step.add_digital_asset.impact": "يعزز مصداقية الكتالوج الرقمي.",
    "Improves digital catalog credibility.": "يعزز مصداقية الكتالوج الرقمي.",
    "personal_assistant.title": "المساعد الشخصي",
    "Personal assistant": "المساعد الشخصي",
    "personal_assistant.heading": "طوّر منصتك خطوة بخطوة",
    "Grow your platform one step at a time": "طوّر منصتك خطوة بخطوة",
    "personal_assistant.subtitle": "مصمم لـ {launchType}. نرتب الإجراءات حسب الأثر والجاهزية.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "مصمم لـ {launchType}. نرتب الإجراءات حسب الأثر والجاهزية.",
    "personal_assistant.launch.store": "متجر",
    "a store": "متجر",
    "personal_assistant.launch.marketplace": "سوق إلكتروني",
    "a marketplace": "سوق إلكتروني",
    "personal_assistant.launch.booking": "منصة حجز",
    "a booking platform": "منصة حجز",
    "personal_assistant.launch.digital": "نشاط رقمي",
    "a digital business": "نشاط رقمي",
    "personal_assistant.launch.campaign": "منصة حملات",
    "a campaign platform": "منصة حملات",
    "personal_assistant.metric.tasks_completed": "المهام المكتملة",
    "Tasks completed": "المهام المكتملة",
    "personal_assistant.metric.recommendation_clicks": "النقرات على التوصيات",
    "Recommendation clicks": "النقرات على التوصيات",
    "personal_assistant.metric.completed_by_recommendation": "المكتملة عبر التوصيات",
    "Completed via recommendations": "المكتملة عبر التوصيات",
    "personal_assistant.metric.assist_rate": "معدل المساعدة",
    "Assist rate": "معدل المساعدة",
    "personal_assistant.personalizing": "جارٍ تخصيص توصياتك…",
    "Personalizing your recommendations…": "جارٍ تخصيص توصياتك…",
    "personal_assistant.do_this_now": "نفّذ هذا الآن",
    "Do this now": "نفّذ هذا الآن",
    "personal_assistant.estimated_time": "المدة المقدرة: {minutes} د",
    "Estimated time: {minutes} min": "المدة المقدرة: {minutes} د",
    "personal_assistant.minutes_short": "{minutes} د",
    "{minutes} min": "{minutes} د",
    "personal_assistant.open": "فتح",
    "personal_assistant.mark_done": "تحديد كمكتمل",
    "personal_assistant.up_next": "التالي",
    "Up next": "التالي",
    "personal_assistant.coming_after": "يأتي بعد ذلك",
    "Coming after this": "يأتي بعد ذلك",
    "personal_assistant.completed_count": "مكتملة ({count})",
    "Completed ({count})": "مكتملة ({count})",
    "personal_assistant.hide": "إخفاء",
    "Hide": "إخفاء",
    "personal_assistant.show": "عرض",
    "personal_assistant.feature.open_live_site.name": "افتح التجربة المباشرة",
    "personal_assistant.feature.open_live_site.outcome": "تتحقق من قدرة العملاء على الوصول إلى المنصة.",
    "You confirm customers can reach the live platform.": "تتحقق من قدرة العملاء على الوصول إلى المنصة.",
    "personal_assistant.feature.create_supply_shape.name": "أنشئ أول فئة",
    "personal_assistant.feature.create_supply_shape.outcome": "يمكن للعملاء التصفح ضمن هيكل واضح.",
    "Customers can browse with a clear structure.": "يمكن للعملاء التصفح ضمن هيكل واضح.",
    "personal_assistant.feature.post_first_listing.name": "انشر إعلانًا تجريبيًا",
    "personal_assistant.feature.post_first_listing.outcome": "أصبح لدى المنصة أول معروض لتقييمه.",
    "The platform now has first supply to evaluate.": "أصبح لدى المنصة أول معروض لتقييمه.",
    "personal_assistant.feature.test_buyer_action.name": "تصرّف كمشترٍ",
    "personal_assistant.feature.test_buyer_action.outcome": "تتحقق من تجربة المشتري كاملة.",
    "You validate buyer-side experience end to end.": "تتحقق من تجربة المشتري كاملة.",
    "personal_assistant.feature.setup_payments.name": "اربط وسائل الدفع",
    "personal_assistant.feature.setup_payments.outcome": "يمكن للعملاء إتمام معاملات فعلية.",
    "Customers can complete real transactions.": "يمكن للعملاء إتمام معاملات فعلية.",
    "personal_assistant.feature.setup_delivery.name": "حدّد طريقة الشحن أو الخدمة",
    "personal_assistant.feature.setup_delivery.outcome": "يفهم العملاء بوضوح طريقة تنفيذ الطلب.",
    "Customers can understand fulfillment clearly.": "يفهم العملاء بوضوح طريقة تنفيذ الطلب.",
    "personal_assistant.feature.add_promotion.name": "أضف عرضًا ترويجيًا للإطلاق",
    "personal_assistant.feature.add_promotion.outcome": "تنشئ حافزًا مبكرًا للتحويل.",
    "You create an early conversion incentive.": "تنشئ حافزًا مبكرًا للتحويل.",
    "personal_assistant.feature.configure_comms.name": "راجع قوالب التواصل",
    "personal_assistant.feature.configure_comms.outcome": "يتلقى المستخدمون رسائل واضحة خلال مراحل تجربتهم.",
    "Users receive clear lifecycle communication.": "يتلقى المستخدمون رسائل واضحة خلال مراحل تجربتهم.",
    "personal_assistant.feature.view_orders.name": "افتح الطلبات",
    "Open orders": "افتح الطلبات",
    "personal_assistant.feature.view_orders.outcome": "يمكنك متابعة الطلبات الواردة ومعالجتها.",
    "You can monitor and process incoming demand.": "يمكنك متابعة الطلبات الواردة ومعالجتها.",
    "personal_assistant.feature.view_accounts.name": "افتح الحسابات",
    "Open accounts": "افتح الحسابات",
    "personal_assistant.feature.view_accounts.outcome": "يمكنك مراجعة الموردين أو الأعضاء بكفاءة.",
    "You can review suppliers or members efficiently.": "يمكنك مراجعة الموردين أو الأعضاء بكفاءة.",
    "personal_assistant.feature.configure_account_categories.name": "اضبط فئات الحسابات",
    "Configure account categories": "اضبط فئات الحسابات",
    "personal_assistant.feature.configure_account_categories.outcome": "يوضح هيكل الموردين والأعضاء عملية الانضمام ويعزز الثقة.",
    "Supplier and member structure is clearer for onboarding and trust.": "يوضح هيكل الموردين والأعضاء عملية الانضمام ويعزز الثقة.",
    "personal_assistant.feature.configure_account_attributes.name": "اضبط سمات الحساب",
    "Configure account attributes": "اضبط سمات الحساب",
    "personal_assistant.feature.configure_account_attributes.outcome": "تجمع الملفات المعلومات المهمة لاتخاذ قرارات الشراء.",
    "Profiles capture decision-critical info for buyers.": "تجمع الملفات المعلومات المهمة لاتخاذ قرارات الشراء.",
    "personal_assistant.feature.review_account_config.name": "راجع إعدادات الحساب",
    "Review account configuration": "راجع إعدادات الحساب",
    "personal_assistant.feature.review_account_config.outcome": "يتوافق سلوك الحسابات مع سياسات السوق.",
    "Account behavior matches your marketplace policy.": "يتوافق سلوك الحسابات مع سياسات السوق.",
    "personal_assistant.feature.view_listings.name": "افتح الإعلانات",
    "Open listings": "افتح الإعلانات",
    "personal_assistant.feature.view_listings.outcome": "يمكنك متابعة جودة الكتالوج وجاهزيته.",
    "You can monitor catalog quality and readiness.": "يمكنك متابعة جودة الكتالوج وجاهزيته.",
    "personal_assistant.feature.configure_listing_categories.name": "اضبط فئات الإعلانات",
    "Configure listing categories": "اضبط فئات الإعلانات",
    "personal_assistant.feature.configure_listing_categories.outcome": "يصبح التنقل في الكتالوج واكتشافه أسهل.",
    "The catalog becomes easier to navigate and discover.": "يصبح التنقل في الكتالوج واكتشافه أسهل.",
    "personal_assistant.feature.configure_listing_attributes.name": "اضبط سمات الإعلانات",
    "Configure listing attributes": "اضبط سمات الإعلانات",
    "personal_assistant.feature.configure_listing_attributes.outcome": "يمكن للمستخدمين مقارنة الإعلانات عبر تفاصيل منظمة.",
    "Users can compare listings with structured details.": "يمكن للمستخدمين مقارنة الإعلانات عبر تفاصيل منظمة.",
    "personal_assistant.feature.configure_variant_types.name": "اضبط أنواع المتغيرات",
    "Configure variant types": "اضبط أنواع المتغيرات",
    "personal_assistant.feature.configure_variant_types.outcome": "يدعم الكتالوج تنوع المنتجات والخدمات بوضوح.",
    "The catalog supports product and service variations clearly.": "يدعم الكتالوج تنوع المنتجات والخدمات بوضوح.",
    "personal_assistant.feature.review_listing_configs.name": "راجع خيارات الإعلانات الإضافية",
    "Review listing additional features": "راجع خيارات الإعلانات الإضافية",
    "personal_assistant.feature.review_listing_configs.outcome": "يتوافق سلوك الإعلانات مع نموذج التشغيل لديك.",
    "Listing behavior matches your operating model.": "يتوافق سلوك الإعلانات مع نموذج التشغيل لديك.",
    "personal_assistant.feature.manage_collections.name": "أدر المجموعات",
    "Manage collections": "أدر المجموعات",
    "personal_assistant.feature.manage_collections.outcome": "يسهل اكتشاف مسارات التصفح ذات النية العالية.",
    "High-intent browsing paths are easier to discover.": "يسهل اكتشاف مسارات التصفح ذات النية العالية.",
    "personal_assistant.feature.manage_coupons.name": "أدر القسائم",
    "Manage coupons": "أدر القسائم",
    "personal_assistant.feature.manage_coupons.outcome": "يمكنك تقديم عروض مستهدفة لتحفيز التفاعل.",
    "You can run targeted offers for activation.": "يمكنك تقديم عروض مستهدفة لتحفيز التفاعل.",
    "personal_assistant.feature.view_transactions.name": "اعرض المعاملات",
    "View transactions": "اعرض المعاملات",
    "personal_assistant.feature.view_transactions.outcome": "يمكن متابعة المدفوعات لتعزيز الثقة وإدارة العمليات.",
    "Payment activity can be monitored for trust and operations.": "يمكن متابعة المدفوعات لتعزيز الثقة وإدارة العمليات.",
    "personal_assistant.feature.view_users.name": "افتح المستخدمين",
    "Open users": "افتح المستخدمين",
    "personal_assistant.feature.view_users.outcome": "يمكنك متابعة جودة نمو العملاء والأعضاء.",
    "You can monitor customer and member growth quality.": "يمكنك متابعة جودة نمو العملاء والأعضاء.",
    "personal_assistant.feature.configure_user_attributes.name": "اضبط سمات المستخدم",
    "Configure user attributes": "اضبط سمات المستخدم",
    "personal_assistant.feature.configure_user_attributes.outcome": "يمكنك جمع بيانات الملف الشخصي لتحسين التفاعل.",
    "You can capture profile signals to improve engagement.": "يمكنك جمع بيانات الملف الشخصي لتحسين التفاعل.",
    "personal_assistant.feature.review_ratings.name": "راجع التقييمات والمراجعات",
    "Review ratings and reviews": "راجع التقييمات والمراجعات",
    "personal_assistant.feature.review_ratings.outcome": "تتم متابعة مؤشرات الثقة وتحسينها.",
    "Trust signals are monitored and improved.": "تتم متابعة مؤشرات الثقة وتحسينها.",
    "personal_assistant.feature.view_reports.name": "افتح التقارير",
    "Open reports": "افتح التقارير",
    "personal_assistant.feature.view_reports.outcome": "يمكنك متابعة الأداء باستخدام البيانات.",
    "You can track performance with a data view.": "يمكنك متابعة الأداء باستخدام البيانات.",
    "personal_assistant.feature.manage_media.name": "أدر مكتبة الوسائط",
    "Manage media library": "أدر مكتبة الوسائط",
    "personal_assistant.feature.manage_media.outcome": "يسهل الحفاظ على صور العلامة التجارية والإعلانات.",
    "Brand and listing visuals are easier to maintain.": "يسهل الحفاظ على صور العلامة التجارية والإعلانات.",
    "personal_assistant.feature.manage_reported_listings.name": "راجع الإعلانات المبلّغ عنها",
    "Review reported listings": "راجع الإعلانات المبلّغ عنها",
    "personal_assistant.feature.manage_reported_listings.outcome": "يمكن التعامل بسرعة مع المحتوى منخفض الجودة أو المشبوه.",
    "Risky or low-quality content can be handled quickly.": "يمكن التعامل بسرعة مع المحتوى منخفض الجودة أو المشبوه.",
    "personal_assistant.feature.app_customization.name": "خصّص تجربة التطبيق",
    "Customize app experience": "خصّص تجربة التطبيق",
    "personal_assistant.feature.app_customization.outcome": "تتوافق تجربة التطبيق مع علامتك التجارية.",
    "The mobile app experience aligns with your brand.": "تتوافق تجربة التطبيق مع علامتك التجارية.",
    "personal_assistant.feature.app_integrations.name": "اضبط تكاملات التطبيق",
    "Configure app integrations": "اضبط تكاملات التطبيق",
    "personal_assistant.feature.app_integrations.outcome": "تتصل خدمات المنصة الأساسية بسير عمل التطبيق.",
    "Core platform services connect with app workflows.": "تتصل خدمات المنصة الأساسية بسير عمل التطبيق.",
    "personal_assistant.feature.customize_strings.name": "خصّص نصوص الواجهة",
    "Customize interface text": "خصّص نصوص الواجهة",
    "personal_assistant.feature.customize_strings.outcome": "تتوافق نصوص المنتج مع جمهورك وأسلوبك.",
    "Product copy matches your audience and tone.": "تتوافق نصوص المنتج مع جمهورك وأسلوبك.",
    "personal_assistant.feature.review_settings_home.name": "افتح الإعدادات",
    "Open settings": "افتح الإعدادات",
    "personal_assistant.feature.review_settings_home.outcome": "يسهل العثور على الإعدادات اللازمة لعمليات الفريق.",
    "Configuration is easy to find for team operations.": "يسهل العثور على الإعدادات اللازمة لعمليات الفريق.",
    "personal_assistant.feature.configure_commission.name": "اضبط العمولات",
    "Configure commission": "اضبط العمولات",
    "personal_assistant.feature.configure_commission.outcome": "يتوافق تقاسم الإيرادات مع نموذج عملك.",
    "Revenue sharing aligns with your business model.": "يتوافق تقاسم الإيرادات مع نموذج عملك.",
    "personal_assistant.feature.configure_taxes.name": "اضبط الضرائب",
    "Configure taxes": "اضبط الضرائب",
    "personal_assistant.feature.configure_taxes.outcome": "تكون الأسعار واضحة عند الدفع وإعدادات الضرائب جاهزة.",
    "Checkout pricing is predictable and tax settings are ready.": "تكون الأسعار واضحة عند الدفع وإعدادات الضرائب جاهزة.",
    "personal_assistant.feature.configure_languages.name": "اضبط اللغات",
    "Configure languages": "اضبط اللغات",
    "personal_assistant.feature.configure_languages.outcome": "تدعم التجربة جمهورًا متعدد اللغات.",
    "The experience supports a multilingual audience.": "تدعم التجربة جمهورًا متعدد اللغات.",
    "personal_assistant.feature.configure_currency.name": "اضبط العملة",
    "Configure currency": "اضبط العملة",
    "personal_assistant.feature.configure_currency.outcome": "تتوافق الأسعار مع توقعات السوق المستهدف.",
    "Prices align with the expectations of your target market.": "تتوافق الأسعار مع توقعات السوق المستهدف.",
    "personal_assistant.feature.configure_countries.name": "اضبط البلدان",
    "Configure countries": "اضبط البلدان",
    "personal_assistant.feature.configure_countries.outcome": "يتم ضبط النطاق الجغرافي للإطلاق.",
    "Geographic coverage is controlled for launch.": "يتم ضبط النطاق الجغرافي للإطلاق.",
    "personal_assistant.feature.review_checkout_settings.name": "راجع إعدادات الدفع",
    "Review checkout settings": "راجع إعدادات الدفع",
    "personal_assistant.feature.review_checkout_settings.outcome": "أصبحت عملية الدفع أوضح وأكثر موثوقية.",
    "Checkout is cleaner and more reliable.": "أصبحت عملية الدفع أوضح وأكثر موثوقية.",
    "personal_assistant.feature.api_configuration.name": "راجع إعدادات API",
    "Review API configuration": "راجع إعدادات API",
    "personal_assistant.feature.api_configuration.outcome": "أصبحت عمليات التكامل ووصول المطورين جاهزة.",
    "Integrations and developer access are ready.": "أصبحت عمليات التكامل ووصول المطورين جاهزة.",
    "personal_assistant.feature.workspace_website_editor.name": "افتح محرر الموقع",
    "Open website editor": "افتح محرر الموقع",
    "personal_assistant.feature.workspace_website_editor.outcome": "يمكن تحسين واجهة المتجر لزيادة التحويل.",
    "The storefront can be refined for conversion.": "يمكن تحسين واجهة المتجر لزيادة التحويل.",
    "personal_assistant.feature.workspace_domain_setup.name": "راجع إعداد النطاق",
    "Review domain setup": "راجع إعداد النطاق",
    "personal_assistant.feature.workspace_domain_setup.outcome": "يعزز النطاق الواضح الثقة بالعلامة التجارية.",
    "A clean domain improves brand trust.": "يعزز النطاق الواضح الثقة بالعلامة التجارية.",
    "personal_assistant.feature.workspace_pages.name": "راجع صفحات الموقع",
    "Review site pages": "راجع صفحات الموقع",
    "personal_assistant.feature.workspace_pages.outcome": "تعزز صفحات الهبوط والمحتوى الأساسية ثقة المستخدمين.",
    "Core landing and content pages support user trust.": "تعزز صفحات الهبوط والمحتوى الأساسية ثقة المستخدمين.",
    "reports.title": "التقارير",
    "reports.metric.0": "المستخدمون",
    "reports.metric.1": "الحسابات",
    "reports.metric.2": "الإعلانات",
    "reports.metric.3": "الإعلانات المباعة",
    "Listings Sold": "الإعلانات المباعة",
    "reports.metric.4": "إجمالي المبيعات",
    "Total Sales": "إجمالي المبيعات",
    "reports.metric.5": "إجمالي الطلبات",
    "reports.metric.6": "إجمالي الأرباح",
    "Total Earnings": "إجمالي الأرباح",
    "reports.chart.activity": "نشاط السوق اليومي",
    "Daily marketplace activity": "نشاط السوق اليومي",
    "reports.chart.activity_description": "الإعلانات والمستخدمون الجدد بمرور الوقت",
    "Listings and new users over time": "الإعلانات والمستخدمون الجدد بمرور الوقت",
    "reports.chart.listings_monthly": "الإعلانات شهريًا",
    "Listings monthly": "الإعلانات شهريًا",
    "reports.chart.listings_daily": "الإعلانات يوميًا",
    "Listings daily": "الإعلانات يوميًا",
    "reports.chart.users_daily": "المستخدمون يوميًا",
    "Users daily": "المستخدمون يوميًا",
    "reports.chart.users_monthly": "المستخدمون شهريًا",
    "Users monthly": "المستخدمون شهريًا",
    "reports.series.listings": "الإعلانات",
    "reports.series.new_users": "المستخدمون الجدد",
    "New users": "المستخدمون الجدد",
    "reports.top_sold_listings": "الإعلانات الأكثر مبيعًا",
    "Top sold listings": "الإعلانات الأكثر مبيعًا",
    "reports.view_more_insights": "عرض مزيد من الإحصاءات",
    "View more insights": "عرض مزيد من الإحصاءات",
    "reports.ai.title": "تقارير المبيعات بالذكاء الاصطناعي",
    "AI sales reports": "تقارير المبيعات بالذكاء الاصطناعي",
    "reports.ai.generating": "جارٍ إنشاء التقارير…",
    "Generating reports…": "جارٍ إنشاء التقارير…",
    "reports.ai.value": "القيمة",
    "reports.ai.more_info": "معلومات إضافية حول {label}",
    "More information about {label}": "معلومات إضافية حول {label}",
    "reports.ai.saved_snapshot": "لقطة محفوظة",
    "Saved snapshot": "لقطة محفوظة",
    "reports.ai.no_data": "لا تتوفر بيانات",
    "No data available": "لا تتوفر بيانات",
    "reports.ai.showing_top": "عرض أول {shown} من أصل {total} نتيجة",
    "Showing the top {shown} of {total} results": "عرض أول {shown} من أصل {total} نتيجة",
    "reports.ai.saved_report": "تقرير ذكاء اصطناعي محفوظ",
    "Saved AI report": "تقرير ذكاء اصطناعي محفوظ",
    "reports.ai.template.country": "المبيعات حسب البلد",
    "Sales by country": "المبيعات حسب البلد",
    "reports.ai.template.state": "المبيعات حسب الولاية",
    "Sales by state": "المبيعات حسب الولاية",
    "reports.ai.template.city": "المبيعات حسب المدينة",
    "Sales by city": "المبيعات حسب المدينة",
    "reports.ai.template.category": "المبيعات حسب الفئة",
    "Sales by category": "المبيعات حسب الفئة",
    "reports.ai.template.country_all_time": "المبيعات حسب البلد (كل الفترات)",
    "Sales by country (all time)": "المبيعات حسب البلد (كل الفترات)",
    "reports.ai.template.top_listings_all_time": "الإعلانات الأكثر مبيعًا (كل الفترات)",
    "Top sold listings (all time)": "الإعلانات الأكثر مبيعًا (كل الفترات)",
    "reports.ai.template.listings_by_category_all_time": "الإعلانات حسب الفئة (كل الفترات)",
    "Listings by category (all time)": "الإعلانات حسب الفئة (كل الفترات)",
    "reports.search_table.title": "بحث الإعلانات",
    "Listing search": "بحث الإعلانات",
    "reports.search_table.phrase": "العبارة",
    "Phrase": "العبارة",
    "reports.search_table.result": "النتيجة",
    "reports.search_table.created_at": "تاريخ الإنشاء",
    "Created at": "تاريخ الإنشاء",
    "reports.search_table.user_first_name": "الاسم الأول للمستخدم",
    "User first name": "الاسم الأول للمستخدم",
    "reports.search_table.user_last_name": "اسم العائلة للمستخدم",
    "User last name": "اسم العائلة للمستخدم",
    "reports.search_table.user_email": "بريد المستخدم الإلكتروني",
    "User email": "بريد المستخدم الإلكتروني",
    "intelligence.title": "التحليلات",
    "intelligence.description": "أنشئ تقارير بالذكاء الاصطناعي واحفظ الرسوم وثبّت التقارير المفيدة في لوحة التحكم.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "أنشئ تقارير بالذكاء الاصطناعي واحفظ الرسوم وثبّت التقارير المفيدة في لوحة التحكم.",
    "intelligence.dashboard.label": "لوحة التحكم",
    "intelligence.dashboard.pinned_title": "عناصر التحليلات المثبتة",
    "Pinned intelligence widgets": "عناصر التحليلات المثبتة",
    "intelligence.dashboard.pinned_count": "{count} مثبت",
    "{count} pinned": "{count} مثبت",
    "intelligence.dashboard.empty": "ثبّت التقارير المحفوظة لإنشاء لوحة تحكم قابلة لإعادة الاستخدام.",
    "Pin saved reports to build a reusable dashboard grid.": "ثبّت التقارير المحفوظة لإنشاء لوحة تحكم قابلة لإعادة الاستخدام.",
    "intelligence.action.open": "فتح",
    "intelligence.action.pin": "تثبيت",
    "Pin": "تثبيت",
    "intelligence.action.unpin": "إلغاء التثبيت",
    "Unpin": "إلغاء التثبيت",
    "intelligence.action.generate": "إنشاء",
    "intelligence.action.save_snapshot": "حفظ لقطة",
    "Save snapshot": "حفظ لقطة",
    "intelligence.action.discard_draft": "تجاهل المسودة",
    "Discard draft": "تجاهل المسودة",
    "intelligence.action.load": "تحميل",
    "Load": "تحميل",
    "intelligence.action.refresh": "تحديث",
    "intelligence.action.delete": "حذف",
    "intelligence.table.no_rows": "لم يتم إرجاع صفوف منظمة لهذا التقرير.",
    "No structured rows were returned for this report.": "لم يتم إرجاع صفوف منظمة لهذا التقرير.",
    "intelligence.table.no_rows_short": "لا توجد صفوف متاحة.",
    "No rows available.": "لا توجد صفوف متاحة.",
    "intelligence.field.template": "قالب التقرير",
    "Report template": "قالب التقرير",
    "intelligence.field.date_filter": "مرشح التاريخ",
    "Date filter": "مرشح التاريخ",
    "intelligence.field.prompt": "معاينة الطلب",
    "Prompt preview": "معاينة الطلب",
    "intelligence.field.report_name": "اسم التقرير",
    "Report name": "اسم التقرير",
    "intelligence.field.report_name_placeholder": "مثال: المنتجات الأكثر مبيعًا – آخر 30 يومًا",
    "For example: Top Selling Products – Last 30 Days": "مثال: المنتجات الأكثر مبيعًا – آخر 30 يومًا",
    "intelligence.field.chart": "رسم بياني",
    "Chart": "رسم بياني",
    "intelligence.field.prompt_label": "الطلب",
    "Prompt": "الطلب",
    "intelligence.date.relative": "نسبي",
    "Relative": "نسبي",
    "intelligence.date.absolute": "محدد",
    "Absolute": "محدد",
    "intelligence.date.last_n_days": "آخر N يومًا",
    "Last N days": "آخر N يومًا",
    "intelligence.date.last_days": "آخر {days} يومًا",
    "Last {days} days": "آخر {days} يومًا",
    "intelligence.date.from": "من",
    "From": "من",
    "intelligence.date.to": "إلى",
    "To": "إلى",
    "intelligence.saved_reports.title": "التقارير المحفوظة",
    "Saved reports": "التقارير المحفوظة",
    "intelligence.saved_reports.empty": "لا توجد تقارير تحليلات محفوظة بعد.",
    "No saved intelligence reports yet.": "لا توجد تقارير تحليلات محفوظة بعد.",
    "intelligence.active_report": "التقرير النشط",
    "Active report": "التقرير النشط",
    "intelligence.no_report_selected": "لم يتم تحديد تقرير",
    "No report selected": "لم يتم تحديد تقرير",
    "intelligence.active_report.empty_description": "أنشئ تقريرًا أو حمّل تقريرًا محفوظًا لفحص البيانات.",
    "Generate a report or load a saved one to inspect the data.": "أنشئ تقريرًا أو حمّل تقريرًا محفوظًا لفحص البيانات.",
    "intelligence.chart.value": "القيمة",
    "intelligence.chart.unknown": "غير معروف",
    "intelligence.chart_type.bar": "أعمدة",
    "Barres": "أعمدة",
    "intelligence.chart_type.line": "خطي",
    "Line": "خطي",
    "intelligence.chart_type.area": "مساحة",
    "Area": "مساحة",
    "intelligence.chart_type.pie": "دائري",
    "Pie": "دائري",
    "intelligence.chart.no_rows": "لم يُرجع هذا التقرير صفوفًا لعرضها.",
    "This report did not return rows to plot.": "لم يُرجع هذا التقرير صفوفًا لعرضها.",
    "intelligence.empty_report": "استخدم القالب وعناصر التحكم بالتاريخ لإنشاء تقرير منظم ثم احفظه وثبّته في لوحة التحكم.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "استخدم القالب وعناصر التحكم بالتاريخ لإنشاء تقرير منظم ثم احفظه وثبّته في لوحة التحكم.",
    "intelligence.error.update": "تعذر تحديث التقرير المحفوظ.",
    "Unable to update the saved report.": "تعذر تحديث التقرير المحفوظ.",
    "intelligence.error.prompt_required": "أدخل طلبًا لإنشاء تقرير.",
    "Enter a prompt to generate a report.": "أدخل طلبًا لإنشاء تقرير.",
    "intelligence.error.invalid_response": "لم تتضمن استجابة الذكاء الاصطناعي تقريرًا منسقًا.",
    "The AI response did not include a normalized report.": "لم تتضمن استجابة الذكاء الاصطناعي تقريرًا منسقًا.",
    "intelligence.error.generate": "تعذر إنشاء التقرير الآن.",
    "Unable to generate the report right now.": "تعذر إنشاء التقرير الآن.",
    "intelligence.error.generate_before_save": "أنشئ تقريرًا قبل حفظه.",
    "Generate a report before saving.": "أنشئ تقريرًا قبل حفظه.",
    "intelligence.error.save": "تعذر حفظ التقرير.",
    "Unable to save the report.": "تعذر حفظ التقرير.",
    "intelligence.error.load": "تعذر تحميل التقرير المحفوظ.",
    "Unable to load the saved report.": "تعذر تحميل التقرير المحفوظ.",
    "intelligence.error.refresh": "تعذر تحديث التقرير المحفوظ.",
    "Unable to refresh the saved report.": "تعذر تحديث التقرير المحفوظ.",
    "intelligence.error.delete": "تعذر حذف التقرير المحفوظ.",
    "Unable to delete the saved report.": "تعذر حذف التقرير المحفوظ.",
    "intelligence.template.top_selling_products": "المنتجات الأكثر مبيعًا",
    "Top selling products": "المنتجات الأكثر مبيعًا",
    "intelligence.template.revenue_trend": "اتجاه الإيرادات",
    "Revenue trend": "اتجاه الإيرادات",
    "intelligence.template.low_stock_products": "منتجات منخفضة المخزون",
    "Low stock products": "منتجات منخفضة المخزون",
    "intelligence.template.top_categories_by_sales": "الفئات الأعلى مبيعًا",
    "Top categories by sales": "الفئات الأعلى مبيعًا",
    "intelligence.template.order_status_breakdown": "توزيع حالات الطلبات",
    "Order status breakdown": "توزيع حالات الطلبات",
    "intelligence.template.sales_by_day": "المبيعات حسب اليوم",
    "Sales by day": "المبيعات حسب اليوم",
    "intelligence.template.sales_by_country": "المبيعات حسب البلد",
    "intelligence.template.sales_by_state": "المبيعات حسب الولاية",
    "intelligence.template.sales_by_city": "المبيعات حسب المدينة",
    "intelligence.template.sales_by_category": "المبيعات حسب الفئة",
    "intelligence.template.sales_by_subcategory": "المبيعات حسب الفئة الفرعية",
    "Sales by subcategory": "المبيعات حسب الفئة الفرعية",
    "intelligence.prompt.top_selling_products.relative": "اعرض المنتجات الأكثر مبيعًا خلال آخر {days} يومًا",
    "Show me top selling products for the last {days} days": "اعرض المنتجات الأكثر مبيعًا خلال آخر {days} يومًا",
    "intelligence.prompt.top_selling_products.absolute": "اعرض المنتجات الأكثر مبيعًا من {from} إلى {to}",
    "Show me top selling products from {from} to {to}": "اعرض المنتجات الأكثر مبيعًا من {from} إلى {to}",
    "intelligence.prompt.revenue_trend.relative": "ما اتجاه إيراداتي خلال آخر {days} يومًا؟",
    "What is my revenue trend for the last {days} days?": "ما اتجاه إيراداتي خلال آخر {days} يومًا؟",
    "intelligence.prompt.revenue_trend.absolute": "ما اتجاه إيراداتي من {from} إلى {to}؟",
    "What is my revenue trend from {from} to {to}?": "ما اتجاه إيراداتي من {from} إلى {to}؟",
    "intelligence.prompt.low_stock_products": "اعرض المنتجات منخفضة المخزون",
    "Show me low stock products": "اعرض المنتجات منخفضة المخزون",
    "intelligence.prompt.top_categories_by_sales.relative": "اعرض الفئات الأعلى مبيعًا خلال آخر {days} يومًا",
    "Show me top categories by sales for the last {days} days": "اعرض الفئات الأعلى مبيعًا خلال آخر {days} يومًا",
    "intelligence.prompt.top_categories_by_sales.absolute": "اعرض الفئات الأعلى مبيعًا من {from} إلى {to}",
    "Show me top categories by sales from {from} to {to}": "اعرض الفئات الأعلى مبيعًا من {from} إلى {to}",
    "intelligence.prompt.order_status_breakdown.relative": "اعرض توزيع حالات الطلبات خلال آخر {days} يومًا",
    "Show me order status breakdown for the last {days} days": "اعرض توزيع حالات الطلبات خلال آخر {days} يومًا",
    "intelligence.prompt.order_status_breakdown.absolute": "اعرض توزيع حالات الطلبات من {from} إلى {to}",
    "Show me order status breakdown from {from} to {to}": "اعرض توزيع حالات الطلبات من {from} إلى {to}",
    "intelligence.prompt.sales_by_day.relative": "اعرض المبيعات اليومية خلال آخر {days} يومًا",
    "Show me sales by day for the last {days} days": "اعرض المبيعات اليومية خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_day.absolute": "اعرض المبيعات اليومية من {from} إلى {to}",
    "Show me sales by day from {from} to {to}": "اعرض المبيعات اليومية من {from} إلى {to}",
    "intelligence.prompt.sales_by_country.relative": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب البلد خلال آخر {days} يومًا",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب البلد خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_country.absolute": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب البلد من {from} إلى {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب البلد من {from} إلى {to}",
    "intelligence.prompt.sales_by_state.relative": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الولاية خلال آخر {days} يومًا",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الولاية خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_state.absolute": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الولاية من {from} إلى {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الولاية من {from} إلى {to}",
    "intelligence.prompt.sales_by_city.relative": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب المدينة خلال آخر {days} يومًا",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب المدينة خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_city.absolute": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب المدينة من {from} إلى {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب المدينة من {from} إلى {to}",
    "intelligence.prompt.sales_by_category.relative": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الرئيسية خلال آخر {days} يومًا",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الرئيسية خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_category.absolute": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الرئيسية من {from} إلى {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الرئيسية من {from} إلى {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الفرعية خلال آخر {days} يومًا",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الفرعية خلال آخر {days} يومًا",
    "intelligence.prompt.sales_by_subcategory.absolute": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الفرعية من {from} إلى {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "اعرض إجمالي إيرادات المبيعات وعدد الطلبات حسب الفئة الفرعية من {from} إلى {to}",
    "common.status.partial": "جزئي",
    "Partial": "جزئي",
    "common.status.dispatched": "تم الإرسال",
    "Dispatched": "تم الإرسال",
    "common.status.sale": "بيع",
    "Sale": "بيع",
    "common.status.transfer_in": "تحويل وارد",
    "Transfer in": "تحويل وارد",
    "common.status.transfer_out": "تحويل صادر",
    "Transfer out": "تحويل صادر",
    "common.status.return": "إرجاع",
    "Return": "إرجاع",
    "common.status.adjustment": "تسوية",
    "Adjustment": "تسوية",
    "common.status.receipt": "إيصال",
    "inventory.overview.title": "المخزون",
    "inventory.overview.tab.all": "كل المخزون",
    "All stock": "كل المخزون",
    "inventory.overview.tab.low": "مخزون منخفض",
    "Low stock": "مخزون منخفض",
    "inventory.overview.tab.expiring": "دفعات قاربت على الانتهاء",
    "Expiring batches": "دفعات قاربت على الانتهاء",
    "inventory.overview.manage_locations": "إدارة المواقع",
    "Manage locations": "إدارة المواقع",
    "inventory.overview.purchase_orders": "أوامر الشراء",
    "inventory.overview.operations": "العمليات",
    "Operations": "العمليات",
    "inventory.overview.adjust_stock": "تسوية المخزون",
    "Adjust stock": "تسوية المخزون",
    "inventory.overview.description": "عرض مباشر للمخزون في جميع مواقعك.",
    "A live view of stock across your locations.": "عرض مباشر للمخزون في جميع مواقعك.",
    "inventory.overview.adjustment_hint": "استخدم التسويات لتسجيل الجرد أو التلف أو المرتجعات أو أي تصحيحات أخرى.",
    "Use adjustments for counts, damage, returns, or other corrections.": "استخدم التسويات لتسجيل الجرد أو التلف أو المرتجعات أو أي تصحيحات أخرى.",
    "inventory.overview.units_on_hand": "الوحدات المتاحة",
    "Units on hand": "الوحدات المتاحة",
    "inventory.overview.one_stock_row": "صف مخزون واحد",
    "1 stock row": "صف مخزون واحد",
    "inventory.overview.stock_rows": "{count} صفوف مخزون",
    "{count} stock rows": "{count} صفوف مخزون",
    "inventory.overview.low_stock": "مخزون منخفض",
    "inventory.overview.reorder_point_hint": "عند نقطة إعادة الطلب أو أقل منها",
    "At or below reorder point": "عند نقطة إعادة الطلب أو أقل منها",
    "inventory.overview.expiring_soon": "قاربت على الانتهاء",
    "Expiring soon": "قاربت على الانتهاء",
    "inventory.overview.next_90_days": "خلال التسعين يومًا القادمة",
    "Within the next 90 days": "خلال التسعين يومًا القادمة",
    "inventory.overview.stock_value": "قيمة المخزون",
    "Stock value": "قيمة المخزون",
    "inventory.overview.one_active_location": "موقع نشط واحد",
    "1 active location": "موقع نشط واحد",
    "inventory.overview.active_locations": "{count} مواقع نشطة",
    "{count} active locations": "{count} مواقع نشطة",
    "inventory.overview.search": "البحث في المخزون",
    "Search inventory": "البحث في المخزون",
    "inventory.overview.search_placeholder": "ابحث عن منتج أو SKU أو موقع",
    "Search product, SKU, or location": "ابحث عن منتج أو SKU أو موقع",
    "inventory.overview.filter_location": "تصفية حسب الموقع",
    "Filter by location": "تصفية حسب الموقع",
    "inventory.overview.all_locations": "كل المواقع",
    "inventory.overview.empty.all": "لم يتم تسجيل أي مخزون بعد.",
    "No inventory stock has been recorded yet.": "لم يتم تسجيل أي مخزون بعد.",
    "inventory.overview.empty.low": "ممتاز — لا يوجد مخزون دون نقطة إعادة الطلب.",
    "Great — no stock is below its reorder point.": "ممتاز — لا يوجد مخزون دون نقطة إعادة الطلب.",
    "inventory.overview.empty.expiring": "لا توجد دفعات تنتهي خلال 90 يومًا.",
    "No batches are expiring within 90 days.": "لا توجد دفعات تنتهي خلال 90 يومًا.",
    "inventory.overview.adjust": "تسوية",
    "inventory.overview.adjust_title": "تسوية المخزون",
    "inventory.overview.adjust_description": "سجّل تصحيحًا مع ذكر السبب للحفاظ على موثوقية سجل المخزون.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "سجّل تصحيحًا مع ذكر السبب للحفاظ على موثوقية سجل المخزون.",
    "inventory.overview.save_adjustment": "حفظ التسوية",
    "inventory.overview.listing_id": "المعرّف {id}",
    "inventory.overview.unassigned": "غير معيّن",
    "Unassigned": "غير معيّن",
    "inventory.overview.quantity_change": "تغيير الكمية",
    "Quantity change": "تغيير الكمية",
    "inventory.overview.quantity_placeholder": "مثال: 5 أو -2",
    "e.g. 5 or -2": "مثال: 5 أو -2",
    "inventory.overview.reason": "السبب",
    "inventory.overview.reason_placeholder": "جرد دوري، تلف، إرجاع…",
    "Cycle count, damage, return…": "جرد دوري، تلف، إرجاع…",
    "inventory.overview.reason.cycle_count": "جرد دوري",
    "Cycle count": "جرد دوري",
    "inventory.overview.reason.damage": "تلف",
    "Damage": "تلف",
    "inventory.overview.reason.return": "إرجاع",
    "inventory.overview.reason.stocktake": "جرد المخزون",
    "Stocktake": "جرد المخزون",
    "inventory.overview.note_placeholder": "سياق اختياري للشخص التالي",
    "Optional context for the next person": "سياق اختياري للشخص التالي",
    "inventory.overview.adjustment_saved": "تم حفظ تسوية المخزون",
    "Inventory adjustment saved": "تم حفظ تسوية المخزون",
    "inventory.overview.on_hand": "المتاح",
    "On hand": "المتاح",
    "inventory.overview.reorder_at": "إعادة الطلب عند",
    "Reorder at": "إعادة الطلب عند",
    "orders.create_order.payment_reference_missing": "تم إنشاء الطلب، ولكن لم يتم إرجاع مرجع للطلب.",
    "The order was created, but no order reference was returned.": "تم إنشاء الطلب، ولكن لم يتم إرجاع مرجع للطلب.",
    "orders.create_order.payment_domain_missing": "نطاق المستأجر غير متاح لروابط الدفع.",
    "The tenant domain is not available for payment links.": "نطاق المستأجر غير متاح لروابط الدفع.",
    "orders.create_order.payment_link_failed": "تعذر إنشاء رابط الدفع.",
    "Unable to create payment link.": "تعذر إنشاء رابط الدفع.",
    "orders.create_order.admin_session_expired": "انتهت جلسة المسؤول. يُرجى تسجيل الدخول مجددًا قبل إنشاء طلب.",
    "Your admin session has expired. Please sign in again before creating an order.": "انتهت جلسة المسؤول. يُرجى تسجيل الدخول مجددًا قبل إنشاء طلب.",
    "orders.create_order.user": "المستخدم",
    "orders.create_order.add_new_user": "إضافة مستخدم جديد",
    "Add New User": "إضافة مستخدم جديد",
    "orders.create_order.choose_existing_user": "اختيار مستخدم موجود",
    "Choose Existing User": "اختيار مستخدم موجود",
    "orders.create_order.preparing_customer": "جارٍ تجهيز العميل…",
    "Preparing customer…": "جارٍ تجهيز العميل…",
    "orders.create_order.select_user": "اختر مستخدمًا",
    "Select user": "اختر مستخدمًا",
    "orders.create_order.search_listing": "البحث عن إعلان",
    "Search Listing": "البحث عن إعلان",
    "orders.create_order.listings": "الإعلانات",
    "orders.create_order.no_image": "لا توجد صورة",
    "No image": "لا توجد صورة",
    "orders.create_order.add_to_cart": "أضف إلى السلة",
    "Add to Cart": "أضف إلى السلة",
    "orders.create_order.select_rental_dates": "حدّد تاريخي بدء الإيجار وانتهائه أولاً.",
    "Select rental start and end dates first.": "حدّد تاريخي بدء الإيجار وانتهائه أولاً.",
    "orders.create_order.rental_end_after_start": "يجب أن يكون تاريخ انتهاء الإيجار بعد تاريخ البدء.",
    "Rental end must be after the start date.": "يجب أن يكون تاريخ انتهاء الإيجار بعد تاريخ البدء.",
    "orders.create_order.cart_type_conflict": "لدى هذا العميل عناصر من نوع إعلان مختلف. أزلها من الدفع قبل إضافة هذا العنصر.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "لدى هذا العميل عناصر من نوع إعلان مختلف. أزلها من الدفع قبل إضافة هذا العنصر.",
    "orders.create_order.rental_period": "مدة الإيجار",
    "Rental period": "مدة الإيجار",
    "orders.create_order.select_start_end": "اختر تاريخي البدء والانتهاء",
    "Select start and end": "اختر تاريخي البدء والانتهاء",
    "orders.create_order.membership_no_shipping": "طلبات العضوية لا تتطلب شحنًا أو توصيلاً.",
    "Membership orders do not require shipping or delivery.": "طلبات العضوية لا تتطلب شحنًا أو توصيلاً.",
    "orders.create_order.preparing_payment_link": "جارٍ تجهيز رابط الدفع…",
    "Preparing payment link…": "جارٍ تجهيز رابط الدفع…",
    "orders.create_order.payment_link_ready": "رابط الدفع جاهز",
    "Payment link ready": "رابط الدفع جاهز",
    "orders.create_order.copy_payment_link": "نسخ رابط الدفع",
    "Copy payment link": "نسخ رابط الدفع",
    "orders.create_order.payment_method": "طريقة الدفع",
    "orders.create_order.no_payment_methods": "لم يتم إعداد طرق دفع نشطة لهذا المشروع.",
    "No active payment methods are configured for this project.": "لم يتم إعداد طرق دفع نشطة لهذا المشروع.",
    "orders.create_order.shipping_method": "طريقة الشحن",
    "orders.create_order.no_shipping_methods": "لم يتم إعداد طرق شحن نشطة لهذا المشروع.",
    "No active shipping methods are configured for this project.": "لم يتم إعداد طرق شحن نشطة لهذا المشروع.",
    "orders.create_order.shipping_address": "عنوان الشحن",
    "Shipping address": "عنوان الشحن",
    "orders.create_order.loading_addresses": "جارٍ تحميل العناوين المحفوظة…",
    "Loading saved addresses…": "جارٍ تحميل العناوين المحفوظة…",
    "orders.create_order.no_saved_shipping_address": "لا يملك هذا المستخدم عنوان شحن محفوظًا. أضف عنوانًا قبل إنشاء طلب توصيل.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "لا يملك هذا المستخدم عنوان شحن محفوظًا. أضف عنوانًا قبل إنشاء طلب توصيل.",
    "orders.create_order.no_items": "لا توجد عناصر",
    "No items": "لا توجد عناصر",
    "orders.create_order.cart_empty": "سلتك فارغة",
    "Your cart is empty": "سلتك فارغة",
    "orders.create_order.create_order": "إنشاء الطلب",
    "Create Order": "إنشاء الطلب",
    "orders.create_order.create_payment_link": "إنشاء رابط دفع",
    "Create payment link": "إنشاء رابط دفع",
    "orders.create_order.order_summary": "ملخص الطلب",
    "orders.create_order.coupon_value": "قيمة القسيمة",
    "Coupon value": "قيمة القسيمة",
    "orders.create_order.remove_coupon": "إزالة القسيمة",
    "Remove Coupon": "إزالة القسيمة",
    "orders.create_order.apply_coupon": "تطبيق القسيمة",
    "Apply Coupon": "تطبيق القسيمة",
    "orders.create_order.grand_amount": "المبلغ الإجمالي",
    "Grand Amount": "المبلغ الإجمالي",
    "orders.create_order.total": "الإجمالي",
    "orders.create_order.shipping": "الشحن",
    "Shipping": "الشحن",
    "orders.create_order.subtotal": "المجموع الفرعي",
    "Subtotal": "المجموع الفرعي",
    "orders.create_order.stock_unavailable": "المخزون غير متوفر",
    "Stock is not available": "المخزون غير متوفر",
    "orders.create_order.max_quantity": "الحد الأقصى للكمية هو {quantity}",
    "Max quantity is {quantity}": "الحد الأقصى للكمية هو {quantity}",
    "orders.create_order.items_in_cart": "العناصر في السلة",
    "Items in the cart": "العناصر في السلة",
    "orders.create_order.products_in_stock": "{count} منتجًا في المخزون",
    "{count} Products in Stock": "{count} منتجًا في المخزون",
    "orders.create_order.order_items": "عناصر الطلب",
    "Order Items": "عناصر الطلب",
    "orders.create_order.sold_by": "بواسطة {name}",
    "by {name}": "بواسطة {name}",
    "common.first_name": "الاسم الأول",
    "common.last_name": "اسم العائلة",
    "common.unlimited": "غير محدود",
    "unlimited": "غير محدود",
    "orders.reference": "المرجع",
    "orders.amount": "المبلغ",
    "orders.currency": "العملة",
    "orders.transaction_date": "تاريخ المعاملة",
    "Transaction Date": "تاريخ المعاملة",
    "orders.volume_this_page": "حجم هذه الصفحة",
    "Volume (this page)": "حجم هذه الصفحة",
    "orders.seller_entries": "معاملات البائع",
    "Seller Entries": "معاملات البائع",
    "orders.customer_entries": "معاملات العميل",
    "Customer Entries": "معاملات العميل",
    "orders.filter_transactions": "تصفية المعاملات",
    "Filter Transactions": "تصفية المعاملات",
    "orders.reset_filters": "إعادة تعيين عوامل التصفية",
    "Reset filters": "إعادة تعيين عوامل التصفية",
    "orders.manage_transactions": "إدارة معاملاتك",
    "Manage your Transactions": "إدارة معاملاتك",
    "orders.empty_transactions_message": "يمكنك هنا تتبع جميع المعاملات بين المستخدمين، مثل العمولات وأسعار الطلبات ورسوم الدفع والرسوم الخاصة وغيرها.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "يمكنك هنا تتبع جميع المعاملات بين المستخدمين، مثل العمولات وأسعار الطلبات ورسوم الدفع والرسوم الخاصة وغيرها.",
    "orders.super_type": "النوع الرئيسي",
    "Super Type": "النوع الرئيسي",
    "orders.exporting": "جارٍ التصدير…",
    "Exporting…": "جارٍ التصدير…",
    "orders.export_as_csv": "تصدير بصيغة CSV",
    "Export as CSV": "تصدير بصيغة CSV",
    "orders.search_transactions": "البحث في المعاملات",
    "Search transactions": "البحث في المعاملات",
    "orders.filter": "تصفية",
    "Filter": "تصفية",
    "orders.transaction_status": "حالة المعاملة",
    "Transaction Status": "حالة المعاملة",
    "orders.seller_protection_fee": "رسوم حماية البائع",
    "Seller Protection Fee": "رسوم حماية البائع",
    "common.show_rows": "عرض الصفوف",
    "common.clear_all": "مسح الكل",
    "Clear All": "مسح الكل",
    "orders.order_number_value": "الطلب رقم {number}",
    "orders.transactions": "المعاملات",
    "reported_listings.report_detail": "تفاصيل البلاغ",
    "Report Detail": "تفاصيل البلاغ",
    "reported_listings.reported_listing": "الإعلان المُبلّغ عنه",
    "Reported Listing": "الإعلان المُبلّغ عنه",
    "reported_listings.pending": "قيد الانتظار",
    "reported_listings.approved": "تمت الموافقة",
    "reported_listings.rejected": "مرفوض",
    "reported_listings.view_marketplace": "عرض في السوق",
    "View on marketplace": "عرض في السوق",
    "reported_listings.approve_listing": "الموافقة على الإعلان",
    "Approve listing": "الموافقة على الإعلان",
    "reported_listings.reject_listing": "رفض الإعلان",
    "Reject listing": "رفض الإعلان",
    "reported_listings.reported_by": "أبلغ عنه",
    "Reported By": "أبلغ عنه",
    "reported_listings.blocked": "محظور",
    "reported_listings.unblock_user": "إلغاء حظر المستخدم",
    "Unblock user": "إلغاء حظر المستخدم",
    "reported_listings.block_user": "حظر المستخدم",
    "Block user": "حظر المستخدم",
    "reported_listings.report_info": "معلومات البلاغ",
    "Report Info": "معلومات البلاغ",
    "reported_listings.reason": "السبب",
    "reported_listings.reported_on": "تاريخ البلاغ",
    "Reported on": "تاريخ البلاغ",
    "reported_listings.listing_id": "معرّف الإعلان",
    "reported_listings.reporter": "المُبلّغ",
    "Reporter": "المُبلّغ",
    "reported_listings.listing": "الإعلان",
    "reported_listings.status": "الحالة",
    "reported_listings.title": "الإعلانات المُبلّغ عنها",
    "reported_listings.report_count": "البلاغات: {count}",
    "Reports: {count}": "البلاغات: {count}",
    "reported_listings.empty_title": "عرض الإعلانات المُبلّغ عنها",
    "Viewing Reported listings": "عرض الإعلانات المُبلّغ عنها",
    "reported_listings.empty_message": "ستجد هنا الإعلانات التي أبلغ عنها المستخدمون",
    "You will find your users reported listings here": "ستجد هنا الإعلانات التي أبلغ عنها المستخدمون",
    "common.page_of": "الصفحة {page} من {total}",
    "Page {page} of {total}": "الصفحة {page} من {total}",
    "common.view": "عرض",
    "reviews.empty_title": "عرض التقييمات والمراجعات",
    "Viewing Rate & Reviews": "عرض التقييمات والمراجعات",
    "reviews.empty_message": "ستجد هنا تقييمات المستخدمين ومراجعاتهم",
    "You will find your users ratings and reviews here": "ستجد هنا تقييمات المستخدمين ومراجعاتهم",
    "reviews.list": "قائمة",
    "reviews.grid": "شبكة",
    "Grid": "شبكة",
    "reviews.title": "المراجعات والتقييمات",
    "reviews.review": "مراجعة",
    "reviews.name": "الاسم",
    "reviews.rating": "التقييم",
    "Rating": "التقييم",
    "reviews.title_column": "العنوان",
    "reviews.content": "المحتوى",
    "Content": "المحتوى",
    "reviews.image": "الصورة",
    "reviews.images": "الصور",
    "Images": "الصور",
    "reviews.accounts": "الحسابات",
    "reviews.listings": "الإعلانات",
    "reviews.star": "نجمة",
    "Star": "نجمة",
    "reviews.review_image": "صورة المراجعة",
    "Review image": "صورة المراجعة",
    "reviews.title_required": "العنوان مطلوب",
    "Title is required": "العنوان مطلوب",
    "reviews.content_required": "المحتوى مطلوب",
    "Content is required": "المحتوى مطلوب",
    "reviews.updated_successfully": "تم تحديث المراجعة بنجاح",
    "Review updated successfully": "تم تحديث المراجعة بنجاح",
    "reviews.edit_review": "تعديل المراجعة",
    "Edit Review": "تعديل المراجعة",
    "common.not_available": "غير متاح",
    "common.something_went_wrong": "حدث خطأ ما",
    "Something went wrong": "حدث خطأ ما",
    "media.load_failed": "تعذّر تحميل الوسائط.",
    "Unable to load media.": "تعذّر تحميل الوسائط.",
    "media.load_failed_retry": "تعذّر تحميل الوسائط. يُرجى المحاولة مرة أخرى.",
    "media.update_failed": "فشل تحديث الوسائط",
    "Media update failed": "فشل تحديث الوسائط",
    "media.renamed": "تمت إعادة تسمية الوسائط",
    "Media renamed": "تمت إعادة تسمية الوسائط",
    "media.moved": "تم نقل الوسائط",
    "Media moved": "تم نقل الوسائط",
    "media.rename_failed": "تعذّرت إعادة تسمية الوسائط",
    "Unable to rename media": "تعذّرت إعادة تسمية الوسائط",
    "media.move_failed": "تعذّر نقل الوسائط",
    "Unable to move media": "تعذّر نقل الوسائط",
    "media.deleted": "تم حذف الوسائط",
    "Media deleted": "تم حذف الوسائط",
    "media.delete_failed": "تعذّر حذف الوسائط",
    "Unable to delete media": "تعذّر حذف الوسائط",
    "media.confirm_delete": "هل تريد بالتأكيد حذف هذه الوسائط؟",
    "Are you sure you want to delete this media?": "هل تريد بالتأكيد حذف هذه الوسائط؟",
    "media.delete_media": "حذف الوسائط",
    "Delete media": "حذف الوسائط",
    "media.folder_creation_web_only": "إنشاء المجلدات متاح على الويب",
    "Folder creation is available on web": "إنشاء المجلدات متاح على الويب",
    "media.no_create_folder_permission": "ليس لديك إذن لإنشاء مجلدات",
    "You do not have permission to create folders": "ليس لديك إذن لإنشاء مجلدات",
    "media.folder_name": "اسم المجلد",
    "Folder name": "اسم المجلد",
    "media.folder_created": "تم إنشاء المجلد",
    "Folder created": "تم إنشاء المجلد",
    "media.folder_create_failed": "تعذّر إنشاء المجلد",
    "media.link_copied": "تم نسخ الرابط",
    "Link copied": "تم نسخ الرابط",
    "media.copy_link_failed": "تعذّر نسخ الرابط",
    "Unable to copy link": "تعذّر نسخ الرابط",
    "media.urls_copied": "تم نسخ {count} من الروابط",
    "{count} URLs copied": "تم نسخ {count} من الروابط",
    "media.clipboard_unavailable": "الحافظة غير متاحة",
    "Clipboard is not available": "الحافظة غير متاحة",
    "media.copy_urls_failed": "تعذّر نسخ الروابط",
    "Unable to copy URLs": "تعذّر نسخ الروابط",
    "media.upload_failed": "فشل تحميل الوسائط",
    "Media upload failed": "فشل تحميل الوسائط",
    "media.replace_success": "تم استبدال الوسائط. يظل معرّف الوسائط والرابط الثابت كما هما.",
    "Media replaced. The media ID and stable link are unchanged.": "تم استبدال الوسائط. يظل معرّف الوسائط والرابط الثابت كما هما.",
    "media.replace_failed": "تعذّر استبدال الوسائط",
    "Unable to replace media": "تعذّر استبدال الوسائط",
    "media.csv_upload_failed": "فشل تحميل ملف CSV",
    "CSV upload failed": "فشل تحميل ملف CSV",
    "media.csv_metadata_failed": "تعذّر حفظ بيانات CSV الوصفية",
    "Unable to save CSV metadata": "تعذّر حفظ بيانات CSV الوصفية",
    "media.csv_saved_version": "تم حفظ CSV كإصدار جديد",
    "CSV saved as a new version": "تم حفظ CSV كإصدار جديد",
    "media.csv_save_failed": "تعذّر حفظ ملف CSV",
    "Unable to save CSV": "تعذّر حفظ ملف CSV",
    "media.uploading_files": "جارٍ تحميل {count} ملفات…",
    "Uploading {count} files…": "جارٍ تحميل {count} ملفات…",
    "media.upload_progress": "جارٍ تحميل {count} ملفات · {progress}٪",
    "Uploading {count} files · {progress}%": "جارٍ تحميل {count} ملفات · {progress}٪",
    "media.upload_success": "تم تحميل {count} ملفات بنجاح.",
    "{count} files uploaded successfully.": "تم تحميل {count} ملفات بنجاح.",
    "media.upload_failed_retry": "تعذّر تحميل الوسائط. يُرجى المحاولة مرة أخرى.",
    "media.register_failed": "تعذّر تسجيل الوسائط",
    "media.list_view": "عرض القائمة",
    "List view": "عرض القائمة",
    "media.grid_view": "عرض الشبكة",
    "Grid view": "عرض الشبكة",
    "media.copy_uploaded_urls": "نسخ روابط الوسائط التي تم تحميلها",
    "Copy uploaded URLs": "نسخ روابط الوسائط التي تم تحميلها",
    "media.copy_visible_urls": "نسخ الروابط الظاهرة",
    "Copy visible URLs": "نسخ الروابط الظاهرة",
    "media.copy_all_urls": "نسخ جميع الروابط",
    "Copy all URLs": "نسخ جميع الروابط",
    "media.new_folder": "مجلد جديد",
    "New folder": "مجلد جديد",
    "media.uploading_progress": "جارٍ التحميل {progress}٪",
    "Uploading {progress}%": "جارٍ التحميل {progress}٪",
    "media.upload_media": "تحميل الوسائط",
    "media.manager_title": "مدير الوسائط",
    "Media Manager": "مدير الوسائط",
    "media.search": "البحث في الوسائط",
    "Search media": "البحث في الوسائط",
    "media.location": "الموقع",
    "media.media_root": "الوسائط",
    "media.show_type": "عرض وسائط {type}",
    "Show {type} media": "عرض وسائط {type}",
    "media.type_all": "الكل",
    "all": "الكل",
    "media.type_image": "صورة",
    "image": "صورة",
    "media.type_video": "فيديو",
    "video": "فيديو",
    "media.type_audio": "صوت",
    "audio": "صوت",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "مجلد",
    "folder": "مجلد",
    "media.sort_az": "أ–ي",
    "A–Z": "أ–ي",
    "media.oldest": "الأقدم",
    "Oldest": "الأقدم",
    "media.newest": "الأحدث",
    "Newest": "الأحدث",
    "media.sort_current": "ترتيب الوسائط، حاليًا: {sort}",
    "Sort media, currently {sort}": "ترتيب الوسائط، حاليًا: {sort}",
    "media.loading": "جارٍ تحميل الوسائط…",
    "Loading media…": "جارٍ تحميل الوسائط…",
    "media.no_filter_matches": "لا توجد وسائط تطابق عوامل التصفية هذه.",
    "No media matches these filters.": "لا توجد وسائط تطابق عوامل التصفية هذه.",
    "media.empty_title": "مكتبة الوسائط فارغة",
    "Your media library is empty": "مكتبة الوسائط فارغة",
    "media.empty_message": "حمّل الصور وملفات PDF والفيديو لإعادة استخدامها في العروض الترويجية والمقالات وغيرها.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "حمّل الصور وملفات PDF والفيديو لإعادة استخدامها في العروض الترويجية والمقالات وغيرها.",
    "media.empty_hint": "حمّل الملفات أو أنشئ مجلدًا للبدء.",
    "Upload files or create a folder to get started.": "حمّل الملفات أو أنشئ مجلدًا للبدء.",
    "media.folder": "مجلد",
    "Folder": "مجلد",
    "media.file_folder_name": "اسم الملف أو المجلد",
    "File or folder name": "اسم الملف أو المجلد",
    "media.rename_media": "إعادة تسمية الوسائط",
    "Rename media": "إعادة تسمية الوسائط",
    "media.move_media": "نقل الوسائط",
    "Move media": "نقل الوسائط",
    "media.pdf_preview": "معاينة PDF: {name}",
    "PDF preview: {name}": "معاينة PDF: {name}",
    "media.pdf_preview_web": "معاينة PDF متاحة في تطبيق الويب.",
    "PDF preview is available in the web app.": "معاينة PDF متاحة في تطبيق الويب.",
    "media.csv_preview_web": "معاينة CSV متاحة في تطبيق الويب.",
    "CSV preview is available in the web app.": "معاينة CSV متاحة في تطبيق الويب.",
    "media.media_file": "ملف وسائط",
    "Media file": "ملف وسائط",
    "media.share_link": "مشاركة الرابط",
    "Share link": "مشاركة الرابط",
    "media.copy_link": "نسخ الرابط",
    "Copy link": "نسخ الرابط",
    "media.replace_media": "استبدال الوسائط",
    "Replace media": "استبدال الوسائط",
    "media.folders": "المجلدات",
    "Folders": "المجلدات",
    "media.create_new_folder": "إنشاء مجلد جديد",
    "Create new folder": "إنشاء مجلد جديد",
    "media.go_to_all_media": "الانتقال إلى كل الوسائط",
    "Go to all media": "الانتقال إلى كل الوسائط",
    "media.all_media": "كل الوسائط",
    "All media": "كل الوسائط",
    "media.open_folder_name": "فتح المجلد {name}",
    "Open folder {name}": "فتح المجلد {name}",
    "media.no_subfolders": "لا توجد مجلدات فرعية",
    "No subfolders": "لا توجد مجلدات فرعية",
    "media.no_files_in_folder": "لا توجد ملفات في هذا المجلد.",
    "No files in this folder.": "لا توجد ملفات في هذا المجلد.",
    "media.upload_folder": "تحميل وسائط إلى هذا المجلد",
    "Upload media to this folder": "تحميل وسائط إلى هذا المجلد",
    "media.discard_csv_confirm": "هل تريد تجاهل تغييرات CSV؟",
    "Discard your CSV changes?": "هل تريد تجاهل تغييرات CSV؟",
    "media.unsaved_changes": "تغييرات غير محفوظة",
    "Unsaved changes": "تغييرات غير محفوظة",
    "media.find_csv": "البحث في CSV",
    "Find in CSV": "البحث في CSV",
    "media.save_csv": "حفظ CSV",
    "Save CSV": "حفظ CSV",
    "media.loading_csv": "جارٍ تحميل CSV…",
    "Loading CSV…": "جارٍ تحميل CSV…",
    "media.prepare_folder_failed": "تعذّر تجهيز مجلد التحميل",
    "Unable to prepare the upload folder": "تعذّر تجهيز مجلد التحميل",
    "media.add_file_required": "يرجى إضافة ملف",
    "Please add a file": "يرجى إضافة ملف",
    "media.add_media": "إضافة وسائط",
    "Add Media": "إضافة وسائط",
    "media.store_uploaded_media_in": "حفظ الوسائط التي تم تحميلها في",
    "Store uploaded media in": "حفظ الوسائط التي تم تحميلها في",
    "media.destination_business_cards": "بطاقات العمل",
    "Business Cards": "بطاقات العمل",
    "media.destination_listings": "الإعلانات",
    "media.destination_accounts": "الحسابات",
    "media.destination_users": "المستخدمون",
    "media.upload_media_title": "تحميل الوسائط",
    "media.media_files": "الوسائط",
    "media.open_folder": "فتح المجلد",
    "Open folder": "فتح المجلد",
    "common.show": "عرض",
    "common.share": "مشاركة",
    "Share": "مشاركة",
    "common.copy": "نسخ",
    "common.rename": "إعادة تسمية",
    "Rename": "إعادة تسمية",
    "common.move": "نقل",
    "Move": "نقل",
    "common.type": "النوع",
    "common.size": "الحجم",
    "Size": "الحجم",
    "common.preview": "معاينة",
    "Preview": "معاينة",
    "common.undo": "تراجع",
    "Undo": "تراجع",
    "common.redo": "إعادة",
    "Redo": "إعادة",
    "common.discard": "تجاهل",
    "Discard": "تجاهل",
    "common.try_again": "حاول مرة أخرى",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "جدول بيانات",
    "Spreadsheet": "جدول بيانات",
    "media.type_file": "ملف",
    "File": "ملف",
    "media.csv_load_failed": "تعذّر تحميل ملف CSV. يُرجى المحاولة مرة أخرى.",
    "Unable to load CSV. Please try again.": "تعذّر تحميل ملف CSV. يُرجى المحاولة مرة أخرى.",
    "workspace.settings_section.customisation": "التخصيص",
    "workspace.settings_section.integrations": "التكاملات",
    "workspace.settings_section.platform_setup": "إعداد المنصة",
    "Platform Setup": "إعداد المنصة",
    "workspace.settings_section.business_operations": "عمليات الأعمال",
    "Business Operations": "عمليات الأعمال",
    "workspace.settings_section.system_setup": "إعداد النظام",
    "System Setup": "إعداد النظام",
    "workspace.settings_item.app_customisation": "تخصيص التطبيق",
    "App Customisation": "تخصيص التطبيق",
    "workspace.settings_item.web_customisation": "تخصيص الويب",
    "workspace.settings_item.communications": "الاتصالات",
    "Communications": "الاتصالات",
    "workspace.settings_item.strings_customisation": "تخصيص النصوص",
    "Strings Customisation": "تخصيص النصوص",
    "workspace.settings_item.app_integrations": "تكاملات التطبيق",
    "workspace.settings_item.web_integrations": "تكاملات الويب",
    "Web Integrations": "تكاملات الويب",
    "workspace.settings_item.accounts": "الحسابات",
    "workspace.settings_item.listings": "الإعلانات",
    "workspace.settings_item.checkout_and_cart_attributes": "سمات الدفع والسلة",
    "workspace.settings_item.service_shipping": "الخدمة / الشحن",
    "workspace.settings_item.payments": "المدفوعات",
    "workspace.settings_item.commissions": "العمولات",
    "workspace.settings_item.taxes": "الضرائب",
    "workspace.settings_item.special_fees": "رسوم خاصة",
    "workspace.settings_item.languages": "اللغات",
    "workspace.settings_item.currency": "العملة",
    "workspace.settings_item.countries": "الدول",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "الإضافات",
    "Extensions": "الإضافات",
    "workspace.settings_item.manage_features": "إدارة الميزات",
    "Manage Features": "إدارة الميزات",
    "workspace.settings_item.audit_logs": "سجلات التدقيق",
    "Audit Logs": "سجلات التدقيق",
    "workspace.settings_item.auth": "المصادقة",
    "workspace.settings_item.maps": "الخرائط",
    "workspace.settings_hint.accounts": "مثال: متجر",
    "Example: Store": "مثال: متجر",
    "workspace.settings_hint.listings": "مثال: المنتجات والفعاليات",
    "Example: Products, Events": "مثال: المنتجات والفعاليات",
    "workspace.settings_hint.audit_logs": "سجل الامتثال والأمان",
    "Compliance & security trail": "سجل الامتثال والأمان",
    "workspace.settings_hint.auth": "Facebook وGoogle وTwilio",
    "Facebook, Google, Twilio": "Facebook وGoogle وTwilio",
    "workspace.settings_hint.maps": "استخدام المزوّد وإعدادات الخصوصية",
    "Provider usage and privacy settings": "استخدام المزوّد وإعدادات الخصوصية",
    "workspace.settings_access_denied": "ليس لديك صلاحية الوصول إلى {name}",
    "You don't have access of {name}": "ليس لديك صلاحية الوصول إلى {name}",
    "app_customization.title": "تخصيص التطبيق",
    "app_customization.tab_0": "عام",
    "General": "عام",
    "app_customization.tab_1": "شاشة البداية",
    "Splash": "شاشة البداية",
    "app_customization.tab_2": "التعريف بالتطبيق",
    "Onboarding": "التعريف بالتطبيق",
    "app_customization.tab_3": "التسجيل",
    "Registration": "التسجيل",
    "app_customization.tab_4": "الرئيسية",
    "Home": "الرئيسية",
    "app_customization.tab_5": "إشعار فوري",
    "Push Notification": "إشعار فوري",
    "app_customization.tab_6": "الدردشة",
    "Chat": "الدردشة",
    "app_customization.tab_7": "قائمة المزيد",
    "More Menu": "قائمة المزيد",
    "app_customization.tab_8": "تحديث إلزامي",
    "Force Update": "تحديث إلزامي",
    "app_customization.tab_9": "العنوان",
    "app_customization.hide_balances": "إخفاء الأرصدة والمدفوعات في قسم المزيد",
    "Hide balances & payouts in more section": "إخفاء الأرصدة والمدفوعات في قسم المزيد",
    "app_customization.more": "المزيد",
    "app_customization.force_update": "فرض التحديث",
    "Force To Update": "فرض التحديث",
    "app_customization.android_version": "إصدار تطبيق Android",
    "Android app version": "إصدار تطبيق Android",
    "app_customization.enter_android_version": "أدخل إصدار تطبيق Android",
    "Enter android app version": "أدخل إصدار تطبيق Android",
    "app_customization.ios_version": "إصدار تطبيق iOS",
    "iOS app version": "إصدار تطبيق iOS",
    "app_customization.enter_ios_version": "أدخل إصدار تطبيق iOS",
    "Enter iOS app version": "أدخل إصدار تطبيق iOS",
    "app_customization.chat": "الدردشة",
    "app_customization.chat_send_listing": "إرسال الإعلانات تلقائيًا عند فتح الدردشة (تُعرض المعاينة افتراضيًا)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "إرسال الإعلانات تلقائيًا عند فتح الدردشة (تُعرض المعاينة افتراضيًا)",
    "app_customization.make_offer": "تقديم عرض / تفاوض",
    "Make Offer / Negotiation": "تقديم عرض / تفاوض",
    "app_customization.negotiation_button_name": "اسم زر التفاوض:",
    "Negotiation button name:": "اسم زر التفاوض:",
    "app_customization.negotiation_button_example": "(مثال: تقديم عرض، تفاوض، عرض سعر)",
    "(example: Make Offer, Negotiate, Quote)": "(مثال: تقديم عرض، تفاوض، عرض سعر)",
    "app_customization.enter_negotiation_button_name": "أدخل اسم زر التفاوض",
    "Enter negotiation button name": "أدخل اسم زر التفاوض",
    "app_customization.address": "العنوان",
    "app_customization.address_option_0": "إظهار العنوان 2",
    "Show Address 2": "إظهار العنوان 2",
    "app_customization.address_option_1": "إظهار الدولة",
    "Show Country": "إظهار الدولة",
    "app_customization.address_option_2": "إظهار الرمز البريدي",
    "Show Zipcode": "إظهار الرمز البريدي",
    "app_customization.address_option_3": "إظهار الولاية",
    "Show State": "إظهار الولاية",
    "app_customization.address_option_4": "إظهار معلَم قريب",
    "Show Landmark": "إظهار معلَم قريب",
    "app_customization.address_option_5": "إظهار المدينة",
    "Show City": "إظهار المدينة",
    "app_customization.persistent_notification": "إشعار دائم",
    "Persistent Notification": "إشعار دائم",
    "app_customization.account_follow_content": "محتوى إشعار متابعة الحساب",
    "Account follow notification content": "محتوى إشعار متابعة الحساب",
    "app_customization.enter_account_follow_content": "أدخل محتوى إشعار متابعة الحساب",
    "Enter Account follow notification content": "أدخل محتوى إشعار متابعة الحساب",
    "app_customization.listing_like_content": "محتوى إشعار الإعجاب بالإعلان",
    "Listing like notification content": "محتوى إشعار الإعجاب بالإعلان",
    "app_customization.enter_listing_like_content": "أدخل محتوى إشعار الإعجاب بالإعلان",
    "Enter Listing like  notification content": "أدخل محتوى إشعار الإعجاب بالإعلان",
    "app_customization.order_status_content": "محتوى إشعار حالة الطلب",
    "Order status notification content": "محتوى إشعار حالة الطلب",
    "app_customization.enter_order_status_content": "أدخل محتوى إشعار حالة الطلب",
    "Order status follow notification content": "أدخل محتوى إشعار حالة الطلب",
    "app_customization.account_follow_required": "يجب أن يتضمن إشعار المتابعة {account_name}",
    "Account follow notification should contain {account_name}": "يجب أن يتضمن إشعار المتابعة {account_name}",
    "app_customization.listing_like_required": "يجب أن يتضمن إشعار الإعجاب {user_name}",
    "Listing like notification content should contain {user_name}": "يجب أن يتضمن إشعار الإعجاب {user_name}",
    "app_customization.order_number_required": "يجب أن يتضمن إشعار الطلب #{order_number}",
    "Order status notification content should contain #{order_number}": "يجب أن يتضمن إشعار الطلب #{order_number}",
    "app_customization.order_status_required": "يجب أن يتضمن إشعار الطلب {order_status}",
    "Order status notification content should contain {order_status}": "يجب أن يتضمن إشعار الطلب {order_status}",
    "app_customization.preview": "معاينة",
    "app_customization.splash": "شاشة البداية",
    "app_customization.splash_image": "صورة شاشة البداية",
    "Splash Screen Image": "صورة شاشة البداية",
    "app_customization.registration": "التسجيل",
    "app_customization.registration_text": "نص التسجيل",
    "Registration text": "نص التسجيل",
    "app_customization.otp_note": "ملاحظة التحقق برمز OTP",
    "OTP Verification note": "ملاحظة التحقق برمز OTP",
    "app_customization.get_signup_first": "إظهار التسجيل أولاً",
    "app_customization.mobile_in_email_signup": "رقم الهاتف عند التسجيل بالبريد الإلكتروني",
    "Mobile number in email signup": "رقم الهاتف عند التسجيل بالبريد الإلكتروني",
    "app_customization.preview_field_first_name": "الاسم الأول",
    "app_customization.preview_field_last_name": "اسم العائلة",
    "app_customization.preview_field_email": "البريد الإلكتروني",
    "app_customization.preview_field_password": "كلمة المرور",
    "Password": "كلمة المرور",
    "app_customization.preview_field_confirm_password": "تأكيد كلمة المرور",
    "Confirm Password": "تأكيد كلمة المرور",
    "app_customization.preview_field_dob": "تاريخ الميلاد",
    "DOB": "تاريخ الميلاد",
    "app_customization.preview_field_mobile_no": "رقم الهاتف",
    "Mobile No": "رقم الهاتف",
    "app_customization.create": "إنشاء",
    "app_customization.login": "تسجيل الدخول",
    "Login": "تسجيل الدخول",
    "app_customization.create_account": "أنشئ حسابك",
    "Create your account": "أنشئ حسابك",
    "app_customization.login_account": "سجّل الدخول إلى حسابك",
    "Login to your account": "سجّل الدخول إلى حسابك",
    "app_customization.onboarding_settings": "إعدادات التعريف بالتطبيق",
    "Onboarding Settings": "إعدادات التعريف بالتطبيق",
    "app_customization.onboarding_images": "صور التعريف بالتطبيق",
    "Onboarding Images": "صور التعريف بالتطبيق",
    "app_customization.onboarding_text_1": "نص التعريف 1",
    "Onboarding text 1": "نص التعريف 1",
    "app_customization.onboarding_text_2": "نص التعريف 2",
    "Onboarding text 2": "نص التعريف 2",
    "app_customization.onboarding_text_3": "نص التعريف 3",
    "Onboarding text 3": "نص التعريف 3",
    "app_customization.see_how_it_works": "شاهد طريقة العمل",
    "See how it works": "شاهد طريقة العمل",
    "app_customization.sell_icon_text": "نص أيقونة البيع",
    "Sell icon text": "نص أيقونة البيع",
    "app_customization.enter_sell_icon_text": "أدخل نص أيقونة البيع",
    "Enter sell icon text": "أدخل نص أيقونة البيع",
    "app_customization.sell_icon": "أيقونة البيع",
    "Sell Icon": "أيقونة البيع",
    "app_customization.enter_home_title": "أدخل عنوان التطبيق في الصفحة الرئيسية",
    "Enter app title in home": "أدخل عنوان التطبيق في الصفحة الرئيسية",
    "app_customization.app_details": "تفاصيل التطبيق",
    "App Details": "تفاصيل التطبيق",
    "app_customization.app_name": "اسم التطبيق",
    "App Name": "اسم التطبيق",
    "app_customization.primary_colour": "اللون الأساسي للتطبيق",
    "App Primary Colour": "اللون الأساسي للتطبيق",
    "app_customization.secondary_colour": "اللون الثانوي للتطبيق",
    "App Secondary Colour": "اللون الثانوي للتطبيق",
    "app_customization.android_app_icon": "أيقونة تطبيق Android",
    "App Icon Android": "أيقونة تطبيق Android",
    "app_customization.ios_app_icon": "أيقونة تطبيق iOS",
    "App Icon iOS": "أيقونة تطبيق iOS",
    "app_customization.screen_number": "الشاشة {number}",
    "Screen {number}": "الشاشة {number}",
    "app_customization.upload_here": "ارفع هنا",
    "Upload here": "ارفع هنا",
    "app_customization.next": "التالي",
    "app_customization.get_started": "ابدأ",
    "Get Start": "ابدأ",
    "app_customization.select": "اختيار",
    "app_customization.app_title_home_icon": "أيقونة عنوان التطبيق في الرئيسية",
    "App Title Home Icon": "أيقونة عنوان التطبيق في الرئيسية",
    "app_customization.home_icon_hint": "(يجب أن تكون الأيقونة بيضاء بصيغة PNG)",
    "(icon should be white and in png format)": "(يجب أن تكون الأيقونة بيضاء بصيغة PNG)",
    "app_customization.home_title": "عنوان التطبيق في الشاشة الرئيسية",
    "App title in home screen": "عنوان التطبيق في الشاشة الرئيسية",
    "app_customization.default_collection_widgets": "عناصر المجموعات الافتراضية",
    "Default Collection Widgets": "عناصر المجموعات الافتراضية",
    "app_customization.accounts_follow_title": "عنوان مجموعة الحسابات التي يمكن متابعتها",
    "Accounts to follow collection title": "عنوان مجموعة الحسابات التي يمكن متابعتها",
    "app_customization.enter_accounts_follow_title": "أدخل عنوان مجموعة الحسابات التي يمكن متابعتها",
    "Enter accounts to follow collection title": "أدخل عنوان مجموعة الحسابات التي يمكن متابعتها",
    "app_customization.nearby_accounts_title": "عنوان مجموعة الحسابات القريبة",
    "Nearby accounts collection title": "عنوان مجموعة الحسابات القريبة",
    "app_customization.enter_nearby_accounts_title": "أدخل عنوان مجموعة الحسابات القريبة",
    "Enter near by accounts collection title": "أدخل عنوان مجموعة الحسابات القريبة",
    "app_customization.latest_listings_title": "عنوان مجموعة أحدث الإعلانات",
    "Latest listings collection title": "عنوان مجموعة أحدث الإعلانات",
    "app_customization.enter_latest_listings_title": "أدخل عنوان مجموعة أحدث الإعلانات",
    "Enter latest listings collection title": "أدخل عنوان مجموعة أحدث الإعلانات",
    "app_customization.enable_appearance_sections": "اختر أقسام المظهر التي تريد تفعيلها",
    "Select to enable appearance sections": "اختر أقسام المظهر التي تريد تفعيلها",
    "app_customization.choose_photo": "اختر صورة",
    "Choose photo": "اختر صورة",
    "app_customization.choose_icon": "اختر أيقونة",
    "Choose icon": "اختر أيقونة",
    "app_customization.enable_home_icon": "استخدام أيقونة عنوان التطبيق بدلاً من النص",
    "app_customization.account_name": "اسم الحساب",
    "Account Name": "اسم الحساب",
    "app_customization.product_name": "اسم المنتج",
    "Product Name": "اسم المنتج",
    "app_customization.home_option_0": "إظهار مجموعة القريبين",
    "Show nearby collection": "إظهار مجموعة القريبين",
    "app_customization.home_option_1": "إظهار قسم الفئات",
    "Show category section": "إظهار قسم الفئات",
    "app_customization.home_option_2": "إظهار لافتات العروض",
    "Show promo banners": "إظهار لافتات العروض",
    "app_customization.home_option_3": "إظهار دعوة الأصدقاء",
    "Show invite friends": "إظهار دعوة الأصدقاء",
    "app_customization.home_option_4": "إظهار تذكيرات التقييم",
    "Show review reminders": "إظهار تذكيرات التقييم",
    "app_customization.home_option_5": "حسابات لمتابعتها",
    "Accounts to follow": "حسابات لمتابعتها",
    "app_customization.download": "تنزيل",
    "app_customization.cancel": "إلغاء",
    "app_customization.uploaded_successfully": "تم الرفع بنجاح",
    "app_customization.image_limit": "لا يمكنك اختيار مزيد من الصور",
    "app_customization.choose_zip_file": "اختر ملف ZIP",
    "Choose zip file": "اختر ملف ZIP",
    "app_translation.title": "تخصيص النصوص",
    "app_translation.search": "اكتب للبحث...",
    "Type to search...": "اكتب للبحث...",
    "app_translation.default_language": "الافتراضية",
    "app_translation.default_text": "النص الافتراضي",
    "Default text": "النص الافتراضي",
    "communications.title": "الاتصالات",
    "communications.tab_0": "إشعار البريد الإلكتروني",
    "Email Notification": "إشعار البريد الإلكتروني",
    "communications.tab_1": "إعدادات البريد الإلكتروني",
    "Email Configuration": "إعدادات البريد الإلكتروني",
    "communications.tab_2": "إشعار الطلب",
    "Order Notification": "إشعار الطلب",
    "communications.tab_3": "نموذج الملاحظات",
    "Feedback Form": "نموذج الملاحظات",
    "communications.translate": "ترجمة",
    "Translate": "ترجمة",
    "communications.edit_email_template": "تعديل قالب البريد الإلكتروني",
    "Edit email template": "تعديل قالب البريد الإلكتروني",
    "communications.feedback_email": "البريد الإلكتروني",
    "communications.feedback_phone": "الهاتف",
    "communications.feedback_email_or_phone": "البريد الإلكتروني أو الهاتف",
    "Email or Phone": "البريد الإلكتروني أو الهاتف",
    "communications.select_type": "اختر نوعًا",
    "communications.form_required_field": "حقل مطلوب في النموذج",
    "Form Required Field": "حقل مطلوب في النموذج",
    "communications.feedback_recipient_label": "البريد الإلكتروني لاستقبال الملاحظات (افصل بين العناوين المتعددة بفواصل)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "البريد الإلكتروني لاستقبال الملاحظات (افصل بين العناوين المتعددة بفواصل)",
    "communications.enter_email": "أدخل البريد الإلكتروني",
    "Enter email": "أدخل البريد الإلكتروني",
    "communications.enable_feedback_form": "تفعيل نموذج الملاحظات",
    "Enable feedback Form": "تفعيل نموذج الملاحظات",
    "communications.feedback": "ملاحظات",
    "Feedback": "ملاحظات",
    "communications.realtime_config_notice": "تُطبّق الإعدادات أدناه فورًا. عند إجراء التغييرات هنا والضغط على حفظ، ستظهر في التطبيقات واستجابات API.",
    "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.": "تُطبّق الإعدادات أدناه فورًا. عند إجراء التغييرات هنا والضغط على حفظ، ستظهر في التطبيقات واستجابات API.",
    "communications.uploaded_successfully": "تم الرفع بنجاح",
    "communications.email_whitelabeling": "تخصيص البريد الإلكتروني",
    "Email Whitelabelling": "تخصيص البريد الإلكتروني",
    "communications.from_name": "اسم المرسل",
    "From name": "اسم المرسل",
    "communications.enter_from_name": "أدخل اسم المرسل",
    "Enter from name": "أدخل اسم المرسل",
    "communications.from_email_address": "عنوان البريد الإلكتروني للمرسل",
    "From email address": "عنوان البريد الإلكتروني للمرسل",
    "communications.from_email_domain_hint": "لقد اخترت نطاقًا مخصصًا لعنوان البريد الإلكتروني للمرسل. لضمان وصول رسائلك، يرجى التحقق من نطاقك لدينا. تواصل مع فريق الدعم للمساعدة.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "لقد اخترت نطاقًا مخصصًا لعنوان البريد الإلكتروني للمرسل. لضمان وصول رسائلك، يرجى التحقق من نطاقك لدينا. تواصل مع فريق الدعم للمساعدة.",
    "communications.reset": "إعادة تعيين",
    "communications.enter_from_email": "أدخل عنوان البريد الإلكتروني للمرسل",
    "Enter from email address": "أدخل عنوان البريد الإلكتروني للمرسل",
    "communications.email_header_logo": "شعار رأس البريد الإلكتروني",
    "Email Header Logo": "شعار رأس البريد الإلكتروني",
    "communications.choose_logo": "اختر ملفًا 50×50",
    "Choose file 50*50": "اختر ملفًا 50×50",
    "communications.list_view": "عرض القائمة",
    "communications.gallery_view": "عرض المعرض",
    "Gallery view": "عرض المعرض",
    "communications.grid_view": "عرض الشبكة",
    "communications.search": "البحث في الاتصالات",
    "Search communications": "البحث في الاتصالات",
    "communications.email_settings": "إعدادات البريد الإلكتروني",
    "Email settings": "إعدادات البريد الإلكتروني",
    "communications.category_all": "الكل",
    "communications.category_buyer": "المشتري",
    "Buyer": "المشتري",
    "communications.category_seller": "البائع",
    "communications.category_transactional": "معاملاتي",
    "Transactional": "معاملاتي",
    "communications.category_engagement": "التفاعل",
    "Engagement": "التفاعل",
    "communications.category_retention": "الاحتفاظ",
    "Retention": "الاحتفاظ",
    "communications.category_membership": "العضوية",
    "communications.audience_buyer": "المشتري",
    "communications.audience_seller": "البائع",
    "communications.system_notification": "إشعار النظام",
    "System notification": "إشعار النظام",
    "communications.template": "قالب",
    "template": "قالب",
    "communications.edit": "تعديل",
    "communications.sent": "مرسلة",
    "sent": "مرسلة",
    "communications.open": "مفتوحة",
    "open": "مفتوحة",
    "communications.clicks": "نقرات",
    "clicks": "نقرات",
    "communications.no_email_matches": "لا توجد رسائل بريد إلكتروني تطابق هذا التصفية.",
    "No emails match your filter.": "لا توجد رسائل بريد إلكتروني تطابق هذا التصفية.",
    "communications.buyer_order_confirmation": "رسالة تأكيد الطلب للمشتري",
    "Order confirmation email for buyer": "رسالة تأكيد الطلب للمشتري",
    "communications.seller_order_confirmation": "رسالة تأكيد الطلب للبائع",
    "Order confirmation email for seller": "رسالة تأكيد الطلب للبائع",
    "communications.email_card_0": "رسالة ترحيب",
    "Welcome Message": "رسالة ترحيب",
    "communications.email_card_1": "رمز التحقق / OTP",
    "OTP / Verification": "رمز التحقق / OTP",
    "communications.email_card_2": "رابط الاشتراك",
    "Subscription Link": "رابط الاشتراك",
    "communications.email_card_3": "نجاح الاشتراك",
    "Subscription Success": "نجاح الاشتراك",
    "communications.email_card_4": "تأكيد الطلب — المشتري",
    "Order confirmation — buyer": "تأكيد الطلب — المشتري",
    "communications.email_card_5": "تأكيد الطلب — البائع",
    "Order confirmation — seller": "تأكيد الطلب — البائع",
    "communications.email_card_6": "تم شحن الطلب — المشتري",
    "Shipment shipped — buyer": "تم شحن الطلب — المشتري",
    "communications.email_card_7": "تم تسليم الشحنة — المشتري",
    "Shipment delivered — buyer": "تم تسليم الشحنة — المشتري",
    "communications.email_card_8": "إلغاء الطلب — المشتري",
    "Order cancelled — buyer": "إلغاء الطلب — المشتري",
    "communications.email_card_9": "تمت معالجة الاسترداد — المشتري",
    "Refund processed — buyer": "تمت معالجة الاسترداد — المشتري",
    "communications.email_card_10": "إعلان جديد من متجر متابَع — المشتري",
    "New listing from followed store — buyer": "إعلان جديد من متجر متابَع — المشتري",
    "communications.email_card_11": "عاد إلى المخزون — المشتري",
    "Back in stock — buyer": "عاد إلى المخزون — المشتري",
    "communications.email_card_12": "تنبيه انتهاء الإعلان — البائع",
    "Listing expiry warning — seller": "تنبيه انتهاء الإعلان — البائع",
    "communications.email_card_13": "إنجاز الإعجابات على الإعلان — البائع",
    "Listing likes milestone — seller": "إنجاز الإعجابات على الإعلان — البائع",
    "communications.email_card_14": "تم التحقق من الحساب — البائع",
    "Account verified — seller": "تم التحقق من الحساب — البائع",
    "communications.email_card_15": "استعادة نشاط البائع — البائع",
    "Seller win-back — seller": "استعادة نشاط البائع — البائع",
    "communications.email_card_16": "تنبيه انخفاض المخزون — البائع",
    "Low stock warning — seller": "تنبيه انخفاض المخزون — البائع",
    "communications.email_card_17": "انضمام البائع — البائع",
    "Seller onboarded — seller": "انضمام البائع — البائع",
    "communications.email_card_18": "طلب تقييم — المشتري",
    "Review request — buyer": "طلب تقييم — المشتري",
    "communications.email_card_19": "أول عملية بيع — البائع",
    "First sale — seller": "أول عملية بيع — البائع",
    "communications.email_card_20": "إنجاز المبيعات — البائع",
    "Sales milestone — seller": "إنجاز المبيعات — البائع",
    "communications.email_card_21": "استعادة نشاط المشتري — المشتري",
    "Win-back — buyer": "استعادة نشاط المشتري — المشتري",
    "communications.email_card_22": "أول عملية شراء — المشتري",
    "First purchase — buyer": "أول عملية شراء — المشتري",
    "communications.email_card_23": "سؤال العميل — البائع",
    "Customer question — seller": "سؤال العميل — البائع",
    "communications.email_card_24": "إجابة البائع — المشتري",
    "Seller answer — buyer": "إجابة البائع — المشتري",
    "communications.email_card_25": "عرض تفاوض — البائع",
    "Negotiation offer — seller": "عرض تفاوض — البائع",
    "communications.email_card_26": "تم قبول العرض — المشتري",
    "Offer accepted — buyer": "تم قبول العرض — المشتري",
    "communications.email_card_27": "تم رفض العرض — المشتري",
    "Offer rejected — buyer": "تم رفض العرض — المشتري",
    "communications.email_card_28": "متابع جديد — البائع",
    "New follower — seller": "متابع جديد — البائع",
    "communications.email_card_29": "إعجاب بالإعلان — البائع",
    "Listing liked — seller": "إعجاب بالإعلان — البائع",
    "communications.email_card_30": "تمت الموافقة على الإعلان — البائع",
    "Listing approved — seller": "تمت الموافقة على الإعلان — البائع",
    "communications.email_card_31": "تم رفض الإعلان — البائع",
    "Listing rejected — seller": "تم رفض الإعلان — البائع",
    "communications.email_card_32": "أول إعلان — البائع",
    "First listing — seller": "أول إعلان — البائع",
    "communications.email_card_33": "سلة متروكة — المشتري",
    "Abandoned cart — buyer": "سلة متروكة — المشتري",
    "communications.email_card_34": "مراجعة الإعلان — البائع",
    "Listing review — seller": "مراجعة الإعلان — البائع",
    "communications.email_card_35": "تذكير بتنفيذ الطلب — البائع",
    "Fulfillment reminder — seller": "تذكير بتنفيذ الطلب — البائع",
    "communications.email_card_36": "انخفاض السعر — المشتري",
    "Price drop — buyer": "انخفاض السعر — المشتري",
    "communications.email_card_37": "موعد دفع العضوية قريب",
    "Membership payment due soon": "موعد دفع العضوية قريب",
    "communications.email_card_38": "تأخر دفع العضوية",
    "Membership payment overdue": "تأخر دفع العضوية",
    "communications.order_status_notification": "إشعار حالة الطلب",
    "Order Status Notification": "إشعار حالة الطلب",
    "communications.order_group_lifecycle": "مراحل الطلب",
    "Order lifecycle": "مراحل الطلب",
    "communications.order_group_returns": "الإرجاعات ومشكلات التسليم",
    "Returns and delivery issues": "الإرجاعات ومشكلات التسليم",
    "communications.order_group_cancellations": "الإلغاء والاستلام",
    "Cancellations and pickup": "الإلغاء والاستلام",
    "communications.notification_settings_count": "{count} إعدادات إشعار",
    "{count} notification settings": "{count} إعدادات إشعار",
    "communications.enter_order_field": "أدخل {field}",
    "Enter {field}": "أدخل {field}",
    "communications.order_field_0": "تم تأكيد حالة الطلب",
    "Order status confirmed": "تم تأكيد حالة الطلب",
    "communications.order_field_1": "حالة الطلب قيد التنفيذ",
    "Order status in progress": "حالة الطلب قيد التنفيذ",
    "communications.order_field_2": "تم شحن الطلب",
    "Order status shipped": "تم شحن الطلب",
    "communications.order_field_3": "تعذر الوصول إلى العميل بشأن الطلب",
    "Order status customer unreachable": "تعذر الوصول إلى العميل بشأن الطلب",
    "communications.order_field_4": "الطلب خرج للتوصيل",
    "Order status out for delivery": "الطلب خرج للتوصيل",
    "communications.order_field_5": "تعذر تسليم الطلب وإرجاعه",
    "Order status undelivered returned": "تعذر تسليم الطلب وإرجاعه",
    "communications.order_field_6": "تم تأكيد إرجاع الطلب غير المسلّم",
    "Order status undelivered return confirmed": "تم تأكيد إرجاع الطلب غير المسلّم",
    "communications.order_field_7": "تم تسليم الطلب",
    "Order status delivered": "تم تسليم الطلب",
    "communications.order_field_8": "تم تأكيد تسليم الطلب",
    "Order status delivered confirmed": "تم تأكيد تسليم الطلب",
    "communications.order_field_9": "بدأ إرجاع العميل",
    "Order status customer return initiated": "بدأ إرجاع العميل",
    "communications.order_field_10": "تم استلام مرتجع العميل",
    "Order status customer return picked": "تم استلام مرتجع العميل",
    "communications.order_field_11": "تم تأكيد إرجاع العميل",
    "Order status customer return confirmed": "تم تأكيد إرجاع العميل",
    "communications.order_field_12": "تم الاعتراض على إرجاع العميل",
    "Order status customer return disputed": "تم الاعتراض على إرجاع العميل",
    "communications.order_field_13": "ألغى البائع الطلب",
    "Order status cancelled by account": "ألغى البائع الطلب",
    "communications.order_field_14": "ألغى العميل الطلب",
    "Order status cancelled by customer": "ألغى العميل الطلب",
    "communications.order_field_15": "الطلب جاهز للاستلام",
    "Order status ready for pickup": "الطلب جاهز للاستلام",
    "communications.order_field_16": "اكتمل الطلب",
    "Order status completed": "اكتمل الطلب",
    "communications.update": "تحديث",
    "communications.download_template": "تنزيل القالب",
    "Download Template": "تنزيل القالب",
    "communications.reset_to_default": "إعادة التعيين إلى الافتراضي",
    "Reset to default": "إعادة التعيين إلى الافتراضي",
    "communications.send_test_email": "إرسال بريد إلكتروني تجريبي",
    "Send test email": "إرسال بريد إلكتروني تجريبي",
    "communications.enter_test_emails": "أدخل عناوين البريد الإلكتروني مفصولة بفواصل",
    "Enter email(s), comma-separated": "أدخل عناوين البريد الإلكتروني مفصولة بفواصل",
    "communications.send_test": "إرسال اختبار",
    "Send test": "إرسال اختبار",
    "communications.subject_required": "يجب ألا يكون الموضوع فارغًا",
    "Subject should not be empty": "يجب ألا يكون الموضوع فارغًا",
    "communications.body_required": "يجب ألا يكون المحتوى فارغًا",
    "Body should not be empty": "يجب ألا يكون المحتوى فارغًا",
    "communications.code_merge_tag_required": "علامة الدمج {code} مطلوبة",
    "{code} merge tag is mandatory": "علامة الدمج {code} مطلوبة",
    "communications.edit_template_named": "تعديل {name}",
    "Edit {name}": "تعديل {name}",
    "communications.subject": "الموضوع",
    "Subject": "الموضوع",
    "communications.enter_subject": "أدخل الموضوع",
    "Enter the Subject": "أدخل الموضوع",
    "communications.available_merge_tags": "علامات الدمج المتاحة:",
    "Available merge tags:": "علامات الدمج المتاحة:",
    "communications.body": "المحتوى",
    "Body": "المحتوى",
    "communications.write_here": "اكتب هنا...",
    "Write here...": "اكتب هنا...",
    "communications.subject_line": "سطر الموضوع",
    "Subject Line": "سطر الموضوع",
    "communications.enter_subject_line": "أدخل الموضوع…",
    "Enter the subject…": "أدخل الموضوع…",
    "communications.merge_tags": "علامات الدمج",
    "Merge tags": "علامات الدمج",
    "communications.loading_templates": "جارٍ تحميل القوالب…",
    "Loading templates…": "جارٍ تحميل القوالب…",
    "communications.hide_templates": "إخفاء القوالب",
    "Hide templates": "إخفاء القوالب",
    "communications.load_template": "تحميل قالب",
    "Load template": "تحميل قالب",
    "communications.html_body": "محتوى HTML",
    "HTML Body": "محتوى HTML",
    "communications.enter_html_body": "الصق أو اكتب HTML هنا…",
    "Paste or type your HTML here…": "الصق أو اكتب HTML هنا…",
    "communications.live_preview": "معاينة مباشرة",
    "Live Preview": "معاينة مباشرة",
    "communications.desktop": "سطح المكتب",
    "Desktop": "سطح المكتب",
    "communications.mobile": "الهاتف المحمول",
    "communications.email_preview": "معاينة البريد الإلكتروني",
    "Email preview": "معاينة البريد الإلكتروني",
    "communications.start_typing_preview": "ابدأ الكتابة لعرض المعاينة",
    "Start typing to see a preview": "ابدأ الكتابة لعرض المعاينة",
    "communications.translations": "الترجمات",
    "translations": "الترجمات",
    "communications.validation_account_follow_tag": "يجب أن يتضمن إشعار المتابعة {account_name}",
    "communications.validation_listing_like_tag": "يجب أن يتضمن إشعار الإعجاب بالإعلان {user_name}",
    "Listing follow notification should contain {user_name}": "يجب أن يتضمن إشعار الإعجاب بالإعلان {user_name}",
    "communications.validation_order_number_tag": "يجب أن يتضمن إشعار حالة الطلب #{order_number}",
    "Order status follow notification should contain #{order_number}": "يجب أن يتضمن إشعار حالة الطلب #{order_number}",
    "communications.validation_order_status_tag": "يجب أن يتضمن إشعار حالة الطلب {order_status}",
    "Order status follow notification should contain {order_status}": "يجب أن يتضمن إشعار حالة الطلب {order_status}",
    "communications.journey_title": "خريطة رحلة البريد الإلكتروني",
    "Email Journey Map": "خريطة رحلة البريد الإلكتروني",
    "communications.journey_subtitle": "موعد إرسال كل بريد إلكتروني خلال رحلة المستخدم",
    "Where each email fires in the user lifecycle": "موعد إرسال كل بريد إلكتروني خلال رحلة المستخدم",
    "communications.journey_buyer": "رحلة المشتري",
    "Buyer Journey": "رحلة المشتري",
    "communications.journey_seller": "رحلة البائع",
    "Seller Journey": "رحلة البائع",
    "communications.journey_buyer_stage_0": "التسجيل",
    "Sign Up": "التسجيل",
    "communications.journey_buyer_stage_1": "التصفح",
    "Browse": "التصفح",
    "communications.journey_buyer_stage_2": "السلة",
    "Cart": "السلة",
    "communications.journey_buyer_stage_3": "تم تقديم الطلب",
    "Order Placed": "تم تقديم الطلب",
    "communications.journey_buyer_stage_4": "تم الشحن",
    "communications.journey_buyer_stage_5": "تم التسليم",
    "communications.journey_buyer_stage_6": "التفاوض",
    "Negotiate": "التفاوض",
    "communications.journey_buyer_stage_7": "غير نشط",
    "communications.journey_seller_stage_0": "الانضمام",
    "Onboard": "الانضمام",
    "communications.journey_seller_stage_1": "نشر الإعلان",
    "communications.journey_seller_stage_2": "الإدارة",
    "communications.journey_seller_stage_3": "طلب وارد",
    "Order In": "طلب وارد",
    "communications.journey_seller_stage_4": "الشحن",
    "communications.journey_seller_stage_5": "مكتمل",
    "Complete": "مكتمل",
    "communications.journey_seller_stage_6": "غير نشط",
    "accounts.title": "الحسابات",
    "accounts.status_pending": "قيد الانتظار",
    "accounts.status_approved": "تمت الموافقة",
    "accounts.status_rejected": "مرفوض",
    "accounts.show_rows": "إظهار الصفوف",
    "accounts.next": "التالي",
    "accounts.previous": "السابق",
    "accounts.view_list": "قائمة",
    "accounts.view_map": "خريطة",
    "Map": "خريطة",
    "accounts.view_board": "لوحة",
    "accounts.view_grid": "شبكة",
    "accounts.view_list_accessibility": "عرض القائمة",
    "accounts.view_map_accessibility": "عرض الخريطة",
    "Map view": "عرض الخريطة",
    "accounts.view_board_accessibility": "عرض اللوحة",
    "Board view": "عرض اللوحة",
    "accounts.view_grid_accessibility": "عرض الشبكة",
    "accounts.column_name": "الاسم",
    "accounts.column_account_id": "معرّف الحساب",
    "accounts.column_description": "الوصف",
    "accounts.column_image": "الصورة",
    "accounts.column_user_name": "اسم المستخدم",
    "User Name": "اسم المستخدم",
    "accounts.column_email": "البريد الإلكتروني",
    "accounts.column_status": "الحالة",
    "accounts.column_account_status": "حالة الحساب",
    "Account Status": "حالة الحساب",
    "accounts.column_location": "الموقع",
    "accounts.search": "البحث في الحسابات",
    "Search accounts": "البحث في الحسابات",
    "accounts.export": "تصدير",
    "accounts.import": "استيراد",
    "accounts.export_accounts": "تصدير الحسابات",
    "Export accounts": "تصدير الحسابات",
    "accounts.import_accounts": "استيراد الحسابات",
    "Import accounts": "استيراد الحسابات",
    "accounts.smart_upload_accounts": "التحميل الذكي للحسابات",
    "Smart Upload accounts": "التحميل الذكي للحسابات",
    "accounts.export_all_question": "تصدير جميع الحسابات؟",
    "Export all accounts?": "تصدير جميع الحسابات؟",
    "accounts.export_all_description": "سيتم تجهيز ملف يحتوي على جميع الحسابات. يمكنك مراجعة هذه العملية قبل الترقية.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "سيتم تجهيز ملف يحتوي على جميع الحسابات. يمكنك مراجعة هذه العملية قبل الترقية.",
    "accounts.export_all": "تصدير جميع الحسابات",
    "Export all accounts": "تصدير جميع الحسابات",
    "accounts.cancel": "إلغاء",
    "accounts.active": "نشط",
    "accounts.inactive": "غير نشط",
    "accounts.not_available": "غير متاح",
    "accounts.approve": "موافقة",
    "accounts.reject": "رفض",
    "accounts.manage": "إدارة",
    "accounts.tooltip_title": "الحسابات تشبه المتاجر.",
    "Accounts are like shops.": "الحسابات تشبه المتاجر.",
    "accounts.tooltip_description": "يمكن للمستخدمين إنشاء مساحة على منصتك لإدارة نشاط تجاري، وتُسمى هذه المساحة حسابًا. قد لا يحتاج كل مستخدم إلى حساب. ويمكن ربط الحسابات بحسابات الضمان لاستلام المدفوعات.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "يمكن للمستخدمين إنشاء مساحة على منصتك لإدارة نشاط تجاري، وتُسمى هذه المساحة حسابًا. قد لا يحتاج كل مستخدم إلى حساب. ويمكن ربط الحسابات بحسابات الضمان لاستلام المدفوعات.",
    "accounts.create_account": "إنشاء حساب",
    "Create Account": "إنشاء حساب",
    "accounts.create_new_account": "إنشاء حساب جديد",
    "Create New Account": "إنشاء حساب جديد",
    "accounts.save": "حفظ",
    "accounts.please_wait": "يرجى الانتظار…",
    "Please wait...": "يرجى الانتظار…",
    "accounts.account_name": "اسم الحساب",
    "accounts.slug": "الاسم المختصر للرابط",
    "accounts.account_slug": "اسم رابط الحساب",
    "Account Slug": "اسم رابط الحساب",
    "accounts.account_description": "وصف الحساب",
    "Account Description": "وصف الحساب",
    "accounts.enter_name_first": "يرجى إدخال اسم أولاً",
    "accounts.user": "المستخدم",
    "accounts.select_user": "اختر مستخدمًا",
    "accounts.category": "الفئة",
    "Category": "الفئة",
    "accounts.select_type": "اختر نوعًا",
    "accounts.smart_upload_title": "التحميل الذكي للحسابات",
    "Smart account upload": "التحميل الذكي للحسابات",
    "accounts.start_over": "البدء من جديد",
    "accounts.smart_upload_description": "ارفع الحسابات وطابق أعمدة CSV مع حقول الحساب.",
    "Upload accounts and match your CSV columns to account fields.": "ارفع الحسابات وطابق أعمدة CSV مع حقول الحساب.",
    "accounts.smart_upload_step_0": "رفع",
    "accounts.smart_upload_step_1": "مطابقة الأعمدة",
    "accounts.smart_upload_step_2": "مراجعة",
    "accounts.smart_upload_step_3": "استيراد",
    "accounts.choose_csv": "اختر ملف CSV",
    "accounts.smart_upload_required_note": "الاسم مطلوب. العنوان والاسم المختصر والفئة والمالك والإحداثيات اختيارية.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "الاسم مطلوب. العنوان والاسم المختصر والفئة والمالك والإحداثيات اختيارية.",
    "accounts.select_csv": "اختر ملف CSV",
    "accounts.match_columns": "مطابقة أعمدة الحساب",
    "Match account columns": "مطابقة أعمدة الحساب",
    "accounts.import_field_name": "الاسم",
    "accounts.import_field_description": "الوصف",
    "accounts.import_field_slug": "الاسم المختصر للرابط",
    "accounts.import_field_category_id": "معرّف الفئة",
    "Category ID": "معرّف الفئة",
    "accounts.import_field_user_id": "معرّف مستخدم المالك",
    "Owner User ID": "معرّف مستخدم المالك",
    "accounts.import_field_location": "العنوان",
    "accounts.import_field_latitude": "خط العرض",
    "Latitude": "خط العرض",
    "accounts.import_field_longitude": "خط الطول",
    "Longitude": "خط الطول",
    "accounts.do_not_import": "عدم الاستيراد",
    "accounts.review_import": "مراجعة الاستيراد",
    "accounts.import_count": "سيتم استيراد {count} حسابات.",
    "{count} accounts will be imported.": "سيتم استيراد {count} حسابات.",
    "accounts.smart_upload_complete": "اكتمل التحميل الذكي",
    "accounts.imported_count": "تم استيراد {imported} من أصل {total} حسابًا.",
    "{imported} of {total} accounts imported.": "تم استيراد {imported} من أصل {total} حسابًا.",
    "accounts.selected_file": "المحدد: {filename}",
    "Selected: {filename}": "المحدد: {filename}",
    "accounts.review": "مراجعة",
    "accounts.importing": "جارٍ الاستيراد…",
    "accounts.uploading": "جارٍ الرفع…",
    "accounts.download": "تنزيل",
    "accounts.file_label": "الملف:",
    "accounts.select_file": "اختر ملفًا",
    "accounts.upload": "رفع",
    "accounts.download_template": "تنزيل قالب {type}",
    "Download {type} template": "تنزيل قالب {type}",
    "accounts.import_stage_prepare": "جارٍ تجهيز ملف الاستيراد",
    "accounts.import_prepare_failed": "تعذر تجهيز ملف الاستيراد.",
    "accounts.import_stage_upload": "جارٍ رفع ملف الاستيراد",
    "accounts.import_upload_failed": "تعذر رفع ملف الاستيراد.",
    "accounts.import_stage_server": "يقوم Tradly باستيراد الحسابات",
    "Tradly is importing accounts": "يقوم Tradly باستيراد الحسابات",
    "accounts.import_stage_complete": "اكتمل الاستيراد",
    "Import complete": "اكتمل الاستيراد",
    "accounts.import_stage_stopped": "توقف الاستيراد",
    "accounts.confirm_approve": "هل تريد الموافقة على هذا الحساب؟",
    "Approve this account?": "هل تريد الموافقة على هذا الحساب؟",
    "accounts.confirm_reject": "هل تريد رفض هذا الحساب؟",
    "Reject this account?": "هل تريد رفض هذا الحساب؟",
    "accounts.name_required": "الاسم مطلوب",
    "Name is required": "الاسم مطلوب",
    "accounts.user_required": "المستخدم مطلوب",
    "User is required": "المستخدم مطلوب",
    "accounts.attribute_required": "{attribute} مطلوب",
    "accounts.overview": "نظرة عامة على الحساب",
    "Account Overview": "نظرة عامة على الحساب",
    "accounts.section_listings": "القوائم",
    "accounts.loading": "جارٍ التحميل…",
    "accounts.no_listings_owned": "لا توجد قوائم بعد",
    "accounts.page_analytics": "تحليلات الصفحة",
    "Page Analytics": "تحليلات الصفحة",
    "accounts.analytics_key_missing": "مفتاح API للتحليلات غير مُعدّ لهذا المستأجر.",
    "Analytics API key not configured for this tenant.": "مفتاح API للتحليلات غير مُعدّ لهذا المستأجر.",
    "accounts.storefront_url_missing": "لا يتوفر رابط متجر لهذا الحساب.",
    "No storefront URL available for this account.": "لا يتوفر رابط متجر لهذا الحساب.",
    "accounts.no_analytics_loaded": "لم يتم تحميل التحليلات بعد.",
    "accounts.load_analytics": "تحميل التحليلات",
    "Load Analytics": "تحميل التحليلات",
    "accounts.attributes": "السمات",
    "accounts.shipping": "الشحن",
    "accounts.commission": "العمولة",
    "Commission": "العمولة",
    "accounts.detail_title": "العنوان",
    "accounts.detail_description": "الوصف",
    "accounts.detail_descriptions": "الأوصاف",
    "Descriptions": "الأوصاف",
    "accounts.detail_listings": "القوائم",
    "accounts.detail_categories": "الفئات",
    "accounts.detail_location": "الموقع",
    "accounts.detail_account_status": "حالة الحساب",
    "accounts.detail_status": "الحالة",
    "accounts.detail_shipping_method": "طريقة الشحن",
    "accounts.detail_shipping_methods": "طرق الشحن",
    "Shipping Methods": "طرق الشحن",
    "accounts.detail_account_user": "مستخدم الحساب",
    "Account User": "مستخدم الحساب",
    "accounts.detail_pending": "قيد الانتظار",
    "accounts.detail_approved": "تمت الموافقة",
    "accounts.detail_rejected": "مرفوض",
    "accounts.detail_active": "نشط",
    "accounts.detail_inactive": "غير نشط",
    "accounts.detail_joined": "تاريخ الانضمام",
    "Joined": "تاريخ الانضمام",
    "accounts.detail_account_age": "عمر الحساب",
    "Account Age": "عمر الحساب",
    "accounts.detail_less_than_a_month": "أقل من شهر",
    "Less than a month": "أقل من شهر",
    "accounts.detail_page_views": "مشاهدات الصفحة",
    "Page Views": "مشاهدات الصفحة",
    "accounts.detail_unique_visitors": "الزوار الفريدون",
    "Unique Visitors": "الزوار الفريدون",
    "accounts.detail_sessions": "الجلسات",
    "Sessions": "الجلسات",
    "accounts.detail_clicks": "النقرات",
    "Clicks": "النقرات",
    "accounts.detail_goals": "الأهداف",
    "Goals": "الأهداف",
    "accounts.detail_bot_views": "مشاهدات الروبوتات",
    "Bot Views": "مشاهدات الروبوتات",
    "accounts.detail_followers": "المتابعون",
    "Followers": "المتابعون",
    "accounts.detail_total_orders": "إجمالي الطلبات",
    "accounts.detail_revenue": "الإيرادات",
    "accounts.detail_avg_order": "متوسط الطلب",
    "Avg Order": "متوسط الطلب",
    "accounts.detail_paid_orders": "الطلبات المدفوعة",
    "Paid Orders": "الطلبات المدفوعة",
    "accounts.detail_owner": "المالك",
    "Owner": "المالك",
    "accounts.detail_account_id": "معرّف الحساب",
    "accounts.detail_category": "الفئة",
    "accounts.detail_profile_completeness": "اكتمال الملف الشخصي",
    "Profile Completeness": "اكتمال الملف الشخصي",
    "accounts.detail_total_listings": "إجمالي القوائم",
    "Total Listings": "إجمالي القوائم",
    "accounts.detail_loaded_listings": "القوائم المحملة",
    "Loaded Listings": "القوائم المحملة",
    "accounts.detail_active_listings": "القوائم النشطة",
    "Active Listings": "القوائم النشطة",
    "accounts.detail_last_updated": "آخر تحديث",
    "Last Updated": "آخر تحديث",
    "accounts.detail_last_activity": "آخر نشاط",
    "Last Activity": "آخر نشاط",
    "accounts.detail_verification": "التحقق",
    "Verification": "التحقق",
    "accounts.detail_subscription": "الاشتراك",
    "accounts.detail_attributes": "السمات",
    "accounts.detail_shipping_charge_split": "تقسيم رسوم الشحن",
    "Shipping Charge Split": "تقسيم رسوم الشحن",
    "accounts.detail_value_type": "نوع القيمة",
    "Value Type": "نوع القيمة",
    "accounts.detail_value": "القيمة",
    "accounts.detail_enter_value": "أدخل قيمة",
    "accounts.detail_commission_percentage": "نسبة العمولة",
    "Commission Percentage": "نسبة العمولة",
    "accounts.detail_commission_percent": "نسبة العمولة",
    "Commission Percent": "نسبة العمولة",
    "accounts.detail_share": "مشاركة",
    "accounts.detail_view_account": "عرض الحساب",
    "View Account": "عرض الحساب",
    "accounts.detail_add_listing": "إضافة قائمة",
    "accounts.detail_edit_account": "تعديل الحساب",
    "Edit Account": "تعديل الحساب",
    "accounts.no_attribute_values": "لا توجد قيم سمات لـ {name}",
    "No attribute values for {name}": "لا توجد قيم سمات لـ {name}",
    "accounts.no_attributes_yet": "لا توجد سمات بعد",
    "No attributes yet": "لا توجد سمات بعد",
    "accounts.edit_account": "تعديل الحساب",
    "accounts.detail_preview": "معاينة",
    "accounts.detail_fixed": "ثابت",
    "Fixed": "ثابت",
    "accounts.detail_percentage": "النسبة المئوية",
    "accounts.detail_select_value_type": "اختر نوع القيمة",
    "Select Value Type": "اختر نوع القيمة",
    "accounts.detail_approve": "موافقة",
    "accounts.detail_reject": "رفض",
    "accounts.detail_section": "التفاصيل",
    "Details": "التفاصيل",
    "category.add_child": "إضافة فئة فرعية",
    "Add Child Category": "إضافة فئة فرعية",
    "category.add_listing": "إضافة قائمة",
    "category.manage": "إدارة الفئات",
    "Manage Categories": "إدارة الفئات",
    "category.account_overview_eyebrow": "نظرة عامة على فئة الحساب",
    "ACCOUNT CATEGORY OVERVIEW": "نظرة عامة على فئة الحساب",
    "category.overview_eyebrow": "نظرة عامة على الفئة",
    "CATEGORY OVERVIEW": "نظرة عامة على الفئة",
    "category.category": "الفئة",
    "category.active": "نشط",
    "category.inactive": "غير نشط",
    "category.accounts": "الحسابات",
    "category.listings": "القوائم",
    "category.child_categories": "الفئات الفرعية",
    "Child Categories": "الفئات الفرعية",
    "category.attributes": "السمات",
    "category.category_age": "عمر الفئة",
    "Category age": "عمر الفئة",
    "category.category_overview": "نظرة عامة على الفئة",
    "Category Overview": "نظرة عامة على الفئة",
    "category.category_id": "معرّف الفئة",
    "category.name": "الاسم",
    "category.slug": "الاسم المختصر للرابط",
    "category.description": "الوصف",
    "category.parent_category": "الفئة الأصلية",
    "Parent Category": "الفئة الأصلية",
    "category.hierarchy": "التسلسل الهرمي",
    "Hierarchy": "التسلسل الهرمي",
    "category.status": "الحالة",
    "category.display_order": "ترتيب العرض",
    "Display Order": "ترتيب العرض",
    "category.created": "تاريخ الانضمام / الإنشاء",
    "Joined / Created": "تاريخ الانضمام / الإنشاء",
    "category.configured": "مُعدّ",
    "Configured": "مُعدّ",
    "category.no_attributes": "لا توجد سمات مخصصة.",
    "No attributes assigned.": "لا توجد سمات مخصصة.",
    "category.no_child_categories": "لا توجد فئات فرعية.",
    "No child categories.": "لا توجد فئات فرعية.",
    "category.no_accounts": "لا توجد حسابات في هذه الفئة.",
    "No accounts in this category.": "لا توجد حسابات في هذه الفئة.",
    "category.no_listings": "لا توجد قوائم في هذه الفئة.",
    "No listings in this category.": "لا توجد قوائم في هذه الفئة.",
    "category.detail_title": "تفاصيل الفئة",
    "Category Detail": "تفاصيل الفئة",
    "category.age_less_month": "أقل من شهر",
    "category.age_month": "{count} شهر",
    "{count} month": "{count} شهر",
    "category.age_months": "{count} أشهر",
    "{count} months": "{count} أشهر",
    "category.age_year": "{count} سنة",
    "{count} year": "{count} سنة",
    "category.age_years": "{count} سنوات",
    "{count} years": "{count} سنوات",
    "category.header_name": "الاسم",
    "category.header_category_id": "معرّف الفئة",
    "category.header_image": "الصورة",
    "category.header_order": "الترتيب",
    "category.header_parent": "الفئة الأصلية",
    "Parent": "الفئة الأصلية",
    "category.header_active": "نشط",
    "category.header_action": "الإجراء",
    "category.header_url": "الرابط",
    "category.categories": "الفئات",
    "category.translate": "ترجمة",
    "category.import": "استيراد",
    "category.export": "تصدير",
    "category.add_category": "إضافة فئة",
    "Add Category": "إضافة فئة",
    "category.import_categories": "استيراد الفئات",
    "Import Categories": "استيراد الفئات",
    "category.delete_warning": "لن تفتح القوائم الحالية على الموقع أو التطبيق وستظهر رسالة خطأ.",
    "Existing listings will not open in website or app, you will see an error.": "لن تفتح القوائم الحالية على الموقع أو التطبيق وستظهر رسالة خطأ.",
    "category.editor_edit_category": "تعديل الفئة",
    "Edit Category": "تعديل الفئة",
    "category.editor_add_category": "إضافة فئة",
    "category.editor_save": "حفظ",
    "category.editor_select_category_level": "اختر مستوى الفئة",
    "Select Category Level": "اختر مستوى الفئة",
    "category.editor_parent_category": "الفئة الأصلية",
    "category.editor_select": "اختيار",
    "category.editor_category_name": "اسم الفئة",
    "Category Name": "اسم الفئة",
    "category.editor_enter_category_name": "أدخل اسم الفئة",
    "Enter category name": "أدخل اسم الفئة",
    "category.editor_slug": "الاسم المختصر للرابط",
    "category.editor_enter_slug": "أدخل الاسم المختصر للرابط",
    "category.editor_category_description": "وصف الفئة",
    "Category Description": "وصف الفئة",
    "category.editor_order": "الترتيب",
    "category.editor_enter_order": "أدخل الترتيب",
    "Enter order": "أدخل الترتيب",
    "category.editor_status_not_active_active": "الحالة (غير نشط / نشط)",
    "Status (Not Active / Active)": "الحالة (غير نشط / نشط)",
    "category.editor_upload_media": "رفع الوسائط",
    "category.editor_meta_title": "عنوان SEO",
    "category.editor_enter_meta_title": "أدخل عنوان SEO",
    "category.editor_meta_description": "وصف SEO",
    "category.editor_category": "الفئة",
    "category.editor_name": "الاسم",
    "category.editor_status": "الحالة",
    "category.editor_action": "الإجراء",
    "category.editor_add_attribute": "إضافة سمة",
    "Add Attribute": "إضافة سمة",
    "category.editor_attributes_list": "قائمة السمات",
    "Attributes List": "قائمة السمات",
    "category.editor_please_enter_a_category_name_first": "يرجى إدخال اسم الفئة أولاً",
    "Please enter a category name first": "يرجى إدخال اسم الفئة أولاً",
    "category.editor_successfully_added_category": "تمت إضافة الفئة بنجاح",
    "Successfully added category": "تمت إضافة الفئة بنجاح",
    "category.deleted": "تم حذف الفئة",
    "Category deleted": "تم حذف الفئة",
    "attributes.title": "السمات",
    "attributes.cart_checkout": "السلة والدفع",
    "Cart & Checkout": "السلة والدفع",
    "attributes.cart_settings": "إعدادات السلة",
    "Cart settings": "إعدادات السلة",
    "attributes.order_status_notifications": "إشعارات حالة الطلب",
    "Order status notifications": "إشعارات حالة الطلب",
    "attributes.groups": "مجموعات السمات",
    "Attribute Groups": "مجموعات السمات",
    "attributes.add_attribute": "إضافة سمة",
    "attributes.edit_bulk": "تعديل جماعي",
    "Edit Bulk": "تعديل جماعي",
    "attributes.confirm_delete": "هل تريد حذف هذه السمة؟",
    "Do you want to delete this attribute?": "هل تريد حذف هذه السمة؟",
    "attributes.header_attribute_name": "اسم السمة",
    "Attribute Name": "اسم السمة",
    "attributes.header_action": "الإجراء",
    "attributes.header_manage_attribute_values": "إدارة قيم السمات",
    "Manage Attribute Values": "إدارة قيم السمات",
    "attributes.header_type": "النوع",
    "attributes.header_optional": "اختياري",
    "attributes.header_icon": "أيقونة",
    "Icon": "أيقونة",
    "attributes.header_categories": "الفئات",
    "attributes.header_hidden_field": "حقل مخفي",
    "Hidden Field": "حقل مخفي",
    "attributes.header_values": "القيم",
    "Values": "القيم",
    "attributes.header_status": "الحالة",
    "attributes.type_single_select": "اختيار واحد",
    "Single Select": "اختيار واحد",
    "attributes.type_multi_select": "اختيار متعدد",
    "Multi Select": "اختيار متعدد",
    "attributes.type_open_single_value": "مفتوح (قيمة واحدة)",
    "Open (Single Value)": "مفتوح (قيمة واحدة)",
    "attributes.type_open_multiple_value": "مفتوح (قيم متعددة)",
    "Open (Multiple Value)": "مفتوح (قيم متعددة)",
    "attributes.type_attachment": "مرفق",
    "Attachment": "مرفق",
    "attributes.type_text_area": "منطقة نص",
    "Text Area": "منطقة نص",
    "attributes.type_date_time": "التاريخ والوقت",
    "Date Time": "التاريخ والوقت",
    "attributes.type_number": "رقم",
    "attributes.type_boolean": "قيمة منطقية",
    "Boolean": "قيمة منطقية",
    "attributes.type_color": "اللون",
    "Color": "اللون",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "الموقع",
    "attributes.type_audio": "صوت",
    "Audio": "صوت",
    "attributes.type_video": "فيديو",
    "Video": "فيديو",
    "attributes.type_open_multi_value": "مفتوح (قيم متعددة)",
    "Open (Multi Value)": "مفتوح (قيم متعددة)",
    "attributes.editor_edit_attribute": "تعديل السمة",
    "Edit Attribute": "تعديل السمة",
    "attributes.editor_add_attribute": "إضافة سمة",
    "attributes.editor_attribute_name": "اسم السمة",
    "attributes.editor_select_type": "اختر النوع",
    "attributes.prefill_user": "المستخدم",
    "common.search_placeholder": "اكتب للبحث...",
    "attributes.prefill_accounts": "الحسابات",
    "attributes.prefill_listings": "الإعلانات",
    "listings.detail_nav_gallery": "معرض الصور",
    "Gallery": "معرض الصور",
    "listings.detail_nav_details": "التفاصيل",
    "listings.detail_nav_inventory": "المخزون",
    "listings.detail_nav_social": "التواصل الاجتماعي",
    "Social": "التواصل الاجتماعي",
    "listings.detail_nav_orders": "الطلبات",
    "listings.detail_nav_analytics": "التحليلات",
    "listings.detail_nav_schedule": "الجدول",
    "listings.detail_nav_rental": "الإيجار",
    "Rental": "الإيجار",
    "listings.detail_nav_attributes": "السمات",
    "listings.detail_nav_seller": "البائع",
    "attributes.editor_icon": "أيقونة",
    "attributes.editor_tool_tip": "تلميح",
    "Tool tip": "تلميح",
    "attributes.editor_enter_attribute_name": "أدخل اسم السمة",
    "Enter attribute name": "أدخل اسم السمة",
    "attributes.editor_enter_attribute_tool_tip": "أدخل تلميح السمة",
    "Enter attribute tool tip": "أدخل تلميح السمة",
    "attributes.editor_optional": "اختياري",
    "attributes.editor_private": "خاص",
    "Private": "خاص",
    "attributes.editor_hidden_field": "حقل مخفي",
    "Hidden field": "حقل مخفي",
    "attributes.editor_show_in_filter": "إظهار في عامل التصفية",
    "attributes.editor_status_not_active_active": "الحالة (غير نشط / نشط)",
    "attributes.editor_add_meta_data": "إضافة بيانات وصفية",
    "Add meta data": "إضافة بيانات وصفية",
    "attributes.editor_select": "اختيار",
    "attributes.editor_select_category": "اختر فئة",
    "Select category": "اختر فئة",
    "attributes.editor_select_all": "تحديد الكل",
    "Select All": "تحديد الكل",
    "attributes.editor_unselect_all": "إلغاء تحديد الكل",
    "UnSelect All": "إلغاء تحديد الكل",
    "attributes.editor_create_categories_in_this_configuration_first": "أنشئ الفئات في هذا الإعداد أولاً",
    "Create categories in this configuration first": "أنشئ الفئات في هذا الإعداد أولاً",
    "attributes.editor_please_enter_attribute_name": "يرجى إدخال اسم السمة",
    "attributes.editor_please_select_type": "يرجى اختيار النوع",
    "Please select type": "يرجى اختيار النوع",
    "attributes.editor_select_single_attribute_values": "اختر قيم سمة واحدة",
    "attributes.editor_select_multiple_attribute_values": "اختر عدة قيم للسمات",
    "attributes.editor_enter_value": "أدخل قيمة",
    "attributes.editor_enter_multiple_tag": "أدخل عدة وسوم",
    "Enter Multiple Tag": "أدخل عدة وسوم",
    "attributes.editor_upload_file": "رفع ملف",
    "attributes.editor_enter_text": "أدخل نصًا",
    "Enter Text": "أدخل نصًا",
    "attributes.editor_select_date": "اختر تاريخًا",
    "attributes.editor_enter_number": "أدخل رقمًا",
    "Enter Number": "أدخل رقمًا",
    "attributes.editor_select_color": "اختر لونًا",
    "Select Color": "اختر لونًا",
    "attributes.editor_upload_json": "رفع JSON",
    "Upload Json": "رفع JSON",
    "attributes.editor_select_location": "اختر موقعًا",
    "Select Location": "اختر موقعًا",
    "attributes.editor_category": "الفئة",
    "attributes.editor_price": "السعر",
    "attributes.editor_enter_price": "أدخل السعر",
    "Enter Price": "أدخل السعر",
    "attributes.editor_preview": "معاينة",
    "attributes.editor_title": "العنوان",
    "attributes.editor_enter_title": "أدخل العنوان",
    "Enter Title": "أدخل العنوان",
    "attributes.editor_description": "الوصف",
    "attributes.editor_add_listing": "إضافة قائمة",
    "attributes.editor_add_account": "إضافة حساب",
    "Add Account": "إضافة حساب",
    "attributes.editor_successfully_added_attributes": "تمت إضافة السمات بنجاح",
    "Successfully added attributes": "تمت إضافة السمات بنجاح",
    "attributes.editor_add_attribute_values": "إضافة قيم السمة",
    "Add Attribute Values": "إضافة قيم السمة",
    "common.image": "الصورة",
    "common.please_wait": "يرجى الانتظار…",
    "attribute_groups.title": "مجموعات السمات",
    "attribute_groups.title_singular": "مجموعة السمات",
    "Attribute Group": "مجموعة السمات",
    "attribute_groups.add": "إضافة مجموعة سمات",
    "Add Attribute Group": "إضافة مجموعة سمات",
    "attribute_groups.image_path": "مسار الصورة",
    "Image Path": "مسار الصورة",
    "attribute_groups.name_placeholder": "اسم المجموعة",
    "Group Name": "اسم المجموعة",
    "attribute_groups.select_attributes": "اختر السمات",
    "Select Attributes": "اختر السمات",
    "attribute_groups.select_attributes_placeholder": "اختر السمات…",
    "Select Attributes...": "اختر السمات…",
    "attribute_groups.added_successfully": "تمت إضافة مجموعة السمات بنجاح",
    "Attribute Group Added Successfully": "تمت إضافة مجموعة السمات بنجاح",
    "attribute_groups.deleted_successfully": "تم الحذف بنجاح",
    "Deleted successfully": "تم الحذف بنجاح",
    "attribute_groups.name_required": "الاسم مطلوب",
    "attribute_groups.save_attributes_failed": "تم حفظ المجموعة، ولكن تعذر تعيين سماتها.",
    "The group was saved, but its attributes could not be assigned.": "تم حفظ المجموعة، ولكن تعذر تعيين سماتها.",
    "attributes.editor_enter_description": "أدخل الوصف",
    "Enter Description": "أدخل الوصف",
    "account_config.title": "إعدادات الحساب",
    "account_config.account_detail_note": "ملاحظة الحساب",
    "Account detail note": "ملاحظة الحساب",
    "account_config.enter_account_detail_note": "أدخل ملاحظة الحساب",
    "Enter account detail note": "أدخل ملاحظة الحساب",
    "account_config.address_label": "تسمية العنوان",
    "Address label": "تسمية العنوان",
    "account_config.enter_address_label": "أدخل تسمية العنوان",
    "Enter address label": "أدخل تسمية العنوان",
    "account_config.category_label": "تسمية الفئة",
    "Category label": "تسمية الفئة",
    "account_config.enter_category_label": "أدخل تسمية الفئة",
    "Enter category label": "أدخل تسمية الفئة",
    "account_config.nearby_accounts_radius_km": "نطاق الحسابات القريبة (كم)",
    "Nearby accounts radius (km)": "نطاق الحسابات القريبة (كم)",
    "account_config.nearby_accounts_radius_placeholder": "نطاق الحسابات القريبة بالكيلومتر",
    "Account nearby radius in km": "نطاق الحسابات القريبة بالكيلومتر",
    "account_config.account_limit": "حد الحسابات",
    "Account Limit": "حد الحسابات",
    "account_config.account_limit_placeholder": "حد الحسابات",
    "Account limit": "حد الحسابات",
    "account_config.shipping_preference_note": "ملاحظة تفضيلات الشحن",
    "Shipping method preference note": "ملاحظة تفضيلات الشحن",
    "account_config.option_accounts_auto_approved": "الموافقة التلقائية على الحسابات",
    "Accounts auto approved": "الموافقة التلقائية على الحسابات",
    "account_config.option_shipping_methods_preference_for_accounts": "تفضيلات الشحن للحسابات",
    "Shipping methods preference for accounts": "تفضيلات الشحن للحسابات",
    "account_config.option_account_map_location_selector": "محدد موقع الحساب على الخريطة",
    "Account map location selector": "محدد موقع الحساب على الخريطة",
    "account_config.option_account_geo_location": "الموقع الجغرافي للحساب",
    "Account Geo Location": "الموقع الجغرافي للحساب",
    "account_config.option_slug": "الاسم المختصر للرابط",
    "account_config.option_show_description": "إظهار الوصف",
    "Show Description": "إظهار الوصف",
    "account_config.option_formatted_text_description": "وصف بتنسيق منسق",
    "Formatted Text Description": "وصف بتنسيق منسق",
    "account_config.option_hide_address_from_account_detail": "إخفاء العنوان من تفاصيل الحساب",
    "Hide Address from Account Detail": "إخفاء العنوان من تفاصيل الحساب",
    "account_config.option_get_account_pickup_address_always": "استخدم عنوان استلام الحساب دائمًا",
    "Get Account Pickup Address Always": "استخدم عنوان استلام الحساب دائمًا",
    "account_config.option_get_pickup_address_for_delivery": "استخدم عنوان الاستلام للتوصيل",
    "Get Pickup Address for Delivery": "استخدم عنوان الاستلام للتوصيل",
    "account_config.uploaded_successfully": "تم الحفظ بنجاح",
    "app_customization.realtime_config_notice": "تُطبّق الإعدادات أدناه فورًا. عند إجراء التغييرات هنا والضغط على حفظ، ستظهر في التطبيقات واستجابات API.",
    "app_customization.release_config_notice": "ملاحظة لقنوات تطبيقات الهاتف المحمول: تُطبّق الإعدادات أدناه عند إصدار المنتج أو تحديثه فقط، ولا تُحدّث فورًا. بعد إجراء تغييرات تتطلب إصدارًا جديدًا، أرسل طلب إنشاء من بوابة الدعم. (تنطبق على خطة Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "ملاحظة لقنوات تطبيقات الهاتف المحمول: تُطبّق الإعدادات أدناه عند إصدار المنتج أو تحديثه فقط، ولا تُحدّث فورًا. بعد إجراء تغييرات تتطلب إصدارًا جديدًا، أرسل طلب إنشاء من بوابة الدعم. (تنطبق على خطة Starter)",
    "category.translation_title": "ترجمة الفئة",
    "Translate Category": "ترجمة الفئة",
    "category.translation_category_name": "اسم الفئة",
    "category.translation_description": "الوصف",
    "listing_configs.title": "إعدادات الإعلانات",
    "Listing Configuration": "إعدادات الإعلانات",
    "listing_configs.rules": "القواعد (مستوى المشروع/المستأجر)",
    "RULES (Projects/Tenant level)": "القواعد (مستوى المشروع/المستأجر)",
    "listing_configs.features": "الميزات (لتطبيق الهاتف فقط)",
    "FEATURES (Only for mobile app)": "الميزات (لتطبيق الهاتف فقط)",
    "listing_configs.ui_customisation": "تخصيص الواجهة",
    "UI Customisation": "تخصيص الواجهة",
    "listing_configs.overridden_max_quantity": "الحد الأقصى للكمية لكل إعلان",
    "Maximum quantity per listing": "الحد الأقصى للكمية لكل إعلان",
    "listing_configs.overridden_max_quantity_example": "(مثال: 100)",
    "(Example: 100)": "(مثال: 100)",
    "listing_configs.listing_min_price": "الحد الأدنى لسعر الإعلان",
    "Minimum listing price": "الحد الأدنى لسعر الإعلان",
    "listing_configs.listing_min_price_example": "(مثال: 5 $)",
    "(Example: $5)": "(مثال: 5 $)",
    "listing_configs.auto_approval": "الموافقة تلقائيًا على الإعلانات؟",
    "listing_configs.listing_pictures_count": "عدد الصور القابلة للتحميل",
    "listing_configs.seller_can_place_order": "يمكن للبائع تقديم طلب",
    "Seller can place order": "يمكن للبائع تقديم طلب",
    "listing_configs.hide_offer_percent": "نسبة العرض",
    "listing_configs.show_max_quantity": "قيود الحد الأقصى للكمية على مستوى الإعلان",
    "Maximum quantity restrictions on listing level": "قيود الحد الأقصى للكمية على مستوى الإعلان",
    "listing_configs.show_shipping_charges": "رسوم الشحن",
    "Shipping charges": "رسوم الشحن",
    "listing_configs.listing_address_label": "تسمية العنوان",
    "listing_configs.listing_address_label_example": "(مثال: معلم بارز)",
    "listing_configs.listing_map_location_selector_enabled": "استخدم علامة الخريطة بدلًا من البحث عن العنوان",
    "Use map marker instead of searching address": "استخدم علامة الخريطة بدلًا من البحث عن العنوان",
    "listing_configs.listing_hide_tags": "الوسوم",
    "Tags": "الوسوم",
    "listing_configs.enable_stock": "المخزون",
    "Stocks": "المخزون",
    "listing_configs.listing_address_enabled": "العنوان الجغرافي",
    "Geo address": "العنوان الجغرافي",
    "listing_configs.show_stock_out_listings": "عرض الإعلانات غير المتوفرة في الخلاصة",
    "listing_configs.enable_slug": "معرّف عنوان الإعلان في الرابط",
    "listing_configs.show_variants": "المتغيرات",
    "listing_configs.meta_title": "عنوان Meta",
    "listing_configs.meta_description": "وصف Meta",
    "listing_configs.listing_enable_formatted_text_description": "تفعيل محرر النصوص",
    "Enable Composer": "تفعيل محرر النصوص",
    "listing_configs.listing_enable_weight": "تفعيل الوزن",
    "Enable Weight": "تفعيل الوزن",
    "listing_configs.listing_enable_dimensions": "تفعيل الأبعاد",
    "Enable Dimensions": "تفعيل الأبعاد",
    "listing_configs.enable_stocks_listing_schedules": "جداول المخزون",
    "Stock Schedules": "جداول المخزون",
    "listing_variants.title": "أنواع المتغيرات",
    "listing_variants.add_type": "إضافة نوع متغير",
    "Add Variant Type": "إضافة نوع متغير",
    "listing_variants.edit_type": "تعديل نوع المتغير",
    "Edit Variant Type": "تعديل نوع المتغير",
    "listing_variants.name": "الاسم",
    "listing_variants.values": "القيم",
    "listing_variants.status": "الحالة",
    "listing_variants.action": "الإجراء",
    "listing_variants.add_value": "إضافة قيمة",
    "Add Value": "إضافة قيمة",
    "listing_variants.active": "نشط",
    "listing_variants.inactive": "غير نشط",
    "listing_variants.details": "التفاصيل",
    "listing_variants.translate": "ترجمة",
    "listing_variants.delete_confirm": "هل تريد حذف نوع المتغير هذا؟",
    "Do you want to delete this variant type?": "هل تريد حذف نوع المتغير هذا؟",
    "listing_variants.add_value_first": "أضف قيمة قبل عرض المتغيرات.",
    "Add a value before viewing variants.": "أضف قيمة قبل عرض المتغيرات.",
    "listing_variants.enter_name": "أدخل الاسم",
    "Enter name": "أدخل الاسم",
    "listing_variants.status_hint": "الحالة (غير نشط / نشط)",
    "listing_variants.total_values": "إجمالي القيم",
    "Total Values": "إجمالي القيم",
    "listing_variants.type_id": "معرّف النوع",
    "Type ID": "معرّف النوع",
    "listing_variants.total_count": "الإجمالي {count}",
    "{count} total": "الإجمالي {count}",
    "listing_variants.loading": "جارٍ التحميل…",
    "listing_variants.loading_values": "جارٍ تحميل القيم…",
    "Loading values…": "جارٍ تحميل القيم…",
    "listing_variants.no_values": "لا توجد قيم بعد",
    "No values yet": "لا توجد قيم بعد",
    "listing_variants.add_first_value": "إضافة أول قيمة",
    "Add First Value": "إضافة أول قيمة",
    "listing_variants.actions": "الإجراءات",
    "listing_variants.edit": "تعديل",
    "listing_variants.delete": "حذف",
    "listing_variants.edit_value": "تعديل القيمة",
    "Edit Value": "تعديل القيمة",
    "listing_variants.value_name_required": "اسم القيمة *",
    "Value Name *": "اسم القيمة *",
    "listing_variants.value_examples": "مثال: أحمر، XL، قطن…",
    "e.g. Red, XL, Cotton…": "مثال: أحمر، XL، قطن…",
    "listing_variants.saving": "جارٍ الحفظ…",
    "listing_variants.save_changes": "حفظ التغييرات",
    "Save Changes": "حفظ التغييرات",
    "listing_variants.delete_value_confirm": "هل تريد حذف قيمة المتغير هذه؟",
    "Do you want to delete this variant value?": "هل تريد حذف قيمة المتغير هذه؟",
    "listing_variants.clear_all": "مسح الكل",
    "listing_variants.multiple_values_help": "يمكنك إضافة قيم مفصولة بفواصل أو لصق عمود من Excel.",
    "You can add comma-separated values or paste a column from Excel.": "يمكنك إضافة قيم مفصولة بفواصل أو لصق عمود من Excel.",
    "listing_variants.save": "حفظ",
    "listing_variants.close": "إغلاق",
    "listing_variants.update": "تحديث",
    "listing_variants.default_text": "النص الافتراضي",
    "listing_variants.enter_value": "أدخل قيمة المتغير",
    "Enter variant value": "أدخل قيمة المتغير",
    "listing_variants.add_values": "إضافة قيم",
    "Add Values": "إضافة قيم",
    "listing_variants.add_variant_values": "إضافة قيم نوع المتغير",
    "Add Variant Type Values": "إضافة قيم نوع المتغير",
    "listing_variants.values_list": "قائمة قيم نوع المتغير",
    "Variant Type Values List": "قائمة قيم نوع المتغير",
    "listing_variants.cancel_editing": "إلغاء التعديل",
    "Cancel Editing": "إلغاء التعديل",
    "listing_variants.value_name": "قيمة نوع المتغير",
    "Variant Type Value": "قيمة نوع المتغير",
    "common.default_text": "النص الافتراضي",
    "common.translation_heading": "ترجمات {title}",
    "{title} Translations": "ترجمات {title}",
    "attributes.value_delete_confirm": "هل تريد حذف قيمة السمة هذه؟",
    "Do you want to delete this attribute value?": "هل تريد حذف قيمة السمة هذه؟",
    "attributes.value_clear_all": "مسح الكل",
    "attributes.value_multiple_help": "أدخل قيمًا مفصولة بفواصل أو الصق عمودًا من Excel.",
    "Add comma-separated values or paste a column from Excel.": "أدخل قيمًا مفصولة بفواصل أو الصق عمودًا من Excel.",
    "attributes.value_active": "نشط",
    "attributes.value_inactive": "غير نشط",
    "attributes.value_save": "حفظ",
    "attributes.value_close": "إغلاق",
    "attributes.value_translate": "ترجمة",
    "attributes.value_update": "تحديث",
    "attributes.value_sort_alpha": "ترتيب أبجدي",
    "Sort Alphabetically": "ترتيب أبجدي",
    "attributes.value_default_text": "النص الافتراضي",
    "attributes.value_add_metadata": "إضافة بيانات وصفية",
    "Add Metadata": "إضافة بيانات وصفية",
    "attributes.value_cancel_edit": "إلغاء التعديل",
    "attributes.value_success_help": "رائع! يمكنك الآن العثور على هذه السمة المخصصة في صفحة إضافة الإعلان.",
    "Great! You can now find this custom attribute on the Add Listing page.": "رائع! يمكنك الآن العثور على هذه السمة المخصصة في صفحة إضافة الإعلان.",
    "attributes.value_add": "إضافة قيم السمة",
    "attributes.value_add_listing": "إضافة قيم سمة الإعلان",
    "Add Listing Attribute Values": "إضافة قيم سمة الإعلان",
    "attributes.value_metadata_for": "بيانات وصفية لـ",
    "Metadata for": "بيانات وصفية لـ",
    "attributes.value_enter": "أدخل قيمة السمة",
    "Enter attribute value": "أدخل قيمة السمة",
    "attributes.value_add_values": "إضافة قيم",
    "attributes.value_status_hint": "الحالة (غير نشط / نشط)",
    "attributes.value_list": "قائمة قيم السمة",
    "Attribute Values List": "قائمة قيم السمة",
    "attributes.value_table_name": "قيمة السمة",
    "Attribute Value": "قيمة السمة",
    "attributes.value_table_status": "الحالة",
    "attributes.value_table_action": "الإجراء",
    "attributes.metadata_key": "المفتاح",
    "Key": "المفتاح",
    "attributes.metadata_value": "القيمة",
    "attributes.metadata_add_row": "إضافة صف",
    "Add Row": "إضافة صف",
    "workspace.countries": "البلدان",
    "workspace.country_add": "إضافة بلد",
    "Add Country": "إضافة بلد",
    "workspace.country_edit": "تعديل البلد",
    "Edit Country": "تعديل البلد",
    "workspace.country_name": "اسم البلد",
    "Country Name": "اسم البلد",
    "workspace.select_country": "اختر بلدًا",
    "Select country": "اختر بلدًا",
    "workspace.country_order": "الترتيب",
    "workspace.country_order_placeholder": "أدخل الترتيب",
    "workspace.country_status": "الحالة (غير نشط / نشط)",
    "workspace.country_default": "افتراضي",
    "workspace.country_active": "نشط",
    "workspace.country_inactive": "غير نشط",
    "workspace.country_delete_confirm": "هل تريد حذف هذا البلد؟",
    "Do you want to delete this country?": "هل تريد حذف هذا البلد؟",
    "workspace.country_table_name": "الاسم",
    "workspace.country_table_default": "افتراضي",
    "workspace.country_table_order": "الترتيب",
    "workspace.country_table_status": "الحالة",
    "workspace.country_table_action": "الإجراء",
    "workspace.languages": "اللغات",
    "workspace.language_add": "إضافة لغة",
    "Add Language": "إضافة لغة",
    "workspace.language_edit": "تعديل اللغة",
    "Edit Language": "تعديل اللغة",
    "workspace.language_name": "اللغة",
    "workspace.language_select": "اختر لغة",
    "Select Language": "اختر لغة",
    "workspace.language_order": "الترتيب",
    "workspace.language_order_placeholder": "أدخل الترتيب",
    "workspace.language_status": "الحالة",
    "workspace.language_default": "افتراضي",
    "workspace.language_default_warning": "يؤدي تغيير اللغة الافتراضية إلى تغيير لغة التطبيق.",
    "Changing the default language changes the app language setting.": "يؤدي تغيير اللغة الافتراضية إلى تغيير لغة التطبيق.",
    "workspace.language_active": "نشط",
    "workspace.language_inactive": "غير نشط",
    "workspace.language_delete_confirm": "هل تريد حذف هذه اللغة؟",
    "Do you want to delete this language?": "هل تريد حذف هذه اللغة؟",
    "workspace.language_table_name": "الاسم",
    "workspace.language_table_default": "افتراضي",
    "workspace.language_table_order": "الترتيب",
    "workspace.language_table_status": "الحالة",
    "workspace.language_table_action": "الإجراء",
    "workspace.language_add_photo": "إضافة صورة",
    "Add Photo": "إضافة صورة",
    "workspace.currency": "العملة",
    "workspace.currency_add": "إضافة عملة",
    "Add Currency": "إضافة عملة",
    "workspace.currency_edit": "تعديل العملة",
    "Edit Currency": "تعديل العملة",
    "workspace.currency_delete_confirm": "هل تريد حذف هذه العملة؟",
    "Do you want to delete this currency?": "هل تريد حذف هذه العملة؟",
    "workspace.currency_show": "عرض",
    "workspace.currency_entries": "إدخالات",
    "entries": "إدخالات",
    "workspace.currency_search": "بحث:",
    "Search:": "بحث:",
    "workspace.currency_search_placeholder": "ابحث عن العملات",
    "Search currencies": "ابحث عن العملات",
    "workspace.currency_empty": "لم يتم العثور على عملات.",
    "No currencies found.": "لم يتم العثور على عملات.",
    "workspace.currency_active": "نشطة",
    "workspace.currency_inactive": "غير نشطة",
    "workspace.currency_name": "الاسم",
    "workspace.currency_name_placeholder": "اسم العملة",
    "Currency Name": "اسم العملة",
    "workspace.currency_upload_media": "تحميل وسائط",
    "workspace.currency_select_media": "اختر من الوسائط",
    "Select from media": "اختر من الوسائط",
    "workspace.currency_no_media": "لا توجد ملفات وسائط لديك.",
    "workspace.currency_code": "الرمز",
    "workspace.currency_select_code": "اختر",
    "workspace.currency_exchange_rate": "سعر الصرف",
    "Exchange Rate": "سعر الصرف",
    "workspace.currency_precision": "الدقة",
    "Precision": "الدقة",
    "workspace.currency_thousand_separator": "فاصل الآلاف",
    "Thousand Separator": "فاصل الآلاف",
    "workspace.currency_decimal_point": "الفاصل العشري",
    "Decimal Point": "الفاصل العشري",
    "workspace.currency_status_hint": "الحالة (غير نشطة / نشطة)",
    "workspace.currency_default": "افتراضية",
    "workspace.currency_format": "التنسيق",
    "Format": "التنسيق",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "الاسم",
    "workspace.currency_table_code": "الرمز",
    "workspace.currency_table_format": "التنسيق",
    "workspace.currency_table_exchange": "الصرف",
    "Exchange": "الصرف",
    "workspace.currency_table_status": "الحالة",
    "workspace.currency_table_default": "افتراضية",
    "workspace.currency_table_action": "الإجراء",
    "commissions.title": "العمولات",
    "commissions.add": "إضافة عمولة",
    "Add Commission": "إضافة عمولة",
    "commissions.edit": "تعديل العمولة",
    "Edit Commission": "تعديل العمولة",
    "commissions.delete_confirm": "هل تريد حذف هذه العمولة؟",
    "Do you want to delete this commission?": "هل تريد حذف هذه العمولة؟",
    "commissions.yes": "نعم",
    "commissions.no": "لا",
    "commissions.filter_all": "الكل",
    "commissions.filter_supply": "العرض",
    "Supply": "العرض",
    "commissions.filter_demand": "الطلب",
    "Demand": "الطلب",
    "commissions.filter_cart": "السلة",
    "commissions.table_title": "العنوان",
    "commissions.table_default_value": "القيمة الافتراضية",
    "Default Value": "القيمة الافتراضية",
    "commissions.table_status": "الحالة",
    "commissions.table_action": "الإجراء",
    "commissions.active": "نشط",
    "commissions.inactive": "غير نشط",
    "commissions.type": "النوع",
    "commissions.type_supply": "العرض",
    "commissions.type_demand": "الطلب",
    "commissions.type_cart": "السلة",
    "commissions.select_category": "اختر فئة",
    "Select Category": "اختر فئة",
    "commissions.title_label": "العنوان",
    "commissions.enter_title": "أدخل العنوان",
    "Enter title": "أدخل العنوان",
    "commissions.description": "الوصف",
    "commissions.enter_description": "أدخل الوصف",
    "Enter description": "أدخل الوصف",
    "commissions.default_value_percent": "القيمة الافتراضية (%)",
    "Default value (%)": "القيمة الافتراضية (%)",
    "commissions.short_code": "رمز مختصر",
    "commissions.short_code_tooltip_title": "الرمز المختصر",
    "Short code": "الرمز المختصر",
    "commissions.short_code_tooltip_description": "أدخل رمزًا مختصرًا لهذه العمولة.",
    "Enter a short code for this commission.": "أدخل رمزًا مختصرًا لهذه العمولة.",
    "commissions.enter_short_code": "أدخل الرمز المختصر",
    "commissions.status_hint": "الحالة (غير نشط / نشط)",
    "commissions.optional": "اختياري",
    "commissions.advanced": "متقدم",
    "Advanced": "متقدم",
    "commissions.add_by_category": "إضافة عمولة حسب الفئة",
    "Add commission by category": "إضافة عمولة حسب الفئة",
    "commissions.select_calculation_type": "اختر النوع",
    "commissions.calc_fixed": "ثابت",
    "commissions.calc_slab": "شرائح",
    "Slab": "شرائح",
    "commissions.value": "القيمة",
    "commissions.choose_category": "اختر فئة",
    "Choose category": "اختر فئة",
    "commissions.create_categories_first": "أنشئ الفئات أولًا في إعدادات القوائم",
    "Create categories in Listing Configuration first": "أنشئ الفئات أولًا في إعدادات القوائم",
    "commissions.select_type": "اختر النوع",
    "commissions.demand_fixed": "ثابت",
    "commissions.demand_percentage": "نسبة مئوية",
    "commissions.unlimited_hint": "* أدخل -1 لغير المحدود",
    "* Enter -1 for unlimited": "* أدخل -1 لغير المحدود",
    "commissions.from": "من",
    "commissions.enter_from": "أدخل قيمة البداية",
    "Enter from": "أدخل قيمة البداية",
    "commissions.to": "إلى",
    "commissions.enter_to": "أدخل قيمة النهاية",
    "Enter to": "أدخل قيمة النهاية",
    "commissions.enter_value": "أدخل القيمة",
    "commissions.add_row": "إضافة صف",
    "commissions.minimum_amount": "الحد الأدنى للمبلغ",
    "Minimum amount": "الحد الأدنى للمبلغ",
    "commissions.enter_minimum_amount": "أدخل الحد الأدنى للمبلغ",
    "Enter minimum amount": "أدخل الحد الأدنى للمبلغ",
    "commissions.maximum_amount": "الحد الأقصى للمبلغ",
    "Maximum amount": "الحد الأقصى للمبلغ",
    "commissions.enter_maximum_amount": "أدخل الحد الأقصى للمبلغ",
    "Enter maximum amount": "أدخل الحد الأقصى للمبلغ",
    "commissions.notes": "ملاحظات",
    "Notes": "ملاحظات",
    "commissions.enter_note": "أدخل ملاحظة",
    "Enter note": "أدخل ملاحظة",
    "commissions.from_value": "قيمة البداية",
    "From Value": "قيمة البداية",
    "commissions.to_value": "قيمة النهاية",
    "To Value": "قيمة النهاية",
    "commissions.unlimited_short_hint": "(-1 لغير المحدود)",
    "(-1 for unlimited)": "(-1 لغير المحدود)",
    "commissions.value_percent": "القيمة (%)",
    "Value (%)": "القيمة (%)",
    "commissions.from_value_validation": "يجب أن تكون قيمة البداية أكبر من قيمة النهاية السابقة",
    "From value should be greater than the previous To value": "يجب أن تكون قيمة البداية أكبر من قيمة النهاية السابقة",
    "commissions.to_value_validation": "يجب أن تكون قيمة النهاية أكبر من قيمة البداية",
    "To value should be greater than From value": "يجب أن تكون قيمة النهاية أكبر من قيمة البداية",
    "taxes.title": "الضريبة",
    "taxes.title_plural": "الضرائب",
    "taxes.add": "إضافة ضريبة",
    "Add Tax": "إضافة ضريبة",
    "taxes.edit": "تعديل الضريبة",
    "Edit Tax": "تعديل الضريبة",
    "taxes.delete_confirm": "هل أنت متأكد من حذف هذه الضريبة؟",
    "Are you sure you want to delete this tax?": "هل أنت متأكد من حذف هذه الضريبة؟",
    "taxes.table_title": "العنوان",
    "taxes.table_short_code": "رمز مختصر",
    "taxes.table_default_value": "القيمة الافتراضية",
    "taxes.table_status": "الحالة",
    "taxes.table_action": "الإجراء",
    "taxes.active": "نشط",
    "taxes.inactive": "غير نشط",
    "taxes.select_type": "اختر النوع",
    "taxes.type_order": "الطلب",
    "taxes.type_listing": "القائمة",
    "taxes.type_tax": "الضريبة",
    "taxes.demand_fixed": "ثابت",
    "taxes.demand_percentage": "نسبة مئوية",
    "taxes.from": "من",
    "taxes.enter_from": "أدخل قيمة البداية",
    "taxes.to": "إلى",
    "taxes.enter_to": "أدخل قيمة النهاية",
    "taxes.unlimited_hint": "(-1 لغير المحدود)",
    "taxes.value": "القيمة",
    "taxes.enter_value": "أدخل القيمة",
    "taxes.add_row": "إضافة صف",
    "taxes.note": "ملاحظة",
    "taxes.note_placeholder": "أدخل ملاحظة تظهر للمستخدمين عند الدفع وفي تفاصيل الطلب.",
    "Enter a note for users to see during checkout and in order details.": "أدخل ملاحظة تظهر للمستخدمين عند الدفع وفي تفاصيل الطلب.",
    "taxes.inclusive": "الضريبة مشمولة",
    "Tax Inclusive": "الضريبة مشمولة",
    "taxes.inclusive_tooltip": "فعّل هذا الخيار إذا كان السعر المعروض يشمل الضريبة بالفعل.",
    "Enable this when the listed price already includes tax.": "فعّل هذا الخيار إذا كان السعر المعروض يشمل الضريبة بالفعل.",
    "taxes.title_placeholder": "أدخل اسمًا يظهر للمستخدمين عند الدفع وفي تفاصيل الطلب.",
    "Enter a name shown to users at checkout and in order details.": "أدخل اسمًا يظهر للمستخدمين عند الدفع وفي تفاصيل الطلب.",
    "taxes.default_value": "القيمة الافتراضية (%)",
    "taxes.default_placeholder": "القيمة الافتراضية بالنسبة المئوية. مثال: 6.5",
    "Default value in %. Example: 6.5": "القيمة الافتراضية بالنسبة المئوية. مثال: 6.5",
    "taxes.short_code": "رمز مختصر",
    "taxes.short_code_tooltip_title": "الرمز المختصر",
    "taxes.short_code_tooltip_description": "أدخل رمزًا مختصرًا لهذه الضريبة.",
    "Enter a short code for this tax.": "أدخل رمزًا مختصرًا لهذه الضريبة.",
    "taxes.short_code_placeholder": "استخدم الأحرف والأرقام بحد أقصى 10. مثال: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "استخدم الأحرف والأرقام بحد أقصى 10. مثال: GST10",
    "taxes.status_hint": "الحالة (غير نشط / نشط)",
    "taxes.advanced": "متقدم",
    "special_fees.title": "رسوم خاصة",
    "special_fees.description": "أعدّ رسومًا إضافية ثابتة أو نسبة مئوية لكل قائمة.",
    "Configure an additional fixed amount or percentage fee for each listing.": "أعدّ رسومًا إضافية ثابتة أو نسبة مئوية لكل قائمة.",
    "special_fees.fixed": "رسوم ثابتة",
    "Special fees fixed": "رسوم ثابتة",
    "special_fees.fixed_placeholder": "أدخل مبلغ الرسوم (مثال: 5)",
    "Enter special fee amount (example: 5)": "أدخل مبلغ الرسوم (مثال: 5)",
    "special_fees.percentage": "رسوم النسبة المئوية",
    "Special fees percentage": "رسوم النسبة المئوية",
    "special_fees.percentage_placeholder": "أدخل نسبة الرسوم (مثال: 10٪)",
    "Enter special fee percentage (example: 10%)": "أدخل نسبة الرسوم (مثال: 10٪)",
    "special_fees.example": "مثال",
    "Example": "مثال",
    "special_fees.example_description": "يمكنك إضافة رسوم إلى سعر القائمة. على سبيل المثال، سعر المنتج 100 دولار وتضيف رسمين لكل قائمة.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "يمكنك إضافة رسوم إلى سعر القائمة. على سبيل المثال، سعر المنتج 100 دولار وتضيف رسمين لكل قائمة.",
    "special_fees.example_fixed": "المبلغ الثابت الإضافي = 10 دولارات",
    "Additional fixed amount = $10": "المبلغ الثابت الإضافي = 10 دولارات",
    "special_fees.example_percentage": "النسبة المئوية الإضافية = 10٪",
    "Additional fixed percentage = 10%": "النسبة المئوية الإضافية = 10٪",
    "special_fees.example_total": "السعر النهائي = 120 دولارًا",
    "Final price = $120": "السعر النهائي = 120 دولارًا",
    "delivery.methods_title": "طرق الخدمة والشحن",
    "Service / Shipping Methods": "طرق الخدمة والشحن",
    "delivery.shipping_service": "الشحن / الخدمة",
    "Shipping / Service": "الشحن / الخدمة",
    "delivery.table_name": "الاسم",
    "delivery.table_default": "افتراضي",
    "delivery.table_order": "الترتيب",
    "delivery.table_status": "الحالة",
    "delivery.table_action": "الإجراء",
    "delivery.yes": "نعم",
    "delivery.no": "لا",
    "delivery.active": "نشط",
    "delivery.inactive": "غير نشط",
    "delivery.delete_confirm": "هل تريد حذف طريقة الشحن هذه؟",
    "Do you want to delete this shipping method?": "هل تريد حذف طريقة الشحن هذه؟",
    "delivery.schedule_time": "جدولة الوقت",
    "Schedule Time": "جدولة الوقت",
    "delivery.translate": "ترجمة",
    "delivery.config": "الإعدادات",
    "Config": "الإعدادات",
    "delivery.add": "إضافة خدمة / شحن",
    "Add Shipping/Service": "إضافة خدمة / شحن",
    "delivery.save": "حفظ",
    "delivery.edit": "تعديل الخدمة / الشحن",
    "Edit Shipping/Service": "تعديل الخدمة / الشحن",
    "delivery.stuart_config": "إعدادات Stuart",
    "Stuart Configs": "إعدادات Stuart",
    "delivery.shipping_configs": "إعدادات الخدمة والشحن",
    "Service / Shipping Configs": "إعدادات الخدمة والشحن",
    "delivery.settings": "الإعدادات",
    "delivery.preview": "معاينة",
    "delivery.shipment_option": "خيار الشحن",
    "Shipment Option": "خيار الشحن",
    "delivery.name": "الاسم",
    "delivery.enter_name": "أدخل الاسم",
    "delivery.note": "ملاحظة",
    "delivery.enter_note": "أدخل ملاحظة",
    "delivery.note_tooltip_title": "ملاحظة",
    "delivery.note_tooltip_description": "أضف ملاحظة اختيارية لشرح خيار الشحن أو الخدمة.",
    "Add an optional note to explain this shipping or service option.": "أضف ملاحظة اختيارية لشرح خيار الشحن أو الخدمة.",
    "delivery.order": "الترتيب",
    "delivery.enter_order": "أدخل الترتيب",
    "delivery.status_hint": "الحالة (غير نشط / نشط)",
    "delivery.default": "افتراضي",
    "delivery.select_shipping_method": "اختر طريقة الشحن",
    "Select shipping method": "اختر طريقة الشحن",
    "delivery.select_extension": "اختر إضافة",
    "Select extension": "اختر إضافة",
    "delivery.add_photo": "إضافة صورة",
    "delivery.config.flat_shipping_fee.title": "رسوم شحن ثابتة",
    "Flat Shipping Fee": "رسوم شحن ثابتة",
    "delivery.config.flat_shipping_fee.placeholder": "أدخل رسوم الشحن الثابتة",
    "Enter flat shipping fee": "أدخل رسوم الشحن الثابتة",
    "delivery.config.schedule_time.title": "جدولة الوقت",
    "delivery.config.fulfillment_by_platform_enabled.title": "التنفيذ بواسطة المنصة",
    "Fulfillment by platform": "التنفيذ بواسطة المنصة",
    "delivery.config.fulfilled_by_platform_icon_path.title": "أيقونة تنفيذ المنصة",
    "Fulfillment by Platform Icon": "أيقونة تنفيذ المنصة",
    "delivery.config.fulfilled_by_seller_icon_path.title": "أيقونة توصيل البائع",
    "Seller Delivery Icon": "أيقونة توصيل البائع",
    "delivery.phone_number": "رقم الهاتف",
    "Phone number": "رقم الهاتف",
    "delivery.enter_phone_number": "أدخل رقم الهاتف",
    "Enter phone number": "أدخل رقم الهاتف",
    "delivery.address_line_1": "العنوان سطر 1",
    "Address line 1": "العنوان سطر 1",
    "delivery.enter_address_line_1": "أدخل العنوان سطر 1",
    "Enter address line 1": "أدخل العنوان سطر 1",
    "delivery.address_line_2": "العنوان سطر 2",
    "Address line 2": "العنوان سطر 2",
    "delivery.enter_address_line_2": "أدخل العنوان سطر 2",
    "Enter address line 2": "أدخل العنوان سطر 2",
    "delivery.landmark": "معلم مميز",
    "Landmark": "معلم مميز",
    "delivery.enter_landmark": "أدخل معلمًا مميزًا",
    "Enter landmark": "أدخل معلمًا مميزًا",
    "delivery.state": "الولاية",
    "delivery.enter_state": "أدخل الولاية",
    "Enter state": "أدخل الولاية",
    "delivery.post_code": "الرمز البريدي",
    "Post code": "الرمز البريدي",
    "delivery.enter_post_code": "أدخل الرمز البريدي",
    "Enter post code": "أدخل الرمز البريدي",
    "delivery.country": "البلد",
    "delivery.enter_country": "أدخل البلد",
    "Enter country": "أدخل البلد",
    "delivery.required_information": "يرجى إدخال المعلومات المطلوبة",
    "Please fill the required information": "يرجى إدخال المعلومات المطلوبة",
    "delivery.saved_successfully": "تم الحفظ بنجاح",
    "delivery.storage_hub.title": "نقاط مركز التخزين",
    "Storage Hub Points": "نقاط مركز التخزين",
    "delivery.storage_hub.add": "إضافة مركز تخزين",
    "Add Storage Hub": "إضافة مركز تخزين",
    "delivery.storage_hub.edit": "تعديل مركز التخزين",
    "Edit Storage Hub": "تعديل مركز التخزين",
    "delivery.storage_hub.delete_confirm": "هل تريد حذف نقطة مركز التخزين هذه؟",
    "Do you want to delete this storage hub point?": "هل تريد حذف نقطة مركز التخزين هذه؟",
    "delivery.storage_hub.table_name": "الاسم",
    "delivery.storage_hub.table_phone": "رقم الهاتف",
    "delivery.storage_hub.table_address": "العنوان",
    "delivery.storage_hub.table_landmark": "معلم مميز",
    "delivery.storage_hub.table_state": "الولاية",
    "delivery.storage_hub.table_post_code": "الرمز البريدي",
    "Post Code": "الرمز البريدي",
    "delivery.storage_hub.table_country": "البلد",
    "delivery.storage_hub.table_action": "الإجراء",
    "delivery.select_environment": "اختر البيئة",
    "Select environment": "اختر البيئة",
    "delivery.environment_sandbox": "بيئة الاختبار",
    "Sandbox": "بيئة الاختبار",
    "delivery.environment_production": "الإنتاج",
    "Production": "الإنتاج",
    "delivery.stuart.client_id": "معرّف العميل",
    "delivery.stuart.enter_client_id": "أدخل معرّف العميل",
    "delivery.stuart.client_secret": "سر العميل",
    "Client Secret": "سر العميل",
    "delivery.stuart.enter_client_secret": "أدخل سر العميل",
    "Enter client secret": "أدخل سر العميل",
    "delivery.stuart.webhook_key": "مفتاح مصادقة Webhook",
    "Webhook Authentication Key": "مفتاح مصادقة Webhook",
    "delivery.stuart.enter_webhook_key": "أدخل مفتاح مصادقة Webhook",
    "Enter webhook authentication key": "أدخل مفتاح مصادقة Webhook",
    "delivery.sendcloud.public_key": "المفتاح العام",
    "Public Key": "المفتاح العام",
    "delivery.sendcloud.enter_public_key": "أدخل مفتاح API",
    "delivery.sendcloud.secret_key": "المفتاح السري",
    "Secret Key": "المفتاح السري",
    "delivery.sendcloud.enter_secret_key": "أدخل سر الإشعارات",
    "Enter notification secret": "أدخل سر الإشعارات",
    "delivery.sendcloud.default_shipping_address": "عنوان الشحن الافتراضي",
    "Default Shipping Address": "عنوان الشحن الافتراضي",
    "delivery.sendcloud.add_new": "+ إضافة جديد",
    "+ Add New": "+ إضافة جديد",
    "delivery.sendcloud.country_id": "المعرّف",
    "ID": "المعرّف",
    "payments.title": "طرق الدفع",
    "Payment Methods": "طرق الدفع",
    "payments.add": "إضافة طريقة دفع",
    "Add Payment Method": "إضافة طريقة دفع",
    "payments.edit": "تعديل طريقة الدفع",
    "Edit Payment Method": "تعديل طريقة الدفع",
    "payments.delete_confirm": "هل تريد حذف طريقة الدفع هذه؟",
    "Do you want to delete this payment method?": "هل تريد حذف طريقة الدفع هذه؟",
    "payments.save_continue": "حفظ ومتابعة",
    "Save and continue": "حفظ ومتابعة",
    "payments.translate": "ترجمة طرق الدفع",
    "Translate Payments": "ترجمة طرق الدفع",
    "payments.config": "الإعدادات",
    "payments.integration_settings": "إعدادات التكامل",
    "Integration Settings": "إعدادات التكامل",
    "payments.opp_integration": "تكامل OPP",
    "OPP Integration": "تكامل OPP",
    "payments.billplz_integration": "تكامل BillPlz",
    "BillPlz Integration": "تكامل BillPlz",
    "payments.stripe_integration": "تكامل Stripe",
    "Stripe Integration": "تكامل Stripe",
    "payments.stripe_web_integration": "تكامل Stripe Web",
    "Stripe Web Integration": "تكامل Stripe Web",
    "payments.pawapay_integration": "تكامل PawaPay",
    "PawaPay Integration": "تكامل PawaPay",
    "payments.korapay_integration": "تكامل KoraPay",
    "KoraPay Integration": "تكامل KoraPay",
    "payments.flutterwave_integration": "تكامل Flutterwave",
    "Flutterwave Integration": "تكامل Flutterwave",
    "payments.commercepay_integration": "تكامل CommercePay",
    "CommercePay Integration": "تكامل CommercePay",
    "payments.checkout_com_integration": "تكامل Checkout.com",
    "Checkout.com Integration": "تكامل Checkout.com",
    "payments.paystack_integration": "تكامل PayStack",
    "PayStack Integration": "تكامل PayStack",
    "payments.razorpay_settings": "إعدادات Razorpay",
    "Razorpay settings": "إعدادات Razorpay",
    "payments.paydunya_settings": "إعدادات Pay Dunya",
    "Pay Dunya settings": "إعدادات Pay Dunya",
    "payments.mangopay_settings": "إعدادات MangoPay",
    "MangoPay settings": "إعدادات MangoPay",
    "payments.payu_latam_integration": "تكامل PayU LATAM",
    "PayU LATAM Integration": "تكامل PayU LATAM",
    "payments.table_name": "الاسم",
    "payments.table_actions": "الإجراءات",
    "payments.table_min_amount": "الحد الأدنى للمبلغ",
    "Minimum Amount": "الحد الأدنى للمبلغ",
    "payments.table_max_amount": "الحد الأقصى للمبلغ",
    "Maximum Amount": "الحد الأقصى للمبلغ",
    "payments.table_default": "افتراضي",
    "payments.table_order_by": "الترتيب",
    "payments.table_status": "الحالة",
    "payments.yes": "نعم",
    "payments.no": "لا",
    "payments.active": "نشط",
    "payments.inactive": "غير نشط",
    "payments.settings": "الإعدادات",
    "payments.not_available": "غير متاح",
    "payments.step_select_type": "اختر النوع",
    "payments.step_configure": "إعداد",
    "Configure": "إعداد",
    "payments.step_integration": "التكامل",
    "payments.next": "التالي →",
    "Next →": "التالي →",
    "payments.save": "حفظ",
    "payments.choose_method": "اختر طريقة الدفع لإعدادها",
    "Choose a payment method to configure": "اختر طريقة الدفع لإعدادها",
    "payments.name": "الاسم",
    "payments.enter_name": "أدخل الاسم",
    "payments.maximum_amount": "الحد الأقصى للمبلغ",
    "payments.enter_maximum_amount": "أدخل الحد الأقصى للمبلغ",
    "payments.minimum_amount": "الحد الأدنى للمبلغ",
    "payments.enter_minimum_amount": "أدخل الحد الأدنى للمبلغ",
    "payments.note": "ملاحظة",
    "payments.enter_note": "أدخل ملاحظة",
    "payments.note_tooltip": "أضف ملاحظة اختيارية للعملاء عند الدفع.",
    "Add an optional note for customers at checkout.": "أضف ملاحظة اختيارية للعملاء عند الدفع.",
    "payments.order": "الترتيب",
    "payments.enter_order": "أدخل الترتيب",
    "payments.default": "افتراضي",
    "payments.config_title": "إعدادات طرق الدفع",
    "Payment Methods Configuration": "إعدادات طرق الدفع",
    "payments.wallet_enable": "المحفظة مفعّلة",
    "Wallet enabled": "المحفظة مفعّلة",
    "payments.account_type": "نوع الحساب",
    "payments.select_account_type": "اختر نوع الحساب",
    "Select account type": "اختر نوع الحساب",
    "payments.connect_message_standard": "رسالة الاتصال القياسية",
    "Connect message standard": "رسالة الاتصال القياسية",
    "payments.enter_connect_message_standard": "أدخل رسالة الاتصال القياسية",
    "Enter connect message standard": "أدخل رسالة الاتصال القياسية",
    "payments.disconnect_message_standard": "رسالة قطع الاتصال القياسية",
    "Disconnect message standard": "رسالة قطع الاتصال القياسية",
    "payments.enter_disconnect_message_standard": "أدخل رسالة قطع الاتصال القياسية",
    "Enter disconnect message standard": "أدخل رسالة قطع الاتصال القياسية",
    "payments.connect_message_express": "رسالة الاتصال السريع",
    "Connect message express": "رسالة الاتصال السريع",
    "payments.enter_connect_message_express": "أدخل رسالة الاتصال السريع",
    "Enter connect message express": "أدخل رسالة الاتصال السريع",
    "payments.disconnect_message_express": "رسالة قطع الاتصال السريع",
    "Disconnect message express": "رسالة قطع الاتصال السريع",
    "payments.enter_disconnect_message_express": "أدخل رسالة قطع الاتصال السريع",
    "Enter disconnect message express": "أدخل رسالة قطع الاتصال السريع",
    "payments.enable_sandbox": "تفعيل وضع الاختبار",
    "Enable sandbox": "تفعيل وضع الاختبار",
    "payments.api_token": "رمز API",
    "API Token": "رمز API",
    "payments.enter_token": "أدخل الرمز",
    "Enter token": "أدخل الرمز",
    "payments.key_id": "معرّف المفتاح",
    "Key ID": "معرّف المفتاح",
    "payments.enter_key_id": "أدخل معرّف المفتاح",
    "Enter key ID": "أدخل معرّف المفتاح",
    "payments.key_secret": "المفتاح السري",
    "Key Secret": "المفتاح السري",
    "payments.enter_secret_key": "أدخل المفتاح السري",
    "Enter secret key": "أدخل المفتاح السري",
    "payments.webhook_secret_key": "المفتاح السري لـ webhook",
    "Webhook Secret Key": "المفتاح السري لـ webhook",
    "payments.enter_webhook_secret_key": "أدخل المفتاح السري لـ webhook",
    "Enter webhook secret key": "أدخل المفتاح السري لـ webhook",
    "payments.master_key": "المفتاح الرئيسي",
    "Master Key": "المفتاح الرئيسي",
    "payments.public_key": "المفتاح العام",
    "payments.enter_public_key": "أدخل المفتاح العام",
    "Enter public key": "أدخل المفتاح العام",
    "payments.private_key": "المفتاح الخاص",
    "Private Key": "المفتاح الخاص",
    "payments.merchant_id": "معرّف التاجر",
    "Merchant ID": "معرّف التاجر",
    "payments.enter_merchant_id": "أدخل معرّف التاجر",
    "Enter merchant id": "أدخل معرّف التاجر",
    "payments.processing_channel_id": "معرّف قناة المعالجة",
    "Processing channel ID": "معرّف قناة المعالجة",
    "payments.enter_processing_channel_id": "أدخل معرّف قناة المعالجة",
    "Enter processing channel id": "أدخل معرّف قناة المعالجة",
    "payments.api_key": "مفتاح API",
    "payments.x_signature_key": "مفتاح التوقيع X",
    "X Signature Key": "مفتاح التوقيع X",
    "payments.account_id": "معرّف الحساب",
    "payments.login_api_key": "مفتاح API لتسجيل الدخول",
    "Login API key": "مفتاح API لتسجيل الدخول",
    "payments.client_id": "معرّف العميل",
    "payments.client_api_key": "مفتاح API للعميل",
    "Client API Key": "مفتاح API للعميل",
    "payments.payin_fee": "رسوم PayIn (%)",
    "PayIn fee (%)": "رسوم PayIn (%)",
    "payments.withdraw_fee": "رسوم السحب (%)",
    "Withdraw fee (%)": "رسوم السحب (%)",
    "payments.enter_api_key": "أدخل مفتاح API",
    "payments.enter_account_id": "أدخل معرّف الحساب",
    "Enter account ID": "أدخل معرّف الحساب",
    "payments.enter_login_api_key": "أدخل مفتاح API لتسجيل الدخول",
    "Enter login API key": "أدخل مفتاح API لتسجيل الدخول",
    "payments.enter_notification_secret": "أدخل سر الإشعارات",
    "payments.enter_payin_fee": "أدخل الرسوم كنسبة مئوية",
    "Enter fee as a percentage": "أدخل الرسوم كنسبة مئوية",
    "payments.secret_key": "المفتاح السري",
    "Secret key": "المفتاح السري",
    "payments.publishable_key": "المفتاح القابل للنشر",
    "Publishable key": "المفتاح القابل للنشر",
    "payments.webhook_secret": "سر webhook",
    "Webhook secret": "سر webhook",
    "payments.enter_webhook_secret": "أدخل سر webhook",
    "Enter webhook secret": "أدخل سر webhook",
    "payments.enter_subscription_webhook_secret": "أدخل سر webhook للاشتراك",
    "Enter subscription webhook secret": "أدخل سر webhook للاشتراك",
    "payments.connect_client_id": "معرّف عميل Connect",
    "Connect client ID": "معرّف عميل Connect",
    "payments.enter_connect_client_id": "أدخل معرّف عميل Connect",
    "Enter Connect client ID": "أدخل معرّف عميل Connect",
    "payments.stripe_reminders": "تذكيرات Stripe",
    "Stripe reminders": "تذكيرات Stripe",
    "payments.stripe_sync_help": "يتحقق Sync من المفتاح السري لدى Stripe، ويملأ معلومات الحساب، وينشئ نقاط webhook اللازمة لـ Tradly. تتم تعبئة أسرار webhook تلقائيًا؛ احفظ النموذج عند الانتهاء.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "يتحقق Sync من المفتاح السري لدى Stripe، ويملأ معلومات الحساب، وينشئ نقاط webhook اللازمة لـ Tradly. تتم تعبئة أسرار webhook تلقائيًا؛ احفظ النموذج عند الانتهاء.",
    "payments.find_in_stripe": "اعثر عليه في لوحة Stripe",
    "Find in Stripe Dashboard": "اعثر عليه في لوحة Stripe",
    "payments.description": "الوصف",
    "payments.learn_more_stripe": "معرفة المزيد عن مدفوعات Stripe",
    "Learn more about Stripe Payments": "معرفة المزيد عن مدفوعات Stripe",
    "payments.learn_more_stripe_connect": "معرفة المزيد عن Stripe Connect للأسواق",
    "Learn more about Stripe Connect for marketplaces": "معرفة المزيد عن Stripe Connect للأسواق",
    "payments.token": "رمز",
    "payments.payment_options": "خيارات الدفع",
    "Payment options": "خيارات الدفع",
    "payments.enable_integration": "تفعيل التكامل",
    "Enable integration": "تفعيل التكامل",
    "payments.enter_provider_id": "أدخل معرّف {provider}",
    "Enter {provider} ID": "أدخل معرّف {provider}",
    "payments.integration_status_help": "اضبط هذا المزوّد من إعداداته.",
    "Configure this provider in its settings.": "اضبط هذا المزوّد من إعداداته.",
    "listings.title": "القوائم",
    "listings.manage": "إدارة",
    "listings.show_rows": "إظهار الصفوف",
    "listings.clear": "مسح",
    "listings.apply": "تطبيق",
    "listings.select_date": "اختر تاريخًا",
    "Select date": "اختر تاريخًا",
    "listings.start_date": "تاريخ البدء",
    "listings.end_date": "تاريخ الانتهاء",
    "listings.status_types": "أنواع الحالة",
    "Status types": "أنواع الحالة",
    "listings.categories": "الفئات",
    "listings.attributes": "السمات",
    "listings.clear_all_filters": "مسح جميع عوامل التصفية",
    "Clear all filters": "مسح جميع عوامل التصفية",
    "listings.import": "استيراد",
    "listings.export": "تصدير",
    "listings.smart_upload": "الرفع الذكي (تجريبي)",
    "Smart Upload (Beta)": "الرفع الذكي (تجريبي)",
    "listings.filter_listings": "تصفية القوائم",
    "Filter listings": "تصفية القوائم",
    "listings.sort_listings": "ترتيب القوائم",
    "Sort listings": "ترتيب القوائم",
    "listings.import_listings": "استيراد القوائم",
    "listings.export_listings": "تصدير القوائم",
    "Export listings": "تصدير القوائم",
    "listings.list_view": "عرض القائمة",
    "listings.grid_view": "عرض الشبكة",
    "listings.map_view": "عرض الخريطة",
    "listings.board_view": "عرض اللوحة",
    "listings.export_all_title": "تصدير جميع القوائم؟",
    "Export all listings?": "تصدير جميع القوائم؟",
    "listings.export_all_message": "سيتم تجهيز ملف يتضمن جميع القوائم. هل تريد المتابعة؟",
    "This will prepare a file containing all listings. Do you want to continue?": "سيتم تجهيز ملف يتضمن جميع القوائم. هل تريد المتابعة؟",
    "listings.export_all": "تصدير جميع القوائم",
    "Export all listings": "تصدير جميع القوائم",
    "listings.cancel": "إلغاء",
    "listings.status_all": "الكل",
    "listings.status_pending": "قيد الانتظار",
    "listings.status_approved": "موافق عليه",
    "listings.status_rejected": "مرفوض",
    "listings.status_archived": "مؤرشف",
    "listings.sort_newest_first": "الأحدث أولًا",
    "Newest first": "الأحدث أولًا",
    "listings.sort_price_high_to_low": "السعر: من الأعلى إلى الأقل",
    "Price: high to low": "السعر: من الأعلى إلى الأقل",
    "listings.sort_price_low_to_high": "السعر: من الأقل إلى الأعلى",
    "Price: low to high": "السعر: من الأقل إلى الأعلى",
    "listings.header_0": "العنوان",
    "listings.header_1": "الموقع الإلكتروني",
    "Website": "الموقع الإلكتروني",
    "listings.header_2": "السعر الأصلي",
    "listings.header_3": "نسبة الخصم",
    "listings.header_4": "الصورة",
    "listings.header_5": "سعر العرض",
    "Offer price": "سعر العرض",
    "listings.header_6": "الحالة",
    "listings.header_7": "معرّف القائمة",
    "listings.header_8": "حالة القائمة",
    "Listing status": "حالة القائمة",
    "listings.header_9": "الحسابات",
    "listings.header_10": "العملة",
    "listings.header_11": "مباع",
    "listings.header_12": "مبلغ الهدف",
    "Goal amount": "مبلغ الهدف",
    "listings.filter_status": "الحالة",
    "listings.filter_price": "السعر",
    "listings.filter_category": "الفئة",
    "listings.filter_clear_all": "مسح جميع عوامل التصفية",
    "listings.status_count": "الحالة ({count})",
    "Status ({count})": "الحالة ({count})",
    "listings.price_count": "السعر ({count})",
    "Price ({count})": "السعر ({count})",
    "listings.category_count": "الفئة ({count})",
    "Category ({count})": "الفئة ({count})",
    "listings.search": "البحث في القوائم",
    "listings.clear_search": "مسح البحث عن القوائم",
    "Clear listing search": "مسح البحث عن القوائم",
    "listings.active": "نشط",
    "listings.inactive": "غير نشط",
    "listings.approve": "موافقة",
    "listings.reject": "رفض",
    "listings.delete_confirm": "هل تريد بالتأكيد حذف هذه القائمة؟",
    "listings.approve_confirm": "هل تريد الموافقة على هذه القائمة؟",
    "Do you want to approve this listing?": "هل تريد الموافقة على هذه القائمة؟",
    "listings.reject_confirm": "هل تريد رفض هذه القائمة؟",
    "Do you want to reject this listing?": "هل تريد رفض هذه القائمة؟",
    "listings.yes": "نعم",
    "listings.no": "لا",
    "listings.confirm_delete": "هل تريد بالتأكيد حذف هذه القائمة؟",
    "listings.confirm_approve": "هل تريد الموافقة على هذه القائمة؟",
    "listings.confirm_reject": "هل تريد رفض هذه القائمة؟",
    "listings.column.actions": "الإجراءات",
    "listings.audio_episode": "حلقة صوتية",
    "Audio episode": "حلقة صوتية",
    "listings.video": "فيديو",
    "listings.seller": "البائع",
    "listings.rating": "التقييم",
    "listings.followers": "المتابعون",
    "listings.view_seller_account": "عرض حساب البائع",
    "View seller account": "عرض حساب البائع",
    "listings.add_variant": "إضافة متغير",
    "Add variant": "إضافة متغير",
    "listings.edit": "تعديل",
    "listings.preview": "معاينة",
    "listings.share": "مشاركة",
    "listings.view_listing": "عرض القائمة",
    "View listing": "عرض القائمة",
    "listings.stock": "المخزون",
    "Stock": "المخزون",
    "listings.variants": "المتغيرات",
    "listings.campaign": "الحملة",
    "Campaign": "الحملة",
    "listings.rental_details": "تفاصيل الإيجار",
    "Rental details": "تفاصيل الإيجار",
    "listings.copy": "نسخ",
    "listings.inventory": "المخزون",
    "listings.order_type": "نوع الطلب",
    "Order type": "نوع الطلب",
    "listings.stock_by_location": "المخزون حسب الموقع",
    "Stock by location": "المخزون حسب الموقع",
    "listings.loading_location_stock": "جارٍ تحميل المخزون حسب الموقع…",
    "Loading location stock…": "جارٍ تحميل المخزون حسب الموقع…",
    "listings.no_location_stock": "لا يوجد مخزون مخصص لأي موقع.",
    "No stock assigned to a location.": "لا يوجد مخزون مخصص لأي موقع.",
    "listings.page_analytics": "تحليلات الصفحة",
    "Page analytics": "تحليلات الصفحة",
    "listings.loading": "جارٍ التحميل…",
    "listings.analytics_key_missing": "لم يتم إعداد مفتاح API للتحليلات لهذا المستأجر.",
    "Analytics API key is not configured for this tenant.": "لم يتم إعداد مفتاح API للتحليلات لهذا المستأجر.",
    "listings.no_slug": "لا يوجد رابط مختصر لهذه القائمة.",
    "No slug is available for this listing.": "لا يوجد رابط مختصر لهذه القائمة.",
    "listings.no_analytics": "لم يتم تحميل أي تحليلات بعد.",
    "listings.load_analytics": "تحميل التحليلات",
    "Load analytics": "تحميل التحليلات",
    "listings.no_orders": "لا توجد طلبات لهذه القائمة بعد",
    "No orders yet for this listing": "لا توجد طلبات لهذه القائمة بعد",
    "listings.social_ratings": "التواصل والتقييمات",
    "Social and ratings": "التواصل والتقييمات",
    "listings.tags": "الوسوم",
    "listings.schedule": "الجدول",
    "listings.detail": "التفاصيل",
    "Detail": "التفاصيل",
    "listings.update_stock": "تحديث المخزون",
    "Update stock": "تحديث المخزون",
    "listings.new_stock_quantity": "كمية المخزون الجديدة",
    "New stock quantity": "كمية المخزون الجديدة",
    "listings.location": "الموقع",
    "listings.quantity": "الكمية",
    "listings.current_stock": "المخزون الحالي: {quantity}",
    "Current stock: {quantity}": "المخزون الحالي: {quantity}",
    "listings.loading_rental": "جارٍ تحميل إعدادات الإيجار…",
    "Loading rental settings…": "جارٍ تحميل إعدادات الإيجار…",
    "payments.enter_publishable_key": "أدخل المفتاح القابل للنشر",
    "Enter publishable key": "أدخل المفتاح القابل للنشر",
    "listings.add_listing": "إضافة قائمة",
    "Add listing": "إضافة قائمة",
    "listings.edit_listing": "تعديل القائمة",
    "Edit listing": "تعديل القائمة",
    "listings.enter_title": "أدخل العنوان",
    "listings.account": "الحساب",
    "listings.list_price": "السعر الأصلي",
    "listings.enter_list_price": "أدخل السعر الأصلي",
    "listings.select_currency": "اختر العملة",
    "Select currency": "اختر العملة",
    "listings.select_category": "اختر فئة",
    "listings.select_categories": "اختر الفئات",
    "Select categories": "اختر الفئات",
    "listings.add_category": "+ إضافة فئة",
    "+ Add category": "+ إضافة فئة",
    "listings.add_attribute": "إضافة سمة",
    "Add attribute": "إضافة سمة",
    "listings.enter_stock": "أدخل المخزون",
    "Enter stock": "أدخل المخزون",
    "listings.offer_percentage": "نسبة الخصم",
    "Offer percentage": "نسبة الخصم",
    "listings.enter_offer": "أدخل الخصم",
    "Enter offer": "أدخل الخصم",
    "listings.max_quantity_optional": "الحد الأقصى للكمية (اختياري)",
    "Max quantity (optional)": "الحد الأقصى للكمية (اختياري)",
    "listings.enter_max_quantity": "أدخل الحد الأقصى للكمية",
    "Enter max quantity": "أدخل الحد الأقصى للكمية",
    "listings.enter_slug": "أدخل الرابط المختصر",
    "listings.enter_meta_title": "أدخل عنوان meta",
    "listings.repeat": "تكرار",
    "Repeat": "تكرار",
    "listings.start_time": "وقت البدء",
    "Start time": "وقت البدء",
    "listings.end_time": "وقت الانتهاء",
    "End time": "وقت الانتهاء",
    "listings.slot": "الفترة",
    "Slot": "الفترة",
    "listings.starts_from": "يبدأ من:",
    "Starts from:": "يبدأ من:",
    "listings.add_schedule": "+ إضافة جدول",
    "+ Add schedule": "+ إضافة جدول",
    "listings.upload_here": "ارفع هنا",
    "listings.save": "حفظ",
    "listings.update": "تحديث",
    "listings.tax": "الضريبة",
    "listings.title_required": "يرجى إدخال عنوان",
    "Please enter a title": "يرجى إدخال عنوان",
    "listings.select_tax": "يرجى اختيار ضريبة",
    "Please select a tax": "يرجى اختيار ضريبة",
    "listings.select_item": "يرجى اختيار {item}",
    "Please select {item}": "يرجى اختيار {item}",
    "listings.offer_percentage_validation": "يجب أن تكون نسبة الخصم بين 0 و100",
    "Offer percentage must be between 0 and 100": "يجب أن تكون نسبة الخصم بين 0 و100",
    "listings.custom_seo": "تحسين محركات البحث المخصص",
    "Custom SEO": "تحسين محركات البحث المخصص",
    "listings.select_value": "اختر قيمة",
    "Select value": "اختر قيمة",
    "listings.add_schedule_title": "إضافة جدول",
    "Add schedule": "إضافة جدول",
    "listings.select_from_media": "اختر من الوسائط",
    "listing_form.create_listing": "إنشاء قائمة",
    "Create listing": "إنشاء قائمة",
    "listing_form.update_listing": "تحديث القائمة",
    "Update listing": "تحديث القائمة",
    "listing_form.saving": "جارٍ الحفظ…",
    "listing_form.main_information": "المعلومات الرئيسية",
    "Main information": "المعلومات الرئيسية",
    "listing_form.audio_listing": "قائمة صوتية",
    "Audio listing": "قائمة صوتية",
    "listing_form.basic_information": "المعلومات الأساسية",
    "Basic information": "المعلومات الأساسية",
    "listing_form.listing_type": "نوع القائمة",
    "Listing type": "نوع القائمة",
    "listing_form.title": "العنوان",
    "listing_form.enter_listing_title": "أدخل عنوان القائمة",
    "Enter listing title": "أدخل عنوان القائمة",
    "listing_form.description": "الوصف",
    "listing_form.enter_detailed_description": "أدخل وصفًا تفصيليًا",
    "Enter detailed description": "أدخل وصفًا تفصيليًا",
    "listing_form.tags": "الوسوم",
    "listing_form.tag_example": "مثال: إلكترونيات، أدوات، جديد",
    "e.g., electronics, gadgets, new": "مثال: إلكترونيات، أدوات، جديد",
    "listing_form.taxes": "الضرائب",
    "listing_form.optional": "اختياري",
    "listing_form.start_date": "تاريخ البدء",
    "listing_form.end_date": "تاريخ الانتهاء",
    "listing_form.currency": "العملة",
    "listing_form.select_currency": "اختر العملة",
    "listing_form.goal_price": "السعر المستهدف",
    "Goal price": "السعر المستهدف",
    "listing_form.set_fundraising_goal": "حدد هدف جمع التبرعات",
    "Set your fundraising goal": "حدد هدف جمع التبرعات",
    "listing_form.pricing": "التسعير",
    "Pricing": "التسعير",
    "listing_form.select": "اختر",
    "listing_form.price": "السعر",
    "listing_form.offer_percent": "نسبة الخصم %",
    "Offer %": "نسبة الخصم %",
    "listing_form.listing_price": "سعر القائمة:",
    "Listing price:": "سعر القائمة:",
    "listing_form.set_fundraising_goal_amount": "حدد مبلغ هدف جمع التبرعات",
    "Set your fundraising goal amount": "حدد مبلغ هدف جمع التبرعات",
    "listing_form.category": "الفئة",
    "listing_form.select_a_category": "اختر فئة",
    "Select a category": "اختر فئة",
    "listing_form.clear_selected_category": "مسح الفئة المحددة",
    "Clear selected category": "مسح الفئة المحددة",
    "listing_form.create_new_category": "إنشاء فئة جديدة",
    "Create a new category": "إنشاء فئة جديدة",
    "listing_form.search_categories": "البحث عن الفئات…",
    "Search categories…": "البحث عن الفئات…",
    "listing_form.no_categories_match": "لم يتم العثور على فئات",
    "No categories found": "لم يتم العثور على فئات",
    "listing_form.draft_found": "تم العثور على مسودة محفوظة.",
    "A saved draft was found.": "تم العثور على مسودة محفوظة.",
    "listing_form.restore": "استعادة",
    "Restore": "استعادة",
    "listing_form.discard": "تجاهل",
    "listing_form.characters": "حرفًا",
    "characters": "حرفًا",
    "listing_form.zero_amount": "0.00",
    "0.00": "0.00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "منتجات مادية",
    "Physical products": "منتجات مادية",
    "listing_form.type_events": "فعاليات",
    "listing_form.type_digital": "منتجات رقمية",
    "Digital products": "منتجات رقمية",
    "listing_form.type_appointments": "مواعيد",
    "Appointments": "مواعيد",
    "listing_form.type_rentals": "إيجارات",
    "listing_form.type_donation": "تمويل جماعي",
    "Crowdfunding": "تمويل جماعي",
    "listing_form.type_information_listing": "معلومات",
    "Information": "معلومات",
    "listing_form.type_video_listing": "فيديو",
    "listing_form.type_audio_listing": "صوت",
    "listing_form.select_taxes": "اختر الضرائب (اختياري)",
    "Select taxes (optional)": "اختر الضرائب (اختياري)",
    "listing_form.no_taxes": "لا توجد ضرائب متاحة",
    "No taxes available": "لا توجد ضرائب متاحة",
    "listing_form.inventory_shipping": "المخزون والشحن",
    "Inventory & shipping": "المخزون والشحن",
    "listing_form.stock": "المخزون",
    "listing_form.weight": "الوزن",
    "Weight": "الوزن",
    "listing_form.dimensions": "الأبعاد (ط×ع×ا)",
    "Dimensions (L×W×H)": "الأبعاد (ط×ع×ا)",
    "listing_form.sku": "SKU",
    "listing_form.barcode": "الباركود",
    "listing_form.length": "الطول",
    "Length": "الطول",
    "listing_form.width": "العرض",
    "Width": "العرض",
    "listing_form.height": "الارتفاع",
    "Height": "الارتفاع",
    "listing_form.seo_settings": "إعدادات SEO",
    "SEO settings": "إعدادات SEO",
    "listing_form.slug": "الرابط المختصر",
    "listing_form.url_friendly_title": "نسخة ملائمة للرابط من العنوان",
    "URL-friendly version of the title": "نسخة ملائمة للرابط من العنوان",
    "listing_form.meta_title": "عنوان meta",
    "listing_form.recommended_meta_title": "موصى به: 50–60 حرفًا",
    "Recommended: 50–60 chars": "موصى به: 50–60 حرفًا",
    "listing_form.meta_keywords": "كلمات meta المفتاحية",
    "Meta keywords": "كلمات meta المفتاحية",
    "listing_form.separate_with_commas": "افصل بينها بفواصل",
    "Separate with commas": "افصل بينها بفواصل",
    "listing_form.meta_description": "وصف meta",
    "listing_form.recommended_meta_description": "موصى به: 150–160 حرفًا",
    "Recommended: 150–160 chars": "موصى به: 150–160 حرفًا",
    "listing_form.hide": "إخفاء",
    "listing_form.show": "إظهار",
    "listing_form.seo_fields": "حقول تحسين محركات البحث",
    "search engine optimization fields": "حقول تحسين محركات البحث",
    "listing_form.auto_generated_slug": "يتم إنشاؤه تلقائيًا من العنوان",
    "Auto-generated from title": "يتم إنشاؤه تلقائيًا من العنوان",
    "listing_form.seo_title_optional": "عنوان SEO (اختياري)",
    "SEO title (optional)": "عنوان SEO (اختياري)",
    "listing_form.keywords_comma_separated": "كلمات مفتاحية مفصولة بفواصل",
    "Keywords separated by commas": "كلمات مفتاحية مفصولة بفواصل",
    "listing_form.search_description_optional": "وصف موجز لنتائج البحث (اختياري)",
    "Brief description for search results (optional)": "وصف موجز لنتائج البحث (اختياري)",
    "listing_form.account": "الحساب",
    "listing_form.loading_accounts": "جارٍ تحميل الحسابات…",
    "Loading accounts…": "جارٍ تحميل الحسابات…",
    "listing_form.clear_selected_account": "مسح الحساب المحدد",
    "Clear selected account": "مسح الحساب المحدد",
    "listing_form.search_accounts": "البحث عن الحسابات…",
    "Search accounts…": "البحث عن الحسابات…",
    "listing_form.create_account": "إنشاء حساب جديد",
    "Create a new account": "إنشاء حساب جديد",
    "listing_form.no_accounts_found": "لم يتم العثور على حسابات",
    "No accounts found": "لم يتم العثور على حسابات",
    "listing_form.rental_settings": "إعدادات الإيجار",
    "Rental settings": "إعدادات الإيجار",
    "listing_form.rental_price_help": "يتم احتساب سعر القائمة بناءً على معدل الإيجار ومدته.",
    "The listing price is calculated from the rental rate and duration.": "يتم احتساب سعر القائمة بناءً على معدل الإيجار ومدته.",
    "listing_form.rate_unit": "وحدة السعر",
    "Rate unit": "وحدة السعر",
    "listing_form.hour": "ساعة",
    "Hour": "ساعة",
    "listing_form.day": "يوم",
    "listing_form.week": "أسبوع",
    "listing_form.rental_rate_amount": "معدل الإيجار",
    "Rental rate": "معدل الإيجار",
    "listing_form.rental_min_duration": "المدة الدنيا",
    "Minimum duration": "المدة الدنيا",
    "listing_form.rental_max_duration": "المدة القصوى",
    "Maximum duration": "المدة القصوى",
    "listing_form.rental_buffer_time": "وقت احتياطي (ساعات)",
    "Buffer time (hours)": "وقت احتياطي (ساعات)",
    "listing_form.rental_deposit_amount": "مبلغ التأمين",
    "Deposit amount": "مبلغ التأمين",
    "listing_form.rental_max_units": "الحد الأقصى للوحدات",
    "Maximum units": "الحد الأقصى للوحدات",
    "listing_form.quick_create_title": "إنشاء {entity}",
    "Create {entity}": "إنشاء {entity}",
    "listing_form.close": "إغلاق",
    "listing_form.account_name": "اسم الحساب",
    "listing_form.category_name": "اسم الفئة",
    "Category name": "اسم الفئة",
    "listing_form.account_example": "مثال: متجر أكمي",
    "e.g. Acme Store": "مثال: متجر أكمي",
    "listing_form.category_example": "مثال: منتجات طازجة",
    "e.g. Fresh Produce": "مثال: منتجات طازجة",
    "listing_form.creating": "جارٍ الإنشاء…",
    "listing_form.create_entity": "إنشاء {entity}",
    "listing_form.cancel": "إلغاء",
    "listing_form.go_back": "رجوع",
    "Go back": "رجوع",
    "listing_form.upgrade_plan": "ترقية الخطة",
    "Upgrade plan": "ترقية الخطة",
    "listing_form.close_upgrade_dialog": "إغلاق نافذة الترقية",
    "Close upgrade dialog": "إغلاق نافذة الترقية",
    "listing_form.loading_attributes": "جارٍ تحميل السمات…",
    "Loading attributes…": "جارٍ تحميل السمات…",
    "listing_form.no_attributes": "لا توجد سمات لهذه الفئة",
    "No attributes for this category": "لا توجد سمات لهذه الفئة",
    "listing_form.unsupported_field_type": "نوع الحقل غير مدعوم",
    "Unsupported field type": "نوع الحقل غير مدعوم",
    "listing_form.delete_schedule_confirm": "هل تريد بالتأكيد حذف هذا الجدول؟",
    "Are you sure you want to delete this schedule?": "هل تريد بالتأكيد حذف هذا الجدول؟",
    "listing_form.no_schedules_added": "لم تتم إضافة جداول بعد",
    "No schedules added yet": "لم تتم إضافة جداول بعد",
    "listing_form.stock_label": "المخزون:",
    "Stock:": "المخزون:",
    "listing_form.active": "نشط",
    "listing_form.inactive": "غير نشط",
    "listing_form.edit": "تعديل",
    "listing_form.delete": "حذف",
    "listing_form.schedules": "الجداول",
    "Schedules": "الجداول",
    "listing_form.no_schedules_yet": "لا توجد جداول بعد",
    "No schedules yet": "لا توجد جداول بعد",
    "listing_form.dates_label": "التواريخ:",
    "Dates:": "التواريخ:",
    "listing_form.time_label": "الوقت:",
    "Time:": "الوقت:",
    "listing_form.repeat_label": "التكرار:",
    "Repeat:": "التكرار:",
    "listing_form.capacity_label": "السعة:",
    "Capacity:": "السعة:",
    "listing_form.edit_schedule": "تعديل الجدول",
    "Edit schedule": "تعديل الجدول",
    "listing_form.add_new_schedule": "إضافة جدول جديد",
    "Add new schedule": "إضافة جدول جديد",
    "listing_form.repeat_pattern": "نمط التكرار",
    "Repeat pattern": "نمط التكرار",
    "listing_form.select_days": "اختر الأيام",
    "Select days": "اختر الأيام",
    "listing_form.total_stocks_capacity": "إجمالي المخزون (السعة)",
    "Total stock (capacity)": "إجمالي المخزون (السعة)",
    "listing_form.select_at_least_one_day": "يرجى اختيار يوم واحد على الأقل",
    "Please select at least one day": "يرجى اختيار يوم واحد على الأقل",
    "listing_form.unlimited_capacity_help": "اتركه فارغًا لسعة غير محدودة",
    "Leave empty for unlimited capacity": "اتركه فارغًا لسعة غير محدودة",
    "listing_form.add_schedule": "+ إضافة جدول",
    "listing_form.schedule_number": "الجدول رقم {number}",
    "Schedule #{number}": "الجدول رقم {number}",
    "listing_form.update_action": "تحديث",
    "update": "تحديث",
    "listing_form.create_action": "إنشاء",
    "create": "إنشاء",
    "listing_form.a_schedule": "جدولًا",
    "a schedule": "جدولًا",
    "listing_form.daily": "يوميًا",
    "listing_form.weekdays": "أيام الأسبوع (الاثنين إلى الجمعة)",
    "Weekdays (Mon - Fri)": "أيام الأسبوع (الاثنين إلى الجمعة)",
    "listing_form.weekend": "نهاية الأسبوع (السبت والأحد)",
    "Weekend (Sat - Sun)": "نهاية الأسبوع (السبت والأحد)",
    "listing_form.custom": "مخصص",
    "listing_form.weekday_0": "الاثنين",
    "Monday": "الاثنين",
    "listing_form.weekday_1": "الثلاثاء",
    "Tuesday": "الثلاثاء",
    "listing_form.weekday_2": "الأربعاء",
    "Wednesday": "الأربعاء",
    "listing_form.weekday_3": "الخميس",
    "Thursday": "الخميس",
    "listing_form.weekday_4": "الجمعة",
    "Friday": "الجمعة",
    "listing_form.weekday_5": "السبت",
    "Saturday": "السبت",
    "listing_form.weekday_6": "الأحد",
    "Sunday": "الأحد",
    "listing_form.media_max_files": "الحد الأقصى {count} من {type} مسموح",
    "Maximum {count} {type} allowed": "الحد الأقصى {count} من {type} مسموح",
    "listing_form.video_size_limit": "يجب ألا يتجاوز حجم كل فيديو 1 جيجابايت",
    "Each video must be 1GB or smaller": "يجب ألا يتجاوز حجم كل فيديو 1 جيجابايت",
    "listing_form.videos": "الفيديوهات",
    "Videos": "الفيديوهات",
    "listing_form.images": "الصور",
    "listing_form.select_from_media": "اختر من الوسائط",
    "listing_form.video_upload_help": "حمّل فيديوهات بصيغة MP4 أو MOV أو AVI أو MKV أو WebM (بحد أقصى 1 جيجابايت لكل فيديو)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "حمّل فيديوهات بصيغة MP4 أو MOV أو AVI أو MKV أو WebM (بحد أقصى 1 جيجابايت لكل فيديو)",
    "listing_form.image_upload_help": "حمّل صورًا بصيغة JPG أو PNG أو GIF أو WebP (بحد أقصى 10 ميجابايت لكل صورة)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "حمّل صورًا بصيغة JPG أو PNG أو GIF أو WebP (بحد أقصى 10 ميجابايت لكل صورة)",
    "listing_form.uploading_video": "جارٍ تحميل الفيديو…",
    "Uploading video…": "جارٍ تحميل الفيديو…",
    "listing_form.audio_episode": "حلقة صوتية",
    "listing_form.audio_upload_help": "حمّل ملفًا صوتيًا أو الصق رابطًا صوتيًا عامًا لخلاصة RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "حمّل ملفًا صوتيًا أو الصق رابطًا صوتيًا عامًا لخلاصة RSS.",
    "listing_form.selected_file": "المحدد: {name}",
    "listing_form.audio_url_help": "الرابط اختياري عند تحديد ملف. اتركه فارغًا لاستخدام الملف الذي تم تحميله.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "الرابط اختياري عند تحديد ملف. اتركه فارغًا لاستخدام الملف الذي تم تحميله.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "جارٍ تحميل الصوت…",
    "Uploading audio…": "جارٍ تحميل الصوت…",
    "listing_form.validation_start_date": "يرجى تحديد تاريخ البدء",
    "Please select start date": "يرجى تحديد تاريخ البدء",
    "listing_form.validation_end_date": "يرجى تحديد تاريخ الانتهاء",
    "Please select end date": "يرجى تحديد تاريخ الانتهاء",
    "listing_form.validation_start_time": "يرجى تحديد وقت البدء",
    "Please select start time": "يرجى تحديد وقت البدء",
    "listing_form.validation_end_time": "يرجى تحديد وقت الانتهاء",
    "Please select end time": "يرجى تحديد وقت الانتهاء",
    "listing_form.weekdays_short": "أيام الأسبوع",
    "Weekdays": "أيام الأسبوع",
    "listing_form.weekend_short": "عطلة نهاية الأسبوع",
    "Weekend": "عطلة نهاية الأسبوع",
    "listing_form.click_add_schedule_help": "انقر على \"{action}\" لإنشاء جدولك الأول",
    "Click \"{action}\" to create your first schedule": "انقر على \"{action}\" لإنشاء جدولك الأول",
    "listing_form.schedule_form_intro": "أدخل التفاصيل أدناه من أجل",
    "Fill in the details below to": "أدخل التفاصيل أدناه من أجل",
    "listing_form.update": "تحديث",
    "listing_form.save": "حفظ",
    "listing_form.variant_value_required": "يرجى تحديد قيمة متغير واحدة على الأقل (مثل اللون أو المقاس)",
    "Please select at least one variant value (e.g., Color, Size)": "يرجى تحديد قيمة متغير واحدة على الأقل (مثل اللون أو المقاس)",
    "listing_form.valid_price_required": "يرجى إدخال سعر صالح",
    "Please enter a valid price": "يرجى إدخال سعر صالح",
    "listing_form.delete_variant_confirm": "هل تريد بالتأكيد حذف هذا المتغير؟",
    "listing_form.product_variants": "متغيرات المنتج",
    "Product Variants": "متغيرات المنتج",
    "listing_form.add_variant": "+ إضافة متغير",
    "+ Add Variant": "+ إضافة متغير",
    "listing_form.select_all_variants": "تحديد كل المتغيرات",
    "Select all variants": "تحديد كل المتغيرات",
    "listing_form.set_quantity_selected": "تحديد كمية العناصر المحددة",
    "Set quantity for selected": "تحديد كمية العناصر المحددة",
    "listing_form.quantity": "الكمية",
    "listing_form.apply_quantity": "تطبيق الكمية",
    "Apply quantity": "تطبيق الكمية",
    "listing_form.select_variant_number": "تحديد المتغير {number}",
    "Select variant {number}": "تحديد المتغير {number}",
    "listing_form.variant_number": "المتغير رقم {number}",
    "Variant #{number}": "المتغير رقم {number}",
    "listing_form.existing": "موجود",
    "Existing": "موجود",
    "listing_form.modified": "معدّل",
    "Modified": "معدّل",
    "listing_form.variant_name": "اسم المتغير",
    "Variant Name": "اسم المتغير",
    "listing_form.variant_values": "قيم المتغير",
    "Variant Values": "قيم المتغير",
    "listing_form.type": "النوع",
    "listing_form.no_variant_values": "لا توجد قيم للمتغير",
    "No variant values": "لا توجد قيم للمتغير",
    "listing_form.no_variants_yet": "لا توجد متغيرات بعد",
    "No variants yet": "لا توجد متغيرات بعد",
    "listing_form.click_add_variant_help": "انقر على \"{action}\" لإنشاء أول متغير",
    "Click \"{action}\" to create your first variant": "انقر على \"{action}\" لإنشاء أول متغير",
    "listing_form.select_variant_type": "اختر {type}",
    "Select {type}": "اختر {type}",
    "listing_form.no_variant_types": "لا تتوفر أنواع متغيرات. يرجى إنشاء أنواع متغيرات (مثل اللون والمقاس) أولاً.",
    "No variant types available. Please create variant types (like Color, Size) first.": "لا تتوفر أنواع متغيرات. يرجى إنشاء أنواع متغيرات (مثل اللون والمقاس) أولاً.",
    "listing_form.generated_name": "الاسم المُنشأ:",
    "Generated Name:": "الاسم المُنشأ:",
    "listing_form.custom_title": "عنوان مخصص",
    "Custom Title": "عنوان مخصص",
    "listing_form.auto_generate_help": "اتركه فارغًا للإنشاء تلقائيًا",
    "Leave blank to auto-generate": "اتركه فارغًا للإنشاء تلقائيًا",
    "listing_form.save_variant": "حفظ المتغير",
    "Save Variant": "حفظ المتغير",
    "listing_form.start_time": "وقت البدء",
    "Start Time": "وقت البدء",
    "listing_form.end_time": "وقت الانتهاء",
    "End Time": "وقت الانتهاء",
    "listing_form.enter_capacity_limit": "أدخل حد السعة",
    "Enter capacity limit": "أدخل حد السعة",
    "collections.validation_title": "يجب ألا يكون العنوان فارغًا",
    "Title should not be empty": "يجب ألا يكون العنوان فارغًا",
    "collections.validation_platform": "يرجى تحديد منصة واحدة على الأقل",
    "Select at least one platform": "يرجى تحديد منصة واحدة على الأقل",
    "collections.validation_dates": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
    "End Date must be later than start date": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
    "collections.validation_minimum_selection": "حدد {type} واحدًا على الأقل",
    "Select at least one {type}": "حدد {type} واحدًا على الأقل",
    "collections.account": "حساب",
    "account": "حساب",
    "collections.listing": "إعلان",
    "listing": "إعلان",
    "collections.edit_title": "تعديل المجموعة",
    "Edit Collection": "تعديل المجموعة",
    "collections.create_title": "إنشاء مجموعة",
    "Create Collection": "إنشاء مجموعة",
    "collections.details": "تفاصيل المجموعة",
    "Collection details": "تفاصيل المجموعة",
    "collections.title_placeholder": "أدخل العنوان",
    "Enter title name": "أدخل العنوان",
    "collections.slug": "المعرّف المختصر",
    "collections.slug_placeholder": "أدخل المعرّف المختصر",
    "collections.enter_title_first": "يرجى إدخال عنوان أولاً",
    "collections.scope": "النطاق",
    "collections.accounts": "الحسابات",
    "collections.listings": "الإعلانات",
    "collections.choose_category": "اختر فئة",
    "collections.conditions": "الشروط",
    "Conditions": "الشروط",
    "collections.condition_type": "نوع الشرط",
    "Condition type": "نوع الشرط",
    "collections.manual": "يدوي",
    "Manual": "يدوي",
    "collections.automated": "تلقائي",
    "Automated": "تلقائي",
    "collections.availability": "توفر المجموعة",
    "Collections availability": "توفر المجموعة",
    "collections.schedule": "الجدولة",
    "collections.applicable_channels": "حدد القنوات المناسبة",
    "Select applicable channel": "حدد القنوات المناسبة",
    "collections.web": "الويب",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "ابحث بالاسم",
    "Search by name": "ابحث بالاسم",
    "collections.not_found": "المجموعة غير موجودة.",
    "Collection not found.": "المجموعة غير موجودة.",
    "collections.featured_listings": "الإعلانات المميزة",
    "Featured listings": "الإعلانات المميزة",
    "collections.url_copied": "تم نسخ الرابط العام",
    "Public URL copied": "تم نسخ الرابط العام",
    "collections.url_copy_failed": "تعذر نسخ الرابط العام",
    "Unable to copy the public URL": "تعذر نسخ الرابط العام",
    "collections.collection": "مجموعة",
    "Collection": "مجموعة",
    "collections.this_collection": "هذه المجموعة",
    "this collection": "هذه المجموعة",
    "collections.share_text": "عرض {title}",
    "View {title}": "عرض {title}",
    "collections.public_url": "الرابط العام:",
    "Public URL:": "الرابط العام:",
    "collections.copy_url": "نسخ الرابط",
    "Copy URL": "نسخ الرابط",
    "collections.items": "العناصر",
    "collections.expires": "ينتهي",
    "collections.never": "أبدًا",
    "Never": "أبدًا",
    "collections.automatic_conditions": "الشروط التلقائية",
    "Automatic Conditions": "الشروط التلقائية",
    "collections.item_count": "{count} عنصر",
    "collections.loading_items": "جارٍ تحميل العناصر…",
    "Loading items…": "جارٍ تحميل العناصر…",
    "collections.no_items": "لا توجد عناصر في هذه المجموعة حتى الآن.",
    "No items in this collection yet.": "لا توجد عناصر في هذه المجموعة حتى الآن.",
    "collections.delete_confirm": "هل تريد حذف هذه المجموعة؟",
    "Do you want to delete this collection?": "هل تريد حذف هذه المجموعة؟",
    "collections.title": "المجموعات",
    "collections.header_title": "العنوان",
    "collections.header_action": "الإجراء",
    "collections.header_id": "المعرّف",
    "collections.header_condition_type": "نوع الشرط",
    "Condition Type": "نوع الشرط",
    "collections.header_scope": "النطاق",
    "collections.header_start_date": "تاريخ البدء",
    "collections.header_end_date": "تاريخ الانتهاء",
    "collections.header_status": "الحالة",
    "collections.header_url": "الرابط",
    "common.calendar_view": "عرض التقويم",
    "Calendar view": "عرض التقويم",
    "common.deleted": "تم الحذف",
    "Deleted": "تم الحذف",
    "common.list_view": "عرض القائمة",
    "common.description": "الوصف",
    "common.title": "العنوان",
    "common.end_date": "تاريخ الانتهاء",
    "common.start_date": "تاريخ البدء",
    "promotions.image_required": "يرجى إضافة صورة",
    "Please add an image": "يرجى إضافة صورة",
    "promotions.edit_title": "تعديل العرض الترويجي",
    "Edit Promotion": "تعديل العرض الترويجي",
    "promotions.add_title": "إضافة عرض ترويجي",
    "Add Promotion": "إضافة عرض ترويجي",
    "promotions.name": "اسم العرض الترويجي",
    "Promotion Name": "اسم العرض الترويجي",
    "promotions.select_medium": "اختر الوسيط",
    "Select Medium": "اختر الوسيط",
    "promotions.upload_media": "تحميل الوسائط",
    "promotions.schedule": "الجدولة",
    "promotions.destination_type": "نوع الوجهة",
    "Destination Type": "نوع الوجهة",
    "promotions.placement": "موضع العرض",
    "promotions.status": "الحالة (غير نشط / نشط)",
    "promotions.delete_confirm": "هل تريد حذف هذا العرض الترويجي؟",
    "Do you want to delete this promotion?": "هل تريد حذف هذا العرض الترويجي؟",
    "promotions.title": "العروض الترويجية",
    "promotions.header_image": "الصورة",
    "promotions.header_medium": "الوسيط",
    "promotions.header_placement": "الموضع",
    "promotions.header_type": "النوع",
    "promotions.header_value": "القيمة",
    "promotions.header_active": "نشط",
    "promotions.header_action": "الإجراء",
    "promotions.header_start_at": "وقت البدء",
    "Start At": "وقت البدء",
    "promotions.header_end_at": "وقت الانتهاء",
    "End At": "وقت الانتهاء",
    "common.grid_view": "عرض الشبكة",
    "promotions.type_general": "عام",
    "promotions.type_listing": "إعلان",
    "promotions.type_account": "حساب",
    "promotions.type_external_link": "رابط خارجي",
    "External link": "رابط خارجي",
    "promotions.preview": "معاينة",
    "promotions.select_listing": "اختر إعلانًا",
    "Select Listing": "اختر إعلانًا",
    "promotions.select_account": "اختر حسابًا",
    "Select Account": "اختر حسابًا",
    "promotions.home_placement": "الرئيسية",
    "promotions.footer_placement": "تذييل الصفحة",
    "Footer": "تذييل الصفحة",
    "promotions.web_only": "(للويب فقط)",
    "(Web Only)": "(للويب فقط)",
    "coupons.edit_title": "تعديل القسيمة",
    "Edit Coupon": "تعديل القسيمة",
    "coupons.add_title": "إضافة قسيمة",
    "Add Coupon": "إضافة قسيمة",
    "coupons.reference_name": "الاسم المرجعي",
    "Reference Name": "الاسم المرجعي",
    "coupons.enter_name": "أدخل الاسم",
    "coupons.coupon_type": "نوع القسيمة",
    "Coupon type": "نوع القسيمة",
    "coupons.discount_value": "قيمة الخصم",
    "Discount Value": "قيمة الخصم",
    "coupons.enter_discount_value": "أدخل قيمة الخصم",
    "Enter discount value": "أدخل قيمة الخصم",
    "coupons.code": "الرمز",
    "coupons.code_example": "مثال: HOLIDAY10",
    "Ex: HOLIDAY10": "مثال: HOLIDAY10",
    "coupons.short_code": "رمز قصير",
    "coupons.enter_short_code": "أدخل الرمز القصير",
    "coupons.advanced": "إعدادات متقدمة",
    "ADVANCED": "إعدادات متقدمة",
    "coupons.minimum_amount": "الحد الأدنى للمبلغ",
    "coupons.enter_minimum_amount": "أدخل الحد الأدنى للمبلغ",
    "coupons.maximum_amount": "الحد الأقصى للمبلغ",
    "coupons.enter_maximum_amount": "أدخل الحد الأقصى للمبلغ",
    "coupons.maximum_discount_amount": "الحد الأقصى لقيمة الخصم",
    "Maximum Discount Amount": "الحد الأقصى لقيمة الخصم",
    "coupons.enter_maximum_discount_amount": "أدخل الحد الأقصى لقيمة الخصم",
    "Enter maximum discount amount": "أدخل الحد الأقصى لقيمة الخصم",
    "coupons.maximum_uses": "الحد الأقصى لعدد الاستخدامات",
    "Maximum Uses": "الحد الأقصى لعدد الاستخدامات",
    "coupons.enter_maximum_uses": "أدخل الحد الأقصى للاستخدامات",
    "Enter maximum uses": "أدخل الحد الأقصى للاستخدامات",
    "coupons.maximum_uses_per_user": "الحد الأقصى للاستخدامات لكل مستخدم",
    "Maximum Uses Per User": "الحد الأقصى للاستخدامات لكل مستخدم",
    "coupons.enter_maximum_uses_per_user": "أدخل الحد الأقصى للاستخدامات لكل مستخدم",
    "Enter maximum uses per user": "أدخل الحد الأقصى للاستخدامات لكل مستخدم",
    "coupons.new_user_only": "مستخدم جديد",
    "New User": "مستخدم جديد",
    "coupons.enter_note": "أدخل ملاحظة",
    "coupons.start_date_time": "تاريخ ووقت البدء",
    "Start Date Time": "تاريخ ووقت البدء",
    "coupons.end_date_time": "تاريخ ووقت الانتهاء",
    "End Date Time": "تاريخ ووقت الانتهاء",
    "coupons.select_start_date_time": "اختر تاريخ ووقت البدء",
    "Select start date time": "اختر تاريخ ووقت البدء",
    "coupons.select_end_date_time": "اختر تاريخ ووقت الانتهاء",
    "Select end date time": "اختر تاريخ ووقت الانتهاء",
    "coupons.flat_example": "مبلغ ثابت (مثال: 10$)",
    "Flat (Ex: $10)": "مبلغ ثابت (مثال: 10$)",
    "coupons.percentage_example": "نسبة مئوية (مثال: 10٪)",
    "Percentage (Ex: 10%)": "نسبة مئوية (مثال: 10٪)",
    "coupons.delete_confirm": "هل تريد حذف هذه القسيمة؟",
    "Do you want to delete this coupon?": "هل تريد حذف هذه القسيمة؟",
    "coupons.title": "القسائم",
    "coupons.header_name": "الاسم",
    "coupons.header_code": "الرمز",
    "coupons.header_coupon_type": "نوع القسيمة",
    "Coupon Type": "نوع القسيمة",
    "coupons.header_start_date_time": "تاريخ ووقت البدء",
    "coupons.header_end_date_time": "تاريخ ووقت الانتهاء",
    "coupons.header_active": "نشط",
    "coupons.header_action": "الإجراء",
    "coupons.load_error": "تعذر تحميل هذه القسيمة.",
    "Unable to load this coupon.": "تعذر تحميل هذه القسيمة.",
    "coupons.expired": "منتهية الصلاحية",
    "coupons.total_orders": "إجمالي الطلبات",
    "coupons.unique_customers": "العملاء الفريدون",
    "Unique Customers": "العملاء الفريدون",
    "coupons.revenue": "الإيرادات",
    "coupons.average_transaction": "متوسط المعاملة",
    "Avg Transaction": "متوسط المعاملة",
    "coupons.paid_orders": "الطلبات المدفوعة",
    "coupons.uses_remaining": "الاستخدامات المتبقية",
    "Uses Remaining": "الاستخدامات المتبقية",
    "coupons.unlimited": "غير محدود",
    "Unlimited": "غير محدود",
    "coupons.performance": "الأداء",
    "Performance": "الأداء",
    "coupons.usage_against_limit": "الاستخدام مقارنة بالحد",
    "Usage against limit": "الاستخدام مقارنة بالحد",
    "coupons.details": "التفاصيل",
    "coupons.discount": "الخصم",
    "coupons.minimum_order": "الحد الأدنى للطلب",
    "Min order": "الحد الأدنى للطلب",
    "coupons.maximum_discount": "الحد الأقصى للخصم",
    "Max discount": "الحد الأقصى للخصم",
    "coupons.maximum_total_uses": "الحد الأقصى لإجمالي الاستخدامات",
    "Max total uses": "الحد الأقصى لإجمالي الاستخدامات",
    "coupons.maximum_per_user": "الحد الأقصى لكل مستخدم",
    "Max / user": "الحد الأقصى لكل مستخدم",
    "coupons.new_users_only": "للمستخدمين الجدد فقط",
    "New users only": "للمستخدمين الجدد فقط",
    "coupons.valid_from": "صالح من",
    "Valid from": "صالح من",
    "coupons.valid_until": "صالح حتى",
    "Valid until": "صالح حتى",
    "coupons.orders": "الطلبات",
    "coupons.no_orders": "لم تستخدم أي طلبات هذه القسيمة بعد",
    "No orders have used this coupon yet": "لم تستخدم أي طلبات هذه القسيمة بعد",
    "coupons.orders_header_order": "الطلب",
    "coupons.orders_header_customer": "العميل",
    "coupons.orders_header_date": "التاريخ",
    "coupons.orders_header_amount": "المبلغ",
    "coupons.orders_header_status": "الحالة",
    "coupons.paid": "مدفوع",
    "coupons.pending": "قيد الانتظار",
    "coupons.coupon": "قسيمة",
    "coupons.detail_title": "تفاصيل القسيمة",
    "Coupon Detail": "تفاصيل القسيمة",
    "coupons.discount_percentage": "{value}٪ خصم",
    "{value}% off": "{value}٪ خصم",
    "coupons.discount_flat": "خصم ثابت بقيمة {value}",
    "{value} flat off": "خصم ثابت بقيمة {value}",
    "coupons.type_direct_discount": "خصم مباشر",
    "Direct discount": "خصم مباشر",
    "collections.condition_and": "و",
    "AND": "و",
    "collections.condition_or": "أو",
    "OR": "أو",
    "users.first_seen": "أول ظهور",
    "First seen": "أول ظهور",
    "users.last_seen": "آخر ظهور",
    "Last seen": "آخر ظهور",
    "users.avg_order": "متوسط الطلب",
    "Avg order": "متوسط الطلب",
    "users.purchase_value": "قيمة المشتريات",
    "Purchase value": "قيمة المشتريات",
    "users.price_range": "نطاق السعر",
    "Price range": "نطاق السعر",
    "users.attributes": "السمات",
    "users.detail_title": "تفاصيل المستخدم",
    "User Detail": "تفاصيل المستخدم",
    "users.detail_orders_list": "قائمة طلبات المستخدم",
    "User Orders List": "قائمة طلبات المستخدم",
    "users.confirm_user_action": "هل تريد {action} {name}؟",
    "{action} {name}?": "هل تريد {action} {name}؟",
    "users.as_buyer": "كمشترٍ",
    "As a Buyer": "كمشترٍ",
    "users.as_seller": "كَبائع",
    "As a Seller": "كَبائع",
    "users.health": "الحالة",
    "users.no_listings": "لا توجد إعلانات بعد",
    "users.no_accounts": "لا توجد حسابات بعد",
    "No accounts yet": "لا توجد حسابات بعد",
    "users.top_categories": "أهم الفئات",
    "Top categories": "أهم الفئات",
    "users.top_listings": "أهم الإعلانات",
    "Top listings": "أهم الإعلانات",
    "users.recent_activity": "النشاط الأخير",
    "Recent activity": "النشاط الأخير",
    "users.acquisition": "الاكتساب",
    "Acquisition": "الاكتساب",
    "users.sent_emails": "رسائل البريد المرسلة",
    "Sent Emails": "رسائل البريد المرسلة",
    "users.no_emails_sent": "لم يتم إرسال رسائل بريد إلكتروني",
    "No emails sent": "لم يتم إرسال رسائل بريد إلكتروني",
    "users.load_more_emails": "تحميل المزيد ({loaded} / {total})",
    "Load More ({loaded} / {total})": "تحميل المزيد ({loaded} / {total})",
    "users.email_to": "إلى: {email}",
    "To: {email}": "إلى: {email}",
    "users.sending_email": "جارٍ الإرسال…",
    "users.send_email": "إرسال بريد إلكتروني",
    "Send Email": "إرسال بريد إلكتروني",
    "users.send_email_title": "إرسال بريد إلكتروني — {name}",
    "Send Email — {name}": "إرسال بريد إلكتروني — {name}",
    "users.customer": "العميل",
    "users.block_named": "حظر {name}",
    "Block {name}": "حظر {name}",
    "users.unblock_named": "إلغاء حظر {name}",
    "Unblock {name}": "إلغاء حظر {name}",
    "users.email_sent": "تم إرسال البريد الإلكتروني بنجاح",
    "Email sent successfully": "تم إرسال البريد الإلكتروني بنجاح",
    "users.email_send_failed": "فشل إرسال البريد الإلكتروني",
    "Failed to send email": "فشل إرسال البريد الإلكتروني",
    "common.value": "القيمة",
    "users.email_bounced": "مرتد",
    "Bounced": "مرتد",
    "users.email_complained": "تم الإبلاغ عنه كرسالة مزعجة",
    "Complained": "تم الإبلاغ عنه كرسالة مزعجة",
    "users.unverified": "لم يتم التحقق",
    "Unverified": "لم يتم التحقق",
    "users.otp_enabled": "تم تفعيل OTP",
    "OTP Enabled": "تم تفعيل OTP",
    "users.account_info": "معلومات الحساب",
    "Account Info": "معلومات الحساب",
    "users.mobile": "الهاتف المحمول",
    "users.locale": "اللغة",
    "Locale": "اللغة",
    "users.joined": "تاريخ الانضمام",
    "users.following": "يتابع",
    "Following": "يتابع",
    "users.email_health": "حالة البريد الإلكتروني",
    "Email Health": "حالة البريد الإلكتروني",
    "users.orders": "الطلبات",
    "users.no_orders": "لا توجد طلبات",
    "No orders": "لا توجد طلبات",
    "users.order_reference": "الطلب {number}",
    "Order {number}": "الطلب {number}",
    "users.order_ref": "المرجع: {reference}",
    "Ref: {reference}": "المرجع: {reference}",
    "users.unpaid": "غير مدفوع",
    "users.revenue_ltv": "الإيرادات والقيمة الدائمة للعميل",
    "Revenue & LTV": "الإيرادات والقيمة الدائمة للعميل",
    "users.total_spent": "إجمالي الإنفاق",
    "Total Spent": "إجمالي الإنفاق",
    "users.paid_order_count": "{count} طلبات مدفوعة",
    "{count} paid orders": "{count} طلبات مدفوعة",
    "users.average_order": "متوسط الطلب",
    "users.of_total_orders": "من إجمالي {count}",
    "of {count} total": "من إجمالي {count}",
    "users.gmv": "إجمالي قيمة البضائع",
    "GMV": "إجمالي قيمة البضائع",
    "users.active_count": "{count} نشط",
    "{count} active": "{count} نشط",
    "users.at_risk": "معرّض للخطر",
    "At Risk": "معرّض للخطر",
    "common.today": "اليوم",
    "common.yesterday": "أمس",
    "Yesterday": "أمس",
    "users.days_ago": "قبل {count} يومًا",
    "{count} days ago": "قبل {count} يومًا",
    "users.months_ago": "قبل {count} شهرًا",
    "{count} months ago": "قبل {count} شهرًا",
    "users.years_ago": "قبل {count} سنة",
    "{count} years ago": "قبل {count} سنة",
    "users.last_order": "آخر طلب",
    "Last order": "آخر طلب",
    "users.last_listing": "آخر إعلان",
    "Last listing": "آخر إعلان",
    "users.events": "الأحداث",
    "users.viewed": "المشاهدات",
    "Viewed": "المشاهدات",
    "users.cart": "السلة",
    "users.checkouts": "عمليات الدفع",
    "Checkouts": "عمليات الدفع",
    "users.purchases": "المشتريات",
    "Purchases": "المشتريات",
    "users.last_30_days": "آخر 30 يومًا",
    "Last 30 days": "آخر 30 يومًا",
    "users.no_analytics": "لا توجد بيانات تحليلات لهذا المستخدم بعد.",
    "No analytics data for this user yet.": "لا توجد بيانات تحليلات لهذا المستخدم بعد.",
    "users.analytics_unavailable": "التحليلات غير متاحة لهذا المستأجر.",
    "Analytics unavailable for this tenant.": "التحليلات غير متاحة لهذا المستأجر.",
    "users.account_number": "الحساب رقم {number}",
    "Account #{number}": "الحساب رقم {number}",
    "users.no_subject": "بلا موضوع",
    "No Subject": "بلا موضوع",
    "common.unknown": "غير معروف",
    "users.opened": "مفتوح",
    "Opened": "مفتوح",
    "users.not_opened": "غير مفتوح",
    "Not opened": "غير مفتوح",
    "users.user_action_success": "تم تنفيذ إجراء المستخدم",
    "User action completed": "تم تنفيذ إجراء المستخدم",
    "common.pending": "قيد الانتظار",
    "common.never": "أبدًا",
    "users.customer_analytics": "تحليلات العميل",
    "Customer Analytics": "تحليلات العميل",
    "users.analytics": "التحليلات",
    "users.emails": "رسائل البريد",
    "Emails": "رسائل البريد",
    "users.first_visit": "أول زيارة",
    "First visit": "أول زيارة",
    "users.latest_visit": "أحدث زيارة",
    "Latest visit": "أحدث زيارة",
    "users.landing_page": "الصفحة المقصودة",
    "Landing page": "الصفحة المقصودة",
    "users.referrer": "المُحيل",
    "Referrer": "المُحيل",
    "users.utm_source": "مصدر UTM",
    "UTM source": "مصدر UTM",
    "users.utm_medium": "وسيط UTM",
    "UTM medium": "وسيط UTM",
    "users.utm_campaign": "حملة UTM",
    "UTM campaign": "حملة UTM",
    "users.utm_term": "مصطلح UTM",
    "UTM term": "مصطلح UTM",
    "users.utm_content": "محتوى UTM",
    "UTM content": "محتوى UTM",
    "users.ai_source": "مصدر الذكاء الاصطناعي",
    "AI source": "مصدر الذكاء الاصطناعي",
    "rewards.edit_scope": "تعديل النطاق",
    "Edit scope": "تعديل النطاق",
    "rewards.add_scope": "إضافة نطاق",
    "Add scope": "إضافة نطاق",
    "rewards.save_scope": "حفظ النطاق",
    "Save scope": "حفظ النطاق",
    "rewards.scope_type": "نوع النطاق",
    "Scope type": "نوع النطاق",
    "rewards.scope_reference": "مرجع النطاق",
    "Scope reference": "مرجع النطاق",
    "rewards.match_config": "إعدادات المطابقة",
    "Match config": "إعدادات المطابقة",
    "rewards.priority_order": "ترتيب الأولوية",
    "Priority order": "ترتيب الأولوية",
    "rewards.active": "نشط",
    "rewards.scope_active": "النطاق نشط",
    "Scope is active": "النطاق نشط",
    "rewards.edit_rule": "تعديل القاعدة",
    "Edit rule": "تعديل القاعدة",
    "rewards.add_rule": "إضافة قاعدة",
    "Add rule": "إضافة قاعدة",
    "rewards.save_rule": "حفظ القاعدة",
    "Save rule": "حفظ القاعدة",
    "rewards.trigger_event": "حدث التشغيل",
    "Trigger event": "حدث التشغيل",
    "rewards.beneficiary_type": "نوع المستفيد",
    "Beneficiary type": "نوع المستفيد",
    "rewards.beneficiary_config": "إعدادات المستفيد",
    "Beneficiary config": "إعدادات المستفيد",
    "rewards.eligibility": "الأهلية",
    "Eligibility": "الأهلية",
    "rewards.conditions": "الشروط",
    "rewards.priority": "الأولوية",
    "Priority": "الأولوية",
    "rewards.edit_component": "تعديل مكوّن الوصفة",
    "Edit recipe component": "تعديل مكوّن الوصفة",
    "rewards.add_component": "إضافة مكوّن للوصفة",
    "Add recipe component": "إضافة مكوّن للوصفة",
    "rewards.save_component": "حفظ المكوّن",
    "Save component": "حفظ المكوّن",
    "rewards.rule": "القاعدة",
    "Rule": "القاعدة",
    "rewards.component_key": "مفتاح المكوّن",
    "Component key": "مفتاح المكوّن",
    "rewards.component_type": "نوع المكوّن",
    "Component type": "نوع المكوّن",
    "rewards.commission_definition": "تعريف العمولة",
    "Commission definition": "تعريف العمولة",
    "rewards.config": "الإعدادات",
    "rewards.position": "الموضع",
    "Position": "الموضع",
    "rewards.component": "المكوّن",
    "Component": "المكوّن",
    "rewards.status.draft": "مسودة",
    "rewards.status.active": "نشط",
    "rewards.status.paused": "متوقف مؤقتًا",
    "Paused": "متوقف مؤقتًا",
    "rewards.status.archived": "مؤرشف",
    "rewards.configuration_updated": "تم تحديث إعدادات المكافآت",
    "Reward configuration updated": "تم تحديث إعدادات المكافآت",
    "rewards.configuration_added": "تمت إضافة إعدادات المكافآت",
    "Reward configuration added": "تمت إضافة إعدادات المكافآت",
    "rewards.archive_item_confirm": "هل تريد أرشفة {name}؟",
    "Archive {name}?": "هل تريد أرشفة {name}؟",
    "rewards.empty_scopes": "لم يتم إعداد أي نطاقات بعد.",
    "No scopes configured yet.": "لم يتم إعداد أي نطاقات بعد.",
    "rewards.empty_rules": "لم يتم إعداد أي قواعد بعد.",
    "No rules configured yet.": "لم يتم إعداد أي قواعد بعد.",
    "rewards.empty_components": "لم يتم إعداد أي مكوّنات بعد.",
    "No components configured yet.": "لم يتم إعداد أي مكوّنات بعد.",
    "rewards.edit_program": "تعديل برنامج المكافآت",
    "Edit reward program": "تعديل برنامج المكافآت",
    "rewards.new_program": "برنامج مكافآت جديد",
    "New reward program": "برنامج مكافآت جديد",
    "rewards.create_program": "إنشاء برنامج",
    "Create program": "إنشاء برنامج",
    "rewards.program_type": "نوع البرنامج",
    "Program type": "نوع البرنامج",
    "rewards.starts_at": "يبدأ في",
    "Starts at": "يبدأ في",
    "rewards.ends_at": "ينتهي في",
    "Ends at": "ينتهي في",
    "rewards.program_updated": "تم تحديث برنامج المكافآت",
    "Reward program updated": "تم تحديث برنامج المكافآت",
    "rewards.program_created": "تم إنشاء برنامج المكافآت",
    "Reward program created": "تم إنشاء برنامج المكافآت",
    "rewards.archive_program_confirm": "هل تريد أرشفة {name}؟",
    "rewards.program_archived": "تمت أرشفة برنامج المكافآت",
    "Reward program archived": "تمت أرشفة برنامج المكافآت",
    "rewards.tab.overview": "نظرة عامة",
    "rewards.tab.programs": "البرامج",
    "Programs": "البرامج",
    "rewards.tab.impact": "الأثر",
    "Impact": "الأثر",
    "rewards.tab.attribution": "الإحالة",
    "Tracking": "الإحالة",
    "rewards.page_description": "أنشئ برامج المكافآت وأدرها، بما في ذلك إعدادات الأهلية وقواعد المكافآت ووصفاتها. تُضاف الطلبات المكتملة تلقائيًا إلى تقاريرك.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "أنشئ برامج المكافآت وأدرها، بما في ذلك إعدادات الأهلية وقواعد المكافآت ووصفاتها. تُضاف الطلبات المكتملة تلقائيًا إلى تقاريرك.",
    "rewards.program": "البرنامج",
    "Program": "البرنامج",
    "rewards.starts": "يبدأ",
    "Starts": "يبدأ",
    "rewards.no_programs": "لا توجد برامج مكافآت بعد.",
    "No reward programs yet.": "لا توجد برامج مكافآت بعد.",
    "rewards.program_title": "برنامج المكافآت",
    "Reward program": "برنامج المكافآت",
    "rewards.back_to_rewards": "العودة إلى المكافآت",
    "Back to rewards": "العودة إلى المكافآت",
    "common.archive": "أرشفة",
    "Archive": "أرشفة",
    "common.save_changes": "حفظ التغييرات",
    "common.none": "لا شيء",
    "common.this_item": "هذا العنصر",
    "this item": "هذا العنصر",
    "rewards.tab.scopes": "النطاقات",
    "Scopes": "النطاقات",
    "rewards.tab.rules": "القواعد",
    "Rules": "القواعد",
    "rewards.tab.components": "مكوّنات الوصفة",
    "Recipe components": "مكوّنات الوصفة",
    "rewards.reference": "المرجع",
    "rewards.trigger": "المحفّز",
    "rewards.beneficiary": "المستفيد",
    "Beneficiary": "المستفيد",
    "rewards.attributed_conversions": "التحويلات المنسوبة",
    "Attributed conversions": "التحويلات المنسوبة",
    "rewards.new_customers": "العملاء الجدد",
    "New customers": "العملاء الجدد",
    "rewards.revenue_influenced": "الإيرادات المتأثرة",
    "Revenue influenced": "الإيرادات المتأثرة",
    "rewards.rewards_issued": "المكافآت الممنوحة",
    "Rewards issued": "المكافآت الممنوحة",
    "rewards.live_business_results": "نتائج الأعمال المباشرة",
    "Live business results": "نتائج الأعمال المباشرة",
    "rewards.impact_at_a_glance": "ملخص الأثر",
    "Impact at a glance": "ملخص الأثر",
    "rewards.impact_last_30_days": "عرض مباشر للطلبات المكتملة ونتائج الشركاء خلال آخر 30 يومًا.",
    "A live view of completed orders and partner results from the last 30 days.": "عرض مباشر للطلبات المكتملة ونتائج الشركاء خلال آخر 30 يومًا.",
    "rewards.view_full_impact": "عرض الأثر بالكامل",
    "View full impact": "عرض الأثر بالكامل",
    "rewards.impact_load_error": "تعذّر تحميل بيانات الأثر: {error}",
    "Impact data could not be loaded: {error}": "تعذّر تحميل بيانات الأثر: {error}",
    "rewards.programs": "البرامج",
    "rewards.programs_configured": "برامج المكافآت المُعدّة لمساحة العمل هذه.",
    "Reward programs configured for this workspace.": "برامج المكافآت المُعدّة لمساحة العمل هذه.",
    "rewards.programs_eligible": "البرامج المؤهلة حاليًا للتقييم.",
    "Programs currently eligible for evaluation.": "البرامج المؤهلة حاليًا للتقييم.",
    "rewards.drafts": "المسودات",
    "Drafts": "المسودات",
    "rewards.programs_being_configured": "البرامج التي لا يزال إعدادها جاريًا.",
    "Programs still being configured.": "البرامج التي لا يزال إعدادها جاريًا.",
    "rewards.clicks": "النقرات",
    "rewards.completed_orders": "الطلبات المكتملة",
    "Completed orders": "الطلبات المكتملة",
    "rewards.conversion_rate": "معدل التحويل",
    "Conversion rate": "معدل التحويل",
    "rewards.revenue": "الإيرادات",
    "rewards.live_connection": "اتصال مباشر",
    "Live connection": "اتصال مباشر",
    "rewards.attribution_activity": "نشاط الإحالة",
    "Attribution activity": "نشاط الإحالة",
    "rewards.connected_workspace": "متصل بـ {name}.",
    "Connected to {name}.": "متصل بـ {name}.",
    "rewards.your_attribution_workspace": "مساحة عمل الإحالة الخاصة بك",
    "your Attribution workspace": "مساحة عمل الإحالة الخاصة بك",
    "rewards.loading_workspace": "جارٍ تحميل مساحة عمل الإحالة المتصلة.",
    "Loading your connected Attribution workspace.": "جارٍ تحميل مساحة عمل الإحالة المتصلة.",
    "rewards.open_attribution": "فتح الإحالة",
    "Open Attribution": "فتح الإحالة",
    "rewards.connection_attention": "يتطلب الاتصال الانتباه",
    "Connection needs attention": "يتطلب الاتصال الانتباه",
    "rewards.open_attribution_workspace": "فتح مساحة عمل الإحالة",
    "Open Attribution workspace": "فتح مساحة عمل الإحالة",
    "rewards.workspace_connected": "مساحة العمل متصلة",
    "Workspace connected": "مساحة العمل متصلة",
    "rewards.workspace_not_linked": "لم يتم ربط مساحة العمل بعد",
    "Workspace not linked yet": "لم يتم ربط مساحة العمل بعد",
    "rewards.attribution_data_connected": "تُقرأ النقرات والروابط والحملات والطلبات المكتملة مباشرةً من الإحالة.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "تُقرأ النقرات والروابط والحملات والطلبات المكتملة مباشرةً من الإحالة.",
    "rewards.connect_workspace_prompt": "افتح الإحالة لربط مساحة العمل هذه قبل تتبّع النشاط.",
    "Open Attribution to connect this workspace before tracking activity.": "افتح الإحالة لربط مساحة العمل هذه قبل تتبّع النشاط.",
    "rewards.successful_referrals": "الإحالات الناجحة",
    "Successful referrals": "الإحالات الناجحة",
    "rewards.new_customers_acquired": "العملاء الجدد المكتسبون",
    "New customers acquired": "العملاء الجدد المكتسبون",
    "rewards.gross_revenue_influenced": "إجمالي الإيرادات المتأثرة",
    "Gross revenue influenced": "إجمالي الإيرادات المتأثرة",
    "rewards.reward_cost": "تكلفة المكافآت",
    "Reward cost": "تكلفة المكافآت",
    "rewards.net_revenue": "صافي الإيرادات",
    "Net revenue": "صافي الإيرادات",
    "rewards.average_order_value": "متوسط قيمة الطلب",
    "Average order value": "متوسط قيمة الطلب",
    "rewards.cost_per_acquisition": "تكلفة اكتساب العميل",
    "Cost per acquisition": "تكلفة اكتساب العميل",
    "rewards.repeat_purchase_rate": "معدل تكرار الشراء",
    "Repeat purchase rate": "معدل تكرار الشراء",
    "rewards.business_outcome_reporting": "تقارير نتائج الأعمال",
    "Business outcome reporting": "تقارير نتائج الأعمال",
    "rewards.impact": "الأثر",
    "rewards.impact_description": "التحويلات واكتساب العملاء والإيرادات المتأثرة وتكلفة المكافآت للفترة المحددة.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "التحويلات واكتساب العملاء والإيرادات المتأثرة وتكلفة المكافآت للفترة المحددة.",
    "rewards.from": "من",
    "rewards.to": "إلى",
    "rewards.trend": "الاتجاه",
    "Trend": "الاتجاه",
    "rewards.daily": "يومي",
    "rewards.weekly": "أسبوعي",
    "Weekly": "أسبوعي",
    "rewards.top_partners": "أفضل الشركاء / المُحيلين",
    "Top partners / referrers": "أفضل الشركاء / المُحيلين",
    "rewards.partner": "الشريك",
    "Partner": "الشريك",
    "rewards.conversions": "التحويلات",
    "Conversions": "التحويلات",
    "rewards.no_partner_data": "لا توجد بيانات شركاء مُحالة لهذه الفترة.",
    "No attributed partner data for this period.": "لا توجد بيانات شركاء مُحالة لهذه الفترة.",
    "rewards.period": "الفترة",
    "rewards.no_trend_data": "لا توجد بيانات اتجاه لهذه الفترة.",
    "No trend data for this period.": "لا توجد بيانات اتجاه لهذه الفترة.",
    "rewards.campaign_performance": "أداء الحملات",
    "Campaign performance": "أداء الحملات",
    "rewards.campaign_count": "{count} حملة",
    "{count} campaigns": "{count} حملة",
    "rewards.campaign": "الحملة",
    "rewards.orders": "الطلبات",
    "rewards.rate": "المعدل",
    "Rate": "المعدل",
    "rewards.no_campaign_activity": "لا يوجد نشاط للحملات بعد. أنشئ رابط تتبّع في الإحالة لبدء قياس النتائج.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "لا يوجد نشاط للحملات بعد. أنشئ رابط تتبّع في الإحالة لبدء قياس النتائج.",
    "rewards.recent_completed_orders": "الطلبات المكتملة مؤخرًا",
    "Recent completed orders": "الطلبات المكتملة مؤخرًا",
    "rewards.recent_events_count": "{count} من الأحداث الأخيرة",
    "{count} recent events": "{count} من الأحداث الأخيرة",
    "rewards.event": "الحدث",
    "rewards.completed_order": "طلب مكتمل",
    "Completed order": "طلب مكتمل",
    "rewards.no_completed_order_activity": "لم يصل أي نشاط للطلبات المكتملة بعد.",
    "No completed order activity has arrived yet.": "لم يصل أي نشاط للطلبات المكتملة بعد.",
    "rewards.impact_data_quality_note": "لا تتوفر هنا أعداد النقرات ومعدل التحويل حتى يتم ربط ملخص نقرات الإحالة. تعتمد تكلفة المكافآت على سجلات المكافآت المعتمدة أو الممنوحة؛ ولا تُحتسب المبالغ المستردة بعد.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "لا تتوفر هنا أعداد النقرات ومعدل التحويل حتى يتم ربط ملخص نقرات الإحالة. تعتمد تكلفة المكافآت على سجلات المكافآت المعتمدة أو الممنوحة؛ ولا تُحتسب المبالغ المستردة بعد.",
    "subscriptions.type.free": "اشتراك مجاني",
    "Free Subscription": "اشتراك مجاني",
    "subscriptions.form.title_placeholder": "عنوان الاشتراك",
    "Subscription Title": "عنوان الاشتراك",
    "subscriptions.form.title_help": "أدخل عنوانًا واضحًا لباقـة الاشتراك (مثل «الخطة المميزة» أو «الباقة الأساسية»).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "أدخل عنوانًا واضحًا لباقـة الاشتراك (مثل «الخطة المميزة» أو «الباقة الأساسية»).",
    "subscriptions.form.description_placeholder": "وصف الاشتراك",
    "Subscription Description": "وصف الاشتراك",
    "subscriptions.form.description_help": "أدخل وصفًا مفصلًا للاشتراك يوضح ميزاته وفوائده.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "أدخل وصفًا مفصلًا للاشتراك يوضح ميزاته وفوائده.",
    "subscriptions.form.select_currency": "اختر العملة",
    "Select Currency": "اختر العملة",
    "subscriptions.form.currency_help": "اختر عملة الاشتراك من القائمة (العملة الافتراضية لديك).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "اختر عملة الاشتراك من القائمة (العملة الافتراضية لديك).",
    "subscriptions.form.amount_placeholder": "مبلغ الاشتراك",
    "Subscription Amount": "مبلغ الاشتراك",
    "subscriptions.form.amount_help": "أدخل سعر الاشتراك.",
    "Enter the subscription price.": "أدخل سعر الاشتراك.",
    "subscriptions.form.sku_placeholder": "رمز SKU للاشتراك",
    "Subscription SKU": "رمز SKU للاشتراك",
    "subscriptions.form.sku_help": "أدخل معرّفًا فريدًا للاشتراك لتسهيل تمييزه وتتبعِه.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "أدخل معرّفًا فريدًا للاشتراك لتسهيل تمييزه وتتبعِه.",
    "subscriptions.form.allowed_listings": "الإعلانات المسموح بها",
    "Allowed Listings": "الإعلانات المسموح بها",
    "subscriptions.form.allowed_listings_placeholder": "عدد الإعلانات المسموح بها في الاشتراك",
    "Subscription Allowed Listings": "عدد الإعلانات المسموح بها في الاشتراك",
    "subscriptions.form.allowed_listings_help": "حدّد عدد الإعلانات المسموح بها لهذا الاشتراك.",
    "Specify the number of listings allowed for this subscription.": "حدّد عدد الإعلانات المسموح بها لهذا الاشتراك.",
    "subscriptions.form.fixed_fee_per_order": "رسوم ثابتة لكل طلب",
    "Fixed Fee Per Order": "رسوم ثابتة لكل طلب",
    "subscriptions.form.fixed_fee_placeholder": "الرسوم الثابتة للاشتراك لكل طلب",
    "Subscription Fee Fixed Per Order": "الرسوم الثابتة للاشتراك لكل طلب",
    "subscriptions.form.fixed_fee_help": "أدخل الرسوم الثابتة لكل طلب، إن وُجدت.",
    "Enter a fixed fee per order, if applicable.": "أدخل الرسوم الثابتة لكل طلب، إن وُجدت.",
    "subscriptions.form.commission_percent_per_order": "نسبة العمولة لكل طلب",
    "Commission % Per Order": "نسبة العمولة لكل طلب",
    "subscriptions.form.commission_placeholder": "نسبة عمولة الاشتراك لكل طلب",
    "Subscription Commission Percent Per Order": "نسبة عمولة الاشتراك لكل طلب",
    "subscriptions.form.commission_help": "أدخل نسبة العمولة لكل طلب، إن وُجدت.",
    "Enter the commission percentage per order, if applicable.": "أدخل نسبة العمولة لكل طلب، إن وُجدت.",
    "subscriptions.form.expiry_days": "أيام انتهاء الصلاحية",
    "Expiry Days": "أيام انتهاء الصلاحية",
    "subscriptions.form.expiry_days_placeholder": "مدة صلاحية الاشتراك بالأيام",
    "Subscription Expiry Days": "مدة صلاحية الاشتراك بالأيام",
    "subscriptions.form.expiry_days_help": "حدّد عدد الأيام حتى انتهاء صلاحية الاشتراك (الخطة أو الباقة)، مثل 7 أو 30 يومًا.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "حدّد عدد الأيام حتى انتهاء صلاحية الاشتراك (الخطة أو الباقة)، مثل 7 أو 30 يومًا.",
    "subscriptions.form.payment_method": "طريقة الدفع",
    "subscriptions.form.select_type": "اختر النوع",
    "subscriptions.form.payment_method_help": "اختر طرق الدفع التي يدعمها هذا الاشتراك (مثل Stripe أو Mangopay أو Android أو iOS أو الاشتراك المجاني).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "اختر طرق الدفع التي يدعمها هذا الاشتراك (مثل Stripe أو Mangopay أو Android أو iOS أو الاشتراك المجاني).",
    "subscriptions.form.active_placeholder": "الاشتراك نشط",
    "Subscription Active": "الاشتراك نشط",
    "subscriptions.form.active_help": "فعّل المفتاح أو أوقفه لتنشيط الاشتراك أو تعطيله. يكون الاشتراك النشط متاحًا للشراء.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "فعّل المفتاح أو أوقفه لتنشيط الاشتراك أو تعطيله. يكون الاشتراك النشط متاحًا للشراء.",
    "subscriptions.add_title": "إضافة منتج اشتراك جديد",
    "Add new subscription product": "إضافة منتج اشتراك جديد",
    "subscriptions.edit_title": "تعديل منتج الاشتراك",
    "Edit subscription product": "تعديل منتج الاشتراك",
    "subscriptions.added_success": "تمت إضافة الاشتراك بنجاح",
    "Subscription listing added successfully": "تمت إضافة الاشتراك بنجاح",
    "subscriptions.updated_success": "تم تحديث الاشتراك بنجاح",
    "Subscription listing updated successfully": "تم تحديث الاشتراك بنجاح",
    "common.currency": "العملة",
    "common.sku": "رمز SKU",
    "subscriptions.title": "الاشتراكات",
    "subscriptions.add_subscription": "إضافة اشتراك",
    "Add subscription": "إضافة اشتراك",
    "subscriptions.plans": "الخطط",
    "subscriptions.active_subscribers": "المشتركون النشطون",
    "Active Subscribers": "المشتركون النشطون",
    "subscriptions.total_mrr": "إجمالي الإيراد الشهري المتكرر",
    "Total MRR": "إجمالي الإيراد الشهري المتكرر",
    "subscriptions.churn_rate": "معدل إلغاء الاشتراك",
    "Churn Rate": "معدل إلغاء الاشتراك",
    "subscriptions.new_this_month": "الجدد هذا الشهر",
    "New This Month": "الجدد هذا الشهر",
    "subscriptions.average_duration": "متوسط المدة",
    "Avg Duration": "متوسط المدة",
    "subscriptions.monthly_recurring_revenue": "الإيراد الشهري المتكرر",
    "Monthly Recurring Revenue": "الإيراد الشهري المتكرر",
    "subscriptions.annual_run_rate": "معدل الإيراد السنوي",
    "Annual Run Rate": "معدل الإيراد السنوي",
    "subscriptions.last_30_days": "آخر 30 يومًا",
    "subscriptions.subscriber_lifetime": "مدة اشتراك العميل",
    "Subscriber lifetime": "مدة اشتراك العميل",
    "subscriptions.subscriber_distribution": "توزيع المشتركين",
    "Subscriber Distribution": "توزيع المشتركين",
    "subscriptions.billing_period": "فترة الفوترة",
    "Billing Period": "فترة الفوترة",
    "subscriptions.allowed_listings": "الإعلانات المسموح بها",
    "subscriptions.commission_per_order": "العمولة لكل طلب",
    "Commission per Order": "العمولة لكل طلب",
    "subscriptions.fixed_fee_per_order": "الرسوم الثابتة لكل طلب",
    "Fixed Fee per Order": "الرسوم الثابتة لكل طلب",
    "subscriptions.payment_provider": "مزود الدفع",
    "Payment Provider": "مزود الدفع",
    "subscriptions.sku_product_id": "رمز SKU / معرّف المنتج",
    "SKU / Product ID": "رمز SKU / معرّف المنتج",
    "subscriptions.revenue_over_time": "الإيرادات بمرور الوقت",
    "Revenue Over Time": "الإيرادات بمرور الوقت",
    "subscriptions.revenue": "الإيرادات",
    "subscriptions.subscriber_growth": "نمو عدد المشتركين",
    "Subscriber Growth": "نمو عدد المشتركين",
    "subscriptions.subscribers": "المشتركون",
    "Subscribers": "المشتركون",
    "subscriptions.set_inactive": "تعيين كغير نشط",
    "Set Inactive": "تعيين كغير نشط",
    "subscriptions.set_active": "تعيين كنشط",
    "Set Active": "تعيين كنشط",
    "subscriptions.plan_title": "خطة الاشتراك",
    "Subscription Plan": "خطة الاشتراك",
    "subscriptions.status.active": "نشط",
    "subscriptions.status.cancelled": "ملغى",
    "subscriptions.status.expired": "منتهي الصلاحية",
    "subscriptions.status.trial": "تجريبي",
    "Trial": "تجريبي",
    "subscriptions.status.pending": "قيد الانتظار",
    "subscriptions.period.lifetime": "مدى الحياة",
    "Lifetime": "مدى الحياة",
    "subscriptions.period.daily": "يومي",
    "subscriptions.period.weekly": "أسبوعي",
    "subscriptions.period.monthly": "شهري",
    "Monthly": "شهري",
    "subscriptions.period.quarterly": "ربع سنوي",
    "Quarterly": "ربع سنوي",
    "subscriptions.period.semi_annual": "نصف سنوي",
    "Semi-annual": "نصف سنوي",
    "subscriptions.period.annual": "سنوي",
    "Annual": "سنوي",
    "subscriptions.period.days": "{count} يومًا",
    "subscriptions.period.day": "/ يوم",
    "/ day": "/ يوم",
    "subscriptions.period.week": "/ أسبوع",
    "/ week": "/ أسبوع",
    "subscriptions.period.month": "/ شهر",
    "subscriptions.period.quarter": "/ ربع سنة",
    "/ quarter": "/ ربع سنة",
    "subscriptions.period.six_months": "/ 6 أشهر",
    "/ 6 months": "/ 6 أشهر",
    "subscriptions.period.year": "/ سنة",
    "/ year": "/ سنة",
    "subscriptions.listings_count": "{count} إعلانًا",
    "{count} listings": "{count} إعلانًا",
    "subscriptions.commission_percentage": "عمولة بنسبة {rate}%",
    "{rate}% commission": "عمولة بنسبة {rate}%",
    "subscriptions.per_order": "/ طلب",
    "/ order": "/ طلب",
    "subscriptions.view_details_subscribers": "عرض التفاصيل والمشتركين",
    "View details and subscribers": "عرض التفاصيل والمشتركين",
    "subscriptions.edit_subscription": "تعديل الاشتراك",
    "Edit subscription": "تعديل الاشتراك",
    "subscriptions.delete_subscription": "حذف الاشتراك",
    "Delete subscription": "حذف الاشتراك",
    "subscriptions.deleted": "تم حذف الاشتراك",
    "Subscription deleted": "تم حذف الاشتراك",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "مشتريات Android داخل التطبيق",
    "Android IAP": "مشتريات Android داخل التطبيق",
    "subscriptions.type.ios": "مشتريات iOS داخل التطبيق",
    "iOS IAP": "مشتريات iOS داخل التطبيق",
    "subscriptions.type.free_subscription": "مجاني",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "تم تحميل {count}",
    "subscriptions.no_subscribers": "لا يوجد مشتركون بحالة {status}.",
    "No {status} subscribers.": "لا يوجد مشتركون بحالة {status}.",
    "subscriptions.billing_records": "سجلات الفوترة",
    "Billing Records": "سجلات الفوترة",
    "subscriptions.no_invoices": "لم يتم العثور على فواتير.",
    "No invoices found.": "لم يتم العثور على فواتير.",
    "subscriptions.column.account": "الحساب",
    "subscriptions.column.email": "البريد الإلكتروني",
    "subscriptions.column.status": "الحالة",
    "subscriptions.column.subscribed": "تاريخ الاشتراك",
    "Subscribed": "تاريخ الاشتراك",
    "subscriptions.column.expires": "تاريخ الانتهاء",
    "subscriptions.column.next_renewal": "التجديد التالي",
    "Next Renewal": "التجديد التالي",
    "subscriptions.column.amount_paid": "المبلغ المدفوع",
    "Amount Paid": "المبلغ المدفوع",
    "subscriptions.invoice_column.invoice_id": "معرّف الفاتورة",
    "Invoice ID": "معرّف الفاتورة",
    "subscriptions.invoice_column.account": "الحساب",
    "subscriptions.invoice_column.amount": "المبلغ",
    "subscriptions.invoice_column.status": "الحالة",
    "subscriptions.invoice_column.period": "الفترة",
    "subscriptions.invoice_column.paid_at": "تاريخ الدفع",
    "Paid At": "تاريخ الدفع",
    "subscriptions.validation.title_required": "العنوان مطلوب",
    "subscriptions.validation.allowed_listings_positive": "يجب أن يكون عدد الإعلانات المسموح بها أكبر من 0",
    "Allowed listings should be greater than 0": "يجب أن يكون عدد الإعلانات المسموح بها أكبر من 0",
    "subscriptions.validation.currency_required": "العملة مطلوبة",
    "Currency is required": "العملة مطلوبة",
    "subscriptions.validation.expiry_required": "عدد أيام انتهاء الصلاحية مطلوب",
    "Expiry days are required": "عدد أيام انتهاء الصلاحية مطلوب",
    "subscriptions.validation.payment_method_required": "طريقة الدفع مطلوبة",
    "Payment method is required": "طريقة الدفع مطلوبة",
    "subscriptions.error.save": "حدث خطأ أثناء حفظ الاشتراك.",
    "Something went wrong while saving the subscription.": "حدث خطأ أثناء حفظ الاشتراك.",
    "subscriptions.error.delete": "حدث خطأ أثناء حذف الاشتراك.",
    "Something went wrong while deleting the subscription.": "حدث خطأ أثناء حذف الاشتراك.",
    "common.configuration": "الإعدادات",
    "subscriptions.per_period": "لكل {period}",
    "per {period}": "لكل {period}",
    "subscriptions.tab.subscribers": "المشتركون",
    "subscriptions.tab.invoices": "الفواتير",
    "subscriptions.account_title": "اشتراك الحساب",
    "Account Subscription": "اشتراك الحساب",
    "subscriptions.config.description": "أدر اشتراكات الحسابات. عند تفعيلها، يحتاج مالكو الحسابات إلى اشتراك نشط لنشر الإعلانات. تُستخدم بوابة الدفع الافتراضية المحددة في «طريقة الدفع» لتحصيل رسوم الاشتراك.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "أدر اشتراكات الحسابات. عند تفعيلها، يحتاج مالكو الحسابات إلى اشتراك نشط لنشر الإعلانات. تُستخدم بوابة الدفع الافتراضية المحددة في «طريقة الدفع» لتحصيل رسوم الاشتراك.",
    "subscriptions.config.enable": "تفعيل الاشتراكات",
    "Enable subscriptions": "تفعيل الاشتراكات",
    "subscriptions.config.type": "نوع الاشتراك",
    "Subscription type": "نوع الاشتراك",
    "subscriptions.config.purchased_message": "الرسالة عند شراء الاشتراك مسبقًا",
    "Message when a subscription is already purchased": "الرسالة عند شراء الاشتراك مسبقًا",
    "subscriptions.config.purchased_placeholder": "أدخل رسالة الاشتراك الذي تم شراؤه مسبقًا",
    "Enter the already-purchased message": "أدخل رسالة الاشتراك الذي تم شراؤه مسبقًا",
    "subscriptions.config.listings_exhausted_message": "الرسالة عند بلوغ حد الإعلانات",
    "Message when the listing limit is reached": "الرسالة عند بلوغ حد الإعلانات",
    "subscriptions.config.listings_exhausted_placeholder": "أدخل رسالة بلوغ حد الإعلانات",
    "Enter the listing limit message": "أدخل رسالة بلوغ حد الإعلانات",
    "subscriptions.config.inactive_message": "الرسالة عند عدم نشاط الاشتراك",
    "Message when the subscription is inactive": "الرسالة عند عدم نشاط الاشتراك",
    "subscriptions.config.inactive_placeholder": "أدخل رسالة الاشتراك غير النشط",
    "Enter the inactive subscription message": "أدخل رسالة الاشتراك غير النشط",
    "subscriptions.config.saved": "تم حفظ إعدادات الاشتراك بنجاح",
    "Subscription settings saved successfully": "تم حفظ إعدادات الاشتراك بنجاح",
    "people.title": "الأفراد",
    "people.tab.staff": "الموظفون",
    "people.tab.departments": "الأقسام",
    "Departments": "الأقسام",
    "people.tab.job_profiles": "المسميات الوظيفية",
    "Job profiles": "المسميات الوظيفية",
    "people.tab.pay_grades": "درجات الأجر",
    "Pay grades": "درجات الأجر",
    "people.action.add_staff": "إضافة موظف",
    "people.action.add_department": "إضافة قسم",
    "Add department": "إضافة قسم",
    "people.action.add_job_profile": "إضافة مسمى وظيفي",
    "Add job profile": "إضافة مسمى وظيفي",
    "people.action.add_pay_grade": "إضافة درجة أجر",
    "Add pay grade": "إضافة درجة أجر",
    "people.currency_id": "معرّف العملة",
    "people.onboarding.eyebrow": "ابدأ باستخدام إدارة الأفراد",
    "Get started with People": "ابدأ باستخدام إدارة الأفراد",
    "people.onboarding.title": "أنشئ دليل فريقك",
    "Build your team directory": "أنشئ دليل فريقك",
    "people.onboarding.description": "أضف أول موظف، ثم نظّم فريقك باستخدام الأقسام والمسميات الوظيفية ودرجات الأجر.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "أضف أول موظف، ثم نظّم فريقك باستخدام الأقسام والمسميات الوظيفية ودرجات الأجر.",
    "people.onboarding.add_first": "أضف أول موظف",
    "Add your first staff member": "أضف أول موظف",
    "people.onboarding.step_staff": "إضافة موظفين",
    "people.onboarding.step_staff_description": "اربط مستخدمًا موجودًا بدليل الموظفين.",
    "Link an existing user to your staff directory.": "اربط مستخدمًا موجودًا بدليل الموظفين.",
    "people.onboarding.step_teams": "تنظيم الفرق",
    "Organize teams": "تنظيم الفرق",
    "people.onboarding.step_teams_description": "أنشئ الأقسام والمسميات الوظيفية مع نمو فريقك.",
    "Create departments and job profiles as you grow.": "أنشئ الأقسام والمسميات الوظيفية مع نمو فريقك.",
    "people.onboarding.step_pay": "تحديد التعويضات",
    "Set compensation": "تحديد التعويضات",
    "people.onboarding.step_pay_description": "حدّد درجات الأجر لإعداد الرواتب بشكل متسق.",
    "Define pay grades for consistent payroll setup.": "حدّد درجات الأجر لإعداد الرواتب بشكل متسق.",
    "people.staff_profile": "الملف الوظيفي",
    "Staff profile": "الملف الوظيفي",
    "people.field.employee_code": "رمز الموظف",
    "Employee code": "رمز الموظف",
    "people.field.job_title": "المسمى الوظيفي",
    "Job title": "المسمى الوظيفي",
    "people.field.department": "القسم",
    "Department": "القسم",
    "people.field.job_profile": "المسمى الوظيفي",
    "Job profile": "المسمى الوظيفي",
    "people.field.pay_grade": "درجة الأجر",
    "Pay grade": "درجة الأجر",
    "people.field.employment_type": "نوع التوظيف",
    "Employment type": "نوع التوظيف",
    "people.field.start_date": "تاريخ البدء",
    "people.field.user_id": "معرّف المستخدم",
    "people.field.user": "المستخدم",
    "people.field.grade": "الدرجة",
    "Grade": "الدرجة",
    "people.field.salary_range": "نطاق الراتب",
    "Salary range": "نطاق الراتب",
    "people.field.minimum_salary": "الحد الأدنى للراتب",
    "Minimum salary": "الحد الأدنى للراتب",
    "people.field.maximum_salary": "الحد الأقصى للراتب",
    "Maximum salary": "الحد الأقصى للراتب",
    "people.field.currency_id": "معرّف العملة",
    "people.form.staff.edit": "تعديل الموظف",
    "Edit staff": "تعديل الموظف",
    "people.form.staff.add": "إضافة موظف",
    "people.form.staff.description": "اربط مستخدمًا موجودًا بملف الموظف.",
    "Link an existing user to a staff profile.": "اربط مستخدمًا موجودًا بملف الموظف.",
    "people.form.department.edit": "تعديل القسم",
    "Edit department": "تعديل القسم",
    "people.form.department.add": "إضافة قسم",
    "people.form.job_profile.edit": "تعديل المسمى الوظيفي",
    "Edit job profile": "تعديل المسمى الوظيفي",
    "people.form.job_profile.add": "إضافة مسمى وظيفي",
    "people.form.pay_grade.edit": "تعديل درجة الأجر",
    "Edit pay grade": "تعديل درجة الأجر",
    "people.form.pay_grade.add": "إضافة درجة أجر",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "مهندس أول",
    "Senior Engineer": "مهندس أول",
    "people.placeholder.department": "الهندسة",
    "Engineering": "الهندسة",
    "people.placeholder.department_description": "فريق المنتجات والهندسة",
    "Product & Engineering team": "فريق المنتجات والهندسة",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "دوام كامل",
    "Full time": "دوام كامل",
    "people.employment.part_time": "دوام جزئي",
    "Part time": "دوام جزئي",
    "people.employment.contractor": "متعاقد",
    "Contractor": "متعاقد",
    "people.toast.staff_added": "تمت إضافة الموظف",
    "Staff added": "تمت إضافة الموظف",
    "people.toast.staff_updated": "تم تحديث الموظف",
    "Staff updated": "تم تحديث الموظف",
    "people.toast.department_added": "تمت إضافة القسم",
    "Department added": "تمت إضافة القسم",
    "people.toast.department_updated": "تم تحديث القسم",
    "Department updated": "تم تحديث القسم",
    "people.toast.job_profile_added": "تمت إضافة المسمى الوظيفي",
    "Job profile added": "تمت إضافة المسمى الوظيفي",
    "people.toast.job_profile_updated": "تم تحديث المسمى الوظيفي",
    "Job profile updated": "تم تحديث المسمى الوظيفي",
    "people.toast.pay_grade_added": "تمت إضافة درجة الأجر",
    "Pay grade added": "تمت إضافة درجة الأجر",
    "people.toast.pay_grade_updated": "تم تحديث درجة الأجر",
    "Pay grade updated": "تم تحديث درجة الأجر",
    "people.empty.staff": "لا يوجد موظفون بعد. أضف ملف موظف للبدء.",
    "No staff yet. Add a staff profile to get started.": "لا يوجد موظفون بعد. أضف ملف موظف للبدء.",
    "people.empty.departments": "لا توجد أقسام بعد.",
    "No departments yet.": "لا توجد أقسام بعد.",
    "people.empty.job_profiles": "لا توجد مسميات وظيفية بعد.",
    "No job profiles yet.": "لا توجد مسميات وظيفية بعد.",
    "people.empty.pay_grades": "لا توجد درجات أجر بعد.",
    "No pay grades yet.": "لا توجد درجات أجر بعد.",
    "people.pagination.page": "الصفحة {page}",
    "Page {page}": "الصفحة {page}",
    "workforce.title": "القوى العاملة",
    "workforce.tab.shifts": "المناوبات",
    "Shifts": "المناوبات",
    "workforce.tab.attendance": "الحضور",
    "Attendance": "الحضور",
    "workforce.tab.leave_requests": "طلبات الإجازة",
    "Leave requests": "طلبات الإجازة",
    "workforce.tab.leave_balances": "أرصدة الإجازات",
    "Leave balances": "أرصدة الإجازات",
    "workforce.tab.leave_policies": "سياسات الإجازات",
    "Leave policies": "سياسات الإجازات",
    "workforce.action.add_shift": "إضافة مناوبة",
    "Add shift": "إضافة مناوبة",
    "workforce.action.new_leave_request": "طلب إجازة جديد",
    "New leave request": "طلب إجازة جديد",
    "workforce.action.set_balance": "تحديد الرصيد",
    "Set balance": "تحديد الرصيد",
    "workforce.action.add_policy": "إضافة سياسة",
    "Add policy": "إضافة سياسة",
    "workforce.action.create_request": "إنشاء طلب",
    "Create request": "إنشاء طلب",
    "workforce.action.save_balance": "حفظ الرصيد",
    "Save balance": "حفظ الرصيد",
    "workforce.action.clock_in": "تسجيل الحضور",
    "workforce.action.clock_out": "تسجيل الانصراف",
    "workforce.action.clocking_in": "جارٍ تسجيل الحضور…",
    "Clocking in…": "جارٍ تسجيل الحضور…",
    "workforce.action.clocking_out": "جارٍ تسجيل الانصراف…",
    "Clocking out…": "جارٍ تسجيل الانصراف…",
    "workforce.field.staff": "الموظف",
    "workforce.field.start_time": "البداية",
    "workforce.field.end_time": "النهاية",
    "workforce.field.location": "الموقع",
    "workforce.field.leave_type": "نوع الإجازة",
    "Leave type": "نوع الإجازة",
    "workforce.field.from": "من",
    "workforce.field.to": "إلى",
    "workforce.field.days": "الأيام",
    "Days": "الأيام",
    "workforce.field.total_days": "إجمالي الأيام",
    "Total days": "إجمالي الأيام",
    "workforce.field.days_per_year": "الأيام في السنة",
    "Days per year": "الأيام في السنة",
    "workforce.field.carry_over": "ترحيل الرصيد",
    "Carry over": "ترحيل الرصيد",
    "workforce.field.carry_over_hint": "تُرحّل الأيام غير المستخدمة إلى السنة التالية",
    "Unused days carry over to next year": "تُرحّل الأيام غير المستخدمة إلى السنة التالية",
    "workforce.field.reason": "السبب",
    "workforce.field.time": "الوقت",
    "workforce.field.clock_in": "وقت الحضور",
    "workforce.field.clock_out": "وقت الانصراف",
    "workforce.field.hours": "الساعات",
    "Hours": "الساعات",
    "workforce.field.dates": "التواريخ",
    "Dates": "التواريخ",
    "workforce.field.used_days": "المستخدم",
    "Used": "المستخدم",
    "workforce.field.remaining_days": "المتبقي",
    "workforce.field.policy": "السياسة",
    "Policy": "السياسة",
    "workforce.placeholder.location": "المقر الرئيسي",
    "HQ": "المقر الرئيسي",
    "workforce.placeholder.leave_note": "إجازة عائلية",
    "Family holiday": "إجازة عائلية",
    "workforce.placeholder.policy_name": "إجازة سنوية",
    "Annual Leave": "إجازة سنوية",
    "workforce.placeholder.reject_reason": "فترة عمل مزدحمة",
    "Busy period": "فترة عمل مزدحمة",
    "workforce.placeholder.optional_note": "ملاحظة اختيارية",
    "Optional note": "ملاحظة اختيارية",
    "workforce.select.all_staff": "جميع الموظفين",
    "All staff": "جميع الموظفين",
    "workforce.form.shift.add": "إضافة مناوبة",
    "workforce.form.leave_request.add": "طلب إجازة جديد",
    "workforce.form.leave_balance.title": "تحديد رصيد الإجازة",
    "Set leave balance": "تحديد رصيد الإجازة",
    "workforce.form.leave_balance.description": "تحديد رصيد استحقاق الموظف لنوع إجازة وسنة محددين.",
    "Initialize a staff member’s entitlement for a leave type and year.": "تحديد رصيد استحقاق الموظف لنوع إجازة وسنة محددين.",
    "workforce.form.leave_policy.add": "إضافة سياسة إجازة",
    "Add leave policy": "إضافة سياسة إجازة",
    "workforce.form.leave_request.reject": "رفض طلب الإجازة",
    "Reject leave request": "رفض طلب الإجازة",
    "workforce.form.clock_out": "تسجيل الانصراف",
    "workforce.toast.shift_added": "تمت إضافة المناوبة",
    "Shift added": "تمت إضافة المناوبة",
    "workforce.toast.leave_request_created": "تم إنشاء طلب الإجازة",
    "Leave request created": "تم إنشاء طلب الإجازة",
    "workforce.toast.leave_balance_saved": "تم حفظ رصيد الإجازة",
    "Leave balance saved": "تم حفظ رصيد الإجازة",
    "workforce.toast.leave_policy_added": "تمت إضافة سياسة الإجازة",
    "Leave policy added": "تمت إضافة سياسة الإجازة",
    "workforce.toast.leave_request_rejected": "تم رفض طلب الإجازة",
    "Leave request rejected": "تم رفض طلب الإجازة",
    "workforce.toast.leave_request_approved": "تمت الموافقة على طلب الإجازة",
    "Leave request approved": "تمت الموافقة على طلب الإجازة",
    "workforce.toast.clocked_in": "تم تسجيل الحضور",
    "Clocked in": "تم تسجيل الحضور",
    "workforce.toast.clocked_out": "تم تسجيل الانصراف",
    "Clocked out": "تم تسجيل الانصراف",
    "workforce.empty.shifts": "لا توجد مناوبات خلال هذه الفترة.",
    "No shifts in this period.": "لا توجد مناوبات خلال هذه الفترة.",
    "workforce.empty.attendance": "لا توجد سجلات حضور.",
    "No attendance records.": "لا توجد سجلات حضور.",
    "workforce.empty.leave_requests": "لا توجد طلبات إجازة.",
    "No leave requests.": "لا توجد طلبات إجازة.",
    "workforce.empty.leave_balances": "لا توجد أرصدة إجازات. استخدم «تحديد الرصيد» لإضافة رصيد.",
    "No leave balances. Use Set balance to add one.": "لا توجد أرصدة إجازات. استخدم «تحديد الرصيد» لإضافة رصيد.",
    "workforce.empty.leave_policies": "لا توجد سياسات إجازات بعد.",
    "No leave policies yet.": "لا توجد سياسات إجازات بعد.",
    "workforce.leave_type.annual": "إجازة سنوية",
    "Annual leave": "إجازة سنوية",
    "workforce.leave_type.sick": "إجازة مرضية",
    "Sick leave": "إجازة مرضية",
    "workforce.leave_type.unpaid": "إجازة بدون أجر",
    "Unpaid leave": "إجازة بدون أجر",
    "workforce.leave_type.parental": "إجازة والدية",
    "Parental leave": "إجازة والدية",
    "workforce.leave_type.compassionate": "إجازة وفاة",
    "Compassionate leave": "إجازة وفاة",
    "workforce.duration.hours_minutes": "{hours} س {minutes} د",
    "{hours}h {minutes}m": "{hours} س {minutes} د",
    "common.year": "السنة",
    "Year": "السنة",
    "common.approve": "موافقة",
    "common.reject": "رفض",
    "payroll.title": "كشوف الرواتب",
    "payroll.tab.runs": "دفعات الرواتب",
    "Payroll runs": "دفعات الرواتب",
    "payroll.tab.components": "مكوّنات الأجر",
    "Pay components": "مكوّنات الأجر",
    "payroll.tab.claims": "مطالبات المصروفات",
    "Expense claims": "مطالبات المصروفات",
    "payroll.tab.categories": "فئات المصروفات",
    "Expense categories": "فئات المصروفات",
    "payroll.action.new_run": "دفعة رواتب جديدة",
    "New payroll run": "دفعة رواتب جديدة",
    "payroll.action.add_component": "إضافة مكوّن أجر",
    "Add pay component": "إضافة مكوّن أجر",
    "payroll.action.new_claim": "مطالبة مصروفات جديدة",
    "New expense claim": "مطالبة مصروفات جديدة",
    "payroll.action.add_category": "إضافة فئة",
    "payroll.action.create_run": "إنشاء دفعة",
    "Create run": "إنشاء دفعة",
    "payroll.action.create_component": "إنشاء مكوّن",
    "Create component": "إنشاء مكوّن",
    "payroll.action.create_claim": "إنشاء مطالبة",
    "Create claim": "إنشاء مطالبة",
    "payroll.action.submit_claim": "إرسال",
    "Submit": "إرسال",
    "payroll.action.approve_claim": "موافقة",
    "payroll.action.reimburse_claim": "رد المبلغ",
    "payroll.action.approve_payroll": "اعتماد الرواتب",
    "Approve payroll": "اعتماد الرواتب",
    "payroll.action.activate": "تفعيل",
    "Activate": "تفعيل",
    "payroll.action.deactivate": "تعطيل",
    "payroll.action.adjust": "تعديل",
    "payroll.action.save_adjustment": "حفظ التعديل",
    "payroll.action.export_csv": "تصدير CSV",
    "Export CSV": "تصدير CSV",
    "payroll.action.exporting": "جارٍ التصدير…",
    "payroll.action.view_staff_items": "عرض بنود الموظفين",
    "View staff items": "عرض بنود الموظفين",
    "payroll.action.view_payslips": "عرض قسائم الرواتب",
    "View payslips": "عرض قسائم الرواتب",
    "payroll.type.addition": "إضافة",
    "Addition": "إضافة",
    "payroll.type.deduction": "خصم",
    "Deduction": "خصم",
    "payroll.calculation.fixed": "مبلغ ثابت",
    "Fixed amount": "مبلغ ثابت",
    "payroll.calculation.percentage": "نسبة مئوية",
    "payroll.applies_to.all": "جميع الموظفين",
    "payroll.applies_to.hourly": "الموظفون بنظام الساعة",
    "Hourly staff": "الموظفون بنظام الساعة",
    "payroll.applies_to.salaried": "الموظفون بنظام الراتب",
    "Salaried staff": "الموظفون بنظام الراتب",
    "payroll.category.archive_confirm": "هل تريد أرشفة {name}؟",
    "payroll.components.description": "تُطبّق الإضافات والخصومات النشطة تلقائيًا على دفعات الرواتب الجديدة.",
    "Active additions and deductions are applied automatically to new payroll runs.": "تُطبّق الإضافات والخصومات النشطة تلقائيًا على دفعات الرواتب الجديدة.",
    "payroll.empty.categories": "لا توجد فئات مصروفات بعد.",
    "No expense categories yet.": "لا توجد فئات مصروفات بعد.",
    "payroll.empty.claims": "لا توجد مطالبات مصروفات بعد.",
    "No expense claims yet.": "لا توجد مطالبات مصروفات بعد.",
    "payroll.empty.components": "لم يتم إعداد مكوّنات أجر بعد.",
    "No pay components configured yet.": "لم يتم إعداد مكوّنات أجر بعد.",
    "payroll.empty.runs": "لا توجد دفعات رواتب بعد.",
    "No payroll runs yet.": "لا توجد دفعات رواتب بعد.",
    "payroll.field.staff": "الموظف",
    "payroll.field.base_pay": "الأجر الأساسي",
    "Base pay": "الأجر الأساسي",
    "payroll.field.allowances": "البدلات",
    "Allowances": "البدلات",
    "payroll.field.deductions": "الخصومات",
    "Deductions": "الخصومات",
    "payroll.field.commission": "العمولة",
    "payroll.field.net_pay": "صافي الأجر",
    "Net pay": "صافي الأجر",
    "payroll.field.components": "المكوّنات",
    "Components": "المكوّنات",
    "payroll.field.commission_override": "تجاوز قيمة العمولة",
    "Commission override": "تجاوز قيمة العمولة",
    "payroll.field.calculation": "طريقة الحساب",
    "Calculation": "طريقة الحساب",
    "payroll.field.applies_to": "ينطبق على",
    "Applies to": "ينطبق على",
    "payroll.field.staff_optional_draft": "الموظف (اختياري أثناء إعداد المسودة)",
    "Staff (optional while drafting)": "الموظف (اختياري أثناء إعداد المسودة)",
    "payroll.field.category_optional_draft": "الفئة (اختيارية أثناء إعداد المسودة)",
    "Category (optional while drafting)": "الفئة (اختيارية أثناء إعداد المسودة)",
    "payroll.field.category": "الفئة",
    "payroll.field.period": "الفترة",
    "payroll.field.period_start": "بداية الفترة",
    "Period start": "بداية الفترة",
    "payroll.field.period_end": "نهاية الفترة",
    "Period end": "نهاية الفترة",
    "payroll.field.generate_email_payslips": "إنشاء قسائم الرواتب وإرسالها بالبريد الإلكتروني",
    "Generate and email payslips": "إنشاء قسائم الرواتب وإرسالها بالبريد الإلكتروني",
    "payroll.field.gl_code": "رمز دفتر الأستاذ العام",
    "GL code": "رمز دفتر الأستاذ العام",
    "payroll.field.maximum_per_claim": "الحد الأقصى لكل مطالبة",
    "Maximum per claim": "الحد الأقصى لكل مطالبة",
    "payroll.field.maximum_per_transaction": "الحد الأقصى لكل معاملة",
    "Maximum per transaction": "الحد الأقصى لكل معاملة",
    "payroll.field.spending_cap": "حد الإنفاق",
    "Spending cap": "حد الإنفاق",
    "payroll.field.tax_rate": "معدل الضريبة (%)",
    "Tax rate (%)": "معدل الضريبة (%)",
    "payroll.field.no_limit": "بلا حد",
    "No limit": "بلا حد",
    "payroll.form.run.title": "دفعة رواتب جديدة",
    "payroll.form.run.description": "يُحسب الأجر وفق درجات رواتب الموظفين للفترة المحددة.",
    "Pay is calculated from staff pay grades for the selected period.": "يُحسب الأجر وفق درجات رواتب الموظفين للفترة المحددة.",
    "payroll.form.component.title": "إضافة مكوّن أجر",
    "payroll.form.component.description": "تُدرج المكوّنات تلقائيًا في دفعات الرواتب المستقبلية.",
    "Components are automatically included in future payroll runs.": "تُدرج المكوّنات تلقائيًا في دفعات الرواتب المستقبلية.",
    "payroll.form.claim.title": "مطالبة مصروفات جديدة",
    "payroll.form.claim.description": "تبدأ المطالبات كمسودات إلى أن تُرسل للموافقة.",
    "Claims start as drafts until submitted for approval.": "تبدأ المطالبات كمسودات إلى أن تُرسل للموافقة.",
    "payroll.form.category.add": "إضافة فئة مصروفات",
    "Add expense category": "إضافة فئة مصروفات",
    "payroll.form.category.edit": "تعديل فئة المصروفات",
    "Edit expense category": "تعديل فئة المصروفات",
    "payroll.form.claim.approve_title": "الموافقة على مطالبة المصروفات",
    "Approve expense claim": "الموافقة على مطالبة المصروفات",
    "payroll.form.run.approve_title": "الموافقة على دفعة الرواتب",
    "Approve payroll run": "الموافقة على دفعة الرواتب",
    "payroll.form.run.approve_description": "تؤدي الموافقة إلى قفل دفعة الرواتب. يمكنك أيضًا إنشاء قسائم الرواتب وإرسالها بالبريد الآن.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "تؤدي الموافقة إلى قفل دفعة الرواتب. يمكنك أيضًا إنشاء قسائم الرواتب وإرسالها بالبريد الآن.",
    "payroll.items.title": "بنود رواتب الموظفين",
    "Staff payroll items": "بنود رواتب الموظفين",
    "payroll.items.loading": "جارٍ تحميل بنود الرواتب…",
    "Loading payroll items…": "جارٍ تحميل بنود الرواتب…",
    "payroll.items.empty": "لم يتم العثور على بنود رواتب.",
    "No payroll items found.": "لم يتم العثور على بنود رواتب.",
    "payroll.items.adjust_title": "تعديل بند الرواتب",
    "Adjust payroll item": "تعديل بند الرواتب",
    "payroll.items.adjust_description": "حدّث الخصومات أو تجاوز مبلغ العمولة لهذا الموظف.",
    "Update deductions or override the commission amount for this staff member.": "حدّث الخصومات أو تجاوز مبلغ العمولة لهذا الموظف.",
    "payroll.payslips.title": "قسائم الرواتب",
    "Payslips": "قسائم الرواتب",
    "payroll.payslips.generate": "إنشاء قسائم الرواتب",
    "Generate payslips": "إنشاء قسائم الرواتب",
    "payroll.payslips.generating": "جارٍ إنشاء القسائم…",
    "Generating…": "جارٍ إنشاء القسائم…",
    "payroll.payslips.empty": "لم يتم إنشاء قسائم رواتب بعد.",
    "No payslips generated yet.": "لم يتم إنشاء قسائم رواتب بعد.",
    "payroll.payslips.generated": "تم الإنشاء",
    "Generated": "تم الإنشاء",
    "payroll.payslips.sent_at": "أُرسلت في {date}",
    "Sent {date}": "أُرسلت في {date}",
    "payroll.payslips.not_sent": "لم تُرسل",
    "Not sent": "لم تُرسل",
    "payroll.payslips.send_email": "إرسال بالبريد الإلكتروني",
    "Send email": "إرسال بالبريد الإلكتروني",
    "payroll.payslips.sending": "جارٍ الإرسال…",
    "payroll.payslips.details": "تفاصيل قسيمة الراتب",
    "Payslip details": "تفاصيل قسيمة الراتب",
    "payroll.placeholder.approval_note": "تمت الموافقة",
    "payroll.placeholder.category_name": "السفر",
    "Travel": "السفر",
    "payroll.placeholder.claim_description": "رحلة جوية إلى العميل",
    "Flight to client": "رحلة جوية إلى العميل",
    "payroll.placeholder.component_name": "بدل النقل",
    "Transport Allowance": "بدل النقل",
    "payroll.staff_number": "رقم الموظف {id}",
    "Staff #{id}": "رقم الموظف {id}",
    "payroll.toast.category_added": "تمت إضافة فئة المصروفات",
    "Expense category added": "تمت إضافة فئة المصروفات",
    "payroll.toast.category_archived": "تمت أرشفة فئة المصروفات",
    "Expense category archived": "تمت أرشفة فئة المصروفات",
    "payroll.toast.category_updated": "تم تحديث فئة المصروفات",
    "Expense category updated": "تم تحديث فئة المصروفات",
    "payroll.toast.claim_approved": "تمت الموافقة على المطالبة",
    "Claim approved": "تمت الموافقة على المطالبة",
    "payroll.toast.claim_created": "تم إنشاء مطالبة المصروفات",
    "Expense claim created": "تم إنشاء مطالبة المصروفات",
    "payroll.toast.claim_reimbursed": "تم تحديد المطالبة على أنها مستردة",
    "Claim marked as reimbursed": "تم تحديد المطالبة على أنها مستردة",
    "payroll.toast.claim_submitted": "تم إرسال المطالبة",
    "Claim submitted": "تم إرسال المطالبة",
    "payroll.toast.component_activated": "تم تفعيل مكوّن الأجر",
    "Pay component activated": "تم تفعيل مكوّن الأجر",
    "payroll.toast.component_created": "تم إنشاء مكوّن الأجر",
    "Pay component created": "تم إنشاء مكوّن الأجر",
    "payroll.toast.component_deactivated": "تم تعطيل مكوّن الأجر",
    "Pay component deactivated": "تم تعطيل مكوّن الأجر",
    "payroll.toast.item_updated": "تم تحديث بند الرواتب",
    "Payroll item updated": "تم تحديث بند الرواتب",
    "payroll.toast.payslip_email_sent": "تم إرسال قسيمة الراتب بالبريد الإلكتروني",
    "Payslip email sent": "تم إرسال قسيمة الراتب بالبريد الإلكتروني",
    "payroll.toast.payslips_generated": "تم إنشاء قسائم الرواتب",
    "Payslips generated": "تم إنشاء قسائم الرواتب",
    "payroll.toast.run_approved": "تم اعتماد دفعة الرواتب",
    "Payroll run approved": "تم اعتماد دفعة الرواتب",
    "payroll.toast.run_approved_payslips_queued": "تم اعتماد الرواتب وإضافة قسائمها إلى قائمة الإرسال",
    "Payroll approved and payslips queued": "تم اعتماد الرواتب وإضافة قسائمها إلى قائمة الإرسال",
    "payroll.toast.run_created": "تم إنشاء دفعة الرواتب",
    "payroll.toast.exported": "تم تصدير الرواتب",
    "Payroll exported": "تم تصدير الرواتب",
    "common.notes": "ملاحظات",
    "expenses.title": "المصروفات",
    "expenses.action.add": "إضافة مصروف",
    "Add expense": "إضافة مصروف",
    "expenses.action.create": "إنشاء المصروف",
    "Create expense": "إنشاء المصروف",
    "expenses.action.submit": "إرسال",
    "expenses.action.approve": "موافقة",
    "expenses.action.reimburse": "تعويض",
    "expenses.action.pay": "دفع",
    "expenses.action.lifecycle": "تم {action} المصروف",
    "Expense {action}d": "تم {action} المصروف",
    "expenses.type.claim": "مطالبة",
    "Claim": "مطالبة",
    "expenses.type.claims": "المطالبات",
    "Claims": "المطالبات",
    "expenses.type.bill": "فاتورة",
    "Bill": "فاتورة",
    "expenses.type.bills": "الفواتير",
    "Bills": "الفواتير",
    "expenses.filter.all_types": "كل الأنواع",
    "All types": "كل الأنواع",
    "expenses.filter.all_statuses": "كل الحالات",
    "expenses.summary.title": "ملخص",
    "Summary": "ملخص",
    "expenses.summary.by_category": "حسب الفئة",
    "By category": "حسب الفئة",
    "expenses.summary.by_status": "حسب الحالة",
    "By status": "حسب الحالة",
    "expenses.summary.by_party": "حسب المورد / الموظف",
    "By supplier / staff": "حسب المورد / الموظف",
    "expenses.summary.heading": "ملخص حسب {group}",
    "Summary by {group}": "ملخص حسب {group}",
    "expenses.summary.group.category": "الفئة",
    "category": "الفئة",
    "expenses.summary.group.status": "الحالة",
    "status": "الحالة",
    "expenses.summary.group.party": "المورد / الموظف",
    "supplier / staff": "المورد / الموظف",
    "expenses.summary.empty": "لا يتوفر ملخص.",
    "No summary available.": "لا يتوفر ملخص.",
    "expenses.column.type": "النوع",
    "expenses.column.party": "الموظف / المورد",
    "Staff / Supplier": "الموظف / المورد",
    "expenses.column.status": "الحالة",
    "expenses.field.staff_optional": "الموظف (اختياري أثناء إعداد المسودة)",
    "expenses.field.supplier_optional": "المورد (اختياري أثناء إعداد المسودة)",
    "Supplier (optional while drafting)": "المورد (اختياري أثناء إعداد المسودة)",
    "expenses.field.category_optional": "الفئة (اختيارية أثناء إعداد المسودة)",
    "expenses.field.amount": "المبلغ",
    "expenses.field.currency": "العملة",
    "expenses.field.description": "الوصف",
    "expenses.field.due_date": "تاريخ الاستحقاق",
    "Due date": "تاريخ الاستحقاق",
    "expenses.field.receipt_url": "رابط الإيصال",
    "Receipt URL": "رابط الإيصال",
    "expenses.empty": "لم يتم العثور على مصروفات تطابق عوامل التصفية المحددة.",
    "No expenses found for the selected filters.": "لم يتم العثور على مصروفات تطابق عوامل التصفية المحددة.",
    "expenses.modal.edit": "تعديل المصروف",
    "Edit expense": "تعديل المصروف",
    "expenses.modal.add": "إضافة {type}",
    "Add {type}": "إضافة {type}",
    "expenses.modal.bill_help": "أنشئ المسودة الآن وحدد مورداً قبل الإرسال.",
    "Create the draft now and assign a supplier before submitting.": "أنشئ المسودة الآن وحدد مورداً قبل الإرسال.",
    "expenses.modal.claim_help": "أنشئ المسودة الآن وحدد موظفاً قبل الإرسال.",
    "Create the draft now and assign a staff member before submitting.": "أنشئ المسودة الآن وحدد موظفاً قبل الإرسال.",
    "expenses.toast.updated": "تم تحديث المصروف",
    "Expense updated": "تم تحديث المصروف",
    "expenses.toast.created": "تم إنشاء المصروف",
    "Expense created": "تم إنشاء المصروف",
    "recurring_payments.title": "المدفوعات المتكررة",
    "recurring_payments.action.add": "إضافة دفعة متكررة",
    "Add recurring payment": "إضافة دفعة متكررة",
    "recurring_payments.action.create": "إنشاء دفعة متكررة",
    "Create recurring payment": "إنشاء دفعة متكررة",
    "recurring_payments.action.pause": "إيقاف مؤقت",
    "Pause": "إيقاف مؤقت",
    "recurring_payments.action.resume": "استئناف",
    "Resume": "استئناف",
    "recurring_payments.action.remove": "إزالة",
    "recurring_payments.description": "أنشئ مسودات فواتير المصروفات تلقائياً لمدفوعات الموردين المنتظمة.",
    "Automatically create draft expense bills for regular supplier payments.": "أنشئ مسودات فواتير المصروفات تلقائياً لمدفوعات الموردين المنتظمة.",
    "recurring_payments.field.name": "الاسم",
    "recurring_payments.field.supplier": "المورد",
    "recurring_payments.field.supplier_optional": "المورد (اختياري)",
    "Supplier (optional)": "المورد (اختياري)",
    "recurring_payments.field.frequency": "التكرار",
    "Frequency": "التكرار",
    "recurring_payments.field.next_due": "تاريخ الاستحقاق التالي",
    "Next due date": "تاريخ الاستحقاق التالي",
    "recurring_payments.field.auto_create": "إنشاء مسودة فاتورة تلقائياً",
    "Auto-create draft bill": "إنشاء مسودة فاتورة تلقائياً",
    "recurring_payments.field.auto_create_help": "إنشاء مسودة فاتورة مصروفات تلقائياً",
    "Create a draft expense bill automatically": "إنشاء مسودة فاتورة مصروفات تلقائياً",
    "recurring_payments.field.one_time": "دفعة لمرة واحدة",
    "One-time payment": "دفعة لمرة واحدة",
    "recurring_payments.field.one_time_help": "إنهاء بعد إنشاء الفاتورة التالية",
    "End after the next generated bill": "إنهاء بعد إنشاء الفاتورة التالية",
    "recurring_payments.field.end_date": "تاريخ الانتهاء",
    "recurring_payments.placeholder.name": "إيجار المكتب",
    "Office Rent": "إيجار المكتب",
    "recurring_payments.frequency.daily": "يومي",
    "recurring_payments.frequency.weekly": "أسبوعي",
    "recurring_payments.frequency.monthly": "شهري",
    "recurring_payments.frequency.quarterly": "ربع سنوي",
    "recurring_payments.frequency.yearly": "سنوي",
    "Yearly": "سنوي",
    "recurring_payments.form.description": "تنشئ المدفوعات المستحقة مسودات فواتير تلقائياً في المصروفات عند تفعيل الخيار.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "تنشئ المدفوعات المستحقة مسودات فواتير تلقائياً في المصروفات عند تفعيل الخيار.",
    "recurring_payments.empty": "لا توجد مدفوعات متكررة بعد.",
    "No recurring payments yet.": "لا توجد مدفوعات متكررة بعد.",
    "recurring_payments.this_payment": "هذه الدفعة المتكررة",
    "this recurring payment": "هذه الدفعة المتكررة",
    "recurring_payments.confirm_remove": "هل تريد إزالة {name}؟",
    "Remove {name}?": "هل تريد إزالة {name}؟",
    "recurring_payments.toast.pause": "تم إيقاف الدفعة المتكررة مؤقتاً",
    "Recurring payment paused": "تم إيقاف الدفعة المتكررة مؤقتاً",
    "recurring_payments.toast.resume": "تم استئناف الدفعة المتكررة",
    "Recurring payment resumed": "تم استئناف الدفعة المتكررة",
    "recurring_payments.toast.delete": "تمت إزالة الدفعة المتكررة",
    "Recurring payment removed": "تمت إزالة الدفعة المتكررة",
    "recurring_payments.toast.created": "تم إنشاء الدفعة المتكررة",
    "Recurring payment created": "تم إنشاء الدفعة المتكررة",
    "expenses.toast.submit": "تم إرسال المصروف",
    "Expense submitted": "تم إرسال المصروف",
    "expenses.toast.approve": "تمت الموافقة على المصروف",
    "Expense approved": "تمت الموافقة على المصروف",
    "expenses.toast.reimburse": "تم تعويض المصروف",
    "Expense reimbursed": "تم تعويض المصروف",
    "expenses.toast.pay": "تم دفع المصروف",
    "Expense paid": "تم دفع المصروف",
    "media_picker.title": "اختيار وسائط",
    "Select media": "اختيار وسائط",
    "media_picker.type.media": "الوسائط",
    "media_picker.type.all": "الكل",
    "media_picker.type.image": "صورة",
    "media_picker.type.video": "فيديو",
    "media_picker.type.audio": "صوت",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "مجلد",
    "media_picker.label.show": "عرض",
    "media_picker.label.media_type": "نوع الوسائط",
    "Media type": "نوع الوسائط",
    "media_picker.action.show_type": "عرض وسائط {type}",
    "media_picker.action.close": "إغلاق منتقي الوسائط",
    "Close media picker": "إغلاق منتقي الوسائط",
    "media_picker.action.upload": "تحميل وسائط",
    "media_picker.action.creating": "جارٍ الإنشاء…",
    "media_picker.action.create_folder": "إنشاء مجلد",
    "Create folder": "إنشاء مجلد",
    "media_picker.action.cancel": "إلغاء",
    "media_picker.action.use_selected": "استخدام المحدد",
    "Use selected": "استخدام المحدد",
    "media_picker.placeholder.search": "البحث في الوسائط",
    "media_picker.placeholder.folder": "اسم المجلد الجديد",
    "New folder name": "اسم المجلد الجديد",
    "media_picker.loading": "جارٍ تحميل الوسائط…",
    "media_picker.empty": "لا توجد وسائط في هذا المجلد.",
    "No media found in this folder.": "لا توجد وسائط في هذا المجلد.",
    "media_picker.selection.count": "تم تحديد {count}",
    "{count} selected": "تم تحديد {count}",
    "media_picker.selection.prompt": "حدد ملفاً للمتابعة",
    "Select a file to continue": "حدد ملفاً للمتابعة",
    "media_picker.error.load": "تعذر تحميل الوسائط",
    "Unable to load media": "تعذر تحميل الوسائط",
    "media_picker.error.load_retry": "تعذر تحميل الوسائط. يرجى المحاولة مرة أخرى.",
    "media_picker.error.create_folder": "تعذر إنشاء المجلد",
    "media_picker.error.create_folder_retry": "تعذر إنشاء المجلد. يرجى المحاولة مرة أخرى.",
    "Unable to create folder. Please try again.": "تعذر إنشاء المجلد. يرجى المحاولة مرة أخرى.",
    "media_picker.error.prepare_upload": "تعذر تجهيز التحميل",
    "Unable to prepare upload": "تعذر تجهيز التحميل",
    "media_picker.error.upload_url": "رابط التحميل غير متوفر",
    "Upload URL missing": "رابط التحميل غير متوفر",
    "media_picker.error.register_media": "تعذر تسجيل الوسائط",
    "media_picker.error.upload_retry": "تعذر تحميل الوسائط. يرجى المحاولة مرة أخرى.",
    "membership.title": "العضوية",
    "membership.description": "أدر برامج العضوية ومساهمات الأعضاء وحالة الدفع والتذكيرات.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "أدر برامج العضوية ومساهمات الأعضاء وحالة الدفع والتذكيرات.",
    "membership.action.settings": "الإعدادات",
    "membership.action.manage_programs": "إدارة البرامج",
    "Manage programs": "إدارة البرامج",
    "membership.action.view_data": "عرض البيانات",
    "View data": "عرض البيانات",
    "membership.action.edit_listing": "تعديل القائمة",
    "membership.action.go_to_listings": "الانتقال إلى القوائم",
    "Go to listings": "الانتقال إلى القوائم",
    "membership.action.view_order": "عرض الطلب",
    "View order": "عرض الطلب",
    "membership.action.configure_reminders": "إعداد التذكيرات",
    "Configure reminders": "إعداد التذكيرات",
    "membership.stat.programs": "البرامج",
    "membership.stat.active_members": "الأعضاء النشطون",
    "Active members": "الأعضاء النشطون",
    "membership.stat.contributions": "المساهمات",
    "Contributions": "المساهمات",
    "membership.stat.units": "الوحدات المضافة",
    "Units credited": "الوحدات المضافة",
    "membership.programs.title": "البرامج",
    "membership.programs.description": "قوائم العضوية المتاحة لعملائك.",
    "Membership-type listings available to your customers.": "قوائم العضوية المتاحة لعملائك.",
    "membership.programs.no_description": "لا يوجد وصف للبرنامج بعد.",
    "No program description yet.": "لا يوجد وصف للبرنامج بعد.",
    "membership.programs.empty_title": "لا توجد برامج عضوية بعد",
    "No membership programs yet": "لا توجد برامج عضوية بعد",
    "membership.programs.empty_description": "أنشئ قائمة من نوع العضوية لبدء استقبال المساهمات.",
    "Create a listing with type membership to start accepting contributions.": "أنشئ قائمة من نوع العضوية لبدء استقبال المساهمات.",
    "membership.programs.history_description": "سجل الأسعار والأعضاء المسجلون.",
    "Price history and enrolled members.": "سجل الأسعار والأعضاء المسجلون.",
    "membership.badge": "العضوية",
    "membership.loading_program": "جارٍ تحميل بيانات البرنامج…",
    "Loading program data…": "جارٍ تحميل بيانات البرنامج…",
    "membership.price_logs.title": "سجل الأسعار",
    "Price logs": "سجل الأسعار",
    "membership.price_logs.empty": "لا يوجد سجل للأسعار.",
    "No price logs recorded.": "لا يوجد سجل للأسعار.",
    "membership.source.manual": "يدوي",
    "manual": "يدوي",
    "membership.members.title": "الأعضاء",
    "Members": "الأعضاء",
    "membership.members.empty_program": "لا يوجد أعضاء مسجلون في هذا البرنامج.",
    "No members enrolled in this program.": "لا يوجد أعضاء مسجلون في هذا البرنامج.",
    "membership.members.recent": "الأعضاء الجدد",
    "Recent members": "الأعضاء الجدد",
    "membership.members.empty_recent": "ستظهر الأعضاء ومساهماتهم هنا بعد التسجيل.",
    "Members and contributions will appear here after enrolment.": "ستظهر الأعضاء ومساهماتهم هنا بعد التسجيل.",
    "membership.member_heading": "العضو: {member}",
    "Member: {member}": "العضو: {member}",
    "membership.contributions.title": "المساهمات",
    "membership.contributions.empty": "لا توجد مساهمات مسجلة بعد.",
    "No contributions recorded yet.": "لا توجد مساهمات مسجلة بعد.",
    "membership.payment_dues.title": "مستحقات الدفع",
    "Payment dues": "مستحقات الدفع",
    "membership.payment_dues.empty": "لا توجد مستحقات دفع مجدولة.",
    "No scheduled payment dues.": "لا توجد مستحقات دفع مجدولة.",
    "membership.unit": "وحدة",
    "unit": "وحدة",
    "membership.units": "وحدات",
    "units": "وحدات",
    "membership.months": "أشهر",
    "membership.automation.label": "الأتمتة",
    "AUTOMATION": "الأتمتة",
    "membership.automation.description": "تتحقق مهمة يومية من مدفوعات العضوية المجدولة.",
    "Daily worker checks scheduled membership payments.": "تتحقق مهمة يومية من مدفوعات العضوية المجدولة.",
    "membership.reminders.title": "تذكيرات الدفع",
    "Payment reminders": "تذكيرات الدفع",
    "membership.reminders.due_soon": "تذكير قبل الاستحقاق",
    "Due-soon reminder": "تذكير قبل الاستحقاق",
    "membership.reminders.due_soon_short": "قريب الاستحقاق",
    "Due soon": "قريب الاستحقاق",
    "membership.reminders.due_soon_help": "أرسل تذكيراً واحداً قبل موعد الدفع المجدول.",
    "Send one reminder before a scheduled payment is due.": "أرسل تذكيراً واحداً قبل موعد الدفع المجدول.",
    "membership.reminders.days_before": "الأيام قبل موعد الاستحقاق",
    "Days before due date": "الأيام قبل موعد الاستحقاق",
    "membership.reminders.days_before_value": "قبل {count} أيام",
    "{count} days before": "قبل {count} أيام",
    "membership.reminders.overdue": "تذكير بالتأخر",
    "Overdue reminder": "تذكير بالتأخر",
    "membership.reminders.overdue_help": "أرسل تذكيراً واحداً بعد تاريخ الاستحقاق وفترة السماح.",
    "Send one reminder after the due date and grace period.": "أرسل تذكيراً واحداً بعد تاريخ الاستحقاق وفترة السماح.",
    "membership.settings.title": "إعدادات العضوية",
    "Membership settings": "إعدادات العضوية",
    "membership.settings.description": "اضبط جدول تذكيرات الدفع.",
    "Configure the payment reminder schedule.": "اضبط جدول تذكيرات الدفع.",
    "membership.email_copy.title": "نص البريد الإلكتروني المخصص",
    "Custom email copy": "نص البريد الإلكتروني المخصص",
    "membership.email_copy.description": "استخدم الإعدادات ← الإشعارات ← العضوية لتعديل مواضيع وقوالب رسائل التذكير.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "استخدم الإعدادات ← الإشعارات ← العضوية لتعديل مواضيع وقوالب رسائل التذكير.",
    "membership.toast.saved": "تم حفظ إعدادات تذكيرات العضوية.",
    "Membership reminder settings saved.": "تم حفظ إعدادات تذكيرات العضوية.",
    "membership.toast.save_failed": "تعذر حفظ إعدادات تذكيرات العضوية.",
    "Unable to save membership reminder settings.": "تعذر حفظ إعدادات تذكيرات العضوية.",
    "common.status.off": "متوقف",
    "Off": "متوقف",
    "common.status.on": "يعمل",
    "On": "يعمل",
    "common.save_settings": "حفظ الإعدادات",
    "Save settings": "حفظ الإعدادات",
    "developer.page.title": "واجهة API والمطور",
    "API & Developer": "واجهة API والمطور",
    "developer.api_keys.title": "مفاتيح API",
    "API Keys": "مفاتيح API",
    "developer.api_keys.description": "استخدم هذه المفاتيح لمصادقة طلبات Tradly API. احتفظ بالمفتاح السري ولا تكشفه في كود العميل.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "استخدم هذه المفاتيح لمصادقة طلبات Tradly API. احتفظ بالمفتاح السري ولا تكشفه في كود العميل.",
    "developer.api_keys.credentials_description": "تجد أدناه مفاتيح الإنتاج. ستحتاج إليها لتفويض تطبيقاتك وإنشائها.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "تجد أدناه مفاتيح الإنتاج. ستحتاج إليها لتفويض تطبيقاتك وإنشائها.",
    "developer.api_keys.publishable": "المفتاح القابل للنشر",
    "Publishable Key": "المفتاح القابل للنشر",
    "developer.api_keys.publishable_placeholder": "أدخل المفتاح القابل للنشر",
    "Enter Publishable Key": "أدخل المفتاح القابل للنشر",
    "developer.api_keys.secret": "المفتاح السري",
    "developer.api_keys.secret_placeholder": "أدخل المفتاح السري",
    "Enter Secret Key": "أدخل المفتاح السري",
    "developer.api_keys.access_label": "الوصول إلى API",
    "API access": "الوصول إلى API",
    "developer.api_reference.title": "مرجع API",
    "developer.api_reference.description": "توثيق REST API الكامل والأدلة وأمثلة التعليمات البرمجية للبناء على سوق Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "توثيق REST API الكامل والأدلة وأمثلة التعليمات البرمجية للبناء على سوق Tradly.",
    "developer.api_reference.card_description": "استكشف مرجع API الكامل وأدلة المصادقة وخطافات الويب وتوثيق SDK. كل ما تحتاجه للتكامل أو إنشاء واجهات مخصصة لسوقك.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "استكشف مرجع API الكامل وأدلة المصادقة وخطافات الويب وتوثيق SDK. كل ما تحتاجه للتكامل أو إنشاء واجهات مخصصة لسوقك.",
    "developer.api_reference.open_docs": "فتح توثيق API",
    "Open API Docs": "فتح توثيق API",
    "developer.ai_agents.title": "الذكاء الاصطناعي والوكلاء",
    "AI & Agents": "الذكاء الاصطناعي والوكلاء",
    "developer.ai_agents.description": "اربط سوقك بأدوات الذكاء الاصطناعي واسمح للعملاء بإنشاء وكلاء مدعومين بمنصتك.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "اربط سوقك بأدوات الذكاء الاصطناعي واسمح للعملاء بإنشاء وكلاء مدعومين بمنصتك.",
    "developer.mcp.action.create": "إنشاء",
    "developer.mcp.action.removing": "جارٍ الإزالة…",
    "developer.mcp.scope.resource": "المورد",
    "developer.customer_agents.description": "اسمح لعملائك بإنشاء وكلاء ذكاء اصطناعي يتفاعلون مع سوقك. يتوافق مع ChatGPT وClaude ومنصات أخرى، ويمكنه أتمتة عمليات الشراء وإنشاء واجهات متاجر مخصصة ومساعدين للتسوق.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "اسمح لعملائك بإنشاء وكلاء ذكاء اصطناعي يتفاعلون مع سوقك. يتوافق مع ChatGPT وClaude ومنصات أخرى، ويمكنه أتمتة عمليات الشراء وإنشاء واجهات متاجر مخصصة ومساعدين للتسوق.",
    "whatsapp.title": "موصل واتساب",
    "WhatsApp connector": "موصل واتساب",
    "whatsapp.intro.title": "أرسل رموز OTP ورسائل التسويق عبر واتساب",
    "Send OTPs and marketing messages through WhatsApp": "أرسل رموز OTP ورسائل التسويق عبر واتساب",
    "whatsapp.intro.help": "اربط هذا المستأجر بواجهة Meta WhatsApp Cloud API. تبقى الرسائل النصية متاحة كقناة افتراضية أو احتياطية، ويمكن للموصل نفسه إرسال قوالب حملات واتساب المعتمدة.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "اربط هذا المستأجر بواجهة Meta WhatsApp Cloud API. تبقى الرسائل النصية متاحة كقناة افتراضية أو احتياطية، ويمكن للموصل نفسه إرسال قوالب حملات واتساب المعتمدة.",
    "whatsapp.status.disabled": "معطل",
    "whatsapp.status.sms_otp": "الموصل مفعل · رمز OTP عبر SMS",
    "Connector on · SMS OTP": "الموصل مفعل · رمز OTP عبر SMS",
    "whatsapp.status.needs_configuration": "يتطلب الإعداد",
    "Needs configuration": "يتطلب الإعداد",
    "whatsapp.status.auto_fallback": "واتساب مع SMS احتياطي",
    "WhatsApp with SMS fallback": "واتساب مع SMS احتياطي",
    "whatsapp.status.sms_whatsapp_backup": "SMS مع احتياطي واتساب",
    "SMS with WhatsApp backup": "SMS مع احتياطي واتساب",
    "whatsapp.status.enabled": "واتساب مفعل",
    "WhatsApp enabled": "واتساب مفعل",
    "whatsapp.draft.notice": "لديك مسودة غير محفوظة لإعدادات واتساب.",
    "You have an unsaved WhatsApp settings draft.": "لديك مسودة غير محفوظة لإعدادات واتساب.",
    "whatsapp.connect.title": "اربط واتساب الخاص بنشاطك التجاري",
    "Connect your business WhatsApp": "اربط واتساب الخاص بنشاطك التجاري",
    "whatsapp.connect.description": "أدخل رقم النشاط التجاري الذي يعرفه عملاؤك. ستفتح Meta نافذة تحقق آمنة؛ لا تحتاج إلى العثور على معرف WABA أو معرف رقم الهاتف أو رمز وصول أو إعداد API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "أدخل رقم النشاط التجاري الذي يعرفه عملاؤك. ستفتح Meta نافذة تحقق آمنة؛ لا تحتاج إلى العثور على معرف WABA أو معرف رقم الهاتف أو رمز وصول أو إعداد API.",
    "whatsapp.field.business_number": "رقم واتساب للنشاط التجاري",
    "Business WhatsApp number": "رقم واتساب للنشاط التجاري",
    "whatsapp.field.business_number_help": "استخدم الرقم الذي تريد أن يراسله العملاء، متضمناً رمز الدولة.",
    "Use the number you want customers to message, including country code.": "استخدم الرقم الذي تريد أن يراسله العملاء، متضمناً رمز الدولة.",
    "whatsapp.placeholder.business_number": "مثال: ‎+60 13 333 1671",
    "e.g. +60 13 333 1671": "مثال: ‎+60 13 333 1671",
    "whatsapp.field.connection_name": "اسم الاتصال",
    "whatsapp.field.connection_name_help": "استخدم اسماً واضحاً مثل كوالالمبور أو علامة البيع أو الدعم.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "استخدم اسماً واضحاً مثل كوالالمبور أو علامة البيع أو الدعم.",
    "whatsapp.placeholder.connection_name": "مثال: دعم كوالالمبور",
    "e.g. Kuala Lumpur support": "مثال: دعم كوالالمبور",
    "whatsapp.field.optional_details": "تفاصيل اتصال اختيارية",
    "Optional connection details": "تفاصيل اتصال اختيارية",
    "whatsapp.field.optional_details_help": "استخدم هذه الحقول فقط إذا كان الرقم تابعاً لعلامة تجارية أو حساب أو فرع محدد.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "استخدم هذه الحقول فقط إذا كان الرقم تابعاً لعلامة تجارية أو حساب أو فرع محدد.",
    "whatsapp.field.brand_key": "مفتاح العلامة التجارية",
    "Brand key": "مفتاح العلامة التجارية",
    "whatsapp.field.brand_key_help": "مفتاح داخلي ثابت للعلامة التجارية، مثل التجزئة أو البيع بالجملة.",
    "Stable internal key for a brand, such as retail or wholesale.": "مفتاح داخلي ثابت للعلامة التجارية، مثل التجزئة أو البيع بالجملة.",
    "whatsapp.placeholder.brand_key": "مثال: retail",
    "e.g. retail": "مثال: retail",
    "whatsapp.field.account_id": "معرف الحساب",
    "whatsapp.field.account_id_help": "اربط هذا الرقم بحساب Tradly موجود.",
    "Associate this number with an existing Tradly account.": "اربط هذا الرقم بحساب Tradly موجود.",
    "whatsapp.placeholder.account_id": "مثال: 123",
    "e.g. 123": "مثال: 123",
    "whatsapp.field.branch_id": "معرف الفرع",
    "Branch ID": "معرف الفرع",
    "whatsapp.field.branch_id_help": "اربط هذا الرقم بفرع Tradly موجود.",
    "Associate this number with an existing Tradly branch.": "اربط هذا الرقم بفرع Tradly موجود.",
    "whatsapp.placeholder.branch_id": "مثال: 456",
    "e.g. 456": "مثال: 456",
    "whatsapp.field.default_connection": "استخدم كاتصال افتراضي",
    "Use as default connection": "استخدم كاتصال افتراضي",
    "whatsapp.field.default_connection_help": "تستخدم تدفقات OTP القديمة هذا الاتصال الافتراضي عند عدم تحديد اتصال خاص بالفرع.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "تستخدم تدفقات OTP القديمة هذا الاتصال الافتراضي عند عدم تحديد اتصال خاص بالفرع.",
    "whatsapp.field.uses_business_app": "أستخدم تطبيق واتساب للأعمال على هذا الرقم",
    "I use the WhatsApp Business app on this number": "أستخدم تطبيق واتساب للأعمال على هذا الرقم",
    "whatsapp.field.uses_business_app_help": "واصل المحادثة في تطبيق واتساب للأعمال على هاتفك. ستطلب منك Meta مسح رمز QR من التطبيق، وستتم مزامنة جهات الاتصال والمحادثات الأخيرة. يتطلب الإصدار 2.24.17 أو أحدث.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "واصل المحادثة في تطبيق واتساب للأعمال على هاتفك. ستطلب منك Meta مسح رمز QR من التطبيق، وستتم مزامنة جهات الاتصال والمحادثات الأخيرة. يتطلب الإصدار 2.24.17 أو أحدث.",
    "whatsapp.connected.business_account": "حساب واتساب للأعمال",
    "WhatsApp business account": "حساب واتساب للأعمال",
    "whatsapp.connected.template_ready": "قالب المصادقة جاهز · يمكن لرمز OTP التلقائي استخدام واتساب.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "قالب المصادقة جاهز · يمكن لرمز OTP التلقائي استخدام واتساب.",
    "whatsapp.connected.template_pending": "متصل · تبقى رسائل SMS خياراً احتياطياً آمناً حتى اعتماد قالب المصادقة.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "متصل · تبقى رسائل SMS خياراً احتياطياً آمناً حتى اعتماد قالب المصادقة.",
    "whatsapp.action.connect": "ربط واتساب",
    "Connect WhatsApp": "ربط واتساب",
    "whatsapp.action.reconnect": "إعادة ربط واتساب",
    "Reconnect WhatsApp": "إعادة ربط واتساب",
    "whatsapp.connections.title": "أرقام واتساب المتصلة",
    "Connected WhatsApp numbers": "أرقام واتساب المتصلة",
    "whatsapp.connections.description": "يمكن أن يتبع كل رقم علامة تجارية أو حساباً أو فرعاً مختلفاً. حدد واحداً قبل تفعيل القوالب.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "يمكن أن يتبع كل رقم علامة تجارية أو حساباً أو فرعاً مختلفاً. حدد واحداً قبل تفعيل القوالب.",
    "whatsapp.connections.unnamed": "اتصال واتساب",
    "WhatsApp connection": "اتصال واتساب",
    "whatsapp.connections.default": "افتراضي",
    "whatsapp.connections.account": "الحساب {id}",
    "Account {id}": "الحساب {id}",
    "whatsapp.connections.branch": "الفرع {id}",
    "Branch {id}": "الفرع {id}",
    "whatsapp.connections.tenant_wide": "اتصال على مستوى المستأجر",
    "Tenant-wide connection": "اتصال على مستوى المستأجر",
    "whatsapp.action.make_default": "تعيين كافتراضي",
    "Make default": "تعيين كافتراضي",
    "whatsapp.notice.default_updated": "تم تحديث اتصال واتساب الافتراضي.",
    "Default WhatsApp connection updated.": "تم تحديث اتصال واتساب الافتراضي.",
    "whatsapp.error.default_update": "تعذر تغيير الاتصال الافتراضي.",
    "Unable to change the default connection.": "تعذر تغيير الاتصال الافتراضي.",
    "whatsapp.templates.title": "قوالب الرسائل",
    "Message templates": "قوالب الرسائل",
    "whatsapp.templates.description": "اختر قالباً جاهزاً. ترسله Tradly إلى Meta للموافقة وتفعله تلقائياً بعد اعتماده.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "اختر قالباً جاهزاً. ترسله Tradly إلى Meta للموافقة وتفعله تلقائياً بعد اعتماده.",
    "whatsapp.template.status.not_activated": "غير مفعل",
    "Not activated": "غير مفعل",
    "whatsapp.template.status.approved": "معتمد",
    "whatsapp.template.status.pending": "قيد الانتظار",
    "whatsapp.template.status.submitted": "تم الإرسال",
    "Submitted": "تم الإرسال",
    "whatsapp.template.action.active": "نشط",
    "whatsapp.template.action.submitted": "تم الإرسال",
    "whatsapp.template.action.activate": "تفعيل القالب",
    "Activate template": "تفعيل القالب",
    "whatsapp.notice.template_active": "تم اعتماد {name} وتفعيله.",
    "{name} is approved and active.": "تم اعتماد {name} وتفعيله.",
    "whatsapp.notice.template_submitted": "تم إرسال {name} إلى Meta للمراجعة. يمكنك متابعة استخدام SMS حتى اعتماده.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "تم إرسال {name} إلى Meta للمراجعة. يمكنك متابعة استخدام SMS حتى اعتماده.",
    "whatsapp.channel.title": "قناة التسليم",
    "Delivery channel": "قناة التسليم",
    "whatsapp.channel.help": "يفعّل المفتاح واتساب لنشاطك التجاري. يمكن إرسال رموز الدخول عبر SMS فقط أو واتساب فقط أو SMS مع واتساب كاحتياطي؛ تتطلب خيارات واتساب قالب رمز معتمدًا.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "يفعّل المفتاح واتساب لنشاطك التجاري. يمكن إرسال رموز الدخول عبر SMS فقط أو واتساب فقط أو SMS مع واتساب كاحتياطي؛ تتطلب خيارات واتساب قالب رمز معتمدًا.",
    "whatsapp.channel.primary_otp": "قناة OTP الأساسية",
    "Primary OTP channel": "قناة OTP الأساسية",
    "whatsapp.channel.sms_description": "استخدم مسار تسليم SMS الحالي.",
    "Keep the existing SMS delivery path.": "استخدم مسار تسليم SMS الحالي.",
    "whatsapp.channel.whatsapp_description": "استخدم Meta Cloud API لهذا المستأجر.",
    "Use Meta Cloud API for this tenant.": "استخدم Meta Cloud API لهذا المستأجر.",
    "whatsapp.channel.automatic": "تلقائي",
    "Automatic": "تلقائي",
    "whatsapp.channel.automatic_description": "استخدم واتساب عند الإعداد، وإلا فاستخدم SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "استخدم واتساب عند الإعداد، وإلا فاستخدم SMS.",
    "whatsapp.channel.fallback": "الخيار الاحتياطي بعد فشل واتساب",
    "Fallback after WhatsApp failure": "الخيار الاحتياطي بعد فشل واتساب",
    "whatsapp.channel.no_fallback": "بدون خيار احتياطي",
    "No fallback": "بدون خيار احتياطي",
    "whatsapp.channel.no_fallback_description": "أعد نتيجة التسليم المهيأة.",
    "Return the configured delivery result.": "أعد نتيجة التسليم المهيأة.",
    "whatsapp.channel.sms_fallback_description": "جرّب SMS باستخدام رمز OTP نفسه.",
    "Try SMS with the same OTP code.": "جرّب SMS باستخدام رمز OTP نفسه.",
    "whatsapp.channel.sms_only": "SMS فقط",
    "SMS only": "SMS فقط",
    "whatsapp.channel.sms_only_description": "تُرسل الرموز برسالة نصية.",
    "Codes are sent by text message.": "تُرسل الرموز برسالة نصية.",
    "whatsapp.channel.whatsapp_only": "واتساب فقط",
    "WhatsApp only": "واتساب فقط",
    "whatsapp.channel.whatsapp_only_description": "تُرسل الرموز من رقم واتساب الخاص بك.",
    "Codes are sent from your WhatsApp number.": "تُرسل الرموز من رقم واتساب الخاص بك.",
    "whatsapp.channel.sms_whatsapp": "SMS، مع واتساب كاحتياطي",
    "SMS, WhatsApp as backup": "SMS، مع واتساب كاحتياطي",
    "whatsapp.channel.sms_whatsapp_description": "تُرسل الرموز برسالة نصية؛ وإذا فشلت، يُرسل الرمز نفسه عبر واتساب.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "تُرسل الرموز برسالة نصية؛ وإذا فشلت، يُرسل الرمز نفسه عبر واتساب.",
    "whatsapp.advanced.title": "إعدادات الاستعادة التقنية",
    "Technical recovery settings": "إعدادات الاستعادة التقنية",
    "whatsapp.advanced.description": "لدعم المنصة فقط. ينبغي لمعظم الأنشطة استخدام ربط واتساب أعلاه.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "لدعم المنصة فقط. ينبغي لمعظم الأنشطة استخدام ربط واتساب أعلاه.",
    "whatsapp.field.phone_number_id": "معرف رقم هاتف واتساب",
    "WhatsApp phone number ID": "معرف رقم هاتف واتساب",
    "whatsapp.field.phone_number_id_help": "معرف رقم الهاتف المرتبط بحساب WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "معرف رقم الهاتف المرتبط بحساب WhatsApp Business.",
    "whatsapp.field.waba_id": "معرف حساب WhatsApp Business",
    "WhatsApp Business Account ID": "معرف حساب WhatsApp Business",
    "whatsapp.field.waba_id_help": "يظهر بجانب معرف رقم الهاتف في Meta (WhatsApp > إعداد API). مطلوب للقوالب والرسائل التجريبية.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "يظهر بجانب معرف رقم الهاتف في Meta (WhatsApp > إعداد API). مطلوب للقوالب والرسائل التجريبية.",
    "whatsapp.placeholder.phone_number_id": "مثال: 123456789012345",
    "e.g. 123456789012345": "مثال: 123456789012345",
    "whatsapp.field.access_token": "رمز وصول Meta",
    "Meta access token": "رمز وصول Meta",
    "whatsapp.field.access_token_saved_help": "محفوظ بأمان على الخادم. اتركه فارغاً للإبقاء عليه أو الصق رمزاً جديداً لاستبداله.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "محفوظ بأمان على الخادم. اتركه فارغاً للإبقاء عليه أو الصق رمزاً جديداً لاستبداله.",
    "whatsapp.field.access_token_help": "استخدم رمز مستخدم نظام يملك صلاحية إرسال رسائل WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "استخدم رمز مستخدم نظام يملك صلاحية إرسال رسائل WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "محفوظ بأمان · اتركه فارغاً للإبقاء عليه",
    "Saved securely · leave blank to keep": "محفوظ بأمان · اتركه فارغاً للإبقاء عليه",
    "whatsapp.placeholder.access_token": "ألصق الرمز",
    "Paste token": "ألصق الرمز",
    "whatsapp.token.saved": "تم حفظ رمز وصول Meta بأمان",
    "Meta access token saved securely": "تم حفظ رمز وصول Meta بأمان",
    "whatsapp.field.otp_template": "اسم قالب OTP المعتمد",
    "Approved OTP template name": "اسم قالب OTP المعتمد",
    "whatsapp.field.otp_template_help": "يجب أن يقبل نص القالب رمز OTP كمعامل نصي واحد.",
    "The template body must accept the OTP as one text parameter.": "يجب أن يقبل نص القالب رمز OTP كمعامل نصي واحد.",
    "whatsapp.placeholder.otp_template": "مثال: login_verification",
    "e.g. login_verification": "مثال: login_verification",
    "whatsapp.field.template_language": "لغة القالب",
    "Template language": "لغة القالب",
    "whatsapp.field.marketing_template": "اسم قالب التسويق المعتمد (اختياري)",
    "Approved marketing template name (optional)": "اسم قالب التسويق المعتمد (اختياري)",
    "whatsapp.field.marketing_template_help": "استخدم قالب تسويق معتمداً من Meta. يمكن للحملة استبدال هذا الاسم في content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "استخدم قالب تسويق معتمداً من Meta. يمكن للحملة استبدال هذا الاسم في content.template_name.",
    "whatsapp.placeholder.marketing_template": "مثال: monthly_offer",
    "e.g. monthly_offer": "مثال: monthly_offer",
    "whatsapp.field.marketing_language": "لغة قالب التسويق",
    "Marketing template language": "لغة قالب التسويق",
    "whatsapp.info.title": "قبل تفعيل واتساب",
    "Before enabling WhatsApp": "قبل تفعيل واتساب",
    "whatsapp.info.description": "يجب أن توافق Meta على كل قالب OTP أو تسويق قبل إرساله. يستخدم محتوى حملات واتساب template_name وtemplate_language ومعاملات نصية اختيارية؛ ويجب أن تكون الأرقام بتنسيق E.164. عند تفعيل الخيار الاحتياطي التلقائي، تعيد ArcticOwl محاولة SMS برمز OTP نفسه.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "يجب أن توافق Meta على كل قالب OTP أو تسويق قبل إرساله. يستخدم محتوى حملات واتساب template_name وtemplate_language ومعاملات نصية اختيارية؛ ويجب أن تكون الأرقام بتنسيق E.164. عند تفعيل الخيار الاحتياطي التلقائي، تعيد ArcticOwl محاولة SMS برمز OTP نفسه.",
    "whatsapp.action.hide_token": "إخفاء رمز وصول Meta",
    "Hide Meta access token": "إخفاء رمز وصول Meta",
    "whatsapp.action.show_token": "عرض رمز وصول Meta",
    "Show Meta access token": "عرض رمز وصول Meta",
    "whatsapp.error.generic": "تعذر حفظ إعدادات واتساب.",
    "Unable to save WhatsApp settings.": "تعذر حفظ إعدادات واتساب.",
    "whatsapp.error.browser_required": "يتوفر ربط واتساب في المتصفح فقط.",
    "WhatsApp connection is only available in a browser.": "يتوفر ربط واتساب في المتصفح فقط.",
    "whatsapp.error.meta_load": "تعذر تحميل Meta. تحقق من إعدادات خصوصية المتصفح وحاول مرة أخرى.",
    "Meta could not load. Check the browser privacy settings and try again.": "تعذر تحميل Meta. تحقق من إعدادات خصوصية المتصفح وحاول مرة أخرى.",
    "whatsapp.error.load": "تعذر تحميل إعدادات واتساب.",
    "Unable to load WhatsApp settings.": "تعذر تحميل إعدادات واتساب.",
    "whatsapp.error.connect_before_template": "اربط واتساب قبل تفعيل القالب.",
    "Connect WhatsApp before activating a template.": "اربط واتساب قبل تفعيل القالب.",
    "whatsapp.error.template_submit": "تعذر إرسال قالب واتساب.",
    "Unable to submit the WhatsApp template.": "تعذر إرسال قالب واتساب.",
    "whatsapp.error.business_number_required": "أدخل رقم واتساب للنشاط التجاري قبل الربط. ستتحقق Meta منه في الخطوة التالية.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "أدخل رقم واتساب للنشاط التجاري قبل الربط. ستتحقق Meta منه في الخطوة التالية.",
    "whatsapp.error.signup_not_ready": "لا تزال المنصة تجهز اتصال واتساب. يرجى المحاولة بعد قليل.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "لا تزال المنصة تجهز اتصال واتساب. يرجى المحاولة بعد قليل.",
    "whatsapp.error.signup_cancelled": "تم إلغاء اتصال Meta أو لم يُرجع رمز تفويض.",
    "Meta connection was cancelled or did not return an authorization code.": "تم إلغاء اتصال Meta أو لم يُرجع رمز تفويض.",
    "whatsapp.error.phone_number_missing": "لم تُرجع Meta رقم واتساب للنشاط التجاري المحدد. يرجى إعادة محاولة الربط.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "لم تُرجع Meta رقم واتساب للنشاط التجاري المحدد. يرجى إعادة محاولة الربط.",
    "whatsapp.notice.connected_auto": "تم ربط واتساب. سيستخدم تسليم OTP التلقائي واتساب أولاً ثم SMS عند الفشل.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "تم ربط واتساب. سيستخدم تسليم OTP التلقائي واتساب أولاً ثم SMS عند الفشل.",
    "whatsapp.notice.connected_sms": "تم ربط واتساب. تبقى SMS فعالة حتى تعتمد Meta قالب المصادقة.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "تم ربط واتساب. تبقى SMS فعالة حتى تعتمد Meta قالب المصادقة.",
    "whatsapp.error.connect": "تعذر ربط واتساب.",
    "Unable to connect WhatsApp.": "تعذر ربط واتساب.",
    "whatsapp.error.otp_configuration": "يتطلب OTP عبر واتساب أو التلقائي معرف رقم هاتف واسم قالب OTP معتمداً ورمز وصول Meta. للتسويق عبر واتساب فقط، اختر SMS كقناة OTP أساسية وأبقِ الموصل مفعلاً.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "يتطلب OTP عبر واتساب أو التلقائي معرف رقم هاتف واسم قالب OTP معتمداً ورمز وصول Meta. للتسويق عبر واتساب فقط، اختر SMS كقناة OTP أساسية وأبقِ الموصل مفعلاً.",
    "whatsapp.notice.saved": "تم حفظ إعدادات موصل واتساب لهذا المستأجر.",
    "WhatsApp connector settings saved for this tenant.": "تم حفظ إعدادات موصل واتساب لهذا المستأجر.",
    "whatsapp.error.save": "تعذر حفظ إعدادات واتساب.",
    "whatsapp.notice.discarded": "تم تجاهل المسودة.",
    "Draft discarded.": "تم تجاهل المسودة.",
    "whatsapp.test.title": "إرسال رسالة تجريبية",
    "Send a test message": "إرسال رسالة تجريبية",
    "whatsapp.test.description": "أرسل قالباً معتمداً إلى أي رقم واتساب للتحقق من أن الاتصال يعمل.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "أرسل قالباً معتمداً إلى أي رقم واتساب للتحقق من أن الاتصال يعمل.",
    "whatsapp.test.refresh": "تحديث القوالب",
    "Refresh templates": "تحديث القوالب",
    "whatsapp.test.field.template": "القالب المعتمد",
    "Approved template": "القالب المعتمد",
    "whatsapp.test.field.parameter": "قيمة {{{number}}}",
    "Value for {{{number}}}": "قيمة {{{number}}}",
    "whatsapp.test.field.mobile": "إرسال إلى",
    "Send to": "إرسال إلى",
    "whatsapp.test.field.mobile_help": "رقم واتساب مع رمز الدولة.",
    "WhatsApp number with country code.": "رقم واتساب مع رمز الدولة.",
    "whatsapp.test.action.send": "إرسال الرسالة التجريبية",
    "Send test message": "إرسال الرسالة التجريبية",
    "whatsapp.test.sent": "تم الإرسال إلى {mobile}. معرّف رسالة Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "تم الإرسال إلى {mobile}. معرّف رسالة Meta: {id}",
    "whatsapp.test.no_templates": "لا توجد قوالب معتمدة بعد. فعّل قالباً أعلاه وأرسله بعد موافقة Meta.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "لا توجد قوالب معتمدة بعد. فعّل قالباً أعلاه وأرسله بعد موافقة Meta.",
    "common.discard_draft": "تجاهل المسودة",
    "common.status.connected": "متصل",
    "Connected": "متصل",
    "extensions.title": "الإضافات",
    "extensions.action.add": "إضافة ملحق",
    "Add Extension": "إضافة ملحق",
    "extensions.action.add_new": "إضافة ملحق جديد",
    "Add New Extension": "إضافة ملحق جديد",
    "extensions.action.edit": "تعديل الملحق",
    "Edit Extension": "تعديل الملحق",
    "extensions.action.delete": "حذف الملحق",
    "Delete extension": "حذف الملحق",
    "extensions.field.name": "الاسم",
    "extensions.field.domain": "النطاق",
    "extensions.field.configs": "الإعدادات",
    "Configs": "الإعدادات",
    "extensions.placeholder.name": "اسم الملحق",
    "Extension Name": "اسم الملحق",
    "extensions.placeholder.domain": "نطاق الملحق",
    "Extension Domain": "نطاق الملحق",
    "extensions.empty": "لم يتم إعداد أي ملحقات بعد.",
    "No extensions configured yet.": "لم يتم إعداد أي ملحقات بعد.",
    "extensions.toast.added": "تمت إضافة الملحق بنجاح.",
    "Extension added successfully.": "تمت إضافة الملحق بنجاح.",
    "extensions.toast.updated": "تم تحديث الملحق بنجاح.",
    "Extension updated successfully.": "تم تحديث الملحق بنجاح.",
    "extensions.toast.deleted": "تم حذف الملحق بنجاح.",
    "Extension deleted successfully.": "تم حذف الملحق بنجاح.",
    "extensions.error.name_required": "الاسم مطلوب",
    "extensions.error.domain_required": "النطاق مطلوب",
    "Domain is required": "النطاق مطلوب",
    "extensions.error.configs_required": "الإعدادات مطلوبة",
    "Configs is required": "الإعدادات مطلوبة",
    "extensions.error.save_failed": "تعذر حفظ الملحق.",
    "Unable to save the extension.": "تعذر حفظ الملحق.",
    "extensions.error.delete_failed": "تعذر حذف الملحق.",
    "Unable to delete the extension.": "تعذر حذف الملحق.",
    "automation_rules.kicker": "أتمتة العمليات",
    "Operations automation": "أتمتة العمليات",
    "automation_rules.title": "قواعد الأتمتة",
    "Automation rules": "قواعد الأتمتة",
    "automation_rules.description": "حوّل أحداث الموظفين والمصروفات إلى خطوات واضحة للموافقة والمراجعة.",
    "Turn staff and expense events into clear approval and review steps.": "حوّل أحداث الموظفين والمصروفات إلى خطوات واضحة للموافقة والمراجعة.",
    "automation_rules.action.new_rule": "قاعدة جديدة",
    "New rule": "قاعدة جديدة",
    "automation_rules.action.create_rule": "إنشاء قاعدة",
    "Create rule": "إنشاء قاعدة",
    "automation_rules.action.create_help": "احفظ المشغل والشروط والإجراء كقاعدة",
    "Save this trigger, conditions, and action as a rule": "احفظ المشغل والشروط والإجراء كقاعدة",
    "automation_rules.action.add_condition": "إضافة شرط",
    "Add condition": "إضافة شرط",
    "automation_rules.action.add_condition_help": "أضف شرطاً آخر إلى هذه القاعدة",
    "Add another condition to this rule": "أضف شرطاً آخر إلى هذه القاعدة",
    "automation_rules.action.remove_condition": "إزالة الشرط",
    "Remove condition": "إزالة الشرط",
    "automation_rules.action.choose": "اختر إجراءً",
    "Choose an action": "اختر إجراءً",
    "automation_rules.action.require_second_approver": "طلب موافق ثانٍ",
    "Require second approver": "طلب موافق ثانٍ",
    "automation_rules.action.require_second_approver_help": "وجّه المطالبة إلى موافق آخر.",
    "Route the claim to another approver.": "وجّه المطالبة إلى موافق آخر.",
    "automation_rules.action.auto_reject_expense": "رفض المصروف تلقائياً",
    "Auto-reject expense": "رفض المصروف تلقائياً",
    "automation_rules.action.auto_reject_expense_help": "ارفض المصروف مع ذكر السبب.",
    "Reject the expense with a reason.": "ارفض المصروف مع ذكر السبب.",
    "automation_rules.action.notify_role": "إشعار دور",
    "Notify a role": "إشعار دور",
    "automation_rules.action.notify_role_help": "أرسل إشعاراً إلى دور موظف.",
    "Send a notification to a staff role.": "أرسل إشعاراً إلى دور موظف.",
    "automation_rules.action.flag_for_review": "وضع علامة للمراجعة",
    "Flag for review": "وضع علامة للمراجعة",
    "automation_rules.action.flag_for_review_help": "ضع علامة على المورد للمراجعة اليدوية.",
    "Mark a resource for manual review.": "ضع علامة على المورد للمراجعة اليدوية.",
    "automation_rules.field.rule_name": "اسم القاعدة",
    "Rule name": "اسم القاعدة",
    "automation_rules.field.priority": "الأولوية",
    "automation_rules.field.module": "الوحدة",
    "Module": "الوحدة",
    "automation_rules.field.event": "الحدث",
    "automation_rules.field.field": "الحقل",
    "Field": "الحقل",
    "automation_rules.field.operator": "المعامل",
    "Operator": "المعامل",
    "automation_rules.field.value": "القيمة",
    "automation_rules.field.action": "الإجراء",
    "automation_rules.field.action_params": "معاملات الإجراء",
    "Action parameters": "معاملات الإجراء",
    "automation_rules.placeholder.rule_name": "طلب موافق ثانٍ للمطالبات الكبيرة",
    "Require second approver for large claims": "طلب موافق ثانٍ للمطالبات الكبيرة",
    "automation_rules.placeholder.field": "المبلغ",
    "amount": "المبلغ",
    "automation_rules.placeholder.value": "500 أو false",
    "500 or false": "500 أو false",
    "automation_rules.builder.description": "أنشئ المشغل والشروط والإجراء أدناه ثم احفظها كقاعدة واحدة.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "أنشئ المشغل والشروط والإجراء أدناه ثم احفظها كقاعدة واحدة.",
    "automation_rules.error.load": "تعذر تحميل قواعد الأتمتة.",
    "Unable to load automation rules.": "تعذر تحميل قواعد الأتمتة.",
    "automation_rules.error.required_fields": "الاسم والوحدة والحدث والإجراء مطلوبة.",
    "Name, module, event, and action are required.": "الاسم والوحدة والحدث والإجراء مطلوبة.",
    "automation_rules.error.create": "تعذر إنشاء قاعدة الأتمتة.",
    "Unable to create automation rule.": "تعذر إنشاء قاعدة الأتمتة.",
    "automation_rules.error.valid_json": "أدخل JSON صالحاً قبل الحفظ.",
    "Use valid JSON before saving.": "أدخل JSON صالحاً قبل الحفظ.",
    "automation_rules.notice.created": "تم إنشاء قاعدة الأتمتة.",
    "Automation rule created.": "تم إنشاء قاعدة الأتمتة.",
    "automation_rules.notice.discarded": "تم تجاهل المسودة.",
    "automation_rules.draft.restored": "تمت استعادة مسودة قاعدة الأتمتة غير المحفوظة.",
    "Your unsaved automation rule draft was restored.": "تمت استعادة مسودة قاعدة الأتمتة غير المحفوظة.",
    "automation_rules.list.title": "القواعد",
    "automation_rules.list.count": "تم إعداد {count}",
    "{count} configured": "تم إعداد {count}",
    "automation_rules.list.loading": "جارٍ تحميل القواعد…",
    "Loading rules…": "جارٍ تحميل القواعد…",
    "automation_rules.list.unnamed": "قاعدة بلا اسم",
    "Unnamed rule": "قاعدة بلا اسم",
    "automation_rules.list.no_action": "لم يتم إعداد إجراء",
    "No action configured": "لم يتم إعداد إجراء",
    "automation_rules.list.empty": "لا توجد قواعد بعد. أنشئ أول قاعدة من المخطط.",
    "No rules yet. Create the first one from the diagram.": "لا توجد قواعد بعد. أنشئ أول قاعدة من المخطط.",
    "automation_rules.status.draft": "مسودة",
    "automation_rules.status.active": "نشطة",
    "automation_rules.inspector.title": "إعدادات الكتلة",
    "Block settings": "إعدادات الكتلة",
    "automation_rules.inspector.diagram": "مخطط",
    "Diagram": "مخطط",
    "automation_rules.inspector.select_block": "حدد كتلة في المخطط لإعدادها.",
    "Select a block on the diagram to configure it.": "حدد كتلة في المخطط لإعدادها.",
    "automation_rules.inspector.no_configuration": "لا تحتاج هذه الكتلة إلى إعداد.",
    "This block does not need configuration.": "لا تحتاج هذه الكتلة إلى إعداد.",
    "automation_rules.node.trigger": "مشغل",
    "automation_rules.node.condition": "شرط",
    "automation_rules.node.action": "إجراء",
    "automation_rules.node.end": "نهاية",
    "automation_rules.node.completed": "مكتمل",
    "automation_rules.node.finished": "اكتمل تقييم القاعدة",
    "Rule evaluation finished": "اكتمل تقييم القاعدة",
    "automation_rules.trigger.choose_event": "اختر حدثاً",
    "Choose an event": "اختر حدثاً",
    "automation_rules.trigger.module": "وحدة",
    "module": "وحدة",
    "automation_rules.trigger.module_event": "حدث الوحدة {module}",
    "{module} event": "حدث الوحدة {module}",
    "automation_rules.trigger.help": "يتم تقييم القاعدة عند إصدار الوحدة لهذا الحدث.",
    "The rule evaluates when this event is emitted by the module.": "يتم تقييم القاعدة عند إصدار الوحدة لهذا الحدث.",
    "automation_rules.condition.label": "شرط",
    "automation_rules.condition.none": "بدون شروط",
    "No conditions": "بدون شروط",
    "automation_rules.condition.always_fires": "يتم تشغيله دائماً",
    "Always fires": "يتم تشغيله دائماً",
    "automation_rules.condition.empty_help": "أضف شرطاً لتقييد هذه القاعدة.",
    "Add a condition to restrict this rule.": "أضف شرطاً لتقييد هذه القاعدة.",
    "automation_rules.condition.value_required": "القيمة مطلوبة",
    "Value required": "القيمة مطلوبة",
    "automation_rules.condition.value": "القيمة: {value}",
    "Value: {value}": "القيمة: {value}",
    "automation_rules.operator.equals": "يساوي",
    "Equals": "يساوي",
    "automation_rules.operator.gt": "أكبر من",
    "Greater than": "أكبر من",
    "automation_rules.operator.gte": "أكبر من أو يساوي",
    "Greater than or equal": "أكبر من أو يساوي",
    "automation_rules.operator.lt": "أقل من",
    "Less than": "أقل من",
    "automation_rules.operator.exists": "موجود",
    "Exists": "موجود",
    "automation_rules.module.expenses": "المصروفات",
    "automation_rules.module.staff": "الموظفون",
    "automation_rules.event.expense.submitted": "تم إرسال المصروف",
    "automation_rules.event.leave.requested": "تم طلب إجازة",
    "Leave requested": "تم طلب إجازة",
    "automation_rules.event.payroll_run.created": "تم إنشاء مسير الرواتب",
    "automation_rules.meta.conditions": "{count} شروط · يجب أن تتطابق جميعها قبل تنفيذ الإجراء",
    "{count} condition(s) · all must match before the action runs": "{count} شروط · يجب أن تتطابق جميعها قبل تنفيذ الإجراء",
    "automation_rules.meta.no_conditions": "بدون شروط · يتم تنفيذ الإجراء دائماً بعد المشغل",
    "No conditions · the action always runs after the trigger": "بدون شروط · يتم تنفيذ الإجراء دائماً بعد المشغل",
    "automation_rules.draft.unsaved": "لديك مسودة غير محفوظة لقاعدة أتمتة.",
    "You have an unsaved automation rule draft.": "لديك مسودة غير محفوظة لقاعدة أتمتة.",
    "automation_rules.meta.one_condition": "شرط واحد · يجب أن يتطابق قبل تنفيذ الإجراء",
    "1 condition · all must match before the action runs": "شرط واحد · يجب أن يتطابق قبل تنفيذ الإجراء",
    "automation_rules.meta.many_conditions": "{count} شروط · يجب أن تتطابق جميعها قبل تنفيذ الإجراء",
    "{count} conditions · all must match before the action runs": "{count} شروط · يجب أن تتطابق جميعها قبل تنفيذ الإجراء",
    "cms.type.page": "صفحة",
    "Page": "صفحة",
    "cms.type.blog": "مدونة",
    "cms.type.docs": "مستندات",
    "cms.type.pages": "صفحات",
    "cms.type.blogs": "مدونات",
    "Blogs": "مدونات",
    "cms.action.add_content": "إضافة محتوى",
    "Add content": "إضافة محتوى",
    "cms.action.add_type": "إضافة {type}",
    "cms.action.create_type": "إنشاء {type}",
    "Create {type}": "إنشاء {type}",
    "cms.action.edit": "تعديل",
    "cms.action.duplicate": "تكرار",
    "Duplicate": "تكرار",
    "cms.action.open": "فتح",
    "cms.field.title": "العنوان",
    "cms.field.slug": "الرابط المختصر",
    "cms.field.content": "المحتوى",
    "cms.field.meta_title": "عنوان محركات البحث",
    "cms.field.meta_description": "وصف محركات البحث",
    "cms.placeholder.title": "مثال: من نحن",
    "e.g. About us": "مثال: من نحن",
    "cms.placeholder.slug": "من-نحن",
    "about-us": "من-نحن",
    "cms.placeholder.page_title": "عنوان الصفحة",
    "Page title": "عنوان الصفحة",
    "cms.placeholder.page_slug": "رابط-الصفحة",
    "page-slug": "رابط-الصفحة",
    "cms.placeholder.content": "اكتب المحتوى هنا…",
    "Write your content here…": "اكتب المحتوى هنا…",
    "cms.placeholder.meta_title": "يستخدم العنوان افتراضياً",
    "Defaults to title": "يستخدم العنوان افتراضياً",
    "cms.placeholder.meta_description": "وصف موجز لمحركات البحث",
    "Short description for search engines": "وصف موجز لمحركات البحث",
    "cms.section.seo_optional": "تحسين محركات البحث (اختياري)",
    "SEO (optional)": "تحسين محركات البحث (اختياري)",
    "cms.error.title_required": "العنوان مطلوب.",
    "Title is required.": "العنوان مطلوب.",
    "cms.error.content_required": "أضف محتوى قبل الحفظ.",
    "Add some content before saving.": "أضف محتوى قبل الحفظ.",
    "cms.error.create": "فشل الإنشاء. يرجى المحاولة مجدداً.",
    "Failed to create. Please try again.": "فشل الإنشاء. يرجى المحاولة مجدداً.",
    "cms.error.save": "فشل الحفظ.",
    "Failed to save.": "فشل الحفظ.",
    "cms.error.load_layer": "تعذر تحميل هذا المحتوى.",
    "Could not load this layer.": "تعذر تحميل هذا المحتوى.",
    "cms.toast.created": "تم إنشاء {type} بنجاح.",
    "{type} created successfully.": "تم إنشاء {type} بنجاح.",
    "cms.toast.saved": "تم الحفظ",
    "Saved": "تم الحفظ",
    "cms.toast.changes_saved": "تم حفظ التغييرات.",
    "Changes saved.": "تم حفظ التغييرات.",
    "cms.toast.deleted": "تم الحذف",
    "cms.toast.duplicated": "تم التكرار",
    "Duplicated": "تم التكرار",
    "cms.error.delete": "فشل الحذف",
    "Failed to delete": "فشل الحذف",
    "cms.error.duplicate": "فشل التكرار",
    "Failed to duplicate": "فشل التكرار",
    "cms.confirm.delete": "هل تريد حذف \"{title}\"؟",
    "Delete \"{title}\"?": "هل تريد حذف \"{title}\"؟",
    "cms.duplicate.title": "{title} (نسخة)",
    "{title} (copy)": "{title} (نسخة)",
    "cms.draft.restored": "تمت استعادة مسودة المحتوى غير المحفوظة.",
    "Your unsaved content draft was restored.": "تمت استعادة مسودة المحتوى غير المحفوظة.",
    "cms.search": "بحث…",
    "Search…": "بحث…",
    "cms.list.no_results": "لم يتم العثور على نتائج.",
    "No results found.": "لم يتم العثور على نتائج.",
    "cms.list.empty_type": "لا يوجد {type} بعد.",
    "No {type} yet.": "لا يوجد {type} بعد.",
    "cms.list.untitled": "بلا عنوان",
    "Untitled": "بلا عنوان",
    "cms.editor.placeholder": "اكتب المحتوى هنا…",
    "cms.editor.normal_text": "نص عادي",
    "Normal text": "نص عادي",
    "cms.editor.heading": "عنوان {level}",
    "Heading {level}": "عنوان {level}",
    "cms.editor.align_left": "محاذاة لليسار",
    "Align Left": "محاذاة لليسار",
    "cms.editor.align_center": "توسيط",
    "Align Center": "توسيط",
    "cms.editor.align_right": "محاذاة لليمين",
    "Align Right": "محاذاة لليمين",
    "cms.editor.insert_table": "إدراج جدول",
    "Insert table": "إدراج جدول",
    "cms.editor.add_column": "إضافة عمود",
    "Add column": "إضافة عمود",
    "cms.editor.add_row": "إضافة صف",
    "Add row": "إضافة صف",
    "cms.editor.delete_table": "حذف الجدول",
    "Delete table": "حذف الجدول",
    "cms.editor.delete_column": "حذف العمود",
    "Delete column": "حذف العمود",
    "cms.editor.delete_row": "حذف الصف",
    "Delete row": "حذف الصف",
    "cms.editor.underline": "تسطير",
    "Underline": "تسطير",
    "cms.editor.strikethrough": "يتوسطه خط",
    "Strikethrough": "يتوسطه خط",
    "cms.editor.code": "رمز",
    "cms.editor.code_block": "كتلة رمز",
    "Code block": "كتلة رمز",
    "cms.editor.subscript": "منخفض",
    "Subscript": "منخفض",
    "cms.editor.superscript": "مرتفع",
    "Superscript": "مرتفع",
    "cms.editor.prompt.url": "رابط URL",
    "cms.editor.prompt.image_url": "رابط الصورة",
    "Image URL": "رابط الصورة",
    "cms.editor.prompt.youtube_url": "رابط YouTube",
    "YouTube URL": "رابط YouTube",
    "cms.editor.undo": "تراجع",
    "cms.editor.redo": "إعادة",
    "cms.editor.table": "جدول",
    "Table": "جدول",
    "cms.editor.more": "المزيد",
    "cms.editor.bold": "عريض",
    "Bold": "عريض",
    "cms.editor.italic": "مائل",
    "Italic": "مائل",
    "cms.editor.bullet_list": "قائمة نقطية",
    "Bullet list": "قائمة نقطية",
    "cms.editor.ordered_list": "قائمة مرقمة",
    "Ordered list": "قائمة مرقمة",
    "cms.editor.task_list": "قائمة مهام",
    "Task list": "قائمة مهام",
    "cms.editor.link": "رابط",
    "Link": "رابط",
    "cms.editor.image": "صورة",
    "cms.editor.text_color": "لون النص",
    "Text color": "لون النص",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "صفحات",
    "cms.test.type.pages_description": "صفحات الهبوط ومحتوى المتجر المنظم.",
    "Landing pages and structured storefront content.": "صفحات الهبوط ومحتوى المتجر المنظم.",
    "cms.test.type.blogs": "مدونات",
    "cms.test.type.blogs_description": "مقالات وقصص وتحديثات لجمهورك.",
    "Articles, stories, and updates for your audience.": "مقالات وقصص وتحديثات لجمهورك.",
    "cms.test.type.docs": "مستندات",
    "cms.test.type.docs_description": "التوثيق والأدلة ومحتوى المساعدة.",
    "Documentation, guides, and help content.": "التوثيق والأدلة ومحتوى المساعدة.",
    "cms.test.operation.list": "قائمة المحتوى حسب النوع",
    "List content by type": "قائمة المحتوى حسب النوع",
    "cms.test.operation.fetch": "جلب عنصر محتوى",
    "Fetch one Layer": "جلب عنصر محتوى",
    "cms.test.operation.create": "إنشاء محتوى",
    "Create a Layer": "إنشاء محتوى",
    "cms.test.operation.update": "تحديث المحتوى",
    "Update a Layer": "تحديث المحتوى",
    "cms.test.operation.delete": "حذف محتوى",
    "Delete a Layer": "حذف محتوى",
    "cms.test.operation.search": "بحث في المحتوى",
    "Search content": "بحث في المحتوى",
    "cms.test.operation.categories": "تحميل الفئات",
    "Load categories": "تحميل الفئات",
    "cms.test.operation.translations": "حفظ الترجمات",
    "Save translations": "حفظ الترجمات",
    "cms.test.editor.placeholder": "اكتب محتوى صفحتك…",
    "Write your page content...": "اكتب محتوى صفحتك…",
    "cms.test.error.load_type": "تعذر تحميل محتوى {type}",
    "Unable to load {type} content": "تعذر تحميل محتوى {type}",
    "cms.test.error.load": "تعذر تحميل محتوى CMS.",
    "Unable to load CMS content.": "تعذر تحميل محتوى CMS.",
    "cms.test.error.required": "أضف عنوان الصفحة والمحتوى قبل الحفظ.",
    "Add a page title and content before saving.": "أضف عنوان الصفحة والمحتوى قبل الحفظ.",
    "cms.test.error.create": "تعذر إنشاء هذه الصفحة.",
    "Unable to create this page.": "تعذر إنشاء هذه الصفحة.",
    "cms.test.toast.created": "تم إنشاء الصفحة بنجاح.",
    "Page created successfully.": "تم إنشاء الصفحة بنجاح.",
    "cms.test.hero.eyebrow": "إدارة المحتوى",
    "CONTENT MANAGEMENT": "إدارة المحتوى",
    "cms.test.hero.title": "نظام Layers لإدارة المحتوى",
    "Layers CMS": "نظام Layers لإدارة المحتوى",
    "cms.test.hero.description": "أنشئ محتوى منظماً مرة واحدة وأتحه عبر متجرك وتطبيقاتك وتجاربك المخصصة.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "أنشئ محتوى منظماً مرة واحدة وأتحه عبر متجرك وتطبيقاتك وتجاربك المخصصة.",
    "cms.test.hero.live_workspace": "مساحة العمل الحالية: {tenant} · معاينة للقراءة فقط",
    "Live workspace: {tenant} · read-only preview": "مساحة العمل الحالية: {tenant} · معاينة للقراءة فقط",
    "cms.test.current_tenant": "المستأجر الحالي",
    "current tenant": "المستأجر الحالي",
    "cms.test.content.title": "محتواك",
    "Your content": "محتواك",
    "cms.test.content.description": "أدر الصفحات والمدونات والمستندات من مكان واحد.",
    "Pages, blogs, and docs are ready to manage from one place.": "أدر الصفحات والمدونات والمستندات من مكان واحد.",
    "cms.test.action.create_page": "إنشاء صفحة",
    "Create Page": "إنشاء صفحة",
    "cms.test.form.description": "أنشئ محتوى صفحة منظماً في Layers. ستصبح الصفحة متاحة عبر API بعد الحفظ.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "أنشئ محتوى صفحة منظماً في Layers. ستصبح الصفحة متاحة عبر API بعد الحفظ.",
    "cms.test.placeholder.slug": "من-نحن (اختياري)",
    "about-us (optional)": "من-نحن (اختياري)",
    "cms.test.draft.unsaved": "لديك مسودة صفحة غير محفوظة.",
    "You have an unsaved page draft.": "لديك مسودة صفحة غير محفوظة.",
    "cms.test.loading": "جارٍ تحميل محتوى Layers…",
    "Loading live Layers content…": "جارٍ تحميل محتوى Layers…",
    "cms.test.content.empty_title": "لا يوجد {type} بعد",
    "No {type} yet": "لا يوجد {type} بعد",
    "cms.test.content.empty_description": "أنشئ أول عنصر محتوى في مساحة العمل لعرضه هنا.",
    "Create your first Layer in the workspace to see it here.": "أنشئ أول عنصر محتوى في مساحة العمل لعرضه هنا.",
    "cms.test.feature.types": "أنواع محتوى مخصصة",
    "Custom content types": "أنواع محتوى مخصصة",
    "cms.test.feature.types_description": "الصفحات والمدونات والمستندات نقاط بداية. عرّف نموذج منشور أو أي نموذج يحتاجه نشاطك.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "الصفحات والمدونات والمستندات نقاط بداية. عرّف نموذج منشور أو أي نموذج يحتاجه نشاطك.",
    "cms.test.feature.structured": "منظم ومترجم",
    "Structured and localized": "منظم ومترجم",
    "cms.test.feature.structured_description": "استخدم روابط مختصرة وفئات وصوراً وبيانات SEO وترجمات لمصدر المحتوى نفسه.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "استخدم روابط مختصرة وفئات وصوراً وبيانات SEO وترجمات لمصدر المحتوى نفسه.",
    "cms.test.feature.headless": "بلا واجهة افتراضياً",
    "Headless by default": "بلا واجهة افتراضياً",
    "cms.test.feature.headless_description": "استخدم Layers API في موقع أو تطبيق جوال أو أداة داخلية أو واجهة مخصصة.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "استخدم Layers API في موقع أو تطبيق جوال أو أداة داخلية أو واجهة مخصصة.",
    "cms.test.feature.ai": "مصدر معرفة للذكاء الاصطناعي",
    "AI knowledge source": "مصدر معرفة للذكاء الاصطناعي",
    "cms.test.feature.ai_description": "أرسل محتوى Tradly CMS إلى iRyxo Agent Builder كمصدر معرفة.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "أرسل محتوى Tradly CMS إلى iRyxo Agent Builder كمصدر معرفة.",
    "cms.test.community.eyebrow": "محتوى المجتمع",
    "COMMUNITY CONTENT": "محتوى المجتمع",
    "cms.test.community.title": "حوّل Layers إلى موجز اجتماعي",
    "Turn Layers into a social feed": "حوّل Layers إلى موجز اجتماعي",
    "cms.test.community.description": "أنشئ نوع منشور مخصصاً واسمح للمستخدمين بنشر التحديثات وأضف التفاعل عبر واجهتك.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "أنشئ نوع منشور مخصصاً واسمح للمستخدمين بنشر التحديثات وأضف التفاعل عبر واجهتك.",
    "cms.test.community.share_placeholder": "شارك تحديثاً…",
    "Share an update…": "شارك تحديثاً…",
    "cms.test.community.post": "نشر",
    "Post": "نشر",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "تحديث مجتمعي منشور من محتوى مخصص.",
    "A community update published from a custom Layer.": "تحديث مجتمعي منشور من محتوى مخصص.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 تعليقات   ·   ↗ مشاركة",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 تعليقات   ·   ↗ مشاركة",
    "cms.test.community.endpoints": "أمثلة لنقاط النهاية",
    "Example endpoints": "أمثلة لنقاط النهاية",
    "cms.test.developer.eyebrow": "وصول المطور",
    "DEVELOPER ACCESS": "وصول المطور",
    "cms.test.developer.title": "Layers API",
    "Layers API": "Layers API",
    "cms.test.developer.docs": "توثيق المطور",
    "Developer docs": "توثيق المطور",
    "auth.title": "Authentification",
    "auth.sign_in_method": "طريقة تسجيل الدخول",
    "auth.facebook_auth": "مصادقة Facebook",
    "auth.google_auth": "مصادقة Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "تسجيل الدخول الموحد للمؤسسات",
    "Enterprise SSO": "تسجيل الدخول الموحد للمؤسسات",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "إعدادات الدفع",
    "Checkout Settings": "إعدادات الدفع",
    "checkout.orders": "الطلبات",
    "checkout.carts": "السلال",
    "Carts": "السلال",
    "audit_logs.action": "الإجراء",
    "audit_logs.resource": "المورد",
    "audit_logs.resource_id": "معرّف المورد",
    "Resource ID": "معرّف المورد",
    "audit_logs.agent_id": "معرّف الوكيل",
    "Agent ID": "معرّف الوكيل",
    "audit_logs.result": "النتيجة",
    "audit_logs.actor_id": "معرّف المنفذ",
    "Actor ID": "معرّف المنفذ",
    "audit_logs.ip": "عنوان IP",
    "IP": "عنوان IP",
    "audit_logs.timestamp": "الطابع الزمني",
    "Timestamp": "الطابع الزمني",
    "audit_logs.succeeded": "نجح",
    "audit_logs.failed": "فشل",
    "audit_logs.source": "المصدر",
    "audit_logs.all_sources": "كل المصادر",
    "All sources": "كل المصادر",
    "audit_logs.human_admin": "مستخدم بشري (مسؤول)",
    "Human (admin)": "مستخدم بشري (مسؤول)",
    "audit_logs.agent_mcp": "وكيل (MCP)",
    "Agent (MCP)": "وكيل (MCP)",
    "audit_logs.all_actions": "كل الإجراءات",
    "All actions": "كل الإجراءات",
    "audit_logs.from": "من",
    "audit_logs.to": "إلى",
    "audit_logs.apply": "تطبيق",
    "audit_logs.clear": "مسح",
    "audit_logs.export_csv": "تصدير CSV",
    "audit_logs.exporting": "جارٍ التصدير…",
    "audit_logs.title": "سجلات التدقيق",
    "audit_logs.empty_title": "لم يتم العثور على سجلات تدقيق",
    "No audit logs found": "لم يتم العثور على سجلات تدقيق",
    "audit_logs.empty_subtitle": "جرّب تعديل عوامل التصفية",
    "Try adjusting your filters": "جرّب تعديل عوامل التصفية",
    "audit_logs.restriction_notice": "يتم عرض أحدث 5 سجلات تدقيق. قم بالترقية إلى Growth لعرض السجل الكامل وتصدير السجلات.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "يتم عرض أحدث 5 سجلات تدقيق. قم بالترقية إلى Growth لعرض السجل الكامل وتصدير السجلات.",
    "audit_logs.extended_history": "سجل تدقيق موسع",
    "Extended audit log history": "سجل تدقيق موسع",
    "manage_features.title": "إدارة الميزات",
    "manage_features.general": "عام",
    "manage_features.apps": "التطبيقات",
    "manage_features.marketplace": "السوق",
    "manage_features.commerce": "التجارة",
    "manage_features.channels": "القنوات",
    "manage_features.left_menu": "القائمة اليسرى",
    "Left Menu": "القائمة اليسرى",
    "manage_features.right_sidepanel": "اللوحة الجانبية اليمنى",
    "Right Sidepanel": "اللوحة الجانبية اليمنى",
    "workflow.integration": "التكامل",
    "workflow.no_url_title": "لا يوجد رابط تكامل",
    "No Integration URL": "لا يوجد رابط تكامل",
    "workflow.no_url_description": "يرجى إعداد رابط التكامل.",
    "Please configure the integration URL.": "يرجى إعداد رابط التكامل.",
    "workflow.back": "رجوع",
    "Go Back": "رجوع",
    "workflow.loading": "جارٍ تحميل التكامل…",
    "Loading integration...": "جارٍ تحميل التكامل…",
    "workflow.loading_hint": "يرجى الانتظار أثناء الاتصال",
    "Please wait while we connect": "يرجى الانتظار أثناء الاتصال",
    "workflow.error_title": "خطأ في التكامل",
    "Integration Error": "خطأ في التكامل",
    "workflow.error_description": "تعذر تحميل التكامل. تحقق من اتصالك وحاول مرة أخرى.",
    "Unable to load the integration. Please check your connection and try again.": "تعذر تحميل التكامل. تحقق من اتصالك وحاول مرة أخرى.",
    "workflow.retry": "حاول مرة أخرى",
    "Try Again": "حاول مرة أخرى",
    "upgrade_preview.eyebrow": "معاينة المكون",
    "Component preview": "معاينة المكون",
    "upgrade_preview.title": "تجربة الترقية",
    "Upgrade experience": "تجربة الترقية",
    "upgrade_preview.description": "بوابة ميزات مشتركة توضّح ما يمكن للعميل إنجازه بعد الترقية.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "بوابة ميزات مشتركة توضّح ما يمكن للعميل إنجازه بعد الترقية.",
    "upgrade_preview.feature": "إضافة نوع",
    "Add a variant": "إضافة نوع",
    "upgrade_preview.context": "هذه هي النقطة التي يصل فيها مستخدم الخطة الأساسية إلى حد الميزة.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "هذه هي النقطة التي يصل فيها مستخدم الخطة الأساسية إلى حد الميزة.",
    "upgrade_preview.button": "معاينة لوحة الترقية",
    "Preview upgrade panel": "معاينة لوحة الترقية",
    "upgrade_preview.listing_context": "لهذا العرض",
    "For this listing": "لهذا العرض",
    "gamification_test.eyebrow": "تحفيز النمو · مسار اختبار",
    "GROWTH GAMIFICATION · TEST ROUTE": "تحفيز النمو · مسار اختبار",
    "gamification_test.title": "ادفع عملك إلى الأمام",
    "Build momentum for your business": "ادفع عملك إلى الأمام",
    "gamification_test.subtitle": "عاين المهام والعملات والشارات وسلاسل الإنجاز في {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "عاين المهام والعملات والشارات وسلاسل الإنجاز في {workspace}.",
    "gamification_test.this_workspace": "مساحة العمل هذه",
    "this workspace": "مساحة العمل هذه",
    "gamification_test.coins": "عملات",
    "COINS": "عملات",
    "gamification_test.points": "نقاط",
    "POINTS": "نقاط",
    "gamification_test.streak": "سلسلة",
    "STREAK": "سلسلة",
    "gamification_test.week": "أسبوع واحد",
    "1 week": "أسبوع واحد",
    "gamification_test.launch": "مسار الإطلاق",
    "Launch path": "مسار الإطلاق",
    "gamification_test.progress": "اكتمل {completed} من {total} إجراءات · حتى {coins} عملات",
    "{completed} of {total} actions complete · up to {coins} coins": "اكتمل {completed} من {total} إجراءات · حتى {coins} عملات",
    "gamification_test.done": "تم",
    "gamification_test.reward": "+{count} عملات",
    "+{count} coins": "+{count} عملات",
    "gamification_test.badges": "الشارات",
    "Badges": "الشارات",
    "gamification_test.mission_listing_created": "أنشئ أول عرض لك",
    "Create your first listing": "أنشئ أول عرض لك",
    "gamification_test.mission_collection_created": "أنشئ أول مجموعة لك",
    "gamification_test.mission_payment_configured": "أعد إعداد المدفوعات",
    "Configure payments": "أعد إعداد المدفوعات",
    "gamification_test.mission_publish_completed": "انشر موقعك",
    "Publish your site": "انشر موقعك",
    "gamification_test.mission_analytics_enabled": "فعّل التحليلات",
    "Enable analytics": "فعّل التحليلات",
    "gamification_test.badge_first_step": "الخطوة الأولى",
    "First Step": "الخطوة الأولى",
    "gamification_test.badge_catalog_builder": "منشئ الكتالوج",
    "Catalog Builder": "منشئ الكتالوج",
    "gamification_test.badge_ready_to_sell": "جاهز للبيع",
    "Ready to Sell": "جاهز للبيع",
    "gamification_test.badge_data_driven": "مدفوع بالبيانات",
    "Data Driven": "مدفوع بالبيانات",
    "gamification_test.badge_growth_operator": "مسؤول النمو",
    "Growth Operator": "مسؤول النمو",
    "sentry_check.title": "التحقق من إعداد Sentry",
    "Sentry Configuration Check": "التحقق من إعداد Sentry",
    "sentry_check.subtitle": "اختبر وتحقق من إعداد تتبع الأخطاء في Sentry",
    "Test and verify Sentry error tracking setup": "اختبر وتحقق من إعداد تتبع الأخطاء في Sentry",
    "sentry_check.configuration": "الإعداد",
    "sentry_check.check_configuration": "التحقق من الإعداد",
    "Check Configuration": "التحقق من الإعداد",
    "sentry_check.status": "الحالة:",
    "Status:": "الحالة:",
    "sentry_check.enabled": "✓ مفعّل",
    "✓ Enabled": "✓ مفعّل",
    "sentry_check.disabled": "✗ معطّل",
    "✗ Disabled": "✗ معطّل",
    "sentry_check.environment": "البيئة:",
    "Environment:": "البيئة:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "معدل عينات التتبّع:",
    "Traces Sample Rate:": "معدل عينات التتبّع:",
    "sentry_check.test_functions": "وظائف الاختبار",
    "Test Functions": "وظائف الاختبار",
    "sentry_check.test_hint": "انقر الأزرار أدناه لاختبار وظائف Sentry المختلفة. تحقق من لوحة Sentry للتأكد من تسجيل الأحداث.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "انقر الأزرار أدناه لاختبار وظائف Sentry المختلفة. تحقق من لوحة Sentry للتأكد من تسجيل الأحداث.",
    "sentry_check.test_results": "نتائج الاختبار",
    "Test Results": "نتائج الاختبار",
    "sentry_check.clear": "مسح",
    "sentry_check.no_tests": "لم يتم تشغيل اختبارات بعد",
    "No tests run yet": "لم يتم تشغيل اختبارات بعد",
    "sentry_check.important_notes": "⚠️ ملاحظات مهمة",
    "⚠️ Important Notes": "⚠️ ملاحظات مهمة",
    "sentry_check.warning_real_events": "• ستنشئ هذه الاختبارات أحداث أخطاء فعلية في لوحة Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• ستنشئ هذه الاختبارات أحداث أخطاء فعلية في لوحة Sentry",
    "sentry_check.warning_dashboard": "• تحقق من لوحة Sentry للتأكد من تسجيل الأحداث",
    "• Check your Sentry dashboard to verify events are being captured": "• تحقق من لوحة Sentry للتأكد من تسجيل الأحداث",
    "sentry_check.warning_traces": "• قد لا تظهر بعض الاختبارات في Sentry إذا كانت قيمة tracesSampleRate هي 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• قد لا تظهر بعض الاختبارات في Sentry إذا كانت قيمة tracesSampleRate هي 0.0",
    "sentry_check.warning_dsn": "• تأكد من إعداد DSN بشكل صحيح في متغيرات البيئة",
    "• Make sure your DSN is correctly configured in environment variables": "• تأكد من إعداد DSN بشكل صحيح في متغيرات البيئة",
    "sentry_check.normal_error": "اختبار خطأ عادي",
    "Test Normal Error": "اختبار خطأ عادي",
    "sentry_check.test_normal_error": "اختبار خطأ عادي",
    "sentry_check.test_message": "اختبار رسالة",
    "Test Message": "اختبار رسالة",
    "sentry_check.test_breadcrumb": "اختبار مسار التتبع",
    "Test Breadcrumb": "اختبار مسار التتبع",
    "sentry_check.test_user_context": "اختبار سياق المستخدم",
    "Test User Context": "اختبار سياق المستخدم",
    "sentry_check.test_custom_exception": "اختبار استثناء مخصص",
    "Test Custom Exception": "اختبار استثناء مخصص",
    "sentry_check.test_promise_rejection": "اختبار رفض الوعد",
    "Test Promise Rejection": "اختبار رفض الوعد",
    "sentry_check.configuration_check": "فحص الإعداد",
    "Configuration Check": "فحص الإعداد",
    "sentry_check.config_loaded": "تم تحميل الإعداد بنجاح",
    "Config loaded successfully": "تم تحميل الإعداد بنجاح",
    "sentry_check.error_captured": "تم التقاط الخطأ وإرساله إلى Sentry",
    "Error captured and sent to Sentry": "تم التقاط الخطأ وإرساله إلى Sentry",
    "sentry_check.error_capture_failed": "تعذر التقاط الخطأ: {message}",
    "Failed to capture error: {message}": "تعذر التقاط الخطأ: {message}",
    "sentry_check.message": "رسالة",
    "Message": "رسالة",
    "sentry_check.message_captured": "تم التقاط الرسالة وإرسالها إلى Sentry",
    "Message captured and sent to Sentry": "تم التقاط الرسالة وإرسالها إلى Sentry",
    "sentry_check.message_capture_failed": "تعذر التقاط الرسالة: {message}",
    "Failed to capture message: {message}": "تعذر التقاط الرسالة: {message}",
    "sentry_check.breadcrumb": "مسار التتبع",
    "Breadcrumb": "مسار التتبع",
    "sentry_check.breadcrumb_added": "تمت إضافة مسار التتبع إلى سياق Sentry",
    "Breadcrumb added to Sentry context": "تمت إضافة مسار التتبع إلى سياق Sentry",
    "sentry_check.breadcrumb_failed": "تعذرت إضافة مسار التتبع: {message}",
    "Failed to add breadcrumb: {message}": "تعذرت إضافة مسار التتبع: {message}",
    "sentry_check.user_context": "سياق المستخدم",
    "User Context": "سياق المستخدم",
    "sentry_check.user_set": "تم تعيين سياق المستخدم في Sentry",
    "User context set in Sentry": "تم تعيين سياق المستخدم في Sentry",
    "sentry_check.user_failed": "تعذر تعيين سياق المستخدم: {message}",
    "Failed to set user context: {message}": "تعذر تعيين سياق المستخدم: {message}",
    "sentry_check.custom_exception": "استثناء مخصص",
    "Custom Exception": "استثناء مخصص",
    "sentry_check.custom_sent": "تم إرسال استثناء مخصص مع السياق إلى Sentry",
    "Custom exception with context sent to Sentry": "تم إرسال استثناء مخصص مع السياق إلى Sentry",
    "sentry_check.custom_failed": "تعذر التقاط الاستثناء المخصص: {message}",
    "Failed to capture custom exception: {message}": "تعذر التقاط الاستثناء المخصص: {message}",
    "sentry_check.promise_rejection": "رفض الوعد",
    "Promise Rejection": "رفض الوعد",
    "sentry_check.promise_captured": "تم التقاط رفض الوعد وإرساله إلى Sentry",
    "Promise rejection captured and sent to Sentry": "تم التقاط رفض الوعد وإرساله إلى Sentry",
    "sentry_check.promise_failed": "تعذرت معالجة رفض الوعد: {message}",
    "Failed to handle promise rejection: {message}": "تعذرت معالجة رفض الوعد: {message}",
    "checkout_settings.orders": "الطلبات",
    "checkout_settings.return_policy_days": "أيام سياسة الإرجاع",
    "Return policy days": "أيام سياسة الإرجاع",
    "checkout_settings.enter_return_policy_days": "أدخل أيام سياسة الإرجاع",
    "Enter return policy days": "أدخل أيام سياسة الإرجاع",
    "checkout_settings.saved": "تم الرفع بنجاح",
    "checkout_settings.cart": "السلة",
    "checkout_settings.hide_quantity_selection": "إخفاء اختيار الكمية (افتراضيًا: يظهر حقل اختيار الكمية)",
    "Hide quantity selection (Default: Shows field to select quantity)": "إخفاء اختيار الكمية (افتراضيًا: يظهر حقل اختيار الكمية)",
    "checkout_settings.enable_coupon": "تفعيل القسائم",
    "Enable Coupon": "تفعيل القسائم",
    "upgrade_page.copy.a_practical_next_step": "خطوة عملية إلى الأمام",
    "A practical next step": "خطوة عملية إلى الأمام",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "أضف المعلومات المنظمة التي يحتاجها سير عملك.",
    "Add the structured information your workflow needs.": "أضف المعلومات المنظمة التي يحتاجها سير عملك.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "عيّن الأدوار والأذونات لكل عضو في الفريق.",
    "Assign roles and permissions to every teammate.": "عيّن الأدوار والأذونات لكل عضو في الفريق.",
    "upgrade_page.copy.audit_log_export": "تصدير سجلات التدقيق",
    "Audit log export": "تصدير سجلات التدقيق",
    "upgrade_page.copy.best_next_step": "أفضل خطوة تالية",
    "Best next step": "أفضل خطوة تالية",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "استورد سجلات منظمة، وعدّلها دون اتصال، وصدّرها عندما يحتاج فريقك إلى نسخة عمل كاملة.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "استورد سجلات منظمة، وعدّلها دون اتصال، وصدّرها عندما يحتاج فريقك إلى نسخة عمل كاملة.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "تجاوز الواجهة القياسية",
    "Build beyond the standard interface": "تجاوز الواجهة القياسية",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "اجمع التفاصيل التي تجعل كتالوجك مفيدًا.",
    "Capture the details that make your catalogue useful.": "اجمع التفاصيل التي تجعل كتالوجك مفيدًا.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "استفد من المرونة لبناء تجاربك الخاصة للعملاء باستخدام Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "استفد من المرونة لبناء تجاربك الخاصة للعملاء باستخدام Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "اجمع العروض الحالية في حزم منسقة ودع العملاء يختارون العناصر المؤهلة عند الدفع.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "اجمع العروض الحالية في حزم منسقة ودع العملاء يختارون العناصر المؤهلة عند الدفع.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "أعد إعداد العملات التي يحتاجها نشاطك عند العمل في مناطق مختلفة.",
    "Configure the currencies your business needs as you operate across regions.": "أعد إعداد العملات التي يحتاجها نشاطك عند العمل في مناطق مختلفة.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "اربط منصتك بأدواتك الداخلية وبالأتمتة عندما لا يعود العمل اليدوي قابلًا للتوسع.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "اربط منصتك بأدواتك الداخلية وبالأتمتة عندما لا يعود العمل اليدوي قابلًا للتوسع.",
    "upgrade_page.copy.connect_your_own_tools": "اربط أدواتك الخاصة",
    "Connect your own tools": "اربط أدواتك الخاصة",
    "upgrade_page.copy.control_who_can_see_and_change_what": "تحكم فيمن يمكنه رؤية العناصر وتعديلها.",
    "Control who can see and change what.": "تحكم فيمن يمكنه رؤية العناصر وتعديلها.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "أنشئ حقولًا مخصصة للمعلومات التي يحتاج العملاء وفريقك إلى رؤيتها في كل عرض أو حساب.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "أنشئ حقولًا مخصصة للمعلومات التي يحتاج العملاء وفريقك إلى رؤيتها في كل عرض أو حساب.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "أنشئ حزمًا ثابتة أو قابلة للتخصيص.",
    "Create fixed and mix-and-match bundles.": "أنشئ حزمًا ثابتة أو قابلة للتخصيص.",
    "upgrade_page.copy.custom_attributes": "سمات مخصصة",
    "Custom attributes": "سمات مخصصة",
    "upgrade_page.copy.custom_email_templates": "قوالب بريد إلكتروني مخصصة",
    "Custom email templates": "قوالب بريد إلكتروني مخصصة",
    "upgrade_page.copy.email_whitelabelling": "تخصيص العلامة التجارية للبريد الإلكتروني",
    "Email whitelabelling": "تخصيص العلامة التجارية للبريد الإلكتروني",
    "upgrade_page.copy.everything_in_growth": "كل ما تتضمنه Growth",
    "Everything in Growth": "كل ما تتضمنه Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "كل ما تتضمنه Growth مع أعلى الحدود.",
    "Everything in Growth, with the highest limits.": "كل ما تتضمنه Growth مع أعلى الحدود.",
    "upgrade_page.copy.everything_in_starter": "كل ما تتضمنه Starter",
    "Everything in Starter": "كل ما تتضمنه Starter",
    "upgrade_page.copy.expand_your_workspace": "وسّع مساحة عملك",
    "Expand your workspace": "وسّع مساحة عملك",
    "upgrade_page.copy.feature_access": "الوصول إلى الميزات",
    "Feature access": "الوصول إلى الميزات",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "للكتالوج المتنامي الذي يحتاج إلى خيارات منتجات أوضح.",
    "For a growing catalogue that needs clearer product choices.": "للكتالوج المتنامي الذي يحتاج إلى خيارات منتجات أوضح.",
    "upgrade_page.copy.for_established_businesses": "للأنشطة التجارية الراسخة",
    "For established businesses": "للأنشطة التجارية الراسخة",
    "upgrade_page.copy.for_growing_operations": "للعمليات المتنامية",
    "For growing operations": "للعمليات المتنامية",
    "upgrade_page.copy.for_growing_teams": "للفرق المتنامية",
    "For growing teams": "للفرق المتنامية",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "للفرق ذات حجم العمل الكبير التي تحتاج إلى مساحة للتوسع.",
    "For high-volume teams that need room to operate at scale.": "للفرق ذات حجم العمل الكبير التي تحتاج إلى مساحة للتوسع.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "للفرق التي تدير كتالوجًا أكبر وسير عمل أكثر.",
    "For teams managing a larger catalogue and more workflows.": "للفرق التي تدير كتالوجًا أكبر وسير عمل أكثر.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "للفرق المستعدة للعمل على أكثر من سجل في المرة الواحدة.",
    "For teams ready to work beyond one record at a time.": "للفرق المستعدة للعمل على أكثر من سجل في المرة الواحدة.",
    "upgrade_page.copy.full_audit_history": "سجل التدقيق الكامل",
    "Full audit history": "سجل التدقيق الكامل",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "تتيح خطتا Growth وScale مراجعة سجل التدقيق الكامل وتصديره لسير عمل الامتثال.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "تتيح خطتا Growth وScale مراجعة سجل التدقيق الكامل وتصديره لسير عمل الامتثال.",
    "upgrade_page.copy.higher_usage_limits": "حدود استخدام أعلى",
    "Higher usage limits": "حدود استخدام أعلى",
    "upgrade_page.copy.highest_usage_limits": "أعلى حدود للاستخدام",
    "Highest usage limits": "أعلى حدود للاستخدام",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "استورد السجلات وصدّرها دون أعمال يدوية متكررة.",
    "Import and export records without repetitive manual work.": "استورد السجلات وصدّرها دون أعمال يدوية متكررة.",
    "upgrade_page.copy.import_and_export_tools": "أدوات الاستيراد والتصدير",
    "Import and export tools": "أدوات الاستيراد والتصدير",
    "upgrade_page.copy.improve_important_customer_messages": "حسّن الرسائل المهمة المرسلة للعملاء",
    "Improve important customer messages": "حسّن الرسائل المهمة المرسلة للعملاء",
    "upgrade_page.copy.keep_a_longer_compliance_history": "احتفظ بسجل امتثال أطول",
    "Keep a longer compliance history": "احتفظ بسجل امتثال أطول",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "حافظ على رؤية كاملة للامتثال في العمليات ذات حجم العمل الكبير.",
    "Keep complete compliance visibility for high-volume operations.": "حافظ على رؤية كاملة للامتثال في العمليات ذات حجم العمل الكبير.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "نظّم المزيد من البيانات وسير العمل مع نمو الكتالوج.",
    "Keep more data and workflows organised as the catalogue grows.": "نظّم المزيد من البيانات وسير العمل مع نمو الكتالوج.",
    "upgrade_page.copy.keep_your_workspace_secure": "حافظ على أمان مساحة عملك",
    "Keep your workspace secure": "حافظ على أمان مساحة عملك",
    "upgrade_page.copy.large": "كبير",
    "Large": "كبير",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "دع العملاء يختارون الخيارات من عرض واحد.",
    "Let customers choose options from one listing.": "دع العملاء يختارون الخيارات من عرض واحد.",
    "upgrade_page.copy.listing_variants": "خيارات العرض",
    "Listing variants": "خيارات العرض",
    "upgrade_page.copy.make_every_customer_email_yours": "اجعل كل بريد إلكتروني للعملاء يعكس علامتك",
    "Make every customer email yours": "اجعل كل بريد إلكتروني للعملاء يعكس علامتك",
    "upgrade_page.copy.make_one_listing_work_harder": "حقق استفادة أكبر من عرض واحد",
    "Make one listing work harder": "حقق استفادة أكبر من عرض واحد",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "اجعل رسائل النظام متوافقة مع سير عملك ونبرتك.",
    "Make system emails match your workflow and tone.": "اجعل رسائل النظام متوافقة مع سير عملك ونبرتك.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "اجعل مشروعك متاحًا بلغات أكثر.",
    "Make your project available in more languages.": "اجعل مشروعك متاحًا بلغات أكثر.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "أدر تجربة اللغة الموجهة للعملاء عند التوسع إلى مناطق وجماهير جديدة.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "أدر تجربة اللغة الموجهة للعملاء عند التوسع إلى مناطق وجماهير جديدة.",
    "upgrade_page.copy.medium": "متوسط",
    "upgrade_page.copy.more_capacity": "سعة أكبر",
    "More capacity": "سعة أكبر",
    "upgrade_page.copy.more_storage": "مساحة تخزين أكبر",
    "More storage": "مساحة تخزين أكبر",
    "upgrade_page.copy.more_team_capacity": "قدرة أكبر لفريقك",
    "More team capacity": "قدرة أكبر لفريقك",
    "upgrade_page.copy.move_faster_with_your_catalogue": "أنجز أعمال الكتالوج بسرعة أكبر",
    "Move faster with your catalogue": "أنجز أعمال الكتالوج بسرعة أكبر",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "سرّع المهام الروتينية للكتالوجات الأكبر والفرق الأوسع.",
    "Move larger catalogues and teams through routine work faster.": "سرّع المهام الروتينية للكتالوجات الأكبر والفرق الأوسع.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "اعرض المقاسات والألوان أو خيارات أخرى دون تكرار العروض أو تقسيم إدارة المخزون.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "اعرض المقاسات والألوان أو خيارات أخرى دون تكرار العروض أو تقسيم إدارة المخزون.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "اعمل بأعلى الحدود المتاحة.",
    "Operate with the highest available limits.": "اعمل بأعلى الحدود المتاحة.",
    "upgrade_page.copy.per_module_permissions": "أذونات لكل وحدة",
    "Per-module permissions": "أذونات لكل وحدة",
    "upgrade_page.copy.priority_support": "دعم ذو أولوية",
    "Priority support": "دعم ذو أولوية",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "راجع أكثر من أحدث خمسة أحداث تدقيق.",
    "Review more than the latest five audit events.": "راجع أكثر من أحدث خمسة أحداث تدقيق.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "راجع سجل التدقيق الكامل مع نمو فريقك ونشاطك.",
    "Review the full audit history as your team and activity grow.": "راجع سجل التدقيق الكامل مع نمو فريقك ونشاطك.",
    "upgrade_page.copy.role_based_access_control": "التحكم في الوصول القائم على الأدوار",
    "Role-based access control": "التحكم في الوصول القائم على الأدوار",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "تتيح لك الأدوار منح كل عضو في الفريق صلاحيات الوصول التي يحتاجها فقط. متاح في Growth وما فوق.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "تتيح لك الأدوار منح كل عضو في الفريق صلاحيات الوصول التي يحتاجها فقط. متاح في Growth وما فوق.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "أنشئ سير عمل أقوى وأكثر اتساقًا للتواصل مع العملاء.",
    "Run a stronger, more polished customer communication workflow.": "أنشئ سير عمل أقوى وأكثر اتساقًا للتواصل مع العملاء.",
    "upgrade_page.copy.sell_across_markets": "بِع في أسواق متعددة",
    "Sell across markets": "بِع في أسواق متعددة",
    "upgrade_page.copy.sell_products_together": "بِع المنتجات معًا",
    "Sell products together": "بِع المنتجات معًا",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "أرسل رسائل البريد الإلكتروني بعلامة تجارية يعرفها عملاؤك.",
    "Send email from a brand your customers recognise.": "أرسل رسائل البريد الإلكتروني بعلامة تجارية يعرفها عملاؤك.",
    "upgrade_page.copy.shape_the_information_you_collect": "نظّم المعلومات التي تجمعها",
    "Shape the information you collect": "نظّم المعلومات التي تجمعها",
    "upgrade_page.copy.small": "صغير",
    "Small": "صغير",
    "upgrade_page.copy.speak_to_more_customers": "تواصل مع عملاء أكثر",
    "Speak to more customers": "تواصل مع عملاء أكثر",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "وحّد البيانات الغنية في العمليات ذات حجم العمل الكبير.",
    "Standardise richer data across a high-volume operation.": "وحّد البيانات الغنية في العمليات ذات حجم العمل الكبير.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "ابدأ بتقديم تجربة أكثر اتساقًا للعملاء.",
    "Start presenting a more consistent customer experience.": "ابدأ بتقديم تجربة أكثر اتساقًا للعملاء.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "قدّم تجربة عملاء متكاملة وجاهزة للمؤسسات.",
    "Support a complete enterprise-ready customer experience.": "قدّم تجربة عملاء متكاملة وجاهزة للمؤسسات.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "ادعم العملاء الذين يتسوقون بعملات مختلفة.",
    "Support customers who shop in different currencies.": "ادعم العملاء الذين يتسوقون بعملات مختلفة.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "ادعم سير العمل التشغيلي ذي الحجم الكبير على نطاق واسع.",
    "Support high-volume operational workflows at scale.": "ادعم سير العمل التشغيلي ذي الحجم الكبير على نطاق واسع.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "ادعم سير عمل وفرقًا أكبر.",
    "Support larger workflows and teams.": "ادعم سير عمل وفرقًا أكبر.",
    "upgrade_page.copy.t_shirt": "قميص",
    "T-shirt": "قميص",
    "upgrade_page.copy.t_shirt_large": "قميص — كبير",
    "T-shirt — Large": "قميص — كبير",
    "upgrade_page.copy.t_shirt_medium": "قميص — متوسط",
    "T-shirt — Medium": "قميص — متوسط",
    "upgrade_page.copy.t_shirt_small": "قميص — صغير",
    "T-shirt — Small": "قميص — صغير",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "خصّص الرسائل التي يتلقاها العملاء في اللحظات المهمة دون تغيير إعداد منصتك.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "خصّص الرسائل التي يتلقاها العملاء في اللحظات المهمة دون تغيير إعداد منصتك.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "افتح أدوات أكثر مع بدء نمو مساحة عملك.",
    "Unlock more tools as your workspace begins to grow.": "افتح أدوات أكثر مع بدء نمو مساحة عملك.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "افتح هذه الميزة عندما تكون مستعدًا.",
    "Unlock this feature when you are ready.": "افتح هذه الميزة عندما تكون مستعدًا.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "استخدم واجهات API بلا واجهة جاهزة لتجربة مخصصة بالكامل.",
    "Use headless APIs for a fully custom experience.": "استخدم واجهات API بلا واجهة جاهزة لتجربة مخصصة بالكامل.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "استخدم واجهة API عندما يحتاج سير عملك إلى مزيد من الإمكانات.",
    "Use the API when your workflow needs to go further.": "استخدم واجهة API عندما يحتاج سير عملك إلى مزيد من الإمكانات.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "استخدم هوية المرسل وعلامتك التجارية للحفاظ على اتساق اتصالات المنصة.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "استخدم هوية المرسل وعلامتك التجارية للحفاظ على اتساق اتصالات المنصة.",
    "upgrade_page.copy.with_variants": "مع الخيارات",
    "With variants": "مع الخيارات",
    "upgrade_page.copy.without_variants": "دون خيارات",
    "Without variants": "دون خيارات",
    "upgrade_page.copy.workflow_tools": "أدوات سير العمل",
    "Workflow tools": "أدوات سير العمل",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "سيظل عملك الحالي كما هو أثناء مقارنة الخطة التي تتضمن هذه الإمكانية.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "سيظل عملك الحالي كما هو أثناء مقارنة الخطة التي تتضمن هذه الإمكانية.",
    "upgrade_page.copy.a_paid_plan": "خطة مدفوعة",
    "a paid plan": "خطة مدفوعة",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "كل ما يحتاجه المتجر النامي: إزالة العلامة، وإضافة نطاق، وفتح أدوات أكثر.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "كل ما يحتاجه المتجر النامي: إزالة العلامة، وإضافة نطاق، وفتح أدوات أكثر.",
    "upgrade_page.copy.everything_unlocked": "كل الميزات متاحة",
    "Everything unlocked": "كل الميزات متاحة",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "مجموعة ذكاء اصطناعي كاملة وتسويق متقدم وكل الميزات للمتاجر الجادة في النمو.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "رسالة من فريق Tradly",
    "A note from the Tradly team": "رسالة من فريق Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "ساعدنا على مواصلة Tradly",
    "Help us keep Tradly going": "ساعدنا على مواصلة Tradly",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "ارتفعت تكاليفنا، ونحتاج إلى دعم مجتمعنا لمواصلة تطوير Tradly ودعمها. للمتابعة في مساحة عملك، يُرجى اختيار خطة. متجرك وبياناتك بأمان وفي انتظارك. شكرًا لكونك جزءًا من Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "ارتفعت تكاليفنا، ونحتاج إلى دعم مجتمعنا لمواصلة تطوير Tradly ودعمها. للمتابعة في مساحة عملك، يُرجى اختيار خطة. متجرك وبياناتك بأمان وفي انتظارك. شكرًا لكونك جزءًا من Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "منذ عام 2019، قدمنا Tradly بخطة مجانية تتضمن الكثير من الميزات حتى يتمكن الجميع من بدء مشروع. يسعدنا ذلك، لكن لم يعد بإمكاننا تحمّل تكلفته وحدنا. نخطط لإعادة الخطة المجانية عندما يصل العمل إلى مرحلة معينة، لنرد الجميل للمجتمع الذي أوصلنا إلى هنا.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "منذ عام 2019، قدمنا Tradly بخطة مجانية تتضمن الكثير من الميزات حتى يتمكن الجميع من بدء مشروع. يسعدنا ذلك، لكن لم يعد بإمكاننا تحمّل تكلفته وحدنا. نخطط لإعادة الخطة المجانية عندما يصل العمل إلى مرحلة معينة، لنرد الجميل للمجتمع الذي أوصلنا إلى هنا.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "اختر الخطة المناسبة لك اليوم. يمكنك تغييرها في أي وقت.",
    "Choose the plan that fits you today. You can change it any time.": "اختر الخطة المناسبة لك اليوم. يمكنك تغييرها في أي وقت.",
    "upgrade_page.back_to_workspace": "العودة إلى مساحة العمل",
    "Back to workspace": "العودة إلى مساحة العمل",
    "upgrade_page.grow_when_ready": "توسّع عندما يتطلب العمل ذلك",
    "Grow when the work calls for it": "توسّع عندما يتطلب العمل ذلك",
    "upgrade_page.reassurance": "ستظل بياناتك وعروضك وإعداداتك الحالية كما هي.",
    "Your existing data, listings, and setup stay exactly as they are.": "ستظل بياناتك وعروضك وإعداداتك الحالية كما هي.",
    "upgrade_page.choose_plan": "اختر خطة",
    "Choose a plan": "اختر خطة",
    "upgrade_page.feature_availability": "توفر الميزة",
    "Feature availability": "توفر الميزة",
    "upgrade_page.available_from": "متاحة بدءًا من",
    "Available from": "متاحة بدءًا من",
    "upgrade_page.and_above": "وما فوق",
    "and above": "وما فوق",
    "upgrade_page.choose_when_useful": "اختر خطة فقط عندما تكون هذه الإمكانية مفيدة لفريقك.",
    "Choose a plan only when this capability is useful to your team.": "اختر خطة فقط عندما تكون هذه الإمكانية مفيدة لفريقك.",
    "upgrade_page.practical_difference": "الفرق العملي",
    "The practical difference": "الفرق العملي",
    "upgrade_page.keep_work_simple": "حافظ على بساطة العمل مع نموك.",
    "Keep the work simpler as you grow.": "حافظ على بساطة العمل مع نموك.",
    "upgrade_page.plan_path": "مسار الخطط",
    "Plan path": "مسار الخطط",
    "upgrade_page.plan_path_title": "ابدأ بالخطة التي تدعم خطوتك التالية.",
    "Start with the plan that supports this next step.": "ابدأ بالخطة التي تدعم خطوتك التالية.",
    "upgrade_page.best_next_step": "أفضل خطوة تالية",
    "upgrade_page.includes_capability": "تتضمن هذه الإمكانية",
    "Includes this capability": "تتضمن هذه الإمكانية",
    "upgrade_page.not_included": "غير متضمن",
    "Not included": "غير متضمن",
    "upgrade_page.included": "✓ متضمن",
    "✓ Included": "✓ متضمن",
    "upgrade_page.ready_when_you_are": "جاهز عندما تكون مستعدًا.",
    "Ready when you are.": "جاهز عندما تكون مستعدًا.",
    "upgrade_page.billing_details": "راجع تفاصيل الخطط كاملة وتابع بأمان عبر فوترة Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "راجع تفاصيل الخطط كاملة وتابع بأمان عبر فوترة Tradly.",
    "upgrade_page.panel.close": "إغلاق لوحة الترقية",
    "Close upgrade panel": "إغلاق لوحة الترقية",
    "upgrade_page.panel.show_less": "عرض أقل",
    "Show less": "عرض أقل",
    "upgrade_page.panel.see_more": "عرض المزيد",
    "See more": "عرض المزيد",
    "upgrade_page.panel.choose_to_continue": "اختر خطة للمتابعة",
    "Choose a plan to continue": "اختر خطة للمتابعة",
    "upgrade_page.panel.more_ways_to_grow": "مزيد من خيارات النمو",
    "More ways to grow": "مزيد من خيارات النمو",
    "upgrade_page.panel.plan_includes_feature": "تتضمن كل خطة هذه الميزة وسعة إضافية لمرحلتك التالية.",
    "Each plan includes this feature plus additional capacity for your next stage.": "تتضمن كل خطة هذه الميزة وسعة إضافية لمرحلتك التالية.",
    "upgrade_page.panel.add_credits": "أضف رصيدًا أو منتجات",
    "Add credits or products": "أضف رصيدًا أو منتجات",
    "upgrade_page.panel.ala_carte_description": "تتم فوترة مساحة عملك حسب الاستخدام. أضف رصيدًا أو المنتجات التي تحتاجها.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "تتم فوترة مساحة عملك حسب الاستخدام. أضف رصيدًا أو المنتجات التي تحتاجها.",
    "upgrade_page.panel.open_ala_carte": "فتح الدفع حسب الاستخدام",
    "Open à la carte": "فتح الدفع حسب الاستخدام",
    "upgrade_page.panel.recommended": "موصى به",
    "Recommended": "موصى به",
    "upgrade_page.panel.per_month": "/ شهريًا",
    "upgrade_page.panel.please_wait": "يرجى الانتظار…",
    "upgrade_page.panel.unlock_plan": "افتح {plan}",
    "Unlock {plan}": "افتح {plan}",
    "upgrade_page.panel.choose_plan": "اختر {plan}",
    "Choose {plan}": "اختر {plan}",
    "upgrade_page.panel.compare_plans": "قارن تفاصيل جميع الخطط",
    "Compare all plan details": "قارن تفاصيل جميع الخطط",
    "workspace.usage.page_title": "نظرة عامة على الاستخدام",
    "Usage overview": "نظرة عامة على الاستخدام",
    "workspace.usage.page_description": "اطّلع على الاستخدام الحالي والحدود المطبقة على مساحة العمل هذه.",
    "workspace.usage.not_available": "غير متاح",
    "workspace.usage.limit_not_configured": "لم يتم إعداد الحد",
    "Limit not configured": "لم يتم إعداد الحد",
    "workspace.usage.limit_value": "الحد: {limit}",
    "Limit: {limit}": "الحد: {limit}",
    "listings.photos": "الصور",
    "Photos": "الصور",
    "listings.listen_episode": "استمع إلى هذه الحلقة",
    "Listen to this episode": "استمع إلى هذه الحلقة",
    "listings.other_listings": "عروض أخرى",
    "Other listings": "عروض أخرى",
    "listings.delete": "حذف",
    "listings.fulfilled_by_platform": "تم التنفيذ بواسطة المنصة",
    "listings.no_attributes_set": "لم يتم تعيين سمات",
    "No attributes set": "لم يتم تعيين سمات",
    "listings.campaign_raised": "تم جمع {amount}",
    "{amount} raised": "تم جمع {amount}",
    "listings.campaign_progress": "{percent}% من {goal}",
    "{percent}% of {goal}": "{percent}% من {goal}",
    "listings.seat": "مقعد",
    "seat": "مقعد",
    "listings.seats": "مقاعد",
    "seats": "مقاعد",
    "listings.per_slot": "لكل فترة",
    "per slot": "لكل فترة",
    "listings.total_value": "الإجمالي: {total}",
    "Total: {total}": "الإجمالي: {total}",
    "listings.orders": "الطلبات",
    "listings.total_orders": "إجمالي الطلبات",
    "Total orders": "إجمالي الطلبات",
    "listings.revenue": "الإيرادات",
    "listings.average_order": "متوسط الطلب",
    "listings.customers": "العملاء",
    "Customers": "العملاء",
    "listings.load_more": "تحميل المزيد",
    "Load more": "تحميل المزيد",
    "listings.filter": "تصفية",
    "listings.sort": "ترتيب",
    "Sort": "ترتيب",
    "listings.value_price": "السعر",
    "Value Price": "السعر",
    "listings.detail_label_title": "العنوان",
    "listings.detail_label_slug": "الرابط المختصر",
    "listings.detail_label_description": "الوصف",
    "listings.detail_label_categories": "الفئات",
    "listings.detail_label_list_price": "سعر القائمة",
    "listings.detail_label_offer": "العرض",
    "Offer": "العرض",
    "listings.detail_label_currency": "العملة",
    "listings.detail_label_listing_status": "حالة العرض",
    "listings.detail_label_active": "نشط",
    "listings.detail_label_sold": "مباع",
    "listings.detail_label_meta_title": "عنوان ميتا",
    "listings.detail_label_meta_description": "وصف ميتا",
    "listings.detail_label_goal": "الهدف",
    "Goal": "الهدف",
    "listings.detail_label_donors": "المتبرعون",
    "Donors": "المتبرعون",
    "listings.detail_label_start_date": "تاريخ البدء",
    "listings.detail_label_end_date": "تاريخ الانتهاء",
    "listings.detail_label_stock": "المخزون",
    "listings.detail_label_max_qty_order": "الحد الأقصى للكمية / طلب",
    "Max qty / order": "الحد الأقصى للكمية / طلب",
    "listings.detail_label_weight": "الوزن",
    "listings.detail_label_dimensions": "الأبعاد",
    "Dimensions": "الأبعاد",
    "listings.detail_label_listing_period": "فترة العرض",
    "Listing period": "فترة العرض",
    "listings.detail_label_max_tickets_booking": "الحد الأقصى للتذاكر / الحجز",
    "Max tickets / booking": "الحد الأقصى للتذاكر / الحجز",
    "listings.detail_label_rating": "التقييم",
    "listings.detail_label_reviews": "المراجعات",
    "listings.detail_label_likes": "الإعجابات",
    "Likes": "الإعجابات",
    "listings.detail_label_dislikes": "عدم الإعجاب",
    "Dislikes": "عدم الإعجاب",
    "listings.detail_label_barcode": "الرمز الشريطي",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "معلومات أساسية",
    "Basic Info": "معلومات أساسية",
    "listings.detail_section_pricing": "التسعير",
    "listings.detail_section_seo": "تحسين محركات البحث",
    "SEO": "تحسين محركات البحث",
    "listing_form.select_type_hint": "حدد نوع العرض أعلاه للمتابعة.",
    "Select a listing type above to continue.": "حدد نوع العرض أعلاه للمتابعة.",
    "listing_form.attributes": "السمات",
    "category.status_active_help": "الحالة (غير نشط / نشط)",
    "promotions.medium": "متوسط",
    "users.listings": "القوائم",
    "users.accounts": "الحسابات",
    "users.click_count_one": "{count} نقرة",
    "{count} click": "{count} نقرة",
    "users.click_count": "{count} نقرات",
    "{count} clicks": "{count} نقرات",
    "integrations.generic.provider_help": "أعد إعداد المزوّد المحدد باستخدام الحقول أدناه.",
    "Configure the selected provider using the fields below.": "أعد إعداد المزوّد المحدد باستخدام الحقول أدناه.",
    "attributes.editor_prefill_data_from": "تعبئة البيانات مسبقًا من",
    "Prefill Data From": "تعبئة البيانات مسبقًا من",
    "attributes.editor_select_attribute": "حدد سمة",
    "Select Attribute": "حدد سمة",
    "attributes.editor_select_attribute_group": "حدد مجموعة سمات",
    "Select Attribute Group": "حدد مجموعة سمات",
    "attributes.editor_attribute": "السمة",
    "Attribute": "السمة",
    "attributes.editor_attributes": "السمات",
    "attributes.editor_cart_attributes": "سمات السلة",
    "Cart Attributes": "سمات السلة",
    "listings.add_photo": "إضافة صورة",
    "accounts.analytics": "التحليلات",
    "listings.image_optional": "صور الإعلانات (اختياري)",
    "Listing Images (Optional)": "صور الإعلانات (اختياري)",
    "listings.currency": "العملة",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "نشط",
    "listing_form.digital_deleted_item_cannot_edit": "هذا العنصر محدد للحذف ولا يمكن تعديله",
    "This item is marked for deletion and cannot be edited": "هذا العنصر محدد للحذف ولا يمكن تعديله",
    "listing_form.digital_max_files": "يُسمح بحد أقصى 10 ملفات",
    "Maximum 10 files allowed": "يُسمح بحد أقصى 10 ملفات",
    "listing_form.digital_title_required": "يرجى إدخال عنوان",
    "listing_form.digital_version_required": "يرجى إدخال اسم الإصدار",
    "Please enter a version name": "يرجى إدخال اسم الإصدار",
    "listing_form.digital_contents": "المحتوى الرقمي",
    "Digital Contents": "المحتوى الرقمي",
    "listing_form.digital_add_content": "+ إضافة محتوى",
    "+ Add Content": "+ إضافة محتوى",
    "listing_form.no_description": "لا يوجد وصف",
    "No description": "لا يوجد وصف",
    "listing_form.digital_file_count": "{count} ملف",
    "{count} file(s)": "{count} ملف",
    "listing_form.digital_empty": "لا يوجد محتوى رقمي بعد",
    "No digital contents yet": "لا يوجد محتوى رقمي بعد",
    "listing_form.digital_empty_help": "انقر على \"{action}\" لإنشاء أول محتوى رقمي",
    "Click \"{action}\" to create your first digital content": "انقر على \"{action}\" لإنشاء أول محتوى رقمي",
    "listing_form.digital_marked_for_deletion": "محدد للحذف ({count})",
    "Marked for Deletion ({count})": "محدد للحذف ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ سيُحذف عند الإرسال",
    "✓ Will be deleted on submit": "✓ سيُحذف عند الإرسال",
    "listing_form.digital_edit_title": "تعديل المحتوى الرقمي",
    "Edit Digital Content": "تعديل المحتوى الرقمي",
    "listing_form.digital_add_title": "إضافة محتوى رقمي جديد",
    "Add New Digital Content": "إضافة محتوى رقمي جديد",
    "listing_form.digital_form_description": "أكمل التفاصيل أدناه من أجل {action} المحتوى الرقمي",
    "Fill in the details below to {action} digital content": "أكمل التفاصيل أدناه من أجل {action} المحتوى الرقمي",
    "listing_form.digital_title_placeholder": "أدخل عنوان المحتوى الرقمي",
    "Enter digital content title": "أدخل عنوان المحتوى الرقمي",
    "listing_form.description_optional_placeholder": "أدخل الوصف (اختياري)",
    "Enter description (optional)": "أدخل الوصف (اختياري)",
    "listing_form.version": "الإصدار",
    "Version": "الإصدار",
    "listing_form.files": "الملفات",
    "Files": "الملفات",
    "listing_form.max_files": "(الحد الأقصى {count})",
    "(Max {count})": "(الحد الأقصى {count})",
    "listing_form.click_to_upload_files": "انقر لتحميل الملفات",
    "Click to upload files": "انقر لتحميل الملفات",
    "listing_form.files_uploaded_count": "تم تحميل {count}/10 ملفات",
    "{count}/10 files uploaded": "تم تحميل {count}/10 ملفات",
    "listing_form.unknown_size": "حجم غير معروف",
    "Unknown size": "حجم غير معروف",
    "listing_form.no_accounts_available": "لا توجد حسابات متاحة",
    "No accounts available": "لا توجد حسابات متاحة",
    "listing_form.select_account": "اختر حسابًا",
    "Select an account": "اختر حسابًا",
    "listing_form.searching": "جارٍ البحث...",
    "Searching...": "جارٍ البحث...",
    "listing_form.location_enter_address": "يرجى إدخال عنوان للبحث عنه",
    "Please enter an address to search": "يرجى إدخال عنوان للبحث عنه",
    "listing_form.location_no_addresses_search": "لم يتم العثور على عناوين. يرجى تجربة بحث آخر.",
    "No addresses found. Please try a different search.": "لم يتم العثور على عناوين. يرجى تجربة بحث آخر.",
    "listing_form.location_search_failed": "تعذر البحث عن العناوين. يرجى المحاولة مرة أخرى.",
    "Failed to search addresses. Please try again.": "تعذر البحث عن العناوين. يرجى المحاولة مرة أخرى.",
    "listing_form.location_place_details_failed": "تعذر الحصول على تفاصيل الموقع. يرجى المحاولة مرة أخرى.",
    "Failed to get place details. Please try again.": "تعذر الحصول على تفاصيل الموقع. يرجى المحاولة مرة أخرى.",
    "listing_form.location_access_denied": "تم رفض الوصول إلى الموقع. يرجى تفعيل إذن الموقع.",
    "Location access denied. Please enable location permissions.": "تم رفض الوصول إلى الموقع. يرجى تفعيل إذن الموقع.",
    "listing_form.location_unavailable": "تعذر تحديد الموقع. يرجى المحاولة مرة أخرى.",
    "Unable to determine location. Please try again.": "تعذر تحديد الموقع. يرجى المحاولة مرة أخرى.",
    "listing_form.location_timeout": "انتهت مهلة طلب الموقع. يرجى المحاولة مرة أخرى.",
    "Location request timed out. Please try again.": "انتهت مهلة طلب الموقع. يرجى المحاولة مرة أخرى.",
    "listing_form.location_current_failed": "تعذر الحصول على الموقع الحالي. يرجى المحاولة مرة أخرى.",
    "Failed to get current location. Please try again.": "تعذر الحصول على الموقع الحالي. يرجى المحاولة مرة أخرى.",
    "listing_form.location": "الموقع",
    "listing_form.location_search_placeholder": "ابحث عن موقع...",
    "Search for a location...": "ابحث عن موقع...",
    "listing_form.location_searching": "جارٍ البحث عن العناوين...",
    "Searching addresses...": "جارٍ البحث عن العناوين...",
    "listing_form.location_no_addresses": "لم يتم العثور على عناوين",
    "No addresses found": "لم يتم العثور على عناوين",
    "listing_form.location_try_different_search": "جرّب عبارة بحث مختلفة",
    "Try a different search term": "جرّب عبارة بحث مختلفة",
    "listing_form.location_getting": "جارٍ تحديد الموقع...",
    "Getting location...": "جارٍ تحديد الموقع...",
    "listing_form.location_use_current": "استخدم الموقع الحالي",
    "Use Current Location": "استخدم الموقع الحالي",
    "listing_form.location_selected": "الموقع المحدد",
    "Selected Location": "الموقع المحدد",
    "listing_form.latitude": "خط العرض:",
    "Latitude:": "خط العرض:",
    "listing_form.longitude": "خط الطول:",
    "Longitude:": "خط الطول:",
    "listing_form.location_helper": "ابحث عن عنوان أو استخدم موقعك الحالي",
    "Search for an address or use your current location": "ابحث عن عنوان أو استخدم موقعك الحالي",
    "common.change": "تغيير",
    "listing_form.variant_id_tooltip": "معرّف النوع: {typeId}، معرّف القيمة: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "معرّف النوع: {typeId}، معرّف القيمة: {valueId}",
    "listing_form.variants_marked_for_deletion": "محدد للحذف ({count} عنصر):",
    "Marked for Deletion ({count} items):": "محدد للحذف ({count} عنصر):",
    "listing_form.add_new_variant": "إضافة متغير جديد",
    "Add New Variant": "إضافة متغير جديد",
    "listing_form.add_variant_description": "أكمل التفاصيل أدناه لإنشاء متغير",
    "Fill in the details below to create a new variant": "أكمل التفاصيل أدناه لإنشاء متغير",
    "listing_form.google_search_preview": "معاينة بحث Google",
    "Google Search Preview": "معاينة بحث Google",
    "listing_form.meta_title_preview": "سيظهر عنوان الميتا هنا",
    "Your Meta Title Here": "سيظهر عنوان الميتا هنا",
    "listing_form.meta_description_preview": "سيظهر وصف الميتا هنا لمساعدة المستخدمين على فهم محتوى صفحتك في نتائج البحث.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "سيظهر وصف الميتا هنا لمساعدة المستخدمين على فهم محتوى صفحتك في نتائج البحث.",
    "listing_form.variant_name_placeholder": "أدخل الاسم",
    "listing_form.list_price_placeholder": "أدخل سعر القائمة",
    "listing_form.offer_percent_placeholder": "أدخل نسبة العرض",
    "Enter Offer Percent": "أدخل نسبة العرض",
    "attributes.select_all": "تحديد الكل",
    "attributes.unselect_all": "إلغاء تحديد الكل",
    "Unselect All": "إلغاء تحديد الكل",
    "attributes.select_category": "اختر فئة",
    "attributes.create_category_configuration_first": "أنشئ الفئات أولاً في إعدادات {type}",
    "Create categories in {type} configuration first": "أنشئ الفئات أولاً في إعدادات {type}",
    "attributes.select_single_attribute_values": "اختر قيم السمة المفردة",
    "attributes.select_multiple_attribute_values": "اختر قيم السمات المتعددة",
    "attributes.enter_value": "أدخل قيمة",
    "attributes.enter_multiple_tags": "أدخل عدة وسوم",
    "Enter Multiple Tags": "أدخل عدة وسوم",
    "attributes.upload_file": "تحميل ملف",
    "collections.add_condition": "+ إضافة شرط آخر",
    "+ Add another condition": "+ إضافة شرط آخر",
    "collections.add_photo": "إضافة صورة",
    "collections.status": "الحالة (غير نشط / نشط)",
    "collections.start_date_placeholder": "اختر تاريخ البدء",
    "Select start date": "اختر تاريخ البدء",
    "collections.end_date_placeholder": "اختر تاريخ الانتهاء",
    "Select end date": "اختر تاريخ الانتهاء",
    "navigation.editor": "المحرر",
    "Editor": "المحرر",
    "navigation.web_analytics": "تحليلات الويب",
    "Web Analytics": "تحليلات الويب",
    "navigation.ai_studio": "استوديو الذكاء الاصطناعي",
    "AI Studio": "استوديو الذكاء الاصطناعي",
    "navigation.docs": "المستندات",
    "navigation.logout": "تسجيل الخروج",
    "Logout": "تسجيل الخروج",
    "navigation.tenant_name_placeholder": "(اسم المستأجر)",
    "(Tenant name)": "(اسم المستأجر)",
    "navigation.username_placeholder": "(اسم المستخدم)",
    "(Username)": "(اسم المستخدم)",
    "navigation.invite_description": "أرسل روابط الدعوة إلى أعضاء الفريق",
    "Send invitation links to team members": "أرسل روابط الدعوة إلى أعضاء الفريق",
    "navigation.invite": "دعوة",
    "Invite": "دعوة",
    "navigation.test_mode": "وضع الاختبار",
    "Test Mode": "وضع الاختبار",
    "navigation.upgrade": "ترقية",
    "navigation.open_account_menu": "فتح قائمة الحساب",
    "Open account menu": "فتح قائمة الحساب",
    "navigation.invite_name_required": "يرجى إدخال الاسم",
    "Please fill in the name": "يرجى إدخال الاسم",
    "navigation.invite_email_required": "يرجى إدخال البريد الإلكتروني",
    "Please fill in the email": "يرجى إدخال البريد الإلكتروني",
    "navigation.open_url_failed": "تعذّر فتح هذا الرابط: {url}",
    "Don't know how to open this URL: {url}": "تعذّر فتح هذا الرابط: {url}",
    "navigation.no_code_editor": "محرر بدون برمجة",
    "No-code editor": "محرر بدون برمجة",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "نظام إدارة المحتوى",
    "CMS": "نظام إدارة المحتوى",
    "navigation.marketing_automation": "أتمتة التسويق",
    "Marketing automation": "أتمتة التسويق",
    "navigation.analytics_recommendation": "التحليلات والتوصيات",
    "Analytics & Recommendation": "التحليلات والتوصيات",
    "navigation.ai_studio_iryxo": "استوديو الذكاء الاصطناعي (Iryxo)",
    "AI Studio (Iryxo)": "استوديو الذكاء الاصطناعي (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "المشروع الحالي",
    "Current project": "المشروع الحالي",
    "navigation.current_user": "المستخدم الحالي",
    "Current user": "المستخدم الحالي",
    "navigation.switch_to_light_mode": "التبديل إلى الوضع الفاتح",
    "Switch to light mode": "التبديل إلى الوضع الفاتح",
    "navigation.switch_to_dark_mode": "التبديل إلى الوضع الداكن",
    "Switch to dark mode": "التبديل إلى الوضع الداكن",
    "navigation.download_android_app": "تنزيل تطبيق Android",
    "Download Android app": "تنزيل تطبيق Android",
    "navigation.download_ios_app": "تنزيل تطبيق iOS",
    "Download iOS app": "تنزيل تطبيق iOS",
    "navigation.subscribe_youtube": "الاشتراك على YouTube",
    "Subscribe on YouTube": "الاشتراك على YouTube",
    "navigation.open_app_switcher": "فتح مبدّل التطبيقات",
    "Open app switcher": "فتح مبدّل التطبيقات",
    "navigation.open_android_app": "فتح تطبيق Android",
    "Open Android app": "فتح تطبيق Android",
    "navigation.open_ios_app": "فتح تطبيق iOS",
    "Open iOS app": "فتح تطبيق iOS",
    "navigation.open_ai_support": "فتح دعم Tradly على ChatGPT",
    "Open Tradly ChatGPT support": "فتح دعم Tradly على ChatGPT",
    "navigation.open_youtube_channel": "فتح قناة Tradly على YouTube",
    "Open Tradly YouTube channel": "فتح قناة Tradly على YouTube",
    "navigation.demo": "عرض توضيحي",
    "Demo": "عرض توضيحي",
    "listings.smart_upload.listing_id_optional": "معرّف الإعلان (اختياري — لتحديث إعلان موجود)",
    "Listing ID (optional — update existing)": "معرّف الإعلان (اختياري — لتحديث إعلان موجود)",
    "listings.smart_upload.category_id": "معرّف الفئة",
    "listings.smart_upload.list_price": "سعر القائمة",
    "listings.smart_upload.stock": "المخزون",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "الرمز الشريطي",
    "listings.smart_upload.account_id": "معرّف الحساب",
    "listings.smart_upload.slug": "المعرّف المختصر",
    "listings.smart_upload.text": "نص",
    "listings.smart_upload.long_text": "نص طويل",
    "listings.smart_upload.number": "رقم",
    "listings.smart_upload.single_select": "اختيار واحد",
    "listings.smart_upload.multi_select": "اختيار متعدد",
    "listings.smart_upload.attribute_name_required": "أدخل اسم سمة لـ \"{header}\".",
    "listings.smart_upload.attribute_create_failed": "لم يُرجع Tradly السمة الجديدة \"{name}\".",
    "Tradly did not return the new “{name}” attribute.": "لم يُرجع Tradly السمة الجديدة \"{name}\".",
    "listings.smart_upload.attribute_option_create_failed": "تعذر إنشاء الخيار \"{value}\" للسمة {name}.",
    "Could not create the “{value}” option for {name}.": "تعذر إنشاء الخيار \"{value}\" للسمة {name}.",
    "listings.smart_upload.attribute_no_longer_available": "لم تعد السمة المرتبطة بـ \"{header}\" متاحة.",
    "listings.smart_upload.csv_needs_header_and_listing": "يجب أن يحتوي ملف CSV على صف عناوين وإعلان واحد على الأقل.",
    "The CSV must contain a header row and at least one listing.": "يجب أن يحتوي ملف CSV على صف عناوين وإعلان واحد على الأقل.",
    "listings.smart_upload.unique_headers_required": "يجب أن يكون لكل عمود إعلان عنوان فريد وغير فارغ.",
    "Every listing column needs a unique, non-empty header.": "يجب أن يكون لكل عمود إعلان عنوان فريد وغير فارغ.",
    "listings.smart_upload.csv_read_failed": "تعذر قراءة ملف CSV هذا.",
    "listings.smart_upload.map_required_fields": "اربط الأعمدة المطلوبة قبل المتابعة: {fields}",
    "Map these required columns before continuing: {fields}": "اربط الأعمدة المطلوبة قبل المتابعة: {fields}",
    "listings.smart_upload.row_missing_required_value": "تفتقد القيمة المطلوبة في الصف {row}.",
    "Row {row} is missing a required value.": "تفتقد القيمة المطلوبة في الصف {row}.",
    "listings.smart_upload.invalid_category_id_row": "يحتاج الصف {row} إلى معرّف فئة رقمي صالح، أو اختر \"اربط معرّف الفئة يدويًا\".",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "يحتاج الصف {row} إلى معرّف فئة رقمي صالح، أو اختر \"اربط معرّف الفئة يدويًا\".",
    "listings.smart_upload.invalid_listing_id_row": "يحتاج الصف {row} إلى معرّف إعلان رقمي صالح، أو اترك المعرّف فارغًا لإنشاء إعلان جديد.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "يحتاج الصف {row} إلى معرّف إعلان رقمي صالح، أو اترك المعرّف فارغًا لإنشاء إعلان جديد.",
    "listings.smart_upload.progress.checking_duplicates": "جارٍ التحقق من الإعلانات الموجودة",
    "Checking for existing listings": "جارٍ التحقق من الإعلانات الموجودة",
    "listings.smart_upload.duplicate_same_value_row": "تظهر قيمة {field} نفسها في الصف {row} من هذا الملف.",
    "Same {field} appears in row {row} of this file.": "تظهر قيمة {field} نفسها في الصف {row} من هذا الملف.",
    "listings.smart_upload.duplicate_same_value_multiple": "تظهر قيمة {field} نفسها أكثر من مرة في هذا الملف.",
    "Same {field} appears more than once in this file.": "تظهر قيمة {field} نفسها أكثر من مرة في هذا الملف.",
    "listings.smart_upload.duplicate_existing_listing": "يطابق الإعلان الموجود رقم {id} حسب {field}.",
    "Matches existing listing #{id} by {field}.": "يطابق الإعلان الموجود رقم {id} حسب {field}.",
    "listings.smart_upload.explicit_listing_update": "سيتم تحديث الإعلان المحدد بالمعرّف {id}.",
    "Explicit listing ID #{id} will be updated.": "سيتم تحديث الإعلان المحدد بالمعرّف {id}.",
    "listings.smart_upload.progress.duplicates_complete": "اكتمل التحقق من التكرار",
    "Duplicate check complete": "اكتمل التحقق من التكرار",
    "listings.smart_upload.duplicate_check_failed": "تعذر التحقق من الإعلانات الموجودة.",
    "Could not check existing listings.": "تعذر التحقق من الإعلانات الموجودة.",
    "listings.smart_upload.progress.duplicates_stopped": "توقف التحقق من التكرار",
    "Duplicate check stopped": "توقف التحقق من التكرار",
    "listings.smart_upload.prepare_file_failed": "تعذر تجهيز ملف الاستيراد.",
    "listings.smart_upload.progress.uploading_file": "جارٍ تحميل ملف الاستيراد",
    "listings.smart_upload.upload_file_failed": "تعذر تحميل ملف الاستيراد.",
    "listings.smart_upload.all_rows_duplicates": "تم تحديد جميع الصفوف على أنها مكررة. اختر \"استيراد على أي حال\" لإرسالها إلى Tradly، أو ابدأ من جديد.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "تم تحديد جميع الصفوف على أنها مكررة. اختر \"استيراد على أي حال\" لإرسالها إلى Tradly، أو ابدأ من جديد.",
    "listings.smart_upload.progress.preparing_attributes": "جارٍ إعداد السمات",
    "listings.smart_upload.attribute_mapped_once": "يمكن ربط كل سمة إعلان مرة واحدة فقط. راجع تعيينات الأعمدة قبل الاستيراد.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "يمكن ربط كل سمة إعلان مرة واحدة فقط. راجع تعيينات الأعمدة قبل الاستيراد.",
    "listings.smart_upload.progress.preparing_file": "جارٍ إعداد ملف الاستيراد",
    "listings.smart_upload.progress.tradly_importing": "يقوم Tradly باستيراد الإعلانات",
    "Tradly is importing listings": "يقوم Tradly باستيراد الإعلانات",
    "listings.smart_upload.progress.import_complete": "اكتمل الاستيراد",
    "listings.smart_upload.progress.import_stopped": "توقف الاستيراد",
    "listings.smart_upload.progress.preparing_import": "جارٍ إعداد الاستيراد…",
    "Preparing import…": "جارٍ إعداد الاستيراد…",
    "listings.smart_upload.progress.rows_prepared": "تم إعداد {current} من أصل {total} صفًا",
    "{current} of {total} rows prepared": "تم إعداد {current} من أصل {total} صفًا",
    "listings.smart_upload.progress.remote_processing": "يعالج Tradly ملف CSV الذي تم تحميله. قد يستغرق ذلك بعض الوقت.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "يعالج Tradly ملف CSV الذي تم تحميله. قد يستغرق ذلك بعض الوقت.",
    "listings.smart_upload.progress.partial_import": "استورد Tradly عدد {imported} من أصل {total} صفًا{ending} راجع النتيجة قبل إعادة المحاولة؛ فقد يؤدي تكرار العملية كاملة إلى تكرار الصفوف الناجحة.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "استورد Tradly عدد {imported} من أصل {total} صفًا{ending} راجع النتيجة قبل إعادة المحاولة؛ فقد يؤدي تكرار العملية كاملة إلى تكرار الصفوف الناجحة.",
    "listings.smart_upload.title": "الاستيراد الذكي",
    "Smart Upload": "الاستيراد الذكي",
    "listings.smart_upload.beta": "(تجريبي)",
    "listings.smart_upload.start_over": "البدء من جديد",
    "listings.smart_upload.description": "حمّل الإعلانات واربط الأعمدة بالحقول الموجودة أو أنشئ سمات جديدة قبل الاستيراد.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "حمّل الإعلانات واربط الأعمدة بالحقول الموجودة أو أنشئ سمات جديدة قبل الاستيراد.",
    "listings.smart_upload.step_upload": "تحميل",
    "listings.smart_upload.step_match": "مطابقة الأعمدة",
    "listings.smart_upload.step_preview": "معاينة",
    "listings.smart_upload.step_import": "استيراد",
    "listings.smart_upload.choose_csv": "اختر ملف CSV",
    "listings.smart_upload.required_columns_help": "الأعمدة المطلوبة هي title وcategory_id. يمكن تحويل الأعمدة الأخرى إلى سمات للإعلان.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "الأعمدة المطلوبة هي title وcategory_id. يمكن تحويل الأعمدة الأخرى إلى سمات للإعلان.",
    "listings.smart_upload.select_csv_file": "اختر ملف CSV",
    "listings.smart_upload.match_columns": "مطابقة أعمدة الإعلان",
    "Match listing columns": "مطابقة أعمدة الإعلان",
    "listings.smart_upload.core_fields_help": "تُرسل الحقول الأساسية إلى واجهة الإعلانات. يمكن حفظ الأعمدة الإضافية كسمات للإعلان.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "تُرسل الحقول الأساسية إلى واجهة الإعلانات. يمكن حفظ الأعمدة الإضافية كسمات للإعلان.",
    "listings.smart_upload.do_not_import": "عدم الاستيراد",
    "listings.smart_upload.map_category_manually": "اربط معرّف الفئة يدويًا",
    "Map Category ID manually": "اربط معرّف الفئة يدويًا",
    "listings.smart_upload.category_assignment_help": "اختر الفئة التي تريد تعيينها لكل إعلان مستورد.",
    "Choose the category to assign to every imported listing.": "اختر الفئة التي تريد تعيينها لكل إعلان مستورد.",
    "listings.smart_upload.select_category": "اختر فئة",
    "listings.smart_upload.no_categories": "لم يتم العثور على فئات للإعلانات. أنشئ فئة أولاً ثم افتح الاستيراد الذكي مجددًا.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "لم يتم العثور على فئات للإعلانات. أنشئ فئة أولاً ثم افتح الاستيراد الذكي مجددًا.",
    "listings.smart_upload.additional_attributes": "سمات إضافية للإعلان",
    "Additional listing attributes": "سمات إضافية للإعلان",
    "listings.smart_upload.ignore_column": "تجاهل هذا العمود",
    "listings.smart_upload.create_attribute": "＋ إنشاء سمة إعلان جديدة",
    "＋ Create a new listing attribute": "＋ إنشاء سمة إعلان جديدة",
    "listings.smart_upload.attribute_name": "اسم السمة",
    "listings.smart_upload.review_import": "مراجعة الاستيراد",
    "listings.smart_upload.rows_scanned_help": "تم فحص {count} إعلانًا قبل التحميل. يتم التحقق من التكرار باستخدام SKU والرمز الشريطي والمعرّف المختصر والقيم المتكررة في CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "تم فحص {count} إعلانًا قبل التحميل. يتم التحقق من التكرار باستخدام SKU والرمز الشريطي والمعرّف المختصر والقيم المتكررة في CSV.",
    "listings.smart_upload.duplicates_found": "تم العثور على عناصر مكررة محتملة",
    "Potential duplicates found": "تم العثور على عناصر مكررة محتملة",
    "listings.smart_upload.duplicate_rows_skipped": "سيتم تخطي {count} صفًا افتراضيًا.",
    "{count} row(s) will be skipped by default.": "سيتم تخطي {count} صفًا افتراضيًا.",
    "listings.smart_upload.row_label": "صف",
    "Row": "صف",
    "listings.smart_upload.explicit_ids_are_updates": "تُعامل الصفوف التي تحتوي على معرّف إعلان صريح على أنها تحديثات.",
    "Rows with an explicit listing ID are treated as updates.": "تُعامل الصفوف التي تحتوي على معرّف إعلان صريح على أنها تحديثات.",
    "listings.smart_upload.duplicate_action": "إجراء التكرار",
    "Duplicate action": "إجراء التكرار",
    "listings.smart_upload.skip_duplicates": "تخطي العناصر المكررة المحتملة (موصى به)",
    "Skip potential duplicates (recommended)": "تخطي العناصر المكررة المحتملة (موصى به)",
    "listings.smart_upload.import_all_anyway": "استيراد جميع الصفوف على أي حال",
    "Import all rows anyway": "استيراد جميع الصفوف على أي حال",
    "listings.smart_upload.untitled_listing": "إعلان بلا عنوان",
    "Untitled listing": "إعلان بلا عنوان",
    "listings.smart_upload.category_label": "الفئة:",
    "Category:": "الفئة:",
    "listings.smart_upload.complete": "اكتمل الاستيراد الذكي",
    "listings.smart_upload.imported_count": "تم استيراد {imported} من أصل {total} إعلانًا.",
    "{imported} of {total} listings imported.": "تم استيراد {imported} من أصل {total} إعلانًا.",
    "listings.smart_upload.selected_file": "المحدد: {name}",
    "listings.smart_upload.checking": "جارٍ التحقق…",
    "listings.smart_upload.check_duplicates": "التحقق من التكرار",
    "Check duplicates": "التحقق من التكرار",
    "listings.smart_upload.importing": "جارٍ الاستيراد…",
    "listings.smart_upload.import_listings": "استيراد الإعلانات",
    "listings.smart_upload.failed": "فشل الاستيراد الذكي.",
    "Smart Upload failed.": "فشل الاستيراد الذكي.",
    "listings.smart_upload.id_label": "المعرّف",
    "listings.status_toggle_hint": "الحالة (غير نشط / نشط)",
    "listings.upload_media": "تحميل الوسائط",
    "listing_form.stock_placeholder": "أدخل المخزون",
    "orders.create_order.order_items_alt": "عناصر الطلب",
    "orders.create_order.by": "بواسطة",
    "by": "بواسطة",
    "orders.create_order.decrease_quantity": "تقليل الكمية",
    "Decrease quantity": "تقليل الكمية",
    "orders.create_order.increase_quantity": "زيادة الكمية",
    "Increase quantity": "زيادة الكمية",
    "orders.create_order.remove_item": "إزالة العنصر",
    "Remove item": "إزالة العنصر",
    "orders.create_order.rental_period_label": "مدة الإيجار:",
    "Rental period:": "مدة الإيجار:",
    "attributes.enter_text": "أدخل نصًا",
    "attributes.select_date": "اختر تاريخًا",
    "attributes.enter_number": "أدخل رقمًا",
    "attributes.select_color": "اختر لونًا",
    "attributes.upload_json": "تحميل JSON",
    "Upload JSON": "تحميل JSON",
    "attributes.select_location": "اختر موقعًا",
    "attributes.add_listing_preview": "إضافة إعلان",
    "attributes.add_account_preview": "إضافة حساب",
    "attributes.enter_price": "أدخل السعر",
    "attributes.preview": "معاينة",
    "attributes.enter_title": "أدخل العنوان",
    "attributes.enter_description": "أدخل الوصف",
    "attributes.category": "الفئة",
    "attributes.attribute_name": "اسم السمة",
    "attributes.enter_attribute_name": "أدخل اسم السمة",
    "attributes.select_type": "اختر النوع",
    "attributes.icon": "أيقونة",
    "attributes.tooltip": "تلميح",
    "Tooltip": "تلميح",
    "attributes.enter_tooltip": "أدخل تلميح السمة",
    "Enter attribute tooltip": "أدخل تلميح السمة",
    "listings.detail.images": "الصور",
    "listings.detail.posted_by": "نُشر بواسطة",
    "Posted by": "نُشر بواسطة",
    "listings.detail.fulfilled_by_platform": "تنفيذ المنصة",
    "listings.detail.preview": "معاينة",
    "listings.detail.view_listing": "عرض الإعلان",
    "View Listing": "عرض الإعلان",
    "listings.detail.variants": "المتغيرات",
    "listings.detail.no_attribute_values": "لا توجد قيم سمات لـ {name}",
    "listings.detail.attributes": "السمات",
    "listings.detail.starts_from": "يبدأ من:",
    "Starts From:": "يبدأ من:",
    "listings.detail.schedule": "الجدولة",
    "listings.detail.detail": "التفاصيل",
    "web_config.download": "تنزيل",
    "web_config.cancel": "إلغاء",
    "web_config.choose_file": "اختر ملفًا",
    "web_config.title": "إعدادات الموقع الإلكتروني",
    "Web Configs": "إعدادات الموقع الإلكتروني",
    "web_config.favicon": "أيقونة الموقع",
    "Favicon": "أيقونة الموقع",
    "web_config.logo": "الشعار",
    "web_config.logo_width": "عرض الشعار",
    "Logo Width": "عرض الشعار",
    "web_config.width": "العرض",
    "web_config.logo_height": "ارتفاع الشعار",
    "Logo Height": "ارتفاع الشعار",
    "web_config.height": "الارتفاع",
    "web_config.social_share_image": "الصورة المميزة للموقع للمشاركة الاجتماعية - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "الصورة المميزة للموقع للمشاركة الاجتماعية - Open Graph",
    "web_config.business_name": "اسم النشاط التجاري",
    "web_config.enter_web_name": "أدخل اسم الموقع الإلكتروني",
    "Enter web name": "أدخل اسم الموقع الإلكتروني",
    "web_config.title_font": "خط العنوان",
    "Title Font": "خط العنوان",
    "web_config.select_title_font": "اختر خط العنوان",
    "Select title font": "اختر خط العنوان",
    "web_config.body_font": "خط النص",
    "Body Font": "خط النص",
    "web_config.select_body_font": "اختر خط النص",
    "Select body font": "اختر خط النص",
    "web_config.primary_font": "الخط الأساسي",
    "Primary Font": "الخط الأساسي",
    "web_config.select_primary_font": "اختر الخط الأساسي",
    "Select primary font": "اختر الخط الأساسي",
    "web_config.uploaded_successfully": "تم الرفع بنجاح",
    "web_config.ios_download_icon": "أيقونة تنزيل تطبيق iOS",
    "iOS app download icon": "أيقونة تنزيل تطبيق iOS",
    "web_config.ios_download_link": "رابط تنزيل تطبيق iOS",
    "iOS app download link": "رابط تنزيل تطبيق iOS",
    "web_config.enter_ios_download_link": "أدخل رابط تنزيل تطبيق iOS",
    "Enter iOS app download link": "أدخل رابط تنزيل تطبيق iOS",
    "web_config.android_download_icon": "أيقونة تنزيل تطبيق Android",
    "Android app download icon": "أيقونة تنزيل تطبيق Android",
    "web_config.android_download_link": "رابط تنزيل تطبيق Android",
    "Android app download link": "رابط تنزيل تطبيق Android",
    "web_config.enter_android_download_link": "أدخل رابط تنزيل تطبيق Android",
    "Enter android app download link": "أدخل رابط تنزيل تطبيق Android",
    "coupons.preview.customer_checkout": "الدفع للعميل",
    "CUSTOMER CHECKOUT": "الدفع للعميل",
    "coupons.preview.title": "القسائم قيد الاستخدام",
    "Coupons in action": "القسائم قيد الاستخدام",
    "coupons.preview.featured_product": "منتجك المميز",
    "Your featured product": "منتجك المميز",
    "coupons.preview.product_meta": "عنصر واحد · توصيل عادي",
    "1 item · Standard delivery": "عنصر واحد · توصيل عادي",
    "coupons.preview.coupon_applied": "تم تطبيق القسيمة",
    "Coupon applied": "تم تطبيق القسيمة",
    "coupons.preview.remove": "إزالة",
    "coupons.preview.discount_applied": "تم تطبيق الخصم على الطلب",
    "Discount applied to the order": "تم تطبيق الخصم على الطلب",
    "coupons.preview.subtotal": "المجموع الفرعي",
    "coupons.preview.coupon_label": "قسيمة · WELCOME10",
    "Coupon · WELCOME10": "قسيمة · WELCOME10",
    "coupons.preview.grand_total": "الإجمالي الكلي",
    "Grand total": "الإجمالي الكلي",
    "coupons.preview.checkout": "إتمام الشراء",
    "CHECKOUT": "إتمام الشراء",
    "payments.stripe_get_keys": "الحصول على مفاتيح Stripe",
    "Get Stripe keys": "الحصول على مفاتيح Stripe",
    "payments.stripe_syncing": "جارٍ المزامنة مع Stripe…",
    "Syncing with Stripe...": "جارٍ المزامنة مع Stripe…",
    "payments.stripe_verifying_key": "جارٍ التحقق من المفتاح السري",
    "Verifying secret key": "جارٍ التحقق من المفتاح السري",
    "payments.stripe_creating_webhook": "جارٍ إنشاء خطاف الويب للدفع",
    "Creating payment webhook": "جارٍ إنشاء خطاف الويب للدفع",
    "payments.stripe_account_summary": "{country} · وضع {mode} · {id}",
    "{country} · {mode} mode · {id}": "{country} · وضع {mode} · {id}",
    "payments.stripe_webhooks_configured": "✓ تم إعداد خطافات الويب وملء الأسرار أدناه تلقائيًا. احفظ النموذج للاحتفاظ بها.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ تم إعداد خطافات الويب وملء الأسرار أدناه تلقائيًا. احفظ النموذج للاحتفاظ بها.",
    "payments.stripe_webhooks_error": "⚠ تعذر إعداد خطاف الويب. تحقق من أذونات المفتاح ثم أعد المزامنة.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ تعذر إعداد خطاف الويب. تحقق من أذونات المفتاح ثم أعد المزامنة.",
    "payments.stripe_invalid_key": "المفتاح السري غير صالح. تحقق منه ثم أعد المحاولة.",
    "Invalid secret key. Check and try again.": "المفتاح السري غير صالح. تحقق منه ثم أعد المحاولة.",
    "payments.stripe_setup_failed": "فشل الإعداد. تأكد من مزامنة المفتاح السري أولًا.",
    "Setup failed. Make sure your secret key is synced first.": "فشل الإعداد. تأكد من مزامنة المفتاح السري أولًا.",
    "payments.stripe_marketplace_connect": "Stripe Connect للسوق",
    "Marketplace Connect": "Stripe Connect للسوق",
    "payments.stripe_marketplace_hint": "مطلوب فقط عند استخدام Stripe Connect لصرف مستحقات السوق",
    "Only needed if you use Stripe Connect for marketplace payouts": "مطلوب فقط عند استخدام Stripe Connect لصرف مستحقات السوق",
    "payments.stripe_subscription_hint": "مطلوب فقط عند بيع منتجات الاشتراك على Tradly",
    "Only needed if you sell subscription products on Tradly": "مطلوب فقط عند بيع منتجات الاشتراك على Tradly",
    "integrations.sso.title": "تسجيل الدخول الموحد للمؤسسات",
    "Enterprise single sign-on": "تسجيل الدخول الموحد للمؤسسات",
    "integrations.sso.description": "اربط موفر الهوية الخاص بشركتك لتمكين موظفي المستأجر المجهزين من تسجيل الدخول إلى ArcticWhale باستخدام OIDC. ندعم Okta وMicrosoft Entra ID وموفري OIDC الذين يوقعون رموز ID باستخدام RS256.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "اربط موفر الهوية الخاص بشركتك لتمكين موظفي المستأجر المجهزين من تسجيل الدخول إلى ArcticWhale باستخدام OIDC. ندعم Okta وMicrosoft Entra ID وموفري OIDC الذين يوقعون رموز ID باستخدام RS256.",
    "integrations.sso.issuer_url": "عنوان URL للجهة المُصدرة",
    "Issuer URL": "عنوان URL للجهة المُصدرة",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "معرّف العميل",
    "integrations.sso.client_secret": "سر العميل",
    "integrations.sso.secret_replace_placeholder": "تم حفظه بأمان. أدخل قيمة لاستبداله.",
    "Saved securely. Enter a value to replace it.": "تم حفظه بأمان. أدخل قيمة لاستبداله.",
    "integrations.sso.secret_placeholder": "أدخل سر العميل",
    "Enter the client secret": "أدخل سر العميل",
    "integrations.sso.email_domains": "نطاقات البريد الإلكتروني للشركة",
    "Company email domains": "نطاقات البريد الإلكتروني للشركة",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "يجب أن يكون لدى الموظفين حساب ArcticWhale وإمكانية الوصول إلى هذا المستأجر. استخدم نطاقات تملكها مؤسستك.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "يجب أن يكون لدى الموظفين حساب ArcticWhale وإمكانية الوصول إلى هذا المستأجر. استخدم نطاقات تملكها مؤسستك.",
    "integrations.sso.callback_url": "عنوان URL لإعادة التوجيه OIDC",
    "OIDC callback URL": "عنوان URL لإعادة التوجيه OIDC",
    "integrations.sso.loading_callback_url": "جارٍ تحميل عنوان URL لإعادة التوجيه…",
    "Loading callback URL…": "جارٍ تحميل عنوان URL لإعادة التوجيه…",
    "integrations.sso.callback_help": "أضف عنوان URL هذا كما هو إلى تطبيق موفر الهوية باعتباره عنوان إعادة توجيه للويب.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "أضف عنوان URL هذا كما هو إلى تطبيق موفر الهوية باعتباره عنوان إعادة توجيه للويب.",
    "integrations.sso.enable": "تفعيل تسجيل الدخول الموحد للشركة",
    "Enable company SSO sign-in": "تفعيل تسجيل الدخول الموحد للشركة",
    "integrations.sso.checking": "جارٍ التحقق…",
    "integrations.sso.test_issuer": "اختبار الجهة المُصدرة",
    "Test issuer": "اختبار الجهة المُصدرة",
    "integrations.sso.saving": "جارٍ الحفظ…",
    "integrations.sso.save": "حفظ إعدادات تسجيل الدخول الموحد",
    "Save SSO settings": "حفظ إعدادات تسجيل الدخول الموحد",
    "integrations.sso.security_help": "يُشفّر سر العميل قبل تخزينه. يضيف تسجيل الدخول الموحد خيارًا لمؤسستك، مع بقاء تسجيل الدخول بكلمة المرور دون تغيير.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "يُشفّر سر العميل قبل تخزينه. يضيف تسجيل الدخول الموحد خيارًا لمؤسستك، مع بقاء تسجيل الدخول بكلمة المرور دون تغيير.",
    "integrations.sso.load_error": "تعذر تحميل إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "Unable to load enterprise SSO settings.": "تعذر تحميل إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "integrations.sso.save_error": "تعذر حفظ إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "Unable to save enterprise SSO settings.": "تعذر حفظ إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "integrations.sso.saved": "تم حفظ إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "Enterprise SSO settings saved.": "تم حفظ إعدادات تسجيل الدخول الموحد للمؤسسة.",
    "integrations.sso.connection_ok": "يمكن الوصول إلى نقطة اكتشاف موفر الهوية.",
    "Identity provider discovery is reachable.": "يمكن الوصول إلى نقطة اكتشاف موفر الهوية.",
    "integrations.sso.connection_error": "تعذر الاتصال بموفر الهوية.",
    "Unable to connect to the identity provider.": "تعذر الاتصال بموفر الهوية.",
    "listing_configs.maximum_quantity_per_listing": "الحد الأقصى للكمية لكل إعلان",
    "listing_configs.example_quantity": "(مثال: 100)",
    "listing_configs.enter_maximum_quantity": "أدخل الحد الأقصى للكمية لكل إعلان",
    "Enter maximum quantity per listing": "أدخل الحد الأقصى للكمية لكل إعلان",
    "listing_configs.minimum_listing_price": "الحد الأدنى لسعر الإعلان",
    "listing_configs.example_price": "(مثال: 5 $)",
    "listing_configs.enter_minimum_price": "أدخل الحد الأدنى لسعر الإعلان",
    "Enter minimum listing price": "أدخل الحد الأدنى لسعر الإعلان",
    "listing_configs.picture_count": "عدد الصور التي يمكن رفعها",
    "listing_configs.enter_picture_count": "أدخل عدد الصور",
    "Enter Pictures count": "أدخل عدد الصور",
    "listing_configs.feature_activation": "تفعيل الميزات",
    "FEATURE ACTIVATION": "تفعيل الميزات",
    "listing_configs.example_landmark": "(مثال: معلم قريب)",
    "listing_configs.enter_address_label": "أدخل تسمية العنوان",
    "Enter address Label": "أدخل تسمية العنوان",
    "listing_configs.legacy_switch_0": "الموافقة على الإعلانات تلقائيًا؟",
    "listing_configs.legacy_switch_1": "نسبة العرض",
    "listing_configs.legacy_switch_2": "قيود الحد الأقصى للكمية على مستوى الإعلان",
    "listing_configs.legacy_switch_3": "رسوم الشحن",
    "listing_configs.legacy_switch_4": "استخدم علامة الخريطة بدلًا من البحث عن عنوان",
    "Use map marker instead \nof searching address": "استخدم علامة الخريطة بدلًا من البحث عن عنوان",
    "listing_configs.legacy_switch_5": "الوسوم",
    "listing_configs.legacy_switch_6": "المخزون",
    "listing_configs.legacy_switch_7": "العنوان الجغرافي",
    "listing_configs.legacy_switch_8": "إظهار الإعلانات غير المتوفرة في المخزون ضمن الخلاصة",
    "listing_configs.legacy_switch_9": "جزء عنوان الإعلان في الرابط",
    "listing_configs.legacy_switch_10": "المتغيرات",
    "listing_configs.legacy_switch_11": "عنوان Meta",
    "listing_configs.legacy_switch_12": "وصف Meta",
    "listing_configs.legacy_switch_13": "منتج رقمي",
    "Digital Product": "منتج رقمي",
    "listing_configs.legacy_switch_14": "تفعيل محرر النصوص",
    "listing_configs.legacy_switch_15": "تفعيل الوزن",
    "listing_configs.legacy_switch_16": "تفعيل الأبعاد",
    "navigation.app_download.close": "إغلاق",
    "navigation.app_download.eyebrow": "تطبيق الهاتف المرافق",
    "Mobile companion": "تطبيق الهاتف المرافق",
    "navigation.app_download.title": "واصل إدارة مشروعك.",
    "Keep your project moving.": "واصل إدارة مشروعك.",
    "navigation.app_download.description": "أنجز المهام الأساسية من هاتفك، من الموافقة على الإعلانات إلى مراجعة الطلبات ومتابعة أعمالك.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "أنجز المهام الأساسية من هاتفك، من الموافقة على الإعلانات إلى مراجعة الطلبات ومتابعة أعمالك.",
    "navigation.app_download.approve_listings": "الموافقة على الإعلانات",
    "Approve listings": "الموافقة على الإعلانات",
    "navigation.app_download.manage_orders": "إدارة الطلبات",
    "Manage orders": "إدارة الطلبات",
    "navigation.app_download.check_performance": "مراجعة الأداء",
    "Check performance": "مراجعة الأداء",
    "navigation.app_download.download_title": "نزّل تطبيق SuperAdmin",
    "Download the SuperAdmin app": "نزّل تطبيق SuperAdmin",
    "navigation.app_download.download_on": "نزّل من",
    "Download on the": "نزّل من",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "احصل عليه من",
    "Get it on": "احصل عليه من",
    "listing_configs.address_label": "تسمية العنوان",
    "collections.add_another_condition": "+ إضافة شرط آخر",
    "collections.search": "بحث",
    "collections.status_inactive_active": "الحالة (غير نشط / نشط)",
    "media_picker.add_photo": "إضافة صورة",
    "payments.payment_intent_webhook_secret": "سر خطاف الويب Payment Intent",
    "Payment Intent Webhook secret": "سر خطاف الويب Payment Intent",
    "payments.subscription_webhook_secret": "سر خطاف الويب للاشتراك",
    "Subscription Webhook secret": "سر خطاف الويب للاشتراك",
    "payments.webhook_secret_autofilled": "تم ملء سر خطاف الويب أعلاه تلقائيًا — احفظ النموذج للاحتفاظ به.",
    "Webhook secret auto-filled above — save the form to persist.": "تم ملء سر خطاف الويب أعلاه تلقائيًا — احفظ النموذج للاحتفاظ به.",
    "app_customization.white_png_icon_help": "يجب أن تكون الأيقونة بيضاء وبصيغة PNG",
    "icon should be white and in png format": "يجب أن تكون الأيقونة بيضاء وبصيغة PNG",
    "app_customization.other_appearance": "مظهر آخر",
    "Other appearance": "مظهر آخر",
    "app_customization.notification_icon": "أيقونة الإشعارات",
    "Notification icon": "أيقونة الإشعارات",
    "app_customization.app_title_home": "عنوان التطبيق في الشاشة الرئيسية",
    "app_customization.enable_app_title_icon": "استخدام أيقونة بدلًا من عنوان التطبيق",
    "listings.quick_add.title": "إضافة إعلان سريع",
    "Quick Add Listing": "إضافة إعلان سريع",
    "listings.quick_add.success": "تمت إضافة الإعلان بنجاح",
    "Listing Added Successfully": "تمت إضافة الإعلان بنجاح",
    "listings.quick_add.image": "الصورة",
    "listings.quick_add.listing_name": "اسم الإعلان",
    "Listing Name": "اسم الإعلان",
    "listings.quick_add.title_placeholder": "مثال: سماعات لاسلكية مميزة",
    "e.g., Premium Wireless Headphones": "مثال: سماعات لاسلكية مميزة",
    "listings.quick_add.category": "الفئة",
    "listings.quick_add.select_category": "اختر فئة",
    "listings.quick_add.price": "السعر",
    "listings.quick_add.stock": "المخزون",
    "listings.quick_add.description": "الوصف",
    "listings.quick_add.description_placeholder": "وصف موجز لمنتجك...",
    "Brief Description of your product...": "وصف موجز لمنتجك...",
    "listings.quick_add.more_options": "هل تحتاج إلى خيارات أخرى؟ استخدم",
    "Need more options? Use the full": "هل تحتاج إلى خيارات أخرى؟ استخدم",
    "listings.quick_add.guided_form": "النموذج الإرشادي",
    "guided form": "النموذج الإرشادي",
    "listings.quick_add.instead": "بدلًا من ذلك",
    "instead": "بدلًا من ذلك",
    "listings.digital_product.title": "إضافة منتج رقمي",
    "Add Digital Product": "إضافة منتج رقمي",
    "listings.digital_product.select_file": "اختر ملفًا",
    "Select file": "اختر ملفًا",
    "listings.digital_product.name": "العنوان",
    "listings.digital_product.version": "الإصدار",
    "listings.digital_product.description": "الوصف",
    "web_config.social_info": "معلومات التواصل الاجتماعي",
    "Social Info": "معلومات التواصل الاجتماعي",
    "web_config.social_facebook_pageurl": "رابط صفحة Facebook",
    "Facebook page URL": "رابط صفحة Facebook",
    "web_config.enter_social_facebook_pageurl": "أدخل رابط صفحة Facebook",
    "Enter Facebook page URL": "أدخل رابط صفحة Facebook",
    "web_config.social_twitter_handleurl": "رابط حساب Twitter",
    "Twitter handle URL": "رابط حساب Twitter",
    "web_config.enter_social_twitter_handleurl": "أدخل رابط حساب Twitter",
    "Enter Twitter handle URL": "أدخل رابط حساب Twitter",
    "web_config.social_instagram_url": "رابط Instagram",
    "Instagram URL": "رابط Instagram",
    "web_config.enter_social_instagram_url": "أدخل رابط Instagram",
    "Enter Instagram URL": "أدخل رابط Instagram",
    "web_config.social_youtube_channelurl": "رابط قناة YouTube",
    "Youtube channel URL": "رابط قناة YouTube",
    "web_config.enter_social_youtube_channelurl": "أدخل رابط قناة YouTube",
    "Enter Youtube channel URL": "أدخل رابط قناة YouTube",
    "web_config.social_tiktok_url": "رابط TikTok",
    "Tiktok URL": "رابط TikTok",
    "web_config.enter_social_tiktok_url": "أدخل رابط TikTok",
    "Enter Tiktok URL": "أدخل رابط TikTok",
    "web_config.social_spotify_url": "رابط Spotify",
    "Spotify URL": "رابط Spotify",
    "web_config.enter_social_spotify_url": "أدخل رابط Spotify",
    "Enter Spotify URL": "أدخل رابط Spotify",
    "web_config.social_whatsapp_number": "رقم WhatsApp",
    "Whatsapp number": "رقم WhatsApp",
    "web_config.enter_social_whatsapp_number": "أدخل رقم WhatsApp",
    "Enter Whatsapp number": "أدخل رقم WhatsApp",
    "web_config.social_telegram_url": "رابط Telegram",
    "Telegram URL": "رابط Telegram",
    "web_config.enter_social_telegram_url": "أدخل رابط Telegram",
    "Enter Telegram URL": "أدخل رابط Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "أدخل Snapchat",
    "Enter Snapchat": "أدخل Snapchat",
    "payments.paydunya.title": "تكامل PayDunya",
    "PayDunya Integration": "تكامل PayDunya",
    "payments.paydunya.master_key": "المفتاح الرئيسي",
    "Master key": "المفتاح الرئيسي",
    "payments.paydunya.enter_master_key": "أدخل المفتاح الرئيسي",
    "Enter master key": "أدخل المفتاح الرئيسي",
    "payments.paydunya.public_key": "المفتاح العام",
    "Public key": "المفتاح العام",
    "payments.paydunya.enter_public_key": "أدخل المفتاح العام",
    "payments.paydunya.private_key": "المفتاح الخاص",
    "Private key": "المفتاح الخاص",
    "payments.paydunya.enter_private_key": "أدخل المفتاح الخاص",
    "Enter private key": "أدخل المفتاح الخاص",
    "payments.paydunya.token": "الرمز",
    "payments.paydunya.enter_token": "أدخل الرمز",
    "payments.paydunya.uploaded_successfully": "تم الرفع بنجاح",
    "communications.email_stats_open": "{sent} أُرسلت · {openRate}% مفتوحة",
    "{sent} sent · {openRate}% open": "{sent} أُرسلت · {openRate}% مفتوحة",
    "communications.email_stats_full": "{sent} أُرسلت · {openRate}% مفتوحة · {clicks} نقرة",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} أُرسلت · {openRate}% مفتوحة · {clicks} نقرة",
    "navigation.mini_apps.title": "تطبيقات مصغّرة",
    "Mini Apps": "تطبيقات مصغّرة",
    "navigation.mini_apps.subtitle": "أدوات Tradly المساعدة — اضغط على بطاقة لعرض التفاصيل والأسعار",
    "Tradly-built companion tools — tap a card to see details and pricing": "أدوات Tradly المساعدة — اضغط على بطاقة لعرض التفاصيل والأسعار",
    "navigation.mini_apps.soon": "قريبًا",
    "Soon": "قريبًا",
    "navigation.mini_apps.included_in_paid_plan": "متوفر ضمن خطة مدفوعة",
    "Included in a paid plan": "متوفر ضمن خطة مدفوعة",
    "navigation.mini_apps.know_more": "اعرف المزيد",
    "Know more": "اعرف المزيد",
    "navigation.mini_apps.hide_details": "إخفاء التفاصيل",
    "Hide details": "إخفاء التفاصيل",
    "navigation.mini_apps.view_plans": "عرض الخطط",
    "navigation.mini_apps.remove": "إزالة",
    "navigation.mini_apps.add_to_sidebar": "إضافة إلى الشريط الجانبي",
    "Add to sidebar": "إضافة إلى الشريط الجانبي",
    "navigation.mini_apps.why_heading": "لماذا تحتاج إليه أعمالك",
    "Why your business needs it": "لماذا تحتاج إليه أعمالك",
    "navigation.mini_apps.coming_soon": "قريبًا",
    "navigation.mini_apps.workflow.title": "التسويق",
    "navigation.mini_apps.workflow.description": "أنشئ حملات بريد إلكتروني وإشعارات فورية وعروضًا ترويجية لتنمية جمهورك.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "أنشئ حملات بريد إلكتروني وإشعارات فورية وعروضًا ترويجية لتنمية جمهورك.",
    "navigation.mini_apps.workflow.why_1": "أرسل حملات بريدية موجهة حسب نشاط المشترين والبائعين",
    "Send targeted email campaigns to buyers and sellers based on activity": "أرسل حملات بريدية موجهة حسب نشاط المشترين والبائعين",
    "navigation.mini_apps.workflow.why_2": "أعد جذب المستخدمين الغائبين لأكثر من 7 أيام بالإشعارات",
    "Push notifications to re-engage users who haven't visited in 7+ days": "أعد جذب المستخدمين الغائبين لأكثر من 7 أيام بالإشعارات",
    "navigation.mini_apps.workflow.why_3": "أطلق قسائم ترويجية بالتزامن مع فعالياتك الموسمية",
    "Run promotions with coupon drops timed to your seasonal events": "أطلق قسائم ترويجية بالتزامن مع فعالياتك الموسمية",
    "navigation.mini_apps.workflow.pricing_label": "قائم على الأرصدة",
    "Credits-based": "قائم على الأرصدة",
    "navigation.mini_apps.workflow.pricing_detail": "ادفع لكل إرسال: تكلف 1,000 رسالة 100 رصيد، ولا تنتهي صلاحية الأرصدة.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "ادفع لكل إرسال: تكلف 1,000 رسالة 100 رصيد، ولا تنتهي صلاحية الأرصدة.",
    "navigation.mini_apps.intelligence_section.title": "الذكاء",
    "navigation.mini_apps.intelligence_section.description": "افهم نموك من خلال التحليلات ومسارات التحويل والرؤى المدعومة بالذكاء الاصطناعي.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "افهم نموك من خلال التحليلات ومسارات التحويل والرؤى المدعومة بالذكاء الاصطناعي.",
    "navigation.mini_apps.intelligence_section.why_1": "اعرف الإعلانات والحسابات والفئات التي تحقق أعلى قيمة مبيعات",
    "See which listings, accounts, and categories drive the most GMV": "اعرف الإعلانات والحسابات والفئات التي تحقق أعلى قيمة مبيعات",
    "navigation.mini_apps.intelligence_section.why_2": "حدد موضع مغادرة المشترين قبل الدفع",
    "Drop-off funnels show exactly where buyers leave before checkout": "حدد موضع مغادرة المشترين قبل الدفع",
    "navigation.mini_apps.intelligence_section.why_3": "يكشف الذكاء الاصطناعي الحالات والفرص في بياناتك",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "يكشف الذكاء الاصطناعي الحالات والفرص في بياناتك",
    "navigation.mini_apps.intelligence_section.pricing_label": "قائم على الأرصدة",
    "navigation.mini_apps.intelligence_section.pricing_detail": "تستهلك تحليلات الذكاء الاصطناعي والتقارير أرصدة. عرض البيانات مجاني دائمًا.",
    "AI analysis and generated reports consume credits. Data views are always free.": "تستهلك تحليلات الذكاء الاصطناعي والتقارير أرصدة. عرض البيانات مجاني دائمًا.",
    "navigation.mini_apps.subscription_section.title": "الاشتراكات",
    "navigation.mini_apps.subscription_section.description": "أدر الخطط ودورات الفوترة واستحقاقات الميزات للمستأجرين.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "أدر الخطط ودورات الفوترة واستحقاقات الميزات للمستأجرين.",
    "navigation.mini_apps.subscription_section.why_1": "أنشئ خططًا متعددة المستويات بصلاحيات لكل ميزة",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "أنشئ خططًا متعددة المستويات بصلاحيات لكل ميزة",
    "navigation.mini_apps.subscription_section.why_2": "أتمت دورات الفوترة الشهرية أو السنوية أو المخصصة",
    "Automate billing cycles — monthly, annual, or custom durations": "أتمت دورات الفوترة الشهرية أو السنوية أو المخصصة",
    "navigation.mini_apps.subscription_section.why_3": "افتح الميزات أو قيّدها حسب استحقاقات المستأجر",
    "Entitlements unlock or restrict features across your tenant base": "افتح الميزات أو قيّدها حسب استحقاقات المستأجر",
    "navigation.mini_apps.subscription_section.pricing_label": "ربط",
    "Connect": "ربط",
    "navigation.mini_apps.subscription_section.pricing_detail": "تسعير حسب المهمة لكل حدث اشتراك: ترقية أو تجديد أو إلغاء.",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "تسعير حسب المهمة لكل حدث اشتراك: ترقية أو تجديد أو إلغاء.",
    "navigation.mini_apps.membership_section.title": "العضويات",
    "navigation.mini_apps.membership_section.description": "أدر برامج العضوية والأعضاء والمساهمات والمدفوعات المستحقة.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "أدر برامج العضوية والأعضاء والمساهمات والمدفوعات المستحقة.",
    "navigation.mini_apps.membership_section.why_1": "أدر برامج العضوية والأعضاء المسجلين",
    "Manage membership programs and enrolled members": "أدر برامج العضوية والأعضاء المسجلين",
    "navigation.mini_apps.membership_section.why_2": "تابع المساهمات والمبالغ المستحقة وحالة العضوية",
    "Track contributions, payment dues, and membership status": "تابع المساهمات والمبالغ المستحقة وحالة العضوية",
    "navigation.mini_apps.membership_section.why_3": "اربط مساهمات الأعضاء بطلباتهم",
    "Connect membership contributions back to their orders": "اربط مساهمات الأعضاء بطلباتهم",
    "navigation.mini_apps.membership_section.pricing_label": "السعر قيد التحديد",
    "Pricing TBC": "السعر قيد التحديد",
    "navigation.mini_apps.membership_section.pricing_detail": "أدر برامج العضوية وسجل المساهمات من مكان واحد.",
    "Manage membership programs and contribution history in one place.": "أدر برامج العضوية وسجل المساهمات من مكان واحد.",
    "navigation.mini_apps.reward_programs.title": "المكافآت",
    "navigation.mini_apps.reward_programs.description": "أنشئ برامج مكافآت بنطاقات وقواعد ووصفات قابلة لإعادة الاستخدام.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "أنشئ برامج مكافآت بنطاقات وقواعد ووصفات قابلة لإعادة الاستخدام.",
    "navigation.mini_apps.reward_programs.why_1": "حدد برامج مكافآت للإحالة أو المناطق أو المتاجر",
    "Define affiliate, referral, regional, or store reward programs": "حدد برامج مكافآت للإحالة أو المناطق أو المتاجر",
    "navigation.mini_apps.reward_programs.why_2": "أنشئ قواعد من مكونات عمولات ومكافآت قابلة لإعادة الاستخدام",
    "Build rules from reusable commission and reward components": "أنشئ قواعد من مكونات عمولات ومكافآت قابلة لإعادة الاستخدام",
    "navigation.mini_apps.reward_programs.why_3": "دع نظام ERP يدير حساب المكافآت وترحيلها",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "دع نظام ERP يدير حساب المكافآت وترحيلها",
    "navigation.mini_apps.reward_programs.pricing_label": "السعر قيد التحديد",
    "navigation.mini_apps.reward_programs.pricing_detail": "أعد برامج المكافآت واربطها بالإحالة.",
    "Configure reward programs and connect them to attribution.": "أعد برامج المكافآت واربطها بالإحالة.",
    "navigation.mini_apps.bundles_app.title": "الحزم",
    "navigation.mini_apps.bundles_app.description": "أنشئ حزمًا ثابتة أو قابلة للتجميع من الإعلانات الحالية.",
    "Create fixed and mix-and-match bundles from existing listings.": "أنشئ حزمًا ثابتة أو قابلة للتجميع من الإعلانات الحالية.",
    "navigation.mini_apps.bundles_app.why_1": "اجمع الإعلانات دون تكرار بيانات المنتج",
    "Combine existing listings without duplicating product data": "اجمع الإعلانات دون تكرار بيانات المنتج",
    "navigation.mini_apps.bundles_app.why_2": "وفّر حزمًا ثابتة أو يختار العميل مكوناتها",
    "Support fixed bundles and customer-selected mix-and-match bundles": "وفّر حزمًا ثابتة أو يختار العميل مكوناتها",
    "navigation.mini_apps.bundles_app.why_3": "تحقق من مخزون المكونات قبل الدفع والتنفيذ",
    "Validate component stock before checkout and fulfilment": "تحقق من مخزون المكونات قبل الدفع والتنفيذ",
    "navigation.mini_apps.bundles_app.pricing_label": "ميزة ضمن باقة مدفوعة",
    "Paid package feature": "ميزة ضمن باقة مدفوعة",
    "navigation.mini_apps.bundles_app.pricing_detail": "متوفر في الخطط التي تشمل عمليات الحزم.",
    "Available on plans that include bundle operations.": "متوفر في الخطط التي تشمل عمليات الحزم.",
    "navigation.mini_apps.inventory_section.title": "سلسلة الإمداد",
    "navigation.mini_apps.inventory_section.description": "المخزون وأوامر الشراء ومواقع التخزين والموردون والعمليات.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "المخزون وأوامر الشراء ومواقع التخزين والموردون والعمليات.",
    "navigation.mini_apps.inventory_section.why_1": "تابع المخزون عبر المستودعات والمتاجر",
    "Track stock levels across multiple warehouses and store locations": "تابع المخزون عبر المستودعات والمتاجر",
    "navigation.mini_apps.inventory_section.why_2": "أنشئ أوامر شراء واستلم المخزون من الموردين",
    "Raise purchase orders with suppliers and receive stock against them": "أنشئ أوامر شراء واستلم المخزون من الموردين",
    "navigation.mini_apps.inventory_section.why_3": "سجل تعديلات المخزون والتحويلات والشطب",
    "Record inventory operations — adjustments, transfers, and write-offs": "سجل تعديلات المخزون والتحويلات والشطب",
    "navigation.mini_apps.inventory_section.pricing_label": "مضمن",
    "Included": "مضمن",
    "navigation.mini_apps.inventory_section.pricing_detail": "سلسلة الإمداد مشمولة في خطتك دون رسوم إضافية.",
    "Supply Chain is included in your plan. No additional charge.": "سلسلة الإمداد مشمولة في خطتك دون رسوم إضافية.",
    "navigation.mini_apps.people_app.title": "الموظفون",
    "navigation.mini_apps.people_app.description": "دليل الموظفين والأقسام والملفات الوظيفية ودرجات الأجور.",
    "Staff directory, departments, job profiles, and pay grades.": "دليل الموظفين والأقسام والملفات الوظيفية ودرجات الأجور.",
    "navigation.mini_apps.people_app.why_1": "اجمع ملفات الموظفين ورموزهم وأنواع التوظيف في دليل واحد",
    "Keep every staff profile, code, and employment type in one directory": "اجمع ملفات الموظفين ورموزهم وأنواع التوظيف في دليل واحد",
    "navigation.mini_apps.people_app.why_2": "نظم الفرق ضمن أقسام وملفات وظيفية موحدة",
    "Organise teams into departments with standard job profiles": "نظم الفرق ضمن أقسام وملفات وظيفية موحدة",
    "navigation.mini_apps.people_app.why_3": "حدد درجات الأجور وخصصها للموظفين",
    "Define pay grades once and assign them to staff": "حدد درجات الأجور وخصصها للموظفين",
    "navigation.mini_apps.people_app.pricing_label": "السعر قيد التحديد",
    "navigation.mini_apps.people_app.pricing_detail": "مطلوب للقوى العاملة وكشوف الرواتب.",
    "Required by Workforce and Payroll.": "مطلوب للقوى العاملة وكشوف الرواتب.",
    "navigation.mini_apps.workforce_app.title": "القوى العاملة",
    "navigation.mini_apps.workforce_app.description": "إدارة الورديات والحضور والإجازات لفريقك.",
    "Shifts, attendance, and leave management for your team.": "إدارة الورديات والحضور والإجازات لفريقك.",
    "navigation.mini_apps.workforce_app.why_1": "جدول الموظفين حسب التاريخ والوقت والموقع",
    "Roster staff into shifts by date, time, and location": "جدول الموظفين حسب التاريخ والوقت والموقع",
    "navigation.mini_apps.workforce_app.why_2": "تابع تسجيل الحضور والانصراف وسجلاته",
    "Clock in and out with a full attendance history": "تابع تسجيل الحضور والانصراف وسجلاته",
    "navigation.mini_apps.workforce_app.why_3": "أدر سياسات الإجازة وأرصدتها والموافقة عليها",
    "Leave policies, balances, and an approve/reject workflow": "أدر سياسات الإجازة وأرصدتها والموافقة عليها",
    "navigation.mini_apps.workforce_app.pricing_label": "السعر قيد التحديد",
    "navigation.mini_apps.workforce_app.pricing_detail": "يفعّل People تلقائيًا.",
    "Turns on People automatically.": "يفعّل People تلقائيًا.",
    "navigation.mini_apps.payroll_app.title": "الرواتب",
    "navigation.mini_apps.payroll_app.description": "مسيرات الرواتب والموافقات وتصدير CSV وتعويض النفقات.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "مسيرات الرواتب والموافقات وتصدير CSV وتعويض النفقات.",
    "navigation.mini_apps.payroll_app.why_1": "أنشئ مسيرات الرواتب حسب درجات الأجور",
    "Create payroll runs per period from staff pay grades": "أنشئ مسيرات الرواتب حسب درجات الأجور",
    "navigation.mini_apps.payroll_app.why_2": "اعتمد المسيرات وصدرها بصيغة CSV للبنك أو المحاسب",
    "Approve runs and export them as CSV for your bank or accountant": "اعتمد المسيرات وصدرها بصيغة CSV للبنك أو المحاسب",
    "navigation.mini_apps.payroll_app.why_3": "أدر مطالبات النفقات حتى التعويض",
    "Staff expense claims from submission to reimbursement": "أدر مطالبات النفقات حتى التعويض",
    "navigation.mini_apps.payroll_app.pricing_label": "السعر قيد التحديد",
    "navigation.mini_apps.payroll_app.pricing_detail": "يفعّل People تلقائيًا.",
    "navigation.mini_apps.unified_inbox.title": "صندوق الوارد الموحد",
    "Unified Inbox": "صندوق الوارد الموحد",
    "navigation.mini_apps.unified_inbox.description": "كل تواصل العملاء — الطلبات والدعم والدردشة — من مكان واحد.",
    "All your customer communication — orders, support, and chat — from one place.": "كل تواصل العملاء — الطلبات والدعم والدردشة — من مكان واحد.",
    "navigation.mini_apps.unified_inbox.why_1": "اجمع استفسارات الطلبات وتذاكر الدعم ورسائل المشترين في سلسلة واحدة",
    "Order queries, support tickets, and buyer messages in one thread view": "اجمع استفسارات الطلبات وتذاكر الدعم ورسائل المشترين في سلسلة واحدة",
    "navigation.mini_apps.unified_inbox.why_2": "رد باقتراحات ذكاء اصطناعي مدربة على كتالوجك",
    "Reply with AI-suggested responses trained on your catalogue": "رد باقتراحات ذكاء اصطناعي مدربة على كتالوجك",
    "navigation.mini_apps.unified_inbox.why_3": "صنف المحادثات ووزعها وحلها عبر الفريق",
    "Tag, assign, and resolve conversations across your team": "صنف المحادثات ووزعها وحلها عبر الفريق",
    "navigation.mini_apps.unified_inbox.pricing_label": "ربط",
    "navigation.mini_apps.unified_inbox.pricing_detail": "تسعير حسب المهمة لكل محادثة يتم حلها.",
    "Task-based pricing per resolved conversation.": "تسعير حسب المهمة لكل محادثة يتم حلها.",
    "navigation.mini_apps.social_connect.title": "التواصل الاجتماعي",
    "Social Connect": "التواصل الاجتماعي",
    "navigation.mini_apps.social_connect.description": "شارك الإعلانات على قنوات التواصل وفق جدول تحدده.",
    "Share listings to social channels on a schedule you define.": "شارك الإعلانات على قنوات التواصل وفق جدول تحدده.",
    "navigation.mini_apps.social_connect.why_1": "جدول نشر الإعلانات تلقائيًا على Instagram وFacebook وX",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "جدول نشر الإعلانات تلقائيًا على Instagram وFacebook وX",
    "navigation.mini_apps.social_connect.why_2": "حدد جدول نشر لكل قناة وفق وتيرة تناسبك",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "حدد جدول نشر لكل قناة وفق وتيرة تناسبك",
    "navigation.mini_apps.social_connect.why_3": "تابع النقرات والتفاعل لكل إعلان من لوحة التحكم",
    "Track clicks and engagement back to each listing from the dashboard": "تابع النقرات والتفاعل لكل إعلان من لوحة التحكم",
    "navigation.mini_apps.social_connect.pricing_label": "ربط",
    "navigation.mini_apps.social_connect.pricing_detail": "تسعير حسب المهمة لكل منشور مجدول يتم نشره.",
    "Task-based pricing per scheduled post delivered.": "تسعير حسب المهمة لكل منشور مجدول يتم نشره.",
    "navigation.mini_apps.shopping_channels.title": "قنوات التسوق",
    "Shopping Channels": "قنوات التسوق",
    "navigation.mini_apps.shopping_channels.description": "اربط كتالوجك بـ TikTok Shop وShopee وMeta Catalog وUber Eats وغيرها.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "اربط كتالوجك بـ TikTok Shop وShopee وMeta Catalog وUber Eats وغيرها.",
    "navigation.mini_apps.shopping_channels.why_1": "زامن إعلاناتك مع TikTok Shop وShopee وMeta Catalog فورًا",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "زامن إعلاناتك مع TikTok Shop وShopee وMeta Catalog فورًا",
    "navigation.mini_apps.shopping_channels.why_2": "اربط كتالوجات الطعام والشراب بـ Uber Eats وGrab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "اربط كتالوجات الطعام والشراب بـ Uber Eats وGrab",
    "navigation.mini_apps.shopping_channels.why_3": "زامن المخزون والطلبات تلقائيًا دون إدخال مزدوج",
    "Inventory and orders sync back automatically — no double-entry": "زامن المخزون والطلبات تلقائيًا دون إدخال مزدوج",
    "navigation.mini_apps.shopping_channels.pricing_label": "ربط",
    "navigation.mini_apps.shopping_channels.pricing_detail": "تسعير حسب المهمة لكل طلب ينفذ عبر قناة متصلة.",
    "Task-based pricing per order fulfilled through a connected channel.": "تسعير حسب المهمة لكل طلب ينفذ عبر قناة متصلة.",
    "listing_configs.customize_table": "تخصيص الجدول",
    "Customize table": "تخصيص الجدول",
    "listing_configs.fields_visible": "الحقول الظاهرة في الجدول",
    "Fields visible in table": "الحقول الظاهرة في الجدول",
    "listing_configs.fields_hidden": "الحقول غير الظاهرة في الجدول",
    "Fields not shown in table": "الحقول غير الظاهرة في الجدول",
    "listing_configs.reset_default": "إعادة التعيين إلى الافتراضي",
    "listing_configs.column_title": "العنوان",
    "listing_configs.column_actions": "الإجراءات",
    "listing_configs.column_website": "الموقع الإلكتروني",
    "listing_configs.column_list_price": "السعر الأصلي",
    "listing_configs.column_offer_percent": "نسبة الخصم",
    "Offer Percent": "نسبة الخصم",
    "listing_configs.column_image": "الصورة",
    "listing_configs.column_offer_price": "سعر العرض",
    "Offer Price": "سعر العرض",
    "listing_configs.column_status": "الحالة",
    "listing_configs.column_listing_id": "معرّف الإعلان",
    "listing_configs.column_listing_status": "حالة الإعلان",
    "listing_configs.column_accounts": "الحسابات",
    "listing_configs.column_currency": "العملة",
    "listing_configs.column_sold": "تم البيع",
    "listing_configs.column_goal_amount": "مبلغ الهدف",
    "Goal Amount": "مبلغ الهدف",
    "listing_configs.column_width": "العرض",
    "listing_configs.column_height": "الارتفاع",
    "listing_configs.column_weight": "الوزن",
    "listing_configs.column_volume": "الحجم",
    "Volume": "الحجم",
    "listing_configs.column_order_type": "نوع الطلب",
    "Order Type": "نوع الطلب",
    "navigation.apps_group": "التطبيقات",
    "navigation.channels_group": "القنوات",
    "navigation.manage_mini_apps": "إدارة التطبيقات المصغرة",
    "Manage Mini Apps": "إدارة التطبيقات المصغرة",
    "navigation.manage_channels": "إدارة القنوات",
    "Manage Channels": "إدارة القنوات",
    "listings.import.uploading": "جارٍ الرفع…",
    "listings.import.complete": "اكتمل الاستيراد",
    "listings.import.error": "خطأ: {message}",
    "Error: {message}": "خطأ: {message}",
    "listings.import.file_label": "الملف:",
    "listings.import.select_file": "اختر ملفًا",
    "listings.import.response": "استجابة الاستيراد",
    "Import response": "استجابة الاستيراد",
    "listings.import.total_rows": "إجمالي الصفوف:",
    "Total rows:": "إجمالي الصفوف:",
    "listings.import.total_imported": "إجمالي ما تم استيراده:",
    "Total imported:": "إجمالي ما تم استيراده:",
    "listings.import.download_template": "تنزيل قالب الإعلانات",
    "Download listings template": "تنزيل قالب الإعلانات",
    "common.upload": "رفع",
    "common.kanban_unavailable": "عرض اللوحة غير متاح مؤقتًا",
    "Board view is temporarily unavailable": "عرض اللوحة غير متاح مؤقتًا",
    "common.retry": "إعادة المحاولة",
    "Retry": "إعادة المحاولة",
    "listings.digital_assets.title": "الأصول الرقمية",
    "Digital assets": "الأصول الرقمية",
    "listings.digital_assets.not_found": "لم يتم العثور على أصول رقمية",
    "Digital assets not found": "لم يتم العثور على أصول رقمية",
    "listings.addon.saved": "تم حفظ الإضافة بنجاح.",
    "Add-on saved successfully.": "تم حفظ الإضافة بنجاح.",
    "listings.addon.title_required": "يرجى إدخال عنوان.",
    "Please enter a title.": "يرجى إدخال عنوان.",
    "listings.addon.price_required": "يرجى إدخال السعر.",
    "Please enter a price.": "يرجى إدخال السعر.",
    "listings.addon.no_media": "لا توجد لديك ملفات وسائط.",
    "listings.addon.price": "السعر",
    "listings.addon.offer_percentage": "نسبة العرض",
    "Offer Percentage": "نسبة العرض",
    "listings.addon.maximum_quantity": "الكمية القصوى",
    "Maximum Quantity": "الكمية القصوى",
    "listings.addon.stock": "المخزون",
    "listings.addon.enter_price": "أدخل السعر",
    "Enter price": "أدخل السعر",
    "listings.addon.enter_offer_percentage": "أدخل نسبة العرض",
    "Enter offer percentage": "أدخل نسبة العرض",
    "listings.addon.enter_maximum_quantity": "أدخل الكمية القصوى",
    "Enter maximum quantity": "أدخل الكمية القصوى",
    "listings.addon.enter_stock": "أدخل المخزون",
    "listings.addon.edit_title": "تعديل الإضافة",
    "Edit Add-on": "تعديل الإضافة",
    "listings.addon.add_title": "إضافة خيار",
    "Add Add-on": "إضافة خيار",
    "listings.addon.title": "العنوان",
    "listings.addon.enter_title": "أدخل العنوان",
    "listings.addon.status": "الحالة (غير نشط / نشط)",
    "listings.addon.upload_media": "رفع وسائط",
    "attributes.prefill_for": "تعبئة مسبقة لـ",
    "Prefill for": "تعبئة مسبقة لـ",
    "attributes.first_item": "العنصر الأول",
    "First Item": "العنصر الأول",
    "attributes.all_items": "جميع العناصر",
    "All Items": "جميع العناصر",
    "common.uploading": "جارٍ الرفع…",
    "common.uploading_named": "جارٍ رفع {title}",
    "Uploading {title}": "جارٍ رفع {title}",
    "common.please_wait_short": "يرجى الانتظار",
    "Please wait": "يرجى الانتظار",
    "attributes.select_option": "اختيار",
    "attributes.select_value": "اختر قيمة...",
    "Select value...": "اختر قيمة...",
    "attributes.type_placeholder": "اكتب {name}",
    "Type {name}": "اكتب {name}",
    "attributes.multiple_values_placeholder": "يمكنك إدخال عدة قيم باستخدام فاصلة.",
    "Using a comma, you can enter several values.": "يمكنك إدخال عدة قيم باستخدام فاصلة.",
    "attributes.upload_attachment": "رفع مرفق",
    "Upload Attachment": "رفع مرفق",
    "attributes.upload_json_file": "رفع ملف JSON",
    "Upload JSON File": "رفع ملف JSON",
    "attributes.copied_value": "تم نسخ القيمة",
    "Copied the value": "تم نسخ القيمة",
    "attributes.latitude_longitude_placeholder": "أدخل خط العرض وخط الطول (مثال: 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "أدخل خط العرض وخط الطول (مثال: 12.34,56.78)",
    "navigation.sidebar_label": "الشريط الجانبي",
    "Side bar": "الشريط الجانبي",
    "checkout_settings.orders_option_0": "عرض تقويم الطلبات",
    "Orders Calendar View": "عرض تقويم الطلبات",
    "checkout_settings.show_cart_attributes": "إظهار سمات سلة التسوق",
    "Show cart attributes": "إظهار سمات سلة التسوق",
    "checkout_settings.select_order_status": "حدد حالة الطلب",
    "Select order status": "حدد حالة الطلب",
    "checkout_settings.order_status_0": "تم تقديم الطلب",
    "Placed success": "تم تقديم الطلب",
    "checkout_settings.order_status_1": "قيد المعالجة",
    "In process": "قيد المعالجة",
    "checkout_settings.order_status_2": "تم الشحن",
    "checkout_settings.order_status_3": "تم التوصيل",
    "checkout_settings.order_status_4": "مكتمل",
    "listing_form.no_categories_found": "لم يتم العثور على فئات. استخدم «{action}» أعلاه.",
    "No categories found. Use “{action}” above.": "لم يتم العثور على فئات. استخدم «{action}» أعلاه.",
    "common.learn_more": "مزيد من المعلومات",
    "Learn more": "مزيد من المعلومات",
    "common.show_information": "عرض المعلومات",
    "Show information": "عرض المعلومات",
    "common.paid_feature": "ميزة مدفوعة",
    "Paid Feature": "ميزة مدفوعة",
    "common.learn_more_about": "مزيد من المعلومات حول",
    "Learn more about": "مزيد من المعلومات حول",
    "attributes.categories": "الفئات",
    "attributes.edit_bulk_title": "تعديل جماعي: {title}",
    "{title} Edit Bulk": "تعديل جماعي: {title}",
    "common.enter_description": "أدخل الوصف",
    "common.empty_fetch_message": "لا يوجد ما يمكن عرضه هنا بعد. سيظهر المحتوى في هذه الصفحة عند توفره.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "لا يوجد ما يمكن عرضه هنا بعد. سيظهر المحتوى في هذه الصفحة عند توفره.",
    "common.ai_credits_and_top_up": "رصيد الذكاء الاصطناعي وإعادة الشحن",
    "AI credits and top up": "رصيد الذكاء الاصطناعي وإعادة الشحن",
    "common.ai_credits_loading": "جارٍ تحميل رصيد الذكاء الاصطناعي",
    "Loading AI credits": "جارٍ تحميل رصيد الذكاء الاصطناعي",
    "common.ai_credits_unavailable": "رصيد الذكاء الاصطناعي غير متاح",
    "AI credits unavailable": "رصيد الذكاء الاصطناعي غير متاح",
    "common.ai_credits_available": "رصيد الذكاء الاصطناعي المتاح: {count}",
    "Available AI credits: {count}": "رصيد الذكاء الاصطناعي المتاح: {count}",
    "common.ai_credits_unavailable_top_up": "رصيد الذكاء الاصطناعي غير متاح — انقر لإعادة الشحن",
    "AI credits unavailable — click to top up": "رصيد الذكاء الاصطناعي غير متاح — انقر لإعادة الشحن",
    "common.ai_credits_available_top_up": "رصيد الذكاء الاصطناعي المتاح: {count} — انقر لإضافة رصيد",
    "Available AI credits: {count} — click to add credits": "رصيد الذكاء الاصطناعي المتاح: {count} — انقر لإضافة رصيد",
    "common.ai_credits_add": "إضافة رصيد",
    "Add credits": "إضافة رصيد",
    "navigation.switch_project": "تبديل المشروع",
    "Switch Project": "تبديل المشروع",
    "navigation.tenant_switch_failed": "تعذر تبديل مساحة العمل. حاول مرة أخرى.",
    "Tenant switch failed. Please try again.": "تعذر تبديل مساحة العمل. حاول مرة أخرى.",
    "navigation.select_project": "اختر مشروعًا",
    "Select Project": "اختر مشروعًا",
    "navigation.collapse_sidebar": "طي الشريط الجانبي",
    "Collapse sidebar": "طي الشريط الجانبي",
    "navigation.expand_sidebar": "توسيع الشريط الجانبي",
    "Expand sidebar": "توسيع الشريط الجانبي",
    "navigation.search": "بحث",
    "navigation.loading": "جارٍ تحميل التنقل",
    "Loading navigation": "جارٍ تحميل التنقل",
    "navigation.help_documentation": "التوثيق",
    "navigation.help_community": "المجتمع",
    "navigation.help_api_reference": "مرجع واجهة API",
    "listings.quick_form": "نموذج سريع",
    "Quick Form": "نموذج سريع",
    "payments.notification_secret": "سر الإشعارات",
    "Notification Secret": "سر الإشعارات",
    "payments.user_type": "نوع المستخدم",
    "User Type": "نوع المستخدم",
    "payments.category_id": "معرّف الفئة",
    "app_customization.other_settings": "إعدادات أخرى",
    "Other Settings": "إعدادات أخرى",
    "app_customization.other_hide_balances": "إخفاء الأرصدة والمدفوعات في قسم المزيد",
    "app_customization.other_enable_logs": "تفعيل السجلات",
    "Enable logs": "تفعيل السجلات",
    "app_customization.other_signup_first": "عرض التسجيل أولاً",
    "common.beta": "(تجريبي)",
    "(beta)": "(تجريبي)",
    "common.selected_image": "الصورة المحددة",
    "Selected image": "الصورة المحددة",
    "common.ai_no_response_to_copy": "لا توجد استجابة لنسخها",
    "No response to copy": "لا توجد استجابة لنسخها",
    "common.copied_to_clipboard": "تم النسخ إلى الحافظة",
    "Copied to clipboard": "تم النسخ إلى الحافظة",
    "common.ai_suggestions": "اقتراحات",
    "Suggestions": "اقتراحات",
    "common.regenerate": "إعادة الإنشاء",
    "Regenerate": "إعادة الإنشاء",
    "common.esc": "إلغاء",
    "ESC": "إلغاء",
    "common.json_icon_alt": "أيقونة JSON",
    "JSON icon": "أيقونة JSON",
    "collections.generator_title": "منشئ المجموعات",
    "Collection Generator": "منشئ المجموعات",
    "collections.generator_create": "إنشاء مجموعة",
    "collections.generator_json_placeholder": "أدخل JSON",
    "Enter JSON input": "أدخل JSON",
    "collections.generator_invalid_data": "يرجى إدخال بيانات صالحة",
    "Please enter valid data": "يرجى إدخال بيانات صالحة",
    "category.editor_select_from_media": "اختر من الوسائط",
    "payments.subscription": "اشتراك",
    "payments.subscription_setting_up": "جارٍ الإعداد…",
    "Setting up...": "جارٍ الإعداد…",
    "payments.subscription_webhook_configured": "تم إعداد webhook الاشتراك",
    "Subscription webhook configured": "تم إعداد webhook الاشتراك",
    "payments.subscription_retry_setup": "إعادة محاولة الإعداد",
    "Retry setup": "إعادة محاولة الإعداد",
    "payments.setup_subscription_webhook": "إعداد webhook الاشتراك",
    "Setup Subscription Webhook": "إعداد webhook الاشتراك",
    "orders.shipment_number": "الشحنة {number}",
    "Shipment {number}": "الشحنة {number}",
    "orders.quantity_short": "الكمية",
    "orders.shipment_status_1": "تم إنشاء الشحنة",
    "orders.shipment_status_2": "الشحنة قيد التنفيذ",
    "orders.shipment_status_3": "تم الشحن",
    "orders.shipment_status_4": "جاهزة للاستلام",
    "orders.shipment_status_5": "خرجت للتوصيل",
    "orders.shipment_status_6": "إرجاع غير مُسلّم",
    "orders.shipment_status_7": "تم تسليم الشحنة",
    "orders.shipment_status_8": "تم تأكيد تسليم الشحنة",
    "orders.shipment_status_9": "بدأ الإرجاع",
    "orders.shipment_status_10": "تم استلام المرتجع",
    "orders.shipment_status_11": "تم تأكيد إرجاع الشحنة",
    "orders.shipment_status_12": "ألغى البائع",
    "orders.shipment_status_13": "ألغى العميل",
    "orders.shipment_status_14": "وصلت إلى موقع العميل",
    "orders.shipment_status_15": "ألغى المسؤول",
    "attributes.metadata_title": "البيانات الوصفية",
    "Metadata": "البيانات الوصفية",
    "common.add_row": "إضافة صف",
    "common.no_access": "ليست لديك صلاحية الوصول",
    "You don't have access": "ليست لديك صلاحية الوصول",
    "common.error_404_message": "عذرًا، الصفحة التي تبحث عنها غير متاحة حاليًا. تحقق من عنوان URL وحاول مرة أخرى أو عاود الزيارة لاحقًا. إذا استمرت المشكلة، فاتصل بفريق الدعم. شكرًا لتفهمك.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "عذرًا، الصفحة التي تبحث عنها غير متاحة حاليًا. تحقق من عنوان URL وحاول مرة أخرى أو عاود الزيارة لاحقًا. إذا استمرت المشكلة، فاتصل بفريق الدعم. شكرًا لتفهمك.",
    "accounts.smart_upload_beta_label": "(تجريبي)",
    "orders.transaction_direction": "اتجاه المعاملة",
    "Transaction direction": "اتجاه المعاملة",
    "category.default_text": "النص الافتراضي",
    "collections.generator_open": "فتح منشئ المجموعات",
    "Open collection generator": "فتح منشئ المجموعات",
    "collections.duplicate_success": "تم تكرار المجموعة بنجاح",
    "Collection duplicated successfully": "تم تكرار المجموعة بنجاح",
    "collections.duplicate_failed": "فشل تكرار المجموعة",
    "Failed to duplicate collection": "فشل تكرار المجموعة",
    "listings.name_required": "اسم الإعلان مطلوب",
    "Listing Name is required": "اسم الإعلان مطلوب",
    "listings.category_required": "الفئة مطلوبة",
    "Category is required": "الفئة مطلوبة",
    "attribute_groups.edit_title": "تعديل مجموعة السمات",
    "Edit Attribute Group": "تعديل مجموعة السمات",
    "orders.create_order.validation.select_shipping_method": "يرجى تحديد طريقة الشحن",
    "Please select shipping method": "يرجى تحديد طريقة الشحن",
    "orders.create_order.validation.shipping_method_error": "خطأ في طريقة الشحن",
    "Shipping Method Error": "خطأ في طريقة الشحن",
    "orders.create_order.validation.select_shipping_address": "يرجى تحديد عنوان الشحن",
    "Please select shipping address": "يرجى تحديد عنوان الشحن",
    "orders.create_order.validation.shipping_address_error": "خطأ في عنوان الشحن",
    "Shipping Address Error": "خطأ في عنوان الشحن",
    "orders.create_order.validation.select_shipment_method": "يرجى تحديد طريقة الإرسال",
    "Please select shipment method": "يرجى تحديد طريقة الإرسال",
    "orders.create_order.validation.shipment_method_error": "خطأ في طريقة الإرسال",
    "Shipment Method Error": "خطأ في طريقة الإرسال",
    "orders.create_order.validation.select_payment_method": "يرجى تحديد طريقة الدفع",
    "Please select payment method": "يرجى تحديد طريقة الدفع",
    "orders.create_order.validation.payment_method_error": "خطأ في طريقة الدفع",
    "Payment Method Error": "خطأ في طريقة الدفع",
    "orders.create_order.validation.insufficient_balance": "الرصيد غير كافٍ",
    "Insufficient balance": "الرصيد غير كافٍ",
    "orders.create_order.validation.wallet_error": "خطأ في المحفظة",
    "Wallet Error": "خطأ في المحفظة",
    "attributes.value.preview_item": "معاينة {count}",
    "Preview {count}": "معاينة {count}",
    "attributes.value.click_to_upload": "انقر لتحميل {type}",
    "Click to upload {type}": "انقر لتحميل {type}",
    "attributes.value.image_upload_formats": "PNG وJPG وGIF، حتى 5 ملفات",
    "PNG, JPG, GIF up to 5 files": "PNG وJPG وGIF، حتى 5 ملفات",
    "attributes.value.audio_upload_formats": "MP3 وWAV، ملف واحد كحد أقصى",
    "MP3, WAV up to 1 file": "MP3 وWAV، ملف واحد كحد أقصى",
    "attributes.value.video_upload_formats": "MP4 وMOV، ملف واحد كحد أقصى",
    "MP4, MOV up to 1 file": "MP4 وMOV، ملف واحد كحد أقصى",
    "attributes.value.upload_limit": "حمّل ملفات {type} (الحد الأقصى {count})",
    "Upload {type} files (Max {count})": "حمّل ملفات {type} (الحد الأقصى {count})",
    "attributes.value.json_format_failed": "JSON غير صالح، يتعذر تنسيقه",
    "Invalid JSON - cannot format": "JSON غير صالح، يتعذر تنسيقه",
    "attributes.value.json_file_invalid": "يرجى تحديد ملف JSON صالح",
    "Please select a valid JSON file": "يرجى تحديد ملف JSON صالح",
    "attributes.value.file_empty": "الملف فارغ",
    "File is empty": "الملف فارغ",
    "attributes.value.json_file_parse_failed": "ملف JSON غير صالح: {message}",
    "Invalid JSON file: {message}": "ملف JSON غير صالح: {message}",
    "attributes.value.file_read_failed": "تعذرت قراءة الملف",
    "Failed to read file": "تعذرت قراءة الملف",
    "attributes.value.invalid_json": "JSON غير صالح",
    "Invalid JSON": "JSON غير صالح",
    "attributes.value.json_editor_help": "حمّل ملف JSON أو اكتب/الصق محتوى JSON مباشرةً",
    "Upload a JSON file or type/paste JSON directly": "حمّل ملف JSON أو اكتب/الصق محتوى JSON مباشرةً",
    "attributes.value.hex_color_code": "رمز اللون السداسي عشري",
    "Hex Color Code": "رمز اللون السداسي عشري",
    "attributes.value.multi_text_placeholder": "اكتب قيمة ثم اضغط Enter أو الفاصلة لإضافتها",
    "Type and press Enter or comma to add": "اكتب قيمة ثم اضغط Enter أو الفاصلة لإضافتها",
    "attributes.value.multi_text_help": "اضغط Enter أو الفاصلة لإضافة كل عنصر",
    "Press Enter or comma to add each item": "اضغط Enter أو الفاصلة لإضافة كل عنصر",
    "attributes.value.item_count": "{count} عنصر",
    "{count} item": "{count} عنصر",
    "attributes.value.items_count": "{count} عناصر",
    "attributes.value.search_options": "ابحث عن {name}…",
    "Search {name}...": "ابحث عن {name}…",
    "attributes.value.selected_count": "تم تحديد {count}",
    "attributes.value.no_options_found": "لم يتم العثور على خيارات",
    "No options found": "لم يتم العثور على خيارات",
    "attributes.value.select_named_option": "اختر {name}",
    "Select {name}": "اختر {name}",
    "attributes.value.enable_option": "تفعيل هذا الخيار",
    "Enable this option": "تفعيل هذا الخيار",
    "attributes.value.enter_named_value": "أدخل {name}",
    "Enter {name}": "أدخل {name}",
    "common.valid": "صالح",
    "Valid": "صالح",
    "common.invalid": "غير صالح",
    "Invalid": "غير صالح",
    "common.go_back_home": "العودة إلى الصفحة الرئيسية",
    "Go back home": "العودة إلى الصفحة الرئيسية",
    "attributes.value.enter_named_text": "أدخل {name}…",
    "Enter {name}...": "أدخل {name}…",
    "listings.analytics.page_views": "مشاهدات الصفحة",
    "listings.analytics.unique_visitors": "الزوار الفريدون",
    "listings.analytics.sessions": "الجلسات",
    "listings.analytics.clicks": "النقرات",
    "listings.analytics.goals": "الأهداف",
    "listings.analytics.bot_views": "مشاهدات الروبوتات",
    "listings.detail_summary.buyers": "المشترون",
    "Buyers": "المشترون",
    "listings.detail_summary.orders": "الطلبات",
    "listings.detail_summary.revenue": "الإيرادات",
    "listings.detail_summary.average_order": "متوسط الطلب",
    "listings.add_advanced": "متقدم",
    "listings.add_audio": "إضافة محتوى صوتي",
    "Add Audio": "إضافة محتوى صوتي",
    "payments.updated_successfully": "تم التحديث بنجاح",
    "Updated successfully": "تم التحديث بنجاح",
    "users.deleted_successfully": "تم حذف المستخدم بنجاح",
    "User deleted successfully": "تم حذف المستخدم بنجاح",
    "users.deletion_failed": "فشل حذف المستخدم",
    "User deletion failed": "فشل حذف المستخدم",
    "accounts.flow.title": "صمّم تجربة الحسابات",
    "Shape the account experience": "صمّم تجربة الحسابات",
    "accounts.flow.description": "نظّم أنواع الحسابات وحدّد المعلومات التي يحتاجها كل حساب.",
    "Organize account types and define the information each account needs.": "نظّم أنواع الحسابات وحدّد المعلومات التي يحتاجها كل حساب.",
    "accounts.flow.lane_title": "أساسيات الحسابات",
    "Account foundation": "أساسيات الحسابات",
    "accounts.flow.badge": "الهيكل",
    "Structure": "الهيكل",
    "accounts.flow.node_accounts": "الحسابات",
    "accounts.flow.node_categories": "الفئات",
    "accounts.flow.node_attributes": "السمات",
    "accounts.flow.lane_description": "امنح كل حساب فئة ونوعًا ومجموعة واضحة من التفاصيل المفيدة.",
    "Give every account a clear place, type, and set of useful details.": "امنح كل حساب فئة ونوعًا ومجموعة واضحة من التفاصيل المفيدة.",
    "accounts.flow.primary_action": "أضف حسابك الأول",
    "Add your first account": "أضف حسابك الأول",
    "listings.flow.title": "أنشئ كتالوج إعلاناتك",
    "Build your listing catalog": "أنشئ كتالوج إعلاناتك",
    "listings.flow.description": "أنشئ كتالوجًا منظمًا بالفئات والسمات والأنواع المختلفة.",
    "Create a structured catalog with categories, attributes, and variants.": "أنشئ كتالوجًا منظمًا بالفئات والسمات والأنواع المختلفة.",
    "listings.flow.lane_title": "مسار الكتالوج",
    "Catalog path": "مسار الكتالوج",
    "listings.flow.badge": "إنشاء",
    "Build": "إنشاء",
    "listings.flow.node_listings": "الإعلانات",
    "listings.flow.node_categories": "الفئات",
    "listings.flow.node_attributes": "السمات",
    "listings.flow.node_variants": "الأنواع المختلفة",
    "listings.flow.lane_description": "حدّد ما تبيعه والمعلومات التي يحتاجها العملاء لاتخاذ قرارهم.",
    "Define what you sell and the information customers need to make a choice.": "حدّد ما تبيعه والمعلومات التي يحتاجها العملاء لاتخاذ قرارهم.",
    "listings.flow.primary_action": "أضف إعلانك الأول",
    "Add your first listing": "أضف إعلانك الأول",
    "collections.flow.title": "اجمع محتوى سوقك في مكان واحد",
    "Bring your marketplace content together": "اجمع محتوى سوقك في مكان واحد",
    "collections.flow.description": "اجمع الإعلانات والحسابات في مجموعات يسهل اكتشافها وإدارتها.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "اجمع الإعلانات والحسابات في مجموعات يسهل اكتشافها وإدارتها.",
    "collections.flow.lane_title": "مسار المجموعات",
    "Collection path": "مسار المجموعات",
    "collections.flow.badge": "تنسيق",
    "Curate": "تنسيق",
    "collections.flow.node_collections": "المجموعات",
    "collections.flow.node_rules": "القواعد",
    "collections.flow.node_listings": "الإعلانات",
    "collections.flow.lane_description": "اختر العناصر التي تنتمي معًا واجعل العثور عليها سهلًا للعملاء.",
    "Choose what belongs together and make it easy for customers to find.": "اختر العناصر التي تنتمي معًا واجعل العثور عليها سهلًا للعملاء.",
    "collections.flow.audience_lane_title": "مسار الجمهور",
    "Audience path": "مسار الجمهور",
    "collections.flow.audience_badge": "ربط",
    "collections.flow.node_accounts": "الحسابات",
    "collections.flow.node_users": "المستخدمون",
    "collections.flow.node_storefront": "واجهة المتجر",
    "Storefront": "واجهة المتجر",
    "collections.flow.audience_description": "اربط المحتوى المنسق بالأشخاص وواجهات المتاجر المناسبة له.",
    "Connect curated content to the people and storefronts it is meant for.": "اربط المحتوى المنسق بالأشخاص وواجهات المتاجر المناسبة له.",
    "collections.flow.primary_action": "أنشئ مجموعتك الأولى",
    "listings.addon.image_limit": "لا يمكنك اختيار مزيد من الصور.",
    "listings.schedule.start_time_before_end": "يجب أن يسبق وقت البدء وقت الانتهاء.",
    "Start time must be before the end time": "يجب أن يسبق وقت البدء وقت الانتهاء.",
    "listings.schedule.end_time_after_start": "يجب أن يأتي وقت الانتهاء بعد وقت البدء.",
    "End time must be after the start time": "يجب أن يأتي وقت الانتهاء بعد وقت البدء.",
    "listings.schedule.repeat_required": "اختر نمط التكرار.",
    "Select a repeat pattern": "اختر نمط التكرار.",
    "listing_variants.form.select_type": "اختر نوع المتغير",
    "Select variant type": "اختر نوع المتغير",
    "listing_variants.form.select_type_values": "اختر قيم المتغير",
    "Select variant values": "اختر قيم المتغير",
    "listing_variants.form.add_variant": "إضافة متغير",
    "listing_variants.form.edit_variant": "تعديل المتغير",
    "Edit variant": "تعديل المتغير",
    "listing_variants.form.variant_type": "نوع المتغير",
    "Variant type": "نوع المتغير",
    "listing_variants.form.variant_type_value": "قيمة المتغير",
    "Variant value": "قيمة المتغير",
    "listing_variants.form.variant_name": "اسم المتغير",
    "Variant name": "اسم المتغير",
    "listing_variants.form.description_placeholder": "أدخل الوصف",
    "rewards.item_archived": "تمت الأرشفة",
    "listings.confirm_delete_variant": "هل تريد حذف هذا المتغير؟",
    "listings.confirm_delete_listing": "هل تريد حذف هذا الإعلان؟",
    "listing_form.digital_delete_confirm": "هل تريد حذف هذا المحتوى الرقمي؟",
    "Are you sure you want to delete this digital content?": "هل تريد حذف هذا المحتوى الرقمي؟",
    "category.confirm_delete_attribute": "هل تريد حذف هذه السمة؟",
    "common.permission_required": "ليس لديك إذن لتنفيذ هذا الإجراء.",
    "You do not have permission to perform this action.": "ليس لديك إذن لتنفيذ هذا الإجراء.",
    "common.copied": "تم النسخ",
    "attributes.editor_name_required": "أدخل اسم السمة",
    "onboarding.full_step.setup_payments.description": "فعّل المعاملات الفعلية ليتمكن المستخدمون من إتمام عملياتهم بسهولة.",
    "Enable real transactions so users can complete intent without friction.": "فعّل المعاملات الفعلية ليتمكن المستخدمون من إتمام عملياتهم بسهولة.",
    "onboarding.full_step.setup_payments.cta": "إعداد المدفوعات",
    "Setup payments": "إعداد المدفوعات",
    "onboarding.full_step.setup_payments.impact": "تم تفعيل مسار الإيرادات.",
    "Revenue path enabled.": "تم تفعيل مسار الإيرادات.",
    "onboarding.full_step.setup_payments.creator_description": "جهّز مسارًا يتيح لجمهورك شراء عملك أو دعمه.",
    "Prepare the path for your audience to purchase or support your work.": "جهّز مسارًا يتيح لجمهورك شراء عملك أو دعمه.",
    "onboarding.full_step.setup_delivery.description": "حدّد طريقة تنفيذ الطلبات ليكون إتمام الشراء واضحًا للمستخدمين.",
    "onboarding.full_step.setup_delivery.impact": "أصبحت طريقة تنفيذ الطلبات واضحة.",
    "Fulfillment path clear.": "أصبحت طريقة تنفيذ الطلبات واضحة.",
    "onboarding.full_step.add_promotion.description": "أنشئ أول عرض ترويجي لزيادة التفاعل في الزيارة الأولى.",
    "Create your first promotion to increase first-session action rate.": "أنشئ أول عرض ترويجي لزيادة التفاعل في الزيارة الأولى.",
    "onboarding.full_step.add_promotion.impact": "عزّز التحويل عند الإطلاق.",
    "Stronger conversion during launch.": "عزّز التحويل عند الإطلاق.",
    "onboarding.full_step.create_coupon.description": "اختبر الخصومات وشجّع المشترين الجدد أو الأعضاء على التفاعل.",
    "Test discounts and improve activation for first-time buyers or members.": "اختبر الخصومات وشجّع المشترين الجدد أو الأعضاء على التفاعل.",
    "onboarding.full_step.create_coupon.impact": "أُتيحت دورة العرض الأول.",
    "First-offer loop unlocked.": "أُتيحت دورة العرض الأول.",
    "onboarding.full_step.collections_setup.description": "نظّم الإعلانات التي تحظى باهتمام كبير لتسهيل اكتشافها وتصفحها.",
    "Organize high-intent listings to improve discovery and browsing flow.": "نظّم الإعلانات التي تحظى باهتمام كبير لتسهيل اكتشافها وتصفحها.",
    "onboarding.full_step.collections_setup.impact": "تحسّن التصفح والاكتشاف.",
    "Navigation and discovery improved.": "تحسّن التصفح والاكتشاف.",
    "onboarding.full_step.configure_comms.description": "جهّز إشعارات التسجيل والطلبات قبل تنمية نشاطك.",
    "Make post-signup and order notifications production-ready before growth.": "جهّز إشعارات التسجيل والطلبات قبل تنمية نشاطك.",
    "onboarding.full_step.configure_comms.impact": "أصبحت رسائل مراحل رحلة العميل جاهزة.",
    "Lifecycle messaging ready.": "أصبحت رسائل مراحل رحلة العميل جاهزة.",
    "onboarding.full_step.customize_attributes.description": "أضف حقولًا منظمة ليتمكن المستخدمون من تصفية العناصر المهمة ومقارنتها.",
    "onboarding.full_step.customize_attributes.impact": "حسّن البحث والتحويل.",
    "Better search and conversion.": "حسّن البحث والتحويل.",
    "onboarding.full_step.customize_attributes.creator_description": "أضف التفاصيل التي تساعد جمهورك على فهم ما تقدمه ومقارنته.",
    "Add the details that help people understand and compare what you create.": "أضف التفاصيل التي تساعد جمهورك على فهم ما تقدمه ومقارنته.",
    "onboarding.full_step.add_digital_asset.description": "وسّع كتالوجك الأولي ليتمكن المستخدمون من تقييم الجودة والتنوع.",
    "Expand initial catalog so users can evaluate quality and assortment.": "وسّع كتالوجك الأولي ليتمكن المستخدمون من تقييم الجودة والتنوع.",
    "onboarding.full_step.add_digital_asset.impact": "تعزّزت مصداقية الكتالوج الرقمي.",
    "Digital catalog credibility improved.": "تعزّزت مصداقية الكتالوج الرقمي.",
    "onboarding.full_step.open_live_site.description": "ابدأ بما يراه العملاء. فهذا يجعل المنتج ملموسًا قبل أن يصبح الإعداد نظريًا.",
    "onboarding.full_step.open_live_site.impact": "تأكد من أن المشروع متاح بالفعل.",
    "onboarding.full_step.add_first_product.description": "انشر أول منتج أو خدمة أو مورد تريد أن يكتشفه جمهورك.",
    "Publish the first product, service, or resource you want your audience to discover.": "انشر أول منتج أو خدمة أو مورد تريد أن يكتشفه جمهورك.",
    "onboarding.full_step.add_first_product.impact": "أنشئ أول عرض جاهز لتقديمه إلى جمهورك.",
    "Creates your first audience-ready offer.": "أنشئ أول عرض جاهز لتقديمه إلى جمهورك.",
    "onboarding.full_step.customize_attributes.creator_impact": "اجعل عرضك أسهل فهمًا.",
    "Makes your offer easier to understand.": "اجعل عرضك أسهل فهمًا.",
    "onboarding.full_step.setup_payments.creator_impact": "افتح الطريق لتحقيق الإيرادات.",
    "listings.detail_preview_fx.title": "معاينة العملات",
    "Preview FX": "معاينة العملات",
    "listings.detail_preview_fx.base": "العملة الأساسية",
    "Base": "العملة الأساسية",
    "listings.detail_preview_fx.description": "اعرض هذا الإعلان بكل عملة نشطة.",
    "See this listing in each active currency.": "اعرض هذا الإعلان بكل عملة نشطة.",
    "listings.detail_preview_fx.refresh": "تحديث المعاينة",
    "Refresh preview": "تحديث المعاينة",
    "listings.detail_preview_fx.loading_rates": "جارٍ تحميل أسعار الصرف…",
    "Loading exchange rates…": "جارٍ تحميل أسعار الصرف…",
    "listings.detail_preview_fx.load_hint": "اختر معاينة العملات لتحميل الأسعار الحالية.",
    "Select Preview FX to load current rates.": "اختر معاينة العملات لتحميل الأسعار الحالية.",
    "listings.detail_preview_fx.preview_note": "هذه معاينة فقط. لن تتغير أسعار الإعلان المحفوظة.",
    "Preview only. Saved listing prices remain unchanged.": "هذه معاينة فقط. لن تتغير أسعار الإعلان المحفوظة.",
    "listings.detail_preview_fx.listing": "إعلان",
    "listings.detail_preview_fx.variant": "متغير",
    "Variant": "متغير",
    "listings.detail_event_booking.event_details": "تفاصيل الفعالية",
    "Event Details": "تفاصيل الفعالية",
    "listings.detail_event_booking.booking_details": "تفاصيل الحجز",
    "Booking Details": "تفاصيل الحجز",
    "listings.unassigned_location": "موقع غير معيّن",
    "Unassigned location": "موقع غير معيّن",
    "listings.no_ratings_yet": "لا توجد تقييمات بعد",
    "No ratings yet": "لا توجد تقييمات بعد",
    "listing_form.loading_listing": "جارٍ تحميل الإعلان…",
    "Loading listing…": "جارٍ تحميل الإعلان…",
    "listing_form.preparing_form": "جارٍ إعداد النموذج…",
    "Preparing form…": "جارٍ إعداد النموذج…",
    "listing_form.edit_listing": "تعديل الإعلان",
    "Edit Listing": "تعديل الإعلان",
    "listing_form.add_new_listing": "إضافة إعلان جديد",
    "Add New Listing": "إضافة إعلان جديد",
    "workspace.catalog.templates": "القوالب",
    "Templates": "القوالب",
    "workspace.catalog.integrations": "التكاملات",
    "workspace.catalog.template": "قالب",
    "Template": "قالب",
    "workspace.catalog.integration": "تكامل",
    "workspace.catalog.templates_heading": "اختر قالبًا للانطلاق بفكرتك",
    "Choose a template to kickstart your Idea": "اختر قالبًا للانطلاق بفكرتك",
    "workspace.catalog.integrations_heading": "تكاملات لتطبيقات الويب المستضافة",
    "Integrations for Hosted Web Apps": "تكاملات لتطبيقات الويب المستضافة",
    "workspace.catalog.templates_description": "ابدأ بقالب جاهز وخصصه ليناسب منصتك.",
    "Start with a prebuilt template and customise it for your marketplace.": "ابدأ بقالب جاهز وخصصه ليناسب منصتك.",
    "workspace.catalog.integrations_description": "اربط مساحة عملك بالأدوات والخدمات التي تستخدمها بالفعل.",
    "Connect your workspace to the tools and services you already use.": "اربط مساحة عملك بالأدوات والخدمات التي تستخدمها بالفعل.",
    "workspace.catalog.no_templates": "لا تتوفر قوالب في الوقت الحالي.",
    "No templates available at the moment.": "لا تتوفر قوالب في الوقت الحالي.",
    "workspace.catalog.no_integrations": "لا تتوفر تكاملات في الوقت الحالي.",
    "No integrations available at the moment.": "لا تتوفر تكاملات في الوقت الحالي.",
    "workspace.catalog.coming_soon": "قريبًا",
    "Coming Soon": "قريبًا",
    "workspace.catalog.configure": "إعداد",
    "workspace.catalog.custom_development": "تطوير مخصص لـ {type}",
    "Custom {type} Development": "تطوير مخصص لـ {type}",
    "workspace.catalog.custom_help": "هل تبحث عن حل مخصص؟ تواصل معنا للحصول على عرض سعر.",
    "Looking for something custom? Contact us for a quote.": "هل تبحث عن حل مخصص؟ تواصل معنا للحصول على عرض سعر.",
    "workspace.catalog.contact_quote": "اطلب عرض سعر",
    "Contact for a Quote": "اطلب عرض سعر",
    "users.select_user": "اختر مستخدمًا",
    "Select User": "اختر مستخدمًا",
    "developer.api_keys.paid_feature_title": "الوصول إلى API ميزة مدفوعة",
    "API access is a paid feature": "الوصول إلى API ميزة مدفوعة",
    "developer.api_keys.paid_feature_description": "اختر خطة مدفوعة لعرض مفاتيح النشر والمفتاح السري ونسخها واستخدامها.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "اختر خطة مدفوعة لعرض مفاتيح النشر والمفتاح السري ونسخها واستخدامها.",
    "developer.api_keys.available_on_paid_plans": "متاح ضمن الخطط المدفوعة",
    "Available on paid plans": "متاح ضمن الخطط المدفوعة",
    "developer.api_keys.view_plans": "عرض الخطط",
    "currency.rates.title": "أسعار الصرف الحالية",
    "Current FX rates": "أسعار الصرف الحالية",
    "currency.rates.base": "العملة الأساسية:",
    "Base:": "العملة الأساسية:",
    "currency.rates.source": "· المصدر:",
    "· Source:": "· المصدر:",
    "currency.rates.cached_up_to": "مخزنة مؤقتًا لمدة تصل إلى {hours} ساعة",
    "Cached up to {hours}h": "مخزنة مؤقتًا لمدة تصل إلى {hours} ساعة",
    "currency.rates.refresh": "تحديث الأسعار",
    "Refresh rates": "تحديث الأسعار",
    "currency.rates.currency": "العملة",
    "currency.rates.one_base_equals": "كل 1 {code} يساوي",
    "1 {code} equals": "كل 1 {code} يساوي",
    "currency.rates.empty": "أضف عملة نشطة لعرض سعر الصرف الخاص بها.",
    "Add an active currency to see its exchange rate.": "أضف عملة نشطة لعرض سعر الصرف الخاص بها.",
    "currency.rates.manual": "أسعار يدوية",
    "Manual rates": "أسعار يدوية",
    "currency.rates.load_error": "تعذر تحميل أسعار الصرف.",
    "Unable to load exchange rates.": "تعذر تحميل أسعار الصرف.",
    "chats.title": "محادثات العملاء",
    "Customer chat": "محادثات العملاء",
    "chats.conversations": "المحادثات",
    "Conversations": "المحادثات",
    "chats.empty_conversations": "لا توجد محادثات مع العملاء بعد.",
    "No customer conversations yet.": "لا توجد محادثات مع العملاء بعد.",
    "chats.customer_id": "العميل {id}",
    "Customer {id}": "العميل {id}",
    "chats.no_messages_yet": "لا توجد رسائل بعد",
    "No messages yet": "لا توجد رسائل بعد",
    "chats.conversation_id": "المحادثة رقم {id}",
    "Conversation #{id}": "المحادثة رقم {id}",
    "chats.status.closed": "مغلقة",
    "closed": "مغلقة",
    "chats.status.open": "مفتوحة",
    "chats.reopen": "Réouvrir",
    "Reopen": "Réouvrir",
    "chats.close_conversation": "إغلاق المحادثة",
    "Close conversation": "إغلاق المحادثة",
    "chats.your_team": "فريقك",
    "Your team": "فريقك",
    "chats.empty_messages": "لا توجد رسائل في هذه المحادثة بعد.",
    "No messages in this conversation yet.": "لا توجد رسائل في هذه المحادثة بعد.",
    "chats.write_reply": "اكتب ردًا",
    "Write a reply": "اكتب ردًا",
    "chats.send": "إرسال",
    "Send": "إرسال",
    "chats.select_conversation": "اختر محادثة لعرض رسائلها.",
    "Select a conversation to view its messages.": "اختر محادثة لعرض رسائلها.",
    "chats.error.session_not_ready": "جلستك غير جاهزة. حدّث الصفحة ثم حاول مرة أخرى.",
    "Your session is not ready. Refresh the page and try again.": "جلستك غير جاهزة. حدّث الصفحة ثم حاول مرة أخرى.",
    "chats.error.request_failed": "فشل طلب المحادثة ({status})",
    "Chat request failed ({status})": "فشل طلب المحادثة ({status})",
    "chats.error.load_conversations": "تعذر تحميل المحادثات.",
    "Could not load conversations.": "تعذر تحميل المحادثات.",
    "chats.error.load_messages": "تعذر تحميل الرسائل.",
    "Could not load messages.": "تعذر تحميل الرسائل.",
    "chats.error.send_message": "تعذر إرسال الرسالة.",
    "Message could not be sent.": "تعذر إرسال الرسالة.",
    "chats.error.update_status": "تعذر تحديث حالة المحادثة.",
    "Conversation status could not be updated.": "تعذر تحديث حالة المحادثة.",
    "accounts.select_account": "اختر حسابًا",
    "common.accounts": "الحسابات",
    "common.listings": "القوائم",
    "communications.loading_preview": "جارٍ تحميل المعاينة…",
    "Loading preview…": "جارٍ تحميل المعاينة…",
    "communications.no_preview": "لا توجد معاينة",
    "No preview": "لا توجد معاينة",
    "collections.choose_type": "اختر {type}",
    "Choose {type}": "اختر {type}",
    "collections.create_type_category_first": "أنشئ فئة {type} أولًا",
    "Create {type} category first": "أنشئ فئة {type} أولًا",
    "web_config.customisation": "تخصيص الموقع الإلكتروني",
    "web_config.configuration": "إعدادات الموقع الإلكتروني",
    "Web Configuration": "إعدادات الموقع الإلكتروني",
    "web_config.section_general": "عام",
    "web_config.section_social": "التواصل الاجتماعي",
    "web_config.section_footer": "تذييل الصفحة",
    "web_config.assets": "الأصول",
    "Assets": "الأصول",
    "web_config.small_logo": "الشعار المصغّر",
    "Small logo": "الشعار المصغّر",
    "attributes.edit_attribute": "تعديل السمة",
    "currency.rate_managed_automatically": "يُدار السعر تلقائيًا.",
    "Rate is managed automatically.": "يُدار السعر تلقائيًا.",
    "navigation.add_or_manage_mini_apps": "إضافة التطبيقات المصغرة أو إدارتها",
    "Add or manage Mini Apps": "إضافة التطبيقات المصغرة أو إدارتها",
    "listings.import.download_type_template": "تنزيل قالب {type}",
    "navigation.promo_banner": "احصل على خصم {percent}% للعملاء الجدد فقط. استخدم الرمز: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "احصل على خصم {percent}% للعملاء الجدد فقط. استخدم الرمز: {code}.",
    "orders.cash_refund_recorded": "تم تسجيل رد المبلغ نقدًا. أُضيفت عملية القيد المحاسبي العكسية إلى قائمة الانتظار.",
    "Cash refund recorded. The accounting reversal has been queued.": "تم تسجيل رد المبلغ نقدًا. أُضيفت عملية القيد المحاسبي العكسية إلى قائمة الانتظار.",
    "orders.cash_refund_failed": "تعذر تسجيل رد المبلغ نقدًا. تحقق من حالة دفع الطلب وسجل المبالغ المستردة.",
    "Could not record the cash refund. Check the order payment status and refund history.": "تعذر تسجيل رد المبلغ نقدًا. تحقق من حالة دفع الطلب وسجل المبالغ المستردة.",
    "orders.recording_cash_refund": "جارٍ تسجيل المبلغ المسترد…",
    "Recording refund…": "جارٍ تسجيل المبلغ المسترد…",
    "orders.record_cash_refund": "تسجيل رد المبلغ نقدًا",
    "Record cash refund": "تسجيل رد المبلغ نقدًا",
    "orders.confirm_cash_refund": "تأكيد رد المبلغ نقدًا",
    "Confirm cash refund": "تأكيد رد المبلغ نقدًا",
    "orders.cash_refund_order_amount": "هل تريد تسجيل رد كامل بقيمة {amount} نقدًا للطلب {reference}؟",
    "Record a full cash refund of {amount} for order {reference}?": "هل تريد تسجيل رد كامل بقيمة {amount} نقدًا للطلب {reference}؟",
    "orders.cash_refund_manual_notice": "يسجل هذا ردًا يدويًا نقديًا أو عند التسليم ويضيف القيد المحاسبي العكسي إلى قائمة الانتظار. لن يتم التواصل مع أي مزود دفع.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "يسجل هذا ردًا يدويًا نقديًا أو عند التسليم ويضيف القيد المحاسبي العكسي إلى قائمة الانتظار. لن يتم التواصل مع أي مزود دفع.",
    "currency_conversion.title": "تحويل العملات",
    "Currency conversion": "تحويل العملات",
    "currency_conversion.open_settings": "إعدادات التحويل",
    "Conversion settings": "إعدادات التحويل",
    "currency_conversion.load_failed": "تعذر تحميل إعدادات تحويل العملات.",
    "Could not load currency conversion settings.": "تعذر تحميل إعدادات تحويل العملات.",
    "currency_conversion.interval_error": "يجب أن تتراوح فترة التحديث بين 5 دقائق و24 ساعة.",
    "Refresh interval must be between 5 minutes and 24 hours.": "يجب أن تتراوح فترة التحديث بين 5 دقائق و24 ساعة.",
    "currency_conversion.save_failed": "تعذر حفظ إعدادات تحويل العملات.",
    "Could not save currency conversion settings.": "تعذر حفظ إعدادات تحويل العملات.",
    "currency_conversion.saved": "تم حفظ إعدادات تحويل العملات.",
    "Currency conversion settings saved.": "تم حفظ إعدادات تحويل العملات.",
    "currency_conversion.description": "اختر طريقة حساب تحويلات العملات المعروضة.",
    "Choose how displayed currency conversions are calculated.": "اختر طريقة حساب تحويلات العملات المعروضة.",
    "currency_conversion.manual_title": "أسعار يدوية",
    "currency_conversion.manual_help": "استخدم سعر الصرف المُدخل لكل عملة أدناه.",
    "Use the exchange rate entered for each currency below.": "استخدم سعر الصرف المُدخل لكل عملة أدناه.",
    "currency_conversion.frankfurter_title": "Frankfurter (افتراضي)",
    "Frankfurter (default)": "Frankfurter (افتراضي)",
    "currency_conversion.frankfurter_help": "أسعار صرف يومية مجانية. لا يلزم مفتاح API لمزود الخدمة.",
    "Free daily exchange rates. No provider API key is required.": "أسعار صرف يومية مجانية. لا يلزم مفتاح API لمزود الخدمة.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "استخدم خدمة Fixer التي تديرها المنصة. تعتمد تحديثات الأسعار على خطة المزود.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "استخدم خدمة Fixer التي تديرها المنصة. تعتمد تحديثات الأسعار على خطة المزود.",
    "currency_conversion.refresh_interval": "فترة إعادة التحقق من السعر (بالدقائق)",
    "Rate re-check interval (minutes)": "فترة إعادة التحقق من السعر (بالدقائق)",
    "workspace.currency_search_code": "ابحث أو اختر",
    "Search or select": "ابحث أو اختر",
    "workspace.currency_preset_hint": "تم تطبيق القيم الافتراضية المقترحة. يمكنك تعديل أي حقل.",
    "Recommended defaults applied. You can edit any field.": "تم تطبيق القيم الافتراضية المقترحة. يمكنك تعديل أي حقل.",
    "developer.api_keys.copy_unavailable": "المفتاح غير متاح بعد.",
    "Key is not available yet.": "المفتاح غير متاح بعد.",
    "developer.api_keys.copy_failed": "تعذر نسخ المفتاح. حاول مرة أخرى.",
    "Unable to copy the key. Try again.": "تعذر نسخ المفتاح. حاول مرة أخرى.",
    "payroll.action.export_pdf": "تصدير PDF",
    "Export PDF": "تصدير PDF",
    "cms.category.name_prompt": "اسم الفئة",
    "cms.field.cover_image": "صورة الغلاف",
    "Cover Image": "صورة الغلاف",
    "cms.action.add_cover_photo": "إضافة صورة غلاف",
    "Add cover photo": "إضافة صورة غلاف",
    "cms.field.category": "الفئة",
    "cms.category.none": "بلا فئة",
    "No category": "بلا فئة",
    "cms.advanced": "متقدم",
    "media_picker.action.select_image": "اختر صورة",
    "Select image": "اختر صورة",
    "orders.confirm_record_cash_refund": "تسجيل المبلغ المسترد",
    "Record refund": "تسجيل المبلغ المسترد",
    "listing_form.no_repeat": "بدون تكرار",
    "No repeat": "بدون تكرار",
    "listing_form.custom_repeat_days": "مخصص: {days}",
    "Custom: {days}": "مخصص: {days}",
    "common.sending": "جارٍ الإرسال…",
    "listings.detail.unique_name": "الاسم الفريد",
    "Unique Name": "الاسم الفريد",
    "app_customization.username": "اسم المستخدم",
    "workspace.templates.name_required": "اسم القالب مطلوب.",
    "Template name is required.": "اسم القالب مطلوب.",
    "workspace.templates.saved": "تم حفظ قالب الأدوار.",
    "Role template saved.": "تم حفظ قالب الأدوار.",
    "workspace.templates.confirm_delete": "هل تريد حذف القالب \"{name}\"؟",
    "Delete template \"{name}\"?": "هل تريد حذف القالب \"{name}\"؟",
    "workspace.templates.deleted": "تم حذف القالب.",
    "Template deleted.": "تم حذف القالب.",
    "workspace.members.tab_members": "الأعضاء",
    "workspace.templates.tab": "قوالب الأدوار",
    "Role Templates": "قوالب الأدوار",
    "workspace.templates.title": "قوالب الأدوار",
    "workspace.templates.new": "قالب جديد",
    "New Template": "قالب جديد",
    "workspace.templates.name": "الاسم",
    "workspace.templates.empty": "لا توجد قوالب أدوار حتى الآن.",
    "No role templates yet.": "لا توجد قوالب أدوار حتى الآن.",
    "workspace.templates.edit": "تعديل القالب",
    "Edit Template": "تعديل القالب",
    "workspace.templates.name_label": "اسم القالب",
    "Template name": "اسم القالب",
    "workspace.templates.name_placeholder": "مثال: مدير المحتوى",
    "e.g. Content Manager": "مثال: مدير المحتوى",
    "listings.import.unknown_error": "تعذر استيراد الفئات. تحقق من ملف CSV ثم حاول مرة أخرى.",
    "The categories could not be imported. Please check the CSV and try again.": "تعذر استيراد الفئات. تحقق من ملف CSV ثم حاول مرة أخرى.",
    "common.no_access_to_page": "لا تملك صلاحية الوصول",
    "No access": "لا تملك صلاحية الوصول",
    "common.permission_to_view_page_denied": "ليس لديك إذن لعرض هذه الصفحة.",
    "You do not have permission to view this page.": "ليس لديك إذن لعرض هذه الصفحة.",
    "common.loading_permissions": "جارٍ تحميل الأذونات…",
    "Loading permissions…": "جارٍ تحميل الأذونات…",
    "attributes.added_successfully": "تمت إضافة السمات بنجاح 🎉",
    "Nice 🎉, Successfully added attributes": "تمت إضافة السمات بنجاح 🎉",
    "attributes.add_attribute_values": "إضافة قيم السمة",
    "attributes.attribute": "السمة",
    "attributes.optional": "اختياري",
    "attributes.private": "خاص",
    "attributes.hidden_field": "حقل مخفي",
    "attributes.show_in_filter": "إظهار في عوامل التصفية",
    "attributes.status_not_active_active": "الحالة (غير نشط / نشط)",
    "attributes.add_metadata": "إضافة بيانات وصفية",
    "Add metadata": "إضافة بيانات وصفية",
    "attributes.select_date_time": "اختر التاريخ والوقت",
    "listings.addons.column_title": "العنوان",
    "listings.addons.column_image": "الصورة",
    "listings.addons.column_price": "السعر",
    "listings.addons.column_max_quantity": "الكمية القصوى",
    "Max Quantity": "الكمية القصوى",
    "listings.addons.column_offer": "العرض",
    "listings.addons.column_stock": "المخزون",
    "listings.addons.column_action": "الإجراء",
    "listings.addons.column_status": "الحالة",
    "listings.addons.confirm_delete": "هل تريد حذف هذا النوع من الإضافات؟",
    "Do you want to delete this add-on type?": "هل تريد حذف هذا النوع من الإضافات؟",
    "common.share_collection": "مشاركة المجموعة",
    "Share collection": "مشاركة المجموعة",
    "communications.view_modes": "أنماط عرض الاتصالات",
    "Communication view modes": "أنماط عرض الاتصالات",
    "payments.accessibility.gateway_logo": "شعار بوابة الدفع",
    "Payment gateway logo": "شعار بوابة الدفع",
    "common.build_version": "إصدار البناء",
    "Build version": "إصدار البناء",
    "common.build_label": "إصدار البناء",
    "build": "إصدار البناء",
    "listings.under_category_title": "القوائم ضمن الفئة {category}",
    "Listings under {category}": "القوائم ضمن الفئة {category}",
    "attributes.signup": "التسجيل",
    "Signup": "التسجيل",
    "common.toast.please_check_action": "يرجى التحقق من هذا الإجراء.",
    "Please check this action": "يرجى التحقق من هذا الإجراء.",
    "common.information": "معلومات",
    "listing_form.error.load_listing_data": "تعذر تحميل بيانات القائمة.",
    "Failed to load listing data": "تعذر تحميل بيانات القائمة.",
    "listing_form.error.load_digital_contents": "تعذر تحميل المحتوى الرقمي.",
    "Failed to load digital contents": "تعذر تحميل المحتوى الرقمي.",
    "listing_form.validation.audio_file_or_url_required": "أضف ملفًا صوتيًا أو رابطًا صوتيًا عامًا قبل إنشاء الحلقة.",
    "Add an audio file or public audio URL before creating the episode.": "أضف ملفًا صوتيًا أو رابطًا صوتيًا عامًا قبل إنشاء الحلقة.",
    "listing_form.validation.rental_rate_greater_than_zero": "أدخل سعر إيجار أكبر من 0.",
    "Enter a rental rate greater than 0.": "أدخل سعر إيجار أكبر من 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "يجب أن تكون المدة القصوى أكبر من المدة الدنيا أو مساوية لها.",
    "Maximum duration must be greater than or equal to minimum duration.": "يجب أن تكون المدة القصوى أكبر من المدة الدنيا أو مساوية لها.",
    "listing_form.updated_successfully": "تم تحديث القائمة بنجاح.",
    "Listing updated successfully!": "تم تحديث القائمة بنجاح.",
    "listing_form.created_successfully": "تم إنشاء القائمة بنجاح.",
    "Listing created successfully!": "تم إنشاء القائمة بنجاح.",
    "listing_form.error.save_failed": "تعذر حفظ القائمة. حاول مرة أخرى.",
    "Failed to save listing. Please try again.": "تعذر حفظ القائمة. حاول مرة أخرى.",
    "listing_form.error.delete_variant_failed": "تعذر حذف الخيار: {title}",
    "Failed to delete variant: {title}": "تعذر حذف الخيار: {title}",
    "listing_form.error.variant_action_failed": "تعذر {action} الخيار: {title}",
    "Failed to {action} variant: {title}": "تعذر {action} الخيار: {title}",
    "listing_form.error.digital_content_action_failed": "تعذر {action} المحتوى الرقمي: {title}",
    "Failed to {action} digital content: {title}": "تعذر {action} المحتوى الرقمي: {title}",
    "listing_form.action.create": "إنشاء",
    "listing_form.action.update": "تحديث",
    "listing_form.action.delete": "حذف",
    "delete": "حذف",
    "listing_form.error.save_request_failed": "تعذر حفظ القائمة.",
    "Failed to save listing": "تعذر حفظ القائمة.",
    "listing_form.error.rental_settings_save_failed": "تم حفظ القائمة، ولكن تعذر حفظ إعدادات الإيجار.",
    "Listing saved, but rental settings could not be saved.": "تم حفظ القائمة، ولكن تعذر حفظ إعدادات الإيجار.",
    "users.action_failed": "تعذر تنفيذ الإجراء. حاول مرة أخرى.",
    "Action failed. Please try again.": "تعذر تنفيذ الإجراء. حاول مرة أخرى.",
    "common.successfully_added": "تمت الإضافة بنجاح",
    "Successfully added": "تمت الإضافة بنجاح",
    "listing_form.validation.title_min_length": "يجب ألا يقل العنوان عن {count} أحرف.",
    "Title must be at least {count} characters": "يجب ألا يقل العنوان عن {count} أحرف.",
    "listing_form.validation.title_max_length": "يجب ألا يتجاوز العنوان {count} حرفًا.",
    "Title must not exceed {count} characters": "يجب ألا يتجاوز العنوان {count} حرفًا.",
    "listing_form.validation.price_minimum": "يجب ألا يقل السعر عن {amount}.",
    "Price must be at least {amount}": "يجب ألا يقل السعر عن {amount}.",
    "listing_form.validation.attribute_required": "{attribute} مطلوب.",
    "listings.error.load_failed": "تعذر تحميل القوائم.",
    "Unable to load listings": "تعذر تحميل القوائم.",
    "communications.from_email_required_before_verification": "أدخل عنوان البريد الإلكتروني للمرسل قبل التحقق.",
    "Please enter From email address before verifying.": "أدخل عنوان البريد الإلكتروني للمرسل قبل التحقق.",
    "communications.verification_email_sent": "تم إرسال رسالة تحقق. تحقق من صندوق الوارد واتبع التعليمات لتأكيد عنوان البريد الإلكتروني.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "تم إرسال رسالة تحقق. تحقق من صندوق الوارد واتبع التعليمات لتأكيد عنوان البريد الإلكتروني.",
    "communications.verification_start_failed": "تعذر بدء التحقق. حاول مرة أخرى.",
    "Unable to start verification. Please try again.": "تعذر بدء التحقق. حاول مرة أخرى.",
    "common.uploaded_successfully": "تمت العملية بنجاح",
    "upgrade_page.panel.yearly": "سنوي",
    "upgrade_page.panel.monthly": "شهري",
    "orders.advance_paid": "الدفعة المقدمة المدفوعة",
    "Advance paid": "الدفعة المقدمة المدفوعة",
    "orders.balance_due": "الرصيد المستحق",
    "Balance due": "الرصيد المستحق",
    "orders.advance_invalid": "أدخل مبلغًا أقل من إجمالي الطلب.",
    "Enter an amount less than the order total.": "أدخل مبلغًا أقل من إجمالي الطلب.",
    "orders.advance_failed": "تعذّر حفظ الدفعة المقدمة.",
    "Could not save the advance.": "تعذّر حفظ الدفعة المقدمة.",
    "orders.edit_advance": "تعديل الدفعة المقدمة",
    "Edit advance": "تعديل الدفعة المقدمة",
    "orders.record_advance": "تسجيل دفعة مقدمة",
    "Record advance": "تسجيل دفعة مقدمة",
    "orders.advance_notice": "المبلغ الذي دفعه العميل حتى الآن، ويجب أن يكون أقل من إجمالي الطلب البالغ {total}. يظل الطلب غير مدفوع حتى تحدد الرصيد على أنه مدفوع. أدخل 0 لإزالة الدفعة المقدمة.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "المبلغ الذي دفعه العميل حتى الآن، ويجب أن يكون أقل من إجمالي الطلب البالغ {total}. يظل الطلب غير مدفوع حتى تحدد الرصيد على أنه مدفوع. أدخل 0 لإزالة الدفعة المقدمة.",
    "orders.save_advance": "حفظ",
    "common.hide": "إخفاء",
    "listings.repeat.daily": "يوميًا",
    "listings.repeat.weekdays": "أيام الأسبوع (الاثنين إلى الجمعة)",
    "Weekdays (Mon-Fri)": "أيام الأسبوع (الاثنين إلى الجمعة)",
    "listings.repeat.weekend": "عطلة نهاية الأسبوع (السبت والأحد)",
    "Weekend (Sat-Sun)": "عطلة نهاية الأسبوع (السبت والأحد)",
    "listings.repeat.custom": "مخصص",
    "listings.weekday.sun": "الأحد",
    "Sun": "الأحد",
    "listings.weekday.mon": "الاثنين",
    "Mon": "الاثنين",
    "listings.weekday.tue": "الثلاثاء",
    "Tue": "الثلاثاء",
    "listings.weekday.wed": "الأربعاء",
    "Wed": "الأربعاء",
    "listings.weekday.thu": "الخميس",
    "Thu": "الخميس",
    "listings.weekday.fri": "الجمعة",
    "Fri": "الجمعة",
    "listings.weekday.sat": "السبت",
    "Sat": "السبت",
    "orders.pay_balance": "ادفع الرصيد {amount}",
    "Pay balance {amount}": "ادفع الرصيد {amount}",
    "orders.partially_paid": "مدفوع جزئيًا",
    "Partially paid": "مدفوع جزئيًا",
    "orders.balance_amount": "الرصيد: {amount}",
    "Balance {amount}": "الرصيد: {amount}",
    "delivery.get_started.add_branch": "إضافة فرع",
    "Add branch": "إضافة فرع",
    "delivery.get_started.add_fleet": "إضافة أسطول",
    "Add fleet": "إضافة أسطول",
    "delivery.get_started.api_documentation": "توثيق واجهة برمجة التطبيقات",
    "API Documentation": "توثيق واجهة برمجة التطبيقات",
    "delivery.get_started.add_driver": "إضافة سائق",
    "Add driver": "إضافة سائق",
    "delivery.get_started.branch_title": "أضف فرعك",
    "Add your branch": "أضف فرعك",
    "delivery.get_started.branch_description": "يمكن أن يضم الفرع عدة أساطيل وسائقين",
    "A branch can have many fleets and drivers": "يمكن أن يضم الفرع عدة أساطيل وسائقين",
    "delivery.get_started.fleet_title": "أضف أسطولك",
    "Add your fleet": "أضف أسطولك",
    "delivery.get_started.fleet_description": "يمكن تعيين أسطول لسائق",
    "A fleet can be assigned to a driver": "يمكن تعيين أسطول لسائق",
    "delivery.get_started.driver_title": "أضف سائقك",
    "Add your driver": "أضف سائقك",
    "delivery.get_started.driver_description": "سيوصل السائق طلبك",
    "The driver will deliver your order": "سيوصل السائق طلبك",
    "delivery.get_started.order_title": "أنشئ طلبك الأول",
    "Create your first order": "أنشئ طلبك الأول",
    "delivery.get_started.order_description": "يمكن إنشاء الطلبات عبر واجهة برمجة التطبيقات",
    "Orders can be created through the API": "يمكن إنشاء الطلبات عبر واجهة برمجة التطبيقات",
    "delivery.get_started.progress.branches": "فروع",
    "Branches": "فروع",
    "delivery.get_started.progress.fleets": "أساطيل",
    "Fleets": "أساطيل",
    "delivery.get_started.progress.drivers": "سائقون",
    "Drivers": "سائقون",
    "delivery.get_started.progress.orders": "طلبات التوصيل",
    "Delivery Orders": "طلبات التوصيل",
    "delivery.get_started.welcome": "أهلاً بك في",
    "Welcome to": "أهلاً بك في",
    "delivery.get_started.question": "ماذا تريد أن تفعل؟",
    "What would you like to do?": "ماذا تريد أن تفعل؟",
    "workspace.templates.built_in": "مدمج",
    "Built-in": "مدمج",
    "workspace.templates.copy_of": "نسخة من {name}",
    "Copy of {name}": "نسخة من {name}",
    "workspace.members.role": "دور",
    "Role": "دور",
    "workspace.members.role_full_access": "وصول كامل",
    "Full access": "وصول كامل",
    "workspace.templates.duplicate": "تكرار",
    "workspace.members.role_custom": "مخصص (حدده أدناه)",
    "Custom (set below)": "مخصص (حدده أدناه)"
  },
  "es": {
    "0": "0",
    "6100": "6100",
    "common.language": "Idioma",
    "Language": "Idioma",
    "common.english": "Inglés",
    "English": "Inglés",
    "common.french": "Francés",
    "French": "Francés",
    "common.arabic": "Árabe",
    "Arabic": "Árabe",
    "navigation.get_started": "Empezar",
    "Get Started": "Empezar",
    "navigation.dashboard": "Panel",
    "Dashboard": "Panel",
    "navigation.orders": "Pedidos",
    "Orders": "Pedidos",
    "navigation.schedule": "Horario",
    "navigation.accounts": "Cuentas",
    "Accounts": "Cuentas",
    "navigation.account_categories": "Categorías de cuentas",
    "Account Categories": "Categorías de cuentas",
    "navigation.account_attributes": "Atributos de cuenta",
    "Account Attributes": "Atributos de cuenta",
    "navigation.account_configuration": "Configuración de cuenta",
    "navigation.agents": "Agentes",
    "Agents": "Agentes",
    "navigation.listings": "Listados",
    "Listings": "Listados",
    "navigation.categories": "Categorías",
    "Categories": "Categorías",
    "navigation.custom_attributes": "Atributos personalizados",
    "Custom Attributes": "Atributos personalizados",
    "navigation.variant_types": "Tipos de variante",
    "navigation.additional_features": "Características adicionales",
    "Additional Features": "Características adicionales",
    "navigation.reported_listings": "Listados reportados",
    "Reported Listings": "Listados reportados",
    "navigation.report_accounts": "Cuentas reportadas",
    "Report Accounts": "Cuentas reportadas",
    "navigation.users": "Usuarios",
    "Users": "Usuarios",
    "navigation.user_attributes": "Atributos de usuario",
    "User Attributes": "Atributos de usuario",
    "navigation.reviews_ratings": "Reseñas y calificaciones",
    "navigation.report": "Reporte",
    "Report": "Reporte",
    "navigation.reports": "Informes",
    "Reports": "Informes",
    "navigation.platform_health": "Salud de la Plataforma",
    "Platform Health": "Salud de la Plataforma",
    "navigation.promotions": "Promociones",
    "Promotions": "Promociones",
    "navigation.collections": "Colecciones",
    "Collections": "Colecciones",
    "navigation.promotion_ads": "Promoción / Anuncios",
    "Promotion / Ads": "Promoción / Anuncios",
    "navigation.coupons": "Cupones",
    "Coupons": "Cupones",
    "navigation.finance": "Finanzas",
    "Finance": "Finanzas",
    "navigation.transactions": "Transacciones",
    "Transactions": "Transacciones",
    "navigation.settlement": "Liquidación",
    "Settlement": "Liquidación",
    "navigation.expenses": "Gastos",
    "Expenses": "Gastos",
    "navigation.recurring_payments": "Pagos recurrentes",
    "Recurring payments": "Pagos recurrentes",
    "navigation.media": "Medios",
    "Media": "Medios",
    "navigation.communication": "Comunicación",
    "Communication": "Comunicación",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Editor de sitio web",
    "Website Editor": "Editor de sitio web",
    "navigation.change_templates": "Cambiar plantillas",
    "Change Templates": "Cambiar plantillas",
    "navigation.pages": "Páginas",
    "Pages": "Páginas",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Personalizar textos",
    "Customise texts": "Personalizar textos",
    "navigation.add_integrations": "Agregar integraciones",
    "Add Integrations": "Agregar integraciones",
    "navigation.domain": "Dominio",
    "Domain": "Dominio",
    "navigation.customise_seo": "Personalizar SEO",
    "Customise SEO": "Personalizar SEO",
    "navigation.app": "Aplicación",
    "App": "Aplicación",
    "navigation.apps": "Aplicaciones",
    "Apps": "Aplicaciones",
    "navigation.buy_app_templates": "Comprar plantillas de aplicación",
    "Buy App Templates": "Comprar plantillas de aplicación",
    "navigation.customisation": "Personalización",
    "Customisation": "Personalización",
    "navigation.integrations": "Integraciones",
    "Integrations": "Integraciones",
    "navigation.invite_team": "Invitar a equipo",
    "Invite Team": "Invitar a equipo",
    "navigation.help": "Ayuda",
    "Help": "Ayuda",
    "navigation.documentation": "Documentación",
    "Documentation": "Documentación",
    "navigation.community": "Comunidad",
    "Community": "Comunidad",
    "navigation.api_reference": "Referencia de API",
    "API Reference": "Referencia de API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Canal",
    "navigation.coding_kits": "Kit de programación",
    "Coding Kits": "Kit de programación",
    "navigation.vibe_coding": "Programación asistida por IA",
    "Vibe Coding": "Programación asistida por IA",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Configuración",
    "navigation.more": "Más",
    "More": "Más",
    "navigation.marketplace": "Marketplace",
    "navigation.commerce": "Comercio",
    "Commerce": "Comercio",
    "navigation.marketing": "Marketing",
    "Marketing": "Marketing",
    "navigation.intelligence": "Inteligencia",
    "Intelligence": "Inteligencia",
    "navigation.subscription": "Suscripción",
    "Subscription": "Suscripción",
    "navigation.membership": "Membresía",
    "Membership": "Membresía",
    "navigation.rewards": "Recompensas",
    "Rewards": "Recompensas",
    "navigation.bundles": "Paquetes",
    "Bundles": "Paquetes",
    "navigation.supply_chain": "Cadena de suministro",
    "Supply Chain": "Cadena de suministro",
    "navigation.people": "Personas",
    "People": "Personas",
    "navigation.workforce": "Fuerza laboral",
    "Workforce": "Fuerza laboral",
    "navigation.payroll": "Nómina",
    "Payroll": "Nómina",
    "navigation.inventory": "Inventario",
    "Inventory": "Inventario",
    "navigation.inventory_operations": "Operaciones de inventario",
    "Inventory Operations": "Operaciones de inventario",
    "navigation.purchase_orders": "Órdenes de compra",
    "Purchase Orders": "Órdenes de compra",
    "navigation.stock_locations": "Ubicaciones de stock",
    "Stock Locations": "Ubicaciones de stock",
    "navigation.purchase_orders_2": "Órdenes de compra",
    "navigation.suppliers": "Proveedores",
    "Suppliers": "Proveedores",
    "navigation.locations": "Ubicaciones",
    "Locations": "Ubicaciones",
    "navigation.maps": "Mapas",
    "Maps": "Mapas",
    "navigation.accounting": "Contabilidad",
    "Accounting": "Contabilidad",
    "navigation.invoices": "Facturas",
    "Invoices": "Facturas",
    "navigation.plans": "Planes",
    "Plans": "Planes",
    "navigation.countries": "Países",
    "Countries": "Países",
    "navigation.currency": "Moneda",
    "Currency": "Moneda",
    "navigation.languages": "Idiomas",
    "Languages": "Idiomas",
    "navigation.payments": "Pagos",
    "Payments": "Pagos",
    "navigation.commissions": "Comisiones",
    "Commissions": "Comisiones",
    "navigation.taxes": "Impuestos",
    "Taxes": "Impuestos",
    "navigation.special_fees": "Honorarios especiales",
    "navigation.service_shipping": "Servicio / Envío",
    "Service / Shipping": "Servicio / Envío",
    "navigation.checkout_cart_attributes": "Atributos de carrito y checkout",
    "navigation.dark_mode_background_color": "Color de fondo del modo oscuro",
    "Dark Mode Background Color": "Color de fondo del modo oscuro",
    "navigation.dark_mode_text_color": "Color del texto del modo oscuro",
    "Dark Mode Text Color": "Color del texto del modo oscuro",
    "navigation.light_mode_background_color": "Color de fondo del modo claro",
    "Light Mode Background Color": "Color de fondo del modo claro",
    "navigation.light_mode_text_color": "Color del texto del modo claro",
    "Light Mode Text Color": "Color del texto del modo claro",
    "navigation.workspace": "Espacio de trabajo",
    "Workspace": "Espacio de trabajo",
    "navigation.user_management": "Gestión de usuarios",
    "User Management": "Gestión de usuarios",
    "navigation.privacy": "Privacidad",
    "Privacy": "Privacidad",
    "common.search": "Buscar...",
    "Search...": "Buscar...",
    "common.search_2": "Buscar",
    "Search": "Buscar",
    "common.no_results_found": "No se encontraron resultados",
    "No results found": "No se encontraron resultados",
    "common.no_record_found": "No se encontró ningún registro",
    "No Record Found": "No se encontró ningún registro",
    "common.open_in_a_new_tab": "Abrir en una nueva pestaña",
    "Open in a new tab": "Abrir en una nueva pestaña",
    "common.open": "Abrir",
    "common.in_a_new_tab": "en una nueva pestaña",
    "in a new tab": "en una nueva pestaña",
    "common.loading_page": "Cargando página…",
    "Loading page…": "Cargando página…",
    "common.close": "Cerrar",
    "Close": "Cerrar",
    "common.save": "Guardar",
    "Save": "Guardar",
    "common.cancel": "Cancelar",
    "Cancel": "Cancelar",
    "common.delete": "Eliminar",
    "Delete": "Eliminar",
    "common.edit": "Editar",
    "Edit": "Editar",
    "common.add": "Agregar",
    "common.create": "Crear",
    "Create": "Crear",
    "common.update": "Actualizar",
    "Update": "Actualizar",
    "common.back": "Atrás",
    "Back": "Atrás",
    "common.next": "Siguiente",
    "Next": "Siguiente",
    "common.previous": "Anterior",
    "Previous": "Anterior",
    "common.done": "Hecho",
    "Done": "Hecho",
    "common.yes": "Sí",
    "Yes": "Sí",
    "common.no": "No",
    "No": "No",
    "common.name": "Nombre",
    "Name": "Nombre",
    "common.status": "Estado",
    "Status": "Estado",
    "common.date": "Fecha",
    "Date": "Fecha",
    "common.actions": "Acciones",
    "Actions": "Acciones",
    "common.action": "Acción",
    "Action": "Acción",
    "orders.scan_order": "Escanea el pedido",
    "Scan order": "Escanea el pedido",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Escanea una referencia de código de barras/QR o introdúcela manualmente.",
    "Scan a barcode/QR reference or enter it manually.": "Escanea una referencia de código de barras/QR o introdúcela manualmente.",
    "orders.camera_scanner": "Escáner de cámara",
    "Camera scanner": "Escáner de cámara",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "No se admite el escaneo de cámara aquí. Introduce la referencia del pedido a continuación.",
    "Camera scanning is not supported here. Enter the order reference below.": "No se admite el escaneo de cámara aquí. Introduce la referencia del pedido a continuación.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "El acceso a la cámara no está disponible. Introduce la referencia del pedido a continuación.",
    "Camera access is unavailable. Enter the order reference below.": "El acceso a la cámara no está disponible. Introduce la referencia del pedido a continuación.",
    "orders.order_reference_number": "Número de referencia del pedido",
    "Order reference number": "Número de referencia del pedido",
    "orders.find_order": "Buscar pedido",
    "Find order": "Buscar pedido",
    "common.your_orders_will_be_shown_here": "Aquí se mostrarán sus pedidos.",
    "Your orders will be shown here.": "Aquí se mostrarán sus pedidos.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Aquí, puede controlar los pedidos, reservas, etc. realizados con otras cuentas y seguir las actualizaciones de estado.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Aquí, puede controlar los pedidos, reservas, etc. realizados con otras cuentas y seguir las actualizaciones de estado.",
    "common.reference": "Referencia #",
    "Reference #": "Referencia #",
    "common.amount": "Monto",
    "orders.order_status": "Estado del pedido",
    "Order Status": "Estado del pedido",
    "orders.payment_status": "Estado del pago",
    "Payment Status": "Estado del pago",
    "common.payment_method": "Método de pago",
    "Payment Method": "Método de pago",
    "common.shipping_method": "Método de envío",
    "Shipping Method": "Método de envío",
    "common.paid": "Pagado",
    "Paid": "Pagado",
    "common.not_paid": "No pagado",
    "Not Paid": "No pagado",
    "common.unpaid": "No pagado",
    "UnPaid": "No pagado",
    "common.failed": "Fallido",
    "common.incomplete": "Incompleto",
    "Incomplete": "Incompleto",
    "common.order_placed": "Pedido realizado",
    "Order placed": "Pedido realizado",
    "common.order_in_progress": "Pedido en curso",
    "Order in progress": "Pedido en curso",
    "common.shipped": "Enviado",
    "Shipped": "Enviado",
    "common.delivered": "Entregado",
    "Delivered": "Entregado",
    "common.cancelled_by_customer": "Cancelado por el cliente",
    "Cancelled by customer": "Cancelado por el cliente",
    "common.order_completed": "Pedido completado",
    "Order completed": "Pedido completado",
    "common.n_a": "N/D",
    "N/A": "N/D",
    "orders.total_orders": "Pedidos totales",
    "Total Orders": "Pedidos totales",
    "orders.page_revenue": "Ingresos de la página",
    "Page Revenue": "Ingresos de la página",
    "orders.pending_payment": "Pago pendiente",
    "Pending Payment": "Pago pendiente",
    "common.failed_payments": "Pagos fallidos",
    "Failed payments": "Pagos fallidos",
    "common.abandoned": "Abandonado",
    "Abandoned": "Abandonado",
    "orders.search_orders_by_reference_number": "Buscar pedidos por número de referencia",
    "Search orders by reference number": "Buscar pedidos por número de referencia",
    "orders.search_by_reference_number": "Buscar por número de referencia…",
    "Search by reference number…": "Buscar por número de referencia…",
    "orders.export_orders_as_csv": "Exportar pedidos como CSV",
    "Export orders as CSV": "Exportar pedidos como CSV",
    "orders.manual_order": "Pedido manual",
    "Manual Order": "Pedido manual",
    "orders.scan_order_reference": "Escanear número de referencia del pedido",
    "Scan order reference": "Escanear número de referencia del pedido",
    "orders.change_status_to": "Cambiar estado a…",
    "Change status to…": "Cambiar estado a…",
    "common.apply": "Aplicar",
    "Apply": "Aplicar",
    "common.clear": "Borrar",
    "orders.pay": "Pagar",
    "Pay": "Pagar",
    "orders.clear_selection": "Borrar selección",
    "Clear selection": "Borrar selección",
    "orders.list": "Lista",
    "orders.board": "Tablero",
    "Board": "Tablero",
    "orders.filter_orders": "Filtrar pedidos",
    "Filter orders": "Filtrar pedidos",
    "orders.start_date": "Fecha de inicio",
    "Start Date": "Fecha de inicio",
    "orders.end_date": "Fecha de fin",
    "orders.select_date": "Seleccionar fecha",
    "Select Date": "Seleccionar fecha",
    "orders.show_rows": "Mostrar filas",
    "Show rows": "Mostrar filas",
    "common.order_selected": "pedido seleccionado",
    "order selected": "pedido seleccionado",
    "common.orders_selected": "pedidos seleccionados",
    "orders selected": "pedidos seleccionados",
    "common.order_updated": "pedido actualizado",
    "order updated": "pedido actualizado",
    "common.orders_updated": "pedidos actualizados",
    "orders updated": "pedidos actualizados",
    "orders.order_archived_successfully": "Pedido archivado con éxito",
    "Order archived successfully": "Pedido archivado con éxito",
    "orders.failed_to_archive_order": "No se pudo archivar el pedido",
    "Failed to archive order": "No se pudo archivar el pedido",
    "orders.loading_order": "Cargando pedido…",
    "Loading order…": "Cargando pedido…",
    "orders.order_created_successfully": "Pedido creado con éxito",
    "Order created successfully": "Pedido creado con éxito",
    "orders.the_order_has_been_created_and_is_ready_to_review": "El pedido se ha creado y está listo para revisar.",
    "The order has been created and is ready to review.": "El pedido se ha creado y está listo para revisar.",
    "orders.order_reference": "Referencia del pedido",
    "common.created": "Creado",
    "Created": "Creado",
    "common.total": "Total",
    "Total": "Total",
    "common.items": "Artículos",
    "orders.print_save_pdf": "Imprimir / Guardar PDF",
    "Print / Save PDF": "Imprimir / Guardar PDF",
    "orders.view_order_details": "Ver detalles del pedido",
    "View order details": "Ver detalles del pedido",
    "orders.create_another_order": "Crear otro pedido",
    "Create another order": "Crear otro pedido",
    "orders.confirmed": "Confirmado",
    "Confirmed": "Confirmado",
    "orders.in_progress": "En progreso",
    "In progress": "En progreso",
    "orders.customer_unreachable": "Cliente no alcanzable",
    "Customer unreachable": "Cliente no alcanzable",
    "orders.out_for_delivery": "En camino a la entrega",
    "Out for delivery": "En camino a la entrega",
    "orders.returned": "Devuelto",
    "Returned": "Devuelto",
    "orders.return_confirmed": "Devolución confirmada",
    "Return confirmed": "Devolución confirmada",
    "orders.delivery_confirmed": "Entrega confirmada",
    "Delivery confirmed": "Entrega confirmada",
    "orders.return_initiated": "Devolución iniciada",
    "Return initiated": "Devolución iniciada",
    "orders.return_picked": "Devolución recogida",
    "Return picked": "Devolución recogida",
    "orders.return_disputed": "Devolución en disputa",
    "Return disputed": "Devolución en disputa",
    "orders.canceled_by_seller": "Cancelado por el vendedor",
    "Canceled by seller": "Cancelado por el vendedor",
    "orders.canceled_by_customer": "Cancelado por el cliente",
    "Canceled by customer": "Cancelado por el cliente",
    "orders.ready_for_pickup": "Listo para recoger",
    "Ready for pickup": "Listo para recoger",
    "orders.arrived_at_customer_location": "Llegado al lugar del cliente",
    "Arrived at customer location": "Llegado al lugar del cliente",
    "orders.undelivered_returned": "No entregado - Devuelto",
    "Undelivered - Returned": "No entregado - Devuelto",
    "orders.undelivered_return_confirmed": "No entregado - Devolución confirmada",
    "Undelivered - Return confirmed": "No entregado - Devolución confirmada",
    "orders.disputed": "En disputa",
    "Disputed": "En disputa",
    "orders.completed": "Completado",
    "Completed": "Completado",
    "orders.detail_legacy.order_number": "Número de pedido:",
    "Order Number:": "Número de pedido:",
    "orders.detail_legacy.order_date": "Fecha de pedido:",
    "Order Date:": "Fecha de pedido:",
    "orders.detail_legacy.buyer_details": "Detalles del comprador:",
    "Buyer Details:": "Detalles del comprador:",
    "orders.detail_legacy.delivery_address": "Dirección de entrega:",
    "Delivery Address:": "Dirección de entrega:",
    "orders.detail_legacy.pickup_address": "Dirección de recogida:",
    "Pickup Address:": "Dirección de recogida:",
    "orders.detail_legacy.total_amount": "Importe total:",
    "Total Amount:": "Importe total:",
    "orders.detail_legacy.amount_in_words": "Importe en palabras:",
    "Amount in Words:": "Importe en palabras:",
    "orders.detail_legacy.amount_words_only": "Sólo",
    "Only": "Sólo",
    "orders.detail_legacy.payout_date": "Fecha de pago:",
    "Payout Date:": "Fecha de pago:",
    "orders.detail_legacy.change": "Cambio",
    "orders.detail_legacy.select_date_time": "Seleccionar fecha y hora",
    "Select Date & Time": "Seleccionar fecha y hora",
    "orders.detail_legacy.change_payout_date_time": "Cambiar fecha y hora de pago",
    "Change Payout Date and Time": "Cambiar fecha y hora de pago",
    "orders.detail_legacy.update_payout": "Actualizar",
    "orders.detail_legacy.update_status": "Actualizar estado",
    "Update Status": "Actualizar estado",
    "orders.detail_legacy.change_order_status": "Cambiar estado del pedido",
    "Change Order Status": "Cambiar estado del pedido",
    "orders.detail_legacy.column_description": "Descripción",
    "Description": "Descripción",
    "orders.detail_legacy.column_unit_price": "Precio por unidad",
    "Unit Price": "Precio por unidad",
    "orders.detail_legacy.column_discount": "Descuento",
    "Discount": "Descuento",
    "orders.detail_legacy.column_tax_rate": "Tasa de impuestos",
    "Tax Rate": "Tasa de impuestos",
    "orders.item": "Artículo",
    "Item": "Artículo",
    "orders.order_details": "Detalles del pedido",
    "Order Details": "Detalles del pedido",
    "orders.copy_order_reference": "Copiar referencia de pedido",
    "Copy order reference": "Copiar referencia de pedido",
    "orders.order_summary": "Resumen del pedido",
    "Order Summary": "Resumen del pedido",
    "orders.order_created": "Pedido creado",
    "Order created": "Pedido creado",
    "orders.order_time": "Hora del pedido",
    "Order time": "Hora del pedido",
    "orders.total_earnings": "Ingresos totales",
    "Total earnings": "Ingresos totales",
    "orders.total_price": "Precio total",
    "Total price": "Precio total",
    "orders.delivery_fee": "Tarifa de entrega",
    "Delivery fee": "Tarifa de entrega",
    "orders.sub_total": "Subtotal",
    "Sub total": "Subtotal",
    "orders.customer_information": "Información del cliente",
    "Customer Information": "Información del cliente",
    "common.customer_name": "Nombre del cliente",
    "Customer Name": "Nombre del cliente",
    "common.phone": "Teléfono",
    "Phone": "Teléfono",
    "common.email": "Correo electrónico",
    "Email": "Correo electrónico",
    "orders.seller_details": "Detalles del vendedor",
    "Seller Details": "Detalles del vendedor",
    "common.seller_name": "Nombre del vendedor",
    "Seller Name": "Nombre del vendedor",
    "common.mobile": "Móvil",
    "Mobile": "Móvil",
    "orders.generate": "Generar",
    "Generate": "Generar",
    "orders.cancel_order": "Cancelar pedido",
    "Cancel Order": "Cancelar pedido",
    "orders.mark_as_paid": "Marcar como pagado",
    "Mark as Paid": "Marcar como pagado",
    "orders.failed_to_mark_as_paid": "No se pudo marcar como pagado",
    "Failed to mark as paid": "No se pudo marcar como pagado",
    "orders.order_cancelled_successfully": "Pedido cancelado con éxito",
    "Order cancelled successfully": "Pedido cancelado con éxito",
    "orders.failed_to_cancel_order_by_admin": "No se pudo cancelar el pedido por el administrador",
    "Failed to cancel order by admin": "No se pudo cancelar el pedido por el administrador",
    "orders.no_transactions_found": "No se encontraron transacciones",
    "No transactions found": "No se encontraron transacciones",
    "orders.transaction_no": "Número de transacción",
    "Transaction No": "Número de transacción",
    "orders.entity": "Entidad",
    "Entity": "Entidad",
    "orders.transaction_type": "Tipo de transacción",
    "Transaction Type": "Tipo de transacción",
    "common.seller": "Vendedor",
    "Seller": "Vendedor",
    "common.customer": "Cliente",
    "Customer": "Cliente",
    "common.platform_owner": "Propietario de la plataforma",
    "Platform Owner": "Propietario de la plataforma",
    "orders.items_summary": "Resumen de artículos",
    "Items Summary": "Resumen de artículos",
    "orders.qty": "Cantidad",
    "orders.price": "Precio",
    "Price": "Precio",
    "orders.total_price_2": "Precio total",
    "Total Price": "Precio total",
    "orders.membership_purchase": "Compra de membresía",
    "Membership purchase": "Compra de membresía",
    "orders.member_id": "ID de miembro",
    "Member ID": "ID de miembro",
    "orders.period": "Período",
    "Period": "Período",
    "orders.start_date_2": "Fecha de inicio",
    "Start date": "Fecha de inicio",
    "common.next_renewal": "Próxima renovación",
    "Next renewal": "Próxima renovación",
    "common.expiry_date": "Fecha de caducidad",
    "Expiry date": "Fecha de caducidad",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Este pedido se gestiona como una contribución de membresía, no como un envío.",
    "This order is managed as a membership contribution, not a shipment.": "Este pedido se gestiona como una contribución de membresía, no como un envío.",
    "orders.months": "meses",
    "months": "meses",
    "orders.days": "días",
    "days": "días",
    "orders.address": "Dirección",
    "Address": "Dirección",
    "orders.address_1": "Dirección 1",
    "Address 1": "Dirección 1",
    "orders.address_2": "Dirección 2",
    "Address 2": "Dirección 2",
    "orders.zip_code": "Código postal",
    "Zip code": "Código postal",
    "orders.full_address": "Dirección completa",
    "Full Address": "Dirección completa",
    "orders.formatted_address": "Dirección formateada",
    "Formatted Address": "Dirección formateada",
    "orders.phone_number": "Número de teléfono",
    "Phone Number": "Número de teléfono",
    "orders.address_not_found": "Dirección no encontrada",
    "Address not found": "Dirección no encontrada",
    "orders.address_not_applicable": "Dirección no aplicable",
    "Address not applicable": "Dirección no aplicable",
    "orders.address_is_not_available": "Dirección no disponible",
    "Address is not available": "Dirección no disponible",
    "orders.add_pickup_address": "Agregar dirección de recogida",
    "Add Pickup Address": "Agregar dirección de recogida",
    "orders.edit_pickup_address": "Editar dirección de recogida",
    "Edit Pickup Address": "Editar dirección de recogida",
    "orders.discard_and_close": "Descartar y cerrar",
    "Discard and close": "Descartar y cerrar",
    "orders.state": "Estado",
    "State": "Estado",
    "common.country": "País",
    "Country": "País",
    "orders.sales_payout": "Pago de ventas",
    "Sales Payout": "Pago de ventas",
    "orders.sales_no_payout": "Ventas (Sin pago)",
    "Sales (No Payout)": "Ventas (Sin pago)",
    "orders.sales_payout_reversal": "Reversión de pago de ventas",
    "Sales Payout Reversal": "Reversión de pago de ventas",
    "orders.sales_no_payout_reversal": "Reversión de ventas sin pago",
    "Sales no payout reversal": "Reversión de ventas sin pago",
    "orders.seller_commission": "Comisión del vendedor",
    "Seller Commission": "Comisión del vendedor",
    "orders.seller_commission_reversal": "Reversión de comisión del vendedor",
    "Seller Commission Reversal": "Reversión de comisión del vendedor",
    "orders.seller_transfer": "Transferencia del vendedor",
    "Seller Transfer": "Transferencia del vendedor",
    "orders.seller_transfer_reversal": "Reversión de transferencia del vendedor",
    "Seller Transfer Reversal": "Reversión de transferencia del vendedor",
    "orders.seller_payout": "Pago del vendedor",
    "Seller Payout": "Pago del vendedor",
    "orders.seller_subscription": "Suscripción del vendedor",
    "Seller Subscription": "Suscripción del vendedor",
    "orders.seller_payment_processing_fee": "Tarifa de procesamiento de pago del vendedor",
    "Seller Payment processing fee": "Tarifa de procesamiento de pago del vendedor",
    "orders.seller_payment_processing_fee_reversal": "Reversión de tarifa de procesamiento de pago del vendedor",
    "Seller Payment processing fee reversal": "Reversión de tarifa de procesamiento de pago del vendedor",
    "orders.sub_total_2": "Subtotal",
    "Sub Total": "Subtotal",
    "orders.customer_commission": "Comisión del cliente",
    "Customer Commission": "Comisión del cliente",
    "orders.tax": "Impuesto",
    "Tax": "Impuesto",
    "orders.shipping_charge": "Cargo de envío",
    "Shipping Charge": "Cargo de envío",
    "orders.refund": "Reembolso",
    "Refund": "Reembolso",
    "orders.special_fee": "Tarifa especial",
    "Special Fee": "Tarifa especial",
    "orders.coupon": "Cupón",
    "Coupon": "Cupón",
    "orders.shipment": "Envío",
    "Shipment": "Envío",
    "orders.fulfilled_by_platform": "Cumplido por la plataforma",
    "Fulfilled by platform": "Cumplido por la plataforma",
    "orders.fulfilled_by": "Cumplido por",
    "Fulfilled by": "Cumplido por",
    "orders.fulfilled_by_seller": "Cumplido por el vendedor",
    "Fulfilled by seller": "Cumplido por el vendedor",
    "orders.on_seller_protection_policy": "Política de protección al vendedor",
    "On Seller Protection Policy": "Política de protección al vendedor",
    "orders.product_image": "Imagen del producto",
    "Product image": "Imagen del producto",
    "orders.status_changed_successfully": "Estado cambiado con éxito",
    "Status changed successfully": "Estado cambiado con éxito",
    "orders.pickup_address_not_available_please_add_pickup_address": "Dirección de recogida no disponible. Por favor, añada dirección de recogida",
    "Pickup Address not available. Please Add Pickup Address": "Dirección de recogida no disponible. Por favor, añada dirección de recogida",
    "orders.failed_to_save_pickup_address_please_try_again": "Error al guardar dirección de recogida. Por favor, inténtelo de nuevo",
    "Failed to save pickup address. Please try again.": "Error al guardar dirección de recogida. Por favor, inténtelo de nuevo",
    "orders.change_shipment_status": "Cambiar estado del envío",
    "Change shipment status": "Cambiar estado del envío",
    "orders.not_available": "No disponible",
    "Not available": "No disponible",
    "orders.shipment_created": "Envío creado",
    "Shipment created": "Envío creado",
    "orders.shipment_in_progress": "Envío en progreso",
    "Shipment in progress": "Envío en progreso",
    "orders.ship": "Enviar",
    "Ship": "Enviar",
    "orders.undelivered_return": "Devolución sin entrega",
    "orders.shipment_deliver": "Entrega de envío",
    "Shipment deliver": "Entrega de envío",
    "orders.shipment_delivery_confirm": "Confirmar entrega de envío",
    "Shipment delivery confirm": "Confirmar entrega de envío",
    "orders.return_initiate": "Iniciar devolución",
    "Return initiate": "Iniciar devolución",
    "orders.return_for_pickup": "Devolución para recogida",
    "Return for pickup": "Devolución para recogida",
    "orders.shipment_return_confirm": "Confirmar devolución de envío",
    "Shipment return confirm": "Confirmar devolución de envío",
    "orders.cancel_by_seller": "Cancelar por vendedor",
    "Cancel by seller": "Cancelar por vendedor",
    "orders.cancel_by_customer": "Cancelar por cliente",
    "Cancel by customer": "Cancelar por cliente",
    "orders.arrive_at_customer_location": "Llegar a ubicación del cliente",
    "Arrive at customer location": "Llegar a ubicación del cliente",
    "orders.shipment_delivered": "Envío entregado",
    "Shipment delivered": "Envío entregado",
    "orders.shipment_delivery_confirmed": "Entrega confirmada",
    "Shipment delivery confirmed": "Entrega confirmada",
    "orders.returned_for_pickup": "Devolución para recogida",
    "orders.shipment_return_confirmed": "Devolución confirmada",
    "Shipment return confirmed": "Devolución confirmada",
    "orders.cancelled_by_seller": "Cancelado por vendedor",
    "common.cancelled_by_admin": "Cancelado por el administrador",
    "orders.invoice": "Factura",
    "Invoice": "Factura",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Seleccione un tipo de archivo válido (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Seleccione un tipo de archivo válido (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "El tamaño del archivo debe ser inferior a 5 MB",
    "File size must be less than 5MB": "El tamaño del archivo debe ser inferior a 5 MB",
    "orders.please_upload_a_file_first": "Suba un archivo primero",
    "Please upload a file first": "Suba un archivo primero",
    "orders.invoice_uploaded_successfully": "Factura subida con éxito",
    "Invoice uploaded successfully!": "Factura subida con éxito",
    "orders.failed_to_upload_invoice_please_try_again": "Error al subir la factura. Inténtelo de nuevo.",
    "Failed to upload invoice. Please try again.": "Error al subir la factura. Inténtelo de nuevo.",
    "orders.upload_invoice": "Subir factura",
    "Upload Invoice": "Subir factura",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Formatos admitidos: PDF, JPG, PNG, DOC (Tamaño máximo: 5 MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Formatos admitidos: PDF, JPG, PNG, DOC (Tamaño máximo: 5 MB)",
    "orders.uploading": "Subiendo...",
    "Uploading...": "Subiendo...",
    "orders.choose_file": "Elegir archivo",
    "Choose File": "Elegir archivo",
    "common.download": "Descargar",
    "Download": "Descargar",
    "common.remove": "Eliminar",
    "Remove": "Eliminar",
    "orders.upload_new_file": "Subir nuevo archivo",
    "Upload New File": "Subir nuevo archivo",
    "orders.saving": "Guardando...",
    "Saving...": "Guardando...",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Eliminar un pedido eliminará inmediatamente el pedido de la vista del vendedor y del comprador. Una vez eliminado, no se permitirán más actualizaciones de estado, y el pedido se excluirá de todas las métricas y informes. ¿Está seguro de que desea continuar?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Eliminar un pedido eliminará inmediatamente el pedido de la vista del vendedor y del comprador. Una vez eliminado, no se permitirán más actualizaciones de estado, y el pedido se excluirá de todas las métricas y informes. ¿Está seguro de que desea continuar?",
    "common.showing": "Mostrando",
    "Showing": "Mostrando",
    "common.of": "de",
    "of": "de",
    "common.all": "Todos",
    "common.active": "Activo",
    "Active": "Activo",
    "common.inactive": "Inactivo",
    "Inactive": "Inactivo",
    "common.enabled": "Habilitado",
    "Enabled": "Habilitado",
    "common.disabled": "Deshabilitado",
    "Disabled": "Deshabilitado",
    "common.success": "Éxito",
    "Success": "Éxito",
    "common.error": "Error",
    "Error": "Error",
    "common.warning": "Advertencia",
    "Warning": "Advertencia",
    "common.required": "Requerido",
    "Required": "Requerido",
    "users.title": "Usuarios",
    "users.import": "Importar",
    "Import": "Importar",
    "users.import_users": "Importar usuarios",
    "Import users": "Importar usuarios",
    "users.smart_upload_users": "Carga inteligente de usuarios",
    "Smart Upload Users": "Carga inteligente de usuarios",
    "users.smart_upload_beta": "Carga inteligente de usuarios (Beta)",
    "Smart upload users (Beta)": "Carga inteligente de usuarios (Beta)",
    "users.export": "Exportar",
    "Export": "Exportar",
    "users.export_users": "Exportar usuarios",
    "Export users": "Exportar usuarios",
    "users.search_users": "Buscar usuarios",
    "Search users": "Buscar usuarios",
    "users.verified": "Verificado",
    "Verified": "Verificado",
    "users.not_verified": "No verificado",
    "Non Verified": "No verificado",
    "users.block": "Bloquear",
    "Block": "Bloquear",
    "users.unblock": "Desbloquear",
    "Unblock": "Desbloquear",
    "users.confirm_block": "¿Quieres bloquear a este usuario?",
    "Do you want to block this user?": "¿Quieres bloquear a este usuario?",
    "users.confirm_unblock": "¿Quieres desbloquear a este usuario?",
    "Do you want to unblock this user?": "¿Quieres desbloquear a este usuario?",
    "users.import_export": "Importación y exportación de usuarios",
    "User import and export": "Importación y exportación de usuarios",
    "users.user_id": "ID de usuario",
    "User ID": "ID de usuario",
    "users.first_name": "Nombre",
    "First Name": "Nombre",
    "users.last_name": "Apellido",
    "Last Name": "Apellido",
    "users.email": "Correo electrónico",
    "users.phone_number": "Número de teléfono",
    "users.country": "País",
    "users.profile": "Perfil",
    "Profile": "Perfil",
    "users.email_verified": "Correo verificado",
    "Email Verified": "Correo verificado",
    "users.blocked": "Bloqueado",
    "Blocked": "Bloqueado",
    "users.action": "Acción",
    "users.join_date": "Fecha de registro",
    "Join Date": "Fecha de registro",
    "users.last_login": "Último inicio de sesión",
    "Last Login": "Último inicio de sesión",
    "users.customer_type": "Tipo de cliente",
    "Customer Type": "Tipo de cliente",
    "common.and": "y",
    "and": "y",
    "users.import_failed": "Error al importar el usuario.",
    "User import failed.": "Error al importar el usuario.",
    "users.smart_upload.paid_title": "La carga inteligente de usuarios es una característica de pago",
    "Smart user upload is a paid feature": "La carga inteligente de usuarios es una característica de pago",
    "users.smart_upload.paid_description": "Actualiza tu espacio de trabajo a Starter o Go para importar usuarios desde un archivo CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Actualiza tu espacio de trabajo a Starter o Go para importar usuarios desde un archivo CSV.",
    "users.smart_upload.view_plans": "Ver planes",
    "View plans": "Ver planes",
    "users.smart_upload.csv_needs_user": "El CSV debe contener una fila de encabezados y al menos un usuario.",
    "The CSV must contain a header row and at least one user.": "El CSV debe contener una fila de encabezados y al menos un usuario.",
    "users.smart_upload.unique_headers": "Cada columna de usuario necesita un encabezado único y no vacío.",
    "Every user column needs a unique, non-empty header.": "Cada columna de usuario necesita un encabezado único y no vacío.",
    "users.smart_upload.csv_read_error": "No se puede leer este CSV.",
    "Unable to read this CSV.": "No se puede leer este CSV.",
    "users.smart_upload.map_required": "Mapea {fields} antes de continuar.",
    "Map {fields} before continuing.": "Mapea {fields} antes de continuar.",
    "users.smart_upload.map_contact": "Mapea una columna de Correo electrónico o Teléfono. Cada fila necesita al menos un método de contacto.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Mapea una columna de Correo electrónico o Teléfono. Cada fila necesita al menos un método de contacto.",
    "users.smart_upload.invalid_row": "La fila {row} está faltando un valor requerido de nombre o contacto.",
    "Row {row} is missing a required name or contact value.": "La fila {row} está faltando un valor requerido de nombre o contacto.",
    "users.smart_upload.attribute_name_required": "Ingresa un nombre de atributo para “{header}”.",
    "users.smart_upload.attribute_create_error": "No se pudo crear el atributo “{name}”.",
    "Could not create the “{name}” attribute.": "No se pudo crear el atributo “{name}”.",
    "users.smart_upload.attribute_missing": "El atributo mapeado desde “{header}” ya no está disponible.",
    "users.smart_upload.prepare_error": "No se pudo preparar el archivo de importación.",
    "Could not prepare the import file.": "No se pudo preparar el archivo de importación.",
    "users.smart_upload.upload_error": "No se pudo subir el archivo de importación.",
    "The import file could not be uploaded.": "No se pudo subir el archivo de importación.",
    "users.smart_upload.all_duplicates": "Cada fila es un duplicado de otra fila en este archivo.",
    "Every row is a duplicate of another row in this file.": "Cada fila es un duplicado de otra fila en este archivo.",
    "users.smart_upload.source_attribute_error": "No se pudo crear el atributo contact_source.",
    "Could not create the contact_source attribute.": "No se pudo crear el atributo contact_source.",
    "users.smart_upload.duplicates_skipped": "Filas duplicadas para omitir: {count}.",
    "Duplicate rows to skip: {count}.": "Filas duplicadas para omitir: {count}.",
    "users.smart_upload.preparing_attributes": "Preparando atributos",
    "Preparing attributes": "Preparando atributos",
    "users.smart_upload.checking_users": "Verificando usuarios existentes",
    "Checking existing users": "Verificando usuarios existentes",
    "users.smart_upload.uploading_file": "Subiendo archivo de importación",
    "Uploading import file": "Subiendo archivo de importación",
    "users.smart_upload.importing_users": "Tradly está importando usuarios",
    "Tradly is importing users": "Tradly está importando usuarios",
    "users.smart_upload.import_stopped": "Importación detenida",
    "Import stopped": "Importación detenida",
    "users.smart_upload.title": "Carga inteligente de usuarios",
    "Smart user upload": "Carga inteligente de usuarios",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Empezar de nuevo",
    "Start over": "Empezar de nuevo",
    "users.smart_upload.description": "Suba contactos, asigne columnas a atributos de usuario y clasifíquelos como salientes o registrados.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Suba contactos, asigne columnas a atributos de usuario y clasifíquelos como salientes o registrados.",
    "users.smart_upload.step_upload": "Subir",
    "users.smart_upload.step_match": "Asignar columnas",
    "users.smart_upload.step_review": "Revisar",
    "users.smart_upload.step_import": "Importar",
    "users.smart_upload.choose_csv": "Seleccione un archivo CSV",
    "users.smart_upload.required_fields": "Se requieren nombre, apellido y correo electrónico o teléfono. Las contraseñas se generan automáticamente.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Se requieren nombre, apellido y correo electrónico o teléfono. Las contraseñas se generan automáticamente.",
    "users.smart_upload.select_csv": "Seleccione el archivo CSV",
    "users.smart_upload.match_columns": "Asignar columnas de usuario",
    "Match user columns": "Asignar columnas de usuario",
    "users.smart_upload.first_name": "Nombre de pila",
    "users.smart_upload.last_name": "Apellido",
    "Last name": "Apellido",
    "users.smart_upload.email": "Correo electrónico",
    "users.smart_upload.phone": "Teléfono",
    "users.smart_upload.username": "Nombre de usuario",
    "Username": "Nombre de usuario",
    "users.smart_upload.do_not_import": "No importar",
    "Do not import": "No importar",
    "users.smart_upload.additional_attributes": "Atributos adicionales de usuario",
    "Additional user attributes": "Atributos adicionales de usuario",
    "users.smart_upload.ignore_column": "Ignorar esta columna",
    "Ignore this column": "Ignorar esta columna",
    "users.smart_upload.create_attribute": "Crear un nuevo atributo de usuario",
    "Create a new user attribute": "Crear un nuevo atributo de usuario",
    "users.smart_upload.attribute_name": "Nombre del atributo",
    "Attribute name": "Nombre del atributo",
    "users.smart_upload.type_text": "Texto",
    "Text": "Texto",
    "users.smart_upload.type_long_text": "Texto largo",
    "Long text": "Texto largo",
    "users.smart_upload.type_number": "Número",
    "Number": "Número",
    "users.smart_upload.type_single_select": "Selección única",
    "Single select": "Selección única",
    "users.smart_upload.type_multi_select": "Selección múltiple",
    "Multi select": "Selección múltiple",
    "users.smart_upload.review_import": "Revisar importación",
    "Review import": "Revisar importación",
    "users.smart_upload.review_description": "Contactos para importar: {count}. Los usuarios existentes de Tradly pueden ser rechazados por la API; volver a intentar una importación parcial puede duplicar filas exitosas.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Contactos para importar: {count}. Los usuarios existentes de Tradly pueden ser rechazados por la API; volver a intentar una importación parcial puede duplicar filas exitosas.",
    "users.smart_upload.contact_classification": "Clasificación de contacto",
    "Contact classification": "Clasificación de contacto",
    "users.smart_upload.outbound": "Salida (no optado)",
    "Outbound (not opted in)": "Salida (no optado)",
    "users.smart_upload.signed_up": "Registrado (optado)",
    "Signed-up (opted in)": "Registrado (optado)",
    "users.smart_upload.contact_source_help": "Esto se guarda como el atributo contact_source. El tipo de usuario integrado de Tradly sigue siendo cliente.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Esto se guarda como el atributo contact_source. El tipo de usuario integrado de Tradly sigue siendo cliente.",
    "users.smart_upload.import_complete": "Importación de usuarios completa",
    "User import complete": "Importación de usuarios completa",
    "users.smart_upload.imported_summary": "{imported} de {total} usuarios importados.",
    "{imported} of {total} users imported.": "{imported} de {total} usuarios importados.",
    "users.smart_upload.selected_file": "Seleccionado: {name}",
    "Selected: {name}": "Seleccionado: {name}",
    "users.smart_upload.review_action": "Revisar",
    "users.smart_upload.importing_action": "Importando…",
    "Importing…": "Importando…",
    "users.smart_upload.import_users_action": "Importar usuarios",
    "users.import.uploading": "Subiendo…",
    "Uploading…": "Subiendo…",
    "users.import.please_wait": "Por favor espere…",
    "users.import.error_prefix": "Error",
    "users.import.select_file_error": "Seleccione un archivo",
    "Please select a file": "Seleccione un archivo",
    "users.import.download": "Descargar",
    "users.import.file_label": "Archivo:",
    "File:": "Archivo:",
    "users.import.select_file": "Seleccionar archivo",
    "Select File": "Seleccionar archivo",
    "users.import.upload": "Subir",
    "users.create.button": "Crear usuario",
    "Create User": "Crear usuario",
    "users.create.title": "Crear nuevo usuario",
    "Create New User": "Crear nuevo usuario",
    "users.create.please_wait": "Espere…",
    "users.create.email": "Correo electrónico",
    "users.create.first_name": "Nombre",
    "users.create.last_name": "Apellido",
    "users.create.email_required": "El correo electrónico es obligatorio",
    "Email is required": "El correo electrónico es obligatorio",
    "users.create.first_name_required": "El nombre es obligatorio",
    "First Name is required": "El nombre es obligatorio",
    "users.create.last_name_required": "El apellido es obligatorio",
    "Last Name is required": "El apellido es obligatorio",
    "users.create.session_expired": "Su sesión de administrador ha expirado. Inicie sesión nuevamente antes de crear un usuario.",
    "Your admin session has expired. Please sign in again before creating a user.": "Su sesión de administrador ha expirado. Inicie sesión nuevamente antes de crear un usuario.",
    "users.create.unable_to_create": "No se puede crear este usuario.",
    "Unable to create this user.": "No se puede crear este usuario.",
    "users.create.success": "Usuario creado con éxito",
    "User created successfully": "Usuario creado con éxito",
    "users.create.failed": "No se pudo crear el usuario. Inténtelo de nuevo.",
    "User creation failed. Please try again.": "No se pudo crear el usuario. Inténtelo de nuevo.",
    "common.feature_flow.eyebrow": "VER CÓMO FUNCIONA",
    "SEE HOW IT WORKS": "VER CÓMO FUNCIONA",
    "common.feature_flow.open_guide": "Abrir guía de flujo",
    "Open flow guide": "Abrir guía de flujo",
    "common.feature_flow.close_guide": "Cerrar guía de sección",
    "Close section guide": "Cerrar guía de sección",
    "common.feature_flow.section_guide": "Guía de sección",
    "Section guide": "Guía de sección",
    "users.flow.title": "Todo lo que necesita para administrar sus usuarios",
    "Everything you need to manage your users": "Todo lo que necesita para administrar sus usuarios",
    "users.flow.description": "Crea perfiles de usuario, personaliza los datos y entiende los comentarios de los clientes en un solo lugar.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Crea perfiles de usuario, personaliza los datos y entiende los comentarios de los clientes en un solo lugar.",
    "users.flow.lane_title": "Gestión de usuarios",
    "User management": "Gestión de usuarios",
    "users.flow.badge": "Herramientas principales",
    "Core tools": "Herramientas principales",
    "users.flow.attributes": "Atributos",
    "Attributes": "Atributos",
    "users.flow.reviews": "Reseñas",
    "users.flow.lane_description": "Administra personas, añade los campos de perfil que necesitas y aprende de su experiencia.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Administra personas, añade los campos de perfil que necesitas y aprende de su experiencia.",
    "users.flow.primary_action": "Añade tu primer usuario",
    "Add your first user": "Añade tu primer usuario",
    "users.tooltip.title": "Cada individuo es un usuario único",
    "Every individual is a unique user": "Cada individuo es un usuario único",
    "users.tooltip.description": "Imagina, por un momento, que posees un centro comercial.\n\nCada usuario que entra en una tienda se considera un usuario.\n\nCada comerciante que gestiona una tienda se considera un usuario.\n\nEn Tradly, todos los usuarios diferentes (comerciante o cliente) se llaman «Usuarios», y sus detalles únicos se almacenan en la sección de usuarios. Puedes encontrar sus detalles de compra o las cuentas que poseen.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Imagina, por un momento, que posees un centro comercial.\n\nCada usuario que entra en una tienda se considera un usuario.\n\nCada comerciante que gestiona una tienda se considera un usuario.\n\nEn Tradly, todos los usuarios diferentes (comerciante o cliente) se llaman «Usuarios», y sus detalles únicos se almacenan en la sección de usuarios. Puedes encontrar sus detalles de compra o las cuentas que poseen.",
    "workspace.loading": "Cargando configuración del espacio de trabajo…",
    "Loading workspace settings…": "Cargando configuración del espacio de trabajo…",
    "workspace.kicker": "ESPACIO DE TRABAJO",
    "WORKSPACE": "ESPACIO DE TRABAJO",
    "workspace.fallback_name": "Espacio de trabajo",
    "workspace.members.title": "Invitar miembro del equipo",
    "Invite Team Member": "Invitar miembro del equipo",
    "workspace.members.description": "Añade compañeros de equipo y da a cada persona solo el acceso que necesitan.",
    "Add teammates and give each person only the access they need.": "Añade compañeros de equipo y da a cada persona solo el acceso que necesitan.",
    "workspace.members.enter_name_email": "Introduce el nombre y dirección de correo electrónico del miembro.",
    "Enter a member name and email address.": "Introduce el nombre y dirección de correo electrónico del miembro.",
    "workspace.members.invitation_sent": "Invitación enviada.",
    "Invitation sent.": "Invitación enviada.",
    "workspace.members.confirm_remove": "¿Eliminar a {name} de este espacio de trabajo?",
    "Remove {name} from this workspace?": "¿Eliminar a {name} de este espacio de trabajo?",
    "workspace.members.removed": "Miembro del equipo eliminado.",
    "Team member removed.": "Miembro del equipo eliminado.",
    "workspace.members.roles_saved": "Roles de miembro guardados.",
    "Member roles saved.": "Roles de miembro guardados.",
    "workspace.members.read": "Ver",
    "workspace.members.write": "Escribir",
    "Write": "Escribir",
    "workspace.members.delete": "Eliminar",
    "workspace.members.select_all_permission": "Seleccionar todos los {permission} en {group}",
    "Select all {permission} in {group}": "Seleccionar todos los {permission} en {group}",
    "workspace.members.member_name": "Nombre del miembro",
    "Member Name": "Nombre del miembro",
    "workspace.members.email_address": "Dirección de correo electrónico",
    "Email Address": "Dirección de correo electrónico",
    "workspace.members.sending": "Enviando…",
    "Sending…": "Enviando…",
    "workspace.members.send_invitation": "Enviar invitación",
    "Send invitation": "Enviar invitación",
    "workspace.members.team_members": "Miembros del equipo",
    "Team members": "Miembros del equipo",
    "workspace.members.search_members": "Buscar miembros",
    "Search members": "Buscar miembros",
    "workspace.members.search": "Buscar",
    "workspace.members.member": "Miembro",
    "Member": "Miembro",
    "workspace.members.email": "Correo electrónico",
    "workspace.members.status": "Estado",
    "workspace.members.actions": "Acciones",
    "workspace.members.unnamed": "Miembro sin nombre",
    "Unnamed member": "Miembro sin nombre",
    "workspace.members.roles": "Roles",
    "Roles": "Roles",
    "workspace.members.empty": "No se encontraron miembros del equipo.",
    "No team members found.": "No se encontraron miembros del equipo.",
    "workspace.members.page_of": "Página {page} de {pages}",
    "Page {page} of {pages}": "Página {page} de {pages}",
    "workspace.members.assign_roles": "Asignar roles",
    "Assign roles": "Asignar roles",
    "workspace.members.save_roles": "Guardar roles",
    "Save roles": "Guardar roles",
    "workspace.members.saving": "Guardando…",
    "Saving…": "Guardando…",
    "workspace.error.generic": "Ocurrió un error. Por favor, inténtelo de nuevo.",
    "Something went wrong. Please try again.": "Ocurrió un error. Por favor, inténtelo de nuevo.",
    "workspace.billing.view_label": "Vista de facturación del espacio de trabajo",
    "Billing workspace view": "Vista de facturación del espacio de trabajo",
    "workspace.billing.tab_usage": "Uso",
    "Usage": "Uso",
    "workspace.billing.tab_plans": "Planes",
    "workspace.billing.tab_invoices": "Facturas pagadas",
    "Paid invoices": "Facturas pagadas",
    "workspace.billing.tab_account": "Cuenta",
    "Account": "Cuenta",
    "workspace.account.title": "Configuración de negocio",
    "Business Settings": "Configuración de negocio",
    "workspace.account.description": "Administra tu perfil de negocio, los productos habilitados y la privacidad de la cuenta.",
    "Manage your business profile, enabled products, and account privacy.": "Administra tu perfil de negocio, los productos habilitados y la privacidad de la cuenta.",
    "workspace.account.profile_updated": "Perfil de negocio actualizado.",
    "Business profile updated.": "Perfil de negocio actualizado.",
    "workspace.account.logo_updated": "Logotipo actualizado.",
    "Logo updated.": "Logotipo actualizado.",
    "workspace.account.logo_upload_error": "No se puede subir el logotipo.",
    "Unable to upload logo.": "No se puede subir el logotipo.",
    "workspace.account.confirm_delete": "¿Eliminar esta cuenta de Tradly permanentemente? Esto no se puede deshacer.",
    "Delete this Tradly account permanently? This cannot be undone.": "¿Eliminar esta cuenta de Tradly permanentemente? Esto no se puede deshacer.",
    "workspace.account.business_profile": "Perfil de negocio",
    "Business Profile": "Perfil de negocio",
    "workspace.account.logo": "Logotipo",
    "workspace.account.logo_alt": "Logotipo de negocio",
    "Business logo": "Logotipo de negocio",
    "workspace.account.add_photo": "Agregar foto",
    "Add photo": "Agregar foto",
    "workspace.account.logo_formats": "PNG, JPG, SVG o ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG o ICO",
    "workspace.account.business_name": "Nombre de la empresa",
    "workspace.account.contact_name": "Nombre de contacto del negocio",
    "Business Contact Name": "Nombre de contacto del negocio",
    "workspace.account.business_address": "Dirección de la empresa",
    "Business Address": "Dirección de la empresa",
    "workspace.account.products_of_interest": "Productos de interés",
    "Products of Interest": "Productos de interés",
    "workspace.account.marketplace": "Mercado",
    "workspace.account.single_store": "Comercio de tienda única",
    "Single Store Commerce": "Comercio de tienda única",
    "workspace.account.alacarte_products": "Productos a la carta",
    "À la carte Products": "Productos a la carta",
    "workspace.account.alacarte_description": "Los productos individuales habilitados para este espacio de trabajo se gestionan desde Planes & Facturación.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Los productos individuales habilitados para este espacio de trabajo se gestionan desde Planes & Facturación.",
    "workspace.account.manage_alacarte": "Gestionar productos a la carta",
    "Manage à la carte products": "Gestionar productos a la carta",
    "workspace.account.delete_irreversible": "Eliminar cuenta: Irreversible",
    "Delete your Account: Irreversible": "Eliminar cuenta: Irreversible",
    "workspace.account.delete_description": "Esto elimina permanentemente el inquilino Tradly y todos los datos asociados.",
    "This permanently deletes the Tradly tenant and all associated data.": "Esto elimina permanentemente el inquilino Tradly y todos los datos asociados.",
    "workspace.account.deleting": "Eliminando…",
    "Deleting…": "Eliminando…",
    "workspace.account.delete_button": "Eliminar cuenta con Tradly",
    "Delete Account With Tradly": "Eliminar cuenta con Tradly",
    "workspace.privacy.title": "Privacidad y procesadores de datos",
    "Privacy & Data Processors": "Privacidad y procesadores de datos",
    "workspace.privacy.description": "Entender qué procesadores ayudan a operar Tradly y cómo funciona la retención después de una solicitud de eliminación.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Entender qué procesadores ayudan a operar Tradly y cómo funciona la retención después de una solicitud de eliminación.",
    "workspace.privacy.processor_retention": "Utilizamos los siguientes procesadores y herramientas para operar el servicio, mejorar la calidad del producto y apoyar la facturación y fiabilidad. Este período de retención aplica solo después de que un usuario solicite la eliminación de su cuenta. Los datos de usuario de Tradly Platform se retienen aproximadamente entre 90 y 180 días según necesidades operativas y de cumplimiento.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Utilizamos los siguientes procesadores y herramientas para operar el servicio, mejorar la calidad del producto y apoyar la facturación y fiabilidad. Este período de retención aplica solo después de que un usuario solicite la eliminación de su cuenta. Los datos de usuario de Tradly Platform se retienen aproximadamente entre 90 y 180 días según necesidades operativas y de cumplimiento.",
    "workspace.privacy.read_more": "Leer más.",
    "Read more.": "Leer más.",
    "workspace.privacy.tool": "Herramienta",
    "Tool": "Herramienta",
    "workspace.privacy.purpose": "Propósito",
    "Purpose": "Propósito",
    "workspace.privacy.data_category": "Categoría de datos",
    "Data Category": "Categoría de datos",
    "workspace.privacy.deletion_requests": "Solicitudes de eliminación de cuenta y datos",
    "Account deletion and data requests": "Solicitudes de eliminación de cuenta y datos",
    "workspace.privacy.deletion_description": "Para solicitar la eliminación de la cuenta o su eliminación de una herramienta de relación con clientes, contacte a su administrador de espacio de trabajo o soporte. Estas acciones requieren confirmación de backend antes de que se expongan aquí.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Para solicitar la eliminación de la cuenta o su eliminación de una herramienta de relación con clientes, contacte a su administrador de espacio de trabajo o soporte. Estas acciones requieren confirmación de backend antes de que se expongan aquí.",
    "workspace.privacy.open_account": "Abrir configuración de cuenta",
    "Open account settings": "Abrir configuración de cuenta",
    "workspace.privacy.core_operations": "Operaciones básicas del producto",
    "Core product operations": "Operaciones básicas del producto",
    "workspace.privacy.user_data_retention": "Datos de usuario (retención: 90–180 días)",
    "User data (retention: 90–180 days)": "Datos de usuario (retención: 90–180 días)",
    "workspace.privacy.crm_support_lifecycle": "CRM, soporte y comunicación del ciclo de vida",
    "CRM, support, lifecycle communication": "CRM, soporte y comunicación del ciclo de vida",
    "workspace.privacy.personal_data": "Datos personales",
    "Personal data": "Datos personales",
    "workspace.privacy.product_analytics": "Análisis de producto y embudos de compromiso",
    "Product analytics and engagement funnels": "Análisis de producto y embudos de compromiso",
    "workspace.privacy.usage_events": "Análisis de uso y eventos",
    "Usage and event analytics": "Análisis de uso y eventos",
    "workspace.privacy.billing_payments": "Procesamiento de facturación y pagos",
    "Billing and payment processing": "Procesamiento de facturación y pagos",
    "workspace.privacy.billing_data": "Datos de facturación",
    "Billing data": "Datos de facturación",
    "workspace.privacy.traffic_analytics": "Análisis de tráfico y comportamiento",
    "Traffic and behavior analytics": "Análisis de tráfico y comportamiento",
    "workspace.privacy.usage_analytics": "Análisis de uso",
    "Usage analytics": "Análisis de uso",
    "workspace.privacy.session_diagnostics": "Informes de sesión y diagnóstico de botones rotos",
    "Session insights and broken-button diagnostics": "Informes de sesión y diagnóstico de botones rotos",
    "workspace.privacy.ux_telemetry": "Telemetría UX/sesión",
    "UX/session telemetry": "Telemetría UX/sesión",
    "workspace.privacy.error_monitoring": "Monitoreo de errores de código y estabilidad",
    "Code error and stability monitoring": "Monitoreo de errores de código y estabilidad",
    "workspace.privacy.error_logs": "Registros de errores y diagnósticos",
    "Error logs and diagnostics": "Registros de errores y diagnósticos",
    "workspace.privacy.email_delivery": "Entrega de correos transaccionales",
    "Transactional email delivery": "Entrega de correos transaccionales",
    "workspace.privacy.email_metadata": "Metadatos de correo electrónico",
    "Email metadata": "Metadatos de correo electrónico",
    "workspace.privacy.hosting_infrastructure": "Almacenamiento e infraestructura",
    "Hosting and infrastructure": "Almacenamiento e infraestructura",
    "workspace.privacy.infrastructure_logs": "Registros de infraestructura y servicio",
    "Infrastructure and service logs": "Registros de infraestructura y servicio",
    "workspace.domain.title": "Dominios",
    "Domains": "Dominios",
    "workspace.domain.description": "Conecta tu propio dominio para reemplazar la URL predeterminada de Tradly alojada.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Conecta tu propio dominio para reemplazar la URL predeterminada de Tradly alojada.",
    "workspace.domain.invalid": "Introduce un dominio válido, como example.com.",
    "Enter a valid domain, such as example.com.": "Introduce un dominio válido, como example.com.",
    "workspace.domain.reserved": "tradly.co está reservado para dominios de espacio de trabajo alojados.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co está reservado para dominios de espacio de trabajo alojados.",
    "workspace.domain.missing_primary": "No hay dominio primario disponible para el espacio de trabajo.",
    "No primary workspace domain is available.": "No hay dominio primario disponible para el espacio de trabajo.",
    "workspace.domain.saved": "Dominio personalizado guardado. Actualiza tus registros DNS y luego refresca su estado.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Dominio personalizado guardado. Actualiza tus registros DNS y luego refresca su estado.",
    "workspace.domain.reset_success": "Dominio restablecido a la URL alojada por Tradly.",
    "Domain reset to the Tradly-hosted URL.": "Dominio restablecido a la URL alojada por Tradly.",
    "workspace.domain.current": "DOMINIO ACTUAL",
    "CURRENT DOMAIN": "DOMINIO ACTUAL",
    "workspace.domain.hosted": "Dominio alojado por Tradly",
    "Tradly-hosted domain": "Dominio alojado por Tradly",
    "workspace.domain.dns_status": "Estado DNS: {status}",
    "DNS status: {status}": "Estado DNS: {status}",
    "workspace.domain.checking": "Comprobando estado DNS…",
    "Checking DNS status…": "Comprobando estado DNS…",
    "workspace.domain.refresh": "Actualizar estado",
    "Refresh status": "Actualizar estado",
    "workspace.domain.reset": "Restablecer dominio",
    "Reset domain": "Restablecer dominio",
    "workspace.domain.connect_title": "Conectar un dominio personalizado",
    "Connect a custom domain": "Conectar un dominio personalizado",
    "workspace.domain.connect_description": "Introduce un dominio que ya poseas. Mostraremos los registros DNS necesarios para conectarlo.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Introduce un dominio que ya poseas. Mostraremos los registros DNS necesarios para conectarlo.",
    "workspace.domain.saving": "Guardando…",
    "workspace.domain.add": "Añadir dominio",
    "Add domain": "Añadir dominio",
    "workspace.domain.dns_title": "Configuración DNS",
    "DNS setup": "Configuración DNS",
    "workspace.domain.a_record": "Registro A",
    "A record": "Registro A",
    "workspace.domain.root_description": "Utiliza esto para un dominio raíz, como",
    "Use this for a root domain such as": "Utiliza esto para un dominio raíz, como",
    "workspace.domain.cname_record": "Registro CNAME",
    "CNAME record": "Registro CNAME",
    "workspace.domain.subdomain_description": "Utilízalo para un subdominio como",
    "Use this for a subdomain such as": "Utilízalo para un subdominio como",
    "workspace.domain.host": "Host",
    "Host": "Host",
    "workspace.domain.value": "Valor",
    "Value": "Valor",
    "workspace.domain.need_domain": "¿Necesitas un dominio?",
    "Need a domain?": "¿Necesitas un dominio?",
    "workspace.domain.buy_domain": "Compra un dominio en Google Domains o GoDaddy, luego regresa aquí para conectarlo.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Compra un dominio en Google Domains o GoDaddy, luego regresa aquí para conectarlo.",
    "workspace.billing.title": "Facturación y uso",
    "Billing & Usage": "Facturación y uso",
    "workspace.billing.description": "Gestiona planes de workspace, uso y facturación.",
    "Manage workspace plans, usage, and billing.": "Gestiona planes de workspace, uso y facturación.",
    "workspace.billing.invoice_description": "Gestiona planes de workspace, uso y facturas pagadas.",
    "Manage workspace plans, usage, and paid invoices.": "Gestiona planes de workspace, uso y facturas pagadas.",
    "workspace.billing.usage_description": "Consulta el uso actual y los límites aplicados a este workspace.",
    "workspace.invoices.loading": "Cargando facturas…",
    "Loading invoices…": "Cargando facturas…",
    "workspace.invoices.description": "Descarga facturas o completa el pago por un saldo pendiente.",
    "Download invoices or complete payment for an outstanding balance.": "Descarga facturas o completa el pago por un saldo pendiente.",
    "workspace.invoices.payment_failed": "Pago fallido — el acceso al servicio puede verse afectado.",
    "Payment failed — service access may be affected.": "Pago fallido — el acceso al servicio puede verse afectado.",
    "workspace.invoices.awaiting_payment": "La factura {invoice} está esperando pago.",
    "Invoice {invoice} is awaiting payment.": "La factura {invoice} está esperando pago.",
    "workspace.invoices.outstanding": "pendiente",
    "outstanding": "pendiente",
    "workspace.invoices.pay_invoice": "Pagar factura",
    "Pay invoice": "Pagar factura",
    "workspace.invoices.invoice": "Factura",
    "workspace.invoices.date": "Fecha",
    "workspace.invoices.amount": "Monto",
    "workspace.invoices.paid": "Pagado",
    "workspace.invoices.unpaid": "No pagado",
    "workspace.invoices.download_invoice": "Descargar factura",
    "Download invoice": "Descargar factura",
    "workspace.invoices.empty_title": "No hay facturas disponibles",
    "No invoices available": "No hay facturas disponibles",
    "workspace.invoices.empty_description": "Las facturas se crean después de suscribirte y realizar un pago. Contacta al soporte si tienes preguntas.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Las facturas se crean después de suscribirte y realizar un pago. Contacta al soporte si tienes preguntas.",
    "workspace.plans.heading": "Planes",
    "workspace.plans.tab_marketplace": "Mercado",
    "workspace.plans.tab_marketplace_description": "Multi-vendedor",
    "Multi-vendor": "Multi-vendedor",
    "workspace.plans.tab_single": "Tienda única",
    "Single Store": "Tienda única",
    "workspace.plans.tab_single_description": "Autónomos y creadores",
    "Indie & Creators": "Autónomos y creadores",
    "workspace.plans.tab_alacarte": "A la carta",
    "A la carte": "A la carta",
    "workspace.plans.tab_alacarte_description": "Créditos y complementos",
    "Credits & add-ons": "Créditos y complementos",
    "workspace.plans.tab_services": "Servicios",
    "Services": "Servicios",
    "workspace.plans.tab_services_description": "Servicios adicionales",
    "Additional services": "Servicios adicionales",
    "workspace.plans.selected": "Seleccionado",
    "Selected": "Seleccionado",
    "workspace.plans.try_again": "Intentar de nuevo",
    "Try again": "Intentar de nuevo",
    "workspace.plans.bill_yearly": "Facturar anualmente",
    "Bill Yearly": "Facturar anualmente",
    "workspace.plans.bill_monthly": "Facturar mensualmente",
    "Bill Monthly": "Facturar mensualmente",
    "workspace.plans.compare": "Comparar planes",
    "Compare Plans": "Comparar planes",
    "workspace.plans.community": "Comunidad",
    "workspace.plans.community_description": "Gratis para siempre. Perfecto para aficionados y proyectos comunitarios.",
    "Free forever. Perfect for hobbyists and community projects.": "Gratis para siempre. Perfecto para aficionados y proyectos comunitarios.",
    "workspace.plans.different_configurations": "¿Buscas diferentes configuraciones?",
    "Looking for different configurations?": "¿Buscas diferentes configuraciones?",
    "workspace.plans.contact_us": "Contáctanos",
    "Contact Us": "Contáctanos",
    "workspace.plans.see_alacarte_pricing": "Ver precios a la carta",
    "See à la carte pricing": "Ver precios a la carta",
    "workspace.plans.available": "Disponible",
    "Available": "Disponible",
    "workspace.plans.used_90d": "Usado (90d)",
    "Used (90d)": "Usado (90d)",
    "workspace.plans.expired_90d": "Vencido (90d)",
    "Expired (90d)": "Vencido (90d)",
    "workspace.plans.expires_on": "Caduca {date}",
    "Expires {date}": "Caduca {date}",
    "workspace.plans.top_up_credits": "Recargar créditos",
    "Top Up Credits": "Recargar créditos",
    "workspace.plans.credits_description": "Los créditos permiten el uso de Correo electrónico, Búsqueda de IA, Recomendaciones y acciones de Agente. 100 créditos = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Los créditos permiten el uso de Correo electrónico, Búsqueda de IA, Recomendaciones y acciones de Agente. 100 créditos = $5.",
    "workspace.plans.credits": "créditos",
    "credits": "créditos",
    "workspace.plans.custom_amount": "Monto personalizado",
    "Custom amount": "Monto personalizado",
    "workspace.plans.amount_example": "ej. 2500",
    "e.g. 2500": "ej. 2500",
    "workspace.plans.opening_checkout": "Abriendo caja…",
    "Opening checkout…": "Abriendo caja…",
    "workspace.plans.buy_credits": "Comprar {count} créditos",
    "Buy {count} credits": "Comprar {count} créditos",
    "workspace.plans.select_amount": "Seleccionar una cantidad",
    "Select an amount": "Seleccionar una cantidad",
    "workspace.plans.alacarte_products": "Productos a la carta",
    "A la carte Products": "Productos a la carta",
    "workspace.plans.products_description": "Selecciona los productos que usas. Esto nos ayuda a adaptar tu experiencia. El uso se paga con créditos.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Selecciona los productos que usas. Esto nos ayuda a adaptar tu experiencia. El uso se paga con créditos.",
    "workspace.plans.enabled": "Habilitado",
    "workspace.plans.enable": "Habilitar",
    "Enable": "Habilitar",
    "workspace.plans.open_here": "Abrir aquí",
    "Open here": "Abrir aquí",
    "workspace.plans.open_marketing": "Abrir marketing.tradly.app",
    "Open marketing.tradly.app": "Abrir marketing.tradly.app",
    "workspace.plans.open_analytics": "Abrir analytics.tradly.app",
    "Open analytics.tradly.app": "Abrir analytics.tradly.app",
    "workspace.plans.open_external": "Abrir externo",
    "Open external": "Abrir externo",
    "workspace.plans.coming_soon": "Próximamente",
    "Coming soon": "Próximamente",
    "workspace.plans.services_title": "Servicios de configuración única y personalizados",
    "One-Time Setup & Custom Services": "Servicios de configuración única y personalizados",
    "workspace.plans.service_app_launch": "Lanzamiento de aplicación de marca blanca",
    "White-Label App Launch": "Lanzamiento de aplicación de marca blanca",
    "workspace.plans.service_frontend": "Personalización de frontend",
    "Frontend Customization": "Personalización de frontend",
    "workspace.plans.service_multilanguage": "Soporte multilingüe",
    "Multi-Language Support": "Soporte multilingüe",
    "workspace.plans.view_docs": "Ver documentos",
    "View Docs": "Ver documentos",
    "workspace.plans.confirm_change": "Confirma tu cambio de plan",
    "Confirm your plan change": "Confirma tu cambio de plan",
    "workspace.plans.confirm_charge": "Los cargos son anticipados y facturados en tu fecha de suscripción.",
    "Charges are prepaid and billed on your subscription date.": "Los cargos son anticipados y facturados en tu fecha de suscripción.",
    "workspace.plans.confirm_promo": "Los códigos promocionales se pueden ingresar durante el pago en Stripe donde estén disponibles.",
    "Promotional codes can be entered during Stripe checkout where available.": "Los códigos promocionales se pueden ingresar durante el pago en Stripe donde estén disponibles.",
    "workspace.plans.confirm_delay": "Los cambios de plan pueden tardar un momento en aparecer en tu workspace.",
    "Plan changes may take a moment to appear in your workspace.": "Los cambios de plan pueden tardar un momento en aparecer en tu workspace.",
    "workspace.plans.payment_active": "Pago recibido. Su plan está activo.",
    "Payment received. Your plan is active.": "Pago recibido. Su plan está activo.",
    "workspace.plans.payment_method_updated": "Método de pago actualizado.",
    "Payment method updated.": "Método de pago actualizado.",
    "workspace.plans.payment_cancelled": "El pago no se completó, por lo que su plan no ha cambiado.",
    "Payment was not completed, so your plan has not changed.": "El pago no se completó, por lo que su plan no ha cambiado.",
    "workspace.plans.activating": "Pago recibido. Activando su plan…",
    "Payment received. Activating your plan…": "Pago recibido. Activando su plan…",
    "workspace.plans.activation_delayed": "Pago recibido. Su plan está tardando un poco más en activarse. Por favor, refresque en un minuto.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Pago recibido. Su plan está tardando un poco más en activarse. Por favor, refresque en un minuto.",
    "workspace.plans.card_saved": "Tarjeta guardada y suscripción actualizada.",
    "Card saved and subscription updated.": "Tarjeta guardada y suscripción actualizada.",
    "workspace.plans.subscription_updated": "Suscripción actualizada.",
    "Subscription updated.": "Suscripción actualizada.",
    "workspace.plans.products_saved": "Productos a la carta guardados.",
    "À la carte products saved.": "Productos a la carta guardados.",
    "workspace.plans.minimum_credits": "Ingrese al menos 100 créditos.",
    "Enter at least 100 credits.": "Ingrese al menos 100 créditos.",
    "workspace.plans.credit_topup_description": "Recarga de créditos ({count} créditos)",
    "Credit Top-Up ({count} credits)": "Recarga de créditos ({count} créditos)",
    "workspace.plans.billing_details": "Detalles de facturación actuales",
    "Current billing details": "Detalles de facturación actuales",
    "workspace.plans.current_plan": "Plan actual",
    "Current Plan": "Plan actual",
    "workspace.plans.renews": "Renueva",
    "Renews": "Renueva",
    "workspace.plans.payment_method": "Método de pago",
    "Payment method": "Método de pago",
    "workspace.plans.opening": "Abriendo…",
    "Opening…": "Abriendo…",
    "workspace.plans.manage_payment_method": "Administrar método de pago",
    "Manage payment method": "Administrar método de pago",
    "workspace.plans.upgrade": "Actualizar",
    "Upgrade": "Actualizar",
    "workspace.plans.downgrade": "Reducir",
    "Downgrade": "Reducir",
    "workspace.plans.custom_price": "Personalizado",
    "Custom": "Personalizado",
    "workspace.plans.per_month_short": "/mes",
    "/month": "/mes",
    "workspace.plans.per_year_amount": "por año ({amount})",
    "per year ({amount})": "por año ({amount})",
    "workspace.plans.per_month_amount": "por mes ({amount})",
    "per month ({amount})": "por mes ({amount})",
    "workspace.plans.yearly_savings": "Ahorre {amount} anualmente",
    "Save {amount} yearly": "Ahorre {amount} anualmente",
    "workspace.plans.billed_yearly": "Facturado anualmente",
    "billed yearly": "Facturado anualmente",
    "workspace.plans.billed_monthly": "facturado mensualmente",
    "billed monthly": "facturado mensualmente",
    "workspace.plans.free_trial": "Estás en una prueba gratuita.",
    "You are on a free trial.": "Estás en una prueba gratuita.",
    "workspace.plans.updating": "Actualizando…",
    "Updating…": "Actualizando…",
    "workspace.plans.temporarily_unavailable": "Temporalmente no disponible",
    "Temporarily unavailable": "Temporalmente no disponible",
    "workspace.plans.whats_included": "Qué incluye",
    "What's included": "Qué incluye",
    "workspace.plans.products.auth.title": "Autenticación",
    "Auth": "Autenticación",
    "workspace.plans.products.auth.description": "Identidad, SSO, permisos y gestión de usuarios.",
    "Identity, SSO, permissions, and user management.": "Identidad, SSO, permisos y gestión de usuarios.",
    "workspace.plans.products.email.title": "Correo electrónico",
    "workspace.plans.products.email.description": "Correo electrónico transaccional y de marketing, integrado.",
    "Transactional and marketing email, built in.": "Correo electrónico transaccional y de marketing, integrado.",
    "workspace.plans.products.analytics.title": "Análisis",
    "workspace.plans.products.analytics.description": "Análisis gratuito para web, aplicación y agentes.",
    "Free analytics for web, app, and agents.": "Análisis gratuito para web, aplicación y agentes.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "Un CRM que se llena solo a partir de la actividad del usuario.",
    "A CRM that fills itself from user activity.": "Un CRM que se llena solo a partir de la actividad del usuario.",
    "workspace.plans.products.subscription.title": "Suscripciones",
    "Subscriptions": "Suscripciones",
    "workspace.plans.products.subscription.description": "Facturación recurrente, pruebas y gestión de morosidad — gestionada.",
    "Recurring billing, trials, and dunning — handled.": "Facturación recurrente, pruebas y gestión de morosidad — gestionada.",
    "workspace.plans.products.recommendation.title": "Recomendaciones",
    "Recommendations": "Recomendaciones",
    "workspace.plans.products.recommendation.description": "Muestra a cada usuario lo que realmente quieren.",
    "Show each user what they will actually want.": "Muestra a cada usuario lo que realmente quieren.",
    "workspace.plans.marketplace.2025-superstarter.title": "Básico",
    "Basic": "Básico",
    "workspace.plans.marketplace.2025-superstarter.description": "Ideal para equipo pequeño. Todas las características de la comunidad más el blanqueo (elimina el sello \"Construido con Tradly\").",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Ideal para equipo pequeño. Todas las características de la comunidad más el blanqueo (elimina el sello \"Construido con Tradly\").",
    "workspace.plans.marketplace.2025-superstarter.button": "Iniciar prueba de 7 días",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Sin comisión por transacción",
    "No transaction fee": "Sin comisión por transacción",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Sitio web alojado gratuitamente por Tradly",
    "Free Tradly hosted website": "Sitio web alojado gratuitamente por Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Añade tu dominio personalizado",
    "Add your custom domain": "Añade tu dominio personalizado",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Editor - Historial de páginas de 3 días",
    "Editor - 3 Day page history": "Editor - Historial de páginas de 3 días",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Para startups que validan su idea de negocio. Incluye todos los esenciales para probar el mercado y adquirir clientes iniciales.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Para startups que validan su idea de negocio. Incluye todos los esenciales para probar el mercado y adquirir clientes iniciales.",
    "workspace.plans.marketplace.2025-starter.button": "Empieza prueba de 7 días",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Sin comisión por transacción",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Atributos personalizados ilimitados",
    "Unlimited Custom Attributes": "Atributos personalizados ilimitados",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "Historial de página de 30 días",
    "30 Day page history": "Historial de página de 30 días",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Suscripción restringida",
    "Gated Subscription": "Suscripción restringida",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Inicios de sesión sociales",
    "Social Logins": "Inicios de sesión sociales",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhooks",
    "Webhooks": "Webhooks",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Para ideas probadas en su etapa de crecimiento. Tienen necesidades personalizadas y integraciones adicionales para crecer.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Para ideas probadas en su etapa de crecimiento. Tienen necesidades personalizadas y integraciones adicionales para crecer.",
    "workspace.plans.marketplace.2025-growth.button": "Empieza prueba de 7 días",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Sin comisión por transacción",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Correo 'Desde' personalizado",
    "Custom 'From Email'": "Correo 'Desde' personalizado",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Mini herramientas y integraciones adicionales",
    "Additional Mini Tools & Integrations": "Mini herramientas y integraciones adicionales",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Llamadas de incorporación personalizadas*",
    "Personalised Onboarding calls*": "Llamadas de incorporación personalizadas*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "Historial de página de 90 días",
    "90 Day page history": "Historial de página de 90 días",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Monedas y idiomas múltiples",
    "Multi Currencies & Multi Languages": "Monedas y idiomas múltiples",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Control de acceso basado en roles (RBAC)",
    "Role-based access control (RBAC)": "Control de acceso basado en roles (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Chat integrado para aplicaciones",
    "Inbuilt Chat for Apps": "Chat integrado para aplicaciones",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Empresas en etapa de crecimiento que buscan soluciones personalizadas y otros requisitos específicos.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Empresas en etapa de crecimiento que buscan soluciones personalizadas y otros requisitos específicos.",
    "workspace.plans.marketplace.2025-scale.button": "Empieza prueba de 7 días",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Sin comisión por transacción",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Soporte prioritario",
    "Priority Support": "Soporte prioritario",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Múltiples canales (soporte para aplicaciones)",
    "Multiple Channels (App Support)": "Múltiples canales (soporte para aplicaciones)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Inicio de sesión único (SSO)",
    "Single Sign-on (SSO)": "Inicio de sesión único (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Historial de páginas ilimitado",
    "Unlimited page history": "Historial de páginas ilimitado",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Chat integrado para aplicaciones",
    "In-built Chat for Apps": "Chat integrado para aplicaciones",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Todo lo necesario para una tienda en crecimiento — elimina la marca, agrega tu dominio y desbloquea más herramientas.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Todo lo necesario para una tienda en crecimiento — elimina la marca, agrega tu dominio y desbloquea más herramientas.",
    "workspace.plans.indie.go.button": "Comienza prueba de 7 días",
    "Start 7-day trial": "Comienza prueba de 7 días",
    "workspace.plans.indie.go.feature_1.title": "Sin marca Tradly",
    "No Tradly branding": "Sin marca Tradly",
    "workspace.plans.indie.go.feature_2.title": "Dominio personalizado",
    "Custom domain": "Dominio personalizado",
    "workspace.plans.indie.go.feature_3.title": "Productos ilimitados",
    "Unlimited products": "Productos ilimitados",
    "workspace.plans.indie.go.feature_4.title": "Campañas por correo electrónico",
    "Email campaigns": "Campañas por correo electrónico",
    "workspace.plans.indie.go.feature_5.title": "Recomendaciones de IA",
    "AI Recommendations": "Recomendaciones de IA",
    "workspace.plans.indie.go.feature_6.title": "Soporte basado en tickets",
    "Ticket-based support": "Soporte basado en tickets",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Pila de IA completa, marketing avanzado y todo desbloqueado para tiendas serias sobre el crecimiento.",
    "workspace.plans.indie.genius.button": "Comienza prueba de 7 días",
    "workspace.plans.indie.genius.feature_1.title": "Todo lo incluido en Pro",
    "Everything in Pro": "Todo lo incluido en Pro",
    "workspace.plans.indie.genius.feature_2.title": "Agentes de IA (Asistente de compras, etc.)",
    "AI Agents (Shopping Assistant, etc.)": "Agentes de IA (Asistente de compras, etc.)",
    "workspace.plans.indie.genius.feature_3.title": "Búsqueda de lenguaje natural",
    "Natural language search": "Búsqueda de lenguaje natural",
    "workspace.plans.indie.genius.feature_4.title": "Automatización avanzada de correo electrónico",
    "Advanced email automation": "Automatización avanzada de correo electrónico",
    "workspace.plans.indie.genius.feature_5.title": "Solicitudes ilimitadas de recomendaciones",
    "Unlimited recommendation requests": "Solicitudes ilimitadas de recomendaciones",
    "workspace.plans.indie.genius.feature_6.title": "Soporte basado en tickets",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Cargos de suscripción para que las personas abran cuentas y envíen listados",
    "Subscription charges for people to open accounts & submit listings": "Cargos de suscripción para que las personas abran cuentas y envíen listados",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Registro/inicio de sesión con Google, Meta",
    "Signup/in via Google, Meta": "Registro/inicio de sesión con Google, Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Para conectar con Zapier & Make",
    "To connect with Zapier & Make": "Para conectar con Zapier & Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Mensajería nativa en la aplicación para tus usuarios",
    "Native in-app messaging for your users": "Mensajería nativa en la aplicación para tus usuarios",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Tiempo de respuesta de 24 horas para no críticos",
    "24 hour response time for non-critical": "Tiempo de respuesta de 24 horas para no críticos",
    "common.continue": "Continuar",
    "Continue": "Continuar",
    "workspace.plans.free_plan": "Gratis",
    "Free": "Gratis",
    "workspace.usage.group_platform": "Plataforma y espacio de trabajo",
    "Platform & workspace": "Plataforma y espacio de trabajo",
    "workspace.usage.group_ai": "IA y uso",
    "AI & usage": "IA y uso",
    "workspace.usage.group_storage": "Contenido y almacenamiento",
    "Content & storage": "Contenido y almacenamiento",
    "workspace.usage.group_alacarte": "A la carta",
    "workspace.usage.accounts": "Cuentas",
    "workspace.usage.listings": "Listados",
    "workspace.usage.sites": "Sitios bajo el espacio de trabajo",
    "Sites under workspace": "Sitios bajo el espacio de trabajo",
    "workspace.usage.external_users": "Usuarios externos",
    "External users": "Usuarios externos",
    "workspace.usage.internal_users": "Usuarios internos",
    "Internal users": "Usuarios internos",
    "workspace.usage.ai_credits": "Créditos de IA",
    "AI credits": "Créditos de IA",
    "workspace.usage.storage": "Almacenamiento",
    "Storage": "Almacenamiento",
    "workspace.usage.email": "Correo electrónico",
    "workspace.usage.maps": "Mapas",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analíticas",
    "workspace.usage.recommendations": "Recomendaciones",
    "workspace.usage.ai_agents": "Agentes de IA",
    "AI agents": "Agentes de IA",
    "workspace.usage.status_not_reported": "No reportado",
    "Not reported": "No reportado",
    "workspace.usage.status_nearly_full": "Casi lleno",
    "Nearly full": "Casi lleno",
    "workspace.usage.status_on_track": "En ruta",
    "On track": "En ruta",
    "workspace.usage.workspace_files": "Archivos del espacio de trabajo",
    "Workspace files": "Archivos del espacio de trabajo",
    "workspace.usage.workspace_usage": "Uso del espacio de trabajo",
    "Workspace usage": "Uso del espacio de trabajo",
    "workspace.usage.of_limit": "de {limit}",
    "of {limit}": "de {limit}",
    "workspace.usage.no_cap": "No hay límite configurado",
    "No cap configured": "No hay límite configurado",
    "workspace.usage.trend": "Tendencia de uso",
    "Usage trend": "Tendencia de uso",
    "workspace.usage.unavailable": "Los datos de uso no están disponibles temporalmente.",
    "Usage data is temporarily unavailable.": "Los datos de uso no están disponibles temporalmente.",
    "workspace.usage.loading": "Cargando uso del espacio de trabajo…",
    "Loading workspace usage…": "Cargando uso del espacio de trabajo…",
    "workspace.usage.overview": "Resumen del espacio de trabajo",
    "Workspace overview": "Resumen del espacio de trabajo",
    "workspace.usage.title": "Desglose del uso",
    "Usage breakdown": "Desglose del uso",
    "workspace.usage.description": "Vea lo que su espacio de trabajo ha utilizado y cuánto espacio queda en su plan actual.",
    "See what your workspace has used and how much room remains on your current plan.": "Vea lo que su espacio de trabajo ha utilizado y cuánto espacio queda en su plan actual.",
    "workspace.usage.view_plans": "Ver planes",
    "workspace.usage.showing_available_limits": "Mostrando los límites que ya están disponibles en este espacio de trabajo.",
    "Showing the limits that are already available in this workspace.": "Mostrando los límites que ya están disponibles en este espacio de trabajo.",
    "workspace.usage.summary": "Resumen del uso",
    "Usage summary": "Resumen del uso",
    "workspace.usage.metrics_tracked": "Métricas seguidas",
    "Metrics tracked": "Métricas seguidas",
    "workspace.usage.metrics_count": "{count} de {total}",
    "{count} of {total}": "{count} de {total}",
    "workspace.usage.next_reset": "Próximo restablecimiento",
    "Next reset": "Próximo restablecimiento",
    "workspace.usage.not_provided": "No proporcionado",
    "Not provided": "No proporcionado",
    "workspace.usage.data_source": "Fuente de datos",
    "Data source": "Fuente de datos",
    "workspace.usage.clear_view": "Una vista clara de su espacio de trabajo",
    "A clear view of your workspace": "Una vista clara de su espacio de trabajo",
    "workspace.usage.by_resource": "Uso por recurso",
    "Usage by resource": "Uso por recurso",
    "workspace.usage.live_summary": "Resumen en vivo",
    "Live summary": "Resumen en vivo",
    "workspace.usage.resource": "Recurso",
    "Resource": "Recurso",
    "workspace.usage.used_limit": "Usado / límite",
    "Used / limit": "Usado / límite",
    "workspace.usage.progress": "Progreso",
    "Progress": "Progreso",
    "workspace.usage.cost": "Costo",
    "Cost": "Costo",
    "workspace.usage.footnote": "El uso y los límites provienen del servicio de uso del espacio de trabajo. Un guion significa que esta métrica aún no se informa mediante la API actual.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "El uso y los límites provienen del servicio de uso del espacio de trabajo. Un guion significa que esta métrica aún no se informa mediante la API actual.",
    "workspace.usage.refresh": "Actualizar",
    "Refresh": "Actualizar",
    "maps.title": "Mapas",
    "maps.tab.analysis": "Escaneo de mercado",
    "Market scan": "Escaneo de mercado",
    "maps.tab.usage": "Uso",
    "maps.tab.settings": "Configuración",
    "maps.action.save": "Guardar",
    "maps.action.saving": "Guardando…",
    "maps.action.analyze_area": "Analizar área",
    "Analyze area": "Analizar área",
    "maps.action.analyzing": "Analizando…",
    "Analyzing…": "Analizando…",
    "maps.action.refresh": "Actualizar",
    "maps.action.loading": "Cargando…",
    "Loading…": "Cargando…",
    "maps.action.open_in_maps": "Abrir en Mapas",
    "Open in Maps": "Abrir en Mapas",
    "maps.analysis.title": "Explorar un mercado local",
    "Explore a local market": "Explorar un mercado local",
    "maps.analysis.description": "Ver negocios que Google lista alrededor de una ubicación propuesta. Esto es una escaneo inicial de competencia, no una previsión de demanda o viabilidad.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Ver negocios que Google lista alrededor de una ubicación propuesta. Esto es una escaneo inicial de competencia, no una previsión de demanda o viabilidad.",
    "maps.analysis.address_label": "Dirección o localidad",
    "Address or locality": "Dirección o localidad",
    "maps.analysis.address_placeholder": "Calle, barrio o ciudad",
    "Street, suburb, or city": "Calle, barrio o ciudad",
    "maps.analysis.category_label": "Tipo de negocio",
    "Business type": "Tipo de negocio",
    "maps.analysis.radius_label": "Radio de búsqueda",
    "Search radius": "Radio de búsqueda",
    "maps.analysis.places_listings": "Listados de lugares",
    "Places listings": "Listados de lugares",
    "maps.analysis.within_radius": "{category} dentro de {radius}",
    "{category} within {radius}": "{category} dentro de {radius}",
    "maps.analysis.results_description": "Los resultados se filtran por categoría y radio, luego se ordenan por distancia.",
    "Results are filtered by category and radius, then ordered by distance.": "Los resultados se filtran por categoría y radio, luego se ordenan por distancia.",
    "maps.analysis.result_limit_notice": "Google devolvió el máximo de 20 lugares. El número real puede ser mayor; prueba un radio más pequeño para un escaneo más detallado.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google devolvió el máximo de 20 lugares. El número real puede ser mayor; prueba un radio más pequeño para un escaneo más detallado.",
    "maps.analysis.limitations": "Los listados pueden ser incompletos y no miden la demanda del cliente, el flujo de personas, la población, el alquiler o la rentabilidad. Úsalos como una entrada más en tu investigación local.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Los listados pueden ser incompletos y no miden la demanda del cliente, el flujo de personas, la población, el alquiler o la rentabilidad. Úsalos como una entrada más en tu investigación local.",
    "maps.analysis.nearby_businesses": "Negocios cercanos ({count})",
    "Nearby businesses ({count})": "Negocios cercanos ({count})",
    "maps.analysis.businesses": "Negocios",
    "Businesses": "Negocios",
    "maps.analysis.no_listings": "No se encontraron listados de Google Maps coincidentes para esta área y categoría.",
    "No matching Google Maps listings were returned for this area and category.": "No se encontraron listados de Google Maps coincidentes para esta área y categoría.",
    "maps.category.retail": "Comercio minorista",
    "Retail": "Comercio minorista",
    "maps.category.grocery": "Alimentos y bebidas",
    "Grocery": "Alimentos y bebidas",
    "maps.category.clothing": "Ropa",
    "Clothing": "Ropa",
    "maps.category.pharmacy": "Farmacia",
    "Pharmacy": "Farmacia",
    "maps.category.restaurant": "Restaurante / café",
    "Restaurant / café": "Restaurante / café",
    "maps.competition.limited": "Competencia limitada",
    "Limited listed competition": "Competencia limitada",
    "maps.competition.some": "Alguna competencia listada",
    "Some listed competition": "Alguna competencia listada",
    "maps.competition.many": "Mucha competencia listada",
    "Many listed competitors": "Mucha competencia listada",
    "maps.competition.limit_reached": "Al menos 20 listados (límite alcanzado)",
    "At least 20 listings (result limit reached)": "Al menos 20 listados (límite alcanzado)",
    "maps.competition.default": "Competencia listada",
    "Listed competition": "Competencia listada",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Operativo",
    "Operational": "Operativo",
    "maps.usage.title": "Uso del proveedor",
    "Provider usage": "Uso del proveedor",
    "maps.usage.description": "Recuentos de solicitudes registrados por el servicio Maps. Los cargos se reconcilian por separado.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Recuentos de solicitudes registrados por el servicio Maps. Los cargos se reconcilian por separado.",
    "maps.usage.days": "{count} días",
    "{count} days": "{count} días",
    "maps.usage.provider_requests": "Solicitudes del proveedor",
    "Provider requests": "Solicitudes del proveedor",
    "maps.usage.range_detail": "{count} día de ventana",
    "{count} day window": "{count} día de ventana",
    "maps.usage.successful": "Correcto",
    "maps.usage.completed_calls": "Llamadas completadas al proveedor",
    "Completed provider calls": "Llamadas completadas al proveedor",
    "maps.usage.errors": "Errores",
    "Errors": "Errores",
    "maps.usage.failed_calls": "Llamadas fallidas al proveedor",
    "Failed provider calls": "Llamadas fallidas al proveedor",
    "maps.usage.metered_units": "Unidades medibles",
    "Metered units": "Unidades medibles",
    "maps.usage.unit_detail": "Una unidad por solicitud registrada",
    "One unit per recorded request": "Una unidad por solicitud registrada",
    "maps.usage.by_operation": "Uso por operación",
    "Usage by operation": "Uso por operación",
    "maps.usage.group_description": "Los conteos se agrupan por proveedor, operación y resultado.",
    "Counts are grouped by provider, operation, and outcome.": "Los conteos se agrupan por proveedor, operación y resultado.",
    "maps.usage.empty": "No hay solicitudes de mapa en este rango de fechas.",
    "No map requests in this date range.": "No hay solicitudes de mapa en este rango de fechas.",
    "maps.usage.provider": "Proveedor",
    "Provider": "Proveedor",
    "maps.usage.operation": "Operación",
    "Operation": "Operación",
    "maps.usage.outcome": "Resultado",
    "Outcome": "Resultado",
    "maps.usage.requests": "Solicitudes",
    "Requests": "Solicitudes",
    "maps.usage.units": "Unidades",
    "Units": "Unidades",
    "maps.settings.provider_title": "Proveedor de mapas",
    "Map provider": "Proveedor de mapas",
    "maps.settings.provider_description": "Elija el proveedor permitido por su política de privacidad de datos. Las credenciales del proveedor se gestionan por Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Elija el proveedor permitido por su política de privacidad de datos. Las credenciales del proveedor se gestionan por Tradly.",
    "maps.settings.selected": "Seleccionado",
    "maps.settings.available": "Disponible",
    "maps.settings.planned": "Planeado",
    "Planned": "Planeado",
    "maps.settings.origins_title": "Orígenes de sitio web permitidos",
    "Allowed website origins": "Orígenes de sitio web permitidos",
    "maps.settings.origins_description": "Los dominios registrados del tenant se permiten automáticamente. Agregue orígenes exactos aquí para otros sitios como staging.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Los dominios registrados del tenant se permiten automáticamente. Agregue orígenes exactos aquí para otros sitios como staging.",
    "maps.settings.registered_domains": "Dominios registrados",
    "Registered domains": "Dominios registrados",
    "maps.settings.no_domains": "No se cargaron dominios registrados.",
    "No registered domains were loaded.": "No se cargaron dominios registrados.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Agregar origen",
    "Add origin": "Agregar origen",
    "maps.settings.remove_origin": "Eliminar",
    "maps.settings.no_origins": "No se han agregado orígenes adicionales.",
    "No extra origins added.": "No se han agregado orígenes adicionales.",
    "maps.error.session_not_ready": "Su sesión de administración aún no está lista.",
    "Your admin session is not ready yet.": "Su sesión de administración aún no está lista.",
    "maps.error.load_data": "No se puede cargar los datos de Maps ({status}).",
    "Unable to load Maps data ({status}).": "No se puede cargar los datos de Maps ({status}).",
    "maps.error.load_usage": "No se puede cargar el uso de Maps.",
    "Unable to load Maps usage.": "No se puede cargar el uso de Maps.",
    "maps.error.load_settings": "No se puede cargar la configuración de Maps.",
    "Unable to load Maps settings.": "No se puede cargar la configuración de Maps.",
    "maps.error.save_settings": "No se puede guardar la configuración de Maps.",
    "Unable to save Maps settings.": "No se puede guardar la configuración de Maps.",
    "maps.error.invalid_origin": "Ingrese un origen completo, como https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Ingrese un origen completo, como https://staging.example.com.",
    "maps.error.registered_origin": "Este origen ya está cubierto por un dominio registrado.",
    "This origin is already covered by a registered domain.": "Este origen ya está cubierto por un dominio registrado.",
    "maps.error.address_required": "Ingrese una dirección o localidad para escanear.",
    "Enter an address or locality to scan.": "Ingrese una dirección o localidad para escanear.",
    "maps.error.location_not_found": "No se puede encontrar esa ubicación.",
    "Unable to find that location.": "No se puede encontrar esa ubicación.",
    "maps.error.no_coordinates": "No se encontraron coordenadas para esa dirección. Pruebe con una calle cercana, barrio o ciudad.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "No se encontraron coordenadas para esa dirección. Pruebe con una calle cercana, barrio o ciudad.",
    "maps.error.analyze_area": "No se puede analizar esta área.",
    "Unable to analyze this area.": "No se puede analizar esta área.",
    "maps.notice.settings_saved": "Configuración de Maps guardada.",
    "Maps settings saved.": "Configuración de Maps guardada.",
    "maps.status.success": "Éxito",
    "maps.status.error": "Error",
    "maps.operation.geocode": "Geocodificar",
    "Geocode": "Geocodificar",
    "maps.operation.maps_geocode": "Geocodificación de Maps",
    "Maps geocode": "Geocodificación de Maps",
    "maps.operation.market_analysis": "Análisis de mercado",
    "Market analysis": "Análisis de mercado",
    "maps.operation.maps_market_analysis": "Análisis de mercado de Maps",
    "Maps market analysis": "Análisis de mercado de Maps",
    "maps.operation.places_search": "Búsqueda de lugares",
    "Places search": "Búsqueda de lugares",
    "maps.operation.places_nearby": "Lugares cercanos",
    "Nearby places": "Lugares cercanos",
    "maps.operation.place_details": "Detalles del lugar",
    "Place details": "Detalles del lugar",
    "common.loading": "Cargando…",
    "common.saving": "Guardando…",
    "common.searching": "Buscando…",
    "Searching…": "Buscando…",
    "common.no_matches": "No se encontraron coincidencias.",
    "No matches found.": "No se encontraron coincidencias.",
    "common.select": "Seleccionar…",
    "Select…": "Seleccionar…",
    "common.search_users": "Buscar usuarios por nombre o correo electrónico",
    "Search users by name or email": "Buscar usuarios por nombre o correo electrónico",
    "common.reset": "Restablecer",
    "Reset": "Restablecer",
    "common.validation.email": "Introduzca una dirección de correo electrónico válida.",
    "Enter a valid email address.": "Introduzca una dirección de correo electrónico válida.",
    "common.validation.phone": "Introduzca un número de teléfono válido.",
    "Enter a valid phone number.": "Introduzca un número de teléfono válido.",
    "common.validation.currency": "Utilice un código de moneda de 3 letras, como USD.",
    "Use a 3-letter currency code, such as USD.": "Utilice un código de moneda de 3 letras, como USD.",
    "common.validation.location": "Introduzca una dirección o ubicación válida.",
    "Enter a valid address or location.": "Introduzca una dirección o ubicación válida.",
    "common.validation.required": "{label} es obligatorio.",
    "{label} is required.": "{label} es obligatorio.",
    "common.validation.invalid": "{label} no es válido.",
    "{label} is invalid.": "{label} no es válido.",
    "common.status.active": "Activo",
    "common.status.inactive": "Inactivo",
    "common.status.open": "Abierto",
    "common.status.closed": "Cerrado",
    "Closed": "Cerrado",
    "common.status.posted": "Publicado",
    "Posted": "Publicado",
    "common.status.voided": "Anulado",
    "Voided": "Anulado",
    "common.status.draft": "Borrador",
    "Draft": "Borrador",
    "common.status.success": "Éxito",
    "common.status.error": "Error",
    "accounting.title": "Contabilidad",
    "accounting.description": "Administra cuentas, mapeos, periodos, diarios y informes financieros.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Administra cuentas, mapeos, periodos, diarios y informes financieros.",
    "accounting.tab.overview": "Visión general",
    "accounting.tab.accounts": "Libro mayor",
    "accounting.tab.mappings": "Mapeos de cuentas",
    "Account mappings": "Mapeos de cuentas",
    "accounting.tab.periods": "Periodos contables",
    "Accounting periods": "Periodos contables",
    "accounting.tab.journals": "Diarios",
    "Journals": "Diarios",
    "accounting.tab.reports": "Informes",
    "accounting.account.edit_title": "Editar cuenta",
    "Edit account": "Editar cuenta",
    "accounting.account.new_title": "Nueva cuenta",
    "New account": "Nueva cuenta",
    "accounting.account.save": "Guardar cuenta",
    "Save account": "Guardar cuenta",
    "accounting.account.create": "Crear cuenta",
    "Create account": "Crear cuenta",
    "accounting.account.code": "Código de cuenta",
    "Account code": "Código de cuenta",
    "accounting.account.name": "Nombre de cuenta",
    "accounting.account.type": "Tipo de cuenta",
    "Account type": "Tipo de cuenta",
    "accounting.account.currency_id": "ID de moneda",
    "Currency ID": "ID de moneda",
    "accounting.account.active": "Activo",
    "accounting.account.unnamed": "Cuenta sin nombre",
    "Unnamed account": "Cuenta sin nombre",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Gasto de nómina",
    "Payroll expense": "Gasto de nómina",
    "accounting.type.asset": "Activo",
    "Asset": "Activo",
    "accounting.type.liability": "Pasivo",
    "Liability": "Pasivo",
    "accounting.type.equity": "Patrimonio",
    "Equity": "Patrimonio",
    "accounting.type.revenue": "Ingreso",
    "accounting.type.expense": "Gasto",
    "Expense": "Gasto",
    "accounting.toast.account_updated": "Cuenta actualizada",
    "Account updated": "Cuenta actualizada",
    "accounting.toast.account_created": "Cuenta creada",
    "Account created": "Cuenta creada",
    "accounting.toast.defaults_created": "Cuentas predeterminadas creadas",
    "Default accounts created": "Cuentas predeterminadas creadas",
    "accounting.toast.mapping_saved": "Asignación guardada",
    "Mapping saved": "Asignación guardada",
    "accounting.toast.period_closed": "Período contable cerrado",
    "Accounting period closed": "Período contable cerrado",
    "accounting.toast.period_created": "Período creado",
    "Period created": "Período creado",
    "accounting.toast.journal_created": "Diario creado",
    "Journal created": "Diario creado",
    "accounting.toast.journal_voided": "Diario anulado",
    "Journal voided": "Diario anulado",
    "accounting.validation.journal_balanced": "El diario debe tener una fecha, descripción y totales de débito y crédito equilibrados.",
    "Journal must have a date, description, and balanced debit and credit totals.": "El diario debe tener una fecha, descripción y totales de débito y crédito equilibrados.",
    "accounting.filter.all_types": "Todos los tipos de cuenta",
    "All account types": "Todos los tipos de cuenta",
    "accounting.filter.all_statuses": "Todos los estados",
    "All statuses": "Todos los estados",
    "accounting.action.bootstrap": "Configurar predeterminados",
    "Bootstrap defaults": "Configurar predeterminados",
    "accounting.action.new_account": "Nueva cuenta",
    "accounting.empty.accounts": "No se encontraron cuentas.",
    "No accounts found.": "No se encontraron cuentas.",
    "accounting.column.code": "Código",
    "Code": "Código",
    "accounting.column.account": "Cuenta",
    "accounting.column.type": "Tipo",
    "Type": "Tipo",
    "accounting.column.currency": "Moneda",
    "accounting.column.status": "Estado",
    "accounting.action.edit": "Editar",
    "accounting.mapping.edit_title": "Editar asignación de cuenta",
    "Edit account mapping": "Editar asignación de cuenta",
    "accounting.mapping.new_title": "Nueva asignación de cuenta",
    "New account mapping": "Nueva asignación de cuenta",
    "accounting.mapping.save": "Guardar asignación",
    "Save mapping": "Guardar asignación",
    "accounting.mapping.create": "Crear asignación",
    "Create mapping": "Crear asignación",
    "accounting.mapping.source_type": "Tipo de origen",
    "accounting.mapping.event_key": "Clave de evento",
    "Event key": "Clave de evento",
    "accounting.mapping.debit_account": "Cuenta de débito",
    "Debit account": "Cuenta de débito",
    "accounting.mapping.credit_account": "Cuenta de crédito",
    "Credit account": "Cuenta de crédito",
    "accounting.mapping.tax_account": "Cuenta de impuestos",
    "Tax account": "Cuenta de impuestos",
    "accounting.mapping.none": "Ninguno",
    "None": "Ninguno",
    "accounting.mapping.source_placeholder": "pedido",
    "order": "pedido",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filtrar tipo de origen",
    "Filter source type": "Filtrar tipo de origen",
    "accounting.action.new_mapping": "Nuevo mapeo",
    "New mapping": "Nuevo mapeo",
    "accounting.empty.mappings": "No se encontraron mapeos de cuenta.",
    "No account mappings found.": "No se encontraron mapeos de cuenta.",
    "accounting.column.source": "Origen",
    "Source": "Origen",
    "accounting.column.event": "Evento",
    "accounting.column.debit": "Débito",
    "Debit": "Débito",
    "accounting.column.credit": "Crédito",
    "Credit": "Crédito",
    "accounting.period.close_confirm": "¿Cerrar {period}? Esto no se puede deshacer.",
    "Close {period}? This cannot be reversed.": "¿Cerrar {period}? Esto no se puede deshacer.",
    "accounting.period.this": "este período contable",
    "this accounting period": "este período contable",
    "accounting.period.new_title": "Nuevo período contable",
    "New accounting period": "Nuevo período contable",
    "accounting.period.create": "Crear período",
    "Create period": "Crear período",
    "accounting.period.name": "Nombre del período",
    "Period name": "Nombre del período",
    "accounting.period.start": "Fecha de inicio",
    "accounting.period.end": "Fecha de finalización",
    "accounting.period.name_placeholder": "enero 2027",
    "January 2027": "enero 2027",
    "accounting.period.open": "Abrir",
    "accounting.period.closed": "Cerrado",
    "accounting.action.new_period": "Nuevo período",
    "New period": "Nuevo período",
    "accounting.empty.periods": "No se encontraron períodos contables.",
    "No accounting periods found.": "No se encontraron períodos contables.",
    "accounting.column.period": "Período",
    "accounting.column.start": "Inicio",
    "Start": "Inicio",
    "accounting.column.end": "Fin",
    "End": "Fin",
    "accounting.action.close_period": "Cerrar período",
    "Close period": "Cerrar período",
    "accounting.journal.new_title": "Nuevo diario",
    "New journal": "Nuevo diario",
    "accounting.journal.balance_help": "Los débitos y créditos deben equilibrarse antes de guardar.",
    "Debits and credits must balance before saving.": "Los débitos y créditos deben equilibrarse antes de guardar.",
    "accounting.journal.close": "Cerrar",
    "accounting.journal.entry_date": "Fecha de entrada",
    "Entry date": "Fecha de entrada",
    "accounting.journal.description": "Descripción",
    "accounting.journal.source_type": "Tipo de fuente",
    "accounting.journal.source_id": "ID de fuente",
    "Source ID": "ID de fuente",
    "accounting.journal.account": "Cuenta",
    "accounting.journal.select_account": "Seleccionar cuenta",
    "Select account": "Seleccionar cuenta",
    "accounting.journal.debit_total": "Débito: {debit} · Crédito: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Débito: {debit} · Crédito: {credit} · {status}",
    "accounting.journal.balanced": "Equilibrado",
    "Balanced": "Equilibrado",
    "accounting.journal.unbalanced": "Desbalanceado",
    "Unbalanced": "Desbalanceado",
    "accounting.journal.add_line": "Añadir línea",
    "Add line": "Añadir línea",
    "accounting.journal.save": "Guardar diario",
    "Save journal": "Guardar diario",
    "accounting.journal.empty": "No hay líneas de diario.",
    "No journal lines.": "No hay líneas de diario.",
    "accounting.journal.reason_prompt": "Razón para anular este diario:",
    "Reason for voiding this journal:": "Razón para anular este diario:",
    "accounting.journal.details_title": "Diario #{id}",
    "Journal #{id}": "Diario #{id}",
    "accounting.action.view": "Ver",
    "View": "Ver",
    "accounting.action.void": "Anular",
    "Void": "Anular",
    "accounting.filter.all_accounts": "Todas las cuentas",
    "All accounts": "Todas las cuentas",
    "accounting.empty.journals": "No se encontraron diarios.",
    "No journals found.": "No se encontraron diarios.",
    "accounting.column.date": "Fecha",
    "accounting.column.description": "Descripción",
    "accounting.column.account_source": "Origen",
    "accounting.empty.journal_lines": "No hay líneas de diario.",
    "accounting.report.trial_balance": "Balance de comprobación",
    "Trial balance": "Balance de comprobación",
    "accounting.report.general_ledger": "Libro mayor",
    "General ledger": "Libro mayor",
    "accounting.action.run_report": "Ejecutar informe",
    "Run report": "Ejecutar informe",
    "accounting.report.loading": "Cargando informe…",
    "Loading report…": "Cargando informe…",
    "accounting.empty.report": "No se encontraron filas de informe.",
    "No report rows found.": "No se encontraron filas de informe.",
    "accounting.report.choose_run": "Seleccione un informe y ejecútelo.",
    "Choose a report and run it.": "Seleccione un informe y ejecútelo.",
    "accounting.column.balance": "Saldo",
    "Balance": "Saldo",
    "accounting.overview.chart_title": "Libro de cuentas",
    "accounting.overview.chart_description": "Defina las cuentas utilizadas por su libro mayor.",
    "Define the accounts used by your ledger.": "Defina las cuentas utilizadas por su libro mayor.",
    "accounting.overview.journals_title": "Diarios",
    "accounting.overview.journals_description": "Cree y revise entradas de diario equilibradas.",
    "Create and review balanced journal entries.": "Cree y revise entradas de diario equilibradas.",
    "accounting.overview.reports_title": "Informes",
    "accounting.overview.reports_description": "Ejecute informes de balance de comprobación y libro mayor.",
    "Run trial balance and general ledger reports.": "Ejecute informes de balance de comprobación y libro mayor.",
    "common.refresh": "Actualizar",
    "reports.search.title": "Buscar análisis",
    "Search analytics": "Buscar análisis",
    "reports.search.back_to_report": "Volver al informe",
    "Back to report": "Volver al informe",
    "reports.search.description": "La búsqueda de demanda muestra lo que los visitantes están buscando y dónde necesita cobertura tu catálogo.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "La búsqueda de demanda muestra lo que los visitantes están buscando y dónde necesita cobertura tu catálogo.",
    "reports.search.metric.searches": "Búsquedas",
    "Searches": "Búsquedas",
    "reports.search.metric.unique_keywords": "Palabras clave únicas",
    "Unique keywords": "Palabras clave únicas",
    "reports.search.metric.with_listings": "Con listados",
    "With listings": "Con listados",
    "reports.search.metric.no_matches": "Sin coincidencias en listados",
    "No listing matches": "Sin coincidencias en listados",
    "reports.search.metric.coverage": "Cobertura",
    "Coverage": "Cobertura",
    "reports.search.insights.title": "Consejos para administradores",
    "Admin insights": "Consejos para administradores",
    "reports.search.insights.no_results_one": "{count} palabra clave no devolvió listados. Considere crear un listado, agregar el término como categoría o etiqueta, o mejorar el título y descripción del listado.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "{count} palabra clave no devolvió listados. Considere crear un listado, agregar el término como categoría o etiqueta, o mejorar el título y descripción del listado.",
    "reports.search.insights.no_results_many": "{count} palabras clave no devolvieron listados. Considere crear listados, agregar los términos como categorías o etiquetas, o mejorar los títulos y descripciones de los listados.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} palabras clave no devolvieron listados. Considere crear listados, agregar los términos como categorías o etiquetas, o mejorar los títulos y descripciones de los listados.",
    "reports.search.insights.all_covered": "Cada palabra clave rastreada devolvió al menos un listado. Revise las palabras clave más frecuentes para mejorar la mercadotecnia y la ubicación de categorías.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Cada palabra clave rastreada devolvió al menos un listado. Revise las palabras clave más frecuentes para mejorar la mercadotecnia y la ubicación de categorías.",
    "reports.search.insights.empty": "Los datos de búsqueda aparecerán después de que los visitantes busquen en el mercado.",
    "Search data will appear after visitors search the marketplace.": "Los datos de búsqueda aparecerán después de que los visitantes busquen en el mercado.",
    "reports.search.insights.total_matches": "{count} coincidencias totales de listados fueron devueltas en los registros de búsqueda cargados.",
    "{count} total listing matches were returned across the loaded search records.": "{count} coincidencias totales de listados fueron devueltas en los registros de búsqueda cargados.",
    "reports.search.coverage_title": "Cobertura de palabras clave",
    "Keyword coverage": "Cobertura de palabras clave",
    "reports.search.loading": "Cargando análisis de búsqueda…",
    "Loading search analytics…": "Cargando análisis de búsqueda…",
    "reports.search.empty": "No se encontraron frases de búsqueda.",
    "No search phrases found.": "No se encontraron frases de búsqueda.",
    "reports.search.error.load": "No se puede cargar el análisis de búsqueda.",
    "Unable to load search analytics.": "No se puede cargar el análisis de búsqueda.",
    "reports.search.unknown": "Búsqueda desconocida",
    "Unknown search": "Búsqueda desconocida",
    "reports.search.column.keyword": "Palabra clave",
    "Keyword": "Palabra clave",
    "reports.search.column.listings": "Listados",
    "reports.search.column.coverage": "Cobertura",
    "reports.search.column.last_searched": "Última búsqueda",
    "Last searched": "Última búsqueda",
    "reports.search.column.suggested_action": "Acción sugerida",
    "Suggested action": "Acción sugerida",
    "reports.search.status.covered": "Cubierta",
    "Covered": "Cubierta",
    "reports.search.status.no_matches": "Sin coincidencias",
    "No matches": "Sin coincidencias",
    "reports.search.action.review_ranking": "Revisar clasificación",
    "Review ranking": "Revisar clasificación",
    "reports.search.action.add_listing": "Agregar lista o categoría",
    "Add listing or category": "Agregar lista o categoría",
    "platform_health.title": "Salud de la plataforma",
    "Platform health": "Salud de la plataforma",
    "platform_health.tab.health": "Salud",
    "Health": "Salud",
    "platform_health.tab.configuration": "Configuración",
    "Configuration": "Configuración",
    "platform_health.action.refreshing": "Actualizando…",
    "Refreshing…": "Actualizando…",
    "platform_health.window_note": "La vista actual carga los primeros {count} registros para cada tipo de evento.",
    "The current view loads the first {count} records for each event type.": "La vista actual carga los primeros {count} registros para cada tipo de evento.",
    "platform_health.error.title": "No se pueden cargar los informes de autenticación",
    "Unable to load authentication audits": "No se pueden cargar los informes de autenticación",
    "platform_health.error.proxy_note": "La API puede requerir que esta solicitud de administrador se envíe de forma proxy desde el servidor en lugar de directamente desde el navegador.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "La API puede requerir que esta solicitud de administrador se envíe de forma proxy desde el servidor en lugar de directamente desde el navegador.",
    "platform_health.error.session": "Su sesión de administración aún no está lista. Inicie sesión nuevamente.",
    "Your admin session is not ready yet. Please sign in again.": "Su sesión de administración aún no está lista. Inicie sesión nuevamente.",
    "platform_health.error.load": "No se pueden cargar los informes de autenticación ({status}).",
    "Unable to load authentication audits ({status}).": "No se pueden cargar los informes de autenticación ({status}).",
    "platform_health.error.load_generic": "No se pueden cargar los informes de auditoría de la plataforma.",
    "Unable to load platform health audits.": "No se pueden cargar los informes de auditoría de la plataforma.",
    "platform_health.metric.login_attempts": "Intentos de inicio de sesión",
    "Login attempts": "Intentos de inicio de sesión",
    "platform_health.metric.signup_attempts": "Intentos de registro",
    "Signup attempts": "Intentos de registro",
    "platform_health.metric.audit_records": "Registros de auditoría",
    "Audit records": "Registros de auditoría",
    "platform_health.metric.successful": "Exitosos",
    "platform_health.metric.failed": "Fallidos",
    "platform_health.metric.outcome_returned": "Solo cuando el resultado se devuelve",
    "Only when outcome is returned": "Solo cuando el resultado se devuelve",
    "platform_health.metric.failure_rate": "Tasa de fallos",
    "Failure rate": "Tasa de fallos",
    "platform_health.metric.classified_records": "Registros clasificados",
    "Classified records": "Registros clasificados",
    "platform_health.activity.title": "Actividad de autenticación",
    "Authentication activity": "Actividad de autenticación",
    "platform_health.activity.description": "Intentos devueltos por la ventana de auditoría seleccionada",
    "Attempts returned by the selected audit window": "Intentos devueltos por la ventana de auditoría seleccionada",
    "platform_health.activity.no_timestamps": "No se devolvieron registros de auditoría con marca de tiempo.",
    "No timestamped audit records returned.": "No se devolvieron registros de auditoría con marca de tiempo.",
    "platform_health.event.login": "inicio de sesión",
    "login": "inicio de sesión",
    "platform_health.event.signup": "registro",
    "signup": "registro",
    "platform_health.status.success": "Éxito",
    "platform_health.status.failed": "Fallido",
    "platform_health.status.recorded": "Registrado",
    "Recorded": "Registrado",
    "platform_health.unknown_day": "Desconocido",
    "Unknown": "Desconocido",
    "platform_health.failure_reasons": "Razones de fallo",
    "Failure reasons": "Razones de fallo",
    "platform_health.no_failures": "No se devolvieron fallas clasificadas.",
    "No classified failures returned.": "No se devolvieron fallas clasificadas.",
    "platform_health.unspecified_failure": "Fallo no especificado",
    "Unspecified failure": "Fallo no especificado",
    "platform_health.recent_records": "Registros de auditoría recientes",
    "Recent audit records": "Registros de auditoría recientes",
    "platform_health.normalized_note": "Los campos sin procesar solo se normalizan para su visualización.",
    "Raw fields are normalized only for display.": "Los campos sin procesar solo se normalizan para su visualización.",
    "platform_health.loaded_count": "{count} cargados",
    "{count} loaded": "{count} cargados",
    "platform_health.loading_records": "Cargando registros de auditoría…",
    "Loading audit records…": "Cargando registros de auditoría…",
    "platform_health.no_records": "No se devolvieron registros de auditoría.",
    "No audit records returned.": "No se devolvieron registros de auditoría.",
    "platform_health.column.event": "Evento",
    "platform_health.column.status": "Estado",
    "platform_health.column.user": "Usuario",
    "User": "Usuario",
    "platform_health.column.time": "Hora",
    "Time": "Hora",
    "platform_health.column.reason": "Razón",
    "platform_health.config.sign_in": "Método de inicio de sesión",
    "Sign-in method": "Método de inicio de sesión",
    "platform_health.config.facebook": "Autenticación de Facebook",
    "Facebook Auth": "Autenticación de Facebook",
    "platform_health.config.google": "Autenticación de Google",
    "Google Auth": "Autenticación de Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Estos ajustes se aplican inmediatamente. Después de guardarlos, aparecen en aplicaciones y respuestas de API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Estos ajustes se aplican inmediatamente. Después de guardarlos, aparecen en aplicaciones y respuestas de API.",
    "integrations.note.mobile_release": "La configuración del canal de aplicación móvil se aplica cuando se lanza o actualiza un producto. Para obtener una nueva compilación, solicítela desde el Portal de Soporte. Esto aplica para el plan Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "La configuración del canal de aplicación móvil se aplica cuando se lanza o actualiza un producto. Para obtener una nueva compilación, solicítela desde el Portal de Soporte. Esto aplica para el plan Starter.",
    "integrations.toast.saved": "Configuración de integración guardada.",
    "Integration settings saved.": "Configuración de integración guardada.",
    "integrations.error.save": "No se pueden guardar las configuraciones de la integración.",
    "Unable to save integration settings.": "No se pueden guardar las configuraciones de la integración.",
    "integrations.twilio.title": "Integración de Twilio",
    "Twilio integration": "Integración de Twilio",
    "integrations.twilio.account_sid": "SID de cuenta",
    "Account SID": "SID de cuenta",
    "integrations.twilio.account_sid_placeholder": "Introduzca el SID de la cuenta",
    "Enter account SID": "Introduzca el SID de la cuenta",
    "integrations.twilio.auth_token": "Token de autenticación",
    "Auth token": "Token de autenticación",
    "integrations.twilio.auth_token_placeholder": "Introduzca el token de autenticación",
    "Enter auth token": "Introduzca el token de autenticación",
    "integrations.twilio.source_phone": "Número de teléfono de origen",
    "Source phone number": "Número de teléfono de origen",
    "integrations.twilio.source_phone_placeholder": "Introduzca el número de teléfono de origen",
    "Enter source phone number": "Introduzca el número de teléfono de origen",
    "integrations.facebook.title": "Autenticación de Facebook",
    "integrations.facebook.enable_login": "Habilitar inicio de sesión de Facebook",
    "Enable Facebook login": "Habilitar inicio de sesión de Facebook",
    "integrations.facebook.app_id": "ID de aplicación",
    "App ID": "ID de aplicación",
    "integrations.facebook.app_id_placeholder": "Introduzca el ID de aplicación",
    "integrations.google.title": "Autenticación de Google",
    "integrations.google.enable_sign_in": "Habilitar inicio de sesión con Google",
    "Enable Google sign-in": "Habilitar inicio de sesión con Google",
    "integrations.google.client_id": "ID de cliente",
    "Client ID": "ID de cliente",
    "integrations.google.client_id_placeholder": "Introduzca el ID de cliente",
    "Enter client ID": "Introduzca el ID de cliente",
    "integrations.auth.title": "Método de inicio de sesión",
    "integrations.auth.description": "Elija cómo los usuarios se registran y acceden. El correo electrónico y la verificación por SMS usan la configuración de entrega configurada para el tenant.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Elija cómo los usuarios se registran y acceden. El correo electrónico y la verificación por SMS usan la configuración de entrega configurada para el tenant.",
    "integrations.auth.empty": "No hay ningún método de inicio de sesión compatible configurado actualmente. Seleccione uno para continuar.",
    "No supported sign-in method is currently configured. Select one to continue.": "No hay ningún método de inicio de sesión compatible configurado actualmente. Seleccione uno para continuar.",
    "integrations.auth.save_note": "Al guardar se aplica este método a los puntos de acceso de registro y inicio de sesión del tenant. Los usuarios directamente provisionados se gestionan por separado.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Al guardar se aplica este método a los puntos de acceso de registro y inicio de sesión del tenant. Los usuarios directamente provisionados se gestionan por separado.",
    "integrations.auth.error.load": "No se puede cargar el método de inicio de sesión actual.",
    "Unable to load the current sign-in method.": "No se puede cargar el método de inicio de sesión actual.",
    "integrations.auth.error.save": "No se puede guardar el método de inicio de sesión.",
    "Unable to save the sign-in method.": "No se puede guardar el método de inicio de sesión.",
    "integrations.auth.toast.saved": "Método de inicio de sesión guardado.",
    "Sign-in method saved.": "Método de inicio de sesión guardado.",
    "integrations.auth.email_password": "Correo electrónico y contraseña",
    "Email and password": "Correo electrónico y contraseña",
    "integrations.auth.email_password_help": "Los usuarios verifican su correo electrónico durante el registro, luego inician sesión con una contraseña.",
    "Users verify their email during sign-up, then sign in with a password.": "Los usuarios verifican su correo electrónico durante el registro, luego inician sesión con una contraseña.",
    "integrations.auth.email_code": "Código de verificación por correo electrónico",
    "Email one-time code": "Código de verificación por correo electrónico",
    "integrations.auth.email_code_help": "Los usuarios reciben un código de verificación por correo electrónico para el registro y el inicio de sesión.",
    "Users receive a verification code by email for sign-up and sign-in.": "Los usuarios reciben un código de verificación por correo electrónico para el registro y el inicio de sesión.",
    "integrations.auth.phone_code": "Código de verificación por teléfono",
    "Phone one-time code": "Código de verificación por teléfono",
    "integrations.auth.phone_code_help": "Los usuarios reciben un código de verificación por SMS para el registro y el inicio de sesión.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Los usuarios reciben un código de verificación por SMS para el registro y el inicio de sesión.",
    "integrations.auth.phone_password": "Teléfono y contraseña",
    "Phone and password": "Teléfono y contraseña",
    "integrations.auth.phone_password_help": "Los usuarios verifican su teléfono durante el registro, luego inician sesión con una contraseña.",
    "Users verify their phone during sign-up, then sign in with a password.": "Los usuarios verifican su teléfono durante el registro, luego inician sesión con una contraseña.",
    "integrations.auth.email_password_unverified": "Correo electrónico y contraseña sin verificación de registro",
    "Email and password without sign-up verification": "Correo electrónico y contraseña sin verificación de registro",
    "integrations.auth.email_password_unverified_help": "Los usuarios pueden registrarse con un correo electrónico y contraseña sin un código de verificación por correo electrónico.",
    "Users can sign up with an email and password without an email verification code.": "Los usuarios pueden registrarse con un correo electrónico y contraseña sin un código de verificación por correo electrónico.",
    "integrations.auth.phone_password_unverified": "Teléfono y contraseña sin verificación de registro",
    "Phone and password without sign-up verification": "Teléfono y contraseña sin verificación de registro",
    "integrations.auth.phone_password_unverified_help": "Los usuarios pueden registrarse con un teléfono y contraseña sin un código de verificación por SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Los usuarios pueden registrarse con un teléfono y contraseña sin un código de verificación por SMS.",
    "integrations.page.title": "Integraciones de aplicación",
    "App Integrations": "Integraciones de aplicación",
    "integrations.generic.id_placeholder": "Introduzca el ID de {name}",
    "Enter {name} ID": "Introduzca el ID de {name}",
    "integrations.generic.enable": "Habilitar la integración de {name}",
    "Enable {name} integration": "Habilitar la integración de {name}",
    "integrations.menu.map": "Mapas",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Integración de mapas",
    "Maps integration": "Integración de mapas",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Clave de API",
    "integrations.maps.api_key_placeholder": "Introduzca clave de API",
    "integrations.maps.reverse_geocode_key": "Clave de API de geocodificación inversa de Google Maps",
    "Google Maps reverse geocoding API key": "Clave de API de geocodificación inversa de Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Introduzca clave de API de geocodificación inversa de Google Maps",
    "Enter Google Maps reverse geocoding API key": "Introduzca clave de API de geocodificación inversa de Google Maps",
    "integrations.maps.places_key": "Clave de API de Google Maps Places",
    "Google Maps Places API key": "Clave de API de Google Maps Places",
    "integrations.maps.places_key_placeholder": "Introduzca clave de API de Google Maps Places",
    "Enter Google Maps Places API key": "Introduzca clave de API de Google Maps Places",
    "integrations.maps.nearby_accounts": "Activar cuentas cercanas en la página de inicio",
    "Activate nearby accounts on the home page": "Activar cuentas cercanas en la página de inicio",
    "integrations.maps.listing_location": "Activar ubicación en la presentación de listado",
    "Activate location in listing submission": "Activar ubicación en la presentación de listado",
    "integrations.maps.account_location": "Activar ubicación en la presentación de cuenta",
    "Activate location in account submission": "Activar ubicación en la presentación de cuenta",
    "integrations.playstore.title": "Integración de Google Play",
    "Google Play integration": "Integración de Google Play",
    "integrations.playstore.application_id": "ID de aplicación",
    "Application ID": "ID de aplicación",
    "integrations.playstore.application_id_placeholder": "Introduzca ID de aplicación (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Introduzca ID de aplicación (com.tenantname.app)",
    "integrations.playstore.first_name": "Nombre",
    "integrations.playstore.first_name_placeholder": "Introduzca nombre",
    "Enter first name": "Introduzca nombre",
    "integrations.playstore.last_name": "Apellido",
    "integrations.playstore.last_name_placeholder": "Introduzca apellido",
    "Enter last name": "Introduzca apellido",
    "integrations.playstore.unit": "Unidad organizacional",
    "Organizational unit": "Unidad organizacional",
    "integrations.playstore.unit_placeholder": "Introduzca unidad organizacional",
    "Enter organizational unit": "Introduzca unidad organizacional",
    "integrations.playstore.organization": "Organización",
    "Organization": "Organización",
    "integrations.playstore.organization_placeholder": "Introduzca nombre de organización",
    "Enter organization name": "Introduzca nombre de organización",
    "integrations.playstore.city": "Ciudad o localidad",
    "City or locality": "Ciudad o localidad",
    "integrations.playstore.city_placeholder": "Introduzca ciudad o localidad",
    "Enter city or locality": "Introduzca ciudad o localidad",
    "integrations.playstore.state": "Estado o provincia",
    "State or province": "Estado o provincia",
    "integrations.playstore.state_placeholder": "Introduzca estado o provincia",
    "Enter state or province": "Introduzca estado o provincia",
    "integrations.playstore.country_code": "Código de país (XX)",
    "Country code (XX)": "Código de país (XX)",
    "integrations.playstore.country_code_placeholder": "Introduzca código de país",
    "Enter country code": "Introduzca código de país",
    "integrations.playstore.link": "Enlace de Google Play",
    "Google Play link": "Enlace de Google Play",
    "integrations.playstore.link_placeholder": "Introduzca el enlace de Google Play de su aplicación",
    "Enter your app Google Play link": "Introduzca el enlace de Google Play de su aplicación",
    "integrations.admob.title": "Integración de AdMob",
    "AdMob integration": "Integración de AdMob",
    "integrations.admob.app_id": "ID de aplicación",
    "integrations.admob.app_id_placeholder": "Introduzca ID de aplicación",
    "Enter App ID": "Introduzca ID de aplicación",
    "integrations.admob.unit_id": "ID de unidad",
    "Unit ID": "ID de unidad",
    "integrations.admob.unit_id_placeholder": "Introduzca ID de unidad AdMob",
    "Enter AdMob unit ID": "Introduzca ID de unidad AdMob",
    "integrations.admob.listings_id": "ID de listados",
    "Listings ID": "ID de listados",
    "integrations.admob.listings_id_placeholder": "Introduzca ID de listados",
    "Enter listings ID": "Introduzca ID de listados",
    "integrations.admob.listing_detail_id": "ID de detalle de listado",
    "Listing detail ID": "ID de detalle de listado",
    "integrations.admob.listing_detail_id_placeholder": "Introduzca ID de detalle de listado",
    "Enter listing detail ID": "Introduzca ID de detalle de listado",
    "integrations.admob.home_id": "ID de inicio",
    "Home ID": "ID de inicio",
    "integrations.admob.home_id_placeholder": "Introduzca ID de inicio",
    "Enter home ID": "Introduzca ID de inicio",
    "integrations.admob.enable_ads": "Habilitar anuncios",
    "Enable ads": "Habilitar anuncios",
    "integrations.admob.enable_listing_ads": "Habilitar anuncios en el feed de listados",
    "Enable ads on the listings feed": "Habilitar anuncios en el feed de listados",
    "integrations.admob.enable_listing_detail_ads": "Habilitar anuncios en detalles de listado",
    "Enable ads on listing details": "Habilitar anuncios en detalles de listado",
    "integrations.admob.enable_home_ads": "Habilitar anuncios en la navegación inferior de inicio",
    "Enable ads in the home bottom navigation": "Habilitar anuncios en la navegación inferior de inicio",
    "integrations.save_success": "Guardado con éxito",
    "Saved successfully": "Guardado con éxito",
    "integrations.note.release": "Estos ajustes se aplican cuando la aplicación móvil se lanza o actualiza. Solicite un nuevo build desde el Portal de Soporte después de hacer cambios. Aplica el plan Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Estos ajustes se aplican cuando la aplicación móvil se lanza o actualiza. Solicite un nuevo build desde el Portal de Soporte después de hacer cambios. Aplica el plan Starter.",
    "integrations.action.download": "Descargar",
    "integrations.branch.title": "Integración de Branch",
    "Branch integration": "Integración de Branch",
    "integrations.branch.app_id": "ID de aplicación",
    "integrations.branch.app_id_placeholder": "Introduzca el ID de la aplicación",
    "integrations.branch.live_key": "Clave en vivo",
    "Live key": "Clave en vivo",
    "integrations.branch.live_key_placeholder": "Introduzca clave en vivo",
    "Enter live key": "Introduzca clave en vivo",
    "integrations.branch.live_secret": "Secreto en vivo",
    "Live secret": "Secreto en vivo",
    "integrations.branch.live_secret_placeholder": "Introduzca secreto en vivo",
    "Enter live secret": "Introduzca secreto en vivo",
    "integrations.branch.uri_scheme": "Esquema URI",
    "URI scheme": "Esquema URI",
    "integrations.branch.uri_scheme_placeholder": "Introduzca esquema URI",
    "Enter URI scheme": "Introduzca esquema URI",
    "integrations.branch.link_domain": "Dominio del enlace",
    "Link domain": "Dominio del enlace",
    "integrations.branch.link_domain_placeholder": "Introduzca dominio del enlace",
    "Enter link domain": "Introduzca dominio del enlace",
    "integrations.branch.alternate_domain": "Dominio alternativo del enlace",
    "Alternate link domain": "Dominio alternativo del enlace",
    "integrations.branch.alternate_domain_placeholder": "Introduzca dominio alternativo del enlace",
    "Enter alternate link domain": "Introduzca dominio alternativo del enlace",
    "integrations.branch.link_description": "Descripción del enlace",
    "Link description": "Descripción del enlace",
    "integrations.branch.link_description_placeholder": "Introduzca descripción del enlace",
    "Enter link description": "Introduzca descripción del enlace",
    "integrations.branch.invite_friends": "Invitar amigos",
    "Invite friends": "Invitar amigos",
    "integrations.branch.invite_title": "Título",
    "integrations.branch.invite_description": "Descripción",
    "integrations.branch.destination_link": "Enlace de destino de Branch (opcional)",
    "Branch destination link (optional)": "Enlace de destino de Branch (opcional)",
    "integrations.branch.web_app_note": "Aplica a usuarios de aplicación web",
    "Applies to web app users": "Aplica a usuarios de aplicación web",
    "integrations.branch.destination_placeholder": "Introduzca enlace de destino de Branch",
    "Enter branch destination link": "Introduzca enlace de destino de Branch",
    "integrations.ios.title": "Provisión de App Store",
    "App Store provisioning": "Provisión de App Store",
    "integrations.ios.bundle_id": "ID de paquete",
    "Bundle ID": "ID de paquete",
    "integrations.ios.bundle_id_placeholder": "Introduzca ID de paquete",
    "Enter bundle ID": "Introduzca ID de paquete",
    "integrations.ios.certificate_password": "Contraseña del certificado de distribución",
    "Distribution certificate password": "Contraseña del certificado de distribución",
    "integrations.ios.certificate_password_placeholder": "Introduzca contraseña del certificado de distribución",
    "Enter distribution certificate password": "Introduzca contraseña del certificado de distribución",
    "integrations.ios.push_key_id": "ID de clave de notificación",
    "Push key ID": "ID de clave de notificación",
    "integrations.ios.push_key_id_placeholder": "Introduzca ID de clave de notificación",
    "Enter push key ID": "Introduzca ID de clave de notificación",
    "integrations.ios.team_id": "ID de equipo",
    "Team ID": "ID de equipo",
    "integrations.ios.team_id_placeholder": "Introduzca ID de equipo",
    "Enter team ID": "Introduzca ID de equipo",
    "integrations.ios.apple_id": "ID de Apple",
    "Apple ID": "ID de Apple",
    "integrations.ios.apple_id_placeholder": "Introduzca ID de Apple",
    "Enter Apple ID": "Introduzca ID de Apple",
    "integrations.ios.distribution_certificate": "Certificado de distribución",
    "Distribution certificate": "Certificado de distribución",
    "integrations.ios.provisioning_profile": "Perfil de aprovisionamiento de distribución",
    "Distribution provisioning profile": "Perfil de aprovisionamiento de distribución",
    "integrations.ios.push_key": "Clave de notificación",
    "Push key": "Clave de notificación",
    "integrations.ios.app_store_link": "Enlace de App Store",
    "Your App Store link": "Enlace de App Store",
    "integrations.ios.app_store_link_placeholder": "Introduzca el enlace de App Store de su aplicación",
    "Enter your app App Store link": "Introduzca el enlace de App Store de su aplicación",
    "integrations.firebase.title": "Integración de Firebase",
    "Firebase integration": "Integración de Firebase",
    "integrations.firebase.choose_file": "Elegir archivo",
    "integrations.firebase.service_account": "Cuenta de servicio Firebase",
    "Firebase service account": "Cuenta de servicio Firebase",
    "integrations.firebase.android_json": "Archivo JSON de aplicación Android",
    "Android app JSON file": "Archivo JSON de aplicación Android",
    "integrations.firebase.ios_plist": "Archivo plist de aplicación iOS",
    "iOS app plist file": "Archivo plist de aplicación iOS",
    "integrations.firebase.create_project": "Crear proyecto Firebase",
    "Create Firebase project": "Crear proyecto Firebase",
    "integrations.firebase.create_android": "Crear aplicación Android",
    "Create Android app": "Crear aplicación Android",
    "integrations.firebase.create_ios": "Crear aplicación iOS",
    "Create iOS app": "Crear aplicación iOS",
    "integrations.firebase.create_database": "Crear base de datos en tiempo real",
    "Create realtime database": "Crear base de datos en tiempo real",
    "integrations.firebase.apply_rules": "Aplicar reglas de base de datos Firebase",
    "Apply Firebase database rules": "Aplicar reglas de base de datos Firebase",
    "bundles.listing_number": "Listado #{id}",
    "Listing #{id}": "Listado #{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Configurar paquete",
    "Configure bundle": "Configurar paquete",
    "bundles.configure.subtitle": "Lista de paquetes # {id} · añade listados existentes a continuación.",
    "Bundle listing #{id} · add existing listings below.": "Lista de paquetes # {id} · añade listados existentes a continuación.",
    "bundles.back": "Volver a paquetes",
    "Back to bundles": "Volver a paquetes",
    "bundles.fixed_components": "Componentes fijos",
    "Fixed components": "Componentes fijos",
    "bundles.selection_pool": "Bolsa de combinación",
    "Mix-and-match pool": "Bolsa de combinación",
    "bundles.available_listings": "Listados disponibles",
    "Available listings": "Listados disponibles",
    "bundles.available_description": "Busca y añade productos ya en tu catálogo.",
    "Search and add products already in your catalogue.": "Busca y añade productos ya en tu catálogo.",
    "bundles.search_listings": "Buscar listados",
    "Search listings": "Buscar listados",
    "bundles.quantity_per_component": "Cantidad por componente",
    "Quantity per component": "Cantidad por componente",
    "bundles.loading_listings": "Cargando listados…",
    "Loading listings…": "Cargando listados…",
    "bundles.added": "Añadido",
    "Added": "Añadido",
    "bundles.adding": "Añadiendo…",
    "Adding…": "Añadiendo…",
    "bundles.add": "Añadir",
    "bundles.no_matching_listings": "No se encontraron listados coincidentes.",
    "No matching listings found.": "No se encontraron listados coincidentes.",
    "bundles.one_listing_added": "1 listado añadido",
    "1 listing added": "1 listado añadido",
    "bundles.many_listings_added": "{count} listados añadidos",
    "{count} listings added": "{count} listados añadidos",
    "bundles.quantity_short": "Cant. {count}",
    "Qty {count}": "Cant. {count}",
    "bundles.removing": "Eliminando…",
    "Removing…": "Eliminando…",
    "bundles.remove": "Eliminar",
    "bundles.no_components": "Aún no se han añadido componentes.",
    "No components added yet.": "Aún no se han añadido componentes.",
    "bundles.pool_remove_note": "La eliminación de la piscina requiere el punto final de eliminación del backend; las adiciones están habilitadas ahora.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "La eliminación de la piscina requiere el punto final de eliminación del backend; las adiciones están habilitadas ahora.",
    "bundles.error.load_components": "No se pueden cargar los componentes del paquete.",
    "Unable to load bundle components.": "No se pueden cargar los componentes del paquete.",
    "bundles.error.add_listing": "No se puede añadir la listado al paquete.",
    "Unable to add listing to the bundle.": "No se puede añadir la listado al paquete.",
    "bundles.error.remove_component": "No se puede eliminar el componente del paquete.",
    "Unable to remove bundle component.": "No se puede eliminar el componente del paquete.",
    "bundles.error.load_listings": "No se pueden cargar las listas.",
    "Unable to load listings.": "No se pueden cargar las listas.",
    "bundles.components": "Componentes del paquete",
    "Bundle components": "Componentes del paquete",
    "bundles.picker_description": "Selecciona listados que ya existen en tu catálogo. Se vincularán después de crear el paquete.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Selecciona listados que ya existen en tu catálogo. Se vincularán después de crear el paquete.",
    "bundles.fixed_bundle": "Paquete fijo",
    "Fixed bundle": "Paquete fijo",
    "bundles.mix_match": "Mezcla y combina",
    "Mix and match": "Mezcla y combina",
    "bundles.quantity_per_selected": "Cantidad por listado seleccionado",
    "Quantity per selected listing": "Cantidad por listado seleccionado",
    "bundles.search_existing": "Buscar listados existentes",
    "Search existing listings": "Buscar listados existentes",
    "bundles.selected_count": "Seleccionados ({count})",
    "Selected ({count})": "Seleccionados ({count})",
    "bundles.choose_component_hint": "Elige al menos un listado existente, o crea el paquete primero.",
    "Choose at least one existing listing, or create the bundle first.": "Elige al menos un listado existente, o crea el paquete primero.",
    "bundles.error.attach_components": "El paquete se creó, pero no se pudieron adjuntar los componentes.",
    "The bundle was created, but components could not be attached.": "El paquete se creó, pero no se pudieron adjuntar los componentes.",
    "bundles.continue_configure_hint": "Puedes continuar desde la página de configuración del paquete.",
    "You can continue from the bundle configuration page.": "Puedes continuar desde la página de configuración del paquete.",
    "bundles.title": "Paquetes",
    "bundles.create": "Crear paquete",
    "Create bundle": "Crear paquete",
    "bundles.subtitle": "Crea una lista de paquete principal, luego adjunta componentes fijos o un grupo de selección mixta.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Crea una lista de paquete principal, luego adjunta componentes fijos o un grupo de selección mixta.",
    "bundles.workflow": "Flujo de trabajo del paquete",
    "Bundle workflow": "Flujo de trabajo del paquete",
    "bundles.how_it_works": "Cómo funcionan los paquetes",
    "How bundles work": "Cómo funcionan los paquetes",
    "bundles.parent_description": "Una sola lista principal controla el paquete visible al cliente.",
    "One parent listing controls the customer-facing bundle.": "Una sola lista principal controla el paquete visible al cliente.",
    "bundles.flow": "Flujo del paquete",
    "Bundle flow": "Flujo del paquete",
    "bundles.parent_listing": "Lista principal",
    "Parent listing": "Lista principal",
    "bundles.name_price_category": "Nombre, precio, categoría",
    "Name, price, category": "Nombre, precio, categoría",
    "bundles.fixed_or_pool": "Artículos fijos o un grupo",
    "Fixed items or a pool": "Artículos fijos o un grupo",
    "bundles.checkout_stock": "Stock en caja",
    "Checkout stock": "Stock en caja",
    "bundles.selection_availability": "Selección + disponibilidad",
    "Selection + availability": "Selección + disponibilidad",
    "bundles.fixed_bundles": "Paquetes fijos",
    "Fixed bundles": "Paquetes fijos",
    "bundles.fixed_description": "Vende un grupo definido de listados existentes juntos.",
    "Sell a defined group of existing listings together.": "Vende un grupo definido de listados existentes juntos.",
    "bundles.fixed_detail": "Agregar listados existentes como componentes fijos.",
    "Add existing listings as fixed components.": "Agregar listados existentes como componentes fijos.",
    "bundles.pool_description": "Permitir a los clientes elegir artículos elegibles de un grupo de paquetes.",
    "Let customers choose eligible items from a bundle pool.": "Permitir a los clientes elegir artículos elegibles de un grupo de paquetes.",
    "bundles.pool_detail": "Establecer el mínimo y máximo de selecciones en el checkout.",
    "Set the minimum and maximum selections at checkout.": "Establecer el mínimo y máximo de selecciones en el checkout.",
    "channels.opensource.title": "Kit de inicio de código abierto",
    "Open-source starter kits": "Kit de inicio de código abierto",
    "channels.opensource.view_org": "Ver organización de GitHub",
    "View GitHub organization": "Ver organización de GitHub",
    "channels.opensource.description": "Explore repositorios de código abierto de Tradly y kits de inicio desde la organización TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Explore repositorios de código abierto de Tradly y kits de inicio desde la organización TRADLY-PLATFORM.",
    "channels.opensource.loading": "Cargando repositorios…",
    "Loading repositories…": "Cargando repositorios…",
    "channels.opensource.error.http": "GitHub devolvió {status}.",
    "GitHub returned {status}.": "GitHub devolvió {status}.",
    "channels.opensource.error.load": "No se pueden cargar los repositorios. Inténtelo de nuevo más tarde.",
    "Unable to load repositories. Try again later.": "No se pueden cargar los repositorios. Inténtelo de nuevo más tarde.",
    "channels.opensource.empty": "No se encontraron repositorios públicos.",
    "No public repositories found.": "No se encontraron repositorios públicos.",
    "channels.opensource.repo_fallback": "Repositorio de código abierto de Tradly.",
    "Open-source Tradly repository.": "Repositorio de código abierto de Tradly.",
    "channels.opensource.language_code": "Código",
    "channels.opensource.view_repo": "Ver repositorio",
    "View repository": "Ver repositorio",
    "developer.mcp.select_all": "Seleccionar todo",
    "Select all": "Seleccionar todo",
    "developer.mcp.read": "Leer",
    "developer.mcp.write": "Escribir",
    "developer.mcp.delete": "Eliminar",
    "developer.mcp.export": "Exportar",
    "developer.mcp.copy": "Copiar",
    "Copy": "Copiar",
    "developer.mcp.copied": "Copiado",
    "Copied": "Copiado",
    "developer.mcp.connection_created": "Conexión creada",
    "Connection created": "Conexión creada",
    "developer.mcp.save_secret_warning": "Guarde su secreto de cliente ahora — no se mostrará de nuevo.",
    "Save your client secret now — it will not be shown again.": "Guarde su secreto de cliente ahora — no se mostrará de nuevo.",
    "developer.mcp.client_id": "ID de cliente",
    "developer.mcp.client_secret": "Secreto de cliente",
    "developer.mcp.new_connection": "Nueva conexión MCP",
    "New MCP connection": "Nueva conexión MCP",
    "developer.mcp.platform": "Plataforma",
    "Platform": "Plataforma",
    "developer.mcp.platform_custom": "Personalizado",
    "developer.mcp.connection_name": "Nombre de la conexión",
    "developer.mcp.connection_name_placeholder": "ej. ChatGPT",
    "e.g. ChatGPT": "ej. ChatGPT",
    "developer.mcp.redirect_uris": "URIs de redirección",
    "Redirect URIs": "URIs de redirección",
    "developer.mcp.one_per_line": "(uno por línea)",
    "(one per line)": "(uno por línea)",
    "developer.mcp.permissions": "Permisos",
    "Permissions": "Permisos",
    "developer.mcp.error.connection_name": "Introduzca un nombre de conexión",
    "Enter a connection name": "Introduzca un nombre de conexión",
    "developer.mcp.error.redirect_uri": "Introduzca al menos una URI de redirección",
    "Enter at least one redirect URI": "Introduzca al menos una URI de redirección",
    "developer.mcp.error.create": "No se pudo crear la conexión",
    "Failed to create connection": "No se pudo crear la conexión",
    "developer.mcp.creating": "Creando…",
    "Creating…": "Creando…",
    "developer.mcp.edit_permissions": "Editar permisos",
    "Edit permissions": "Editar permisos",
    "developer.mcp.permissions_updated": "Permisos actualizados",
    "Permissions updated": "Permisos actualizados",
    "developer.mcp.error.update_permissions": "No se pudo actualizar los permisos",
    "Failed to update permissions": "No se pudo actualizar los permisos",
    "developer.mcp.saving": "Guardando…",
    "developer.mcp.error.load": "No se pudieron cargar las conexiones MCP.",
    "MCP connections could not be loaded.": "No se pudieron cargar las conexiones MCP.",
    "developer.mcp.confirm_delete": "¿Eliminar esta conexión? Se eliminará de la lista y se revocarán sus accesos.",
    "Delete this connection? It will be removed from the list and its access revoked.": "¿Eliminar esta conexión? Se eliminará de la lista y se revocarán sus accesos.",
    "developer.mcp.connection_removed": "Conexión eliminada",
    "Connection removed": "Conexión eliminada",
    "developer.mcp.error.remove_connection": "No se pudo eliminar la conexión",
    "Failed to remove connection": "No se pudo eliminar la conexión",
    "developer.mcp.connection_deactivated": "Conexión desactivada",
    "Connection deactivated": "Conexión desactivada",
    "developer.mcp.error.deactivate_connection": "No se pudo desactivar la conexión",
    "Failed to deactivate connection": "No se pudo desactivar la conexión",
    "developer.mcp.title": "Conexiones MCP",
    "MCP connections": "Conexiones MCP",
    "developer.mcp.description": "Clientes OAuth registrados en el tenant y aplicaciones de IA autorizadas para usar el servidor MCP de este tenant.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Clientes OAuth registrados en el tenant y aplicaciones de IA autorizadas para usar el servidor MCP de este tenant.",
    "developer.mcp.empty": "Sin conexiones aún. Crea un cliente o conecta una aplicación de IA al servidor MCP de este inquilino.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Sin conexiones aún. Crea un cliente o conecta una aplicación de IA al servidor MCP de este inquilino.",
    "developer.mcp.status.connected_one": "Conectado · 1 usuario",
    "Connected · 1 user": "Conectado · 1 usuario",
    "developer.mcp.status.connected_many": "Conectado · {count} usuarios",
    "Connected · {count} users": "Conectado · {count} usuarios",
    "developer.mcp.status.deactivated": "Desactivado",
    "Deactivated": "Desactivado",
    "developer.mcp.status.previously_connected": "Conectado anteriormente",
    "Previously connected": "Conectado anteriormente",
    "developer.mcp.status.registered": "Registrado · no conectado",
    "Registered · not connected": "Registrado · no conectado",
    "developer.mcp.oauth_app": "Aplicación OAuth",
    "OAuth app": "Aplicación OAuth",
    "developer.mcp.created": "Creado",
    "developer.mcp.updated": "Actualizado",
    "Updated": "Actualizado",
    "developer.mcp.edit_scopes": "Editar ámbitos",
    "Edit scopes": "Editar ámbitos",
    "developer.mcp.edit_scopes_for": "Editar ámbitos para {name}",
    "Edit scopes for {name}": "Editar ámbitos para {name}",
    "developer.mcp.deactivate_hint": "Desactivar (mantiene listado y registrado)",
    "Deactivate (keeps it listed and logged)": "Desactivar (mantiene listado y registrado)",
    "developer.mcp.deactivate_named": "Desactivar {name}",
    "Deactivate {name}": "Desactivar {name}",
    "developer.mcp.delete_connection": "Eliminar conexión",
    "Delete connection": "Eliminar conexión",
    "developer.mcp.delete_named": "Eliminar {name}",
    "Delete {name}": "Eliminar {name}",
    "developer.mcp.resource.listings": "Listados",
    "developer.mcp.resource.orders": "Pedidos",
    "developer.mcp.resource.users": "Usuarios",
    "developer.mcp.resource.accounts": "Cuentas",
    "developer.mcp.resource.categories": "Categorías",
    "developer.mcp.resource.attributes": "Atributos",
    "developer.mcp.resource.analytics": "Analíticas",
    "developer.mcp.resource.attribution": "Atribución",
    "Attribution": "Atribución",
    "developer.mcp.resource.rewards": "Recompensas",
    "developer.mcp.resource.layers": "Capas / CMS",
    "Layers / CMS": "Capas / CMS",
    "developer.mcp.resource.settings": "Configuración de la tienda",
    "Store settings": "Configuración de la tienda",
    "developer.mcp.resource.marketing": "Marketing",
    "developer.mcp.resource.market_research": "Investigación de mercado",
    "Market research": "Investigación de mercado",
    "developer.mcp.resource.audiences": "Público objetivo de marketing",
    "Marketing audiences": "Público objetivo de marketing",
    "developer.mcp.resource.agents": "Agentes de IA",
    "developer.mcp.resource.assets": "Carga de archivos",
    "File uploads": "Carga de archivos",
    "developer.mcp.resource.workforce": "Fuerza laboral",
    "developer.mcp.resource.inventory": "Inventario",
    "developer.mcp.resource.memberships": "Membresías",
    "Memberships": "Membresías",
    "developer.mcp.resource.bundles": "Paquetes",
    "developer.mcp.resource.rentals": "Alquileres",
    "Rentals": "Alquileres",
    "developer.mcp.resource.accounting": "Contabilidad",
    "developer.mcp.nav.label": "Navegación MCP",
    "MCP navigation": "Navegación MCP",
    "developer.mcp.nav.connections": "Conexiones",
    "Connections": "Conexiones",
    "developer.mcp.nav.logs": "Registros",
    "Logs": "Registros",
    "developer.mcp.unknown_provider": "Proveedor desconocido",
    "Unknown provider": "Proveedor desconocido",
    "developer.mcp.tenant_user": "Inquilino #{tenant} · Usuario #{user}",
    "Tenant #{tenant} · User #{user}": "Inquilino #{tenant} · Usuario #{user}",
    "developer.mcp.logs.title": "Registros MCP",
    "MCP logs": "Registros MCP",
    "developer.mcp.logs.heading": "Actividad reciente de agentes",
    "Recent agent activity": "Actividad reciente de agentes",
    "developer.mcp.logs.description": "Mostrando los eventos MCP de este inquilino. La vista de actividad se actualiza cada 15 segundos.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Mostrando los eventos MCP de este inquilino. La vista de actividad se actualiza cada 15 segundos.",
    "developer.mcp.logs.error.audit": "No se pudieron cargar los registros de auditoría de MCP.",
    "MCP audit logs could not be loaded.": "No se pudieron cargar los registros de auditoría de MCP.",
    "developer.mcp.logs.error.load": "No se pudieron cargar los registros MCP.",
    "MCP logs could not be loaded.": "No se pudieron cargar los registros MCP.",
    "developer.mcp.logs.unknown_agent": "Agente desconocido",
    "Unknown agent": "Agente desconocido",
    "developer.mcp.logs.all_agents": "Todos los agentes",
    "All agents": "Todos los agentes",
    "developer.mcp.logs.updated": "Actualizado {time}",
    "Updated {time}": "Actualizado {time}",
    "developer.mcp.logs.loading": "Cargando actividad MCP…",
    "Loading MCP activity…": "Cargando actividad MCP…",
    "developer.mcp.logs.empty": "No se encontraron eventos MCP recientes para este inquilino.",
    "No recent MCP events found for this tenant.": "No se encontraron eventos MCP recientes para este inquilino.",
    "developer.mcp.logs.empty_agent": "No se encontraron eventos MCP recientes para este inquilino y agente.",
    "No recent MCP events found for this tenant and agent.": "No se encontraron eventos MCP recientes para este inquilino y agente.",
    "developer.mcp.logs.time": "Hora",
    "developer.mcp.logs.event": "Evento",
    "developer.mcp.logs.tool": "Herramienta",
    "developer.mcp.logs.agent": "Agente",
    "Agent": "Agente",
    "developer.mcp.logs.tenant_user": "Inquilino / usuario",
    "Tenant / user": "Inquilino / usuario",
    "developer.mcp.logs.scope": "Alcance",
    "Scope": "Alcance",
    "developer.mcp.logs.result": "Resultado",
    "Result": "Resultado",
    "developer.mcp.logs.duration": "Duración",
    "Duration": "Duración",
    "developer.mcp.logs.view_details": "Ver detalles de {event}",
    "View details for {event}": "Ver detalles de {event}",
    "developer.mcp.logs.tenant": "Inquilino #{id}",
    "Tenant #{id}": "Inquilino #{id}",
    "developer.mcp.logs.user": "Usuario #{id}",
    "User #{id}": "Usuario #{id}",
    "developer.mcp.logs.view_granted_scopes": "Ver alcances concedidos",
    "View granted scopes": "Ver alcances concedidos",
    "developer.mcp.logs.succeeded": "Éxito",
    "Succeeded": "Éxito",
    "developer.mcp.logs.failed": "Error",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "Detalles del evento MCP",
    "MCP event details": "Detalles del evento MCP",
    "developer.mcp.logs.required_scope": "Alcance requerido",
    "Required scope": "Alcance requerido",
    "developer.mcp.logs.granted_scopes": "Alcances concedidos",
    "Granted scopes": "Alcances concedidos",
    "developer.mcp.logs.event_generic": "Evento genérico",
    "developer.mcp.logs.event.tool_called": "Herramienta llamada",
    "Tool called": "Herramienta llamada",
    "developer.mcp.logs.event.connection_requested": "Conexión solicitada",
    "Connection requested": "Conexión solicitada",
    "developer.mcp.logs.event.connection_connected": "Conexión establecida",
    "Connection connected": "Conexión establecida",
    "developer.mcp.logs.event.connection_deactivated": "Conexión desactivada",
    "developer.mcp.logs.event.connection_deleted": "Conexión eliminada",
    "Connection deleted": "Conexión eliminada",
    "developer.mcp.logs.event.permissions_updated": "Permisos actualizados",
    "common.status.label": "Estado",
    "suppliers.title": "Proveedores",
    "suppliers.search": "Buscar proveedores",
    "Search suppliers": "Buscar proveedores",
    "suppliers.add": "Agregar proveedor",
    "Add supplier": "Agregar proveedor",
    "suppliers.deactivate": "Desactivar",
    "Deactivate": "Desactivar",
    "suppliers.empty": "No se encontraron proveedores.",
    "No suppliers found.": "No se encontraron proveedores.",
    "suppliers.add_title": "Agregar proveedor",
    "suppliers.edit_title": "Editar proveedor",
    "Edit supplier": "Editar proveedor",
    "suppliers.save_changes": "Guardar cambios",
    "Save changes": "Guardar cambios",
    "suppliers.confirm_deactivate": "Desactivar {name}?",
    "Deactivate {name}?": "Desactivar {name}?",
    "suppliers.toast.updated": "Proveedor actualizado",
    "Supplier updated": "Proveedor actualizado",
    "suppliers.toast.added": "Proveedor agregado",
    "Supplier added": "Proveedor agregado",
    "suppliers.toast.deactivated": "Proveedor desactivado",
    "Supplier deactivated": "Proveedor desactivado",
    "suppliers.column.name": "Nombre",
    "suppliers.column.code": "Código",
    "suppliers.column.contact": "Contacto",
    "Contact": "Contacto",
    "suppliers.field.name": "Nombre",
    "suppliers.field.code": "Código",
    "suppliers.field.contact_name": "Nombre de contacto",
    "Contact name": "Nombre de contacto",
    "suppliers.field.email": "Correo electrónico",
    "suppliers.field.phone": "Teléfono",
    "suppliers.field.currency": "Moneda",
    "suppliers.field.payment_terms": "Términos de pago",
    "Payment terms": "Términos de pago",
    "suppliers.field.address": "Dirección",
    "suppliers.field.note": "Nota",
    "Note": "Nota",
    "suppliers.placeholder.name": "Nombre de la empresa o proveedor",
    "Company or supplier name": "Nombre de la empresa o proveedor",
    "suppliers.placeholder.code": "Código de proveedor",
    "Supplier code": "Código de proveedor",
    "suppliers.placeholder.contact_name": "Nombre de contacto",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Pago contra entrega",
    "Cash on delivery": "Pago contra entrega",
    "suppliers.payment_terms.payment_on_receipt": "Pago al recibir",
    "Payment on receipt": "Pago al recibir",
    "suppliers.payment_terms.payment_in_advance": "Pago por adelantado",
    "Payment in advance": "Pago por adelantado",
    "suppliers.payment_terms.net_7": "Neto 7 días",
    "Net 7 days": "Neto 7 días",
    "suppliers.payment_terms.net_15": "Neto 15 días",
    "Net 15 days": "Neto 15 días",
    "suppliers.payment_terms.net_30": "Neto 30 días",
    "Net 30 days": "Neto 30 días",
    "suppliers.payment_terms.net_45": "Neto 45 días",
    "Net 45 days": "Neto 45 días",
    "suppliers.payment_terms.net_60": "Neto 60 días",
    "Net 60 days": "Neto 60 días",
    "suppliers.detail_title": "Detalles del proveedor",
    "Supplier details": "Detalles del proveedor",
    "suppliers.edit": "Editar proveedor",
    "suppliers.back": "Volver a proveedores",
    "Back to suppliers": "Volver a proveedores",
    "suppliers.loading": "Cargando proveedor…",
    "Loading supplier…": "Cargando proveedor…",
    "suppliers.unnamed": "Proveedor sin nombre",
    "Unnamed supplier": "Proveedor sin nombre",
    "suppliers.profile_description": "Perfil y datos de contacto del proveedor",
    "Supplier profile and contact information": "Perfil y datos de contacto del proveedor",
    "suppliers.total_spend": "Gasto total",
    "Total spend": "Gasto total",
    "suppliers.outstanding": "Pendiente",
    "Outstanding": "Pendiente",
    "suppliers.paid": "Pagado",
    "suppliers.draft": "Borrador",
    "suppliers.purchase_history": "Historial de compras",
    "Purchase history": "Historial de compras",
    "suppliers.bill.reference": "Referencia",
    "Reference": "Referencia",
    "suppliers.bill.date": "Fecha",
    "suppliers.bill.amount": "Monto",
    "suppliers.bill.number": "Factura #{id}",
    "Bill #{id}": "Factura #{id}",
    "suppliers.bills_empty": "No se encontraron facturas para este proveedor.",
    "No bills found for this supplier.": "No se encontraron facturas para este proveedor.",
    "inventory.locations.title": "Ubicaciones",
    "inventory.locations.add": "Agregar ubicación",
    "Add location": "Agregar ubicación",
    "inventory.locations.description": "Almacenes y tiendas que almacenan stock. Las órdenes de compra se reciben en una ubicación.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Almacenes y tiendas que almacenan stock. Las órdenes de compra se reciben en una ubicación.",
    "inventory.locations.field.name": "Nombre",
    "inventory.locations.field.code": "Código",
    "inventory.locations.field.address": "Dirección",
    "inventory.locations.field.linked_store": "Tienda vinculada (opcional)",
    "Linked store (optional)": "Tienda vinculada (opcional)",
    "inventory.locations.field.linked_store_short": "Tienda vinculada",
    "Linked store": "Tienda vinculada",
    "inventory.locations.placeholder.name": "Almacén principal",
    "Main warehouse": "Almacén principal",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Buscar una dirección o lugar",
    "Search an address or place": "Buscar una dirección o lugar",
    "inventory.locations.placeholder.linked_store": "Buscar cuentas de vendedor o tienda",
    "Search seller or store accounts": "Buscar cuentas de vendedor o tienda",
    "inventory.locations.confirm_deactivate": "¿Desactivar {name}? Ya no estará disponible para nuevas órdenes de compra.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "¿Desactivar {name}? Ya no estará disponible para nuevas órdenes de compra.",
    "inventory.locations.toast.deactivated": "Ubicación desactivada",
    "Location deactivated": "Ubicación desactivada",
    "inventory.locations.deactivate": "Desactivar",
    "inventory.locations.empty": "Aún no hay ubicaciones. Agrega un almacén o tienda para comenzar a recibir stock.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Aún no hay ubicaciones. Agrega un almacén o tienda para comenzar a recibir stock.",
    "inventory.locations.edit_title": "Editar ubicación",
    "Edit location": "Editar ubicación",
    "inventory.locations.add_title": "Agregar ubicación",
    "inventory.locations.form_description": "Vincule una cuenta de tienda solo si esta ubicación pertenece a un vendedor específico.",
    "Link a store account only if this location belongs to a specific seller.": "Vincule una cuenta de tienda solo si esta ubicación pertenece a un vendedor específico.",
    "inventory.locations.save_changes": "Guardar cambios",
    "inventory.locations.toast.updated": "Ubicación actualizada",
    "Location updated": "Ubicación actualizada",
    "inventory.locations.toast.added": "Ubicación agregada",
    "Location added": "Ubicación agregada",
    "inventory.operations.title": "Operaciones de inventario",
    "Inventory operations": "Operaciones de inventario",
    "inventory.operations.tab.movements": "Historial de movimientos",
    "Movement history": "Historial de movimientos",
    "inventory.operations.tab.batches": "Lotes y caducidad",
    "Batches & expiry": "Lotes y caducidad",
    "inventory.operations.tab.transfers": "Órdenes de transferencia",
    "Transfer orders": "Órdenes de transferencia",
    "inventory.operations.tab.requisitions": "Requisiciones",
    "Requisitions": "Requisiciones",
    "inventory.operations.tab.receipts": "Mercancía recibida",
    "Goods received": "Mercancía recibida",
    "inventory.operations.description.movements": "Un registro inmutable de cada recepción, venta, transferencia, devolución y ajuste.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Un registro inmutable de cada recepción, venta, transferencia, devolución y ajuste.",
    "inventory.operations.description.batches": "Rastrea lotes, fechas de caducidad, condición y unidades sin cambiar el libro de existencias aquí.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Rastrea lotes, fechas de caducidad, condición y unidades sin cambiar el libro de existencias aquí.",
    "inventory.operations.description.transfers": "Mueve el stock entre ubicaciones con seguimiento de estado seguro contra discrepancias en envío, recepción y discrepancias.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Mueve el stock entre ubicaciones con seguimiento de estado seguro contra discrepancias en envío, recepción y discrepancias.",
    "inventory.operations.description.requisitions": "Revisa las solicitudes internas de stock. La aprobación crea automáticamente un pedido de transferencia.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Revisa las solicitudes internas de stock. La aprobación crea automáticamente un pedido de transferencia.",
    "inventory.operations.description.receipts": "Crea recibos y rastrea trabajos abiertos, parciales y cerrados de recepción.",
    "Create receipts and track open, partial, and closed receiving work.": "Crea recibos y rastrea trabajos abiertos, parciales y cerrados de recepción.",
    "inventory.operations.overview": "Resumen",
    "inventory.operations.new_transfer": "Nueva transferencia",
    "New transfer": "Nueva transferencia",
    "inventory.operations.new_requisition": "Nueva requisición",
    "New requisition": "Nueva requisición",
    "inventory.operations.new_receipt": "Nuevo recibo",
    "New receipt": "Nuevo recibo",
    "inventory.operations.search": "Buscar",
    "inventory.operations.search_view": "Buscar en esta vista",
    "Search this view": "Buscar en esta vista",
    "inventory.operations.search_products": "Buscar productos",
    "Search products": "Buscar productos",
    "inventory.operations.search_purchase_order": "Buscar pedidos de compra (opcional)",
    "Search purchase orders (optional)": "Buscar pedidos de compra (opcional)",
    "inventory.operations.listing_number": "Listado #{id}",
    "inventory.operations.location_number": "Ubicación #{id}",
    "Location #{id}": "Ubicación #{id}",
    "inventory.operations.no_sku": "Sin SKU",
    "No SKU": "Sin SKU",
    "inventory.operations.order_status": "Estado: {status}",
    "Status: {status}": "Estado: {status}",
    "inventory.operations.field.receiving_location": "Ubicación de recepción",
    "Receiving location": "Ubicación de recepción",
    "inventory.operations.field.purchase_order": "Pedido de compra",
    "Purchase order": "Pedido de compra",
    "inventory.operations.field.reference": "Referencia",
    "inventory.operations.field.note": "Nota",
    "inventory.operations.field.from_location": "Ubicación de origen",
    "From location": "Ubicación de origen",
    "inventory.operations.field.supplying_location": "Ubicación de suministro",
    "Supplying location": "Ubicación de suministro",
    "inventory.operations.field.to_location": "Ubicación de destino",
    "To location": "Ubicación de destino",
    "inventory.operations.field.requesting_location": "Ubicación de solicitud",
    "Requesting location": "Ubicación de solicitud",
    "inventory.operations.field.product": "Producto",
    "Product": "Producto",
    "inventory.operations.field.quantity": "Cantidad",
    "Quantity": "Cantidad",
    "inventory.operations.field.location": "Ubicación",
    "Location": "Ubicación",
    "inventory.operations.placeholder.delivery_note": "Nota de entrega del proveedor",
    "Supplier delivery note": "Nota de entrega del proveedor",
    "inventory.operations.placeholder.receiving_note": "Nota de recepción opcional",
    "Optional receiving note": "Nota de recepción opcional",
    "inventory.operations.placeholder.transfer_reference": "Referencia de transferencia",
    "Transfer reference": "Referencia de transferencia",
    "inventory.operations.placeholder.request_reference": "Referencia de solicitud",
    "Request reference": "Referencia de solicitud",
    "inventory.operations.placeholder.context": "Contexto opcional",
    "Optional context": "Contexto opcional",
    "inventory.operations.create.transfer_title": "Nueva orden de transferencia",
    "New transfer order": "Nueva orden de transferencia",
    "inventory.operations.create.requisition_title": "Nueva requisición",
    "inventory.operations.create.receipt_title": "Nueva recepción de mercancía",
    "New goods receipt": "Nueva recepción de mercancía",
    "inventory.operations.create.transfer_description": "Mover stock entre dos ubicaciones.",
    "Move stock between two locations.": "Mover stock entre dos ubicaciones.",
    "inventory.operations.create.requisition_description": "Solicitar stock desde otra ubicación.",
    "Request stock from another location.": "Solicitar stock desde otra ubicación.",
    "inventory.operations.create.receipt_description": "Crear una recepción antes de escanear o añadir cajas.",
    "Create a receipt before scanning or adding boxes.": "Crear una recepción antes de escanear o añadir cajas.",
    "inventory.operations.toast.transfer_created": "Orden de transferencia creada",
    "Transfer order created": "Orden de transferencia creada",
    "inventory.operations.toast.requisition_created": "Requisición creada",
    "Requisition created": "Requisición creada",
    "inventory.operations.toast.receipt_created": "Recepción de mercancía creada",
    "Goods receipt created": "Recepción de mercancía creada",
    "inventory.operations.toast.transfer_dispatched": "Transferencia enviada",
    "Transfer dispatched": "Transferencia enviada",
    "inventory.operations.toast.transfer_received": "Transferencia recibida",
    "Transfer received": "Transferencia recibida",
    "inventory.operations.toast.transfer_cancelled": "Transferencia cancelada",
    "Transfer cancelled": "Transferencia cancelada",
    "inventory.operations.toast.requisition_approved": "Requisición aprobada",
    "Requisition approved": "Requisición aprobada",
    "inventory.operations.toast.requisition_rejected": "Requisición rechazada",
    "Requisition rejected": "Requisición rechazada",
    "inventory.operations.action.dispatch": "Enviar",
    "Dispatch": "Enviar",
    "inventory.operations.action.receive": "Recibir",
    "Receive": "Recibir",
    "inventory.operations.action.approve": "Aprobar",
    "Approve": "Aprobar",
    "inventory.operations.action.reject": "Rechazar",
    "Reject": "Rechazar",
    "inventory.operations.column.when": "Cuando",
    "When": "Cuando",
    "inventory.operations.column.event": "Evento",
    "inventory.operations.column.change": "Cambio",
    "inventory.operations.column.after": "Después",
    "After": "Después",
    "inventory.operations.column.order": "Orden",
    "inventory.operations.column.route": "Ruta",
    "Route": "Ruta",
    "inventory.operations.column.lines": "Líneas",
    "Lines": "Líneas",
    "inventory.operations.column.expected": "Previsto",
    "inventory.operations.column.request": "Solicitud",
    "Request": "Solicitud",
    "inventory.operations.column.request_supply": "Solicitud / suministro",
    "Request / supply": "Solicitud / suministro",
    "inventory.operations.column.created": "Creado",
    "inventory.operations.column.receipt": "Recibo",
    "Receipt": "Recibo",
    "inventory.operations.empty.movements": "No hay movimientos de stock registrados aún.",
    "No stock movements recorded yet.": "No hay movimientos de stock registrados aún.",
    "inventory.operations.empty.batches": "Aún no se han registrado lotes de inventario.",
    "No inventory batches have been recorded yet.": "Aún no se han registrado lotes de inventario.",
    "inventory.operations.empty.transfers": "Aún no hay órdenes de transferencia.",
    "No transfer orders yet.": "Aún no hay órdenes de transferencia.",
    "inventory.operations.empty.requisitions": "Aún no hay solicitudes.",
    "No requisitions yet.": "Aún no hay solicitudes.",
    "inventory.operations.empty.receipts": "Aún no hay recepciones de mercancías.",
    "No goods receipts yet.": "Aún no hay recepciones de mercancías.",
    "inventory.operations.batch.edit_title": "Editar lote",
    "Edit batch": "Editar lote",
    "inventory.operations.batch.edit_description": "La cantidad del lote se cambia mediante un ajuste de stock; este formulario solo actualiza su identidad y campos de seguimiento.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "La cantidad del lote se cambia mediante un ajuste de stock; este formulario solo actualiza su identidad y campos de seguimiento.",
    "inventory.operations.batch.save": "Guardar lote",
    "Save batch": "Guardar lote",
    "inventory.operations.batch.lot_number": "Número de lote",
    "Lot number": "Número de lote",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Fecha de caducidad",
    "inventory.operations.batch.condition": "Condición",
    "Condition": "Condición",
    "inventory.operations.batch.condition_placeholder": "bueno",
    "good": "bueno",
    "inventory.operations.batch.unit": "Unidad de medida",
    "Unit of measure": "Unidad de medida",
    "inventory.operations.batch.unit_placeholder": "caja, pieza, kg",
    "box, piece, kg": "caja, pieza, kg",
    "inventory.operations.batch.no_expiry": "Sin caducidad",
    "No expiry": "Sin caducidad",
    "inventory.operations.batch.updated": "Lote actualizado",
    "Batch updated": "Lote actualizado",
    "common.status.in_transit": "En tránsito",
    "In transit": "En tránsito",
    "common.status.pending": "Pendiente",
    "Pending": "Pendiente",
    "common.status.approved": "Aprobado",
    "Approved": "Aprobado",
    "common.status.rejected": "Rechazado",
    "Rejected": "Rechazado",
    "common.status.cancelled": "Cancelado",
    "Cancelled": "Cancelado",
    "common.status.received": "Recibido",
    "Received": "Recibido",
    "common.status.sent": "Enviado",
    "Sent": "Enviado",
    "common.note": "Nota",
    "common.optional": "Opcional",
    "Optional": "Opcional",
    "common.error.generic": "Algo salió mal.",
    "Something went wrong.": "Algo salió mal.",
    "purchase_orders.title": "Pedidos de compra",
    "purchase_orders.title_singular": "Pedido de compra",
    "purchase_orders.tab.all": "Todos",
    "purchase_orders.tab.partial": "Parcialmente recibido",
    "Partially received": "Parcialmente recibido",
    "purchase_orders.create.new": "Nuevo pedido de compra",
    "New purchase order": "Nuevo pedido de compra",
    "purchase_orders.create.title": "Nuevo pedido de compra",
    "purchase_orders.create.subtitle": "Guardado como borrador. Marca como enviado una vez que esté con el proveedor.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Guardado como borrador. Marca como enviado una vez que esté con el proveedor.",
    "purchase_orders.create.submit": "Crear borrador",
    "Create draft": "Crear borrador",
    "purchase_orders.field.location": "Ubicación de recepción",
    "purchase_orders.field.supplier": "Proveedor",
    "Supplier": "Proveedor",
    "purchase_orders.field.reference": "Referencia del proveedor",
    "Supplier reference": "Referencia del proveedor",
    "purchase_orders.field.expected_delivery": "Entrega esperada",
    "Expected delivery": "Entrega esperada",
    "purchase_orders.field.products": "Productos",
    "Products": "Productos",
    "purchase_orders.select_location": "Seleccionar ubicación",
    "Select location": "Seleccionar ubicación",
    "purchase_orders.no_locations": "No hay ubicaciones configuradas",
    "No locations set up": "No hay ubicaciones configuradas",
    "purchase_orders.add_location": "Agrega una ubicación primero →",
    "Add a location first →": "Agrega una ubicación primero →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Todas las ubicaciones",
    "All locations": "Todas las ubicaciones",
    "purchase_orders.location_number": "Ubicación #{id}",
    "purchase_orders.search_products": "Buscar productos para agregar",
    "Search products to add": "Buscar productos para agregar",
    "purchase_orders.in_stock": "En stock: {count}",
    "In stock: {count}": "En stock: {count}",
    "purchase_orders.column.order": "Pedido",
    "purchase_orders.column.product": "Producto",
    "purchase_orders.column.quantity": "Cantidad",
    "purchase_orders.column.ordered": "Pedidos",
    "Ordered": "Pedidos",
    "purchase_orders.column.received": "Recibido",
    "purchase_orders.column.remaining": "Pendiente",
    "purchase_orders.column.unit_cost": "Costo unitario",
    "Unit cost": "Costo unitario",
    "purchase_orders.column.supplier": "Proveedor",
    "purchase_orders.column.location": "Ubicación",
    "purchase_orders.column.progress": "Recibido",
    "purchase_orders.column.value": "Valor",
    "purchase_orders.column.expected": "Esperado",
    "purchase_orders.column.status": "Estado",
    "purchase_orders.action.mark_sent": "Marcar como enviado",
    "Mark as sent": "Marcar como enviado",
    "purchase_orders.action.receive": "Recibir",
    "purchase_orders.action.receive_stock": "Recibir stock",
    "Receive stock": "Recibir stock",
    "purchase_orders.action.cancel_order": "Cancelar pedido",
    "Cancel order": "Cancelar pedido",
    "purchase_orders.action.close_order": "Cerrar pedido",
    "Close order": "Cerrar pedido",
    "purchase_orders.receive.subtitle": "Introduce lo recibido. El stock en el lugar de recepción se actualiza al confirmar.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Introduce lo recibido. El stock en el lugar de recepción se actualiza al confirmar.",
    "purchase_orders.receive.now": "Recibir ahora",
    "Receive now": "Recibir ahora",
    "purchase_orders.receive.confirm": "Confirmar recepción",
    "Confirm receipt": "Confirmar recepción",
    "purchase_orders.confirm.cancel": "¿Cancelar este pedido de compra?",
    "Cancel this purchase order?": "¿Cancelar este pedido de compra?",
    "purchase_orders.empty.all": "Aún no hay pedidos de compra. Crea uno para reponer el inventario.",
    "No purchase orders yet. Create one to restock inventory.": "Aún no hay pedidos de compra. Crea uno para reponer el inventario.",
    "purchase_orders.empty.filtered": "No hay pedidos de compra con este estado.",
    "No purchase orders with this status.": "No hay pedidos de compra con este estado.",
    "purchase_orders.error.location_required": "Selecciona un lugar de recepción.",
    "Choose a receiving location.": "Selecciona un lugar de recepción.",
    "purchase_orders.error.product_required": "Añade al menos un producto.",
    "Add at least one product.": "Añade al menos un producto.",
    "purchase_orders.error.quantity_positive": "Cada cantidad debe ser mayor que 0.",
    "Every quantity must be greater than 0.": "Cada cantidad debe ser mayor que 0.",
    "purchase_orders.error.receive_quantity": "Introduce una cantidad para al menos un artículo.",
    "Enter a quantity for at least one item.": "Introduce una cantidad para al menos un artículo.",
    "purchase_orders.toast.created": "Pedido de compra creado como borrador",
    "Purchase order created as draft": "Pedido de compra creado como borrador",
    "purchase_orders.toast.sent": "Marcado como enviado",
    "Marked as sent": "Marcado como enviado",
    "purchase_orders.toast.received": "Stock recibido y inventario actualizado",
    "Stock received and inventory updated": "Stock recibido y inventario actualizado",
    "purchase_orders.toast.cancelled": "Pedido de compra cancelado",
    "Purchase order cancelled": "Pedido de compra cancelado",
    "purchase_orders.toast.closed": "Pedido de compra cerrado",
    "Purchase order closed": "Pedido de compra cerrado",
    "schedule.title": "Programación",
    "schedule.view.month": "Mes",
    "Month": "Mes",
    "schedule.view.week": "Semana",
    "Week": "Semana",
    "schedule.view.day": "Día",
    "Day": "Día",
    "schedule.today": "Hoy",
    "Today": "Hoy",
    "schedule.order_number": "Pedido #{number}",
    "Order #{number}": "Pedido #{number}",
    "schedule.customer": "Cliente",
    "schedule.more_events": "+{count} más",
    "+{count} more": "+{count} más",
    "schedule.payment.paid": "Pagado",
    "schedule.payment.pending": "Pendiente",
    "schedule.payment.failed": "Fallido",
    "schedule.booking_details": "Detalles de la reserva",
    "Booking details": "Detalles de la reserva",
    "schedule.order_reference": "Referencia de pedido",
    "schedule.amount": "Monto",
    "schedule.start": "Inicio",
    "schedule.end": "Fin",
    "schedule.item_number": "Artículo {number}",
    "Item {number}": "Artículo {number}",
    "schedule.view_order": "Ver pedido completo",
    "View full order": "Ver pedido completo",
    "onboarding.greeting.morning": "Buenos días",
    "Good morning": "Buenos días",
    "onboarding.greeting.morning_named": "Buenos días {name}",
    "Good morning {name}": "Buenos días {name}",
    "onboarding.greeting.afternoon": "Buenas tardes",
    "Good afternoon": "Buenas tardes",
    "onboarding.greeting.afternoon_named": "Buenas tardes {name}",
    "Good afternoon {name}": "Buenas tardes {name}",
    "onboarding.greeting.evening": "Buenas noches",
    "Good evening": "Buenas noches",
    "onboarding.greeting.evening_named": "Buenas noches {name}",
    "Good evening {name}": "Buenas noches {name}",
    "onboarding.greeting.night": "Hola",
    "Hello": "Hola",
    "onboarding.greeting.night_named": "Hola {name}",
    "Hello {name}": "Hola {name}",
    "onboarding.encouragement": "Construye la plataforma que desearías existir.",
    "Build the platform you wish existed.": "Construye la plataforma que desearías existir.",
    "onboarding.plan.personalized": "Plan de lanzamiento personalizado",
    "Personalized launch plan": "Plan de lanzamiento personalizado",
    "onboarding.plan.label": "Plan de lanzamiento",
    "Launch plan": "Plan de lanzamiento",
    "onboarding.plan.refining": "Refinando tu camino…",
    "Refining your path…": "Refinando tu camino…",
    "onboarding.plan.getting_ready": "Tu plan personalizado está listo.",
    "Your personalized plan is getting ready.": "Tu plan personalizado está listo.",
    "onboarding.checklist.preview": "Vista previa de la lista de verificación",
    "Checklist preview": "Vista previa de la lista de verificación",
    "onboarding.workspace.live": "Espacio de trabajo en vivo",
    "Live workspace": "Espacio de trabajo en vivo",
    "onboarding.workspace.no_tenant": "Sin inquilino conectado en vivo",
    "No live tenant connected": "Sin inquilino conectado en vivo",
    "onboarding.workspace.domain_pending": "Dominio pendiente",
    "Domain pending": "Dominio pendiente",
    "onboarding.progress.summary": "{completed} de {total} acciones de lanzamiento completadas",
    "{completed} of {total} launch actions done": "{completed} de {total} acciones de lanzamiento completadas",
    "onboarding.progress.auto_detected": "{count} detectados automáticamente",
    "{count} auto-detected": "{count} detectados automáticamente",
    "onboarding.progress.auto_detected_short": "Detectado automáticamente",
    "Auto-detected": "Detectado automáticamente",
    "onboarding.progress.saving": "Guardando progreso…",
    "Saving progress…": "Guardando progreso…",
    "onboarding.progress.checking": "Verificando…",
    "onboarding.progress.mark_done": "Marcar como completado",
    "Mark done": "Marcar como completado",
    "onboarding.progress.unlocked": "Desbloqueado: {impact}",
    "Unlocked: {impact}": "Desbloqueado: {impact}",
    "onboarding.next_task": "Próxima tarea ideal",
    "Next best task": "Próxima tarea ideal",
    "onboarding.upcoming.title": "Tareas próximas",
    "Upcoming tasks": "Tareas próximas",
    "onboarding.upcoming.summary_one": "{count} tarea programada después de la acción actual.",
    "{count} task queued after the current action.": "{count} tarea programada después de la acción actual.",
    "onboarding.upcoming.summary_other": "{count} tareas programadas después de la acción actual.",
    "{count} tasks queued after the current action.": "{count} tareas programadas después de la acción actual.",
    "onboarding.upcoming.hide": "Ocultar tareas",
    "Hide tasks": "Ocultar tareas",
    "onboarding.upcoming.view_all": "Ver todas las tareas",
    "View all tasks": "Ver todas las tareas",
    "onboarding.complete.title": "Gran inicio. Tu base está en vivo.",
    "Great start. Your foundation is live.": "Gran inicio. Tu base está en vivo.",
    "onboarding.complete.description": "Continúa para desbloquear esenciales de crecimiento como promociones y comunicaciones.",
    "Keep going to unlock growth essentials like promotions and communications.": "Continúa para desbloquear esenciales de crecimiento como promociones y comunicaciones.",
    "onboarding.full_checklist.title": "Lista completa",
    "Full checklist": "Lista completa",
    "onboarding.full_checklist.description": "Continúa la configuración en la misma experiencia.",
    "Continue setup in the same experience.": "Continúa la configuración en la misma experiencia.",
    "onboarding.full_checklist.back": "Volver al camino de lanzamiento",
    "Back to launch path": "Volver al camino de lanzamiento",
    "onboarding.completed.title": "Completado",
    "onboarding.completed.summary_one": "{count} tarea completada",
    "{count} task completed": "{count} tarea completada",
    "onboarding.completed.summary_other": "{count} tareas completadas",
    "{count} tasks completed": "{count} tareas completadas",
    "onboarding.completed.open_again": "Abrir de nuevo",
    "Open again": "Abrir de nuevo",
    "onboarding.plan.marketplace.eyebrow": "Ruta de lanzamiento de Marketplace",
    "Marketplace launch path": "Ruta de lanzamiento de Marketplace",
    "onboarding.plan.marketplace.title": "Lanza tu marketplace",
    "Launch your marketplace": "Lanza tu marketplace",
    "onboarding.plan.marketplace.title_named": "Convierte {project} en un marketplace funcional",
    "Turn {project} into a working marketplace": "Convierte {project} en un marketplace funcional",
    "onboarding.plan.marketplace.subtitle": "Abre el sitio en vivo, crea el primer anuncio y prueba el recorrido del comprador.",
    "Open the live site create the first listing and test the buyer journey.": "Abre el sitio en vivo, crea el primer anuncio y prueba el recorrido del comprador.",
    "onboarding.plan.marketplace.value_moment": "Primer momento de valor: un vendedor puede publicar y un comprador puede actuar.",
    "First value moment: a seller can publish and a buyer can act.": "Primer momento de valor: un vendedor puede publicar y un comprador puede actuar.",
    "onboarding.plan.marketplace.why_title": "¿Por qué los equipos terminan esto?",
    "Why teams finish this": "¿Por qué los equipos terminan esto?",
    "onboarding.plan.marketplace.why_body": "Resultados reales de compradores y vendedores hacen que cada paso siguiente sea útil y mantengan el impulso.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Resultados reales de compradores y vendedores hacen que cada paso siguiente sea útil y mantengan el impulso.",
    "onboarding.plan.store.eyebrow": "Ruta de lanzamiento de Tienda",
    "Store launch path": "Ruta de lanzamiento de Tienda",
    "onboarding.plan.store.title": "Prepara tu tienda para el primer pedido",
    "Get your store ready for the first order": "Prepara tu tienda para el primer pedido",
    "onboarding.plan.store.title_named": "Prepara {project} para el primer pedido",
    "Make {project} ready for the first order": "Prepara {project} para el primer pedido",
    "onboarding.plan.store.subtitle": "Añade un producto, revisa la tienda y completa los elementos esenciales de la caja.",
    "Add a product check the storefront and complete checkout essentials.": "Añade un producto, revisa la tienda y completa los elementos esenciales de la caja.",
    "onboarding.plan.store.value_moment": "Primer momento de valor: el producto es visible y se puede probar el checkout.",
    "First value moment: a product is visible and checkout can be tested.": "Primer momento de valor: el producto es visible y se puede probar el checkout.",
    "onboarding.plan.store.why_title": "¿Por qué los equipos terminan esto?",
    "onboarding.plan.store.why_body": "Mueve de producto a caja rápidamente para que la tienda se sienta real y el progreso sea motivador.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Mueve de producto a caja rápidamente para que la tienda se sienta real y el progreso sea motivador.",
    "onboarding.plan.booking.eyebrow": "Ruta de lanzamiento de Reserva",
    "Booking launch path": "Ruta de lanzamiento de Reserva",
    "onboarding.plan.booking.title": "Haz que tu plataforma sea reservable",
    "Make your platform bookable": "Haz que tu plataforma sea reservable",
    "onboarding.plan.booking.title_named": "Haz que {project} sea reservable",
    "Make {project} bookable": "Haz que {project} sea reservable",
    "onboarding.plan.booking.subtitle": "Crea el primer servicio, abre la experiencia del cliente y prueba una reserva.",
    "Create the first service open the customer experience and test a reservation.": "Crea el primer servicio, abre la experiencia del cliente y prueba una reserva.",
    "onboarding.plan.booking.value_moment": "Primer momento de valor: un cliente puede solicitar un horario o espacio.",
    "First value moment: a customer can request a time or slot.": "Primer momento de valor: un cliente puede solicitar un horario o espacio.",
    "onboarding.plan.booking.why_title": "¿Por qué los equipos terminan esto?",
    "onboarding.plan.booking.why_body": "Valida la jornada completa de reserva desde el principio para construir confianza antes de expandir.",
    "Validate the full booking journey early to build confidence before expanding.": "Valida la jornada completa de reserva desde el principio para construir confianza antes de expandir.",
    "onboarding.plan.digital.eyebrow": "Ruta de lanzamiento Digital",
    "Digital launch path": "Ruta de lanzamiento Digital",
    "onboarding.plan.digital.title": "Empieza a vender tus productos digitales",
    "Start selling your digital products": "Empieza a vender tus productos digitales",
    "onboarding.plan.digital.title_named": "Prepara {project} para vender productos digitales",
    "Make {project} ready to sell digital products": "Prepara {project} para vender productos digitales",
    "onboarding.plan.digital.subtitle": "Sube una vista previa del producto digital, recorre el flujo del cliente y confirma la preparación para el pago.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Sube una vista previa del producto digital, recorre el flujo del cliente y confirma la preparación para el pago.",
    "onboarding.plan.digital.value_moment": "Primer momento de valor: un comprador puede descubrir y comprar un archivo.",
    "First value moment: a buyer can discover and purchase a file.": "Primer momento de valor: un comprador puede descubrir y comprar un archivo.",
    "onboarding.plan.digital.why_title": "¿Por qué los equipos terminan esto?",
    "onboarding.plan.digital.why_body": "Demuestra la descubierta y compra rápidamente para que expandir el catálogo se sienta como crecimiento.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Demuestra la descubierta y compra rápidamente para que expandir el catálogo se sienta como crecimiento.",
    "onboarding.plan.campaign.eyebrow": "Camino para lanzar una campaña",
    "Campaign launch path": "Camino para lanzar una campaña",
    "onboarding.plan.campaign.title": "Lanza tu plataforma de campaña",
    "Launch your campaign platform": "Lanza tu plataforma de campaña",
    "onboarding.plan.campaign.title_named": "Prepara {project} para sus seguidores",
    "Make {project} ready for supporters": "Prepara {project} para sus seguidores",
    "onboarding.plan.campaign.subtitle": "Crea una vista previa de la campaña, revisa la página pública y prueba el recorrido de contribución.",
    "Create a campaign preview the public page and test the contribution journey.": "Crea una vista previa de la campaña, revisa la página pública y prueba el recorrido de contribución.",
    "onboarding.plan.campaign.value_moment": "Primer momento de valor: un seguidor puede entender y contribuir.",
    "First value moment: a supporter can understand and contribute.": "Primer momento de valor: un seguidor puede entender y contribuir.",
    "onboarding.plan.campaign.why_title": "¿Por qué los equipos terminan esto?",
    "onboarding.plan.campaign.why_body": "Clarifica la historia y el flujo de contribución desde el principio para que los seguidores puedan confiar y actuar.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Clarifica la historia y el flujo de contribución desde el principio para que los seguidores puedan confiar y actuar.",
    "onboarding.plan.creator.eyebrow": "Camino para lanzar un creador",
    "Creator launch path": "Camino para lanzar un creador",
    "onboarding.plan.creator.title": "Prepara para tu primera audiencia",
    "Get ready for your first audience": "Prepara para tu primera audiencia",
    "onboarding.plan.creator.title_named": "Prepara {project} para su primera audiencia",
    "Make {project} ready for its first audience": "Prepara {project} para su primera audiencia",
    "onboarding.plan.creator.subtitle": "Publica una oferta clara, define la experiencia y hazla fácil de descubrir y apoyar tu trabajo.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Publica una oferta clara, define la experiencia y hazla fácil de descubrir y apoyar tu trabajo.",
    "onboarding.plan.creator.value_moment": "Primer momento de valor: tu trabajo es visible y listo para compartir.",
    "First value moment: your work is visible and ready to share.": "Primer momento de valor: tu trabajo es visible y listo para compartir.",
    "onboarding.plan.creator.why_title": "¿Por qué funciona esto?",
    "Why this works": "¿Por qué funciona esto?",
    "onboarding.plan.creator.why_body": "Enfócate en publicar algo real antes de añadir más herramientas o complejidad.",
    "Focus on publishing something real before adding more tools or complexity.": "Enfócate en publicar algo real antes de añadir más herramientas o complejidad.",
    "onboarding.step.open_live_site.title": "Abre la experiencia en vivo",
    "onboarding.step.open_live_site.description": "Empieza con lo que ven los clientes. Esto hace que el producto se sienta real antes de que la configuración se vuelva abstracta.",
    "Start with what customers see. This makes the product feel real before setup becomes abstract.": "Empieza con lo que ven los clientes. Esto hace que el producto se sienta real antes de que la configuración se vuelva abstracta.",
    "onboarding.step.open_live_site.description_domain": "Abre {domain} y ve lo que ven tus clientes. Esto hace que la construcción se sienta real antes del siguiente paso.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Abre {domain} y ve lo que ven tus clientes. Esto hace que la construcción se sienta real antes del siguiente paso.",
    "onboarding.step.open_live_site.cta": "Abrir sitio",
    "Open site": "Abrir sitio",
    "onboarding.step.open_live_site.cta_domain": "Abrir {domain}",
    "Open {domain}": "Abrir {domain}",
    "onboarding.step.open_live_site.impact": "Confirma que el proyecto ya está en vivo.",
    "Confirms the project is already live.": "Confirma que el proyecto ya está en vivo.",
    "onboarding.step.create_supply_shape.title": "Crea la primera categoría",
    "onboarding.step.create_supply_shape.description": "Da a vendedores y compradores un lugar claro para empezar. Las categorías crean estructura para la búsqueda.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Da a vendedores y compradores un lugar claro para empezar. Las categorías crean estructura para la búsqueda.",
    "onboarding.step.create_supply_shape.cta": "Añadir categoría",
    "onboarding.step.create_supply_shape.impact": "Convierte un mercado en blanco en uno navegable.",
    "Turns a blank marketplace into a browsable one.": "Convierte un mercado en blanco en uno navegable.",
    "onboarding.step.post_first_listing.title": "Publica un anuncio de prueba",
    "onboarding.step.post_first_listing.description": "Experimenta el camino del vendedor y publica el primer artículo que los compradores pueden inspeccionar.",
    "Experience the seller path and publish the first item buyers can inspect.": "Experimenta el camino del vendedor y publica el primer artículo que los compradores pueden inspeccionar.",
    "onboarding.step.post_first_listing.cta": "Publicar anuncio",
    "Post listing": "Publicar anuncio",
    "onboarding.step.post_first_listing.impact": "Crea el evento central de activación del mercado.",
    "Creates supply the core marketplace activation event.": "Crea el evento central de activación del mercado.",
    "onboarding.step.test_buyer_action.title": "Actúa como comprador",
    "onboarding.step.test_buyer_action.description": "Navega, añade interés y prueba el camino de pedido para experimentar lo que los clientes verán.",
    "Browse add interest and test the order path to experience what customers will see.": "Navega, añade interés y prueba el camino de pedido para experimentar lo que los clientes verán.",
    "onboarding.step.test_buyer_action.cta": "Probar flujo de comprador",
    "Test buyer flow": "Probar flujo de comprador",
    "onboarding.step.test_buyer_action.impact": "Valida el recorrido del comprador de extremo a extremo.",
    "Validates the buyer journey end to end.": "Valida el recorrido del comprador de extremo a extremo.",
    "onboarding.step.add_first_product.title": "Añade un producto real",
    "Add one real product": "Añade un producto real",
    "onboarding.step.add_first_product.description": "Un producto completo enseña al sistema la forma de tu catálogo mejor que un largo recorrido por la configuración.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Un producto completo enseña al sistema la forma de tu catálogo mejor que un largo recorrido por la configuración.",
    "onboarding.step.add_first_product.cta": "Añadir producto",
    "Add product": "Añadir producto",
    "onboarding.step.add_first_product.impact": "Crea el primer artículo vendible.",
    "Creates the first sellable item.": "Crea el primer artículo vendible.",
    "onboarding.step.setup_payments.title": "Conectar pagos",
    "Connect payments": "Conectar pagos",
    "onboarding.step.setup_payments.description": "Habilita transacciones reales para que los usuarios completen compras sin fricción.",
    "Enable real transactions so users can complete purchases without friction.": "Habilita transacciones reales para que los usuarios completen compras sin fricción.",
    "onboarding.step.setup_payments.cta": "Configurar pagos",
    "Set up payments": "Configurar pagos",
    "onboarding.step.setup_payments.impact": "Desbloquea el camino hacia los ingresos.",
    "Unlocks the path to revenue.": "Desbloquea el camino hacia los ingresos.",
    "onboarding.step.setup_delivery.title": "Configurar método de envío o servicio",
    "Set shipping or service method": "Configurar método de envío o servicio",
    "onboarding.step.setup_delivery.description": "Define cómo se cumplirá el pedido para que el checkout sea predecible para los usuarios.",
    "Define how the order is fulfilled so checkout is predictable for users.": "Define cómo se cumplirá el pedido para que el checkout sea predecible para los usuarios.",
    "onboarding.step.setup_delivery.cta": "Configurar entrega",
    "Configure delivery": "Configurar entrega",
    "onboarding.step.setup_delivery.impact": "Clarifica la cumplimentación en el proceso de pago.",
    "Makes fulfillment clear at checkout.": "Clarifica la cumplimentación en el proceso de pago.",
    "onboarding.step.create_bookable_listing.title": "Crea una oferta reservable",
    "Create one bookable offer": "Crea una oferta reservable",
    "onboarding.step.create_bookable_listing.description": "Añade el evento de servicio, alquiler o cita que los clientes deben reservar primero.",
    "Add the service event rental or appointment customers should book first.": "Añade el evento de servicio, alquiler o cita que los clientes deben reservar primero.",
    "onboarding.step.create_bookable_listing.cta": "Crear oferta",
    "Create offer": "Crear oferta",
    "onboarding.step.create_bookable_listing.impact": "Crea la primera unidad reservable.",
    "Creates the first bookable unit.": "Crea la primera unidad reservable.",
    "onboarding.step.shape_details.title": "Añade detalles de reserva",
    "Add booking details": "Añade detalles de reserva",
    "onboarding.step.shape_details.description": "Utiliza categorías y campos para capturar lo que los clientes necesitan antes de comprometerse.",
    "Use categories and fields to capture what customers need before they commit.": "Utiliza categorías y campos para capturar lo que los clientes necesitan antes de comprometerse.",
    "onboarding.step.shape_details.cta": "Configurar campos",
    "Set up fields": "Configurar campos",
    "onboarding.step.shape_details.impact": "Hace que la oferta sea más fácil de comparar y confiar.",
    "Makes the offer easier to compare and trust.": "Hace que la oferta sea más fácil de comparar y confiar.",
    "onboarding.step.test_booking.title": "Prueba el camino del cliente",
    "Test the customer path": "Prueba el camino del cliente",
    "onboarding.step.test_booking.description": "Abre el flujo público y verifica que los clientes puedan pasar de interés a acción.",
    "Open the public flow and verify customers can move from interest to action.": "Abre el flujo público y verifica que los clientes puedan pasar de interés a acción.",
    "onboarding.step.test_booking.cta": "Probar reserva",
    "Test booking": "Probar reserva",
    "onboarding.step.test_booking.impact": "Valida el recorrido de reserva.",
    "Validates the booking journey.": "Valida el recorrido de reserva.",
    "onboarding.step.upload_digital_product.title": "Sube un producto digital",
    "Upload one digital product": "Sube un producto digital",
    "onboarding.step.upload_digital_product.description": "Haz que el primer elemento descargable esté lo suficientemente completo para previsualizar y vender.",
    "Make the first downloadable item complete enough to preview and sell.": "Haz que el primer elemento descargable esté lo suficientemente completo para previsualizar y vender.",
    "onboarding.step.upload_digital_product.cta": "Añadir producto digital",
    "Add digital product": "Añadir producto digital",
    "onboarding.step.upload_digital_product.impact": "Crea tu primer activo digital vendible.",
    "Creates your first sellable digital asset.": "Crea tu primer activo digital vendible.",
    "onboarding.step.test_purchase.title": "Prueba el flujo de compra",
    "Test purchase flow": "Prueba el flujo de compra",
    "onboarding.step.test_purchase.description": "Previsualiza lo que los compradores ven desde el descubrimiento hasta el checkout.",
    "Preview what buyers see from discovery through checkout.": "Previsualiza lo que los compradores ven desde el descubrimiento hasta el checkout.",
    "onboarding.step.test_purchase.cta": "Probar checkout",
    "Test checkout": "Probar checkout",
    "onboarding.step.test_purchase.impact": "Confirma la ruta del comprador.",
    "Confirms the buyer journey.": "Confirma la ruta del comprador.",
    "onboarding.step.create_campaign.title": "Crea la primera campaña",
    "Create the first campaign": "Crea la primera campaña",
    "onboarding.step.create_campaign.description": "Añade la página de campaña o causa que los patrocinadores deben entender primero.",
    "Add the campaign or cause page supporters should understand first.": "Añade la página de campaña o causa que los patrocinadores deben entender primero.",
    "onboarding.step.create_campaign.cta": "Crear campaña",
    "Create campaign": "Crear campaña",
    "onboarding.step.create_campaign.impact": "Crea el primer motivo público para actuar.",
    "Creates the first public reason to act.": "Crea el primer motivo público para actuar.",
    "onboarding.step.setup_payments_campaign.title": "Conectar pagos de contribuciones",
    "Connect contribution payments": "Conectar pagos de contribuciones",
    "onboarding.step.setup_payments_campaign.description": "La intención del patrocinador importa cuando pueden completar una contribución.",
    "Supporter intent matters when they can complete a contribution.": "La intención del patrocinador importa cuando pueden completar una contribución.",
    "onboarding.step.setup_payments_campaign.cta": "Configurar pagos",
    "onboarding.step.setup_payments_campaign.impact": "Habilita contribuciones reales.",
    "Enables real contributions.": "Habilita contribuciones reales.",
    "onboarding.step.test_supporter_flow.title": "Probar flujo de patrocinador",
    "Test supporter flow": "Probar flujo de patrocinador",
    "onboarding.step.test_supporter_flow.description": "Abre el recorrido público y asegúrate de que la historia y la acción sean claras.",
    "Open the public journey and make sure the story and action are clear.": "Abre el recorrido público y asegúrate de que la historia y la acción sean claras.",
    "onboarding.step.test_supporter_flow.cta": "Probar flujo",
    "Test flow": "Probar flujo",
    "onboarding.step.test_supporter_flow.impact": "Valida la ruta pública.",
    "Validates the public path.": "Valida la ruta pública.",
    "onboarding.step.set_account_categories.title": "Definir categorías de cuentas de proveedor",
    "Define supplier account categories": "Definir categorías de cuentas de proveedor",
    "onboarding.step.set_account_categories.description": "Separa perfiles de proveedor por tipo para mejorar la confianza y la navegación del comprador.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Separa perfiles de proveedor por tipo para mejorar la confianza y la navegación del comprador.",
    "onboarding.step.set_account_categories.cta": "Categorías de cuenta",
    "Account categories": "Categorías de cuenta",
    "onboarding.step.set_account_categories.impact": "Estructura de proveedor establecida.",
    "Supplier structure established.": "Estructura de proveedor establecida.",
    "onboarding.step.set_account_attributes.title": "Agregar atributos de perfil de proveedor",
    "Add supplier profile attributes": "Agregar atributos de perfil de proveedor",
    "onboarding.step.set_account_attributes.description": "Captura detalles que los compradores necesitan antes de contactar o pedir a proveedores.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Captura detalles que los compradores necesitan antes de contactar o pedir a proveedores.",
    "onboarding.step.set_account_attributes.cta": "Atributos de proveedor",
    "Supplier attributes": "Atributos de proveedor",
    "onboarding.step.set_account_attributes.impact": "Más confianza del comprador.",
    "Higher buyer confidence.": "Más confianza del comprador.",
    "onboarding.step.add_promotion.title": "Agregar una promoción de lanzamiento",
    "Add a launch promotion": "Agregar una promoción de lanzamiento",
    "onboarding.step.add_promotion.description": "Crea tu primera promoción para fomentar la acción durante la primera visita.",
    "Create your first promotion to encourage action during the first visit.": "Crea tu primera promoción para fomentar la acción durante la primera visita.",
    "onboarding.step.add_promotion.cta": "Agregar promoción",
    "Add promotion": "Agregar promoción",
    "onboarding.step.add_promotion.impact": "Fortalece la conversión de lanzamiento.",
    "Strengthens launch conversion.": "Fortalece la conversión de lanzamiento.",
    "onboarding.step.create_coupon.title": "Crea tu primer cupón",
    "Create your first coupon": "Crea tu primer cupón",
    "onboarding.step.create_coupon.description": "Prueba descuentos para primeros compradores o miembros.",
    "Test discounts for first-time buyers or members.": "Prueba descuentos para primeros compradores o miembros.",
    "onboarding.step.create_coupon.cta": "Crear cupón",
    "Create coupon": "Crear cupón",
    "onboarding.step.create_coupon.impact": "Desbloquea tu primer bucle de ofertas.",
    "Unlocks your first offer loop.": "Desbloquea tu primer bucle de ofertas.",
    "onboarding.step.collections_setup.title": "Crear una colección",
    "Create a collection": "Crear una colección",
    "onboarding.step.collections_setup.description": "Organiza los listados importantes para mejorar la búsqueda y navegación.",
    "Organize important listings to improve discovery and browsing.": "Organiza los listados importantes para mejorar la búsqueda y navegación.",
    "onboarding.step.collections_setup.cta": "Crear colección",
    "Create collection": "Crear colección",
    "onboarding.step.collections_setup.impact": "Mejora la navegación y descubrimiento.",
    "Improves navigation and discovery.": "Mejora la navegación y descubrimiento.",
    "onboarding.step.configure_comms.title": "Revisar plantillas de comunicación",
    "Review communication templates": "Revisar plantillas de comunicación",
    "onboarding.step.configure_comms.description": "Prepara notificaciones de registro y pedidos antes del crecimiento.",
    "Prepare signup and order notifications before growth.": "Prepara notificaciones de registro y pedidos antes del crecimiento.",
    "onboarding.step.configure_comms.cta": "Abrir comunicaciones",
    "Open communications": "Abrir comunicaciones",
    "onboarding.step.configure_comms.impact": "Prepara las comunicaciones con los clientes.",
    "Prepares customer communications.": "Prepara las comunicaciones con los clientes.",
    "onboarding.step.customize_attributes.title": "Agregar atributos de listado",
    "Add listing attributes": "Agregar atributos de listado",
    "onboarding.step.customize_attributes.description": "Agrega campos estructurados para que los usuarios puedan filtrar y comparar lo que importa.",
    "Add structured fields so users can filter and compare what matters.": "Agrega campos estructurados para que los usuarios puedan filtrar y comparar lo que importa.",
    "onboarding.step.customize_attributes.cta": "Agregar atributos",
    "Add attributes": "Agregar atributos",
    "onboarding.step.customize_attributes.impact": "Facilita la comparación de listados.",
    "Makes listings easier to compare.": "Facilita la comparación de listados.",
    "onboarding.step.add_digital_asset.title": "Agregar otro elemento digital",
    "Add another digital item": "Agregar otro elemento digital",
    "onboarding.step.add_digital_asset.description": "Amplía el catálogo para que los usuarios evalúen calidad y variedad.",
    "Expand the catalog so users can evaluate quality and assortment.": "Amplía el catálogo para que los usuarios evalúen calidad y variedad.",
    "onboarding.step.add_digital_asset.cta": "Agregar listado digital",
    "Add digital listing": "Agregar listado digital",
    "onboarding.step.add_digital_asset.impact": "Mejora la credibilidad del catálogo digital.",
    "Improves digital catalog credibility.": "Mejora la credibilidad del catálogo digital.",
    "personal_assistant.title": "Asistente personal",
    "Personal assistant": "Asistente personal",
    "personal_assistant.heading": "Crecer tu plataforma paso a paso",
    "Grow your platform one step at a time": "Crecer tu plataforma paso a paso",
    "personal_assistant.subtitle": "Diseñado para {launchType}. Priorizamos acciones por impacto y preparación.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Diseñado para {launchType}. Priorizamos acciones por impacto y preparación.",
    "personal_assistant.launch.store": "una tienda",
    "a store": "una tienda",
    "personal_assistant.launch.marketplace": "un mercado",
    "a marketplace": "un mercado",
    "personal_assistant.launch.booking": "una plataforma de reservas",
    "a booking platform": "una plataforma de reservas",
    "personal_assistant.launch.digital": "un negocio digital",
    "a digital business": "un negocio digital",
    "personal_assistant.launch.campaign": "plataforma de campaña",
    "a campaign platform": "plataforma de campaña",
    "personal_assistant.metric.tasks_completed": "Tareas completadas",
    "Tasks completed": "Tareas completadas",
    "personal_assistant.metric.recommendation_clicks": "Clics en recomendaciones",
    "Recommendation clicks": "Clics en recomendaciones",
    "personal_assistant.metric.completed_by_recommendation": "Completado mediante recomendaciones",
    "Completed via recommendations": "Completado mediante recomendaciones",
    "personal_assistant.metric.assist_rate": "Tasa de asistencia",
    "Assist rate": "Tasa de asistencia",
    "personal_assistant.personalizing": "Personalizando sus recomendaciones…",
    "Personalizing your recommendations…": "Personalizando sus recomendaciones…",
    "personal_assistant.do_this_now": "Hacer ahora",
    "Do this now": "Hacer ahora",
    "personal_assistant.estimated_time": "Tiempo estimado: {minutes} min",
    "Estimated time: {minutes} min": "Tiempo estimado: {minutes} min",
    "personal_assistant.minutes_short": "{minutes} min",
    "{minutes} min": "{minutes} min",
    "personal_assistant.open": "Abrir",
    "personal_assistant.mark_done": "Marcar como completado",
    "personal_assistant.up_next": "Próximo",
    "Up next": "Próximo",
    "personal_assistant.coming_after": "Siguiente después de esto",
    "Coming after this": "Siguiente después de esto",
    "personal_assistant.completed_count": "Completado ({count})",
    "Completed ({count})": "Completado ({count})",
    "personal_assistant.hide": "Ocultar",
    "Hide": "Ocultar",
    "personal_assistant.show": "Mostrar",
    "Show": "Mostrar",
    "personal_assistant.feature.open_live_site.name": "Abrir la experiencia en vivo",
    "personal_assistant.feature.open_live_site.outcome": "Confirma que los clientes pueden acceder a la plataforma en vivo.",
    "You confirm customers can reach the live platform.": "Confirma que los clientes pueden acceder a la plataforma en vivo.",
    "personal_assistant.feature.create_supply_shape.name": "Crear la primera categoría",
    "personal_assistant.feature.create_supply_shape.outcome": "Los clientes pueden navegar con una estructura clara.",
    "Customers can browse with a clear structure.": "Los clientes pueden navegar con una estructura clara.",
    "personal_assistant.feature.post_first_listing.name": "Publicar un anuncio de prueba",
    "personal_assistant.feature.post_first_listing.outcome": "La plataforma ahora tiene la primera oferta para evaluar.",
    "The platform now has first supply to evaluate.": "La plataforma ahora tiene la primera oferta para evaluar.",
    "personal_assistant.feature.test_buyer_action.name": "Actuar como comprador",
    "personal_assistant.feature.test_buyer_action.outcome": "Valida la experiencia del lado del comprador de principio a fin.",
    "You validate buyer-side experience end to end.": "Valida la experiencia del lado del comprador de principio a fin.",
    "personal_assistant.feature.setup_payments.name": "Conectar pagos",
    "personal_assistant.feature.setup_payments.outcome": "Los clientes pueden completar transacciones reales.",
    "Customers can complete real transactions.": "Los clientes pueden completar transacciones reales.",
    "personal_assistant.feature.setup_delivery.name": "Configurar método de envío o servicio",
    "personal_assistant.feature.setup_delivery.outcome": "Los clientes pueden entender claramente la cumplimentación.",
    "Customers can understand fulfillment clearly.": "Los clientes pueden entender claramente la cumplimentación.",
    "personal_assistant.feature.add_promotion.name": "Agregar una promoción de lanzamiento",
    "personal_assistant.feature.add_promotion.outcome": "Crea un incentivo para conversiones tempranas.",
    "You create an early conversion incentive.": "Crea un incentivo para conversiones tempranas.",
    "personal_assistant.feature.configure_comms.name": "Revisar plantillas de comunicación",
    "personal_assistant.feature.configure_comms.outcome": "Los usuarios reciben comunicación clara durante todo el ciclo de vida.",
    "Users receive clear lifecycle communication.": "Los usuarios reciben comunicación clara durante todo el ciclo de vida.",
    "personal_assistant.feature.view_orders.name": "Abrir pedidos",
    "Open orders": "Abrir pedidos",
    "personal_assistant.feature.view_orders.outcome": "Puedes monitorear y procesar la demanda entrante.",
    "You can monitor and process incoming demand.": "Puedes monitorear y procesar la demanda entrante.",
    "personal_assistant.feature.view_accounts.name": "Abrir cuentas",
    "Open accounts": "Abrir cuentas",
    "personal_assistant.feature.view_accounts.outcome": "Puedes revisar proveedores o miembros de forma eficiente.",
    "You can review suppliers or members efficiently.": "Puedes revisar proveedores o miembros de forma eficiente.",
    "personal_assistant.feature.configure_account_categories.name": "Configurar categorías de cuentas",
    "Configure account categories": "Configurar categorías de cuentas",
    "personal_assistant.feature.configure_account_categories.outcome": "La estructura de proveedores y miembros es más clara para la incorporación y la confianza.",
    "Supplier and member structure is clearer for onboarding and trust.": "La estructura de proveedores y miembros es más clara para la incorporación y la confianza.",
    "personal_assistant.feature.configure_account_attributes.name": "Configurar atributos de cuenta",
    "Configure account attributes": "Configurar atributos de cuenta",
    "personal_assistant.feature.configure_account_attributes.outcome": "Los perfiles capturan información crítica para los compradores.",
    "Profiles capture decision-critical info for buyers.": "Los perfiles capturan información crítica para los compradores.",
    "personal_assistant.feature.review_account_config.name": "Revisar configuración de cuenta",
    "Review account configuration": "Revisar configuración de cuenta",
    "personal_assistant.feature.review_account_config.outcome": "El comportamiento de la cuenta coincide con su política de mercado.",
    "Account behavior matches your marketplace policy.": "El comportamiento de la cuenta coincide con su política de mercado.",
    "personal_assistant.feature.view_listings.name": "Abrir listados",
    "Open listings": "Abrir listados",
    "personal_assistant.feature.view_listings.outcome": "Puedes monitorear la calidad y preparación del catálogo.",
    "You can monitor catalog quality and readiness.": "Puedes monitorear la calidad y preparación del catálogo.",
    "personal_assistant.feature.configure_listing_categories.name": "Configurar categorías de listados",
    "Configure listing categories": "Configurar categorías de listados",
    "personal_assistant.feature.configure_listing_categories.outcome": "El catálogo se vuelve más fácil de navegar y descubrir.",
    "The catalog becomes easier to navigate and discover.": "El catálogo se vuelve más fácil de navegar y descubrir.",
    "personal_assistant.feature.configure_listing_attributes.name": "Configurar atributos de listado",
    "Configure listing attributes": "Configurar atributos de listado",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Los usuarios pueden comparar listados con detalles estructurados.",
    "Users can compare listings with structured details.": "Los usuarios pueden comparar listados con detalles estructurados.",
    "personal_assistant.feature.configure_variant_types.name": "Configurar tipos de variante",
    "Configure variant types": "Configurar tipos de variante",
    "personal_assistant.feature.configure_variant_types.outcome": "El catálogo admite claramente variaciones de productos y servicios.",
    "The catalog supports product and service variations clearly.": "El catálogo admite claramente variaciones de productos y servicios.",
    "personal_assistant.feature.review_listing_configs.name": "Revisar características adicionales de listado",
    "Review listing additional features": "Revisar características adicionales de listado",
    "personal_assistant.feature.review_listing_configs.outcome": "El comportamiento del listado coincide con su modelo operativo.",
    "Listing behavior matches your operating model.": "El comportamiento del listado coincide con su modelo operativo.",
    "personal_assistant.feature.manage_collections.name": "Gestionar colecciones",
    "Manage collections": "Gestionar colecciones",
    "personal_assistant.feature.manage_collections.outcome": "Las rutas de navegación de alto interés son más fáciles de descubrir.",
    "High-intent browsing paths are easier to discover.": "Las rutas de navegación de alto interés son más fáciles de descubrir.",
    "personal_assistant.feature.manage_coupons.name": "Gestionar cupones",
    "Manage coupons": "Gestionar cupones",
    "personal_assistant.feature.manage_coupons.outcome": "Puede ejecutar ofertas dirigidas para activación.",
    "You can run targeted offers for activation.": "Puede ejecutar ofertas dirigidas para activación.",
    "personal_assistant.feature.view_transactions.name": "Ver transacciones",
    "View transactions": "Ver transacciones",
    "personal_assistant.feature.view_transactions.outcome": "La actividad de pago se puede monitorear para confianza y operaciones.",
    "Payment activity can be monitored for trust and operations.": "La actividad de pago se puede monitorear para confianza y operaciones.",
    "personal_assistant.feature.view_users.name": "Abrir usuarios",
    "Open users": "Abrir usuarios",
    "personal_assistant.feature.view_users.outcome": "Puede monitorear la calidad del crecimiento de clientes y miembros.",
    "You can monitor customer and member growth quality.": "Puede monitorear la calidad del crecimiento de clientes y miembros.",
    "personal_assistant.feature.configure_user_attributes.name": "Configurar atributos de usuario",
    "Configure user attributes": "Configurar atributos de usuario",
    "personal_assistant.feature.configure_user_attributes.outcome": "Puede capturar señales de perfil para mejorar el engagement.",
    "You can capture profile signals to improve engagement.": "Puede capturar señales de perfil para mejorar el engagement.",
    "personal_assistant.feature.review_ratings.name": "Revisar calificaciones y reseñas",
    "Review ratings and reviews": "Revisar calificaciones y reseñas",
    "personal_assistant.feature.review_ratings.outcome": "Las señales de confianza se monitorean y mejoran.",
    "Trust signals are monitored and improved.": "Las señales de confianza se monitorean y mejoran.",
    "personal_assistant.feature.view_reports.name": "Abrir informes",
    "Open reports": "Abrir informes",
    "personal_assistant.feature.view_reports.outcome": "Puede rastrear el rendimiento con una vista de datos.",
    "You can track performance with a data view.": "Puede rastrear el rendimiento con una vista de datos.",
    "personal_assistant.feature.manage_media.name": "Gestionar biblioteca de medios",
    "Manage media library": "Gestionar biblioteca de medios",
    "personal_assistant.feature.manage_media.outcome": "Las imágenes de marca y listado son más fáciles de mantener.",
    "Brand and listing visuals are easier to maintain.": "Las imágenes de marca y listado son más fáciles de mantener.",
    "personal_assistant.feature.manage_reported_listings.name": "Revisar listados reportados",
    "Review reported listings": "Revisar listados reportados",
    "personal_assistant.feature.manage_reported_listings.outcome": "El contenido riesgoso o de baja calidad puede ser manejado rápidamente.",
    "Risky or low-quality content can be handled quickly.": "El contenido riesgoso o de baja calidad puede ser manejado rápidamente.",
    "personal_assistant.feature.app_customization.name": "Personalizar experiencia de app",
    "Customize app experience": "Personalizar experiencia de app",
    "personal_assistant.feature.app_customization.outcome": "La experiencia de app móvil coincide con su marca.",
    "The mobile app experience aligns with your brand.": "La experiencia de app móvil coincide con su marca.",
    "personal_assistant.feature.app_integrations.name": "Configurar integraciones de aplicaciones",
    "Configure app integrations": "Configurar integraciones de aplicaciones",
    "personal_assistant.feature.app_integrations.outcome": "Los servicios de la plataforma central se conectan con los flujos de trabajo de las aplicaciones.",
    "Core platform services connect with app workflows.": "Los servicios de la plataforma central se conectan con los flujos de trabajo de las aplicaciones.",
    "personal_assistant.feature.customize_strings.name": "Personalizar texto de la interfaz",
    "Customize interface text": "Personalizar texto de la interfaz",
    "personal_assistant.feature.customize_strings.outcome": "El texto del producto coincide con tu audiencia y tono.",
    "Product copy matches your audience and tone.": "El texto del producto coincide con tu audiencia y tono.",
    "personal_assistant.feature.review_settings_home.name": "Abrir configuración",
    "Open settings": "Abrir configuración",
    "personal_assistant.feature.review_settings_home.outcome": "La configuración es fácil de encontrar para operaciones del equipo.",
    "Configuration is easy to find for team operations.": "La configuración es fácil de encontrar para operaciones del equipo.",
    "personal_assistant.feature.configure_commission.name": "Configurar comisión",
    "Configure commission": "Configurar comisión",
    "personal_assistant.feature.configure_commission.outcome": "El reparto de ingresos se alinea con tu modelo de negocio.",
    "Revenue sharing aligns with your business model.": "El reparto de ingresos se alinea con tu modelo de negocio.",
    "personal_assistant.feature.configure_taxes.name": "Configurar impuestos",
    "Configure taxes": "Configurar impuestos",
    "personal_assistant.feature.configure_taxes.outcome": "El precio de finalización es predecible y la configuración de impuestos está lista.",
    "Checkout pricing is predictable and tax settings are ready.": "El precio de finalización es predecible y la configuración de impuestos está lista.",
    "personal_assistant.feature.configure_languages.name": "Configurar idiomas",
    "Configure languages": "Configurar idiomas",
    "personal_assistant.feature.configure_languages.outcome": "La experiencia soporta una audiencia multilingüe.",
    "The experience supports a multilingual audience.": "La experiencia soporta una audiencia multilingüe.",
    "personal_assistant.feature.configure_currency.name": "Configurar moneda",
    "Configure currency": "Configurar moneda",
    "personal_assistant.feature.configure_currency.outcome": "Los precios coinciden con las expectativas de tu mercado objetivo.",
    "Prices align with the expectations of your target market.": "Los precios coinciden con las expectativas de tu mercado objetivo.",
    "personal_assistant.feature.configure_countries.name": "Configurar países",
    "Configure countries": "Configurar países",
    "personal_assistant.feature.configure_countries.outcome": "La cobertura geográfica se controla para el lanzamiento.",
    "Geographic coverage is controlled for launch.": "La cobertura geográfica se controla para el lanzamiento.",
    "personal_assistant.feature.review_checkout_settings.name": "Revisar configuración de caja",
    "Review checkout settings": "Revisar configuración de caja",
    "personal_assistant.feature.review_checkout_settings.outcome": "El checkout es más limpio y confiable.",
    "Checkout is cleaner and more reliable.": "El checkout es más limpio y confiable.",
    "personal_assistant.feature.api_configuration.name": "Revisar configuración de API",
    "Review API configuration": "Revisar configuración de API",
    "personal_assistant.feature.api_configuration.outcome": "Las integraciones y el acceso para desarrolladores están listos.",
    "Integrations and developer access are ready.": "Las integraciones y el acceso para desarrolladores están listos.",
    "personal_assistant.feature.workspace_website_editor.name": "Abrir editor de sitio web",
    "Open website editor": "Abrir editor de sitio web",
    "personal_assistant.feature.workspace_website_editor.outcome": "El escaparate puede refinarse para conversión.",
    "The storefront can be refined for conversion.": "El escaparate puede refinarse para conversión.",
    "personal_assistant.feature.workspace_domain_setup.name": "Revisar configuración de dominio",
    "Review domain setup": "Revisar configuración de dominio",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Un dominio limpio mejora la confianza de la marca.",
    "A clean domain improves brand trust.": "Un dominio limpio mejora la confianza de la marca.",
    "personal_assistant.feature.workspace_pages.name": "Revisar páginas del sitio",
    "Review site pages": "Revisar páginas del sitio",
    "personal_assistant.feature.workspace_pages.outcome": "Páginas de aterrizaje y contenido principales que respaldan la confianza del usuario.",
    "Core landing and content pages support user trust.": "Páginas de aterrizaje y contenido principales que respaldan la confianza del usuario.",
    "reports.title": "Informes",
    "reports.metric.0": "Usuarios",
    "reports.metric.1": "Cuentas",
    "reports.metric.2": "Listados",
    "reports.metric.3": "Listados vendidos",
    "Listings Sold": "Listados vendidos",
    "reports.metric.4": "Ventas totales",
    "Total Sales": "Ventas totales",
    "reports.metric.5": "Pedidos totales",
    "reports.metric.6": "Ganancias totales",
    "Total Earnings": "Ganancias totales",
    "reports.chart.activity": "Actividad diaria en el mercado",
    "Daily marketplace activity": "Actividad diaria en el mercado",
    "reports.chart.activity_description": "Listados y nuevos usuarios a lo largo del tiempo",
    "Listings and new users over time": "Listados y nuevos usuarios a lo largo del tiempo",
    "reports.chart.listings_monthly": "Listados mensuales",
    "Listings monthly": "Listados mensuales",
    "reports.chart.listings_daily": "Listados diarios",
    "Listings daily": "Listados diarios",
    "reports.chart.users_daily": "Usuarios diarios",
    "Users daily": "Usuarios diarios",
    "reports.chart.users_monthly": "Usuarios mensuales",
    "Users monthly": "Usuarios mensuales",
    "reports.series.listings": "Listados",
    "reports.series.new_users": "Nuevos usuarios",
    "New users": "Nuevos usuarios",
    "reports.top_sold_listings": "Listados más vendidos",
    "Top sold listings": "Listados más vendidos",
    "reports.view_more_insights": "Ver más información",
    "View more insights": "Ver más información",
    "reports.ai.title": "Informes de ventas con IA",
    "AI sales reports": "Informes de ventas con IA",
    "reports.ai.generating": "Generando informes…",
    "Generating reports…": "Generando informes…",
    "reports.ai.value": "Valor",
    "reports.ai.more_info": "Más información sobre {label}",
    "More information about {label}": "Más información sobre {label}",
    "reports.ai.saved_snapshot": "Instantánea guardada",
    "Saved snapshot": "Instantánea guardada",
    "reports.ai.no_data": "No hay datos disponibles",
    "No data available": "No hay datos disponibles",
    "reports.ai.showing_top": "Mostrando los {shown} primeros de {total} resultados",
    "Showing the top {shown} of {total} results": "Mostrando los {shown} primeros de {total} resultados",
    "reports.ai.saved_report": "Informe de IA guardado",
    "Saved AI report": "Informe de IA guardado",
    "reports.ai.template.country": "Ventas por país",
    "Sales by country": "Ventas por país",
    "reports.ai.template.state": "Ventas por estado",
    "Sales by state": "Ventas por estado",
    "reports.ai.template.city": "Ventas por ciudad",
    "Sales by city": "Ventas por ciudad",
    "reports.ai.template.category": "Ventas por categoría",
    "Sales by category": "Ventas por categoría",
    "reports.ai.template.country_all_time": "Ventas por país (todo el tiempo)",
    "Sales by country (all time)": "Ventas por país (todo el tiempo)",
    "reports.ai.template.top_listings_all_time": "Listados más vendidos (todo el tiempo)",
    "Top sold listings (all time)": "Listados más vendidos (todo el tiempo)",
    "reports.ai.template.listings_by_category_all_time": "Listados por categoría (todo el tiempo)",
    "Listings by category (all time)": "Listados por categoría (todo el tiempo)",
    "reports.search_table.title": "Búsqueda de listados",
    "Listing search": "Búsqueda de listados",
    "reports.search_table.phrase": "Frase",
    "Phrase": "Frase",
    "reports.search_table.result": "Resultado",
    "reports.search_table.created_at": "Creado en",
    "Created at": "Creado en",
    "reports.search_table.user_first_name": "Nombre de usuario",
    "User first name": "Nombre de usuario",
    "reports.search_table.user_last_name": "Apellido de usuario",
    "User last name": "Apellido de usuario",
    "reports.search_table.user_email": "Correo electrónico del usuario",
    "User email": "Correo electrónico del usuario",
    "intelligence.title": "Inteligencia",
    "intelligence.description": "Genera informes de IA, guarda instantáneas de gráficos y fija informes útiles en tu panel.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Genera informes de IA, guarda instantáneas de gráficos y fija informes útiles en tu panel.",
    "intelligence.dashboard.label": "Panel",
    "intelligence.dashboard.pinned_title": "Widgets de inteligencia fijados",
    "Pinned intelligence widgets": "Widgets de inteligencia fijados",
    "intelligence.dashboard.pinned_count": "{count} fijados",
    "{count} pinned": "{count} fijados",
    "intelligence.dashboard.empty": "Fija informes guardados para crear una cuadrícula de panel reutilizable.",
    "Pin saved reports to build a reusable dashboard grid.": "Fija informes guardados para crear una cuadrícula de panel reutilizable.",
    "intelligence.action.open": "Abrir",
    "intelligence.action.pin": "Fijar",
    "Pin": "Fijar",
    "intelligence.action.unpin": "Desfijar",
    "Unpin": "Desfijar",
    "intelligence.action.generate": "Generar",
    "intelligence.action.save_snapshot": "Guardar instantánea",
    "Save snapshot": "Guardar instantánea",
    "intelligence.action.discard_draft": "Descartar borrador",
    "Discard draft": "Descartar borrador",
    "intelligence.action.load": "Cargar",
    "Load": "Cargar",
    "intelligence.action.refresh": "Actualizar",
    "intelligence.action.delete": "Eliminar",
    "intelligence.table.no_rows": "No se devolvieron filas estructuradas para este informe.",
    "No structured rows were returned for this report.": "No se devolvieron filas estructuradas para este informe.",
    "intelligence.table.no_rows_short": "No hay filas disponibles.",
    "No rows available.": "No hay filas disponibles.",
    "intelligence.field.template": "Plantilla de informe",
    "Report template": "Plantilla de informe",
    "intelligence.field.date_filter": "Filtro de fecha",
    "Date filter": "Filtro de fecha",
    "intelligence.field.prompt": "Vista previa del prompt",
    "Prompt preview": "Vista previa del prompt",
    "intelligence.field.report_name": "Nombre del informe",
    "Report name": "Nombre del informe",
    "intelligence.field.report_name_placeholder": "Por ejemplo: Productos más vendidos – Últimos 30 días",
    "For example: Top Selling Products – Last 30 Days": "Por ejemplo: Productos más vendidos – Últimos 30 días",
    "intelligence.field.chart": "Gráfico",
    "Chart": "Gráfico",
    "intelligence.field.prompt_label": "Prompt",
    "Prompt": "Prompt",
    "intelligence.date.relative": "Relativo",
    "Relative": "Relativo",
    "intelligence.date.absolute": "Absoluto",
    "Absolute": "Absoluto",
    "intelligence.date.last_n_days": "Últimos N días",
    "Last N days": "Últimos N días",
    "intelligence.date.last_days": "Últimos {days} días",
    "Last {days} days": "Últimos {days} días",
    "intelligence.date.from": "Desde",
    "From": "Desde",
    "intelligence.date.to": "Hasta",
    "To": "Hasta",
    "intelligence.saved_reports.title": "Informes guardados",
    "Saved reports": "Informes guardados",
    "intelligence.saved_reports.empty": "Aún no hay informes de inteligencia guardados.",
    "No saved intelligence reports yet.": "Aún no hay informes de inteligencia guardados.",
    "intelligence.active_report": "Informe activo",
    "Active report": "Informe activo",
    "intelligence.no_report_selected": "No se ha seleccionado ningún informe",
    "No report selected": "No se ha seleccionado ningún informe",
    "intelligence.active_report.empty_description": "Genera un informe o carga uno guardado para inspeccionar los datos.",
    "Generate a report or load a saved one to inspect the data.": "Genera un informe o carga uno guardado para inspeccionar los datos.",
    "intelligence.chart.value": "Valor",
    "intelligence.chart.unknown": "Desconocido",
    "intelligence.chart_type.bar": "Barras",
    "Barres": "Barras",
    "intelligence.chart_type.line": "Línea",
    "Line": "Línea",
    "intelligence.chart_type.area": "Área",
    "Area": "Área",
    "intelligence.chart_type.pie": "Tarta",
    "Pie": "Tarta",
    "intelligence.chart.no_rows": "Este informe no devolvió filas para trazar.",
    "This report did not return rows to plot.": "Este informe no devolvió filas para trazar.",
    "intelligence.empty_report": "Utiliza la plantilla y los controles de fecha para generar un informe estructurado de IA, luego guárdalo y fíjalo en tu tablero.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Utiliza la plantilla y los controles de fecha para generar un informe estructurado de IA, luego guárdalo y fíjalo en tu tablero.",
    "intelligence.error.update": "No se puede actualizar el informe guardado.",
    "Unable to update the saved report.": "No se puede actualizar el informe guardado.",
    "intelligence.error.prompt_required": "Introduce un prompt para generar un informe.",
    "Enter a prompt to generate a report.": "Introduce un prompt para generar un informe.",
    "intelligence.error.invalid_response": "La respuesta de la IA no incluyó un informe normalizado.",
    "The AI response did not include a normalized report.": "La respuesta de la IA no incluyó un informe normalizado.",
    "intelligence.error.generate": "No se puede generar el informe en este momento.",
    "Unable to generate the report right now.": "No se puede generar el informe en este momento.",
    "intelligence.error.generate_before_save": "Genera un informe antes de guardar.",
    "Generate a report before saving.": "Genera un informe antes de guardar.",
    "intelligence.error.save": "No se puede guardar el informe.",
    "Unable to save the report.": "No se puede guardar el informe.",
    "intelligence.error.load": "No se puede cargar el informe guardado.",
    "Unable to load the saved report.": "No se puede cargar el informe guardado.",
    "intelligence.error.refresh": "No se puede actualizar el informe guardado.",
    "Unable to refresh the saved report.": "No se puede actualizar el informe guardado.",
    "intelligence.error.delete": "No se puede eliminar el informe guardado.",
    "Unable to delete the saved report.": "No se puede eliminar el informe guardado.",
    "intelligence.template.top_selling_products": "Productos más vendidos",
    "Top selling products": "Productos más vendidos",
    "intelligence.template.revenue_trend": "Tendencia de ingresos",
    "Revenue trend": "Tendencia de ingresos",
    "intelligence.template.low_stock_products": "Productos con bajo stock",
    "Low stock products": "Productos con bajo stock",
    "intelligence.template.top_categories_by_sales": "Categorías más vendidas",
    "Top categories by sales": "Categorías más vendidas",
    "intelligence.template.order_status_breakdown": "Desglose de estado de pedidos",
    "Order status breakdown": "Desglose de estado de pedidos",
    "intelligence.template.sales_by_day": "Ventas por día",
    "Sales by day": "Ventas por día",
    "intelligence.template.sales_by_country": "Ventas por país",
    "intelligence.template.sales_by_state": "Ventas por estado",
    "intelligence.template.sales_by_city": "Ventas por ciudad",
    "intelligence.template.sales_by_category": "Ventas por categoría",
    "intelligence.template.sales_by_subcategory": "Ventas por subcategoría",
    "Sales by subcategory": "Ventas por subcategoría",
    "intelligence.prompt.top_selling_products.relative": "Muestra los productos más vendidos de los últimos {days} días",
    "Show me top selling products for the last {days} days": "Muestra los productos más vendidos de los últimos {days} días",
    "intelligence.prompt.top_selling_products.absolute": "Muestra los productos más vendidos desde {from} hasta {to}",
    "Show me top selling products from {from} to {to}": "Muestra los productos más vendidos desde {from} hasta {to}",
    "intelligence.prompt.revenue_trend.relative": "¿Cuál es mi tendencia de ingresos para los últimos {days} días?",
    "What is my revenue trend for the last {days} days?": "¿Cuál es mi tendencia de ingresos para los últimos {days} días?",
    "intelligence.prompt.revenue_trend.absolute": "¿Cuál es mi tendencia de ingresos desde {from} hasta {to}?",
    "What is my revenue trend from {from} to {to}?": "¿Cuál es mi tendencia de ingresos desde {from} hasta {to}?",
    "intelligence.prompt.low_stock_products": "Muestra los productos con bajo stock",
    "Show me low stock products": "Muestra los productos con bajo stock",
    "intelligence.prompt.top_categories_by_sales.relative": "Muestra las categorías más vendidas por ventas para los últimos {days} días",
    "Show me top categories by sales for the last {days} days": "Muestra las categorías más vendidas por ventas para los últimos {days} días",
    "intelligence.prompt.top_categories_by_sales.absolute": "Muestra las categorías más vendidas por ventas desde {from} hasta {to}",
    "Show me top categories by sales from {from} to {to}": "Muestra las categorías más vendidas por ventas desde {from} hasta {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Muestra el desglose del estado de los pedidos para los últimos {days} días",
    "Show me order status breakdown for the last {days} days": "Muestra el desglose del estado de los pedidos para los últimos {days} días",
    "intelligence.prompt.order_status_breakdown.absolute": "Muestra el desglose del estado de los pedidos desde {from} hasta {to}",
    "Show me order status breakdown from {from} to {to}": "Muestra el desglose del estado de los pedidos desde {from} hasta {to}",
    "intelligence.prompt.sales_by_day.relative": "Muestra las ventas por día para los últimos {days} días",
    "Show me sales by day for the last {days} days": "Muestra las ventas por día para los últimos {days} días",
    "intelligence.prompt.sales_by_day.absolute": "Muestra las ventas por día desde {from} hasta {to}",
    "Show me sales by day from {from} to {to}": "Muestra las ventas por día desde {from} hasta {to}",
    "intelligence.prompt.sales_by_country.relative": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por país para los últimos {days} días",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por país para los últimos {days} días",
    "intelligence.prompt.sales_by_country.absolute": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por país desde {from} hasta {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por país desde {from} hasta {to}",
    "intelligence.prompt.sales_by_state.relative": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por estado o provincia para los últimos {days} días",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por estado o provincia para los últimos {days} días",
    "intelligence.prompt.sales_by_state.absolute": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por estado o provincia desde {from} hasta {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Muestra el ingreso total de ventas y el recuento de pedidos agrupados por estado o provincia desde {from} hasta {to}",
    "intelligence.prompt.sales_by_city.relative": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por ciudad para los últimos {days} días",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por ciudad para los últimos {days} días",
    "intelligence.prompt.sales_by_city.absolute": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por ciudad desde {from} hasta {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por ciudad desde {from} hasta {to}",
    "intelligence.prompt.sales_by_category.relative": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por categoría de lista de nivel superior para los últimos {days} días",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por categoría de lista de nivel superior para los últimos {days} días",
    "intelligence.prompt.sales_by_category.absolute": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por categoría de lista de nivel superior desde {from} hasta {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por categoría de lista de nivel superior desde {from} hasta {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por subcategoría de lista para los últimos {days} días",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por subcategoría de lista para los últimos {days} días",
    "intelligence.prompt.sales_by_subcategory.absolute": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por subcategoría de lista desde {from} hasta {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Muestra los ingresos totales de ventas y el recuento de pedidos agrupados por subcategoría de lista desde {from} hasta {to}",
    "common.status.partial": "Parcial",
    "Partial": "Parcial",
    "common.status.dispatched": "Enviado",
    "Dispatched": "Enviado",
    "common.status.sale": "Venta",
    "Sale": "Venta",
    "common.status.transfer_in": "Transferencia entrante",
    "Transfer in": "Transferencia entrante",
    "common.status.transfer_out": "Transferencia saliente",
    "Transfer out": "Transferencia saliente",
    "common.status.return": "Devolución",
    "Return": "Devolución",
    "common.status.adjustment": "Ajuste",
    "Adjustment": "Ajuste",
    "common.status.receipt": "Recibo",
    "inventory.overview.title": "Inventario",
    "inventory.overview.tab.all": "Todo el stock",
    "All stock": "Todo el stock",
    "inventory.overview.tab.low": "Stock bajo",
    "Low stock": "Stock bajo",
    "inventory.overview.tab.expiring": "Lotes próximos a caducar",
    "Expiring batches": "Lotes próximos a caducar",
    "inventory.overview.manage_locations": "Administrar ubicaciones",
    "Manage locations": "Administrar ubicaciones",
    "inventory.overview.purchase_orders": "Pedidos de compra",
    "inventory.overview.operations": "Operaciones",
    "Operations": "Operaciones",
    "inventory.overview.adjust_stock": "Ajustar stock",
    "Adjust stock": "Ajustar stock",
    "inventory.overview.description": "Vista en tiempo real del stock en todas sus ubicaciones.",
    "A live view of stock across your locations.": "Vista en tiempo real del stock en todas sus ubicaciones.",
    "inventory.overview.adjustment_hint": "Utilice ajustes para conteos, daños, devoluciones u otras correcciones.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Utilice ajustes para conteos, daños, devoluciones u otras correcciones.",
    "inventory.overview.units_on_hand": "Unidades en stock",
    "Units on hand": "Unidades en stock",
    "inventory.overview.one_stock_row": "1 fila de stock",
    "1 stock row": "1 fila de stock",
    "inventory.overview.stock_rows": "{count} filas de stock",
    "{count} stock rows": "{count} filas de stock",
    "inventory.overview.low_stock": "Stock bajo",
    "inventory.overview.reorder_point_hint": "En o por debajo del punto de reabastecimiento",
    "At or below reorder point": "En o por debajo del punto de reabastecimiento",
    "inventory.overview.expiring_soon": "Vence pronto",
    "Expiring soon": "Vence pronto",
    "inventory.overview.next_90_days": "Dentro de los próximos 90 días",
    "Within the next 90 days": "Dentro de los próximos 90 días",
    "inventory.overview.stock_value": "Valor del stock",
    "Stock value": "Valor del stock",
    "inventory.overview.one_active_location": "1 ubicación activa",
    "1 active location": "1 ubicación activa",
    "inventory.overview.active_locations": "{count} ubicaciones activas",
    "{count} active locations": "{count} ubicaciones activas",
    "inventory.overview.search": "Buscar inventario",
    "Search inventory": "Buscar inventario",
    "inventory.overview.search_placeholder": "Buscar producto, SKU o ubicación",
    "Search product, SKU, or location": "Buscar producto, SKU o ubicación",
    "inventory.overview.filter_location": "Filtrar por ubicación",
    "Filter by location": "Filtrar por ubicación",
    "inventory.overview.all_locations": "Todas las ubicaciones",
    "inventory.overview.empty.all": "Aún no se ha registrado ningún stock de inventario.",
    "No inventory stock has been recorded yet.": "Aún no se ha registrado ningún stock de inventario.",
    "inventory.overview.empty.low": "¡Genial — no hay stock por debajo de su punto de reabastecimiento!",
    "Great — no stock is below its reorder point.": "¡Genial — no hay stock por debajo de su punto de reabastecimiento!",
    "inventory.overview.empty.expiring": "No hay lotes que caduquen en los próximos 90 días.",
    "No batches are expiring within 90 days.": "No hay lotes que caduquen en los próximos 90 días.",
    "inventory.overview.adjust": "Ajustar",
    "Adjust": "Ajustar",
    "inventory.overview.adjust_title": "Ajustar stock",
    "inventory.overview.adjust_description": "Registra una corrección con una razón para que el historial de inventario permanezca confiable.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Registra una corrección con una razón para que el historial de inventario permanezca confiable.",
    "inventory.overview.save_adjustment": "Guardar ajuste",
    "Save adjustment": "Guardar ajuste",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "No asignado",
    "Unassigned": "No asignado",
    "inventory.overview.quantity_change": "Cambio de cantidad",
    "Quantity change": "Cambio de cantidad",
    "inventory.overview.quantity_placeholder": "Ej.: 5 o -2",
    "e.g. 5 or -2": "Ej.: 5 o -2",
    "inventory.overview.reason": "Motivo",
    "inventory.overview.reason_placeholder": "Ej.: Conteo cíclico, daño, devolución…",
    "Cycle count, damage, return…": "Ej.: Conteo cíclico, daño, devolución…",
    "inventory.overview.reason.cycle_count": "Conteo cíclico",
    "Cycle count": "Conteo cíclico",
    "inventory.overview.reason.damage": "Daño",
    "Damage": "Daño",
    "inventory.overview.reason.return": "Devolución",
    "inventory.overview.reason.stocktake": "Inventario físico",
    "Stocktake": "Inventario físico",
    "inventory.overview.note_placeholder": "Contexto opcional para la siguiente persona",
    "Optional context for the next person": "Contexto opcional para la siguiente persona",
    "inventory.overview.adjustment_saved": "Ajuste de inventario guardado",
    "Inventory adjustment saved": "Ajuste de inventario guardado",
    "inventory.overview.on_hand": "Disponible",
    "On hand": "Disponible",
    "inventory.overview.reorder_at": "Reordenar en",
    "Reorder at": "Reordenar en",
    "orders.create_order.payment_reference_missing": "El pedido se creó, pero no se devolvió ninguna referencia de pedido.",
    "The order was created, but no order reference was returned.": "El pedido se creó, pero no se devolvió ninguna referencia de pedido.",
    "orders.create_order.payment_domain_missing": "El dominio del inquilino no está disponible para enlaces de pago.",
    "The tenant domain is not available for payment links.": "El dominio del inquilino no está disponible para enlaces de pago.",
    "orders.create_order.payment_link_failed": "No se puede crear el enlace de pago.",
    "Unable to create payment link.": "No se puede crear el enlace de pago.",
    "orders.create_order.admin_session_expired": "Su sesión de administrador ha expirado. Inicie sesión nuevamente antes de crear un pedido.",
    "Your admin session has expired. Please sign in again before creating an order.": "Su sesión de administrador ha expirado. Inicie sesión nuevamente antes de crear un pedido.",
    "orders.create_order.user": "Usuario",
    "orders.create_order.add_new_user": "Agregar nuevo usuario",
    "Add New User": "Agregar nuevo usuario",
    "orders.create_order.choose_existing_user": "Seleccionar usuario existente",
    "Choose Existing User": "Seleccionar usuario existente",
    "orders.create_order.preparing_customer": "Preparando cliente…",
    "Preparing customer…": "Preparando cliente…",
    "orders.create_order.select_user": "Seleccionar usuario",
    "Select user": "Seleccionar usuario",
    "orders.create_order.search_listing": "Buscar lista",
    "Search Listing": "Buscar lista",
    "orders.create_order.listings": "Listados",
    "orders.create_order.no_image": "Sin imagen",
    "No image": "Sin imagen",
    "orders.create_order.add_to_cart": "Agregar al carrito",
    "Add to Cart": "Agregar al carrito",
    "orders.create_order.select_rental_dates": "Selecciona primero las fechas de inicio y fin del alquiler.",
    "Select rental start and end dates first.": "Selecciona primero las fechas de inicio y fin del alquiler.",
    "orders.create_order.rental_end_after_start": "La fecha de finalización del alquiler debe ser posterior a la fecha de inicio.",
    "Rental end must be after the start date.": "La fecha de finalización del alquiler debe ser posterior a la fecha de inicio.",
    "orders.create_order.cart_type_conflict": "Este cliente ya tiene artículos con un tipo de lista diferente. Elimina esos artículos en la Caja antes de agregar este.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Este cliente ya tiene artículos con un tipo de lista diferente. Elimina esos artículos en la Caja antes de agregar este.",
    "orders.create_order.rental_period": "Período de alquiler",
    "Rental period": "Período de alquiler",
    "orders.create_order.select_start_end": "Selecciona inicio y fin",
    "Select start and end": "Selecciona inicio y fin",
    "orders.create_order.membership_no_shipping": "Las órdenes de membresía no requieren envío o entrega.",
    "Membership orders do not require shipping or delivery.": "Las órdenes de membresía no requieren envío o entrega.",
    "orders.create_order.preparing_payment_link": "Preparando enlace de pago…",
    "Preparing payment link…": "Preparando enlace de pago…",
    "orders.create_order.payment_link_ready": "Enlace de pago listo",
    "Payment link ready": "Enlace de pago listo",
    "orders.create_order.copy_payment_link": "Copiar enlace de pago",
    "Copy payment link": "Copiar enlace de pago",
    "orders.create_order.payment_method": "Método de pago",
    "orders.create_order.no_payment_methods": "No hay métodos de pago activos configurados para este proyecto.",
    "No active payment methods are configured for this project.": "No hay métodos de pago activos configurados para este proyecto.",
    "orders.create_order.shipping_method": "Método de envío",
    "orders.create_order.no_shipping_methods": "No hay métodos de envío activos configurados para este proyecto.",
    "No active shipping methods are configured for this project.": "No hay métodos de envío activos configurados para este proyecto.",
    "orders.create_order.shipping_address": "Dirección de envío",
    "Shipping address": "Dirección de envío",
    "orders.create_order.loading_addresses": "Cargando direcciones guardadas…",
    "Loading saved addresses…": "Cargando direcciones guardadas…",
    "orders.create_order.no_saved_shipping_address": "Este usuario no tiene dirección de envío guardada. Agrega una antes de crear un pedido de entrega.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "Este usuario no tiene dirección de envío guardada. Agrega una antes de crear un pedido de entrega.",
    "orders.create_order.no_items": "Sin artículos",
    "No items": "Sin artículos",
    "orders.create_order.cart_empty": "Tu carrito está vacío",
    "Your cart is empty": "Tu carrito está vacío",
    "orders.create_order.create_order": "Crear pedido",
    "Create Order": "Crear pedido",
    "orders.create_order.create_payment_link": "Crear enlace de pago",
    "Create payment link": "Crear enlace de pago",
    "orders.create_order.order_summary": "Resumen del pedido",
    "orders.create_order.coupon_value": "Valor del cupón",
    "Coupon value": "Valor del cupón",
    "orders.create_order.remove_coupon": "Eliminar cupón",
    "Remove Coupon": "Eliminar cupón",
    "orders.create_order.apply_coupon": "Aplicar cupón",
    "Apply Coupon": "Aplicar cupón",
    "orders.create_order.grand_amount": "Importe total",
    "Grand Amount": "Importe total",
    "orders.create_order.total": "Total",
    "orders.create_order.shipping": "Envío",
    "Shipping": "Envío",
    "orders.create_order.subtotal": "Subtotal",
    "Subtotal": "Subtotal",
    "orders.create_order.stock_unavailable": "El stock no está disponible",
    "Stock is not available": "El stock no está disponible",
    "orders.create_order.max_quantity": "Cantidad máxima es {quantity}",
    "Max quantity is {quantity}": "Cantidad máxima es {quantity}",
    "orders.create_order.items_in_cart": "Artículos en el carrito",
    "Items in the cart": "Artículos en el carrito",
    "orders.create_order.products_in_stock": "{count} Productos en stock",
    "{count} Products in Stock": "{count} Productos en stock",
    "orders.create_order.order_items": "Artículos del pedido",
    "Order Items": "Artículos del pedido",
    "orders.create_order.sold_by": "por {name}",
    "by {name}": "por {name}",
    "common.first_name": "Nombre",
    "common.last_name": "Apellido",
    "common.unlimited": "ilimitado",
    "unlimited": "ilimitado",
    "orders.reference": "Referencia",
    "orders.amount": "Importe",
    "orders.currency": "Moneda",
    "orders.transaction_date": "Fecha de transacción",
    "Transaction Date": "Fecha de transacción",
    "orders.volume_this_page": "Volumen (página actual)",
    "Volume (this page)": "Volumen (página actual)",
    "orders.seller_entries": "Entradas del vendedor",
    "Seller Entries": "Entradas del vendedor",
    "orders.customer_entries": "Entradas del cliente",
    "Customer Entries": "Entradas del cliente",
    "orders.filter_transactions": "Filtrar transacciones",
    "Filter Transactions": "Filtrar transacciones",
    "orders.reset_filters": "Restablecer filtros",
    "Reset filters": "Restablecer filtros",
    "orders.manage_transactions": "Administrar sus transacciones",
    "Manage your Transactions": "Administrar sus transacciones",
    "orders.empty_transactions_message": "Aquí puedes rastrear todas las transacciones entre usuarios.\nTransacciones como comisiones, precio de pedido, cargos de pago, tarifas especiales, etc.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Aquí puedes rastrear todas las transacciones entre usuarios.\nTransacciones como comisiones, precio de pedido, cargos de pago, tarifas especiales, etc.",
    "orders.super_type": "Tipo super",
    "Super Type": "Tipo super",
    "orders.exporting": "Exportando…",
    "Exporting…": "Exportando…",
    "orders.export_as_csv": "Exportar como CSV",
    "Export as CSV": "Exportar como CSV",
    "orders.search_transactions": "Buscar transacciones",
    "Search transactions": "Buscar transacciones",
    "orders.filter": "Filtrar",
    "Filter": "Filtrar",
    "orders.transaction_status": "Estado de transacción",
    "Transaction Status": "Estado de transacción",
    "orders.seller_protection_fee": "Tarifa de protección al vendedor",
    "Seller Protection Fee": "Tarifa de protección al vendedor",
    "common.show_rows": "Mostrar filas",
    "common.clear_all": "Limpiar todo",
    "orders.order_number_value": "Pedido #{number}",
    "orders.transactions": "Transacciones",
    "reported_listings.report_detail": "Detalle del informe",
    "Report Detail": "Detalle del informe",
    "reported_listings.reported_listing": "Listado denunciado",
    "Reported Listing": "Listado denunciado",
    "reported_listings.pending": "Pendiente",
    "reported_listings.approved": "Aprobado",
    "reported_listings.rejected": "Rechazado",
    "reported_listings.view_marketplace": "Ver en el mercado",
    "View on marketplace": "Ver en el mercado",
    "reported_listings.approve_listing": "Aprobar listado",
    "Approve listing": "Aprobar listado",
    "reported_listings.reject_listing": "Rechazar listado",
    "Reject listing": "Rechazar listado",
    "reported_listings.reported_by": "Denunciado por",
    "Reported By": "Denunciado por",
    "reported_listings.blocked": "Bloqueado",
    "reported_listings.unblock_user": "Desbloquear usuario",
    "Unblock user": "Desbloquear usuario",
    "reported_listings.block_user": "Bloquear usuario",
    "Block user": "Bloquear usuario",
    "reported_listings.report_info": "Información del informe",
    "Report Info": "Información del informe",
    "reported_listings.reason": "Razón",
    "reported_listings.reported_on": "Reportado el",
    "Reported on": "Reportado el",
    "reported_listings.listing_id": "ID de anuncio",
    "reported_listings.reporter": "Reportante",
    "Reporter": "Reportante",
    "reported_listings.listing": "Anuncio",
    "reported_listings.status": "Estado",
    "reported_listings.title": "Listados reportados",
    "reported_listings.report_count": "Denuncias: {count}",
    "Reports: {count}": "Denuncias: {count}",
    "reported_listings.empty_title": "Viendo listados reportados",
    "Viewing Reported listings": "Viendo listados reportados",
    "reported_listings.empty_message": "Aquí encontrarás los anuncios reportados por tus usuarios",
    "You will find your users reported listings here": "Aquí encontrarás los anuncios reportados por tus usuarios",
    "common.page_of": "Página {page} de {total}",
    "Page {page} of {total}": "Página {page} de {total}",
    "common.view": "Ver",
    "reviews.empty_title": "Viendo Calificaciones y Reseñas",
    "Viewing Rate & Reviews": "Viendo Calificaciones y Reseñas",
    "reviews.empty_message": "Aquí encontrarás las calificaciones y reseñas de tus usuarios",
    "You will find your users ratings and reviews here": "Aquí encontrarás las calificaciones y reseñas de tus usuarios",
    "reviews.list": "Lista",
    "reviews.grid": "Cuadrícula",
    "Grid": "Cuadrícula",
    "reviews.title": "Reseñas y Calificaciones",
    "reviews.review": "Reseña",
    "reviews.name": "Nombre",
    "reviews.rating": "Calificación",
    "reviews.title_column": "Título",
    "reviews.content": "Contenido",
    "Content": "Contenido",
    "reviews.image": "Imagen",
    "Image": "Imagen",
    "reviews.images": "Imágenes",
    "Images": "Imágenes",
    "reviews.accounts": "Cuentas",
    "reviews.listings": "Listados",
    "reviews.star": "Estrella",
    "Star": "Estrella",
    "reviews.review_image": "Imagen de revisión",
    "Review image": "Imagen de revisión",
    "reviews.title_required": "El título es obligatorio",
    "Title is required": "El título es obligatorio",
    "reviews.content_required": "El contenido es obligatorio",
    "Content is required": "El contenido es obligatorio",
    "reviews.updated_successfully": "Revisión actualizada con éxito",
    "Review updated successfully": "Revisión actualizada con éxito",
    "reviews.edit_review": "Editar revisión",
    "Edit Review": "Editar revisión",
    "common.not_available": "N/D",
    "common.something_went_wrong": "Algo salió mal",
    "Something went wrong": "Algo salió mal",
    "media.load_failed": "No se puede cargar el medio",
    "Unable to load media.": "No se puede cargar el medio",
    "media.load_failed_retry": "No se puede cargar el medio. Por favor, inténtelo de nuevo.",
    "media.update_failed": "Error al actualizar el medio",
    "Media update failed": "Error al actualizar el medio",
    "media.renamed": "Medio renombrado",
    "Media renamed": "Medio renombrado",
    "media.moved": "Medio movido",
    "Media moved": "Medio movido",
    "media.rename_failed": "No se puede renombrar el medio",
    "Unable to rename media": "No se puede renombrar el medio",
    "media.move_failed": "No se puede mover el medio",
    "Unable to move media": "No se puede mover el medio",
    "media.deleted": "Medio eliminado",
    "Media deleted": "Medio eliminado",
    "media.delete_failed": "No se puede eliminar el medio",
    "Unable to delete media": "No se puede eliminar el medio",
    "media.confirm_delete": "¿Está seguro de que desea eliminar este medio?",
    "Are you sure you want to delete this media?": "¿Está seguro de que desea eliminar este medio?",
    "media.delete_media": "Eliminar medio",
    "Delete media": "Eliminar medio",
    "media.folder_creation_web_only": "La creación de carpetas está disponible en la web",
    "Folder creation is available on web": "La creación de carpetas está disponible en la web",
    "media.no_create_folder_permission": "No tiene permiso para crear carpetas",
    "You do not have permission to create folders": "No tiene permiso para crear carpetas",
    "media.folder_name": "Nombre de carpeta",
    "Folder name": "Nombre de carpeta",
    "media.folder_created": "Carpeta creada",
    "Folder created": "Carpeta creada",
    "media.folder_create_failed": "No se puede crear la carpeta",
    "Unable to create folder": "No se puede crear la carpeta",
    "media.link_copied": "Enlace copiado",
    "Link copied": "Enlace copiado",
    "media.copy_link_failed": "No se puede copiar el enlace",
    "Unable to copy link": "No se puede copiar el enlace",
    "media.urls_copied": "{count} enlaces copiados",
    "{count} URLs copied": "{count} enlaces copiados",
    "media.clipboard_unavailable": "Portapapeles no disponible",
    "Clipboard is not available": "Portapapeles no disponible",
    "media.copy_urls_failed": "No se pueden copiar los enlaces",
    "Unable to copy URLs": "No se pueden copiar los enlaces",
    "media.upload_failed": "Error al subir los medios",
    "Media upload failed": "Error al subir los medios",
    "media.replace_success": "Medios reemplazados. El ID y el enlace estable permanecen sin cambios.",
    "Media replaced. The media ID and stable link are unchanged.": "Medios reemplazados. El ID y el enlace estable permanecen sin cambios.",
    "media.replace_failed": "No se puede reemplazar la media",
    "Unable to replace media": "No se puede reemplazar la media",
    "media.csv_upload_failed": "Error al subir el CSV",
    "CSV upload failed": "Error al subir el CSV",
    "media.csv_metadata_failed": "No se pueden guardar los metadatos del CSV",
    "Unable to save CSV metadata": "No se pueden guardar los metadatos del CSV",
    "media.csv_saved_version": "CSV guardado como nueva versión",
    "CSV saved as a new version": "CSV guardado como nueva versión",
    "media.csv_save_failed": "No se puede guardar el CSV",
    "Unable to save CSV": "No se puede guardar el CSV",
    "media.uploading_files": "Subiendo {count} archivos…",
    "Uploading {count} files…": "Subiendo {count} archivos…",
    "media.upload_progress": "Subiendo {count} archivos · {progress}%",
    "Uploading {count} files · {progress}%": "Subiendo {count} archivos · {progress}%",
    "media.upload_success": "{count} archivos subidos con éxito.",
    "{count} files uploaded successfully.": "{count} archivos subidos con éxito.",
    "media.upload_failed_retry": "No se puede subir la media. Por favor, inténtelo de nuevo.",
    "Unable to upload media. Please try again.": "No se puede subir la media. Por favor, inténtelo de nuevo.",
    "media.register_failed": "No se puede registrar la media",
    "Unable to register media": "No se puede registrar la media",
    "media.list_view": "Vista de lista",
    "List view": "Vista de lista",
    "media.grid_view": "Vista de cuadrícula",
    "Grid view": "Vista de cuadrícula",
    "media.copy_uploaded_urls": "Copiar URLs cargadas",
    "Copy uploaded URLs": "Copiar URLs cargadas",
    "media.copy_visible_urls": "Copiar URLs visibles",
    "Copy visible URLs": "Copiar URLs visibles",
    "media.copy_all_urls": "Copiar todas las URLs",
    "Copy all URLs": "Copiar todas las URLs",
    "media.new_folder": "Nueva carpeta",
    "New folder": "Nueva carpeta",
    "media.uploading_progress": "Subiendo {progress}%",
    "Uploading {progress}%": "Subiendo {progress}%",
    "media.upload_media": "Subir medios",
    "Upload media": "Subir medios",
    "media.manager_title": "Administrador de medios",
    "Media Manager": "Administrador de medios",
    "media.search": "Buscar medios",
    "Search media": "Buscar medios",
    "media.location": "Ubicación",
    "media.media_root": "Medios",
    "media.show_type": "Mostrar {type} medios",
    "Show {type} media": "Mostrar {type} medios",
    "media.type_all": "todo",
    "all": "todo",
    "media.type_image": "imagen",
    "image": "imagen",
    "media.type_video": "vídeo",
    "video": "vídeo",
    "media.type_audio": "audio",
    "audio": "audio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "carpeta",
    "folder": "carpeta",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Más antiguo",
    "Oldest": "Más antiguo",
    "media.newest": "Más reciente",
    "Newest": "Más reciente",
    "media.sort_current": "Ordenar medios, actualmente {sort}",
    "Sort media, currently {sort}": "Ordenar medios, actualmente {sort}",
    "media.loading": "Cargando medios…",
    "Loading media…": "Cargando medios…",
    "media.no_filter_matches": "No hay medios que coincidan con estos filtros.",
    "No media matches these filters.": "No hay medios que coincidan con estos filtros.",
    "media.empty_title": "Tu biblioteca de medios está vacía",
    "Your media library is empty": "Tu biblioteca de medios está vacía",
    "media.empty_message": "Sube imágenes, PDF, videos para reutilizar en casos como promoción, artículo, etc.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Sube imágenes, PDF, videos para reutilizar en casos como promoción, artículo, etc.",
    "media.empty_hint": "Sube archivos o crea una carpeta para empezar.",
    "Upload files or create a folder to get started.": "Sube archivos o crea una carpeta para empezar.",
    "media.folder": "Carpeta",
    "Folder": "Carpeta",
    "media.file_folder_name": "Nombre de archivo o carpeta",
    "File or folder name": "Nombre de archivo o carpeta",
    "media.rename_media": "Renombrar medios",
    "Rename media": "Renombrar medios",
    "media.move_media": "Mover medios",
    "Move media": "Mover medios",
    "media.pdf_preview": "Vista previa de PDF: {name}",
    "PDF preview: {name}": "Vista previa de PDF: {name}",
    "media.pdf_preview_web": "Vista previa de PDF disponible en la aplicación web.",
    "PDF preview is available in the web app.": "Vista previa de PDF disponible en la aplicación web.",
    "media.csv_preview_web": "Vista previa de CSV disponible en la aplicación web.",
    "CSV preview is available in the web app.": "Vista previa de CSV disponible en la aplicación web.",
    "media.media_file": "Archivo multimedia",
    "Media file": "Archivo multimedia",
    "media.share_link": "Enlace para compartir",
    "Share link": "Enlace para compartir",
    "media.copy_link": "Copiar enlace",
    "Copy link": "Copiar enlace",
    "media.replace_media": "Reemplazar medios",
    "Replace media": "Reemplazar medios",
    "media.folders": "Carpetas",
    "Folders": "Carpetas",
    "media.create_new_folder": "Crear nueva carpeta",
    "Create new folder": "Crear nueva carpeta",
    "media.go_to_all_media": "Ir a todos los medios",
    "Go to all media": "Ir a todos los medios",
    "media.all_media": "Todos los medios",
    "All media": "Todos los medios",
    "media.open_folder_name": "Abrir carpeta {name}",
    "Open folder {name}": "Abrir carpeta {name}",
    "media.no_subfolders": "Sin subcarpetas",
    "No subfolders": "Sin subcarpetas",
    "media.no_files_in_folder": "No hay archivos en esta carpeta.",
    "No files in this folder.": "No hay archivos en esta carpeta.",
    "media.upload_folder": "Subir medios a esta carpeta",
    "Upload media to this folder": "Subir medios a esta carpeta",
    "media.discard_csv_confirm": "¿Descartar los cambios en el CSV?",
    "Discard your CSV changes?": "¿Descartar los cambios en el CSV?",
    "media.unsaved_changes": "Cambios no guardados",
    "Unsaved changes": "Cambios no guardados",
    "media.find_csv": "Buscar en CSV",
    "Find in CSV": "Buscar en CSV",
    "media.save_csv": "Guardar CSV",
    "Save CSV": "Guardar CSV",
    "media.loading_csv": "Cargando CSV…",
    "Loading CSV…": "Cargando CSV…",
    "media.prepare_folder_failed": "No se puede preparar la carpeta de carga",
    "Unable to prepare the upload folder": "No se puede preparar la carpeta de carga",
    "media.add_file_required": "Agregue un archivo",
    "Please add a file": "Agregue un archivo",
    "media.add_media": "Agregar Medios",
    "Add Media": "Agregar Medios",
    "media.store_uploaded_media_in": "Almacenar medios subidos en",
    "Store uploaded media in": "Almacenar medios subidos en",
    "media.destination_business_cards": "Tarjetas de presentación",
    "Business Cards": "Tarjetas de presentación",
    "media.destination_listings": "Listados",
    "media.destination_accounts": "Cuentas",
    "media.destination_users": "Usuarios",
    "media.upload_media_title": "Subir Medios",
    "media.media_files": "Medios",
    "media.open_folder": "Abrir carpeta",
    "Open folder": "Abrir carpeta",
    "common.show": "Mostrar",
    "common.share": "Compartir",
    "Share": "Compartir",
    "common.copy": "Copiar",
    "common.rename": "Renombrar",
    "Rename": "Renombrar",
    "common.move": "Mover",
    "Move": "Mover",
    "common.type": "Tipo",
    "common.size": "Tamaño",
    "Size": "Tamaño",
    "common.preview": "Vista previa",
    "common.undo": "Deshacer",
    "Undo": "Deshacer",
    "common.redo": "Rehacer",
    "Redo": "Rehacer",
    "common.discard": "Descartar",
    "Discard": "Descartar",
    "common.try_again": "Intentar de nuevo",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Hoja de cálculo",
    "Spreadsheet": "Hoja de cálculo",
    "media.type_file": "Archivo",
    "File": "Archivo",
    "media.csv_load_failed": "No se puede cargar el CSV. Inténtalo de nuevo.",
    "Unable to load CSV. Please try again.": "No se puede cargar el CSV. Inténtalo de nuevo.",
    "workspace.settings_section.customisation": "Personalización",
    "workspace.settings_section.integrations": "Integraciones",
    "workspace.settings_section.platform_setup": "Configuración de la plataforma",
    "Platform Setup": "Configuración de la plataforma",
    "workspace.settings_section.business_operations": "Operaciones comerciales",
    "Business Operations": "Operaciones comerciales",
    "workspace.settings_section.system_setup": "Configuración del sistema",
    "System Setup": "Configuración del sistema",
    "workspace.settings_item.app_customisation": "Personalización de la aplicación",
    "workspace.settings_item.web_customisation": "Personalización web",
    "Web Customisation": "Personalización web",
    "workspace.settings_item.communications": "Comunicaciones",
    "Communications": "Comunicaciones",
    "workspace.settings_item.strings_customisation": "Personalización de cadenas",
    "Strings Customisation": "Personalización de cadenas",
    "workspace.settings_item.app_integrations": "Integraciones de aplicación",
    "workspace.settings_item.web_integrations": "Integraciones web",
    "Web Integrations": "Integraciones web",
    "workspace.settings_item.accounts": "Cuentas",
    "workspace.settings_item.listings": "Listados",
    "workspace.settings_item.checkout_and_cart_attributes": "Atributos de compra y carrito",
    "workspace.settings_item.service_shipping": "Servicio / Envío",
    "workspace.settings_item.payments": "Pagos",
    "workspace.settings_item.commissions": "Comisiones",
    "workspace.settings_item.taxes": "Impuestos",
    "workspace.settings_item.special_fees": "Tarifas especiales",
    "workspace.settings_item.languages": "Idiomas",
    "workspace.settings_item.currency": "Moneda",
    "workspace.settings_item.countries": "Países",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Extensiones",
    "Extensions": "Extensiones",
    "workspace.settings_item.manage_features": "Administrar características",
    "Manage Features": "Administrar características",
    "workspace.settings_item.audit_logs": "Registros de auditoría",
    "Audit Logs": "Registros de auditoría",
    "workspace.settings_item.auth": "Autenticación",
    "workspace.settings_item.maps": "Mapas",
    "workspace.settings_hint.accounts": "Ejemplo: Tienda",
    "Example: Store": "Ejemplo: Tienda",
    "workspace.settings_hint.listings": "Ejemplo: Productos, Eventos",
    "Example: Products, Events": "Ejemplo: Productos, Eventos",
    "workspace.settings_hint.audit_logs": "Rastro de cumplimiento y seguridad",
    "Compliance & security trail": "Rastro de cumplimiento y seguridad",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Configuración de proveedor y privacidad",
    "Provider usage and privacy settings": "Configuración de proveedor y privacidad",
    "workspace.settings_access_denied": "No tienes acceso a {name}",
    "You don't have access of {name}": "No tienes acceso a {name}",
    "app_customization.title": "Personalización de aplicación",
    "app_customization.tab_0": "General",
    "General": "General",
    "app_customization.tab_1": "Pantalla de inicio",
    "Splash": "Pantalla de inicio",
    "app_customization.tab_2": "Introducción",
    "Onboarding": "Introducción",
    "app_customization.tab_3": "Registro",
    "Registration": "Registro",
    "app_customization.tab_4": "Inicio",
    "Home": "Inicio",
    "app_customization.tab_5": "Notificaciones por push",
    "Push Notification": "Notificaciones por push",
    "app_customization.tab_6": "Chat",
    "Chat": "Chat",
    "app_customization.tab_7": "Menú más",
    "More Menu": "Menú más",
    "app_customization.tab_8": "Actualización forzada",
    "Force Update": "Actualización forzada",
    "app_customization.tab_9": "Dirección",
    "app_customization.hide_balances": "Ocultar balances y pagos en la sección Más",
    "app_customization.more": "Más",
    "app_customization.force_update": "Forzar actualización",
    "Force To Update": "Forzar actualización",
    "app_customization.android_version": "Versión de la aplicación Android",
    "Android app version": "Versión de la aplicación Android",
    "app_customization.enter_android_version": "Introducir versión de la aplicación Android",
    "Enter android app version": "Introducir versión de la aplicación Android",
    "app_customization.ios_version": "Versión de la aplicación iOS",
    "iOS app version": "Versión de la aplicación iOS",
    "app_customization.enter_ios_version": "Introducir versión de la aplicación iOS",
    "Enter iOS app version": "Introducir versión de la aplicación iOS",
    "app_customization.chat": "Chat",
    "app_customization.chat_send_listing": "Habilitar envío automático de listados al hacer clic en chat (Por defecto muestra vista previa en la parte superior)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Habilitar envío automático de listados al hacer clic en chat (Por defecto muestra vista previa en la parte superior)",
    "app_customization.make_offer": "Hacer oferta / Negociación",
    "Make Offer / Negotiation": "Hacer oferta / Negociación",
    "app_customization.negotiation_button_name": "Nombre del botón de negociación:",
    "Negotiation button name:": "Nombre del botón de negociación:",
    "app_customization.negotiation_button_example": "(ejemplo: Hacer oferta, Negociar, Cotizar)",
    "(example: Make Offer, Negotiate, Quote)": "(ejemplo: Hacer oferta, Negociar, Cotizar)",
    "app_customization.enter_negotiation_button_name": "Introducir nombre del botón de negociación",
    "Enter negotiation button name": "Introducir nombre del botón de negociación",
    "app_customization.address": "Dirección",
    "app_customization.address_option_0": "Mostrar Dirección 2",
    "Show Address 2": "Mostrar Dirección 2",
    "app_customization.address_option_1": "Mostrar País",
    "Show Country": "Mostrar País",
    "app_customization.address_option_2": "Mostrar Código postal",
    "Show Zipcode": "Mostrar Código postal",
    "app_customization.address_option_3": "Mostrar Estado",
    "Show State": "Mostrar Estado",
    "app_customization.address_option_4": "Mostrar Punto de referencia",
    "Show Landmark": "Mostrar Punto de referencia",
    "app_customization.address_option_5": "Mostrar Ciudad",
    "Show City": "Mostrar Ciudad",
    "app_customization.persistent_notification": "Notificación persistente",
    "Persistent Notification": "Notificación persistente",
    "app_customization.account_follow_content": "Contenido de notificación de seguimiento de cuenta",
    "Account follow notification content": "Contenido de notificación de seguimiento de cuenta",
    "app_customization.enter_account_follow_content": "Introducir contenido de notificación de seguimiento de cuenta",
    "Enter Account follow notification content": "Introducir contenido de notificación de seguimiento de cuenta",
    "app_customization.listing_like_content": "Contenido de notificación de me gusta en listado",
    "Listing like notification content": "Contenido de notificación de me gusta en listado",
    "app_customization.enter_listing_like_content": "Introducir contenido de notificación como anuncio",
    "Enter Listing like  notification content": "Introducir contenido de notificación como anuncio",
    "app_customization.order_status_content": "Contenido de notificación de estado de pedido",
    "Order status notification content": "Contenido de notificación de estado de pedido",
    "app_customization.enter_order_status_content": "Contenido de notificación de seguimiento de estado de pedido",
    "Order status follow notification content": "Contenido de notificación de seguimiento de estado de pedido",
    "app_customization.account_follow_required": "La notificación de seguimiento de cuenta debe contener {account_name}",
    "Account follow notification should contain {account_name}": "La notificación de seguimiento de cuenta debe contener {account_name}",
    "app_customization.listing_like_required": "El contenido de notificación de me gusta en el anuncio debe contener {user_name}",
    "Listing like notification content should contain {user_name}": "El contenido de notificación de me gusta en el anuncio debe contener {user_name}",
    "app_customization.order_number_required": "El contenido de notificación de estado de pedido debe contener #{order_number}",
    "Order status notification content should contain #{order_number}": "El contenido de notificación de estado de pedido debe contener #{order_number}",
    "app_customization.order_status_required": "El contenido de notificación de estado de pedido debe contener {order_status}",
    "Order status notification content should contain {order_status}": "El contenido de notificación de estado de pedido debe contener {order_status}",
    "app_customization.preview": "Vista previa",
    "app_customization.splash": "Pantalla de inicio",
    "app_customization.splash_image": "Imagen de pantalla de inicio",
    "Splash Screen Image": "Imagen de pantalla de inicio",
    "app_customization.registration": "Registro",
    "app_customization.registration_text": "Texto de registro",
    "Registration text": "Texto de registro",
    "app_customization.otp_note": "Nota de verificación OTP",
    "OTP Verification note": "Nota de verificación OTP",
    "app_customization.get_signup_first": "Obtener registro primero",
    "Get sign up first": "Obtener registro primero",
    "app_customization.mobile_in_email_signup": "Número de móvil en registro por correo electrónico",
    "Mobile number in email signup": "Número de móvil en registro por correo electrónico",
    "app_customization.preview_field_first_name": "Nombre",
    "app_customization.preview_field_last_name": "Apellido",
    "app_customization.preview_field_email": "Correo electrónico",
    "app_customization.preview_field_password": "Contraseña",
    "Password": "Contraseña",
    "app_customization.preview_field_confirm_password": "Confirmar contraseña",
    "Confirm Password": "Confirmar contraseña",
    "app_customization.preview_field_dob": "Fecha de nacimiento",
    "DOB": "Fecha de nacimiento",
    "app_customization.preview_field_mobile_no": "Número de móvil",
    "Mobile No": "Número de móvil",
    "app_customization.create": "Crear",
    "app_customization.login": "Iniciar sesión",
    "Login": "Iniciar sesión",
    "app_customization.create_account": "Crear tu cuenta",
    "Create your account": "Crear tu cuenta",
    "app_customization.login_account": "Iniciar sesión en tu cuenta",
    "Login to your account": "Iniciar sesión en tu cuenta",
    "app_customization.onboarding_settings": "Configuración de bienvenida",
    "Onboarding Settings": "Configuración de bienvenida",
    "app_customization.onboarding_images": "Imágenes de bienvenida",
    "Onboarding Images": "Imágenes de bienvenida",
    "app_customization.onboarding_text_1": "Texto de bienvenida 1",
    "Onboarding text 1": "Texto de bienvenida 1",
    "app_customization.onboarding_text_2": "Texto de bienvenida 2",
    "Onboarding text 2": "Texto de bienvenida 2",
    "app_customization.onboarding_text_3": "Texto de bienvenida 3",
    "Onboarding text 3": "Texto de bienvenida 3",
    "app_customization.see_how_it_works": "Ver cómo funciona",
    "See how it works": "Ver cómo funciona",
    "app_customization.sell_icon_text": "Texto del icono de venta",
    "Sell icon text": "Texto del icono de venta",
    "app_customization.enter_sell_icon_text": "Introducir texto del icono de venta",
    "Enter sell icon text": "Introducir texto del icono de venta",
    "app_customization.sell_icon": "Icono de venta",
    "Sell Icon": "Icono de venta",
    "app_customization.enter_home_title": "Introducir título de la aplicación en la pantalla de inicio",
    "Enter app title in home": "Introducir título de la aplicación en la pantalla de inicio",
    "app_customization.app_details": "Detalles de la aplicación",
    "App Details": "Detalles de la aplicación",
    "app_customization.app_name": "Nombre de la aplicación",
    "App Name": "Nombre de la aplicación",
    "app_customization.primary_colour": "Color primario de la aplicación",
    "App Primary Colour": "Color primario de la aplicación",
    "app_customization.secondary_colour": "Color secundario de la aplicación",
    "App Secondary Colour": "Color secundario de la aplicación",
    "app_customization.android_app_icon": "Icono de aplicación Android",
    "App Icon Android": "Icono de aplicación Android",
    "app_customization.ios_app_icon": "Icono de aplicación iOS",
    "App Icon iOS": "Icono de aplicación iOS",
    "app_customization.screen_number": "Pantalla {number}",
    "Screen {number}": "Pantalla {number}",
    "app_customization.upload_here": "Subir aquí",
    "Upload here": "Subir aquí",
    "app_customization.next": "Siguiente",
    "app_customization.get_started": "Empezar",
    "Get Start": "Empezar",
    "app_customization.select": "Seleccionar",
    "Select": "Seleccionar",
    "app_customization.app_title_home_icon": "Título de la aplicación en el icono de inicio",
    "App Title Home Icon": "Título de la aplicación en el icono de inicio",
    "app_customization.home_icon_hint": "(el icono debe ser blanco y en formato png)",
    "(icon should be white and in png format)": "(el icono debe ser blanco y en formato png)",
    "app_customization.home_title": "Título de la aplicación en la pantalla de inicio",
    "app_customization.default_collection_widgets": "Widgets predeterminados de colección",
    "Default Collection Widgets": "Widgets predeterminados de colección",
    "app_customization.accounts_follow_title": "Título de colección 'Cuentas a seguir'",
    "Accounts to follow collection title": "Título de colección 'Cuentas a seguir'",
    "app_customization.enter_accounts_follow_title": "Introduzca el título de colección 'Cuentas a seguir'",
    "Enter accounts to follow collection title": "Introduzca el título de colección 'Cuentas a seguir'",
    "app_customization.nearby_accounts_title": "Título de colección 'Cuentas cercanas'",
    "Nearby accounts collection title": "Título de colección 'Cuentas cercanas'",
    "app_customization.enter_nearby_accounts_title": "Introduzca el título de colección 'Cuentas cercanas'",
    "Enter near by accounts collection title": "Introduzca el título de colección 'Cuentas cercanas'",
    "app_customization.latest_listings_title": "Título de colección 'Listados recientes'",
    "Latest listings collection title": "Título de colección 'Listados recientes'",
    "app_customization.enter_latest_listings_title": "Introduzca el título de colección 'Listados recientes'",
    "Enter latest listings collection title": "Introduzca el título de colección 'Listados recientes'",
    "app_customization.enable_appearance_sections": "Seleccione para habilitar las secciones de apariencia",
    "Select to enable appearance sections": "Seleccione para habilitar las secciones de apariencia",
    "app_customization.choose_photo": "Elegir foto",
    "Choose photo": "Elegir foto",
    "app_customization.choose_icon": "Elegir icono",
    "Choose icon": "Elegir icono",
    "app_customization.enable_home_icon": "Habilitar icono de título de aplicación en lugar de texto",
    "Enable app title icon instead of text": "Habilitar icono de título de aplicación en lugar de texto",
    "app_customization.account_name": "Nombre de cuenta",
    "Account Name": "Nombre de cuenta",
    "app_customization.product_name": "Nombre de producto",
    "Product Name": "Nombre de producto",
    "app_customization.home_option_0": "Mostrar colección 'Cercanas'",
    "Show nearby collection": "Mostrar colección 'Cercanas'",
    "app_customization.home_option_1": "Mostrar sección de categorías",
    "Show category section": "Mostrar sección de categorías",
    "app_customization.home_option_2": "Mostrar banners promocionales",
    "Show promo banners": "Mostrar banners promocionales",
    "app_customization.home_option_3": "Mostrar invitación a amigos",
    "Show invite friends": "Mostrar invitación a amigos",
    "app_customization.home_option_4": "Mostrar recordatorios de reseñas",
    "Show review reminders": "Mostrar recordatorios de reseñas",
    "app_customization.home_option_5": "Cuentas a seguir",
    "Accounts to follow": "Cuentas a seguir",
    "app_customization.download": "Descargar",
    "app_customization.cancel": "Cancelar",
    "app_customization.uploaded_successfully": "Subido con éxito",
    "Uploaded successfully": "Subido con éxito",
    "app_customization.image_limit": "No puedes seleccionar más imágenes",
    "You cannot select more images": "No puedes seleccionar más imágenes",
    "app_customization.choose_zip_file": "Seleccionar archivo zip",
    "Choose zip file": "Seleccionar archivo zip",
    "app_translation.title": "Personalización de cadenas",
    "app_translation.search": "Escriba para buscar...",
    "Type to search...": "Escriba para buscar...",
    "app_translation.default_language": "Predeterminado",
    "Default": "Predeterminado",
    "app_translation.default_text": "Texto predeterminado",
    "Default text": "Texto predeterminado",
    "communications.title": "Comunicaciones",
    "communications.tab_0": "Notificación por correo electrónico",
    "Email Notification": "Notificación por correo electrónico",
    "communications.tab_1": "Configuración de correo electrónico",
    "Email Configuration": "Configuración de correo electrónico",
    "communications.tab_2": "Notificación de pedido",
    "Order Notification": "Notificación de pedido",
    "communications.tab_3": "Formulario de comentarios",
    "Feedback Form": "Formulario de comentarios",
    "communications.translate": "Traducir",
    "Translate": "Traducir",
    "communications.edit_email_template": "Editar plantilla de correo electrónico",
    "Edit email template": "Editar plantilla de correo electrónico",
    "communications.feedback_email": "Correo electrónico",
    "communications.feedback_phone": "Teléfono",
    "communications.feedback_email_or_phone": "Correo electrónico o teléfono",
    "Email or Phone": "Correo electrónico o teléfono",
    "communications.select_type": "Seleccionar tipo",
    "Select type": "Seleccionar tipo",
    "communications.form_required_field": "Campo requerido del formulario",
    "Form Required Field": "Campo requerido del formulario",
    "communications.feedback_recipient_label": "Correo electrónico para recibir comentarios (Para más de un correo, ingrese como separado por comas)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Correo electrónico para recibir comentarios (Para más de un correo, ingrese como separado por comas)",
    "communications.enter_email": "Ingresar correo electrónico",
    "Enter email": "Ingresar correo electrónico",
    "communications.enable_feedback_form": "Habilitar formulario de comentarios",
    "Enable feedback Form": "Habilitar formulario de comentarios",
    "communications.feedback": "Comentarios",
    "Feedback": "Comentarios",
    "communications.realtime_config_notice": "Estas configuraciones se aplican en tiempo real. Al hacer cambios aquí y hacer clic en Guardar, se reflejarán en las aplicaciones y respuestas de la API.",
    "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.": "Estas configuraciones se aplican en tiempo real. Al hacer cambios aquí y hacer clic en Guardar, se reflejarán en las aplicaciones y respuestas de la API.",
    "communications.uploaded_successfully": "Subido con éxito",
    "communications.email_whitelabeling": "Marca blanca de correo electrónico",
    "Email Whitelabelling": "Marca blanca de correo electrónico",
    "communications.from_name": "Nombre de remitente",
    "From name": "Nombre de remitente",
    "communications.enter_from_name": "Introduzca nombre de remitente",
    "Enter from name": "Introduzca nombre de remitente",
    "communications.from_email_address": "Dirección de correo electrónico de remitente",
    "From email address": "Dirección de correo electrónico de remitente",
    "communications.from_email_domain_hint": "Ha elegido un dominio personalizado para su dirección de correo electrónico de remitente. Para asegurar que sus correos electrónicos se entreguen, verifique su dominio con nosotros. Póngase en contacto con nuestro equipo de soporte para obtener ayuda con el proceso de verificación.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Ha elegido un dominio personalizado para su dirección de correo electrónico de remitente. Para asegurar que sus correos electrónicos se entreguen, verifique su dominio con nosotros. Póngase en contacto con nuestro equipo de soporte para obtener ayuda con el proceso de verificación.",
    "communications.reset": "Restablecer",
    "communications.enter_from_email": "Introduzca dirección de correo electrónico de remitente",
    "Enter from email address": "Introduzca dirección de correo electrónico de remitente",
    "communications.email_header_logo": "Logotipo del encabezado de correo electrónico",
    "Email Header Logo": "Logotipo del encabezado de correo electrónico",
    "communications.choose_logo": "Elegir archivo 50*50",
    "Choose file 50*50": "Elegir archivo 50*50",
    "communications.list_view": "Vista de lista",
    "communications.gallery_view": "Vista de galería",
    "Gallery view": "Vista de galería",
    "communications.grid_view": "Vista de cuadrícula",
    "communications.search": "Buscar comunicaciones",
    "Search communications": "Buscar comunicaciones",
    "communications.email_settings": "Configuración de correo electrónico",
    "Email settings": "Configuración de correo electrónico",
    "communications.category_all": "Todos",
    "communications.category_buyer": "Comprador",
    "Buyer": "Comprador",
    "communications.category_seller": "Vendedor",
    "communications.category_transactional": "Transaccional",
    "Transactional": "Transaccional",
    "communications.category_engagement": "Compromiso",
    "Engagement": "Compromiso",
    "communications.category_retention": "Retención",
    "Retention": "Retención",
    "communications.category_membership": "Membresía",
    "communications.audience_buyer": "Comprador",
    "communications.audience_seller": "Vendedor",
    "communications.system_notification": "Notificación del sistema",
    "System notification": "Notificación del sistema",
    "communications.template": "plantilla",
    "template": "plantilla",
    "communications.edit": "Editar",
    "communications.sent": "enviado",
    "sent": "enviado",
    "communications.open": "abierto",
    "communications.clicks": "clics",
    "clicks": "clics",
    "communications.no_email_matches": "No hay correos electrónicos que coincidan con tu filtro.",
    "No emails match your filter.": "No hay correos electrónicos que coincidan con tu filtro.",
    "communications.buyer_order_confirmation": "Correo electrónico de confirmación de pedido para comprador",
    "Order confirmation email for buyer": "Correo electrónico de confirmación de pedido para comprador",
    "communications.seller_order_confirmation": "Correo electrónico de confirmación de pedido para vendedor",
    "Order confirmation email for seller": "Correo electrónico de confirmación de pedido para vendedor",
    "communications.email_card_0": "Mensaje de bienvenida",
    "Welcome Message": "Mensaje de bienvenida",
    "communications.email_card_1": "OTP / Verificación",
    "OTP / Verification": "OTP / Verificación",
    "communications.email_card_2": "Enlace de suscripción",
    "Subscription Link": "Enlace de suscripción",
    "communications.email_card_3": "Suscripción exitosa",
    "Subscription Success": "Suscripción exitosa",
    "communications.email_card_4": "Confirmación de pedido — comprador",
    "Order confirmation — buyer": "Confirmación de pedido — comprador",
    "communications.email_card_5": "Confirmación de pedido — vendedor",
    "Order confirmation — seller": "Confirmación de pedido — vendedor",
    "communications.email_card_6": "Envío enviado — comprador",
    "Shipment shipped — buyer": "Envío enviado — comprador",
    "communications.email_card_7": "Entrega realizada — comprador",
    "Shipment delivered — buyer": "Entrega realizada — comprador",
    "communications.email_card_8": "Pedido cancelado — comprador",
    "Order cancelled — buyer": "Pedido cancelado — comprador",
    "communications.email_card_9": "Reembolso procesado — comprador",
    "Refund processed — buyer": "Reembolso procesado — comprador",
    "communications.email_card_10": "Nueva lista de tienda seguida — comprador",
    "New listing from followed store — buyer": "Nueva lista de tienda seguida — comprador",
    "communications.email_card_11": "Producto de nuevo en stock — comprador",
    "Back in stock — buyer": "Producto de nuevo en stock — comprador",
    "communications.email_card_12": "Aviso de vencimiento de lista — vendedor",
    "Listing expiry warning — seller": "Aviso de vencimiento de lista — vendedor",
    "communications.email_card_13": "Hitos de likes en lista — vendedor",
    "Listing likes milestone — seller": "Hitos de likes en lista — vendedor",
    "communications.email_card_14": "Cuenta verificada — vendedor",
    "Account verified — seller": "Cuenta verificada — vendedor",
    "communications.email_card_15": "Recuperación de vendedor — vendedor",
    "Seller win-back — seller": "Recuperación de vendedor — vendedor",
    "communications.email_card_16": "Aviso de bajo stock — vendedor",
    "Low stock warning — seller": "Aviso de bajo stock — vendedor",
    "communications.email_card_17": "Vendedor registrado — vendedor",
    "Seller onboarded — seller": "Vendedor registrado — vendedor",
    "communications.email_card_18": "Solicitud de revisión — comprador",
    "Review request — buyer": "Solicitud de revisión — comprador",
    "communications.email_card_19": "Primer venta — vendedor",
    "First sale — seller": "Primer venta — vendedor",
    "communications.email_card_20": "Hitos de ventas — vendedor",
    "Sales milestone — seller": "Hitos de ventas — vendedor",
    "communications.email_card_21": "Recuperación de cliente — comprador",
    "Win-back — buyer": "Recuperación de cliente — comprador",
    "communications.email_card_22": "Primera compra — comprador",
    "First purchase — buyer": "Primera compra — comprador",
    "communications.email_card_23": "Pregunta del cliente — vendedor",
    "Customer question — seller": "Pregunta del cliente — vendedor",
    "communications.email_card_24": "Respuesta del vendedor — comprador",
    "Seller answer — buyer": "Respuesta del vendedor — comprador",
    "communications.email_card_25": "Oferta de negociación — vendedor",
    "Negotiation offer — seller": "Oferta de negociación — vendedor",
    "communications.email_card_26": "Oferta aceptada — comprador",
    "Offer accepted — buyer": "Oferta aceptada — comprador",
    "communications.email_card_27": "Oferta rechazada — comprador",
    "Offer rejected — buyer": "Oferta rechazada — comprador",
    "communications.email_card_28": "Nuevo seguidor — vendedor",
    "New follower — seller": "Nuevo seguidor — vendedor",
    "communications.email_card_29": "Listado favorito — vendedor",
    "Listing liked — seller": "Listado favorito — vendedor",
    "communications.email_card_30": "Listado aprobado — vendedor",
    "Listing approved — seller": "Listado aprobado — vendedor",
    "communications.email_card_31": "Listado rechazado — vendedor",
    "Listing rejected — seller": "Listado rechazado — vendedor",
    "communications.email_card_32": "Primer listado — vendedor",
    "First listing — seller": "Primer listado — vendedor",
    "communications.email_card_33": "Carrito abandonado — comprador",
    "Abandoned cart — buyer": "Carrito abandonado — comprador",
    "communications.email_card_34": "Revisión del listado — vendedor",
    "Listing review — seller": "Revisión del listado — vendedor",
    "communications.email_card_35": "Recordatorio de cumplimiento — vendedor",
    "Fulfillment reminder — seller": "Recordatorio de cumplimiento — vendedor",
    "communications.email_card_36": "Baja de precio — comprador",
    "Price drop — buyer": "Baja de precio — comprador",
    "communications.email_card_37": "Pago de membresía próximo",
    "Membership payment due soon": "Pago de membresía próximo",
    "communications.email_card_38": "Pago de membresía vencido",
    "Membership payment overdue": "Pago de membresía vencido",
    "communications.order_status_notification": "Notificación de estado de pedido",
    "Order Status Notification": "Notificación de estado de pedido",
    "communications.order_group_lifecycle": "Ciclo de vida del pedido",
    "Order lifecycle": "Ciclo de vida del pedido",
    "communications.order_group_returns": "Devoluciones y problemas de entrega",
    "Returns and delivery issues": "Devoluciones y problemas de entrega",
    "communications.order_group_cancellations": "Cancelaciones y recogida",
    "Cancellations and pickup": "Cancelaciones y recogida",
    "communications.notification_settings_count": "{count} configuraciones de notificación",
    "{count} notification settings": "{count} configuraciones de notificación",
    "communications.enter_order_field": "Introducir {field}",
    "Enter {field}": "Introducir {field}",
    "communications.order_field_0": "Estado del pedido confirmado",
    "Order status confirmed": "Estado del pedido confirmado",
    "communications.order_field_1": "Estado del pedido en curso",
    "Order status in progress": "Estado del pedido en curso",
    "communications.order_field_2": "Estado del pedido enviado",
    "Order status shipped": "Estado del pedido enviado",
    "communications.order_field_3": "Estado del pedido cliente no localizable",
    "Order status customer unreachable": "Estado del pedido cliente no localizable",
    "communications.order_field_4": "Estado del pedido en camino de entrega",
    "Order status out for delivery": "Estado del pedido en camino de entrega",
    "communications.order_field_5": "Estado del pedido no entregado devuelto",
    "Order status undelivered returned": "Estado del pedido no entregado devuelto",
    "communications.order_field_6": "Estado del pedido no entregado devuelto confirmado",
    "Order status undelivered return confirmed": "Estado del pedido no entregado devuelto confirmado",
    "communications.order_field_7": "Estado del pedido entregado",
    "Order status delivered": "Estado del pedido entregado",
    "communications.order_field_8": "Estado del pedido entregado confirmado",
    "Order status delivered confirmed": "Estado del pedido entregado confirmado",
    "communications.order_field_9": "Estado del pedido devolución iniciada por cliente",
    "Order status customer return initiated": "Estado del pedido devolución iniciada por cliente",
    "communications.order_field_10": "Estado del pedido devolución recogida por cliente",
    "Order status customer return picked": "Estado del pedido devolución recogida por cliente",
    "communications.order_field_11": "Estado del pedido devolución confirmada por cliente",
    "Order status customer return confirmed": "Estado del pedido devolución confirmada por cliente",
    "communications.order_field_12": "Estado del pedido devolución disputada por cliente",
    "Order status customer return disputed": "Estado del pedido devolución disputada por cliente",
    "communications.order_field_13": "Estado del pedido cancelado por cuenta",
    "Order status cancelled by account": "Estado del pedido cancelado por cuenta",
    "communications.order_field_14": "Estado del pedido cancelado por cliente",
    "Order status cancelled by customer": "Estado del pedido cancelado por cliente",
    "communications.order_field_15": "Estado del pedido listo para recoger",
    "Order status ready for pickup": "Estado del pedido listo para recoger",
    "communications.order_field_16": "Estado del pedido completado",
    "Order status completed": "Estado del pedido completado",
    "communications.update": "Actualizar",
    "communications.download_template": "Descargar plantilla",
    "Download Template": "Descargar plantilla",
    "communications.reset_to_default": "Restablecer a predeterminado",
    "Reset to default": "Restablecer a predeterminado",
    "communications.send_test_email": "Enviar correo de prueba",
    "Send test email": "Enviar correo de prueba",
    "communications.enter_test_emails": "Introduzca correo(s), separado(s) por comas",
    "Enter email(s), comma-separated": "Introduzca correo(s), separado(s) por comas",
    "communications.send_test": "Enviar prueba",
    "Send test": "Enviar prueba",
    "communications.subject_required": "El asunto no debe estar vacío",
    "Subject should not be empty": "El asunto no debe estar vacío",
    "communications.body_required": "El cuerpo no debe estar vacío",
    "Body should not be empty": "El cuerpo no debe estar vacío",
    "communications.code_merge_tag_required": "Se requiere la etiqueta de fusión {code}",
    "{code} merge tag is mandatory": "Se requiere la etiqueta de fusión {code}",
    "communications.edit_template_named": "Editar {name}",
    "Edit {name}": "Editar {name}",
    "communications.subject": "Asunto",
    "Subject": "Asunto",
    "communications.enter_subject": "Introduzca el asunto",
    "Enter the Subject": "Introduzca el asunto",
    "communications.available_merge_tags": "Etiquetas de fusión disponibles:",
    "Available merge tags:": "Etiquetas de fusión disponibles:",
    "communications.body": "Cuerpo",
    "Body": "Cuerpo",
    "communications.write_here": "Escriba aquí...",
    "Write here...": "Escriba aquí...",
    "communications.subject_line": "Línea de asunto",
    "Subject Line": "Línea de asunto",
    "communications.enter_subject_line": "Introduzca el asunto…",
    "Enter the subject…": "Introduzca el asunto…",
    "communications.merge_tags": "Etiquetas de fusión",
    "Merge tags": "Etiquetas de fusión",
    "communications.loading_templates": "Cargando plantillas…",
    "Loading templates…": "Cargando plantillas…",
    "communications.hide_templates": "Ocultar plantillas",
    "Hide templates": "Ocultar plantillas",
    "communications.load_template": "Cargar plantilla",
    "Load template": "Cargar plantilla",
    "communications.html_body": "Cuerpo HTML",
    "HTML Body": "Cuerpo HTML",
    "communications.enter_html_body": "Pegue o escriba su HTML aquí…",
    "Paste or type your HTML here…": "Pegue o escriba su HTML aquí…",
    "communications.live_preview": "Vista previa en vivo",
    "Live Preview": "Vista previa en vivo",
    "communications.desktop": "Escritorio",
    "Desktop": "Escritorio",
    "communications.mobile": "Móvil",
    "communications.email_preview": "Vista previa del correo electrónico",
    "Email preview": "Vista previa del correo electrónico",
    "communications.start_typing_preview": "Escribe para ver una vista previa",
    "Start typing to see a preview": "Escribe para ver una vista previa",
    "communications.translations": "traducciones",
    "translations": "traducciones",
    "communications.validation_account_follow_tag": "La notificación de seguimiento de cuenta debe contener {account_name}",
    "communications.validation_listing_like_tag": "La notificación de seguimiento de listado debe contener {user_name}",
    "Listing follow notification should contain {user_name}": "La notificación de seguimiento de listado debe contener {user_name}",
    "communications.validation_order_number_tag": "La notificación de seguimiento de estado de pedido debe contener #{order_number}",
    "Order status follow notification should contain #{order_number}": "La notificación de seguimiento de estado de pedido debe contener #{order_number}",
    "communications.validation_order_status_tag": "La notificación de seguimiento de estado de pedido debe contener {order_status}",
    "Order status follow notification should contain {order_status}": "La notificación de seguimiento de estado de pedido debe contener {order_status}",
    "communications.journey_title": "Mapa de viaje de correo electrónico",
    "Email Journey Map": "Mapa de viaje de correo electrónico",
    "communications.journey_subtitle": "Dónde se envía cada correo en el ciclo de vida del usuario",
    "Where each email fires in the user lifecycle": "Dónde se envía cada correo en el ciclo de vida del usuario",
    "communications.journey_buyer": "Viaje del comprador",
    "Buyer Journey": "Viaje del comprador",
    "communications.journey_seller": "Viaje del vendedor",
    "Seller Journey": "Viaje del vendedor",
    "communications.journey_buyer_stage_0": "Registro",
    "Sign Up": "Registro",
    "communications.journey_buyer_stage_1": "Explorar",
    "Browse": "Explorar",
    "communications.journey_buyer_stage_2": "Carrito",
    "Cart": "Carrito",
    "communications.journey_buyer_stage_3": "Pedido realizado",
    "Order Placed": "Pedido realizado",
    "communications.journey_buyer_stage_4": "Enviado",
    "communications.journey_buyer_stage_5": "Entregado",
    "communications.journey_buyer_stage_6": "Negociar",
    "Negotiate": "Negociar",
    "communications.journey_buyer_stage_7": "Inactivo",
    "communications.journey_seller_stage_0": "Incorporación",
    "Onboard": "Incorporación",
    "communications.journey_seller_stage_1": "Listar",
    "communications.journey_seller_stage_2": "Administrar",
    "Manage": "Administrar",
    "communications.journey_seller_stage_3": "Pedido entrante",
    "Order In": "Pedido entrante",
    "communications.journey_seller_stage_4": "Enviar",
    "communications.journey_seller_stage_5": "Completado",
    "Complete": "Completado",
    "communications.journey_seller_stage_6": "Inactivo",
    "accounts.title": "Cuentas",
    "accounts.status_pending": "Pendiente",
    "accounts.status_approved": "Aprobado",
    "accounts.status_rejected": "Rechazado",
    "accounts.show_rows": "Mostrar filas",
    "accounts.next": "Siguiente",
    "accounts.previous": "Anterior",
    "accounts.view_list": "Lista",
    "accounts.view_map": "Mapa",
    "Map": "Mapa",
    "accounts.view_board": "Tablero",
    "accounts.view_grid": "Cuadrícula",
    "accounts.view_list_accessibility": "Vista de lista",
    "accounts.view_map_accessibility": "Vista de mapa",
    "Map view": "Vista de mapa",
    "accounts.view_board_accessibility": "Vista de tablero",
    "accounts.view_grid_accessibility": "Vista de cuadrícula",
    "accounts.column_name": "Nombre",
    "accounts.column_account_id": "ID de cuenta",
    "Account ID": "ID de cuenta",
    "accounts.column_description": "Descripción",
    "accounts.column_image": "Imagen",
    "accounts.column_user_name": "Nombre de usuario",
    "User Name": "Nombre de usuario",
    "accounts.column_email": "Correo electrónico",
    "accounts.column_status": "Estado",
    "accounts.column_account_status": "Estado de la cuenta",
    "Account Status": "Estado de la cuenta",
    "accounts.column_location": "Ubicación",
    "accounts.search": "Buscar cuentas",
    "Search accounts": "Buscar cuentas",
    "accounts.export": "Exportar",
    "accounts.import": "Importar",
    "accounts.export_accounts": "Exportar cuentas",
    "Export accounts": "Exportar cuentas",
    "accounts.import_accounts": "Importar cuentas",
    "Import accounts": "Importar cuentas",
    "accounts.smart_upload_accounts": "Carga inteligente de cuentas",
    "Smart Upload accounts": "Carga inteligente de cuentas",
    "accounts.export_all_question": "¿Exportar todas las cuentas?",
    "Export all accounts?": "¿Exportar todas las cuentas?",
    "accounts.export_all_description": "Esto preparará un archivo que contendrá todas las cuentas. Puede revisar este flujo de trabajo antes de actualizar.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Esto preparará un archivo que contendrá todas las cuentas. Puede revisar este flujo de trabajo antes de actualizar.",
    "accounts.export_all": "Exportar todas las cuentas",
    "Export all accounts": "Exportar todas las cuentas",
    "accounts.cancel": "Cancelar",
    "accounts.active": "Activo",
    "accounts.inactive": "Inactivo",
    "accounts.not_available": "N/D",
    "accounts.approve": "Aprobar",
    "accounts.reject": "Rechazar",
    "accounts.manage": "Administrar",
    "accounts.tooltip_title": "Las cuentas son como tiendas.",
    "Accounts are like shops.": "Las cuentas son como tiendas.",
    "accounts.tooltip_description": "Los usuarios pueden crear un espacio en su plataforma para ejecutar un negocio. Estas son cuentas. Un usuario puede no necesitar una cuenta, y las cuentas pueden conectar cuentas de depósito para recibir pagos.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Los usuarios pueden crear un espacio en su plataforma para ejecutar un negocio. Estas son cuentas. Un usuario puede no necesitar una cuenta, y las cuentas pueden conectar cuentas de depósito para recibir pagos.",
    "accounts.create_account": "Crear Cuenta",
    "Create Account": "Crear Cuenta",
    "accounts.create_new_account": "Crear Nueva Cuenta",
    "Create New Account": "Crear Nueva Cuenta",
    "accounts.save": "Guardar",
    "accounts.please_wait": "Espere por favor...",
    "Please wait...": "Espere por favor...",
    "accounts.account_name": "Nombre de cuenta",
    "accounts.slug": "Slug",
    "Slug": "Slug",
    "accounts.account_slug": "Slug de cuenta",
    "Account Slug": "Slug de cuenta",
    "accounts.account_description": "Descripción de la cuenta",
    "Account Description": "Descripción de la cuenta",
    "accounts.enter_name_first": "Por favor, ingrese un título primero",
    "Please enter a title first": "Por favor, ingrese un título primero",
    "accounts.user": "Usuario",
    "accounts.select_user": "Seleccionar usuario",
    "accounts.category": "Categoría",
    "Category": "Categoría",
    "accounts.select_type": "Seleccionar tipo",
    "accounts.smart_upload_title": "Carga inteligente de cuentas",
    "Smart account upload": "Carga inteligente de cuentas",
    "accounts.start_over": "Empezar de nuevo",
    "accounts.smart_upload_description": "Cargue cuentas y asocie las columnas de su CSV con los campos de la cuenta.",
    "Upload accounts and match your CSV columns to account fields.": "Cargue cuentas y asocie las columnas de su CSV con los campos de la cuenta.",
    "accounts.smart_upload_step_0": "Cargar",
    "accounts.smart_upload_step_1": "Asociar columnas",
    "accounts.smart_upload_step_2": "Revisar",
    "accounts.smart_upload_step_3": "Importar",
    "accounts.choose_csv": "Elegir un archivo CSV",
    "accounts.smart_upload_required_note": "El nombre es obligatorio. Dirección, slug, categoría, propietario y coordenadas son opcionales.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "El nombre es obligatorio. Dirección, slug, categoría, propietario y coordenadas son opcionales.",
    "accounts.select_csv": "Seleccionar archivo CSV",
    "accounts.match_columns": "Asociar columnas de cuenta",
    "Match account columns": "Asociar columnas de cuenta",
    "accounts.import_field_name": "Nombre",
    "accounts.import_field_description": "Descripción",
    "accounts.import_field_slug": "Slug",
    "accounts.import_field_category_id": "ID de categoría",
    "accounts.import_field_user_id": "ID de usuario propietario",
    "Owner User ID": "ID de usuario propietario",
    "accounts.import_field_location": "Dirección",
    "accounts.import_field_latitude": "Latitud",
    "Latitude": "Latitud",
    "accounts.import_field_longitude": "Longitud",
    "Longitude": "Longitud",
    "accounts.do_not_import": "No importar",
    "accounts.review_import": "Revisar importación",
    "accounts.import_count": "{count} cuentas se importarán.",
    "{count} accounts will be imported.": "{count} cuentas se importarán.",
    "accounts.smart_upload_complete": "Importación Smart Upload completada",
    "accounts.imported_count": "{imported} de {total} cuentas importadas.",
    "{imported} of {total} accounts imported.": "{imported} de {total} cuentas importadas.",
    "accounts.selected_file": "Seleccionado: {filename}",
    "Selected: {filename}": "Seleccionado: {filename}",
    "accounts.review": "Revisar",
    "accounts.importing": "Importando…",
    "accounts.uploading": "Subiendo...",
    "accounts.download": "Descargar",
    "accounts.file_label": "Archivo:",
    "accounts.select_file": "Seleccionar archivo",
    "accounts.upload": "Subir",
    "accounts.download_template": "Descargar plantilla {type}",
    "Download {type} template": "Descargar plantilla {type}",
    "accounts.import_stage_prepare": "Preparando archivo de importación",
    "Preparing import file": "Preparando archivo de importación",
    "accounts.import_prepare_failed": "No se pudo preparar el archivo de importación.",
    "accounts.import_stage_upload": "Subiendo archivo de importación",
    "accounts.import_upload_failed": "No se pudo subir el archivo de importación.",
    "accounts.import_stage_server": "Tradly está importando cuentas",
    "Tradly is importing accounts": "Tradly está importando cuentas",
    "accounts.import_stage_complete": "Importación completada",
    "accounts.import_stage_stopped": "Importación detenida",
    "accounts.confirm_approve": "¿Aprobar esta cuenta?",
    "Approve this account?": "¿Aprobar esta cuenta?",
    "accounts.confirm_reject": "¿Rechazar esta cuenta?",
    "Reject this account?": "¿Rechazar esta cuenta?",
    "accounts.name_required": "Se requiere nombre",
    "accounts.user_required": "Se requiere usuario",
    "User is required": "Se requiere usuario",
    "accounts.attribute_required": "{attribute} es requerido",
    "accounts.overview": "Resumen de cuenta",
    "Account Overview": "Resumen de cuenta",
    "accounts.section_listings": "Listados",
    "accounts.loading": "Cargando…",
    "accounts.no_listings_owned": "Aún no hay listados",
    "No listings yet": "Aún no hay listados",
    "accounts.page_analytics": "Análisis de página",
    "Page Analytics": "Análisis de página",
    "accounts.analytics_key_missing": "La clave de API de análisis no está configurada para este inquilino.",
    "Analytics API key not configured for this tenant.": "La clave de API de análisis no está configurada para este inquilino.",
    "accounts.storefront_url_missing": "No hay URL de tienda disponible para esta cuenta.",
    "No storefront URL available for this account.": "No hay URL de tienda disponible para esta cuenta.",
    "accounts.no_analytics_loaded": "Aún no se han cargado análisis.",
    "accounts.load_analytics": "Cargar análisis",
    "Load Analytics": "Cargar análisis",
    "accounts.attributes": "Atributos",
    "accounts.shipping": "Envío",
    "accounts.commission": "Comisión",
    "Commission": "Comisión",
    "accounts.detail_title": "Título",
    "accounts.detail_description": "Descripción",
    "accounts.detail_descriptions": "Descripciones",
    "Descriptions": "Descripciones",
    "accounts.detail_listings": "Listados",
    "accounts.detail_categories": "Categorías",
    "accounts.detail_location": "Ubicación",
    "accounts.detail_account_status": "Estado de la cuenta",
    "accounts.detail_status": "Estado",
    "accounts.detail_shipping_method": "Método de envío",
    "accounts.detail_shipping_methods": "Métodos de envío",
    "Shipping Methods": "Métodos de envío",
    "accounts.detail_account_user": "Usuario de la cuenta",
    "Account User": "Usuario de la cuenta",
    "accounts.detail_pending": "Pendiente",
    "accounts.detail_approved": "Aprobado",
    "accounts.detail_rejected": "Rechazado",
    "accounts.detail_active": "Activo",
    "accounts.detail_inactive": "Inactivo",
    "accounts.detail_joined": "Unido",
    "accounts.detail_account_age": "Edad de la cuenta",
    "Account Age": "Edad de la cuenta",
    "accounts.detail_less_than_a_month": "Menos de un mes",
    "Less than a month": "Menos de un mes",
    "accounts.detail_page_views": "Vistas de página",
    "Page Views": "Vistas de página",
    "accounts.detail_unique_visitors": "Visitantes únicos",
    "Unique Visitors": "Visitantes únicos",
    "accounts.detail_sessions": "Sesiones",
    "Sessions": "Sesiones",
    "accounts.detail_clicks": "Clics",
    "Clicks": "Clics",
    "accounts.detail_goals": "Objetivos",
    "Goals": "Objetivos",
    "accounts.detail_bot_views": "Vistas de bot",
    "Bot Views": "Vistas de bot",
    "accounts.detail_followers": "Seguidores",
    "Followers": "Seguidores",
    "accounts.detail_total_orders": "Pedidos totales",
    "accounts.detail_revenue": "Ingresos",
    "accounts.detail_avg_order": "Promedio de pedido",
    "Avg Order": "Promedio de pedido",
    "accounts.detail_paid_orders": "Pedidos pagados",
    "Paid Orders": "Pedidos pagados",
    "accounts.detail_owner": "Propietario",
    "Owner": "Propietario",
    "accounts.detail_account_id": "ID de cuenta",
    "accounts.detail_category": "Categoría",
    "accounts.detail_profile_completeness": "Completitud del perfil",
    "Profile Completeness": "Completitud del perfil",
    "accounts.detail_total_listings": "Listados totales",
    "Total Listings": "Listados totales",
    "accounts.detail_loaded_listings": "Listados cargados",
    "Loaded Listings": "Listados cargados",
    "accounts.detail_active_listings": "Listados activos",
    "Active Listings": "Listados activos",
    "accounts.detail_last_updated": "Última actualización",
    "Last Updated": "Última actualización",
    "accounts.detail_last_activity": "Última actividad",
    "Last Activity": "Última actividad",
    "accounts.detail_verification": "Verificación",
    "Verification": "Verificación",
    "accounts.detail_subscription": "Suscripción",
    "accounts.detail_attributes": "Atributos",
    "accounts.detail_shipping_charge_split": "División de cargos de envío",
    "Shipping Charge Split": "División de cargos de envío",
    "accounts.detail_value_type": "Tipo de valor",
    "Value Type": "Tipo de valor",
    "accounts.detail_value": "Valor",
    "accounts.detail_enter_value": "Introducir valor",
    "accounts.detail_commission_percentage": "Porcentaje de comisión",
    "Commission Percentage": "Porcentaje de comisión",
    "accounts.detail_commission_percent": "Porcentaje de comisión",
    "Commission Percent": "Porcentaje de comisión",
    "accounts.detail_share": "Compartir",
    "accounts.detail_view_account": "Ver cuenta",
    "View Account": "Ver cuenta",
    "accounts.detail_add_listing": "Añadir listado",
    "accounts.detail_edit_account": "Editar cuenta",
    "accounts.no_attribute_values": "No hay valores de atributo para {name}",
    "No attribute values for {name}": "No hay valores de atributo para {name}",
    "accounts.no_attributes_yet": "Aún no hay atributos",
    "No attributes yet": "Aún no hay atributos",
    "accounts.edit_account": "Editar Cuenta",
    "accounts.detail_preview": "Vista previa",
    "accounts.detail_fixed": "Fijo",
    "Fixed": "Fijo",
    "accounts.detail_percentage": "Porcentaje",
    "Percentage": "Porcentaje",
    "accounts.detail_select_value_type": "Seleccionar tipo de valor",
    "Select Value Type": "Seleccionar tipo de valor",
    "accounts.detail_approve": "Aprobar",
    "accounts.detail_reject": "Rechazar",
    "accounts.detail_section": "Detalles",
    "Details": "Detalles",
    "category.add_child": "Agregar Categoría Hija",
    "Add Child Category": "Agregar Categoría Hija",
    "category.add_listing": "Agregar Listado",
    "category.manage": "Administrar Categorías",
    "Manage Categories": "Administrar Categorías",
    "category.account_overview_eyebrow": "RESUMEN DE CATEGORÍA DE CUENTA",
    "ACCOUNT CATEGORY OVERVIEW": "RESUMEN DE CATEGORÍA DE CUENTA",
    "category.overview_eyebrow": "RESUMEN DE CATEGORÍA",
    "CATEGORY OVERVIEW": "RESUMEN DE CATEGORÍA",
    "category.category": "Categoría",
    "category.active": "Activo",
    "category.inactive": "Inactivo",
    "category.accounts": "Cuentas",
    "category.listings": "Listados",
    "category.child_categories": "Categorías Hijas",
    "Child Categories": "Categorías Hijas",
    "category.attributes": "Atributos",
    "category.category_age": "Edad de la Categoría",
    "Category age": "Edad de la Categoría",
    "category.category_overview": "Resumen de Categoría",
    "Category Overview": "Resumen de Categoría",
    "category.category_id": "ID de Categoría",
    "category.name": "Nombre",
    "category.slug": "Slug",
    "category.description": "Descripción",
    "category.parent_category": "Categoría padre",
    "Parent Category": "Categoría padre",
    "category.hierarchy": "Jerarquía",
    "Hierarchy": "Jerarquía",
    "category.status": "Estado",
    "category.display_order": "Orden de visualización",
    "Display Order": "Orden de visualización",
    "category.created": "Unido / Creado",
    "Joined / Created": "Unido / Creado",
    "category.configured": "Configurado",
    "Configured": "Configurado",
    "category.no_attributes": "No hay atributos asignados.",
    "No attributes assigned.": "No hay atributos asignados.",
    "category.no_child_categories": "No hay categorías secundarias.",
    "No child categories.": "No hay categorías secundarias.",
    "category.no_accounts": "No hay cuentas en esta categoría.",
    "No accounts in this category.": "No hay cuentas en esta categoría.",
    "category.no_listings": "No hay anuncios en esta categoría.",
    "No listings in this category.": "No hay anuncios en esta categoría.",
    "category.detail_title": "Detalle de categoría",
    "Category Detail": "Detalle de categoría",
    "category.age_less_month": "Menos de un mes",
    "category.age_month": "{count} mes",
    "{count} month": "{count} mes",
    "category.age_months": "{count} meses",
    "{count} months": "{count} meses",
    "category.age_year": "{count} año",
    "{count} year": "{count} año",
    "category.age_years": "{count} años",
    "{count} years": "{count} años",
    "category.header_name": "Nombre",
    "category.header_category_id": "ID de categoría",
    "category.header_image": "Imagen",
    "category.header_order": "Orden",
    "category.header_parent": "Padre",
    "Parent": "Padre",
    "category.header_active": "Activo",
    "category.header_action": "Acción",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Categorías",
    "category.translate": "Traducir",
    "category.import": "Importar",
    "category.export": "Exportar",
    "category.add_category": "Agregar categoría",
    "Add Category": "Agregar categoría",
    "category.import_categories": "Importar categorías",
    "Import Categories": "Importar categorías",
    "category.delete_warning": "Los listados existentes no se abrirán en el sitio web o aplicación, verás un error.",
    "Existing listings will not open in website or app, you will see an error.": "Los listados existentes no se abrirán en el sitio web o aplicación, verás un error.",
    "category.editor_edit_category": "Editar categoría",
    "Edit Category": "Editar categoría",
    "category.editor_add_category": "Agregar categoría",
    "category.editor_save": "Guardar",
    "category.editor_select_category_level": "Seleccionar nivel de categoría",
    "Select Category Level": "Seleccionar nivel de categoría",
    "category.editor_parent_category": "Categoría padre",
    "category.editor_select": "Seleccionar",
    "category.editor_category_name": "Nombre de categoría",
    "Category Name": "Nombre de categoría",
    "category.editor_enter_category_name": "Introduce el nombre de la categoría",
    "Enter category name": "Introduce el nombre de la categoría",
    "category.editor_slug": "Slug",
    "category.editor_enter_slug": "Introduce el slug",
    "category.editor_category_description": "Descripción de categoría",
    "Category Description": "Descripción de categoría",
    "category.editor_order": "Orden",
    "category.editor_enter_order": "Introduce el orden",
    "category.editor_status_not_active_active": "Estado (No activo / Activo)",
    "Status (Not Active / Active)": "Estado (No activo / Activo)",
    "category.editor_upload_media": "Subir medios",
    "category.editor_meta_title": "Título meta",
    "category.editor_enter_meta_title": "Introduzca título meta",
    "category.editor_meta_description": "Descripción meta",
    "category.editor_category": "Categoría",
    "category.editor_name": "Nombre",
    "category.editor_status": "Estado",
    "category.editor_action": "Acción",
    "category.editor_add_attribute": "Añadir atributo",
    "category.editor_attributes_list": "Lista de atributos",
    "Attributes List": "Lista de atributos",
    "category.editor_please_enter_a_category_name_first": "Por favor, introduzca primero el nombre de la categoría",
    "Please enter a category name first": "Por favor, introduzca primero el nombre de la categoría",
    "category.editor_successfully_added_category": "Categoría añadida con éxito",
    "Successfully added category": "Categoría añadida con éxito",
    "category.deleted": "Categoría eliminada",
    "Category deleted": "Categoría eliminada",
    "attributes.title": "Atributos",
    "attributes.cart_checkout": "Carrito y finalizar compra",
    "Cart & Checkout": "Carrito y finalizar compra",
    "attributes.cart_settings": "Configuración del carrito",
    "Cart settings": "Configuración del carrito",
    "attributes.order_status_notifications": "Notificaciones de estado de pedido",
    "Order status notifications": "Notificaciones de estado de pedido",
    "attributes.groups": "Grupos de atributos",
    "attributes.add_attribute": "Añadir atributo",
    "attributes.edit_bulk": "Editar por lotes",
    "Edit Bulk": "Editar por lotes",
    "attributes.confirm_delete": "¿Quieres eliminar este atributo?",
    "attributes.header_attribute_name": "Nombre del atributo",
    "Attribute Name": "Nombre del atributo",
    "attributes.header_action": "Acción",
    "attributes.header_manage_attribute_values": "Administrar valores de atributo",
    "Manage Attribute Values": "Administrar valores de atributo",
    "attributes.header_type": "Tipo",
    "attributes.header_optional": "Opcional",
    "attributes.header_icon": "Icono",
    "Icon": "Icono",
    "attributes.header_categories": "Categorías",
    "attributes.header_hidden_field": "Campo oculto",
    "Hidden Field": "Campo oculto",
    "attributes.header_values": "Valores",
    "Values": "Valores",
    "attributes.header_status": "Estado",
    "attributes.type_single_select": "Selección única",
    "Single Select": "Selección única",
    "attributes.type_multi_select": "Selección múltiple",
    "Multi Select": "Selección múltiple",
    "attributes.type_open_single_value": "Abierto (Valor único)",
    "Open (Single Value)": "Abierto (Valor único)",
    "attributes.type_open_multiple_value": "Abierto (Valores múltiples)",
    "Open (Multiple Value)": "Abierto (Valores múltiples)",
    "attributes.type_attachment": "Adjunto",
    "Attachment": "Adjunto",
    "attributes.type_text_area": "Área de texto",
    "Text Area": "Área de texto",
    "attributes.type_date_time": "Fecha y hora",
    "Date Time": "Fecha y hora",
    "attributes.type_number": "Número",
    "attributes.type_boolean": "Booleano",
    "Boolean": "Booleano",
    "attributes.type_color": "Color",
    "Color": "Color",
    "attributes.type_json": "Json",
    "Json": "Json",
    "attributes.type_location": "Ubicación",
    "attributes.type_audio": "Audio",
    "Audio": "Audio",
    "attributes.type_video": "Vídeo",
    "Video": "Vídeo",
    "attributes.type_open_multi_value": "Abierto (Valores múltiples)",
    "Open (Multi Value)": "Abierto (Valores múltiples)",
    "attributes.editor_edit_attribute": "Editar atributo",
    "Edit Attribute": "Editar atributo",
    "attributes.editor_add_attribute": "Agregar atributo",
    "attributes.editor_attribute_name": "Nombre del atributo",
    "attributes.editor_select_type": "Seleccionar tipo",
    "attributes.prefill_user": "Usuario",
    "common.search_placeholder": "Escriba para buscar...",
    "attributes.prefill_accounts": "Cuentas",
    "attributes.prefill_listings": "Listados",
    "listings.detail_nav_gallery": "Galería",
    "Gallery": "Galería",
    "listings.detail_nav_details": "Detalles",
    "listings.detail_nav_inventory": "Inventario",
    "listings.detail_nav_social": "Social",
    "Social": "Social",
    "listings.detail_nav_orders": "Pedidos",
    "listings.detail_nav_analytics": "Analíticas",
    "listings.detail_nav_schedule": "Programación",
    "listings.detail_nav_rental": "Alquiler",
    "Rental": "Alquiler",
    "listings.detail_nav_attributes": "Atributos",
    "listings.detail_nav_seller": "Vendedor",
    "attributes.editor_icon": "Icono",
    "attributes.editor_tool_tip": "Tooltip",
    "Tool tip": "Tooltip",
    "attributes.editor_enter_attribute_name": "Ingrese nombre del atributo",
    "attributes.editor_enter_attribute_tool_tip": "Ingrese descripción de la herramienta",
    "Enter attribute tool tip": "Ingrese descripción de la herramienta",
    "attributes.editor_optional": "Opcional",
    "attributes.editor_private": "Privado",
    "Private": "Privado",
    "attributes.editor_hidden_field": "Campo oculto",
    "Hidden field": "Campo oculto",
    "attributes.editor_show_in_filter": "Mostrar en filtro",
    "Show in filter": "Mostrar en filtro",
    "attributes.editor_status_not_active_active": "Estado (No activo / Activo)",
    "attributes.editor_add_meta_data": "Agregar metadatos",
    "Add meta data": "Agregar metadatos",
    "attributes.editor_select": "Seleccionar",
    "attributes.editor_select_category": "Seleccionar categoría",
    "Select category": "Seleccionar categoría",
    "attributes.editor_select_all": "Seleccionar todo",
    "Select All": "Seleccionar todo",
    "attributes.editor_unselect_all": "Deseleccionar todo",
    "UnSelect All": "Deseleccionar todo",
    "attributes.editor_create_categories_in_this_configuration_first": "Crea categorías en esta configuración primero",
    "Create categories in this configuration first": "Crea categorías en esta configuración primero",
    "attributes.editor_please_enter_attribute_name": "Por favor, ingrese el nombre del atributo",
    "Please enter attribute name": "Por favor, ingrese el nombre del atributo",
    "attributes.editor_please_select_type": "Por favor seleccione el tipo",
    "Please select type": "Por favor seleccione el tipo",
    "attributes.editor_select_single_attribute_values": "Seleccionar valores de atributo único",
    "Select Single Attribute Values": "Seleccionar valores de atributo único",
    "attributes.editor_select_multiple_attribute_values": "Seleccionar valores de atributo múltiple",
    "Select Multiple Attribute Values": "Seleccionar valores de atributo múltiple",
    "attributes.editor_enter_value": "Ingresar valor",
    "attributes.editor_enter_multiple_tag": "Ingresar múltiples etiquetas",
    "Enter Multiple Tag": "Ingresar múltiples etiquetas",
    "attributes.editor_upload_file": "Subir archivo",
    "Upload file": "Subir archivo",
    "attributes.editor_enter_text": "Ingresar texto",
    "attributes.editor_select_date": "Seleccionar fecha",
    "attributes.editor_enter_number": "Ingresar número",
    "Enter Number": "Ingresar número",
    "attributes.editor_select_color": "Seleccionar color",
    "Select Color": "Seleccionar color",
    "attributes.editor_upload_json": "Subir Json",
    "Upload Json": "Subir Json",
    "attributes.editor_select_location": "Seleccionar ubicación",
    "Select Location": "Seleccionar ubicación",
    "attributes.editor_category": "Categoría",
    "attributes.editor_price": "Precio",
    "attributes.editor_enter_price": "Ingresar precio",
    "Enter Price": "Ingresar precio",
    "attributes.editor_preview": "Vista previa",
    "attributes.editor_title": "Título",
    "attributes.editor_enter_title": "Introducir título",
    "attributes.editor_description": "Descripción",
    "attributes.editor_add_listing": "Agregar Listado",
    "attributes.editor_add_account": "Agregar Cuenta",
    "attributes.editor_successfully_added_attributes": "Atributos agregados con éxito",
    "Successfully added attributes": "Atributos agregados con éxito",
    "attributes.editor_add_attribute_values": "Agregar Valores de Atributo",
    "common.image": "Imagen",
    "common.please_wait": "Espere por favor...",
    "attribute_groups.title": "Grupos de Atributos",
    "attribute_groups.title_singular": "Grupo de Atributos",
    "Attribute Group": "Grupo de Atributos",
    "attribute_groups.add": "Agregar Grupo de Atributos",
    "Add Attribute Group": "Agregar Grupo de Atributos",
    "attribute_groups.image_path": "Ruta de la Imagen",
    "Image Path": "Ruta de la Imagen",
    "attribute_groups.name_placeholder": "Nombre del Grupo",
    "Group Name": "Nombre del Grupo",
    "attribute_groups.select_attributes": "Seleccionar Atributos",
    "Select Attributes": "Seleccionar Atributos",
    "attribute_groups.select_attributes_placeholder": "Seleccionar Atributos...",
    "Select Attributes...": "Seleccionar Atributos...",
    "attribute_groups.added_successfully": "Grupo de Atributos agregado con éxito",
    "Attribute Group Added Successfully": "Grupo de Atributos agregado con éxito",
    "attribute_groups.deleted_successfully": "Eliminado con éxito",
    "Deleted successfully": "Eliminado con éxito",
    "attribute_groups.name_required": "El nombre es obligatorio",
    "attribute_groups.save_attributes_failed": "El grupo se guardó, pero no se pudieron asignar sus atributos.",
    "The group was saved, but its attributes could not be assigned.": "El grupo se guardó, pero no se pudieron asignar sus atributos.",
    "attributes.editor_enter_description": "Introducir Descripción",
    "account_config.title": "Configuración de Cuenta",
    "account_config.account_detail_note": "Nota de detalle de cuenta",
    "Account detail note": "Nota de detalle de cuenta",
    "account_config.enter_account_detail_note": "Introducir nota de detalle de cuenta",
    "Enter account detail note": "Introducir nota de detalle de cuenta",
    "account_config.address_label": "Etiqueta de dirección",
    "Address label": "Etiqueta de dirección",
    "account_config.enter_address_label": "Etiqueta de dirección",
    "Enter address label": "Etiqueta de dirección",
    "account_config.category_label": "Etiqueta de categoría",
    "Category label": "Etiqueta de categoría",
    "account_config.enter_category_label": "Introducir etiqueta de categoría",
    "Enter category label": "Introducir etiqueta de categoría",
    "account_config.nearby_accounts_radius_km": "Radio de cuentas cercanas (km)",
    "Nearby accounts radius (km)": "Radio de cuentas cercanas (km)",
    "account_config.nearby_accounts_radius_placeholder": "Radio de cuenta cercana en km",
    "Account nearby radius in km": "Radio de cuenta cercana en km",
    "account_config.account_limit": "Límite de cuentas",
    "Account Limit": "Límite de cuentas",
    "account_config.account_limit_placeholder": "Límite de cuentas",
    "Account limit": "Límite de cuentas",
    "account_config.shipping_preference_note": "Nota sobre preferencia de método de envío",
    "Shipping method preference note": "Nota sobre preferencia de método de envío",
    "account_config.option_accounts_auto_approved": "Cuentas aprobadas automáticamente",
    "Accounts auto approved": "Cuentas aprobadas automáticamente",
    "account_config.option_shipping_methods_preference_for_accounts": "Preferencia de métodos de envío para cuentas",
    "Shipping methods preference for accounts": "Preferencia de métodos de envío para cuentas",
    "account_config.option_account_map_location_selector": "Selector de ubicación en mapa para cuentas",
    "Account map location selector": "Selector de ubicación en mapa para cuentas",
    "account_config.option_account_geo_location": "Ubicación geográfica de la cuenta",
    "Account Geo Location": "Ubicación geográfica de la cuenta",
    "account_config.option_slug": "Slug",
    "account_config.option_show_description": "Mostrar descripción",
    "Show Description": "Mostrar descripción",
    "account_config.option_formatted_text_description": "Descripción en texto formateado",
    "Formatted Text Description": "Descripción en texto formateado",
    "account_config.option_hide_address_from_account_detail": "Ocultar dirección en detalle de cuenta",
    "Hide Address from Account Detail": "Ocultar dirección en detalle de cuenta",
    "account_config.option_get_account_pickup_address_always": "Obtener dirección de recogida de cuenta siempre",
    "Get Account Pickup Address Always": "Obtener dirección de recogida de cuenta siempre",
    "account_config.option_get_pickup_address_for_delivery": "Obtener dirección de recogida para entrega",
    "Get Pickup Address for Delivery": "Obtener dirección de recogida para entrega",
    "account_config.uploaded_successfully": "Subido con éxito",
    "app_customization.realtime_config_notice": "Estas configuraciones se aplican en tiempo real. Al hacer cambios aquí y hacer clic en Guardar, se reflejarán en las aplicaciones y respuestas de la API.",
    "app_customization.release_config_notice": "Nota para Canales de Aplicación Móvil: Estas configuraciones solo se aplican en el momento de la liberación del producto y actualizaciones. Nunca se actualizarán en tiempo real. Al hacer cambios aquí y necesitar una compilación actualizada, solicite una compilación desde el Portal de Soporte. (Aplicable al plan Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Nota para Canales de Aplicación Móvil: Estas configuraciones solo se aplican en el momento de la liberación del producto y actualizaciones. Nunca se actualizarán en tiempo real. Al hacer cambios aquí y necesitar una compilación actualizada, solicite una compilación desde el Portal de Soporte. (Aplicable al plan Starter)",
    "category.translation_title": "Traducir categoría",
    "Translate Category": "Traducir categoría",
    "category.translation_category_name": "Nombre de categoría",
    "category.translation_description": "Descripción",
    "listing_configs.title": "Configuración de lista",
    "Listing Configuration": "Configuración de lista",
    "listing_configs.rules": "REGLAS (Nivel de proyectos/Inquilino)",
    "RULES (Projects/Tenant level)": "REGLAS (Nivel de proyectos/Inquilino)",
    "listing_configs.features": "CARACTERÍSTICAS (Solo para aplicación móvil)",
    "FEATURES (Only for mobile app)": "CARACTERÍSTICAS (Solo para aplicación móvil)",
    "listing_configs.ui_customisation": "Personalización de la interfaz",
    "UI Customisation": "Personalización de la interfaz",
    "listing_configs.overridden_max_quantity": "Cantidad máxima por lista",
    "listing_configs.overridden_max_quantity_example": "(Ejemplo: 100)",
    "(Example: 100)": "(Ejemplo: 100)",
    "listing_configs.listing_min_price": "Precio mínimo de lista",
    "listing_configs.listing_min_price_example": "(Ejemplo: $5)",
    "(Example: $5)": "(Ejemplo: $5)",
    "listing_configs.auto_approval": "¿Aprobar listas automáticamente?",
    "listing_configs.listing_pictures_count": "Número de imágenes cargables",
    "listing_configs.seller_can_place_order": "El vendedor puede realizar pedidos",
    "Seller can place order": "El vendedor puede realizar pedidos",
    "listing_configs.hide_offer_percent": "Porcentaje de oferta",
    "listing_configs.show_max_quantity": "Restricciones de cantidad máxima en nivel de lista",
    "listing_configs.show_shipping_charges": "Gastos de envío",
    "listing_configs.listing_address_label": "Etiqueta de dirección",
    "listing_configs.listing_address_label_example": "(Ejemplo: Punto de referencia)",
    "(Example: Landmark)": "(Ejemplo: Punto de referencia)",
    "listing_configs.listing_map_location_selector_enabled": "Usar marcador de mapa en lugar de buscar dirección",
    "Use map marker instead of searching address": "Usar marcador de mapa en lugar de buscar dirección",
    "listing_configs.listing_hide_tags": "Etiquetas",
    "Tags": "Etiquetas",
    "listing_configs.enable_stock": "Existencias",
    "Stocks": "Existencias",
    "listing_configs.listing_address_enabled": "Dirección geográfica",
    "Geo address": "Dirección geográfica",
    "listing_configs.show_stock_out_listings": "Mostrar listas sin stock en el feed",
    "listing_configs.enable_slug": "Slug del título de lista",
    "listing_configs.show_variants": "Variantes",
    "Variants": "Variantes",
    "listing_configs.meta_title": "Título meta",
    "listing_configs.meta_description": "Descripción meta",
    "listing_configs.listing_enable_formatted_text_description": "Habilitar Composer",
    "Enable Composer": "Habilitar Composer",
    "listing_configs.listing_enable_weight": "Habilitar Peso",
    "listing_configs.listing_enable_dimensions": "Habilitar Dimensiones",
    "listing_configs.enable_stocks_listing_schedules": "Horarios de Stock",
    "Stock Schedules": "Horarios de Stock",
    "listing_variants.title": "Tipos de Variante",
    "listing_variants.add_type": "Agregar Tipo de Variante",
    "Add Variant Type": "Agregar Tipo de Variante",
    "listing_variants.edit_type": "Editar Tipo de Variante",
    "Edit Variant Type": "Editar Tipo de Variante",
    "listing_variants.name": "Nombre",
    "listing_variants.values": "Valores",
    "listing_variants.status": "Estado",
    "listing_variants.action": "Acción",
    "listing_variants.add_value": "Agregar Valor",
    "Add Value": "Agregar Valor",
    "listing_variants.active": "Activo",
    "listing_variants.inactive": "Inactivo",
    "listing_variants.details": "Detalles",
    "listing_variants.translate": "Traducir",
    "listing_variants.delete_confirm": "¿Quieres eliminar este tipo de variante?",
    "Do you want to delete this variant type?": "¿Quieres eliminar este tipo de variante?",
    "listing_variants.add_value_first": "Agrega un valor antes de ver variantes.",
    "Add a value before viewing variants.": "Agrega un valor antes de ver variantes.",
    "listing_variants.enter_name": "Ingresa nombre",
    "listing_variants.status_hint": "Estado (Inactivo / Activo)",
    "Status (Inactive / Active)": "Estado (Inactivo / Activo)",
    "listing_variants.total_values": "Valores Totales",
    "Total Values": "Valores Totales",
    "listing_variants.type_id": "ID de Tipo",
    "Type ID": "ID de Tipo",
    "listing_variants.total_count": "{count} en total",
    "{count} total": "{count} en total",
    "listing_variants.loading": "Cargando…",
    "listing_variants.loading_values": "Cargando valores…",
    "Loading values…": "Cargando valores…",
    "listing_variants.no_values": "Aún no hay valores",
    "No values yet": "Aún no hay valores",
    "listing_variants.add_first_value": "Añadir primer valor",
    "Add First Value": "Añadir primer valor",
    "listing_variants.actions": "Acciones",
    "listing_variants.edit": "Editar",
    "listing_variants.delete": "Eliminar",
    "listing_variants.edit_value": "Editar valor",
    "Edit Value": "Editar valor",
    "listing_variants.value_name_required": "Nombre del valor *",
    "Value Name *": "Nombre del valor *",
    "listing_variants.value_examples": "p. ej. Rojo, XL, Algodón…",
    "e.g. Red, XL, Cotton…": "p. ej. Rojo, XL, Algodón…",
    "listing_variants.saving": "Guardando…",
    "listing_variants.save_changes": "Guardar cambios",
    "Save Changes": "Guardar cambios",
    "listing_variants.delete_value_confirm": "¿Quieres eliminar este valor de variante?",
    "Do you want to delete this variant value?": "¿Quieres eliminar este valor de variante?",
    "listing_variants.clear_all": "Borrar todo",
    "listing_variants.multiple_values_help": "Puedes añadir valores separados por comas o pegar una columna de Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Puedes añadir valores separados por comas o pegar una columna de Excel.",
    "listing_variants.save": "Guardar",
    "listing_variants.close": "Cerrar",
    "listing_variants.update": "Actualizar",
    "listing_variants.default_text": "Texto predeterminado",
    "listing_variants.enter_value": "Introduce el valor de la variante",
    "Enter variant value": "Introduce el valor de la variante",
    "listing_variants.add_values": "Añadir valores",
    "listing_variants.add_variant_values": "Añadir valores de tipo de variante",
    "Add Variant Type Values": "Añadir valores de tipo de variante",
    "listing_variants.values_list": "Lista de valores de tipo de variante",
    "Variant Type Values List": "Lista de valores de tipo de variante",
    "listing_variants.cancel_editing": "Cancelar edición",
    "Cancel Editing": "Cancelar edición",
    "listing_variants.value_name": "Valor del tipo de variante",
    "Variant Type Value": "Valor del tipo de variante",
    "common.default_text": "Texto predeterminado",
    "common.translation_heading": "{title} Traducciones",
    "{title} Translations": "{title} Traducciones",
    "attributes.value_delete_confirm": "¿Quieres eliminar este valor de atributo?",
    "Do you want to delete this attribute value?": "¿Quieres eliminar este valor de atributo?",
    "attributes.value_clear_all": "Borrar todo",
    "attributes.value_multiple_help": "Agrega valores separados por comas o pega una columna de Excel.",
    "Add comma-separated values or paste a column from Excel.": "Agrega valores separados por comas o pega una columna de Excel.",
    "attributes.value_active": "Activo",
    "attributes.value_inactive": "Inactivo",
    "attributes.value_save": "Guardar",
    "attributes.value_close": "Cerrar",
    "attributes.value_translate": "Traducir",
    "attributes.value_update": "Actualizar",
    "attributes.value_sort_alpha": "Ordenar alfabéticamente",
    "Sort Alphabetically": "Ordenar alfabéticamente",
    "attributes.value_default_text": "Texto predeterminado",
    "attributes.value_add_metadata": "Agregar Metadatos",
    "Add Metadata": "Agregar Metadatos",
    "attributes.value_cancel_edit": "Cancelar edición",
    "attributes.value_success_help": "¡Genial! Ahora puedes encontrar este atributo personalizado en la página Agregar Listado.",
    "Great! You can now find this custom attribute on the Add Listing page.": "¡Genial! Ahora puedes encontrar este atributo personalizado en la página Agregar Listado.",
    "attributes.value_add": "Agregar Valores de Atributo",
    "attributes.value_add_listing": "Agregar Valores de Atributo de Listado",
    "Add Listing Attribute Values": "Agregar Valores de Atributo de Listado",
    "attributes.value_metadata_for": "Metadatos para",
    "Metadata for": "Metadatos para",
    "attributes.value_enter": "Introducir valor de atributo",
    "Enter attribute value": "Introducir valor de atributo",
    "attributes.value_add_values": "Agregar Valores",
    "attributes.value_status_hint": "Estado (Inactivo / Activo)",
    "attributes.value_list": "Lista de Valores de Atributo",
    "Attribute Values List": "Lista de Valores de Atributo",
    "attributes.value_table_name": "Valor de atributo",
    "Attribute Value": "Valor de atributo",
    "attributes.value_table_status": "Estado",
    "attributes.value_table_action": "Acción",
    "attributes.metadata_key": "Clave",
    "Key": "Clave",
    "attributes.metadata_value": "Valor",
    "attributes.metadata_add_row": "Agregar fila",
    "workspace.countries": "Países",
    "workspace.country_add": "Agregar país",
    "Add Country": "Agregar país",
    "workspace.country_edit": "Editar país",
    "Edit Country": "Editar país",
    "workspace.country_name": "Nombre del país",
    "Country Name": "Nombre del país",
    "workspace.select_country": "Seleccionar país",
    "Select country": "Seleccionar país",
    "workspace.country_order": "Orden",
    "workspace.country_order_placeholder": "Ingrese el orden",
    "workspace.country_status": "Estado (Inactivo / Activo)",
    "workspace.country_default": "Predeterminado",
    "workspace.country_active": "Activo",
    "workspace.country_inactive": "Inactivo",
    "workspace.country_delete_confirm": "¿Quieres eliminar este país?",
    "Do you want to delete this country?": "¿Quieres eliminar este país?",
    "workspace.country_table_name": "Nombre",
    "workspace.country_table_default": "Predeterminado",
    "workspace.country_table_order": "Orden",
    "workspace.country_table_status": "Estado",
    "workspace.country_table_action": "Acción",
    "workspace.languages": "Idiomas",
    "workspace.language_add": "Agregar idioma",
    "Add Language": "Agregar idioma",
    "workspace.language_edit": "Editar idioma",
    "Edit Language": "Editar idioma",
    "workspace.language_name": "Idioma",
    "workspace.language_select": "Seleccionar idioma",
    "Select Language": "Seleccionar idioma",
    "workspace.language_order": "Orden",
    "workspace.language_order_placeholder": "Introducir orden",
    "workspace.language_status": "Estado",
    "workspace.language_default": "Predeterminado",
    "workspace.language_default_warning": "Cambiar el idioma predeterminado cambia la configuración del idioma de la aplicación.",
    "Changing the default language changes the app language setting.": "Cambiar el idioma predeterminado cambia la configuración del idioma de la aplicación.",
    "workspace.language_active": "Activo",
    "workspace.language_inactive": "Inactivo",
    "workspace.language_delete_confirm": "¿Quieres eliminar este idioma?",
    "Do you want to delete this language?": "¿Quieres eliminar este idioma?",
    "workspace.language_table_name": "Nombre",
    "workspace.language_table_default": "Predeterminado",
    "workspace.language_table_order": "Orden",
    "workspace.language_table_status": "Estado",
    "workspace.language_table_action": "Acción",
    "workspace.language_add_photo": "Agregar foto",
    "workspace.currency": "Moneda",
    "workspace.currency_add": "Agregar moneda",
    "Add Currency": "Agregar moneda",
    "workspace.currency_edit": "Editar moneda",
    "Edit Currency": "Editar moneda",
    "workspace.currency_delete_confirm": "¿Quieres eliminar esta moneda?",
    "Do you want to delete this currency?": "¿Quieres eliminar esta moneda?",
    "workspace.currency_show": "Mostrar",
    "workspace.currency_entries": "entradas",
    "entries": "entradas",
    "workspace.currency_search": "Buscar:",
    "Search:": "Buscar:",
    "workspace.currency_search_placeholder": "Buscar divisas",
    "Search currencies": "Buscar divisas",
    "workspace.currency_empty": "No se encontraron divisas.",
    "No currencies found.": "No se encontraron divisas.",
    "workspace.currency_active": "Activo",
    "workspace.currency_inactive": "Inactivo",
    "workspace.currency_name": "Nombre",
    "workspace.currency_name_placeholder": "Nombre de la divisa",
    "Currency Name": "Nombre de la divisa",
    "workspace.currency_upload_media": "Subir medios",
    "workspace.currency_select_media": "Seleccionar de medios",
    "workspace.currency_no_media": "No tienes archivos de medios.",
    "workspace.currency_code": "Código",
    "workspace.currency_select_code": "Seleccionar",
    "workspace.currency_exchange_rate": "Tipo de cambio",
    "Exchange Rate": "Tipo de cambio",
    "workspace.currency_precision": "Precisión",
    "Precision": "Precisión",
    "workspace.currency_thousand_separator": "Separador de miles",
    "Thousand Separator": "Separador de miles",
    "workspace.currency_decimal_point": "Punto decimal",
    "Decimal Point": "Punto decimal",
    "workspace.currency_status_hint": "Estado (Inactivo / Activo)",
    "workspace.currency_default": "Predeterminado",
    "workspace.currency_format": "Formato",
    "Format": "Formato",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Nombre",
    "workspace.currency_table_code": "Código",
    "workspace.currency_table_format": "Formato",
    "workspace.currency_table_exchange": "Cambio",
    "Exchange": "Cambio",
    "workspace.currency_table_status": "Estado",
    "workspace.currency_table_default": "Predeterminado",
    "workspace.currency_table_action": "Acción",
    "commissions.title": "Comisiones",
    "commissions.add": "Agregar comisión",
    "Add Commission": "Agregar comisión",
    "commissions.edit": "Editar comisión",
    "Edit Commission": "Editar comisión",
    "commissions.delete_confirm": "¿Quieres eliminar esta comisión?",
    "Do you want to delete this commission?": "¿Quieres eliminar esta comisión?",
    "commissions.yes": "Sí",
    "commissions.no": "No",
    "commissions.filter_all": "Todos",
    "commissions.filter_supply": "Suministro",
    "Supply": "Suministro",
    "commissions.filter_demand": "Demanda",
    "Demand": "Demanda",
    "commissions.filter_cart": "Carrito",
    "commissions.table_title": "Título",
    "commissions.table_default_value": "Valor predeterminado",
    "Default Value": "Valor predeterminado",
    "commissions.table_status": "Estado",
    "commissions.table_action": "Acción",
    "commissions.active": "Activo",
    "commissions.inactive": "Inactivo",
    "commissions.type": "Tipo",
    "commissions.type_supply": "Suministro",
    "commissions.type_demand": "Demanda",
    "commissions.type_cart": "Carrito",
    "commissions.select_category": "Seleccionar categoría",
    "Select Category": "Seleccionar categoría",
    "commissions.title_label": "Título",
    "commissions.enter_title": "Introduzca título",
    "commissions.description": "Descripción",
    "commissions.enter_description": "Introduzca descripción",
    "commissions.default_value_percent": "Valor predeterminado (%)",
    "Default value (%)": "Valor predeterminado (%)",
    "commissions.short_code": "Código corto",
    "Short Code": "Código corto",
    "commissions.short_code_tooltip_title": "Código corto",
    "Short code": "Código corto",
    "commissions.short_code_tooltip_description": "Introduzca un código corto para esta comisión.",
    "Enter a short code for this commission.": "Introduzca un código corto para esta comisión.",
    "commissions.enter_short_code": "Introduzca código corto",
    "commissions.status_hint": "Estado (Inactivo / Activo)",
    "commissions.optional": "Opcional",
    "commissions.advanced": "Avanzado",
    "Advanced": "Avanzado",
    "commissions.add_by_category": "Agregar comisión por categoría",
    "Add commission by category": "Agregar comisión por categoría",
    "commissions.select_calculation_type": "Seleccionar tipo",
    "commissions.calc_fixed": "Fijo",
    "commissions.calc_slab": "Placa",
    "Slab": "Placa",
    "commissions.value": "Valor",
    "commissions.choose_category": "Elegir categoría",
    "Choose category": "Elegir categoría",
    "commissions.create_categories_first": "Cree categorías primero en la Configuración de Listado",
    "Create categories in Listing Configuration first": "Cree categorías primero en la Configuración de Listado",
    "commissions.select_type": "Seleccionar tipo",
    "commissions.demand_fixed": "Fijo",
    "commissions.demand_percentage": "Porcentaje",
    "commissions.unlimited_hint": "* Ingrese -1 para ilimitado",
    "* Enter -1 for unlimited": "* Ingrese -1 para ilimitado",
    "commissions.from": "Desde",
    "commissions.enter_from": "Introducir desde",
    "Enter from": "Introducir desde",
    "commissions.to": "Hasta",
    "commissions.enter_to": "Introducir hasta",
    "Enter to": "Introducir hasta",
    "commissions.enter_value": "Introducir valor",
    "commissions.add_row": "Agregar fila",
    "commissions.minimum_amount": "Monto mínimo",
    "Minimum amount": "Monto mínimo",
    "commissions.enter_minimum_amount": "Introducir monto mínimo",
    "commissions.maximum_amount": "Monto máximo",
    "Maximum amount": "Monto máximo",
    "commissions.enter_maximum_amount": "Introducir monto máximo",
    "commissions.notes": "Notas",
    "Notes": "Notas",
    "commissions.enter_note": "Introducir nota",
    "commissions.from_value": "Desde valor",
    "From Value": "Desde valor",
    "commissions.to_value": "Hasta valor",
    "To Value": "Hasta valor",
    "commissions.unlimited_short_hint": "(-1 para ilimitado)",
    "(-1 for unlimited)": "(-1 para ilimitado)",
    "commissions.value_percent": "Valor (%)",
    "Value (%)": "Valor (%)",
    "commissions.from_value_validation": "El valor desde debe ser mayor que el valor To anterior",
    "From value should be greater than the previous To value": "El valor desde debe ser mayor que el valor To anterior",
    "commissions.to_value_validation": "El valor hasta debe ser mayor que el valor desde",
    "To value should be greater than From value": "El valor hasta debe ser mayor que el valor desde",
    "taxes.title": "Impuesto",
    "taxes.title_plural": "Impuestos",
    "taxes.add": "Agregar impuesto",
    "Add Tax": "Agregar impuesto",
    "taxes.edit": "Editar impuesto",
    "Edit Tax": "Editar impuesto",
    "taxes.delete_confirm": "¿Está seguro de que desea eliminar este impuesto?",
    "Are you sure you want to delete this tax?": "¿Está seguro de que desea eliminar este impuesto?",
    "taxes.table_title": "Título",
    "taxes.table_short_code": "Código corto",
    "taxes.table_default_value": "Valor predeterminado",
    "taxes.table_status": "Estado",
    "taxes.table_action": "Acción",
    "taxes.active": "Activo",
    "taxes.inactive": "Inactivo",
    "taxes.select_type": "Seleccionar tipo",
    "taxes.type_order": "Orden",
    "taxes.type_listing": "Listado",
    "taxes.type_tax": "Impuesto",
    "taxes.demand_fixed": "Fijo",
    "taxes.demand_percentage": "Porcentaje",
    "taxes.from": "Desde",
    "taxes.enter_from": "Introducir desde",
    "taxes.to": "Hasta",
    "taxes.enter_to": "Introducir hasta",
    "taxes.unlimited_hint": "(-1 para ilimitado)",
    "taxes.value": "Valor",
    "taxes.enter_value": "Introducir valor",
    "taxes.add_row": "Añadir fila",
    "taxes.note": "Nota",
    "taxes.note_placeholder": "Ingrese una nota para que los usuarios vean durante el pago y en los detalles del pedido.",
    "Enter a note for users to see during checkout and in order details.": "Ingrese una nota para que los usuarios vean durante el pago y en los detalles del pedido.",
    "taxes.inclusive": "Impuesto incluido",
    "Tax Inclusive": "Impuesto incluido",
    "taxes.inclusive_tooltip": "Habilite esto cuando el precio listado ya incluye impuesto.",
    "Enable this when the listed price already includes tax.": "Habilite esto cuando el precio listado ya incluye impuesto.",
    "taxes.title_placeholder": "Ingrese un nombre mostrado a los usuarios durante el pago y en los detalles del pedido.",
    "Enter a name shown to users at checkout and in order details.": "Ingrese un nombre mostrado a los usuarios durante el pago y en los detalles del pedido.",
    "taxes.default_value": "Valor predeterminado (%)",
    "taxes.default_placeholder": "Valor predeterminado en %. Ejemplo: 6.5",
    "Default value in %. Example: 6.5": "Valor predeterminado en %. Ejemplo: 6.5",
    "taxes.short_code": "Código corto",
    "taxes.short_code_tooltip_title": "Código corto",
    "taxes.short_code_tooltip_description": "Introduzca un código corto para este impuesto.",
    "Enter a short code for this tax.": "Introduzca un código corto para este impuesto.",
    "taxes.short_code_placeholder": "Use letras y números, hasta 10 caracteres. Ejemplo: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Use letras y números, hasta 10 caracteres. Ejemplo: GST10",
    "taxes.status_hint": "Estado (Inactivo / Activo)",
    "taxes.advanced": "Avanzado",
    "special_fees.title": "Tarifas especiales",
    "special_fees.description": "Configure una tarifa fija adicional o porcentaje para cada lista.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Configure una tarifa fija adicional o porcentaje para cada lista.",
    "special_fees.fixed": "Tarifa especial fija",
    "Special fees fixed": "Tarifa especial fija",
    "special_fees.fixed_placeholder": "Introduzca la cantidad de la tarifa especial (ejemplo: 5)",
    "Enter special fee amount (example: 5)": "Introduzca la cantidad de la tarifa especial (ejemplo: 5)",
    "special_fees.percentage": "Tarifa especial porcentual",
    "Special fees percentage": "Tarifa especial porcentual",
    "special_fees.percentage_placeholder": "Introduzca el porcentaje de la tarifa especial (ejemplo: 10%)",
    "Enter special fee percentage (example: 10%)": "Introduzca el porcentaje de la tarifa especial (ejemplo: 10%)",
    "special_fees.example": "Ejemplo",
    "Example": "Ejemplo",
    "special_fees.example_description": "Puede agregar una tarifa especial sobre el precio de la lista. Por ejemplo, un producto listado cuesta $100 y agrega dos tarifas por lista.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "Puede agregar una tarifa especial sobre el precio de la lista. Por ejemplo, un producto listado cuesta $100 y agrega dos tarifas por lista.",
    "special_fees.example_fixed": "Monto fijo adicional = $10",
    "Additional fixed amount = $10": "Monto fijo adicional = $10",
    "special_fees.example_percentage": "Porcentaje fijo adicional = 10%",
    "Additional fixed percentage = 10%": "Porcentaje fijo adicional = 10%",
    "special_fees.example_total": "Precio final = $120",
    "Final price = $120": "Precio final = $120",
    "delivery.methods_title": "Métodos de servicio / envío",
    "Service / Shipping Methods": "Métodos de servicio / envío",
    "delivery.shipping_service": "Envío / Servicio",
    "Shipping / Service": "Envío / Servicio",
    "delivery.table_name": "Nombre",
    "delivery.table_default": "Predeterminado",
    "delivery.table_order": "Orden",
    "delivery.table_status": "Estado",
    "delivery.table_action": "Acción",
    "delivery.yes": "Sí",
    "delivery.no": "No",
    "delivery.active": "Activo",
    "delivery.inactive": "Inactivo",
    "delivery.delete_confirm": "¿Quieres eliminar este método de envío?",
    "Do you want to delete this shipping method?": "¿Quieres eliminar este método de envío?",
    "delivery.schedule_time": "Hora de programación",
    "Schedule Time": "Hora de programación",
    "delivery.translate": "Traducir",
    "delivery.config": "Configuración",
    "delivery.add": "Agregar Envío/Servicio",
    "Add Shipping/Service": "Agregar Envío/Servicio",
    "delivery.save": "Guardar",
    "delivery.edit": "Editar Envío/Servicio",
    "Edit Shipping/Service": "Editar Envío/Servicio",
    "delivery.stuart_config": "Configuraciones de Stuart",
    "Stuart Configs": "Configuraciones de Stuart",
    "delivery.shipping_configs": "Configuraciones de Servicio/Envío",
    "Service / Shipping Configs": "Configuraciones de Servicio/Envío",
    "delivery.settings": "Configuración",
    "delivery.preview": "Vista previa",
    "delivery.shipment_option": "Opción de envío",
    "Shipment Option": "Opción de envío",
    "delivery.name": "Nombre",
    "delivery.enter_name": "Introducir nombre",
    "delivery.note": "Nota",
    "delivery.enter_note": "Introducir nota",
    "delivery.note_tooltip_title": "Nota",
    "delivery.note_tooltip_description": "Añade una nota opcional para explicar esta opción de envío o servicio.",
    "Add an optional note to explain this shipping or service option.": "Añade una nota opcional para explicar esta opción de envío o servicio.",
    "delivery.order": "Pedido",
    "delivery.enter_order": "Introducir pedido",
    "delivery.status_hint": "Estado (Inactivo / Activo)",
    "delivery.default": "Predeterminado",
    "delivery.select_shipping_method": "Seleccionar método de envío",
    "Select shipping method": "Seleccionar método de envío",
    "delivery.select_extension": "Seleccionar extensión",
    "Select extension": "Seleccionar extensión",
    "delivery.add_photo": "Añadir foto",
    "delivery.config.flat_shipping_fee.title": "Tarifa fija de envío",
    "Flat Shipping Fee": "Tarifa fija de envío",
    "delivery.config.flat_shipping_fee.placeholder": "Introducir tarifa fija de envío",
    "Enter flat shipping fee": "Introducir tarifa fija de envío",
    "delivery.config.schedule_time.title": "Hora de programación",
    "delivery.config.fulfillment_by_platform_enabled.title": "Cumplimiento por plataforma",
    "Fulfillment by platform": "Cumplimiento por plataforma",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Icono de cumplimiento por plataforma",
    "Fulfillment by Platform Icon": "Icono de cumplimiento por plataforma",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Icono de entrega por vendedor",
    "Seller Delivery Icon": "Icono de entrega por vendedor",
    "delivery.phone_number": "Número de teléfono",
    "Phone number": "Número de teléfono",
    "delivery.enter_phone_number": "Introducir número de teléfono",
    "Enter phone number": "Introducir número de teléfono",
    "delivery.address_line_1": "Dirección línea 1",
    "Address line 1": "Dirección línea 1",
    "delivery.enter_address_line_1": "Introducir dirección línea 1",
    "Enter address line 1": "Introducir dirección línea 1",
    "delivery.address_line_2": "Dirección línea 2",
    "Address line 2": "Dirección línea 2",
    "delivery.enter_address_line_2": "Introducir dirección línea 2",
    "Enter address line 2": "Introducir dirección línea 2",
    "delivery.landmark": "Punto de referencia",
    "Landmark": "Punto de referencia",
    "delivery.enter_landmark": "Introducir punto de referencia",
    "Enter landmark": "Introducir punto de referencia",
    "delivery.state": "Estado",
    "delivery.enter_state": "Introducir estado",
    "Enter state": "Introducir estado",
    "delivery.post_code": "Código postal",
    "Post code": "Código postal",
    "delivery.enter_post_code": "Introduzca el código postal",
    "Enter post code": "Introduzca el código postal",
    "delivery.country": "País",
    "delivery.enter_country": "Introduzca el país",
    "Enter country": "Introduzca el país",
    "delivery.required_information": "Complete la información requerida",
    "Please fill the required information": "Complete la información requerida",
    "delivery.saved_successfully": "Subido con éxito",
    "delivery.storage_hub.title": "Puntos de Almacenamiento",
    "Storage Hub Points": "Puntos de Almacenamiento",
    "delivery.storage_hub.add": "Agregar Punto de Almacenamiento",
    "Add Storage Hub": "Agregar Punto de Almacenamiento",
    "delivery.storage_hub.edit": "Editar Punto de Almacenamiento",
    "Edit Storage Hub": "Editar Punto de Almacenamiento",
    "delivery.storage_hub.delete_confirm": "¿Desea eliminar este punto de almacén?",
    "Do you want to delete this storage hub point?": "¿Desea eliminar este punto de almacén?",
    "delivery.storage_hub.table_name": "Nombre",
    "delivery.storage_hub.table_phone": "Teléfono",
    "delivery.storage_hub.table_address": "Dirección",
    "delivery.storage_hub.table_landmark": "Punto de referencia",
    "delivery.storage_hub.table_state": "Estado",
    "delivery.storage_hub.table_post_code": "Código postal",
    "Post Code": "Código postal",
    "delivery.storage_hub.table_country": "País",
    "delivery.storage_hub.table_action": "Acción",
    "delivery.select_environment": "Seleccione el entorno",
    "Select environment": "Seleccione el entorno",
    "delivery.environment_sandbox": "Entorno de pruebas",
    "Sandbox": "Entorno de pruebas",
    "delivery.environment_production": "Producción",
    "Production": "Producción",
    "delivery.stuart.client_id": "ID de cliente",
    "delivery.stuart.enter_client_id": "Introduzca el ID de cliente",
    "delivery.stuart.client_secret": "Secreto de cliente",
    "Client Secret": "Secreto de cliente",
    "delivery.stuart.enter_client_secret": "Introduzca el secreto de cliente",
    "Enter client secret": "Introduzca el secreto de cliente",
    "delivery.stuart.webhook_key": "Clave de autenticación de webhook",
    "Webhook Authentication Key": "Clave de autenticación de webhook",
    "delivery.stuart.enter_webhook_key": "Introduzca la clave de autenticación del webhook",
    "Enter webhook authentication key": "Introduzca la clave de autenticación del webhook",
    "delivery.sendcloud.public_key": "Clave pública",
    "Public Key": "Clave pública",
    "delivery.sendcloud.enter_public_key": "Introduzca la clave de API",
    "delivery.sendcloud.secret_key": "Clave secreta",
    "Secret Key": "Clave secreta",
    "delivery.sendcloud.enter_secret_key": "Introduzca la clave secreta de notificación",
    "delivery.sendcloud.default_shipping_address": "Dirección de envío predeterminada",
    "Default Shipping Address": "Dirección de envío predeterminada",
    "delivery.sendcloud.add_new": "+ Añadir nuevo",
    "+ Add New": "+ Añadir nuevo",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Métodos de pago",
    "Payment Methods": "Métodos de pago",
    "payments.add": "Añadir método de pago",
    "Add Payment Method": "Añadir método de pago",
    "payments.edit": "Editar método de pago",
    "Edit Payment Method": "Editar método de pago",
    "payments.delete_confirm": "¿Quieres eliminar este método de pago?",
    "Do you want to delete this payment method?": "¿Quieres eliminar este método de pago?",
    "payments.save_continue": "Guardar y continuar",
    "Save and continue": "Guardar y continuar",
    "payments.translate": "Traducir pagos",
    "Translate Payments": "Traducir pagos",
    "payments.config": "Configuración",
    "payments.integration_settings": "Configuración de integración",
    "Integration Settings": "Configuración de integración",
    "payments.opp_integration": "Integración OPP",
    "OPP Integration": "Integración OPP",
    "payments.billplz_integration": "Integración BillPlz",
    "BillPlz Integration": "Integración BillPlz",
    "payments.stripe_integration": "Integración Stripe",
    "Stripe Integration": "Integración Stripe",
    "payments.stripe_web_integration": "Integración web de Stripe",
    "Stripe Web Integration": "Integración web de Stripe",
    "payments.pawapay_integration": "Integración PawaPay",
    "PawaPay Integration": "Integración PawaPay",
    "payments.korapay_integration": "Integración KoraPay",
    "KoraPay Integration": "Integración KoraPay",
    "payments.flutterwave_integration": "Integración Flutterwave",
    "Flutterwave Integration": "Integración Flutterwave",
    "payments.commercepay_integration": "Integración de CommercePay",
    "CommercePay Integration": "Integración de CommercePay",
    "payments.checkout_com_integration": "Integración de Checkout.com",
    "Checkout.com Integration": "Integración de Checkout.com",
    "payments.paystack_integration": "Integración de PayStack",
    "PayStack Integration": "Integración de PayStack",
    "payments.razorpay_settings": "Ajustes de Razorpay",
    "Razorpay settings": "Ajustes de Razorpay",
    "payments.paydunya_settings": "Ajustes de Pay Dunya",
    "Pay Dunya settings": "Ajustes de Pay Dunya",
    "payments.mangopay_settings": "Ajustes de MangoPay",
    "MangoPay settings": "Ajustes de MangoPay",
    "payments.payu_latam_integration": "Integración de PayU LATAM",
    "PayU LATAM Integration": "Integración de PayU LATAM",
    "payments.table_name": "Nombre",
    "payments.table_actions": "Acciones",
    "payments.table_min_amount": "Monto Mínimo",
    "payments.table_max_amount": "Monto Máximo",
    "payments.table_default": "Predeterminado",
    "payments.table_order_by": "Orden",
    "payments.table_status": "Estado",
    "payments.yes": "Sí",
    "payments.no": "No",
    "payments.active": "Activo",
    "payments.inactive": "Inactivo",
    "payments.settings": "Ajustes",
    "payments.not_available": "N/D",
    "payments.step_select_type": "Seleccionar Tipo",
    "payments.step_configure": "Configurar",
    "Configure": "Configurar",
    "payments.step_integration": "Integración",
    "Integration": "Integración",
    "payments.next": "Siguiente →",
    "Next →": "Siguiente →",
    "payments.save": "Guardar",
    "payments.choose_method": "Selecciona un método de pago para configurar",
    "Choose a payment method to configure": "Selecciona un método de pago para configurar",
    "payments.name": "Nombre",
    "payments.enter_name": "Introduce nombre",
    "payments.maximum_amount": "Monto máximo",
    "payments.enter_maximum_amount": "Introduce monto máximo",
    "payments.minimum_amount": "Monto mínimo",
    "payments.enter_minimum_amount": "Introduce monto mínimo",
    "payments.note": "Nota",
    "payments.enter_note": "Introduce nota",
    "payments.note_tooltip": "Añade una nota opcional para los clientes en el checkout.",
    "Add an optional note for customers at checkout.": "Añade una nota opcional para los clientes en el checkout.",
    "payments.order": "Orden",
    "payments.enter_order": "Introduce orden",
    "payments.default": "Predeterminado",
    "payments.config_title": "Configuración de métodos de pago",
    "Payment Methods Configuration": "Configuración de métodos de pago",
    "payments.wallet_enable": "Billetera habilitada",
    "Wallet enabled": "Billetera habilitada",
    "payments.account_type": "Tipo de cuenta",
    "payments.select_account_type": "Selecciona tipo de cuenta",
    "Select account type": "Selecciona tipo de cuenta",
    "payments.connect_message_standard": "Mensaje de conexión estándar",
    "Connect message standard": "Mensaje de conexión estándar",
    "payments.enter_connect_message_standard": "Introduce mensaje de conexión estándar",
    "Enter connect message standard": "Introduce mensaje de conexión estándar",
    "payments.disconnect_message_standard": "Mensaje de desconexión estándar",
    "Disconnect message standard": "Mensaje de desconexión estándar",
    "payments.enter_disconnect_message_standard": "Introduce mensaje de desconexión estándar",
    "Enter disconnect message standard": "Introduce mensaje de desconexión estándar",
    "payments.connect_message_express": "Mensaje de conexión express",
    "Connect message express": "Mensaje de conexión express",
    "payments.enter_connect_message_express": "Introduce mensaje de conexión express",
    "Enter connect message express": "Introduce mensaje de conexión express",
    "payments.disconnect_message_express": "Mensaje de desconexión express",
    "Disconnect message express": "Mensaje de desconexión express",
    "payments.enter_disconnect_message_express": "Introducir mensaje de desconexión express",
    "Enter disconnect message express": "Introducir mensaje de desconexión express",
    "payments.enable_sandbox": "Habilitar sandbox",
    "Enable sandbox": "Habilitar sandbox",
    "payments.api_token": "Token de API",
    "API Token": "Token de API",
    "payments.enter_token": "Introducir token",
    "Enter token": "Introducir token",
    "payments.key_id": "ID de clave",
    "Key ID": "ID de clave",
    "payments.enter_key_id": "Introducir ID de clave",
    "Enter key ID": "Introducir ID de clave",
    "payments.key_secret": "Secreto de clave",
    "Key Secret": "Secreto de clave",
    "payments.enter_secret_key": "Introducir clave secreta",
    "Enter secret key": "Introducir clave secreta",
    "payments.webhook_secret_key": "Clave secreta de webhook",
    "Webhook Secret Key": "Clave secreta de webhook",
    "payments.enter_webhook_secret_key": "Introducir clave secreta de webhook",
    "Enter webhook secret key": "Introducir clave secreta de webhook",
    "payments.master_key": "Clave maestra",
    "Master Key": "Clave maestra",
    "payments.public_key": "Clave pública",
    "payments.enter_public_key": "Introducir clave pública",
    "Enter public key": "Introducir clave pública",
    "payments.private_key": "Clave privada",
    "Private Key": "Clave privada",
    "payments.merchant_id": "ID de comerciante",
    "Merchant ID": "ID de comerciante",
    "payments.enter_merchant_id": "Introducir ID de comerciante",
    "Enter merchant id": "Introducir ID de comerciante",
    "payments.processing_channel_id": "ID de canal de procesamiento",
    "Processing channel ID": "ID de canal de procesamiento",
    "payments.enter_processing_channel_id": "Introducir ID de canal de procesamiento",
    "Enter processing channel id": "Introducir ID de canal de procesamiento",
    "payments.api_key": "Clave API",
    "payments.x_signature_key": "Clave de firma X",
    "X Signature Key": "Clave de firma X",
    "payments.account_id": "ID de cuenta",
    "payments.login_api_key": "Clave API de inicio de sesión",
    "Login API key": "Clave API de inicio de sesión",
    "payments.client_id": "ID de cliente",
    "payments.client_api_key": "Clave de API del cliente",
    "Client API Key": "Clave de API del cliente",
    "payments.payin_fee": "Comisión de PayIn (%)",
    "PayIn fee (%)": "Comisión de PayIn (%)",
    "payments.withdraw_fee": "Comisión de Withdraw (%)",
    "Withdraw fee (%)": "Comisión de Withdraw (%)",
    "payments.enter_api_key": "Introducir clave API",
    "payments.enter_account_id": "Introducir ID de cuenta",
    "Enter account ID": "Introducir ID de cuenta",
    "payments.enter_login_api_key": "Introducir clave API de inicio de sesión",
    "Enter login API key": "Introducir clave API de inicio de sesión",
    "payments.enter_notification_secret": "Introducir secreto de notificación",
    "payments.enter_payin_fee": "Introducir comisión como porcentaje",
    "Enter fee as a percentage": "Introducir comisión como porcentaje",
    "payments.secret_key": "Clave secreta",
    "Secret key": "Clave secreta",
    "payments.publishable_key": "Clave publicable",
    "Publishable key": "Clave publicable",
    "payments.webhook_secret": "Secreto de webhook",
    "Webhook secret": "Secreto de webhook",
    "payments.enter_webhook_secret": "Introducir secreto de webhook",
    "Enter webhook secret": "Introducir secreto de webhook",
    "payments.enter_subscription_webhook_secret": "Introducir secreto de webhook de suscripción",
    "Enter subscription webhook secret": "Introducir secreto de webhook de suscripción",
    "payments.connect_client_id": "ID de cliente Connect",
    "Connect client ID": "ID de cliente Connect",
    "payments.enter_connect_client_id": "Introducir ID de cliente Connect",
    "Enter Connect client ID": "Introducir ID de cliente Connect",
    "payments.stripe_reminders": "Recordatorios de Stripe",
    "Stripe reminders": "Recordatorios de Stripe",
    "payments.stripe_sync_help": "La sincronización verifica su clave secreta con Stripe, completa su información de cuenta y crea los puntos finales de webhook que Tradly necesita. Los secretos de webhook se rellenan automáticamente; guarde el formulario al terminar.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "La sincronización verifica su clave secreta con Stripe, completa su información de cuenta y crea los puntos finales de webhook que Tradly necesita. Los secretos de webhook se rellenan automáticamente; guarde el formulario al terminar.",
    "payments.find_in_stripe": "Buscar en el panel de Stripe",
    "Find in Stripe Dashboard": "Buscar en el panel de Stripe",
    "payments.description": "Descripción",
    "payments.learn_more_stripe": "Más información sobre Stripe Payments",
    "Learn more about Stripe Payments": "Más información sobre Stripe Payments",
    "payments.learn_more_stripe_connect": "Más información sobre Stripe Connect para marketplaces",
    "Learn more about Stripe Connect for marketplaces": "Más información sobre Stripe Connect para marketplaces",
    "payments.token": "Token",
    "Token": "Token",
    "payments.payment_options": "Opciones de pago",
    "Payment options": "Opciones de pago",
    "payments.enable_integration": "Habilitar integración",
    "Enable integration": "Habilitar integración",
    "payments.enter_provider_id": "Introduzca el ID de {provider}",
    "Enter {provider} ID": "Introduzca el ID de {provider}",
    "payments.integration_status_help": "Configure este proveedor en sus ajustes.",
    "Configure this provider in its settings.": "Configure este proveedor en sus ajustes.",
    "listings.title": "Listados",
    "listings.manage": "Administrar",
    "listings.show_rows": "Mostrar filas",
    "listings.clear": "Borrar",
    "listings.apply": "Aplicar",
    "listings.select_date": "Seleccionar fecha",
    "Select date": "Seleccionar fecha",
    "listings.start_date": "Fecha de inicio",
    "listings.end_date": "Fecha de fin",
    "listings.status_types": "Tipos de estado",
    "Status types": "Tipos de estado",
    "listings.categories": "Categorías",
    "listings.attributes": "Atributos",
    "listings.clear_all_filters": "Borrar todos los filtros",
    "Clear all filters": "Borrar todos los filtros",
    "listings.import": "Importar",
    "listings.export": "Exportar",
    "listings.smart_upload": "Carga inteligente (Beta)",
    "Smart Upload (Beta)": "Carga inteligente (Beta)",
    "listings.filter_listings": "Filtrar listados",
    "Filter listings": "Filtrar listados",
    "listings.sort_listings": "Ordenar listados",
    "Sort listings": "Ordenar listados",
    "listings.import_listings": "Importar listados",
    "Import listings": "Importar listados",
    "listings.export_listings": "Exportar listados",
    "Export listings": "Exportar listados",
    "listings.list_view": "Vista de lista",
    "listings.grid_view": "Vista de cuadrícula",
    "listings.map_view": "Vista de mapa",
    "listings.board_view": "Vista tablero",
    "listings.export_all_title": "¿Exportar todas las listas?",
    "Export all listings?": "¿Exportar todas las listas?",
    "listings.export_all_message": "Esto preparará un archivo con todas las listas. ¿Desea continuar?",
    "This will prepare a file containing all listings. Do you want to continue?": "Esto preparará un archivo con todas las listas. ¿Desea continuar?",
    "listings.export_all": "Exportar todas las listas",
    "Export all listings": "Exportar todas las listas",
    "listings.cancel": "Cancelar",
    "listings.status_all": "Todos",
    "listings.status_pending": "Pendiente",
    "listings.status_approved": "Aprobado",
    "listings.status_rejected": "Rechazado",
    "listings.status_archived": "Archivado",
    "Archived": "Archivado",
    "listings.sort_newest_first": "Más reciente primero",
    "Newest first": "Más reciente primero",
    "listings.sort_price_high_to_low": "Precio: alto a bajo",
    "Price: high to low": "Precio: alto a bajo",
    "listings.sort_price_low_to_high": "Precio: bajo a alto",
    "Price: low to high": "Precio: bajo a alto",
    "listings.header_0": "Título",
    "listings.header_1": "Sitio web",
    "Website": "Sitio web",
    "listings.header_2": "Precio de lista",
    "List price": "Precio de lista",
    "listings.header_3": "Porcentaje de oferta",
    "listings.header_4": "Imagen",
    "listings.header_5": "Precio de oferta",
    "Offer price": "Precio de oferta",
    "listings.header_6": "Estado",
    "listings.header_7": "ID de lista",
    "listings.header_8": "Estado de la lista",
    "Listing status": "Estado de la lista",
    "listings.header_9": "Cuentas",
    "listings.header_10": "Moneda",
    "listings.header_11": "Vendido",
    "Sold": "Vendido",
    "listings.header_12": "Monto objetivo",
    "Goal amount": "Monto objetivo",
    "listings.filter_status": "Estado",
    "listings.filter_price": "Precio",
    "listings.filter_category": "Categoría",
    "listings.filter_clear_all": "Borrar todos los filtros",
    "listings.status_count": "Estado ({count})",
    "Status ({count})": "Estado ({count})",
    "listings.price_count": "Precio ({count})",
    "Price ({count})": "Precio ({count})",
    "listings.category_count": "Categoría ({count})",
    "Category ({count})": "Categoría ({count})",
    "listings.search": "Buscar listados",
    "listings.clear_search": "Borrar búsqueda",
    "Clear listing search": "Borrar búsqueda",
    "listings.active": "Activo",
    "listings.inactive": "Inactivo",
    "listings.approve": "Aprobar",
    "listings.reject": "Rechazar",
    "listings.delete_confirm": "¿Estás seguro de que quieres eliminar este listado?",
    "listings.approve_confirm": "¿Quieres aprobar este listado?",
    "Do you want to approve this listing?": "¿Quieres aprobar este listado?",
    "listings.reject_confirm": "¿Quieres rechazar este listado?",
    "Do you want to reject this listing?": "¿Quieres rechazar este listado?",
    "listings.yes": "Sí",
    "listings.no": "No",
    "listings.confirm_delete": "¿Estás seguro de que quieres eliminar este listado?",
    "listings.confirm_approve": "¿Quieres aprobar este listado?",
    "listings.confirm_reject": "¿Quieres rechazar este listado?",
    "listings.column.actions": "Acciones",
    "listings.audio_episode": "Episodio de audio",
    "Audio episode": "Episodio de audio",
    "listings.video": "Vídeo",
    "listings.seller": "Vendedor",
    "listings.rating": "Calificación",
    "listings.followers": "Seguidores",
    "listings.view_seller_account": "Ver cuenta del vendedor",
    "View seller account": "Ver cuenta del vendedor",
    "listings.add_variant": "Agregar variante",
    "Add variant": "Agregar variante",
    "listings.edit": "Editar",
    "listings.preview": "Previsualizar",
    "listings.share": "Compartir",
    "listings.view_listing": "Ver lista",
    "View listing": "Ver lista",
    "listings.stock": "Stock",
    "Stock": "Stock",
    "listings.variants": "Variantes",
    "listings.campaign": "Campaña",
    "Campaign": "Campaña",
    "listings.rental_details": "Detalles de alquiler",
    "Rental details": "Detalles de alquiler",
    "listings.copy": "Copiar",
    "listings.inventory": "Inventario",
    "listings.order_type": "Tipo de pedido",
    "Order type": "Tipo de pedido",
    "listings.stock_by_location": "Stock por ubicación",
    "Stock by location": "Stock por ubicación",
    "listings.loading_location_stock": "Cargando stock de ubicación…",
    "Loading location stock…": "Cargando stock de ubicación…",
    "listings.no_location_stock": "No hay stock asignado a una ubicación.",
    "No stock assigned to a location.": "No hay stock asignado a una ubicación.",
    "listings.page_analytics": "Análisis de página",
    "Page analytics": "Análisis de página",
    "listings.loading": "Cargando…",
    "listings.analytics_key_missing": "La clave de API de análisis no está configurada para este inquilino.",
    "Analytics API key is not configured for this tenant.": "La clave de API de análisis no está configurada para este inquilino.",
    "listings.no_slug": "No hay slug disponible para este listado.",
    "No slug is available for this listing.": "No hay slug disponible para este listado.",
    "listings.no_analytics": "No se han cargado analíticas aún.",
    "listings.load_analytics": "Cargar analíticas",
    "Load analytics": "Cargar analíticas",
    "listings.no_orders": "No hay pedidos aún para este listado",
    "No orders yet for this listing": "No hay pedidos aún para este listado",
    "listings.social_ratings": "Social y calificaciones",
    "Social and ratings": "Social y calificaciones",
    "listings.tags": "Etiquetas",
    "listings.schedule": "Programar",
    "listings.detail": "Detalle",
    "Detail": "Detalle",
    "listings.update_stock": "Actualizar stock",
    "Update stock": "Actualizar stock",
    "listings.new_stock_quantity": "Nueva cantidad de stock",
    "New stock quantity": "Nueva cantidad de stock",
    "listings.location": "Ubicación",
    "listings.quantity": "Cantidad",
    "listings.current_stock": "Stock actual: {quantity}",
    "Current stock: {quantity}": "Stock actual: {quantity}",
    "listings.loading_rental": "Cargando configuraciones de alquiler…",
    "Loading rental settings…": "Cargando configuraciones de alquiler…",
    "payments.enter_publishable_key": "Introducir clave pública",
    "Enter publishable key": "Introducir clave pública",
    "listings.add_listing": "Añadir listado",
    "Add listing": "Añadir listado",
    "listings.edit_listing": "Editar listado",
    "listings.enter_title": "Introducir título",
    "listings.account": "Cuenta",
    "listings.list_price": "Precio de lista",
    "listings.enter_list_price": "Introducir precio de lista",
    "listings.select_currency": "Seleccionar moneda",
    "Select currency": "Seleccionar moneda",
    "listings.select_category": "Seleccionar categoría",
    "listings.select_categories": "Seleccionar categorías",
    "Select categories": "Seleccionar categorías",
    "listings.add_category": "+ Añadir categoría",
    "+ Add category": "+ Añadir categoría",
    "listings.add_attribute": "Añadir atributo",
    "Add attribute": "Añadir atributo",
    "listings.enter_stock": "Introducir stock",
    "listings.offer_percentage": "Porcentaje de oferta",
    "Offer percentage": "Porcentaje de oferta",
    "listings.enter_offer": "Introducir oferta",
    "Enter offer": "Introducir oferta",
    "listings.max_quantity_optional": "Cantidad máxima (opcional)",
    "Max quantity (optional)": "Cantidad máxima (opcional)",
    "listings.enter_max_quantity": "Introducir cantidad máxima",
    "Enter max quantity": "Introducir cantidad máxima",
    "listings.enter_slug": "Introducir slug",
    "listings.enter_meta_title": "Introducir título meta",
    "listings.repeat": "Repetir",
    "Repeat": "Repetir",
    "listings.start_time": "Hora de inicio",
    "Start time": "Hora de inicio",
    "listings.end_time": "Hora de fin",
    "End time": "Hora de fin",
    "listings.slot": "Ranura",
    "Slot": "Ranura",
    "listings.starts_from": "Comienza desde:",
    "Starts from:": "Comienza desde:",
    "listings.add_schedule": "+ Añadir horario",
    "listings.upload_here": "Subir aquí",
    "listings.save": "Guardar",
    "listings.update": "Actualizar",
    "listings.tax": "Impuesto",
    "listings.title_required": "Por favor, introduzca un título",
    "Please enter a title": "Por favor, introduzca un título",
    "listings.select_tax": "Por favor, seleccione un impuesto",
    "Please select a tax": "Por favor, seleccione un impuesto",
    "listings.select_item": "Por favor, seleccione {item}",
    "Please select {item}": "Por favor, seleccione {item}",
    "listings.offer_percentage_validation": "El porcentaje de oferta debe estar entre 0 y 100",
    "Offer percentage must be between 0 and 100": "El porcentaje de oferta debe estar entre 0 y 100",
    "listings.custom_seo": "SEO personalizado",
    "Custom SEO": "SEO personalizado",
    "listings.select_value": "Seleccionar valor",
    "Select value": "Seleccionar valor",
    "listings.add_schedule_title": "Agregar horario",
    "Add schedule": "Agregar horario",
    "listings.select_from_media": "Seleccionar de los medios",
    "listing_form.create_listing": "Crear anuncio",
    "Create listing": "Crear anuncio",
    "listing_form.update_listing": "Actualizar anuncio",
    "Update listing": "Actualizar anuncio",
    "listing_form.saving": "Guardando…",
    "listing_form.main_information": "Información principal",
    "Main information": "Información principal",
    "listing_form.audio_listing": "Anuncio de audio",
    "Audio listing": "Anuncio de audio",
    "listing_form.basic_information": "Información básica",
    "Basic information": "Información básica",
    "listing_form.listing_type": "Tipo de anuncio",
    "Listing type": "Tipo de anuncio",
    "listing_form.title": "Título",
    "listing_form.enter_listing_title": "Ingrese el título del anuncio",
    "Enter listing title": "Ingrese el título del anuncio",
    "listing_form.description": "Descripción",
    "listing_form.enter_detailed_description": "Ingrese una descripción detallada",
    "Enter detailed description": "Ingrese una descripción detallada",
    "listing_form.tags": "Etiquetas",
    "listing_form.tag_example": "p. ej., electrónicos, gadgets, nuevos",
    "e.g., electronics, gadgets, new": "p. ej., electrónicos, gadgets, nuevos",
    "listing_form.taxes": "Impuestos",
    "listing_form.optional": "Opcional",
    "listing_form.start_date": "Fecha de inicio",
    "listing_form.end_date": "Fecha de finalización",
    "listing_form.currency": "Moneda",
    "listing_form.select_currency": "Seleccionar moneda",
    "listing_form.goal_price": "Precio objetivo",
    "Goal price": "Precio objetivo",
    "listing_form.set_fundraising_goal": "Establecer objetivo de recaudación de fondos",
    "Set your fundraising goal": "Establecer objetivo de recaudación de fondos",
    "listing_form.pricing": "Precios",
    "Pricing": "Precios",
    "listing_form.select": "Seleccionar",
    "listing_form.price": "Precio",
    "listing_form.offer_percent": "Oferta %",
    "Offer %": "Oferta %",
    "listing_form.listing_price": "Precio de lista:",
    "Listing price:": "Precio de lista:",
    "listing_form.set_fundraising_goal_amount": "Establece tu objetivo de recaudación de fondos",
    "Set your fundraising goal amount": "Establece tu objetivo de recaudación de fondos",
    "listing_form.category": "Categoría",
    "listing_form.select_a_category": "Selecciona una categoría",
    "listing_form.clear_selected_category": "Borrar categoría seleccionada",
    "Clear selected category": "Borrar categoría seleccionada",
    "listing_form.create_new_category": "Crear una nueva categoría",
    "Create a new category": "Crear una nueva categoría",
    "listing_form.search_categories": "Buscar categorías…",
    "Search categories…": "Buscar categorías…",
    "listing_form.no_categories_match": "No se encontraron categorías",
    "No categories found": "No se encontraron categorías",
    "listing_form.draft_found": "Se encontró un borrador guardado.",
    "A saved draft was found.": "Se encontró un borrador guardado.",
    "listing_form.restore": "Restaurar",
    "Restore": "Restaurar",
    "listing_form.discard": "Descartar",
    "listing_form.characters": "caracteres",
    "characters": "caracteres",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Productos físicos",
    "Physical products": "Productos físicos",
    "listing_form.type_events": "Eventos",
    "Events": "Eventos",
    "listing_form.type_digital": "Productos digitales",
    "Digital products": "Productos digitales",
    "listing_form.type_appointments": "Citas",
    "Appointments": "Citas",
    "listing_form.type_rentals": "Alquileres",
    "listing_form.type_donation": "Financiación colectiva",
    "Crowdfunding": "Financiación colectiva",
    "listing_form.type_information_listing": "Información",
    "Information": "Información",
    "listing_form.type_video_listing": "Vídeo",
    "listing_form.type_audio_listing": "Audio",
    "listing_form.select_taxes": "Seleccionar impuestos (opcional)",
    "Select taxes (optional)": "Seleccionar impuestos (opcional)",
    "listing_form.no_taxes": "No hay impuestos disponibles",
    "No taxes available": "No hay impuestos disponibles",
    "listing_form.inventory_shipping": "Inventario y envío",
    "Inventory & shipping": "Inventario y envío",
    "listing_form.stock": "Stock",
    "listing_form.weight": "Peso",
    "Weight": "Peso",
    "listing_form.dimensions": "Dimensiones (L×W×H)",
    "Dimensions (L×W×H)": "Dimensiones (L×W×H)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Código de barras",
    "Barcode": "Código de barras",
    "listing_form.length": "Longitud",
    "Length": "Longitud",
    "listing_form.width": "Ancho",
    "Width": "Ancho",
    "listing_form.height": "Altura",
    "listing_form.seo_settings": "Configuración SEO",
    "SEO settings": "Configuración SEO",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "Versión amigable para URL",
    "URL-friendly version of the title": "Versión amigable para URL",
    "listing_form.meta_title": "Título meta",
    "listing_form.recommended_meta_title": "Recomendado: 50–60 caracteres",
    "Recommended: 50–60 chars": "Recomendado: 50–60 caracteres",
    "listing_form.meta_keywords": "Palabras clave meta",
    "Meta keywords": "Palabras clave meta",
    "listing_form.separate_with_commas": "Separar con comas",
    "Separate with commas": "Separar con comas",
    "listing_form.meta_description": "Descripción meta",
    "listing_form.recommended_meta_description": "Recomendado: 150–160 caracteres",
    "Recommended: 150–160 chars": "Recomendado: 150–160 caracteres",
    "listing_form.hide": "Ocultar",
    "listing_form.show": "Mostrar",
    "listing_form.seo_fields": "Campos de optimización de motores de búsqueda",
    "search engine optimization fields": "Campos de optimización de motores de búsqueda",
    "listing_form.auto_generated_slug": "Generado automáticamente desde el título",
    "Auto-generated from title": "Generado automáticamente desde el título",
    "listing_form.seo_title_optional": "Título SEO (opcional)",
    "SEO title (optional)": "Título SEO (opcional)",
    "listing_form.keywords_comma_separated": "Palabras clave separadas por comas",
    "Keywords separated by commas": "Palabras clave separadas por comas",
    "listing_form.search_description_optional": "Descripción breve para resultados de búsqueda (opcional)",
    "Brief description for search results (optional)": "Descripción breve para resultados de búsqueda (opcional)",
    "listing_form.account": "Cuenta",
    "listing_form.loading_accounts": "Cargando cuentas…",
    "Loading accounts…": "Cargando cuentas…",
    "listing_form.clear_selected_account": "Borrar cuenta seleccionada",
    "Clear selected account": "Borrar cuenta seleccionada",
    "listing_form.search_accounts": "Buscar cuentas…",
    "Search accounts…": "Buscar cuentas…",
    "listing_form.create_account": "Crear una nueva cuenta",
    "Create a new account": "Crear una nueva cuenta",
    "listing_form.no_accounts_found": "No se encontraron cuentas",
    "No accounts found": "No se encontraron cuentas",
    "listing_form.rental_settings": "Configuración de alquiler",
    "Rental settings": "Configuración de alquiler",
    "listing_form.rental_price_help": "El precio del listado se calcula a partir de la tarifa de alquiler y la duración.",
    "The listing price is calculated from the rental rate and duration.": "El precio del listado se calcula a partir de la tarifa de alquiler y la duración.",
    "listing_form.rate_unit": "Unidad de tarifa",
    "Rate unit": "Unidad de tarifa",
    "listing_form.hour": "Hora",
    "Hour": "Hora",
    "listing_form.day": "Día",
    "listing_form.week": "Semana",
    "listing_form.rental_rate_amount": "Tarifa de alquiler",
    "Rental rate": "Tarifa de alquiler",
    "listing_form.rental_min_duration": "Duración mínima",
    "Minimum duration": "Duración mínima",
    "listing_form.rental_max_duration": "Duración máxima",
    "Maximum duration": "Duración máxima",
    "listing_form.rental_buffer_time": "Tiempo de buffer (horas)",
    "Buffer time (hours)": "Tiempo de buffer (horas)",
    "listing_form.rental_deposit_amount": "Monto del depósito",
    "Deposit amount": "Monto del depósito",
    "listing_form.rental_max_units": "Unidades máximas",
    "Maximum units": "Unidades máximas",
    "listing_form.quick_create_title": "Crear {entity}",
    "Create {entity}": "Crear {entity}",
    "listing_form.close": "Cerrar",
    "listing_form.account_name": "Nombre de la cuenta",
    "listing_form.category_name": "Nombre de la categoría",
    "listing_form.account_example": "Ej.: Tienda Acme",
    "e.g. Acme Store": "Ej.: Tienda Acme",
    "listing_form.category_example": "Ej.: Productos frescos",
    "e.g. Fresh Produce": "Ej.: Productos frescos",
    "listing_form.creating": "Creando…",
    "listing_form.create_entity": "Crear {entity}",
    "listing_form.cancel": "Cancelar",
    "listing_form.go_back": "Volver",
    "Go back": "Volver",
    "listing_form.upgrade_plan": "Actualizar plan",
    "Upgrade plan": "Actualizar plan",
    "listing_form.close_upgrade_dialog": "Cerrar diálogo de actualización",
    "Close upgrade dialog": "Cerrar diálogo de actualización",
    "listing_form.loading_attributes": "Cargando atributos…",
    "Loading attributes…": "Cargando atributos…",
    "listing_form.no_attributes": "No hay atributos para esta categoría",
    "No attributes for this category": "No hay atributos para esta categoría",
    "listing_form.unsupported_field_type": "Tipo de campo no compatible",
    "Unsupported field type": "Tipo de campo no compatible",
    "listing_form.delete_schedule_confirm": "¿Estás seguro de que quieres eliminar esta programación?",
    "Are you sure you want to delete this schedule?": "¿Estás seguro de que quieres eliminar esta programación?",
    "listing_form.no_schedules_added": "Aún no se han agregado horarios",
    "No schedules added yet": "Aún no se han agregado horarios",
    "listing_form.stock_label": "Existencias:",
    "Stock:": "Existencias:",
    "listing_form.active": "Activo",
    "listing_form.inactive": "Inactivo",
    "listing_form.edit": "Editar",
    "listing_form.delete": "Eliminar",
    "listing_form.schedules": "Horarios",
    "Schedules": "Horarios",
    "listing_form.no_schedules_yet": "Aún no hay horarios",
    "No schedules yet": "Aún no hay horarios",
    "listing_form.dates_label": "Fechas:",
    "Dates:": "Fechas:",
    "listing_form.time_label": "Hora:",
    "Time:": "Hora:",
    "listing_form.repeat_label": "Repetir:",
    "Repeat:": "Repetir:",
    "listing_form.capacity_label": "Capacidad:",
    "Capacity:": "Capacidad:",
    "listing_form.edit_schedule": "Editar horario",
    "Edit schedule": "Editar horario",
    "listing_form.add_new_schedule": "Agregar nuevo horario",
    "Add new schedule": "Agregar nuevo horario",
    "listing_form.repeat_pattern": "Patrón de repetición",
    "Repeat pattern": "Patrón de repetición",
    "listing_form.select_days": "Seleccionar días",
    "Select days": "Seleccionar días",
    "listing_form.total_stocks_capacity": "Stock total (capacidad)",
    "Total stock (capacity)": "Stock total (capacidad)",
    "listing_form.select_at_least_one_day": "Seleccione al menos un día",
    "Please select at least one day": "Seleccione al menos un día",
    "listing_form.unlimited_capacity_help": "Deje en blanco para capacidad ilimitada",
    "Leave empty for unlimited capacity": "Deje en blanco para capacidad ilimitada",
    "listing_form.add_schedule": "+ Agregar horario",
    "listing_form.schedule_number": "Horario #{number}",
    "Schedule #{number}": "Horario #{number}",
    "listing_form.update_action": "actualizar",
    "update": "actualizar",
    "listing_form.create_action": "crear",
    "create": "crear",
    "listing_form.a_schedule": "un horario",
    "a schedule": "un horario",
    "listing_form.daily": "Diario",
    "Daily": "Diario",
    "listing_form.weekdays": "Días laborables (Lun - Vie)",
    "Weekdays (Mon - Fri)": "Días laborables (Lun - Vie)",
    "listing_form.weekend": "Fin de semana (Sáb - Dom)",
    "Weekend (Sat - Sun)": "Fin de semana (Sáb - Dom)",
    "listing_form.custom": "Personalizado",
    "listing_form.weekday_0": "Lunes",
    "Monday": "Lunes",
    "listing_form.weekday_1": "Martes",
    "Tuesday": "Martes",
    "listing_form.weekday_2": "Miércoles",
    "Wednesday": "Miércoles",
    "listing_form.weekday_3": "Jueves",
    "Thursday": "Jueves",
    "listing_form.weekday_4": "Viernes",
    "Friday": "Viernes",
    "listing_form.weekday_5": "Sábado",
    "Saturday": "Sábado",
    "listing_form.weekday_6": "Domingo",
    "Sunday": "Domingo",
    "listing_form.media_max_files": "Máximo {count} {type} permitido",
    "Maximum {count} {type} allowed": "Máximo {count} {type} permitido",
    "listing_form.video_size_limit": "Cada video debe ser de 1 GB o menor",
    "Each video must be 1GB or smaller": "Cada video debe ser de 1 GB o menor",
    "listing_form.videos": "Vídeos",
    "Videos": "Vídeos",
    "listing_form.images": "Imágenes",
    "listing_form.select_from_media": "Seleccionar de los medios",
    "listing_form.video_upload_help": "Sube vídeos en formato MP4, MOV, AVI, MKV, WebM (máximo 1GB cada uno)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Sube vídeos en formato MP4, MOV, AVI, MKV, WebM (máximo 1GB cada uno)",
    "listing_form.image_upload_help": "Sube imágenes en formato JPG, PNG, GIF, WebP (máximo 10MB cada una)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Sube imágenes en formato JPG, PNG, GIF, WebP (máximo 10MB cada una)",
    "listing_form.uploading_video": "Subiendo video…",
    "Uploading video…": "Subiendo video…",
    "listing_form.audio_episode": "Episodio de audio",
    "listing_form.audio_upload_help": "Sube un archivo de audio o pega una URL pública para el feed RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Sube un archivo de audio o pega una URL pública para el feed RSS.",
    "listing_form.selected_file": "Seleccionado: {name}",
    "listing_form.audio_url_help": "La URL es opcional cuando se selecciona un archivo. Deje en blanco para usar el archivo subido.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "La URL es opcional cuando se selecciona un archivo. Deje en blanco para usar el archivo subido.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Subiendo audio…",
    "Uploading audio…": "Subiendo audio…",
    "listing_form.validation_start_date": "Por favor seleccione la fecha de inicio",
    "Please select start date": "Por favor seleccione la fecha de inicio",
    "listing_form.validation_end_date": "Por favor seleccione la fecha de finalización",
    "Please select end date": "Por favor seleccione la fecha de finalización",
    "listing_form.validation_start_time": "Por favor seleccione la hora de inicio",
    "Please select start time": "Por favor seleccione la hora de inicio",
    "listing_form.validation_end_time": "Por favor seleccione la hora de finalización",
    "Please select end time": "Por favor seleccione la hora de finalización",
    "listing_form.weekdays_short": "Días laborables",
    "Weekdays": "Días laborables",
    "listing_form.weekend_short": "Fin de semana",
    "Weekend": "Fin de semana",
    "listing_form.click_add_schedule_help": "Haga clic en \"{action}\" para crear su primer horario",
    "Click \"{action}\" to create your first schedule": "Haga clic en \"{action}\" para crear su primer horario",
    "listing_form.schedule_form_intro": "Completa los detalles a continuación para",
    "Fill in the details below to": "Completa los detalles a continuación para",
    "listing_form.update": "Actualizar",
    "listing_form.save": "Guardar",
    "listing_form.variant_value_required": "Seleccione al menos un valor de variante (por ejemplo, Color, Tamaño)",
    "Please select at least one variant value (e.g., Color, Size)": "Seleccione al menos un valor de variante (por ejemplo, Color, Tamaño)",
    "listing_form.valid_price_required": "Introduzca un precio válido",
    "Please enter a valid price": "Introduzca un precio válido",
    "listing_form.delete_variant_confirm": "¿Está seguro de que desea eliminar esta variante?",
    "Are you sure you want to delete this variant?": "¿Está seguro de que desea eliminar esta variante?",
    "listing_form.product_variants": "Variantes del producto",
    "Product Variants": "Variantes del producto",
    "listing_form.add_variant": "+ Añadir variante",
    "+ Add Variant": "+ Añadir variante",
    "listing_form.select_all_variants": "Seleccionar todas las variantes",
    "Select all variants": "Seleccionar todas las variantes",
    "listing_form.set_quantity_selected": "Establecer cantidad para seleccionadas",
    "Set quantity for selected": "Establecer cantidad para seleccionadas",
    "listing_form.quantity": "Cantidad",
    "listing_form.apply_quantity": "Aplicar cantidad",
    "Apply quantity": "Aplicar cantidad",
    "listing_form.select_variant_number": "Seleccione la variante {number}",
    "Select variant {number}": "Seleccione la variante {number}",
    "listing_form.variant_number": "Variante #{number}",
    "Variant #{number}": "Variante #{number}",
    "listing_form.existing": "Existente",
    "Existing": "Existente",
    "listing_form.modified": "Modificado",
    "Modified": "Modificado",
    "listing_form.variant_name": "Nombre de la variante",
    "Variant Name": "Nombre de la variante",
    "listing_form.variant_values": "Valores de variante",
    "Variant Values": "Valores de variante",
    "listing_form.type": "Tipo",
    "listing_form.no_variant_values": "Sin valores de variante",
    "No variant values": "Sin valores de variante",
    "listing_form.no_variants_yet": "Aún no hay variantes",
    "No variants yet": "Aún no hay variantes",
    "listing_form.click_add_variant_help": "Haga clic en \"{action}\" para crear su primera variante",
    "Click \"{action}\" to create your first variant": "Haga clic en \"{action}\" para crear su primera variante",
    "listing_form.select_variant_type": "Seleccione {type}",
    "Select {type}": "Seleccione {type}",
    "listing_form.no_variant_types": "No hay tipos de variante disponibles. Cree primero los tipos de variante (como Color, Tamaño).",
    "No variant types available. Please create variant types (like Color, Size) first.": "No hay tipos de variante disponibles. Cree primero los tipos de variante (como Color, Tamaño).",
    "listing_form.generated_name": "Nombre generado:",
    "Generated Name:": "Nombre generado:",
    "listing_form.custom_title": "Título personalizado",
    "Custom Title": "Título personalizado",
    "listing_form.auto_generate_help": "Deje en blanco para generar automáticamente",
    "Leave blank to auto-generate": "Deje en blanco para generar automáticamente",
    "listing_form.save_variant": "Guardar variante",
    "Save Variant": "Guardar variante",
    "listing_form.start_time": "Hora de inicio",
    "Start Time": "Hora de inicio",
    "listing_form.end_time": "Hora de finalización",
    "End Time": "Hora de finalización",
    "listing_form.enter_capacity_limit": "Introduzca el límite de capacidad",
    "Enter capacity limit": "Introduzca el límite de capacidad",
    "collections.validation_title": "El título no puede estar vacío",
    "Title should not be empty": "El título no puede estar vacío",
    "collections.validation_platform": "Seleccione al menos una plataforma",
    "Select at least one platform": "Seleccione al menos una plataforma",
    "collections.validation_dates": "La fecha de finalización debe ser posterior a la fecha de inicio",
    "End Date must be later than start date": "La fecha de finalización debe ser posterior a la fecha de inicio",
    "collections.validation_minimum_selection": "Seleccione al menos un {type}",
    "Select at least one {type}": "Seleccione al menos un {type}",
    "collections.account": "cuenta",
    "account": "cuenta",
    "collections.listing": "listado",
    "listing": "listado",
    "collections.edit_title": "Editar colección",
    "Edit Collection": "Editar colección",
    "collections.create_title": "Crear colección",
    "Create Collection": "Crear colección",
    "collections.details": "Detalles de la colección",
    "Collection details": "Detalles de la colección",
    "collections.title_placeholder": "Ingrese nombre del título",
    "Enter title name": "Ingrese nombre del título",
    "collections.slug": "Slug",
    "collections.slug_placeholder": "Ingrese slug",
    "collections.enter_title_first": "Por favor, ingrese un título primero",
    "collections.scope": "Alcance",
    "collections.accounts": "Cuentas",
    "collections.listings": "Listados",
    "collections.choose_category": "Elegir categoría",
    "collections.conditions": "Condiciones",
    "Conditions": "Condiciones",
    "collections.condition_type": "Tipo de condición",
    "Condition type": "Tipo de condición",
    "collections.manual": "Manual",
    "Manual": "Manual",
    "collections.automated": "Automático",
    "Automated": "Automático",
    "collections.availability": "Disponibilidad de colecciones",
    "Collections availability": "Disponibilidad de colecciones",
    "collections.schedule": "Programación",
    "collections.applicable_channels": "Seleccionar canal aplicable",
    "Select applicable channel": "Seleccionar canal aplicable",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Buscar por nombre",
    "Search by name": "Buscar por nombre",
    "collections.not_found": "Colección no encontrada.",
    "Collection not found.": "Colección no encontrada.",
    "collections.featured_listings": "Listados destacados",
    "Featured listings": "Listados destacados",
    "collections.url_copied": "URL pública copiada",
    "Public URL copied": "URL pública copiada",
    "collections.url_copy_failed": "No se puede copiar la URL pública",
    "Unable to copy the public URL": "No se puede copiar la URL pública",
    "collections.collection": "Colección",
    "Collection": "Colección",
    "collections.this_collection": "esta colección",
    "this collection": "esta colección",
    "collections.share_text": "Ver {title}",
    "View {title}": "Ver {title}",
    "collections.public_url": "URL pública:",
    "Public URL:": "URL pública:",
    "collections.copy_url": "Copiar URL",
    "Copy URL": "Copiar URL",
    "collections.items": "Elementos",
    "collections.expires": "Caduca",
    "Expires": "Caduca",
    "collections.never": "Nunca",
    "Never": "Nunca",
    "collections.automatic_conditions": "Condiciones automáticas",
    "Automatic Conditions": "Condiciones automáticas",
    "collections.item_count": "{count} elementos",
    "{count} items": "{count} elementos",
    "collections.loading_items": "Cargando elementos…",
    "Loading items…": "Cargando elementos…",
    "collections.no_items": "Aún no hay elementos en esta colección.",
    "No items in this collection yet.": "Aún no hay elementos en esta colección.",
    "collections.delete_confirm": "¿Quieres eliminar esta colección?",
    "Do you want to delete this collection?": "¿Quieres eliminar esta colección?",
    "collections.title": "Colecciones",
    "collections.header_title": "Título",
    "collections.header_action": "Acción",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Tipo de condición",
    "Condition Type": "Tipo de condición",
    "collections.header_scope": "Alcance",
    "collections.header_start_date": "Fecha de inicio",
    "collections.header_end_date": "Fecha de finalización",
    "collections.header_status": "Estado",
    "collections.header_url": "URL",
    "common.calendar_view": "Vista de calendario",
    "Calendar view": "Vista de calendario",
    "common.deleted": "Eliminado",
    "Deleted": "Eliminado",
    "common.list_view": "Vista de lista",
    "common.description": "Descripción",
    "common.title": "Título",
    "common.end_date": "Fecha de finalización",
    "common.start_date": "Fecha de inicio",
    "promotions.image_required": "Por favor, añade una imagen",
    "Please add an image": "Por favor, añade una imagen",
    "promotions.edit_title": "Editar promoción",
    "Edit Promotion": "Editar promoción",
    "promotions.add_title": "Agregar promoción",
    "Add Promotion": "Agregar promoción",
    "promotions.name": "Nombre de la promoción",
    "Promotion Name": "Nombre de la promoción",
    "promotions.select_medium": "Seleccionar medio",
    "Select Medium": "Seleccionar medio",
    "promotions.upload_media": "Subir medio",
    "promotions.schedule": "Programar",
    "promotions.destination_type": "Tipo de destino",
    "Destination Type": "Tipo de destino",
    "promotions.placement": "Ubicación",
    "Placement": "Ubicación",
    "promotions.status": "Estado (Inactivo / Activo)",
    "promotions.delete_confirm": "¿Quieres eliminar esta promoción?",
    "Do you want to delete this promotion?": "¿Quieres eliminar esta promoción?",
    "promotions.title": "Promociones",
    "promotions.header_image": "Imagen",
    "promotions.header_medium": "Medio",
    "promotions.header_placement": "Ubicación",
    "promotions.header_type": "Tipo",
    "promotions.header_value": "Valor",
    "promotions.header_active": "Activo",
    "promotions.header_action": "Acción",
    "promotions.header_start_at": "Comienzo a",
    "Start At": "Comienzo a",
    "promotions.header_end_at": "Finaliza a",
    "End At": "Finaliza a",
    "common.grid_view": "Vista de cuadrícula",
    "promotions.type_general": "General",
    "promotions.type_listing": "Listado",
    "promotions.type_account": "Cuenta",
    "promotions.type_external_link": "Enlace externo",
    "External link": "Enlace externo",
    "promotions.preview": "Vista previa",
    "promotions.select_listing": "Seleccionar lista",
    "Select Listing": "Seleccionar lista",
    "promotions.select_account": "Seleccionar Cuenta",
    "promotions.home_placement": "Inicio",
    "promotions.footer_placement": "Pie de página",
    "Footer": "Pie de página",
    "promotions.web_only": "(Solo web)",
    "(Web Only)": "(Solo web)",
    "coupons.edit_title": "Editar Cupón",
    "Edit Coupon": "Editar Cupón",
    "coupons.add_title": "Agregar Cupón",
    "Add Coupon": "Agregar Cupón",
    "coupons.reference_name": "Nombre de referencia",
    "Reference Name": "Nombre de referencia",
    "coupons.enter_name": "Ingrese nombre",
    "coupons.coupon_type": "Tipo de cupón",
    "Coupon type": "Tipo de cupón",
    "coupons.discount_value": "Valor de descuento",
    "Discount Value": "Valor de descuento",
    "coupons.enter_discount_value": "Ingrese valor de descuento",
    "Enter discount value": "Ingrese valor de descuento",
    "coupons.code": "Código",
    "coupons.code_example": "Ej: HOLIDAY10",
    "Ex: HOLIDAY10": "Ej: HOLIDAY10",
    "coupons.short_code": "Código corto",
    "coupons.enter_short_code": "Ingrese código corto",
    "coupons.advanced": "AVANZADO",
    "ADVANCED": "AVANZADO",
    "coupons.minimum_amount": "Monto mínimo",
    "coupons.enter_minimum_amount": "Ingrese monto mínimo",
    "coupons.maximum_amount": "Monto máximo",
    "coupons.enter_maximum_amount": "Ingrese monto máximo",
    "coupons.maximum_discount_amount": "Monto máximo de descuento",
    "Maximum Discount Amount": "Monto máximo de descuento",
    "coupons.enter_maximum_discount_amount": "Ingrese monto máximo de descuento",
    "Enter maximum discount amount": "Ingrese monto máximo de descuento",
    "coupons.maximum_uses": "Máximo de usos",
    "Maximum Uses": "Máximo de usos",
    "coupons.enter_maximum_uses": "Introducir usos máximos",
    "Enter maximum uses": "Introducir usos máximos",
    "coupons.maximum_uses_per_user": "Usos máximos por usuario",
    "Maximum Uses Per User": "Usos máximos por usuario",
    "coupons.enter_maximum_uses_per_user": "Introducir usos máximos por usuario",
    "Enter maximum uses per user": "Introducir usos máximos por usuario",
    "coupons.new_user_only": "Nuevo usuario",
    "New User": "Nuevo usuario",
    "coupons.enter_note": "Introducir nota",
    "coupons.start_date_time": "Fecha y hora de inicio",
    "Start Date Time": "Fecha y hora de inicio",
    "coupons.end_date_time": "Fecha y hora de finalización",
    "End Date Time": "Fecha y hora de finalización",
    "coupons.select_start_date_time": "Seleccionar fecha y hora de inicio",
    "Select start date time": "Seleccionar fecha y hora de inicio",
    "coupons.select_end_date_time": "Seleccionar fecha y hora de finalización",
    "Select end date time": "Seleccionar fecha y hora de finalización",
    "coupons.flat_example": "Plano (Ej: $10)",
    "Flat (Ex: $10)": "Plano (Ej: $10)",
    "coupons.percentage_example": "Porcentaje (Ej: 10%)",
    "Percentage (Ex: 10%)": "Porcentaje (Ej: 10%)",
    "coupons.delete_confirm": "¿Quieres eliminar este cupón?",
    "Do you want to delete this coupon?": "¿Quieres eliminar este cupón?",
    "coupons.title": "Cupones",
    "coupons.header_name": "Nombre",
    "coupons.header_code": "Código",
    "coupons.header_coupon_type": "Tipo de cupón",
    "Coupon Type": "Tipo de cupón",
    "coupons.header_start_date_time": "Fecha y hora de inicio",
    "coupons.header_end_date_time": "Fecha y hora de finalización",
    "coupons.header_active": "Activo",
    "coupons.header_action": "Acción",
    "coupons.load_error": "No se puede cargar este cupón.",
    "Unable to load this coupon.": "No se puede cargar este cupón.",
    "coupons.expired": "Caducado",
    "coupons.total_orders": "Pedidos totales",
    "coupons.unique_customers": "Clientes únicos",
    "Unique Customers": "Clientes únicos",
    "coupons.revenue": "Ingresos",
    "coupons.average_transaction": "Promedio de transacción",
    "Avg Transaction": "Promedio de transacción",
    "coupons.paid_orders": "Pedidos pagados",
    "coupons.uses_remaining": "Usos restantes",
    "Uses Remaining": "Usos restantes",
    "coupons.unlimited": "Ilimitado",
    "Unlimited": "Ilimitado",
    "coupons.performance": "Rendimiento",
    "Performance": "Rendimiento",
    "coupons.usage_against_limit": "Uso contra límite",
    "Usage against limit": "Uso contra límite",
    "coupons.details": "Detalles",
    "coupons.discount": "Descuento",
    "coupons.minimum_order": "Pedido mínimo",
    "Min order": "Pedido mínimo",
    "coupons.maximum_discount": "Máximo descuento",
    "Max discount": "Máximo descuento",
    "coupons.maximum_total_uses": "Máximo usos totales",
    "Max total uses": "Máximo usos totales",
    "coupons.maximum_per_user": "Máximo / usuario",
    "Max / user": "Máximo / usuario",
    "coupons.new_users_only": "Solo nuevos usuarios",
    "New users only": "Solo nuevos usuarios",
    "coupons.valid_from": "Válido desde",
    "Valid from": "Válido desde",
    "coupons.valid_until": "Válido hasta",
    "Valid until": "Válido hasta",
    "coupons.orders": "Pedidos",
    "coupons.no_orders": "Aún no se ha utilizado este cupón en ningún pedido",
    "No orders have used this coupon yet": "Aún no se ha utilizado este cupón en ningún pedido",
    "coupons.orders_header_order": "Pedido",
    "coupons.orders_header_customer": "Cliente",
    "coupons.orders_header_date": "Fecha",
    "coupons.orders_header_amount": "Monto",
    "coupons.orders_header_status": "Estado",
    "coupons.paid": "Pagado",
    "coupons.pending": "Pendiente",
    "coupons.coupon": "Cupón",
    "coupons.detail_title": "Detalles del cupón",
    "Coupon Detail": "Detalles del cupón",
    "coupons.discount_percentage": "{value}% de descuento",
    "{value}% off": "{value}% de descuento",
    "coupons.discount_flat": "{value} de descuento fijo",
    "{value} flat off": "{value} de descuento fijo",
    "coupons.type_direct_discount": "Descuento directo",
    "Direct discount": "Descuento directo",
    "collections.condition_and": "Y",
    "AND": "Y",
    "collections.condition_or": "O",
    "OR": "O",
    "users.first_seen": "Primera vez visto",
    "First seen": "Primera vez visto",
    "users.last_seen": "Última vez visto",
    "Last seen": "Última vez visto",
    "users.avg_order": "Pedido promedio",
    "Avg order": "Pedido promedio",
    "users.purchase_value": "Valor de compra",
    "Purchase value": "Valor de compra",
    "users.price_range": "Rango de precios",
    "Price range": "Rango de precios",
    "users.attributes": "Atributos",
    "users.detail_title": "Detalles del usuario",
    "User Detail": "Detalles del usuario",
    "users.detail_orders_list": "Lista de pedidos del usuario",
    "User Orders List": "Lista de pedidos del usuario",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "Como comprador",
    "As a Buyer": "Como comprador",
    "users.as_seller": "Como vendedor",
    "As a Seller": "Como vendedor",
    "users.health": "Salud",
    "users.no_listings": "Aún no hay listados",
    "users.no_accounts": "Aún no hay cuentas",
    "No accounts yet": "Aún no hay cuentas",
    "users.top_categories": "Categorías principales",
    "Top categories": "Categorías principales",
    "users.top_listings": "Listados principales",
    "Top listings": "Listados principales",
    "users.recent_activity": "Actividad reciente",
    "Recent activity": "Actividad reciente",
    "users.acquisition": "Adquisición",
    "Acquisition": "Adquisición",
    "users.sent_emails": "Correos enviados",
    "Sent Emails": "Correos enviados",
    "users.no_emails_sent": "No se han enviado correos",
    "No emails sent": "No se han enviado correos",
    "users.load_more_emails": "Cargar más ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Cargar más ({loaded} / {total})",
    "users.email_to": "Para: {email}",
    "To: {email}": "Para: {email}",
    "users.sending_email": "Enviando…",
    "users.send_email": "Enviar correo",
    "Send Email": "Enviar correo",
    "users.send_email_title": "Enviar correo — {name}",
    "Send Email — {name}": "Enviar correo — {name}",
    "users.customer": "Cliente",
    "users.block_named": "Bloquear {name}",
    "Block {name}": "Bloquear {name}",
    "users.unblock_named": "Desbloquear {name}",
    "Unblock {name}": "Desbloquear {name}",
    "users.email_sent": "Correo enviado con éxito",
    "Email sent successfully": "Correo enviado con éxito",
    "users.email_send_failed": "No se pudo enviar el correo",
    "Failed to send email": "No se pudo enviar el correo",
    "common.value": "Valor",
    "users.email_bounced": "Rebotado",
    "Bounced": "Rebotado",
    "users.email_complained": "Queja",
    "Complained": "Queja",
    "users.unverified": "No verificado",
    "Unverified": "No verificado",
    "users.otp_enabled": "OTP habilitado",
    "OTP Enabled": "OTP habilitado",
    "users.account_info": "Información de cuenta",
    "Account Info": "Información de cuenta",
    "users.mobile": "Móvil",
    "users.locale": "Idioma",
    "Locale": "Idioma",
    "users.joined": "Ingresado",
    "users.following": "Siguiendo",
    "Following": "Siguiendo",
    "users.email_health": "Salud del correo",
    "Email Health": "Salud del correo",
    "users.orders": "Pedidos",
    "users.no_orders": "Sin pedidos",
    "No orders": "Sin pedidos",
    "users.order_reference": "Pedido {number}",
    "Order {number}": "Pedido {number}",
    "users.order_ref": "Ref: {reference}",
    "Ref: {reference}": "Ref: {reference}",
    "users.unpaid": "Sin pagar",
    "users.revenue_ltv": "Ingresos y LTV",
    "Revenue & LTV": "Ingresos y LTV",
    "users.total_spent": "Total gastado",
    "Total Spent": "Total gastado",
    "users.paid_order_count": "{count} pedidos pagados",
    "{count} paid orders": "{count} pedidos pagados",
    "users.average_order": "Promedio de pedido",
    "users.of_total_orders": "de {count} total",
    "of {count} total": "de {count} total",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} activos",
    "{count} active": "{count} activos",
    "users.at_risk": "En riesgo",
    "At Risk": "En riesgo",
    "common.today": "Hoy",
    "common.yesterday": "Ayer",
    "Yesterday": "Ayer",
    "users.days_ago": "{count} días atrás",
    "{count} days ago": "{count} días atrás",
    "users.months_ago": "{count} meses atrás",
    "{count} months ago": "{count} meses atrás",
    "users.years_ago": "{count} años atrás",
    "{count} years ago": "{count} años atrás",
    "users.last_order": "Último pedido",
    "Last order": "Último pedido",
    "users.last_listing": "Última lista",
    "Last listing": "Última lista",
    "users.events": "Eventos",
    "users.viewed": "Visto",
    "Viewed": "Visto",
    "users.cart": "Carrito",
    "users.checkouts": "Compras",
    "Checkouts": "Compras",
    "users.purchases": "Compras",
    "Purchases": "Compras",
    "users.last_30_days": "Últimos 30 días",
    "Last 30 days": "Últimos 30 días",
    "users.no_analytics": "No hay datos de análisis para este usuario aún.",
    "No analytics data for this user yet.": "No hay datos de análisis para este usuario aún.",
    "users.analytics_unavailable": "Análisis no disponible para este inquilino.",
    "Analytics unavailable for this tenant.": "Análisis no disponible para este inquilino.",
    "users.account_number": "Cuenta #{number}",
    "Account #{number}": "Cuenta #{number}",
    "users.no_subject": "Sin asunto",
    "No Subject": "Sin asunto",
    "common.unknown": "Desconocido",
    "users.opened": "Abierto",
    "Opened": "Abierto",
    "users.not_opened": "No abierto",
    "Not opened": "No abierto",
    "users.user_action_success": "Acción de usuario completada",
    "User action completed": "Acción de usuario completada",
    "common.pending": "Pendiente",
    "common.never": "Nunca",
    "users.customer_analytics": "Análisis de clientes",
    "Customer Analytics": "Análisis de clientes",
    "users.analytics": "Análisis",
    "users.emails": "Correos electrónicos",
    "Emails": "Correos electrónicos",
    "users.first_visit": "Primera visita",
    "First visit": "Primera visita",
    "users.latest_visit": "Última visita",
    "Latest visit": "Última visita",
    "users.landing_page": "Página de aterrizaje",
    "Landing page": "Página de aterrizaje",
    "users.referrer": "Referente",
    "Referrer": "Referente",
    "users.utm_source": "Fuente UTM",
    "UTM source": "Fuente UTM",
    "users.utm_medium": "Medio UTM",
    "UTM medium": "Medio UTM",
    "users.utm_campaign": "Campaña UTM",
    "UTM campaign": "Campaña UTM",
    "users.utm_term": "Término UTM",
    "UTM term": "Término UTM",
    "users.utm_content": "Contenido UTM",
    "UTM content": "Contenido UTM",
    "users.ai_source": "Origen de IA",
    "AI source": "Origen de IA",
    "rewards.edit_scope": "Editar ámbito",
    "Edit scope": "Editar ámbito",
    "rewards.add_scope": "Añadir ámbito",
    "Add scope": "Añadir ámbito",
    "rewards.save_scope": "Guardar ámbito",
    "Save scope": "Guardar ámbito",
    "rewards.scope_type": "Tipo de ámbito",
    "Scope type": "Tipo de ámbito",
    "rewards.scope_reference": "Referencia de ámbito",
    "Scope reference": "Referencia de ámbito",
    "rewards.match_config": "Configuración de coincidencia",
    "Match config": "Configuración de coincidencia",
    "rewards.priority_order": "Orden de prioridad",
    "Priority order": "Orden de prioridad",
    "rewards.active": "Activo",
    "rewards.scope_active": "El ámbito está activo",
    "Scope is active": "El ámbito está activo",
    "rewards.edit_rule": "Editar regla",
    "Edit rule": "Editar regla",
    "rewards.add_rule": "Añadir regla",
    "Add rule": "Añadir regla",
    "rewards.save_rule": "Guardar regla",
    "Save rule": "Guardar regla",
    "rewards.trigger_event": "Evento de activación",
    "Trigger event": "Evento de activación",
    "rewards.beneficiary_type": "Tipo de beneficiario",
    "Beneficiary type": "Tipo de beneficiario",
    "rewards.beneficiary_config": "Configuración del beneficiario",
    "Beneficiary config": "Configuración del beneficiario",
    "rewards.eligibility": "Elegibilidad",
    "Eligibility": "Elegibilidad",
    "rewards.conditions": "Condiciones",
    "rewards.priority": "Prioridad",
    "Priority": "Prioridad",
    "rewards.edit_component": "Editar componente de receta",
    "Edit recipe component": "Editar componente de receta",
    "rewards.add_component": "Añadir componente de receta",
    "Add recipe component": "Añadir componente de receta",
    "rewards.save_component": "Guardar componente",
    "Save component": "Guardar componente",
    "rewards.rule": "Regla",
    "Rule": "Regla",
    "rewards.component_key": "Clave del componente",
    "Component key": "Clave del componente",
    "rewards.component_type": "Tipo de componente",
    "Component type": "Tipo de componente",
    "rewards.commission_definition": "Definición de comisión",
    "Commission definition": "Definición de comisión",
    "rewards.config": "Config",
    "rewards.position": "Posición",
    "Position": "Posición",
    "rewards.component": "Componente",
    "Component": "Componente",
    "rewards.status.draft": "Borrador",
    "rewards.status.active": "Activo",
    "rewards.status.paused": "Pausado",
    "Paused": "Pausado",
    "rewards.status.archived": "Archivado",
    "rewards.configuration_updated": "Configuración de recompensa actualizada",
    "Reward configuration updated": "Configuración de recompensa actualizada",
    "rewards.configuration_added": "Configuración de recompensa agregada",
    "Reward configuration added": "Configuración de recompensa agregada",
    "rewards.archive_item_confirm": "¿Archivar {name}?",
    "Archive {name}?": "¿Archivar {name}?",
    "rewards.empty_scopes": "No hay ámbitos configurados aún.",
    "No scopes configured yet.": "No hay ámbitos configurados aún.",
    "rewards.empty_rules": "No hay reglas configuradas aún.",
    "No rules configured yet.": "No hay reglas configuradas aún.",
    "rewards.empty_components": "No hay componentes configurados aún.",
    "No components configured yet.": "No hay componentes configurados aún.",
    "rewards.edit_program": "Editar programa de recompensas",
    "Edit reward program": "Editar programa de recompensas",
    "rewards.new_program": "Nuevo programa de recompensas",
    "New reward program": "Nuevo programa de recompensas",
    "rewards.create_program": "Crear programa",
    "Create program": "Crear programa",
    "rewards.program_type": "Tipo de programa",
    "Program type": "Tipo de programa",
    "rewards.starts_at": "Comienza a",
    "Starts at": "Comienza a",
    "rewards.ends_at": "Termina a",
    "Ends at": "Termina a",
    "rewards.program_updated": "Programa de recompensas actualizado",
    "Reward program updated": "Programa de recompensas actualizado",
    "rewards.program_created": "Programa de recompensas creado",
    "Reward program created": "Programa de recompensas creado",
    "rewards.archive_program_confirm": "¿Archivar {name}?",
    "rewards.program_archived": "Programa de recompensas archivado",
    "Reward program archived": "Programa de recompensas archivado",
    "rewards.tab.overview": "Resumen",
    "rewards.tab.programs": "Programas",
    "Programs": "Programas",
    "rewards.tab.impact": "Impacto",
    "Impact": "Impacto",
    "rewards.tab.attribution": "Seguimiento",
    "Tracking": "Seguimiento",
    "rewards.page_description": "Crea y gestiona programas de recompensas, configuraciones de elegibilidad, reglas de recompensas y recetas de recompensas. Los pedidos completados se añaden automáticamente a tus informes.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Crea y gestiona programas de recompensas, configuraciones de elegibilidad, reglas de recompensas y recetas de recompensas. Los pedidos completados se añaden automáticamente a tus informes.",
    "rewards.program": "Programa",
    "Program": "Programa",
    "rewards.starts": "Comienza",
    "Starts": "Comienza",
    "rewards.no_programs": "Aún no hay programas de recompensas.",
    "No reward programs yet.": "Aún no hay programas de recompensas.",
    "rewards.program_title": "Programa de recompensas",
    "Reward program": "Programa de recompensas",
    "rewards.back_to_rewards": "Volver a recompensas",
    "Back to rewards": "Volver a recompensas",
    "common.archive": "Archivar",
    "Archive": "Archivar",
    "common.save_changes": "Guardar cambios",
    "common.none": "Ninguno",
    "common.this_item": "este elemento",
    "this item": "este elemento",
    "rewards.tab.scopes": "Ámbitos",
    "Scopes": "Ámbitos",
    "rewards.tab.rules": "Reglas",
    "Rules": "Reglas",
    "rewards.tab.components": "Componentes de receta",
    "Recipe components": "Componentes de receta",
    "rewards.reference": "Referencia",
    "rewards.trigger": "Disparador",
    "Trigger": "Disparador",
    "rewards.beneficiary": "Beneficiario",
    "Beneficiary": "Beneficiario",
    "rewards.attributed_conversions": "Conversiones atribuidas",
    "Attributed conversions": "Conversiones atribuidas",
    "rewards.new_customers": "Nuevos clientes",
    "New customers": "Nuevos clientes",
    "rewards.revenue_influenced": "Ingresos influenciados",
    "Revenue influenced": "Ingresos influenciados",
    "rewards.rewards_issued": "Recompensas emitidas",
    "Rewards issued": "Recompensas emitidas",
    "rewards.live_business_results": "Resultados comerciales en vivo",
    "Live business results": "Resultados comerciales en vivo",
    "rewards.impact_at_a_glance": "Impacto a primera vista",
    "Impact at a glance": "Impacto a primera vista",
    "rewards.impact_last_30_days": "Vista en vivo de pedidos completados y resultados de socios de los últimos 30 días.",
    "A live view of completed orders and partner results from the last 30 days.": "Vista en vivo de pedidos completados y resultados de socios de los últimos 30 días.",
    "rewards.view_full_impact": "Ver impacto completo",
    "View full impact": "Ver impacto completo",
    "rewards.impact_load_error": "No se pudieron cargar los datos de impacto: {error}",
    "Impact data could not be loaded: {error}": "No se pudieron cargar los datos de impacto: {error}",
    "rewards.programs": "Programas",
    "rewards.programs_configured": "Programas de recompensas configurados para este espacio de trabajo.",
    "Reward programs configured for this workspace.": "Programas de recompensas configurados para este espacio de trabajo.",
    "rewards.programs_eligible": "Programas actualmente elegibles para evaluación.",
    "Programs currently eligible for evaluation.": "Programas actualmente elegibles para evaluación.",
    "rewards.drafts": "Borradores",
    "Drafts": "Borradores",
    "rewards.programs_being_configured": "Programas aún en configuración.",
    "Programs still being configured.": "Programas aún en configuración.",
    "rewards.clicks": "Clics",
    "rewards.completed_orders": "Pedidos completados",
    "Completed orders": "Pedidos completados",
    "rewards.conversion_rate": "Tasa de conversión",
    "Conversion rate": "Tasa de conversión",
    "rewards.revenue": "Ingresos",
    "rewards.live_connection": "Conexión en vivo",
    "Live connection": "Conexión en vivo",
    "rewards.attribution_activity": "Actividad de atribución",
    "Attribution activity": "Actividad de atribución",
    "rewards.connected_workspace": "Conectado a {name}.",
    "Connected to {name}.": "Conectado a {name}.",
    "rewards.your_attribution_workspace": "tu espacio de trabajo de Atribución",
    "your Attribution workspace": "tu espacio de trabajo de Atribución",
    "rewards.loading_workspace": "Cargando tu espacio de trabajo de Atribución conectado.",
    "Loading your connected Attribution workspace.": "Cargando tu espacio de trabajo de Atribución conectado.",
    "rewards.open_attribution": "Abrir Atribución",
    "Open Attribution": "Abrir Atribución",
    "rewards.connection_attention": "La conexión requiere atención",
    "Connection needs attention": "La conexión requiere atención",
    "rewards.open_attribution_workspace": "Abrir espacio de trabajo de Atribución",
    "Open Attribution workspace": "Abrir espacio de trabajo de Atribución",
    "rewards.workspace_connected": "Espacio de trabajo conectado",
    "Workspace connected": "Espacio de trabajo conectado",
    "rewards.workspace_not_linked": "Espacio de trabajo no vinculado aún",
    "Workspace not linked yet": "Espacio de trabajo no vinculado aún",
    "rewards.attribution_data_connected": "Se están leyendo los clics en vivo, enlaces, campañas y pedidos completados desde la Atribución.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Se están leyendo los clics en vivo, enlaces, campañas y pedidos completados desde la Atribución.",
    "rewards.connect_workspace_prompt": "Abra Atribución para conectar este espacio de trabajo antes de rastrear la actividad.",
    "Open Attribution to connect this workspace before tracking activity.": "Abra Atribución para conectar este espacio de trabajo antes de rastrear la actividad.",
    "rewards.successful_referrals": "Referidos exitosos",
    "Successful referrals": "Referidos exitosos",
    "rewards.new_customers_acquired": "Nuevos clientes adquiridos",
    "New customers acquired": "Nuevos clientes adquiridos",
    "rewards.gross_revenue_influenced": "Ingresos brutos influenciados",
    "Gross revenue influenced": "Ingresos brutos influenciados",
    "rewards.reward_cost": "Costo de recompensa",
    "Reward cost": "Costo de recompensa",
    "rewards.net_revenue": "Ingresos netos",
    "Net revenue": "Ingresos netos",
    "rewards.average_order_value": "Valor promedio de pedido",
    "Average order value": "Valor promedio de pedido",
    "rewards.cost_per_acquisition": "Costo por adquisición",
    "Cost per acquisition": "Costo por adquisición",
    "rewards.repeat_purchase_rate": "Tasa de compra repetida",
    "Repeat purchase rate": "Tasa de compra repetida",
    "rewards.business_outcome_reporting": "Informes de resultados comerciales",
    "Business outcome reporting": "Informes de resultados comerciales",
    "rewards.impact": "Impacto",
    "rewards.impact_description": "Conversiones, adquisición de clientes, ingresos influenciados y costo de recompensa del período seleccionado.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Conversiones, adquisición de clientes, ingresos influenciados y costo de recompensa del período seleccionado.",
    "rewards.from": "Desde",
    "rewards.to": "Hasta",
    "rewards.trend": "Tendencia",
    "Trend": "Tendencia",
    "rewards.daily": "Diario",
    "rewards.weekly": "Semanal",
    "Weekly": "Semanal",
    "rewards.top_partners": "Principales socios / referidores",
    "Top partners / referrers": "Principales socios / referidores",
    "rewards.partner": "Socio",
    "Partner": "Socio",
    "rewards.conversions": "Conversiones",
    "Conversions": "Conversiones",
    "rewards.no_partner_data": "No hay datos de socio atribuidos para este período.",
    "No attributed partner data for this period.": "No hay datos de socio atribuidos para este período.",
    "rewards.period": "Período",
    "rewards.no_trend_data": "No hay datos de tendencia para este período.",
    "No trend data for this period.": "No hay datos de tendencia para este período.",
    "rewards.campaign_performance": "Rendimiento de la campaña",
    "Campaign performance": "Rendimiento de la campaña",
    "rewards.campaign_count": "{count} campañas",
    "{count} campaigns": "{count} campañas",
    "rewards.campaign": "Campaña",
    "rewards.orders": "Pedidos",
    "rewards.rate": "Tasa",
    "Rate": "Tasa",
    "rewards.no_campaign_activity": "Aún no hay actividad de campaña. Crea un enlace de seguimiento en Atribución para comenzar a medir resultados.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Aún no hay actividad de campaña. Crea un enlace de seguimiento en Atribución para comenzar a medir resultados.",
    "rewards.recent_completed_orders": "Pedidos completados recientes",
    "Recent completed orders": "Pedidos completados recientes",
    "rewards.recent_events_count": "{count} eventos recientes",
    "{count} recent events": "{count} eventos recientes",
    "rewards.event": "Evento",
    "rewards.completed_order": "Pedido completado",
    "Completed order": "Pedido completado",
    "rewards.no_completed_order_activity": "Aún no ha llegado actividad de pedidos completados.",
    "No completed order activity has arrived yet.": "Aún no ha llegado actividad de pedidos completados.",
    "rewards.impact_data_quality_note": "El volumen de clics y la tasa de conversión permanecen no disponibles aquí hasta que se conecte el agregado de clics de Atribución. El costo de recompensa utiliza filas aprobadas o emitidas en el registro de recompensas; los reembolsos aún no se incluyen.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "El volumen de clics y la tasa de conversión permanecen no disponibles aquí hasta que se conecte el agregado de clics de Atribución. El costo de recompensa utiliza filas aprobadas o emitidas en el registro de recompensas; los reembolsos aún no se incluyen.",
    "subscriptions.type.free": "Suscripción gratuita",
    "Free Subscription": "Suscripción gratuita",
    "subscriptions.form.title_placeholder": "Título de suscripción",
    "Subscription Title": "Título de suscripción",
    "subscriptions.form.title_help": "Ingrese un título descriptivo para el paquete de suscripción (por ejemplo, “Plan Premium”, “Nivel Básico”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Ingrese un título descriptivo para el paquete de suscripción (por ejemplo, “Plan Premium”, “Nivel Básico”).",
    "subscriptions.form.description_placeholder": "Descripción de suscripción",
    "Subscription Description": "Descripción de suscripción",
    "subscriptions.form.description_help": "Proporcione una descripción detallada de la suscripción, indicando sus características y beneficios.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Proporcione una descripción detallada de la suscripción, indicando sus características y beneficios.",
    "subscriptions.form.select_currency": "Seleccionar moneda",
    "Select Currency": "Seleccionar moneda",
    "subscriptions.form.currency_help": "Seleccione la moneda de la suscripción desde el menú desplegable (Su moneda predeterminada)",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Seleccione la moneda de la suscripción desde el menú desplegable (Su moneda predeterminada)",
    "subscriptions.form.amount_placeholder": "Monto de suscripción",
    "Subscription Amount": "Monto de suscripción",
    "subscriptions.form.amount_help": "Ingrese el precio de la suscripción.",
    "Enter the subscription price.": "Ingrese el precio de la suscripción.",
    "subscriptions.form.sku_placeholder": "SKU de suscripción",
    "Subscription SKU": "SKU de suscripción",
    "subscriptions.form.sku_help": "Introduce un identificador único para la suscripción (a menudo utilizado para simplificar los datos, garantizar la unicidad y el seguimiento).",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Introduce un identificador único para la suscripción (a menudo utilizado para simplificar los datos, garantizar la unicidad y el seguimiento).",
    "subscriptions.form.allowed_listings": "Listados permitidos",
    "Allowed Listings": "Listados permitidos",
    "subscriptions.form.allowed_listings_placeholder": "Listados permitidos para suscripción",
    "Subscription Allowed Listings": "Listados permitidos para suscripción",
    "subscriptions.form.allowed_listings_help": "Especifica el número de listados permitidos para esta suscripción.",
    "Specify the number of listings allowed for this subscription.": "Especifica el número de listados permitidos para esta suscripción.",
    "subscriptions.form.fixed_fee_per_order": "Tarifa fija por pedido",
    "Fixed Fee Per Order": "Tarifa fija por pedido",
    "subscriptions.form.fixed_fee_placeholder": "Tarifa fija por pedido",
    "Subscription Fee Fixed Per Order": "Tarifa fija por pedido",
    "subscriptions.form.fixed_fee_help": "Introduce una tarifa fija por pedido, si es aplicable.",
    "Enter a fixed fee per order, if applicable.": "Introduce una tarifa fija por pedido, si es aplicable.",
    "subscriptions.form.commission_percent_per_order": "Comisión % por pedido",
    "Commission % Per Order": "Comisión % por pedido",
    "subscriptions.form.commission_placeholder": "Comisión de suscripción por pedido",
    "Subscription Commission Percent Per Order": "Comisión de suscripción por pedido",
    "subscriptions.form.commission_help": "Introduce el porcentaje de comisión por pedido, si es aplicable.",
    "Enter the commission percentage per order, if applicable.": "Introduce el porcentaje de comisión por pedido, si es aplicable.",
    "subscriptions.form.expiry_days": "Días de caducidad",
    "Expiry Days": "Días de caducidad",
    "subscriptions.form.expiry_days_placeholder": "Días de caducidad de suscripción",
    "Subscription Expiry Days": "Días de caducidad de suscripción",
    "subscriptions.form.expiry_days_help": "Establece el número de días antes de que caduque la suscripción (plan, paquete). Ejemplo: 7 días, 30 días.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Establece el número de días antes de que caduque la suscripción (plan, paquete). Ejemplo: 7 días, 30 días.",
    "subscriptions.form.payment_method": "Método de pago",
    "subscriptions.form.select_type": "Seleccionar tipo",
    "subscriptions.form.payment_method_help": "Selecciona el método de pago(s) admitido(s) para esta suscripción (ej.: Stripe, Mangopay, Android, iOS, Suscripción gratuita).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Selecciona el método de pago(s) admitido(s) para esta suscripción (ej.: Stripe, Mangopay, Android, iOS, Suscripción gratuita).",
    "subscriptions.form.active_placeholder": "Suscripción activa",
    "Subscription Active": "Suscripción activa",
    "subscriptions.form.active_help": "Activa o desactiva la suscripción mediante el interruptor. Una suscripción activa está disponible para compra.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Activa o desactiva la suscripción mediante el interruptor. Una suscripción activa está disponible para compra.",
    "subscriptions.add_title": "Añadir nuevo producto de suscripción",
    "Add new subscription product": "Añadir nuevo producto de suscripción",
    "subscriptions.edit_title": "Editar producto de suscripción",
    "Edit subscription product": "Editar producto de suscripción",
    "subscriptions.added_success": "Listado de suscripción añadido con éxito",
    "Subscription listing added successfully": "Listado de suscripción añadido con éxito",
    "subscriptions.updated_success": "Listado de suscripción actualizado con éxito",
    "Subscription listing updated successfully": "Listado de suscripción actualizado con éxito",
    "common.currency": "Moneda",
    "common.sku": "SKU",
    "subscriptions.title": "Suscripciones",
    "subscriptions.add_subscription": "Agregar suscripción",
    "Add subscription": "Agregar suscripción",
    "subscriptions.plans": "Planes",
    "subscriptions.active_subscribers": "Suscriptores activos",
    "Active Subscribers": "Suscriptores activos",
    "subscriptions.total_mrr": "Total MRR",
    "Total MRR": "Total MRR",
    "subscriptions.churn_rate": "Tasa de abandono",
    "Churn Rate": "Tasa de abandono",
    "subscriptions.new_this_month": "Nuevos este mes",
    "New This Month": "Nuevos este mes",
    "subscriptions.average_duration": "Duración media",
    "Avg Duration": "Duración media",
    "subscriptions.monthly_recurring_revenue": "Ingresos recurrentes mensuales",
    "Monthly Recurring Revenue": "Ingresos recurrentes mensuales",
    "subscriptions.annual_run_rate": "Tasa anual de ejecución",
    "Annual Run Rate": "Tasa anual de ejecución",
    "subscriptions.last_30_days": "Últimos 30 días",
    "subscriptions.subscriber_lifetime": "Duración de la suscripción",
    "Subscriber lifetime": "Duración de la suscripción",
    "subscriptions.subscriber_distribution": "Distribución de suscriptores",
    "Subscriber Distribution": "Distribución de suscriptores",
    "subscriptions.billing_period": "Período de facturación",
    "Billing Period": "Período de facturación",
    "subscriptions.allowed_listings": "Listados permitidos",
    "subscriptions.commission_per_order": "Comisión por pedido",
    "Commission per Order": "Comisión por pedido",
    "subscriptions.fixed_fee_per_order": "Tarifa fija por pedido",
    "Fixed Fee per Order": "Tarifa fija por pedido",
    "subscriptions.payment_provider": "Proveedor de pago",
    "Payment Provider": "Proveedor de pago",
    "subscriptions.sku_product_id": "SKU / ID de producto",
    "SKU / Product ID": "SKU / ID de producto",
    "subscriptions.revenue_over_time": "Ingresos a lo largo del tiempo",
    "Revenue Over Time": "Ingresos a lo largo del tiempo",
    "subscriptions.revenue": "Ingresos",
    "subscriptions.subscriber_growth": "Crecimiento de suscriptores",
    "Subscriber Growth": "Crecimiento de suscriptores",
    "subscriptions.subscribers": "Suscriptores",
    "Subscribers": "Suscriptores",
    "subscriptions.set_inactive": "Establecer inactivo",
    "Set Inactive": "Establecer inactivo",
    "subscriptions.set_active": "Activar",
    "Set Active": "Activar",
    "subscriptions.plan_title": "Plan de suscripción",
    "Subscription Plan": "Plan de suscripción",
    "subscriptions.status.active": "Activo",
    "subscriptions.status.cancelled": "Cancelado",
    "subscriptions.status.expired": "Expirado",
    "subscriptions.status.trial": "Período de prueba",
    "Trial": "Período de prueba",
    "subscriptions.status.pending": "Pendiente",
    "subscriptions.period.lifetime": "De por vida",
    "Lifetime": "De por vida",
    "subscriptions.period.daily": "Diario",
    "subscriptions.period.weekly": "Semanal",
    "subscriptions.period.monthly": "Mensual",
    "Monthly": "Mensual",
    "subscriptions.period.quarterly": "Trimestral",
    "Quarterly": "Trimestral",
    "subscriptions.period.semi_annual": "Semianual",
    "Semi-annual": "Semianual",
    "subscriptions.period.annual": "Anual",
    "Annual": "Anual",
    "subscriptions.period.days": "{count} días",
    "subscriptions.period.day": "/ día",
    "/ day": "/ día",
    "subscriptions.period.week": "/ semana",
    "/ week": "/ semana",
    "subscriptions.period.month": "/ mes",
    "/ month": "/ mes",
    "subscriptions.period.quarter": "/ trimestre",
    "/ quarter": "/ trimestre",
    "subscriptions.period.six_months": "/ 6 meses",
    "/ 6 months": "/ 6 meses",
    "subscriptions.period.year": "/ año",
    "/ year": "/ año",
    "subscriptions.listings_count": "{count} anuncios",
    "{count} listings": "{count} anuncios",
    "subscriptions.commission_percentage": "{rate}% de comisión",
    "{rate}% commission": "{rate}% de comisión",
    "subscriptions.per_order": "/ pedido",
    "/ order": "/ pedido",
    "subscriptions.view_details_subscribers": "Ver detalles y suscriptores",
    "View details and subscribers": "Ver detalles y suscriptores",
    "subscriptions.edit_subscription": "Editar suscripción",
    "Edit subscription": "Editar suscripción",
    "subscriptions.delete_subscription": "Eliminar suscripción",
    "Delete subscription": "Eliminar suscripción",
    "subscriptions.deleted": "Suscripción eliminada",
    "Subscription deleted": "Suscripción eliminada",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Android IAP",
    "Android IAP": "Android IAP",
    "subscriptions.type.ios": "iOS IAP",
    "iOS IAP": "iOS IAP",
    "subscriptions.type.free_subscription": "Gratis",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "{count} cargados",
    "subscriptions.no_subscribers": "No hay suscriptores {status}.",
    "No {status} subscribers.": "No hay suscriptores {status}.",
    "subscriptions.billing_records": "Registros de facturación",
    "Billing Records": "Registros de facturación",
    "subscriptions.no_invoices": "No se encontraron facturas.",
    "No invoices found.": "No se encontraron facturas.",
    "subscriptions.column.account": "Cuenta",
    "subscriptions.column.email": "Correo electrónico",
    "subscriptions.column.status": "Estado",
    "subscriptions.column.subscribed": "Suscripto",
    "Subscribed": "Suscripto",
    "subscriptions.column.expires": "Caduca",
    "subscriptions.column.next_renewal": "Próxima renovación",
    "Next Renewal": "Próxima renovación",
    "subscriptions.column.amount_paid": "Monto pagado",
    "Amount Paid": "Monto pagado",
    "subscriptions.invoice_column.invoice_id": "ID de factura",
    "Invoice ID": "ID de factura",
    "subscriptions.invoice_column.account": "Cuenta",
    "subscriptions.invoice_column.amount": "Monto",
    "subscriptions.invoice_column.status": "Estado",
    "subscriptions.invoice_column.period": "Período",
    "subscriptions.invoice_column.paid_at": "Pagado en",
    "Paid At": "Pagado en",
    "subscriptions.validation.title_required": "El título es obligatorio",
    "subscriptions.validation.allowed_listings_positive": "Los listados permitidos deben ser mayores que 0",
    "Allowed listings should be greater than 0": "Los listados permitidos deben ser mayores que 0",
    "subscriptions.validation.currency_required": "La moneda es obligatoria",
    "Currency is required": "La moneda es obligatoria",
    "subscriptions.validation.expiry_required": "Los días de caducidad son obligatorios",
    "Expiry days are required": "Los días de caducidad son obligatorios",
    "subscriptions.validation.payment_method_required": "El método de pago es obligatorio",
    "Payment method is required": "El método de pago es obligatorio",
    "subscriptions.error.save": "Ha ocurrido un error al guardar la suscripción.",
    "Something went wrong while saving the subscription.": "Ha ocurrido un error al guardar la suscripción.",
    "subscriptions.error.delete": "Ha ocurrido un error al eliminar la suscripción.",
    "Something went wrong while deleting the subscription.": "Ha ocurrido un error al eliminar la suscripción.",
    "common.configuration": "Configuración",
    "subscriptions.per_period": "por {period}",
    "per {period}": "por {period}",
    "subscriptions.tab.subscribers": "Suscriptores",
    "subscriptions.tab.invoices": "Facturas",
    "subscriptions.account_title": "Suscripción de cuenta",
    "Account Subscription": "Suscripción de cuenta",
    "subscriptions.config.description": "Gestione las suscripciones de cuenta. Cuando está habilitado, los propietarios de la cuenta necesitan una suscripción activa para publicar listados. Se utiliza la pasarela de pago predeterminada seleccionada en el Método de Pago para los pagos de suscripción.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Gestione las suscripciones de cuenta. Cuando está habilitado, los propietarios de la cuenta necesitan una suscripción activa para publicar listados. Se utiliza la pasarela de pago predeterminada seleccionada en el Método de Pago para los pagos de suscripción.",
    "subscriptions.config.enable": "Habilitar suscripciones",
    "Enable subscriptions": "Habilitar suscripciones",
    "subscriptions.config.type": "Tipo de suscripción",
    "Subscription type": "Tipo de suscripción",
    "subscriptions.config.purchased_message": "Mensaje cuando una suscripción ya está comprada",
    "Message when a subscription is already purchased": "Mensaje cuando una suscripción ya está comprada",
    "subscriptions.config.purchased_placeholder": "Ingrese el mensaje ya comprado",
    "Enter the already-purchased message": "Ingrese el mensaje ya comprado",
    "subscriptions.config.listings_exhausted_message": "Mensaje cuando se alcanza el límite de listados",
    "Message when the listing limit is reached": "Mensaje cuando se alcanza el límite de listados",
    "subscriptions.config.listings_exhausted_placeholder": "Ingrese el mensaje de límite de listados",
    "Enter the listing limit message": "Ingrese el mensaje de límite de listados",
    "subscriptions.config.inactive_message": "Mensaje cuando la suscripción está inactiva",
    "Message when the subscription is inactive": "Mensaje cuando la suscripción está inactiva",
    "subscriptions.config.inactive_placeholder": "Ingrese el mensaje de suscripción inactiva",
    "Enter the inactive subscription message": "Ingrese el mensaje de suscripción inactiva",
    "subscriptions.config.saved": "Configuración de suscripción guardada con éxito",
    "Subscription settings saved successfully": "Configuración de suscripción guardada con éxito",
    "people.title": "Personas",
    "people.tab.staff": "Equipo",
    "people.tab.departments": "Departamentos",
    "Departments": "Departamentos",
    "people.tab.job_profiles": "Perfiles de puesto",
    "Job profiles": "Perfiles de puesto",
    "people.tab.pay_grades": "Grados salariales",
    "Pay grades": "Grados salariales",
    "people.action.add_staff": "Agregar personal",
    "Add staff": "Agregar personal",
    "people.action.add_department": "Agregar departamento",
    "Add department": "Agregar departamento",
    "people.action.add_job_profile": "Agregar perfil de puesto",
    "Add job profile": "Agregar perfil de puesto",
    "people.action.add_pay_grade": "Agregar grado salarial",
    "Add pay grade": "Agregar grado salarial",
    "people.currency_id": "ID de moneda",
    "people.onboarding.eyebrow": "Empieza con Personas",
    "Get started with People": "Empieza con Personas",
    "people.onboarding.title": "Construye tu directorio de equipo",
    "Build your team directory": "Construye tu directorio de equipo",
    "people.onboarding.description": "Agrega tu primer miembro del equipo, luego organiza tu equipo con departamentos, perfiles de puesto y grados salariales.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Agrega tu primer miembro del equipo, luego organiza tu equipo con departamentos, perfiles de puesto y grados salariales.",
    "people.onboarding.add_first": "Agrega tu primer miembro del equipo",
    "Add your first staff member": "Agrega tu primer miembro del equipo",
    "people.onboarding.step_staff": "Agregar personal",
    "people.onboarding.step_staff_description": "Vincula un usuario existente a tu directorio de personal.",
    "Link an existing user to your staff directory.": "Vincula un usuario existente a tu directorio de personal.",
    "people.onboarding.step_teams": "Organizar equipos",
    "Organize teams": "Organizar equipos",
    "people.onboarding.step_teams_description": "Crea departamentos y perfiles de puesto a medida que creces.",
    "Create departments and job profiles as you grow.": "Crea departamentos y perfiles de puesto a medida que creces.",
    "people.onboarding.step_pay": "Configurar compensación",
    "Set compensation": "Configurar compensación",
    "people.onboarding.step_pay_description": "Define grados salariales para una configuración consistente de nómina.",
    "Define pay grades for consistent payroll setup.": "Define grados salariales para una configuración consistente de nómina.",
    "people.staff_profile": "Perfil de personal",
    "Staff profile": "Perfil de personal",
    "people.field.employee_code": "Código de empleado",
    "Employee code": "Código de empleado",
    "people.field.job_title": "Cargo",
    "Job title": "Cargo",
    "people.field.department": "Departamento",
    "Department": "Departamento",
    "people.field.job_profile": "Perfil laboral",
    "Job profile": "Perfil laboral",
    "people.field.pay_grade": "Grado salarial",
    "Pay grade": "Grado salarial",
    "people.field.employment_type": "Tipo de empleo",
    "Employment type": "Tipo de empleo",
    "people.field.start_date": "Fecha de inicio",
    "people.field.user_id": "ID de usuario",
    "people.field.user": "Usuario",
    "people.field.grade": "Grado",
    "Grade": "Grado",
    "people.field.salary_range": "Rango salarial",
    "Salary range": "Rango salarial",
    "people.field.minimum_salary": "Salario mínimo",
    "Minimum salary": "Salario mínimo",
    "people.field.maximum_salary": "Salario máximo",
    "Maximum salary": "Salario máximo",
    "people.field.currency_id": "ID de moneda",
    "people.form.staff.edit": "Editar personal",
    "Edit staff": "Editar personal",
    "people.form.staff.add": "Agregar personal",
    "people.form.staff.description": "Vincule un usuario existente a un perfil de personal.",
    "Link an existing user to a staff profile.": "Vincule un usuario existente a un perfil de personal.",
    "people.form.department.edit": "Editar departamento",
    "Edit department": "Editar departamento",
    "people.form.department.add": "Agregar departamento",
    "people.form.job_profile.edit": "Editar perfil de puesto",
    "Edit job profile": "Editar perfil de puesto",
    "people.form.job_profile.add": "Agregar perfil de puesto",
    "people.form.pay_grade.edit": "Editar grado salarial",
    "Edit pay grade": "Editar grado salarial",
    "people.form.pay_grade.add": "Agregar grado salarial",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Ingeniero Senior",
    "Senior Engineer": "Ingeniero Senior",
    "people.placeholder.department": "Ingeniería",
    "Engineering": "Ingeniería",
    "people.placeholder.department_description": "Equipo de Producto y Ingeniería",
    "Product & Engineering team": "Equipo de Producto y Ingeniería",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Tiempo completo",
    "Full time": "Tiempo completo",
    "people.employment.part_time": "Medio tiempo",
    "Part time": "Medio tiempo",
    "people.employment.contractor": "Contratista",
    "Contractor": "Contratista",
    "people.toast.staff_added": "Personal agregado",
    "Staff added": "Personal agregado",
    "people.toast.staff_updated": "Personal actualizado",
    "Staff updated": "Personal actualizado",
    "people.toast.department_added": "Departamento agregado",
    "Department added": "Departamento agregado",
    "people.toast.department_updated": "Departamento actualizado",
    "Department updated": "Departamento actualizado",
    "people.toast.job_profile_added": "Perfil de puesto agregado",
    "Job profile added": "Perfil de puesto agregado",
    "people.toast.job_profile_updated": "Perfil de puesto actualizado",
    "Job profile updated": "Perfil de puesto actualizado",
    "people.toast.pay_grade_added": "Grado salarial agregado",
    "Pay grade added": "Grado salarial agregado",
    "people.toast.pay_grade_updated": "Grado salarial actualizado",
    "Pay grade updated": "Grado salarial actualizado",
    "people.empty.staff": "Aún no hay personal. Agrega un perfil de personal para comenzar.",
    "No staff yet. Add a staff profile to get started.": "Aún no hay personal. Agrega un perfil de personal para comenzar.",
    "people.empty.departments": "Aún no hay departamentos.",
    "No departments yet.": "Aún no hay departamentos.",
    "people.empty.job_profiles": "Aún no hay perfiles de puesto.",
    "No job profiles yet.": "Aún no hay perfiles de puesto.",
    "people.empty.pay_grades": "Aún no hay grados salariales.",
    "No pay grades yet.": "Aún no hay grados salariales.",
    "people.pagination.page": "Página {page}",
    "Page {page}": "Página {page}",
    "workforce.title": "Fuerza laboral",
    "workforce.tab.shifts": "Turnos",
    "Shifts": "Turnos",
    "workforce.tab.attendance": "Asistencia",
    "Attendance": "Asistencia",
    "workforce.tab.leave_requests": "Solicitudes de licencia",
    "Leave requests": "Solicitudes de licencia",
    "workforce.tab.leave_balances": "Saldo de licencias",
    "Leave balances": "Saldo de licencias",
    "workforce.tab.leave_policies": "Políticas de licencia",
    "Leave policies": "Políticas de licencia",
    "workforce.action.add_shift": "Agregar turno",
    "Add shift": "Agregar turno",
    "workforce.action.new_leave_request": "Nueva solicitud de licencia",
    "workforce.action.set_balance": "Establecer saldo",
    "Set balance": "Establecer saldo",
    "workforce.action.add_policy": "Agregar política",
    "Add policy": "Agregar política",
    "workforce.action.create_request": "Crear solicitud",
    "Create request": "Crear solicitud",
    "workforce.action.save_balance": "Guardar saldo",
    "Save balance": "Guardar saldo",
    "workforce.action.clock_in": "Marcar entrada",
    "Clock in": "Marcar entrada",
    "workforce.action.clock_out": "Marcar salida",
    "workforce.action.clocking_in": "Marcando entrada…",
    "Clocking in…": "Marcando entrada…",
    "workforce.action.clocking_out": "Marcando salida…",
    "Clocking out…": "Marcando salida…",
    "workforce.field.staff": "Personal",
    "workforce.field.start_time": "Inicio",
    "workforce.field.end_time": "Fin",
    "workforce.field.location": "Ubicación",
    "workforce.field.leave_type": "Tipo de licencia",
    "Leave type": "Tipo de licencia",
    "workforce.field.from": "Desde",
    "workforce.field.to": "Hasta",
    "workforce.field.days": "Días",
    "Days": "Días",
    "workforce.field.total_days": "Días totales",
    "Total days": "Días totales",
    "workforce.field.days_per_year": "Días por año",
    "Days per year": "Días por año",
    "workforce.field.carry_over": "Transferir al año siguiente",
    "Carry over": "Transferir al año siguiente",
    "workforce.field.carry_over_hint": "Los días no utilizados se transfieren al año siguiente.",
    "Unused days carry over to next year": "Los días no utilizados se transfieren al año siguiente.",
    "workforce.field.reason": "Motivo",
    "workforce.field.time": "Hora",
    "workforce.field.clock_in": "Marcar entrada",
    "workforce.field.clock_out": "Salir",
    "workforce.field.hours": "Horas",
    "Hours": "Horas",
    "workforce.field.dates": "Fechas",
    "Dates": "Fechas",
    "workforce.field.used_days": "Usado",
    "Used": "Usado",
    "workforce.field.remaining_days": "Restante",
    "workforce.field.policy": "Política",
    "Policy": "Política",
    "workforce.placeholder.location": "Sede",
    "HQ": "Sede",
    "workforce.placeholder.leave_note": "Vacaciones familiares",
    "Family holiday": "Vacaciones familiares",
    "workforce.placeholder.policy_name": "Permiso anual",
    "Annual Leave": "Permiso anual",
    "workforce.placeholder.reject_reason": "Período ocupado",
    "Busy period": "Período ocupado",
    "workforce.placeholder.optional_note": "Nota opcional",
    "Optional note": "Nota opcional",
    "workforce.select.all_staff": "Todo el personal",
    "All staff": "Todo el personal",
    "workforce.form.shift.add": "Agregar turno",
    "workforce.form.leave_request.add": "Nueva solicitud de permiso",
    "workforce.form.leave_balance.title": "Establecer saldo de permiso",
    "Set leave balance": "Establecer saldo de permiso",
    "workforce.form.leave_balance.description": "Inicializar el derecho de un empleado a un tipo de permiso y año.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Inicializar el derecho de un empleado a un tipo de permiso y año.",
    "workforce.form.leave_policy.add": "Agregar política de permiso",
    "Add leave policy": "Agregar política de permiso",
    "workforce.form.leave_request.reject": "Rechazar solicitud de permiso",
    "Reject leave request": "Rechazar solicitud de permiso",
    "workforce.form.clock_out": "Salir",
    "workforce.toast.shift_added": "Turno agregado",
    "Shift added": "Turno agregado",
    "workforce.toast.leave_request_created": "Solicitud de permiso creada",
    "Leave request created": "Solicitud de permiso creada",
    "workforce.toast.leave_balance_saved": "Saldo de permiso guardado",
    "Leave balance saved": "Saldo de permiso guardado",
    "workforce.toast.leave_policy_added": "Política de permiso agregada",
    "Leave policy added": "Política de permiso agregada",
    "workforce.toast.leave_request_rejected": "Solicitud de permiso rechazada",
    "Leave request rejected": "Solicitud de permiso rechazada",
    "workforce.toast.leave_request_approved": "Solicitud de baja aprobada",
    "Leave request approved": "Solicitud de baja aprobada",
    "workforce.toast.clocked_in": "Registrado",
    "Clocked in": "Registrado",
    "workforce.toast.clocked_out": "Desmarcado",
    "Clocked out": "Desmarcado",
    "workforce.empty.shifts": "No hay turnos en este período.",
    "No shifts in this period.": "No hay turnos en este período.",
    "workforce.empty.attendance": "No hay registros de asistencia.",
    "No attendance records.": "No hay registros de asistencia.",
    "workforce.empty.leave_requests": "No hay solicitudes de baja.",
    "No leave requests.": "No hay solicitudes de baja.",
    "workforce.empty.leave_balances": "No hay saldos de vacaciones. Usa 'Establecer saldo' para agregar uno.",
    "No leave balances. Use Set balance to add one.": "No hay saldos de vacaciones. Usa 'Establecer saldo' para agregar uno.",
    "workforce.empty.leave_policies": "Aún no hay políticas de vacaciones.",
    "No leave policies yet.": "Aún no hay políticas de vacaciones.",
    "workforce.leave_type.annual": "Vacaciones anuales",
    "Annual leave": "Vacaciones anuales",
    "workforce.leave_type.sick": "Vacaciones por enfermedad",
    "Sick leave": "Vacaciones por enfermedad",
    "workforce.leave_type.unpaid": "Vacaciones no remuneradas",
    "Unpaid leave": "Vacaciones no remuneradas",
    "workforce.leave_type.parental": "Vacaciones parentales",
    "Parental leave": "Vacaciones parentales",
    "workforce.leave_type.compassionate": "Vacaciones por compasión",
    "Compassionate leave": "Vacaciones por compasión",
    "workforce.duration.hours_minutes": "{hours}h {minutes}m",
    "{hours}h {minutes}m": "{hours}h {minutes}m",
    "common.year": "Año",
    "Year": "Año",
    "common.approve": "Aprobar",
    "common.reject": "Rechazar",
    "payroll.title": "Nómina",
    "payroll.tab.runs": "Ejecuciones de nómina",
    "Payroll runs": "Ejecuciones de nómina",
    "payroll.tab.components": "Componentes de nómina",
    "Pay components": "Componentes de nómina",
    "payroll.tab.claims": "Solicitudes de gastos",
    "Expense claims": "Solicitudes de gastos",
    "payroll.tab.categories": "Categorías de gastos",
    "Expense categories": "Categorías de gastos",
    "payroll.action.new_run": "Nueva ejecución de nómina",
    "New payroll run": "Nueva ejecución de nómina",
    "payroll.action.add_component": "Agregar componente de nómina",
    "payroll.action.new_claim": "Nueva reclamación de gastos",
    "New expense claim": "Nueva reclamación de gastos",
    "payroll.action.add_category": "Agregar categoría",
    "payroll.action.create_run": "Crear ejecución",
    "Create run": "Crear ejecución",
    "payroll.action.create_component": "Crear componente",
    "Create component": "Crear componente",
    "payroll.action.create_claim": "Crear reclamación",
    "Create claim": "Crear reclamación",
    "payroll.action.submit_claim": "Enviar",
    "Submit": "Enviar",
    "payroll.action.approve_claim": "Aprobar",
    "payroll.action.reimburse_claim": "Reembolsar",
    "Reimburse": "Reembolsar",
    "payroll.action.approve_payroll": "Aprobar nómina",
    "Approve payroll": "Aprobar nómina",
    "payroll.action.activate": "Activar",
    "Activate": "Activar",
    "payroll.action.deactivate": "Desactivar",
    "payroll.action.adjust": "Ajustar",
    "payroll.action.save_adjustment": "Guardar ajuste",
    "payroll.action.export_csv": "Exportar CSV",
    "Export CSV": "Exportar CSV",
    "payroll.action.exporting": "Exportando…",
    "payroll.action.view_staff_items": "Ver artículos del personal",
    "View staff items": "Ver artículos del personal",
    "payroll.action.view_payslips": "Ver nóminas",
    "View payslips": "Ver nóminas",
    "payroll.type.addition": "Adición",
    "Addition": "Adición",
    "payroll.type.deduction": "Deducción",
    "Deduction": "Deducción",
    "payroll.calculation.fixed": "Monto fijo",
    "Fixed amount": "Monto fijo",
    "payroll.calculation.percentage": "Porcentaje",
    "payroll.applies_to.all": "Todo el personal",
    "payroll.applies_to.hourly": "Personal por hora",
    "Hourly staff": "Personal por hora",
    "payroll.applies_to.salaried": "Personal de sueldo",
    "Salaried staff": "Personal de sueldo",
    "payroll.category.archive_confirm": "¿Archivar {name}?",
    "payroll.components.description": "Los adicionales y deducciones activos se aplican automáticamente a nuevos procesos de nómina.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Los adicionales y deducciones activos se aplican automáticamente a nuevos procesos de nómina.",
    "payroll.empty.categories": "Aún no hay categorías de gastos.",
    "No expense categories yet.": "Aún no hay categorías de gastos.",
    "payroll.empty.claims": "Aún no hay reclamaciones de gastos.",
    "No expense claims yet.": "Aún no hay reclamaciones de gastos.",
    "payroll.empty.components": "Aún no hay componentes de pago configurados.",
    "No pay components configured yet.": "Aún no hay componentes de pago configurados.",
    "payroll.empty.runs": "Aún no hay procesos de nómina.",
    "No payroll runs yet.": "Aún no hay procesos de nómina.",
    "payroll.field.staff": "Personal",
    "payroll.field.base_pay": "Sueldo base",
    "Base pay": "Sueldo base",
    "payroll.field.allowances": "Indemnizaciones",
    "Allowances": "Indemnizaciones",
    "payroll.field.deductions": "Deducciones",
    "Deductions": "Deducciones",
    "payroll.field.commission": "Comisión",
    "payroll.field.net_pay": "Sueldo neto",
    "Net pay": "Sueldo neto",
    "payroll.field.components": "Componentes",
    "Components": "Componentes",
    "payroll.field.commission_override": "Sobreescribir comisión",
    "Commission override": "Sobreescribir comisión",
    "payroll.field.calculation": "Cálculo",
    "Calculation": "Cálculo",
    "payroll.field.applies_to": "Aplica a",
    "Applies to": "Aplica a",
    "payroll.field.staff_optional_draft": "Personal (opcional durante el borrador)",
    "payroll.field.category_optional_draft": "Categoría (opcional durante el borrador)",
    "payroll.field.category": "Categoría",
    "payroll.field.period": "Período",
    "payroll.field.period_start": "Inicio del período",
    "Period start": "Inicio del período",
    "payroll.field.period_end": "Fin del período",
    "Period end": "Fin del período",
    "payroll.field.generate_email_payslips": "Generar y enviar por correo las nóminas",
    "Generate and email payslips": "Generar y enviar por correo las nóminas",
    "payroll.field.gl_code": "Código GL",
    "GL code": "Código GL",
    "payroll.field.maximum_per_claim": "Máximo por reclamación",
    "Maximum per claim": "Máximo por reclamación",
    "payroll.field.maximum_per_transaction": "Máximo por transacción",
    "Maximum per transaction": "Máximo por transacción",
    "payroll.field.spending_cap": "Tope de gasto",
    "Spending cap": "Tope de gasto",
    "payroll.field.tax_rate": "Tasa de impuesto (%)",
    "Tax rate (%)": "Tasa de impuesto (%)",
    "payroll.field.no_limit": "Sin límite",
    "No limit": "Sin límite",
    "payroll.form.run.title": "Nueva ejecución de nómina",
    "payroll.form.run.description": "El pago se calcula a partir de los grados salariales del personal para el período seleccionado.",
    "Pay is calculated from staff pay grades for the selected period.": "El pago se calcula a partir de los grados salariales del personal para el período seleccionado.",
    "payroll.form.component.title": "Agregar componente de pago",
    "payroll.form.component.description": "Los componentes se incluyen automáticamente en futuras ejecuciones de nómina.",
    "Components are automatically included in future payroll runs.": "Los componentes se incluyen automáticamente en futuras ejecuciones de nómina.",
    "payroll.form.claim.title": "Nueva reclamación de gastos",
    "payroll.form.claim.description": "Las reclamaciones comienzan como borradores hasta que se envían para aprobación.",
    "Claims start as drafts until submitted for approval.": "Las reclamaciones comienzan como borradores hasta que se envían para aprobación.",
    "payroll.form.category.add": "Agregar categoría de gastos",
    "Add expense category": "Agregar categoría de gastos",
    "payroll.form.category.edit": "Editar categoría de gastos",
    "Edit expense category": "Editar categoría de gastos",
    "payroll.form.claim.approve_title": "Aprobar reclamación de gastos",
    "Approve expense claim": "Aprobar reclamación de gastos",
    "payroll.form.run.approve_title": "Aprobar ejecución de nómina",
    "Approve payroll run": "Aprobar ejecución de nómina",
    "payroll.form.run.approve_description": "La aprobación bloquea la ejecución de nómina. También puedes generar y enviar recibos por correo electrónico ahora.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "La aprobación bloquea la ejecución de nómina. También puedes generar y enviar recibos por correo electrónico ahora.",
    "payroll.items.title": "Elementos de nómina del personal",
    "Staff payroll items": "Elementos de nómina del personal",
    "payroll.items.loading": "Cargando elementos de nómina…",
    "Loading payroll items…": "Cargando elementos de nómina…",
    "payroll.items.empty": "No se encontraron elementos de nómina.",
    "No payroll items found.": "No se encontraron elementos de nómina.",
    "payroll.items.adjust_title": "Ajustar elemento de nómina",
    "Adjust payroll item": "Ajustar elemento de nómina",
    "payroll.items.adjust_description": "Actualiza deducciones o anula la cantidad de comisión para este empleado.",
    "Update deductions or override the commission amount for this staff member.": "Actualiza deducciones o anula la cantidad de comisión para este empleado.",
    "payroll.payslips.title": "Recibos de pago",
    "Payslips": "Recibos de pago",
    "payroll.payslips.generate": "Generar recibos de pago",
    "Generate payslips": "Generar recibos de pago",
    "payroll.payslips.generating": "Generando…",
    "Generating…": "Generando…",
    "payroll.payslips.empty": "No hay nóminas generadas aún.",
    "No payslips generated yet.": "No hay nóminas generadas aún.",
    "payroll.payslips.generated": "Generado",
    "Generated": "Generado",
    "payroll.payslips.sent_at": "Enviado {date}",
    "Sent {date}": "Enviado {date}",
    "payroll.payslips.not_sent": "No enviado",
    "Not sent": "No enviado",
    "payroll.payslips.send_email": "Enviar correo electrónico",
    "Send email": "Enviar correo electrónico",
    "payroll.payslips.sending": "Enviando…",
    "payroll.payslips.details": "Detalles de la nómina",
    "Payslip details": "Detalles de la nómina",
    "payroll.placeholder.approval_note": "Aprobado",
    "payroll.placeholder.category_name": "Viaje",
    "Travel": "Viaje",
    "payroll.placeholder.claim_description": "Vuelo al cliente",
    "Flight to client": "Vuelo al cliente",
    "payroll.placeholder.component_name": "Indemnización por transporte",
    "Transport Allowance": "Indemnización por transporte",
    "payroll.staff_number": "Personal #{id}",
    "Staff #{id}": "Personal #{id}",
    "payroll.toast.category_added": "Categoría de gastos añadida",
    "Expense category added": "Categoría de gastos añadida",
    "payroll.toast.category_archived": "Categoría de gastos archivada",
    "Expense category archived": "Categoría de gastos archivada",
    "payroll.toast.category_updated": "Categoría de gastos actualizada",
    "Expense category updated": "Categoría de gastos actualizada",
    "payroll.toast.claim_approved": "Reclamación aprobada",
    "Claim approved": "Reclamación aprobada",
    "payroll.toast.claim_created": "Reclamación de gastos creada",
    "Expense claim created": "Reclamación de gastos creada",
    "payroll.toast.claim_reimbursed": "Reclamación marcada como reembolsada",
    "Claim marked as reimbursed": "Reclamación marcada como reembolsada",
    "payroll.toast.claim_submitted": "Reclamación presentada",
    "Claim submitted": "Reclamación presentada",
    "payroll.toast.component_activated": "Componente salarial activado",
    "Pay component activated": "Componente salarial activado",
    "payroll.toast.component_created": "Componente salarial creado",
    "Pay component created": "Componente salarial creado",
    "payroll.toast.component_deactivated": "Componente salarial desactivado",
    "Pay component deactivated": "Componente salarial desactivado",
    "payroll.toast.item_updated": "Elemento de nómina actualizado",
    "Payroll item updated": "Elemento de nómina actualizado",
    "payroll.toast.payslip_email_sent": "Correo electrónico de nómina enviado",
    "Payslip email sent": "Correo electrónico de nómina enviado",
    "payroll.toast.payslips_generated": "Nóminas generadas",
    "Payslips generated": "Nóminas generadas",
    "payroll.toast.run_approved": "Ejecución de nómina aprobada",
    "Payroll run approved": "Ejecución de nómina aprobada",
    "payroll.toast.run_approved_payslips_queued": "Nómina aprobada y nóminas en cola",
    "Payroll approved and payslips queued": "Nómina aprobada y nóminas en cola",
    "payroll.toast.run_created": "Ejecución de nómina creada",
    "Payroll run created": "Ejecución de nómina creada",
    "payroll.toast.exported": "Nómina exportada",
    "Payroll exported": "Nómina exportada",
    "common.notes": "Notas",
    "expenses.title": "Gastos",
    "expenses.action.add": "Agregar gasto",
    "Add expense": "Agregar gasto",
    "expenses.action.create": "Crear gasto",
    "Create expense": "Crear gasto",
    "expenses.action.submit": "Enviar",
    "expenses.action.approve": "Aprobar",
    "expenses.action.reimburse": "Reembolsar",
    "expenses.action.pay": "Pagar",
    "expenses.action.lifecycle": "Gasto {action}ado",
    "Expense {action}d": "Gasto {action}ado",
    "expenses.type.claim": "Reclamación",
    "Claim": "Reclamación",
    "expenses.type.claims": "Reclamaciones",
    "Claims": "Reclamaciones",
    "expenses.type.bill": "Factura",
    "Bill": "Factura",
    "expenses.type.bills": "Facturas",
    "Bills": "Facturas",
    "expenses.filter.all_types": "Todos los tipos",
    "All types": "Todos los tipos",
    "expenses.filter.all_statuses": "Todos los estados",
    "expenses.summary.title": "Resumen",
    "Summary": "Resumen",
    "expenses.summary.by_category": "Por categoría",
    "By category": "Por categoría",
    "expenses.summary.by_status": "Por estado",
    "By status": "Por estado",
    "expenses.summary.by_party": "Por proveedor / personal",
    "By supplier / staff": "Por proveedor / personal",
    "expenses.summary.heading": "Resumen por {group}",
    "Summary by {group}": "Resumen por {group}",
    "expenses.summary.group.category": "categoría",
    "category": "categoría",
    "expenses.summary.group.status": "estado",
    "status": "estado",
    "expenses.summary.group.party": "proveedor / personal",
    "supplier / staff": "proveedor / personal",
    "expenses.summary.empty": "No hay resumen disponible.",
    "No summary available.": "No hay resumen disponible.",
    "expenses.column.type": "Tipo",
    "expenses.column.party": "Personal / Proveedor",
    "Staff / Supplier": "Personal / Proveedor",
    "expenses.column.status": "Estado",
    "expenses.field.staff_optional": "Personal (opcional al crear borrador)",
    "expenses.field.supplier_optional": "Proveedor (opcional al crear borrador)",
    "Supplier (optional while drafting)": "Proveedor (opcional al crear borrador)",
    "expenses.field.category_optional": "Categoría (opcional al crear borrador)",
    "expenses.field.amount": "Importe",
    "expenses.field.currency": "Moneda",
    "expenses.field.description": "Descripción",
    "expenses.field.due_date": "Fecha de vencimiento",
    "Due date": "Fecha de vencimiento",
    "expenses.field.receipt_url": "URL del recibo",
    "Receipt URL": "URL del recibo",
    "expenses.empty": "No se encontraron gastos para los filtros seleccionados.",
    "No expenses found for the selected filters.": "No se encontraron gastos para los filtros seleccionados.",
    "expenses.modal.edit": "Editar gasto",
    "Edit expense": "Editar gasto",
    "expenses.modal.add": "Añadir {type}",
    "expenses.modal.bill_help": "Crea el borrador ahora y asigna un proveedor antes de enviar.",
    "Create the draft now and assign a supplier before submitting.": "Crea el borrador ahora y asigna un proveedor antes de enviar.",
    "expenses.modal.claim_help": "Crea el borrador ahora y asigna un personal antes de enviar.",
    "Create the draft now and assign a staff member before submitting.": "Crea el borrador ahora y asigna un personal antes de enviar.",
    "expenses.toast.updated": "Gasto actualizado",
    "Expense updated": "Gasto actualizado",
    "expenses.toast.created": "Gasto creado",
    "Expense created": "Gasto creado",
    "recurring_payments.title": "Pagos recurrentes",
    "recurring_payments.action.add": "Agregar pago recurrente",
    "Add recurring payment": "Agregar pago recurrente",
    "recurring_payments.action.create": "Crear pago recurrente",
    "Create recurring payment": "Crear pago recurrente",
    "recurring_payments.action.pause": "Pausar",
    "Pause": "Pausar",
    "recurring_payments.action.resume": "Reanudar",
    "Resume": "Reanudar",
    "recurring_payments.action.remove": "Eliminar",
    "recurring_payments.description": "Crea automáticamente facturas de gastos borrador para pagos regulares a proveedores.",
    "Automatically create draft expense bills for regular supplier payments.": "Crea automáticamente facturas de gastos borrador para pagos regulares a proveedores.",
    "recurring_payments.field.name": "Nombre",
    "recurring_payments.field.supplier": "Proveedor",
    "recurring_payments.field.supplier_optional": "Proveedor (opcional)",
    "Supplier (optional)": "Proveedor (opcional)",
    "recurring_payments.field.frequency": "Frecuencia",
    "Frequency": "Frecuencia",
    "recurring_payments.field.next_due": "Próxima fecha de vencimiento",
    "Next due date": "Próxima fecha de vencimiento",
    "recurring_payments.field.auto_create": "Crear automáticamente borrador de factura",
    "Auto-create draft bill": "Crear automáticamente borrador de factura",
    "recurring_payments.field.auto_create_help": "Crear automáticamente una factura de gasto borrador",
    "Create a draft expense bill automatically": "Crear automáticamente una factura de gasto borrador",
    "recurring_payments.field.one_time": "Pago único",
    "One-time payment": "Pago único",
    "recurring_payments.field.one_time_help": "Terminar después de la próxima factura generada",
    "End after the next generated bill": "Terminar después de la próxima factura generada",
    "recurring_payments.field.end_date": "Fecha de finalización",
    "recurring_payments.placeholder.name": "Alquiler de oficina",
    "Office Rent": "Alquiler de oficina",
    "recurring_payments.frequency.daily": "Diario",
    "recurring_payments.frequency.weekly": "Semanal",
    "recurring_payments.frequency.monthly": "Mensual",
    "recurring_payments.frequency.quarterly": "Trimestral",
    "recurring_payments.frequency.yearly": "Anual",
    "Yearly": "Anual",
    "recurring_payments.form.description": "Los pagos vencidos crean automáticamente facturas borrador en Gastos cuando se habilita la opción de auto-creación.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Los pagos vencidos crean automáticamente facturas borrador en Gastos cuando se habilita la opción de auto-creación.",
    "recurring_payments.empty": "Aún no hay pagos recurrentes.",
    "No recurring payments yet.": "Aún no hay pagos recurrentes.",
    "recurring_payments.this_payment": "este pago recurrente",
    "this recurring payment": "este pago recurrente",
    "recurring_payments.confirm_remove": "¿Eliminar {name}?",
    "Remove {name}?": "¿Eliminar {name}?",
    "recurring_payments.toast.pause": "Pago recurrente pausado",
    "Recurring payment paused": "Pago recurrente pausado",
    "recurring_payments.toast.resume": "Pago recurrente reanudado",
    "Recurring payment resumed": "Pago recurrente reanudado",
    "recurring_payments.toast.delete": "Pago recurrente eliminado",
    "Recurring payment removed": "Pago recurrente eliminado",
    "recurring_payments.toast.created": "Pago recurrente creado",
    "Recurring payment created": "Pago recurrente creado",
    "expenses.toast.submit": "Gasto presentado",
    "Expense submitted": "Gasto presentado",
    "expenses.toast.approve": "Gasto aprobado",
    "Expense approved": "Gasto aprobado",
    "expenses.toast.reimburse": "Gasto reembolsado",
    "Expense reimbursed": "Gasto reembolsado",
    "expenses.toast.pay": "Gasto pagado",
    "Expense paid": "Gasto pagado",
    "media_picker.title": "Seleccionar medios",
    "Select media": "Seleccionar medios",
    "media_picker.type.media": "Medios",
    "media_picker.type.all": "Todo",
    "media_picker.type.image": "Imagen",
    "media_picker.type.video": "Vídeo",
    "media_picker.type.audio": "Audio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Carpeta",
    "media_picker.label.show": "Mostrar",
    "media_picker.label.media_type": "Tipo de medio",
    "Media type": "Tipo de medio",
    "media_picker.action.show_type": "Mostrar {type} medios",
    "media_picker.action.close": "Cerrar selector de medios",
    "Close media picker": "Cerrar selector de medios",
    "media_picker.action.upload": "Subir medios",
    "media_picker.action.creating": "Creando…",
    "media_picker.action.create_folder": "Crear carpeta",
    "Create folder": "Crear carpeta",
    "media_picker.action.cancel": "Cancelar",
    "media_picker.action.use_selected": "Usar seleccionados",
    "Use selected": "Usar seleccionados",
    "media_picker.placeholder.search": "Buscar medios",
    "media_picker.placeholder.folder": "Nombre de nueva carpeta",
    "New folder name": "Nombre de nueva carpeta",
    "media_picker.loading": "Cargando medios…",
    "media_picker.empty": "No se encontraron medios en esta carpeta.",
    "No media found in this folder.": "No se encontraron medios en esta carpeta.",
    "media_picker.selection.count": "{count} seleccionados",
    "{count} selected": "{count} seleccionados",
    "media_picker.selection.prompt": "Selecciona un archivo para continuar",
    "Select a file to continue": "Selecciona un archivo para continuar",
    "media_picker.error.load": "No se puede cargar la media",
    "Unable to load media": "No se puede cargar la media",
    "media_picker.error.load_retry": "No se puede cargar la media. Por favor, inténtelo de nuevo.",
    "media_picker.error.create_folder": "No se puede crear la carpeta",
    "media_picker.error.create_folder_retry": "No se puede crear la carpeta. Por favor, inténtelo de nuevo.",
    "Unable to create folder. Please try again.": "No se puede crear la carpeta. Por favor, inténtelo de nuevo.",
    "media_picker.error.prepare_upload": "No se puede preparar la carga",
    "Unable to prepare upload": "No se puede preparar la carga",
    "media_picker.error.upload_url": "URL de carga faltante",
    "Upload URL missing": "URL de carga faltante",
    "media_picker.error.register_media": "No se puede registrar la media",
    "media_picker.error.upload_retry": "No se puede subir la media. Por favor, inténtelo de nuevo.",
    "membership.title": "Membresía",
    "membership.description": "Administra programas de membresía, contribuciones de miembros, estado de pago y reglas de recordatorio.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Administra programas de membresía, contribuciones de miembros, estado de pago y reglas de recordatorio.",
    "membership.action.settings": "Configuración",
    "membership.action.manage_programs": "Administrar programas",
    "Manage programs": "Administrar programas",
    "membership.action.view_data": "Ver datos",
    "View data": "Ver datos",
    "membership.action.edit_listing": "Editar lista",
    "membership.action.go_to_listings": "Ir a listados",
    "Go to listings": "Ir a listados",
    "membership.action.view_order": "Ver pedido",
    "View order": "Ver pedido",
    "membership.action.configure_reminders": "Configurar recordatorios",
    "Configure reminders": "Configurar recordatorios",
    "membership.stat.programs": "Programas",
    "membership.stat.active_members": "Miembros activos",
    "Active members": "Miembros activos",
    "membership.stat.contributions": "Contribuciones",
    "Contributions": "Contribuciones",
    "membership.stat.units": "Unidades creditadas",
    "Units credited": "Unidades creditadas",
    "membership.programs.title": "Programas",
    "membership.programs.description": "Listados de tipo membresía disponibles para sus clientes.",
    "Membership-type listings available to your customers.": "Listados de tipo membresía disponibles para sus clientes.",
    "membership.programs.no_description": "Aún no hay descripción del programa.",
    "No program description yet.": "Aún no hay descripción del programa.",
    "membership.programs.empty_title": "Aún no hay programas de membresía",
    "No membership programs yet": "Aún no hay programas de membresía",
    "membership.programs.empty_description": "Crea un listado con tipo membresía para empezar a aceptar contribuciones.",
    "Create a listing with type membership to start accepting contributions.": "Crea un listado con tipo membresía para empezar a aceptar contribuciones.",
    "membership.programs.history_description": "Historial de precios y miembros inscritos.",
    "Price history and enrolled members.": "Historial de precios y miembros inscritos.",
    "membership.badge": "Membresía",
    "membership.loading_program": "Cargando datos del programa…",
    "Loading program data…": "Cargando datos del programa…",
    "membership.price_logs.title": "Registros de precios",
    "Price logs": "Registros de precios",
    "membership.price_logs.empty": "No hay registros de precios.",
    "No price logs recorded.": "No hay registros de precios.",
    "membership.source.manual": "manual",
    "manual": "manual",
    "membership.members.title": "Miembros",
    "Members": "Miembros",
    "membership.members.empty_program": "No hay miembros inscritos en este programa.",
    "No members enrolled in this program.": "No hay miembros inscritos en este programa.",
    "membership.members.recent": "Miembros recientes",
    "Recent members": "Miembros recientes",
    "membership.members.empty_recent": "Los miembros y contribuciones aparecerán aquí después de la inscripción.",
    "Members and contributions will appear here after enrolment.": "Los miembros y contribuciones aparecerán aquí después de la inscripción.",
    "membership.member_heading": "Miembro: {member}",
    "Member: {member}": "Miembro: {member}",
    "membership.contributions.title": "Contribuciones",
    "membership.contributions.empty": "No se han registrado contribuciones aún.",
    "No contributions recorded yet.": "No se han registrado contribuciones aún.",
    "membership.payment_dues.title": "Cuotas de pago",
    "Payment dues": "Cuotas de pago",
    "membership.payment_dues.empty": "No hay cuotas de pago programadas.",
    "No scheduled payment dues.": "No hay cuotas de pago programadas.",
    "membership.unit": "unidad",
    "unit": "unidad",
    "membership.units": "unidades",
    "units": "unidades",
    "membership.months": "meses",
    "membership.automation.label": "AUTOMATIZACIÓN",
    "AUTOMATION": "AUTOMATIZACIÓN",
    "membership.automation.description": "El trabajador diario verifica los pagos programados de membresía.",
    "Daily worker checks scheduled membership payments.": "El trabajador diario verifica los pagos programados de membresía.",
    "membership.reminders.title": "Recordatorios de pago",
    "Payment reminders": "Recordatorios de pago",
    "membership.reminders.due_soon": "Recordatorio de vencimiento cercano",
    "Due-soon reminder": "Recordatorio de vencimiento cercano",
    "membership.reminders.due_soon_short": "Vencimiento cercano",
    "Due soon": "Vencimiento cercano",
    "membership.reminders.due_soon_help": "Enviar un recordatorio antes de que una cuota programada esté vencida.",
    "Send one reminder before a scheduled payment is due.": "Enviar un recordatorio antes de que una cuota programada esté vencida.",
    "membership.reminders.days_before": "Días antes de la fecha de vencimiento",
    "Days before due date": "Días antes de la fecha de vencimiento",
    "membership.reminders.days_before_value": "{count} días antes",
    "{count} days before": "{count} días antes",
    "membership.reminders.overdue": "Recordatorio de vencimiento",
    "Overdue reminder": "Recordatorio de vencimiento",
    "membership.reminders.overdue_help": "Enviar un recordatorio después de la fecha de vencimiento y el período de gracia.",
    "Send one reminder after the due date and grace period.": "Enviar un recordatorio después de la fecha de vencimiento y el período de gracia.",
    "membership.settings.title": "Configuración de membresía",
    "Membership settings": "Configuración de membresía",
    "membership.settings.description": "Configura el horario de recordatorios de pago.",
    "Configure the payment reminder schedule.": "Configura el horario de recordatorios de pago.",
    "membership.email_copy.title": "Copia de correo personalizada",
    "Custom email copy": "Copia de correo personalizada",
    "membership.email_copy.description": "Usa Configuración → Notificaciones → Membresía para editar los asuntos y plantillas de vencimiento cercano y vencido.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Usa Configuración → Notificaciones → Membresía para editar los asuntos y plantillas de vencimiento cercano y vencido.",
    "membership.toast.saved": "Configuración de recordatorios de membresía guardada.",
    "Membership reminder settings saved.": "Configuración de recordatorios de membresía guardada.",
    "membership.toast.save_failed": "No se pueden guardar las configuraciones de recordatorios de membresía.",
    "Unable to save membership reminder settings.": "No se pueden guardar las configuraciones de recordatorios de membresía.",
    "common.status.off": "Apagado",
    "Off": "Apagado",
    "common.status.on": "Encendido",
    "On": "Encendido",
    "common.save_settings": "Guardar configuración",
    "Save settings": "Guardar configuración",
    "developer.page.title": "API y desarrollador",
    "API & Developer": "API y desarrollador",
    "developer.api_keys.title": "Claves de API",
    "API Keys": "Claves de API",
    "developer.api_keys.description": "Utiliza estas claves para autenticar solicitudes a la API de Tradly. Mantén tu Clave Secreta privada — nunca la expongas en código del lado del cliente.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Utiliza estas claves para autenticar solicitudes a la API de Tradly. Mantén tu Clave Secreta privada — nunca la expongas en código del lado del cliente.",
    "developer.api_keys.credentials_description": "Encuentra abajo tus claves de producción. Necesitarás usar estas claves para autorizar y construir tus aplicaciones.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Encuentra abajo tus claves de producción. Necesitarás usar estas claves para autorizar y construir tus aplicaciones.",
    "developer.api_keys.publishable": "Clave publicable",
    "Publishable Key": "Clave publicable",
    "developer.api_keys.publishable_placeholder": "Introduce Clave publicable",
    "Enter Publishable Key": "Introduce Clave publicable",
    "developer.api_keys.secret": "Clave secreta",
    "developer.api_keys.secret_placeholder": "Introduce Clave secreta",
    "Enter Secret Key": "Introduce Clave secreta",
    "developer.api_keys.access_label": "Acceso a API",
    "API access": "Acceso a API",
    "developer.api_reference.title": "Referencia de API",
    "developer.api_reference.description": "Documentación completa de la API REST, guías y ejemplos de código para construir sobre tu mercado Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Documentación completa de la API REST, guías y ejemplos de código para construir sobre tu mercado Tradly.",
    "developer.api_reference.card_description": "Explora la referencia completa de API, guías de autenticación, webhooks y documentación de SDK. Todo lo que necesitas para integrar o construir frontends personalizados sobre tu mercado.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Explora la referencia completa de API, guías de autenticación, webhooks y documentación de SDK. Todo lo que necesitas para integrar o construir frontends personalizados sobre tu mercado.",
    "developer.api_reference.open_docs": "Abrir documentación de API",
    "Open API Docs": "Abrir documentación de API",
    "developer.ai_agents.title": "IA y agentes",
    "AI & Agents": "IA y agentes",
    "developer.ai_agents.description": "Conecta tu mercado a herramientas de IA y permite a los clientes crear agentes impulsados por tu plataforma.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Conecta tu mercado a herramientas de IA y permite a los clientes crear agentes impulsados por tu plataforma.",
    "developer.mcp.action.create": "Crear",
    "developer.mcp.action.removing": "Eliminando…",
    "developer.mcp.scope.resource": "Recurso",
    "developer.customer_agents.description": "Permite a tus clientes crear agentes de IA que interactúen con tu mercado. Compatible con ChatGPT, Claude y otras plataformas de IA. Ideal para automatizar flujos de trabajo de compradores, crear tiendas personalizadas o crear asistentes de compras inteligentes.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Permite a tus clientes crear agentes de IA que interactúen con tu mercado. Compatible con ChatGPT, Claude y otras plataformas de IA. Ideal para automatizar flujos de trabajo de compradores, crear tiendas personalizadas o crear asistentes de compras inteligentes.",
    "whatsapp.title": "Conector de WhatsApp",
    "WhatsApp connector": "Conector de WhatsApp",
    "whatsapp.intro.title": "Envía OTP y mensajes de marketing a través de WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Envía OTP y mensajes de marketing a través de WhatsApp",
    "whatsapp.intro.help": "Conecta este inquilino a la API de Meta WhatsApp Cloud. El SMS sigue siendo el canal predeterminado o de reserva, y el mismo conector puede entregar plantillas de campaña aprobadas de WhatsApp.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Conecta este inquilino a la API de Meta WhatsApp Cloud. El SMS sigue siendo el canal predeterminado o de reserva, y el mismo conector puede entregar plantillas de campaña aprobadas de WhatsApp.",
    "whatsapp.status.disabled": "Deshabilitado",
    "whatsapp.status.sms_otp": "Conector activo · OTP por SMS",
    "Connector on · SMS OTP": "Conector activo · OTP por SMS",
    "whatsapp.status.needs_configuration": "Necesita configuración",
    "Needs configuration": "Necesita configuración",
    "whatsapp.status.auto_fallback": "WhatsApp con recuperación por SMS",
    "WhatsApp with SMS fallback": "WhatsApp con recuperación por SMS",
    "whatsapp.status.sms_whatsapp_backup": "SMS con respaldo de WhatsApp",
    "SMS with WhatsApp backup": "SMS con respaldo de WhatsApp",
    "whatsapp.status.enabled": "WhatsApp activado",
    "WhatsApp enabled": "WhatsApp activado",
    "whatsapp.draft.notice": "Tienes un borrador no guardado de configuración de WhatsApp.",
    "You have an unsaved WhatsApp settings draft.": "Tienes un borrador no guardado de configuración de WhatsApp.",
    "whatsapp.connect.title": "Conecta tu WhatsApp comercial",
    "Connect your business WhatsApp": "Conecta tu WhatsApp comercial",
    "whatsapp.connect.description": "Introduce el número de negocio que conocen tus clientes. Meta abrirá una ventana de verificación segura; no necesitas buscar un ID de WABA, ID de número telefónico, token de acceso o configuración de API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Introduce el número de negocio que conocen tus clientes. Meta abrirá una ventana de verificación segura; no necesitas buscar un ID de WABA, ID de número telefónico, token de acceso o configuración de API.",
    "whatsapp.field.business_number": "Número de WhatsApp comercial",
    "Business WhatsApp number": "Número de WhatsApp comercial",
    "whatsapp.field.business_number_help": "Usa el número que quieres que los clientes envíen mensajes, incluido el código de país.",
    "Use the number you want customers to message, including country code.": "Usa el número que quieres que los clientes envíen mensajes, incluido el código de país.",
    "whatsapp.placeholder.business_number": "ej. +60 13 333 1671",
    "e.g. +60 13 333 1671": "ej. +60 13 333 1671",
    "whatsapp.field.connection_name": "Nombre de conexión",
    "whatsapp.field.connection_name_help": "Usa un nombre claro como Kuala Lumpur, Marca minorista o Soporte.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Usa un nombre claro como Kuala Lumpur, Marca minorista o Soporte.",
    "whatsapp.placeholder.connection_name": "ej. Soporte de Kuala Lumpur",
    "e.g. Kuala Lumpur support": "ej. Soporte de Kuala Lumpur",
    "whatsapp.field.optional_details": "Detalles de conexión opcionales",
    "Optional connection details": "Detalles de conexión opcionales",
    "whatsapp.field.optional_details_help": "Úselos solo cuando este número pertenezca a una marca, cuenta o sucursal específica.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Úselos solo cuando este número pertenezca a una marca, cuenta o sucursal específica.",
    "whatsapp.field.brand_key": "Clave de marca",
    "Brand key": "Clave de marca",
    "whatsapp.field.brand_key_help": "Clave interna estable para una marca, como minorista o mayorista.",
    "Stable internal key for a brand, such as retail or wholesale.": "Clave interna estable para una marca, como minorista o mayorista.",
    "whatsapp.placeholder.brand_key": "ej. minorista",
    "e.g. retail": "ej. minorista",
    "whatsapp.field.account_id": "ID de cuenta",
    "whatsapp.field.account_id_help": "Asocia este número con una cuenta Tradly existente.",
    "Associate this number with an existing Tradly account.": "Asocia este número con una cuenta Tradly existente.",
    "whatsapp.placeholder.account_id": "ej. 123",
    "e.g. 123": "ej. 123",
    "whatsapp.field.branch_id": "ID de sucursal",
    "Branch ID": "ID de sucursal",
    "whatsapp.field.branch_id_help": "Asocia este número con una sucursal Tradly existente.",
    "Associate this number with an existing Tradly branch.": "Asocia este número con una sucursal Tradly existente.",
    "whatsapp.placeholder.branch_id": "ej. 456",
    "e.g. 456": "ej. 456",
    "whatsapp.field.default_connection": "Usar como conexión predeterminada",
    "Use as default connection": "Usar como conexión predeterminada",
    "whatsapp.field.default_connection_help": "Los flujos OTP heredados usan la conexión seleccionada predeterminada cuando no se elige una conexión específica de rama.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Los flujos OTP heredados usan la conexión seleccionada predeterminada cuando no se elige una conexión específica de rama.",
    "whatsapp.field.uses_business_app": "Uso la app WhatsApp Business en este número",
    "I use the WhatsApp Business app on this number": "Uso la app WhatsApp Business en este número",
    "whatsapp.field.uses_business_app_help": "Sigue chateando en la app WhatsApp Business de tu teléfono. Meta te pedirá escanear un código QR desde la app y se sincronizarán tus contactos y chats recientes. Requiere la versión 2.24.17 o posterior.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Sigue chateando en la app WhatsApp Business de tu teléfono. Meta te pedirá escanear un código QR desde la app y se sincronizarán tus contactos y chats recientes. Requiere la versión 2.24.17 o posterior.",
    "whatsapp.connected.business_account": "Cuenta de negocio de WhatsApp",
    "WhatsApp business account": "Cuenta de negocio de WhatsApp",
    "whatsapp.connected.template_ready": "Plantilla de autenticación lista · OTP automático puede usar WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Plantilla de autenticación lista · OTP automático puede usar WhatsApp.",
    "whatsapp.connected.template_pending": "Conectado · SMS sigue siendo el respaldo seguro mientras se aprueba la plantilla de autenticación.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Conectado · SMS sigue siendo el respaldo seguro mientras se aprueba la plantilla de autenticación.",
    "whatsapp.action.connect": "Conectar WhatsApp",
    "Connect WhatsApp": "Conectar WhatsApp",
    "whatsapp.action.reconnect": "Reconectar WhatsApp",
    "Reconnect WhatsApp": "Reconectar WhatsApp",
    "whatsapp.connections.title": "Números de WhatsApp conectados",
    "Connected WhatsApp numbers": "Números de WhatsApp conectados",
    "whatsapp.connections.description": "Cada número puede pertenecer a una marca, cuenta o sucursal diferente. Seleccione uno antes de activar las plantillas.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Cada número puede pertenecer a una marca, cuenta o sucursal diferente. Seleccione uno antes de activar las plantillas.",
    "whatsapp.connections.unnamed": "Conexión de WhatsApp",
    "WhatsApp connection": "Conexión de WhatsApp",
    "whatsapp.connections.default": "Predeterminado",
    "whatsapp.connections.account": "Cuenta {id}",
    "Account {id}": "Cuenta {id}",
    "whatsapp.connections.branch": "Sucursal {id}",
    "Branch {id}": "Sucursal {id}",
    "whatsapp.connections.tenant_wide": "Conexión para toda la empresa",
    "Tenant-wide connection": "Conexión para toda la empresa",
    "whatsapp.action.make_default": "Hacer predeterminado",
    "Make default": "Hacer predeterminado",
    "whatsapp.notice.default_updated": "Conexión predeterminada de WhatsApp actualizada.",
    "Default WhatsApp connection updated.": "Conexión predeterminada de WhatsApp actualizada.",
    "whatsapp.error.default_update": "No se puede cambiar la conexión predeterminada.",
    "Unable to change the default connection.": "No se puede cambiar la conexión predeterminada.",
    "whatsapp.templates.title": "Plantillas de mensajes",
    "Message templates": "Plantillas de mensajes",
    "whatsapp.templates.description": "Elija una plantilla lista. Tradly la envía a Meta para su aprobación y la activa automáticamente cuando Meta la aprueba.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Elija una plantilla lista. Tradly la envía a Meta para su aprobación y la activa automáticamente cuando Meta la aprueba.",
    "whatsapp.template.status.not_activated": "No activado",
    "Not activated": "No activado",
    "whatsapp.template.status.approved": "Aprobado",
    "whatsapp.template.status.pending": "Pendiente",
    "whatsapp.template.status.submitted": "Enviado",
    "Submitted": "Enviado",
    "whatsapp.template.action.active": "Activo",
    "whatsapp.template.action.submitted": "Enviado",
    "whatsapp.template.action.activate": "Activar plantilla",
    "Activate template": "Activar plantilla",
    "whatsapp.notice.template_active": "{name} está aprobada y activa.",
    "{name} is approved and active.": "{name} está aprobada y activa.",
    "whatsapp.notice.template_submitted": "{name} se envió a Meta para revisión. Puedes seguir usando SMS hasta que sea aprobado.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} se envió a Meta para revisión. Puedes seguir usando SMS hasta que sea aprobado.",
    "whatsapp.channel.title": "Canal de entrega",
    "Delivery channel": "Canal de entrega",
    "whatsapp.channel.help": "El interruptor activa WhatsApp para tu negocio. Los códigos de acceso pueden enviarse solo por SMS, solo por WhatsApp o por SMS con WhatsApp como respaldo; las opciones de WhatsApp requieren una plantilla de código aprobada.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "El interruptor activa WhatsApp para tu negocio. Los códigos de acceso pueden enviarse solo por SMS, solo por WhatsApp o por SMS con WhatsApp como respaldo; las opciones de WhatsApp requieren una plantilla de código aprobada.",
    "whatsapp.channel.primary_otp": "Canal OTP primario",
    "Primary OTP channel": "Canal OTP primario",
    "whatsapp.channel.sms_description": "Mantén la ruta de entrega SMS existente.",
    "Keep the existing SMS delivery path.": "Mantén la ruta de entrega SMS existente.",
    "whatsapp.channel.whatsapp_description": "Usa la API de Meta Cloud para este inquilino.",
    "Use Meta Cloud API for this tenant.": "Usa la API de Meta Cloud para este inquilino.",
    "whatsapp.channel.automatic": "Automático",
    "Automatic": "Automático",
    "whatsapp.channel.automatic_description": "Usa WhatsApp cuando esté configurado, de lo contrario SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Usa WhatsApp cuando esté configurado, de lo contrario SMS.",
    "whatsapp.channel.fallback": "Cambio tras fallo en WhatsApp",
    "Fallback after WhatsApp failure": "Cambio tras fallo en WhatsApp",
    "whatsapp.channel.no_fallback": "Sin cambio",
    "No fallback": "Sin cambio",
    "whatsapp.channel.no_fallback_description": "Devuelve el resultado de entrega configurado.",
    "Return the configured delivery result.": "Devuelve el resultado de entrega configurado.",
    "whatsapp.channel.sms_fallback_description": "Intenta SMS con el mismo código OTP.",
    "Try SMS with the same OTP code.": "Intenta SMS con el mismo código OTP.",
    "whatsapp.channel.sms_only": "Solo SMS",
    "SMS only": "Solo SMS",
    "whatsapp.channel.sms_only_description": "Los códigos se envían por SMS.",
    "Codes are sent by text message.": "Los códigos se envían por SMS.",
    "whatsapp.channel.whatsapp_only": "Solo WhatsApp",
    "WhatsApp only": "Solo WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "Los códigos se envían desde tu número de WhatsApp.",
    "Codes are sent from your WhatsApp number.": "Los códigos se envían desde tu número de WhatsApp.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp como respaldo",
    "SMS, WhatsApp as backup": "SMS, WhatsApp como respaldo",
    "whatsapp.channel.sms_whatsapp_description": "Los códigos se envían por SMS; si falla, el mismo código se envía por WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Los códigos se envían por SMS; si falla, el mismo código se envía por WhatsApp.",
    "whatsapp.advanced.title": "Configuración técnica de recuperación",
    "Technical recovery settings": "Configuración técnica de recuperación",
    "whatsapp.advanced.description": "Solo para soporte de plataforma. La mayoría de los negocios deben usar Connect WhatsApp arriba.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Solo para soporte de plataforma. La mayoría de los negocios deben usar Connect WhatsApp arriba.",
    "whatsapp.field.phone_number_id": "ID del número de teléfono de WhatsApp",
    "WhatsApp phone number ID": "ID del número de teléfono de WhatsApp",
    "whatsapp.field.phone_number_id_help": "El ID del número de teléfono adjunto a tu cuenta de WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "El ID del número de teléfono adjunto a tu cuenta de WhatsApp Business.",
    "whatsapp.field.waba_id": "ID de la cuenta de WhatsApp Business",
    "WhatsApp Business Account ID": "ID de la cuenta de WhatsApp Business",
    "whatsapp.field.waba_id_help": "Aparece junto al ID del número en Meta (WhatsApp > Configuración de la API). Necesario para plantillas y mensajes de prueba.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Aparece junto al ID del número en Meta (WhatsApp > Configuración de la API). Necesario para plantillas y mensajes de prueba.",
    "whatsapp.placeholder.phone_number_id": "Ejemplo: 123456789012345",
    "e.g. 123456789012345": "Ejemplo: 123456789012345",
    "whatsapp.field.access_token": "Token de acceso de Meta",
    "Meta access token": "Token de acceso de Meta",
    "whatsapp.field.access_token_saved_help": "Guardado de forma segura en el servidor. Deje en blanco para mantenerlo sin cambios, o pegue un nuevo token para reemplazarlo.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Guardado de forma segura en el servidor. Deje en blanco para mantenerlo sin cambios, o pegue un nuevo token para reemplazarlo.",
    "whatsapp.field.access_token_help": "Utilice un token de usuario del sistema con permiso de mensajería de WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Utilice un token de usuario del sistema con permiso de mensajería de WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Guardado de forma segura · deje en blanco para mantener",
    "Saved securely · leave blank to keep": "Guardado de forma segura · deje en blanco para mantener",
    "whatsapp.placeholder.access_token": "Pegar token",
    "Paste token": "Pegar token",
    "whatsapp.token.saved": "Token de acceso de Meta guardado de forma segura",
    "Meta access token saved securely": "Token de acceso de Meta guardado de forma segura",
    "whatsapp.field.otp_template": "Nombre del modelo de OTP aprobado",
    "Approved OTP template name": "Nombre del modelo de OTP aprobado",
    "whatsapp.field.otp_template_help": "El cuerpo del modelo debe aceptar el OTP como un parámetro de texto.",
    "The template body must accept the OTP as one text parameter.": "El cuerpo del modelo debe aceptar el OTP como un parámetro de texto.",
    "whatsapp.placeholder.otp_template": "ej. login_verification",
    "e.g. login_verification": "ej. login_verification",
    "whatsapp.field.template_language": "Idioma del modelo",
    "Template language": "Idioma del modelo",
    "whatsapp.field.marketing_template": "Nombre del modelo de marketing aprobado (opcional)",
    "Approved marketing template name (optional)": "Nombre del modelo de marketing aprobado (opcional)",
    "whatsapp.field.marketing_template_help": "Use un modelo de marketing aprobado por Meta. Una campaña puede anular este nombre en su content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Use un modelo de marketing aprobado por Meta. Una campaña puede anular este nombre en su content.template_name.",
    "whatsapp.placeholder.marketing_template": "ej. monthly_offer",
    "e.g. monthly_offer": "ej. monthly_offer",
    "whatsapp.field.marketing_language": "Idioma del modelo de marketing",
    "Marketing template language": "Idioma del modelo de marketing",
    "whatsapp.info.title": "Antes de activar WhatsApp",
    "Before enabling WhatsApp": "Antes de activar WhatsApp",
    "whatsapp.info.description": "Meta debe aprobar cada modelo de OTP o de marketing antes de que se pueda enviar. El contenido de la campaña de WhatsApp usa template_name, template_language y parámetros opcionales de cuerpo; los números de destinatario deben estar en formato E.164. Si se habilita el reenvío automático, ArcticOwl intenta SMS con el OTP original en lugar de generar un segundo código.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta debe aprobar cada modelo de OTP o de marketing antes de que se pueda enviar. El contenido de la campaña de WhatsApp usa template_name, template_language y parámetros opcionales de cuerpo; los números de destinatario deben estar en formato E.164. Si se habilita el reenvío automático, ArcticOwl intenta SMS con el OTP original en lugar de generar un segundo código.",
    "whatsapp.action.hide_token": "Ocultar token de acceso de Meta",
    "Hide Meta access token": "Ocultar token de acceso de Meta",
    "whatsapp.action.show_token": "Mostrar token de acceso de Meta",
    "Show Meta access token": "Mostrar token de acceso de Meta",
    "whatsapp.error.generic": "No se pueden guardar la configuración de WhatsApp.",
    "whatsapp.error.browser_required": "La conexión de WhatsApp solo está disponible en un navegador.",
    "WhatsApp connection is only available in a browser.": "La conexión de WhatsApp solo está disponible en un navegador.",
    "whatsapp.error.meta_load": "Meta no pudo cargar. Verifique la configuración de privacidad del navegador e inténtelo de nuevo.",
    "Meta could not load. Check the browser privacy settings and try again.": "Meta no pudo cargar. Verifique la configuración de privacidad del navegador e inténtelo de nuevo.",
    "whatsapp.error.load": "No se pueden cargar las configuraciones de WhatsApp.",
    "Unable to load WhatsApp settings.": "No se pueden cargar las configuraciones de WhatsApp.",
    "whatsapp.error.connect_before_template": "Conecte WhatsApp antes de activar un modelo.",
    "Connect WhatsApp before activating a template.": "Conecte WhatsApp antes de activar un modelo.",
    "whatsapp.error.template_submit": "No se puede enviar el modelo de WhatsApp.",
    "Unable to submit the WhatsApp template.": "No se puede enviar el modelo de WhatsApp.",
    "whatsapp.error.business_number_required": "Ingrese el número de WhatsApp comercial antes de conectarse. Meta lo verificará en el siguiente paso.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Ingrese el número de WhatsApp comercial antes de conectarse. Meta lo verificará en el siguiente paso.",
    "whatsapp.error.signup_not_ready": "La conexión de WhatsApp aún se está preparando por la plataforma. Por favor, inténtelo de nuevo pronto.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "La conexión de WhatsApp aún se está preparando por la plataforma. Por favor, inténtelo de nuevo pronto.",
    "whatsapp.error.signup_cancelled": "La conexión de Meta fue cancelada o no devolvió un código de autorización.",
    "Meta connection was cancelled or did not return an authorization code.": "La conexión de Meta fue cancelada o no devolvió un código de autorización.",
    "whatsapp.error.phone_number_missing": "Meta no devolvió el número de WhatsApp comercial seleccionado. Por favor, intente la conexión de nuevo.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta no devolvió el número de WhatsApp comercial seleccionado. Por favor, intente la conexión de nuevo.",
    "whatsapp.notice.connected_auto": "WhatsApp está conectado. La entrega automática de OTP usará WhatsApp primero y SMS si falla.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp está conectado. La entrega automática de OTP usará WhatsApp primero y SMS si falla.",
    "whatsapp.notice.connected_sms": "WhatsApp está conectado. El SMS permanecerá activo hasta que Meta apruebe una plantilla de autenticación.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp está conectado. El SMS permanecerá activo hasta que Meta apruebe una plantilla de autenticación.",
    "whatsapp.error.connect": "No se puede conectar WhatsApp.",
    "Unable to connect WhatsApp.": "No se puede conectar WhatsApp.",
    "whatsapp.error.otp_configuration": "WhatsApp o Entrega Automática de OTP necesitan un ID de número de teléfono, un nombre de plantilla de OTP aprobada y un token de acceso de Meta. Para WhatsApp solo de marketing, elija SMS como canal principal de OTP y mantenga el conector habilitado.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "WhatsApp o Entrega Automática de OTP necesitan un ID de número de teléfono, un nombre de plantilla de OTP aprobada y un token de acceso de Meta. Para WhatsApp solo de marketing, elija SMS como canal principal de OTP y mantenga el conector habilitado.",
    "whatsapp.notice.saved": "Configuración del conector de WhatsApp guardada para este inquilino.",
    "WhatsApp connector settings saved for this tenant.": "Configuración del conector de WhatsApp guardada para este inquilino.",
    "whatsapp.error.save": "No se pueden guardar las configuraciones de WhatsApp.",
    "whatsapp.notice.discarded": "Borrador descartado.",
    "Draft discarded.": "Borrador descartado.",
    "whatsapp.test.title": "Enviar un mensaje de prueba",
    "Send a test message": "Enviar un mensaje de prueba",
    "whatsapp.test.description": "Envía una plantilla aprobada a cualquier número de WhatsApp para comprobar que tu conexión funciona.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Envía una plantilla aprobada a cualquier número de WhatsApp para comprobar que tu conexión funciona.",
    "whatsapp.test.refresh": "Actualizar plantillas",
    "Refresh templates": "Actualizar plantillas",
    "whatsapp.test.field.template": "Plantilla aprobada",
    "Approved template": "Plantilla aprobada",
    "whatsapp.test.field.parameter": "Valor para {{{number}}}",
    "Value for {{{number}}}": "Valor para {{{number}}}",
    "whatsapp.test.field.mobile": "Enviar a",
    "Send to": "Enviar a",
    "whatsapp.test.field.mobile_help": "Número de WhatsApp con el código de país.",
    "WhatsApp number with country code.": "Número de WhatsApp con el código de país.",
    "whatsapp.test.action.send": "Enviar mensaje de prueba",
    "Send test message": "Enviar mensaje de prueba",
    "whatsapp.test.sent": "Enviado a {mobile}. ID del mensaje de Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Enviado a {mobile}. ID del mensaje de Meta: {id}",
    "whatsapp.test.no_templates": "Aún no hay plantillas aprobadas. Activa una plantilla arriba y envíala cuando Meta la apruebe.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Aún no hay plantillas aprobadas. Activa una plantilla arriba y envíala cuando Meta la apruebe.",
    "common.discard_draft": "Descartar borrador",
    "common.status.connected": "Conectado",
    "Connected": "Conectado",
    "extensions.title": "Extensiones",
    "extensions.action.add": "Agregar Extensión",
    "Add Extension": "Agregar Extensión",
    "extensions.action.add_new": "Agregar Nueva Extensión",
    "Add New Extension": "Agregar Nueva Extensión",
    "extensions.action.edit": "Editar Extensión",
    "Edit Extension": "Editar Extensión",
    "extensions.action.delete": "Eliminar extensión",
    "Delete extension": "Eliminar extensión",
    "extensions.field.name": "Nombre",
    "extensions.field.domain": "Dominio",
    "extensions.field.configs": "Configuraciones",
    "Configs": "Configuraciones",
    "extensions.placeholder.name": "Nombre de la extensión",
    "Extension Name": "Nombre de la extensión",
    "extensions.placeholder.domain": "Dominio de la extensión",
    "Extension Domain": "Dominio de la extensión",
    "extensions.empty": "No hay extensiones configuradas aún.",
    "No extensions configured yet.": "No hay extensiones configuradas aún.",
    "extensions.toast.added": "Extensión agregada con éxito.",
    "Extension added successfully.": "Extensión agregada con éxito.",
    "extensions.toast.updated": "Extensión actualizada con éxito.",
    "Extension updated successfully.": "Extensión actualizada con éxito.",
    "extensions.toast.deleted": "Extensión eliminada con éxito.",
    "Extension deleted successfully.": "Extensión eliminada con éxito.",
    "extensions.error.name_required": "Se requiere nombre.",
    "extensions.error.domain_required": "El dominio es obligatorio",
    "Domain is required": "El dominio es obligatorio",
    "extensions.error.configs_required": "Se requieren configuraciones",
    "Configs is required": "Se requieren configuraciones",
    "extensions.error.save_failed": "No se puede guardar la extensión.",
    "Unable to save the extension.": "No se puede guardar la extensión.",
    "extensions.error.delete_failed": "No se puede eliminar la extensión.",
    "Unable to delete the extension.": "No se puede eliminar la extensión.",
    "automation_rules.kicker": "Automatización de operaciones",
    "Operations automation": "Automatización de operaciones",
    "automation_rules.title": "Reglas de automatización",
    "Automation rules": "Reglas de automatización",
    "automation_rules.description": "Convierte los eventos de personal y gastos en pasos claros de aprobación y revisión.",
    "Turn staff and expense events into clear approval and review steps.": "Convierte los eventos de personal y gastos en pasos claros de aprobación y revisión.",
    "automation_rules.action.new_rule": "Nueva regla",
    "New rule": "Nueva regla",
    "automation_rules.action.create_rule": "Crear regla",
    "Create rule": "Crear regla",
    "automation_rules.action.create_help": "Guarde este desencadenante, condiciones y acción como regla",
    "Save this trigger, conditions, and action as a rule": "Guarde este desencadenante, condiciones y acción como regla",
    "automation_rules.action.add_condition": "Agregar condición",
    "Add condition": "Agregar condición",
    "automation_rules.action.add_condition_help": "Agregar otra condición a esta regla",
    "Add another condition to this rule": "Agregar otra condición a esta regla",
    "automation_rules.action.remove_condition": "Eliminar condición",
    "Remove condition": "Eliminar condición",
    "automation_rules.action.choose": "Elegir una acción",
    "Choose an action": "Elegir una acción",
    "automation_rules.action.require_second_approver": "Requerir segundo aprobador",
    "Require second approver": "Requerir segundo aprobador",
    "automation_rules.action.require_second_approver_help": "Derivar la reclamación a otro aprobador.",
    "Route the claim to another approver.": "Derivar la reclamación a otro aprobador.",
    "automation_rules.action.auto_reject_expense": "Rechazar automáticamente el gasto",
    "Auto-reject expense": "Rechazar automáticamente el gasto",
    "automation_rules.action.auto_reject_expense_help": "Rechazar el gasto con una razón.",
    "Reject the expense with a reason.": "Rechazar el gasto con una razón.",
    "automation_rules.action.notify_role": "Notificar un rol",
    "Notify a role": "Notificar un rol",
    "automation_rules.action.notify_role_help": "Enviar una notificación a un rol de personal.",
    "Send a notification to a staff role.": "Enviar una notificación a un rol de personal.",
    "automation_rules.action.flag_for_review": "Marcar para revisión",
    "Flag for review": "Marcar para revisión",
    "automation_rules.action.flag_for_review_help": "Marcar un recurso para revisión manual.",
    "Mark a resource for manual review.": "Marcar un recurso para revisión manual.",
    "automation_rules.field.rule_name": "Nombre de la regla",
    "Rule name": "Nombre de la regla",
    "automation_rules.field.priority": "Prioridad",
    "automation_rules.field.module": "Módulo",
    "Module": "Módulo",
    "automation_rules.field.event": "Evento",
    "automation_rules.field.field": "Campo",
    "Field": "Campo",
    "automation_rules.field.operator": "Operador",
    "Operator": "Operador",
    "automation_rules.field.value": "Valor",
    "automation_rules.field.action": "Acción",
    "automation_rules.field.action_params": "Parámetros de acción",
    "Action parameters": "Parámetros de acción",
    "automation_rules.placeholder.rule_name": "Requerir segundo aprobador para reclamaciones grandes",
    "Require second approver for large claims": "Requerir segundo aprobador para reclamaciones grandes",
    "automation_rules.placeholder.field": "monto",
    "amount": "monto",
    "automation_rules.placeholder.value": "500 o false",
    "500 or false": "500 o false",
    "automation_rules.builder.description": "Construye el desencadenante, condiciones y acción a continuación, luego guárdalos como una regla.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Construye el desencadenante, condiciones y acción a continuación, luego guárdalos como una regla.",
    "automation_rules.error.load": "No se pueden cargar las reglas de automatización.",
    "Unable to load automation rules.": "No se pueden cargar las reglas de automatización.",
    "automation_rules.error.required_fields": "Se requieren nombre, módulo, evento y acción.",
    "Name, module, event, and action are required.": "Se requieren nombre, módulo, evento y acción.",
    "automation_rules.error.create": "No se puede crear la regla de automatización.",
    "Unable to create automation rule.": "No se puede crear la regla de automatización.",
    "automation_rules.error.valid_json": "Utilice JSON válido antes de guardar.",
    "Use valid JSON before saving.": "Utilice JSON válido antes de guardar.",
    "automation_rules.notice.created": "Regla de automatización creada.",
    "Automation rule created.": "Regla de automatización creada.",
    "automation_rules.notice.discarded": "Borrador descartado.",
    "automation_rules.draft.restored": "Se restauró el borrador no guardado de la regla de automatización.",
    "Your unsaved automation rule draft was restored.": "Se restauró el borrador no guardado de la regla de automatización.",
    "automation_rules.list.title": "Reglas",
    "automation_rules.list.count": "{count} configuradas",
    "{count} configured": "{count} configuradas",
    "automation_rules.list.loading": "Cargando reglas…",
    "Loading rules…": "Cargando reglas…",
    "automation_rules.list.unnamed": "Regla sin nombre",
    "Unnamed rule": "Regla sin nombre",
    "automation_rules.list.no_action": "Ninguna acción configurada",
    "No action configured": "Ninguna acción configurada",
    "automation_rules.list.empty": "Aún no hay reglas. Crea la primera desde el diagrama.",
    "No rules yet. Create the first one from the diagram.": "Aún no hay reglas. Crea la primera desde el diagrama.",
    "automation_rules.status.draft": "Borrador",
    "automation_rules.status.active": "Activo",
    "automation_rules.inspector.title": "Configuración del bloque",
    "Block settings": "Configuración del bloque",
    "automation_rules.inspector.diagram": "Diagrama",
    "Diagram": "Diagrama",
    "automation_rules.inspector.select_block": "Selecciona un bloque en el diagrama para configurarlo.",
    "Select a block on the diagram to configure it.": "Selecciona un bloque en el diagrama para configurarlo.",
    "automation_rules.inspector.no_configuration": "Este bloque no requiere configuración.",
    "This block does not need configuration.": "Este bloque no requiere configuración.",
    "automation_rules.node.trigger": "Disparador",
    "automation_rules.node.condition": "Condición",
    "automation_rules.node.action": "Acción",
    "automation_rules.node.end": "Fin",
    "automation_rules.node.completed": "Completado",
    "automation_rules.node.finished": "Evaluación de regla finalizada",
    "Rule evaluation finished": "Evaluación de regla finalizada",
    "automation_rules.trigger.choose_event": "Elige un evento",
    "Choose an event": "Elige un evento",
    "automation_rules.trigger.module": "módulo",
    "module": "módulo",
    "automation_rules.trigger.module_event": "Evento de {module}",
    "{module} event": "Evento de {module}",
    "automation_rules.trigger.help": "La regla se evalúa cuando se emite este evento por el módulo.",
    "The rule evaluates when this event is emitted by the module.": "La regla se evalúa cuando se emite este evento por el módulo.",
    "automation_rules.condition.label": "Condición",
    "automation_rules.condition.none": "Sin condiciones",
    "No conditions": "Sin condiciones",
    "automation_rules.condition.always_fires": "Siempre se dispara",
    "Always fires": "Siempre se dispara",
    "automation_rules.condition.empty_help": "Añade una condición para restringir esta regla.",
    "Add a condition to restrict this rule.": "Añade una condición para restringir esta regla.",
    "automation_rules.condition.value_required": "Valor requerido",
    "Value required": "Valor requerido",
    "automation_rules.condition.value": "Valor: {value}",
    "Value: {value}": "Valor: {value}",
    "automation_rules.operator.equals": "Igual a",
    "Equals": "Igual a",
    "automation_rules.operator.gt": "Mayor que",
    "Greater than": "Mayor que",
    "automation_rules.operator.gte": "Mayor o igual que",
    "Greater than or equal": "Mayor o igual que",
    "automation_rules.operator.lt": "Menor que",
    "Less than": "Menor que",
    "automation_rules.operator.exists": "Existe",
    "Exists": "Existe",
    "automation_rules.module.expenses": "Gastos",
    "automation_rules.module.staff": "Personal",
    "automation_rules.event.expense.submitted": "Gasto presentado",
    "automation_rules.event.leave.requested": "Permiso solicitado",
    "Leave requested": "Permiso solicitado",
    "automation_rules.event.payroll_run.created": "Ejecución de nómina creada",
    "automation_rules.meta.conditions": "{count} condición(es) · todas deben coincidir antes de ejecutar la acción",
    "{count} condition(s) · all must match before the action runs": "{count} condición(es) · todas deben coincidir antes de ejecutar la acción",
    "automation_rules.meta.no_conditions": "Sin condiciones · la acción siempre se ejecuta después del desencadenante",
    "No conditions · the action always runs after the trigger": "Sin condiciones · la acción siempre se ejecuta después del desencadenante",
    "automation_rules.draft.unsaved": "Tienes un borrador de regla de automatización no guardado.",
    "You have an unsaved automation rule draft.": "Tienes un borrador de regla de automatización no guardado.",
    "automation_rules.meta.one_condition": "1 condición · todas deben coincidir antes de ejecutar la acción",
    "1 condition · all must match before the action runs": "1 condición · todas deben coincidir antes de ejecutar la acción",
    "automation_rules.meta.many_conditions": "{count} condiciones · todas deben coincidir antes de ejecutar la acción",
    "{count} conditions · all must match before the action runs": "{count} condiciones · todas deben coincidir antes de ejecutar la acción",
    "cms.type.page": "Página",
    "Page": "Página",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Documentos",
    "Docs": "Documentos",
    "cms.type.pages": "Páginas",
    "cms.type.blogs": "Blogs",
    "Blogs": "Blogs",
    "cms.action.add_content": "Agregar contenido",
    "Add content": "Agregar contenido",
    "cms.action.add_type": "Agregar {type}",
    "cms.action.create_type": "Crear {type}",
    "Create {type}": "Crear {type}",
    "cms.action.edit": "Editar",
    "cms.action.duplicate": "Duplicar",
    "Duplicate": "Duplicar",
    "cms.action.open": "Abrir",
    "cms.field.title": "Título",
    "cms.field.slug": "Slug",
    "cms.field.content": "Contenido",
    "cms.field.meta_title": "Meta título",
    "cms.field.meta_description": "Meta descripción",
    "cms.placeholder.title": "Ej.: Acerca de nosotros",
    "e.g. About us": "Ej.: Acerca de nosotros",
    "cms.placeholder.slug": "acerca-de-nosotros",
    "about-us": "acerca-de-nosotros",
    "cms.placeholder.page_title": "Título de página",
    "Page title": "Título de página",
    "cms.placeholder.page_slug": "page-slug",
    "page-slug": "page-slug",
    "cms.placeholder.content": "Escribe tu contenido aquí…",
    "Write your content here…": "Escribe tu contenido aquí…",
    "cms.placeholder.meta_title": "Por defecto, título",
    "Defaults to title": "Por defecto, título",
    "cms.placeholder.meta_description": "Descripción breve para motores de búsqueda",
    "Short description for search engines": "Descripción breve para motores de búsqueda",
    "cms.section.seo_optional": "SEO (opcional)",
    "SEO (optional)": "SEO (opcional)",
    "cms.error.title_required": "El título es obligatorio.",
    "Title is required.": "El título es obligatorio.",
    "cms.error.content_required": "Agregue contenido antes de guardar.",
    "Add some content before saving.": "Agregue contenido antes de guardar.",
    "cms.error.create": "Error al crear. Inténtelo de nuevo.",
    "Failed to create. Please try again.": "Error al crear. Inténtelo de nuevo.",
    "cms.error.save": "Error al guardar.",
    "Failed to save.": "Error al guardar.",
    "cms.error.load_layer": "No se pudo cargar esta capa.",
    "Could not load this layer.": "No se pudo cargar esta capa.",
    "cms.toast.created": "{type} creado con éxito.",
    "{type} created successfully.": "{type} creado con éxito.",
    "cms.toast.saved": "Guardado",
    "Saved": "Guardado",
    "cms.toast.changes_saved": "Cambios guardados.",
    "Changes saved.": "Cambios guardados.",
    "cms.toast.deleted": "Eliminado",
    "cms.toast.duplicated": "Duplicado",
    "Duplicated": "Duplicado",
    "cms.error.delete": "Error al eliminar.",
    "Failed to delete": "Error al eliminar.",
    "cms.error.duplicate": "Error al duplicar",
    "Failed to duplicate": "Error al duplicar",
    "cms.confirm.delete": "¿Eliminar \"{title}\"?",
    "Delete \"{title}\"?": "¿Eliminar \"{title}\"?",
    "cms.duplicate.title": "{title} (copia)",
    "{title} (copy)": "{title} (copia)",
    "cms.draft.restored": "Se restauró el borrador de contenido no guardado.",
    "Your unsaved content draft was restored.": "Se restauró el borrador de contenido no guardado.",
    "cms.search": "Buscar…",
    "Search…": "Buscar…",
    "cms.list.no_results": "No se encontraron resultados.",
    "No results found.": "No se encontraron resultados.",
    "cms.list.empty_type": "Aún no hay {type}.",
    "No {type} yet.": "Aún no hay {type}.",
    "cms.list.untitled": "Sin título",
    "Untitled": "Sin título",
    "cms.editor.placeholder": "Escribe tu contenido aquí…",
    "cms.editor.normal_text": "Texto normal",
    "Normal text": "Texto normal",
    "cms.editor.heading": "Encabezado {level}",
    "Heading {level}": "Encabezado {level}",
    "cms.editor.align_left": "Alinear a la izquierda",
    "Align Left": "Alinear a la izquierda",
    "cms.editor.align_center": "Centrar",
    "Align Center": "Centrar",
    "cms.editor.align_right": "Alinear a la derecha",
    "Align Right": "Alinear a la derecha",
    "cms.editor.insert_table": "Insertar tabla",
    "Insert table": "Insertar tabla",
    "cms.editor.add_column": "Agregar columna",
    "Add column": "Agregar columna",
    "cms.editor.add_row": "Agregar fila",
    "Add row": "Agregar fila",
    "cms.editor.delete_table": "Eliminar tabla",
    "Delete table": "Eliminar tabla",
    "cms.editor.delete_column": "Eliminar columna",
    "Delete column": "Eliminar columna",
    "cms.editor.delete_row": "Eliminar fila",
    "Delete row": "Eliminar fila",
    "cms.editor.underline": "Subrayar",
    "Underline": "Subrayar",
    "cms.editor.strikethrough": "Tachar",
    "Strikethrough": "Tachar",
    "cms.editor.code": "Código",
    "cms.editor.code_block": "Bloque de código",
    "Code block": "Bloque de código",
    "cms.editor.subscript": "Subíndice",
    "Subscript": "Subíndice",
    "cms.editor.superscript": "Superíndice",
    "Superscript": "Superíndice",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL de imagen",
    "Image URL": "URL de imagen",
    "cms.editor.prompt.youtube_url": "URL de YouTube",
    "YouTube URL": "URL de YouTube",
    "cms.editor.undo": "Deshacer",
    "cms.editor.redo": "Rehacer",
    "cms.editor.table": "Tabla",
    "Table": "Tabla",
    "cms.editor.more": "Más",
    "cms.editor.bold": "Negrita",
    "Bold": "Negrita",
    "cms.editor.italic": "Cursiva",
    "Italic": "Cursiva",
    "cms.editor.bullet_list": "Lista de viñetas",
    "Bullet list": "Lista de viñetas",
    "cms.editor.ordered_list": "Lista ordenada",
    "Ordered list": "Lista ordenada",
    "cms.editor.task_list": "Lista de tareas",
    "Task list": "Lista de tareas",
    "cms.editor.link": "Enlace",
    "Link": "Enlace",
    "cms.editor.image": "Imagen",
    "cms.editor.text_color": "Color del texto",
    "Text color": "Color del texto",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Páginas",
    "cms.test.type.pages_description": "Páginas de aterrizaje y contenido estructurado para tiendas.",
    "Landing pages and structured storefront content.": "Páginas de aterrizaje y contenido estructurado para tiendas.",
    "cms.test.type.blogs": "Blogs",
    "cms.test.type.blogs_description": "Artículos, historias y actualizaciones para tu audiencia.",
    "Articles, stories, and updates for your audience.": "Artículos, historias y actualizaciones para tu audiencia.",
    "cms.test.type.docs": "Documentos",
    "cms.test.type.docs_description": "Documentación, guías y contenido de ayuda.",
    "Documentation, guides, and help content.": "Documentación, guías y contenido de ayuda.",
    "cms.test.operation.list": "Listar contenido por tipo",
    "List content by type": "Listar contenido por tipo",
    "cms.test.operation.fetch": "Obtener una Capa",
    "Fetch one Layer": "Obtener una Capa",
    "cms.test.operation.create": "Crear una Capa",
    "Create a Layer": "Crear una Capa",
    "cms.test.operation.update": "Actualizar una Capa",
    "Update a Layer": "Actualizar una Capa",
    "cms.test.operation.delete": "Eliminar una Capa",
    "Delete a Layer": "Eliminar una Capa",
    "cms.test.operation.search": "Buscar contenido",
    "Search content": "Buscar contenido",
    "cms.test.operation.categories": "Cargar categorías",
    "Load categories": "Cargar categorías",
    "cms.test.operation.translations": "Guardar traducciones",
    "Save translations": "Guardar traducciones",
    "cms.test.editor.placeholder": "Escribe tu contenido de página...",
    "Write your page content...": "Escribe tu contenido de página...",
    "cms.test.error.load_type": "No se puede cargar el contenido {type}",
    "Unable to load {type} content": "No se puede cargar el contenido {type}",
    "cms.test.error.load": "No se puede cargar el contenido CMS.",
    "Unable to load CMS content.": "No se puede cargar el contenido CMS.",
    "cms.test.error.required": "Agrega un título y contenido de página antes de guardar.",
    "Add a page title and content before saving.": "Agrega un título y contenido de página antes de guardar.",
    "cms.test.error.create": "No se puede crear esta página.",
    "Unable to create this page.": "No se puede crear esta página.",
    "cms.test.toast.created": "Página creada con éxito.",
    "Page created successfully.": "Página creada con éxito.",
    "cms.test.hero.eyebrow": "GESTIÓN DE CONTENIDO",
    "CONTENT MANAGEMENT": "GESTIÓN DE CONTENIDO",
    "cms.test.hero.title": "Layers CMS",
    "Layers CMS": "Layers CMS",
    "cms.test.hero.description": "Crea contenido estructurado una vez, luego hazlo disponible en tu tienda, aplicaciones y experiencias personalizadas.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Crea contenido estructurado una vez, luego hazlo disponible en tu tienda, aplicaciones y experiencias personalizadas.",
    "cms.test.hero.live_workspace": "Espacio de trabajo en vivo: {tenant} · vista previa de solo lectura",
    "Live workspace: {tenant} · read-only preview": "Espacio de trabajo en vivo: {tenant} · vista previa de solo lectura",
    "cms.test.current_tenant": "inquilino actual",
    "current tenant": "inquilino actual",
    "cms.test.content.title": "Tu contenido",
    "Your content": "Tu contenido",
    "cms.test.content.description": "Páginas, blogs y documentos están listos para gestionar desde un solo lugar.",
    "Pages, blogs, and docs are ready to manage from one place.": "Páginas, blogs y documentos están listos para gestionar desde un solo lugar.",
    "cms.test.action.create_page": "Crear Página",
    "Create Page": "Crear Página",
    "cms.test.form.description": "Crea contenido de página estructurado en Layers. La página estará disponible a través de la API después de guardar.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Crea contenido de página estructurado en Layers. La página estará disponible a través de la API después de guardar.",
    "cms.test.placeholder.slug": "about-us (opcional)",
    "about-us (optional)": "about-us (opcional)",
    "cms.test.draft.unsaved": "Tiene un borrador de página sin guardar.",
    "You have an unsaved page draft.": "Tiene un borrador de página sin guardar.",
    "cms.test.loading": "Cargando contenido de Layers en vivo…",
    "Loading live Layers content…": "Cargando contenido de Layers en vivo…",
    "cms.test.content.empty_title": "Aún no hay {type}",
    "No {type} yet": "Aún no hay {type}",
    "cms.test.content.empty_description": "Crea tu primer Layer en el espacio de trabajo para verlo aquí.",
    "Create your first Layer in the workspace to see it here.": "Crea tu primer Layer en el espacio de trabajo para verlo aquí.",
    "cms.test.feature.types": "Tipos de contenido personalizados",
    "Custom content types": "Tipos de contenido personalizados",
    "cms.test.feature.types_description": "Páginas, blogs y documentos son puntos de partida. Define un Post o cualquier otro modelo que necesite tu negocio.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Páginas, blogs y documentos son puntos de partida. Define un Post o cualquier otro modelo que necesite tu negocio.",
    "cms.test.feature.structured": "Estructurado y localizado por defecto",
    "Structured and localized": "Estructurado y localizado por defecto",
    "cms.test.feature.structured_description": "Usa slugs, categorías, imágenes, metadatos SEO y traducciones para la misma fuente de contenido.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Usa slugs, categorías, imágenes, metadatos SEO y traducciones para la misma fuente de contenido.",
    "cms.test.feature.headless": "Headless por defecto",
    "Headless by default": "Headless por defecto",
    "cms.test.feature.headless_description": "Usa la API de Layers en un sitio web, aplicación móvil, herramienta interna o frontend personalizado.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Usa la API de Layers en un sitio web, aplicación móvil, herramienta interna o frontend personalizado.",
    "cms.test.feature.ai": "Fuente de conocimiento de IA",
    "AI knowledge source": "Fuente de conocimiento de IA",
    "cms.test.feature.ai_description": "Envía el contenido de Tradly CMS al iRyxo Agent Builder como fuente de conocimiento.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Envía el contenido de Tradly CMS al iRyxo Agent Builder como fuente de conocimiento.",
    "cms.test.community.eyebrow": "CONTENIDO DE LA COMUNIDAD",
    "COMMUNITY CONTENT": "CONTENIDO DE LA COMUNIDAD",
    "cms.test.community.title": "Convierte Layers en un feed social",
    "Turn Layers into a social feed": "Convierte Layers en un feed social",
    "cms.test.community.description": "Crea un tipo de Post personalizado, permite a los usuarios publicar actualizaciones y añade interacción a través de tu frontend.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Crea un tipo de Post personalizado, permite a los usuarios publicar actualizaciones y añade interacción a través de tu frontend.",
    "cms.test.community.share_placeholder": "Comparte una actualización…",
    "Share an update…": "Comparte una actualización…",
    "cms.test.community.post": "Publicar",
    "Post": "Publicar",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Una actualización de comunidad publicada desde una Layer personalizada.",
    "A community update published from a custom Layer.": "Una actualización de comunidad publicada desde una Layer personalizada.",
    "cms.test.community.sample_actions": "♡ 24 · 💬 6 comentarios · ↗ Compartir",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24 · 💬 6 comentarios · ↗ Compartir",
    "cms.test.community.endpoints": "Ejemplos de endpoints",
    "Example endpoints": "Ejemplos de endpoints",
    "cms.test.developer.eyebrow": "ACCESO PARA DESARROLLADORES",
    "DEVELOPER ACCESS": "ACCESO PARA DESARROLLADORES",
    "cms.test.developer.title": "API de Layers",
    "Layers API": "API de Layers",
    "cms.test.developer.docs": "Documentación para desarrolladores",
    "Developer docs": "Documentación para desarrolladores",
    "auth.title": "Autenticación",
    "auth.sign_in_method": "Método de inicio de sesión",
    "auth.facebook_auth": "Autenticación de Facebook",
    "auth.google_auth": "Autenticación de Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "SSO empresarial",
    "Enterprise SSO": "SSO empresarial",
    "auth.admob": "Admob",
    "Admob": "Admob",
    "checkout.title": "Configuración de pago",
    "Checkout Settings": "Configuración de pago",
    "checkout.orders": "Pedidos",
    "checkout.carts": "Carritos",
    "Carts": "Carritos",
    "audit_logs.action": "Acción",
    "audit_logs.resource": "Recurso",
    "audit_logs.resource_id": "ID de recurso",
    "Resource ID": "ID de recurso",
    "audit_logs.agent_id": "ID de agente",
    "Agent ID": "ID de agente",
    "audit_logs.result": "Resultado",
    "audit_logs.actor_id": "ID de actor",
    "Actor ID": "ID de actor",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Marca de tiempo",
    "Timestamp": "Marca de tiempo",
    "audit_logs.succeeded": "Éxito",
    "audit_logs.failed": "Fallo",
    "audit_logs.source": "Origen",
    "audit_logs.all_sources": "Todas las fuentes",
    "All sources": "Todas las fuentes",
    "audit_logs.human_admin": "Humano (administrador)",
    "Human (admin)": "Humano (administrador)",
    "audit_logs.agent_mcp": "Agente (MCP)",
    "Agent (MCP)": "Agente (MCP)",
    "audit_logs.all_actions": "Todas las acciones",
    "All actions": "Todas las acciones",
    "audit_logs.from": "Desde",
    "audit_logs.to": "Hasta",
    "audit_logs.apply": "Aplicar",
    "audit_logs.clear": "Limpiar",
    "audit_logs.export_csv": "Exportar CSV",
    "audit_logs.exporting": "Exportando…",
    "audit_logs.title": "Registros de auditoría",
    "audit_logs.empty_title": "No se encontraron registros de auditoría",
    "No audit logs found": "No se encontraron registros de auditoría",
    "audit_logs.empty_subtitle": "Prueba ajustando tus filtros",
    "Try adjusting your filters": "Prueba ajustando tus filtros",
    "audit_logs.restriction_notice": "Mostrando los últimos 5 registros de auditoría. Actualiza a Growth para ver el historial completo y exportar registros.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Mostrando los últimos 5 registros de auditoría. Actualiza a Growth para ver el historial completo y exportar registros.",
    "audit_logs.extended_history": "Historial extendido de registros de auditoría",
    "Extended audit log history": "Historial extendido de registros de auditoría",
    "manage_features.title": "Administrar características",
    "manage_features.general": "General",
    "manage_features.apps": "Aplicaciones",
    "manage_features.marketplace": "Marketplace",
    "manage_features.commerce": "Comercio",
    "manage_features.channels": "Canales",
    "manage_features.left_menu": "Menú izquierdo",
    "Left Menu": "Menú izquierdo",
    "manage_features.right_sidepanel": "Panel lateral derecho",
    "Right Sidepanel": "Panel lateral derecho",
    "workflow.integration": "Integración",
    "workflow.no_url_title": "Sin URL de integración",
    "No Integration URL": "Sin URL de integración",
    "workflow.no_url_description": "Configure la URL de integración.",
    "Please configure the integration URL.": "Configure la URL de integración.",
    "workflow.back": "Volver",
    "Go Back": "Volver",
    "workflow.loading": "Cargando integración...",
    "Loading integration...": "Cargando integración...",
    "workflow.loading_hint": "Espere mientras conectamos",
    "Please wait while we connect": "Espere mientras conectamos",
    "workflow.error_title": "Error de integración",
    "Integration Error": "Error de integración",
    "workflow.error_description": "No se puede cargar la integración. Compruebe su conexión e inténtelo de nuevo.",
    "Unable to load the integration. Please check your connection and try again.": "No se puede cargar la integración. Compruebe su conexión e inténtelo de nuevo.",
    "workflow.retry": "Intentar de nuevo",
    "Try Again": "Intentar de nuevo",
    "upgrade_preview.eyebrow": "Vista previa del componente",
    "Component preview": "Vista previa del componente",
    "upgrade_preview.title": "Experiencia de actualización",
    "Upgrade experience": "Experiencia de actualización",
    "upgrade_preview.description": "Una puerta de características compartida centrada en lo que un cliente puede lograr después de actualizar.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Una puerta de características compartida centrada en lo que un cliente puede lograr después de actualizar.",
    "upgrade_preview.feature": "Agregar una variante",
    "Add a variant": "Agregar una variante",
    "upgrade_preview.context": "Este es el punto actual donde un usuario de plan Básico alcanza el límite de la función.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Este es el punto actual donde un usuario de plan Básico alcanza el límite de la función.",
    "upgrade_preview.button": "Vista previa del panel de actualización",
    "Preview upgrade panel": "Vista previa del panel de actualización",
    "upgrade_preview.listing_context": "Para esta lista",
    "For this listing": "Para esta lista",
    "gamification_test.eyebrow": "GAMIFICACIÓN DE CRECIMIENTO · RUTA DE PRUEBA",
    "GROWTH GAMIFICATION · TEST ROUTE": "GAMIFICACIÓN DE CRECIMIENTO · RUTA DE PRUEBA",
    "gamification_test.title": "Construye impulso para tu negocio",
    "Build momentum for your business": "Construye impulso para tu negocio",
    "gamification_test.subtitle": "Vista previa de misiones, monedas, insignias y rachas para {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Vista previa de misiones, monedas, insignias y rachas para {workspace}.",
    "gamification_test.this_workspace": "este espacio de trabajo",
    "this workspace": "este espacio de trabajo",
    "gamification_test.coins": "MONEDAS",
    "COINS": "MONEDAS",
    "gamification_test.points": "PUNTOS",
    "POINTS": "PUNTOS",
    "gamification_test.streak": "SERIE",
    "STREAK": "SERIE",
    "gamification_test.week": "1 semana",
    "1 week": "1 semana",
    "gamification_test.launch": "Camino de lanzamiento",
    "Launch path": "Camino de lanzamiento",
    "gamification_test.progress": "{completed} de {total} acciones completadas · hasta {coins} monedas",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} de {total} acciones completadas · hasta {coins} monedas",
    "gamification_test.done": "Hecho",
    "gamification_test.reward": "+{count} monedas",
    "+{count} coins": "+{count} monedas",
    "gamification_test.badges": "Insignias",
    "Badges": "Insignias",
    "gamification_test.mission_listing_created": "Crea tu primer listado",
    "Create your first listing": "Crea tu primer listado",
    "gamification_test.mission_collection_created": "Crea tu primera colección",
    "Create your first collection": "Crea tu primera colección",
    "gamification_test.mission_payment_configured": "Configura pagos",
    "Configure payments": "Configura pagos",
    "gamification_test.mission_publish_completed": "Publica tu sitio",
    "Publish your site": "Publica tu sitio",
    "gamification_test.mission_analytics_enabled": "Habilita analíticas",
    "Enable analytics": "Habilita analíticas",
    "gamification_test.badge_first_step": "Primer paso",
    "First Step": "Primer paso",
    "gamification_test.badge_catalog_builder": "Constructor de catálogo",
    "Catalog Builder": "Constructor de catálogo",
    "gamification_test.badge_ready_to_sell": "Listo para vender",
    "Ready to Sell": "Listo para vender",
    "gamification_test.badge_data_driven": "Basado en datos",
    "Data Driven": "Basado en datos",
    "gamification_test.badge_growth_operator": "Operador de crecimiento",
    "Growth Operator": "Operador de crecimiento",
    "sentry_check.title": "Verificación de configuración de Sentry",
    "Sentry Configuration Check": "Verificación de configuración de Sentry",
    "sentry_check.subtitle": "Prueba y verifica la configuración de seguimiento de errores de Sentry",
    "Test and verify Sentry error tracking setup": "Prueba y verifica la configuración de seguimiento de errores de Sentry",
    "sentry_check.configuration": "Configuración",
    "sentry_check.check_configuration": "Ver configuración",
    "Check Configuration": "Ver configuración",
    "sentry_check.status": "Estado:",
    "Status:": "Estado:",
    "sentry_check.enabled": "✓ Habilitado",
    "✓ Enabled": "✓ Habilitado",
    "sentry_check.disabled": "✗ Deshabilitado",
    "✗ Disabled": "✗ Deshabilitado",
    "sentry_check.environment": "Entorno:",
    "Environment:": "Entorno:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Tasa de muestreo de trazas:",
    "Traces Sample Rate:": "Tasa de muestreo de trazas:",
    "sentry_check.test_functions": "Funciones de prueba",
    "Test Functions": "Funciones de prueba",
    "sentry_check.test_hint": "Haga clic en los botones de abajo para probar diferentes funcionalidades de Sentry. Verifique su panel de Sentry para verificar que los eventos se están capturando.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Haga clic en los botones de abajo para probar diferentes funcionalidades de Sentry. Verifique su panel de Sentry para verificar que los eventos se están capturando.",
    "sentry_check.test_results": "Resultados de la prueba",
    "Test Results": "Resultados de la prueba",
    "sentry_check.clear": "Borrar",
    "sentry_check.no_tests": "No se han ejecutado pruebas aún",
    "No tests run yet": "No se han ejecutado pruebas aún",
    "sentry_check.important_notes": "⚠️ Notas importantes",
    "⚠️ Important Notes": "⚠️ Notas importantes",
    "sentry_check.warning_real_events": "• Estas pruebas crearán eventos de error reales en tu panel de Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Estas pruebas crearán eventos de error reales en tu panel de Sentry",
    "sentry_check.warning_dashboard": "• Revisa tu panel de Sentry para verificar que los eventos se están capturando",
    "• Check your Sentry dashboard to verify events are being captured": "• Revisa tu panel de Sentry para verificar que los eventos se están capturando",
    "sentry_check.warning_traces": "• Algunas pruebas pueden no aparecer en Sentry si tracesSampleRate es 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Algunas pruebas pueden no aparecer en Sentry si tracesSampleRate es 0.0",
    "sentry_check.warning_dsn": "• Asegúrate de que tu DSN esté configurado correctamente en las variables de entorno",
    "• Make sure your DSN is correctly configured in environment variables": "• Asegúrate de que tu DSN esté configurado correctamente en las variables de entorno",
    "sentry_check.normal_error": "Error Normal de Prueba",
    "Test Normal Error": "Error Normal de Prueba",
    "sentry_check.test_normal_error": "Error Normal de Prueba",
    "sentry_check.test_message": "Mensaje de Prueba",
    "Test Message": "Mensaje de Prueba",
    "sentry_check.test_breadcrumb": "Bocadillo de Prueba",
    "Test Breadcrumb": "Bocadillo de Prueba",
    "sentry_check.test_user_context": "Contexto de Usuario de Prueba",
    "Test User Context": "Contexto de Usuario de Prueba",
    "sentry_check.test_custom_exception": "Excepción Personalizada de Prueba",
    "Test Custom Exception": "Excepción Personalizada de Prueba",
    "sentry_check.test_promise_rejection": "Rechazo de Promesa de Prueba",
    "Test Promise Rejection": "Rechazo de Promesa de Prueba",
    "sentry_check.configuration_check": "Verificación de Configuración",
    "Configuration Check": "Verificación de Configuración",
    "sentry_check.config_loaded": "Configuración cargada con éxito",
    "Config loaded successfully": "Configuración cargada con éxito",
    "sentry_check.error_captured": "Error capturado y enviado a Sentry",
    "Error captured and sent to Sentry": "Error capturado y enviado a Sentry",
    "sentry_check.error_capture_failed": "Error al capturar: {message}",
    "Failed to capture error: {message}": "Error al capturar: {message}",
    "sentry_check.message": "Mensaje",
    "Message": "Mensaje",
    "sentry_check.message_captured": "Mensaje capturado y enviado a Sentry",
    "Message captured and sent to Sentry": "Mensaje capturado y enviado a Sentry",
    "sentry_check.message_capture_failed": "Error al capturar mensaje: {message}",
    "Failed to capture message: {message}": "Error al capturar mensaje: {message}",
    "sentry_check.breadcrumb": "Bocadillo",
    "Breadcrumb": "Bocadillo",
    "sentry_check.breadcrumb_added": "Bocadillo agregado al contexto de Sentry",
    "Breadcrumb added to Sentry context": "Bocadillo agregado al contexto de Sentry",
    "sentry_check.breadcrumb_failed": "Error al agregar bocadillo: {message}",
    "Failed to add breadcrumb: {message}": "Error al agregar bocadillo: {message}",
    "sentry_check.user_context": "Contexto de usuario",
    "User Context": "Contexto de usuario",
    "sentry_check.user_set": "Contexto de usuario establecido en Sentry",
    "User context set in Sentry": "Contexto de usuario establecido en Sentry",
    "sentry_check.user_failed": "Error al establecer el contexto de usuario: {message}",
    "Failed to set user context: {message}": "Error al establecer el contexto de usuario: {message}",
    "sentry_check.custom_exception": "Excepción personalizada",
    "Custom Exception": "Excepción personalizada",
    "sentry_check.custom_sent": "Excepción personalizada con contexto enviada a Sentry",
    "Custom exception with context sent to Sentry": "Excepción personalizada con contexto enviada a Sentry",
    "sentry_check.custom_failed": "Error al capturar excepción personalizada: {message}",
    "Failed to capture custom exception: {message}": "Error al capturar excepción personalizada: {message}",
    "sentry_check.promise_rejection": "Rechazo de promesa",
    "Promise Rejection": "Rechazo de promesa",
    "sentry_check.promise_captured": "Rechazo de promesa capturado y enviado a Sentry",
    "Promise rejection captured and sent to Sentry": "Rechazo de promesa capturado y enviado a Sentry",
    "sentry_check.promise_failed": "Error al manejar rechazo de promesa: {message}",
    "Failed to handle promise rejection: {message}": "Error al manejar rechazo de promesa: {message}",
    "checkout_settings.orders": "Pedidos",
    "checkout_settings.return_policy_days": "Días de política de devolución",
    "Return policy days": "Días de política de devolución",
    "checkout_settings.enter_return_policy_days": "Introducir días de política de devolución",
    "Enter return policy days": "Introducir días de política de devolución",
    "checkout_settings.saved": "Subido con éxito",
    "checkout_settings.cart": "Carrito",
    "checkout_settings.hide_quantity_selection": "Ocultar selección de cantidad (Predeterminado: Muestra campo para seleccionar cantidad)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Ocultar selección de cantidad (Predeterminado: Muestra campo para seleccionar cantidad)",
    "checkout_settings.enable_coupon": "Habilitar Cupón",
    "Enable Coupon": "Habilitar Cupón",
    "upgrade_page.copy.a_practical_next_step": "Un paso práctico siguiente",
    "A practical next step": "Un paso práctico siguiente",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Añadir la información estructurada que necesita tu flujo de trabajo",
    "Add the structured information your workflow needs.": "Añadir la información estructurada que necesita tu flujo de trabajo",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Asignar roles y permisos a cada compañero",
    "Assign roles and permissions to every teammate.": "Asignar roles y permisos a cada compañero",
    "upgrade_page.copy.audit_log_export": "Exportar registro de auditoría",
    "Audit log export": "Exportar registro de auditoría",
    "upgrade_page.copy.best_next_step": "Mejor paso siguiente",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Traer registros estructurados, hacer cambios fuera de línea y exportarlos cuando tu equipo necesite una copia de trabajo completa",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Traer registros estructurados, hacer cambios fuera de línea y exportarlos cuando tu equipo necesite una copia de trabajo completa",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Construir más allá de la interfaz estándar",
    "Build beyond the standard interface": "Construir más allá de la interfaz estándar",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Capturar los detalles que hacen útil tu catálogo",
    "Capture the details that make your catalogue useful.": "Capturar los detalles que hacen útil tu catálogo",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Elige la flexibilidad para crear tus propias experiencias orientadas al cliente sobre Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Elige la flexibilidad para crear tus propias experiencias orientadas al cliente sobre Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Combina listados existentes en paquetes curados y permite a los clientes seleccionar artículos elegibles en el checkout.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Combina listados existentes en paquetes curados y permite a los clientes seleccionar artículos elegibles en el checkout.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Configura las monedas que necesita tu negocio al operar en varias regiones.",
    "Configure the currencies your business needs as you operate across regions.": "Configura las monedas que necesita tu negocio al operar en varias regiones.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Conecta tu marketplace con herramientas internas y automatización cuando el trabajo manual ya no escala.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Conecta tu marketplace con herramientas internas y automatización cuando el trabajo manual ya no escala.",
    "upgrade_page.copy.connect_your_own_tools": "Conecta tus propias herramientas",
    "Connect your own tools": "Conecta tus propias herramientas",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Controla quién puede ver y cambiar qué.",
    "Control who can see and change what.": "Controla quién puede ver y cambiar qué.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Crea campos personalizados para los hechos que los clientes y tu equipo necesitan ver en cada lista o cuenta.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Crea campos personalizados para los hechos que los clientes y tu equipo necesitan ver en cada lista o cuenta.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Crea paquetes fijos y mix-and-match.",
    "Create fixed and mix-and-match bundles.": "Crea paquetes fijos y mix-and-match.",
    "upgrade_page.copy.custom_attributes": "Atributos personalizados",
    "Custom attributes": "Atributos personalizados",
    "upgrade_page.copy.custom_email_templates": "Plantillas de correo electrónico personalizadas",
    "Custom email templates": "Plantillas de correo electrónico personalizadas",
    "upgrade_page.copy.email_whitelabelling": "Blanqueo de correo electrónico",
    "Email whitelabelling": "Blanqueo de correo electrónico",
    "upgrade_page.copy.everything_in_growth": "Todo en Growth",
    "Everything in Growth": "Todo en Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Todo en Growth, con los límites más altos.",
    "Everything in Growth, with the highest limits.": "Todo en Growth, con los límites más altos.",
    "upgrade_page.copy.everything_in_starter": "Todo en Starter",
    "Everything in Starter": "Todo en Starter",
    "upgrade_page.copy.expand_your_workspace": "Amplía tu espacio de trabajo",
    "Expand your workspace": "Amplía tu espacio de trabajo",
    "upgrade_page.copy.feature_access": "Acceso a funciones",
    "Feature access": "Acceso a funciones",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Para un catálogo en crecimiento que necesita opciones de producto más claras.",
    "For a growing catalogue that needs clearer product choices.": "Para un catálogo en crecimiento que necesita opciones de producto más claras.",
    "upgrade_page.copy.for_established_businesses": "Para negocios establecidos",
    "For established businesses": "Para negocios establecidos",
    "upgrade_page.copy.for_growing_operations": "Para operaciones en crecimiento",
    "For growing operations": "Para operaciones en crecimiento",
    "upgrade_page.copy.for_growing_teams": "Para equipos en crecimiento",
    "For growing teams": "Para equipos en crecimiento",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Para equipos de alto volumen que necesitan espacio para operar a gran escala.",
    "For high-volume teams that need room to operate at scale.": "Para equipos de alto volumen que necesitan espacio para operar a gran escala.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Para equipos que gestionan un catálogo más grande y más flujos de trabajo.",
    "For teams managing a larger catalogue and more workflows.": "Para equipos que gestionan un catálogo más grande y más flujos de trabajo.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Para equipos listos para trabajar más allá de un registro a la vez.",
    "For teams ready to work beyond one record at a time.": "Para equipos listos para trabajar más allá de un registro a la vez.",
    "upgrade_page.copy.full_audit_history": "Historial de auditoría completo",
    "Full audit history": "Historial de auditoría completo",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Los planes de crecimiento y escala pueden revisar el historial de auditoría completo y exportarlo para flujos de trabajo de cumplimiento.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Los planes de crecimiento y escala pueden revisar el historial de auditoría completo y exportarlo para flujos de trabajo de cumplimiento.",
    "upgrade_page.copy.higher_usage_limits": "Límites de uso más altos",
    "Higher usage limits": "Límites de uso más altos",
    "upgrade_page.copy.highest_usage_limits": "Límites de uso más altos",
    "Highest usage limits": "Límites de uso más altos",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Importa y exporta registros sin trabajo manual repetitivo.",
    "Import and export records without repetitive manual work.": "Importa y exporta registros sin trabajo manual repetitivo.",
    "upgrade_page.copy.import_and_export_tools": "Herramientas de importación y exportación",
    "Import and export tools": "Herramientas de importación y exportación",
    "upgrade_page.copy.improve_important_customer_messages": "Mejora los mensajes importantes para los clientes",
    "Improve important customer messages": "Mejora los mensajes importantes para los clientes",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Mantén un historial de cumplimiento más largo",
    "Keep a longer compliance history": "Mantén un historial de cumplimiento más largo",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Mantén una visibilidad completa del cumplimiento para operaciones de alto volumen.",
    "Keep complete compliance visibility for high-volume operations.": "Mantén una visibilidad completa del cumplimiento para operaciones de alto volumen.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Mantén más datos y flujos de trabajo organizados a medida que crece el catálogo.",
    "Keep more data and workflows organised as the catalogue grows.": "Mantén más datos y flujos de trabajo organizados a medida que crece el catálogo.",
    "upgrade_page.copy.keep_your_workspace_secure": "Mantén tu espacio de trabajo seguro",
    "Keep your workspace secure": "Mantén tu espacio de trabajo seguro",
    "upgrade_page.copy.large": "Grande",
    "Large": "Grande",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Permite a los clientes elegir opciones desde un solo listado.",
    "Let customers choose options from one listing.": "Permite a los clientes elegir opciones desde un solo listado.",
    "upgrade_page.copy.listing_variants": "Variantes de listado",
    "Listing variants": "Variantes de listado",
    "upgrade_page.copy.make_every_customer_email_yours": "Haz que cada correo electrónico de cliente sea tuyo",
    "Make every customer email yours": "Haz que cada correo electrónico de cliente sea tuyo",
    "upgrade_page.copy.make_one_listing_work_harder": "Haz que un solo listado trabaje más duro",
    "Make one listing work harder": "Haz que un solo listado trabaje más duro",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Ajusta los correos electrónicos del sistema a tu flujo de trabajo y tono.",
    "Make system emails match your workflow and tone.": "Ajusta los correos electrónicos del sistema a tu flujo de trabajo y tono.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Hace que tu proyecto esté disponible en más idiomas.",
    "Make your project available in more languages.": "Hace que tu proyecto esté disponible en más idiomas.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Gestiona la experiencia de idioma para el cliente a medida que expandes a nuevas regiones y audiencias.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Gestiona la experiencia de idioma para el cliente a medida que expandes a nuevas regiones y audiencias.",
    "upgrade_page.copy.medium": "Mediano",
    "upgrade_page.copy.more_capacity": "Más capacidad",
    "More capacity": "Más capacidad",
    "upgrade_page.copy.more_storage": "Más almacenamiento",
    "More storage": "Más almacenamiento",
    "upgrade_page.copy.more_team_capacity": "Más capacidad para el equipo",
    "More team capacity": "Más capacidad para el equipo",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Mueve más rápido con tu catálogo",
    "Move faster with your catalogue": "Mueve más rápido con tu catálogo",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Mueve catálogos y equipos más grandes a través del trabajo rutinario más rápido.",
    "Move larger catalogues and teams through routine work faster.": "Mueve catálogos y equipos más grandes a través del trabajo rutinario más rápido.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Ofrece tallas, colores u otras opciones sin duplicar listados ni dividir la gestión de stock.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Ofrece tallas, colores u otras opciones sin duplicar listados ni dividir la gestión de stock.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Opera con los límites más altos disponibles.",
    "Operate with the highest available limits.": "Opera con los límites más altos disponibles.",
    "upgrade_page.copy.per_module_permissions": "Permisos por módulo",
    "Per-module permissions": "Permisos por módulo",
    "upgrade_page.copy.priority_support": "Soporte prioritario",
    "Priority support": "Soporte prioritario",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Revisa más de los últimos cinco eventos de auditoría.",
    "Review more than the latest five audit events.": "Revisa más de los últimos cinco eventos de auditoría.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Revisa la historia completa de auditoría a medida que tu equipo y actividad crecen.",
    "Review the full audit history as your team and activity grow.": "Revisa la historia completa de auditoría a medida que tu equipo y actividad crecen.",
    "upgrade_page.copy.role_based_access_control": "Control de acceso basado en roles",
    "Role-based access control": "Control de acceso basado en roles",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Los roles te permiten dar a cada compañero solo el acceso que necesitan. Disponible en Growth y superior.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Los roles te permiten dar a cada compañero solo el acceso que necesitan. Disponible en Growth y superior.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Ejecuta un flujo de trabajo de comunicación con clientes más sólido y pulido.",
    "Run a stronger, more polished customer communication workflow.": "Ejecuta un flujo de trabajo de comunicación con clientes más sólido y pulido.",
    "upgrade_page.copy.sell_across_markets": "Vende en mercados diversos",
    "Sell across markets": "Vende en mercados diversos",
    "upgrade_page.copy.sell_products_together": "Vende productos juntos",
    "Sell products together": "Vende productos juntos",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Envía correos electrónicos desde una marca que tus clientes reconozcan.",
    "Send email from a brand your customers recognise.": "Envía correos electrónicos desde una marca que tus clientes reconozcan.",
    "upgrade_page.copy.shape_the_information_you_collect": "Define la información que recopilas",
    "Shape the information you collect": "Define la información que recopilas",
    "upgrade_page.copy.small": "Pequeño",
    "Small": "Pequeño",
    "upgrade_page.copy.speak_to_more_customers": "Habla con más clientes",
    "Speak to more customers": "Habla con más clientes",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Estandariza datos más ricos en una operación de alto volumen.",
    "Standardise richer data across a high-volume operation.": "Estandariza datos más ricos en una operación de alto volumen.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Empieza a presentar una experiencia de cliente más consistente.",
    "Start presenting a more consistent customer experience.": "Empieza a presentar una experiencia de cliente más consistente.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Soporta una experiencia de cliente completa y lista para empresa.",
    "Support a complete enterprise-ready customer experience.": "Soporta una experiencia de cliente completa y lista para empresa.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Soporta clientes que compran en diferentes monedas.",
    "Support customers who shop in different currencies.": "Soporta clientes que compran en diferentes monedas.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Soporta flujos de trabajo operativos de alto volumen a escala.",
    "Support high-volume operational workflows at scale.": "Soporta flujos de trabajo operativos de alto volumen a escala.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Soporta flujos de trabajo y equipos más grandes.",
    "Support larger workflows and teams.": "Soporta flujos de trabajo y equipos más grandes.",
    "upgrade_page.copy.t_shirt": "Camiseta",
    "T-shirt": "Camiseta",
    "upgrade_page.copy.t_shirt_large": "Camiseta — Grande",
    "T-shirt — Large": "Camiseta — Grande",
    "upgrade_page.copy.t_shirt_medium": "Camiseta — Mediana",
    "T-shirt — Medium": "Camiseta — Mediana",
    "upgrade_page.copy.t_shirt_small": "Camiseta — Pequeña",
    "T-shirt — Small": "Camiseta — Pequeña",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Adapta los mensajes que reciben los clientes en momentos clave sin cambiar la configuración de tu mercado.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Adapta los mensajes que reciben los clientes en momentos clave sin cambiar la configuración de tu mercado.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Desbloquea más herramientas a medida que tu espacio de trabajo comienza a crecer.",
    "Unlock more tools as your workspace begins to grow.": "Desbloquea más herramientas a medida que tu espacio de trabajo comienza a crecer.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Desbloquea esta función cuando estés listo.",
    "Unlock this feature when you are ready.": "Desbloquea esta función cuando estés listo.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Utiliza APIs sin cabeza para una experiencia totalmente personalizada.",
    "Use headless APIs for a fully custom experience.": "Utiliza APIs sin cabeza para una experiencia totalmente personalizada.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Utiliza la API cuando tu flujo de trabajo necesite ir más allá.",
    "Use the API when your workflow needs to go further.": "Utiliza la API cuando tu flujo de trabajo necesite ir más allá.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Utiliza tu propia identidad de remitente y diseño visual para que las comunicaciones del mercado permanezcan consistentes.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Utiliza tu propia identidad de remitente y diseño visual para que las comunicaciones del mercado permanezcan consistentes.",
    "upgrade_page.copy.with_variants": "Con variantes",
    "With variants": "Con variantes",
    "upgrade_page.copy.without_variants": "Sin variantes",
    "Without variants": "Sin variantes",
    "upgrade_page.copy.workflow_tools": "Herramientas de flujo de trabajo",
    "Workflow tools": "Herramientas de flujo de trabajo",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Tu trabajo actual permanece sin cambios mientras comparas el plan que incluye esta capacidad.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Tu trabajo actual permanece sin cambios mientras comparas el plan que incluye esta capacidad.",
    "upgrade_page.copy.a_paid_plan": "un plan de pago",
    "a paid plan": "un plan de pago",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Todo lo que necesita una tienda en crecimiento: elimina la marca, agrega tu dominio y desbloquea más herramientas.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Todo lo que necesita una tienda en crecimiento: elimina la marca, agrega tu dominio y desbloquea más herramientas.",
    "upgrade_page.copy.everything_unlocked": "Todo desbloqueado",
    "Everything unlocked": "Todo desbloqueado",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Pila completa de IA, marketing avanzado y todo desbloqueado para tiendas serias en crecimiento.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Una nota del equipo de Tradly",
    "A note from the Tradly team": "Una nota del equipo de Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Ayúdanos a mantener Tradly en funcionamiento",
    "Help us keep Tradly going": "Ayúdanos a mantener Tradly en funcionamiento",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Nuestros costos han aumentado, y para seguir construyendo y apoyando Tradly necesitamos el apoyo de nuestra comunidad. Para continuar con tu espacio de trabajo, por favor elige un plan. Tu tienda y tus datos están seguros y esperándote. Gracias por ser parte de Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Nuestros costos han aumentado, y para seguir construyendo y apoyando Tradly necesitamos el apoyo de nuestra comunidad. Para continuar con tu espacio de trabajo, por favor elige un plan. Tu tienda y tus datos están seguros y esperándote. Gracias por ser parte de Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Desde 2019 ofrecemos Tradly con un paquete gratuito, con mucho incluido sin costo, porque queríamos que cualquiera pudiera empezar algo. Estábamos contentos de hacerlo, pero ya no podemos sostenerlo por nuestra cuenta. Planeamos traer de vuelta el plan gratuito una vez que el negocio alcance un cierto nivel, para poder devolverle a la comunidad que nos llevó hasta aquí.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Desde 2019 ofrecemos Tradly con un paquete gratuito, con mucho incluido sin costo, porque queríamos que cualquiera pudiera empezar algo. Estábamos contentos de hacerlo, pero ya no podemos sostenerlo por nuestra cuenta. Planeamos traer de vuelta el plan gratuito una vez que el negocio alcance un cierto nivel, para poder devolverle a la comunidad que nos llevó hasta aquí.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Elige el plan que te convenga hoy. Puedes cambiarlo en cualquier momento.",
    "Choose the plan that fits you today. You can change it any time.": "Elige el plan que te convenga hoy. Puedes cambiarlo en cualquier momento.",
    "upgrade_page.back_to_workspace": "Volver al espacio de trabajo",
    "Back to workspace": "Volver al espacio de trabajo",
    "upgrade_page.grow_when_ready": "Crecer cuando el trabajo lo requiera",
    "Grow when the work calls for it": "Crecer cuando el trabajo lo requiera",
    "upgrade_page.reassurance": "Tus datos, listados y configuración existentes permanecen exactamente como están.",
    "Your existing data, listings, and setup stay exactly as they are.": "Tus datos, listados y configuración existentes permanecen exactamente como están.",
    "upgrade_page.choose_plan": "Elige un plan",
    "Choose a plan": "Elige un plan",
    "upgrade_page.feature_availability": "Disponibilidad de características",
    "Feature availability": "Disponibilidad de características",
    "upgrade_page.available_from": "Disponible desde",
    "Available from": "Disponible desde",
    "upgrade_page.and_above": "y superior",
    "and above": "y superior",
    "upgrade_page.choose_when_useful": "Elige un plan solo cuando esta capacidad sea útil para tu equipo.",
    "Choose a plan only when this capability is useful to your team.": "Elige un plan solo cuando esta capacidad sea útil para tu equipo.",
    "upgrade_page.practical_difference": "La diferencia práctica",
    "The practical difference": "La diferencia práctica",
    "upgrade_page.keep_work_simple": "Mantén el trabajo más simple a medida que creces.",
    "Keep the work simpler as you grow.": "Mantén el trabajo más simple a medida que creces.",
    "upgrade_page.plan_path": "Ruta del plan",
    "Plan path": "Ruta del plan",
    "upgrade_page.plan_path_title": "Comienza con el plan que respalda este próximo paso.",
    "Start with the plan that supports this next step.": "Comienza con el plan que respalda este próximo paso.",
    "upgrade_page.best_next_step": "Mejor próximo paso",
    "upgrade_page.includes_capability": "Incluye esta capacidad",
    "Includes this capability": "Incluye esta capacidad",
    "upgrade_page.not_included": "No incluido",
    "Not included": "No incluido",
    "upgrade_page.included": "✓ Incluido",
    "✓ Included": "✓ Incluido",
    "upgrade_page.ready_when_you_are": "Listo cuando estés listo.",
    "Ready when you are.": "Listo cuando estés listo.",
    "upgrade_page.billing_details": "Revisa los detalles completos del plan y continúa de forma segura con la facturación de Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Revisa los detalles completos del plan y continúa de forma segura con la facturación de Tradly.",
    "upgrade_page.panel.close": "Cerrar panel de actualización",
    "Close upgrade panel": "Cerrar panel de actualización",
    "upgrade_page.panel.show_less": "Mostrar menos",
    "Show less": "Mostrar menos",
    "upgrade_page.panel.see_more": "Ver más",
    "See more": "Ver más",
    "upgrade_page.panel.choose_to_continue": "Elige un plan para continuar",
    "Choose a plan to continue": "Elige un plan para continuar",
    "upgrade_page.panel.more_ways_to_grow": "Más formas de crecer",
    "More ways to grow": "Más formas de crecer",
    "upgrade_page.panel.plan_includes_feature": "Cada plan incluye esta característica más capacidad adicional para tu siguiente etapa.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Cada plan incluye esta característica más capacidad adicional para tu siguiente etapa.",
    "upgrade_page.panel.add_credits": "Añadir créditos o productos",
    "Add credits or products": "Añadir créditos o productos",
    "upgrade_page.panel.ala_carte_description": "Tu espacio de trabajo se factura a la carta. Recarga créditos o añade los productos que necesitas.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Tu espacio de trabajo se factura a la carta. Recarga créditos o añade los productos que necesitas.",
    "upgrade_page.panel.open_ala_carte": "Abrir a la carta",
    "Open à la carte": "Abrir a la carta",
    "upgrade_page.panel.recommended": "Recomendado",
    "Recommended": "Recomendado",
    "upgrade_page.panel.per_month": "/ mes",
    "upgrade_page.panel.please_wait": "Espere…",
    "upgrade_page.panel.unlock_plan": "Desbloquear {plan}",
    "Unlock {plan}": "Desbloquear {plan}",
    "upgrade_page.panel.choose_plan": "Elegir {plan}",
    "Choose {plan}": "Elegir {plan}",
    "upgrade_page.panel.compare_plans": "Comparar todos los detalles del plan",
    "Compare all plan details": "Comparar todos los detalles del plan",
    "workspace.usage.page_title": "Visión general del uso",
    "Usage overview": "Visión general del uso",
    "workspace.usage.page_description": "Ver el uso actual y los límites aplicados a este espacio de trabajo.",
    "workspace.usage.not_available": "No disponible",
    "workspace.usage.limit_not_configured": "Límite no configurado",
    "Limit not configured": "Límite no configurado",
    "workspace.usage.limit_value": "Límite: {limit}",
    "Limit: {limit}": "Límite: {limit}",
    "listings.photos": "Fotos",
    "Photos": "Fotos",
    "listings.listen_episode": "Escuchar este episodio",
    "Listen to this episode": "Escuchar este episodio",
    "listings.other_listings": "Otros anuncios",
    "Other listings": "Otros anuncios",
    "listings.delete": "Eliminar",
    "listings.fulfilled_by_platform": "Cumplido por la Plataforma",
    "Fulfilled by Platform": "Cumplido por la Plataforma",
    "listings.no_attributes_set": "No se han configurado atributos",
    "No attributes set": "No se han configurado atributos",
    "listings.campaign_raised": "{amount} recaudados",
    "{amount} raised": "{amount} recaudados",
    "listings.campaign_progress": "{percent}% de {goal}",
    "{percent}% of {goal}": "{percent}% de {goal}",
    "listings.seat": "asiento",
    "seat": "asiento",
    "listings.seats": "asientos",
    "seats": "asientos",
    "listings.per_slot": "por slot",
    "per slot": "por slot",
    "listings.total_value": "Total: {total}",
    "Total: {total}": "Total: {total}",
    "listings.orders": "Pedidos",
    "listings.total_orders": "Pedidos totales",
    "Total orders": "Pedidos totales",
    "listings.revenue": "Ingresos",
    "listings.average_order": "Pedido promedio",
    "listings.customers": "Clientes",
    "Customers": "Clientes",
    "listings.load_more": "Cargar más",
    "Load more": "Cargar más",
    "listings.filter": "Filtrar",
    "listings.sort": "Ordenar",
    "Sort": "Ordenar",
    "listings.value_price": "Precio de valor",
    "Value Price": "Precio de valor",
    "listings.detail_label_title": "Título",
    "listings.detail_label_slug": "Slug",
    "listings.detail_label_description": "Descripción",
    "listings.detail_label_categories": "Categorías",
    "listings.detail_label_list_price": "Precio de lista",
    "List Price": "Precio de lista",
    "listings.detail_label_offer": "Oferta",
    "Offer": "Oferta",
    "listings.detail_label_currency": "Moneda",
    "listings.detail_label_listing_status": "Estado del listado",
    "listings.detail_label_active": "Activo",
    "listings.detail_label_sold": "Vendido",
    "listings.detail_label_meta_title": "Meta título",
    "listings.detail_label_meta_description": "Meta descripción",
    "listings.detail_label_goal": "Objetivo",
    "Goal": "Objetivo",
    "listings.detail_label_donors": "Donantes",
    "Donors": "Donantes",
    "listings.detail_label_start_date": "Fecha de inicio",
    "listings.detail_label_end_date": "Fecha de finalización",
    "listings.detail_label_stock": "Stock",
    "listings.detail_label_max_qty_order": "Cantidad máxima / pedido",
    "Max qty / order": "Cantidad máxima / pedido",
    "listings.detail_label_weight": "Peso",
    "listings.detail_label_dimensions": "Dimensiones",
    "Dimensions": "Dimensiones",
    "listings.detail_label_listing_period": "Período de listado",
    "Listing period": "Período de listado",
    "listings.detail_label_max_tickets_booking": "Máx. entradas / reserva",
    "Max tickets / booking": "Máx. entradas / reserva",
    "listings.detail_label_rating": "Valoración",
    "listings.detail_label_reviews": "Comentarios",
    "listings.detail_label_likes": "Me gusta",
    "Likes": "Me gusta",
    "listings.detail_label_dislikes": "No me gusta",
    "Dislikes": "No me gusta",
    "listings.detail_label_barcode": "Código de barras",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Información básica",
    "Basic Info": "Información básica",
    "listings.detail_section_pricing": "Precios",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Seleccione un tipo de listado arriba para continuar.",
    "Select a listing type above to continue.": "Seleccione un tipo de listado arriba para continuar.",
    "listing_form.attributes": "Atributos",
    "category.status_active_help": "Estado (Inactivo / Activo)",
    "promotions.medium": "Medio",
    "users.listings": "Listados",
    "users.accounts": "Cuentas",
    "users.click_count_one": "{count} clic",
    "{count} click": "{count} clic",
    "users.click_count": "{count} clics",
    "{count} clicks": "{count} clics",
    "integrations.generic.provider_help": "Configura el proveedor seleccionado utilizando los campos de abajo.",
    "Configure the selected provider using the fields below.": "Configura el proveedor seleccionado utilizando los campos de abajo.",
    "attributes.editor_prefill_data_from": "Rellenar datos desde",
    "Prefill Data From": "Rellenar datos desde",
    "attributes.editor_select_attribute": "Seleccionar Atributo",
    "Select Attribute": "Seleccionar Atributo",
    "attributes.editor_select_attribute_group": "Seleccionar Grupo de Atributos",
    "Select Attribute Group": "Seleccionar Grupo de Atributos",
    "attributes.editor_attribute": "Atributo",
    "Attribute": "Atributo",
    "attributes.editor_attributes": "Atributos",
    "attributes.editor_cart_attributes": "Atributos del Carro",
    "Cart Attributes": "Atributos del Carro",
    "listings.add_photo": "Añadir Foto",
    "accounts.analytics": "Analíticas",
    "listings.image_optional": "Imágenes de Listado (Opcional)",
    "Listing Images (Optional)": "Imágenes de Listado (Opcional)",
    "listings.currency": "Moneda",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "Activo",
    "listing_form.digital_deleted_item_cannot_edit": "Este artículo está marcado para eliminación y no se puede editar",
    "This item is marked for deletion and cannot be edited": "Este artículo está marcado para eliminación y no se puede editar",
    "listing_form.digital_max_files": "Máximo 10 archivos permitidos",
    "Maximum 10 files allowed": "Máximo 10 archivos permitidos",
    "listing_form.digital_title_required": "Por favor, introduzca un título",
    "listing_form.digital_version_required": "Por favor, introduzca un nombre de versión",
    "Please enter a version name": "Por favor, introduzca un nombre de versión",
    "listing_form.digital_contents": "Contenido Digital",
    "Digital Contents": "Contenido Digital",
    "listing_form.digital_add_content": "+ Añadir Contenido",
    "+ Add Content": "+ Añadir Contenido",
    "listing_form.no_description": "Sin descripción",
    "No description": "Sin descripción",
    "listing_form.digital_file_count": "{count} archivo(s)",
    "{count} file(s)": "{count} archivo(s)",
    "listing_form.digital_empty": "Aún no hay contenidos digitales",
    "No digital contents yet": "Aún no hay contenidos digitales",
    "listing_form.digital_empty_help": "Haga clic en \"{action}\" para crear su primer contenido digital",
    "Click \"{action}\" to create your first digital content": "Haga clic en \"{action}\" para crear su primer contenido digital",
    "listing_form.digital_marked_for_deletion": "Marcado para eliminación ({count})",
    "Marked for Deletion ({count})": "Marcado para eliminación ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Se eliminará al enviar",
    "✓ Will be deleted on submit": "✓ Se eliminará al enviar",
    "listing_form.digital_edit_title": "Editar contenido digital",
    "Edit Digital Content": "Editar contenido digital",
    "listing_form.digital_add_title": "Agregar nuevo contenido digital",
    "Add New Digital Content": "Agregar nuevo contenido digital",
    "listing_form.digital_form_description": "Rellene los detalles a continuación para {action} contenido digital",
    "Fill in the details below to {action} digital content": "Rellene los detalles a continuación para {action} contenido digital",
    "listing_form.digital_title_placeholder": "Ingrese el título del contenido digital",
    "Enter digital content title": "Ingrese el título del contenido digital",
    "listing_form.description_optional_placeholder": "Ingrese descripción (opcional)",
    "Enter description (optional)": "Ingrese descripción (opcional)",
    "listing_form.version": "Versión",
    "Version": "Versión",
    "listing_form.files": "Archivos",
    "Files": "Archivos",
    "listing_form.max_files": "(Máx {count})",
    "(Max {count})": "(Máx {count})",
    "listing_form.click_to_upload_files": "Haga clic para subir archivos",
    "Click to upload files": "Haga clic para subir archivos",
    "listing_form.files_uploaded_count": "{count}/10 archivos subidos",
    "{count}/10 files uploaded": "{count}/10 archivos subidos",
    "listing_form.unknown_size": "Tamaño desconocido",
    "Unknown size": "Tamaño desconocido",
    "listing_form.no_accounts_available": "No hay cuentas disponibles",
    "No accounts available": "No hay cuentas disponibles",
    "listing_form.select_account": "Seleccione una cuenta",
    "Select an account": "Seleccione una cuenta",
    "listing_form.searching": "Buscando...",
    "Searching...": "Buscando...",
    "listing_form.location_enter_address": "Por favor, introduzca una dirección para buscar",
    "Please enter an address to search": "Por favor, introduzca una dirección para buscar",
    "listing_form.location_no_addresses_search": "No se encontraron direcciones. Por favor, intente una búsqueda diferente.",
    "No addresses found. Please try a different search.": "No se encontraron direcciones. Por favor, intente una búsqueda diferente.",
    "listing_form.location_search_failed": "Error al buscar direcciones. Por favor, inténtelo de nuevo.",
    "Failed to search addresses. Please try again.": "Error al buscar direcciones. Por favor, inténtelo de nuevo.",
    "listing_form.location_place_details_failed": "Error al obtener detalles del lugar. Por favor, inténtelo de nuevo.",
    "Failed to get place details. Please try again.": "Error al obtener detalles del lugar. Por favor, inténtelo de nuevo.",
    "listing_form.location_access_denied": "Acceso a la ubicación denegado. Por favor, habilite los permisos de ubicación.",
    "Location access denied. Please enable location permissions.": "Acceso a la ubicación denegado. Por favor, habilite los permisos de ubicación.",
    "listing_form.location_unavailable": "No se puede determinar la ubicación. Por favor, inténtelo de nuevo.",
    "Unable to determine location. Please try again.": "No se puede determinar la ubicación. Por favor, inténtelo de nuevo.",
    "listing_form.location_timeout": "Tiempo de espera agotado para la solicitud de ubicación. Por favor, inténtelo de nuevo.",
    "Location request timed out. Please try again.": "Tiempo de espera agotado para la solicitud de ubicación. Por favor, inténtelo de nuevo.",
    "listing_form.location_current_failed": "Error al obtener la ubicación actual. Por favor, inténtelo de nuevo.",
    "Failed to get current location. Please try again.": "Error al obtener la ubicación actual. Por favor, inténtelo de nuevo.",
    "listing_form.location": "Ubicación",
    "listing_form.location_search_placeholder": "Buscar una ubicación...",
    "Search for a location...": "Buscar una ubicación...",
    "listing_form.location_searching": "Buscando direcciones...",
    "Searching addresses...": "Buscando direcciones...",
    "listing_form.location_no_addresses": "No se encontraron direcciones",
    "No addresses found": "No se encontraron direcciones",
    "listing_form.location_try_different_search": "Prueba un término de búsqueda diferente",
    "Try a different search term": "Prueba un término de búsqueda diferente",
    "listing_form.location_getting": "Obteniendo ubicación...",
    "Getting location...": "Obteniendo ubicación...",
    "listing_form.location_use_current": "Usar ubicación actual",
    "Use Current Location": "Usar ubicación actual",
    "listing_form.location_selected": "Ubicación seleccionada",
    "Selected Location": "Ubicación seleccionada",
    "listing_form.latitude": "Latitud:",
    "Latitude:": "Latitud:",
    "listing_form.longitude": "Longitud:",
    "Longitude:": "Longitud:",
    "listing_form.location_helper": "Busca una dirección o usa tu ubicación actual",
    "Search for an address or use your current location": "Busca una dirección o usa tu ubicación actual",
    "common.change": "Cambiar",
    "listing_form.variant_id_tooltip": "Tipo ID: {typeId}, Valor ID: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "Tipo ID: {typeId}, Valor ID: {valueId}",
    "listing_form.variants_marked_for_deletion": "Marcado para eliminación ({count} elementos):",
    "Marked for Deletion ({count} items):": "Marcado para eliminación ({count} elementos):",
    "listing_form.add_new_variant": "Agregar nuevo variante",
    "Add New Variant": "Agregar nuevo variante",
    "listing_form.add_variant_description": "Completa los detalles a continuación para crear una nueva variante",
    "Fill in the details below to create a new variant": "Completa los detalles a continuación para crear una nueva variante",
    "listing_form.google_search_preview": "Vista previa de búsqueda de Google",
    "Google Search Preview": "Vista previa de búsqueda de Google",
    "listing_form.meta_title_preview": "Tu título meta aquí",
    "Your Meta Title Here": "Tu título meta aquí",
    "listing_form.meta_description_preview": "Tu descripción meta aparecerá aquí. Esto ayuda a los usuarios a entender el contenido de tu página en los resultados de búsqueda.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Tu descripción meta aparecerá aquí. Esto ayuda a los usuarios a entender el contenido de tu página en los resultados de búsqueda.",
    "listing_form.variant_name_placeholder": "Introduce nombre",
    "listing_form.list_price_placeholder": "Introduce precio de lista",
    "listing_form.offer_percent_placeholder": "Introduce porcentaje de oferta",
    "Enter Offer Percent": "Introduce porcentaje de oferta",
    "attributes.select_all": "Seleccionar todo",
    "attributes.unselect_all": "Deseleccionar todo",
    "Unselect All": "Deseleccionar todo",
    "attributes.select_category": "Seleccionar categoría",
    "attributes.create_category_configuration_first": "Crea categorías en la configuración {type} primero",
    "Create categories in {type} configuration first": "Crea categorías en la configuración {type} primero",
    "attributes.select_single_attribute_values": "Seleccionar valores de atributo único",
    "attributes.select_multiple_attribute_values": "Seleccionar valores de atributo múltiple",
    "attributes.enter_value": "Introducir valor",
    "attributes.enter_multiple_tags": "Introducir múltiples etiquetas",
    "Enter Multiple Tags": "Introducir múltiples etiquetas",
    "attributes.upload_file": "Subir archivo",
    "collections.add_condition": "+ Añadir otra condición",
    "+ Add another condition": "+ Añadir otra condición",
    "collections.add_photo": "Añadir foto",
    "collections.status": "Estado (Inactivo / Activo)",
    "collections.start_date_placeholder": "Seleccionar fecha de inicio",
    "Select start date": "Seleccionar fecha de inicio",
    "collections.end_date_placeholder": "Seleccionar fecha de finalización",
    "Select end date": "Seleccionar fecha de finalización",
    "navigation.editor": "Editor",
    "Editor": "Editor",
    "navigation.web_analytics": "Análisis web",
    "Web Analytics": "Análisis web",
    "navigation.ai_studio": "Estudio de IA",
    "AI Studio": "Estudio de IA",
    "navigation.docs": "Documentos",
    "navigation.logout": "Cerrar sesión",
    "Logout": "Cerrar sesión",
    "navigation.tenant_name_placeholder": "(Nombre de inquilino)",
    "(Tenant name)": "(Nombre de inquilino)",
    "navigation.username_placeholder": "(Nombre de usuario)",
    "(Username)": "(Nombre de usuario)",
    "navigation.invite_description": "Envía enlaces de invitación a los miembros del equipo",
    "Send invitation links to team members": "Envía enlaces de invitación a los miembros del equipo",
    "navigation.invite": "Invitar",
    "Invite": "Invitar",
    "navigation.test_mode": "Modo de prueba",
    "Test Mode": "Modo de prueba",
    "navigation.upgrade": "Actualizar",
    "navigation.open_account_menu": "Abrir menú de cuenta",
    "Open account menu": "Abrir menú de cuenta",
    "navigation.invite_name_required": "Por favor, complete el nombre",
    "Please fill in the name": "Por favor, complete el nombre",
    "navigation.invite_email_required": "Complete el correo electrónico",
    "Please fill in the email": "Complete el correo electrónico",
    "navigation.open_url_failed": "No sé cómo abrir esta URL: {url}",
    "Don't know how to open this URL: {url}": "No sé cómo abrir esta URL: {url}",
    "navigation.no_code_editor": "Editor sin código",
    "No-code editor": "Editor sin código",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Automatización de marketing",
    "Marketing automation": "Automatización de marketing",
    "navigation.analytics_recommendation": "Análisis y recomendación",
    "Analytics & Recommendation": "Análisis y recomendación",
    "navigation.ai_studio_iryxo": "Estudio de IA (Iryxo)",
    "AI Studio (Iryxo)": "Estudio de IA (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Proyecto actual",
    "Current project": "Proyecto actual",
    "navigation.current_user": "Usuario actual",
    "Current user": "Usuario actual",
    "navigation.switch_to_light_mode": "Cambiar a modo claro",
    "Switch to light mode": "Cambiar a modo claro",
    "navigation.switch_to_dark_mode": "Cambiar a modo oscuro",
    "Switch to dark mode": "Cambiar a modo oscuro",
    "navigation.download_android_app": "Descargar aplicación Android",
    "Download Android app": "Descargar aplicación Android",
    "navigation.download_ios_app": "Descargar aplicación iOS",
    "Download iOS app": "Descargar aplicación iOS",
    "navigation.subscribe_youtube": "Suscribirse a YouTube",
    "Subscribe on YouTube": "Suscribirse a YouTube",
    "navigation.open_app_switcher": "Abrir selector de aplicaciones",
    "Open app switcher": "Abrir selector de aplicaciones",
    "navigation.open_android_app": "Abrir aplicación Android",
    "Open Android app": "Abrir aplicación Android",
    "navigation.open_ios_app": "Abrir aplicación iOS",
    "Open iOS app": "Abrir aplicación iOS",
    "navigation.open_ai_support": "Abrir soporte Tradly ChatGPT",
    "Open Tradly ChatGPT support": "Abrir soporte Tradly ChatGPT",
    "navigation.open_youtube_channel": "Abrir canal de YouTube Tradly",
    "Open Tradly YouTube channel": "Abrir canal de YouTube Tradly",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "ID de lista (opcional — actualizar existente)",
    "Listing ID (optional — update existing)": "ID de lista (opcional — actualizar existente)",
    "listings.smart_upload.category_id": "ID de categoría",
    "listings.smart_upload.list_price": "Precio de lista",
    "listings.smart_upload.stock": "Stock",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Código de barras",
    "listings.smart_upload.account_id": "ID de cuenta",
    "listings.smart_upload.slug": "Slug",
    "listings.smart_upload.text": "Texto",
    "listings.smart_upload.long_text": "Texto largo",
    "listings.smart_upload.number": "Número",
    "listings.smart_upload.single_select": "Selección única",
    "listings.smart_upload.multi_select": "Selección múltiple",
    "listings.smart_upload.attribute_name_required": "Ingrese un nombre de atributo para «{header}».",
    "listings.smart_upload.attribute_create_failed": "Tradly no devolvió el nuevo atributo «{name}».",
    "Tradly did not return the new “{name}” attribute.": "Tradly no devolvió el nuevo atributo «{name}».",
    "listings.smart_upload.attribute_option_create_failed": "No se pudo crear la opción «{value}» para {name}.",
    "Could not create the “{value}” option for {name}.": "No se pudo crear la opción «{value}» para {name}.",
    "listings.smart_upload.attribute_no_longer_available": "El atributo mapeado desde «{header}» ya no está disponible.",
    "listings.smart_upload.csv_needs_header_and_listing": "El CSV debe contener una fila de encabezados y al menos una lista.",
    "The CSV must contain a header row and at least one listing.": "El CSV debe contener una fila de encabezados y al menos una lista.",
    "listings.smart_upload.unique_headers_required": "Cada columna de lista necesita un encabezado único y no vacío.",
    "Every listing column needs a unique, non-empty header.": "Cada columna de lista necesita un encabezado único y no vacío.",
    "listings.smart_upload.csv_read_failed": "No se puede leer este CSV.",
    "listings.smart_upload.map_required_fields": "Mapee estas columnas requeridas antes de continuar: {fields}",
    "Map these required columns before continuing: {fields}": "Mapee estas columnas requeridas antes de continuar: {fields}",
    "listings.smart_upload.row_missing_required_value": "La fila {row} carece de un valor requerido.",
    "Row {row} is missing a required value.": "La fila {row} carece de un valor requerido.",
    "listings.smart_upload.invalid_category_id_row": "La fila {row} necesita un ID de categoría numérico válido, o elija «Mapear ID de categoría manualmente».",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "La fila {row} necesita un ID de categoría numérico válido, o elija «Mapear ID de categoría manualmente».",
    "listings.smart_upload.invalid_listing_id_row": "La fila {row} necesita un ID de lista numérico válido, o deje el ID en blanco para crear una nueva lista.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "La fila {row} necesita un ID de lista numérico válido, o deje el ID en blanco para crear una nueva lista.",
    "listings.smart_upload.progress.checking_duplicates": "Comprobando listados existentes",
    "Checking for existing listings": "Comprobando listados existentes",
    "listings.smart_upload.duplicate_same_value_row": "El mismo {field} aparece en la fila {row} de este archivo.",
    "Same {field} appears in row {row} of this file.": "El mismo {field} aparece en la fila {row} de este archivo.",
    "listings.smart_upload.duplicate_same_value_multiple": "El mismo {field} aparece más de una vez en este archivo.",
    "Same {field} appears more than once in this file.": "El mismo {field} aparece más de una vez en este archivo.",
    "listings.smart_upload.duplicate_existing_listing": "Coincide con el listado existente #{id} por {field}.",
    "Matches existing listing #{id} by {field}.": "Coincide con el listado existente #{id} por {field}.",
    "listings.smart_upload.explicit_listing_update": "Se actualizará el ID de listado explícito #{id}.",
    "Explicit listing ID #{id} will be updated.": "Se actualizará el ID de listado explícito #{id}.",
    "listings.smart_upload.progress.duplicates_complete": "Comprobación de duplicados completada",
    "Duplicate check complete": "Comprobación de duplicados completada",
    "listings.smart_upload.duplicate_check_failed": "No se pudo comprobar los listados existentes.",
    "Could not check existing listings.": "No se pudo comprobar los listados existentes.",
    "listings.smart_upload.progress.duplicates_stopped": "Comprobación de duplicados detenida",
    "Duplicate check stopped": "Comprobación de duplicados detenida",
    "listings.smart_upload.prepare_file_failed": "No se pudo preparar el archivo de importación.",
    "listings.smart_upload.progress.uploading_file": "Subiendo archivo de importación",
    "listings.smart_upload.upload_file_failed": "No se pudo subir el archivo de importación.",
    "listings.smart_upload.all_rows_duplicates": "Todas las filas se identificaron como duplicados. Elija «Importar de todos modos» para enviarlas a Tradly, o empiece de nuevo.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Todas las filas se identificaron como duplicados. Elija «Importar de todos modos» para enviarlas a Tradly, o empiece de nuevo.",
    "listings.smart_upload.progress.preparing_attributes": "Preparando atributos",
    "listings.smart_upload.attribute_mapped_once": "Cada atributo de listado solo puede asignarse una vez. Revise los mapeos de columnas antes de importar.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Cada atributo de listado solo puede asignarse una vez. Revise los mapeos de columnas antes de importar.",
    "listings.smart_upload.progress.preparing_file": "Preparando archivo de importación",
    "listings.smart_upload.progress.tradly_importing": "Tradly está importando listados",
    "Tradly is importing listings": "Tradly está importando listados",
    "listings.smart_upload.progress.import_complete": "Importación completada",
    "listings.smart_upload.progress.import_stopped": "Importación detenida",
    "listings.smart_upload.progress.preparing_import": "Preparando importación…",
    "Preparing import…": "Preparando importación…",
    "listings.smart_upload.progress.rows_prepared": "{current} de {total} filas preparadas",
    "{current} of {total} rows prepared": "{current} de {total} filas preparadas",
    "listings.smart_upload.progress.remote_processing": "Tradly está procesando el CSV subido. Esto puede tardar un momento.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly está procesando el CSV subido. Esto puede tardar un momento.",
    "listings.smart_upload.progress.partial_import": "Tradly importó {imported} de {total} filas{ending}. Revise el resultado antes de reintentar; un reintento completo podría duplicar filas exitosas.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly importó {imported} de {total} filas{ending}. Revise el resultado antes de reintentar; un reintento completo podría duplicar filas exitosas.",
    "listings.smart_upload.title": "Carga inteligente",
    "Smart Upload": "Carga inteligente",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Empezar de nuevo",
    "listings.smart_upload.description": "Suba listados, asigne columnas a campos existentes o cree nuevos atributos de listado antes de importar.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Suba listados, asigne columnas a campos existentes o cree nuevos atributos de listado antes de importar.",
    "listings.smart_upload.step_upload": "Subir",
    "listings.smart_upload.step_match": "Asignar columnas",
    "listings.smart_upload.step_preview": "Vista previa",
    "listings.smart_upload.step_import": "Importar",
    "listings.smart_upload.choose_csv": "Seleccionar un archivo CSV",
    "listings.smart_upload.required_columns_help": "Las columnas requeridas son título y category_id. Cualquier otra columna puede convertirse en un atributo de lista.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Las columnas requeridas son título y category_id. Cualquier otra columna puede convertirse en un atributo de lista.",
    "listings.smart_upload.select_csv_file": "Seleccionar archivo CSV",
    "listings.smart_upload.match_columns": "Asignar columnas de lista",
    "Match listing columns": "Asignar columnas de lista",
    "listings.smart_upload.core_fields_help": "Los campos principales se envían a la API de lista. Otras columnas pueden guardarse como atributos de lista.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Los campos principales se envían a la API de lista. Otras columnas pueden guardarse como atributos de lista.",
    "listings.smart_upload.do_not_import": "No importar",
    "listings.smart_upload.map_category_manually": "Asignar ID de categoría manualmente",
    "Map Category ID manually": "Asignar ID de categoría manualmente",
    "listings.smart_upload.category_assignment_help": "Elija la categoría para asignar a cada lista importada.",
    "Choose the category to assign to every imported listing.": "Elija la categoría para asignar a cada lista importada.",
    "listings.smart_upload.select_category": "Seleccionar una categoría",
    "listings.smart_upload.no_categories": "No se devolvieron categorías de lista. Cree una categoría primero, luego vuelva a abrir Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "No se devolvieron categorías de lista. Cree una categoría primero, luego vuelva a abrir Smart Upload.",
    "listings.smart_upload.additional_attributes": "Atributos adicionales de lista",
    "Additional listing attributes": "Atributos adicionales de lista",
    "listings.smart_upload.ignore_column": "Ignorar esta columna",
    "listings.smart_upload.create_attribute": "＋ Crear un nuevo atributo de lista",
    "＋ Create a new listing attribute": "＋ Crear un nuevo atributo de lista",
    "listings.smart_upload.attribute_name": "Nombre del atributo",
    "listings.smart_upload.review_import": "Revisar importación",
    "listings.smart_upload.rows_scanned_help": "{count} listados escaneados antes de la carga. Las comprobaciones de duplicados usan SKU, código de barras, slug y valores repetidos en este CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} listados escaneados antes de la carga. Las comprobaciones de duplicados usan SKU, código de barras, slug y valores repetidos en este CSV.",
    "listings.smart_upload.duplicates_found": "Se encontraron posibles duplicados",
    "Potential duplicates found": "Se encontraron posibles duplicados",
    "listings.smart_upload.duplicate_rows_skipped": "{count} fila(s) se omitirán por defecto.",
    "{count} row(s) will be skipped by default.": "{count} fila(s) se omitirán por defecto.",
    "listings.smart_upload.row_label": "Fila",
    "Row": "Fila",
    "listings.smart_upload.explicit_ids_are_updates": "Las filas con un ID de lista explícito se tratan como actualizaciones.",
    "Rows with an explicit listing ID are treated as updates.": "Las filas con un ID de lista explícito se tratan como actualizaciones.",
    "listings.smart_upload.duplicate_action": "Acción duplicada",
    "Duplicate action": "Acción duplicada",
    "listings.smart_upload.skip_duplicates": "Saltar duplicados potenciales (recomendado)",
    "Skip potential duplicates (recommended)": "Saltar duplicados potenciales (recomendado)",
    "listings.smart_upload.import_all_anyway": "Importar todas las filas de todos modos",
    "Import all rows anyway": "Importar todas las filas de todos modos",
    "listings.smart_upload.untitled_listing": "Listado sin título",
    "Untitled listing": "Listado sin título",
    "listings.smart_upload.category_label": "Categoría:",
    "Category:": "Categoría:",
    "listings.smart_upload.complete": "Smart Upload completado",
    "listings.smart_upload.imported_count": "{imported} de {total} listados importados.",
    "{imported} of {total} listings imported.": "{imported} de {total} listados importados.",
    "listings.smart_upload.selected_file": "Seleccionado: {name}",
    "listings.smart_upload.checking": "Comprobando…",
    "listings.smart_upload.check_duplicates": "Comprobar duplicados",
    "Check duplicates": "Comprobar duplicados",
    "listings.smart_upload.importing": "Importando…",
    "listings.smart_upload.import_listings": "Importar listados",
    "listings.smart_upload.failed": "Smart Upload fallido.",
    "Smart Upload failed.": "Smart Upload fallido.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Estado (Inactivo / Activo)",
    "listings.upload_media": "Subir medios",
    "listing_form.stock_placeholder": "Introducir stock",
    "orders.create_order.order_items_alt": "Artículos del pedido",
    "orders.create_order.by": "por",
    "by": "por",
    "orders.create_order.decrease_quantity": "Disminuir cantidad",
    "Decrease quantity": "Disminuir cantidad",
    "orders.create_order.increase_quantity": "Aumentar cantidad",
    "Increase quantity": "Aumentar cantidad",
    "orders.create_order.remove_item": "Eliminar artículo",
    "Remove item": "Eliminar artículo",
    "orders.create_order.rental_period_label": "Período de alquiler:",
    "Rental period:": "Período de alquiler:",
    "attributes.enter_text": "Introducir texto",
    "attributes.select_date": "Seleccionar fecha",
    "attributes.enter_number": "Ingresar número",
    "attributes.select_color": "Seleccionar color",
    "attributes.upload_json": "Subir JSON",
    "Upload JSON": "Subir JSON",
    "attributes.select_location": "Seleccionar ubicación",
    "attributes.add_listing_preview": "Agregar lista",
    "attributes.add_account_preview": "Agregar cuenta",
    "attributes.enter_price": "Ingresar precio",
    "attributes.preview": "Vista previa",
    "attributes.enter_title": "Ingresar título",
    "attributes.enter_description": "Ingresar descripción",
    "attributes.category": "Categoría",
    "attributes.attribute_name": "Nombre del atributo",
    "attributes.enter_attribute_name": "Ingresar nombre del atributo",
    "attributes.select_type": "Seleccionar tipo",
    "attributes.icon": "Icono",
    "attributes.tooltip": "Ayuda emergente",
    "Tooltip": "Ayuda emergente",
    "attributes.enter_tooltip": "Ingresar tooltip",
    "Enter attribute tooltip": "Ingresar tooltip",
    "listings.detail.images": "Imágenes",
    "listings.detail.posted_by": "Publicado por",
    "Posted by": "Publicado por",
    "listings.detail.fulfilled_by_platform": "Cumplido por la Plataforma",
    "listings.detail.preview": "Vista previa",
    "listings.detail.view_listing": "Ver lista",
    "View Listing": "Ver lista",
    "listings.detail.variants": "Variantes",
    "listings.detail.no_attribute_values": "No hay valores de atributo para {name}",
    "listings.detail.attributes": "Atributos",
    "listings.detail.starts_from": "Comienza desde:",
    "Starts From:": "Comienza desde:",
    "listings.detail.schedule": "Horario",
    "listings.detail.detail": "Detalle",
    "web_config.download": "Descargar",
    "web_config.cancel": "Cancelar",
    "web_config.choose_file": "Seleccionar archivo",
    "web_config.title": "Configuraciones web",
    "Web Configs": "Configuraciones web",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Ancho del logo",
    "Logo Width": "Ancho del logo",
    "web_config.width": "Ancho",
    "web_config.logo_height": "Alto del logo",
    "Logo Height": "Alto del logo",
    "web_config.height": "Alto",
    "web_config.social_share_image": "Imagen destacada para redes sociales - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Imagen destacada para redes sociales - Open Graph",
    "web_config.business_name": "Nombre del negocio",
    "web_config.enter_web_name": "Ingrese nombre del sitio",
    "Enter web name": "Ingrese nombre del sitio",
    "web_config.title_font": "Fuente del título",
    "Title Font": "Fuente del título",
    "web_config.select_title_font": "Seleccione fuente del título",
    "Select title font": "Seleccione fuente del título",
    "web_config.body_font": "Fuente del cuerpo",
    "Body Font": "Fuente del cuerpo",
    "web_config.select_body_font": "Seleccione fuente del cuerpo",
    "Select body font": "Seleccione fuente del cuerpo",
    "web_config.primary_font": "Fuente principal",
    "Primary Font": "Fuente principal",
    "web_config.select_primary_font": "Seleccione fuente principal",
    "Select primary font": "Seleccione fuente principal",
    "web_config.uploaded_successfully": "Subido con éxito",
    "web_config.ios_download_icon": "Icono de descarga de la app iOS",
    "iOS app download icon": "Icono de descarga de la app iOS",
    "web_config.ios_download_link": "Enlace de descarga de la app iOS",
    "iOS app download link": "Enlace de descarga de la app iOS",
    "web_config.enter_ios_download_link": "Introducir enlace de descarga de la app iOS",
    "Enter iOS app download link": "Introducir enlace de descarga de la app iOS",
    "web_config.android_download_icon": "Icono de descarga de la app Android",
    "Android app download icon": "Icono de descarga de la app Android",
    "web_config.android_download_link": "Enlace de descarga de la app Android",
    "Android app download link": "Enlace de descarga de la app Android",
    "web_config.enter_android_download_link": "Introducir enlace de descarga de la app Android",
    "Enter android app download link": "Introducir enlace de descarga de la app Android",
    "coupons.preview.customer_checkout": "PAGO DEL CLIENTE",
    "CUSTOMER CHECKOUT": "PAGO DEL CLIENTE",
    "coupons.preview.title": "Cupones en acción",
    "Coupons in action": "Cupones en acción",
    "coupons.preview.featured_product": "Su producto destacado",
    "Your featured product": "Su producto destacado",
    "coupons.preview.product_meta": "1 artículo · Entrega estándar",
    "1 item · Standard delivery": "1 artículo · Entrega estándar",
    "coupons.preview.coupon_applied": "Cupón aplicado",
    "Coupon applied": "Cupón aplicado",
    "coupons.preview.remove": "Eliminar",
    "coupons.preview.discount_applied": "Descuento aplicado al pedido",
    "Discount applied to the order": "Descuento aplicado al pedido",
    "coupons.preview.subtotal": "Subtotal",
    "coupons.preview.coupon_label": "Cupón · WELCOME10",
    "Coupon · WELCOME10": "Cupón · WELCOME10",
    "coupons.preview.grand_total": "Total general",
    "Grand total": "Total general",
    "coupons.preview.checkout": "PAGAR",
    "CHECKOUT": "PAGAR",
    "payments.stripe_get_keys": "Obtener claves de Stripe",
    "Get Stripe keys": "Obtener claves de Stripe",
    "payments.stripe_syncing": "Sincronizando con Stripe...",
    "Syncing with Stripe...": "Sincronizando con Stripe...",
    "payments.stripe_verifying_key": "Verificando clave secreta",
    "Verifying secret key": "Verificando clave secreta",
    "payments.stripe_creating_webhook": "Creando webhook de pago",
    "Creating payment webhook": "Creando webhook de pago",
    "payments.stripe_account_summary": "{country} · {mode} modo · {id}",
    "{country} · {mode} mode · {id}": "{country} · {mode} modo · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhooks configurados — claves secretas rellenadas automáticamente. Guarde el formulario para persistir.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhooks configurados — claves secretas rellenadas automáticamente. Guarde el formulario para persistir.",
    "payments.stripe_webhooks_error": "⚠ La configuración del webhook falló. Verifica los permisos de tu clave e intenta sincronizar de nuevo.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ La configuración del webhook falló. Verifica los permisos de tu clave e intenta sincronizar de nuevo.",
    "payments.stripe_invalid_key": "Clave secreta no válida. Verifica e intenta de nuevo.",
    "Invalid secret key. Check and try again.": "Clave secreta no válida. Verifica e intenta de nuevo.",
    "payments.stripe_setup_failed": "Configuración fallida. Asegúrate de que tu clave secreta esté sincronizada primero.",
    "Setup failed. Make sure your secret key is synced first.": "Configuración fallida. Asegúrate de que tu clave secreta esté sincronizada primero.",
    "payments.stripe_marketplace_connect": "Conexión de Marketplace",
    "Marketplace Connect": "Conexión de Marketplace",
    "payments.stripe_marketplace_hint": "Solo necesario si usas Stripe Connect para pagos de mercado.",
    "Only needed if you use Stripe Connect for marketplace payouts": "Solo necesario si usas Stripe Connect para pagos de mercado.",
    "payments.stripe_subscription_hint": "Solo necesario si vendes productos de suscripción en Tradly.",
    "Only needed if you sell subscription products on Tradly": "Solo necesario si vendes productos de suscripción en Tradly.",
    "integrations.sso.title": "Inicio de sesión único empresarial",
    "Enterprise single sign-on": "Inicio de sesión único empresarial",
    "integrations.sso.description": "Conecta tu proveedor de identidad corporativa para que el personal asignado pueda iniciar sesión en ArcticWhale con OIDC. Se admiten Okta, Microsoft Entra ID y proveedores OIDC que firman tokens de identidad con RS256.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Conecta tu proveedor de identidad corporativa para que el personal asignado pueda iniciar sesión en ArcticWhale con OIDC. Se admiten Okta, Microsoft Entra ID y proveedores OIDC que firman tokens de identidad con RS256.",
    "integrations.sso.issuer_url": "URL del emisor",
    "Issuer URL": "URL del emisor",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID de cliente",
    "integrations.sso.client_secret": "Secreto del cliente",
    "integrations.sso.secret_replace_placeholder": "Guardado de forma segura. Introduce un valor para reemplazarlo.",
    "Saved securely. Enter a value to replace it.": "Guardado de forma segura. Introduce un valor para reemplazarlo.",
    "integrations.sso.secret_placeholder": "Introduce el secreto del cliente",
    "Enter the client secret": "Introduce el secreto del cliente",
    "integrations.sso.email_domains": "Dominios de correo corporativo",
    "Company email domains": "Dominios de correo corporativo",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "El personal debe tener una cuenta de ArcticWhale y acceso a este tenant. Usa dominios propiedad de tu organización.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "El personal debe tener una cuenta de ArcticWhale y acceso a este tenant. Usa dominios propiedad de tu organización.",
    "integrations.sso.callback_url": "URL de devolución de llamada OIDC",
    "OIDC callback URL": "URL de devolución de llamada OIDC",
    "integrations.sso.loading_callback_url": "Cargando URL de devolución de llamada…",
    "Loading callback URL…": "Cargando URL de devolución de llamada…",
    "integrations.sso.callback_help": "Añade esta URL exacta a la aplicación del proveedor de identidad como URI de redirección web.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Añade esta URL exacta a la aplicación del proveedor de identidad como URI de redirección web.",
    "integrations.sso.enable": "Habilitar inicio de sesión SSO empresarial",
    "Enable company SSO sign-in": "Habilitar inicio de sesión SSO empresarial",
    "integrations.sso.checking": "Comprobando…",
    "integrations.sso.test_issuer": "Probar emisor",
    "Test issuer": "Probar emisor",
    "integrations.sso.saving": "Guardando…",
    "integrations.sso.save": "Guardar configuración SSO",
    "Save SSO settings": "Guardar configuración SSO",
    "integrations.sso.security_help": "El secreto del cliente se cifra antes de almacenarse. SSO agrega una opción de inicio de sesión de organización; el inicio de sesión con contraseña permanece sin cambios en esta configuración.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "El secreto del cliente se cifra antes de almacenarse. SSO agrega una opción de inicio de sesión de organización; el inicio de sesión con contraseña permanece sin cambios en esta configuración.",
    "integrations.sso.load_error": "No se pueden cargar las configuraciones de SSO empresarial.",
    "Unable to load enterprise SSO settings.": "No se pueden cargar las configuraciones de SSO empresarial.",
    "integrations.sso.save_error": "No se pueden guardar las configuraciones de SSO empresarial.",
    "Unable to save enterprise SSO settings.": "No se pueden guardar las configuraciones de SSO empresarial.",
    "integrations.sso.saved": "Configuraciones de SSO empresarial guardadas.",
    "Enterprise SSO settings saved.": "Configuraciones de SSO empresarial guardadas.",
    "integrations.sso.connection_ok": "El descubrimiento del proveedor de identidad es accesible.",
    "Identity provider discovery is reachable.": "El descubrimiento del proveedor de identidad es accesible.",
    "integrations.sso.connection_error": "No se puede conectar con el proveedor de identidad.",
    "Unable to connect to the identity provider.": "No se puede conectar con el proveedor de identidad.",
    "listing_configs.maximum_quantity_per_listing": "Cantidad máxima por anuncio",
    "listing_configs.example_quantity": "(Ejemplo: 100)",
    "listing_configs.enter_maximum_quantity": "Ingrese la cantidad máxima por anuncio",
    "Enter maximum quantity per listing": "Ingrese la cantidad máxima por anuncio",
    "listing_configs.minimum_listing_price": "Precio mínimo por anuncio",
    "listing_configs.example_price": "(Ejemplo: $5)",
    "listing_configs.enter_minimum_price": "Ingrese el precio mínimo por anuncio",
    "Enter minimum listing price": "Ingrese el precio mínimo por anuncio",
    "listing_configs.picture_count": "Cantidad de imágenes que se pueden subir",
    "listing_configs.enter_picture_count": "Ingrese la cantidad de imágenes",
    "Enter Pictures count": "Ingrese la cantidad de imágenes",
    "listing_configs.feature_activation": "ACTIVACIÓN DE CARACTERÍSTICAS",
    "FEATURE ACTIVATION": "ACTIVACIÓN DE CARACTERÍSTICAS",
    "listing_configs.example_landmark": "(Ejemplo: Punto de referencia)",
    "listing_configs.enter_address_label": "Ingrese la etiqueta de dirección",
    "Enter address Label": "Ingrese la etiqueta de dirección",
    "listing_configs.legacy_switch_0": "¿Aprobar automáticamente los anuncios?",
    "listing_configs.legacy_switch_1": "Oferta porcentual",
    "listing_configs.legacy_switch_2": "Restricciones de cantidad máxima en el nivel de anuncio",
    "listing_configs.legacy_switch_3": "Cargos de envío",
    "listing_configs.legacy_switch_4": "Usar marcador de mapa en lugar de buscar dirección",
    "Use map marker instead \nof searching address": "Usar marcador de mapa en lugar de buscar dirección",
    "listing_configs.legacy_switch_5": "Etiquetas",
    "listing_configs.legacy_switch_6": "Existencias",
    "listing_configs.legacy_switch_7": "Dirección geográfica",
    "listing_configs.legacy_switch_8": "Mostrar listados agotados en el feed",
    "listing_configs.legacy_switch_9": "Slug del título de la lista",
    "listing_configs.legacy_switch_10": "Variantes",
    "listing_configs.legacy_switch_11": "Meta título",
    "listing_configs.legacy_switch_12": "Meta descripción",
    "listing_configs.legacy_switch_13": "Producto digital",
    "Digital Product": "Producto digital",
    "listing_configs.legacy_switch_14": "Habilitar Composer",
    "listing_configs.legacy_switch_15": "Habilitar peso",
    "listing_configs.legacy_switch_16": "Habilitar dimensiones",
    "navigation.app_download.close": "Cerrar",
    "navigation.app_download.eyebrow": "Compañero móvil",
    "Mobile companion": "Compañero móvil",
    "navigation.app_download.title": "Mantén tu proyecto en movimiento.",
    "Keep your project moving.": "Mantén tu proyecto en movimiento.",
    "navigation.app_download.description": "Gestiona lo esencial desde tu teléfono, desde aprobar nuevas listas hasta revisar pedidos y mantener tu negocio en marcha.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Gestiona lo esencial desde tu teléfono, desde aprobar nuevas listas hasta revisar pedidos y mantener tu negocio en marcha.",
    "navigation.app_download.approve_listings": "Aprobar listas",
    "Approve listings": "Aprobar listas",
    "navigation.app_download.manage_orders": "Gestionar pedidos",
    "Manage orders": "Gestionar pedidos",
    "navigation.app_download.check_performance": "Ver rendimiento",
    "Check performance": "Ver rendimiento",
    "navigation.app_download.download_title": "Descargar la aplicación SuperAdmin",
    "Download the SuperAdmin app": "Descargar la aplicación SuperAdmin",
    "navigation.app_download.download_on": "Descargar en",
    "Download on the": "Descargar en",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Obténlo en",
    "Get it on": "Obténlo en",
    "listing_configs.address_label": "Etiqueta de dirección",
    "collections.add_another_condition": "+ Añadir otra condición",
    "collections.search": "Buscar",
    "collections.status_inactive_active": "Estado (No activo / Activo)",
    "media_picker.add_photo": "Agregar foto",
    "payments.payment_intent_webhook_secret": "Secreto de webhook de intención de pago",
    "Payment Intent Webhook secret": "Secreto de webhook de intención de pago",
    "payments.subscription_webhook_secret": "Secreto de webhook de suscripción",
    "Subscription Webhook secret": "Secreto de webhook de suscripción",
    "payments.webhook_secret_autofilled": "Secreto de webhook rellenado automáticamente arriba — guarde el formulario para persistir.",
    "Webhook secret auto-filled above — save the form to persist.": "Secreto de webhook rellenado automáticamente arriba — guarde el formulario para persistir.",
    "app_customization.white_png_icon_help": "El icono debe ser blanco y en formato png",
    "icon should be white and in png format": "El icono debe ser blanco y en formato png",
    "app_customization.other_appearance": "Otra apariencia",
    "Other appearance": "Otra apariencia",
    "app_customization.notification_icon": "Icono de notificación",
    "Notification icon": "Icono de notificación",
    "app_customization.app_title_home": "Título de la aplicación en pantalla de inicio",
    "app_customization.enable_app_title_icon": "Habilitar icono de título de aplicación en lugar de texto",
    "listings.quick_add.title": "Agregar lista rápida",
    "Quick Add Listing": "Agregar lista rápida",
    "listings.quick_add.success": "Lista agregada con éxito",
    "Listing Added Successfully": "Lista agregada con éxito",
    "listings.quick_add.image": "Imagen",
    "listings.quick_add.listing_name": "Nombre de la lista",
    "Listing Name": "Nombre de la lista",
    "listings.quick_add.title_placeholder": "ej.: Auriculares inalámbricos Premium",
    "e.g., Premium Wireless Headphones": "ej.: Auriculares inalámbricos Premium",
    "listings.quick_add.category": "Categoría",
    "listings.quick_add.select_category": "Seleccionar categoría",
    "listings.quick_add.price": "Precio",
    "listings.quick_add.stock": "Stock",
    "listings.quick_add.description": "Descripción",
    "listings.quick_add.description_placeholder": "Descripción breve de su producto...",
    "Brief Description of your product...": "Descripción breve de su producto...",
    "listings.quick_add.more_options": "¿Necesita más opciones? Use el formulario completo.",
    "Need more options? Use the full": "¿Necesita más opciones? Use el formulario completo.",
    "listings.quick_add.guided_form": "formulario guiado",
    "guided form": "formulario guiado",
    "listings.quick_add.instead": "en lugar de",
    "instead": "en lugar de",
    "listings.digital_product.title": "Agregar producto digital",
    "Add Digital Product": "Agregar producto digital",
    "listings.digital_product.select_file": "Seleccionar archivo",
    "Select file": "Seleccionar archivo",
    "listings.digital_product.name": "Título",
    "listings.digital_product.version": "Versión",
    "listings.digital_product.description": "Descripción",
    "web_config.social_info": "Información social",
    "Social Info": "Información social",
    "web_config.social_facebook_pageurl": "URL de página de Facebook",
    "Facebook page URL": "URL de página de Facebook",
    "web_config.enter_social_facebook_pageurl": "Introduzca la URL de la página de Facebook",
    "Enter Facebook page URL": "Introduzca la URL de la página de Facebook",
    "web_config.social_twitter_handleurl": "URL de manejador de Twitter",
    "Twitter handle URL": "URL de manejador de Twitter",
    "web_config.enter_social_twitter_handleurl": "Introduzca la URL del manejador de Twitter",
    "Enter Twitter handle URL": "Introduzca la URL del manejador de Twitter",
    "web_config.social_instagram_url": "URL de Instagram",
    "Instagram URL": "URL de Instagram",
    "web_config.enter_social_instagram_url": "Introduzca la URL de Instagram",
    "Enter Instagram URL": "Introduzca la URL de Instagram",
    "web_config.social_youtube_channelurl": "URL del canal de Youtube",
    "Youtube channel URL": "URL del canal de Youtube",
    "web_config.enter_social_youtube_channelurl": "Introduzca la URL del canal de Youtube",
    "Enter Youtube channel URL": "Introduzca la URL del canal de Youtube",
    "web_config.social_tiktok_url": "URL de Tiktok",
    "Tiktok URL": "URL de Tiktok",
    "web_config.enter_social_tiktok_url": "Introduzca la URL de Tiktok",
    "Enter Tiktok URL": "Introduzca la URL de Tiktok",
    "web_config.social_spotify_url": "URL de Spotify",
    "Spotify URL": "URL de Spotify",
    "web_config.enter_social_spotify_url": "Introduzca la URL de Spotify",
    "Enter Spotify URL": "Introduzca la URL de Spotify",
    "web_config.social_whatsapp_number": "Número de Whatsapp",
    "Whatsapp number": "Número de Whatsapp",
    "web_config.enter_social_whatsapp_number": "Introduzca el número de Whatsapp",
    "Enter Whatsapp number": "Introduzca el número de Whatsapp",
    "web_config.social_telegram_url": "URL de Telegram",
    "Telegram URL": "URL de Telegram",
    "web_config.enter_social_telegram_url": "Introduzca la URL de Telegram",
    "Enter Telegram URL": "Introduzca la URL de Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Introducir Snapchat",
    "Enter Snapchat": "Introducir Snapchat",
    "payments.paydunya.title": "Integración de PayDunya",
    "PayDunya Integration": "Integración de PayDunya",
    "payments.paydunya.master_key": "Clave maestra",
    "Master key": "Clave maestra",
    "payments.paydunya.enter_master_key": "Introducir clave maestra",
    "Enter master key": "Introducir clave maestra",
    "payments.paydunya.public_key": "Clave pública",
    "Public key": "Clave pública",
    "payments.paydunya.enter_public_key": "Introducir clave pública",
    "payments.paydunya.private_key": "Clave privada",
    "Private key": "Clave privada",
    "payments.paydunya.enter_private_key": "Introducir clave privada",
    "Enter private key": "Introducir clave privada",
    "payments.paydunya.token": "Token",
    "payments.paydunya.enter_token": "Introducir token",
    "payments.paydunya.uploaded_successfully": "Subido con éxito",
    "communications.email_stats_open": "{sent} enviado · {openRate}% abierto",
    "{sent} sent · {openRate}% open": "{sent} enviado · {openRate}% abierto",
    "communications.email_stats_full": "{sent} enviados · {openRate}% abierto · {clicks} clics",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} enviados · {openRate}% abierto · {clicks} clics",
    "navigation.mini_apps.title": "Miniaplicaciones",
    "Mini Apps": "Miniaplicaciones",
    "navigation.mini_apps.subtitle": "Herramientas complementarias creadas con Tradly — toca una tarjeta para ver detalles y precios",
    "Tradly-built companion tools — tap a card to see details and pricing": "Herramientas complementarias creadas con Tradly — toca una tarjeta para ver detalles y precios",
    "navigation.mini_apps.soon": "Pronto",
    "Soon": "Pronto",
    "navigation.mini_apps.included_in_paid_plan": "Incluido en un plan de pago",
    "Included in a paid plan": "Incluido en un plan de pago",
    "navigation.mini_apps.know_more": "Saber más",
    "Know more": "Saber más",
    "navigation.mini_apps.hide_details": "Ocultar detalles",
    "Hide details": "Ocultar detalles",
    "navigation.mini_apps.view_plans": "Ver planes",
    "navigation.mini_apps.remove": "Eliminar",
    "navigation.mini_apps.add_to_sidebar": "Agregar a la barra lateral",
    "Add to sidebar": "Agregar a la barra lateral",
    "navigation.mini_apps.why_heading": "¿Por qué su negocio lo necesita?",
    "Why your business needs it": "¿Por qué su negocio lo necesita?",
    "navigation.mini_apps.coming_soon": "Próximamente",
    "navigation.mini_apps.workflow.title": "Marketing",
    "navigation.mini_apps.workflow.description": "Ejecuta campañas de correo electrónico, notificaciones push y promociones para aumentar tu audiencia.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Ejecuta campañas de correo electrónico, notificaciones push y promociones para aumentar tu audiencia.",
    "navigation.mini_apps.workflow.why_1": "Envía campañas de correo electrónico dirigidas a compradores y vendedores según su actividad",
    "Send targeted email campaigns to buyers and sellers based on activity": "Envía campañas de correo electrónico dirigidas a compradores y vendedores según su actividad",
    "navigation.mini_apps.workflow.why_2": "Notificaciones push para reenganchar usuarios que no han visitado en 7+ días",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Notificaciones push para reenganchar usuarios que no han visitado en 7+ días",
    "navigation.mini_apps.workflow.why_3": "Realiza promociones con descuentos programados para tus eventos estacionales",
    "Run promotions with coupon drops timed to your seasonal events": "Realiza promociones con descuentos programados para tus eventos estacionales",
    "navigation.mini_apps.workflow.pricing_label": "Basado en créditos",
    "Credits-based": "Basado en créditos",
    "navigation.mini_apps.workflow.pricing_detail": "Paga por envío — 1.000 correos cuestan 100 créditos. Los créditos nunca caducan.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Paga por envío — 1.000 correos cuestan 100 créditos. Los créditos nunca caducan.",
    "navigation.mini_apps.intelligence_section.title": "Inteligencia",
    "navigation.mini_apps.intelligence_section.description": "Entiende tu crecimiento con análisis, embudos y consejos impulsados por IA.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Entiende tu crecimiento con análisis, embudos y consejos impulsados por IA.",
    "navigation.mini_apps.intelligence_section.why_1": "Ve qué listados, cuentas y categorías generan más GMV",
    "See which listings, accounts, and categories drive the most GMV": "Ve qué listados, cuentas y categorías generan más GMV",
    "navigation.mini_apps.intelligence_section.why_2": "Los embudos de abandono muestran exactamente dónde los compradores se van antes de pagar",
    "Drop-off funnels show exactly where buyers leave before checkout": "Los embudos de abandono muestran exactamente dónde los compradores se van antes de pagar",
    "navigation.mini_apps.intelligence_section.why_3": "La IA detecta anomalías y oportunidades que pasarías por alto en los datos sin procesar",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "La IA detecta anomalías y oportunidades que pasarías por alto en los datos sin procesar",
    "navigation.mini_apps.intelligence_section.pricing_label": "Basado en créditos",
    "navigation.mini_apps.intelligence_section.pricing_detail": "El análisis de IA y los informes generados consumen créditos. Las vistas de datos siempre son gratuitas.",
    "AI analysis and generated reports consume credits. Data views are always free.": "El análisis de IA y los informes generados consumen créditos. Las vistas de datos siempre son gratuitas.",
    "navigation.mini_apps.subscription_section.title": "Suscripción",
    "navigation.mini_apps.subscription_section.description": "Administra planes, ciclos de facturación y derechos de acceso a funciones para tus inquilinos.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Administra planes, ciclos de facturación y derechos de acceso a funciones para tus inquilinos.",
    "navigation.mini_apps.subscription_section.why_1": "Crea planes escalonados (Gratis / Pro / Empresa) con puertas por función",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Crea planes escalonados (Gratis / Pro / Empresa) con puertas por función",
    "navigation.mini_apps.subscription_section.why_2": "Automatiza ciclos de facturación — mensuales, anuales o duraciones personalizadas",
    "Automate billing cycles — monthly, annual, or custom durations": "Automatiza ciclos de facturación — mensuales, anuales o duraciones personalizadas",
    "navigation.mini_apps.subscription_section.why_3": "Los derechos de acceso activan o restringen funciones en toda tu base de inquilinos",
    "Entitlements unlock or restrict features across your tenant base": "Los derechos de acceso activan o restringen funciones en toda tu base de inquilinos",
    "navigation.mini_apps.subscription_section.pricing_label": "Conectar",
    "Connect": "Conectar",
    "navigation.mini_apps.subscription_section.pricing_detail": "Precios por tarea — se cobra por evento de suscripción (actualización, renovación, cancelación).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Precios por tarea — se cobra por evento de suscripción (actualización, renovación, cancelación).",
    "navigation.mini_apps.membership_section.title": "Membresía",
    "navigation.mini_apps.membership_section.description": "Administra programas de membresía, miembros inscritos, contribuciones y pagos.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Administra programas de membresía, miembros inscritos, contribuciones y pagos.",
    "navigation.mini_apps.membership_section.why_1": "Administra programas de membresía y miembros inscritos",
    "Manage membership programs and enrolled members": "Administra programas de membresía y miembros inscritos",
    "navigation.mini_apps.membership_section.why_2": "Seguimiento de contribuciones, deudas de pago y estado de membresía",
    "Track contributions, payment dues, and membership status": "Seguimiento de contribuciones, deudas de pago y estado de membresía",
    "navigation.mini_apps.membership_section.why_3": "Conectar las contribuciones de membresía a sus pedidos",
    "Connect membership contributions back to their orders": "Conectar las contribuciones de membresía a sus pedidos",
    "navigation.mini_apps.membership_section.pricing_label": "Precios TBC",
    "Pricing TBC": "Precios TBC",
    "navigation.mini_apps.membership_section.pricing_detail": "Administra programas de membresía y el historial de contribuciones en un solo lugar.",
    "Manage membership programs and contribution history in one place.": "Administra programas de membresía y el historial de contribuciones en un solo lugar.",
    "navigation.mini_apps.reward_programs.title": "Recompensas",
    "navigation.mini_apps.reward_programs.description": "Crea programas de recompensas con ámbitos, reglas y recetas de recompensas reutilizables.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Crea programas de recompensas con ámbitos, reglas y recetas de recompensas reutilizables.",
    "navigation.mini_apps.reward_programs.why_1": "Define programas de recompensas para afiliados, referidos, regionales o de tienda",
    "Define affiliate, referral, regional, or store reward programs": "Define programas de recompensas para afiliados, referidos, regionales o de tienda",
    "navigation.mini_apps.reward_programs.why_2": "Construye reglas a partir de componentes reutilizables de comisión y recompensa",
    "Build rules from reusable commission and reward components": "Construye reglas a partir de componentes reutilizables de comisión y recompensa",
    "navigation.mini_apps.reward_programs.why_3": "Mantén la gestión de cálculo y entrega de registros de recompensas por parte del backend del ERP",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Mantén la gestión de cálculo y entrega de registros de recompensas por parte del backend del ERP",
    "navigation.mini_apps.reward_programs.pricing_label": "Precios TBC",
    "navigation.mini_apps.reward_programs.pricing_detail": "Configura programas de recompensas y conéctalos a la atribución.",
    "Configure reward programs and connect them to attribution.": "Configura programas de recompensas y conéctalos a la atribución.",
    "navigation.mini_apps.bundles_app.title": "Paquetes",
    "navigation.mini_apps.bundles_app.description": "Crea paquetes fijos y mix-and-match a partir de listados existentes.",
    "Create fixed and mix-and-match bundles from existing listings.": "Crea paquetes fijos y mix-and-match a partir de listados existentes.",
    "navigation.mini_apps.bundles_app.why_1": "Combina listados existentes sin duplicar datos de productos",
    "Combine existing listings without duplicating product data": "Combina listados existentes sin duplicar datos de productos",
    "navigation.mini_apps.bundles_app.why_2": "Soporta paquetes fijos y paquetes mix-and-match seleccionados por el cliente",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Soporta paquetes fijos y paquetes mix-and-match seleccionados por el cliente",
    "navigation.mini_apps.bundles_app.why_3": "Valida el stock de componentes antes de la compra y cumplimiento",
    "Validate component stock before checkout and fulfilment": "Valida el stock de componentes antes de la compra y cumplimiento",
    "navigation.mini_apps.bundles_app.pricing_label": "Característica de paquete de pago",
    "Paid package feature": "Característica de paquete de pago",
    "navigation.mini_apps.bundles_app.pricing_detail": "Disponible en planes que incluyen operaciones de paquetes.",
    "Available on plans that include bundle operations.": "Disponible en planes que incluyen operaciones de paquetes.",
    "navigation.mini_apps.inventory_section.title": "Cadena de suministro",
    "navigation.mini_apps.inventory_section.description": "Inventario, órdenes de compra, ubicaciones de stock, proveedores y operaciones.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Inventario, órdenes de compra, ubicaciones de stock, proveedores y operaciones.",
    "navigation.mini_apps.inventory_section.why_1": "Seguimiento de niveles de stock en múltiples almacenes y ubicaciones de tienda",
    "Track stock levels across multiple warehouses and store locations": "Seguimiento de niveles de stock en múltiples almacenes y ubicaciones de tienda",
    "navigation.mini_apps.inventory_section.why_2": "Genera órdenes de compra con proveedores y recibe stock contra ellas",
    "Raise purchase orders with suppliers and receive stock against them": "Genera órdenes de compra con proveedores y recibe stock contra ellas",
    "navigation.mini_apps.inventory_section.why_3": "Registra operaciones de inventario — ajustes, transferencias y escrituración",
    "Record inventory operations — adjustments, transfers, and write-offs": "Registra operaciones de inventario — ajustes, transferencias y escrituración",
    "navigation.mini_apps.inventory_section.pricing_label": "Incluido",
    "Included": "Incluido",
    "navigation.mini_apps.inventory_section.pricing_detail": "La cadena de suministro está incluida en tu plan. Sin cargo adicional.",
    "Supply Chain is included in your plan. No additional charge.": "La cadena de suministro está incluida en tu plan. Sin cargo adicional.",
    "navigation.mini_apps.people_app.title": "Personas",
    "navigation.mini_apps.people_app.description": "Directorio de personal, departamentos, perfiles de trabajo y escalafones salariales.",
    "Staff directory, departments, job profiles, and pay grades.": "Directorio de personal, departamentos, perfiles de trabajo y escalafones salariales.",
    "navigation.mini_apps.people_app.why_1": "Mantén todos los perfiles de personal, códigos y tipos de empleo en un solo directorio",
    "Keep every staff profile, code, and employment type in one directory": "Mantén todos los perfiles de personal, códigos y tipos de empleo en un solo directorio",
    "navigation.mini_apps.people_app.why_2": "Organiza equipos en departamentos con perfiles de trabajo estándar",
    "Organise teams into departments with standard job profiles": "Organiza equipos en departamentos con perfiles de trabajo estándar",
    "navigation.mini_apps.people_app.why_3": "Define los escalafones salariales una vez y asígnales a los empleados",
    "Define pay grades once and assign them to staff": "Define los escalafones salariales una vez y asígnales a los empleados",
    "navigation.mini_apps.people_app.pricing_label": "Precios TBC",
    "navigation.mini_apps.people_app.pricing_detail": "Requerido por el Personal y Nómina.",
    "Required by Workforce and Payroll.": "Requerido por el Personal y Nómina.",
    "navigation.mini_apps.workforce_app.title": "Fuerza laboral",
    "navigation.mini_apps.workforce_app.description": "Gestión de turnos, asistencia y permisos para tu equipo.",
    "Shifts, attendance, and leave management for your team.": "Gestión de turnos, asistencia y permisos para tu equipo.",
    "navigation.mini_apps.workforce_app.why_1": "Asigna personal a turnos según fecha, hora y ubicación",
    "Roster staff into shifts by date, time, and location": "Asigna personal a turnos según fecha, hora y ubicación",
    "navigation.mini_apps.workforce_app.why_2": "Marca tu entrada y salida con un historial completo de asistencia",
    "Clock in and out with a full attendance history": "Marca tu entrada y salida con un historial completo de asistencia",
    "navigation.mini_apps.workforce_app.why_3": "Políticas de permisos, saldos y un flujo de trabajo para aprobación/rechazo",
    "Leave policies, balances, and an approve/reject workflow": "Políticas de permisos, saldos y un flujo de trabajo para aprobación/rechazo",
    "navigation.mini_apps.workforce_app.pricing_label": "Precios TBC",
    "navigation.mini_apps.workforce_app.pricing_detail": "Activa automáticamente el Personal.",
    "Turns on People automatically.": "Activa automáticamente el Personal.",
    "navigation.mini_apps.payroll_app.title": "Nómina",
    "navigation.mini_apps.payroll_app.description": "Ejecución de nóminas, aprobaciones, exportación CSV y reembolsos de gastos.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Ejecución de nóminas, aprobaciones, exportación CSV y reembolsos de gastos.",
    "navigation.mini_apps.payroll_app.why_1": "Crea ejecuciones de nómina por período desde los escalafones salariales de los empleados",
    "Create payroll runs per period from staff pay grades": "Crea ejecuciones de nómina por período desde los escalafones salariales de los empleados",
    "navigation.mini_apps.payroll_app.why_2": "Aprueba ejecuciones y exporta como CSV para tu banco o contable",
    "Approve runs and export them as CSV for your bank or accountant": "Aprueba ejecuciones y exporta como CSV para tu banco o contable",
    "navigation.mini_apps.payroll_app.why_3": "Reclamaciones de gastos de personal desde la presentación hasta el reembolso",
    "Staff expense claims from submission to reimbursement": "Reclamaciones de gastos de personal desde la presentación hasta el reembolso",
    "navigation.mini_apps.payroll_app.pricing_label": "Precios TBC",
    "navigation.mini_apps.payroll_app.pricing_detail": "Activa automáticamente el Personal.",
    "navigation.mini_apps.unified_inbox.title": "Buzón unificado",
    "Unified Inbox": "Buzón unificado",
    "navigation.mini_apps.unified_inbox.description": "Toda tu comunicación con clientes — pedidos, soporte y chat — desde un solo lugar.",
    "All your customer communication — orders, support, and chat — from one place.": "Toda tu comunicación con clientes — pedidos, soporte y chat — desde un solo lugar.",
    "navigation.mini_apps.unified_inbox.why_1": "Consulta de pedidos, tickets de soporte y mensajes de compradores en una sola vista de hilo",
    "Order queries, support tickets, and buyer messages in one thread view": "Consulta de pedidos, tickets de soporte y mensajes de compradores en una sola vista de hilo",
    "navigation.mini_apps.unified_inbox.why_2": "Responde con respuestas sugeridas por IA entrenadas en tu catálogo",
    "Reply with AI-suggested responses trained on your catalogue": "Responde con respuestas sugeridas por IA entrenadas en tu catálogo",
    "navigation.mini_apps.unified_inbox.why_3": "Etiqueta, asigna y resuelve conversaciones en todo tu equipo",
    "Tag, assign, and resolve conversations across your team": "Etiqueta, asigna y resuelve conversaciones en todo tu equipo",
    "navigation.mini_apps.unified_inbox.pricing_label": "Conectar",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Precios basados en tareas por conversación resuelta.",
    "Task-based pricing per resolved conversation.": "Precios basados en tareas por conversación resuelta.",
    "navigation.mini_apps.social_connect.title": "Conectar redes sociales",
    "Social Connect": "Conectar redes sociales",
    "navigation.mini_apps.social_connect.description": "Comparte listados en canales sociales según el horario que definas.",
    "Share listings to social channels on a schedule you define.": "Comparte listados en canales sociales según el horario que definas.",
    "navigation.mini_apps.social_connect.why_1": "Programa publicaciones de listados en Instagram, Facebook y X automáticamente",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Programa publicaciones de listados en Instagram, Facebook y X automáticamente",
    "navigation.mini_apps.social_connect.why_2": "Define horarios de publicación por canal — descuentos diarios, ventas flash o cadencia personalizada",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Define horarios de publicación por canal — descuentos diarios, ventas flash o cadencia personalizada",
    "navigation.mini_apps.social_connect.why_3": "Rastrea clics y engagement de cada lista desde el panel de control",
    "Track clicks and engagement back to each listing from the dashboard": "Rastrea clics y engagement de cada lista desde el panel de control",
    "navigation.mini_apps.social_connect.pricing_label": "Conectar",
    "navigation.mini_apps.social_connect.pricing_detail": "Precios basados en tareas por publicación programada entregada.",
    "Task-based pricing per scheduled post delivered.": "Precios basados en tareas por publicación programada entregada.",
    "navigation.mini_apps.shopping_channels.title": "Canal de compras",
    "Shopping Channels": "Canal de compras",
    "navigation.mini_apps.shopping_channels.description": "Conecta tu catálogo a TikTok Shop, Shopee, Meta Catalog, Uber Eats y más.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Conecta tu catálogo a TikTok Shop, Shopee, Meta Catalog, Uber Eats y más.",
    "navigation.mini_apps.shopping_channels.why_1": "Sincroniza tus listados a TikTok Shop, Shopee y Meta Catalog instantáneamente",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Sincroniza tus listados a TikTok Shop, Shopee y Meta Catalog instantáneamente",
    "navigation.mini_apps.shopping_channels.why_2": "Conecta catálogos de alimentos y bebidas a Uber Eats y Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Conecta catálogos de alimentos y bebidas a Uber Eats y Grab",
    "navigation.mini_apps.shopping_channels.why_3": "El inventario y las órdenes se sincronizan automáticamente — sin entrada doble",
    "Inventory and orders sync back automatically — no double-entry": "El inventario y las órdenes se sincronizan automáticamente — sin entrada doble",
    "navigation.mini_apps.shopping_channels.pricing_label": "Conectar",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Precios basados en tareas por pedido cumplido a través de un canal conectado.",
    "Task-based pricing per order fulfilled through a connected channel.": "Precios basados en tareas por pedido cumplido a través de un canal conectado.",
    "listing_configs.customize_table": "Personalizar tabla",
    "Customize table": "Personalizar tabla",
    "listing_configs.fields_visible": "Campos visibles en tabla",
    "Fields visible in table": "Campos visibles en tabla",
    "listing_configs.fields_hidden": "Campos no mostrados en tabla",
    "Fields not shown in table": "Campos no mostrados en tabla",
    "listing_configs.reset_default": "Restablecer a predeterminado",
    "listing_configs.column_title": "Título de columna",
    "listing_configs.column_actions": "Acciones",
    "listing_configs.column_website": "Sitio web",
    "listing_configs.column_list_price": "Precio de lista",
    "listing_configs.column_offer_percent": "Porcentaje de oferta",
    "Offer Percent": "Porcentaje de oferta",
    "listing_configs.column_image": "Imagen",
    "listing_configs.column_offer_price": "Precio de oferta",
    "Offer Price": "Precio de oferta",
    "listing_configs.column_status": "Estado",
    "listing_configs.column_listing_id": "ID de lista",
    "listing_configs.column_listing_status": "Estado de la lista",
    "listing_configs.column_accounts": "Cuentas",
    "listing_configs.column_currency": "Moneda",
    "listing_configs.column_sold": "Vendido",
    "listing_configs.column_goal_amount": "Monto objetivo",
    "Goal Amount": "Monto objetivo",
    "listing_configs.column_width": "Ancho",
    "listing_configs.column_height": "Alto",
    "listing_configs.column_weight": "Peso",
    "listing_configs.column_volume": "Volumen",
    "Volume": "Volumen",
    "listing_configs.column_order_type": "Tipo de pedido",
    "Order Type": "Tipo de pedido",
    "navigation.apps_group": "Aplicaciones",
    "navigation.channels_group": "Canales",
    "navigation.manage_mini_apps": "Administrar Mini Apps",
    "Manage Mini Apps": "Administrar Mini Apps",
    "navigation.manage_channels": "Administrar Canales",
    "Manage Channels": "Administrar Canales",
    "listings.import.uploading": "Subiendo...",
    "listings.import.complete": "Importación completa",
    "listings.import.error": "Error: {message}",
    "Error: {message}": "Error: {message}",
    "listings.import.file_label": "Archivo:",
    "listings.import.select_file": "Seleccionar archivo",
    "listings.import.response": "Respuesta de importación",
    "Import response": "Respuesta de importación",
    "listings.import.total_rows": "Filas totales:",
    "Total rows:": "Filas totales:",
    "listings.import.total_imported": "Importado total:",
    "Total imported:": "Importado total:",
    "listings.import.download_template": "Descargar plantilla de listados",
    "Download listings template": "Descargar plantilla de listados",
    "common.upload": "Subir",
    "common.kanban_unavailable": "La vista de tablero no está disponible temporalmente",
    "Board view is temporarily unavailable": "La vista de tablero no está disponible temporalmente",
    "common.retry": "Reintentar",
    "Retry": "Reintentar",
    "listings.digital_assets.title": "Activos digitales",
    "Digital assets": "Activos digitales",
    "listings.digital_assets.not_found": "No se encontraron activos digitales",
    "Digital assets not found": "No se encontraron activos digitales",
    "listings.addon.saved": "Complemento guardado con éxito.",
    "Add-on saved successfully.": "Complemento guardado con éxito.",
    "listings.addon.title_required": "Por favor, ingrese un título.",
    "Please enter a title.": "Por favor, ingrese un título.",
    "listings.addon.price_required": "Por favor, ingrese un precio.",
    "Please enter a price.": "Por favor, ingrese un precio.",
    "listings.addon.no_media": "No tiene archivos multimedia.",
    "listings.addon.price": "Precio",
    "listings.addon.offer_percentage": "Porcentaje de oferta",
    "Offer Percentage": "Porcentaje de oferta",
    "listings.addon.maximum_quantity": "Cantidad máxima",
    "Maximum Quantity": "Cantidad máxima",
    "listings.addon.stock": "Stock",
    "listings.addon.enter_price": "Ingrese precio",
    "Enter price": "Ingrese precio",
    "listings.addon.enter_offer_percentage": "Ingrese porcentaje de oferta",
    "Enter offer percentage": "Ingrese porcentaje de oferta",
    "listings.addon.enter_maximum_quantity": "Ingrese cantidad máxima",
    "Enter maximum quantity": "Ingrese cantidad máxima",
    "listings.addon.enter_stock": "Ingrese stock",
    "listings.addon.edit_title": "Editar complemento",
    "Edit Add-on": "Editar complemento",
    "listings.addon.add_title": "Añadir complemento",
    "Add Add-on": "Añadir complemento",
    "listings.addon.title": "Título",
    "listings.addon.enter_title": "Introducir título",
    "listings.addon.status": "Estado (No activo / Activo)",
    "listings.addon.upload_media": "Subir medios",
    "attributes.prefill_for": "Prellenar para",
    "Prefill for": "Prellenar para",
    "attributes.first_item": "Primer elemento",
    "First Item": "Primer elemento",
    "attributes.all_items": "Todos los elementos",
    "All Items": "Todos los elementos",
    "common.uploading": "Subiendo...",
    "common.uploading_named": "Subiendo {title}",
    "Uploading {title}": "Subiendo {title}",
    "common.please_wait_short": "Espere un momento",
    "Please wait": "Espere un momento",
    "attributes.select_option": "Seleccionar",
    "attributes.select_value": "Seleccionar valor...",
    "Select value...": "Seleccionar valor...",
    "attributes.type_placeholder": "Escribir {name}",
    "Type {name}": "Escribir {name}",
    "attributes.multiple_values_placeholder": "Puede ingresar varios valores separados por comas.",
    "Using a comma, you can enter several values.": "Puede ingresar varios valores separados por comas.",
    "attributes.upload_attachment": "Subir archivo adjunto",
    "Upload Attachment": "Subir archivo adjunto",
    "attributes.upload_json_file": "Subir archivo JSON",
    "Upload JSON File": "Subir archivo JSON",
    "attributes.copied_value": "Valor copiado",
    "Copied the value": "Valor copiado",
    "attributes.latitude_longitude_placeholder": "Introducir latitud, longitud (ej. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Introducir latitud, longitud (ej. 12.34,56.78)",
    "navigation.sidebar_label": "Barra lateral",
    "Side bar": "Barra lateral",
    "checkout_settings.orders_option_0": "Vista de calendario de pedidos",
    "Orders Calendar View": "Vista de calendario de pedidos",
    "checkout_settings.show_cart_attributes": "Mostrar atributos del carrito",
    "Show cart attributes": "Mostrar atributos del carrito",
    "checkout_settings.select_order_status": "Seleccionar estado del pedido",
    "Select order status": "Seleccionar estado del pedido",
    "checkout_settings.order_status_0": "Colocado con éxito",
    "Placed success": "Colocado con éxito",
    "checkout_settings.order_status_1": "En proceso",
    "In process": "En proceso",
    "checkout_settings.order_status_2": "Enviado",
    "checkout_settings.order_status_3": "Entregado",
    "checkout_settings.order_status_4": "Completado",
    "listing_form.no_categories_found": "No se encontraron categorías. Usa «{action}» arriba.",
    "No categories found. Use “{action}” above.": "No se encontraron categorías. Usa «{action}» arriba.",
    "common.learn_more": "Más información",
    "Learn more": "Más información",
    "common.show_information": "Mostrar información",
    "Show information": "Mostrar información",
    "common.paid_feature": "Característica de pago",
    "Paid Feature": "Característica de pago",
    "common.learn_more_about": "Más información sobre",
    "Learn more about": "Más información sobre",
    "attributes.categories": "Categorías",
    "attributes.edit_bulk_title": "{title} Editar por lotes",
    "{title} Edit Bulk": "{title} Editar por lotes",
    "common.enter_description": "Introducir descripción",
    "common.empty_fetch_message": "Aquí no hay nada que mostrar aún. Cuando haya contenido disponible, aparecerá en esta página.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Aquí no hay nada que mostrar aún. Cuando haya contenido disponible, aparecerá en esta página.",
    "common.ai_credits_and_top_up": "Créditos de IA y recarga",
    "AI credits and top up": "Créditos de IA y recarga",
    "common.ai_credits_loading": "Cargando créditos de IA",
    "Loading AI credits": "Cargando créditos de IA",
    "common.ai_credits_unavailable": "Créditos de IA no disponibles",
    "AI credits unavailable": "Créditos de IA no disponibles",
    "common.ai_credits_available": "Créditos de IA disponibles: {count}",
    "Available AI credits: {count}": "Créditos de IA disponibles: {count}",
    "common.ai_credits_unavailable_top_up": "Créditos de IA no disponibles — haz clic para recargar",
    "AI credits unavailable — click to top up": "Créditos de IA no disponibles — haz clic para recargar",
    "common.ai_credits_available_top_up": "Créditos de IA disponibles: {count} — haz clic para añadir créditos",
    "Available AI credits: {count} — click to add credits": "Créditos de IA disponibles: {count} — haz clic para añadir créditos",
    "common.ai_credits_add": "Añadir créditos",
    "Add credits": "Añadir créditos",
    "navigation.switch_project": "Cambiar proyecto",
    "Switch Project": "Cambiar proyecto",
    "navigation.tenant_switch_failed": "Error al cambiar de inquilino. Por favor, inténtelo de nuevo.",
    "Tenant switch failed. Please try again.": "Error al cambiar de inquilino. Por favor, inténtelo de nuevo.",
    "navigation.select_project": "Seleccionar proyecto",
    "Select Project": "Seleccionar proyecto",
    "navigation.collapse_sidebar": "Contraer barra lateral",
    "Collapse sidebar": "Contraer barra lateral",
    "navigation.expand_sidebar": "Expandir barra lateral",
    "Expand sidebar": "Expandir barra lateral",
    "navigation.search": "Buscar",
    "navigation.loading": "Cargando navegación",
    "Loading navigation": "Cargando navegación",
    "navigation.help_documentation": "Documentación",
    "navigation.help_community": "Comunidad",
    "navigation.help_api_reference": "Referencia de API",
    "listings.quick_form": "Formulario rápido",
    "Quick Form": "Formulario rápido",
    "payments.notification_secret": "Secreto de notificación",
    "Notification Secret": "Secreto de notificación",
    "payments.user_type": "Tipo de usuario",
    "User Type": "Tipo de usuario",
    "payments.category_id": "ID de categoría",
    "app_customization.other_settings": "Otras configuraciones",
    "Other Settings": "Otras configuraciones",
    "app_customization.other_hide_balances": "Ocultar saldos y pagos en más sección",
    "app_customization.other_enable_logs": "Habilitar registros",
    "Enable logs": "Habilitar registros",
    "app_customization.other_signup_first": "Obtener registro primero",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Imagen seleccionada",
    "Selected image": "Imagen seleccionada",
    "common.ai_no_response_to_copy": "No hay respuesta para copiar",
    "No response to copy": "No hay respuesta para copiar",
    "common.copied_to_clipboard": "Copiado al portapapeles",
    "Copied to clipboard": "Copiado al portapapeles",
    "common.ai_suggestions": "Sugerencias",
    "Suggestions": "Sugerencias",
    "common.regenerate": "Regenerar",
    "Regenerate": "Regenerar",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "Icono JSON",
    "JSON icon": "Icono JSON",
    "collections.generator_title": "Generador de colección",
    "Collection Generator": "Generador de colección",
    "collections.generator_create": "Crear colección",
    "collections.generator_json_placeholder": "Introduzca entrada JSON",
    "Enter JSON input": "Introduzca entrada JSON",
    "collections.generator_invalid_data": "Introduzca datos válidos",
    "Please enter valid data": "Introduzca datos válidos",
    "category.editor_select_from_media": "Seleccionar desde medios",
    "payments.subscription": "Suscripción",
    "payments.subscription_setting_up": "Configurando...",
    "Setting up...": "Configurando...",
    "payments.subscription_webhook_configured": "Webhook de suscripción configurado",
    "Subscription webhook configured": "Webhook de suscripción configurado",
    "payments.subscription_retry_setup": "Intentar configuración de nuevo",
    "Retry setup": "Intentar configuración de nuevo",
    "payments.setup_subscription_webhook": "Configurar Webhook de suscripción",
    "Setup Subscription Webhook": "Configurar Webhook de suscripción",
    "orders.shipment_number": "Envío {number}",
    "Shipment {number}": "Envío {number}",
    "orders.quantity_short": "Cant.",
    "orders.shipment_status_1": "Envío creado",
    "orders.shipment_status_2": "Envío en progreso",
    "orders.shipment_status_3": "Enviado",
    "orders.shipment_status_4": "Listo para recoger",
    "orders.shipment_status_5": "En camino a la entrega",
    "orders.shipment_status_6": "Devolución no entregada",
    "orders.shipment_status_7": "Envío entregado",
    "orders.shipment_status_8": "Entrega confirmada",
    "orders.shipment_status_9": "Devolución iniciada",
    "orders.shipment_status_10": "Devolución para recoger",
    "orders.shipment_status_11": "Devolución confirmada",
    "orders.shipment_status_12": "Cancelado por el vendedor",
    "orders.shipment_status_13": "Cancelado por el cliente",
    "orders.shipment_status_14": "Llegado al lugar del cliente",
    "orders.shipment_status_15": "Cancelado por administrador",
    "attributes.metadata_title": "Metadatos",
    "Metadata": "Metadatos",
    "common.add_row": "Agregar fila",
    "common.no_access": "No tienes acceso",
    "You don't have access": "No tienes acceso",
    "common.error_404_message": "Lo sentimos, la página que está buscando actualmente no está disponible. Por favor, verifique la URL e inténtelo de nuevo, o vuelva más tarde. Si continúa experimentando este problema, póngase en contacto con nuestro equipo de soporte para obtener ayuda. Gracias por su comprensión.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "Lo sentimos, la página que está buscando actualmente no está disponible. Por favor, verifique la URL e inténtelo de nuevo, o vuelva más tarde. Si continúa experimentando este problema, póngase en contacto con nuestro equipo de soporte para obtener ayuda. Gracias por su comprensión.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "Dirección de transacción",
    "Transaction direction": "Dirección de transacción",
    "category.default_text": "Texto predeterminado",
    "collections.generator_open": "Generador de colección abierto",
    "Open collection generator": "Generador de colección abierto",
    "collections.duplicate_success": "Colección duplicada con éxito",
    "Collection duplicated successfully": "Colección duplicada con éxito",
    "collections.duplicate_failed": "Error al duplicar colección",
    "Failed to duplicate collection": "Error al duplicar colección",
    "listings.name_required": "Se requiere nombre de lista",
    "Listing Name is required": "Se requiere nombre de lista",
    "listings.category_required": "Se requiere categoría",
    "Category is required": "Se requiere categoría",
    "attribute_groups.edit_title": "Editar grupo de atributos",
    "Edit Attribute Group": "Editar grupo de atributos",
    "orders.create_order.validation.select_shipping_method": "Seleccione método de envío",
    "Please select shipping method": "Seleccione método de envío",
    "orders.create_order.validation.shipping_method_error": "Error de método de envío",
    "Shipping Method Error": "Error de método de envío",
    "orders.create_order.validation.select_shipping_address": "Seleccione dirección de envío",
    "Please select shipping address": "Seleccione dirección de envío",
    "orders.create_order.validation.shipping_address_error": "Error de dirección de envío",
    "Shipping Address Error": "Error de dirección de envío",
    "orders.create_order.validation.select_shipment_method": "Seleccione método de envío",
    "Please select shipment method": "Seleccione método de envío",
    "orders.create_order.validation.shipment_method_error": "Error de método de envío",
    "Shipment Method Error": "Error de método de envío",
    "orders.create_order.validation.select_payment_method": "Seleccione método de pago",
    "Please select payment method": "Seleccione método de pago",
    "orders.create_order.validation.payment_method_error": "Error de método de pago",
    "Payment Method Error": "Error de método de pago",
    "orders.create_order.validation.insufficient_balance": "Saldo insuficiente",
    "Insufficient balance": "Saldo insuficiente",
    "orders.create_order.validation.wallet_error": "Error de billetera",
    "Wallet Error": "Error de billetera",
    "attributes.value.preview_item": "Vista previa {count}",
    "Preview {count}": "Vista previa {count}",
    "attributes.value.click_to_upload": "Haga clic para subir {type}",
    "Click to upload {type}": "Haga clic para subir {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF hasta 5 archivos",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF hasta 5 archivos",
    "attributes.value.audio_upload_formats": "MP3, WAV hasta 1 archivo",
    "MP3, WAV up to 1 file": "MP3, WAV hasta 1 archivo",
    "attributes.value.video_upload_formats": "MP4, MOV hasta 1 archivo",
    "MP4, MOV up to 1 file": "MP4, MOV hasta 1 archivo",
    "attributes.value.upload_limit": "Subir {type} archivos (Máx {count})",
    "Upload {type} files (Max {count})": "Subir {type} archivos (Máx {count})",
    "attributes.value.json_format_failed": "JSON no válido - no se puede formatear",
    "Invalid JSON - cannot format": "JSON no válido - no se puede formatear",
    "attributes.value.json_file_invalid": "Seleccione un archivo JSON válido",
    "Please select a valid JSON file": "Seleccione un archivo JSON válido",
    "attributes.value.file_empty": "El archivo está vacío",
    "File is empty": "El archivo está vacío",
    "attributes.value.json_file_parse_failed": "Archivo JSON no válido: {message}",
    "Invalid JSON file: {message}": "Archivo JSON no válido: {message}",
    "attributes.value.file_read_failed": "No se pudo leer el archivo",
    "Failed to read file": "No se pudo leer el archivo",
    "attributes.value.invalid_json": "JSON no válido",
    "Invalid JSON": "JSON no válido",
    "attributes.value.json_editor_help": "Suba un archivo JSON o escriba/paste JSON directamente",
    "Upload a JSON file or type/paste JSON directly": "Suba un archivo JSON o escriba/paste JSON directamente",
    "attributes.value.hex_color_code": "Código de color Hex",
    "Hex Color Code": "Código de color Hex",
    "attributes.value.multi_text_placeholder": "Escriba y presione Enter o coma para agregar",
    "Type and press Enter or comma to add": "Escriba y presione Enter o coma para agregar",
    "attributes.value.multi_text_help": "Presione Enter o coma para agregar cada elemento",
    "Press Enter or comma to add each item": "Presione Enter o coma para agregar cada elemento",
    "attributes.value.item_count": "{count} elemento",
    "{count} item": "{count} elemento",
    "attributes.value.items_count": "{count} elementos",
    "attributes.value.search_options": "Buscar {name}...",
    "Search {name}...": "Buscar {name}...",
    "attributes.value.selected_count": "{count} seleccionados",
    "attributes.value.no_options_found": "No se encontraron opciones",
    "No options found": "No se encontraron opciones",
    "attributes.value.select_named_option": "Seleccione {name}",
    "Select {name}": "Seleccione {name}",
    "attributes.value.enable_option": "Habilite esta opción",
    "Enable this option": "Habilite esta opción",
    "attributes.value.enter_named_value": "Introduzca {name}",
    "Enter {name}": "Introduzca {name}",
    "common.valid": "Válido",
    "Valid": "Válido",
    "common.invalid": "No válido",
    "Invalid": "No válido",
    "common.go_back_home": "Volver a inicio",
    "Go back home": "Volver a inicio",
    "attributes.value.enter_named_text": "Introduzca {name}...",
    "Enter {name}...": "Introduzca {name}...",
    "listings.analytics.page_views": "Vistas de página",
    "listings.analytics.unique_visitors": "Visitantes únicos",
    "listings.analytics.sessions": "Sesiones",
    "listings.analytics.clicks": "Clics",
    "listings.analytics.goals": "Objetivos",
    "listings.analytics.bot_views": "Vistas de bot",
    "listings.detail_summary.buyers": "Compradores",
    "Buyers": "Compradores",
    "listings.detail_summary.orders": "Pedidos",
    "listings.detail_summary.revenue": "Ingresos",
    "listings.detail_summary.average_order": "Promedio de pedido",
    "listings.add_advanced": "Avanzado",
    "listings.add_audio": "Agregar audio",
    "Add Audio": "Agregar audio",
    "payments.updated_successfully": "Actualizado con éxito",
    "Updated successfully": "Actualizado con éxito",
    "users.deleted_successfully": "Usuario eliminado con éxito",
    "User deleted successfully": "Usuario eliminado con éxito",
    "users.deletion_failed": "Error al eliminar usuario",
    "User deletion failed": "Error al eliminar usuario",
    "accounts.flow.title": "Configura la experiencia de la cuenta",
    "Shape the account experience": "Configura la experiencia de la cuenta",
    "accounts.flow.description": "Organiza los tipos de cuenta y define la información que cada cuenta necesita.",
    "Organize account types and define the information each account needs.": "Organiza los tipos de cuenta y define la información que cada cuenta necesita.",
    "accounts.flow.lane_title": "Cimientos de la cuenta",
    "Account foundation": "Cimientos de la cuenta",
    "accounts.flow.badge": "Estructura",
    "Structure": "Estructura",
    "accounts.flow.node_accounts": "Cuentas",
    "accounts.flow.node_categories": "Categorías",
    "accounts.flow.node_attributes": "Atributos",
    "accounts.flow.lane_description": "Da a cada cuenta un lugar claro, tipo y un conjunto de detalles útiles.",
    "Give every account a clear place, type, and set of useful details.": "Da a cada cuenta un lugar claro, tipo y un conjunto de detalles útiles.",
    "accounts.flow.primary_action": "Añade tu primera cuenta",
    "Add your first account": "Añade tu primera cuenta",
    "listings.flow.title": "Construye tu catálogo de listados",
    "Build your listing catalog": "Construye tu catálogo de listados",
    "listings.flow.description": "Crea un catálogo estructurado con categorías, atributos y variantes.",
    "Create a structured catalog with categories, attributes, and variants.": "Crea un catálogo estructurado con categorías, atributos y variantes.",
    "listings.flow.lane_title": "Ruta del catálogo",
    "Catalog path": "Ruta del catálogo",
    "listings.flow.badge": "Construir",
    "Build": "Construir",
    "listings.flow.node_listings": "Listados",
    "listings.flow.node_categories": "Categorías",
    "listings.flow.node_attributes": "Atributos",
    "listings.flow.node_variants": "Variantes",
    "listings.flow.lane_description": "Define qué vendes y la información que los clientes necesitan para elegir.",
    "Define what you sell and the information customers need to make a choice.": "Define qué vendes y la información que los clientes necesitan para elegir.",
    "listings.flow.primary_action": "Añade tu primer listado",
    "Add your first listing": "Añade tu primer listado",
    "collections.flow.title": "Reúne todo el contenido de tu mercado",
    "Bring your marketplace content together": "Reúne todo el contenido de tu mercado",
    "collections.flow.description": "Agrupa listados y cuentas en colecciones curadas que son fáciles de descubrir y gestionar.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Agrupa listados y cuentas en colecciones curadas que son fáciles de descubrir y gestionar.",
    "collections.flow.lane_title": "Ruta de la colección",
    "Collection path": "Ruta de la colección",
    "collections.flow.badge": "Curar",
    "Curate": "Curar",
    "collections.flow.node_collections": "Colecciones",
    "collections.flow.node_rules": "Reglas",
    "collections.flow.node_listings": "Listados",
    "collections.flow.lane_description": "Elige qué pertenece juntos y hazlo fácil para los clientes encontrar.",
    "Choose what belongs together and make it easy for customers to find.": "Elige qué pertenece juntos y hazlo fácil para los clientes encontrar.",
    "collections.flow.audience_lane_title": "Ruta de audiencia",
    "Audience path": "Ruta de audiencia",
    "collections.flow.audience_badge": "Conectar",
    "collections.flow.node_accounts": "Cuentas",
    "collections.flow.node_users": "Usuarios",
    "collections.flow.node_storefront": "Tienda",
    "Storefront": "Tienda",
    "collections.flow.audience_description": "Conecta contenido curado a las personas y tiendas para las que está destinado.",
    "Connect curated content to the people and storefronts it is meant for.": "Conecta contenido curado a las personas y tiendas para las que está destinado.",
    "collections.flow.primary_action": "Crea tu primera colección",
    "listings.addon.image_limit": "No puedes seleccionar más imágenes",
    "listings.schedule.start_time_before_end": "La hora de inicio debe ser antes de la hora de finalización",
    "Start time must be before the end time": "La hora de inicio debe ser antes de la hora de finalización",
    "listings.schedule.end_time_after_start": "La hora de finalización debe ser después de la hora de inicio",
    "End time must be after the start time": "La hora de finalización debe ser después de la hora de inicio",
    "listings.schedule.repeat_required": "Selecciona un patrón de repetición",
    "Select a repeat pattern": "Selecciona un patrón de repetición",
    "listing_variants.form.select_type": "Selecciona el tipo de variante",
    "Select variant type": "Selecciona el tipo de variante",
    "listing_variants.form.select_type_values": "Selecciona los valores de variante",
    "Select variant values": "Selecciona los valores de variante",
    "listing_variants.form.add_variant": "Agregar variante",
    "listing_variants.form.edit_variant": "Editar variante",
    "Edit variant": "Editar variante",
    "listing_variants.form.variant_type": "Tipo de variante",
    "Variant type": "Tipo de variante",
    "listing_variants.form.variant_type_value": "Valor de variante",
    "Variant value": "Valor de variante",
    "listing_variants.form.variant_name": "Nombre de variante",
    "Variant name": "Nombre de variante",
    "listing_variants.form.description_placeholder": "Introduzca descripción",
    "rewards.item_archived": "Archivado",
    "listings.confirm_delete_variant": "¿Está seguro de que desea eliminar esta variante?",
    "listings.confirm_delete_listing": "¿Está seguro de que desea eliminar esta lista?",
    "listing_form.digital_delete_confirm": "¿Está seguro de que desea eliminar este contenido digital?",
    "Are you sure you want to delete this digital content?": "¿Está seguro de que desea eliminar este contenido digital?",
    "category.confirm_delete_attribute": "¿Desea eliminar este atributo?",
    "common.permission_required": "No tiene permiso para realizar esta acción.",
    "You do not have permission to perform this action.": "No tiene permiso para realizar esta acción.",
    "common.copied": "Copiado",
    "attributes.editor_name_required": "Por favor, ingrese el nombre del atributo",
    "onboarding.full_step.setup_payments.description": "Habilite transacciones reales para que los usuarios completen su intención sin fricción.",
    "Enable real transactions so users can complete intent without friction.": "Habilite transacciones reales para que los usuarios completen su intención sin fricción.",
    "onboarding.full_step.setup_payments.cta": "Configurar pagos",
    "Setup payments": "Configurar pagos",
    "onboarding.full_step.setup_payments.impact": "Ruta de ingresos habilitada.",
    "Revenue path enabled.": "Ruta de ingresos habilitada.",
    "onboarding.full_step.setup_payments.creator_description": "Prepara el camino para que tu audiencia compre o apoye tu trabajo.",
    "Prepare the path for your audience to purchase or support your work.": "Prepara el camino para que tu audiencia compre o apoye tu trabajo.",
    "onboarding.full_step.setup_delivery.description": "Define cómo se cumplirá el pedido para que el checkout sea predecible para los usuarios.",
    "onboarding.full_step.setup_delivery.impact": "Ruta de cumplimiento clara.",
    "Fulfillment path clear.": "Ruta de cumplimiento clara.",
    "onboarding.full_step.add_promotion.description": "Crea tu primera promoción para aumentar la tasa de acción en la primera sesión.",
    "Create your first promotion to increase first-session action rate.": "Crea tu primera promoción para aumentar la tasa de acción en la primera sesión.",
    "onboarding.full_step.add_promotion.impact": "Mejor conversión durante el lanzamiento.",
    "Stronger conversion during launch.": "Mejor conversión durante el lanzamiento.",
    "onboarding.full_step.create_coupon.description": "Prueba descuentos y mejora la activación para primeros compradores o miembros.",
    "Test discounts and improve activation for first-time buyers or members.": "Prueba descuentos y mejora la activación para primeros compradores o miembros.",
    "onboarding.full_step.create_coupon.impact": "Bucle de primera oferta desbloqueado.",
    "First-offer loop unlocked.": "Bucle de primera oferta desbloqueado.",
    "onboarding.full_step.collections_setup.description": "Organiza listados de alto interés para mejorar el descubrimiento y el flujo de navegación.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Organiza listados de alto interés para mejorar el descubrimiento y el flujo de navegación.",
    "onboarding.full_step.collections_setup.impact": "Navegación y descubrimiento mejorados.",
    "Navigation and discovery improved.": "Navegación y descubrimiento mejorados.",
    "onboarding.full_step.configure_comms.description": "Haz que las notificaciones post-registro y de pedidos estén listas para producción antes del crecimiento.",
    "Make post-signup and order notifications production-ready before growth.": "Haz que las notificaciones post-registro y de pedidos estén listas para producción antes del crecimiento.",
    "onboarding.full_step.configure_comms.impact": "Mensajes de ciclo de vida listos.",
    "Lifecycle messaging ready.": "Mensajes de ciclo de vida listos.",
    "onboarding.full_step.customize_attributes.description": "Agrega campos estructurados para que los usuarios puedan filtrar y comparar lo que importa.",
    "onboarding.full_step.customize_attributes.impact": "Búsqueda y conversión mejoradas.",
    "Better search and conversion.": "Búsqueda y conversión mejoradas.",
    "onboarding.full_step.customize_attributes.creator_description": "Agrega los detalles que ayudan a las personas a entender y comparar lo que creas.",
    "Add the details that help people understand and compare what you create.": "Agrega los detalles que ayudan a las personas a entender y comparar lo que creas.",
    "onboarding.full_step.add_digital_asset.description": "Amplía el catálogo inicial para que los usuarios evalúen la calidad y el surtido.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Amplía el catálogo inicial para que los usuarios evalúen la calidad y el surtido.",
    "onboarding.full_step.add_digital_asset.impact": "Credibilidad del catálogo digital mejorada.",
    "Digital catalog credibility improved.": "Credibilidad del catálogo digital mejorada.",
    "onboarding.full_step.open_live_site.description": "Empieza con lo que ven los clientes. Esto hace que el producto se sienta real antes de que la configuración se vuelva abstracta.",
    "onboarding.full_step.open_live_site.impact": "Confirma que el proyecto ya está en vivo.",
    "onboarding.full_step.add_first_product.description": "Publica el primer producto, servicio o recurso que quieres que tu audiencia descubra.",
    "Publish the first product, service, or resource you want your audience to discover.": "Publica el primer producto, servicio o recurso que quieres que tu audiencia descubra.",
    "onboarding.full_step.add_first_product.impact": "Crea tu primera oferta lista para audiencia.",
    "Creates your first audience-ready offer.": "Crea tu primera oferta lista para audiencia.",
    "onboarding.full_step.customize_attributes.creator_impact": "Hace tu oferta más fácil de entender.",
    "Makes your offer easier to understand.": "Hace tu oferta más fácil de entender.",
    "onboarding.full_step.setup_payments.creator_impact": "Desbloquea el camino hacia los ingresos.",
    "listings.detail_preview_fx.title": "Vista previa FX",
    "Preview FX": "Vista previa FX",
    "listings.detail_preview_fx.base": "Base",
    "Base": "Base",
    "listings.detail_preview_fx.description": "Ver este listado en cada moneda activa.",
    "See this listing in each active currency.": "Ver este listado en cada moneda activa.",
    "listings.detail_preview_fx.refresh": "Actualizar vista previa",
    "Refresh preview": "Actualizar vista previa",
    "listings.detail_preview_fx.loading_rates": "Cargando tasas de cambio…",
    "Loading exchange rates…": "Cargando tasas de cambio…",
    "listings.detail_preview_fx.load_hint": "Selecciona Vista previa FX para cargar las tasas actuales.",
    "Select Preview FX to load current rates.": "Selecciona Vista previa FX para cargar las tasas actuales.",
    "listings.detail_preview_fx.preview_note": "Solo vista previa. Los precios guardados del listado permanecen sin cambios.",
    "Preview only. Saved listing prices remain unchanged.": "Solo vista previa. Los precios guardados del listado permanecen sin cambios.",
    "listings.detail_preview_fx.listing": "Listado",
    "listings.detail_preview_fx.variant": "Variante",
    "Variant": "Variante",
    "listings.detail_event_booking.event_details": "Detalles del evento",
    "Event Details": "Detalles del evento",
    "listings.detail_event_booking.booking_details": "Detalles de reserva",
    "Booking Details": "Detalles de reserva",
    "listings.unassigned_location": "Ubicación no asignada",
    "Unassigned location": "Ubicación no asignada",
    "listings.no_ratings_yet": "Aún no hay calificaciones.",
    "No ratings yet": "Aún no hay calificaciones.",
    "listing_form.loading_listing": "Cargando listado…",
    "Loading listing…": "Cargando listado…",
    "listing_form.preparing_form": "Preparando formulario…",
    "Preparing form…": "Preparando formulario…",
    "listing_form.edit_listing": "Editar listado",
    "Edit Listing": "Editar listado",
    "listing_form.add_new_listing": "Agregar nuevo listado",
    "Add New Listing": "Agregar nuevo listado",
    "workspace.catalog.templates": "Plantillas",
    "Templates": "Plantillas",
    "workspace.catalog.integrations": "Integraciones",
    "workspace.catalog.template": "Plantilla",
    "Template": "Plantilla",
    "workspace.catalog.integration": "Integración",
    "workspace.catalog.templates_heading": "Elige una plantilla para iniciar tu Idea",
    "Choose a template to kickstart your Idea": "Elige una plantilla para iniciar tu Idea",
    "workspace.catalog.integrations_heading": "Integraciones para aplicaciones web alojadas",
    "Integrations for Hosted Web Apps": "Integraciones para aplicaciones web alojadas",
    "workspace.catalog.templates_description": "Empieza con una plantilla preconstruida y personalízala para tu mercado.",
    "Start with a prebuilt template and customise it for your marketplace.": "Empieza con una plantilla preconstruida y personalízala para tu mercado.",
    "workspace.catalog.integrations_description": "Conecta tu espacio de trabajo con las herramientas y servicios que ya usas.",
    "Connect your workspace to the tools and services you already use.": "Conecta tu espacio de trabajo con las herramientas y servicios que ya usas.",
    "workspace.catalog.no_templates": "No hay plantillas disponibles en este momento.",
    "No templates available at the moment.": "No hay plantillas disponibles en este momento.",
    "workspace.catalog.no_integrations": "No hay integraciones disponibles en este momento.",
    "No integrations available at the moment.": "No hay integraciones disponibles en este momento.",
    "workspace.catalog.coming_soon": "Próximamente",
    "Coming Soon": "Próximamente",
    "workspace.catalog.configure": "Configurar",
    "workspace.catalog.custom_development": "Desarrollo personalizado de {type}",
    "Custom {type} Development": "Desarrollo personalizado de {type}",
    "workspace.catalog.custom_help": "¿Buscas algo personalizado? Contáctanos para obtener un presupuesto.",
    "Looking for something custom? Contact us for a quote.": "¿Buscas algo personalizado? Contáctanos para obtener un presupuesto.",
    "workspace.catalog.contact_quote": "Contáctanos para un presupuesto",
    "Contact for a Quote": "Contáctanos para un presupuesto",
    "users.select_user": "Seleccionar Usuario",
    "Select User": "Seleccionar Usuario",
    "developer.api_keys.paid_feature_title": "El acceso a la API es una característica de pago",
    "API access is a paid feature": "El acceso a la API es una característica de pago",
    "developer.api_keys.paid_feature_description": "Elige un plan de pago para ver, copiar y usar tus Claves Publicables y Secretas.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Elige un plan de pago para ver, copiar y usar tus Claves Publicables y Secretas.",
    "developer.api_keys.available_on_paid_plans": "Disponible en planes de pago",
    "Available on paid plans": "Disponible en planes de pago",
    "developer.api_keys.view_plans": "Ver planes",
    "currency.rates.title": "Tipos de cambio actuales",
    "Current FX rates": "Tipos de cambio actuales",
    "currency.rates.base": "Base:",
    "Base:": "Base:",
    "currency.rates.source": "· Fuente:",
    "· Source:": "· Fuente:",
    "currency.rates.cached_up_to": "Caché hasta {hours}h",
    "Cached up to {hours}h": "Caché hasta {hours}h",
    "currency.rates.refresh": "Actualizar tasas",
    "Refresh rates": "Actualizar tasas",
    "currency.rates.currency": "Moneda",
    "currency.rates.one_base_equals": "1 {code} equivale a",
    "1 {code} equals": "1 {code} equivale a",
    "currency.rates.empty": "Agrega una moneda activa para ver su tipo de cambio.",
    "Add an active currency to see its exchange rate.": "Agrega una moneda activa para ver su tipo de cambio.",
    "currency.rates.manual": "Tarifas manuales",
    "Manual rates": "Tarifas manuales",
    "currency.rates.load_error": "No se pueden cargar las tasas de cambio.",
    "Unable to load exchange rates.": "No se pueden cargar las tasas de cambio.",
    "chats.title": "Chat de cliente",
    "Customer chat": "Chat de cliente",
    "chats.conversations": "Conversaciones",
    "Conversations": "Conversaciones",
    "chats.empty_conversations": "Aún no hay conversaciones con clientes.",
    "No customer conversations yet.": "Aún no hay conversaciones con clientes.",
    "chats.customer_id": "Cliente {id}",
    "Customer {id}": "Cliente {id}",
    "chats.no_messages_yet": "Aún no hay mensajes.",
    "No messages yet": "Aún no hay mensajes.",
    "chats.conversation_id": "Conversación #{id}",
    "Conversation #{id}": "Conversación #{id}",
    "chats.status.closed": "cerrada",
    "closed": "cerrada",
    "chats.status.open": "abierta",
    "chats.reopen": "Reabrir",
    "Reopen": "Reabrir",
    "chats.close_conversation": "Cerrar conversación",
    "Close conversation": "Cerrar conversación",
    "chats.your_team": "Tu equipo",
    "Your team": "Tu equipo",
    "chats.empty_messages": "Aún no hay mensajes en esta conversación.",
    "No messages in this conversation yet.": "Aún no hay mensajes en esta conversación.",
    "chats.write_reply": "Escribe una respuesta",
    "Write a reply": "Escribe una respuesta",
    "chats.send": "Enviar",
    "Send": "Enviar",
    "chats.select_conversation": "Selecciona una conversación para ver sus mensajes.",
    "Select a conversation to view its messages.": "Selecciona una conversación para ver sus mensajes.",
    "chats.error.session_not_ready": "Tu sesión no está lista. Refresca la página e inténtalo de nuevo.",
    "Your session is not ready. Refresh the page and try again.": "Tu sesión no está lista. Refresca la página e inténtalo de nuevo.",
    "chats.error.request_failed": "La solicitud de chat falló ({status})",
    "Chat request failed ({status})": "La solicitud de chat falló ({status})",
    "chats.error.load_conversations": "No se pudieron cargar las conversaciones.",
    "Could not load conversations.": "No se pudieron cargar las conversaciones.",
    "chats.error.load_messages": "No se pudieron cargar los mensajes.",
    "Could not load messages.": "No se pudieron cargar los mensajes.",
    "chats.error.send_message": "No se pudo enviar el mensaje.",
    "Message could not be sent.": "No se pudo enviar el mensaje.",
    "chats.error.update_status": "No se pudo actualizar el estado de la conversación.",
    "Conversation status could not be updated.": "No se pudo actualizar el estado de la conversación.",
    "accounts.select_account": "Selecciona Cuenta",
    "common.accounts": "Cuentas",
    "common.listings": "Listados",
    "communications.loading_preview": "Cargando vista previa…",
    "Loading preview…": "Cargando vista previa…",
    "communications.no_preview": "Sin vista previa",
    "No preview": "Sin vista previa",
    "collections.choose_type": "Seleccionar {type}",
    "Choose {type}": "Seleccionar {type}",
    "collections.create_type_category_first": "Crea primero la categoría de {type}",
    "Create {type} category first": "Crea primero la categoría de {type}",
    "web_config.customisation": "Personalización web",
    "web_config.configuration": "Configuración web",
    "Web Configuration": "Configuración web",
    "web_config.section_general": "General",
    "web_config.section_social": "Social",
    "web_config.section_footer": "Pie de página",
    "web_config.assets": "Recursos",
    "Assets": "Recursos",
    "web_config.small_logo": "Pequeño logotipo",
    "Small logo": "Pequeño logotipo",
    "attributes.edit_attribute": "Editar atributo",
    "currency.rate_managed_automatically": "La tasa se gestiona automáticamente.",
    "Rate is managed automatically.": "La tasa se gestiona automáticamente.",
    "navigation.add_or_manage_mini_apps": "Agregar o gestionar Mini Apps",
    "Add or manage Mini Apps": "Agregar o gestionar Mini Apps",
    "listings.import.download_type_template": "Descargar plantilla {type}",
    "navigation.promo_banner": "¡Obtén {percent}% de descuento! Solo para primeros clientes. Usa el código: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "¡Obtén {percent}% de descuento! Solo para primeros clientes. Usa el código: {code}.",
    "orders.cash_refund_recorded": "Reembolso en efectivo registrado. La reversión contable se ha programado.",
    "Cash refund recorded. The accounting reversal has been queued.": "Reembolso en efectivo registrado. La reversión contable se ha programado.",
    "orders.cash_refund_failed": "No se pudo registrar el reembolso en efectivo. Verifique el estado del pago del pedido y el historial de reembolsos.",
    "Could not record the cash refund. Check the order payment status and refund history.": "No se pudo registrar el reembolso en efectivo. Verifique el estado del pago del pedido y el historial de reembolsos.",
    "orders.recording_cash_refund": "Registrando reembolso…",
    "Recording refund…": "Registrando reembolso…",
    "orders.record_cash_refund": "Registrar reembolso en efectivo",
    "Record cash refund": "Registrar reembolso en efectivo",
    "orders.confirm_cash_refund": "Confirmar reembolso en efectivo",
    "Confirm cash refund": "Confirmar reembolso en efectivo",
    "orders.cash_refund_order_amount": "¿Registrar un reembolso en efectivo completo de {amount} para el pedido {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "¿Registrar un reembolso en efectivo completo de {amount} para el pedido {reference}?",
    "orders.cash_refund_manual_notice": "Esto registra un reembolso manual de efectivo/COD y programa su reversión contable. No se contactará a ningún proveedor de pago.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Esto registra un reembolso manual de efectivo/COD y programa su reversión contable. No se contactará a ningún proveedor de pago.",
    "currency_conversion.title": "Conversión de moneda",
    "Currency conversion": "Conversión de moneda",
    "currency_conversion.open_settings": "Configuración de conversión",
    "Conversion settings": "Configuración de conversión",
    "currency_conversion.load_failed": "No se pudieron cargar la configuración de conversión de moneda.",
    "Could not load currency conversion settings.": "No se pudieron cargar la configuración de conversión de moneda.",
    "currency_conversion.interval_error": "El intervalo de actualización debe estar entre 5 minutos y 24 horas.",
    "Refresh interval must be between 5 minutes and 24 hours.": "El intervalo de actualización debe estar entre 5 minutos y 24 horas.",
    "currency_conversion.save_failed": "No se pudieron guardar las configuraciones de conversión de moneda.",
    "Could not save currency conversion settings.": "No se pudieron guardar las configuraciones de conversión de moneda.",
    "currency_conversion.saved": "Configuración de conversión de moneda guardada.",
    "Currency conversion settings saved.": "Configuración de conversión de moneda guardada.",
    "currency_conversion.description": "Elige cómo se calculan las conversiones de moneda mostradas.",
    "Choose how displayed currency conversions are calculated.": "Elige cómo se calculan las conversiones de moneda mostradas.",
    "currency_conversion.manual_title": "Tarifas manuales",
    "currency_conversion.manual_help": "Utiliza la tasa de cambio introducida para cada moneda a continuación.",
    "Use the exchange rate entered for each currency below.": "Utiliza la tasa de cambio introducida para cada moneda a continuación.",
    "currency_conversion.frankfurter_title": "Frankfurter (predeterminado)",
    "Frankfurter (default)": "Frankfurter (predeterminado)",
    "currency_conversion.frankfurter_help": "Tipos de cambio gratuitos diarios. No se requiere clave de API del proveedor.",
    "Free daily exchange rates. No provider API key is required.": "Tipos de cambio gratuitos diarios. No se requiere clave de API del proveedor.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Utiliza el servicio Fixer gestionado por la plataforma. Las actualizaciones de tarifas dependen del plan del proveedor.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Utiliza el servicio Fixer gestionado por la plataforma. Las actualizaciones de tarifas dependen del plan del proveedor.",
    "currency_conversion.refresh_interval": "Intervalo de revisión de tarifas (minutos)",
    "Rate re-check interval (minutes)": "Intervalo de revisión de tarifas (minutos)",
    "workspace.currency_search_code": "Buscar o seleccionar",
    "Search or select": "Buscar o seleccionar",
    "workspace.currency_preset_hint": "Se aplican valores predeterminados recomendados. Puedes editar cualquier campo.",
    "Recommended defaults applied. You can edit any field.": "Se aplican valores predeterminados recomendados. Puedes editar cualquier campo.",
    "developer.api_keys.copy_unavailable": "La clave no está disponible aún.",
    "Key is not available yet.": "La clave no está disponible aún.",
    "developer.api_keys.copy_failed": "No se pudo copiar la clave. Inténtalo de nuevo.",
    "Unable to copy the key. Try again.": "No se pudo copiar la clave. Inténtalo de nuevo.",
    "payroll.action.export_pdf": "Exportar PDF",
    "Export PDF": "Exportar PDF",
    "cms.category.name_prompt": "Nombre de categoría",
    "cms.field.cover_image": "Imagen de portada",
    "Cover Image": "Imagen de portada",
    "cms.action.add_cover_photo": "Agregar foto de portada",
    "Add cover photo": "Agregar foto de portada",
    "cms.field.category": "Categoría",
    "cms.category.none": "Sin categoría",
    "No category": "Sin categoría",
    "cms.advanced": "Avanzado",
    "media_picker.action.select_image": "Seleccionar imagen",
    "Select image": "Seleccionar imagen",
    "orders.confirm_record_cash_refund": "Registrar reembolso",
    "Record refund": "Registrar reembolso",
    "listing_form.no_repeat": "No repetir",
    "No repeat": "No repetir",
    "listing_form.custom_repeat_days": "Personalizado: {days}",
    "Custom: {days}": "Personalizado: {days}",
    "common.sending": "Enviando…",
    "listings.detail.unique_name": "Nombre único",
    "Unique Name": "Nombre único",
    "app_customization.username": "Nombre de usuario",
    "workspace.templates.name_required": "Se requiere nombre de plantilla.",
    "Template name is required.": "Se requiere nombre de plantilla.",
    "workspace.templates.saved": "Plantilla de rol guardada.",
    "Role template saved.": "Plantilla de rol guardada.",
    "workspace.templates.confirm_delete": "¿Eliminar plantilla \"{name}\"?",
    "Delete template \"{name}\"?": "¿Eliminar plantilla \"{name}\"?",
    "workspace.templates.deleted": "Plantilla eliminada.",
    "Template deleted.": "Plantilla eliminada.",
    "workspace.members.tab_members": "Miembros",
    "workspace.templates.tab": "Plantillas de rol",
    "Role Templates": "Plantillas de rol",
    "workspace.templates.title": "Plantillas de rol",
    "workspace.templates.new": "Nueva plantilla",
    "New Template": "Nueva plantilla",
    "workspace.templates.name": "Nombre",
    "workspace.templates.empty": "Aún no hay plantillas de rol.",
    "No role templates yet.": "Aún no hay plantillas de rol.",
    "workspace.templates.edit": "Editar plantilla",
    "Edit Template": "Editar plantilla",
    "workspace.templates.name_label": "Nombre de la plantilla",
    "Template name": "Nombre de la plantilla",
    "workspace.templates.name_placeholder": "ej. Gestor de contenido",
    "e.g. Content Manager": "ej. Gestor de contenido",
    "listings.import.unknown_error": "No se pudieron importar las categorías. Verifica el CSV e inténtalo de nuevo.",
    "The categories could not be imported. Please check the CSV and try again.": "No se pudieron importar las categorías. Verifica el CSV e inténtalo de nuevo.",
    "common.no_access_to_page": "Sin acceso",
    "No access": "Sin acceso",
    "common.permission_to_view_page_denied": "No tiene permiso para ver esta página.",
    "You do not have permission to view this page.": "No tiene permiso para ver esta página.",
    "common.loading_permissions": "Cargando permisos…",
    "Loading permissions…": "Cargando permisos…",
    "attributes.added_successfully": "¡Genial 🎉, Atributos agregados con éxito!",
    "Nice 🎉, Successfully added attributes": "¡Genial 🎉, Atributos agregados con éxito!",
    "attributes.add_attribute_values": "Agregar valores de atributo",
    "attributes.attribute": "Atributo",
    "attributes.optional": "Opcional",
    "attributes.private": "Privado",
    "attributes.hidden_field": "Campo oculto",
    "attributes.show_in_filter": "Mostrar en filtro",
    "attributes.status_not_active_active": "Estado (No activo / Activo)",
    "attributes.add_metadata": "Agregar metadatos",
    "Add metadata": "Agregar metadatos",
    "attributes.select_date_time": "Seleccionar fecha y hora",
    "listings.addons.column_title": "Título",
    "listings.addons.column_image": "Imagen",
    "listings.addons.column_price": "Precio",
    "listings.addons.column_max_quantity": "Cantidad máxima",
    "Max Quantity": "Cantidad máxima",
    "listings.addons.column_offer": "Oferta",
    "listings.addons.column_stock": "Stock",
    "listings.addons.column_action": "Acción",
    "listings.addons.column_status": "Estado",
    "listings.addons.confirm_delete": "¿Quieres eliminar este tipo de complemento?",
    "Do you want to delete this add-on type?": "¿Quieres eliminar este tipo de complemento?",
    "common.share_collection": "Compartir colección",
    "Share collection": "Compartir colección",
    "communications.view_modes": "Modos de vista de comunicación",
    "Communication view modes": "Modos de vista de comunicación",
    "payments.accessibility.gateway_logo": "Logotipo de pasarela de pago",
    "Payment gateway logo": "Logotipo de pasarela de pago",
    "common.build_version": "Versión de compilación",
    "Build version": "Versión de compilación",
    "common.build_label": "compilación",
    "build": "compilación",
    "listings.under_category_title": "Listados bajo {category}",
    "Listings under {category}": "Listados bajo {category}",
    "attributes.signup": "Registro",
    "Signup": "Registro",
    "common.toast.please_check_action": "Por favor, revise esta acción",
    "Please check this action": "Por favor, revise esta acción",
    "common.information": "Información",
    "listing_form.error.load_listing_data": "No se pudo cargar los datos del listado",
    "Failed to load listing data": "No se pudo cargar los datos del listado",
    "listing_form.error.load_digital_contents": "No se pudo cargar los contenidos digitales",
    "Failed to load digital contents": "No se pudo cargar los contenidos digitales",
    "listing_form.validation.audio_file_or_url_required": "Agregue un archivo de audio o una URL pública de audio antes de crear el episodio.",
    "Add an audio file or public audio URL before creating the episode.": "Agregue un archivo de audio o una URL pública de audio antes de crear el episodio.",
    "listing_form.validation.rental_rate_greater_than_zero": "Ingrese una tarifa de alquiler mayor que 0.",
    "Enter a rental rate greater than 0.": "Ingrese una tarifa de alquiler mayor que 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "La duración máxima debe ser mayor o igual que la duración mínima.",
    "Maximum duration must be greater than or equal to minimum duration.": "La duración máxima debe ser mayor o igual que la duración mínima.",
    "listing_form.updated_successfully": "Listado actualizado con éxito",
    "Listing updated successfully!": "Listado actualizado con éxito",
    "listing_form.created_successfully": "Listado creado con éxito",
    "Listing created successfully!": "Listado creado con éxito",
    "listing_form.error.save_failed": "No se pudo guardar el listado. Por favor, inténtelo de nuevo.",
    "Failed to save listing. Please try again.": "No se pudo guardar el listado. Por favor, inténtelo de nuevo.",
    "listing_form.error.delete_variant_failed": "No se pudo eliminar la variante: {title}",
    "Failed to delete variant: {title}": "No se pudo eliminar la variante: {title}",
    "listing_form.error.variant_action_failed": "No se pudo {action} la variante: {title}",
    "Failed to {action} variant: {title}": "No se pudo {action} la variante: {title}",
    "listing_form.error.digital_content_action_failed": "No se pudo {action} el contenido digital: {title}",
    "Failed to {action} digital content: {title}": "No se pudo {action} el contenido digital: {title}",
    "listing_form.action.create": "crear",
    "listing_form.action.update": "actualizar",
    "listing_form.action.delete": "eliminar",
    "delete": "eliminar",
    "listing_form.error.save_request_failed": "No se pudo guardar el listado",
    "Failed to save listing": "No se pudo guardar el listado",
    "listing_form.error.rental_settings_save_failed": "Listado guardado, pero no se pudieron guardar los ajustes de alquiler.",
    "Listing saved, but rental settings could not be saved.": "Listado guardado, pero no se pudieron guardar los ajustes de alquiler.",
    "users.action_failed": "La acción falló. Por favor, inténtelo de nuevo.",
    "Action failed. Please try again.": "La acción falló. Por favor, inténtelo de nuevo.",
    "common.successfully_added": "Agregado con éxito",
    "Successfully added": "Agregado con éxito",
    "listing_form.validation.title_min_length": "El título debe tener al menos {count} caracteres",
    "Title must be at least {count} characters": "El título debe tener al menos {count} caracteres",
    "listing_form.validation.title_max_length": "El título no debe exceder {count} caracteres",
    "Title must not exceed {count} characters": "El título no debe exceder {count} caracteres",
    "listing_form.validation.price_minimum": "El precio debe ser al menos {amount}",
    "Price must be at least {amount}": "El precio debe ser al menos {amount}",
    "listing_form.validation.attribute_required": "{attribute} es obligatorio",
    "listings.error.load_failed": "No se pueden cargar los anuncios",
    "Unable to load listings": "No se pueden cargar los anuncios",
    "communications.from_email_required_before_verification": "Por favor, introduzca la dirección de correo electrónico de origen antes de verificar.",
    "Please enter From email address before verifying.": "Por favor, introduzca la dirección de correo electrónico de origen antes de verificar.",
    "communications.verification_email_sent": "Se ha enviado un correo de verificación. Por favor, revise su bandeja de entrada y siga las instrucciones para verificar esta dirección de correo electrónico.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Se ha enviado un correo de verificación. Por favor, revise su bandeja de entrada y siga las instrucciones para verificar esta dirección de correo electrónico.",
    "communications.verification_start_failed": "No se puede iniciar la verificación. Por favor, inténtelo de nuevo.",
    "Unable to start verification. Please try again.": "No se puede iniciar la verificación. Por favor, inténtelo de nuevo.",
    "common.uploaded_successfully": "Subido con éxito",
    "upgrade_page.panel.yearly": "Anual",
    "upgrade_page.panel.monthly": "Mensual",
    "orders.advance_paid": "Pagado por adelantado",
    "Advance paid": "Pagado por adelantado",
    "orders.balance_due": "Saldo pendiente",
    "Balance due": "Saldo pendiente",
    "orders.advance_invalid": "Ingrese una cantidad menor que el total del pedido.",
    "Enter an amount less than the order total.": "Ingrese una cantidad menor que el total del pedido.",
    "orders.advance_failed": "No se pudo guardar el anticipo.",
    "Could not save the advance.": "No se pudo guardar el anticipo.",
    "orders.edit_advance": "Editar anticipo",
    "Edit advance": "Editar anticipo",
    "orders.record_advance": "Registrar anticipo",
    "Record advance": "Registrar anticipo",
    "orders.advance_notice": "Cantidad pagada por el cliente hasta ahora, menos que el total del pedido de {total}. El pedido permanece sin pagar hasta que marque el saldo como pagado. Ingrese 0 para eliminar el anticipo.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Cantidad pagada por el cliente hasta ahora, menos que el total del pedido de {total}. El pedido permanece sin pagar hasta que marque el saldo como pagado. Ingrese 0 para eliminar el anticipo.",
    "orders.save_advance": "Guardar",
    "common.hide": "Ocultar",
    "listings.repeat.daily": "Diario",
    "listings.repeat.weekdays": "Días laborables (Lun-Vie)",
    "Weekdays (Mon-Fri)": "Días laborables (Lun-Vie)",
    "listings.repeat.weekend": "Fin de semana (Sáb-Dom)",
    "Weekend (Sat-Sun)": "Fin de semana (Sáb-Dom)",
    "listings.repeat.custom": "Personalizado",
    "listings.weekday.sun": "Dom",
    "Sun": "Dom",
    "listings.weekday.mon": "Lun",
    "Mon": "Lun",
    "listings.weekday.tue": "Mar",
    "Tue": "Mar",
    "listings.weekday.wed": "Mié",
    "Wed": "Mié",
    "listings.weekday.thu": "Jue",
    "Thu": "Jue",
    "listings.weekday.fri": "Vie",
    "Fri": "Vie",
    "listings.weekday.sat": "Sáb",
    "Sat": "Sáb",
    "orders.pay_balance": "Pagar saldo {amount}",
    "Pay balance {amount}": "Pagar saldo {amount}",
    "orders.partially_paid": "Pagado parcialmente",
    "Partially paid": "Pagado parcialmente",
    "orders.balance_amount": "Saldo {amount}",
    "Balance {amount}": "Saldo {amount}",
    "delivery.get_started.add_branch": "Agregar sucursal",
    "Add branch": "Agregar sucursal",
    "delivery.get_started.add_fleet": "Agregar flota",
    "Add fleet": "Agregar flota",
    "delivery.get_started.api_documentation": "Documentación de la API",
    "API Documentation": "Documentación de la API",
    "delivery.get_started.add_driver": "Agregar conductor",
    "Add driver": "Agregar conductor",
    "delivery.get_started.branch_title": "Agrega tu sucursal",
    "Add your branch": "Agrega tu sucursal",
    "delivery.get_started.branch_description": "Una sucursal puede tener varias flotas y conductores",
    "A branch can have many fleets and drivers": "Una sucursal puede tener varias flotas y conductores",
    "delivery.get_started.fleet_title": "Agrega tu flota",
    "Add your fleet": "Agrega tu flota",
    "delivery.get_started.fleet_description": "Una flota puede asignarse a un conductor",
    "A fleet can be assigned to a driver": "Una flota puede asignarse a un conductor",
    "delivery.get_started.driver_title": "Agrega tu conductor",
    "Add your driver": "Agrega tu conductor",
    "delivery.get_started.driver_description": "El conductor entregará tu pedido",
    "The driver will deliver your order": "El conductor entregará tu pedido",
    "delivery.get_started.order_title": "Crea tu primer pedido",
    "Create your first order": "Crea tu primer pedido",
    "delivery.get_started.order_description": "Los pedidos se pueden crear a través de la API",
    "Orders can be created through the API": "Los pedidos se pueden crear a través de la API",
    "delivery.get_started.progress.branches": "Sucursales",
    "Branches": "Sucursales",
    "delivery.get_started.progress.fleets": "Flotas",
    "Fleets": "Flotas",
    "delivery.get_started.progress.drivers": "Conductores",
    "Drivers": "Conductores",
    "delivery.get_started.progress.orders": "Pedidos de entrega",
    "Delivery Orders": "Pedidos de entrega",
    "delivery.get_started.welcome": "Te damos la bienvenida a",
    "Welcome to": "Te damos la bienvenida a",
    "delivery.get_started.question": "¿Qué te gustaría hacer?",
    "What would you like to do?": "¿Qué te gustaría hacer?",
    "workspace.templates.built_in": "Integrado",
    "Built-in": "Integrado",
    "workspace.templates.copy_of": "Copia de {name}",
    "Copy of {name}": "Copia de {name}",
    "workspace.members.role": "Rol",
    "Role": "Rol",
    "workspace.members.role_full_access": "Acceso completo",
    "Full access": "Acceso completo",
    "workspace.templates.duplicate": "Duplicar",
    "workspace.members.role_custom": "Personalizado (configurar abajo)",
    "Custom (set below)": "Personalizado (configurar abajo)"
  },
  "pt": {
    "0": "0",
    "6100": "6100",
    "common.language": "Idioma",
    "Language": "Idioma",
    "common.english": "Inglês",
    "English": "Inglês",
    "common.french": "Francês",
    "French": "Francês",
    "common.arabic": "Árabe",
    "Arabic": "Árabe",
    "navigation.get_started": "Começar",
    "Get Started": "Começar",
    "navigation.dashboard": "Painel",
    "Dashboard": "Painel",
    "navigation.orders": "Pedidos",
    "Orders": "Pedidos",
    "navigation.schedule": "Agenda",
    "navigation.accounts": "Contas",
    "Accounts": "Contas",
    "navigation.account_categories": "Categorias de contas",
    "Account Categories": "Categorias de contas",
    "navigation.account_attributes": "Atributos de conta",
    "Account Attributes": "Atributos de conta",
    "navigation.account_configuration": "Configuração da conta",
    "navigation.agents": "Agentes",
    "Agents": "Agentes",
    "navigation.listings": "Listagens",
    "navigation.categories": "Categorias",
    "Categories": "Categorias",
    "navigation.custom_attributes": "Atributos personalizados",
    "Custom Attributes": "Atributos personalizados",
    "navigation.variant_types": "Tipos de variante",
    "navigation.additional_features": "Recursos adicionais",
    "Additional Features": "Recursos adicionais",
    "navigation.reported_listings": "Listagens reportadas",
    "Reported Listings": "Listagens reportadas",
    "navigation.report_accounts": "Contas reportadas",
    "Report Accounts": "Contas reportadas",
    "navigation.users": "Usuários",
    "Users": "Usuários",
    "navigation.user_attributes": "Atributos de usuário",
    "User Attributes": "Atributos de usuário",
    "navigation.reviews_ratings": "Avaliações e classificações",
    "navigation.report": "Relatório",
    "Report": "Relatório",
    "navigation.reports": "Relatórios",
    "Reports": "Relatórios",
    "navigation.platform_health": "Saúde da Plataforma",
    "Platform Health": "Saúde da Plataforma",
    "navigation.promotions": "Promoções",
    "Promotions": "Promoções",
    "navigation.collections": "Coleções",
    "Collections": "Coleções",
    "navigation.promotion_ads": "Promoção / Anúncios",
    "Promotion / Ads": "Promoção / Anúncios",
    "navigation.coupons": "Cupons",
    "Coupons": "Cupons",
    "navigation.finance": "Finanças",
    "Finance": "Finanças",
    "navigation.transactions": "Transações",
    "Transactions": "Transações",
    "navigation.settlement": "Liquidar",
    "Settlement": "Liquidar",
    "navigation.expenses": "Despesas",
    "Expenses": "Despesas",
    "navigation.recurring_payments": "Pagamentos recorrentes",
    "Recurring payments": "Pagamentos recorrentes",
    "navigation.media": "Mídia",
    "Media": "Mídia",
    "navigation.communication": "Comunicação",
    "Communication": "Comunicação",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Editor de Site",
    "Website Editor": "Editor de Site",
    "navigation.change_templates": "Alterar Modelos",
    "Change Templates": "Alterar Modelos",
    "navigation.pages": "Páginas",
    "Pages": "Páginas",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Personalizar Textos",
    "Customise texts": "Personalizar Textos",
    "navigation.add_integrations": "Adicionar Integrações",
    "Add Integrations": "Adicionar Integrações",
    "navigation.domain": "Domínio",
    "Domain": "Domínio",
    "navigation.customise_seo": "Personalizar SEO",
    "Customise SEO": "Personalizar SEO",
    "navigation.app": "Aplicativo",
    "App": "Aplicativo",
    "navigation.apps": "Aplicativos",
    "Apps": "Aplicativos",
    "navigation.buy_app_templates": "Comprar modelos de aplicativo",
    "Buy App Templates": "Comprar modelos de aplicativo",
    "navigation.customisation": "Personalização",
    "Customisation": "Personalização",
    "navigation.integrations": "Integrações",
    "Integrations": "Integrações",
    "navigation.invite_team": "Convidar equipe",
    "Invite Team": "Convidar equipe",
    "navigation.help": "Ajuda",
    "Help": "Ajuda",
    "navigation.documentation": "Documentação",
    "Documentation": "Documentação",
    "navigation.community": "Comunidade",
    "Community": "Comunidade",
    "navigation.api_reference": "Referência da API",
    "API Reference": "Referência da API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Canal",
    "navigation.coding_kits": "Kit de codificação",
    "Coding Kits": "Kit de codificação",
    "navigation.vibe_coding": "Programação assistida por IA",
    "Vibe Coding": "Programação assistida por IA",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Configuração",
    "navigation.more": "Mais",
    "More": "Mais",
    "navigation.marketplace": "Marketplace",
    "navigation.commerce": "Comércio",
    "Commerce": "Comércio",
    "navigation.marketing": "Marketing",
    "Marketing": "Marketing",
    "navigation.intelligence": "Inteligência",
    "Intelligence": "Inteligência",
    "navigation.subscription": "Assinatura",
    "Subscription": "Assinatura",
    "navigation.membership": "Membro",
    "navigation.rewards": "Recompensas",
    "Rewards": "Recompensas",
    "navigation.bundles": "Pacotes",
    "Bundles": "Pacotes",
    "navigation.supply_chain": "Cadeia de suprimento",
    "navigation.people": "Pessoas",
    "People": "Pessoas",
    "navigation.workforce": "Força de trabalho",
    "navigation.payroll": "Folha de pagamento",
    "navigation.inventory": "Inventário",
    "navigation.inventory_operations": "Operações de estoque",
    "Inventory Operations": "Operações de estoque",
    "navigation.purchase_orders": "Pedidos de compra",
    "Purchase Orders": "Pedidos de compra",
    "navigation.stock_locations": "Localizações de estoque",
    "Stock Locations": "Localizações de estoque",
    "navigation.purchase_orders_2": "Pedidos de compra",
    "Purchase orders": "Pedidos de compra",
    "navigation.suppliers": "Fornecedores",
    "Suppliers": "Fornecedores",
    "navigation.locations": "Localizações",
    "Locations": "Localizações",
    "navigation.maps": "Mapas",
    "Maps": "Mapas",
    "navigation.accounting": "Contabilidade",
    "Accounting": "Contabilidade",
    "navigation.invoices": "Faturas",
    "Invoices": "Faturas",
    "navigation.plans": "Planos",
    "Plans": "Planos",
    "navigation.countries": "Países",
    "Countries": "Países",
    "navigation.currency": "Moeda",
    "Currency": "Moeda",
    "navigation.languages": "Idiomas",
    "Languages": "Idiomas",
    "navigation.payments": "Pagamentos",
    "Payments": "Pagamentos",
    "navigation.commissions": "Comissões",
    "Commissions": "Comissões",
    "navigation.taxes": "Impostos",
    "Taxes": "Impostos",
    "navigation.special_fees": "Taxas especiais",
    "navigation.service_shipping": "Serviço / Entrega",
    "navigation.checkout_cart_attributes": "Atributos de carrinho e checkout",
    "navigation.dark_mode_background_color": "Cor de fundo do modo escuro",
    "Dark Mode Background Color": "Cor de fundo do modo escuro",
    "navigation.dark_mode_text_color": "Cor do texto do modo escuro",
    "Dark Mode Text Color": "Cor do texto do modo escuro",
    "navigation.light_mode_background_color": "Cor de fundo do modo claro",
    "Light Mode Background Color": "Cor de fundo do modo claro",
    "navigation.light_mode_text_color": "Cor do texto do modo claro",
    "Light Mode Text Color": "Cor do texto do modo claro",
    "navigation.workspace": "Espaço de trabalho",
    "Workspace": "Espaço de trabalho",
    "navigation.user_management": "Gerenciamento de usuários",
    "User Management": "Gerenciamento de usuários",
    "navigation.privacy": "Privacidade",
    "Privacy": "Privacidade",
    "common.search": "Pesquisar...",
    "Search...": "Pesquisar...",
    "common.search_2": "Pesquisar",
    "common.no_results_found": "Nenhum resultado encontrado",
    "No results found": "Nenhum resultado encontrado",
    "common.no_record_found": "Nenhum registro encontrado",
    "No Record Found": "Nenhum registro encontrado",
    "common.open_in_a_new_tab": "Abrir em uma nova guia",
    "Open in a new tab": "Abrir em uma nova guia",
    "common.open": "Abrir",
    "common.in_a_new_tab": "em uma nova guia",
    "in a new tab": "em uma nova guia",
    "common.loading_page": "Carregando página…",
    "Loading page…": "Carregando página…",
    "common.close": "Fechar",
    "Close": "Fechar",
    "common.save": "Salvar",
    "Save": "Salvar",
    "common.cancel": "Cancelar",
    "Cancel": "Cancelar",
    "common.delete": "Excluir",
    "Delete": "Excluir",
    "common.edit": "Editar",
    "Edit": "Editar",
    "common.add": "Adicionar",
    "Add": "Adicionar",
    "common.create": "Criar",
    "Create": "Criar",
    "common.update": "Atualizar",
    "Update": "Atualizar",
    "common.back": "Voltar",
    "Back": "Voltar",
    "common.next": "Próximo",
    "Next": "Próximo",
    "common.previous": "Anterior",
    "Previous": "Anterior",
    "common.done": "Concluído",
    "Done": "Concluído",
    "common.yes": "Sim",
    "Yes": "Sim",
    "common.no": "Não",
    "No": "Não",
    "common.name": "Nome",
    "Name": "Nome",
    "common.status": "Status",
    "Status": "Status",
    "common.date": "Data",
    "Date": "Data",
    "common.actions": "Ações",
    "Actions": "Ações",
    "common.action": "Ação",
    "Action": "Ação",
    "orders.scan_order": "Escanear pedido",
    "Scan order": "Escanear pedido",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Escanear referência de código de barras/QR ou digitar manualmente.",
    "Scan a barcode/QR reference or enter it manually.": "Escanear referência de código de barras/QR ou digitar manualmente.",
    "orders.camera_scanner": "Scanner de câmera",
    "Camera scanner": "Scanner de câmera",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "Escanear câmera não é suportado aqui. Digite a referência do pedido abaixo.",
    "Camera scanning is not supported here. Enter the order reference below.": "Escanear câmera não é suportado aqui. Digite a referência do pedido abaixo.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "Acesso à câmera não está disponível. Digite a referência do pedido abaixo.",
    "Camera access is unavailable. Enter the order reference below.": "Acesso à câmera não está disponível. Digite a referência do pedido abaixo.",
    "orders.order_reference_number": "Número de referência do pedido",
    "Order reference number": "Número de referência do pedido",
    "orders.find_order": "Localizar pedido",
    "Find order": "Localizar pedido",
    "common.your_orders_will_be_shown_here": "Seus pedidos serão exibidos aqui.",
    "Your orders will be shown here.": "Seus pedidos serão exibidos aqui.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Aqui, você pode acompanhar os pedidos, reservas, etc. feitos com outras contas e seguir as atualizações de status.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Aqui, você pode acompanhar os pedidos, reservas, etc. feitos com outras contas e seguir as atualizações de status.",
    "common.reference": "Referência #",
    "Reference #": "Referência #",
    "common.amount": "Valor",
    "Amount": "Valor",
    "orders.order_status": "Status do pedido",
    "Order Status": "Status do pedido",
    "orders.payment_status": "Status do pagamento",
    "Payment Status": "Status do pagamento",
    "common.payment_method": "Método de pagamento",
    "Payment Method": "Método de pagamento",
    "common.shipping_method": "Método de envio",
    "Shipping Method": "Método de envio",
    "common.paid": "Pago",
    "Paid": "Pago",
    "common.not_paid": "Não pago",
    "Not Paid": "Não pago",
    "common.unpaid": "Não pago",
    "UnPaid": "Não pago",
    "common.failed": "Falhou",
    "common.incomplete": "Incompleto",
    "Incomplete": "Incompleto",
    "common.order_placed": "Pedido realizado",
    "Order placed": "Pedido realizado",
    "common.order_in_progress": "Pedido em andamento",
    "Order in progress": "Pedido em andamento",
    "common.shipped": "Enviado",
    "Shipped": "Enviado",
    "common.delivered": "Entregue",
    "Delivered": "Entregue",
    "common.cancelled_by_customer": "Cancelado pelo cliente",
    "Cancelled by customer": "Cancelado pelo cliente",
    "common.order_completed": "Pedido concluído",
    "Order completed": "Pedido concluído",
    "common.n_a": "N/A",
    "orders.total_orders": "Pedidos totais",
    "Total Orders": "Pedidos totais",
    "orders.page_revenue": "Receita da página",
    "Page Revenue": "Receita da página",
    "orders.pending_payment": "Pagamento pendente",
    "Pending Payment": "Pagamento pendente",
    "common.failed_payments": "Pagamentos falhados",
    "Failed payments": "Pagamentos falhados",
    "common.abandoned": "Abandonado",
    "Abandoned": "Abandonado",
    "orders.search_orders_by_reference_number": "Pesquisar pedidos pelo número de referência",
    "Search orders by reference number": "Pesquisar pedidos pelo número de referência",
    "orders.search_by_reference_number": "Pesquisar pelo número de referência…",
    "Search by reference number…": "Pesquisar pelo número de referência…",
    "orders.export_orders_as_csv": "Exportar pedidos como CSV",
    "Export orders as CSV": "Exportar pedidos como CSV",
    "orders.manual_order": "Pedido manual",
    "Manual Order": "Pedido manual",
    "orders.scan_order_reference": "Escanear referência do pedido",
    "Scan order reference": "Escanear referência do pedido",
    "orders.change_status_to": "Alterar status para…",
    "Change status to…": "Alterar status para…",
    "common.apply": "Aplicar",
    "Apply": "Aplicar",
    "common.clear": "Limpar",
    "Clear": "Limpar",
    "orders.pay": "Pagar",
    "Pay": "Pagar",
    "orders.clear_selection": "Limpar seleção",
    "Clear selection": "Limpar seleção",
    "orders.list": "Lista",
    "orders.board": "Quadro",
    "Board": "Quadro",
    "orders.filter_orders": "Filtrar pedidos",
    "Filter orders": "Filtrar pedidos",
    "orders.start_date": "Data de início",
    "Start Date": "Data de início",
    "orders.end_date": "Data de término",
    "End Date": "Data de término",
    "orders.select_date": "Selecionar data",
    "Select Date": "Selecionar data",
    "orders.show_rows": "Mostrar linhas",
    "Show rows": "Mostrar linhas",
    "common.order_selected": "pedido selecionado",
    "order selected": "pedido selecionado",
    "common.orders_selected": "pedidos selecionados",
    "orders selected": "pedidos selecionados",
    "common.order_updated": "pedido atualizado",
    "order updated": "pedido atualizado",
    "common.orders_updated": "pedidos atualizados",
    "orders updated": "pedidos atualizados",
    "orders.order_archived_successfully": "Pedido arquivado com sucesso",
    "Order archived successfully": "Pedido arquivado com sucesso",
    "orders.failed_to_archive_order": "Falha ao arquivar pedido",
    "Failed to archive order": "Falha ao arquivar pedido",
    "orders.loading_order": "Carregando pedido…",
    "Loading order…": "Carregando pedido…",
    "orders.order_created_successfully": "Pedido criado com sucesso",
    "Order created successfully": "Pedido criado com sucesso",
    "orders.the_order_has_been_created_and_is_ready_to_review": "O pedido foi criado e está pronto para revisão.",
    "The order has been created and is ready to review.": "O pedido foi criado e está pronto para revisão.",
    "orders.order_reference": "Referência do pedido",
    "Order reference": "Referência do pedido",
    "common.created": "Criado",
    "Created": "Criado",
    "common.total": "Total",
    "Total": "Total",
    "common.items": "Itens",
    "Items": "Itens",
    "orders.print_save_pdf": "Imprimir / Salvar PDF",
    "Print / Save PDF": "Imprimir / Salvar PDF",
    "orders.view_order_details": "Ver detalhes do pedido",
    "View order details": "Ver detalhes do pedido",
    "orders.create_another_order": "Criar outro pedido",
    "Create another order": "Criar outro pedido",
    "orders.confirmed": "Confirmado",
    "Confirmed": "Confirmado",
    "orders.in_progress": "Em andamento",
    "In progress": "Em andamento",
    "orders.customer_unreachable": "Cliente não alcançável",
    "Customer unreachable": "Cliente não alcançável",
    "orders.out_for_delivery": "Em trânsito para entrega",
    "Out for delivery": "Em trânsito para entrega",
    "orders.returned": "Devolvido",
    "Returned": "Devolvido",
    "orders.return_confirmed": "Devolução confirmada",
    "Return confirmed": "Devolução confirmada",
    "orders.delivery_confirmed": "Entrega confirmada",
    "Delivery confirmed": "Entrega confirmada",
    "orders.return_initiated": "Devolução iniciada",
    "Return initiated": "Devolução iniciada",
    "orders.return_picked": "Devolução coletada",
    "Return picked": "Devolução coletada",
    "orders.return_disputed": "Devolução em disputa",
    "Return disputed": "Devolução em disputa",
    "orders.canceled_by_seller": "Cancelado pelo vendedor",
    "Canceled by seller": "Cancelado pelo vendedor",
    "orders.canceled_by_customer": "Cancelado pelo cliente",
    "Canceled by customer": "Cancelado pelo cliente",
    "orders.ready_for_pickup": "Pronto para retirar",
    "Ready for pickup": "Pronto para retirar",
    "orders.arrived_at_customer_location": "Chegou ao local do cliente",
    "Arrived at customer location": "Chegou ao local do cliente",
    "orders.undelivered_returned": "Não entregue - Devolvido",
    "Undelivered - Returned": "Não entregue - Devolvido",
    "orders.undelivered_return_confirmed": "Não entregue - Devolução confirmada",
    "Undelivered - Return confirmed": "Não entregue - Devolução confirmada",
    "orders.disputed": "Em disputa",
    "Disputed": "Em disputa",
    "orders.completed": "Concluído",
    "Completed": "Concluído",
    "orders.detail_legacy.order_number": "Número do pedido:",
    "Order Number:": "Número do pedido:",
    "orders.detail_legacy.order_date": "Data do pedido:",
    "Order Date:": "Data do pedido:",
    "orders.detail_legacy.buyer_details": "Detalhes do comprador:",
    "Buyer Details:": "Detalhes do comprador:",
    "orders.detail_legacy.delivery_address": "Endereço de entrega:",
    "Delivery Address:": "Endereço de entrega:",
    "orders.detail_legacy.pickup_address": "Endereço de retirada:",
    "Pickup Address:": "Endereço de retirada:",
    "orders.detail_legacy.total_amount": "Valor total:",
    "Total Amount:": "Valor total:",
    "orders.detail_legacy.amount_in_words": "Valor por extenso:",
    "Amount in Words:": "Valor por extenso:",
    "orders.detail_legacy.amount_words_only": "Apenas",
    "Only": "Apenas",
    "orders.detail_legacy.payout_date": "Data de pagamento:",
    "Payout Date:": "Data de pagamento:",
    "orders.detail_legacy.change": "Troco",
    "orders.detail_legacy.select_date_time": "Selecionar data e horário",
    "orders.detail_legacy.change_payout_date_time": "Alterar data e horário de pagamento",
    "Change Payout Date and Time": "Alterar data e horário de pagamento",
    "orders.detail_legacy.update_payout": "Atualizar",
    "orders.detail_legacy.update_status": "Atualizar status",
    "Update Status": "Atualizar status",
    "orders.detail_legacy.change_order_status": "Alterar status do pedido",
    "Change Order Status": "Alterar status do pedido",
    "orders.detail_legacy.column_description": "Descrição",
    "Description": "Descrição",
    "orders.detail_legacy.column_unit_price": "Preço unitário",
    "Unit Price": "Preço unitário",
    "orders.detail_legacy.column_discount": "Desconto",
    "Discount": "Desconto",
    "orders.detail_legacy.column_tax_rate": "Taxa de imposto",
    "Tax Rate": "Taxa de imposto",
    "orders.item": "Item",
    "Item": "Item",
    "orders.order_details": "Detalhes do pedido",
    "Order Details": "Detalhes do pedido",
    "orders.copy_order_reference": "Copiar referência do pedido",
    "Copy order reference": "Copiar referência do pedido",
    "orders.order_summary": "Resumo do pedido",
    "Order Summary": "Resumo do pedido",
    "orders.order_created": "Pedido criado",
    "Order created": "Pedido criado",
    "orders.order_time": "Hora do pedido",
    "Order time": "Hora do pedido",
    "orders.total_earnings": "Ganhos totais",
    "Total earnings": "Ganhos totais",
    "orders.total_price": "Preço total",
    "Total price": "Preço total",
    "orders.delivery_fee": "Taxa de entrega",
    "Delivery fee": "Taxa de entrega",
    "orders.sub_total": "Subtotal",
    "Sub total": "Subtotal",
    "orders.customer_information": "Informações do cliente",
    "Customer Information": "Informações do cliente",
    "common.customer_name": "Nome do cliente",
    "Customer Name": "Nome do cliente",
    "common.phone": "Telefone",
    "Phone": "Telefone",
    "common.email": "E-mail",
    "Email": "E-mail",
    "orders.seller_details": "Detalhes do vendedor",
    "Seller Details": "Detalhes do vendedor",
    "common.seller_name": "Nome do vendedor",
    "Seller Name": "Nome do vendedor",
    "common.mobile": "Celular",
    "orders.generate": "Gerar",
    "Generate": "Gerar",
    "orders.cancel_order": "Cancelar pedido",
    "Cancel Order": "Cancelar pedido",
    "orders.mark_as_paid": "Marcar como pago",
    "Mark as Paid": "Marcar como pago",
    "orders.failed_to_mark_as_paid": "Falha ao marcar como pago",
    "Failed to mark as paid": "Falha ao marcar como pago",
    "orders.order_cancelled_successfully": "Pedido cancelado com sucesso",
    "Order cancelled successfully": "Pedido cancelado com sucesso",
    "orders.failed_to_cancel_order_by_admin": "Falha ao cancelar pedido pelo administrador",
    "Failed to cancel order by admin": "Falha ao cancelar pedido pelo administrador",
    "orders.no_transactions_found": "Nenhuma transação encontrada",
    "No transactions found": "Nenhuma transação encontrada",
    "orders.transaction_no": "Número da transação",
    "Transaction No": "Número da transação",
    "orders.entity": "Entidade",
    "Entity": "Entidade",
    "orders.transaction_type": "Tipo de transação",
    "Transaction Type": "Tipo de transação",
    "common.seller": "Vendedor",
    "Seller": "Vendedor",
    "common.customer": "Cliente",
    "Customer": "Cliente",
    "common.platform_owner": "Proprietário da plataforma",
    "Platform Owner": "Proprietário da plataforma",
    "orders.items_summary": "Resumo dos itens",
    "Items Summary": "Resumo dos itens",
    "orders.qty": "Quantidade",
    "orders.price": "Preço",
    "Price": "Preço",
    "orders.total_price_2": "Preço total",
    "Total Price": "Preço total",
    "orders.membership_purchase": "Compra de assinatura",
    "Membership purchase": "Compra de assinatura",
    "orders.member_id": "ID do membro",
    "Member ID": "ID do membro",
    "orders.period": "Período",
    "Period": "Período",
    "orders.start_date_2": "Data de início",
    "Start date": "Data de início",
    "common.next_renewal": "Próxima renovação",
    "Next renewal": "Próxima renovação",
    "common.expiry_date": "Data de expiração",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Este pedido é gerenciado como uma contribuição de assinatura, não como um envio.",
    "This order is managed as a membership contribution, not a shipment.": "Este pedido é gerenciado como uma contribuição de assinatura, não como um envio.",
    "orders.months": "meses",
    "months": "meses",
    "orders.days": "dias",
    "days": "dias",
    "orders.address": "Endereço",
    "Address": "Endereço",
    "orders.address_1": "Endereço 1",
    "Address 1": "Endereço 1",
    "orders.address_2": "Endereço 2",
    "Address 2": "Endereço 2",
    "orders.zip_code": "CEP",
    "Zip code": "CEP",
    "orders.full_address": "Endereço completo",
    "Full Address": "Endereço completo",
    "orders.formatted_address": "Endereço formatado",
    "Formatted Address": "Endereço formatado",
    "orders.phone_number": "Número de telefone",
    "Phone Number": "Número de telefone",
    "orders.address_not_found": "Endereço não encontrado",
    "Address not found": "Endereço não encontrado",
    "orders.address_not_applicable": "Endereço não aplicável",
    "Address not applicable": "Endereço não aplicável",
    "orders.address_is_not_available": "Endereço não disponível",
    "Address is not available": "Endereço não disponível",
    "orders.add_pickup_address": "Adicionar endereço de retirada",
    "Add Pickup Address": "Adicionar endereço de retirada",
    "orders.edit_pickup_address": "Editar endereço de retirada",
    "Edit Pickup Address": "Editar endereço de retirada",
    "orders.discard_and_close": "Descartar e fechar",
    "Discard and close": "Descartar e fechar",
    "orders.state": "Estado",
    "State": "Estado",
    "common.country": "País",
    "Country": "País",
    "orders.sales_payout": "Pagamento de vendas",
    "Sales Payout": "Pagamento de vendas",
    "orders.sales_no_payout": "Vendas (Sem pagamento)",
    "Sales (No Payout)": "Vendas (Sem pagamento)",
    "orders.sales_payout_reversal": "Reversão do pagamento de vendas",
    "Sales Payout Reversal": "Reversão do pagamento de vendas",
    "orders.sales_no_payout_reversal": "Reversão de vendas sem pagamento",
    "Sales no payout reversal": "Reversão de vendas sem pagamento",
    "orders.seller_commission": "Comissão do vendedor",
    "Seller Commission": "Comissão do vendedor",
    "orders.seller_commission_reversal": "Reversão da comissão do vendedor",
    "Seller Commission Reversal": "Reversão da comissão do vendedor",
    "orders.seller_transfer": "Transferência do vendedor",
    "Seller Transfer": "Transferência do vendedor",
    "orders.seller_transfer_reversal": "Reversão da transferência do vendedor",
    "Seller Transfer Reversal": "Reversão da transferência do vendedor",
    "orders.seller_payout": "Pagamento do vendedor",
    "Seller Payout": "Pagamento do vendedor",
    "orders.seller_subscription": "Assinatura do vendedor",
    "Seller Subscription": "Assinatura do vendedor",
    "orders.seller_payment_processing_fee": "Taxa de processamento de pagamento do vendedor",
    "Seller Payment processing fee": "Taxa de processamento de pagamento do vendedor",
    "orders.seller_payment_processing_fee_reversal": "Reversão da taxa de processamento de pagamento do vendedor",
    "Seller Payment processing fee reversal": "Reversão da taxa de processamento de pagamento do vendedor",
    "orders.sub_total_2": "Subtotal",
    "Sub Total": "Subtotal",
    "orders.customer_commission": "Comissão do cliente",
    "Customer Commission": "Comissão do cliente",
    "orders.tax": "Imposto",
    "Tax": "Imposto",
    "orders.shipping_charge": "Custo de envio",
    "Shipping Charge": "Custo de envio",
    "orders.refund": "Reembolso",
    "Refund": "Reembolso",
    "orders.special_fee": "Taxa especial",
    "Special Fee": "Taxa especial",
    "orders.coupon": "Cupom",
    "Coupon": "Cupom",
    "orders.shipment": "Envio",
    "Shipment": "Envio",
    "orders.fulfilled_by_platform": "Atendido pela plataforma",
    "Fulfilled by platform": "Atendido pela plataforma",
    "orders.fulfilled_by": "Atendido por",
    "Fulfilled by": "Atendido por",
    "orders.fulfilled_by_seller": "Atendido pelo vendedor",
    "Fulfilled by seller": "Atendido pelo vendedor",
    "orders.on_seller_protection_policy": "Política de Proteção ao Vendedor",
    "On Seller Protection Policy": "Política de Proteção ao Vendedor",
    "orders.product_image": "Imagem do produto",
    "Product image": "Imagem do produto",
    "orders.status_changed_successfully": "Status alterado com sucesso",
    "Status changed successfully": "Status alterado com sucesso",
    "orders.pickup_address_not_available_please_add_pickup_address": "Endereço de retirada não disponível. Por favor, adicione endereço de retirada",
    "Pickup Address not available. Please Add Pickup Address": "Endereço de retirada não disponível. Por favor, adicione endereço de retirada",
    "orders.failed_to_save_pickup_address_please_try_again": "Falha ao salvar endereço de retirada. Por favor, tente novamente",
    "Failed to save pickup address. Please try again.": "Falha ao salvar endereço de retirada. Por favor, tente novamente",
    "orders.change_shipment_status": "Alterar status do envio",
    "Change shipment status": "Alterar status do envio",
    "orders.not_available": "Indisponível",
    "Not available": "Indisponível",
    "orders.shipment_created": "Envio criado",
    "orders.shipment_in_progress": "Envio em andamento",
    "orders.ship": "Enviar",
    "Ship": "Enviar",
    "orders.undelivered_return": "Devolução sem entrega",
    "orders.shipment_deliver": "Entrega do envio",
    "Shipment deliver": "Entrega do envio",
    "orders.shipment_delivery_confirm": "Confirmar entrega do envio",
    "Shipment delivery confirm": "Confirmar entrega do envio",
    "orders.return_initiate": "Iniciar devolução",
    "Return initiate": "Iniciar devolução",
    "orders.return_for_pickup": "Devolução para retirada",
    "Return for pickup": "Devolução para retirada",
    "orders.shipment_return_confirm": "Confirmar devolução do envio",
    "Shipment return confirm": "Confirmar devolução do envio",
    "orders.cancel_by_seller": "Cancelar por vendedor",
    "Cancel by seller": "Cancelar por vendedor",
    "orders.cancel_by_customer": "Cancelar por cliente",
    "Cancel by customer": "Cancelar por cliente",
    "orders.arrive_at_customer_location": "Chegar ao local do cliente",
    "Arrive at customer location": "Chegar ao local do cliente",
    "orders.shipment_delivered": "Envio entregue",
    "orders.shipment_delivery_confirmed": "Entrega confirmada",
    "Shipment delivery confirmed": "Entrega confirmada",
    "orders.returned_for_pickup": "Devolução para retirada",
    "orders.shipment_return_confirmed": "Devolução confirmada",
    "Shipment return confirmed": "Devolução confirmada",
    "orders.cancelled_by_seller": "Cancelado por vendedor",
    "common.cancelled_by_admin": "Cancelado pelo administrador",
    "orders.invoice": "Fatura",
    "Invoice": "Fatura",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Selecione um tipo de arquivo válido (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Selecione um tipo de arquivo válido (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "O tamanho do arquivo deve ser inferior a 5 MB",
    "File size must be less than 5MB": "O tamanho do arquivo deve ser inferior a 5 MB",
    "orders.please_upload_a_file_first": "Carregue um arquivo primeiro",
    "Please upload a file first": "Carregue um arquivo primeiro",
    "orders.invoice_uploaded_successfully": "Fatura carregada com sucesso",
    "Invoice uploaded successfully!": "Fatura carregada com sucesso",
    "orders.failed_to_upload_invoice_please_try_again": "Falha ao carregar a fatura. Tente novamente.",
    "Failed to upload invoice. Please try again.": "Falha ao carregar a fatura. Tente novamente.",
    "orders.upload_invoice": "Carregar fatura",
    "Upload Invoice": "Carregar fatura",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Formatos suportados: PDF, JPG, PNG, DOC (Tamanho máximo: 5 MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Formatos suportados: PDF, JPG, PNG, DOC (Tamanho máximo: 5 MB)",
    "orders.uploading": "Carregando...",
    "orders.choose_file": "Escolher arquivo",
    "Choose File": "Escolher arquivo",
    "common.download": "Baixar",
    "Download": "Baixar",
    "common.remove": "Remover",
    "Remove": "Remover",
    "orders.upload_new_file": "Carregar novo arquivo",
    "Upload New File": "Carregar novo arquivo",
    "orders.saving": "Salvando...",
    "Saving...": "Salvando...",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Excluir um pedido removerá imediatamente o pedido da visão do vendedor e do comprador. Após exclusão, nenhuma atualização de status adicional será permitida, e o pedido será excluído de todas as métricas e relatórios. Você tem certeza de que deseja prosseguir?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Excluir um pedido removerá imediatamente o pedido da visão do vendedor e do comprador. Após exclusão, nenhuma atualização de status adicional será permitida, e o pedido será excluído de todas as métricas e relatórios. Você tem certeza de que deseja prosseguir?",
    "common.showing": "Mostrando",
    "Showing": "Mostrando",
    "common.of": "de",
    "of": "de",
    "common.all": "Todos",
    "common.active": "Ativo",
    "Active": "Ativo",
    "common.inactive": "Inativo",
    "Inactive": "Inativo",
    "common.enabled": "Habilitado",
    "Enabled": "Habilitado",
    "common.disabled": "Desabilitado",
    "common.success": "Sucesso",
    "Success": "Sucesso",
    "common.error": "Erro",
    "Error": "Erro",
    "common.warning": "Aviso",
    "Warning": "Aviso",
    "common.required": "Obrigatório",
    "Required": "Obrigatório",
    "users.title": "Usuários",
    "users.import": "Importar",
    "Import": "Importar",
    "users.import_users": "Importar usuários",
    "Import users": "Importar usuários",
    "users.smart_upload_users": "Upload inteligente de usuários",
    "Smart Upload Users": "Upload inteligente de usuários",
    "users.smart_upload_beta": "Upload inteligente de usuários (Beta)",
    "Smart upload users (Beta)": "Upload inteligente de usuários (Beta)",
    "users.export": "Exportar",
    "Export": "Exportar",
    "users.export_users": "Exportar usuários",
    "Export users": "Exportar usuários",
    "users.search_users": "Pesquisar usuários",
    "Search users": "Pesquisar usuários",
    "users.verified": "Verificado",
    "Verified": "Verificado",
    "users.not_verified": "Não verificado",
    "Non Verified": "Não verificado",
    "users.block": "Bloquear",
    "Block": "Bloquear",
    "users.unblock": "Desbloquear",
    "Unblock": "Desbloquear",
    "users.confirm_block": "Você quer bloquear este usuário?",
    "Do you want to block this user?": "Você quer bloquear este usuário?",
    "users.confirm_unblock": "Você quer desbloquear este usuário?",
    "Do you want to unblock this user?": "Você quer desbloquear este usuário?",
    "users.import_export": "Importação e exportação de usuários",
    "User import and export": "Importação e exportação de usuários",
    "users.user_id": "ID do usuário",
    "User ID": "ID do usuário",
    "users.first_name": "Nome",
    "First Name": "Nome",
    "users.last_name": "Sobrenome",
    "Last Name": "Sobrenome",
    "users.email": "E-mail",
    "users.phone_number": "Número de telefone",
    "users.country": "País",
    "users.profile": "Perfil",
    "Profile": "Perfil",
    "users.email_verified": "E-mail verificado",
    "Email Verified": "E-mail verificado",
    "users.blocked": "Bloqueado",
    "Blocked": "Bloqueado",
    "users.action": "Ação",
    "users.join_date": "Data de inscrição",
    "Join Date": "Data de inscrição",
    "users.last_login": "Último acesso",
    "Last Login": "Último acesso",
    "users.customer_type": "Tipo de cliente",
    "Customer Type": "Tipo de cliente",
    "common.and": "e",
    "and": "e",
    "users.import_failed": "Falha na importação do usuário.",
    "User import failed.": "Falha na importação do usuário.",
    "users.smart_upload.paid_title": "O upload inteligente de usuários é um recurso pago",
    "Smart user upload is a paid feature": "O upload inteligente de usuários é um recurso pago",
    "users.smart_upload.paid_description": "Atualize seu workspace para Starter ou Go para importar usuários de um arquivo CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Atualize seu workspace para Starter ou Go para importar usuários de um arquivo CSV.",
    "users.smart_upload.view_plans": "Ver planos",
    "View plans": "Ver planos",
    "users.smart_upload.csv_needs_user": "O CSV deve conter uma linha de cabeçalho e pelo menos um usuário.",
    "The CSV must contain a header row and at least one user.": "O CSV deve conter uma linha de cabeçalho e pelo menos um usuário.",
    "users.smart_upload.unique_headers": "Cada coluna de usuário precisa de um cabeçalho único e não vazio.",
    "Every user column needs a unique, non-empty header.": "Cada coluna de usuário precisa de um cabeçalho único e não vazio.",
    "users.smart_upload.csv_read_error": "Não é possível ler este CSV.",
    "Unable to read this CSV.": "Não é possível ler este CSV.",
    "users.smart_upload.map_required": "Mapeie {fields} antes de continuar.",
    "Map {fields} before continuing.": "Mapeie {fields} antes de continuar.",
    "users.smart_upload.map_contact": "Mapeie uma coluna de E-mail ou Telefone. Cada linha precisa de pelo menos um método de contato.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Mapeie uma coluna de E-mail ou Telefone. Cada linha precisa de pelo menos um método de contato.",
    "users.smart_upload.invalid_row": "A linha {row} está faltando um valor obrigatório de nome ou contato.",
    "Row {row} is missing a required name or contact value.": "A linha {row} está faltando um valor obrigatório de nome ou contato.",
    "users.smart_upload.attribute_name_required": "Insira um nome de atributo para “{header}”.",
    "users.smart_upload.attribute_create_error": "Não foi possível criar o atributo “{name}”.",
    "Could not create the “{name}” attribute.": "Não foi possível criar o atributo “{name}”.",
    "users.smart_upload.attribute_missing": "O atributo mapeado a partir de “{header}” não está mais disponível.",
    "users.smart_upload.prepare_error": "Não foi possível preparar o arquivo de importação.",
    "Could not prepare the import file.": "Não foi possível preparar o arquivo de importação.",
    "users.smart_upload.upload_error": "Não foi possível enviar o arquivo de importação.",
    "The import file could not be uploaded.": "Não foi possível enviar o arquivo de importação.",
    "users.smart_upload.all_duplicates": "Cada linha é um duplicado de outra linha neste arquivo.",
    "Every row is a duplicate of another row in this file.": "Cada linha é um duplicado de outra linha neste arquivo.",
    "users.smart_upload.source_attribute_error": "Não foi possível criar o atributo contact_source.",
    "Could not create the contact_source attribute.": "Não foi possível criar o atributo contact_source.",
    "users.smart_upload.duplicates_skipped": "Linhas duplicadas para ignorar: {count}.",
    "Duplicate rows to skip: {count}.": "Linhas duplicadas para ignorar: {count}.",
    "users.smart_upload.preparing_attributes": "Preparando atributos",
    "Preparing attributes": "Preparando atributos",
    "users.smart_upload.checking_users": "Verificando usuários existentes",
    "Checking existing users": "Verificando usuários existentes",
    "users.smart_upload.uploading_file": "Enviando arquivo de importação",
    "Uploading import file": "Enviando arquivo de importação",
    "users.smart_upload.importing_users": "Tradly está importando usuários",
    "Tradly is importing users": "Tradly está importando usuários",
    "users.smart_upload.import_stopped": "Importação interrompida",
    "Import stopped": "Importação interrompida",
    "users.smart_upload.title": "Upload inteligente de usuários",
    "Smart user upload": "Upload inteligente de usuários",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Começar novamente",
    "Start over": "Começar novamente",
    "users.smart_upload.description": "Faça o upload de contatos, mapeie colunas para atributos de usuário e classifique-os como saídas ou registradas.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Faça o upload de contatos, mapeie colunas para atributos de usuário e classifique-os como saídas ou registradas.",
    "users.smart_upload.step_upload": "Enviar",
    "users.smart_upload.step_match": "Mapear colunas",
    "users.smart_upload.step_review": "Revisar",
    "users.smart_upload.step_import": "Importar",
    "users.smart_upload.choose_csv": "Selecione um arquivo CSV",
    "users.smart_upload.required_fields": "Primeiro nome, último nome e e-mail ou telefone são obrigatórios. Senhas são geradas automaticamente.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Primeiro nome, último nome e e-mail ou telefone são obrigatórios. Senhas são geradas automaticamente.",
    "users.smart_upload.select_csv": "Selecione o arquivo CSV",
    "users.smart_upload.match_columns": "Mapear colunas de usuário",
    "Match user columns": "Mapear colunas de usuário",
    "users.smart_upload.first_name": "Primeiro nome",
    "users.smart_upload.last_name": "Sobrenome",
    "Last name": "Sobrenome",
    "users.smart_upload.email": "E-mail",
    "users.smart_upload.phone": "Telefone",
    "users.smart_upload.username": "Nome de usuário",
    "Username": "Nome de usuário",
    "users.smart_upload.do_not_import": "Não importar",
    "Do not import": "Não importar",
    "users.smart_upload.additional_attributes": "Atributos adicionais do usuário",
    "Additional user attributes": "Atributos adicionais do usuário",
    "users.smart_upload.ignore_column": "Ignorar esta coluna",
    "Ignore this column": "Ignorar esta coluna",
    "users.smart_upload.create_attribute": "Criar um novo atributo do usuário",
    "Create a new user attribute": "Criar um novo atributo do usuário",
    "users.smart_upload.attribute_name": "Nome do atributo",
    "Attribute name": "Nome do atributo",
    "users.smart_upload.type_text": "Texto",
    "Text": "Texto",
    "users.smart_upload.type_long_text": "Texto longo",
    "Long text": "Texto longo",
    "users.smart_upload.type_number": "Número",
    "Number": "Número",
    "users.smart_upload.type_single_select": "Seleção única",
    "Single select": "Seleção única",
    "users.smart_upload.type_multi_select": "Seleção múltipla",
    "Multi select": "Seleção múltipla",
    "users.smart_upload.review_import": "Revisar importação",
    "Review import": "Revisar importação",
    "users.smart_upload.review_description": "Contatos para importar: {count}. Usuários existentes do Tradly podem ser rejeitados pela API; tentar novamente uma importação parcial pode duplicar linhas bem-sucedidas.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Contatos para importar: {count}. Usuários existentes do Tradly podem ser rejeitados pela API; tentar novamente uma importação parcial pode duplicar linhas bem-sucedidas.",
    "users.smart_upload.contact_classification": "Classificação de contato",
    "Contact classification": "Classificação de contato",
    "users.smart_upload.outbound": "Saída (não optado)",
    "Outbound (not opted in)": "Saída (não optado)",
    "users.smart_upload.signed_up": "Registrado (optado)",
    "Signed-up (opted in)": "Registrado (optado)",
    "users.smart_upload.contact_source_help": "Isso é salvo como o atributo contact_source. O tipo de usuário integrado do Tradly permanece cliente.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Isso é salvo como o atributo contact_source. O tipo de usuário integrado do Tradly permanece cliente.",
    "users.smart_upload.import_complete": "Importação de usuários concluída",
    "User import complete": "Importação de usuários concluída",
    "users.smart_upload.imported_summary": "{imported} de {total} usuários importados.",
    "{imported} of {total} users imported.": "{imported} de {total} usuários importados.",
    "users.smart_upload.selected_file": "Selecionado: {name}",
    "Selected: {name}": "Selecionado: {name}",
    "users.smart_upload.review_action": "Revisar",
    "users.smart_upload.importing_action": "Importando…",
    "Importing…": "Importando…",
    "users.smart_upload.import_users_action": "Importar usuários",
    "users.import.uploading": "Enviando…",
    "Uploading…": "Enviando…",
    "users.import.please_wait": "Por favor aguarde…",
    "users.import.error_prefix": "Erro",
    "users.import.select_file_error": "Selecione um arquivo",
    "Please select a file": "Selecione um arquivo",
    "users.import.download": "Baixar",
    "users.import.file_label": "Arquivo:",
    "File:": "Arquivo:",
    "users.import.select_file": "Selecionar arquivo",
    "Select File": "Selecionar arquivo",
    "users.import.upload": "Enviar",
    "users.create.button": "Criar usuário",
    "Create User": "Criar usuário",
    "users.create.title": "Criar novo usuário",
    "Create New User": "Criar novo usuário",
    "users.create.please_wait": "Aguarde…",
    "users.create.email": "E-mail",
    "users.create.first_name": "Nome",
    "users.create.last_name": "Sobrenome",
    "users.create.email_required": "E-mail é obrigatório",
    "Email is required": "E-mail é obrigatório",
    "users.create.first_name_required": "Nome é obrigatório",
    "First Name is required": "Nome é obrigatório",
    "users.create.last_name_required": "Sobrenome é obrigatório",
    "Last Name is required": "Sobrenome é obrigatório",
    "users.create.session_expired": "Sua sessão de administrador expirou. Faça login novamente antes de criar um usuário.",
    "Your admin session has expired. Please sign in again before creating a user.": "Sua sessão de administrador expirou. Faça login novamente antes de criar um usuário.",
    "users.create.unable_to_create": "Não é possível criar este usuário.",
    "Unable to create this user.": "Não é possível criar este usuário.",
    "users.create.success": "Usuário criado com sucesso",
    "User created successfully": "Usuário criado com sucesso",
    "users.create.failed": "Não foi possível criar o usuário. Tente novamente.",
    "User creation failed. Please try again.": "Não foi possível criar o usuário. Tente novamente.",
    "common.feature_flow.eyebrow": "VEJA COMO FUNCIONA",
    "SEE HOW IT WORKS": "VEJA COMO FUNCIONA",
    "common.feature_flow.open_guide": "Abrir guia de fluxo",
    "Open flow guide": "Abrir guia de fluxo",
    "common.feature_flow.close_guide": "Fechar guia de seção",
    "Close section guide": "Fechar guia de seção",
    "common.feature_flow.section_guide": "Guia de seção",
    "Section guide": "Guia de seção",
    "users.flow.title": "Tudo o que você precisa para gerenciar seus usuários",
    "Everything you need to manage your users": "Tudo o que você precisa para gerenciar seus usuários",
    "users.flow.description": "Crie perfis de usuário, personalize os dados e entenda o feedback do cliente em um único local.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Crie perfis de usuário, personalize os dados e entenda o feedback do cliente em um único local.",
    "users.flow.lane_title": "Gerenciamento de usuários",
    "User management": "Gerenciamento de usuários",
    "users.flow.badge": "Ferramentas principais",
    "Core tools": "Ferramentas principais",
    "users.flow.attributes": "Atributos",
    "Attributes": "Atributos",
    "users.flow.reviews": "Avaliações",
    "Reviews": "Avaliações",
    "users.flow.lane_description": "Gerencie pessoas, adicione os campos de perfil que precisar e aprenda com sua experiência.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Gerencie pessoas, adicione os campos de perfil que precisar e aprenda com sua experiência.",
    "users.flow.primary_action": "Adicione seu primeiro usuário",
    "Add your first user": "Adicione seu primeiro usuário",
    "users.tooltip.title": "Cada indivíduo é um usuário único",
    "Every individual is a unique user": "Cada indivíduo é um usuário único",
    "users.tooltip.description": "Imagine, por um momento, que você possui um shopping center.\n\nTodo usuário que entra em uma loja é considerado um usuário.\n\nTodo comerciante que gerencia uma loja é considerado um usuário.\n\nNo Tradly, todos os usuários diferentes (comerciante ou cliente) são chamados de «Usuários», e seus detalhes únicos são armazenados na seção de usuários. Você pode encontrar seus detalhes de compra ou as contas que possuem.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Imagine, por um momento, que você possui um shopping center.\n\nTodo usuário que entra em uma loja é considerado um usuário.\n\nTodo comerciante que gerencia uma loja é considerado um usuário.\n\nNo Tradly, todos os usuários diferentes (comerciante ou cliente) são chamados de «Usuários», e seus detalhes únicos são armazenados na seção de usuários. Você pode encontrar seus detalhes de compra ou as contas que possuem.",
    "workspace.loading": "Carregando configurações do workspace…",
    "Loading workspace settings…": "Carregando configurações do workspace…",
    "workspace.kicker": "ESPAÇO DE TRABALHO",
    "WORKSPACE": "ESPAÇO DE TRABALHO",
    "workspace.fallback_name": "Espaço de trabalho",
    "workspace.members.title": "Convidar membro da equipe",
    "Invite Team Member": "Convidar membro da equipe",
    "workspace.members.description": "Adicione colegas de equipe e dê a cada pessoa apenas o acesso que precisam.",
    "Add teammates and give each person only the access they need.": "Adicione colegas de equipe e dê a cada pessoa apenas o acesso que precisam.",
    "workspace.members.enter_name_email": "Insira o nome e o endereço de e-mail do membro.",
    "Enter a member name and email address.": "Insira o nome e o endereço de e-mail do membro.",
    "workspace.members.invitation_sent": "Convite enviado.",
    "Invitation sent.": "Convite enviado.",
    "workspace.members.confirm_remove": "Remover {name} deste workspace?",
    "Remove {name} from this workspace?": "Remover {name} deste workspace?",
    "workspace.members.removed": "Membro da equipe removido.",
    "Team member removed.": "Membro da equipe removido.",
    "workspace.members.roles_saved": "Funções do membro salvas.",
    "Member roles saved.": "Funções do membro salvas.",
    "workspace.members.read": "Ver",
    "workspace.members.write": "Escrever",
    "Write": "Escrever",
    "workspace.members.delete": "Excluir",
    "workspace.members.select_all_permission": "Selecione todas as {permission} em {group}",
    "Select all {permission} in {group}": "Selecione todas as {permission} em {group}",
    "workspace.members.member_name": "Nome do membro",
    "Member Name": "Nome do membro",
    "workspace.members.email_address": "Endereço de e-mail",
    "Email Address": "Endereço de e-mail",
    "workspace.members.sending": "Enviando…",
    "Sending…": "Enviando…",
    "workspace.members.send_invitation": "Enviar convite",
    "Send invitation": "Enviar convite",
    "workspace.members.team_members": "Membros da equipe",
    "Team members": "Membros da equipe",
    "workspace.members.search_members": "Buscar membros",
    "Search members": "Buscar membros",
    "workspace.members.search": "Buscar",
    "workspace.members.member": "Membro",
    "Member": "Membro",
    "workspace.members.email": "E-mail",
    "workspace.members.status": "Status",
    "workspace.members.actions": "Ações",
    "workspace.members.unnamed": "Membro sem nome",
    "Unnamed member": "Membro sem nome",
    "workspace.members.roles": "Funções",
    "Roles": "Funções",
    "workspace.members.empty": "Nenhum membro da equipe encontrado.",
    "No team members found.": "Nenhum membro da equipe encontrado.",
    "workspace.members.page_of": "Página {page} de {pages}",
    "Page {page} of {pages}": "Página {page} de {pages}",
    "workspace.members.assign_roles": "Atribuir funções",
    "Assign roles": "Atribuir funções",
    "workspace.members.save_roles": "Salvar funções",
    "Save roles": "Salvar funções",
    "workspace.members.saving": "Salvando…",
    "Saving…": "Salvando…",
    "workspace.error.generic": "Ocorreu um erro. Por favor, tente novamente.",
    "Something went wrong. Please try again.": "Ocorreu um erro. Por favor, tente novamente.",
    "workspace.billing.view_label": "Visualização de faturamento do workspace",
    "Billing workspace view": "Visualização de faturamento do workspace",
    "workspace.billing.tab_usage": "Uso",
    "Usage": "Uso",
    "workspace.billing.tab_plans": "Planos",
    "workspace.billing.tab_invoices": "Faturas pagas",
    "Paid invoices": "Faturas pagas",
    "workspace.billing.tab_account": "Conta",
    "Account": "Conta",
    "workspace.account.title": "Configuração de negócio",
    "Business Settings": "Configuração de negócio",
    "workspace.account.description": "Gerencie seu perfil de negócios, produtos habilitados e privacidade da conta.",
    "Manage your business profile, enabled products, and account privacy.": "Gerencie seu perfil de negócios, produtos habilitados e privacidade da conta.",
    "workspace.account.profile_updated": "Perfil de negócios atualizado.",
    "Business profile updated.": "Perfil de negócios atualizado.",
    "workspace.account.logo_updated": "Logotipo atualizado.",
    "Logo updated.": "Logotipo atualizado.",
    "workspace.account.logo_upload_error": "Não é possível fazer o upload do logotipo.",
    "Unable to upload logo.": "Não é possível fazer o upload do logotipo.",
    "workspace.account.confirm_delete": "Excluir esta conta Tradly permanentemente? Isso não pode ser desfeito.",
    "Delete this Tradly account permanently? This cannot be undone.": "Excluir esta conta Tradly permanentemente? Isso não pode ser desfeito.",
    "workspace.account.business_profile": "Perfil de negócios",
    "Business Profile": "Perfil de negócios",
    "workspace.account.logo": "Logotipo",
    "workspace.account.logo_alt": "Logotipo do negócio",
    "Business logo": "Logotipo do negócio",
    "workspace.account.add_photo": "Adicionar foto",
    "Add photo": "Adicionar foto",
    "workspace.account.logo_formats": "PNG, JPG, SVG ou ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG ou ICO",
    "workspace.account.business_name": "Nome da empresa",
    "workspace.account.contact_name": "Nome do contato do negócio",
    "Business Contact Name": "Nome do contato do negócio",
    "workspace.account.business_address": "Endereço da empresa",
    "Business Address": "Endereço da empresa",
    "workspace.account.products_of_interest": "Produtos de interesse",
    "Products of Interest": "Produtos de interesse",
    "workspace.account.marketplace": "Mercado",
    "workspace.account.single_store": "Comércio de loja única",
    "Single Store Commerce": "Comércio de loja única",
    "workspace.account.alacarte_products": "Produtos à la carte",
    "À la carte Products": "Produtos à la carte",
    "workspace.account.alacarte_description": "Os produtos individuais habilitados para este espaço de trabalho são gerenciados a partir de Planos & Faturamento.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Os produtos individuais habilitados para este espaço de trabalho são gerenciados a partir de Planos & Faturamento.",
    "workspace.account.manage_alacarte": "Gerenciar produtos à la carte",
    "Manage à la carte products": "Gerenciar produtos à la carte",
    "workspace.account.delete_irreversible": "Excluir conta: Irreversível",
    "Delete your Account: Irreversible": "Excluir conta: Irreversível",
    "workspace.account.delete_description": "Isso exclui permanentemente o inquilino Tradly e todos os dados associados.",
    "This permanently deletes the Tradly tenant and all associated data.": "Isso exclui permanentemente o inquilino Tradly e todos os dados associados.",
    "workspace.account.deleting": "Excluindo…",
    "Deleting…": "Excluindo…",
    "workspace.account.delete_button": "Excluir conta com Tradly",
    "Delete Account With Tradly": "Excluir conta com Tradly",
    "workspace.privacy.title": "Privacidade e processadores de dados",
    "Privacy & Data Processors": "Privacidade e processadores de dados",
    "workspace.privacy.description": "Entenda quais processadores ajudam a operar o Tradly e como a retenção funciona após um pedido de exclusão.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Entenda quais processadores ajudam a operar o Tradly e como a retenção funciona após um pedido de exclusão.",
    "workspace.privacy.processor_retention": "Utilizamos os seguintes processadores e ferramentas para operar o serviço, melhorar a qualidade do produto e apoiar faturamento e confiabilidade. Este período de retenção aplica-se apenas após um usuário solicitar a exclusão da conta. Dados de usuário do Tradly Platform são retidos por aproximadamente 90–180 dias com base em necessidades operacionais e de conformidade.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Utilizamos os seguintes processadores e ferramentas para operar o serviço, melhorar a qualidade do produto e apoiar faturamento e confiabilidade. Este período de retenção aplica-se apenas após um usuário solicitar a exclusão da conta. Dados de usuário do Tradly Platform são retidos por aproximadamente 90–180 dias com base em necessidades operacionais e de conformidade.",
    "workspace.privacy.read_more": "Ler mais.",
    "Read more.": "Ler mais.",
    "workspace.privacy.tool": "Ferramenta",
    "Tool": "Ferramenta",
    "workspace.privacy.purpose": "Propósito",
    "Purpose": "Propósito",
    "workspace.privacy.data_category": "Categoria de dados",
    "Data Category": "Categoria de dados",
    "workspace.privacy.deletion_requests": "Solicitações de exclusão de conta e dados",
    "Account deletion and data requests": "Solicitações de exclusão de conta e dados",
    "workspace.privacy.deletion_description": "Para solicitar a exclusão da conta ou remoção de uma ferramenta de relacionamento com clientes, entre em contato com o administrador do seu espaço de trabalho ou suporte. Essas ações requerem confirmação de backend antes de serem expostas aqui.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Para solicitar a exclusão da conta ou remoção de uma ferramenta de relacionamento com clientes, entre em contato com o administrador do seu espaço de trabalho ou suporte. Essas ações requerem confirmação de backend antes de serem expostas aqui.",
    "workspace.privacy.open_account": "Abrir configuração da conta",
    "Open account settings": "Abrir configuração da conta",
    "workspace.privacy.core_operations": "Operações básicas do produto",
    "Core product operations": "Operações básicas do produto",
    "workspace.privacy.user_data_retention": "Dados do usuário (retenção: 90–180 dias)",
    "User data (retention: 90–180 days)": "Dados do usuário (retenção: 90–180 dias)",
    "workspace.privacy.crm_support_lifecycle": "CRM, suporte e comunicação do ciclo de vida",
    "CRM, support, lifecycle communication": "CRM, suporte e comunicação do ciclo de vida",
    "workspace.privacy.personal_data": "Dados pessoais",
    "Personal data": "Dados pessoais",
    "workspace.privacy.product_analytics": "Análise de produto e funis de engajamento",
    "Product analytics and engagement funnels": "Análise de produto e funis de engajamento",
    "workspace.privacy.usage_events": "Análise de uso e eventos",
    "Usage and event analytics": "Análise de uso e eventos",
    "workspace.privacy.billing_payments": "Processamento de faturamento e pagamentos",
    "Billing and payment processing": "Processamento de faturamento e pagamentos",
    "workspace.privacy.billing_data": "Dados de faturamento",
    "Billing data": "Dados de faturamento",
    "workspace.privacy.traffic_analytics": "Análise de tráfego e comportamento",
    "Traffic and behavior analytics": "Análise de tráfego e comportamento",
    "workspace.privacy.usage_analytics": "Análise de uso",
    "Usage analytics": "Análise de uso",
    "workspace.privacy.session_diagnostics": "Relatórios de sessão e diagnóstico de botões quebrados",
    "Session insights and broken-button diagnostics": "Relatórios de sessão e diagnóstico de botões quebrados",
    "workspace.privacy.ux_telemetry": "Telemetria UX/sessão",
    "UX/session telemetry": "Telemetria UX/sessão",
    "workspace.privacy.error_monitoring": "Monitoramento de erros de código e estabilidade",
    "Code error and stability monitoring": "Monitoramento de erros de código e estabilidade",
    "workspace.privacy.error_logs": "Registros de erros e diagnósticos",
    "Error logs and diagnostics": "Registros de erros e diagnósticos",
    "workspace.privacy.email_delivery": "Entrega de e-mails transacionais",
    "Transactional email delivery": "Entrega de e-mails transacionais",
    "workspace.privacy.email_metadata": "Metadados de e-mail",
    "Email metadata": "Metadados de e-mail",
    "workspace.privacy.hosting_infrastructure": "Hospedagem e infraestrutura",
    "Hosting and infrastructure": "Hospedagem e infraestrutura",
    "workspace.privacy.infrastructure_logs": "Registros de infraestrutura e serviço",
    "Infrastructure and service logs": "Registros de infraestrutura e serviço",
    "workspace.domain.title": "Domínios",
    "Domains": "Domínios",
    "workspace.domain.description": "Conecte seu próprio domínio para substituir a URL padrão hospedada pelo Tradly.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Conecte seu próprio domínio para substituir a URL padrão hospedada pelo Tradly.",
    "workspace.domain.invalid": "Insira um domínio válido, como example.com.",
    "Enter a valid domain, such as example.com.": "Insira um domínio válido, como example.com.",
    "workspace.domain.reserved": "tradly.co está reservado para domínios de espaço de trabalho hospedados.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co está reservado para domínios de espaço de trabalho hospedados.",
    "workspace.domain.missing_primary": "Nenhum domínio primário está disponível para o espaço de trabalho.",
    "No primary workspace domain is available.": "Nenhum domínio primário está disponível para o espaço de trabalho.",
    "workspace.domain.saved": "Domínio personalizado salvo. Atualize seus registros DNS e depois atualize o status.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Domínio personalizado salvo. Atualize seus registros DNS e depois atualize o status.",
    "workspace.domain.reset_success": "Domínio redefinido para a URL hospedada pelo Tradly.",
    "Domain reset to the Tradly-hosted URL.": "Domínio redefinido para a URL hospedada pelo Tradly.",
    "workspace.domain.current": "DOMÍNIO ATUAL",
    "CURRENT DOMAIN": "DOMÍNIO ATUAL",
    "workspace.domain.hosted": "Domínio hospedado pelo Tradly",
    "Tradly-hosted domain": "Domínio hospedado pelo Tradly",
    "workspace.domain.dns_status": "Status DNS: {status}",
    "DNS status: {status}": "Status DNS: {status}",
    "workspace.domain.checking": "Verificando status DNS…",
    "Checking DNS status…": "Verificando status DNS…",
    "workspace.domain.refresh": "Atualizar status",
    "Refresh status": "Atualizar status",
    "workspace.domain.reset": "Redefinir domínio",
    "Reset domain": "Redefinir domínio",
    "workspace.domain.connect_title": "Conectar um domínio personalizado",
    "Connect a custom domain": "Conectar um domínio personalizado",
    "workspace.domain.connect_description": "Insira um domínio que você já possua. Mostraremos os registros DNS necessários para conectá-lo.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Insira um domínio que você já possua. Mostraremos os registros DNS necessários para conectá-lo.",
    "workspace.domain.saving": "Salvando…",
    "workspace.domain.add": "Adicionar domínio",
    "Add domain": "Adicionar domínio",
    "workspace.domain.dns_title": "Configuração DNS",
    "DNS setup": "Configuração DNS",
    "workspace.domain.a_record": "Registro A",
    "A record": "Registro A",
    "workspace.domain.root_description": "Use isso para um domínio raiz, como",
    "Use this for a root domain such as": "Use isso para um domínio raiz, como",
    "workspace.domain.cname_record": "Registro CNAME",
    "CNAME record": "Registro CNAME",
    "workspace.domain.subdomain_description": "Use isso para um subdomínio como",
    "Use this for a subdomain such as": "Use isso para um subdomínio como",
    "workspace.domain.host": "Host",
    "Host": "Host",
    "workspace.domain.value": "Valor",
    "Value": "Valor",
    "workspace.domain.need_domain": "Precisa de um domínio?",
    "Need a domain?": "Precisa de um domínio?",
    "workspace.domain.buy_domain": "Compre um domínio no Google Domains ou GoDaddy, depois retorne aqui para conectá-lo.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Compre um domínio no Google Domains ou GoDaddy, depois retorne aqui para conectá-lo.",
    "workspace.billing.title": "Faturamento e uso",
    "Billing & Usage": "Faturamento e uso",
    "workspace.billing.description": "Gerencie planos de workspace, uso e faturamento.",
    "Manage workspace plans, usage, and billing.": "Gerencie planos de workspace, uso e faturamento.",
    "workspace.billing.invoice_description": "Gerencie planos de workspace, uso e faturas pagas.",
    "Manage workspace plans, usage, and paid invoices.": "Gerencie planos de workspace, uso e faturas pagas.",
    "workspace.billing.usage_description": "Veja o uso atual e os limites aplicados a este workspace.",
    "workspace.invoices.loading": "Carregando faturas…",
    "Loading invoices…": "Carregando faturas…",
    "workspace.invoices.description": "Baixe faturas ou conclua o pagamento de um saldo pendente.",
    "Download invoices or complete payment for an outstanding balance.": "Baixe faturas ou conclua o pagamento de um saldo pendente.",
    "workspace.invoices.payment_failed": "Pagamento falhou — o acesso ao serviço pode ser afetado.",
    "Payment failed — service access may be affected.": "Pagamento falhou — o acesso ao serviço pode ser afetado.",
    "workspace.invoices.awaiting_payment": "A fatura {invoice} está aguardando pagamento.",
    "Invoice {invoice} is awaiting payment.": "A fatura {invoice} está aguardando pagamento.",
    "workspace.invoices.outstanding": "pendente",
    "outstanding": "pendente",
    "workspace.invoices.pay_invoice": "Pagar fatura",
    "Pay invoice": "Pagar fatura",
    "workspace.invoices.invoice": "Fatura",
    "workspace.invoices.date": "Data",
    "workspace.invoices.amount": "Valor",
    "workspace.invoices.paid": "Pago",
    "workspace.invoices.unpaid": "Não pago",
    "Unpaid": "Não pago",
    "workspace.invoices.download_invoice": "Baixar fatura",
    "Download invoice": "Baixar fatura",
    "workspace.invoices.empty_title": "Nenhuma fatura disponível",
    "No invoices available": "Nenhuma fatura disponível",
    "workspace.invoices.empty_description": "As faturas são criadas após você se inscrever e fazer um pagamento. Contate o suporte se tiver dúvidas.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "As faturas são criadas após você se inscrever e fazer um pagamento. Contate o suporte se tiver dúvidas.",
    "workspace.plans.heading": "Planos",
    "workspace.plans.tab_marketplace": "Mercado",
    "workspace.plans.tab_marketplace_description": "Multi-vendedor",
    "Multi-vendor": "Multi-vendedor",
    "workspace.plans.tab_single": "Loja única",
    "Single Store": "Loja única",
    "workspace.plans.tab_single_description": "Indie & Criadores",
    "Indie & Creators": "Indie & Criadores",
    "workspace.plans.tab_alacarte": "À la carte",
    "A la carte": "À la carte",
    "workspace.plans.tab_alacarte_description": "Créditos e complementos",
    "Credits & add-ons": "Créditos e complementos",
    "workspace.plans.tab_services": "Serviços",
    "Services": "Serviços",
    "workspace.plans.tab_services_description": "Serviços adicionais",
    "Additional services": "Serviços adicionais",
    "workspace.plans.selected": "Selecionado",
    "Selected": "Selecionado",
    "workspace.plans.try_again": "Tentar novamente",
    "Try again": "Tentar novamente",
    "workspace.plans.bill_yearly": "Faturar anualmente",
    "Bill Yearly": "Faturar anualmente",
    "workspace.plans.bill_monthly": "Faturar mensalmente",
    "Bill Monthly": "Faturar mensalmente",
    "workspace.plans.compare": "Comparar planos",
    "Compare Plans": "Comparar planos",
    "workspace.plans.community": "Comunidade",
    "workspace.plans.community_description": "Grátis para sempre. Perfeito para hobbies e projetos comunitários.",
    "Free forever. Perfect for hobbyists and community projects.": "Grátis para sempre. Perfeito para hobbies e projetos comunitários.",
    "workspace.plans.different_configurations": "Procurando por diferentes configurações?",
    "Looking for different configurations?": "Procurando por diferentes configurações?",
    "workspace.plans.contact_us": "Contate-nos",
    "Contact Us": "Contate-nos",
    "workspace.plans.see_alacarte_pricing": "Ver preços à la carte",
    "See à la carte pricing": "Ver preços à la carte",
    "workspace.plans.available": "Disponível",
    "Available": "Disponível",
    "workspace.plans.used_90d": "Usado (90d)",
    "Used (90d)": "Usado (90d)",
    "workspace.plans.expired_90d": "Vencido (90d)",
    "Expired (90d)": "Vencido (90d)",
    "workspace.plans.expires_on": "Vence {date}",
    "Expires {date}": "Vence {date}",
    "workspace.plans.top_up_credits": "Recarregar créditos",
    "Top Up Credits": "Recarregar créditos",
    "workspace.plans.credits_description": "Créditos permitem o uso de Email, Pesquisa de IA, Recomendações e ações de Agente. 100 créditos = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Créditos permitem o uso de Email, Pesquisa de IA, Recomendações e ações de Agente. 100 créditos = $5.",
    "workspace.plans.credits": "créditos",
    "credits": "créditos",
    "workspace.plans.custom_amount": "Valor personalizado",
    "Custom amount": "Valor personalizado",
    "workspace.plans.amount_example": "ex. 2500",
    "e.g. 2500": "ex. 2500",
    "workspace.plans.opening_checkout": "Abrindo checkout…",
    "Opening checkout…": "Abrindo checkout…",
    "workspace.plans.buy_credits": "Comprar {count} créditos",
    "Buy {count} credits": "Comprar {count} créditos",
    "workspace.plans.select_amount": "Selecione uma quantidade",
    "Select an amount": "Selecione uma quantidade",
    "workspace.plans.alacarte_products": "Produtos à la carte",
    "A la carte Products": "Produtos à la carte",
    "workspace.plans.products_description": "Selecione os produtos que você usa. Isso nos ajuda a personalizar sua experiência. O uso é pago com créditos.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Selecione os produtos que você usa. Isso nos ajuda a personalizar sua experiência. O uso é pago com créditos.",
    "workspace.plans.enabled": "Habilitado",
    "workspace.plans.enable": "Habilitar",
    "Enable": "Habilitar",
    "workspace.plans.open_here": "Abrir aqui",
    "Open here": "Abrir aqui",
    "workspace.plans.open_marketing": "Abrir marketing.tradly.app",
    "Open marketing.tradly.app": "Abrir marketing.tradly.app",
    "workspace.plans.open_analytics": "Abrir analytics.tradly.app",
    "Open analytics.tradly.app": "Abrir analytics.tradly.app",
    "workspace.plans.open_external": "Abrir externo",
    "Open external": "Abrir externo",
    "workspace.plans.coming_soon": "Em breve",
    "Coming soon": "Em breve",
    "workspace.plans.services_title": "Serviços de configuração única e personalizados",
    "One-Time Setup & Custom Services": "Serviços de configuração única e personalizados",
    "workspace.plans.service_app_launch": "Lançamento de aplicativo de marca branca",
    "White-Label App Launch": "Lançamento de aplicativo de marca branca",
    "workspace.plans.service_frontend": "Personalização do frontend",
    "Frontend Customization": "Personalização do frontend",
    "workspace.plans.service_multilanguage": "Suporte multilíngue",
    "Multi-Language Support": "Suporte multilíngue",
    "workspace.plans.view_docs": "Ver documentos",
    "View Docs": "Ver documentos",
    "workspace.plans.confirm_change": "Confirme sua mudança de plano",
    "Confirm your plan change": "Confirme sua mudança de plano",
    "workspace.plans.confirm_charge": "As cobranças são pré-pagas e faturadas na data da sua assinatura.",
    "Charges are prepaid and billed on your subscription date.": "As cobranças são pré-pagas e faturadas na data da sua assinatura.",
    "workspace.plans.confirm_promo": "Códigos promocionais podem ser inseridos durante o checkout do Stripe, quando disponíveis.",
    "Promotional codes can be entered during Stripe checkout where available.": "Códigos promocionais podem ser inseridos durante o checkout do Stripe, quando disponíveis.",
    "workspace.plans.confirm_delay": "Mudanças de plano podem levar um momento para aparecer em seu workspace.",
    "Plan changes may take a moment to appear in your workspace.": "Mudanças de plano podem levar um momento para aparecer em seu workspace.",
    "workspace.plans.payment_active": "Pagamento recebido. Seu plano está ativo.",
    "Payment received. Your plan is active.": "Pagamento recebido. Seu plano está ativo.",
    "workspace.plans.payment_method_updated": "Método de pagamento atualizado.",
    "Payment method updated.": "Método de pagamento atualizado.",
    "workspace.plans.payment_cancelled": "O pagamento não foi concluído, então seu plano não foi alterado.",
    "Payment was not completed, so your plan has not changed.": "O pagamento não foi concluído, então seu plano não foi alterado.",
    "workspace.plans.activating": "Pagamento recebido. Ativando seu plano…",
    "Payment received. Activating your plan…": "Pagamento recebido. Ativando seu plano…",
    "workspace.plans.activation_delayed": "Pagamento recebido. Seu plano está levando um pouco mais de tempo para ativar. Por favor, atualize em um minuto.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Pagamento recebido. Seu plano está levando um pouco mais de tempo para ativar. Por favor, atualize em um minuto.",
    "workspace.plans.card_saved": "Cartão salvo e assinatura atualizada.",
    "Card saved and subscription updated.": "Cartão salvo e assinatura atualizada.",
    "workspace.plans.subscription_updated": "Assinatura atualizada.",
    "Subscription updated.": "Assinatura atualizada.",
    "workspace.plans.products_saved": "Produtos à la carte salvos.",
    "À la carte products saved.": "Produtos à la carte salvos.",
    "workspace.plans.minimum_credits": "Insira pelo menos 100 créditos.",
    "Enter at least 100 credits.": "Insira pelo menos 100 créditos.",
    "workspace.plans.credit_topup_description": "Recarga de créditos ({count} créditos)",
    "Credit Top-Up ({count} credits)": "Recarga de créditos ({count} créditos)",
    "workspace.plans.billing_details": "Detalhes de faturamento atuais",
    "Current billing details": "Detalhes de faturamento atuais",
    "workspace.plans.current_plan": "Plano atual",
    "Current Plan": "Plano atual",
    "workspace.plans.renews": "Renova",
    "Renews": "Renova",
    "workspace.plans.payment_method": "Método de pagamento",
    "Payment method": "Método de pagamento",
    "workspace.plans.opening": "Abrindo…",
    "Opening…": "Abrindo…",
    "workspace.plans.manage_payment_method": "Gerenciar método de pagamento",
    "Manage payment method": "Gerenciar método de pagamento",
    "workspace.plans.upgrade": "Atualizar",
    "Upgrade": "Atualizar",
    "workspace.plans.downgrade": "Reduzir",
    "Downgrade": "Reduzir",
    "workspace.plans.custom_price": "Personalizado",
    "Custom": "Personalizado",
    "workspace.plans.per_month_short": "/mês",
    "/month": "/mês",
    "workspace.plans.per_year_amount": "por ano ({amount})",
    "per year ({amount})": "por ano ({amount})",
    "workspace.plans.per_month_amount": "por mês ({amount})",
    "per month ({amount})": "por mês ({amount})",
    "workspace.plans.yearly_savings": "Economize {amount} por ano",
    "Save {amount} yearly": "Economize {amount} por ano",
    "workspace.plans.billed_yearly": "Faturado anualmente",
    "billed yearly": "Faturado anualmente",
    "workspace.plans.billed_monthly": "faturado mensalmente",
    "billed monthly": "faturado mensalmente",
    "workspace.plans.free_trial": "Você está em uma avaliação gratuita.",
    "You are on a free trial.": "Você está em uma avaliação gratuita.",
    "workspace.plans.updating": "Atualizando…",
    "Updating…": "Atualizando…",
    "workspace.plans.temporarily_unavailable": "Temporariamente indisponível",
    "Temporarily unavailable": "Temporariamente indisponível",
    "workspace.plans.whats_included": "O que está incluído",
    "What's included": "O que está incluído",
    "workspace.plans.products.auth.title": "Autenticação",
    "Auth": "Autenticação",
    "workspace.plans.products.auth.description": "Identidade, SSO, permissões e gerenciamento de usuários.",
    "Identity, SSO, permissions, and user management.": "Identidade, SSO, permissões e gerenciamento de usuários.",
    "workspace.plans.products.email.title": "E-mail",
    "workspace.plans.products.email.description": "E-mail transacional e de marketing, integrado.",
    "Transactional and marketing email, built in.": "E-mail transacional e de marketing, integrado.",
    "workspace.plans.products.analytics.title": "Análise",
    "workspace.plans.products.analytics.description": "Análise gratuita para web, aplicativo e agentes.",
    "Free analytics for web, app, and agents.": "Análise gratuita para web, aplicativo e agentes.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "Um CRM que se preenche automaticamente a partir da atividade do usuário.",
    "A CRM that fills itself from user activity.": "Um CRM que se preenche automaticamente a partir da atividade do usuário.",
    "workspace.plans.products.subscription.title": "Assinaturas",
    "Subscriptions": "Assinaturas",
    "workspace.plans.products.subscription.description": "Faturamento recorrente, testes e gestão de inadimplência — gerenciado.",
    "Recurring billing, trials, and dunning — handled.": "Faturamento recorrente, testes e gestão de inadimplência — gerenciado.",
    "workspace.plans.products.recommendation.title": "Recomendações",
    "Recommendations": "Recomendações",
    "workspace.plans.products.recommendation.description": "Mostra para cada usuário o que eles realmente querem.",
    "Show each user what they will actually want.": "Mostra para cada usuário o que eles realmente querem.",
    "workspace.plans.marketplace.2025-superstarter.title": "Básico",
    "Basic": "Básico",
    "workspace.plans.marketplace.2025-superstarter.description": "Ideal para equipe pequena. Todos os recursos da comunidade mais white-labeling (remove o selo \"Construído com Tradly\").",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Ideal para equipe pequena. Todos os recursos da comunidade mais white-labeling (remove o selo \"Construído com Tradly\").",
    "workspace.plans.marketplace.2025-superstarter.button": "Iniciar avaliação de 7 dias",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Sem taxa de transação",
    "No transaction fee": "Sem taxa de transação",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Site web hospedado gratuitamente pela Tradly",
    "Free Tradly hosted website": "Site web hospedado gratuitamente pela Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Adicione seu domínio personalizado",
    "Add your custom domain": "Adicione seu domínio personalizado",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Editor - Histórico de páginas de 3 dias",
    "Editor - 3 Day page history": "Editor - Histórico de páginas de 3 dias",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Para startups validando sua ideia de negócio. Inclui todos os essenciais para testar o mercado e adquirir clientes iniciais.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Para startups validando sua ideia de negócio. Inclui todos os essenciais para testar o mercado e adquirir clientes iniciais.",
    "workspace.plans.marketplace.2025-starter.button": "Inicie teste de 7 dias",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Sem taxa de transação",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Atributos personalizados ilimitados",
    "Unlimited Custom Attributes": "Atributos personalizados ilimitados",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "Histórico de página de 30 dias",
    "30 Day page history": "Histórico de página de 30 dias",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Assinatura restrita",
    "Gated Subscription": "Assinatura restrita",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Login social",
    "Social Logins": "Login social",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhooks",
    "Webhooks": "Webhooks",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Para ideias comprovadas em sua fase de crescimento. Possuem necessidades personalizadas e integrações adicionais para crescer.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Para ideias comprovadas em sua fase de crescimento. Possuem necessidades personalizadas e integrações adicionais para crescer.",
    "workspace.plans.marketplace.2025-growth.button": "Inicie teste de 7 dias",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Sem taxa de transação",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "E-mail 'De' personalizado",
    "Custom 'From Email'": "E-mail 'De' personalizado",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Ferramentas e integrações adicionais",
    "Additional Mini Tools & Integrations": "Ferramentas e integrações adicionais",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Chamadas de onboarding personalizadas*",
    "Personalised Onboarding calls*": "Chamadas de onboarding personalizadas*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "Histórico de página de 90 dias",
    "90 Day page history": "Histórico de página de 90 dias",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Múltiplos idiomas e moedas",
    "Multi Currencies & Multi Languages": "Múltiplos idiomas e moedas",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Controle de acesso baseado em funções (RBAC)",
    "Role-based access control (RBAC)": "Controle de acesso baseado em funções (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Chat integrado para aplicativos",
    "Inbuilt Chat for Apps": "Chat integrado para aplicativos",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Empresas em fase de crescimento que buscam soluções personalizadas e outros requisitos específicos.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Empresas em fase de crescimento que buscam soluções personalizadas e outros requisitos específicos.",
    "workspace.plans.marketplace.2025-scale.button": "Inicie teste de 7 dias",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Sem taxa de transação",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Suporte prioritário",
    "Priority Support": "Suporte prioritário",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Múltiplos canais (suporte para aplicativos)",
    "Multiple Channels (App Support)": "Múltiplos canais (suporte para aplicativos)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Login único (SSO)",
    "Single Sign-on (SSO)": "Login único (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Histórico de páginas ilimitado",
    "Unlimited page history": "Histórico de páginas ilimitado",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Chat integrado para aplicativos",
    "In-built Chat for Apps": "Chat integrado para aplicativos",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Tudo o que uma loja em crescimento precisa — remova a marca, adicione seu domínio e desbloqueie mais ferramentas.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Tudo o que uma loja em crescimento precisa — remova a marca, adicione seu domínio e desbloqueie mais ferramentas.",
    "workspace.plans.indie.go.button": "Inicie teste de 7 dias",
    "Start 7-day trial": "Inicie teste de 7 dias",
    "workspace.plans.indie.go.feature_1.title": "Sem marca Tradly",
    "No Tradly branding": "Sem marca Tradly",
    "workspace.plans.indie.go.feature_2.title": "Domínio personalizado",
    "Custom domain": "Domínio personalizado",
    "workspace.plans.indie.go.feature_3.title": "Produtos ilimitados",
    "Unlimited products": "Produtos ilimitados",
    "workspace.plans.indie.go.feature_4.title": "Campanhas por e-mail",
    "Email campaigns": "Campanhas por e-mail",
    "workspace.plans.indie.go.feature_5.title": "Recomendações de IA",
    "AI Recommendations": "Recomendações de IA",
    "workspace.plans.indie.go.feature_6.title": "Suporte baseado em tickets",
    "Ticket-based support": "Suporte baseado em tickets",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Pilha completa de IA, marketing avançado e tudo desbloqueado para lojas sérias sobre crescimento.",
    "workspace.plans.indie.genius.button": "Inicie teste de 7 dias",
    "workspace.plans.indie.genius.feature_1.title": "Tudo incluído no Pro",
    "Everything in Pro": "Tudo incluído no Pro",
    "workspace.plans.indie.genius.feature_2.title": "Agentes de IA (Assistente de compras, etc.)",
    "AI Agents (Shopping Assistant, etc.)": "Agentes de IA (Assistente de compras, etc.)",
    "workspace.plans.indie.genius.feature_3.title": "Pesquisa de linguagem natural",
    "Natural language search": "Pesquisa de linguagem natural",
    "workspace.plans.indie.genius.feature_4.title": "Automação avançada de e-mail",
    "Advanced email automation": "Automação avançada de e-mail",
    "workspace.plans.indie.genius.feature_5.title": "Solicitações ilimitadas de recomendações",
    "Unlimited recommendation requests": "Solicitações ilimitadas de recomendações",
    "workspace.plans.indie.genius.feature_6.title": "Suporte baseado em tickets",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Cobranças de assinatura para que as pessoas abram contas e enviem listagens",
    "Subscription charges for people to open accounts & submit listings": "Cobranças de assinatura para que as pessoas abram contas e enviem listagens",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Cadastro/entrada com Google, Meta",
    "Signup/in via Google, Meta": "Cadastro/entrada com Google, Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Para conectar com Zapier & Make",
    "To connect with Zapier & Make": "Para conectar com Zapier & Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Mensagens nativas no aplicativo para seus usuários",
    "Native in-app messaging for your users": "Mensagens nativas no aplicativo para seus usuários",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Tempo de resposta de 24 horas para não críticos",
    "24 hour response time for non-critical": "Tempo de resposta de 24 horas para não críticos",
    "common.continue": "Continuar",
    "Continue": "Continuar",
    "workspace.plans.free_plan": "Grátis",
    "Free": "Grátis",
    "workspace.usage.group_platform": "Plataforma e workspace",
    "Platform & workspace": "Plataforma e workspace",
    "workspace.usage.group_ai": "IA e uso",
    "AI & usage": "IA e uso",
    "workspace.usage.group_storage": "Conteúdo e armazenamento",
    "Content & storage": "Conteúdo e armazenamento",
    "workspace.usage.group_alacarte": "À la carte",
    "workspace.usage.accounts": "Contas",
    "workspace.usage.listings": "Listagens",
    "workspace.usage.sites": "Sites sob o workspace",
    "Sites under workspace": "Sites sob o workspace",
    "workspace.usage.external_users": "Usuários externos",
    "External users": "Usuários externos",
    "workspace.usage.internal_users": "Usuários internos",
    "Internal users": "Usuários internos",
    "workspace.usage.ai_credits": "Créditos de IA",
    "AI credits": "Créditos de IA",
    "workspace.usage.storage": "Armazenamento",
    "Storage": "Armazenamento",
    "workspace.usage.email": "E-mail",
    "workspace.usage.maps": "Mapas",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Análise",
    "workspace.usage.recommendations": "Recomendações",
    "workspace.usage.ai_agents": "Agentes de IA",
    "AI agents": "Agentes de IA",
    "workspace.usage.status_not_reported": "Não relatado",
    "Not reported": "Não relatado",
    "workspace.usage.status_nearly_full": "Quase cheio",
    "Nearly full": "Quase cheio",
    "workspace.usage.status_on_track": "Em andamento",
    "On track": "Em andamento",
    "workspace.usage.workspace_files": "Arquivos do espaço de trabalho",
    "Workspace files": "Arquivos do espaço de trabalho",
    "workspace.usage.workspace_usage": "Uso do espaço de trabalho",
    "Workspace usage": "Uso do espaço de trabalho",
    "workspace.usage.of_limit": "de {limit}",
    "of {limit}": "de {limit}",
    "workspace.usage.no_cap": "Nenhum limite configurado",
    "No cap configured": "Nenhum limite configurado",
    "workspace.usage.trend": "Tendência de uso",
    "Usage trend": "Tendência de uso",
    "workspace.usage.unavailable": "Os dados de uso estão temporariamente indisponíveis.",
    "Usage data is temporarily unavailable.": "Os dados de uso estão temporariamente indisponíveis.",
    "workspace.usage.loading": "Carregando uso do espaço de trabalho…",
    "Loading workspace usage…": "Carregando uso do espaço de trabalho…",
    "workspace.usage.overview": "Visão geral do espaço de trabalho",
    "Workspace overview": "Visão geral do espaço de trabalho",
    "workspace.usage.title": "Divisão de uso",
    "Usage breakdown": "Divisão de uso",
    "workspace.usage.description": "Veja o que seu espaço de trabalho utilizou e quanto espaço resta em seu plano atual.",
    "See what your workspace has used and how much room remains on your current plan.": "Veja o que seu espaço de trabalho utilizou e quanto espaço resta em seu plano atual.",
    "workspace.usage.view_plans": "Ver planos",
    "workspace.usage.showing_available_limits": "Mostrando os limites já disponíveis neste espaço de trabalho.",
    "Showing the limits that are already available in this workspace.": "Mostrando os limites já disponíveis neste espaço de trabalho.",
    "workspace.usage.summary": "Resumo do uso",
    "Usage summary": "Resumo do uso",
    "workspace.usage.metrics_tracked": "Métricas rastreadas",
    "Metrics tracked": "Métricas rastreadas",
    "workspace.usage.metrics_count": "{count} de {total}",
    "{count} of {total}": "{count} de {total}",
    "workspace.usage.next_reset": "Próximo reinício",
    "Next reset": "Próximo reinício",
    "workspace.usage.not_provided": "Não fornecido",
    "Not provided": "Não fornecido",
    "workspace.usage.data_source": "Fonte de dados",
    "Data source": "Fonte de dados",
    "workspace.usage.clear_view": "Uma visão clara do seu espaço de trabalho",
    "A clear view of your workspace": "Uma visão clara do seu espaço de trabalho",
    "workspace.usage.by_resource": "Uso por recurso",
    "Usage by resource": "Uso por recurso",
    "workspace.usage.live_summary": "Resumo ao vivo",
    "Live summary": "Resumo ao vivo",
    "workspace.usage.resource": "Recurso",
    "Resource": "Recurso",
    "workspace.usage.used_limit": "Usado / limite",
    "Used / limit": "Usado / limite",
    "workspace.usage.progress": "Progresso",
    "Progress": "Progresso",
    "workspace.usage.cost": "Custo",
    "Cost": "Custo",
    "workspace.usage.footnote": "O uso e os limites vêm do serviço de uso do workspace. Um traço significa que essa métrica ainda não é relatada pela API atual.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "O uso e os limites vêm do serviço de uso do workspace. Um traço significa que essa métrica ainda não é relatada pela API atual.",
    "workspace.usage.refresh": "Atualizar",
    "Refresh": "Atualizar",
    "maps.title": "Mapas",
    "maps.tab.analysis": "Varredura de mercado",
    "Market scan": "Varredura de mercado",
    "maps.tab.usage": "Uso",
    "maps.tab.settings": "Configuração",
    "maps.action.save": "Salvar",
    "maps.action.saving": "Salvando…",
    "maps.action.analyze_area": "Analisar área",
    "Analyze area": "Analisar área",
    "maps.action.analyzing": "Analizando…",
    "Analyzing…": "Analizando…",
    "maps.action.refresh": "Atualizar",
    "maps.action.loading": "Carregando…",
    "Loading…": "Carregando…",
    "maps.action.open_in_maps": "Abrir no Mapas",
    "Open in Maps": "Abrir no Mapas",
    "maps.analysis.title": "Explorar um mercado local",
    "Explore a local market": "Explorar um mercado local",
    "maps.analysis.description": "Veja negócios que o Google lista ao redor de um local proposto. Isso é uma varredura inicial de competição, não uma previsão de demanda ou viabilidade.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Veja negócios que o Google lista ao redor de um local proposto. Isso é uma varredura inicial de competição, não uma previsão de demanda ou viabilidade.",
    "maps.analysis.address_label": "Endereço ou localidade",
    "Address or locality": "Endereço ou localidade",
    "maps.analysis.address_placeholder": "Rua, bairro ou cidade",
    "Street, suburb, or city": "Rua, bairro ou cidade",
    "maps.analysis.category_label": "Tipo de negócio",
    "Business type": "Tipo de negócio",
    "maps.analysis.radius_label": "Raio de busca",
    "Search radius": "Raio de busca",
    "maps.analysis.places_listings": "Listagens de lugares",
    "Places listings": "Listagens de lugares",
    "maps.analysis.within_radius": "{category} dentro de {radius}",
    "{category} within {radius}": "{category} dentro de {radius}",
    "maps.analysis.results_description": "Os resultados são filtrados por categoria e raio, depois ordenados pela distância.",
    "Results are filtered by category and radius, then ordered by distance.": "Os resultados são filtrados por categoria e raio, depois ordenados pela distância.",
    "maps.analysis.result_limit_notice": "O Google retornou o máximo de 20 locais. O número real pode ser maior; tente um raio menor para uma varredura mais detalhada.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "O Google retornou o máximo de 20 locais. O número real pode ser maior; tente um raio menor para uma varredura mais detalhada.",
    "maps.analysis.limitations": "Os listados podem ser incompletos e não medem a demanda do cliente, fluxo de pessoas, população, aluguel ou lucratividade. Use-os como uma entrada para sua pesquisa local.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Os listados podem ser incompletos e não medem a demanda do cliente, fluxo de pessoas, população, aluguel ou lucratividade. Use-os como uma entrada para sua pesquisa local.",
    "maps.analysis.nearby_businesses": "Negócios próximos ({count})",
    "Nearby businesses ({count})": "Negócios próximos ({count})",
    "maps.analysis.businesses": "Negócios",
    "Businesses": "Negócios",
    "maps.analysis.no_listings": "Nenhum resultado correspondente do Google Maps foi retornado para esta área e categoria.",
    "No matching Google Maps listings were returned for this area and category.": "Nenhum resultado correspondente do Google Maps foi retornado para esta área e categoria.",
    "maps.category.retail": "Varejo",
    "Retail": "Varejo",
    "maps.category.grocery": "Mercearia",
    "Grocery": "Mercearia",
    "maps.category.clothing": "Vestuário",
    "Clothing": "Vestuário",
    "maps.category.pharmacy": "Farmácia",
    "Pharmacy": "Farmácia",
    "maps.category.restaurant": "Restaurante / café",
    "Restaurant / café": "Restaurante / café",
    "maps.competition.limited": "Concorrência limitada",
    "Limited listed competition": "Concorrência limitada",
    "maps.competition.some": "Alguma concorrência listada",
    "Some listed competition": "Alguma concorrência listada",
    "maps.competition.many": "Muita concorrência listada",
    "Many listed competitors": "Muita concorrência listada",
    "maps.competition.limit_reached": "Pelo menos 20 listagens (limite atingido)",
    "At least 20 listings (result limit reached)": "Pelo menos 20 listagens (limite atingido)",
    "maps.competition.default": "Concorrência listada",
    "Listed competition": "Concorrência listada",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Operacional",
    "Operational": "Operacional",
    "maps.usage.title": "Uso do provedor",
    "Provider usage": "Uso do provedor",
    "maps.usage.description": "Contagens de solicitações registradas pelo serviço Maps. As cobranças são reconciliadas separadamente.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Contagens de solicitações registradas pelo serviço Maps. As cobranças são reconciliadas separadamente.",
    "maps.usage.days": "{count} dias",
    "{count} days": "{count} dias",
    "maps.usage.provider_requests": "Solicitações do provedor",
    "Provider requests": "Solicitações do provedor",
    "maps.usage.range_detail": "Janela de {count} dia",
    "{count} day window": "Janela de {count} dia",
    "maps.usage.successful": "Sucesso",
    "Successful": "Sucesso",
    "maps.usage.completed_calls": "Chamadas completadas ao provedor",
    "Completed provider calls": "Chamadas completadas ao provedor",
    "maps.usage.errors": "Erros",
    "Errors": "Erros",
    "maps.usage.failed_calls": "Chamadas falhadas ao provedor",
    "Failed provider calls": "Chamadas falhadas ao provedor",
    "maps.usage.metered_units": "Unidades medidas",
    "Metered units": "Unidades medidas",
    "maps.usage.unit_detail": "Uma unidade por solicitação registrada",
    "One unit per recorded request": "Uma unidade por solicitação registrada",
    "maps.usage.by_operation": "Uso por operação",
    "Usage by operation": "Uso por operação",
    "maps.usage.group_description": "As contagens são agrupadas por provedor, operação e resultado.",
    "Counts are grouped by provider, operation, and outcome.": "As contagens são agrupadas por provedor, operação e resultado.",
    "maps.usage.empty": "Nenhuma solicitação de mapa nesse intervalo de datas.",
    "No map requests in this date range.": "Nenhuma solicitação de mapa nesse intervalo de datas.",
    "maps.usage.provider": "Provedor",
    "Provider": "Provedor",
    "maps.usage.operation": "Operação",
    "Operation": "Operação",
    "maps.usage.outcome": "Resultado",
    "Outcome": "Resultado",
    "maps.usage.requests": "Solicitações",
    "Requests": "Solicitações",
    "maps.usage.units": "Unidades",
    "Units": "Unidades",
    "maps.settings.provider_title": "Provedor de mapas",
    "Map provider": "Provedor de mapas",
    "maps.settings.provider_description": "Escolha o provedor permitido pela sua política de privacidade de dados. As credenciais do provedor são gerenciadas pela Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Escolha o provedor permitido pela sua política de privacidade de dados. As credenciais do provedor são gerenciadas pela Tradly.",
    "maps.settings.selected": "Selecionado",
    "maps.settings.available": "Disponível",
    "maps.settings.planned": "Planejado",
    "Planned": "Planejado",
    "maps.settings.origins_title": "Origens de site permitidas",
    "Allowed website origins": "Origens de site permitidas",
    "maps.settings.origins_description": "Os domínios registrados do tenant são permitidos automaticamente. Adicione origens exatas aqui para outros sites, como staging.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Os domínios registrados do tenant são permitidos automaticamente. Adicione origens exatas aqui para outros sites, como staging.",
    "maps.settings.registered_domains": "Domínios registrados",
    "Registered domains": "Domínios registrados",
    "maps.settings.no_domains": "Nenhum domínio registrado foi carregado.",
    "No registered domains were loaded.": "Nenhum domínio registrado foi carregado.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Adicionar origem",
    "Add origin": "Adicionar origem",
    "maps.settings.remove_origin": "Remover",
    "maps.settings.no_origins": "Nenhuma origem extra adicionada.",
    "No extra origins added.": "Nenhuma origem extra adicionada.",
    "maps.error.session_not_ready": "Sua sessão de administração ainda não está pronta.",
    "Your admin session is not ready yet.": "Sua sessão de administração ainda não está pronta.",
    "maps.error.load_data": "Não é possível carregar os dados do Maps ({status}).",
    "Unable to load Maps data ({status}).": "Não é possível carregar os dados do Maps ({status}).",
    "maps.error.load_usage": "Não é possível carregar o uso do Maps.",
    "Unable to load Maps usage.": "Não é possível carregar o uso do Maps.",
    "maps.error.load_settings": "Não é possível carregar as configurações do Maps.",
    "Unable to load Maps settings.": "Não é possível carregar as configurações do Maps.",
    "maps.error.save_settings": "Não é possível salvar as configurações do Maps.",
    "Unable to save Maps settings.": "Não é possível salvar as configurações do Maps.",
    "maps.error.invalid_origin": "Insira um origem completo, como https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Insira um origem completo, como https://staging.example.com.",
    "maps.error.registered_origin": "Esta origem já está coberta por um domínio registrado.",
    "This origin is already covered by a registered domain.": "Esta origem já está coberta por um domínio registrado.",
    "maps.error.address_required": "Insira um endereço ou localidade para escanear.",
    "Enter an address or locality to scan.": "Insira um endereço ou localidade para escanear.",
    "maps.error.location_not_found": "Não é possível encontrar esse local.",
    "Unable to find that location.": "Não é possível encontrar esse local.",
    "maps.error.no_coordinates": "Nenhuma coordenada foi encontrada para esse endereço. Tente uma rua próxima, bairro ou cidade.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Nenhuma coordenada foi encontrada para esse endereço. Tente uma rua próxima, bairro ou cidade.",
    "maps.error.analyze_area": "Não é possível analisar esta área.",
    "Unable to analyze this area.": "Não é possível analisar esta área.",
    "maps.notice.settings_saved": "Configurações do Maps salvas.",
    "Maps settings saved.": "Configurações do Maps salvas.",
    "maps.status.success": "Sucesso",
    "maps.status.error": "Erro",
    "maps.operation.geocode": "Geocodificação",
    "Geocode": "Geocodificação",
    "maps.operation.maps_geocode": "Geocodificação do Maps",
    "Maps geocode": "Geocodificação do Maps",
    "maps.operation.market_analysis": "Análise de mercado",
    "Market analysis": "Análise de mercado",
    "maps.operation.maps_market_analysis": "Análise de mercado do Maps",
    "Maps market analysis": "Análise de mercado do Maps",
    "maps.operation.places_search": "Pesquisa de lugares",
    "Places search": "Pesquisa de lugares",
    "maps.operation.places_nearby": "Locais próximos",
    "Nearby places": "Locais próximos",
    "maps.operation.place_details": "Detalhes do local",
    "Place details": "Detalhes do local",
    "common.loading": "Carregando…",
    "common.saving": "Salvando…",
    "common.searching": "Pesquisando…",
    "Searching…": "Pesquisando…",
    "common.no_matches": "Nenhum resultado encontrado.",
    "No matches found.": "Nenhum resultado encontrado.",
    "common.select": "Selecionar…",
    "Select…": "Selecionar…",
    "common.search_users": "Pesquisar usuários por nome ou e-mail",
    "Search users by name or email": "Pesquisar usuários por nome ou e-mail",
    "common.reset": "Redefinir",
    "Reset": "Redefinir",
    "common.validation.email": "Insira um endereço de e-mail válido.",
    "Enter a valid email address.": "Insira um endereço de e-mail válido.",
    "common.validation.phone": "Insira um número de telefone válido.",
    "Enter a valid phone number.": "Insira um número de telefone válido.",
    "common.validation.currency": "Use um código de moeda de 3 letras, como USD.",
    "Use a 3-letter currency code, such as USD.": "Use um código de moeda de 3 letras, como USD.",
    "common.validation.location": "Insira um endereço ou localização válido.",
    "Enter a valid address or location.": "Insira um endereço ou localização válido.",
    "common.validation.required": "{label} é obrigatório.",
    "{label} is required.": "{label} é obrigatório.",
    "common.validation.invalid": "{label} é inválido.",
    "{label} is invalid.": "{label} é inválido.",
    "common.status.active": "Ativo",
    "common.status.inactive": "Inativo",
    "common.status.open": "Aberto",
    "common.status.closed": "Fechado",
    "Closed": "Fechado",
    "common.status.posted": "Publicado",
    "Posted": "Publicado",
    "common.status.voided": "Anulado",
    "Voided": "Anulado",
    "common.status.draft": "Rascunho",
    "Draft": "Rascunho",
    "common.status.success": "Sucesso",
    "common.status.error": "Erro",
    "accounting.title": "Contabilidade",
    "accounting.description": "Gerencie contas, mapeamentos, períodos, diários e relatórios financeiros.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Gerencie contas, mapeamentos, períodos, diários e relatórios financeiros.",
    "accounting.tab.overview": "Visão geral",
    "Overview": "Visão geral",
    "accounting.tab.accounts": "Estrutura de contas",
    "accounting.tab.mappings": "Mapeamentos de contas",
    "Account mappings": "Mapeamentos de contas",
    "accounting.tab.periods": "Períodos contábeis",
    "Accounting periods": "Períodos contábeis",
    "accounting.tab.journals": "Diários",
    "Journals": "Diários",
    "accounting.tab.reports": "Relatórios",
    "accounting.account.edit_title": "Editar conta",
    "Edit account": "Editar conta",
    "accounting.account.new_title": "Nova conta",
    "New account": "Nova conta",
    "accounting.account.save": "Salvar conta",
    "Save account": "Salvar conta",
    "accounting.account.create": "Criar conta",
    "Create account": "Criar conta",
    "accounting.account.code": "Código da conta",
    "Account code": "Código da conta",
    "accounting.account.name": "Nome da conta",
    "Account name": "Nome da conta",
    "accounting.account.type": "Tipo de conta",
    "Account type": "Tipo de conta",
    "accounting.account.currency_id": "ID da moeda",
    "Currency ID": "ID da moeda",
    "accounting.account.active": "Ativo",
    "accounting.account.unnamed": "Conta sem nome",
    "Unnamed account": "Conta sem nome",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Despesa de folha de pagamento",
    "Payroll expense": "Despesa de folha de pagamento",
    "accounting.type.asset": "Ativo",
    "Asset": "Ativo",
    "accounting.type.liability": "Passivo",
    "Liability": "Passivo",
    "accounting.type.equity": "Patrimônio",
    "Equity": "Patrimônio",
    "accounting.type.revenue": "Receita",
    "accounting.type.expense": "Despesa",
    "Expense": "Despesa",
    "accounting.toast.account_updated": "Conta atualizada",
    "Account updated": "Conta atualizada",
    "accounting.toast.account_created": "Conta criada",
    "Account created": "Conta criada",
    "accounting.toast.defaults_created": "Contas padrão criadas",
    "Default accounts created": "Contas padrão criadas",
    "accounting.toast.mapping_saved": "Mapeamento salvo",
    "Mapping saved": "Mapeamento salvo",
    "accounting.toast.period_closed": "Período contábil fechado",
    "Accounting period closed": "Período contábil fechado",
    "accounting.toast.period_created": "Período criado",
    "Period created": "Período criado",
    "accounting.toast.journal_created": "Diário criado",
    "Journal created": "Diário criado",
    "accounting.toast.journal_voided": "Diário anulado",
    "Journal voided": "Diário anulado",
    "accounting.validation.journal_balanced": "O diário deve ter uma data, descrição e totais de débito e crédito equilibrados.",
    "Journal must have a date, description, and balanced debit and credit totals.": "O diário deve ter uma data, descrição e totais de débito e crédito equilibrados.",
    "accounting.filter.all_types": "Todos os tipos de conta",
    "All account types": "Todos os tipos de conta",
    "accounting.filter.all_statuses": "Todos os status",
    "accounting.action.bootstrap": "Configurar padrões",
    "Bootstrap defaults": "Configurar padrões",
    "accounting.action.new_account": "Nova conta",
    "accounting.empty.accounts": "Nenhuma conta encontrada.",
    "No accounts found.": "Nenhuma conta encontrada.",
    "accounting.column.code": "Código",
    "Code": "Código",
    "accounting.column.account": "Conta",
    "accounting.column.type": "Tipo",
    "Type": "Tipo",
    "accounting.column.currency": "Moeda",
    "accounting.column.status": "Status",
    "accounting.action.edit": "Editar",
    "accounting.mapping.edit_title": "Editar mapeamento de conta",
    "Edit account mapping": "Editar mapeamento de conta",
    "accounting.mapping.new_title": "Novo mapeamento de conta",
    "New account mapping": "Novo mapeamento de conta",
    "accounting.mapping.save": "Salvar mapeamento",
    "Save mapping": "Salvar mapeamento",
    "accounting.mapping.create": "Criar mapeamento",
    "Create mapping": "Criar mapeamento",
    "accounting.mapping.source_type": "Tipo de origem",
    "accounting.mapping.event_key": "Chave do evento",
    "Event key": "Chave do evento",
    "accounting.mapping.debit_account": "Conta de débito",
    "Debit account": "Conta de débito",
    "accounting.mapping.credit_account": "Conta de crédito",
    "Credit account": "Conta de crédito",
    "accounting.mapping.tax_account": "Conta de impostos",
    "Tax account": "Conta de impostos",
    "accounting.mapping.none": "Nenhum",
    "None": "Nenhum",
    "accounting.mapping.source_placeholder": "pedido",
    "order": "pedido",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filtrar tipo de origem",
    "Filter source type": "Filtrar tipo de origem",
    "accounting.action.new_mapping": "Novo mapeamento",
    "New mapping": "Novo mapeamento",
    "accounting.empty.mappings": "Nenhum mapeamento de conta encontrado.",
    "No account mappings found.": "Nenhum mapeamento de conta encontrado.",
    "accounting.column.source": "Origem",
    "accounting.column.event": "Evento",
    "accounting.column.debit": "Débito",
    "Debit": "Débito",
    "accounting.column.credit": "Crédito",
    "Credit": "Crédito",
    "accounting.period.close_confirm": "Fechar {period}? Isso não pode ser revertido.",
    "Close {period}? This cannot be reversed.": "Fechar {period}? Isso não pode ser revertido.",
    "accounting.period.this": "este período contábil",
    "this accounting period": "este período contábil",
    "accounting.period.new_title": "Novo período contábil",
    "New accounting period": "Novo período contábil",
    "accounting.period.create": "Criar período",
    "Create period": "Criar período",
    "accounting.period.name": "Nome do período",
    "Period name": "Nome do período",
    "accounting.period.start": "Data de início",
    "accounting.period.end": "Data de término",
    "End date": "Data de término",
    "accounting.period.name_placeholder": "janeiro de 2027",
    "January 2027": "janeiro de 2027",
    "accounting.period.open": "Abrir",
    "accounting.period.closed": "Fechado",
    "accounting.action.new_period": "Novo período",
    "New period": "Novo período",
    "accounting.empty.periods": "Nenhum período contábil encontrado.",
    "No accounting periods found.": "Nenhum período contábil encontrado.",
    "accounting.column.period": "Período",
    "accounting.column.start": "Início",
    "Start": "Início",
    "accounting.column.end": "Fim",
    "End": "Fim",
    "accounting.action.close_period": "Fechar período",
    "Close period": "Fechar período",
    "accounting.journal.new_title": "Novo diário",
    "New journal": "Novo diário",
    "accounting.journal.balance_help": "Débitos e créditos devem estar equilibrados antes de salvar.",
    "Debits and credits must balance before saving.": "Débitos e créditos devem estar equilibrados antes de salvar.",
    "accounting.journal.close": "Fechar",
    "accounting.journal.entry_date": "Data de entrada",
    "Entry date": "Data de entrada",
    "accounting.journal.description": "Descrição",
    "accounting.journal.source_type": "Tipo de fonte",
    "accounting.journal.source_id": "ID da fonte",
    "Source ID": "ID da fonte",
    "accounting.journal.account": "Conta",
    "accounting.journal.select_account": "Selecionar conta",
    "Select account": "Selecionar conta",
    "accounting.journal.debit_total": "Débito: {debit} · Crédito: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Débito: {debit} · Crédito: {credit} · {status}",
    "accounting.journal.balanced": "Equilibrado",
    "Balanced": "Equilibrado",
    "accounting.journal.unbalanced": "Desbalanceado",
    "Unbalanced": "Desbalanceado",
    "accounting.journal.add_line": "Adicionar linha",
    "Add line": "Adicionar linha",
    "accounting.journal.save": "Salvar diário",
    "Save journal": "Salvar diário",
    "accounting.journal.empty": "Nenhuma linha de diário encontrada.",
    "accounting.journal.reason_prompt": "Motivo para anular este diário:",
    "Reason for voiding this journal:": "Motivo para anular este diário:",
    "accounting.journal.details_title": "Diário #{id}",
    "Journal #{id}": "Diário #{id}",
    "accounting.action.view": "Ver",
    "View": "Ver",
    "accounting.action.void": "Anular",
    "Void": "Anular",
    "accounting.filter.all_accounts": "Todas as contas",
    "All accounts": "Todas as contas",
    "accounting.empty.journals": "Nenhum diário encontrado.",
    "No journals found.": "Nenhum diário encontrado.",
    "accounting.column.date": "Data",
    "accounting.column.description": "Descrição",
    "accounting.column.account_source": "Fonte",
    "accounting.empty.journal_lines": "Nenhuma linha de diário.",
    "accounting.report.trial_balance": "Balancete",
    "Trial balance": "Balancete",
    "accounting.report.general_ledger": "Livro geral",
    "General ledger": "Livro geral",
    "accounting.action.run_report": "Executar relatório",
    "Run report": "Executar relatório",
    "accounting.report.loading": "Carregando relatório…",
    "Loading report…": "Carregando relatório…",
    "accounting.empty.report": "Nenhuma linha de relatório encontrada.",
    "No report rows found.": "Nenhuma linha de relatório encontrada.",
    "accounting.report.choose_run": "Selecione um relatório e execute-o.",
    "Choose a report and run it.": "Selecione um relatório e execute-o.",
    "accounting.column.balance": "Saldo",
    "Balance": "Saldo",
    "accounting.overview.chart_title": "Livro de contas",
    "accounting.overview.chart_description": "Defina as contas usadas pelo seu livro maior.",
    "Define the accounts used by your ledger.": "Defina as contas usadas pelo seu livro maior.",
    "accounting.overview.journals_title": "Diários",
    "accounting.overview.journals_description": "Crie e revise entradas de diário equilibradas.",
    "Create and review balanced journal entries.": "Crie e revise entradas de diário equilibradas.",
    "accounting.overview.reports_title": "Relatórios",
    "accounting.overview.reports_description": "Execute relatórios de balancete e livro geral.",
    "Run trial balance and general ledger reports.": "Execute relatórios de balancete e livro geral.",
    "common.refresh": "Atualizar",
    "reports.search.title": "Pesquisar análise",
    "Search analytics": "Pesquisar análise",
    "reports.search.back_to_report": "Voltar ao relatório",
    "Back to report": "Voltar ao relatório",
    "reports.search.description": "A pesquisa de demanda mostra o que os visitantes estão procurando e onde seu catálogo precisa de cobertura.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "A pesquisa de demanda mostra o que os visitantes estão procurando e onde seu catálogo precisa de cobertura.",
    "reports.search.metric.searches": "Pesquisas",
    "Searches": "Pesquisas",
    "reports.search.metric.unique_keywords": "Palavras-chave únicas",
    "Unique keywords": "Palavras-chave únicas",
    "reports.search.metric.with_listings": "Com listagens",
    "With listings": "Com listagens",
    "reports.search.metric.no_matches": "Sem correspondência em listagens",
    "No listing matches": "Sem correspondência em listagens",
    "reports.search.metric.coverage": "Cobertura",
    "Coverage": "Cobertura",
    "reports.search.insights.title": "Insights para administradores",
    "Admin insights": "Insights para administradores",
    "reports.search.insights.no_results_one": "{count} palavra-chave não retornou listagens. Considere criar uma listagem, adicionar o termo como categoria ou tag, ou melhorar o título e descrição da listagem.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "{count} palavra-chave não retornou listagens. Considere criar uma listagem, adicionar o termo como categoria ou tag, ou melhorar o título e descrição da listagem.",
    "reports.search.insights.no_results_many": "{count} palavras-chave não retornaram listagens. Considere criar listagens, adicionar os termos como categorias ou tags, ou melhorar os títulos e descrições das listagens.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} palavras-chave não retornaram listagens. Considere criar listagens, adicionar os termos como categorias ou tags, ou melhorar os títulos e descrições das listagens.",
    "reports.search.insights.all_covered": "Cada palavra-chave rastreada retornou pelo menos uma listagem. Revise as palavras-chave mais frequentes para melhorar merchandising e posicionamento de categorias.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Cada palavra-chave rastreada retornou pelo menos uma listagem. Revise as palavras-chave mais frequentes para melhorar merchandising e posicionamento de categorias.",
    "reports.search.insights.empty": "Os dados de pesquisa aparecerão após os visitantes pesquisarem no mercado.",
    "Search data will appear after visitors search the marketplace.": "Os dados de pesquisa aparecerão após os visitantes pesquisarem no mercado.",
    "reports.search.insights.total_matches": "{count} correspondências totais de listagens foram retornadas nos registros de pesquisa carregados.",
    "{count} total listing matches were returned across the loaded search records.": "{count} correspondências totais de listagens foram retornadas nos registros de pesquisa carregados.",
    "reports.search.coverage_title": "Cobertura de palavras-chave",
    "Keyword coverage": "Cobertura de palavras-chave",
    "reports.search.loading": "Carregando análise de pesquisa…",
    "Loading search analytics…": "Carregando análise de pesquisa…",
    "reports.search.empty": "Nenhuma frase de pesquisa encontrada.",
    "No search phrases found.": "Nenhuma frase de pesquisa encontrada.",
    "reports.search.error.load": "Não é possível carregar a análise de pesquisa.",
    "Unable to load search analytics.": "Não é possível carregar a análise de pesquisa.",
    "reports.search.unknown": "Pesquisa desconhecida",
    "Unknown search": "Pesquisa desconhecida",
    "reports.search.column.keyword": "Palavra-chave",
    "Keyword": "Palavra-chave",
    "reports.search.column.listings": "Listagens",
    "reports.search.column.coverage": "Cobertura",
    "reports.search.column.last_searched": "Última pesquisa",
    "Last searched": "Última pesquisa",
    "reports.search.column.suggested_action": "Ação sugerida",
    "Suggested action": "Ação sugerida",
    "reports.search.status.covered": "Coberta",
    "Covered": "Coberta",
    "reports.search.status.no_matches": "Sem correspondência",
    "No matches": "Sem correspondência",
    "reports.search.action.review_ranking": "Revisar classificação",
    "Review ranking": "Revisar classificação",
    "reports.search.action.add_listing": "Adicionar lista ou categoria",
    "Add listing or category": "Adicionar lista ou categoria",
    "platform_health.title": "Saúde da plataforma",
    "Platform health": "Saúde da plataforma",
    "platform_health.tab.health": "Saúde",
    "Health": "Saúde",
    "platform_health.tab.configuration": "Configuração",
    "Configuration": "Configuração",
    "platform_health.action.refreshing": "Atualizando…",
    "Refreshing…": "Atualizando…",
    "platform_health.window_note": "A visualização atual carrega os primeiros {count} registros para cada tipo de evento.",
    "The current view loads the first {count} records for each event type.": "A visualização atual carrega os primeiros {count} registros para cada tipo de evento.",
    "platform_health.error.title": "Não é possível carregar os relatórios de autenticação",
    "Unable to load authentication audits": "Não é possível carregar os relatórios de autenticação",
    "platform_health.error.proxy_note": "A API pode exigir que este pedido de administrador seja enviado por proxy do servidor em vez de diretamente pelo navegador.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "A API pode exigir que este pedido de administrador seja enviado por proxy do servidor em vez de diretamente pelo navegador.",
    "platform_health.error.session": "Sua sessão de administração ainda não está pronta. Faça login novamente.",
    "Your admin session is not ready yet. Please sign in again.": "Sua sessão de administração ainda não está pronta. Faça login novamente.",
    "platform_health.error.load": "Não é possível carregar os relatórios de autenticação ({status}).",
    "Unable to load authentication audits ({status}).": "Não é possível carregar os relatórios de autenticação ({status}).",
    "platform_health.error.load_generic": "Não é possível carregar os relatórios de auditoria da plataforma.",
    "Unable to load platform health audits.": "Não é possível carregar os relatórios de auditoria da plataforma.",
    "platform_health.metric.login_attempts": "Tentativas de login",
    "Login attempts": "Tentativas de login",
    "platform_health.metric.signup_attempts": "Tentativas de registro",
    "Signup attempts": "Tentativas de registro",
    "platform_health.metric.audit_records": "Registros de auditoria",
    "Audit records": "Registros de auditoria",
    "platform_health.metric.successful": "Sucesso",
    "platform_health.metric.failed": "Falha",
    "platform_health.metric.outcome_returned": "Apenas quando o resultado é retornado",
    "Only when outcome is returned": "Apenas quando o resultado é retornado",
    "platform_health.metric.failure_rate": "Taxa de falhas",
    "Failure rate": "Taxa de falhas",
    "platform_health.metric.classified_records": "Registros classificados",
    "Classified records": "Registros classificados",
    "platform_health.activity.title": "Atividade de autenticação",
    "Authentication activity": "Atividade de autenticação",
    "platform_health.activity.description": "Tentativas retornadas pela janela de auditoria selecionada",
    "Attempts returned by the selected audit window": "Tentativas retornadas pela janela de auditoria selecionada",
    "platform_health.activity.no_timestamps": "Nenhum registro de auditoria com marca de tempo foi retornado.",
    "No timestamped audit records returned.": "Nenhum registro de auditoria com marca de tempo foi retornado.",
    "platform_health.event.login": "login",
    "login": "login",
    "platform_health.event.signup": "cadastro",
    "signup": "cadastro",
    "platform_health.status.success": "Sucesso",
    "platform_health.status.failed": "Falha",
    "platform_health.status.recorded": "Registrado",
    "Recorded": "Registrado",
    "platform_health.unknown_day": "Desconhecido",
    "Unknown": "Desconhecido",
    "platform_health.failure_reasons": "Motivos de falha",
    "Failure reasons": "Motivos de falha",
    "platform_health.no_failures": "Nenhuma falha classificada retornada.",
    "No classified failures returned.": "Nenhuma falha classificada retornada.",
    "platform_health.unspecified_failure": "Falha não especificada",
    "Unspecified failure": "Falha não especificada",
    "platform_health.recent_records": "Registros de auditoria recentes",
    "Recent audit records": "Registros de auditoria recentes",
    "platform_health.normalized_note": "Campos brutos são normalizados apenas para exibição.",
    "Raw fields are normalized only for display.": "Campos brutos são normalizados apenas para exibição.",
    "platform_health.loaded_count": "{count} carregados",
    "{count} loaded": "{count} carregados",
    "platform_health.loading_records": "Carregando registros de auditoria…",
    "Loading audit records…": "Carregando registros de auditoria…",
    "platform_health.no_records": "Nenhum registro de auditoria retornado.",
    "No audit records returned.": "Nenhum registro de auditoria retornado.",
    "platform_health.column.event": "Evento",
    "platform_health.column.status": "Status",
    "platform_health.column.user": "Usuário",
    "User": "Usuário",
    "platform_health.column.time": "Hora",
    "Time": "Hora",
    "platform_health.column.reason": "Motivo",
    "Reason": "Motivo",
    "platform_health.config.sign_in": "Método de login",
    "Sign-in method": "Método de login",
    "platform_health.config.facebook": "Autenticação do Facebook",
    "Facebook Auth": "Autenticação do Facebook",
    "platform_health.config.google": "Autenticação do Google",
    "Google Auth": "Autenticação do Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Essas configurações são aplicadas imediatamente. Após salvá-las, elas aparecem em aplicativos e respostas da API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Essas configurações são aplicadas imediatamente. Após salvá-las, elas aparecem em aplicativos e respostas da API.",
    "integrations.note.mobile_release": "As configurações do canal de aplicativo móvel são aplicadas quando um produto é lançado ou atualizado. Para obter um novo build, solicite um pelo Portal de Suporte. Isso se aplica ao plano Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "As configurações do canal de aplicativo móvel são aplicadas quando um produto é lançado ou atualizado. Para obter um novo build, solicite um pelo Portal de Suporte. Isso se aplica ao plano Starter.",
    "integrations.toast.saved": "Configuração de integração salva.",
    "Integration settings saved.": "Configuração de integração salva.",
    "integrations.error.save": "Não é possível salvar as configurações de integração.",
    "Unable to save integration settings.": "Não é possível salvar as configurações de integração.",
    "integrations.twilio.title": "Integração do Twilio",
    "Twilio integration": "Integração do Twilio",
    "integrations.twilio.account_sid": "SID da conta",
    "Account SID": "SID da conta",
    "integrations.twilio.account_sid_placeholder": "Insira o SID da conta",
    "Enter account SID": "Insira o SID da conta",
    "integrations.twilio.auth_token": "Token de autenticação",
    "Auth token": "Token de autenticação",
    "integrations.twilio.auth_token_placeholder": "Insira o token de autenticação",
    "Enter auth token": "Insira o token de autenticação",
    "integrations.twilio.source_phone": "Número de telefone de origem",
    "Source phone number": "Número de telefone de origem",
    "integrations.twilio.source_phone_placeholder": "Insira o número de telefone de origem",
    "Enter source phone number": "Insira o número de telefone de origem",
    "integrations.facebook.title": "Autenticação do Facebook",
    "integrations.facebook.enable_login": "Habilitar login do Facebook",
    "Enable Facebook login": "Habilitar login do Facebook",
    "integrations.facebook.app_id": "ID do aplicativo",
    "App ID": "ID do aplicativo",
    "integrations.facebook.app_id_placeholder": "Insira a ID do aplicativo",
    "integrations.google.title": "Autenticação do Google",
    "integrations.google.enable_sign_in": "Habilitar login com Google",
    "Enable Google sign-in": "Habilitar login com Google",
    "integrations.google.client_id": "ID do cliente",
    "integrations.google.client_id_placeholder": "Insira a ID do cliente",
    "integrations.auth.title": "Método de login",
    "integrations.auth.description": "Escolha como os usuários se registram e entram. E-mail e verificação por SMS usam as configurações de entrega configuradas para o tenant.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Escolha como os usuários se registram e entram. E-mail e verificação por SMS usam as configurações de entrega configuradas para o tenant.",
    "integrations.auth.empty": "Atualmente não há nenhum método de login compatível configurado. Selecione um para continuar.",
    "No supported sign-in method is currently configured. Select one to continue.": "Atualmente não há nenhum método de login compatível configurado. Selecione um para continuar.",
    "integrations.auth.save_note": "Salvando aplica este método aos pontos de acesso de registro e login do tenant. Usuários diretamente provisionados são gerenciados separadamente.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Salvando aplica este método aos pontos de acesso de registro e login do tenant. Usuários diretamente provisionados são gerenciados separadamente.",
    "integrations.auth.error.load": "Não é possível carregar o método de login atual.",
    "Unable to load the current sign-in method.": "Não é possível carregar o método de login atual.",
    "integrations.auth.error.save": "Não é possível salvar o método de login.",
    "Unable to save the sign-in method.": "Não é possível salvar o método de login.",
    "integrations.auth.toast.saved": "Método de login salvo.",
    "Sign-in method saved.": "Método de login salvo.",
    "integrations.auth.email_password": "E-mail e senha",
    "Email and password": "E-mail e senha",
    "integrations.auth.email_password_help": "Os usuários verificam seu e-mail durante o cadastro, depois entram com uma senha.",
    "Users verify their email during sign-up, then sign in with a password.": "Os usuários verificam seu e-mail durante o cadastro, depois entram com uma senha.",
    "integrations.auth.email_code": "Código de verificação por e-mail",
    "Email one-time code": "Código de verificação por e-mail",
    "integrations.auth.email_code_help": "Os usuários recebem um código de verificação por e-mail para cadastro e login.",
    "Users receive a verification code by email for sign-up and sign-in.": "Os usuários recebem um código de verificação por e-mail para cadastro e login.",
    "integrations.auth.phone_code": "Código de verificação por SMS",
    "Phone one-time code": "Código de verificação por SMS",
    "integrations.auth.phone_code_help": "Os usuários recebem um código de verificação por SMS para cadastro e login.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Os usuários recebem um código de verificação por SMS para cadastro e login.",
    "integrations.auth.phone_password": "Telefone e senha",
    "Phone and password": "Telefone e senha",
    "integrations.auth.phone_password_help": "Os usuários verificam seu telefone durante o cadastro, depois entram com uma senha.",
    "Users verify their phone during sign-up, then sign in with a password.": "Os usuários verificam seu telefone durante o cadastro, depois entram com uma senha.",
    "integrations.auth.email_password_unverified": "E-mail e senha sem verificação de cadastro",
    "Email and password without sign-up verification": "E-mail e senha sem verificação de cadastro",
    "integrations.auth.email_password_unverified_help": "Os usuários podem se cadastrar com e-mail e senha sem código de verificação por e-mail.",
    "Users can sign up with an email and password without an email verification code.": "Os usuários podem se cadastrar com e-mail e senha sem código de verificação por e-mail.",
    "integrations.auth.phone_password_unverified": "Telefone e senha sem verificação de cadastro",
    "Phone and password without sign-up verification": "Telefone e senha sem verificação de cadastro",
    "integrations.auth.phone_password_unverified_help": "Os usuários podem se cadastrar com telefone e senha sem código de verificação por SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Os usuários podem se cadastrar com telefone e senha sem código de verificação por SMS.",
    "integrations.page.title": "Integrações de aplicativo",
    "integrations.generic.id_placeholder": "Insira o ID de {name}",
    "Enter {name} ID": "Insira o ID de {name}",
    "integrations.generic.enable": "Habilitar integração de {name}",
    "Enable {name} integration": "Habilitar integração de {name}",
    "integrations.menu.map": "Mapas",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Integração de mapas",
    "Maps integration": "Integração de mapas",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Chave da API",
    "integrations.maps.api_key_placeholder": "Insira a chave da API",
    "integrations.maps.reverse_geocode_key": "Chave da API de geocodificação reversa do Google Maps",
    "Google Maps reverse geocoding API key": "Chave da API de geocodificação reversa do Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Insira a chave da API de geocodificação reversa do Google Maps",
    "Enter Google Maps reverse geocoding API key": "Insira a chave da API de geocodificação reversa do Google Maps",
    "integrations.maps.places_key": "Chave da API do Google Maps Places",
    "Google Maps Places API key": "Chave da API do Google Maps Places",
    "integrations.maps.places_key_placeholder": "Insira a chave da API do Google Maps Places",
    "Enter Google Maps Places API key": "Insira a chave da API do Google Maps Places",
    "integrations.maps.nearby_accounts": "Ativar contas próximas na página inicial",
    "Activate nearby accounts on the home page": "Ativar contas próximas na página inicial",
    "integrations.maps.listing_location": "Ativar localização na submissão de lista",
    "Activate location in listing submission": "Ativar localização na submissão de lista",
    "integrations.maps.account_location": "Ativar localização na submissão de conta",
    "Activate location in account submission": "Ativar localização na submissão de conta",
    "integrations.playstore.title": "Integração do Google Play",
    "Google Play integration": "Integração do Google Play",
    "integrations.playstore.application_id": "ID do aplicativo",
    "Application ID": "ID do aplicativo",
    "integrations.playstore.application_id_placeholder": "Insira o ID do aplicativo (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Insira o ID do aplicativo (com.tenantname.app)",
    "integrations.playstore.first_name": "Nome",
    "integrations.playstore.first_name_placeholder": "Insira o nome",
    "Enter first name": "Insira o nome",
    "integrations.playstore.last_name": "Sobrenome",
    "integrations.playstore.last_name_placeholder": "Insira o sobrenome",
    "Enter last name": "Insira o sobrenome",
    "integrations.playstore.unit": "Unidade organizacional",
    "Organizational unit": "Unidade organizacional",
    "integrations.playstore.unit_placeholder": "Insira a unidade organizacional",
    "Enter organizational unit": "Insira a unidade organizacional",
    "integrations.playstore.organization": "Organização",
    "Organization": "Organização",
    "integrations.playstore.organization_placeholder": "Insira o nome da organização",
    "Enter organization name": "Insira o nome da organização",
    "integrations.playstore.city": "Cidade ou localidade",
    "City or locality": "Cidade ou localidade",
    "integrations.playstore.city_placeholder": "Insira cidade ou localidade",
    "Enter city or locality": "Insira cidade ou localidade",
    "integrations.playstore.state": "Estado ou província",
    "State or province": "Estado ou província",
    "integrations.playstore.state_placeholder": "Insira estado ou província",
    "Enter state or province": "Insira estado ou província",
    "integrations.playstore.country_code": "Código do país (XX)",
    "Country code (XX)": "Código do país (XX)",
    "integrations.playstore.country_code_placeholder": "Insira o código do país",
    "Enter country code": "Insira o código do país",
    "integrations.playstore.link": "Link do Google Play",
    "Google Play link": "Link do Google Play",
    "integrations.playstore.link_placeholder": "Insira o link do Google Play do seu aplicativo",
    "Enter your app Google Play link": "Insira o link do Google Play do seu aplicativo",
    "integrations.admob.title": "Integração do AdMob",
    "AdMob integration": "Integração do AdMob",
    "integrations.admob.app_id": "ID do aplicativo",
    "integrations.admob.app_id_placeholder": "Insira o ID do aplicativo",
    "Enter App ID": "Insira o ID do aplicativo",
    "integrations.admob.unit_id": "ID da unidade",
    "Unit ID": "ID da unidade",
    "integrations.admob.unit_id_placeholder": "Insira o ID da unidade AdMob",
    "Enter AdMob unit ID": "Insira o ID da unidade AdMob",
    "integrations.admob.listings_id": "ID de listagens",
    "Listings ID": "ID de listagens",
    "integrations.admob.listings_id_placeholder": "Insira o ID de listagens",
    "Enter listings ID": "Insira o ID de listagens",
    "integrations.admob.listing_detail_id": "ID do detalhe da listagem",
    "Listing detail ID": "ID do detalhe da listagem",
    "integrations.admob.listing_detail_id_placeholder": "Insira o ID do detalhe da listagem",
    "Enter listing detail ID": "Insira o ID do detalhe da listagem",
    "integrations.admob.home_id": "ID da página inicial",
    "Home ID": "ID da página inicial",
    "integrations.admob.home_id_placeholder": "Insira o ID da página inicial",
    "Enter home ID": "Insira o ID da página inicial",
    "integrations.admob.enable_ads": "Habilitar anúncios",
    "Enable ads": "Habilitar anúncios",
    "integrations.admob.enable_listing_ads": "Habilitar anúncios no feed de listagens",
    "Enable ads on the listings feed": "Habilitar anúncios no feed de listagens",
    "integrations.admob.enable_listing_detail_ads": "Habilitar anúncios nos detalhes da listagem",
    "Enable ads on listing details": "Habilitar anúncios nos detalhes da listagem",
    "integrations.admob.enable_home_ads": "Habilitar anúncios na navegação inferior da página inicial",
    "Enable ads in the home bottom navigation": "Habilitar anúncios na navegação inferior da página inicial",
    "integrations.save_success": "Salvo com sucesso",
    "Saved successfully": "Salvo com sucesso",
    "integrations.note.release": "Essas configurações se aplicam quando o aplicativo móvel é lançado ou atualizado. Solicite um novo build no Portal de Suporte após fazer alterações. Aplica o plano Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Essas configurações se aplicam quando o aplicativo móvel é lançado ou atualizado. Solicite um novo build no Portal de Suporte após fazer alterações. Aplica o plano Starter.",
    "integrations.action.download": "Baixar",
    "integrations.branch.title": "Integração do Branch",
    "Branch integration": "Integração do Branch",
    "integrations.branch.app_id": "ID do aplicativo",
    "integrations.branch.app_id_placeholder": "Insira o ID do aplicativo",
    "integrations.branch.live_key": "Chave ao vivo",
    "Live key": "Chave ao vivo",
    "integrations.branch.live_key_placeholder": "Insira a chave ao vivo",
    "Enter live key": "Insira a chave ao vivo",
    "integrations.branch.live_secret": "Segredo ao vivo",
    "Live secret": "Segredo ao vivo",
    "integrations.branch.live_secret_placeholder": "Insira o segredo ao vivo",
    "Enter live secret": "Insira o segredo ao vivo",
    "integrations.branch.uri_scheme": "Esquema URI",
    "URI scheme": "Esquema URI",
    "integrations.branch.uri_scheme_placeholder": "Insira o esquema URI",
    "Enter URI scheme": "Insira o esquema URI",
    "integrations.branch.link_domain": "Domínio do link",
    "Link domain": "Domínio do link",
    "integrations.branch.link_domain_placeholder": "Insira o domínio do link",
    "Enter link domain": "Insira o domínio do link",
    "integrations.branch.alternate_domain": "Domínio alternativo do link",
    "Alternate link domain": "Domínio alternativo do link",
    "integrations.branch.alternate_domain_placeholder": "Insira o domínio alternativo do link",
    "Enter alternate link domain": "Insira o domínio alternativo do link",
    "integrations.branch.link_description": "Descrição do link",
    "Link description": "Descrição do link",
    "integrations.branch.link_description_placeholder": "Insira a descrição do link",
    "Enter link description": "Insira a descrição do link",
    "integrations.branch.invite_friends": "Convidar amigos",
    "Invite friends": "Convidar amigos",
    "integrations.branch.invite_title": "Título",
    "integrations.branch.invite_description": "Descrição",
    "integrations.branch.destination_link": "Link de destino da Branch (opcional)",
    "Branch destination link (optional)": "Link de destino da Branch (opcional)",
    "integrations.branch.web_app_note": "Aplica a usuários de aplicativo web",
    "Applies to web app users": "Aplica a usuários de aplicativo web",
    "integrations.branch.destination_placeholder": "Insira o link de destino da Branch",
    "Enter branch destination link": "Insira o link de destino da Branch",
    "integrations.ios.title": "Provisão da App Store",
    "App Store provisioning": "Provisão da App Store",
    "integrations.ios.bundle_id": "ID do pacote",
    "Bundle ID": "ID do pacote",
    "integrations.ios.bundle_id_placeholder": "Insira o ID do pacote",
    "Enter bundle ID": "Insira o ID do pacote",
    "integrations.ios.certificate_password": "Senha do certificado de distribuição",
    "Distribution certificate password": "Senha do certificado de distribuição",
    "integrations.ios.certificate_password_placeholder": "Insira a senha do certificado de distribuição",
    "Enter distribution certificate password": "Insira a senha do certificado de distribuição",
    "integrations.ios.push_key_id": "ID da chave de push",
    "Push key ID": "ID da chave de push",
    "integrations.ios.push_key_id_placeholder": "Insira a ID da chave de push",
    "Enter push key ID": "Insira a ID da chave de push",
    "integrations.ios.team_id": "ID da equipe",
    "Team ID": "ID da equipe",
    "integrations.ios.team_id_placeholder": "Insira a ID da equipe",
    "Enter team ID": "Insira a ID da equipe",
    "integrations.ios.apple_id": "ID da Apple",
    "Apple ID": "ID da Apple",
    "integrations.ios.apple_id_placeholder": "Insira a ID da Apple",
    "Enter Apple ID": "Insira a ID da Apple",
    "integrations.ios.distribution_certificate": "Certificado de distribuição",
    "Distribution certificate": "Certificado de distribuição",
    "integrations.ios.provisioning_profile": "Perfil de provisionamento de distribuição",
    "Distribution provisioning profile": "Perfil de provisionamento de distribuição",
    "integrations.ios.push_key": "Chave de push",
    "Push key": "Chave de push",
    "integrations.ios.app_store_link": "Link da App Store",
    "Your App Store link": "Link da App Store",
    "integrations.ios.app_store_link_placeholder": "Insira o link da App Store do seu aplicativo",
    "Enter your app App Store link": "Insira o link da App Store do seu aplicativo",
    "integrations.firebase.title": "Integração do Firebase",
    "Firebase integration": "Integração do Firebase",
    "integrations.firebase.choose_file": "Escolher arquivo",
    "Choose file": "Escolher arquivo",
    "integrations.firebase.service_account": "Conta de serviço Firebase",
    "Firebase service account": "Conta de serviço Firebase",
    "integrations.firebase.android_json": "Arquivo JSON do aplicativo Android",
    "Android app JSON file": "Arquivo JSON do aplicativo Android",
    "integrations.firebase.ios_plist": "Arquivo plist do aplicativo iOS",
    "iOS app plist file": "Arquivo plist do aplicativo iOS",
    "integrations.firebase.create_project": "Criar projeto Firebase",
    "Create Firebase project": "Criar projeto Firebase",
    "integrations.firebase.create_android": "Criar aplicativo Android",
    "Create Android app": "Criar aplicativo Android",
    "integrations.firebase.create_ios": "Criar aplicativo iOS",
    "Create iOS app": "Criar aplicativo iOS",
    "integrations.firebase.create_database": "Criar banco de dados em tempo real",
    "Create realtime database": "Criar banco de dados em tempo real",
    "integrations.firebase.apply_rules": "Aplicar regras de banco de dados Firebase",
    "Apply Firebase database rules": "Aplicar regras de banco de dados Firebase",
    "bundles.listing_number": "Listagem #{id}",
    "Listing #{id}": "Listagem #{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Configurar pacote",
    "Configure bundle": "Configurar pacote",
    "bundles.configure.subtitle": "Lista de pacotes # {id} · adicione listagens existentes abaixo.",
    "Bundle listing #{id} · add existing listings below.": "Lista de pacotes # {id} · adicione listagens existentes abaixo.",
    "bundles.back": "Voltar para pacotes",
    "Back to bundles": "Voltar para pacotes",
    "bundles.fixed_components": "Componentes fixos",
    "Fixed components": "Componentes fixos",
    "bundles.selection_pool": "Piscina de mistura e combinação",
    "Mix-and-match pool": "Piscina de mistura e combinação",
    "bundles.available_listings": "Listagens disponíveis",
    "Available listings": "Listagens disponíveis",
    "bundles.available_description": "Pesquise e adicione produtos já em seu catálogo.",
    "Search and add products already in your catalogue.": "Pesquise e adicione produtos já em seu catálogo.",
    "bundles.search_listings": "Pesquisar listagens",
    "Search listings": "Pesquisar listagens",
    "bundles.quantity_per_component": "Quantidade por componente",
    "Quantity per component": "Quantidade por componente",
    "bundles.loading_listings": "Carregando listagens…",
    "Loading listings…": "Carregando listagens…",
    "bundles.added": "Adicionado",
    "Added": "Adicionado",
    "bundles.adding": "Adicionando…",
    "Adding…": "Adicionando…",
    "bundles.add": "Adicionar",
    "bundles.no_matching_listings": "Nenhuma listagem correspondente encontrada.",
    "No matching listings found.": "Nenhuma listagem correspondente encontrada.",
    "bundles.one_listing_added": "1 listagem adicionada",
    "1 listing added": "1 listagem adicionada",
    "bundles.many_listings_added": "{count} listagens adicionadas",
    "{count} listings added": "{count} listagens adicionadas",
    "bundles.quantity_short": "Qtde. {count}",
    "Qty {count}": "Qtde. {count}",
    "bundles.removing": "Removendo…",
    "Removing…": "Removendo…",
    "bundles.remove": "Remover",
    "bundles.no_components": "Nenhum componente adicionado ainda.",
    "No components added yet.": "Nenhum componente adicionado ainda.",
    "bundles.pool_remove_note": "A remoção da piscina requer o endpoint de exclusão do backend; as adições estão habilitadas agora.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "A remoção da piscina requer o endpoint de exclusão do backend; as adições estão habilitadas agora.",
    "bundles.error.load_components": "Não é possível carregar os componentes do pacote.",
    "Unable to load bundle components.": "Não é possível carregar os componentes do pacote.",
    "bundles.error.add_listing": "Não é possível adicionar a listagem ao pacote.",
    "Unable to add listing to the bundle.": "Não é possível adicionar a listagem ao pacote.",
    "bundles.error.remove_component": "Não é possível remover o componente do pacote.",
    "Unable to remove bundle component.": "Não é possível remover o componente do pacote.",
    "bundles.error.load_listings": "Não é possível carregar as listagens.",
    "Unable to load listings.": "Não é possível carregar as listagens.",
    "bundles.components": "Componentes do pacote",
    "Bundle components": "Componentes do pacote",
    "bundles.picker_description": "Selecione listagens que já existem em seu catálogo. Elas serão vinculadas após a criação do pacote.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Selecione listagens que já existem em seu catálogo. Elas serão vinculadas após a criação do pacote.",
    "bundles.fixed_bundle": "Pacote fixo",
    "Fixed bundle": "Pacote fixo",
    "bundles.mix_match": "Misture e combine",
    "Mix and match": "Misture e combine",
    "bundles.quantity_per_selected": "Quantidade por listagem selecionada",
    "Quantity per selected listing": "Quantidade por listagem selecionada",
    "bundles.search_existing": "Pesquisar listagens existentes",
    "Search existing listings": "Pesquisar listagens existentes",
    "bundles.selected_count": "Selecionados ({count})",
    "Selected ({count})": "Selecionados ({count})",
    "bundles.choose_component_hint": "Escolha pelo menos uma listagem existente ou crie o pacote primeiro.",
    "Choose at least one existing listing, or create the bundle first.": "Escolha pelo menos uma listagem existente ou crie o pacote primeiro.",
    "bundles.error.attach_components": "O pacote foi criado, mas os componentes não puderam ser anexados.",
    "The bundle was created, but components could not be attached.": "O pacote foi criado, mas os componentes não puderam ser anexados.",
    "bundles.continue_configure_hint": "Você pode continuar da página de configuração do pacote.",
    "You can continue from the bundle configuration page.": "Você pode continuar da página de configuração do pacote.",
    "bundles.title": "Pacotes",
    "bundles.create": "Criar pacote",
    "Create bundle": "Criar pacote",
    "bundles.subtitle": "Crie uma listagem de pacote principal, depois anexe componentes fixos ou um grupo de seleção mista.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Crie uma listagem de pacote principal, depois anexe componentes fixos ou um grupo de seleção mista.",
    "bundles.workflow": "Fluxo de trabalho do pacote",
    "Bundle workflow": "Fluxo de trabalho do pacote",
    "bundles.how_it_works": "Como os pacotes funcionam",
    "How bundles work": "Como os pacotes funcionam",
    "bundles.parent_description": "Uma única listagem principal controla o pacote visível ao cliente.",
    "One parent listing controls the customer-facing bundle.": "Uma única listagem principal controla o pacote visível ao cliente.",
    "bundles.flow": "Fluxo do pacote",
    "Bundle flow": "Fluxo do pacote",
    "bundles.parent_listing": "Listagem principal",
    "Parent listing": "Listagem principal",
    "bundles.name_price_category": "Nome, preço, categoria",
    "Name, price, category": "Nome, preço, categoria",
    "bundles.fixed_or_pool": "Itens fixos ou um grupo",
    "Fixed items or a pool": "Itens fixos ou um grupo",
    "bundles.checkout_stock": "Estoque no checkout",
    "Checkout stock": "Estoque no checkout",
    "bundles.selection_availability": "Seleção + disponibilidade",
    "Selection + availability": "Seleção + disponibilidade",
    "bundles.fixed_bundles": "Pacotes fixos",
    "Fixed bundles": "Pacotes fixos",
    "bundles.fixed_description": "Venda um grupo definido de listagens existentes juntas.",
    "Sell a defined group of existing listings together.": "Venda um grupo definido de listagens existentes juntas.",
    "bundles.fixed_detail": "Adicionar listagens existentes como componentes fixos.",
    "Add existing listings as fixed components.": "Adicionar listagens existentes como componentes fixos.",
    "bundles.pool_description": "Permita que os clientes escolham itens elegíveis de um pool de pacotes.",
    "Let customers choose eligible items from a bundle pool.": "Permita que os clientes escolham itens elegíveis de um pool de pacotes.",
    "bundles.pool_detail": "Defina o mínimo e máximo de seleções no checkout.",
    "Set the minimum and maximum selections at checkout.": "Defina o mínimo e máximo de seleções no checkout.",
    "channels.opensource.title": "Kits iniciais de código aberto",
    "Open-source starter kits": "Kits iniciais de código aberto",
    "channels.opensource.view_org": "Ver organização do GitHub",
    "View GitHub organization": "Ver organização do GitHub",
    "channels.opensource.description": "Explore repositórios de código aberto Tradly e kits iniciais da organização TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Explore repositórios de código aberto Tradly e kits iniciais da organização TRADLY-PLATFORM.",
    "channels.opensource.loading": "Carregando repositórios…",
    "Loading repositories…": "Carregando repositórios…",
    "channels.opensource.error.http": "GitHub retornou {status}.",
    "GitHub returned {status}.": "GitHub retornou {status}.",
    "channels.opensource.error.load": "Não é possível carregar repositórios. Tente novamente mais tarde.",
    "Unable to load repositories. Try again later.": "Não é possível carregar repositórios. Tente novamente mais tarde.",
    "channels.opensource.empty": "Nenhum repositório público encontrado.",
    "No public repositories found.": "Nenhum repositório público encontrado.",
    "channels.opensource.repo_fallback": "Repositório de código aberto Tradly.",
    "Open-source Tradly repository.": "Repositório de código aberto Tradly.",
    "channels.opensource.language_code": "Código",
    "channels.opensource.view_repo": "Ver repositório",
    "View repository": "Ver repositório",
    "developer.mcp.select_all": "Selecionar tudo",
    "Select all": "Selecionar tudo",
    "developer.mcp.read": "Ler",
    "developer.mcp.write": "Escrever",
    "developer.mcp.delete": "Excluir",
    "developer.mcp.export": "Exportar",
    "developer.mcp.copy": "Copiar",
    "Copy": "Copiar",
    "developer.mcp.copied": "Copiado",
    "Copied": "Copiado",
    "developer.mcp.connection_created": "Conexão criada",
    "Connection created": "Conexão criada",
    "developer.mcp.save_secret_warning": "Salve sua chave secreta do cliente agora — ela não será exibida novamente.",
    "Save your client secret now — it will not be shown again.": "Salve sua chave secreta do cliente agora — ela não será exibida novamente.",
    "developer.mcp.client_id": "ID do cliente",
    "developer.mcp.client_secret": "Segredo do cliente",
    "Client secret": "Segredo do cliente",
    "developer.mcp.new_connection": "Nova conexão MCP",
    "New MCP connection": "Nova conexão MCP",
    "developer.mcp.platform": "Plataforma",
    "Platform": "Plataforma",
    "developer.mcp.platform_custom": "Personalizado",
    "developer.mcp.connection_name": "Nome da conexão",
    "Connection name": "Nome da conexão",
    "developer.mcp.connection_name_placeholder": "ex. ChatGPT",
    "e.g. ChatGPT": "ex. ChatGPT",
    "developer.mcp.redirect_uris": "URIs de redirecionamento",
    "Redirect URIs": "URIs de redirecionamento",
    "developer.mcp.one_per_line": "(um por linha)",
    "(one per line)": "(um por linha)",
    "developer.mcp.permissions": "Permissões",
    "Permissions": "Permissões",
    "developer.mcp.error.connection_name": "Insira um nome de conexão",
    "Enter a connection name": "Insira um nome de conexão",
    "developer.mcp.error.redirect_uri": "Insira pelo menos uma URI de redirecionamento",
    "Enter at least one redirect URI": "Insira pelo menos uma URI de redirecionamento",
    "developer.mcp.error.create": "Falha ao criar conexão",
    "Failed to create connection": "Falha ao criar conexão",
    "developer.mcp.creating": "Criando…",
    "Creating…": "Criando…",
    "developer.mcp.edit_permissions": "Editar permissões",
    "Edit permissions": "Editar permissões",
    "developer.mcp.permissions_updated": "Permissões atualizadas",
    "Permissions updated": "Permissões atualizadas",
    "developer.mcp.error.update_permissions": "Falha ao atualizar permissões",
    "Failed to update permissions": "Falha ao atualizar permissões",
    "developer.mcp.saving": "Salvando…",
    "developer.mcp.error.load": "Conexões MCP não puderam ser carregadas.",
    "MCP connections could not be loaded.": "Conexões MCP não puderam ser carregadas.",
    "developer.mcp.confirm_delete": "Excluir esta conexão? Ela será removida da lista e seus acessos revogados.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Excluir esta conexão? Ela será removida da lista e seus acessos revogados.",
    "developer.mcp.connection_removed": "Conexão excluída",
    "Connection removed": "Conexão excluída",
    "developer.mcp.error.remove_connection": "Falha ao excluir conexão",
    "Failed to remove connection": "Falha ao excluir conexão",
    "developer.mcp.connection_deactivated": "Conexão desativada",
    "Connection deactivated": "Conexão desativada",
    "developer.mcp.error.deactivate_connection": "Falha ao desativar conexão",
    "Failed to deactivate connection": "Falha ao desativar conexão",
    "developer.mcp.title": "Conexões MCP",
    "MCP connections": "Conexões MCP",
    "developer.mcp.description": "Clientes OAuth registrados no tenant e aplicativos de IA autorizados a usar o servidor MCP deste tenant.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Clientes OAuth registrados no tenant e aplicativos de IA autorizados a usar o servidor MCP deste tenant.",
    "developer.mcp.empty": "Nenhuma conexão ainda. Crie um cliente ou conecte um aplicativo de IA ao servidor MCP deste inquilino.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Nenhuma conexão ainda. Crie um cliente ou conecte um aplicativo de IA ao servidor MCP deste inquilino.",
    "developer.mcp.status.connected_one": "Conectado · 1 usuário",
    "Connected · 1 user": "Conectado · 1 usuário",
    "developer.mcp.status.connected_many": "Conectado · {count} usuários",
    "Connected · {count} users": "Conectado · {count} usuários",
    "developer.mcp.status.deactivated": "Desativado",
    "Deactivated": "Desativado",
    "developer.mcp.status.previously_connected": "Conectado anteriormente",
    "Previously connected": "Conectado anteriormente",
    "developer.mcp.status.registered": "Registrado · não conectado",
    "Registered · not connected": "Registrado · não conectado",
    "developer.mcp.oauth_app": "Aplicativo OAuth",
    "OAuth app": "Aplicativo OAuth",
    "developer.mcp.created": "Criado",
    "developer.mcp.updated": "Atualizado",
    "Updated": "Atualizado",
    "developer.mcp.edit_scopes": "Editar escopos",
    "Edit scopes": "Editar escopos",
    "developer.mcp.edit_scopes_for": "Editar escopos para {name}",
    "Edit scopes for {name}": "Editar escopos para {name}",
    "developer.mcp.deactivate_hint": "Desativar (mantém listado e registrado)",
    "Deactivate (keeps it listed and logged)": "Desativar (mantém listado e registrado)",
    "developer.mcp.deactivate_named": "Desativar {name}",
    "Deactivate {name}": "Desativar {name}",
    "developer.mcp.delete_connection": "Excluir conexão",
    "Delete connection": "Excluir conexão",
    "developer.mcp.delete_named": "Excluir {name}",
    "Delete {name}": "Excluir {name}",
    "developer.mcp.resource.listings": "Listagens",
    "developer.mcp.resource.orders": "Pedidos",
    "developer.mcp.resource.users": "Usuários",
    "developer.mcp.resource.accounts": "Contas",
    "developer.mcp.resource.categories": "Categorias",
    "developer.mcp.resource.attributes": "Atributos",
    "developer.mcp.resource.analytics": "Analíticas",
    "developer.mcp.resource.attribution": "Atribuição",
    "Attribution": "Atribuição",
    "developer.mcp.resource.rewards": "Recompensas",
    "developer.mcp.resource.layers": "Camadas / CMS",
    "Layers / CMS": "Camadas / CMS",
    "developer.mcp.resource.settings": "Configurações da loja",
    "Store settings": "Configurações da loja",
    "developer.mcp.resource.marketing": "Marketing",
    "developer.mcp.resource.market_research": "Pesquisa de mercado",
    "Market research": "Pesquisa de mercado",
    "developer.mcp.resource.audiences": "Público-alvo de marketing",
    "Marketing audiences": "Público-alvo de marketing",
    "developer.mcp.resource.agents": "Agentes de IA",
    "developer.mcp.resource.assets": "Envio de arquivos",
    "File uploads": "Envio de arquivos",
    "developer.mcp.resource.workforce": "Força de trabalho",
    "developer.mcp.resource.inventory": "Inventário",
    "developer.mcp.resource.memberships": "Membros",
    "Memberships": "Membros",
    "developer.mcp.resource.bundles": "Pacotes",
    "developer.mcp.resource.rentals": "Aluguéis",
    "Rentals": "Aluguéis",
    "developer.mcp.resource.accounting": "Contabilidade",
    "developer.mcp.nav.label": "Navegação MCP",
    "MCP navigation": "Navegação MCP",
    "developer.mcp.nav.connections": "Conexões",
    "Connections": "Conexões",
    "developer.mcp.nav.logs": "Registros",
    "Logs": "Registros",
    "developer.mcp.unknown_provider": "Provedor desconhecido",
    "Unknown provider": "Provedor desconhecido",
    "developer.mcp.tenant_user": "Inquilino #{tenant} · Usuário #{user}",
    "Tenant #{tenant} · User #{user}": "Inquilino #{tenant} · Usuário #{user}",
    "developer.mcp.logs.title": "Registros MCP",
    "MCP logs": "Registros MCP",
    "developer.mcp.logs.heading": "Atividade recente de agentes",
    "Recent agent activity": "Atividade recente de agentes",
    "developer.mcp.logs.description": "Mostrando os eventos MCP deste inquilino. A visualização de atividade é atualizada a cada 15 segundos.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Mostrando os eventos MCP deste inquilino. A visualização de atividade é atualizada a cada 15 segundos.",
    "developer.mcp.logs.error.audit": "Não foi possível carregar os registros de auditoria MCP.",
    "MCP audit logs could not be loaded.": "Não foi possível carregar os registros de auditoria MCP.",
    "developer.mcp.logs.error.load": "Não foi possível carregar os registros MCP.",
    "MCP logs could not be loaded.": "Não foi possível carregar os registros MCP.",
    "developer.mcp.logs.unknown_agent": "Agente desconhecido",
    "Unknown agent": "Agente desconhecido",
    "developer.mcp.logs.all_agents": "Todos os agentes",
    "All agents": "Todos os agentes",
    "developer.mcp.logs.updated": "Atualizado {time}",
    "Updated {time}": "Atualizado {time}",
    "developer.mcp.logs.loading": "Carregando atividade MCP…",
    "Loading MCP activity…": "Carregando atividade MCP…",
    "developer.mcp.logs.empty": "Nenhum evento MCP recente encontrado para este inquilino.",
    "No recent MCP events found for this tenant.": "Nenhum evento MCP recente encontrado para este inquilino.",
    "developer.mcp.logs.empty_agent": "Nenhum evento MCP recente encontrado para este inquilino e agente.",
    "No recent MCP events found for this tenant and agent.": "Nenhum evento MCP recente encontrado para este inquilino e agente.",
    "developer.mcp.logs.time": "Hora",
    "developer.mcp.logs.event": "Evento",
    "developer.mcp.logs.tool": "Ferramenta",
    "developer.mcp.logs.agent": "Agente",
    "Agent": "Agente",
    "developer.mcp.logs.tenant_user": "Inquilino / usuário",
    "Tenant / user": "Inquilino / usuário",
    "developer.mcp.logs.scope": "Escopo",
    "Scope": "Escopo",
    "developer.mcp.logs.result": "Resultado",
    "Result": "Resultado",
    "developer.mcp.logs.duration": "Duração",
    "Duration": "Duração",
    "developer.mcp.logs.view_details": "Ver detalhes de {event}",
    "View details for {event}": "Ver detalhes de {event}",
    "developer.mcp.logs.tenant": "Inquilino #{id}",
    "Tenant #{id}": "Inquilino #{id}",
    "developer.mcp.logs.user": "Usuário #{id}",
    "User #{id}": "Usuário #{id}",
    "developer.mcp.logs.view_granted_scopes": "Ver escopos concedidos",
    "View granted scopes": "Ver escopos concedidos",
    "developer.mcp.logs.succeeded": "Sucesso",
    "Succeeded": "Sucesso",
    "developer.mcp.logs.failed": "Falha",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "Detalhes do evento MCP",
    "MCP event details": "Detalhes do evento MCP",
    "developer.mcp.logs.required_scope": "Escopo requerido",
    "Required scope": "Escopo requerido",
    "developer.mcp.logs.granted_scopes": "Escopos concedidos",
    "Granted scopes": "Escopos concedidos",
    "developer.mcp.logs.event_generic": "Evento genérico",
    "developer.mcp.logs.event.tool_called": "Ferramenta chamada",
    "Tool called": "Ferramenta chamada",
    "developer.mcp.logs.event.connection_requested": "Conexão solicitada",
    "Connection requested": "Conexão solicitada",
    "developer.mcp.logs.event.connection_connected": "Conexão estabelecida",
    "Connection connected": "Conexão estabelecida",
    "developer.mcp.logs.event.connection_deactivated": "Conexão desativada",
    "developer.mcp.logs.event.connection_deleted": "Conexão excluída",
    "Connection deleted": "Conexão excluída",
    "developer.mcp.logs.event.permissions_updated": "Permissões atualizadas",
    "common.status.label": "Status",
    "suppliers.title": "Fornecedores",
    "suppliers.search": "Buscar fornecedores",
    "Search suppliers": "Buscar fornecedores",
    "suppliers.add": "Adicionar fornecedor",
    "Add supplier": "Adicionar fornecedor",
    "suppliers.deactivate": "Desativar",
    "Deactivate": "Desativar",
    "suppliers.empty": "Nenhum fornecedor encontrado.",
    "No suppliers found.": "Nenhum fornecedor encontrado.",
    "suppliers.add_title": "Adicionar fornecedor",
    "suppliers.edit_title": "Editar fornecedor",
    "Edit supplier": "Editar fornecedor",
    "suppliers.save_changes": "Salvar alterações",
    "Save changes": "Salvar alterações",
    "suppliers.confirm_deactivate": "Desativar {name}?",
    "Deactivate {name}?": "Desativar {name}?",
    "suppliers.toast.updated": "Fornecedor atualizado",
    "Supplier updated": "Fornecedor atualizado",
    "suppliers.toast.added": "Fornecedor adicionado",
    "Supplier added": "Fornecedor adicionado",
    "suppliers.toast.deactivated": "Fornecedor desativado",
    "Supplier deactivated": "Fornecedor desativado",
    "suppliers.column.name": "Nome",
    "suppliers.column.code": "Código",
    "suppliers.column.contact": "Contato",
    "Contact": "Contato",
    "suppliers.field.name": "Nome",
    "suppliers.field.code": "Código",
    "suppliers.field.contact_name": "Nome do contato",
    "Contact name": "Nome do contato",
    "suppliers.field.email": "E-mail",
    "suppliers.field.phone": "Telefone",
    "suppliers.field.currency": "Moeda",
    "suppliers.field.payment_terms": "Condições de pagamento",
    "Payment terms": "Condições de pagamento",
    "suppliers.field.address": "Endereço",
    "suppliers.field.note": "Observação",
    "suppliers.placeholder.name": "Nome da empresa ou fornecedor",
    "Company or supplier name": "Nome da empresa ou fornecedor",
    "suppliers.placeholder.code": "Código do fornecedor",
    "Supplier code": "Código do fornecedor",
    "suppliers.placeholder.contact_name": "Nome do contato",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Pagamento na entrega",
    "Cash on delivery": "Pagamento na entrega",
    "suppliers.payment_terms.payment_on_receipt": "Pagamento ao receber",
    "Payment on receipt": "Pagamento ao receber",
    "suppliers.payment_terms.payment_in_advance": "Pagamento antecipado",
    "Payment in advance": "Pagamento antecipado",
    "suppliers.payment_terms.net_7": "Neto 7 dias",
    "Net 7 days": "Neto 7 dias",
    "suppliers.payment_terms.net_15": "Neto 15 dias",
    "Net 15 days": "Neto 15 dias",
    "suppliers.payment_terms.net_30": "Neto 30 dias",
    "Net 30 days": "Neto 30 dias",
    "suppliers.payment_terms.net_45": "Neto 45 dias",
    "Net 45 days": "Neto 45 dias",
    "suppliers.payment_terms.net_60": "Neto 60 dias",
    "Net 60 days": "Neto 60 dias",
    "suppliers.detail_title": "Detalhes do fornecedor",
    "Supplier details": "Detalhes do fornecedor",
    "suppliers.edit": "Editar fornecedor",
    "suppliers.back": "Voltar para fornecedores",
    "Back to suppliers": "Voltar para fornecedores",
    "suppliers.loading": "Carregando fornecedor…",
    "Loading supplier…": "Carregando fornecedor…",
    "suppliers.unnamed": "Fornecedor sem nome",
    "Unnamed supplier": "Fornecedor sem nome",
    "suppliers.profile_description": "Perfil e informações de contato do fornecedor",
    "Supplier profile and contact information": "Perfil e informações de contato do fornecedor",
    "suppliers.total_spend": "Gasto total",
    "Total spend": "Gasto total",
    "suppliers.outstanding": "Pendente",
    "Outstanding": "Pendente",
    "suppliers.paid": "Pago",
    "suppliers.draft": "Rascunho",
    "suppliers.purchase_history": "Histórico de compras",
    "Purchase history": "Histórico de compras",
    "suppliers.bill.reference": "Referência",
    "Reference": "Referência",
    "suppliers.bill.date": "Data",
    "suppliers.bill.amount": "Valor",
    "suppliers.bill.number": "Fatura #{id}",
    "Bill #{id}": "Fatura #{id}",
    "suppliers.bills_empty": "Nenhuma fatura encontrada para este fornecedor.",
    "No bills found for this supplier.": "Nenhuma fatura encontrada para este fornecedor.",
    "inventory.locations.title": "Localizações",
    "inventory.locations.add": "Adicionar localização",
    "Add location": "Adicionar localização",
    "inventory.locations.description": "Armazéns e lojas que armazenam estoque. Pedidos de compra são recebidos em uma localização.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Armazéns e lojas que armazenam estoque. Pedidos de compra são recebidos em uma localização.",
    "inventory.locations.field.name": "Nome",
    "inventory.locations.field.code": "Código",
    "inventory.locations.field.address": "Endereço",
    "inventory.locations.field.linked_store": "Loja vinculada (opcional)",
    "Linked store (optional)": "Loja vinculada (opcional)",
    "inventory.locations.field.linked_store_short": "Loja vinculada",
    "Linked store": "Loja vinculada",
    "inventory.locations.placeholder.name": "Armazém principal",
    "Main warehouse": "Armazém principal",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Pesquisar um endereço ou local",
    "Search an address or place": "Pesquisar um endereço ou local",
    "inventory.locations.placeholder.linked_store": "Pesquisar contas de vendedor ou loja",
    "Search seller or store accounts": "Pesquisar contas de vendedor ou loja",
    "inventory.locations.confirm_deactivate": "Desativar {name}? Não estará mais disponível para novos pedidos de compra.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Desativar {name}? Não estará mais disponível para novos pedidos de compra.",
    "inventory.locations.toast.deactivated": "Localização desativada",
    "Location deactivated": "Localização desativada",
    "inventory.locations.deactivate": "Desativar",
    "inventory.locations.empty": "Nenhuma localização ainda. Adicione um armazém ou loja para começar a receber estoque.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Nenhuma localização ainda. Adicione um armazém ou loja para começar a receber estoque.",
    "inventory.locations.edit_title": "Editar localização",
    "Edit location": "Editar localização",
    "inventory.locations.add_title": "Adicionar localização",
    "inventory.locations.form_description": "Vincule uma conta de loja apenas se esta localização pertencer a um vendedor específico.",
    "Link a store account only if this location belongs to a specific seller.": "Vincule uma conta de loja apenas se esta localização pertencer a um vendedor específico.",
    "inventory.locations.save_changes": "Salvar alterações",
    "inventory.locations.toast.updated": "Localização atualizada",
    "Location updated": "Localização atualizada",
    "inventory.locations.toast.added": "Localização adicionada",
    "Location added": "Localização adicionada",
    "inventory.operations.title": "Operações de estoque",
    "Inventory operations": "Operações de estoque",
    "inventory.operations.tab.movements": "Histórico de movimentações",
    "Movement history": "Histórico de movimentações",
    "inventory.operations.tab.batches": "Lotes e validade",
    "Batches & expiry": "Lotes e validade",
    "inventory.operations.tab.transfers": "Pedidos de transferência",
    "Transfer orders": "Pedidos de transferência",
    "inventory.operations.tab.requisitions": "Requisições",
    "Requisitions": "Requisições",
    "inventory.operations.tab.receipts": "Mercadorias recebidas",
    "Goods received": "Mercadorias recebidas",
    "inventory.operations.description.movements": "Um registro imutável de cada recebimento, venda, transferência, devolução e ajuste.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Um registro imutável de cada recebimento, venda, transferência, devolução e ajuste.",
    "inventory.operations.description.batches": "Rastreie lotes, datas de validade, condição e unidades sem alterar o livro de estoque aqui.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Rastreie lotes, datas de validade, condição e unidades sem alterar o livro de estoque aqui.",
    "inventory.operations.description.transfers": "Mova estoque entre localizações com rastreamento seguro de status contra discrepâncias em despacho, recebimento e discrepâncias.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Mova estoque entre localizações com rastreamento seguro de status contra discrepâncias em despacho, recebimento e discrepâncias.",
    "inventory.operations.description.requisitions": "Revise as solicitações internas de estoque. A aprovação cria automaticamente um pedido de transferência.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Revise as solicitações internas de estoque. A aprovação cria automaticamente um pedido de transferência.",
    "inventory.operations.description.receipts": "Crie recibos e rastreie trabalhos abertos, parciais e fechados de recebimento.",
    "Create receipts and track open, partial, and closed receiving work.": "Crie recibos e rastreie trabalhos abertos, parciais e fechados de recebimento.",
    "inventory.operations.overview": "Visão geral",
    "inventory.operations.new_transfer": "Nova transferência",
    "New transfer": "Nova transferência",
    "inventory.operations.new_requisition": "Nova requisição",
    "New requisition": "Nova requisição",
    "inventory.operations.new_receipt": "Novo recebimento",
    "New receipt": "Novo recebimento",
    "inventory.operations.search": "Pesquisar",
    "inventory.operations.search_view": "Pesquisar nesta vista",
    "Search this view": "Pesquisar nesta vista",
    "inventory.operations.search_products": "Pesquisar produtos",
    "Search products": "Pesquisar produtos",
    "inventory.operations.search_purchase_order": "Pesquisar pedidos de compra (opcional)",
    "Search purchase orders (optional)": "Pesquisar pedidos de compra (opcional)",
    "inventory.operations.listing_number": "Listagem #{id}",
    "inventory.operations.location_number": "Localização #{id}",
    "inventory.operations.no_sku": "Sem SKU",
    "No SKU": "Sem SKU",
    "inventory.operations.order_status": "Status: {status}",
    "Status: {status}": "Status: {status}",
    "inventory.operations.field.receiving_location": "Localização de recebimento",
    "Receiving location": "Localização de recebimento",
    "inventory.operations.field.purchase_order": "Pedido de compra",
    "Purchase order": "Pedido de compra",
    "inventory.operations.field.reference": "Referência",
    "inventory.operations.field.note": "Nota",
    "inventory.operations.field.from_location": "Localização de origem",
    "From location": "Localização de origem",
    "inventory.operations.field.supplying_location": "Localização de fornecimento",
    "Supplying location": "Localização de fornecimento",
    "inventory.operations.field.to_location": "Localização de destino",
    "To location": "Localização de destino",
    "inventory.operations.field.requesting_location": "Localização de solicitação",
    "Requesting location": "Localização de solicitação",
    "inventory.operations.field.product": "Produto",
    "Product": "Produto",
    "inventory.operations.field.quantity": "Quantidade",
    "Quantity": "Quantidade",
    "inventory.operations.field.location": "Localização",
    "inventory.operations.placeholder.delivery_note": "Nota de entrega do fornecedor",
    "Supplier delivery note": "Nota de entrega do fornecedor",
    "inventory.operations.placeholder.receiving_note": "Nota de recebimento opcional",
    "Optional receiving note": "Nota de recebimento opcional",
    "inventory.operations.placeholder.transfer_reference": "Referência de transferência",
    "Transfer reference": "Referência de transferência",
    "inventory.operations.placeholder.request_reference": "Referência de solicitação",
    "Request reference": "Referência de solicitação",
    "inventory.operations.placeholder.context": "Contexto opcional",
    "Optional context": "Contexto opcional",
    "inventory.operations.create.transfer_title": "Nova ordem de transferência",
    "New transfer order": "Nova ordem de transferência",
    "inventory.operations.create.requisition_title": "Nova requisição",
    "inventory.operations.create.receipt_title": "Nova recepção de mercadorias",
    "New goods receipt": "Nova recepção de mercadorias",
    "inventory.operations.create.transfer_description": "Mover estoque entre dois locais.",
    "Move stock between two locations.": "Mover estoque entre dois locais.",
    "inventory.operations.create.requisition_description": "Solicitar estoque de outro local.",
    "Request stock from another location.": "Solicitar estoque de outro local.",
    "inventory.operations.create.receipt_description": "Crie uma recepção antes de escanear ou adicionar caixas.",
    "Create a receipt before scanning or adding boxes.": "Crie uma recepção antes de escanear ou adicionar caixas.",
    "inventory.operations.toast.transfer_created": "Ordem de transferência criada",
    "Transfer order created": "Ordem de transferência criada",
    "inventory.operations.toast.requisition_created": "Requisição criada",
    "Requisition created": "Requisição criada",
    "inventory.operations.toast.receipt_created": "Recepção de mercadorias criada",
    "Goods receipt created": "Recepção de mercadorias criada",
    "inventory.operations.toast.transfer_dispatched": "Transferência despachada",
    "Transfer dispatched": "Transferência despachada",
    "inventory.operations.toast.transfer_received": "Transferência recebida",
    "Transfer received": "Transferência recebida",
    "inventory.operations.toast.transfer_cancelled": "Transferência cancelada",
    "Transfer cancelled": "Transferência cancelada",
    "inventory.operations.toast.requisition_approved": "Requisição aprovada",
    "Requisition approved": "Requisição aprovada",
    "inventory.operations.toast.requisition_rejected": "Requisição rejeitada",
    "Requisition rejected": "Requisição rejeitada",
    "inventory.operations.action.dispatch": "Enviar",
    "Dispatch": "Enviar",
    "inventory.operations.action.receive": "Receber",
    "Receive": "Receber",
    "inventory.operations.action.approve": "Aprovar",
    "Approve": "Aprovar",
    "inventory.operations.action.reject": "Rejeitar",
    "Reject": "Rejeitar",
    "inventory.operations.column.when": "Quando",
    "When": "Quando",
    "inventory.operations.column.event": "Evento",
    "inventory.operations.column.change": "Mudança",
    "inventory.operations.column.after": "Depois",
    "After": "Depois",
    "inventory.operations.column.order": "Ordem",
    "inventory.operations.column.route": "Rota",
    "Route": "Rota",
    "inventory.operations.column.lines": "Linhas",
    "Lines": "Linhas",
    "inventory.operations.column.expected": "Previsto",
    "inventory.operations.column.request": "Solicitação",
    "Request": "Solicitação",
    "inventory.operations.column.request_supply": "Solicitação / suprimento",
    "Request / supply": "Solicitação / suprimento",
    "inventory.operations.column.created": "Criado",
    "inventory.operations.column.receipt": "Recebimento",
    "inventory.operations.empty.movements": "Nenhum movimento de estoque registrado ainda.",
    "No stock movements recorded yet.": "Nenhum movimento de estoque registrado ainda.",
    "inventory.operations.empty.batches": "Nenhum lote de estoque registrado ainda.",
    "No inventory batches have been recorded yet.": "Nenhum lote de estoque registrado ainda.",
    "inventory.operations.empty.transfers": "Nenhuma ordem de transferência ainda.",
    "No transfer orders yet.": "Nenhuma ordem de transferência ainda.",
    "inventory.operations.empty.requisitions": "Nenhuma requisição ainda.",
    "No requisitions yet.": "Nenhuma requisição ainda.",
    "inventory.operations.empty.receipts": "Nenhuma recepção de mercadorias ainda.",
    "No goods receipts yet.": "Nenhuma recepção de mercadorias ainda.",
    "inventory.operations.batch.edit_title": "Editar lote",
    "Edit batch": "Editar lote",
    "inventory.operations.batch.edit_description": "A quantidade do lote é alterada por meio de um ajuste de estoque; este formulário atualiza apenas sua identidade e campos de rastreamento.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "A quantidade do lote é alterada por meio de um ajuste de estoque; este formulário atualiza apenas sua identidade e campos de rastreamento.",
    "inventory.operations.batch.save": "Salvar lote",
    "Save batch": "Salvar lote",
    "inventory.operations.batch.lot_number": "Número do lote",
    "Lot number": "Número do lote",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Data de validade",
    "inventory.operations.batch.condition": "Condição",
    "Condition": "Condição",
    "inventory.operations.batch.condition_placeholder": "bom",
    "good": "bom",
    "inventory.operations.batch.unit": "Unidade de medida",
    "Unit of measure": "Unidade de medida",
    "inventory.operations.batch.unit_placeholder": "caixa, peça, kg",
    "box, piece, kg": "caixa, peça, kg",
    "inventory.operations.batch.no_expiry": "Sem validade",
    "No expiry": "Sem validade",
    "inventory.operations.batch.updated": "Lote atualizado",
    "Batch updated": "Lote atualizado",
    "common.status.in_transit": "Em trânsito",
    "In transit": "Em trânsito",
    "common.status.pending": "Pendente",
    "Pending": "Pendente",
    "common.status.approved": "Aprovado",
    "Approved": "Aprovado",
    "common.status.rejected": "Rejeitado",
    "Rejected": "Rejeitado",
    "common.status.cancelled": "Cancelado",
    "Cancelled": "Cancelado",
    "common.status.received": "Recebido",
    "Received": "Recebido",
    "common.status.sent": "Enviado",
    "Sent": "Enviado",
    "common.note": "Nota",
    "common.optional": "Opcional",
    "Optional": "Opcional",
    "common.error.generic": "Algo deu errado.",
    "Something went wrong.": "Algo deu errado.",
    "purchase_orders.title": "Pedidos de compra",
    "purchase_orders.title_singular": "Pedido de compra",
    "purchase_orders.tab.all": "Todos",
    "purchase_orders.tab.partial": "Parcialmente recebido",
    "Partially received": "Parcialmente recebido",
    "purchase_orders.create.new": "Novo pedido de compra",
    "New purchase order": "Novo pedido de compra",
    "purchase_orders.create.title": "Novo pedido de compra",
    "purchase_orders.create.subtitle": "Salvo como rascunho. Marque como enviado quando estiver com o fornecedor.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Salvo como rascunho. Marque como enviado quando estiver com o fornecedor.",
    "purchase_orders.create.submit": "Criar rascunho",
    "Create draft": "Criar rascunho",
    "purchase_orders.field.location": "Localização de recebimento",
    "purchase_orders.field.supplier": "Fornecedor",
    "Supplier": "Fornecedor",
    "purchase_orders.field.reference": "Referência do fornecedor",
    "Supplier reference": "Referência do fornecedor",
    "purchase_orders.field.expected_delivery": "Entrega esperada",
    "Expected delivery": "Entrega esperada",
    "purchase_orders.field.products": "Produtos",
    "Products": "Produtos",
    "purchase_orders.select_location": "Selecionar localização",
    "Select location": "Selecionar localização",
    "purchase_orders.no_locations": "Nenhuma localização configurada",
    "No locations set up": "Nenhuma localização configurada",
    "purchase_orders.add_location": "Adicione um local primeiro →",
    "Add a location first →": "Adicione um local primeiro →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Todos os locais",
    "purchase_orders.location_number": "Local #{id}",
    "purchase_orders.search_products": "Pesquisar produtos para adicionar",
    "Search products to add": "Pesquisar produtos para adicionar",
    "purchase_orders.in_stock": "Em estoque: {count}",
    "In stock: {count}": "Em estoque: {count}",
    "purchase_orders.column.order": "Pedido",
    "purchase_orders.column.product": "Produto",
    "purchase_orders.column.quantity": "Quantidade",
    "purchase_orders.column.ordered": "Enviados",
    "Ordered": "Enviados",
    "purchase_orders.column.received": "Recebido",
    "purchase_orders.column.remaining": "Pendente",
    "purchase_orders.column.unit_cost": "Custo unitário",
    "Unit cost": "Custo unitário",
    "purchase_orders.column.supplier": "Fornecedor",
    "purchase_orders.column.location": "Local",
    "purchase_orders.column.progress": "Recebido",
    "purchase_orders.column.value": "Valor",
    "purchase_orders.column.expected": "Esperado",
    "purchase_orders.column.status": "Status",
    "purchase_orders.action.mark_sent": "Marcar como enviado",
    "Mark as sent": "Marcar como enviado",
    "purchase_orders.action.receive": "Receber",
    "purchase_orders.action.receive_stock": "Receber estoque",
    "Receive stock": "Receber estoque",
    "purchase_orders.action.cancel_order": "Cancelar pedido",
    "Cancel order": "Cancelar pedido",
    "purchase_orders.action.close_order": "Fechar pedido",
    "Close order": "Fechar pedido",
    "purchase_orders.receive.subtitle": "Insira o que chegou. O estoque no local de recebimento é atualizado ao confirmar.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Insira o que chegou. O estoque no local de recebimento é atualizado ao confirmar.",
    "purchase_orders.receive.now": "Receber agora",
    "Receive now": "Receber agora",
    "purchase_orders.receive.confirm": "Confirmar recebimento",
    "Confirm receipt": "Confirmar recebimento",
    "purchase_orders.confirm.cancel": "Cancelar este pedido de compra?",
    "Cancel this purchase order?": "Cancelar este pedido de compra?",
    "purchase_orders.empty.all": "Ainda não há pedidos de compra. Crie um para reabastecer o estoque.",
    "No purchase orders yet. Create one to restock inventory.": "Ainda não há pedidos de compra. Crie um para reabastecer o estoque.",
    "purchase_orders.empty.filtered": "Não há pedidos de compra com este status.",
    "No purchase orders with this status.": "Não há pedidos de compra com este status.",
    "purchase_orders.error.location_required": "Escolha um local de recebimento.",
    "Choose a receiving location.": "Escolha um local de recebimento.",
    "purchase_orders.error.product_required": "Adicione pelo menos um produto.",
    "Add at least one product.": "Adicione pelo menos um produto.",
    "purchase_orders.error.quantity_positive": "Cada quantidade deve ser maior que 0.",
    "Every quantity must be greater than 0.": "Cada quantidade deve ser maior que 0.",
    "purchase_orders.error.receive_quantity": "Insira uma quantidade para pelo menos um item.",
    "Enter a quantity for at least one item.": "Insira uma quantidade para pelo menos um item.",
    "purchase_orders.toast.created": "Pedido de compra criado como rascunho",
    "Purchase order created as draft": "Pedido de compra criado como rascunho",
    "purchase_orders.toast.sent": "Marcado como enviado",
    "Marked as sent": "Marcado como enviado",
    "purchase_orders.toast.received": "Estoque recebido e inventário atualizado",
    "Stock received and inventory updated": "Estoque recebido e inventário atualizado",
    "purchase_orders.toast.cancelled": "Pedido de compra cancelado",
    "Purchase order cancelled": "Pedido de compra cancelado",
    "purchase_orders.toast.closed": "Pedido de compra fechado",
    "Purchase order closed": "Pedido de compra fechado",
    "schedule.title": "Agenda",
    "schedule.view.month": "Mês",
    "Month": "Mês",
    "schedule.view.week": "Semana",
    "Week": "Semana",
    "schedule.view.day": "Dia",
    "Day": "Dia",
    "schedule.today": "Hoje",
    "Today": "Hoje",
    "schedule.order_number": "Pedido #{number}",
    "Order #{number}": "Pedido #{number}",
    "schedule.customer": "Cliente",
    "schedule.more_events": "+{count} mais",
    "+{count} more": "+{count} mais",
    "schedule.payment.paid": "Pago",
    "schedule.payment.pending": "Pendente",
    "schedule.payment.failed": "Falhou",
    "schedule.booking_details": "Detalhes da reserva",
    "Booking details": "Detalhes da reserva",
    "schedule.order_reference": "Referência do pedido",
    "schedule.amount": "Valor",
    "schedule.start": "Início",
    "schedule.end": "Fim",
    "schedule.item_number": "Item {number}",
    "Item {number}": "Item {number}",
    "schedule.view_order": "Ver pedido completo",
    "View full order": "Ver pedido completo",
    "onboarding.greeting.morning": "Bom dia",
    "Good morning": "Bom dia",
    "onboarding.greeting.morning_named": "Bom dia {name}",
    "Good morning {name}": "Bom dia {name}",
    "onboarding.greeting.afternoon": "Boa tarde",
    "Good afternoon": "Boa tarde",
    "onboarding.greeting.afternoon_named": "Boa tarde {name}",
    "Good afternoon {name}": "Boa tarde {name}",
    "onboarding.greeting.evening": "Boa noite",
    "Good evening": "Boa noite",
    "onboarding.greeting.evening_named": "Boa noite {name}",
    "Good evening {name}": "Boa noite {name}",
    "onboarding.greeting.night": "Olá",
    "Hello": "Olá",
    "onboarding.greeting.night_named": "Olá {name}",
    "Hello {name}": "Olá {name}",
    "onboarding.encouragement": "Construa a plataforma que você desejaria existir.",
    "Build the platform you wish existed.": "Construa a plataforma que você desejaria existir.",
    "onboarding.plan.personalized": "Plano de lançamento personalizado",
    "Personalized launch plan": "Plano de lançamento personalizado",
    "onboarding.plan.label": "Plano de lançamento",
    "Launch plan": "Plano de lançamento",
    "onboarding.plan.refining": "Refinando seu caminho…",
    "Refining your path…": "Refinando seu caminho…",
    "onboarding.plan.getting_ready": "Seu plano personalizado está pronto.",
    "Your personalized plan is getting ready.": "Seu plano personalizado está pronto.",
    "onboarding.checklist.preview": "Prévia da lista de verificação",
    "Checklist preview": "Prévia da lista de verificação",
    "onboarding.workspace.live": "Espaço de trabalho ao vivo",
    "Live workspace": "Espaço de trabalho ao vivo",
    "onboarding.workspace.no_tenant": "Nenhum inquilino conectado ao vivo",
    "No live tenant connected": "Nenhum inquilino conectado ao vivo",
    "onboarding.workspace.domain_pending": "Domínio pendente",
    "Domain pending": "Domínio pendente",
    "onboarding.progress.summary": "{completed} de {total} ações de lançamento concluídas",
    "{completed} of {total} launch actions done": "{completed} de {total} ações de lançamento concluídas",
    "onboarding.progress.auto_detected": "{count} detectados automaticamente",
    "{count} auto-detected": "{count} detectados automaticamente",
    "onboarding.progress.auto_detected_short": "Detectado automaticamente",
    "Auto-detected": "Detectado automaticamente",
    "onboarding.progress.saving": "Salvando progresso…",
    "Saving progress…": "Salvando progresso…",
    "onboarding.progress.checking": "Verificando…",
    "Checking…": "Verificando…",
    "onboarding.progress.mark_done": "Marcar como concluído",
    "Mark done": "Marcar como concluído",
    "onboarding.progress.unlocked": "Desbloqueado: {impact}",
    "Unlocked: {impact}": "Desbloqueado: {impact}",
    "onboarding.next_task": "Próxima tarefa ideal",
    "Next best task": "Próxima tarefa ideal",
    "onboarding.upcoming.title": "Próximas tarefas",
    "Upcoming tasks": "Próximas tarefas",
    "onboarding.upcoming.summary_one": "{count} tarefa programada após a ação atual.",
    "{count} task queued after the current action.": "{count} tarefa programada após a ação atual.",
    "onboarding.upcoming.summary_other": "{count} tarefas programadas após a ação atual.",
    "{count} tasks queued after the current action.": "{count} tarefas programadas após a ação atual.",
    "onboarding.upcoming.hide": "Esconder tarefas",
    "Hide tasks": "Esconder tarefas",
    "onboarding.upcoming.view_all": "Ver todas as tarefas",
    "View all tasks": "Ver todas as tarefas",
    "onboarding.complete.title": "Ótimo início. Sua base está ao vivo.",
    "Great start. Your foundation is live.": "Ótimo início. Sua base está ao vivo.",
    "onboarding.complete.description": "Continue para desbloquear essenciais de crescimento como promoções e comunicações.",
    "Keep going to unlock growth essentials like promotions and communications.": "Continue para desbloquear essenciais de crescimento como promoções e comunicações.",
    "onboarding.full_checklist.title": "Lista completa",
    "Full checklist": "Lista completa",
    "onboarding.full_checklist.description": "Continue a configuração na mesma experiência.",
    "Continue setup in the same experience.": "Continue a configuração na mesma experiência.",
    "onboarding.full_checklist.back": "Voltar para o caminho de lançamento",
    "Back to launch path": "Voltar para o caminho de lançamento",
    "onboarding.completed.title": "Concluído",
    "onboarding.completed.summary_one": "{count} tarefa concluída",
    "{count} task completed": "{count} tarefa concluída",
    "onboarding.completed.summary_other": "{count} tarefas concluídas",
    "{count} tasks completed": "{count} tarefas concluídas",
    "onboarding.completed.open_again": "Abrir novamente",
    "Open again": "Abrir novamente",
    "onboarding.plan.marketplace.eyebrow": "Caminho de lançamento do Marketplace",
    "Marketplace launch path": "Caminho de lançamento do Marketplace",
    "onboarding.plan.marketplace.title": "Lançar seu marketplace",
    "Launch your marketplace": "Lançar seu marketplace",
    "onboarding.plan.marketplace.title_named": "Transforme {project} em um marketplace funcional",
    "Turn {project} into a working marketplace": "Transforme {project} em um marketplace funcional",
    "onboarding.plan.marketplace.subtitle": "Abra o site ao vivo, crie o primeiro anúncio e teste a jornada do comprador.",
    "Open the live site create the first listing and test the buyer journey.": "Abra o site ao vivo, crie o primeiro anúncio e teste a jornada do comprador.",
    "onboarding.plan.marketplace.value_moment": "Primeiro momento de valor: um vendedor pode publicar e um comprador pode agir.",
    "First value moment: a seller can publish and a buyer can act.": "Primeiro momento de valor: um vendedor pode publicar e um comprador pode agir.",
    "onboarding.plan.marketplace.why_title": "Por que as equipes concluem isso?",
    "Why teams finish this": "Por que as equipes concluem isso?",
    "onboarding.plan.marketplace.why_body": "Resultados reais de compradores e vendedores tornam cada próximo passo útil e mantêm o impulso.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Resultados reais de compradores e vendedores tornam cada próximo passo útil e mantêm o impulso.",
    "onboarding.plan.store.eyebrow": "Caminho de lançamento da Loja",
    "Store launch path": "Caminho de lançamento da Loja",
    "onboarding.plan.store.title": "Prepare sua loja para o primeiro pedido",
    "Get your store ready for the first order": "Prepare sua loja para o primeiro pedido",
    "onboarding.plan.store.title_named": "Prepare {project} para o primeiro pedido",
    "Make {project} ready for the first order": "Prepare {project} para o primeiro pedido",
    "onboarding.plan.store.subtitle": "Adicione um produto, verifique a loja e conclua os elementos essenciais do checkout.",
    "Add a product check the storefront and complete checkout essentials.": "Adicione um produto, verifique a loja e conclua os elementos essenciais do checkout.",
    "onboarding.plan.store.value_moment": "Primeiro momento de valor: o produto é visível e o checkout pode ser testado.",
    "First value moment: a product is visible and checkout can be tested.": "Primeiro momento de valor: o produto é visível e o checkout pode ser testado.",
    "onboarding.plan.store.why_title": "Por que as equipes concluem isso?",
    "onboarding.plan.store.why_body": "Mova rapidamente de produto para o checkout para que a loja pareça real e o progresso seja motivador.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Mova rapidamente de produto para o checkout para que a loja pareça real e o progresso seja motivador.",
    "onboarding.plan.booking.eyebrow": "Caminho de lançamento de Reserva",
    "Booking launch path": "Caminho de lançamento de Reserva",
    "onboarding.plan.booking.title": "Torne sua plataforma reservável",
    "Make your platform bookable": "Torne sua plataforma reservável",
    "onboarding.plan.booking.title_named": "Torne {project} reservável",
    "Make {project} bookable": "Torne {project} reservável",
    "onboarding.plan.booking.subtitle": "Crie o primeiro serviço, abra a experiência do cliente e teste uma reserva.",
    "Create the first service open the customer experience and test a reservation.": "Crie o primeiro serviço, abra a experiência do cliente e teste uma reserva.",
    "onboarding.plan.booking.value_moment": "Primeiro momento de valor: um cliente pode solicitar um horário ou slot.",
    "First value moment: a customer can request a time or slot.": "Primeiro momento de valor: um cliente pode solicitar um horário ou slot.",
    "onboarding.plan.booking.why_title": "Por que as equipes concluem isso?",
    "onboarding.plan.booking.why_body": "Valide a jornada completa de reserva desde o início para construir confiança antes de expandir.",
    "Validate the full booking journey early to build confidence before expanding.": "Valide a jornada completa de reserva desde o início para construir confiança antes de expandir.",
    "onboarding.plan.digital.eyebrow": "Caminho de lançamento Digital",
    "Digital launch path": "Caminho de lançamento Digital",
    "onboarding.plan.digital.title": "Comece a vender seus produtos digitais",
    "Start selling your digital products": "Comece a vender seus produtos digitais",
    "onboarding.plan.digital.title_named": "Prepare {project} para vender produtos digitais",
    "Make {project} ready to sell digital products": "Prepare {project} para vender produtos digitais",
    "onboarding.plan.digital.subtitle": "Carregue uma prévia do produto digital, percorra o fluxo do cliente e confirme a prontidão para pagamento.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Carregue uma prévia do produto digital, percorra o fluxo do cliente e confirme a prontidão para pagamento.",
    "onboarding.plan.digital.value_moment": "Primeiro momento de valor: um comprador pode descobrir e comprar um arquivo.",
    "First value moment: a buyer can discover and purchase a file.": "Primeiro momento de valor: um comprador pode descobrir e comprar um arquivo.",
    "onboarding.plan.digital.why_title": "Por que as equipes concluem isso?",
    "onboarding.plan.digital.why_body": "Demonstre descoberta e compra rapidamente para que expandir o catálogo pareça crescimento.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Demonstre descoberta e compra rapidamente para que expandir o catálogo pareça crescimento.",
    "onboarding.plan.campaign.eyebrow": "Caminho para lançar uma campanha",
    "Campaign launch path": "Caminho para lançar uma campanha",
    "onboarding.plan.campaign.title": "Lance sua plataforma de campanha",
    "Launch your campaign platform": "Lance sua plataforma de campanha",
    "onboarding.plan.campaign.title_named": "Prepare {project} para seus apoiadores",
    "Make {project} ready for supporters": "Prepare {project} para seus apoiadores",
    "onboarding.plan.campaign.subtitle": "Crie uma prévia da campanha, revise a página pública e teste o percurso de contribuição.",
    "Create a campaign preview the public page and test the contribution journey.": "Crie uma prévia da campanha, revise a página pública e teste o percurso de contribuição.",
    "onboarding.plan.campaign.value_moment": "Primeiro momento de valor: um apoiador pode entender e contribuir.",
    "First value moment: a supporter can understand and contribute.": "Primeiro momento de valor: um apoiador pode entender e contribuir.",
    "onboarding.plan.campaign.why_title": "Por que as equipes concluem isso?",
    "onboarding.plan.campaign.why_body": "Clarifique a história e o fluxo de contribuição desde o início para que os apoiadores possam confiar e agir.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Clarifique a história e o fluxo de contribuição desde o início para que os apoiadores possam confiar e agir.",
    "onboarding.plan.creator.eyebrow": "Caminho para lançar um criador",
    "Creator launch path": "Caminho para lançar um criador",
    "onboarding.plan.creator.title": "Prepare-se para sua primeira audiência",
    "Get ready for your first audience": "Prepare-se para sua primeira audiência",
    "onboarding.plan.creator.title_named": "Prepare {project} para sua primeira audiência",
    "Make {project} ready for its first audience": "Prepare {project} para sua primeira audiência",
    "onboarding.plan.creator.subtitle": "Publique uma oferta clara, defina a experiência e torne-a fácil de descobrir e apoiar seu trabalho.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Publique uma oferta clara, defina a experiência e torne-a fácil de descobrir e apoiar seu trabalho.",
    "onboarding.plan.creator.value_moment": "Primeiro momento de valor: seu trabalho é visível e pronto para compartilhar.",
    "First value moment: your work is visible and ready to share.": "Primeiro momento de valor: seu trabalho é visível e pronto para compartilhar.",
    "onboarding.plan.creator.why_title": "Por que isso funciona?",
    "Why this works": "Por que isso funciona?",
    "onboarding.plan.creator.why_body": "Concentre-se em publicar algo real antes de adicionar mais ferramentas ou complexidade.",
    "Focus on publishing something real before adding more tools or complexity.": "Concentre-se em publicar algo real antes de adicionar mais ferramentas ou complexidade.",
    "onboarding.step.open_live_site.title": "Abra a experiência ao vivo",
    "onboarding.step.open_live_site.description": "Comece com o que os clientes veem. Isso faz com que o produto pareça real antes que a configuração se torne abstrata.",
    "Start with what customers see. This makes the product feel real before setup becomes abstract.": "Comece com o que os clientes veem. Isso faz com que o produto pareça real antes que a configuração se torne abstrata.",
    "onboarding.step.open_live_site.description_domain": "Abra {domain} e veja o que seus clientes veem. Isso faz com que a construção pareça real antes do próximo passo.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Abra {domain} e veja o que seus clientes veem. Isso faz com que a construção pareça real antes do próximo passo.",
    "onboarding.step.open_live_site.cta": "Abrir site",
    "Open site": "Abrir site",
    "onboarding.step.open_live_site.cta_domain": "Abrir {domain}",
    "Open {domain}": "Abrir {domain}",
    "onboarding.step.open_live_site.impact": "Confirma que o projeto já está ao vivo.",
    "Confirms the project is already live.": "Confirma que o projeto já está ao vivo.",
    "onboarding.step.create_supply_shape.title": "Crie a primeira categoria",
    "onboarding.step.create_supply_shape.description": "Dê aos vendedores e compradores um local claro para começar. Categorias criam estrutura para descoberta.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Dê aos vendedores e compradores um local claro para começar. Categorias criam estrutura para descoberta.",
    "onboarding.step.create_supply_shape.cta": "Adicionar categoria",
    "Add category": "Adicionar categoria",
    "onboarding.step.create_supply_shape.impact": "Transforma um mercado em branco em um navegável.",
    "Turns a blank marketplace into a browsable one.": "Transforma um mercado em branco em um navegável.",
    "onboarding.step.post_first_listing.title": "Publique um anúncio de teste",
    "onboarding.step.post_first_listing.description": "Experimente o caminho do vendedor e publique o primeiro item que os compradores podem inspecionar.",
    "Experience the seller path and publish the first item buyers can inspect.": "Experimente o caminho do vendedor e publique o primeiro item que os compradores podem inspecionar.",
    "onboarding.step.post_first_listing.cta": "Publicar anúncio",
    "Post listing": "Publicar anúncio",
    "onboarding.step.post_first_listing.impact": "Cria o evento central de ativação do mercado.",
    "Creates supply the core marketplace activation event.": "Cria o evento central de ativação do mercado.",
    "onboarding.step.test_buyer_action.title": "Aja como comprador",
    "onboarding.step.test_buyer_action.description": "Navegue, adicione interesse e teste o caminho de pedido para experimentar o que os clientes verão.",
    "Browse add interest and test the order path to experience what customers will see.": "Navegue, adicione interesse e teste o caminho de pedido para experimentar o que os clientes verão.",
    "onboarding.step.test_buyer_action.cta": "Teste o fluxo de comprador",
    "Test buyer flow": "Teste o fluxo de comprador",
    "onboarding.step.test_buyer_action.impact": "Valida a jornada do comprador de ponta a ponta.",
    "Validates the buyer journey end to end.": "Valida a jornada do comprador de ponta a ponta.",
    "onboarding.step.add_first_product.title": "Adicione um produto real",
    "Add one real product": "Adicione um produto real",
    "onboarding.step.add_first_product.description": "Um produto completo ensina ao sistema a forma do seu catálogo melhor do que uma longa visita às configurações.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Um produto completo ensina ao sistema a forma do seu catálogo melhor do que uma longa visita às configurações.",
    "onboarding.step.add_first_product.cta": "Adicionar produto",
    "Add product": "Adicionar produto",
    "onboarding.step.add_first_product.impact": "Cria o primeiro item vendável.",
    "Creates the first sellable item.": "Cria o primeiro item vendável.",
    "onboarding.step.setup_payments.title": "Conectar pagamentos",
    "Connect payments": "Conectar pagamentos",
    "onboarding.step.setup_payments.description": "Habilite transações reais para que os usuários completem compras sem fricção.",
    "Enable real transactions so users can complete purchases without friction.": "Habilite transações reais para que os usuários completem compras sem fricção.",
    "onboarding.step.setup_payments.cta": "Configurar pagamentos",
    "Set up payments": "Configurar pagamentos",
    "onboarding.step.setup_payments.impact": "Desbloqueia o caminho para a receita.",
    "Unlocks the path to revenue.": "Desbloqueia o caminho para a receita.",
    "onboarding.step.setup_delivery.title": "Configure método de envio ou serviço",
    "onboarding.step.setup_delivery.description": "Defina como o pedido será cumprido para que o checkout seja previsível para os usuários.",
    "Define how the order is fulfilled so checkout is predictable for users.": "Defina como o pedido será cumprido para que o checkout seja previsível para os usuários.",
    "onboarding.step.setup_delivery.cta": "Configurar entrega",
    "Configure delivery": "Configurar entrega",
    "onboarding.step.setup_delivery.impact": "Deixa a entrega clara no checkout.",
    "Makes fulfillment clear at checkout.": "Deixa a entrega clara no checkout.",
    "onboarding.step.create_bookable_listing.title": "Crie uma oferta reservável",
    "Create one bookable offer": "Crie uma oferta reservável",
    "onboarding.step.create_bookable_listing.description": "Adicione o evento de serviço, aluguel ou agendamento que os clientes devem reservar primeiro.",
    "Add the service event rental or appointment customers should book first.": "Adicione o evento de serviço, aluguel ou agendamento que os clientes devem reservar primeiro.",
    "onboarding.step.create_bookable_listing.cta": "Criar oferta",
    "Create offer": "Criar oferta",
    "onboarding.step.create_bookable_listing.impact": "Cria a primeira unidade reservável.",
    "Creates the first bookable unit.": "Cria a primeira unidade reservável.",
    "onboarding.step.shape_details.title": "Adicione detalhes de reserva",
    "Add booking details": "Adicione detalhes de reserva",
    "onboarding.step.shape_details.description": "Use categorias e campos para capturar o que os clientes precisam antes de se comprometerem.",
    "Use categories and fields to capture what customers need before they commit.": "Use categorias e campos para capturar o que os clientes precisam antes de se comprometerem.",
    "onboarding.step.shape_details.cta": "Configurar campos",
    "Set up fields": "Configurar campos",
    "onboarding.step.shape_details.impact": "Torna a oferta mais fácil de comparar e confiar.",
    "Makes the offer easier to compare and trust.": "Torna a oferta mais fácil de comparar e confiar.",
    "onboarding.step.test_booking.title": "Teste o fluxo do cliente",
    "Test the customer path": "Teste o fluxo do cliente",
    "onboarding.step.test_booking.description": "Abra o fluxo público e verifique se os clientes podem passar de interesse para ação.",
    "Open the public flow and verify customers can move from interest to action.": "Abra o fluxo público e verifique se os clientes podem passar de interesse para ação.",
    "onboarding.step.test_booking.cta": "Teste de reserva",
    "Test booking": "Teste de reserva",
    "onboarding.step.test_booking.impact": "Valida a jornada de reserva.",
    "Validates the booking journey.": "Valida a jornada de reserva.",
    "onboarding.step.upload_digital_product.title": "Faça o upload de um produto digital",
    "Upload one digital product": "Faça o upload de um produto digital",
    "onboarding.step.upload_digital_product.description": "Torne o primeiro item descarregável suficientemente completo para visualizar e vender.",
    "Make the first downloadable item complete enough to preview and sell.": "Torne o primeiro item descarregável suficientemente completo para visualizar e vender.",
    "onboarding.step.upload_digital_product.cta": "Adicionar produto digital",
    "Add digital product": "Adicionar produto digital",
    "onboarding.step.upload_digital_product.impact": "Cria seu primeiro ativo digital vendável.",
    "Creates your first sellable digital asset.": "Cria seu primeiro ativo digital vendável.",
    "onboarding.step.test_purchase.title": "Teste o fluxo de compra",
    "Test purchase flow": "Teste o fluxo de compra",
    "onboarding.step.test_purchase.description": "Visualize o que os compradores veem desde o descobrimento até o checkout.",
    "Preview what buyers see from discovery through checkout.": "Visualize o que os compradores veem desde o descobrimento até o checkout.",
    "onboarding.step.test_purchase.cta": "Teste de checkout",
    "Test checkout": "Teste de checkout",
    "onboarding.step.test_purchase.impact": "Confirma a jornada do comprador.",
    "Confirms the buyer journey.": "Confirma a jornada do comprador.",
    "onboarding.step.create_campaign.title": "Crie a primeira campanha",
    "Create the first campaign": "Crie a primeira campanha",
    "onboarding.step.create_campaign.description": "Adicione a página da campanha ou causa que os apoiadores devem entender primeiro.",
    "Add the campaign or cause page supporters should understand first.": "Adicione a página da campanha ou causa que os apoiadores devem entender primeiro.",
    "onboarding.step.create_campaign.cta": "Criar campanha",
    "Create campaign": "Criar campanha",
    "onboarding.step.create_campaign.impact": "Cria o primeiro motivo público para agir.",
    "Creates the first public reason to act.": "Cria o primeiro motivo público para agir.",
    "onboarding.step.setup_payments_campaign.title": "Conectar pagamentos de contribuição",
    "Connect contribution payments": "Conectar pagamentos de contribuição",
    "onboarding.step.setup_payments_campaign.description": "A intenção do apoiador importa quando eles podem concluir uma contribuição.",
    "Supporter intent matters when they can complete a contribution.": "A intenção do apoiador importa quando eles podem concluir uma contribuição.",
    "onboarding.step.setup_payments_campaign.cta": "Configurar pagamentos",
    "onboarding.step.setup_payments_campaign.impact": "Habilita contribuições reais.",
    "Enables real contributions.": "Habilita contribuições reais.",
    "onboarding.step.test_supporter_flow.title": "Testar fluxo de apoiador",
    "Test supporter flow": "Testar fluxo de apoiador",
    "onboarding.step.test_supporter_flow.description": "Abra a jornada pública e certifique-se de que a história e a ação sejam claras.",
    "Open the public journey and make sure the story and action are clear.": "Abra a jornada pública e certifique-se de que a história e a ação sejam claras.",
    "onboarding.step.test_supporter_flow.cta": "Testar fluxo",
    "Test flow": "Testar fluxo",
    "onboarding.step.test_supporter_flow.impact": "Valida o caminho público.",
    "Validates the public path.": "Valida o caminho público.",
    "onboarding.step.set_account_categories.title": "Definir categorias de conta de fornecedor",
    "Define supplier account categories": "Definir categorias de conta de fornecedor",
    "onboarding.step.set_account_categories.description": "Separe perfis de fornecedor por tipo para melhorar a confiança e a navegação do comprador.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Separe perfis de fornecedor por tipo para melhorar a confiança e a navegação do comprador.",
    "onboarding.step.set_account_categories.cta": "Categorias de conta",
    "Account categories": "Categorias de conta",
    "onboarding.step.set_account_categories.impact": "Estrutura de fornecedor estabelecida.",
    "Supplier structure established.": "Estrutura de fornecedor estabelecida.",
    "onboarding.step.set_account_attributes.title": "Adicionar atributos de perfil de fornecedor",
    "Add supplier profile attributes": "Adicionar atributos de perfil de fornecedor",
    "onboarding.step.set_account_attributes.description": "Capture detalhes que os compradores precisam antes de contatar ou pedir aos fornecedores.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Capture detalhes que os compradores precisam antes de contatar ou pedir aos fornecedores.",
    "onboarding.step.set_account_attributes.cta": "Atributos de fornecedor",
    "Supplier attributes": "Atributos de fornecedor",
    "onboarding.step.set_account_attributes.impact": "Mais confiança do comprador.",
    "Higher buyer confidence.": "Mais confiança do comprador.",
    "onboarding.step.add_promotion.title": "Adicionar uma promoção de lançamento",
    "Add a launch promotion": "Adicionar uma promoção de lançamento",
    "onboarding.step.add_promotion.description": "Crie sua primeira promoção para incentivar a ação durante a primeira visita.",
    "Create your first promotion to encourage action during the first visit.": "Crie sua primeira promoção para incentivar a ação durante a primeira visita.",
    "onboarding.step.add_promotion.cta": "Adicionar promoção",
    "Add promotion": "Adicionar promoção",
    "onboarding.step.add_promotion.impact": "Fortalece a conversão de lançamento.",
    "Strengthens launch conversion.": "Fortalece a conversão de lançamento.",
    "onboarding.step.create_coupon.title": "Crie seu primeiro cupom",
    "Create your first coupon": "Crie seu primeiro cupom",
    "onboarding.step.create_coupon.description": "Teste descontos para primeiros compradores ou membros.",
    "Test discounts for first-time buyers or members.": "Teste descontos para primeiros compradores ou membros.",
    "onboarding.step.create_coupon.cta": "Criar cupom",
    "Create coupon": "Criar cupom",
    "onboarding.step.create_coupon.impact": "Desbloqueia seu primeiro ciclo de ofertas.",
    "Unlocks your first offer loop.": "Desbloqueia seu primeiro ciclo de ofertas.",
    "onboarding.step.collections_setup.title": "Criar uma coleção",
    "Create a collection": "Criar uma coleção",
    "onboarding.step.collections_setup.description": "Organize listagens importantes para melhorar a descoberta e navegação.",
    "Organize important listings to improve discovery and browsing.": "Organize listagens importantes para melhorar a descoberta e navegação.",
    "onboarding.step.collections_setup.cta": "Criar coleção",
    "Create collection": "Criar coleção",
    "onboarding.step.collections_setup.impact": "Melhora a navegação e descoberta.",
    "Improves navigation and discovery.": "Melhora a navegação e descoberta.",
    "onboarding.step.configure_comms.title": "Revisar modelos de comunicação",
    "Review communication templates": "Revisar modelos de comunicação",
    "onboarding.step.configure_comms.description": "Prepare notificações de inscrição e pedidos antes do crescimento.",
    "Prepare signup and order notifications before growth.": "Prepare notificações de inscrição e pedidos antes do crescimento.",
    "onboarding.step.configure_comms.cta": "Abrir comunicações",
    "Open communications": "Abrir comunicações",
    "onboarding.step.configure_comms.impact": "Prepara as comunicações com os clientes.",
    "Prepares customer communications.": "Prepara as comunicações com os clientes.",
    "onboarding.step.customize_attributes.title": "Adicionar atributos de listagem",
    "Add listing attributes": "Adicionar atributos de listagem",
    "onboarding.step.customize_attributes.description": "Adicione campos estruturados para que os usuários possam filtrar e comparar o que importa.",
    "Add structured fields so users can filter and compare what matters.": "Adicione campos estruturados para que os usuários possam filtrar e comparar o que importa.",
    "onboarding.step.customize_attributes.cta": "Adicionar atributos",
    "Add attributes": "Adicionar atributos",
    "onboarding.step.customize_attributes.impact": "Facilita a comparação de listagens.",
    "Makes listings easier to compare.": "Facilita a comparação de listagens.",
    "onboarding.step.add_digital_asset.title": "Adicionar outro item digital",
    "Add another digital item": "Adicionar outro item digital",
    "onboarding.step.add_digital_asset.description": "Expanda o catálogo para que os usuários avaliem qualidade e variedade.",
    "Expand the catalog so users can evaluate quality and assortment.": "Expanda o catálogo para que os usuários avaliem qualidade e variedade.",
    "onboarding.step.add_digital_asset.cta": "Adicionar listagem digital",
    "Add digital listing": "Adicionar listagem digital",
    "onboarding.step.add_digital_asset.impact": "Melhora a credibilidade do catálogo digital.",
    "Improves digital catalog credibility.": "Melhora a credibilidade do catálogo digital.",
    "personal_assistant.title": "Assistente pessoal",
    "Personal assistant": "Assistente pessoal",
    "personal_assistant.heading": "Crescer sua plataforma passo a passo",
    "Grow your platform one step at a time": "Crescer sua plataforma passo a passo",
    "personal_assistant.subtitle": "Desenhado para {launchType}. Priorizamos ações por impacto e prontidão.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Desenhado para {launchType}. Priorizamos ações por impacto e prontidão.",
    "personal_assistant.launch.store": "uma loja",
    "a store": "uma loja",
    "personal_assistant.launch.marketplace": "um mercado",
    "a marketplace": "um mercado",
    "personal_assistant.launch.booking": "uma plataforma de reservas",
    "a booking platform": "uma plataforma de reservas",
    "personal_assistant.launch.digital": "um negócio digital",
    "a digital business": "um negócio digital",
    "personal_assistant.launch.campaign": "plataforma de campanha",
    "a campaign platform": "plataforma de campanha",
    "personal_assistant.metric.tasks_completed": "Tarefas concluídas",
    "Tasks completed": "Tarefas concluídas",
    "personal_assistant.metric.recommendation_clicks": "Cliques em recomendações",
    "Recommendation clicks": "Cliques em recomendações",
    "personal_assistant.metric.completed_by_recommendation": "Concluído por recomendações",
    "Completed via recommendations": "Concluído por recomendações",
    "personal_assistant.metric.assist_rate": "Taxa de assistência",
    "Assist rate": "Taxa de assistência",
    "personal_assistant.personalizing": "Personalizando suas recomendações…",
    "Personalizing your recommendations…": "Personalizando suas recomendações…",
    "personal_assistant.do_this_now": "Fazer agora",
    "Do this now": "Fazer agora",
    "personal_assistant.estimated_time": "Tempo estimado: {minutes} min",
    "Estimated time: {minutes} min": "Tempo estimado: {minutes} min",
    "personal_assistant.minutes_short": "{minutes} min",
    "{minutes} min": "{minutes} min",
    "personal_assistant.open": "Abrir",
    "personal_assistant.mark_done": "Marcar como concluído",
    "personal_assistant.up_next": "Próximo",
    "Up next": "Próximo",
    "personal_assistant.coming_after": "Próximo após isso",
    "Coming after this": "Próximo após isso",
    "personal_assistant.completed_count": "Concluído ({count})",
    "Completed ({count})": "Concluído ({count})",
    "personal_assistant.hide": "Ocultar",
    "Hide": "Ocultar",
    "personal_assistant.show": "Mostrar",
    "personal_assistant.feature.open_live_site.name": "Abrir a experiência ao vivo",
    "personal_assistant.feature.open_live_site.outcome": "Confirma que os clientes podem acessar a plataforma ao vivo.",
    "You confirm customers can reach the live platform.": "Confirma que os clientes podem acessar a plataforma ao vivo.",
    "personal_assistant.feature.create_supply_shape.name": "Criar a primeira categoria",
    "personal_assistant.feature.create_supply_shape.outcome": "Os clientes podem navegar com uma estrutura clara.",
    "Customers can browse with a clear structure.": "Os clientes podem navegar com uma estrutura clara.",
    "personal_assistant.feature.post_first_listing.name": "Publicar um anúncio de teste",
    "personal_assistant.feature.post_first_listing.outcome": "A plataforma agora tem a primeira oferta para avaliar.",
    "The platform now has first supply to evaluate.": "A plataforma agora tem a primeira oferta para avaliar.",
    "personal_assistant.feature.test_buyer_action.name": "Agir como comprador",
    "personal_assistant.feature.test_buyer_action.outcome": "Valida a experiência do lado do comprador de ponta a ponta.",
    "You validate buyer-side experience end to end.": "Valida a experiência do lado do comprador de ponta a ponta.",
    "personal_assistant.feature.setup_payments.name": "Conectar pagamentos",
    "personal_assistant.feature.setup_payments.outcome": "Os clientes podem concluir transações reais.",
    "Customers can complete real transactions.": "Os clientes podem concluir transações reais.",
    "personal_assistant.feature.setup_delivery.name": "Configurar método de envio ou serviço",
    "personal_assistant.feature.setup_delivery.outcome": "Os clientes podem entender claramente a entrega.",
    "Customers can understand fulfillment clearly.": "Os clientes podem entender claramente a entrega.",
    "personal_assistant.feature.add_promotion.name": "Adicionar uma promoção de lançamento",
    "personal_assistant.feature.add_promotion.outcome": "Você cria um incentivo para conversão inicial.",
    "You create an early conversion incentive.": "Você cria um incentivo para conversão inicial.",
    "personal_assistant.feature.configure_comms.name": "Revisar modelos de comunicação",
    "personal_assistant.feature.configure_comms.outcome": "Os usuários recebem comunicação clara durante todo o ciclo de vida.",
    "Users receive clear lifecycle communication.": "Os usuários recebem comunicação clara durante todo o ciclo de vida.",
    "personal_assistant.feature.view_orders.name": "Abrir pedidos",
    "Open orders": "Abrir pedidos",
    "personal_assistant.feature.view_orders.outcome": "Você pode monitorar e processar a demanda entrante.",
    "You can monitor and process incoming demand.": "Você pode monitorar e processar a demanda entrante.",
    "personal_assistant.feature.view_accounts.name": "Abrir contas",
    "Open accounts": "Abrir contas",
    "personal_assistant.feature.view_accounts.outcome": "Você pode revisar fornecedores ou membros de forma eficiente.",
    "You can review suppliers or members efficiently.": "Você pode revisar fornecedores ou membros de forma eficiente.",
    "personal_assistant.feature.configure_account_categories.name": "Configurar categorias de contas",
    "Configure account categories": "Configurar categorias de contas",
    "personal_assistant.feature.configure_account_categories.outcome": "A estrutura de fornecedores e membros é mais clara para integração e confiança.",
    "Supplier and member structure is clearer for onboarding and trust.": "A estrutura de fornecedores e membros é mais clara para integração e confiança.",
    "personal_assistant.feature.configure_account_attributes.name": "Configurar atributos de conta",
    "Configure account attributes": "Configurar atributos de conta",
    "personal_assistant.feature.configure_account_attributes.outcome": "Os perfis capturam informações críticas para os compradores.",
    "Profiles capture decision-critical info for buyers.": "Os perfis capturam informações críticas para os compradores.",
    "personal_assistant.feature.review_account_config.name": "Revisar configuração de conta",
    "Review account configuration": "Revisar configuração de conta",
    "personal_assistant.feature.review_account_config.outcome": "O comportamento da conta coincide com sua política de mercado.",
    "Account behavior matches your marketplace policy.": "O comportamento da conta coincide com sua política de mercado.",
    "personal_assistant.feature.view_listings.name": "Abrir listagens",
    "Open listings": "Abrir listagens",
    "personal_assistant.feature.view_listings.outcome": "Você pode monitorar a qualidade e prontidão do catálogo.",
    "You can monitor catalog quality and readiness.": "Você pode monitorar a qualidade e prontidão do catálogo.",
    "personal_assistant.feature.configure_listing_categories.name": "Configurar categorias de listagens",
    "Configure listing categories": "Configurar categorias de listagens",
    "personal_assistant.feature.configure_listing_categories.outcome": "O catálogo se torna mais fácil de navegar e descobrir.",
    "The catalog becomes easier to navigate and discover.": "O catálogo se torna mais fácil de navegar e descobrir.",
    "personal_assistant.feature.configure_listing_attributes.name": "Configurar atributos de listagem",
    "Configure listing attributes": "Configurar atributos de listagem",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Os usuários podem comparar listagens com detalhes estruturados.",
    "Users can compare listings with structured details.": "Os usuários podem comparar listagens com detalhes estruturados.",
    "personal_assistant.feature.configure_variant_types.name": "Configurar tipos de variante",
    "Configure variant types": "Configurar tipos de variante",
    "personal_assistant.feature.configure_variant_types.outcome": "O catálogo suporta claramente variações de produtos e serviços.",
    "The catalog supports product and service variations clearly.": "O catálogo suporta claramente variações de produtos e serviços.",
    "personal_assistant.feature.review_listing_configs.name": "Revisar características adicionais de listagem",
    "Review listing additional features": "Revisar características adicionais de listagem",
    "personal_assistant.feature.review_listing_configs.outcome": "O comportamento do anúncio corresponde ao seu modelo operacional.",
    "Listing behavior matches your operating model.": "O comportamento do anúncio corresponde ao seu modelo operacional.",
    "personal_assistant.feature.manage_collections.name": "Gerenciar coleções",
    "Manage collections": "Gerenciar coleções",
    "personal_assistant.feature.manage_collections.outcome": "Caminhos de navegação de alto interesse são mais fáceis de descobrir.",
    "High-intent browsing paths are easier to discover.": "Caminhos de navegação de alto interesse são mais fáceis de descobrir.",
    "personal_assistant.feature.manage_coupons.name": "Gerenciar cupons",
    "Manage coupons": "Gerenciar cupons",
    "personal_assistant.feature.manage_coupons.outcome": "Você pode executar ofertas direcionadas para ativação.",
    "You can run targeted offers for activation.": "Você pode executar ofertas direcionadas para ativação.",
    "personal_assistant.feature.view_transactions.name": "Ver transações",
    "View transactions": "Ver transações",
    "personal_assistant.feature.view_transactions.outcome": "A atividade de pagamento pode ser monitorada para confiança e operações.",
    "Payment activity can be monitored for trust and operations.": "A atividade de pagamento pode ser monitorada para confiança e operações.",
    "personal_assistant.feature.view_users.name": "Abrir usuários",
    "Open users": "Abrir usuários",
    "personal_assistant.feature.view_users.outcome": "Você pode monitorar a qualidade do crescimento de clientes e membros.",
    "You can monitor customer and member growth quality.": "Você pode monitorar a qualidade do crescimento de clientes e membros.",
    "personal_assistant.feature.configure_user_attributes.name": "Configurar atributos de usuário",
    "Configure user attributes": "Configurar atributos de usuário",
    "personal_assistant.feature.configure_user_attributes.outcome": "Você pode capturar sinais de perfil para melhorar o engajamento.",
    "You can capture profile signals to improve engagement.": "Você pode capturar sinais de perfil para melhorar o engajamento.",
    "personal_assistant.feature.review_ratings.name": "Revisar classificações e avaliações",
    "Review ratings and reviews": "Revisar classificações e avaliações",
    "personal_assistant.feature.review_ratings.outcome": "Sinais de confiança são monitorados e melhorados.",
    "Trust signals are monitored and improved.": "Sinais de confiança são monitorados e melhorados.",
    "personal_assistant.feature.view_reports.name": "Abrir relatórios",
    "Open reports": "Abrir relatórios",
    "personal_assistant.feature.view_reports.outcome": "Você pode rastrear o desempenho com uma visão de dados.",
    "You can track performance with a data view.": "Você pode rastrear o desempenho com uma visão de dados.",
    "personal_assistant.feature.manage_media.name": "Gerenciar biblioteca de mídia",
    "Manage media library": "Gerenciar biblioteca de mídia",
    "personal_assistant.feature.manage_media.outcome": "As imagens da marca e do anúncio são mais fáceis de manter.",
    "Brand and listing visuals are easier to maintain.": "As imagens da marca e do anúncio são mais fáceis de manter.",
    "personal_assistant.feature.manage_reported_listings.name": "Revisar listagens reportadas",
    "Review reported listings": "Revisar listagens reportadas",
    "personal_assistant.feature.manage_reported_listings.outcome": "Conteúdo arriscado ou de baixa qualidade pode ser gerenciado rapidamente.",
    "Risky or low-quality content can be handled quickly.": "Conteúdo arriscado ou de baixa qualidade pode ser gerenciado rapidamente.",
    "personal_assistant.feature.app_customization.name": "Personalizar experiência do app",
    "Customize app experience": "Personalizar experiência do app",
    "personal_assistant.feature.app_customization.outcome": "A experiência do aplicativo móvel alinha-se com sua marca.",
    "The mobile app experience aligns with your brand.": "A experiência do aplicativo móvel alinha-se com sua marca.",
    "personal_assistant.feature.app_integrations.name": "Configurar integrações de aplicativos",
    "Configure app integrations": "Configurar integrações de aplicativos",
    "personal_assistant.feature.app_integrations.outcome": "Os serviços da plataforma central se conectam aos fluxos de trabalho dos aplicativos.",
    "Core platform services connect with app workflows.": "Os serviços da plataforma central se conectam aos fluxos de trabalho dos aplicativos.",
    "personal_assistant.feature.customize_strings.name": "Personalizar texto da interface",
    "Customize interface text": "Personalizar texto da interface",
    "personal_assistant.feature.customize_strings.outcome": "A cópia do produto corresponde à sua audiência e tom.",
    "Product copy matches your audience and tone.": "A cópia do produto corresponde à sua audiência e tom.",
    "personal_assistant.feature.review_settings_home.name": "Abrir configuração",
    "Open settings": "Abrir configuração",
    "personal_assistant.feature.review_settings_home.outcome": "A configuração é fácil de encontrar para operações da equipe.",
    "Configuration is easy to find for team operations.": "A configuração é fácil de encontrar para operações da equipe.",
    "personal_assistant.feature.configure_commission.name": "Configurar comissão",
    "Configure commission": "Configurar comissão",
    "personal_assistant.feature.configure_commission.outcome": "A divisão de receita alinha-se com seu modelo de negócio.",
    "Revenue sharing aligns with your business model.": "A divisão de receita alinha-se com seu modelo de negócio.",
    "personal_assistant.feature.configure_taxes.name": "Configurar impostos",
    "Configure taxes": "Configurar impostos",
    "personal_assistant.feature.configure_taxes.outcome": "O preço de checkout é previsível e as configurações de impostos estão prontas.",
    "Checkout pricing is predictable and tax settings are ready.": "O preço de checkout é previsível e as configurações de impostos estão prontas.",
    "personal_assistant.feature.configure_languages.name": "Configurar idiomas",
    "Configure languages": "Configurar idiomas",
    "personal_assistant.feature.configure_languages.outcome": "A experiência suporta uma audiência multilíngue.",
    "The experience supports a multilingual audience.": "A experiência suporta uma audiência multilíngue.",
    "personal_assistant.feature.configure_currency.name": "Configurar moeda",
    "Configure currency": "Configurar moeda",
    "personal_assistant.feature.configure_currency.outcome": "Os preços estão alinhados com as expectativas do seu mercado-alvo.",
    "Prices align with the expectations of your target market.": "Os preços estão alinhados com as expectativas do seu mercado-alvo.",
    "personal_assistant.feature.configure_countries.name": "Configurar países",
    "Configure countries": "Configurar países",
    "personal_assistant.feature.configure_countries.outcome": "A cobertura geográfica é controlada para o lançamento.",
    "Geographic coverage is controlled for launch.": "A cobertura geográfica é controlada para o lançamento.",
    "personal_assistant.feature.review_checkout_settings.name": "Revisar configuração de checkout",
    "Review checkout settings": "Revisar configuração de checkout",
    "personal_assistant.feature.review_checkout_settings.outcome": "O checkout é mais limpo e confiável.",
    "Checkout is cleaner and more reliable.": "O checkout é mais limpo e confiável.",
    "personal_assistant.feature.api_configuration.name": "Revisar configuração da API",
    "Review API configuration": "Revisar configuração da API",
    "personal_assistant.feature.api_configuration.outcome": "As integrações e o acesso para desenvolvedores estão prontos.",
    "Integrations and developer access are ready.": "As integrações e o acesso para desenvolvedores estão prontos.",
    "personal_assistant.feature.workspace_website_editor.name": "Abrir editor de site",
    "Open website editor": "Abrir editor de site",
    "personal_assistant.feature.workspace_website_editor.outcome": "A loja pode ser refinada para conversão.",
    "The storefront can be refined for conversion.": "A loja pode ser refinada para conversão.",
    "personal_assistant.feature.workspace_domain_setup.name": "Revisar configuração de domínio",
    "Review domain setup": "Revisar configuração de domínio",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Um domínio limpo melhora a confiança da marca.",
    "A clean domain improves brand trust.": "Um domínio limpo melhora a confiança da marca.",
    "personal_assistant.feature.workspace_pages.name": "Revisar páginas do site",
    "Review site pages": "Revisar páginas do site",
    "personal_assistant.feature.workspace_pages.outcome": "Páginas principais de aterrizagem e conteúdo que apoiam a confiança do usuário.",
    "Core landing and content pages support user trust.": "Páginas principais de aterrizagem e conteúdo que apoiam a confiança do usuário.",
    "reports.title": "Relatórios",
    "reports.metric.0": "Usuários",
    "reports.metric.1": "Contas",
    "reports.metric.2": "Listagens",
    "reports.metric.3": "Listagens vendidas",
    "Listings Sold": "Listagens vendidas",
    "reports.metric.4": "Vendas totais",
    "Total Sales": "Vendas totais",
    "reports.metric.5": "Pedidos totais",
    "reports.metric.6": "Ganhos totais",
    "Total Earnings": "Ganhos totais",
    "reports.chart.activity": "Atividade diária no mercado",
    "Daily marketplace activity": "Atividade diária no mercado",
    "reports.chart.activity_description": "Listagens e novos usuários ao longo do tempo",
    "Listings and new users over time": "Listagens e novos usuários ao longo do tempo",
    "reports.chart.listings_monthly": "Listagens mensais",
    "Listings monthly": "Listagens mensais",
    "reports.chart.listings_daily": "Listagens diárias",
    "Listings daily": "Listagens diárias",
    "reports.chart.users_daily": "Usuários diários",
    "Users daily": "Usuários diários",
    "reports.chart.users_monthly": "Usuários mensais",
    "Users monthly": "Usuários mensais",
    "reports.series.listings": "Listagens",
    "reports.series.new_users": "Novos usuários",
    "New users": "Novos usuários",
    "reports.top_sold_listings": "Listagens mais vendidas",
    "Top sold listings": "Listagens mais vendidas",
    "reports.view_more_insights": "Ver mais informações",
    "View more insights": "Ver mais informações",
    "reports.ai.title": "Relatórios de vendas com IA",
    "AI sales reports": "Relatórios de vendas com IA",
    "reports.ai.generating": "Gerando relatórios…",
    "Generating reports…": "Gerando relatórios…",
    "reports.ai.value": "Valor",
    "reports.ai.more_info": "Mais informações sobre {label}",
    "More information about {label}": "Mais informações sobre {label}",
    "reports.ai.saved_snapshot": "Instantânea salva",
    "Saved snapshot": "Instantânea salva",
    "reports.ai.no_data": "Nenhum dado disponível",
    "No data available": "Nenhum dado disponível",
    "reports.ai.showing_top": "Mostrando os {shown} primeiros de {total} resultados",
    "Showing the top {shown} of {total} results": "Mostrando os {shown} primeiros de {total} resultados",
    "reports.ai.saved_report": "Relatório de IA salvo",
    "Saved AI report": "Relatório de IA salvo",
    "reports.ai.template.country": "Vendas por país",
    "Sales by country": "Vendas por país",
    "reports.ai.template.state": "Vendas por estado",
    "Sales by state": "Vendas por estado",
    "reports.ai.template.city": "Vendas por cidade",
    "Sales by city": "Vendas por cidade",
    "reports.ai.template.category": "Vendas por categoria",
    "Sales by category": "Vendas por categoria",
    "reports.ai.template.country_all_time": "Vendas por país (todo o tempo)",
    "Sales by country (all time)": "Vendas por país (todo o tempo)",
    "reports.ai.template.top_listings_all_time": "Listagens mais vendidas (todo o tempo)",
    "Top sold listings (all time)": "Listagens mais vendidas (todo o tempo)",
    "reports.ai.template.listings_by_category_all_time": "Listagens por categoria (todo o tempo)",
    "Listings by category (all time)": "Listagens por categoria (todo o tempo)",
    "reports.search_table.title": "Pesquisa de listagens",
    "Listing search": "Pesquisa de listagens",
    "reports.search_table.phrase": "Frase",
    "Phrase": "Frase",
    "reports.search_table.result": "Resultado",
    "reports.search_table.created_at": "Criado em",
    "Created at": "Criado em",
    "reports.search_table.user_first_name": "Nome do usuário",
    "User first name": "Nome do usuário",
    "reports.search_table.user_last_name": "Sobrenome do usuário",
    "User last name": "Sobrenome do usuário",
    "reports.search_table.user_email": "E-mail do usuário",
    "User email": "E-mail do usuário",
    "intelligence.title": "Inteligência",
    "intelligence.description": "Gere relatórios de IA, salve instantâneas de gráficos e fixe relatórios úteis no seu painel.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Gere relatórios de IA, salve instantâneas de gráficos e fixe relatórios úteis no seu painel.",
    "intelligence.dashboard.label": "Painel",
    "intelligence.dashboard.pinned_title": "Widgets de inteligência fixados",
    "Pinned intelligence widgets": "Widgets de inteligência fixados",
    "intelligence.dashboard.pinned_count": "{count} fixados",
    "{count} pinned": "{count} fixados",
    "intelligence.dashboard.empty": "Fixe relatórios salvos para criar uma grade de painel reutilizável.",
    "Pin saved reports to build a reusable dashboard grid.": "Fixe relatórios salvos para criar uma grade de painel reutilizável.",
    "intelligence.action.open": "Abrir",
    "intelligence.action.pin": "Fixar",
    "Pin": "Fixar",
    "intelligence.action.unpin": "Desafixar",
    "Unpin": "Desafixar",
    "intelligence.action.generate": "Gerar",
    "intelligence.action.save_snapshot": "Salvar instantânea",
    "Save snapshot": "Salvar instantânea",
    "intelligence.action.discard_draft": "Descartar rascunho",
    "Discard draft": "Descartar rascunho",
    "intelligence.action.load": "Carregar",
    "Load": "Carregar",
    "intelligence.action.refresh": "Atualizar",
    "intelligence.action.delete": "Excluir",
    "intelligence.table.no_rows": "Nenhuma linha estruturada foi retornada para este relatório.",
    "No structured rows were returned for this report.": "Nenhuma linha estruturada foi retornada para este relatório.",
    "intelligence.table.no_rows_short": "Nenhuma linha disponível.",
    "No rows available.": "Nenhuma linha disponível.",
    "intelligence.field.template": "Modelo de relatório",
    "Report template": "Modelo de relatório",
    "intelligence.field.date_filter": "Filtro de data",
    "Date filter": "Filtro de data",
    "intelligence.field.prompt": "Prévia do prompt",
    "Prompt preview": "Prévia do prompt",
    "intelligence.field.report_name": "Nome do relatório",
    "Report name": "Nome do relatório",
    "intelligence.field.report_name_placeholder": "Por exemplo: Produtos mais vendidos – Últimos 30 dias",
    "For example: Top Selling Products – Last 30 Days": "Por exemplo: Produtos mais vendidos – Últimos 30 dias",
    "intelligence.field.chart": "Gráfico",
    "Chart": "Gráfico",
    "intelligence.field.prompt_label": "Prompt",
    "Prompt": "Prompt",
    "intelligence.date.relative": "Relativo",
    "Relative": "Relativo",
    "intelligence.date.absolute": "Absoluto",
    "Absolute": "Absoluto",
    "intelligence.date.last_n_days": "Últimos N dias",
    "Last N days": "Últimos N dias",
    "intelligence.date.last_days": "Últimos {days} dias",
    "Last {days} days": "Últimos {days} dias",
    "intelligence.date.from": "De",
    "From": "De",
    "intelligence.date.to": "Até",
    "To": "Até",
    "intelligence.saved_reports.title": "Relatórios salvos",
    "Saved reports": "Relatórios salvos",
    "intelligence.saved_reports.empty": "Ainda não há relatórios de inteligência salvos.",
    "No saved intelligence reports yet.": "Ainda não há relatórios de inteligência salvos.",
    "intelligence.active_report": "Relatório ativo",
    "Active report": "Relatório ativo",
    "intelligence.no_report_selected": "Nenhum relatório selecionado",
    "No report selected": "Nenhum relatório selecionado",
    "intelligence.active_report.empty_description": "Gere um relatório ou carregue um salvo para inspecionar os dados.",
    "Generate a report or load a saved one to inspect the data.": "Gere um relatório ou carregue um salvo para inspecionar os dados.",
    "intelligence.chart.value": "Valor",
    "intelligence.chart.unknown": "Desconhecido",
    "intelligence.chart_type.bar": "Barras",
    "Barres": "Barras",
    "intelligence.chart_type.line": "Linha",
    "Line": "Linha",
    "intelligence.chart_type.area": "Área",
    "Area": "Área",
    "intelligence.chart_type.pie": "Pizza",
    "Pie": "Pizza",
    "intelligence.chart.no_rows": "Este relatório não retornou linhas para plotar.",
    "This report did not return rows to plot.": "Este relatório não retornou linhas para plotar.",
    "intelligence.empty_report": "Use a model e os controles de data para gerar um relatório estruturado de IA, depois salve e fixe no seu painel.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Use a model e os controles de data para gerar um relatório estruturado de IA, depois salve e fixe no seu painel.",
    "intelligence.error.update": "Não é possível atualizar o relatório salvo.",
    "Unable to update the saved report.": "Não é possível atualizar o relatório salvo.",
    "intelligence.error.prompt_required": "Insira um prompt para gerar um relatório.",
    "Enter a prompt to generate a report.": "Insira um prompt para gerar um relatório.",
    "intelligence.error.invalid_response": "A resposta da IA não incluiu um relatório normalizado.",
    "The AI response did not include a normalized report.": "A resposta da IA não incluiu um relatório normalizado.",
    "intelligence.error.generate": "Não é possível gerar o relatório agora.",
    "Unable to generate the report right now.": "Não é possível gerar o relatório agora.",
    "intelligence.error.generate_before_save": "Gere um relatório antes de salvar.",
    "Generate a report before saving.": "Gere um relatório antes de salvar.",
    "intelligence.error.save": "Não é possível salvar o relatório.",
    "Unable to save the report.": "Não é possível salvar o relatório.",
    "intelligence.error.load": "Não é possível carregar o relatório salvo.",
    "Unable to load the saved report.": "Não é possível carregar o relatório salvo.",
    "intelligence.error.refresh": "Não é possível atualizar o relatório salvo.",
    "Unable to refresh the saved report.": "Não é possível atualizar o relatório salvo.",
    "intelligence.error.delete": "Não é possível excluir o relatório salvo.",
    "Unable to delete the saved report.": "Não é possível excluir o relatório salvo.",
    "intelligence.template.top_selling_products": "Produtos mais vendidos",
    "Top selling products": "Produtos mais vendidos",
    "intelligence.template.revenue_trend": "Tendência de receita",
    "Revenue trend": "Tendência de receita",
    "intelligence.template.low_stock_products": "Produtos com estoque baixo",
    "Low stock products": "Produtos com estoque baixo",
    "intelligence.template.top_categories_by_sales": "Categorias mais vendidas",
    "Top categories by sales": "Categorias mais vendidas",
    "intelligence.template.order_status_breakdown": "Desglose do status dos pedidos",
    "Order status breakdown": "Desglose do status dos pedidos",
    "intelligence.template.sales_by_day": "Vendas por dia",
    "Sales by day": "Vendas por dia",
    "intelligence.template.sales_by_country": "Vendas por país",
    "intelligence.template.sales_by_state": "Vendas por estado",
    "intelligence.template.sales_by_city": "Vendas por cidade",
    "intelligence.template.sales_by_category": "Vendas por categoria",
    "intelligence.template.sales_by_subcategory": "Vendas por subcategoria",
    "Sales by subcategory": "Vendas por subcategoria",
    "intelligence.prompt.top_selling_products.relative": "Mostre os produtos mais vendidos nos últimos {days} dias",
    "Show me top selling products for the last {days} days": "Mostre os produtos mais vendidos nos últimos {days} dias",
    "intelligence.prompt.top_selling_products.absolute": "Mostre os produtos mais vendidos de {from} a {to}",
    "Show me top selling products from {from} to {to}": "Mostre os produtos mais vendidos de {from} a {to}",
    "intelligence.prompt.revenue_trend.relative": "Qual é a minha tendência de receita nos últimos {days} dias?",
    "What is my revenue trend for the last {days} days?": "Qual é a minha tendência de receita nos últimos {days} dias?",
    "intelligence.prompt.revenue_trend.absolute": "Qual é a minha tendência de receita de {from} a {to}?",
    "What is my revenue trend from {from} to {to}?": "Qual é a minha tendência de receita de {from} a {to}?",
    "intelligence.prompt.low_stock_products": "Mostre os produtos com estoque baixo",
    "Show me low stock products": "Mostre os produtos com estoque baixo",
    "intelligence.prompt.top_categories_by_sales.relative": "Mostre as categorias mais vendidas por vendas nos últimos {days} dias",
    "Show me top categories by sales for the last {days} days": "Mostre as categorias mais vendidas por vendas nos últimos {days} dias",
    "intelligence.prompt.top_categories_by_sales.absolute": "Mostre as categorias mais vendidas por vendas de {from} a {to}",
    "Show me top categories by sales from {from} to {to}": "Mostre as categorias mais vendidas por vendas de {from} a {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Mostre o desglose do status dos pedidos nos últimos {days} dias",
    "Show me order status breakdown for the last {days} days": "Mostre o desglose do status dos pedidos nos últimos {days} dias",
    "intelligence.prompt.order_status_breakdown.absolute": "Mostre o desglose do status dos pedidos de {from} a {to}",
    "Show me order status breakdown from {from} to {to}": "Mostre o desglose do status dos pedidos de {from} a {to}",
    "intelligence.prompt.sales_by_day.relative": "Mostre as vendas por dia nos últimos {days} dias",
    "Show me sales by day for the last {days} days": "Mostre as vendas por dia nos últimos {days} dias",
    "intelligence.prompt.sales_by_day.absolute": "Mostre as vendas por dia de {from} a {to}",
    "Show me sales by day from {from} to {to}": "Mostre as vendas por dia de {from} a {to}",
    "intelligence.prompt.sales_by_country.relative": "Mostre o receita total de vendas e a contagem de pedidos agrupados por país nos últimos {days} dias",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Mostre o receita total de vendas e a contagem de pedidos agrupados por país nos últimos {days} dias",
    "intelligence.prompt.sales_by_country.absolute": "Mostre o receita total de vendas e a contagem de pedidos agrupados por país de {from} a {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Mostre o receita total de vendas e a contagem de pedidos agrupados por país de {from} a {to}",
    "intelligence.prompt.sales_by_state.relative": "Mostre o receita total de vendas e a contagem de pedidos agrupados por estado ou província nos últimos {days} dias",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Mostre o receita total de vendas e a contagem de pedidos agrupados por estado ou província nos últimos {days} dias",
    "intelligence.prompt.sales_by_state.absolute": "Mostre o receita total de vendas e a contagem de pedidos agrupados por estado ou província de {from} a {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Mostre o receita total de vendas e a contagem de pedidos agrupados por estado ou província de {from} a {to}",
    "intelligence.prompt.sales_by_city.relative": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por cidade para os últimos {days} dias",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por cidade para os últimos {days} dias",
    "intelligence.prompt.sales_by_city.absolute": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por cidade de {from} a {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por cidade de {from} a {to}",
    "intelligence.prompt.sales_by_category.relative": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por categoria de lista de nível superior para os últimos {days} dias",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por categoria de lista de nível superior para os últimos {days} dias",
    "intelligence.prompt.sales_by_category.absolute": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por categoria de lista de nível superior de {from} a {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por categoria de lista de nível superior de {from} a {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por subcategoria de lista para os últimos {days} dias",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por subcategoria de lista para os últimos {days} dias",
    "intelligence.prompt.sales_by_subcategory.absolute": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por subcategoria de lista de {from} a {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Mostre os recebimentos totais de vendas e a contagem de pedidos agrupados por subcategoria de lista de {from} a {to}",
    "common.status.partial": "Parcial",
    "Partial": "Parcial",
    "common.status.dispatched": "Enviado",
    "Dispatched": "Enviado",
    "common.status.sale": "Venda",
    "Sale": "Venda",
    "common.status.transfer_in": "Transferência recebida",
    "Transfer in": "Transferência recebida",
    "common.status.transfer_out": "Transferência enviada",
    "Transfer out": "Transferência enviada",
    "common.status.return": "Devolução",
    "Return": "Devolução",
    "common.status.adjustment": "Ajuste",
    "Adjustment": "Ajuste",
    "common.status.receipt": "Recibo",
    "inventory.overview.title": "Estoque",
    "inventory.overview.tab.all": "Todo o estoque",
    "All stock": "Todo o estoque",
    "inventory.overview.tab.low": "Estoque baixo",
    "Low stock": "Estoque baixo",
    "inventory.overview.tab.expiring": "Lotes próximos a vencer",
    "Expiring batches": "Lotes próximos a vencer",
    "inventory.overview.manage_locations": "Gerenciar localizações",
    "Manage locations": "Gerenciar localizações",
    "inventory.overview.purchase_orders": "Pedidos de compra",
    "inventory.overview.operations": "Operações",
    "Operations": "Operações",
    "inventory.overview.adjust_stock": "Ajustar estoque",
    "Adjust stock": "Ajustar estoque",
    "inventory.overview.description": "Visualização em tempo real do estoque em todas as suas localizações.",
    "A live view of stock across your locations.": "Visualização em tempo real do estoque em todas as suas localizações.",
    "inventory.overview.adjustment_hint": "Use ajustes para contagens, danos, devoluções ou outras correções.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Use ajustes para contagens, danos, devoluções ou outras correções.",
    "inventory.overview.units_on_hand": "Unidades em estoque",
    "Units on hand": "Unidades em estoque",
    "inventory.overview.one_stock_row": "1 linha de estoque",
    "1 stock row": "1 linha de estoque",
    "inventory.overview.stock_rows": "{count} linhas de estoque",
    "{count} stock rows": "{count} linhas de estoque",
    "inventory.overview.low_stock": "Estoque baixo",
    "inventory.overview.reorder_point_hint": "Em ou abaixo do ponto de reposição",
    "At or below reorder point": "Em ou abaixo do ponto de reposição",
    "inventory.overview.expiring_soon": "Vence em breve",
    "Expiring soon": "Vence em breve",
    "inventory.overview.next_90_days": "Dentro dos próximos 90 dias",
    "Within the next 90 days": "Dentro dos próximos 90 dias",
    "inventory.overview.stock_value": "Valor do estoque",
    "Stock value": "Valor do estoque",
    "inventory.overview.one_active_location": "1 localização ativa",
    "1 active location": "1 localização ativa",
    "inventory.overview.active_locations": "{count} localizações ativas",
    "{count} active locations": "{count} localizações ativas",
    "inventory.overview.search": "Pesquisar estoque",
    "Search inventory": "Pesquisar estoque",
    "inventory.overview.search_placeholder": "Pesquisar produto, SKU ou localização",
    "Search product, SKU, or location": "Pesquisar produto, SKU ou localização",
    "inventory.overview.filter_location": "Filtrar por localização",
    "Filter by location": "Filtrar por localização",
    "inventory.overview.all_locations": "Todas as localizações",
    "inventory.overview.empty.all": "Nenhum estoque de inventário ainda foi registrado.",
    "No inventory stock has been recorded yet.": "Nenhum estoque de inventário ainda foi registrado.",
    "inventory.overview.empty.low": "Ótimo — nenhum estoque está abaixo do ponto de reposição!",
    "Great — no stock is below its reorder point.": "Ótimo — nenhum estoque está abaixo do ponto de reposição!",
    "inventory.overview.empty.expiring": "Nenhum lote está vencendo nos próximos 90 dias.",
    "No batches are expiring within 90 days.": "Nenhum lote está vencendo nos próximos 90 dias.",
    "inventory.overview.adjust": "Ajustar",
    "Adjust": "Ajustar",
    "inventory.overview.adjust_title": "Ajustar estoque",
    "inventory.overview.adjust_description": "Registre uma correção com uma razão para que o histórico de estoque permaneça confiável.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Registre uma correção com uma razão para que o histórico de estoque permaneça confiável.",
    "inventory.overview.save_adjustment": "Salvar ajuste",
    "Save adjustment": "Salvar ajuste",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Não atribuído",
    "Unassigned": "Não atribuído",
    "inventory.overview.quantity_change": "Alteração de quantidade",
    "Quantity change": "Alteração de quantidade",
    "inventory.overview.quantity_placeholder": "Ex.: 5 ou -2",
    "e.g. 5 or -2": "Ex.: 5 ou -2",
    "inventory.overview.reason": "Motivo",
    "inventory.overview.reason_placeholder": "Ex.: Contagem cíclica, dano, devolução…",
    "Cycle count, damage, return…": "Ex.: Contagem cíclica, dano, devolução…",
    "inventory.overview.reason.cycle_count": "Contagem cíclica",
    "Cycle count": "Contagem cíclica",
    "inventory.overview.reason.damage": "Dano",
    "Damage": "Dano",
    "inventory.overview.reason.return": "Devolução",
    "inventory.overview.reason.stocktake": "Inventário físico",
    "Stocktake": "Inventário físico",
    "inventory.overview.note_placeholder": "Contexto opcional para a próxima pessoa",
    "Optional context for the next person": "Contexto opcional para a próxima pessoa",
    "inventory.overview.adjustment_saved": "Ajuste de estoque salvo",
    "Inventory adjustment saved": "Ajuste de estoque salvo",
    "inventory.overview.on_hand": "Disponível",
    "On hand": "Disponível",
    "inventory.overview.reorder_at": "Repor em",
    "Reorder at": "Repor em",
    "orders.create_order.payment_reference_missing": "O pedido foi criado, mas nenhuma referência de pedido foi retornada.",
    "The order was created, but no order reference was returned.": "O pedido foi criado, mas nenhuma referência de pedido foi retornada.",
    "orders.create_order.payment_domain_missing": "O domínio do inquilino não está disponível para links de pagamento.",
    "The tenant domain is not available for payment links.": "O domínio do inquilino não está disponível para links de pagamento.",
    "orders.create_order.payment_link_failed": "Não é possível criar o link de pagamento.",
    "Unable to create payment link.": "Não é possível criar o link de pagamento.",
    "orders.create_order.admin_session_expired": "Sua sessão de administrador expirou. Faça login novamente antes de criar um pedido.",
    "Your admin session has expired. Please sign in again before creating an order.": "Sua sessão de administrador expirou. Faça login novamente antes de criar um pedido.",
    "orders.create_order.user": "Usuário",
    "orders.create_order.add_new_user": "Adicionar novo usuário",
    "Add New User": "Adicionar novo usuário",
    "orders.create_order.choose_existing_user": "Escolher usuário existente",
    "Choose Existing User": "Escolher usuário existente",
    "orders.create_order.preparing_customer": "Preparando cliente…",
    "Preparing customer…": "Preparando cliente…",
    "orders.create_order.select_user": "Selecionar usuário",
    "Select user": "Selecionar usuário",
    "orders.create_order.search_listing": "Buscar lista",
    "Search Listing": "Buscar lista",
    "orders.create_order.listings": "Listagens",
    "orders.create_order.no_image": "Sem imagem",
    "No image": "Sem imagem",
    "orders.create_order.add_to_cart": "Adicionar ao carrinho",
    "Add to Cart": "Adicionar ao carrinho",
    "orders.create_order.select_rental_dates": "Selecione primeiro as datas de início e término do aluguel.",
    "Select rental start and end dates first.": "Selecione primeiro as datas de início e término do aluguel.",
    "orders.create_order.rental_end_after_start": "A data de término do aluguel deve ser posterior à data de início.",
    "Rental end must be after the start date.": "A data de término do aluguel deve ser posterior à data de início.",
    "orders.create_order.cart_type_conflict": "Este cliente já tem itens com um tipo de lista diferente. Remova esses itens no Checkout antes de adicionar este.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Este cliente já tem itens com um tipo de lista diferente. Remova esses itens no Checkout antes de adicionar este.",
    "orders.create_order.rental_period": "Período de aluguel",
    "Rental period": "Período de aluguel",
    "orders.create_order.select_start_end": "Selecione início e término",
    "Select start and end": "Selecione início e término",
    "orders.create_order.membership_no_shipping": "Pedidos de assinatura não exigem envio ou entrega.",
    "Membership orders do not require shipping or delivery.": "Pedidos de assinatura não exigem envio ou entrega.",
    "orders.create_order.preparing_payment_link": "Preparando link de pagamento…",
    "Preparing payment link…": "Preparando link de pagamento…",
    "orders.create_order.payment_link_ready": "Link de pagamento pronto",
    "Payment link ready": "Link de pagamento pronto",
    "orders.create_order.copy_payment_link": "Copiar link de pagamento",
    "Copy payment link": "Copiar link de pagamento",
    "orders.create_order.payment_method": "Método de pagamento",
    "orders.create_order.no_payment_methods": "Não há métodos de pagamento ativos configurados para este projeto.",
    "No active payment methods are configured for this project.": "Não há métodos de pagamento ativos configurados para este projeto.",
    "orders.create_order.shipping_method": "Método de envio",
    "orders.create_order.no_shipping_methods": "Nenhum método de envio ativo está configurado para este projeto.",
    "No active shipping methods are configured for this project.": "Nenhum método de envio ativo está configurado para este projeto.",
    "orders.create_order.shipping_address": "Endereço de entrega",
    "Shipping address": "Endereço de entrega",
    "orders.create_order.loading_addresses": "Carregando endereços salvos…",
    "Loading saved addresses…": "Carregando endereços salvos…",
    "orders.create_order.no_saved_shipping_address": "Este usuário não tem endereço de entrega salvo. Adicione um antes de criar um pedido de entrega.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "Este usuário não tem endereço de entrega salvo. Adicione um antes de criar um pedido de entrega.",
    "orders.create_order.no_items": "Sem itens",
    "No items": "Sem itens",
    "orders.create_order.cart_empty": "Seu carrinho está vazio",
    "Your cart is empty": "Seu carrinho está vazio",
    "orders.create_order.create_order": "Criar pedido",
    "Create Order": "Criar pedido",
    "orders.create_order.create_payment_link": "Criar link de pagamento",
    "Create payment link": "Criar link de pagamento",
    "orders.create_order.order_summary": "Resumo do pedido",
    "orders.create_order.coupon_value": "Valor do cupom",
    "Coupon value": "Valor do cupom",
    "orders.create_order.remove_coupon": "Remover cupom",
    "Remove Coupon": "Remover cupom",
    "orders.create_order.apply_coupon": "Aplicar cupom",
    "Apply Coupon": "Aplicar cupom",
    "orders.create_order.grand_amount": "Valor total",
    "Grand Amount": "Valor total",
    "orders.create_order.total": "Total",
    "orders.create_order.shipping": "Frete",
    "orders.create_order.subtotal": "Subtotal",
    "Subtotal": "Subtotal",
    "orders.create_order.stock_unavailable": "Estoque indisponível",
    "Stock is not available": "Estoque indisponível",
    "orders.create_order.max_quantity": "Quantidade máxima é {quantity}",
    "Max quantity is {quantity}": "Quantidade máxima é {quantity}",
    "orders.create_order.items_in_cart": "Itens no carrinho",
    "Items in the cart": "Itens no carrinho",
    "orders.create_order.products_in_stock": "{count} Produtos em estoque",
    "{count} Products in Stock": "{count} Produtos em estoque",
    "orders.create_order.order_items": "Itens do pedido",
    "Order Items": "Itens do pedido",
    "orders.create_order.sold_by": "por {name}",
    "by {name}": "por {name}",
    "common.first_name": "Nome",
    "common.last_name": "Sobrenome",
    "common.unlimited": "ilimitado",
    "unlimited": "ilimitado",
    "orders.reference": "Referência",
    "orders.amount": "Valor",
    "orders.currency": "Moeda",
    "orders.transaction_date": "Data da transação",
    "Transaction Date": "Data da transação",
    "orders.volume_this_page": "Volume (página atual)",
    "Volume (this page)": "Volume (página atual)",
    "orders.seller_entries": "Entradas do vendedor",
    "Seller Entries": "Entradas do vendedor",
    "orders.customer_entries": "Entradas do cliente",
    "Customer Entries": "Entradas do cliente",
    "orders.filter_transactions": "Filtrar transações",
    "Filter Transactions": "Filtrar transações",
    "orders.reset_filters": "Redefinir filtros",
    "Reset filters": "Redefinir filtros",
    "orders.manage_transactions": "Gerenciar suas transações",
    "Manage your Transactions": "Gerenciar suas transações",
    "orders.empty_transactions_message": "Aqui você pode rastrear todas as transações entre usuários.\nTransações como comissões, preço do pedido, taxas de pagamento, taxas especiais, etc.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Aqui você pode rastrear todas as transações entre usuários.\nTransações como comissões, preço do pedido, taxas de pagamento, taxas especiais, etc.",
    "orders.super_type": "Tipo super",
    "Super Type": "Tipo super",
    "orders.exporting": "Exportando…",
    "Exporting…": "Exportando…",
    "orders.export_as_csv": "Exportar como CSV",
    "Export as CSV": "Exportar como CSV",
    "orders.search_transactions": "Buscar transações",
    "Search transactions": "Buscar transações",
    "orders.filter": "Filtrar",
    "Filter": "Filtrar",
    "orders.transaction_status": "Status da transação",
    "Transaction Status": "Status da transação",
    "orders.seller_protection_fee": "Taxa de proteção do vendedor",
    "Seller Protection Fee": "Taxa de proteção do vendedor",
    "common.show_rows": "Mostrar linhas",
    "common.clear_all": "Limpar tudo",
    "Clear All": "Limpar tudo",
    "orders.order_number_value": "Pedido #{number}",
    "orders.transactions": "Transações",
    "reported_listings.report_detail": "Detalhe do relatório",
    "Report Detail": "Detalhe do relatório",
    "reported_listings.reported_listing": "Listagem denunciada",
    "Reported Listing": "Listagem denunciada",
    "reported_listings.pending": "Pendente",
    "reported_listings.approved": "Aprovado",
    "reported_listings.rejected": "Rejeitado",
    "reported_listings.view_marketplace": "Ver no mercado",
    "View on marketplace": "Ver no mercado",
    "reported_listings.approve_listing": "Aprovar listagem",
    "Approve listing": "Aprovar listagem",
    "reported_listings.reject_listing": "Rejeitar listagem",
    "Reject listing": "Rejeitar listagem",
    "reported_listings.reported_by": "Denunciado por",
    "Reported By": "Denunciado por",
    "reported_listings.blocked": "Bloqueado",
    "reported_listings.unblock_user": "Desbloquear usuário",
    "Unblock user": "Desbloquear usuário",
    "reported_listings.block_user": "Bloquear usuário",
    "Block user": "Bloquear usuário",
    "reported_listings.report_info": "Informação do relatório",
    "Report Info": "Informação do relatório",
    "reported_listings.reason": "Motivo",
    "reported_listings.reported_on": "Reportado em",
    "Reported on": "Reportado em",
    "reported_listings.listing_id": "ID do anúncio",
    "reported_listings.reporter": "Relator",
    "Reporter": "Relator",
    "reported_listings.listing": "Anúncio",
    "reported_listings.status": "Status",
    "reported_listings.title": "Listagens reportadas",
    "reported_listings.report_count": "Relatos: {count}",
    "Reports: {count}": "Relatos: {count}",
    "reported_listings.empty_title": "Visualizando listagens reportadas",
    "Viewing Reported listings": "Visualizando listagens reportadas",
    "reported_listings.empty_message": "Você encontrará aqui os anúncios reportados por seus usuários",
    "You will find your users reported listings here": "Você encontrará aqui os anúncios reportados por seus usuários",
    "common.page_of": "Página {page} de {total}",
    "Page {page} of {total}": "Página {page} de {total}",
    "common.view": "Ver",
    "reviews.empty_title": "Visualizando Avaliações e Classificações",
    "Viewing Rate & Reviews": "Visualizando Avaliações e Classificações",
    "reviews.empty_message": "Você encontrará aqui as classificações e avaliações de seus usuários",
    "You will find your users ratings and reviews here": "Você encontrará aqui as classificações e avaliações de seus usuários",
    "reviews.list": "Lista",
    "reviews.grid": "Grade",
    "Grid": "Grade",
    "reviews.title": "Avaliações e Classificações",
    "reviews.review": "Avaliação",
    "reviews.name": "Nome",
    "reviews.rating": "Classificação",
    "reviews.title_column": "Título",
    "reviews.content": "Conteúdo",
    "Content": "Conteúdo",
    "reviews.image": "Imagem",
    "Image": "Imagem",
    "reviews.images": "Imagens",
    "Images": "Imagens",
    "reviews.accounts": "Contas",
    "reviews.listings": "Listagens",
    "reviews.star": "Estrela",
    "Star": "Estrela",
    "reviews.review_image": "Imagem da revisão",
    "Review image": "Imagem da revisão",
    "reviews.title_required": "Título é obrigatório",
    "reviews.content_required": "Conteúdo é obrigatório",
    "Content is required": "Conteúdo é obrigatório",
    "reviews.updated_successfully": "Avaliação atualizada com sucesso",
    "Review updated successfully": "Avaliação atualizada com sucesso",
    "reviews.edit_review": "Editar avaliação",
    "Edit Review": "Editar avaliação",
    "common.not_available": "N/A",
    "common.something_went_wrong": "Algo deu errado",
    "Something went wrong": "Algo deu errado",
    "media.load_failed": "Não é possível carregar mídia",
    "Unable to load media.": "Não é possível carregar mídia",
    "media.load_failed_retry": "Não é possível carregar mídia. Por favor, tente novamente.",
    "media.update_failed": "Falha na atualização da mídia",
    "Media update failed": "Falha na atualização da mídia",
    "media.renamed": "Mídia renomeada",
    "Media renamed": "Mídia renomeada",
    "media.moved": "Mídia movida",
    "Media moved": "Mídia movida",
    "media.rename_failed": "Não é possível renomear mídia",
    "Unable to rename media": "Não é possível renomear mídia",
    "media.move_failed": "Não é possível mover mídia",
    "Unable to move media": "Não é possível mover mídia",
    "media.deleted": "Mídia excluída",
    "Media deleted": "Mídia excluída",
    "media.delete_failed": "Não é possível excluir mídia",
    "Unable to delete media": "Não é possível excluir mídia",
    "media.confirm_delete": "Tem certeza de que deseja excluir esta mídia?",
    "Are you sure you want to delete this media?": "Tem certeza de que deseja excluir esta mídia?",
    "media.delete_media": "Excluir mídia",
    "Delete media": "Excluir mídia",
    "media.folder_creation_web_only": "Criação de pastas está disponível no web",
    "Folder creation is available on web": "Criação de pastas está disponível no web",
    "media.no_create_folder_permission": "Você não tem permissão para criar pastas",
    "You do not have permission to create folders": "Você não tem permissão para criar pastas",
    "media.folder_name": "Nome da pasta",
    "Folder name": "Nome da pasta",
    "media.folder_created": "Pasta criada",
    "Folder created": "Pasta criada",
    "media.folder_create_failed": "Não é possível criar pasta",
    "media.link_copied": "Link copiado",
    "Link copied": "Link copiado",
    "media.copy_link_failed": "Não é possível copiar o link",
    "Unable to copy link": "Não é possível copiar o link",
    "media.urls_copied": "{count} links copiados",
    "{count} URLs copied": "{count} links copiados",
    "media.clipboard_unavailable": "Clipboard não disponível",
    "Clipboard is not available": "Clipboard não disponível",
    "media.copy_urls_failed": "Não é possível copiar links",
    "Unable to copy URLs": "Não é possível copiar links",
    "media.upload_failed": "Falha ao fazer upload de mídia",
    "Media upload failed": "Falha ao fazer upload de mídia",
    "media.replace_success": "Mídia substituída. O ID e o link estável permanecem inalterados.",
    "Media replaced. The media ID and stable link are unchanged.": "Mídia substituída. O ID e o link estável permanecem inalterados.",
    "media.replace_failed": "Não é possível substituir a mídia",
    "Unable to replace media": "Não é possível substituir a mídia",
    "media.csv_upload_failed": "Falha ao fazer upload do CSV",
    "CSV upload failed": "Falha ao fazer upload do CSV",
    "media.csv_metadata_failed": "Não é possível salvar os metadados do CSV",
    "Unable to save CSV metadata": "Não é possível salvar os metadados do CSV",
    "media.csv_saved_version": "CSV salvo como nova versão",
    "CSV saved as a new version": "CSV salvo como nova versão",
    "media.csv_save_failed": "Não é possível salvar o CSV",
    "Unable to save CSV": "Não é possível salvar o CSV",
    "media.uploading_files": "Enviando {count} arquivos…",
    "Uploading {count} files…": "Enviando {count} arquivos…",
    "media.upload_progress": "Enviando {count} arquivos · {progress}%",
    "Uploading {count} files · {progress}%": "Enviando {count} arquivos · {progress}%",
    "media.upload_success": "{count} arquivos enviados com sucesso.",
    "{count} files uploaded successfully.": "{count} arquivos enviados com sucesso.",
    "media.upload_failed_retry": "Não é possível fazer upload da mídia. Por favor, tente novamente.",
    "media.register_failed": "Não é possível registrar a mídia",
    "Unable to register media": "Não é possível registrar a mídia",
    "media.list_view": "Visualização em lista",
    "media.grid_view": "Visualização em grade",
    "media.copy_uploaded_urls": "Copiar URLs carregadas",
    "Copy uploaded URLs": "Copiar URLs carregadas",
    "media.copy_visible_urls": "Copiar URLs visíveis",
    "Copy visible URLs": "Copiar URLs visíveis",
    "media.copy_all_urls": "Copiar todas as URLs",
    "Copy all URLs": "Copiar todas as URLs",
    "media.new_folder": "Nova pasta",
    "New folder": "Nova pasta",
    "media.uploading_progress": "Enviando {progress}%",
    "Uploading {progress}%": "Enviando {progress}%",
    "media.upload_media": "Enviar mídia",
    "Upload media": "Enviar mídia",
    "media.manager_title": "Gerenciador de mídia",
    "Media Manager": "Gerenciador de mídia",
    "media.search": "Pesquisar mídia",
    "Search media": "Pesquisar mídia",
    "media.location": "Localização",
    "media.media_root": "Mídia",
    "media.show_type": "Mostrar mídia {type}",
    "media.type_all": "todos",
    "all": "todos",
    "media.type_image": "imagem",
    "image": "imagem",
    "media.type_video": "vídeo",
    "video": "vídeo",
    "media.type_audio": "áudio",
    "audio": "áudio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "pasta",
    "folder": "pasta",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Mais antigo",
    "Oldest": "Mais antigo",
    "media.newest": "Mais recente",
    "Newest": "Mais recente",
    "media.sort_current": "Ordenar mídia, atualmente {sort}",
    "Sort media, currently {sort}": "Ordenar mídia, atualmente {sort}",
    "media.loading": "Carregando mídia…",
    "Loading media…": "Carregando mídia…",
    "media.no_filter_matches": "Nenhuma mídia corresponde a esses filtros.",
    "No media matches these filters.": "Nenhuma mídia corresponde a esses filtros.",
    "media.empty_title": "Sua biblioteca de mídia está vazia",
    "Your media library is empty": "Sua biblioteca de mídia está vazia",
    "media.empty_message": "Envie imagens, PDFs, vídeos para reutilizar em casos como promoção, artigo, etc.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Envie imagens, PDFs, vídeos para reutilizar em casos como promoção, artigo, etc.",
    "media.empty_hint": "Envie arquivos ou crie uma pasta para começar.",
    "Upload files or create a folder to get started.": "Envie arquivos ou crie uma pasta para começar.",
    "media.folder": "Pasta",
    "Folder": "Pasta",
    "media.file_folder_name": "Nome do arquivo ou pasta",
    "File or folder name": "Nome do arquivo ou pasta",
    "media.rename_media": "Renomear mídia",
    "Rename media": "Renomear mídia",
    "media.move_media": "Mover mídia",
    "Move media": "Mover mídia",
    "media.pdf_preview": "Visualização do PDF: {name}",
    "PDF preview: {name}": "Visualização do PDF: {name}",
    "media.pdf_preview_web": "Visualização de PDF disponível no aplicativo da web.",
    "PDF preview is available in the web app.": "Visualização de PDF disponível no aplicativo da web.",
    "media.csv_preview_web": "Visualização de CSV disponível no aplicativo da web.",
    "CSV preview is available in the web app.": "Visualização de CSV disponível no aplicativo da web.",
    "media.media_file": "Arquivo de mídia",
    "Media file": "Arquivo de mídia",
    "media.share_link": "Link para compartilhar",
    "Share link": "Link para compartilhar",
    "media.copy_link": "Copiar link",
    "Copy link": "Copiar link",
    "media.replace_media": "Substituir mídia",
    "Replace media": "Substituir mídia",
    "media.folders": "Pastas",
    "Folders": "Pastas",
    "media.create_new_folder": "Criar nova pasta",
    "Create new folder": "Criar nova pasta",
    "media.go_to_all_media": "Ir para todos os meios",
    "Go to all media": "Ir para todos os meios",
    "media.all_media": "Todos os meios",
    "All media": "Todos os meios",
    "media.open_folder_name": "Abrir pasta {name}",
    "Open folder {name}": "Abrir pasta {name}",
    "media.no_subfolders": "Sem subpastas",
    "No subfolders": "Sem subpastas",
    "media.no_files_in_folder": "Não há arquivos nesta pasta.",
    "No files in this folder.": "Não há arquivos nesta pasta.",
    "media.upload_folder": "Enviar mídia para esta pasta",
    "Upload media to this folder": "Enviar mídia para esta pasta",
    "media.discard_csv_confirm": "Descartar alterações no CSV?",
    "Discard your CSV changes?": "Descartar alterações no CSV?",
    "media.unsaved_changes": "Alterações não salvas",
    "Unsaved changes": "Alterações não salvas",
    "media.find_csv": "Buscar no CSV",
    "Find in CSV": "Buscar no CSV",
    "media.save_csv": "Salvar CSV",
    "Save CSV": "Salvar CSV",
    "media.loading_csv": "Carregando CSV…",
    "Loading CSV…": "Carregando CSV…",
    "media.prepare_folder_failed": "Não é possível preparar a pasta de upload",
    "Unable to prepare the upload folder": "Não é possível preparar a pasta de upload",
    "media.add_file_required": "Adicione um arquivo",
    "Please add a file": "Adicione um arquivo",
    "media.add_media": "Adicionar Mídia",
    "Add Media": "Adicionar Mídia",
    "media.store_uploaded_media_in": "Armazenar mídia carregada em",
    "Store uploaded media in": "Armazenar mídia carregada em",
    "media.destination_business_cards": "Cartões de visita",
    "Business Cards": "Cartões de visita",
    "media.destination_listings": "Listagens",
    "media.destination_accounts": "Contas",
    "media.destination_users": "Usuários",
    "media.upload_media_title": "Enviar Mídia",
    "media.media_files": "Mídia",
    "media.open_folder": "Abrir pasta",
    "Open folder": "Abrir pasta",
    "common.show": "Exibir",
    "common.share": "Compartilhar",
    "Share": "Compartilhar",
    "common.copy": "Copiar",
    "common.rename": "Renomear",
    "Rename": "Renomear",
    "common.move": "Mover",
    "Move": "Mover",
    "common.type": "Tipo",
    "common.size": "Tamanho",
    "Size": "Tamanho",
    "common.preview": "Visualizar",
    "common.undo": "Desfazer",
    "Undo": "Desfazer",
    "common.redo": "Refazer",
    "Redo": "Refazer",
    "common.discard": "Descartar",
    "Discard": "Descartar",
    "common.try_again": "Tentar novamente",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Planilha",
    "Spreadsheet": "Planilha",
    "media.type_file": "Arquivo",
    "File": "Arquivo",
    "media.csv_load_failed": "Não é possível carregar o CSV. Tente novamente.",
    "Unable to load CSV. Please try again.": "Não é possível carregar o CSV. Tente novamente.",
    "workspace.settings_section.customisation": "Personalização",
    "workspace.settings_section.integrations": "Integrações",
    "workspace.settings_section.platform_setup": "Configuração da Plataforma",
    "Platform Setup": "Configuração da Plataforma",
    "workspace.settings_section.business_operations": "Operações Comerciais",
    "Business Operations": "Operações Comerciais",
    "workspace.settings_section.system_setup": "Configuração do Sistema",
    "System Setup": "Configuração do Sistema",
    "workspace.settings_item.app_customisation": "Personalização do Aplicativo",
    "workspace.settings_item.web_customisation": "Personalização Web",
    "workspace.settings_item.communications": "Comunicações",
    "Communications": "Comunicações",
    "workspace.settings_item.strings_customisation": "Personalização de Strings",
    "workspace.settings_item.app_integrations": "Integrações do Aplicativo",
    "workspace.settings_item.web_integrations": "Integrações Web",
    "Web Integrations": "Integrações Web",
    "workspace.settings_item.accounts": "Contas",
    "workspace.settings_item.listings": "Listagens",
    "workspace.settings_item.checkout_and_cart_attributes": "Atributos de Checkout e Carrinho",
    "workspace.settings_item.service_shipping": "Serviço / Envio",
    "workspace.settings_item.payments": "Pagamentos",
    "workspace.settings_item.commissions": "Comissões",
    "workspace.settings_item.taxes": "Impostos",
    "workspace.settings_item.special_fees": "Taxas Especiais",
    "workspace.settings_item.languages": "Idiomas",
    "workspace.settings_item.currency": "Moeda",
    "workspace.settings_item.countries": "Países",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Extensões",
    "Extensions": "Extensões",
    "workspace.settings_item.manage_features": "Gerenciar recursos",
    "Manage Features": "Gerenciar recursos",
    "workspace.settings_item.audit_logs": "Logs de auditoria",
    "workspace.settings_item.auth": "Autenticação",
    "workspace.settings_item.maps": "Mapas",
    "workspace.settings_hint.accounts": "Exemplo: Loja",
    "Example: Store": "Exemplo: Loja",
    "workspace.settings_hint.listings": "Exemplo: Produtos, Eventos",
    "Example: Products, Events": "Exemplo: Produtos, Eventos",
    "workspace.settings_hint.audit_logs": "Rastro de conformidade e segurança",
    "Compliance & security trail": "Rastro de conformidade e segurança",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Configuração de provedor e privacidade",
    "Provider usage and privacy settings": "Configuração de provedor e privacidade",
    "workspace.settings_access_denied": "Você não tem acesso a {name}",
    "You don't have access of {name}": "Você não tem acesso a {name}",
    "app_customization.title": "Personalização do aplicativo",
    "app_customization.tab_0": "Geral",
    "General": "Geral",
    "app_customization.tab_1": "Tela inicial",
    "Splash": "Tela inicial",
    "app_customization.tab_2": "Apresentação inicial",
    "Onboarding": "Apresentação inicial",
    "app_customization.tab_3": "Registro",
    "Registration": "Registro",
    "app_customization.tab_4": "Início",
    "Home": "Início",
    "app_customization.tab_5": "Notificações por push",
    "Push Notification": "Notificações por push",
    "app_customization.tab_6": "Chat",
    "Chat": "Chat",
    "app_customization.tab_7": "Mais menu",
    "More Menu": "Mais menu",
    "app_customization.tab_8": "Atualização forçada",
    "Force Update": "Atualização forçada",
    "app_customization.tab_9": "Endereço",
    "app_customization.hide_balances": "Ocultar saldos e pagamentos na seção Mais",
    "app_customization.more": "Mais",
    "app_customization.force_update": "Forçar atualização",
    "Force To Update": "Forçar atualização",
    "app_customization.android_version": "Versão do aplicativo Android",
    "Android app version": "Versão do aplicativo Android",
    "app_customization.enter_android_version": "Insira a versão do aplicativo Android",
    "Enter android app version": "Insira a versão do aplicativo Android",
    "app_customization.ios_version": "Versão do aplicativo iOS",
    "iOS app version": "Versão do aplicativo iOS",
    "app_customization.enter_ios_version": "Insira a versão do aplicativo iOS",
    "Enter iOS app version": "Insira a versão do aplicativo iOS",
    "app_customization.chat": "Chat",
    "app_customization.chat_send_listing": "Habilitar envio automático de listagens ao clicar no chat (Padrão mostra prévia no topo)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Habilitar envio automático de listagens ao clicar no chat (Padrão mostra prévia no topo)",
    "app_customization.make_offer": "Fazer oferta / Negociação",
    "Make Offer / Negotiation": "Fazer oferta / Negociação",
    "app_customization.negotiation_button_name": "Nome do botão de negociação:",
    "Negotiation button name:": "Nome do botão de negociação:",
    "app_customization.negotiation_button_example": "(exemplo: Fazer oferta, Negociar, Cotar)",
    "(example: Make Offer, Negotiate, Quote)": "(exemplo: Fazer oferta, Negociar, Cotar)",
    "app_customization.enter_negotiation_button_name": "Insira o nome do botão de negociação",
    "Enter negotiation button name": "Insira o nome do botão de negociação",
    "app_customization.address": "Endereço",
    "app_customization.address_option_0": "Mostrar Endereço 2",
    "Show Address 2": "Mostrar Endereço 2",
    "app_customization.address_option_1": "Mostrar País",
    "Show Country": "Mostrar País",
    "app_customization.address_option_2": "Mostrar CEP",
    "Show Zipcode": "Mostrar CEP",
    "app_customization.address_option_3": "Mostrar Estado",
    "Show State": "Mostrar Estado",
    "app_customization.address_option_4": "Mostrar Ponto de Referência",
    "Show Landmark": "Mostrar Ponto de Referência",
    "app_customization.address_option_5": "Mostrar Cidade",
    "Show City": "Mostrar Cidade",
    "app_customization.persistent_notification": "Notificação persistente",
    "Persistent Notification": "Notificação persistente",
    "app_customization.account_follow_content": "Conteúdo da notificação de seguimento de conta",
    "Account follow notification content": "Conteúdo da notificação de seguimento de conta",
    "app_customization.enter_account_follow_content": "Insira o conteúdo da notificação de seguimento de conta",
    "Enter Account follow notification content": "Insira o conteúdo da notificação de seguimento de conta",
    "app_customization.listing_like_content": "Conteúdo da notificação de curtida em lista",
    "Listing like notification content": "Conteúdo da notificação de curtida em lista",
    "app_customization.enter_listing_like_content": "Insira o conteúdo de notificação como anúncio",
    "Enter Listing like  notification content": "Insira o conteúdo de notificação como anúncio",
    "app_customization.order_status_content": "Conteúdo da notificação de status do pedido",
    "Order status notification content": "Conteúdo da notificação de status do pedido",
    "app_customization.enter_order_status_content": "Conteúdo da notificação de acompanhamento de status do pedido",
    "Order status follow notification content": "Conteúdo da notificação de acompanhamento de status do pedido",
    "app_customization.account_follow_required": "A notificação de follow de conta deve conter {account_name}",
    "app_customization.listing_like_required": "O conteúdo da notificação de like no anúncio deve conter {user_name}",
    "Listing like notification content should contain {user_name}": "O conteúdo da notificação de like no anúncio deve conter {user_name}",
    "app_customization.order_number_required": "O conteúdo da notificação de status do pedido deve conter #{order_number}",
    "Order status notification content should contain #{order_number}": "O conteúdo da notificação de status do pedido deve conter #{order_number}",
    "app_customization.order_status_required": "O conteúdo da notificação de status do pedido deve conter {order_status}",
    "Order status notification content should contain {order_status}": "O conteúdo da notificação de status do pedido deve conter {order_status}",
    "app_customization.preview": "Pré-visualização",
    "app_customization.splash": "Tela inicial",
    "app_customization.splash_image": "Imagem de tela de splash",
    "Splash Screen Image": "Imagem de tela de splash",
    "app_customization.registration": "Registro",
    "app_customization.registration_text": "Texto de registro",
    "Registration text": "Texto de registro",
    "app_customization.otp_note": "Nota de verificação OTP",
    "OTP Verification note": "Nota de verificação OTP",
    "app_customization.get_signup_first": "Obter registro primeiro",
    "app_customization.mobile_in_email_signup": "Número de celular no registro por e-mail",
    "Mobile number in email signup": "Número de celular no registro por e-mail",
    "app_customization.preview_field_first_name": "Nome",
    "app_customization.preview_field_last_name": "Sobrenome",
    "app_customization.preview_field_email": "E-mail",
    "app_customization.preview_field_password": "Senha",
    "Password": "Senha",
    "app_customization.preview_field_confirm_password": "Confirmar senha",
    "Confirm Password": "Confirmar senha",
    "app_customization.preview_field_dob": "Data de nascimento",
    "DOB": "Data de nascimento",
    "app_customization.preview_field_mobile_no": "Número de celular",
    "Mobile No": "Número de celular",
    "app_customization.create": "Criar",
    "app_customization.login": "Entrar",
    "Login": "Entrar",
    "app_customization.create_account": "Criar sua conta",
    "Create your account": "Criar sua conta",
    "app_customization.login_account": "Entrar na sua conta",
    "Login to your account": "Entrar na sua conta",
    "app_customization.onboarding_settings": "Configurações de boas-vindas",
    "Onboarding Settings": "Configurações de boas-vindas",
    "app_customization.onboarding_images": "Imagens de boas-vindas",
    "Onboarding Images": "Imagens de boas-vindas",
    "app_customization.onboarding_text_1": "Texto de boas-vindas 1",
    "Onboarding text 1": "Texto de boas-vindas 1",
    "app_customization.onboarding_text_2": "Texto de boas-vindas 2",
    "Onboarding text 2": "Texto de boas-vindas 2",
    "app_customization.onboarding_text_3": "Texto de boas-vindas 3",
    "Onboarding text 3": "Texto de boas-vindas 3",
    "app_customization.see_how_it_works": "Veja como funciona",
    "See how it works": "Veja como funciona",
    "app_customization.sell_icon_text": "Texto do ícone de venda",
    "Sell icon text": "Texto do ícone de venda",
    "app_customization.enter_sell_icon_text": "Insira o texto do ícone de venda",
    "Enter sell icon text": "Insira o texto do ícone de venda",
    "app_customization.sell_icon": "Ícone de venda",
    "Sell Icon": "Ícone de venda",
    "app_customization.enter_home_title": "Insira o título do aplicativo na tela inicial",
    "Enter app title in home": "Insira o título do aplicativo na tela inicial",
    "app_customization.app_details": "Detalhes do aplicativo",
    "App Details": "Detalhes do aplicativo",
    "app_customization.app_name": "Nome do aplicativo",
    "App Name": "Nome do aplicativo",
    "app_customization.primary_colour": "Cor primária do aplicativo",
    "App Primary Colour": "Cor primária do aplicativo",
    "app_customization.secondary_colour": "Cor secundária do aplicativo",
    "App Secondary Colour": "Cor secundária do aplicativo",
    "app_customization.android_app_icon": "Ícone do aplicativo Android",
    "App Icon Android": "Ícone do aplicativo Android",
    "app_customization.ios_app_icon": "Ícone do aplicativo iOS",
    "App Icon iOS": "Ícone do aplicativo iOS",
    "app_customization.screen_number": "Tela {number}",
    "Screen {number}": "Tela {number}",
    "app_customization.upload_here": "Carregar aqui",
    "app_customization.next": "Próximo",
    "app_customization.get_started": "Começar",
    "Get Start": "Começar",
    "app_customization.select": "Selecionar",
    "Select": "Selecionar",
    "app_customization.app_title_home_icon": "Título do aplicativo no ícone inicial",
    "App Title Home Icon": "Título do aplicativo no ícone inicial",
    "app_customization.home_icon_hint": "(o ícone deve ser branco e no formato png)",
    "(icon should be white and in png format)": "(o ícone deve ser branco e no formato png)",
    "app_customization.home_title": "Título do aplicativo na tela inicial",
    "App title in home screen": "Título do aplicativo na tela inicial",
    "app_customization.default_collection_widgets": "Widgets padrão da coleção",
    "Default Collection Widgets": "Widgets padrão da coleção",
    "app_customization.accounts_follow_title": "Título da coleção 'Contas para seguir'",
    "Accounts to follow collection title": "Título da coleção 'Contas para seguir'",
    "app_customization.enter_accounts_follow_title": "Insira o título da coleção 'Contas para seguir'",
    "Enter accounts to follow collection title": "Insira o título da coleção 'Contas para seguir'",
    "app_customization.nearby_accounts_title": "Título da coleção 'Contas próximas'",
    "Nearby accounts collection title": "Título da coleção 'Contas próximas'",
    "app_customization.enter_nearby_accounts_title": "Insira o título da coleção 'Contas próximas'",
    "Enter near by accounts collection title": "Insira o título da coleção 'Contas próximas'",
    "app_customization.latest_listings_title": "Título da coleção 'Listagens recentes'",
    "Latest listings collection title": "Título da coleção 'Listagens recentes'",
    "app_customization.enter_latest_listings_title": "Insira o título da coleção 'Listagens recentes'",
    "Enter latest listings collection title": "Insira o título da coleção 'Listagens recentes'",
    "app_customization.enable_appearance_sections": "Selecione para habilitar as seções de aparência",
    "Select to enable appearance sections": "Selecione para habilitar as seções de aparência",
    "app_customization.choose_photo": "Escolher foto",
    "Choose photo": "Escolher foto",
    "app_customization.choose_icon": "Escolher ícone",
    "Choose icon": "Escolher ícone",
    "app_customization.enable_home_icon": "Habilitar ícone de título do aplicativo em vez de texto",
    "Enable app title icon instead of text": "Habilitar ícone de título do aplicativo em vez de texto",
    "app_customization.account_name": "Nome da conta",
    "Account Name": "Nome da conta",
    "app_customization.product_name": "Nome do produto",
    "Product Name": "Nome do produto",
    "app_customization.home_option_0": "Mostrar coleção 'Próximas'",
    "Show nearby collection": "Mostrar coleção 'Próximas'",
    "app_customization.home_option_1": "Mostrar seção de categorias",
    "Show category section": "Mostrar seção de categorias",
    "app_customization.home_option_2": "Mostrar banners promocionais",
    "Show promo banners": "Mostrar banners promocionais",
    "app_customization.home_option_3": "Mostrar convite para amigos",
    "Show invite friends": "Mostrar convite para amigos",
    "app_customization.home_option_4": "Mostrar lembretes de avaliações",
    "Show review reminders": "Mostrar lembretes de avaliações",
    "app_customization.home_option_5": "Contas para seguir",
    "Accounts to follow": "Contas para seguir",
    "app_customization.download": "Baixar",
    "app_customization.cancel": "Cancelar",
    "app_customization.uploaded_successfully": "Enviado com sucesso",
    "Uploaded successfully": "Enviado com sucesso",
    "app_customization.image_limit": "Você não pode selecionar mais imagens",
    "You cannot select more images": "Você não pode selecionar mais imagens",
    "app_customization.choose_zip_file": "Escolher arquivo zip",
    "Choose zip file": "Escolher arquivo zip",
    "app_translation.title": "Personalização de strings",
    "app_translation.search": "Digite para pesquisar...",
    "Type to search...": "Digite para pesquisar...",
    "app_translation.default_language": "Padrão",
    "Default": "Padrão",
    "app_translation.default_text": "Texto padrão",
    "Default text": "Texto padrão",
    "communications.title": "Comunicações",
    "communications.tab_0": "Notificação por e-mail",
    "Email Notification": "Notificação por e-mail",
    "communications.tab_1": "Configuração de e-mail",
    "Email Configuration": "Configuração de e-mail",
    "communications.tab_2": "Notificação de pedido",
    "Order Notification": "Notificação de pedido",
    "communications.tab_3": "Formulário de feedback",
    "Feedback Form": "Formulário de feedback",
    "communications.translate": "Traduzir",
    "Translate": "Traduzir",
    "communications.edit_email_template": "Editar modelo de e-mail",
    "Edit email template": "Editar modelo de e-mail",
    "communications.feedback_email": "E-mail",
    "communications.feedback_phone": "Telefone",
    "communications.feedback_email_or_phone": "E-mail ou telefone",
    "Email or Phone": "E-mail ou telefone",
    "communications.select_type": "Selecionar tipo",
    "Select type": "Selecionar tipo",
    "communications.form_required_field": "Campo obrigatório do formulário",
    "Form Required Field": "Campo obrigatório do formulário",
    "communications.feedback_recipient_label": "E-mail para receber feedback (Para mais de um e-mail, insira separado por vírgulas)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "E-mail para receber feedback (Para mais de um e-mail, insira separado por vírgulas)",
    "communications.enter_email": "Digite o e-mail",
    "Enter email": "Digite o e-mail",
    "communications.enable_feedback_form": "Habilitar formulário de feedback",
    "Enable feedback Form": "Habilitar formulário de feedback",
    "communications.feedback": "Feedback",
    "Feedback": "Feedback",
    "communications.realtime_config_notice": "Essas configurações são aplicadas em tempo real. Ao fazer alterações aqui e clicar em Salvar, elas serão refletidas nos aplicativos e respostas da API.",
    "This below configs are applied on realtime. When you make the changes here and click Save, it will be reflected in apps and API response.": "Essas configurações são aplicadas em tempo real. Ao fazer alterações aqui e clicar em Salvar, elas serão refletidas nos aplicativos e respostas da API.",
    "communications.uploaded_successfully": "Enviado com sucesso",
    "communications.email_whitelabeling": "Personalização de marca branca para email",
    "Email Whitelabelling": "Personalização de marca branca para email",
    "communications.from_name": "Nome do remetente",
    "From name": "Nome do remetente",
    "communications.enter_from_name": "Insira o nome do remetente",
    "Enter from name": "Insira o nome do remetente",
    "communications.from_email_address": "Endereço de e-mail do remetente",
    "From email address": "Endereço de e-mail do remetente",
    "communications.from_email_domain_hint": "Você escolheu um domínio personalizado para seu endereço de e-mail de remetente. Para garantir que seus e-mails sejam entregues, verifique seu domínio conosco. Entre em contato com nossa equipe de suporte para assistência no processo de verificação.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Você escolheu um domínio personalizado para seu endereço de e-mail de remetente. Para garantir que seus e-mails sejam entregues, verifique seu domínio conosco. Entre em contato com nossa equipe de suporte para assistência no processo de verificação.",
    "communications.reset": "Redefinir",
    "communications.enter_from_email": "Insira o endereço de e-mail do remetente",
    "Enter from email address": "Insira o endereço de e-mail do remetente",
    "communications.email_header_logo": "Logotipo do cabeçalho de e-mail",
    "Email Header Logo": "Logotipo do cabeçalho de e-mail",
    "communications.choose_logo": "Escolher arquivo 50*50",
    "Choose file 50*50": "Escolher arquivo 50*50",
    "communications.list_view": "Visualização em lista",
    "communications.gallery_view": "Visualização em galeria",
    "Gallery view": "Visualização em galeria",
    "communications.grid_view": "Visualização em grade",
    "communications.search": "Pesquisar comunicações",
    "Search communications": "Pesquisar comunicações",
    "communications.email_settings": "Configuração de e-mail",
    "Email settings": "Configuração de e-mail",
    "communications.category_all": "Todos",
    "communications.category_buyer": "Comprador",
    "Buyer": "Comprador",
    "communications.category_seller": "Vendedor",
    "communications.category_transactional": "Transacional",
    "Transactional": "Transacional",
    "communications.category_engagement": "Compromisso",
    "Engagement": "Compromisso",
    "communications.category_retention": "Retenção",
    "Retention": "Retenção",
    "communications.category_membership": "Membro",
    "communications.audience_buyer": "Comprador",
    "communications.audience_seller": "Vendedor",
    "communications.system_notification": "Notificação do sistema",
    "System notification": "Notificação do sistema",
    "communications.template": "modelo",
    "template": "modelo",
    "communications.edit": "Editar",
    "communications.sent": "enviado",
    "sent": "enviado",
    "communications.open": "aberto",
    "communications.clicks": "cliques",
    "clicks": "cliques",
    "communications.no_email_matches": "Nenhum e-mail corresponde ao seu filtro.",
    "No emails match your filter.": "Nenhum e-mail corresponde ao seu filtro.",
    "communications.buyer_order_confirmation": "E-mail de confirmação de pedido para comprador",
    "Order confirmation email for buyer": "E-mail de confirmação de pedido para comprador",
    "communications.seller_order_confirmation": "E-mail de confirmação de pedido para vendedor",
    "Order confirmation email for seller": "E-mail de confirmação de pedido para vendedor",
    "communications.email_card_0": "Mensagem de boas-vindas",
    "Welcome Message": "Mensagem de boas-vindas",
    "communications.email_card_1": "OTP / Verificação",
    "OTP / Verification": "OTP / Verificação",
    "communications.email_card_2": "Link de inscrição",
    "Subscription Link": "Link de inscrição",
    "communications.email_card_3": "Inscrever-se com sucesso",
    "Subscription Success": "Inscrever-se com sucesso",
    "communications.email_card_4": "Confirmação de pedido — comprador",
    "Order confirmation — buyer": "Confirmação de pedido — comprador",
    "communications.email_card_5": "Confirmação de pedido — vendedor",
    "Order confirmation — seller": "Confirmação de pedido — vendedor",
    "communications.email_card_6": "Envio enviado — comprador",
    "Shipment shipped — buyer": "Envio enviado — comprador",
    "communications.email_card_7": "Entrega realizada — comprador",
    "Shipment delivered — buyer": "Entrega realizada — comprador",
    "communications.email_card_8": "Pedido cancelado — comprador",
    "Order cancelled — buyer": "Pedido cancelado — comprador",
    "communications.email_card_9": "Reembolso processado — comprador",
    "Refund processed — buyer": "Reembolso processado — comprador",
    "communications.email_card_10": "Nova lista de loja seguida — comprador",
    "New listing from followed store — buyer": "Nova lista de loja seguida — comprador",
    "communications.email_card_11": "Produto de novo em estoque — comprador",
    "Back in stock — buyer": "Produto de novo em estoque — comprador",
    "communications.email_card_12": "Aviso de vencimento de lista — vendedor",
    "Listing expiry warning — seller": "Aviso de vencimento de lista — vendedor",
    "communications.email_card_13": "Marcar likes na lista — vendedor",
    "Listing likes milestone — seller": "Marcar likes na lista — vendedor",
    "communications.email_card_14": "Conta verificada — vendedor",
    "Account verified — seller": "Conta verificada — vendedor",
    "communications.email_card_15": "Recuperação de vendedor — vendedor",
    "Seller win-back — seller": "Recuperação de vendedor — vendedor",
    "communications.email_card_16": "Aviso de estoque baixo — vendedor",
    "Low stock warning — seller": "Aviso de estoque baixo — vendedor",
    "communications.email_card_17": "Vendedor cadastrado — vendedor",
    "Seller onboarded — seller": "Vendedor cadastrado — vendedor",
    "communications.email_card_18": "Solicitação de avaliação — comprador",
    "Review request — buyer": "Solicitação de avaliação — comprador",
    "communications.email_card_19": "Primeira venda — vendedor",
    "First sale — seller": "Primeira venda — vendedor",
    "communications.email_card_20": "Marco de vendas — vendedor",
    "Sales milestone — seller": "Marco de vendas — vendedor",
    "communications.email_card_21": "Recuperação de cliente — comprador",
    "Win-back — buyer": "Recuperação de cliente — comprador",
    "communications.email_card_22": "Primeira compra — comprador",
    "First purchase — buyer": "Primeira compra — comprador",
    "communications.email_card_23": "Pergunta do cliente — vendedor",
    "Customer question — seller": "Pergunta do cliente — vendedor",
    "communications.email_card_24": "Resposta do vendedor — comprador",
    "Seller answer — buyer": "Resposta do vendedor — comprador",
    "communications.email_card_25": "Oferta de negociação — vendedor",
    "Negotiation offer — seller": "Oferta de negociação — vendedor",
    "communications.email_card_26": "Oferta aceita — comprador",
    "Offer accepted — buyer": "Oferta aceita — comprador",
    "communications.email_card_27": "Oferta recusada — comprador",
    "Offer rejected — buyer": "Oferta recusada — comprador",
    "communications.email_card_28": "Novo seguidor — vendedor",
    "New follower — seller": "Novo seguidor — vendedor",
    "communications.email_card_29": "Listagem favorita — vendedor",
    "Listing liked — seller": "Listagem favorita — vendedor",
    "communications.email_card_30": "Listagem aprovada — vendedor",
    "Listing approved — seller": "Listagem aprovada — vendedor",
    "communications.email_card_31": "Listagem rejeitada — vendedor",
    "Listing rejected — seller": "Listagem rejeitada — vendedor",
    "communications.email_card_32": "Primeira listagem — vendedor",
    "First listing — seller": "Primeira listagem — vendedor",
    "communications.email_card_33": "Carrinho abandonado — comprador",
    "Abandoned cart — buyer": "Carrinho abandonado — comprador",
    "communications.email_card_34": "Avaliação da listagem — vendedor",
    "Listing review — seller": "Avaliação da listagem — vendedor",
    "communications.email_card_35": "Lembrete de cumprimento — vendedor",
    "Fulfillment reminder — seller": "Lembrete de cumprimento — vendedor",
    "communications.email_card_36": "Queda de preço — comprador",
    "Price drop — buyer": "Queda de preço — comprador",
    "communications.email_card_37": "Pagamento de associação próximo",
    "Membership payment due soon": "Pagamento de associação próximo",
    "communications.email_card_38": "Pagamento de associação vencido",
    "Membership payment overdue": "Pagamento de associação vencido",
    "communications.order_status_notification": "Notificação de status do pedido",
    "Order Status Notification": "Notificação de status do pedido",
    "communications.order_group_lifecycle": "Ciclo de vida do pedido",
    "Order lifecycle": "Ciclo de vida do pedido",
    "communications.order_group_returns": "Devoluções e problemas de entrega",
    "Returns and delivery issues": "Devoluções e problemas de entrega",
    "communications.order_group_cancellations": "Cancelamentos e retirada",
    "Cancellations and pickup": "Cancelamentos e retirada",
    "communications.notification_settings_count": "{count} configurações de notificação",
    "{count} notification settings": "{count} configurações de notificação",
    "communications.enter_order_field": "Insira {field}",
    "Enter {field}": "Insira {field}",
    "communications.order_field_0": "Status do pedido confirmado",
    "Order status confirmed": "Status do pedido confirmado",
    "communications.order_field_1": "Status do pedido em andamento",
    "Order status in progress": "Status do pedido em andamento",
    "communications.order_field_2": "Status do pedido enviado",
    "Order status shipped": "Status do pedido enviado",
    "communications.order_field_3": "Status do pedido cliente não localizado",
    "Order status customer unreachable": "Status do pedido cliente não localizado",
    "communications.order_field_4": "Status do pedido em trânsito para entrega",
    "Order status out for delivery": "Status do pedido em trânsito para entrega",
    "communications.order_field_5": "Status do pedido não entregue devolvido",
    "Order status undelivered returned": "Status do pedido não entregue devolvido",
    "communications.order_field_6": "Status do pedido não entregue devolvido confirmado",
    "Order status undelivered return confirmed": "Status do pedido não entregue devolvido confirmado",
    "communications.order_field_7": "Status do pedido entregue",
    "Order status delivered": "Status do pedido entregue",
    "communications.order_field_8": "Status do pedido entregue confirmado",
    "Order status delivered confirmed": "Status do pedido entregue confirmado",
    "communications.order_field_9": "Status do pedido devolução iniciada pelo cliente",
    "Order status customer return initiated": "Status do pedido devolução iniciada pelo cliente",
    "communications.order_field_10": "Status do pedido devolução recolhida pelo cliente",
    "Order status customer return picked": "Status do pedido devolução recolhida pelo cliente",
    "communications.order_field_11": "Status do pedido devolução confirmada pelo cliente",
    "Order status customer return confirmed": "Status do pedido devolução confirmada pelo cliente",
    "communications.order_field_12": "Status do pedido devolução disputada pelo cliente",
    "Order status customer return disputed": "Status do pedido devolução disputada pelo cliente",
    "communications.order_field_13": "Status do pedido cancelado pela conta",
    "Order status cancelled by account": "Status do pedido cancelado pela conta",
    "communications.order_field_14": "Status do pedido cancelado pelo cliente",
    "Order status cancelled by customer": "Status do pedido cancelado pelo cliente",
    "communications.order_field_15": "Status do pedido pronto para retirada",
    "Order status ready for pickup": "Status do pedido pronto para retirada",
    "communications.order_field_16": "Status do pedido concluído",
    "Order status completed": "Status do pedido concluído",
    "communications.update": "Atualizar",
    "communications.download_template": "Baixar modelo",
    "Download Template": "Baixar modelo",
    "communications.reset_to_default": "Redefinir para padrão",
    "Reset to default": "Redefinir para padrão",
    "communications.send_test_email": "Enviar e-mail de teste",
    "Send test email": "Enviar e-mail de teste",
    "communications.enter_test_emails": "Insira o(s) e-mail(s), separado(s) por vírgula",
    "Enter email(s), comma-separated": "Insira o(s) e-mail(s), separado(s) por vírgula",
    "communications.send_test": "Enviar teste",
    "Send test": "Enviar teste",
    "communications.subject_required": "O assunto não deve estar vazio",
    "Subject should not be empty": "O assunto não deve estar vazio",
    "communications.body_required": "O corpo não deve estar vazio",
    "Body should not be empty": "O corpo não deve estar vazio",
    "communications.code_merge_tag_required": "A tag de fusão {code} é obrigatória",
    "{code} merge tag is mandatory": "A tag de fusão {code} é obrigatória",
    "communications.edit_template_named": "Editar {name}",
    "Edit {name}": "Editar {name}",
    "communications.subject": "Assunto",
    "Subject": "Assunto",
    "communications.enter_subject": "Insira o assunto",
    "Enter the Subject": "Insira o assunto",
    "communications.available_merge_tags": "Tags de fusão disponíveis:",
    "Available merge tags:": "Tags de fusão disponíveis:",
    "communications.body": "Corpo",
    "Body": "Corpo",
    "communications.write_here": "Escreva aqui...",
    "Write here...": "Escreva aqui...",
    "communications.subject_line": "Linha do assunto",
    "Subject Line": "Linha do assunto",
    "communications.enter_subject_line": "Insira o assunto…",
    "Enter the subject…": "Insira o assunto…",
    "communications.merge_tags": "Tags de fusão",
    "Merge tags": "Tags de fusão",
    "communications.loading_templates": "Carregando modelos…",
    "Loading templates…": "Carregando modelos…",
    "communications.hide_templates": "Ocultar modelos",
    "Hide templates": "Ocultar modelos",
    "communications.load_template": "Carregar modelo",
    "Load template": "Carregar modelo",
    "communications.html_body": "Corpo HTML",
    "HTML Body": "Corpo HTML",
    "communications.enter_html_body": "Cole ou digite seu HTML aqui…",
    "Paste or type your HTML here…": "Cole ou digite seu HTML aqui…",
    "communications.live_preview": "Visualização ao vivo",
    "Live Preview": "Visualização ao vivo",
    "communications.desktop": "Desktop",
    "Desktop": "Desktop",
    "communications.mobile": "Móvel",
    "communications.email_preview": "Visualização de e-mail",
    "Email preview": "Visualização de e-mail",
    "communications.start_typing_preview": "Comece a digitar para ver uma prévia",
    "Start typing to see a preview": "Comece a digitar para ver uma prévia",
    "communications.translations": "traduções",
    "translations": "traduções",
    "communications.validation_account_follow_tag": "A notificação de acompanhamento de conta deve conter {account_name}",
    "communications.validation_listing_like_tag": "A notificação de acompanhamento de lista deve conter {user_name}",
    "Listing follow notification should contain {user_name}": "A notificação de acompanhamento de lista deve conter {user_name}",
    "communications.validation_order_number_tag": "A notificação de acompanhamento de status do pedido deve conter #{order_number}",
    "Order status follow notification should contain #{order_number}": "A notificação de acompanhamento de status do pedido deve conter #{order_number}",
    "communications.validation_order_status_tag": "A notificação de acompanhamento de status do pedido deve conter {order_status}",
    "Order status follow notification should contain {order_status}": "A notificação de acompanhamento de status do pedido deve conter {order_status}",
    "communications.journey_title": "Mapa da Jornada de E-mail",
    "Email Journey Map": "Mapa da Jornada de E-mail",
    "communications.journey_subtitle": "Onde cada e-mail é disparado no ciclo de vida do usuário",
    "Where each email fires in the user lifecycle": "Onde cada e-mail é disparado no ciclo de vida do usuário",
    "communications.journey_buyer": "Jornada do Comprador",
    "Buyer Journey": "Jornada do Comprador",
    "communications.journey_seller": "Jornada do Vendedor",
    "Seller Journey": "Jornada do Vendedor",
    "communications.journey_buyer_stage_0": "Cadastro",
    "Sign Up": "Cadastro",
    "communications.journey_buyer_stage_1": "Navegar",
    "Browse": "Navegar",
    "communications.journey_buyer_stage_2": "Carrinho",
    "Cart": "Carrinho",
    "communications.journey_buyer_stage_3": "Pedido realizado",
    "Order Placed": "Pedido realizado",
    "communications.journey_buyer_stage_4": "Enviado",
    "communications.journey_buyer_stage_5": "Entregue",
    "communications.journey_buyer_stage_6": "Negociar",
    "Negotiate": "Negociar",
    "communications.journey_buyer_stage_7": "Inativo",
    "communications.journey_seller_stage_0": "Onboarding",
    "Onboard": "Onboarding",
    "communications.journey_seller_stage_1": "Listar",
    "communications.journey_seller_stage_2": "Gerenciar",
    "Manage": "Gerenciar",
    "communications.journey_seller_stage_3": "Pedido recebido",
    "Order In": "Pedido recebido",
    "communications.journey_seller_stage_4": "Enviar",
    "communications.journey_seller_stage_5": "Concluído",
    "Complete": "Concluído",
    "communications.journey_seller_stage_6": "Inativo",
    "accounts.title": "Contas",
    "accounts.status_pending": "Pendente",
    "accounts.status_approved": "Aprovado",
    "accounts.status_rejected": "Rejeitado",
    "accounts.show_rows": "Mostrar linhas",
    "accounts.next": "Próximo",
    "accounts.previous": "Anterior",
    "accounts.view_list": "Lista",
    "accounts.view_map": "Mapa",
    "Map": "Mapa",
    "accounts.view_board": "Quadro",
    "accounts.view_grid": "Grade",
    "accounts.view_list_accessibility": "Visualização de lista",
    "accounts.view_map_accessibility": "Visualização de mapa",
    "accounts.view_board_accessibility": "Visualização de quadro",
    "Board view": "Visualização de quadro",
    "accounts.view_grid_accessibility": "Visualização de grade",
    "accounts.column_name": "Nome",
    "accounts.column_account_id": "ID da conta",
    "Account ID": "ID da conta",
    "accounts.column_description": "Descrição",
    "accounts.column_image": "Imagem",
    "accounts.column_user_name": "Nome de usuário",
    "User Name": "Nome de usuário",
    "accounts.column_email": "E-mail",
    "accounts.column_status": "Status",
    "accounts.column_account_status": "Status da conta",
    "Account Status": "Status da conta",
    "accounts.column_location": "Localização",
    "accounts.search": "Pesquisar contas",
    "Search accounts": "Pesquisar contas",
    "accounts.export": "Exportar",
    "accounts.import": "Importar",
    "accounts.export_accounts": "Exportar contas",
    "Export accounts": "Exportar contas",
    "accounts.import_accounts": "Importar contas",
    "Import accounts": "Importar contas",
    "accounts.smart_upload_accounts": "Upload inteligente de contas",
    "Smart Upload accounts": "Upload inteligente de contas",
    "accounts.export_all_question": "Exportar todas as contas?",
    "Export all accounts?": "Exportar todas as contas?",
    "accounts.export_all_description": "Isso preparará um arquivo contendo todas as contas. Você pode revisar este fluxo de trabalho antes de atualizar.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Isso preparará um arquivo contendo todas as contas. Você pode revisar este fluxo de trabalho antes de atualizar.",
    "accounts.export_all": "Exportar todas as contas",
    "Export all accounts": "Exportar todas as contas",
    "accounts.cancel": "Cancelar",
    "accounts.active": "Ativo",
    "accounts.inactive": "Inativo",
    "accounts.not_available": "N/D",
    "accounts.approve": "Aprovar",
    "accounts.reject": "Rejeitar",
    "accounts.manage": "Gerenciar",
    "accounts.tooltip_title": "Contas são como lojas.",
    "Accounts are like shops.": "Contas são como lojas.",
    "accounts.tooltip_description": "Os usuários podem criar um espaço na sua plataforma para executar um negócio. Estas são contas. Um usuário pode não precisar de uma conta, e contas podem conectar contas de depósito para receber pagamentos.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Os usuários podem criar um espaço na sua plataforma para executar um negócio. Estas são contas. Um usuário pode não precisar de uma conta, e contas podem conectar contas de depósito para receber pagamentos.",
    "accounts.create_account": "Criar Conta",
    "Create Account": "Criar Conta",
    "accounts.create_new_account": "Criar Nova Conta",
    "Create New Account": "Criar Nova Conta",
    "accounts.save": "Salvar",
    "accounts.please_wait": "Por favor, aguarde...",
    "accounts.account_name": "Nome da conta",
    "accounts.slug": "Slug",
    "Slug": "Slug",
    "accounts.account_slug": "Slug da conta",
    "Account Slug": "Slug da conta",
    "accounts.account_description": "Descrição da conta",
    "Account Description": "Descrição da conta",
    "accounts.enter_name_first": "Por favor, insira um título primeiro",
    "Please enter a title first": "Por favor, insira um título primeiro",
    "accounts.user": "Usuário",
    "accounts.select_user": "Selecionar usuário",
    "accounts.category": "Categoria",
    "Category": "Categoria",
    "accounts.select_type": "Selecionar tipo",
    "accounts.smart_upload_title": "Upload inteligente de contas",
    "Smart account upload": "Upload inteligente de contas",
    "accounts.start_over": "Começar novamente",
    "accounts.smart_upload_description": "Faça upload de contas e associe as colunas do seu CSV aos campos da conta.",
    "Upload accounts and match your CSV columns to account fields.": "Faça upload de contas e associe as colunas do seu CSV aos campos da conta.",
    "accounts.smart_upload_step_0": "Carregar",
    "accounts.smart_upload_step_1": "Associar colunas",
    "accounts.smart_upload_step_2": "Revisar",
    "accounts.smart_upload_step_3": "Importar",
    "accounts.choose_csv": "Escolher um arquivo CSV",
    "accounts.smart_upload_required_note": "O nome é obrigatório. Endereço, slug, categoria, proprietário e coordenadas são opcionais.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "O nome é obrigatório. Endereço, slug, categoria, proprietário e coordenadas são opcionais.",
    "accounts.select_csv": "Selecionar arquivo CSV",
    "accounts.match_columns": "Associar colunas da conta",
    "Match account columns": "Associar colunas da conta",
    "accounts.import_field_name": "Nome",
    "accounts.import_field_description": "Descrição",
    "accounts.import_field_slug": "Slug",
    "accounts.import_field_category_id": "ID da categoria",
    "accounts.import_field_user_id": "ID do usuário proprietário",
    "Owner User ID": "ID do usuário proprietário",
    "accounts.import_field_location": "Endereço",
    "accounts.import_field_latitude": "Latitude",
    "Latitude": "Latitude",
    "accounts.import_field_longitude": "Longitude",
    "Longitude": "Longitude",
    "accounts.do_not_import": "Não importar",
    "accounts.review_import": "Revisar importação",
    "accounts.import_count": "{count} contas serão importadas.",
    "{count} accounts will be imported.": "{count} contas serão importadas.",
    "accounts.smart_upload_complete": "Smart Upload concluído",
    "Smart Upload complete": "Smart Upload concluído",
    "accounts.imported_count": "{imported} de {total} contas importadas.",
    "{imported} of {total} accounts imported.": "{imported} de {total} contas importadas.",
    "accounts.selected_file": "Selecionado: {filename}",
    "Selected: {filename}": "Selecionado: {filename}",
    "accounts.review": "Revisar",
    "accounts.importing": "Importando…",
    "accounts.uploading": "Enviando...",
    "accounts.download": "Baixar",
    "accounts.file_label": "Arquivo:",
    "accounts.select_file": "Selecionar arquivo",
    "accounts.upload": "Enviar",
    "accounts.download_template": "Baixar modelo {type}",
    "Download {type} template": "Baixar modelo {type}",
    "accounts.import_stage_prepare": "Preparando arquivo de importação",
    "Preparing import file": "Preparando arquivo de importação",
    "accounts.import_prepare_failed": "Não foi possível preparar o arquivo de importação.",
    "accounts.import_stage_upload": "Enviando arquivo de importação",
    "accounts.import_upload_failed": "Não foi possível enviar o arquivo de importação.",
    "accounts.import_stage_server": "Tradly está importando contas",
    "Tradly is importing accounts": "Tradly está importando contas",
    "accounts.import_stage_complete": "Importação concluída",
    "Import complete": "Importação concluída",
    "accounts.import_stage_stopped": "Importação interrompida",
    "accounts.confirm_approve": "Aprovar esta conta?",
    "Approve this account?": "Aprovar esta conta?",
    "accounts.confirm_reject": "Rejeitar esta conta?",
    "Reject this account?": "Rejeitar esta conta?",
    "accounts.name_required": "Nome é obrigatório",
    "accounts.user_required": "Usuário é obrigatório",
    "User is required": "Usuário é obrigatório",
    "accounts.attribute_required": "{attribute} é obrigatório",
    "{attribute} is required": "{attribute} é obrigatório",
    "accounts.overview": "Visão geral da conta",
    "Account Overview": "Visão geral da conta",
    "accounts.section_listings": "Listagens",
    "accounts.loading": "Carregando…",
    "accounts.no_listings_owned": "Nenhuma listagem ainda",
    "accounts.page_analytics": "Análise de página",
    "Page Analytics": "Análise de página",
    "accounts.analytics_key_missing": "Chave da API de análise não configurada para este inquilino.",
    "Analytics API key not configured for this tenant.": "Chave da API de análise não configurada para este inquilino.",
    "accounts.storefront_url_missing": "Nenhuma URL de loja disponível para esta conta.",
    "No storefront URL available for this account.": "Nenhuma URL de loja disponível para esta conta.",
    "accounts.no_analytics_loaded": "Nenhuma análise carregada ainda.",
    "No analytics loaded yet.": "Nenhuma análise carregada ainda.",
    "accounts.load_analytics": "Carregar análise",
    "Load Analytics": "Carregar análise",
    "accounts.attributes": "Atributos",
    "accounts.shipping": "Envio",
    "accounts.commission": "Comissão",
    "Commission": "Comissão",
    "accounts.detail_title": "Título",
    "accounts.detail_description": "Descrição",
    "accounts.detail_descriptions": "Descrições",
    "Descriptions": "Descrições",
    "accounts.detail_listings": "Listagens",
    "accounts.detail_categories": "Categorias",
    "accounts.detail_location": "Localização",
    "accounts.detail_account_status": "Status da conta",
    "accounts.detail_status": "Status",
    "accounts.detail_shipping_method": "Método de envio",
    "accounts.detail_shipping_methods": "Métodos de envio",
    "Shipping Methods": "Métodos de envio",
    "accounts.detail_account_user": "Usuário da conta",
    "Account User": "Usuário da conta",
    "accounts.detail_pending": "Pendente",
    "accounts.detail_approved": "Aprovado",
    "accounts.detail_rejected": "Rejeitado",
    "accounts.detail_active": "Ativo",
    "accounts.detail_inactive": "Inativo",
    "accounts.detail_joined": "Inscrito",
    "accounts.detail_account_age": "Idade da conta",
    "Account Age": "Idade da conta",
    "accounts.detail_less_than_a_month": "Menos de um mês",
    "Less than a month": "Menos de um mês",
    "accounts.detail_page_views": "Visualizações de página",
    "Page Views": "Visualizações de página",
    "accounts.detail_unique_visitors": "Visitantes únicos",
    "Unique Visitors": "Visitantes únicos",
    "accounts.detail_sessions": "Sessões",
    "Sessions": "Sessões",
    "accounts.detail_clicks": "Cliques",
    "Clicks": "Cliques",
    "accounts.detail_goals": "Objetivos",
    "Goals": "Objetivos",
    "accounts.detail_bot_views": "Visualizações de bot",
    "Bot Views": "Visualizações de bot",
    "accounts.detail_followers": "Seguidores",
    "Followers": "Seguidores",
    "accounts.detail_total_orders": "Pedidos totais",
    "accounts.detail_revenue": "Receita",
    "accounts.detail_avg_order": "Média de pedido",
    "accounts.detail_paid_orders": "Pedidos pagos",
    "Paid Orders": "Pedidos pagos",
    "accounts.detail_owner": "Proprietário",
    "Owner": "Proprietário",
    "accounts.detail_account_id": "ID da conta",
    "accounts.detail_category": "Categoria",
    "accounts.detail_profile_completeness": "Completude do perfil",
    "Profile Completeness": "Completude do perfil",
    "accounts.detail_total_listings": "Listagens totais",
    "Total Listings": "Listagens totais",
    "accounts.detail_loaded_listings": "Listagens carregadas",
    "Loaded Listings": "Listagens carregadas",
    "accounts.detail_active_listings": "Listagens ativas",
    "Active Listings": "Listagens ativas",
    "accounts.detail_last_updated": "Última atualização",
    "Last Updated": "Última atualização",
    "accounts.detail_last_activity": "Última atividade",
    "Last Activity": "Última atividade",
    "accounts.detail_verification": "Verificação",
    "Verification": "Verificação",
    "accounts.detail_subscription": "Assinatura",
    "accounts.detail_attributes": "Atributos",
    "accounts.detail_shipping_charge_split": "Divisão de custos de envio",
    "Shipping Charge Split": "Divisão de custos de envio",
    "accounts.detail_value_type": "Tipo de valor",
    "Value Type": "Tipo de valor",
    "accounts.detail_value": "Valor",
    "accounts.detail_enter_value": "Inserir valor",
    "accounts.detail_commission_percentage": "Porcentagem de comissão",
    "Commission Percentage": "Porcentagem de comissão",
    "accounts.detail_commission_percent": "Porcentagem de comissão",
    "Commission Percent": "Porcentagem de comissão",
    "accounts.detail_share": "Compartilhar",
    "accounts.detail_view_account": "Ver conta",
    "View Account": "Ver conta",
    "accounts.detail_add_listing": "Adicionar listagem",
    "accounts.detail_edit_account": "Editar conta",
    "accounts.no_attribute_values": "Nenhum valor de atributo para {name}",
    "No attribute values for {name}": "Nenhum valor de atributo para {name}",
    "accounts.no_attributes_yet": "Ainda não há atributos",
    "No attributes yet": "Ainda não há atributos",
    "accounts.edit_account": "Editar Conta",
    "accounts.detail_preview": "Visualizar",
    "accounts.detail_fixed": "Fixo",
    "Fixed": "Fixo",
    "accounts.detail_percentage": "Porcentagem",
    "Percentage": "Porcentagem",
    "accounts.detail_select_value_type": "Selecionar Tipo de Valor",
    "Select Value Type": "Selecionar Tipo de Valor",
    "accounts.detail_approve": "Aprovar",
    "accounts.detail_reject": "Rejeitar",
    "accounts.detail_section": "Detalhes",
    "Details": "Detalhes",
    "category.add_child": "Adicionar Categoria Filha",
    "Add Child Category": "Adicionar Categoria Filha",
    "category.add_listing": "Adicionar Listagem",
    "category.manage": "Gerenciar Categorias",
    "Manage Categories": "Gerenciar Categorias",
    "category.account_overview_eyebrow": "VISÃO GERAL DA CATEGORIA DE CONTA",
    "ACCOUNT CATEGORY OVERVIEW": "VISÃO GERAL DA CATEGORIA DE CONTA",
    "category.overview_eyebrow": "VISÃO GERAL DA CATEGORIA",
    "CATEGORY OVERVIEW": "VISÃO GERAL DA CATEGORIA",
    "category.category": "Categoria",
    "category.active": "Ativo",
    "category.inactive": "Inativo",
    "category.accounts": "Contas",
    "category.listings": "Listagens",
    "category.child_categories": "Categorias Filhas",
    "Child Categories": "Categorias Filhas",
    "category.attributes": "Atributos",
    "category.category_age": "Idade da Categoria",
    "Category age": "Idade da Categoria",
    "category.category_overview": "Visão Geral da Categoria",
    "Category Overview": "Visão Geral da Categoria",
    "category.category_id": "ID da Categoria",
    "category.name": "Nome",
    "category.slug": "Slug",
    "category.description": "Descrição",
    "category.parent_category": "Categoria pai",
    "Parent Category": "Categoria pai",
    "category.hierarchy": "Hierarquia",
    "Hierarchy": "Hierarquia",
    "category.status": "Status",
    "category.display_order": "Ordem de exibição",
    "Display Order": "Ordem de exibição",
    "category.created": "Ingressado / Criado",
    "Joined / Created": "Ingressado / Criado",
    "category.configured": "Configurado",
    "Configured": "Configurado",
    "category.no_attributes": "Nenhum atributo atribuído.",
    "No attributes assigned.": "Nenhum atributo atribuído.",
    "category.no_child_categories": "Nenhuma categoria secundária.",
    "No child categories.": "Nenhuma categoria secundária.",
    "category.no_accounts": "Nenhuma conta nesta categoria.",
    "No accounts in this category.": "Nenhuma conta nesta categoria.",
    "category.no_listings": "Nenhuma lista nesta categoria.",
    "No listings in this category.": "Nenhuma lista nesta categoria.",
    "category.detail_title": "Detalhe da categoria",
    "Category Detail": "Detalhe da categoria",
    "category.age_less_month": "Menos de um mês",
    "category.age_month": "{count} mês",
    "{count} month": "{count} mês",
    "category.age_months": "{count} meses",
    "{count} months": "{count} meses",
    "category.age_year": "{count} ano",
    "{count} year": "{count} ano",
    "category.age_years": "{count} anos",
    "{count} years": "{count} anos",
    "category.header_name": "Nome",
    "category.header_category_id": "ID da categoria",
    "category.header_image": "Imagem",
    "category.header_order": "Ordem",
    "category.header_parent": "Pai",
    "Parent": "Pai",
    "category.header_active": "Ativo",
    "category.header_action": "Ação",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Categorias",
    "category.translate": "Traduzir",
    "category.import": "Importar",
    "category.export": "Exportar",
    "category.add_category": "Adicionar categoria",
    "Add Category": "Adicionar categoria",
    "category.import_categories": "Importar categorias",
    "Import Categories": "Importar categorias",
    "category.delete_warning": "Listagens existentes não abrirão no site ou aplicativo, você verá um erro.",
    "Existing listings will not open in website or app, you will see an error.": "Listagens existentes não abrirão no site ou aplicativo, você verá um erro.",
    "category.editor_edit_category": "Editar categoria",
    "Edit Category": "Editar categoria",
    "category.editor_add_category": "Adicionar categoria",
    "category.editor_save": "Salvar",
    "category.editor_select_category_level": "Selecionar nível da categoria",
    "Select Category Level": "Selecionar nível da categoria",
    "category.editor_parent_category": "Categoria pai",
    "category.editor_select": "Selecionar",
    "category.editor_category_name": "Nome da categoria",
    "Category Name": "Nome da categoria",
    "category.editor_enter_category_name": "Insira o nome da categoria",
    "Enter category name": "Insira o nome da categoria",
    "category.editor_slug": "Slug",
    "category.editor_enter_slug": "Insira o slug",
    "category.editor_category_description": "Descrição da categoria",
    "Category Description": "Descrição da categoria",
    "category.editor_order": "Ordem",
    "category.editor_enter_order": "Insira a ordem",
    "category.editor_status_not_active_active": "Status (Inativo / Ativo)",
    "category.editor_upload_media": "Enviar mídia",
    "category.editor_meta_title": "Meta título",
    "Meta Title": "Meta título",
    "category.editor_enter_meta_title": "Insira o título meta",
    "category.editor_meta_description": "Descrição meta",
    "category.editor_category": "Categoria",
    "category.editor_name": "Nome",
    "category.editor_status": "Status",
    "category.editor_action": "Ação",
    "category.editor_add_attribute": "Adicionar atributo",
    "Add Attribute": "Adicionar atributo",
    "category.editor_attributes_list": "Lista de atributos",
    "Attributes List": "Lista de atributos",
    "category.editor_please_enter_a_category_name_first": "Por favor, insira primeiro o nome da categoria",
    "Please enter a category name first": "Por favor, insira primeiro o nome da categoria",
    "category.editor_successfully_added_category": "Categoria adicionada com sucesso",
    "Successfully added category": "Categoria adicionada com sucesso",
    "category.deleted": "Categoria excluída",
    "Category deleted": "Categoria excluída",
    "attributes.title": "Atributos",
    "attributes.cart_checkout": "Carrinho e checkout",
    "Cart & Checkout": "Carrinho e checkout",
    "attributes.cart_settings": "Configuração do carrinho",
    "Cart settings": "Configuração do carrinho",
    "attributes.order_status_notifications": "Notificações de status do pedido",
    "Order status notifications": "Notificações de status do pedido",
    "attributes.groups": "Grupos de atributos",
    "attributes.add_attribute": "Adicionar atributo",
    "attributes.edit_bulk": "Editar em lote",
    "Edit Bulk": "Editar em lote",
    "attributes.confirm_delete": "Você quer excluir este atributo?",
    "attributes.header_attribute_name": "Nome do atributo",
    "Attribute Name": "Nome do atributo",
    "attributes.header_action": "Ação",
    "attributes.header_manage_attribute_values": "Gerenciar valores de atributo",
    "Manage Attribute Values": "Gerenciar valores de atributo",
    "attributes.header_type": "Tipo",
    "attributes.header_optional": "Opcional",
    "attributes.header_icon": "Ícone",
    "Icon": "Ícone",
    "attributes.header_categories": "Categorias",
    "attributes.header_hidden_field": "Campo oculto",
    "Hidden Field": "Campo oculto",
    "attributes.header_values": "Valores",
    "Values": "Valores",
    "attributes.header_status": "Status",
    "attributes.type_single_select": "Seleção única",
    "Single Select": "Seleção única",
    "attributes.type_multi_select": "Seleção múltipla",
    "Multi Select": "Seleção múltipla",
    "attributes.type_open_single_value": "Aberto (Valor único)",
    "Open (Single Value)": "Aberto (Valor único)",
    "attributes.type_open_multiple_value": "Aberto (Valores múltiplos)",
    "Open (Multiple Value)": "Aberto (Valores múltiplos)",
    "attributes.type_attachment": "Anexo",
    "Attachment": "Anexo",
    "attributes.type_text_area": "Área de texto",
    "Text Area": "Área de texto",
    "attributes.type_date_time": "Data e hora",
    "Date Time": "Data e hora",
    "attributes.type_number": "Número",
    "attributes.type_boolean": "Booleano",
    "Boolean": "Booleano",
    "attributes.type_color": "Cor",
    "Color": "Cor",
    "attributes.type_json": "Json",
    "Json": "Json",
    "attributes.type_location": "Localização",
    "attributes.type_audio": "Áudio",
    "Audio": "Áudio",
    "attributes.type_video": "Vídeo",
    "Video": "Vídeo",
    "attributes.type_open_multi_value": "Aberto (Valores múltiplos)",
    "Open (Multi Value)": "Aberto (Valores múltiplos)",
    "attributes.editor_edit_attribute": "Editar atributo",
    "Edit Attribute": "Editar atributo",
    "attributes.editor_add_attribute": "Adicionar atributo",
    "attributes.editor_attribute_name": "Nome do atributo",
    "attributes.editor_select_type": "Selecionar tipo",
    "attributes.prefill_user": "Usuário",
    "common.search_placeholder": "Digite para pesquisar...",
    "attributes.prefill_accounts": "Contas",
    "attributes.prefill_listings": "Listagens",
    "listings.detail_nav_gallery": "Galeria",
    "Gallery": "Galeria",
    "listings.detail_nav_details": "Detalhes",
    "listings.detail_nav_inventory": "Inventário",
    "listings.detail_nav_social": "Social",
    "Social": "Social",
    "listings.detail_nav_orders": "Pedidos",
    "listings.detail_nav_analytics": "Análise",
    "listings.detail_nav_schedule": "Agenda",
    "listings.detail_nav_rental": "Aluguel",
    "Rental": "Aluguel",
    "listings.detail_nav_attributes": "Atributos",
    "listings.detail_nav_seller": "Vendedor",
    "attributes.editor_icon": "Ícone",
    "attributes.editor_tool_tip": "Dica de ferramenta",
    "Tool tip": "Dica de ferramenta",
    "attributes.editor_enter_attribute_name": "Insira o nome do atributo",
    "attributes.editor_enter_attribute_tool_tip": "Insira a descrição da ferramenta",
    "Enter attribute tool tip": "Insira a descrição da ferramenta",
    "attributes.editor_optional": "Opcional",
    "attributes.editor_private": "Privado",
    "Private": "Privado",
    "attributes.editor_hidden_field": "Campo oculto",
    "Hidden field": "Campo oculto",
    "attributes.editor_show_in_filter": "Mostrar no filtro",
    "Show in filter": "Mostrar no filtro",
    "attributes.editor_status_not_active_active": "Status (Inativo / Ativo)",
    "attributes.editor_add_meta_data": "Adicionar metadados",
    "Add meta data": "Adicionar metadados",
    "attributes.editor_select": "Selecionar",
    "attributes.editor_select_category": "Selecionar categoria",
    "attributes.editor_select_all": "Selecionar tudo",
    "Select All": "Selecionar tudo",
    "attributes.editor_unselect_all": "Desmarcar tudo",
    "UnSelect All": "Desmarcar tudo",
    "attributes.editor_create_categories_in_this_configuration_first": "Crie categorias nesta configuração primeiro",
    "Create categories in this configuration first": "Crie categorias nesta configuração primeiro",
    "attributes.editor_please_enter_attribute_name": "Por favor, insira o nome do atributo",
    "Please enter attribute name": "Por favor, insira o nome do atributo",
    "attributes.editor_please_select_type": "Por favor selecione o tipo",
    "Please select type": "Por favor selecione o tipo",
    "attributes.editor_select_single_attribute_values": "Selecionar valores de atributo único",
    "attributes.editor_select_multiple_attribute_values": "Selecionar valores de atributo múltiplo",
    "attributes.editor_enter_value": "Inserir valor",
    "attributes.editor_enter_multiple_tag": "Inserir múltiplas etiquetas",
    "Enter Multiple Tag": "Inserir múltiplas etiquetas",
    "attributes.editor_upload_file": "Enviar arquivo",
    "Upload file": "Enviar arquivo",
    "attributes.editor_enter_text": "Inserir texto",
    "attributes.editor_select_date": "Selecionar data",
    "attributes.editor_enter_number": "Inserir número",
    "Enter Number": "Inserir número",
    "attributes.editor_select_color": "Selecionar cor",
    "Select Color": "Selecionar cor",
    "attributes.editor_upload_json": "Enviar Json",
    "Upload Json": "Enviar Json",
    "attributes.editor_select_location": "Selecionar localização",
    "Select Location": "Selecionar localização",
    "attributes.editor_category": "Categoria",
    "attributes.editor_price": "Preço",
    "attributes.editor_enter_price": "Inserir preço",
    "Enter Price": "Inserir preço",
    "attributes.editor_preview": "Pré-visualização",
    "attributes.editor_title": "Título",
    "attributes.editor_enter_title": "Digite o título",
    "attributes.editor_description": "Descrição",
    "attributes.editor_add_listing": "Adicionar Listagem",
    "attributes.editor_add_account": "Adicionar Conta",
    "attributes.editor_successfully_added_attributes": "Atributos adicionados com sucesso",
    "Successfully added attributes": "Atributos adicionados com sucesso",
    "attributes.editor_add_attribute_values": "Adicionar Valores de Atributo",
    "common.image": "Imagem",
    "common.please_wait": "Aguarde por favor...",
    "attribute_groups.title": "Grupos de Atributos",
    "attribute_groups.title_singular": "Grupo de Atributos",
    "Attribute Group": "Grupo de Atributos",
    "attribute_groups.add": "Adicionar Grupo de Atributos",
    "Add Attribute Group": "Adicionar Grupo de Atributos",
    "attribute_groups.image_path": "Caminho da Imagem",
    "Image Path": "Caminho da Imagem",
    "attribute_groups.name_placeholder": "Nome do Grupo",
    "Group Name": "Nome do Grupo",
    "attribute_groups.select_attributes": "Selecionar Atributos",
    "Select Attributes": "Selecionar Atributos",
    "attribute_groups.select_attributes_placeholder": "Selecionar Atributos...",
    "Select Attributes...": "Selecionar Atributos...",
    "attribute_groups.added_successfully": "Grupo de Atributos adicionado com sucesso",
    "Attribute Group Added Successfully": "Grupo de Atributos adicionado com sucesso",
    "attribute_groups.deleted_successfully": "Excluído com sucesso",
    "Deleted successfully": "Excluído com sucesso",
    "attribute_groups.name_required": "O nome é obrigatório",
    "attribute_groups.save_attributes_failed": "O grupo foi salvo, mas não foi possível atribuir seus atributos.",
    "The group was saved, but its attributes could not be assigned.": "O grupo foi salvo, mas não foi possível atribuir seus atributos.",
    "attributes.editor_enter_description": "Digite a descrição",
    "account_config.title": "Configuração da Conta",
    "account_config.account_detail_note": "Nota de detalhe da conta",
    "Account detail note": "Nota de detalhe da conta",
    "account_config.enter_account_detail_note": "Digite a nota de detalhe da conta",
    "Enter account detail note": "Digite a nota de detalhe da conta",
    "account_config.address_label": "Rótulo de endereço",
    "Address label": "Rótulo de endereço",
    "account_config.enter_address_label": "Rótulo de endereço",
    "Enter address label": "Rótulo de endereço",
    "account_config.category_label": "Rótulo de categoria",
    "Category label": "Rótulo de categoria",
    "account_config.enter_category_label": "Insira o rótulo da categoria",
    "Enter category label": "Insira o rótulo da categoria",
    "account_config.nearby_accounts_radius_km": "Raio de contas próximas (km)",
    "Nearby accounts radius (km)": "Raio de contas próximas (km)",
    "account_config.nearby_accounts_radius_placeholder": "Raio da conta próxima em km",
    "Account nearby radius in km": "Raio da conta próxima em km",
    "account_config.account_limit": "Limite de contas",
    "Account Limit": "Limite de contas",
    "account_config.account_limit_placeholder": "Limite de contas",
    "Account limit": "Limite de contas",
    "account_config.shipping_preference_note": "Nota sobre preferência de método de envio",
    "Shipping method preference note": "Nota sobre preferência de método de envio",
    "account_config.option_accounts_auto_approved": "Contas aprovadas automaticamente",
    "Accounts auto approved": "Contas aprovadas automaticamente",
    "account_config.option_shipping_methods_preference_for_accounts": "Preferência de métodos de envio para contas",
    "Shipping methods preference for accounts": "Preferência de métodos de envio para contas",
    "account_config.option_account_map_location_selector": "Seletor de localização no mapa para contas",
    "Account map location selector": "Seletor de localização no mapa para contas",
    "account_config.option_account_geo_location": "Localização geográfica da conta",
    "Account Geo Location": "Localização geográfica da conta",
    "account_config.option_slug": "Slug",
    "account_config.option_show_description": "Mostrar descrição",
    "Show Description": "Mostrar descrição",
    "account_config.option_formatted_text_description": "Descrição em texto formatado",
    "Formatted Text Description": "Descrição em texto formatado",
    "account_config.option_hide_address_from_account_detail": "Ocultar endereço no detalhe da conta",
    "Hide Address from Account Detail": "Ocultar endereço no detalhe da conta",
    "account_config.option_get_account_pickup_address_always": "Obter endereço de retirada da conta sempre",
    "Get Account Pickup Address Always": "Obter endereço de retirada da conta sempre",
    "account_config.option_get_pickup_address_for_delivery": "Obter endereço de retirada para entrega",
    "Get Pickup Address for Delivery": "Obter endereço de retirada para entrega",
    "account_config.uploaded_successfully": "Enviado com sucesso",
    "app_customization.realtime_config_notice": "Essas configurações são aplicadas em tempo real. Ao fazer alterações aqui e clicar em Salvar, elas serão refletidas nos aplicativos e respostas da API.",
    "app_customization.release_config_notice": "Observação para Canais de Aplicativo Móvel: Essas configurações são aplicadas apenas no momento da liberação do produto e atualizações. Nunca serão atualizadas em tempo real. Ao fazer alterações aqui e precisar de uma compilação atualizada, solicite uma compilação no Portal de Suporte. (Aplicável ao plano Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Observação para Canais de Aplicativo Móvel: Essas configurações são aplicadas apenas no momento da liberação do produto e atualizações. Nunca serão atualizadas em tempo real. Ao fazer alterações aqui e precisar de uma compilação atualizada, solicite uma compilação no Portal de Suporte. (Aplicável ao plano Starter)",
    "category.translation_title": "Traduzir categoria",
    "Translate Category": "Traduzir categoria",
    "category.translation_category_name": "Nome da categoria",
    "category.translation_description": "Descrição",
    "listing_configs.title": "Configuração de lista",
    "Listing Configuration": "Configuração de lista",
    "listing_configs.rules": "REGRAS (Nível de projetos/Tenant)",
    "RULES (Projects/Tenant level)": "REGRAS (Nível de projetos/Tenant)",
    "listing_configs.features": "RECURSOS (Apenas para aplicativo móvel)",
    "FEATURES (Only for mobile app)": "RECURSOS (Apenas para aplicativo móvel)",
    "listing_configs.ui_customisation": "Personalização da interface",
    "UI Customisation": "Personalização da interface",
    "listing_configs.overridden_max_quantity": "Quantidade máxima por lista",
    "listing_configs.overridden_max_quantity_example": "(Exemplo: 100)",
    "(Example: 100)": "(Exemplo: 100)",
    "listing_configs.listing_min_price": "Preço mínimo da lista",
    "listing_configs.listing_min_price_example": "(Exemplo: $5)",
    "(Example: $5)": "(Exemplo: $5)",
    "listing_configs.auto_approval": "Aprovar listas automaticamente?",
    "listing_configs.listing_pictures_count": "Número de imagens carregáveis",
    "listing_configs.seller_can_place_order": "Vendedor pode fazer pedidos",
    "Seller can place order": "Vendedor pode fazer pedidos",
    "listing_configs.hide_offer_percent": "Percentual de oferta",
    "listing_configs.show_max_quantity": "Restrições de quantidade máxima no nível da lista",
    "listing_configs.show_shipping_charges": "Custos de envio",
    "Shipping charges": "Custos de envio",
    "listing_configs.listing_address_label": "Rótulo de endereço",
    "listing_configs.listing_address_label_example": "(Exemplo: Ponto de referência)",
    "(Example: Landmark)": "(Exemplo: Ponto de referência)",
    "listing_configs.listing_map_location_selector_enabled": "Usar marcador de mapa em vez de pesquisar endereço",
    "Use map marker instead of searching address": "Usar marcador de mapa em vez de pesquisar endereço",
    "listing_configs.listing_hide_tags": "Etiquetas",
    "Tags": "Etiquetas",
    "listing_configs.enable_stock": "Estoque",
    "Stocks": "Estoque",
    "listing_configs.listing_address_enabled": "Endereço geográfico",
    "Geo address": "Endereço geográfico",
    "listing_configs.show_stock_out_listings": "Mostrar listas sem estoque no feed",
    "listing_configs.enable_slug": "Slug do título da lista",
    "Listing title slug": "Slug do título da lista",
    "listing_configs.show_variants": "Variantes",
    "Variants": "Variantes",
    "listing_configs.meta_title": "Título meta",
    "listing_configs.meta_description": "Descrição meta",
    "listing_configs.listing_enable_formatted_text_description": "Habilitar Composer",
    "Enable Composer": "Habilitar Composer",
    "listing_configs.listing_enable_weight": "Habilitar Peso",
    "listing_configs.listing_enable_dimensions": "Habilitar Dimensões",
    "listing_configs.enable_stocks_listing_schedules": "Agendamentos de Estoque",
    "Stock Schedules": "Agendamentos de Estoque",
    "listing_variants.title": "Tipos de Variante",
    "listing_variants.add_type": "Adicionar Tipo de Variante",
    "Add Variant Type": "Adicionar Tipo de Variante",
    "listing_variants.edit_type": "Editar Tipo de Variante",
    "Edit Variant Type": "Editar Tipo de Variante",
    "listing_variants.name": "Nome",
    "listing_variants.values": "Valores",
    "listing_variants.status": "Status",
    "listing_variants.action": "Ação",
    "listing_variants.add_value": "Adicionar Valor",
    "Add Value": "Adicionar Valor",
    "listing_variants.active": "Ativo",
    "listing_variants.inactive": "Inativo",
    "listing_variants.details": "Detalhes",
    "listing_variants.translate": "Traduzir",
    "listing_variants.delete_confirm": "Você quer excluir este tipo de variante?",
    "Do you want to delete this variant type?": "Você quer excluir este tipo de variante?",
    "listing_variants.add_value_first": "Adicione um valor antes de visualizar variantes.",
    "Add a value before viewing variants.": "Adicione um valor antes de visualizar variantes.",
    "listing_variants.enter_name": "Insira nome",
    "listing_variants.status_hint": "Status (Inativo / Ativo)",
    "Status (Inactive / Active)": "Status (Inativo / Ativo)",
    "listing_variants.total_values": "Valores Totais",
    "Total Values": "Valores Totais",
    "listing_variants.type_id": "ID do Tipo",
    "Type ID": "ID do Tipo",
    "listing_variants.total_count": "{count} no total",
    "{count} total": "{count} no total",
    "listing_variants.loading": "Carregando…",
    "listing_variants.loading_values": "Carregando valores…",
    "Loading values…": "Carregando valores…",
    "listing_variants.no_values": "Ainda não há valores",
    "No values yet": "Ainda não há valores",
    "listing_variants.add_first_value": "Adicionar primeiro valor",
    "Add First Value": "Adicionar primeiro valor",
    "listing_variants.actions": "Ações",
    "listing_variants.edit": "Editar",
    "listing_variants.delete": "Excluir",
    "listing_variants.edit_value": "Editar valor",
    "Edit Value": "Editar valor",
    "listing_variants.value_name_required": "Nome do valor *",
    "Value Name *": "Nome do valor *",
    "listing_variants.value_examples": "ex. Vermelho, XL, Algodão…",
    "e.g. Red, XL, Cotton…": "ex. Vermelho, XL, Algodão…",
    "listing_variants.saving": "Salvando…",
    "listing_variants.save_changes": "Salvar alterações",
    "Save Changes": "Salvar alterações",
    "listing_variants.delete_value_confirm": "Você quer excluir este valor de variante?",
    "Do you want to delete this variant value?": "Você quer excluir este valor de variante?",
    "listing_variants.clear_all": "Limpar tudo",
    "listing_variants.multiple_values_help": "Você pode adicionar valores separados por vírgula ou colar uma coluna do Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Você pode adicionar valores separados por vírgula ou colar uma coluna do Excel.",
    "listing_variants.save": "Salvar",
    "listing_variants.close": "Fechar",
    "listing_variants.update": "Atualizar",
    "listing_variants.default_text": "Texto padrão",
    "listing_variants.enter_value": "Insira o valor da variante",
    "Enter variant value": "Insira o valor da variante",
    "listing_variants.add_values": "Adicionar valores",
    "listing_variants.add_variant_values": "Adicionar valores de tipo de variante",
    "Add Variant Type Values": "Adicionar valores de tipo de variante",
    "listing_variants.values_list": "Lista de valores de tipo de variante",
    "Variant Type Values List": "Lista de valores de tipo de variante",
    "listing_variants.cancel_editing": "Cancelar edição",
    "Cancel Editing": "Cancelar edição",
    "listing_variants.value_name": "Valor do tipo de variante",
    "Variant Type Value": "Valor do tipo de variante",
    "common.default_text": "Texto padrão",
    "common.translation_heading": "{title} Traduções",
    "{title} Translations": "{title} Traduções",
    "attributes.value_delete_confirm": "Você quer excluir este valor de atributo?",
    "Do you want to delete this attribute value?": "Você quer excluir este valor de atributo?",
    "attributes.value_clear_all": "Limpar tudo",
    "attributes.value_multiple_help": "Adicione valores separados por vírgula ou cole e uma coluna do Excel.",
    "Add comma-separated values or paste a column from Excel.": "Adicione valores separados por vírgula ou cole e uma coluna do Excel.",
    "attributes.value_active": "Ativo",
    "attributes.value_inactive": "Inativo",
    "attributes.value_save": "Salvar",
    "attributes.value_close": "Fechar",
    "attributes.value_translate": "Traduzir",
    "attributes.value_update": "Atualizar",
    "attributes.value_sort_alpha": "Ordenar alfabeticamente",
    "Sort Alphabetically": "Ordenar alfabeticamente",
    "attributes.value_default_text": "Texto padrão",
    "attributes.value_add_metadata": "Adicionar Metadados",
    "Add Metadata": "Adicionar Metadados",
    "attributes.value_cancel_edit": "Cancelar edição",
    "attributes.value_success_help": "Ótimo! Agora você pode encontrar este atributo personalizado na página Adicionar Lista.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Ótimo! Agora você pode encontrar este atributo personalizado na página Adicionar Lista.",
    "attributes.value_add": "Adicionar Valores de Atributo",
    "attributes.value_add_listing": "Adicionar Valores de Atributo de Lista",
    "Add Listing Attribute Values": "Adicionar Valores de Atributo de Lista",
    "attributes.value_metadata_for": "Metadados para",
    "Metadata for": "Metadados para",
    "attributes.value_enter": "Digite o valor do atributo",
    "Enter attribute value": "Digite o valor do atributo",
    "attributes.value_add_values": "Adicionar Valores",
    "attributes.value_status_hint": "Status (Inativo / Ativo)",
    "attributes.value_list": "Lista de Valores de Atributo",
    "Attribute Values List": "Lista de Valores de Atributo",
    "attributes.value_table_name": "Valor do atributo",
    "Attribute Value": "Valor do atributo",
    "attributes.value_table_status": "Status",
    "attributes.value_table_action": "Ação",
    "attributes.metadata_key": "Chave",
    "Key": "Chave",
    "attributes.metadata_value": "Valor",
    "attributes.metadata_add_row": "Adicionar linha",
    "Add Row": "Adicionar linha",
    "workspace.countries": "Países",
    "workspace.country_add": "Adicionar país",
    "Add Country": "Adicionar país",
    "workspace.country_edit": "Editar país",
    "Edit Country": "Editar país",
    "workspace.country_name": "Nome do país",
    "Country Name": "Nome do país",
    "workspace.select_country": "Selecionar país",
    "Select country": "Selecionar país",
    "workspace.country_order": "Ordem",
    "workspace.country_order_placeholder": "Insira a ordem",
    "workspace.country_status": "Status (Inativo / Ativo)",
    "workspace.country_default": "Padrão",
    "workspace.country_active": "Ativo",
    "workspace.country_inactive": "Inativo",
    "workspace.country_delete_confirm": "Você quer excluir este país?",
    "Do you want to delete this country?": "Você quer excluir este país?",
    "workspace.country_table_name": "Nome",
    "workspace.country_table_default": "Padrão",
    "workspace.country_table_order": "Ordem",
    "workspace.country_table_status": "Status",
    "workspace.country_table_action": "Ação",
    "workspace.languages": "Idiomas",
    "workspace.language_add": "Adicionar idioma",
    "Add Language": "Adicionar idioma",
    "workspace.language_edit": "Editar idioma",
    "Edit Language": "Editar idioma",
    "workspace.language_name": "Idioma",
    "workspace.language_select": "Selecionar idioma",
    "Select Language": "Selecionar idioma",
    "workspace.language_order": "Ordem",
    "workspace.language_order_placeholder": "Insira a ordem",
    "workspace.language_status": "Status",
    "workspace.language_default": "Padrão",
    "workspace.language_default_warning": "Alterar o idioma padrão altera a configuração de idioma do aplicativo.",
    "Changing the default language changes the app language setting.": "Alterar o idioma padrão altera a configuração de idioma do aplicativo.",
    "workspace.language_active": "Ativo",
    "workspace.language_inactive": "Inativo",
    "workspace.language_delete_confirm": "Você quer excluir este idioma?",
    "Do you want to delete this language?": "Você quer excluir este idioma?",
    "workspace.language_table_name": "Nome",
    "workspace.language_table_default": "Padrão",
    "workspace.language_table_order": "Ordem",
    "workspace.language_table_status": "Status",
    "workspace.language_table_action": "Ação",
    "workspace.language_add_photo": "Adicionar foto",
    "workspace.currency": "Moeda",
    "workspace.currency_add": "Adicionar moeda",
    "Add Currency": "Adicionar moeda",
    "workspace.currency_edit": "Editar moeda",
    "Edit Currency": "Editar moeda",
    "workspace.currency_delete_confirm": "Você quer excluir esta moeda?",
    "Do you want to delete this currency?": "Você quer excluir esta moeda?",
    "workspace.currency_show": "Mostrar",
    "workspace.currency_entries": "entradas",
    "entries": "entradas",
    "workspace.currency_search": "Pesquisar:",
    "Search:": "Pesquisar:",
    "workspace.currency_search_placeholder": "Pesquisar moedas",
    "Search currencies": "Pesquisar moedas",
    "workspace.currency_empty": "Nenhuma moeda encontrada.",
    "No currencies found.": "Nenhuma moeda encontrada.",
    "workspace.currency_active": "Ativo",
    "workspace.currency_inactive": "Inativo",
    "workspace.currency_name": "Nome",
    "workspace.currency_name_placeholder": "Nome da moeda",
    "Currency Name": "Nome da moeda",
    "workspace.currency_upload_media": "Enviar mídia",
    "workspace.currency_select_media": "Selecionar da mídia",
    "workspace.currency_no_media": "Você não tem arquivos de mídia.",
    "workspace.currency_code": "Código",
    "workspace.currency_select_code": "Selecionar",
    "workspace.currency_exchange_rate": "Taxa de câmbio",
    "Exchange Rate": "Taxa de câmbio",
    "workspace.currency_precision": "Precisão",
    "Precision": "Precisão",
    "workspace.currency_thousand_separator": "Separador de mil",
    "Thousand Separator": "Separador de mil",
    "workspace.currency_decimal_point": "Ponto decimal",
    "Decimal Point": "Ponto decimal",
    "workspace.currency_status_hint": "Status (Inativo / Ativo)",
    "workspace.currency_default": "Padrão",
    "workspace.currency_format": "Formato",
    "Format": "Formato",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Nome",
    "workspace.currency_table_code": "Código",
    "workspace.currency_table_format": "Formato",
    "workspace.currency_table_exchange": "Câmbio",
    "Exchange": "Câmbio",
    "workspace.currency_table_status": "Status",
    "workspace.currency_table_default": "Padrão",
    "workspace.currency_table_action": "Ação",
    "commissions.title": "Comissões",
    "commissions.add": "Adicionar comissão",
    "Add Commission": "Adicionar comissão",
    "commissions.edit": "Editar comissão",
    "Edit Commission": "Editar comissão",
    "commissions.delete_confirm": "Você quer excluir esta comissão?",
    "Do you want to delete this commission?": "Você quer excluir esta comissão?",
    "commissions.yes": "Sim",
    "commissions.no": "Não",
    "commissions.filter_all": "Todos",
    "commissions.filter_supply": "Fornecimento",
    "Supply": "Fornecimento",
    "commissions.filter_demand": "Demanda",
    "Demand": "Demanda",
    "commissions.filter_cart": "Carrinho",
    "commissions.table_title": "Título",
    "commissions.table_default_value": "Valor padrão",
    "Default Value": "Valor padrão",
    "commissions.table_status": "Status",
    "commissions.table_action": "Ação",
    "commissions.active": "Ativo",
    "commissions.inactive": "Inativo",
    "commissions.type": "Tipo",
    "commissions.type_supply": "Fornecimento",
    "commissions.type_demand": "Demanda",
    "commissions.type_cart": "Carrinho",
    "commissions.select_category": "Selecionar categoria",
    "Select Category": "Selecionar categoria",
    "commissions.title_label": "Título",
    "commissions.enter_title": "Insira o título",
    "Enter title": "Insira o título",
    "commissions.description": "Descrição",
    "commissions.enter_description": "Insira a descrição",
    "commissions.default_value_percent": "Valor padrão (%)",
    "Default value (%)": "Valor padrão (%)",
    "commissions.short_code": "Código curto",
    "Short Code": "Código curto",
    "commissions.short_code_tooltip_title": "Código curto",
    "Short code": "Código curto",
    "commissions.short_code_tooltip_description": "Insira um código curto para esta comissão.",
    "Enter a short code for this commission.": "Insira um código curto para esta comissão.",
    "commissions.enter_short_code": "Insira código curto",
    "commissions.status_hint": "Status (Inativo / Ativo)",
    "commissions.optional": "Opcional",
    "commissions.advanced": "Avançado",
    "Advanced": "Avançado",
    "commissions.add_by_category": "Adicionar comissão por categoria",
    "Add commission by category": "Adicionar comissão por categoria",
    "commissions.select_calculation_type": "Selecionar tipo",
    "commissions.calc_fixed": "Fixo",
    "commissions.calc_slab": "Escada",
    "Slab": "Escada",
    "commissions.value": "Valor",
    "commissions.choose_category": "Escolher categoria",
    "Choose category": "Escolher categoria",
    "commissions.create_categories_first": "Crie categorias primeiro na Configuração de Listagem",
    "Create categories in Listing Configuration first": "Crie categorias primeiro na Configuração de Listagem",
    "commissions.select_type": "Selecionar tipo",
    "commissions.demand_fixed": "Fixo",
    "commissions.demand_percentage": "Porcentagem",
    "commissions.unlimited_hint": "* Insira -1 para ilimitado",
    "* Enter -1 for unlimited": "* Insira -1 para ilimitado",
    "commissions.from": "De",
    "commissions.enter_from": "Inserir de",
    "commissions.to": "Até",
    "commissions.enter_to": "Inserir até",
    "commissions.enter_value": "Inserir valor",
    "commissions.add_row": "Adicionar linha",
    "commissions.minimum_amount": "Valor mínimo",
    "Minimum amount": "Valor mínimo",
    "commissions.enter_minimum_amount": "Inserir valor mínimo",
    "commissions.maximum_amount": "Valor máximo",
    "Maximum amount": "Valor máximo",
    "commissions.enter_maximum_amount": "Inserir valor máximo",
    "commissions.notes": "Notas",
    "Notes": "Notas",
    "commissions.enter_note": "Inserir nota",
    "commissions.from_value": "Valor de",
    "From Value": "Valor de",
    "commissions.to_value": "Valor até",
    "To Value": "Valor até",
    "commissions.unlimited_short_hint": "(-1 para ilimitado)",
    "(-1 for unlimited)": "(-1 para ilimitado)",
    "commissions.value_percent": "Valor (%)",
    "Value (%)": "Valor (%)",
    "commissions.from_value_validation": "O valor de deve ser maior que o valor To anterior",
    "From value should be greater than the previous To value": "O valor de deve ser maior que o valor To anterior",
    "commissions.to_value_validation": "O valor até deve ser maior que o valor de",
    "To value should be greater than From value": "O valor até deve ser maior que o valor de",
    "taxes.title": "Imposto",
    "taxes.title_plural": "Impostos",
    "taxes.add": "Adicionar imposto",
    "Add Tax": "Adicionar imposto",
    "taxes.edit": "Editar imposto",
    "Edit Tax": "Editar imposto",
    "taxes.delete_confirm": "Tem certeza de que deseja excluir este imposto?",
    "Are you sure you want to delete this tax?": "Tem certeza de que deseja excluir este imposto?",
    "taxes.table_title": "Título",
    "taxes.table_short_code": "Código curto",
    "taxes.table_default_value": "Valor padrão",
    "taxes.table_status": "Status",
    "taxes.table_action": "Ação",
    "taxes.active": "Ativo",
    "taxes.inactive": "Inativo",
    "taxes.select_type": "Selecionar tipo",
    "taxes.type_order": "Ordem",
    "taxes.type_listing": "Listagem",
    "taxes.type_tax": "Imposto",
    "taxes.demand_fixed": "Fixo",
    "taxes.demand_percentage": "Porcentagem",
    "taxes.from": "De",
    "taxes.enter_from": "Digite de",
    "taxes.to": "Até",
    "taxes.enter_to": "Digite até",
    "taxes.unlimited_hint": "(-1 para ilimitado)",
    "taxes.value": "Valor",
    "taxes.enter_value": "Digite valor",
    "taxes.add_row": "Adicionar linha",
    "taxes.note": "Nota",
    "taxes.note_placeholder": "Insira uma nota para que os usuários vejam durante o checkout e nos detalhes do pedido.",
    "Enter a note for users to see during checkout and in order details.": "Insira uma nota para que os usuários vejam durante o checkout e nos detalhes do pedido.",
    "taxes.inclusive": "Imposto incluído",
    "Tax Inclusive": "Imposto incluído",
    "taxes.inclusive_tooltip": "Ative isso quando o preço listado já inclui imposto.",
    "Enable this when the listed price already includes tax.": "Ative isso quando o preço listado já inclui imposto.",
    "taxes.title_placeholder": "Insira um nome mostrado aos usuários durante o checkout e nos detalhes do pedido.",
    "Enter a name shown to users at checkout and in order details.": "Insira um nome mostrado aos usuários durante o checkout e nos detalhes do pedido.",
    "taxes.default_value": "Valor padrão (%)",
    "taxes.default_placeholder": "Valor padrão em %. Exemplo: 6,5",
    "Default value in %. Example: 6.5": "Valor padrão em %. Exemplo: 6,5",
    "taxes.short_code": "Código curto",
    "taxes.short_code_tooltip_title": "Código curto",
    "taxes.short_code_tooltip_description": "Insira um código curto para este imposto.",
    "Enter a short code for this tax.": "Insira um código curto para este imposto.",
    "taxes.short_code_placeholder": "Use letras e números, até 10 caracteres. Exemplo: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Use letras e números, até 10 caracteres. Exemplo: GST10",
    "taxes.status_hint": "Status (Inativo / Ativo)",
    "taxes.advanced": "Avançado",
    "special_fees.title": "Taxas especiais",
    "special_fees.description": "Configure uma taxa fixa adicional ou porcentagem para cada lista.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Configure uma taxa fixa adicional ou porcentagem para cada lista.",
    "special_fees.fixed": "Taxa especial fixa",
    "Special fees fixed": "Taxa especial fixa",
    "special_fees.fixed_placeholder": "Insira o valor da taxa especial (exemplo: 5)",
    "Enter special fee amount (example: 5)": "Insira o valor da taxa especial (exemplo: 5)",
    "special_fees.percentage": "Taxa especial percentual",
    "Special fees percentage": "Taxa especial percentual",
    "special_fees.percentage_placeholder": "Insira a porcentagem da taxa especial (exemplo: 10%)",
    "Enter special fee percentage (example: 10%)": "Insira a porcentagem da taxa especial (exemplo: 10%)",
    "special_fees.example": "Exemplo",
    "Example": "Exemplo",
    "special_fees.example_description": "Você pode adicionar uma taxa especial sobre o preço da lista. Por exemplo, um produto listado custa $100 e você adiciona duas taxas por lista.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "Você pode adicionar uma taxa especial sobre o preço da lista. Por exemplo, um produto listado custa $100 e você adiciona duas taxas por lista.",
    "special_fees.example_fixed": "Valor fixo adicional = $10",
    "Additional fixed amount = $10": "Valor fixo adicional = $10",
    "special_fees.example_percentage": "Porcentagem fixa adicional = 10%",
    "Additional fixed percentage = 10%": "Porcentagem fixa adicional = 10%",
    "special_fees.example_total": "Preço final = $120",
    "Final price = $120": "Preço final = $120",
    "delivery.methods_title": "Métodos de serviço / envio",
    "Service / Shipping Methods": "Métodos de serviço / envio",
    "delivery.shipping_service": "Envio / Serviço",
    "Shipping / Service": "Envio / Serviço",
    "delivery.table_name": "Nome",
    "delivery.table_default": "Padrão",
    "delivery.table_order": "Ordem",
    "delivery.table_status": "Status",
    "delivery.table_action": "Ação",
    "delivery.yes": "Sim",
    "delivery.no": "Não",
    "delivery.active": "Ativo",
    "delivery.inactive": "Inativo",
    "delivery.delete_confirm": "Você quer excluir este método de envio?",
    "Do you want to delete this shipping method?": "Você quer excluir este método de envio?",
    "delivery.schedule_time": "Horário de agendamento",
    "delivery.translate": "Traduzir",
    "delivery.config": "Configuração",
    "Config": "Configuração",
    "delivery.add": "Adicionar Envio/Serviço",
    "Add Shipping/Service": "Adicionar Envio/Serviço",
    "delivery.save": "Salvar",
    "delivery.edit": "Editar Envio/Serviço",
    "Edit Shipping/Service": "Editar Envio/Serviço",
    "delivery.stuart_config": "Configurações do Stuart",
    "Stuart Configs": "Configurações do Stuart",
    "delivery.shipping_configs": "Configurações de Serviço/Envio",
    "Service / Shipping Configs": "Configurações de Serviço/Envio",
    "delivery.settings": "Configuração",
    "delivery.preview": "Visualizar",
    "delivery.shipment_option": "Opção de Envio",
    "Shipment Option": "Opção de Envio",
    "delivery.name": "Nome",
    "delivery.enter_name": "Digite o nome",
    "delivery.note": "Nota",
    "delivery.enter_note": "Digite a nota",
    "delivery.note_tooltip_title": "Nota",
    "delivery.note_tooltip_description": "Adicione uma nota opcional para explicar esta opção de envio ou serviço.",
    "Add an optional note to explain this shipping or service option.": "Adicione uma nota opcional para explicar esta opção de envio ou serviço.",
    "delivery.order": "Pedido",
    "delivery.enter_order": "Inserir pedido",
    "delivery.status_hint": "Status (Inativo / Ativo)",
    "delivery.default": "Padrão",
    "delivery.select_shipping_method": "Selecionar método de envio",
    "Select shipping method": "Selecionar método de envio",
    "delivery.select_extension": "Selecionar extensão",
    "Select extension": "Selecionar extensão",
    "delivery.add_photo": "Adicionar foto",
    "delivery.config.flat_shipping_fee.title": "Taxa fixa de envio",
    "Flat Shipping Fee": "Taxa fixa de envio",
    "delivery.config.flat_shipping_fee.placeholder": "Inserir taxa fixa de envio",
    "Enter flat shipping fee": "Inserir taxa fixa de envio",
    "delivery.config.schedule_time.title": "Horário de programação",
    "delivery.config.fulfillment_by_platform_enabled.title": "Cumprimento pela plataforma",
    "Fulfillment by platform": "Cumprimento pela plataforma",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Ícone de cumprimento pela plataforma",
    "Fulfillment by Platform Icon": "Ícone de cumprimento pela plataforma",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Ícone de entrega pelo vendedor",
    "Seller Delivery Icon": "Ícone de entrega pelo vendedor",
    "delivery.phone_number": "Número de telefone",
    "Phone number": "Número de telefone",
    "delivery.enter_phone_number": "Inserir número de telefone",
    "Enter phone number": "Inserir número de telefone",
    "delivery.address_line_1": "Endereço linha 1",
    "Address line 1": "Endereço linha 1",
    "delivery.enter_address_line_1": "Inserir endereço linha 1",
    "Enter address line 1": "Inserir endereço linha 1",
    "delivery.address_line_2": "Endereço linha 2",
    "Address line 2": "Endereço linha 2",
    "delivery.enter_address_line_2": "Inserir endereço linha 2",
    "Enter address line 2": "Inserir endereço linha 2",
    "delivery.landmark": "Ponto de referência",
    "delivery.enter_landmark": "Inserir ponto de referência",
    "Enter landmark": "Inserir ponto de referência",
    "delivery.state": "Estado",
    "delivery.enter_state": "Inserir estado",
    "Enter state": "Inserir estado",
    "delivery.post_code": "Código postal",
    "Post code": "Código postal",
    "delivery.enter_post_code": "Insira o código postal",
    "Enter post code": "Insira o código postal",
    "delivery.country": "País",
    "delivery.enter_country": "Insira o país",
    "Enter country": "Insira o país",
    "delivery.required_information": "Preencha as informações obrigatórias",
    "Please fill the required information": "Preencha as informações obrigatórias",
    "delivery.saved_successfully": "Enviado com sucesso",
    "delivery.storage_hub.title": "Pontos de Armazenamento",
    "Storage Hub Points": "Pontos de Armazenamento",
    "delivery.storage_hub.add": "Adicionar Ponto de Armazenamento",
    "Add Storage Hub": "Adicionar Ponto de Armazenamento",
    "delivery.storage_hub.edit": "Editar Ponto de Armazenamento",
    "Edit Storage Hub": "Editar Ponto de Armazenamento",
    "delivery.storage_hub.delete_confirm": "Deseja excluir este ponto de armazenamento?",
    "Do you want to delete this storage hub point?": "Deseja excluir este ponto de armazenamento?",
    "delivery.storage_hub.table_name": "Nome",
    "delivery.storage_hub.table_phone": "Telefone",
    "delivery.storage_hub.table_address": "Endereço",
    "delivery.storage_hub.table_landmark": "Ponto de Referência",
    "delivery.storage_hub.table_state": "Estado",
    "delivery.storage_hub.table_post_code": "Código Postal",
    "Post Code": "Código Postal",
    "delivery.storage_hub.table_country": "País",
    "delivery.storage_hub.table_action": "Ação",
    "delivery.select_environment": "Selecione o ambiente",
    "Select environment": "Selecione o ambiente",
    "delivery.environment_sandbox": "Ambiente de testes",
    "Sandbox": "Ambiente de testes",
    "delivery.environment_production": "Produção",
    "Production": "Produção",
    "delivery.stuart.client_id": "ID do Cliente",
    "delivery.stuart.enter_client_id": "Insira o ID do Cliente",
    "delivery.stuart.client_secret": "Segredo do Cliente",
    "Client Secret": "Segredo do Cliente",
    "delivery.stuart.enter_client_secret": "Insira o Segredo do Cliente",
    "Enter client secret": "Insira o Segredo do Cliente",
    "delivery.stuart.webhook_key": "Chave de autenticação do webhook",
    "Webhook Authentication Key": "Chave de autenticação do webhook",
    "delivery.stuart.enter_webhook_key": "Insira a chave de autenticação do webhook",
    "Enter webhook authentication key": "Insira a chave de autenticação do webhook",
    "delivery.sendcloud.public_key": "Chave pública",
    "Public Key": "Chave pública",
    "delivery.sendcloud.enter_public_key": "Insira a chave da API",
    "delivery.sendcloud.secret_key": "Chave secreta",
    "Secret Key": "Chave secreta",
    "delivery.sendcloud.enter_secret_key": "Insira a chave secreta de notificação",
    "delivery.sendcloud.default_shipping_address": "Endereço de envio padrão",
    "Default Shipping Address": "Endereço de envio padrão",
    "delivery.sendcloud.add_new": "+ Adicionar novo",
    "+ Add New": "+ Adicionar novo",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Métodos de pagamento",
    "Payment Methods": "Métodos de pagamento",
    "payments.add": "Adicionar método de pagamento",
    "Add Payment Method": "Adicionar método de pagamento",
    "payments.edit": "Editar método de pagamento",
    "Edit Payment Method": "Editar método de pagamento",
    "payments.delete_confirm": "Você quer excluir este método de pagamento?",
    "Do you want to delete this payment method?": "Você quer excluir este método de pagamento?",
    "payments.save_continue": "Salvar e continuar",
    "Save and continue": "Salvar e continuar",
    "payments.translate": "Traduzir pagamentos",
    "Translate Payments": "Traduzir pagamentos",
    "payments.config": "Configuração",
    "payments.integration_settings": "Configuração de integração",
    "Integration Settings": "Configuração de integração",
    "payments.opp_integration": "Integração OPP",
    "OPP Integration": "Integração OPP",
    "payments.billplz_integration": "Integração BillPlz",
    "BillPlz Integration": "Integração BillPlz",
    "payments.stripe_integration": "Integração Stripe",
    "Stripe Integration": "Integração Stripe",
    "payments.stripe_web_integration": "Integração web do Stripe",
    "Stripe Web Integration": "Integração web do Stripe",
    "payments.pawapay_integration": "Integração PawaPay",
    "PawaPay Integration": "Integração PawaPay",
    "payments.korapay_integration": "Integração KoraPay",
    "KoraPay Integration": "Integração KoraPay",
    "payments.flutterwave_integration": "Integração Flutterwave",
    "Flutterwave Integration": "Integração Flutterwave",
    "payments.commercepay_integration": "Integração CommercePay",
    "CommercePay Integration": "Integração CommercePay",
    "payments.checkout_com_integration": "Integração Checkout.com",
    "Checkout.com Integration": "Integração Checkout.com",
    "payments.paystack_integration": "Integração PayStack",
    "PayStack Integration": "Integração PayStack",
    "payments.razorpay_settings": "Configurações Razorpay",
    "Razorpay settings": "Configurações Razorpay",
    "payments.paydunya_settings": "Configurações Pay Dunya",
    "Pay Dunya settings": "Configurações Pay Dunya",
    "payments.mangopay_settings": "Configurações MangoPay",
    "MangoPay settings": "Configurações MangoPay",
    "payments.payu_latam_integration": "Integração PayU LATAM",
    "PayU LATAM Integration": "Integração PayU LATAM",
    "payments.table_name": "Nome",
    "payments.table_actions": "Ações",
    "payments.table_min_amount": "Valor Mínimo",
    "payments.table_max_amount": "Valor Máximo",
    "payments.table_default": "Padrão",
    "payments.table_order_by": "Ordem",
    "payments.table_status": "Status",
    "payments.yes": "Sim",
    "payments.no": "Não",
    "payments.active": "Ativo",
    "payments.inactive": "Inativo",
    "payments.settings": "Configurações",
    "payments.not_available": "N/D",
    "payments.step_select_type": "Selecionar Tipo",
    "payments.step_configure": "Configurar",
    "Configure": "Configurar",
    "payments.step_integration": "Integração",
    "Integration": "Integração",
    "payments.next": "Próximo →",
    "Next →": "Próximo →",
    "payments.save": "Salvar",
    "payments.choose_method": "Escolha um método de pagamento para configurar",
    "Choose a payment method to configure": "Escolha um método de pagamento para configurar",
    "payments.name": "Nome",
    "payments.enter_name": "Insira nome",
    "payments.maximum_amount": "Valor máximo",
    "payments.enter_maximum_amount": "Insira valor máximo",
    "payments.minimum_amount": "Valor mínimo",
    "payments.enter_minimum_amount": "Insira valor mínimo",
    "payments.note": "Nota",
    "payments.enter_note": "Insira nota",
    "payments.note_tooltip": "Adicione uma nota opcional para os clientes no checkout.",
    "Add an optional note for customers at checkout.": "Adicione uma nota opcional para os clientes no checkout.",
    "payments.order": "Ordem",
    "payments.enter_order": "Insira ordem",
    "payments.default": "Padrão",
    "payments.config_title": "Configuração de métodos de pagamento",
    "Payment Methods Configuration": "Configuração de métodos de pagamento",
    "payments.wallet_enable": "Carteira habilitada",
    "Wallet enabled": "Carteira habilitada",
    "payments.account_type": "Tipo de conta",
    "payments.select_account_type": "Selecione tipo de conta",
    "Select account type": "Selecione tipo de conta",
    "payments.connect_message_standard": "Mensagem de conexão padrão",
    "Connect message standard": "Mensagem de conexão padrão",
    "payments.enter_connect_message_standard": "Insira mensagem de conexão padrão",
    "Enter connect message standard": "Insira mensagem de conexão padrão",
    "payments.disconnect_message_standard": "Mensagem de desconexão padrão",
    "Disconnect message standard": "Mensagem de desconexão padrão",
    "payments.enter_disconnect_message_standard": "Insira mensagem de desconexão padrão",
    "Enter disconnect message standard": "Insira mensagem de desconexão padrão",
    "payments.connect_message_express": "Mensagem de conexão expressa",
    "Connect message express": "Mensagem de conexão expressa",
    "payments.enter_connect_message_express": "Insira mensagem de conexão expressa",
    "Enter connect message express": "Insira mensagem de conexão expressa",
    "payments.disconnect_message_express": "Mensagem de desconexão express",
    "Disconnect message express": "Mensagem de desconexão express",
    "payments.enter_disconnect_message_express": "Insira a mensagem de desconexão express",
    "Enter disconnect message express": "Insira a mensagem de desconexão express",
    "payments.enable_sandbox": "Habilitar sandbox",
    "Enable sandbox": "Habilitar sandbox",
    "payments.api_token": "Token de API",
    "API Token": "Token de API",
    "payments.enter_token": "Insira o token",
    "payments.key_id": "ID da chave",
    "Key ID": "ID da chave",
    "payments.enter_key_id": "Insira a ID da chave",
    "Enter key ID": "Insira a ID da chave",
    "payments.key_secret": "Segredo da chave",
    "Key Secret": "Segredo da chave",
    "payments.enter_secret_key": "Insira a chave secreta",
    "Enter secret key": "Insira a chave secreta",
    "payments.webhook_secret_key": "Chave secreta de webhook",
    "Webhook Secret Key": "Chave secreta de webhook",
    "payments.enter_webhook_secret_key": "Insira a chave secreta de webhook",
    "Enter webhook secret key": "Insira a chave secreta de webhook",
    "payments.master_key": "Chave mestra",
    "Master Key": "Chave mestra",
    "payments.public_key": "Chave pública",
    "payments.enter_public_key": "Insira a chave pública",
    "payments.private_key": "Chave privada",
    "Private Key": "Chave privada",
    "payments.merchant_id": "ID do comerciante",
    "Merchant ID": "ID do comerciante",
    "payments.enter_merchant_id": "Insira a ID do comerciante",
    "Enter merchant id": "Insira a ID do comerciante",
    "payments.processing_channel_id": "ID do canal de processamento",
    "Processing channel ID": "ID do canal de processamento",
    "payments.enter_processing_channel_id": "Insira a ID do canal de processamento",
    "Enter processing channel id": "Insira a ID do canal de processamento",
    "payments.api_key": "Chave API",
    "payments.x_signature_key": "Chave de assinatura X",
    "X Signature Key": "Chave de assinatura X",
    "payments.account_id": "ID da conta",
    "payments.login_api_key": "Chave API de login",
    "Login API key": "Chave API de login",
    "payments.client_id": "ID do cliente",
    "payments.client_api_key": "Chave de API do cliente",
    "Client API Key": "Chave de API do cliente",
    "payments.payin_fee": "Taxa de PayIn (%)",
    "PayIn fee (%)": "Taxa de PayIn (%)",
    "payments.withdraw_fee": "Taxa de Withdraw (%)",
    "Withdraw fee (%)": "Taxa de Withdraw (%)",
    "payments.enter_api_key": "Insira a chave API",
    "payments.enter_account_id": "Insira o ID da conta",
    "Enter account ID": "Insira o ID da conta",
    "payments.enter_login_api_key": "Insira a chave API de login",
    "Enter login API key": "Insira a chave API de login",
    "payments.enter_notification_secret": "Insira o segredo de notificação",
    "payments.enter_payin_fee": "Insira a taxa como porcentagem",
    "Enter fee as a percentage": "Insira a taxa como porcentagem",
    "payments.secret_key": "Chave secreta",
    "Secret key": "Chave secreta",
    "payments.publishable_key": "Chave publicável",
    "Publishable key": "Chave publicável",
    "payments.webhook_secret": "Segredo do webhook",
    "Webhook secret": "Segredo do webhook",
    "payments.enter_webhook_secret": "Insira o segredo do webhook",
    "Enter webhook secret": "Insira o segredo do webhook",
    "payments.enter_subscription_webhook_secret": "Insira o segredo do webhook de assinatura",
    "Enter subscription webhook secret": "Insira o segredo do webhook de assinatura",
    "payments.connect_client_id": "ID do cliente Connect",
    "Connect client ID": "ID do cliente Connect",
    "payments.enter_connect_client_id": "Insira o ID do cliente Connect",
    "Enter Connect client ID": "Insira o ID do cliente Connect",
    "payments.stripe_reminders": "Lembretes do Stripe",
    "Stripe reminders": "Lembretes do Stripe",
    "payments.stripe_sync_help": "A sincronização verifica sua chave secreta com o Stripe, preenche suas informações de conta e cria os pontos finais de webhook que a Tradly precisa. Os segredos de webhook são preenchidos automaticamente; salve o formulário quando terminar.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "A sincronização verifica sua chave secreta com o Stripe, preenche suas informações de conta e cria os pontos finais de webhook que a Tradly precisa. Os segredos de webhook são preenchidos automaticamente; salve o formulário quando terminar.",
    "payments.find_in_stripe": "Localizar no Painel do Stripe",
    "Find in Stripe Dashboard": "Localizar no Painel do Stripe",
    "payments.description": "Descrição",
    "payments.learn_more_stripe": "Saiba mais sobre Pagamentos Stripe",
    "Learn more about Stripe Payments": "Saiba mais sobre Pagamentos Stripe",
    "payments.learn_more_stripe_connect": "Saiba mais sobre Stripe Connect para marketplaces",
    "Learn more about Stripe Connect for marketplaces": "Saiba mais sobre Stripe Connect para marketplaces",
    "payments.token": "Token",
    "Token": "Token",
    "payments.payment_options": "Opções de pagamento",
    "Payment options": "Opções de pagamento",
    "payments.enable_integration": "Ativar integração",
    "Enable integration": "Ativar integração",
    "payments.enter_provider_id": "Insira o ID de {provider}",
    "Enter {provider} ID": "Insira o ID de {provider}",
    "payments.integration_status_help": "Configure este provedor em suas configurações.",
    "Configure this provider in its settings.": "Configure este provedor em suas configurações.",
    "listings.title": "Listagens",
    "listings.manage": "Gerenciar",
    "listings.show_rows": "Mostrar linhas",
    "listings.clear": "Limpar",
    "listings.apply": "Aplicar",
    "listings.select_date": "Selecionar data",
    "Select date": "Selecionar data",
    "listings.start_date": "Data de início",
    "listings.end_date": "Data de término",
    "listings.status_types": "Tipos de status",
    "Status types": "Tipos de status",
    "listings.categories": "Categorias",
    "listings.attributes": "Atributos",
    "listings.clear_all_filters": "Limpar todos os filtros",
    "Clear all filters": "Limpar todos os filtros",
    "listings.import": "Importar",
    "listings.export": "Exportar",
    "listings.smart_upload": "Upload inteligente (Beta)",
    "Smart Upload (Beta)": "Upload inteligente (Beta)",
    "listings.filter_listings": "Filtrar listagens",
    "Filter listings": "Filtrar listagens",
    "listings.sort_listings": "Ordenar listagens",
    "Sort listings": "Ordenar listagens",
    "listings.import_listings": "Importar listagens",
    "Import listings": "Importar listagens",
    "listings.export_listings": "Exportar listagens",
    "Export listings": "Exportar listagens",
    "listings.list_view": "Vista de lista",
    "listings.grid_view": "Vista de grade",
    "listings.map_view": "Vista de mapa",
    "listings.board_view": "Visualização de quadro",
    "listings.export_all_title": "Exportar todas as listagens?",
    "Export all listings?": "Exportar todas as listagens?",
    "listings.export_all_message": "Isso preparará um arquivo contendo todas as listagens. Deseja continuar?",
    "This will prepare a file containing all listings. Do you want to continue?": "Isso preparará um arquivo contendo todas as listagens. Deseja continuar?",
    "listings.export_all": "Exportar todas as listagens",
    "Export all listings": "Exportar todas as listagens",
    "listings.cancel": "Cancelar",
    "listings.status_all": "Todos",
    "listings.status_pending": "Pendente",
    "listings.status_approved": "Aprovado",
    "listings.status_rejected": "Rejeitado",
    "listings.status_archived": "Arquivado",
    "Archived": "Arquivado",
    "listings.sort_newest_first": "Mais recente primeiro",
    "Newest first": "Mais recente primeiro",
    "listings.sort_price_high_to_low": "Preço: alto para baixo",
    "Price: high to low": "Preço: alto para baixo",
    "listings.sort_price_low_to_high": "Preço: baixo para alto",
    "Price: low to high": "Preço: baixo para alto",
    "listings.header_0": "Título",
    "listings.header_1": "Site",
    "Website": "Site",
    "listings.header_2": "Preço da lista",
    "listings.header_3": "Percentual de oferta",
    "listings.header_4": "Imagem",
    "listings.header_5": "Preço da oferta",
    "Offer price": "Preço da oferta",
    "listings.header_6": "Status",
    "listings.header_7": "ID da lista",
    "listings.header_8": "Status da lista",
    "Listing status": "Status da lista",
    "listings.header_9": "Contas",
    "listings.header_10": "Moeda",
    "listings.header_11": "Vendido",
    "Sold": "Vendido",
    "listings.header_12": "Valor objetivo",
    "Goal amount": "Valor objetivo",
    "listings.filter_status": "Status",
    "listings.filter_price": "Preço",
    "listings.filter_category": "Categoria",
    "listings.filter_clear_all": "Limpar todos os filtros",
    "listings.status_count": "Status ({count})",
    "Status ({count})": "Status ({count})",
    "listings.price_count": "Preço ({count})",
    "Price ({count})": "Preço ({count})",
    "listings.category_count": "Categoria ({count})",
    "Category ({count})": "Categoria ({count})",
    "listings.search": "Pesquisar listagens",
    "listings.clear_search": "Limpar pesquisa",
    "Clear listing search": "Limpar pesquisa",
    "listings.active": "Ativo",
    "listings.inactive": "Inativo",
    "listings.approve": "Aprovar",
    "listings.reject": "Rejeitar",
    "listings.delete_confirm": "Tem certeza de que deseja excluir esta listagem?",
    "listings.approve_confirm": "Você deseja aprovar esta listagem?",
    "Do you want to approve this listing?": "Você deseja aprovar esta listagem?",
    "listings.reject_confirm": "Você deseja rejeitar esta listagem?",
    "Do you want to reject this listing?": "Você deseja rejeitar esta listagem?",
    "listings.yes": "Sim",
    "listings.no": "Não",
    "listings.confirm_delete": "Tem certeza de que deseja excluir esta listagem?",
    "listings.confirm_approve": "Você deseja aprovar esta listagem?",
    "listings.confirm_reject": "Você deseja rejeitar esta listagem?",
    "listings.column.actions": "Ações",
    "listings.audio_episode": "Episódio de áudio",
    "Audio episode": "Episódio de áudio",
    "listings.video": "Vídeo",
    "listings.seller": "Vendedor",
    "listings.rating": "Avaliação",
    "listings.followers": "Seguidores",
    "listings.view_seller_account": "Ver conta do vendedor",
    "View seller account": "Ver conta do vendedor",
    "listings.add_variant": "Adicionar variante",
    "Add variant": "Adicionar variante",
    "listings.edit": "Editar",
    "listings.preview": "Pré-visualizar",
    "listings.share": "Compartilhar",
    "listings.view_listing": "Ver lista",
    "View listing": "Ver lista",
    "listings.stock": "Estoque",
    "Stock": "Estoque",
    "listings.variants": "Variantes",
    "listings.campaign": "Campanha",
    "Campaign": "Campanha",
    "listings.rental_details": "Detalhes de aluguel",
    "Rental details": "Detalhes de aluguel",
    "listings.copy": "Copiar",
    "listings.inventory": "Inventário",
    "listings.order_type": "Tipo de pedido",
    "Order type": "Tipo de pedido",
    "listings.stock_by_location": "Estoque por localização",
    "Stock by location": "Estoque por localização",
    "listings.loading_location_stock": "Carregando estoque por localização…",
    "Loading location stock…": "Carregando estoque por localização…",
    "listings.no_location_stock": "Nenhum estoque atribuído a uma localização.",
    "No stock assigned to a location.": "Nenhum estoque atribuído a uma localização.",
    "listings.page_analytics": "Análise de página",
    "Page analytics": "Análise de página",
    "listings.loading": "Carregando…",
    "listings.analytics_key_missing": "A chave da API de análise não está configurada para este inquilino.",
    "Analytics API key is not configured for this tenant.": "A chave da API de análise não está configurada para este inquilino.",
    "listings.no_slug": "Nenhum slug está disponível para este anúncio.",
    "No slug is available for this listing.": "Nenhum slug está disponível para este anúncio.",
    "listings.no_analytics": "Nenhuma análise carregada ainda.",
    "listings.load_analytics": "Carregar análises",
    "Load analytics": "Carregar análises",
    "listings.no_orders": "Nenhum pedido ainda para este anúncio",
    "No orders yet for this listing": "Nenhum pedido ainda para este anúncio",
    "listings.social_ratings": "Social e classificações",
    "Social and ratings": "Social e classificações",
    "listings.tags": "Etiquetas",
    "listings.schedule": "Agendar",
    "listings.detail": "Detalhe",
    "Detail": "Detalhe",
    "listings.update_stock": "Atualizar estoque",
    "Update stock": "Atualizar estoque",
    "listings.new_stock_quantity": "Nova quantidade de estoque",
    "New stock quantity": "Nova quantidade de estoque",
    "listings.location": "Localização",
    "listings.quantity": "Quantidade",
    "listings.current_stock": "Estoque atual: {quantity}",
    "Current stock: {quantity}": "Estoque atual: {quantity}",
    "listings.loading_rental": "Carregando configurações de aluguel…",
    "Loading rental settings…": "Carregando configurações de aluguel…",
    "payments.enter_publishable_key": "Insira a chave pública",
    "Enter publishable key": "Insira a chave pública",
    "listings.add_listing": "Adicionar anúncio",
    "Add listing": "Adicionar anúncio",
    "listings.edit_listing": "Editar anúncio",
    "listings.enter_title": "Insira o título",
    "listings.account": "Conta",
    "listings.list_price": "Preço de lista",
    "listings.enter_list_price": "Insira o preço de lista",
    "listings.select_currency": "Selecione a moeda",
    "listings.select_category": "Selecione a categoria",
    "listings.select_categories": "Selecione categorias",
    "Select categories": "Selecione categorias",
    "listings.add_category": "+ Adicionar categoria",
    "+ Add category": "+ Adicionar categoria",
    "listings.add_attribute": "Adicionar atributo",
    "Add attribute": "Adicionar atributo",
    "listings.enter_stock": "Inserir estoque",
    "listings.offer_percentage": "Porcentagem de oferta",
    "Offer percentage": "Porcentagem de oferta",
    "listings.enter_offer": "Inserir oferta",
    "Enter offer": "Inserir oferta",
    "listings.max_quantity_optional": "Quantidade máxima (opcional)",
    "Max quantity (optional)": "Quantidade máxima (opcional)",
    "listings.enter_max_quantity": "Inserir quantidade máxima",
    "Enter max quantity": "Inserir quantidade máxima",
    "listings.enter_slug": "Inserir slug",
    "listings.enter_meta_title": "Inserir título meta",
    "listings.repeat": "Repetir",
    "Repeat": "Repetir",
    "listings.start_time": "Hora de início",
    "Start time": "Hora de início",
    "listings.end_time": "Hora de término",
    "End time": "Hora de término",
    "listings.slot": "Slot",
    "Slot": "Slot",
    "listings.starts_from": "Começa a partir de:",
    "Starts from:": "Começa a partir de:",
    "listings.add_schedule": "+ Adicionar horário",
    "+ Add schedule": "+ Adicionar horário",
    "listings.upload_here": "Enviar aqui",
    "listings.save": "Salvar",
    "listings.update": "Atualizar",
    "listings.tax": "Imposto",
    "listings.title_required": "Por favor, insira um título",
    "Please enter a title": "Por favor, insira um título",
    "listings.select_tax": "Por favor, selecione um imposto",
    "Please select a tax": "Por favor, selecione um imposto",
    "listings.select_item": "Por favor, selecione {item}",
    "Please select {item}": "Por favor, selecione {item}",
    "listings.offer_percentage_validation": "A porcentagem de oferta deve estar entre 0 e 100",
    "Offer percentage must be between 0 and 100": "A porcentagem de oferta deve estar entre 0 e 100",
    "listings.custom_seo": "SEO personalizado",
    "Custom SEO": "SEO personalizado",
    "listings.select_value": "Selecionar valor",
    "Select value": "Selecionar valor",
    "listings.add_schedule_title": "Adicionar horário",
    "Add schedule": "Adicionar horário",
    "listings.select_from_media": "Selecionar dos meios",
    "listing_form.create_listing": "Criar anúncio",
    "Create listing": "Criar anúncio",
    "listing_form.update_listing": "Atualizar anúncio",
    "Update listing": "Atualizar anúncio",
    "listing_form.saving": "Salvando…",
    "listing_form.main_information": "Informação principal",
    "Main information": "Informação principal",
    "listing_form.audio_listing": "Anúncio de áudio",
    "Audio listing": "Anúncio de áudio",
    "listing_form.basic_information": "Informação básica",
    "Basic information": "Informação básica",
    "listing_form.listing_type": "Tipo de anúncio",
    "Listing type": "Tipo de anúncio",
    "listing_form.title": "Título",
    "listing_form.enter_listing_title": "Insira o título do anúncio",
    "Enter listing title": "Insira o título do anúncio",
    "listing_form.description": "Descrição",
    "listing_form.enter_detailed_description": "Insira uma descrição detalhada",
    "Enter detailed description": "Insira uma descrição detalhada",
    "listing_form.tags": "Etiquetas",
    "listing_form.tag_example": "ex., eletrônicos, gadgets, novos",
    "e.g., electronics, gadgets, new": "ex., eletrônicos, gadgets, novos",
    "listing_form.taxes": "Impostos",
    "listing_form.optional": "Opcional",
    "listing_form.start_date": "Data de início",
    "listing_form.end_date": "Data de término",
    "listing_form.currency": "Moeda",
    "listing_form.select_currency": "Selecionar moeda",
    "listing_form.goal_price": "Preço objetivo",
    "Goal price": "Preço objetivo",
    "listing_form.set_fundraising_goal": "Definir meta de arrecadação",
    "Set your fundraising goal": "Definir meta de arrecadação",
    "listing_form.pricing": "Preços",
    "Pricing": "Preços",
    "listing_form.select": "Selecionar",
    "listing_form.price": "Preço",
    "listing_form.offer_percent": "Oferta %",
    "Offer %": "Oferta %",
    "listing_form.listing_price": "Preço da lista:",
    "Listing price:": "Preço da lista:",
    "listing_form.set_fundraising_goal_amount": "Defina o valor do objetivo de arrecadação",
    "Set your fundraising goal amount": "Defina o valor do objetivo de arrecadação",
    "listing_form.category": "Categoria",
    "listing_form.select_a_category": "Selecione uma categoria",
    "Select a category": "Selecione uma categoria",
    "listing_form.clear_selected_category": "Limpar categoria selecionada",
    "Clear selected category": "Limpar categoria selecionada",
    "listing_form.create_new_category": "Criar uma nova categoria",
    "Create a new category": "Criar uma nova categoria",
    "listing_form.search_categories": "Pesquisar categorias…",
    "Search categories…": "Pesquisar categorias…",
    "listing_form.no_categories_match": "Nenhuma categoria encontrada",
    "No categories found": "Nenhuma categoria encontrada",
    "listing_form.draft_found": "Um rascunho salvo foi encontrado.",
    "A saved draft was found.": "Um rascunho salvo foi encontrado.",
    "listing_form.restore": "Restaurar",
    "Restore": "Restaurar",
    "listing_form.discard": "Descartar",
    "listing_form.characters": "caracteres",
    "characters": "caracteres",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Produtos físicos",
    "Physical products": "Produtos físicos",
    "listing_form.type_events": "Eventos",
    "Events": "Eventos",
    "listing_form.type_digital": "Produtos digitais",
    "Digital products": "Produtos digitais",
    "listing_form.type_appointments": "Agendamentos",
    "Appointments": "Agendamentos",
    "listing_form.type_rentals": "Aluguéis",
    "listing_form.type_donation": "Financiamento coletivo",
    "Crowdfunding": "Financiamento coletivo",
    "listing_form.type_information_listing": "Informação",
    "Information": "Informação",
    "listing_form.type_video_listing": "Vídeo",
    "listing_form.type_audio_listing": "Áudio",
    "listing_form.select_taxes": "Selecionar impostos (opcional)",
    "Select taxes (optional)": "Selecionar impostos (opcional)",
    "listing_form.no_taxes": "Nenhum imposto disponível",
    "No taxes available": "Nenhum imposto disponível",
    "listing_form.inventory_shipping": "Estoque e envio",
    "Inventory & shipping": "Estoque e envio",
    "listing_form.stock": "Estoque",
    "listing_form.weight": "Peso",
    "Weight": "Peso",
    "listing_form.dimensions": "Dimensões (L×A×H)",
    "Dimensions (L×W×H)": "Dimensões (L×A×H)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Código de barras",
    "Barcode": "Código de barras",
    "listing_form.length": "Comprimento",
    "Length": "Comprimento",
    "listing_form.width": "Largura",
    "Width": "Largura",
    "listing_form.height": "Altura",
    "Height": "Altura",
    "listing_form.seo_settings": "Configuração SEO",
    "SEO settings": "Configuração SEO",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "Versão amigável para URL",
    "URL-friendly version of the title": "Versão amigável para URL",
    "listing_form.meta_title": "Título meta",
    "listing_form.recommended_meta_title": "Recomendado: 50–60 caracteres",
    "Recommended: 50–60 chars": "Recomendado: 50–60 caracteres",
    "listing_form.meta_keywords": "Palavras-chave meta",
    "Meta keywords": "Palavras-chave meta",
    "listing_form.separate_with_commas": "Separar com vírgulas",
    "Separate with commas": "Separar com vírgulas",
    "listing_form.meta_description": "Descrição meta",
    "listing_form.recommended_meta_description": "Recomendado: 150–160 caracteres",
    "Recommended: 150–160 chars": "Recomendado: 150–160 caracteres",
    "listing_form.hide": "Ocultar",
    "listing_form.show": "Exibir",
    "listing_form.seo_fields": "Campos de otimização de mecanismos de pesquisa",
    "search engine optimization fields": "Campos de otimização de mecanismos de pesquisa",
    "listing_form.auto_generated_slug": "Gerado automaticamente a partir do título",
    "Auto-generated from title": "Gerado automaticamente a partir do título",
    "listing_form.seo_title_optional": "Título SEO (opcional)",
    "SEO title (optional)": "Título SEO (opcional)",
    "listing_form.keywords_comma_separated": "Palavras-chave separadas por vírgulas",
    "Keywords separated by commas": "Palavras-chave separadas por vírgulas",
    "listing_form.search_description_optional": "Descrição breve para resultados de pesquisa (opcional)",
    "Brief description for search results (optional)": "Descrição breve para resultados de pesquisa (opcional)",
    "listing_form.account": "Conta",
    "listing_form.loading_accounts": "Carregando contas…",
    "Loading accounts…": "Carregando contas…",
    "listing_form.clear_selected_account": "Limpar conta selecionada",
    "Clear selected account": "Limpar conta selecionada",
    "listing_form.search_accounts": "Pesquisar contas…",
    "Search accounts…": "Pesquisar contas…",
    "listing_form.create_account": "Criar uma nova conta",
    "Create a new account": "Criar uma nova conta",
    "listing_form.no_accounts_found": "Nenhuma conta encontrada",
    "No accounts found": "Nenhuma conta encontrada",
    "listing_form.rental_settings": "Configuração de aluguel",
    "Rental settings": "Configuração de aluguel",
    "listing_form.rental_price_help": "O preço do anúncio é calculado a partir da taxa de aluguel e da duração.",
    "The listing price is calculated from the rental rate and duration.": "O preço do anúncio é calculado a partir da taxa de aluguel e da duração.",
    "listing_form.rate_unit": "Unidade de taxa",
    "Rate unit": "Unidade de taxa",
    "listing_form.hour": "Hora",
    "Hour": "Hora",
    "listing_form.day": "Dia",
    "listing_form.week": "Semana",
    "listing_form.rental_rate_amount": "Taxa de aluguel",
    "Rental rate": "Taxa de aluguel",
    "listing_form.rental_min_duration": "Duração mínima",
    "Minimum duration": "Duração mínima",
    "listing_form.rental_max_duration": "Duração máxima",
    "Maximum duration": "Duração máxima",
    "listing_form.rental_buffer_time": "Tempo de buffer (horas)",
    "Buffer time (hours)": "Tempo de buffer (horas)",
    "listing_form.rental_deposit_amount": "Valor do depósito",
    "Deposit amount": "Valor do depósito",
    "listing_form.rental_max_units": "Unidades máximas",
    "Maximum units": "Unidades máximas",
    "listing_form.quick_create_title": "Criar {entity}",
    "Create {entity}": "Criar {entity}",
    "listing_form.close": "Fechar",
    "listing_form.account_name": "Nome da conta",
    "listing_form.category_name": "Nome da categoria",
    "Category name": "Nome da categoria",
    "listing_form.account_example": "Ex.: Loja Acme",
    "e.g. Acme Store": "Ex.: Loja Acme",
    "listing_form.category_example": "Ex.: Produtos frescos",
    "e.g. Fresh Produce": "Ex.: Produtos frescos",
    "listing_form.creating": "Criando…",
    "listing_form.create_entity": "Criar {entity}",
    "listing_form.cancel": "Cancelar",
    "listing_form.go_back": "Voltar",
    "Go back": "Voltar",
    "listing_form.upgrade_plan": "Atualizar plano",
    "Upgrade plan": "Atualizar plano",
    "listing_form.close_upgrade_dialog": "Fechar diálogo de atualização",
    "Close upgrade dialog": "Fechar diálogo de atualização",
    "listing_form.loading_attributes": "Carregando atributos…",
    "Loading attributes…": "Carregando atributos…",
    "listing_form.no_attributes": "Nenhum atributo para esta categoria",
    "No attributes for this category": "Nenhum atributo para esta categoria",
    "listing_form.unsupported_field_type": "Tipo de campo não compatível",
    "Unsupported field type": "Tipo de campo não compatível",
    "listing_form.delete_schedule_confirm": "Tem certeza de que deseja excluir este agendamento?",
    "Are you sure you want to delete this schedule?": "Tem certeza de que deseja excluir este agendamento?",
    "listing_form.no_schedules_added": "Nenhum horário adicionado ainda",
    "No schedules added yet": "Nenhum horário adicionado ainda",
    "listing_form.stock_label": "Estoque:",
    "Stock:": "Estoque:",
    "listing_form.active": "Ativo",
    "listing_form.inactive": "Inativo",
    "listing_form.edit": "Editar",
    "listing_form.delete": "Excluir",
    "listing_form.schedules": "Agendamentos",
    "Schedules": "Agendamentos",
    "listing_form.no_schedules_yet": "Nenhum horário ainda",
    "No schedules yet": "Nenhum horário ainda",
    "listing_form.dates_label": "Datas:",
    "Dates:": "Datas:",
    "listing_form.time_label": "Horário:",
    "Time:": "Horário:",
    "listing_form.repeat_label": "Repetir:",
    "Repeat:": "Repetir:",
    "listing_form.capacity_label": "Capacidade:",
    "Capacity:": "Capacidade:",
    "listing_form.edit_schedule": "Editar horário",
    "Edit schedule": "Editar horário",
    "listing_form.add_new_schedule": "Adicionar novo horário",
    "Add new schedule": "Adicionar novo horário",
    "listing_form.repeat_pattern": "Padrão de repetição",
    "Repeat pattern": "Padrão de repetição",
    "listing_form.select_days": "Selecionar dias",
    "Select days": "Selecionar dias",
    "listing_form.total_stocks_capacity": "Estoque total (capacidade)",
    "Total stock (capacity)": "Estoque total (capacidade)",
    "listing_form.select_at_least_one_day": "Selecione pelo menos um dia",
    "Please select at least one day": "Selecione pelo menos um dia",
    "listing_form.unlimited_capacity_help": "Deixe em branco para capacidade ilimitada",
    "Leave empty for unlimited capacity": "Deixe em branco para capacidade ilimitada",
    "listing_form.add_schedule": "+ Adicionar horário",
    "listing_form.schedule_number": "Horário #{number}",
    "Schedule #{number}": "Horário #{number}",
    "listing_form.update_action": "atualizar",
    "update": "atualizar",
    "listing_form.create_action": "criar",
    "create": "criar",
    "listing_form.a_schedule": "um horário",
    "a schedule": "um horário",
    "listing_form.daily": "Diário",
    "Daily": "Diário",
    "listing_form.weekdays": "Dias úteis (Seg - Sex)",
    "Weekdays (Mon - Fri)": "Dias úteis (Seg - Sex)",
    "listing_form.weekend": "Fim de semana (Sáb - Dom)",
    "Weekend (Sat - Sun)": "Fim de semana (Sáb - Dom)",
    "listing_form.custom": "Personalizado",
    "listing_form.weekday_0": "Segunda-feira",
    "Monday": "Segunda-feira",
    "listing_form.weekday_1": "Terça-feira",
    "Tuesday": "Terça-feira",
    "listing_form.weekday_2": "Quarta-feira",
    "Wednesday": "Quarta-feira",
    "listing_form.weekday_3": "Quinta-feira",
    "Thursday": "Quinta-feira",
    "listing_form.weekday_4": "Sexta-feira",
    "Friday": "Sexta-feira",
    "listing_form.weekday_5": "Sábado",
    "Saturday": "Sábado",
    "listing_form.weekday_6": "Domingo",
    "Sunday": "Domingo",
    "listing_form.media_max_files": "Máximo {count} {type} permitido",
    "Maximum {count} {type} allowed": "Máximo {count} {type} permitido",
    "listing_form.video_size_limit": "Cada vídeo deve ter 1 GB ou menos",
    "Each video must be 1GB or smaller": "Cada vídeo deve ter 1 GB ou menos",
    "listing_form.videos": "Vídeos",
    "Videos": "Vídeos",
    "listing_form.images": "Imagens",
    "listing_form.select_from_media": "Selecionar dos meios",
    "listing_form.video_upload_help": "Envie vídeos nos formatos MP4, MOV, AVI, MKV, WebM (máximo 1GB cada um)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Envie vídeos nos formatos MP4, MOV, AVI, MKV, WebM (máximo 1GB cada um)",
    "listing_form.image_upload_help": "Envie imagens nos formatos JPG, PNG, GIF, WebP (máximo 10MB cada uma)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Envie imagens nos formatos JPG, PNG, GIF, WebP (máximo 10MB cada uma)",
    "listing_form.uploading_video": "Enviando vídeo…",
    "Uploading video…": "Enviando vídeo…",
    "listing_form.audio_episode": "Episódio de áudio",
    "listing_form.audio_upload_help": "Envie um arquivo de áudio ou cole uma URL pública para o feed RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Envie um arquivo de áudio ou cole uma URL pública para o feed RSS.",
    "listing_form.selected_file": "Selecionado: {name}",
    "listing_form.audio_url_help": "A URL é opcional quando um arquivo é selecionado. Deixe em branco para usar o arquivo enviado.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "A URL é opcional quando um arquivo é selecionado. Deixe em branco para usar o arquivo enviado.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Enviando áudio…",
    "Uploading audio…": "Enviando áudio…",
    "listing_form.validation_start_date": "Por favor selecione a data de início",
    "Please select start date": "Por favor selecione a data de início",
    "listing_form.validation_end_date": "Por favor selecione a data de término",
    "Please select end date": "Por favor selecione a data de término",
    "listing_form.validation_start_time": "Por favor selecione a hora de início",
    "Please select start time": "Por favor selecione a hora de início",
    "listing_form.validation_end_time": "Por favor selecione a hora de término",
    "Please select end time": "Por favor selecione a hora de término",
    "listing_form.weekdays_short": "Dias úteis",
    "Weekdays": "Dias úteis",
    "listing_form.weekend_short": "Fim de semana",
    "Weekend": "Fim de semana",
    "listing_form.click_add_schedule_help": "Clique em \"{action}\" para criar seu primeiro horário",
    "Click \"{action}\" to create your first schedule": "Clique em \"{action}\" para criar seu primeiro horário",
    "listing_form.schedule_form_intro": "Preencha os detalhes abaixo para",
    "Fill in the details below to": "Preencha os detalhes abaixo para",
    "listing_form.update": "Atualizar",
    "listing_form.save": "Salvar",
    "listing_form.variant_value_required": "Selecione pelo menos um valor de variante (por exemplo, Cor, Tamanho)",
    "Please select at least one variant value (e.g., Color, Size)": "Selecione pelo menos um valor de variante (por exemplo, Cor, Tamanho)",
    "listing_form.valid_price_required": "Insira um preço válido",
    "Please enter a valid price": "Insira um preço válido",
    "listing_form.delete_variant_confirm": "Tem certeza de que deseja excluir esta variante?",
    "Are you sure you want to delete this variant?": "Tem certeza de que deseja excluir esta variante?",
    "listing_form.product_variants": "Variantes do produto",
    "Product Variants": "Variantes do produto",
    "listing_form.add_variant": "+ Adicionar variante",
    "+ Add Variant": "+ Adicionar variante",
    "listing_form.select_all_variants": "Selecionar todas as variantes",
    "Select all variants": "Selecionar todas as variantes",
    "listing_form.set_quantity_selected": "Definir quantidade para selecionadas",
    "Set quantity for selected": "Definir quantidade para selecionadas",
    "listing_form.quantity": "Quantidade",
    "listing_form.apply_quantity": "Aplicar quantidade",
    "Apply quantity": "Aplicar quantidade",
    "listing_form.select_variant_number": "Selecione a variante {number}",
    "Select variant {number}": "Selecione a variante {number}",
    "listing_form.variant_number": "Variante #{number}",
    "Variant #{number}": "Variante #{number}",
    "listing_form.existing": "Existente",
    "Existing": "Existente",
    "listing_form.modified": "Modificado",
    "Modified": "Modificado",
    "listing_form.variant_name": "Nome da variante",
    "Variant Name": "Nome da variante",
    "listing_form.variant_values": "Valores da variante",
    "Variant Values": "Valores da variante",
    "listing_form.type": "Tipo",
    "listing_form.no_variant_values": "Sem valores de variante",
    "No variant values": "Sem valores de variante",
    "listing_form.no_variants_yet": "Ainda não há variantes",
    "No variants yet": "Ainda não há variantes",
    "listing_form.click_add_variant_help": "Clique em \"{action}\" para criar sua primeira variante",
    "Click \"{action}\" to create your first variant": "Clique em \"{action}\" para criar sua primeira variante",
    "listing_form.select_variant_type": "Selecione {type}",
    "Select {type}": "Selecione {type}",
    "listing_form.no_variant_types": "Não há tipos de variante disponíveis. Crie os tipos de variante (como Cor, Tamanho) primeiro.",
    "No variant types available. Please create variant types (like Color, Size) first.": "Não há tipos de variante disponíveis. Crie os tipos de variante (como Cor, Tamanho) primeiro.",
    "listing_form.generated_name": "Nome gerado:",
    "Generated Name:": "Nome gerado:",
    "listing_form.custom_title": "Título personalizado",
    "Custom Title": "Título personalizado",
    "listing_form.auto_generate_help": "Deixe em branco para gerar automaticamente",
    "Leave blank to auto-generate": "Deixe em branco para gerar automaticamente",
    "listing_form.save_variant": "Salvar variante",
    "Save Variant": "Salvar variante",
    "listing_form.start_time": "Hora de início",
    "Start Time": "Hora de início",
    "listing_form.end_time": "Hora de término",
    "End Time": "Hora de término",
    "listing_form.enter_capacity_limit": "Insira o limite de capacidade",
    "Enter capacity limit": "Insira o limite de capacidade",
    "collections.validation_title": "O título não pode estar vazio",
    "Title should not be empty": "O título não pode estar vazio",
    "collections.validation_platform": "Selecione pelo menos uma plataforma",
    "Select at least one platform": "Selecione pelo menos uma plataforma",
    "collections.validation_dates": "A data de término deve ser posterior à data de início",
    "End Date must be later than start date": "A data de término deve ser posterior à data de início",
    "collections.validation_minimum_selection": "Selecione pelo menos um {type}",
    "Select at least one {type}": "Selecione pelo menos um {type}",
    "collections.account": "conta",
    "account": "conta",
    "collections.listing": "lista",
    "listing": "lista",
    "collections.edit_title": "Editar coleção",
    "Edit Collection": "Editar coleção",
    "collections.create_title": "Criar coleção",
    "Create Collection": "Criar coleção",
    "collections.details": "Detalhes da coleção",
    "Collection details": "Detalhes da coleção",
    "collections.title_placeholder": "Insira o nome do título",
    "Enter title name": "Insira o nome do título",
    "collections.slug": "Slug",
    "collections.slug_placeholder": "Insira o slug",
    "collections.enter_title_first": "Por favor, insira um título primeiro",
    "collections.scope": "Escopo",
    "collections.accounts": "Contas",
    "collections.listings": "Listas",
    "collections.choose_category": "Escolher categoria",
    "collections.conditions": "Condições",
    "Conditions": "Condições",
    "collections.condition_type": "Tipo de condição",
    "Condition type": "Tipo de condição",
    "collections.manual": "Manual",
    "Manual": "Manual",
    "collections.automated": "Automático",
    "Automated": "Automático",
    "collections.availability": "Disponibilidade das coleções",
    "Collections availability": "Disponibilidade das coleções",
    "collections.schedule": "Agendamento",
    "collections.applicable_channels": "Selecione o canal aplicável",
    "Select applicable channel": "Selecione o canal aplicável",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Pesquisar por nome",
    "Search by name": "Pesquisar por nome",
    "collections.not_found": "Coleção não encontrada.",
    "Collection not found.": "Coleção não encontrada.",
    "collections.featured_listings": "Listagens destacadas",
    "Featured listings": "Listagens destacadas",
    "collections.url_copied": "URL pública copiada",
    "Public URL copied": "URL pública copiada",
    "collections.url_copy_failed": "Não é possível copiar a URL pública",
    "Unable to copy the public URL": "Não é possível copiar a URL pública",
    "collections.collection": "Coleção",
    "Collection": "Coleção",
    "collections.this_collection": "esta coleção",
    "this collection": "esta coleção",
    "collections.share_text": "Ver {title}",
    "View {title}": "Ver {title}",
    "collections.public_url": "URL pública:",
    "Public URL:": "URL pública:",
    "collections.copy_url": "Copiar URL",
    "Copy URL": "Copiar URL",
    "collections.items": "Itens",
    "collections.expires": "Expira",
    "collections.never": "Nunca",
    "Never": "Nunca",
    "collections.automatic_conditions": "Condições automáticas",
    "Automatic Conditions": "Condições automáticas",
    "collections.item_count": "{count} itens",
    "{count} items": "{count} itens",
    "collections.loading_items": "Carregando itens…",
    "Loading items…": "Carregando itens…",
    "collections.no_items": "Nenhum item nesta coleção ainda.",
    "No items in this collection yet.": "Nenhum item nesta coleção ainda.",
    "collections.delete_confirm": "Você quer excluir esta coleção?",
    "Do you want to delete this collection?": "Você quer excluir esta coleção?",
    "collections.title": "Coleções",
    "collections.header_title": "Título",
    "collections.header_action": "Ação",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Tipo de condição",
    "Condition Type": "Tipo de condição",
    "collections.header_scope": "Escopo",
    "collections.header_start_date": "Data de início",
    "collections.header_end_date": "Data de término",
    "collections.header_status": "Status",
    "collections.header_url": "URL",
    "common.calendar_view": "Visualização de calendário",
    "Calendar view": "Visualização de calendário",
    "common.deleted": "Excluído",
    "Deleted": "Excluído",
    "common.list_view": "Visualização de lista",
    "common.description": "Descrição",
    "common.title": "Título",
    "common.end_date": "Data de término",
    "common.start_date": "Data de início",
    "promotions.image_required": "Por favor, adicione uma imagem",
    "Please add an image": "Por favor, adicione uma imagem",
    "promotions.edit_title": "Editar promoção",
    "Edit Promotion": "Editar promoção",
    "promotions.add_title": "Adicionar promoção",
    "Add Promotion": "Adicionar promoção",
    "promotions.name": "Nome da promoção",
    "Promotion Name": "Nome da promoção",
    "promotions.select_medium": "Selecionar meio",
    "Select Medium": "Selecionar meio",
    "promotions.upload_media": "Enviar mídia",
    "promotions.schedule": "Agendar",
    "promotions.destination_type": "Tipo de destino",
    "Destination Type": "Tipo de destino",
    "promotions.placement": "Localização",
    "Placement": "Localização",
    "promotions.status": "Status (Inativo / Ativo)",
    "promotions.delete_confirm": "Você quer excluir esta promoção?",
    "Do you want to delete this promotion?": "Você quer excluir esta promoção?",
    "promotions.title": "Promoções",
    "promotions.header_image": "Imagem",
    "promotions.header_medium": "Meio",
    "promotions.header_placement": "Localização",
    "promotions.header_type": "Tipo",
    "promotions.header_value": "Valor",
    "promotions.header_active": "Ativo",
    "promotions.header_action": "Ação",
    "promotions.header_start_at": "Início em",
    "Start At": "Início em",
    "promotions.header_end_at": "Término em",
    "End At": "Término em",
    "common.grid_view": "Visualização em grade",
    "promotions.type_general": "Geral",
    "promotions.type_listing": "Lista",
    "promotions.type_account": "Conta",
    "promotions.type_external_link": "Link externo",
    "External link": "Link externo",
    "promotions.preview": "Pré-visualização",
    "promotions.select_listing": "Selecionar lista",
    "Select Listing": "Selecionar lista",
    "promotions.select_account": "Selecionar conta",
    "promotions.home_placement": "Início",
    "promotions.footer_placement": "Rodapé",
    "Footer": "Rodapé",
    "promotions.web_only": "(Apenas web)",
    "(Web Only)": "(Apenas web)",
    "coupons.edit_title": "Editar cupom",
    "Edit Coupon": "Editar cupom",
    "coupons.add_title": "Adicionar cupom",
    "Add Coupon": "Adicionar cupom",
    "coupons.reference_name": "Nome de referência",
    "Reference Name": "Nome de referência",
    "coupons.enter_name": "Insira o nome",
    "coupons.coupon_type": "Tipo de cupom",
    "Coupon type": "Tipo de cupom",
    "coupons.discount_value": "Valor do desconto",
    "Discount Value": "Valor do desconto",
    "coupons.enter_discount_value": "Insira o valor do desconto",
    "Enter discount value": "Insira o valor do desconto",
    "coupons.code": "Código",
    "coupons.code_example": "Ex: HOLIDAY10",
    "Ex: HOLIDAY10": "Ex: HOLIDAY10",
    "coupons.short_code": "Código curto",
    "coupons.enter_short_code": "Insira o código curto",
    "coupons.advanced": "AVANÇADO",
    "ADVANCED": "AVANÇADO",
    "coupons.minimum_amount": "Valor mínimo",
    "coupons.enter_minimum_amount": "Insira o valor mínimo",
    "coupons.maximum_amount": "Valor máximo",
    "coupons.enter_maximum_amount": "Insira o valor máximo",
    "coupons.maximum_discount_amount": "Valor máximo do desconto",
    "Maximum Discount Amount": "Valor máximo do desconto",
    "coupons.enter_maximum_discount_amount": "Insira o valor máximo do desconto",
    "Enter maximum discount amount": "Insira o valor máximo do desconto",
    "coupons.maximum_uses": "Máximo de usos",
    "Maximum Uses": "Máximo de usos",
    "coupons.enter_maximum_uses": "Insira o número máximo de usos",
    "Enter maximum uses": "Insira o número máximo de usos",
    "coupons.maximum_uses_per_user": "Usos máximos por usuário",
    "Maximum Uses Per User": "Usos máximos por usuário",
    "coupons.enter_maximum_uses_per_user": "Insira o número máximo de usos por usuário",
    "Enter maximum uses per user": "Insira o número máximo de usos por usuário",
    "coupons.new_user_only": "Novo usuário",
    "New User": "Novo usuário",
    "coupons.enter_note": "Insira a nota",
    "coupons.start_date_time": "Data e hora de início",
    "Start Date Time": "Data e hora de início",
    "coupons.end_date_time": "Data e hora de término",
    "End Date Time": "Data e hora de término",
    "coupons.select_start_date_time": "Selecione a data e hora de início",
    "Select start date time": "Selecione a data e hora de início",
    "coupons.select_end_date_time": "Selecione a data e hora de término",
    "Select end date time": "Selecione a data e hora de término",
    "coupons.flat_example": "Plano (Ex: $10)",
    "Flat (Ex: $10)": "Plano (Ex: $10)",
    "coupons.percentage_example": "Porcentagem (Ex: 10%)",
    "Percentage (Ex: 10%)": "Porcentagem (Ex: 10%)",
    "coupons.delete_confirm": "Você quer excluir este cupom?",
    "Do you want to delete this coupon?": "Você quer excluir este cupom?",
    "coupons.title": "Cupons",
    "coupons.header_name": "Nome",
    "coupons.header_code": "Código",
    "coupons.header_coupon_type": "Tipo de cupom",
    "Coupon Type": "Tipo de cupom",
    "coupons.header_start_date_time": "Data e hora de início",
    "coupons.header_end_date_time": "Data e hora de término",
    "coupons.header_active": "Ativo",
    "coupons.header_action": "Ação",
    "coupons.load_error": "Não é possível carregar este cupom.",
    "Unable to load this coupon.": "Não é possível carregar este cupom.",
    "coupons.expired": "Expirado",
    "Expired": "Expirado",
    "coupons.total_orders": "Pedidos totais",
    "coupons.unique_customers": "Clientes únicos",
    "Unique Customers": "Clientes únicos",
    "coupons.revenue": "Receita",
    "coupons.average_transaction": "Transação média",
    "Avg Transaction": "Transação média",
    "coupons.paid_orders": "Pedidos pagos",
    "coupons.uses_remaining": "Usos restantes",
    "Uses Remaining": "Usos restantes",
    "coupons.unlimited": "Ilimitado",
    "Unlimited": "Ilimitado",
    "coupons.performance": "Desempenho",
    "Performance": "Desempenho",
    "coupons.usage_against_limit": "Uso contra limite",
    "Usage against limit": "Uso contra limite",
    "coupons.details": "Detalhes",
    "coupons.discount": "Desconto",
    "coupons.minimum_order": "Pedido mínimo",
    "Min order": "Pedido mínimo",
    "coupons.maximum_discount": "Máximo desconto",
    "Max discount": "Máximo desconto",
    "coupons.maximum_total_uses": "Máximo usos totais",
    "Max total uses": "Máximo usos totais",
    "coupons.maximum_per_user": "Máximo / usuário",
    "Max / user": "Máximo / usuário",
    "coupons.new_users_only": "Somente novos usuários",
    "New users only": "Somente novos usuários",
    "coupons.valid_from": "Válido a partir de",
    "Valid from": "Válido a partir de",
    "coupons.valid_until": "Válido até",
    "Valid until": "Válido até",
    "coupons.orders": "Pedidos",
    "coupons.no_orders": "Nenhum pedido usou este cupom ainda",
    "No orders have used this coupon yet": "Nenhum pedido usou este cupom ainda",
    "coupons.orders_header_order": "Pedido",
    "coupons.orders_header_customer": "Cliente",
    "coupons.orders_header_date": "Data",
    "coupons.orders_header_amount": "Valor",
    "coupons.orders_header_status": "Status",
    "coupons.paid": "Pago",
    "coupons.pending": "Pendente",
    "coupons.coupon": "Cupom",
    "coupons.detail_title": "Detalhes do cupom",
    "Coupon Detail": "Detalhes do cupom",
    "coupons.discount_percentage": "{value}% de desconto",
    "{value}% off": "{value}% de desconto",
    "coupons.discount_flat": "{value} de desconto fixo",
    "{value} flat off": "{value} de desconto fixo",
    "coupons.type_direct_discount": "Desconto direto",
    "Direct discount": "Desconto direto",
    "collections.condition_and": "E",
    "AND": "E",
    "collections.condition_or": "O",
    "OR": "O",
    "users.first_seen": "Primeira vez visto",
    "First seen": "Primeira vez visto",
    "users.last_seen": "Última vez visto",
    "Last seen": "Última vez visto",
    "users.avg_order": "Pedido médio",
    "Avg order": "Pedido médio",
    "users.purchase_value": "Valor da compra",
    "Purchase value": "Valor da compra",
    "users.price_range": "Faixa de preços",
    "Price range": "Faixa de preços",
    "users.attributes": "Atributos",
    "users.detail_title": "Detalhes do usuário",
    "User Detail": "Detalhes do usuário",
    "users.detail_orders_list": "Lista de pedidos do usuário",
    "User Orders List": "Lista de pedidos do usuário",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "Como comprador",
    "As a Buyer": "Como comprador",
    "users.as_seller": "Como vendedor",
    "As a Seller": "Como vendedor",
    "users.health": "Saúde",
    "users.no_listings": "Ainda não há listagens",
    "users.no_accounts": "Ainda não há contas",
    "No accounts yet": "Ainda não há contas",
    "users.top_categories": "Categorias principais",
    "Top categories": "Categorias principais",
    "users.top_listings": "Listagens principais",
    "Top listings": "Listagens principais",
    "users.recent_activity": "Atividade recente",
    "Recent activity": "Atividade recente",
    "users.acquisition": "Aquisição",
    "Acquisition": "Aquisição",
    "users.sent_emails": "E-mails enviados",
    "Sent Emails": "E-mails enviados",
    "users.no_emails_sent": "Nenhum e-mail enviado",
    "No emails sent": "Nenhum e-mail enviado",
    "users.load_more_emails": "Carregar mais ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Carregar mais ({loaded} / {total})",
    "users.email_to": "Para: {email}",
    "To: {email}": "Para: {email}",
    "users.sending_email": "Enviando…",
    "users.send_email": "Enviar e-mail",
    "Send Email": "Enviar e-mail",
    "users.send_email_title": "Enviar e-mail — {name}",
    "Send Email — {name}": "Enviar e-mail — {name}",
    "users.customer": "Cliente",
    "users.block_named": "Bloquear {name}",
    "Block {name}": "Bloquear {name}",
    "users.unblock_named": "Desbloquear {name}",
    "Unblock {name}": "Desbloquear {name}",
    "users.email_sent": "E-mail enviado com sucesso",
    "Email sent successfully": "E-mail enviado com sucesso",
    "users.email_send_failed": "Falha ao enviar e-mail",
    "Failed to send email": "Falha ao enviar e-mail",
    "common.value": "Valor",
    "users.email_bounced": "Recebido",
    "Bounced": "Recebido",
    "users.email_complained": "Reclamação",
    "Complained": "Reclamação",
    "users.unverified": "Não verificado",
    "Unverified": "Não verificado",
    "users.otp_enabled": "OTP habilitado",
    "OTP Enabled": "OTP habilitado",
    "users.account_info": "Informações da conta",
    "Account Info": "Informações da conta",
    "users.mobile": "Móvel",
    "users.locale": "Idioma",
    "Locale": "Idioma",
    "users.joined": "Ingressado",
    "users.following": "Seguindo",
    "Following": "Seguindo",
    "users.email_health": "Saúde do e-mail",
    "Email Health": "Saúde do e-mail",
    "users.orders": "Pedidos",
    "users.no_orders": "Sem pedidos",
    "No orders": "Sem pedidos",
    "users.order_reference": "Pedido {number}",
    "Order {number}": "Pedido {number}",
    "users.order_ref": "Ref: {reference}",
    "Ref: {reference}": "Ref: {reference}",
    "users.unpaid": "Não pago",
    "users.revenue_ltv": "Receita e LTV",
    "Revenue & LTV": "Receita e LTV",
    "users.total_spent": "Total gasto",
    "Total Spent": "Total gasto",
    "users.paid_order_count": "{count} pedidos pagos",
    "{count} paid orders": "{count} pedidos pagos",
    "users.average_order": "Média do pedido",
    "users.of_total_orders": "de {count} total",
    "of {count} total": "de {count} total",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} ativos",
    "{count} active": "{count} ativos",
    "users.at_risk": "Em risco",
    "At Risk": "Em risco",
    "common.today": "Hoje",
    "common.yesterday": "Ontem",
    "Yesterday": "Ontem",
    "users.days_ago": "{count} dias atrás",
    "{count} days ago": "{count} dias atrás",
    "users.months_ago": "{count} meses atrás",
    "{count} months ago": "{count} meses atrás",
    "users.years_ago": "{count} anos atrás",
    "{count} years ago": "{count} anos atrás",
    "users.last_order": "Último pedido",
    "Last order": "Último pedido",
    "users.last_listing": "Última lista",
    "Last listing": "Última lista",
    "users.events": "Eventos",
    "users.viewed": "Visto",
    "Viewed": "Visto",
    "users.cart": "Carrinho",
    "users.checkouts": "Compras",
    "Checkouts": "Compras",
    "users.purchases": "Compras",
    "Purchases": "Compras",
    "users.last_30_days": "Últimos 30 dias",
    "Last 30 days": "Últimos 30 dias",
    "users.no_analytics": "Nenhum dado de análise para este usuário ainda.",
    "No analytics data for this user yet.": "Nenhum dado de análise para este usuário ainda.",
    "users.analytics_unavailable": "Análise indisponível para este locatário.",
    "Analytics unavailable for this tenant.": "Análise indisponível para este locatário.",
    "users.account_number": "Conta #{number}",
    "Account #{number}": "Conta #{number}",
    "users.no_subject": "Sem assunto",
    "No Subject": "Sem assunto",
    "common.unknown": "Desconhecido",
    "users.opened": "Aberto",
    "Opened": "Aberto",
    "users.not_opened": "Não aberto",
    "Not opened": "Não aberto",
    "users.user_action_success": "Ação de usuário concluída",
    "User action completed": "Ação de usuário concluída",
    "common.pending": "Pendente",
    "common.never": "Nunca",
    "users.customer_analytics": "Análise de clientes",
    "Customer Analytics": "Análise de clientes",
    "users.analytics": "Análise",
    "users.emails": "E-mails",
    "Emails": "E-mails",
    "users.first_visit": "Primeira visita",
    "First visit": "Primeira visita",
    "users.latest_visit": "Última visita",
    "Latest visit": "Última visita",
    "users.landing_page": "Página de aterrissagem",
    "Landing page": "Página de aterrissagem",
    "users.referrer": "Referente",
    "Referrer": "Referente",
    "users.utm_source": "Fonte UTM",
    "UTM source": "Fonte UTM",
    "users.utm_medium": "Meio UTM",
    "UTM medium": "Meio UTM",
    "users.utm_campaign": "Campanha UTM",
    "UTM campaign": "Campanha UTM",
    "users.utm_term": "Termo UTM",
    "UTM term": "Termo UTM",
    "users.utm_content": "Conteúdo UTM",
    "UTM content": "Conteúdo UTM",
    "users.ai_source": "Fonte de IA",
    "AI source": "Fonte de IA",
    "rewards.edit_scope": "Editar escopo",
    "Edit scope": "Editar escopo",
    "rewards.add_scope": "Adicionar escopo",
    "Add scope": "Adicionar escopo",
    "rewards.save_scope": "Salvar escopo",
    "Save scope": "Salvar escopo",
    "rewards.scope_type": "Tipo de escopo",
    "Scope type": "Tipo de escopo",
    "rewards.scope_reference": "Referência de escopo",
    "Scope reference": "Referência de escopo",
    "rewards.match_config": "Configuração de correspondência",
    "Match config": "Configuração de correspondência",
    "rewards.priority_order": "Ordem de prioridade",
    "Priority order": "Ordem de prioridade",
    "rewards.active": "Ativo",
    "rewards.scope_active": "O escopo está ativo",
    "Scope is active": "O escopo está ativo",
    "rewards.edit_rule": "Editar regra",
    "Edit rule": "Editar regra",
    "rewards.add_rule": "Adicionar regra",
    "Add rule": "Adicionar regra",
    "rewards.save_rule": "Salvar regra",
    "Save rule": "Salvar regra",
    "rewards.trigger_event": "Evento de gatilho",
    "Trigger event": "Evento de gatilho",
    "rewards.beneficiary_type": "Tipo de beneficiário",
    "Beneficiary type": "Tipo de beneficiário",
    "rewards.beneficiary_config": "Configuração do beneficiário",
    "Beneficiary config": "Configuração do beneficiário",
    "rewards.eligibility": "Elegibilidade",
    "Eligibility": "Elegibilidade",
    "rewards.conditions": "Condições",
    "rewards.priority": "Prioridade",
    "Priority": "Prioridade",
    "rewards.edit_component": "Editar componente da receita",
    "Edit recipe component": "Editar componente da receita",
    "rewards.add_component": "Adicionar componente da receita",
    "Add recipe component": "Adicionar componente da receita",
    "rewards.save_component": "Salvar componente",
    "Save component": "Salvar componente",
    "rewards.rule": "Regra",
    "Rule": "Regra",
    "rewards.component_key": "Chave do componente",
    "Component key": "Chave do componente",
    "rewards.component_type": "Tipo de componente",
    "Component type": "Tipo de componente",
    "rewards.commission_definition": "Definição de comissão",
    "Commission definition": "Definição de comissão",
    "rewards.config": "Configuração",
    "rewards.position": "Posição",
    "Position": "Posição",
    "rewards.component": "Componente",
    "Component": "Componente",
    "rewards.status.draft": "Rascunho",
    "rewards.status.active": "Ativo",
    "rewards.status.paused": "Pausado",
    "Paused": "Pausado",
    "rewards.status.archived": "Arquivado",
    "rewards.configuration_updated": "Configuração de recompensa atualizada",
    "Reward configuration updated": "Configuração de recompensa atualizada",
    "rewards.configuration_added": "Configuração de recompensa adicionada",
    "Reward configuration added": "Configuração de recompensa adicionada",
    "rewards.archive_item_confirm": "Arquivar {name}?",
    "Archive {name}?": "Arquivar {name}?",
    "rewards.empty_scopes": "Nenhum escopo configurado ainda.",
    "No scopes configured yet.": "Nenhum escopo configurado ainda.",
    "rewards.empty_rules": "Nenhuma regra configurada ainda.",
    "No rules configured yet.": "Nenhuma regra configurada ainda.",
    "rewards.empty_components": "Nenhum componente configurado ainda.",
    "No components configured yet.": "Nenhum componente configurado ainda.",
    "rewards.edit_program": "Editar programa de recompensa",
    "Edit reward program": "Editar programa de recompensa",
    "rewards.new_program": "Novo programa de recompensa",
    "New reward program": "Novo programa de recompensa",
    "rewards.create_program": "Criar programa",
    "Create program": "Criar programa",
    "rewards.program_type": "Tipo de programa",
    "Program type": "Tipo de programa",
    "rewards.starts_at": "Inicia em",
    "Starts at": "Inicia em",
    "rewards.ends_at": "Termina em",
    "Ends at": "Termina em",
    "rewards.program_updated": "Programa de recompensa atualizado",
    "Reward program updated": "Programa de recompensa atualizado",
    "rewards.program_created": "Programa de recompensa criado",
    "Reward program created": "Programa de recompensa criado",
    "rewards.archive_program_confirm": "Arquivar {name}?",
    "rewards.program_archived": "Programa de recompensas arquivado",
    "Reward program archived": "Programa de recompensas arquivado",
    "rewards.tab.overview": "Visão geral",
    "rewards.tab.programs": "Programas",
    "Programs": "Programas",
    "rewards.tab.impact": "Impacto",
    "Impact": "Impacto",
    "rewards.tab.attribution": "Rastreamento",
    "Tracking": "Rastreamento",
    "rewards.page_description": "Crie e gerencie programas de recompensas, configurações de elegibilidade, regras de recompensas e receitas de recompensas. Pedidos concluídos são adicionados automaticamente aos seus relatórios.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Crie e gerencie programas de recompensas, configurações de elegibilidade, regras de recompensas e receitas de recompensas. Pedidos concluídos são adicionados automaticamente aos seus relatórios.",
    "rewards.program": "Programa",
    "Program": "Programa",
    "rewards.starts": "Início",
    "Starts": "Início",
    "rewards.no_programs": "Ainda não há programas de recompensas.",
    "No reward programs yet.": "Ainda não há programas de recompensas.",
    "rewards.program_title": "Programa de recompensas",
    "Reward program": "Programa de recompensas",
    "rewards.back_to_rewards": "Voltar para recompensas",
    "Back to rewards": "Voltar para recompensas",
    "common.archive": "Arquivar",
    "Archive": "Arquivar",
    "common.save_changes": "Salvar alterações",
    "common.none": "Nenhum",
    "common.this_item": "este item",
    "this item": "este item",
    "rewards.tab.scopes": "Escopos",
    "Scopes": "Escopos",
    "rewards.tab.rules": "Regras",
    "Rules": "Regras",
    "rewards.tab.components": "Componentes da receita",
    "Recipe components": "Componentes da receita",
    "rewards.reference": "Referência",
    "rewards.trigger": "Gatilho",
    "Trigger": "Gatilho",
    "rewards.beneficiary": "Beneficiário",
    "Beneficiary": "Beneficiário",
    "rewards.attributed_conversions": "Conversões atribuídas",
    "Attributed conversions": "Conversões atribuídas",
    "rewards.new_customers": "Novos clientes",
    "New customers": "Novos clientes",
    "rewards.revenue_influenced": "Receita influenciada",
    "Revenue influenced": "Receita influenciada",
    "rewards.rewards_issued": "Recompensas emitidas",
    "Rewards issued": "Recompensas emitidas",
    "rewards.live_business_results": "Resultados comerciais ao vivo",
    "Live business results": "Resultados comerciais ao vivo",
    "rewards.impact_at_a_glance": "Impacto de primeira vista",
    "Impact at a glance": "Impacto de primeira vista",
    "rewards.impact_last_30_days": "Visualização ao vivo de pedidos concluídos e resultados de parceiros nos últimos 30 dias.",
    "A live view of completed orders and partner results from the last 30 days.": "Visualização ao vivo de pedidos concluídos e resultados de parceiros nos últimos 30 dias.",
    "rewards.view_full_impact": "Ver impacto completo",
    "View full impact": "Ver impacto completo",
    "rewards.impact_load_error": "Os dados de impacto não puderam ser carregados: {error}",
    "Impact data could not be loaded: {error}": "Os dados de impacto não puderam ser carregados: {error}",
    "rewards.programs": "Programas",
    "rewards.programs_configured": "Programas de recompensas configurados para este espaço de trabalho.",
    "Reward programs configured for this workspace.": "Programas de recompensas configurados para este espaço de trabalho.",
    "rewards.programs_eligible": "Programas atualmente elegíveis para avaliação.",
    "Programs currently eligible for evaluation.": "Programas atualmente elegíveis para avaliação.",
    "rewards.drafts": "Rascunhos",
    "Drafts": "Rascunhos",
    "rewards.programs_being_configured": "Programas ainda em configuração.",
    "Programs still being configured.": "Programas ainda em configuração.",
    "rewards.clicks": "Cliques",
    "rewards.completed_orders": "Pedidos concluídos",
    "Completed orders": "Pedidos concluídos",
    "rewards.conversion_rate": "Taxa de conversão",
    "Conversion rate": "Taxa de conversão",
    "rewards.revenue": "Receita",
    "rewards.live_connection": "Conexão ao vivo",
    "Live connection": "Conexão ao vivo",
    "rewards.attribution_activity": "Atividade de atribuição",
    "Attribution activity": "Atividade de atribuição",
    "rewards.connected_workspace": "Conectado a {name}.",
    "Connected to {name}.": "Conectado a {name}.",
    "rewards.your_attribution_workspace": "seu espaço de trabalho de Atribuição",
    "your Attribution workspace": "seu espaço de trabalho de Atribuição",
    "rewards.loading_workspace": "Carregando seu espaço de trabalho de Atribuição conectado.",
    "Loading your connected Attribution workspace.": "Carregando seu espaço de trabalho de Atribuição conectado.",
    "rewards.open_attribution": "Abrir Atribuição",
    "Open Attribution": "Abrir Atribuição",
    "rewards.connection_attention": "A conexão requer atenção",
    "Connection needs attention": "A conexão requer atenção",
    "rewards.open_attribution_workspace": "Abrir espaço de trabalho de Atribuição",
    "Open Attribution workspace": "Abrir espaço de trabalho de Atribuição",
    "rewards.workspace_connected": "Espaço de trabalho conectado",
    "Workspace connected": "Espaço de trabalho conectado",
    "rewards.workspace_not_linked": "Espaço de trabalho não vinculado ainda",
    "Workspace not linked yet": "Espaço de trabalho não vinculado ainda",
    "rewards.attribution_data_connected": "Cliques ao vivo, links, campanhas e pedidos concluídos estão sendo lidos da Atribuição.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Cliques ao vivo, links, campanhas e pedidos concluídos estão sendo lidos da Atribuição.",
    "rewards.connect_workspace_prompt": "Abra Atribuição para conectar este espaço de trabalho antes de rastrear a atividade.",
    "Open Attribution to connect this workspace before tracking activity.": "Abra Atribuição para conectar este espaço de trabalho antes de rastrear a atividade.",
    "rewards.successful_referrals": "Indicações bem-sucedidas",
    "Successful referrals": "Indicações bem-sucedidas",
    "rewards.new_customers_acquired": "Novos clientes adquiridos",
    "New customers acquired": "Novos clientes adquiridos",
    "rewards.gross_revenue_influenced": "Receita bruta influenciada",
    "Gross revenue influenced": "Receita bruta influenciada",
    "rewards.reward_cost": "Custo da recompensa",
    "Reward cost": "Custo da recompensa",
    "rewards.net_revenue": "Receita líquida",
    "Net revenue": "Receita líquida",
    "rewards.average_order_value": "Valor médio do pedido",
    "Average order value": "Valor médio do pedido",
    "rewards.cost_per_acquisition": "Custo por aquisição",
    "Cost per acquisition": "Custo por aquisição",
    "rewards.repeat_purchase_rate": "Taxa de compra repetida",
    "Repeat purchase rate": "Taxa de compra repetida",
    "rewards.business_outcome_reporting": "Relatórios de resultados comerciais",
    "Business outcome reporting": "Relatórios de resultados comerciais",
    "rewards.impact": "Impacto",
    "rewards.impact_description": "Conversões, aquisição de clientes, receita influenciada e custo da recompensa do período selecionado.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Conversões, aquisição de clientes, receita influenciada e custo da recompensa do período selecionado.",
    "rewards.from": "De",
    "rewards.to": "Até",
    "rewards.trend": "Tendência",
    "Trend": "Tendência",
    "rewards.daily": "Diário",
    "rewards.weekly": "Semanal",
    "Weekly": "Semanal",
    "rewards.top_partners": "Principais parceiros / referidores",
    "Top partners / referrers": "Principais parceiros / referidores",
    "rewards.partner": "Parceiro",
    "Partner": "Parceiro",
    "rewards.conversions": "Conversões",
    "Conversions": "Conversões",
    "rewards.no_partner_data": "Não há dados de parceiro atribuídos para este período.",
    "No attributed partner data for this period.": "Não há dados de parceiro atribuídos para este período.",
    "rewards.period": "Período",
    "rewards.no_trend_data": "Não há dados de tendência para este período.",
    "No trend data for this period.": "Não há dados de tendência para este período.",
    "rewards.campaign_performance": "Desempenho da campanha",
    "Campaign performance": "Desempenho da campanha",
    "rewards.campaign_count": "{count} campanhas",
    "{count} campaigns": "{count} campanhas",
    "rewards.campaign": "Campanha",
    "rewards.orders": "Pedidos",
    "rewards.rate": "Taxa",
    "Rate": "Taxa",
    "rewards.no_campaign_activity": "Ainda não há atividade de campanha. Crie um link de rastreamento em Atribuição para começar a medir resultados.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Ainda não há atividade de campanha. Crie um link de rastreamento em Atribuição para começar a medir resultados.",
    "rewards.recent_completed_orders": "Pedidos concluídos recentes",
    "Recent completed orders": "Pedidos concluídos recentes",
    "rewards.recent_events_count": "{count} eventos recentes",
    "{count} recent events": "{count} eventos recentes",
    "rewards.event": "Evento",
    "rewards.completed_order": "Pedido concluído",
    "Completed order": "Pedido concluído",
    "rewards.no_completed_order_activity": "Ainda não chegou atividade de pedidos concluídos.",
    "No completed order activity has arrived yet.": "Ainda não chegou atividade de pedidos concluídos.",
    "rewards.impact_data_quality_note": "O volume de cliques e a taxa de conversão permanecem indisponíveis aqui até que o agregado de cliques de Atribuição seja conectado. O custo de recompensa usa linhas aprovadas ou emitidas no registro de recompensas; reembolsos ainda não são incluídos.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "O volume de cliques e a taxa de conversão permanecem indisponíveis aqui até que o agregado de cliques de Atribuição seja conectado. O custo de recompensa usa linhas aprovadas ou emitidas no registro de recompensas; reembolsos ainda não são incluídos.",
    "subscriptions.type.free": "Assinatura gratuita",
    "Free Subscription": "Assinatura gratuita",
    "subscriptions.form.title_placeholder": "Título da assinatura",
    "Subscription Title": "Título da assinatura",
    "subscriptions.form.title_help": "Insira um título descritivo para o pacote de assinatura (por exemplo, “Plano Premium”, “Nível Básico”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Insira um título descritivo para o pacote de assinatura (por exemplo, “Plano Premium”, “Nível Básico”).",
    "subscriptions.form.description_placeholder": "Descrição da assinatura",
    "Subscription Description": "Descrição da assinatura",
    "subscriptions.form.description_help": "Forneça uma descrição detalhada da assinatura, indicando suas características e benefícios.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Forneça uma descrição detalhada da assinatura, indicando suas características e benefícios.",
    "subscriptions.form.select_currency": "Selecionar moeda",
    "Select Currency": "Selecionar moeda",
    "subscriptions.form.currency_help": "Selecione a moeda da assinatura no menu suspenso (Sua moeda padrão)",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Selecione a moeda da assinatura no menu suspenso (Sua moeda padrão)",
    "subscriptions.form.amount_placeholder": "Valor da assinatura",
    "Subscription Amount": "Valor da assinatura",
    "subscriptions.form.amount_help": "Insira o preço da assinatura.",
    "Enter the subscription price.": "Insira o preço da assinatura.",
    "subscriptions.form.sku_placeholder": "SKU da assinatura",
    "Subscription SKU": "SKU da assinatura",
    "subscriptions.form.sku_help": "Insira um identificador único para a assinatura (geralmente usado para simplicidade de dados, unicidade e rastreamento).",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Insira um identificador único para a assinatura (geralmente usado para simplicidade de dados, unicidade e rastreamento).",
    "subscriptions.form.allowed_listings": "Listagens permitidas",
    "Allowed Listings": "Listagens permitidas",
    "subscriptions.form.allowed_listings_placeholder": "Listagens permitidas para assinatura",
    "Subscription Allowed Listings": "Listagens permitidas para assinatura",
    "subscriptions.form.allowed_listings_help": "Especifique o número de listagens permitidas para esta assinatura.",
    "Specify the number of listings allowed for this subscription.": "Especifique o número de listagens permitidas para esta assinatura.",
    "subscriptions.form.fixed_fee_per_order": "Taxa fixa por pedido",
    "Fixed Fee Per Order": "Taxa fixa por pedido",
    "subscriptions.form.fixed_fee_placeholder": "Taxa fixa por pedido",
    "Subscription Fee Fixed Per Order": "Taxa fixa por pedido",
    "subscriptions.form.fixed_fee_help": "Insira uma taxa fixa por pedido, se aplicável.",
    "Enter a fixed fee per order, if applicable.": "Insira uma taxa fixa por pedido, se aplicável.",
    "subscriptions.form.commission_percent_per_order": "Comissão % por pedido",
    "Commission % Per Order": "Comissão % por pedido",
    "subscriptions.form.commission_placeholder": "Comissão de assinatura por pedido",
    "Subscription Commission Percent Per Order": "Comissão de assinatura por pedido",
    "subscriptions.form.commission_help": "Insira a porcentagem de comissão por pedido, se aplicável.",
    "Enter the commission percentage per order, if applicable.": "Insira a porcentagem de comissão por pedido, se aplicável.",
    "subscriptions.form.expiry_days": "Dias de expiração",
    "Expiry Days": "Dias de expiração",
    "subscriptions.form.expiry_days_placeholder": "Dias de expiração da assinatura",
    "Subscription Expiry Days": "Dias de expiração da assinatura",
    "subscriptions.form.expiry_days_help": "Defina o número de dias antes da expiração da assinatura (plano, pacote). Exemplo: 7 dias, 30 dias.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Defina o número de dias antes da expiração da assinatura (plano, pacote). Exemplo: 7 dias, 30 dias.",
    "subscriptions.form.payment_method": "Método de pagamento",
    "subscriptions.form.select_type": "Selecionar tipo",
    "subscriptions.form.payment_method_help": "Selecione o método de pagamento(s) suportado(s) para esta assinatura (ex.: Stripe, Mangopay, Android, iOS, Assinatura gratuita).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Selecione o método de pagamento(s) suportado(s) para esta assinatura (ex.: Stripe, Mangopay, Android, iOS, Assinatura gratuita).",
    "subscriptions.form.active_placeholder": "Assinatura ativa",
    "Subscription Active": "Assinatura ativa",
    "subscriptions.form.active_help": "Ative ou desative a assinatura usando o interruptor. Uma assinatura ativa está disponível para compra.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Ative ou desative a assinatura usando o interruptor. Uma assinatura ativa está disponível para compra.",
    "subscriptions.add_title": "Adicionar novo produto de assinatura",
    "Add new subscription product": "Adicionar novo produto de assinatura",
    "subscriptions.edit_title": "Editar produto de assinatura",
    "Edit subscription product": "Editar produto de assinatura",
    "subscriptions.added_success": "Listagem de assinatura adicionada com sucesso",
    "Subscription listing added successfully": "Listagem de assinatura adicionada com sucesso",
    "subscriptions.updated_success": "Listagem de assinatura atualizada com sucesso",
    "Subscription listing updated successfully": "Listagem de assinatura atualizada com sucesso",
    "common.currency": "Moeda",
    "common.sku": "SKU",
    "subscriptions.title": "Assinaturas",
    "subscriptions.add_subscription": "Adicionar assinatura",
    "Add subscription": "Adicionar assinatura",
    "subscriptions.plans": "Planos",
    "subscriptions.active_subscribers": "Assinantes ativos",
    "Active Subscribers": "Assinantes ativos",
    "subscriptions.total_mrr": "MRR Total",
    "Total MRR": "MRR Total",
    "subscriptions.churn_rate": "Taxa de cancelamento",
    "Churn Rate": "Taxa de cancelamento",
    "subscriptions.new_this_month": "Novos este mês",
    "New This Month": "Novos este mês",
    "subscriptions.average_duration": "Duração média",
    "Avg Duration": "Duração média",
    "subscriptions.monthly_recurring_revenue": "Receita Recorrente Mensal",
    "Monthly Recurring Revenue": "Receita Recorrente Mensal",
    "subscriptions.annual_run_rate": "Taxa Anual de Execução",
    "Annual Run Rate": "Taxa Anual de Execução",
    "subscriptions.last_30_days": "Últimos 30 dias",
    "subscriptions.subscriber_lifetime": "Duração da assinatura",
    "Subscriber lifetime": "Duração da assinatura",
    "subscriptions.subscriber_distribution": "Distribuição de assinantes",
    "Subscriber Distribution": "Distribuição de assinantes",
    "subscriptions.billing_period": "Período de faturamento",
    "Billing Period": "Período de faturamento",
    "subscriptions.allowed_listings": "Listagens permitidas",
    "subscriptions.commission_per_order": "Comissão por pedido",
    "Commission per Order": "Comissão por pedido",
    "subscriptions.fixed_fee_per_order": "Taxa fixa por pedido",
    "Fixed Fee per Order": "Taxa fixa por pedido",
    "subscriptions.payment_provider": "Provedor de pagamento",
    "Payment Provider": "Provedor de pagamento",
    "subscriptions.sku_product_id": "SKU / ID do produto",
    "SKU / Product ID": "SKU / ID do produto",
    "subscriptions.revenue_over_time": "Receita ao longo do tempo",
    "Revenue Over Time": "Receita ao longo do tempo",
    "subscriptions.revenue": "Receita",
    "subscriptions.subscriber_growth": "Crescimento de assinantes",
    "Subscriber Growth": "Crescimento de assinantes",
    "subscriptions.subscribers": "Assinantes",
    "Subscribers": "Assinantes",
    "subscriptions.set_inactive": "Definir inativo",
    "Set Inactive": "Definir inativo",
    "subscriptions.set_active": "Ativar",
    "Set Active": "Ativar",
    "subscriptions.plan_title": "Plano de assinatura",
    "Subscription Plan": "Plano de assinatura",
    "subscriptions.status.active": "Ativo",
    "subscriptions.status.cancelled": "Cancelado",
    "subscriptions.status.expired": "Expirado",
    "subscriptions.status.trial": "Período de teste",
    "Trial": "Período de teste",
    "subscriptions.status.pending": "Pendente",
    "subscriptions.period.lifetime": "Por vida",
    "Lifetime": "Por vida",
    "subscriptions.period.daily": "Diário",
    "subscriptions.period.weekly": "Semanal",
    "subscriptions.period.monthly": "Mensal",
    "Monthly": "Mensal",
    "subscriptions.period.quarterly": "Trimestral",
    "Quarterly": "Trimestral",
    "subscriptions.period.semi_annual": "Semianual",
    "Semi-annual": "Semianual",
    "subscriptions.period.annual": "Anual",
    "Annual": "Anual",
    "subscriptions.period.days": "{count} dias",
    "subscriptions.period.day": "/ dia",
    "/ day": "/ dia",
    "subscriptions.period.week": "/ semana",
    "/ week": "/ semana",
    "subscriptions.period.month": "/ mês",
    "/ month": "/ mês",
    "subscriptions.period.quarter": "/ trimestre",
    "/ quarter": "/ trimestre",
    "subscriptions.period.six_months": "/ 6 meses",
    "/ 6 months": "/ 6 meses",
    "subscriptions.period.year": "/ ano",
    "/ year": "/ ano",
    "subscriptions.listings_count": "{count} anúncios",
    "{count} listings": "{count} anúncios",
    "subscriptions.commission_percentage": "{rate}% de comissão",
    "{rate}% commission": "{rate}% de comissão",
    "subscriptions.per_order": "/ pedido",
    "/ order": "/ pedido",
    "subscriptions.view_details_subscribers": "Ver detalhes e assinantes",
    "View details and subscribers": "Ver detalhes e assinantes",
    "subscriptions.edit_subscription": "Editar assinatura",
    "Edit subscription": "Editar assinatura",
    "subscriptions.delete_subscription": "Excluir assinatura",
    "Delete subscription": "Excluir assinatura",
    "subscriptions.deleted": "Assinatura excluída",
    "Subscription deleted": "Assinatura excluída",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Android IAP",
    "Android IAP": "Android IAP",
    "subscriptions.type.ios": "iOS IAP",
    "iOS IAP": "iOS IAP",
    "subscriptions.type.free_subscription": "Grátis",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "{count} carregados",
    "subscriptions.no_subscribers": "Nenhum assinante {status}.",
    "No {status} subscribers.": "Nenhum assinante {status}.",
    "subscriptions.billing_records": "Registros de faturamento",
    "Billing Records": "Registros de faturamento",
    "subscriptions.no_invoices": "Nenhuma fatura encontrada.",
    "No invoices found.": "Nenhuma fatura encontrada.",
    "subscriptions.column.account": "Conta",
    "subscriptions.column.email": "E-mail",
    "subscriptions.column.status": "Status",
    "subscriptions.column.subscribed": "Assinado",
    "Subscribed": "Assinado",
    "subscriptions.column.expires": "Vence",
    "subscriptions.column.next_renewal": "Próxima renovação",
    "Next Renewal": "Próxima renovação",
    "subscriptions.column.amount_paid": "Valor pago",
    "Amount Paid": "Valor pago",
    "subscriptions.invoice_column.invoice_id": "ID da fatura",
    "Invoice ID": "ID da fatura",
    "subscriptions.invoice_column.account": "Conta",
    "subscriptions.invoice_column.amount": "Valor",
    "subscriptions.invoice_column.status": "Status",
    "subscriptions.invoice_column.period": "Período",
    "subscriptions.invoice_column.paid_at": "Pago em",
    "Paid At": "Pago em",
    "subscriptions.validation.title_required": "O título é obrigatório",
    "subscriptions.validation.allowed_listings_positive": "Os listados permitidos devem ser maiores que 0",
    "Allowed listings should be greater than 0": "Os listados permitidos devem ser maiores que 0",
    "subscriptions.validation.currency_required": "A moeda é obrigatória",
    "Currency is required": "A moeda é obrigatória",
    "subscriptions.validation.expiry_required": "Os dias de expiração são obrigatórios",
    "Expiry days are required": "Os dias de expiração são obrigatórios",
    "subscriptions.validation.payment_method_required": "O método de pagamento é obrigatório",
    "Payment method is required": "O método de pagamento é obrigatório",
    "subscriptions.error.save": "Ocorreu um erro ao salvar a assinatura.",
    "Something went wrong while saving the subscription.": "Ocorreu um erro ao salvar a assinatura.",
    "subscriptions.error.delete": "Ocorreu um erro ao excluir a assinatura.",
    "Something went wrong while deleting the subscription.": "Ocorreu um erro ao excluir a assinatura.",
    "common.configuration": "Configuração",
    "subscriptions.per_period": "por {period}",
    "per {period}": "por {period}",
    "subscriptions.tab.subscribers": "Assinantes",
    "subscriptions.tab.invoices": "Faturas",
    "subscriptions.account_title": "Assinatura da conta",
    "Account Subscription": "Assinatura da conta",
    "subscriptions.config.description": "Gerencie as assinaturas da conta. Quando habilitado, os proprietários da conta precisam de uma assinatura ativa para publicar anúncios. A gateway de pagamento padrão selecionada no Método de Pagamento é usada para pagamentos de assinatura.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Gerencie as assinaturas da conta. Quando habilitado, os proprietários da conta precisam de uma assinatura ativa para publicar anúncios. A gateway de pagamento padrão selecionada no Método de Pagamento é usada para pagamentos de assinatura.",
    "subscriptions.config.enable": "Habilitar assinaturas",
    "Enable subscriptions": "Habilitar assinaturas",
    "subscriptions.config.type": "Tipo de assinatura",
    "Subscription type": "Tipo de assinatura",
    "subscriptions.config.purchased_message": "Mensagem quando uma assinatura já foi comprada",
    "Message when a subscription is already purchased": "Mensagem quando uma assinatura já foi comprada",
    "subscriptions.config.purchased_placeholder": "Insira a mensagem já comprada",
    "Enter the already-purchased message": "Insira a mensagem já comprada",
    "subscriptions.config.listings_exhausted_message": "Mensagem quando o limite de listados é atingido",
    "Message when the listing limit is reached": "Mensagem quando o limite de listados é atingido",
    "subscriptions.config.listings_exhausted_placeholder": "Insira a mensagem de limite de listados",
    "Enter the listing limit message": "Insira a mensagem de limite de listados",
    "subscriptions.config.inactive_message": "Mensagem quando a assinatura está inativa",
    "Message when the subscription is inactive": "Mensagem quando a assinatura está inativa",
    "subscriptions.config.inactive_placeholder": "Insira a mensagem de assinatura inativa",
    "Enter the inactive subscription message": "Insira a mensagem de assinatura inativa",
    "subscriptions.config.saved": "Configuração de assinatura salva com sucesso",
    "Subscription settings saved successfully": "Configuração de assinatura salva com sucesso",
    "people.title": "Pessoas",
    "people.tab.staff": "Equipe",
    "people.tab.departments": "Departamentos",
    "Departments": "Departamentos",
    "people.tab.job_profiles": "Perfis de cargo",
    "Job profiles": "Perfis de cargo",
    "people.tab.pay_grades": "Níveis salariais",
    "Pay grades": "Níveis salariais",
    "people.action.add_staff": "Adicionar equipe",
    "Add staff": "Adicionar equipe",
    "people.action.add_department": "Adicionar departamento",
    "Add department": "Adicionar departamento",
    "people.action.add_job_profile": "Adicionar perfil de cargo",
    "Add job profile": "Adicionar perfil de cargo",
    "people.action.add_pay_grade": "Adicionar nível salarial",
    "Add pay grade": "Adicionar nível salarial",
    "people.currency_id": "ID da moeda",
    "people.onboarding.eyebrow": "Comece com Pessoas",
    "Get started with People": "Comece com Pessoas",
    "people.onboarding.title": "Construa seu diretório de equipe",
    "Build your team directory": "Construa seu diretório de equipe",
    "people.onboarding.description": "Adicione seu primeiro membro da equipe, depois organize sua equipe com departamentos, perfis de cargo e níveis salariais.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Adicione seu primeiro membro da equipe, depois organize sua equipe com departamentos, perfis de cargo e níveis salariais.",
    "people.onboarding.add_first": "Adicione seu primeiro membro da equipe",
    "Add your first staff member": "Adicione seu primeiro membro da equipe",
    "people.onboarding.step_staff": "Adicionar equipe",
    "people.onboarding.step_staff_description": "Vincule um usuário existente ao seu diretório de equipe.",
    "Link an existing user to your staff directory.": "Vincule um usuário existente ao seu diretório de equipe.",
    "people.onboarding.step_teams": "Organizar equipe",
    "Organize teams": "Organizar equipe",
    "people.onboarding.step_teams_description": "Crie departamentos e perfis de cargo à medida que cresce.",
    "Create departments and job profiles as you grow.": "Crie departamentos e perfis de cargo à medida que cresce.",
    "people.onboarding.step_pay": "Configurar compensação",
    "Set compensation": "Configurar compensação",
    "people.onboarding.step_pay_description": "Defina níveis salariais para uma configuração consistente de folha de pagamento.",
    "Define pay grades for consistent payroll setup.": "Defina níveis salariais para uma configuração consistente de folha de pagamento.",
    "people.staff_profile": "Perfil de equipe",
    "Staff profile": "Perfil de equipe",
    "people.field.employee_code": "Código do funcionário",
    "Employee code": "Código do funcionário",
    "people.field.job_title": "Cargo",
    "Job title": "Cargo",
    "people.field.department": "Departamento",
    "Department": "Departamento",
    "people.field.job_profile": "Perfil profissional",
    "Job profile": "Perfil profissional",
    "people.field.pay_grade": "Nível salarial",
    "Pay grade": "Nível salarial",
    "people.field.employment_type": "Tipo de emprego",
    "Employment type": "Tipo de emprego",
    "people.field.start_date": "Data de início",
    "people.field.user_id": "ID do usuário",
    "people.field.user": "Usuário",
    "people.field.grade": "Grau",
    "Grade": "Grau",
    "people.field.salary_range": "Faixa salarial",
    "Salary range": "Faixa salarial",
    "people.field.minimum_salary": "Salário mínimo",
    "Minimum salary": "Salário mínimo",
    "people.field.maximum_salary": "Salário máximo",
    "Maximum salary": "Salário máximo",
    "people.field.currency_id": "ID da moeda",
    "people.form.staff.edit": "Editar equipe",
    "Edit staff": "Editar equipe",
    "people.form.staff.add": "Adicionar equipe",
    "people.form.staff.description": "Link um usuário existente a um perfil de equipe.",
    "Link an existing user to a staff profile.": "Link um usuário existente a um perfil de equipe.",
    "people.form.department.edit": "Editar departamento",
    "Edit department": "Editar departamento",
    "people.form.department.add": "Adicionar departamento",
    "people.form.job_profile.edit": "Editar perfil de cargo",
    "Edit job profile": "Editar perfil de cargo",
    "people.form.job_profile.add": "Adicionar perfil de cargo",
    "people.form.pay_grade.edit": "Editar nível salarial",
    "Edit pay grade": "Editar nível salarial",
    "people.form.pay_grade.add": "Adicionar nível salarial",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Engenheiro Sênior",
    "Senior Engineer": "Engenheiro Sênior",
    "people.placeholder.department": "Engenharia",
    "Engineering": "Engenharia",
    "people.placeholder.department_description": "Equipe de Produto e Engenharia",
    "Product & Engineering team": "Equipe de Produto e Engenharia",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Tempo integral",
    "Full time": "Tempo integral",
    "people.employment.part_time": "Meio período",
    "Part time": "Meio período",
    "people.employment.contractor": "Contratado",
    "Contractor": "Contratado",
    "people.toast.staff_added": "Funcionário adicionado",
    "Staff added": "Funcionário adicionado",
    "people.toast.staff_updated": "Funcionário atualizado",
    "Staff updated": "Funcionário atualizado",
    "people.toast.department_added": "Departamento adicionado",
    "Department added": "Departamento adicionado",
    "people.toast.department_updated": "Departamento atualizado",
    "Department updated": "Departamento atualizado",
    "people.toast.job_profile_added": "Perfil de cargo adicionado",
    "Job profile added": "Perfil de cargo adicionado",
    "people.toast.job_profile_updated": "Perfil de cargo atualizado",
    "Job profile updated": "Perfil de cargo atualizado",
    "people.toast.pay_grade_added": "Nível salarial adicionado",
    "Pay grade added": "Nível salarial adicionado",
    "people.toast.pay_grade_updated": "Nível salarial atualizado",
    "Pay grade updated": "Nível salarial atualizado",
    "people.empty.staff": "Nenhum funcionário ainda. Adicione um perfil de funcionário para começar.",
    "No staff yet. Add a staff profile to get started.": "Nenhum funcionário ainda. Adicione um perfil de funcionário para começar.",
    "people.empty.departments": "Nenhum departamento ainda.",
    "No departments yet.": "Nenhum departamento ainda.",
    "people.empty.job_profiles": "Nenhum perfil de cargo ainda.",
    "No job profiles yet.": "Nenhum perfil de cargo ainda.",
    "people.empty.pay_grades": "Nenhum nível salarial ainda.",
    "No pay grades yet.": "Nenhum nível salarial ainda.",
    "people.pagination.page": "Página {page}",
    "Page {page}": "Página {page}",
    "workforce.title": "Força de trabalho",
    "workforce.tab.shifts": "Turnos",
    "Shifts": "Turnos",
    "workforce.tab.attendance": "Presença",
    "Attendance": "Presença",
    "workforce.tab.leave_requests": "Solicitações de férias",
    "Leave requests": "Solicitações de férias",
    "workforce.tab.leave_balances": "Saldo de férias",
    "Leave balances": "Saldo de férias",
    "workforce.tab.leave_policies": "Políticas de férias",
    "Leave policies": "Políticas de férias",
    "workforce.action.add_shift": "Adicionar turno",
    "Add shift": "Adicionar turno",
    "workforce.action.new_leave_request": "Nova solicitação de folga",
    "workforce.action.set_balance": "Definir saldo",
    "Set balance": "Definir saldo",
    "workforce.action.add_policy": "Adicionar política",
    "Add policy": "Adicionar política",
    "workforce.action.create_request": "Criar solicitação",
    "Create request": "Criar solicitação",
    "workforce.action.save_balance": "Salvar saldo",
    "Save balance": "Salvar saldo",
    "workforce.action.clock_in": "Marcar entrada",
    "Clock in": "Marcar entrada",
    "workforce.action.clock_out": "Marcar saída",
    "workforce.action.clocking_in": "Marcando entrada…",
    "Clocking in…": "Marcando entrada…",
    "workforce.action.clocking_out": "Marcando saída…",
    "Clocking out…": "Marcando saída…",
    "workforce.field.staff": "Pessoal",
    "workforce.field.start_time": "Início",
    "workforce.field.end_time": "Fim",
    "workforce.field.location": "Localização",
    "workforce.field.leave_type": "Tipo de folga",
    "Leave type": "Tipo de folga",
    "workforce.field.from": "De",
    "workforce.field.to": "Até",
    "workforce.field.days": "Dias",
    "Days": "Dias",
    "workforce.field.total_days": "Dias totais",
    "Total days": "Dias totais",
    "workforce.field.days_per_year": "Dias por ano",
    "Days per year": "Dias por ano",
    "workforce.field.carry_over": "Transferir para o próximo ano",
    "Carry over": "Transferir para o próximo ano",
    "workforce.field.carry_over_hint": "Os dias não utilizados são transferidos para o próximo ano.",
    "Unused days carry over to next year": "Os dias não utilizados são transferidos para o próximo ano.",
    "workforce.field.reason": "Motivo",
    "workforce.field.time": "Hora",
    "workforce.field.clock_in": "Marcar entrada",
    "workforce.field.clock_out": "Registrar saída",
    "workforce.field.hours": "Horas",
    "Hours": "Horas",
    "workforce.field.dates": "Datas",
    "Dates": "Datas",
    "workforce.field.used_days": "Utilizado",
    "Used": "Utilizado",
    "workforce.field.remaining_days": "Restante",
    "workforce.field.policy": "Política",
    "Policy": "Política",
    "workforce.placeholder.location": "Sede",
    "HQ": "Sede",
    "workforce.placeholder.leave_note": "Férias familiares",
    "Family holiday": "Férias familiares",
    "workforce.placeholder.policy_name": "Férias anuais",
    "Annual Leave": "Férias anuais",
    "workforce.placeholder.reject_reason": "Período ocupado",
    "Busy period": "Período ocupado",
    "workforce.placeholder.optional_note": "Observação opcional",
    "Optional note": "Observação opcional",
    "workforce.select.all_staff": "Todo o pessoal",
    "workforce.form.shift.add": "Adicionar turno",
    "workforce.form.leave_request.add": "Nova solicitação de férias",
    "workforce.form.leave_balance.title": "Definir saldo de férias",
    "Set leave balance": "Definir saldo de férias",
    "workforce.form.leave_balance.description": "Inicializar o direito de um funcionário para um tipo de férias e ano.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Inicializar o direito de um funcionário para um tipo de férias e ano.",
    "workforce.form.leave_policy.add": "Adicionar política de férias",
    "Add leave policy": "Adicionar política de férias",
    "workforce.form.leave_request.reject": "Rejeitar solicitação de férias",
    "Reject leave request": "Rejeitar solicitação de férias",
    "workforce.form.clock_out": "Registrar saída",
    "workforce.toast.shift_added": "Turno adicionado",
    "Shift added": "Turno adicionado",
    "workforce.toast.leave_request_created": "Solicitação de férias criada",
    "Leave request created": "Solicitação de férias criada",
    "workforce.toast.leave_balance_saved": "Saldo de férias salvo",
    "Leave balance saved": "Saldo de férias salvo",
    "workforce.toast.leave_policy_added": "Política de férias adicionada",
    "Leave policy added": "Política de férias adicionada",
    "workforce.toast.leave_request_rejected": "Solicitação de férias rejeitada",
    "Leave request rejected": "Solicitação de férias rejeitada",
    "workforce.toast.leave_request_approved": "Solicitação de folga aprovada",
    "Leave request approved": "Solicitação de folga aprovada",
    "workforce.toast.clocked_in": "Marcado",
    "Clocked in": "Marcado",
    "workforce.toast.clocked_out": "Desmarcado",
    "Clocked out": "Desmarcado",
    "workforce.empty.shifts": "Nenhum turno neste período.",
    "No shifts in this period.": "Nenhum turno neste período.",
    "workforce.empty.attendance": "Nenhum registro de ponto.",
    "No attendance records.": "Nenhum registro de ponto.",
    "workforce.empty.leave_requests": "Nenhuma solicitação de folga.",
    "No leave requests.": "Nenhuma solicitação de folga.",
    "workforce.empty.leave_balances": "Nenhum saldo de férias. Use 'Definir saldo' para adicionar um.",
    "No leave balances. Use Set balance to add one.": "Nenhum saldo de férias. Use 'Definir saldo' para adicionar um.",
    "workforce.empty.leave_policies": "Nenhuma política de férias ainda.",
    "No leave policies yet.": "Nenhuma política de férias ainda.",
    "workforce.leave_type.annual": "Férias anuais",
    "Annual leave": "Férias anuais",
    "workforce.leave_type.sick": "Férias por doença",
    "Sick leave": "Férias por doença",
    "workforce.leave_type.unpaid": "Férias não remuneradas",
    "Unpaid leave": "Férias não remuneradas",
    "workforce.leave_type.parental": "Férias parentais",
    "Parental leave": "Férias parentais",
    "workforce.leave_type.compassionate": "Férias por compaixão",
    "Compassionate leave": "Férias por compaixão",
    "workforce.duration.hours_minutes": "{hours}h {minutes}m",
    "{hours}h {minutes}m": "{hours}h {minutes}m",
    "common.year": "Ano",
    "Year": "Ano",
    "common.approve": "Aprovar",
    "common.reject": "Rejeitar",
    "payroll.title": "Folha de pagamento",
    "payroll.tab.runs": "Execuções de folha de pagamento",
    "Payroll runs": "Execuções de folha de pagamento",
    "payroll.tab.components": "Componentes da folha de pagamento",
    "Pay components": "Componentes da folha de pagamento",
    "payroll.tab.claims": "Reclamações de despesas",
    "Expense claims": "Reclamações de despesas",
    "payroll.tab.categories": "Categorias de despesas",
    "Expense categories": "Categorias de despesas",
    "payroll.action.new_run": "Nova execução de folha de pagamento",
    "New payroll run": "Nova execução de folha de pagamento",
    "payroll.action.add_component": "Adicionar componente de folha de pagamento",
    "payroll.action.new_claim": "Nova reclamação de despesas",
    "New expense claim": "Nova reclamação de despesas",
    "payroll.action.add_category": "Adicionar categoria",
    "payroll.action.create_run": "Criar execução",
    "Create run": "Criar execução",
    "payroll.action.create_component": "Criar componente",
    "Create component": "Criar componente",
    "payroll.action.create_claim": "Criar reclamação",
    "Create claim": "Criar reclamação",
    "payroll.action.submit_claim": "Enviar",
    "Submit": "Enviar",
    "payroll.action.approve_claim": "Aprovar",
    "payroll.action.reimburse_claim": "Reembolsar",
    "Reimburse": "Reembolsar",
    "payroll.action.approve_payroll": "Aprovar folha de pagamento",
    "Approve payroll": "Aprovar folha de pagamento",
    "payroll.action.activate": "Ativar",
    "Activate": "Ativar",
    "payroll.action.deactivate": "Desativar",
    "payroll.action.adjust": "Ajustar",
    "payroll.action.save_adjustment": "Salvar ajuste",
    "payroll.action.export_csv": "Exportar CSV",
    "Export CSV": "Exportar CSV",
    "payroll.action.exporting": "Exportando…",
    "payroll.action.view_staff_items": "Ver itens de funcionários",
    "View staff items": "Ver itens de funcionários",
    "payroll.action.view_payslips": "Ver folhas de pagamento",
    "View payslips": "Ver folhas de pagamento",
    "payroll.type.addition": "Adição",
    "Addition": "Adição",
    "payroll.type.deduction": "Dedução",
    "Deduction": "Dedução",
    "payroll.calculation.fixed": "Valor fixo",
    "Fixed amount": "Valor fixo",
    "payroll.calculation.percentage": "Porcentagem",
    "payroll.applies_to.all": "Todos os funcionários",
    "payroll.applies_to.hourly": "Funcionários horistas",
    "Hourly staff": "Funcionários horistas",
    "payroll.applies_to.salaried": "Funcionários assalariados",
    "Salaried staff": "Funcionários assalariados",
    "payroll.category.archive_confirm": "Arquivar {name}?",
    "payroll.components.description": "Adições e deduções ativas são aplicadas automaticamente a novos processos de folha de pagamento.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Adições e deduções ativas são aplicadas automaticamente a novos processos de folha de pagamento.",
    "payroll.empty.categories": "Nenhuma categoria de despesa ainda.",
    "No expense categories yet.": "Nenhuma categoria de despesa ainda.",
    "payroll.empty.claims": "Nenhuma reclamação de despesa ainda.",
    "No expense claims yet.": "Nenhuma reclamação de despesa ainda.",
    "payroll.empty.components": "Nenhum componente de pagamento configurado ainda.",
    "No pay components configured yet.": "Nenhum componente de pagamento configurado ainda.",
    "payroll.empty.runs": "Nenhum processo de folha de pagamento ainda.",
    "No payroll runs yet.": "Nenhum processo de folha de pagamento ainda.",
    "payroll.field.staff": "Pessoal",
    "payroll.field.base_pay": "Salário base",
    "Base pay": "Salário base",
    "payroll.field.allowances": "Abonos",
    "Allowances": "Abonos",
    "payroll.field.deductions": "Deduções",
    "Deductions": "Deduções",
    "payroll.field.commission": "Comissão",
    "payroll.field.net_pay": "Salário líquido",
    "Net pay": "Salário líquido",
    "payroll.field.components": "Componentes",
    "Components": "Componentes",
    "payroll.field.commission_override": "Substituir comissão",
    "Commission override": "Substituir comissão",
    "payroll.field.calculation": "Cálculo",
    "Calculation": "Cálculo",
    "payroll.field.applies_to": "Aplica a",
    "Applies to": "Aplica a",
    "payroll.field.staff_optional_draft": "Pessoal (opcional durante o rascunho)",
    "payroll.field.category_optional_draft": "Categoria (opcional durante o rascunho)",
    "payroll.field.category": "Categoria",
    "payroll.field.period": "Período",
    "payroll.field.period_start": "Início do período",
    "Period start": "Início do período",
    "payroll.field.period_end": "Fim do período",
    "Period end": "Fim do período",
    "payroll.field.generate_email_payslips": "Gerar e enviar folhas de pagamento por e-mail",
    "Generate and email payslips": "Gerar e enviar folhas de pagamento por e-mail",
    "payroll.field.gl_code": "Código GL",
    "GL code": "Código GL",
    "payroll.field.maximum_per_claim": "Máximo por transação",
    "Maximum per claim": "Máximo por transação",
    "payroll.field.maximum_per_transaction": "Máximo por transação",
    "Maximum per transaction": "Máximo por transação",
    "payroll.field.spending_cap": "Limite de gasto",
    "Spending cap": "Limite de gasto",
    "payroll.field.tax_rate": "Taxa de imposto (%)",
    "Tax rate (%)": "Taxa de imposto (%)",
    "payroll.field.no_limit": "Sem limite",
    "No limit": "Sem limite",
    "payroll.form.run.title": "Nova execução de folha de pagamento",
    "payroll.form.run.description": "O pagamento é calculado com base nos níveis salariais dos funcionários para o período selecionado.",
    "Pay is calculated from staff pay grades for the selected period.": "O pagamento é calculado com base nos níveis salariais dos funcionários para o período selecionado.",
    "payroll.form.component.title": "Adicionar componente de pagamento",
    "payroll.form.component.description": "Os componentes são incluídos automaticamente em futuras execuções de folha de pagamento.",
    "Components are automatically included in future payroll runs.": "Os componentes são incluídos automaticamente em futuras execuções de folha de pagamento.",
    "payroll.form.claim.title": "Nova reclamação de despesas",
    "payroll.form.claim.description": "As reclamações começam como rascunhos até serem enviadas para aprovação.",
    "Claims start as drafts until submitted for approval.": "As reclamações começam como rascunhos até serem enviadas para aprovação.",
    "payroll.form.category.add": "Adicionar categoria de despesas",
    "Add expense category": "Adicionar categoria de despesas",
    "payroll.form.category.edit": "Editar categoria de despesas",
    "Edit expense category": "Editar categoria de despesas",
    "payroll.form.claim.approve_title": "Aprovar reclamação de despesas",
    "Approve expense claim": "Aprovar reclamação de despesas",
    "payroll.form.run.approve_title": "Aprovar execução de folha de pagamento",
    "Approve payroll run": "Aprovar execução de folha de pagamento",
    "payroll.form.run.approve_description": "A aprovação bloqueia a execução da folha de pagamento. Você também pode gerar e enviar holerites por e-mail agora.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "A aprovação bloqueia a execução da folha de pagamento. Você também pode gerar e enviar holerites por e-mail agora.",
    "payroll.items.title": "Itens de folha de pagamento da equipe",
    "Staff payroll items": "Itens de folha de pagamento da equipe",
    "payroll.items.loading": "Carregando itens de folha de pagamento…",
    "Loading payroll items…": "Carregando itens de folha de pagamento…",
    "payroll.items.empty": "Nenhum item de folha de pago encontrado.",
    "No payroll items found.": "Nenhum item de folha de pago encontrado.",
    "payroll.items.adjust_title": "Ajustar item de folha de pagamento",
    "Adjust payroll item": "Ajustar item de folha de pagamento",
    "payroll.items.adjust_description": "Atualize as deduções ou substitua o valor da comissão para este funcionário.",
    "Update deductions or override the commission amount for this staff member.": "Atualize as deduções ou substitua o valor da comissão para este funcionário.",
    "payroll.payslips.title": "Holerites",
    "Payslips": "Holerites",
    "payroll.payslips.generate": "Gerar holerites",
    "Generate payslips": "Gerar holerites",
    "payroll.payslips.generating": "Gerando…",
    "Generating…": "Gerando…",
    "payroll.payslips.empty": "Nenhuma folha de pagamento gerada ainda.",
    "No payslips generated yet.": "Nenhuma folha de pagamento gerada ainda.",
    "payroll.payslips.generated": "Gerado",
    "Generated": "Gerado",
    "payroll.payslips.sent_at": "Enviado {date}",
    "Sent {date}": "Enviado {date}",
    "payroll.payslips.not_sent": "Não enviado",
    "Not sent": "Não enviado",
    "payroll.payslips.send_email": "Enviar e-mail",
    "Send email": "Enviar e-mail",
    "payroll.payslips.sending": "Enviando…",
    "payroll.payslips.details": "Detalhes da folha de pagamento",
    "Payslip details": "Detalhes da folha de pagamento",
    "payroll.placeholder.approval_note": "Aprovado",
    "payroll.placeholder.category_name": "Viagem",
    "Travel": "Viagem",
    "payroll.placeholder.claim_description": "Voo para cliente",
    "Flight to client": "Voo para cliente",
    "payroll.placeholder.component_name": "Indenização por transporte",
    "Transport Allowance": "Indenização por transporte",
    "payroll.staff_number": "Funcionário #{id}",
    "Staff #{id}": "Funcionário #{id}",
    "payroll.toast.category_added": "Categoria de despesa adicionada",
    "Expense category added": "Categoria de despesa adicionada",
    "payroll.toast.category_archived": "Categoria de despesa arquivada",
    "Expense category archived": "Categoria de despesa arquivada",
    "payroll.toast.category_updated": "Categoria de despesa atualizada",
    "Expense category updated": "Categoria de despesa atualizada",
    "payroll.toast.claim_approved": "Reclamação aprovada",
    "Claim approved": "Reclamação aprovada",
    "payroll.toast.claim_created": "Reclamação de despesa criada",
    "Expense claim created": "Reclamação de despesa criada",
    "payroll.toast.claim_reimbursed": "Reclamação marcada como reembolsada",
    "Claim marked as reimbursed": "Reclamação marcada como reembolsada",
    "payroll.toast.claim_submitted": "Reclamação enviada",
    "Claim submitted": "Reclamação enviada",
    "payroll.toast.component_activated": "Componente salarial ativado",
    "Pay component activated": "Componente salarial ativado",
    "payroll.toast.component_created": "Componente salarial criado",
    "Pay component created": "Componente salarial criado",
    "payroll.toast.component_deactivated": "Componente salarial desativado",
    "Pay component deactivated": "Componente salarial desativado",
    "payroll.toast.item_updated": "Item de folha de pagamento atualizado",
    "Payroll item updated": "Item de folha de pagamento atualizado",
    "payroll.toast.payslip_email_sent": "E-mail da folha de pagamento enviado",
    "Payslip email sent": "E-mail da folha de pagamento enviado",
    "payroll.toast.payslips_generated": "Folhas de pagamento geradas",
    "Payslips generated": "Folhas de pagamento geradas",
    "payroll.toast.run_approved": "Execução de folha de pagamento aprovada",
    "Payroll run approved": "Execução de folha de pagamento aprovada",
    "payroll.toast.run_approved_payslips_queued": "Folha de pagamento aprovada e folhas de pagamento na fila",
    "Payroll approved and payslips queued": "Folha de pagamento aprovada e folhas de pagamento na fila",
    "payroll.toast.run_created": "Execução de folha de pagamento criada",
    "payroll.toast.exported": "Folha de pagamento exportada",
    "Payroll exported": "Folha de pagamento exportada",
    "common.notes": "Notas",
    "expenses.title": "Despesas",
    "expenses.action.add": "Adicionar despesa",
    "Add expense": "Adicionar despesa",
    "expenses.action.create": "Criar despesa",
    "Create expense": "Criar despesa",
    "expenses.action.submit": "Enviar",
    "expenses.action.approve": "Aprovar",
    "expenses.action.reimburse": "Reembolsar",
    "expenses.action.pay": "Pagar",
    "expenses.action.lifecycle": "Despesa {action}ada",
    "Expense {action}d": "Despesa {action}ada",
    "expenses.type.claim": "Reclamação",
    "Claim": "Reclamação",
    "expenses.type.claims": "Reclamações",
    "Claims": "Reclamações",
    "expenses.type.bill": "Fatura",
    "Bill": "Fatura",
    "expenses.type.bills": "Faturas",
    "Bills": "Faturas",
    "expenses.filter.all_types": "Todos os tipos",
    "All types": "Todos os tipos",
    "expenses.filter.all_statuses": "Todos os estados",
    "expenses.summary.title": "Resumo",
    "Summary": "Resumo",
    "expenses.summary.by_category": "Por categoria",
    "By category": "Por categoria",
    "expenses.summary.by_status": "Por estado",
    "By status": "Por estado",
    "expenses.summary.by_party": "Por fornecedor / funcionário",
    "By supplier / staff": "Por fornecedor / funcionário",
    "expenses.summary.heading": "Resumo por {group}",
    "Summary by {group}": "Resumo por {group}",
    "expenses.summary.group.category": "categoria",
    "category": "categoria",
    "expenses.summary.group.status": "status",
    "status": "status",
    "expenses.summary.group.party": "fornecedor / funcionário",
    "supplier / staff": "fornecedor / funcionário",
    "expenses.summary.empty": "Nenhum resumo disponível.",
    "No summary available.": "Nenhum resumo disponível.",
    "expenses.column.type": "Tipo",
    "expenses.column.party": "Funcionário / Fornecedor",
    "Staff / Supplier": "Funcionário / Fornecedor",
    "expenses.column.status": "Status",
    "expenses.field.staff_optional": "Funcionário (opcional ao criar rascunho)",
    "expenses.field.supplier_optional": "Fornecedor (opcional ao criar rascunho)",
    "Supplier (optional while drafting)": "Fornecedor (opcional ao criar rascunho)",
    "expenses.field.category_optional": "Categoria (opcional ao criar rascunho)",
    "expenses.field.amount": "Valor",
    "expenses.field.currency": "Moeda",
    "expenses.field.description": "Descrição",
    "expenses.field.due_date": "Data de vencimento",
    "Due date": "Data de vencimento",
    "expenses.field.receipt_url": "URL do comprovante",
    "Receipt URL": "URL do comprovante",
    "expenses.empty": "Nenhuma despesa encontrada para os filtros selecionados.",
    "No expenses found for the selected filters.": "Nenhuma despesa encontrada para os filtros selecionados.",
    "expenses.modal.edit": "Editar despesa",
    "Edit expense": "Editar despesa",
    "expenses.modal.add": "Adicionar {type}",
    "Add {type}": "Adicionar {type}",
    "expenses.modal.bill_help": "Crie o rascunho agora e atribua um fornecedor antes de enviar.",
    "Create the draft now and assign a supplier before submitting.": "Crie o rascunho agora e atribua um fornecedor antes de enviar.",
    "expenses.modal.claim_help": "Crie o rascunho agora e atribua um funcionário antes de enviar.",
    "Create the draft now and assign a staff member before submitting.": "Crie o rascunho agora e atribua um funcionário antes de enviar.",
    "expenses.toast.updated": "Despesa atualizada",
    "Expense updated": "Despesa atualizada",
    "expenses.toast.created": "Despesa criada",
    "Expense created": "Despesa criada",
    "recurring_payments.title": "Pagamentos recorrentes",
    "recurring_payments.action.add": "Adicionar pagamento recorrente",
    "Add recurring payment": "Adicionar pagamento recorrente",
    "recurring_payments.action.create": "Criar pagamento recorrente",
    "Create recurring payment": "Criar pagamento recorrente",
    "recurring_payments.action.pause": "Pausar",
    "Pause": "Pausar",
    "recurring_payments.action.resume": "Retomar",
    "Resume": "Retomar",
    "recurring_payments.action.remove": "Remover",
    "recurring_payments.description": "Crie automaticamente faturas de despesa rascunho para pagamentos regulares a fornecedores.",
    "Automatically create draft expense bills for regular supplier payments.": "Crie automaticamente faturas de despesa rascunho para pagamentos regulares a fornecedores.",
    "recurring_payments.field.name": "Nome",
    "recurring_payments.field.supplier": "Fornecedor",
    "recurring_payments.field.supplier_optional": "Fornecedor (opcional)",
    "Supplier (optional)": "Fornecedor (opcional)",
    "recurring_payments.field.frequency": "Frequência",
    "Frequency": "Frequência",
    "recurring_payments.field.next_due": "Próxima data de vencimento",
    "Next due date": "Próxima data de vencimento",
    "recurring_payments.field.auto_create": "Criar automaticamente rascunho de fatura",
    "Auto-create draft bill": "Criar automaticamente rascunho de fatura",
    "recurring_payments.field.auto_create_help": "Criar automaticamente um rascunho de fatura de despesa",
    "Create a draft expense bill automatically": "Criar automaticamente um rascunho de fatura de despesa",
    "recurring_payments.field.one_time": "Pagamento único",
    "One-time payment": "Pagamento único",
    "recurring_payments.field.one_time_help": "Encerrar após a próxima fatura gerada",
    "End after the next generated bill": "Encerrar após a próxima fatura gerada",
    "recurring_payments.field.end_date": "Data de término",
    "recurring_payments.placeholder.name": "Aluguel de escritório",
    "Office Rent": "Aluguel de escritório",
    "recurring_payments.frequency.daily": "Diário",
    "recurring_payments.frequency.weekly": "Semanal",
    "recurring_payments.frequency.monthly": "Mensal",
    "recurring_payments.frequency.quarterly": "Trimestral",
    "recurring_payments.frequency.yearly": "Anual",
    "Yearly": "Anual",
    "recurring_payments.form.description": "Pagamentos vencidos criam automaticamente faturas rascunho em Despesas quando a opção de criação automática é habilitada.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Pagamentos vencidos criam automaticamente faturas rascunho em Despesas quando a opção de criação automática é habilitada.",
    "recurring_payments.empty": "Ainda não há pagamentos recorrentes.",
    "No recurring payments yet.": "Ainda não há pagamentos recorrentes.",
    "recurring_payments.this_payment": "este pagamento recorrente",
    "this recurring payment": "este pagamento recorrente",
    "recurring_payments.confirm_remove": "Remover {name}?",
    "Remove {name}?": "Remover {name}?",
    "recurring_payments.toast.pause": "Pagamento recorrente pausado",
    "Recurring payment paused": "Pagamento recorrente pausado",
    "recurring_payments.toast.resume": "Pagamento recorrente retomado",
    "Recurring payment resumed": "Pagamento recorrente retomado",
    "recurring_payments.toast.delete": "Pagamento recorrente removido",
    "Recurring payment removed": "Pagamento recorrente removido",
    "recurring_payments.toast.created": "Pagamento recorrente criado",
    "Recurring payment created": "Pagamento recorrente criado",
    "expenses.toast.submit": "Despesa enviada",
    "Expense submitted": "Despesa enviada",
    "expenses.toast.approve": "Despesa aprovada",
    "Expense approved": "Despesa aprovada",
    "expenses.toast.reimburse": "Despesa reembolsada",
    "Expense reimbursed": "Despesa reembolsada",
    "expenses.toast.pay": "Despesa paga",
    "Expense paid": "Despesa paga",
    "media_picker.title": "Selecionar mídia",
    "Select media": "Selecionar mídia",
    "media_picker.type.media": "Mídia",
    "media_picker.type.all": "Tudo",
    "media_picker.type.image": "Imagem",
    "media_picker.type.video": "Vídeo",
    "media_picker.type.audio": "Áudio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Pasta",
    "media_picker.label.show": "Mostrar",
    "media_picker.label.media_type": "Tipo de mídia",
    "Media type": "Tipo de mídia",
    "media_picker.action.show_type": "Mostrar {type} mídia",
    "media_picker.action.close": "Fechar seletor de mídia",
    "Close media picker": "Fechar seletor de mídia",
    "media_picker.action.upload": "Enviar mídia",
    "media_picker.action.creating": "Criando…",
    "media_picker.action.create_folder": "Criar pasta",
    "Create folder": "Criar pasta",
    "media_picker.action.cancel": "Cancelar",
    "media_picker.action.use_selected": "Usar selecionados",
    "Use selected": "Usar selecionados",
    "media_picker.placeholder.search": "Pesquisar mídia",
    "media_picker.placeholder.folder": "Nome da nova pasta",
    "New folder name": "Nome da nova pasta",
    "media_picker.loading": "Carregando mídia…",
    "media_picker.empty": "Nenhuma mídia encontrada nesta pasta.",
    "No media found in this folder.": "Nenhuma mídia encontrada nesta pasta.",
    "media_picker.selection.count": "{count} selecionados",
    "{count} selected": "{count} selecionados",
    "media_picker.selection.prompt": "Selecione um arquivo para continuar",
    "Select a file to continue": "Selecione um arquivo para continuar",
    "media_picker.error.load": "Não é possível carregar a mídia",
    "Unable to load media": "Não é possível carregar a mídia",
    "media_picker.error.load_retry": "Não é possível carregar a mídia. Por favor, tente novamente.",
    "media_picker.error.create_folder": "Não é possível criar a pasta",
    "media_picker.error.create_folder_retry": "Não é possível criar a pasta. Por favor, tente novamente.",
    "Unable to create folder. Please try again.": "Não é possível criar a pasta. Por favor, tente novamente.",
    "media_picker.error.prepare_upload": "Não é possível preparar o upload",
    "Unable to prepare upload": "Não é possível preparar o upload",
    "media_picker.error.upload_url": "URL de upload ausente",
    "Upload URL missing": "URL de upload ausente",
    "media_picker.error.register_media": "Não é possível registrar a mídia",
    "media_picker.error.upload_retry": "Não é possível fazer o upload da mídia. Por favor, tente novamente.",
    "membership.title": "Membro",
    "membership.description": "Gerencie programas de membro, contribuições de membros, status de pagamento e regras de lembrete.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Gerencie programas de membro, contribuições de membros, status de pagamento e regras de lembrete.",
    "membership.action.settings": "Configurações",
    "membership.action.manage_programs": "Gerenciar programas",
    "Manage programs": "Gerenciar programas",
    "membership.action.view_data": "Ver dados",
    "View data": "Ver dados",
    "membership.action.edit_listing": "Editar lista",
    "membership.action.go_to_listings": "Ir para listagens",
    "Go to listings": "Ir para listagens",
    "membership.action.view_order": "Ver pedido",
    "View order": "Ver pedido",
    "membership.action.configure_reminders": "Configurar lembretes",
    "Configure reminders": "Configurar lembretes",
    "membership.stat.programs": "Programas",
    "membership.stat.active_members": "Membros ativos",
    "Active members": "Membros ativos",
    "membership.stat.contributions": "Contribuições",
    "Contributions": "Contribuições",
    "membership.stat.units": "Unidades creditadas",
    "Units credited": "Unidades creditadas",
    "membership.programs.title": "Programas",
    "membership.programs.description": "Listagens de tipo de assinatura disponíveis para seus clientes.",
    "Membership-type listings available to your customers.": "Listagens de tipo de assinatura disponíveis para seus clientes.",
    "membership.programs.no_description": "Ainda não há descrição do programa.",
    "No program description yet.": "Ainda não há descrição do programa.",
    "membership.programs.empty_title": "Ainda não há programas de assinatura",
    "No membership programs yet": "Ainda não há programas de assinatura",
    "membership.programs.empty_description": "Crie uma listagem com tipo de assinatura para começar a aceitar contribuições.",
    "Create a listing with type membership to start accepting contributions.": "Crie uma listagem com tipo de assinatura para começar a aceitar contribuições.",
    "membership.programs.history_description": "Histórico de preços e membros inscritos.",
    "Price history and enrolled members.": "Histórico de preços e membros inscritos.",
    "membership.badge": "Assinatura",
    "membership.loading_program": "Carregando dados do programa…",
    "Loading program data…": "Carregando dados do programa…",
    "membership.price_logs.title": "Registros de preços",
    "Price logs": "Registros de preços",
    "membership.price_logs.empty": "Não há registros de preços.",
    "No price logs recorded.": "Não há registros de preços.",
    "membership.source.manual": "manual",
    "manual": "manual",
    "membership.members.title": "Membros",
    "Members": "Membros",
    "membership.members.empty_program": "Não há membros inscritos neste programa.",
    "No members enrolled in this program.": "Não há membros inscritos neste programa.",
    "membership.members.recent": "Membros recentes",
    "Recent members": "Membros recentes",
    "membership.members.empty_recent": "Os membros e contribuições aparecerão aqui após a inscrição.",
    "Members and contributions will appear here after enrolment.": "Os membros e contribuições aparecerão aqui após a inscrição.",
    "membership.member_heading": "Membro: {member}",
    "Member: {member}": "Membro: {member}",
    "membership.contributions.title": "Contribuições",
    "membership.contributions.empty": "Nenhuma contribuição registrada ainda.",
    "No contributions recorded yet.": "Nenhuma contribuição registrada ainda.",
    "membership.payment_dues.title": "Dívidas de pagamento",
    "Payment dues": "Dívidas de pagamento",
    "membership.payment_dues.empty": "Nenhuma dívida de pagamento agendada.",
    "No scheduled payment dues.": "Nenhuma dívida de pagamento agendada.",
    "membership.unit": "unidade",
    "unit": "unidade",
    "membership.units": "unidades",
    "units": "unidades",
    "membership.months": "meses",
    "membership.automation.label": "AUTOMAÇÃO",
    "AUTOMATION": "AUTOMAÇÃO",
    "membership.automation.description": "O trabalhador diário verifica os pagamentos programados de associação.",
    "Daily worker checks scheduled membership payments.": "O trabalhador diário verifica os pagamentos programados de associação.",
    "membership.reminders.title": "Lembretes de pagamento",
    "Payment reminders": "Lembretes de pagamento",
    "membership.reminders.due_soon": "Lembrete de vencimento próximo",
    "Due-soon reminder": "Lembrete de vencimento próximo",
    "membership.reminders.due_soon_short": "Vencimento próximo",
    "Due soon": "Vencimento próximo",
    "membership.reminders.due_soon_help": "Enviar um lembrete antes da data de vencimento da dívida programada.",
    "Send one reminder before a scheduled payment is due.": "Enviar um lembrete antes da data de vencimento da dívida programada.",
    "membership.reminders.days_before": "Dias antes da data de vencimento",
    "Days before due date": "Dias antes da data de vencimento",
    "membership.reminders.days_before_value": "{count} dias antes",
    "{count} days before": "{count} dias antes",
    "membership.reminders.overdue": "Lembrete de vencimento",
    "Overdue reminder": "Lembrete de vencimento",
    "membership.reminders.overdue_help": "Enviar um lembrete após a data de vencimento e o período de carência.",
    "Send one reminder after the due date and grace period.": "Enviar um lembrete após a data de vencimento e o período de carência.",
    "membership.settings.title": "Configuração de associação",
    "Membership settings": "Configuração de associação",
    "membership.settings.description": "Configure o horário de lembretes de pagamento.",
    "Configure the payment reminder schedule.": "Configure o horário de lembretes de pagamento.",
    "membership.email_copy.title": "Cópia de e-mail personalizada",
    "Custom email copy": "Cópia de e-mail personalizada",
    "membership.email_copy.description": "Use Configurações → Notificações → Associação para editar os assuntos e modelos de vencimento próximo e vencido.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Use Configurações → Notificações → Associação para editar os assuntos e modelos de vencimento próximo e vencido.",
    "membership.toast.saved": "Configuração de lembretes de associação salva.",
    "Membership reminder settings saved.": "Configuração de lembretes de associação salva.",
    "membership.toast.save_failed": "Não é possível salvar a configuração de lembretes de associação.",
    "Unable to save membership reminder settings.": "Não é possível salvar a configuração de lembretes de associação.",
    "common.status.off": "Desligado",
    "Off": "Desligado",
    "common.status.on": "Ligado",
    "On": "Ligado",
    "common.save_settings": "Salvar configurações",
    "Save settings": "Salvar configurações",
    "developer.page.title": "API e desenvolvedor",
    "API & Developer": "API e desenvolvedor",
    "developer.api_keys.title": "Chaves da API",
    "API Keys": "Chaves da API",
    "developer.api_keys.description": "Use estas chaves para autenticar solicitações à API Tradly. Mantenha sua Chave Secreta privada — nunca a exponha em código do lado do cliente.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Use estas chaves para autenticar solicitações à API Tradly. Mantenha sua Chave Secreta privada — nunca a exponha em código do lado do cliente.",
    "developer.api_keys.credentials_description": "Encontre abaixo suas chaves de produção. Você precisará usar essas chaves para autorizar e construir seus aplicativos.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Encontre abaixo suas chaves de produção. Você precisará usar essas chaves para autorizar e construir seus aplicativos.",
    "developer.api_keys.publishable": "Chave publicável",
    "Publishable Key": "Chave publicável",
    "developer.api_keys.publishable_placeholder": "Insira a Chave publicável",
    "Enter Publishable Key": "Insira a Chave publicável",
    "developer.api_keys.secret": "Chave secreta",
    "developer.api_keys.secret_placeholder": "Insira a Chave secreta",
    "Enter Secret Key": "Insira a Chave secreta",
    "developer.api_keys.access_label": "Acesso à API",
    "API access": "Acesso à API",
    "developer.api_reference.title": "Referência da API",
    "developer.api_reference.description": "Documentação completa da API REST, guias e exemplos de código para construir sobre seu mercado Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Documentação completa da API REST, guias e exemplos de código para construir sobre seu mercado Tradly.",
    "developer.api_reference.card_description": "Explore a referência completa da API, guias de autenticação, webhooks e documentação do SDK. Tudo o que você precisa para integrar ou construir interfaces personalizadas sobre seu mercado.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Explore a referência completa da API, guias de autenticação, webhooks e documentação do SDK. Tudo o que você precisa para integrar ou construir interfaces personalizadas sobre seu mercado.",
    "developer.api_reference.open_docs": "Abrir Documentação da API",
    "Open API Docs": "Abrir Documentação da API",
    "developer.ai_agents.title": "IA e agentes",
    "AI & Agents": "IA e agentes",
    "developer.ai_agents.description": "Conecte seu mercado às ferramentas de IA e permita que seus clientes criem agentes impulsionados pela sua plataforma.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Conecte seu mercado às ferramentas de IA e permita que seus clientes criem agentes impulsionados pela sua plataforma.",
    "developer.mcp.action.create": "Criar",
    "developer.mcp.action.removing": "Removendo…",
    "developer.mcp.scope.resource": "Recurso",
    "developer.customer_agents.description": "Permite que seus clientes criem agentes de IA que interajam com seu mercado. Compatível com ChatGPT, Claude e outras plataformas de IA. Ideal para automatizar fluxos de trabalho de compradores, criar lojas personalizadas ou criar assistentes de compras inteligentes.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Permite que seus clientes criem agentes de IA que interajam com seu mercado. Compatível com ChatGPT, Claude e outras plataformas de IA. Ideal para automatizar fluxos de trabalho de compradores, criar lojas personalizadas ou criar assistentes de compras inteligentes.",
    "whatsapp.title": "Conector do WhatsApp",
    "WhatsApp connector": "Conector do WhatsApp",
    "whatsapp.intro.title": "Envie OTP e mensagens de marketing através do WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Envie OTP e mensagens de marketing através do WhatsApp",
    "whatsapp.intro.help": "Conecte este inquilino à API Meta WhatsApp Cloud. O SMS permanece como canal padrão ou de reserva, e o mesmo conector pode entregar modelos de campanha aprovados do WhatsApp.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Conecte este inquilino à API Meta WhatsApp Cloud. O SMS permanece como canal padrão ou de reserva, e o mesmo conector pode entregar modelos de campanha aprovados do WhatsApp.",
    "whatsapp.status.disabled": "Desativado",
    "whatsapp.status.sms_otp": "Conector ativo · OTP por SMS",
    "Connector on · SMS OTP": "Conector ativo · OTP por SMS",
    "whatsapp.status.needs_configuration": "Precisa de configuração",
    "Needs configuration": "Precisa de configuração",
    "whatsapp.status.auto_fallback": "WhatsApp com fallback SMS",
    "WhatsApp with SMS fallback": "WhatsApp com fallback SMS",
    "whatsapp.status.sms_whatsapp_backup": "SMS com reserva no WhatsApp",
    "SMS with WhatsApp backup": "SMS com reserva no WhatsApp",
    "whatsapp.status.enabled": "WhatsApp ativado",
    "WhatsApp enabled": "WhatsApp ativado",
    "whatsapp.draft.notice": "Você tem um rascunho não salvo de configurações do WhatsApp.",
    "You have an unsaved WhatsApp settings draft.": "Você tem um rascunho não salvo de configurações do WhatsApp.",
    "whatsapp.connect.title": "Conecte seu WhatsApp comercial",
    "Connect your business WhatsApp": "Conecte seu WhatsApp comercial",
    "whatsapp.connect.description": "Insira o número de negócio que seus clientes conhecem. A Meta abrirá uma janela de verificação segura; você não precisa encontrar um ID de WABA, ID de número de telefone, token de acesso ou configuração de API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Insira o número de negócio que seus clientes conhecem. A Meta abrirá uma janela de verificação segura; você não precisa encontrar um ID de WABA, ID de número de telefone, token de acesso ou configuração de API.",
    "whatsapp.field.business_number": "Número do WhatsApp comercial",
    "Business WhatsApp number": "Número do WhatsApp comercial",
    "whatsapp.field.business_number_help": "Use o número que você deseja que os clientes enviem mensagens, incluindo o código do país.",
    "Use the number you want customers to message, including country code.": "Use o número que você deseja que os clientes enviem mensagens, incluindo o código do país.",
    "whatsapp.placeholder.business_number": "ex. +60 13 333 1671",
    "e.g. +60 13 333 1671": "ex. +60 13 333 1671",
    "whatsapp.field.connection_name": "Nome da conexão",
    "whatsapp.field.connection_name_help": "Use um nome claro como Kuala Lumpur, Marca varejista ou Suporte.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Use um nome claro como Kuala Lumpur, Marca varejista ou Suporte.",
    "whatsapp.placeholder.connection_name": "ex. Suporte de Kuala Lumpur",
    "e.g. Kuala Lumpur support": "ex. Suporte de Kuala Lumpur",
    "whatsapp.field.optional_details": "Detalhes de conexão opcionais",
    "Optional connection details": "Detalhes de conexão opcionais",
    "whatsapp.field.optional_details_help": "Use-os apenas quando este número pertencer a uma marca, conta ou filial específica.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Use-os apenas quando este número pertencer a uma marca, conta ou filial específica.",
    "whatsapp.field.brand_key": "Chave da marca",
    "Brand key": "Chave da marca",
    "whatsapp.field.brand_key_help": "Chave interna estável para uma marca, como varejo ou atacado.",
    "Stable internal key for a brand, such as retail or wholesale.": "Chave interna estável para uma marca, como varejo ou atacado.",
    "whatsapp.placeholder.brand_key": "ex. varejo",
    "e.g. retail": "ex. varejo",
    "whatsapp.field.account_id": "ID da conta",
    "whatsapp.field.account_id_help": "Associe este número a uma conta Tradly existente.",
    "Associate this number with an existing Tradly account.": "Associe este número a uma conta Tradly existente.",
    "whatsapp.placeholder.account_id": "ex. 123",
    "e.g. 123": "ex. 123",
    "whatsapp.field.branch_id": "ID da filial",
    "Branch ID": "ID da filial",
    "whatsapp.field.branch_id_help": "Associe este número a uma filial Tradly existente.",
    "Associate this number with an existing Tradly branch.": "Associe este número a uma filial Tradly existente.",
    "whatsapp.placeholder.branch_id": "ex. 456",
    "e.g. 456": "ex. 456",
    "whatsapp.field.default_connection": "Usar como conexão padrão",
    "Use as default connection": "Usar como conexão padrão",
    "whatsapp.field.default_connection_help": "Os fluxos OTP herdados usam a conexão padrão selecionada quando nenhuma conexão específica de ramo é escolhida.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Os fluxos OTP herdados usam a conexão padrão selecionada quando nenhuma conexão específica de ramo é escolhida.",
    "whatsapp.field.uses_business_app": "Uso o app WhatsApp Business neste número",
    "I use the WhatsApp Business app on this number": "Uso o app WhatsApp Business neste número",
    "whatsapp.field.uses_business_app_help": "Continue conversando no app WhatsApp Business do seu celular. A Meta pedirá que você escaneie um QR code pelo app, e seus contatos e conversas recentes serão sincronizados. Requer a versão 2.24.17 ou posterior.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Continue conversando no app WhatsApp Business do seu celular. A Meta pedirá que você escaneie um QR code pelo app, e seus contatos e conversas recentes serão sincronizados. Requer a versão 2.24.17 ou posterior.",
    "whatsapp.connected.business_account": "Conta de negócios do WhatsApp",
    "WhatsApp business account": "Conta de negócios do WhatsApp",
    "whatsapp.connected.template_ready": "Modelo de autenticação pronto · OTP automático pode usar o WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Modelo de autenticação pronto · OTP automático pode usar o WhatsApp.",
    "whatsapp.connected.template_pending": "Conectado · SMS permanece como fallback seguro enquanto a modelo de autenticação é aprovada.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Conectado · SMS permanece como fallback seguro enquanto a modelo de autenticação é aprovada.",
    "whatsapp.action.connect": "Conectar WhatsApp",
    "Connect WhatsApp": "Conectar WhatsApp",
    "whatsapp.action.reconnect": "Reconectar WhatsApp",
    "Reconnect WhatsApp": "Reconectar WhatsApp",
    "whatsapp.connections.title": "Números de WhatsApp conectados",
    "Connected WhatsApp numbers": "Números de WhatsApp conectados",
    "whatsapp.connections.description": "Cada número pode pertencer a uma marca, conta ou filial diferente. Selecione um antes de ativar os modelos.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Cada número pode pertencer a uma marca, conta ou filial diferente. Selecione um antes de ativar os modelos.",
    "whatsapp.connections.unnamed": "Conexão do WhatsApp",
    "WhatsApp connection": "Conexão do WhatsApp",
    "whatsapp.connections.default": "Padrão",
    "whatsapp.connections.account": "Conta {id}",
    "Account {id}": "Conta {id}",
    "whatsapp.connections.branch": "Filial {id}",
    "Branch {id}": "Filial {id}",
    "whatsapp.connections.tenant_wide": "Conexão para toda a empresa",
    "Tenant-wide connection": "Conexão para toda a empresa",
    "whatsapp.action.make_default": "Tornar padrão",
    "Make default": "Tornar padrão",
    "whatsapp.notice.default_updated": "Conexão padrão do WhatsApp atualizada.",
    "Default WhatsApp connection updated.": "Conexão padrão do WhatsApp atualizada.",
    "whatsapp.error.default_update": "Não é possível alterar a conexão padrão.",
    "Unable to change the default connection.": "Não é possível alterar a conexão padrão.",
    "whatsapp.templates.title": "Modelos de mensagens",
    "Message templates": "Modelos de mensagens",
    "whatsapp.templates.description": "Escolha um modelo pronto. Tradly envia-o para aprovação da Meta e ativa automaticamente quando a Meta aprovar.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Escolha um modelo pronto. Tradly envia-o para aprovação da Meta e ativa automaticamente quando a Meta aprovar.",
    "whatsapp.template.status.not_activated": "Não ativado",
    "Not activated": "Não ativado",
    "whatsapp.template.status.approved": "Aprovado",
    "whatsapp.template.status.pending": "Pendente",
    "whatsapp.template.status.submitted": "Enviado",
    "Submitted": "Enviado",
    "whatsapp.template.action.active": "Ativo",
    "whatsapp.template.action.submitted": "Enviado",
    "whatsapp.template.action.activate": "Ativar modelo",
    "Activate template": "Ativar modelo",
    "whatsapp.notice.template_active": "{name} foi aprovada e está ativa.",
    "{name} is approved and active.": "{name} foi aprovada e está ativa.",
    "whatsapp.notice.template_submitted": "{name} foi enviado para revisão na Meta. Você pode continuar usando SMS até que seja aprovado.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} foi enviado para revisão na Meta. Você pode continuar usando SMS até que seja aprovado.",
    "whatsapp.channel.title": "Canal de entrega",
    "Delivery channel": "Canal de entrega",
    "whatsapp.channel.help": "O botão ativa o WhatsApp para o seu negócio. Os códigos de login podem ir somente por SMS, somente pelo WhatsApp ou por SMS com WhatsApp como reserva; as opções de WhatsApp exigem um modelo de código aprovado.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "O botão ativa o WhatsApp para o seu negócio. Os códigos de login podem ir somente por SMS, somente pelo WhatsApp ou por SMS com WhatsApp como reserva; as opções de WhatsApp exigem um modelo de código aprovado.",
    "whatsapp.channel.primary_otp": "Canal OTP primário",
    "Primary OTP channel": "Canal OTP primário",
    "whatsapp.channel.sms_description": "Mantenha o caminho de entrega SMS existente.",
    "Keep the existing SMS delivery path.": "Mantenha o caminho de entrega SMS existente.",
    "whatsapp.channel.whatsapp_description": "Use a API da Meta Cloud para este inquilino.",
    "Use Meta Cloud API for this tenant.": "Use a API da Meta Cloud para este inquilino.",
    "whatsapp.channel.automatic": "Automático",
    "Automatic": "Automático",
    "whatsapp.channel.automatic_description": "Use WhatsApp quando configurado, caso contrário SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Use WhatsApp quando configurado, caso contrário SMS.",
    "whatsapp.channel.fallback": "Falha após WhatsApp",
    "Fallback after WhatsApp failure": "Falha após WhatsApp",
    "whatsapp.channel.no_fallback": "Sem fallback",
    "No fallback": "Sem fallback",
    "whatsapp.channel.no_fallback_description": "Retorna o resultado de entrega configurado.",
    "Return the configured delivery result.": "Retorna o resultado de entrega configurado.",
    "whatsapp.channel.sms_fallback_description": "Tente SMS com o mesmo código OTP.",
    "Try SMS with the same OTP code.": "Tente SMS com o mesmo código OTP.",
    "whatsapp.channel.sms_only": "Somente SMS",
    "SMS only": "Somente SMS",
    "whatsapp.channel.sms_only_description": "Os códigos são enviados por SMS.",
    "Codes are sent by text message.": "Os códigos são enviados por SMS.",
    "whatsapp.channel.whatsapp_only": "Somente WhatsApp",
    "WhatsApp only": "Somente WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "Os códigos são enviados do seu número de WhatsApp.",
    "Codes are sent from your WhatsApp number.": "Os códigos são enviados do seu número de WhatsApp.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp como reserva",
    "SMS, WhatsApp as backup": "SMS, WhatsApp como reserva",
    "whatsapp.channel.sms_whatsapp_description": "Os códigos vão por SMS; se falhar, o mesmo código é enviado pelo WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Os códigos vão por SMS; se falhar, o mesmo código é enviado pelo WhatsApp.",
    "whatsapp.advanced.title": "Configuração técnica de recuperação",
    "Technical recovery settings": "Configuração técnica de recuperação",
    "whatsapp.advanced.description": "Somente para suporte da plataforma. A maioria dos negócios deve usar Connect WhatsApp acima.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Somente para suporte da plataforma. A maioria dos negócios deve usar Connect WhatsApp acima.",
    "whatsapp.field.phone_number_id": "ID do número de telefone do WhatsApp",
    "WhatsApp phone number ID": "ID do número de telefone do WhatsApp",
    "whatsapp.field.phone_number_id_help": "A ID do número de telefone associado à sua conta do WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "A ID do número de telefone associado à sua conta do WhatsApp Business.",
    "whatsapp.field.waba_id": "ID da conta do WhatsApp Business",
    "WhatsApp Business Account ID": "ID da conta do WhatsApp Business",
    "whatsapp.field.waba_id_help": "Aparece ao lado da ID do número na Meta (WhatsApp > Configuração da API). Necessário para modelos e mensagens de teste.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Aparece ao lado da ID do número na Meta (WhatsApp > Configuração da API). Necessário para modelos e mensagens de teste.",
    "whatsapp.placeholder.phone_number_id": "Exemplo: 123456789012345",
    "e.g. 123456789012345": "Exemplo: 123456789012345",
    "whatsapp.field.access_token": "Token de acesso da Meta",
    "Meta access token": "Token de acesso da Meta",
    "whatsapp.field.access_token_saved_help": "Salvo com segurança no servidor. Deixe em branco para manter inalterado, ou cole um novo token para substituí-lo.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Salvo com segurança no servidor. Deixe em branco para manter inalterado, ou cole um novo token para substituí-lo.",
    "whatsapp.field.access_token_help": "Use um token de usuário do sistema com permissão de mensagens do WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Use um token de usuário do sistema com permissão de mensagens do WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Salvo com segurança · deixe em branco para manter",
    "Saved securely · leave blank to keep": "Salvo com segurança · deixe em branco para manter",
    "whatsapp.placeholder.access_token": "Colar token",
    "Paste token": "Colar token",
    "whatsapp.token.saved": "Token de acesso da Meta salvo com segurança",
    "Meta access token saved securely": "Token de acesso da Meta salvo com segurança",
    "whatsapp.field.otp_template": "Nome do modelo de OTP aprovado",
    "Approved OTP template name": "Nome do modelo de OTP aprovado",
    "whatsapp.field.otp_template_help": "O corpo do modelo deve aceitar o OTP como um parâmetro de texto.",
    "The template body must accept the OTP as one text parameter.": "O corpo do modelo deve aceitar o OTP como um parâmetro de texto.",
    "whatsapp.placeholder.otp_template": "ex. login_verification",
    "e.g. login_verification": "ex. login_verification",
    "whatsapp.field.template_language": "Idioma do modelo",
    "Template language": "Idioma do modelo",
    "whatsapp.field.marketing_template": "Nome do modelo de marketing aprovado (opcional)",
    "Approved marketing template name (optional)": "Nome do modelo de marketing aprovado (opcional)",
    "whatsapp.field.marketing_template_help": "Use um modelo de marketing aprovado pela Meta. Uma campanha pode substituir este nome em seu content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Use um modelo de marketing aprovado pela Meta. Uma campanha pode substituir este nome em seu content.template_name.",
    "whatsapp.placeholder.marketing_template": "ex. monthly_offer",
    "e.g. monthly_offer": "ex. monthly_offer",
    "whatsapp.field.marketing_language": "Idioma do modelo de marketing",
    "Marketing template language": "Idioma do modelo de marketing",
    "whatsapp.info.title": "Antes de ativar o WhatsApp",
    "Before enabling WhatsApp": "Antes de ativar o WhatsApp",
    "whatsapp.info.description": "A Meta deve aprovar cada modelo de OTP ou de marketing antes de que possa ser enviado. O conteúdo da campanha do WhatsApp usa template_name, template_language e parâmetros opcionais de corpo; os números de destinatário devem estar no formato E.164. Se o fallback automático estiver habilitado, o ArcticOwl tenta SMS com o OTP original em vez de gerar um segundo código.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "A Meta deve aprovar cada modelo de OTP ou de marketing antes de que possa ser enviado. O conteúdo da campanha do WhatsApp usa template_name, template_language e parâmetros opcionais de corpo; os números de destinatário devem estar no formato E.164. Se o fallback automático estiver habilitado, o ArcticOwl tenta SMS com o OTP original em vez de gerar um segundo código.",
    "whatsapp.action.hide_token": "Ocultar token de acesso da Meta",
    "Hide Meta access token": "Ocultar token de acesso da Meta",
    "whatsapp.action.show_token": "Mostrar token de acesso da Meta",
    "Show Meta access token": "Mostrar token de acesso da Meta",
    "whatsapp.error.generic": "Não é possível salvar as configurações do WhatsApp.",
    "Unable to save WhatsApp settings.": "Não é possível salvar as configurações do WhatsApp.",
    "whatsapp.error.browser_required": "A conexão do WhatsApp só está disponível em um navegador.",
    "WhatsApp connection is only available in a browser.": "A conexão do WhatsApp só está disponível em um navegador.",
    "whatsapp.error.meta_load": "A Meta não pôde carregar. Verifique as configurações de privacidade do navegador e tente novamente.",
    "Meta could not load. Check the browser privacy settings and try again.": "A Meta não pôde carregar. Verifique as configurações de privacidade do navegador e tente novamente.",
    "whatsapp.error.load": "Não é possível carregar as configurações do WhatsApp.",
    "Unable to load WhatsApp settings.": "Não é possível carregar as configurações do WhatsApp.",
    "whatsapp.error.connect_before_template": "Conecte o WhatsApp antes de ativar um modelo.",
    "Connect WhatsApp before activating a template.": "Conecte o WhatsApp antes de ativar um modelo.",
    "whatsapp.error.template_submit": "Não é possível enviar o modelo do WhatsApp.",
    "Unable to submit the WhatsApp template.": "Não é possível enviar o modelo do WhatsApp.",
    "whatsapp.error.business_number_required": "Insira o número de WhatsApp comercial antes de se conectar. A Meta verificará em etapa seguinte.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Insira o número de WhatsApp comercial antes de se conectar. A Meta verificará em etapa seguinte.",
    "whatsapp.error.signup_not_ready": "A conexão do WhatsApp ainda está sendo preparada pela plataforma. Por favor, tente novamente em breve.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "A conexão do WhatsApp ainda está sendo preparada pela plataforma. Por favor, tente novamente em breve.",
    "whatsapp.error.signup_cancelled": "A conexão da Meta foi cancelada ou não retornou um código de autorização.",
    "Meta connection was cancelled or did not return an authorization code.": "A conexão da Meta foi cancelada ou não retornou um código de autorização.",
    "whatsapp.error.phone_number_missing": "A Meta não retornou o número de WhatsApp comercial selecionado. Por favor, tente a conexão novamente.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "A Meta não retornou o número de WhatsApp comercial selecionado. Por favor, tente a conexão novamente.",
    "whatsapp.notice.connected_auto": "WhatsApp está conectado. A entrega automática de OTP usará WhatsApp primeiro e SMS se falhar.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp está conectado. A entrega automática de OTP usará WhatsApp primeiro e SMS se falhar.",
    "whatsapp.notice.connected_sms": "WhatsApp está conectado. O SMS permanecerá ativo até que a Meta aprovar um modelo de autenticação.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp está conectado. O SMS permanecerá ativo até que a Meta aprovar um modelo de autenticação.",
    "whatsapp.error.connect": "Não é possível conectar o WhatsApp.",
    "Unable to connect WhatsApp.": "Não é possível conectar o WhatsApp.",
    "whatsapp.error.otp_configuration": "WhatsApp ou Entrega Automática de OTP precisam de um ID de número de telefone, um nome de modelo de OTP aprovado e um token de acesso da Meta. Para WhatsApp apenas para marketing, escolha SMS como canal principal de OTP e mantenha o conector habilitado.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "WhatsApp ou Entrega Automática de OTP precisam de um ID de número de telefone, um nome de modelo de OTP aprovado e um token de acesso da Meta. Para WhatsApp apenas para marketing, escolha SMS como canal principal de OTP e mantenha o conector habilitado.",
    "whatsapp.notice.saved": "Configurações do conector do WhatsApp salvas para este inquilino.",
    "WhatsApp connector settings saved for this tenant.": "Configurações do conector do WhatsApp salvas para este inquilino.",
    "whatsapp.error.save": "Não é possível salvar as configurações do WhatsApp.",
    "whatsapp.notice.discarded": "Rascunho descartado.",
    "Draft discarded.": "Rascunho descartado.",
    "whatsapp.test.title": "Enviar uma mensagem de teste",
    "Send a test message": "Enviar uma mensagem de teste",
    "whatsapp.test.description": "Envie um modelo aprovado para qualquer número do WhatsApp para verificar se sua conexão funciona.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Envie um modelo aprovado para qualquer número do WhatsApp para verificar se sua conexão funciona.",
    "whatsapp.test.refresh": "Atualizar modelos",
    "Refresh templates": "Atualizar modelos",
    "whatsapp.test.field.template": "Modelo aprovado",
    "Approved template": "Modelo aprovado",
    "whatsapp.test.field.parameter": "Valor para {{{number}}}",
    "Value for {{{number}}}": "Valor para {{{number}}}",
    "whatsapp.test.field.mobile": "Enviar para",
    "Send to": "Enviar para",
    "whatsapp.test.field.mobile_help": "Número do WhatsApp com o código do país.",
    "WhatsApp number with country code.": "Número do WhatsApp com o código do país.",
    "whatsapp.test.action.send": "Enviar mensagem de teste",
    "Send test message": "Enviar mensagem de teste",
    "whatsapp.test.sent": "Enviado para {mobile}. ID da mensagem da Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Enviado para {mobile}. ID da mensagem da Meta: {id}",
    "whatsapp.test.no_templates": "Ainda não há modelos aprovados. Ative um modelo acima e envie quando a Meta aprová-lo.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Ainda não há modelos aprovados. Ative um modelo acima e envie quando a Meta aprová-lo.",
    "common.discard_draft": "Descartar rascunho",
    "common.status.connected": "Conectado",
    "Connected": "Conectado",
    "extensions.title": "Extensões",
    "extensions.action.add": "Adicionar Extensão",
    "Add Extension": "Adicionar Extensão",
    "extensions.action.add_new": "Adicionar Nova Extensão",
    "Add New Extension": "Adicionar Nova Extensão",
    "extensions.action.edit": "Editar Extensão",
    "Edit Extension": "Editar Extensão",
    "extensions.action.delete": "Excluir extensão",
    "Delete extension": "Excluir extensão",
    "extensions.field.name": "Nome",
    "extensions.field.domain": "Domínio",
    "extensions.field.configs": "Configurações",
    "Configs": "Configurações",
    "extensions.placeholder.name": "Nome da extensão",
    "Extension Name": "Nome da extensão",
    "extensions.placeholder.domain": "Domínio da extensão",
    "Extension Domain": "Domínio da extensão",
    "extensions.empty": "Nenhuma extensão configurada ainda.",
    "No extensions configured yet.": "Nenhuma extensão configurada ainda.",
    "extensions.toast.added": "Extensão adicionada com sucesso.",
    "Extension added successfully.": "Extensão adicionada com sucesso.",
    "extensions.toast.updated": "Extensión atualizada com sucesso.",
    "Extension updated successfully.": "Extensión atualizada com sucesso.",
    "extensions.toast.deleted": "Extensión excluída com sucesso.",
    "Extension deleted successfully.": "Extensión excluída com sucesso.",
    "extensions.error.name_required": "Nome é obrigatório.",
    "extensions.error.domain_required": "Domínio é obrigatório",
    "Domain is required": "Domínio é obrigatório",
    "extensions.error.configs_required": "Configurações são obrigatórias",
    "Configs is required": "Configurações são obrigatórias",
    "extensions.error.save_failed": "Não é possível salvar a extensão.",
    "Unable to save the extension.": "Não é possível salvar a extensão.",
    "extensions.error.delete_failed": "Não é possível excluir a extensão.",
    "Unable to delete the extension.": "Não é possível excluir a extensão.",
    "automation_rules.kicker": "Automação de operações",
    "Operations automation": "Automação de operações",
    "automation_rules.title": "Regras de automação",
    "Automation rules": "Regras de automação",
    "automation_rules.description": "Transforme eventos de equipe e despesas em etapas claras de aprovação e revisão.",
    "Turn staff and expense events into clear approval and review steps.": "Transforme eventos de equipe e despesas em etapas claras de aprovação e revisão.",
    "automation_rules.action.new_rule": "Nova regra",
    "New rule": "Nova regra",
    "automation_rules.action.create_rule": "Criar regra",
    "Create rule": "Criar regra",
    "automation_rules.action.create_help": "Salve este gatilho, condições e ação como regra",
    "Save this trigger, conditions, and action as a rule": "Salve este gatilho, condições e ação como regra",
    "automation_rules.action.add_condition": "Adicionar condição",
    "Add condition": "Adicionar condição",
    "automation_rules.action.add_condition_help": "Adicionar outra condição a esta regra",
    "Add another condition to this rule": "Adicionar outra condição a esta regra",
    "automation_rules.action.remove_condition": "Remover condição",
    "Remove condition": "Remover condição",
    "automation_rules.action.choose": "Escolher uma ação",
    "Choose an action": "Escolher uma ação",
    "automation_rules.action.require_second_approver": "Requerir segundo aprovador",
    "Require second approver": "Requerir segundo aprovador",
    "automation_rules.action.require_second_approver_help": "Encaminhe a reclamação para outro aprovador.",
    "Route the claim to another approver.": "Encaminhe a reclamação para outro aprovador.",
    "automation_rules.action.auto_reject_expense": "Rejeitar automaticamente a despesa",
    "Auto-reject expense": "Rejeitar automaticamente a despesa",
    "automation_rules.action.auto_reject_expense_help": "Rejeite a despesa com uma razão.",
    "Reject the expense with a reason.": "Rejeite a despesa com uma razão.",
    "automation_rules.action.notify_role": "Notificar um papel",
    "Notify a role": "Notificar um papel",
    "automation_rules.action.notify_role_help": "Envie uma notificação para um papel de equipe.",
    "Send a notification to a staff role.": "Envie uma notificação para um papel de equipe.",
    "automation_rules.action.flag_for_review": "Marcar para revisão",
    "Flag for review": "Marcar para revisão",
    "automation_rules.action.flag_for_review_help": "Marque um recurso para revisão manual.",
    "Mark a resource for manual review.": "Marque um recurso para revisão manual.",
    "automation_rules.field.rule_name": "Nome da regra",
    "Rule name": "Nome da regra",
    "automation_rules.field.priority": "Prioridade",
    "automation_rules.field.module": "Módulo",
    "Module": "Módulo",
    "automation_rules.field.event": "Evento",
    "automation_rules.field.field": "Campo",
    "Field": "Campo",
    "automation_rules.field.operator": "Operador",
    "Operator": "Operador",
    "automation_rules.field.value": "Valor",
    "automation_rules.field.action": "Ação",
    "automation_rules.field.action_params": "Parâmetros de ação",
    "Action parameters": "Parâmetros de ação",
    "automation_rules.placeholder.rule_name": "Requerir segundo aprovador para reclamações grandes",
    "Require second approver for large claims": "Requerir segundo aprovador para reclamações grandes",
    "automation_rules.placeholder.field": "valor",
    "amount": "valor",
    "automation_rules.placeholder.value": "500 ou false",
    "500 or false": "500 ou false",
    "automation_rules.builder.description": "Construa o gatilho, condições e ação abaixo, depois salve-os como uma regra.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Construa o gatilho, condições e ação abaixo, depois salve-os como uma regra.",
    "automation_rules.error.load": "Não é possível carregar as regras de automação.",
    "Unable to load automation rules.": "Não é possível carregar as regras de automação.",
    "automation_rules.error.required_fields": "Nome, módulo, evento e ação são obrigatórios.",
    "Name, module, event, and action are required.": "Nome, módulo, evento e ação são obrigatórios.",
    "automation_rules.error.create": "Não é possível criar a regra de automação.",
    "Unable to create automation rule.": "Não é possível criar a regra de automação.",
    "automation_rules.error.valid_json": "Use JSON válido antes de salvar.",
    "Use valid JSON before saving.": "Use JSON válido antes de salvar.",
    "automation_rules.notice.created": "Regra de automação criada.",
    "Automation rule created.": "Regra de automação criada.",
    "automation_rules.notice.discarded": "Rascunho descartado.",
    "automation_rules.draft.restored": "O rascunho não salvo da regra de automação foi restaurado.",
    "Your unsaved automation rule draft was restored.": "O rascunho não salvo da regra de automação foi restaurado.",
    "automation_rules.list.title": "Regras",
    "automation_rules.list.count": "{count} configuradas",
    "{count} configured": "{count} configuradas",
    "automation_rules.list.loading": "Carregando regras…",
    "Loading rules…": "Carregando regras…",
    "automation_rules.list.unnamed": "Regra sem nome",
    "Unnamed rule": "Regra sem nome",
    "automation_rules.list.no_action": "Nenhuma ação configurada",
    "No action configured": "Nenhuma ação configurada",
    "automation_rules.list.empty": "Ainda não há regras. Crie a primeira a partir do diagrama.",
    "No rules yet. Create the first one from the diagram.": "Ainda não há regras. Crie a primeira a partir do diagrama.",
    "automation_rules.status.draft": "Rascunho",
    "automation_rules.status.active": "Ativo",
    "automation_rules.inspector.title": "Configuração do bloco",
    "Block settings": "Configuração do bloco",
    "automation_rules.inspector.diagram": "Diagrama",
    "Diagram": "Diagrama",
    "automation_rules.inspector.select_block": "Selecione um bloco no diagrama para configurá-lo.",
    "Select a block on the diagram to configure it.": "Selecione um bloco no diagrama para configurá-lo.",
    "automation_rules.inspector.no_configuration": "Este bloco não requer configuração.",
    "This block does not need configuration.": "Este bloco não requer configuração.",
    "automation_rules.node.trigger": "Gatilho",
    "automation_rules.node.condition": "Condição",
    "automation_rules.node.action": "Ação",
    "automation_rules.node.end": "Fim",
    "automation_rules.node.completed": "Concluído",
    "automation_rules.node.finished": "Avaliação da regra concluída",
    "Rule evaluation finished": "Avaliação da regra concluída",
    "automation_rules.trigger.choose_event": "Escolha um evento",
    "Choose an event": "Escolha um evento",
    "automation_rules.trigger.module": "módulo",
    "module": "módulo",
    "automation_rules.trigger.module_event": "Evento do {module}",
    "{module} event": "Evento do {module}",
    "automation_rules.trigger.help": "A regra é avaliada quando este evento é emitido pelo módulo.",
    "The rule evaluates when this event is emitted by the module.": "A regra é avaliada quando este evento é emitido pelo módulo.",
    "automation_rules.condition.label": "Condição",
    "automation_rules.condition.none": "Sem condições",
    "No conditions": "Sem condições",
    "automation_rules.condition.always_fires": "Sempre dispara",
    "Always fires": "Sempre dispara",
    "automation_rules.condition.empty_help": "Adicione uma condição para restringir esta regra.",
    "Add a condition to restrict this rule.": "Adicione uma condição para restringir esta regra.",
    "automation_rules.condition.value_required": "Valor necessário",
    "Value required": "Valor necessário",
    "automation_rules.condition.value": "Valor: {value}",
    "Value: {value}": "Valor: {value}",
    "automation_rules.operator.equals": "Igual a",
    "Equals": "Igual a",
    "automation_rules.operator.gt": "Maior que",
    "Greater than": "Maior que",
    "automation_rules.operator.gte": "Maior ou igual que",
    "Greater than or equal": "Maior ou igual que",
    "automation_rules.operator.lt": "Menor que",
    "Less than": "Menor que",
    "automation_rules.operator.exists": "Existe",
    "Exists": "Existe",
    "automation_rules.module.expenses": "Despesas",
    "automation_rules.module.staff": "Equipe",
    "automation_rules.event.expense.submitted": "Despesa enviada",
    "automation_rules.event.leave.requested": "Férias solicitadas",
    "Leave requested": "Férias solicitadas",
    "automation_rules.event.payroll_run.created": "Lote de folha de pagamento criado",
    "automation_rules.meta.conditions": "{count} condição(ões) · todas devem corresponder antes da ação ser executada",
    "{count} condition(s) · all must match before the action runs": "{count} condição(ões) · todas devem corresponder antes da ação ser executada",
    "automation_rules.meta.no_conditions": "Sem condições · a ação sempre é executada após o gatilho",
    "No conditions · the action always runs after the trigger": "Sem condições · a ação sempre é executada após o gatilho",
    "automation_rules.draft.unsaved": "Você tem um rascunho de regra de automação não salvo.",
    "You have an unsaved automation rule draft.": "Você tem um rascunho de regra de automação não salvo.",
    "automation_rules.meta.one_condition": "1 condição · todas devem corresponder antes da ação ser executada",
    "1 condition · all must match before the action runs": "1 condição · todas devem corresponder antes da ação ser executada",
    "automation_rules.meta.many_conditions": "{count} condições · todas devem corresponder antes da ação ser executada",
    "{count} conditions · all must match before the action runs": "{count} condições · todas devem corresponder antes da ação ser executada",
    "cms.type.page": "Página",
    "Page": "Página",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Documentos",
    "Docs": "Documentos",
    "cms.type.pages": "Páginas",
    "cms.type.blogs": "Blogs",
    "Blogs": "Blogs",
    "cms.action.add_content": "Adicionar conteúdo",
    "Add content": "Adicionar conteúdo",
    "cms.action.add_type": "Adicionar {type}",
    "cms.action.create_type": "Criar {type}",
    "Create {type}": "Criar {type}",
    "cms.action.edit": "Editar",
    "cms.action.duplicate": "Duplicar",
    "Duplicate": "Duplicar",
    "cms.action.open": "Abrir",
    "cms.field.title": "Título",
    "cms.field.slug": "Slug",
    "cms.field.content": "Conteúdo",
    "cms.field.meta_title": "Meta título",
    "cms.field.meta_description": "Meta descrição",
    "cms.placeholder.title": "Ex.: Sobre nós",
    "e.g. About us": "Ex.: Sobre nós",
    "cms.placeholder.slug": "sobre-nos",
    "about-us": "sobre-nos",
    "cms.placeholder.page_title": "Título da página",
    "Page title": "Título da página",
    "cms.placeholder.page_slug": "slug-da-página",
    "page-slug": "slug-da-página",
    "cms.placeholder.content": "Escreva seu conteúdo aqui…",
    "Write your content here…": "Escreva seu conteúdo aqui…",
    "cms.placeholder.meta_title": "Padrão para título",
    "Defaults to title": "Padrão para título",
    "cms.placeholder.meta_description": "Descrição curta para motores de busca",
    "Short description for search engines": "Descrição curta para motores de busca",
    "cms.section.seo_optional": "SEO (opcional)",
    "SEO (optional)": "SEO (opcional)",
    "cms.error.title_required": "O título é obrigatório.",
    "Title is required.": "O título é obrigatório.",
    "cms.error.content_required": "Adicione conteúdo antes de salvar.",
    "Add some content before saving.": "Adicione conteúdo antes de salvar.",
    "cms.error.create": "Falha ao criar. Tente novamente.",
    "Failed to create. Please try again.": "Falha ao criar. Tente novamente.",
    "cms.error.save": "Falha ao salvar.",
    "Failed to save.": "Falha ao salvar.",
    "cms.error.load_layer": "Não foi possível carregar esta camada.",
    "Could not load this layer.": "Não foi possível carregar esta camada.",
    "cms.toast.created": "{type} criado com sucesso.",
    "{type} created successfully.": "{type} criado com sucesso.",
    "cms.toast.saved": "Salvo",
    "Saved": "Salvo",
    "cms.toast.changes_saved": "Alterações salvas.",
    "Changes saved.": "Alterações salvas.",
    "cms.toast.deleted": "Excluído",
    "cms.toast.duplicated": "Duplicado",
    "Duplicated": "Duplicado",
    "cms.error.delete": "Falha ao excluir.",
    "Failed to delete": "Falha ao excluir.",
    "cms.error.duplicate": "Falha ao duplicar",
    "Failed to duplicate": "Falha ao duplicar",
    "cms.confirm.delete": "Excluir \"{title}\"?",
    "Delete \"{title}\"?": "Excluir \"{title}\"?",
    "cms.duplicate.title": "{title} (cópia)",
    "{title} (copy)": "{title} (cópia)",
    "cms.draft.restored": "O rascunho não salvo foi restaurado.",
    "Your unsaved content draft was restored.": "O rascunho não salvo foi restaurado.",
    "cms.search": "Pesquisar…",
    "Search…": "Pesquisar…",
    "cms.list.no_results": "Nenhum resultado encontrado.",
    "No results found.": "Nenhum resultado encontrado.",
    "cms.list.empty_type": "Ainda não há {type}.",
    "No {type} yet.": "Ainda não há {type}.",
    "cms.list.untitled": "Sem título",
    "Untitled": "Sem título",
    "cms.editor.placeholder": "Escreva seu conteúdo aqui…",
    "cms.editor.normal_text": "Texto normal",
    "Normal text": "Texto normal",
    "cms.editor.heading": "Título {level}",
    "Heading {level}": "Título {level}",
    "cms.editor.align_left": "Alinhar à esquerda",
    "Align Left": "Alinhar à esquerda",
    "cms.editor.align_center": "Centralizar",
    "Align Center": "Centralizar",
    "cms.editor.align_right": "Alinhar à direita",
    "Align Right": "Alinhar à direita",
    "cms.editor.insert_table": "Inserir tabela",
    "Insert table": "Inserir tabela",
    "cms.editor.add_column": "Adicionar coluna",
    "Add column": "Adicionar coluna",
    "cms.editor.add_row": "Adicionar linha",
    "Add row": "Adicionar linha",
    "cms.editor.delete_table": "Excluir tabela",
    "Delete table": "Excluir tabela",
    "cms.editor.delete_column": "Excluir coluna",
    "Delete column": "Excluir coluna",
    "cms.editor.delete_row": "Excluir linha",
    "Delete row": "Excluir linha",
    "cms.editor.underline": "Sublinhar",
    "Underline": "Sublinhar",
    "cms.editor.strikethrough": "Riscar",
    "Strikethrough": "Riscar",
    "cms.editor.code": "Código",
    "cms.editor.code_block": "Bloco de código",
    "Code block": "Bloco de código",
    "cms.editor.subscript": "Subscrito",
    "Subscript": "Subscrito",
    "cms.editor.superscript": "Sobrescrito",
    "Superscript": "Sobrescrito",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL da imagem",
    "Image URL": "URL da imagem",
    "cms.editor.prompt.youtube_url": "URL do YouTube",
    "YouTube URL": "URL do YouTube",
    "cms.editor.undo": "Desfazer",
    "cms.editor.redo": "Refazer",
    "cms.editor.table": "Tabela",
    "Table": "Tabela",
    "cms.editor.more": "Mais",
    "cms.editor.bold": "Negrito",
    "Bold": "Negrito",
    "cms.editor.italic": "Itálico",
    "Italic": "Itálico",
    "cms.editor.bullet_list": "Lista de marcadores",
    "Bullet list": "Lista de marcadores",
    "cms.editor.ordered_list": "Lista ordenada",
    "Ordered list": "Lista ordenada",
    "cms.editor.task_list": "Lista de tarefas",
    "Task list": "Lista de tarefas",
    "cms.editor.link": "Link",
    "Link": "Link",
    "cms.editor.image": "Imagem",
    "cms.editor.text_color": "Cor do texto",
    "Text color": "Cor do texto",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Páginas",
    "cms.test.type.pages_description": "Páginas de destino e conteúdo estruturado para lojas.",
    "Landing pages and structured storefront content.": "Páginas de destino e conteúdo estruturado para lojas.",
    "cms.test.type.blogs": "Blogs",
    "cms.test.type.blogs_description": "Artigos, histórias e atualizações para sua audiência.",
    "Articles, stories, and updates for your audience.": "Artigos, histórias e atualizações para sua audiência.",
    "cms.test.type.docs": "Documentos",
    "cms.test.type.docs_description": "Documentação, guias e conteúdo de ajuda.",
    "Documentation, guides, and help content.": "Documentação, guias e conteúdo de ajuda.",
    "cms.test.operation.list": "Listar conteúdo por tipo",
    "List content by type": "Listar conteúdo por tipo",
    "cms.test.operation.fetch": "Buscar uma Camada",
    "Fetch one Layer": "Buscar uma Camada",
    "cms.test.operation.create": "Criar uma Camada",
    "Create a Layer": "Criar uma Camada",
    "cms.test.operation.update": "Atualizar uma Camada",
    "Update a Layer": "Atualizar uma Camada",
    "cms.test.operation.delete": "Excluir uma Camada",
    "Delete a Layer": "Excluir uma Camada",
    "cms.test.operation.search": "Buscar conteúdo",
    "Search content": "Buscar conteúdo",
    "cms.test.operation.categories": "Carregar categorias",
    "Load categories": "Carregar categorias",
    "cms.test.operation.translations": "Salvar traduções",
    "Save translations": "Salvar traduções",
    "cms.test.editor.placeholder": "Escreva seu conteúdo de página...",
    "Write your page content...": "Escreva seu conteúdo de página...",
    "cms.test.error.load_type": "Não é possível carregar o conteúdo {type}",
    "Unable to load {type} content": "Não é possível carregar o conteúdo {type}",
    "cms.test.error.load": "Não é possível carregar o conteúdo CMS.",
    "Unable to load CMS content.": "Não é possível carregar o conteúdo CMS.",
    "cms.test.error.required": "Adicione um título e conteúdo de página antes de salvar.",
    "Add a page title and content before saving.": "Adicione um título e conteúdo de página antes de salvar.",
    "cms.test.error.create": "Não é possível criar esta página.",
    "Unable to create this page.": "Não é possível criar esta página.",
    "cms.test.toast.created": "Página criada com sucesso.",
    "Page created successfully.": "Página criada com sucesso.",
    "cms.test.hero.eyebrow": "GERENCIAMENTO DE CONTEÚDO",
    "CONTENT MANAGEMENT": "GERENCIAMENTO DE CONTEÚDO",
    "cms.test.hero.title": "Layers CMS",
    "Layers CMS": "Layers CMS",
    "cms.test.hero.description": "Crie conteúdo estruturado uma vez, depois disponibilize-o em sua loja, aplicativos e experiências personalizadas.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Crie conteúdo estruturado uma vez, depois disponibilize-o em sua loja, aplicativos e experiências personalizadas.",
    "cms.test.hero.live_workspace": "Espaço de trabalho ao vivo: {tenant} · visualização somente leitura",
    "Live workspace: {tenant} · read-only preview": "Espaço de trabalho ao vivo: {tenant} · visualização somente leitura",
    "cms.test.current_tenant": "inquilino atual",
    "current tenant": "inquilino atual",
    "cms.test.content.title": "Seu conteúdo",
    "Your content": "Seu conteúdo",
    "cms.test.content.description": "Páginas, blogs e documentos estão prontos para gerenciar em um único local.",
    "Pages, blogs, and docs are ready to manage from one place.": "Páginas, blogs e documentos estão prontos para gerenciar em um único local.",
    "cms.test.action.create_page": "Criar Página",
    "Create Page": "Criar Página",
    "cms.test.form.description": "Crie conteúdo de página estruturado no Layers. A página ficará disponível através da API após salvar.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Crie conteúdo de página estruturado no Layers. A página ficará disponível através da API após salvar.",
    "cms.test.placeholder.slug": "about-us (opcional)",
    "about-us (optional)": "about-us (opcional)",
    "cms.test.draft.unsaved": "Você tem um rascunho de página não salvo.",
    "You have an unsaved page draft.": "Você tem um rascunho de página não salvo.",
    "cms.test.loading": "Carregando conteúdo de Layers ao vivo…",
    "Loading live Layers content…": "Carregando conteúdo de Layers ao vivo…",
    "cms.test.content.empty_title": "Ainda não há {type}",
    "No {type} yet": "Ainda não há {type}",
    "cms.test.content.empty_description": "Crie seu primeiro Layer no espaço de trabalho para vê-lo aqui.",
    "Create your first Layer in the workspace to see it here.": "Crie seu primeiro Layer no espaço de trabalho para vê-lo aqui.",
    "cms.test.feature.types": "Tipos de conteúdo personalizados",
    "Custom content types": "Tipos de conteúdo personalizados",
    "cms.test.feature.types_description": "Páginas, blogs e documentos são pontos de partida. Defina um Post ou qualquer outro modelo que sua empresa precise.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Páginas, blogs e documentos são pontos de partida. Defina um Post ou qualquer outro modelo que sua empresa precise.",
    "cms.test.feature.structured": "Estruturado e localizado por padrão",
    "Structured and localized": "Estruturado e localizado por padrão",
    "cms.test.feature.structured_description": "Use slugs, categorias, imagens, metadados SEO e traduções para a mesma fonte de conteúdo.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Use slugs, categorias, imagens, metadados SEO e traduções para a mesma fonte de conteúdo.",
    "cms.test.feature.headless": "Headless por padrão",
    "Headless by default": "Headless por padrão",
    "cms.test.feature.headless_description": "Use a API de Layers em um site, aplicativo móvel, ferramenta interna ou frontend personalizado.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Use a API de Layers em um site, aplicativo móvel, ferramenta interna ou frontend personalizado.",
    "cms.test.feature.ai": "Fonte de conhecimento de IA",
    "AI knowledge source": "Fonte de conhecimento de IA",
    "cms.test.feature.ai_description": "Envie o conteúdo do Tradly CMS para o iRyxo Agent Builder como fonte de conhecimento.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Envie o conteúdo do Tradly CMS para o iRyxo Agent Builder como fonte de conhecimento.",
    "cms.test.community.eyebrow": "CONTEÚDO DA COMUNIDADE",
    "COMMUNITY CONTENT": "CONTEÚDO DA COMUNIDADE",
    "cms.test.community.title": "Transforme Layers em um feed social",
    "Turn Layers into a social feed": "Transforme Layers em um feed social",
    "cms.test.community.description": "Crie um tipo de Post personalizado, permita que os usuários publiquem atualizações e adicione interação através do seu frontend.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Crie um tipo de Post personalizado, permita que os usuários publiquem atualizações e adicione interação através do seu frontend.",
    "cms.test.community.share_placeholder": "Compartilhe uma atualização…",
    "Share an update…": "Compartilhe uma atualização…",
    "cms.test.community.post": "Publicar",
    "Post": "Publicar",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Uma atualização de comunidade publicada a partir de uma Layer personalizada.",
    "A community update published from a custom Layer.": "Uma atualização de comunidade publicada a partir de uma Layer personalizada.",
    "cms.test.community.sample_actions": "♡ 24 · 💬 6 comentários · ↗ Compartilhar",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24 · 💬 6 comentários · ↗ Compartilhar",
    "cms.test.community.endpoints": "Exemplos de endpoints",
    "Example endpoints": "Exemplos de endpoints",
    "cms.test.developer.eyebrow": "ACESSO PARA DESENVOLVEDORES",
    "DEVELOPER ACCESS": "ACESSO PARA DESENVOLVEDORES",
    "cms.test.developer.title": "API de Layers",
    "Layers API": "API de Layers",
    "cms.test.developer.docs": "Documentação para desenvolvedores",
    "Developer docs": "Documentação para desenvolvedores",
    "auth.title": "Autenticação",
    "auth.sign_in_method": "Método de login",
    "auth.facebook_auth": "Autenticação do Facebook",
    "auth.google_auth": "Autenticação do Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "SSO empresarial",
    "Enterprise SSO": "SSO empresarial",
    "auth.admob": "Admob",
    "Admob": "Admob",
    "checkout.title": "Configuração de checkout",
    "Checkout Settings": "Configuração de checkout",
    "checkout.orders": "Pedidos",
    "checkout.carts": "Carrinhos",
    "Carts": "Carrinhos",
    "audit_logs.action": "Ação",
    "audit_logs.resource": "Recurso",
    "audit_logs.resource_id": "ID do recurso",
    "Resource ID": "ID do recurso",
    "audit_logs.agent_id": "ID do agente",
    "Agent ID": "ID do agente",
    "audit_logs.result": "Resultado",
    "audit_logs.actor_id": "ID do ator",
    "Actor ID": "ID do ator",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Marca de tempo",
    "Timestamp": "Marca de tempo",
    "audit_logs.succeeded": "Sucesso",
    "audit_logs.failed": "Falha",
    "audit_logs.source": "Origem",
    "audit_logs.all_sources": "Todas as fontes",
    "All sources": "Todas as fontes",
    "audit_logs.human_admin": "Humano (admin)",
    "Human (admin)": "Humano (admin)",
    "audit_logs.agent_mcp": "Agente (MCP)",
    "Agent (MCP)": "Agente (MCP)",
    "audit_logs.all_actions": "Todas as ações",
    "All actions": "Todas as ações",
    "audit_logs.from": "De",
    "audit_logs.to": "Até",
    "audit_logs.apply": "Aplicar",
    "audit_logs.clear": "Limpar",
    "audit_logs.export_csv": "Exportar CSV",
    "audit_logs.exporting": "Exportando…",
    "audit_logs.title": "Registros de auditoria",
    "audit_logs.empty_title": "Nenhum registro de auditoria encontrado",
    "No audit logs found": "Nenhum registro de auditoria encontrado",
    "audit_logs.empty_subtitle": "Tente ajustar seus filtros",
    "Try adjusting your filters": "Tente ajustar seus filtros",
    "audit_logs.restriction_notice": "Mostrando os últimos 5 registros de auditoria. Atualize para Growth para ver o histórico completo e exportar registros.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Mostrando os últimos 5 registros de auditoria. Atualize para Growth para ver o histórico completo e exportar registros.",
    "audit_logs.extended_history": "Histórico estendido de registros de auditoria",
    "Extended audit log history": "Histórico estendido de registros de auditoria",
    "manage_features.title": "Gerenciar recursos",
    "manage_features.general": "Geral",
    "manage_features.apps": "Aplicativos",
    "manage_features.marketplace": "Marketplace",
    "manage_features.commerce": "Comércio",
    "manage_features.channels": "Canais",
    "manage_features.left_menu": "Menu esquerdo",
    "Left Menu": "Menu esquerdo",
    "manage_features.right_sidepanel": "Painel lateral direito",
    "Right Sidepanel": "Painel lateral direito",
    "workflow.integration": "Integração",
    "workflow.no_url_title": "Sem URL de integração",
    "No Integration URL": "Sem URL de integração",
    "workflow.no_url_description": "Configure a URL de integração.",
    "Please configure the integration URL.": "Configure a URL de integração.",
    "workflow.back": "Voltar",
    "Go Back": "Voltar",
    "workflow.loading": "Carregando integração...",
    "Loading integration...": "Carregando integração...",
    "workflow.loading_hint": "Aguarde enquanto conectamos",
    "Please wait while we connect": "Aguarde enquanto conectamos",
    "workflow.error_title": "Erro de integração",
    "Integration Error": "Erro de integração",
    "workflow.error_description": "Não é possível carregar a integração. Verifique sua conexão e tente novamente.",
    "Unable to load the integration. Please check your connection and try again.": "Não é possível carregar a integração. Verifique sua conexão e tente novamente.",
    "workflow.retry": "Tentar novamente",
    "Try Again": "Tentar novamente",
    "upgrade_preview.eyebrow": "Visualização do componente",
    "Component preview": "Visualização do componente",
    "upgrade_preview.title": "Experiência de atualização",
    "Upgrade experience": "Experiência de atualização",
    "upgrade_preview.description": "Uma porta de características compartida focada no que um cliente pode alcançar após atualizar.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Uma porta de características compartida focada no que um cliente pode alcançar após atualizar.",
    "upgrade_preview.feature": "Adicionar uma variante",
    "Add a variant": "Adicionar uma variante",
    "upgrade_preview.context": "Este é o ponto atual onde um usuário do plano Básico atinge o limite da funcionalidade.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Este é o ponto atual onde um usuário do plano Básico atinge o limite da funcionalidade.",
    "upgrade_preview.button": "Visualização do painel de atualização",
    "Preview upgrade panel": "Visualização do painel de atualização",
    "upgrade_preview.listing_context": "Para esta lista",
    "For this listing": "Para esta lista",
    "gamification_test.eyebrow": "GAMIFICAÇÃO DE CRESCIMENTO · ROTA DE TESTE",
    "GROWTH GAMIFICATION · TEST ROUTE": "GAMIFICAÇÃO DE CRESCIMENTO · ROTA DE TESTE",
    "gamification_test.title": "Construa impulso para seu negócio",
    "Build momentum for your business": "Construa impulso para seu negócio",
    "gamification_test.subtitle": "Pré-visualização de missões, moedas, medalhas e sequências para {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Pré-visualização de missões, moedas, medalhas e sequências para {workspace}.",
    "gamification_test.this_workspace": "este espaço de trabalho",
    "this workspace": "este espaço de trabalho",
    "gamification_test.coins": "MOEDAS",
    "COINS": "MOEDAS",
    "gamification_test.points": "PONTOS",
    "POINTS": "PONTOS",
    "gamification_test.streak": "SÉRIE",
    "STREAK": "SÉRIE",
    "gamification_test.week": "1 semana",
    "1 week": "1 semana",
    "gamification_test.launch": "Caminho de lançamento",
    "Launch path": "Caminho de lançamento",
    "gamification_test.progress": "{completed} de {total} ações concluídas · até {coins} moedas",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} de {total} ações concluídas · até {coins} moedas",
    "gamification_test.done": "Concluído",
    "gamification_test.reward": "+{count} moedas",
    "+{count} coins": "+{count} moedas",
    "gamification_test.badges": "Emblemas",
    "Badges": "Emblemas",
    "gamification_test.mission_listing_created": "Crie seu primeiro catálogo",
    "Create your first listing": "Crie seu primeiro catálogo",
    "gamification_test.mission_collection_created": "Crie sua primeira coleção",
    "Create your first collection": "Crie sua primeira coleção",
    "gamification_test.mission_payment_configured": "Configure pagamentos",
    "Configure payments": "Configure pagamentos",
    "gamification_test.mission_publish_completed": "Publique seu site",
    "Publish your site": "Publique seu site",
    "gamification_test.mission_analytics_enabled": "Habilite análises",
    "Enable analytics": "Habilite análises",
    "gamification_test.badge_first_step": "Primeiro passo",
    "First Step": "Primeiro passo",
    "gamification_test.badge_catalog_builder": "Construtor de catálogo",
    "Catalog Builder": "Construtor de catálogo",
    "gamification_test.badge_ready_to_sell": "Pronto para vender",
    "Ready to Sell": "Pronto para vender",
    "gamification_test.badge_data_driven": "Baseado em dados",
    "Data Driven": "Baseado em dados",
    "gamification_test.badge_growth_operator": "Operador de crescimento",
    "Growth Operator": "Operador de crescimento",
    "sentry_check.title": "Verificação de configuração do Sentry",
    "Sentry Configuration Check": "Verificação de configuração do Sentry",
    "sentry_check.subtitle": "Teste e verifique a configuração de rastreamento de erros do Sentry",
    "Test and verify Sentry error tracking setup": "Teste e verifique a configuração de rastreamento de erros do Sentry",
    "sentry_check.configuration": "Configuração",
    "sentry_check.check_configuration": "Ver configuração",
    "Check Configuration": "Ver configuração",
    "sentry_check.status": "Status:",
    "Status:": "Status:",
    "sentry_check.enabled": "✓ Habilitado",
    "✓ Enabled": "✓ Habilitado",
    "sentry_check.disabled": "✗ Desabilitado",
    "✗ Disabled": "✗ Desabilitado",
    "sentry_check.environment": "Ambiente:",
    "Environment:": "Ambiente:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Taxa de amostragem de rastreamento:",
    "Traces Sample Rate:": "Taxa de amostragem de rastreamento:",
    "sentry_check.test_functions": "Funções de teste",
    "Test Functions": "Funções de teste",
    "sentry_check.test_hint": "Clique nos botões abaixo para testar diferentes funcionalidades do Sentry. Verifique seu painel do Sentry para verificar se os eventos estão sendo capturados.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Clique nos botões abaixo para testar diferentes funcionalidades do Sentry. Verifique seu painel do Sentry para verificar se os eventos estão sendo capturados.",
    "sentry_check.test_results": "Resultados do teste",
    "Test Results": "Resultados do teste",
    "sentry_check.clear": "Limpar",
    "sentry_check.no_tests": "Nenhuma prova executada ainda",
    "No tests run yet": "Nenhuma prova executada ainda",
    "sentry_check.important_notes": "⚠️ Notas importantes",
    "⚠️ Important Notes": "⚠️ Notas importantes",
    "sentry_check.warning_real_events": "• Essas provas criarão eventos de erro reais no seu painel Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Essas provas criarão eventos de erro reais no seu painel Sentry",
    "sentry_check.warning_dashboard": "• Verifique seu painel Sentry para verificar se os eventos estão sendo capturados",
    "• Check your Sentry dashboard to verify events are being captured": "• Verifique seu painel Sentry para verificar se os eventos estão sendo capturados",
    "sentry_check.warning_traces": "• Algumas provas podem não aparecer no Sentry se tracesSampleRate for 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Algumas provas podem não aparecer no Sentry se tracesSampleRate for 0.0",
    "sentry_check.warning_dsn": "• Certifique-se de que seu DSN esteja configurado corretamente nas variáveis de ambiente",
    "• Make sure your DSN is correctly configured in environment variables": "• Certifique-se de que seu DSN esteja configurado corretamente nas variáveis de ambiente",
    "sentry_check.normal_error": "Erro Normal de Teste",
    "Test Normal Error": "Erro Normal de Teste",
    "sentry_check.test_normal_error": "Erro Normal de Teste",
    "sentry_check.test_message": "Mensagem de Teste",
    "Test Message": "Mensagem de Teste",
    "sentry_check.test_breadcrumb": "Pedaço de Teste",
    "Test Breadcrumb": "Pedaço de Teste",
    "sentry_check.test_user_context": "Contexto de Usuário de Teste",
    "Test User Context": "Contexto de Usuário de Teste",
    "sentry_check.test_custom_exception": "Exceção Personalizada de Teste",
    "Test Custom Exception": "Exceção Personalizada de Teste",
    "sentry_check.test_promise_rejection": "Rejeição de Promessa de Teste",
    "Test Promise Rejection": "Rejeição de Promessa de Teste",
    "sentry_check.configuration_check": "Verificação de Configuração",
    "Configuration Check": "Verificação de Configuração",
    "sentry_check.config_loaded": "Configuração carregada com sucesso",
    "Config loaded successfully": "Configuração carregada com sucesso",
    "sentry_check.error_captured": "Erro capturado e enviado para o Sentry",
    "Error captured and sent to Sentry": "Erro capturado e enviado para o Sentry",
    "sentry_check.error_capture_failed": "Falha ao capturar erro: {message}",
    "Failed to capture error: {message}": "Falha ao capturar erro: {message}",
    "sentry_check.message": "Mensagem",
    "Message": "Mensagem",
    "sentry_check.message_captured": "Mensagem capturada e enviada para o Sentry",
    "Message captured and sent to Sentry": "Mensagem capturada e enviada para o Sentry",
    "sentry_check.message_capture_failed": "Falha ao capturar mensagem: {message}",
    "Failed to capture message: {message}": "Falha ao capturar mensagem: {message}",
    "sentry_check.breadcrumb": "Pedaço",
    "Breadcrumb": "Pedaço",
    "sentry_check.breadcrumb_added": "Pedaço adicionado ao contexto do Sentry",
    "Breadcrumb added to Sentry context": "Pedaço adicionado ao contexto do Sentry",
    "sentry_check.breadcrumb_failed": "Falha ao adicionar pedaço: {message}",
    "Failed to add breadcrumb: {message}": "Falha ao adicionar pedaço: {message}",
    "sentry_check.user_context": "Contexto do usuário",
    "User Context": "Contexto do usuário",
    "sentry_check.user_set": "Contexto do usuário definido no Sentry",
    "User context set in Sentry": "Contexto do usuário definido no Sentry",
    "sentry_check.user_failed": "Falha ao definir o contexto do usuário: {message}",
    "Failed to set user context: {message}": "Falha ao definir o contexto do usuário: {message}",
    "sentry_check.custom_exception": "Exceção personalizada",
    "Custom Exception": "Exceção personalizada",
    "sentry_check.custom_sent": "Exceção personalizada com contexto enviada para o Sentry",
    "Custom exception with context sent to Sentry": "Exceção personalizada com contexto enviada para o Sentry",
    "sentry_check.custom_failed": "Falha ao capturar exceção personalizada: {message}",
    "Failed to capture custom exception: {message}": "Falha ao capturar exceção personalizada: {message}",
    "sentry_check.promise_rejection": "Rejeição de promessa",
    "Promise Rejection": "Rejeição de promessa",
    "sentry_check.promise_captured": "Rejeição de promessa capturada e enviada para o Sentry",
    "Promise rejection captured and sent to Sentry": "Rejeição de promessa capturada e enviada para o Sentry",
    "sentry_check.promise_failed": "Falha ao lidar com rejeição de promessa: {message}",
    "Failed to handle promise rejection: {message}": "Falha ao lidar com rejeição de promessa: {message}",
    "checkout_settings.orders": "Pedidos",
    "checkout_settings.return_policy_days": "Dias da política de devolução",
    "Return policy days": "Dias da política de devolução",
    "checkout_settings.enter_return_policy_days": "Insira os dias da política de devolução",
    "Enter return policy days": "Insira os dias da política de devolução",
    "checkout_settings.saved": "Enviado com sucesso",
    "checkout_settings.cart": "Carrinho",
    "checkout_settings.hide_quantity_selection": "Ocultar seleção de quantidade (Padrão: Mostra campo para selecionar quantidade)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Ocultar seleção de quantidade (Padrão: Mostra campo para selecionar quantidade)",
    "checkout_settings.enable_coupon": "Habilitar Cupom",
    "Enable Coupon": "Habilitar Cupom",
    "upgrade_page.copy.a_practical_next_step": "Próximo passo prático",
    "A practical next step": "Próximo passo prático",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Adicione a informação estruturada que seu fluxo de trabalho precisa",
    "Add the structured information your workflow needs.": "Adicione a informação estruturada que seu fluxo de trabalho precisa",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Atribuir papéis e permissões a cada colega",
    "Assign roles and permissions to every teammate.": "Atribuir papéis e permissões a cada colega",
    "upgrade_page.copy.audit_log_export": "Exportar registro de auditoria",
    "Audit log export": "Exportar registro de auditoria",
    "upgrade_page.copy.best_next_step": "Próximo passo ideal",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Traga registros estruturados, faça alterações offline e exporte-os quando sua equipe precisar de uma cópia de trabalho completa",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Traga registros estruturados, faça alterações offline e exporte-os quando sua equipe precisar de uma cópia de trabalho completa",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Construir além da interface padrão",
    "Build beyond the standard interface": "Construir além da interface padrão",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Capture os detalhes que tornam seu catálogo útil",
    "Capture the details that make your catalogue useful.": "Capture os detalhes que tornam seu catálogo útil",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Escolha a flexibilidade para construir suas próprias experiências focadas no cliente sobre a Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Escolha a flexibilidade para construir suas próprias experiências focadas no cliente sobre a Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Combine listagens existentes em pacotes curados e permita que os clientes selecionem itens elegíveis no checkout.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Combine listagens existentes em pacotes curados e permita que os clientes selecionem itens elegíveis no checkout.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Configure as moedas necessárias para o seu negócio ao operar em várias regiões.",
    "Configure the currencies your business needs as you operate across regions.": "Configure as moedas necessárias para o seu negócio ao operar em várias regiões.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Conecte seu marketplace com ferramentas internas e automação quando o trabalho manual não escala mais.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Conecte seu marketplace com ferramentas internas e automação quando o trabalho manual não escala mais.",
    "upgrade_page.copy.connect_your_own_tools": "Conecte suas próprias ferramentas",
    "Connect your own tools": "Conecte suas próprias ferramentas",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Controle quem pode ver e alterar o que.",
    "Control who can see and change what.": "Controle quem pode ver e alterar o que.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Crie campos personalizados para os fatos que clientes e sua equipe precisam ver em cada lista ou conta.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Crie campos personalizados para os fatos que clientes e sua equipe precisam ver em cada lista ou conta.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Crie pacotes fixos e mix-and-match.",
    "Create fixed and mix-and-match bundles.": "Crie pacotes fixos e mix-and-match.",
    "upgrade_page.copy.custom_attributes": "Atributos personalizados",
    "Custom attributes": "Atributos personalizados",
    "upgrade_page.copy.custom_email_templates": "Modelos de e-mail personalizados",
    "Custom email templates": "Modelos de e-mail personalizados",
    "upgrade_page.copy.email_whitelabelling": "Branding de e-mail",
    "Email whitelabelling": "Branding de e-mail",
    "upgrade_page.copy.everything_in_growth": "Tudo no Growth",
    "Everything in Growth": "Tudo no Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Tudo no Growth, com os limites mais altos.",
    "Everything in Growth, with the highest limits.": "Tudo no Growth, com os limites mais altos.",
    "upgrade_page.copy.everything_in_starter": "Tudo no Starter",
    "Everything in Starter": "Tudo no Starter",
    "upgrade_page.copy.expand_your_workspace": "Expanda seu espaço de trabalho",
    "Expand your workspace": "Expanda seu espaço de trabalho",
    "upgrade_page.copy.feature_access": "Acesso a recursos",
    "Feature access": "Acesso a recursos",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Para um catálogo em crescimento que precisa de escolhas de produto mais claras.",
    "For a growing catalogue that needs clearer product choices.": "Para um catálogo em crescimento que precisa de escolhas de produto mais claras.",
    "upgrade_page.copy.for_established_businesses": "Para negócios estabelecidos",
    "For established businesses": "Para negócios estabelecidos",
    "upgrade_page.copy.for_growing_operations": "Para operações em crescimento",
    "For growing operations": "Para operações em crescimento",
    "upgrade_page.copy.for_growing_teams": "Para equipes em crescimento",
    "For growing teams": "Para equipes em crescimento",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Para equipes de alto volume que precisam de espaço para operar em escala.",
    "For high-volume teams that need room to operate at scale.": "Para equipes de alto volume que precisam de espaço para operar em escala.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Para equipes que gerenciam um catálogo maior e mais fluxos de trabalho.",
    "For teams managing a larger catalogue and more workflows.": "Para equipes que gerenciam um catálogo maior e mais fluxos de trabalho.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Para equipes prontas para trabalhar além de um registro por vez.",
    "For teams ready to work beyond one record at a time.": "Para equipes prontas para trabalhar além de um registro por vez.",
    "upgrade_page.copy.full_audit_history": "Histórico completo de auditoria",
    "Full audit history": "Histórico completo de auditoria",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Planos de crescimento e escala podem revisar o histórico completo de auditoria e exportá-lo para fluxos de trabalho de conformidade.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Planos de crescimento e escala podem revisar o histórico completo de auditoria e exportá-lo para fluxos de trabalho de conformidade.",
    "upgrade_page.copy.higher_usage_limits": "Limites de uso mais altos",
    "Higher usage limits": "Limites de uso mais altos",
    "upgrade_page.copy.highest_usage_limits": "Limites de uso mais altos",
    "Highest usage limits": "Limites de uso mais altos",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Importe e exporte registros sem trabalho manual repetitivo.",
    "Import and export records without repetitive manual work.": "Importe e exporte registros sem trabalho manual repetitivo.",
    "upgrade_page.copy.import_and_export_tools": "Ferramentas de importação e exportação",
    "Import and export tools": "Ferramentas de importação e exportação",
    "upgrade_page.copy.improve_important_customer_messages": "Melhore as mensagens importantes para os clientes",
    "Improve important customer messages": "Melhore as mensagens importantes para os clientes",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Mantenha um histórico de conformidade mais longo",
    "Keep a longer compliance history": "Mantenha um histórico de conformidade mais longo",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Mantenha uma visibilidade completa de conformidade para operações de alto volume.",
    "Keep complete compliance visibility for high-volume operations.": "Mantenha uma visibilidade completa de conformidade para operações de alto volume.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Mantenha mais dados e fluxos de trabalho organizados à medida que o catálogo cresce.",
    "Keep more data and workflows organised as the catalogue grows.": "Mantenha mais dados e fluxos de trabalho organizados à medida que o catálogo cresce.",
    "upgrade_page.copy.keep_your_workspace_secure": "Mantenha seu espaço de trabalho seguro",
    "Keep your workspace secure": "Mantenha seu espaço de trabalho seguro",
    "upgrade_page.copy.large": "Grande",
    "Large": "Grande",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Permita que os clientes escolham opções de uma única lista.",
    "Let customers choose options from one listing.": "Permita que os clientes escolham opções de uma única lista.",
    "upgrade_page.copy.listing_variants": "Variantes de listagem",
    "Listing variants": "Variantes de listagem",
    "upgrade_page.copy.make_every_customer_email_yours": "Torne cada e-mail do cliente seu",
    "Make every customer email yours": "Torne cada e-mail do cliente seu",
    "upgrade_page.copy.make_one_listing_work_harder": "Faça com que uma única lista trabalhe mais",
    "Make one listing work harder": "Faça com que uma única lista trabalhe mais",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Ajuste os e-mails do sistema ao seu fluxo de trabalho e tom.",
    "Make system emails match your workflow and tone.": "Ajuste os e-mails do sistema ao seu fluxo de trabalho e tom.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Torne seu projeto disponível em mais idiomas.",
    "Make your project available in more languages.": "Torne seu projeto disponível em mais idiomas.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Gerencie a experiência de idioma para o cliente à medida que expande para novas regiões e audiências.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Gerencie a experiência de idioma para o cliente à medida que expande para novas regiões e audiências.",
    "upgrade_page.copy.medium": "Médio",
    "upgrade_page.copy.more_capacity": "Mais capacidade",
    "More capacity": "Mais capacidade",
    "upgrade_page.copy.more_storage": "Mais armazenamento",
    "More storage": "Mais armazenamento",
    "upgrade_page.copy.more_team_capacity": "Mais capacidade para a equipe",
    "More team capacity": "Mais capacidade para a equipe",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Mova-se mais rápido com seu catálogo",
    "Move faster with your catalogue": "Mova-se mais rápido com seu catálogo",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Mova catálogos e equipes maiores através do trabalho rotineiro mais rápido.",
    "Move larger catalogues and teams through routine work faster.": "Mova catálogos e equipes maiores através do trabalho rotineiro mais rápido.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Ofereça tamanhos, cores ou outras opções sem duplicar listagens ou dividir a gestão do estoque.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Ofereça tamanhos, cores ou outras opções sem duplicar listagens ou dividir a gestão do estoque.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Operar com os limites mais altos disponíveis.",
    "Operate with the highest available limits.": "Operar com os limites mais altos disponíveis.",
    "upgrade_page.copy.per_module_permissions": "Permissões por módulo",
    "Per-module permissions": "Permissões por módulo",
    "upgrade_page.copy.priority_support": "Suporte prioritário",
    "Priority support": "Suporte prioritário",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Revise mais de cinco eventos de auditoria recentes.",
    "Review more than the latest five audit events.": "Revise mais de cinco eventos de auditoria recentes.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Revise o histórico completo de auditoria à medida que sua equipe e atividade crescem.",
    "Review the full audit history as your team and activity grow.": "Revise o histórico completo de auditoria à medida que sua equipe e atividade crescem.",
    "upgrade_page.copy.role_based_access_control": "Controle de acesso baseado em funções",
    "Role-based access control": "Controle de acesso baseado em funções",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "As funções permitem que você dê a cada membro da equipe apenas o acesso necessário. Disponível no Growth e acima.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "As funções permitem que você dê a cada membro da equipe apenas o acesso necessário. Disponível no Growth e acima.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Execute um fluxo de trabalho de comunicação com clientes mais sólido e refinado.",
    "Run a stronger, more polished customer communication workflow.": "Execute um fluxo de trabalho de comunicação com clientes mais sólido e refinado.",
    "upgrade_page.copy.sell_across_markets": "Venda em mercados diversos",
    "Sell across markets": "Venda em mercados diversos",
    "upgrade_page.copy.sell_products_together": "Venda produtos juntos",
    "Sell products together": "Venda produtos juntos",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Envie e-mails de uma marca que seus clientes reconheçam.",
    "Send email from a brand your customers recognise.": "Envie e-mails de uma marca que seus clientes reconheçam.",
    "upgrade_page.copy.shape_the_information_you_collect": "Defina a informação que você coleta",
    "Shape the information you collect": "Defina a informação que você coleta",
    "upgrade_page.copy.small": "Pequeno",
    "Small": "Pequeno",
    "upgrade_page.copy.speak_to_more_customers": "Fale com mais clientes",
    "Speak to more customers": "Fale com mais clientes",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Padronize dados mais ricos em uma operação de alto volume.",
    "Standardise richer data across a high-volume operation.": "Padronize dados mais ricos em uma operação de alto volume.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Comece a apresentar uma experiência de cliente mais consistente.",
    "Start presenting a more consistent customer experience.": "Comece a apresentar uma experiência de cliente mais consistente.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Suporte uma experiência de cliente completa e pronta para empresa.",
    "Support a complete enterprise-ready customer experience.": "Suporte uma experiência de cliente completa e pronta para empresa.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Suporte clientes que compram em diferentes moedas.",
    "Support customers who shop in different currencies.": "Suporte clientes que compram em diferentes moedas.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Suporte fluxos de trabalho operacionais de alto volume em escala.",
    "Support high-volume operational workflows at scale.": "Suporte fluxos de trabalho operacionais de alto volume em escala.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Suporte fluxos de trabalho e equipes maiores.",
    "Support larger workflows and teams.": "Suporte fluxos de trabalho e equipes maiores.",
    "upgrade_page.copy.t_shirt": "Camiseta",
    "T-shirt": "Camiseta",
    "upgrade_page.copy.t_shirt_large": "Camiseta — Grande",
    "T-shirt — Large": "Camiseta — Grande",
    "upgrade_page.copy.t_shirt_medium": "Camiseta — Média",
    "T-shirt — Medium": "Camiseta — Média",
    "upgrade_page.copy.t_shirt_small": "Camiseta — Pequena",
    "T-shirt — Small": "Camiseta — Pequena",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Personalize as mensagens que os clientes recebem em momentos-chave sem alterar a configuração do seu mercado.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Personalize as mensagens que os clientes recebem em momentos-chave sem alterar a configuração do seu mercado.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Desbloqueie mais ferramentas à medida que seu espaço de trabalho começa a crescer.",
    "Unlock more tools as your workspace begins to grow.": "Desbloqueie mais ferramentas à medida que seu espaço de trabalho começa a crescer.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Desbloqueie este recurso quando estiver pronto.",
    "Unlock this feature when you are ready.": "Desbloqueie este recurso quando estiver pronto.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Use APIs sem cabeça para uma experiência totalmente personalizada.",
    "Use headless APIs for a fully custom experience.": "Use APIs sem cabeça para uma experiência totalmente personalizada.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Use a API quando seu fluxo de trabalho precisar ir além.",
    "Use the API when your workflow needs to go further.": "Use a API quando seu fluxo de trabalho precisar ir além.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Use sua própria identidade de remetente e branding visual para que as comunicações do mercado permaneçam consistentes.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Use sua própria identidade de remetente e branding visual para que as comunicações do mercado permaneçam consistentes.",
    "upgrade_page.copy.with_variants": "Com variantes",
    "With variants": "Com variantes",
    "upgrade_page.copy.without_variants": "Sem variantes",
    "Without variants": "Sem variantes",
    "upgrade_page.copy.workflow_tools": "Ferramentas de fluxo de trabalho",
    "Workflow tools": "Ferramentas de fluxo de trabalho",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Seu trabalho atual permanece inalterado enquanto você compara o plano que inclui este recurso.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Seu trabalho atual permanece inalterado enquanto você compara o plano que inclui este recurso.",
    "upgrade_page.copy.a_paid_plan": "um plano pago",
    "a paid plan": "um plano pago",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Tudo o que uma loja em crescimento precisa: remova a marca, adicione seu domínio e desbloqueie mais ferramentas.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Tudo o que uma loja em crescimento precisa: remova a marca, adicione seu domínio e desbloqueie mais ferramentas.",
    "upgrade_page.copy.everything_unlocked": "Tudo desbloqueado",
    "Everything unlocked": "Tudo desbloqueado",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Pilha completa de IA, marketing avançado e tudo desbloqueado para lojas sérias em crescimento.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Uma nota da equipe Tradly",
    "A note from the Tradly team": "Uma nota da equipe Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Ajude-nos a manter o Tradly funcionando",
    "Help us keep Tradly going": "Ajude-nos a manter o Tradly funcionando",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Nossos custos aumentaram, e para continuar construindo e apoiando o Tradly precisamos do apoio da nossa comunidade. Para continuar com seu espaço de trabalho, por favor escolha um plano. Sua loja e seus dados estão seguros e esperando por você. Obrigado por fazer parte do Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Nossos custos aumentaram, e para continuar construindo e apoiando o Tradly precisamos do apoio da nossa comunidade. Para continuar com seu espaço de trabalho, por favor escolha um plano. Sua loja e seus dados estão seguros e esperando por você. Obrigado por fazer parte do Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Desde 2019 oferecemos o Tradly com um pacote gratuito, com muito incluído sem custo, porque queríamos que qualquer pessoa pudesse começar algo. Estavamos felizes em fazer isso, mas já não podemos sustentá-lo por conta própria. Planejamos trazer de volta o plano gratuito uma vez que o negócio atinja um certo estágio, para podermos devolver à comunidade que nos levou até aqui.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Desde 2019 oferecemos o Tradly com um pacote gratuito, com muito incluído sem custo, porque queríamos que qualquer pessoa pudesse começar algo. Estavamos felizes em fazer isso, mas já não podemos sustentá-lo por conta própria. Planejamos trazer de volta o plano gratuito uma vez que o negócio atinja um certo estágio, para podermos devolver à comunidade que nos levou até aqui.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Escolha o plano que mais se adapta a você hoje. Você pode alterá-lo a qualquer momento.",
    "Choose the plan that fits you today. You can change it any time.": "Escolha o plano que mais se adapta a você hoje. Você pode alterá-lo a qualquer momento.",
    "upgrade_page.back_to_workspace": "Voltar para o espaço de trabalho",
    "Back to workspace": "Voltar para o espaço de trabalho",
    "upgrade_page.grow_when_ready": "Crescer quando o trabalho exigir",
    "Grow when the work calls for it": "Crescer quando o trabalho exigir",
    "upgrade_page.reassurance": "Seus dados, listagens e configurações existentes permanecem exatamente como estão.",
    "Your existing data, listings, and setup stay exactly as they are.": "Seus dados, listagens e configurações existentes permanecem exatamente como estão.",
    "upgrade_page.choose_plan": "Escolha um plano",
    "Choose a plan": "Escolha um plano",
    "upgrade_page.feature_availability": "Disponibilidade de recursos",
    "Feature availability": "Disponibilidade de recursos",
    "upgrade_page.available_from": "Disponível a partir de",
    "Available from": "Disponível a partir de",
    "upgrade_page.and_above": "e acima",
    "and above": "e acima",
    "upgrade_page.choose_when_useful": "Escolha um plano apenas quando essa capacidade for útil para sua equipe.",
    "Choose a plan only when this capability is useful to your team.": "Escolha um plano apenas quando essa capacidade for útil para sua equipe.",
    "upgrade_page.practical_difference": "A diferença prática",
    "The practical difference": "A diferença prática",
    "upgrade_page.keep_work_simple": "Mantenha o trabalho mais simples à medida que você cresce.",
    "Keep the work simpler as you grow.": "Mantenha o trabalho mais simples à medida que você cresce.",
    "upgrade_page.plan_path": "Caminho do plano",
    "Plan path": "Caminho do plano",
    "upgrade_page.plan_path_title": "Comece com o plano que suporta este próximo passo.",
    "Start with the plan that supports this next step.": "Comece com o plano que suporta este próximo passo.",
    "upgrade_page.best_next_step": "Próximo passo recomendado",
    "upgrade_page.includes_capability": "Inclui este recurso",
    "Includes this capability": "Inclui este recurso",
    "upgrade_page.not_included": "Não incluído",
    "Not included": "Não incluído",
    "upgrade_page.included": "✓ Incluído",
    "✓ Included": "✓ Incluído",
    "upgrade_page.ready_when_you_are": "Pronto quando você estiver pronto.",
    "Ready when you are.": "Pronto quando você estiver pronto.",
    "upgrade_page.billing_details": "Revise os detalhes completos do plano e continue com segurança com a cobrança da Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Revise os detalhes completos do plano e continue com segurança com a cobrança da Tradly.",
    "upgrade_page.panel.close": "Fechar painel de atualização",
    "Close upgrade panel": "Fechar painel de atualização",
    "upgrade_page.panel.show_less": "Mostrar menos",
    "Show less": "Mostrar menos",
    "upgrade_page.panel.see_more": "Ver mais",
    "See more": "Ver mais",
    "upgrade_page.panel.choose_to_continue": "Escolha um plano para continuar",
    "Choose a plan to continue": "Escolha um plano para continuar",
    "upgrade_page.panel.more_ways_to_grow": "Mais formas de crescer",
    "More ways to grow": "Mais formas de crescer",
    "upgrade_page.panel.plan_includes_feature": "Cada plano inclui este recurso mais capacidade adicional para sua próxima etapa.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Cada plano inclui este recurso mais capacidade adicional para sua próxima etapa.",
    "upgrade_page.panel.add_credits": "Adicionar créditos ou produtos",
    "Add credits or products": "Adicionar créditos ou produtos",
    "upgrade_page.panel.ala_carte_description": "Seu espaço de trabalho é cobrado à la carte. Recarregue créditos ou adicione os produtos que você precisa.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Seu espaço de trabalho é cobrado à la carte. Recarregue créditos ou adicione os produtos que você precisa.",
    "upgrade_page.panel.open_ala_carte": "Abrir à la carte",
    "Open à la carte": "Abrir à la carte",
    "upgrade_page.panel.recommended": "Recomendado",
    "Recommended": "Recomendado",
    "upgrade_page.panel.per_month": "/ mês",
    "upgrade_page.panel.please_wait": "Aguarde…",
    "upgrade_page.panel.unlock_plan": "Desbloquear {plan}",
    "Unlock {plan}": "Desbloquear {plan}",
    "upgrade_page.panel.choose_plan": "Escolher {plan}",
    "Choose {plan}": "Escolher {plan}",
    "upgrade_page.panel.compare_plans": "Comparar todos os detalhes do plano",
    "Compare all plan details": "Comparar todos os detalhes do plano",
    "workspace.usage.page_title": "Visão geral do uso",
    "Usage overview": "Visão geral do uso",
    "workspace.usage.page_description": "Veja o uso atual e os limites aplicados a este espaço de trabalho.",
    "workspace.usage.not_available": "Indisponível",
    "workspace.usage.limit_not_configured": "Limite não configurado",
    "Limit not configured": "Limite não configurado",
    "workspace.usage.limit_value": "Limite: {limit}",
    "Limit: {limit}": "Limite: {limit}",
    "listings.photos": "Fotos",
    "Photos": "Fotos",
    "listings.listen_episode": "Ouvir este episódio",
    "Listen to this episode": "Ouvir este episódio",
    "listings.other_listings": "Outras listagens",
    "Other listings": "Outras listagens",
    "listings.delete": "Excluir",
    "listings.fulfilled_by_platform": "Cumprido pela Plataforma",
    "Fulfilled by Platform": "Cumprido pela Plataforma",
    "listings.no_attributes_set": "Nenhum atributo configurado",
    "No attributes set": "Nenhum atributo configurado",
    "listings.campaign_raised": "{amount} arrecadados",
    "{amount} raised": "{amount} arrecadados",
    "listings.campaign_progress": "{percent}% do {goal}",
    "{percent}% of {goal}": "{percent}% do {goal}",
    "listings.seat": "lugar",
    "seat": "lugar",
    "listings.seats": "lugares",
    "seats": "lugares",
    "listings.per_slot": "por slot",
    "per slot": "por slot",
    "listings.total_value": "Total: {total}",
    "Total: {total}": "Total: {total}",
    "listings.orders": "Pedidos",
    "listings.total_orders": "Pedidos totais",
    "Total orders": "Pedidos totais",
    "listings.revenue": "Receita",
    "listings.average_order": "Pedido médio",
    "listings.customers": "Clientes",
    "Customers": "Clientes",
    "listings.load_more": "Carregar mais",
    "Load more": "Carregar mais",
    "listings.filter": "Filtrar",
    "listings.sort": "Ordenar",
    "Sort": "Ordenar",
    "listings.value_price": "Preço de valor",
    "Value Price": "Preço de valor",
    "listings.detail_label_title": "Título",
    "listings.detail_label_slug": "Slug",
    "listings.detail_label_description": "Descrição",
    "listings.detail_label_categories": "Categorias",
    "listings.detail_label_list_price": "Preço de lista",
    "List Price": "Preço de lista",
    "listings.detail_label_offer": "Oferta",
    "Offer": "Oferta",
    "listings.detail_label_currency": "Moeda",
    "listings.detail_label_listing_status": "Status do anúncio",
    "listings.detail_label_active": "Ativo",
    "listings.detail_label_sold": "Vendido",
    "listings.detail_label_meta_title": "Meta título",
    "listings.detail_label_meta_description": "Meta descrição",
    "listings.detail_label_goal": "Meta",
    "Goal": "Meta",
    "listings.detail_label_donors": "Doadores",
    "Donors": "Doadores",
    "listings.detail_label_start_date": "Data de início",
    "listings.detail_label_end_date": "Data de término",
    "listings.detail_label_stock": "Estoque",
    "listings.detail_label_max_qty_order": "Quantidade máxima / pedido",
    "Max qty / order": "Quantidade máxima / pedido",
    "listings.detail_label_weight": "Peso",
    "listings.detail_label_dimensions": "Dimensões",
    "Dimensions": "Dimensões",
    "listings.detail_label_listing_period": "Período de listagem",
    "Listing period": "Período de listagem",
    "listings.detail_label_max_tickets_booking": "Máx. ingressos / reserva",
    "Max tickets / booking": "Máx. ingressos / reserva",
    "listings.detail_label_rating": "Avaliação",
    "listings.detail_label_reviews": "Avaliações",
    "listings.detail_label_likes": "Curtidas",
    "Likes": "Curtidas",
    "listings.detail_label_dislikes": "Não gostei",
    "Dislikes": "Não gostei",
    "listings.detail_label_barcode": "Código de barras",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Informações básicas",
    "Basic Info": "Informações básicas",
    "listings.detail_section_pricing": "Preços",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Selecione um tipo de listagem acima para continuar.",
    "Select a listing type above to continue.": "Selecione um tipo de listagem acima para continuar.",
    "listing_form.attributes": "Atributos",
    "category.status_active_help": "Status (Inativo / Ativo)",
    "promotions.medium": "Mídia",
    "users.listings": "Listagens",
    "users.accounts": "Contas",
    "users.click_count_one": "{count} clique",
    "{count} click": "{count} clique",
    "users.click_count": "{count} cliques",
    "{count} clicks": "{count} cliques",
    "integrations.generic.provider_help": "Configure o provedor selecionado usando os campos abaixo.",
    "Configure the selected provider using the fields below.": "Configure o provedor selecionado usando os campos abaixo.",
    "attributes.editor_prefill_data_from": "Preencher dados de",
    "Prefill Data From": "Preencher dados de",
    "attributes.editor_select_attribute": "Selecionar Atributo",
    "Select Attribute": "Selecionar Atributo",
    "attributes.editor_select_attribute_group": "Selecionar Grupo de Atributos",
    "Select Attribute Group": "Selecionar Grupo de Atributos",
    "attributes.editor_attribute": "Atributo",
    "Attribute": "Atributo",
    "attributes.editor_attributes": "Atributos",
    "attributes.editor_cart_attributes": "Atributos do Carrinho",
    "Cart Attributes": "Atributos do Carrinho",
    "listings.add_photo": "Adicionar Foto",
    "accounts.analytics": "Análise",
    "listings.image_optional": "Imagens do Anúncio (Opcional)",
    "Listing Images (Optional)": "Imagens do Anúncio (Opcional)",
    "listings.currency": "Moeda",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "Ativo",
    "listing_form.digital_deleted_item_cannot_edit": "Este item está marcado para exclusão e não pode ser editado",
    "This item is marked for deletion and cannot be edited": "Este item está marcado para exclusão e não pode ser editado",
    "listing_form.digital_max_files": "Máximo 10 arquivos permitidos",
    "Maximum 10 files allowed": "Máximo 10 arquivos permitidos",
    "listing_form.digital_title_required": "Por favor, insira um título",
    "listing_form.digital_version_required": "Por favor, insira um nome de versão",
    "Please enter a version name": "Por favor, insira um nome de versão",
    "listing_form.digital_contents": "Conteúdo Digital",
    "Digital Contents": "Conteúdo Digital",
    "listing_form.digital_add_content": "+ Adicionar Conteúdo",
    "+ Add Content": "+ Adicionar Conteúdo",
    "listing_form.no_description": "Sem descrição",
    "No description": "Sem descrição",
    "listing_form.digital_file_count": "{count} arquivo(s)",
    "{count} file(s)": "{count} arquivo(s)",
    "listing_form.digital_empty": "Ainda não há conteúdo digital",
    "No digital contents yet": "Ainda não há conteúdo digital",
    "listing_form.digital_empty_help": "Clique em \"{action}\" para criar seu primeiro conteúdo digital",
    "Click \"{action}\" to create your first digital content": "Clique em \"{action}\" para criar seu primeiro conteúdo digital",
    "listing_form.digital_marked_for_deletion": "Marcado para exclusão ({count})",
    "Marked for Deletion ({count})": "Marcado para exclusão ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Será excluído ao enviar",
    "✓ Will be deleted on submit": "✓ Será excluído ao enviar",
    "listing_form.digital_edit_title": "Editar conteúdo digital",
    "Edit Digital Content": "Editar conteúdo digital",
    "listing_form.digital_add_title": "Adicionar novo conteúdo digital",
    "Add New Digital Content": "Adicionar novo conteúdo digital",
    "listing_form.digital_form_description": "Preencha os detalhes abaixo para {action} conteúdo digital",
    "Fill in the details below to {action} digital content": "Preencha os detalhes abaixo para {action} conteúdo digital",
    "listing_form.digital_title_placeholder": "Insira o título do conteúdo digital",
    "Enter digital content title": "Insira o título do conteúdo digital",
    "listing_form.description_optional_placeholder": "Insira descrição (opcional)",
    "Enter description (optional)": "Insira descrição (opcional)",
    "listing_form.version": "Versão",
    "Version": "Versão",
    "listing_form.files": "Arquivos",
    "Files": "Arquivos",
    "listing_form.max_files": "(Máx {count})",
    "(Max {count})": "(Máx {count})",
    "listing_form.click_to_upload_files": "Clique para fazer upload de arquivos",
    "Click to upload files": "Clique para fazer upload de arquivos",
    "listing_form.files_uploaded_count": "{count}/10 arquivos enviados",
    "{count}/10 files uploaded": "{count}/10 arquivos enviados",
    "listing_form.unknown_size": "Tamanho desconhecido",
    "Unknown size": "Tamanho desconhecido",
    "listing_form.no_accounts_available": "Nenhuma conta disponível",
    "No accounts available": "Nenhuma conta disponível",
    "listing_form.select_account": "Selecione uma conta",
    "Select an account": "Selecione uma conta",
    "listing_form.searching": "Pesquisando...",
    "Searching...": "Pesquisando...",
    "listing_form.location_enter_address": "Por favor, insira um endereço para pesquisar",
    "Please enter an address to search": "Por favor, insira um endereço para pesquisar",
    "listing_form.location_no_addresses_search": "Nenhuma endereço encontrado. Por favor, tente uma pesquisa diferente.",
    "No addresses found. Please try a different search.": "Nenhuma endereço encontrado. Por favor, tente uma pesquisa diferente.",
    "listing_form.location_search_failed": "Falha ao pesquisar endereços. Por favor, tente novamente.",
    "Failed to search addresses. Please try again.": "Falha ao pesquisar endereços. Por favor, tente novamente.",
    "listing_form.location_place_details_failed": "Falha ao obter detalhes do local. Por favor, tente novamente.",
    "Failed to get place details. Please try again.": "Falha ao obter detalhes do local. Por favor, tente novamente.",
    "listing_form.location_access_denied": "Acesso à localização negado. Por favor, habilite as permissões de localização.",
    "Location access denied. Please enable location permissions.": "Acesso à localização negado. Por favor, habilite as permissões de localização.",
    "listing_form.location_unavailable": "Não é possível determinar a localização. Por favor, tente novamente.",
    "Unable to determine location. Please try again.": "Não é possível determinar a localização. Por favor, tente novamente.",
    "listing_form.location_timeout": "Tempo limite excedido para solicitação de localização. Por favor, tente novamente.",
    "Location request timed out. Please try again.": "Tempo limite excedido para solicitação de localização. Por favor, tente novamente.",
    "listing_form.location_current_failed": "Falha ao obter localização atual. Por favor, tente novamente.",
    "Failed to get current location. Please try again.": "Falha ao obter localização atual. Por favor, tente novamente.",
    "listing_form.location": "Localização",
    "listing_form.location_search_placeholder": "Pesquisar um local...",
    "Search for a location...": "Pesquisar um local...",
    "listing_form.location_searching": "Pesquisando endereços...",
    "Searching addresses...": "Pesquisando endereços...",
    "listing_form.location_no_addresses": "Nenhum endereço encontrado",
    "No addresses found": "Nenhum endereço encontrado",
    "listing_form.location_try_different_search": "Tente um termo de pesquisa diferente",
    "Try a different search term": "Tente um termo de pesquisa diferente",
    "listing_form.location_getting": "Obtendo localização...",
    "Getting location...": "Obtendo localização...",
    "listing_form.location_use_current": "Usar localização atual",
    "Use Current Location": "Usar localização atual",
    "listing_form.location_selected": "Localização selecionada",
    "Selected Location": "Localização selecionada",
    "listing_form.latitude": "Latitude:",
    "Latitude:": "Latitude:",
    "listing_form.longitude": "Longitude:",
    "Longitude:": "Longitude:",
    "listing_form.location_helper": "Pesquise um endereço ou use sua localização atual",
    "Search for an address or use your current location": "Pesquise um endereço ou use sua localização atual",
    "common.change": "Alterar",
    "listing_form.variant_id_tooltip": "Tipo ID: {typeId}, Valor ID: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "Tipo ID: {typeId}, Valor ID: {valueId}",
    "listing_form.variants_marked_for_deletion": "Marcado para exclusão ({count} itens):",
    "Marked for Deletion ({count} items):": "Marcado para exclusão ({count} itens):",
    "listing_form.add_new_variant": "Adicionar nova variante",
    "Add New Variant": "Adicionar nova variante",
    "listing_form.add_variant_description": "Preencha os detalhes abaixo para criar uma nova variante",
    "Fill in the details below to create a new variant": "Preencha os detalhes abaixo para criar uma nova variante",
    "listing_form.google_search_preview": "Visualização da pesquisa do Google",
    "Google Search Preview": "Visualização da pesquisa do Google",
    "listing_form.meta_title_preview": "Seu título meta aqui",
    "Your Meta Title Here": "Seu título meta aqui",
    "listing_form.meta_description_preview": "Sua descrição meta aparecerá aqui. Isso ajuda os usuários a entender o conteúdo da sua página nos resultados de pesquisa.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Sua descrição meta aparecerá aqui. Isso ajuda os usuários a entender o conteúdo da sua página nos resultados de pesquisa.",
    "listing_form.variant_name_placeholder": "Insira nome",
    "listing_form.list_price_placeholder": "Insira preço de lista",
    "listing_form.offer_percent_placeholder": "Insira percentual de oferta",
    "Enter Offer Percent": "Insira percentual de oferta",
    "attributes.select_all": "Selecionar tudo",
    "attributes.unselect_all": "Desmarcar tudo",
    "Unselect All": "Desmarcar tudo",
    "attributes.select_category": "Selecionar categoria",
    "attributes.create_category_configuration_first": "Crie categorias na configuração {type} primeiro",
    "Create categories in {type} configuration first": "Crie categorias na configuração {type} primeiro",
    "attributes.select_single_attribute_values": "Selecione valores de atributo único",
    "attributes.select_multiple_attribute_values": "Selecione valores de atributo múltiplo",
    "attributes.enter_value": "Insira o valor",
    "attributes.enter_multiple_tags": "Insira várias etiquetas",
    "Enter Multiple Tags": "Insira várias etiquetas",
    "attributes.upload_file": "Enviar arquivo",
    "collections.add_condition": "+ Adicionar outra condição",
    "+ Add another condition": "+ Adicionar outra condição",
    "collections.add_photo": "Adicionar foto",
    "collections.status": "Status (Inativo / Ativo)",
    "collections.start_date_placeholder": "Selecione a data de início",
    "Select start date": "Selecione a data de início",
    "collections.end_date_placeholder": "Selecione a data de término",
    "Select end date": "Selecione a data de término",
    "navigation.editor": "Editor",
    "Editor": "Editor",
    "navigation.web_analytics": "Análise web",
    "Web Analytics": "Análise web",
    "navigation.ai_studio": "Estúdio de IA",
    "AI Studio": "Estúdio de IA",
    "navigation.docs": "Documentos",
    "navigation.logout": "Sair",
    "Logout": "Sair",
    "navigation.tenant_name_placeholder": "(Nome do inquilino)",
    "(Tenant name)": "(Nome do inquilino)",
    "navigation.username_placeholder": "(Nome de usuário)",
    "(Username)": "(Nome de usuário)",
    "navigation.invite_description": "Envie links de convite para membros da equipe",
    "Send invitation links to team members": "Envie links de convite para membros da equipe",
    "navigation.invite": "Convidar",
    "Invite": "Convidar",
    "navigation.test_mode": "Modo de teste",
    "Test Mode": "Modo de teste",
    "navigation.upgrade": "Atualizar",
    "navigation.open_account_menu": "Abrir menu da conta",
    "Open account menu": "Abrir menu da conta",
    "navigation.invite_name_required": "Por favor, preencha o nome",
    "Please fill in the name": "Por favor, preencha o nome",
    "navigation.invite_email_required": "Preencha o e-mail",
    "Please fill in the email": "Preencha o e-mail",
    "navigation.open_url_failed": "Não sei como abrir esta URL: {url}",
    "Don't know how to open this URL: {url}": "Não sei como abrir esta URL: {url}",
    "navigation.no_code_editor": "Editor sem código",
    "No-code editor": "Editor sem código",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Automação de marketing",
    "Marketing automation": "Automação de marketing",
    "navigation.analytics_recommendation": "Análise e recomendação",
    "Analytics & Recommendation": "Análise e recomendação",
    "navigation.ai_studio_iryxo": "Estúdio de IA (Iryxo)",
    "AI Studio (Iryxo)": "Estúdio de IA (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Projeto atual",
    "Current project": "Projeto atual",
    "navigation.current_user": "Usuário atual",
    "Current user": "Usuário atual",
    "navigation.switch_to_light_mode": "Mudar para modo claro",
    "Switch to light mode": "Mudar para modo claro",
    "navigation.switch_to_dark_mode": "Mudar para modo escuro",
    "Switch to dark mode": "Mudar para modo escuro",
    "navigation.download_android_app": "Baixar aplicativo Android",
    "Download Android app": "Baixar aplicativo Android",
    "navigation.download_ios_app": "Baixar aplicativo iOS",
    "Download iOS app": "Baixar aplicativo iOS",
    "navigation.subscribe_youtube": "Assinar no YouTube",
    "Subscribe on YouTube": "Assinar no YouTube",
    "navigation.open_app_switcher": "Abrir seletor de aplicativos",
    "Open app switcher": "Abrir seletor de aplicativos",
    "navigation.open_android_app": "Abrir aplicativo Android",
    "Open Android app": "Abrir aplicativo Android",
    "navigation.open_ios_app": "Abrir aplicativo iOS",
    "Open iOS app": "Abrir aplicativo iOS",
    "navigation.open_ai_support": "Abrir suporte Tradly ChatGPT",
    "Open Tradly ChatGPT support": "Abrir suporte Tradly ChatGPT",
    "navigation.open_youtube_channel": "Abrir canal do YouTube Tradly",
    "Open Tradly YouTube channel": "Abrir canal do YouTube Tradly",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "ID da lista (opcional — atualizar existente)",
    "Listing ID (optional — update existing)": "ID da lista (opcional — atualizar existente)",
    "listings.smart_upload.category_id": "ID da categoria",
    "listings.smart_upload.list_price": "Preço de lista",
    "listings.smart_upload.stock": "Estoque",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Código de barras",
    "listings.smart_upload.account_id": "ID da conta",
    "listings.smart_upload.slug": "Slug",
    "listings.smart_upload.text": "Texto",
    "listings.smart_upload.long_text": "Texto longo",
    "listings.smart_upload.number": "Número",
    "listings.smart_upload.single_select": "Seleção única",
    "listings.smart_upload.multi_select": "Seleção múltipla",
    "listings.smart_upload.attribute_name_required": "Insira um nome de atributo para «{header}».",
    "listings.smart_upload.attribute_create_failed": "Tradly não retornou o novo atributo «{name}».",
    "Tradly did not return the new “{name}” attribute.": "Tradly não retornou o novo atributo «{name}».",
    "listings.smart_upload.attribute_option_create_failed": "Não foi possível criar a opção «{value}» para {name}.",
    "Could not create the “{value}” option for {name}.": "Não foi possível criar a opção «{value}» para {name}.",
    "listings.smart_upload.attribute_no_longer_available": "O atributo mapeado de «{header}» já não está disponível.",
    "listings.smart_upload.csv_needs_header_and_listing": "O CSV deve conter uma linha de cabeçalho e pelo menos uma lista.",
    "The CSV must contain a header row and at least one listing.": "O CSV deve conter uma linha de cabeçalho e pelo menos uma lista.",
    "listings.smart_upload.unique_headers_required": "Cada coluna de lista precisa de um cabeçalho único e não vazio.",
    "Every listing column needs a unique, non-empty header.": "Cada coluna de lista precisa de um cabeçalho único e não vazio.",
    "listings.smart_upload.csv_read_failed": "Não é possível ler este CSV.",
    "listings.smart_upload.map_required_fields": "Mapeie estas colunas obrigatórias antes de continuar: {fields}",
    "Map these required columns before continuing: {fields}": "Mapeie estas colunas obrigatórias antes de continuar: {fields}",
    "listings.smart_upload.row_missing_required_value": "A linha {row} está faltando um valor obrigatório.",
    "Row {row} is missing a required value.": "A linha {row} está faltando um valor obrigatório.",
    "listings.smart_upload.invalid_category_id_row": "A linha {row} precisa de um ID de categoria numérico válido, ou escolha «Mapear ID de categoria manualmente».",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "A linha {row} precisa de um ID de categoria numérico válido, ou escolha «Mapear ID de categoria manualmente».",
    "listings.smart_upload.invalid_listing_id_row": "A linha {row} precisa de um ID de lista numérico válido, ou deixe o ID em branco para criar uma nova lista.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "A linha {row} precisa de um ID de lista numérico válido, ou deixe o ID em branco para criar uma nova lista.",
    "listings.smart_upload.progress.checking_duplicates": "Verificando listagens existentes",
    "Checking for existing listings": "Verificando listagens existentes",
    "listings.smart_upload.duplicate_same_value_row": "O mesmo {field} aparece na linha {row} deste arquivo.",
    "Same {field} appears in row {row} of this file.": "O mesmo {field} aparece na linha {row} deste arquivo.",
    "listings.smart_upload.duplicate_same_value_multiple": "O mesmo {field} aparece mais de uma vez neste arquivo.",
    "Same {field} appears more than once in this file.": "O mesmo {field} aparece mais de uma vez neste arquivo.",
    "listings.smart_upload.duplicate_existing_listing": "Corresponde ao anúncio existente #{id} por {field}.",
    "Matches existing listing #{id} by {field}.": "Corresponde ao anúncio existente #{id} por {field}.",
    "listings.smart_upload.explicit_listing_update": "O ID de listagem explícito #{id} será atualizado.",
    "Explicit listing ID #{id} will be updated.": "O ID de listagem explícito #{id} será atualizado.",
    "listings.smart_upload.progress.duplicates_complete": "Verificação de duplicatas concluída",
    "Duplicate check complete": "Verificação de duplicatas concluída",
    "listings.smart_upload.duplicate_check_failed": "Não foi possível verificar os anúncios existentes.",
    "Could not check existing listings.": "Não foi possível verificar os anúncios existentes.",
    "listings.smart_upload.progress.duplicates_stopped": "Verificação de duplicatas interrompida",
    "Duplicate check stopped": "Verificação de duplicatas interrompida",
    "listings.smart_upload.prepare_file_failed": "Não foi possível preparar o arquivo de importação.",
    "listings.smart_upload.progress.uploading_file": "Enviando arquivo de importação",
    "listings.smart_upload.upload_file_failed": "Não foi possível enviar o arquivo de importação.",
    "listings.smart_upload.all_rows_duplicates": "Todas as linhas foram identificadas como duplicatas. Escolha «Importar mesmo assim» para enviá-las para o Tradly, ou comece novamente.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Todas as linhas foram identificadas como duplicatas. Escolha «Importar mesmo assim» para enviá-las para o Tradly, ou comece novamente.",
    "listings.smart_upload.progress.preparing_attributes": "Preparando atributos",
    "listings.smart_upload.attribute_mapped_once": "Cada atributo de listagem pode ser mapeado apenas uma vez. Revise os mapeamentos de colunas antes de importar.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Cada atributo de listagem pode ser mapeado apenas uma vez. Revise os mapeamentos de colunas antes de importar.",
    "listings.smart_upload.progress.preparing_file": "Preparando arquivo de importação",
    "listings.smart_upload.progress.tradly_importing": "Tradly está importando listagens",
    "Tradly is importing listings": "Tradly está importando listagens",
    "listings.smart_upload.progress.import_complete": "Importação concluída",
    "listings.smart_upload.progress.import_stopped": "Importação interrompida",
    "listings.smart_upload.progress.preparing_import": "Preparando importação…",
    "Preparing import…": "Preparando importação…",
    "listings.smart_upload.progress.rows_prepared": "{current} de {total} linhas preparadas",
    "{current} of {total} rows prepared": "{current} de {total} linhas preparadas",
    "listings.smart_upload.progress.remote_processing": "Tradly está processando o CSV enviado. Isso pode levar um momento.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly está processando o CSV enviado. Isso pode levar um momento.",
    "listings.smart_upload.progress.partial_import": "Tradly importou {imported} de {total} linhas{ending}. Revise o resultado antes de tentar novamente; uma nova tentativa completa pode duplicar linhas bem-sucedidas.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly importou {imported} de {total} linhas{ending}. Revise o resultado antes de tentar novamente; uma nova tentativa completa pode duplicar linhas bem-sucedidas.",
    "listings.smart_upload.title": "Upload inteligente",
    "Smart Upload": "Upload inteligente",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Começar novamente",
    "listings.smart_upload.description": "Carregue listagens, mapeie colunas para campos existentes ou crie novos atributos de listagem antes de importar.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Carregue listagens, mapeie colunas para campos existentes ou crie novos atributos de listagem antes de importar.",
    "listings.smart_upload.step_upload": "Enviar",
    "listings.smart_upload.step_match": "Correspondência de colunas",
    "listings.smart_upload.step_preview": "Pré-visualização",
    "listings.smart_upload.step_import": "Importar",
    "listings.smart_upload.choose_csv": "Escolha um arquivo CSV",
    "listings.smart_upload.required_columns_help": "As colunas obrigatórias são título e category_id. Outras colunas podem se tornar atributos de lista.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "As colunas obrigatórias são título e category_id. Outras colunas podem se tornar atributos de lista.",
    "listings.smart_upload.select_csv_file": "Selecione o arquivo CSV",
    "listings.smart_upload.match_columns": "Correspondência de colunas da lista",
    "Match listing columns": "Correspondência de colunas da lista",
    "listings.smart_upload.core_fields_help": "Campos principais são enviados para a API de lista. Outras colunas podem ser salvas como atributos de lista.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Campos principais são enviados para a API de lista. Outras colunas podem ser salvas como atributos de lista.",
    "listings.smart_upload.do_not_import": "Não importar",
    "listings.smart_upload.map_category_manually": "Mapear ID da categoria manualmente",
    "Map Category ID manually": "Mapear ID da categoria manualmente",
    "listings.smart_upload.category_assignment_help": "Escolha a categoria para atribuir a cada lista importada.",
    "Choose the category to assign to every imported listing.": "Escolha a categoria para atribuir a cada lista importada.",
    "listings.smart_upload.select_category": "Selecione uma categoria",
    "listings.smart_upload.no_categories": "Nenhuma categoria de lista foi retornada. Crie uma categoria primeiro, depois reabra o Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "Nenhuma categoria de lista foi retornada. Crie uma categoria primeiro, depois reabra o Smart Upload.",
    "listings.smart_upload.additional_attributes": "Atributos adicionais da lista",
    "Additional listing attributes": "Atributos adicionais da lista",
    "listings.smart_upload.ignore_column": "Ignorar esta coluna",
    "listings.smart_upload.create_attribute": "＋ Criar um novo atributo da lista",
    "＋ Create a new listing attribute": "＋ Criar um novo atributo da lista",
    "listings.smart_upload.attribute_name": "Nome do atributo",
    "listings.smart_upload.review_import": "Revisar importação",
    "listings.smart_upload.rows_scanned_help": "{count} listagens escaneadas antes do upload. Verificações de duplicatas usam SKU, código de barras, slug e valores repetidos neste CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} listagens escaneadas antes do upload. Verificações de duplicatas usam SKU, código de barras, slug e valores repetidos neste CSV.",
    "listings.smart_upload.duplicates_found": "Foram encontrados duplicatas potenciais",
    "Potential duplicates found": "Foram encontrados duplicatas potenciais",
    "listings.smart_upload.duplicate_rows_skipped": "{count} linha(s) serão ignoradas por padrão.",
    "{count} row(s) will be skipped by default.": "{count} linha(s) serão ignoradas por padrão.",
    "listings.smart_upload.row_label": "Linha",
    "Row": "Linha",
    "listings.smart_upload.explicit_ids_are_updates": "Linhas com ID de lista explícito são tratadas como atualizações.",
    "Rows with an explicit listing ID are treated as updates.": "Linhas com ID de lista explícito são tratadas como atualizações.",
    "listings.smart_upload.duplicate_action": "Ação duplicada",
    "Duplicate action": "Ação duplicada",
    "listings.smart_upload.skip_duplicates": "Ignorar duplicatas potenciais (recomendado)",
    "Skip potential duplicates (recommended)": "Ignorar duplicatas potenciais (recomendado)",
    "listings.smart_upload.import_all_anyway": "Importar todas as linhas de qualquer forma",
    "Import all rows anyway": "Importar todas as linhas de qualquer forma",
    "listings.smart_upload.untitled_listing": "Listagem sem título",
    "Untitled listing": "Listagem sem título",
    "listings.smart_upload.category_label": "Categoria:",
    "Category:": "Categoria:",
    "listings.smart_upload.complete": "Smart Upload concluído",
    "listings.smart_upload.imported_count": "{imported} de {total} listagens importadas.",
    "{imported} of {total} listings imported.": "{imported} de {total} listagens importadas.",
    "listings.smart_upload.selected_file": "Selecionado: {name}",
    "listings.smart_upload.checking": "Verificando…",
    "listings.smart_upload.check_duplicates": "Verificar duplicatas",
    "Check duplicates": "Verificar duplicatas",
    "listings.smart_upload.importing": "Importando…",
    "listings.smart_upload.import_listings": "Importar listagens",
    "listings.smart_upload.failed": "Smart Upload falhou.",
    "Smart Upload failed.": "Smart Upload falhou.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Status (Inativo / Ativo)",
    "listings.upload_media": "Enviar mídia",
    "listing_form.stock_placeholder": "Insira estoque",
    "orders.create_order.order_items_alt": "Itens do pedido",
    "orders.create_order.by": "por",
    "by": "por",
    "orders.create_order.decrease_quantity": "Diminuir quantidade",
    "Decrease quantity": "Diminuir quantidade",
    "orders.create_order.increase_quantity": "Aumentar quantidade",
    "Increase quantity": "Aumentar quantidade",
    "orders.create_order.remove_item": "Remover item",
    "Remove item": "Remover item",
    "orders.create_order.rental_period_label": "Período de aluguel:",
    "Rental period:": "Período de aluguel:",
    "attributes.enter_text": "Digite texto",
    "attributes.select_date": "Selecionar data",
    "attributes.enter_number": "Inserir número",
    "attributes.select_color": "Selecionar cor",
    "attributes.upload_json": "Enviar JSON",
    "Upload JSON": "Enviar JSON",
    "attributes.select_location": "Selecionar localização",
    "attributes.add_listing_preview": "Adicionar lista",
    "attributes.add_account_preview": "Adicionar conta",
    "attributes.enter_price": "Inserir preço",
    "attributes.preview": "Pré-visualização",
    "attributes.enter_title": "Inserir título",
    "attributes.enter_description": "Inserir descrição",
    "attributes.category": "Categoria",
    "attributes.attribute_name": "Nome do atributo",
    "attributes.enter_attribute_name": "Inserir nome do atributo",
    "attributes.select_type": "Selecionar tipo",
    "attributes.icon": "Ícone",
    "attributes.tooltip": "Dica",
    "Tooltip": "Dica",
    "attributes.enter_tooltip": "Inserir tooltip",
    "Enter attribute tooltip": "Inserir tooltip",
    "listings.detail.images": "Imagens",
    "listings.detail.posted_by": "Postado por",
    "Posted by": "Postado por",
    "listings.detail.fulfilled_by_platform": "Cumprido pela Plataforma",
    "listings.detail.preview": "Pré-visualização",
    "listings.detail.view_listing": "Ver lista",
    "View Listing": "Ver lista",
    "listings.detail.variants": "Variantes",
    "listings.detail.no_attribute_values": "Nenhum valor de atributo para {name}",
    "listings.detail.attributes": "Atributos",
    "listings.detail.starts_from": "Inicia de:",
    "Starts From:": "Inicia de:",
    "listings.detail.schedule": "Horário",
    "listings.detail.detail": "Detalhe",
    "web_config.download": "Baixar",
    "web_config.cancel": "Cancelar",
    "web_config.choose_file": "Escolher arquivo",
    "web_config.title": "Configurações da web",
    "Web Configs": "Configurações da web",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Largura do logo",
    "Logo Width": "Largura do logo",
    "web_config.width": "Largura",
    "web_config.logo_height": "Altura do logo",
    "Logo Height": "Altura do logo",
    "web_config.height": "Altura",
    "web_config.social_share_image": "Imagem destacada para compartilhamento em redes sociais - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Imagem destacada para compartilhamento em redes sociais - Open Graph",
    "web_config.business_name": "Nome do negócio",
    "web_config.enter_web_name": "Insira o nome do site",
    "Enter web name": "Insira o nome do site",
    "web_config.title_font": "Fonte do título",
    "Title Font": "Fonte do título",
    "web_config.select_title_font": "Selecione a fonte do título",
    "Select title font": "Selecione a fonte do título",
    "web_config.body_font": "Fonte do corpo",
    "Body Font": "Fonte do corpo",
    "web_config.select_body_font": "Selecione a fonte do corpo",
    "Select body font": "Selecione a fonte do corpo",
    "web_config.primary_font": "Fonte principal",
    "Primary Font": "Fonte principal",
    "web_config.select_primary_font": "Selecione a fonte principal",
    "Select primary font": "Selecione a fonte principal",
    "web_config.uploaded_successfully": "Enviado com sucesso",
    "web_config.ios_download_icon": "Ícone de download do app iOS",
    "iOS app download icon": "Ícone de download do app iOS",
    "web_config.ios_download_link": "Link de download do app iOS",
    "iOS app download link": "Link de download do app iOS",
    "web_config.enter_ios_download_link": "Insira o link de download do app iOS",
    "Enter iOS app download link": "Insira o link de download do app iOS",
    "web_config.android_download_icon": "Ícone de download do app Android",
    "Android app download icon": "Ícone de download do app Android",
    "web_config.android_download_link": "Link de download do app Android",
    "Android app download link": "Link de download do app Android",
    "web_config.enter_android_download_link": "Insira o link de download do app Android",
    "Enter android app download link": "Insira o link de download do app Android",
    "coupons.preview.customer_checkout": "PAGAMENTO DO CLIENTE",
    "CUSTOMER CHECKOUT": "PAGAMENTO DO CLIENTE",
    "coupons.preview.title": "Cupons em ação",
    "Coupons in action": "Cupons em ação",
    "coupons.preview.featured_product": "Seu produto destacado",
    "Your featured product": "Seu produto destacado",
    "coupons.preview.product_meta": "1 item · Entrega padrão",
    "1 item · Standard delivery": "1 item · Entrega padrão",
    "coupons.preview.coupon_applied": "Cupom aplicado",
    "Coupon applied": "Cupom aplicado",
    "coupons.preview.remove": "Remover",
    "coupons.preview.discount_applied": "Desconto aplicado ao pedido",
    "Discount applied to the order": "Desconto aplicado ao pedido",
    "coupons.preview.subtotal": "Subtotal",
    "coupons.preview.coupon_label": "Cupom · WELCOME10",
    "Coupon · WELCOME10": "Cupom · WELCOME10",
    "coupons.preview.grand_total": "Total geral",
    "Grand total": "Total geral",
    "coupons.preview.checkout": "PAGAR",
    "CHECKOUT": "PAGAR",
    "payments.stripe_get_keys": "Obter chaves do Stripe",
    "Get Stripe keys": "Obter chaves do Stripe",
    "payments.stripe_syncing": "Sincronizando com o Stripe...",
    "Syncing with Stripe...": "Sincronizando com o Stripe...",
    "payments.stripe_verifying_key": "Verificando chave secreta",
    "Verifying secret key": "Verificando chave secreta",
    "payments.stripe_creating_webhook": "Criando webhook de pagamento",
    "Creating payment webhook": "Criando webhook de pagamento",
    "payments.stripe_account_summary": "{country} · {mode} modo · {id}",
    "{country} · {mode} mode · {id}": "{country} · {mode} modo · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhooks configurados — segredos preenchidos automaticamente. Salve o formulário para persistir.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhooks configurados — segredos preenchidos automaticamente. Salve o formulário para persistir.",
    "payments.stripe_webhooks_error": "⚠ Falha na configuração do webhook. Verifique as permissões da chave e tente sincronizar novamente.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Falha na configuração do webhook. Verifique as permissões da chave e tente sincronizar novamente.",
    "payments.stripe_invalid_key": "Chave secreta inválida. Verifique e tente novamente.",
    "Invalid secret key. Check and try again.": "Chave secreta inválida. Verifique e tente novamente.",
    "payments.stripe_setup_failed": "Falha na configuração. Certifique-se de que sua chave secreta esteja sincronizada primeiro.",
    "Setup failed. Make sure your secret key is synced first.": "Falha na configuração. Certifique-se de que sua chave secreta esteja sincronizada primeiro.",
    "payments.stripe_marketplace_connect": "Conexão do Marketplace",
    "Marketplace Connect": "Conexão do Marketplace",
    "payments.stripe_marketplace_hint": "Necessário apenas se você usar o Stripe Connect para pagamentos de marketplace.",
    "Only needed if you use Stripe Connect for marketplace payouts": "Necessário apenas se você usar o Stripe Connect para pagamentos de marketplace.",
    "payments.stripe_subscription_hint": "Necessário apenas se você vender produtos de assinatura na Tradly.",
    "Only needed if you sell subscription products on Tradly": "Necessário apenas se você vender produtos de assinatura na Tradly.",
    "integrations.sso.title": "Autenticação única empresarial",
    "Enterprise single sign-on": "Autenticação única empresarial",
    "integrations.sso.description": "Conecte seu provedor de identidade corporativa para que o pessoal designado possa fazer login no ArcticWhale com OIDC. Okta, Microsoft Entra ID e provedores OIDC que assinam tokens de identidade com RS256 são compatíveis.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Conecte seu provedor de identidade corporativa para que o pessoal designado possa fazer login no ArcticWhale com OIDC. Okta, Microsoft Entra ID e provedores OIDC que assinam tokens de identidade com RS256 são compatíveis.",
    "integrations.sso.issuer_url": "URL do emissor",
    "Issuer URL": "URL do emissor",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID do cliente",
    "integrations.sso.client_secret": "Segredo do cliente",
    "integrations.sso.secret_replace_placeholder": "Salvo com segurança. Insira um valor para substituí-lo.",
    "Saved securely. Enter a value to replace it.": "Salvo com segurança. Insira um valor para substituí-lo.",
    "integrations.sso.secret_placeholder": "Insira o segredo do cliente",
    "Enter the client secret": "Insira o segredo do cliente",
    "integrations.sso.email_domains": "Domínios de e-mail corporativos",
    "Company email domains": "Domínios de e-mail corporativos",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "O pessoal deve ter uma conta no ArcticWhale e acesso a este tenant. Use domínios pertencentes à sua organização.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "O pessoal deve ter uma conta no ArcticWhale e acesso a este tenant. Use domínios pertencentes à sua organização.",
    "integrations.sso.callback_url": "URL de callback OIDC",
    "OIDC callback URL": "URL de callback OIDC",
    "integrations.sso.loading_callback_url": "Carregando URL de callback…",
    "Loading callback URL…": "Carregando URL de callback…",
    "integrations.sso.callback_help": "Adicione esta URL exata à aplicação do provedor de identidade como URI de redirecionamento web.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Adicione esta URL exata à aplicação do provedor de identidade como URI de redirecionamento web.",
    "integrations.sso.enable": "Habilitar login SSO corporativo",
    "Enable company SSO sign-in": "Habilitar login SSO corporativo",
    "integrations.sso.checking": "Verificando…",
    "integrations.sso.test_issuer": "Testar emissor",
    "Test issuer": "Testar emissor",
    "integrations.sso.saving": "Salvando…",
    "integrations.sso.save": "Salvar configurações SSO",
    "Save SSO settings": "Salvar configurações SSO",
    "integrations.sso.security_help": "O segredo do cliente é criptografado antes de ser armazenado. O SSO adiciona uma opção de login da organização; o login com senha permanece inalterado nesta configuração.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "O segredo do cliente é criptografado antes de ser armazenado. O SSO adiciona uma opção de login da organização; o login com senha permanece inalterado nesta configuração.",
    "integrations.sso.load_error": "Não é possível carregar as configurações SSO empresarial.",
    "Unable to load enterprise SSO settings.": "Não é possível carregar as configurações SSO empresarial.",
    "integrations.sso.save_error": "Não é possível salvar as configurações SSO empresarial.",
    "Unable to save enterprise SSO settings.": "Não é possível salvar as configurações SSO empresarial.",
    "integrations.sso.saved": "Configurações SSO empresarial salvas.",
    "Enterprise SSO settings saved.": "Configurações SSO empresarial salvas.",
    "integrations.sso.connection_ok": "A descoberta do provedor de identidade é alcançável.",
    "Identity provider discovery is reachable.": "A descoberta do provedor de identidade é alcançável.",
    "integrations.sso.connection_error": "Não é possível conectar-se ao provedor de identidade.",
    "Unable to connect to the identity provider.": "Não é possível conectar-se ao provedor de identidade.",
    "listing_configs.maximum_quantity_per_listing": "Quantidade máxima por anúncio",
    "listing_configs.example_quantity": "(Exemplo: 100)",
    "listing_configs.enter_maximum_quantity": "Insira a quantidade máxima por anúncio",
    "Enter maximum quantity per listing": "Insira a quantidade máxima por anúncio",
    "listing_configs.minimum_listing_price": "Preço mínimo por anúncio",
    "listing_configs.example_price": "(Exemplo: $5)",
    "listing_configs.enter_minimum_price": "Insira o preço mínimo por anúncio",
    "Enter minimum listing price": "Insira o preço mínimo por anúncio",
    "listing_configs.picture_count": "Quantidade de imagens que podem ser enviadas",
    "listing_configs.enter_picture_count": "Insira a quantidade de imagens",
    "Enter Pictures count": "Insira a quantidade de imagens",
    "listing_configs.feature_activation": "ATIVAÇÃO DE RECURSOS",
    "FEATURE ACTIVATION": "ATIVAÇÃO DE RECURSOS",
    "listing_configs.example_landmark": "(Exemplo: Ponto de referência)",
    "listing_configs.enter_address_label": "Insira a etiqueta de endereço",
    "Enter address Label": "Insira a etiqueta de endereço",
    "listing_configs.legacy_switch_0": "Aprovar anúncios automaticamente?",
    "listing_configs.legacy_switch_1": "Oferta percentual",
    "listing_configs.legacy_switch_2": "Restrições de quantidade máxima no nível do anúncio",
    "listing_configs.legacy_switch_3": "Custos de envio",
    "listing_configs.legacy_switch_4": "Use marcador de mapa em vez de pesquisar endereço",
    "Use map marker instead \nof searching address": "Use marcador de mapa em vez de pesquisar endereço",
    "listing_configs.legacy_switch_5": "Etiquetas",
    "listing_configs.legacy_switch_6": "Estoque",
    "listing_configs.legacy_switch_7": "Endereço geográfico",
    "listing_configs.legacy_switch_8": "Mostrar listagens esgotadas no feed",
    "listing_configs.legacy_switch_9": "Slug do título da lista",
    "listing_configs.legacy_switch_10": "Variantes",
    "listing_configs.legacy_switch_11": "Meta título",
    "listing_configs.legacy_switch_12": "Meta descrição",
    "listing_configs.legacy_switch_13": "Produto digital",
    "Digital Product": "Produto digital",
    "listing_configs.legacy_switch_14": "Habilitar Composer",
    "listing_configs.legacy_switch_15": "Habilitar peso",
    "listing_configs.legacy_switch_16": "Habilitar dimensões",
    "navigation.app_download.close": "Fechar",
    "navigation.app_download.eyebrow": "Companion móvel",
    "Mobile companion": "Companion móvel",
    "navigation.app_download.title": "Mantenha seu projeto em movimento.",
    "Keep your project moving.": "Mantenha seu projeto em movimento.",
    "navigation.app_download.description": "Gerencie o essencial do seu telefone, desde aprovar novas listagens até verificar pedidos e manter seu negócio em andamento.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Gerencie o essencial do seu telefone, desde aprovar novas listagens até verificar pedidos e manter seu negócio em andamento.",
    "navigation.app_download.approve_listings": "Aprovar listagens",
    "Approve listings": "Aprovar listagens",
    "navigation.app_download.manage_orders": "Gerenciar pedidos",
    "Manage orders": "Gerenciar pedidos",
    "navigation.app_download.check_performance": "Ver desempenho",
    "Check performance": "Ver desempenho",
    "navigation.app_download.download_title": "Baixar o aplicativo SuperAdmin",
    "Download the SuperAdmin app": "Baixar o aplicativo SuperAdmin",
    "navigation.app_download.download_on": "Baixar no",
    "Download on the": "Baixar no",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Obtenha-o no",
    "Get it on": "Obtenha-o no",
    "listing_configs.address_label": "Rótulo de endereço",
    "collections.add_another_condition": "+ Adicionar outra condição",
    "collections.search": "Pesquisar",
    "collections.status_inactive_active": "Status (Inativo / Ativo)",
    "media_picker.add_photo": "Adicionar foto",
    "payments.payment_intent_webhook_secret": "Segredo do webhook de intenção de pagamento",
    "Payment Intent Webhook secret": "Segredo do webhook de intenção de pagamento",
    "payments.subscription_webhook_secret": "Segredo do webhook de assinatura",
    "Subscription Webhook secret": "Segredo do webhook de assinatura",
    "payments.webhook_secret_autofilled": "Segredo do webhook preenchido automaticamente acima — salve o formulário para persistir.",
    "Webhook secret auto-filled above — save the form to persist.": "Segredo do webhook preenchido automaticamente acima — salve o formulário para persistir.",
    "app_customization.white_png_icon_help": "O ícone deve ser branco e no formato png",
    "icon should be white and in png format": "O ícone deve ser branco e no formato png",
    "app_customization.other_appearance": "Outra aparência",
    "Other appearance": "Outra aparência",
    "app_customization.notification_icon": "Ícone de notificação",
    "Notification icon": "Ícone de notificação",
    "app_customization.app_title_home": "Título do aplicativo na tela inicial",
    "app_customization.enable_app_title_icon": "Habilitar ícone de título do aplicativo em vez de texto",
    "listings.quick_add.title": "Adicionar lista rápida",
    "Quick Add Listing": "Adicionar lista rápida",
    "listings.quick_add.success": "Lista adicionada com sucesso",
    "Listing Added Successfully": "Lista adicionada com sucesso",
    "listings.quick_add.image": "Imagem",
    "listings.quick_add.listing_name": "Nome da lista",
    "Listing Name": "Nome da lista",
    "listings.quick_add.title_placeholder": "ex.: Fones de ouvido sem fio premium",
    "e.g., Premium Wireless Headphones": "ex.: Fones de ouvido sem fio premium",
    "listings.quick_add.category": "Categoria",
    "listings.quick_add.select_category": "Selecionar categoria",
    "listings.quick_add.price": "Preço",
    "listings.quick_add.stock": "Estoque",
    "listings.quick_add.description": "Descrição",
    "listings.quick_add.description_placeholder": "Descrição breve do seu produto...",
    "Brief Description of your product...": "Descrição breve do seu produto...",
    "listings.quick_add.more_options": "Precisa de mais opções? Use o formulário completo.",
    "Need more options? Use the full": "Precisa de mais opções? Use o formulário completo.",
    "listings.quick_add.guided_form": "formulario guiado",
    "guided form": "formulario guiado",
    "listings.quick_add.instead": "em vez de",
    "instead": "em vez de",
    "listings.digital_product.title": "Adicionar produto digital",
    "Add Digital Product": "Adicionar produto digital",
    "listings.digital_product.select_file": "Selecionar arquivo",
    "Select file": "Selecionar arquivo",
    "listings.digital_product.name": "Título",
    "listings.digital_product.version": "Versão",
    "listings.digital_product.description": "Descrição",
    "web_config.social_info": "Informações sociais",
    "Social Info": "Informações sociais",
    "web_config.social_facebook_pageurl": "URL da página do Facebook",
    "Facebook page URL": "URL da página do Facebook",
    "web_config.enter_social_facebook_pageurl": "Insira a URL da página do Facebook",
    "Enter Facebook page URL": "Insira a URL da página do Facebook",
    "web_config.social_twitter_handleurl": "URL do manejador do Twitter",
    "Twitter handle URL": "URL do manejador do Twitter",
    "web_config.enter_social_twitter_handleurl": "Insira a URL do manejador do Twitter",
    "Enter Twitter handle URL": "Insira a URL do manejador do Twitter",
    "web_config.social_instagram_url": "URL do Instagram",
    "Instagram URL": "URL do Instagram",
    "web_config.enter_social_instagram_url": "Insira a URL do Instagram",
    "Enter Instagram URL": "Insira a URL do Instagram",
    "web_config.social_youtube_channelurl": "URL do canal do Youtube",
    "Youtube channel URL": "URL do canal do Youtube",
    "web_config.enter_social_youtube_channelurl": "Insira a URL do canal do Youtube",
    "Enter Youtube channel URL": "Insira a URL do canal do Youtube",
    "web_config.social_tiktok_url": "URL do Tiktok",
    "Tiktok URL": "URL do Tiktok",
    "web_config.enter_social_tiktok_url": "Insira a URL do Tiktok",
    "Enter Tiktok URL": "Insira a URL do Tiktok",
    "web_config.social_spotify_url": "URL do Spotify",
    "Spotify URL": "URL do Spotify",
    "web_config.enter_social_spotify_url": "Insira a URL do Spotify",
    "Enter Spotify URL": "Insira a URL do Spotify",
    "web_config.social_whatsapp_number": "Número do Whatsapp",
    "Whatsapp number": "Número do Whatsapp",
    "web_config.enter_social_whatsapp_number": "Insira o número do Whatsapp",
    "Enter Whatsapp number": "Insira o número do Whatsapp",
    "web_config.social_telegram_url": "URL do Telegram",
    "Telegram URL": "URL do Telegram",
    "web_config.enter_social_telegram_url": "Insira a URL do Telegram",
    "Enter Telegram URL": "Insira a URL do Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Inserir Snapchat",
    "Enter Snapchat": "Inserir Snapchat",
    "payments.paydunya.title": "Integração PayDunya",
    "PayDunya Integration": "Integração PayDunya",
    "payments.paydunya.master_key": "Chave mestra",
    "Master key": "Chave mestra",
    "payments.paydunya.enter_master_key": "Inserir chave mestra",
    "Enter master key": "Inserir chave mestra",
    "payments.paydunya.public_key": "Chave pública",
    "Public key": "Chave pública",
    "payments.paydunya.enter_public_key": "Inserir chave pública",
    "payments.paydunya.private_key": "Chave privada",
    "Private key": "Chave privada",
    "payments.paydunya.enter_private_key": "Inserir chave privada",
    "Enter private key": "Inserir chave privada",
    "payments.paydunya.token": "Token",
    "payments.paydunya.enter_token": "Inserir token",
    "payments.paydunya.uploaded_successfully": "Enviado com sucesso",
    "communications.email_stats_open": "{sent} enviado · {openRate}% aberto",
    "{sent} sent · {openRate}% open": "{sent} enviado · {openRate}% aberto",
    "communications.email_stats_full": "{sent} enviados · {openRate}% abertos · {clicks} cliques",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} enviados · {openRate}% abertos · {clicks} cliques",
    "navigation.mini_apps.title": "Miniaplicativos",
    "Mini Apps": "Miniaplicativos",
    "navigation.mini_apps.subtitle": "Ferramentas complementares criadas com Tradly — toque em um cartão para ver detalhes e preços",
    "Tradly-built companion tools — tap a card to see details and pricing": "Ferramentas complementares criadas com Tradly — toque em um cartão para ver detalhes e preços",
    "navigation.mini_apps.soon": "Em breve",
    "Soon": "Em breve",
    "navigation.mini_apps.included_in_paid_plan": "Incluído em um plano pago",
    "Included in a paid plan": "Incluído em um plano pago",
    "navigation.mini_apps.know_more": "Saiba mais",
    "Know more": "Saiba mais",
    "navigation.mini_apps.hide_details": "Esconder detalhes",
    "Hide details": "Esconder detalhes",
    "navigation.mini_apps.view_plans": "Ver planos",
    "navigation.mini_apps.remove": "Remover",
    "navigation.mini_apps.add_to_sidebar": "Adicionar à barra lateral",
    "Add to sidebar": "Adicionar à barra lateral",
    "navigation.mini_apps.why_heading": "Por que seu negócio precisa disso?",
    "Why your business needs it": "Por que seu negócio precisa disso?",
    "navigation.mini_apps.coming_soon": "Em breve",
    "navigation.mini_apps.workflow.title": "Marketing",
    "navigation.mini_apps.workflow.description": "Execute campanhas de e-mail, notificações push e promoções para crescer sua audiência.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Execute campanhas de e-mail, notificações push e promoções para crescer sua audiência.",
    "navigation.mini_apps.workflow.why_1": "Envie campanhas de e-mail direcionadas a compradores e vendedores com base em atividade",
    "Send targeted email campaigns to buyers and sellers based on activity": "Envie campanhas de e-mail direcionadas a compradores e vendedores com base em atividade",
    "navigation.mini_apps.workflow.why_2": "Notificações push para reengajar usuários que não visitaram há 7+ dias",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Notificações push para reengajar usuários que não visitaram há 7+ dias",
    "navigation.mini_apps.workflow.why_3": "Execute promoções com descontos programados para seus eventos sazonais",
    "Run promotions with coupon drops timed to your seasonal events": "Execute promoções com descontos programados para seus eventos sazonais",
    "navigation.mini_apps.workflow.pricing_label": "Baseado em créditos",
    "Credits-based": "Baseado em créditos",
    "navigation.mini_apps.workflow.pricing_detail": "Pague por envio — 1.000 e-mails custam 100 créditos. Créditos nunca expiram.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Pague por envio — 1.000 e-mails custam 100 créditos. Créditos nunca expiram.",
    "navigation.mini_apps.intelligence_section.title": "Inteligência",
    "navigation.mini_apps.intelligence_section.description": "Entenda seu crescimento com análises, funis e insights impulsionados por IA.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Entenda seu crescimento com análises, funis e insights impulsionados por IA.",
    "navigation.mini_apps.intelligence_section.why_1": "Veja quais listagens, contas e categorias geram mais GMV",
    "See which listings, accounts, and categories drive the most GMV": "Veja quais listagens, contas e categorias geram mais GMV",
    "navigation.mini_apps.intelligence_section.why_2": "Funis de abandono mostram exatamente onde os compradores saem antes do pagamento",
    "Drop-off funnels show exactly where buyers leave before checkout": "Funis de abandono mostram exatamente onde os compradores saem antes do pagamento",
    "navigation.mini_apps.intelligence_section.why_3": "A IA identifica anomalias e oportunidades que você perderia nos dados brutos",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "A IA identifica anomalias e oportunidades que você perderia nos dados brutos",
    "navigation.mini_apps.intelligence_section.pricing_label": "Baseado em créditos",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Análise de IA e relatórios gerados consomem créditos. Visualizações de dados são sempre gratuitas.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Análise de IA e relatórios gerados consomem créditos. Visualizações de dados são sempre gratuitas.",
    "navigation.mini_apps.subscription_section.title": "Assinatura",
    "navigation.mini_apps.subscription_section.description": "Gerencie planos, ciclos de faturamento e direitos de acesso a recursos para seus inquilinos.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Gerencie planos, ciclos de faturamento e direitos de acesso a recursos para seus inquilinos.",
    "navigation.mini_apps.subscription_section.why_1": "Crie planos escalonados (Grátis / Pro / Empresa) com portas por recurso",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Crie planos escalonados (Grátis / Pro / Empresa) com portas por recurso",
    "navigation.mini_apps.subscription_section.why_2": "Automatize ciclos de faturamento — mensais, anuais ou durações personalizadas",
    "Automate billing cycles — monthly, annual, or custom durations": "Automatize ciclos de faturamento — mensais, anuais ou durações personalizadas",
    "navigation.mini_apps.subscription_section.why_3": "Direitos de acesso ativam ou restringem recursos em toda sua base de inquilinos",
    "Entitlements unlock or restrict features across your tenant base": "Direitos de acesso ativam ou restringem recursos em toda sua base de inquilinos",
    "navigation.mini_apps.subscription_section.pricing_label": "Conectar",
    "Connect": "Conectar",
    "navigation.mini_apps.subscription_section.pricing_detail": "Preço por tarefa — cobrado por evento de assinatura (atualização, renovação, cancelamento).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Preço por tarefa — cobrado por evento de assinatura (atualização, renovação, cancelamento).",
    "navigation.mini_apps.membership_section.title": "Membro",
    "navigation.mini_apps.membership_section.description": "Gerencie programas de membros, membros inscritos, contribuições e pagamentos.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Gerencie programas de membros, membros inscritos, contribuições e pagamentos.",
    "navigation.mini_apps.membership_section.why_1": "Gerencie programas de membros e membros inscritos",
    "Manage membership programs and enrolled members": "Gerencie programas de membros e membros inscritos",
    "navigation.mini_apps.membership_section.why_2": "Rastrear contribuições, dívidas de pagamento e status de associação",
    "Track contributions, payment dues, and membership status": "Rastrear contribuições, dívidas de pagamento e status de associação",
    "navigation.mini_apps.membership_section.why_3": "Conectar contribuições de associação aos seus pedidos",
    "Connect membership contributions back to their orders": "Conectar contribuições de associação aos seus pedidos",
    "navigation.mini_apps.membership_section.pricing_label": "Preços TBC",
    "navigation.mini_apps.membership_section.pricing_detail": "Gerencie programas de associação e histórico de contribuições em um único local.",
    "Manage membership programs and contribution history in one place.": "Gerencie programas de associação e histórico de contribuições em um único local.",
    "navigation.mini_apps.reward_programs.title": "Recompensas",
    "navigation.mini_apps.reward_programs.description": "Crie programas de recompensas com escopos, regras e receitas de recompensas reutilizáveis.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Crie programas de recompensas com escopos, regras e receitas de recompensas reutilizáveis.",
    "navigation.mini_apps.reward_programs.why_1": "Defina programas de recompensas para afiliados, referidos, regionais ou de loja",
    "Define affiliate, referral, regional, or store reward programs": "Defina programas de recompensas para afiliados, referidos, regionais ou de loja",
    "navigation.mini_apps.reward_programs.why_2": "Construa regras a partir de componentes reutilizáveis de comissão e recompensa",
    "Build rules from reusable commission and reward components": "Construa regras a partir de componentes reutilizáveis de comissão e recompensa",
    "navigation.mini_apps.reward_programs.why_3": "Mantenha o cálculo de recompensas e entrega de registros gerenciados pelo backend do ERP",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Mantenha o cálculo de recompensas e entrega de registros gerenciados pelo backend do ERP",
    "navigation.mini_apps.reward_programs.pricing_label": "Preços TBC",
    "navigation.mini_apps.reward_programs.pricing_detail": "Configure programas de recompensas e conecte-os à atribuição.",
    "Configure reward programs and connect them to attribution.": "Configure programas de recompensas e conecte-os à atribuição.",
    "navigation.mini_apps.bundles_app.title": "Pacotes",
    "navigation.mini_apps.bundles_app.description": "Crie pacotes fixos e mix-and-match a partir de listagens existentes.",
    "Create fixed and mix-and-match bundles from existing listings.": "Crie pacotes fixos e mix-and-match a partir de listagens existentes.",
    "navigation.mini_apps.bundles_app.why_1": "Combine listagens existentes sem duplicar dados de produtos",
    "Combine existing listings without duplicating product data": "Combine listagens existentes sem duplicar dados de produtos",
    "navigation.mini_apps.bundles_app.why_2": "Suporte a pacotes fixos e pacotes mix-and-match selecionados pelo cliente",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Suporte a pacotes fixos e pacotes mix-and-match selecionados pelo cliente",
    "navigation.mini_apps.bundles_app.why_3": "Valide o estoque de componentes antes da compra e cumprimento",
    "Validate component stock before checkout and fulfilment": "Valide o estoque de componentes antes da compra e cumprimento",
    "navigation.mini_apps.bundles_app.pricing_label": "Recursos de pacote pago",
    "Paid package feature": "Recursos de pacote pago",
    "navigation.mini_apps.bundles_app.pricing_detail": "Disponível em planos que incluem operações de pacotes.",
    "Available on plans that include bundle operations.": "Disponível em planos que incluem operações de pacotes.",
    "navigation.mini_apps.inventory_section.title": "Cadeia de suprimentos",
    "navigation.mini_apps.inventory_section.description": "Estoque, pedidos de compra, localizações de estoque, fornecedores e operações.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Estoque, pedidos de compra, localizações de estoque, fornecedores e operações.",
    "navigation.mini_apps.inventory_section.why_1": "Rastreie níveis de estoque em múltiplos armazéns e localizações de loja",
    "Track stock levels across multiple warehouses and store locations": "Rastreie níveis de estoque em múltiplos armazéns e localizações de loja",
    "navigation.mini_apps.inventory_section.why_2": "Gere pedidos de compra com fornecedores e receba estoque contra eles",
    "Raise purchase orders with suppliers and receive stock against them": "Gere pedidos de compra com fornecedores e receba estoque contra eles",
    "navigation.mini_apps.inventory_section.why_3": "Registre operações de estoque — ajustes, transferências e escrituração",
    "Record inventory operations — adjustments, transfers, and write-offs": "Registre operações de estoque — ajustes, transferências e escrituração",
    "navigation.mini_apps.inventory_section.pricing_label": "Incluído",
    "Included": "Incluído",
    "navigation.mini_apps.inventory_section.pricing_detail": "A cadeia de suprimentos está incluída em seu plano. Sem custo adicional.",
    "Supply Chain is included in your plan. No additional charge.": "A cadeia de suprimentos está incluída em seu plano. Sem custo adicional.",
    "navigation.mini_apps.people_app.title": "Pessoas",
    "navigation.mini_apps.people_app.description": "Catálogo de funcionários, departamentos, perfis de cargo e níveis salariais.",
    "Staff directory, departments, job profiles, and pay grades.": "Catálogo de funcionários, departamentos, perfis de cargo e níveis salariais.",
    "navigation.mini_apps.people_app.why_1": "Mantenha todos os perfis de funcionários, códigos e tipos de emprego em um único catálogo",
    "Keep every staff profile, code, and employment type in one directory": "Mantenha todos os perfis de funcionários, códigos e tipos de emprego em um único catálogo",
    "navigation.mini_apps.people_app.why_2": "Organize equipes em departamentos com perfis de cargo padrão",
    "Organise teams into departments with standard job profiles": "Organize equipes em departamentos com perfis de cargo padrão",
    "navigation.mini_apps.people_app.why_3": "Defina níveis salariais uma vez e atribua-os aos funcionários",
    "Define pay grades once and assign them to staff": "Defina níveis salariais uma vez e atribua-os aos funcionários",
    "navigation.mini_apps.people_app.pricing_label": "Preços sob consulta",
    "navigation.mini_apps.people_app.pricing_detail": "Necessário para Pessoal e Folha de Pagamento.",
    "Required by Workforce and Payroll.": "Necessário para Pessoal e Folha de Pagamento.",
    "navigation.mini_apps.workforce_app.title": "Força de Trabalho",
    "navigation.mini_apps.workforce_app.description": "Gestão de turnos, frequência e férias para sua equipe.",
    "Shifts, attendance, and leave management for your team.": "Gestão de turnos, frequência e férias para sua equipe.",
    "navigation.mini_apps.workforce_app.why_1": "Atribua funcionários a turnos por data, horário e localização",
    "Roster staff into shifts by date, time, and location": "Atribua funcionários a turnos por data, horário e localização",
    "navigation.mini_apps.workforce_app.why_2": "Marque entrada e saída com histórico completo de frequência",
    "Clock in and out with a full attendance history": "Marque entrada e saída com histórico completo de frequência",
    "navigation.mini_apps.workforce_app.why_3": "Políticas de férias, saldos e fluxo de trabalho para aprovação/reprovação",
    "Leave policies, balances, and an approve/reject workflow": "Políticas de férias, saldos e fluxo de trabalho para aprovação/reprovação",
    "navigation.mini_apps.workforce_app.pricing_label": "Preços sob consulta",
    "navigation.mini_apps.workforce_app.pricing_detail": "Ativa automaticamente o Pessoal.",
    "Turns on People automatically.": "Ativa automaticamente o Pessoal.",
    "navigation.mini_apps.payroll_app.title": "Folha de Pagamento",
    "navigation.mini_apps.payroll_app.description": "Execução de folhas de pagamento, aprovações, exportação CSV e reembolsos de despesas.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Execução de folhas de pagamento, aprovações, exportação CSV e reembolsos de despesas.",
    "navigation.mini_apps.payroll_app.why_1": "Crie execuções de folha de pagamento por período a partir dos níveis salariais dos funcionários",
    "Create payroll runs per period from staff pay grades": "Crie execuções de folha de pagamento por período a partir dos níveis salariais dos funcionários",
    "navigation.mini_apps.payroll_app.why_2": "Aprova execuções e exporte como CSV para seu banco ou contador",
    "Approve runs and export them as CSV for your bank or accountant": "Aprova execuções e exporte como CSV para seu banco ou contador",
    "navigation.mini_apps.payroll_app.why_3": "Reclamações de despesas de funcionários desde a submissão até o reembolso",
    "Staff expense claims from submission to reimbursement": "Reclamações de despesas de funcionários desde a submissão até o reembolso",
    "navigation.mini_apps.payroll_app.pricing_label": "Preços sob consulta",
    "navigation.mini_apps.payroll_app.pricing_detail": "Ativa automaticamente o Pessoal.",
    "navigation.mini_apps.unified_inbox.title": "Caixa de Entrada Unificada",
    "Unified Inbox": "Caixa de Entrada Unificada",
    "navigation.mini_apps.unified_inbox.description": "Toda sua comunicação com clientes — pedidos, suporte e chat — de um único local.",
    "All your customer communication — orders, support, and chat — from one place.": "Toda sua comunicação com clientes — pedidos, suporte e chat — de um único local.",
    "navigation.mini_apps.unified_inbox.why_1": "Consultas de pedidos, tickets de suporte e mensagens de compradores em uma única visualização de fio",
    "Order queries, support tickets, and buyer messages in one thread view": "Consultas de pedidos, tickets de suporte e mensagens de compradores em uma única visualização de fio",
    "navigation.mini_apps.unified_inbox.why_2": "Responda com respostas sugeridas por IA treinadas no seu catálogo",
    "Reply with AI-suggested responses trained on your catalogue": "Responda com respostas sugeridas por IA treinadas no seu catálogo",
    "navigation.mini_apps.unified_inbox.why_3": "Marque, atribua e resolva conversas em toda a sua equipe",
    "Tag, assign, and resolve conversations across your team": "Marque, atribua e resolva conversas em toda a sua equipe",
    "navigation.mini_apps.unified_inbox.pricing_label": "Conectar",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Preço baseado em tarefas por postagem agendada entregue.",
    "Task-based pricing per resolved conversation.": "Preço baseado em tarefas por postagem agendada entregue.",
    "navigation.mini_apps.social_connect.title": "Conectar redes sociais",
    "Social Connect": "Conectar redes sociais",
    "navigation.mini_apps.social_connect.description": "Compartilhe listagens em canais sociais no horário que você definir.",
    "Share listings to social channels on a schedule you define.": "Compartilhe listagens em canais sociais no horário que você definir.",
    "navigation.mini_apps.social_connect.why_1": "Agende postagens de listagens no Instagram, Facebook e X automaticamente",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Agende postagens de listagens no Instagram, Facebook e X automaticamente",
    "navigation.mini_apps.social_connect.why_2": "Defina horários de postagem por canal — descansos diários, vendas flash ou cadência personalizada",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Defina horários de postagem por canal — descansos diários, vendas flash ou cadência personalizada",
    "navigation.mini_apps.social_connect.why_3": "Monitore cliques e engajamento de cada lista a partir do painel de controle",
    "Track clicks and engagement back to each listing from the dashboard": "Monitore cliques e engajamento de cada lista a partir do painel de controle",
    "navigation.mini_apps.social_connect.pricing_label": "Conectar",
    "navigation.mini_apps.social_connect.pricing_detail": "Preço baseado em tarefas por postagem agendada entregue.",
    "Task-based pricing per scheduled post delivered.": "Preço baseado em tarefas por postagem agendada entregue.",
    "navigation.mini_apps.shopping_channels.title": "Canais de Compras",
    "Shopping Channels": "Canais de Compras",
    "navigation.mini_apps.shopping_channels.description": "Conecte seu catálogo ao TikTok Shop, Shopee, Meta Catalog, Uber Eats e mais.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Conecte seu catálogo ao TikTok Shop, Shopee, Meta Catalog, Uber Eats e mais.",
    "navigation.mini_apps.shopping_channels.why_1": "Sincronize suas listagens para TikTok Shop, Shopee e Meta Catalog instantaneamente",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Sincronize suas listagens para TikTok Shop, Shopee e Meta Catalog instantaneamente",
    "navigation.mini_apps.shopping_channels.why_2": "Conecte catálogos de alimentos e bebidas ao Uber Eats e Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Conecte catálogos de alimentos e bebidas ao Uber Eats e Grab",
    "navigation.mini_apps.shopping_channels.why_3": "O inventário e os pedidos são sincronizados automaticamente — sem entrada dupla",
    "Inventory and orders sync back automatically — no double-entry": "O inventário e os pedidos são sincronizados automaticamente — sem entrada dupla",
    "navigation.mini_apps.shopping_channels.pricing_label": "Conectar",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Preço baseado em tarefas por pedido concluído através de um canal conectado.",
    "Task-based pricing per order fulfilled through a connected channel.": "Preço baseado em tarefas por pedido concluído através de um canal conectado.",
    "listing_configs.customize_table": "Personalizar tabela",
    "Customize table": "Personalizar tabela",
    "listing_configs.fields_visible": "Campos visíveis na tabela",
    "Fields visible in table": "Campos visíveis na tabela",
    "listing_configs.fields_hidden": "Campos não mostrados na tabela",
    "Fields not shown in table": "Campos não mostrados na tabela",
    "listing_configs.reset_default": "Redefinir para padrão",
    "listing_configs.column_title": "Título da coluna",
    "listing_configs.column_actions": "Ações",
    "listing_configs.column_website": "Site",
    "listing_configs.column_list_price": "Preço de lista",
    "listing_configs.column_offer_percent": "Percentual de oferta",
    "Offer Percent": "Percentual de oferta",
    "listing_configs.column_image": "Imagem",
    "listing_configs.column_offer_price": "Preço de oferta",
    "Offer Price": "Preço de oferta",
    "listing_configs.column_status": "Status",
    "listing_configs.column_listing_id": "ID da lista",
    "listing_configs.column_listing_status": "Status da lista",
    "listing_configs.column_accounts": "Contas",
    "listing_configs.column_currency": "Moeda",
    "listing_configs.column_sold": "Vendido",
    "listing_configs.column_goal_amount": "Valor objetivo",
    "Goal Amount": "Valor objetivo",
    "listing_configs.column_width": "Largura",
    "listing_configs.column_height": "Altura",
    "listing_configs.column_weight": "Peso",
    "listing_configs.column_volume": "Volume",
    "Volume": "Volume",
    "listing_configs.column_order_type": "Tipo de pedido",
    "Order Type": "Tipo de pedido",
    "navigation.apps_group": "Aplicativos",
    "navigation.channels_group": "Canais",
    "navigation.manage_mini_apps": "Gerenciar Mini Apps",
    "Manage Mini Apps": "Gerenciar Mini Apps",
    "navigation.manage_channels": "Gerenciar Canais",
    "Manage Channels": "Gerenciar Canais",
    "listings.import.uploading": "Enviando...",
    "listings.import.complete": "Importação concluída",
    "listings.import.error": "Erro: {message}",
    "Error: {message}": "Erro: {message}",
    "listings.import.file_label": "Arquivo:",
    "listings.import.select_file": "Selecionar arquivo",
    "listings.import.response": "Resposta de importação",
    "Import response": "Resposta de importação",
    "listings.import.total_rows": "Linhas totais:",
    "Total rows:": "Linhas totais:",
    "listings.import.total_imported": "Importado total:",
    "Total imported:": "Importado total:",
    "listings.import.download_template": "Baixar modelo de listagens",
    "Download listings template": "Baixar modelo de listagens",
    "common.upload": "Enviar",
    "common.kanban_unavailable": "A visualização do quadro está temporariamente indisponível",
    "Board view is temporarily unavailable": "A visualização do quadro está temporariamente indisponível",
    "common.retry": "Tentar novamente",
    "Retry": "Tentar novamente",
    "listings.digital_assets.title": "Ativos digitais",
    "Digital assets": "Ativos digitais",
    "listings.digital_assets.not_found": "Ativos digitais não encontrados",
    "Digital assets not found": "Ativos digitais não encontrados",
    "listings.addon.saved": "Complemento salvo com sucesso.",
    "Add-on saved successfully.": "Complemento salvo com sucesso.",
    "listings.addon.title_required": "Por favor, insira um título.",
    "Please enter a title.": "Por favor, insira um título.",
    "listings.addon.price_required": "Por favor, insira um preço.",
    "Please enter a price.": "Por favor, insira um preço.",
    "listings.addon.no_media": "Você não possui arquivos multimídia.",
    "listings.addon.price": "Preço",
    "listings.addon.offer_percentage": "Porcentagem de oferta",
    "Offer Percentage": "Porcentagem de oferta",
    "listings.addon.maximum_quantity": "Quantidade máxima",
    "Maximum Quantity": "Quantidade máxima",
    "listings.addon.stock": "Estoque",
    "listings.addon.enter_price": "Insira preço",
    "Enter price": "Insira preço",
    "listings.addon.enter_offer_percentage": "Insira porcentagem de oferta",
    "Enter offer percentage": "Insira porcentagem de oferta",
    "listings.addon.enter_maximum_quantity": "Insira quantidade máxima",
    "Enter maximum quantity": "Insira quantidade máxima",
    "listings.addon.enter_stock": "Insira estoque",
    "listings.addon.edit_title": "Editar complemento",
    "Edit Add-on": "Editar complemento",
    "listings.addon.add_title": "Adicionar complemento",
    "Add Add-on": "Adicionar complemento",
    "listings.addon.title": "Título",
    "listings.addon.enter_title": "Insira o título",
    "listings.addon.status": "Status (Não Ativo / Ativo)",
    "listings.addon.upload_media": "Enviar mídia",
    "attributes.prefill_for": "Preencher automaticamente para",
    "Prefill for": "Preencher automaticamente para",
    "attributes.first_item": "Primeiro item",
    "First Item": "Primeiro item",
    "attributes.all_items": "Todos os itens",
    "All Items": "Todos os itens",
    "common.uploading": "Enviando...",
    "common.uploading_named": "Enviando {title}",
    "Uploading {title}": "Enviando {title}",
    "common.please_wait_short": "Aguarde",
    "Please wait": "Aguarde",
    "attributes.select_option": "Selecionar",
    "attributes.select_value": "Selecione o valor...",
    "Select value...": "Selecione o valor...",
    "attributes.type_placeholder": "Digite {name}",
    "Type {name}": "Digite {name}",
    "attributes.multiple_values_placeholder": "Você pode inserir vários valores separados por vírgula.",
    "Using a comma, you can enter several values.": "Você pode inserir vários valores separados por vírgula.",
    "attributes.upload_attachment": "Enviar anexo",
    "Upload Attachment": "Enviar anexo",
    "attributes.upload_json_file": "Enviar arquivo JSON",
    "Upload JSON File": "Enviar arquivo JSON",
    "attributes.copied_value": "Valor copiado",
    "Copied the value": "Valor copiado",
    "attributes.latitude_longitude_placeholder": "Insira latitude, longitude (ex. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Insira latitude, longitude (ex. 12.34,56.78)",
    "navigation.sidebar_label": "Barra lateral",
    "Side bar": "Barra lateral",
    "checkout_settings.orders_option_0": "Visualização de calendário de pedidos",
    "Orders Calendar View": "Visualização de calendário de pedidos",
    "checkout_settings.show_cart_attributes": "Mostrar atributos do carrinho",
    "Show cart attributes": "Mostrar atributos do carrinho",
    "checkout_settings.select_order_status": "Selecionar status do pedido",
    "Select order status": "Selecionar status do pedido",
    "checkout_settings.order_status_0": "Pedido realizado com sucesso",
    "Placed success": "Pedido realizado com sucesso",
    "checkout_settings.order_status_1": "Em processamento",
    "In process": "Em processamento",
    "checkout_settings.order_status_2": "Enviado",
    "checkout_settings.order_status_3": "Entregue",
    "checkout_settings.order_status_4": "Concluído",
    "listing_form.no_categories_found": "Nenhuma categoria encontrada. Use «{action}» acima.",
    "No categories found. Use “{action}” above.": "Nenhuma categoria encontrada. Use «{action}» acima.",
    "common.learn_more": "Saiba mais",
    "Learn more": "Saiba mais",
    "common.show_information": "Mostrar informações",
    "Show information": "Mostrar informações",
    "common.paid_feature": "Recursos pagos",
    "Paid Feature": "Recursos pagos",
    "common.learn_more_about": "Saiba mais sobre",
    "Learn more about": "Saiba mais sobre",
    "attributes.categories": "Categorias",
    "attributes.edit_bulk_title": "{title} Editar em lote",
    "{title} Edit Bulk": "{title} Editar em lote",
    "common.enter_description": "Insira descrição",
    "common.empty_fetch_message": "Nada para mostrar aqui ainda. Quando o conteúdo estiver disponível, aparecerá nesta página.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Nada para mostrar aqui ainda. Quando o conteúdo estiver disponível, aparecerá nesta página.",
    "common.ai_credits_and_top_up": "Créditos de IA e recarga",
    "AI credits and top up": "Créditos de IA e recarga",
    "common.ai_credits_loading": "Carregando créditos de IA",
    "Loading AI credits": "Carregando créditos de IA",
    "common.ai_credits_unavailable": "Créditos de IA não disponíveis",
    "AI credits unavailable": "Créditos de IA não disponíveis",
    "common.ai_credits_available": "Créditos de IA disponíveis: {count}",
    "Available AI credits: {count}": "Créditos de IA disponíveis: {count}",
    "common.ai_credits_unavailable_top_up": "Créditos de IA não disponíveis — clique para recarregar",
    "AI credits unavailable — click to top up": "Créditos de IA não disponíveis — clique para recarregar",
    "common.ai_credits_available_top_up": "Créditos de IA disponíveis: {count} — clique para adicionar créditos",
    "Available AI credits: {count} — click to add credits": "Créditos de IA disponíveis: {count} — clique para adicionar créditos",
    "common.ai_credits_add": "Adicionar créditos",
    "Add credits": "Adicionar créditos",
    "navigation.switch_project": "Mudar projeto",
    "Switch Project": "Mudar projeto",
    "navigation.tenant_switch_failed": "Falha ao alternar de inquilino. Por favor, tente novamente.",
    "Tenant switch failed. Please try again.": "Falha ao alternar de inquilino. Por favor, tente novamente.",
    "navigation.select_project": "Selecionar projeto",
    "Select Project": "Selecionar projeto",
    "navigation.collapse_sidebar": "Colapsar barra lateral",
    "Collapse sidebar": "Colapsar barra lateral",
    "navigation.expand_sidebar": "Expandir barra lateral",
    "Expand sidebar": "Expandir barra lateral",
    "navigation.search": "Pesquisar",
    "navigation.loading": "Carregando navegação",
    "Loading navigation": "Carregando navegação",
    "navigation.help_documentation": "Documentação",
    "navigation.help_community": "Comunidade",
    "navigation.help_api_reference": "Referência da API",
    "listings.quick_form": "Formulário rápido",
    "Quick Form": "Formulário rápido",
    "payments.notification_secret": "Segredo de notificação",
    "Notification Secret": "Segredo de notificação",
    "payments.user_type": "Tipo de usuário",
    "User Type": "Tipo de usuário",
    "payments.category_id": "ID da categoria",
    "app_customization.other_settings": "Outras configurações",
    "Other Settings": "Outras configurações",
    "app_customization.other_hide_balances": "Ocultar saldos e pagamentos na seção mais",
    "app_customization.other_enable_logs": "Habilitar logs",
    "Enable logs": "Habilitar logs",
    "app_customization.other_signup_first": "Obter inscrição primeiro",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Imagem selecionada",
    "Selected image": "Imagem selecionada",
    "common.ai_no_response_to_copy": "Nenhuma resposta para copiar",
    "No response to copy": "Nenhuma resposta para copiar",
    "common.copied_to_clipboard": "Copiado para a área de transferência",
    "Copied to clipboard": "Copiado para a área de transferência",
    "common.ai_suggestions": "Sugestões",
    "Suggestions": "Sugestões",
    "common.regenerate": "Regenerar",
    "Regenerate": "Regenerar",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "Ícone JSON",
    "JSON icon": "Ícone JSON",
    "collections.generator_title": "Gerador de coleção",
    "Collection Generator": "Gerador de coleção",
    "collections.generator_create": "Criar coleção",
    "collections.generator_json_placeholder": "Insira entrada JSON",
    "Enter JSON input": "Insira entrada JSON",
    "collections.generator_invalid_data": "Insira dados válidos",
    "Please enter valid data": "Insira dados válidos",
    "category.editor_select_from_media": "Selecionar a partir de mídia",
    "payments.subscription": "Assinatura",
    "payments.subscription_setting_up": "Configurando...",
    "Setting up...": "Configurando...",
    "payments.subscription_webhook_configured": "Webhook de assinatura configurado",
    "Subscription webhook configured": "Webhook de assinatura configurado",
    "payments.subscription_retry_setup": "Tentar configuração novamente",
    "Retry setup": "Tentar configuração novamente",
    "payments.setup_subscription_webhook": "Configurar Webhook de assinatura",
    "Setup Subscription Webhook": "Configurar Webhook de assinatura",
    "orders.shipment_number": "Remessa {number}",
    "Shipment {number}": "Remessa {number}",
    "orders.quantity_short": "QTD",
    "orders.shipment_status_1": "Remessa criada",
    "orders.shipment_status_2": "Remessa em andamento",
    "orders.shipment_status_3": "Enviado",
    "orders.shipment_status_4": "Pronto para retirar",
    "orders.shipment_status_5": "Em trânsito para entrega",
    "orders.shipment_status_6": "Devolução não entregue",
    "orders.shipment_status_7": "Remessa entregue",
    "orders.shipment_status_8": "Entrega confirmada",
    "orders.shipment_status_9": "Devolução iniciada",
    "orders.shipment_status_10": "Devolução para retirar",
    "orders.shipment_status_11": "Devolução confirmada",
    "orders.shipment_status_12": "Cancelado pelo vendedor",
    "orders.shipment_status_13": "Cancelado pelo cliente",
    "orders.shipment_status_14": "Chegou ao local do cliente",
    "orders.shipment_status_15": "Cancelado por administrador",
    "attributes.metadata_title": "Metadados",
    "Metadata": "Metadados",
    "common.add_row": "Adicionar linha",
    "common.no_access": "Você não tem acesso",
    "You don't have access": "Você não tem acesso",
    "common.error_404_message": "Lamentamos, a página que você está procurando atualmente não está disponível. Por favor, verifique a URL e tente novamente, ou volte mais tarde. Se você continuar experimentando este problema, entre em contato com nossa equipe de suporte para obter assistência. Obrigado pela sua compreensão.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "Lamentamos, a página que você está procurando atualmente não está disponível. Por favor, verifique a URL e tente novamente, ou volte mais tarde. Se você continuar experimentando este problema, entre em contato com nossa equipe de suporte para obter assistência. Obrigado pela sua compreensão.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "Direção da transação",
    "Transaction direction": "Direção da transação",
    "category.default_text": "Texto padrão",
    "collections.generator_open": "Gerador de coleção aberto",
    "Open collection generator": "Gerador de coleção aberto",
    "collections.duplicate_success": "Coleção duplicada com sucesso",
    "Collection duplicated successfully": "Coleção duplicada com sucesso",
    "collections.duplicate_failed": "Falha ao duplicar coleção",
    "Failed to duplicate collection": "Falha ao duplicar coleção",
    "listings.name_required": "Nome da lista é obrigatório",
    "Listing Name is required": "Nome da lista é obrigatório",
    "listings.category_required": "Categoria é obrigatória",
    "Category is required": "Categoria é obrigatória",
    "attribute_groups.edit_title": "Editar grupo de atributos",
    "Edit Attribute Group": "Editar grupo de atributos",
    "orders.create_order.validation.select_shipping_method": "Selecione o método de envio",
    "Please select shipping method": "Selecione o método de envio",
    "orders.create_order.validation.shipping_method_error": "Erro no método de envio",
    "Shipping Method Error": "Erro no método de envio",
    "orders.create_order.validation.select_shipping_address": "Selecione o endereço de envio",
    "Please select shipping address": "Selecione o endereço de envio",
    "orders.create_order.validation.shipping_address_error": "Erro no endereço de envio",
    "Shipping Address Error": "Erro no endereço de envio",
    "orders.create_order.validation.select_shipment_method": "Selecione o método de envio",
    "Please select shipment method": "Selecione o método de envio",
    "orders.create_order.validation.shipment_method_error": "Erro no método de envio",
    "Shipment Method Error": "Erro no método de envio",
    "orders.create_order.validation.select_payment_method": "Selecione o método de pagamento",
    "Please select payment method": "Selecione o método de pagamento",
    "orders.create_order.validation.payment_method_error": "Erro no método de pagamento",
    "Payment Method Error": "Erro no método de pagamento",
    "orders.create_order.validation.insufficient_balance": "Saldo insuficiente",
    "Insufficient balance": "Saldo insuficiente",
    "orders.create_order.validation.wallet_error": "Erro da carteira",
    "Wallet Error": "Erro da carteira",
    "attributes.value.preview_item": "Pré-visualização {count}",
    "Preview {count}": "Pré-visualização {count}",
    "attributes.value.click_to_upload": "Clique para fazer upload de {type}",
    "Click to upload {type}": "Clique para fazer upload de {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF até 5 arquivos",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF até 5 arquivos",
    "attributes.value.audio_upload_formats": "MP3, WAV até 1 arquivo",
    "MP3, WAV up to 1 file": "MP3, WAV até 1 arquivo",
    "attributes.value.video_upload_formats": "MP4, MOV até 1 arquivo",
    "MP4, MOV up to 1 file": "MP4, MOV até 1 arquivo",
    "attributes.value.upload_limit": "Fazer upload de {type} arquivos (Máx {count})",
    "Upload {type} files (Max {count})": "Fazer upload de {type} arquivos (Máx {count})",
    "attributes.value.json_format_failed": "JSON inválido - não pode ser formatado",
    "Invalid JSON - cannot format": "JSON inválido - não pode ser formatado",
    "attributes.value.json_file_invalid": "Selecione um arquivo JSON válido",
    "Please select a valid JSON file": "Selecione um arquivo JSON válido",
    "attributes.value.file_empty": "Arquivo vazio",
    "File is empty": "Arquivo vazio",
    "attributes.value.json_file_parse_failed": "Arquivo JSON inválido: {message}",
    "Invalid JSON file: {message}": "Arquivo JSON inválido: {message}",
    "attributes.value.file_read_failed": "Falha ao ler o arquivo",
    "Failed to read file": "Falha ao ler o arquivo",
    "attributes.value.invalid_json": "JSON inválido",
    "Invalid JSON": "JSON inválido",
    "attributes.value.json_editor_help": "Faça upload de um arquivo JSON ou digite/cole JSON diretamente",
    "Upload a JSON file or type/paste JSON directly": "Faça upload de um arquivo JSON ou digite/cole JSON diretamente",
    "attributes.value.hex_color_code": "Código de cor Hex",
    "Hex Color Code": "Código de cor Hex",
    "attributes.value.multi_text_placeholder": "Digite e pressione Enter ou vírgula para adicionar",
    "Type and press Enter or comma to add": "Digite e pressione Enter ou vírgula para adicionar",
    "attributes.value.multi_text_help": "Pressione Enter ou vírgula para adicionar cada item",
    "Press Enter or comma to add each item": "Pressione Enter ou vírgula para adicionar cada item",
    "attributes.value.item_count": "{count} item",
    "{count} item": "{count} item",
    "attributes.value.items_count": "{count} itens",
    "attributes.value.search_options": "Pesquisar {name}...",
    "Search {name}...": "Pesquisar {name}...",
    "attributes.value.selected_count": "{count} selecionados",
    "attributes.value.no_options_found": "Nenhuma opção encontrada",
    "No options found": "Nenhuma opção encontrada",
    "attributes.value.select_named_option": "Selecione {name}",
    "Select {name}": "Selecione {name}",
    "attributes.value.enable_option": "Habilite esta opção",
    "Enable this option": "Habilite esta opção",
    "attributes.value.enter_named_value": "Insira {name}",
    "Enter {name}": "Insira {name}",
    "common.valid": "Válido",
    "Valid": "Válido",
    "common.invalid": "Inválido",
    "Invalid": "Inválido",
    "common.go_back_home": "Voltar para a página inicial",
    "Go back home": "Voltar para a página inicial",
    "attributes.value.enter_named_text": "Insira {name}...",
    "Enter {name}...": "Insira {name}...",
    "listings.analytics.page_views": "Visualizações de página",
    "listings.analytics.unique_visitors": "Visitantes únicos",
    "listings.analytics.sessions": "Sessões",
    "listings.analytics.clicks": "Cliques",
    "listings.analytics.goals": "Objetivos",
    "listings.analytics.bot_views": "Visualizações de bot",
    "listings.detail_summary.buyers": "Compradores",
    "Buyers": "Compradores",
    "listings.detail_summary.orders": "Pedidos",
    "listings.detail_summary.revenue": "Receitas",
    "listings.detail_summary.average_order": "Média de pedido",
    "listings.add_advanced": "Avançado",
    "listings.add_audio": "Adicionar áudio",
    "Add Audio": "Adicionar áudio",
    "payments.updated_successfully": "Atualizado com sucesso",
    "Updated successfully": "Atualizado com sucesso",
    "users.deleted_successfully": "Usuário excluído com sucesso",
    "User deleted successfully": "Usuário excluído com sucesso",
    "users.deletion_failed": "Falha na exclusão do usuário",
    "User deletion failed": "Falha na exclusão do usuário",
    "accounts.flow.title": "Configure a experiência da conta",
    "Shape the account experience": "Configure a experiência da conta",
    "accounts.flow.description": "Organize os tipos de conta e defina as informações que cada conta precisa.",
    "Organize account types and define the information each account needs.": "Organize os tipos de conta e defina as informações que cada conta precisa.",
    "accounts.flow.lane_title": "Fundação da conta",
    "Account foundation": "Fundação da conta",
    "accounts.flow.badge": "Estrutura",
    "Structure": "Estrutura",
    "accounts.flow.node_accounts": "Contas",
    "accounts.flow.node_categories": "Categorias",
    "accounts.flow.node_attributes": "Atributos",
    "accounts.flow.lane_description": "Dê a cada conta um local claro, tipo e um conjunto de detalhes úteis.",
    "Give every account a clear place, type, and set of useful details.": "Dê a cada conta um local claro, tipo e um conjunto de detalhes úteis.",
    "accounts.flow.primary_action": "Adicione sua primeira conta",
    "Add your first account": "Adicione sua primeira conta",
    "listings.flow.title": "Construa seu catálogo de listagens",
    "Build your listing catalog": "Construa seu catálogo de listagens",
    "listings.flow.description": "Crie um catálogo estruturado com categorias, atributos e variantes.",
    "Create a structured catalog with categories, attributes, and variants.": "Crie um catálogo estruturado com categorias, atributos e variantes.",
    "listings.flow.lane_title": "Caminho do catálogo",
    "Catalog path": "Caminho do catálogo",
    "listings.flow.badge": "Construir",
    "Build": "Construir",
    "listings.flow.node_listings": "Listagens",
    "listings.flow.node_categories": "Categorias",
    "listings.flow.node_attributes": "Atributos",
    "listings.flow.node_variants": "Variantes",
    "listings.flow.lane_description": "Defina o que você vende e a informação que os clientes precisam para escolher.",
    "Define what you sell and the information customers need to make a choice.": "Defina o que você vende e a informação que os clientes precisam para escolher.",
    "listings.flow.primary_action": "Adicione sua primeira listagem",
    "Add your first listing": "Adicione sua primeira listagem",
    "collections.flow.title": "Reúna todo o conteúdo do seu mercado",
    "Bring your marketplace content together": "Reúna todo o conteúdo do seu mercado",
    "collections.flow.description": "Agrupe listagens e contas em coleções curadas que são fáceis de descobrir e gerenciar.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Agrupe listagens e contas em coleções curadas que são fáceis de descobrir e gerenciar.",
    "collections.flow.lane_title": "Caminho da coleção",
    "Collection path": "Caminho da coleção",
    "collections.flow.badge": "Curar",
    "Curate": "Curar",
    "collections.flow.node_collections": "Coleções",
    "collections.flow.node_rules": "Regras",
    "collections.flow.node_listings": "Listagens",
    "collections.flow.lane_description": "Escolha o que pertence juntos e torne fácil para os clientes encontrarem.",
    "Choose what belongs together and make it easy for customers to find.": "Escolha o que pertence juntos e torne fácil para os clientes encontrarem.",
    "collections.flow.audience_lane_title": "Caminho da audiência",
    "Audience path": "Caminho da audiência",
    "collections.flow.audience_badge": "Conectar",
    "collections.flow.node_accounts": "Contas",
    "collections.flow.node_users": "Usuários",
    "collections.flow.node_storefront": "Loja",
    "Storefront": "Loja",
    "collections.flow.audience_description": "Conecte conteúdo selecionado às pessoas e lojas para as quais é destinado.",
    "Connect curated content to the people and storefronts it is meant for.": "Conecte conteúdo selecionado às pessoas e lojas para as quais é destinado.",
    "collections.flow.primary_action": "Crie sua primeira coleção",
    "listings.addon.image_limit": "Você não pode selecionar mais imagens",
    "listings.schedule.start_time_before_end": "O horário de início deve ser antes do horário de término",
    "Start time must be before the end time": "O horário de início deve ser antes do horário de término",
    "listings.schedule.end_time_after_start": "O horário de término deve ser após o horário de início",
    "End time must be after the start time": "O horário de término deve ser após o horário de início",
    "listings.schedule.repeat_required": "Selecione um padrão de repetição",
    "Select a repeat pattern": "Selecione um padrão de repetição",
    "listing_variants.form.select_type": "Selecione o tipo de variante",
    "Select variant type": "Selecione o tipo de variante",
    "listing_variants.form.select_type_values": "Selecione os valores de variante",
    "Select variant values": "Selecione os valores de variante",
    "listing_variants.form.add_variant": "Adicionar variante",
    "listing_variants.form.edit_variant": "Editar variante",
    "Edit variant": "Editar variante",
    "listing_variants.form.variant_type": "Tipo de variante",
    "Variant type": "Tipo de variante",
    "listing_variants.form.variant_type_value": "Valor da variante",
    "Variant value": "Valor da variante",
    "listing_variants.form.variant_name": "Nome da variante",
    "Variant name": "Nome da variante",
    "listing_variants.form.description_placeholder": "Insira descrição",
    "rewards.item_archived": "Arquivado",
    "listings.confirm_delete_variant": "Tem certeza de que deseja excluir esta variante?",
    "listings.confirm_delete_listing": "Tem certeza de que deseja excluir esta lista?",
    "listing_form.digital_delete_confirm": "Tem certeza de que deseja excluir este conteúdo digital?",
    "Are you sure you want to delete this digital content?": "Tem certeza de que deseja excluir este conteúdo digital?",
    "category.confirm_delete_attribute": "Deseja excluir este atributo?",
    "common.permission_required": "Você não tem permissão para executar esta ação.",
    "You do not have permission to perform this action.": "Você não tem permissão para executar esta ação.",
    "common.copied": "Copiado",
    "attributes.editor_name_required": "Por favor, insira o nome do atributo",
    "onboarding.full_step.setup_payments.description": "Habilite transações reais para que os usuários completem a intenção sem atrito.",
    "Enable real transactions so users can complete intent without friction.": "Habilite transações reais para que os usuários completem a intenção sem atrito.",
    "onboarding.full_step.setup_payments.cta": "Configurar pagamentos",
    "Setup payments": "Configurar pagamentos",
    "onboarding.full_step.setup_payments.impact": "Caminho de receita habilitado.",
    "Revenue path enabled.": "Caminho de receita habilitado.",
    "onboarding.full_step.setup_payments.creator_description": "Prepare o caminho para que sua audiência compre ou apoie seu trabalho.",
    "Prepare the path for your audience to purchase or support your work.": "Prepare o caminho para que sua audiência compre ou apoie seu trabalho.",
    "onboarding.full_step.setup_delivery.description": "Defina como o pedido será cumprido para que o checkout seja previsível para os usuários.",
    "onboarding.full_step.setup_delivery.impact": "Caminho de cumprimento claro.",
    "Fulfillment path clear.": "Caminho de cumprimento claro.",
    "onboarding.full_step.add_promotion.description": "Crie sua primeira promoção para aumentar a taxa de ação na primeira sessão.",
    "Create your first promotion to increase first-session action rate.": "Crie sua primeira promoção para aumentar a taxa de ação na primeira sessão.",
    "onboarding.full_step.add_promotion.impact": "Conversão mais forte durante o lançamento.",
    "Stronger conversion during launch.": "Conversão mais forte durante o lançamento.",
    "onboarding.full_step.create_coupon.description": "Teste descontos e melhore a ativação para primeiros compradores ou membros.",
    "Test discounts and improve activation for first-time buyers or members.": "Teste descontos e melhore a ativação para primeiros compradores ou membros.",
    "onboarding.full_step.create_coupon.impact": "Lazo da primeira oferta desbloqueado.",
    "First-offer loop unlocked.": "Lazo da primeira oferta desbloqueado.",
    "onboarding.full_step.collections_setup.description": "Organize listagens de alto interesse para melhorar o descobrimento e o fluxo de navegação.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Organize listagens de alto interesse para melhorar o descobrimento e o fluxo de navegação.",
    "onboarding.full_step.collections_setup.impact": "Navegação e descoberta melhoradas.",
    "Navigation and discovery improved.": "Navegação e descoberta melhoradas.",
    "onboarding.full_step.configure_comms.description": "Torne as notificações pós-inscrição e de pedidos prontas para produção antes do crescimento.",
    "Make post-signup and order notifications production-ready before growth.": "Torne as notificações pós-inscrição e de pedidos prontas para produção antes do crescimento.",
    "onboarding.full_step.configure_comms.impact": "Mensagens de ciclo de vida prontas.",
    "Lifecycle messaging ready.": "Mensagens de ciclo de vida prontas.",
    "onboarding.full_step.customize_attributes.description": "Adicione campos estruturados para que os usuários possam filtrar e comparar o que importa.",
    "onboarding.full_step.customize_attributes.impact": "Busca e conversão melhoradas.",
    "Better search and conversion.": "Busca e conversão melhoradas.",
    "onboarding.full_step.customize_attributes.creator_description": "Adicione os detalhes que ajudam as pessoas a entender e comparar o que você cria.",
    "Add the details that help people understand and compare what you create.": "Adicione os detalhes que ajudam as pessoas a entender e comparar o que você cria.",
    "onboarding.full_step.add_digital_asset.description": "Expanda o catálogo inicial para que os usuários avaliem a qualidade e o surtido.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Expanda o catálogo inicial para que os usuários avaliem a qualidade e o surtido.",
    "onboarding.full_step.add_digital_asset.impact": "Credibilidade do catálogo digital melhorada.",
    "Digital catalog credibility improved.": "Credibilidade do catálogo digital melhorada.",
    "onboarding.full_step.open_live_site.description": "Comece com o que os clientes veem. Isso faz com que o produto pareça real antes que a configuração se torne abstrata.",
    "onboarding.full_step.open_live_site.impact": "Confirma que o projeto já está ao vivo.",
    "onboarding.full_step.add_first_product.description": "Publique o primeiro produto, serviço ou recurso que você quer que sua audiência descubra.",
    "Publish the first product, service, or resource you want your audience to discover.": "Publique o primeiro produto, serviço ou recurso que você quer que sua audiência descubra.",
    "onboarding.full_step.add_first_product.impact": "Cria sua primeira oferta pronta para audiência.",
    "Creates your first audience-ready offer.": "Cria sua primeira oferta pronta para audiência.",
    "onboarding.full_step.customize_attributes.creator_impact": "Torna sua oferta mais fácil de entender.",
    "Makes your offer easier to understand.": "Torna sua oferta mais fácil de entender.",
    "onboarding.full_step.setup_payments.creator_impact": "Desbloqueia o caminho para a receita.",
    "listings.detail_preview_fx.title": "Visualização FX",
    "Preview FX": "Visualização FX",
    "listings.detail_preview_fx.base": "Base",
    "Base": "Base",
    "listings.detail_preview_fx.description": "Veja este anúncio em cada moeda ativa.",
    "See this listing in each active currency.": "Veja este anúncio em cada moeda ativa.",
    "listings.detail_preview_fx.refresh": "Atualizar visualização",
    "Refresh preview": "Atualizar visualização",
    "listings.detail_preview_fx.loading_rates": "Carregando taxas de câmbio…",
    "Loading exchange rates…": "Carregando taxas de câmbio…",
    "listings.detail_preview_fx.load_hint": "Selecione Visualização FX para carregar as taxas atuais.",
    "Select Preview FX to load current rates.": "Selecione Visualização FX para carregar as taxas atuais.",
    "listings.detail_preview_fx.preview_note": "Visualização apenas. Os preços salvos do anúncio permanecem inalterados.",
    "Preview only. Saved listing prices remain unchanged.": "Visualização apenas. Os preços salvos do anúncio permanecem inalterados.",
    "listings.detail_preview_fx.listing": "Anúncio",
    "listings.detail_preview_fx.variant": "Variante",
    "Variant": "Variante",
    "listings.detail_event_booking.event_details": "Detalhes do evento",
    "Event Details": "Detalhes do evento",
    "listings.detail_event_booking.booking_details": "Detalhes da reserva",
    "Booking Details": "Detalhes da reserva",
    "listings.unassigned_location": "Localização não atribuída",
    "Unassigned location": "Localização não atribuída",
    "listings.no_ratings_yet": "Ainda não há avaliações.",
    "No ratings yet": "Ainda não há avaliações.",
    "listing_form.loading_listing": "Carregando anúncio…",
    "Loading listing…": "Carregando anúncio…",
    "listing_form.preparing_form": "Preparando formulário…",
    "Preparing form…": "Preparando formulário…",
    "listing_form.edit_listing": "Editar anúncio",
    "Edit Listing": "Editar anúncio",
    "listing_form.add_new_listing": "Adicionar novo anúncio",
    "Add New Listing": "Adicionar novo anúncio",
    "workspace.catalog.templates": "Modelos",
    "Templates": "Modelos",
    "workspace.catalog.integrations": "Integrações",
    "workspace.catalog.template": "Modelo",
    "Template": "Modelo",
    "workspace.catalog.integration": "Integração",
    "workspace.catalog.templates_heading": "Escolha um modelo para iniciar sua Ideia",
    "Choose a template to kickstart your Idea": "Escolha um modelo para iniciar sua Ideia",
    "workspace.catalog.integrations_heading": "Integrações para Aplicativos Web Hospedados",
    "Integrations for Hosted Web Apps": "Integrações para Aplicativos Web Hospedados",
    "workspace.catalog.templates_description": "Comece com um modelo pré-construído e personalize-o para sua plataforma.",
    "Start with a prebuilt template and customise it for your marketplace.": "Comece com um modelo pré-construído e personalize-o para sua plataforma.",
    "workspace.catalog.integrations_description": "Conecte seu espaço de trabalho às ferramentas e serviços que você já usa.",
    "Connect your workspace to the tools and services you already use.": "Conecte seu espaço de trabalho às ferramentas e serviços que você já usa.",
    "workspace.catalog.no_templates": "Nenhum modelo disponível no momento.",
    "No templates available at the moment.": "Nenhum modelo disponível no momento.",
    "workspace.catalog.no_integrations": "Nenhuma integração disponível no momento.",
    "No integrations available at the moment.": "Nenhuma integração disponível no momento.",
    "workspace.catalog.coming_soon": "Em breve",
    "Coming Soon": "Em breve",
    "workspace.catalog.configure": "Configurar",
    "workspace.catalog.custom_development": "Desenvolvimento personalizado de {type}",
    "Custom {type} Development": "Desenvolvimento personalizado de {type}",
    "workspace.catalog.custom_help": "Procurando algo personalizado? Contate-nos para um orçamento.",
    "Looking for something custom? Contact us for a quote.": "Procurando algo personalizado? Contate-nos para um orçamento.",
    "workspace.catalog.contact_quote": "Contate-nos para um orçamento",
    "Contact for a Quote": "Contate-nos para um orçamento",
    "users.select_user": "Selecionar Usuário",
    "Select User": "Selecionar Usuário",
    "developer.api_keys.paid_feature_title": "O acesso à API é um recurso pago",
    "API access is a paid feature": "O acesso à API é um recurso pago",
    "developer.api_keys.paid_feature_description": "Escolha um plano pago para visualizar, copiar e usar suas Chaves Publicáveis e Secretas.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Escolha um plano pago para visualizar, copiar e usar suas Chaves Publicáveis e Secretas.",
    "developer.api_keys.available_on_paid_plans": "Disponível em planos pagos",
    "Available on paid plans": "Disponível em planos pagos",
    "developer.api_keys.view_plans": "Ver planos",
    "currency.rates.title": "Taxas de câmbio atuais",
    "Current FX rates": "Taxas de câmbio atuais",
    "currency.rates.base": "Base:",
    "Base:": "Base:",
    "currency.rates.source": "· Fonte:",
    "· Source:": "· Fonte:",
    "currency.rates.cached_up_to": "Cache até {hours}h",
    "Cached up to {hours}h": "Cache até {hours}h",
    "currency.rates.refresh": "Atualizar taxas",
    "Refresh rates": "Atualizar taxas",
    "currency.rates.currency": "Moeda",
    "currency.rates.one_base_equals": "1 {code} equivale a",
    "1 {code} equals": "1 {code} equivale a",
    "currency.rates.empty": "Adicione uma moeda ativa para ver sua taxa de câmbio.",
    "Add an active currency to see its exchange rate.": "Adicione uma moeda ativa para ver sua taxa de câmbio.",
    "currency.rates.manual": "Taxas manuais",
    "Manual rates": "Taxas manuais",
    "currency.rates.load_error": "Não foi possível carregar as taxas de câmbio.",
    "Unable to load exchange rates.": "Não foi possível carregar as taxas de câmbio.",
    "chats.title": "Chat do cliente",
    "Customer chat": "Chat do cliente",
    "chats.conversations": "Conversas",
    "Conversations": "Conversas",
    "chats.empty_conversations": "Ainda não há conversas com clientes.",
    "No customer conversations yet.": "Ainda não há conversas com clientes.",
    "chats.customer_id": "Cliente {id}",
    "Customer {id}": "Cliente {id}",
    "chats.no_messages_yet": "Ainda não há mensagens.",
    "No messages yet": "Ainda não há mensagens.",
    "chats.conversation_id": "Conversa #{id}",
    "Conversation #{id}": "Conversa #{id}",
    "chats.status.closed": "fechada",
    "closed": "fechada",
    "chats.status.open": "aberta",
    "chats.reopen": "Reabrir",
    "Reopen": "Reabrir",
    "chats.close_conversation": "Fechar conversa",
    "Close conversation": "Fechar conversa",
    "chats.your_team": "Seu time",
    "Your team": "Seu time",
    "chats.empty_messages": "Ainda não há mensagens nesta conversa.",
    "No messages in this conversation yet.": "Ainda não há mensagens nesta conversa.",
    "chats.write_reply": "Escreva uma resposta",
    "Write a reply": "Escreva uma resposta",
    "chats.send": "Enviar",
    "Send": "Enviar",
    "chats.select_conversation": "Selecione uma conversa para ver suas mensagens.",
    "Select a conversation to view its messages.": "Selecione uma conversa para ver suas mensagens.",
    "chats.error.session_not_ready": "Sua sessão não está pronta. Atualize a página e tente novamente.",
    "Your session is not ready. Refresh the page and try again.": "Sua sessão não está pronta. Atualize a página e tente novamente.",
    "chats.error.request_failed": "A solicitação de chat falhou ({status})",
    "Chat request failed ({status})": "A solicitação de chat falhou ({status})",
    "chats.error.load_conversations": "Não foi possível carregar as conversas.",
    "Could not load conversations.": "Não foi possível carregar as conversas.",
    "chats.error.load_messages": "Não foi possível carregar as mensagens.",
    "Could not load messages.": "Não foi possível carregar as mensagens.",
    "chats.error.send_message": "Não foi possível enviar a mensagem.",
    "Message could not be sent.": "Não foi possível enviar a mensagem.",
    "chats.error.update_status": "Não foi possível atualizar o status da conversa.",
    "Conversation status could not be updated.": "Não foi possível atualizar o status da conversa.",
    "accounts.select_account": "Selecione Conta",
    "common.accounts": "Contas",
    "common.listings": "Listagens",
    "communications.loading_preview": "Carregando prévia…",
    "Loading preview…": "Carregando prévia…",
    "communications.no_preview": "Sem prévia",
    "No preview": "Sem prévia",
    "collections.choose_type": "Escolher {type}",
    "Choose {type}": "Escolher {type}",
    "collections.create_type_category_first": "Crie a categoria de {type} primeiro",
    "Create {type} category first": "Crie a categoria de {type} primeiro",
    "web_config.customisation": "Personalização da web",
    "web_config.configuration": "Configuração da web",
    "Web Configuration": "Configuração da web",
    "web_config.section_general": "Geral",
    "web_config.section_social": "Social",
    "web_config.section_footer": "Rodapé",
    "web_config.assets": "Recursos",
    "Assets": "Recursos",
    "web_config.small_logo": "Pequeno logotipo",
    "Small logo": "Pequeno logotipo",
    "attributes.edit_attribute": "Editar atributo",
    "currency.rate_managed_automatically": "A taxa é gerenciada automaticamente.",
    "Rate is managed automatically.": "A taxa é gerenciada automaticamente.",
    "navigation.add_or_manage_mini_apps": "Adicionar ou gerenciar Mini Apps",
    "Add or manage Mini Apps": "Adicionar ou gerenciar Mini Apps",
    "listings.import.download_type_template": "Baixar modelo {type}",
    "navigation.promo_banner": "Obtenha {percent}% de desconto! Apenas para clientes novos. Use o código: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Obtenha {percent}% de desconto! Apenas para clientes novos. Use o código: {code}.",
    "orders.cash_refund_recorded": "Reembolso em dinheiro registrado. A reversão contábil foi agendada.",
    "Cash refund recorded. The accounting reversal has been queued.": "Reembolso em dinheiro registrado. A reversão contábil foi agendada.",
    "orders.cash_refund_failed": "Não foi possível registrar o reembolso em dinheiro. Verifique o status do pagamento do pedido e o histórico de reembolsos.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Não foi possível registrar o reembolso em dinheiro. Verifique o status do pagamento do pedido e o histórico de reembolsos.",
    "orders.recording_cash_refund": "Registrando reembolso…",
    "Recording refund…": "Registrando reembolso…",
    "orders.record_cash_refund": "Registrar reembolso em dinheiro",
    "Record cash refund": "Registrar reembolso em dinheiro",
    "orders.confirm_cash_refund": "Confirmar reembolso em dinheiro",
    "Confirm cash refund": "Confirmar reembolso em dinheiro",
    "orders.cash_refund_order_amount": "Registrar um reembolso em dinheiro completo de {amount} para o pedido {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "Registrar um reembolso em dinheiro completo de {amount} para o pedido {reference}?",
    "orders.cash_refund_manual_notice": "Isso registra um reembolso manual de dinheiro/COD e enfileira sua reversão contábil. Nenhum provedor de pagamento será contatado.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Isso registra um reembolso manual de dinheiro/COD e enfileira sua reversão contábil. Nenhum provedor de pagamento será contatado.",
    "currency_conversion.title": "Conversão de moeda",
    "Currency conversion": "Conversão de moeda",
    "currency_conversion.open_settings": "Configurações de conversão",
    "Conversion settings": "Configurações de conversão",
    "currency_conversion.load_failed": "Não foi possível carregar as configurações de conversão de moeda.",
    "Could not load currency conversion settings.": "Não foi possível carregar as configurações de conversão de moeda.",
    "currency_conversion.interval_error": "O intervalo de atualização deve estar entre 5 minutos e 24 horas.",
    "Refresh interval must be between 5 minutes and 24 hours.": "O intervalo de atualização deve estar entre 5 minutos e 24 horas.",
    "currency_conversion.save_failed": "Não foi possível salvar as configurações de conversão de moeda.",
    "Could not save currency conversion settings.": "Não foi possível salvar as configurações de conversão de moeda.",
    "currency_conversion.saved": "Configurações de conversão de moeda salvas.",
    "Currency conversion settings saved.": "Configurações de conversão de moeda salvas.",
    "currency_conversion.description": "Escolha como as conversões de moeda exibidas são calculadas.",
    "Choose how displayed currency conversions are calculated.": "Escolha como as conversões de moeda exibidas são calculadas.",
    "currency_conversion.manual_title": "Taxas manuais",
    "currency_conversion.manual_help": "Use a taxa de câmbio inserida para cada moeda abaixo.",
    "Use the exchange rate entered for each currency below.": "Use a taxa de câmbio inserida para cada moeda abaixo.",
    "currency_conversion.frankfurter_title": "Frankfurter (padrão)",
    "Frankfurter (default)": "Frankfurter (padrão)",
    "currency_conversion.frankfurter_help": "Taxas de câmbio gratuitas diariamente. Nenhuma chave de API do provedor é necessária.",
    "Free daily exchange rates. No provider API key is required.": "Taxas de câmbio gratuitas diariamente. Nenhuma chave de API do provedor é necessária.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Use o serviço Fixer gerenciado pela plataforma. Atualizações de taxa dependem do plano do provedor.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Use o serviço Fixer gerenciado pela plataforma. Atualizações de taxa dependem do plano do provedor.",
    "currency_conversion.refresh_interval": "Intervalo de revisão de taxas (minutos)",
    "Rate re-check interval (minutes)": "Intervalo de revisão de taxas (minutos)",
    "workspace.currency_search_code": "Pesquisar ou selecionar",
    "Search or select": "Pesquisar ou selecionar",
    "workspace.currency_preset_hint": "Valores padrão recomendados aplicados. Você pode editar qualquer campo.",
    "Recommended defaults applied. You can edit any field.": "Valores padrão recomendados aplicados. Você pode editar qualquer campo.",
    "developer.api_keys.copy_unavailable": "A chave não está disponível ainda.",
    "Key is not available yet.": "A chave não está disponível ainda.",
    "developer.api_keys.copy_failed": "Não foi possível copiar a chave. Tente novamente.",
    "Unable to copy the key. Try again.": "Não foi possível copiar a chave. Tente novamente.",
    "payroll.action.export_pdf": "Exportar PDF",
    "Export PDF": "Exportar PDF",
    "cms.category.name_prompt": "Nome da categoria",
    "cms.field.cover_image": "Imagem de capa",
    "Cover Image": "Imagem de capa",
    "cms.action.add_cover_photo": "Adicionar foto de capa",
    "Add cover photo": "Adicionar foto de capa",
    "cms.field.category": "Categoria",
    "cms.category.none": "Sem categoria",
    "No category": "Sem categoria",
    "cms.advanced": "Avançado",
    "media_picker.action.select_image": "Selecionar imagem",
    "Select image": "Selecionar imagem",
    "orders.confirm_record_cash_refund": "Registrar reembolso",
    "Record refund": "Registrar reembolso",
    "listing_form.no_repeat": "Não repetir",
    "No repeat": "Não repetir",
    "listing_form.custom_repeat_days": "Personalizado: {days}",
    "Custom: {days}": "Personalizado: {days}",
    "common.sending": "Enviando…",
    "listings.detail.unique_name": "Nome único",
    "Unique Name": "Nome único",
    "app_customization.username": "Nome de usuário",
    "workspace.templates.name_required": "Nome do modelo é obrigatório.",
    "Template name is required.": "Nome do modelo é obrigatório.",
    "workspace.templates.saved": "Modelo de papel salvo.",
    "Role template saved.": "Modelo de papel salvo.",
    "workspace.templates.confirm_delete": "Excluir modelo \"{name}\"?",
    "Delete template \"{name}\"?": "Excluir modelo \"{name}\"?",
    "workspace.templates.deleted": "Modelo excluído.",
    "Template deleted.": "Modelo excluído.",
    "workspace.members.tab_members": "Membros",
    "workspace.templates.tab": "Modelos de papel",
    "Role Templates": "Modelos de papel",
    "workspace.templates.title": "Modelos de papel",
    "workspace.templates.new": "Novo modelo",
    "New Template": "Novo modelo",
    "workspace.templates.name": "Nome",
    "workspace.templates.empty": "Ainda não há modelos de papel.",
    "No role templates yet.": "Ainda não há modelos de papel.",
    "workspace.templates.edit": "Editar modelo",
    "Edit Template": "Editar modelo",
    "workspace.templates.name_label": "Nome do modelo",
    "Template name": "Nome do modelo",
    "workspace.templates.name_placeholder": "ex. Gerente de conteúdo",
    "e.g. Content Manager": "ex. Gerente de conteúdo",
    "listings.import.unknown_error": "As categorias não puderam ser importadas. Verifique o CSV e tente novamente.",
    "The categories could not be imported. Please check the CSV and try again.": "As categorias não puderam ser importadas. Verifique o CSV e tente novamente.",
    "common.no_access_to_page": "Sem acesso",
    "No access": "Sem acesso",
    "common.permission_to_view_page_denied": "Você não tem permissão para visualizar esta página.",
    "You do not have permission to view this page.": "Você não tem permissão para visualizar esta página.",
    "common.loading_permissions": "Carregando permissões…",
    "Loading permissions…": "Carregando permissões…",
    "attributes.added_successfully": "Legal 🎉, Atributos adicionados com sucesso!",
    "Nice 🎉, Successfully added attributes": "Legal 🎉, Atributos adicionados com sucesso!",
    "attributes.add_attribute_values": "Adicionar valores de atributo",
    "attributes.attribute": "Atributo",
    "attributes.optional": "Opcional",
    "attributes.private": "Privado",
    "attributes.hidden_field": "Campo oculto",
    "attributes.show_in_filter": "Mostrar no filtro",
    "attributes.status_not_active_active": "Status (Não ativo / Ativo)",
    "attributes.add_metadata": "Adicionar metadados",
    "Add metadata": "Adicionar metadados",
    "attributes.select_date_time": "Selecionar data e hora",
    "listings.addons.column_title": "Título",
    "listings.addons.column_image": "Imagem",
    "listings.addons.column_price": "Preço",
    "listings.addons.column_max_quantity": "Quantidade máxima",
    "Max Quantity": "Quantidade máxima",
    "listings.addons.column_offer": "Oferta",
    "listings.addons.column_stock": "Estoque",
    "listings.addons.column_action": "Ação",
    "listings.addons.column_status": "Status",
    "listings.addons.confirm_delete": "Você quer excluir este tipo de complemento?",
    "Do you want to delete this add-on type?": "Você quer excluir este tipo de complemento?",
    "common.share_collection": "Compartilhar coleção",
    "Share collection": "Compartilhar coleção",
    "communications.view_modes": "Modos de visualização de comunicação",
    "Communication view modes": "Modos de visualização de comunicação",
    "payments.accessibility.gateway_logo": "Logotipo da gateway de pagamento",
    "Payment gateway logo": "Logotipo da gateway de pagamento",
    "common.build_version": "Versão do build",
    "Build version": "Versão do build",
    "common.build_label": "compilação",
    "build": "compilação",
    "listings.under_category_title": "Listagens sob {category}",
    "Listings under {category}": "Listagens sob {category}",
    "attributes.signup": "Cadastro",
    "Signup": "Cadastro",
    "common.toast.please_check_action": "Por favor, verifique esta ação",
    "Please check this action": "Por favor, verifique esta ação",
    "common.information": "Informação",
    "listing_form.error.load_listing_data": "Falha ao carregar os dados do listagem",
    "Failed to load listing data": "Falha ao carregar os dados do listagem",
    "listing_form.error.load_digital_contents": "Falha ao carregar os conteúdos digitais",
    "Failed to load digital contents": "Falha ao carregar os conteúdos digitais",
    "listing_form.validation.audio_file_or_url_required": "Adicione um arquivo de áudio ou URL pública de áudio antes de criar o episódio.",
    "Add an audio file or public audio URL before creating the episode.": "Adicione um arquivo de áudio ou URL pública de áudio antes de criar o episódio.",
    "listing_form.validation.rental_rate_greater_than_zero": "Insira uma taxa de aluguel maior que 0.",
    "Enter a rental rate greater than 0.": "Insira uma taxa de aluguel maior que 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "A duração máxima deve ser maior ou igual à duração mínima.",
    "Maximum duration must be greater than or equal to minimum duration.": "A duração máxima deve ser maior ou igual à duração mínima.",
    "listing_form.updated_successfully": "Listagem atualizada com sucesso",
    "Listing updated successfully!": "Listagem atualizada com sucesso",
    "listing_form.created_successfully": "Listagem criada com sucesso",
    "Listing created successfully!": "Listagem criada com sucesso",
    "listing_form.error.save_failed": "Falha ao salvar a listagem. Por favor, tente novamente.",
    "Failed to save listing. Please try again.": "Falha ao salvar a listagem. Por favor, tente novamente.",
    "listing_form.error.delete_variant_failed": "Falha ao excluir a variante: {title}",
    "Failed to delete variant: {title}": "Falha ao excluir a variante: {title}",
    "listing_form.error.variant_action_failed": "Falha ao {action} a variante: {title}",
    "Failed to {action} variant: {title}": "Falha ao {action} a variante: {title}",
    "listing_form.error.digital_content_action_failed": "Falha ao {action} o conteúdo digital: {title}",
    "Failed to {action} digital content: {title}": "Falha ao {action} o conteúdo digital: {title}",
    "listing_form.action.create": "criar",
    "listing_form.action.update": "atualizar",
    "listing_form.action.delete": "excluir",
    "delete": "excluir",
    "listing_form.error.save_request_failed": "Falha ao salvar a listagem",
    "Failed to save listing": "Falha ao salvar a listagem",
    "listing_form.error.rental_settings_save_failed": "Listagem salva, mas os ajustes de aluguel não puderam ser salvos.",
    "Listing saved, but rental settings could not be saved.": "Listagem salva, mas os ajustes de aluguel não puderam ser salvos.",
    "users.action_failed": "A ação falhou. Por favor, tente novamente.",
    "Action failed. Please try again.": "A ação falhou. Por favor, tente novamente.",
    "common.successfully_added": "Adicionado com sucesso",
    "Successfully added": "Adicionado com sucesso",
    "listing_form.validation.title_min_length": "O título deve ter pelo menos {count} caracteres",
    "Title must be at least {count} characters": "O título deve ter pelo menos {count} caracteres",
    "listing_form.validation.title_max_length": "O título não deve exceder {count} caracteres",
    "Title must not exceed {count} characters": "O título não deve exceder {count} caracteres",
    "listing_form.validation.price_minimum": "O preço deve ser pelo menos {amount}",
    "Price must be at least {amount}": "O preço deve ser pelo menos {amount}",
    "listing_form.validation.attribute_required": "{attribute} é obrigatório",
    "listings.error.load_failed": "Não foi possível carregar os anúncios",
    "Unable to load listings": "Não foi possível carregar os anúncios",
    "communications.from_email_required_before_verification": "Por favor, insira o endereço de e-mail de origem antes de verificar.",
    "Please enter From email address before verifying.": "Por favor, insira o endereço de e-mail de origem antes de verificar.",
    "communications.verification_email_sent": "Um e-mail de verificação foi enviado. Por favor, verifique sua caixa de entrada e siga as instruções para verificar este endereço de e-mail.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Um e-mail de verificação foi enviado. Por favor, verifique sua caixa de entrada e siga as instruções para verificar este endereço de e-mail.",
    "communications.verification_start_failed": "Não é possível iniciar a verificação. Por favor, tente novamente.",
    "Unable to start verification. Please try again.": "Não é possível iniciar a verificação. Por favor, tente novamente.",
    "common.uploaded_successfully": "Enviado com sucesso",
    "upgrade_page.panel.yearly": "Anual",
    "upgrade_page.panel.monthly": "Mensal",
    "orders.advance_paid": "Pago antecipado",
    "Advance paid": "Pago antecipado",
    "orders.balance_due": "Saldo devido",
    "Balance due": "Saldo devido",
    "orders.advance_invalid": "Insira um valor menor que o total do pedido.",
    "Enter an amount less than the order total.": "Insira um valor menor que o total do pedido.",
    "orders.advance_failed": "Não foi possível salvar o adiantamento.",
    "Could not save the advance.": "Não foi possível salvar o adiantamento.",
    "orders.edit_advance": "Editar adiantamento",
    "Edit advance": "Editar adiantamento",
    "orders.record_advance": "Registrar adiantamento",
    "Record advance": "Registrar adiantamento",
    "orders.advance_notice": "Valor pago pelo cliente até agora, menor que o total do pedido de {total}. O pedido permanece não pago até que você marque o saldo como pago. Insira 0 para remover o adiantamento.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Valor pago pelo cliente até agora, menor que o total do pedido de {total}. O pedido permanece não pago até que você marque o saldo como pago. Insira 0 para remover o adiantamento.",
    "orders.save_advance": "Salvar",
    "common.hide": "Ocultar",
    "listings.repeat.daily": "Diário",
    "listings.repeat.weekdays": "Dias úteis (Seg-Sex)",
    "Weekdays (Mon-Fri)": "Dias úteis (Seg-Sex)",
    "listings.repeat.weekend": "Fim de semana (Sáb-Dom)",
    "Weekend (Sat-Sun)": "Fim de semana (Sáb-Dom)",
    "listings.repeat.custom": "Personalizado",
    "listings.weekday.sun": "Dom",
    "Sun": "Dom",
    "listings.weekday.mon": "Seg",
    "Mon": "Seg",
    "listings.weekday.tue": "Ter",
    "Tue": "Ter",
    "listings.weekday.wed": "Qua",
    "Wed": "Qua",
    "listings.weekday.thu": "Qui",
    "Thu": "Qui",
    "listings.weekday.fri": "Sex",
    "Fri": "Sex",
    "listings.weekday.sat": "Sáb",
    "Sat": "Sáb",
    "orders.pay_balance": "Pagar saldo {amount}",
    "Pay balance {amount}": "Pagar saldo {amount}",
    "orders.partially_paid": "Parcialmente pago",
    "Partially paid": "Parcialmente pago",
    "orders.balance_amount": "Saldo {amount}",
    "Balance {amount}": "Saldo {amount}",
    "delivery.get_started.add_branch": "Adicionar filial",
    "Add branch": "Adicionar filial",
    "delivery.get_started.add_fleet": "Adicionar frota",
    "Add fleet": "Adicionar frota",
    "delivery.get_started.api_documentation": "Documentação da API",
    "API Documentation": "Documentação da API",
    "delivery.get_started.add_driver": "Adicionar motorista",
    "Add driver": "Adicionar motorista",
    "delivery.get_started.branch_title": "Adicione sua filial",
    "Add your branch": "Adicione sua filial",
    "delivery.get_started.branch_description": "Uma filial pode ter várias frotas e motoristas",
    "A branch can have many fleets and drivers": "Uma filial pode ter várias frotas e motoristas",
    "delivery.get_started.fleet_title": "Adicione sua frota",
    "Add your fleet": "Adicione sua frota",
    "delivery.get_started.fleet_description": "Uma frota pode ser atribuída a um motorista",
    "A fleet can be assigned to a driver": "Uma frota pode ser atribuída a um motorista",
    "delivery.get_started.driver_title": "Adicione seu motorista",
    "Add your driver": "Adicione seu motorista",
    "delivery.get_started.driver_description": "O motorista entregará seu pedido",
    "The driver will deliver your order": "O motorista entregará seu pedido",
    "delivery.get_started.order_title": "Crie seu primeiro pedido",
    "Create your first order": "Crie seu primeiro pedido",
    "delivery.get_started.order_description": "Os pedidos podem ser criados através da API",
    "Orders can be created through the API": "Os pedidos podem ser criados através da API",
    "delivery.get_started.progress.branches": "Filiais",
    "Branches": "Filiais",
    "delivery.get_started.progress.fleets": "Frotas",
    "Fleets": "Frotas",
    "delivery.get_started.progress.drivers": "Motoristas",
    "Drivers": "Motoristas",
    "delivery.get_started.progress.orders": "Pedidos de entrega",
    "Delivery Orders": "Pedidos de entrega",
    "delivery.get_started.welcome": "Boas-vindas a",
    "Welcome to": "Boas-vindas a",
    "delivery.get_started.question": "O que você gostaria de fazer?",
    "What would you like to do?": "O que você gostaria de fazer?",
    "workspace.templates.built_in": "Integrado",
    "Built-in": "Integrado",
    "workspace.templates.copy_of": "Cópia de {name}",
    "Copy of {name}": "Cópia de {name}",
    "workspace.members.role": "Função",
    "Role": "Função",
    "workspace.members.role_full_access": "Acesso completo",
    "Full access": "Acesso completo",
    "workspace.templates.duplicate": "Duplicar",
    "workspace.members.role_custom": "Personalizado (defina abaixo)",
    "Custom (set below)": "Personalizado (defina abaixo)"
  },
  "ta": {
    "0": "0",
    "6100": "6100",
    "common.language": "மொழி",
    "Language": "மொழி",
    "common.english": "ஆங்கிலம்",
    "English": "ஆங்கிலம்",
    "common.french": "பிரான்சிஸ்",
    "French": "பிரான்சிஸ்",
    "common.arabic": "அரபிய",
    "Arabic": "அரபிய",
    "navigation.get_started": "தொடங்கு",
    "Get Started": "தொடங்கு",
    "navigation.dashboard": "டாஷ்போர்ட்",
    "Dashboard": "டாஷ்போர்ட்",
    "navigation.orders": "ஆர்டர்கள்",
    "Orders": "ஆர்டர்கள்",
    "navigation.schedule": "விநியோகம்",
    "navigation.accounts": "கணக்குகள்",
    "Accounts": "கணக்குகள்",
    "navigation.account_categories": "கணக்கு வகைகள்",
    "Account Categories": "கணக்கு வகைகள்",
    "navigation.account_attributes": "கணக்கு பண்புகள்",
    "Account Attributes": "கணக்கு பண்புகள்",
    "navigation.account_configuration": "கணக்கு அமைப்பு",
    "Account Configuration": "கணக்கு அமைப்பு",
    "navigation.agents": "ஏஜென்ட்கள்",
    "Agents": "ஏஜென்ட்கள்",
    "navigation.listings": "பட்டியல்கள்",
    "navigation.categories": "வகைகள்",
    "navigation.custom_attributes": "மாற்றம் செய்யப்பட்ட பண்புகள்",
    "Custom Attributes": "மாற்றம் செய்யப்பட்ட பண்புகள்",
    "navigation.variant_types": "வேரியண்ட் வகைகள்",
    "Variant Types": "வேரியண்ட் வகைகள்",
    "navigation.additional_features": "கூடுதல் அம்சங்கள்",
    "Additional Features": "கூடுதல் அம்சங்கள்",
    "navigation.reported_listings": "அறிவிக்கப்பட்ட பட்டியல்கள்",
    "navigation.report_accounts": "அறிவிக்கப்பட்ட கணக்குகள்",
    "Report Accounts": "அறிவிக்கப்பட்ட கணக்குகள்",
    "navigation.users": "பயனர்கள்",
    "Users": "பயனர்கள்",
    "navigation.user_attributes": "பயனர் பண்புகள்",
    "User Attributes": "பயனர் பண்புகள்",
    "navigation.reviews_ratings": "மதிப்பீடுகள் மற்றும் மதிப்பெண்கள்",
    "navigation.report": "அறிக்கை",
    "Report": "அறிக்கை",
    "navigation.reports": "அறிக்கைகள்",
    "Reports": "அறிக்கைகள்",
    "navigation.platform_health": "தள ஆரோக்கியம்",
    "Platform Health": "தள ஆரோக்கியம்",
    "navigation.promotions": "பிரமோஷன்கள்",
    "navigation.collections": "கொள்முதல்கள்",
    "navigation.promotion_ads": "பிரமோஷன் / பிரச்சாரங்கள்",
    "Promotion / Ads": "பிரமோஷன் / பிரச்சாரங்கள்",
    "navigation.coupons": "கூப்பன்கள்",
    "Coupons": "கூப்பன்கள்",
    "navigation.finance": "நிதிகள்",
    "Finance": "நிதிகள்",
    "navigation.transactions": "மாற்றுகள்",
    "navigation.settlement": "தொகை செலுத்துதல்",
    "Settlement": "தொகை செலுத்துதல்",
    "navigation.expenses": "செலவுகள்",
    "Expenses": "செலவுகள்",
    "navigation.recurring_payments": "மீண்டும் செலுத்தும் பணம்",
    "navigation.media": "ஊடகங்கள்",
    "navigation.communication": "தகவல் தொடர்பு",
    "Communication": "தகவல் தொடர்பு",
    "navigation.web": "வலைத்தளம்",
    "Web": "வலைத்தளம்",
    "navigation.website_editor": "வலைத்தள தொகுப்பாளர்",
    "Website Editor": "வலைத்தள தொகுப்பாளர்",
    "navigation.change_templates": "வடிவமைப்புகளை மாற்றுதல்",
    "Change Templates": "வடிவமைப்புகளை மாற்றுதல்",
    "navigation.pages": "பக்கங்கள்",
    "Pages": "பக்கங்கள்",
    "navigation.blog": "பிளாக்",
    "Blog": "பிளாக்",
    "navigation.customise_texts": "தேர்வு உரைகளை தொகுத்தல்",
    "Customise texts": "தேர்வு உரைகளை தொகுத்தல்",
    "navigation.add_integrations": "ஒன்றிணைப்புகளைச் சேர்க்கவும்",
    "Add Integrations": "ஒன்றிணைப்புகளைச் சேர்க்கவும்",
    "navigation.domain": "டொமைன்",
    "Domain": "டொமைன்",
    "navigation.customise_seo": "SEO-ஐ தொகுத்தல்",
    "Customise SEO": "SEO-ஐ தொகுத்தல்",
    "navigation.app": "பயன்பாடு",
    "App": "பயன்பாடு",
    "navigation.apps": "பயன்பாடுகள்",
    "Apps": "பயன்பாடுகள்",
    "navigation.buy_app_templates": "ஆப்பிளிகேஷன் டெம்பிளேட்டுகளை வாங்கவும்",
    "Buy App Templates": "ஆப்பிளிகேஷன் டெம்பிளேட்டுகளை வாங்கவும்",
    "navigation.customisation": "தனிப்பயனாக்கம்",
    "Customisation": "தனிப்பயனாக்கம்",
    "navigation.integrations": "ஒருங்கிணைப்புகள்",
    "navigation.invite_team": "குழுவை அழைக்கவும்",
    "Invite Team": "குழுவை அழைக்கவும்",
    "navigation.help": "உதவி",
    "Help": "உதவி",
    "navigation.documentation": "ஆவணம்",
    "Documentation": "ஆவணம்",
    "navigation.community": "குழுமம்",
    "Community": "குழுமம்",
    "navigation.api_reference": "API வழிகாட்டி",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "வழித்தடம்",
    "navigation.coding_kits": "கோடிங் கிட்",
    "Coding Kits": "கோடிங் கிட்",
    "navigation.vibe_coding": "செயற்கை நுண்ணறிவு உதவியுடன் நிரலாக்கம்",
    "Vibe Coding": "செயற்கை நுண்ணறிவு உதவியுடன் நிரலாக்கம்",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "அமைப்புகள்",
    "navigation.more": "மேலும்",
    "More": "மேலும்",
    "navigation.marketplace": "மார்க்கெட்ப்ளேஸ்",
    "navigation.commerce": "வர்த்தகம்",
    "Commerce": "வர்த்தகம்",
    "navigation.marketing": "மார்க்கெட்டிங்",
    "Marketing": "மார்க்கெட்டிங்",
    "navigation.intelligence": "நுண்ணறிவு",
    "navigation.subscription": "சந்தா",
    "navigation.membership": "உறுப்பினர்",
    "navigation.rewards": "விருதுகள்",
    "Rewards": "விருதுகள்",
    "navigation.bundles": "பேக்கேஜ்கள்",
    "Bundles": "பேக்கேஜ்கள்",
    "navigation.supply_chain": "சப்ளை செயின்",
    "Supply Chain": "சப்ளை செயின்",
    "navigation.people": "மக்கள்",
    "navigation.workforce": "பணியாளர்கள்",
    "navigation.payroll": "கூட்டு பணம்",
    "navigation.inventory": "கொள்முதல்",
    "navigation.inventory_operations": "கொள்முதல் பணிகள்",
    "Inventory Operations": "கொள்முதல் பணிகள்",
    "navigation.purchase_orders": "வாங்கும் பணிகள்",
    "Purchase Orders": "வாங்கும் பணிகள்",
    "navigation.stock_locations": "கொள்முதல் இடங்கள்",
    "Stock Locations": "கொள்முதல் இடங்கள்",
    "navigation.purchase_orders_2": "வாங்கும் பணிகள்",
    "Purchase orders": "வாங்கும் பணிகள்",
    "navigation.suppliers": "மூலங்கள்",
    "navigation.locations": "இடங்கள்",
    "Locations": "இடங்கள்",
    "navigation.maps": "மேப்புகள்",
    "navigation.accounting": "கணக்கு",
    "navigation.invoices": "கணக்குகள்",
    "Invoices": "கணக்குகள்",
    "navigation.plans": "திட்டங்கள்",
    "Plans": "திட்டங்கள்",
    "navigation.countries": "நாடுகள்",
    "Countries": "நாடுகள்",
    "navigation.currency": "நாணயம்",
    "navigation.languages": "மொழிகள்",
    "Languages": "மொழிகள்",
    "navigation.payments": "கட்டணங்கள்",
    "Payments": "கட்டணங்கள்",
    "navigation.commissions": "கமிஷன்கள்",
    "Commissions": "கமிஷன்கள்",
    "navigation.taxes": "வரி",
    "navigation.special_fees": "கூடுதல் கட்டணங்கள்",
    "Special Fees": "கூடுதல் கட்டணங்கள்",
    "navigation.service_shipping": "சேவை / போக்குவரத்து",
    "navigation.checkout_cart_attributes": "கார்ட் மற்றும் செக்கவுட் அம்சங்கள்",
    "navigation.dark_mode_background_color": "இருண்ட மோட் பின்னணி நிறம்",
    "Dark Mode Background Color": "இருண்ட மோட் பின்னணி நிறம்",
    "navigation.dark_mode_text_color": "இருண்ட மோட் எழுத்து நிறம்",
    "Dark Mode Text Color": "இருண்ட மோட் எழுத்து நிறம்",
    "navigation.light_mode_background_color": "விளக்கு மோட் பின்னணி நிறம்",
    "Light Mode Background Color": "விளக்கு மோட் பின்னணி நிறம்",
    "navigation.light_mode_text_color": "விளக்கு மோட் எழுத்து நிறம்",
    "Light Mode Text Color": "விளக்கு மோட் எழுத்து நிறம்",
    "navigation.workspace": "வேலை இடம்",
    "Workspace": "வேலை இடம்",
    "navigation.user_management": "பயனர் மேலாண்மை",
    "User Management": "பயனர் மேலாண்மை",
    "navigation.privacy": "தனியுரிமை",
    "Privacy": "தனியுரிமை",
    "common.search": "தேடு...",
    "Search...": "தேடு...",
    "common.search_2": "தேடு",
    "Search": "தேடு",
    "common.no_results_found": " results கிடைக்கவில்லை",
    "No results found": " results கிடைக்கவில்லை",
    "common.no_record_found": "பதிவு கிடைக்கவில்லை",
    "No Record Found": "பதிவு கிடைக்கவில்லை",
    "common.open_in_a_new_tab": "புதிய பக்கத்தில் திறக்க",
    "Open in a new tab": "புதிய பக்கத்தில் திறக்க",
    "common.open": "திறக்க",
    "common.in_a_new_tab": "புதிய பக்கத்தில்",
    "in a new tab": "புதிய பக்கத்தில்",
    "common.loading_page": "பக்கம் ஏற்றும்…",
    "Loading page…": "பக்கம் ஏற்றும்…",
    "common.close": "மூடு",
    "Close": "மூடு",
    "common.save": "சேமி",
    "common.cancel": "ரத்து செய்",
    "common.delete": "நீக்கு",
    "common.edit": "தொகு",
    "common.add": "சேர்",
    "Add": "சேர்",
    "common.create": "உருவாக்கு",
    "Create": "உருவாக்கு",
    "common.update": "புதுப்பி",
    "common.back": "முன்னோக்கி",
    "Back": "முன்னோக்கி",
    "common.next": "அடுத்தது",
    "Next": "அடுத்தது",
    "common.previous": "முன்னர்",
    "common.done": "முடிந்தது",
    "Done": "முடிந்தது",
    "common.yes": "ஆம்",
    "Yes": "ஆம்",
    "common.no": "இல்லை",
    "No": "இல்லை",
    "common.name": "பெயர்",
    "Name": "பெயர்",
    "common.status": "நிலை",
    "Status": "நிலை",
    "common.date": "தேதி",
    "Date": "தேதி",
    "common.actions": "செயல்கள்",
    "common.action": "செயல்",
    "orders.scan_order": "ஆர்டரை ஸ்கேன் செய்யவும்",
    "Scan order": "ஆர்டரை ஸ்கேன் செய்யவும்",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "பார்கோட்/கிரேட் முகவரியை ஸ்கேன் செய்யவும் அல்லது கையால் உள்ளிடவும்.",
    "Scan a barcode/QR reference or enter it manually.": "பார்கோட்/கிரேட் முகவரியை ஸ்கேன் செய்யவும் அல்லது கையால் உள்ளிடவும்.",
    "orders.camera_scanner": "கேமரா ஸ்கேனர்",
    "Camera scanner": "கேமரா ஸ்கேனர்",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "இங்கு கேமரா ஸ்கேனிங் ஆதரிக்கப்படவில்லை. கீழே ஆர்டர் முகவரியை உள்ளிடவும்.",
    "Camera scanning is not supported here. Enter the order reference below.": "இங்கு கேமரா ஸ்கேனிங் ஆதரிக்கப்படவில்லை. கீழே ஆர்டர் முகவரியை உள்ளிடவும்.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "கேமரா அணுகல் கிடைக்கவில்லை. கீழே ஆர்டர் முகவரியை உள்ளிடவும்.",
    "Camera access is unavailable. Enter the order reference below.": "கேமரா அணுகல் கிடைக்கவில்லை. கீழே ஆர்டர் முகவரியை உள்ளிடவும்.",
    "orders.order_reference_number": "ஆர்டர் முகவரி எண்",
    "Order reference number": "ஆர்டர் முகவரி எண்",
    "orders.find_order": "ஆர்டரைத் தேடு",
    "Find order": "ஆர்டரைத் தேடு",
    "common.your_orders_will_be_shown_here": "உங்கள் ஆர்டர்கள் இங்கு காட்டப்படும்.",
    "Your orders will be shown here.": "உங்கள் ஆர்டர்கள் இங்கு காட்டப்படும்.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "இங்கு, பிற கணக்குகளுடன் செய்த ஆர்டர்கள், புகலிடங்கள் மற்றும் போன்றவற்றை கண்காணித்து, நிலை மேம்பாடுகளை பின்பற்றலாம்.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "இங்கு, பிற கணக்குகளுடன் செய்த ஆர்டர்கள், புகலிடங்கள் மற்றும் போன்றவற்றை கண்காணித்து, நிலை மேம்பாடுகளை பின்பற்றலாம்.",
    "common.reference": "முகவரி #",
    "Reference #": "முகவரி #",
    "common.amount": "தொகை",
    "Amount": "தொகை",
    "orders.order_status": "ஆர்டர் நிலை",
    "Order Status": "ஆர்டர் நிலை",
    "orders.payment_status": "பேமென்ட் நிலை",
    "Payment Status": "பேமென்ட் நிலை",
    "common.payment_method": "பேமென்ட் முறை",
    "common.shipping_method": "அனுப்பும் முறை",
    "Shipping Method": "அனுப்பும் முறை",
    "common.paid": "பேமென்ட்",
    "common.not_paid": "இல்லை",
    "Not Paid": "இல்லை",
    "common.unpaid": "இல்லை",
    "UnPaid": "இல்லை",
    "common.failed": "தோல்வி",
    "Failed": "தோல்வி",
    "common.incomplete": "முடிக்கப்படாதது",
    "Incomplete": "முடிக்கப்படாதது",
    "common.order_placed": "ஆர்டர் செய்யப்பட்டது",
    "Order placed": "ஆர்டர் செய்யப்பட்டது",
    "common.order_in_progress": "ஆர்டர் நடைபெறுகிறது",
    "Order in progress": "ஆர்டர் நடைபெறுகிறது",
    "common.shipped": "அனுப்பப்பட்டது",
    "Shipped": "அனுப்பப்பட்டது",
    "common.delivered": "அனுப்பப்பட்டது",
    "common.cancelled_by_customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "Cancelled by customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "common.order_completed": "ஆர்டர் முடிக்கப்பட்டது",
    "Order completed": "ஆர்டர் முடிக்கப்பட்டது",
    "common.n_a": "N/A",
    "orders.total_orders": "மொத்த ஆர்டர்கள்",
    "Total Orders": "மொத்த ஆர்டர்கள்",
    "orders.page_revenue": "பக்க வருமானம்",
    "Page Revenue": "பக்க வருமானம்",
    "orders.pending_payment": "தொகை காத்திருக்கிறது",
    "Pending Payment": "தொகை காத்திருக்கிறது",
    "common.failed_payments": "தோல்வியடைந்த பேமென்ட்கள்",
    "Failed payments": "தோல்வியடைந்த பேமென்ட்கள்",
    "common.abandoned": "விட்டுவிடப்பட்டது",
    "Abandoned": "விட்டுவிடப்பட்டது",
    "orders.search_orders_by_reference_number": "மேற்கோள் எண்ணைப் பயன்படுத்தி ஆர்டர்களைத் தேடவும்",
    "Search orders by reference number": "மேற்கோள் எண்ணைப் பயன்படுத்தி ஆர்டர்களைத் தேடவும்",
    "orders.search_by_reference_number": "மேற்கோள் எண்ணைப் பயன்படுத்தி தேடவும்…",
    "Search by reference number…": "மேற்கோள் எண்ணைப் பயன்படுத்தி தேடவும்…",
    "orders.export_orders_as_csv": "ஆர்டர்களை CSV ஆக ஏற்றுமதி செய்யவும்",
    "Export orders as CSV": "ஆர்டர்களை CSV ஆக ஏற்றுமதி செய்யவும்",
    "orders.manual_order": "கையேடு ஆர்டர்",
    "Manual Order": "கையேடு ஆர்டர்",
    "orders.scan_order_reference": "ஆர்டர் மேற்கோள் எண்ணை ஸ்கேன் செய்யவும்",
    "Scan order reference": "ஆர்டர் மேற்கோள் எண்ணை ஸ்கேன் செய்யவும்",
    "orders.change_status_to": "நிலையை மாற்றவும்…",
    "Change status to…": "நிலையை மாற்றவும்…",
    "common.apply": "பயன்படுத்து",
    "common.clear": "அழி",
    "orders.pay": "செலுத்து",
    "Pay": "செலுத்து",
    "orders.clear_selection": "தேர்வை அழி",
    "Clear selection": "தேர்வை அழி",
    "orders.list": "பட்டியல்",
    "orders.board": "பலகை",
    "orders.filter_orders": "ஆர்டர்களை தேர்வு செய்யவும்",
    "Filter orders": "ஆர்டர்களை தேர்வு செய்யவும்",
    "orders.start_date": "தொடக்க தேதி",
    "Start Date": "தொடக்க தேதி",
    "orders.end_date": "முடிவு தேதி",
    "End Date": "முடிவு தேதி",
    "orders.select_date": "தேதியைத் தேர்வு செய்யவும்",
    "orders.show_rows": "வரிகளைக் காட்டு",
    "Show rows": "வரிகளைக் காட்டு",
    "common.order_selected": "ஆர்டர் தேர்வு செய்யப்பட்டது",
    "order selected": "ஆர்டர் தேர்வு செய்யப்பட்டது",
    "common.orders_selected": "ஆர்டர்கள் தேர்வு செய்யப்பட்டன",
    "orders selected": "ஆர்டர்கள் தேர்வு செய்யப்பட்டன",
    "common.order_updated": "ஆர்டர் புதுப்பிக்கப்பட்டது",
    "order updated": "ஆர்டர் புதுப்பிக்கப்பட்டது",
    "common.orders_updated": "ஆர்டர்கள் புதுப்பிக்கப்பட்டன",
    "orders updated": "ஆர்டர்கள் புதுப்பிக்கப்பட்டன",
    "orders.order_archived_successfully": "ஆர்டர் சேமிக்கப்பட்டது",
    "Order archived successfully": "ஆர்டர் சேமிக்கப்பட்டது",
    "orders.failed_to_archive_order": "ஆர்டரை சேமிக்க முடியவில்லை",
    "Failed to archive order": "ஆர்டரை சேமிக்க முடியவில்லை",
    "orders.loading_order": "ஆர்டரை ஏற்றுகிறது…",
    "Loading order…": "ஆர்டரை ஏற்றுகிறது…",
    "orders.order_created_successfully": "ஆர்டர் உருவாக்கப்பட்டது",
    "Order created successfully": "ஆர்டர் உருவாக்கப்பட்டது",
    "orders.the_order_has_been_created_and_is_ready_to_review": "ஆர்டர் உருவாக்கப்பட்டு, மதிப்பீட்டிற்கு தயாராக உள்ளது.",
    "The order has been created and is ready to review.": "ஆர்டர் உருவாக்கப்பட்டு, மதிப்பீட்டிற்கு தயாராக உள்ளது.",
    "orders.order_reference": "ஆர்டர் முகவரி",
    "Order reference": "ஆர்டர் முகவரி",
    "common.created": "உருவாக்கப்பட்டது",
    "common.total": "மொத்தம்",
    "Total": "மொத்தம்",
    "common.items": "பொருட்கள்",
    "Items": "பொருட்கள்",
    "orders.print_save_pdf": "அச்சிடு / PDF சேமி",
    "Print / Save PDF": "அச்சிடு / PDF சேமி",
    "orders.view_order_details": "ஆர்டர் விவரங்களைப் பார்க்கவும்",
    "View order details": "ஆர்டர் விவரங்களைப் பார்க்கவும்",
    "orders.create_another_order": "மற்றொரு ஆர்டரை உருவாக்கவும்",
    "Create another order": "மற்றொரு ஆர்டரை உருவாக்கவும்",
    "orders.confirmed": "உறுதிப்படுத்தப்பட்டது",
    "Confirmed": "உறுதிப்படுத்தப்பட்டது",
    "orders.in_progress": "நடைபெறுகிறது",
    "In progress": "நடைபெறுகிறது",
    "orders.customer_unreachable": "வாடிக்கையாளர் அடைய முடியாது",
    "Customer unreachable": "வாடிக்கையாளர் அடைய முடியாது",
    "orders.out_for_delivery": "கிடைப்பதற்காக வெளியேறியுள்ளது",
    "orders.returned": "திரும்ப அனுப்பப்பட்டது",
    "Returned": "திரும்ப அனுப்பப்பட்டது",
    "orders.return_confirmed": "திரும்ப அனுப்பல் உறுதிப்படுத்தப்பட்டது",
    "Return confirmed": "திரும்ப அனுப்பல் உறுதிப்படுத்தப்பட்டது",
    "orders.delivery_confirmed": "கிடைப்பு உறுதிப்படுத்தப்பட்டது",
    "Delivery confirmed": "கிடைப்பு உறுதிப்படுத்தப்பட்டது",
    "orders.return_initiated": "திரும்ப அனுப்பல் தொடங்கப்பட்டது",
    "orders.return_picked": "திரும்ப அனுப்பல் பெறப்பட்டது",
    "Return picked": "திரும்ப அனுப்பல் பெறப்பட்டது",
    "orders.return_disputed": "திரும்ப அனுப்பல் முறையிடப்பட்டது",
    "Return disputed": "திரும்ப அனுப்பல் முறையிடப்பட்டது",
    "orders.canceled_by_seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "Canceled by seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "orders.canceled_by_customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "Canceled by customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "orders.ready_for_pickup": "எடுக்க தயாராக உள்ளது",
    "orders.arrived_at_customer_location": "வாடிக்கையாளர் இடத்திற்கு வந்தது",
    "orders.undelivered_returned": "கிடைக்காது - திரும்ப அனுப்பப்பட்டது",
    "Undelivered - Returned": "கிடைக்காது - திரும்ப அனுப்பப்பட்டது",
    "orders.undelivered_return_confirmed": "கிடைக்காது - திரும்ப அனுப்பல் உறுதிப்படுத்தப்பட்டது",
    "Undelivered - Return confirmed": "கிடைக்காது - திரும்ப அனுப்பல் உறுதிப்படுத்தப்பட்டது",
    "orders.disputed": "முறையிடப்பட்டது",
    "Disputed": "முறையிடப்பட்டது",
    "orders.completed": "முடிக்கப்பட்டது",
    "Completed": "முடிக்கப்பட்டது",
    "orders.detail_legacy.order_number": "ஆர்டர் எண்:",
    "Order Number:": "ஆர்டர் எண்:",
    "orders.detail_legacy.order_date": "ஆர்டர் தேதி:",
    "Order Date:": "ஆர்டர் தேதி:",
    "orders.detail_legacy.buyer_details": "வாங்குபவர் விவரங்கள்:",
    "Buyer Details:": "வாங்குபவர் விவரங்கள்:",
    "orders.detail_legacy.delivery_address": "கிடைப்பு முகவரி:",
    "Delivery Address:": "கிடைப்பு முகவரி:",
    "orders.detail_legacy.pickup_address": "எடுக்கும் முகவரி:",
    "Pickup Address:": "எடுக்கும் முகவரி:",
    "orders.detail_legacy.total_amount": "மொத்த தொகை:",
    "Total Amount:": "மொத்த தொகை:",
    "orders.detail_legacy.amount_in_words": "ஆங்கிலத்தில் தொகை:",
    "Amount in Words:": "ஆங்கிலத்தில் தொகை:",
    "orders.detail_legacy.amount_words_only": "மட்டும்",
    "Only": "மட்டும்",
    "orders.detail_legacy.payout_date": "செலுத்தும் தேதி:",
    "Payout Date:": "செலுத்தும் தேதி:",
    "orders.detail_legacy.change": "மாற்று:",
    "orders.detail_legacy.select_date_time": "தேதி மற்றும் நேரத்தைத் தேர்வு செய்யவும்",
    "orders.detail_legacy.change_payout_date_time": "செலுத்தும் தேதி மற்றும் நேரத்தை மாற்று",
    "Change Payout Date and Time": "செலுத்தும் தேதி மற்றும் நேரத்தை மாற்று",
    "orders.detail_legacy.update_payout": "தொகுத்துக்காட்டு",
    "orders.detail_legacy.update_status": "நிலையை தொகுத்துக்காட்டு",
    "Update Status": "நிலையை தொகுத்துக்காட்டு",
    "orders.detail_legacy.change_order_status": "ஆர்டர் நிலையை மாற்று",
    "Change Order Status": "ஆர்டர் நிலையை மாற்று",
    "orders.detail_legacy.column_description": "விவரணம்",
    "orders.detail_legacy.column_unit_price": "அலகு விலை",
    "Unit Price": "அலகு விலை",
    "orders.detail_legacy.column_discount": "குறைப்பு",
    "Discount": "குறைப்பு",
    "orders.detail_legacy.column_tax_rate": "வரி விகிதம்",
    "Tax Rate": "வரி விகிதம்",
    "orders.item": "பொருள்",
    "Item": "பொருள்",
    "orders.order_details": "ஆர்டர் விவரங்கள்",
    "Order Details": "ஆர்டர் விவரங்கள்",
    "orders.copy_order_reference": "ஆர்டர் முகவரியை நகலெடுக்கவும்",
    "Copy order reference": "ஆர்டர் முகவரியை நகலெடுக்கவும்",
    "orders.order_summary": "ஆர்டர் சுருக்கம்",
    "Order Summary": "ஆர்டர் சுருக்கம்",
    "orders.order_created": "ஆர்டர் உருவாக்கப்பட்டது",
    "Order created": "ஆர்டர் உருவாக்கப்பட்டது",
    "orders.order_time": "ஆர்டர் நேரம்",
    "Order time": "ஆர்டர் நேரம்",
    "orders.total_earnings": "மொத்த வருமானம்",
    "Total earnings": "மொத்த வருமானம்",
    "orders.total_price": "மொத்த விலை",
    "Total price": "மொத்த விலை",
    "orders.delivery_fee": "கொண்டு செல்லும் கட்டணம்",
    "Delivery fee": "கொண்டு செல்லும் கட்டணம்",
    "orders.sub_total": "சப்டோடல்",
    "Sub total": "சப்டோடல்",
    "orders.customer_information": "வாடிக்கையாளர் தகவல்கள்",
    "Customer Information": "வாடிக்கையாளர் தகவல்கள்",
    "common.customer_name": "வாடிக்கையாளர் பெயர்",
    "Customer Name": "வாடிக்கையாளர் பெயர்",
    "common.phone": "தொலைபேசி",
    "Phone": "தொலைபேசி",
    "common.email": "மின்னஞ்சல்",
    "Email": "மின்னஞ்சல்",
    "orders.seller_details": "விற்பனையாளர் விவரங்கள்",
    "Seller Details": "விற்பனையாளர் விவரங்கள்",
    "common.seller_name": "விற்பனையாளர் பெயர்",
    "Seller Name": "விற்பனையாளர் பெயர்",
    "common.mobile": "மொபைல்",
    "Mobile": "மொபைல்",
    "orders.generate": "உருவாக்கு",
    "orders.cancel_order": "ஆர்டரை ரத்து செய்யுங்கள்",
    "Cancel Order": "ஆர்டரை ரத்து செய்யுங்கள்",
    "orders.mark_as_paid": "செலுத்தப்பட்டதாக குறிப்பிடு",
    "Mark as Paid": "செலுத்தப்பட்டதாக குறிப்பிடு",
    "orders.failed_to_mark_as_paid": "செலுத்தப்பட்டதாக குறிப்பிட முடியவில்லை",
    "Failed to mark as paid": "செலுத்தப்பட்டதாக குறிப்பிட முடியவில்லை",
    "orders.order_cancelled_successfully": "ஆர்டர் வெற்றிகரமாக ரத்து செய்யப்பட்டது",
    "Order cancelled successfully": "ஆர்டர் வெற்றிகரமாக ரத்து செய்யப்பட்டது",
    "orders.failed_to_cancel_order_by_admin": "நிர்வாகி மூலம் ஆர்டரை ரத்து செய்ய முடியவில்லை",
    "Failed to cancel order by admin": "நிர்வாகி மூலம் ஆர்டரை ரத்து செய்ய முடியவில்லை",
    "orders.no_transactions_found": "எந்த பரிமாற்றமும் கிடைக்கவில்லை",
    "No transactions found": "எந்த பரிமாற்றமும் கிடைக்கவில்லை",
    "orders.transaction_no": "பரிமாற்ற எண்",
    "Transaction No": "பரிமாற்ற எண்",
    "orders.entity": "உரிமையாளர்",
    "Entity": "உரிமையாளர்",
    "orders.transaction_type": "பரிமாற்ற வகை",
    "Transaction Type": "பரிமாற்ற வகை",
    "common.seller": "விற்பனையாளர்",
    "Seller": "விற்பனையாளர்",
    "common.customer": "வாடிக்கையாளர்",
    "Customer": "வாடிக்கையாளர்",
    "common.platform_owner": "தள உரிமையாளர்",
    "Platform Owner": "தள உரிமையாளர்",
    "orders.items_summary": "பொருட்கள் சுருக்கம்",
    "Items Summary": "பொருட்கள் சுருக்கம்",
    "orders.qty": "அளவு",
    "QTY": "அளவு",
    "orders.price": "விலை",
    "Price": "விலை",
    "orders.total_price_2": "மொத்த விலை",
    "Total Price": "மொத்த விலை",
    "orders.membership_purchase": "உறுப்பினர் பதிவு",
    "Membership purchase": "உறுப்பினர் பதிவு",
    "orders.member_id": "உறுப்பினர் ஐடி",
    "Member ID": "உறுப்பினர் ஐடி",
    "orders.period": "காலம்",
    "orders.start_date_2": "தொடக்க தேதி",
    "common.next_renewal": "அடுத்த புதுப்பிப்பு",
    "Next renewal": "அடுத்த புதுப்பிப்பு",
    "common.expiry_date": "முடிவு தேதி",
    "Expiry date": "முடிவு தேதி",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "இந்த ஆர்டர் ஒரு உறுப்பினர் பங்களிப்பாக மட்டுமே கையாளப்படுகிறது, அன்றி ஒரு அனுப்புதல் அல்ல.",
    "This order is managed as a membership contribution, not a shipment.": "இந்த ஆர்டர் ஒரு உறுப்பினர் பங்களிப்பாக மட்டுமே கையாளப்படுகிறது, அன்றி ஒரு அனுப்புதல் அல்ல.",
    "orders.months": "மாதங்கள்",
    "months": "மாதங்கள்",
    "orders.days": "நாட்கள்",
    "days": "நாட்கள்",
    "orders.address": "முகவரி",
    "Address": "முகவரி",
    "orders.address_1": "முகவரி 1",
    "Address 1": "முகவரி 1",
    "orders.address_2": "முகவரி 2",
    "Address 2": "முகவரி 2",
    "orders.zip_code": "கோடு",
    "Zip code": "கோடு",
    "orders.full_address": "முழு முகவரி",
    "Full Address": "முழு முகவரி",
    "orders.formatted_address": "வடிவமைக்கப்பட்ட முகவரி",
    "Formatted Address": "வடிவமைக்கப்பட்ட முகவரி",
    "orders.phone_number": "தொலைபேசி எண்",
    "Phone Number": "தொலைபேசி எண்",
    "orders.address_not_found": "முகவரி கிடைக்கவில்லை",
    "Address not found": "முகவரி கிடைக்கவில்லை",
    "orders.address_not_applicable": "முகவரி பொருந்தாதது",
    "Address not applicable": "முகவரி பொருந்தாதது",
    "orders.address_is_not_available": "முகவரி கிடைக்காதது",
    "Address is not available": "முகவரி கிடைக்காதது",
    "orders.add_pickup_address": "பெறும் முகவரியை சேர்க்கவும்",
    "Add Pickup Address": "பெறும் முகவரியை சேர்க்கவும்",
    "orders.edit_pickup_address": "பெறும் முகவரியை தொகுக்கவும்",
    "Edit Pickup Address": "பெறும் முகவரியை தொகுக்கவும்",
    "orders.discard_and_close": "நீக்கி மூடு",
    "Discard and close": "நீக்கி மூடு",
    "orders.state": "நிலை",
    "common.country": "நாடு",
    "Country": "நாடு",
    "orders.sales_payout": "விற்பனை பணம்",
    "Sales Payout": "விற்பனை பணம்",
    "orders.sales_no_payout": "விற்பனை (பணம் இல்லை)",
    "Sales (No Payout)": "விற்பனை (பணம் இல்லை)",
    "orders.sales_payout_reversal": "விற்பனை பணம் மாற்றுதல்",
    "Sales Payout Reversal": "விற்பனை பணம் மாற்றுதல்",
    "orders.sales_no_payout_reversal": "பணம் இல்லாத விற்பனை மாற்றுதல்",
    "Sales no payout reversal": "பணம் இல்லாத விற்பனை மாற்றுதல்",
    "orders.seller_commission": "விற்பனையாளர் கமிஷன்",
    "Seller Commission": "விற்பனையாளர் கமிஷன்",
    "orders.seller_commission_reversal": "விற்பனையாளர் கமிஷன் மாற்றுதல்",
    "Seller Commission Reversal": "விற்பனையாளர் கமிஷன் மாற்றுதல்",
    "orders.seller_transfer": "விற்பனையாளர் பரிமாற்றம்",
    "Seller Transfer": "விற்பனையாளர் பரிமாற்றம்",
    "orders.seller_transfer_reversal": "விற்பனையாளர் பரிமாற்றம் மாற்றுதல்",
    "Seller Transfer Reversal": "விற்பனையாளர் பரிமாற்றம் மாற்றுதல்",
    "orders.seller_payout": "விற்பனையாளர் பணம்",
    "Seller Payout": "விற்பனையாளர் பணம்",
    "orders.seller_subscription": "விற்பனையாளர் உறுப்பினர்",
    "Seller Subscription": "விற்பனையாளர் உறுப்பினர்",
    "orders.seller_payment_processing_fee": "விற்பனையாளர் பணம் செலுத்தும் கட்டணம்",
    "Seller Payment processing fee": "விற்பனையாளர் பணம் செலுத்தும் கட்டணம்",
    "orders.seller_payment_processing_fee_reversal": "விற்பனையாளர் பணம் செலுத்தும் கட்டணம் மாற்றுதல்",
    "Seller Payment processing fee reversal": "விற்பனையாளர் பணம் செலுத்தும் கட்டணம் மாற்றுதல்",
    "orders.sub_total_2": "தொகுதி மொத்தம்",
    "Sub Total": "தொகுதி மொத்தம்",
    "orders.customer_commission": "வாடிக்கையாளர் கமிஷன்",
    "Customer Commission": "வாடிக்கையாளர் கமிஷன்",
    "orders.tax": "வரி",
    "Tax": "வரி",
    "orders.shipping_charge": "அனுப்பும் கட்டணம்",
    "Shipping Charge": "அனுப்பும் கட்டணம்",
    "orders.refund": "மீள்வழங்கல்",
    "Refund": "மீள்வழங்கல்",
    "orders.special_fee": "கூடுதல் கட்டணம்",
    "Special Fee": "கூடுதல் கட்டணம்",
    "orders.coupon": "கூப்பன்",
    "Coupon": "கூப்பன்",
    "orders.shipment": "அனுப்புதல்",
    "Shipment": "அனுப்புதல்",
    "orders.fulfilled_by_platform": "தளத்தால் நிறைவேற்றப்பட்டது",
    "Fulfilled by platform": "தளத்தால் நிறைவேற்றப்பட்டது",
    "orders.fulfilled_by": "அனுப்பப்பட்டது",
    "Fulfilled by": "அனுப்பப்பட்டது",
    "orders.fulfilled_by_seller": "விற்பனையாளரால் நிறைவேற்றப்பட்டது",
    "Fulfilled by seller": "விற்பனையாளரால் நிறைவேற்றப்பட்டது",
    "orders.on_seller_protection_policy": "விற்பனையாளர் பாதுகாப்பு கொள்கை",
    "On Seller Protection Policy": "விற்பனையாளர் பாதுகாப்பு கொள்கை",
    "orders.product_image": "தயாரிப்பு படம்",
    "Product image": "தயாரிப்பு படம்",
    "orders.status_changed_successfully": "நிலை வெற்றிகரமாக மாற்றப்பட்டது",
    "Status changed successfully": "நிலை வெற்றிகரமாக மாற்றப்பட்டது",
    "orders.pickup_address_not_available_please_add_pickup_address": "கொண்டு வரும் இடம் கிடைக்கவில்லை. கொண்டு வரும் இடத்தை சேர்க்கவும்",
    "Pickup Address not available. Please Add Pickup Address": "கொண்டு வரும் இடம் கிடைக்கவில்லை. கொண்டு வரும் இடத்தை சேர்க்கவும்",
    "orders.failed_to_save_pickup_address_please_try_again": "கொண்டு வரும் இடம் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்",
    "Failed to save pickup address. Please try again.": "கொண்டு வரும் இடம் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்",
    "orders.change_shipment_status": "கப்பல் நிலையை மாற்று",
    "Change shipment status": "கப்பல் நிலையை மாற்று",
    "orders.not_available": "கிடைக்காதது",
    "Not available": "கிடைக்காதது",
    "orders.shipment_created": "கப்பல் உருவாக்கப்பட்டது",
    "orders.shipment_in_progress": "கப்பல் நடைபெறுகிறது",
    "orders.ship": "அனுப்பு",
    "orders.undelivered_return": "கொடுக்கப்படாத திரும்பப் பெறுதல்",
    "orders.shipment_deliver": "கப்பல் கொடுக்கப்பட்டது",
    "Shipment deliver": "கப்பல் கொடுக்கப்பட்டது",
    "orders.shipment_delivery_confirm": "கப்பல் கொடுக்கப்பட்டதை உறுதிப்படுத்து",
    "Shipment delivery confirm": "கப்பல் கொடுக்கப்பட்டதை உறுதிப்படுத்து",
    "orders.return_initiate": "திரும்பப் பெறுதலை தொடங்கு",
    "Return initiate": "திரும்பப் பெறுதலை தொடங்கு",
    "orders.return_for_pickup": "கொண்டு வரும் பொருட்களுக்கான திரும்பப் பெறுதல்",
    "Return for pickup": "கொண்டு வரும் பொருட்களுக்கான திரும்பப் பெறுதல்",
    "orders.shipment_return_confirm": "கப்பல் திரும்பப் பெறுதலை உறுதிப்படுத்து",
    "Shipment return confirm": "கப்பல் திரும்பப் பெறுதலை உறுதிப்படுத்து",
    "orders.cancel_by_seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "Cancel by seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "orders.cancel_by_customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "Cancel by customer": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "orders.arrive_at_customer_location": "வாடிக்கையாளர் இடத்திற்கு வந்தது",
    "Arrive at customer location": "வாடிக்கையாளர் இடத்திற்கு வந்தது",
    "orders.shipment_delivered": "கப்பல் கொடுக்கப்பட்டது",
    "orders.shipment_delivery_confirmed": "கொடுக்கப்பட்டதை உறுதிப்படுத்தப்பட்டது",
    "orders.returned_for_pickup": "கொண்டு வரும் பொருட்களுக்கான திரும்பப் பெறுதல்",
    "orders.shipment_return_confirmed": "திரும்பப் பெறுதல் உறுதிப்படுத்தப்பட்டது",
    "Shipment return confirmed": "திரும்பப் பெறுதல் உறுதிப்படுத்தப்பட்டது",
    "orders.cancelled_by_seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "Cancelled by seller": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "common.cancelled_by_admin": "நிர்வாகர் காரணமாக ரத்து செய்யப்பட்டது",
    "orders.invoice": "கணக்கு",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "சரியான கோப்பு வடிவமைப்பைத் தேர்வு செய்க (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "சரியான கோப்பு வடிவமைப்பைத் தேர்வு செய்க (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "கோப்பு அளவு 5MB ஐ விடக் குறைவாக இருக்க வேண்டும்",
    "File size must be less than 5MB": "கோப்பு அளவு 5MB ஐ விடக் குறைவாக இருக்க வேண்டும்",
    "orders.please_upload_a_file_first": "முதலில் ஒரு கோப்பை பதிவேற்றுங்கள்",
    "Please upload a file first": "முதலில் ஒரு கோப்பை பதிவேற்றுங்கள்",
    "orders.invoice_uploaded_successfully": "கணக்கு வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "Invoice uploaded successfully!": "கணக்கு வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "orders.failed_to_upload_invoice_please_try_again": "கணக்கு பதிவேற்றம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "Failed to upload invoice. Please try again.": "கணக்கு பதிவேற்றம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "orders.upload_invoice": "கணக்கு பதிவேற்று",
    "Upload Invoice": "கணக்கு பதிவேற்று",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "ஆதரிக்கப்படும் வடிவங்கள்: PDF, JPG, PNG, DOC (கூடுதல் அளவு: 5MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "ஆதரிக்கப்படும் வடிவங்கள்: PDF, JPG, PNG, DOC (கூடுதல் அளவு: 5MB)",
    "orders.uploading": "பதிவேற்றம் நடைபெறுகிறது...",
    "orders.choose_file": "கோப்பைத் தேர்வு செய்க",
    "Choose File": "கோப்பைத் தேர்வு செய்க",
    "common.download": "பதிவிறக்கம்",
    "common.remove": "அகற்று",
    "Remove": "அகற்று",
    "orders.upload_new_file": "புதிய கோப்பை பதிவேற்று",
    "Upload New File": "புதிய கோப்பை பதிவேற்று",
    "orders.saving": "சேமிக்கப்படுகிறது...",
    "Saving...": "சேமிக்கப்படுகிறது...",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "ஒரு ஆர்டரை நீக்குவது விற்பனையாளர் மற்றும் வாங்குபவரின் காட்சியிலிருந்து உடனடியாக அதை நீக்கும். நீக்கப்பட்ட பிறகு, மேலும் நிலை புதுப்பிப்புகள் அனுமதிக்கப்படாது, மற்றும் ஆர்டர் அனைத்து அளவீடுகள் மற்றும் அறிக்கைகளிலிருந்தும் வெளியேற்றப்படும். நீங்கள் தொடர விரும்புகிறீர்களா என்று உறுதிப்படுத்தவும்?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "ஒரு ஆர்டரை நீக்குவது விற்பனையாளர் மற்றும் வாங்குபவரின் காட்சியிலிருந்து உடனடியாக அதை நீக்கும். நீக்கப்பட்ட பிறகு, மேலும் நிலை புதுப்பிப்புகள் அனுமதிக்கப்படாது, மற்றும் ஆர்டர் அனைத்து அளவீடுகள் மற்றும் அறிக்கைகளிலிருந்தும் வெளியேற்றப்படும். நீங்கள் தொடர விரும்புகிறீர்களா என்று உறுதிப்படுத்தவும்?",
    "common.showing": "காட்டப்படுகிறது",
    "Showing": "காட்டப்படுகிறது",
    "common.of": "இல்",
    "of": "இல்",
    "common.all": "அனைத்தும்",
    "common.active": "செயல்பாட்டில்",
    "common.inactive": "இயல்பில்லாத",
    "common.enabled": "செயல்படுத்தப்பட்டது",
    "common.disabled": "செயல்படுத்தப்படாதது",
    "common.success": "வெற்றி",
    "Success": "வெற்றி",
    "common.error": "பிழை",
    "Error": "பிழை",
    "common.warning": "எச்சரிக்கை",
    "Warning": "எச்சரிக்கை",
    "common.required": "தேவை",
    "Required": "தேவை",
    "users.title": "பயனர்கள்",
    "users.import": "கொண்டுவருதல்",
    "users.import_users": "பயனர்களை கொண்டுவருதல்",
    "users.smart_upload_users": "உரிமையாளர் பயனர்களை கொண்டுவருதல்",
    "Smart Upload Users": "உரிமையாளர் பயனர்களை கொண்டுவருதல்",
    "users.smart_upload_beta": "உரிமையாளர் பயனர்களை கொண்டுவருதல் (Beta)",
    "Smart upload users (Beta)": "உரிமையாளர் பயனர்களை கொண்டுவருதல் (Beta)",
    "users.export": "வெளியீடு",
    "Export": "வெளியீடு",
    "users.export_users": "பயனர்களை வெளியீடு",
    "Export users": "பயனர்களை வெளியீடு",
    "users.search_users": "பயனர்களைத் தேடு",
    "Search users": "பயனர்களைத் தேடு",
    "users.verified": "உறுதிப்படுத்தப்பட்டது",
    "Verified": "உறுதிப்படுத்தப்பட்டது",
    "users.not_verified": "உறுதிப்படுத்தப்படாதது",
    "Non Verified": "உறுதிப்படுத்தப்படாதது",
    "users.block": "தடுக்க",
    "Block": "தடுக்க",
    "users.unblock": "தடை நீக்கு",
    "Unblock": "தடை நீக்கு",
    "users.confirm_block": "இந்த பயனரை தடுக்க விரும்புகிறீர்களா?",
    "Do you want to block this user?": "இந்த பயனரை தடுக்க விரும்புகிறீர்களா?",
    "users.confirm_unblock": "இந்த பயனரின் தடையை நீக்க விரும்புகிறீர்களா?",
    "Do you want to unblock this user?": "இந்த பயனரின் தடையை நீக்க விரும்புகிறீர்களா?",
    "users.import_export": "பயனர்களை கொண்டுவருதல் மற்றும் வெளியீடு",
    "User import and export": "பயனர்களை கொண்டுவருதல் மற்றும் வெளியீடு",
    "users.user_id": "பயனர் ID",
    "User ID": "பயனர் ID",
    "users.first_name": "பெயர்",
    "users.last_name": "குடும்ப பெயர்",
    "users.email": "மின்னஞ்சல்",
    "users.phone_number": "தொலைபேசி எண்",
    "Phone No": "தொலைபேசி எண்",
    "users.country": "நாடு",
    "users.profile": "தொகுப்பு",
    "Profile": "தொகுப்பு",
    "users.email_verified": "மின்னஞ்சல் சரிபார்க்கப்பட்டது",
    "Email Verified": "மின்னஞ்சல் சரிபார்க்கப்பட்டது",
    "users.blocked": "தடுக்கப்பட்டவர்",
    "users.action": "செயல்முறை",
    "users.join_date": "பதிவு தேதி",
    "Join Date": "பதிவு தேதி",
    "users.last_login": "கடைசி உள்நுழைவு",
    "Last Login": "கடைசி உள்நுழைவு",
    "users.customer_type": "வாடிக்கையாளர் வகை",
    "Customer Type": "வாடிக்கையாளர் வகை",
    "common.and": "மற்றும்",
    "and": "மற்றும்",
    "users.import_failed": "பயனர் இறக்குமதி தோல்வி.",
    "User import failed.": "பயனர் இறக்குமதி தோல்வி.",
    "users.smart_upload.paid_title": "உபயோகிப்பாளர்களை குறிப்பிட்ட முறையில் இறக்குமதி செய்வது பணம் செலுத்தப்பட்ட பண்பு",
    "Smart user upload is a paid feature": "உபயோகிப்பாளர்களை குறிப்பிட்ட முறையில் இறக்குமதி செய்வது பணம் செலுத்தப்பட்ட பண்பு",
    "users.smart_upload.paid_description": "CSV கோப்பிலிருந்து பயனர்களை இறக்குமதி செய்ய, உங்கள் வேலை இடத்தை Starter அல்லது Go ஆக மேம்படுத்தவும்.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "CSV கோப்பிலிருந்து பயனர்களை இறக்குமதி செய்ய, உங்கள் வேலை இடத்தை Starter அல்லது Go ஆக மேம்படுத்தவும்.",
    "users.smart_upload.view_plans": "திட்டங்களைப் பார்க்கவும்",
    "users.smart_upload.csv_needs_user": "CSV கோப்பில் தலைப்பு வரி மற்றும் குறைந்தது ஒரு பயனர் இருக்க வேண்டும்.",
    "The CSV must contain a header row and at least one user.": "CSV கோப்பில் தலைப்பு வரி மற்றும் குறைந்தது ஒரு பயனர் இருக்க வேண்டும்.",
    "users.smart_upload.unique_headers": "ஒவ்வொரு பயனர் நிரலுக்கும் தனித்துவமான மற்றும் வெற்று இல்லாத தலைப்பு தேவை.",
    "Every user column needs a unique, non-empty header.": "ஒவ்வொரு பயனர் நிரலுக்கும் தனித்துவமான மற்றும் வெற்று இல்லாத தலைப்பு தேவை.",
    "users.smart_upload.csv_read_error": "இந்த CSV ஐ படிக்க முடியவில்லை.",
    "users.smart_upload.map_required": "{fields} ஐ தொடர்ந்து மேப்பிங் செய்யவும்.",
    "Map {fields} before continuing.": "{fields} ஐ தொடர்ந்து மேப்பிங் செய்யவும்.",
    "users.smart_upload.map_contact": "மின்னஞ்சல் அல்லது தொலைபேசி நிரலை மேப்பிங் செய்யவும். ஒவ்வொரு வரியிலும் குறைந்தது ஒரு தொடர்பு முறை தேவை.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "மின்னஞ்சல் அல்லது தொலைபேசி நிரலை மேப்பிங் செய்யவும். ஒவ்வொரு வரியிலும் குறைந்தது ஒரு தொடர்பு முறை தேவை.",
    "users.smart_upload.invalid_row": "{row} வரியில் தேவையான பெயர் அல்லது தொடர்பு மதிப்பு இல்லை.",
    "Row {row} is missing a required name or contact value.": "{row} வரியில் தேவையான பெயர் அல்லது தொடர்பு மதிப்பு இல்லை.",
    "users.smart_upload.attribute_name_required": "{header} க்கு பண்பு பெயரை உள்ளிடவும்.",
    "users.smart_upload.attribute_create_error": "{name} பண்பை உருவாக்க முடியவில்லை.",
    "Could not create the “{name}” attribute.": "{name} பண்பை உருவாக்க முடியவில்லை.",
    "users.smart_upload.attribute_missing": "{header} இருந்து மேப்பிங் செய்யப்பட்ட பண்பு இப்போது கிடைக்காது.",
    "users.smart_upload.prepare_error": "இறக்குமதி கோப்பை தயாரிக்க முடியவில்லை.",
    "users.smart_upload.upload_error": "இறக்குமதி கோப்பை பதிவேற்றம் செய்ய முடியவில்லை.",
    "users.smart_upload.all_duplicates": "இந்த கோப்பில் உள்ள ஒவ்வொரு வரியும் மற்றொரு வரியின் மடக்கு பிரதியாக உள்ளது.",
    "Every row is a duplicate of another row in this file.": "இந்த கோப்பில் உள்ள ஒவ்வொரு வரியும் மற்றொரு வரியின் மடக்கு பிரதியாக உள்ளது.",
    "users.smart_upload.source_attribute_error": "தொடர்பு மூல அம்புலினை உருவாக்க முடியவில்லை.",
    "Could not create the contact_source attribute.": "தொடர்பு மூல அம்புலினை உருவாக்க முடியவில்லை.",
    "users.smart_upload.duplicates_skipped": "மீள்வரையறுக்கப்பட்ட வரிகள்: {count}.",
    "Duplicate rows to skip: {count}.": "மீள்வரையறுக்கப்பட்ட வரிகள்: {count}.",
    "users.smart_upload.preparing_attributes": "அம்புலின்களை தயாரிக்கிறது",
    "users.smart_upload.checking_users": "ஏற்கனவே உள்ள பயனர்களை சரிபார்க்கிறது",
    "Checking existing users": "ஏற்கனவே உள்ள பயனர்களை சரிபார்க்கிறது",
    "users.smart_upload.uploading_file": "இறக்குமதி கோப்பை பதிவேற்றுகிறது",
    "users.smart_upload.importing_users": "Tradly பயனர்களை இறக்குமதி செய்கிறது",
    "Tradly is importing users": "Tradly பயனர்களை இறக்குமதி செய்கிறது",
    "users.smart_upload.import_stopped": "இறக்குமதி நிறுத்தப்பட்டது",
    "Import stopped": "இறக்குமதி நிறுத்தப்பட்டது",
    "users.smart_upload.title": "உபயோகிப்பாளர் கூட்டு ஏற்றுமதி",
    "Smart user upload": "உபயோகிப்பாளர் கூட்டு ஏற்றுமதி",
    "users.smart_upload.beta": "(பீட்டா)",
    "(Beta)": "(பீட்டா)",
    "users.smart_upload.start_over": "மீண்டும் தொடங்கு",
    "Start over": "மீண்டும் தொடங்கு",
    "users.smart_upload.description": "தொடர்புகளை பதிவேற்று, பயனர் அம்புலின்களுக்கு நிரல்களை மேப் செய்து, வெளியேற்ற அல்லது பதிவு செய்த என வகைப்படுத்தவும்.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "தொடர்புகளை பதிவேற்று, பயனர் அம்புலின்களுக்கு நிரல்களை மேப் செய்து, வெளியேற்ற அல்லது பதிவு செய்த என வகைப்படுத்தவும்.",
    "users.smart_upload.step_upload": "பதிவேற்று",
    "users.smart_upload.step_match": "நிரல்களை மேப் செய்தல்",
    "users.smart_upload.step_review": "மீண்டும் பார்க்க",
    "users.smart_upload.step_import": "இறக்குமதி",
    "users.smart_upload.choose_csv": "CSV கோப்பைத் தேர்வு செய்க",
    "users.smart_upload.required_fields": "முதல் பெயர், கடைசி பெயர் மற்றும் மின்னஞ்சல் அல்லது தொலைபேசி தேவை. கடவுச்சொற்கள் தானியங்கி உருவாக்கப்படுகின்றன.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "முதல் பெயர், கடைசி பெயர் மற்றும் மின்னஞ்சல் அல்லது தொலைபேசி தேவை. கடவுச்சொற்கள் தானியங்கி உருவாக்கப்படுகின்றன.",
    "users.smart_upload.select_csv": "CSV கோப்பைத் தேர்வு செய்க",
    "users.smart_upload.match_columns": "பயனர் நிரல்களை மேப் செய்தல்",
    "Match user columns": "பயனர் நிரல்களை மேப் செய்தல்",
    "users.smart_upload.first_name": "முதல் பெயர்",
    "users.smart_upload.last_name": "கடைசி பெயர்",
    "Last name": "கடைசி பெயர்",
    "users.smart_upload.email": "மின்னஞ்சல்",
    "users.smart_upload.phone": "தொலைபேசி",
    "users.smart_upload.username": "பயனர் பெயர்",
    "users.smart_upload.do_not_import": "இறக்குமதி செய்ய வேண்டாம்",
    "users.smart_upload.additional_attributes": "பயனர் கூடுதல் பண்புகள்",
    "Additional user attributes": "பயனர் கூடுதல் பண்புகள்",
    "users.smart_upload.ignore_column": "இந்த நிரலை மறுத்துவிடு",
    "Ignore this column": "இந்த நிரலை மறுத்துவிடு",
    "users.smart_upload.create_attribute": "புதிய பயனர் பண்பை உருவாக்கு",
    "Create a new user attribute": "புதிய பயனர் பண்பை உருவாக்கு",
    "users.smart_upload.attribute_name": "பண்பு பெயர்",
    "users.smart_upload.type_text": "テキスト",
    "users.smart_upload.type_long_text": "நீண்ட உரை",
    "Long text": "நீண்ட உரை",
    "users.smart_upload.type_number": "எண்",
    "Number": "எண்",
    "users.smart_upload.type_single_select": "ஒரு தேர்வு",
    "Single select": "ஒரு தேர்வு",
    "users.smart_upload.type_multi_select": "பல தேர்வுகள்",
    "Multi select": "பல தேர்வுகள்",
    "users.smart_upload.review_import": "இறக்குமதி மீண்டும் பார்க்க",
    "users.smart_upload.review_description": "இறக்குமதி செய்ய வேண்டிய தொடர்புகள்: {count}. தொடர்புகள் இருக்கும் பயனர்கள் API மூலம் நிராகரிக்கப்படலாம்; பாகமாக இறக்குமதி செய்வதை மீண்டும் முயற்சி செய்வது வெற்றிகரமான வரிகளை இரட்டிப்பாக்கலாம்.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "இறக்குமதி செய்ய வேண்டிய தொடர்புகள்: {count}. தொடர்புகள் இருக்கும் பயனர்கள் API மூலம் நிராகரிக்கப்படலாம்; பாகமாக இறக்குமதி செய்வதை மீண்டும் முயற்சி செய்வது வெற்றிகரமான வரிகளை இரட்டிப்பாக்கலாம்.",
    "users.smart_upload.contact_classification": "தொடர்பு வகைப்பாடு",
    "Contact classification": "தொடர்பு வகைப்பாடு",
    "users.smart_upload.outbound": "வெளியீடு (தேர்வு செய்யப்படவில்லை)",
    "Outbound (not opted in)": "வெளியீடு (தேர்வு செய்யப்படவில்லை)",
    "users.smart_upload.signed_up": "பதிவு செய்துள்ளது (தேர்வு செய்துள்ளது)",
    "Signed-up (opted in)": "பதிவு செய்துள்ளது (தேர்வு செய்துள்ளது)",
    "users.smart_upload.contact_source_help": "இது contact_source பண்பாக சேமிக்கப்படுகிறது. Tradly-ன் உள்ளீட்டு பயனர் வகை வாடிக்கையாளராக தொடர்கிறது.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "இது contact_source பண்பாக சேமிக்கப்படுகிறது. Tradly-ன் உள்ளீட்டு பயனர் வகை வாடிக்கையாளராக தொடர்கிறது.",
    "users.smart_upload.import_complete": "பயனர் இறக்குமதி முடிந்தது",
    "User import complete": "பயனர் இறக்குமதி முடிந்தது",
    "users.smart_upload.imported_summary": "{imported} பயனர்கள் {total} இலிருந்து இறக்குமதி செய்யப்பட்டனர்.",
    "{imported} of {total} users imported.": "{imported} பயனர்கள் {total} இலிருந்து இறக்குமதி செய்யப்பட்டனர்.",
    "users.smart_upload.selected_file": "தேர்ந்தெடுக்கப்பட்டது: {name}",
    "users.smart_upload.review_action": "மீண்டும் பார்க்க",
    "users.smart_upload.importing_action": "இறக்குமதி செய்து கொண்டிருக்கிறேன்…",
    "users.smart_upload.import_users_action": "பயனர்களை இறக்குமதி செய்ய",
    "users.import.uploading": "பதிவேற்றம் செய்து கொண்டிருக்கிறேன்…",
    "Uploading…": "பதிவேற்றம் செய்து கொண்டிருக்கிறேன்…",
    "users.import.please_wait": "காத்திருக்கவும்…",
    "Please wait…": "காத்திருக்கவும்…",
    "users.import.error_prefix": "பிழை",
    "users.import.select_file_error": "கோப்பைத் தேர்வுசெய்க",
    "Please select a file": "கோப்பைத் தேர்வுசெய்க",
    "users.import.download": "பதிவிறக்கு",
    "users.import.file_label": "கோப்பு:",
    "File:": "கோப்பு:",
    "users.import.select_file": "கோப்பைத் தேர்வுசெய்க",
    "users.import.upload": "பதிவேற்று",
    "users.create.button": "பயனரை உருவாக்கு",
    "Create User": "பயனரை உருவாக்கு",
    "users.create.title": "புதிய பயனரை உருவாக்கு",
    "Create New User": "புதிய பயனரை உருவாக்கு",
    "users.create.please_wait": "காத்திருக்கவும்…",
    "users.create.email": "மின்னஞ்சல்",
    "users.create.first_name": "முதல் பெயர்",
    "users.create.last_name": "கடைசி பெயர்",
    "users.create.email_required": "மின்னஞ்சல் அவசியம்",
    "Email is required": "மின்னஞ்சல் அவசியம்",
    "users.create.first_name_required": "முதல் பெயர் அவசியம்",
    "First Name is required": "முதல் பெயர் அவசியம்",
    "users.create.last_name_required": "கடைசி பெயர் அவசியம்",
    "Last Name is required": "கடைசி பெயர் அவசியம்",
    "users.create.session_expired": "உங்கள் நிர்வாக உறுப்பினர் காலாவதியாகிவிட்டது. பயனரை உருவாக்கும் முன் மீண்டும் உள்நுழையவும்.",
    "Your admin session has expired. Please sign in again before creating a user.": "உங்கள் நிர்வாக உறுப்பினர் காலாவதியாகிவிட்டது. பயனரை உருவாக்கும் முன் மீண்டும் உள்நுழையவும்.",
    "users.create.unable_to_create": "இந்த பயனரை உருவாக்க முடியவில்லை.",
    "Unable to create this user.": "இந்த பயனரை உருவாக்க முடியவில்லை.",
    "users.create.success": "பயனர் வெற்றிகரமாக உருவாக்கப்பட்டது",
    "User created successfully": "பயனர் வெற்றிகரமாக உருவாக்கப்பட்டது",
    "users.create.failed": "பயனரை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "User creation failed. Please try again.": "பயனரை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "common.feature_flow.eyebrow": "அது எவ்வாறு செயல்படுகிறது என்பதைக் காண்க",
    "SEE HOW IT WORKS": "அது எவ்வாறு செயல்படுகிறது என்பதைக் காண்க",
    "common.feature_flow.open_guide": "ஒழுங்குமுறை வழிகாட்டியைத் திறக்கவும்",
    "Open flow guide": "ஒழுங்குமுறை வழிகாட்டியைத் திறக்கவும்",
    "common.feature_flow.close_guide": "பிரிவு வழிகாட்டியை மூடு",
    "Close section guide": "பிரிவு வழிகாட்டியை மூடு",
    "common.feature_flow.section_guide": "பிரிவு வழிகாட்டி",
    "Section guide": "பிரிவு வழிகாட்டி",
    "users.flow.title": "உங்கள் பயனர்களை மேலாண்மை செய்ய உங்களுக்கு தேவையான அனைத்தும்",
    "Everything you need to manage your users": "உங்கள் பயனர்களை மேலாண்மை செய்ய உங்களுக்கு தேவையான அனைத்தும்",
    "users.flow.description": "பயனர் சுயவிவரங்களை உருவாக்கி, பயனர் தரவை தனிப்பயனமாக்கி, வாடிக்கையாளர் கருத்துகளை ஒரே இடத்தில் புரிந்துகொள்ளவும்.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "பயனர் சுயவிவரங்களை உருவாக்கி, பயனர் தரவை தனிப்பயனமாக்கி, வாடிக்கையாளர் கருத்துகளை ஒரே இடத்தில் புரிந்துகொள்ளவும்.",
    "users.flow.lane_title": "பயனர் மேலாண்மை",
    "User management": "பயனர் மேலாண்மை",
    "users.flow.badge": "முக்கிய கருவிகள்",
    "Core tools": "முக்கிய கருவிகள்",
    "users.flow.attributes": "பண்புகள்",
    "users.flow.reviews": "மதிப்பீடுகள்",
    "users.flow.lane_description": "நபர்களை மேலாண்மை செய்து, உங்களுக்கு தேவையான சுயவிவர புலங்களை சேர்த்து, அவர்களின் அனுபவத்திலிருந்து கற்றுக்கொள்ளவும்.",
    "Manage people, add the profile fields you need, and learn from their experience.": "நபர்களை மேலாண்மை செய்து, உங்களுக்கு தேவையான சுயவிவர புலங்களை சேர்த்து, அவர்களின் அனுபவத்திலிருந்து கற்றுக்கொள்ளவும்.",
    "users.flow.primary_action": "முதல் பயனரை சேர்க்கவும்",
    "Add your first user": "முதல் பயனரை சேர்க்கவும்",
    "users.tooltip.title": "ஒவ்வொரு தனிநபரும் ஒரு தனித்துவமான பயனர்",
    "Every individual is a unique user": "ஒவ்வொரு தனிநபரும் ஒரு தனித்துவமான பயனர்",
    "users.tooltip.description": "ஒரு கடைக்குள் நுழையும் ஒவ்வொரு பயனரும் ஒரு பயனராகக் கருதப்படுகிறார். ஒவ்வொரு வணிகரும் ஒரு பயனராகக் கருதப்படுகிறார். டிராட்லியில், விற்பனையாளர் அல்லது வாடிக்கையாளர் என்ற வேறுபட்ட பயனர்கள் அனைவரும் 'பயனர்கள்' என்று அழைக்கப்படுகின்றனர், மேலும் அவர்களின் தனித்துவமான விவரங்கள் பயனர் பிரிவில் சேமிக்கப்படுகின்றன. அவர்களின் வாங்கும் விவரங்கள் அல்லது அவர்கள் உரிமையாகக் கொண்டிருக்கும் கணக்குகளை நீங்கள் காணலாம்.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "ஒரு கடைக்குள் நுழையும் ஒவ்வொரு பயனரும் ஒரு பயனராகக் கருதப்படுகிறார். ஒவ்வொரு வணிகரும் ஒரு பயனராகக் கருதப்படுகிறார். டிராட்லியில், விற்பனையாளர் அல்லது வாடிக்கையாளர் என்ற வேறுபட்ட பயனர்கள் அனைவரும் 'பயனர்கள்' என்று அழைக்கப்படுகின்றனர், மேலும் அவர்களின் தனித்துவமான விவரங்கள் பயனர் பிரிவில் சேமிக்கப்படுகின்றன. அவர்களின் வாங்கும் விவரங்கள் அல்லது அவர்கள் உரிமையாகக் கொண்டிருக்கும் கணக்குகளை நீங்கள் காணலாம்.",
    "workspace.loading": "வேலை இட அமைப்புகளை ஏற்றுகிறது…",
    "Loading workspace settings…": "வேலை இட அமைப்புகளை ஏற்றுகிறது…",
    "workspace.kicker": "வேலை இடம்",
    "WORKSPACE": "வேலை இடம்",
    "workspace.fallback_name": "வேலை இடம்",
    "workspace.members.title": "குழு உறுப்பினரை அழைக்கவும்",
    "Invite Team Member": "குழு உறுப்பினரை அழைக்கவும்",
    "workspace.members.description": "குழு உறுப்பினர்களைச் சேர்த்து, ஒவ்வொருவருக்கும் அவர்கள் தேவைப்படும் அணுகலை மட்டுமே வழங்கவும்.",
    "Add teammates and give each person only the access they need.": "குழு உறுப்பினர்களைச் சேர்த்து, ஒவ்வொருவருக்கும் அவர்கள் தேவைப்படும் அணுகலை மட்டுமே வழங்கவும்.",
    "workspace.members.enter_name_email": "உறுப்பினரின் பெயர் மற்றும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "Enter a member name and email address.": "உறுப்பினரின் பெயர் மற்றும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "workspace.members.invitation_sent": "அழைப்பு அனுப்பப்பட்டது.",
    "Invitation sent.": "அழைப்பு அனுப்பப்பட்டது.",
    "workspace.members.confirm_remove": "{name} ஐ இந்த வேலை இடத்திலிருந்து நீக்க விரும்புகிறீர்களா?",
    "Remove {name} from this workspace?": "{name} ஐ இந்த வேலை இடத்திலிருந்து நீக்க விரும்புகிறீர்களா?",
    "workspace.members.removed": "குழு உறுப்பினர் நீக்கப்பட்டார்.",
    "Team member removed.": "குழு உறுப்பினர் நீக்கப்பட்டார்.",
    "workspace.members.roles_saved": "உறுப்பினர் பங்குகள் சேமிக்கப்பட்டன.",
    "Member roles saved.": "உறுப்பினர் பங்குகள் சேமிக்கப்பட்டன.",
    "workspace.members.read": "பார்க்க",
    "workspace.members.write": "எழுதுதல்",
    "workspace.members.delete": "நீக்குதல்",
    "workspace.members.select_all_permission": "{group}-இல் {permission}-ஐ அனைத்தையும் தேர்வு செய்க",
    "Select all {permission} in {group}": "{group}-இல் {permission}-ஐ அனைத்தையும் தேர்வு செய்க",
    "workspace.members.member_name": "உறுப்பினர் பெயர்",
    "Member Name": "உறுப்பினர் பெயர்",
    "workspace.members.email_address": "மேலாளர் முகவரி",
    "Email Address": "மேலாளர் முகவரி",
    "workspace.members.sending": "அனுப்பும்…",
    "workspace.members.send_invitation": "அழைப்பு அனுப்பு",
    "Send invitation": "அழைப்பு அனுப்பு",
    "workspace.members.team_members": "குழு உறுப்பினர்கள்",
    "Team members": "குழு உறுப்பினர்கள்",
    "workspace.members.search_members": "உறுப்பினர்களைத் தேடு",
    "Search members": "உறுப்பினர்களைத் தேடு",
    "workspace.members.search": "தேடு",
    "workspace.members.member": "உறுப்பினர்",
    "Member": "உறுப்பினர்",
    "workspace.members.email": "மின்னஞ்சல்",
    "workspace.members.status": "நிலை",
    "workspace.members.actions": "செயல்கள்",
    "workspace.members.unnamed": "பெயரில்லா உறுப்பினர்",
    "Unnamed member": "பெயரில்லா உறுப்பினர்",
    "workspace.members.roles": "பங்குகள்",
    "Roles": "பங்குகள்",
    "workspace.members.empty": "குழு உறுப்பினர்கள் காணப்படவில்லை.",
    "No team members found.": "குழு உறுப்பினர்கள் காணப்படவில்லை.",
    "workspace.members.page_of": "பக்கம் {page} இலிருந்து {pages}",
    "Page {page} of {pages}": "பக்கம் {page} இலிருந்து {pages}",
    "workspace.members.assign_roles": "பங்குகளை ஒதுக்கு",
    "Assign roles": "பங்குகளை ஒதுக்கு",
    "workspace.members.save_roles": "பங்குகளை சேமி",
    "Save roles": "பங்குகளை சேமி",
    "workspace.members.saving": "சேமித்துக் கொண்டிருக்கிறேன்…",
    "workspace.error.generic": "பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
    "Something went wrong. Please try again.": "பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
    "workspace.billing.view_label": "வேர்க்ஸ்பேஸ் பில்லிங் காட்சி",
    "Billing workspace view": "வேர்க்ஸ்பேஸ் பில்லிங் காட்சி",
    "workspace.billing.tab_usage": "பயன்பாடு",
    "Usage": "பயன்பாடு",
    "workspace.billing.tab_plans": "திட்டங்கள்",
    "workspace.billing.tab_invoices": "கட்டணம் செலுத்தப்பட்ட பில்கள்",
    "Paid invoices": "கட்டணம் செலுத்தப்பட்ட பில்கள்",
    "workspace.billing.tab_account": "கணக்கு",
    "Account": "கணக்கு",
    "workspace.account.title": "வணிக அமைப்பு",
    "Business Settings": "வணிக அமைப்பு",
    "workspace.account.description": "உங்கள் வணிக உருவம், செயல்பாட்டு பொருட்கள் மற்றும் கணக்கு தனியுரிமையை மேனேஜ் செய்யவும்.",
    "Manage your business profile, enabled products, and account privacy.": "உங்கள் வணிக உருவம், செயல்பாட்டு பொருட்கள் மற்றும் கணக்கு தனியுரிமையை மேனேஜ் செய்யவும்.",
    "workspace.account.profile_updated": "வணிக உருவம் புதுப்பிக்கப்பட்டது.",
    "Business profile updated.": "வணிக உருவம் புதுப்பிக்கப்பட்டது.",
    "workspace.account.logo_updated": "லோகோ புதுப்பிக்கப்பட்டது.",
    "Logo updated.": "லோகோ புதுப்பிக்கப்பட்டது.",
    "workspace.account.logo_upload_error": "லோகோ பதிவேற்றம் செய்ய முடியவில்லை.",
    "Unable to upload logo.": "லோகோ பதிவேற்றம் செய்ய முடியவில்லை.",
    "workspace.account.confirm_delete": "இதை Tradly கணக்கை நிரந்தரமாக அழிக்க வேண்டுமா? இதை மாற்ற முடியாது.",
    "Delete this Tradly account permanently? This cannot be undone.": "இதை Tradly கணக்கை நிரந்தரமாக அழிக்க வேண்டுமா? இதை மாற்ற முடியாது.",
    "workspace.account.business_profile": "வணிக உருவம்",
    "Business Profile": "வணிக உருவம்",
    "workspace.account.logo": "லோகோ",
    "Logo": "லோகோ",
    "workspace.account.logo_alt": "வணிக லோகோ",
    "Business logo": "வணிக லோகோ",
    "workspace.account.add_photo": "படத்தை சேர்க்கவும்",
    "Add photo": "படத்தை சேர்க்கவும்",
    "workspace.account.logo_formats": "PNG, JPG, SVG அல்லது ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG அல்லது ICO",
    "workspace.account.business_name": "நிறுவன பெயர்",
    "workspace.account.contact_name": "வணிக தொடர்பு பெயர்",
    "Business Contact Name": "வணிக தொடர்பு பெயர்",
    "workspace.account.business_address": "வணிக முகவரி",
    "Business Address": "வணிக முகவரி",
    "workspace.account.products_of_interest": "ஆர்வம் உள்ள பொருட்கள்",
    "Products of Interest": "ஆர்வம் உள்ள பொருட்கள்",
    "workspace.account.marketplace": "வணிக மண்டலம்",
    "workspace.account.single_store": "ஒரே கடை வணிகம்",
    "Single Store Commerce": "ஒரே கடை வணிகம்",
    "workspace.account.alacarte_products": "ஒவ்வொரு பொருளும் தனித்தனியாக",
    "À la carte Products": "ஒவ்வொரு பொருளும் தனித்தனியாக",
    "workspace.account.alacarte_description": "இந்த வேலை இடத்திற்கு தனித்தனியாக செயல்படுத்தப்பட்ட பொருட்கள் திட்டங்கள் & பில்லிங் மூலம் மேனேஜ் செய்யப்படுகின்றன.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "இந்த வேலை இடத்திற்கு தனித்தனியாக செயல்படுத்தப்பட்ட பொருட்கள் திட்டங்கள் & பில்லிங் மூலம் மேனேஜ் செய்யப்படுகின்றன.",
    "workspace.account.manage_alacarte": "à la carte பொருட்களை மேனேஜ் செய்யவும்",
    "Manage à la carte products": "à la carte பொருட்களை மேனேஜ் செய்யவும்",
    "workspace.account.delete_irreversible": "கணக்கை அழிக்க: மாற்ற முடியாதது",
    "Delete your Account: Irreversible": "கணக்கை அழிக்க: மாற்ற முடியாதது",
    "workspace.account.delete_description": "இது Tradly குடியிருப்பு மற்றும் அனைத்து தொடர்புடைய தரவுகளையும் நிரந்தரமாக அழிக்கிறது.",
    "This permanently deletes the Tradly tenant and all associated data.": "இது Tradly குடியிருப்பு மற்றும் அனைத்து தொடர்புடைய தரவுகளையும் நிரந்தரமாக அழிக்கிறது.",
    "workspace.account.deleting": "அழிக்கப்படுகிறது…",
    "Deleting…": "அழிக்கப்படுகிறது…",
    "workspace.account.delete_button": "Tradly உடன் கணக்கை அழிக்கவும்",
    "Delete Account With Tradly": "Tradly உடன் கணக்கை அழிக்கவும்",
    "workspace.privacy.title": "தனியுரிமை மற்றும் தரவு செயலாக்கிகள்",
    "Privacy & Data Processors": "தனியுரிமை மற்றும் தரவு செயலாக்கிகள்",
    "workspace.privacy.description": "Tradly இயக்க உதவும் செயலாக்கிகளையும், நீக்க கோரிக்கைக்குப் பிறகு எவ்வாறு பராமரிப்பு நடைபெறுகிறது என்பதை புரிந்துகொள்ளவும்.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Tradly இயக்க உதவும் செயலாக்கிகளையும், நீக்க கோரிக்கைக்குப் பிறகு எவ்வாறு பராமரிப்பு நடைபெறுகிறது என்பதை புரிந்துகொள்ளவும்.",
    "workspace.privacy.processor_retention": "Tradly சேவையை இயக்க, தயாரிப்பு தரத்தை மேம்படுத்த, பில்லிங் மற்றும் நம்பகத்தன்மையை ஆதரிக்க நாங்கள் பின்வரும் செயலாக்கிகள் மற்றும் கருவிகளைப் பயன்படுத்துகிறோம். இந்த பராமரிப்பு கால அளவு பயனர் கணக்கு நீக்கம் கோரிக்கை செய்த பிறகு மட்டுமே பொருந்தும். Tradly Platform பயனர் தரவுகள் இயக்க மற்றும் பொறுப்பு தேவைகளுக்கு ஏற்ப 90–180 நாட்களுக்கு பராமரிக்கப்படுகின்றன.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Tradly சேவையை இயக்க, தயாரிப்பு தரத்தை மேம்படுத்த, பில்லிங் மற்றும் நம்பகத்தன்மையை ஆதரிக்க நாங்கள் பின்வரும் செயலாக்கிகள் மற்றும் கருவிகளைப் பயன்படுத்துகிறோம். இந்த பராமரிப்பு கால அளவு பயனர் கணக்கு நீக்கம் கோரிக்கை செய்த பிறகு மட்டுமே பொருந்தும். Tradly Platform பயனர் தரவுகள் இயக்க மற்றும் பொறுப்பு தேவைகளுக்கு ஏற்ப 90–180 நாட்களுக்கு பராமரிக்கப்படுகின்றன.",
    "workspace.privacy.read_more": "மேலும் படிக்கவும்.",
    "Read more.": "மேலும் படிக்கவும்.",
    "workspace.privacy.tool": "கருவி",
    "Tool": "கருவி",
    "workspace.privacy.purpose": "நோக்கம்",
    "Purpose": "நோக்கம்",
    "workspace.privacy.data_category": "தரவு வகை",
    "Data Category": "தரவு வகை",
    "workspace.privacy.deletion_requests": "கணக்கு நீக்கம் மற்றும் தரவு கோரிக்கைகள்",
    "Account deletion and data requests": "கணக்கு நீக்கம் மற்றும் தரவு கோரிக்கைகள்",
    "workspace.privacy.deletion_description": "கணக்கு நீக்கம் அல்லது வாடிக்கையாளர் தொடர்பு கருவியிலிருந்து நீக்கம் கோர, உங்கள் வேலை இட நிர்வாகியோ அல்லது ஆதரவு அலுவலகத்தை தொடர்புகொள்ளவும். இங்கு காட்டப்படுவதற்கு முன் இந்த செயல்களுக்கு பின்னடைவு உறுதிப்பாடு தேவை.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "கணக்கு நீக்கம் அல்லது வாடிக்கையாளர் தொடர்பு கருவியிலிருந்து நீக்கம் கோர, உங்கள் வேலை இட நிர்வாகியோ அல்லது ஆதரவு அலுவலகத்தை தொடர்புகொள்ளவும். இங்கு காட்டப்படுவதற்கு முன் இந்த செயல்களுக்கு பின்னடைவு உறுதிப்பாடு தேவை.",
    "workspace.privacy.open_account": "கணக்கு அமைப்பைத் திறக்கவும்",
    "Open account settings": "கணக்கு அமைப்பைத் திறக்கவும்",
    "workspace.privacy.core_operations": "தயாரிப்பு அடிப்படை இயக்கங்கள்",
    "Core product operations": "தயாரிப்பு அடிப்படை இயக்கங்கள்",
    "workspace.privacy.user_data_retention": "பயனர் தரவு (பராமரிப்பு: 90–180 நாட்கள்)",
    "User data (retention: 90–180 days)": "பயனர் தரவு (பராமரிப்பு: 90–180 நாட்கள்)",
    "workspace.privacy.crm_support_lifecycle": "CRM, ஆதரவு மற்றும் வாழ்க்கை சுழற்சி தகவல்",
    "CRM, support, lifecycle communication": "CRM, ஆதரவு மற்றும் வாழ்க்கை சுழற்சி தகவல்",
    "workspace.privacy.personal_data": "தனிப்பட்ட தரவுகள்",
    "Personal data": "தனிப்பட்ட தரவுகள்",
    "workspace.privacy.product_analytics": "தயாரிப்பு பகுப்பாய்வு மற்றும் ஈடுபடுத்தல் கோடுகள்",
    "Product analytics and engagement funnels": "தயாரிப்பு பகுப்பாய்வு மற்றும் ஈடுபடுத்தல் கோடுகள்",
    "workspace.privacy.usage_events": "பயன்பாடு மற்றும் நிகழ்வு பகுப்பாய்வு",
    "Usage and event analytics": "பயன்பாடு மற்றும் நிகழ்வு பகுப்பாய்வு",
    "workspace.privacy.billing_payments": "பில்லிங் மற்றும் கடன் செயலாக்கம்",
    "Billing and payment processing": "பில்லிங் மற்றும் கடன் செயலாக்கம்",
    "workspace.privacy.billing_data": "பில்லிங் தரவுகள்",
    "Billing data": "பில்லிங் தரவுகள்",
    "workspace.privacy.traffic_analytics": "போக்குவரத்து மற்றும் நடத்தை பகுப்பாய்வு",
    "Traffic and behavior analytics": "போக்குவரத்து மற்றும் நடத்தை பகுப்பாய்வு",
    "workspace.privacy.usage_analytics": "பயன்பாடு பகுப்பாய்வு",
    "Usage analytics": "பயன்பாடு பகுப்பாய்வு",
    "workspace.privacy.session_diagnostics": "அமர்வு தகவல்கள் மற்றும் உடைந்த பட்டன் பரிசோதனை",
    "Session insights and broken-button diagnostics": "அமர்வு தகவல்கள் மற்றும் உடைந்த பட்டன் பரிசோதனை",
    "workspace.privacy.ux_telemetry": "UX/அமர்வு தொலைமீட்டர்",
    "UX/session telemetry": "UX/அமர்வு தொலைமீட்டர்",
    "workspace.privacy.error_monitoring": "குறைபாடு தொகுதி மற்றும் நிலைத்தன்மை கண்காணிப்பு",
    "Code error and stability monitoring": "குறைபாடு தொகுதி மற்றும் நிலைத்தன்மை கண்காணிப்பு",
    "workspace.privacy.error_logs": "தொலைதூர பதிவுகள் மற்றும் பரிசோதனைகள்",
    "Error logs and diagnostics": "தொலைதூர பதிவுகள் மற்றும் பரிசோதனைகள்",
    "workspace.privacy.email_delivery": "மாற்று மின்னஞ்சல் அனுப்புதல்",
    "Transactional email delivery": "மாற்று மின்னஞ்சல் அனுப்புதல்",
    "workspace.privacy.email_metadata": "மெயில் மெட்டாடேட்டாக்கள்",
    "Email metadata": "மெயில் மெட்டாடேட்டாக்கள்",
    "workspace.privacy.hosting_infrastructure": "ஹோஸ்டிங் மற்றும் அடிப்படை அமைப்பு",
    "Hosting and infrastructure": "ஹோஸ்டிங் மற்றும் அடிப்படை அமைப்பு",
    "workspace.privacy.infrastructure_logs": "இன்ஃப்ராஸ்ட்ரக்சர் மற்றும் சேவை பதிவுகள்",
    "Infrastructure and service logs": "இன்ஃப்ராஸ்ட்ரக்சர் மற்றும் சேவை பதிவுகள்",
    "workspace.domain.title": "டொமைன்கள்",
    "Domains": "டொமைன்கள்",
    "workspace.domain.description": "Tradly-இன் பொதுவான முகவரியை மாற்ற, உங்கள் சொந்த டொமைனை இணைக்கவும்.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Tradly-இன் பொதுவான முகவரியை மாற்ற, உங்கள் சொந்த டொமைனை இணைக்கவும்.",
    "workspace.domain.invalid": "example.com போன்ற செல்லுபடியான டொமைனை உள்ளிடவும்.",
    "Enter a valid domain, such as example.com.": "example.com போன்ற செல்லுபடியான டொமைனை உள்ளிடவும்.",
    "workspace.domain.reserved": "tradly.co என்பது ஹோஸ்ட் செய்யப்பட்ட வேலை இட டொமைன்களுக்கு ஒதுக்கப்பட்டுள்ளது.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co என்பது ஹோஸ்ட் செய்யப்பட்ட வேலை இட டொமைன்களுக்கு ஒதுக்கப்பட்டுள்ளது.",
    "workspace.domain.missing_primary": "வேலை இடத்திற்கு முதன்மை டொமைன் கிடைக்கவில்லை.",
    "No primary workspace domain is available.": "வேலை இடத்திற்கு முதன்மை டொமைன் கிடைக்கவில்லை.",
    "workspace.domain.saved": "தனிப்பயன் டொமைன் சேமிக்கப்பட்டது. DNS பதிவுகளை மாற்றி, பின்னர் நிலையை புதுப்பி.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "தனிப்பயன் டொமைன் சேமிக்கப்பட்டது. DNS பதிவுகளை மாற்றி, பின்னர் நிலையை புதுப்பி.",
    "workspace.domain.reset_success": "டொமைன் Tradly-இன் ஹோஸ்ட் செய்யப்பட்ட முகவரிக்கு மீண்டும் அமைக்கப்பட்டது.",
    "Domain reset to the Tradly-hosted URL.": "டொமைன் Tradly-இன் ஹோஸ்ட் செய்யப்பட்ட முகவரிக்கு மீண்டும் அமைக்கப்பட்டது.",
    "workspace.domain.current": "தற்போதைய டொமைன்",
    "CURRENT DOMAIN": "தற்போதைய டொமைன்",
    "workspace.domain.hosted": "Tradly-இன் ஹோஸ்ட் செய்யப்பட்ட டொமைன்",
    "Tradly-hosted domain": "Tradly-இன் ஹோஸ்ட் செய்யப்பட்ட டொமைன்",
    "workspace.domain.dns_status": "DNS நிலை: {status}",
    "DNS status: {status}": "DNS நிலை: {status}",
    "workspace.domain.checking": "DNS நிலையை சரிபார்க்கிறது…",
    "Checking DNS status…": "DNS நிலையை சரிபார்க்கிறது…",
    "workspace.domain.refresh": "நிலையை புதுப்பி",
    "Refresh status": "நிலையை புதுப்பி",
    "workspace.domain.reset": "டொமைனை மீட்டமை",
    "Reset domain": "டொமைனை மீட்டமை",
    "workspace.domain.connect_title": "தனிப்பயன் டொமைனை இணைக்கவும்",
    "Connect a custom domain": "தனிப்பயன் டொமைனை இணைக்கவும்",
    "workspace.domain.connect_description": "நீங்கள் ஏற்கனவே உரிமையாளராக உள்ள டொமைனை உள்ளிடவும். அதை இணைக்க தேவையான DNS பதிவுகளை நாங்கள் காட்டுவோம்.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "நீங்கள் ஏற்கனவே உரிமையாளராக உள்ள டொமைனை உள்ளிடவும். அதை இணைக்க தேவையான DNS பதிவுகளை நாங்கள் காட்டுவோம்.",
    "workspace.domain.saving": "சேமிக்கப்படுகிறது…",
    "workspace.domain.add": "டொமைனை சேர்க்கவும்",
    "Add domain": "டொமைனை சேர்க்கவும்",
    "workspace.domain.dns_title": "DNS அமைப்பு",
    "DNS setup": "DNS அமைப்பு",
    "workspace.domain.a_record": "A பதிவு",
    "A record": "A பதிவு",
    "workspace.domain.root_description": "இதை மூல டொமைன் போன்று பயன்படுத்தவும்",
    "Use this for a root domain such as": "இதை மூல டொமைன் போன்று பயன்படுத்தவும்",
    "workspace.domain.cname_record": "CNAME பதிவு",
    "CNAME record": "CNAME பதிவு",
    "workspace.domain.subdomain_description": "இதை உப-டொமைன் போன்றதற்கு பயன்படுத்தவும்",
    "Use this for a subdomain such as": "இதை உப-டொமைன் போன்றதற்கு பயன்படுத்தவும்",
    "workspace.domain.host": "ஹோஸ்ட்",
    "Host": "ஹோஸ்ட்",
    "workspace.domain.value": "மதிப்பு",
    "Value": "மதிப்பு",
    "workspace.domain.need_domain": "தேவையான டொமைன்?",
    "Need a domain?": "தேவையான டொமைன்?",
    "workspace.domain.buy_domain": "Google Domains அல்லது GoDaddy-லிலிருந்து டொமைனை வாங்கி, அதை இணைக்க இங்கு திரும்பவும்.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Google Domains அல்லது GoDaddy-லிலிருந்து டொமைனை வாங்கி, அதை இணைக்க இங்கு திரும்பவும்.",
    "workspace.billing.title": "கணக்கெடுப்பு மற்றும் பயன்பாடு",
    "Billing & Usage": "கணக்கெடுப்பு மற்றும் பயன்பாடு",
    "workspace.billing.description": "வேர்க்ஸ்பேஸ் திட்டங்கள், பயன்பாடு மற்றும் கணக்கெடுப்பை மேலாண்மை செய்யவும்.",
    "Manage workspace plans, usage, and billing.": "வேர்க்ஸ்பேஸ் திட்டங்கள், பயன்பாடு மற்றும் கணக்கெடுப்பை மேலாண்மை செய்யவும்.",
    "workspace.billing.invoice_description": "வேர்க்ஸ்பேஸ் திட்டங்கள், பயன்பாடு மற்றும் கட்டணம் செலுத்தப்பட்ட கணக்கெடுப்புகளை மேலாண்மை செய்யவும்.",
    "Manage workspace plans, usage, and paid invoices.": "வேர்க்ஸ்பேஸ் திட்டங்கள், பயன்பாடு மற்றும் கட்டணம் செலுத்தப்பட்ட கணக்கெடுப்புகளை மேலாண்மை செய்யவும்.",
    "workspace.billing.usage_description": "இந்த வேர்க்ஸ்பேஸில் பயன்படுத்தப்பட்ட பயன்பாட்டையும், விதிகளையும் பார்க்கவும்.",
    "workspace.invoices.loading": "கணக்கெடுப்புகளை ஏற்றுகிறது…",
    "Loading invoices…": "கணக்கெடுப்புகளை ஏற்றுகிறது…",
    "workspace.invoices.description": "கணக்கெடுப்புகளை பதிவிறக்கவும் அல்லது தொகை செலுத்த வேண்டிய தொகையை முடிக்கவும்.",
    "Download invoices or complete payment for an outstanding balance.": "கணக்கெடுப்புகளை பதிவிறக்கவும் அல்லது தொகை செலுத்த வேண்டிய தொகையை முடிக்கவும்.",
    "workspace.invoices.payment_failed": "கட்டணம் தோல்வியடைந்தது — சேவை அணுகல் பாதிக்கப்படலாம்.",
    "Payment failed — service access may be affected.": "கட்டணம் தோல்வியடைந்தது — சேவை அணுகல் பாதிக்கப்படலாம்.",
    "workspace.invoices.awaiting_payment": "கணக்கெடுப்பு {invoice} கட்டணம் செலுத்த காத்திருக்கிறது.",
    "Invoice {invoice} is awaiting payment.": "கணக்கெடுப்பு {invoice} கட்டணம் செலுத்த காத்திருக்கிறது.",
    "workspace.invoices.outstanding": "தொகை செலுத்த வேண்டிய",
    "outstanding": "தொகை செலுத்த வேண்டிய",
    "workspace.invoices.pay_invoice": "கணக்கெடுப்பை செலுத்து",
    "Pay invoice": "கணக்கெடுப்பை செலுத்து",
    "workspace.invoices.invoice": "கணக்கெடுப்பு",
    "workspace.invoices.date": "தேதி",
    "workspace.invoices.amount": "தொகை",
    "workspace.invoices.paid": "செலுத்தப்பட்டது",
    "workspace.invoices.unpaid": "செலுத்தப்படாதது",
    "workspace.invoices.download_invoice": "கணக்கெடுப்பை பதிவிறக்கு",
    "Download invoice": "கணக்கெடுப்பை பதிவிறக்கு",
    "workspace.invoices.empty_title": "கணக்கெடுப்புகள் கிடைக்கவில்லை",
    "No invoices available": "கணக்கெடுப்புகள் கிடைக்கவில்லை",
    "workspace.invoices.empty_description": "உங்கள் பதிவு செய்த பிறகும் கட்டணம் செலுத்திய பிறகும் கணக்கெடுப்புகள் உருவாக்கப்படுகின்றன. கேள்விகள் இருந்தால் ஆதரவு அலுவலகத்தை தொடர்புகொள்ளவும்.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "உங்கள் பதிவு செய்த பிறகும் கட்டணம் செலுத்திய பிறகும் கணக்கெடுப்புகள் உருவாக்கப்படுகின்றன. கேள்விகள் இருந்தால் ஆதரவு அலுவலகத்தை தொடர்புகொள்ளவும்.",
    "workspace.plans.heading": "திட்டங்கள்",
    "workspace.plans.tab_marketplace": "மார்க்கெட்",
    "workspace.plans.tab_marketplace_description": "பல்வேறு விற்பனையாளர்கள்",
    "Multi-vendor": "பல்வேறு விற்பனையாளர்கள்",
    "workspace.plans.tab_single": "ஒரே கடை",
    "Single Store": "ஒரே கடை",
    "workspace.plans.tab_single_description": "தனித்துவமான மற்றும் படைப்பாளிகள்",
    "Indie & Creators": "தனித்துவமான மற்றும் படைப்பாளிகள்",
    "workspace.plans.tab_alacarte": "அலா கார்ட்",
    "workspace.plans.tab_alacarte_description": "கிரெடிட்கள் மற்றும் கூடுதல் பொருட்கள்",
    "Credits & add-ons": "கிரெடிட்கள் மற்றும் கூடுதல் பொருட்கள்",
    "workspace.plans.tab_services": "சேவைகள்",
    "Services": "சேவைகள்",
    "workspace.plans.tab_services_description": "கூடுதல் சேவைகள்",
    "Additional services": "கூடுதல் சேவைகள்",
    "workspace.plans.selected": "தேர்ந்தெடுக்கப்பட்டது",
    "Selected": "தேர்ந்தெடுக்கப்பட்டது",
    "workspace.plans.try_again": "மீண்டும் முயற்சி செய்யவும்",
    "workspace.plans.bill_yearly": "ஆண்டுக்கு கணக்கு வழங்குதல்",
    "Bill Yearly": "ஆண்டுக்கு கணக்கு வழங்குதல்",
    "workspace.plans.bill_monthly": "மாதத்திற்கு கணக்கு வழங்குதல்",
    "Bill Monthly": "மாதத்திற்கு கணக்கு வழங்குதல்",
    "workspace.plans.compare": "திட்டங்களை ஒப்பிடு",
    "Compare Plans": "திட்டங்களை ஒப்பிடு",
    "workspace.plans.community": "குழுமம்",
    "workspace.plans.community_description": "நிரந்தரமாக இலவசம். இது அருமையான பிரிவுகளுக்கும் குழு திட்டங்களுக்கும் பொருத்தமானது.",
    "Free forever. Perfect for hobbyists and community projects.": "நிரந்தரமாக இலவசம். இது அருமையான பிரிவுகளுக்கும் குழு திட்டங்களுக்கும் பொருத்தமானது.",
    "workspace.plans.different_configurations": "வேறுபட்ட அமைப்புகளைத் தேடுகிறீர்களா?",
    "Looking for different configurations?": "வேறுபட்ட அமைப்புகளைத் தேடுகிறீர்களா?",
    "workspace.plans.contact_us": "எங்களை தொடர்பு கொள்ளவும்",
    "Contact Us": "எங்களை தொடர்பு கொள்ளவும்",
    "workspace.plans.see_alacarte_pricing": "அலா கார்ட் விலைகளைப் பார்க்கவும்",
    "See à la carte pricing": "அலா கார்ட் விலைகளைப் பார்க்கவும்",
    "workspace.plans.available": "கிடைக்கும்",
    "Available": "கிடைக்கும்",
    "workspace.plans.used_90d": "பயன்படுத்தப்பட்டது (90d)",
    "Used (90d)": "பயன்படுத்தப்பட்டது (90d)",
    "workspace.plans.expired_90d": "முடிவடைந்தது (90d)",
    "Expired (90d)": "முடிவடைந்தது (90d)",
    "workspace.plans.expires_on": "முடிவடைகிறது {date}",
    "Expires {date}": "முடிவடைகிறது {date}",
    "workspace.plans.top_up_credits": "கிரெடிட்களை நிரப்பு",
    "Top Up Credits": "கிரெடிட்களை நிரப்பு",
    "workspace.plans.credits_description": "கிரெடிட்கள் மெய்ல், ஐ.ஏ. தேடல், பரிந்துரைகள் மற்றும் ஏஜென்ட் செயல்பாடுகளைப் பயன்படுத்த உதவுகின்றன. 100 கிரெடிட்கள் = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "கிரெடிட்கள் மெய்ல், ஐ.ஏ. தேடல், பரிந்துரைகள் மற்றும் ஏஜென்ட் செயல்பாடுகளைப் பயன்படுத்த உதவுகின்றன. 100 கிரெடிட்கள் = $5.",
    "workspace.plans.credits": "கிரெடிட்கள்",
    "credits": "கிரெடிட்கள்",
    "workspace.plans.custom_amount": "தனிப்பயன் தொகை",
    "Custom amount": "தனிப்பயன் தொகை",
    "workspace.plans.amount_example": "எ.கா. 2500",
    "e.g. 2500": "எ.கா. 2500",
    "workspace.plans.opening_checkout": "கேஷ் திறக்கப்படுகிறது…",
    "Opening checkout…": "கேஷ் திறக்கப்படுகிறது…",
    "workspace.plans.buy_credits": "{count} கிரெடிட்களை வாங்கவும்",
    "Buy {count} credits": "{count} கிரெடிட்களை வாங்கவும்",
    "workspace.plans.select_amount": "தொகையைத் தேர்வு செய்யவும்",
    "Select an amount": "தொகையைத் தேர்வு செய்யவும்",
    "workspace.plans.alacarte_products": "அலாகார்ட் பொருட்கள்",
    "A la carte Products": "அலாகார்ட் பொருட்கள்",
    "workspace.plans.products_description": "நீங்கள் பயன்படுத்தும் பொருட்களைத் தேர்வு செய்யவும். இது உங்கள் அனுபவத்தை தனிப்பயனாக்க உதவுகிறது. பயன்பாடு கிரெடிட்களுக்கு கட்டணம் வசூலிக்கப்படுகிறது.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "நீங்கள் பயன்படுத்தும் பொருட்களைத் தேர்வு செய்யவும். இது உங்கள் அனுபவத்தை தனிப்பயனாக்க உதவுகிறது. பயன்பாடு கிரெடிட்களுக்கு கட்டணம் வசூலிக்கப்படுகிறது.",
    "workspace.plans.enabled": "செயல்பாட்டில்",
    "workspace.plans.enable": "செயல்படுத்து",
    "Enable": "செயல்படுத்து",
    "workspace.plans.open_here": "இங்கே திறக்கவும்",
    "Open here": "இங்கே திறக்கவும்",
    "workspace.plans.open_marketing": "marketing.tradly.app-ஐத் திறக்கவும்",
    "Open marketing.tradly.app": "marketing.tradly.app-ஐத் திறக்கவும்",
    "workspace.plans.open_analytics": "analytics.tradly.app-ஐத் திறக்கவும்",
    "Open analytics.tradly.app": "analytics.tradly.app-ஐத் திறக்கவும்",
    "workspace.plans.open_external": "வெளிப்புறத்தைத் திறக்கவும்",
    "Open external": "வெளிப்புறத்தைத் திறக்கவும்",
    "workspace.plans.coming_soon": "விரைவில்",
    "Coming soon": "விரைவில்",
    "workspace.plans.services_title": "ஒருமுறை அமைப்பு மற்றும் தனிப்பயன் சேவைகள்",
    "One-Time Setup & Custom Services": "ஒருமுறை அமைப்பு மற்றும் தனிப்பயன் சேவைகள்",
    "workspace.plans.service_app_launch": "வெள்ளை அடையாள பயன்பாட்டு தொடங்குதல்",
    "White-Label App Launch": "வெள்ளை அடையாள பயன்பாட்டு தொடங்குதல்",
    "workspace.plans.service_frontend": "ஃப்ரண்ட்எண்ட் தனிப்பயனாக்கம்",
    "Frontend Customization": "ஃப்ரண்ட்எண்ட் தனிப்பயனாக்கம்",
    "workspace.plans.service_multilanguage": "பல மொழி ஆதரவு",
    "Multi-Language Support": "பல மொழி ஆதரவு",
    "workspace.plans.view_docs": "ஆவணங்களைப் பார்க்கவும்",
    "View Docs": "ஆவணங்களைப் பார்க்கவும்",
    "workspace.plans.confirm_change": "திட்ட மாற்றத்தை உறுதிப்படுத்தவும்",
    "Confirm your plan change": "திட்ட மாற்றத்தை உறுதிப்படுத்தவும்",
    "workspace.plans.confirm_charge": "கட்டணங்கள் முன்கூட்டியே செலுத்தப்பட்டு, உங்கள் பதிவு தேதியில் விவரிக்கப்படுகின்றன.",
    "Charges are prepaid and billed on your subscription date.": "கட்டணங்கள் முன்கூட்டியே செலுத்தப்பட்டு, உங்கள் பதிவு தேதியில் விவரிக்கப்படுகின்றன.",
    "workspace.plans.confirm_promo": "கிடைக்கும் போது, Stripe செலுத்தும் போது பிரமோஷனல் குறியீடுகளை உள்ளிடலாம்.",
    "Promotional codes can be entered during Stripe checkout where available.": "கிடைக்கும் போது, Stripe செலுத்தும் போது பிரமோஷனல் குறியீடுகளை உள்ளிடலாம்.",
    "workspace.plans.confirm_delay": "திட்ட மாற்றங்கள் உங்கள் வொர்க்ஸ்பேஸில் தோன்ற சிறிது நேரம் ஆகலாம்.",
    "Plan changes may take a moment to appear in your workspace.": "திட்ட மாற்றங்கள் உங்கள் வொர்க்ஸ்பேஸில் தோன்ற சிறிது நேரம் ஆகலாம்.",
    "workspace.plans.payment_active": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டம் செயல்பாட்டில் உள்ளது.",
    "Payment received. Your plan is active.": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டம் செயல்பாட்டில் உள்ளது.",
    "workspace.plans.payment_method_updated": "கட்டண முறை புதுப்பிக்கப்பட்டுள்ளது.",
    "Payment method updated.": "கட்டண முறை புதுப்பிக்கப்பட்டுள்ளது.",
    "workspace.plans.payment_cancelled": "கட்டணம் முடிக்கப்படவில்லை, எனவே உங்கள் திட்டம் மாற்றமடையவில்லை.",
    "Payment was not completed, so your plan has not changed.": "கட்டணம் முடிக்கப்படவில்லை, எனவே உங்கள் திட்டம் மாற்றமடையவில்லை.",
    "workspace.plans.activating": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டத்தை செயல்படுத்துகிறோம்…",
    "Payment received. Activating your plan…": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டத்தை செயல்படுத்துகிறோம்…",
    "workspace.plans.activation_delayed": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டம் செயல்பாட்டிற்கு சிறிது நேரம் எடுக்கிறது. ஒரு நிமிடத்தில் புதுப்பிக்கவும்.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "கட்டணம் பெறப்பட்டது. உங்கள் திட்டம் செயல்பாட்டிற்கு சிறிது நேரம் எடுக்கிறது. ஒரு நிமிடத்தில் புதுப்பிக்கவும்.",
    "workspace.plans.card_saved": "கார்டு சேமிக்கப்பட்டுள்ளது மற்றும் உறுப்பினர் பதிவு புதுப்பிக்கப்பட்டுள்ளது.",
    "Card saved and subscription updated.": "கார்டு சேமிக்கப்பட்டுள்ளது மற்றும் உறுப்பினர் பதிவு புதுப்பிக்கப்பட்டுள்ளது.",
    "workspace.plans.subscription_updated": "உறுப்பினர் பதிவு புதுப்பிக்கப்பட்டுள்ளது.",
    "Subscription updated.": "உறுப்பினர் பதிவு புதுப்பிக்கப்பட்டுள்ளது.",
    "workspace.plans.products_saved": "அலா கார்ட் தயாரிப்புகள் சேமிக்கப்பட்டன.",
    "À la carte products saved.": "அலா கார்ட் தயாரிப்புகள் சேமிக்கப்பட்டன.",
    "workspace.plans.minimum_credits": "குறைந்தது 100 கிரெடிட்களை உள்ளிடவும்.",
    "Enter at least 100 credits.": "குறைந்தது 100 கிரெடிட்களை உள்ளிடவும்.",
    "workspace.plans.credit_topup_description": "கிரெடிட் நிரப்புதல் ({count} கிரெடிட்கள்)",
    "Credit Top-Up ({count} credits)": "கிரெடிட் நிரப்புதல் ({count} கிரெடிட்கள்)",
    "workspace.plans.billing_details": "தற்போதைய விலை விவரங்கள்",
    "Current billing details": "தற்போதைய விலை விவரங்கள்",
    "workspace.plans.current_plan": "தற்போதைய திட்டம்",
    "Current Plan": "தற்போதைய திட்டம்",
    "workspace.plans.renews": "மீண்டும் பெறுதல்",
    "Renews": "மீண்டும் பெறுதல்",
    "workspace.plans.payment_method": "கட்டண முறை",
    "Payment method": "கட்டண முறை",
    "workspace.plans.opening": "திறக்கப்படுகிறது…",
    "Opening…": "திறக்கப்படுகிறது…",
    "workspace.plans.manage_payment_method": "கட்டண முறையை நிர்வகிக்கவும்",
    "Manage payment method": "கட்டண முறையை நிர்வகிக்கவும்",
    "workspace.plans.upgrade": "புதுப்பிக்கவும்",
    "workspace.plans.downgrade": "குறைப்பு",
    "Downgrade": "குறைப்பு",
    "workspace.plans.custom_price": "தனிப்பயன்",
    "workspace.plans.per_month_short": "/மாதம்",
    "/month": "/மாதம்",
    "workspace.plans.per_year_amount": "ஆண்டுக்கு ({amount})",
    "per year ({amount})": "ஆண்டுக்கு ({amount})",
    "workspace.plans.per_month_amount": "மாதத்திற்கு ({amount})",
    "per month ({amount})": "மாதத்திற்கு ({amount})",
    "workspace.plans.yearly_savings": "ஆண்டுக்கு {amount} சேமிக்கவும்",
    "Save {amount} yearly": "ஆண்டுக்கு {amount} சேமிக்கவும்",
    "workspace.plans.billed_yearly": "ஆண்டுக்கு விலை கணக்கிடப்படுகிறது",
    "billed yearly": "ஆண்டுக்கு விலை கணக்கிடப்படுகிறது",
    "workspace.plans.billed_monthly": "மாதாந்திர கணக்கெடுப்பு",
    "billed monthly": "மாதாந்திர கணக்கெடுப்பு",
    "workspace.plans.free_trial": "நீங்கள் இலவச சோதனையில் உள்ளீர்கள்.",
    "You are on a free trial.": "நீங்கள் இலவச சோதனையில் உள்ளீர்கள்.",
    "workspace.plans.updating": "புதுப்பித்துக் கொண்டிருக்கிறோம்…",
    "Updating…": "புதுப்பித்துக் கொண்டிருக்கிறோம்…",
    "workspace.plans.temporarily_unavailable": "தற்காலிகமாக கிடைக்காது",
    "Temporarily unavailable": "தற்காலிகமாக கிடைக்காது",
    "workspace.plans.whats_included": "என்ன அடங்கும்",
    "What's included": "என்ன அடங்கும்",
    "workspace.plans.products.auth.title": "அடையாளம் காட்டுதல்",
    "workspace.plans.products.auth.description": "அடையாளம், SSO, அனுமதிகள் மற்றும் பயனர் மேலாண்மை.",
    "Identity, SSO, permissions, and user management.": "அடையாளம், SSO, அனுமதிகள் மற்றும் பயனர் மேலாண்மை.",
    "workspace.plans.products.email.title": "மின்னஞ்சல்",
    "workspace.plans.products.email.description": "மாற்று மற்றும் பரிமாற்ற மின்னஞ்சல், அடங்கியுள்ளது.",
    "Transactional and marketing email, built in.": "மாற்று மற்றும் பரிமாற்ற மின்னஞ்சல், அடங்கியுள்ளது.",
    "workspace.plans.products.analytics.title": "பகுப்பாய்வு",
    "workspace.plans.products.analytics.description": "இணையதளம், பயன்பாடு மற்றும் ஏஜென்ட்களுக்கான இலவச பகுப்பாய்வு.",
    "Free analytics for web, app, and agents.": "இணையதளம், பயன்பாடு மற்றும் ஏஜென்ட்களுக்கான இலவச பகுப்பாய்வு.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "பயனர் செயல்பாட்டிலிருந்து தானாக நிரப்பப்படும் CRM.",
    "A CRM that fills itself from user activity.": "பயனர் செயல்பாட்டிலிருந்து தானாக நிரப்பப்படும் CRM.",
    "workspace.plans.products.subscription.title": "சந்தாக்கள்",
    "workspace.plans.products.subscription.description": "மீண்டும் மீண்டும் கணக்கெடுப்பு, சோதனைகள் மற்றும் கடன் மேலாண்மை — கையாளப்பட்டது.",
    "Recurring billing, trials, and dunning — handled.": "மீண்டும் மீண்டும் கணக்கெடுப்பு, சோதனைகள் மற்றும் கடன் மேலாண்மை — கையாளப்பட்டது.",
    "workspace.plans.products.recommendation.title": "பரிந்துரைகள்",
    "Recommendations": "பரிந்துரைகள்",
    "workspace.plans.products.recommendation.description": "ஆர்வம் உள்ள ஒவ்வொரு பயனருக்கும் அவர்கள் உண்மையில் விரும்பும் விஷயத்தைக் காட்டுகிறது.",
    "Show each user what they will actually want.": "ஆர்வம் உள்ள ஒவ்வொரு பயனருக்கும் அவர்கள் உண்மையில் விரும்பும் விஷயத்தைக் காட்டுகிறது.",
    "workspace.plans.marketplace.2025-superstarter.title": "அடிப்படை",
    "Basic": "அடிப்படை",
    "workspace.plans.marketplace.2025-superstarter.description": "சிறிய குழுவிற்கு ஏற்றது. அனைத்து சமூக அம்சங்களுடன் மட்டும் \"Tradly உருவாக்கப்பட்டது\" பட்டம் அகற்றப்பட்டுள்ளது.",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "சிறிய குழுவிற்கு ஏற்றது. அனைத்து சமூக அம்சங்களுடன் மட்டும் \"Tradly உருவாக்கப்பட்டது\" பட்டம் அகற்றப்பட்டுள்ளது.",
    "workspace.plans.marketplace.2025-superstarter.button": "7 நாட்கள் சோதனையைத் தொடங்கவும்",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "கடன் கட்டணம் இல்லை",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Tradly இன் இலவச வலைத்தளம் பதிவு செய்யப்பட்டுள்ளது",
    "Free Tradly hosted website": "Tradly இன் இலவச வலைத்தளம் பதிவு செய்யப்பட்டுள்ளது",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "உங்கள் தனிப்பயன் டொமைனைச் சேர்க்கவும்",
    "Add your custom domain": "உங்கள் தனிப்பயன் டொமைனைச் சேர்க்கவும்",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "தொகுப்பாளர் - 3 நாட்கள் பக்க வரலாறு",
    "Editor - 3 Day page history": "தொகுப்பாளர் - 3 நாட்கள் பக்க வரலாறு",
    "workspace.plans.marketplace.2025-starter.title": "ஸ்டார்டர்",
    "Starter": "ஸ்டார்டர்",
    "workspace.plans.marketplace.2025-starter.description": "விற்பனை யோசனையை சோதிக்கும் ஸ்டார்ட்அப்களுக்கு. சந்தை சோதனை மற்றும் முதல் வாடிக்கையாளர் பெறுவதற்கான அனைத்து அடிப்படைகளையும் உள்ளடக்கியது.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "விற்பனை யோசனையை சோதிக்கும் ஸ்டார்ட்அப்களுக்கு. சந்தை சோதனை மற்றும் முதல் வாடிக்கையாளர் பெறுவதற்கான அனைத்து அடிப்படைகளையும் உள்ளடக்கியது.",
    "workspace.plans.marketplace.2025-starter.button": "7 நாட்கள் சோதனை தொடங்கு",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "கட்டணம் இல்லாமல் கடன்",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "முடிவில்லாத தனிப்பயன் பண்புகள்",
    "Unlimited Custom Attributes": "முடிவில்லாத தனிப்பயன் பண்புகள்",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "30 நாட்கள் பக்க வரலாறு",
    "30 Day page history": "30 நாட்கள் பக்க வரலாறு",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "கட்டுப்பாட்டு சேவை",
    "Gated Subscription": "கட்டுப்பாட்டு சேவை",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "சமூக உள்நுழைவுகள்",
    "Social Logins": "சமூக உள்நுழைவுகள்",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "வெப்ஹுக்ஸ்",
    "Webhooks": "வெப்ஹுக்ஸ்",
    "workspace.plans.marketplace.2025-growth.title": "கிரோத்",
    "Growth": "கிரோத்",
    "workspace.plans.marketplace.2025-growth.description": "வளர்ச்சி கட்டத்தில் சோதிக்கப்பட்ட யோசனைகளுக்கு. வளர்ச்சிக்கு தனிப்பயன் தேவைகள் மற்றும் கூடுதல் ஒத்துழைப்புகளை கொண்டுள்ளது.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "வளர்ச்சி கட்டத்தில் சோதிக்கப்பட்ட யோசனைகளுக்கு. வளர்ச்சிக்கு தனிப்பயன் தேவைகள் மற்றும் கூடுதல் ஒத்துழைப்புகளை கொண்டுள்ளது.",
    "workspace.plans.marketplace.2025-growth.button": "7 நாட்கள் சோதனை தொடங்கு",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "கட்டணம் இல்லாமல் கடன்",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "தனிப்பயன் 'முதல் மின்னஞ்சல்'",
    "Custom 'From Email'": "தனிப்பயன் 'முதல் மின்னஞ்சல்'",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "கூடுதல் மினி கருவிகள் மற்றும் ஒத்துழைப்புகள்",
    "Additional Mini Tools & Integrations": "கூடுதல் மினி கருவிகள் மற்றும் ஒத்துழைப்புகள்",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "தனிப்பயன் உள்ளீடு அழைப்புகள்*",
    "Personalised Onboarding calls*": "தனிப்பயன் உள்ளீடு அழைப்புகள்*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "90 நாட்கள் பக்க வரலாறு",
    "90 Day page history": "90 நாட்கள் பக்க வரலாறு",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "பல முக்கிய மொழிகள் மற்றும் பணம்",
    "Multi Currencies & Multi Languages": "பல முக்கிய மொழிகள் மற்றும் பணம்",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "பங்கு அடிப்படையிலான அணுகல் கட்டுப்பாடு (RBAC)",
    "Role-based access control (RBAC)": "பங்கு அடிப்படையிலான அணுகல் கட்டுப்பாடு (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "பயன்பாடுகளுக்கான கூட்டு செய்திகள்",
    "Inbuilt Chat for Apps": "பயன்பாடுகளுக்கான கூட்டு செய்திகள்",
    "workspace.plans.marketplace.2025-scale.title": "ஸ்கேல்",
    "Scale": "ஸ்கேல்",
    "workspace.plans.marketplace.2025-scale.description": "வளர்ச்சி கட்டத்தில் உள்ள நிறுவனங்கள், தனிப்பயன் தீர்வுகள் மற்றும் கூடுதல் தேவைகளை தேடுகின்றன.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "வளர்ச்சி கட்டத்தில் உள்ள நிறுவனங்கள், தனிப்பயன் தீர்வுகள் மற்றும் கூடுதல் தேவைகளை தேடுகின்றன.",
    "workspace.plans.marketplace.2025-scale.button": "7 நாட்கள் சோதனை தொடங்கு",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "கட்டணம் இல்லாமல் கடன்",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "முன்னுரிமை ஆதரவு",
    "Priority Support": "முன்னுரிமை ஆதரவு",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "நிறைய சேனல்கள் (ஆப்ஸ் ஆதரவு)",
    "Multiple Channels (App Support)": "நிறைய சேனல்கள் (ஆப்ஸ் ஆதரவு)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "ஒரே பயனர் அடையாளம் (SSO)",
    "Single Sign-on (SSO)": "ஒரே பயனர் அடையாளம் (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "முடிவற்ற பக்க வரலாறு",
    "Unlimited page history": "முடிவற்ற பக்க வரலாறு",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "ஆப்ஸ்களுக்கான உள்ளீட்டு சாட்",
    "In-built Chat for Apps": "ஆப்ஸ்களுக்கான உள்ளீட்டு சாட்",
    "workspace.plans.indie.go.title": "ப்ரோ",
    "Pro": "ப்ரோ",
    "workspace.plans.indie.go.description": "வளரும் கடைக்கு தேவையான அனைத்தும் — பிராண்டிங்கை அகற்றி, உங்கள் டொமைனைச் சேர்த்து, மேலும் கருவிகளை விடுவிக்கவும்.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "வளரும் கடைக்கு தேவையான அனைத்தும் — பிராண்டிங்கை அகற்றி, உங்கள் டொமைனைச் சேர்த்து, மேலும் கருவிகளை விடுவிக்கவும்.",
    "workspace.plans.indie.go.button": "7 நாட்கள் சோதனையை தொடங்கு",
    "Start 7-day trial": "7 நாட்கள் சோதனையை தொடங்கு",
    "workspace.plans.indie.go.feature_1.title": "டிராட்லி பிராண்டிங் இல்லை",
    "No Tradly branding": "டிராட்லி பிராண்டிங் இல்லை",
    "workspace.plans.indie.go.feature_2.title": "தனிப்பயன் டொமைன்",
    "Custom domain": "தனிப்பயன் டொமைன்",
    "workspace.plans.indie.go.feature_3.title": "முடிவற்ற பொருட்கள்",
    "Unlimited products": "முடிவற்ற பொருட்கள்",
    "workspace.plans.indie.go.feature_4.title": "மின்னஞ்சல் பிரச்சாரங்கள்",
    "Email campaigns": "மின்னஞ்சல் பிரச்சாரங்கள்",
    "workspace.plans.indie.go.feature_5.title": "AI பரிந்துரைகள்",
    "AI Recommendations": "AI பரிந்துரைகள்",
    "workspace.plans.indie.go.feature_6.title": "டிக்கெட் அடிப்படையிலான ஆதரவு",
    "Ticket-based support": "டிக்கெட் அடிப்படையிலான ஆதரவு",
    "workspace.plans.indie.genius.title": "ஜெனியஸ்",
    "Genius": "ஜெனியஸ்",
    "workspace.plans.indie.genius.description": "முழுமையான AI அமைப்பு, மேம்பட்ட பிரச்சாரம், வளர்ச்சியை கவனிக்கும் கடைகளுக்கு அனைத்தும் திறந்துள்ளது.",
    "workspace.plans.indie.genius.button": "7 நாட்கள் சோதனையை தொடங்கு",
    "workspace.plans.indie.genius.feature_1.title": "ப்ரோவில் உள்ள அனைத்தும்",
    "Everything in Pro": "ப்ரோவில் உள்ள அனைத்தும்",
    "workspace.plans.indie.genius.feature_2.title": "AI ஏஜென்ட்கள் (வாங்கும் உதவி, மேலும்)",
    "AI Agents (Shopping Assistant, etc.)": "AI ஏஜென்ட்கள் (வாங்கும் உதவி, மேலும்)",
    "workspace.plans.indie.genius.feature_3.title": "இயற்கை மொழி தேடல்",
    "Natural language search": "இயற்கை மொழி தேடல்",
    "workspace.plans.indie.genius.feature_4.title": "மேம்பட்ட மின்னஞ்சல் தானியங்கி",
    "Advanced email automation": "மேம்பட்ட மின்னஞ்சல் தானியங்கி",
    "workspace.plans.indie.genius.feature_5.title": "முடிவற்ற பரிந்துரை கோரிக்கைகள்",
    "Unlimited recommendation requests": "முடிவற்ற பரிந்துரை கோரிக்கைகள்",
    "workspace.plans.indie.genius.feature_6.title": "டிக்கெட் அடிப்படையிலான ஆதரவு",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "கணக்குகளைத் திறக்கவும் பட்டியல்களை அனுப்பவும் சந்தா கட்டணங்கள்",
    "Subscription charges for people to open accounts & submit listings": "கணக்குகளைத் திறக்கவும் பட்டியல்களை அனுப்பவும் சந்தா கட்டணங்கள்",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "கூகிள், மெட்டா மூலம் பதிவு/உள்நுழைவு",
    "Signup/in via Google, Meta": "கூகிள், மெட்டா மூலம் பதிவு/உள்நுழைவு",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Zapier & Make உடன் இணைக்க முடியும்",
    "To connect with Zapier & Make": "Zapier & Make உடன் இணைக்க முடியும்",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "உங்கள் பயனர்களுக்கான நேரடி பயன்பாட்டு செய்திகள்",
    "Native in-app messaging for your users": "உங்கள் பயனர்களுக்கான நேரடி பயன்பாட்டு செய்திகள்",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "இயல்பு தொடர்புகளுக்கு 24 மணி நேர பதில் காலம்",
    "24 hour response time for non-critical": "இயல்பு தொடர்புகளுக்கு 24 மணி நேர பதில் காலம்",
    "common.continue": "தொடர்க",
    "Continue": "தொடர்க",
    "workspace.plans.free_plan": "இலவசம்",
    "Free": "இலவசம்",
    "workspace.usage.group_platform": "தளம் மற்றும் வேலை இடம்",
    "Platform & workspace": "தளம் மற்றும் வேலை இடம்",
    "workspace.usage.group_ai": "AI மற்றும் பயன்பாடு",
    "AI & usage": "AI மற்றும் பயன்பாடு",
    "workspace.usage.group_storage": "பொருள் மற்றும் சேமிப்பு",
    "Content & storage": "பொருள் மற்றும் சேமிப்பு",
    "workspace.usage.group_alacarte": "அ லா கார்ட்",
    "workspace.usage.accounts": "கணக்குகள்",
    "workspace.usage.listings": "பட்டியல்கள்",
    "workspace.usage.sites": "வேலை இடத்தில் உள்ள தளங்கள்",
    "Sites under workspace": "வேலை இடத்தில் உள்ள தளங்கள்",
    "workspace.usage.external_users": "வெளிப்புற பயனர்கள்",
    "External users": "வெளிப்புற பயனர்கள்",
    "workspace.usage.internal_users": "உள்ளீட்டு பயனர்கள்",
    "Internal users": "உள்ளீட்டு பயனர்கள்",
    "workspace.usage.ai_credits": "AI கிரெடிட்டுகள்",
    "AI credits": "AI கிரெடிட்டுகள்",
    "workspace.usage.storage": "சேமிப்பு",
    "Storage": "சேமிப்பு",
    "workspace.usage.email": "மின்னஞ்சல்",
    "workspace.usage.maps": "மேப்புகள்",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "வாட்ஸ்அப்",
    "WhatsApp": "வாட்ஸ்அப்",
    "workspace.usage.analytics": "பகுப்பாய்வுகள்",
    "workspace.usage.recommendations": "பரிந்துரைகள்",
    "workspace.usage.ai_agents": "AI ஏஜென்ட்கள்",
    "AI agents": "AI ஏஜென்ட்கள்",
    "workspace.usage.status_not_reported": "அறிவிக்கப்படவில்லை",
    "Not reported": "அறிவிக்கப்படவில்லை",
    "workspace.usage.status_nearly_full": "நிரப்பப்பட்டுள்ளது",
    "Nearly full": "நிரப்பப்பட்டுள்ளது",
    "workspace.usage.status_on_track": "பாதையில்",
    "On track": "பாதையில்",
    "workspace.usage.workspace_files": "வேலை இடத்தின் கோப்புகள்",
    "Workspace files": "வேலை இடத்தின் கோப்புகள்",
    "workspace.usage.workspace_usage": "வேலை இடத்தின் பயன்பாடு",
    "Workspace usage": "வேலை இடத்தின் பயன்பாடு",
    "workspace.usage.of_limit": "{limit}-ன் பின்னர்",
    "of {limit}": "{limit}-ன் பின்னர்",
    "workspace.usage.no_cap": "கூடுதல் வரம்பு அமைக்கப்படவில்லை",
    "No cap configured": "கூடுதல் வரம்பு அமைக்கப்படவில்லை",
    "workspace.usage.trend": "பயன்பாட்டு போக்கு",
    "Usage trend": "பயன்பாட்டு போக்கு",
    "workspace.usage.unavailable": "பயன்பாட்டு தகவல்கள் தற்காலிகமாக கிடைக்கவில்லை.",
    "Usage data is temporarily unavailable.": "பயன்பாட்டு தகவல்கள் தற்காலிகமாக கிடைக்கவில்லை.",
    "workspace.usage.loading": "வேலை இடத்தின் பயன்பாட்டை ஏற்றுகிறது…",
    "Loading workspace usage…": "வேலை இடத்தின் பயன்பாட்டை ஏற்றுகிறது…",
    "workspace.usage.overview": "வேலை இட சுருக்கம்",
    "Workspace overview": "வேலை இட சுருக்கம்",
    "workspace.usage.title": "பயன்பாட்டு விவரம்",
    "Usage breakdown": "பயன்பாட்டு விவரம்",
    "workspace.usage.description": "உங்கள் வேலை இடத்தின் பயன்பாட்டையும், தற்போதைய திட்டத்தில் மீதமுள்ள இடத்தையும் பார்க்கவும்.",
    "See what your workspace has used and how much room remains on your current plan.": "உங்கள் வேலை இடத்தின் பயன்பாட்டையும், தற்போதைய திட்டத்தில் மீதமுள்ள இடத்தையும் பார்க்கவும்.",
    "workspace.usage.view_plans": "திட்டங்களைப் பார்க்கவும்",
    "workspace.usage.showing_available_limits": "இந்த வேலை இடத்தில் ஏற்கனவே கிடைக்கும் வரம்புகளைக் காட்டுகிறது.",
    "Showing the limits that are already available in this workspace.": "இந்த வேலை இடத்தில் ஏற்கனவே கிடைக்கும் வரம்புகளைக் காட்டுகிறது.",
    "workspace.usage.summary": "பயன்பாட்டு சுருக்கம்",
    "Usage summary": "பயன்பாட்டு சுருக்கம்",
    "workspace.usage.metrics_tracked": "அளவுகோல்கள் பின்பற்றப்பட்டுள்ளன",
    "Metrics tracked": "அளவுகோல்கள் பின்பற்றப்பட்டுள்ளன",
    "workspace.usage.metrics_count": "{count} முதல் {total}",
    "{count} of {total}": "{count} முதல் {total}",
    "workspace.usage.next_reset": "அடுத்த மீளமைப்பு",
    "Next reset": "அடுத்த மீளமைப்பு",
    "workspace.usage.not_provided": "கொடுக்கப்படவில்லை",
    "Not provided": "கொடுக்கப்படவில்லை",
    "workspace.usage.data_source": "தரவு மூலம்",
    "Data source": "தரவு மூலம்",
    "workspace.usage.clear_view": "உங்கள் வேலை இடத்தின் தெளிவான காட்சி",
    "A clear view of your workspace": "உங்கள் வேலை இடத்தின் தெளிவான காட்சி",
    "workspace.usage.by_resource": "மூலத்தின் பயன்பாடு",
    "Usage by resource": "மூலத்தின் பயன்பாடு",
    "workspace.usage.live_summary": "ஆன்லைன் சுருக்கம்",
    "Live summary": "ஆன்லைன் சுருக்கம்",
    "workspace.usage.resource": "உள்ளீடு",
    "workspace.usage.used_limit": "பயன்படுத்தப்பட்டது / கூடுதல்",
    "Used / limit": "பயன்படுத்தப்பட்டது / கூடுதல்",
    "workspace.usage.progress": "முன்னேற்றம்",
    "Progress": "முன்னேற்றம்",
    "workspace.usage.cost": "செலவு",
    "Cost": "செலவு",
    "workspace.usage.footnote": "பயன்பாடு மற்றும் வரம்புகள் வேலையிட பயன்பாட்டு சேவையிலிருந்து வருகின்றன. குறியீடு என்பது தற்போதைய API மூலம் அந்த அளவீடு அறிவிக்கப்படவில்லை என்று குறிப்பிடுகிறது.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "பயன்பாடு மற்றும் வரம்புகள் வேலையிட பயன்பாட்டு சேவையிலிருந்து வருகின்றன. குறியீடு என்பது தற்போதைய API மூலம் அந்த அளவீடு அறிவிக்கப்படவில்லை என்று குறிப்பிடுகிறது.",
    "workspace.usage.refresh": "புதுப்பிக்கவும்",
    "maps.title": "மேப்புகள்",
    "maps.tab.analysis": "சந்தை தேடல்",
    "Market scan": "சந்தை தேடல்",
    "maps.tab.usage": "பயன்பாடு",
    "maps.tab.settings": "அமைப்புகள்",
    "maps.action.save": "சேமி",
    "maps.action.saving": "சேமித்துக் கொண்டிருக்கிறேன்…",
    "maps.action.analyze_area": "பகுதியை பகுப்பாய்வு செய்யவும்",
    "Analyze area": "பகுதியை பகுப்பாய்வு செய்யவும்",
    "maps.action.analyzing": "பகுப்பாய்வு செய்து கொண்டிருக்கிறேன்…",
    "Analyzing…": "பகுப்பாய்வு செய்து கொண்டிருக்கிறேன்…",
    "maps.action.refresh": "புதுப்பிக்கவும்",
    "maps.action.loading": "பதிவிறக்கம்…",
    "maps.action.open_in_maps": "மேப்புகளில் திறக்கவும்",
    "Open in Maps": "மேப்புகளில் திறக்கவும்",
    "maps.analysis.title": "உள்ளூர் சந்தையை ஆராயவும்",
    "Explore a local market": "உள்ளூர் சந்தையை ஆராயவும்",
    "maps.analysis.description": "Proposed location இல் Google பட்டியலிடும் வணிகங்களைப் பார்க்கவும். இது ஒரு தொடக்க போட்டி தேடல், தேவை அல்லது சாத்தியமான முன்னேற்றம் அல்ல.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Proposed location இல் Google பட்டியலிடும் வணிகங்களைப் பார்க்கவும். இது ஒரு தொடக்க போட்டி தேடல், தேவை அல்லது சாத்தியமான முன்னேற்றம் அல்ல.",
    "maps.analysis.address_label": "தொகுதி அல்லது பகுதி",
    "Address or locality": "தொகுதி அல்லது பகுதி",
    "maps.analysis.address_placeholder": " đường, பகுதி அல்லது நகரம்",
    "Street, suburb, or city": " đường, பகுதி அல்லது நகரம்",
    "maps.analysis.category_label": "வணிக வகை",
    "Business type": "வணிக வகை",
    "maps.analysis.radius_label": "தேடல் ஆரம்",
    "Search radius": "தேடல் ஆரம்",
    "maps.analysis.places_listings": "இடங்கள் பட்டியல்",
    "Places listings": "இடங்கள் பட்டியல்",
    "maps.analysis.within_radius": "{category} {radius} க்குள்",
    "{category} within {radius}": "{category} {radius} க்குள்",
    "maps.analysis.results_description": "விருப்பத்திற்கு மற்றும் ஆரம் அடிப்படையில் முடிவுகள் தேர்வு செய்யப்பட்டு, தூரத்தின் அடிப்படையில் வரிசைப்படுத்தப்பட்டுள்ளன.",
    "Results are filtered by category and radius, then ordered by distance.": "விருப்பத்திற்கு மற்றும் ஆரம் அடிப்படையில் முடிவுகள் தேர்வு செய்யப்பட்டு, தூரத்தின் அடிப்படையில் வரிசைப்படுத்தப்பட்டுள்ளன.",
    "maps.analysis.result_limit_notice": "Google-ஆல் 20 இடங்கள் அதிகபட்சமாக திரும்பப் பெறப்பட்டன. உண்மையான எண்ணிக்கை அதிகமாக இருக்கலாம்; விரிவான தேடலுக்கு சிறிய ஆரம் பயன்படுத்தவும்.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google-ஆல் 20 இடங்கள் அதிகபட்சமாக திரும்பப் பெறப்பட்டன. உண்மையான எண்ணிக்கை அதிகமாக இருக்கலாம்; விரிவான தேடலுக்கு சிறிய ஆரம் பயன்படுத்தவும்.",
    "maps.analysis.limitations": "பட்டியலிடப்பட்டவை முழுமையற்றதாக இருக்கலாம், மேலும் வாடிக்கையாளர் தேவை, மக்கள் ஓட்டம், மக்கள் தொகை, வாடகை அல்லது லாபம் அளவிடப்படவில்லை. இதை உள்ளூர் ஆராய்ச்சியில் ஒரு உள்ளீடாக பயன்படுத்தவும்.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "பட்டியலிடப்பட்டவை முழுமையற்றதாக இருக்கலாம், மேலும் வாடிக்கையாளர் தேவை, மக்கள் ஓட்டம், மக்கள் தொகை, வாடகை அல்லது லாபம் அளவிடப்படவில்லை. இதை உள்ளூர் ஆராய்ச்சியில் ஒரு உள்ளீடாக பயன்படுத்தவும்.",
    "maps.analysis.nearby_businesses": "அருகிலுள்ள வணிகங்கள் ({count})",
    "Nearby businesses ({count})": "அருகிலுள்ள வணிகங்கள் ({count})",
    "maps.analysis.businesses": "வணிகங்கள்",
    "Businesses": "வணிகங்கள்",
    "maps.analysis.no_listings": "இந்த பகுதி மற்றும் வகையிற்கு Google Maps பட்டியல்கள் கிடைக்கவில்லை.",
    "No matching Google Maps listings were returned for this area and category.": "இந்த பகுதி மற்றும் வகையிற்கு Google Maps பட்டியல்கள் கிடைக்கவில்லை.",
    "maps.category.retail": "விற்பனை வணிகம்",
    "Retail": "விற்பனை வணிகம்",
    "maps.category.grocery": "கூட்டு உணவு",
    "Grocery": "கூட்டு உணவு",
    "maps.category.clothing": "உடைகள்",
    "Clothing": "உடைகள்",
    "maps.category.pharmacy": "மருந்து கடை",
    "Pharmacy": "மருந்து கடை",
    "maps.category.restaurant": "தேநீர் கடை / உணவகம்",
    "Restaurant / café": "தேநீர் கடை / உணவகம்",
    "maps.competition.limited": "குறைந்த போட்டியாளர்கள்",
    "Limited listed competition": "குறைந்த போட்டியாளர்கள்",
    "maps.competition.some": "பட்டியலிடப்பட்ட சில போட்டியாளர்கள்",
    "Some listed competition": "பட்டியலிடப்பட்ட சில போட்டியாளர்கள்",
    "maps.competition.many": "பட்டியலிடப்பட்ட அதிக போட்டியாளர்கள்",
    "Many listed competitors": "பட்டியலிடப்பட்ட அதிக போட்டியாளர்கள்",
    "maps.competition.limit_reached": "குறைந்தது 20 பட்டியல்கள் (வரம்பு அடைந்தது)",
    "At least 20 listings (result limit reached)": "குறைந்தது 20 பட்டியல்கள் (வரம்பு அடைந்தது)",
    "maps.competition.default": "பட்டியலிடப்பட்ட போட்டியாளர்கள்",
    "Listed competition": "பட்டியலிடப்பட்ட போட்டியாளர்கள்",
    "maps.distance_km": "{value} கிலோமீட்டர்",
    "{value} km": "{value} கிலோமீட்டர்",
    "maps.distance_m": "{value} மீட்டர்",
    "{value} m": "{value} மீட்டர்",
    "maps.business_status.operational": "செயல்பாட்டில்",
    "Operational": "செயல்பாட்டில்",
    "maps.usage.title": "வழங்குநர் பயன்பாடு",
    "Provider usage": "வழங்குநர் பயன்பாடு",
    "maps.usage.description": "Maps சேவையால் பதிவு செய்யப்பட்ட கோரிக்கைகளின் எண்ணிக்கை. கட்டணங்கள் தனித்தனியே தொகுக்கப்படுகின்றன.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Maps சேவையால் பதிவு செய்யப்பட்ட கோரிக்கைகளின் எண்ணிக்கை. கட்டணங்கள் தனித்தனியே தொகுக்கப்படுகின்றன.",
    "maps.usage.days": "{count} நாட்கள்",
    "{count} days": "{count} நாட்கள்",
    "maps.usage.provider_requests": "வழங்குநர் கோரிக்கைகள்",
    "Provider requests": "வழங்குநர் கோரிக்கைகள்",
    "maps.usage.range_detail": "{count} நாள் சாவிக்காலம்",
    "{count} day window": "{count} நாள் சாவிக்காலம்",
    "maps.usage.successful": "வெற்றி",
    "maps.usage.completed_calls": "முடிவுற்ற வழங்குநர் கோரிக்கைகள்",
    "Completed provider calls": "முடிவுற்ற வழங்குநர் கோரிக்கைகள்",
    "maps.usage.errors": "பிழைகள்",
    "Errors": "பிழைகள்",
    "maps.usage.failed_calls": "தோல்வியடைந்த வழங்குநர் கோரிக்கைகள்",
    "Failed provider calls": "தோல்வியடைந்த வழங்குநர் கோரிக்கைகள்",
    "maps.usage.metered_units": "அளவுகோல் அலகுகள்",
    "Metered units": "அளவுகோல் அலகுகள்",
    "maps.usage.unit_detail": "பதிவு செய்யப்பட்ட கோரிக்கைக்கு ஒரு அலகு",
    "One unit per recorded request": "பதிவு செய்யப்பட்ட கோரிக்கைக்கு ஒரு அலகு",
    "maps.usage.by_operation": "ஆபரேஷன் பூர்த்தி அளவு",
    "Usage by operation": "ஆபரேஷன் பூர்த்தி அளவு",
    "maps.usage.group_description": "கணக்கெடுப்புகள் வழங்குநர், செயல்முறை மற்றும் முடிவின் அடிப்படையில் குழுக்களாக பிரிக்கப்படுகின்றன.",
    "Counts are grouped by provider, operation, and outcome.": "கணக்கெடுப்புகள் வழங்குநர், செயல்முறை மற்றும் முடிவின் அடிப்படையில் குழுக்களாக பிரிக்கப்படுகின்றன.",
    "maps.usage.empty": "இந்த தேதி வரம்பில் வரைபட கோரிக்கைகள் இல்லை.",
    "No map requests in this date range.": "இந்த தேதி வரம்பில் வரைபட கோரிக்கைகள் இல்லை.",
    "maps.usage.provider": "வழங்குநர்",
    "Provider": "வழங்குநர்",
    "maps.usage.operation": "செயல்முறை",
    "Operation": "செயல்முறை",
    "maps.usage.outcome": "முடிவு",
    "Outcome": "முடிவு",
    "maps.usage.requests": "கோரிக்கைகள்",
    "Requests": "கோரிக்கைகள்",
    "maps.usage.units": "அலகுகள்",
    "Units": "அலகுகள்",
    "maps.settings.provider_title": "வரைபட வழங்குநர்",
    "Map provider": "வரைபட வழங்குநர்",
    "maps.settings.provider_description": "உங்கள் தரவு தனியுரிமை கொள்கைக்கு ஏற்ப அனுமதிக்கப்பட்ட வழங்குநரைத் தேர்வு செய்யவும். வழங்குநர் குறிப்புகள் Tradly மூலம் மேலாண்மை செய்யப்படுகின்றன.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "உங்கள் தரவு தனியுரிமை கொள்கைக்கு ஏற்ப அனுமதிக்கப்பட்ட வழங்குநரைத் தேர்வு செய்யவும். வழங்குநர் குறிப்புகள் Tradly மூலம் மேலாண்மை செய்யப்படுகின்றன.",
    "maps.settings.selected": "தேர்ந்தெடுக்கப்பட்டது",
    "maps.settings.available": "கிடைக்கும்",
    "maps.settings.planned": "திட்டமிடப்பட்டது",
    "Planned": "திட்டமிடப்பட்டது",
    "maps.settings.origins_title": "அனுமதிக்கப்பட்ட வலைத்தள மூலங்கள்",
    "Allowed website origins": "அனுமதிக்கப்பட்ட வலைத்தள மூலங்கள்",
    "maps.settings.origins_description": "குறிப்பிட்ட டெண்ட் டொமைன்கள் தானாகவே அனுமதிக்கப்படுகின்றன. ஸ்டேஜிங் போன்ற பிற தளங்களுக்கு துல்லியமான மூலங்களை இங்கே சேர்க்கவும்.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "குறிப்பிட்ட டெண்ட் டொமைன்கள் தானாகவே அனுமதிக்கப்படுகின்றன. ஸ்டேஜிங் போன்ற பிற தளங்களுக்கு துல்லியமான மூலங்களை இங்கே சேர்க்கவும்.",
    "maps.settings.registered_domains": "பதிவு செய்யப்பட்ட டொமைன்கள்",
    "Registered domains": "பதிவு செய்யப்பட்ட டொமைன்கள்",
    "maps.settings.no_domains": "பதிவு செய்யப்பட்ட டொமைன்கள் ஏதும் ஏற்றப்படவில்லை.",
    "No registered domains were loaded.": "பதிவு செய்யப்பட்ட டொமைன்கள் ஏதும் ஏற்றப்படவில்லை.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "மூலம் சேர்க்கவும்",
    "Add origin": "மூலம் சேர்க்கவும்",
    "maps.settings.remove_origin": "அகற்று",
    "maps.settings.no_origins": "கூடுதல் மூலங்கள் சேர்க்கப்படவில்லை.",
    "No extra origins added.": "கூடுதல் மூலங்கள் சேர்க்கப்படவில்லை.",
    "maps.error.session_not_ready": "உங்கள் நிர்வாக அமர்வு இன்னும் தயாராக இல்லை.",
    "Your admin session is not ready yet.": "உங்கள் நிர்வாக அமர்வு இன்னும் தயாராக இல்லை.",
    "maps.error.load_data": "மேப்ஸ் தரவுகளை ஏற்ற முடியவில்லை ({status}).",
    "Unable to load Maps data ({status}).": "மேப்ஸ் தரவுகளை ஏற்ற முடியவில்லை ({status}).",
    "maps.error.load_usage": "மேப்ஸ் பயன்பாட்டை ஏற்ற முடியவில்லை.",
    "Unable to load Maps usage.": "மேப்ஸ் பயன்பாட்டை ஏற்ற முடியவில்லை.",
    "maps.error.load_settings": "மேப்ஸ் அமைப்புகளை ஏற்ற முடியவில்லை.",
    "Unable to load Maps settings.": "மேப்ஸ் அமைப்புகளை ஏற்ற முடியவில்லை.",
    "maps.error.save_settings": "மேப்ஸ் அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Unable to save Maps settings.": "மேப்ஸ் அமைப்புகளை சேமிக்க முடியவில்லை.",
    "maps.error.invalid_origin": "முழுமையான மூலத்தை உள்ளிடவும், உதாரணமாக https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "முழுமையான மூலத்தை உள்ளிடவும், உதாரணமாக https://staging.example.com.",
    "maps.error.registered_origin": "இந்த மூலம் ஏற்கனவே பதிவு செய்யப்பட்ட டொமைனால் பெரும்பாலும் பெறப்பட்டுள்ளது.",
    "This origin is already covered by a registered domain.": "இந்த மூலம் ஏற்கனவே பதிவு செய்யப்பட்ட டொமைனால் பெரும்பாலும் பெறப்பட்டுள்ளது.",
    "maps.error.address_required": "ஸ்கேன் செய்ய ஒரு முகவரி அல்லது பகுதியை உள்ளிடவும்.",
    "Enter an address or locality to scan.": "ஸ்கேன் செய்ய ஒரு முகவரி அல்லது பகுதியை உள்ளிடவும்.",
    "maps.error.location_not_found": "அந்த இடத்தைக் கண்டறிய முடியவில்லை.",
    "Unable to find that location.": "அந்த இடத்தைக் கண்டறிய முடியவில்லை.",
    "maps.error.no_coordinates": "அந்த முகவரிக்கு ஆயத்திரம் கிடைக்கவில்லை. அருகிலுள்ள தெரு, பகுதி அல்லது நகரத்தை முயற்சிக்கவும்.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "அந்த முகவரிக்கு ஆயத்திரம் கிடைக்கவில்லை. அருகிலுள்ள தெரு, பகுதி அல்லது நகரத்தை முயற்சிக்கவும்.",
    "maps.error.analyze_area": "இந்த பகுதியை பகுப்பாய்வு செய்ய முடியவில்லை.",
    "Unable to analyze this area.": "இந்த பகுதியை பகுப்பாய்வு செய்ய முடியவில்லை.",
    "maps.notice.settings_saved": "மேப்ஸ் அமைப்புகள் சேமிக்கப்பட்டன.",
    "Maps settings saved.": "மேப்ஸ் அமைப்புகள் சேமிக்கப்பட்டன.",
    "maps.status.success": "வெற்றி",
    "maps.status.error": "பிழை",
    "maps.operation.geocode": "ஜியோகோடிங்",
    "Geocode": "ஜியோகோடிங்",
    "maps.operation.maps_geocode": "மேப்ஸ் ஜியோகோடிங்",
    "Maps geocode": "மேப்ஸ் ஜியோகோடிங்",
    "maps.operation.market_analysis": "சந்தை பகுப்பாய்வு",
    "Market analysis": "சந்தை பகுப்பாய்வு",
    "maps.operation.maps_market_analysis": "மேப்ஸ் சந்தை பகுப்பாய்வு",
    "Maps market analysis": "மேப்ஸ் சந்தை பகுப்பாய்வு",
    "maps.operation.places_search": "இடங்களைத் தேடுதல்",
    "Places search": "இடங்களைத் தேடுதல்",
    "maps.operation.places_nearby": "அருகிலுள்ள இடங்கள்",
    "Nearby places": "அருகிலுள்ள இடங்கள்",
    "maps.operation.place_details": "இடத்தின் விவரங்கள்",
    "Place details": "இடத்தின் விவரங்கள்",
    "common.loading": "இயக்கும்…",
    "common.saving": "சேமித்துக் கொள்ளும்…",
    "common.searching": "தேடும்…",
    "Searching…": "தேடும்…",
    "common.no_matches": "பொருத்தமான பதில் கிடைக்கவில்லை.",
    "No matches found.": "பொருத்தமான பதில் கிடைக்கவில்லை.",
    "common.select": "தேர்வு செய்யவும்…",
    "Select…": "தேர்வு செய்யவும்…",
    "common.search_users": "பெயர் அல்லது மின்னஞ்சல் மூலம் பயனர்களைத் தேடவும்",
    "Search users by name or email": "பெயர் அல்லது மின்னஞ்சல் மூலம் பயனர்களைத் தேடவும்",
    "common.reset": "மீளமைப்பு",
    "Reset": "மீளமைப்பு",
    "common.validation.email": "செல்லுபடியாகும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "Enter a valid email address.": "செல்லுபடியாகும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "common.validation.phone": "செல்லுபடியாகும் தொலைபேசி எண்ணை உள்ளிடவும்.",
    "Enter a valid phone number.": "செல்லுபடியாகும் தொலைபேசி எண்ணை உள்ளிடவும்.",
    "common.validation.currency": "USD போன்ற 3 எழுத்துகள் கொண்ட நாணய குறியீட்டைப் பயன்படுத்தவும்.",
    "Use a 3-letter currency code, such as USD.": "USD போன்ற 3 எழுத்துகள் கொண்ட நாணய குறியீட்டைப் பயன்படுத்தவும்.",
    "common.validation.location": "செல்லுபடியான முகவரி அல்லது இடம் உள்ளிடவும்.",
    "Enter a valid address or location.": "செல்லுபடியான முகவரி அல்லது இடம் உள்ளிடவும்.",
    "common.validation.required": "{label} அவசியம்.",
    "{label} is required.": "{label} அவசியம்.",
    "common.validation.invalid": "{label} செல்லுபடியானது அல்ல.",
    "{label} is invalid.": "{label} செல்லுபடியானது அல்ல.",
    "common.status.active": "செயல்பாட்டில்",
    "common.status.inactive": "இயக்கமற்ற",
    "common.status.open": "திறந்த",
    "common.status.closed": "மூடப்பட்ட",
    "common.status.posted": "பதிவேற்றப்பட்ட",
    "Posted": "பதிவேற்றப்பட்ட",
    "common.status.voided": "ரத்து செய்யப்பட்ட",
    "Voided": "ரத்து செய்யப்பட்ட",
    "common.status.draft": "முன்னோட்டம்",
    "common.status.success": "வெற்றி",
    "common.status.error": "பிழை",
    "accounting.title": "கணக்குகள்",
    "accounting.description": "கணக்குகளை, மேப்பிங்குகளை, காலக்கெடுகளை, ஜர்னல்களை மற்றும் நிதியியல் அறிக்கைகளை மேனேஜ் செய்யவும்.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "கணக்குகளை, மேப்பிங்குகளை, காலக்கெடுகளை, ஜர்னல்களை மற்றும் நிதியியல் அறிக்கைகளை மேனேஜ் செய்யவும்.",
    "accounting.tab.overview": "மொத்த பார்வை",
    "accounting.tab.accounts": "கணக்கு நூல்",
    "Chart of accounts": "கணக்கு நூல்",
    "accounting.tab.mappings": "கணக்கு மேப்பிங்குகள்",
    "Account mappings": "கணக்கு மேப்பிங்குகள்",
    "accounting.tab.periods": "கணக்கு காலக்கெடுகள்",
    "Accounting periods": "கணக்கு காலக்கெடுகள்",
    "accounting.tab.journals": "ஜர்னல்கள்",
    "accounting.tab.reports": "அறிக்கைகள்",
    "accounting.account.edit_title": "கணக்கை தொகுத்தல்",
    "Edit account": "கணக்கை தொகுத்தல்",
    "accounting.account.new_title": "புதிய கணக்கு",
    "New account": "புதிய கணக்கு",
    "accounting.account.save": "கணக்கை சேமிக்கவும்",
    "Save account": "கணக்கை சேமிக்கவும்",
    "accounting.account.create": "கணக்கை உருவாக்குதல்",
    "Create account": "கணக்கை உருவாக்குதல்",
    "accounting.account.code": "கணக்கு குறியீடு",
    "Account code": "கணக்கு குறியீடு",
    "accounting.account.name": "கணக்கு பெயர்",
    "Account name": "கணக்கு பெயர்",
    "accounting.account.type": "கணக்கு வகை",
    "Account type": "கணக்கு வகை",
    "accounting.account.currency_id": "முதலீட்டு ஐடி",
    "accounting.account.active": "நிலையான செயல்பாடு",
    "accounting.account.unnamed": "பெயரில்லா கணக்கு",
    "Unnamed account": "பெயரில்லா கணக்கு",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "கூட்டு செலவு",
    "Payroll expense": "கூட்டு செலவு",
    "accounting.type.asset": "ஆபத்து",
    "Asset": "ஆபத்து",
    "accounting.type.liability": "பாஸிவ்",
    "Liability": "பாஸிவ்",
    "accounting.type.equity": "சொத்து",
    "Equity": "சொத்து",
    "accounting.type.revenue": "வருமானம்",
    "accounting.type.expense": "செலவு",
    "Expense": "செலவு",
    "accounting.toast.account_updated": "கணக்கு புதுப்பிக்கப்பட்டது",
    "Account updated": "கணக்கு புதுப்பிக்கப்பட்டது",
    "accounting.toast.account_created": "கணக்கு உருவாக்கப்பட்டது",
    "Account created": "கணக்கு உருவாக்கப்பட்டது",
    "accounting.toast.defaults_created": "இயல்புநிலை கணக்குகள் உருவாக்கப்பட்டன",
    "Default accounts created": "இயல்புநிலை கணக்குகள் உருவாக்கப்பட்டன",
    "accounting.toast.mapping_saved": "மேப்பிங் சேமிக்கப்பட்டது",
    "Mapping saved": "மேப்பிங் சேமிக்கப்பட்டது",
    "accounting.toast.period_closed": "கணக்கியல் காலக்கெடு மூடப்பட்டது",
    "Accounting period closed": "கணக்கியல் காலக்கெடு மூடப்பட்டது",
    "accounting.toast.period_created": "காலக்கெடு உருவாக்கப்பட்டது",
    "Period created": "காலக்கெடு உருவாக்கப்பட்டது",
    "accounting.toast.journal_created": "ஆவணம் உருவாக்கப்பட்டது",
    "Journal created": "ஆவணம் உருவாக்கப்பட்டது",
    "accounting.toast.journal_voided": "ஆவணம் ரத்து செய்யப்பட்டது",
    "Journal voided": "ஆவணம் ரத்து செய்யப்பட்டது",
    "accounting.validation.journal_balanced": "ஆவணத்திற்கு தேதி, விவரம் மற்றும் சமப்படுத்தப்பட்ட கடன் மற்றும் கிடைப்பு மொத்தம் இருக்க வேண்டும்.",
    "Journal must have a date, description, and balanced debit and credit totals.": "ஆவணத்திற்கு தேதி, விவரம் மற்றும் சமப்படுத்தப்பட்ட கடன் மற்றும் கிடைப்பு மொத்தம் இருக்க வேண்டும்.",
    "accounting.filter.all_types": "எல்லா கணக்கு வகைகளும்",
    "All account types": "எல்லா கணக்கு வகைகளும்",
    "accounting.filter.all_statuses": "எல்லா நிலைகளும்",
    "All statuses": "எல்லா நிலைகளும்",
    "accounting.action.bootstrap": "இயல்புநிலைகளை அமைக்கவும்",
    "Bootstrap defaults": "இயல்புநிலைகளை அமைக்கவும்",
    "accounting.action.new_account": "புதிய கணக்கு",
    "accounting.empty.accounts": "கணக்குகள் கிடைக்கவில்லை.",
    "No accounts found.": "கணக்குகள் கிடைக்கவில்லை.",
    "accounting.column.code": "குறியீடு",
    "Code": "குறியீடு",
    "accounting.column.account": "கணக்கு",
    "accounting.column.type": "வகை",
    "Type": "வகை",
    "accounting.column.currency": "நாணயம்",
    "accounting.column.status": "நிலை",
    "accounting.action.edit": "தொகுத்தல்",
    "accounting.mapping.edit_title": "கணக்கு மேப்பிங்கை தொகுத்தல்",
    "Edit account mapping": "கணக்கு மேப்பிங்கை தொகுத்தல்",
    "accounting.mapping.new_title": "புதிய கணக்கு மேப்பிங்",
    "New account mapping": "புதிய கணக்கு மேப்பிங்",
    "accounting.mapping.save": "மேப்பிங்கை சேமி",
    "Save mapping": "மேப்பிங்கை சேமி",
    "accounting.mapping.create": "மேப்பிங்கை உருவாக்குங்கள்",
    "Create mapping": "மேப்பிங்கை உருவாக்குங்கள்",
    "accounting.mapping.source_type": "மூலம் வகை",
    "accounting.mapping.event_key": "ஈவெண்ட் கீ",
    "Event key": "ஈவெண்ட் கீ",
    "accounting.mapping.debit_account": "டிபிட் கணக்கு",
    "Debit account": "டிபிட் கணக்கு",
    "accounting.mapping.credit_account": "கிரெடிட் கணக்கு",
    "Credit account": "கிரெடிட் கணக்கு",
    "accounting.mapping.tax_account": "வரி கணக்கு",
    "Tax account": "வரி கணக்கு",
    "accounting.mapping.none": "எதுவுமில்லை",
    "accounting.mapping.source_placeholder": "ஆர்டர்",
    "order": "ஆர்டர்",
    "accounting.mapping.event_placeholder": "பேமெண்ட் கேப்சர்ட்",
    "payment_captured": "பேமெண்ட் கேப்சர்ட்",
    "accounting.mapping.filter_placeholder": "மூல வகையை தேர்வு செய்க",
    "Filter source type": "மூல வகையை தேர்வு செய்க",
    "accounting.action.new_mapping": "புதிய மேப்பிங்",
    "New mapping": "புதிய மேப்பிங்",
    "accounting.empty.mappings": "கணக்கு மேப்பிங்குகள் கிடைக்கவில்லை.",
    "No account mappings found.": "கணக்கு மேப்பிங்குகள் கிடைக்கவில்லை.",
    "accounting.column.source": "மூலம்",
    "Source": "மூலம்",
    "accounting.column.event": "ஈவெண்ட்",
    "accounting.column.debit": "டிபிட்",
    "Debit": "டிபிட்",
    "accounting.column.credit": "கிரெடிட்",
    "Credit": "கிரெடிட்",
    "accounting.period.close_confirm": "{period}-ஐ மூடுவது? இதை மாற்ற முடியாது.",
    "Close {period}? This cannot be reversed.": "{period}-ஐ மூடுவது? இதை மாற்ற முடியாது.",
    "accounting.period.this": "இந்த கணக்கு காலம்",
    "this accounting period": "இந்த கணக்கு காலம்",
    "accounting.period.new_title": "புதிய கணக்கு காலம்",
    "New accounting period": "புதிய கணக்கு காலம்",
    "accounting.period.create": "காலம் உருவாக்கு",
    "Create period": "காலம் உருவாக்கு",
    "accounting.period.name": "கால பெயர்",
    "Period name": "கால பெயர்",
    "accounting.period.start": "தொடக்க தேதி",
    "accounting.period.end": "முடிவு தேதி",
    "End date": "முடிவு தேதி",
    "accounting.period.name_placeholder": "ஜனவரி 2027",
    "January 2027": "ஜனவரி 2027",
    "accounting.period.open": "திறக்க",
    "accounting.period.closed": "மூடப்பட்டது",
    "accounting.action.new_period": "புதிய காலகட்டம்",
    "New period": "புதிய காலகட்டம்",
    "accounting.empty.periods": "கணக்கியல் காலகட்டங்கள் கிடைக்கவில்லை.",
    "No accounting periods found.": "கணக்கியல் காலகட்டங்கள் கிடைக்கவில்லை.",
    "accounting.column.period": "காலகட்டம்",
    "accounting.column.start": "தொடக்கம்",
    "Start": "தொடக்கம்",
    "accounting.column.end": "முடிவு",
    "End": "முடிவு",
    "accounting.action.close_period": "காலகட்டத்தை மூடு",
    "Close period": "காலகட்டத்தை மூடு",
    "accounting.journal.new_title": "புதிய பதிவேடு",
    "New journal": "புதிய பதிவேடு",
    "accounting.journal.balance_help": "முன்னேற்றம் மற்றும் கடன் சமன் செய்யப்பட வேண்டும், பின்னர் சேமிக்கவும்.",
    "Debits and credits must balance before saving.": "முன்னேற்றம் மற்றும் கடன் சமன் செய்யப்பட வேண்டும், பின்னர் சேமிக்கவும்.",
    "accounting.journal.close": "மூடு",
    "accounting.journal.entry_date": "உள்ளீட்டு தேதி",
    "Entry date": "உள்ளீட்டு தேதி",
    "accounting.journal.description": "விவரம்",
    "accounting.journal.source_type": "மூல வகை",
    "accounting.journal.source_id": "மூல ID",
    "Source ID": "மூல ID",
    "accounting.journal.account": "கணக்கு",
    "accounting.journal.select_account": "கணக்கைத் தேர்வுசெய்க",
    "Select account": "கணக்கைத் தேர்வுசெய்க",
    "accounting.journal.debit_total": "முன்னேற்றம்: {debit} · கடன்: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "முன்னேற்றம்: {debit} · கடன்: {credit} · {status}",
    "accounting.journal.balanced": "சமன்",
    "Balanced": "சமன்",
    "accounting.journal.unbalanced": "சமன் இல்லாத",
    "Unbalanced": "சமன் இல்லாத",
    "accounting.journal.add_line": "வரி சேர்க்க",
    "Add line": "வரி சேர்க்க",
    "accounting.journal.save": "பதிவேட்டை சேமி",
    "Save journal": "பதிவேட்டை சேமி",
    "accounting.journal.empty": "பதிவேடு வரிகள் கிடைக்கவில்லை.",
    "accounting.journal.reason_prompt": "இந்த பதிவேட்டை ரத்து செய்ய காரணம்:",
    "Reason for voiding this journal:": "இந்த பதிவேட்டை ரத்து செய்ய காரணம்:",
    "accounting.journal.details_title": "பதிவேடு #{id}",
    "Journal #{id}": "பதிவேடு #{id}",
    "accounting.action.view": "பார்க்க",
    "View": "பார்க்க",
    "accounting.action.void": "தொடர்புகொள்ள",
    "Void": "தொடர்புகொள்ள",
    "accounting.filter.all_accounts": "எல்லா கணக்குகளும்",
    "All accounts": "எல்லா கணக்குகளும்",
    "accounting.empty.journals": "எந்த பதிவுகளும் கிடைக்கவில்லை.",
    "No journals found.": "எந்த பதிவுகளும் கிடைக்கவில்லை.",
    "accounting.column.date": "தேதி",
    "accounting.column.description": "விளக்கம்",
    "accounting.column.account_source": "மூலம்",
    "accounting.empty.journal_lines": "பதிவு வரிகள் இல்லை.",
    "accounting.report.trial_balance": "சோதனை பேலன்ஸ்",
    "Trial balance": "சோதனை பேலன்ஸ்",
    "accounting.report.general_ledger": "பொது புத்தகம்",
    "General ledger": "பொது புத்தகம்",
    "accounting.action.run_report": "அறிக்கையை இயக்கு",
    "Run report": "அறிக்கையை இயக்கு",
    "accounting.report.loading": "அறிக்கை ஏற்றப்படுகிறது…",
    "Loading report…": "அறிக்கை ஏற்றப்படுகிறது…",
    "accounting.empty.report": "அறிக்கை வரிகள் கிடைக்கவில்லை.",
    "No report rows found.": "அறிக்கை வரிகள் கிடைக்கவில்லை.",
    "accounting.report.choose_run": "ஒரு அறிக்கையைத் தேர்வு செய்து இயக்கவும்.",
    "Choose a report and run it.": "ஒரு அறிக்கையைத் தேர்வு செய்து இயக்கவும்.",
    "accounting.column.balance": "செலவு",
    "Balance": "செலவு",
    "accounting.overview.chart_title": "கணக்கு நூல்",
    "accounting.overview.chart_description": "உங்கள் புத்தகத்தில் பயன்படுத்தப்படும் கணக்குகளை அமைக்கவும்.",
    "Define the accounts used by your ledger.": "உங்கள் புத்தகத்தில் பயன்படுத்தப்படும் கணக்குகளை அமைக்கவும்.",
    "accounting.overview.journals_title": "பதிவுகள்",
    "accounting.overview.journals_description": "சமநிலையான பதிவு குறிப்புகளை உருவாக்கி மதிப்பீடு செய்யவும்.",
    "Create and review balanced journal entries.": "சமநிலையான பதிவு குறிப்புகளை உருவாக்கி மதிப்பீடு செய்யவும்.",
    "accounting.overview.reports_title": "அறிக்கைகள்",
    "accounting.overview.reports_description": "சோதனை பேலன்ஸ் மற்றும் பொது புத்தக அறிக்கைகளை இயக்கவும்.",
    "Run trial balance and general ledger reports.": "சோதனை பேலன்ஸ் மற்றும் பொது புத்தக அறிக்கைகளை இயக்கவும்.",
    "common.refresh": "புதுப்பிக்க",
    "reports.search.title": "பகுப்பாய்வைத் தேடு",
    "Search analytics": "பகுப்பாய்வைத் தேடு",
    "reports.search.back_to_report": "அறிக்கைக்கு திரும்புக",
    "Back to report": "அறிக்கைக்கு திரும்புக",
    "reports.search.description": "மக்கள் தேடும் விஷயங்களையும், உங்கள் கதாலாக்கத்திற்கு பெரும்பாலும் தேவையான பகுதிகளையும் காட்டுகிறது.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "மக்கள் தேடும் விஷயங்களையும், உங்கள் கதாலாக்கத்திற்கு பெரும்பாலும் தேவையான பகுதிகளையும் காட்டுகிறது.",
    "reports.search.metric.searches": "தேடல்கள்",
    "Searches": "தேடல்கள்",
    "reports.search.metric.unique_keywords": "தனித்துவமான சொற்கள்",
    "Unique keywords": "தனித்துவமான சொற்கள்",
    "reports.search.metric.with_listings": "பட்டியலிடப்பட்டவை",
    "With listings": "பட்டியலிடப்பட்டவை",
    "reports.search.metric.no_matches": "பட்டியலில் பொருத்தமில்லாதவை",
    "No listing matches": "பட்டியலில் பொருத்தமில்லாதவை",
    "reports.search.metric.coverage": "பெரும்பாலும் பயன்படுத்தப்படும்",
    "Coverage": "பெரும்பாலும் பயன்படுத்தப்படும்",
    "reports.search.insights.title": "நிர்வாக அறிவுரைகள்",
    "Admin insights": "நிர்வாக அறிவுரைகள்",
    "reports.search.insights.no_results_one": "{count} சொற்கள் பட்டியலிடப்படவில்லை. பட்டியலை உருவாக்குதல், சொற்றொடரை பிரிவாக அல்லது குறியீடாக சேர்த்தல், அல்லது பட்டியல் தலைப்பு மற்றும் விவரங்களை மேம்படுத்துதல் பற்றி சிந்திக்கவும்.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "{count} சொற்கள் பட்டியலிடப்படவில்லை. பட்டியலை உருவாக்குதல், சொற்றொடரை பிரிவாக அல்லது குறியீடாக சேர்த்தல், அல்லது பட்டியல் தலைப்பு மற்றும் விவரங்களை மேம்படுத்துதல் பற்றி சிந்திக்கவும்.",
    "reports.search.insights.no_results_many": "{count} சொற்கள் பட்டியலிடப்படவில்லை. பட்டியல்களை உருவாக்குதல், சொற்களை பிரிவுகளாக அல்லது குறியீடுகளாக சேர்த்தல், அல்லது பட்டியல் தலைப்புகள் மற்றும் விவரங்களை மேம்படுத்துதல் பற்றி சிந்திக்கவும்.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} சொற்கள் பட்டியலிடப்படவில்லை. பட்டியல்களை உருவாக்குதல், சொற்களை பிரிவுகளாக அல்லது குறியீடுகளாக சேர்த்தல், அல்லது பட்டியல் தலைப்புகள் மற்றும் விவரங்களை மேம்படுத்துதல் பற்றி சிந்திக்கவும்.",
    "reports.search.insights.all_covered": "தேடப்பட்ட சொற்களில் அனைத்தும் குறைந்தது ஒரு பட்டியலை திரும்பப் பெற்றன. பெரும்பாலும் பயன்படுத்தப்படும் சொற்களை மேம்படுத்த, விற்பனை மற்றும் பிரிவு அமைப்பை மேம்படுத்த மீண்டும் பார்க்கவும்.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "தேடப்பட்ட சொற்களில் அனைத்தும் குறைந்தது ஒரு பட்டியலை திரும்பப் பெற்றன. பெரும்பாலும் பயன்படுத்தப்படும் சொற்களை மேம்படுத்த, விற்பனை மற்றும் பிரிவு அமைப்பை மேம்படுத்த மீண்டும் பார்க்கவும்.",
    "reports.search.insights.empty": "மக்கள் சந்தையில் தேடல் செய்த பிறகு தேடல் தகவல்கள் காட்டப்படும்.",
    "Search data will appear after visitors search the marketplace.": "மக்கள் சந்தையில் தேடல் செய்த பிறகு தேடல் தகவல்கள் காட்டப்படும்.",
    "reports.search.insights.total_matches": "{count} மொத்த பட்டியல் பொருத்தங்கள் ஏற்றப்பட்ட தேடல் பதிவுகளில் திரும்பப் பெறப்பட்டன.",
    "{count} total listing matches were returned across the loaded search records.": "{count} மொத்த பட்டியல் பொருத்தங்கள் ஏற்றப்பட்ட தேடல் பதிவுகளில் திரும்பப் பெறப்பட்டன.",
    "reports.search.coverage_title": "சொற்கள் பெரும்பாலும் பயன்படுத்தப்படும்",
    "Keyword coverage": "சொற்கள் பெரும்பாலும் பயன்படுத்தப்படும்",
    "reports.search.loading": "தேடல் பகுப்பாய்வு ஏற்றப்படுகிறது…",
    "Loading search analytics…": "தேடல் பகுப்பாய்வு ஏற்றப்படுகிறது…",
    "reports.search.empty": "தேடல் வாக்கியங்கள் கிடைக்கவில்லை.",
    "No search phrases found.": "தேடல் வாக்கியங்கள் கிடைக்கவில்லை.",
    "reports.search.error.load": "தேடல் பகுப்பாய்வை ஏற்ற முடியவில்லை.",
    "Unable to load search analytics.": "தேடல் பகுப்பாய்வை ஏற்ற முடியவில்லை.",
    "reports.search.unknown": "அறியப்படாத தேடல்",
    "Unknown search": "அறியப்படாத தேடல்",
    "reports.search.column.keyword": "சொற்கள்",
    "Keyword": "சொற்கள்",
    "reports.search.column.listings": "பட்டியல்கள்",
    "reports.search.column.coverage": "பெரும்பாலும் பயன்படுத்தப்படும்",
    "reports.search.column.last_searched": "கடைசி தேடல்",
    "Last searched": "கடைசி தேடல்",
    "reports.search.column.suggested_action": "பரிந்துரைக்கப்பட்ட செயல்",
    "Suggested action": "பரிந்துரைக்கப்பட்ட செயல்",
    "reports.search.status.covered": "பெரும்பாலும் பயன்படுத்தப்படும்",
    "Covered": "பெரும்பாலும் பயன்படுத்தப்படும்",
    "reports.search.status.no_matches": "பொருத்தமில்லாதவை",
    "No matches": "பொருத்தமில்லாதவை",
    "reports.search.action.review_ranking": "மேம்படுத்துதல் வரிசை",
    "Review ranking": "மேம்படுத்துதல் வரிசை",
    "reports.search.action.add_listing": "பட்டியல் அல்லது வகையைச் சேர்க்கவும்",
    "Add listing or category": "பட்டியல் அல்லது வகையைச் சேர்க்கவும்",
    "platform_health.title": "தொடர்பு முறை ஆரோக்கியம்",
    "Platform health": "தொடர்பு முறை ஆரோக்கியம்",
    "platform_health.tab.health": "ஆரோக்கியம்",
    "Health": "ஆரோக்கியம்",
    "platform_health.tab.configuration": "அமைப்பு",
    "Configuration": "அமைப்பு",
    "platform_health.action.refreshing": "புதுப்பித்துக் கொண்டிருக்கிறது…",
    "Refreshing…": "புதுப்பித்துக் கொண்டிருக்கிறது…",
    "platform_health.window_note": "தற்போதைய காட்சி ஒவ்வொரு நிகழ்வு வகைக்கும் முதல் {count} பதிவுகளை ஏற்றுகிறது.",
    "The current view loads the first {count} records for each event type.": "தற்போதைய காட்சி ஒவ்வொரு நிகழ்வு வகைக்கும் முதல் {count} பதிவுகளை ஏற்றுகிறது.",
    "platform_health.error.title": "அடையாளம் காண்பிப்பு அறிக்கைகளை ஏற்ற முடியவில்லை",
    "Unable to load authentication audits": "அடையாளம் காண்பிப்பு அறிக்கைகளை ஏற்ற முடியவில்லை",
    "platform_health.error.proxy_note": "API இது ஒரு நிர்வாக கோரிக்கையை உடனடியாக தளத்திலிருந்து அனுப்பாமல், சர்வரிலிருந்து ப்ராக்ஸி மூலம் அனுப்பப்பட வேண்டும் என்று தேவைப்படுத்தலாம்.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "API இது ஒரு நிர்வாக கோரிக்கையை உடனடியாக தளத்திலிருந்து அனுப்பாமல், சர்வரிலிருந்து ப்ராக்ஸி மூலம் அனுப்பப்பட வேண்டும் என்று தேவைப்படுத்தலாம்.",
    "platform_health.error.session": "உங்கள் நிர்வாக உறுப்பினர் பதிவு இன்னும் தயாராக இல்லை. மீண்டும் பதிவு செய்யவும்.",
    "Your admin session is not ready yet. Please sign in again.": "உங்கள் நிர்வாக உறுப்பினர் பதிவு இன்னும் தயாராக இல்லை. மீண்டும் பதிவு செய்யவும்.",
    "platform_health.error.load": "அடையாளம் காண்பிப்பு அறிக்கைகளை ஏற்ற முடியவில்லை ({status}).",
    "Unable to load authentication audits ({status}).": "அடையாளம் காண்பிப்பு அறிக்கைகளை ஏற்ற முடியவில்லை ({status}).",
    "platform_health.error.load_generic": "தொடர்பு முறை ஆய்வு அறிக்கைகளை ஏற்ற முடியவில்லை.",
    "Unable to load platform health audits.": "தொடர்பு முறை ஆய்வு அறிக்கைகளை ஏற்ற முடியவில்லை.",
    "platform_health.metric.login_attempts": "முகவரி பதிவு முயற்சிகள்",
    "Login attempts": "முகவரி பதிவு முயற்சிகள்",
    "platform_health.metric.signup_attempts": "பதிவு முயற்சிகள்",
    "Signup attempts": "பதிவு முயற்சிகள்",
    "platform_health.metric.audit_records": "ஆய்வு பதிவுகள்",
    "Audit records": "ஆய்வு பதிவுகள்",
    "platform_health.metric.successful": "வெற்றிகரமானது",
    "platform_health.metric.failed": "தோல்வி",
    "platform_health.metric.outcome_returned": "முடிவு திரும்ப வழங்கப்பட்டால் மட்டும்",
    "Only when outcome is returned": "முடிவு திரும்ப வழங்கப்பட்டால் மட்டும்",
    "platform_health.metric.failure_rate": "தோல்வி விகிதம்",
    "Failure rate": "தோல்வி விகிதம்",
    "platform_health.metric.classified_records": "வகைப்படுத்தப்பட்ட பதிவுகள்",
    "Classified records": "வகைப்படுத்தப்பட்ட பதிவுகள்",
    "platform_health.activity.title": "அடையாளம் காண்பிப்பு செயல்பாடு",
    "Authentication activity": "அடையாளம் காண்பிப்பு செயல்பாடு",
    "platform_health.activity.description": "தேர்ந்தெடுக்கப்பட்ட ஆய்வு சாளரத்திலிருந்து திரும்ப வழங்கப்பட்ட முயற்சிகள்",
    "Attempts returned by the selected audit window": "தேர்ந்தெடுக்கப்பட்ட ஆய்வு சாளரத்திலிருந்து திரும்ப வழங்கப்பட்ட முயற்சிகள்",
    "platform_health.activity.no_timestamps": "நேர அடையாளம் கொண்ட ஆய்வு பதிவுகள் திரும்ப வழங்கப்படவில்லை.",
    "No timestamped audit records returned.": "நேர அடையாளம் கொண்ட ஆய்வு பதிவுகள் திரும்ப வழங்கப்படவில்லை.",
    "platform_health.event.login": "முகவரி பதிவு",
    "login": "முகவரி பதிவு",
    "platform_health.event.signup": "பதிவு",
    "signup": "பதிவு",
    "platform_health.status.success": "வெற்றி",
    "platform_health.status.failed": "தோல்வி",
    "platform_health.status.recorded": "பதிவுசெய்யப்பட்டது",
    "Recorded": "பதிவுசெய்யப்பட்டது",
    "platform_health.unknown_day": "தெரியாத",
    "platform_health.failure_reasons": "தோல்வி காரணங்கள்",
    "Failure reasons": "தோல்வி காரணங்கள்",
    "platform_health.no_failures": "வகைப்படுத்தப்பட்ட தோல்விகள் திரும்ப கிடைக்கவில்லை.",
    "No classified failures returned.": "வகைப்படுத்தப்பட்ட தோல்விகள் திரும்ப கிடைக்கவில்லை.",
    "platform_health.unspecified_failure": "தெரிவிக்கப்படாத தோல்வி",
    "Unspecified failure": "தெரிவிக்கப்படாத தோல்வி",
    "platform_health.recent_records": "கடந்த கால ஆடிட் பதிவுகள்",
    "Recent audit records": "கடந்த கால ஆடிட் பதிவுகள்",
    "platform_health.normalized_note": "தரவு காட்டப்படுவதற்கு மட்டுமே பயன்படுத்தப்படும் தரவுகள் சீராக்கப்படுகின்றன.",
    "Raw fields are normalized only for display.": "தரவு காட்டப்படுவதற்கு மட்டுமே பயன்படுத்தப்படும் தரவுகள் சீராக்கப்படுகின்றன.",
    "platform_health.loaded_count": "{count} ஏற்றப்பட்டது",
    "{count} loaded": "{count} ஏற்றப்பட்டது",
    "platform_health.loading_records": "ஆடிட் பதிவுகளை ஏற்றுகிறது…",
    "Loading audit records…": "ஆடிட் பதிவுகளை ஏற்றுகிறது…",
    "platform_health.no_records": "ஆடிட் பதிவுகள் திரும்ப கிடைக்கவில்லை.",
    "No audit records returned.": "ஆடிட் பதிவுகள் திரும்ப கிடைக்கவில்லை.",
    "platform_health.column.event": "நிகழ்வு",
    "platform_health.column.status": "நிலை",
    "platform_health.column.user": "பயனர்",
    "User": "பயனர்",
    "platform_health.column.time": "நேரம்",
    "Time": "நேரம்",
    "platform_health.column.reason": "காரணம்",
    "Reason": "காரணம்",
    "platform_health.config.sign_in": "முகவரி உள்நுழைவு முறை",
    "platform_health.config.facebook": "ஃபேஸ்புக் அடையாளம் காட்டுதல்",
    "platform_health.config.google": "கூகிள் அடையாளம் காட்டுதல்",
    "platform_health.config.twilio": "டுவிலியோ",
    "integrations.note.realtime": "இந்த அமைப்புகள் உடனடியாக பயன்படுத்தப்படும். அவற்றை சேமித்த பிறகு, பயன்பாடுகள் மற்றும் API பதில்களில் காணப்படும்.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "இந்த அமைப்புகள் உடனடியாக பயன்படுத்தப்படும். அவற்றை சேமித்த பிறகு, பயன்பாடுகள் மற்றும் API பதில்களில் காணப்படும்.",
    "integrations.note.mobile_release": "மொபைல் பயன்பாடு சேனல் அமைப்புகள் தயாரிப்பு வெளியிடப்படும் அல்லது புதுப்பிக்கப்படும் போது பயன்படுத்தப்படும். புதிய கட்டமைப்பைப் பெற, ஆதரவு போர்ட்டலிலிருந்து கோரவும். இது ஸ்டார்டர் திட்டத்திற்கு பொருந்தும்.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "மொபைல் பயன்பாடு சேனல் அமைப்புகள் தயாரிப்பு வெளியிடப்படும் அல்லது புதுப்பிக்கப்படும் போது பயன்படுத்தப்படும். புதிய கட்டமைப்பைப் பெற, ஆதரவு போர்ட்டலிலிருந்து கோரவும். இது ஸ்டார்டர் திட்டத்திற்கு பொருந்தும்.",
    "integrations.toast.saved": "ஒருங்கிணைப்பு அமைப்புகள் சேமிக்கப்பட்டன.",
    "Integration settings saved.": "ஒருங்கிணைப்பு அமைப்புகள் சேமிக்கப்பட்டன.",
    "integrations.error.save": "ஒருங்கிணைப்பு அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Unable to save integration settings.": "ஒருங்கிணைப்பு அமைப்புகளை சேமிக்க முடியவில்லை.",
    "integrations.twilio.title": "ட்விலியோ ஒருங்கிணைப்பு",
    "Twilio integration": "ட்விலியோ ஒருங்கிணைப்பு",
    "integrations.twilio.account_sid": "கணக்கு சிட்",
    "Account SID": "கணக்கு சிட்",
    "integrations.twilio.account_sid_placeholder": "கணக்கு சிட் உள்ளிடவும்",
    "Enter account SID": "கணக்கு சிட் உள்ளிடவும்",
    "integrations.twilio.auth_token": "அங்கீகார டோக்கன்",
    "Auth token": "அங்கீகார டோக்கன்",
    "integrations.twilio.auth_token_placeholder": "அங்கீகார டோக்கனை உள்ளிடவும்",
    "Enter auth token": "அங்கீகார டோக்கனை உள்ளிடவும்",
    "integrations.twilio.source_phone": "மூல தொலைபேசி எண்",
    "Source phone number": "மூல தொலைபேசி எண்",
    "integrations.twilio.source_phone_placeholder": "மூல தொலைபேசி எண்ணை உள்ளிடவும்",
    "Enter source phone number": "மூல தொலைபேசி எண்ணை உள்ளிடவும்",
    "integrations.facebook.title": "ஃபேஸ்புக் அங்கீகாரம்",
    "integrations.facebook.enable_login": "ஃபேஸ்புக் உள்நுழைவை செயல்படுத்தவும்",
    "Enable Facebook login": "ஃபேஸ்புக் உள்நுழைவை செயல்படுத்தவும்",
    "integrations.facebook.app_id": "பயன்பாட்டு ஐடி",
    "integrations.facebook.app_id_placeholder": "பயன்பாட்டு ஐடியை உள்ளிடவும்",
    "integrations.google.title": "கூகிள் அங்கீகாரம்",
    "integrations.google.enable_sign_in": "கூகிள் உள்நுழைவை செயல்படுத்தவும்",
    "Enable Google sign-in": "கூகிள் உள்நுழைவை செயல்படுத்தவும்",
    "integrations.google.client_id": "வாடிக்கையாளர் ஐடி",
    "integrations.google.client_id_placeholder": "வாடிக்கையாளர் ஐடியை உள்ளிடவும்",
    "integrations.auth.title": "உள்நுழைவு முறை",
    "integrations.auth.description": "பயனர்கள் பதிவு செய்து உள்நுழைய எவ்வாறு தேர்வு செய்ய வேண்டும் என்பதை தேர்வு செய்யவும். மின்னஞ்சல் மற்றும் SMS சரிபார்ப்பு டெண்ட் இல் அமைக்கப்பட்டுள்ள அனுப்பும் அமைப்புகளைப் பயன்படுத்துகின்றன.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "பயனர்கள் பதிவு செய்து உள்நுழைய எவ்வாறு தேர்வு செய்ய வேண்டும் என்பதை தேர்வு செய்யவும். மின்னஞ்சல் மற்றும் SMS சரிபார்ப்பு டெண்ட் இல் அமைக்கப்பட்டுள்ள அனுப்பும் அமைப்புகளைப் பயன்படுத்துகின்றன.",
    "integrations.auth.empty": "தற்போது ஏதும் ஆதரிக்கப்பட்ட உள்நுழைவு முறை அமைக்கப்படவில்லை. தொடர ஒன்றைத் தேர்வு செய்யவும்.",
    "No supported sign-in method is currently configured. Select one to continue.": "தற்போது ஏதும் ஆதரிக்கப்பட்ட உள்நுழைவு முறை அமைக்கப்படவில்லை. தொடர ஒன்றைத் தேர்வு செய்யவும்.",
    "integrations.auth.save_note": "சேமிப்பதன் மூலம் இந்த முறை டெண்ட் இன் பதிவு மற்றும் உள்நுழைவு புள்ளிகளுக்கு பயன்படுத்தப்படும். நேரடியாக வழங்கப்பட்ட பயனர்கள் தனித்தனியாக மேலாண்மை செய்யப்படுகின்றனர்.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "சேமிப்பதன் மூலம் இந்த முறை டெண்ட் இன் பதிவு மற்றும் உள்நுழைவு புள்ளிகளுக்கு பயன்படுத்தப்படும். நேரடியாக வழங்கப்பட்ட பயனர்கள் தனித்தனியாக மேலாண்மை செய்யப்படுகின்றனர்.",
    "integrations.auth.error.load": "தற்போதைய உள்நுழைவு முறையை ஏற்ற முடியவில்லை.",
    "Unable to load the current sign-in method.": "தற்போதைய உள்நுழைவு முறையை ஏற்ற முடியவில்லை.",
    "integrations.auth.error.save": "உள்நுழைவு முறையை சேமிக்க முடியவில்லை.",
    "Unable to save the sign-in method.": "உள்நுழைவு முறையை சேமிக்க முடியவில்லை.",
    "integrations.auth.toast.saved": "உள்நுழைவு முறை சேமிக்கப்பட்டது.",
    "Sign-in method saved.": "உள்நுழைவு முறை சேமிக்கப்பட்டது.",
    "integrations.auth.email_password": "மேலும் விவரங்கள்",
    "Email and password": "மேலும் விவரங்கள்",
    "integrations.auth.email_password_help": "பதிவு செய்யும் போது பயனர்கள் தங்கள் மின்னஞ்சலை உறுதிப்படுத்துகிறார்கள், பின்னர் கடவுச்சொல்லுடன் உள்நுழைகிறார்கள்.",
    "Users verify their email during sign-up, then sign in with a password.": "பதிவு செய்யும் போது பயனர்கள் தங்கள் மின்னஞ்சலை உறுதிப்படுத்துகிறார்கள், பின்னர் கடவுச்சொல்லுடன் உள்நுழைகிறார்கள்.",
    "integrations.auth.email_code": "மின்னஞ்சல் மூலம் ஒருமுறை குறியீடு",
    "Email one-time code": "மின்னஞ்சல் மூலம் ஒருமுறை குறியீடு",
    "integrations.auth.email_code_help": "பதிவு மற்றும் உள்நுழைவுக்கு பயனர்களுக்கு மின்னஞ்சல் மூலம் உறுதிப்படுத்தும் குறியீடு அனுப்பப்படுகிறது.",
    "Users receive a verification code by email for sign-up and sign-in.": "பதிவு மற்றும் உள்நுழைவுக்கு பயனர்களுக்கு மின்னஞ்சல் மூலம் உறுதிப்படுத்தும் குறியீடு அனுப்பப்படுகிறது.",
    "integrations.auth.phone_code": "தொலைபேசி ஒருமுறை குறியீடு",
    "Phone one-time code": "தொலைபேசி ஒருமுறை குறியீடு",
    "integrations.auth.phone_code_help": "பதிவு மற்றும் உள்நுழைவுக்கு பயனர்களுக்கு SMS மூலம் உறுதிப்படுத்தும் குறியீடு அனுப்பப்படுகிறது.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "பதிவு மற்றும் உள்நுழைவுக்கு பயனர்களுக்கு SMS மூலம் உறுதிப்படுத்தும் குறியீடு அனுப்பப்படுகிறது.",
    "integrations.auth.phone_password": "தொலைபேசி மற்றும் கடவுச்சொல்",
    "Phone and password": "தொலைபேசி மற்றும் கடவுச்சொல்",
    "integrations.auth.phone_password_help": "பதிவு செய்யும் போது பயனர்கள் தங்கள் தொலைபேசியை உறுதிப்படுத்துகிறார்கள், பின்னர் கடவுச்சொல்லுடன் உள்நுழைகிறார்கள்.",
    "Users verify their phone during sign-up, then sign in with a password.": "பதிவு செய்யும் போது பயனர்கள் தங்கள் தொலைபேசியை உறுதிப்படுத்துகிறார்கள், பின்னர் கடவுச்சொல்லுடன் உள்நுழைகிறார்கள்.",
    "integrations.auth.email_password_unverified": "பதிவு உறுதிப்படுத்தல் இல்லாமல் மின்னஞ்சல் மற்றும் கடவுச்சொல்",
    "Email and password without sign-up verification": "பதிவு உறுதிப்படுத்தல் இல்லாமல் மின்னஞ்சல் மற்றும் கடவுச்சொல்",
    "integrations.auth.email_password_unverified_help": "மின்னஞ்சல் மற்றும் கடவுச்சொல்லுடன் உறுதிப்படுத்தும் குறியீடு இல்லாமல் பயனர்கள் பதிவு செய்யலாம்.",
    "Users can sign up with an email and password without an email verification code.": "மின்னஞ்சல் மற்றும் கடவுச்சொல்லுடன் உறுதிப்படுத்தும் குறியீடு இல்லாமல் பயனர்கள் பதிவு செய்யலாம்.",
    "integrations.auth.phone_password_unverified": "பதிவு உறுதிப்படுத்தல் இல்லாமல் தொலைபேசி மற்றும் கடவுச்சொல்",
    "Phone and password without sign-up verification": "பதிவு உறுதிப்படுத்தல் இல்லாமல் தொலைபேசி மற்றும் கடவுச்சொல்",
    "integrations.auth.phone_password_unverified_help": "SMS உறுதிப்படுத்தும் குறியீடு இல்லாமல் பயனர்கள் தொலைபேசி மற்றும் கடவுச்சொல்லுடன் பதிவு செய்யலாம்.",
    "Users can sign up with a phone and password without an SMS verification code.": "SMS உறுதிப்படுத்தும் குறியீடு இல்லாமல் பயனர்கள் தொலைபேசி மற்றும் கடவுச்சொல்லுடன் பதிவு செய்யலாம்.",
    "integrations.page.title": "பயன்பாடு ஒத்திசைவுகள்",
    "integrations.generic.id_placeholder": "{name} ஐடி உள்ளிடவும்",
    "Enter {name} ID": "{name} ஐடி உள்ளிடவும்",
    "integrations.generic.enable": "{name} ஒத்திசைவை செயல்படுத்து",
    "Enable {name} integration": "{name} ஒத்திசைவை செயல்படுத்து",
    "integrations.menu.map": "மேப்ஸ்",
    "integrations.menu.firebase": "பைரென்ட்",
    "Firebase": "பைரென்ட்",
    "integrations.menu.branch": "பிராஞ்ச்",
    "Branch": "பிராஞ்ச்",
    "integrations.menu.appstore": "ஆப் ஸ்டோர்",
    "App Store": "ஆப் ஸ்டோர்",
    "integrations.menu.playstore": "கூகிள் ப்ளே",
    "Google Play": "கூகிள் ப்ளே",
    "integrations.menu.admob": "அட்மாப்",
    "AdMob": "அட்மாப்",
    "integrations.maps.title": "மேப்ஸ் ஒத்திசைவு",
    "Maps integration": "மேப்ஸ் ஒத்திசைவு",
    "integrations.maps.google": "கூகிள் மேப்ஸ்",
    "Google Maps": "கூகிள் மேப்ஸ்",
    "integrations.maps.openstreet": "ஆப்பன் ஸ்ட்ரீட் மேப்",
    "OpenStreetMap": "ஆப்பன் ஸ்ட்ரீட் மேப்",
    "integrations.maps.api_key": "API குறியீடு",
    "API key": "API குறியீடு",
    "integrations.maps.api_key_placeholder": "API குறியீட்டை உள்ளிடவும்",
    "Enter API key": "API குறியீட்டை உள்ளிடவும்",
    "integrations.maps.reverse_geocode_key": "Google Maps பின்னொத்திய புவியியல் அடையாளம் API குறியீடு",
    "Google Maps reverse geocoding API key": "Google Maps பின்னொத்திய புவியியல் அடையாளம் API குறியீடு",
    "integrations.maps.reverse_geocode_key_placeholder": "Google Maps பின்னொத்திய புவியியல் அடையாளம் API குறியீட்டை உள்ளிடவும்",
    "Enter Google Maps reverse geocoding API key": "Google Maps பின்னொத்திய புவியியல் அடையாளம் API குறியீட்டை உள்ளிடவும்",
    "integrations.maps.places_key": "Google Maps Places API குறியீடு",
    "Google Maps Places API key": "Google Maps Places API குறியீடு",
    "integrations.maps.places_key_placeholder": "Google Maps Places API குறியீட்டை உள்ளிடவும்",
    "Enter Google Maps Places API key": "Google Maps Places API குறியீட்டை உள்ளிடவும்",
    "integrations.maps.nearby_accounts": "முகப்புப் பக்கத்தில் அருகிலுள்ள கணக்குகளை செயல்படுத்து",
    "Activate nearby accounts on the home page": "முகப்புப் பக்கத்தில் அருகிலுள்ள கணக்குகளை செயல்படுத்து",
    "integrations.maps.listing_location": "பட்டியல் சமர்ப்பிப்பில் இடம் செயல்படுத்து",
    "Activate location in listing submission": "பட்டியல் சமர்ப்பிப்பில் இடம் செயல்படுத்து",
    "integrations.maps.account_location": "கணக்கு சமர்ப்பிப்பில் இடம் செயல்படுத்து",
    "Activate location in account submission": "கணக்கு சமர்ப்பிப்பில் இடம் செயல்படுத்து",
    "integrations.playstore.title": "Google Play ஒத்திசைவு",
    "Google Play integration": "Google Play ஒத்திசைவு",
    "integrations.playstore.application_id": "பயன்பாட்டு ID",
    "Application ID": "பயன்பாட்டு ID",
    "integrations.playstore.application_id_placeholder": "பயன்பாட்டு ID (com.tenantname.app) உள்ளிடவும்",
    "Enter application ID (com.tenantname.app)": "பயன்பாட்டு ID (com.tenantname.app) உள்ளிடவும்",
    "integrations.playstore.first_name": "பெயர்",
    "integrations.playstore.first_name_placeholder": "பெயரை உள்ளிடவும்",
    "Enter first name": "பெயரை உள்ளிடவும்",
    "integrations.playstore.last_name": "கடைசி பெயர்",
    "integrations.playstore.last_name_placeholder": "கடைசி பெயரை உள்ளிடவும்",
    "Enter last name": "கடைசி பெயரை உள்ளிடவும்",
    "integrations.playstore.unit": "நிறுவன அலகு",
    "Organizational unit": "நிறுவன அலகு",
    "integrations.playstore.unit_placeholder": "நிறுவன அலகை உள்ளிடவும்",
    "Enter organizational unit": "நிறுவன அலகை உள்ளிடவும்",
    "integrations.playstore.organization": "நிறுவனம்",
    "Organization": "நிறுவனம்",
    "integrations.playstore.organization_placeholder": "நிறுவன பெயரை உள்ளிடவும்",
    "Enter organization name": "நிறுவன பெயரை உள்ளிடவும்",
    "integrations.playstore.city": "நகரம் அல்லது பகுதி",
    "City or locality": "நகரம் அல்லது பகுதி",
    "integrations.playstore.city_placeholder": "நகரம் அல்லது பகுதியை உள்ளிடவும்",
    "Enter city or locality": "நகரம் அல்லது பகுதியை உள்ளிடவும்",
    "integrations.playstore.state": "மாநிலம் அல்லது மாகாணம்",
    "State or province": "மாநிலம் அல்லது மாகாணம்",
    "integrations.playstore.state_placeholder": "மாநிலம் அல்லது மாகாணத்தை உள்ளிடவும்",
    "Enter state or province": "மாநிலம் அல்லது மாகாணத்தை உள்ளிடவும்",
    "integrations.playstore.country_code": "நாட்டு குறியீடு (XX)",
    "Country code (XX)": "நாட்டு குறியீடு (XX)",
    "integrations.playstore.country_code_placeholder": "நாட்டு குறியீட்டை உள்ளிடவும்",
    "Enter country code": "நாட்டு குறியீட்டை உள்ளிடவும்",
    "integrations.playstore.link": "Google Play இணைப்பு",
    "Google Play link": "Google Play இணைப்பு",
    "integrations.playstore.link_placeholder": "உங்கள் பயன்பாட்டிற்கான Google Play இணைப்பை உள்ளிடவும்",
    "Enter your app Google Play link": "உங்கள் பயன்பாட்டிற்கான Google Play இணைப்பை உள்ளிடவும்",
    "integrations.admob.title": "AdMob ஒத்துழைப்பு",
    "AdMob integration": "AdMob ஒத்துழைப்பு",
    "integrations.admob.app_id": "பயன்பாட்டு ID",
    "integrations.admob.app_id_placeholder": "பயன்பாட்டு ID-ஐ உள்ளிடவும்",
    "Enter App ID": "பயன்பாட்டு ID-ஐ உள்ளிடவும்",
    "integrations.admob.unit_id": "அலகு ID",
    "Unit ID": "அலகு ID",
    "integrations.admob.unit_id_placeholder": "AdMob அலகு ID-ஐ உள்ளிடவும்",
    "Enter AdMob unit ID": "AdMob அலகு ID-ஐ உள்ளிடவும்",
    "integrations.admob.listings_id": "பட்டியல் ID",
    "Listings ID": "பட்டியல் ID",
    "integrations.admob.listings_id_placeholder": "பட்டியல் ID-ஐ உள்ளிடவும்",
    "Enter listings ID": "பட்டியல் ID-ஐ உள்ளிடவும்",
    "integrations.admob.listing_detail_id": "பட்டியல் விவரம் ID",
    "Listing detail ID": "பட்டியல் விவரம் ID",
    "integrations.admob.listing_detail_id_placeholder": "பட்டியல் விவரம் ID-ஐ உள்ளிடவும்",
    "Enter listing detail ID": "பட்டியல் விவரம் ID-ஐ உள்ளிடவும்",
    "integrations.admob.home_id": "தொடக்கம் ID",
    "Home ID": "தொடக்கம் ID",
    "integrations.admob.home_id_placeholder": "தொடக்கம் ID-ஐ உள்ளிடவும்",
    "Enter home ID": "தொடக்கம் ID-ஐ உள்ளிடவும்",
    "integrations.admob.enable_ads": "அறிவிப்புகளை செயல்படுத்து",
    "Enable ads": "அறிவிப்புகளை செயல்படுத்து",
    "integrations.admob.enable_listing_ads": "பட்டியல் பட்டியலில் அறிவிப்புகளை செயல்படுத்து",
    "Enable ads on the listings feed": "பட்டியல் பட்டியலில் அறிவிப்புகளை செயல்படுத்து",
    "integrations.admob.enable_listing_detail_ads": "பட்டியல் விவரங்களில் அறிவிப்புகளை செயல்படுத்து",
    "Enable ads on listing details": "பட்டியல் விவரங்களில் அறிவிப்புகளை செயல்படுத்து",
    "integrations.admob.enable_home_ads": "தொடக்க கீழ் பகுதியில் அறிவிப்புகளை செயல்படுத்து",
    "Enable ads in the home bottom navigation": "தொடக்க கீழ் பகுதியில் அறிவிப்புகளை செயல்படுத்து",
    "integrations.save_success": "வெற்றிகரமாக சேமிக்கப்பட்டது",
    "Saved successfully": "வெற்றிகரமாக சேமிக்கப்பட்டது",
    "integrations.note.release": "இந்த அமைப்புகள் மொபைல் பயன்பாடு வெளியிடப்படும் அல்லது புதுப்பிக்கப்படும் போது பொருந்தும். மாற்றங்களைச் செய்த பிறகு சப்போர்ட் போர்ட்டலிலிருந்து புதிய பில்ட் கேட்கவும். ஸ்டார்டர் திட்டம் பொருந்தும்.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "இந்த அமைப்புகள் மொபைல் பயன்பாடு வெளியிடப்படும் அல்லது புதுப்பிக்கப்படும் போது பொருந்தும். மாற்றங்களைச் செய்த பிறகு சப்போர்ட் போர்ட்டலிலிருந்து புதிய பில்ட் கேட்கவும். ஸ்டார்டர் திட்டம் பொருந்தும்.",
    "integrations.action.download": "பதிவிறக்கு",
    "integrations.branch.title": "Branch ஒத்துழைப்பு",
    "Branch integration": "Branch ஒத்துழைப்பு",
    "integrations.branch.app_id": "பயன்பாட்டு ID",
    "integrations.branch.app_id_placeholder": "ஆப்பிளின் ஐடி உள்ளிடவும்",
    "integrations.branch.live_key": "லைவ் கீ",
    "Live key": "லைவ் கீ",
    "integrations.branch.live_key_placeholder": "லைவ் கீ உள்ளிடவும்",
    "Enter live key": "லைவ் கீ உள்ளிடவும்",
    "integrations.branch.live_secret": "லைவ் சீக்ரெட்",
    "Live secret": "லைவ் சீக்ரெட்",
    "integrations.branch.live_secret_placeholder": "லைவ் சீக்ரெட் உள்ளிடவும்",
    "Enter live secret": "லைவ் சீக்ரெட் உள்ளிடவும்",
    "integrations.branch.uri_scheme": "URI ஸ்கீம்",
    "URI scheme": "URI ஸ்கீம்",
    "integrations.branch.uri_scheme_placeholder": "URI ஸ்கீம் உள்ளிடவும்",
    "Enter URI scheme": "URI ஸ்கீம் உள்ளிடவும்",
    "integrations.branch.link_domain": "லிங்க் டொமைன்",
    "Link domain": "லிங்க் டொமைன்",
    "integrations.branch.link_domain_placeholder": "லிங்க் டொமைன் உள்ளிடவும்",
    "Enter link domain": "லிங்க் டொமைன் உள்ளிடவும்",
    "integrations.branch.alternate_domain": "ஆல்ட்டர்னேட் லிங்க் டொமைன்",
    "Alternate link domain": "ஆல்ட்டர்னேட் லிங்க் டொமைன்",
    "integrations.branch.alternate_domain_placeholder": "ஆல்ட்டர்னேட் லிங்க் டொமைன் உள்ளிடவும்",
    "Enter alternate link domain": "ஆல்ட்டர்னேட் லிங்க் டொமைன் உள்ளிடவும்",
    "integrations.branch.link_description": "லிங்க் விவரணம்",
    "Link description": "லிங்க் விவரணம்",
    "integrations.branch.link_description_placeholder": "லிங்க் விவரணம் உள்ளிடவும்",
    "Enter link description": "லிங்க் விவரணம் உள்ளிடவும்",
    "integrations.branch.invite_friends": "மைத்துனர்களை அழைக்கவும்",
    "Invite friends": "மைத்துனர்களை அழைக்கவும்",
    "integrations.branch.invite_title": "தலைப்பு",
    "integrations.branch.invite_description": "விவரணம்",
    "integrations.branch.destination_link": "பிராஞ்ச் டெஸ்டினேஷன் லிங்க் (ஆப்ஷனல்)",
    "Branch destination link (optional)": "பிராஞ்ச் டெஸ்டினேஷன் லிங்க் (ஆப்ஷனல்)",
    "integrations.branch.web_app_note": "வெப் அப்ளிகேஷன் பயனர்களுக்கு பொருந்தும்",
    "Applies to web app users": "வெப் அப்ளிகேஷன் பயனர்களுக்கு பொருந்தும்",
    "integrations.branch.destination_placeholder": "பிராஞ்ச் டெஸ்டினேஷன் லிங்க் உள்ளிடவும்",
    "Enter branch destination link": "பிராஞ்ச் டெஸ்டினேஷன் லிங்க் உள்ளிடவும்",
    "integrations.ios.title": "App Store ப்ரொவிஷன்",
    "App Store provisioning": "App Store ப்ரொவிஷன்",
    "integrations.ios.bundle_id": "பேக்கேஜ் ஐடி",
    "Bundle ID": "பேக்கேஜ் ஐடி",
    "integrations.ios.bundle_id_placeholder": "பேக்கேஜ் ஐடி உள்ளிடவும்",
    "Enter bundle ID": "பேக்கேஜ் ஐடி உள்ளிடவும்",
    "integrations.ios.certificate_password": "டிஸ்டிப்யூஷன் சர்டிஃபிகேட் பாஸ்வேர்ட்",
    "Distribution certificate password": "டிஸ்டிப்யூஷன் சர்டிஃபிகேட் பாஸ்வேர்ட்",
    "integrations.ios.certificate_password_placeholder": "டிஸ்டிப்யூஷன் சர்டிஃபிகேட் பாஸ்வேர்ட் உள்ளிடவும்",
    "Enter distribution certificate password": "டிஸ்டிப்யூஷன் சர்டிஃபிகேட் பாஸ்வேர்ட் உள்ளிடவும்",
    "integrations.ios.push_key_id": "அனுப்பு குறியீட்டு ID",
    "Push key ID": "அனுப்பு குறியீட்டு ID",
    "integrations.ios.push_key_id_placeholder": "அனுப்பு குறியீட்டு ID உள்ளிடவும்",
    "Enter push key ID": "அனுப்பு குறியீட்டு ID உள்ளிடவும்",
    "integrations.ios.team_id": "குழு ID",
    "Team ID": "குழு ID",
    "integrations.ios.team_id_placeholder": "குழு ID உள்ளிடவும்",
    "Enter team ID": "குழு ID உள்ளிடவும்",
    "integrations.ios.apple_id": "ஆப்பிள் ஐடி",
    "Apple ID": "ஆப்பிள் ஐடி",
    "integrations.ios.apple_id_placeholder": "Apple ID உள்ளிடவும்",
    "Enter Apple ID": "Apple ID உள்ளிடவும்",
    "integrations.ios.distribution_certificate": "பரப்புதல் சான்றிதழ்",
    "Distribution certificate": "பரப்புதல் சான்றிதழ்",
    "integrations.ios.provisioning_profile": "பரப்புதல் வழங்கும் திட்டம்",
    "Distribution provisioning profile": "பரப்புதல் வழங்கும் திட்டம்",
    "integrations.ios.push_key": "அனுப்பு குறியீடு",
    "Push key": "அனுப்பு குறியீடு",
    "integrations.ios.app_store_link": "App Store இணைப்பு",
    "Your App Store link": "App Store இணைப்பு",
    "integrations.ios.app_store_link_placeholder": "உங்கள் பயன்பாட்டிற்கான App Store இணைப்பை உள்ளிடவும்",
    "Enter your app App Store link": "உங்கள் பயன்பாட்டிற்கான App Store இணைப்பை உள்ளிடவும்",
    "integrations.firebase.title": "Firebase இணைப்பு",
    "Firebase integration": "Firebase இணைப்பு",
    "integrations.firebase.choose_file": "கோப்பைத் தேர்வுசெய்யவும்",
    "integrations.firebase.service_account": "Firebase சேவை கணக்கு",
    "Firebase service account": "Firebase சேவை கணக்கு",
    "integrations.firebase.android_json": "Android பயன்பாட்டு JSON கோப்பு",
    "Android app JSON file": "Android பயன்பாட்டு JSON கோப்பு",
    "integrations.firebase.ios_plist": "iOS பயன்பாட்டு plist கோப்பு",
    "iOS app plist file": "iOS பயன்பாட்டு plist கோப்பு",
    "integrations.firebase.create_project": "Firebase திட்டத்தை உருவாக்கு",
    "Create Firebase project": "Firebase திட்டத்தை உருவாக்கு",
    "integrations.firebase.create_android": "Android பயன்பாட்டை உருவாக்கு",
    "Create Android app": "Android பயன்பாட்டை உருவாக்கு",
    "integrations.firebase.create_ios": "iOS பயன்பாட்டை உருவாக்கு",
    "Create iOS app": "iOS பயன்பாட்டை உருவாக்கு",
    "integrations.firebase.create_database": "நேரடி தரவுத்தளத்தை உருவாக்கு",
    "Create realtime database": "நேரடி தரவுத்தளத்தை உருவாக்கு",
    "integrations.firebase.apply_rules": "Firebase தரவுத்தள விதிகளை பயன்படுத்து",
    "Apply Firebase database rules": "Firebase தரவுத்தள விதிகளை பயன்படுத்து",
    "bundles.listing_number": "பட்டியல் #{id}",
    "Listing #{id}": "பட்டியல் #{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "பேக்கேஜை அமைக்கவும்",
    "Configure bundle": "பேக்கேஜை அமைக்கவும்",
    "bundles.configure.subtitle": "பேக்கேஜ் பட்டியல் #{id} · கீழே ஏற்கனவே உள்ள பட்டியல்களைச் சேர்க்கவும்.",
    "Bundle listing #{id} · add existing listings below.": "பேக்கேஜ் பட்டியல் #{id} · கீழே ஏற்கனவே உள்ள பட்டியல்களைச் சேர்க்கவும்.",
    "bundles.back": "பேக்கேஜ்களுக்கு திரும்பு",
    "Back to bundles": "பேக்கேஜ்களுக்கு திரும்பு",
    "bundles.fixed_components": "நிலையான பாகங்கள்",
    "Fixed components": "நிலையான பாகங்கள்",
    "bundles.selection_pool": "கலவை மற்றும் தேர்வு பெட்டி",
    "Mix-and-match pool": "கலவை மற்றும் தேர்வு பெட்டி",
    "bundles.available_listings": "கிடைக்கும் பட்டியல்கள்",
    "Available listings": "கிடைக்கும் பட்டியல்கள்",
    "bundles.available_description": "உங்கள் கத்தலாக்கில் ஏற்கனவே உள்ள பொருட்களைத் தேடி சேர்க்கவும்.",
    "Search and add products already in your catalogue.": "உங்கள் கத்தலாக்கில் ஏற்கனவே உள்ள பொருட்களைத் தேடி சேர்க்கவும்.",
    "bundles.search_listings": "பட்டியல்களைத் தேடு",
    "Search listings": "பட்டியல்களைத் தேடு",
    "bundles.quantity_per_component": "ஒவ்வொரு பாகத்திற்கும் அளவு",
    "Quantity per component": "ஒவ்வொரு பாகத்திற்கும் அளவு",
    "bundles.loading_listings": "பட்டியல்களை ஏற்றுகிறது…",
    "Loading listings…": "பட்டியல்களை ஏற்றுகிறது…",
    "bundles.added": "சேர்க்கப்பட்டது",
    "Added": "சேர்க்கப்பட்டது",
    "bundles.adding": "சேர்க்கிறது…",
    "Adding…": "சேர்க்கிறது…",
    "bundles.add": "சேர்",
    "bundles.no_matching_listings": "பொருத்தமான பட்டியல்கள் கிடைக்கவில்லை.",
    "No matching listings found.": "பொருத்தமான பட்டியல்கள் கிடைக்கவில்லை.",
    "bundles.one_listing_added": "1 பட்டியல் சேர்க்கப்பட்டது",
    "1 listing added": "1 பட்டியல் சேர்க்கப்பட்டது",
    "bundles.many_listings_added": "{count} பட்டியல்கள் சேர்க்கப்பட்டன",
    "{count} listings added": "{count} பட்டியல்கள் சேர்க்கப்பட்டன",
    "bundles.quantity_short": "அளவு {count}",
    "Qty {count}": "அளவு {count}",
    "bundles.removing": "அகற்றப்படுகிறது…",
    "Removing…": "அகற்றப்படுகிறது…",
    "bundles.remove": "அகற்று",
    "bundles.no_components": "இன்னும் பாகங்கள் சேர்க்கப்படவில்லை.",
    "No components added yet.": "இன்னும் பாகங்கள் சேர்க்கப்படவில்லை.",
    "bundles.pool_remove_note": "பூட்டு அகற்றுதலுக்கு பின்னடைவு புள்ளியை தேவைப்படுகிறது; சேர்க்கைகள் இப்போது செயல்பாட்டில் உள்ளன.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "பூட்டு அகற்றுதலுக்கு பின்னடைவு புள்ளியை தேவைப்படுகிறது; சேர்க்கைகள் இப்போது செயல்பாட்டில் உள்ளன.",
    "bundles.error.load_components": "பேக்கேஜ் பாகங்களை ஏற்ற முடியவில்லை.",
    "Unable to load bundle components.": "பேக்கேஜ் பாகங்களை ஏற்ற முடியவில்லை.",
    "bundles.error.add_listing": "பேக்கேஜில் பட்டியலைச் சேர்க்க முடியவில்லை.",
    "Unable to add listing to the bundle.": "பேக்கேஜில் பட்டியலைச் சேர்க்க முடியவில்லை.",
    "bundles.error.remove_component": "பேக்கேஜிலிருந்து பாகத்தை அகற்ற முடியவில்லை.",
    "Unable to remove bundle component.": "பேக்கேஜிலிருந்து பாகத்தை அகற்ற முடியவில்லை.",
    "bundles.error.load_listings": "பட்டியல்களை ஏற்ற முடியவில்லை.",
    "Unable to load listings.": "பட்டியல்களை ஏற்ற முடியவில்லை.",
    "bundles.components": "பேக்கேஜ் கூறுகள்",
    "Bundle components": "பேக்கேஜ் கூறுகள்",
    "bundles.picker_description": "உங்கள் கத்தலாக்கத்தில் ஏற்கனவே உள்ள பட்டியல்களைத் தேர்வு செய்யவும். பேக்கேஜ் உருவாக்கப்பட்ட பிறகு இவை இணைக்கப்படும்.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "உங்கள் கத்தலாக்கத்தில் ஏற்கனவே உள்ள பட்டியல்களைத் தேர்வு செய்யவும். பேக்கேஜ் உருவாக்கப்பட்ட பிறகு இவை இணைக்கப்படும்.",
    "bundles.fixed_bundle": "நிலையான பேக்கேஜ்",
    "Fixed bundle": "நிலையான பேக்கேஜ்",
    "bundles.mix_match": "கலப்பு மற்றும் தேர்வு செய்தல்",
    "Mix and match": "கலப்பு மற்றும் தேர்வு செய்தல்",
    "bundles.quantity_per_selected": "தேர்ந்தெடுக்கப்பட்ட பட்டியலுக்கு அளவு",
    "Quantity per selected listing": "தேர்ந்தெடுக்கப்பட்ட பட்டியலுக்கு அளவு",
    "bundles.search_existing": "ஏற்கனவே உள்ள பட்டியல்களைத் தேடுதல்",
    "Search existing listings": "ஏற்கனவே உள்ள பட்டியல்களைத் தேடுதல்",
    "bundles.selected_count": "தேர்ந்தெடுக்கப்பட்டவை ({count})",
    "Selected ({count})": "தேர்ந்தெடுக்கப்பட்டவை ({count})",
    "bundles.choose_component_hint": "ஏதாவது ஒரு ஏற்கனவே உள்ள பட்டியலைத் தேர்ந்தெடுக்கவும், அல்லது முதலில் பேக்கேஜை உருவாக்கவும்.",
    "Choose at least one existing listing, or create the bundle first.": "ஏதாவது ஒரு ஏற்கனவே உள்ள பட்டியலைத் தேர்ந்தெடுக்கவும், அல்லது முதலில் பேக்கேஜை உருவாக்கவும்.",
    "bundles.error.attach_components": "பேக்கேஜ் உருவாக்கப்பட்டது, ஆனால் கூறுகள் இணைக்கப்படவில்லை.",
    "The bundle was created, but components could not be attached.": "பேக்கேஜ் உருவாக்கப்பட்டது, ஆனால் கூறுகள் இணைக்கப்படவில்லை.",
    "bundles.continue_configure_hint": "நீங்கள் பேக்கேஜ் அமைப்பு பக்கத்திலிருந்து தொடரலாம்.",
    "You can continue from the bundle configuration page.": "நீங்கள் பேக்கேஜ் அமைப்பு பக்கத்திலிருந்து தொடரலாம்.",
    "bundles.title": "பேக்கேஜ்கள்",
    "bundles.create": "பேக்கேஜ் உருவாக்குதல்",
    "Create bundle": "பேக்கேஜ் உருவாக்குதல்",
    "bundles.subtitle": "முதன்மை பேக்கேஜ் பட்டியலை உருவாக்கி, பின்னர் நிலையான கூறுகளை அல்லது கலப்புத் தேர்வுக் குழுவை இணைக்கவும்.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "முதன்மை பேக்கேஜ் பட்டியலை உருவாக்கி, பின்னர் நிலையான கூறுகளை அல்லது கலப்புத் தேர்வுக் குழுவை இணைக்கவும்.",
    "bundles.workflow": "பேக்கேஜ் வேலை ஒழுங்கு",
    "Bundle workflow": "பேக்கேஜ் வேலை ஒழுங்கு",
    "bundles.how_it_works": "பேக்கேஜ்கள் எவ்வாறு செயல்படுகின்றன",
    "How bundles work": "பேக்கேஜ்கள் எவ்வாறு செயல்படுகின்றன",
    "bundles.parent_description": "ஆதரவு வாடிக்கையாளர் பார்க்கும் பேக்கேஜை ஒரு முதன்மை பட்டியல் கட்டுப்படுத்துகிறது.",
    "One parent listing controls the customer-facing bundle.": "ஆதரவு வாடிக்கையாளர் பார்க்கும் பேக்கேஜை ஒரு முதன்மை பட்டியல் கட்டுப்படுத்துகிறது.",
    "bundles.flow": "பேக்கேஜ் ஓட்டம்",
    "Bundle flow": "பேக்கேஜ் ஓட்டம்",
    "bundles.parent_listing": "முதன்மை பட்டியல்",
    "Parent listing": "முதன்மை பட்டியல்",
    "bundles.name_price_category": "பெயர், விலை, வகை",
    "Name, price, category": "பெயர், விலை, வகை",
    "bundles.fixed_or_pool": "நிலையான பொருட்கள் அல்லது குழு",
    "Fixed items or a pool": "நிலையான பொருட்கள் அல்லது குழு",
    "bundles.checkout_stock": "கிடைப்பு கடையில்",
    "Checkout stock": "கிடைப்பு கடையில்",
    "bundles.selection_availability": "தேர்வு + கிடைப்பு",
    "Selection + availability": "தேர்வு + கிடைப்பு",
    "bundles.fixed_bundles": "நிலையான பேக்கேஜ்கள்",
    "Fixed bundles": "நிலையான பேக்கேஜ்கள்",
    "bundles.fixed_description": "ஏற்கனவே உள்ள பட்டியல்களின் குறிப்பிட்ட குழுவை இணைத்து விற்கவும்.",
    "Sell a defined group of existing listings together.": "ஏற்கனவே உள்ள பட்டியல்களின் குறிப்பிட்ட குழுவை இணைத்து விற்கவும்.",
    "bundles.fixed_detail": "உள்ளிடப்பட்ட பட்டியல்களை நிலையான கூறுகளாக சேர்க்கவும்.",
    "Add existing listings as fixed components.": "உள்ளிடப்பட்ட பட்டியல்களை நிலையான கூறுகளாக சேர்க்கவும்.",
    "bundles.pool_description": "பொருட்களை பேக்கேஜ் குழுவிலிருந்து தேர்வு செய்ய வாடிக்கையாளர்களுக்கு அனுமதிக்கவும்.",
    "Let customers choose eligible items from a bundle pool.": "பொருட்களை பேக்கேஜ் குழுவிலிருந்து தேர்வு செய்ய வாடிக்கையாளர்களுக்கு அனுமதிக்கவும்.",
    "bundles.pool_detail": "செலுத்துதலில் குறைந்தபட்சம் மற்றும் அதிகபட்ச தேர்வுகளை அமைக்கவும்.",
    "Set the minimum and maximum selections at checkout.": "செலுத்துதலில் குறைந்தபட்சம் மற்றும் அதிகபட்ச தேர்வுகளை அமைக்கவும்.",
    "channels.opensource.title": "திறந்த மூல தொடக்க கிட்கள்",
    "Open-source starter kits": "திறந்த மூல தொடக்க கிட்கள்",
    "channels.opensource.view_org": "கிட்ஹப் நிறுவனத்தைப் பார்க்கவும்",
    "View GitHub organization": "கிட்ஹப் நிறுவனத்தைப் பார்க்கவும்",
    "channels.opensource.description": "TRADLY-PLATFORM நிறுவனத்திலிருந்து திறந்த மூல டிராட்லி பேக்கேஜ்களையும், தொடக்க கிட்களையும் ஆராயவும்.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "TRADLY-PLATFORM நிறுவனத்திலிருந்து திறந்த மூல டிராட்லி பேக்கேஜ்களையும், தொடக்க கிட்களையும் ஆராயவும்.",
    "channels.opensource.loading": "ஆராய்ச்சி பேக்கேஜ்களை ஏற்றுகிறது…",
    "Loading repositories…": "ஆராய்ச்சி பேக்கேஜ்களை ஏற்றுகிறது…",
    "channels.opensource.error.http": "கிட்ஹப் {status} அனுப்பியது.",
    "GitHub returned {status}.": "கிட்ஹப் {status} அனுப்பியது.",
    "channels.opensource.error.load": "பேக்கேஜ்களை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "Unable to load repositories. Try again later.": "பேக்கேஜ்களை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "channels.opensource.empty": "பொது பேக்கேஜ்கள் கிடைக்கவில்லை.",
    "No public repositories found.": "பொது பேக்கேஜ்கள் கிடைக்கவில்லை.",
    "channels.opensource.repo_fallback": "திறந்த மூல டிராட்லி பேக்கேஜ்.",
    "Open-source Tradly repository.": "திறந்த மூல டிராட்லி பேக்கேஜ்.",
    "channels.opensource.language_code": "குறியீடு",
    "channels.opensource.view_repo": "பேக்கேஜைப் பார்க்கவும்",
    "View repository": "பேக்கேஜைப் பார்க்கவும்",
    "developer.mcp.select_all": "எல்லாவற்றையும் தேர்வு செய்யவும்",
    "Select all": "எல்லாவற்றையும் தேர்வு செய்யவும்",
    "developer.mcp.read": "படிக்க",
    "developer.mcp.write": "எழுது",
    "developer.mcp.delete": "நீக்கு",
    "developer.mcp.export": "வெளியீடு",
    "developer.mcp.copy": "நகலெடு",
    "developer.mcp.copied": "நகலெடுக்கப்பட்டது",
    "Copied": "நகலெடுக்கப்பட்டது",
    "developer.mcp.connection_created": "இணைப்பு உருவாக்கப்பட்டது",
    "Connection created": "இணைப்பு உருவாக்கப்பட்டது",
    "developer.mcp.save_secret_warning": "உங்கள் வாடிக்கையாளர் ரகசியத்தை இப்போது சேமிக்கவும் — அது மீண்டும் காட்டப்படாது.",
    "Save your client secret now — it will not be shown again.": "உங்கள் வாடிக்கையாளர் ரகசியத்தை இப்போது சேமிக்கவும் — அது மீண்டும் காட்டப்படாது.",
    "developer.mcp.client_id": "வாடிக்கையாளர் ID",
    "developer.mcp.client_secret": "வாடிக்கையாளர் ரகசியம்",
    "Client secret": "வாடிக்கையாளர் ரகசியம்",
    "developer.mcp.new_connection": "புதிய MCP இணைப்பு",
    "New MCP connection": "புதிய MCP இணைப்பு",
    "developer.mcp.platform": "தளம்",
    "Platform": "தளம்",
    "developer.mcp.platform_custom": "தனிப்பயனாக்கப்பட்ட",
    "developer.mcp.connection_name": "இணைப்பு பெயர்",
    "Connection name": "இணைப்பு பெயர்",
    "developer.mcp.connection_name_placeholder": "எ.கா. ChatGPT",
    "e.g. ChatGPT": "எ.கா. ChatGPT",
    "developer.mcp.redirect_uris": "மீள்வழிப்படுத்தல் URIs",
    "Redirect URIs": "மீள்வழிப்படுத்தல் URIs",
    "developer.mcp.one_per_line": "(ஒவ்வொரு வரியிலும் ஒன்று)",
    "(one per line)": "(ஒவ்வொரு வரியிலும் ஒன்று)",
    "developer.mcp.permissions": "அனுமதிகள்",
    "Permissions": "அனுமதிகள்",
    "developer.mcp.error.connection_name": "இணைப்பு பெயரை உள்ளிடவும்",
    "Enter a connection name": "இணைப்பு பெயரை உள்ளிடவும்",
    "developer.mcp.error.redirect_uri": "குறைந்தது ஒரு மீள்வழிப்படுத்தல் URI உள்ளிடவும்",
    "Enter at least one redirect URI": "குறைந்தது ஒரு மீள்வழிப்படுத்தல் URI உள்ளிடவும்",
    "developer.mcp.error.create": "இணைப்பை உருவாக்க முடியவில்லை",
    "Failed to create connection": "இணைப்பை உருவாக்க முடியவில்லை",
    "developer.mcp.creating": "உருவாக்குகிறது…",
    "developer.mcp.edit_permissions": "அனுமதிகளை தொகுத்தல்",
    "Edit permissions": "அனுமதிகளை தொகுத்தல்",
    "developer.mcp.permissions_updated": "அனுமதிகள் புதுப்பிக்கப்பட்டன",
    "Permissions updated": "அனுமதிகள் புதுப்பிக்கப்பட்டன",
    "developer.mcp.error.update_permissions": "அனுமதிகளை புதுப்பிக்க முடியவில்லை",
    "Failed to update permissions": "அனுமதிகளை புதுப்பிக்க முடியவில்லை",
    "developer.mcp.saving": "சேமிக்கிறது…",
    "developer.mcp.error.load": "MCP இணைப்புகளை ஏற்ற முடியவில்லை.",
    "MCP connections could not be loaded.": "MCP இணைப்புகளை ஏற்ற முடியவில்லை.",
    "developer.mcp.confirm_delete": "இந்த இணைப்பை நீக்க வேண்டுமா? இது பட்டியலிலிருந்து நீக்கப்பட்டு, அதன் அணுகுமுறைகள் ரத்து செய்யப்படும்.",
    "Delete this connection? It will be removed from the list and its access revoked.": "இந்த இணைப்பை நீக்க வேண்டுமா? இது பட்டியலிலிருந்து நீக்கப்பட்டு, அதன் அணுகுமுறைகள் ரத்து செய்யப்படும்.",
    "developer.mcp.connection_removed": "இணைப்பு நீக்கப்பட்டது",
    "Connection removed": "இணைப்பு நீக்கப்பட்டது",
    "developer.mcp.error.remove_connection": "இணைப்பை நீக்க முடியவில்லை",
    "Failed to remove connection": "இணைப்பை நீக்க முடியவில்லை",
    "developer.mcp.connection_deactivated": "இணைப்பு முடக்கப்பட்டது",
    "Connection deactivated": "இணைப்பு முடக்கப்பட்டது",
    "developer.mcp.error.deactivate_connection": "இணைப்பை முடக்க முடியவில்லை",
    "Failed to deactivate connection": "இணைப்பை முடக்க முடியவில்லை",
    "developer.mcp.title": "MCP இணைப்புகள்",
    "MCP connections": "MCP இணைப்புகள்",
    "developer.mcp.description": "இந்த டெண்ட்-இன் MCP செர்வரைப் பயன்படுத்த அனுமதிக்கப்பட்டுள்ள டெண்ட்-ஆக பதிவு செய்யப்பட்ட OAuth வாடிக்கையாளர்கள் மற்றும் AI பயன்பாடுகள்.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "இந்த டெண்ட்-இன் MCP செர்வரைப் பயன்படுத்த அனுமதிக்கப்பட்டுள்ள டெண்ட்-ஆக பதிவு செய்யப்பட்ட OAuth வாடிக்கையாளர்கள் மற்றும் AI பயன்பாடுகள்.",
    "developer.mcp.empty": "இன்னும் எந்த இணைப்புகளும் இல்லை. இந்த டென்ட் இன்னின் MCP செர்வருக்கு ஒரு கிளயண்ட் அல்லது AI பயன்பாட்டை இணைக்கவும்.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "இன்னும் எந்த இணைப்புகளும் இல்லை. இந்த டென்ட் இன்னின் MCP செர்வருக்கு ஒரு கிளயண்ட் அல்லது AI பயன்பாட்டை இணைக்கவும்.",
    "developer.mcp.status.connected_one": "இணைக்கப்பட்டுள்ளது · 1 பயனர்",
    "Connected · 1 user": "இணைக்கப்பட்டுள்ளது · 1 பயனர்",
    "developer.mcp.status.connected_many": "இணைக்கப்பட்டுள்ளது · {count} பயனர்கள்",
    "Connected · {count} users": "இணைக்கப்பட்டுள்ளது · {count} பயனர்கள்",
    "developer.mcp.status.deactivated": "முடக்கப்பட்டுள்ளது",
    "Deactivated": "முடக்கப்பட்டுள்ளது",
    "developer.mcp.status.previously_connected": "முன்னர் இணைக்கப்பட்டது",
    "Previously connected": "முன்னர் இணைக்கப்பட்டது",
    "developer.mcp.status.registered": "பதிவு செய்யப்பட்டுள்ளது · இணைக்கப்படவில்லை",
    "Registered · not connected": "பதிவு செய்யப்பட்டுள்ளது · இணைக்கப்படவில்லை",
    "developer.mcp.oauth_app": "OAuth பயன்பாடு",
    "OAuth app": "OAuth பயன்பாடு",
    "developer.mcp.created": "உருவாக்கப்பட்டது",
    "developer.mcp.updated": "தொகுக்கப்பட்டது",
    "Updated": "தொகுக்கப்பட்டது",
    "developer.mcp.edit_scopes": "விரிவான பகுதிகளை தொகுக்கவும்",
    "Edit scopes": "விரிவான பகுதிகளை தொகுக்கவும்",
    "developer.mcp.edit_scopes_for": "{name}-க்கான விரிவான பகுதிகளை தொகுக்கவும்",
    "Edit scopes for {name}": "{name}-க்கான விரிவான பகுதிகளை தொகுக்கவும்",
    "developer.mcp.deactivate_hint": "முடக்கு (பட்டியலிடப்பட்டு பதிவு செய்யப்பட்டுள்ளது)",
    "Deactivate (keeps it listed and logged)": "முடக்கு (பட்டியலிடப்பட்டு பதிவு செய்யப்பட்டுள்ளது)",
    "developer.mcp.deactivate_named": "{name}-ஐ முடக்கவும்",
    "Deactivate {name}": "{name}-ஐ முடக்கவும்",
    "developer.mcp.delete_connection": "இணைப்பை நீக்கவும்",
    "Delete connection": "இணைப்பை நீக்கவும்",
    "developer.mcp.delete_named": "{name}-ஐ நீக்கவும்",
    "Delete {name}": "{name}-ஐ நீக்கவும்",
    "developer.mcp.resource.listings": "பட்டியல்கள்",
    "developer.mcp.resource.orders": "ஆர்டர்கள்",
    "developer.mcp.resource.users": "பயனர்கள்",
    "developer.mcp.resource.accounts": "கணக்குகள்",
    "developer.mcp.resource.categories": "வகைகள்",
    "developer.mcp.resource.attributes": "பண்புகள்",
    "developer.mcp.resource.analytics": "பகுப்பாய்வுகள்",
    "developer.mcp.resource.attribution": "பெயரிடுதல்",
    "Attribution": "பெயரிடுதல்",
    "developer.mcp.resource.rewards": "விருதுகள்",
    "developer.mcp.resource.layers": "அடுக்குகள் / CMS",
    "Layers / CMS": "அடுக்குகள் / CMS",
    "developer.mcp.resource.settings": "கடை அமைப்புகள்",
    "Store settings": "கடை அமைப்புகள்",
    "developer.mcp.resource.marketing": "மார்க்கெட்டிங்",
    "developer.mcp.resource.market_research": "சந்தை ஆராய்ச்சி",
    "Market research": "சந்தை ஆராய்ச்சி",
    "developer.mcp.resource.audiences": "மார்க்கெட்டிங் பொதுமக்கள்",
    "Marketing audiences": "மார்க்கெட்டிங் பொதுமக்கள்",
    "developer.mcp.resource.agents": "AI ஏஜென்ட்கள்",
    "developer.mcp.resource.assets": "கோப்புகள் பதிவேற்றம்",
    "File uploads": "கோப்புகள் பதிவேற்றம்",
    "developer.mcp.resource.workforce": "பணியாளர் பட்டியல்",
    "developer.mcp.resource.inventory": "கொள்முதல்",
    "developer.mcp.resource.memberships": "உறுப்பினர் உறுப்புகள்",
    "Memberships": "உறுப்பினர் உறுப்புகள்",
    "developer.mcp.resource.bundles": "பேக்கேஜ்கள்",
    "developer.mcp.resource.rentals": "வாடகை",
    "developer.mcp.resource.accounting": "கணக்குகள்",
    "developer.mcp.nav.label": "MCP பயணம்",
    "MCP navigation": "MCP பயணம்",
    "developer.mcp.nav.connections": "இணைப்புகள்",
    "Connections": "இணைப்புகள்",
    "developer.mcp.nav.logs": "பதிவுகள்",
    "Logs": "பதிவுகள்",
    "developer.mcp.unknown_provider": "தெரியாத வழங்குநர்",
    "Unknown provider": "தெரியாத வழங்குநர்",
    "developer.mcp.tenant_user": "குடியிருப்பு #{tenant} · பயனர் #{user}",
    "Tenant #{tenant} · User #{user}": "குடியிருப்பு #{tenant} · பயனர் #{user}",
    "developer.mcp.logs.title": "MCP பதிவுகள்",
    "MCP logs": "MCP பதிவுகள்",
    "developer.mcp.logs.heading": "ஏஜென்ட் சமீபத்திய செயல்பாடு",
    "Recent agent activity": "ஏஜென்ட் சமீபத்திய செயல்பாடு",
    "developer.mcp.logs.description": "இந்த குடியிருப்பின் MCP நிகழ்வுகளைக் காட்டுகிறது. செயல்பாடு காட்சி ஒவ்வொரு 15 விநாடிகளும் புதுப்பிக்கப்படுகிறது.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "இந்த குடியிருப்பின் MCP நிகழ்வுகளைக் காட்டுகிறது. செயல்பாடு காட்சி ஒவ்வொரு 15 விநாடிகளும் புதுப்பிக்கப்படுகிறது.",
    "developer.mcp.logs.error.audit": "MCP ஆடிட்டர் பதிவுகள் ஏற்றப்படவில்லை.",
    "MCP audit logs could not be loaded.": "MCP ஆடிட்டர் பதிவுகள் ஏற்றப்படவில்லை.",
    "developer.mcp.logs.error.load": "MCP பதிவுகள் ஏற்றப்படவில்லை.",
    "MCP logs could not be loaded.": "MCP பதிவுகள் ஏற்றப்படவில்லை.",
    "developer.mcp.logs.unknown_agent": "தெரியாத ஏஜென்ட்",
    "Unknown agent": "தெரியாத ஏஜென்ட்",
    "developer.mcp.logs.all_agents": "எல்லா ஏஜென்ட்களும்",
    "All agents": "எல்லா ஏஜென்ட்களும்",
    "developer.mcp.logs.updated": "{time} புதுப்பிக்கப்பட்டது",
    "Updated {time}": "{time} புதுப்பிக்கப்பட்டது",
    "developer.mcp.logs.loading": "MCP செயல்பாடு ஏற்றப்படுகிறது…",
    "Loading MCP activity…": "MCP செயல்பாடு ஏற்றப்படுகிறது…",
    "developer.mcp.logs.empty": "இந்த டெனன்ட்டிற்கு புதிய MCP நிகழ்வுகள் கிடைக்கவில்லை.",
    "No recent MCP events found for this tenant.": "இந்த டெனன்ட்டிற்கு புதிய MCP நிகழ்வுகள் கிடைக்கவில்லை.",
    "developer.mcp.logs.empty_agent": "இந்த டெனன்ட்டிற்கும் ஏஜென்ட்டிற்கும் புதிய MCP நிகழ்வுகள் கிடைக்கவில்லை.",
    "No recent MCP events found for this tenant and agent.": "இந்த டெனன்ட்டிற்கும் ஏஜென்ட்டிற்கும் புதிய MCP நிகழ்வுகள் கிடைக்கவில்லை.",
    "developer.mcp.logs.time": "நேரம்",
    "developer.mcp.logs.event": "நிகழ்வு",
    "developer.mcp.logs.tool": "கருவி",
    "developer.mcp.logs.agent": "ஏஜென்ட்",
    "Agent": "ஏஜென்ட்",
    "developer.mcp.logs.tenant_user": "டெனன்ட் / பயனர்",
    "Tenant / user": "டெனன்ட் / பயனர்",
    "developer.mcp.logs.scope": "விரிவான பகுதி",
    "Scope": "விரிவான பகுதி",
    "developer.mcp.logs.result": "முடிவு",
    "Result": "முடிவு",
    "developer.mcp.logs.duration": "நேரம்",
    "Duration": "நேரம்",
    "developer.mcp.logs.view_details": "{event} விவரங்களைப் பார்க்க",
    "View details for {event}": "{event} விவரங்களைப் பார்க்க",
    "developer.mcp.logs.tenant": "டெனன்ட் #{id}",
    "Tenant #{id}": "டெனன்ட் #{id}",
    "developer.mcp.logs.user": "பயனர் #{id}",
    "User #{id}": "பயனர் #{id}",
    "developer.mcp.logs.view_granted_scopes": "அனுமதிக்கப்பட்ட விரிவான பகுதிகளைப் பார்க்க",
    "View granted scopes": "அனுமதிக்கப்பட்ட விரிவான பகுதிகளைப் பார்க்க",
    "developer.mcp.logs.succeeded": "வெற்றி",
    "Succeeded": "வெற்றி",
    "developer.mcp.logs.failed": "தோல்வி",
    "developer.mcp.logs.duration_ms": "{count} மில்லிசெகண்ட்",
    "{count} ms": "{count} மில்லிசெகண்ட்",
    "developer.mcp.logs.details_title": "MCP நிகழ்வு விவரங்கள்",
    "MCP event details": "MCP நிகழ்வு விவரங்கள்",
    "developer.mcp.logs.required_scope": "தேவையான விரிவான பகுதி",
    "Required scope": "தேவையான விரிவான பகுதி",
    "developer.mcp.logs.granted_scopes": "அனுமதிக்கப்பட்ட விரிவான பகுதிகள்",
    "Granted scopes": "அனுமதிக்கப்பட்ட விரிவான பகுதிகள்",
    "developer.mcp.logs.event_generic": "பொதுவான நிகழ்வு",
    "developer.mcp.logs.event.tool_called": "கருவி அழைக்கப்பட்டது",
    "Tool called": "கருவி அழைக்கப்பட்டது",
    "developer.mcp.logs.event.connection_requested": "இணைப்பு கோரப்பட்டது",
    "Connection requested": "இணைப்பு கோரப்பட்டது",
    "developer.mcp.logs.event.connection_connected": "இணைப்பு ஏற்றுக்கொள்ளப்பட்டது",
    "Connection connected": "இணைப்பு ஏற்றுக்கொள்ளப்பட்டது",
    "developer.mcp.logs.event.connection_deactivated": "இணைப்பு முடக்கப்பட்டது",
    "developer.mcp.logs.event.connection_deleted": "இணைப்பு நீக்கப்பட்டது",
    "Connection deleted": "இணைப்பு நீக்கப்பட்டது",
    "developer.mcp.logs.event.permissions_updated": "அனுமதிகள் புதுப்பிக்கப்பட்டன",
    "common.status.label": "நிலை",
    "suppliers.title": "மூலாதாரங்கள்",
    "suppliers.search": "மூலாதாரங்களைத் தேடு",
    "Search suppliers": "மூலாதாரங்களைத் தேடு",
    "suppliers.add": "மூலாதாரத்தைச் சேர்க்கவும்",
    "Add supplier": "மூலாதாரத்தைச் சேர்க்கவும்",
    "suppliers.deactivate": "முடக்கு",
    "Deactivate": "முடக்கு",
    "suppliers.empty": "மூலாதாரங்கள் கிடைக்கவில்லை.",
    "No suppliers found.": "மூலாதாரங்கள் கிடைக்கவில்லை.",
    "suppliers.add_title": "மூலாதாரத்தைச் சேர்க்கவும்",
    "suppliers.edit_title": "மூலாதாரத்தைத் தொகுக்கவும்",
    "suppliers.save_changes": "மாற்றங்களைச் சேமி",
    "suppliers.confirm_deactivate": "{name}-ஐ முடக்க வேண்டுமா?",
    "Deactivate {name}?": "{name}-ஐ முடக்க வேண்டுமா?",
    "suppliers.toast.updated": "மூலாதாரம் புதுப்பிக்கப்பட்டது",
    "Supplier updated": "மூலாதாரம் புதுப்பிக்கப்பட்டது",
    "suppliers.toast.added": "மூலாதாரம் சேர்க்கப்பட்டது",
    "Supplier added": "மூலாதாரம் சேர்க்கப்பட்டது",
    "suppliers.toast.deactivated": "மூலாதாரம் முடக்கப்பட்டது",
    "Supplier deactivated": "மூலாதாரம் முடக்கப்பட்டது",
    "suppliers.column.name": "பெயர்",
    "suppliers.column.code": "குறியீடு",
    "suppliers.column.contact": "தொடர்பு",
    "Contact": "தொடர்பு",
    "suppliers.field.name": "பெயர்",
    "suppliers.field.code": "குறியீடு",
    "suppliers.field.contact_name": "தொடர்பு பெயர்",
    "Contact name": "தொடர்பு பெயர்",
    "suppliers.field.email": "மின்னஞ்சல்",
    "suppliers.field.phone": "தொலைபேசி",
    "suppliers.field.currency": "நாணயம்",
    "suppliers.field.payment_terms": "கட்டண விதிமுறைகள்",
    "Payment terms": "கட்டண விதிமுறைகள்",
    "suppliers.field.address": "முகவரி",
    "suppliers.field.note": "குறிப்பு",
    "Note": "குறிப்பு",
    "suppliers.placeholder.name": "நிறுவனம் அல்லது வழங்குநர் பெயர்",
    "Company or supplier name": "நிறுவனம் அல்லது வழங்குநர் பெயர்",
    "suppliers.placeholder.code": "வழங்குநர் குறியீடு",
    "Supplier code": "வழங்குநர் குறியீடு",
    "suppliers.placeholder.contact_name": "தொடர்பு பெயர்",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "கொடுக்கப்பட்ட கடைசி நாளில் கட்டணம்",
    "Cash on delivery": "கொடுக்கப்பட்ட கடைசி நாளில் கட்டணம்",
    "suppliers.payment_terms.payment_on_receipt": "பெறும் போது கட்டணம்",
    "Payment on receipt": "பெறும் போது கட்டணம்",
    "suppliers.payment_terms.payment_in_advance": "முன்கூட்டியே கட்டணம்",
    "Payment in advance": "முன்கூட்டியே கட்டணம்",
    "suppliers.payment_terms.net_7": "Net 7 நாட்கள்",
    "Net 7 days": "Net 7 நாட்கள்",
    "suppliers.payment_terms.net_15": "Net 15 நாட்கள்",
    "Net 15 days": "Net 15 நாட்கள்",
    "suppliers.payment_terms.net_30": "Net 30 நாட்கள்",
    "Net 30 days": "Net 30 நாட்கள்",
    "suppliers.payment_terms.net_45": "Net 45 நாட்கள்",
    "Net 45 days": "Net 45 நாட்கள்",
    "suppliers.payment_terms.net_60": "Net 60 நாட்கள்",
    "Net 60 days": "Net 60 நாட்கள்",
    "suppliers.detail_title": "வழங்குநர் விவரங்கள்",
    "Supplier details": "வழங்குநர் விவரங்கள்",
    "suppliers.edit": "வழங்குநரை தொகுத்தல்",
    "suppliers.back": "வழங்குநர்களுக்கு திரும்புதல்",
    "Back to suppliers": "வழங்குநர்களுக்கு திரும்புதல்",
    "suppliers.loading": "வழங்குநரை ஏற்றுகிறது…",
    "Loading supplier…": "வழங்குநரை ஏற்றுகிறது…",
    "suppliers.unnamed": "பெயரில்லாத வழங்குநர்",
    "Unnamed supplier": "பெயரில்லாத வழங்குநர்",
    "suppliers.profile_description": "முதலீட்டாளர் தொடர்பு விவரங்கள்",
    "Supplier profile and contact information": "முதலீட்டாளர் தொடர்பு விவரங்கள்",
    "suppliers.total_spend": "மொத்த செலவு",
    "Total spend": "மொத்த செலவு",
    "suppliers.outstanding": "தொகை காத்திருக்கிறது",
    "Outstanding": "தொகை காத்திருக்கிறது",
    "suppliers.paid": "செலுத்தப்பட்டது",
    "suppliers.draft": "மூலப்பொருள்",
    "suppliers.purchase_history": "வாங்கும் வரலாறு",
    "Purchase history": "வாங்கும் வரலாறு",
    "suppliers.bill.reference": "மேற்கோள்",
    "suppliers.bill.date": "தேதி",
    "suppliers.bill.amount": "தொகை",
    "suppliers.bill.number": "கணக்கெடுப்பு #{id}",
    "Bill #{id}": "கணக்கெடுப்பு #{id}",
    "suppliers.bills_empty": "இந்த முதலீட்டாளருக்கு கணக்கெடுப்புகள் கிடைக்கவில்லை.",
    "No bills found for this supplier.": "இந்த முதலீட்டாளருக்கு கணக்கெடுப்புகள் கிடைக்கவில்லை.",
    "inventory.locations.title": "இடங்கள்",
    "inventory.locations.add": "இடத்தை சேர்க்கவும்",
    "inventory.locations.description": "கொள்முதல் பொருட்களை வைத்திருக்கும் உள்ளீடுகள் மற்றும் கடைகள். கொள்முதல் ஆர்டர்கள் ஒரு இடத்தில் பெறப்படுகின்றன.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "கொள்முதல் பொருட்களை வைத்திருக்கும் உள்ளீடுகள் மற்றும் கடைகள். கொள்முதல் ஆர்டர்கள் ஒரு இடத்தில் பெறப்படுகின்றன.",
    "inventory.locations.field.name": "பெயர்",
    "inventory.locations.field.code": "குறியீடு",
    "inventory.locations.field.address": "முகவரி",
    "inventory.locations.field.linked_store": "இணைக்கப்பட்ட கடை (கூடுதல்)",
    "Linked store (optional)": "இணைக்கப்பட்ட கடை (கூடுதல்)",
    "inventory.locations.field.linked_store_short": "இணைக்கப்பட்ட கடை",
    "Linked store": "இணைக்கப்பட்ட கடை",
    "inventory.locations.placeholder.name": "முக்கிய உள்ளீடு",
    "Main warehouse": "முக்கிய உள்ளீடு",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "முகவரி அல்லது இடத்தைத் தேடவும்",
    "Search an address or place": "முகவரி அல்லது இடத்தைத் தேடவும்",
    "inventory.locations.placeholder.linked_store": "விற்பனையாளர் அல்லது கடை கணக்குகளைத் தேடவும்",
    "Search seller or store accounts": "விற்பனையாளர் அல்லது கடை கணக்குகளைத் தேடவும்",
    "inventory.locations.confirm_deactivate": "{name} ஐ நிறுத்த வேண்டுமா? புதிய கொள்முதல் ஆர்டர்களுக்கு இது கிடைக்காது.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "{name} ஐ நிறுத்த வேண்டுமா? புதிய கொள்முதல் ஆர்டர்களுக்கு இது கிடைக்காது.",
    "inventory.locations.toast.deactivated": "உள்ளிடம் முடக்கப்பட்டது",
    "Location deactivated": "உள்ளிடம் முடக்கப்பட்டது",
    "inventory.locations.deactivate": "முடக்கு",
    "inventory.locations.empty": "எந்த உள்ளிடங்களும் இல்லை. ஸ்டாக் பெற ஆரம்பிக்க, ஒரு கடை அல்லது சேமிப்பு மையத்தை சேர்க்கவும்.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "எந்த உள்ளிடங்களும் இல்லை. ஸ்டாக் பெற ஆரம்பிக்க, ஒரு கடை அல்லது சேமிப்பு மையத்தை சேர்க்கவும்.",
    "inventory.locations.edit_title": "உள்ளிடத்தை தொகுத்துக்கொள்ளுதல்",
    "Edit location": "உள்ளிடத்தை தொகுத்துக்கொள்ளுதல்",
    "inventory.locations.add_title": "உள்ளிடம் சேர்க்க",
    "inventory.locations.form_description": "இந்த உள்ளிடம் குறிப்பிட்ட விற்பனையாளருக்கு சேர்ந்ததாக இருந்தால் மட்டுமே கடை கணக்கை இணைக்கவும்.",
    "Link a store account only if this location belongs to a specific seller.": "இந்த உள்ளிடம் குறிப்பிட்ட விற்பனையாளருக்கு சேர்ந்ததாக இருந்தால் மட்டுமே கடை கணக்கை இணைக்கவும்.",
    "inventory.locations.save_changes": "மாற்றங்களை சேமி",
    "inventory.locations.toast.updated": "உள்ளிடம் புதுப்பிக்கப்பட்டது",
    "Location updated": "உள்ளிடம் புதுப்பிக்கப்பட்டது",
    "inventory.locations.toast.added": "உள்ளிடம் சேர்க்கப்பட்டது",
    "Location added": "உள்ளிடம் சேர்க்கப்பட்டது",
    "inventory.operations.title": "கொள்முதல் இயக்கங்கள்",
    "Inventory operations": "கொள்முதல் இயக்கங்கள்",
    "inventory.operations.tab.movements": "இயக்க வரலாறு",
    "Movement history": "இயக்க வரலாறு",
    "inventory.operations.tab.batches": "தொகுதிகள் மற்றும் காலாவதியாகும் தேதி",
    "Batches & expiry": "தொகுதிகள் மற்றும் காலாவதியாகும் தேதி",
    "inventory.operations.tab.transfers": "பரிமாற்ற உத்தரவுகள்",
    "Transfer orders": "பரிமாற்ற உத்தரவுகள்",
    "inventory.operations.tab.requisitions": "கோரிக்கைகள்",
    "Requisitions": "கோரிக்கைகள்",
    "inventory.operations.tab.receipts": "பெற்ற பொருட்கள்",
    "Goods received": "பெற்ற பொருட்கள்",
    "inventory.operations.description.movements": "ஒவ்வொரு பெறுதல், விற்பனை, பரிமாற்றம், திரும்பப் பெறுதல் மற்றும் திருத்தமும் ஒரு மாற்றாமையான பதிவு.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "ஒவ்வொரு பெறுதல், விற்பனை, பரிமாற்றம், திரும்பப் பெறுதல் மற்றும் திருத்தமும் ஒரு மாற்றாமையான பதிவு.",
    "inventory.operations.description.batches": "இங்கு ஸ்டாக் புத்தகத்தை மாற்றாமல் தொகுதிகள், காலாவதியாகும் தேதிகள், நிலை மற்றும் அலகுகளை கண்காணிக்கவும்.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "இங்கு ஸ்டாக் புத்தகத்தை மாற்றாமல் தொகுதிகள், காலாவதியாகும் தேதிகள், நிலை மற்றும் அலகுகளை கண்காணிக்கவும்.",
    "inventory.operations.description.transfers": "அனுப்புதல், பெறுதல் மற்றும் வேறுபாடுகளுக்கு எதிரான பாதுகாப்பான நிலை கண்காணிப்புடன் உள்ளிடங்களுக்கு இடையே ஸ்டாக்கை நகர்த்துங்கள்.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "அனுப்புதல், பெறுதல் மற்றும் வேறுபாடுகளுக்கு எதிரான பாதுகாப்பான நிலை கண்காணிப்புடன் உள்ளிடங்களுக்கு இடையே ஸ்டாக்கை நகர்த்துங்கள்.",
    "inventory.operations.description.requisitions": "ஸ்டாக் உள்ளீட்டு கோரிக்கைகளை மதிப்பீடு செய்யவும். ஒப்புதல் தானியங்கியாக பரிமாற்ற உத்தரவை உருவாக்கும்.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "ஸ்டாக் உள்ளீட்டு கோரிக்கைகளை மதிப்பீடு செய்யவும். ஒப்புதல் தானியங்கியாக பரிமாற்ற உத்தரவை உருவாக்கும்.",
    "inventory.operations.description.receipts": "பெறுதல் தொடர்பான திறந்த, பாதியான மற்றும் மூடப்பட்ட பணிகளை கண்காணிக்க உருவாக்கவும்.",
    "Create receipts and track open, partial, and closed receiving work.": "பெறுதல் தொடர்பான திறந்த, பாதியான மற்றும் மூடப்பட்ட பணிகளை கண்காணிக்க உருவாக்கவும்.",
    "inventory.operations.overview": "சுருக்கம்",
    "inventory.operations.new_transfer": "புதிய பரிமாற்றம்",
    "New transfer": "புதிய பரிமாற்றம்",
    "inventory.operations.new_requisition": "புதிய கோரிக்கை",
    "New requisition": "புதிய கோரிக்கை",
    "inventory.operations.new_receipt": "புதிய பெறுதல்",
    "New receipt": "புதிய பெறுதல்",
    "inventory.operations.search": "தேடு",
    "inventory.operations.search_view": "இந்த காட்சியில் தேடு",
    "Search this view": "இந்த காட்சியில் தேடு",
    "inventory.operations.search_products": "தயாரிப்புகளைத் தேடு",
    "Search products": "தயாரிப்புகளைத் தேடு",
    "inventory.operations.search_purchase_order": "வாங்கும் பணிகளைத் தேடு (தேர்வுக்குரியது)",
    "Search purchase orders (optional)": "வாங்கும் பணிகளைத் தேடு (தேர்வுக்குரியது)",
    "inventory.operations.listing_number": "பட்டியல் #{id}",
    "inventory.operations.location_number": "இடம் #{id}",
    "Location #{id}": "இடம் #{id}",
    "inventory.operations.no_sku": "SKU இல்லை",
    "No SKU": "SKU இல்லை",
    "inventory.operations.order_status": "நிலை: {status}",
    "Status: {status}": "நிலை: {status}",
    "inventory.operations.field.receiving_location": "பெறும் இடம்",
    "Receiving location": "பெறும் இடம்",
    "inventory.operations.field.purchase_order": "வாங்கும் பணி",
    "Purchase order": "வாங்கும் பணி",
    "inventory.operations.field.reference": "மூலம்",
    "inventory.operations.field.note": "குறிப்பு",
    "inventory.operations.field.from_location": "தொடக்க இடம்",
    "From location": "தொடக்க இடம்",
    "inventory.operations.field.supplying_location": "வழங்கும் இடம்",
    "Supplying location": "வழங்கும் இடம்",
    "inventory.operations.field.to_location": "இலக்கு இடம்",
    "To location": "இலக்கு இடம்",
    "inventory.operations.field.requesting_location": "கோரிக்கை இடம்",
    "Requesting location": "கோரிக்கை இடம்",
    "inventory.operations.field.product": "தயாரிப்பு",
    "Product": "தயாரிப்பு",
    "inventory.operations.field.quantity": "அளவு",
    "Quantity": "அளவு",
    "inventory.operations.field.location": "இடம்",
    "Location": "இடம்",
    "inventory.operations.placeholder.delivery_note": "மூலம் வழங்கும் குறிப்பு",
    "Supplier delivery note": "மூலம் வழங்கும் குறிப்பு",
    "inventory.operations.placeholder.receiving_note": "தேர்வுக்குரிய பெறும் குறிப்பு",
    "Optional receiving note": "தேர்வுக்குரிய பெறும் குறிப்பு",
    "inventory.operations.placeholder.transfer_reference": "பரிமாற்ற மூலம்",
    "Transfer reference": "பரிமாற்ற மூலம்",
    "inventory.operations.placeholder.request_reference": "கோரிக்கை மூலம்",
    "Request reference": "கோரிக்கை மூலம்",
    "inventory.operations.placeholder.context": "தேர்வுக்குரிய சூழ்நிலை",
    "Optional context": "தேர்வுக்குரிய சூழ்நிலை",
    "inventory.operations.create.transfer_title": "புதிய பரிமாற்ற உத்தரவு",
    "New transfer order": "புதிய பரிமாற்ற உத்தரவு",
    "inventory.operations.create.requisition_title": "புதிய கோரிக்கை",
    "inventory.operations.create.receipt_title": "புதிய பொருட்கள் பெறுதல்",
    "New goods receipt": "புதிய பொருட்கள் பெறுதல்",
    "inventory.operations.create.transfer_description": "இரண்டு இடங்களுக்கு இடையே ஸ்டாக்கை நகர்த்தவும்.",
    "Move stock between two locations.": "இரண்டு இடங்களுக்கு இடையே ஸ்டாக்கை நகர்த்தவும்.",
    "inventory.operations.create.requisition_description": "மற்றொரு இடத்திலிருந்து ஸ்டாக்கை கோருங்கள்.",
    "Request stock from another location.": "மற்றொரு இடத்திலிருந்து ஸ்டாக்கை கோருங்கள்.",
    "inventory.operations.create.receipt_description": "ஸ்கேன் செய்வதற்கு அல்லது பெட்டிகளைச் சேர்ப்பதற்கு முன் பெறுதலை உருவாக்கவும்.",
    "Create a receipt before scanning or adding boxes.": "ஸ்கேன் செய்வதற்கு அல்லது பெட்டிகளைச் சேர்ப்பதற்கு முன் பெறுதலை உருவாக்கவும்.",
    "inventory.operations.toast.transfer_created": "பரிமாற்ற உத்தரவு உருவாக்கப்பட்டது",
    "Transfer order created": "பரிமாற்ற உத்தரவு உருவாக்கப்பட்டது",
    "inventory.operations.toast.requisition_created": "கோரிக்கை உருவாக்கப்பட்டது",
    "Requisition created": "கோரிக்கை உருவாக்கப்பட்டது",
    "inventory.operations.toast.receipt_created": "பொருட்கள் பெறுதல் உருவாக்கப்பட்டது",
    "Goods receipt created": "பொருட்கள் பெறுதல் உருவாக்கப்பட்டது",
    "inventory.operations.toast.transfer_dispatched": "பரிமாற்றம் அனுப்பப்பட்டது",
    "Transfer dispatched": "பரிமாற்றம் அனுப்பப்பட்டது",
    "inventory.operations.toast.transfer_received": "பரிமாற்றம் பெறப்பட்டது",
    "Transfer received": "பரிமாற்றம் பெறப்பட்டது",
    "inventory.operations.toast.transfer_cancelled": "பரிமாற்றம் ரத்து செய்யப்பட்டது",
    "Transfer cancelled": "பரிமாற்றம் ரத்து செய்யப்பட்டது",
    "inventory.operations.toast.requisition_approved": "கோரிக்கை ஒப்புக்கொள்ளப்பட்டது",
    "Requisition approved": "கோரிக்கை ஒப்புக்கொள்ளப்பட்டது",
    "inventory.operations.toast.requisition_rejected": "கோரிக்கை நிராகரிக்கப்பட்டது",
    "Requisition rejected": "கோரிக்கை நிராகரிக்கப்பட்டது",
    "inventory.operations.action.dispatch": "அனுப்பு",
    "Dispatch": "அனுப்பு",
    "inventory.operations.action.receive": "பெறு",
    "Receive": "பெறு",
    "inventory.operations.action.approve": "ஒப்புக்கொள்",
    "inventory.operations.action.reject": "நிராகரி",
    "inventory.operations.column.when": "எப்போது",
    "When": "எப்போது",
    "inventory.operations.column.event": "நிகழ்வு",
    "inventory.operations.column.change": "மாற்றம்",
    "inventory.operations.column.after": "பிறகு",
    "After": "பிறகு",
    "inventory.operations.column.order": "ஆணை",
    "inventory.operations.column.route": "பாதை",
    "Route": "பாதை",
    "inventory.operations.column.lines": "கோடுகள்",
    "Lines": "கோடுகள்",
    "inventory.operations.column.expected": "எதிர்பார்க்கப்பட்ட",
    "inventory.operations.column.request": "கோரிக்கை",
    "Request": "கோரிக்கை",
    "inventory.operations.column.request_supply": "கோரிக்கை / வழங்குதல்",
    "Request / supply": "கோரிக்கை / வழங்குதல்",
    "inventory.operations.column.created": "உருவாக்கப்பட்ட",
    "inventory.operations.column.receipt": "பெறுதல்",
    "Receipt": "பெறுதல்",
    "inventory.operations.empty.movements": "இன்னும் ஸ்டாக் இயக்கங்கள் பதிவு செய்யப்படவில்லை.",
    "No stock movements recorded yet.": "இன்னும் ஸ்டாக் இயக்கங்கள் பதிவு செய்யப்படவில்லை.",
    "inventory.operations.empty.batches": "இன்னும் இன்வென்டரி லோட்டுகள் பதிவு செய்யப்படவில்லை.",
    "No inventory batches have been recorded yet.": "இன்னும் இன்வென்டரி லோட்டுகள் பதிவு செய்யப்படவில்லை.",
    "inventory.operations.empty.transfers": "இன்னும் பரிமாற்ற ஆர்டர்கள் இல்லை.",
    "No transfer orders yet.": "இன்னும் பரிமாற்ற ஆர்டர்கள் இல்லை.",
    "inventory.operations.empty.requisitions": "இன்னும் கோரிக்கைகள் இல்லை.",
    "No requisitions yet.": "இன்னும் கோரிக்கைகள் இல்லை.",
    "inventory.operations.empty.receipts": "இன்னும் பொருட்கள் பெறுதல் இல்லை.",
    "No goods receipts yet.": "இன்னும் பொருட்கள் பெறுதல் இல்லை.",
    "inventory.operations.batch.edit_title": "லோட்டை தொகுதி தொகுதி",
    "Edit batch": "லோட்டை தொகுதி தொகுதி",
    "inventory.operations.batch.edit_description": "லோட்டின் அளவு ஸ்டாக் திருத்தத்தின் மூலம் மாற்றப்படுகிறது; இந்த படிவம் அதன் அடையாளம் மற்றும் தொடர்பு புலங்களை மட்டுமே புதுப்பிக்கிறது.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "லோட்டின் அளவு ஸ்டாக் திருத்தத்தின் மூலம் மாற்றப்படுகிறது; இந்த படிவம் அதன் அடையாளம் மற்றும் தொடர்பு புலங்களை மட்டுமே புதுப்பிக்கிறது.",
    "inventory.operations.batch.save": "லோட்டை சேமி",
    "Save batch": "லோட்டை சேமி",
    "inventory.operations.batch.lot_number": "லோட் எண்",
    "Lot number": "லோட் எண்",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "முடிவு தேதி",
    "inventory.operations.batch.condition": "நிலை",
    "inventory.operations.batch.condition_placeholder": "நல்லது",
    "good": "நல்லது",
    "inventory.operations.batch.unit": "அளவு அலகு",
    "Unit of measure": "அளவு அலகு",
    "inventory.operations.batch.unit_placeholder": "பாக்ஸ், பீஸ், கிலோ",
    "box, piece, kg": "பாக்ஸ், பீஸ், கிலோ",
    "inventory.operations.batch.no_expiry": "முடிவில்லாத",
    "No expiry": "முடிவில்லாத",
    "inventory.operations.batch.updated": "லோட் புதுப்பிக்கப்பட்டது",
    "Batch updated": "லோட் புதுப்பிக்கப்பட்டது",
    "common.status.in_transit": "ஓட்டம் நிலையில்",
    "In transit": "ஓட்டம் நிலையில்",
    "common.status.pending": "நிலுவையில்",
    "common.status.approved": "ஒப்புக்கொள்ளப்பட்ட",
    "common.status.rejected": "நிராகரிக்கப்பட்ட",
    "common.status.cancelled": "ரத்துசெய்யப்பட்ட",
    "common.status.received": "பெறப்பட்ட",
    "common.status.sent": "அனுப்பப்பட்ட",
    "Sent": "அனுப்பப்பட்ட",
    "common.note": "குறிப்பு",
    "common.optional": "கூடுதல்",
    "common.error.generic": "ஒன்று தவறாக இருக்கிறது.",
    "Something went wrong.": "ஒன்று தவறாக இருக்கிறது.",
    "purchase_orders.title": "வாங்கும் பணிகள்",
    "purchase_orders.title_singular": "வாங்கும் பணி",
    "purchase_orders.tab.all": "எல்லாம்",
    "purchase_orders.tab.partial": "பாகமாக பெறப்பட்ட",
    "Partially received": "பாகமாக பெறப்பட்ட",
    "purchase_orders.create.new": "புதிய வாங்கும் பணி",
    "New purchase order": "புதிய வாங்கும் பணி",
    "purchase_orders.create.title": "புதிய வாங்கும் பணி",
    "purchase_orders.create.subtitle": "மூலப்படியாக சேமிக்கப்பட்டது. வழங்குநருடன் இருக்கும்போது அனுப்பப்பட்டதாகக் குறிப்பிடவும்.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "மூலப்படியாக சேமிக்கப்பட்டது. வழங்குநருடன் இருக்கும்போது அனுப்பப்பட்டதாகக் குறிப்பிடவும்.",
    "purchase_orders.create.submit": "மூலப்படியை உருவாக்கு",
    "Create draft": "மூலப்படியை உருவாக்கு",
    "purchase_orders.field.location": "பெறும் இடம்",
    "purchase_orders.field.supplier": "வழங்குநர்",
    "purchase_orders.field.reference": "வழங்குநர் முகவரி",
    "Supplier reference": "வழங்குநர் முகவரி",
    "purchase_orders.field.expected_delivery": "எதிர்பார்க்கப்படும் விநியோகம்",
    "Expected delivery": "எதிர்பார்க்கப்படும் விநியோகம்",
    "purchase_orders.field.products": "தயாரிப்புகள்",
    "Products": "தயாரிப்புகள்",
    "purchase_orders.select_location": "இடத்தைத் தேர்வுசெய்க",
    "Select location": "இடத்தைத் தேர்வுசெய்க",
    "purchase_orders.no_locations": "அமைக்கப்பட்ட இடங்கள் இல்லை",
    "No locations set up": "அமைக்கப்பட்ட இடங்கள் இல்லை",
    "purchase_orders.add_location": "முதலில் ஒரு இடத்தை சேர்க்கவும் →",
    "Add a location first →": "முதலில் ஒரு இடத்தை சேர்க்கவும் →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "எல்லா இடங்களும்",
    "purchase_orders.location_number": "இடம் #{id}",
    "purchase_orders.search_products": "சேர்க்க தயாரிப்புகளைத் தேடு",
    "Search products to add": "சேர்க்க தயாரிப்புகளைத் தேடு",
    "purchase_orders.in_stock": "கையில் உள்ளது: {count}",
    "In stock: {count}": "கையில் உள்ளது: {count}",
    "purchase_orders.column.order": "ஆர்டர்",
    "purchase_orders.column.product": "தயாரிப்பு",
    "purchase_orders.column.quantity": "அளவு",
    "purchase_orders.column.ordered": "ஆர்டர் செய்தது",
    "Ordered": "ஆர்டர் செய்தது",
    "purchase_orders.column.received": "பெறப்பட்டது",
    "purchase_orders.column.remaining": "தொடர்புடையது",
    "purchase_orders.column.unit_cost": "அலகு விலை",
    "Unit cost": "அலகு விலை",
    "purchase_orders.column.supplier": "மூலம்",
    "purchase_orders.column.location": "இடம்",
    "purchase_orders.column.progress": "பெறப்பட்டது",
    "purchase_orders.column.value": "மதிப்பு",
    "purchase_orders.column.expected": "எதிர்பார்க்கப்படுகிறது",
    "purchase_orders.column.status": "நிலை",
    "purchase_orders.action.mark_sent": "அனுப்பப்பட்டதாக குறிப்பிடு",
    "Mark as sent": "அனுப்பப்பட்டதாக குறிப்பிடு",
    "purchase_orders.action.receive": "பெறு",
    "purchase_orders.action.receive_stock": "ஸ்டாக்கை பெறு",
    "Receive stock": "ஸ்டாக்கை பெறு",
    "purchase_orders.action.cancel_order": "ஆர்டரை ரத்து செய்து",
    "Cancel order": "ஆர்டரை ரத்து செய்து",
    "purchase_orders.action.close_order": "முடிக்கும் ஆர்டர்",
    "Close order": "முடிக்கும் ஆர்டர்",
    "purchase_orders.receive.subtitle": "கிடைத்தவை உள்ளிடவும். உறுதிப்படுத்தும்போது பெறும் இடத்தில் ஸ்டாக் புதுப்பிக்கப்படும்.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "கிடைத்தவை உள்ளிடவும். உறுதிப்படுத்தும்போது பெறும் இடத்தில் ஸ்டாக் புதுப்பிக்கப்படும்.",
    "purchase_orders.receive.now": "இப்போது பெறு",
    "Receive now": "இப்போது பெறு",
    "purchase_orders.receive.confirm": "பெறுதலை உறுதிப்படுத்து",
    "Confirm receipt": "பெறுதலை உறுதிப்படுத்து",
    "purchase_orders.confirm.cancel": "இந்த வாங்கும் ஆர்டரை ரத்து செய்ய வேண்டுமா?",
    "Cancel this purchase order?": "இந்த வாங்கும் ஆர்டரை ரத்து செய்ய வேண்டுமா?",
    "purchase_orders.empty.all": "முன்பு வாங்கும் ஆர்டர்கள் இல்லை. ஸ்டாக்கை நிரப்ப ஒன்றை உருவாக்கவும்.",
    "No purchase orders yet. Create one to restock inventory.": "முன்பு வாங்கும் ஆர்டர்கள் இல்லை. ஸ்டாக்கை நிரப்ப ஒன்றை உருவாக்கவும்.",
    "purchase_orders.empty.filtered": "இந்த நிலையில் வாங்கும் ஆர்டர்கள் இல்லை.",
    "No purchase orders with this status.": "இந்த நிலையில் வாங்கும் ஆர்டர்கள் இல்லை.",
    "purchase_orders.error.location_required": "பெறும் இடத்தைத் தேர்வு செய்யவும்.",
    "Choose a receiving location.": "பெறும் இடத்தைத் தேர்வு செய்யவும்.",
    "purchase_orders.error.product_required": "குறைந்தது ஒரு பொருளைச் சேர்க்கவும்.",
    "Add at least one product.": "குறைந்தது ஒரு பொருளைச் சேர்க்கவும்.",
    "purchase_orders.error.quantity_positive": "ஒவ்வொரு அளவும் 0-க்கு மேலாக இருக்க வேண்டும்.",
    "Every quantity must be greater than 0.": "ஒவ்வொரு அளவும் 0-க்கு மேலாக இருக்க வேண்டும்.",
    "purchase_orders.error.receive_quantity": "குறைந்தது ஒரு பொருளுக்கு அளவை உள்ளிடவும்.",
    "Enter a quantity for at least one item.": "குறைந்தது ஒரு பொருளுக்கு அளவை உள்ளிடவும்.",
    "purchase_orders.toast.created": "வாங்கும் ஆர்டர் தொடக்க நிலையில் உருவாக்கப்பட்டது",
    "Purchase order created as draft": "வாங்கும் ஆர்டர் தொடக்க நிலையில் உருவாக்கப்பட்டது",
    "purchase_orders.toast.sent": "அனுப்பப்பட்டதாகக் குறிப்பிடப்பட்டது",
    "Marked as sent": "அனுப்பப்பட்டதாகக் குறிப்பிடப்பட்டது",
    "purchase_orders.toast.received": "ஸ்டாக் பெறப்பட்டது மற்றும் ஸ்டாக் புதுப்பிக்கப்பட்டது",
    "Stock received and inventory updated": "ஸ்டாக் பெறப்பட்டது மற்றும் ஸ்டாக் புதுப்பிக்கப்பட்டது",
    "purchase_orders.toast.cancelled": "வாங்கும் ஆர்டர் ரத்து செய்யப்பட்டது",
    "Purchase order cancelled": "வாங்கும் ஆர்டர் ரத்து செய்யப்பட்டது",
    "purchase_orders.toast.closed": "வாங்கும் ஆர்டர் மூடப்பட்டது",
    "Purchase order closed": "வாங்கும் ஆர்டர் மூடப்பட்டது",
    "schedule.title": "திட்டமிடல்",
    "schedule.view.month": "மாதம்",
    "Month": "மாதம்",
    "schedule.view.week": "வாரம்",
    "Week": "வாரம்",
    "schedule.view.day": "நாள்",
    "Day": "நாள்",
    "schedule.today": "இன்று",
    "Today": "இன்று",
    "schedule.order_number": "ஆர்டர் #{number}",
    "Order #{number}": "ஆர்டர் #{number}",
    "schedule.customer": "வாடிக்கையாளர்",
    "schedule.more_events": "+{count} மேலும்",
    "+{count} more": "+{count} மேலும்",
    "schedule.payment.paid": "பேமெண்ட்",
    "schedule.payment.pending": "நிலுவையில்",
    "schedule.payment.failed": "தோல்வி",
    "schedule.booking_details": "புகலிட விவரங்கள்",
    "Booking details": "புகலிட விவரங்கள்",
    "schedule.order_reference": "ஆர்டர் முகவரி",
    "schedule.amount": "தொகை",
    "schedule.start": "தொடக்கம்",
    "schedule.end": "முடிவு",
    "schedule.item_number": "பொருள் {number}",
    "Item {number}": "பொருள் {number}",
    "schedule.view_order": "முழு ஆர்டரைப் பார்க்க",
    "View full order": "முழு ஆர்டரைப் பார்க்க",
    "onboarding.greeting.morning": "காலை வணக்கம்",
    "Good morning": "காலை வணக்கம்",
    "onboarding.greeting.morning_named": "காலை வணக்கம் {name}",
    "Good morning {name}": "காலை வணக்கம் {name}",
    "onboarding.greeting.afternoon": "மதிய வணக்கம்",
    "Good afternoon": "மதிய வணக்கம்",
    "onboarding.greeting.afternoon_named": "மதிய வணக்கம் {name}",
    "Good afternoon {name}": "மதிய வணக்கம் {name}",
    "onboarding.greeting.evening": "இரவு வணக்கம்",
    "Good evening": "இரவு வணக்கம்",
    "onboarding.greeting.evening_named": "இரவு வணக்கம் {name}",
    "Good evening {name}": "இரவு வணக்கம் {name}",
    "onboarding.greeting.night": "வணக்கம்",
    "Hello": "வணக்கம்",
    "onboarding.greeting.night_named": "வணக்கம் {name}",
    "Hello {name}": "வணக்கம் {name}",
    "onboarding.encouragement": "நீங்கள் விரும்பும் தளத்தை உருவாக்குங்கள்.",
    "Build the platform you wish existed.": "நீங்கள் விரும்பும் தளத்தை உருவாக்குங்கள்.",
    "onboarding.plan.personalized": "தனிப்பயன் வெளியீட்டு திட்டம்",
    "Personalized launch plan": "தனிப்பயன் வெளியீட்டு திட்டம்",
    "onboarding.plan.label": "வெளியீட்டு திட்டம்",
    "Launch plan": "வெளியீட்டு திட்டம்",
    "onboarding.plan.refining": "உங்கள் பாதையை மேம்படுத்துகிறோம்…",
    "Refining your path…": "உங்கள் பாதையை மேம்படுத்துகிறோம்…",
    "onboarding.plan.getting_ready": "உங்கள் தனிப்பயன் திட்டம் தயாராக உள்ளது.",
    "Your personalized plan is getting ready.": "உங்கள் தனிப்பயன் திட்டம் தயாராக உள்ளது.",
    "onboarding.checklist.preview": "சரிபார்ப்பு பட்டியல் முன்னோட்டம்",
    "Checklist preview": "சரிபார்ப்பு பட்டியல் முன்னோட்டம்",
    "onboarding.workspace.live": "லைவ் வேலை இடம்",
    "Live workspace": "லைவ் வேலை இடம்",
    "onboarding.workspace.no_tenant": "லைவ் குடியிருப்பாளர் இணைக்கப்படவில்லை",
    "No live tenant connected": "லைவ் குடியிருப்பாளர் இணைக்கப்படவில்லை",
    "onboarding.workspace.domain_pending": "தொடர்பு காத்திருக்கிறது",
    "Domain pending": "தொடர்பு காத்திருக்கிறது",
    "onboarding.progress.summary": "{completed} {total} வெளியீட்டு செயல்பாடுகள் முடிக்கப்பட்டது",
    "{completed} of {total} launch actions done": "{completed} {total} வெளியீட்டு செயல்பாடுகள் முடிக்கப்பட்டது",
    "onboarding.progress.auto_detected": "{count} தானியங்கி கண்டறியப்பட்டது",
    "{count} auto-detected": "{count} தானியங்கி கண்டறியப்பட்டது",
    "onboarding.progress.auto_detected_short": "தானியங்கி கண்டறியப்பட்டது",
    "Auto-detected": "தானியங்கி கண்டறியப்பட்டது",
    "onboarding.progress.saving": "முன்னேற்றம் சேமிக்கப்படுகிறது…",
    "Saving progress…": "முன்னேற்றம் சேமிக்கப்படுகிறது…",
    "onboarding.progress.checking": "சரிபார்க்கப்படுகிறது…",
    "onboarding.progress.mark_done": "முடிக்கப்பட்டதாக குறிப்பிடு",
    "onboarding.progress.unlocked": "திறக்கப்பட்டது: {impact}",
    "Unlocked: {impact}": "திறக்கப்பட்டது: {impact}",
    "onboarding.next_task": "அடுத்த சிறந்த பணி",
    "Next best task": "அடுத்த சிறந்த பணி",
    "onboarding.upcoming.title": "அடுத்த பணிகள்",
    "Upcoming tasks": "அடுத்த பணிகள்",
    "onboarding.upcoming.summary_one": "{count} பணி தற்போதைய செயல்பாட்டிற்குப் பிறகு அமைக்கப்பட்டுள்ளது.",
    "{count} task queued after the current action.": "{count} பணி தற்போதைய செயல்பாட்டிற்குப் பிறகு அமைக்கப்பட்டுள்ளது.",
    "onboarding.upcoming.summary_other": "{count} பணிகள் தற்போதைய செயல்பாட்டிற்குப் பிறகு அமைக்கப்பட்டுள்ளன.",
    "{count} tasks queued after the current action.": "{count} பணிகள் தற்போதைய செயல்பாட்டிற்குப் பிறகு அமைக்கப்பட்டுள்ளன.",
    "onboarding.upcoming.hide": "பணிகளை மறை",
    "Hide tasks": "பணிகளை மறை",
    "onboarding.upcoming.view_all": "எல்லா பணிகளையும் பார்க்கவும்",
    "View all tasks": "எல்லா பணிகளையும் பார்க்கவும்",
    "onboarding.complete.title": "நல்ல தொடக்கம். உங்கள் அடிப்படை லைவ் உள்ளது.",
    "Great start. Your foundation is live.": "நல்ல தொடக்கம். உங்கள் அடிப்படை லைவ் உள்ளது.",
    "onboarding.complete.description": "மேம்பாட்டு தேவைகளான பிரமோஷன்கள் மற்றும் தகவல்களை திறக்க தொடரவும்.",
    "Keep going to unlock growth essentials like promotions and communications.": "மேம்பாட்டு தேவைகளான பிரமோஷன்கள் மற்றும் தகவல்களை திறக்க தொடரவும்.",
    "onboarding.full_checklist.title": "முழு பட்டியல்",
    "Full checklist": "முழு பட்டியல்",
    "onboarding.full_checklist.description": "அதே அனுபவத்தில் அமைப்பைத் தொடரவும்.",
    "Continue setup in the same experience.": "அதே அனுபவத்தில் அமைப்பைத் தொடரவும்.",
    "onboarding.full_checklist.back": "வெளியீட்டு பாதைக்கு திரும்பு",
    "Back to launch path": "வெளியீட்டு பாதைக்கு திரும்பு",
    "onboarding.completed.title": "முடிக்கப்பட்டது",
    "onboarding.completed.summary_one": "{count} பணி முடிக்கப்பட்டது",
    "{count} task completed": "{count} பணி முடிக்கப்பட்டது",
    "onboarding.completed.summary_other": "{count} பணிகள் முடிக்கப்பட்டன",
    "{count} tasks completed": "{count} பணிகள் முடிக்கப்பட்டன",
    "onboarding.completed.open_again": "மீண்டும் திறக்கவும்",
    "Open again": "மீண்டும் திறக்கவும்",
    "onboarding.plan.marketplace.eyebrow": "மார்க்கெட்பிளேஸ் வெளியீட்டு பாதை",
    "Marketplace launch path": "மார்க்கெட்பிளேஸ் வெளியீட்டு பாதை",
    "onboarding.plan.marketplace.title": "மார்க்கெட்பிளேஸை வெளியிடு",
    "Launch your marketplace": "மார்க்கெட்பிளேஸை வெளியிடு",
    "onboarding.plan.marketplace.title_named": "{project}-ஐ செயல்பாட்டு மார்க்கெட்பிளேஸாக மாற்று",
    "Turn {project} into a working marketplace": "{project}-ஐ செயல்பாட்டு மார்க்கெட்பிளேஸாக மாற்று",
    "onboarding.plan.marketplace.subtitle": "ஆன்லைன் தளத்தைத் திறந்து, முதல் பட்டியலை உருவாக்கி, வாங்குபவரின் பயணத்தை சோதி",
    "Open the live site create the first listing and test the buyer journey.": "ஆன்லைன் தளத்தைத் திறந்து, முதல் பட்டியலை உருவாக்கி, வாங்குபவரின் பயணத்தை சோதி",
    "onboarding.plan.marketplace.value_moment": "முதல் மதிப்பு நேரம்: ஒரு விற்பனையாளர் பதிவிட மற்றும் ஒரு வாங்குபவர் செயல்பட முடியும்.",
    "First value moment: a seller can publish and a buyer can act.": "முதல் மதிப்பு நேரம்: ஒரு விற்பனையாளர் பதிவிட மற்றும் ஒரு வாங்குபவர் செயல்பட முடியும்.",
    "onboarding.plan.marketplace.why_title": "என்ன காரணத்தால் அணிகள் இதை முடிக்கின்றனர்?",
    "onboarding.plan.marketplace.why_body": "உண்மையான வாங்குபவர் மற்றும் விற்பனையாளர் முடிவுகள் அடுத்த படிகளை பயனுள்ளதாகவும், முன்னேற்றத்தை தொடர்ந்து வைக்கின்றன.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "உண்மையான வாங்குபவர் மற்றும் விற்பனையாளர் முடிவுகள் அடுத்த படிகளை பயனுள்ளதாகவும், முன்னேற்றத்தை தொடர்ந்து வைக்கின்றன.",
    "onboarding.plan.store.eyebrow": "கடை வெளியீட்டு பாதை",
    "Store launch path": "கடை வெளியீட்டு பாதை",
    "onboarding.plan.store.title": "முதல் ஆர்டருக்கு கடையை தயார் செய்யுங்கள்",
    "Get your store ready for the first order": "முதல் ஆர்டருக்கு கடையை தயார் செய்யுங்கள்",
    "onboarding.plan.store.title_named": "{project}-ஐ முதல் ஆர்டருக்கு தயார் செய்யுங்கள்",
    "Make {project} ready for the first order": "{project}-ஐ முதல் ஆர்டருக்கு தயார் செய்யுங்கள்",
    "onboarding.plan.store.subtitle": "தயாரிப்பைச் சேர்த்து, கடையை பார்த்து, செலுத்துதல் அடிப்படைகளை முடிக்கவும்.",
    "Add a product check the storefront and complete checkout essentials.": "தயாரிப்பைச் சேர்த்து, கடையை பார்த்து, செலுத்துதல் அடிப்படைகளை முடிக்கவும்.",
    "onboarding.plan.store.value_moment": "முதல் மதிப்பு நேரம்: தயாரிப்பு தெரிகிறது மற்றும் செலுத்துதலை சோதிக்க முடியும்.",
    "First value moment: a product is visible and checkout can be tested.": "முதல் மதிப்பு நேரம்: தயாரிப்பு தெரிகிறது மற்றும் செலுத்துதலை சோதிக்க முடியும்.",
    "onboarding.plan.store.why_title": "என்ன காரணத்தால் அணிகள் இதை முடிக்கின்றனர்?",
    "onboarding.plan.store.why_body": "தயாரிப்பிலிருந்து செலுத்துதலுக்கு விரைவாக மாறி, கடை உண்மையானது போல் உணர்வதற்கும், முன்னேற்றம் ஊக்கமளிக்கும் வகையில் வைக்கவும்.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "தயாரிப்பிலிருந்து செலுத்துதலுக்கு விரைவாக மாறி, கடை உண்மையானது போல் உணர்வதற்கும், முன்னேற்றம் ஊக்கமளிக்கும் வகையில் வைக்கவும்.",
    "onboarding.plan.booking.eyebrow": "புகலிட வெளியீட்டு பாதை",
    "Booking launch path": "புகலிட வெளியீட்டு பாதை",
    "onboarding.plan.booking.title": "உங்கள் தளத்தை புகலிடமாக மாற்று",
    "Make your platform bookable": "உங்கள் தளத்தை புகலிடமாக மாற்று",
    "onboarding.plan.booking.title_named": "{project}-ஐ புகலிடமாக மாற்று",
    "Make {project} bookable": "{project}-ஐ புகலிடமாக மாற்று",
    "onboarding.plan.booking.subtitle": "முதல் சேவையை உருவாக்கி, வாடிக்கையாளர் அனுபவத்தைத் திறந்து, ஒரு புகலிடத்தை சோதி",
    "Create the first service open the customer experience and test a reservation.": "முதல் சேவையை உருவாக்கி, வாடிக்கையாளர் அனுபவத்தைத் திறந்து, ஒரு புகலிடத்தை சோதி",
    "onboarding.plan.booking.value_moment": "முதல் மதிப்பு நேரம்: ஒரு வாடிக்கையாளர் நேரம் அல்லது இடத்தை கோர முடியும்.",
    "First value moment: a customer can request a time or slot.": "முதல் மதிப்பு நேரம்: ஒரு வாடிக்கையாளர் நேரம் அல்லது இடத்தை கோர முடியும்.",
    "onboarding.plan.booking.why_title": "என்ன காரணத்தால் அணிகள் இதை முடிக்கின்றனர்?",
    "onboarding.plan.booking.why_body": "விரிவாக்கம் செய்வதற்கு முன் நம்பிக்கை கட்டுவதற்கு முழு புகலிட பயணத்தை ஆரம்பத்திலேயே சரிபார்க்கவும்.",
    "Validate the full booking journey early to build confidence before expanding.": "விரிவாக்கம் செய்வதற்கு முன் நம்பிக்கை கட்டுவதற்கு முழு புகலிட பயணத்தை ஆரம்பத்திலேயே சரிபார்க்கவும்.",
    "onboarding.plan.digital.eyebrow": "டிஜிட்டல் வெளியீட்டு பாதை",
    "Digital launch path": "டிஜிட்டல் வெளியீட்டு பாதை",
    "onboarding.plan.digital.title": "உங்கள் டிஜிட்டல் தயாரிப்புகளை விற்க தொடங்குங்கள்",
    "Start selling your digital products": "உங்கள் டிஜிட்டல் தயாரிப்புகளை விற்க தொடங்குங்கள்",
    "onboarding.plan.digital.title_named": "மென்பொருள் தயாரிப்புகளை விற்க {project} தயார் செய்யுங்கள்",
    "Make {project} ready to sell digital products": "மென்பொருள் தயாரிப்புகளை விற்க {project} தயார் செய்யுங்கள்",
    "onboarding.plan.digital.subtitle": "மென்பொருள் தயாரிப்பு முன்னோட்டத்தை ஏற்று, வாடிக்கையாளர் பாதையை சென்று, கட்டண தயாரிப்பை உறுதிப்படுத்துங்கள்.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "மென்பொருள் தயாரிப்பு முன்னோட்டத்தை ஏற்று, வாடிக்கையாளர் பாதையை சென்று, கட்டண தயாரிப்பை உறுதிப்படுத்துங்கள்.",
    "onboarding.plan.digital.value_moment": "முதல் மதிப்பு நேரம்: ஒரு வாங்குபவர் கோப்பை கண்டுபிடித்து வாங்க முடியும்.",
    "First value moment: a buyer can discover and purchase a file.": "முதல் மதிப்பு நேரம்: ஒரு வாங்குபவர் கோப்பை கண்டுபிடித்து வாங்க முடியும்.",
    "onboarding.plan.digital.why_title": "இதை முடிக்க குழுக்கள் ஏன் செய்கின்றனர்?",
    "onboarding.plan.digital.why_body": "கேட்டலையும் வாங்குதலையும் விரைவாக காட்டி, கேட்டலை விரிவாக்குவது வளர்ச்சியாக உணர்த்தும்.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "கேட்டலையும் வாங்குதலையும் விரைவாக காட்டி, கேட்டலை விரிவாக்குவது வளர்ச்சியாக உணர்த்தும்.",
    "onboarding.plan.campaign.eyebrow": "கூட்டு விளம்பரம் தொடங்கும் பாதை",
    "Campaign launch path": "கூட்டு விளம்பரம் தொடங்கும் பாதை",
    "onboarding.plan.campaign.title": "கூட்டு விளம்பர தளத்தை தொடங்குங்கள்",
    "Launch your campaign platform": "கூட்டு விளம்பர தளத்தை தொடங்குங்கள்",
    "onboarding.plan.campaign.title_named": "{project} ஐ ஆதரவாளர்களுக்கு தயார் செய்யுங்கள்",
    "Make {project} ready for supporters": "{project} ஐ ஆதரவாளர்களுக்கு தயார் செய்யுங்கள்",
    "onboarding.plan.campaign.subtitle": "கூட்டு விளம்பரத்தின் முன்னோட்டத்தை உருவாக்கி, பொது பக்கத்தை பார்த்து, ஆதரவு பாதையை சோதி.",
    "Create a campaign preview the public page and test the contribution journey.": "கூட்டு விளம்பரத்தின் முன்னோட்டத்தை உருவாக்கி, பொது பக்கத்தை பார்த்து, ஆதரவு பாதையை சோதி.",
    "onboarding.plan.campaign.value_moment": "முதல் மதிப்பு நேரம்: ஆதரவாளர் புரிந்து கொள்ள மற்றும் ஆதரிக்க முடியும்.",
    "First value moment: a supporter can understand and contribute.": "முதல் மதிப்பு நேரம்: ஆதரவாளர் புரிந்து கொள்ள மற்றும் ஆதரிக்க முடியும்.",
    "onboarding.plan.campaign.why_title": "இதை முடிக்க குழுக்கள் ஏன் செய்கின்றனர்?",
    "onboarding.plan.campaign.why_body": "ஆதரவாளர்கள் நம்பி செயல்பட முடியும் என்பதற்காக கதையையும் ஆதரவு பாதையையும் முதலிலேயே தெளிவுபடுத்துங்கள்.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "ஆதரவாளர்கள் நம்பி செயல்பட முடியும் என்பதற்காக கதையையும் ஆதரவு பாதையையும் முதலிலேயே தெளிவுபடுத்துங்கள்.",
    "onboarding.plan.creator.eyebrow": "உருவாக்குநர் தொடங்கும் பாதை",
    "Creator launch path": "உருவாக்குநர் தொடங்கும் பாதை",
    "onboarding.plan.creator.title": "முதல் பார்வையாளர்களுக்கு தயாராகுங்கள்",
    "Get ready for your first audience": "முதல் பார்வையாளர்களுக்கு தயாராகுங்கள்",
    "onboarding.plan.creator.title_named": "{project} ஐ முதல் பார்வையாளர்களுக்கு தயார் செய்யுங்கள்",
    "Make {project} ready for its first audience": "{project} ஐ முதல் பார்வையாளர்களுக்கு தயார் செய்யுங்கள்",
    "onboarding.plan.creator.subtitle": "தெளிவான அறிவிப்பை வெளியிட்டு, அனுபவத்தை வரையறுத்து, உங்கள் வேலையை எளிதில் கண்டுபிடித்து ஆதரிக்க முடியுமாக செய்யுங்கள்.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "தெளிவான அறிவிப்பை வெளியிட்டு, அனுபவத்தை வரையறுத்து, உங்கள் வேலையை எளிதில் கண்டுபிடித்து ஆதரிக்க முடியுமாக செய்யுங்கள்.",
    "onboarding.plan.creator.value_moment": "முதல் மதிப்பு நேரம்: உங்கள் வேலை தெரியும் மற்றும் பகிர தயாராக உள்ளது.",
    "First value moment: your work is visible and ready to share.": "முதல் மதிப்பு நேரம்: உங்கள் வேலை தெரியும் மற்றும் பகிர தயாராக உள்ளது.",
    "onboarding.plan.creator.why_title": "இது எவ்வாறு செயல்படுகிறது?",
    "Why this works": "இது எவ்வாறு செயல்படுகிறது?",
    "onboarding.plan.creator.why_body": "மேலும் கருவிகளை அல்லது சிக்கலை சேர்க்கும் முன் உண்மையான ஒன்றை வெளியிடுவதில் கவனம் செலுத்துங்கள்.",
    "Focus on publishing something real before adding more tools or complexity.": "மேலும் கருவிகளை அல்லது சிக்கலை சேர்க்கும் முன் உண்மையான ஒன்றை வெளியிடுவதில் கவனம் செலுத்துங்கள்.",
    "onboarding.step.open_live_site.title": "ஆன்லைன் அனுபவத்தைத் திறக்கவும்",
    "Open the live experience": "ஆன்லைன் அனுபவத்தைத் திறக்கவும்",
    "onboarding.step.open_live_site.description": "வாடிக்கையாளர்கள் பார்க்கும் விஷயத்திலிருந்து தொடங்குங்கள். இது அமைப்பு கற்பனையாக மாறும் முன் தயாரிப்பு உண்மையாக உணர்த்தும்.",
    "onboarding.step.open_live_site.description_domain": "{domain} ஐத் திறந்து வாடிக்கையாளர்கள் பார்க்கும் விஷயத்தைப் பாருங்கள். அடுத்த படிக்கு முன் கட்டுமானம் உண்மையாக உணர்த்தும்.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "{domain} ஐத் திறந்து வாடிக்கையாளர்கள் பார்க்கும் விஷயத்தைப் பாருங்கள். அடுத்த படிக்கு முன் கட்டுமானம் உண்மையாக உணர்த்தும்.",
    "onboarding.step.open_live_site.cta": "தளத்தைத் திறக்கவும்",
    "Open site": "தளத்தைத் திறக்கவும்",
    "onboarding.step.open_live_site.cta_domain": "{domain} ஐத் திறக்கவும்",
    "Open {domain}": "{domain} ஐத் திறக்கவும்",
    "onboarding.step.open_live_site.impact": "திட்டம் ஏற்கனவே ஆன்லைனில் உள்ளது என்பதை உறுதிப்படுத்துகிறது.",
    "Confirms the project is already live.": "திட்டம் ஏற்கனவே ஆன்லைனில் உள்ளது என்பதை உறுதிப்படுத்துகிறது.",
    "onboarding.step.create_supply_shape.title": "முதல் பிரிவை சேர்க்கவும்",
    "onboarding.step.create_supply_shape.description": "விற்பனையாளர்கள் மற்றும் வாங்குபவர்களுக்கு தொடங்க தெளிவான இடத்தை வழங்குக. பிரிவுகள் தேடலுக்கு அமைப்பை உருவாக்குகின்றன.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "விற்பனையாளர்கள் மற்றும் வாங்குபவர்களுக்கு தொடங்க தெளிவான இடத்தை வழங்குக. பிரிவுகள் தேடலுக்கு அமைப்பை உருவாக்குகின்றன.",
    "onboarding.step.create_supply_shape.cta": "பிரிவைச் சேர்க்கவும்",
    "onboarding.step.create_supply_shape.impact": "வெறும் சந்தையை தொடர்ச்சியாக தேடக்கூடியதாக மாற்றுகிறது.",
    "Turns a blank marketplace into a browsable one.": "வெறும் சந்தையை தொடர்ச்சியாக தேடக்கூடியதாக மாற்றுகிறது.",
    "onboarding.step.post_first_listing.title": "சோதனை பதிவு ஒன்றை வெளியிடவும்",
    "onboarding.step.post_first_listing.description": "விற்பனையாளர் பாதையை அனுபவித்து, வாங்குபவர்கள் பார்க்க முடியும் முதல் பொருளை வெளியிடவும்.",
    "Experience the seller path and publish the first item buyers can inspect.": "விற்பனையாளர் பாதையை அனுபவித்து, வாங்குபவர்கள் பார்க்க முடியும் முதல் பொருளை வெளியிடவும்.",
    "onboarding.step.post_first_listing.cta": "பதிவை வெளியிடவும்",
    "Post listing": "பதிவை வெளியிடவும்",
    "onboarding.step.post_first_listing.impact": "சந்தை செயல்பாட்டிற்கு முக்கிய நிகழ்வை உருவாக்குகிறது.",
    "Creates supply the core marketplace activation event.": "சந்தை செயல்பாட்டிற்கு முக்கிய நிகழ்வை உருவாக்குகிறது.",
    "onboarding.step.test_buyer_action.title": "வாங்குபவராக நடந்துகொள்ளவும்",
    "Act like a buyer": "வாங்குபவராக நடந்துகொள்ளவும்",
    "onboarding.step.test_buyer_action.description": "தேடுதல், ஆர்வம் சேர்த்து, ஆர்டர் பாதையை சோதித்து, வாடிக்கையாளர்கள் பார்க்கும் விஷயத்தை அனுபவிக்கவும்.",
    "Browse add interest and test the order path to experience what customers will see.": "தேடுதல், ஆர்வம் சேர்த்து, ஆர்டர் பாதையை சோதித்து, வாடிக்கையாளர்கள் பார்க்கும் விஷயத்தை அனுபவிக்கவும்.",
    "onboarding.step.test_buyer_action.cta": "வாங்குபவர் பாதையை சோதிக்கவும்",
    "Test buyer flow": "வாங்குபவர் பாதையை சோதிக்கவும்",
    "onboarding.step.test_buyer_action.impact": "முழு வாங்குபவர் பயணத்தை சரிபார்க்கிறது.",
    "Validates the buyer journey end to end.": "முழு வாங்குபவர் பயணத்தை சரிபார்க்கிறது.",
    "onboarding.step.add_first_product.title": "உண்மையான பொருளைச் சேர்க்கவும்",
    "Add one real product": "உண்மையான பொருளைச் சேர்க்கவும்",
    "onboarding.step.add_first_product.description": "ஒரு முழுமையான பொருள் அமைப்பை அமைப்பு வழியாக நீண்ட பயன்பாட்டை விட சிறந்த விதத்தில் கேட்டலோக் வடிவத்தை கற்பிக்கிறது.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "ஒரு முழுமையான பொருள் அமைப்பை அமைப்பு வழியாக நீண்ட பயன்பாட்டை விட சிறந்த விதத்தில் கேட்டலோக் வடிவத்தை கற்பிக்கிறது.",
    "onboarding.step.add_first_product.cta": "பொருளைச் சேர்க்கவும்",
    "Add product": "பொருளைச் சேர்க்கவும்",
    "onboarding.step.add_first_product.impact": "முதல் விற்பனையாகும் பொருளை உருவாக்குகிறது.",
    "Creates the first sellable item.": "முதல் விற்பனையாகும் பொருளை உருவாக்குகிறது.",
    "onboarding.step.setup_payments.title": "கட்டணங்களை இணைக்கவும்",
    "onboarding.step.setup_payments.description": "பயனர்கள் பிரச்சனையின்றி வாங்குதலை முடிக்க முடியும் என உண்மையான பரிமாற்றங்களை செயல்படுத்துகிறது.",
    "Enable real transactions so users can complete purchases without friction.": "பயனர்கள் பிரச்சனையின்றி வாங்குதலை முடிக்க முடியும் என உண்மையான பரிமாற்றங்களை செயல்படுத்துகிறது.",
    "onboarding.step.setup_payments.cta": "கட்டண அமைப்பை அமைக்கவும்",
    "onboarding.step.setup_payments.impact": "மூலதனத்திற்கு வழியைத் திறக்கிறது.",
    "onboarding.step.setup_delivery.title": "கிரிப்பு அல்லது சேவை முறையை அமைக்கவும்",
    "onboarding.step.setup_delivery.description": "வாடிக்கையாளர்களுக்கு செய்கிற செயல்முறையை முன்னறிவிப்பு செய்ய வேண்டும் என்பதை வரையறுக்கிறது.",
    "onboarding.step.setup_delivery.cta": "கிரிப்பை அமைக்கவும்",
    "Configure delivery": "கிரிப்பை அமைக்கவும்",
    "onboarding.step.setup_delivery.impact": "கொள்முதலில் நிறைவேற்றுதலை விளக்குகிறது.",
    "Makes fulfillment clear at checkout.": "கொள்முதலில் நிறைவேற்றுதலை விளக்குகிறது.",
    "onboarding.step.create_bookable_listing.title": "ஒரு புதிய பொருளை முன்பதிவு செய்ய உருவாக்கவும்",
    "Create one bookable offer": "ஒரு புதிய பொருளை முன்பதிவு செய்ய உருவாக்கவும்",
    "onboarding.step.create_bookable_listing.description": "வாடிக்கையாளர்கள் முதலில் முன்பதிவு செய்ய வேண்டிய சேவை நிகழ்வு, வாடகை அல்லது சந்திப்பை சேர்க்கவும்.",
    "Add the service event rental or appointment customers should book first.": "வாடிக்கையாளர்கள் முதலில் முன்பதிவு செய்ய வேண்டிய சேவை நிகழ்வு, வாடகை அல்லது சந்திப்பை சேர்க்கவும்.",
    "onboarding.step.create_bookable_listing.cta": "ஆஃபரை உருவாக்கு",
    "Create offer": "ஆஃபரை உருவாக்கு",
    "onboarding.step.create_bookable_listing.impact": "முதல் முன்பதிவு செய்யக்கூடிய அலகை உருவாக்குகிறது.",
    "Creates the first bookable unit.": "முதல் முன்பதிவு செய்யக்கூடிய அலகை உருவாக்குகிறது.",
    "onboarding.step.shape_details.title": "முன்பதிவு விவரங்களைச் சேர்க்கவும்",
    "Add booking details": "முன்பதிவு விவரங்களைச் சேர்க்கவும்",
    "onboarding.step.shape_details.description": "வாடிக்கையாளர்கள் உறுதியாக இருக்கும் முன் அவர்கள் தேவையானதை பிடிக்க வகைகள் மற்றும் புலங்களைப் பயன்படுத்தவும்.",
    "Use categories and fields to capture what customers need before they commit.": "வாடிக்கையாளர்கள் உறுதியாக இருக்கும் முன் அவர்கள் தேவையானதை பிடிக்க வகைகள் மற்றும் புலங்களைப் பயன்படுத்தவும்.",
    "onboarding.step.shape_details.cta": "புலங்களை அமைக்கவும்",
    "Set up fields": "புலங்களை அமைக்கவும்",
    "onboarding.step.shape_details.impact": "ஆஃபரை ஒப்பிடவும் நம்பவும் எளிதாக்குகிறது.",
    "Makes the offer easier to compare and trust.": "ஆஃபரை ஒப்பிடவும் நம்பவும் எளிதாக்குகிறது.",
    "onboarding.step.test_booking.title": "வாடிக்கையாளர் பாதையை சோதிக்கவும்",
    "Test the customer path": "வாடிக்கையாளர் பாதையை சோதிக்கவும்",
    "onboarding.step.test_booking.description": "பொது பாதையைத் திறந்து, வாடிக்கையாளர்கள் ஆர்வத்திலிருந்து செயல்பாட்டிற்கு மாற முடியுமா என்பதை சரிபார்க்கவும்.",
    "Open the public flow and verify customers can move from interest to action.": "பொது பாதையைத் திறந்து, வாடிக்கையாளர்கள் ஆர்வத்திலிருந்து செயல்பாட்டிற்கு மாற முடியுமா என்பதை சரிபார்க்கவும்.",
    "onboarding.step.test_booking.cta": "முன்பதிவை சோதிக்கவும்",
    "Test booking": "முன்பதிவை சோதிக்கவும்",
    "onboarding.step.test_booking.impact": "முன்பதிவு பயணத்தை சரிபார்க்கிறது.",
    "Validates the booking journey.": "முன்பதிவு பயணத்தை சரிபார்க்கிறது.",
    "onboarding.step.upload_digital_product.title": "ஒரு டிஜிட்டல் பொருளை பதிவேற்றவும்",
    "Upload one digital product": "ஒரு டிஜிட்டல் பொருளை பதிவேற்றவும்",
    "onboarding.step.upload_digital_product.description": "முதல் பதிவிறக்கக்கூடிய பொருளை முன்னோட்டம் மற்றும் விற்பனைக்கு போதுமான அளவு முழுமையாக செய்யவும்.",
    "Make the first downloadable item complete enough to preview and sell.": "முதல் பதிவிறக்கக்கூடிய பொருளை முன்னோட்டம் மற்றும் விற்பனைக்கு போதுமான அளவு முழுமையாக செய்யவும்.",
    "onboarding.step.upload_digital_product.cta": "டிஜிட்டல் பொருளைச் சேர்க்கவும்",
    "Add digital product": "டிஜிட்டல் பொருளைச் சேர்க்கவும்",
    "onboarding.step.upload_digital_product.impact": "உங்கள் முதல் விற்பனையாகும் டிஜிட்டல் செயல்பாட்டை உருவாக்குகிறது.",
    "Creates your first sellable digital asset.": "உங்கள் முதல் விற்பனையாகும் டிஜிட்டல் செயல்பாட்டை உருவாக்குகிறது.",
    "onboarding.step.test_purchase.title": "வாங்கும் பாதையை சோதிக்கவும்",
    "Test purchase flow": "வாங்கும் பாதையை சோதிக்கவும்",
    "onboarding.step.test_purchase.description": "வாங்குபவர்கள் கண்டறிவது முதல் காசோலை வரை என்ன பார்க்கிறார்கள் என்பதை முன்னோட்டம் காட்டுகிறது.",
    "Preview what buyers see from discovery through checkout.": "வாங்குபவர்கள் கண்டறிவது முதல் காசோலை வரை என்ன பார்க்கிறார்கள் என்பதை முன்னோட்டம் காட்டுகிறது.",
    "onboarding.step.test_purchase.cta": "காசோலையை சோதிக்கவும்",
    "Test checkout": "காசோலையை சோதிக்கவும்",
    "onboarding.step.test_purchase.impact": "வாங்குபவர் பயணத்தை உறுதிப்படுத்துகிறது.",
    "Confirms the buyer journey.": "வாங்குபவர் பயணத்தை உறுதிப்படுத்துகிறது.",
    "onboarding.step.create_campaign.title": "முதல் கூட்டுறவை உருவாக்கவும்",
    "Create the first campaign": "முதல் கூட்டுறவை உருவாக்கவும்",
    "onboarding.step.create_campaign.description": "ஆதரவாளர்கள் முதலில் புரிந்துகொள்ள வேண்டிய கூட்டுறவு அல்லது காரண பக்கத்தைச் சேர்க்கவும்.",
    "Add the campaign or cause page supporters should understand first.": "ஆதரவாளர்கள் முதலில் புரிந்துகொள்ள வேண்டிய கூட்டுறவு அல்லது காரண பக்கத்தைச் சேர்க்கவும்.",
    "onboarding.step.create_campaign.cta": "கூட்டுறவை உருவாக்கு",
    "Create campaign": "கூட்டுறவை உருவாக்கு",
    "onboarding.step.create_campaign.impact": "முதல் பொது செயல்பாட்டுக்கான காரணத்தை உருவாக்குகிறது.",
    "Creates the first public reason to act.": "முதல் பொது செயல்பாட்டுக்கான காரணத்தை உருவாக்குகிறது.",
    "onboarding.step.setup_payments_campaign.title": "கொடை பேமென்ட்ஸை இணைக்கவும்",
    "Connect contribution payments": "கொடை பேமென்ட்ஸை இணைக்கவும்",
    "onboarding.step.setup_payments_campaign.description": "ஒரு கொடையை முடிக்க முடியும் போது ஆதரவாளரின் தீர்மானம் முக்கியம்.",
    "Supporter intent matters when they can complete a contribution.": "ஒரு கொடையை முடிக்க முடியும் போது ஆதரவாளரின் தீர்மானம் முக்கியம்.",
    "onboarding.step.setup_payments_campaign.cta": "பேமென்ட்ஸை அமைக்கவும்",
    "onboarding.step.setup_payments_campaign.impact": "உண்மையான கொடைகளை செயல்படுத்துகிறது.",
    "Enables real contributions.": "உண்மையான கொடைகளை செயல்படுத்துகிறது.",
    "onboarding.step.test_supporter_flow.title": "ஆதரவாளர் பாதையை சோதிக்கவும்",
    "Test supporter flow": "ஆதரவாளர் பாதையை சோதிக்கவும்",
    "onboarding.step.test_supporter_flow.description": "பொது பயணத்தைத் திறந்து, கதை மற்றும் செயல்முறை தெளிவாக இருக்கிறதா என்பதை உறுதிப்படுத்தவும்.",
    "Open the public journey and make sure the story and action are clear.": "பொது பயணத்தைத் திறந்து, கதை மற்றும் செயல்முறை தெளிவாக இருக்கிறதா என்பதை உறுதிப்படுத்தவும்.",
    "onboarding.step.test_supporter_flow.cta": "பாதையை சோதிக்கவும்",
    "Test flow": "பாதையை சோதிக்கவும்",
    "onboarding.step.test_supporter_flow.impact": "பொது பாதையை சரிபார்க்கிறது.",
    "Validates the public path.": "பொது பாதையை சரிபார்க்கிறது.",
    "onboarding.step.set_account_categories.title": "மூலாதார கணக்கு வகைகளை அமைக்கவும்",
    "Define supplier account categories": "மூலாதார கணக்கு வகைகளை அமைக்கவும்",
    "onboarding.step.set_account_categories.description": "மூலாதார பயனர் செய்முறைகளை வகைகளில் பிரித்து, நம்பிக்கையையும் வாங்குபவர் நாட்டையும் மேம்படுத்தவும்.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "மூலாதார பயனர் செய்முறைகளை வகைகளில் பிரித்து, நம்பிக்கையையும் வாங்குபவர் நாட்டையும் மேம்படுத்தவும்.",
    "onboarding.step.set_account_categories.cta": "கணக்கு வகைகள்",
    "Account categories": "கணக்கு வகைகள்",
    "onboarding.step.set_account_categories.impact": "மூலாதார அமைப்பு நிலையானது.",
    "Supplier structure established.": "மூலாதார அமைப்பு நிலையானது.",
    "onboarding.step.set_account_attributes.title": "மூலாதார கணக்கு அம்சங்களைச் சேர்க்கவும்",
    "Add supplier profile attributes": "மூலாதார கணக்கு அம்சங்களைச் சேர்க்கவும்",
    "onboarding.step.set_account_attributes.description": "மூலாதாரரை தொடர்புகொள்ள அல்லது ஆர்டர் செய்ய முன் வாங்குபவர்களுக்கு தேவையான விவரங்களைப் பதிவு செய்கிறது.",
    "Capture details buyers need before contacting or ordering from suppliers.": "மூலாதாரரை தொடர்புகொள்ள அல்லது ஆர்டர் செய்ய முன் வாங்குபவர்களுக்கு தேவையான விவரங்களைப் பதிவு செய்கிறது.",
    "onboarding.step.set_account_attributes.cta": "மூலாதார அம்சங்கள்",
    "Supplier attributes": "மூலாதார அம்சங்கள்",
    "onboarding.step.set_account_attributes.impact": "வாங்குபவர் நம்பிக்கை அதிகரிக்கிறது.",
    "Higher buyer confidence.": "வாங்குபவர் நம்பிக்கை அதிகரிக்கிறது.",
    "onboarding.step.add_promotion.title": "லான்ச் பிரமோஷனைச் சேர்க்கவும்",
    "onboarding.step.add_promotion.description": "முதல் முறை வருகையில் செயல்பாட்டை ஊக்குவிக்க உங்கள் முதல் பிரமோஷனை உருவாக்கவும்.",
    "Create your first promotion to encourage action during the first visit.": "முதல் முறை வருகையில் செயல்பாட்டை ஊக்குவிக்க உங்கள் முதல் பிரமோஷனை உருவாக்கவும்.",
    "onboarding.step.add_promotion.cta": "பிரமோஷனைச் சேர்க்கவும்",
    "Add promotion": "பிரமோஷனைச் சேர்க்கவும்",
    "onboarding.step.add_promotion.impact": "லான்ச் மாற்றத்தை வலுப்படுத்துகிறது.",
    "Strengthens launch conversion.": "லான்ச் மாற்றத்தை வலுப்படுத்துகிறது.",
    "onboarding.step.create_coupon.title": "உங்கள் முதல் கூப்பனை உருவாக்கவும்",
    "Create your first coupon": "உங்கள் முதல் கூப்பனை உருவாக்கவும்",
    "onboarding.step.create_coupon.description": "முதல் வாங்குபவர்கள் அல்லது உறுப்பினர்களுக்கு தள்ளுபடி சோதிக்கவும்.",
    "Test discounts for first-time buyers or members.": "முதல் வாங்குபவர்கள் அல்லது உறுப்பினர்களுக்கு தள்ளுபடி சோதிக்கவும்.",
    "onboarding.step.create_coupon.cta": "கூப்பனை உருவாக்கவும்",
    "Create coupon": "கூப்பனை உருவாக்கவும்",
    "onboarding.step.create_coupon.impact": "உங்கள் முதல் முன்னெடுப்பு சுற்றுவித்தலை திறக்கிறது.",
    "Unlocks your first offer loop.": "உங்கள் முதல் முன்னெடுப்பு சுற்றுவித்தலை திறக்கிறது.",
    "onboarding.step.collections_setup.title": "கொள்முதல் பட்டியலை உருவாக்குதல்",
    "Create a collection": "கொள்முதல் பட்டியலை உருவாக்குதல்",
    "onboarding.step.collections_setup.description": "முக்கியமான பட்டியல்களை அமைத்து, தேடல் மற்றும் பார்வையிடுதலை மேம்படுத்துங்கள்.",
    "Organize important listings to improve discovery and browsing.": "முக்கியமான பட்டியல்களை அமைத்து, தேடல் மற்றும் பார்வையிடுதலை மேம்படுத்துங்கள்.",
    "onboarding.step.collections_setup.cta": "கொள்முதல் பட்டியலை உருவாக்குதல்",
    "Create collection": "கொள்முதல் பட்டியலை உருவாக்குதல்",
    "onboarding.step.collections_setup.impact": "நெடுவரை மற்றும் கண்டறிதலை மேம்படுத்துகிறது.",
    "Improves navigation and discovery.": "நெடுவரை மற்றும் கண்டறிதலை மேம்படுத்துகிறது.",
    "onboarding.step.configure_comms.title": "தொடர்பு மாதிரிகளை மேற்கோள் காட்டுதல்",
    "onboarding.step.configure_comms.description": "வளர்ச்சிக்கு முன் பதிவு மற்றும் ஆர்டர் அறிவிப்புகளை தயாரிக்கவும்.",
    "Prepare signup and order notifications before growth.": "வளர்ச்சிக்கு முன் பதிவு மற்றும் ஆர்டர் அறிவிப்புகளை தயாரிக்கவும்.",
    "onboarding.step.configure_comms.cta": "தொடர்புகளைத் திறக்கவும்",
    "Open communications": "தொடர்புகளைத் திறக்கவும்",
    "onboarding.step.configure_comms.impact": "வாடிக்கையாளர்களுடன் தொடர்புகளை தயாரிக்கிறது.",
    "Prepares customer communications.": "வாடிக்கையாளர்களுடன் தொடர்புகளை தயாரிக்கிறது.",
    "onboarding.step.customize_attributes.title": "பட்டியல் அம்சங்களைச் சேர்க்கவும்",
    "Add listing attributes": "பட்டியல் அம்சங்களைச் சேர்க்கவும்",
    "onboarding.step.customize_attributes.description": "பயனர்கள் முக்கியமானவற்றை தேர்வு செய்து ஒப்பிட முடியும் என அமைக்கப்பட்ட புலங்களைச் சேர்க்கவும்.",
    "onboarding.step.customize_attributes.cta": "அம்சங்களைச் சேர்க்கவும்",
    "Add attributes": "அம்சங்களைச் சேர்க்கவும்",
    "onboarding.step.customize_attributes.impact": "பட்டியல்களை ஒப்பிட எளிதாக்குகிறது.",
    "Makes listings easier to compare.": "பட்டியல்களை ஒப்பிட எளிதாக்குகிறது.",
    "onboarding.step.add_digital_asset.title": "மேலும் ஒரு டிஜிட்டல் பொருளைச் சேர்க்கவும்",
    "Add another digital item": "மேலும் ஒரு டிஜிட்டல் பொருளைச் சேர்க்கவும்",
    "onboarding.step.add_digital_asset.description": "பயனர்கள் தரம் மற்றும் வகைப்பாட்டை மதிப்பிட முடியும் என கத்தலாக்கத்தை விரிவாக்கவும்.",
    "Expand the catalog so users can evaluate quality and assortment.": "பயனர்கள் தரம் மற்றும் வகைப்பாட்டை மதிப்பிட முடியும் என கத்தலாக்கத்தை விரிவாக்கவும்.",
    "onboarding.step.add_digital_asset.cta": "டிஜிட்டல் பட்டியலைச் சேர்க்கவும்",
    "Add digital listing": "டிஜிட்டல் பட்டியலைச் சேர்க்கவும்",
    "onboarding.step.add_digital_asset.impact": "டிஜிட்டல் கத்தலாக்கத்தின் நம்பகத்தன்மையை மேம்படுத்துகிறது.",
    "Improves digital catalog credibility.": "டிஜிட்டல் கத்தலாக்கத்தின் நம்பகத்தன்மையை மேம்படுத்துகிறது.",
    "personal_assistant.title": "தனிப்பட்ட உதவியாளர்",
    "Personal assistant": "தனிப்பட்ட உதவியாளர்",
    "personal_assistant.heading": "உங்கள் தளத்தை ஒரு படியாக வளர்த்துக்கொள்ளுங்கள்",
    "Grow your platform one step at a time": "உங்கள் தளத்தை ஒரு படியாக வளர்த்துக்கொள்ளுங்கள்",
    "personal_assistant.subtitle": "{launchType} க்காக உருவாக்கப்பட்டது. தாக்கம் மற்றும் தயாரிப்பு அடிப்படையில் செயல்பாடுகளை முன்னுரிமை கொடுக்கிறோம்.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "{launchType} க்காக உருவாக்கப்பட்டது. தாக்கம் மற்றும் தயாரிப்பு அடிப்படையில் செயல்பாடுகளை முன்னுரிமை கொடுக்கிறோம்.",
    "personal_assistant.launch.store": "ஒரு கடை",
    "a store": "ஒரு கடை",
    "personal_assistant.launch.marketplace": "ஒரு சந்தை",
    "a marketplace": "ஒரு சந்தை",
    "personal_assistant.launch.booking": "ஒரு புதிய முன்னேற்ற தளம்",
    "a booking platform": "ஒரு புதிய முன்னேற்ற தளம்",
    "personal_assistant.launch.digital": "ஒரு டிஜிட்டல் வணிகம்",
    "a digital business": "ஒரு டிஜிட்டல் வணிகம்",
    "personal_assistant.launch.campaign": "கேம்பேயின் தளம்",
    "a campaign platform": "கேம்பேயின் தளம்",
    "personal_assistant.metric.tasks_completed": "முடிக்கப்பட்ட பணிகள்",
    "Tasks completed": "முடிக்கப்பட்ட பணிகள்",
    "personal_assistant.metric.recommendation_clicks": "பரிந்துரைகளுக்கான கிளிக்குகள்",
    "Recommendation clicks": "பரிந்துரைகளுக்கான கிளிக்குகள்",
    "personal_assistant.metric.completed_by_recommendation": "பரிந்துரைகள் மூலம் முடிக்கப்பட்டது",
    "Completed via recommendations": "பரிந்துரைகள் மூலம் முடிக்கப்பட்டது",
    "personal_assistant.metric.assist_rate": "ஆதரவு விகிதம்",
    "Assist rate": "ஆதரவு விகிதம்",
    "personal_assistant.personalizing": "உங்கள் பரிந்துரைகளை தனிப்பயனாக்குகிறோம்…",
    "Personalizing your recommendations…": "உங்கள் பரிந்துரைகளை தனிப்பயனாக்குகிறோம்…",
    "personal_assistant.do_this_now": "இப்போது செய்யவும்",
    "Do this now": "இப்போது செய்யவும்",
    "personal_assistant.estimated_time": "எதிர்பார்க்கப்படும் நேரம்: {minutes} நிமிடங்கள்",
    "Estimated time: {minutes} min": "எதிர்பார்க்கப்படும் நேரம்: {minutes} நிமிடங்கள்",
    "personal_assistant.minutes_short": "{minutes} நிமிடங்கள்",
    "{minutes} min": "{minutes} நிமிடங்கள்",
    "personal_assistant.open": "திறக்கவும்",
    "personal_assistant.mark_done": "முடிக்கப்பட்டதாகக் குறிக்கவும்",
    "personal_assistant.up_next": "அடுத்தது",
    "Up next": "அடுத்தது",
    "personal_assistant.coming_after": "இதற்குப் பிறகு வரும்",
    "Coming after this": "இதற்குப் பிறகு வரும்",
    "personal_assistant.completed_count": "முடிக்கப்பட்டது ({count})",
    "Completed ({count})": "முடிக்கப்பட்டது ({count})",
    "personal_assistant.hide": "மறைக்கவும்",
    "personal_assistant.show": "காட்டு",
    "Show": "காட்டு",
    "personal_assistant.feature.open_live_site.name": "ஆன்லைன் அனுபவத்தைத் திறக்கவும்",
    "personal_assistant.feature.open_live_site.outcome": "உங்கள் வாடிக்கையாளர்கள் ஆன்லைன் தளத்தை அணுக முடியும் என்பதை உறுதிப்படுத்துகிறீர்கள்.",
    "You confirm customers can reach the live platform.": "உங்கள் வாடிக்கையாளர்கள் ஆன்லைன் தளத்தை அணுக முடியும் என்பதை உறுதிப்படுத்துகிறீர்கள்.",
    "personal_assistant.feature.create_supply_shape.name": "முதல் வகையை உருவாக்கவும்",
    "personal_assistant.feature.create_supply_shape.outcome": "வாடிக்கையாளர்கள் தெளிவான அமைப்பில் தேடல் செய்யலாம்.",
    "Customers can browse with a clear structure.": "வாடிக்கையாளர்கள் தெளிவான அமைப்பில் தேடல் செய்யலாம்.",
    "personal_assistant.feature.post_first_listing.name": "சோதனை பிரசுரத்தை வெளியிடவும்",
    "personal_assistant.feature.post_first_listing.outcome": "தளம் தற்போது மதிப்பிட முதல் விற்பனை விவரங்களைக் கொண்டுள்ளது.",
    "The platform now has first supply to evaluate.": "தளம் தற்போது மதிப்பிட முதல் விற்பனை விவரங்களைக் கொண்டுள்ளது.",
    "personal_assistant.feature.test_buyer_action.name": "வாங்குபவராக நடந்துகொள்ளவும்",
    "personal_assistant.feature.test_buyer_action.outcome": "முழுமையான வாங்குபவர் அனுபவத்தை சரிபார்க்கிறீர்கள்.",
    "You validate buyer-side experience end to end.": "முழுமையான வாங்குபவர் அனுபவத்தை சரிபார்க்கிறீர்கள்.",
    "personal_assistant.feature.setup_payments.name": "பேமென்ட்ஸை இணைக்கவும்",
    "personal_assistant.feature.setup_payments.outcome": "ஆட்டோமேட்டிக் டிரான்ஸாக்ஷன்களை முடிக்க வாடிக்கையாளர்கள் முடியும்.",
    "Customers can complete real transactions.": "ஆட்டோமேட்டிக் டிரான்ஸாக்ஷன்களை முடிக்க வாடிக்கையாளர்கள் முடியும்.",
    "personal_assistant.feature.setup_delivery.name": "ஷிப்பிங் அல்லது சேவை முறையை அமைக்கவும்",
    "personal_assistant.feature.setup_delivery.outcome": "வாடிக்கையாளர்கள் ஃபுல்ஃபில்மென்ட்டை தெளிவாக புரிந்து கொள்ளலாம்.",
    "Customers can understand fulfillment clearly.": "வாடிக்கையாளர்கள் ஃபுல்ஃபில்மென்ட்டை தெளிவாக புரிந்து கொள்ளலாம்.",
    "personal_assistant.feature.add_promotion.name": "லான்ச் பிரமோஷனை சேர்க்கவும்",
    "personal_assistant.feature.add_promotion.outcome": "நீங்கள் முதல் கன்வெர்ஷன் ஈர்ப்பு உருவாக்குகிறீர்கள்.",
    "You create an early conversion incentive.": "நீங்கள் முதல் கன்வெர்ஷன் ஈர்ப்பு உருவாக்குகிறீர்கள்.",
    "personal_assistant.feature.configure_comms.name": "தொடர்பு மாதிரிகளை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.configure_comms.outcome": "பயனர்கள் வாழ்க்கை சுற்று முழுவதும் தெளிவான தகவல்களைப் பெறுகிறார்கள்.",
    "Users receive clear lifecycle communication.": "பயனர்கள் வாழ்க்கை சுற்று முழுவதும் தெளிவான தகவல்களைப் பெறுகிறார்கள்.",
    "personal_assistant.feature.view_orders.name": "ஆர்டர்களைத் திறக்கவும்",
    "Open orders": "ஆர்டர்களைத் திறக்கவும்",
    "personal_assistant.feature.view_orders.outcome": "நீங்கள் வரும் தேவையை கண்காணித்து செயல்படுத்த முடியும்.",
    "You can monitor and process incoming demand.": "நீங்கள் வரும் தேவையை கண்காணித்து செயல்படுத்த முடியும்.",
    "personal_assistant.feature.view_accounts.name": "கணக்குகளைத் திறக்கவும்",
    "Open accounts": "கணக்குகளைத் திறக்கவும்",
    "personal_assistant.feature.view_accounts.outcome": "நீங்கள் வழங்குநர்கள் அல்லது உறுப்பினர்களை திறமையாக மீண்டும் பார்க்க முடியும்.",
    "You can review suppliers or members efficiently.": "நீங்கள் வழங்குநர்கள் அல்லது உறுப்பினர்களை திறமையாக மீண்டும் பார்க்க முடியும்.",
    "personal_assistant.feature.configure_account_categories.name": "கணக்கு வகைகளை அமைக்கவும்",
    "Configure account categories": "கணக்கு வகைகளை அமைக்கவும்",
    "personal_assistant.feature.configure_account_categories.outcome": "வழங்குநர் மற்றும் உறுப்பினர் அமைப்பு சேர்க்கை மற்றும் நம்பிக்கைக்கு தெளிவாக இருக்கிறது.",
    "Supplier and member structure is clearer for onboarding and trust.": "வழங்குநர் மற்றும் உறுப்பினர் அமைப்பு சேர்க்கை மற்றும் நம்பிக்கைக்கு தெளிவாக இருக்கிறது.",
    "personal_assistant.feature.configure_account_attributes.name": "கணக்கு அம்சங்களை அமைக்கவும்",
    "Configure account attributes": "கணக்கு அம்சங்களை அமைக்கவும்",
    "personal_assistant.feature.configure_account_attributes.outcome": "பிரோஃபைல்கள் வாங்குபவர்களுக்கு முக்கியமான தகவல்களைப் பிடிக்கின்றன.",
    "Profiles capture decision-critical info for buyers.": "பிரோஃபைல்கள் வாங்குபவர்களுக்கு முக்கியமான தகவல்களைப் பிடிக்கின்றன.",
    "personal_assistant.feature.review_account_config.name": "கணக்கு அமைப்பை மீண்டும் பார்க்கவும்",
    "Review account configuration": "கணக்கு அமைப்பை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.review_account_config.outcome": "கணக்கு நடத்தை உங்கள் சந்தை கொள்கைக்கு ஏற்ப இருக்கிறது.",
    "Account behavior matches your marketplace policy.": "கணக்கு நடத்தை உங்கள் சந்தை கொள்கைக்கு ஏற்ப இருக்கிறது.",
    "personal_assistant.feature.view_listings.name": "லிஸ்டிங்கைத் திறக்கவும்",
    "Open listings": "லிஸ்டிங்கைத் திறக்கவும்",
    "personal_assistant.feature.view_listings.outcome": "நீங்கள் கத்தலாக் குறிப்புகளை மற்றும் தயாரிப்பை கண்காணிக்க முடியும்.",
    "You can monitor catalog quality and readiness.": "நீங்கள் கத்தலாக் குறிப்புகளை மற்றும் தயாரிப்பை கண்காணிக்க முடியும்.",
    "personal_assistant.feature.configure_listing_categories.name": "லிஸ்டிங் வகைகளை அமைக்கவும்",
    "Configure listing categories": "லிஸ்டிங் வகைகளை அமைக்கவும்",
    "personal_assistant.feature.configure_listing_categories.outcome": "கத்தலாக் குறிப்புகள் எளிதாக தேடப்படும் மற்றும் கண்டறியப்படும்.",
    "The catalog becomes easier to navigate and discover.": "கத்தலாக் குறிப்புகள் எளிதாக தேடப்படும் மற்றும் கண்டறியப்படும்.",
    "personal_assistant.feature.configure_listing_attributes.name": "லிஸ்டிங் அம்சங்களை அமைக்கவும்",
    "Configure listing attributes": "லிஸ்டிங் அம்சங்களை அமைக்கவும்",
    "personal_assistant.feature.configure_listing_attributes.outcome": "பயனர்கள் அமைக்கப்பட்ட விவரங்களுடன் லிஸ்டிங்கை ஒப்பிட முடியும்.",
    "Users can compare listings with structured details.": "பயனர்கள் அமைக்கப்பட்ட விவரங்களுடன் லிஸ்டிங்கை ஒப்பிட முடியும்.",
    "personal_assistant.feature.configure_variant_types.name": "வித்தியாச வகைகளை அமைக்கவும்",
    "Configure variant types": "வித்தியாச வகைகளை அமைக்கவும்",
    "personal_assistant.feature.configure_variant_types.outcome": "தயாரிப்பு மற்றும் சேவை வித்தியாசங்களை தெளிவாக ஆதரிக்கிறது.",
    "The catalog supports product and service variations clearly.": "தயாரிப்பு மற்றும் சேவை வித்தியாசங்களை தெளிவாக ஆதரிக்கிறது.",
    "personal_assistant.feature.review_listing_configs.name": "பட்டியலிடப்பட்ட கூடுதல் அம்சங்களை மீண்டும் பார்க்கவும்",
    "Review listing additional features": "பட்டியலிடப்பட்ட கூடுதல் அம்சங்களை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.review_listing_configs.outcome": "பட்டியலிடப்பட்ட நடத்தை உங்கள் இயக்க மாதிரியுடன் பொருந்துகிறது.",
    "Listing behavior matches your operating model.": "பட்டியலிடப்பட்ட நடத்தை உங்கள் இயக்க மாதிரியுடன் பொருந்துகிறது.",
    "personal_assistant.feature.manage_collections.name": "கூட்டுகளை மேலாண்மை செய்யவும்",
    "Manage collections": "கூட்டுகளை மேலாண்மை செய்யவும்",
    "personal_assistant.feature.manage_collections.outcome": "உயர் ஆர்வம் கொண்ட தேடல் பாதைகள் எளிதில் கண்டறியப்படுகின்றன.",
    "High-intent browsing paths are easier to discover.": "உயர் ஆர்வம் கொண்ட தேடல் பாதைகள் எளிதில் கண்டறியப்படுகின்றன.",
    "personal_assistant.feature.manage_coupons.name": "கூப்பன்களை மேலாண்மை செய்யவும்",
    "Manage coupons": "கூப்பன்களை மேலாண்மை செய்யவும்",
    "personal_assistant.feature.manage_coupons.outcome": "நேர்முகமான அறிவிப்புகளை செயல்படுத்த முடியும்.",
    "You can run targeted offers for activation.": "நேர்முகமான அறிவிப்புகளை செயல்படுத்த முடியும்.",
    "personal_assistant.feature.view_transactions.name": "மாற்றுகளைப் பார்க்கவும்",
    "View transactions": "மாற்றுகளைப் பார்க்கவும்",
    "personal_assistant.feature.view_transactions.outcome": "கட்டண செயல்பாடுகள் நம்பிக்கை மற்றும் இயக்கங்களுக்கு கண்காணிக்கப்படுகின்றன.",
    "Payment activity can be monitored for trust and operations.": "கட்டண செயல்பாடுகள் நம்பிக்கை மற்றும் இயக்கங்களுக்கு கண்காணிக்கப்படுகின்றன.",
    "personal_assistant.feature.view_users.name": "பயனர்களைத் திறக்கவும்",
    "Open users": "பயனர்களைத் திறக்கவும்",
    "personal_assistant.feature.view_users.outcome": "உங்கள் வாடிக்கையாளர் மற்றும் உறுப்பினர் வளர்ச்சியின் தரம் கண்காணிக்கப்படுகிறது.",
    "You can monitor customer and member growth quality.": "உங்கள் வாடிக்கையாளர் மற்றும் உறுப்பினர் வளர்ச்சியின் தரம் கண்காணிக்கப்படுகிறது.",
    "personal_assistant.feature.configure_user_attributes.name": "பயனர் அம்சங்களை அமைக்கவும்",
    "Configure user attributes": "பயனர் அம்சங்களை அமைக்கவும்",
    "personal_assistant.feature.configure_user_attributes.outcome": "பயனர் தரவுகளைப் பெற்று ஈடுபடுத்தலை மேம்படுத்த முடியும்.",
    "You can capture profile signals to improve engagement.": "பயனர் தரவுகளைப் பெற்று ஈடுபடுத்தலை மேம்படுத்த முடியும்.",
    "personal_assistant.feature.review_ratings.name": "மதிப்பீடுகள் மற்றும் மதிப்புரைகளை மீண்டும் பார்க்கவும்",
    "Review ratings and reviews": "மதிப்பீடுகள் மற்றும் மதிப்புரைகளை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.review_ratings.outcome": "நம்பிக்கை சின்னங்கள் கண்காணிக்கப்பட்டு மேம்படுத்தப்படுகின்றன.",
    "Trust signals are monitored and improved.": "நம்பிக்கை சின்னங்கள் கண்காணிக்கப்பட்டு மேம்படுத்தப்படுகின்றன.",
    "personal_assistant.feature.view_reports.name": "அறிக்கைகளைத் திறக்கவும்",
    "Open reports": "அறிக்கைகளைத் திறக்கவும்",
    "personal_assistant.feature.view_reports.outcome": "தரவு காட்சியுடன் செயல்திறனை கண்காணிக்க முடியும்.",
    "You can track performance with a data view.": "தரவு காட்சியுடன் செயல்திறனை கண்காணிக்க முடியும்.",
    "personal_assistant.feature.manage_media.name": "ஊடக நூலகத்தை மேலாண்மை செய்யவும்",
    "Manage media library": "ஊடக நூலகத்தை மேலாண்மை செய்யவும்",
    "personal_assistant.feature.manage_media.outcome": "பிராண்ட் மற்றும் பட்டியல் காட்சிகள் எளிதில் பராமரிக்கப்படுகின்றன.",
    "Brand and listing visuals are easier to maintain.": "பிராண்ட் மற்றும் பட்டியல் காட்சிகள் எளிதில் பராமரிக்கப்படுகின்றன.",
    "personal_assistant.feature.manage_reported_listings.name": "அறிக்கை செய்யப்பட்ட பட்டியல்களை மீண்டும் பார்க்கவும்",
    "Review reported listings": "அறிக்கை செய்யப்பட்ட பட்டியல்களை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.manage_reported_listings.outcome": "ஆபத்தான அல்லது குறைந்த தரமான உள்ளடக்கம் விரைவாக மேலாண்மை செய்யப்படுகிறது.",
    "Risky or low-quality content can be handled quickly.": "ஆபத்தான அல்லது குறைந்த தரமான உள்ளடக்கம் விரைவாக மேலாண்மை செய்யப்படுகிறது.",
    "personal_assistant.feature.app_customization.name": "ஆப் அனுபவத்தை தனிப்பயனாக்கவும்",
    "Customize app experience": "ஆப் அனுபவத்தை தனிப்பயனாக்கவும்",
    "personal_assistant.feature.app_customization.outcome": "மொபைல் ஆப் அனுபவம் உங்கள் பிராண்டுடன் பொருந்துகிறது.",
    "The mobile app experience aligns with your brand.": "மொபைல் ஆப் அனுபவம் உங்கள் பிராண்டுடன் பொருந்துகிறது.",
    "personal_assistant.feature.app_integrations.name": "ஆப்பிளிகேஷன் ஒத்திசைவுகளை அமைக்கவும்",
    "Configure app integrations": "ஆப்பிளிகேஷன் ஒத்திசைவுகளை அமைக்கவும்",
    "personal_assistant.feature.app_integrations.outcome": "முக்கிய தள சேவைகள் ஆப்பிளிகேஷன் வேலை ஓட்டங்களுடன் இணைக்கப்பட்டுள்ளன.",
    "Core platform services connect with app workflows.": "முக்கிய தள சேவைகள் ஆப்பிளிகேஷன் வேலை ஓட்டங்களுடன் இணைக்கப்பட்டுள்ளன.",
    "personal_assistant.feature.customize_strings.name": "இடைமுக உரையை தனிப்பயனாக்குதல்",
    "Customize interface text": "இடைமுக உரையை தனிப்பயனாக்குதல்",
    "personal_assistant.feature.customize_strings.outcome": "தயாரிப்பு உரை உங்கள் பார்வையாளர் மற்றும் குரலுக்கு ஏற்ப உள்ளது.",
    "Product copy matches your audience and tone.": "தயாரிப்பு உரை உங்கள் பார்வையாளர் மற்றும் குரலுக்கு ஏற்ப உள்ளது.",
    "personal_assistant.feature.review_settings_home.name": "அமைப்பைத் திறக்கவும்",
    "Open settings": "அமைப்பைத் திறக்கவும்",
    "personal_assistant.feature.review_settings_home.outcome": "குழு இயக்கங்களுக்கு அமைப்பு எளிதில் காணலாம்.",
    "Configuration is easy to find for team operations.": "குழு இயக்கங்களுக்கு அமைப்பு எளிதில் காணலாம்.",
    "personal_assistant.feature.configure_commission.name": "கமிஷனை அமைக்கவும்",
    "Configure commission": "கமிஷனை அமைக்கவும்",
    "personal_assistant.feature.configure_commission.outcome": "வருமான பகிர்வு உங்கள் வணிக மாதிரிக்கு ஏற்ப உள்ளது.",
    "Revenue sharing aligns with your business model.": "வருமான பகிர்வு உங்கள் வணிக மாதிரிக்கு ஏற்ப உள்ளது.",
    "personal_assistant.feature.configure_taxes.name": "வரி அமைப்பு",
    "Configure taxes": "வரி அமைப்பு",
    "personal_assistant.feature.configure_taxes.outcome": "கேஷ் ஆஃப் விலை முன்னறிவிப்புடன் உள்ளது மற்றும் வரி அமைப்புகள் தயாராக உள்ளன.",
    "Checkout pricing is predictable and tax settings are ready.": "கேஷ் ஆஃப் விலை முன்னறிவிப்புடன் உள்ளது மற்றும் வரி அமைப்புகள் தயாராக உள்ளன.",
    "personal_assistant.feature.configure_languages.name": "மொழிகளை அமைக்கவும்",
    "Configure languages": "மொழிகளை அமைக்கவும்",
    "personal_assistant.feature.configure_languages.outcome": "அனைத்து மொழிகளையும் ஆதரிக்கும் அனுபவம்.",
    "The experience supports a multilingual audience.": "அனைத்து மொழிகளையும் ஆதரிக்கும் அனுபவம்.",
    "personal_assistant.feature.configure_currency.name": "முதலீட்டு அமைப்பு",
    "Configure currency": "முதலீட்டு அமைப்பு",
    "personal_assistant.feature.configure_currency.outcome": "விலைகள் உங்கள் இலக்க சந்தையின் எதிர்பார்ப்புகளுக்கு ஏற்ப உள்ளன.",
    "Prices align with the expectations of your target market.": "விலைகள் உங்கள் இலக்க சந்தையின் எதிர்பார்ப்புகளுக்கு ஏற்ப உள்ளன.",
    "personal_assistant.feature.configure_countries.name": "நாடுகளை அமைக்கவும்",
    "Configure countries": "நாடுகளை அமைக்கவும்",
    "personal_assistant.feature.configure_countries.outcome": "வெளியீட்டிற்கு பிராந்திய பரவல் கட்டுப்படுத்தப்பட்டுள்ளது.",
    "Geographic coverage is controlled for launch.": "வெளியீட்டிற்கு பிராந்திய பரவல் கட்டுப்படுத்தப்பட்டுள்ளது.",
    "personal_assistant.feature.review_checkout_settings.name": "கேஷ் ஆஃப் அமைப்பை மீண்டும் பார்க்கவும்",
    "Review checkout settings": "கேஷ் ஆஃப் அமைப்பை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.review_checkout_settings.outcome": "கேஷ் ஆஃப் சுத்தமானது மற்றும் நம்பகமானது.",
    "Checkout is cleaner and more reliable.": "கேஷ் ஆஃப் சுத்தமானது மற்றும் நம்பகமானது.",
    "personal_assistant.feature.api_configuration.name": "API அமைப்பை மீண்டும் பார்க்கவும்",
    "Review API configuration": "API அமைப்பை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.api_configuration.outcome": "ஒத்திசைவுகள் மற்றும் மேம்படுத்துதல் அணுகல் தயாராக உள்ளது.",
    "Integrations and developer access are ready.": "ஒத்திசைவுகள் மற்றும் மேம்படுத்துதல் அணுகல் தயாராக உள்ளது.",
    "personal_assistant.feature.workspace_website_editor.name": "வலைத்தள எடிட்டரைத் திறக்கவும்",
    "Open website editor": "வலைத்தள எடிட்டரைத் திறக்கவும்",
    "personal_assistant.feature.workspace_website_editor.outcome": "காட்சி மாற்றத்திற்கு மேம்படுத்தப்படலாம்.",
    "The storefront can be refined for conversion.": "காட்சி மாற்றத்திற்கு மேம்படுத்தப்படலாம்.",
    "personal_assistant.feature.workspace_domain_setup.name": "டொமைன் அமைப்பை மீண்டும் பார்க்கவும்",
    "Review domain setup": "டொமைன் அமைப்பை மீண்டும் பார்க்கவும்",
    "personal_assistant.feature.workspace_domain_setup.outcome": "சுத்தமான டொமைன் பிராண்ட் நம்பகத்தன்மையை மேம்படுத்துகிறது.",
    "A clean domain improves brand trust.": "சுத்தமான டொமைன் பிராண்ட் நம்பகத்தன்மையை மேம்படுத்துகிறது.",
    "personal_assistant.feature.workspace_pages.name": "தள பக்கங்களை மேம்படுத்து",
    "Review site pages": "தள பக்கங்களை மேம்படுத்து",
    "personal_assistant.feature.workspace_pages.outcome": "பயனர் நம்பிக்கையை ஆதரிக்கும் முக்கிய வலைத்தள மற்றும் உள்ளடக்க பக்கங்கள்.",
    "Core landing and content pages support user trust.": "பயனர் நம்பிக்கையை ஆதரிக்கும் முக்கிய வலைத்தள மற்றும் உள்ளடக்க பக்கங்கள்.",
    "reports.title": "அறிக்கைகள்",
    "reports.metric.0": "பயனர்கள்",
    "reports.metric.1": "கணக்குகள்",
    "reports.metric.2": "பட்டியல்கள்",
    "reports.metric.3": "விற்ற பட்டியல்கள்",
    "Listings Sold": "விற்ற பட்டியல்கள்",
    "reports.metric.4": "மொத்த விற்பனை",
    "Total Sales": "மொத்த விற்பனை",
    "reports.metric.5": "மொத்த ஆர்டர்கள்",
    "reports.metric.6": "மொத்த வருமானம்",
    "Total Earnings": "மொத்த வருமானம்",
    "reports.chart.activity": "தினசரி சந்தை செயல்பாடு",
    "Daily marketplace activity": "தினசரி சந்தை செயல்பாடு",
    "reports.chart.activity_description": "நேரத்தின் படி பட்டியல்கள் மற்றும் புதிய பயனர்கள்",
    "Listings and new users over time": "நேரத்தின் படி பட்டியல்கள் மற்றும் புதிய பயனர்கள்",
    "reports.chart.listings_monthly": "மாதாந்திர பட்டியல்கள்",
    "Listings monthly": "மாதாந்திர பட்டியல்கள்",
    "reports.chart.listings_daily": "தினசரி பட்டியல்கள்",
    "Listings daily": "தினசரி பட்டியல்கள்",
    "reports.chart.users_daily": "தினசரி பயனர்கள்",
    "Users daily": "தினசரி பயனர்கள்",
    "reports.chart.users_monthly": "மாதாந்திர பயனர்கள்",
    "Users monthly": "மாதாந்திர பயனர்கள்",
    "reports.series.listings": "பட்டியல்கள்",
    "reports.series.new_users": "புதிய பயனர்கள்",
    "New users": "புதிய பயனர்கள்",
    "reports.top_sold_listings": "அதிகம் விற்ற பட்டியல்கள்",
    "Top sold listings": "அதிகம் விற்ற பட்டியல்கள்",
    "reports.view_more_insights": "மேலும் தகவல்களைப் பார்க்க",
    "View more insights": "மேலும் தகவல்களைப் பார்க்க",
    "reports.ai.title": "AI பயன்பாட்டு விற்பனை அறிக்கைகள்",
    "AI sales reports": "AI பயன்பாட்டு விற்பனை அறிக்கைகள்",
    "reports.ai.generating": "அறிக்கைகளை உருவாக்குகிறது…",
    "Generating reports…": "அறிக்கைகளை உருவாக்குகிறது…",
    "reports.ai.value": "மதிப்பு",
    "reports.ai.more_info": "{label} பற்றிய மேலும் தகவல்கள்",
    "More information about {label}": "{label} பற்றிய மேலும் தகவல்கள்",
    "reports.ai.saved_snapshot": "சேமிக்கப்பட்ட ஸ்னாப்ஷாட்",
    "Saved snapshot": "சேமிக்கப்பட்ட ஸ்னாப்ஷாட்",
    "reports.ai.no_data": "கிடைக்கும் தரவுகள் இல்லை",
    "No data available": "கிடைக்கும் தரவுகள் இல்லை",
    "reports.ai.showing_top": "{total} முடிவுகளில் {shown} முதல் காட்டப்படுகிறது",
    "Showing the top {shown} of {total} results": "{total} முடிவுகளில் {shown} முதல் காட்டப்படுகிறது",
    "reports.ai.saved_report": "AI அறிக்கை சேமிக்கப்பட்டது",
    "Saved AI report": "AI அறிக்கை சேமிக்கப்பட்டது",
    "reports.ai.template.country": "நாடு வழியாக விற்பனை",
    "reports.ai.template.state": "மாநிலம் வழியாக விற்பனை",
    "reports.ai.template.city": "நகரம் வழியாக விற்பனை",
    "reports.ai.template.category": "பிரிவு வழியாக விற்பனை",
    "reports.ai.template.country_all_time": "எல்லா நேரத்திலும் நாடு வழியாக விற்பனை",
    "Sales by country (all time)": "எல்லா நேரத்திலும் நாடு வழியாக விற்பனை",
    "reports.ai.template.top_listings_all_time": "எல்லா நேரத்திலும் அதிகம் விற்கப்பட்ட பட்டியல்கள்",
    "Top sold listings (all time)": "எல்லா நேரத்திலும் அதிகம் விற்கப்பட்ட பட்டியல்கள்",
    "reports.ai.template.listings_by_category_all_time": "எல்லா நேரத்திலும் பிரிவு வழியாக பட்டியல்கள்",
    "Listings by category (all time)": "எல்லா நேரத்திலும் பிரிவு வழியாக பட்டியல்கள்",
    "reports.search_table.title": "பட்டியல் தேடல்",
    "Listing search": "பட்டியல் தேடல்",
    "reports.search_table.phrase": "சொற்றொடர்",
    "Phrase": "சொற்றொடர்",
    "reports.search_table.result": "முடிவு",
    "reports.search_table.created_at": "உருவாக்கப்பட்ட நேரம்",
    "Created at": "உருவாக்கப்பட்ட நேரம்",
    "reports.search_table.user_first_name": "பயனர் பெயர்",
    "User first name": "பயனர் பெயர்",
    "reports.search_table.user_last_name": "பயனர் கடைசி பெயர்",
    "User last name": "பயனர் கடைசி பெயர்",
    "reports.search_table.user_email": "பயனர் மின்னஞ்சல்",
    "User email": "பயனர் மின்னஞ்சல்",
    "intelligence.title": "உள்ளுணர்வு",
    "intelligence.description": "AI அறிக்கைகளை உருவாக்கி, வரைபட ஸ்னாப்ஷாட்டை சேமித்து, பயனுள்ள அறிக்கைகளை உங்கள் டாஷ்போர்டில் பின்னே பொருத்தவும்.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "AI அறிக்கைகளை உருவாக்கி, வரைபட ஸ்னாப்ஷாட்டை சேமித்து, பயனுள்ள அறிக்கைகளை உங்கள் டாஷ்போர்டில் பின்னே பொருத்தவும்.",
    "intelligence.dashboard.label": "டாஷ்போர்ட்",
    "intelligence.dashboard.pinned_title": "நிலையான உள்ளுணர்வு விஷ்யூகள்",
    "Pinned intelligence widgets": "நிலையான உள்ளுணர்வு விஷ்யூகள்",
    "intelligence.dashboard.pinned_count": "{count} நிலையாக பொருத்தப்பட்டுள்ளது",
    "{count} pinned": "{count} நிலையாக பொருத்தப்பட்டுள்ளது",
    "intelligence.dashboard.empty": "மீண்டும் பயன்படுத்தக்கூடிய டாஷ்போர்ட் கிரிட்டை உருவாக்க, சேமிக்கப்பட்ட அறிக்கைகளை பின்னே பொருத்தவும்.",
    "Pin saved reports to build a reusable dashboard grid.": "மீண்டும் பயன்படுத்தக்கூடிய டாஷ்போர்ட் கிரிட்டை உருவாக்க, சேமிக்கப்பட்ட அறிக்கைகளை பின்னே பொருத்தவும்.",
    "intelligence.action.open": "திறக்க",
    "intelligence.action.pin": "நிலைநிறுத்த",
    "Pin": "நிலைநிறுத்த",
    "intelligence.action.unpin": "நிலை நீக்க",
    "Unpin": "நிலை நீக்க",
    "intelligence.action.generate": "உருவாக்க",
    "intelligence.action.save_snapshot": "உறுதிப்படுத்து",
    "Save snapshot": "உறுதிப்படுத்து",
    "intelligence.action.discard_draft": "முன்னோட்டத்தை தவிர்க்க",
    "intelligence.action.load": "பதிவேற்று",
    "Load": "பதிவேற்று",
    "intelligence.action.refresh": "புதுப்பிக்க",
    "intelligence.action.delete": "நீக்க",
    "intelligence.table.no_rows": "இந்த அறிக்கைக்கு அமைப்பு வரிகள் திரும்ப கிடைக்கவில்லை.",
    "No structured rows were returned for this report.": "இந்த அறிக்கைக்கு அமைப்பு வரிகள் திரும்ப கிடைக்கவில்லை.",
    "intelligence.table.no_rows_short": "கிடைக்கும் வரிகள் இல்லை.",
    "No rows available.": "கிடைக்கும் வரிகள் இல்லை.",
    "intelligence.field.template": "அறிக்கை மாதிரி",
    "Report template": "அறிக்கை மாதிரி",
    "intelligence.field.date_filter": "தேதி தேர்வு",
    "Date filter": "தேதி தேர்வு",
    "intelligence.field.prompt": "தொடக்க விவரம்",
    "Prompt preview": "தொடக்க விவரம்",
    "intelligence.field.report_name": "அறிக்கை பெயர்",
    "Report name": "அறிக்கை பெயர்",
    "intelligence.field.report_name_placeholder": "எடுத்துக்காட்டு: மிக அதிகம் விற்கப்பட்ட பொருட்கள் – கடைசி 30 நாட்கள்",
    "For example: Top Selling Products – Last 30 Days": "எடுத்துக்காட்டு: மிக அதிகம் விற்கப்பட்ட பொருட்கள் – கடைசி 30 நாட்கள்",
    "intelligence.field.chart": "வரைபடம்",
    "Chart": "வரைபடம்",
    "intelligence.field.prompt_label": "தொடக்க",
    "Prompt": "தொடக்க",
    "intelligence.date.relative": "உறவுடன்",
    "Relative": "உறவுடன்",
    "intelligence.date.absolute": "முழுமையான",
    "Absolute": "முழுமையான",
    "intelligence.date.last_n_days": "கடைசி N நாட்கள்",
    "Last N days": "கடைசி N நாட்கள்",
    "intelligence.date.last_days": "கடைசி {days} நாட்கள்",
    "Last {days} days": "கடைசி {days} நாட்கள்",
    "intelligence.date.from": "முதல்",
    "From": "முதல்",
    "intelligence.date.to": "வரை",
    "intelligence.saved_reports.title": "சேமிக்கப்பட்ட அறிக்கைகள்",
    "Saved reports": "சேமிக்கப்பட்ட அறிக்கைகள்",
    "intelligence.saved_reports.empty": "இன்னும் சேமிக்கப்பட்ட புரிதல் அறிக்கைகள் இல்லை.",
    "No saved intelligence reports yet.": "இன்னும் சேமிக்கப்பட்ட புரிதல் அறிக்கைகள் இல்லை.",
    "intelligence.active_report": "நடைமுறை அறிக்கை",
    "Active report": "நடைமுறை அறிக்கை",
    "intelligence.no_report_selected": "எந்த அறிக்கையும் தேர்ந்தெடுக்கப்படவில்லை",
    "No report selected": "எந்த அறிக்கையும் தேர்ந்தெடுக்கப்படவில்லை",
    "intelligence.active_report.empty_description": "விவரங்களை ஆய்வு செய்ய, அறிக்கையை உருவாக்கவும் அல்லது சேமிக்கப்பட்டதை ஏற்றிக்கொள்ளவும்.",
    "Generate a report or load a saved one to inspect the data.": "விவரங்களை ஆய்வு செய்ய, அறிக்கையை உருவாக்கவும் அல்லது சேமிக்கப்பட்டதை ஏற்றிக்கொள்ளவும்.",
    "intelligence.chart.value": "மதிப்பு",
    "intelligence.chart.unknown": "அறியப்படாதது",
    "intelligence.chart_type.bar": "பார்கள்",
    "Barres": "பார்கள்",
    "intelligence.chart_type.line": "கோடு",
    "Line": "கோடு",
    "intelligence.chart_type.area": "பரப்பளவு",
    "Area": "பரப்பளவு",
    "intelligence.chart_type.pie": "பை",
    "Pie": "பை",
    "intelligence.chart.no_rows": "இந்த அறிக்கை வரைபடம் செய்ய வரிகளை திரும்ப அனுப்பவில்லை.",
    "This report did not return rows to plot.": "இந்த அறிக்கை வரைபடம் செய்ய வரிகளை திரும்ப அனுப்பவில்லை.",
    "intelligence.empty_report": "AI அமைக்கப்பட்ட அறிக்கையை உருவாக்க, தேதி கட்டுப்பாடுகளைப் பயன்படுத்தி அதை சேமித்து உங்கள் டாஷ்போர்ட்டில் பின்னிடவும்.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "AI அமைக்கப்பட்ட அறிக்கையை உருவாக்க, தேதி கட்டுப்பாடுகளைப் பயன்படுத்தி அதை சேமித்து உங்கள் டாஷ்போர்ட்டில் பின்னிடவும்.",
    "intelligence.error.update": "சேமிக்கப்பட்ட அறிக்கையை மேம்படுத்த முடியவில்லை.",
    "Unable to update the saved report.": "சேமிக்கப்பட்ட அறிக்கையை மேம்படுத்த முடியவில்லை.",
    "intelligence.error.prompt_required": "அறிக்கை உருவாக்க, புள்ளிவிவரங்களை உள்ளிடவும்.",
    "Enter a prompt to generate a report.": "அறிக்கை உருவாக்க, புள்ளிவிவரங்களை உள்ளிடவும்.",
    "intelligence.error.invalid_response": "AI பதில் சீரமைக்கப்பட்ட அறிக்கையை உள்ளடக்கவில்லை.",
    "The AI response did not include a normalized report.": "AI பதில் சீரமைக்கப்பட்ட அறிக்கையை உள்ளடக்கவில்லை.",
    "intelligence.error.generate": "இப்போது அறிக்கை உருவாக்க முடியாது.",
    "Unable to generate the report right now.": "இப்போது அறிக்கை உருவாக்க முடியாது.",
    "intelligence.error.generate_before_save": "சேமிக்கும் முன் அறிக்கையை உருவாக்கவும்.",
    "Generate a report before saving.": "சேமிக்கும் முன் அறிக்கையை உருவாக்கவும்.",
    "intelligence.error.save": "அறிக்கையை சேமிக்க முடியவில்லை.",
    "Unable to save the report.": "அறிக்கையை சேமிக்க முடியவில்லை.",
    "intelligence.error.load": "சேமிக்கப்பட்ட அறிக்கையை ஏற்ற முடியவில்லை.",
    "Unable to load the saved report.": "சேமிக்கப்பட்ட அறிக்கையை ஏற்ற முடியவில்லை.",
    "intelligence.error.refresh": "சேமிக்கப்பட்ட அறிக்கையை மேம்படுத்த முடியவில்லை.",
    "Unable to refresh the saved report.": "சேமிக்கப்பட்ட அறிக்கையை மேம்படுத்த முடியவில்லை.",
    "intelligence.error.delete": "சேமிக்கப்பட்ட அறிக்கையை நீக்க முடியவில்லை.",
    "Unable to delete the saved report.": "சேமிக்கப்பட்ட அறிக்கையை நீக்க முடியவில்லை.",
    "intelligence.template.top_selling_products": "அதிக விற்பனையான பொருட்கள்",
    "Top selling products": "அதிக விற்பனையான பொருட்கள்",
    "intelligence.template.revenue_trend": "வருவாய் போக்கு",
    "Revenue trend": "வருவாய் போக்கு",
    "intelligence.template.low_stock_products": "குறைந்த ஸ்டாக் பொருட்கள்",
    "Low stock products": "குறைந்த ஸ்டாக் பொருட்கள்",
    "intelligence.template.top_categories_by_sales": "மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகள்",
    "Top categories by sales": "மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகள்",
    "intelligence.template.order_status_breakdown": "ஆர்டர் நிலை பிரிவின் விவரம்",
    "Order status breakdown": "ஆர்டர் நிலை பிரிவின் விவரம்",
    "intelligence.template.sales_by_day": "நாள் வாரியாக விற்பனை",
    "Sales by day": "நாள் வாரியாக விற்பனை",
    "intelligence.template.sales_by_country": "நாடு வாரியாக விற்பனை",
    "intelligence.template.sales_by_state": "மாநிலம் வாரியாக விற்பனை",
    "intelligence.template.sales_by_city": "நகரம் வாரியாக விற்பனை",
    "intelligence.template.sales_by_category": "பிரிவு வாரியாக விற்பனை",
    "intelligence.template.sales_by_subcategory": "சிறிய பிரிவு வாரியாக விற்பனை",
    "Sales by subcategory": "சிறிய பிரிவு வாரியாக விற்பனை",
    "intelligence.prompt.top_selling_products.relative": "{days} நாட்களுக்கு முன்புள்ள மிக அதிக விற்பனை செய்யப்பட்ட பொருட்களைக் காட்டு",
    "Show me top selling products for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள மிக அதிக விற்பனை செய்யப்பட்ட பொருட்களைக் காட்டு",
    "intelligence.prompt.top_selling_products.absolute": "{from} முதல் {to} வரையிலான மிக அதிக விற்பனை செய்யப்பட்ட பொருட்களைக் காட்டு",
    "Show me top selling products from {from} to {to}": "{from} முதல் {to} வரையிலான மிக அதிக விற்பனை செய்யப்பட்ட பொருட்களைக் காட்டு",
    "intelligence.prompt.revenue_trend.relative": "{days} நாட்களுக்கு முன்புள்ள வருமான போக்கு என்ன?",
    "What is my revenue trend for the last {days} days?": "{days} நாட்களுக்கு முன்புள்ள வருமான போக்கு என்ன?",
    "intelligence.prompt.revenue_trend.absolute": "{from} முதல் {to} வரையிலான வருமான போக்கு என்ன?",
    "What is my revenue trend from {from} to {to}?": "{from} முதல் {to} வரையிலான வருமான போக்கு என்ன?",
    "intelligence.prompt.low_stock_products": "குறைந்த ஸ்டாக் பொருட்களைக் காட்டு",
    "Show me low stock products": "குறைந்த ஸ்டாக் பொருட்களைக் காட்டு",
    "intelligence.prompt.top_categories_by_sales.relative": "{days} நாட்களுக்கு முன்புள்ள மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகளைக் காட்டு",
    "Show me top categories by sales for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகளைக் காட்டு",
    "intelligence.prompt.top_categories_by_sales.absolute": "{from} முதல் {to} வரையிலான மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகளைக் காட்டு",
    "Show me top categories by sales from {from} to {to}": "{from} முதல் {to} வரையிலான மிக அதிக விற்பனை செய்யப்பட்ட பிரிவுகளைக் காட்டு",
    "intelligence.prompt.order_status_breakdown.relative": "{days} நாட்களுக்கு முன்புள்ள ஆர்டர் நிலை பிரிவின் விவரத்தைக் காட்டு",
    "Show me order status breakdown for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள ஆர்டர் நிலை பிரிவின் விவரத்தைக் காட்டு",
    "intelligence.prompt.order_status_breakdown.absolute": "{from} முதல் {to} வரையிலான ஆர்டர் நிலை பிரிவின் விவரத்தைக் காட்டு",
    "Show me order status breakdown from {from} to {to}": "{from} முதல் {to} வரையிலான ஆர்டர் நிலை பிரிவின் விவரத்தைக் காட்டு",
    "intelligence.prompt.sales_by_day.relative": "{days} நாட்களுக்கு முன்புள்ள நாள் வாரியாக விற்பனையைக் காட்டு",
    "Show me sales by day for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள நாள் வாரியாக விற்பனையைக் காட்டு",
    "intelligence.prompt.sales_by_day.absolute": "{from} முதல் {to} வரையிலான நாள் வாரியாக விற்பனையைக் காட்டு",
    "Show me sales by day from {from} to {to}": "{from} முதல் {to} வரையிலான நாள் வாரியாக விற்பனையைக் காட்டு",
    "intelligence.prompt.sales_by_country.relative": "{days} நாட்களுக்கு முன்புள்ள நாடு வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள நாடு வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_country.absolute": "{from} முதல் {to} வரையிலான நாடு வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "{from} முதல் {to} வரையிலான நாடு வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_state.relative": "{days} நாட்களுக்கு முன்புள்ள மாநிலம் அல்லது மாகாணம் வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "{days} நாட்களுக்கு முன்புள்ள மாநிலம் அல்லது மாகாணம் வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_state.absolute": "{from} முதல் {to} வரையிலான மாநிலம் அல்லது மாகாணம் வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "{from} முதல் {to} வரையிலான மாநிலம் அல்லது மாகாணம் வாரியாக மொத்த விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_city.relative": "கடைசி {days} நாட்களுக்கு நகரங்களில் குழுவாக விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "கடைசி {days} நாட்களுக்கு நகரங்களில் குழுவாக விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_city.absolute": "கடைசி {from} முதல் {to} வரை நகரங்களில் குழுவாக விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "கடைசி {from} முதல் {to} வரை நகரங்களில் குழுவாக விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_category.relative": "மேல் மட்ட பட்டியல் பிரிவுகளில் குழுவாக கடைசி {days} நாட்களுக்கு விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "மேல் மட்ட பட்டியல் பிரிவுகளில் குழுவாக கடைசி {days} நாட்களுக்கு விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_category.absolute": "மேல் மட்ட பட்டியல் பிரிவுகளில் குழுவாக {from} முதல் {to} வரை விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "மேல் மட்ட பட்டியல் பிரிவுகளில் குழுவாக {from} முதல் {to} வரை விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_subcategory.relative": "பட்டியல் உள்பிரிவுகளில் குழுவாக கடைசி {days} நாட்களுக்கு விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "பட்டியல் உள்பிரிவுகளில் குழுவாக கடைசி {days} நாட்களுக்கு விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "intelligence.prompt.sales_by_subcategory.absolute": "பட்டியல் உள்பிரிவுகளில் குழுவாக {from} முதல் {to} வரை விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "பட்டியல் உள்பிரிவுகளில் குழுவாக {from} முதல் {to} வரை விற்பனை வருமானம் மற்றும் ஆர்டர் எண்ணிக்கையைக் காட்டு",
    "common.status.partial": "பாகம்",
    "Partial": "பாகம்",
    "common.status.dispatched": "அனுப்பப்பட்ட",
    "Dispatched": "அனுப்பப்பட்ட",
    "common.status.sale": "விற்பனை",
    "Sale": "விற்பனை",
    "common.status.transfer_in": "உள்ளீட்டு பரிமாற்றம்",
    "Transfer in": "உள்ளீட்டு பரிமாற்றம்",
    "common.status.transfer_out": "வெளியேற்றப்பட்ட பரிமாற்றம்",
    "Transfer out": "வெளியேற்றப்பட்ட பரிமாற்றம்",
    "common.status.return": "திரும்பப் பெறுதல்",
    "Return": "திரும்பப் பெறுதல்",
    "common.status.adjustment": "திருத்தம்",
    "Adjustment": "திருத்தம்",
    "common.status.receipt": "பெறுதல்",
    "inventory.overview.title": "கொள்முதல்",
    "inventory.overview.tab.all": "எல்லா ஸ்டாக்",
    "All stock": "எல்லா ஸ்டாக்",
    "inventory.overview.tab.low": "குறைந்த ஸ்டாக்",
    "Low stock": "குறைந்த ஸ்டாக்",
    "inventory.overview.tab.expiring": "முடிவடையும் பேட்ச்கள்",
    "Expiring batches": "முடிவடையும் பேட்ச்கள்",
    "inventory.overview.manage_locations": "இடங்களை நிர்வகிக்கவும்",
    "Manage locations": "இடங்களை நிர்வகிக்கவும்",
    "inventory.overview.purchase_orders": "வாங்கும் பணிகள்",
    "inventory.overview.operations": "செயல்பாடுகள்",
    "Operations": "செயல்பாடுகள்",
    "inventory.overview.adjust_stock": "ஸ்டாக்கை திருத்து",
    "Adjust stock": "ஸ்டாக்கை திருத்து",
    "inventory.overview.description": "உங்கள் இடங்களில் ஸ்டாக்கை நேரடியாகப் பார்க்கலாம்.",
    "A live view of stock across your locations.": "உங்கள் இடங்களில் ஸ்டாக்கை நேரடியாகப் பார்க்கலாம்.",
    "inventory.overview.adjustment_hint": "கணக்கெடுப்புகள், சேதம், திரும்பப் பெறுதல் அல்லது பிற திருத்தங்களுக்கு அமைப்புகளைப் பயன்படுத்தவும்.",
    "Use adjustments for counts, damage, returns, or other corrections.": "கணக்கெடுப்புகள், சேதம், திரும்பப் பெறுதல் அல்லது பிற திருத்தங்களுக்கு அமைப்புகளைப் பயன்படுத்தவும்.",
    "inventory.overview.units_on_hand": "உள்ள அலகுகள்",
    "Units on hand": "உள்ள அலகுகள்",
    "inventory.overview.one_stock_row": "1 ஸ்டாக் வரி",
    "1 stock row": "1 ஸ்டாக் வரி",
    "inventory.overview.stock_rows": "{count} ஸ்டாக் வரிகள்",
    "{count} stock rows": "{count} ஸ்டாக் வரிகள்",
    "inventory.overview.low_stock": "குறைந்த ஸ்டாக்",
    "inventory.overview.reorder_point_hint": "மீண்டும் பெறும் புள்ளியில் அல்லது அதற்கு கீழே",
    "At or below reorder point": "மீண்டும் பெறும் புள்ளியில் அல்லது அதற்கு கீழே",
    "inventory.overview.expiring_soon": "விரைவில் முடிவடையும்",
    "Expiring soon": "விரைவில் முடிவடையும்",
    "inventory.overview.next_90_days": "90 நாட்களில் உள்ள அடுத்த காலகட்டத்தில்",
    "Within the next 90 days": "90 நாட்களில் உள்ள அடுத்த காலகட்டத்தில்",
    "inventory.overview.stock_value": "ஸ்டாக் மதிப்பு",
    "Stock value": "ஸ்டாக் மதிப்பு",
    "inventory.overview.one_active_location": "1 செயல்பாட்டு இடம்",
    "1 active location": "1 செயல்பாட்டு இடம்",
    "inventory.overview.active_locations": "{count} செயல்பாட்டு இடங்கள்",
    "{count} active locations": "{count} செயல்பாட்டு இடங்கள்",
    "inventory.overview.search": "கூட்டு உள்ளீட்டைத் தேடு",
    "Search inventory": "கூட்டு உள்ளீட்டைத் தேடு",
    "inventory.overview.search_placeholder": "தயாரிப்பு, SKU அல்லது இடத்தைத் தேடு",
    "Search product, SKU, or location": "தயாரிப்பு, SKU அல்லது இடத்தைத் தேடு",
    "inventory.overview.filter_location": "இடத்தை அடிப்படையாகக் கொண்டு தேர்வுசெய்ய",
    "Filter by location": "இடத்தை அடிப்படையாகக் கொண்டு தேர்வுசெய்ய",
    "inventory.overview.all_locations": "அனைத்து இடங்களும்",
    "inventory.overview.empty.all": "இன்வென்டரி ஸ்டாக் பதிவு செய்யப்படவில்லை.",
    "No inventory stock has been recorded yet.": "இன்வென்டரி ஸ்டாக் பதிவு செய்யப்படவில்லை.",
    "inventory.overview.empty.low": "நல்லது — மீண்டும் பெறும் புள்ளிக்கு கீழே ஸ்டாக் இல்லை!",
    "Great — no stock is below its reorder point.": "நல்லது — மீண்டும் பெறும் புள்ளிக்கு கீழே ஸ்டாக் இல்லை!",
    "inventory.overview.empty.expiring": "90 நாட்களில் முடிவடையும் பொருட்கள் இல்லை.",
    "No batches are expiring within 90 days.": "90 நாட்களில் முடிவடையும் பொருட்கள் இல்லை.",
    "inventory.overview.adjust": "திருத்து",
    "Adjust": "திருத்து",
    "inventory.overview.adjust_title": "ஸ்டாக்கை திருத்து",
    "inventory.overview.adjust_description": "இன்வென்டரி வரலாறு நம்பகமாக இருக்க காரணத்துடன் திருத்தத்தைப் பதிவு செய்யவும்.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "இன்வென்டரி வரலாறு நம்பகமாக இருக்க காரணத்துடன் திருத்தத்தைப் பதிவு செய்யவும்.",
    "inventory.overview.save_adjustment": "திருத்தத்தை சேமி",
    "Save adjustment": "திருத்தத்தை சேமி",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "விதிக்கப்படாத",
    "Unassigned": "விதிக்கப்படாத",
    "inventory.overview.quantity_change": "அளவு மாற்றம்",
    "Quantity change": "அளவு மாற்றம்",
    "inventory.overview.quantity_placeholder": "எ.கா: 5 அல்லது -2",
    "e.g. 5 or -2": "எ.கா: 5 அல்லது -2",
    "inventory.overview.reason": "காரணம்",
    "inventory.overview.reason_placeholder": "எ.கா: சுழற்சி எண்ணிக்கை, சேதம், திரும்பப் பெறுதல்…",
    "Cycle count, damage, return…": "எ.கா: சுழற்சி எண்ணிக்கை, சேதம், திரும்பப் பெறுதல்…",
    "inventory.overview.reason.cycle_count": "சுழற்சி எண்ணிக்கை",
    "Cycle count": "சுழற்சி எண்ணிக்கை",
    "inventory.overview.reason.damage": "சேதம்",
    "Damage": "சேதம்",
    "inventory.overview.reason.return": "திரும்பப் பெறுதல்",
    "inventory.overview.reason.stocktake": "சேமிப்பு எண்ணிக்கை",
    "Stocktake": "சேமிப்பு எண்ணிக்கை",
    "inventory.overview.note_placeholder": "அடுத்த நபருக்கு கூடுதல் விவரம் (விரும்பினால்)",
    "Optional context for the next person": "அடுத்த நபருக்கு கூடுதல் விவரம் (விரும்பினால்)",
    "inventory.overview.adjustment_saved": "சேமிப்பு பதிவு சேமிக்கப்பட்டது",
    "Inventory adjustment saved": "சேமிப்பு பதிவு சேமிக்கப்பட்டது",
    "inventory.overview.on_hand": "கிடைக்கும்",
    "On hand": "கிடைக்கும்",
    "inventory.overview.reorder_at": "மீண்டும் வாங்குதல் அளவு",
    "Reorder at": "மீண்டும் வாங்குதல் அளவு",
    "orders.create_order.payment_reference_missing": "ஆர்டர் உருவாக்கப்பட்டது, ஆனால் ஆர்டர் முகவரி திரும்பப் பெறப்படவில்லை.",
    "The order was created, but no order reference was returned.": "ஆர்டர் உருவாக்கப்பட்டது, ஆனால் ஆர்டர் முகவரி திரும்பப் பெறப்படவில்லை.",
    "orders.create_order.payment_domain_missing": "ஆர்டர் உருவாக்கப்பட்டது, ஆனால் ஆர்டர் முகவரி திரும்பப் பெறப்படவில்லை.",
    "The tenant domain is not available for payment links.": "ஆர்டர் உருவாக்கப்பட்டது, ஆனால் ஆர்டர் முகவரி திரும்பப் பெறப்படவில்லை.",
    "orders.create_order.payment_link_failed": "பேமென்ட் இணைப்பு உருவாக்க முடியவில்லை.",
    "Unable to create payment link.": "பேமென்ட் இணைப்பு உருவாக்க முடியவில்லை.",
    "orders.create_order.admin_session_expired": "உங்கள் நிர்வாக உறுப்பினர் காலாவதியாகிவிட்டது. ஆர்டர் உருவாக்கும் முன் மீண்டும் உள்நுழையவும்.",
    "Your admin session has expired. Please sign in again before creating an order.": "உங்கள் நிர்வாக உறுப்பினர் காலாவதியாகிவிட்டது. ஆர்டர் உருவாக்கும் முன் மீண்டும் உள்நுழையவும்.",
    "orders.create_order.user": "பயனர்",
    "orders.create_order.add_new_user": "புதிய பயனரைச் சேர்க்கவும்",
    "Add New User": "புதிய பயனரைச் சேர்க்கவும்",
    "orders.create_order.choose_existing_user": "உள்ளிருக்கும் பயனரைத் தேர்வு செய்க",
    "Choose Existing User": "உள்ளிருக்கும் பயனரைத் தேர்வு செய்க",
    "orders.create_order.preparing_customer": "வாடிக்கையாளரை தயார் செய்து கொண்டிருக்கிறோம்…",
    "Preparing customer…": "வாடிக்கையாளரை தயார் செய்து கொண்டிருக்கிறோம்…",
    "orders.create_order.select_user": "பயனரைத் தேர்வு செய்க",
    "orders.create_order.search_listing": "பட்டியலைத் தேடு",
    "Search Listing": "பட்டியலைத் தேடு",
    "orders.create_order.listings": "பட்டியல்கள்",
    "orders.create_order.no_image": "படம் இல்லை",
    "No image": "படம் இல்லை",
    "orders.create_order.add_to_cart": "வாடிக்கையாளர் கார்ட்டிற்கு சேர்க்கவும்",
    "Add to Cart": "வாடிக்கையாளர் கார்ட்டிற்கு சேர்க்கவும்",
    "orders.create_order.select_rental_dates": "முதலில் வாடகை தொடங்கும் மற்றும் முடிவு தேதிகளைத் தேர்வு செய்யவும்.",
    "Select rental start and end dates first.": "முதலில் வாடகை தொடங்கும் மற்றும் முடிவு தேதிகளைத் தேர்வு செய்யவும்.",
    "orders.create_order.rental_end_after_start": "வாடகை முடிவு தேதி தொடங்கும் தேதிக்குப் பிறகு இருக்க வேண்டும்.",
    "Rental end must be after the start date.": "வாடகை முடிவு தேதி தொடங்கும் தேதிக்குப் பிறகு இருக்க வேண்டும்.",
    "orders.create_order.cart_type_conflict": "இந்த வாடிக்கையாளருக்கு வேறு வகையான பட்டியல் விதத்தில் பொருட்கள் உள்ளன. இந்த பொருளைச் சேர்க்கும் முன் காசோலையில் அந்த பொருட்களை அகற்றவும்.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "இந்த வாடிக்கையாளருக்கு வேறு வகையான பட்டியல் விதத்தில் பொருட்கள் உள்ளன. இந்த பொருளைச் சேர்க்கும் முன் காசோலையில் அந்த பொருட்களை அகற்றவும்.",
    "orders.create_order.rental_period": "வாடகை காலம்",
    "Rental period": "வாடகை காலம்",
    "orders.create_order.select_start_end": "தொடங்கும் மற்றும் முடிவு தேர்வு செய்யவும்",
    "Select start and end": "தொடங்கும் மற்றும் முடிவு தேர்வு செய்யவும்",
    "orders.create_order.membership_no_shipping": "உறுப்பினர் ஆர்டர்களுக்கு போஸ்ட் அல்லது கிடைப்பு தேவையில்லை.",
    "Membership orders do not require shipping or delivery.": "உறுப்பினர் ஆர்டர்களுக்கு போஸ்ட் அல்லது கிடைப்பு தேவையில்லை.",
    "orders.create_order.preparing_payment_link": "செலுத்துதல் இணைப்பைத் தயாரிக்கிறோம்…",
    "Preparing payment link…": "செலுத்துதல் இணைப்பைத் தயாரிக்கிறோம்…",
    "orders.create_order.payment_link_ready": "செலுத்துதல் இணைப்பு தயார்",
    "Payment link ready": "செலுத்துதல் இணைப்பு தயார்",
    "orders.create_order.copy_payment_link": "செலுத்துதல் இணைப்பை நகலெடுக்கவும்",
    "Copy payment link": "செலுத்துதல் இணைப்பை நகலெடுக்கவும்",
    "orders.create_order.payment_method": "செலுத்தும் முறை",
    "orders.create_order.no_payment_methods": "இந்த திட்டத்திற்கு செயல்பாட்டில் உள்ள செலுத்தும் முறைகள் இல்லை.",
    "No active payment methods are configured for this project.": "இந்த திட்டத்திற்கு செயல்பாட்டில் உள்ள செலுத்தும் முறைகள் இல்லை.",
    "orders.create_order.shipping_method": "அனுப்பும் முறை",
    "orders.create_order.no_shipping_methods": "இந்த திட்டத்திற்கு செயல்பாட்டில் உள்ள அனுப்புதல் முறைகள் அமைக்கப்படவில்லை.",
    "No active shipping methods are configured for this project.": "இந்த திட்டத்திற்கு செயல்பாட்டில் உள்ள அனுப்புதல் முறைகள் அமைக்கப்படவில்லை.",
    "orders.create_order.shipping_address": "அனுப்புதல் முகவரி",
    "Shipping address": "அனுப்புதல் முகவரி",
    "orders.create_order.loading_addresses": "சேமிக்கப்பட்ட முகவரிகள் ஏற்றப்படுகின்றன…",
    "Loading saved addresses…": "சேமிக்கப்பட்ட முகவரிகள் ஏற்றப்படுகின்றன…",
    "orders.create_order.no_saved_shipping_address": "இந்த பயனருக்கு சேமிக்கப்பட்ட அனுப்புதல் முகவரி இல்லை. கிடைப்பு ஆர்டரை உருவாக்கும் முன் ஒன்றை சேர்க்கவும்.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "இந்த பயனருக்கு சேமிக்கப்பட்ட அனுப்புதல் முகவரி இல்லை. கிடைப்பு ஆர்டரை உருவாக்கும் முன் ஒன்றை சேர்க்கவும்.",
    "orders.create_order.no_items": "பொருட்கள் இல்லை",
    "No items": "பொருட்கள் இல்லை",
    "orders.create_order.cart_empty": "உங்கள் கார்ட் வெறுமையாக உள்ளது",
    "Your cart is empty": "உங்கள் கார்ட் வெறுமையாக உள்ளது",
    "orders.create_order.create_order": "ஆர்டரை உருவாக்கு",
    "Create Order": "ஆர்டரை உருவாக்கு",
    "orders.create_order.create_payment_link": "செலுத்தும் இணைப்பை உருவாக்கு",
    "Create payment link": "செலுத்தும் இணைப்பை உருவாக்கு",
    "orders.create_order.order_summary": "ஆர்டர் சுருக்கம்",
    "orders.create_order.coupon_value": "கூப்பன் மதிப்பு",
    "Coupon value": "கூப்பன் மதிப்பு",
    "orders.create_order.remove_coupon": "கூப்பனை நீக்கு",
    "Remove Coupon": "கூப்பனை நீக்கு",
    "orders.create_order.apply_coupon": "கூப்பனை பயன்படுத்து",
    "Apply Coupon": "கூப்பனை பயன்படுத்து",
    "orders.create_order.grand_amount": "மொத்த தொகை",
    "Grand Amount": "மொத்த தொகை",
    "orders.create_order.total": "மொத்தம்",
    "orders.create_order.shipping": "கிரிப்பு",
    "orders.create_order.subtotal": "தொகுப்பு மொத்தம்",
    "orders.create_order.stock_unavailable": "கிடைப்பு இல்லை",
    "Stock is not available": "கிடைப்பு இல்லை",
    "orders.create_order.max_quantity": "குறைந்தபட்ச அளவு {quantity}",
    "Max quantity is {quantity}": "குறைந்தபட்ச அளவு {quantity}",
    "orders.create_order.items_in_cart": "கார்ட்டில் உள்ள பொருட்கள்",
    "Items in the cart": "கார்ட்டில் உள்ள பொருட்கள்",
    "orders.create_order.products_in_stock": "{count} ஸ்டாக்கில் உள்ள பொருட்கள்",
    "{count} Products in Stock": "{count} ஸ்டாக்கில் உள்ள பொருட்கள்",
    "orders.create_order.order_items": "ஆர்டர் பொருட்கள்",
    "Order Items": "ஆர்டர் பொருட்கள்",
    "orders.create_order.sold_by": "{name} என்பவரால்",
    "by {name}": "{name} என்பவரால்",
    "common.first_name": "பெயர்",
    "common.last_name": "குடும்ப பெயர்",
    "common.unlimited": "முடிவில்லாத",
    "unlimited": "முடிவில்லாத",
    "orders.reference": "மூலம்",
    "orders.amount": "தொகை",
    "orders.currency": "நாணயம்",
    "orders.transaction_date": "மாற்று தேதி",
    "Transaction Date": "மாற்று தேதி",
    "orders.volume_this_page": "கன அளவு (இந்த பக்கம்)",
    "Volume (this page)": "கன அளவு (இந்த பக்கம்)",
    "orders.seller_entries": "விற்பனையாளர் உள்ளீடுகள்",
    "Seller Entries": "விற்பனையாளர் உள்ளீடுகள்",
    "orders.customer_entries": "வாடிக்கையாளர் உள்ளீடுகள்",
    "Customer Entries": "வாடிக்கையாளர் உள்ளீடுகள்",
    "orders.filter_transactions": "மாற்றுகளை தேர்வு செய்யவும்",
    "Filter Transactions": "மாற்றுகளை தேர்வு செய்யவும்",
    "orders.reset_filters": "தேர்வுகளை மீட்டமை",
    "Reset filters": "தேர்வுகளை மீட்டமை",
    "orders.manage_transactions": "உங்கள் மாற்றுகளை நிர்வகிக்கவும்",
    "Manage your Transactions": "உங்கள் மாற்றுகளை நிர்வகிக்கவும்",
    "orders.empty_transactions_message": "இங்கு நீங்கள் பயனர்களுக்கு இடையேயான அனைத்து மாற்றுகளையும் தொடர்ந்து பார்க்கலாம்.\nகமிஷன்கள், ஆர்டர் விலை, பேமென்ட் கட்டணங்கள், குறிப்பிட்ட கட்டணங்கள் போன்றவை.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "இங்கு நீங்கள் பயனர்களுக்கு இடையேயான அனைத்து மாற்றுகளையும் தொடர்ந்து பார்க்கலாம்.\nகமிஷன்கள், ஆர்டர் விலை, பேமென்ட் கட்டணங்கள், குறிப்பிட்ட கட்டணங்கள் போன்றவை.",
    "orders.super_type": "சூப்பர் வகை",
    "Super Type": "சூப்பர் வகை",
    "orders.exporting": "மேம்படுத்தும்…",
    "orders.export_as_csv": "CSV ஆக ஏற்றுமதி செய்யவும்",
    "Export as CSV": "CSV ஆக ஏற்றுமதி செய்யவும்",
    "orders.search_transactions": "கடன் பரிவர்த்தனைகளைத் தேடு",
    "Search transactions": "கடன் பரிவர்த்தனைகளைத் தேடு",
    "orders.filter": "தேர்வு செய்யவும்",
    "orders.transaction_status": "கடன் பரிவர்த்தனை நிலை",
    "Transaction Status": "கடன் பரிவர்த்தனை நிலை",
    "orders.seller_protection_fee": "விற்பனையாளர் பாதுகாப்பு கட்டணம்",
    "Seller Protection Fee": "விற்பனையாளர் பாதுகாப்பு கட்டணம்",
    "common.show_rows": "வரிகளைக் காட்டு",
    "common.clear_all": "அனைத்தையும் அழி",
    "orders.order_number_value": "ஆர்டர் #{number}",
    "orders.transactions": "பரிவர்த்தனைகள்",
    "reported_listings.report_detail": "அறிக்கை விவரம்",
    "Report Detail": "அறிக்கை விவரம்",
    "reported_listings.reported_listing": "அறிவிக்கப்பட்ட பட்டியல்",
    "Reported Listing": "அறிவிக்கப்பட்ட பட்டியல்",
    "reported_listings.pending": "தொடங்கப்படவில்லை",
    "reported_listings.approved": "ஒப்புக்கொள்ளப்பட்டது",
    "reported_listings.rejected": "நிராகரிக்கப்பட்டது",
    "reported_listings.view_marketplace": "விற்பனை மண்டலத்தில் காட்டு",
    "View on marketplace": "விற்பனை மண்டலத்தில் காட்டு",
    "reported_listings.approve_listing": "பட்டியலை ஒப்புக்கொள்ளவும்",
    "Approve listing": "பட்டியலை ஒப்புக்கொள்ளவும்",
    "reported_listings.reject_listing": "பட்டியலை நிராகரிக்கவும்",
    "Reject listing": "பட்டியலை நிராகரிக்கவும்",
    "reported_listings.reported_by": "அறிவித்தவர்",
    "Reported By": "அறிவித்தவர்",
    "reported_listings.blocked": "தடை செய்யப்பட்டது",
    "reported_listings.unblock_user": "பயனரை தடை நீக்கு",
    "Unblock user": "பயனரை தடை நீக்கு",
    "reported_listings.block_user": "பயனரை தடை செய்ய",
    "Block user": "பயனரை தடை செய்ய",
    "reported_listings.report_info": "அறிக்கை விவரம்",
    "Report Info": "அறிக்கை விவரம்",
    "reported_listings.reason": "காரணம்",
    "reported_listings.reported_on": "அறிவிக்கப்பட்டது",
    "Reported on": "அறிவிக்கப்பட்டது",
    "reported_listings.listing_id": "பதிவு எண்",
    "reported_listings.reporter": "அறிவிப்பாளர்",
    "Reporter": "அறிவிப்பாளர்",
    "reported_listings.listing": "பதிவு",
    "reported_listings.status": "நிலை",
    "reported_listings.title": "அறிவிக்கப்பட்ட பதிவுகள்",
    "reported_listings.report_count": "புகார்கள்: {count}",
    "Reports: {count}": "புகார்கள்: {count}",
    "reported_listings.empty_title": "அறிவிக்கப்பட்ட பதிவுகளைப் பார்க்கிறீர்கள்",
    "Viewing Reported listings": "அறிவிக்கப்பட்ட பதிவுகளைப் பார்க்கிறீர்கள்",
    "reported_listings.empty_message": "உங்கள் பயனர்களால் அறிவிக்கப்பட்ட பதிவுகளை இங்கு காணலாம்",
    "You will find your users reported listings here": "உங்கள் பயனர்களால் அறிவிக்கப்பட்ட பதிவுகளை இங்கு காணலாம்",
    "common.page_of": "பக்கம் {page} முதல் {total}",
    "Page {page} of {total}": "பக்கம் {page} முதல் {total}",
    "common.view": "பார்க்க",
    "reviews.empty_title": "மதிப்பீடுகள் மற்றும் மேலும் கருத்துகளைப் பார்க்கிறீர்கள்",
    "Viewing Rate & Reviews": "மதிப்பீடுகள் மற்றும் மேலும் கருத்துகளைப் பார்க்கிறீர்கள்",
    "reviews.empty_message": "உங்கள் பயனர்களின் மதிப்பீடுகள் மற்றும் மேலும் கருத்துகளை இங்கு காணலாம்",
    "You will find your users ratings and reviews here": "உங்கள் பயனர்களின் மதிப்பீடுகள் மற்றும் மேலும் கருத்துகளை இங்கு காணலாம்",
    "reviews.list": "பட்டியல்",
    "reviews.grid": "கிரிட்",
    "Grid": "கிரிட்",
    "reviews.title": "மதிப்பீடுகள் மற்றும் மதிப்பீடுகள்",
    "reviews.review": "மதிப்பீடு",
    "reviews.name": "பெயர்",
    "reviews.rating": "மதிப்பீடு",
    "Rating": "மதிப்பீடு",
    "reviews.title_column": "தலைப்பு",
    "reviews.content": "பொருள்",
    "reviews.image": "படம்",
    "Image": "படம்",
    "reviews.images": "படங்கள்",
    "Images": "படங்கள்",
    "reviews.accounts": "கணக்குகள்",
    "reviews.listings": "பட்டியல்கள்",
    "reviews.star": "நட்சத்திரம்",
    "Star": "நட்சத்திரம்",
    "reviews.review_image": "மதிப்பீட்டு படம்",
    "Review image": "மதிப்பீட்டு படம்",
    "reviews.title_required": "தலைப்பு அவசியம்",
    "Title is required": "தலைப்பு அவசியம்",
    "reviews.content_required": "பொருள் அவசியம்",
    "Content is required": "பொருள் அவசியம்",
    "reviews.updated_successfully": "மதிப்பீடு வெற்றிகரமாக தொகுக்கப்பட்டது",
    "Review updated successfully": "மதிப்பீடு வெற்றிகரமாக தொகுக்கப்பட்டது",
    "reviews.edit_review": "மதிப்பீட்டை தொகுக்க",
    "Edit Review": "மதிப்பீட்டை தொகுக்க",
    "common.not_available": "N/A",
    "common.something_went_wrong": "ஏதோ தவறானது",
    "Something went wrong": "ஏதோ தவறானது",
    "media.load_failed": "ஊடகம் ஏற்றப்பட முடியவில்லை",
    "Unable to load media.": "ஊடகம் ஏற்றப்பட முடியவில்லை",
    "media.load_failed_retry": "ஊடகம் ஏற்றப்பட முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "media.update_failed": "ஊடகம் தொகுப்பில் பிழை",
    "Media update failed": "ஊடகம் தொகுப்பில் பிழை",
    "media.renamed": "ஊடகம் பெயர் மாற்றப்பட்டது",
    "Media renamed": "ஊடகம் பெயர் மாற்றப்பட்டது",
    "media.moved": "ஊடகம் நகர்த்தப்பட்டது",
    "Media moved": "ஊடகம் நகர்த்தப்பட்டது",
    "media.rename_failed": "ஊடகத்தை பெயர் மாற்ற முடியாது",
    "Unable to rename media": "ஊடகத்தை பெயர் மாற்ற முடியாது",
    "media.move_failed": "ஊடகத்தை நகர்த்த முடியாது",
    "Unable to move media": "ஊடகத்தை நகர்த்த முடியாது",
    "media.deleted": "ஊடகம் நீக்கப்பட்டது",
    "Media deleted": "ஊடகம் நீக்கப்பட்டது",
    "media.delete_failed": "ஊடகத்தை நீக்க முடியாது",
    "Unable to delete media": "ஊடகத்தை நீக்க முடியாது",
    "media.confirm_delete": "இந்த ஊடகத்தை நீக்க விரும்புகிறீர்களா?",
    "Are you sure you want to delete this media?": "இந்த ஊடகத்தை நீக்க விரும்புகிறீர்களா?",
    "media.delete_media": "ஊடகத்தை நீக்கு",
    "Delete media": "ஊடகத்தை நீக்கு",
    "media.folder_creation_web_only": "பெட்டிகளை உருவாக்குதல் வலைத்தளத்தில் கிடைக்கிறது",
    "Folder creation is available on web": "பெட்டிகளை உருவாக்குதல் வலைத்தளத்தில் கிடைக்கிறது",
    "media.no_create_folder_permission": "உங்களிடம் பெட்டிகளை உருவாக்க அனுமதி இல்லை",
    "You do not have permission to create folders": "உங்களிடம் பெட்டிகளை உருவாக்க அனுமதி இல்லை",
    "media.folder_name": "பெட்டி பெயர்",
    "Folder name": "பெட்டி பெயர்",
    "media.folder_created": "பெட்டி உருவாக்கப்பட்டது",
    "Folder created": "பெட்டி உருவாக்கப்பட்டது",
    "media.folder_create_failed": "பெட்டி உருவாக்க முடியவில்லை",
    "media.link_copied": "இணைப்பு நகலெடுக்கப்பட்டது",
    "Link copied": "இணைப்பு நகலெடுக்கப்பட்டது",
    "media.copy_link_failed": "இணைப்பை நகலெடுக்க முடியவில்லை",
    "Unable to copy link": "இணைப்பை நகலெடுக்க முடியவில்லை",
    "media.urls_copied": "{count} இணைப்புகள் நகலெடுக்கப்பட்டன",
    "{count} URLs copied": "{count} இணைப்புகள் நகலெடுக்கப்பட்டன",
    "media.clipboard_unavailable": "கிளிப்போர்ட் கிடைக்கவில்லை",
    "Clipboard is not available": "கிளிப்போர்ட் கிடைக்கவில்லை",
    "media.copy_urls_failed": "இணைப்புகளை நகலெடுக்க முடியவில்லை",
    "Unable to copy URLs": "இணைப்புகளை நகலெடுக்க முடியவில்லை",
    "media.upload_failed": "ஊடக பதிவேற்றம் தோல்வி",
    "Media upload failed": "ஊடக பதிவேற்றம் தோல்வி",
    "media.replace_success": "ஊடகம் மாற்றப்பட்டது. ஊடக ஐடி மற்றும் நிலையான இணைப்பு மாற்றமின்றி உள்ளது.",
    "Media replaced. The media ID and stable link are unchanged.": "ஊடகம் மாற்றப்பட்டது. ஊடக ஐடி மற்றும் நிலையான இணைப்பு மாற்றமின்றி உள்ளது.",
    "media.replace_failed": "ஊடகத்தை மாற்ற முடியவில்லை",
    "Unable to replace media": "ஊடகத்தை மாற்ற முடியவில்லை",
    "media.csv_upload_failed": "CSV பதிவேற்றம் தோல்வி",
    "CSV upload failed": "CSV பதிவேற்றம் தோல்வி",
    "media.csv_metadata_failed": "CSV மெட்டாடேட்டா சேமிக்க முடியவில்லை",
    "Unable to save CSV metadata": "CSV மெட்டாடேட்டா சேமிக்க முடியவில்லை",
    "media.csv_saved_version": "CSV புதிய பதிப்பாக சேமிக்கப்பட்டது",
    "CSV saved as a new version": "CSV புதிய பதிப்பாக சேமிக்கப்பட்டது",
    "media.csv_save_failed": "CSV சேமிக்க முடியவில்லை",
    "Unable to save CSV": "CSV சேமிக்க முடியவில்லை",
    "media.uploading_files": "{count} கோப்புகள் பதிவேற்றம் செய்யப்படுகின்றன…",
    "Uploading {count} files…": "{count} கோப்புகள் பதிவேற்றம் செய்யப்படுகின்றன…",
    "media.upload_progress": "{count} கோப்புகள் பதிவேற்றம் செய்யப்படுகின்றன · {progress}%",
    "Uploading {count} files · {progress}%": "{count} கோப்புகள் பதிவேற்றம் செய்யப்படுகின்றன · {progress}%",
    "media.upload_success": "{count} கோப்புகள் வெற்றிகரமாக பதிவேற்றப்பட்டன.",
    "{count} files uploaded successfully.": "{count} கோப்புகள் வெற்றிகரமாக பதிவேற்றப்பட்டன.",
    "media.upload_failed_retry": "ஊடகத்தை பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "media.register_failed": "ஊடகத்தை பதிவு செய்ய முடியவில்லை",
    "media.list_view": "பட்டியல் காட்சி",
    "List view": "பட்டியல் காட்சி",
    "media.grid_view": "கிரிட் காட்சி",
    "Grid view": "கிரிட் காட்சி",
    "media.copy_uploaded_urls": "பதிவேற்றப்பட்ட URLs நகலெடுக்க",
    "Copy uploaded URLs": "பதிவேற்றப்பட்ட URLs நகலெடுக்க",
    "media.copy_visible_urls": "தெரியும் URLs நகலெடுக்க",
    "Copy visible URLs": "தெரியும் URLs நகலெடுக்க",
    "media.copy_all_urls": "எல்லா URLs நகலெடுக்க",
    "Copy all URLs": "எல்லா URLs நகலெடுக்க",
    "media.new_folder": "புதிய கோப்பு அடைவு",
    "New folder": "புதிய கோப்பு அடைவு",
    "media.uploading_progress": "{progress}% சமர்ப்பிக்கப்படுகிறது",
    "Uploading {progress}%": "{progress}% சமர்ப்பிக்கப்படுகிறது",
    "media.upload_media": "கோப்புகளை பதிவேற்று",
    "media.manager_title": "ஊடக மேலாளர்",
    "Media Manager": "ஊடக மேலாளர்",
    "media.search": "ஊடகங்களைத் தேடு",
    "Search media": "ஊடகங்களைத் தேடு",
    "media.location": "இடம்",
    "media.media_root": "ஊடகங்கள்",
    "media.show_type": "{type} ஊடகங்களைக் காட்டு",
    "Show {type} media": "{type} ஊடகங்களைக் காட்டு",
    "media.type_all": "எல்லாம்",
    "all": "எல்லாம்",
    "media.type_image": "படம்",
    "image": "படம்",
    "media.type_video": "வீடியோ",
    "video": "வீடியோ",
    "media.type_audio": "ஆடியோ",
    "audio": "ஆடியோ",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "கோப்பு அடைவு",
    "folder": "கோப்பு அடைவு",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "மிகப்பழைய",
    "Oldest": "மிகப்பழைய",
    "media.newest": "புதிய",
    "Newest": "புதிய",
    "media.sort_current": "ஊடகங்களை வரிசைப்படுத்து, தற்போது {sort}",
    "Sort media, currently {sort}": "ஊடகங்களை வரிசைப்படுத்து, தற்போது {sort}",
    "media.loading": "ஊடகங்கள் ஏற்றப்படுகின்றன…",
    "media.no_filter_matches": "இந்த தேர்வுகளுக்கு ஏற்ற ஊடகங்கள் இல்லை.",
    "No media matches these filters.": "இந்த தேர்வுகளுக்கு ஏற்ற ஊடகங்கள் இல்லை.",
    "media.empty_title": "உங்கள் ஊடக நூலகம் காலியாக உள்ளது",
    "Your media library is empty": "உங்கள் ஊடக நூலகம் காலியாக உள்ளது",
    "media.empty_message": "பிரமோஷன், கட்டுரை போன்ற பயன்பாடுகளில் மீண்டும் பயன்படுத்த படங்கள், PDF, வீடியோக்களை பதிவேற்று",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "பிரமோஷன், கட்டுரை போன்ற பயன்பாடுகளில் மீண்டும் பயன்படுத்த படங்கள், PDF, வீடியோக்களை பதிவேற்று",
    "media.empty_hint": "தொடங்க கோப்புகளை பதிவேற்று அல்லது ஒரு கோப்பு அடைவை உருவாக்கு.",
    "Upload files or create a folder to get started.": "தொடங்க கோப்புகளை பதிவேற்று அல்லது ஒரு கோப்பு அடைவை உருவாக்கு.",
    "media.folder": "கோப்புகள்",
    "media.file_folder_name": "கோப்பு அல்லது பெட்டியின் பெயர்",
    "File or folder name": "கோப்பு அல்லது பெட்டியின் பெயர்",
    "media.rename_media": "ஊடகத்தை மாற்று",
    "Rename media": "ஊடகத்தை மாற்று",
    "media.move_media": "ஊடகத்தை நகர்த்து",
    "Move media": "ஊடகத்தை நகர்த்து",
    "media.pdf_preview": "PDF முன்னோட்டம்: {name}",
    "PDF preview: {name}": "PDF முன்னோட்டம்: {name}",
    "media.pdf_preview_web": "PDF முன்னோட்டம் வலைப்பக்க பயன்பாட்டில் கிடைக்கிறது.",
    "PDF preview is available in the web app.": "PDF முன்னோட்டம் வலைப்பக்க பயன்பாட்டில் கிடைக்கிறது.",
    "media.csv_preview_web": "CSV முன்னோட்டம் வலைப்பக்க பயன்பாட்டில் கிடைக்கிறது.",
    "CSV preview is available in the web app.": "CSV முன்னோட்டம் வலைப்பக்க பயன்பாட்டில் கிடைக்கிறது.",
    "media.media_file": "ஊடக கோப்பு",
    "Media file": "ஊடக கோப்பு",
    "media.share_link": "பகிர்வு இணைப்பு",
    "Share link": "பகிர்வு இணைப்பு",
    "media.copy_link": "இணைப்பை நகலெடு",
    "Copy link": "இணைப்பை நகலெடு",
    "media.replace_media": "ஊடகத்தை மாற்று",
    "Replace media": "ஊடகத்தை மாற்று",
    "media.folders": "கோப்புகள்",
    "Folders": "கோப்புகள்",
    "media.create_new_folder": "புதிய பெட்டி உருவாக்கு",
    "Create new folder": "புதிய பெட்டி உருவாக்கு",
    "media.go_to_all_media": "எல்லா ஊடகங்களுக்கு செல்லவும்",
    "Go to all media": "எல்லா ஊடகங்களுக்கு செல்லவும்",
    "media.all_media": "எல்லா ஊடகங்களும்",
    "All media": "எல்லா ஊடகங்களும்",
    "media.open_folder_name": "கோப்பு {name} திறக்கவும்",
    "Open folder {name}": "கோப்பு {name} திறக்கவும்",
    "media.no_subfolders": "தொடர்புள்ள பெட்டிகள் இல்லை",
    "No subfolders": "தொடர்புள்ள பெட்டிகள் இல்லை",
    "media.no_files_in_folder": "இந்த பெட்டியில் கோப்புகள் இல்லை.",
    "No files in this folder.": "இந்த பெட்டியில் கோப்புகள் இல்லை.",
    "media.upload_folder": "இந்த பெட்டியில் ஊடகத்தை பதிவேற்று",
    "Upload media to this folder": "இந்த பெட்டியில் ஊடகத்தை பதிவேற்று",
    "media.discard_csv_confirm": "CSV-ல் உள்ள மாற்றங்களை நீக்க வேண்டுமா?",
    "Discard your CSV changes?": "CSV-ல் உள்ள மாற்றங்களை நீக்க வேண்டுமா?",
    "media.unsaved_changes": "சேமிக்கப்படாத மாற்றங்கள்",
    "Unsaved changes": "சேமிக்கப்படாத மாற்றங்கள்",
    "media.find_csv": "CSV-ல் தேடு",
    "Find in CSV": "CSV-ல் தேடு",
    "media.save_csv": "CSV-ஐ சேமி",
    "Save CSV": "CSV-ஐ சேமி",
    "media.loading_csv": "CSV ஏற்றும்…",
    "Loading CSV…": "CSV ஏற்றும்…",
    "media.prepare_folder_failed": "பதிவேற்ற கோப்பு அடைவை தயார் செய்ய முடியவில்லை",
    "Unable to prepare the upload folder": "பதிவேற்ற கோப்பு அடைவை தயார் செய்ய முடியவில்லை",
    "media.add_file_required": "கோப்பை சேர்க்கவும்",
    "Please add a file": "கோப்பை சேர்க்கவும்",
    "media.add_media": "ஊடகத்தை சேர்க்கவும்",
    "Add Media": "ஊடகத்தை சேர்க்கவும்",
    "media.store_uploaded_media_in": "பதிவேற்றிய ஊடகங்களை சேமிக்கவும்",
    "Store uploaded media in": "பதிவேற்றிய ஊடகங்களை சேமிக்கவும்",
    "media.destination_business_cards": "வியாபார அட்டைகள்",
    "Business Cards": "வியாபார அட்டைகள்",
    "media.destination_listings": "பட்டியல்கள்",
    "media.destination_accounts": "கணக்குகள்",
    "media.destination_users": "பயனர்கள்",
    "media.upload_media_title": "ஊடகத்தை பதிவேற்றவும்",
    "media.media_files": "ஊடகங்கள்",
    "media.open_folder": "கோப்பு அடைவைத் திறக்கவும்",
    "Open folder": "கோப்பு அடைவைத் திறக்கவும்",
    "common.show": "காட்டு",
    "common.share": "பகிர்வு",
    "common.copy": "நகலெடு",
    "common.rename": "பெயர் மாற்று",
    "Rename": "பெயர் மாற்று",
    "common.move": "நகர்த்து",
    "Move": "நகர்த்து",
    "common.type": "வகை",
    "common.size": "அளவு",
    "Size": "அளவு",
    "common.preview": "முன்னோட்டம்",
    "Preview": "முன்னோட்டம்",
    "common.undo": "மீள்விக்க",
    "common.redo": "மீண்டும் செய்க",
    "common.discard": "தவிர்க்க",
    "Discard": "தவிர்க்க",
    "common.try_again": "மீண்டும் முயற்சி செய்க",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "முக்கிய அட்டவணை",
    "Spreadsheet": "முக்கிய அட்டவணை",
    "media.type_file": "கோப்பு",
    "File": "கோப்பு",
    "media.csv_load_failed": "CSV ஐ ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Unable to load CSV. Please try again.": "CSV ஐ ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "workspace.settings_section.customisation": "தனிப்பயனாக்கம்",
    "workspace.settings_section.integrations": "ஒன்றிணைப்புகள்",
    "workspace.settings_section.platform_setup": "தள அமைப்பு",
    "Platform Setup": "தள அமைப்பு",
    "workspace.settings_section.business_operations": "வணிக இயக்கங்கள்",
    "Business Operations": "வணிக இயக்கங்கள்",
    "workspace.settings_section.system_setup": "குறிப்பிட்ட அமைப்பு",
    "System Setup": "குறிப்பிட்ட அமைப்பு",
    "workspace.settings_item.app_customisation": "பயன்பாடு தனிப்பயனாக்கம்",
    "workspace.settings_item.web_customisation": "வலைப்பக்க தனிப்பயனாக்கம்",
    "workspace.settings_item.communications": "தகவல் தொடர்புகள்",
    "workspace.settings_item.strings_customisation": "சரம் தனிப்பயனாக்கம்",
    "workspace.settings_item.app_integrations": "பயன்பாடு ஒன்றிணைப்புகள்",
    "workspace.settings_item.web_integrations": "வலைப்பக்க ஒன்றிணைப்புகள்",
    "Web Integrations": "வலைப்பக்க ஒன்றிணைப்புகள்",
    "workspace.settings_item.accounts": "கணக்குகள்",
    "workspace.settings_item.listings": "பட்டியல்கள்",
    "workspace.settings_item.checkout_and_cart_attributes": "வாங்குதல் மற்றும் கார்ட் அம்சங்கள்",
    "workspace.settings_item.service_shipping": "சேவை / அனுப்புதல்",
    "workspace.settings_item.payments": "கட்டணங்கள்",
    "workspace.settings_item.commissions": "கமிஷன்கள்",
    "workspace.settings_item.taxes": "வரி",
    "workspace.settings_item.special_fees": "கூடுதல் கட்டணங்கள்",
    "workspace.settings_item.languages": "மொழிகள்",
    "workspace.settings_item.currency": "நாணயம்",
    "workspace.settings_item.countries": "நாடுகள்",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "நீட்டிப்புகள்",
    "workspace.settings_item.manage_features": "அம்சங்களை நிர்வகிக்கவும்",
    "Manage Features": "அம்சங்களை நிர்வகிக்கவும்",
    "workspace.settings_item.audit_logs": "ஆடிட் பதிவுகள்",
    "Audit Logs": "ஆடிட் பதிவுகள்",
    "workspace.settings_item.auth": "அடையாளம் காட்டுதல்",
    "workspace.settings_item.maps": "மேப்புகள்",
    "workspace.settings_hint.accounts": "எடுத்துக்காட்டு: கடை",
    "Example: Store": "எடுத்துக்காட்டு: கடை",
    "workspace.settings_hint.listings": "எடுத்துக்காட்டு: பொருட்கள், நிகழ்வுகள்",
    "Example: Products, Events": "எடுத்துக்காட்டு: பொருட்கள், நிகழ்வுகள்",
    "workspace.settings_hint.audit_logs": "பொருத்தமான பாதுகாப்பு பதிவு",
    "Compliance & security trail": "பொருத்தமான பாதுகாப்பு பதிவு",
    "workspace.settings_hint.auth": "பேஸ்புக், கூகிள், ட்விலியோ",
    "Facebook, Google, Twilio": "பேஸ்புக், கூகிள், ட்விலியோ",
    "workspace.settings_hint.maps": "வழங்குநர் பயன்பாடு மற்றும் தனியுரிமை அமைப்புகள்",
    "Provider usage and privacy settings": "வழங்குநர் பயன்பாடு மற்றும் தனியுரிமை அமைப்புகள்",
    "workspace.settings_access_denied": "{name}-க்கு உங்களுக்கு அணுகல் இல்லை",
    "You don't have access of {name}": "{name}-க்கு உங்களுக்கு அணுகல் இல்லை",
    "app_customization.title": "பயன்பாட்டை தனிப்பயனாக்குதல்",
    "app_customization.tab_0": "பொதுவானது",
    "app_customization.tab_1": "தொடக்கத் திரை",
    "Splash": "தொடக்கத் திரை",
    "app_customization.tab_2": "அறிமுக வழிகாட்டி",
    "Onboarding": "அறிமுக வழிகாட்டி",
    "app_customization.tab_3": "பதிவு",
    "Registration": "பதிவு",
    "app_customization.tab_4": "தொடக்கம்",
    "app_customization.tab_5": "புஷ் அறிவிப்புகள்",
    "Push Notification": "புஷ் அறிவிப்புகள்",
    "app_customization.tab_6": "செய்தியலை",
    "app_customization.tab_7": "மேலும் மெனு",
    "More Menu": "மேலும் மெனு",
    "app_customization.tab_8": "கட்டாய மேம்பாடு",
    "Force Update": "கட்டாய மேம்பாடு",
    "app_customization.tab_9": "முகவரி",
    "app_customization.hide_balances": "மேலும் பிரிவில் பேலன்ஸ்களையும் பேமென்ட்களையும் மறைக்கவும்",
    "app_customization.more": "மேலும்",
    "app_customization.force_update": "மேம்படுத்துதலை கட்டாயப்படுத்து",
    "Force To Update": "மேம்படுத்துதலை கட்டாயப்படுத்து",
    "app_customization.android_version": "Android பயன்பாட்டின் பதிப்பு",
    "Android app version": "Android பயன்பாட்டின் பதிப்பு",
    "app_customization.enter_android_version": "Android பயன்பாட்டின் பதிப்பை உள்ளிடவும்",
    "Enter android app version": "Android பயன்பாட்டின் பதிப்பை உள்ளிடவும்",
    "app_customization.ios_version": "iOS பயன்பாட்டின் பதிப்பு",
    "iOS app version": "iOS பயன்பாட்டின் பதிப்பு",
    "app_customization.enter_ios_version": "iOS பயன்பாட்டின் பதிப்பை உள்ளிடவும்",
    "Enter iOS app version": "iOS பயன்பாட்டின் பதிப்பை உள்ளிடவும்",
    "app_customization.chat": "செய்தியிடல்",
    "app_customization.chat_send_listing": "செய்தியிடலில் கிளிக் செய்தால் பட்டியல்களை தானியங்கி அனுப்ப வைக்கவும் (இயல்புநிலையில் மேலே முன்னோட்டம் காட்டும்)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "செய்தியிடலில் கிளிக் செய்தால் பட்டியல்களை தானியங்கி அனுப்ப வைக்கவும் (இயல்புநிலையில் மேலே முன்னோட்டம் காட்டும்)",
    "app_customization.make_offer": "ஆஃபர் செய்யவும் / பேச்சுவார்த்தை",
    "Make Offer / Negotiation": "ஆஃபர் செய்யவும் / பேச்சுவார்த்தை",
    "app_customization.negotiation_button_name": "பேச்சுவார்த்தை பட்டன் பெயர்:",
    "Negotiation button name:": "பேச்சுவார்த்தை பட்டன் பெயர்:",
    "app_customization.negotiation_button_example": "(எ.கா: ஆஃபர் செய்ய, பேச்சுவார்த்தை செய்ய, விலை கேட்க)",
    "(example: Make Offer, Negotiate, Quote)": "(எ.கா: ஆஃபர் செய்ய, பேச்சுவார்த்தை செய்ய, விலை கேட்க)",
    "app_customization.enter_negotiation_button_name": "பேச்சுவார்த்தை பட்டன் பெயரை உள்ளிடவும்",
    "Enter negotiation button name": "பேச்சுவார்த்தை பட்டன் பெயரை உள்ளிடவும்",
    "app_customization.address": "முகவரி",
    "app_customization.address_option_0": "இரண்டாம் முகவரியைக் காட்டு",
    "Show Address 2": "இரண்டாம் முகவரியைக் காட்டு",
    "app_customization.address_option_1": "நாட்டைக் காட்டு",
    "Show Country": "நாட்டைக் காட்டு",
    "app_customization.address_option_2": "கோடு எண்ணைக் காட்டு",
    "Show Zipcode": "கோடு எண்ணைக் காட்டு",
    "app_customization.address_option_3": "மாநிலத்தைக் காட்டு",
    "Show State": "மாநிலத்தைக் காட்டு",
    "app_customization.address_option_4": "குறிப்பிட்ட புள்ளியைக் காட்டு",
    "Show Landmark": "குறிப்பிட்ட புள்ளியைக் காட்டு",
    "app_customization.address_option_5": "நகரத்தைக் காட்டு",
    "Show City": "நகரத்தைக் காட்டு",
    "app_customization.persistent_notification": "தொடர்ச்சியான அறிவிப்பு",
    "Persistent Notification": "தொடர்ச்சியான அறிவிப்பு",
    "app_customization.account_follow_content": "கணக்கு பின்பற்றும் அறிவிப்பு உள்ளடக்கம்",
    "Account follow notification content": "கணக்கு பின்பற்றும் அறிவிப்பு உள்ளடக்கம்",
    "app_customization.enter_account_follow_content": "கணக்கு பின்பற்றும் அறிவிப்பு உள்ளடக்கத்தை உள்ளிடவும்",
    "Enter Account follow notification content": "கணக்கு பின்பற்றும் அறிவிப்பு உள்ளடக்கத்தை உள்ளிடவும்",
    "app_customization.listing_like_content": "பட்டியலில் மிகவும் பிடித்த அறிவிப்பு உள்ளடக்கம்",
    "Listing like notification content": "பட்டியலில் மிகவும் பிடித்த அறிவிப்பு உள்ளடக்கம்",
    "app_customization.enter_listing_like_content": "உள்ளிடு போன்ற அறிவிப்பு உள்ளடக்கம்",
    "Enter Listing like  notification content": "உள்ளிடு போன்ற அறிவிப்பு உள்ளடக்கம்",
    "app_customization.order_status_content": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம்",
    "Order status notification content": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம்",
    "app_customization.enter_order_status_content": "ஆர்டர் ஸ்டேட்டஸ் பின்பற்றும் அறிவிப்பு உள்ளடக்கம்",
    "Order status follow notification content": "ஆர்டர் ஸ்டேட்டஸ் பின்பற்றும் அறிவிப்பு உள்ளடக்கம்",
    "app_customization.account_follow_required": "கணக்கு பின்பற்றும் அறிவிப்பு {account_name} ஐ கொண்டிருக்க வேண்டும்",
    "Account follow notification should contain {account_name}": "கணக்கு பின்பற்றும் அறிவிப்பு {account_name} ஐ கொண்டிருக்க வேண்டும்",
    "app_customization.listing_like_required": "ஆன்லைன் அறிவிப்பு உள்ளடக்கம் {user_name} ஐ கொண்டிருக்க வேண்டும்",
    "Listing like notification content should contain {user_name}": "ஆன்லைன் அறிவிப்பு உள்ளடக்கம் {user_name} ஐ கொண்டிருக்க வேண்டும்",
    "app_customization.order_number_required": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம் #{order_number} ஐ கொண்டிருக்க வேண்டும்",
    "Order status notification content should contain #{order_number}": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம் #{order_number} ஐ கொண்டிருக்க வேண்டும்",
    "app_customization.order_status_required": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம் {order_status} ஐ கொண்டிருக்க வேண்டும்",
    "Order status notification content should contain {order_status}": "ஆர்டர் ஸ்டேட்டஸ் அறிவிப்பு உள்ளடக்கம் {order_status} ஐ கொண்டிருக்க வேண்டும்",
    "app_customization.preview": "முன்னோட்டம்",
    "app_customization.splash": "தொடக்கத் திரை",
    "app_customization.splash_image": "ஸ்ப்ளாஷ் ஸ்கிரீன் படம்",
    "Splash Screen Image": "ஸ்ப்ளாஷ் ஸ்கிரீன் படம்",
    "app_customization.registration": "பதிவு",
    "app_customization.registration_text": "பதிவு உள்ளடக்கம்",
    "Registration text": "பதிவு உள்ளடக்கம்",
    "app_customization.otp_note": "OTP சரிபார்ப்பு குறிப்பு",
    "OTP Verification note": "OTP சரிபார்ப்பு குறிப்பு",
    "app_customization.get_signup_first": "முதலில் பதிவு பெறு",
    "app_customization.mobile_in_email_signup": "மின்னஞ்சல் பதிவில் மொபைல் எண்",
    "Mobile number in email signup": "மின்னஞ்சல் பதிவில் மொபைல் எண்",
    "app_customization.preview_field_first_name": "பெயர்",
    "app_customization.preview_field_last_name": "கடைசி பெயர்",
    "app_customization.preview_field_email": "மின்னஞ்சல்",
    "app_customization.preview_field_password": "கடவுச்சொல்",
    "Password": "கடவுச்சொல்",
    "app_customization.preview_field_confirm_password": "கடவுச்சொல்லை உறுதிப்படுத்து",
    "Confirm Password": "கடவுச்சொல்லை உறுதிப்படுத்து",
    "app_customization.preview_field_dob": "பிறந்த தேதி",
    "DOB": "பிறந்த தேதி",
    "app_customization.preview_field_mobile_no": "மொபைல் எண்",
    "Mobile No": "மொபைல் எண்",
    "app_customization.create": "உருவாக்கு",
    "app_customization.login": "உள்நுழைவு",
    "Login": "உள்நுழைவு",
    "app_customization.create_account": "கணக்கை உருவாக்கு",
    "Create your account": "கணக்கை உருவாக்கு",
    "app_customization.login_account": "கணக்கில் உள்நுழையவும்",
    "Login to your account": "கணக்கில் உள்நுழையவும்",
    "app_customization.onboarding_settings": "வரவேற்பு அமைப்புகள்",
    "Onboarding Settings": "வரவேற்பு அமைப்புகள்",
    "app_customization.onboarding_images": "வரவேற்பு படங்கள்",
    "Onboarding Images": "வரவேற்பு படங்கள்",
    "app_customization.onboarding_text_1": "வரவேற்பு உரை 1",
    "Onboarding text 1": "வரவேற்பு உரை 1",
    "app_customization.onboarding_text_2": "வரவேற்பு உரை 2",
    "Onboarding text 2": "வரவேற்பு உரை 2",
    "app_customization.onboarding_text_3": "வரவேற்பு உரை 3",
    "Onboarding text 3": "வரவேற்பு உரை 3",
    "app_customization.see_how_it_works": "அது எவ்வாறு பணியாற்றுகிறது என்பதைப் பார்க்கவும்",
    "See how it works": "அது எவ்வாறு பணியாற்றுகிறது என்பதைப் பார்க்கவும்",
    "app_customization.sell_icon_text": "விற்பனை ஐகான் உரை",
    "Sell icon text": "விற்பனை ஐகான் உரை",
    "app_customization.enter_sell_icon_text": "விற்பனை ஐகான் உரையை உள்ளிடவும்",
    "Enter sell icon text": "விற்பனை ஐகான் உரையை உள்ளிடவும்",
    "app_customization.sell_icon": "விற்பனை ஐகான்",
    "Sell Icon": "விற்பனை ஐகான்",
    "app_customization.enter_home_title": "முகப்பு திரையில் பயன்பாட்டு தலைப்பை உள்ளிடவும்",
    "Enter app title in home": "முகப்பு திரையில் பயன்பாட்டு தலைப்பை உள்ளிடவும்",
    "app_customization.app_details": "பயன்பாட்டு விவரங்கள்",
    "App Details": "பயன்பாட்டு விவரங்கள்",
    "app_customization.app_name": "பயன்பாட்டு பெயர்",
    "App Name": "பயன்பாட்டு பெயர்",
    "app_customization.primary_colour": "பயன்பாட்டின் முதன்மை நிறம்",
    "App Primary Colour": "பயன்பாட்டின் முதன்மை நிறம்",
    "app_customization.secondary_colour": "பயன்பாட்டின் இரண்டாம் நிறம்",
    "App Secondary Colour": "பயன்பாட்டின் இரண்டாம் நிறம்",
    "app_customization.android_app_icon": "Android பயன்பாட்டு ஐகான்",
    "App Icon Android": "Android பயன்பாட்டு ஐகான்",
    "app_customization.ios_app_icon": "iOS பயன்பாட்டு ஐகான்",
    "App Icon iOS": "iOS பயன்பாட்டு ஐகான்",
    "app_customization.screen_number": "திரை {number}",
    "Screen {number}": "திரை {number}",
    "app_customization.upload_here": "இங்கே பதிவேற்று",
    "Upload here": "இங்கே பதிவேற்று",
    "app_customization.next": "அடுத்தது",
    "app_customization.get_started": "தொடங்கு",
    "Get Start": "தொடங்கு",
    "app_customization.select": "தேர்வு செய்யவும்",
    "app_customization.app_title_home_icon": "முகப்பு ஐகானில் பயன்பாட்டு தலைப்பு",
    "App Title Home Icon": "முகப்பு ஐகானில் பயன்பாட்டு தலைப்பு",
    "app_customization.home_icon_hint": "(கோப்பு வடிவம் png மற்றும் வெள்ளை நிறத்தில் இருக்க வேண்டும்)",
    "(icon should be white and in png format)": "(கோப்பு வடிவம் png மற்றும் வெள்ளை நிறத்தில் இருக்க வேண்டும்)",
    "app_customization.home_title": "ஆரம்ப திரையில் பயன்பாட்டின் தலைப்பு",
    "app_customization.default_collection_widgets": "கூட்டு விவரங்கள் தொடர்பான தொடக்க விவரங்கள்",
    "Default Collection Widgets": "கூட்டு விவரங்கள் தொடர்பான தொடக்க விவரங்கள்",
    "app_customization.accounts_follow_title": "'பின்பற்ற வேண்டிய கணக்குகள்' கூட்டு தலைப்பு",
    "Accounts to follow collection title": "'பின்பற்ற வேண்டிய கணக்குகள்' கூட்டு தலைப்பு",
    "app_customization.enter_accounts_follow_title": "'பின்பற்ற வேண்டிய கணக்குகள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "Enter accounts to follow collection title": "'பின்பற்ற வேண்டிய கணக்குகள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "app_customization.nearby_accounts_title": "'அருகிலுள்ள கணக்குகள்' கூட்டு தலைப்பு",
    "Nearby accounts collection title": "'அருகிலுள்ள கணக்குகள்' கூட்டு தலைப்பு",
    "app_customization.enter_nearby_accounts_title": "'அருகிலுள்ள கணக்குகள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "Enter near by accounts collection title": "'அருகிலுள்ள கணக்குகள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "app_customization.latest_listings_title": "'சமீபத்திய பட்டியல்கள்' கூட்டு தலைப்பு",
    "Latest listings collection title": "'சமீபத்திய பட்டியல்கள்' கூட்டு தலைப்பு",
    "app_customization.enter_latest_listings_title": "'சமீபத்திய பட்டியல்கள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "Enter latest listings collection title": "'சமீபத்திய பட்டியல்கள்' கூட்டு தலைப்பை உள்ளிடவும்",
    "app_customization.enable_appearance_sections": "தோற்றத்தை செயல்படுத்த தேர்வு செய்யவும்",
    "Select to enable appearance sections": "தோற்றத்தை செயல்படுத்த தேர்வு செய்யவும்",
    "app_customization.choose_photo": "படத்தைத் தேர்வு செய்யவும்",
    "Choose photo": "படத்தைத் தேர்வு செய்யவும்",
    "app_customization.choose_icon": "ஐகானைத் தேர்வு செய்யவும்",
    "Choose icon": "ஐகானைத் தேர்வு செய்யவும்",
    "app_customization.enable_home_icon": "எழுத்துக்களுக்குப் பதிலாக பயன்பாட்டு தலைப்பு ஐகானை செயல்படுத்தவும்",
    "app_customization.account_name": "கணக்கு பெயர்",
    "Account Name": "கணக்கு பெயர்",
    "app_customization.product_name": "தயாரிப்பு பெயர்",
    "Product Name": "தயாரிப்பு பெயர்",
    "app_customization.home_option_0": "'அருகிலுள்ளவை' கூட்டைக் காட்டு",
    "Show nearby collection": "'அருகிலுள்ளவை' கூட்டைக் காட்டு",
    "app_customization.home_option_1": "வகைப்பாடுகள் பிரிவைக் காட்டு",
    "Show category section": "வகைப்பாடுகள் பிரிவைக் காட்டு",
    "app_customization.home_option_2": "மேம்பாட்டு பேனர்களைக் காட்டு",
    "Show promo banners": "மேம்பாட்டு பேனர்களைக் காட்டு",
    "app_customization.home_option_3": "மைத்துனர்களை அழைக்க காட்டு",
    "Show invite friends": "மைத்துனர்களை அழைக்க காட்டு",
    "app_customization.home_option_4": "மதிப்பீடுகள் நினைவூட்டல்களைக் காட்டு",
    "Show review reminders": "மதிப்பீடுகள் நினைவூட்டல்களைக் காட்டு",
    "app_customization.home_option_5": "பின்பற்ற வேண்டிய கணக்குகள்",
    "Accounts to follow": "பின்பற்ற வேண்டிய கணக்குகள்",
    "app_customization.download": "பதிவிறக்கம்",
    "app_customization.cancel": "ரத்து செய்யவும்",
    "app_customization.uploaded_successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "app_customization.image_limit": "நீங்கள் மேலும் படங்களைத் தேர்வு செய்ய முடியாது",
    "app_customization.choose_zip_file": "zip கோப்பைத் தேர்வுசெய்க",
    "Choose zip file": "zip கோப்பைத் தேர்வுசெய்க",
    "app_translation.title": "சரிபார்ப்பு திருத்தம்",
    "app_translation.search": "தேடுவதற்கு உள்ளிடவும்...",
    "app_translation.default_language": "இயல்புநிலை",
    "app_translation.default_text": "இயல்புநிலை உரை",
    "communications.title": "தொடர்புகள்",
    "communications.tab_0": "மின்னஞ்சல் அறிவிப்பு",
    "Email Notification": "மின்னஞ்சல் அறிவிப்பு",
    "communications.tab_1": "மின்னஞ்சல் அமைப்புகள்",
    "Email Configuration": "மின்னஞ்சல் அமைப்புகள்",
    "communications.tab_2": "ஆர்டர் அறிவிப்பு",
    "Order Notification": "ஆர்டர் அறிவிப்பு",
    "communications.tab_3": "கருத்துக்கள் படிவம்",
    "Feedback Form": "கருத்துக்கள் படிவம்",
    "communications.translate": "மொழிபெயர்க்கவும்",
    "communications.edit_email_template": "மின்னஞ்சல் மாதிரி தொகுக்கவும்",
    "Edit email template": "மின்னஞ்சல் மாதிரி தொகுக்கவும்",
    "communications.feedback_email": "மின்னஞ்சல்",
    "communications.feedback_phone": "தொலைபேசி",
    "communications.feedback_email_or_phone": "மின்னஞ்சல் அல்லது தொலைபேசி",
    "Email or Phone": "மின்னஞ்சல் அல்லது தொலைபேசி",
    "communications.select_type": "வகையைத் தேர்வுசெய்க",
    "communications.form_required_field": "படிவ கட்டாய புலம்",
    "Form Required Field": "படிவ கட்டாய புலம்",
    "communications.feedback_recipient_label": "கருத்துக்களைப் பெற மின்னஞ்சல் (ஒன்றுக்கு மேற்பட்ட மின்னஞ்சலை பிரித்து உள்ளிடவும்)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "கருத்துக்களைப் பெற மின்னஞ்சல் (ஒன்றுக்கு மேற்பட்ட மின்னஞ்சலை பிரித்து உள்ளிடவும்)",
    "communications.enter_email": "மின்னஞ்சலை உள்ளிடவும்",
    "Enter email": "மின்னஞ்சலை உள்ளிடவும்",
    "communications.enable_feedback_form": "கருத்துக்கள் படிவத்தை செயல்படுத்தவும்",
    "Enable feedback Form": "கருத்துக்கள் படிவத்தை செயல்படுத்தவும்",
    "communications.feedback": "கருத்துக்கள்",
    "Feedback": "கருத்துக்கள்",
    "communications.realtime_config_notice": "இந்த அமைப்புகள் நேரடியாக பயன்படுத்தப்படும். இங்கு மாற்றங்களைச் செய்து சேமிக்க கிளிக் செய்தால், அது பயன்பாடுகள் மற்றும் API பதில்களில் பிரதிபலிக்கும்.",
    "communications.uploaded_successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "communications.email_whitelabeling": "மின்னஞ்சல் வெள்ளை லேபிள் வசதி",
    "Email Whitelabelling": "மின்னஞ்சல் வெள்ளை லேபிள் வசதி",
    "communications.from_name": "மேற்கோள் பெயர்",
    "From name": "மேற்கோள் பெயர்",
    "communications.enter_from_name": "மேற்கோள் பெயரை உள்ளிடவும்",
    "Enter from name": "மேற்கோள் பெயரை உள்ளிடவும்",
    "communications.from_email_address": "மேற்கோள் மின்னஞ்சல் முகவரி",
    "From email address": "மேற்கோள் மின்னஞ்சல் முகவரி",
    "communications.from_email_domain_hint": "உங்கள் மேற்கோள் மின்னஞ்சல் முகவரிக்கு தனிப்பயன் டொமைனை தேர்ந்தெடுத்துள்ளீர்கள். உங்கள் மின்னஞ்சல்கள் அனுப்பப்படுவதை உறுதிப்படுத்த, உங்கள் டொமைனை நாங்கள் உறுதிப்படுத்த வேண்டும். உறுதிப்பாட்டு செயல்முறையில் உதவி கோர, எங்கள் ஆதரவு குழுவை தொடர்புகொள்ளவும்.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "உங்கள் மேற்கோள் மின்னஞ்சல் முகவரிக்கு தனிப்பயன் டொமைனை தேர்ந்தெடுத்துள்ளீர்கள். உங்கள் மின்னஞ்சல்கள் அனுப்பப்படுவதை உறுதிப்படுத்த, உங்கள் டொமைனை நாங்கள் உறுதிப்படுத்த வேண்டும். உறுதிப்பாட்டு செயல்முறையில் உதவி கோர, எங்கள் ஆதரவு குழுவை தொடர்புகொள்ளவும்.",
    "communications.reset": "மீளமைப்பு",
    "communications.enter_from_email": "மேற்கோள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    "Enter from email address": "மேற்கோள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    "communications.email_header_logo": "மின்னஞ்சல் தலைப்பு லோகோ",
    "Email Header Logo": "மின்னஞ்சல் தலைப்பு லோகோ",
    "communications.choose_logo": "50*50 கோப்பைத் தேர்வு செய்யவும்",
    "Choose file 50*50": "50*50 கோப்பைத் தேர்வு செய்யவும்",
    "communications.list_view": "பட்டியல் காட்சி",
    "communications.gallery_view": "கலைக்காட்சி காட்சி",
    "Gallery view": "கலைக்காட்சி காட்சி",
    "communications.grid_view": "கிரிட் காட்சி",
    "communications.search": "தகவல்களைத் தேடு",
    "Search communications": "தகவல்களைத் தேடு",
    "communications.email_settings": "மின்னஞ்சல் அமைப்புகள்",
    "Email settings": "மின்னஞ்சல் அமைப்புகள்",
    "communications.category_all": "எல்லாம்",
    "communications.category_buyer": "வாங்குபவர்",
    "Buyer": "வாங்குபவர்",
    "communications.category_seller": "விற்பனையாளர்",
    "communications.category_transactional": "மாற்று நிகழ்வு",
    "Transactional": "மாற்று நிகழ்வு",
    "communications.category_engagement": "இணைப்பு",
    "Engagement": "இணைப்பு",
    "communications.category_retention": "பராமரிப்பு",
    "Retention": "பராமரிப்பு",
    "communications.category_membership": "உறுப்பினர்",
    "communications.audience_buyer": "வாங்குபவர்",
    "communications.audience_seller": "விற்பனையாளர்",
    "communications.system_notification": "குறிப்பிட்ட அறிவிப்பு",
    "System notification": "குறிப்பிட்ட அறிவிப்பு",
    "communications.template": "தானியங்கி",
    "template": "தானியங்கி",
    "communications.edit": "தொகுப்பு",
    "communications.sent": "அனுப்பப்பட்டது",
    "sent": "அனுப்பப்பட்டது",
    "communications.open": "திறந்தது",
    "open": "திறந்தது",
    "communications.clicks": "கிளிக்குகள்",
    "clicks": "கிளிக்குகள்",
    "communications.no_email_matches": "உங்கள் தேர்வுக்கு பொருந்தும் மின்னஞ்சல் இல்லை.",
    "No emails match your filter.": "உங்கள் தேர்வுக்கு பொருந்தும் மின்னஞ்சல் இல்லை.",
    "communications.buyer_order_confirmation": "வாங்குபவருக்கான ஆர்டர் உறுதிப்பாடு மின்னஞ்சல்",
    "Order confirmation email for buyer": "வாங்குபவருக்கான ஆர்டர் உறுதிப்பாடு மின்னஞ்சல்",
    "communications.seller_order_confirmation": "விற்பனையாளருக்கான ஆர்டர் உறுதிப்பாடு மின்னஞ்சல்",
    "Order confirmation email for seller": "விற்பனையாளருக்கான ஆர்டர் உறுதிப்பாடு மின்னஞ்சல்",
    "communications.email_card_0": "வரவேற்பு செய்தி",
    "Welcome Message": "வரவேற்பு செய்தி",
    "communications.email_card_1": "OTP / சரிபார்ப்பு",
    "OTP / Verification": "OTP / சரிபார்ப்பு",
    "communications.email_card_2": "பதிவு இணைப்பு",
    "Subscription Link": "பதிவு இணைப்பு",
    "communications.email_card_3": "பதிவு வெற்றி",
    "Subscription Success": "பதிவு வெற்றி",
    "communications.email_card_4": "ஆர்டர் உறுதிப்பாடு — வாங்குபவர்",
    "Order confirmation — buyer": "ஆர்டர் உறுதிப்பாடு — வாங்குபவர்",
    "communications.email_card_5": "ஆர்டர் உறுதிப்பாடு — விற்பனையாளர்",
    "Order confirmation — seller": "ஆர்டர் உறுதிப்பாடு — விற்பனையாளர்",
    "communications.email_card_6": "அனுப்பப்பட்ட பொருள் — வாங்குபவர்",
    "Shipment shipped — buyer": "அனுப்பப்பட்ட பொருள் — வாங்குபவர்",
    "communications.email_card_7": "கொடுக்கப்பட்ட பொருள் — வாங்குபவர்",
    "Shipment delivered — buyer": "கொடுக்கப்பட்ட பொருள் — வாங்குபவர்",
    "communications.email_card_8": "ஆர்டர் ரத்து செய்யப்பட்டது — வாங்குபவர்",
    "Order cancelled — buyer": "ஆர்டர் ரத்து செய்யப்பட்டது — வாங்குபவர்",
    "communications.email_card_9": "மீள்வழங்கல் செய்யப்பட்டது — வாங்குபவர்",
    "Refund processed — buyer": "மீள்வழங்கல் செய்யப்பட்டது — வாங்குபவர்",
    "communications.email_card_10": "பின்பற்றப்பட்ட கடையின் புதிய பட்டியல் — வாங்குபவர்",
    "New listing from followed store — buyer": "பின்பற்றப்பட்ட கடையின் புதிய பட்டியல் — வாங்குபவர்",
    "communications.email_card_11": "புதிய ஸ்டாக்கில் உள்ள பொருள் — வாங்குபவர்",
    "Back in stock — buyer": "புதிய ஸ்டாக்கில் உள்ள பொருள் — வாங்குபவர்",
    "communications.email_card_12": "பட்டியல் காலாவதியானது — விற்பனையாளர்",
    "Listing expiry warning — seller": "பட்டியல் காலாவதியானது — விற்பனையாளர்",
    "communications.email_card_13": "பட்டியலில் பிடித்த லைக்ஸ் — விற்பனையாளர்",
    "Listing likes milestone — seller": "பட்டியலில் பிடித்த லைக்ஸ் — விற்பனையாளர்",
    "communications.email_card_14": "கணக்கு சரிபார்க்கப்பட்டது — விற்பனையாளர்",
    "Account verified — seller": "கணக்கு சரிபார்க்கப்பட்டது — விற்பனையாளர்",
    "communications.email_card_15": "விற்பனையாளர் மீட்பு — விற்பனையாளர்",
    "Seller win-back — seller": "விற்பனையாளர் மீட்பு — விற்பனையாளர்",
    "communications.email_card_16": "குறைந்த ஸ்டாக் எச்சரிக்கை — விற்பனையாளர்",
    "Low stock warning — seller": "குறைந்த ஸ்டாக் எச்சரிக்கை — விற்பனையாளர்",
    "communications.email_card_17": "விற்பனையாளர் பதிவு செய்யப்பட்டது — விற்பனையாளர்",
    "Seller onboarded — seller": "விற்பனையாளர் பதிவு செய்யப்பட்டது — விற்பனையாளர்",
    "communications.email_card_18": "மதிப்பீட்டு கோரிக்கை — வாங்குபவர்",
    "Review request — buyer": "மதிப்பீட்டு கோரிக்கை — வாங்குபவர்",
    "communications.email_card_19": "முதல் விற்பனை — விற்பனையாளர்",
    "First sale — seller": "முதல் விற்பனை — விற்பனையாளர்",
    "communications.email_card_20": "விற்பனை மைல்கற்கள் — விற்பனையாளர்",
    "Sales milestone — seller": "விற்பனை மைல்கற்கள் — விற்பனையாளர்",
    "communications.email_card_21": "வாடிக்கையாளரை மீட்பது — வாங்குபவர்",
    "Win-back — buyer": "வாடிக்கையாளரை மீட்பது — வாங்குபவர்",
    "communications.email_card_22": "முதல் வாங்குதல் — வாங்குபவர்",
    "First purchase — buyer": "முதல் வாங்குதல் — வாங்குபவர்",
    "communications.email_card_23": "வாடிக்கையாளர் கேள்வி — விற்பனையாளர்",
    "Customer question — seller": "வாடிக்கையாளர் கேள்வி — விற்பனையாளர்",
    "communications.email_card_24": "விற்பனையாளரின் பதில் — வாங்குபவர்",
    "Seller answer — buyer": "விற்பனையாளரின் பதில் — வாங்குபவர்",
    "communications.email_card_25": "பேச்சுவார்த்தை முன்மொழிவு — விற்பனையாளர்",
    "Negotiation offer — seller": "பேச்சுவார்த்தை முன்மொழிவு — விற்பனையாளர்",
    "communications.email_card_26": "ஏற்றுக்கொள்ளப்பட்ட முன்மொழிவு — வாங்குபவர்",
    "Offer accepted — buyer": "ஏற்றுக்கொள்ளப்பட்ட முன்மொழிவு — வாங்குபவர்",
    "communications.email_card_27": "தள்ளுபடி செய்யப்பட்ட முன்மொழிவு — வாங்குபவர்",
    "Offer rejected — buyer": "தள்ளுபடி செய்யப்பட்ட முன்மொழிவு — வாங்குபவர்",
    "communications.email_card_28": "புதிய பின்பற்றுபவர் — விற்பனையாளர்",
    "New follower — seller": "புதிய பின்பற்றுபவர் — விற்பனையாளர்",
    "communications.email_card_29": "அனுப்பப்பட்ட பட்டியல் — விற்பனையாளர்",
    "Listing liked — seller": "அனுப்பப்பட்ட பட்டியல் — விற்பனையாளர்",
    "communications.email_card_30": "பதிவு ஒப்புதல் — விற்பனையாளர்",
    "Listing approved — seller": "பதிவு ஒப்புதல் — விற்பனையாளர்",
    "communications.email_card_31": "பதிவு தள்ளுபடி — விற்பனையாளர்",
    "Listing rejected — seller": "பதிவு தள்ளுபடி — விற்பனையாளர்",
    "communications.email_card_32": "முதல் பட்டியல் — விற்பனையாளர்",
    "First listing — seller": "முதல் பட்டியல் — விற்பனையாளர்",
    "communications.email_card_33": "விட்டு சென்ற வாடிக்கையாளர் வாகனம் — வாங்குபவர்",
    "Abandoned cart — buyer": "விட்டு சென்ற வாடிக்கையாளர் வாகனம் — வாங்குபவர்",
    "communications.email_card_34": "பட்டியல் மதிப்பீடு — விற்பனையாளர்",
    "Listing review — seller": "பட்டியல் மதிப்பீடு — விற்பனையாளர்",
    "communications.email_card_35": "நிறைவேற்றுதல் நினைவூட்டி — விற்பனையாளர்",
    "Fulfillment reminder — seller": "நிறைவேற்றுதல் நினைவூட்டி — விற்பனையாளர்",
    "communications.email_card_36": "விலை குறைப்பு — வாங்குபவர்",
    "Price drop — buyer": "விலை குறைப்பு — வாங்குபவர்",
    "communications.email_card_37": "உறுப்பினர் கட்டணம் அருகில் வருகிறது",
    "Membership payment due soon": "உறுப்பினர் கட்டணம் அருகில் வருகிறது",
    "communications.email_card_38": "உறுப்பினர் கட்டணம் கடன்",
    "Membership payment overdue": "உறுப்பினர் கட்டணம் கடன்",
    "communications.order_status_notification": "ஆர்டர் நிலை அறிவிப்பு",
    "Order Status Notification": "ஆர்டர் நிலை அறிவிப்பு",
    "communications.order_group_lifecycle": "ஆர்டர் வாழ்க்கை சுழற்சி",
    "Order lifecycle": "ஆர்டர் வாழ்க்கை சுழற்சி",
    "communications.order_group_returns": "மீள்வழங்கல் மற்றும் கொடுக்கப்பட்ட பிரச்சனைகள்",
    "Returns and delivery issues": "மீள்வழங்கல் மற்றும் கொடுக்கப்பட்ட பிரச்சனைகள்",
    "communications.order_group_cancellations": "ரத்து செய்தல் மற்றும் எடுத்துச் செல்லுதல்",
    "Cancellations and pickup": "ரத்து செய்தல் மற்றும் எடுத்துச் செல்லுதல்",
    "communications.notification_settings_count": "{count} அறிவிப்பு அமைப்புகள்",
    "{count} notification settings": "{count} அறிவிப்பு அமைப்புகள்",
    "communications.enter_order_field": "{field} உள்ளிடவும்",
    "Enter {field}": "{field} உள்ளிடவும்",
    "communications.order_field_0": "ஆர்டர் நிலை உறுதிப்படுத்தப்பட்டது",
    "Order status confirmed": "ஆர்டர் நிலை உறுதிப்படுத்தப்பட்டது",
    "communications.order_field_1": "ஆர்டர் நிலை தொடர்ச்சியாக உள்ளது",
    "Order status in progress": "ஆர்டர் நிலை தொடர்ச்சியாக உள்ளது",
    "communications.order_field_2": "ஆர்டர் நிலை அனுப்பப்பட்டது",
    "Order status shipped": "ஆர்டர் நிலை அனுப்பப்பட்டது",
    "communications.order_field_3": "ஆர்டர் நிலை வாடிக்கையாளர் கண்டுபிடிக்க முடியாதது",
    "Order status customer unreachable": "ஆர்டர் நிலை வாடிக்கையாளர் கண்டுபிடிக்க முடியாதது",
    "communications.order_field_4": "ஆர்டர் நிலை வழங்கலுக்கு பயணம் செய்து கொண்டிருக்கிறது",
    "Order status out for delivery": "ஆர்டர் நிலை வழங்கலுக்கு பயணம் செய்து கொண்டிருக்கிறது",
    "communications.order_field_5": "ஆர்டர் நிலை வழங்கப்படாமல் திரும்ப அனுப்பப்பட்டது",
    "Order status undelivered returned": "ஆர்டர் நிலை வழங்கப்படாமல் திரும்ப அனுப்பப்பட்டது",
    "communications.order_field_6": "ஆர்டர் நிலை வழங்கப்படாமல் திரும்ப அனுப்பப்பட்டது உறுதிப்படுத்தப்பட்டது",
    "Order status undelivered return confirmed": "ஆர்டர் நிலை வழங்கப்படாமல் திரும்ப அனுப்பப்பட்டது உறுதிப்படுத்தப்பட்டது",
    "communications.order_field_7": "ஆர்டர் நிலை வழங்கப்பட்டது",
    "Order status delivered": "ஆர்டர் நிலை வழங்கப்பட்டது",
    "communications.order_field_8": "ஆர்டர் நிலை வழங்கப்பட்டது உறுதிப்படுத்தப்பட்டது",
    "Order status delivered confirmed": "ஆர்டர் நிலை வழங்கப்பட்டது உறுதிப்படுத்தப்பட்டது",
    "communications.order_field_9": "ஆர்டர் நிலை வாடிக்கையாளர் தொடங்கிய திரும்பப் பெறுதல்",
    "Order status customer return initiated": "ஆர்டர் நிலை வாடிக்கையாளர் தொடங்கிய திரும்பப் பெறுதல்",
    "communications.order_field_10": "ஆர்டர் நிலை வாடிக்கையாளர் எடுத்துச் சென்ற திரும்பப் பெறுதல்",
    "Order status customer return picked": "ஆர்டர் நிலை வாடிக்கையாளர் எடுத்துச் சென்ற திரும்பப் பெறுதல்",
    "communications.order_field_11": "ஆர்டர் நிலை வாடிக்கையாளர் உறுதிப்படுத்திய திரும்பப் பெறுதல்",
    "Order status customer return confirmed": "ஆர்டர் நிலை வாடிக்கையாளர் உறுதிப்படுத்திய திரும்பப் பெறுதல்",
    "communications.order_field_12": "ஆர்டர் நிலை வாடிக்கையாளர் முறையிடப்பட்ட திரும்பப் பெறுதல்",
    "Order status customer return disputed": "ஆர்டர் நிலை வாடிக்கையாளர் முறையிடப்பட்ட திரும்பப் பெறுதல்",
    "communications.order_field_13": "ஆர்டர் நிலை கணக்கில் ரத்து செய்யப்பட்டது",
    "Order status cancelled by account": "ஆர்டர் நிலை கணக்கில் ரத்து செய்யப்பட்டது",
    "communications.order_field_14": "ஆர்டர் நிலை வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "Order status cancelled by customer": "ஆர்டர் நிலை வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "communications.order_field_15": "ஆர்டர் நிலை எடுக்க தயாராக உள்ளது",
    "Order status ready for pickup": "ஆர்டர் நிலை எடுக்க தயாராக உள்ளது",
    "communications.order_field_16": "ஆர்டர் நிலை முடிக்கப்பட்டது",
    "Order status completed": "ஆர்டர் நிலை முடிக்கப்பட்டது",
    "communications.update": "தொகுப்பு",
    "communications.download_template": "தானியங்கி பதிவிறக்கம்",
    "Download Template": "தானியங்கி பதிவிறக்கம்",
    "communications.reset_to_default": "இயல்புநிலைக்கு மீட்டமை",
    "communications.send_test_email": "சோதனை மின்னஞ்சலை அனுப்பு",
    "Send test email": "சோதனை மின்னஞ்சலை அனுப்பு",
    "communications.enter_test_emails": "மின்னஞ்சல்களை கோடிட்ட புள்ளிகளுக்கு இடையே பிரித்து உள்ளிடவும்",
    "Enter email(s), comma-separated": "மின்னஞ்சல்களை கோடிட்ட புள்ளிகளுக்கு இடையே பிரித்து உள்ளிடவும்",
    "communications.send_test": "சோதனை அனுப்பு",
    "Send test": "சோதனை அனுப்பு",
    "communications.subject_required": "விஷயம் காலியாக இருக்கக்கூடாது",
    "Subject should not be empty": "விஷயம் காலியாக இருக்கக்கூடாது",
    "communications.body_required": "பிரிவு காலியாக இருக்கக்கூடாது",
    "Body should not be empty": "பிரிவு காலியாக இருக்கக்கூடாது",
    "communications.code_merge_tag_required": "{code} சேர்க்கை குறியீடு அவசியம்",
    "{code} merge tag is mandatory": "{code} சேர்க்கை குறியீடு அவசியம்",
    "communications.edit_template_named": "{name} ஐ தொகுத்தல்",
    "Edit {name}": "{name} ஐ தொகுத்தல்",
    "communications.subject": "விஷயம்",
    "Subject": "விஷயம்",
    "communications.enter_subject": "விஷயத்தை உள்ளிடவும்",
    "Enter the Subject": "விஷயத்தை உள்ளிடவும்",
    "communications.available_merge_tags": "கிடைக்கும் சேர்க்கை குறியீடுகள்:",
    "Available merge tags:": "கிடைக்கும் சேர்க்கை குறியீடுகள்:",
    "communications.body": "பிரிவு",
    "Body": "பிரிவு",
    "communications.write_here": "இங்கே எழுதவும்...",
    "Write here...": "இங்கே எழுதவும்...",
    "communications.subject_line": "விஷய வரி",
    "Subject Line": "விஷய வரி",
    "communications.enter_subject_line": "விஷயத்தை உள்ளிடவும்…",
    "Enter the subject…": "விஷயத்தை உள்ளிடவும்…",
    "communications.merge_tags": "சேர்க்கை குறியீடுகள்",
    "Merge tags": "சேர்க்கை குறியீடுகள்",
    "communications.loading_templates": "தானியங்கி மாதிரிகளை ஏற்றுகிறது…",
    "Loading templates…": "தானியங்கி மாதிரிகளை ஏற்றுகிறது…",
    "communications.hide_templates": "மாதிரிகளை மறை",
    "Hide templates": "மாதிரிகளை மறை",
    "communications.load_template": "மாதிரியை ஏற்றுகொள்",
    "Load template": "மாதிரியை ஏற்றுகொள்",
    "communications.html_body": "HTML பிரிவு",
    "HTML Body": "HTML பிரிவு",
    "communications.enter_html_body": "HTML ஐ இங்கே ஒட்டவும் அல்லது எழுதவும்…",
    "Paste or type your HTML here…": "HTML ஐ இங்கே ஒட்டவும் அல்லது எழுதவும்…",
    "communications.live_preview": "ஆன்லைன் முன்னோட்டம்",
    "Live Preview": "ஆன்லைன் முன்னோட்டம்",
    "communications.desktop": "ஆடியோ திரை",
    "Desktop": "ஆடியோ திரை",
    "communications.mobile": "மொபைல்",
    "communications.email_preview": "மின்னஞ்சல் முன்னோட்டம்",
    "Email preview": "மின்னஞ்சல் முன்னோட்டம்",
    "communications.start_typing_preview": "முன்னோட்டத்தைக் காண உரையாடுங்கள்",
    "Start typing to see a preview": "முன்னோட்டத்தைக் காண உரையாடுங்கள்",
    "communications.translations": "மொழிபெயர்ப்புகள்",
    "translations": "மொழிபெயர்ப்புகள்",
    "communications.validation_account_follow_tag": "கணக்கு பின்பற்றும் அறிவிப்பு {account_name} ஐ கொண்டிருக்க வேண்டும்",
    "communications.validation_listing_like_tag": "பட்டியல் பின்பற்றும் அறிவிப்பு {user_name} ஐ கொண்டிருக்க வேண்டும்",
    "Listing follow notification should contain {user_name}": "பட்டியல் பின்பற்றும் அறிவிப்பு {user_name} ஐ கொண்டிருக்க வேண்டும்",
    "communications.validation_order_number_tag": "ஆர்டர் நிலை பின்பற்றும் அறிவிப்பு #{order_number} ஐ கொண்டிருக்க வேண்டும்",
    "Order status follow notification should contain #{order_number}": "ஆர்டர் நிலை பின்பற்றும் அறிவிப்பு #{order_number} ஐ கொண்டிருக்க வேண்டும்",
    "communications.validation_order_status_tag": "ஆர்டர் நிலை பின்பற்றும் அறிவிப்பு {order_status} ஐ கொண்டிருக்க வேண்டும்",
    "Order status follow notification should contain {order_status}": "ஆர்டர் நிலை பின்பற்றும் அறிவிப்பு {order_status} ஐ கொண்டிருக்க வேண்டும்",
    "communications.journey_title": "மின்னஞ்சல் பயண வரைபடம்",
    "Email Journey Map": "மின்னஞ்சல் பயண வரைபடம்",
    "communications.journey_subtitle": "பயனர் வாழ்க்கை சுழற்சியில் ஒவ்வொரு மின்னஞ்சலும் எங்கு அனுப்பப்படுகிறது",
    "Where each email fires in the user lifecycle": "பயனர் வாழ்க்கை சுழற்சியில் ஒவ்வொரு மின்னஞ்சலும் எங்கு அனுப்பப்படுகிறது",
    "communications.journey_buyer": "வாங்குபவர் பயணம்",
    "Buyer Journey": "வாங்குபவர் பயணம்",
    "communications.journey_seller": "விற்பனையாளர் பயணம்",
    "Seller Journey": "விற்பனையாளர் பயணம்",
    "communications.journey_buyer_stage_0": "பதிவுசெய்தல்",
    "Sign Up": "பதிவுசெய்தல்",
    "communications.journey_buyer_stage_1": "தேடுதல்",
    "Browse": "தேடுதல்",
    "communications.journey_buyer_stage_2": "வாடிக்கையாளர் கார்ட்",
    "communications.journey_buyer_stage_3": "ஆர்டர் செய்யப்பட்டது",
    "Order Placed": "ஆர்டர் செய்யப்பட்டது",
    "communications.journey_buyer_stage_4": "அனுப்பப்பட்டது",
    "communications.journey_buyer_stage_5": "கொடுக்கப்பட்டது",
    "communications.journey_buyer_stage_6": "பேச்சுவாராய்வு",
    "Negotiate": "பேச்சுவாராய்வு",
    "communications.journey_buyer_stage_7": "இயங்காத",
    "communications.journey_seller_stage_0": "ஆரம்ப பதிவு",
    "Onboard": "ஆரம்ப பதிவு",
    "communications.journey_seller_stage_1": "பட்டியலிடுதல்",
    "communications.journey_seller_stage_2": "நிர்வாகம்",
    "communications.journey_seller_stage_3": "வரும் ஆர்டர்",
    "Order In": "வரும் ஆர்டர்",
    "communications.journey_seller_stage_4": "அனுப்புதல்",
    "communications.journey_seller_stage_5": "முடிக்கப்பட்டது",
    "Complete": "முடிக்கப்பட்டது",
    "communications.journey_seller_stage_6": "இயங்காத",
    "accounts.title": "கணக்குகள்",
    "accounts.status_pending": "தொடங்கப்படவில்லை",
    "accounts.status_approved": "ஒப்புக்கொடுக்கப்பட்டது",
    "accounts.status_rejected": "நிராகரிக்கப்பட்டது",
    "accounts.show_rows": "வரிகளைக் காட்டு",
    "accounts.next": "அடுத்தது",
    "accounts.previous": "முன்னோட்டம்",
    "accounts.view_list": "பட்டியல்",
    "accounts.view_map": "மேப்பு",
    "Map": "மேப்பு",
    "accounts.view_board": "போர்டு",
    "accounts.view_grid": "கிரிட்",
    "accounts.view_list_accessibility": "பட்டியல் காட்சி",
    "accounts.view_map_accessibility": "மேப் காட்சி",
    "Map view": "மேப் காட்சி",
    "accounts.view_board_accessibility": "போர்டு காட்சி",
    "Board view": "போர்டு காட்சி",
    "accounts.view_grid_accessibility": "கிரிட் காட்சி",
    "accounts.column_name": "பெயர்",
    "accounts.column_account_id": "கணக்கு ஐடி",
    "accounts.column_description": "விளக்கம்",
    "accounts.column_image": "படம்",
    "accounts.column_user_name": "பயனர் பெயர்",
    "User Name": "பயனர் பெயர்",
    "accounts.column_email": "மின்னஞ்சல்",
    "accounts.column_status": "நிலை",
    "accounts.column_account_status": "கணக்கு நிலை",
    "Account Status": "கணக்கு நிலை",
    "accounts.column_location": "இடம்",
    "accounts.search": "கணக்குகளைத் தேடு",
    "Search accounts": "கணக்குகளைத் தேடு",
    "accounts.export": "வெளியீடு",
    "accounts.import": "கொண்டுவருதல்",
    "accounts.export_accounts": "கணக்குகளை வெளியீடு",
    "Export accounts": "கணக்குகளை வெளியீடு",
    "accounts.import_accounts": "கணக்குகளை கொண்டுவருதல்",
    "Import accounts": "கணக்குகளை கொண்டுவருதல்",
    "accounts.smart_upload_accounts": "கணக்குகளை குறிப்பிட்ட முறையில் ஏற்றுதல்",
    "Smart Upload accounts": "கணக்குகளை குறிப்பிட்ட முறையில் ஏற்றுதல்",
    "accounts.export_all_question": "எல்லா கணக்குகளையும் வெளியீடு செய்ய வேண்டுமா?",
    "Export all accounts?": "எல்லா கணக்குகளையும் வெளியீடு செய்ய வேண்டுமா?",
    "accounts.export_all_description": "இது அனைத்து கணக்குகளையும் கொண்டிருக்கும் கோப்பை தயாரிக்கும். மேம்படுத்துவதற்கு முன் இந்த வேலை முறையை மீண்டும் பார்க்கலாம்.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "இது அனைத்து கணக்குகளையும் கொண்டிருக்கும் கோப்பை தயாரிக்கும். மேம்படுத்துவதற்கு முன் இந்த வேலை முறையை மீண்டும் பார்க்கலாம்.",
    "accounts.export_all": "எல்லா கணக்குகளையும் வெளியீடு",
    "Export all accounts": "எல்லா கணக்குகளையும் வெளியீடு",
    "accounts.cancel": "ரத்துசெய்",
    "accounts.active": "செயல்பாட்டில்",
    "accounts.inactive": "இயங்காத",
    "accounts.not_available": "கிடைக்காது",
    "accounts.approve": "ஒப்புக்கொள்",
    "accounts.reject": "திரும்ப அனுப்பு",
    "accounts.manage": "நிர்வகி",
    "accounts.tooltip_title": "கணக்குகள் கடைகளைப் போலவே உள்ளன.",
    "Accounts are like shops.": "கணக்குகள் கடைகளைப் போலவே உள்ளன.",
    "accounts.tooltip_description": "பயனர்கள் தங்கள் தளத்தில் வணிகம் நடத்த இடத்தை உருவாக்கலாம். இவை கணக்குகள். ஒரு பயனர் கணக்கு தேவையில்லாமல் இருக்கலாம், மேலும் கணக்குகள் பேமெண்ட்களைப் பெற டெபாசிட் கணக்குகளுடன் இணைக்கலாம்.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "பயனர்கள் தங்கள் தளத்தில் வணிகம் நடத்த இடத்தை உருவாக்கலாம். இவை கணக்குகள். ஒரு பயனர் கணக்கு தேவையில்லாமல் இருக்கலாம், மேலும் கணக்குகள் பேமெண்ட்களைப் பெற டெபாசிட் கணக்குகளுடன் இணைக்கலாம்.",
    "accounts.create_account": "கணக்கை உருவாக்கு",
    "Create Account": "கணக்கை உருவாக்கு",
    "accounts.create_new_account": "புதிய கணக்கை உருவாக்கு",
    "Create New Account": "புதிய கணக்கை உருவாக்கு",
    "accounts.save": "சேமி",
    "accounts.please_wait": "காத்திருக்கவும்...",
    "Please wait...": "காத்திருக்கவும்...",
    "accounts.account_name": "கணக்கு பெயர்",
    "accounts.slug": "ஸ்லக்",
    "Slug": "ஸ்லக்",
    "accounts.account_slug": "கணக்கு ஸ்லக்",
    "Account Slug": "கணக்கு ஸ்லக்",
    "accounts.account_description": "கணக்கு விவரக்குறிப்பு",
    "Account Description": "கணக்கு விவரக்குறிப்பு",
    "accounts.enter_name_first": "முதலில் தலைப்பை உள்ளிடவும்",
    "Please enter a title first": "முதலில் தலைப்பை உள்ளிடவும்",
    "accounts.user": "பயனர்",
    "accounts.select_user": "பயனரைத் தேர்வுசெய்க",
    "accounts.category": "பிரிவு",
    "accounts.select_type": "வகையைத் தேர்வுசெய்க",
    "accounts.smart_upload_title": "கணக்குகளை கூடுதலாக ஏற்றும்",
    "Smart account upload": "கணக்குகளை கூடுதலாக ஏற்றும்",
    "accounts.start_over": "மீண்டும் தொடங்கு",
    "accounts.smart_upload_description": "CSV கோலங்களைக் கணக்கு புலங்களுடன் பொருத்தி கணக்குகளை ஏற்றுக்கொள்ளுங்கள்.",
    "Upload accounts and match your CSV columns to account fields.": "CSV கோலங்களைக் கணக்கு புலங்களுடன் பொருத்தி கணக்குகளை ஏற்றுக்கொள்ளுங்கள்.",
    "accounts.smart_upload_step_0": "ஏற்றுகொள்",
    "accounts.smart_upload_step_1": "கோலங்களை இணைக்க",
    "accounts.smart_upload_step_2": "மீண்டும் பார்க்க",
    "accounts.smart_upload_step_3": "முக்கியமானது",
    "accounts.choose_csv": "CSV கோப்பைத் தேர்வுசெய்க",
    "accounts.smart_upload_required_note": "பெயர் அவசியமானது. முகவரி, ஸ்லக், பிரிவு, உரிமையாளர் மற்றும் ஆயத்திரம் தேர்வுசெய்யக்கூடியது.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "பெயர் அவசியமானது. முகவரி, ஸ்லக், பிரிவு, உரிமையாளர் மற்றும் ஆயத்திரம் தேர்வுசெய்யக்கூடியது.",
    "accounts.select_csv": "CSV கோப்பைத் தேர்வுசெய்க",
    "accounts.match_columns": "கணக்கு கோலங்களை இணைக்க",
    "Match account columns": "கணக்கு கோலங்களை இணைக்க",
    "accounts.import_field_name": "பெயர்",
    "accounts.import_field_description": "விவரக்குறிப்பு",
    "accounts.import_field_slug": "ஸ்லக்",
    "accounts.import_field_category_id": "பிரிவு ஐடி",
    "accounts.import_field_user_id": "உரிமையாளர் பயனர் ID",
    "Owner User ID": "உரிமையாளர் பயனர் ID",
    "accounts.import_field_location": "முகவரி",
    "accounts.import_field_latitude": "தொடக்க அளவு",
    "Latitude": "தொடக்க அளவு",
    "accounts.import_field_longitude": "நீளம்",
    "Longitude": "நீளம்",
    "accounts.do_not_import": "இறக்குமதி செய்யாதே",
    "accounts.review_import": "இறக்குமதி மீண்டும் பார்க்க",
    "accounts.import_count": "{count} கணக்குகள் இறக்குமதி செய்யப்படும்.",
    "{count} accounts will be imported.": "{count} கணக்குகள் இறக்குமதி செய்யப்படும்.",
    "accounts.smart_upload_complete": "சுமத்தும் முடிவுக்கு வந்தது",
    "accounts.imported_count": "{imported} முதல் {total} கணக்குகள் இறக்குமதி செய்யப்பட்டன.",
    "{imported} of {total} accounts imported.": "{imported} முதல் {total} கணக்குகள் இறக்குமதி செய்யப்பட்டன.",
    "accounts.selected_file": "தேர்ந்தெடுக்கப்பட்டது: {filename}",
    "Selected: {filename}": "தேர்ந்தெடுக்கப்பட்டது: {filename}",
    "accounts.review": "மீண்டும் பார்க்க",
    "accounts.importing": "இறக்குமதி செய்யப்படுகிறது…",
    "accounts.uploading": "பதிவேற்றம் செய்யப்படுகிறது...",
    "accounts.download": "பதிவிறக்கம்",
    "accounts.file_label": "கோப்பு:",
    "accounts.select_file": "கோப்பைத் தேர்ந்தெடுக்க",
    "accounts.upload": "பதிவேற்று",
    "accounts.download_template": "{type} தாள் பதிவிறக்கம்",
    "accounts.import_stage_prepare": "இறக்குமதி கோப்பை தயாரித்துக் கொண்டிருக்கிறோம்",
    "accounts.import_prepare_failed": "இறக்குமதி கோப்பை தயாரிக்க முடியவில்லை.",
    "accounts.import_stage_upload": "இறக்குமதி கோப்பை பதிவேற்றுகிறோம்",
    "accounts.import_upload_failed": "இறக்குமதி கோப்பை பதிவேற்ற முடியவில்லை.",
    "accounts.import_stage_server": "Tradly கணக்குகளை இறக்குமதி செய்து கொண்டிருக்கிறது",
    "Tradly is importing accounts": "Tradly கணக்குகளை இறக்குமதி செய்து கொண்டிருக்கிறது",
    "accounts.import_stage_complete": "இறக்குமதி முடிந்தது",
    "accounts.import_stage_stopped": "இறக்குமதி நிறுத்தப்பட்டது",
    "accounts.confirm_approve": "இந்த கணக்கை ஒப்புக்கொள்ள வேண்டுமா?",
    "Approve this account?": "இந்த கணக்கை ஒப்புக்கொள்ள வேண்டுமா?",
    "accounts.confirm_reject": "இந்த கணக்கை நிராகரிக்க வேண்டுமா?",
    "Reject this account?": "இந்த கணக்கை நிராகரிக்க வேண்டுமா?",
    "accounts.name_required": "பெயர் தேவை",
    "accounts.user_required": "பயனர் தேவை",
    "User is required": "பயனர் தேவை",
    "accounts.attribute_required": "{attribute} தேவை",
    "accounts.overview": "கணக்கு சுருக்கம்",
    "Account Overview": "கணக்கு சுருக்கம்",
    "accounts.section_listings": "பட்டியல்கள்",
    "accounts.loading": "பதிவேற்றம் செய்யப்படுகிறது…",
    "accounts.no_listings_owned": "இன்னும் பட்டியல்கள் இல்லை",
    "accounts.page_analytics": "பக்க பகுப்பாய்வு",
    "Page Analytics": "பக்க பகுப்பாய்வு",
    "accounts.analytics_key_missing": "இந்த குடியிருப்பிற்கு பகுப்பாய்வு API குறியீடு அமைக்கப்படவில்லை.",
    "Analytics API key not configured for this tenant.": "இந்த குடியிருப்பிற்கு பகுப்பாய்வு API குறியீடு அமைக்கப்படவில்லை.",
    "accounts.storefront_url_missing": "இந்த கணக்கிற்கு கடை URL கிடைக்கவில்லை.",
    "No storefront URL available for this account.": "இந்த கணக்கிற்கு கடை URL கிடைக்கவில்லை.",
    "accounts.no_analytics_loaded": "இன்னும் பகுப்பாய்வுகள் பதிவேற்றம் செய்யப்படவில்லை.",
    "accounts.load_analytics": "பகுப்பாய்வை பதிவேற்று",
    "Load Analytics": "பகுப்பாய்வை பதிவேற்று",
    "accounts.attributes": "பண்புகள்",
    "accounts.shipping": "அனுப்புதல்",
    "accounts.commission": "கமிஷன்",
    "Commission": "கமிஷன்",
    "accounts.detail_title": "தலைப்பு",
    "accounts.detail_description": "விளக்கம்",
    "accounts.detail_descriptions": "விளக்கங்கள்",
    "Descriptions": "விளக்கங்கள்",
    "accounts.detail_listings": "பட்டியல்கள்",
    "accounts.detail_categories": "பிரிவுகள்",
    "accounts.detail_location": "இடம்",
    "accounts.detail_account_status": "கணக்கு நிலை",
    "accounts.detail_status": "நிலை",
    "accounts.detail_shipping_method": "அனுப்பும் முறை",
    "accounts.detail_shipping_methods": "அனுப்பும் முறைகள்",
    "Shipping Methods": "அனுப்பும் முறைகள்",
    "accounts.detail_account_user": "கணக்கு பயனர்",
    "Account User": "கணக்கு பயனர்",
    "accounts.detail_pending": "தொடங்கப்படவில்லை",
    "accounts.detail_approved": "ஒப்புக்கொள்ளப்பட்டது",
    "accounts.detail_rejected": "நிராகரிக்கப்பட்டது",
    "accounts.detail_active": "செயல்பாட்டில்",
    "accounts.detail_inactive": "இயங்காத",
    "accounts.detail_joined": "இணைந்தது",
    "accounts.detail_account_age": "கணக்கு வயது",
    "Account Age": "கணக்கு வயது",
    "accounts.detail_less_than_a_month": "ஒரு மாதத்திற்கு குறைவானது",
    "Less than a month": "ஒரு மாதத்திற்கு குறைவானது",
    "accounts.detail_page_views": "பக்க பார்வைகள்",
    "Page Views": "பக்க பார்வைகள்",
    "accounts.detail_unique_visitors": "தனித்துவ பார்வையாளர்கள்",
    "accounts.detail_sessions": "அமர்வுகள்",
    "Sessions": "அமர்வுகள்",
    "accounts.detail_clicks": "கிளிக்குகள்",
    "Clicks": "கிளிக்குகள்",
    "accounts.detail_goals": "இலக்குகள்",
    "Goals": "இலக்குகள்",
    "accounts.detail_bot_views": "போட் பார்வைகள்",
    "Bot Views": "போட் பார்வைகள்",
    "accounts.detail_followers": "தொடர்பாளர்கள்",
    "accounts.detail_total_orders": "மொத்த ஆர்டர்கள்",
    "accounts.detail_revenue": "வருமானம்",
    "accounts.detail_avg_order": "ஆர்டர் சராசரி",
    "Avg Order": "ஆர்டர் சராசரி",
    "accounts.detail_paid_orders": "செலுத்தப்பட்ட ஆர்டர்கள்",
    "Paid Orders": "செலுத்தப்பட்ட ஆர்டர்கள்",
    "accounts.detail_owner": "உரிமையாளர்",
    "Owner": "உரிமையாளர்",
    "accounts.detail_account_id": "கணக்கு ID",
    "accounts.detail_category": "வகை",
    "accounts.detail_profile_completeness": "தொகுப்பு நிரப்புதல்",
    "Profile Completeness": "தொகுப்பு நிரப்புதல்",
    "accounts.detail_total_listings": "மொத்த பட்டியல்கள்",
    "Total Listings": "மொத்த பட்டியல்கள்",
    "accounts.detail_loaded_listings": "பதிவேற்றப்பட்ட பட்டியல்கள்",
    "Loaded Listings": "பதிவேற்றப்பட்ட பட்டியல்கள்",
    "accounts.detail_active_listings": "செயல்பாட்டு பட்டியல்கள்",
    "Active Listings": "செயல்பாட்டு பட்டியல்கள்",
    "accounts.detail_last_updated": "கடைசி புதுப்பிப்பு",
    "Last Updated": "கடைசி புதுப்பிப்பு",
    "accounts.detail_last_activity": "கடைசி செயல்பாடு",
    "Last Activity": "கடைசி செயல்பாடு",
    "accounts.detail_verification": "சரிபார்ப்பு",
    "Verification": "சரிபார்ப்பு",
    "accounts.detail_subscription": "பதிவு",
    "accounts.detail_attributes": "பண்புகள்",
    "accounts.detail_shipping_charge_split": "மாற்று போக்குவரத்து கட்டணம்",
    "Shipping Charge Split": "மாற்று போக்குவரத்து கட்டணம்",
    "accounts.detail_value_type": "மதிப்பு வகை",
    "Value Type": "மதிப்பு வகை",
    "accounts.detail_value": "மதிப்பு",
    "accounts.detail_enter_value": "மதிப்பை உள்ளிடவும்",
    "accounts.detail_commission_percentage": "கமிஷன் சதவீதம்",
    "Commission Percentage": "கமிஷன் சதவீதம்",
    "accounts.detail_commission_percent": "கமிஷன் சதவீதம்",
    "Commission Percent": "கமிஷன் சதவீதம்",
    "accounts.detail_share": "பகிரவும்",
    "accounts.detail_view_account": "கணக்கைப் பார்க்க",
    "View Account": "கணக்கைப் பார்க்க",
    "accounts.detail_add_listing": "பட்டியலைச் சேர்க்க",
    "accounts.detail_edit_account": "கணக்கை தொகுத்தல்",
    "Edit Account": "கணக்கை தொகுத்தல்",
    "accounts.no_attribute_values": "{name}-க்கு பண்பு மதிப்புகள் இல்லை",
    "accounts.no_attributes_yet": "இன்னும் பண்புகள் இல்லை",
    "No attributes yet": "இன்னும் பண்புகள் இல்லை",
    "accounts.edit_account": "கணக்கை தொகுத்தல்",
    "accounts.detail_preview": "முன்னோட்டம்",
    "accounts.detail_fixed": "நிலையான",
    "Fixed": "நிலையான",
    "accounts.detail_percentage": "சதவீதம்",
    "Percentage": "சதவீதம்",
    "accounts.detail_select_value_type": "மதிப்பு வகையைத் தேர்வு செய்க",
    "Select Value Type": "மதிப்பு வகையைத் தேர்வு செய்க",
    "accounts.detail_approve": "ஒப்புதல் செய்யவும்",
    "accounts.detail_reject": "நிராகரிக்கவும்",
    "accounts.detail_section": "விவரங்கள்",
    "Details": "விவரங்கள்",
    "category.add_child": "குழந்தை பிரிவைச் சேர்க்கவும்",
    "Add Child Category": "குழந்தை பிரிவைச் சேர்க்கவும்",
    "category.add_listing": "பட்டியலைச் சேர்க்கவும்",
    "category.manage": "பிரிவுகளை நிர்வகிக்கவும்",
    "Manage Categories": "பிரிவுகளை நிர்வகிக்கவும்",
    "category.account_overview_eyebrow": "கணக்கு பிரிவு மேம்பாடு",
    "ACCOUNT CATEGORY OVERVIEW": "கணக்கு பிரிவு மேம்பாடு",
    "category.overview_eyebrow": "பிரிவு மேம்பாடு",
    "CATEGORY OVERVIEW": "பிரிவு மேம்பாடு",
    "category.category": "பிரிவு",
    "category.active": "செயல்பாட்டில்",
    "category.inactive": "இயங்காத",
    "category.accounts": "கணக்குகள்",
    "category.listings": "பட்டியல்கள்",
    "category.child_categories": "குழந்தை பிரிவுகள்",
    "Child Categories": "குழந்தை பிரிவுகள்",
    "category.attributes": "பண்புகள்",
    "category.category_age": "பிரிவு வயது",
    "Category age": "பிரிவு வயது",
    "category.category_overview": "பிரிவு மேம்பாடு",
    "Category Overview": "பிரிவு மேம்பாடு",
    "category.category_id": "பிரிவு ஐடி",
    "category.name": "பெயர்",
    "category.slug": "ஸ்லக்",
    "category.description": "விளக்கம்",
    "category.parent_category": "பெற்றோர் பிரிவு",
    "category.hierarchy": "படிமுறை",
    "Hierarchy": "படிமுறை",
    "category.status": "நிலை",
    "category.display_order": "காட்டும் வரிசை",
    "Display Order": "காட்டும் வரிசை",
    "category.created": "இணைக்கப்பட்டது / உருவாக்கப்பட்டது",
    "Joined / Created": "இணைக்கப்பட்டது / உருவாக்கப்பட்டது",
    "category.configured": "அமைக்கப்பட்டது",
    "Configured": "அமைக்கப்பட்டது",
    "category.no_attributes": "எந்த அம்சங்களும் ஒதுக்கப்படவில்லை.",
    "No attributes assigned.": "எந்த அம்சங்களும் ஒதுக்கப்படவில்லை.",
    "category.no_child_categories": "குழு பிரிவுகள் இல்லை.",
    "No child categories.": "குழு பிரிவுகள் இல்லை.",
    "category.no_accounts": "இந்த பிரிவில் கணக்குகள் இல்லை.",
    "No accounts in this category.": "இந்த பிரிவில் கணக்குகள் இல்லை.",
    "category.no_listings": "இந்த பிரிவில் பட்டியல்கள் இல்லை.",
    "No listings in this category.": "இந்த பிரிவில் பட்டியல்கள் இல்லை.",
    "category.detail_title": "பிரிவு விவரம்",
    "Category Detail": "பிரிவு விவரம்",
    "category.age_less_month": "ஒரு மாதத்திற்கு குறைவானது",
    "category.age_month": "{count} மாதம்",
    "{count} month": "{count} மாதம்",
    "category.age_months": "{count} மாதங்கள்",
    "{count} months": "{count} மாதங்கள்",
    "category.age_year": "{count} ஆண்டு",
    "{count} year": "{count} ஆண்டு",
    "category.age_years": "{count} ஆண்டுகள்",
    "{count} years": "{count} ஆண்டுகள்",
    "category.header_name": "பெயர்",
    "category.header_category_id": "பிரிவு ஐடி",
    "category.header_image": "படம்",
    "category.header_order": "வரிசை",
    "category.header_parent": "பெற்றோர்",
    "Parent": "பெற்றோர்",
    "category.header_active": "செயல்பாட்டில் உள்ளது",
    "category.header_action": "நடவடிக்கை",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "வகைகள்",
    "category.translate": "மொழிபெயர்க்க",
    "category.import": "கொண்டுவருதல்",
    "category.export": "வெளியீடு",
    "category.add_category": "கத்திரிகையைச் சேர்க்க",
    "Add Category": "கத்திரிகையைச் சேர்க்க",
    "category.import_categories": "வகைகளை கொண்டுவருதல்",
    "Import Categories": "வகைகளை கொண்டுவருதல்",
    "category.delete_warning": "உள்ள பட்டியல்கள் வலைத்தளத்தில் அல்லது பயன்பாட்டில் திறக்கப்படாது, தவறு காட்டப்படும்.",
    "Existing listings will not open in website or app, you will see an error.": "உள்ள பட்டியல்கள் வலைத்தளத்தில் அல்லது பயன்பாட்டில் திறக்கப்படாது, தவறு காட்டப்படும்.",
    "category.editor_edit_category": "கத்திரிகையை தொகுக்க",
    "Edit Category": "கத்திரிகையை தொகுக்க",
    "category.editor_add_category": "கத்திரிகையைச் சேர்க்க",
    "category.editor_save": "சேமி",
    "category.editor_select_category_level": "கத்திரிகை அளவைத் தேர்வுசெய்க",
    "Select Category Level": "கத்திரிகை அளவைத் தேர்வுசெய்க",
    "category.editor_parent_category": "பெற்றோர் கத்திரிகை",
    "category.editor_select": "தேர்வுசெய்க",
    "category.editor_category_name": "கத்திரிகை பெயர்",
    "Category Name": "கத்திரிகை பெயர்",
    "category.editor_enter_category_name": "கத்திரிகை பெயரை உள்ளிடவும்",
    "Enter category name": "கத்திரிகை பெயரை உள்ளிடவும்",
    "category.editor_slug": "ஸ்லக்",
    "category.editor_enter_slug": "ஸ்லக் உள்ளிடவும்",
    "category.editor_category_description": "கத்திரிகை விவரிப்பு",
    "Category Description": "கத்திரிகை விவரிப்பு",
    "category.editor_order": "வரிசை",
    "category.editor_enter_order": "வரிசையை உள்ளிடவும்",
    "category.editor_status_not_active_active": "நிலை (இயக்கமற்ற / இயக்கம்)}",
    "category.editor_upload_media": "ஊடகத்தை பதிவிறக்குதல்",
    "category.editor_meta_title": "மெட்டா தலைப்பு",
    "Meta Title": "மெட்டா தலைப்பு",
    "category.editor_enter_meta_title": "மெட்டா தலைப்பை உள்ளிடவும்",
    "category.editor_meta_description": "மெட்டா விவரக்குறிப்பு",
    "category.editor_category": "வகை",
    "category.editor_name": "பெயர்",
    "category.editor_status": "நிலை",
    "category.editor_action": "செயல்முறை",
    "category.editor_add_attribute": "பண்பை சேர்க்கவும்",
    "category.editor_attributes_list": "பண்புகளின் பட்டியல்",
    "Attributes List": "பண்புகளின் பட்டியல்",
    "category.editor_please_enter_a_category_name_first": "முதலில் வகையின் பெயரை உள்ளிடவும்",
    "Please enter a category name first": "முதலில் வகையின் பெயரை உள்ளிடவும்",
    "category.editor_successfully_added_category": "வகை வெற்றிகரமாக சேர்க்கப்பட்டது",
    "Successfully added category": "வகை வெற்றிகரமாக சேர்க்கப்பட்டது",
    "category.deleted": "வகை நீக்கப்பட்டது",
    "Category deleted": "வகை நீக்கப்பட்டது",
    "attributes.title": "பண்புகள்",
    "attributes.cart_checkout": "கார்ட் மற்றும் விற்பனை முடித்தல்",
    "Cart & Checkout": "கார்ட் மற்றும் விற்பனை முடித்தல்",
    "attributes.cart_settings": "கார்ட் அமைப்புகள்",
    "Cart settings": "கார்ட் அமைப்புகள்",
    "attributes.order_status_notifications": "ஆர்டர் நிலை அறிவிப்புகள்",
    "Order status notifications": "ஆர்டர் நிலை அறிவிப்புகள்",
    "attributes.groups": "பண்புகளின் குழுக்கள்",
    "attributes.add_attribute": "பண்பை சேர்க்கவும்",
    "attributes.edit_bulk": "கூட்டு தொகுப்புகளை திருத்தவும்",
    "Edit Bulk": "கூட்டு தொகுப்புகளை திருத்தவும்",
    "attributes.confirm_delete": "இந்த பண்பை நீக்க விரும்புகிறீர்களா?",
    "attributes.header_attribute_name": "பண்பின் பெயர்",
    "Attribute Name": "பண்பின் பெயர்",
    "attributes.header_action": "செயல்முறை",
    "attributes.header_manage_attribute_values": "பண்பு மதிப்புகளை நிர்வகிக்கவும்",
    "Manage Attribute Values": "பண்பு மதிப்புகளை நிர்வகிக்கவும்",
    "attributes.header_type": "வகை",
    "attributes.header_optional": "ஒப்சனல்",
    "attributes.header_icon": "இகோன்",
    "attributes.header_categories": "கத்திரிகள்",
    "attributes.header_hidden_field": "மறைந்த புலம்",
    "Hidden Field": "மறைந்த புலம்",
    "attributes.header_values": "மதிப்புகள்",
    "Values": "மதிப்புகள்",
    "attributes.header_status": "நிலை",
    "attributes.type_single_select": "ஒரு தேர்வு",
    "Single Select": "ஒரு தேர்வு",
    "attributes.type_multi_select": "பல தேர்வுகள்",
    "Multi Select": "பல தேர்வுகள்",
    "attributes.type_open_single_value": "திறந்த (ஒரு மதிப்பு)",
    "Open (Single Value)": "திறந்த (ஒரு மதிப்பு)",
    "attributes.type_open_multiple_value": "திறந்த (பல மதிப்புகள்)",
    "Open (Multiple Value)": "திறந்த (பல மதிப்புகள்)",
    "attributes.type_attachment": "தொடர்புடையது",
    "Attachment": "தொடர்புடையது",
    "attributes.type_text_area": "மெய்ப்பெயர் பகுதி",
    "Text Area": "மெய்ப்பெயர் பகுதி",
    "attributes.type_date_time": "தேதி மற்றும் நேரம்",
    "Date Time": "தேதி மற்றும் நேரம்",
    "attributes.type_number": "எண்",
    "attributes.type_boolean": "புல்லியன்",
    "Boolean": "புல்லியன்",
    "attributes.type_color": "நிறம்",
    "Color": "நிறம்",
    "attributes.type_json": "ஜெசன்",
    "Json": "ஜெசன்",
    "attributes.type_location": "இடம்",
    "attributes.type_audio": "ஆடியோ",
    "Audio": "ஆடியோ",
    "attributes.type_video": "வீடியோ",
    "Video": "வீடியோ",
    "attributes.type_open_multi_value": "திறந்த (பல மதிப்புகள்)",
    "Open (Multi Value)": "திறந்த (பல மதிப்புகள்)",
    "attributes.editor_edit_attribute": "பண்பை தொகுத்தல்",
    "Edit Attribute": "பண்பை தொகுத்தல்",
    "attributes.editor_add_attribute": "பண்பை சேர்க்க",
    "attributes.editor_attribute_name": "பண்பின் பெயர்",
    "attributes.editor_select_type": "தேர்வு வகை",
    "attributes.prefill_user": "பயனர்",
    "common.search_placeholder": "தேடுவதற்கு உரையிடவும்...",
    "attributes.prefill_accounts": "கணக்குகள்",
    "attributes.prefill_listings": "பட்டியல்கள்",
    "listings.detail_nav_gallery": "கலைக்காட்சி",
    "Gallery": "கலைக்காட்சி",
    "listings.detail_nav_details": "விவரங்கள்",
    "listings.detail_nav_inventory": "சேமிப்பு",
    "listings.detail_nav_social": "சமூகம்",
    "Social": "சமூகம்",
    "listings.detail_nav_orders": "ஆர்டர்கள்",
    "listings.detail_nav_analytics": "பகுப்பாய்வுகள்",
    "listings.detail_nav_schedule": "திட்டமிடல்",
    "listings.detail_nav_rental": "வாடகை",
    "Rental": "வாடகை",
    "listings.detail_nav_attributes": "பண்புகள்",
    "listings.detail_nav_seller": "விற்பனையாளர்",
    "attributes.editor_icon": "குறியீடு",
    "attributes.editor_tool_tip": "கருவி குறிப்பு",
    "Tool tip": "கருவி குறிப்பு",
    "attributes.editor_enter_attribute_name": "பண்பு பெயரை உள்ளிடவும்",
    "Enter attribute name": "பண்பு பெயரை உள்ளிடவும்",
    "attributes.editor_enter_attribute_tool_tip": "கருவி விவரத்தை உள்ளிடவும்",
    "Enter attribute tool tip": "கருவி விவரத்தை உள்ளிடவும்",
    "attributes.editor_optional": "தேர்வுசெய்யக்கூடியது",
    "attributes.editor_private": "தனியார்",
    "Private": "தனியார்",
    "attributes.editor_hidden_field": "மறைக்கப்பட்ட புலம்",
    "Hidden field": "மறைக்கப்பட்ட புலம்",
    "attributes.editor_show_in_filter": "தேர்வுக்கு காட்டு",
    "attributes.editor_status_not_active_active": "நிலை (இயக்கமற்ற / இயக்கமுள்ள)",
    "attributes.editor_add_meta_data": "மெட்டா தகவல்களை சேர்க்கவும்",
    "Add meta data": "மெட்டா தகவல்களை சேர்க்கவும்",
    "attributes.editor_select": "தேர்வு செய்யவும்",
    "attributes.editor_select_category": "கத்திரிக்கு தேர்வு செய்யவும்",
    "attributes.editor_select_all": "எல்லாவற்றையும் தேர்வு செய்யவும்",
    "Select All": "எல்லாவற்றையும் தேர்வு செய்யவும்",
    "attributes.editor_unselect_all": "எல்லாவற்றையும் தேர்வு நீக்கவும்",
    "UnSelect All": "எல்லாவற்றையும் தேர்வு நீக்கவும்",
    "attributes.editor_create_categories_in_this_configuration_first": "முதலில் இந்த அமைப்பில் கத்திரிகளை உருவாக்கவும்",
    "Create categories in this configuration first": "முதலில் இந்த அமைப்பில் கத்திரிகளை உருவாக்கவும்",
    "attributes.editor_please_enter_attribute_name": "விவரத்தின் பெயரை உள்ளிடவும்",
    "attributes.editor_please_select_type": "வகையை தேர்வு செய்யவும்",
    "Please select type": "வகையை தேர்வு செய்யவும்",
    "attributes.editor_select_single_attribute_values": "ஒற்றை அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "Select Single Attribute Values": "ஒற்றை அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "attributes.editor_select_multiple_attribute_values": "பல அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "Select Multiple Attribute Values": "பல அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "attributes.editor_enter_value": "மதிப்பை உள்ளிடவும்",
    "attributes.editor_enter_multiple_tag": "பல டேக்குகளை உள்ளிடவும்",
    "Enter Multiple Tag": "பல டேக்குகளை உள்ளிடவும்",
    "attributes.editor_upload_file": "கோப்பை பதிவிறக்கவும்",
    "Upload file": "கோப்பை பதிவிறக்கவும்",
    "attributes.editor_enter_text": "テキストを入力してください",
    "Enter Text": "テキストを入力してください",
    "attributes.editor_select_date": "தேதியைத் தேர்வு செய்யவும்",
    "attributes.editor_enter_number": "எண்ணை உள்ளிடவும்",
    "Enter Number": "எண்ணை உள்ளிடவும்",
    "attributes.editor_select_color": "நிறத்தைத் தேர்வு செய்யவும்",
    "Select Color": "நிறத்தைத் தேர்வு செய்யவும்",
    "attributes.editor_upload_json": "Json ஐ பதிவிறக்கவும்",
    "Upload Json": "Json ஐ பதிவிறக்கவும்",
    "attributes.editor_select_location": "இடத்தைத் தேர்வு செய்யவும்",
    "Select Location": "இடத்தைத் தேர்வு செய்யவும்",
    "attributes.editor_category": "கத்திரி",
    "attributes.editor_price": "விலை",
    "attributes.editor_enter_price": "விலையை உள்ளிடவும்",
    "Enter Price": "விலையை உள்ளிடவும்",
    "attributes.editor_preview": "முன்னோட்டம்",
    "attributes.editor_title": "தலைப்பு",
    "attributes.editor_enter_title": "தலைப்பை உள்ளிடவும்",
    "Enter Title": "தலைப்பை உள்ளிடவும்",
    "attributes.editor_description": "விளக்கம்",
    "attributes.editor_add_listing": "பட்டியலை சேர்க்கவும்",
    "attributes.editor_add_account": "கணக்கை சேர்க்கவும்",
    "attributes.editor_successfully_added_attributes": "உருப்படிகள் வெற்றிகரமாக சேர்க்கப்பட்டன",
    "Successfully added attributes": "உருப்படிகள் வெற்றிகரமாக சேர்க்கப்பட்டன",
    "attributes.editor_add_attribute_values": "உருப்படி மதிப்புகளை சேர்க்கவும்",
    "common.image": "படம்",
    "common.please_wait": "காத்திருக்கவும்...",
    "attribute_groups.title": "உருப்படி குழுக்கள்",
    "attribute_groups.title_singular": "உருப்படி குழு",
    "Attribute Group": "உருப்படி குழு",
    "attribute_groups.add": "உருப்படி குழுவை சேர்க்கவும்",
    "Add Attribute Group": "உருப்படி குழுவை சேர்க்கவும்",
    "attribute_groups.image_path": "படத்தின் பாதை",
    "Image Path": "படத்தின் பாதை",
    "attribute_groups.name_placeholder": "குழுவின் பெயர்",
    "Group Name": "குழுவின் பெயர்",
    "attribute_groups.select_attributes": "உருப்படிகளைத் தேர்வு செய்யவும்",
    "Select Attributes": "உருப்படிகளைத் தேர்வு செய்யவும்",
    "attribute_groups.select_attributes_placeholder": "உருப்படிகளைத் தேர்வு செய்யவும்...",
    "Select Attributes...": "உருப்படிகளைத் தேர்வு செய்யவும்...",
    "attribute_groups.added_successfully": "உருப்படி குழு வெற்றிகரமாக சேர்க்கப்பட்டது",
    "Attribute Group Added Successfully": "உருப்படி குழு வெற்றிகரமாக சேர்க்கப்பட்டது",
    "attribute_groups.deleted_successfully": "வெற்றிகரமாக அகற்றப்பட்டது",
    "Deleted successfully": "வெற்றிகரமாக அகற்றப்பட்டது",
    "attribute_groups.name_required": "பெயர் அவசியமானது",
    "attribute_groups.save_attributes_failed": "குழு சேமிக்கப்பட்டது, ஆனால் அதன் உருப்படிகளை ஒதுக்க முடியவில்லை.",
    "The group was saved, but its attributes could not be assigned.": "குழு சேமிக்கப்பட்டது, ஆனால் அதன் உருப்படிகளை ஒதுக்க முடியவில்லை.",
    "attributes.editor_enter_description": "விளக்கத்தை உள்ளிடவும்",
    "account_config.title": "கணக்கு அமைப்பு",
    "account_config.account_detail_note": "கணக்கு விவர குறிப்பு",
    "Account detail note": "கணக்கு விவர குறிப்பு",
    "account_config.enter_account_detail_note": "கணக்கு விவர குறிப்பை உள்ளிடவும்",
    "Enter account detail note": "கணக்கு விவர குறிப்பை உள்ளிடவும்",
    "account_config.address_label": "முகவரி குறிப்பு",
    "Address label": "முகவரி குறிப்பு",
    "account_config.enter_address_label": "முகவரி குறிப்பு",
    "Enter address label": "முகவரி குறிப்பு",
    "account_config.category_label": "கத்திரிகை குறிப்பு",
    "Category label": "கத்திரிகை குறிப்பு",
    "account_config.enter_category_label": "கத்திரிகை குறிப்பை உள்ளிடவும்",
    "Enter category label": "கத்திரிகை குறிப்பை உள்ளிடவும்",
    "account_config.nearby_accounts_radius_km": "அருகிலுள்ள கணக்குகளின் ஆரம் (km)",
    "Nearby accounts radius (km)": "அருகிலுள்ள கணக்குகளின் ஆரம் (km)",
    "account_config.nearby_accounts_radius_placeholder": "கணக்கு அருகிலுள்ள ஆரம் (km)",
    "Account nearby radius in km": "கணக்கு அருகிலுள்ள ஆரம் (km)",
    "account_config.account_limit": "கணக்குகளின் வரம்பு",
    "Account Limit": "கணக்குகளின் வரம்பு",
    "account_config.account_limit_placeholder": "கணக்குகளின் வரம்பு",
    "Account limit": "கணக்குகளின் வரம்பு",
    "account_config.shipping_preference_note": "முதலீட்டு முறை விருப்பத்தைப் பற்றிய குறிப்பு",
    "Shipping method preference note": "முதலீட்டு முறை விருப்பத்தைப் பற்றிய குறிப்பு",
    "account_config.option_accounts_auto_approved": "தானியங்கி அனுமதிக்கப்பட்ட கணக்குகள்",
    "Accounts auto approved": "தானியங்கி அனுமதிக்கப்பட்ட கணக்குகள்",
    "account_config.option_shipping_methods_preference_for_accounts": "கணக்குகளுக்கான அனுப்பும் முறைகளின் விருப்பம்",
    "Shipping methods preference for accounts": "கணக்குகளுக்கான அனுப்பும் முறைகளின் விருப்பம்",
    "account_config.option_account_map_location_selector": "கணக்குகளுக்கான வரைபட இடம் தேர்வுசெய்யும் கருவி",
    "Account map location selector": "கணக்குகளுக்கான வரைபட இடம் தேர்வுசெய்யும் கருவி",
    "account_config.option_account_geo_location": "கணக்கின் புவியியல் இடம்",
    "Account Geo Location": "கணக்கின் புவியியல் இடம்",
    "account_config.option_slug": "ஸ்லக்",
    "account_config.option_show_description": "விளக்கத்தைக் காட்டு",
    "Show Description": "விளக்கத்தைக் காட்டு",
    "account_config.option_formatted_text_description": "வடிவமைக்கப்பட்ட உரை விளக்கம்",
    "Formatted Text Description": "வடிவமைக்கப்பட்ட உரை விளக்கம்",
    "account_config.option_hide_address_from_account_detail": "கணக்கு விவரத்தில் முகவரியை மறைக்கவும்",
    "Hide Address from Account Detail": "கணக்கு விவரத்தில் முகவரியை மறைக்கவும்",
    "account_config.option_get_account_pickup_address_always": "எப்போதும் கணக்கிலிருந்து எடுக்கும் முகவரியைப் பெறு",
    "Get Account Pickup Address Always": "எப்போதும் கணக்கிலிருந்து எடுக்கும் முகவரியைப் பெறு",
    "account_config.option_get_pickup_address_for_delivery": "கிடைப்புக்காக எடுக்கும் முகவரியைப் பெறு",
    "Get Pickup Address for Delivery": "கிடைப்புக்காக எடுக்கும் முகவரியைப் பெறு",
    "account_config.uploaded_successfully": "வெற்றிகரமாக பதிவேற்றம் செய்யப்பட்டது",
    "app_customization.realtime_config_notice": "இந்த கட்டமைப்புகள் நேரடியாக பயன்படுத்தப்படும். இங்கு மாற்றங்களைச் செய்து சேமிக்க கிளிக் செய்தால், அது பயன்பாடுகள் மற்றும் API பதில்களில் பிரதிபலிக்கும்.",
    "app_customization.release_config_notice": "மொபைல் பயன்பாடு சேனல்களுக்கான குறிப்பு: இந்த கட்டமைப்புகள் தயாரிப்பு வெளியீட்டு நேரத்திலும் மேம்படுத்தல்களிலும் மட்டுமே பயன்படுத்தப்படும். நேரடியாக மேம்படுத்தப்படாது. இங்கு மாற்றங்களைச் செய்து புதுப்பிக்கப்பட்ட கட்டமைப்பு தேவைப்படும்போது, ஆதரவு போர்ட்டலிலிருந்து கட்டமைப்பு கோரிக்கையை செய்யவும். (ஸ்டார்டர் திட்டத்திற்கு பொருந்தும்)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "மொபைல் பயன்பாடு சேனல்களுக்கான குறிப்பு: இந்த கட்டமைப்புகள் தயாரிப்பு வெளியீட்டு நேரத்திலும் மேம்படுத்தல்களிலும் மட்டுமே பயன்படுத்தப்படும். நேரடியாக மேம்படுத்தப்படாது. இங்கு மாற்றங்களைச் செய்து புதுப்பிக்கப்பட்ட கட்டமைப்பு தேவைப்படும்போது, ஆதரவு போர்ட்டலிலிருந்து கட்டமைப்பு கோரிக்கையை செய்யவும். (ஸ்டார்டர் திட்டத்திற்கு பொருந்தும்)",
    "category.translation_title": "கத்திரிகையை மொழிபெயர்க்கவும்",
    "Translate Category": "கத்திரிகையை மொழிபெயர்க்கவும்",
    "category.translation_category_name": "கத்திரிகை பெயர்",
    "category.translation_description": "விளக்கம்",
    "listing_configs.title": "பட்டியல் அமைப்பு",
    "Listing Configuration": "பட்டியல் அமைப்பு",
    "listing_configs.rules": "விதிமுறைகள் (திட்டங்கள்/குடியிருப்பு அளவு)",
    "RULES (Projects/Tenant level)": "விதிமுறைகள் (திட்டங்கள்/குடியிருப்பு அளவு)",
    "listing_configs.features": "அம்சங்கள் (மொபைல் பயன்பாட்டிற்கு மட்டும்)",
    "FEATURES (Only for mobile app)": "அம்சங்கள் (மொபைல் பயன்பாட்டிற்கு மட்டும்)",
    "listing_configs.ui_customisation": "UI தனிப்பயனாக்கம்",
    "UI Customisation": "UI தனிப்பயனாக்கம்",
    "listing_configs.overridden_max_quantity": "பட்டியலுக்கு அதிகபட்ச அளவு",
    "listing_configs.overridden_max_quantity_example": "(எடுத்துக்காட்டு: 100)",
    "(Example: 100)": "(எடுத்துக்காட்டு: 100)",
    "listing_configs.listing_min_price": "பட்டியல் விலையின் குறைந்தபட்ச விலை",
    "listing_configs.listing_min_price_example": "(எடுத்துக்காட்டு: $5)",
    "(Example: $5)": "(எடுத்துக்காட்டு: $5)",
    "listing_configs.auto_approval": "தானியங்கி பட்டியல்களை ஒப்புக்கொள்ள வேண்டுமா? (Auto approve listings?)",
    "listing_configs.listing_pictures_count": "பதிவேற்றக்கூடிய படங்களின் எண்ணிக்கை",
    "listing_configs.seller_can_place_order": "விற்பனையாளர் ஆர்டர் செய்ய முடியும்",
    "Seller can place order": "விற்பனையாளர் ஆர்டர் செய்ய முடியும்",
    "listing_configs.hide_offer_percent": "ஆஃபர் சதவீதம்",
    "listing_configs.show_max_quantity": "பட்டியல் அளவில் அதிகபட்ச அளவு கட்டுப்பாடுகள்",
    "listing_configs.show_shipping_charges": "கொண்டு வரும் செலவுகள்",
    "listing_configs.listing_address_label": "முகவரி குறிப்பு",
    "listing_configs.listing_address_label_example": "(எடுத்துக்காட்டு: குறிப்பு புள்ளி)",
    "listing_configs.listing_map_location_selector_enabled": "முகவரியைத் தேடுவதற்குப் பதிலாக வரைபட மார்க்கரைப் பயன்படுத்தவும்",
    "Use map marker instead of searching address": "முகவரியைத் தேடுவதற்குப் பதிலாக வரைபட மார்க்கரைப் பயன்படுத்தவும்",
    "listing_configs.listing_hide_tags": "குறியீடுகள்",
    "listing_configs.enable_stock": "கொள்முதல்",
    "Stocks": "கொள்முதல்",
    "listing_configs.listing_address_enabled": "நிலையான முகவரி",
    "listing_configs.show_stock_out_listings": "பட்டியலில் கொள்முதல் இல்லாத பட்டியல்களை ஃபீட்டில் காட்டு",
    "listing_configs.enable_slug": "பட்டியல் தலைப்பு Slug",
    "Listing title slug": "பட்டியல் தலைப்பு Slug",
    "listing_configs.show_variants": "வேரியண்ட்ஸ்",
    "listing_configs.meta_title": "மெட்டா தலைப்பு",
    "Meta title": "மெட்டா தலைப்பு",
    "listing_configs.meta_description": "மெட்டா விளக்கம்",
    "listing_configs.listing_enable_formatted_text_description": "கம்போஸரை செயல்படுத்து",
    "listing_configs.listing_enable_weight": "எடையை செயல்படுத்து",
    "Enable Weight": "எடையை செயல்படுத்து",
    "listing_configs.listing_enable_dimensions": "அளவுகளை செயல்படுத்து",
    "Enable Dimensions": "அளவுகளை செயல்படுத்து",
    "listing_configs.enable_stocks_listing_schedules": "ஸ்டாக் நேர அட்டவணைகள்",
    "Stock Schedules": "ஸ்டாக் நேர அட்டவணைகள்",
    "listing_variants.title": "வேரியண்ட் வகைகள்",
    "listing_variants.add_type": "வேரியண்ட் வகையை சேர்",
    "Add Variant Type": "வேரியண்ட் வகையை சேர்",
    "listing_variants.edit_type": "வேரியண்ட் வகையை தொகு",
    "Edit Variant Type": "வேரியண்ட் வகையை தொகு",
    "listing_variants.name": "பெயர்",
    "listing_variants.values": "மதிப்புகள்",
    "listing_variants.status": "நிலை",
    "listing_variants.action": "செயல்",
    "listing_variants.add_value": "மதிப்பை சேர்",
    "Add Value": "மதிப்பை சேர்",
    "listing_variants.active": "செயல்பாட்டில்",
    "listing_variants.inactive": "செயல்படாத",
    "listing_variants.details": "விவரங்கள்",
    "listing_variants.translate": "மொழிபெயர்க்க",
    "listing_variants.delete_confirm": "இந்த வேரியண்ட் வகையை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this variant type?": "இந்த வேரியண்ட் வகையை நீக்க விரும்புகிறீர்களா?",
    "listing_variants.add_value_first": "வேரியண்ட்களைப் பார்க்க முன் மதிப்பைச் சேர்க்கவும்.",
    "Add a value before viewing variants.": "வேரியண்ட்களைப் பார்க்க முன் மதிப்பைச் சேர்க்கவும்.",
    "listing_variants.enter_name": "பெயரை உள்ளிடவும்",
    "Enter name": "பெயரை உள்ளிடவும்",
    "listing_variants.status_hint": "நிலை (செயல்படாத / செயல்பாட்டில்)",
    "listing_variants.total_values": "மொத்த மதிப்புகள்",
    "Total Values": "மொத்த மதிப்புகள்",
    "listing_variants.type_id": "வகை ஐடி",
    "Type ID": "வகை ஐடி",
    "listing_variants.total_count": "{count} மொத்தம்",
    "{count} total": "{count} மொத்தம்",
    "listing_variants.loading": "இறக்குமதி…",
    "listing_variants.loading_values": "மதிப்புகளை ஏற்றுகிறது…",
    "Loading values…": "மதிப்புகளை ஏற்றுகிறது…",
    "listing_variants.no_values": "மதிப்புகள் இல்லை",
    "No values yet": "மதிப்புகள் இல்லை",
    "listing_variants.add_first_value": "முதல் மதிப்பை சேர்க்கவும்",
    "Add First Value": "முதல் மதிப்பை சேர்க்கவும்",
    "listing_variants.actions": "செயல்பாடுகள்",
    "listing_variants.edit": "தொகுப்பு",
    "listing_variants.delete": "நீக்கு",
    "listing_variants.edit_value": "மதிப்பை தொகுப்பு",
    "Edit Value": "மதிப்பை தொகுப்பு",
    "listing_variants.value_name_required": "மதிப்பு பெயர் *",
    "Value Name *": "மதிப்பு பெயர் *",
    "listing_variants.value_examples": "எ.கா. சிவப்பு, XL, காய்ச்சல்…",
    "e.g. Red, XL, Cotton…": "எ.கா. சிவப்பு, XL, காய்ச்சல்…",
    "listing_variants.saving": "சேமித்துக் கொண்டிருக்கிறது…",
    "listing_variants.save_changes": "மாற்றங்களை சேமி",
    "Save Changes": "மாற்றங்களை சேமி",
    "listing_variants.delete_value_confirm": "இந்த வேரியண்ட் மதிப்பை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this variant value?": "இந்த வேரியண்ட் மதிப்பை நீக்க விரும்புகிறீர்களா?",
    "listing_variants.clear_all": "அனைத்தையும் அழி",
    "listing_variants.multiple_values_help": "நீங்கள் குறிப்பிட்ட மதிப்புகளை புள்ளிகளுடன் சேர்க்கலாம் அல்லது Excel இலிருந்து ஒரு நிரலை ஒட்டலாம்.",
    "You can add comma-separated values or paste a column from Excel.": "நீங்கள் குறிப்பிட்ட மதிப்புகளை புள்ளிகளுடன் சேர்க்கலாம் அல்லது Excel இலிருந்து ஒரு நிரலை ஒட்டலாம்.",
    "listing_variants.save": "சேமி",
    "listing_variants.close": "மூடு",
    "listing_variants.update": "புதுப்பிக்க",
    "listing_variants.default_text": "இயல்பு உரை",
    "listing_variants.enter_value": "வேரியண்ட் மதிப்பை உள்ளிடவும்",
    "Enter variant value": "வேரியண்ட் மதிப்பை உள்ளிடவும்",
    "listing_variants.add_values": "மதிப்புகளை சேர்க்க",
    "listing_variants.add_variant_values": "வேரியண்ட் வகை மதிப்புகளை சேர்க்க",
    "Add Variant Type Values": "வேரியண்ட் வகை மதிப்புகளை சேர்க்க",
    "listing_variants.values_list": "வேரியண்ட் வகை மதிப்புகள் பட்டியல்",
    "Variant Type Values List": "வேரியண்ட் வகை மதிப்புகள் பட்டியல்",
    "listing_variants.cancel_editing": "தொகுப்பை ரத்து செய்யுங்கள்",
    "listing_variants.value_name": "வேறுபாட்டு வகை மதிப்பு",
    "Variant Type Value": "வேறுபாட்டு வகை மதிப்பு",
    "common.default_text": "இயல்புநிலை உரை",
    "common.translation_heading": "{title} மொழிபெயர்ப்புகள்",
    "{title} Translations": "{title} மொழிபெயர்ப்புகள்",
    "attributes.value_delete_confirm": "இந்த பண்பு மதிப்பை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this attribute value?": "இந்த பண்பு மதிப்பை நீக்க விரும்புகிறீர்களா?",
    "attributes.value_clear_all": "எல்லாவற்றையும் அழி",
    "attributes.value_multiple_help": "குறிப்பிட்ட புள்ளிகளை பிரித்து சேர்க்கவும் அல்லது Excel இலிருந்து நிரலை ஒட்டவும்.",
    "Add comma-separated values or paste a column from Excel.": "குறிப்பிட்ட புள்ளிகளை பிரித்து சேர்க்கவும் அல்லது Excel இலிருந்து நிரலை ஒட்டவும்.",
    "attributes.value_active": "செயல்பாட்டில்",
    "attributes.value_inactive": "செயலற்ற",
    "attributes.value_save": "சேமி",
    "attributes.value_close": "மூடு",
    "attributes.value_translate": "மொழிபெயர்க",
    "attributes.value_update": "புதுப்பி",
    "attributes.value_sort_alpha": "ஆங்கில வரிசையில் வரிசைப்படுத்து",
    "Sort Alphabetically": "ஆங்கில வரிசையில் வரிசைப்படுத்து",
    "attributes.value_default_text": "இயல்புநிலை உரை",
    "attributes.value_add_metadata": "மெட்டாடேட்டாக்களைச் சேர்க்கவும்",
    "Add Metadata": "மெட்டாடேட்டாக்களைச் சேர்க்கவும்",
    "attributes.value_cancel_edit": "தொகுப்பை ரத்துசெய்",
    "attributes.value_success_help": "நல்லது! இப்போது நீங்கள் இந்த தனிப்பயன் பண்பை 'பட்டியல் சேர்க்க' பக்கத்தில் காணலாம்.",
    "Great! You can now find this custom attribute on the Add Listing page.": "நல்லது! இப்போது நீங்கள் இந்த தனிப்பயன் பண்பை 'பட்டியல் சேர்க்க' பக்கத்தில் காணலாம்.",
    "attributes.value_add": "பண்பு மதிப்புகளைச் சேர்க்கவும்",
    "attributes.value_add_listing": "பட்டியல் பண்பு மதிப்புகளைச் சேர்க்கவும்",
    "Add Listing Attribute Values": "பட்டியல் பண்பு மதிப்புகளைச் சேர்க்கவும்",
    "attributes.value_metadata_for": "மெட்டாடேட்டாக்கள்",
    "Metadata for": "மெட்டாடேட்டாக்கள்",
    "attributes.value_enter": "பண்பு மதிப்பை உள்ளிடவும்",
    "Enter attribute value": "பண்பு மதிப்பை உள்ளிடவும்",
    "attributes.value_add_values": "மதிப்புகளைச் சேர்க்கவும்",
    "attributes.value_status_hint": "நிலை (செயலற்ற / செயல்பாட்டில்)",
    "attributes.value_list": "பண்பு மதிப்புகள் பட்டியல்",
    "Attribute Values List": "பண்பு மதிப்புகள் பட்டியல்",
    "attributes.value_table_name": "அம்ச மதிப்பு",
    "Attribute Value": "அம்ச மதிப்பு",
    "attributes.value_table_status": "நிலை",
    "attributes.value_table_action": "செயல்முறை",
    "attributes.metadata_key": "தொடர்பு",
    "Key": "தொடர்பு",
    "attributes.metadata_value": "மதிப்பு",
    "attributes.metadata_add_row": "வரிசையை சேர்க்கவும்",
    "workspace.countries": "நாடுகள்",
    "workspace.country_add": "நாட்டைச் சேர்க்கவும்",
    "Add Country": "நாட்டைச் சேர்க்கவும்",
    "workspace.country_edit": "நாட்டை தொகுக்கவும்",
    "Edit Country": "நாட்டை தொகுக்கவும்",
    "workspace.country_name": "நாட்டின் பெயர்",
    "Country Name": "நாட்டின் பெயர்",
    "workspace.select_country": "நாட்டைத் தேர்வுசெய்க",
    "Select country": "நாட்டைத் தேர்வுசெய்க",
    "workspace.country_order": "வரிசை",
    "workspace.country_order_placeholder": "வரிசையை உள்ளிடவும்",
    "workspace.country_status": "நிலை (இயல்பற்ற / இயல்புள்ள)",
    "workspace.country_default": "இயல்புநிலை",
    "workspace.country_active": "இயல்புள்ள",
    "workspace.country_inactive": "இயல்பற்ற",
    "workspace.country_delete_confirm": "இந்த நாட்டை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this country?": "இந்த நாட்டை நீக்க விரும்புகிறீர்களா?",
    "workspace.country_table_name": "பெயர்",
    "workspace.country_table_default": "இயல்புநிலை",
    "workspace.country_table_order": "வரிசை",
    "workspace.country_table_status": "நிலை",
    "workspace.country_table_action": "செயல்முறை",
    "workspace.languages": "மொழிகள்",
    "workspace.language_add": "மொழியை சேர்க்கவும்",
    "Add Language": "மொழியை சேர்க்கவும்",
    "workspace.language_edit": "மொழியை தொகுக்கவும்",
    "Edit Language": "மொழியை தொகுக்கவும்",
    "workspace.language_name": "மொழி",
    "workspace.language_select": "மொழியைத் தேர்வுசெய்க",
    "Select Language": "மொழியைத் தேர்வுசெய்க",
    "workspace.language_order": "வரிசை",
    "workspace.language_order_placeholder": "வரிசையை உள்ளிடவும்",
    "workspace.language_status": "நிலை",
    "workspace.language_default": "இயல்புநிலை",
    "workspace.language_default_warning": "இயல்புநிலை மொழியை மாற்றுவது பயன்பாட்டின் மொழி அமைப்பை மாற்றும்.",
    "Changing the default language changes the app language setting.": "இயல்புநிலை மொழியை மாற்றுவது பயன்பாட்டின் மொழி அமைப்பை மாற்றும்.",
    "workspace.language_active": "செயல்பாட்டில்",
    "workspace.language_inactive": "இயல்பில்லாத",
    "workspace.language_delete_confirm": "இந்த மொழியை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this language?": "இந்த மொழியை நீக்க விரும்புகிறீர்களா?",
    "workspace.language_table_name": "பெயர்",
    "workspace.language_table_default": "இயல்புநிலை",
    "workspace.language_table_order": "வரிசை",
    "workspace.language_table_status": "நிலை",
    "workspace.language_table_action": "செயல்",
    "workspace.language_add_photo": "புகைப்படத்தை சேர்க்கவும்",
    "workspace.currency": "நாணயம்",
    "workspace.currency_add": "நாணயத்தை சேர்க்கவும்",
    "Add Currency": "நாணயத்தை சேர்க்கவும்",
    "workspace.currency_edit": "நாணயத்தை தொகுக்கவும்",
    "Edit Currency": "நாணயத்தை தொகுக்கவும்",
    "workspace.currency_delete_confirm": "இந்த நாணயத்தை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this currency?": "இந்த நாணயத்தை நீக்க விரும்புகிறீர்களா?",
    "workspace.currency_show": "காட்டு",
    "workspace.currency_entries": "உள்ளீடுகள்",
    "entries": "உள்ளீடுகள்",
    "workspace.currency_search": "தேடு:",
    "Search:": "தேடு:",
    "workspace.currency_search_placeholder": "நாணயங்களைத் தேடு",
    "Search currencies": "நாணயங்களைத் தேடு",
    "workspace.currency_empty": "எந்த நாணயமும் கிடைக்கவில்லை.",
    "No currencies found.": "எந்த நாணயமும் கிடைக்கவில்லை.",
    "workspace.currency_active": "செயல்பாட்டில்",
    "workspace.currency_inactive": "செயலற்ற",
    "workspace.currency_name": "பெயர்",
    "workspace.currency_name_placeholder": "நாணயத்தின் பெயர்",
    "Currency Name": "நாணயத்தின் பெயர்",
    "workspace.currency_upload_media": "ஊடகத்தை பதிவேற்று",
    "workspace.currency_select_media": "ஊடகத்திலிருந்து தேர்வுசெய்க",
    "workspace.currency_no_media": "உங்களிடம் எந்த ஊடக கோப்புகளும் இல்லை.",
    "workspace.currency_code": "குறியீடு",
    "workspace.currency_select_code": "தேர்வுசெய்க",
    "workspace.currency_exchange_rate": "மாற்று விகிதம்",
    "Exchange Rate": "மாற்று விகிதம்",
    "workspace.currency_precision": "துல்லியம்",
    "Precision": "துல்லியம்",
    "workspace.currency_thousand_separator": "ஆயிரம் பிரிப்பி",
    "Thousand Separator": "ஆயிரம் பிரிப்பி",
    "workspace.currency_decimal_point": "தசம புள்ளி",
    "Decimal Point": "தசம புள்ளி",
    "workspace.currency_status_hint": "நிலை (செயலற்ற / செயல்பாட்டில்)",
    "workspace.currency_default": "இயல்புநிலை",
    "workspace.currency_format": "வடிவமைப்பு",
    "Format": "வடிவமைப்பு",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "பெயர்",
    "workspace.currency_table_code": "குறியீடு",
    "workspace.currency_table_format": "வடிவமைப்பு",
    "workspace.currency_table_exchange": "மாற்று",
    "Exchange": "மாற்று",
    "workspace.currency_table_status": "நிலை",
    "workspace.currency_table_default": "முன்னேற்றம்",
    "workspace.currency_table_action": "செயல்முறை",
    "commissions.title": "கமிஷன்கள்",
    "commissions.add": "கமிஷனை சேர்க்கவும்",
    "Add Commission": "கமிஷனை சேர்க்கவும்",
    "commissions.edit": "கமிஷனை தொகுக்கவும்",
    "Edit Commission": "கமிஷனை தொகுக்கவும்",
    "commissions.delete_confirm": "இந்த கமிஷனை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this commission?": "இந்த கமிஷனை நீக்க விரும்புகிறீர்களா?",
    "commissions.yes": "ஆம்",
    "commissions.no": "இல்லை",
    "commissions.filter_all": "அனைத்தும்",
    "commissions.filter_supply": "சப்ளை",
    "Supply": "சப்ளை",
    "commissions.filter_demand": "தேவை",
    "Demand": "தேவை",
    "commissions.filter_cart": "கார்ட்",
    "commissions.table_title": "தலைப்பு",
    "commissions.table_default_value": "முன்னேற்ற மதிப்பு",
    "commissions.table_status": "நிலை",
    "commissions.table_action": "செயல்முறை",
    "commissions.active": "செயல்பாட்டில்",
    "commissions.inactive": "இயங்காத",
    "commissions.type": "வகை",
    "commissions.type_supply": "சப்ளை",
    "commissions.type_demand": "தேவை",
    "commissions.type_cart": "கார்ட்",
    "commissions.select_category": "கத்திரிகையைத் தேர்வுசெய்க",
    "commissions.title_label": "தலைப்பு",
    "commissions.enter_title": "தலைப்பை உள்ளிடவும்",
    "Enter title": "தலைப்பை உள்ளிடவும்",
    "commissions.description": "விளக்கம்",
    "commissions.enter_description": "விளக்கத்தை உள்ளிடவும்",
    "commissions.default_value_percent": "இயல்புநிலை மதிப்பு (%)",
    "commissions.short_code": "குறுகிய குறியீடு",
    "Short Code": "குறுகிய குறியீடு",
    "commissions.short_code_tooltip_title": "குறுகிய குறியீடு",
    "Short code": "குறுகிய குறியீடு",
    "commissions.short_code_tooltip_description": "இந்த கமிஷனுக்கு குறுகிய குறியீட்டை உள்ளிடவும்.",
    "Enter a short code for this commission.": "இந்த கமிஷனுக்கு குறுகிய குறியீட்டை உள்ளிடவும்.",
    "commissions.enter_short_code": "குறுகிய குறியீட்டை உள்ளிடவும்",
    "Enter short code": "குறுகிய குறியீட்டை உள்ளிடவும்",
    "commissions.status_hint": "நிலை (இயல்பில்லாத / செயல்பாட்டில்)",
    "commissions.optional": "தேர்வுசெய்யக்கூடிய",
    "commissions.advanced": "மேம்பட்ட",
    "commissions.add_by_category": "கேட்டகாரியம் போல கமிஷனை சேர்க்கவும்",
    "Add commission by category": "கேட்டகாரியம் போல கமிஷனை சேர்க்கவும்",
    "commissions.select_calculation_type": "வகையைத் தேர்வுசெய்க",
    "commissions.calc_fixed": "நிலையான",
    "commissions.calc_slab": "பலகை",
    "Slab": "பலகை",
    "commissions.value": "மதிப்பு",
    "commissions.choose_category": "வகையைத் தேர்வுசெய்க",
    "commissions.create_categories_first": "முதலில் பட்டியல் அமைப்பில் வகைகளை உருவாக்கவும்",
    "Create categories in Listing Configuration first": "முதலில் பட்டியல் அமைப்பில் வகைகளை உருவாக்கவும்",
    "commissions.select_type": "வகையைத் தேர்வுசெய்க",
    "commissions.demand_fixed": "நிலையான",
    "commissions.demand_percentage": "சதவீதம்",
    "commissions.unlimited_hint": "* எல்லையில்லாததற்கு -1 உள்ளிடவும்",
    "* Enter -1 for unlimited": "* எல்லையில்லாததற்கு -1 உள்ளிடவும்",
    "commissions.from": "முதல்",
    "commissions.enter_from": "முதல் உள்ளிடவும்",
    "Enter from": "முதல் உள்ளிடவும்",
    "commissions.to": "முடிவு",
    "commissions.enter_to": "முடிவு உள்ளிடவும்",
    "commissions.enter_value": "மதிப்பு உள்ளிடவும்",
    "commissions.add_row": "வரிசையை சேர்க்கவும்",
    "commissions.minimum_amount": "குறைந்தபட்ச தொகை",
    "Minimum amount": "குறைந்தபட்ச தொகை",
    "commissions.enter_minimum_amount": "குறைந்தபட்ச தொகை உள்ளிடவும்",
    "commissions.maximum_amount": "அதிகபட்ச தொகை",
    "commissions.enter_maximum_amount": "அதிகபட்ச தொகை உள்ளிடவும்",
    "commissions.notes": "குறிப்புகள்",
    "Notes": "குறிப்புகள்",
    "commissions.enter_note": "குறிப்பு உள்ளிடவும்",
    "commissions.from_value": "மதிப்பு முதல்",
    "From Value": "மதிப்பு முதல்",
    "commissions.to_value": "மதிப்பு முடிவு",
    "To Value": "மதிப்பு முடிவு",
    "commissions.unlimited_short_hint": "(-1 என்பது எல்லையற்றது)",
    "commissions.value_percent": "மதிப்பு (%)",
    "Value (%)": "மதிப்பு (%)",
    "commissions.from_value_validation": "முன்னைய மதிப்பு முடிவு விட மதிப்பு முதல் பெரியதாக இருக்க வேண்டும்",
    "From value should be greater than the previous To value": "முன்னைய மதிப்பு முடிவு விட மதிப்பு முதல் பெரியதாக இருக்க வேண்டும்",
    "commissions.to_value_validation": "மதிப்பு முடிவு மதிப்பு முதல் விட பெரியதாக இருக்க வேண்டும்",
    "To value should be greater than From value": "மதிப்பு முடிவு மதிப்பு முதல் விட பெரியதாக இருக்க வேண்டும்",
    "taxes.title": "வரி",
    "taxes.title_plural": "வரிகள்",
    "taxes.add": "வரி சேர்க்கவும்",
    "Add Tax": "வரி சேர்க்கவும்",
    "taxes.edit": "வரியை தொகுத்துக்கொள்ளவும்",
    "Edit Tax": "வரியை தொகுத்துக்கொள்ளவும்",
    "taxes.delete_confirm": "இந்த வரியை நீக்க விரும்புகிறீர்களா?",
    "Are you sure you want to delete this tax?": "இந்த வரியை நீக்க விரும்புகிறீர்களா?",
    "taxes.table_title": "தலைப்பு",
    "taxes.table_short_code": "குறுகிய குறியீடு",
    "taxes.table_default_value": "இயல்புநிலை மதிப்பு",
    "taxes.table_status": "நிலை",
    "taxes.table_action": "செயல்முறை",
    "taxes.active": "செயல்பாட்டில்",
    "taxes.inactive": "செயல்பாடில்லை",
    "taxes.select_type": "வகையைத் தேர்வுசெய்க",
    "taxes.type_order": "வரிசை",
    "taxes.type_listing": "பட்டியல்",
    "taxes.type_tax": "வரி",
    "taxes.demand_fixed": "நிலையான",
    "taxes.demand_percentage": "சதவீதம்",
    "taxes.from": "முதல்",
    "taxes.enter_from": "முதல் உள்ளிடவும்",
    "taxes.to": "வரை",
    "taxes.enter_to": "வரை உள்ளிடவும்",
    "taxes.unlimited_hint": "(-1 என்பது எல்லையில்லாததைக் குறிக்கிறது)",
    "taxes.value": "மதிப்பு",
    "taxes.enter_value": "மதிப்பை உள்ளிடவும்",
    "taxes.add_row": "வரிசையைச் சேர்க்கவும்",
    "taxes.note": "குறிப்பு",
    "taxes.note_placeholder": "காப்பீட்டு மற்றும் ஆர்டர் விவரங்களில் பயனர்கள் பார்க்க வேண்டும் என்று ஒரு குறிப்பை உள்ளிடவும்.",
    "Enter a note for users to see during checkout and in order details.": "காப்பீட்டு மற்றும் ஆர்டர் விவரங்களில் பயனர்கள் பார்க்க வேண்டும் என்று ஒரு குறிப்பை உள்ளிடவும்.",
    "taxes.inclusive": "வரி சேர்க்கப்பட்டது",
    "Tax Inclusive": "வரி சேர்க்கப்பட்டது",
    "taxes.inclusive_tooltip": "விலை ஏற்றுக்கொள்ளப்பட்டுள்ளது என்றால் இதை செயல்படுத்தவும்.",
    "Enable this when the listed price already includes tax.": "விலை ஏற்றுக்கொள்ளப்பட்டுள்ளது என்றால் இதை செயல்படுத்தவும்.",
    "taxes.title_placeholder": "காப்பீட்டு மற்றும் ஆர்டர் விவரங்களில் பயனர்களுக்குக் காட்டப்படும் பெயரை உள்ளிடவும்.",
    "Enter a name shown to users at checkout and in order details.": "காப்பீட்டு மற்றும் ஆர்டர் விவரங்களில் பயனர்களுக்குக் காட்டப்படும் பெயரை உள்ளிடவும்.",
    "taxes.default_value": "முன்னேற்ற மதிப்பு (%)",
    "taxes.default_placeholder": "முன்னேற்ற மதிப்பு % இல். எடுத்துக்காட்டு: 6.5",
    "Default value in %. Example: 6.5": "முன்னேற்ற மதிப்பு % இல். எடுத்துக்காட்டு: 6.5",
    "taxes.short_code": "குறுகிய குறியீடு",
    "taxes.short_code_tooltip_title": "குறுகிய குறியீடு",
    "taxes.short_code_tooltip_description": "இந்த வரி க்கான குறுகிய குறியீட்டை உள்ளிடவும்.",
    "Enter a short code for this tax.": "இந்த வரி க்கான குறுகிய குறியீட்டை உள்ளிடவும்.",
    "taxes.short_code_placeholder": "எழுத்துகள் மற்றும் எண்களைப் பயன்படுத்தவும், 10 எழுத்துகள் வரை. எடுத்துக்காட்டு: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "எழுத்துகள் மற்றும் எண்களைப் பயன்படுத்தவும், 10 எழுத்துகள் வரை. எடுத்துக்காட்டு: GST10",
    "taxes.status_hint": "நிலை (இயக்கமற்ற / இயக்கமுள்ள)",
    "taxes.advanced": "மேம்பட்ட",
    "special_fees.title": "கூடுதல் கட்டணங்கள்",
    "special_fees.description": "ஒவ்வொரு பட்டியலுக்கும் கூடுதல் நிலையான தொகை அல்லது சதவீதம் அமைக்கவும்.",
    "Configure an additional fixed amount or percentage fee for each listing.": "ஒவ்வொரு பட்டியலுக்கும் கூடுதல் நிலையான தொகை அல்லது சதவீதம் அமைக்கவும்.",
    "special_fees.fixed": "கூடுதல் நிலையான கட்டணம்",
    "Special fees fixed": "கூடுதல் நிலையான கட்டணம்",
    "special_fees.fixed_placeholder": "கூடுதல் கட்டணத்தின் தொகையை உள்ளிடவும் (எடுத்துக்காட்டு: 5)",
    "Enter special fee amount (example: 5)": "கூடுதல் கட்டணத்தின் தொகையை உள்ளிடவும் (எடுத்துக்காட்டு: 5)",
    "special_fees.percentage": "கூடுதல் சதவீத கட்டணம்",
    "Special fees percentage": "கூடுதல் சதவீத கட்டணம்",
    "special_fees.percentage_placeholder": "கூடுதல் கட்டணத்தின் சதவீதத்தை உள்ளிடவும் (எடுத்துக்காட்டு: 10%)",
    "Enter special fee percentage (example: 10%)": "கூடுதல் கட்டணத்தின் சதவீதத்தை உள்ளிடவும் (எடுத்துக்காட்டு: 10%)",
    "special_fees.example": "எடுத்துக்காட்டு",
    "Example": "எடுத்துக்காட்டு",
    "special_fees.example_description": "நீங்கள் பட்டியல் விலையின் மேல் கூடுதல் கட்டணத்தைச் சேர்க்கலாம். எடுத்துக்காட்டாக, பட்டியலிடப்பட்ட பொருள் $100 விலையில் உள்ளது மற்றும் ஒவ்வொரு பட்டியலுக்கும் இரண்டு கட்டணங்களைச் சேர்க்கிறீர்கள்.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "நீங்கள் பட்டியல் விலையின் மேல் கூடுதல் கட்டணத்தைச் சேர்க்கலாம். எடுத்துக்காட்டாக, பட்டியலிடப்பட்ட பொருள் $100 விலையில் உள்ளது மற்றும் ஒவ்வொரு பட்டியலுக்கும் இரண்டு கட்டணங்களைச் சேர்க்கிறீர்கள்.",
    "special_fees.example_fixed": "கூடுதல் நிலையான தொகை = $10",
    "Additional fixed amount = $10": "கூடுதல் நிலையான தொகை = $10",
    "special_fees.example_percentage": "கூடுதல் நிலையான சதவீதம் = 10%",
    "Additional fixed percentage = 10%": "கூடுதல் நிலையான சதவீதம் = 10%",
    "special_fees.example_total": "மொத்த விலை = $120",
    "Final price = $120": "மொத்த விலை = $120",
    "delivery.methods_title": "சேவை / அனுப்புதல் முறைகள்",
    "Service / Shipping Methods": "சேவை / அனுப்புதல் முறைகள்",
    "delivery.shipping_service": "அனுப்புதல் / சேவை",
    "Shipping / Service": "அனுப்புதல் / சேவை",
    "delivery.table_name": "பெயர்",
    "delivery.table_default": "முன்னேற்றம்",
    "delivery.table_order": "வரிசை",
    "delivery.table_status": "நிலை",
    "delivery.table_action": "செயல்பாடு",
    "delivery.yes": "ஆம்",
    "delivery.no": "இல்லை",
    "delivery.active": "ஆக்டிவ்",
    "delivery.inactive": "இனாக்டிவ்",
    "delivery.delete_confirm": "இந்த போக்குவரத்து முறையை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this shipping method?": "இந்த போக்குவரத்து முறையை நீக்க விரும்புகிறீர்களா?",
    "delivery.schedule_time": "திட்டமிடப்பட்ட நேரம்",
    "delivery.translate": "மொழிபெயர்க்க",
    "delivery.config": "கான்ஃபிக்",
    "delivery.add": "விநியோகம்/சேவையை சேர்க்க",
    "Add Shipping/Service": "விநியோகம்/சேவையை சேர்க்க",
    "delivery.save": "சேமி",
    "delivery.edit": "விநியோகம்/சேவையை தொகு",
    "Edit Shipping/Service": "விநியோகம்/சேவையை தொகு",
    "delivery.stuart_config": "ஸ்டார்ட் கான்ஃபிக்குகள்",
    "Stuart Configs": "ஸ்டார்ட் கான்ஃபிக்குகள்",
    "delivery.shipping_configs": "சேவை/விநியோக கான்ஃபிக்குகள்",
    "Service / Shipping Configs": "சேவை/விநியோக கான்ஃபிக்குகள்",
    "delivery.settings": "கான்ஃபிக்",
    "delivery.preview": "முன்னோட்டம்",
    "delivery.shipment_option": "விநியோக விருப்பம்",
    "Shipment Option": "விநியோக விருப்பம்",
    "delivery.name": "பெயர்",
    "delivery.enter_name": "பெயரை உள்ளிடவும்",
    "delivery.note": "குறிப்பு",
    "delivery.enter_note": "குறிப்பை உள்ளிடவும்",
    "delivery.note_tooltip_title": "குறிப்பு",
    "delivery.note_tooltip_description": "இந்த விநியோக அல்லது சேவை விருப்பத்தை விளக்க கூடுதல் குறிப்பை சேர்க்கவும்.",
    "Add an optional note to explain this shipping or service option.": "இந்த விநியோக அல்லது சேவை விருப்பத்தை விளக்க கூடுதல் குறிப்பை சேர்க்கவும்.",
    "delivery.order": "ஆர்டர்",
    "delivery.enter_order": "ஆர்டரை உள்ளிடவும்",
    "delivery.status_hint": "நிலை (இயங்காத / இயங்கும்)",
    "delivery.default": "இயல்புநிலை",
    "delivery.select_shipping_method": "கிரிப்டோ முறையைத் தேர்வுசெய்க",
    "Select shipping method": "கிரிப்டோ முறையைத் தேர்வுசெய்க",
    "delivery.select_extension": "நீட்சியைத் தேர்வுசெய்க",
    "Select extension": "நீட்சியைத் தேர்வுசெய்க",
    "delivery.add_photo": "புகைப்படத்தை சேர்க்கவும்",
    "delivery.config.flat_shipping_fee.title": "நிலையான கிரிப்டோ கட்டணம்",
    "Flat Shipping Fee": "நிலையான கிரிப்டோ கட்டணம்",
    "delivery.config.flat_shipping_fee.placeholder": "நிலையான கிரிப்டோ கட்டணத்தை உள்ளிடவும்",
    "Enter flat shipping fee": "நிலையான கிரிப்டோ கட்டணத்தை உள்ளிடவும்",
    "delivery.config.schedule_time.title": "திட்டமிடல் நேரம்",
    "delivery.config.fulfillment_by_platform_enabled.title": "தளத்தின் மூலம் நிறைவேற்றம்",
    "Fulfillment by platform": "தளத்தின் மூலம் நிறைவேற்றம்",
    "delivery.config.fulfilled_by_platform_icon_path.title": "தளத்தின் மூலம் நிறைவேற்ற ஐகான்",
    "Fulfillment by Platform Icon": "தளத்தின் மூலம் நிறைவேற்ற ஐகான்",
    "delivery.config.fulfilled_by_seller_icon_path.title": "விற்பனையாளர் மூலம் கிரிப்டோ ஐகான்",
    "Seller Delivery Icon": "விற்பனையாளர் மூலம் கிரிப்டோ ஐகான்",
    "delivery.phone_number": "தொலைபேசி எண்",
    "Phone number": "தொலைபேசி எண்",
    "delivery.enter_phone_number": "தொலைபேசி எண்ணை உள்ளிடவும்",
    "Enter phone number": "தொலைபேசி எண்ணை உள்ளிடவும்",
    "delivery.address_line_1": "முதல் வரியில் முகவரி",
    "Address line 1": "முதல் வரியில் முகவரி",
    "delivery.enter_address_line_1": "முதல் வரியில் முகவரியை உள்ளிடவும்",
    "Enter address line 1": "முதல் வரியில் முகவரியை உள்ளிடவும்",
    "delivery.address_line_2": "இரண்டாம் வரியில் முகவரி",
    "Address line 2": "இரண்டாம் வரியில் முகவரி",
    "delivery.enter_address_line_2": "இரண்டாம் வரியில் முகவரியை உள்ளிடவும்",
    "Enter address line 2": "இரண்டாம் வரியில் முகவரியை உள்ளிடவும்",
    "delivery.landmark": "குறிப்பு புள்ளி",
    "Landmark": "குறிப்பு புள்ளி",
    "delivery.enter_landmark": "குறிப்பு புள்ளியை உள்ளிடவும்",
    "Enter landmark": "குறிப்பு புள்ளியை உள்ளிடவும்",
    "delivery.state": "நிலை",
    "delivery.enter_state": "நிலையை உள்ளிடவும்",
    "Enter state": "நிலையை உள்ளிடவும்",
    "delivery.post_code": "கட்டுப்பாட்டு குறியீடு",
    "Post code": "கட்டுப்பாட்டு குறியீடு",
    "delivery.enter_post_code": "குறியீட்டு எண்ணை உள்ளிடவும்",
    "Enter post code": "குறியீட்டு எண்ணை உள்ளிடவும்",
    "delivery.country": "நாடு",
    "delivery.enter_country": "நாட்டை உள்ளிடவும்",
    "Enter country": "நாட்டை உள்ளிடவும்",
    "delivery.required_information": "தேவையான தகவல்களை நிரப்பவும்",
    "Please fill the required information": "தேவையான தகவல்களை நிரப்பவும்",
    "delivery.saved_successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "delivery.storage_hub.title": "சேமிப்பு மைய புள்ளிகள்",
    "Storage Hub Points": "சேமிப்பு மைய புள்ளிகள்",
    "delivery.storage_hub.add": "சேமிப்பு மையத்தை சேர்க்கவும்",
    "Add Storage Hub": "சேமிப்பு மையத்தை சேர்க்கவும்",
    "delivery.storage_hub.edit": "சேமிப்பு மையத்தை தொகுக்கவும்",
    "Edit Storage Hub": "சேமிப்பு மையத்தை தொகுக்கவும்",
    "delivery.storage_hub.delete_confirm": "இந்த சேமிப்பு மைய புள்ளியை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this storage hub point?": "இந்த சேமிப்பு மைய புள்ளியை நீக்க விரும்புகிறீர்களா?",
    "delivery.storage_hub.table_name": "பெயர்",
    "delivery.storage_hub.table_phone": "தொலைபேசி எண்",
    "delivery.storage_hub.table_address": "முகவரி",
    "delivery.storage_hub.table_landmark": "குறிப்பு புள்ளி",
    "delivery.storage_hub.table_state": "மாநிலம்",
    "delivery.storage_hub.table_post_code": "குறியீட்டு எண்",
    "Post Code": "குறியீட்டு எண்",
    "delivery.storage_hub.table_country": "நாடு",
    "delivery.storage_hub.table_action": "செயல்முறை",
    "delivery.select_environment": "சூழ்நிலையை தேர்வு செய்யவும்",
    "Select environment": "சூழ்நிலையை தேர்வு செய்யவும்",
    "delivery.environment_sandbox": "சோதனைச் சூழல்",
    "Sandbox": "சோதனைச் சூழல்",
    "delivery.environment_production": "தயாரிப்பு",
    "Production": "தயாரிப்பு",
    "delivery.stuart.client_id": "வாடிக்கையாளர் ID",
    "delivery.stuart.enter_client_id": "வாடிக்கையாளர் ID-ஐ உள்ளிடவும்",
    "delivery.stuart.client_secret": "வாடிக்கையாளர் ரகசியம்",
    "Client Secret": "வாடிக்கையாளர் ரகசியம்",
    "delivery.stuart.enter_client_secret": "வாடிக்கையாளர் ரகசியத்தை உள்ளிடவும்",
    "Enter client secret": "வாடிக்கையாளர் ரகசியத்தை உள்ளிடவும்",
    "delivery.stuart.webhook_key": "வெப்ஹுக் அடையாள அடையாள குறியீடு",
    "Webhook Authentication Key": "வெப்ஹுக் அடையாள அடையாள குறியீடு",
    "delivery.stuart.enter_webhook_key": "வெப்ஹுக் அடையாள அடையாள குறியீட்டை உள்ளிடவும்",
    "Enter webhook authentication key": "வெப்ஹுக் அடையாள அடையாள குறியீட்டை உள்ளிடவும்",
    "delivery.sendcloud.public_key": "பொது குறியீடு",
    "Public Key": "பொது குறியீடு",
    "delivery.sendcloud.enter_public_key": "API குறியீட்டை உள்ளிடவும்",
    "delivery.sendcloud.secret_key": "ரகசிய குறியீடு",
    "delivery.sendcloud.enter_secret_key": "அறிவிப்பு ரகசிய குறியீட்டை உள்ளிடவும்",
    "delivery.sendcloud.default_shipping_address": "முன்னேற்ற அனுப்புதல் முகவரி",
    "Default Shipping Address": "முன்னேற்ற அனுப்புதல் முகவரி",
    "delivery.sendcloud.add_new": "+ புதியதை சேர்",
    "+ Add New": "+ புதியதை சேர்",
    "delivery.sendcloud.country_id": "ID",
    "payments.title": "கட்டண முறைகள்",
    "Payment Methods": "கட்டண முறைகள்",
    "payments.add": "கட்டண முறையை சேர்",
    "Add Payment Method": "கட்டண முறையை சேர்",
    "payments.edit": "கட்டண முறையை தொகு",
    "Edit Payment Method": "கட்டண முறையை தொகு",
    "payments.delete_confirm": "இந்த கட்டண முறையை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this payment method?": "இந்த கட்டண முறையை நீக்க விரும்புகிறீர்களா?",
    "payments.save_continue": "சேமித்து தொடரவும்",
    "Save and continue": "சேமித்து தொடரவும்",
    "payments.translate": "கட்டணங்களை மொழிபெயர்க்க",
    "Translate Payments": "கட்டணங்களை மொழிபெயர்க்க",
    "payments.config": "அமைப்பு",
    "payments.integration_settings": "ஒன்றிணைப்பு அமைப்பு",
    "Integration Settings": "ஒன்றிணைப்பு அமைப்பு",
    "payments.opp_integration": "OPP ஒன்றிணைப்பு",
    "OPP Integration": "OPP ஒன்றிணைப்பு",
    "payments.billplz_integration": "BillPlz ஒன்றிணைப்பு",
    "BillPlz Integration": "BillPlz ஒன்றிணைப்பு",
    "payments.stripe_integration": "Stripe ஒன்றிணைப்பு",
    "Stripe Integration": "Stripe ஒன்றிணைப்பு",
    "payments.stripe_web_integration": "Stripe வலைப்பக்க ஒன்றிணைப்பு",
    "Stripe Web Integration": "Stripe வலைப்பக்க ஒன்றிணைப்பு",
    "payments.pawapay_integration": "PawaPay ஒன்றிணைப்பு",
    "PawaPay Integration": "PawaPay ஒன்றிணைப்பு",
    "payments.korapay_integration": "KoraPay ஒன்றிணைப்பு",
    "KoraPay Integration": "KoraPay ஒன்றிணைப்பு",
    "payments.flutterwave_integration": "Flutterwave ஒன்றிணைப்பு",
    "Flutterwave Integration": "Flutterwave ஒன்றிணைப்பு",
    "payments.commercepay_integration": "காமர்ச்பே ஒத்திசைவு",
    "CommercePay Integration": "காமர்ச்பே ஒத்திசைவு",
    "payments.checkout_com_integration": "கூக்கிள் செய்திகள் ஒத்திசைவு",
    "Checkout.com Integration": "கூக்கிள் செய்திகள் ஒத்திசைவு",
    "payments.paystack_integration": "பேய்ஸ்டாக் ஒத்திசைவு",
    "PayStack Integration": "பேய்ஸ்டாக் ஒத்திசைவு",
    "payments.razorpay_settings": "ரேசர்பே அமைப்புகள்",
    "Razorpay settings": "ரேசர்பே அமைப்புகள்",
    "payments.paydunya_settings": "பேய் டூனியா அமைப்புகள்",
    "Pay Dunya settings": "பேய் டூனியா அமைப்புகள்",
    "payments.mangopay_settings": "மங்கோபே அமைப்புகள்",
    "MangoPay settings": "மங்கோபே அமைப்புகள்",
    "payments.payu_latam_integration": "பேய்யு லாடம் ஒத்திசைவு",
    "PayU LATAM Integration": "பேய்யு லாடம் ஒத்திசைவு",
    "payments.table_name": "பெயர்",
    "payments.table_actions": "செயல்பாடுகள்",
    "payments.table_min_amount": "குறைந்தபட்ச தொகை",
    "Minimum Amount": "குறைந்தபட்ச தொகை",
    "payments.table_max_amount": "அதிகபட்ச தொகை",
    "Maximum Amount": "அதிகபட்ச தொகை",
    "payments.table_default": "முன்னிருப்பு",
    "payments.table_order_by": "வரிசை",
    "payments.table_status": "நிலை",
    "payments.yes": "ஆம்",
    "payments.no": "இல்லை",
    "payments.active": "செயல்பாட்டில்",
    "payments.inactive": "இயலாத",
    "payments.settings": "அமைப்புகள்",
    "payments.not_available": "N/A",
    "payments.step_select_type": "வகையைத் தேர்வு செய்யவும்",
    "payments.step_configure": "அமைப்புகளை அமைக்கவும்",
    "payments.step_integration": "ஒத்திசைவு",
    "payments.next": "அடுத்தது →",
    "Next →": "அடுத்தது →",
    "payments.save": "சேமி",
    "payments.choose_method": "கட்டண முறையைத் தேர்வு செய்க",
    "Choose a payment method to configure": "கட்டண முறையைத் தேர்வு செய்க",
    "payments.name": "பெயர்",
    "payments.enter_name": "பெயரை உள்ளிடவும்",
    "payments.maximum_amount": "கூடுதல் தொகை",
    "payments.enter_maximum_amount": "கூடுதல் தொகையை உள்ளிடவும்",
    "payments.minimum_amount": "குறைந்தபட்ச தொகை",
    "payments.enter_minimum_amount": "குறைந்தபட்ச தொகையை உள்ளிடவும்",
    "payments.note": "குறிப்பு",
    "payments.enter_note": "குறிப்பை உள்ளிடவும்",
    "payments.note_tooltip": "காசோலையில் வாடிக்கையாளர்களுக்கு தேர்வுசெய்யக்கூடிய குறிப்பை சேர்க்கவும்.",
    "Add an optional note for customers at checkout.": "காசோலையில் வாடிக்கையாளர்களுக்கு தேர்வுசெய்யக்கூடிய குறிப்பை சேர்க்கவும்.",
    "payments.order": "வரிசை",
    "payments.enter_order": "வரிசையை உள்ளிடவும்",
    "payments.default": "இயல்புநிலை",
    "payments.config_title": "கட்டண முறைகள் அமைப்பு",
    "Payment Methods Configuration": "கட்டண முறைகள் அமைப்பு",
    "payments.wallet_enable": "வாலட் செயல்பாட்டில்",
    "Wallet enabled": "வாலட் செயல்பாட்டில்",
    "payments.account_type": "கணக்கு வகை",
    "payments.select_account_type": "கணக்கு வகையைத் தேர்வு செய்க",
    "Select account type": "கணக்கு வகையைத் தேர்வு செய்க",
    "payments.connect_message_standard": "இணைப்பு செய்தியை தொடங்கு",
    "Connect message standard": "இணைப்பு செய்தியை தொடங்கு",
    "payments.enter_connect_message_standard": "இணைப்பு செய்தியை உள்ளிடவும்",
    "Enter connect message standard": "இணைப்பு செய்தியை உள்ளிடவும்",
    "payments.disconnect_message_standard": "இணைப்பை நீக்கும் செய்தி",
    "Disconnect message standard": "இணைப்பை நீக்கும் செய்தி",
    "payments.enter_disconnect_message_standard": "இணைப்பை நீக்கும் செய்தியை உள்ளிடவும்",
    "Enter disconnect message standard": "இணைப்பை நீக்கும் செய்தியை உள்ளிடவும்",
    "payments.connect_message_express": "விரைவான இணைப்பு செய்தி",
    "Connect message express": "விரைவான இணைப்பு செய்தி",
    "payments.enter_connect_message_express": "விரைவான இணைப்பு செய்தியை உள்ளிடவும்",
    "Enter connect message express": "விரைவான இணைப்பு செய்தியை உள்ளிடவும்",
    "payments.disconnect_message_express": "மேலும் தொடர்பு நீக்க செய்தி",
    "Disconnect message express": "மேலும் தொடர்பு நீக்க செய்தி",
    "payments.enter_disconnect_message_express": "மேலும் தொடர்பு நீக்க செய்தியை உள்ளிடவும்",
    "Enter disconnect message express": "மேலும் தொடர்பு நீக்க செய்தியை உள்ளிடவும்",
    "payments.enable_sandbox": "சான்ட்பாக்ஸை செயல்படுத்து",
    "Enable sandbox": "சான்ட்பாக்ஸை செயல்படுத்து",
    "payments.api_token": "API டோக்கன்",
    "API Token": "API டோக்கன்",
    "payments.enter_token": "டோக்கனை உள்ளிடவும்",
    "payments.key_id": "குறியீடு",
    "Key ID": "குறியீடு",
    "payments.enter_key_id": "குறியீட்டை உள்ளிடவும்",
    "Enter key ID": "குறியீட்டை உள்ளிடவும்",
    "payments.key_secret": "குறியீட்டு ரகசியம்",
    "Key Secret": "குறியீட்டு ரகசியம்",
    "payments.enter_secret_key": "குறியீட்டு ரகசியத்தை உள்ளிடவும்",
    "Enter secret key": "குறியீட்டு ரகசியத்தை உள்ளிடவும்",
    "payments.webhook_secret_key": "ஹுப்பாக் ரகசிய குறியீடு",
    "Webhook Secret Key": "ஹுப்பாக் ரகசிய குறியீடு",
    "payments.enter_webhook_secret_key": "ஹுப்பாக் ரகசிய குறியீட்டை உள்ளிடவும்",
    "Enter webhook secret key": "ஹுப்பாக் ரகசிய குறியீட்டை உள்ளிடவும்",
    "payments.master_key": "முதன்மை குறியீடு",
    "Master Key": "முதன்மை குறியீடு",
    "payments.public_key": "பொது குறியீடு",
    "payments.enter_public_key": "பொது குறியீட்டை உள்ளிடவும்",
    "Enter public key": "பொது குறியீட்டை உள்ளிடவும்",
    "payments.private_key": "தனியார் குறியீடு",
    "Private Key": "தனியார் குறியீடு",
    "payments.merchant_id": "விற்பனையாளர் ID",
    "Merchant ID": "விற்பனையாளர் ID",
    "payments.enter_merchant_id": "விற்பனையாளர் ID-ஐ உள்ளிடவும்",
    "Enter merchant id": "விற்பனையாளர் ID-ஐ உள்ளிடவும்",
    "payments.processing_channel_id": "செயலாக்க சேனல் ID",
    "Processing channel ID": "செயலாக்க சேனல் ID",
    "payments.enter_processing_channel_id": "செயலாக்க சேனல் ID-ஐ உள்ளிடவும்",
    "Enter processing channel id": "செயலாக்க சேனல் ID-ஐ உள்ளிடவும்",
    "payments.api_key": "API குறியீடு",
    "payments.x_signature_key": "X கையொப்ப குறியீடு",
    "X Signature Key": "X கையொப்ப குறியீடு",
    "payments.account_id": "கணக்கு ID",
    "payments.login_api_key": "முகவரி API குறியீடு",
    "Login API key": "முகவரி API குறியீடு",
    "payments.client_id": "வாடிக்கையாளர் ID",
    "payments.client_api_key": "கிளயண்ட் API குறியீடு",
    "Client API Key": "கிளயண்ட் API குறியீடு",
    "payments.payin_fee": "PayIn கழிவு (%)",
    "PayIn fee (%)": "PayIn கழிவு (%)",
    "payments.withdraw_fee": "Withdraw கழிவு (%)",
    "Withdraw fee (%)": "Withdraw கழிவு (%)",
    "payments.enter_api_key": "API குறியீட்டை உள்ளிடவும்",
    "payments.enter_account_id": "கணக்கு ஐடி உள்ளிடவும்",
    "Enter account ID": "கணக்கு ஐடி உள்ளிடவும்",
    "payments.enter_login_api_key": "முகவரி API குறியீட்டை உள்ளிடவும்",
    "Enter login API key": "முகவரி API குறியீட்டை உள்ளிடவும்",
    "payments.enter_notification_secret": "அறிவிப்பு ரகசியத்தை உள்ளிடவும்",
    "payments.enter_payin_fee": "சதவீதமாக கழிவை உள்ளிடவும்",
    "Enter fee as a percentage": "சதவீதமாக கழிவை உள்ளிடவும்",
    "payments.secret_key": "ரகசிய குறியீடு",
    "Secret key": "ரகசிய குறியீடு",
    "payments.publishable_key": "பொது குறியீடு",
    "Publishable key": "பொது குறியீடு",
    "payments.webhook_secret": "Webhook ரகசியம்",
    "Webhook secret": "Webhook ரகசியம்",
    "payments.enter_webhook_secret": "Webhook ரகசியத்தை உள்ளிடவும்",
    "Enter webhook secret": "Webhook ரகசியத்தை உள்ளிடவும்",
    "payments.enter_subscription_webhook_secret": "மாதாந்திர உறுப்பினர் Webhook ரகசியத்தை உள்ளிடவும்",
    "Enter subscription webhook secret": "மாதாந்திர உறுப்பினர் Webhook ரகசியத்தை உள்ளிடவும்",
    "payments.connect_client_id": "Connect கிளயண்ட் ஐடி",
    "Connect client ID": "Connect கிளயண்ட் ஐடி",
    "payments.enter_connect_client_id": "Connect கிளயண்ட் ஐடி உள்ளிடவும்",
    "Enter Connect client ID": "Connect கிளயண்ட் ஐடி உள்ளிடவும்",
    "payments.stripe_reminders": "Stripe நினைவுகூர்வுகள்",
    "Stripe reminders": "Stripe நினைவுகூர்வுகள்",
    "payments.stripe_sync_help": "சிங்கிரோனைசேஷன் ஸ்ட்ரைப் உடன் உங்கள் ரகசிய குறியீட்டை சரிபார்க்கிறது, உங்கள் கணக்கு விவரங்களை நிரப்புகிறது, மற்றும் Tradly தேவைப்படும் webhook புள்ளிகளை உருவாக்குகிறது. Webhook ரகசியங்கள் தானியங்கி நிரப்பப்படுகின்றன; முடித்தபின் வடிவத்தை சேமி.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "சிங்கிரோனைசேஷன் ஸ்ட்ரைப் உடன் உங்கள் ரகசிய குறியீட்டை சரிபார்க்கிறது, உங்கள் கணக்கு விவரங்களை நிரப்புகிறது, மற்றும் Tradly தேவைப்படும் webhook புள்ளிகளை உருவாக்குகிறது. Webhook ரகசியங்கள் தானியங்கி நிரப்பப்படுகின்றன; முடித்தபின் வடிவத்தை சேமி.",
    "payments.find_in_stripe": "Stripe பேனலில் தேடு",
    "Find in Stripe Dashboard": "Stripe பேனலில் தேடு",
    "payments.description": "விவரம்",
    "payments.learn_more_stripe": "Stripe பேமென்ட்ஸ் பற்றி மேலும் அறிய",
    "Learn more about Stripe Payments": "Stripe பேமென்ட்ஸ் பற்றி மேலும் அறிய",
    "payments.learn_more_stripe_connect": "மார்க்கெட்பிளேஸ்களுக்கான Stripe Connect பற்றி மேலும் அறிய",
    "Learn more about Stripe Connect for marketplaces": "மார்க்கெட்பிளேஸ்களுக்கான Stripe Connect பற்றி மேலும் அறிய",
    "payments.token": "டோக்கன்",
    "Token": "டோக்கன்",
    "payments.payment_options": "பேமென்ட் தேர்வுகள்",
    "Payment options": "பேமென்ட் தேர்வுகள்",
    "payments.enable_integration": "ஒன்றிணைப்பை செயல்படுத்து",
    "Enable integration": "ஒன்றிணைப்பை செயல்படுத்து",
    "payments.enter_provider_id": " {provider} ஐடி உள்ளிடவும்",
    "Enter {provider} ID": " {provider} ஐடி உள்ளிடவும்",
    "payments.integration_status_help": "இந்த வழங்குநரை அதன் அமைப்புகளில் அமைக்கவும்.",
    "Configure this provider in its settings.": "இந்த வழங்குநரை அதன் அமைப்புகளில் அமைக்கவும்.",
    "listings.title": "பட்டியல்கள்",
    "listings.manage": "நிர்வகிக்க",
    "listings.show_rows": "வரிகளைக் காட்டு",
    "listings.clear": "அழி",
    "listings.apply": "பயன்படுத்த",
    "listings.select_date": "தேதியைத் தேர்வுசெய்க",
    "Select date": "தேதியைத் தேர்வுசெய்க",
    "listings.start_date": "தொடக்க தேதி",
    "listings.end_date": "முடிவு தேதி",
    "listings.status_types": "நிலை வகைகள்",
    "Status types": "நிலை வகைகள்",
    "listings.categories": "கேட்டகாரிகள்",
    "listings.attributes": "அம்சங்கள்",
    "listings.clear_all_filters": "எல்லா வடிகட்டிகளையும் அழி",
    "Clear all filters": "எல்லா வடிகட்டிகளையும் அழி",
    "listings.import": "கொண்டுவருதல்",
    "listings.export": "வெளியீடு",
    "listings.smart_upload": "உள்ளீடு குறிப்பிட்ட பதிப்பு (Beta)",
    "Smart Upload (Beta)": "உள்ளீடு குறிப்பிட்ட பதிப்பு (Beta)",
    "listings.filter_listings": "பட்டியல்களை தேர்வு செய்தல்",
    "Filter listings": "பட்டியல்களை தேர்வு செய்தல்",
    "listings.sort_listings": "பட்டியல்களை வரிசைப்படுத்துதல்",
    "Sort listings": "பட்டியல்களை வரிசைப்படுத்துதல்",
    "listings.import_listings": "பட்டியல்களை கொண்டுவருதல்",
    "listings.export_listings": "பட்டியல்களை வெளியீடு",
    "Export listings": "பட்டியல்களை வெளியீடு",
    "listings.list_view": "பட்டியல் காட்சி",
    "listings.grid_view": "கிரிட் காட்சி",
    "listings.map_view": "மேப் காட்சி",
    "listings.board_view": "போர்டு காட்சி",
    "listings.export_all_title": "எல்லா பட்டியல்களையும் ஏற்றுமதி செய்ய வேண்டுமா?",
    "Export all listings?": "எல்லா பட்டியல்களையும் ஏற்றுமதி செய்ய வேண்டுமா?",
    "listings.export_all_message": "இது அனைத்து பட்டியல்களையும் கொண்டிருக்கும் கோப்பை தயாரிக்கும். தொடர விரும்புகிறீர்களா?",
    "This will prepare a file containing all listings. Do you want to continue?": "இது அனைத்து பட்டியல்களையும் கொண்டிருக்கும் கோப்பை தயாரிக்கும். தொடர விரும்புகிறீர்களா?",
    "listings.export_all": "எல்லா பட்டியல்களையும் ஏற்றுமதி செய்யவும்",
    "Export all listings": "எல்லா பட்டியல்களையும் ஏற்றுமதி செய்யவும்",
    "listings.cancel": "ரத்து செய்யவும்",
    "listings.status_all": "அனைத்தும்",
    "listings.status_pending": "தொடங்கப்படாத",
    "listings.status_approved": "ஒப்புக்கொள்ளப்பட்டது",
    "listings.status_rejected": "நிராகரிக்கப்பட்டது",
    "listings.status_archived": "கோப்புக்கு வைக்கப்பட்டது",
    "listings.sort_newest_first": "புதியதாக முதலில்",
    "Newest first": "புதியதாக முதலில்",
    "listings.sort_price_high_to_low": "விலை: உயர்ந்தது முதல் குறைவானது",
    "Price: high to low": "விலை: உயர்ந்தது முதல் குறைவானது",
    "listings.sort_price_low_to_high": "விலை: குறைவானது முதல் உயர்ந்தது",
    "Price: low to high": "விலை: குறைவானது முதல் உயர்ந்தது",
    "listings.header_0": "தலைப்பு",
    "listings.header_1": "இணையதளம்",
    "listings.header_2": "பட்டியல் விலை",
    "List price": "பட்டியல் விலை",
    "listings.header_3": "ஆஃபர் சதவீதம்",
    "listings.header_4": "படம்",
    "listings.header_5": "ஆஃபர் விலை",
    "Offer price": "ஆஃபர் விலை",
    "listings.header_6": "நிலை",
    "listings.header_7": "பட்டியல் ID",
    "listings.header_8": "பட்டியல் நிலை",
    "Listing status": "பட்டியல் நிலை",
    "listings.header_9": "கணக்குகள்",
    "listings.header_10": "நாணயம்",
    "listings.header_11": "விற்றது",
    "listings.header_12": "இலக்கு தொகை",
    "Goal amount": "இலக்கு தொகை",
    "listings.filter_status": "நிலை",
    "listings.filter_price": "விலை",
    "listings.filter_category": "பிரிவு",
    "listings.filter_clear_all": "எல்லா வடிகட்டிகளையும் அழி",
    "listings.status_count": "நிலை ({count})",
    "Status ({count})": "நிலை ({count})",
    "listings.price_count": "விலை ({count})",
    "Price ({count})": "விலை ({count})",
    "listings.category_count": "பிரிவு ({count})",
    "Category ({count})": "பிரிவு ({count})",
    "listings.search": "பட்டியல்களைத் தேடு",
    "listings.clear_search": "தேடலை அழி",
    "Clear listing search": "தேடலை அழி",
    "listings.active": "செயல்பாட்டில்",
    "listings.inactive": "செயலற்ற",
    "listings.approve": "ஒப்புக்கொள்ள",
    "listings.reject": "நிராகரிக்க",
    "listings.delete_confirm": "இந்த பட்டியலை நீக்க விரும்புகிறீர்களா?",
    "Are you sure you want to delete this listing?": "இந்த பட்டியலை நீக்க விரும்புகிறீர்களா?",
    "listings.approve_confirm": "இந்த பட்டியலை ஒப்புக்கொள்ள விரும்புகிறீர்களா?",
    "Do you want to approve this listing?": "இந்த பட்டியலை ஒப்புக்கொள்ள விரும்புகிறீர்களா?",
    "listings.reject_confirm": "இந்த பட்டியலை நிராகரிக்க விரும்புகிறீர்களா?",
    "Do you want to reject this listing?": "இந்த பட்டியலை நிராகரிக்க விரும்புகிறீர்களா?",
    "listings.yes": "ஆம்",
    "listings.no": "இல்லை",
    "listings.confirm_delete": "இந்த பட்டியலை நீக்க விரும்புகிறீர்களா?",
    "listings.confirm_approve": "இந்த பட்டியலை ஒப்புக்கொள்ள விரும்புகிறீர்களா?",
    "listings.confirm_reject": "இந்த பட்டியலை நிராகரிக்க விரும்புகிறீர்களா?",
    "listings.column.actions": "செயல்பாடுகள்",
    "listings.audio_episode": "ஆடியோ பகுதி",
    "Audio episode": "ஆடியோ பகுதி",
    "listings.video": "வீடியோ",
    "listings.seller": "விற்பனையாளர்",
    "listings.rating": "மதிப்பீடு",
    "listings.followers": "பின்பற்றுபவர்கள்",
    "listings.view_seller_account": "விற்பனையாளர் கணக்கைப் பார்க்கவும்",
    "View seller account": "விற்பனையாளர் கணக்கைப் பார்க்கவும்",
    "listings.add_variant": "வித்தியாசத்தைச் சேர்க்கவும்",
    "listings.edit": "தொகுக்கவும்",
    "listings.preview": "முன்னோட்டம்",
    "listings.share": "பகிரவும்",
    "listings.view_listing": "பட்டியலைப் பார்க்கவும்",
    "View listing": "பட்டியலைப் பார்க்கவும்",
    "listings.stock": "கொள்முதல்",
    "listings.variants": "வித்தியாசங்கள்",
    "listings.campaign": "முயற்சி",
    "listings.rental_details": "வாடகை விவரங்கள்",
    "Rental details": "வாடகை விவரங்கள்",
    "listings.copy": "நகலெடுக்கவும்",
    "listings.inventory": "கொள்முதல் பட்டியல்",
    "listings.order_type": "ஆர்டர் வகை",
    "Order type": "ஆர்டர் வகை",
    "listings.stock_by_location": "இடத்தில் கொள்முதல்",
    "Stock by location": "இடத்தில் கொள்முதல்",
    "listings.loading_location_stock": "இடத்தில் கொள்முதலை ஏற்றுகிறது…",
    "Loading location stock…": "இடத்தில் கொள்முதலை ஏற்றுகிறது…",
    "listings.no_location_stock": "இடத்திற்கு ஒரு கொள்முதல் ஒதுக்கப்படவில்லை.",
    "No stock assigned to a location.": "இடத்திற்கு ஒரு கொள்முதல் ஒதுக்கப்படவில்லை.",
    "listings.page_analytics": "பக்க பகுப்பாய்வு",
    "Page analytics": "பக்க பகுப்பாய்வு",
    "listings.loading": "ஏற்றுகிறது…",
    "listings.analytics_key_missing": "பகுப்பாய்வு API குறியீடு இந்த குடியிருப்பாளருக்கு அமைக்கப்படவில்லை.",
    "Analytics API key is not configured for this tenant.": "பகுப்பாய்வு API குறியீடு இந்த குடியிருப்பாளருக்கு அமைக்கப்படவில்லை.",
    "listings.no_slug": "இந்த பட்டியலுக்கு ஏதும் ஸ்லக் கிடைக்கவில்லை.",
    "No slug is available for this listing.": "இந்த பட்டியலுக்கு ஏதும் ஸ்லக் கிடைக்கவில்லை.",
    "listings.no_analytics": "இதற்கான பகுப்பாய்வுகள் இன்னும் ஏற்றப்படவில்லை.",
    "listings.load_analytics": "பகுப்பாய்வுகளை ஏற்றுகொள்",
    "Load analytics": "பகுப்பாய்வுகளை ஏற்றுகொள்",
    "listings.no_orders": "இந்த பட்டியலுக்கு இன்னும் பண்டிகைகள் இல்லை",
    "No orders yet for this listing": "இந்த பட்டியலுக்கு இன்னும் பண்டிகைகள் இல்லை",
    "listings.social_ratings": "சமூகம் மற்றும் மதிப்பீடுகள்",
    "Social and ratings": "சமூகம் மற்றும் மதிப்பீடுகள்",
    "listings.tags": "குறியீடுகள்",
    "listings.schedule": "திட்டமிடு",
    "listings.detail": "விவரம்",
    "Detail": "விவரம்",
    "listings.update_stock": "கொள்முதலை புதுப்பி",
    "Update stock": "கொள்முதலை புதுப்பி",
    "listings.new_stock_quantity": "புதிய கொள்முதல் அளவு",
    "New stock quantity": "புதிய கொள்முதல் அளவு",
    "listings.location": "இடம்",
    "listings.quantity": "அளவு",
    "listings.current_stock": "தற்போதைய கொள்முதல்: {quantity}",
    "Current stock: {quantity}": "தற்போதைய கொள்முதல்: {quantity}",
    "listings.loading_rental": "வாடகை அமைப்புகளை ஏற்றுகிறது…",
    "Loading rental settings…": "வாடகை அமைப்புகளை ஏற்றுகிறது…",
    "payments.enter_publishable_key": "பொது குறியீட்டை உள்ளிடவும்",
    "Enter publishable key": "பொது குறியீட்டை உள்ளிடவும்",
    "listings.add_listing": "பட்டியலைச் சேர்க்கவும்",
    "Add listing": "பட்டியலைச் சேர்க்கவும்",
    "listings.edit_listing": "பட்டியலை திருத்தவும்",
    "listings.enter_title": "தலைப்பை உள்ளிடவும்",
    "listings.account": "கணக்கு",
    "listings.list_price": "பட்டியல் விலை",
    "listings.enter_list_price": "பட்டியல் விலையை உள்ளிடவும்",
    "Enter list price": "பட்டியல் விலையை உள்ளிடவும்",
    "listings.select_currency": "நாணயத்தைத் தேர்வுசெய்யவும்",
    "listings.select_category": "பிரிவைத் தேர்வுசெய்யவும்",
    "listings.select_categories": "பிரிவுகளைத் தேர்வுசெய்யவும்",
    "Select categories": "பிரிவுகளைத் தேர்வுசெய்யவும்",
    "listings.add_category": "+ கத்தில் சேர்",
    "+ Add category": "+ கத்தில் சேர்",
    "listings.add_attribute": "பண்பை சேர்",
    "Add attribute": "பண்பை சேர்",
    "listings.enter_stock": "ஸ்டாக்கை உள்ளிடு",
    "listings.offer_percentage": "ஆஃபர் சதவீதம்",
    "Offer percentage": "ஆஃபர் சதவீதம்",
    "listings.enter_offer": "ஆஃபரை உள்ளிடு",
    "Enter offer": "ஆஃபரை உள்ளிடு",
    "listings.max_quantity_optional": "குறைந்தபட்ச அளவு (தேர்வுக்குரியது)",
    "Max quantity (optional)": "குறைந்தபட்ச அளவு (தேர்வுக்குரியது)",
    "listings.enter_max_quantity": "குறைந்தபட்ச அளவை உள்ளிடு",
    "Enter max quantity": "குறைந்தபட்ச அளவை உள்ளிடு",
    "listings.enter_slug": "ஸ்லகை உள்ளிடு",
    "listings.enter_meta_title": "மெட்டா தலைப்பை உள்ளிடு",
    "listings.repeat": "திரும்ப செய்ய",
    "Repeat": "திரும்ப செய்ய",
    "listings.start_time": "தொடக்க நேரம்",
    "Start time": "தொடக்க நேரம்",
    "listings.end_time": "முடிவு நேரம்",
    "End time": "முடிவு நேரம்",
    "listings.slot": "ஸ்லாட்",
    "Slot": "ஸ்லாட்",
    "listings.starts_from": "தொடங்குகிறது:",
    "Starts from:": "தொடங்குகிறது:",
    "listings.add_schedule": "+ நேரம் சேர்",
    "listings.upload_here": "இங்கே பதிவேற்று",
    "listings.save": "சேமி",
    "listings.update": "புதுப்பி",
    "listings.tax": "வரி",
    "listings.title_required": "தலைப்பை உள்ளிடவும்",
    "Please enter a title": "தலைப்பை உள்ளிடவும்",
    "listings.select_tax": "வரியை தேர்வு செய்யவும்",
    "Please select a tax": "வரியை தேர்வு செய்யவும்",
    "listings.select_item": "{item}-ஐ தேர்வு செய்யவும்",
    "Please select {item}": "{item}-ஐ தேர்வு செய்யவும்",
    "listings.offer_percentage_validation": "ஆஃபர் சதவீதம் 0 முதல் 100 வரை இருக்க வேண்டும்",
    "Offer percentage must be between 0 and 100": "ஆஃபர் சதவீதம் 0 முதல் 100 வரை இருக்க வேண்டும்",
    "listings.custom_seo": "தனிப்பயன் SEO",
    "Custom SEO": "தனிப்பயன் SEO",
    "listings.select_value": "மதிப்பைத் தேர்வு செய்யவும்",
    "Select value": "மதிப்பைத் தேர்வு செய்யவும்",
    "listings.add_schedule_title": "வேளையைச் சேர்க்கவும்",
    "Add schedule": "வேளையைச் சேர்க்கவும்",
    "listings.select_from_media": "ஊடகங்களிலிருந்து தேர்வு செய்யவும்",
    "listing_form.create_listing": "அறிவிப்பை உருவாக்கு",
    "Create listing": "அறிவிப்பை உருவாக்கு",
    "listing_form.update_listing": "அறிவிப்பை மேம்படுத்து",
    "Update listing": "அறிவிப்பை மேம்படுத்து",
    "listing_form.saving": "சேமிக்கப்படுகிறது…",
    "listing_form.main_information": "முக்கிய தகவல்",
    "Main information": "முக்கிய தகவல்",
    "listing_form.audio_listing": "ஒலி அறிவிப்பு",
    "Audio listing": "ஒலி அறிவிப்பு",
    "listing_form.basic_information": "அடிப்படைத் தகவல்",
    "Basic information": "அடிப்படைத் தகவல்",
    "listing_form.listing_type": "அறிவிப்பு வகை",
    "Listing type": "அறிவிப்பு வகை",
    "listing_form.title": "தலைப்பு",
    "listing_form.enter_listing_title": "அறிவிப்புத் தலைப்பை உள்ளிடவும்",
    "Enter listing title": "அறிவிப்புத் தலைப்பை உள்ளிடவும்",
    "listing_form.description": "விவரம்",
    "listing_form.enter_detailed_description": "விரிவான விவரத்தை உள்ளிடவும்",
    "Enter detailed description": "விரிவான விவரத்தை உள்ளிடவும்",
    "listing_form.tags": "குறியீடுகள்",
    "listing_form.tag_example": "எ.கா., மின்னணுக்கருவிகள், கேஜெட்கள், புதிய",
    "e.g., electronics, gadgets, new": "எ.கா., மின்னணுக்கருவிகள், கேஜெட்கள், புதிய",
    "listing_form.taxes": "வரி",
    "listing_form.optional": "தேர்வுசெய்யக்கூடியது",
    "listing_form.start_date": "தொடக்க தேதி",
    "listing_form.end_date": "முடிவு தேதி",
    "listing_form.currency": "நாணயம்",
    "listing_form.select_currency": "நாணயத்தைத் தேர்வு செய்யவும்",
    "listing_form.goal_price": "இலக்கு விலை",
    "Goal price": "இலக்கு விலை",
    "listing_form.set_fundraising_goal": "நிதி சேகரிப்பு இலக்கை அமைக்கவும்",
    "Set your fundraising goal": "நிதி சேகரிப்பு இலக்கை அமைக்கவும்",
    "listing_form.pricing": "விலைகள்",
    "Pricing": "விலைகள்",
    "listing_form.select": "தேர்வு செய்யவும்",
    "listing_form.price": "விலை",
    "listing_form.offer_percent": "ஆஃபர் %",
    "Offer %": "ஆஃபர் %",
    "listing_form.listing_price": "பட்டியல் விலை:",
    "Listing price:": "பட்டியல் விலை:",
    "listing_form.set_fundraising_goal_amount": "உங்கள் தொகை கூட்டும் இலக்கை அமைக்கவும்",
    "Set your fundraising goal amount": "உங்கள் தொகை கூட்டும் இலக்கை அமைக்கவும்",
    "listing_form.category": "வகைப்பாடு",
    "listing_form.select_a_category": "வகைப்பாட்டைத் தேர்வு செய்யவும்",
    "listing_form.clear_selected_category": "தேர்வு செய்த வகைப்பாட்டை அழி",
    "Clear selected category": "தேர்வு செய்த வகைப்பாட்டை அழி",
    "listing_form.create_new_category": "புதிய வகைப்பாட்டை உருவாக்கவும்",
    "Create a new category": "புதிய வகைப்பாட்டை உருவாக்கவும்",
    "listing_form.search_categories": "வகைப்பாடுகளைத் தேடு…",
    "Search categories…": "வகைப்பாடுகளைத் தேடு…",
    "listing_form.no_categories_match": "வகைப்பாடுகள் கிடைக்கவில்லை",
    "No categories found": "வகைப்பாடுகள் கிடைக்கவில்லை",
    "listing_form.draft_found": "சேமிக்கப்பட்ட தொடக்க பதிவு கிடைத்தது.",
    "A saved draft was found.": "சேமிக்கப்பட்ட தொடக்க பதிவு கிடைத்தது.",
    "listing_form.restore": "மீட்க",
    "Restore": "மீட்க",
    "listing_form.discard": "தவிர்க்க",
    "listing_form.characters": "எழுத்துக்கள்",
    "characters": "எழுத்துக்கள்",
    "listing_form.zero_amount": "0.00",
    "0.00": "0.00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "உருவப் பொருட்கள்",
    "Physical products": "உருவப் பொருட்கள்",
    "listing_form.type_events": "நிகழ்வுகள்",
    "Events": "நிகழ்வுகள்",
    "listing_form.type_digital": "டிஜிட்டல் பொருட்கள்",
    "Digital products": "டிஜிட்டல் பொருட்கள்",
    "listing_form.type_appointments": "அழைப்புகள்",
    "Appointments": "அழைப்புகள்",
    "listing_form.type_rentals": "வாடகைகள்",
    "listing_form.type_donation": "கூட்டு நிதி திட்டம்",
    "Crowdfunding": "கூட்டு நிதி திட்டம்",
    "listing_form.type_information_listing": "தகவல்",
    "Information": "தகவல்",
    "listing_form.type_video_listing": "வீடியோ",
    "listing_form.type_audio_listing": "ஆடியோ",
    "listing_form.select_taxes": "வரி தேர்வு செய்யவும் (தேர்வுக்குரியது)",
    "Select taxes (optional)": "வரி தேர்வு செய்யவும் (தேர்வுக்குரியது)",
    "listing_form.no_taxes": "கிடைக்கும் வரிகள் இல்லை",
    "No taxes available": "கிடைக்கும் வரிகள் இல்லை",
    "listing_form.inventory_shipping": "சேமிப்பு மற்றும் அனுப்புதல்",
    "Inventory & shipping": "சேமிப்பு மற்றும் அனுப்புதல்",
    "listing_form.stock": "ஸ்டாக்",
    "listing_form.weight": "எடை",
    "Weight": "எடை",
    "listing_form.dimensions": "அளவுகள் (நீளம் × அகலம் × உயரம்)",
    "Dimensions (L×W×H)": "அளவுகள் (நீளம் × அகலம் × உயரம்)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "பரிமாற்ற குறியீடு",
    "listing_form.length": "நீளம்",
    "Length": "நீளம்",
    "listing_form.width": "அகலம்",
    "Width": "அகலம்",
    "listing_form.height": "உயரம்",
    "Height": "உயரம்",
    "listing_form.seo_settings": "SEO அமைப்புகள்",
    "SEO settings": "SEO அமைப்புகள்",
    "listing_form.slug": "ஸ்லக்",
    "listing_form.url_friendly_title": "URL-க்கு ஏற்ற பதிப்பு",
    "URL-friendly version of the title": "URL-க்கு ஏற்ற பதிப்பு",
    "listing_form.meta_title": "மெட்டா தலைப்பு",
    "listing_form.recommended_meta_title": "பரிந்துரைக்கப்பட்டது: 50–60 எழுத்துகள்",
    "Recommended: 50–60 chars": "பரிந்துரைக்கப்பட்டது: 50–60 எழுத்துகள்",
    "listing_form.meta_keywords": "மெட்டா சொற்கள்",
    "Meta keywords": "மெட்டா சொற்கள்",
    "listing_form.separate_with_commas": "கோடுகளால் பிரிக்கவும்",
    "Separate with commas": "கோடுகளால் பிரிக்கவும்",
    "listing_form.meta_description": "மெட்டா விவரணம்",
    "listing_form.recommended_meta_description": "பரிந்துரைக்கப்பட்டது: 150–160 எழுத்துகள்",
    "Recommended: 150–160 chars": "பரிந்துரைக்கப்பட்டது: 150–160 எழுத்துகள்",
    "listing_form.hide": "மறைக்கவும்",
    "listing_form.show": "காட்டு",
    "listing_form.seo_fields": "தேடல் இயந்திர செயல்திறன் புலங்கள்",
    "search engine optimization fields": "தேடல் இயந்திர செயல்திறன் புலங்கள்",
    "listing_form.auto_generated_slug": "தலைப்பிலிருந்து தானியங்கி உருவாக்கப்பட்டது",
    "Auto-generated from title": "தலைப்பிலிருந்து தானியங்கி உருவாக்கப்பட்டது",
    "listing_form.seo_title_optional": "SEO தலைப்பு (கூடுதல்)",
    "SEO title (optional)": "SEO தலைப்பு (கூடுதல்)",
    "listing_form.keywords_comma_separated": "குறிப்புகள் புள்ளிகளால் பிரிக்கப்பட்டவை",
    "Keywords separated by commas": "குறிப்புகள் புள்ளிகளால் பிரிக்கப்பட்டவை",
    "listing_form.search_description_optional": "தேடல் முடிவுகளுக்கான சுருக்கமான விளக்கம் (கூடுதல்)",
    "Brief description for search results (optional)": "தேடல் முடிவுகளுக்கான சுருக்கமான விளக்கம் (கூடுதல்)",
    "listing_form.account": "கணக்கு",
    "listing_form.loading_accounts": "கணக்குகளை ஏற்றுகிறது…",
    "Loading accounts…": "கணக்குகளை ஏற்றுகிறது…",
    "listing_form.clear_selected_account": "தேர்ந்தெடுக்கப்பட்ட கணக்கை அழி",
    "Clear selected account": "தேர்ந்தெடுக்கப்பட்ட கணக்கை அழி",
    "listing_form.search_accounts": "கணக்குகளைத் தேடு…",
    "Search accounts…": "கணக்குகளைத் தேடு…",
    "listing_form.create_account": "புதிய கணக்கை உருவாக்கு",
    "Create a new account": "புதிய கணக்கை உருவாக்கு",
    "listing_form.no_accounts_found": "கணக்குகள் கிடைக்கவில்லை",
    "No accounts found": "கணக்குகள் கிடைக்கவில்லை",
    "listing_form.rental_settings": "வாடகை அமைப்புகள்",
    "Rental settings": "வாடகை அமைப்புகள்",
    "listing_form.rental_price_help": "வாடகை விகிதம் மற்றும் கால அளவிலிருந்து பட்டியல் விலை கணக்கிடப்படுகிறது.",
    "The listing price is calculated from the rental rate and duration.": "வாடகை விகிதம் மற்றும் கால அளவிலிருந்து பட்டியல் விலை கணக்கிடப்படுகிறது.",
    "listing_form.rate_unit": "விகித அலகு",
    "Rate unit": "விகித அலகு",
    "listing_form.hour": "மணி",
    "Hour": "மணி",
    "listing_form.day": "நாள்",
    "listing_form.week": "வாரம்",
    "listing_form.rental_rate_amount": "வாடகை விகிதம்",
    "Rental rate": "வாடகை விகிதம்",
    "listing_form.rental_min_duration": "குறைந்தபட்ச காலம்",
    "Minimum duration": "குறைந்தபட்ச காலம்",
    "listing_form.rental_max_duration": "அதிகபட்ச காலம்",
    "Maximum duration": "அதிகபட்ச காலம்",
    "listing_form.rental_buffer_time": "பஃபர் நேரம் (மணிநேரங்கள்)",
    "Buffer time (hours)": "பஃபர் நேரம் (மணிநேரங்கள்)",
    "listing_form.rental_deposit_amount": "மூலதன தொகை",
    "Deposit amount": "மூலதன தொகை",
    "listing_form.rental_max_units": "அதிகபட்ச அலகுகள்",
    "Maximum units": "அதிகபட்ச அலகுகள்",
    "listing_form.quick_create_title": "கொண்டு உருவாக்கு {entity}",
    "Create {entity}": "கொண்டு உருவாக்கு {entity}",
    "listing_form.close": "மூடு",
    "listing_form.account_name": "கணக்கு பெயர்",
    "listing_form.category_name": "கத்திரிகை பெயர்",
    "Category name": "கத்திரிகை பெயர்",
    "listing_form.account_example": "எ.கா. Acme கடை",
    "e.g. Acme Store": "எ.கா. Acme கடை",
    "listing_form.category_example": "எ.கா. புதிய பொருட்கள்",
    "e.g. Fresh Produce": "எ.கா. புதிய பொருட்கள்",
    "listing_form.creating": "உருவாக்கும்…",
    "listing_form.create_entity": "கொண்டு உருவாக்கு {entity}",
    "listing_form.cancel": "ரத்து செய்ய",
    "listing_form.go_back": "திரும்பு",
    "Go back": "திரும்பு",
    "listing_form.upgrade_plan": "திட்டத்தை மேம்படுத்து",
    "Upgrade plan": "திட்டத்தை மேம்படுத்து",
    "listing_form.close_upgrade_dialog": "மேம்படுத்தல் பேச்சு மூடு",
    "Close upgrade dialog": "மேம்படுத்தல் பேச்சு மூடு",
    "listing_form.loading_attributes": "பண்புகளை ஏற்றுகிறது…",
    "Loading attributes…": "பண்புகளை ஏற்றுகிறது…",
    "listing_form.no_attributes": "இந்த பிரிவிற்கு பண்புகள் இல்லை",
    "No attributes for this category": "இந்த பிரிவிற்கு பண்புகள் இல்லை",
    "listing_form.unsupported_field_type": "பொருத்தமற்ற புல வகை",
    "Unsupported field type": "பொருத்தமற்ற புல வகை",
    "listing_form.delete_schedule_confirm": "இந்த திட்டமிடலை நீக்க விரும்புகிறீர்களா? (உறுதிப்படுத்துதல்)",
    "Are you sure you want to delete this schedule?": "இந்த திட்டமிடலை நீக்க விரும்புகிறீர்களா? (உறுதிப்படுத்துதல்)",
    "listing_form.no_schedules_added": "முன்னர் திட்டமிடல்கள் சேர்க்கப்படவில்லை",
    "No schedules added yet": "முன்னர் திட்டமிடல்கள் சேர்க்கப்படவில்லை",
    "listing_form.stock_label": "கொள்ளளவு:",
    "Stock:": "கொள்ளளவு:",
    "listing_form.active": "செயல்பாட்டில்",
    "listing_form.inactive": "செயலற்ற",
    "listing_form.edit": "தொகு",
    "listing_form.delete": "நீக்கு",
    "listing_form.schedules": "திட்டமிடல்கள்",
    "Schedules": "திட்டமிடல்கள்",
    "listing_form.no_schedules_yet": "முன்னர் திட்டமிடல்கள் இல்லை",
    "No schedules yet": "முன்னர் திட்டமிடல்கள் இல்லை",
    "listing_form.dates_label": "தேதிகள்:",
    "Dates:": "தேதிகள்:",
    "listing_form.time_label": "நேரம்:",
    "Time:": "நேரம்:",
    "listing_form.repeat_label": "மீண்டும் செய்யுங்கள்:",
    "Repeat:": "மீண்டும் செய்யுங்கள்:",
    "listing_form.capacity_label": "திறன்:",
    "Capacity:": "திறன்:",
    "listing_form.edit_schedule": "விநியோக நேரத்தை திருத்து",
    "Edit schedule": "விநியோக நேரத்தை திருத்து",
    "listing_form.add_new_schedule": "புதிய விநியோக நேரத்தை சேர்",
    "Add new schedule": "புதிய விநியோக நேரத்தை சேர்",
    "listing_form.repeat_pattern": "மீண்டும் செய்யும் முறை",
    "Repeat pattern": "மீண்டும் செய்யும் முறை",
    "listing_form.select_days": "நாட்களைத் தேர்வு செய்யவும்",
    "Select days": "நாட்களைத் தேர்வு செய்யவும்",
    "listing_form.total_stocks_capacity": "மொத்த சேமிப்பு (திறன்)",
    "Total stock (capacity)": "மொத்த சேமிப்பு (திறன்)",
    "listing_form.select_at_least_one_day": "குறைந்தது ஒரு நாளைத் தேர்வு செய்யவும்",
    "Please select at least one day": "குறைந்தது ஒரு நாளைத் தேர்வு செய்யவும்",
    "listing_form.unlimited_capacity_help": "முடிவில்லாத திறனுக்கு வ空白 விடவும்",
    "Leave empty for unlimited capacity": "முடிவில்லாத திறனுக்கு வ空白 விடவும்",
    "listing_form.add_schedule": "+ விநியோக நேரத்தை சேர்",
    "listing_form.schedule_number": "விநியோக நேரம் #{number}",
    "Schedule #{number}": "விநியோக நேரம் #{number}",
    "listing_form.update_action": "திருத்து",
    "listing_form.create_action": "உருவாக்கு",
    "listing_form.a_schedule": "ஒரு விநியோக நேரம்",
    "a schedule": "ஒரு விநியோக நேரம்",
    "listing_form.daily": "தினமும்",
    "listing_form.weekdays": "வேலை நாட்கள் (திங்கள் - வியாழன்)",
    "Weekdays (Mon - Fri)": "வேலை நாட்கள் (திங்கள் - வியாழன்)",
    "listing_form.weekend": "விடுமுறை நாட்கள் (சனி - ஞாயிறு)",
    "Weekend (Sat - Sun)": "விடுமுறை நாட்கள் (சனி - ஞாயிறு)",
    "listing_form.custom": "தனிப்பயன்",
    "listing_form.weekday_0": "திங்கள்",
    "Monday": "திங்கள்",
    "listing_form.weekday_1": "மங்கள்",
    "Tuesday": "மங்கள்",
    "listing_form.weekday_2": "புதன்",
    "Wednesday": "புதன்",
    "listing_form.weekday_3": "வியாழன்",
    "Thursday": "வியாழன்",
    "listing_form.weekday_4": "வியாழன்",
    "Friday": "வியாழன்",
    "listing_form.weekday_5": "சனிக்கிழமை",
    "Saturday": "சனிக்கிழமை",
    "listing_form.weekday_6": "ஞாயிறு",
    "Sunday": "ஞாயிறு",
    "listing_form.media_max_files": "குறைந்தபட்சம் {count} {type} அனுமதிக்கப்பட்டது",
    "Maximum {count} {type} allowed": "குறைந்தபட்சம் {count} {type} அனுமதிக்கப்பட்டது",
    "listing_form.video_size_limit": "ஒவ்வொரு வீடியோவும் 1GB அல்லது குறைவாக இருக்க வேண்டும்",
    "Each video must be 1GB or smaller": "ஒவ்வொரு வீடியோவும் 1GB அல்லது குறைவாக இருக்க வேண்டும்",
    "listing_form.videos": "வீடியோக்கள்",
    "Videos": "வீடியோக்கள்",
    "listing_form.images": "படங்கள்",
    "listing_form.select_from_media": "ஊடகங்களிலிருந்து தேர்வு செய்யவும்",
    "listing_form.video_upload_help": "MP4, MOV, AVI, MKV, WebM வடிவத்தில் வீடியோக்களை பதிவேற்றுங்கள் (ஒவ்வொன்றும் குறைந்தபட்சம் 1GB)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "MP4, MOV, AVI, MKV, WebM வடிவத்தில் வீடியோக்களை பதிவேற்றுங்கள் (ஒவ்வொன்றும் குறைந்தபட்சம் 1GB)",
    "listing_form.image_upload_help": "JPG, PNG, GIF, WebP வடிவத்தில் படங்களை பதிவேற்றுங்கள் (ஒவ்வொன்றும் குறைந்தபட்சம் 10MB)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "JPG, PNG, GIF, WebP வடிவத்தில் படங்களை பதிவேற்றுங்கள் (ஒவ்வொன்றும் குறைந்தபட்சம் 10MB)",
    "listing_form.uploading_video": "வீடியோ பதிவேற்றம்…",
    "Uploading video…": "வீடியோ பதிவேற்றம்…",
    "listing_form.audio_episode": "ஆடியோ பகுதி",
    "listing_form.audio_upload_help": "ஆடியோ கோப்பை பதிவேற்றவும் அல்லது RSS புலத்திற்கு பொது ஆடியோ URL-ஐ ஒட்டவும்.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "ஆடியோ கோப்பை பதிவேற்றவும் அல்லது RSS புலத்திற்கு பொது ஆடியோ URL-ஐ ஒட்டவும்.",
    "listing_form.selected_file": "தேர்வு செய்யப்பட்டது: {name}",
    "listing_form.audio_url_help": "கோப்பு தேர்வு செய்யப்பட்டபோது URL தேவையில்லை. பதிவேற்றிய கோப்பை பயன்படுத்த வெறும் இடத்தை விட்டு விடவும்.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "கோப்பு தேர்வு செய்யப்பட்டபோது URL தேவையில்லை. பதிவேற்றிய கோப்பை பயன்படுத்த வெறும் இடத்தை விட்டு விடவும்.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "ஆடியோ பதிவேற்றம்…",
    "Uploading audio…": "ஆடியோ பதிவேற்றம்…",
    "listing_form.validation_start_date": "தொடக்க தேதியை தேர்வு செய்யவும்",
    "Please select start date": "தொடக்க தேதியை தேர்வு செய்யவும்",
    "listing_form.validation_end_date": "முடிவு தேதியை தேர்வு செய்யவும்",
    "Please select end date": "முடிவு தேதியை தேர்வு செய்யவும்",
    "listing_form.validation_start_time": "தொடக்க நேரத்தை தேர்வு செய்யவும்",
    "Please select start time": "தொடக்க நேரத்தை தேர்வு செய்யவும்",
    "listing_form.validation_end_time": "முடிவு நேரத்தை தேர்வு செய்யவும்",
    "Please select end time": "முடிவு நேரத்தை தேர்வு செய்யவும்",
    "listing_form.weekdays_short": "வேலை நாட்கள்",
    "Weekdays": "வேலை நாட்கள்",
    "listing_form.weekend_short": "விடுமுறை நாட்கள்",
    "Weekend": "விடுமுறை நாட்கள்",
    "listing_form.click_add_schedule_help": "முதல் நேர அட்டவணையை உருவாக்க இயக்கம் \"{action}\"-ஐ கிளிக் செய்யவும்",
    "Click \"{action}\" to create your first schedule": "முதல் நேர அட்டவணையை உருவாக்க இயக்கம் \"{action}\"-ஐ கிளிக் செய்யவும்",
    "listing_form.schedule_form_intro": "கீழே உள்ள விவரங்களை நிரப்பவும்",
    "Fill in the details below to": "கீழே உள்ள விவரங்களை நிரப்பவும்",
    "listing_form.update": "தொகுப்பு",
    "listing_form.save": "சேமி",
    "listing_form.variant_value_required": "குறைந்தபட்சம் ஒரு வேரியண்ட் மதிப்பைத் தேர்வு செய்யவும் (எ.கா., வண்ணம், அளவு)",
    "Please select at least one variant value (e.g., Color, Size)": "குறைந்தபட்சம் ஒரு வேரியண்ட் மதிப்பைத் தேர்வு செய்யவும் (எ.கா., வண்ணம், அளவு)",
    "listing_form.valid_price_required": "சரியான விலையை உள்ளிடவும்",
    "Please enter a valid price": "சரியான விலையை உள்ளிடவும்",
    "listing_form.delete_variant_confirm": "இந்த வேரியண்டை நீக்க விரும்புகிறீர்களா? (ஆம்/இல்லை)",
    "listing_form.product_variants": "தயாரிப்பு வேரியண்ட்கள்",
    "Product Variants": "தயாரிப்பு வேரியண்ட்கள்",
    "listing_form.add_variant": "+ வேரியண்டை சேர்",
    "+ Add Variant": "+ வேரியண்டை சேர்",
    "listing_form.select_all_variants": "எல்லா வேரியண்ட்களையும் தேர்வு செய்யவும்",
    "Select all variants": "எல்லா வேரியண்ட்களையும் தேர்வு செய்யவும்",
    "listing_form.set_quantity_selected": "தேர்ந்தெடுக்கப்பட்டவற்றிற்கு அளவை அமைக்கவும்",
    "Set quantity for selected": "தேர்ந்தெடுக்கப்பட்டவற்றிற்கு அளவை அமைக்கவும்",
    "listing_form.quantity": "அளவு",
    "listing_form.apply_quantity": "அளவை பயன்படுத்தவும்",
    "Apply quantity": "அளவை பயன்படுத்தவும்",
    "listing_form.select_variant_number": "வேரியண்ட் {number}ஐத் தேர்வு செய்யவும்",
    "Select variant {number}": "வேரியண்ட் {number}ஐத் தேர்வு செய்யவும்",
    "listing_form.variant_number": "வேரியண்ட் #{number}",
    "Variant #{number}": "வேரியண்ட் #{number}",
    "listing_form.existing": "இருப்புள்ள",
    "Existing": "இருப்புள்ள",
    "listing_form.modified": "மாற்றம் செய்யப்பட்ட",
    "Modified": "மாற்றம் செய்யப்பட்ட",
    "listing_form.variant_name": "வேரியண்ட் பெயர்",
    "Variant Name": "வேரியண்ட் பெயர்",
    "listing_form.variant_values": "வேரியண்ட் மதிப்புகள்",
    "Variant Values": "வேரியண்ட் மதிப்புகள்",
    "listing_form.type": "வகை",
    "listing_form.no_variant_values": "வேரியண்ட் மதிப்புகள் இல்லை",
    "No variant values": "வேரியண்ட் மதிப்புகள் இல்லை",
    "listing_form.no_variants_yet": "வேரியண்ட்கள் இன்னும் இல்லை",
    "No variants yet": "வேரியண்ட்கள் இன்னும் இல்லை",
    "listing_form.click_add_variant_help": "முதல் வேரியண்டை உருவாக்க, \"{action}\"-ஐ கிளிக் செய்யவும்",
    "Click \"{action}\" to create your first variant": "முதல் வேரியண்டை உருவாக்க, \"{action}\"-ஐ கிளிக் செய்யவும்",
    "listing_form.select_variant_type": "{type}-ஐத் தேர்வு செய்யவும்",
    "Select {type}": "{type}-ஐத் தேர்வு செய்யவும்",
    "listing_form.no_variant_types": "வேரியண்ட் வகைகள் கிடைக்கவில்லை. முதலில் வேரியண்ட் வகைகளை (எ.கா., வண்ணம், அளவு) உருவாக்கவும்.",
    "No variant types available. Please create variant types (like Color, Size) first.": "வேரியண்ட் வகைகள் கிடைக்கவில்லை. முதலில் வேரியண்ட் வகைகளை (எ.கா., வண்ணம், அளவு) உருவாக்கவும்.",
    "listing_form.generated_name": "உருவாக்கப்பட்ட பெயர்:",
    "Generated Name:": "உருவாக்கப்பட்ட பெயர்:",
    "listing_form.custom_title": "தனிப்பயன் பெயர்",
    "Custom Title": "தனிப்பயன் பெயர்",
    "listing_form.auto_generate_help": "ஆட்டோ உருவாக்க வெற்று இடத்தை விட்டுவிடவும்",
    "Leave blank to auto-generate": "ஆட்டோ உருவாக்க வெற்று இடத்தை விட்டுவிடவும்",
    "listing_form.save_variant": "வேரியண்டை சேமி",
    "Save Variant": "வேரியண்டை சேமி",
    "listing_form.start_time": "தொடக்க நேரம்",
    "Start Time": "தொடக்க நேரம்",
    "listing_form.end_time": "முடிவு நேரம்",
    "End Time": "முடிவு நேரம்",
    "listing_form.enter_capacity_limit": "திறன் வரம்பை உள்ளிடவும்",
    "Enter capacity limit": "திறன் வரம்பை உள்ளிடவும்",
    "collections.validation_title": "தலைப்பு வெறுமையாக இருக்க முடியாது",
    "Title should not be empty": "தலைப்பு வெறுமையாக இருக்க முடியாது",
    "collections.validation_platform": "குறைந்தது ஒரு தளத்தைத் தேர்வு செய்யவும்",
    "Select at least one platform": "குறைந்தது ஒரு தளத்தைத் தேர்வு செய்யவும்",
    "collections.validation_dates": "முடிவு தேதி தொடக்க தேதியை விட பிறகு இருக்க வேண்டும்",
    "End Date must be later than start date": "முடிவு தேதி தொடக்க தேதியை விட பிறகு இருக்க வேண்டும்",
    "collections.validation_minimum_selection": "குறைந்தது ஒரு {type}-ஐத் தேர்வு செய்யவும்",
    "Select at least one {type}": "குறைந்தது ஒரு {type}-ஐத் தேர்வு செய்யவும்",
    "collections.account": "கணக்கு",
    "account": "கணக்கு",
    "collections.listing": "பட்டியல்",
    "listing": "பட்டியல்",
    "collections.edit_title": "கூட்டுதலை தொகுத்துக்கொள்ளவும்",
    "Edit Collection": "கூட்டுதலை தொகுத்துக்கொள்ளவும்",
    "collections.create_title": "கூட்டுதலை உருவாக்கவும்",
    "collections.details": "கூட்டுதல் விவரங்கள்",
    "Collection details": "கூட்டுதல் விவரங்கள்",
    "collections.title_placeholder": "தலைப்பு பெயரை உள்ளிடவும்",
    "Enter title name": "தலைப்பு பெயரை உள்ளிடவும்",
    "collections.slug": "ஸ்லக்",
    "collections.slug_placeholder": "ஸ்லக் உள்ளிடவும்",
    "collections.enter_title_first": "முதலில் தலைப்பை உள்ளிடவும்",
    "collections.scope": "விரிவான பகுதி",
    "collections.accounts": "கணக்குகள்",
    "collections.listings": "பட்டியல்கள்",
    "collections.choose_category": "கத்திரிகையைத் தேர்வு செய்யவும்",
    "collections.conditions": "நிபந்தனைகள்",
    "Conditions": "நிபந்தனைகள்",
    "collections.condition_type": "நிபந்தனை வகை",
    "Condition type": "நிபந்தனை வகை",
    "collections.manual": "கையேடு",
    "Manual": "கையேடு",
    "collections.automated": "தானியங்கி",
    "Automated": "தானியங்கி",
    "collections.availability": "கொள்ளும் திறன்",
    "Collections availability": "கொள்ளும் திறன்",
    "collections.schedule": "திட்டமிடல்",
    "collections.applicable_channels": "பயன்படுத்தக்கூடிய சேனலைத் தேர்வுசெய்க",
    "Select applicable channel": "பயன்படுத்தக்கூடிய சேனலைத் தேர்வுசெய்க",
    "collections.web": "வலைத்தளம்",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "பெயரில் தேடு",
    "Search by name": "பெயரில் தேடு",
    "collections.not_found": "கொள்ளும் திறன் காணப்படவில்லை.",
    "Collection not found.": "கொள்ளும் திறன் காணப்படவில்லை.",
    "collections.featured_listings": "முன்னணி பட்டியல்கள்",
    "Featured listings": "முன்னணி பட்டியல்கள்",
    "collections.url_copied": "பொது இணைப்பு நகலெடுக்கப்பட்டது",
    "Public URL copied": "பொது இணைப்பு நகலெடுக்கப்பட்டது",
    "collections.url_copy_failed": "பொது இணைப்பை நகலெடுக்க முடியவில்லை",
    "Unable to copy the public URL": "பொது இணைப்பை நகலெடுக்க முடியவில்லை",
    "collections.collection": "கொள்ளும் திறன்",
    "Collection": "கொள்ளும் திறன்",
    "collections.this_collection": "இந்த கொள்ளும் திறன்",
    "this collection": "இந்த கொள்ளும் திறன்",
    "collections.share_text": "{title} ஐப் பார்க்க",
    "View {title}": "{title} ஐப் பார்க்க",
    "collections.public_url": "பொது இணைப்பு:",
    "Public URL:": "பொது இணைப்பு:",
    "collections.copy_url": "URL நகலெடுக்க",
    "Copy URL": "URL நகலெடுக்க",
    "collections.items": "பொருட்கள்",
    "collections.expires": "முடிவடைகிறது",
    "Expires": "முடிவடைகிறது",
    "collections.never": "எப்போதும் இல்லை",
    "Never": "எப்போதும் இல்லை",
    "collections.automatic_conditions": "தானியங்கி நிபந்தனைகள்",
    "Automatic Conditions": "தானியங்கி நிபந்தனைகள்",
    "collections.item_count": "{count} உறுப்புகள்",
    "collections.loading_items": "கூடுதல் உறுப்புகள் ஏற்றப்படுகின்றன…",
    "Loading items…": "கூடுதல் உறுப்புகள் ஏற்றப்படுகின்றன…",
    "collections.no_items": "இந்த கூட்டு கூட்டத்தில் உறுப்புகள் இல்லை.",
    "No items in this collection yet.": "இந்த கூட்டு கூட்டத்தில் உறுப்புகள் இல்லை.",
    "collections.delete_confirm": "இந்த கூட்டத்தை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this collection?": "இந்த கூட்டத்தை நீக்க விரும்புகிறீர்களா?",
    "collections.title": "கூட்டங்கள்",
    "collections.header_title": "தலைப்பு",
    "collections.header_action": "செயல்பாடு",
    "collections.header_id": "ID",
    "collections.header_condition_type": "நிபந்தனை வகை",
    "Condition Type": "நிபந்தனை வகை",
    "collections.header_scope": "விரிவான பகுதி",
    "collections.header_start_date": "தொடக்க தேதி",
    "collections.header_end_date": "முடிவு தேதி",
    "collections.header_status": "நிலை",
    "collections.header_url": "URL",
    "common.calendar_view": "காலண்டர் காட்சி",
    "Calendar view": "காலண்டர் காட்சி",
    "common.deleted": "நீக்கப்பட்ட",
    "common.list_view": "பட்டியல் காட்சி",
    "common.description": "விளக்கம்",
    "common.title": "தலைப்பு",
    "common.end_date": "முடிவு தேதி",
    "common.start_date": "தொடக்க தேதி",
    "promotions.image_required": "கூடுதல் படத்தை சேர்க்கவும்",
    "Please add an image": "கூடுதல் படத்தை சேர்க்கவும்",
    "promotions.edit_title": "பிரமோஷனை தொகுக்கவும்",
    "Edit Promotion": "பிரமோஷனை தொகுக்கவும்",
    "promotions.add_title": "பிரமோஷனை சேர்க்கவும்",
    "Add Promotion": "பிரமோஷனை சேர்க்கவும்",
    "promotions.name": "முன்னெடுப்பு பெயர்",
    "Promotion Name": "முன்னெடுப்பு பெயர்",
    "promotions.select_medium": "காட்சி தேர்வு செய்யவும்",
    "Select Medium": "காட்சி தேர்வு செய்யவும்",
    "promotions.upload_media": "மீடியா பதிவேற்று",
    "promotions.schedule": "திட்டமிடு",
    "promotions.destination_type": "இலக்கு வகை",
    "Destination Type": "இலக்கு வகை",
    "promotions.placement": "இடம்",
    "Placement": "இடம்",
    "promotions.status": "நிலை (இயல்பற்ற / இயங்கும்)",
    "promotions.delete_confirm": "இந்த முன்னெடுப்பை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this promotion?": "இந்த முன்னெடுப்பை நீக்க விரும்புகிறீர்களா?",
    "promotions.title": "முன்னெடுப்புகள்",
    "promotions.header_image": "படம்",
    "promotions.header_medium": "காட்சி",
    "promotions.header_placement": "இடம்",
    "promotions.header_type": "வகை",
    "promotions.header_value": "மதிப்பு",
    "promotions.header_active": "இயங்கும்",
    "promotions.header_action": "செயல்",
    "promotions.header_start_at": "தொடங்கும் நேரம்",
    "Start At": "தொடங்கும் நேரம்",
    "promotions.header_end_at": "முடிவு நேரம்",
    "End At": "முடிவு நேரம்",
    "common.grid_view": "கிரிட் காட்சி",
    "promotions.type_general": "பொது",
    "promotions.type_listing": "பட்டியல்",
    "promotions.type_account": "கணக்கு",
    "promotions.type_external_link": "வெளிப்புற இணைப்பு",
    "External link": "வெளிப்புற இணைப்பு",
    "promotions.preview": "முன்னோட்டம்",
    "promotions.select_listing": "தேர்வு பட்டியல்",
    "Select Listing": "தேர்வு பட்டியல்",
    "promotions.select_account": "கணக்கைத் தேர்வு செய்யவும்",
    "promotions.home_placement": "முகப்பு",
    "promotions.footer_placement": "கீழ்க்குறிப்பு",
    "Footer": "கீழ்க்குறிப்பு",
    "promotions.web_only": "(ஆன்லைன் மட்டும்)",
    "(Web Only)": "(ஆன்லைன் மட்டும்)",
    "coupons.edit_title": "கூப்பனை தொகுத்து எழுது",
    "Edit Coupon": "கூப்பனை தொகுத்து எழுது",
    "coupons.add_title": "கூப்பனை சேர்க்கவும்",
    "Add Coupon": "கூப்பனை சேர்க்கவும்",
    "coupons.reference_name": "மூல பெயர்",
    "Reference Name": "மூல பெயர்",
    "coupons.enter_name": "பெயரை உள்ளிடவும்",
    "coupons.coupon_type": "கூப்பன் வகை",
    "Coupon type": "கூப்பன் வகை",
    "coupons.discount_value": "குறைப்பு மதிப்பு",
    "Discount Value": "குறைப்பு மதிப்பு",
    "coupons.enter_discount_value": "குறைப்பு மதிப்பை உள்ளிடவும்",
    "Enter discount value": "குறைப்பு மதிப்பை உள்ளிடவும்",
    "coupons.code": "குறியீடு",
    "coupons.code_example": "எ.கா: HOLIDAY10",
    "Ex: HOLIDAY10": "எ.கா: HOLIDAY10",
    "coupons.short_code": "குறுகிய குறியீடு",
    "coupons.enter_short_code": "குறுகிய குறியீட்டை உள்ளிடவும்",
    "coupons.advanced": "மேம்பட்ட",
    "ADVANCED": "மேம்பட்ட",
    "coupons.minimum_amount": "குறைந்தபட்ச தொகை",
    "coupons.enter_minimum_amount": "குறைந்தபட்ச தொகையை உள்ளிடவும்",
    "coupons.maximum_amount": "அதிகபட்ச தொகை",
    "coupons.enter_maximum_amount": "அதிகபட்ச தொகையை உள்ளிடவும்",
    "coupons.maximum_discount_amount": "குறைப்பு அதிகபட்ச தொகை",
    "Maximum Discount Amount": "குறைப்பு அதிகபட்ச தொகை",
    "coupons.enter_maximum_discount_amount": "குறைப்பு அதிகபட்ச தொகையை உள்ளிடவும்",
    "Enter maximum discount amount": "குறைப்பு அதிகபட்ச தொகையை உள்ளிடவும்",
    "coupons.maximum_uses": "அதிகபட்ச பயன்பாடுகள்",
    "Maximum Uses": "அதிகபட்ச பயன்பாடுகள்",
    "coupons.enter_maximum_uses": "குறைந்தபட்ச பயன்பாடுகளை உள்ளிடவும்",
    "Enter maximum uses": "குறைந்தபட்ச பயன்பாடுகளை உள்ளிடவும்",
    "coupons.maximum_uses_per_user": "பயனருக்கு குறைந்தபட்ச பயன்பாடுகள்",
    "Maximum Uses Per User": "பயனருக்கு குறைந்தபட்ச பயன்பாடுகள்",
    "coupons.enter_maximum_uses_per_user": "பயனருக்கு குறைந்தபட்ச பயன்பாடுகளை உள்ளிடவும்",
    "Enter maximum uses per user": "பயனருக்கு குறைந்தபட்ச பயன்பாடுகளை உள்ளிடவும்",
    "coupons.new_user_only": "புதிய பயனர்",
    "New User": "புதிய பயனர்",
    "coupons.enter_note": "குறிப்பை உள்ளிடவும்",
    "coupons.start_date_time": "தொடக்க தேதி மற்றும் நேரம்",
    "Start Date Time": "தொடக்க தேதி மற்றும் நேரம்",
    "coupons.end_date_time": "முடிவு தேதி மற்றும் நேரம்",
    "End Date Time": "முடிவு தேதி மற்றும் நேரம்",
    "coupons.select_start_date_time": "தொடக்க தேதி மற்றும் நேரத்தைத் தேர்வு செய்யவும்",
    "Select start date time": "தொடக்க தேதி மற்றும் நேரத்தைத் தேர்வு செய்யவும்",
    "coupons.select_end_date_time": "முடிவு தேதி மற்றும் நேரத்தைத் தேர்வு செய்யவும்",
    "Select end date time": "முடிவு தேதி மற்றும் நேரத்தைத் தேர்வு செய்யவும்",
    "coupons.flat_example": "தளம் (எ.கா: $10)",
    "Flat (Ex: $10)": "தளம் (எ.கா: $10)",
    "coupons.percentage_example": "சதவீதம் (எ.கா: 10%)",
    "Percentage (Ex: 10%)": "சதவீதம் (எ.கா: 10%)",
    "coupons.delete_confirm": "இந்த கூப்பனை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this coupon?": "இந்த கூப்பனை நீக்க விரும்புகிறீர்களா?",
    "coupons.title": "கூப்பன்கள்",
    "coupons.header_name": "பெயர்",
    "coupons.header_code": "குறியீடு",
    "coupons.header_coupon_type": "கூப்பன் வகை",
    "Coupon Type": "கூப்பன் வகை",
    "coupons.header_start_date_time": "தொடக்க தேதி மற்றும் நேரம்",
    "coupons.header_end_date_time": "முடிவு தேதி மற்றும் நேரம்",
    "coupons.header_active": "செயல்பாட்டில்",
    "coupons.header_action": "செயல்முறை",
    "coupons.load_error": "இந்த கூப்பனை ஏற்ற முடியவில்லை.",
    "Unable to load this coupon.": "இந்த கூப்பனை ஏற்ற முடியவில்லை.",
    "coupons.expired": "முடிவடைந்தது",
    "Expired": "முடிவடைந்தது",
    "coupons.total_orders": "மொத்த ஆர்டர்கள்",
    "coupons.unique_customers": "ஒற்றை வாடிக்கையாளர்கள்",
    "Unique Customers": "ஒற்றை வாடிக்கையாளர்கள்",
    "coupons.revenue": "வருவாய்",
    "coupons.average_transaction": "கூட்டு பரிமாற்றம்",
    "Avg Transaction": "கூட்டு பரிமாற்றம்",
    "coupons.paid_orders": "செலுத்தப்பட்ட ஆர்டர்கள்",
    "coupons.uses_remaining": "மீதமுள்ள பயன்பாடுகள்",
    "Uses Remaining": "மீதமுள்ள பயன்பாடுகள்",
    "coupons.unlimited": "எல்லையற்றது",
    "Unlimited": "எல்லையற்றது",
    "coupons.performance": "செயல்திறன்",
    "Performance": "செயல்திறன்",
    "coupons.usage_against_limit": "வரம்புக்கு எதிராக பயன்பாடு",
    "Usage against limit": "வரம்புக்கு எதிராக பயன்பாடு",
    "coupons.details": "விவரங்கள்",
    "coupons.discount": "குறைப்பு",
    "coupons.minimum_order": "குறைந்தபட்ச ஆர்டர்",
    "Min order": "குறைந்தபட்ச ஆர்டர்",
    "coupons.maximum_discount": "கூடுதல் குறைப்பு",
    "Max discount": "கூடுதல் குறைப்பு",
    "coupons.maximum_total_uses": "மொத்த பயன்பாடுகளின் அதிகபட்சம்",
    "Max total uses": "மொத்த பயன்பாடுகளின் அதிகபட்சம்",
    "coupons.maximum_per_user": "அதிகபட்சம் / பயனர்",
    "Max / user": "அதிகபட்சம் / பயனர்",
    "coupons.new_users_only": "புதிய பயனர்களுக்கே",
    "New users only": "புதிய பயனர்களுக்கே",
    "coupons.valid_from": "ஆரம்பம் முதல் செல்லுபடியாகும்",
    "Valid from": "ஆரம்பம் முதல் செல்லுபடியாகும்",
    "coupons.valid_until": "முடிவு வரை செல்லுபடியாகும்",
    "Valid until": "முடிவு வரை செல்லுபடியாகும்",
    "coupons.orders": "ஆர்டர்கள்",
    "coupons.no_orders": "இந்த கூப்பனை எந்த ஆர்டரும் பயன்படுத்தவில்லை",
    "No orders have used this coupon yet": "இந்த கூப்பனை எந்த ஆர்டரும் பயன்படுத்தவில்லை",
    "coupons.orders_header_order": "ஆர்டர்",
    "coupons.orders_header_customer": "வாடிக்கையாளர்",
    "coupons.orders_header_date": "தேதி",
    "coupons.orders_header_amount": "தொகை",
    "coupons.orders_header_status": "நிலை",
    "coupons.paid": "செலுத்தப்பட்டது",
    "coupons.pending": "நிலுவையில்",
    "coupons.coupon": "கூப்பன்",
    "coupons.detail_title": "கூப்பன் விவரங்கள்",
    "Coupon Detail": "கூப்பன் விவரங்கள்",
    "coupons.discount_percentage": "{value}% தள்ளுபோக்கு",
    "{value}% off": "{value}% தள்ளுபோக்கு",
    "coupons.discount_flat": "{value} நிலையான தள்ளுபோக்கு",
    "{value} flat off": "{value} நிலையான தள்ளுபோக்கு",
    "coupons.type_direct_discount": "நேரடி தள்ளுபோக்கு",
    "Direct discount": "நேரடி தள்ளுபோக்கு",
    "collections.condition_and": "மற்றும்",
    "AND": "மற்றும்",
    "collections.condition_or": "அல்லது",
    "OR": "அல்லது",
    "users.first_seen": "முதல் முறை பார்த்தது",
    "First seen": "முதல் முறை பார்த்தது",
    "users.last_seen": "கடைசி முறை பார்த்தது",
    "Last seen": "கடைசி முறை பார்த்தது",
    "users.avg_order": "சராசரி ஆர்டர்",
    "Avg order": "சராசரி ஆர்டர்",
    "users.purchase_value": "வாங்கும் மதிப்பு",
    "Purchase value": "வாங்கும் மதிப்பு",
    "users.price_range": "விலை வரம்பு",
    "Price range": "விலை வரம்பு",
    "users.attributes": "பண்புகள்",
    "users.detail_title": "பயனர் விவரங்கள்",
    "User Detail": "பயனர் விவரங்கள்",
    "users.detail_orders_list": "பயனர் ஆர்டர் பட்டியல்",
    "User Orders List": "பயனர் ஆர்டர் பட்டியல்",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "வாங்குபவராக",
    "As a Buyer": "வாங்குபவராக",
    "users.as_seller": "விற்பனையாளராக",
    "As a Seller": "விற்பனையாளராக",
    "users.health": "ஆரோக்கியம்",
    "users.no_listings": "இன்னும் பட்டியலிடப்படவில்லை",
    "users.no_accounts": "இன்னும் கணக்குகள் இல்லை",
    "No accounts yet": "இன்னும் கணக்குகள் இல்லை",
    "users.top_categories": "முக்கிய பிரிவுகள்",
    "Top categories": "முக்கிய பிரிவுகள்",
    "users.top_listings": "முக்கிய பட்டியல்கள்",
    "Top listings": "முக்கிய பட்டியல்கள்",
    "users.recent_activity": "இறுதியாக செய்த செயல்பாடுகள்",
    "Recent activity": "இறுதியாக செய்த செயல்பாடுகள்",
    "users.acquisition": "பெறுதல்",
    "Acquisition": "பெறுதல்",
    "users.sent_emails": "அனுப்பிய மின்னஞ்சல்கள்",
    "Sent Emails": "அனுப்பிய மின்னஞ்சல்கள்",
    "users.no_emails_sent": "மின்னஞ்சல் அனுப்பப்படவில்லை",
    "No emails sent": "மின்னஞ்சல் அனுப்பப்படவில்லை",
    "users.load_more_emails": "மேலும் ஏற்றுகிறீர்கள் ({loaded} / {total})",
    "Load More ({loaded} / {total})": "மேலும் ஏற்றுகிறீர்கள் ({loaded} / {total})",
    "users.email_to": "அனுப்புதல்: {email}",
    "To: {email}": "அனுப்புதல்: {email}",
    "users.sending_email": "அனுப்பும் போது…",
    "users.send_email": "மின்னஞ்சல் அனுப்பு",
    "Send Email": "மின்னஞ்சல் அனுப்பு",
    "users.send_email_title": "மின்னஞ்சல் அனுப்பு — {name}",
    "Send Email — {name}": "மின்னஞ்சல் அனுப்பு — {name}",
    "users.customer": "வாடிக்கையாளர்",
    "users.block_named": "முடக்கு {name}",
    "Block {name}": "முடக்கு {name}",
    "users.unblock_named": "முடக்கம் தெரிவிக்கவும் {name}",
    "Unblock {name}": "முடக்கம் தெரிவிக்கவும் {name}",
    "users.email_sent": "மின்னஞ்சல் வெற்றிகரமாக அனுப்பப்பட்டது",
    "Email sent successfully": "மின்னஞ்சல் வெற்றிகரமாக அனுப்பப்பட்டது",
    "users.email_send_failed": "மின்னஞ்சல் அனுப்ப முடியவில்லை",
    "Failed to send email": "மின்னஞ்சல் அனுப்ப முடியவில்லை",
    "common.value": "மதிப்பு",
    "users.email_bounced": "மீண்டும் அனுப்பப்பட்டது",
    "Bounced": "மீண்டும் அனுப்பப்பட்டது",
    "users.email_complained": "புகார்",
    "Complained": "புகார்",
    "users.unverified": "உறுதிப்படுத்தப்படாத",
    "Unverified": "உறுதிப்படுத்தப்படாத",
    "users.otp_enabled": "OTP செயல்படுத்தப்பட்டுள்ளது",
    "OTP Enabled": "OTP செயல்படுத்தப்பட்டுள்ளது",
    "users.account_info": "கணக்கு தகவல்கள்",
    "Account Info": "கணக்கு தகவல்கள்",
    "users.mobile": "மொபைல்",
    "users.locale": "மொழி",
    "Locale": "மொழி",
    "users.joined": "சேர்ந்தது",
    "users.following": "தொடர்ந்து பார்க்கிறேன்",
    "Following": "தொடர்ந்து பார்க்கிறேன்",
    "users.email_health": "மேலாண்மை மின்னஞ்சல்",
    "Email Health": "மேலாண்மை மின்னஞ்சல்",
    "users.orders": "ஆர்டர்கள்",
    "users.no_orders": "ஆர்டர்கள் இல்லை",
    "No orders": "ஆர்டர்கள் இல்லை",
    "users.order_reference": "ஆர்டர் {number}",
    "Order {number}": "ஆர்டர் {number}",
    "users.order_ref": "மேற்கோள்: {reference}",
    "Ref: {reference}": "மேற்கோள்: {reference}",
    "users.unpaid": "செலுத்தப்படாத",
    "users.revenue_ltv": "வருமானம் & LTV",
    "Revenue & LTV": "வருமானம் & LTV",
    "users.total_spent": "மொத்தம் செலவிடப்பட்டது",
    "Total Spent": "மொத்தம் செலவிடப்பட்டது",
    "users.paid_order_count": "{count} செலுத்தப்பட்ட ஆர்டர்கள்",
    "{count} paid orders": "{count} செலுத்தப்பட்ட ஆர்டர்கள்",
    "users.average_order": "ஆர்டர் சராசரி",
    "users.of_total_orders": "{count} மொத்தத்தில்",
    "of {count} total": "{count} மொத்தத்தில்",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} செயல்பாட்டில்",
    "{count} active": "{count} செயல்பாட்டில்",
    "users.at_risk": "ஆபத்தில்",
    "At Risk": "ஆபத்தில்",
    "common.today": "இன்று",
    "common.yesterday": "நேற்று",
    "Yesterday": "நேற்று",
    "users.days_ago": "{count} நாட்களுக்கு முன்பு",
    "{count} days ago": "{count} நாட்களுக்கு முன்பு",
    "users.months_ago": "{count} மாதங்களுக்கு முன்பு",
    "{count} months ago": "{count} மாதங்களுக்கு முன்பு",
    "users.years_ago": "{count} ஆண்டுகளுக்கு முன்பு",
    "{count} years ago": "{count} ஆண்டுகளுக்கு முன்பு",
    "users.last_order": "கடைசி ஆர்டர்",
    "Last order": "கடைசி ஆர்டர்",
    "users.last_listing": "கடைசி பட்டியல்",
    "Last listing": "கடைசி பட்டியல்",
    "users.events": "நிகழ்வுகள்",
    "users.viewed": "பார்த்தது",
    "Viewed": "பார்த்தது",
    "users.cart": "கார்ட்",
    "users.checkouts": "மூலம்",
    "Checkouts": "மூலம்",
    "users.purchases": "மூலம்",
    "Purchases": "மூலம்",
    "users.last_30_days": "கடைசி 30 நாட்கள்",
    "users.no_analytics": "இந்த பயனருக்கு பகுப்பாய்வு தரவுகள் இல்லை.",
    "No analytics data for this user yet.": "இந்த பயனருக்கு பகுப்பாய்வு தரவுகள் இல்லை.",
    "users.analytics_unavailable": "இந்த குடியிருப்பாளருக்கு பகுப்பாய்வு கிடைக்கவில்லை.",
    "Analytics unavailable for this tenant.": "இந்த குடியிருப்பாளருக்கு பகுப்பாய்வு கிடைக்கவில்லை.",
    "users.account_number": "கணக்கு #{number}",
    "Account #{number}": "கணக்கு #{number}",
    "users.no_subject": "விஷயம் இல்லை",
    "No Subject": "விஷயம் இல்லை",
    "common.unknown": "அறியப்படாத",
    "users.opened": "திறந்த",
    "Opened": "திறந்த",
    "users.not_opened": "திறக்கப்படவில்லை",
    "Not opened": "திறக்கப்படவில்லை",
    "users.user_action_success": "பயனர் செயல்பாடு முடிக்கப்பட்டது",
    "User action completed": "பயனர் செயல்பாடு முடிக்கப்பட்டது",
    "common.pending": "தொடர்புடைய",
    "common.never": "எப்போதும் இல்லை",
    "users.customer_analytics": "வாடிக்கையாளர் பகுப்பாய்வு",
    "Customer Analytics": "வாடிக்கையாளர் பகுப்பாய்வு",
    "users.analytics": "பகுப்பாய்வு",
    "users.emails": "மின்னஞ்சல்கள்",
    "Emails": "மின்னஞ்சல்கள்",
    "users.first_visit": "முதல் பார்வை",
    "First visit": "முதல் பார்வை",
    "users.latest_visit": "கடைசி பார்வை",
    "Latest visit": "கடைசி பார்வை",
    "users.landing_page": "விழும் பக்கம்",
    "Landing page": "விழும் பக்கம்",
    "users.referrer": "மூலம்",
    "Referrer": "மூலம்",
    "users.utm_source": "UTM மூலம்",
    "UTM source": "UTM மூலம்",
    "users.utm_medium": "UTM ஊடகம்",
    "UTM medium": "UTM ஊடகம்",
    "users.utm_campaign": "UTM கூட்டுறவு",
    "UTM campaign": "UTM கூட்டுறவு",
    "users.utm_term": "UTM வார்த்தை",
    "UTM term": "UTM வார்த்தை",
    "users.utm_content": "UTM உள்ளடக்கம்",
    "UTM content": "UTM உள்ளடக்கம்",
    "users.ai_source": "AI மூலம்",
    "AI source": "AI மூலம்",
    "rewards.edit_scope": "விருப்பத்தை தொகுத்து எழுது",
    "Edit scope": "விருப்பத்தை தொகுத்து எழுது",
    "rewards.add_scope": "விருப்பத்தை சேர்க்கவும்",
    "Add scope": "விருப்பத்தை சேர்க்கவும்",
    "rewards.save_scope": "விருப்பத்தை சேமி",
    "Save scope": "விருப்பத்தை சேமி",
    "rewards.scope_type": "விருப்பத்தின் வகை",
    "Scope type": "விருப்பத்தின் வகை",
    "rewards.scope_reference": "விருப்பத்தின் மூலம்",
    "Scope reference": "விருப்பத்தின் மூலம்",
    "rewards.match_config": "பொருத்தமான அமைப்பு",
    "Match config": "பொருத்தமான அமைப்பு",
    "rewards.priority_order": "முன்னுரிமை வரிசை",
    "Priority order": "முன்னுரிமை வரிசை",
    "rewards.active": "செயல்பாட்டில்",
    "rewards.scope_active": "விருப்பம் செயல்பாட்டில் உள்ளது",
    "Scope is active": "விருப்பம் செயல்பாட்டில் உள்ளது",
    "rewards.edit_rule": "விதிமுறையை தொகுத்து எழுது",
    "Edit rule": "விதிமுறையை தொகுத்து எழுது",
    "rewards.add_rule": "விதிமுறையை சேர்க்கவும்",
    "Add rule": "விதிமுறையை சேர்க்கவும்",
    "rewards.save_rule": "விதிமுறையை சேமி",
    "Save rule": "விதிமுறையை சேமி",
    "rewards.trigger_event": "தூண்டுதல் நிகழ்வு",
    "Trigger event": "தூண்டுதல் நிகழ்வு",
    "rewards.beneficiary_type": "பெறுநர் வகை",
    "Beneficiary type": "பெறுநர் வகை",
    "rewards.beneficiary_config": "பெறுநர் அமைப்பு",
    "Beneficiary config": "பெறுநர் அமைப்பு",
    "rewards.eligibility": "தகுதி",
    "Eligibility": "தகுதி",
    "rewards.conditions": "நிபந்தனைகள்",
    "rewards.priority": "முன்னுரிமை",
    "Priority": "முன்னுரிமை",
    "rewards.edit_component": "விருப்பத்தின் கூறுகளை தொகுத்து எழுது",
    "Edit recipe component": "விருப்பத்தின் கூறுகளை தொகுத்து எழுது",
    "rewards.add_component": "விருப்பத்தின் கூறுகளை சேர்க்கவும்",
    "Add recipe component": "விருப்பத்தின் கூறுகளை சேர்க்கவும்",
    "rewards.save_component": "கூறை சேமி",
    "Save component": "கூறை சேமி",
    "rewards.rule": "விதிமுறை",
    "Rule": "விதிமுறை",
    "rewards.component_key": "கூறு குறியீடு",
    "Component key": "கூறு குறியீடு",
    "rewards.component_type": "கூறு வகை",
    "Component type": "கூறு வகை",
    "rewards.commission_definition": "கமிஷன் வரையறை",
    "Commission definition": "கமிஷன் வரையறை",
    "rewards.config": "கான்ஃபிக்",
    "rewards.position": "இடம்",
    "Position": "இடம்",
    "rewards.component": "கூறு",
    "Component": "கூறு",
    "rewards.status.draft": "முன்னோட்டம்",
    "rewards.status.active": "செயல்பாட்டில்",
    "rewards.status.paused": "நிறுத்தப்பட்டுள்ளது",
    "Paused": "நிறுத்தப்பட்டுள்ளது",
    "rewards.status.archived": "காப்பகம்",
    "rewards.configuration_updated": "விருது அமைப்பு புதுப்பிக்கப்பட்டது",
    "Reward configuration updated": "விருது அமைப்பு புதுப்பிக்கப்பட்டது",
    "rewards.configuration_added": "விருது அமைப்பு சேர்க்கப்பட்டது",
    "Reward configuration added": "விருது அமைப்பு சேர்க்கப்பட்டது",
    "rewards.archive_item_confirm": "{name} ஐ காப்பகத்தில் வைக்கவா?",
    "rewards.empty_scopes": "மேலும் அமைப்புகள் இல்லை.",
    "No scopes configured yet.": "மேலும் அமைப்புகள் இல்லை.",
    "rewards.empty_rules": "விதிகள் இன்னும் அமைக்கப்படவில்லை.",
    "No rules configured yet.": "விதிகள் இன்னும் அமைக்கப்படவில்லை.",
    "rewards.empty_components": "கூறுகள் இன்னும் அமைக்கப்படவில்லை.",
    "No components configured yet.": "கூறுகள் இன்னும் அமைக்கப்படவில்லை.",
    "rewards.edit_program": "விருது திட்டத்தை தொகுத்துக்கொள்ளவும்",
    "Edit reward program": "விருது திட்டத்தை தொகுத்துக்கொள்ளவும்",
    "rewards.new_program": "புதிய விருது திட்டம்",
    "New reward program": "புதிய விருது திட்டம்",
    "rewards.create_program": "திட்டத்தை உருவாக்கு",
    "Create program": "திட்டத்தை உருவாக்கு",
    "rewards.program_type": "திட்ட வகை",
    "Program type": "திட்ட வகை",
    "rewards.starts_at": "தொடங்குகிறது",
    "Starts at": "தொடங்குகிறது",
    "rewards.ends_at": "முடிவடைகிறது",
    "Ends at": "முடிவடைகிறது",
    "rewards.program_updated": "விருது திட்டம் புதுப்பிக்கப்பட்டது",
    "Reward program updated": "விருது திட்டம் புதுப்பிக்கப்பட்டது",
    "rewards.program_created": "விருது திட்டம் உருவாக்கப்பட்டது",
    "Reward program created": "விருது திட்டம் உருவாக்கப்பட்டது",
    "rewards.archive_program_confirm": " {name} ஐ கோப்பு செய்யவா?",
    "rewards.program_archived": "விருது திட்டம் கோப்பு செய்யப்பட்டது",
    "Reward program archived": "விருது திட்டம் கோப்பு செய்யப்பட்டது",
    "rewards.tab.overview": "மேம்பாடு",
    "rewards.tab.programs": "திட்டங்கள்",
    "Programs": "திட்டங்கள்",
    "rewards.tab.impact": "தாக்கம்",
    "Impact": "தாக்கம்",
    "rewards.tab.attribution": "தொடர்பு",
    "Tracking": "தொடர்பு",
    "rewards.page_description": "விருது திட்டங்களை, தகுதி அமைப்புகளை, விருது விதிமுறைகளை மற்றும் விருது சமையல் முறைகளை உருவாக்கி மேலாண்மை செய்யவும். முடிந்த ஆர்டர்கள் உங்கள் அறிக்கைகளில் தானியங்கி சேர்க்கப்படும்.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "விருது திட்டங்களை, தகுதி அமைப்புகளை, விருது விதிமுறைகளை மற்றும் விருது சமையல் முறைகளை உருவாக்கி மேலாண்மை செய்யவும். முடிந்த ஆர்டர்கள் உங்கள் அறிக்கைகளில் தானியங்கி சேர்க்கப்படும்.",
    "rewards.program": "திட்டம்",
    "Program": "திட்டம்",
    "rewards.starts": "தொடங்குகிறது",
    "Starts": "தொடங்குகிறது",
    "rewards.no_programs": "விருது திட்டங்கள் இல்லை.",
    "No reward programs yet.": "விருது திட்டங்கள் இல்லை.",
    "rewards.program_title": "விருது திட்டம்",
    "Reward program": "விருது திட்டம்",
    "rewards.back_to_rewards": "விருதுகளுக்கு திரும்பு",
    "Back to rewards": "விருதுகளுக்கு திரும்பு",
    "common.archive": "கோப்பு செய்ய",
    "Archive": "கோப்பு செய்ய",
    "common.save_changes": "மாற்றங்களை சேமி",
    "common.none": "எதுவும் இல்லை",
    "common.this_item": "இந்த பொருள்",
    "this item": "இந்த பொருள்",
    "rewards.tab.scopes": "விரிவான பகுதிகள்",
    "Scopes": "விரிவான பகுதிகள்",
    "rewards.tab.rules": "விதிமுறைகள்",
    "rewards.tab.components": "விருது கூறுகள்",
    "Recipe components": "விருது கூறுகள்",
    "rewards.reference": "மூலம்",
    "rewards.trigger": "தூண்டுதல்",
    "Trigger": "தூண்டுதல்",
    "rewards.beneficiary": "பயனாளி",
    "Beneficiary": "பயனாளி",
    "rewards.attributed_conversions": "அதிகரித்த மாற்றங்கள்",
    "Attributed conversions": "அதிகரித்த மாற்றங்கள்",
    "rewards.new_customers": "புதிய வாடிக்கையாளர்கள்",
    "New customers": "புதிய வாடிக்கையாளர்கள்",
    "rewards.revenue_influenced": "உள்ளீடுகள் பாதிக்கப்பட்டது",
    "Revenue influenced": "உள்ளீடுகள் பாதிக்கப்பட்டது",
    "rewards.rewards_issued": "விருதுகள் வழங்கப்பட்டன",
    "Rewards issued": "விருதுகள் வழங்கப்பட்டன",
    "rewards.live_business_results": "ஆன்லைன் வணிக முடிவுகள்",
    "Live business results": "ஆன்லைன் வணிக முடிவுகள்",
    "rewards.impact_at_a_glance": "முதல் பார்வையில் தாக்கம்",
    "Impact at a glance": "முதல் பார்வையில் தாக்கம்",
    "rewards.impact_last_30_days": "கடந்த 30 நாட்களில் முடிந்த ஆர்டர்கள் மற்றும் கூட்டு முடிவுகளின் ஆன்லைன் காட்சி.",
    "A live view of completed orders and partner results from the last 30 days.": "கடந்த 30 நாட்களில் முடிந்த ஆர்டர்கள் மற்றும் கூட்டு முடிவுகளின் ஆன்லைன் காட்சி.",
    "rewards.view_full_impact": "முழுமையான தாக்கத்தைப் பார்க்கவும்",
    "View full impact": "முழுமையான தாக்கத்தைப் பார்க்கவும்",
    "rewards.impact_load_error": "தாக்க தரவுகள் ஏற்றப்படவில்லை: {error}",
    "Impact data could not be loaded: {error}": "தாக்க தரவுகள் ஏற்றப்படவில்லை: {error}",
    "rewards.programs": "திட்டங்கள்",
    "rewards.programs_configured": "இந்த வேலை இடத்திற்கு ஏற்றவாறு அமைக்கப்பட்ட விருது திட்டங்கள்.",
    "Reward programs configured for this workspace.": "இந்த வேலை இடத்திற்கு ஏற்றவாறு அமைக்கப்பட்ட விருது திட்டங்கள்.",
    "rewards.programs_eligible": "மதிப்பீட்டிற்கு தற்போது தகுதியான திட்டங்கள்.",
    "Programs currently eligible for evaluation.": "மதிப்பீட்டிற்கு தற்போது தகுதியான திட்டங்கள்.",
    "rewards.drafts": "முன்னோட்டங்கள்",
    "Drafts": "முன்னோட்டங்கள்",
    "rewards.programs_being_configured": "அமைப்பு செய்யப்படும் திட்டங்கள்",
    "Programs still being configured.": "அமைப்பு செய்யப்படும் திட்டங்கள்",
    "rewards.clicks": "கிளிக்குகள்",
    "rewards.completed_orders": "முடிந்த ஆர்டர்கள்",
    "Completed orders": "முடிந்த ஆர்டர்கள்",
    "rewards.conversion_rate": "மாற்று விகிதம்",
    "Conversion rate": "மாற்று விகிதம்",
    "rewards.revenue": "வருமானம்",
    "rewards.live_connection": "ஆன்லைன் இணைப்பு",
    "Live connection": "ஆன்லைன் இணைப்பு",
    "rewards.attribution_activity": "பெயரிடும் செயல்பாடு",
    "Attribution activity": "பெயரிடும் செயல்பாடு",
    "rewards.connected_workspace": "{name} உடன் இணைக்கப்பட்டுள்ளது.",
    "Connected to {name}.": "{name} உடன் இணைக்கப்பட்டுள்ளது.",
    "rewards.your_attribution_workspace": "உங்கள் பெயரிடும் வேலை இடம்",
    "your Attribution workspace": "உங்கள் பெயரிடும் வேலை இடம்",
    "rewards.loading_workspace": "இணைக்கப்பட்ட பெயரிடும் வேலை இடத்தை ஏற்றுகிறோம்.",
    "Loading your connected Attribution workspace.": "இணைக்கப்பட்ட பெயரிடும் வேலை இடத்தை ஏற்றுகிறோம்.",
    "rewards.open_attribution": "பெயரிடும் வேலை இடத்தைத் திறக்கவும்",
    "Open Attribution": "பெயரிடும் வேலை இடத்தைத் திறக்கவும்",
    "rewards.connection_attention": "இணைப்பு கவனம் தேவை",
    "Connection needs attention": "இணைப்பு கவனம் தேவை",
    "rewards.open_attribution_workspace": "பெயரிடும் வேலை இடத்தைத் திறக்கவும்",
    "Open Attribution workspace": "பெயரிடும் வேலை இடத்தைத் திறக்கவும்",
    "rewards.workspace_connected": "வேலைப்பகுதி இணைக்கப்பட்டுள்ளது",
    "Workspace connected": "வேலைப்பகுதி இணைக்கப்பட்டுள்ளது",
    "rewards.workspace_not_linked": "வேலைப்பகுதி இன்னும் இணைக்கப்படவில்லை",
    "Workspace not linked yet": "வேலைப்பகுதி இன்னும் இணைக்கப்படவில்லை",
    "rewards.attribution_data_connected": "ஆதாரம் மூலம் வாழ்க்கை கிளிக்குகள், இணைப்புகள், கேம்பேய்ன்கள் மற்றும் முடிந்த ஆர்டர்கள் படிக்கப்படுகின்றன.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "ஆதாரம் மூலம் வாழ்க்கை கிளிக்குகள், இணைப்புகள், கேம்பேய்ன்கள் மற்றும் முடிந்த ஆர்டர்கள் படிக்கப்படுகின்றன.",
    "rewards.connect_workspace_prompt": "செயல்பாட்டை பதிவு செய்யும் முன், இந்த வேலைப்பகுதியை இணைக்க ஆதாரம் திறக்கவும்.",
    "Open Attribution to connect this workspace before tracking activity.": "செயல்பாட்டை பதிவு செய்யும் முன், இந்த வேலைப்பகுதியை இணைக்க ஆதாரம் திறக்கவும்.",
    "rewards.successful_referrals": "வெற்றிகரமான அறிவிப்புகள்",
    "Successful referrals": "வெற்றிகரமான அறிவிப்புகள்",
    "rewards.new_customers_acquired": "புதிய வாடிக்கையாளர்கள் பெறப்பட்டனர்",
    "New customers acquired": "புதிய வாடிக்கையாளர்கள் பெறப்பட்டனர்",
    "rewards.gross_revenue_influenced": "உள்ளீட்டு வருமானம் பாதிக்கப்பட்டது",
    "Gross revenue influenced": "உள்ளீட்டு வருமானம் பாதிக்கப்பட்டது",
    "rewards.reward_cost": "விருது செலவு",
    "Reward cost": "விருது செலவு",
    "rewards.net_revenue": "குறைந்த வருமானம்",
    "Net revenue": "குறைந்த வருமானம்",
    "rewards.average_order_value": "ஆர்டர் சராசரி மதிப்பு",
    "Average order value": "ஆர்டர் சராசரி மதிப்பு",
    "rewards.cost_per_acquisition": "பெறும் செலவு",
    "Cost per acquisition": "பெறும் செலவு",
    "rewards.repeat_purchase_rate": "மீண்டும் வாங்கும் விகிதம்",
    "Repeat purchase rate": "மீண்டும் வாங்கும் விகிதம்",
    "rewards.business_outcome_reporting": "வணிக முடிவுகள் அறிக்கை",
    "Business outcome reporting": "வணிக முடிவுகள் அறிக்கை",
    "rewards.impact": "தாக்கம்",
    "rewards.impact_description": "தேர்ந்தெடுக்கப்பட்ட காலக்கெடுவில் மாற்றுகள், வாடிக்கையாளர் பெறுதல், பாதிக்கப்பட்ட வருமானம் மற்றும் விருது செலவு.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "தேர்ந்தெடுக்கப்பட்ட காலக்கெடுவில் மாற்றுகள், வாடிக்கையாளர் பெறுதல், பாதிக்கப்பட்ட வருமானம் மற்றும் விருது செலவு.",
    "rewards.from": "முதல்",
    "rewards.to": "வரை",
    "rewards.trend": "போக்கு",
    "Trend": "போக்கு",
    "rewards.daily": "தினசரி",
    "rewards.weekly": "வாராந்திர",
    "rewards.top_partners": "முதன்மை கூட்டாளிகள் / அறிவிப்பாளர்கள்",
    "Top partners / referrers": "முதன்மை கூட்டாளிகள் / அறிவிப்பாளர்கள்",
    "rewards.partner": "கூட்டாளி",
    "Partner": "கூட்டாளி",
    "rewards.conversions": "மாற்றுகள்",
    "Conversions": "மாற்றுகள்",
    "rewards.no_partner_data": "இந்த காலக்கெடுவிற்கு ஆதாரம் கொடுக்கப்பட்ட கூட்டாளி தகவல் இல்லை.",
    "No attributed partner data for this period.": "இந்த காலக்கெடுவிற்கு ஆதாரம் கொடுக்கப்பட்ட கூட்டாளி தகவல் இல்லை.",
    "rewards.period": "காலம்",
    "rewards.no_trend_data": "இந்த கால கட்டத்திற்கான தொடர்ச்சி தரவுகள் இல்லை.",
    "No trend data for this period.": "இந்த கால கட்டத்திற்கான தொடர்ச்சி தரவுகள் இல்லை.",
    "rewards.campaign_performance": "கேம்பைன் செயல்திறன்",
    "Campaign performance": "கேம்பைன் செயல்திறன்",
    "rewards.campaign_count": "{count} கேம்பைன்கள்",
    "{count} campaigns": "{count} கேம்பைன்கள்",
    "rewards.campaign": "கேம்பைன்",
    "rewards.orders": "ஆர்டர்கள்",
    "rewards.rate": "விகிதம்",
    "Rate": "விகிதம்",
    "rewards.no_campaign_activity": "இதுவரை கேம்பைன் செயல்பாடு இல்லை. முடிவுகளை அளவிட தகவல் பதிவேற்றம் செய்ய ஒரு தொடர்பு இணையதளத்தை உருவாக்கவும்.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "இதுவரை கேம்பைன் செயல்பாடு இல்லை. முடிவுகளை அளவிட தகவல் பதிவேற்றம் செய்ய ஒரு தொடர்பு இணையதளத்தை உருவாக்கவும்.",
    "rewards.recent_completed_orders": "சமீபத்திய முடிந்த ஆர்டர்கள்",
    "Recent completed orders": "சமீபத்திய முடிந்த ஆர்டர்கள்",
    "rewards.recent_events_count": "{count} சமீபத்திய நிகழ்வுகள்",
    "{count} recent events": "{count} சமீபத்திய நிகழ்வுகள்",
    "rewards.event": "நிகழ்வு",
    "rewards.completed_order": "முடிந்த ஆர்டர்",
    "Completed order": "முடிந்த ஆர்டர்",
    "rewards.no_completed_order_activity": "முடிந்த ஆர்டர் செயல்பாடு இதுவரை வந்திருக்கவில்லை.",
    "No completed order activity has arrived yet.": "முடிந்த ஆர்டர் செயல்பாடு இதுவரை வந்திருக்கவில்லை.",
    "rewards.impact_data_quality_note": "அடிப்படை கிளிக் கூட்டு இணைக்கப்படும் வரை கிளிக் கூட்டு மற்றும் மாற்று விகிதம் இங்கு கிடைக்காது. விருது செலவு அனுமதிக்கப்பட்ட அல்லது வெளியிடப்பட்ட விருது பட்டியல் வரிகளைப் பயன்படுத்துகிறது; திருப்பித் தரம் இன்னும் சேர்க்கப்படவில்லை.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "அடிப்படை கிளிக் கூட்டு இணைக்கப்படும் வரை கிளிக் கூட்டு மற்றும் மாற்று விகிதம் இங்கு கிடைக்காது. விருது செலவு அனுமதிக்கப்பட்ட அல்லது வெளியிடப்பட்ட விருது பட்டியல் வரிகளைப் பயன்படுத்துகிறது; திருப்பித் தரம் இன்னும் சேர்க்கப்படவில்லை.",
    "subscriptions.type.free": "இலவச சந்தா",
    "Free Subscription": "இலவச சந்தா",
    "subscriptions.form.title_placeholder": "சந்தா தலைப்பு",
    "Subscription Title": "சந்தா தலைப்பு",
    "subscriptions.form.title_help": "சந்தா பேக்கேஜிற்கு விவரண தலைப்பை உள்ளிடவும் (எ.கா., “பிரீமியம் திட்டம்”, “அடிப்படை அளவு”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "சந்தா பேக்கேஜிற்கு விவரண தலைப்பை உள்ளிடவும் (எ.கா., “பிரீமியம் திட்டம்”, “அடிப்படை அளவு”).",
    "subscriptions.form.description_placeholder": "சந்தா விவரணம்",
    "Subscription Description": "சந்தா விவரணம்",
    "subscriptions.form.description_help": "சந்தாவின் அம்சங்கள் மற்றும் நன்மைகளை விவரிக்கும் விரிவான விவரணத்தை வழங்கவும்.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "சந்தாவின் அம்சங்கள் மற்றும் நன்மைகளை விவரிக்கும் விரிவான விவரணத்தை வழங்கவும்.",
    "subscriptions.form.select_currency": "முதலீட்டு முறையைத் தேர்வு செய்யவும்",
    "Select Currency": "முதலீட்டு முறையைத் தேர்வு செய்யவும்",
    "subscriptions.form.currency_help": "முதலீட்டு முறையை மெனுவிலிருந்து தேர்வு செய்யவும் (உங்கள் தேர்வு முதலீட்டு முறை)",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "முதலீட்டு முறையை மெனுவிலிருந்து தேர்வு செய்யவும் (உங்கள் தேர்வு முதலீட்டு முறை)",
    "subscriptions.form.amount_placeholder": "சந்தா தொகை",
    "Subscription Amount": "சந்தா தொகை",
    "subscriptions.form.amount_help": "சந்தா விலையை உள்ளிடவும்.",
    "Enter the subscription price.": "சந்தா விலையை உள்ளிடவும்.",
    "subscriptions.form.sku_placeholder": "சந்தா SKU",
    "Subscription SKU": "சந்தா SKU",
    "subscriptions.form.sku_help": "சப்ஸ்கிரிப்ஷனுக்கான தனித்துவ ஐடியை உள்ளிடவும் (பொதுவாக தரவு எளிமைப்படுத்த, தனித்துவம் மற்றும் தொடர்புக்கு பயன்படுத்தப்படுகிறது).",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "சப்ஸ்கிரிப்ஷனுக்கான தனித்துவ ஐடியை உள்ளிடவும் (பொதுவாக தரவு எளிமைப்படுத்த, தனித்துவம் மற்றும் தொடர்புக்கு பயன்படுத்தப்படுகிறது).",
    "subscriptions.form.allowed_listings": "அனுமதிக்கப்பட்ட பட்டியல்கள்",
    "Allowed Listings": "அனுமதிக்கப்பட்ட பட்டியல்கள்",
    "subscriptions.form.allowed_listings_placeholder": "சப்ஸ்கிரிப்ஷனுக்கான அனுமதிக்கப்பட்ட பட்டியல்கள்",
    "Subscription Allowed Listings": "சப்ஸ்கிரிப்ஷனுக்கான அனுமதிக்கப்பட்ட பட்டியல்கள்",
    "subscriptions.form.allowed_listings_help": "இந்த சப்ஸ்கிரிப்ஷனுக்கான அனுமதிக்கப்பட்ட பட்டியல்களின் எண்ணிக்கையை குறிப்பிடவும்.",
    "Specify the number of listings allowed for this subscription.": "இந்த சப்ஸ்கிரிப்ஷனுக்கான அனுமதிக்கப்பட்ட பட்டியல்களின் எண்ணிக்கையை குறிப்பிடவும்.",
    "subscriptions.form.fixed_fee_per_order": "ஆர்டருக்கு நிலையான கட்டணம்",
    "Fixed Fee Per Order": "ஆர்டருக்கு நிலையான கட்டணம்",
    "subscriptions.form.fixed_fee_placeholder": "ஆர்டருக்கு நிலையான கட்டணம்",
    "Subscription Fee Fixed Per Order": "ஆர்டருக்கு நிலையான கட்டணம்",
    "subscriptions.form.fixed_fee_help": "ஆர்டருக்கு நிலையான கட்டணத்தை உள்ளிடவும், தேவைப்பட்டால்.",
    "Enter a fixed fee per order, if applicable.": "ஆர்டருக்கு நிலையான கட்டணத்தை உள்ளிடவும், தேவைப்பட்டால்.",
    "subscriptions.form.commission_percent_per_order": "ஆர்டருக்கு கமிஷன் %",
    "Commission % Per Order": "ஆர்டருக்கு கமிஷன் %",
    "subscriptions.form.commission_placeholder": "ஆர்டருக்கு சப்ஸ்கிரிப்ஷன் கமிஷன்",
    "Subscription Commission Percent Per Order": "ஆர்டருக்கு சப்ஸ்கிரிப்ஷன் கமிஷன்",
    "subscriptions.form.commission_help": "ஆர்டருக்கு கமிஷன் சதவீதத்தை உள்ளிடவும், தேவைப்பட்டால்.",
    "Enter the commission percentage per order, if applicable.": "ஆர்டருக்கு கமிஷன் சதவீதத்தை உள்ளிடவும், தேவைப்பட்டால்.",
    "subscriptions.form.expiry_days": "முடிவு நாட்கள்",
    "Expiry Days": "முடிவு நாட்கள்",
    "subscriptions.form.expiry_days_placeholder": "சப்ஸ்கிரிப்ஷனுக்கான முடிவு நாட்கள்",
    "Subscription Expiry Days": "சப்ஸ்கிரிப்ஷனுக்கான முடிவு நாட்கள்",
    "subscriptions.form.expiry_days_help": "சப்ஸ்கிரிப்ஷன் (திட்டம், பேக்கேஜ்) முடிவடையும் முன் நாட்களின் எண்ணிக்கையை அமைக்கவும். எ.கா: 7 நாட்கள், 30 நாட்கள்.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "சப்ஸ்கிரிப்ஷன் (திட்டம், பேக்கேஜ்) முடிவடையும் முன் நாட்களின் எண்ணிக்கையை அமைக்கவும். எ.கா: 7 நாட்கள், 30 நாட்கள்.",
    "subscriptions.form.payment_method": "பேமென்ட் முறை",
    "subscriptions.form.select_type": "வகையைத் தேர்வு செய்யவும்",
    "subscriptions.form.payment_method_help": "இந்த சப்ஸ்கிரிப்ஷனுக்கு அனுமதிக்கப்பட்ட பேமென்ட் முறைகளைத் தேர்வு செய்யவும் (எ.கா: Stripe, Mangopay, Android, iOS, இலவச சப்ஸ்கிரிப்ஷன்).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "இந்த சப்ஸ்கிரிப்ஷனுக்கு அனுமதிக்கப்பட்ட பேமென்ட் முறைகளைத் தேர்வு செய்யவும் (எ.கா: Stripe, Mangopay, Android, iOS, இலவச சப்ஸ்கிரிப்ஷன்).",
    "subscriptions.form.active_placeholder": "செயல்பாட்டில் உள்ள சப்ஸ்கிரிப்ஷன்",
    "Subscription Active": "செயல்பாட்டில் உள்ள சப்ஸ்கிரிப்ஷன்",
    "subscriptions.form.active_help": "சுவிட்சை பயன்படுத்தி சப்ஸ்கிரிப்ஷனை செயல்படுத்தவும் அல்லது செயல்பாட்டிலிருந்து நீக்கவும். செயல்பாட்டில் உள்ள சப்ஸ்கிரிப்ஷன் வாங்க கிடைக்கிறது.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "சுவிட்சை பயன்படுத்தி சப்ஸ்கிரிப்ஷனை செயல்படுத்தவும் அல்லது செயல்பாட்டிலிருந்து நீக்கவும். செயல்பாட்டில் உள்ள சப்ஸ்கிரிப்ஷன் வாங்க கிடைக்கிறது.",
    "subscriptions.add_title": "புதிய சப்ஸ்கிரிப்ஷன் தயாரிப்பை சேர்க்கவும்",
    "Add new subscription product": "புதிய சப்ஸ்கிரிப்ஷன் தயாரிப்பை சேர்க்கவும்",
    "subscriptions.edit_title": "சப்ஸ்கிரிப்ஷன் தயாரிப்பை தொகுத்துக்கொள்ளவும்",
    "Edit subscription product": "சப்ஸ்கிரிப்ஷன் தயாரிப்பை தொகுத்துக்கொள்ளவும்",
    "subscriptions.added_success": "சப்ஸ்கிரிப்ஷன் பட்டியல் வெற்றிகரமாக சேர்க்கப்பட்டது",
    "Subscription listing added successfully": "சப்ஸ்கிரிப்ஷன் பட்டியல் வெற்றிகரமாக சேர்க்கப்பட்டது",
    "subscriptions.updated_success": "சப்ஸ்கிரிப்ஷன் பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "Subscription listing updated successfully": "சப்ஸ்கிரிப்ஷன் பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "common.currency": "நாணயம்",
    "common.sku": "SKU",
    "subscriptions.title": "சப்ஸ்கிரிப்ஷன்கள்",
    "subscriptions.add_subscription": "சப்ஸ்கிரிப்ஷனை சேர்க்கவும்",
    "Add subscription": "சப்ஸ்கிரிப்ஷனை சேர்க்கவும்",
    "subscriptions.plans": "திட்டங்கள்",
    "subscriptions.active_subscribers": "செயல்பாட்டு பயனர்கள்",
    "Active Subscribers": "செயல்பாட்டு பயனர்கள்",
    "subscriptions.total_mrr": "மொத்த MRR",
    "Total MRR": "மொத்த MRR",
    "subscriptions.churn_rate": "கைவிடுதல் விகிதம்",
    "Churn Rate": "கைவிடுதல் விகிதம்",
    "subscriptions.new_this_month": "இந்த மாதம் புதியவர்கள்",
    "New This Month": "இந்த மாதம் புதியவர்கள்",
    "subscriptions.average_duration": "சராசரி காலம்",
    "Avg Duration": "சராசரி காலம்",
    "subscriptions.monthly_recurring_revenue": "மாதாந்திர மீள்வருமானம்",
    "Monthly Recurring Revenue": "மாதாந்திர மீள்வருமானம்",
    "subscriptions.annual_run_rate": "ஆண்டு விகிதம்",
    "Annual Run Rate": "ஆண்டு விகிதம்",
    "subscriptions.last_30_days": "கடந்த 30 நாட்கள்",
    "subscriptions.subscriber_lifetime": "சப்ஸ்கிரிப்ஷன் காலம்",
    "Subscriber lifetime": "சப்ஸ்கிரிப்ஷன் காலம்",
    "subscriptions.subscriber_distribution": "சப்ஸ்கிரிப்ஷன் பிரிவு",
    "Subscriber Distribution": "சப்ஸ்கிரிப்ஷன் பிரிவு",
    "subscriptions.billing_period": "பில்லிங் காலம்",
    "Billing Period": "பில்லிங் காலம்",
    "subscriptions.allowed_listings": "அனுமதிக்கப்பட்ட பட்டியல்கள்",
    "subscriptions.commission_per_order": "ஆர்டருக்கு கமிஷன்",
    "Commission per Order": "ஆர்டருக்கு கமிஷன்",
    "subscriptions.fixed_fee_per_order": "ஆர்டருக்கு நிலையான கட்டணம்",
    "Fixed Fee per Order": "ஆர்டருக்கு நிலையான கட்டணம்",
    "subscriptions.payment_provider": "கட்டண வழங்குநர்",
    "Payment Provider": "கட்டண வழங்குநர்",
    "subscriptions.sku_product_id": "SKU / பொருள் ID",
    "SKU / Product ID": "SKU / பொருள் ID",
    "subscriptions.revenue_over_time": "நேரத்தின் படி வருமானம்",
    "Revenue Over Time": "நேரத்தின் படி வருமானம்",
    "subscriptions.revenue": "வருமானம்",
    "subscriptions.subscriber_growth": "சப்ஸ்கிரிப்ஷன் வளர்ச்சி",
    "Subscriber Growth": "சப்ஸ்கிரிப்ஷன் வளர்ச்சி",
    "subscriptions.subscribers": "சப்ஸ்கிரிப்ஷன்கள்",
    "subscriptions.set_inactive": "இன்னும் இயங்காததை அமைக்கவும்",
    "Set Inactive": "இன்னும் இயங்காததை அமைக்கவும்",
    "subscriptions.set_active": "செயல்பாட்டில் வைக்கவும்",
    "Set Active": "செயல்பாட்டில் வைக்கவும்",
    "subscriptions.plan_title": "சப்ஸ்கிரிப்ஷன் திட்டம்",
    "Subscription Plan": "சப்ஸ்கிரிப்ஷன் திட்டம்",
    "subscriptions.status.active": "செயல்பாட்டில்",
    "subscriptions.status.cancelled": "ரத்து செய்யப்பட்டது",
    "subscriptions.status.expired": "முடிவடைந்தது",
    "subscriptions.status.trial": "சோதனை",
    "Trial": "சோதனை",
    "subscriptions.status.pending": "தொடர்புடையது",
    "subscriptions.period.lifetime": "ஆயிரம் ஆண்டுகள்",
    "Lifetime": "ஆயிரம் ஆண்டுகள்",
    "subscriptions.period.daily": "நாள்தோறும்",
    "subscriptions.period.weekly": "வாராந்திரம்",
    "subscriptions.period.monthly": "மாதாந்திரம்",
    "subscriptions.period.quarterly": "மூன்று மாதங்கள்",
    "subscriptions.period.semi_annual": "ஆண்டுக்கு இருமுறை",
    "Semi-annual": "ஆண்டுக்கு இருமுறை",
    "subscriptions.period.annual": "ஆண்டுக்கு",
    "Annual": "ஆண்டுக்கு",
    "subscriptions.period.days": "{count} நாட்கள்",
    "subscriptions.period.day": "/ நாள்",
    "/ day": "/ நாள்",
    "subscriptions.period.week": "/ வாரம்",
    "/ week": "/ வாரம்",
    "subscriptions.period.month": "/ மாதம்",
    "/ month": "/ மாதம்",
    "subscriptions.period.quarter": "/ மூன்று மாதங்கள்",
    "/ quarter": "/ மூன்று மாதங்கள்",
    "subscriptions.period.six_months": "/ 6 மாதங்கள்",
    "/ 6 months": "/ 6 மாதங்கள்",
    "subscriptions.period.year": "/ ஆண்டு",
    "/ year": "/ ஆண்டு",
    "subscriptions.listings_count": "{count} அறிவிப்புகள்",
    "{count} listings": "{count} அறிவிப்புகள்",
    "subscriptions.commission_percentage": "{rate}% கமிஷன்",
    "{rate}% commission": "{rate}% கமிஷன்",
    "subscriptions.per_order": "/ ஆர்டர்",
    "/ order": "/ ஆர்டர்",
    "subscriptions.view_details_subscribers": "விவரங்களையும் உறுப்பினர்களையும் பார்க்கவும்",
    "View details and subscribers": "விவரங்களையும் உறுப்பினர்களையும் பார்க்கவும்",
    "subscriptions.edit_subscription": "சந்தாவை தொகுத்தல்",
    "Edit subscription": "சந்தாவை தொகுத்தல்",
    "subscriptions.delete_subscription": "சந்தாவை நீக்குதல்",
    "Delete subscription": "சந்தாவை நீக்குதல்",
    "subscriptions.deleted": "சந்தா நீக்கப்பட்டது",
    "Subscription deleted": "சந்தா நீக்கப்பட்டது",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Android IAP",
    "Android IAP": "Android IAP",
    "subscriptions.type.ios": "iOS IAP",
    "iOS IAP": "iOS IAP",
    "subscriptions.type.free_subscription": "இலவசம்",
    "subscriptions.type.mangopay": "Mangopay",
    "Mangopay": "Mangopay",
    "subscriptions.loaded_count": "{count} ஏற்றப்பட்டது",
    "subscriptions.no_subscribers": "{status} உறுப்பினர்கள் இல்லை.",
    "No {status} subscribers.": "{status} உறுப்பினர்கள் இல்லை.",
    "subscriptions.billing_records": "பில்லிங் பதிவுகள்",
    "Billing Records": "பில்லிங் பதிவுகள்",
    "subscriptions.no_invoices": "பில்லிங் கண்டறியப்படவில்லை.",
    "No invoices found.": "பில்லிங் கண்டறியப்படவில்லை.",
    "subscriptions.column.account": "கணக்கு",
    "subscriptions.column.email": "மின்னஞ்சல்",
    "subscriptions.column.status": "நிலை",
    "subscriptions.column.subscribed": "சந்தா பெற்றவர்",
    "Subscribed": "சந்தா பெற்றவர்",
    "subscriptions.column.expires": "முடிவடைகிறது",
    "subscriptions.column.next_renewal": "அடுத்த புதுப்பிப்பு",
    "Next Renewal": "அடுத்த புதுப்பிப்பு",
    "subscriptions.column.amount_paid": "செலுத்தப்பட்ட தொகை",
    "Amount Paid": "செலுத்தப்பட்ட தொகை",
    "subscriptions.invoice_column.invoice_id": "பில்லிங் ஐடி",
    "Invoice ID": "பில்லிங் ஐடி",
    "subscriptions.invoice_column.account": "கணக்கு",
    "subscriptions.invoice_column.amount": "தொகை",
    "subscriptions.invoice_column.status": "நிலை",
    "subscriptions.invoice_column.period": "காலம்",
    "subscriptions.invoice_column.paid_at": "பேமென்ட் செய்த தேதி",
    "Paid At": "பேமென்ட் செய்த தேதி",
    "subscriptions.validation.title_required": "தலைப்பு அவசியம்",
    "subscriptions.validation.allowed_listings_positive": "அனுமதிக்கப்பட்ட பட்டியல்கள் 0-க்கு மேலாக இருக்க வேண்டும்",
    "Allowed listings should be greater than 0": "அனுமதிக்கப்பட்ட பட்டியல்கள் 0-க்கு மேலாக இருக்க வேண்டும்",
    "subscriptions.validation.currency_required": "முதலீட்டு மதிப்பு அவசியம்",
    "Currency is required": "முதலீட்டு மதிப்பு அவசியம்",
    "subscriptions.validation.expiry_required": "முடிவுகாலம் நாட்கள் அவசியம்",
    "Expiry days are required": "முடிவுகாலம் நாட்கள் அவசியம்",
    "subscriptions.validation.payment_method_required": "கட்டண முறை அவசியம்",
    "Payment method is required": "கட்டண முறை அவசியம்",
    "subscriptions.error.save": "சப்ஸ்கிரிப்ஷனை சேமிக்கும்போது பிழை ஏற்பட்டது.",
    "Something went wrong while saving the subscription.": "சப்ஸ்கிரிப்ஷனை சேமிக்கும்போது பிழை ஏற்பட்டது.",
    "subscriptions.error.delete": "சப்ஸ்கிரிப்ஷனை நீக்கும்போது பிழை ஏற்பட்டது.",
    "Something went wrong while deleting the subscription.": "சப்ஸ்கிரிப்ஷனை நீக்கும்போது பிழை ஏற்பட்டது.",
    "common.configuration": "அமைப்பு",
    "subscriptions.per_period": "{period}-க்கு வேண்டும்",
    "per {period}": "{period}-க்கு வேண்டும்",
    "subscriptions.tab.subscribers": "சப்ஸ்கிரிப்ஷன் பெறுபவர்கள்",
    "subscriptions.tab.invoices": "கணக்குகள்",
    "subscriptions.account_title": "கணக்கு சப்ஸ்கிரிப்ஷன்",
    "Account Subscription": "கணக்கு சப்ஸ்கிரிப்ஷன்",
    "subscriptions.config.description": "கணக்கு சப்ஸ்கிரிப்ஷன்களை மேலாண்மை செய்யவும். செயல்பாட்டில் இருக்கும்போது, கணக்கு உரிமையாளர்கள் பட்டியல்களை பதிவிட செயல்பாட்டிலுள்ள சப்ஸ்கிரிப்ஷன் தேவைப்படுகிறது. கட்டண முறையில் தேர்ந்தெடுக்கப்பட்ட பொதுவான கட்டண வழித்தடம் சப்ஸ்கிரிப்ஷன் கட்டணங்களுக்கு பயன்படுத்தப்படுகிறது.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "கணக்கு சப்ஸ்கிரிப்ஷன்களை மேலாண்மை செய்யவும். செயல்பாட்டில் இருக்கும்போது, கணக்கு உரிமையாளர்கள் பட்டியல்களை பதிவிட செயல்பாட்டிலுள்ள சப்ஸ்கிரிப்ஷன் தேவைப்படுகிறது. கட்டண முறையில் தேர்ந்தெடுக்கப்பட்ட பொதுவான கட்டண வழித்தடம் சப்ஸ்கிரிப்ஷன் கட்டணங்களுக்கு பயன்படுத்தப்படுகிறது.",
    "subscriptions.config.enable": "சப்ஸ்கிரிப்ஷனை செயல்படுத்து",
    "Enable subscriptions": "சப்ஸ்கிரிப்ஷனை செயல்படுத்து",
    "subscriptions.config.type": "சப்ஸ்கிரிப்ஷன் வகை",
    "Subscription type": "சப்ஸ்கிரிப்ஷன் வகை",
    "subscriptions.config.purchased_message": "சப்ஸ்கிரிப்ஷன் ஏற்கனவே வாங்கப்பட்டிருக்கும்போது செய்தி",
    "Message when a subscription is already purchased": "சப்ஸ்கிரிப்ஷன் ஏற்கனவே வாங்கப்பட்டிருக்கும்போது செய்தி",
    "subscriptions.config.purchased_placeholder": "ஏற்கனவே வாங்கப்பட்ட செய்தியை உள்ளிடவும்",
    "Enter the already-purchased message": "ஏற்கனவே வாங்கப்பட்ட செய்தியை உள்ளிடவும்",
    "subscriptions.config.listings_exhausted_message": "பட்டியல் வரம்பு அடையப்பட்டபோது செய்தி",
    "Message when the listing limit is reached": "பட்டியல் வரம்பு அடையப்பட்டபோது செய்தி",
    "subscriptions.config.listings_exhausted_placeholder": "பட்டியல் வரம்பு செய்தியை உள்ளிடவும்",
    "Enter the listing limit message": "பட்டியல் வரம்பு செய்தியை உள்ளிடவும்",
    "subscriptions.config.inactive_message": "சப்ஸ்கிரிப்ஷன் செயலற்றதாக இருக்கும்போது செய்தி",
    "Message when the subscription is inactive": "சப்ஸ்கிரிப்ஷன் செயலற்றதாக இருக்கும்போது செய்தி",
    "subscriptions.config.inactive_placeholder": "செயலற்ற சப்ஸ்கிரிப்ஷன் செய்தியை உள்ளிடவும்",
    "Enter the inactive subscription message": "செயலற்ற சப்ஸ்கிரிப்ஷன் செய்தியை உள்ளிடவும்",
    "subscriptions.config.saved": "சப்ஸ்கிரிப்ஷன் அமைப்பு வெற்றிகரமாக சேமிக்கப்பட்டது",
    "Subscription settings saved successfully": "சப்ஸ்கிரிப்ஷன் அமைப்பு வெற்றிகரமாக சேமிக்கப்பட்டது",
    "people.title": "மக்கள்",
    "people.tab.staff": "குழு",
    "people.tab.departments": "பிரிவுகள்",
    "Departments": "பிரிவுகள்",
    "people.tab.job_profiles": "பணியிட விவரக்குறிப்புகள்",
    "Job profiles": "பணியிட விவரக்குறிப்புகள்",
    "people.tab.pay_grades": "வேலை வகைகள்",
    "Pay grades": "வேலை வகைகள்",
    "people.action.add_staff": "தொழிலாளரைச் சேர்க்க",
    "people.action.add_department": "பிரிவைச் சேர்க்க",
    "people.action.add_job_profile": "பணியிட விவரக்குறிப்பைச் சேர்க்க",
    "people.action.add_pay_grade": "வேலை வகையைச் சேர்க்க",
    "people.currency_id": "முதலீட்டு எண்",
    "people.onboarding.eyebrow": "மக்களை தொடங்கு",
    "Get started with People": "மக்களை தொடங்கு",
    "people.onboarding.title": "குழு பட்டியலை உருவாக்கு",
    "Build your team directory": "குழு பட்டியலை உருவாக்கு",
    "people.onboarding.description": "முதல் தொழிலாளரைச் சேர்த்து, பின்னர் பிரிவுகள், பணியிட விவரக்குறிப்புகள் மற்றும் வேலை வகைகளைப் பயன்படுத்தி உங்கள் குழுவை அமைக்கவும்.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "முதல் தொழிலாளரைச் சேர்த்து, பின்னர் பிரிவுகள், பணியிட விவரக்குறிப்புகள் மற்றும் வேலை வகைகளைப் பயன்படுத்தி உங்கள் குழுவை அமைக்கவும்.",
    "people.onboarding.add_first": "முதல் தொழிலாளரைச் சேர்க்க",
    "Add your first staff member": "முதல் தொழிலாளரைச் சேர்க்க",
    "people.onboarding.step_staff": "குழுவைச் சேர்க்க",
    "people.onboarding.step_staff_description": "உங்கள் தொழிலாளர் பட்டியலுக்கு ஏற்கனவே உள்ள பயனரை இணைக்கவும்.",
    "Link an existing user to your staff directory.": "உங்கள் தொழிலாளர் பட்டியலுக்கு ஏற்கனவே உள்ள பயனரை இணைக்கவும்.",
    "people.onboarding.step_teams": "குழுவை அமைக்க",
    "Organize teams": "குழுவை அமைக்க",
    "people.onboarding.step_teams_description": "வளர்ச்சியுடன் பிரிவுகள் மற்றும் பணியிட விவரக்குறிப்புகளை உருவாக்குங்கள்.",
    "Create departments and job profiles as you grow.": "வளர்ச்சியுடன் பிரிவுகள் மற்றும் பணியிட விவரக்குறிப்புகளை உருவாக்குங்கள்.",
    "people.onboarding.step_pay": "சம்பளத்தை அமைக்க",
    "Set compensation": "சம்பளத்தை அமைக்க",
    "people.onboarding.step_pay_description": "கூட்டு கணக்கு அமைப்பிற்கு வேலை வகைகளை வரையறுக்கவும்.",
    "Define pay grades for consistent payroll setup.": "கூட்டு கணக்கு அமைப்பிற்கு வேலை வகைகளை வரையறுக்கவும்.",
    "people.staff_profile": "தொழிலாளர் விவரக்குறிப்பு",
    "Staff profile": "தொழிலாளர் விவரக்குறிப்பு",
    "people.field.employee_code": "தொழிலாளர் குறியீடு",
    "Employee code": "தொழிலாளர் குறியீடு",
    "people.field.job_title": "பணியிடம்",
    "Job title": "பணியிடம்",
    "people.field.department": "பிரிவு",
    "Department": "பிரிவு",
    "people.field.job_profile": "வேலை செய்யும் தொழில் சுருக்கம்",
    "Job profile": "வேலை செய்யும் தொழில் சுருக்கம்",
    "people.field.pay_grade": "கூட்டு ஊதிய அளவு",
    "Pay grade": "கூட்டு ஊதிய அளவு",
    "people.field.employment_type": "பணியிட வகை",
    "Employment type": "பணியிட வகை",
    "people.field.start_date": "தொடங்கும் தேதி",
    "people.field.user_id": "பயனர் ID",
    "people.field.user": "பயனர்",
    "people.field.grade": "அளவு",
    "Grade": "அளவு",
    "people.field.salary_range": "ஊதிய வரம்பு",
    "Salary range": "ஊதிய வரம்பு",
    "people.field.minimum_salary": "குறைந்தபட்ச ஊதியம்",
    "Minimum salary": "குறைந்தபட்ச ஊதியம்",
    "people.field.maximum_salary": "அதிகபட்ச ஊதியம்",
    "Maximum salary": "அதிகபட்ச ஊதியம்",
    "people.field.currency_id": "முதலீட்டு ஐடி",
    "people.form.staff.edit": "பணியாளரை திருத்து",
    "Edit staff": "பணியாளரை திருத்து",
    "people.form.staff.add": "பணியாளரை சேர்க்க",
    "people.form.staff.description": "ஒரு பயனரை பணியாளர் சுருக்கத்துடன் இணைக்கவும்.",
    "Link an existing user to a staff profile.": "ஒரு பயனரை பணியாளர் சுருக்கத்துடன் இணைக்கவும்.",
    "people.form.department.edit": "பிரிவை திருத்து",
    "Edit department": "பிரிவை திருத்து",
    "people.form.department.add": "பிரிவை சேர்க்க",
    "people.form.job_profile.edit": "பணியிட சுருக்கத்தை திருத்து",
    "Edit job profile": "பணியிட சுருக்கத்தை திருத்து",
    "people.form.job_profile.add": "பணியிட சுருக்கத்தை சேர்க்க",
    "people.form.pay_grade.edit": "ஊதிய அளவை திருத்து",
    "Edit pay grade": "ஊதிய அளவை திருத்து",
    "people.form.pay_grade.add": "ஊதிய அளவை சேர்க்க",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "தலைமை பொறியாளர்",
    "Senior Engineer": "தலைமை பொறியாளர்",
    "people.placeholder.department": "பொறியியல்",
    "Engineering": "பொறியியல்",
    "people.placeholder.department_description": "தயாரிப்பு மற்றும் பொறியியல் குழு",
    "Product & Engineering team": "தயாரிப்பு மற்றும் பொறியியல் குழு",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "முழு நேர பணியாளர்",
    "Full time": "முழு நேர பணியாளர்",
    "people.employment.part_time": "பாதி நேர பணியாளர்",
    "Part time": "பாதி நேர பணியாளர்",
    "people.employment.contractor": "கூட்டு பணியாளர்",
    "Contractor": "கூட்டு பணியாளர்",
    "people.toast.staff_added": "பணியாளர் சேர்க்கப்பட்டது",
    "Staff added": "பணியாளர் சேர்க்கப்பட்டது",
    "people.toast.staff_updated": "பணியாளர் புதுப்பிக்கப்பட்டது",
    "Staff updated": "பணியாளர் புதுப்பிக்கப்பட்டது",
    "people.toast.department_added": "பிரிவு சேர்க்கப்பட்டது",
    "Department added": "பிரிவு சேர்க்கப்பட்டது",
    "people.toast.department_updated": "பிரிவு புதுப்பிக்கப்பட்டது",
    "Department updated": "பிரிவு புதுப்பிக்கப்பட்டது",
    "people.toast.job_profile_added": "பணியிட விவரம் சேர்க்கப்பட்டது",
    "Job profile added": "பணியிட விவரம் சேர்க்கப்பட்டது",
    "people.toast.job_profile_updated": "பணியிட விவரம் புதுப்பிக்கப்பட்டது",
    "Job profile updated": "பணியிட விவரம் புதுப்பிக்கப்பட்டது",
    "people.toast.pay_grade_added": "கூட்டு ஊதிய வகை சேர்க்கப்பட்டது",
    "Pay grade added": "கூட்டு ஊதிய வகை சேர்க்கப்பட்டது",
    "people.toast.pay_grade_updated": "கூட்டு ஊதிய வகை புதுப்பிக்கப்பட்டது",
    "Pay grade updated": "கூட்டு ஊதிய வகை புதுப்பிக்கப்பட்டது",
    "people.empty.staff": "முன்னர் பணியாளர் இல்லை. தொடங்க பணியாளர் விவரத்தைச் சேர்க்கவும்.",
    "No staff yet. Add a staff profile to get started.": "முன்னர் பணியாளர் இல்லை. தொடங்க பணியாளர் விவரத்தைச் சேர்க்கவும்.",
    "people.empty.departments": "முன்னர் பிரிவுகள் இல்லை.",
    "No departments yet.": "முன்னர் பிரிவுகள் இல்லை.",
    "people.empty.job_profiles": "முன்னர் பணியிட விவரங்கள் இல்லை.",
    "No job profiles yet.": "முன்னர் பணியிட விவரங்கள் இல்லை.",
    "people.empty.pay_grades": "முன்னர் ஊதிய வகைகள் இல்லை.",
    "No pay grades yet.": "முன்னர் ஊதிய வகைகள் இல்லை.",
    "people.pagination.page": "பக்கம் {page}",
    "Page {page}": "பக்கம் {page}",
    "workforce.title": "பணியாளர் பட்டியல்",
    "workforce.tab.shifts": "மாற்றுகள்",
    "Shifts": "மாற்றுகள்",
    "workforce.tab.attendance": "வருகை",
    "Attendance": "வருகை",
    "workforce.tab.leave_requests": "இடைவெளி கோரிக்கைகள்",
    "Leave requests": "இடைவெளி கோரிக்கைகள்",
    "workforce.tab.leave_balances": "இடைவெளி பங்கு",
    "Leave balances": "இடைவெளி பங்கு",
    "workforce.tab.leave_policies": "இடைவெளி கொள்கைகள்",
    "Leave policies": "இடைவெளி கொள்கைகள்",
    "workforce.action.add_shift": "மாற்றைச் சேர்க்கவும்",
    "workforce.action.new_leave_request": "புதிய விடுமுறை கோரிக்கை",
    "New leave request": "புதிய விடுமுறை கோரிக்கை",
    "workforce.action.set_balance": "செலவு சமத்துவம்",
    "Set balance": "செலவு சமத்துவம்",
    "workforce.action.add_policy": "கொள்கையை சேர்க்கவும்",
    "Add policy": "கொள்கையை சேர்க்கவும்",
    "workforce.action.create_request": "கோரிக்கையை உருவாக்கு",
    "Create request": "கோரிக்கையை உருவாக்கு",
    "workforce.action.save_balance": "செலவு சமத்துவம் சேமி",
    "Save balance": "செலவு சமத்துவம் சேமி",
    "workforce.action.clock_in": "உள்ளீடு குறிப்பிடு",
    "Clock in": "உள்ளீடு குறிப்பிடு",
    "workforce.action.clock_out": "வெளியேறும் குறிப்பிடு",
    "workforce.action.clocking_in": "உள்ளீடு குறிப்பிடும்…",
    "Clocking in…": "உள்ளீடு குறிப்பிடும்…",
    "workforce.action.clocking_out": "வெளியேறும் குறிப்பிடும்…",
    "Clocking out…": "வெளியேறும் குறிப்பிடும்…",
    "workforce.field.staff": "பணியாளர்கள்",
    "workforce.field.start_time": "தொடக்கம்",
    "workforce.field.end_time": "முடிவு",
    "workforce.field.location": "இடம்",
    "workforce.field.leave_type": "விடுமுறை வகை",
    "Leave type": "விடுமுறை வகை",
    "workforce.field.from": "முதல்",
    "workforce.field.to": "வரை",
    "workforce.field.days": "நாட்கள்",
    "Days": "நாட்கள்",
    "workforce.field.total_days": "மொத்த நாட்கள்",
    "Total days": "மொத்த நாட்கள்",
    "workforce.field.days_per_year": "ஆண்டுக்கு நாட்கள்",
    "Days per year": "ஆண்டுக்கு நாட்கள்",
    "workforce.field.carry_over": "அடுத்த ஆண்டிற்கு மாற்றுதல்",
    "Carry over": "அடுத்த ஆண்டிற்கு மாற்றுதல்",
    "workforce.field.carry_over_hint": "பயன்படுத்தாத நாட்கள் அடுத்த ஆண்டிற்கு மாற்றப்படும்.",
    "Unused days carry over to next year": "பயன்படுத்தாத நாட்கள் அடுத்த ஆண்டிற்கு மாற்றப்படும்.",
    "workforce.field.reason": "காரணம்",
    "workforce.field.time": "நேரம்",
    "workforce.field.clock_in": "உள்ளீடு குறிப்பிடு",
    "workforce.field.clock_out": "வெளியேறு",
    "workforce.field.hours": "மணிநேரங்கள்",
    "Hours": "மணிநேரங்கள்",
    "workforce.field.dates": "தேதிகள்",
    "Dates": "தேதிகள்",
    "workforce.field.used_days": "பயன்படுத்தப்பட்டது",
    "Used": "பயன்படுத்தப்பட்டது",
    "workforce.field.remaining_days": "மீதமுள்ளது",
    "workforce.field.policy": "அரசியல்",
    "Policy": "அரசியல்",
    "workforce.placeholder.location": "தலைமையகம்",
    "HQ": "தலைமையகம்",
    "workforce.placeholder.leave_note": "குடும்ப விடுமுறை",
    "Family holiday": "குடும்ப விடுமுறை",
    "workforce.placeholder.policy_name": "ஆண்டு விடுமுறை",
    "Annual Leave": "ஆண்டு விடுமுறை",
    "workforce.placeholder.reject_reason": "உள்ளீட்டு காலம்",
    "Busy period": "உள்ளீட்டு காலம்",
    "workforce.placeholder.optional_note": "கூடுதல் குறிப்பு",
    "Optional note": "கூடுதல் குறிப்பு",
    "workforce.select.all_staff": "அனைத்து பணியாளர்களும்",
    "All staff": "அனைத்து பணியாளர்களும்",
    "workforce.form.shift.add": "மாற்று சேர்க்க",
    "workforce.form.leave_request.add": "புதிய விடுமுறை கோரிக்கை",
    "workforce.form.leave_balance.title": "விடுமுறை பங்கு அமைக்கவும்",
    "Set leave balance": "விடுமுறை பங்கு அமைக்கவும்",
    "workforce.form.leave_balance.description": "விடுமுறை வகை மற்றும் ஆண்டுக்கு பணியாளரின் உரிமையை தொடங்கவும்.",
    "Initialize a staff member’s entitlement for a leave type and year.": "விடுமுறை வகை மற்றும் ஆண்டுக்கு பணியாளரின் உரிமையை தொடங்கவும்.",
    "workforce.form.leave_policy.add": "விடுமுறை கொள்கையைச் சேர்க்கவும்",
    "Add leave policy": "விடுமுறை கொள்கையைச் சேர்க்கவும்",
    "workforce.form.leave_request.reject": "விடுமுறை கோரிக்கையை நிராகரிக்கவும்",
    "Reject leave request": "விடுமுறை கோரிக்கையை நிராகரிக்கவும்",
    "workforce.form.clock_out": "வெளியேறு",
    "workforce.toast.shift_added": "மாற்று சேர்க்கப்பட்டது",
    "Shift added": "மாற்று சேர்க்கப்பட்டது",
    "workforce.toast.leave_request_created": "விடுமுறை கோரிக்கை உருவாக்கப்பட்டது",
    "Leave request created": "விடுமுறை கோரிக்கை உருவாக்கப்பட்டது",
    "workforce.toast.leave_balance_saved": "விடுமுறை பங்கு சேமிக்கப்பட்டது",
    "Leave balance saved": "விடுமுறை பங்கு சேமிக்கப்பட்டது",
    "workforce.toast.leave_policy_added": "விடுமுறை கொள்கை சேர்க்கப்பட்டது",
    "Leave policy added": "விடுமுறை கொள்கை சேர்க்கப்பட்டது",
    "workforce.toast.leave_request_rejected": "விடுமுறை கோரிக்கை நிராகரிக்கப்பட்டது",
    "Leave request rejected": "விடுமுறை கோரிக்கை நிராகரிக்கப்பட்டது",
    "workforce.toast.leave_request_approved": "விடுப்பு கோரிக்கை ஒப்புக்கொள்ளப்பட்டது",
    "Leave request approved": "விடுப்பு கோரிக்கை ஒப்புக்கொள்ளப்பட்டது",
    "workforce.toast.clocked_in": "மார்க்கிட் செய்யப்பட்டது",
    "Clocked in": "மார்க்கிட் செய்யப்பட்டது",
    "workforce.toast.clocked_out": "மார்க்கிட் நீக்கப்பட்டது",
    "Clocked out": "மார்க்கிட் நீக்கப்பட்டது",
    "workforce.empty.shifts": "இந்த காலக்கெடுவில் வேலை மாற்றங்கள் இல்லை.",
    "No shifts in this period.": "இந்த காலக்கெடுவில் வேலை மாற்றங்கள் இல்லை.",
    "workforce.empty.attendance": "பங்கேற்பு பதிவுகள் இல்லை.",
    "No attendance records.": "பங்கேற்பு பதிவுகள் இல்லை.",
    "workforce.empty.leave_requests": "விடுப்பு கோரிக்கைகள் இல்லை.",
    "No leave requests.": "விடுப்பு கோரிக்கைகள் இல்லை.",
    "workforce.empty.leave_balances": "விடுப்பு பெறுதல் இல்லை. 'சமப்படுத்து' என்பதைப் பயன்படுத்தி ஒன்றைச் சேர்க்கவும்.",
    "No leave balances. Use Set balance to add one.": "விடுப்பு பெறுதல் இல்லை. 'சமப்படுத்து' என்பதைப் பயன்படுத்தி ஒன்றைச் சேர்க்கவும்.",
    "workforce.empty.leave_policies": "விடுப்பு கொள்கைகள் இன்னும் இல்லை.",
    "No leave policies yet.": "விடுப்பு கொள்கைகள் இன்னும் இல்லை.",
    "workforce.leave_type.annual": "ஆண்டு விடுப்பு",
    "Annual leave": "ஆண்டு விடுப்பு",
    "workforce.leave_type.sick": "நோய் விடுப்பு",
    "Sick leave": "நோய் விடுப்பு",
    "workforce.leave_type.unpaid": "கூலி இல்லாத விடுப்பு",
    "Unpaid leave": "கூலி இல்லாத விடுப்பு",
    "workforce.leave_type.parental": "பெற்றோர் விடுப்பு",
    "Parental leave": "பெற்றோர் விடுப்பு",
    "workforce.leave_type.compassionate": "உள்ளுணர்வு விடுப்பு",
    "Compassionate leave": "உள்ளுணர்வு விடுப்பு",
    "workforce.duration.hours_minutes": "{hours}h {minutes}m",
    "{hours}h {minutes}m": "{hours}h {minutes}m",
    "common.year": "ஆண்டு",
    "Year": "ஆண்டு",
    "common.approve": "ஒப்புக்கொள்ள",
    "common.reject": "நிராகரிக்க",
    "payroll.title": "கூலி பட்டியல்",
    "payroll.tab.runs": "கூலி பட்டியல் இயக்கங்கள்",
    "Payroll runs": "கூலி பட்டியல் இயக்கங்கள்",
    "payroll.tab.components": "கூலி பட்டியல் பாகங்கள்",
    "Pay components": "கூலி பட்டியல் பாகங்கள்",
    "payroll.tab.claims": "செலவு கோரிக்கைகள்",
    "Expense claims": "செலவு கோரிக்கைகள்",
    "payroll.tab.categories": "செலவு வகைகள்",
    "Expense categories": "செலவு வகைகள்",
    "payroll.action.new_run": "புதிய கூலி பட்டியல் இயக்கம்",
    "payroll.action.add_component": "கூலி பட்டியல் பாகத்தைச் சேர்க்கவும்",
    "payroll.action.new_claim": "புதிய செலவு கோரிக்கை",
    "New expense claim": "புதிய செலவு கோரிக்கை",
    "payroll.action.add_category": "கத்திரிக்கு சேர்க்க",
    "payroll.action.create_run": "உருவாக்குதல் இயக்கம்",
    "Create run": "உருவாக்குதல் இயக்கம்",
    "payroll.action.create_component": "கூறு உருவாக்குதல்",
    "Create component": "கூறு உருவாக்குதல்",
    "payroll.action.create_claim": "கோரிக்கை உருவாக்குதல்",
    "Create claim": "கோரிக்கை உருவாக்குதல்",
    "payroll.action.submit_claim": "அனுப்புதல்",
    "payroll.action.approve_claim": "ஒப்புக்கொள்ள",
    "payroll.action.reimburse_claim": "மீள்வழங்குதல்",
    "payroll.action.approve_payroll": "நிலையான பணம் ஒப்புக்கொள்ள",
    "Approve payroll": "நிலையான பணம் ஒப்புக்கொள்ள",
    "payroll.action.activate": "செயல்படுத்து",
    "Activate": "செயல்படுத்து",
    "payroll.action.deactivate": "முடக்கு",
    "payroll.action.adjust": "திருத்து",
    "payroll.action.save_adjustment": "திருத்தத்தை சேமி",
    "payroll.action.export_csv": "CSV ஏற்றுமதி செய்தல்",
    "payroll.action.exporting": "ஏற்றுமதி செய்து கொண்டிருக்கிறது…",
    "payroll.action.view_staff_items": "பணியாளர் பொருட்களைப் பார்க்க",
    "View staff items": "பணியாளர் பொருட்களைப் பார்க்க",
    "payroll.action.view_payslips": "பணம் பட்டியலைப் பார்க்க",
    "View payslips": "பணம் பட்டியலைப் பார்க்க",
    "payroll.type.addition": "சேர்க்கை",
    "Addition": "சேர்க்கை",
    "payroll.type.deduction": "கழிப்பு",
    "Deduction": "கழிப்பு",
    "payroll.calculation.fixed": "நிலையான தொகை",
    "Fixed amount": "நிலையான தொகை",
    "payroll.calculation.percentage": "சதவீதம்",
    "payroll.applies_to.all": "அனைத்து பணியாளர்களும்",
    "payroll.applies_to.hourly": "மணிநேர பணியாளர்கள்",
    "Hourly staff": "மணிநேர பணியாளர்கள்",
    "payroll.applies_to.salaried": "சம்பளம் பெறும் பணியாளர்கள்",
    "Salaried staff": "சம்பளம் பெறும் பணியாளர்கள்",
    "payroll.category.archive_confirm": " {name} ஐ கோப்பு செய்ய வேண்டுமா?",
    "payroll.components.description": "ஆக்டிவ் அதிகப்படிகள் மற்றும் குறைப்புகள் புதிய நோமினா ஓட்டங்களுக்கு தானியங்கி பயன்படுத்தப்படுகின்றன.",
    "Active additions and deductions are applied automatically to new payroll runs.": "ஆக்டிவ் அதிகப்படிகள் மற்றும் குறைப்புகள் புதிய நோமினா ஓட்டங்களுக்கு தானியங்கி பயன்படுத்தப்படுகின்றன.",
    "payroll.empty.categories": "உள்ள செலவு பிரிவுகள் இல்லை.",
    "No expense categories yet.": "உள்ள செலவு பிரிவுகள் இல்லை.",
    "payroll.empty.claims": "உள்ள செலவு கோரிக்கைகள் இல்லை.",
    "No expense claims yet.": "உள்ள செலவு கோரிக்கைகள் இல்லை.",
    "payroll.empty.components": "முன்னதாக அமைக்கப்பட்ட சம்பள பாகங்கள் இல்லை.",
    "No pay components configured yet.": "முன்னதாக அமைக்கப்பட்ட சம்பள பாகங்கள் இல்லை.",
    "payroll.empty.runs": "நோமினா ஓட்டங்கள் இல்லை.",
    "No payroll runs yet.": "நோமினா ஓட்டங்கள் இல்லை.",
    "payroll.field.staff": "பணியாளர்கள்",
    "payroll.field.base_pay": "அடிப்படை சம்பளம்",
    "Base pay": "அடிப்படை சம்பளம்",
    "payroll.field.allowances": "அனுமதிகள்",
    "Allowances": "அனுமதிகள்",
    "payroll.field.deductions": "குறைப்புகள்",
    "Deductions": "குறைப்புகள்",
    "payroll.field.commission": "கமிஷன்",
    "payroll.field.net_pay": "குறைக்கப்பட்ட சம்பளம்",
    "Net pay": "குறைக்கப்பட்ட சம்பளம்",
    "payroll.field.components": "பாகங்கள்",
    "Components": "பாகங்கள்",
    "payroll.field.commission_override": "கமிஷனை மாற்று",
    "Commission override": "கமிஷனை மாற்று",
    "payroll.field.calculation": "கணக்கீடு",
    "Calculation": "கணக்கீடு",
    "payroll.field.applies_to": "பயன்படுத்தப்படும்",
    "Applies to": "பயன்படுத்தப்படும்",
    "payroll.field.staff_optional_draft": "பணியாளர்கள் (முன்னோட்டத்தில் தேர்வு செய்யலாம்)",
    "payroll.field.category_optional_draft": "பிரிவு (முன்னோட்டத்தில் தேர்வு செய்யலாம்)",
    "payroll.field.category": "பிரிவு",
    "payroll.field.period": "காலம்",
    "payroll.field.period_start": "கால கட்டத்தின் தொடக்கம்",
    "Period start": "கால கட்டத்தின் தொடக்கம்",
    "payroll.field.period_end": "கால கட்டத்தின் முடிவு",
    "Period end": "கால கட்டத்தின் முடிவு",
    "payroll.field.generate_email_payslips": "பெய்ஸ்லிப்ஸை மின்னஞ்சலில் அனுப்ப உருவாக்கவும்",
    "Generate and email payslips": "பெய்ஸ்லிப்ஸை மின்னஞ்சலில் அனுப்ப உருவாக்கவும்",
    "payroll.field.gl_code": "GL குறியீடு",
    "GL code": "GL குறியீடு",
    "payroll.field.maximum_per_claim": "கோரிக்கைக்கு அதிகபட்சம்",
    "Maximum per claim": "கோரிக்கைக்கு அதிகபட்சம்",
    "payroll.field.maximum_per_transaction": "மாற்றத்திற்கு அதிகபட்சம்",
    "Maximum per transaction": "மாற்றத்திற்கு அதிகபட்சம்",
    "payroll.field.spending_cap": "செலவு வரம்பு",
    "Spending cap": "செலவு வரம்பு",
    "payroll.field.tax_rate": "வரி விகிதம் (%)",
    "Tax rate (%)": "வரி விகிதம் (%)",
    "payroll.field.no_limit": "வரம்பில்லாமல்",
    "No limit": "வரம்பில்லாமல்",
    "payroll.form.run.title": "புதிய ஊதிய இயக்கம்",
    "payroll.form.run.description": "தேர்ந்தெடுக்கப்பட்ட காலக்கெடுவிற்கு பணியாளர்களின் ஊதிய படிகளிலிருந்து கொடுக்கப்படும் பணம் கணக்கிடப்படுகிறது.",
    "Pay is calculated from staff pay grades for the selected period.": "தேர்ந்தெடுக்கப்பட்ட காலக்கெடுவிற்கு பணியாளர்களின் ஊதிய படிகளிலிருந்து கொடுக்கப்படும் பணம் கணக்கிடப்படுகிறது.",
    "payroll.form.component.title": "ஊதிய கூறு சேர்க்கவும்",
    "payroll.form.component.description": "இந்த கூறுகள் எதிர்கால ஊதிய இயக்கங்களில் தானியங்கியாக சேர்க்கப்படும்.",
    "Components are automatically included in future payroll runs.": "இந்த கூறுகள் எதிர்கால ஊதிய இயக்கங்களில் தானியங்கியாக சேர்க்கப்படும்.",
    "payroll.form.claim.title": "புதிய செலவு கோரிக்கை",
    "payroll.form.claim.description": "செலவு கோரிக்கைகள் அனுப்பப்பட்டு ஒப்புக்கொள்ளப்படும் வரை தொடக்க தொகுப்புகளாக தொடங்குகின்றன.",
    "Claims start as drafts until submitted for approval.": "செலவு கோரிக்கைகள் அனுப்பப்பட்டு ஒப்புக்கொள்ளப்படும் வரை தொடக்க தொகுப்புகளாக தொடங்குகின்றன.",
    "payroll.form.category.add": "செலவு வகையைச் சேர்க்கவும்",
    "Add expense category": "செலவு வகையைச் சேர்க்கவும்",
    "payroll.form.category.edit": "செலவு வகையை தொகுத்துக்கொள்ளவும்",
    "Edit expense category": "செலவு வகையை தொகுத்துக்கொள்ளவும்",
    "payroll.form.claim.approve_title": "செலவு கோரிக்கையை ஒப்புக்கொள்ளவும்",
    "Approve expense claim": "செலவு கோரிக்கையை ஒப்புக்கொள்ளவும்",
    "payroll.form.run.approve_title": "ஊதிய இயக்கத்தை ஒப்புக்கொள்ளவும்",
    "Approve payroll run": "ஊதிய இயக்கத்தை ஒப்புக்கொள்ளவும்",
    "payroll.form.run.approve_description": "ஒப்புக்கொள்ளப்பட்ட ஊதிய இயக்கம் முடக்கப்படும். நீங்கள் இப்போது ஊதிய விவரக்குறிப்புகளை உருவாக்கி மின்னஞ்சல் மூலம் அனுப்பலாம்.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "ஒப்புக்கொள்ளப்பட்ட ஊதிய இயக்கம் முடக்கப்படும். நீங்கள் இப்போது ஊதிய விவரக்குறிப்புகளை உருவாக்கி மின்னஞ்சல் மூலம் அனுப்பலாம்.",
    "payroll.items.title": "பணியாளர் ஊதிய ஐடம்கள்",
    "Staff payroll items": "பணியாளர் ஊதிய ஐடம்கள்",
    "payroll.items.loading": "ஊதிய ஐடம்களை ஏற்றுகிறது…",
    "Loading payroll items…": "ஊதிய ஐடம்களை ஏற்றுகிறது…",
    "payroll.items.empty": "ஊதிய ஐடம்கள் கிடைக்கவில்லை.",
    "No payroll items found.": "ஊதிய ஐடம்கள் கிடைக்கவில்லை.",
    "payroll.items.adjust_title": "ஊதிய ஐடம்மை திருத்தவும்",
    "Adjust payroll item": "ஊதிய ஐடம்மை திருத்தவும்",
    "payroll.items.adjust_description": "இந்த பணியாளருக்கான கழிவுகளை திருத்தவோ அல்லது கமிஷன் தொகையை மாற்றவோ செய்யலாம்.",
    "Update deductions or override the commission amount for this staff member.": "இந்த பணியாளருக்கான கழிவுகளை திருத்தவோ அல்லது கமிஷன் தொகையை மாற்றவோ செய்யலாம்.",
    "payroll.payslips.title": "ஊதிய விவரக்குறிப்புகள்",
    "Payslips": "ஊதிய விவரக்குறிப்புகள்",
    "payroll.payslips.generate": "ஊதிய விவரக்குறிப்புகளை உருவாக்கவும்",
    "Generate payslips": "ஊதிய விவரக்குறிப்புகளை உருவாக்கவும்",
    "payroll.payslips.generating": "உருவாக்கப்படுகிறது…",
    "Generating…": "உருவாக்கப்படுகிறது…",
    "payroll.payslips.empty": "முன்னதாக ஏதும் பெய்ஸ்லிப்ஸ் உருவாக்கப்படவில்லை.",
    "No payslips generated yet.": "முன்னதாக ஏதும் பெய்ஸ்லிப்ஸ் உருவாக்கப்படவில்லை.",
    "payroll.payslips.generated": "உருவாக்கப்பட்டது",
    "Generated": "உருவாக்கப்பட்டது",
    "payroll.payslips.sent_at": "அனுப்பப்பட்டது {date}",
    "Sent {date}": "அனுப்பப்பட்டது {date}",
    "payroll.payslips.not_sent": "அனுப்பப்படவில்லை",
    "Not sent": "அனுப்பப்படவில்லை",
    "payroll.payslips.send_email": "மின்னஞ்சல் அனுப்பு",
    "Send email": "மின்னஞ்சல் அனுப்பு",
    "payroll.payslips.sending": "அனுப்பும்…",
    "payroll.payslips.details": "பெய்ஸ்லிப் விவரங்கள்",
    "Payslip details": "பெய்ஸ்லிப் விவரங்கள்",
    "payroll.placeholder.approval_note": "ஒப்புக்கொடுக்கப்பட்டது",
    "payroll.placeholder.category_name": "பயணம்",
    "Travel": "பயணம்",
    "payroll.placeholder.claim_description": "வாடிக்கையாளருக்கு விமானப்பயணம்",
    "Flight to client": "வாடிக்கையாளருக்கு விமானப்பயணம்",
    "payroll.placeholder.component_name": "போக்குவரத்து பாதுகாப்பு",
    "Transport Allowance": "போக்குவரத்து பாதுகாப்பு",
    "payroll.staff_number": "பணியாளர் #{id}",
    "Staff #{id}": "பணியாளர் #{id}",
    "payroll.toast.category_added": "செலவு பிரிவு சேர்க்கப்பட்டது",
    "Expense category added": "செலவு பிரிவு சேர்க்கப்பட்டது",
    "payroll.toast.category_archived": "செலவு பிரிவு கோப்பு சேமிக்கப்பட்டது",
    "Expense category archived": "செலவு பிரிவு கோப்பு சேமிக்கப்பட்டது",
    "payroll.toast.category_updated": "செலவு பிரிவு புதுப்பிக்கப்பட்டது",
    "Expense category updated": "செலவு பிரிவு புதுப்பிக்கப்பட்டது",
    "payroll.toast.claim_approved": "கோரிக்கை ஒப்புக்கொடுக்கப்பட்டது",
    "Claim approved": "கோரிக்கை ஒப்புக்கொடுக்கப்பட்டது",
    "payroll.toast.claim_created": "செலவு கோரிக்கை உருவாக்கப்பட்டது",
    "Expense claim created": "செலவு கோரிக்கை உருவாக்கப்பட்டது",
    "payroll.toast.claim_reimbursed": "கோரிக்கை மீள்வழங்கப்பட்டதாக குறிப்பிடப்பட்டது",
    "Claim marked as reimbursed": "கோரிக்கை மீள்வழங்கப்பட்டதாக குறிப்பிடப்பட்டது",
    "payroll.toast.claim_submitted": "கோரிக்கை அனுப்பப்பட்டது",
    "Claim submitted": "கோரிக்கை அனுப்பப்பட்டது",
    "payroll.toast.component_activated": "கூட்டு ஊதியம் செயல்படுத்தப்பட்டது",
    "Pay component activated": "கூட்டு ஊதியம் செயல்படுத்தப்பட்டது",
    "payroll.toast.component_created": "கூட்டு ஊதியம் உருவாக்கப்பட்டது",
    "Pay component created": "கூட்டு ஊதியம் உருவாக்கப்பட்டது",
    "payroll.toast.component_deactivated": "கூட்டு ஊதியம் நிறுத்தப்பட்டது",
    "Pay component deactivated": "கூட்டு ஊதியம் நிறுத்தப்பட்டது",
    "payroll.toast.item_updated": "ஊதிய பொருள் புதுப்பிக்கப்பட்டது",
    "Payroll item updated": "ஊதிய பொருள் புதுப்பிக்கப்பட்டது",
    "payroll.toast.payslip_email_sent": "பெய்ஸ்லிப் மின்னஞ்சல் அனுப்பப்பட்டது",
    "Payslip email sent": "பெய்ஸ்லிப் மின்னஞ்சல் அனுப்பப்பட்டது",
    "payroll.toast.payslips_generated": "மாதாந்திர பணம் உருவாக்கப்பட்டது",
    "Payslips generated": "மாதாந்திர பணம் உருவாக்கப்பட்டது",
    "payroll.toast.run_approved": "மாதாந்திர பணம் ஒப்புதல் பெற்றது",
    "Payroll run approved": "மாதாந்திர பணம் ஒப்புதல் பெற்றது",
    "payroll.toast.run_approved_payslips_queued": "மாதாந்திர பணம் ஒப்புதல் பெற்று மாதாந்திர பணம் கோடுகளில் உள்ளது",
    "Payroll approved and payslips queued": "மாதாந்திர பணம் ஒப்புதல் பெற்று மாதாந்திர பணம் கோடுகளில் உள்ளது",
    "payroll.toast.run_created": "மாதாந்திர பணம் உருவாக்கப்பட்டது",
    "payroll.toast.exported": "மாதாந்திர பணம் ஏற்றுமதி செய்யப்பட்டது",
    "Payroll exported": "மாதாந்திர பணம் ஏற்றுமதி செய்யப்பட்டது",
    "common.notes": "குறிப்புகள்",
    "expenses.title": "செலவுகள்",
    "expenses.action.add": "செலவை சேர்க்கவும்",
    "Add expense": "செலவை சேர்க்கவும்",
    "expenses.action.create": "செலவை உருவாக்கவும்",
    "Create expense": "செலவை உருவாக்கவும்",
    "expenses.action.submit": "அனுப்பு",
    "expenses.action.approve": "ஒப்புதல் செய்யுங்கள்",
    "expenses.action.reimburse": "மீள்வழங்கு",
    "expenses.action.pay": "செலுத்து",
    "expenses.action.lifecycle": "செலவு {action} செய்யப்பட்டது",
    "Expense {action}d": "செலவு {action} செய்யப்பட்டது",
    "expenses.type.claim": "கோரிக்கை",
    "Claim": "கோரிக்கை",
    "expenses.type.claims": "கோரிக்கைகள்",
    "Claims": "கோரிக்கைகள்",
    "expenses.type.bill": "கணக்கு",
    "Bill": "கணக்கு",
    "expenses.type.bills": "கணக்குகள்",
    "Bills": "கணக்குகள்",
    "expenses.filter.all_types": "எல்லா வகைகளும்",
    "All types": "எல்லா வகைகளும்",
    "expenses.filter.all_statuses": "எல்லா நிலைகளும்",
    "expenses.summary.title": "சுருக்கம்",
    "Summary": "சுருக்கம்",
    "expenses.summary.by_category": "கேட்டகாரியம் போல",
    "By category": "கேட்டகாரியம் போல",
    "expenses.summary.by_status": "நிலை போல",
    "By status": "நிலை போல",
    "expenses.summary.by_party": "மூலம் / பணியாளர்",
    "By supplier / staff": "மூலம் / பணியாளர்",
    "expenses.summary.heading": "மூலம் {group} சுருக்கம்",
    "Summary by {group}": "மூலம் {group} சுருக்கம்",
    "expenses.summary.group.category": "வகை",
    "category": "வகை",
    "expenses.summary.group.status": "நிலை",
    "status": "நிலை",
    "expenses.summary.group.party": "மூலம் / பணியாளர்",
    "supplier / staff": "மூலம் / பணியாளர்",
    "expenses.summary.empty": "கிடைக்காத சுருக்கம்.",
    "No summary available.": "கிடைக்காத சுருக்கம்.",
    "expenses.column.type": "வகை",
    "expenses.column.party": "பணியாளர் / மூலம்",
    "Staff / Supplier": "பணியாளர் / மூலம்",
    "expenses.column.status": "நிலை",
    "expenses.field.staff_optional": "பணியாளர் (மேம்படுத்தும் போது தேர்வு செய்யலாம்)",
    "expenses.field.supplier_optional": "மூலம் (மேம்படுத்தும் போது தேர்வு செய்யலாம்)",
    "Supplier (optional while drafting)": "மூலம் (மேம்படுத்தும் போது தேர்வு செய்யலாம்)",
    "expenses.field.category_optional": "வகை (மேம்படுத்தும் போது தேர்வு செய்யலாம்)",
    "expenses.field.amount": "தொகை",
    "expenses.field.currency": "நாணயம்",
    "expenses.field.description": "விவரம்",
    "expenses.field.due_date": "முடிவு தேதி",
    "Due date": "முடிவு தேதி",
    "expenses.field.receipt_url": "செலுத்தும் URL",
    "Receipt URL": "செலுத்தும் URL",
    "expenses.empty": "தேர்ந்தெடுக்கப்பட்ட தேர்வுகளுக்கு பொருத்தமான செலவுகள் கிடைக்கவில்லை.",
    "No expenses found for the selected filters.": "தேர்ந்தெடுக்கப்பட்ட தேர்வுகளுக்கு பொருத்தமான செலவுகள் கிடைக்கவில்லை.",
    "expenses.modal.edit": "செலவை திருத்து",
    "Edit expense": "செலவை திருத்து",
    "expenses.modal.add": "{type} சேர்க்க",
    "expenses.modal.bill_help": "இப்போது மேம்படுத்தும் போது மூலம் ஒதுக்கீடு செய்து அனுப்பவும்.",
    "Create the draft now and assign a supplier before submitting.": "இப்போது மேம்படுத்தும் போது மூலம் ஒதுக்கீடு செய்து அனுப்பவும்.",
    "expenses.modal.claim_help": "இப்போது மேம்படுத்தும் போது பணியாளர் ஒதுக்கீடு செய்து அனுப்பவும்.",
    "Create the draft now and assign a staff member before submitting.": "இப்போது மேம்படுத்தும் போது பணியாளர் ஒதுக்கீடு செய்து அனுப்பவும்.",
    "expenses.toast.updated": "செலவு புதுப்பிக்கப்பட்டது",
    "Expense updated": "செலவு புதுப்பிக்கப்பட்டது",
    "expenses.toast.created": "செலவு உருவாக்கப்பட்டது",
    "Expense created": "செலவு உருவாக்கப்பட்டது",
    "recurring_payments.title": "மீண்டும் வரும் பணம் செலுத்துதல்",
    "recurring_payments.action.add": "மீண்டும் செலுத்தும் பணம் சேர்க்கவும்",
    "Add recurring payment": "மீண்டும் செலுத்தும் பணம் சேர்க்கவும்",
    "recurring_payments.action.create": "மீண்டும் செலுத்தும் பணம் உருவாக்கவும்",
    "Create recurring payment": "மீண்டும் செலுத்தும் பணம் உருவாக்கவும்",
    "recurring_payments.action.pause": "நிறுத்து",
    "Pause": "நிறுத்து",
    "recurring_payments.action.resume": "தொடர்ந்து செலுத்து",
    "Resume": "தொடர்ந்து செலுத்து",
    "recurring_payments.action.remove": "அகற்று",
    "recurring_payments.description": "பொதுவான வழியில் வழங்குநர் செலுத்தும் பணத்தை தானியங்கி தொடங்கும் பணிகளை உருவாக்குகிறது.",
    "Automatically create draft expense bills for regular supplier payments.": "பொதுவான வழியில் வழங்குநர் செலுத்தும் பணத்தை தானியங்கி தொடங்கும் பணிகளை உருவாக்குகிறது.",
    "recurring_payments.field.name": "பெயர்",
    "recurring_payments.field.supplier": "வழங்குநர்",
    "recurring_payments.field.supplier_optional": "வழங்குநர் (தேவையில்லை)",
    "Supplier (optional)": "வழங்குநர் (தேவையில்லை)",
    "recurring_payments.field.frequency": "நிகழ்வு",
    "Frequency": "நிகழ்வு",
    "recurring_payments.field.next_due": "அடுத்த கட்டாய தேதி",
    "Next due date": "அடுத்த கட்டாய தேதி",
    "recurring_payments.field.auto_create": "தானியங்கி தொடங்கும் பணிகளை உருவாக்குதல்",
    "Auto-create draft bill": "தானியங்கி தொடங்கும் பணிகளை உருவாக்குதல்",
    "recurring_payments.field.auto_create_help": "தானியங்கி தொடங்கும் பணிகளை உருவாக்குதல்",
    "Create a draft expense bill automatically": "தானியங்கி தொடங்கும் பணிகளை உருவாக்குதல்",
    "recurring_payments.field.one_time": "ஒரு முறை செலுத்துதல்",
    "One-time payment": "ஒரு முறை செலுத்துதல்",
    "recurring_payments.field.one_time_help": "அடுத்த பணியை உருவாக்கிய பிறகு முடிக்கவும்",
    "End after the next generated bill": "அடுத்த பணியை உருவாக்கிய பிறகு முடிக்கவும்",
    "recurring_payments.field.end_date": "முடிவு தேதி",
    "recurring_payments.placeholder.name": "அலுவலக வாடகை",
    "Office Rent": "அலுவலக வாடகை",
    "recurring_payments.frequency.daily": "நாள்தோறும்",
    "recurring_payments.frequency.weekly": "வாராந்திரம்",
    "recurring_payments.frequency.monthly": "மாதாந்திரம்",
    "recurring_payments.frequency.quarterly": "மும்மாத தேதி",
    "recurring_payments.frequency.yearly": "ஆண்டுதோறும்",
    "Yearly": "ஆண்டுதோறும்",
    "recurring_payments.form.description": "ஆட்டோ உருவாக்கம் செய்யப்பட்டால், கடன் தேதி முடிந்த பிறகு செலுத்தும் பணம் தானியங்கி தொடங்கும் பணிகளை உருவாக்குகிறது.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "ஆட்டோ உருவாக்கம் செய்யப்பட்டால், கடன் தேதி முடிந்த பிறகு செலுத்தும் பணம் தானியங்கி தொடங்கும் பணிகளை உருவாக்குகிறது.",
    "recurring_payments.empty": "மீண்டும் செலுத்தும் பணம் இல்லை.",
    "No recurring payments yet.": "மீண்டும் செலுத்தும் பணம் இல்லை.",
    "recurring_payments.this_payment": "இந்த காலாண்டு செலுத்தும் பணம்",
    "this recurring payment": "இந்த காலாண்டு செலுத்தும் பணம்",
    "recurring_payments.confirm_remove": "{name} அகற்றப்படுமா?",
    "Remove {name}?": "{name} அகற்றப்படுமா?",
    "recurring_payments.toast.pause": "காலாண்டு செலுத்தும் பணம் நிறுத்தப்பட்டது",
    "Recurring payment paused": "காலாண்டு செலுத்தும் பணம் நிறுத்தப்பட்டது",
    "recurring_payments.toast.resume": "காலாண்டு செலுத்தும் பணம் மீண்டும் தொடங்கப்பட்டது",
    "Recurring payment resumed": "காலாண்டு செலுத்தும் பணம் மீண்டும் தொடங்கப்பட்டது",
    "recurring_payments.toast.delete": "காலாண்டு செலுத்தும் பணம் அகற்றப்பட்டது",
    "Recurring payment removed": "காலாண்டு செலுத்தும் பணம் அகற்றப்பட்டது",
    "recurring_payments.toast.created": "காலாண்டு செலுத்தும் பணம் உருவாக்கப்பட்டது",
    "Recurring payment created": "காலாண்டு செலுத்தும் பணம் உருவாக்கப்பட்டது",
    "expenses.toast.submit": "செலவு சமர்பிக்கப்பட்டது",
    "expenses.toast.approve": "செலவு ஒப்புக்கொள்ளப்பட்டது",
    "Expense approved": "செலவு ஒப்புக்கொள்ளப்பட்டது",
    "expenses.toast.reimburse": "செலவு மீளப்பெற்றது",
    "Expense reimbursed": "செலவு மீளப்பெற்றது",
    "expenses.toast.pay": "செலவு செலுத்தப்பட்டது",
    "Expense paid": "செலவு செலுத்தப்பட்டது",
    "media_picker.title": "ஊடகங்களைத் தேர்வு செய்யவும்",
    "Select media": "ஊடகங்களைத் தேர்வு செய்யவும்",
    "media_picker.type.media": "ஊடகம்",
    "media_picker.type.all": "எல்லாம்",
    "media_picker.type.image": "படம்",
    "media_picker.type.video": "வீடியோ",
    "media_picker.type.audio": "ஆடியோ",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "பெட்டி",
    "media_picker.label.show": "காட்டு",
    "media_picker.label.media_type": "ஊடக வகை",
    "Media type": "ஊடக வகை",
    "media_picker.action.show_type": "{type} ஊடகங்களைக் காட்டு",
    "media_picker.action.close": "ஊடக தேர்வுக்கு மூடு",
    "Close media picker": "ஊடக தேர்வுக்கு மூடு",
    "media_picker.action.upload": "ஊடகத்தை பதிவேற்று",
    "media_picker.action.creating": "உருவாக்குகிறது…",
    "media_picker.action.create_folder": "கோப்புத்தொகுப்பை உருவாக்கு",
    "Create folder": "கோப்புத்தொகுப்பை உருவாக்கு",
    "media_picker.action.cancel": "ரத்து செய்யுங்கள்",
    "media_picker.action.use_selected": "தேர்ந்தெடுக்கப்பட்டவற்றைப் பயன்படுத்து",
    "Use selected": "தேர்ந்தெடுக்கப்பட்டவற்றைப் பயன்படுத்து",
    "media_picker.placeholder.search": "ஊடகங்களைத் தேடு",
    "media_picker.placeholder.folder": "புதிய கோப்புத்தொகுப்பு பெயர்",
    "New folder name": "புதிய கோப்புத்தொகுப்பு பெயர்",
    "media_picker.loading": "ஊடகங்களை ஏற்றுகிறது…",
    "media_picker.empty": "இந்த கோப்புத்தொகுப்பில் ஊடகங்கள் கிடைக்கவில்லை.",
    "No media found in this folder.": "இந்த கோப்புத்தொகுப்பில் ஊடகங்கள் கிடைக்கவில்லை.",
    "media_picker.selection.count": "{count} தேர்ந்தெடுக்கப்பட்டவை",
    "media_picker.selection.prompt": "தொடர ஒரு கோப்பைத் தேர்ந்தெடுக்கவும்",
    "Select a file to continue": "தொடர ஒரு கோப்பைத் தேர்ந்தெடுக்கவும்",
    "media_picker.error.load": "ஊடகத்தை ஏற்ற முடியவில்லை",
    "Unable to load media": "ஊடகத்தை ஏற்ற முடியவில்லை",
    "media_picker.error.load_retry": "ஊடகத்தை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "media_picker.error.create_folder": "கோப்புத்தொகுப்பை உருவாக்க முடியவில்லை",
    "media_picker.error.create_folder_retry": "கோப்புத்தொகுப்பை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to create folder. Please try again.": "கோப்புத்தொகுப்பை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "media_picker.error.prepare_upload": "பதிவேற்றத்தைத் தயாரிக்க முடியவில்லை",
    "Unable to prepare upload": "பதிவேற்றத்தைத் தயாரிக்க முடியவில்லை",
    "media_picker.error.upload_url": "பதிவேற்ற URL குறைவாக உள்ளது",
    "Upload URL missing": "பதிவேற்ற URL குறைவாக உள்ளது",
    "media_picker.error.register_media": "ஊடகத்தைப் பதிவு செய்ய முடியவில்லை",
    "media_picker.error.upload_retry": "ஊடகத்தை பதிவேற்றம் செய்ய முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "membership.title": "உறுப்பினர்",
    "membership.description": "உறுப்பினர் திட்டங்களை, உறுப்பினர் பங்களிப்புகளை, கட்டண நிலையை மற்றும் நினைவூட்டல் விதிமுறைகளை மேலாண்மை செய்யவும்.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "உறுப்பினர் திட்டங்களை, உறுப்பினர் பங்களிப்புகளை, கட்டண நிலையை மற்றும் நினைவூட்டல் விதிமுறைகளை மேலாண்மை செய்யவும்.",
    "membership.action.settings": "அமைப்புகள்",
    "membership.action.manage_programs": "திட்டங்களை மேலாண்மை செய்யவும்",
    "Manage programs": "திட்டங்களை மேலாண்மை செய்யவும்",
    "membership.action.view_data": "தரவுகளைப் பார்க்கவும்",
    "View data": "தரவுகளைப் பார்க்கவும்",
    "membership.action.edit_listing": "பட்டியலை தொகுத்துக்காட்டு",
    "membership.action.go_to_listings": "பட்டியல்களுக்கு செல்லவும்",
    "Go to listings": "பட்டியல்களுக்கு செல்லவும்",
    "membership.action.view_order": "ஆர்டரைப் பார்க்கவும்",
    "View order": "ஆர்டரைப் பார்க்கவும்",
    "membership.action.configure_reminders": "மீண்டும் நினைவூட்டல்களை அமைக்கவும்",
    "Configure reminders": "மீண்டும் நினைவூட்டல்களை அமைக்கவும்",
    "membership.stat.programs": "திட்டங்கள்",
    "membership.stat.active_members": "செயல்பாட்டு உறுப்பினர்கள்",
    "Active members": "செயல்பாட்டு உறுப்பினர்கள்",
    "membership.stat.contributions": "பங்களிப்புகள்",
    "Contributions": "பங்களிப்புகள்",
    "membership.stat.units": "கிடைத்த அலகுகள்",
    "Units credited": "கிடைத்த அலகுகள்",
    "membership.programs.title": "திட்டங்கள்",
    "membership.programs.description": "உங்கள் வாடிக்கையாளர்களுக்கு கிடைக்கும் உறுப்பினர் வகை பட்டியல்கள்.",
    "Membership-type listings available to your customers.": "உங்கள் வாடிக்கையாளர்களுக்கு கிடைக்கும் உறுப்பினர் வகை பட்டியல்கள்.",
    "membership.programs.no_description": "இதுவரை திட்ட விவரம் இல்லை.",
    "No program description yet.": "இதுவரை திட்ட விவரம் இல்லை.",
    "membership.programs.empty_title": "உறுப்பினர் திட்டங்கள் இல்லை",
    "No membership programs yet": "உறுப்பினர் திட்டங்கள் இல்லை",
    "membership.programs.empty_description": "பங்களிப்புகளை ஏற்றுக்கொள்ள தொடங்க, உறுப்பினர் வகையில் பட்டியலை உருவாக்கவும்.",
    "Create a listing with type membership to start accepting contributions.": "பங்களிப்புகளை ஏற்றுக்கொள்ள தொடங்க, உறுப்பினர் வகையில் பட்டியலை உருவாக்கவும்.",
    "membership.programs.history_description": "விலை வரலாறு மற்றும் பதிவு செய்த உறுப்பினர்கள்.",
    "Price history and enrolled members.": "விலை வரலாறு மற்றும் பதிவு செய்த உறுப்பினர்கள்.",
    "membership.badge": "உறுப்பினர்",
    "membership.loading_program": "திட்ட தகவல்களை ஏற்றுகிறது…",
    "Loading program data…": "திட்ட தகவல்களை ஏற்றுகிறது…",
    "membership.price_logs.title": "விலை பதிவுகள்",
    "Price logs": "விலை பதிவுகள்",
    "membership.price_logs.empty": "விலை பதிவுகள் இல்லை.",
    "No price logs recorded.": "விலை பதிவுகள் இல்லை.",
    "membership.source.manual": "கையேடு",
    "manual": "கையேடு",
    "membership.members.title": "உறுப்பினர்கள்",
    "Members": "உறுப்பினர்கள்",
    "membership.members.empty_program": "இந்த திட்டத்தில் பதிவு செய்த உறுப்பினர்கள் இல்லை.",
    "No members enrolled in this program.": "இந்த திட்டத்தில் பதிவு செய்த உறுப்பினர்கள் இல்லை.",
    "membership.members.recent": "சமீபத்திய உறுப்பினர்கள்",
    "Recent members": "சமீபத்திய உறுப்பினர்கள்",
    "membership.members.empty_recent": "பதிவு செய்த பிறகு, உறுப்பினர்கள் மற்றும் பங்களிப்புகள் இங்கு தோன்றும்.",
    "Members and contributions will appear here after enrolment.": "பதிவு செய்த பிறகு, உறுப்பினர்கள் மற்றும் பங்களிப்புகள் இங்கு தோன்றும்.",
    "membership.member_heading": "உறுப்பினர்: {member}",
    "Member: {member}": "உறுப்பினர்: {member}",
    "membership.contributions.title": "பங்களிப்புகள்",
    "membership.contributions.empty": "இதுவரை பங்களிப்புகள் பதிவு செய்யப்படவில்லை.",
    "No contributions recorded yet.": "இதுவரை பங்களிப்புகள் பதிவு செய்யப்படவில்லை.",
    "membership.payment_dues.title": "கட்டண கடமைகள்",
    "Payment dues": "கட்டண கடமைகள்",
    "membership.payment_dues.empty": "திட்டமிடப்பட்ட கட்டண கடமைகள் இல்லை.",
    "No scheduled payment dues.": "திட்டமிடப்பட்ட கட்டண கடமைகள் இல்லை.",
    "membership.unit": "அலகு",
    "unit": "அலகு",
    "membership.units": "அலகுகள்",
    "units": "அலகுகள்",
    "membership.months": "மாதங்கள்",
    "membership.automation.label": "தானியங்கி",
    "AUTOMATION": "தானியங்கி",
    "membership.automation.description": "தினசரி தொழிலாளர் உறுப்பினர் கட்டண கடமைகளை சரிபார்க்கிறார்.",
    "Daily worker checks scheduled membership payments.": "தினசரி தொழிலாளர் உறுப்பினர் கட்டண கடமைகளை சரிபார்க்கிறார்.",
    "membership.reminders.title": "கட்டண நினைவுகூரல்கள்",
    "Payment reminders": "கட்டண நினைவுகூரல்கள்",
    "membership.reminders.due_soon": "முடிவுகாலம் அருகில் நினைவுகூரல்",
    "Due-soon reminder": "முடிவுகாலம் அருகில் நினைவுகூரல்",
    "membership.reminders.due_soon_short": "முடிவுகாலம் அருகில்",
    "Due soon": "முடிவுகாலம் அருகில்",
    "membership.reminders.due_soon_help": "திட்டமிடப்பட்ட கட்டணம் முடிவுகாலம் அடையும் முன் நினைவுகூரல் அனுப்பவும்.",
    "Send one reminder before a scheduled payment is due.": "திட்டமிடப்பட்ட கட்டணம் முடிவுகாலம் அடையும் முன் நினைவுகூரல் அனுப்பவும்.",
    "membership.reminders.days_before": "முடிவுகாலம் தேதிக்கு முன் நாட்கள்",
    "Days before due date": "முடிவுகாலம் தேதிக்கு முன் நாட்கள்",
    "membership.reminders.days_before_value": "{count} நாட்களுக்கு முன்",
    "{count} days before": "{count} நாட்களுக்கு முன்",
    "membership.reminders.overdue": "முடிவுகாலம் நினைவுகூரல்",
    "Overdue reminder": "முடிவுகாலம் நினைவுகூரல்",
    "membership.reminders.overdue_help": "முடிவுகாலம் தேதி மற்றும் கால கட்டத்திற்குப் பிறகு நினைவுகூரல் அனுப்பவும்.",
    "Send one reminder after the due date and grace period.": "முடிவுகாலம் தேதி மற்றும் கால கட்டத்திற்குப் பிறகு நினைவுகூரல் அனுப்பவும்.",
    "membership.settings.title": "உறுப்பினர் அமைப்புகள்",
    "Membership settings": "உறுப்பினர் அமைப்புகள்",
    "membership.settings.description": "கட்டண நினைவுகூரல்களின் நேரம் அமைக்கவும்.",
    "Configure the payment reminder schedule.": "கட்டண நினைவுகூரல்களின் நேரம் அமைக்கவும்.",
    "membership.email_copy.title": "தனிப்பயன் மின்னஞ்சல் நகல்",
    "Custom email copy": "தனிப்பயன் மின்னஞ்சல் நகல்",
    "membership.email_copy.description": "முடிவுகாலம் அருகில் மற்றும் முடிவுகாலம் கடந்த தலைப்புகள் மற்றும் மாதிரிகளை திருத்த, அமைப்புகள் → அறிவிப்புகள் → உறுப்பினர் என பயன்படுத்தவும்.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "முடிவுகாலம் அருகில் மற்றும் முடிவுகாலம் கடந்த தலைப்புகள் மற்றும் மாதிரிகளை திருத்த, அமைப்புகள் → அறிவிப்புகள் → உறுப்பினர் என பயன்படுத்தவும்.",
    "membership.toast.saved": "உறுப்பினர் நினைவுகூரல் அமைப்புகள் சேமிக்கப்பட்டுள்ளது.",
    "Membership reminder settings saved.": "உறுப்பினர் நினைவுகூரல் அமைப்புகள் சேமிக்கப்பட்டுள்ளது.",
    "membership.toast.save_failed": "உறுப்பினர் நினைவுகூரல் அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Unable to save membership reminder settings.": "உறுப்பினர் நினைவுகூரல் அமைப்புகளை சேமிக்க முடியவில்லை.",
    "common.status.off": "முடக்கப்பட்டுள்ளது",
    "Off": "முடக்கப்பட்டுள்ளது",
    "common.status.on": "ஆனது",
    "On": "ஆனது",
    "common.save_settings": "அமைப்புகளை சேமி",
    "Save settings": "அமைப்புகளை சேமி",
    "developer.page.title": "API மற்றும் மேம்படுத்தலாளர்",
    "API & Developer": "API மற்றும் மேம்படுத்தலாளர்",
    "developer.api_keys.title": "API கீல்கள்",
    "API Keys": "API கீல்கள்",
    "developer.api_keys.description": "Tradly API ஐ பயன்படுத்தி கோரிக்கைகளை உறுதிப்படுத்த இந்த கீல்களைப் பயன்படுத்தவும். உங்கள் ரகசிய கீலை தனியார் முறையில் வைத்திருங்கள் — கிளயண்ட் பக்க குறியீட்டில் அதை வெளிப்படுத்த வேண்டாம்.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Tradly API ஐ பயன்படுத்தி கோரிக்கைகளை உறுதிப்படுத்த இந்த கீல்களைப் பயன்படுத்தவும். உங்கள் ரகசிய கீலை தனியார் முறையில் வைத்திருங்கள் — கிளயண்ட் பக்க குறியீட்டில் அதை வெளிப்படுத்த வேண்டாம்.",
    "developer.api_keys.credentials_description": "உங்கள் உற்பத்தி கீல்களை கீழே காணலாம். உங்கள் பயன்பாடுகளை அனுமதிக்கவும் உருவாக்கவும் இந்த கீல்களைப் பயன்படுத்த வேண்டும்.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "உங்கள் உற்பத்தி கீல்களை கீழே காணலாம். உங்கள் பயன்பாடுகளை அனுமதிக்கவும் உருவாக்கவும் இந்த கீல்களைப் பயன்படுத்த வேண்டும்.",
    "developer.api_keys.publishable": "பொது கீல்",
    "Publishable Key": "பொது கீல்",
    "developer.api_keys.publishable_placeholder": "பொது கீலை உள்ளிடவும்",
    "Enter Publishable Key": "பொது கீலை உள்ளிடவும்",
    "developer.api_keys.secret": "ரகசிய கீல்",
    "developer.api_keys.secret_placeholder": "ரகசிய கீலை உள்ளிடவும்",
    "Enter Secret Key": "ரகசிய கீலை உள்ளிடவும்",
    "developer.api_keys.access_label": "API அணுகுமுறை",
    "API access": "API அணுகுமுறை",
    "developer.api_reference.title": "API குறிப்பு",
    "developer.api_reference.description": "Tradly சந்தையின் மேல் கட்டமைக்க முழுமையான REST API ஆவணம், குறிப்புகள் மற்றும் குறியீடு எடுத்துக்காட்டுகள்.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Tradly சந்தையின் மேல் கட்டமைக்க முழுமையான REST API ஆவணம், குறிப்புகள் மற்றும் குறியீடு எடுத்துக்காட்டுகள்.",
    "developer.api_reference.card_description": "முழுமையான API குறிப்பு, அடையாளம் காட்டும் வழிமுறைகள், webhooks மற்றும் SDK ஆவணம் அனைத்தையும் ஆராயவும். உங்கள் சந்தையின் மேல் ஒருங்கிணைப்பு அல்லது தனிப்பயன் முனையங்களை உருவாக்க உங்களுக்கு தேவையான அனைத்தும்.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "முழுமையான API குறிப்பு, அடையாளம் காட்டும் வழிமுறைகள், webhooks மற்றும் SDK ஆவணம் அனைத்தையும் ஆராயவும். உங்கள் சந்தையின் மேல் ஒருங்கிணைப்பு அல்லது தனிப்பயன் முனையங்களை உருவாக்க உங்களுக்கு தேவையான அனைத்தும்.",
    "developer.api_reference.open_docs": "API ஆவணத்தைத் திறக்கவும்",
    "Open API Docs": "API ஆவணத்தைத் திறக்கவும்",
    "developer.ai_agents.title": "AI மற்றும் ஏஜென்ட்கள்",
    "AI & Agents": "AI மற்றும் ஏஜென்ட்கள்",
    "developer.ai_agents.description": "உங்கள் சந்தையை AI கருவிகளுடன் இணைக்கவும் மற்றும் உங்கள் தளத்தின் அடிப்படையில் வாடிக்கையாளர்கள் ஏஜென்ட்களை உருவாக்க அனுமதிக்கவும்.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "உங்கள் சந்தையை AI கருவிகளுடன் இணைக்கவும் மற்றும் உங்கள் தளத்தின் அடிப்படையில் வாடிக்கையாளர்கள் ஏஜென்ட்களை உருவாக்க அனுமதிக்கவும்.",
    "developer.mcp.action.create": "உருவாக்கு",
    "developer.mcp.action.removing": "அகற்றப்படுகிறது…",
    "developer.mcp.scope.resource": "மூலம்",
    "developer.customer_agents.description": "உங்கள் சந்தையுடன் இணைந்து வாடிக்கையாளர்கள் AI ஏஜென்ட்களை உருவாக்க அனுமதிக்கவும். ChatGPT, Claude மற்றும் பிற AI தளங்களுடன் பொருந்தக்கூடியது. வாங்கும் பணிகளை தானியங்கி செய்ய, தனிப்பயன் கடைகளை உருவாக்க, அல்லது திறமையான வாங்கும் உதவியாளர்களை உருவாக்க சிறந்தது.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "உங்கள் சந்தையுடன் இணைந்து வாடிக்கையாளர்கள் AI ஏஜென்ட்களை உருவாக்க அனுமதிக்கவும். ChatGPT, Claude மற்றும் பிற AI தளங்களுடன் பொருந்தக்கூடியது. வாங்கும் பணிகளை தானியங்கி செய்ய, தனிப்பயன் கடைகளை உருவாக்க, அல்லது திறமையான வாங்கும் உதவியாளர்களை உருவாக்க சிறந்தது.",
    "whatsapp.title": "WhatsApp இணைப்பு",
    "WhatsApp connector": "WhatsApp இணைப்பு",
    "whatsapp.intro.title": "WhatsApp மூலம் OTP மற்றும் பரிமாற்ற செய்திகளை அனுப்பவும்",
    "Send OTPs and marketing messages through WhatsApp": "WhatsApp மூலம் OTP மற்றும் பரிமாற்ற செய்திகளை அனுப்பவும்",
    "whatsapp.intro.help": "இந்த குடியிருப்பை Meta WhatsApp Cloud API உடன் இணைக்கவும். SMS தொடர்ந்து தொடக்க அல்லது பிரதான சேனலாக இருக்கும், மேலும் அதே இணைப்பு WhatsApp அங்கீகரிக்கப்பட்ட பிரச்சார மாதிரிகளை அனுப்ப முடியும்.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "இந்த குடியிருப்பை Meta WhatsApp Cloud API உடன் இணைக்கவும். SMS தொடர்ந்து தொடக்க அல்லது பிரதான சேனலாக இருக்கும், மேலும் அதே இணைப்பு WhatsApp அங்கீகரிக்கப்பட்ட பிரச்சார மாதிரிகளை அனுப்ப முடியும்.",
    "whatsapp.status.disabled": "முடக்கப்பட்டுள்ளது",
    "whatsapp.status.sms_otp": "கனெக்டர் ஆன் · SMS OTP",
    "Connector on · SMS OTP": "கனெக்டர் ஆன் · SMS OTP",
    "whatsapp.status.needs_configuration": "கனிஃபிக்கேஷன் தேவை",
    "Needs configuration": "கனிஃபிக்கேஷன் தேவை",
    "whatsapp.status.auto_fallback": "WhatsApp SMS பெயர்ச்சி",
    "WhatsApp with SMS fallback": "WhatsApp SMS பெயர்ச்சி",
    "whatsapp.status.sms_whatsapp_backup": "WhatsApp காப்புடன் SMS",
    "SMS with WhatsApp backup": "WhatsApp காப்புடன் SMS",
    "whatsapp.status.enabled": "WhatsApp ஆன்",
    "WhatsApp enabled": "WhatsApp ஆன்",
    "whatsapp.draft.notice": "உங்களிடம் WhatsApp அமைப்புகள் சேமிக்கப்படாத தொடக்க பதிவு உள்ளது.",
    "You have an unsaved WhatsApp settings draft.": "உங்களிடம் WhatsApp அமைப்புகள் சேமிக்கப்படாத தொடக்க பதிவு உள்ளது.",
    "whatsapp.connect.title": "உங்கள் வணிக WhatsApp-ஐ இணைக்கவும்",
    "Connect your business WhatsApp": "உங்கள் வணிக WhatsApp-ஐ இணைக்கவும்",
    "whatsapp.connect.description": "உங்கள் வாடிக்கையாளர்கள் அறிந்திருக்கும் வணிக எண்ணை உள்ளிடவும். Meta பாதுகாப்பான உறுதிப்பாடு சாளரத்தைத் திறக்கும்; WABA ID, தொலைபேசி எண் ID, அணுகுமுறை டோக்கன் அல்லது API அமைப்பு தேட தேவையில்லை.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "உங்கள் வாடிக்கையாளர்கள் அறிந்திருக்கும் வணிக எண்ணை உள்ளிடவும். Meta பாதுகாப்பான உறுதிப்பாடு சாளரத்தைத் திறக்கும்; WABA ID, தொலைபேசி எண் ID, அணுகுமுறை டோக்கன் அல்லது API அமைப்பு தேட தேவையில்லை.",
    "whatsapp.field.business_number": "வணிக WhatsApp எண்",
    "Business WhatsApp number": "வணிக WhatsApp எண்",
    "whatsapp.field.business_number_help": "உங்கள் வாடிக்கையாளர்கள் அனுப்பும் எண்ணை நாட்டு குறியீடுடன் பயன்படுத்தவும்.",
    "Use the number you want customers to message, including country code.": "உங்கள் வாடிக்கையாளர்கள் அனுப்பும் எண்ணை நாட்டு குறியீடுடன் பயன்படுத்தவும்.",
    "whatsapp.placeholder.business_number": "எ.கா. +60 13 333 1671",
    "e.g. +60 13 333 1671": "எ.கா. +60 13 333 1671",
    "whatsapp.field.connection_name": "இணைப்பு பெயர்",
    "whatsapp.field.connection_name_help": "குலாலம்பூர், மின்னிய பிராண்ட் அல்லது ஆதரவு போன்ற தெளிவான பெயரைப் பயன்படுத்தவும்.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "குலாலம்பூர், மின்னிய பிராண்ட் அல்லது ஆதரவு போன்ற தெளிவான பெயரைப் பயன்படுத்தவும்.",
    "whatsapp.placeholder.connection_name": "எ.கா. குலாலம்பூர் ஆதரவு",
    "e.g. Kuala Lumpur support": "எ.கா. குலாலம்பூர் ஆதரவு",
    "whatsapp.field.optional_details": "கூடுதல் இணைப்பு விவரங்கள்",
    "Optional connection details": "கூடுதல் இணைப்பு விவரங்கள்",
    "whatsapp.field.optional_details_help": "இந்த எண் குறிப்பிட்ட பிராண்ட், கணக்கு அல்லது கிளைக்கு சேர்ந்திருக்கும்போது மட்டுமே பயன்படுத்தவும்.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "இந்த எண் குறிப்பிட்ட பிராண்ட், கணக்கு அல்லது கிளைக்கு சேர்ந்திருக்கும்போது மட்டுமே பயன்படுத்தவும்.",
    "whatsapp.field.brand_key": "பிராண்ட் கீ",
    "Brand key": "பிராண்ட் கீ",
    "whatsapp.field.brand_key_help": "மின்னிய அல்லது பெரிய அளவில் பிராண்டுக்கான நிலையான உள் கீ.",
    "Stable internal key for a brand, such as retail or wholesale.": "மின்னிய அல்லது பெரிய அளவில் பிராண்டுக்கான நிலையான உள் கீ.",
    "whatsapp.placeholder.brand_key": "எ.கா. மின்னிய",
    "e.g. retail": "எ.கா. மின்னிய",
    "whatsapp.field.account_id": "கணக்கு ID",
    "whatsapp.field.account_id_help": "இந்த எண்ணை இருக்கும் Tradly கணக்குடன் இணைக்கவும்.",
    "Associate this number with an existing Tradly account.": "இந்த எண்ணை இருக்கும் Tradly கணக்குடன் இணைக்கவும்.",
    "whatsapp.placeholder.account_id": "எ.கா. 123",
    "e.g. 123": "எ.கா. 123",
    "whatsapp.field.branch_id": "கிளை ID",
    "Branch ID": "கிளை ID",
    "whatsapp.field.branch_id_help": "இந்த எண்ணை இருக்கும் Tradly கிளையுடன் இணைக்கவும்.",
    "Associate this number with an existing Tradly branch.": "இந்த எண்ணை இருக்கும் Tradly கிளையுடன் இணைக்கவும்.",
    "whatsapp.placeholder.branch_id": "எ.கா. 456",
    "e.g. 456": "எ.கா. 456",
    "whatsapp.field.default_connection": "முன்னேற்ற இணைப்பாக பயன்படுத்தவும்",
    "Use as default connection": "முன்னேற்ற இணைப்பாக பயன்படுத்தவும்",
    "whatsapp.field.default_connection_help": "பழைய OTP பாதைகள் கிளை-குறிப்பிட்ட இணைப்பு தேர்வு செய்யப்படாதபோது, தேர்ந்தெடுக்கப்பட்ட முன்னேற்ற இணைப்பைப் பயன்படுத்துகின்றன.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "பழைய OTP பாதைகள் கிளை-குறிப்பிட்ட இணைப்பு தேர்வு செய்யப்படாதபோது, தேர்ந்தெடுக்கப்பட்ட முன்னேற்ற இணைப்பைப் பயன்படுத்துகின்றன.",
    "whatsapp.field.uses_business_app": "இந்த எண்ணில் WhatsApp Business செயலியைப் பயன்படுத்துகிறேன்",
    "I use the WhatsApp Business app on this number": "இந்த எண்ணில் WhatsApp Business செயலியைப் பயன்படுத்துகிறேன்",
    "whatsapp.field.uses_business_app_help": "உங்கள் தொலைபேசியில் உள்ள WhatsApp Business செயலியில் தொடர்ந்து உரையாடலாம். செயலியிலிருந்து QR குறியீட்டை ஸ்கேன் செய்ய Meta கேட்கும்; உங்கள் தொடர்புகளும் சமீபத்திய உரையாடல்களும் ஒத்திசைக்கப்படும். பதிப்பு 2.24.17 அல்லது அதற்குப் பிந்தையது தேவை.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "உங்கள் தொலைபேசியில் உள்ள WhatsApp Business செயலியில் தொடர்ந்து உரையாடலாம். செயலியிலிருந்து QR குறியீட்டை ஸ்கேன் செய்ய Meta கேட்கும்; உங்கள் தொடர்புகளும் சமீபத்திய உரையாடல்களும் ஒத்திசைக்கப்படும். பதிப்பு 2.24.17 அல்லது அதற்குப் பிந்தையது தேவை.",
    "whatsapp.connected.business_account": "WhatsApp வணிக கணக்கு",
    "WhatsApp business account": "WhatsApp வணிக கணக்கு",
    "whatsapp.connected.template_ready": "அங்கீகார மாதிரி தயார் · தானியங்கி OTP WhatsApp-ஐப் பயன்படுத்தலாம்.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "அங்கீகார மாதிரி தயார் · தானியங்கி OTP WhatsApp-ஐப் பயன்படுத்தலாம்.",
    "whatsapp.connected.template_pending": "இணைக்கப்பட்டுள்ளது · அங்கீகார மாதிரி அங்கீகரிக்கப்படும் வரை SMS பாதுகாப்பான பின்னடைவாக இருக்கும்.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "இணைக்கப்பட்டுள்ளது · அங்கீகார மாதிரி அங்கீகரிக்கப்படும் வரை SMS பாதுகாப்பான பின்னடைவாக இருக்கும்.",
    "whatsapp.action.connect": "WhatsApp-ஐ இணைக்கவும்",
    "Connect WhatsApp": "WhatsApp-ஐ இணைக்கவும்",
    "whatsapp.action.reconnect": "WhatsApp-ஐ மீண்டும் இணைக்கவும்",
    "Reconnect WhatsApp": "WhatsApp-ஐ மீண்டும் இணைக்கவும்",
    "whatsapp.connections.title": "இணைக்கப்பட்ட WhatsApp எண்கள்",
    "Connected WhatsApp numbers": "இணைக்கப்பட்ட WhatsApp எண்கள்",
    "whatsapp.connections.description": "ஒவ்வொரு எண்ணும் வேறுபட்ட பிராண்ட், கணக்கு அல்லது கிளைக்கு சேர்ந்திருக்கலாம். மாதிரிகளை செயல்படுத்துவதற்கு முன் ஒன்றைத் தேர்வு செய்யவும்.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "ஒவ்வொரு எண்ணும் வேறுபட்ட பிராண்ட், கணக்கு அல்லது கிளைக்கு சேர்ந்திருக்கலாம். மாதிரிகளை செயல்படுத்துவதற்கு முன் ஒன்றைத் தேர்வு செய்யவும்.",
    "whatsapp.connections.unnamed": "WhatsApp இணைப்பு",
    "WhatsApp connection": "WhatsApp இணைப்பு",
    "whatsapp.connections.default": "முன்னேற்ற",
    "whatsapp.connections.account": "{id} கணக்கு",
    "Account {id}": "{id} கணக்கு",
    "whatsapp.connections.branch": "{id} கிளை",
    "Branch {id}": "{id} கிளை",
    "whatsapp.connections.tenant_wide": "முழு நிறுவனத்திற்கான இணைப்பு",
    "Tenant-wide connection": "முழு நிறுவனத்திற்கான இணைப்பு",
    "whatsapp.action.make_default": "முன்னேற்றமாக மாற்றவும்",
    "Make default": "முன்னேற்றமாக மாற்றவும்",
    "whatsapp.notice.default_updated": "WhatsApp முன்னேற்ற இணைப்பு புதுப்பிக்கப்பட்டது.",
    "Default WhatsApp connection updated.": "WhatsApp முன்னேற்ற இணைப்பு புதுப்பிக்கப்பட்டது.",
    "whatsapp.error.default_update": "முன்னேற்ற இணைப்பை மாற்ற முடியாது.",
    "Unable to change the default connection.": "முன்னேற்ற இணைப்பை மாற்ற முடியாது.",
    "whatsapp.templates.title": "செய்திமாதிரிகள்",
    "Message templates": "செய்திமாதிரிகள்",
    "whatsapp.templates.description": "தயாரான மாதிரியைத் தேர்வு செய்யவும். Tradly அதை Meta-க்கு அனுப்பி, Meta அங்கீகரிக்கும்போது அதை தானியங்கி செயல்படுத்தும்.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "தயாரான மாதிரியைத் தேர்வு செய்யவும். Tradly அதை Meta-க்கு அனுப்பி, Meta அங்கீகரிக்கும்போது அதை தானியங்கி செயல்படுத்தும்.",
    "whatsapp.template.status.not_activated": "செயல்படுத்தப்படவில்லை",
    "Not activated": "செயல்படுத்தப்படவில்லை",
    "whatsapp.template.status.approved": "அங்கீகரிக்கப்பட்டது",
    "whatsapp.template.status.pending": "தொடர்புடையது",
    "whatsapp.template.status.submitted": "அனுப்பப்பட்டது",
    "Submitted": "அனுப்பப்பட்டது",
    "whatsapp.template.action.active": "செயல்பாட்டில்",
    "whatsapp.template.action.submitted": "அனுப்பப்பட்டது",
    "whatsapp.template.action.activate": "தானியங்கி மாதிரி செயல்படுத்து",
    "Activate template": "தானியங்கி மாதிரி செயல்படுத்து",
    "whatsapp.notice.template_active": "{name} ஒப்புதல் பெற்று செயல்பாட்டில் உள்ளது.",
    "{name} is approved and active.": "{name} ஒப்புதல் பெற்று செயல்பாட்டில் உள்ளது.",
    "whatsapp.notice.template_submitted": "{name} மெட்டாவுக்கு மதிப்பீட்டிற்காக அனுப்பப்பட்டுள்ளது. அது ஒப்புதல் பெறும் வரை SMS-ஐ தொடர்ந்து பயன்படுத்தலாம்.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} மெட்டாவுக்கு மதிப்பீட்டிற்காக அனுப்பப்பட்டுள்ளது. அது ஒப்புதல் பெறும் வரை SMS-ஐ தொடர்ந்து பயன்படுத்தலாம்.",
    "whatsapp.channel.title": "அனுப்பும் சேனல்",
    "Delivery channel": "அனுப்பும் சேனல்",
    "whatsapp.channel.help": "இந்த சுவிட்ச் உங்கள் வணிகத்திற்கு WhatsApp-ஐ இயக்கும். உள்நுழைவு குறியீடுகளை SMS மட்டும், WhatsApp மட்டும், அல்லது WhatsApp காப்புடன் SMS மூலம் அனுப்பலாம்; WhatsApp விருப்பங்களுக்கு அங்கீகரிக்கப்பட்ட குறியீட்டு டெம்ப்ளேட் தேவை.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "இந்த சுவிட்ச் உங்கள் வணிகத்திற்கு WhatsApp-ஐ இயக்கும். உள்நுழைவு குறியீடுகளை SMS மட்டும், WhatsApp மட்டும், அல்லது WhatsApp காப்புடன் SMS மூலம் அனுப்பலாம்; WhatsApp விருப்பங்களுக்கு அங்கீகரிக்கப்பட்ட குறியீட்டு டெம்ப்ளேட் தேவை.",
    "whatsapp.channel.primary_otp": "முதன்மை OTP சேனல்",
    "Primary OTP channel": "முதன்மை OTP சேனல்",
    "whatsapp.channel.sms_description": "உள்ள சிஎம்எஸ் அனுப்பும் பாதையை பராமரிக்கவும்.",
    "Keep the existing SMS delivery path.": "உள்ள சிஎம்எஸ் அனுப்பும் பாதையை பராமரிக்கவும்.",
    "whatsapp.channel.whatsapp_description": "இந்த டெண்ட் க்கு Meta Cloud API-ஐ பயன்படுத்தவும்.",
    "Use Meta Cloud API for this tenant.": "இந்த டெண்ட் க்கு Meta Cloud API-ஐ பயன்படுத்தவும்.",
    "whatsapp.channel.automatic": "தானியங்கி",
    "Automatic": "தானியங்கி",
    "whatsapp.channel.automatic_description": "அமைக்கப்பட்டிருந்தால் WhatsApp-ஐ பயன்படுத்துங்கள், இல்லையெனில் SMS-ஐ பயன்படுத்தவும்.",
    "Use WhatsApp when configured, otherwise SMS.": "அமைக்கப்பட்டிருந்தால் WhatsApp-ஐ பயன்படுத்துங்கள், இல்லையெனில் SMS-ஐ பயன்படுத்தவும்.",
    "whatsapp.channel.fallback": "WhatsApp தோல்விக்குப் பிறகு மாற்று",
    "Fallback after WhatsApp failure": "WhatsApp தோல்விக்குப் பிறகு மாற்று",
    "whatsapp.channel.no_fallback": "மாற்று இல்லை",
    "No fallback": "மாற்று இல்லை",
    "whatsapp.channel.no_fallback_description": "அமைக்கப்பட்ட அனுப்பும் முடிவை திரும்பப் பெறுங்கள்.",
    "Return the configured delivery result.": "அமைக்கப்பட்ட அனுப்பும் முடிவை திரும்பப் பெறுங்கள்.",
    "whatsapp.channel.sms_fallback_description": "அதே OTP குறியீட்டுடன் SMS முயற்சி செய்யவும்.",
    "Try SMS with the same OTP code.": "அதே OTP குறியீட்டுடன் SMS முயற்சி செய்யவும்.",
    "whatsapp.channel.sms_only": "SMS மட்டும்",
    "SMS only": "SMS மட்டும்",
    "whatsapp.channel.sms_only_description": "குறியீடுகள் குறுஞ்செய்தியாக அனுப்பப்படும்.",
    "Codes are sent by text message.": "குறியீடுகள் குறுஞ்செய்தியாக அனுப்பப்படும்.",
    "whatsapp.channel.whatsapp_only": "WhatsApp மட்டும்",
    "WhatsApp only": "WhatsApp மட்டும்",
    "whatsapp.channel.whatsapp_only_description": "குறியீடுகள் உங்கள் WhatsApp எண்ணிலிருந்து அனுப்பப்படும்.",
    "Codes are sent from your WhatsApp number.": "குறியீடுகள் உங்கள் WhatsApp எண்ணிலிருந்து அனுப்பப்படும்.",
    "whatsapp.channel.sms_whatsapp": "SMS, காப்பாக WhatsApp",
    "SMS, WhatsApp as backup": "SMS, காப்பாக WhatsApp",
    "whatsapp.channel.sms_whatsapp_description": "குறியீடுகள் குறுஞ்செய்தியாக அனுப்பப்படும்; SMS தோல்வியுற்றால், அதே குறியீடு WhatsApp-இல் அனுப்பப்படும்.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "குறியீடுகள் குறுஞ்செய்தியாக அனுப்பப்படும்; SMS தோல்வியுற்றால், அதே குறியீடு WhatsApp-இல் அனுப்பப்படும்.",
    "whatsapp.advanced.title": "தொழில்நுட்ப மீட்பு அமைப்புகள்",
    "Technical recovery settings": "தொழில்நுட்ப மீட்பு அமைப்புகள்",
    "whatsapp.advanced.description": "தொடர்புகொள்ள தொழில்நுட்ப ஆதரவுக்கு மட்டும். பெரும்பாலான வணிகங்கள் மேலே உள்ள Connect WhatsApp-ஐ பயன்படுத்த வேண்டும்.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "தொடர்புகொள்ள தொழில்நுட்ப ஆதரவுக்கு மட்டும். பெரும்பாலான வணிகங்கள் மேலே உள்ள Connect WhatsApp-ஐ பயன்படுத்த வேண்டும்.",
    "whatsapp.field.phone_number_id": "WhatsApp எண் ஐடி",
    "WhatsApp phone number ID": "WhatsApp எண் ஐடி",
    "whatsapp.field.phone_number_id_help": "உங்கள் WhatsApp வ Negocios் கணக்குடன் இணைக்கப்பட்ட எண் ஐடி.",
    "The phone number ID attached to your WhatsApp Business account.": "உங்கள் WhatsApp வ Negocios் கணக்குடன் இணைக்கப்பட்ட எண் ஐடி.",
    "whatsapp.field.waba_id": "WhatsApp Business கணக்கு ஐடி",
    "WhatsApp Business Account ID": "WhatsApp Business கணக்கு ஐடி",
    "whatsapp.field.waba_id_help": "Meta இல் (WhatsApp > API Setup) எண் ஐடிக்கு அருகில் காட்டப்படும். மாதிரிகள் மற்றும் சோதனை செய்திகளுக்கு தேவை.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Meta இல் (WhatsApp > API Setup) எண் ஐடிக்கு அருகில் காட்டப்படும். மாதிரிகள் மற்றும் சோதனை செய்திகளுக்கு தேவை.",
    "whatsapp.placeholder.phone_number_id": "எ.கா: 123456789012345",
    "e.g. 123456789012345": "எ.கா: 123456789012345",
    "whatsapp.field.access_token": "Meta அணுகல் தொகுப்பு",
    "Meta access token": "Meta அணுகல் தொகுப்பு",
    "whatsapp.field.access_token_saved_help": "செர்வரில் பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது. மாற்றாமல் வைக்க வெறும் இடத்தை விட்டு விடவும், அல்லது புதிய தொகுப்பை மாற்ற ஒட்டவும்.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "செர்வரில் பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது. மாற்றாமல் வைக்க வெறும் இடத்தை விட்டு விடவும், அல்லது புதிய தொகுப்பை மாற்ற ஒட்டவும்.",
    "whatsapp.field.access_token_help": "WhatsApp வ Negocios் செய்திகள் அனுப்ப அனுமதி கொண்ட அமைப்பு பயனர் தொகுப்பைப் பயன்படுத்தவும்.",
    "Use a system-user token with WhatsApp Business messaging permission.": "WhatsApp வ Negocios் செய்திகள் அனுப்ப அனுமதி கொண்ட அமைப்பு பயனர் தொகுப்பைப் பயன்படுத்தவும்.",
    "whatsapp.placeholder.access_token_saved": "பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது · மாற்றாமல் வைக்க வெறும் இடத்தை விட்டு விடவும்",
    "Saved securely · leave blank to keep": "பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது · மாற்றாமல் வைக்க வெறும் இடத்தை விட்டு விடவும்",
    "whatsapp.placeholder.access_token": "தொகுதி டோக்கன்",
    "Paste token": "தொகுதி டோக்கன்",
    "whatsapp.token.saved": "மெட்டா அணுகுமுறை தொகுதி பாதுகாப்பாக சேமிக்கப்பட்டது",
    "Meta access token saved securely": "மெட்டா அணுகுமுறை தொகுதி பாதுகாப்பாக சேமிக்கப்பட்டது",
    "whatsapp.field.otp_template": "ஆமோதிக்கப்பட்ட OTP மாதிரி பெயர்",
    "Approved OTP template name": "ஆமோதிக்கப்பட்ட OTP மாதிரி பெயர்",
    "whatsapp.field.otp_template_help": "மாதிரி உட்பொருள் OTP-ஐ ஒரு உரை அமைப்பாக ஏற்றுக்கொள்ள வேண்டும்.",
    "The template body must accept the OTP as one text parameter.": "மாதிரி உட்பொருள் OTP-ஐ ஒரு உரை அமைப்பாக ஏற்றுக்கொள்ள வேண்டும்.",
    "whatsapp.placeholder.otp_template": "எ.கா. login_verification",
    "e.g. login_verification": "எ.கா. login_verification",
    "whatsapp.field.template_language": "மாதிரி மொழி",
    "Template language": "மாதிரி மொழி",
    "whatsapp.field.marketing_template": "ஆமோதிக்கப்பட்ட மார்க்கெட்டிங் மாதிரி பெயர் (கூடுதல்)",
    "Approved marketing template name (optional)": "ஆமோதிக்கப்பட்ட மார்க்கெட்டிங் மாதிரி பெயர் (கூடுதல்)",
    "whatsapp.field.marketing_template_help": "Meta ஆமோதித்த மார்க்கெட்டிங் மாதிரியைப் பயன்படுத்தவும். கூடுதல் கேம்பேயின் content.template_name-ல் இந்த பெயரை மாற்றலாம்.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Meta ஆமோதித்த மார்க்கெட்டிங் மாதிரியைப் பயன்படுத்தவும். கூடுதல் கேம்பேயின் content.template_name-ல் இந்த பெயரை மாற்றலாம்.",
    "whatsapp.placeholder.marketing_template": "எ.கா. monthly_offer",
    "e.g. monthly_offer": "எ.கா. monthly_offer",
    "whatsapp.field.marketing_language": "மார்க்கெட்டிங் மாதிரி மொழி",
    "Marketing template language": "மார்க்கெட்டிங் மாதிரி மொழி",
    "whatsapp.info.title": "WhatsApp செயல்பாட்டிற்கு முன்",
    "Before enabling WhatsApp": "WhatsApp செயல்பாட்டிற்கு முன்",
    "whatsapp.info.description": "Meta ஒவ்வொரு OTP அல்லது மார்க்கெட்டிங் மாதிரியையும் அனுப்ப முடியும் முன் ஆமோதிக்க வேண்டும். WhatsApp கூடுதல் கேம்பேயின் உள்ளடக்கம் template_name, template_language மற்றும் கூடுதல் உட்பொருள் அமைப்புகளைப் பயன்படுத்துகிறது; பெறுநர் எண்கள் E.164 வடிவத்தில் இருக்க வேண்டும். தானியங்கி மாற்றம் செயல்பாட்டில் இருந்தால், ArcticOwl இரண்டாவது குறியீட்டை உருவாக்காமல் மூல OTP-ஐ பயன்படுத்தி SMS-ஐ மீண்டும் முயற்சிக்கிறது.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta ஒவ்வொரு OTP அல்லது மார்க்கெட்டிங் மாதிரியையும் அனுப்ப முடியும் முன் ஆமோதிக்க வேண்டும். WhatsApp கூடுதல் கேம்பேயின் உள்ளடக்கம் template_name, template_language மற்றும் கூடுதல் உட்பொருள் அமைப்புகளைப் பயன்படுத்துகிறது; பெறுநர் எண்கள் E.164 வடிவத்தில் இருக்க வேண்டும். தானியங்கி மாற்றம் செயல்பாட்டில் இருந்தால், ArcticOwl இரண்டாவது குறியீட்டை உருவாக்காமல் மூல OTP-ஐ பயன்படுத்தி SMS-ஐ மீண்டும் முயற்சிக்கிறது.",
    "whatsapp.action.hide_token": "மெட்டா அணுகுமுறை தொகுதியை மறைக்கவும்",
    "Hide Meta access token": "மெட்டா அணுகுமுறை தொகுதியை மறைக்கவும்",
    "whatsapp.action.show_token": "மெட்டா அணுகுமுறை தொகுதியைக் காட்டவும்",
    "Show Meta access token": "மெட்டா அணுகுமுறை தொகுதியைக் காட்டவும்",
    "whatsapp.error.generic": "WhatsApp அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Unable to save WhatsApp settings.": "WhatsApp அமைப்புகளை சேமிக்க முடியவில்லை.",
    "whatsapp.error.browser_required": "WhatsApp இணைப்பு மட்டுமே தளத்தில் கிடைக்கிறது.",
    "WhatsApp connection is only available in a browser.": "WhatsApp இணைப்பு மட்டுமே தளத்தில் கிடைக்கிறது.",
    "whatsapp.error.meta_load": "மெட்டா ஏற்றப்படவில்லை. தளத்தின் தனியுரிமை அமைப்புகளை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "Meta could not load. Check the browser privacy settings and try again.": "மெட்டா ஏற்றப்படவில்லை. தளத்தின் தனியுரிமை அமைப்புகளை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "whatsapp.error.load": "WhatsApp அமைப்புகளை ஏற்ற முடியவில்லை.",
    "Unable to load WhatsApp settings.": "WhatsApp அமைப்புகளை ஏற்ற முடியவில்லை.",
    "whatsapp.error.connect_before_template": "மாதிரியை செயல்படுத்துவதற்கு முன் WhatsApp இணைக்கவும்.",
    "Connect WhatsApp before activating a template.": "மாதிரியை செயல்படுத்துவதற்கு முன் WhatsApp இணைக்கவும்.",
    "whatsapp.error.template_submit": "WhatsApp மாதிரியை அனுப்ப முடியவில்லை.",
    "Unable to submit the WhatsApp template.": "WhatsApp மாதிரியை அனுப்ப முடியவில்லை.",
    "whatsapp.error.business_number_required": "இணைப்புக்கு முன் வணிக WhatsApp எண்ணை உள்ளிடவும். Meta அடுத்த படியில் சரிபார்க்கும்.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "இணைப்புக்கு முன் வணிக WhatsApp எண்ணை உள்ளிடவும். Meta அடுத்த படியில் சரிபார்க்கும்.",
    "whatsapp.error.signup_not_ready": "WhatsApp இணைப்பு தளத்தால் தயாரிக்கப்படுகிறது. விரைவில் மீண்டும் முயற்சிக்கவும்.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "WhatsApp இணைப்பு தளத்தால் தயாரிக்கப்படுகிறது. விரைவில் மீண்டும் முயற்சிக்கவும்.",
    "whatsapp.error.signup_cancelled": "மெட்டா இணைப்பு ரத்து செய்யப்பட்டது அல்லது அது அதிகாரம் குறியீட்டை திரும்ப அனுப்பவில்லை.",
    "Meta connection was cancelled or did not return an authorization code.": "மெட்டா இணைப்பு ரத்து செய்யப்பட்டது அல்லது அது அதிகாரம் குறியீட்டை திரும்ப அனுப்பவில்லை.",
    "whatsapp.error.phone_number_missing": "மெட்டா தேர்ந்தெடுக்கப்பட்ட வணிக WhatsApp எண்ணை திரும்ப அனுப்பவில்லை. இணைப்பை மீண்டும் முயற்சிக்கவும்.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "மெட்டா தேர்ந்தெடுக்கப்பட்ட வணிக WhatsApp எண்ணை திரும்ப அனுப்பவில்லை. இணைப்பை மீண்டும் முயற்சிக்கவும்.",
    "whatsapp.notice.connected_auto": "WhatsApp இணைக்கப்பட்டுள்ளது. தானியங்கி OTP அனுப்புதல் WhatsApp-ஐ முதலில் பயன்படுத்தி SMS-ஐ தோல்வியடைந்தால் பயன்படுத்தும்.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp இணைக்கப்பட்டுள்ளது. தானியங்கி OTP அனுப்புதல் WhatsApp-ஐ முதலில் பயன்படுத்தி SMS-ஐ தோல்வியடைந்தால் பயன்படுத்தும்.",
    "whatsapp.notice.connected_sms": "WhatsApp இணைக்கப்பட்டுள்ளது. Meta ஒரு அடையாள அட்டையை ஒப்புக்கொள்ளும் வரை SMS செயல்பாட்டில் இருக்கும்.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp இணைக்கப்பட்டுள்ளது. Meta ஒரு அடையாள அட்டையை ஒப்புக்கொள்ளும் வரை SMS செயல்பாட்டில் இருக்கும்.",
    "whatsapp.error.connect": "WhatsApp-ஐ இணைக்க முடியவில்லை.",
    "Unable to connect WhatsApp.": "WhatsApp-ஐ இணைக்க முடியவில்லை.",
    "whatsapp.error.otp_configuration": "WhatsApp அல்லது தானியங்கி OTP-க்கு தொலைபேசி எண் ID, ஒப்புக்கொள்ளப்பட்ட OTP அட்டை பெயர் மற்றும் Meta அணுகுமுறை டோக்கன் தேவை. விற்பனைக்கான WhatsApp-க்கு, SMS-ஐ OTP முதன்மை சேனலாகத் தேர்ந்தெடுத்து கனெக்டரை செயல்பாட்டில் வைக்கவும்.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "WhatsApp அல்லது தானியங்கி OTP-க்கு தொலைபேசி எண் ID, ஒப்புக்கொள்ளப்பட்ட OTP அட்டை பெயர் மற்றும் Meta அணுகுமுறை டோக்கன் தேவை. விற்பனைக்கான WhatsApp-க்கு, SMS-ஐ OTP முதன்மை சேனலாகத் தேர்ந்தெடுத்து கனெக்டரை செயல்பாட்டில் வைக்கவும்.",
    "whatsapp.notice.saved": "இந்த டெனன்ட்டிற்கான WhatsApp கனெக்டர் அமைப்புகள் சேமிக்கப்பட்டுள்ளன.",
    "WhatsApp connector settings saved for this tenant.": "இந்த டெனன்ட்டிற்கான WhatsApp கனெக்டர் அமைப்புகள் சேமிக்கப்பட்டுள்ளன.",
    "whatsapp.error.save": "WhatsApp அமைப்புகளை சேமிக்க முடியவில்லை.",
    "whatsapp.notice.discarded": "முன்னோட்டம் தொலைக்கப்பட்டது.",
    "Draft discarded.": "முன்னோட்டம் தொலைக்கப்பட்டது.",
    "whatsapp.test.title": "சோதனை செய்தியை அனுப்பு",
    "Send a test message": "சோதனை செய்தியை அனுப்பு",
    "whatsapp.test.description": "உங்கள் இணைப்பு செயல்படுகிறதா என்பதை சரிபார்க்க அங்கீகரிக்கப்பட்ட மாதிரியை எந்த WhatsApp எண்ணுக்கும் அனுப்புங்கள்.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "உங்கள் இணைப்பு செயல்படுகிறதா என்பதை சரிபார்க்க அங்கீகரிக்கப்பட்ட மாதிரியை எந்த WhatsApp எண்ணுக்கும் அனுப்புங்கள்.",
    "whatsapp.test.refresh": "மாதிரிகளைப் புதுப்பி",
    "Refresh templates": "மாதிரிகளைப் புதுப்பி",
    "whatsapp.test.field.template": "அங்கீகரிக்கப்பட்ட மாதிரி",
    "Approved template": "அங்கீகரிக்கப்பட்ட மாதிரி",
    "whatsapp.test.field.parameter": "{{{number}}} க்கான மதிப்பு",
    "Value for {{{number}}}": "{{{number}}} க்கான மதிப்பு",
    "whatsapp.test.field.mobile": "அனுப்ப வேண்டிய எண்",
    "Send to": "அனுப்ப வேண்டிய எண்",
    "whatsapp.test.field.mobile_help": "நாட்டுக் குறியீட்டுடன் WhatsApp எண்.",
    "WhatsApp number with country code.": "நாட்டுக் குறியீட்டுடன் WhatsApp எண்.",
    "whatsapp.test.action.send": "சோதனை செய்தியை அனுப்பு",
    "Send test message": "சோதனை செய்தியை அனுப்பு",
    "whatsapp.test.sent": "{mobile} க்கு அனுப்பப்பட்டது. Meta செய்தி ID: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "{mobile} க்கு அனுப்பப்பட்டது. Meta செய்தி ID: {id}",
    "whatsapp.test.no_templates": "இன்னும் அங்கீகரிக்கப்பட்ட மாதிரிகள் இல்லை. மேலே ஒரு மாதிரியை செயல்படுத்தி Meta அங்கீகரித்ததும் அனுப்புங்கள்.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "இன்னும் அங்கீகரிக்கப்பட்ட மாதிரிகள் இல்லை. மேலே ஒரு மாதிரியை செயல்படுத்தி Meta அங்கீகரித்ததும் அனுப்புங்கள்.",
    "common.discard_draft": "முன்னோட்டத்தை தொலைக்கவும்",
    "common.status.connected": "இணைக்கப்பட்டுள்ளது",
    "Connected": "இணைக்கப்பட்டுள்ளது",
    "extensions.title": "நீட்சிகள்",
    "extensions.action.add": "நீட்சி சேர்க்கவும்",
    "Add Extension": "நீட்சி சேர்க்கவும்",
    "extensions.action.add_new": "புதிய நீட்சியைச் சேர்க்கவும்",
    "Add New Extension": "புதிய நீட்சியைச் சேர்க்கவும்",
    "extensions.action.edit": "நீட்சியை தொகுக்கவும்",
    "Edit Extension": "நீட்சியை தொகுக்கவும்",
    "extensions.action.delete": "நீட்சியை அகற்றவும்",
    "Delete extension": "நீட்சியை அகற்றவும்",
    "extensions.field.name": "பெயர்",
    "extensions.field.domain": "டொமைன்",
    "extensions.field.configs": "அமைப்புகள்",
    "Configs": "அமைப்புகள்",
    "extensions.placeholder.name": "நீட்சி பெயர்",
    "Extension Name": "நீட்சி பெயர்",
    "extensions.placeholder.domain": "நீட்சி டொமைன்",
    "Extension Domain": "நீட்சி டொமைன்",
    "extensions.empty": "இன்னும் எந்த நீட்சிகளும் அமைக்கப்படவில்லை.",
    "No extensions configured yet.": "இன்னும் எந்த நீட்சிகளும் அமைக்கப்படவில்லை.",
    "extensions.toast.added": "நீட்சி வெற்றிகரமாகச் சேர்க்கப்பட்டது.",
    "Extension added successfully.": "நீட்சி வெற்றிகரமாகச் சேர்க்கப்பட்டது.",
    "extensions.toast.updated": "நீட்சி வெற்றிகரமாக தொகுக்கப்பட்டது.",
    "Extension updated successfully.": "நீட்சி வெற்றிகரமாக தொகுக்கப்பட்டது.",
    "extensions.toast.deleted": "நீட்சி வெற்றிகரமாக அகற்றப்பட்டது.",
    "Extension deleted successfully.": "நீட்சி வெற்றிகரமாக அகற்றப்பட்டது.",
    "extensions.error.name_required": "பெயர் தேவை.",
    "extensions.error.domain_required": "தொடர்பு தேவை",
    "Domain is required": "தொடர்பு தேவை",
    "extensions.error.configs_required": "கோப்புகள் தேவை",
    "Configs is required": "கோப்புகள் தேவை",
    "extensions.error.save_failed": "மாற்று சேமிக்க முடியவில்லை.",
    "Unable to save the extension.": "மாற்று சேமிக்க முடியவில்லை.",
    "extensions.error.delete_failed": "மாற்று நீக்க முடியவில்லை.",
    "Unable to delete the extension.": "மாற்று நீக்க முடியவில்லை.",
    "automation_rules.kicker": "ஆபரேஷன் தானியங்கி",
    "Operations automation": "ஆபரேஷன் தானியங்கி",
    "automation_rules.title": "தானியங்கி விதிகள்",
    "Automation rules": "தானியங்கி விதிகள்",
    "automation_rules.description": "பணியாளர் மற்றும் செலவு நிகழ்வுகளை தெளிவான ஒப்புதல் மற்றும் மேம்பாடு படிகளாக மாற்றுக.",
    "Turn staff and expense events into clear approval and review steps.": "பணியாளர் மற்றும் செலவு நிகழ்வுகளை தெளிவான ஒப்புதல் மற்றும் மேம்பாடு படிகளாக மாற்றுக.",
    "automation_rules.action.new_rule": "புதிய விதி",
    "New rule": "புதிய விதி",
    "automation_rules.action.create_rule": "விதி உருவாக்கு",
    "Create rule": "விதி உருவாக்கு",
    "automation_rules.action.create_help": "இந்த தூண்டுதல், நிபந்தனைகள் மற்றும் செயலை விதியாக சேமிக்கவும்",
    "Save this trigger, conditions, and action as a rule": "இந்த தூண்டுதல், நிபந்தனைகள் மற்றும் செயலை விதியாக சேமிக்கவும்",
    "automation_rules.action.add_condition": "நிபந்தனையை சேர்க்கவும்",
    "Add condition": "நிபந்தனையை சேர்க்கவும்",
    "automation_rules.action.add_condition_help": "இந்த விதிக்கு மேலும் நிபந்தனையை சேர்க்கவும்",
    "Add another condition to this rule": "இந்த விதிக்கு மேலும் நிபந்தனையை சேர்க்கவும்",
    "automation_rules.action.remove_condition": "நிபந்தனையை நீக்கு",
    "Remove condition": "நிபந்தனையை நீக்கு",
    "automation_rules.action.choose": "செயலைத் தேர்வு செய்க",
    "Choose an action": "செயலைத் தேர்வு செய்க",
    "automation_rules.action.require_second_approver": "இரண்டாம் ஒப்புதல் வழங்குதல் தேவை",
    "Require second approver": "இரண்டாம் ஒப்புதல் வழங்குதல் தேவை",
    "automation_rules.action.require_second_approver_help": "கோரிக்கையை மற்றொரு ஒப்புதல் வழங்குதலுக்கு அனுப்பவும்.",
    "Route the claim to another approver.": "கோரிக்கையை மற்றொரு ஒப்புதல் வழங்குதலுக்கு அனுப்பவும்.",
    "automation_rules.action.auto_reject_expense": "தானியங்கி செலவை நிராகரிக்கவும்",
    "Auto-reject expense": "தானியங்கி செலவை நிராகரிக்கவும்",
    "automation_rules.action.auto_reject_expense_help": "காரணத்துடன் செலவை நிராகரிக்கவும்.",
    "Reject the expense with a reason.": "காரணத்துடன் செலவை நிராகரிக்கவும்.",
    "automation_rules.action.notify_role": "பங்கு அறிவிப்பு",
    "Notify a role": "பங்கு அறிவிப்பு",
    "automation_rules.action.notify_role_help": "பணியாளர் பங்குக்கு அறிவிப்பு அனுப்பவும்.",
    "Send a notification to a staff role.": "பணியாளர் பங்குக்கு அறிவிப்பு அனுப்பவும்.",
    "automation_rules.action.flag_for_review": "மேம்பாட்டிற்கு குறிப்பிடு",
    "Flag for review": "மேம்பாட்டிற்கு குறிப்பிடு",
    "automation_rules.action.flag_for_review_help": "கையேடு மேம்பாட்டிற்கு விஷயத்தைக் குறிப்பிடவும்.",
    "Mark a resource for manual review.": "கையேடு மேம்பாட்டிற்கு விஷயத்தைக் குறிப்பிடவும்.",
    "automation_rules.field.rule_name": "விதி பெயர்",
    "Rule name": "விதி பெயர்",
    "automation_rules.field.priority": "முன்னுரிமை",
    "automation_rules.field.module": "மாட்யூல்",
    "Module": "மாட்யூல்",
    "automation_rules.field.event": "ஈவென்ட்",
    "automation_rules.field.field": "களம்",
    "Field": "களம்",
    "automation_rules.field.operator": "ஆபரேட்டர்",
    "Operator": "ஆபரேட்டர்",
    "automation_rules.field.value": "மதிப்பு",
    "automation_rules.field.action": "செயல்பாடு",
    "automation_rules.field.action_params": "செயல்பாட்டு அமைப்புகள்",
    "Action parameters": "செயல்பாட்டு அமைப்புகள்",
    "automation_rules.placeholder.rule_name": "பெரிய கோரிக்கைகளுக்கு இரண்டாவது அனுமதிப்பாளரை தேவைப்படுத்து",
    "Require second approver for large claims": "பெரிய கோரிக்கைகளுக்கு இரண்டாவது அனுமதிப்பாளரை தேவைப்படுத்து",
    "automation_rules.placeholder.field": "தொகை",
    "amount": "தொகை",
    "automation_rules.placeholder.value": "500 அல்லது false",
    "500 or false": "500 அல்லது false",
    "automation_rules.builder.description": "கீழே உள்ள தூண்டுதல், நிபந்தனைகள் மற்றும் செயல்பாட்டை உருவாக்கி, அதை ஒரு விதியாக சேமிக்கவும்.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "கீழே உள்ள தூண்டுதல், நிபந்தனைகள் மற்றும் செயல்பாட்டை உருவாக்கி, அதை ஒரு விதியாக சேமிக்கவும்.",
    "automation_rules.error.load": "ஆட்டோமேஷன் விதிகளை ஏற்ற முடியவில்லை.",
    "Unable to load automation rules.": "ஆட்டோமேஷன் விதிகளை ஏற்ற முடியவில்லை.",
    "automation_rules.error.required_fields": "பெயர், மாட்யூல், ஈவென்ட் மற்றும் செயல்பாடு தேவை.",
    "Name, module, event, and action are required.": "பெயர், மாட்யூல், ஈவென்ட் மற்றும் செயல்பாடு தேவை.",
    "automation_rules.error.create": "ஆட்டோமேஷன் விதியை உருவாக்க முடியவில்லை.",
    "Unable to create automation rule.": "ஆட்டோமேஷன் விதியை உருவாக்க முடியவில்லை.",
    "automation_rules.error.valid_json": "சேமிக்கும் முன் செல்லுபடியாகும் JSON-ஐ பயன்படுத்தவும்.",
    "Use valid JSON before saving.": "சேமிக்கும் முன் செல்லுபடியாகும் JSON-ஐ பயன்படுத்தவும்.",
    "automation_rules.notice.created": "ஆட்டோமேஷன் விதி உருவாக்கப்பட்டது.",
    "Automation rule created.": "ஆட்டோமேஷன் விதி உருவாக்கப்பட்டது.",
    "automation_rules.notice.discarded": "முன்னோட்டம் தொலைக்கப்பட்டது.",
    "automation_rules.draft.restored": "ஆட்டோமேஷன் விதியின் சேமிக்கப்படாத முன்னோட்டம் மீட்கப்பட்டது.",
    "Your unsaved automation rule draft was restored.": "ஆட்டோமேஷன் விதியின் சேமிக்கப்படாத முன்னோட்டம் மீட்கப்பட்டது.",
    "automation_rules.list.title": "விதிகள்",
    "automation_rules.list.count": "{count} அமைக்கப்பட்டுள்ளது",
    "{count} configured": "{count} அமைக்கப்பட்டுள்ளது",
    "automation_rules.list.loading": "விதிகளை ஏற்றுகிறது…",
    "Loading rules…": "விதிகளை ஏற்றுகிறது…",
    "automation_rules.list.unnamed": "பெயரில்லாத விதி",
    "Unnamed rule": "பெயரில்லாத விதி",
    "automation_rules.list.no_action": "அமைக்கப்பட்ட செயல்பாடு இல்லை",
    "No action configured": "அமைக்கப்பட்ட செயல்பாடு இல்லை",
    "automation_rules.list.empty": "விதிகள் இல்லை. வரைபடத்திலிருந்து முதல் விதியை உருவாக்கவும்.",
    "No rules yet. Create the first one from the diagram.": "விதிகள் இல்லை. வரைபடத்திலிருந்து முதல் விதியை உருவாக்கவும்.",
    "automation_rules.status.draft": "மூலப்படி",
    "automation_rules.status.active": "ஆக்டிவ்",
    "automation_rules.inspector.title": "பிளாக் அமைப்புகள்",
    "Block settings": "பிளாக் அமைப்புகள்",
    "automation_rules.inspector.diagram": "டியாகிராம்",
    "Diagram": "டியாகிராம்",
    "automation_rules.inspector.select_block": "டியாகிராமில் ஒரு பிளாக்கைத் தேர்வு செய்து அதனை அமைக்கவும்.",
    "Select a block on the diagram to configure it.": "டியாகிராமில் ஒரு பிளாக்கைத் தேர்வு செய்து அதனை அமைக்கவும்.",
    "automation_rules.inspector.no_configuration": "இந்த பிளாக்குக்கு அமைப்பு தேவையில்லை.",
    "This block does not need configuration.": "இந்த பிளாக்குக்கு அமைப்பு தேவையில்லை.",
    "automation_rules.node.trigger": "தூண்டுதல்",
    "automation_rules.node.condition": "நிபந்தனை",
    "automation_rules.node.action": "செயல்பாடு",
    "automation_rules.node.end": "முடிவு",
    "automation_rules.node.completed": "முடிக்கப்பட்டது",
    "automation_rules.node.finished": "விதிகள் மதிப்பீடு முடிந்தது",
    "Rule evaluation finished": "விதிகள் மதிப்பீடு முடிந்தது",
    "automation_rules.trigger.choose_event": "ஒரு நிகழ்வைத் தேர்வு செய்க",
    "Choose an event": "ஒரு நிகழ்வைத் தேர்வு செய்க",
    "automation_rules.trigger.module": "மாட்யூல்",
    "module": "மாட்யூல்",
    "automation_rules.trigger.module_event": "{module} நிகழ்வு",
    "{module} event": "{module} நிகழ்வு",
    "automation_rules.trigger.help": "இந்த நிகழ்வு மாட்யூலிலிருந்து வெளியிடப்படும்போது, விதி மதிப்பீடு செய்யப்படுகிறது.",
    "The rule evaluates when this event is emitted by the module.": "இந்த நிகழ்வு மாட்யூலிலிருந்து வெளியிடப்படும்போது, விதி மதிப்பீடு செய்யப்படுகிறது.",
    "automation_rules.condition.label": "நிபந்தனை",
    "automation_rules.condition.none": "நிபந்தனைகள் இல்லை",
    "No conditions": "நிபந்தனைகள் இல்லை",
    "automation_rules.condition.always_fires": "எப்போதும் தூண்டுதல்",
    "Always fires": "எப்போதும் தூண்டுதல்",
    "automation_rules.condition.empty_help": "இந்த விதியை கட்டுப்படுத்த, நிபந்தனையைச் சேர்க்கவும்.",
    "Add a condition to restrict this rule.": "இந்த விதியை கட்டுப்படுத்த, நிபந்தனையைச் சேர்க்கவும்.",
    "automation_rules.condition.value_required": "மதிப்பு தேவை",
    "Value required": "மதிப்பு தேவை",
    "automation_rules.condition.value": "மதிப்பு: {value}",
    "Value: {value}": "மதிப்பு: {value}",
    "automation_rules.operator.equals": "சமம்",
    "Equals": "சமம்",
    "automation_rules.operator.gt": "மேலும் பெரியது",
    "Greater than": "மேலும் பெரியது",
    "automation_rules.operator.gte": "மேலும் அல்லது சமம்",
    "Greater than or equal": "மேலும் அல்லது சமம்",
    "automation_rules.operator.lt": "குறைவானது",
    "Less than": "குறைவானது",
    "automation_rules.operator.exists": "இருக்கிறது",
    "Exists": "இருக்கிறது",
    "automation_rules.module.expenses": "செலவுகள்",
    "automation_rules.module.staff": "பணியாளர்கள்",
    "automation_rules.event.expense.submitted": "செலவு சமர்ப்பிக்கப்பட்டது",
    "automation_rules.event.leave.requested": "விடுமுறை கோரிக்கை",
    "Leave requested": "விடுமுறை கோரிக்கை",
    "automation_rules.event.payroll_run.created": "கொடுப்பனவு பட்டியல் உருவாக்கப்பட்டது",
    "automation_rules.meta.conditions": "{count} நிபந்தனைகள் · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "{count} condition(s) · all must match before the action runs": "{count} நிபந்தனைகள் · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "automation_rules.meta.no_conditions": "நிபந்தனைகள் இல்லை · தூண்டுதலுக்குப் பிறகு செயல்முறை எப்போதும் நடைபெறும்",
    "No conditions · the action always runs after the trigger": "நிபந்தனைகள் இல்லை · தூண்டுதலுக்குப் பிறகு செயல்முறை எப்போதும் நடைபெறும்",
    "automation_rules.draft.unsaved": "நீங்கள் சேமிக்கப்படாத தாமதமான விதிகளை உள்ளது.",
    "You have an unsaved automation rule draft.": "நீங்கள் சேமிக்கப்படாத தாமதமான விதிகளை உள்ளது.",
    "automation_rules.meta.one_condition": "1 நிபந்தனை · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "1 condition · all must match before the action runs": "1 நிபந்தனை · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "automation_rules.meta.many_conditions": "{count} நிபந்தனைகள் · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "{count} conditions · all must match before the action runs": "{count} நிபந்தனைகள் · செயல்முறை நடைபெறும் முன் அனைத்தும் பொருந்த வேண்டும்",
    "cms.type.page": "பக்கம்",
    "Page": "பக்கம்",
    "cms.type.blog": "பிளாக்",
    "cms.type.docs": "ஆவணங்கள்",
    "Docs": "ஆவணங்கள்",
    "cms.type.pages": "பக்கங்கள்",
    "cms.type.blogs": "பிளாக்குகள்",
    "Blogs": "பிளாக்குகள்",
    "cms.action.add_content": "பொருளைச் சேர்க்கவும்",
    "Add content": "பொருளைச் சேர்க்கவும்",
    "cms.action.add_type": "{type} சேர்க்கவும்",
    "cms.action.create_type": "{type} உருவாக்கவும்",
    "Create {type}": "{type} உருவாக்கவும்",
    "cms.action.edit": "தொகுக்கவும்",
    "cms.action.duplicate": "இரட்டிப்பாக்கவும்",
    "cms.action.open": "திறக்கவும்",
    "cms.field.title": "தலைப்பு",
    "cms.field.slug": "ஸ்லக்",
    "cms.field.content": "பெரும்பாலும்",
    "cms.field.meta_title": "மெட்டா தலைப்பு",
    "cms.field.meta_description": "மெட்டா விளக்கம்",
    "cms.placeholder.title": "எ.கா. நாங்கள் பற்றி",
    "e.g. About us": "எ.கா. நாங்கள் பற்றி",
    "cms.placeholder.slug": "அறிக்கை-நாங்கள்",
    "about-us": "அறிக்கை-நாங்கள்",
    "cms.placeholder.page_title": "பக்க தலைப்பு",
    "Page title": "பக்க தலைப்பு",
    "cms.placeholder.page_slug": "பக்க-ஸ்லக்",
    "page-slug": "பக்க-ஸ்லக்",
    "cms.placeholder.content": "உங்கள் உள்ளடக்கத்தை இங்கே எழுதவும்…",
    "Write your content here…": "உங்கள் உள்ளடக்கத்தை இங்கே எழுதவும்…",
    "cms.placeholder.meta_title": "தலைப்புக்கு பொதுவானது",
    "Defaults to title": "தலைப்புக்கு பொதுவானது",
    "cms.placeholder.meta_description": "தேடல் இயந்திரங்களுக்கான சுருக்கமான விளக்கம்",
    "Short description for search engines": "தேடல் இயந்திரங்களுக்கான சுருக்கமான விளக்கம்",
    "cms.section.seo_optional": "SEO (கூடுதல்)",
    "SEO (optional)": "SEO (கூடுதல்)",
    "cms.error.title_required": "தலைப்பு அவசியம்.",
    "Title is required.": "தலைப்பு அவசியம்.",
    "cms.error.content_required": "சேமிக்கும் முன் உள்ளடக்கத்தை சேர்க்கவும்.",
    "Add some content before saving.": "சேமிக்கும் முன் உள்ளடக்கத்தை சேர்க்கவும்.",
    "cms.error.create": "உருவாக்க தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    "Failed to create. Please try again.": "உருவாக்க தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    "cms.error.save": "சேமிக்க தோல்வி.",
    "Failed to save.": "சேமிக்க தோல்வி.",
    "cms.error.load_layer": "இந்த படலத்தை ஏற்ற முடியவில்லை.",
    "Could not load this layer.": "இந்த படலத்தை ஏற்ற முடியவில்லை.",
    "cms.toast.created": "{type} வெற்றிகரமாக உருவாக்கப்பட்டது.",
    "{type} created successfully.": "{type} வெற்றிகரமாக உருவாக்கப்பட்டது.",
    "cms.toast.saved": "சேமிக்கப்பட்டது",
    "Saved": "சேமிக்கப்பட்டது",
    "cms.toast.changes_saved": "மாற்றங்கள் சேமிக்கப்பட்டன.",
    "Changes saved.": "மாற்றங்கள் சேமிக்கப்பட்டன.",
    "cms.toast.deleted": "அழிக்கப்பட்டது",
    "cms.toast.duplicated": "இரட்டிப்பு",
    "Duplicated": "இரட்டிப்பு",
    "cms.error.delete": "அழிக்க தோல்வி.",
    "Failed to delete": "அழிக்க தோல்வி.",
    "cms.error.duplicate": "நகலெடுக்க தோல்வி",
    "Failed to duplicate": "நகலெடுக்க தோல்வி",
    "cms.confirm.delete": "\"{title}\" ஐ நீக்கவா?",
    "Delete \"{title}\"?": "\"{title}\" ஐ நீக்கவா?",
    "cms.duplicate.title": "{title} (நகல்)",
    "{title} (copy)": "{title} (நகல்)",
    "cms.draft.restored": "சேமிக்கப்படாத உள்ளடக்க தொடக்க பதிப்பு மீட்கப்பட்டது.",
    "Your unsaved content draft was restored.": "சேமிக்கப்படாத உள்ளடக்க தொடக்க பதிப்பு மீட்கப்பட்டது.",
    "cms.search": "தேடு…",
    "Search…": "தேடு…",
    "cms.list.no_results": "结果が見つかりません。",
    "No results found.": "结果が見つかりません。",
    "cms.list.empty_type": "இன்னும் {type} இல்லை.",
    "No {type} yet.": "இன்னும் {type} இல்லை.",
    "cms.list.untitled": "தலைப்பில்லாதது",
    "Untitled": "தலைப்பில்லாதது",
    "cms.editor.placeholder": "உங்கள் உள்ளடக்கத்தை இங்கே எழுதவும்…",
    "cms.editor.normal_text": "இயல்பு உரை",
    "Normal text": "இயல்பு உரை",
    "cms.editor.heading": "தலைப்பு {level}",
    "Heading {level}": "தலைப்பு {level}",
    "cms.editor.align_left": "இடது பக்கம் செருகுதல்",
    "Align Left": "இடது பக்கம் செருகுதல்",
    "cms.editor.align_center": "மையமாக்கு",
    "Align Center": "மையமாக்கு",
    "cms.editor.align_right": "வலதுபுறம் அமை",
    "Align Right": "வலதுபுறம் அமை",
    "cms.editor.insert_table": "அட்டவணையை சேர்க்க",
    "Insert table": "அட்டவணையை சேர்க்க",
    "cms.editor.add_column": "விரிவுரையை சேர்",
    "Add column": "விரிவுரையை சேர்",
    "cms.editor.add_row": "வரிசையை சேர்",
    "Add row": "வரிசையை சேர்",
    "cms.editor.delete_table": "அட்டவணையை நீக்கு",
    "Delete table": "அட்டவணையை நீக்கு",
    "cms.editor.delete_column": "விரிவுரையை நீக்கு",
    "Delete column": "விரிவுரையை நீக்கு",
    "cms.editor.delete_row": "வரிசையை நீக்கு",
    "Delete row": "வரிசையை நீக்கு",
    "cms.editor.underline": "கீழ்கோடு",
    "Underline": "கீழ்கோடு",
    "cms.editor.strikethrough": "குறிப்பிடு",
    "Strikethrough": "குறிப்பிடு",
    "cms.editor.code": "குறியீடு",
    "cms.editor.code_block": "குறியீட்டு பிரிவு",
    "Code block": "குறியீட்டு பிரிவு",
    "cms.editor.subscript": "சுட்டி",
    "Subscript": "சுட்டி",
    "cms.editor.superscript": "மேல் எழுத்து",
    "Superscript": "மேல் எழுத்து",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "பட இணையதள முகவரி",
    "Image URL": "பட இணையதள முகவரி",
    "cms.editor.prompt.youtube_url": "யூடியூப் URL",
    "YouTube URL": "யூடியூப் URL",
    "cms.editor.undo": "மீளமை",
    "cms.editor.redo": "மீண்டும் செய்ய",
    "cms.editor.table": "அட்டவணை",
    "Table": "அட்டவணை",
    "cms.editor.more": "மேலும்",
    "cms.editor.bold": "கோடு",
    "Bold": "கோடு",
    "cms.editor.italic": "கைரேகை",
    "Italic": "கைரேகை",
    "cms.editor.bullet_list": "புள்ளி பட்டியல்",
    "Bullet list": "புள்ளி பட்டியல்",
    "cms.editor.ordered_list": "வரிசைப்படுத்தப்பட்ட பட்டியல்",
    "Ordered list": "வரிசைப்படுத்தப்பட்ட பட்டியல்",
    "cms.editor.task_list": "பணிப்பட்டியல்",
    "Task list": "பணிப்பட்டியல்",
    "cms.editor.link": "இணைப்பு",
    "Link": "இணைப்பு",
    "cms.editor.image": "படம்",
    "cms.editor.text_color": "எழுத்து நிறம்",
    "Text color": "எழுத்து நிறம்",
    "cms.editor.youtube": "யூடியூப்",
    "YouTube": "யூடியூப்",
    "cms.test.type.pages": "பக்கங்கள்",
    "cms.test.type.pages_description": "முகப்பு பக்கங்கள் மற்றும் கடை உள்ளடக்கம்.",
    "Landing pages and structured storefront content.": "முகப்பு பக்கங்கள் மற்றும் கடை உள்ளடக்கம்.",
    "cms.test.type.blogs": "பிளாக்குகள்",
    "cms.test.type.blogs_description": "வாசகர்களுக்கான கட்டுரைகள், கதைகள் மற்றும் புதுப்பிப்புகள்.",
    "Articles, stories, and updates for your audience.": "வாசகர்களுக்கான கட்டுரைகள், கதைகள் மற்றும் புதுப்பிப்புகள்.",
    "cms.test.type.docs": "ஆவணங்கள்",
    "cms.test.type.docs_description": "ஆவணங்கள், வழிகாட்டிகள் மற்றும் உதவி உள்ளடக்கம்.",
    "Documentation, guides, and help content.": "ஆவணங்கள், வழிகாட்டிகள் மற்றும் உதவி உள்ளடக்கம்.",
    "cms.test.operation.list": "தொகுதி பொருளை பட்டியலிடு",
    "List content by type": "தொகுதி பொருளை பட்டியலிடு",
    "cms.test.operation.fetch": "ஒரு படம் பெறு",
    "Fetch one Layer": "ஒரு படம் பெறு",
    "cms.test.operation.create": "ஒரு படம் உருவாக்கு",
    "Create a Layer": "ஒரு படம் உருவாக்கு",
    "cms.test.operation.update": "ஒரு படத்தை புதுப்பிக்க",
    "Update a Layer": "ஒரு படத்தை புதுப்பிக்க",
    "cms.test.operation.delete": "ஒரு படத்தை நீக்கு",
    "Delete a Layer": "ஒரு படத்தை நீக்கு",
    "cms.test.operation.search": "பொருளைத் தேடு",
    "Search content": "பொருளைத் தேடு",
    "cms.test.operation.categories": "வகைகளை ஏற்று",
    "Load categories": "வகைகளை ஏற்று",
    "cms.test.operation.translations": "மொழிபெயர்ப்புகளைச் சேமி",
    "Save translations": "மொழிபெயர்ப்புகளைச் சேமி",
    "cms.test.editor.placeholder": "திரை உள்ளடக்கத்தை எழுதுங்கள்...",
    "Write your page content...": "திரை உள்ளடக்கத்தை எழுதுங்கள்...",
    "cms.test.error.load_type": "{type} உள்ளடக்கத்தை ஏற்ற முடியவில்லை",
    "Unable to load {type} content": "{type} உள்ளடக்கத்தை ஏற்ற முடியவில்லை",
    "cms.test.error.load": "CMS உள்ளடக்கத்தை ஏற்ற முடியவில்லை.",
    "Unable to load CMS content.": "CMS உள்ளடக்கத்தை ஏற்ற முடியவில்லை.",
    "cms.test.error.required": "சேமிக்கும் முன் பக்க தலைப்பு மற்றும் உள்ளடக்கத்தை சேர்க்கவும்.",
    "Add a page title and content before saving.": "சேமிக்கும் முன் பக்க தலைப்பு மற்றும் உள்ளடக்கத்தை சேர்க்கவும்.",
    "cms.test.error.create": "இந்த பக்கத்தை உருவாக்க முடியவில்லை.",
    "Unable to create this page.": "இந்த பக்கத்தை உருவாக்க முடியவில்லை.",
    "cms.test.toast.created": "பக்கம் வெற்றிகரமாக உருவாக்கப்பட்டது.",
    "Page created successfully.": "பக்கம் வெற்றிகரமாக உருவாக்கப்பட்டது.",
    "cms.test.hero.eyebrow": "பொருள் மேலாண்மை",
    "CONTENT MANAGEMENT": "பொருள் மேலாண்மை",
    "cms.test.hero.title": "Layers CMS",
    "Layers CMS": "Layers CMS",
    "cms.test.hero.description": "ஒரு முறை அமைக்கப்பட்ட உள்ளடக்கத்தை உருவாக்கி, பின்னர் அதை உங்கள் கடை, பயன்பாடுகள் மற்றும் தனிப்பயன் அனுபவங்களில் கிடைக்க செய்யவும்.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "ஒரு முறை அமைக்கப்பட்ட உள்ளடக்கத்தை உருவாக்கி, பின்னர் அதை உங்கள் கடை, பயன்பாடுகள் மற்றும் தனிப்பயன் அனுபவங்களில் கிடைக்க செய்யவும்.",
    "cms.test.hero.live_workspace": "ஆன்லைன் வேலை இடம்: {tenant} · பார்வையிட மட்டும்",
    "Live workspace: {tenant} · read-only preview": "ஆன்லைன் வேலை இடம்: {tenant} · பார்வையிட மட்டும்",
    "cms.test.current_tenant": "தற்போதைய குடியிருப்பாளர்",
    "current tenant": "தற்போதைய குடியிருப்பாளர்",
    "cms.test.content.title": "உங்கள் உள்ளடக்கம்",
    "Your content": "உங்கள் உள்ளடக்கம்",
    "cms.test.content.description": "பக்கங்கள், பிளாக்குகள் மற்றும் ஆவணங்கள் ஒரே இடத்திலிருந்து மேலாண்மை செய்ய தயாராக உள்ளன.",
    "Pages, blogs, and docs are ready to manage from one place.": "பக்கங்கள், பிளாக்குகள் மற்றும் ஆவணங்கள் ஒரே இடத்திலிருந்து மேலாண்மை செய்ய தயாராக உள்ளன.",
    "cms.test.action.create_page": "பக்கம் உருவாக்கு",
    "Create Page": "பக்கம் உருவாக்கு",
    "cms.test.form.description": "Layers-ல் அமைக்கப்பட்ட பக்க உள்ளடக்கத்தை உருவாக்குங்கள். சேமித்த பிறகு பக்கம் API மூலம் கிடைக்கும்.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Layers-ல் அமைக்கப்பட்ட பக்க உள்ளடக்கத்தை உருவாக்குங்கள். சேமித்த பிறகு பக்கம் API மூலம் கிடைக்கும்.",
    "cms.test.placeholder.slug": "about-us (கூடுதல் தேவையில்லை)",
    "about-us (optional)": "about-us (கூடுதல் தேவையில்லை)",
    "cms.test.draft.unsaved": "நீங்கள் சேமிக்கப்படாத ஒரு பக்க தொடக்க பதிவை உள்ளது.",
    "You have an unsaved page draft.": "நீங்கள் சேமிக்கப்படாத ஒரு பக்க தொடக்க பதிவை உள்ளது.",
    "cms.test.loading": "லேயர்ஸ் வாழ்க்கை உள்ளடக்கத்தை ஏற்றுகிறது…",
    "Loading live Layers content…": "லேயர்ஸ் வாழ்க்கை உள்ளடக்கத்தை ஏற்றுகிறது…",
    "cms.test.content.empty_title": "{type} இல்லை",
    "No {type} yet": "{type} இல்லை",
    "cms.test.content.empty_description": "இங்கு காண உங்கள் முதல் லேயரை வேலைப்பகுதியில் உருவாக்கவும்.",
    "Create your first Layer in the workspace to see it here.": "இங்கு காண உங்கள் முதல் லேயரை வேலைப்பகுதியில் உருவாக்கவும்.",
    "cms.test.feature.types": "மாற்று உள்ளடக்க வகைகள்",
    "Custom content types": "மாற்று உள்ளடக்க வகைகள்",
    "cms.test.feature.types_description": "பக்கங்கள், பிளாக்குகள் மற்றும் ஆவணங்கள் தொடக்க புள்ளிகள். உங்கள் வணிகத்திற்கு தேவையான Post அல்லது வேறு எந்த மாதிரியையும் வரையறுக்கவும்.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "பக்கங்கள், பிளாக்குகள் மற்றும் ஆவணங்கள் தொடக்க புள்ளிகள். உங்கள் வணிகத்திற்கு தேவையான Post அல்லது வேறு எந்த மாதிரியையும் வரையறுக்கவும்.",
    "cms.test.feature.structured": "இயல்பாக அமைக்கப்பட்ட அமைப்பு மற்றும் உள்ளூரமைப்பு",
    "Structured and localized": "இயல்பாக அமைக்கப்பட்ட அமைப்பு மற்றும் உள்ளூரமைப்பு",
    "cms.test.feature.structured_description": "அதே உள்ளடக்க மூலத்திற்கு சுருக்கங்கள், பிரிவுகள், படங்கள், SEO மெட்டாடேட்டாக்கள் மற்றும் மொழிபெயர்ப்புகளைப் பயன்படுத்தவும்.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "அதே உள்ளடக்க மூலத்திற்கு சுருக்கங்கள், பிரிவுகள், படங்கள், SEO மெட்டாடேட்டாக்கள் மற்றும் மொழிபெயர்ப்புகளைப் பயன்படுத்தவும்.",
    "cms.test.feature.headless": "இயல்பாக ஹெட்லெஸ்",
    "Headless by default": "இயல்பாக ஹெட்லெஸ்",
    "cms.test.feature.headless_description": "லேயர்ஸ் API-ஐ வலைத்தளம், மொபைல் பயன்பாடு, உள்ளீட்டு கருவி அல்லது தனிப்பயன் முன்பகுதியில் பயன்படுத்தவும்.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "லேயர்ஸ் API-ஐ வலைத்தளம், மொபைல் பயன்பாடு, உள்ளீட்டு கருவி அல்லது தனிப்பயன் முன்பகுதியில் பயன்படுத்தவும்.",
    "cms.test.feature.ai": "AI அறிவு மூலம்",
    "AI knowledge source": "AI அறிவு மூலம்",
    "cms.test.feature.ai_description": "Tradly CMS உள்ளடக்கத்தை AI அமைப்பு கட்டுமானத்திற்கு அறிவு மூலமாக அனுப்பவும்.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Tradly CMS உள்ளடக்கத்தை AI அமைப்பு கட்டுமானத்திற்கு அறிவு மூலமாக அனுப்பவும்.",
    "cms.test.community.eyebrow": "குழும உள்ளடக்கம்",
    "COMMUNITY CONTENT": "குழும உள்ளடக்கம்",
    "cms.test.community.title": "லேயர்ஸை சமூக பதிவு முறையாக மாற்றுங்கள்",
    "Turn Layers into a social feed": "லேயர்ஸை சமூக பதிவு முறையாக மாற்றுங்கள்",
    "cms.test.community.description": "தனிப்பயன் Post வகையை உருவாக்கி, பயனர்களுக்கு புதுப்பிப்புகளை பதிவிட அனுமதிக்கவும் மற்றும் உங்கள் முன்பகுதி மூலம் தொடர்பு சேர்க்கவும்.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "தனிப்பயன் Post வகையை உருவாக்கி, பயனர்களுக்கு புதுப்பிப்புகளை பதிவிட அனுமதிக்கவும் மற்றும் உங்கள் முன்பகுதி மூலம் தொடர்பு சேர்க்கவும்.",
    "cms.test.community.share_placeholder": "புதுப்பிப்பைப் பகிரவும்…",
    "Share an update…": "புதுப்பிப்பைப் பகிரவும்…",
    "cms.test.community.post": "பதிவிடுதல்",
    "Post": "பதிவிடுதல்",
    "cms.test.community.sample_author": "ஆலெக்ஸ் மார்கன்",
    "Alex Morgan": "ஆலெக்ஸ் மார்கன்",
    "cms.test.community.sample_post": "தனிப்பயன் லேயரிலிருந்து பதிவிடப்பட்ட சமூக புதுப்பிப்பு.",
    "A community update published from a custom Layer.": "தனிப்பயன் லேயரிலிருந்து பதிவிடப்பட்ட சமூக புதுப்பிப்பு.",
    "cms.test.community.sample_actions": "♡ 24 · 💬 6 கருத்துகள் · ↗ பகிர்வு",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24 · 💬 6 கருத்துகள் · ↗ பகிர்வு",
    "cms.test.community.endpoints": "எண்ட்பாயிண்ட் எடுத்துக்காட்டுகள்",
    "Example endpoints": "எண்ட்பாயிண்ட் எடுத்துக்காட்டுகள்",
    "cms.test.developer.eyebrow": "மேம்படுத்துதல் அணுகல்",
    "DEVELOPER ACCESS": "மேம்படுத்துதல் அணுகல்",
    "cms.test.developer.title": "லேயர்ஸ் API",
    "Layers API": "லேயர்ஸ் API",
    "cms.test.developer.docs": "மேம்படுத்துதல் ஆவணங்கள்",
    "Developer docs": "மேம்படுத்துதல் ஆவணங்கள்",
    "auth.title": "முகவரி உறுதிப்படுத்தல்",
    "auth.sign_in_method": "முகவரி தொடங்கும் முறை",
    "auth.facebook_auth": "ஃபேஸ்புக் உறுதிப்படுத்தல்",
    "auth.google_auth": "கூகிள் உறுதிப்படுத்தல்",
    "auth.twilio": "ட்விலியோ",
    "auth.enterprise_sso": "நிறுவன ஒற்றை உள்நுழைவு (SSO)",
    "Enterprise SSO": "நிறுவன ஒற்றை உள்நுழைவு (SSO)",
    "auth.admob": "அட்மோப்",
    "Admob": "அட்மோப்",
    "checkout.title": "செலுத்தும் அமைப்புகள்",
    "Checkout Settings": "செலுத்தும் அமைப்புகள்",
    "checkout.orders": "ஆர்டர்கள்",
    "checkout.carts": "கார்டுகள்",
    "Carts": "கார்டுகள்",
    "audit_logs.action": "செயல்பாடு",
    "audit_logs.resource": "பொருள்",
    "audit_logs.resource_id": "பொருள் ID",
    "Resource ID": "பொருள் ID",
    "audit_logs.agent_id": "ஏஜென்ட் ID",
    "Agent ID": "ஏஜென்ட் ID",
    "audit_logs.result": "முடிவு",
    "audit_logs.actor_id": "நடிகர் ID",
    "Actor ID": "நடிகர் ID",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "நேர அடையாளம்",
    "Timestamp": "நேர அடையாளம்",
    "audit_logs.succeeded": "வெற்றி",
    "audit_logs.failed": "தோல்வி",
    "audit_logs.source": "மூலம்",
    "audit_logs.all_sources": "எல்லா மூலங்களும்",
    "All sources": "எல்லா மூலங்களும்",
    "audit_logs.human_admin": "மனிதன் (நிர்வாகி)",
    "Human (admin)": "மனிதன் (நிர்வாகி)",
    "audit_logs.agent_mcp": "ஏஜென்ட் (MCP)",
    "Agent (MCP)": "ஏஜென்ட் (MCP)",
    "audit_logs.all_actions": "எல்லா செயல்களும்",
    "All actions": "எல்லா செயல்களும்",
    "audit_logs.from": "முதல்",
    "audit_logs.to": "வரை",
    "audit_logs.apply": "பயன்படுத்து",
    "audit_logs.clear": "அகற்று",
    "audit_logs.export_csv": "CSV ஏற்றுமதி செய்யவும்",
    "audit_logs.exporting": "ஏற்றுமதி செய்து கொண்டிருக்கிறது…",
    "audit_logs.title": "ஆடிட் பதிவுகள்",
    "audit_logs.empty_title": "ஆடிட் பதிவுகள் கிடைக்கவில்லை",
    "No audit logs found": "ஆடிட் பதிவுகள் கிடைக்கவில்லை",
    "audit_logs.empty_subtitle": "தேர்வுகளை திருத்தி முயற்சிக்கவும்",
    "Try adjusting your filters": "தேர்வுகளை திருத்தி முயற்சிக்கவும்",
    "audit_logs.restriction_notice": "கடைசி 5 ஆடிட் பதிவுகள் காட்டப்பட்டுள்ளன. முழு வரலாற்றையும் ஏற்றுமதி செய்ய கிரோத் பதிப்புக்கு மேம்படுத்தவும்.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "கடைசி 5 ஆடிட் பதிவுகள் காட்டப்பட்டுள்ளன. முழு வரலாற்றையும் ஏற்றுமதி செய்ய கிரோத் பதிப்புக்கு மேம்படுத்தவும்.",
    "audit_logs.extended_history": "ஆடிட் பதிவுகளின் நீட்டிக்கப்பட்ட வரலாறு",
    "Extended audit log history": "ஆடிட் பதிவுகளின் நீட்டிக்கப்பட்ட வரலாறு",
    "manage_features.title": "அம்சங்களை நிர்வகிக்கவும்",
    "manage_features.general": "பொது",
    "manage_features.apps": "பயன்பாடுகள்",
    "manage_features.marketplace": "மார்க்கெட்பிளேஸ்",
    "manage_features.commerce": "வர்த்தகம்",
    "manage_features.channels": "வழித்தடங்கள்",
    "manage_features.left_menu": "இடது பக்க மெனு",
    "Left Menu": "இடது பக்க மெனு",
    "manage_features.right_sidepanel": "வலது பக்க பானல்",
    "Right Sidepanel": "வலது பக்க பானல்",
    "workflow.integration": "ஒன்றிணைப்பு",
    "workflow.no_url_title": "ஒன்றிணைப்பு URL இல்லை",
    "No Integration URL": "ஒன்றிணைப்பு URL இல்லை",
    "workflow.no_url_description": "ஒன்றிணைப்பு URL-ஐ அமைக்கவும்.",
    "Please configure the integration URL.": "ஒன்றிணைப்பு URL-ஐ அமைக்கவும்.",
    "workflow.back": "திரும்பு",
    "Go Back": "திரும்பு",
    "workflow.loading": "உள்ளீடு கொண்டு வருகிறது...",
    "Loading integration...": "உள்ளீடு கொண்டு வருகிறது...",
    "workflow.loading_hint": "இணைப்பு செய்யப்படும் வரை காத்திருக்கவும்",
    "Please wait while we connect": "இணைப்பு செய்யப்படும் வரை காத்திருக்கவும்",
    "workflow.error_title": "உள்ளீட்டு பிழை",
    "Integration Error": "உள்ளீட்டு பிழை",
    "workflow.error_description": "உள்ளீட்டை ஏற்ற முடியவில்லை. உங்கள் இணைப்பை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to load the integration. Please check your connection and try again.": "உள்ளீட்டை ஏற்ற முடியவில்லை. உங்கள் இணைப்பை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "workflow.retry": "மீண்டும் முயற்சிக்கவும்",
    "Try Again": "மீண்டும் முயற்சிக்கவும்",
    "upgrade_preview.eyebrow": "கூறு முன்னோட்டம்",
    "Component preview": "கூறு முன்னோட்டம்",
    "upgrade_preview.title": "மேம்படுத்தல் அனுபவம்",
    "Upgrade experience": "மேம்படுத்தல் அனுபவம்",
    "upgrade_preview.description": "மேம்படுத்திய பிறகு வாடிக்கையாளர் அடைய முடியும் விஷயங்களை மையமாகக் கொண்ட பகிரப்பட்ட அம்ச கதவு.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "மேம்படுத்திய பிறகு வாடிக்கையாளர் அடைய முடியும் விஷயங்களை மையமாகக் கொண்ட பகிரப்பட்ட அம்ச கதவு.",
    "upgrade_preview.feature": "வித்தியாசத்தை சேர்க்கவும்",
    "Add a variant": "வித்தியாசத்தை சேர்க்கவும்",
    "upgrade_preview.context": "இது அடிப்படை திட்ட பயனர் அம்ச எல்லையை அடையும் தற்போதைய புள்ளி.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "இது அடிப்படை திட்ட பயனர் அம்ச எல்லையை அடையும் தற்போதைய புள்ளி.",
    "upgrade_preview.button": "மேம்படுத்தல் பலகையின் முன்னோட்டம்",
    "Preview upgrade panel": "மேம்படுத்தல் பலகையின் முன்னோட்டம்",
    "upgrade_preview.listing_context": "இந்த பட்டியலுக்கு",
    "For this listing": "இந்த பட்டியலுக்கு",
    "gamification_test.eyebrow": "வளர்ச்சி கேமிபிகேஷன் · சோதனை பாதை",
    "GROWTH GAMIFICATION · TEST ROUTE": "வளர்ச்சி கேமிபிகேஷன் · சோதனை பாதை",
    "gamification_test.title": "உங்கள் வணிகத்திற்கு உந்துதலை உருவாக்குங்கள்",
    "Build momentum for your business": "உங்கள் வணிகத்திற்கு உந்துதலை உருவாக்குங்கள்",
    "gamification_test.subtitle": "{workspace} க்கான திட்டங்கள், பொன் பந்துகள், பதக்கங்கள் மற்றும் தொடர்ச்சியை முன்னோட்டமாக பார்க்கவும்.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "{workspace} க்கான திட்டங்கள், பொன் பந்துகள், பதக்கங்கள் மற்றும் தொடர்ச்சியை முன்னோட்டமாக பார்க்கவும்.",
    "gamification_test.this_workspace": "இந்த வேலை இடம்",
    "this workspace": "இந்த வேலை இடம்",
    "gamification_test.coins": "பொன் பந்துகள்",
    "COINS": "பொன் பந்துகள்",
    "gamification_test.points": "புள்ளிகள்",
    "POINTS": "புள்ளிகள்",
    "gamification_test.streak": "தொடர்",
    "STREAK": "தொடர்",
    "gamification_test.week": "1 வாரம்",
    "1 week": "1 வாரம்",
    "gamification_test.launch": "தொடங்கும் பாதை",
    "Launch path": "தொடங்கும் பாதை",
    "gamification_test.progress": "{completed} {total} செயல்கள் முடிக்கப்பட்டுள்ளது · {coins} பொன் பந்துகள் வரை",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} {total} செயல்கள் முடிக்கப்பட்டுள்ளது · {coins} பொன் பந்துகள் வரை",
    "gamification_test.done": "முடிந்தது",
    "gamification_test.reward": "+{count} பொன் பந்துகள்",
    "+{count} coins": "+{count} பொன் பந்துகள்",
    "gamification_test.badges": "முத்திரைகள்",
    "Badges": "முத்திரைகள்",
    "gamification_test.mission_listing_created": "முதல் பட்டியலை உருவாக்குங்கள்",
    "Create your first listing": "முதல் பட்டியலை உருவாக்குங்கள்",
    "gamification_test.mission_collection_created": "முதல் தொகுப்பை உருவாக்குங்கள்",
    "gamification_test.mission_payment_configured": "பேமென்ட்களை அமைக்கவும்",
    "Configure payments": "பேமென்ட்களை அமைக்கவும்",
    "gamification_test.mission_publish_completed": "திரையிடுங்கள் உங்கள் தளம்",
    "Publish your site": "திரையிடுங்கள் உங்கள் தளம்",
    "gamification_test.mission_analytics_enabled": "பகுப்பாய்வுகளை இயக்கவும்",
    "Enable analytics": "பகுப்பாய்வுகளை இயக்கவும்",
    "gamification_test.badge_first_step": "முதல் படி",
    "First Step": "முதல் படி",
    "gamification_test.badge_catalog_builder": "கத்தாலாக் கட்டுமானி",
    "Catalog Builder": "கத்தாலாக் கட்டுமானி",
    "gamification_test.badge_ready_to_sell": "விற்பனைக்கு தயார்",
    "Ready to Sell": "விற்பனைக்கு தயார்",
    "gamification_test.badge_data_driven": "தரவு அடிப்படையிலான",
    "Data Driven": "தரவு அடிப்படையிலான",
    "gamification_test.badge_growth_operator": "வளர்ச்சி இயக்கி",
    "Growth Operator": "வளர்ச்சி இயக்கி",
    "sentry_check.title": "சென்ட்ரி அமைப்பு சரிபார்ப்பு",
    "Sentry Configuration Check": "சென்ட்ரி அமைப்பு சரிபார்ப்பு",
    "sentry_check.subtitle": "சென்ட்ரி பிழை தொடர்பு அமைப்பை சோதித்து சரிபார்க்கவும்",
    "Test and verify Sentry error tracking setup": "சென்ட்ரி பிழை தொடர்பு அமைப்பை சோதித்து சரிபார்க்கவும்",
    "sentry_check.configuration": "அமைப்பு",
    "sentry_check.check_configuration": "அமைப்பைப் பார்க்கவும்",
    "Check Configuration": "அமைப்பைப் பார்க்கவும்",
    "sentry_check.status": "நிலை:",
    "Status:": "நிலை:",
    "sentry_check.enabled": "✓ இயக்கப்பட்டுள்ளது",
    "✓ Enabled": "✓ இயக்கப்பட்டுள்ளது",
    "sentry_check.disabled": "✗ அமைக்கப்படவில்லை",
    "✗ Disabled": "✗ அமைக்கப்படவில்லை",
    "sentry_check.environment": "சூழல்:",
    "Environment:": "சூழல்:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "தொடர்பு மாதிரி விகிதம்:",
    "Traces Sample Rate:": "தொடர்பு மாதிரி விகிதம்:",
    "sentry_check.test_functions": "சோதனை செயல்பாடுகள்",
    "Test Functions": "சோதனை செயல்பாடுகள்",
    "sentry_check.test_hint": "சென்ட்ரி வேறுபட்ட செயல்பாடுகளை சோதிக்க, கீழே உள்ள பொத்தான்களை அழுத்தவும். நிகழ்வுகள் பதிவு செய்யப்படுகின்றன என்பதை உங்கள் சென்ட்ரி பலகையில் சரிபார்க்கவும்.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "சென்ட்ரி வேறுபட்ட செயல்பாடுகளை சோதிக்க, கீழே உள்ள பொத்தான்களை அழுத்தவும். நிகழ்வுகள் பதிவு செய்யப்படுகின்றன என்பதை உங்கள் சென்ட்ரி பலகையில் சரிபார்க்கவும்.",
    "sentry_check.test_results": "சோதனை முடிவுகள்",
    "Test Results": "சோதனை முடிவுகள்",
    "sentry_check.clear": "நீக்கு",
    "sentry_check.no_tests": "முன்னர் சோதனைகள் இல்லை",
    "No tests run yet": "முன்னர் சோதனைகள் இல்லை",
    "sentry_check.important_notes": "⚠️ முக்கிய குறிப்புகள்",
    "⚠️ Important Notes": "⚠️ முக்கிய குறிப்புகள்",
    "sentry_check.warning_real_events": "• இந்த சோதனைகள் உங்கள் சென்ட்ரி டாஷ்போர்டில் உண்மையான பிழை நிகழ்வுகளை உருவாக்கும்",
    "• These tests will create real error events in your Sentry dashboard": "• இந்த சோதனைகள் உங்கள் சென்ட்ரி டாஷ்போர்டில் உண்மையான பிழை நிகழ்வுகளை உருவாக்கும்",
    "sentry_check.warning_dashboard": "• நிகழ்வுகள் பதிவு செய்யப்படுகின்றன என்பதை உறுதிப்படுத்த உங்கள் சென்ட்ரி டாஷ்போர்டை சரிபார்க்கவும்",
    "• Check your Sentry dashboard to verify events are being captured": "• நிகழ்வுகள் பதிவு செய்யப்படுகின்றன என்பதை உறுதிப்படுத்த உங்கள் சென்ட்ரி டாஷ்போர்டை சரிபார்க்கவும்",
    "sentry_check.warning_traces": "• tracesSampleRate 0.0 எனில் சில சோதனைகள் சென்ட்ரியில் தெரியாது",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• tracesSampleRate 0.0 எனில் சில சோதனைகள் சென்ட்ரியில் தெரியாது",
    "sentry_check.warning_dsn": "• உங்கள் DSN சூழல் மாறிகளில் சரியாக அமைக்கப்பட்டுள்ளது என்பதை உறுதிப்படுத்தவும்",
    "• Make sure your DSN is correctly configured in environment variables": "• உங்கள் DSN சூழல் மாறிகளில் சரியாக அமைக்கப்பட்டுள்ளது என்பதை உறுதிப்படுத்தவும்",
    "sentry_check.normal_error": "சோதனை சாதாரண பிழை",
    "Test Normal Error": "சோதனை சாதாரண பிழை",
    "sentry_check.test_normal_error": "சோதனை சாதாரண பிழை",
    "sentry_check.test_message": "சோதனை செய்தியை",
    "Test Message": "சோதனை செய்தியை",
    "sentry_check.test_breadcrumb": "சோதனை பிரிவு",
    "Test Breadcrumb": "சோதனை பிரிவு",
    "sentry_check.test_user_context": "சோதனை பயனர் சூழல்",
    "Test User Context": "சோதனை பயனர் சூழல்",
    "sentry_check.test_custom_exception": "சோதனை தனிப்பயன் பிழை",
    "Test Custom Exception": "சோதனை தனிப்பயன் பிழை",
    "sentry_check.test_promise_rejection": "சோதனை முன்னேற்ற திரும்பப் பெறுதல்",
    "Test Promise Rejection": "சோதனை முன்னேற்ற திரும்பப் பெறுதல்",
    "sentry_check.configuration_check": "அமைப்பு சரிபார்ப்பு",
    "Configuration Check": "அமைப்பு சரிபார்ப்பு",
    "sentry_check.config_loaded": "அமைப்பு வெற்றிகரமாக ஏற்றப்பட்டது",
    "Config loaded successfully": "அமைப்பு வெற்றிகரமாக ஏற்றப்பட்டது",
    "sentry_check.error_captured": "பிழை பதிவு செய்யப்பட்டு சென்ட்ரிக்கு அனுப்பப்பட்டது",
    "Error captured and sent to Sentry": "பிழை பதிவு செய்யப்பட்டு சென்ட்ரிக்கு அனுப்பப்பட்டது",
    "sentry_check.error_capture_failed": "பிழை பதிவு செய்ய முடியவில்லை: {message}",
    "Failed to capture error: {message}": "பிழை பதிவு செய்ய முடியவில்லை: {message}",
    "sentry_check.message": "செய்தி",
    "Message": "செய்தி",
    "sentry_check.message_captured": "செய்தி பதிவு செய்யப்பட்டு சென்ட்ரிக்கு அனுப்பப்பட்டது",
    "Message captured and sent to Sentry": "செய்தி பதிவு செய்யப்பட்டு சென்ட்ரிக்கு அனுப்பப்பட்டது",
    "sentry_check.message_capture_failed": "செய்தி பதிவு செய்ய முடியவில்லை: {message}",
    "Failed to capture message: {message}": "செய்தி பதிவு செய்ய முடியவில்லை: {message}",
    "sentry_check.breadcrumb": "பிரிவு",
    "Breadcrumb": "பிரிவு",
    "sentry_check.breadcrumb_added": "சென்ட்ரி சூழலில் பிரிவு சேர்க்கப்பட்டது",
    "Breadcrumb added to Sentry context": "சென்ட்ரி சூழலில் பிரிவு சேர்க்கப்பட்டது",
    "sentry_check.breadcrumb_failed": "பிரிவு சேர்க்க முடியவில்லை: {message}",
    "Failed to add breadcrumb: {message}": "பிரிவு சேர்க்க முடியவில்லை: {message}",
    "sentry_check.user_context": "பயனர் சூழல்",
    "User Context": "பயனர் சூழல்",
    "sentry_check.user_set": "Sentry-இல் பயனர் சூழல் அமைக்கப்பட்டது",
    "User context set in Sentry": "Sentry-இல் பயனர் சூழல் அமைக்கப்பட்டது",
    "sentry_check.user_failed": "பயனர் சூழலை அமைக்க முடியவில்லை: {message}",
    "Failed to set user context: {message}": "பயனர் சூழலை அமைக்க முடியவில்லை: {message}",
    "sentry_check.custom_exception": "மாற்று தவறு",
    "Custom Exception": "மாற்று தவறு",
    "sentry_check.custom_sent": "Sentry-க்கு அனுப்பப்பட்ட மாற்று தவறு சூழல்",
    "Custom exception with context sent to Sentry": "Sentry-க்கு அனுப்பப்பட்ட மாற்று தவறு சூழல்",
    "sentry_check.custom_failed": "மாற்று தவறை பதிவு செய்ய முடியவில்லை: {message}",
    "Failed to capture custom exception: {message}": "மாற்று தவறை பதிவு செய்ய முடியவில்லை: {message}",
    "sentry_check.promise_rejection": "நம்பிக்கை மறுப்பு",
    "Promise Rejection": "நம்பிக்கை மறுப்பு",
    "sentry_check.promise_captured": "Sentry-க்கு அனுப்பப்பட்ட நம்பிக்கை மறுப்பு",
    "Promise rejection captured and sent to Sentry": "Sentry-க்கு அனுப்பப்பட்ட நம்பிக்கை மறுப்பு",
    "sentry_check.promise_failed": "நம்பிக்கை மறுப்பை நிர்வகிக்க முடியவில்லை: {message}",
    "Failed to handle promise rejection: {message}": "நம்பிக்கை மறுப்பை நிர்வகிக்க முடியவில்லை: {message}",
    "checkout_settings.orders": "ஆர்டர்கள்",
    "checkout_settings.return_policy_days": "திரும்ப வழங்கும் கொள்கை நாட்கள்",
    "Return policy days": "திரும்ப வழங்கும் கொள்கை நாட்கள்",
    "checkout_settings.enter_return_policy_days": "திரும்ப வழங்கும் கொள்கை நாட்களை உள்ளிடவும்",
    "Enter return policy days": "திரும்ப வழங்கும் கொள்கை நாட்களை உள்ளிடவும்",
    "checkout_settings.saved": "வெற்றிகரமாக பதிவேற்றம் செய்யப்பட்டது",
    "checkout_settings.cart": "கார்ட்",
    "checkout_settings.hide_quantity_selection": "அளவுத் தேர்வை மறைக்கவும் (இயல்புநிலை: அளவைத் தேர்வு செய்ய புலம் காட்டப்படுகிறது)",
    "Hide quantity selection (Default: Shows field to select quantity)": "அளவுத் தேர்வை மறைக்கவும் (இயல்புநிலை: அளவைத் தேர்வு செய்ய புலம் காட்டப்படுகிறது)",
    "checkout_settings.enable_coupon": "கூப்பனை செயல்படுத்து",
    "Enable Coupon": "கூப்பனை செயல்படுத்து",
    "upgrade_page.copy.a_practical_next_step": "ஒரு செயல்பாட்டு அடுத்த படி",
    "A practical next step": "ஒரு செயல்பாட்டு அடுத்த படி",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "உங்கள் பணிச்செயல்முறைக்கு தேவையான அமைப்பு தகவலைச் சேர்க்கவும்",
    "Add the structured information your workflow needs.": "உங்கள் பணிச்செயல்முறைக்கு தேவையான அமைப்பு தகவலைச் சேர்க்கவும்",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "அனைத்து குழு உறுப்பினர்களுக்கும் பங்குகள் மற்றும் அனுமதிகளை ஒதுக்கவும்",
    "Assign roles and permissions to every teammate.": "அனைத்து குழு உறுப்பினர்களுக்கும் பங்குகள் மற்றும் அனுமதிகளை ஒதுக்கவும்",
    "upgrade_page.copy.audit_log_export": "ஆடிட் லாக் ஏற்றுமதி",
    "Audit log export": "ஆடிட் லாக் ஏற்றுமதி",
    "upgrade_page.copy.best_next_step": "மிகச்சிறந்த அடுத்த படி",
    "Best next step": "மிகச்சிறந்த அடுத்த படி",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "அமைப்பு பதிவுகளை கொண்டுவர, ஆஃப்லைன் மாற்றங்களைச் செய்து, உங்கள் குழுவிற்கு முழுமையான பணியாக்கப்பட்ட நகலை தேவைப்படும்போது அதனை ஏற்றுமதி செய்யவும்",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "அமைப்பு பதிவுகளை கொண்டுவர, ஆஃப்லைன் மாற்றங்களைச் செய்து, உங்கள் குழுவிற்கு முழுமையான பணியாக்கப்பட்ட நகலை தேவைப்படும்போது அதனை ஏற்றுமதி செய்யவும்",
    "upgrade_page.copy.build_beyond_the_standard_interface": "தொடர்பு வடிவமைப்பை மேலும் விரிவாக்கு",
    "Build beyond the standard interface": "தொடர்பு வடிவமைப்பை மேலும் விரிவாக்கு",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "உங்கள் பட்டியலை பயனுள்ளதாக்கும் விவரங்களைப் பதிவு செய்யவும்",
    "Capture the details that make your catalogue useful.": "உங்கள் பட்டியலை பயனுள்ளதாக்கும் விவரங்களைப் பதிவு செய்யவும்",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Tradly-ன் மேல் உங்கள் சொந்த வாடிக்கையாளர் முகமையான அனுபவங்களை உருவாக்க விரும்பும் திறனைத் தேர்வு செய்யவும்.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Tradly-ன் மேல் உங்கள் சொந்த வாடிக்கையாளர் முகமையான அனுபவங்களை உருவாக்க விரும்பும் திறனைத் தேர்வு செய்யவும்.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "உள்ள பட்டியல்களை தேர்ந்தெடுக்கப்பட்ட குழுக்களாக இணைத்து, வாடிக்கையாளர்களுக்கு செல்லிங் போது தேர்ந்தெடுக்கக்கூடிய பொருட்களை அனுமதிக்கவும்.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "உள்ள பட்டியல்களை தேர்ந்தெடுக்கப்பட்ட குழுக்களாக இணைத்து, வாடிக்கையாளர்களுக்கு செல்லிங் போது தேர்ந்தெடுக்கக்கூடிய பொருட்களை அனுமதிக்கவும்.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "பல்வேறு பிராந்தியங்களில் இயங்கும்போது உங்கள் வணிகத்திற்கு தேவையான நாணயங்களை அமைக்கவும்.",
    "Configure the currencies your business needs as you operate across regions.": "பல்வேறு பிராந்தியங்களில் இயங்கும்போது உங்கள் வணிகத்திற்கு தேவையான நாணயங்களை அமைக்கவும்.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "கையால் செய்யப்படும் வேலைகள் மேலும் பெரிய அளவில் செயல்பட முடியாத போது, உங்கள் மார்க்கெட்பிளேஸ்ஸை உள்ளூர் கருவிகளுடனும் தானியங்கி அமைப்புகளுடனும் இணைக்கவும்.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "கையால் செய்யப்படும் வேலைகள் மேலும் பெரிய அளவில் செயல்பட முடியாத போது, உங்கள் மார்க்கெட்பிளேஸ்ஸை உள்ளூர் கருவிகளுடனும் தானியங்கி அமைப்புகளுடனும் இணைக்கவும்.",
    "upgrade_page.copy.connect_your_own_tools": "உங்கள் சொந்த கருவிகளை இணைக்கவும்",
    "Connect your own tools": "உங்கள் சொந்த கருவிகளை இணைக்கவும்",
    "upgrade_page.copy.control_who_can_see_and_change_what": "எவர் எதைப் பார்க்க மற்றும் மாற்ற முடியும் என்பதை கட்டுப்படுத்தவும்.",
    "Control who can see and change what.": "எவர் எதைப் பார்க்க மற்றும் மாற்ற முடியும் என்பதை கட்டுப்படுத்தவும்.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "ஒவ்வொரு பட்டியல் அல்லது கணக்கிலும் வாடிக்கையாளர்கள் மற்றும் உங்கள் அணியினர் பார்க்க தேவையான உண்மைகளுக்கான தனிப்பயன் புலங்களை உருவாக்கவும்.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "ஒவ்வொரு பட்டியல் அல்லது கணக்கிலும் வாடிக்கையாளர்கள் மற்றும் உங்கள் அணியினர் பார்க்க தேவையான உண்மைகளுக்கான தனிப்பயன் புலங்களை உருவாக்கவும்.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "நிலையான மற்றும் கலப்பு-மாற்று பேக்கேஜ்களை உருவாக்கவும்.",
    "Create fixed and mix-and-match bundles.": "நிலையான மற்றும் கலப்பு-மாற்று பேக்கேஜ்களை உருவாக்கவும்.",
    "upgrade_page.copy.custom_attributes": "தனிப்பயன் பண்புகள்",
    "Custom attributes": "தனிப்பயன் பண்புகள்",
    "upgrade_page.copy.custom_email_templates": "தனிப்பயன் மின்னஞ்சல் மாதிரிகள்",
    "Custom email templates": "தனிப்பயன் மின்னஞ்சல் மாதிரிகள்",
    "upgrade_page.copy.email_whitelabelling": "மின்னஞ்சல் பிராண்டிங்",
    "Email whitelabelling": "மின்னஞ்சல் பிராண்டிங்",
    "upgrade_page.copy.everything_in_growth": "Growth-ல் அனைத்தும்",
    "Everything in Growth": "Growth-ல் அனைத்தும்",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Growth-ல் அனைத்தும், அதிக வரம்புகளுடன்.",
    "Everything in Growth, with the highest limits.": "Growth-ல் அனைத்தும், அதிக வரம்புகளுடன்.",
    "upgrade_page.copy.everything_in_starter": "Starter-ல் அனைத்தும்",
    "Everything in Starter": "Starter-ல் அனைத்தும்",
    "upgrade_page.copy.expand_your_workspace": "உங்கள் வேலை இடத்தை விரிவாக்கவும்",
    "Expand your workspace": "உங்கள் வேலை இடத்தை விரிவாக்கவும்",
    "upgrade_page.copy.feature_access": "அம்சங்களுக்கான அணுகல்",
    "Feature access": "அம்சங்களுக்கான அணுகல்",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "விரைவாக வளரும் பட்டியலுக்கு தெளிவான பொருள் தேர்வுகள் தேவைப்படும்.",
    "For a growing catalogue that needs clearer product choices.": "விரைவாக வளரும் பட்டியலுக்கு தெளிவான பொருள் தேர்வுகள் தேவைப்படும்.",
    "upgrade_page.copy.for_established_businesses": "நிலையான வணிகங்களுக்கு",
    "For established businesses": "நிலையான வணிகங்களுக்கு",
    "upgrade_page.copy.for_growing_operations": "வளரும் பணிகளுக்கு",
    "For growing operations": "வளரும் பணிகளுக்கு",
    "upgrade_page.copy.for_growing_teams": "வளரும் அணிகளுக்கு",
    "For growing teams": "வளரும் அணிகளுக்கு",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "பெரிய அளவில் இயங்க வேண்டிய உயர் கனம் கொண்ட அணிகளுக்கு.",
    "For high-volume teams that need room to operate at scale.": "பெரிய அளவில் இயங்க வேண்டிய உயர் கனம் கொண்ட அணிகளுக்கு.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "பெரிய பட்டியலையும் அதிக வேலை ஒழுங்கையும் கையாளும் அணிகளுக்கு.",
    "For teams managing a larger catalogue and more workflows.": "பெரிய பட்டியலையும் அதிக வேலை ஒழுங்கையும் கையாளும் அணிகளுக்கு.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "ஒரே நேரத்தில் ஒரு பதிவை மட்டும் கையாள தயாரான அணிகளுக்கு.",
    "For teams ready to work beyond one record at a time.": "ஒரே நேரத்தில் ஒரு பதிவை மட்டும் கையாள தயாரான அணிகளுக்கு.",
    "upgrade_page.copy.full_audit_history": "முழுமையான ஆடிட் வரலாறு",
    "Full audit history": "முழுமையான ஆடிட் வரலாறு",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "கிரோத் மற்றும் ஸ்கேல் திட்டங்கள் முழுமையான ஆடிட் வரலாற்றை மீண்டும் பார்க்கவும் மற்றும் பொறுப்பு வேலை ஓட்டங்களுக்காக அதை ஏற்றிமாற்றலாம்.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "கிரோத் மற்றும் ஸ்கேல் திட்டங்கள் முழுமையான ஆடிட் வரலாற்றை மீண்டும் பார்க்கவும் மற்றும் பொறுப்பு வேலை ஓட்டங்களுக்காக அதை ஏற்றிமாற்றலாம்.",
    "upgrade_page.copy.higher_usage_limits": "அதிக பயன்பாட்டு வரம்புகள்",
    "Higher usage limits": "அதிக பயன்பாட்டு வரம்புகள்",
    "upgrade_page.copy.highest_usage_limits": "அதிக பயன்பாட்டு வரம்புகள்",
    "Highest usage limits": "அதிக பயன்பாட்டு வரம்புகள்",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "மீண்டும் மீண்டும் கையால் வேலை இல்லாமல் பதிவுகளை இறக்குமதி மற்றும் ஏற்றுமதி செய்யவும்.",
    "Import and export records without repetitive manual work.": "மீண்டும் மீண்டும் கையால் வேலை இல்லாமல் பதிவுகளை இறக்குமதி மற்றும் ஏற்றுமதி செய்யவும்.",
    "upgrade_page.copy.import_and_export_tools": "இறக்குமதி மற்றும் ஏற்றுமதி கருவிகள்",
    "Import and export tools": "இறக்குமதி மற்றும் ஏற்றுமதி கருவிகள்",
    "upgrade_page.copy.improve_important_customer_messages": "முக்கிய வாடிக்கையாளர் செய்திகளை மேம்படுத்துங்கள்",
    "Improve important customer messages": "முக்கிய வாடிக்கையாளர் செய்திகளை மேம்படுத்துங்கள்",
    "upgrade_page.copy.keep_a_longer_compliance_history": "நீண்ட கால பொறுப்பு வரலாற்றை பராமரிக்கவும்",
    "Keep a longer compliance history": "நீண்ட கால பொறுப்பு வரலாற்றை பராமரிக்கவும்",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "உயர் கனிம இயக்கங்களுக்கு முழுமையான பொறுப்பு பார்வையை பராமரிக்கவும்.",
    "Keep complete compliance visibility for high-volume operations.": "உயர் கனிம இயக்கங்களுக்கு முழுமையான பொறுப்பு பார்வையை பராமரிக்கவும்.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "கத்தாலாக் வளரும்போது அதிக தரவுகள் மற்றும் வேலை ஓட்டங்களை அமைத்து வைக்கவும்.",
    "Keep more data and workflows organised as the catalogue grows.": "கத்தாலாக் வளரும்போது அதிக தரவுகள் மற்றும் வேலை ஓட்டங்களை அமைத்து வைக்கவும்.",
    "upgrade_page.copy.keep_your_workspace_secure": "உங்கள் வேலை இடத்தை பாதுகாப்பாக வைக்கவும்",
    "Keep your workspace secure": "உங்கள் வேலை இடத்தை பாதுகாப்பாக வைக்கவும்",
    "upgrade_page.copy.large": "பெரியது",
    "Large": "பெரியது",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "வாடிக்கையாளர்கள் ஒரே பட்டியலிலிருந்து தேர்வுகளை தேர்ந்தெடுக்க அனுமதிக்கவும்.",
    "Let customers choose options from one listing.": "வாடிக்கையாளர்கள் ஒரே பட்டியலிலிருந்து தேர்வுகளை தேர்ந்தெடுக்க அனுமதிக்கவும்.",
    "upgrade_page.copy.listing_variants": "பட்டியல் வகைகள்",
    "Listing variants": "பட்டியல் வகைகள்",
    "upgrade_page.copy.make_every_customer_email_yours": "ஒவ்வொரு வாடிக்கையாளர் மின்னஞ்சலையும் உங்களுடையதாக்கவும்",
    "Make every customer email yours": "ஒவ்வொரு வாடிக்கையாளர் மின்னஞ்சலையும் உங்களுடையதாக்கவும்",
    "upgrade_page.copy.make_one_listing_work_harder": "ஒரே பட்டியலை அதிகம் உழைக்க செய்யவும்",
    "Make one listing work harder": "ஒரே பட்டியலை அதிகம் உழைக்க செய்யவும்",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "குறிப்பிட்ட வேலை ஓட்டத்திற்கும் குரலுக்கும் ஏற்ப அமைக்கவும்.",
    "Make system emails match your workflow and tone.": "குறிப்பிட்ட வேலை ஓட்டத்திற்கும் குரலுக்கும் ஏற்ப அமைக்கவும்.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "உங்கள் திட்டத்தை அதிக மொழிகளில் கிடைக்க செய்யவும்.",
    "Make your project available in more languages.": "உங்கள் திட்டத்தை அதிக மொழிகளில் கிடைக்க செய்யவும்.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "புதிய பிராந்தியங்கள் மற்றும் பார்வையாளர்களை விரிவாக்கும்போது வாடிக்கையாளர் மொழி அனுபவத்தை மேற்கொள்ளவும்.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "புதிய பிராந்தியங்கள் மற்றும் பார்வையாளர்களை விரிவாக்கும்போது வாடிக்கையாளர் மொழி அனுபவத்தை மேற்கொள்ளவும்.",
    "upgrade_page.copy.medium": "நடுத்தரம்",
    "upgrade_page.copy.more_capacity": "அதிக திறன்",
    "More capacity": "அதிக திறன்",
    "upgrade_page.copy.more_storage": "அதிக சேமிப்பு",
    "More storage": "அதிக சேமிப்பு",
    "upgrade_page.copy.more_team_capacity": "குழுவிற்கு அதிக திறன்",
    "More team capacity": "குழுவிற்கு அதிக திறன்",
    "upgrade_page.copy.move_faster_with_your_catalogue": "உங்கள் பட்டியலை வேகமாக நகர்த்தவும்",
    "Move faster with your catalogue": "உங்கள் பட்டியலை வேகமாக நகர்த்தவும்",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "பெரிய கத்தாலாக்குகள் மற்றும் குழுக்களை அதிக வேகத்தில் கையாளவும்.",
    "Move larger catalogues and teams through routine work faster.": "பெரிய கத்தாலாக்குகள் மற்றும் குழுக்களை அதிக வேகத்தில் கையாளவும்.",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "தொகுப்புகளை மற்றும் பிரிவுகளை பிரிக்காமல் அல்லது பதிவுகளை மடக்காமல் அளவுகள், நிறங்கள் அல்லது பிற தேர்வுகளை வழங்கவும்.",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "தொகுப்புகளை மற்றும் பிரிவுகளை பிரிக்காமல் அல்லது பதிவுகளை மடக்காமல் அளவுகள், நிறங்கள் அல்லது பிற தேர்வுகளை வழங்கவும்.",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "கிடைக்கும் அதிக அளவு வரம்புகளுடன் இயக்கவும்.",
    "Operate with the highest available limits.": "கிடைக்கும் அதிக அளவு வரம்புகளுடன் இயக்கவும்.",
    "upgrade_page.copy.per_module_permissions": "மாட்யூல் அடிப்படையிலான அனுமதிகள்",
    "Per-module permissions": "மாட்யூல் அடிப்படையிலான அனுமதிகள்",
    "upgrade_page.copy.priority_support": "முன்னுரிமை ஆதரவு",
    "Priority support": "முன்னுரிமை ஆதரவு",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "கடைசி ஐந்து ஆடிட் நிகழ்வுகளை விட அதிகமானவற்றை மதிப்பீடு செய்யவும்.",
    "Review more than the latest five audit events.": "கடைசி ஐந்து ஆடிட் நிகழ்வுகளை விட அதிகமானவற்றை மதிப்பீடு செய்யவும்.",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "குழுவும் செயல்பாடும் வளரும்போது முழு ஆடிட் வரலாற்றை மதிப்பீடு செய்யவும்.",
    "Review the full audit history as your team and activity grow.": "குழுவும் செயல்பாடும் வளரும்போது முழு ஆடிட் வரலாற்றை மதிப்பீடு செய்யவும்.",
    "upgrade_page.copy.role_based_access_control": "பங்கு அடிப்படையிலான அணுகல் கட்டுப்பாடு",
    "Role-based access control": "பங்கு அடிப்படையிலான அணுகல் கட்டுப்பாடு",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "பங்குகள் உங்களுக்கு ஒவ்வொரு குழு உறுப்பினருக்கும் தேவையான அணுகலை மட்டுமே வழங்க உதவுகின்றன. Growth மற்றும் அதற்கு மேலுள்ள திட்டங்களில் கிடைக்கிறது.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "பங்குகள் உங்களுக்கு ஒவ்வொரு குழு உறுப்பினருக்கும் தேவையான அணுகலை மட்டுமே வழங்க உதவுகின்றன. Growth மற்றும் அதற்கு மேலுள்ள திட்டங்களில் கிடைக்கிறது.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "ஆதரவு வழிமுறையை வலுவாகவும், மேம்பட்டதாகவும் வழங்கும் வாடிக்கையாளர் தொடர்பு வழிமுறையை இயக்கவும்.",
    "Run a stronger, more polished customer communication workflow.": "ஆதரவு வழிமுறையை வலுவாகவும், மேம்பட்டதாகவும் வழங்கும் வாடிக்கையாளர் தொடர்பு வழிமுறையை இயக்கவும்.",
    "upgrade_page.copy.sell_across_markets": "வேறுபட்ட சந்தைகளில் விற்கவும்",
    "Sell across markets": "வேறுபட்ட சந்தைகளில் விற்கவும்",
    "upgrade_page.copy.sell_products_together": "ஒன்றாக பொருட்களை விற்கவும்",
    "Sell products together": "ஒன்றாக பொருட்களை விற்கவும்",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "வாடிக்கையாளர்கள் அடையாளம் காணும் ஒரு பிராண்டிலிருந்து மின்னஞ்சல்களை அனுப்பவும்.",
    "Send email from a brand your customers recognise.": "வாடிக்கையாளர்கள் அடையாளம் காணும் ஒரு பிராண்டிலிருந்து மின்னஞ்சல்களை அனுப்பவும்.",
    "upgrade_page.copy.shape_the_information_you_collect": "சேகரிக்கும் தகவலை வடிவமைக்கவும்",
    "Shape the information you collect": "சேகரிக்கும் தகவலை வடிவமைக்கவும்",
    "upgrade_page.copy.small": "சிறிய",
    "Small": "சிறிய",
    "upgrade_page.copy.speak_to_more_customers": "அதிக வாடிக்கையாளர்களை பேசவும்",
    "Speak to more customers": "அதிக வாடிக்கையாளர்களை பேசவும்",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "உயர் கனிம இயக்கத்தில் மேம்பட்ட தரவுகளை தரம் செய்யவும்.",
    "Standardise richer data across a high-volume operation.": "உயர் கனிம இயக்கத்தில் மேம்பட்ட தரவுகளை தரம் செய்யவும்.",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "கிடைக்கும் வாடிக்கையாளர் அனுபவத்தை அதிக நிலையானதாக வழங்க தொடங்கவும்.",
    "Start presenting a more consistent customer experience.": "கிடைக்கும் வாடிக்கையாளர் அனுபவத்தை அதிக நிலையானதாக வழங்க தொடங்கவும்.",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "முழுமையான தொழில்முறை வாடிக்கையாளர் அனுபவத்தை ஆதரிக்கவும்.",
    "Support a complete enterprise-ready customer experience.": "முழுமையான தொழில்முறை வாடிக்கையாளர் அனுபவத்தை ஆதரிக்கவும்.",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "வெவ்வேறு நாணயங்களில் வாங்கும் வாடிக்கையாளர்களை ஆதரிக்கவும்.",
    "Support customers who shop in different currencies.": "வெவ்வேறு நாணயங்களில் வாங்கும் வாடிக்கையாளர்களை ஆதரிக்கவும்.",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "அதிக கனிம இயக்க வழிமுறைகளை அளவில் ஆதரிக்கவும்.",
    "Support high-volume operational workflows at scale.": "அதிக கனிம இயக்க வழிமுறைகளை அளவில் ஆதரிக்கவும்.",
    "upgrade_page.copy.support_larger_workflows_and_teams": "பெரிய வழிமுறைகள் மற்றும் குழுக்களை ஆதரிக்கவும்.",
    "Support larger workflows and teams.": "பெரிய வழிமுறைகள் மற்றும் குழுக்களை ஆதரிக்கவும்.",
    "upgrade_page.copy.t_shirt": "T-சர்ட்",
    "T-shirt": "T-சர்ட்",
    "upgrade_page.copy.t_shirt_large": "T-சர்ட் — பெரிய",
    "T-shirt — Large": "T-சர்ட் — பெரிய",
    "upgrade_page.copy.t_shirt_medium": "T-சர்ட் — நடுத்தரம்",
    "T-shirt — Medium": "T-சர்ட் — நடுத்தரம்",
    "upgrade_page.copy.t_shirt_small": "கேமிசெட்டா — சிறிய",
    "T-shirt — Small": "கேமிசெட்டா — சிறிய",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "முக்கிய நேரங்களில் வாடிக்கையாளர்கள் பெறும் செய்திகளை உங்கள் சந்தை அமைப்பை மாற்றாமல் தனிப்பயனாக்குங்கள்.",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "முக்கிய நேரங்களில் வாடிக்கையாளர்கள் பெறும் செய்திகளை உங்கள் சந்தை அமைப்பை மாற்றாமல் தனிப்பயனாக்குங்கள்.",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "உங்கள் வேலை இடம் வளரத் தொடங்கும்போது மேலும் கருவிகளை திறக்கவும்.",
    "Unlock more tools as your workspace begins to grow.": "உங்கள் வேலை இடம் வளரத் தொடங்கும்போது மேலும் கருவிகளை திறக்கவும்.",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "இந்த திறனை நீங்கள் தயாராக இருக்கும்போது திறக்கவும்.",
    "Unlock this feature when you are ready.": "இந்த திறனை நீங்கள் தயாராக இருக்கும்போது திறக்கவும்.",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "முழுமையாக தனிப்பயனாக்கப்பட்ட அனுபவத்திற்கு ஹெட்லெஸ் API-களைப் பயன்படுத்தவும்.",
    "Use headless APIs for a fully custom experience.": "முழுமையாக தனிப்பயனாக்கப்பட்ட அனுபவத்திற்கு ஹெட்லெஸ் API-களைப் பயன்படுத்தவும்.",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "உங்கள் வேலை ஒழுங்கு மேலும் செல்ல தேவைப்படும்போது API-ஐப் பயன்படுத்தவும்.",
    "Use the API when your workflow needs to go further.": "உங்கள் வேலை ஒழுங்கு மேலும் செல்ல தேவைப்படும்போது API-ஐப் பயன்படுத்தவும்.",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "சந்தை தொடர்புகள் தொடர்ச்சியாக இருக்க உங்கள் சொந்த அனுப்புநர் அடையாளம் மற்றும் விஷுவல் பிராண்டிங்கைப் பயன்படுத்தவும்.",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "சந்தை தொடர்புகள் தொடர்ச்சியாக இருக்க உங்கள் சொந்த அனுப்புநர் அடையாளம் மற்றும் விஷுவல் பிராண்டிங்கைப் பயன்படுத்தவும்.",
    "upgrade_page.copy.with_variants": "வேறுபாடுகளுடன்",
    "With variants": "வேறுபாடுகளுடன்",
    "upgrade_page.copy.without_variants": "வேறுபாடுகள் இல்லாமல்",
    "Without variants": "வேறுபாடுகள் இல்லாமல்",
    "upgrade_page.copy.workflow_tools": "வேலை ஒழுங்கு கருவிகள்",
    "Workflow tools": "வேலை ஒழுங்கு கருவிகள்",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "இந்த திறனை உள்ளடக்கிய திட்டத்தை ஒப்பிடும்போது உங்கள் தற்போதைய வேலை மாற்றமின்றி இருக்கும்.",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "இந்த திறனை உள்ளடக்கிய திட்டத்தை ஒப்பிடும்போது உங்கள் தற்போதைய வேலை மாற்றமின்றி இருக்கும்.",
    "upgrade_page.copy.a_paid_plan": "கட்டண திட்டம்",
    "a paid plan": "கட்டண திட்டம்",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "வளரும் கடைக்கு தேவையான அனைத்தும்: பிராண்டிங்கை அகற்றி, உங்கள் டொமைனைச் சேர்த்து, மேலும் கருவிகளை திறக்கவும்.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "வளரும் கடைக்கு தேவையான அனைத்தும்: பிராண்டிங்கை அகற்றி, உங்கள் டொமைனைச் சேர்த்து, மேலும் கருவிகளை திறக்கவும்.",
    "upgrade_page.copy.everything_unlocked": "எல்லாம் திறக்கப்பட்டது",
    "Everything unlocked": "எல்லாம் திறக்கப்பட்டது",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "முழு ஐஏ அமைப்பு, மேம்பட்ட பார்வையிடுதல் மற்றும் வளர்ச்சியை கவனிக்கும் கடைகளுக்கு அனைத்தும் திறக்கப்பட்டுள்ளது.",
    "upgrade_page.copy.a_note_from_the_tradly_team": "டிராட்லி அணியிடமிருந்து ஒரு குறிப்பு",
    "A note from the Tradly team": "டிராட்லி அணியிடமிருந்து ஒரு குறிப்பு",
    "upgrade_page.copy.help_us_keep_tradly_going": "டிராட்லியை இயங்க வைக்க உதவுங்கள்",
    "Help us keep Tradly going": "டிராட்லியை இயங்க வைக்க உதவுங்கள்",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "எங்கள் செலவுகள் அதிகரித்துள்ளன, மேலும் Tradly-ஐ கட்டி ஆதரிக்க நம் சமூகத்தின் ஆதரவை வேண்டும். உங்கள் வேலை இடத்தை தொடர தயாராக இருக்க, திட்டத்தை தேர்வு செய்யுங்கள். உங்கள் கடை மற்றும் உங்கள் தரவுகள் பாதுகாக்கப்பட்டு உங்களை எதிர்கொண்டுள்ளது. Tradly-ன் பகுதியாக இருப்பதற்கு நன்றி.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "எங்கள் செலவுகள் அதிகரித்துள்ளன, மேலும் Tradly-ஐ கட்டி ஆதரிக்க நம் சமூகத்தின் ஆதரவை வேண்டும். உங்கள் வேலை இடத்தை தொடர தயாராக இருக்க, திட்டத்தை தேர்வு செய்யுங்கள். உங்கள் கடை மற்றும் உங்கள் தரவுகள் பாதுகாக்கப்பட்டு உங்களை எதிர்கொண்டுள்ளது. Tradly-ன் பகுதியாக இருப்பதற்கு நன்றி.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "2019 முதல் நாங்கள் Tradly-ஐ இலவச பேக்கேஜ் உடன் வழங்கி வருகிறோம், அதில் பலவற்றை இலவசமாக சேர்த்துள்ளோம், ஏனெனில் நாம் எவரும் ஒன்றை தொடங்க முடியும் என்று விரும்பினோம். அதை செய்வதில் நாங்கள் மகிழ்ச்சி அடைந்தோம், ஆனால் இதை நாம் தனியாக தொடர முடியாது. வியாபாரம் ஒரு குறிப்பிட்ட நிலையை அடையும் போது இலவச திட்டத்தை மீண்டும் கொண்டு வர திட்டமிட்டுள்ளோம், அதன் மூலம் நம்மை இங்கு கொண்டு வந்த சமூகத்திற்கு திருப்பி கொடுக்க முடியும்.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "2019 முதல் நாங்கள் Tradly-ஐ இலவச பேக்கேஜ் உடன் வழங்கி வருகிறோம், அதில் பலவற்றை இலவசமாக சேர்த்துள்ளோம், ஏனெனில் நாம் எவரும் ஒன்றை தொடங்க முடியும் என்று விரும்பினோம். அதை செய்வதில் நாங்கள் மகிழ்ச்சி அடைந்தோம், ஆனால் இதை நாம் தனியாக தொடர முடியாது. வியாபாரம் ஒரு குறிப்பிட்ட நிலையை அடையும் போது இலவச திட்டத்தை மீண்டும் கொண்டு வர திட்டமிட்டுள்ளோம், அதன் மூலம் நம்மை இங்கு கொண்டு வந்த சமூகத்திற்கு திருப்பி கொடுக்க முடியும்.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "இன்று உங்களுக்கு ஏற்ற திட்டத்தைத் தேர்வு செய்யுங்கள். நீங்கள் எப்போதும் அதை மாற்றலாம்.",
    "Choose the plan that fits you today. You can change it any time.": "இன்று உங்களுக்கு ஏற்ற திட்டத்தைத் தேர்வு செய்யுங்கள். நீங்கள் எப்போதும் அதை மாற்றலாம்.",
    "upgrade_page.back_to_workspace": "வேலை இடத்திற்கு திரும்பு",
    "Back to workspace": "வேலை இடத்திற்கு திரும்பு",
    "upgrade_page.grow_when_ready": "வேலை தேவைப்படும் போது வளர்ச்சி",
    "Grow when the work calls for it": "வேலை தேவைப்படும் போது வளர்ச்சி",
    "upgrade_page.reassurance": "உங்கள் தற்போதைய தரவுகள், பட்டியல்கள் மற்றும் அமைப்புகள் அவை இருக்கும் போலவே தொடர்கின்றன.",
    "Your existing data, listings, and setup stay exactly as they are.": "உங்கள் தற்போதைய தரவுகள், பட்டியல்கள் மற்றும் அமைப்புகள் அவை இருக்கும் போலவே தொடர்கின்றன.",
    "upgrade_page.choose_plan": "திட்டத்தைத் தேர்வு செய்யுங்கள்",
    "Choose a plan": "திட்டத்தைத் தேர்வு செய்யுங்கள்",
    "upgrade_page.feature_availability": "பண்புகளின் கிடைப்பு",
    "Feature availability": "பண்புகளின் கிடைப்பு",
    "upgrade_page.available_from": "தொடங்கி கிடைக்கிறது",
    "Available from": "தொடங்கி கிடைக்கிறது",
    "upgrade_page.and_above": "மேலும்",
    "and above": "மேலும்",
    "upgrade_page.choose_when_useful": "இந்த திறன் உங்கள் குழுவிற்கு பயனுள்ளதாக இருக்கும்போது மட்டுமே திட்டத்தைத் தேர்வு செய்யவும்.",
    "Choose a plan only when this capability is useful to your team.": "இந்த திறன் உங்கள் குழுவிற்கு பயனுள்ளதாக இருக்கும்போது மட்டுமே திட்டத்தைத் தேர்வு செய்யவும்.",
    "upgrade_page.practical_difference": "உண்மையான வித்தியாசம்",
    "The practical difference": "உண்மையான வித்தியாசம்",
    "upgrade_page.keep_work_simple": "உங்கள் வளர்ச்சியுடன் வேலையை எளிதாக வைத்திருங்கள்.",
    "Keep the work simpler as you grow.": "உங்கள் வளர்ச்சியுடன் வேலையை எளிதாக வைத்திருங்கள்.",
    "upgrade_page.plan_path": "திட்ட பாதை",
    "Plan path": "திட்ட பாதை",
    "upgrade_page.plan_path_title": "இந்த அடுத்த படியை ஆதரிக்கும் திட்டத்தை தொடங்கவும்.",
    "Start with the plan that supports this next step.": "இந்த அடுத்த படியை ஆதரிக்கும் திட்டத்தை தொடங்கவும்.",
    "upgrade_page.best_next_step": "மிகச்சிறந்த அடுத்த படி",
    "upgrade_page.includes_capability": "இந்த திறனை உள்ளடக்கியது",
    "Includes this capability": "இந்த திறனை உள்ளடக்கியது",
    "upgrade_page.not_included": "உள்ளடக்கப்படவில்லை",
    "Not included": "உள்ளடக்கப்படவில்லை",
    "upgrade_page.included": "✓ உள்ளடக்கப்பட்டது",
    "✓ Included": "✓ உள்ளடக்கப்பட்டது",
    "upgrade_page.ready_when_you_are": "நீங்கள் தயாராக இருக்கும்போது தயார்.",
    "Ready when you are.": "நீங்கள் தயாராக இருக்கும்போது தயார்.",
    "upgrade_page.billing_details": "முழுமையான திட்ட விவரங்களை மதிப்பீடு செய்து, Tradly பில்லிங்கில் பாதுகாப்பாக தொடரவும்.",
    "Review the complete plan details and continue securely with Tradly billing.": "முழுமையான திட்ட விவரங்களை மதிப்பீடு செய்து, Tradly பில்லிங்கில் பாதுகாப்பாக தொடரவும்.",
    "upgrade_page.panel.close": "ஆப்பிளிகேஷன் பேனலை மூடுதல்",
    "Close upgrade panel": "ஆப்பிளிகேஷன் பேனலை மூடுதல்",
    "upgrade_page.panel.show_less": "குறைவானதைக் காட்டு",
    "Show less": "குறைவானதைக் காட்டு",
    "upgrade_page.panel.see_more": "மேலும் பார்க்க",
    "See more": "மேலும் பார்க்க",
    "upgrade_page.panel.choose_to_continue": "தொடர திட்டத்தைத் தேர்வு செய்யவும்",
    "Choose a plan to continue": "தொடர திட்டத்தைத் தேர்வு செய்யவும்",
    "upgrade_page.panel.more_ways_to_grow": "மேலும் வளர்ச்சி வழிகள்",
    "More ways to grow": "மேலும் வளர்ச்சி வழிகள்",
    "upgrade_page.panel.plan_includes_feature": "ஒவ்வொரு திட்டமும் இந்த திறனையும், அடுத்த நிலைக்கு தேவையான கூடுதல் திறனையும் உள்ளடக்கியது.",
    "Each plan includes this feature plus additional capacity for your next stage.": "ஒவ்வொரு திட்டமும் இந்த திறனையும், அடுத்த நிலைக்கு தேவையான கூடுதல் திறனையும் உள்ளடக்கியது.",
    "upgrade_page.panel.add_credits": "கிரெடிட்டுகள் அல்லது பொருட்களைச் சேர்க்கவும்",
    "Add credits or products": "கிரெடிட்டுகள் அல்லது பொருட்களைச் சேர்க்கவும்",
    "upgrade_page.panel.ala_carte_description": "உங்கள் வேலை இடம் à la carte க்கு பில்லிங் செய்யப்படுகிறது. தேவையான கிரெடிட்டுகளை நிரப்பவோ அல்லது தேவையான பொருட்களைச் சேர்க்கவோ முடியும்.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "உங்கள் வேலை இடம் à la carte க்கு பில்லிங் செய்யப்படுகிறது. தேவையான கிரெடிட்டுகளை நிரப்பவோ அல்லது தேவையான பொருட்களைச் சேர்க்கவோ முடியும்.",
    "upgrade_page.panel.open_ala_carte": "à la carte ஐத் திறக்கவும்",
    "Open à la carte": "à la carte ஐத் திறக்கவும்",
    "upgrade_page.panel.recommended": "பரிந்துரைக்கப்பட்டது",
    "Recommended": "பரிந்துரைக்கப்பட்டது",
    "upgrade_page.panel.per_month": "/ மாதம்",
    "upgrade_page.panel.please_wait": "காத்திருக்கவும்…",
    "upgrade_page.panel.unlock_plan": "{plan} ஐ திறக்கவும்",
    "Unlock {plan}": "{plan} ஐ திறக்கவும்",
    "upgrade_page.panel.choose_plan": "{plan} தேர்வு செய்யவும்",
    "Choose {plan}": "{plan} தேர்வு செய்யவும்",
    "upgrade_page.panel.compare_plans": "எல்லா திட்ட விவரங்களையும் ஒப்பிடவும்",
    "Compare all plan details": "எல்லா திட்ட விவரங்களையும் ஒப்பிடவும்",
    "workspace.usage.page_title": "பயன்பாட்டின் பார்வை",
    "Usage overview": "பயன்பாட்டின் பார்வை",
    "workspace.usage.page_description": "இந்த வேலை இடத்தில் பயன்படுத்தப்பட்ட பயன்பாட்டையும், பயன்படுத்தப்பட்ட வரம்புகளையும் பார்க்கவும்.",
    "workspace.usage.not_available": "கிடைக்காதது",
    "workspace.usage.limit_not_configured": "வரம்பு அமைக்கப்படவில்லை",
    "Limit not configured": "வரம்பு அமைக்கப்படவில்லை",
    "workspace.usage.limit_value": "வரம்பு: {limit}",
    "Limit: {limit}": "வரம்பு: {limit}",
    "listings.photos": "படங்கள்",
    "Photos": "படங்கள்",
    "listings.listen_episode": "இந்த தொடரை கேட்கவும்",
    "Listen to this episode": "இந்த தொடரை கேட்கவும்",
    "listings.other_listings": "மற்ற பட்டியல்கள்",
    "Other listings": "மற்ற பட்டியல்கள்",
    "listings.delete": "நீக்கு",
    "listings.fulfilled_by_platform": "தளத்தால் நிறைவேற்றப்பட்டது",
    "Fulfilled by Platform": "தளத்தால் நிறைவேற்றப்பட்டது",
    "listings.no_attributes_set": "எந்த அம்சமும் அமைக்கப்படவில்லை",
    "No attributes set": "எந்த அம்சமும் அமைக்கப்படவில்லை",
    "listings.campaign_raised": "{amount} சேகரிக்கப்பட்டது",
    "{amount} raised": "{amount} சேகரிக்கப்பட்டது",
    "listings.campaign_progress": "{percent}% {goal}",
    "{percent}% of {goal}": "{percent}% {goal}",
    "listings.seat": "இருக்கை",
    "seat": "இருக்கை",
    "listings.seats": "இருக்கைகள்",
    "seats": "இருக்கைகள்",
    "listings.per_slot": "ஒவ்வொரு ஸ்லாட்டிலும்",
    "per slot": "ஒவ்வொரு ஸ்லாட்டிலும்",
    "listings.total_value": "மொத்தம்: {total}",
    "Total: {total}": "மொத்தம்: {total}",
    "listings.orders": "ஆர்டர்கள்",
    "listings.total_orders": "மொத்த ஆர்டர்கள்",
    "Total orders": "மொத்த ஆர்டர்கள்",
    "listings.revenue": "வருவாய்",
    "listings.average_order": "சராசரி ஆர்டர்",
    "listings.customers": "வாடிக்கையாளர்கள்",
    "Customers": "வாடிக்கையாளர்கள்",
    "listings.load_more": "மேலும் ஏற்று",
    "Load more": "மேலும் ஏற்று",
    "listings.filter": "தேர்வு செய்தல்",
    "listings.sort": "வரிசைப்படுத்து",
    "Sort": "வரிசைப்படுத்து",
    "listings.value_price": "மதிப்பு விலை",
    "Value Price": "மதிப்பு விலை",
    "listings.detail_label_title": "தலைப்பு",
    "listings.detail_label_slug": "ஸ்லக்",
    "listings.detail_label_description": "விளக்கம்",
    "listings.detail_label_categories": "பிரிவுகள்",
    "listings.detail_label_list_price": "பட்டியல் விலை",
    "List Price": "பட்டியல் விலை",
    "listings.detail_label_offer": "மலிவு",
    "Offer": "மலிவு",
    "listings.detail_label_currency": "நாணயம்",
    "listings.detail_label_listing_status": "பட்டியல் நிலை",
    "Listing Status": "பட்டியல் நிலை",
    "listings.detail_label_active": "செயல்பாட்டில்",
    "listings.detail_label_sold": "விற்றுவிடப்பட்டது",
    "listings.detail_label_meta_title": "மெட்டா தலைப்பு",
    "listings.detail_label_meta_description": "மெட்டா விளக்கம்",
    "listings.detail_label_goal": "இலக்கு",
    "Goal": "இலக்கு",
    "listings.detail_label_donors": "தாராளத்தாளர்கள்",
    "Donors": "தாராளத்தாளர்கள்",
    "listings.detail_label_start_date": "தொடக்க தேதி",
    "listings.detail_label_end_date": "முடிவு தேதி",
    "listings.detail_label_stock": "கொள்முதல்",
    "listings.detail_label_max_qty_order": "குறைந்தபட்ச அளவு / பெறுதல்",
    "Max qty / order": "குறைந்தபட்ச அளவு / பெறுதல்",
    "listings.detail_label_weight": "எடை",
    "listings.detail_label_dimensions": "அளவுகள்",
    "Dimensions": "அளவுகள்",
    "listings.detail_label_listing_period": "பட்டியல் காலம்",
    "Listing period": "பட்டியல் காலம்",
    "listings.detail_label_max_tickets_booking": "குறைந்தபட்ச உள்ளீடுகள் / புகைப்படம்",
    "Max tickets / booking": "குறைந்தபட்ச உள்ளீடுகள் / புகைப்படம்",
    "listings.detail_label_rating": "மதிப்பீடு",
    "listings.detail_label_reviews": "கருத்துகள்",
    "listings.detail_label_likes": "நேர்மறை",
    "Likes": "நேர்மறை",
    "listings.detail_label_dislikes": "எதிர்மறை",
    "Dislikes": "எதிர்மறை",
    "listings.detail_label_barcode": "கோடு குறியீடு",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "அடிப்படை தகவல்கள்",
    "Basic Info": "அடிப்படை தகவல்கள்",
    "listings.detail_section_pricing": "விலைகள்",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "தொடர மேலே ஒரு பட்டியல் வகையைத் தேர்வு செய்யவும்.",
    "Select a listing type above to continue.": "தொடர மேலே ஒரு பட்டியல் வகையைத் தேர்வு செய்யவும்.",
    "listing_form.attributes": "பண்புகள்",
    "category.status_active_help": "நிலை (செயலற்ற / செயலில்)",
    "promotions.medium": "ஊடகம்",
    "users.listings": "பட்டியல்கள்",
    "users.accounts": "கணக்குகள்",
    "users.click_count_one": "{count} கிளிக்",
    "{count} click": "{count} கிளிக்",
    "users.click_count": "{count} கிளிக்குகள்",
    "{count} clicks": "{count} கிளிக்குகள்",
    "integrations.generic.provider_help": "தேர்ந்தெடுக்கப்பட்ட வழங்குநரை கீழே உள்ள புலங்களைப் பயன்படுத்தி அமைக்கவும்.",
    "Configure the selected provider using the fields below.": "தேர்ந்தெடுக்கப்பட்ட வழங்குநரை கீழே உள்ள புலங்களைப் பயன்படுத்தி அமைக்கவும்.",
    "attributes.editor_prefill_data_from": "தரவுகளை முன்னேற்றுதல்",
    "Prefill Data From": "தரவுகளை முன்னேற்றுதல்",
    "attributes.editor_select_attribute": "அமைப்பைத் தேர்ந்தெடுக்கவும்",
    "Select Attribute": "அமைப்பைத் தேர்ந்தெடுக்கவும்",
    "attributes.editor_select_attribute_group": "அமைப்பு குழுவைத் தேர்ந்தெடுக்கவும்",
    "Select Attribute Group": "அமைப்பு குழுவைத் தேர்ந்தெடுக்கவும்",
    "attributes.editor_attribute": "அமைப்பு",
    "attributes.editor_attributes": "அமைப்புகள்",
    "attributes.editor_cart_attributes": "வாகன அமைப்புகள்",
    "Cart Attributes": "வாகன அமைப்புகள்",
    "listings.add_photo": "படத்தை சேர்க்கவும்",
    "accounts.analytics": "பகுப்பாய்வுகள்",
    "listings.image_optional": "பட்டியல் படங்கள் (தேர்வுக்குரியது)",
    "Listing Images (Optional)": "பட்டியல் படங்கள் (தேர்வுக்குரியது)",
    "listings.currency": "நாணயம்",
    "listing_variants.number_sign": "#",
    "#": "#",
    "attributes.active": "செயல்பாட்டில்",
    "listing_form.digital_deleted_item_cannot_edit": "இந்த பொருள் அழிக்க குறிப்பிடப்பட்டுள்ளது மற்றும் தொகுக்க முடியாது",
    "This item is marked for deletion and cannot be edited": "இந்த பொருள் அழிக்க குறிப்பிடப்பட்டுள்ளது மற்றும் தொகுக்க முடியாது",
    "listing_form.digital_max_files": "கூடுதல் 10 கோப்புகள் அனுமதிக்கப்பட்டுள்ளன",
    "Maximum 10 files allowed": "கூடுதல் 10 கோப்புகள் அனுமதிக்கப்பட்டுள்ளன",
    "listing_form.digital_title_required": "தலைப்பை உள்ளிடவும்",
    "listing_form.digital_version_required": "பதிப்பு பெயரை உள்ளிடவும்",
    "Please enter a version name": "பதிப்பு பெயரை உள்ளிடவும்",
    "listing_form.digital_contents": "மின்னணு உள்ளடக்கம்",
    "Digital Contents": "மின்னணு உள்ளடக்கம்",
    "listing_form.digital_add_content": "+ உள்ளடக்கத்தைச் சேர்க்கவும்",
    "+ Add Content": "+ உள்ளடக்கத்தைச் சேர்க்கவும்",
    "listing_form.no_description": "விளக்கம் இல்லை",
    "No description": "விளக்கம் இல்லை",
    "listing_form.digital_file_count": "{count} கோப்பு(கள்)",
    "{count} file(s)": "{count} கோப்பு(கள்)",
    "listing_form.digital_empty": "மின்னணு உள்ளடக்கம் இல்லை",
    "No digital contents yet": "மின்னணு உள்ளடக்கம் இல்லை",
    "listing_form.digital_empty_help": "\"{action}\"-ஐ அழுத்தி உங்கள் முதல் மின்னணு உள்ளடக்கத்தை உருவாக்கவும்",
    "Click \"{action}\" to create your first digital content": "\"{action}\"-ஐ அழுத்தி உங்கள் முதல் மின்னணு உள்ளடக்கத்தை உருவாக்கவும்",
    "listing_form.digital_marked_for_deletion": "அழிக்க குறிப்பிடப்பட்டுள்ளது ({count})",
    "Marked for Deletion ({count})": "அழிக்க குறிப்பிடப்பட்டுள்ளது ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ சமர்ப்பிக்கும்போது அழிக்கப்படும்",
    "✓ Will be deleted on submit": "✓ சமர்ப்பிக்கும்போது அழிக்கப்படும்",
    "listing_form.digital_edit_title": "டிஜிட்டல் கண்டன்டை தொகுத்தல்",
    "Edit Digital Content": "டிஜிட்டல் கண்டன்டை தொகுத்தல்",
    "listing_form.digital_add_title": "புதிய டிஜிட்டல் கண்டன்டை சேர்க்கவும்",
    "Add New Digital Content": "புதிய டிஜிட்டல் கண்டன்டை சேர்க்கவும்",
    "listing_form.digital_form_description": "டிஜிட்டல் கண்டன்டை {action} செய்ய கீழே விவரங்களை நிரப்பவும்",
    "Fill in the details below to {action} digital content": "டிஜிட்டல் கண்டன்டை {action} செய்ய கீழே விவரங்களை நிரப்பவும்",
    "listing_form.digital_title_placeholder": "டிஜிட்டல் கண்டன்ட் தலைப்பை உள்ளிடவும்",
    "Enter digital content title": "டிஜிட்டல் கண்டன்ட் தலைப்பை உள்ளிடவும்",
    "listing_form.description_optional_placeholder": "விவரணம் உள்ளிடவும் (தேர்வுக்கு வேண்டும்)",
    "Enter description (optional)": "விவரணம் உள்ளிடவும் (தேர்வுக்கு வேண்டும்)",
    "listing_form.version": "பதிப்பு",
    "Version": "பதிப்பு",
    "listing_form.files": "கோப்புகள்",
    "Files": "கோப்புகள்",
    "listing_form.max_files": "கூடுதல் {count}",
    "(Max {count})": "கூடுதல் {count}",
    "listing_form.click_to_upload_files": "கோப்புகளை பதிவேற்றம் செய்ய கிளிக் செய்யவும்",
    "Click to upload files": "கோப்புகளை பதிவேற்றம் செய்ய கிளிக் செய்யவும்",
    "listing_form.files_uploaded_count": "{count}/10 கோப்புகள் பதிவேற்றம் செய்யப்பட்டது",
    "{count}/10 files uploaded": "{count}/10 கோப்புகள் பதிவேற்றம் செய்யப்பட்டது",
    "listing_form.unknown_size": "தெரியாத அளவு",
    "Unknown size": "தெரியாத அளவு",
    "listing_form.no_accounts_available": "கிடைக்கும் கணக்குகள் இல்லை",
    "No accounts available": "கிடைக்கும் கணக்குகள் இல்லை",
    "listing_form.select_account": "கணக்கை தேர்வு செய்யவும்",
    "Select an account": "கணக்கை தேர்வு செய்யவும்",
    "listing_form.searching": "தேடுகிறோம்...",
    "Searching...": "தேடுகிறோம்...",
    "listing_form.location_enter_address": "தேடுவதற்கு முன்னர் முகவரியை உள்ளிடவும்",
    "Please enter an address to search": "தேடுவதற்கு முன்னர் முகவரியை உள்ளிடவும்",
    "listing_form.location_no_addresses_search": "முகவரிகள் கிடைக்கவில்லை. தேடலை மாற்றி மீண்டும் முயற்சிக்கவும்.",
    "No addresses found. Please try a different search.": "முகவரிகள் கிடைக்கவில்லை. தேடலை மாற்றி மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location_search_failed": "முகவரிகளை தேட முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Failed to search addresses. Please try again.": "முகவரிகளை தேட முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location_place_details_failed": "இடத்தின் விவரங்களைப் பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Failed to get place details. Please try again.": "இடத்தின் விவரங்களைப் பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location_access_denied": "இடம் அணுகல் தடை செய்யப்பட்டுள்ளது. இடம் அனுமதிகளை செயல்படுத்தவும்.",
    "Location access denied. Please enable location permissions.": "இடம் அணுகல் தடை செய்யப்பட்டுள்ளது. இடம் அனுமதிகளை செயல்படுத்தவும்.",
    "listing_form.location_unavailable": "இடம் கண்டறிய முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Unable to determine location. Please try again.": "இடம் கண்டறிய முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location_timeout": "இடம் கோரிக்கை நேரம் முடிவடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "Location request timed out. Please try again.": "இடம் கோரிக்கை நேரம் முடிவடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location_current_failed": "தற்போதைய இடத்தைப் பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Failed to get current location. Please try again.": "தற்போதைய இடத்தைப் பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.location": "இடம்",
    "listing_form.location_search_placeholder": "இடத்தைத் தேடு...",
    "Search for a location...": "இடத்தைத் தேடு...",
    "listing_form.location_searching": "முகவரிகளைத் தேடுகிறோம்...",
    "Searching addresses...": "முகவரிகளைத் தேடுகிறோம்...",
    "listing_form.location_no_addresses": "முகவரிகள் கிடைக்கவில்லை",
    "No addresses found": "முகவரிகள் கிடைக்கவில்லை",
    "listing_form.location_try_different_search": "வேறு தேடல் வார்த்தையை முயற்சிக்கவும்",
    "Try a different search term": "வேறு தேடல் வார்த்தையை முயற்சிக்கவும்",
    "listing_form.location_getting": "இடத்தைப் பெறுகிறோம்...",
    "Getting location...": "இடத்தைப் பெறுகிறோம்...",
    "listing_form.location_use_current": "தற்போதைய இடத்தைப் பயன்படுத்தவும்",
    "Use Current Location": "தற்போதைய இடத்தைப் பயன்படுத்தவும்",
    "listing_form.location_selected": "தேர்ந்தெடுக்கப்பட்ட இடம்",
    "Selected Location": "தேர்ந்தெடுக்கப்பட்ட இடம்",
    "listing_form.latitude": "அடிப்படை அளவு:",
    "Latitude:": "அடிப்படை அளவு:",
    "listing_form.longitude": "நீளம்:",
    "Longitude:": "நீளம்:",
    "listing_form.location_helper": "முகவரியைத் தேடவும் அல்லது தற்போதைய இடத்தைப் பயன்படுத்தவும்",
    "Search for an address or use your current location": "முகவரியைத் தேடவும் அல்லது தற்போதைய இடத்தைப் பயன்படுத்தவும்",
    "common.change": "மாற்று",
    "listing_form.variant_id_tooltip": "வகை ID: {typeId}, மதிப்பு ID: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "வகை ID: {typeId}, மதிப்பு ID: {valueId}",
    "listing_form.variants_marked_for_deletion": "நீக்கம் செய்யப்பட வேண்டியது ({count} பொருட்கள்):",
    "Marked for Deletion ({count} items):": "நீக்கம் செய்யப்பட வேண்டியது ({count} பொருட்கள்):",
    "listing_form.add_new_variant": "புதிய வகையைச் சேர்க்கவும்",
    "Add New Variant": "புதிய வகையைச் சேர்க்கவும்",
    "listing_form.add_variant_description": "புதிய வகையை உருவாக்க, கீழே உள்ள விவரங்களை நிரப்பவும்",
    "Fill in the details below to create a new variant": "புதிய வகையை உருவாக்க, கீழே உள்ள விவரங்களை நிரப்பவும்",
    "listing_form.google_search_preview": "கூகிள் தேடல் முன்னோட்டம்",
    "Google Search Preview": "கூகிள் தேடல் முன்னோட்டம்",
    "listing_form.meta_title_preview": "உங்கள் மெட்டா தலைப்பு இங்கே",
    "Your Meta Title Here": "உங்கள் மெட்டா தலைப்பு இங்கே",
    "listing_form.meta_description_preview": "உங்கள் மெட்டா விவரணம் இங்கே தோன்றும். இது பயனர்களுக்கு உங்கள் பக்க உள்ளடக்கத்தை தேடல் முடிவுகளில் புரிந்து கொள்ள உதவுகிறது.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "உங்கள் மெட்டா விவரணம் இங்கே தோன்றும். இது பயனர்களுக்கு உங்கள் பக்க உள்ளடக்கத்தை தேடல் முடிவுகளில் புரிந்து கொள்ள உதவுகிறது.",
    "listing_form.variant_name_placeholder": "பெயரை உள்ளிடவும்",
    "listing_form.list_price_placeholder": "பட்டியல் விலையை உள்ளிடவும்",
    "listing_form.offer_percent_placeholder": "ஆஃபர் சதவீதத்தை உள்ளிடவும்",
    "Enter Offer Percent": "ஆஃபர் சதவீதத்தை உள்ளிடவும்",
    "attributes.select_all": "எல்லாவற்றையும் தேர்வு செய்யவும்",
    "attributes.unselect_all": "எல்லாவற்றையும் தேர்வு நீக்கவும்",
    "Unselect All": "எல்லாவற்றையும் தேர்வு நீக்கவும்",
    "attributes.select_category": "கத்திரிகையைத் தேர்வு செய்யவும்",
    "attributes.create_category_configuration_first": "உள்ளீட்டு அமைப்பில் {type} கேட்கோளை முதலில் உருவாக்கவும்",
    "Create categories in {type} configuration first": "உள்ளீட்டு அமைப்பில் {type} கேட்கோளை முதலில் உருவாக்கவும்",
    "attributes.select_single_attribute_values": "ஒற்றை அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "attributes.select_multiple_attribute_values": "பல அம்ச மதிப்புகளைத் தேர்வு செய்யவும்",
    "attributes.enter_value": "மதிப்பை உள்ளிடவும்",
    "attributes.enter_multiple_tags": "பல குறியீடுகளை உள்ளிடவும்",
    "Enter Multiple Tags": "பல குறியீடுகளை உள்ளிடவும்",
    "attributes.upload_file": "கோப்பை பதிவிறக்கவும்",
    "collections.add_condition": "+ மேலும் ஒரு நிபந்தனையைச் சேர்க்கவும்",
    "collections.add_photo": "படத்தைச் சேர்க்கவும்",
    "collections.status": "நிலை (இயல்பற்ற / இயங்கும்)",
    "collections.start_date_placeholder": "தொடக்க தேதியைத் தேர்வு செய்யவும்",
    "Select start date": "தொடக்க தேதியைத் தேர்வு செய்யவும்",
    "collections.end_date_placeholder": "முடிவு தேதியைத் தேர்வு செய்யவும்",
    "Select end date": "முடிவு தேதியைத் தேர்வு செய்யவும்",
    "navigation.editor": "தொகுப்பாளர்",
    "Editor": "தொகுப்பாளர்",
    "navigation.web_analytics": "வலைப்பக்க பகுப்பாய்வு",
    "Web Analytics": "வலைப்பக்க பகுப்பாய்வு",
    "navigation.ai_studio": "AI ஸ்டுடியோ",
    "AI Studio": "AI ஸ்டுடியோ",
    "navigation.docs": "ஆவணங்கள்",
    "navigation.logout": "முடிவு செய்யவும்",
    "Logout": "முடிவு செய்யவும்",
    "navigation.tenant_name_placeholder": "(முதலீட்டாளரின் பெயர்)",
    "(Tenant name)": "(முதலீட்டாளரின் பெயர்)",
    "navigation.username_placeholder": "(பயனர் பெயர்)",
    "(Username)": "(பயனர் பெயர்)",
    "navigation.invite_description": "குழு உறுப்பினர்களுக்கு அழைப்பு இணைப்புகளை அனுப்பவும்",
    "Send invitation links to team members": "குழு உறுப்பினர்களுக்கு அழைப்பு இணைப்புகளை அனுப்பவும்",
    "navigation.invite": "அழைப்பு",
    "Invite": "அழைப்பு",
    "navigation.test_mode": "சோதனை முறை",
    "Test Mode": "சோதனை முறை",
    "navigation.upgrade": "மேம்படுத்து",
    "navigation.open_account_menu": "கணக்கு மெனுவைத் திறக்கவும்",
    "Open account menu": "கணக்கு மெனுவைத் திறக்கவும்",
    "navigation.invite_name_required": "பெயரை நிரப்பவும்",
    "Please fill in the name": "பெயரை நிரப்பவும்",
    "navigation.invite_email_required": "மின்னஞ்சலை நிரப்பவும்",
    "Please fill in the email": "மின்னஞ்சலை நிரப்பவும்",
    "navigation.open_url_failed": "இந்த URL-ஐ திறக்க எப்படி என்று தெரியவில்லை: {url}",
    "Don't know how to open this URL: {url}": "இந்த URL-ஐ திறக்க எப்படி என்று தெரியவில்லை: {url}",
    "navigation.no_code_editor": "குறியீடு இல்லாத தொகுப்பாளர்",
    "No-code editor": "குறியீடு இல்லாத தொகுப்பாளர்",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "மார்க்கெட்டிங் தானியங்கி",
    "Marketing automation": "மார்க்கெட்டிங் தானியங்கி",
    "navigation.analytics_recommendation": "பகுப்பாய்வு மற்றும் பரிந்துரை",
    "Analytics & Recommendation": "பகுப்பாய்வு மற்றும் பரிந்துரை",
    "navigation.ai_studio_iryxo": "AI ஸ்டுடியோ (Iryxo)",
    "AI Studio (Iryxo)": "AI ஸ்டுடியோ (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "தற்போதைய திட்டம்",
    "Current project": "தற்போதைய திட்டம்",
    "navigation.current_user": "தற்போதைய பயனர்",
    "Current user": "தற்போதைய பயனர்",
    "navigation.switch_to_light_mode": "தெளிவான மோடுக்கு மாற்று",
    "Switch to light mode": "தெளிவான மோடுக்கு மாற்று",
    "navigation.switch_to_dark_mode": "இருண்ட மோடுக்கு மாற்று",
    "Switch to dark mode": "இருண்ட மோடுக்கு மாற்று",
    "navigation.download_android_app": "Android பயன்பாட்டை பதிவிறக்கவும்",
    "Download Android app": "Android பயன்பாட்டை பதிவிறக்கவும்",
    "navigation.download_ios_app": "iOS பயன்பாட்டை பதிவிறக்கவும்",
    "Download iOS app": "iOS பயன்பாட்டை பதிவிறக்கவும்",
    "navigation.subscribe_youtube": "YouTube-ல் பதிவு செய்யுங்கள்",
    "Subscribe on YouTube": "YouTube-ல் பதிவு செய்யுங்கள்",
    "navigation.open_app_switcher": "பயன்பாடுகளைத் தேர்வு செய்யும் தொகுப்பாளரைத் திறக்கவும்",
    "Open app switcher": "பயன்பாடுகளைத் தேர்வு செய்யும் தொகுப்பாளரைத் திறக்கவும்",
    "navigation.open_android_app": "Android பயன்பாட்டைத் திறக்கவும்",
    "Open Android app": "Android பயன்பாட்டைத் திறக்கவும்",
    "navigation.open_ios_app": "iOS பயன்பாட்டைத் திறக்கவும்",
    "Open iOS app": "iOS பயன்பாட்டைத் திறக்கவும்",
    "navigation.open_ai_support": "Tradly ChatGPT ஆதரவைத் திறக்கவும்",
    "Open Tradly ChatGPT support": "Tradly ChatGPT ஆதரவைத் திறக்கவும்",
    "navigation.open_youtube_channel": "Tradly YouTube சேனலைத் திறக்கவும்",
    "Open Tradly YouTube channel": "Tradly YouTube சேனலைத் திறக்கவும்",
    "navigation.demo": "டெமோ",
    "Demo": "டெமோ",
    "listings.smart_upload.listing_id_optional": "பட்டியல் ID (தேர்வுக்கு தேவையில்லை — ஏற்கனவே உள்ளதை மாற்று)",
    "Listing ID (optional — update existing)": "பட்டியல் ID (தேர்வுக்கு தேவையில்லை — ஏற்கனவே உள்ளதை மாற்று)",
    "listings.smart_upload.category_id": "கத்திரிகை ID",
    "listings.smart_upload.list_price": "பட்டியல் விலை",
    "listings.smart_upload.stock": "ஸ்டாக்",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "பரிமாற்ற குறியீடு",
    "listings.smart_upload.account_id": "கணக்கு ஐடி",
    "listings.smart_upload.slug": "ஸ்லக்",
    "listings.smart_upload.text": "தெரிவு உரை",
    "listings.smart_upload.long_text": "நீண்ட உரை",
    "listings.smart_upload.number": "எண்",
    "listings.smart_upload.single_select": "ஒரு தேர்வு",
    "listings.smart_upload.multi_select": "பல தேர்வுகள்",
    "listings.smart_upload.attribute_name_required": "«{header}» க்கு அம்ச பெயரை உள்ளிடவும்.",
    "listings.smart_upload.attribute_create_failed": "Tradly புதிய {name} அம்சத்தை திரும்ப அனுப்பவில்லை.",
    "Tradly did not return the new “{name}” attribute.": "Tradly புதிய {name} அம்சத்தை திரும்ப அனுப்பவில்லை.",
    "listings.smart_upload.attribute_option_create_failed": "{name} க்கு «{value}» விருப்பத்தை உருவாக்க முடியவில்லை.",
    "Could not create the “{value}” option for {name}.": "{name} க்கு «{value}» விருப்பத்தை உருவாக்க முடியவில்லை.",
    "listings.smart_upload.attribute_no_longer_available": "«{header}» இலிருந்து மேப் செய்யப்பட்ட அம்சம் இப்போது கிடைக்காது.",
    "listings.smart_upload.csv_needs_header_and_listing": "CSV-ல் தலைப்பு வரியும், குறைந்தது ஒரு பட்டியலும் இருக்க வேண்டும்.",
    "The CSV must contain a header row and at least one listing.": "CSV-ல் தலைப்பு வரியும், குறைந்தது ஒரு பட்டியலும் இருக்க வேண்டும்.",
    "listings.smart_upload.unique_headers_required": "ஒவ்வொரு பட்டியல் நிரலுக்கும் தனித்துவமான, வெற்று இல்லாத தலைப்பு தேவை.",
    "Every listing column needs a unique, non-empty header.": "ஒவ்வொரு பட்டியல் நிரலுக்கும் தனித்துவமான, வெற்று இல்லாத தலைப்பு தேவை.",
    "listings.smart_upload.csv_read_failed": "இந்த CSV-ஐ படிக்க முடியவில்லை.",
    "listings.smart_upload.map_required_fields": "தொடர்ந்து செல்ல முன் இந்த கட்டாய நிரல்களை மேப் செய்யவும்: {fields}",
    "Map these required columns before continuing: {fields}": "தொடர்ந்து செல்ல முன் இந்த கட்டாய நிரல்களை மேப் செய்யவும்: {fields}",
    "listings.smart_upload.row_missing_required_value": "{row} வரியில் கட்டாய மதிப்பு இல்லை.",
    "Row {row} is missing a required value.": "{row} வரியில் கட்டாய மதிப்பு இல்லை.",
    "listings.smart_upload.invalid_category_id_row": "{row} வரியில் சரியான எண் கத்திரிகை ஐடி தேவை, அல்லது «கத்திரிகை ஐடி-யை கையால் மேப் செய்யவும்» தேர்வு செய்யவும்.",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "{row} வரியில் சரியான எண் கத்திரிகை ஐடி தேவை, அல்லது «கத்திரிகை ஐடி-யை கையால் மேப் செய்யவும்» தேர்வு செய்யவும்.",
    "listings.smart_upload.invalid_listing_id_row": "{row} வரியில் சரியான எண் பட்டியல் ஐடி தேவை, அல்லது புதிய பட்டியலை உருவாக்க ஐடியை வெற்று விடவும்.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "{row} வரியில் சரியான எண் பட்டியல் ஐடி தேவை, அல்லது புதிய பட்டியலை உருவாக்க ஐடியை வெற்று விடவும்.",
    "listings.smart_upload.progress.checking_duplicates": "இருக்கும் பட்டியல்களை சரிபார்க்கிறது",
    "Checking for existing listings": "இருக்கும் பட்டியல்களை சரிபார்க்கிறது",
    "listings.smart_upload.duplicate_same_value_row": "இதே {field} இந்த கோப்பில் {row} வரியில் தோன்றுகிறது.",
    "Same {field} appears in row {row} of this file.": "இதே {field} இந்த கோப்பில் {row} வரியில் தோன்றுகிறது.",
    "listings.smart_upload.duplicate_same_value_multiple": "{field} ஒரே மதிப்பு இந்த கோப்பில் பல முறை தோன்றுகிறது.",
    "Same {field} appears more than once in this file.": "{field} ஒரே மதிப்பு இந்த கோப்பில் பல முறை தோன்றுகிறது.",
    "listings.smart_upload.duplicate_existing_listing": "Existing listing #{id} மற்றும் {field} இல் பொருந்துகிறது.",
    "Matches existing listing #{id} by {field}.": "Existing listing #{id} மற்றும் {field} இல் பொருந்துகிறது.",
    "listings.smart_upload.explicit_listing_update": "Explicit listing ID #{id} மேம்படுத்தப்படும்.",
    "Explicit listing ID #{id} will be updated.": "Explicit listing ID #{id} மேம்படுத்தப்படும்.",
    "listings.smart_upload.progress.duplicates_complete": "Duplicated check complete",
    "Duplicate check complete": "Duplicated check complete",
    "listings.smart_upload.duplicate_check_failed": "Existing listings ஐ சரிபார்க்க முடியவில்லை.",
    "Could not check existing listings.": "Existing listings ஐ சரிபார்க்க முடியவில்லை.",
    "listings.smart_upload.progress.duplicates_stopped": "நகல் சரிபார்ப்பு நிறுத்தப்பட்டது",
    "Duplicate check stopped": "நகல் சரிபார்ப்பு நிறுத்தப்பட்டது",
    "listings.smart_upload.prepare_file_failed": "Import file ஐ தயாரிக்க முடியவில்லை.",
    "listings.smart_upload.progress.uploading_file": "Import file ஐ பதிவிறக்கும்",
    "listings.smart_upload.upload_file_failed": "Import file ஐ பதிவிறக்க முடியவில்லை.",
    "listings.smart_upload.all_rows_duplicates": "அனைத்து வரிகளும் மீள்பதிவுகளாக அடையாளம் காணப்பட்டன. Tradlyக்கு அனுப்ப விரும்பினால் «Import anyway» தேர்வு செய்யவும், அல்லது மீண்டும் தொடங்கவும்.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "அனைத்து வரிகளும் மீள்பதிவுகளாக அடையாளம் காணப்பட்டன. Tradlyக்கு அனுப்ப விரும்பினால் «Import anyway» தேர்வு செய்யவும், அல்லது மீண்டும் தொடங்கவும்.",
    "listings.smart_upload.progress.preparing_attributes": "Attributes ஐ தயாரிக்கிறது",
    "listings.smart_upload.attribute_mapped_once": "ஒவ்வொரு listing attribute-ஐயும் ஒருமுறை மட்டுமே மேப் செய்யலாம். Import செய்யும் முன் column mappings-ஐ மீண்டும் பார்க்கவும்.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "ஒவ்வொரு listing attribute-ஐயும் ஒருமுறை மட்டுமே மேப் செய்யலாம். Import செய்யும் முன் column mappings-ஐ மீண்டும் பார்க்கவும்.",
    "listings.smart_upload.progress.preparing_file": "Import file ஐ தயாரிக்கிறது",
    "listings.smart_upload.progress.tradly_importing": "Tradly ஐப் பயன்படுத்தி listings ஐ இறக்கும்",
    "Tradly is importing listings": "Tradly ஐப் பயன்படுத்தி listings ஐ இறக்கும்",
    "listings.smart_upload.progress.import_complete": "இறக்குமதி முடிந்தது",
    "listings.smart_upload.progress.import_stopped": "இறக்குமதி நிறுத்தப்பட்டது",
    "listings.smart_upload.progress.preparing_import": "Import ஐ தயாரிக்கிறது…",
    "Preparing import…": "Import ஐ தயாரிக்கிறது…",
    "listings.smart_upload.progress.rows_prepared": "{current} இலிருந்து {total} rows தயாரிக்கப்பட்டது",
    "{current} of {total} rows prepared": "{current} இலிருந்து {total} rows தயாரிக்கப்பட்டது",
    "listings.smart_upload.progress.remote_processing": "Tradly பதிவிறக்கிய CSV-ஐ செயல்படுத்துகிறது. இது சிறிது நேரம் எடுக்கலாம்.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly பதிவிறக்கிய CSV-ஐ செயல்படுத்துகிறது. இது சிறிது நேரம் எடுக்கலாம்.",
    "listings.smart_upload.progress.partial_import": "Tradly {imported} இலிருந்து {total} rows-ஐ இறக்கியுள்ளது{ending}. மீண்டும் முயற்சி செய்யும் முன் முடிவை மீண்டும் பார்க்கவும்; முழுமையான மீண்டும் முயற்சி வெற்றிகரமான rows-ஐ மீண்டும் பதிவு செய்யலாம்.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly {imported} இலிருந்து {total} rows-ஐ இறக்கியுள்ளது{ending}. மீண்டும் முயற்சி செய்யும் முன் முடிவை மீண்டும் பார்க்கவும்; முழுமையான மீண்டும் முயற்சி வெற்றிகரமான rows-ஐ மீண்டும் பதிவு செய்யலாம்.",
    "listings.smart_upload.title": "நுண்ணறிவு பதிவேற்றம்",
    "Smart Upload": "நுண்ணறிவு பதிவேற்றம்",
    "listings.smart_upload.beta": "(பீட்டா)",
    "listings.smart_upload.start_over": "மீண்டும் தொடங்கு",
    "listings.smart_upload.description": "Listings ஐ பதிவிறக்கவும், ஏற்கனவே உள்ள புலங்களுக்கு காலன் மேப் செய்யவும், அல்லது புதிய listing attributes-ஐ உருவாக்கி இறக்கவும்.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Listings ஐ பதிவிறக்கவும், ஏற்கனவே உள்ள புலங்களுக்கு காலன் மேப் செய்யவும், அல்லது புதிய listing attributes-ஐ உருவாக்கி இறக்கவும்.",
    "listings.smart_upload.step_upload": "பதிவேற்று",
    "listings.smart_upload.step_match": "விரிவான நிரல்களை பொருத்து",
    "listings.smart_upload.step_preview": "முன்னோட்டம்",
    "listings.smart_upload.step_import": "கொண்டுவருதல்",
    "listings.smart_upload.choose_csv": "CSV கோப்பைத் தேர்வுசெய்க",
    "listings.smart_upload.required_columns_help": "கோப்பு தேவையான நிரல்கள் பெயர் மற்றும் category_id. மற்ற நிரல்கள் பட்டியல் அம்சங்களாக மாறலாம்.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "கோப்பு தேவையான நிரல்கள் பெயர் மற்றும் category_id. மற்ற நிரல்கள் பட்டியல் அம்சங்களாக மாறலாம்.",
    "listings.smart_upload.select_csv_file": "CSV கோப்பைத் தேர்வுசெய்க",
    "listings.smart_upload.match_columns": "பட்டியல் நிரல்களை பொருத்து",
    "Match listing columns": "பட்டியல் நிரல்களை பொருத்து",
    "listings.smart_upload.core_fields_help": "முக்கிய தகவல்கள் பட்டியல் API-க்கு அனுப்பப்படுகின்றன. மற்ற நிரல்கள் பட்டியல் அம்சங்களாக சேமிக்கப்படலாம்.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "முக்கிய தகவல்கள் பட்டியல் API-க்கு அனுப்பப்படுகின்றன. மற்ற நிரல்கள் பட்டியல் அம்சங்களாக சேமிக்கப்படலாம்.",
    "listings.smart_upload.do_not_import": "கொண்டுவராதே",
    "listings.smart_upload.map_category_manually": "கேட்டகாரி ஐடி-யை கையால் மாப்புசெய்க",
    "Map Category ID manually": "கேட்டகாரி ஐடி-யை கையால் மாப்புசெய்க",
    "listings.smart_upload.category_assignment_help": "உள்ளீட்டு பட்டியலுக்கு பொருத்தமான பிரிவைத் தேர்வுசெய்க.",
    "Choose the category to assign to every imported listing.": "உள்ளீட்டு பட்டியலுக்கு பொருத்தமான பிரிவைத் தேர்வுசெய்க.",
    "listings.smart_upload.select_category": "பிரிவைத் தேர்வுசெய்க",
    "listings.smart_upload.no_categories": "பட்டியல் பிரிவுகள் கிடைக்கவில்லை. முதலில் ஒரு பிரிவை உருவாக்கி, பின்னர் Smart Upload-ஐ மீண்டும் திறக்கவும்.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "பட்டியல் பிரிவுகள் கிடைக்கவில்லை. முதலில் ஒரு பிரிவை உருவாக்கி, பின்னர் Smart Upload-ஐ மீண்டும் திறக்கவும்.",
    "listings.smart_upload.additional_attributes": "கூடுதல் பட்டியல் அம்சங்கள்",
    "Additional listing attributes": "கூடுதல் பட்டியல் அம்சங்கள்",
    "listings.smart_upload.ignore_column": "இந்த நிரலை மறுத்துவிடு",
    "listings.smart_upload.create_attribute": "＋ புதிய பட்டியல் அம்சத்தை உருவாக்கு",
    "＋ Create a new listing attribute": "＋ புதிய பட்டியல் அம்சத்தை உருவாக்கு",
    "listings.smart_upload.attribute_name": "அம்ச பெயர்",
    "listings.smart_upload.review_import": "உள்ளீட்டை மீண்டும் பார்க்க",
    "listings.smart_upload.rows_scanned_help": "{count} பட்டியல்கள் பதிவேற்றத்திற்கு முன் ஸ்கேன் செய்யப்பட்டன. மீண்டும் எழும் மதிப்புகள், SKU, பற்று குறியீடு, slug மற்றும் இந்த CSV-ல் உள்ள மதிப்புகளைப் பயன்படுத்தி மீள்வரும் பதிவுகள் கண்டறியப்படும்.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} பட்டியல்கள் பதிவேற்றத்திற்கு முன் ஸ்கேன் செய்யப்பட்டன. மீண்டும் எழும் மதிப்புகள், SKU, பற்று குறியீடு, slug மற்றும் இந்த CSV-ல் உள்ள மதிப்புகளைப் பயன்படுத்தி மீள்வரும் பதிவுகள் கண்டறியப்படும்.",
    "listings.smart_upload.duplicates_found": "சாத்தியமான மீள்வரும் பதிவுகள் கண்டறியப்பட்டன",
    "Potential duplicates found": "சாத்தியமான மீள்வரும் பதிவுகள் கண்டறியப்பட்டன",
    "listings.smart_upload.duplicate_rows_skipped": "{count} வரிகள் தானியங்கி முறையில் தவிர்க்கப்படும்.",
    "{count} row(s) will be skipped by default.": "{count} வரிகள் தானியங்கி முறையில் தவிர்க்கப்படும்.",
    "listings.smart_upload.row_label": "வரி",
    "Row": "வரி",
    "listings.smart_upload.explicit_ids_are_updates": "முழுமையான பட்டியல் ஐடி உள்ள வரிகள் புதுப்பிப்புகளாக கருதப்படுகின்றன.",
    "Rows with an explicit listing ID are treated as updates.": "முழுமையான பட்டியல் ஐடி உள்ள வரிகள் புதுப்பிப்புகளாக கருதப்படுகின்றன.",
    "listings.smart_upload.duplicate_action": "மீண்டும் செய்யப்பட்ட செயல்",
    "Duplicate action": "மீண்டும் செய்யப்பட்ட செயல்",
    "listings.smart_upload.skip_duplicates": "சாத்தியமான மீள்வரும் பதிப்புகளை தவிர்க்கவும் (பரிந்துரைக்கப்பட்டது)",
    "Skip potential duplicates (recommended)": "சாத்தியமான மீள்வரும் பதிப்புகளை தவிர்க்கவும் (பரிந்துரைக்கப்பட்டது)",
    "listings.smart_upload.import_all_anyway": "எல்லா வரிகளையும் மாற்றமில்லாமல் இறக்குமதி செய்யவும்",
    "Import all rows anyway": "எல்லா வரிகளையும் மாற்றமில்லாமல் இறக்குமதி செய்யவும்",
    "listings.smart_upload.untitled_listing": "தலைப்பில்லாத பட்டியல்",
    "Untitled listing": "தலைப்பில்லாத பட்டியல்",
    "listings.smart_upload.category_label": "பிரிவு:",
    "Category:": "பிரிவு:",
    "listings.smart_upload.complete": "சுமார் அப்லோட் முடிந்தது",
    "listings.smart_upload.imported_count": "{imported} இலிருந்து {total} பட்டியல்கள் இறக்குமதி செய்யப்பட்டன.",
    "{imported} of {total} listings imported.": "{imported} இலிருந்து {total} பட்டியல்கள் இறக்குமதி செய்யப்பட்டன.",
    "listings.smart_upload.selected_file": "தேர்ந்தெடுக்கப்பட்டது: {name}",
    "listings.smart_upload.checking": "சரிபார்க்கிறது…",
    "listings.smart_upload.check_duplicates": "மீள்வரும் பதிப்புகளை சரிபார்க்கவும்",
    "Check duplicates": "மீள்வரும் பதிப்புகளை சரிபார்க்கவும்",
    "listings.smart_upload.importing": "இறக்குமதி செய்து கொண்டிருக்கிறது…",
    "listings.smart_upload.import_listings": "பட்டியல்களை இறக்குமதி செய்யவும்",
    "listings.smart_upload.failed": "சுமார் அப்லோட் தோல்வியடைந்தது.",
    "Smart Upload failed.": "சுமார் அப்லோட் தோல்வியடைந்தது.",
    "listings.smart_upload.id_label": "ஐடி",
    "listings.status_toggle_hint": "நிலை (இயல்பற்ற / இயல்புள்ள)",
    "listings.upload_media": "ஊடகங்களை பதிவேற்று",
    "listing_form.stock_placeholder": "ஸ்டாக்கை உள்ளிடவும்",
    "orders.create_order.order_items_alt": "ஆர்டர் பொருட்கள்",
    "orders.create_order.by": "மூலம்",
    "by": "மூலம்",
    "orders.create_order.decrease_quantity": "அளவைக் குறைக்கவும்",
    "Decrease quantity": "அளவைக் குறைக்கவும்",
    "orders.create_order.increase_quantity": "அளவை அதிகரிக்கவும்",
    "Increase quantity": "அளவை அதிகரிக்கவும்",
    "orders.create_order.remove_item": "பொருளை நீக்கவும்",
    "Remove item": "பொருளை நீக்கவும்",
    "orders.create_order.rental_period_label": "வாடகை காலம்:",
    "Rental period:": "வாடகை காலம்:",
    "attributes.enter_text": "テキストを入力してください",
    "attributes.select_date": "தேதி தேர்வு செய்யவும்",
    "attributes.enter_number": "எண்ணை உள்ளிடவும்",
    "attributes.select_color": "நிறத்தைத் தேர்வு செய்யவும்",
    "attributes.upload_json": "JSON ஐ பதிவேற்றவும்",
    "Upload JSON": "JSON ஐ பதிவேற்றவும்",
    "attributes.select_location": "இடத்தைத் தேர்வு செய்யவும்",
    "attributes.add_listing_preview": "பட்டியலைச் சேர்க்கவும்",
    "attributes.add_account_preview": "கணக்கைச் சேர்க்கவும்",
    "attributes.enter_price": "விலையை உள்ளிடவும்",
    "attributes.preview": "முன்னோட்டம்",
    "attributes.enter_title": "தலைப்பை உள்ளிடவும்",
    "attributes.enter_description": "விவரத்தை உள்ளிடவும்",
    "attributes.category": "பிரிவு",
    "attributes.attribute_name": "பண்பு பெயர்",
    "attributes.enter_attribute_name": "பண்பு பெயரை உள்ளிடவும்",
    "attributes.select_type": "வகையைத் தேர்வு செய்யவும்",
    "attributes.icon": "குறியீடு",
    "attributes.tooltip": "டூல்டிப்",
    "Tooltip": "டூல்டிப்",
    "attributes.enter_tooltip": "டூல்டிப்பை உள்ளிடவும்",
    "Enter attribute tooltip": "டூல்டிப்பை உள்ளிடவும்",
    "listings.detail.images": "படங்கள்",
    "listings.detail.posted_by": "பதிவேற்றியவர்",
    "Posted by": "பதிவேற்றியவர்",
    "listings.detail.fulfilled_by_platform": "தளத்தால் நிறைவேற்றப்பட்டது",
    "listings.detail.preview": "முன்னோட்டம்",
    "listings.detail.view_listing": "பட்டியலைப் பார்க்கவும்",
    "View Listing": "பட்டியலைப் பார்க்கவும்",
    "listings.detail.variants": "வேரியண்ட்ஸ்",
    "listings.detail.no_attribute_values": "{name} க்கான அம்புல் மதிப்புகள் இல்லை",
    "listings.detail.attributes": "அம்புல்",
    "listings.detail.starts_from": "தொடங்குகிறது:",
    "Starts From:": "தொடங்குகிறது:",
    "listings.detail.schedule": "வேளை",
    "listings.detail.detail": "விவரம்",
    "web_config.download": "பதிவிறக்கம்",
    "web_config.cancel": "ரத்து செய்யும்",
    "web_config.choose_file": "கோப்பைத் தேர்வு செய்யவும்",
    "web_config.title": "வலைப்பக்க அமைப்புகள்",
    "Web Configs": "வலைப்பக்க அமைப்புகள்",
    "web_config.favicon": "ஃபாவிகான்",
    "Favicon": "ஃபாவிகான்",
    "web_config.logo": "லோகோ",
    "web_config.logo_width": "லோகோ அகலம்",
    "Logo Width": "லோகோ அகலம்",
    "web_config.width": "அகலம்",
    "web_config.logo_height": "லோகோ உயரம்",
    "Logo Height": "லோகோ உயரம்",
    "web_config.height": "உயரம்",
    "web_config.social_share_image": "சமூக பகிர்வுக்கான தலைப்பு படம் - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "சமூக பகிர்வுக்கான தலைப்பு படம் - Open Graph",
    "web_config.business_name": "வணிக பெயர்",
    "web_config.enter_web_name": "இணையதள பெயரை உள்ளிடவும்",
    "Enter web name": "இணையதள பெயரை உள்ளிடவும்",
    "web_config.title_font": "தலைப்பு எழுத்துரீதி",
    "Title Font": "தலைப்பு எழுத்துரீதி",
    "web_config.select_title_font": "தலைப்பு எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "Select title font": "தலைப்பு எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "web_config.body_font": "கட்டுரை எழுத்துரீதி",
    "Body Font": "கட்டுரை எழுத்துரீதி",
    "web_config.select_body_font": "கட்டுரை எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "Select body font": "கட்டுரை எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "web_config.primary_font": "முக்கிய எழுத்துரீதி",
    "Primary Font": "முக்கிய எழுத்துரீதி",
    "web_config.select_primary_font": "முக்கிய எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "Select primary font": "முக்கிய எழுத்துரீதியைத் தேர்வு செய்யவும்",
    "web_config.uploaded_successfully": "மேம்படுத்தப்பட்டது",
    "web_config.ios_download_icon": "iOS பயன்பாடு பதிவிறக்க ஐகான்",
    "iOS app download icon": "iOS பயன்பாடு பதிவிறக்க ஐகான்",
    "web_config.ios_download_link": "iOS பயன்பாடு பதிவிறக்க இணைப்பு",
    "iOS app download link": "iOS பயன்பாடு பதிவிறக்க இணைப்பு",
    "web_config.enter_ios_download_link": "iOS பயன்பாடு பதிவிறக்க இணைப்பை உள்ளிடவும்",
    "Enter iOS app download link": "iOS பயன்பாடு பதிவிறக்க இணைப்பை உள்ளிடவும்",
    "web_config.android_download_icon": "Android பயன்பாடு பதிவிறக்க ஐகான்",
    "Android app download icon": "Android பயன்பாடு பதிவிறக்க ஐகான்",
    "web_config.android_download_link": "Android பயன்பாடு பதிவிறக்க இணைப்பு",
    "Android app download link": "Android பயன்பாடு பதிவிறக்க இணைப்பு",
    "web_config.enter_android_download_link": "Android பயன்பாடு பதிவிறக்க இணைப்பை உள்ளிடவும்",
    "Enter android app download link": "Android பயன்பாடு பதிவிறக்க இணைப்பை உள்ளிடவும்",
    "coupons.preview.customer_checkout": "வாடிக்கையாளர் கட்டணம்",
    "CUSTOMER CHECKOUT": "வாடிக்கையாளர் கட்டணம்",
    "coupons.preview.title": "கூப்பன்கள் செயல்பாட்டில்",
    "Coupons in action": "கூப்பன்கள் செயல்பாட்டில்",
    "coupons.preview.featured_product": "உங்கள் தெரிவிக்கப்பட்ட பொருள்",
    "Your featured product": "உங்கள் தெரிவிக்கப்பட்ட பொருள்",
    "coupons.preview.product_meta": "1 பொருள் · திட்டமிட்ட விநியோகம்",
    "1 item · Standard delivery": "1 பொருள் · திட்டமிட்ட விநியோகம்",
    "coupons.preview.coupon_applied": "கூப்பன் பயன்படுத்தப்பட்டது",
    "Coupon applied": "கூப்பன் பயன்படுத்தப்பட்டது",
    "coupons.preview.remove": "அகற்று",
    "coupons.preview.discount_applied": "ஆர்டருக்கு தள்ளுபோக்கு பயன்படுத்தப்பட்டது",
    "Discount applied to the order": "ஆர்டருக்கு தள்ளுபோக்கு பயன்படுத்தப்பட்டது",
    "coupons.preview.subtotal": "சிறிய மொத்தம்",
    "coupons.preview.coupon_label": "கூப்பன் · WELCOME10",
    "Coupon · WELCOME10": "கூப்பன் · WELCOME10",
    "coupons.preview.grand_total": "மொத்தம்",
    "Grand total": "மொத்தம்",
    "coupons.preview.checkout": "செலுத்து",
    "CHECKOUT": "செலுத்து",
    "payments.stripe_get_keys": "Stripe கீழ் பெறு",
    "Get Stripe keys": "Stripe கீழ் பெறு",
    "payments.stripe_syncing": "Stripe உடன் ஒத்திசைவு செய்து கொண்டிருக்கிறது...",
    "Syncing with Stripe...": "Stripe உடன் ஒத்திசைவு செய்து கொண்டிருக்கிறது...",
    "payments.stripe_verifying_key": "குறியீட்டு குறிப்பை சரிபார்க்கிறது",
    "Verifying secret key": "குறியீட்டு குறிப்பை சரிபார்க்கிறது",
    "payments.stripe_creating_webhook": "பேமென்ட் வெப்ஹுக் உருவாக்குகிறது",
    "Creating payment webhook": "பேமென்ட் வெப்ஹுக் உருவாக்குகிறது",
    "payments.stripe_account_summary": "{country} · {mode} மோட் · {id}",
    "{country} · {mode} mode · {id}": "{country} · {mode} மோட் · {id}",
    "payments.stripe_webhooks_configured": "✓ வெப்ஹுக்குகள் அமைக்கப்பட்டுள்ளன — ரகசிய குறியீடுகள் தானியங்கி நிரப்பப்பட்டுள்ளன. நிலைத்தன்மைக்காக வடிவத்தை சேமிக்கவும்.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ வெப்ஹுக்குகள் அமைக்கப்பட்டுள்ளன — ரகசிய குறியீடுகள் தானியங்கி நிரப்பப்பட்டுள்ளன. நிலைத்தன்மைக்காக வடிவத்தை சேமிக்கவும்.",
    "payments.stripe_webhooks_error": "⚠ வெப்ஹுக் அமைப்பு தோல்வியடைந்தது. உங்கள் குறியீட்டு அனுமதிகளை சரிபார்த்து, மீண்டும் சிங்கிரோனைச் செய்யவும்.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ வெப்ஹுக் அமைப்பு தோல்வியடைந்தது. உங்கள் குறியீட்டு அனுமதிகளை சரிபார்த்து, மீண்டும் சிங்கிரோனைச் செய்யவும்.",
    "payments.stripe_invalid_key": "குறியீட்டு குறிப்பு செல்லாது. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "Invalid secret key. Check and try again.": "குறியீட்டு குறிப்பு செல்லாது. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "payments.stripe_setup_failed": "அமைப்பு தோல்வியடைந்தது. முதலில் உங்கள் குறியீட்டு குறிப்பு சிங்கிரோனைச் செய்துள்ளதாக உறுதிப்படுத்தவும்.",
    "Setup failed. Make sure your secret key is synced first.": "அமைப்பு தோல்வியடைந்தது. முதலில் உங்கள் குறியீட்டு குறிப்பு சிங்கிரோனைச் செய்துள்ளதாக உறுதிப்படுத்தவும்.",
    "payments.stripe_marketplace_connect": "மார்க்கெட்பிளேஸ் இணைப்பு",
    "Marketplace Connect": "மார்க்கெட்பிளேஸ் இணைப்பு",
    "payments.stripe_marketplace_hint": "மார்க்கெட்பிளேஸ் பேமென்ட்களுக்கு Stripe Connect பயன்படுத்தும்போது மட்டுமே தேவை.",
    "Only needed if you use Stripe Connect for marketplace payouts": "மார்க்கெட்பிளேஸ் பேமென்ட்களுக்கு Stripe Connect பயன்படுத்தும்போது மட்டுமே தேவை.",
    "payments.stripe_subscription_hint": "Tradly-ல் சந்தா பொருட்களை விற்கும்போது மட்டுமே தேவை.",
    "Only needed if you sell subscription products on Tradly": "Tradly-ல் சந்தா பொருட்களை விற்கும்போது மட்டுமே தேவை.",
    "integrations.sso.title": "நிறுவன ஏகப்பட்ட உள்நுழைவு",
    "Enterprise single sign-on": "நிறுவன ஏகப்பட்ட உள்நுழைவு",
    "integrations.sso.description": "ArcticWhale-ல் OIDC பயன்படுத்தி பொறுப்பு பெற்ற பணியாளர்கள் உள்நுழைய உங்கள் நிறுவன அடையாள வழங்குநரை இணைக்கவும். RS256 ஐப் பயன்படுத்தி அடையாள டோக்கன்களை கையொப்பமிடும் Okta, Microsoft Entra ID மற்றும் OIDC வழங்குநர்கள் ஆதரிக்கப்படுகின்றன.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "ArcticWhale-ல் OIDC பயன்படுத்தி பொறுப்பு பெற்ற பணியாளர்கள் உள்நுழைய உங்கள் நிறுவன அடையாள வழங்குநரை இணைக்கவும். RS256 ஐப் பயன்படுத்தி அடையாள டோக்கன்களை கையொப்பமிடும் Okta, Microsoft Entra ID மற்றும் OIDC வழங்குநர்கள் ஆதரிக்கப்படுகின்றன.",
    "integrations.sso.issuer_url": "வெளியீட்டாளர் URL",
    "Issuer URL": "வெளியீட்டாளர் URL",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "வாடிக்கையாளர் ID",
    "integrations.sso.client_secret": "வாடிக்கையாளர் ரகசியம்",
    "integrations.sso.secret_replace_placeholder": "பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது. அதை மாற்ற ஒரு மதிப்பை உள்ளிடவும்.",
    "Saved securely. Enter a value to replace it.": "பாதுகாப்பாக சேமிக்கப்பட்டுள்ளது. அதை மாற்ற ஒரு மதிப்பை உள்ளிடவும்.",
    "integrations.sso.secret_placeholder": "வாடிக்கையாளர் ரகசியத்தை உள்ளிடவும்",
    "Enter the client secret": "வாடிக்கையாளர் ரகசியத்தை உள்ளிடவும்",
    "integrations.sso.email_domains": "நிறுவன மின்னஞ்சல் டொமைன்கள்",
    "Company email domains": "நிறுவன மின்னஞ்சல் டொமைன்கள்",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "பணியாளர்களுக்கு ArcticWhale கணக்கு இருக்க வேண்டும் மற்றும் இந்த டெண்ட் அணுகல் கொண்டிருக்க வேண்டும். உங்கள் நிறுவனத்தின் சொந்த டொமைன்களைப் பயன்படுத்தவும்.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "பணியாளர்களுக்கு ArcticWhale கணக்கு இருக்க வேண்டும் மற்றும் இந்த டெண்ட் அணுகல் கொண்டிருக்க வேண்டும். உங்கள் நிறுவனத்தின் சொந்த டொமைன்களைப் பயன்படுத்தவும்.",
    "integrations.sso.callback_url": "OIDC கூட்டு முறை URL",
    "OIDC callback URL": "OIDC கூட்டு முறை URL",
    "integrations.sso.loading_callback_url": "கூட்டு முறை URL-ஐ ஏற்றுகிறது…",
    "Loading callback URL…": "கூட்டு முறை URL-ஐ ஏற்றுகிறது…",
    "integrations.sso.callback_help": "இந்த துல்லியமான URL-ஐ அடையாள வழங்குநர் பயன்பாட்டில் வலை மாற்று முகவரி என சேர்க்கவும்.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "இந்த துல்லியமான URL-ஐ அடையாள வழங்குநர் பயன்பாட்டில் வலை மாற்று முகவரி என சேர்க்கவும்.",
    "integrations.sso.enable": "நிறுவன ஏகப்பட்ட உள்நுழைவை செயல்படுத்து",
    "Enable company SSO sign-in": "நிறுவன ஏகப்பட்ட உள்நுழைவை செயல்படுத்து",
    "integrations.sso.checking": "சரிபார்க்கிறது…",
    "integrations.sso.test_issuer": "வெளியீட்டாளரை சோதிக்கவும்",
    "Test issuer": "வெளியீட்டாளரை சோதிக்கவும்",
    "integrations.sso.saving": "சேமிக்கிறது…",
    "integrations.sso.save": "SSO அமைப்புகளை சேமி",
    "Save SSO settings": "SSO அமைப்புகளை சேமி",
    "integrations.sso.security_help": "கிளயண்ட் சீக்ரெட் சேமிக்கப்படும் முன் குறிப்பிட்ட குறியீடு செய்யப்படுகிறது. SSO ஒரு நிறுவன உள்நுழைவு விருப்பத்தை சேர்க்கிறது; கடவுச்சொல் உள்நுழைவு இந்த அமைப்பில் மாற்றமின்றி உள்ளது.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "கிளயண்ட் சீக்ரெட் சேமிக்கப்படும் முன் குறிப்பிட்ட குறியீடு செய்யப்படுகிறது. SSO ஒரு நிறுவன உள்நுழைவு விருப்பத்தை சேர்க்கிறது; கடவுச்சொல் உள்நுழைவு இந்த அமைப்பில் மாற்றமின்றி உள்ளது.",
    "integrations.sso.load_error": "Enterprise SSO அமைப்புகளை ஏற்ற முடியவில்லை.",
    "Unable to load enterprise SSO settings.": "Enterprise SSO அமைப்புகளை ஏற்ற முடியவில்லை.",
    "integrations.sso.save_error": "Enterprise SSO அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Unable to save enterprise SSO settings.": "Enterprise SSO அமைப்புகளை சேமிக்க முடியவில்லை.",
    "integrations.sso.saved": "Enterprise SSO அமைப்புகள் சேமிக்கப்பட்டன.",
    "Enterprise SSO settings saved.": "Enterprise SSO அமைப்புகள் சேமிக்கப்பட்டன.",
    "integrations.sso.connection_ok": "Identity சேவையாளர் கண்டறிதல் அணுகக்கூடியது.",
    "Identity provider discovery is reachable.": "Identity சேவையாளர் கண்டறிதல் அணுகக்கூடியது.",
    "integrations.sso.connection_error": "Identity சேவையாளருடன் இணைப்பு ஏற்படுத்த முடியவில்லை.",
    "Unable to connect to the identity provider.": "Identity சேவையாளருடன் இணைப்பு ஏற்படுத்த முடியவில்லை.",
    "listing_configs.maximum_quantity_per_listing": "அறிவிப்பில் அதிகபட்ச அளவு",
    "listing_configs.example_quantity": "(எடுத்துக்காட்டு: 100)",
    "listing_configs.enter_maximum_quantity": "அறிவிப்பில் அதிகபட்ச அளவை உள்ளிடவும்",
    "Enter maximum quantity per listing": "அறிவிப்பில் அதிகபட்ச அளவை உள்ளிடவும்",
    "listing_configs.minimum_listing_price": "அறிவிப்பில் குறைந்தபட்ச விலை",
    "listing_configs.example_price": "(எடுத்துக்காட்டு: $5)",
    "listing_configs.enter_minimum_price": "அறிவிப்பில் குறைந்தபட்ச விலையை உள்ளிடவும்",
    "Enter minimum listing price": "அறிவிப்பில் குறைந்தபட்ச விலையை உள்ளிடவும்",
    "listing_configs.picture_count": "பதிவேற்றம் செய்யக்கூடிய படங்களின் எண்ணிக்கை",
    "listing_configs.enter_picture_count": "படங்களின் எண்ணிக்கையை உள்ளிடவும்",
    "Enter Pictures count": "படங்களின் எண்ணிக்கையை உள்ளிடவும்",
    "listing_configs.feature_activation": "பண்புகளை செயல்படுத்துதல்",
    "FEATURE ACTIVATION": "பண்புகளை செயல்படுத்துதல்",
    "listing_configs.example_landmark": "(எடுத்துக்காட்டு: அடையாள புள்ளி)",
    "listing_configs.enter_address_label": "முகவரி குறிப்பை உள்ளிடவும்",
    "Enter address Label": "முகவரி குறிப்பை உள்ளிடவும்",
    "listing_configs.legacy_switch_0": "அறிவிப்புகளை தானியங்கி ஒப்புக்கொள்ள வேண்டுமா?",
    "listing_configs.legacy_switch_1": "சதவீத அளிப்பு",
    "listing_configs.legacy_switch_2": "அறிவிப்பு அளவில் அதிகபட்ச அளவு கட்டுப்பாடுகள்",
    "listing_configs.legacy_switch_3": "மின்னஞ்சல் கட்டணம்",
    "listing_configs.legacy_switch_4": "முகவரியை தேடுவதற்கு பதிலாக வரைபட குறிப்பை பயன்படுத்தவும்",
    "Use map marker instead \nof searching address": "முகவரியை தேடுவதற்கு பதிலாக வரைபட குறிப்பை பயன்படுத்தவும்",
    "listing_configs.legacy_switch_5": "குறிப்புகள்",
    "listing_configs.legacy_switch_6": "கொள்முதல்",
    "listing_configs.legacy_switch_7": "இட முகவரி",
    "listing_configs.legacy_switch_8": "கொள்முதல் இல்லாத பட்டியல்களை ஃபீட்டில் காட்டு",
    "listing_configs.legacy_switch_9": "பட்டியல் தலைப்பு Slug",
    "listing_configs.legacy_switch_10": "வேரியன்ட்கள்",
    "listing_configs.legacy_switch_11": "மெட்டா தலைப்பு",
    "listing_configs.legacy_switch_12": "மெட்டா விவரணம்",
    "listing_configs.legacy_switch_13": "டிஜிட்டல் பொருள்",
    "Digital Product": "டிஜிட்டல் பொருள்",
    "listing_configs.legacy_switch_14": "கம்போசரை செயல்படுத்து",
    "listing_configs.legacy_switch_15": "எடையை செயல்படுத்து",
    "listing_configs.legacy_switch_16": "அளவுகளை செயல்படுத்து",
    "navigation.app_download.close": "மூடு",
    "navigation.app_download.eyebrow": "மொபைல் கூட்டாளி",
    "Mobile companion": "மொபைல் கூட்டாளி",
    "navigation.app_download.title": "உங்கள் திட்டத்தை இயக்கத்தில் வைக்கவும்.",
    "Keep your project moving.": "உங்கள் திட்டத்தை இயக்கத்தில் வைக்கவும்.",
    "navigation.app_download.description": "தொலைபேசியிலிருந்து புதிய பட்டியல்களை ஒப்புக்கொள்வது முதல் ஆர்டர்களை சரிபார்த்து உங்கள் வணிகத்தை நடைமுறையில் வைத்திருப்பது வரை அனைத்தையும் கையாளுங்கள்.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "தொலைபேசியிலிருந்து புதிய பட்டியல்களை ஒப்புக்கொள்வது முதல் ஆர்டர்களை சரிபார்த்து உங்கள் வணிகத்தை நடைமுறையில் வைத்திருப்பது வரை அனைத்தையும் கையாளுங்கள்.",
    "navigation.app_download.approve_listings": "பட்டியல்களை ஒப்புக்கொள்",
    "Approve listings": "பட்டியல்களை ஒப்புக்கொள்",
    "navigation.app_download.manage_orders": "ஆர்டர்களை கையாள்",
    "Manage orders": "ஆர்டர்களை கையாள்",
    "navigation.app_download.check_performance": "செயல்திறனை பார்க்க",
    "Check performance": "செயல்திறனை பார்க்க",
    "navigation.app_download.download_title": "SuperAdmin பயன்பாட்டை பதிவிறக்கு",
    "Download the SuperAdmin app": "SuperAdmin பயன்பாட்டை பதிவிறக்கு",
    "navigation.app_download.download_on": "பதிவிறக்கம்",
    "Download on the": "பதிவிறக்கம்",
    "navigation.app_download.app_store": "ஆப் ஸ்டோர்",
    "navigation.app_download.get_it_on": "இதைப் பெறு",
    "Get it on": "இதைப் பெறு",
    "listing_configs.address_label": "முகவரி குறிப்பு",
    "collections.add_another_condition": "+ மற்றொரு நிபந்தனையைச் சேர்க்கவும்",
    "collections.search": "தேடு",
    "collections.status_inactive_active": "நிலை (ஆக்டிவ் இல்லை / ஆக்டிவ்)",
    "media_picker.add_photo": "படம் சேர்க்கவும்",
    "payments.payment_intent_webhook_secret": "பேமென்ட் இன்டென்ட் வெப்ஹுக் சீக்ரெட்",
    "Payment Intent Webhook secret": "பேமென்ட் இன்டென்ட் வெப்ஹுக் சீக்ரெட்",
    "payments.subscription_webhook_secret": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக் சீக்ரெட்",
    "Subscription Webhook secret": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக் சீக்ரெட்",
    "payments.webhook_secret_autofilled": "மேலே ஆட்டோமேட்டிக்காக நிரப்பப்பட்ட வெப்ஹுக் சீக்ரெட் — பேச்சு விவரங்களை சேமிக்க வேண்டும்.",
    "Webhook secret auto-filled above — save the form to persist.": "மேலே ஆட்டோமேட்டிக்காக நிரப்பப்பட்ட வெப்ஹுக் சீக்ரெட் — பேச்சு விவரங்களை சேமிக்க வேண்டும்.",
    "app_customization.white_png_icon_help": "ஐகான் வெள்ளையாகவும், png வடிவத்திலும் இருக்க வேண்டும்",
    "icon should be white and in png format": "ஐகான் வெள்ளையாகவும், png வடிவத்திலும் இருக்க வேண்டும்",
    "app_customization.other_appearance": "மற்ற தோற்றம்",
    "Other appearance": "மற்ற தோற்றம்",
    "app_customization.notification_icon": "அறிவிப்பு ஐகான்",
    "Notification icon": "அறிவிப்பு ஐகான்",
    "app_customization.app_title_home": "முகப்பு திரையில் பயன்பாட்டு தலைப்பு",
    "app_customization.enable_app_title_icon": "எழுத்துக்களுக்குப் பதிலாக பயன்பாட்டு தலைப்பு ஐகானை செயல்படுத்துங்கள்",
    "listings.quick_add.title": "விரைவான பட்டியலைச் சேர்க்கவும்",
    "Quick Add Listing": "விரைவான பட்டியலைச் சேர்க்கவும்",
    "listings.quick_add.success": "பட்டியல் வெற்றிகரமாகச் சேர்க்கப்பட்டது",
    "Listing Added Successfully": "பட்டியல் வெற்றிகரமாகச் சேர்க்கப்பட்டது",
    "listings.quick_add.image": "படம்",
    "listings.quick_add.listing_name": "பட்டியல் பெயர்",
    "Listing Name": "பட்டியல் பெயர்",
    "listings.quick_add.title_placeholder": "எ.கா., பிரீமியம் வயர்லெஸ் ஹெட்ஃபோன்கள்",
    "e.g., Premium Wireless Headphones": "எ.கா., பிரீமியம் வயர்லெஸ் ஹெட்ஃபோன்கள்",
    "listings.quick_add.category": "பிரிவு",
    "listings.quick_add.select_category": "பிரிவைத் தேர்வு செய்க",
    "listings.quick_add.price": "விலை",
    "listings.quick_add.stock": "ஸ்டாக்",
    "listings.quick_add.description": "விவரம்",
    "listings.quick_add.description_placeholder": "உங்கள் பொருளின் சுருக்கமான விவரம்...",
    "Brief Description of your product...": "உங்கள் பொருளின் சுருக்கமான விவரம்...",
    "listings.quick_add.more_options": "மேலும் விருப்பங்கள் தேவையா? முழு வடிவமைப்பைப் பயன்படுத்தவும்.",
    "Need more options? Use the full": "மேலும் விருப்பங்கள் தேவையா? முழு வடிவமைப்பைப் பயன்படுத்தவும்.",
    "listings.quick_add.guided_form": "வழிகாட்டப்பட்ட வடிவமைப்பு",
    "guided form": "வழிகாட்டப்பட்ட வடிவமைப்பு",
    "listings.quick_add.instead": "இடமாற்று",
    "instead": "இடமாற்று",
    "listings.digital_product.title": "டிஜிட்டல் பொருளை சேர்க்கவும்",
    "Add Digital Product": "டிஜிட்டல் பொருளை சேர்க்கவும்",
    "listings.digital_product.select_file": "கோப்பைத் தேர்வு செய்க",
    "Select file": "கோப்பைத் தேர்வு செய்க",
    "listings.digital_product.name": "தலைப்பு",
    "listings.digital_product.version": "பதிப்பு",
    "listings.digital_product.description": "விவரணம்",
    "web_config.social_info": "சமூக தகவல்கள்",
    "Social Info": "சமூக தகவல்கள்",
    "web_config.social_facebook_pageurl": "ஃபேஸ்புக் பக்கத்தின் URL",
    "Facebook page URL": "ஃபேஸ்புக் பக்கத்தின் URL",
    "web_config.enter_social_facebook_pageurl": "ஃபேஸ்புக் பக்கத்தின் URL-ஐ உள்ளிடவும்",
    "Enter Facebook page URL": "ஃபேஸ்புக் பக்கத்தின் URL-ஐ உள்ளிடவும்",
    "web_config.social_twitter_handleurl": "ட்விட்டர் ஹேண்டில் URL",
    "Twitter handle URL": "ட்விட்டர் ஹேண்டில் URL",
    "web_config.enter_social_twitter_handleurl": "ட்விட்டர் ஹேண்டில் URL-ஐ உள்ளிடவும்",
    "Enter Twitter handle URL": "ட்விட்டர் ஹேண்டில் URL-ஐ உள்ளிடவும்",
    "web_config.social_instagram_url": "இன்ஸ்டாகிராம் URL",
    "Instagram URL": "இன்ஸ்டாகிராம் URL",
    "web_config.enter_social_instagram_url": "இன்ஸ்டாகிராம் URL-ஐ உள்ளிடவும்",
    "Enter Instagram URL": "இன்ஸ்டாகிராம் URL-ஐ உள்ளிடவும்",
    "web_config.social_youtube_channelurl": "யூடியூப் சேனல் URL",
    "Youtube channel URL": "யூடியூப் சேனல் URL",
    "web_config.enter_social_youtube_channelurl": "யூடியூப் சேனல் URL-ஐ உள்ளிடவும்",
    "Enter Youtube channel URL": "யூடியூப் சேனல் URL-ஐ உள்ளிடவும்",
    "web_config.social_tiktok_url": "டிக்டாக் URL",
    "Tiktok URL": "டிக்டாக் URL",
    "web_config.enter_social_tiktok_url": "டிக்டாக் URL-ஐ உள்ளிடவும்",
    "Enter Tiktok URL": "டிக்டாக் URL-ஐ உள்ளிடவும்",
    "web_config.social_spotify_url": "ஸ்பாடிப் URL",
    "Spotify URL": "ஸ்பாடிப் URL",
    "web_config.enter_social_spotify_url": "ஸ்பாடிப் URL-ஐ உள்ளிடவும்",
    "Enter Spotify URL": "ஸ்பாடிப் URL-ஐ உள்ளிடவும்",
    "web_config.social_whatsapp_number": "வாட்ஸ்அப் எண்",
    "Whatsapp number": "வாட்ஸ்அப் எண்",
    "web_config.enter_social_whatsapp_number": "வாட்ஸ்அப் எண்ணை உள்ளிடவும்",
    "Enter Whatsapp number": "வாட்ஸ்அப் எண்ணை உள்ளிடவும்",
    "web_config.social_telegram_url": "டெலிகிராம் URL",
    "Telegram URL": "டெலிகிராம் URL",
    "web_config.enter_social_telegram_url": "டெலிகிராம் URL-ஐ உள்ளிடவும்",
    "Enter Telegram URL": "டெலிகிராம் URL-ஐ உள்ளிடவும்",
    "web_config.social_snapchat": "ஸ்னாப்சாட்",
    "Snapchat": "ஸ்னாப்சாட்",
    "web_config.enter_social_snapchat": "சான்ட்ஸ்கேப்பை உள்ளிடவும்",
    "Enter Snapchat": "சான்ட்ஸ்கேப்பை உள்ளிடவும்",
    "payments.paydunya.title": "PayDunya ஒத்திசைவு",
    "PayDunya Integration": "PayDunya ஒத்திசைவு",
    "payments.paydunya.master_key": "முதன்மை குறியீடு",
    "Master key": "முதன்மை குறியீடு",
    "payments.paydunya.enter_master_key": "முதன்மை குறியீட்டை உள்ளிடவும்",
    "Enter master key": "முதன்மை குறியீட்டை உள்ளிடவும்",
    "payments.paydunya.public_key": "பொது குறியீடு",
    "Public key": "பொது குறியீடு",
    "payments.paydunya.enter_public_key": "பொது குறியீட்டை உள்ளிடவும்",
    "payments.paydunya.private_key": "தனியார் குறியீடு",
    "Private key": "தனியார் குறியீடு",
    "payments.paydunya.enter_private_key": "தனியார் குறியீட்டை உள்ளிடவும்",
    "Enter private key": "தனியார் குறியீட்டை உள்ளிடவும்",
    "payments.paydunya.token": "டோக்கன்",
    "payments.paydunya.enter_token": "Token உள்ளிடவும்",
    "payments.paydunya.uploaded_successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "communications.email_stats_open": "{sent} அனுப்பப்பட்டது · {openRate}% திறந்திருக்கிறது",
    "{sent} sent · {openRate}% open": "{sent} அனுப்பப்பட்டது · {openRate}% திறந்திருக்கிறது",
    "communications.email_stats_full": "{sent} அனுப்பப்பட்டது · {openRate}% திறக்கப்பட்டது · {clicks} கிளிக்குகள்",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} அனுப்பப்பட்டது · {openRate}% திறக்கப்பட்டது · {clicks} கிளிக்குகள்",
    "navigation.mini_apps.title": "சிறு செயலிகள்",
    "Mini Apps": "சிறு செயலிகள்",
    "navigation.mini_apps.subtitle": "Tradly-கொண்டு உருவாக்கப்பட்ட துணை கருவிகள் — விவரங்கள் மற்றும் விலைகளைப் பார்க்க ஒரு கார்டைத் தட்டவும்",
    "Tradly-built companion tools — tap a card to see details and pricing": "Tradly-கொண்டு உருவாக்கப்பட்ட துணை கருவிகள் — விவரங்கள் மற்றும் விலைகளைப் பார்க்க ஒரு கார்டைத் தட்டவும்",
    "navigation.mini_apps.soon": "விரைவில்",
    "Soon": "விரைவில்",
    "navigation.mini_apps.included_in_paid_plan": "கட்டண திட்டத்தில் அடங்கும்",
    "Included in a paid plan": "கட்டண திட்டத்தில் அடங்கும்",
    "navigation.mini_apps.know_more": "மேலும் அறிய",
    "Know more": "மேலும் அறிய",
    "navigation.mini_apps.hide_details": "விவரங்களை மறை",
    "Hide details": "விவரங்களை மறை",
    "navigation.mini_apps.view_plans": "திட்டங்களைப் பார்க்க",
    "navigation.mini_apps.remove": "அகற்று",
    "navigation.mini_apps.add_to_sidebar": "பக்க அட்டையில் சேர்",
    "Add to sidebar": "பக்க அட்டையில் சேர்",
    "navigation.mini_apps.why_heading": "உங்கள் வணிகத்திற்கு இது தேவையா?",
    "Why your business needs it": "உங்கள் வணிகத்திற்கு இது தேவையா?",
    "navigation.mini_apps.coming_soon": "விரைவில்",
    "navigation.mini_apps.workflow.title": "மார்க்கெட்டிங்",
    "navigation.mini_apps.workflow.description": "உங்கள் பார்வையாளரை வளர்த்துக்கொள்ள, மின்னஞ்சல் கேம்பேய்ன்கள், புஷ் அறிவிப்புகள் மற்றும் பிரமோஷன்களை இயக்கவும்.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "உங்கள் பார்வையாளரை வளர்த்துக்கொள்ள, மின்னஞ்சல் கேம்பேய்ன்கள், புஷ் அறிவிப்புகள் மற்றும் பிரமோஷன்களை இயக்கவும்.",
    "navigation.mini_apps.workflow.why_1": "செயல்பாட்டின் அடிப்படையில் வாங்குபவர்கள் மற்றும் விற்பனையாளர்களுக்கு இலக்கு நோக்கிய மின்னஞ்சல் கேம்பேய்ன்களை அனுப்பவும்",
    "Send targeted email campaigns to buyers and sellers based on activity": "செயல்பாட்டின் அடிப்படையில் வாங்குபவர்கள் மற்றும் விற்பனையாளர்களுக்கு இலக்கு நோக்கிய மின்னஞ்சல் கேம்பேய்ன்களை அனுப்பவும்",
    "navigation.mini_apps.workflow.why_2": "7+ நாட்களுக்கு மேல் பார்வையிடாத பயனர்களை மீண்டும் ஈர்க்க புஷ் அறிவிப்புகளை அனுப்பவும்",
    "Push notifications to re-engage users who haven't visited in 7+ days": "7+ நாட்களுக்கு மேல் பார்வையிடாத பயனர்களை மீண்டும் ஈர்க்க புஷ் அறிவிப்புகளை அனுப்பவும்",
    "navigation.mini_apps.workflow.why_3": "உங்கள் காலாண்டு நிகழ்வுகளுக்கு ஏற்ப குறைப்புகளை நேர அடிப்படையில் நடத்துங்கள்",
    "Run promotions with coupon drops timed to your seasonal events": "உங்கள் காலாண்டு நிகழ்வுகளுக்கு ஏற்ப குறைப்புகளை நேர அடிப்படையில் நடத்துங்கள்",
    "navigation.mini_apps.workflow.pricing_label": "கிரெடிட் அடிப்படையில்",
    "navigation.mini_apps.workflow.pricing_detail": "அனுப்புவதற்கு கட்டணம் செலுத்துங்கள் — 1,000 மின்னஞ்சல்களுக்கு 100 கிரெடிட்கள். கிரெடிட்கள் முடிவடையாது.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "அனுப்புவதற்கு கட்டணம் செலுத்துங்கள் — 1,000 மின்னஞ்சல்களுக்கு 100 கிரெடிட்கள். கிரெடிட்கள் முடிவடையாது.",
    "navigation.mini_apps.intelligence_section.title": "உள்ளுணர்வு",
    "navigation.mini_apps.intelligence_section.description": "AI மூலம் உருவாக்கப்பட்ட பகுப்பாய்வுகள், எம்புய்ஸ் மற்றும் அறிவுகளுடன் உங்கள் வளர்ச்சியை புரிந்துகொள்ளவும்.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "AI மூலம் உருவாக்கப்பட்ட பகுப்பாய்வுகள், எம்புய்ஸ் மற்றும் அறிவுகளுடன் உங்கள் வளர்ச்சியை புரிந்துகொள்ளவும்.",
    "navigation.mini_apps.intelligence_section.why_1": "மிக அதிக ஜிஎம்வி உருவாக்கும் பட்டியல்கள், கணக்குகள் மற்றும் பிரிவுகளைக் காண்க",
    "See which listings, accounts, and categories drive the most GMV": "மிக அதிக ஜிஎம்வி உருவாக்கும் பட்டியல்கள், கணக்குகள் மற்றும் பிரிவுகளைக் காண்க",
    "navigation.mini_apps.intelligence_section.why_2": "வாங்குபவர்கள் செலுத்துவதற்கு முன் எங்கே விட்டுவிடுகிறார்கள் என்பதை தெளிவாகக் காட்டும் கீழ்த்தட்டு பாதைகள்",
    "Drop-off funnels show exactly where buyers leave before checkout": "வாங்குபவர்கள் செலுத்துவதற்கு முன் எங்கே விட்டுவிடுகிறார்கள் என்பதை தெளிவாகக் காட்டும் கீழ்த்தட்டு பாதைகள்",
    "navigation.mini_apps.intelligence_section.why_3": "மூல தரவுகளில் தவறுதலாக கவனிக்காமல் போகும் அசாதாரணங்கள் மற்றும் வாய்ப்புகளை AI கண்டறிகிறது.",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "மூல தரவுகளில் தவறுதலாக கவனிக்காமல் போகும் அசாதாரணங்கள் மற்றும் வாய்ப்புகளை AI கண்டறிகிறது.",
    "navigation.mini_apps.intelligence_section.pricing_label": "கிரெடிட்டுகளை அடிப்படையாகக் கொண்டது",
    "navigation.mini_apps.intelligence_section.pricing_detail": "AI பகுப்பாய்வு மற்றும் உருவாக்கப்பட்ட அறிக்கைகள் கிரெடிட்டுகளை பயன்படுத்துகின்றன. தரவு காட்சிகள் எப்போதும் இலவசமாக இருக்கும்.",
    "AI analysis and generated reports consume credits. Data views are always free.": "AI பகுப்பாய்வு மற்றும் உருவாக்கப்பட்ட அறிக்கைகள் கிரெடிட்டுகளை பயன்படுத்துகின்றன. தரவு காட்சிகள் எப்போதும் இலவசமாக இருக்கும்.",
    "navigation.mini_apps.subscription_section.title": "சப்ஸ்கிரிப்ஷன்",
    "navigation.mini_apps.subscription_section.description": "உங்கள் டெண்ட் அடிப்படையில் திட்டங்களை, விலை கணக்கீட்டு சுழற்சிகளை மற்றும் செயல்பாடுகளுக்கான உரிமைகளை நிர்வகிக்கவும்.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "உங்கள் டெண்ட் அடிப்படையில் திட்டங்களை, விலை கணக்கீட்டு சுழற்சிகளை மற்றும் செயல்பாடுகளுக்கான உரிமைகளை நிர்வகிக்கவும்.",
    "navigation.mini_apps.subscription_section.why_1": "செயல்பாடுகளுக்கு ஏற்ப தரம் வகைப்படுத்தப்பட்ட திட்டங்களை (இலவசம் / ப்ரோ / நிறுவனம்) உருவாக்கவும்",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "செயல்பாடுகளுக்கு ஏற்ப தரம் வகைப்படுத்தப்பட்ட திட்டங்களை (இலவசம் / ப்ரோ / நிறுவனம்) உருவாக்கவும்",
    "navigation.mini_apps.subscription_section.why_2": "மாதாந்திரம், ஆண்டுதோறும் அல்லது தனிப்பயன் கால அளவுகளுடன் விலை கணக்கீட்டு சுழற்சிகளை தானியங்கி செய்யவும்",
    "Automate billing cycles — monthly, annual, or custom durations": "மாதாந்திரம், ஆண்டுதோறும் அல்லது தனிப்பயன் கால அளவுகளுடன் விலை கணக்கீட்டு சுழற்சிகளை தானியங்கி செய்யவும்",
    "navigation.mini_apps.subscription_section.why_3": "உங்கள் டெண்ட் அடிப்படையில் செயல்பாடுகளை திறக்க அல்லது தடுக்க உரிமைகளை பயன்படுத்தவும்",
    "Entitlements unlock or restrict features across your tenant base": "உங்கள் டெண்ட் அடிப்படையில் செயல்பாடுகளை திறக்க அல்லது தடுக்க உரிமைகளை பயன்படுத்தவும்",
    "navigation.mini_apps.subscription_section.pricing_label": "இணைக்கவும்",
    "Connect": "இணைக்கவும்",
    "navigation.mini_apps.subscription_section.pricing_detail": "காரியம் அடிப்படையிலான விலைகள் — சப்ஸ்கிரிப்ஷன் நிகழ்வுகளுக்கு (ஆப்பிரேட், மீண்டும் பெறுதல், ரத்து செய்தல்) கட்டணம் வசூலிக்கப்படுகிறது.",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "காரியம் அடிப்படையிலான விலைகள் — சப்ஸ்கிரிப்ஷன் நிகழ்வுகளுக்கு (ஆப்பிரேட், மீண்டும் பெறுதல், ரத்து செய்தல்) கட்டணம் வசூலிக்கப்படுகிறது.",
    "navigation.mini_apps.membership_section.title": "மெம்பர்ஷிப்",
    "navigation.mini_apps.membership_section.description": "மெம்பர்ஷிப் திட்டங்களை, பதிவு செய்த உறுப்பினர்களை, பங்களிப்புகளை மற்றும் கட்டணங்களை நிர்வகிக்கவும்.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "மெம்பர்ஷிப் திட்டங்களை, பதிவு செய்த உறுப்பினர்களை, பங்களிப்புகளை மற்றும் கட்டணங்களை நிர்வகிக்கவும்.",
    "navigation.mini_apps.membership_section.why_1": "மெம்பர்ஷிப் திட்டங்களை மற்றும் பதிவு செய்த உறுப்பினர்களை நிர்வகிக்கவும்",
    "Manage membership programs and enrolled members": "மெம்பர்ஷிப் திட்டங்களை மற்றும் பதிவு செய்த உறுப்பினர்களை நிர்வகிக்கவும்",
    "navigation.mini_apps.membership_section.why_2": "கொண்டுவரும் பங்களிப்புகள், கடன் கட்டணம் மற்றும் உறுப்பினர் நிலையை கண்காணிக்கவும்",
    "Track contributions, payment dues, and membership status": "கொண்டுவரும் பங்களிப்புகள், கடன் கட்டணம் மற்றும் உறுப்பினர் நிலையை கண்காணிக்கவும்",
    "navigation.mini_apps.membership_section.why_3": "உறுப்பினர் பங்களிப்புகளை அவர்களின் ஆர்டர்களுடன் இணைக்கவும்",
    "Connect membership contributions back to their orders": "உறுப்பினர் பங்களிப்புகளை அவர்களின் ஆர்டர்களுடன் இணைக்கவும்",
    "navigation.mini_apps.membership_section.pricing_label": "விலைகள் TBC",
    "Pricing TBC": "விலைகள் TBC",
    "navigation.mini_apps.membership_section.pricing_detail": "ஒரே இடத்தில் உறுப்பினர் திட்டங்களையும் பங்களிப்பு வரலாற்றையும் நிர்வகிக்கவும்.",
    "Manage membership programs and contribution history in one place.": "ஒரே இடத்தில் உறுப்பினர் திட்டங்களையும் பங்களிப்பு வரலாற்றையும் நிர்வகிக்கவும்.",
    "navigation.mini_apps.reward_programs.title": "விருதுகள்",
    "navigation.mini_apps.reward_programs.description": "விருது திட்டங்களை விருதுகள் மற்றும் மீண்டும் பயன்படுத்தக்கூடிய விருது சமையல் முறைகளுடன் உருவாக்கவும்.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "விருது திட்டங்களை விருதுகள் மற்றும் மீண்டும் பயன்படுத்தக்கூடிய விருது சமையல் முறைகளுடன் உருவாக்கவும்.",
    "navigation.mini_apps.reward_programs.why_1": "ஆப்பிளியேட், பரிந்துரைக்கப்பட்ட, பிராந்திய அல்லது கடை விருது திட்டங்களை அமைக்கவும்",
    "Define affiliate, referral, regional, or store reward programs": "ஆப்பிளியேட், பரிந்துரைக்கப்பட்ட, பிராந்திய அல்லது கடை விருது திட்டங்களை அமைக்கவும்",
    "navigation.mini_apps.reward_programs.why_2": "கமிஷன் மற்றும் விருது கூறுகளை மீண்டும் பயன்படுத்தக்கூடிய வடிவமைப்புகளிலிருந்து விதிகளை உருவாக்கவும்",
    "Build rules from reusable commission and reward components": "கமிஷன் மற்றும் விருது கூறுகளை மீண்டும் பயன்படுத்தக்கூடிய வடிவமைப்புகளிலிருந்து விதிகளை உருவாக்கவும்",
    "navigation.mini_apps.reward_programs.why_3": "ERP பின்புலத்தின் மூலம் விருது கணக்கீடு மற்றும் பதிவு வழங்கலை நிர்வகிக்கவும்",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "ERP பின்புலத்தின் மூலம் விருது கணக்கீடு மற்றும் பதிவு வழங்கலை நிர்வகிக்கவும்",
    "navigation.mini_apps.reward_programs.pricing_label": "விலைகள் TBC",
    "navigation.mini_apps.reward_programs.pricing_detail": "விருது திட்டங்களை அமைத்து, அதை பெறும் முறையுடன் இணைக்கவும்.",
    "Configure reward programs and connect them to attribution.": "விருது திட்டங்களை அமைத்து, அதை பெறும் முறையுடன் இணைக்கவும்.",
    "navigation.mini_apps.bundles_app.title": "பேக்கேஜ்கள்",
    "navigation.mini_apps.bundles_app.description": "உள்ள பட்டியல்களிலிருந்து நிலையான மற்றும் மிக்ஸ்-அண்ட்-மேட்ச் பேக்கேஜ்களை உருவாக்கவும்.",
    "Create fixed and mix-and-match bundles from existing listings.": "உள்ள பட்டியல்களிலிருந்து நிலையான மற்றும் மிக்ஸ்-அண்ட்-மேட்ச் பேக்கேஜ்களை உருவாக்கவும்.",
    "navigation.mini_apps.bundles_app.why_1": "தயாரிப்பு தரவுகளை மடக்காமல் உள்ள பட்டியல்களை இணைக்கவும்",
    "Combine existing listings without duplicating product data": "தயாரிப்பு தரவுகளை மடக்காமல் உள்ள பட்டியல்களை இணைக்கவும்",
    "navigation.mini_apps.bundles_app.why_2": "நிலையான மற்றும் வாடிக்கையாளர் தேர்வு செய்த மிக்ஸ்-அண்ட்-மேட்ச் பேக்கேஜ்களை ஆதரிக்கவும்",
    "Support fixed bundles and customer-selected mix-and-match bundles": "நிலையான மற்றும் வாடிக்கையாளர் தேர்வு செய்த மிக்ஸ்-அண்ட்-மேட்ச் பேக்கேஜ்களை ஆதரிக்கவும்",
    "navigation.mini_apps.bundles_app.why_3": "கால்வின் மற்றும் நிறைவேற்றத்திற்கு முன் கூறுகளின் ஸ்டாக்கை சரிபார்க்கவும்",
    "Validate component stock before checkout and fulfilment": "கால்வின் மற்றும் நிறைவேற்றத்திற்கு முன் கூறுகளின் ஸ்டாக்கை சரிபார்க்கவும்",
    "navigation.mini_apps.bundles_app.pricing_label": "கட்டண பேக்கேஜ் அம்சம்",
    "Paid package feature": "கட்டண பேக்கேஜ் அம்சம்",
    "navigation.mini_apps.bundles_app.pricing_detail": "பேக்கேஜ் செயல்பாடுகளை உள்ளடக்கிய திட்டங்களில் கிடைக்கிறது.",
    "Available on plans that include bundle operations.": "பேக்கேஜ் செயல்பாடுகளை உள்ளடக்கிய திட்டங்களில் கிடைக்கிறது.",
    "navigation.mini_apps.inventory_section.title": "சப்ளை செயின்",
    "navigation.mini_apps.inventory_section.description": "கொள்முதல், கடைகள், ஸ்டாக் இடங்கள், வழங்குநர்கள் மற்றும் செயல்பாடுகள்.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "கொள்முதல், கடைகள், ஸ்டாக் இடங்கள், வழங்குநர்கள் மற்றும் செயல்பாடுகள்.",
    "navigation.mini_apps.inventory_section.why_1": "பல உள்ளீடுகள் மற்றும் கடை இடங்களில் ஸ்டாக் நிலைகளை கண்காணிக்கவும்",
    "Track stock levels across multiple warehouses and store locations": "பல உள்ளீடுகள் மற்றும் கடை இடங்களில் ஸ்டாக் நிலைகளை கண்காணிக்கவும்",
    "navigation.mini_apps.inventory_section.why_2": "வழங்குநர்களுடன் கொள்முதல் ஆர்டர்களை உருவாக்கி, அதற்கு ஸ்டாக்கை பெறவும்",
    "Raise purchase orders with suppliers and receive stock against them": "வழங்குநர்களுடன் கொள்முதல் ஆர்டர்களை உருவாக்கி, அதற்கு ஸ்டாக்கை பெறவும்",
    "navigation.mini_apps.inventory_section.why_3": "உள்ளீட்டு செயல்பாடுகளை பதிவு செய்யவும் — திருத்தங்கள், பரிமாற்றங்கள் மற்றும் எழுத்துப்பதிவு",
    "Record inventory operations — adjustments, transfers, and write-offs": "உள்ளீட்டு செயல்பாடுகளை பதிவு செய்யவும் — திருத்தங்கள், பரிமாற்றங்கள் மற்றும் எழுத்துப்பதிவு",
    "navigation.mini_apps.inventory_section.pricing_label": "சேர்க்கப்பட்டது",
    "Included": "சேர்க்கப்பட்டது",
    "navigation.mini_apps.inventory_section.pricing_detail": "சப்ளை சைன் உங்கள் திட்டத்தில் அடங்கும். கூடுதல் கட்டணம் இல்லை.",
    "Supply Chain is included in your plan. No additional charge.": "சப்ளை சைன் உங்கள் திட்டத்தில் அடங்கும். கூடுதல் கட்டணம் இல்லை.",
    "navigation.mini_apps.people_app.title": "மனிதர்கள்",
    "navigation.mini_apps.people_app.description": "பணியாளர் பட்டியல், துறைகள், பணிப்பாடுகள் மற்றும் ஊதிய அளவுகள்.",
    "Staff directory, departments, job profiles, and pay grades.": "பணியாளர் பட்டியல், துறைகள், பணிப்பாடுகள் மற்றும் ஊதிய அளவுகள்.",
    "navigation.mini_apps.people_app.why_1": "ஒரே பட்டியலில் அனைத்து பணியாளர் சொத்துகள், குறியீடுகள் மற்றும் பணியாளர் வகைகளை பராமரிக்கவும்",
    "Keep every staff profile, code, and employment type in one directory": "ஒரே பட்டியலில் அனைத்து பணியாளர் சொத்துகள், குறியீடுகள் மற்றும் பணியாளர் வகைகளை பராமரிக்கவும்",
    "navigation.mini_apps.people_app.why_2": "தொழிலாளர் பணிப்பாடுகளுடன் குழுக்களை துறைகளாக அமைக்கவும்",
    "Organise teams into departments with standard job profiles": "தொழிலாளர் பணிப்பாடுகளுடன் குழுக்களை துறைகளாக அமைக்கவும்",
    "navigation.mini_apps.people_app.why_3": "ஒருமுறை ஊதிய அளவுகளை வரையறுத்து, அதை பணியாளர்களுக்கு ஒதுக்கவும்",
    "Define pay grades once and assign them to staff": "ஒருமுறை ஊதிய அளவுகளை வரையறுத்து, அதை பணியாளர்களுக்கு ஒதுக்கவும்",
    "navigation.mini_apps.people_app.pricing_label": "விலைகள் TBC",
    "navigation.mini_apps.people_app.pricing_detail": "பணியாளர் மற்றும் ஊதியம் தேவைப்படுகிறது.",
    "Required by Workforce and Payroll.": "பணியாளர் மற்றும் ஊதியம் தேவைப்படுகிறது.",
    "navigation.mini_apps.workforce_app.title": "பணியாளர் பட்டியல்",
    "navigation.mini_apps.workforce_app.description": "உங்கள் குழுவிற்கான மாற்றுகள், கலந்துரையாடல் மற்றும் விடுமுறை மேலாண்மை.",
    "Shifts, attendance, and leave management for your team.": "உங்கள் குழுவிற்கான மாற்றுகள், கலந்துரையாடல் மற்றும் விடுமுறை மேலாண்மை.",
    "navigation.mini_apps.workforce_app.why_1": "தேதி, நேரம் மற்றும் இடத்திற்கு ஏற்ப பணியாளர்களை மாற்றுகளில் பதிவு செய்யவும்",
    "Roster staff into shifts by date, time, and location": "தேதி, நேரம் மற்றும் இடத்திற்கு ஏற்ப பணியாளர்களை மாற்றுகளில் பதிவு செய்யவும்",
    "navigation.mini_apps.workforce_app.why_2": "முழு பங்கேற்பு வரலாற்றுடன் உள்ளே மற்றும் வெளியே குறிப்பிடவும்",
    "Clock in and out with a full attendance history": "முழு பங்கேற்பு வரலாற்றுடன் உள்ளே மற்றும் வெளியே குறிப்பிடவும்",
    "navigation.mini_apps.workforce_app.why_3": "விடுமுறை கொள்கைகள், சமன்பாடுகள் மற்றும் அனுமதி/நிராகரிப்பு ஒழுங்குமுறை",
    "Leave policies, balances, and an approve/reject workflow": "விடுமுறை கொள்கைகள், சமன்பாடுகள் மற்றும் அனுமதி/நிராகரிப்பு ஒழுங்குமுறை",
    "navigation.mini_apps.workforce_app.pricing_label": "விலைகள் TBC",
    "navigation.mini_apps.workforce_app.pricing_detail": "பணியாளரை தானியங்கி செயல்படுத்துகிறது.",
    "Turns on People automatically.": "பணியாளரை தானியங்கி செயல்படுத்துகிறது.",
    "navigation.mini_apps.payroll_app.title": "ஊதியம்",
    "navigation.mini_apps.payroll_app.description": "ஊதிய இயக்கங்கள், அனுமதிகள், CSV ஏற்றுமதி மற்றும் செலவு மீள்விக்கைகள்.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "ஊதிய இயக்கங்கள், அனுமதிகள், CSV ஏற்றுமதி மற்றும் செலவு மீள்விக்கைகள்.",
    "navigation.mini_apps.payroll_app.why_1": "பணியாளர் ஊதிய அளவுகளிலிருந்து கால அடிப்படையில் ஊதிய இயக்கங்களை உருவாக்கவும்",
    "Create payroll runs per period from staff pay grades": "பணியாளர் ஊதிய அளவுகளிலிருந்து கால அடிப்படையில் ஊதிய இயக்கங்களை உருவாக்கவும்",
    "navigation.mini_apps.payroll_app.why_2": "இயக்கங்களை அனுமதித்து, உங்கள் வங்கி அல்லது கணக்காளருக்கு CSV ஏற்றுமதி செய்யவும்",
    "Approve runs and export them as CSV for your bank or accountant": "இயக்கங்களை அனுமதித்து, உங்கள் வங்கி அல்லது கணக்காளருக்கு CSV ஏற்றுமதி செய்யவும்",
    "navigation.mini_apps.payroll_app.why_3": "பணியாளர் செலவுகள் தாக்கல் முதல் மீள்விக்கை வரை",
    "Staff expense claims from submission to reimbursement": "பணியாளர் செலவுகள் தாக்கல் முதல் மீள்விக்கை வரை",
    "navigation.mini_apps.payroll_app.pricing_label": "விலைகள் TBC",
    "navigation.mini_apps.payroll_app.pricing_detail": "பணியாளரை தானியங்கி செயல்படுத்துகிறது.",
    "navigation.mini_apps.unified_inbox.title": "ஒருங்கிணைந்த மெய்ல் பெட்டி",
    "Unified Inbox": "ஒருங்கிணைந்த மெய்ல் பெட்டி",
    "navigation.mini_apps.unified_inbox.description": "உங்கள் வாடிக்கையாளர் தொடர்புகள் — ஆர்டர்கள், ஆதரவு மற்றும் பேச்சு — ஒரே இடத்திலிருந்து.",
    "All your customer communication — orders, support, and chat — from one place.": "உங்கள் வாடிக்கையாளர் தொடர்புகள் — ஆர்டர்கள், ஆதரவு மற்றும் பேச்சு — ஒரே இடத்திலிருந்து.",
    "navigation.mini_apps.unified_inbox.why_1": "ஒரே தொடர் காட்சியில் ஆர்டர் கேள்விகள், ஆதரவு டிக்கெட்டுகள் மற்றும் வாங்குபவர் செய்திகளை அமைத்தல்",
    "Order queries, support tickets, and buyer messages in one thread view": "ஒரே தொடர் காட்சியில் ஆர்டர் கேள்விகள், ஆதரவு டிக்கெட்டுகள் மற்றும் வாங்குபவர் செய்திகளை அமைத்தல்",
    "navigation.mini_apps.unified_inbox.why_2": "உங்கள் கத்தாலாக் பயிற்சி செய்த ஐ.ஏ. பரிந்துரைக்கப்பட்ட பதில்களுடன் பதிலளிக்கவும்",
    "Reply with AI-suggested responses trained on your catalogue": "உங்கள் கத்தாலாக் பயிற்சி செய்த ஐ.ஏ. பரிந்துரைக்கப்பட்ட பதில்களுடன் பதிலளிக்கவும்",
    "navigation.mini_apps.unified_inbox.why_3": "குழுவில் உள்ள அனைத்து பேச்சுகளையும் குறியீடு, ஒதுக்குதல் மற்றும் தீர்வு செய்யவும்",
    "Tag, assign, and resolve conversations across your team": "குழுவில் உள்ள அனைத்து பேச்சுகளையும் குறியீடு, ஒதுக்குதல் மற்றும் தீர்வு செய்யவும்",
    "navigation.mini_apps.unified_inbox.pricing_label": "இணைக்கவும்",
    "navigation.mini_apps.unified_inbox.pricing_detail": "ஒவ்வொரு தீர்வு செய்யப்பட்ட பேச்சுக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "Task-based pricing per resolved conversation.": "ஒவ்வொரு தீர்வு செய்யப்பட்ட பேச்சுக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "navigation.mini_apps.social_connect.title": "சோஷியல் கனெக்ட்",
    "Social Connect": "சோஷியல் கனெக்ட்",
    "navigation.mini_apps.social_connect.description": "நீங்கள் அமைக்கும் நேரத்தில் சமூக சேனல்களுக்கு பட்டியல்களைப் பகிரவும்.",
    "Share listings to social channels on a schedule you define.": "நீங்கள் அமைக்கும் நேரத்தில் சமூக சேனல்களுக்கு பட்டியல்களைப் பகிரவும்.",
    "navigation.mini_apps.social_connect.why_1": "இன்ஸ்டாகிராம், ஃபேஸ்புக் மற்றும் X-ல் பட்டியல் பதிவுகளை தானியங்கி நேரம் அமைக்கவும்",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "இன்ஸ்டாகிராம், ஃபேஸ்புக் மற்றும் X-ல் பட்டியல் பதிவுகளை தானியங்கி நேரம் அமைக்கவும்",
    "navigation.mini_apps.social_connect.why_2": "ஒவ்வொரு சேனலுக்கும் பதிவு நேரத்தை அமைக்கவும் — தினசரி தள்ளுபோட்டிகள், ஃபிளாஷ் விற்பனைகள் அல்லது தனிப்பயன் கால அடுக்கு",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "ஒவ்வொரு சேனலுக்கும் பதிவு நேரத்தை அமைக்கவும் — தினசரி தள்ளுபோட்டிகள், ஃபிளாஷ் விற்பனைகள் அல்லது தனிப்பயன் கால அடுக்கு",
    "navigation.mini_apps.social_connect.why_3": "டாஷ்போர்டிலிருந்து ஒவ்வொரு பட்டியலுக்கும் கிளிக் மற்றும் ஈடுபடுத்தலை கண்காணிக்கவும்",
    "Track clicks and engagement back to each listing from the dashboard": "டாஷ்போர்டிலிருந்து ஒவ்வொரு பட்டியலுக்கும் கிளிக் மற்றும் ஈடுபடுத்தலை கண்காணிக்கவும்",
    "navigation.mini_apps.social_connect.pricing_label": "இணைக்கவும்",
    "navigation.mini_apps.social_connect.pricing_detail": "ஒவ்வொரு அமைக்கப்பட்ட பதிவுக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "Task-based pricing per scheduled post delivered.": "ஒவ்வொரு அமைக்கப்பட்ட பதிவுக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "navigation.mini_apps.shopping_channels.title": "வாங்கும் சேனல்கள்",
    "Shopping Channels": "வாங்கும் சேனல்கள்",
    "navigation.mini_apps.shopping_channels.description": "TikTok Shop, Shopee, Meta Catalog, Uber Eats மற்றும் பிறவற்றுடன் உங்கள் கத்தாலாக்கை இணைக்கவும்.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "TikTok Shop, Shopee, Meta Catalog, Uber Eats மற்றும் பிறவற்றுடன் உங்கள் கத்தாலாக்கை இணைக்கவும்.",
    "navigation.mini_apps.shopping_channels.why_1": "TikTok Shop, Shopee மற்றும் Meta Catalog-ல் உங்கள் பட்டியல்களை உடனடியாக சிங்கிரோனைஸ் செய்யவும்",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "TikTok Shop, Shopee மற்றும் Meta Catalog-ல் உங்கள் பட்டியல்களை உடனடியாக சிங்கிரோனைஸ் செய்யவும்",
    "navigation.mini_apps.shopping_channels.why_2": "Uber Eats மற்றும் Grab-க்கு உணவு மற்றும் பானங்கள் கத்தாலாக்குகளை இணைக்கவும்",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Uber Eats மற்றும் Grab-க்கு உணவு மற்றும் பானங்கள் கத்தாலாக்குகளை இணைக்கவும்",
    "navigation.mini_apps.shopping_channels.why_3": "கூடுதல் உள்ளீடு இல்லாமல் சேமிப்பு மற்றும் ஆர்டர்கள் தானியங்கி சிங்கிரோனைஸ் செய்யப்படுகின்றன",
    "Inventory and orders sync back automatically — no double-entry": "கூடுதல் உள்ளீடு இல்லாமல் சேமிப்பு மற்றும் ஆர்டர்கள் தானியங்கி சிங்கிரோனைஸ் செய்யப்படுகின்றன",
    "navigation.mini_apps.shopping_channels.pricing_label": "இணைக்கவும்",
    "navigation.mini_apps.shopping_channels.pricing_detail": "இணைக்கப்பட்ட சேனல் மூலம் நிறைவேற்றப்பட்ட ஒவ்வொரு ஆர்டருக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "Task-based pricing per order fulfilled through a connected channel.": "இணைக்கப்பட்ட சேனல் மூலம் நிறைவேற்றப்பட்ட ஒவ்வொரு ஆர்டருக்கும் பணியை அடிப்படையாகக் கொண்ட விலை.",
    "listing_configs.customize_table": "அட்டவணையை தனிப்பயனாக்குதல்",
    "Customize table": "அட்டவணையை தனிப்பயனாக்குதல்",
    "listing_configs.fields_visible": "அட்டவணையில் காணத்தகும் புலங்கள்",
    "Fields visible in table": "அட்டவணையில் காணத்தகும் புலங்கள்",
    "listing_configs.fields_hidden": "அட்டவணையில் காட்டப்படாத புலங்கள்",
    "Fields not shown in table": "அட்டவணையில் காட்டப்படாத புலங்கள்",
    "listing_configs.reset_default": "இயல்புநிலைக்கு மீண்டும் அமைக்கவும்",
    "listing_configs.column_title": "விரிவுரை தலைப்பு",
    "listing_configs.column_actions": "நடவடிக்கைகள்",
    "listing_configs.column_website": "வலைத்தளம்",
    "listing_configs.column_list_price": "பட்டியல் விலை",
    "listing_configs.column_offer_percent": "ஆஃபர் சதவீதம்",
    "Offer Percent": "ஆஃபர் சதவீதம்",
    "listing_configs.column_image": "படம்",
    "listing_configs.column_offer_price": "ஆஃபர் விலை",
    "Offer Price": "ஆஃபர் விலை",
    "listing_configs.column_status": "நிலை",
    "listing_configs.column_listing_id": "பட்டியல் ID",
    "listing_configs.column_listing_status": "பட்டியல் நிலை",
    "listing_configs.column_accounts": "கணக்குகள்",
    "listing_configs.column_currency": "முதலீடு",
    "listing_configs.column_sold": "விற்றது",
    "listing_configs.column_goal_amount": "இலக்கு தொகை",
    "Goal Amount": "இலக்கு தொகை",
    "listing_configs.column_width": "அகலம்",
    "listing_configs.column_height": "உயரம்",
    "listing_configs.column_weight": "எடை",
    "listing_configs.column_volume": "கன அளவு",
    "Volume": "கன அளவு",
    "listing_configs.column_order_type": "ஆர்டர் வகை",
    "Order Type": "ஆர்டர் வகை",
    "navigation.apps_group": "பயன்பாடுகள்",
    "navigation.channels_group": "வழிகள்",
    "navigation.manage_mini_apps": "மினி பயன்பாடுகளை நிர்வகி",
    "Manage Mini Apps": "மினி பயன்பாடுகளை நிர்வகி",
    "navigation.manage_channels": "வழிகளை நிர்வகி",
    "Manage Channels": "வழிகளை நிர்வகி",
    "listings.import.uploading": "பதிவேற்றம் செய்து கொண்டிருக்கிறது...",
    "listings.import.complete": "கொண்டுவருதல் முடிந்தது",
    "listings.import.error": "பிழை: {message}",
    "Error: {message}": "பிழை: {message}",
    "listings.import.file_label": "கோப்பு:",
    "listings.import.select_file": "கோப்பைத் தேர்வுசெய்க",
    "listings.import.response": "கொண்டுவரும் பதில்",
    "Import response": "கொண்டுவரும் பதில்",
    "listings.import.total_rows": "மொத்த வரிகள்:",
    "Total rows:": "மொத்த வரிகள்:",
    "listings.import.total_imported": "மொத்தம் கொண்டுவரப்பட்டது:",
    "Total imported:": "மொத்தம் கொண்டுவரப்பட்டது:",
    "listings.import.download_template": "பட்டியல் மாதிரி பதிவிறக்குதல்",
    "Download listings template": "பட்டியல் மாதிரி பதிவிறக்குதல்",
    "common.upload": "பதிவேற்று",
    "common.kanban_unavailable": "பலகை காட்சி தற்காலிகமாக கிடைக்காது",
    "Board view is temporarily unavailable": "பலகை காட்சி தற்காலிகமாக கிடைக்காது",
    "common.retry": "மீண்டும் முயற்சி செய்க",
    "Retry": "மீண்டும் முயற்சி செய்க",
    "listings.digital_assets.title": "மின்னணு சொத்துகள்",
    "Digital assets": "மின்னணு சொத்துகள்",
    "listings.digital_assets.not_found": "மின்னணு சொத்துகள் காணப்படவில்லை",
    "Digital assets not found": "மின்னணு சொத்துகள் காணப்படவில்லை",
    "listings.addon.saved": "கூடுதல் விவரம் வெற்றிகரமாக சேமிக்கப்பட்டது.",
    "Add-on saved successfully.": "கூடுதல் விவரம் வெற்றிகரமாக சேமிக்கப்பட்டது.",
    "listings.addon.title_required": "தலைப்பை உள்ளிடவும்.",
    "Please enter a title.": "தலைப்பை உள்ளிடவும்.",
    "listings.addon.price_required": "விலையை உள்ளிடவும்.",
    "Please enter a price.": "விலையை உள்ளிடவும்.",
    "listings.addon.no_media": "உங்களிடம் படிம கோப்புகள் இல்லை.",
    "listings.addon.price": "விலை",
    "listings.addon.offer_percentage": "ஆஃபர் சதவீதம்",
    "Offer Percentage": "ஆஃபர் சதவீதம்",
    "listings.addon.maximum_quantity": "கூடுதல் அளவு",
    "Maximum Quantity": "கூடுதல் அளவு",
    "listings.addon.stock": "ஸ்டாக்",
    "listings.addon.enter_price": "விலையை உள்ளிடவும்",
    "Enter price": "விலையை உள்ளிடவும்",
    "listings.addon.enter_offer_percentage": "ஆஃபர் சதவீதத்தை உள்ளிடவும்",
    "Enter offer percentage": "ஆஃபர் சதவீதத்தை உள்ளிடவும்",
    "listings.addon.enter_maximum_quantity": "கூடுதல் அளவை உள்ளிடவும்",
    "Enter maximum quantity": "கூடுதல் அளவை உள்ளிடவும்",
    "listings.addon.enter_stock": "ஸ்டாக்கை உள்ளிடவும்",
    "listings.addon.edit_title": "உருப்படியை தொகுத்து",
    "Edit Add-on": "உருப்படியை தொகுத்து",
    "listings.addon.add_title": "உருப்படியை சேர்க்க",
    "Add Add-on": "உருப்படியை சேர்க்க",
    "listings.addon.title": "தலைப்பு",
    "listings.addon.enter_title": "தலைப்பை உள்ளிடவும்",
    "listings.addon.status": "நிலை (ஆக்டிவ் இல்லை / ஆக்டிவ்)",
    "listings.addon.upload_media": "ஊடகத்தை பதிவிறக்கவும்",
    "attributes.prefill_for": "முன்னேற்றம் செய்யப்பட்டது",
    "Prefill for": "முன்னேற்றம் செய்யப்பட்டது",
    "attributes.first_item": "முதல் பொருள்",
    "First Item": "முதல் பொருள்",
    "attributes.all_items": "அனைத்து பொருட்களும்",
    "All Items": "அனைத்து பொருட்களும்",
    "common.uploading": "பதிவேற்றம் செய்து கொண்டிருக்கிறோம்...",
    "common.uploading_named": "{title} ஐ பதிவேற்றுகிறோம்",
    "Uploading {title}": "{title} ஐ பதிவேற்றுகிறோம்",
    "common.please_wait_short": "காத்திருக்கவும்",
    "Please wait": "காத்திருக்கவும்",
    "attributes.select_option": "தேர்வு செய்யவும்",
    "attributes.select_value": "மதிப்பைத் தேர்வு செய்யவும்...",
    "Select value...": "மதிப்பைத் தேர்வு செய்யவும்...",
    "attributes.type_placeholder": "{name} ஐ உள்ளிடவும்",
    "Type {name}": "{name} ஐ உள்ளிடவும்",
    "attributes.multiple_values_placeholder": "குறிப்பிட்ட மதிப்புகளை பிரித்து உள்ளிடலாம்",
    "Using a comma, you can enter several values.": "குறிப்பிட்ட மதிப்புகளை பிரித்து உள்ளிடலாம்",
    "attributes.upload_attachment": "கோப்பை பதிவேற்றவும்",
    "Upload Attachment": "கோப்பை பதிவேற்றவும்",
    "attributes.upload_json_file": "JSON கோப்பை பதிவேற்றவும்",
    "Upload JSON File": "JSON கோப்பை பதிவேற்றவும்",
    "attributes.copied_value": "மதிப்பு நகலெடுக்கப்பட்டது",
    "Copied the value": "மதிப்பு நகலெடுக்கப்பட்டது",
    "attributes.latitude_longitude_placeholder": "தொலைக்காட்சி, நிலையை உள்ளிடவும் (எ.கா. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "தொலைக்காட்சி, நிலையை உள்ளிடவும் (எ.கா. 12.34,56.78)",
    "navigation.sidebar_label": "பக்க அட்டை",
    "Side bar": "பக்க அட்டை",
    "checkout_settings.orders_option_0": "ஆர்டர் காலண்டர் காட்சி",
    "Orders Calendar View": "ஆர்டர் காலண்டர் காட்சி",
    "checkout_settings.show_cart_attributes": "கார்ட் பண்புகளைக் காட்டு",
    "Show cart attributes": "கார்ட் பண்புகளைக் காட்டு",
    "checkout_settings.select_order_status": "ஆர்டர் நிலையைத் தேர்வு செய்யவும்",
    "Select order status": "ஆர்டர் நிலையைத் தேர்வு செய்யவும்",
    "checkout_settings.order_status_0": "வெற்றிகரமாக பதிவு செய்யப்பட்டது",
    "Placed success": "வெற்றிகரமாக பதிவு செய்யப்பட்டது",
    "checkout_settings.order_status_1": "உருவாக்கப்படுகிறது",
    "In process": "உருவாக்கப்படுகிறது",
    "checkout_settings.order_status_2": "அனுப்பப்பட்டது",
    "checkout_settings.order_status_3": "அனுப்பப்பட்டுள்ளது",
    "checkout_settings.order_status_4": "முடிக்கப்பட்டது",
    "listing_form.no_categories_found": "கத்திரிகள் கிடைக்கவில்லை. மேலே {action} ஐப் பயன்படுத்தவும்.",
    "No categories found. Use “{action}” above.": "கத்திரிகள் கிடைக்கவில்லை. மேலே {action} ஐப் பயன்படுத்தவும்.",
    "common.learn_more": "மேலும் தகவல்",
    "Learn more": "மேலும் தகவல்",
    "common.show_information": "தகவலைக் காட்டு",
    "Show information": "தகவலைக் காட்டு",
    "common.paid_feature": "கட்டண அம்சம்",
    "Paid Feature": "கட்டண அம்சம்",
    "common.learn_more_about": "மேலும் தகவல்",
    "Learn more about": "மேலும் தகவல்",
    "attributes.categories": "கத்திரிகள்",
    "attributes.edit_bulk_title": "{title} கூட்டமாக தொகுத்தல்",
    "{title} Edit Bulk": "{title} கூட்டமாக தொகுத்தல்",
    "common.enter_description": "விளக்கத்தை உள்ளிடவும்",
    "common.empty_fetch_message": "இங்கு இன்னும் காட்ட தகவல் இல்லை. உள்ளடக்கம் கிடைக்கும்போது, இந்த பக்கத்தில் தோன்றும்.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "இங்கு இன்னும் காட்ட தகவல் இல்லை. உள்ளடக்கம் கிடைக்கும்போது, இந்த பக்கத்தில் தோன்றும்.",
    "common.ai_credits_and_top_up": "AI கிரெடிட்டுகள் மற்றும் நிரப்புதல்",
    "AI credits and top up": "AI கிரெடிட்டுகள் மற்றும் நிரப்புதல்",
    "common.ai_credits_loading": "AI கிரெடிட்டுகளை ஏற்றுகிறது",
    "Loading AI credits": "AI கிரெடிட்டுகளை ஏற்றுகிறது",
    "common.ai_credits_unavailable": "AI கிரெடிட்டுகள் கிடைக்கவில்லை",
    "AI credits unavailable": "AI கிரெடிட்டுகள் கிடைக்கவில்லை",
    "common.ai_credits_available": "கிடைக்கும் AI கிரெடிட்டுகள்: {count}",
    "Available AI credits: {count}": "கிடைக்கும் AI கிரெடிட்டுகள்: {count}",
    "common.ai_credits_unavailable_top_up": "AI கிரெடிட்டுகள் கிடைக்கவில்லை — நிரப்ப கிளிக் செய்யவும்",
    "AI credits unavailable — click to top up": "AI கிரெடிட்டுகள் கிடைக்கவில்லை — நிரப்ப கிளிக் செய்யவும்",
    "common.ai_credits_available_top_up": "கிடைக்கும் AI கிரெடிட்டுகள்: {count} — கிரெடிட்டுகளை சேர்க்க கிளிக் செய்யவும்",
    "Available AI credits: {count} — click to add credits": "கிடைக்கும் AI கிரெடிட்டுகள்: {count} — கிரெடிட்டுகளை சேர்க்க கிளிக் செய்யவும்",
    "common.ai_credits_add": "கிரெடிட்டுகளைச் சேர்",
    "Add credits": "கிரெடிட்டுகளைச் சேர்",
    "navigation.switch_project": "திட்டத்தை மாற்று",
    "Switch Project": "திட்டத்தை மாற்று",
    "navigation.tenant_switch_failed": "குடியிருப்பாளரை மாற்ற தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    "Tenant switch failed. Please try again.": "குடியிருப்பாளரை மாற்ற தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    "navigation.select_project": "திட்டத்தைத் தேர்வு செய்யவும்",
    "Select Project": "திட்டத்தைத் தேர்வு செய்யவும்",
    "navigation.collapse_sidebar": "தொடர்பு அட்டையை குறைக்கவும்",
    "Collapse sidebar": "தொடர்பு அட்டையை குறைக்கவும்",
    "navigation.expand_sidebar": "தொடர்பு அட்டையை விரிவாக்கவும்",
    "Expand sidebar": "தொடர்பு அட்டையை விரிவாக்கவும்",
    "navigation.search": "தேடு",
    "navigation.loading": "நேவிகேஷன் பதிவிறக்கும்",
    "Loading navigation": "நேவிகேஷன் பதிவிறக்கும்",
    "navigation.help_documentation": "ஆவணம்",
    "navigation.help_community": "குழுமம்",
    "navigation.help_api_reference": "API வழிகாட்டி",
    "listings.quick_form": "விரைவான படிவம்",
    "Quick Form": "விரைவான படிவம்",
    "payments.notification_secret": "அறிவிப்பு ரகசியம்",
    "Notification Secret": "அறிவிப்பு ரகசியம்",
    "payments.user_type": "பயனர் வகை",
    "User Type": "பயனர் வகை",
    "payments.category_id": "கத்திரிகை ஐடி",
    "app_customization.other_settings": "மற்ற அமைப்புகள்",
    "Other Settings": "மற்ற அமைப்புகள்",
    "app_customization.other_hide_balances": "மேலும் பிரிவில் போட்டிகளையும் பேய்ப்புகளையும் மறைக்கவும்",
    "app_customization.other_enable_logs": "பதிவுகளை இயக்கவும்",
    "Enable logs": "பதிவுகளை இயக்கவும்",
    "app_customization.other_signup_first": "முதலில் பதிவு செய்யவும்",
    "common.beta": "(பீட்டா)",
    "(beta)": "(பீட்டா)",
    "common.selected_image": "தேர்ந்தெடுக்கப்பட்ட படம்",
    "Selected image": "தேர்ந்தெடுக்கப்பட்ட படம்",
    "common.ai_no_response_to_copy": "காப்பி செய்ய பதில் இல்லை",
    "No response to copy": "காப்பி செய்ய பதில் இல்லை",
    "common.copied_to_clipboard": "கிளிப்போர்டில் நகலெடுக்கப்பட்டது",
    "Copied to clipboard": "கிளிப்போர்டில் நகலெடுக்கப்பட்டது",
    "common.ai_suggestions": "பரிந்துரைகள்",
    "Suggestions": "பரிந்துரைகள்",
    "common.regenerate": "மீண்டும் உருவாக்கு",
    "Regenerate": "மீண்டும் உருவாக்கு",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "JSON ஐகான்",
    "JSON icon": "JSON ஐகான்",
    "collections.generator_title": "கொள்ளும் தொகுப்பு உருவாக்கி",
    "Collection Generator": "கொள்ளும் தொகுப்பு உருவாக்கி",
    "collections.generator_create": "கொலெக்ஷனை உருவாக்கு",
    "collections.generator_json_placeholder": "JSON உள்ளீட்டை உள்ளிடவும்",
    "Enter JSON input": "JSON உள்ளீட்டை உள்ளிடவும்",
    "collections.generator_invalid_data": "செல்லுபடியாகும் தரவுகளை உள்ளிடவும்",
    "Please enter valid data": "செல்லுபடியாகும் தரவுகளை உள்ளிடவும்",
    "category.editor_select_from_media": "ஊடகங்களிலிருந்து தேர்வு செய்யவும்",
    "payments.subscription": "சப்ஸ்கிரிப்ஷன்",
    "payments.subscription_setting_up": "அமைப்பு செய்து கொண்டிருக்கிறோம்...",
    "Setting up...": "அமைப்பு செய்து கொண்டிருக்கிறோம்...",
    "payments.subscription_webhook_configured": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக் அமைக்கப்பட்டுள்ளது",
    "Subscription webhook configured": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக் அமைக்கப்பட்டுள்ளது",
    "payments.subscription_retry_setup": "மீண்டும் அமைப்பை முயற்சிக்கவும்",
    "Retry setup": "மீண்டும் அமைப்பை முயற்சிக்கவும்",
    "payments.setup_subscription_webhook": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக்கை அமைக்கவும்",
    "Setup Subscription Webhook": "சப்ஸ்கிரிப்ஷன் வெப்ஹுக்கை அமைக்கவும்",
    "orders.shipment_number": "அனுப்புதல் {number}",
    "Shipment {number}": "அனுப்புதல் {number}",
    "orders.quantity_short": "அளவு",
    "orders.shipment_status_1": "அனுப்புதல் உருவாக்கப்பட்டது",
    "orders.shipment_status_2": "அனுப்புதல் நடைபெற்று வருகிறது",
    "orders.shipment_status_3": "அனுப்பப்பட்டது",
    "orders.shipment_status_4": "எடுக்க தயார்",
    "orders.shipment_status_5": "அனுப்புதல் வழியில்",
    "orders.shipment_status_6": "அனுப்பப்படாத திரும்பப் பெறுதல்",
    "orders.shipment_status_7": "அனுப்புதல் வழங்கப்பட்டது",
    "orders.shipment_status_8": "வழங்கல் உறுதிப்படுத்தப்பட்டது",
    "orders.shipment_status_9": "திரும்பப் பெறுதல் தொடங்கப்பட்டது",
    "orders.shipment_status_10": "எடுக்க திரும்பப் பெறுதல்",
    "orders.shipment_status_11": "திரும்பப் பெறுதல் உறுதிப்படுத்தப்பட்டது",
    "orders.shipment_status_12": "விற்பனையாளரால் ரத்து செய்யப்பட்டது",
    "orders.shipment_status_13": "வாடிக்கையாளரால் ரத்து செய்யப்பட்டது",
    "orders.shipment_status_14": "வாடிக்கையாளர் இடத்தில் கையேற்றப்பட்டது",
    "orders.shipment_status_15": "நிர்வாகி கைவிட்டது",
    "attributes.metadata_title": "மெட்டாடேட்டாக்கள்",
    "Metadata": "மெட்டாடேட்டாக்கள்",
    "common.add_row": "வரிசையை சேர்க்கவும்",
    "common.no_access": "உங்களிடம் அணுகல் இல்லை",
    "You don't have access": "உங்களிடம் அணுகல் இல்லை",
    "common.error_404_message": "தயவுசெய்து நாங்கள் வருந்துகிறோம், நீங்கள் தேடும் பக்கம் தற்போது கிடைக்கவில்லை. கோப்பு முகவரியை சரிபார்த்து மீண்டும் முயற்சிக்கவும், அல்லது பின்னர் மீண்டும் வரவும். இந்த பிரச்சனையை தொடர்ந்து எதிர்கொள்ளும் பட்சத்தில், உதவிக்காக எங்கள் ஆதரவு குழுவை தொடர்புகொள்ளவும். உங்கள் புரிதலுக்கு நன்றி.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "தயவுசெய்து நாங்கள் வருந்துகிறோம், நீங்கள் தேடும் பக்கம் தற்போது கிடைக்கவில்லை. கோப்பு முகவரியை சரிபார்த்து மீண்டும் முயற்சிக்கவும், அல்லது பின்னர் மீண்டும் வரவும். இந்த பிரச்சனையை தொடர்ந்து எதிர்கொள்ளும் பட்சத்தில், உதவிக்காக எங்கள் ஆதரவு குழுவை தொடர்புகொள்ளவும். உங்கள் புரிதலுக்கு நன்றி.",
    "accounts.smart_upload_beta_label": "(பீட்டா)",
    "orders.transaction_direction": "மாற்று திசை",
    "Transaction direction": "மாற்று திசை",
    "category.default_text": "இயல்புநிலை உரை",
    "collections.generator_open": "கூட்டு உருவாக்கியைத் திறக்கவும்",
    "Open collection generator": "கூட்டு உருவாக்கியைத் திறக்கவும்",
    "collections.duplicate_success": "கூட்டு மறுபகர்ப்பு வெற்றிகரமாக முடிந்தது",
    "Collection duplicated successfully": "கூட்டு மறுபகர்ப்பு வெற்றிகரமாக முடிந்தது",
    "collections.duplicate_failed": "கூட்டு மறுபகர்ப்பு தோல்வி",
    "Failed to duplicate collection": "கூட்டு மறுபகர்ப்பு தோல்வி",
    "listings.name_required": "பட்டியல் பெயர் தேவை",
    "Listing Name is required": "பட்டியல் பெயர் தேவை",
    "listings.category_required": "பிரிவு தேவை",
    "Category is required": "பிரிவு தேவை",
    "attribute_groups.edit_title": "பண்பு குழுவை தொகுத்து மாற்று",
    "Edit Attribute Group": "பண்பு குழுவை தொகுத்து மாற்று",
    "orders.create_order.validation.select_shipping_method": "அனுப்பும் முறையைத் தேர்வு செய்க",
    "Please select shipping method": "அனுப்பும் முறையைத் தேர்வு செய்க",
    "orders.create_order.validation.shipping_method_error": "அனுப்பும் முறை பிழை",
    "Shipping Method Error": "அனுப்பும் முறை பிழை",
    "orders.create_order.validation.select_shipping_address": "அனுப்பும் முகவரியைத் தேர்வு செய்க",
    "Please select shipping address": "அனுப்பும் முகவரியைத் தேர்வு செய்க",
    "orders.create_order.validation.shipping_address_error": "அனுப்பும் முகவரி பிழை",
    "Shipping Address Error": "அனுப்பும் முகவரி பிழை",
    "orders.create_order.validation.select_shipment_method": "அனுப்பும் முறையைத் தேர்வு செய்க",
    "Please select shipment method": "அனுப்பும் முறையைத் தேர்வு செய்க",
    "orders.create_order.validation.shipment_method_error": "அனுப்பும் முறை பிழை",
    "Shipment Method Error": "அனுப்பும் முறை பிழை",
    "orders.create_order.validation.select_payment_method": "செலுத்தும் முறையைத் தேர்வு செய்க",
    "Please select payment method": "செலுத்தும் முறையைத் தேர்வு செய்க",
    "orders.create_order.validation.payment_method_error": "செலுத்தும் முறை பிழை",
    "Payment Method Error": "செலுத்தும் முறை பிழை",
    "orders.create_order.validation.insufficient_balance": "போதுமான பணம் இல்லை",
    "Insufficient balance": "போதுமான பணம் இல்லை",
    "orders.create_order.validation.wallet_error": "வாலெட் பிழை",
    "Wallet Error": "வாலெட் பிழை",
    "attributes.value.preview_item": "{count} முன்னோட்டம்",
    "Preview {count}": "{count} முன்னோட்டம்",
    "attributes.value.click_to_upload": "{type} ஐ பதிவேற்ற கிளிக் செய்யவும்",
    "Click to upload {type}": "{type} ஐ பதிவேற்ற கிளிக் செய்யவும்",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF அதிகபட்சம் 5 கோப்புகள்",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF அதிகபட்சம் 5 கோப்புகள்",
    "attributes.value.audio_upload_formats": "MP3, WAV அதிகபட்சம் 1 கோப்பு",
    "MP3, WAV up to 1 file": "MP3, WAV அதிகபட்சம் 1 கோப்பு",
    "attributes.value.video_upload_formats": "MP4, MOV அதிகபட்சம் 1 கோப்பு",
    "MP4, MOV up to 1 file": "MP4, MOV அதிகபட்சம் 1 கோப்பு",
    "attributes.value.upload_limit": "{type} கோப்புகளை பதிவேற்றவும் (அதிகபட்சம் {count})",
    "Upload {type} files (Max {count})": "{type} கோப்புகளை பதிவேற்றவும் (அதிகபட்சம் {count})",
    "attributes.value.json_format_failed": "செல்லுபடியாகாத JSON - வடிவமைக்க முடியாது",
    "Invalid JSON - cannot format": "செல்லுபடியாகாத JSON - வடிவமைக்க முடியாது",
    "attributes.value.json_file_invalid": "செல்லுபடியான JSON கோப்பை தேர்வு செய்யவும்",
    "Please select a valid JSON file": "செல்லுபடியான JSON கோப்பை தேர்வு செய்யவும்",
    "attributes.value.file_empty": "கோப்பு வெற்று",
    "File is empty": "கோப்பு வெற்று",
    "attributes.value.json_file_parse_failed": "செல்லுபடியாத JSON கோப்பு: {message}",
    "Invalid JSON file: {message}": "செல்லுபடியாத JSON கோப்பு: {message}",
    "attributes.value.file_read_failed": "கோப்பை படிக்க முடியவில்லை",
    "Failed to read file": "கோப்பை படிக்க முடியவில்லை",
    "attributes.value.invalid_json": "செல்லுபடியாத JSON",
    "Invalid JSON": "செல்லுபடியாத JSON",
    "attributes.value.json_editor_help": "JSON கோப்பை பதிவேற்றவும் அல்லது JSON ஐ உருவாக்கி/நகலெடுத்து பேஸ்ட் செய்யவும்",
    "Upload a JSON file or type/paste JSON directly": "JSON கோப்பை பதிவேற்றவும் அல்லது JSON ஐ உருவாக்கி/நகலெடுத்து பேஸ்ட் செய்யவும்",
    "attributes.value.hex_color_code": "ஹெக்ஸ் நிற குறியீடு",
    "Hex Color Code": "ஹெக்ஸ் நிற குறியீடு",
    "attributes.value.multi_text_placeholder": "Enter அல்லது கம்மாவை அழுத்தி சேர்க்கவும்",
    "Type and press Enter or comma to add": "Enter அல்லது கம்மாவை அழுத்தி சேர்க்கவும்",
    "attributes.value.multi_text_help": "ஒவ்வொரு பொருளையும் சேர்க்க இருக்கும் Enter அல்லது கம்மாவை அழுத்தவும்",
    "Press Enter or comma to add each item": "ஒவ்வொரு பொருளையும் சேர்க்க இருக்கும் Enter அல்லது கம்மாவை அழுத்தவும்",
    "attributes.value.item_count": "{count} பொருள்",
    "{count} item": "{count} பொருள்",
    "attributes.value.items_count": "{count} பொருட்கள்",
    "attributes.value.search_options": "{name} தேடு...",
    "Search {name}...": "{name} தேடு...",
    "attributes.value.selected_count": "{count} தேர்வு செய்யப்பட்டவை",
    "attributes.value.no_options_found": "விருப்பங்கள் கிடைக்கவில்லை",
    "No options found": "விருப்பங்கள் கிடைக்கவில்லை",
    "attributes.value.select_named_option": "{name} ஐத் தேர்வு செய்யவும்",
    "Select {name}": "{name} ஐத் தேர்வு செய்யவும்",
    "attributes.value.enable_option": "இந்த விருப்பத்தை செயல்படுத்தவும்",
    "Enable this option": "இந்த விருப்பத்தை செயல்படுத்தவும்",
    "attributes.value.enter_named_value": "உள்ளிடவும் {name}",
    "Enter {name}": "உள்ளிடவும் {name}",
    "common.valid": "சரியானது",
    "Valid": "சரியானது",
    "common.invalid": "தவறானது",
    "Invalid": "தவறானது",
    "common.go_back_home": "முகப்புக்கு திரும்பு",
    "Go back home": "முகப்புக்கு திரும்பு",
    "attributes.value.enter_named_text": "உள்ளிடவும் {name}...",
    "Enter {name}...": "உள்ளிடவும் {name}...",
    "listings.analytics.page_views": "பக்க பார்வைகள்",
    "listings.analytics.unique_visitors": "ஒற்றை பார்வையாளர்கள்",
    "listings.analytics.sessions": "அமர்வுகள்",
    "listings.analytics.clicks": "கிளிக்குகள்",
    "listings.analytics.goals": "இலக்குகள்",
    "listings.analytics.bot_views": "போட் பார்வைகள்",
    "listings.detail_summary.buyers": "வாங்குபவர்கள்",
    "Buyers": "வாங்குபவர்கள்",
    "listings.detail_summary.orders": "ஆர்டர்கள்",
    "listings.detail_summary.revenue": "மூலம்",
    "listings.detail_summary.average_order": "ஆர்டர் சராசரி",
    "listings.add_advanced": "மேம்பட்ட",
    "listings.add_audio": "ஆடியோ சேர்க்க",
    "Add Audio": "ஆடியோ சேர்க்க",
    "payments.updated_successfully": "வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "Updated successfully": "வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "users.deleted_successfully": "பயனர் வெற்றிகரமாக நீக்கப்பட்டது",
    "User deleted successfully": "பயனர் வெற்றிகரமாக நீக்கப்பட்டது",
    "users.deletion_failed": "பயனரை நீக்க தோல்வி",
    "User deletion failed": "பயனரை நீக்க தோல்வி",
    "accounts.flow.title": "கணக்கு அனுபவத்தை அமைக்கவும்",
    "Shape the account experience": "கணக்கு அனுபவத்தை அமைக்கவும்",
    "accounts.flow.description": "கணக்கு வகைகளை அமைத்து, ஒவ்வொரு கணக்கும் தேவையான தகவல்களை வரையறுக்கவும்.",
    "Organize account types and define the information each account needs.": "கணக்கு வகைகளை அமைத்து, ஒவ்வொரு கணக்கும் தேவையான தகவல்களை வரையறுக்கவும்.",
    "accounts.flow.lane_title": "கணக்கு அடிப்படை",
    "Account foundation": "கணக்கு அடிப்படை",
    "accounts.flow.badge": "அமைப்பு",
    "Structure": "அமைப்பு",
    "accounts.flow.node_accounts": "கணக்குகள்",
    "accounts.flow.node_categories": "வகைகள்",
    "accounts.flow.node_attributes": "பண்புகள்",
    "accounts.flow.lane_description": "ஒவ்வொரு கணக்குக்கும் தெளிவான இடம், வகை மற்றும் பயனுள்ள விவரங்களை அமைக்கவும்.",
    "Give every account a clear place, type, and set of useful details.": "ஒவ்வொரு கணக்குக்கும் தெளிவான இடம், வகை மற்றும் பயனுள்ள விவரங்களை அமைக்கவும்.",
    "accounts.flow.primary_action": "முதல் கணக்கை சேர்க்கவும்",
    "Add your first account": "முதல் கணக்கை சேர்க்கவும்",
    "listings.flow.title": "உள்ளீடுகள் கதாலாகோவை உருவாக்கு",
    "Build your listing catalog": "உள்ளீடுகள் கதாலாகோவை உருவாக்கு",
    "listings.flow.description": "வகைகள், பண்புகள் மற்றும் பிரதிகளுடன் அமைக்கப்பட்ட கதாலாகோவை உருவாக்கவும்.",
    "Create a structured catalog with categories, attributes, and variants.": "வகைகள், பண்புகள் மற்றும் பிரதிகளுடன் அமைக்கப்பட்ட கதாலாகோவை உருவாக்கவும்.",
    "listings.flow.lane_title": "கதாலாகோ பாதை",
    "Catalog path": "கதாலாகோ பாதை",
    "listings.flow.badge": "கட்டுமானம்",
    "Build": "கட்டுமானம்",
    "listings.flow.node_listings": "உள்ளீடுகள்",
    "listings.flow.node_categories": "வகைகள்",
    "listings.flow.node_attributes": "பண்புகள்",
    "listings.flow.node_variants": "பிரதிகள்",
    "listings.flow.lane_description": "நீங்கள் விற்கும் பொருட்களையும், வாடிக்கையாளர்கள் தேர்வு செய்ய தேவையான தகவல்களையும் வரையறுக்கவும்.",
    "Define what you sell and the information customers need to make a choice.": "நீங்கள் விற்கும் பொருட்களையும், வாடிக்கையாளர்கள் தேர்வு செய்ய தேவையான தகவல்களையும் வரையறுக்கவும்.",
    "listings.flow.primary_action": "முதல் உள்ளீட்டை சேர்க்கவும்",
    "Add your first listing": "முதல் உள்ளீட்டை சேர்க்கவும்",
    "collections.flow.title": "உங்கள் சந்தை உள்ளடக்கத்தை ஒன்றிணைக்கவும்",
    "Bring your marketplace content together": "உங்கள் சந்தை உள்ளடக்கத்தை ஒன்றிணைக்கவும்",
    "collections.flow.description": "உள்ளீடுகள் மற்றும் கணக்குகளை எளிதில் கண்டறியக்கூடிய மற்றும் மேலாண்மை செய்யக்கூடிய தேர்ந்தெடுக்கப்பட்ட கூட்டங்களில் குழுப்படுத்தவும்.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "உள்ளீடுகள் மற்றும் கணக்குகளை எளிதில் கண்டறியக்கூடிய மற்றும் மேலாண்மை செய்யக்கூடிய தேர்ந்தெடுக்கப்பட்ட கூட்டங்களில் குழுப்படுத்தவும்.",
    "collections.flow.lane_title": "கூட்டம் பாதை",
    "Collection path": "கூட்டம் பாதை",
    "collections.flow.badge": "தேர்ந்தெடுக்க",
    "Curate": "தேர்ந்தெடுக்க",
    "collections.flow.node_collections": "கூட்டங்கள்",
    "collections.flow.node_rules": "விதிகள்",
    "collections.flow.node_listings": "உள்ளீடுகள்",
    "collections.flow.lane_description": "ஒன்றாக வேண்டியவற்றைத் தேர்ந்தெடுத்து, வாடிக்கையாளர்களுக்கு எளிதாகக் கண்டுபிடிக்க வைக்கவும்.",
    "Choose what belongs together and make it easy for customers to find.": "ஒன்றாக வேண்டியவற்றைத் தேர்ந்தெடுத்து, வாடிக்கையாளர்களுக்கு எளிதாகக் கண்டுபிடிக்க வைக்கவும்.",
    "collections.flow.audience_lane_title": "கேட்டவர் பாதை",
    "Audience path": "கேட்டவர் பாதை",
    "collections.flow.audience_badge": "இணைக்கவும்",
    "collections.flow.node_accounts": "கணக்குகள்",
    "collections.flow.node_users": "பயனர்கள்",
    "collections.flow.node_storefront": "கடை",
    "Storefront": "கடை",
    "collections.flow.audience_description": "மேற்கோளிடப்பட்ட உள்ளடக்கத்தை அது பயன்படுத்தப்பட வேண்டியவர்கள் மற்றும் கடைகளுக்கு இணைக்கவும்.",
    "Connect curated content to the people and storefronts it is meant for.": "மேற்கோளிடப்பட்ட உள்ளடக்கத்தை அது பயன்படுத்தப்பட வேண்டியவர்கள் மற்றும் கடைகளுக்கு இணைக்கவும்.",
    "collections.flow.primary_action": "உங்கள் முதல் தொகுப்பை உருவாக்கவும்",
    "listings.addon.image_limit": "மேலும் படங்களைத் தேர்வு செய்ய முடியாது",
    "listings.schedule.start_time_before_end": "தொடக்க நேரம் முடிவு நேரத்திற்கு முன்பாக இருக்க வேண்டும்",
    "Start time must be before the end time": "தொடக்க நேரம் முடிவு நேரத்திற்கு முன்பாக இருக்க வேண்டும்",
    "listings.schedule.end_time_after_start": "முடிவு நேரம் தொடக்க நேரத்திற்குப் பிறகு இருக்க வேண்டும்",
    "End time must be after the start time": "முடிவு நேரம் தொடக்க நேரத்திற்குப் பிறகு இருக்க வேண்டும்",
    "listings.schedule.repeat_required": "மீண்டும் தொடர்பு அமைப்பைத் தேர்வு செய்யவும்",
    "Select a repeat pattern": "மீண்டும் தொடர்பு அமைப்பைத் தேர்வு செய்யவும்",
    "listing_variants.form.select_type": "வேரியண்ட் வகையைத் தேர்வு செய்யவும்",
    "Select variant type": "வேரியண்ட் வகையைத் தேர்வு செய்யவும்",
    "listing_variants.form.select_type_values": "வேரியண்ட் மதிப்புகளைத் தேர்வு செய்யவும்",
    "Select variant values": "வேரியண்ட் மதிப்புகளைத் தேர்வு செய்யவும்",
    "listing_variants.form.add_variant": "விரிவான சேர்க்க",
    "listing_variants.form.edit_variant": "விரிவானதை தொகுத்தல்",
    "Edit variant": "விரிவானதை தொகுத்தல்",
    "listing_variants.form.variant_type": "விரிவான வகை",
    "Variant type": "விரிவான வகை",
    "listing_variants.form.variant_type_value": "விரிவான மதிப்பு",
    "Variant value": "விரிவான மதிப்பு",
    "listing_variants.form.variant_name": "விரிவான பெயர்",
    "Variant name": "விரிவான பெயர்",
    "listing_variants.form.description_placeholder": "விவரத்தை உள்ளிடவும்",
    "rewards.item_archived": "கோப்புகள் சேமிக்கப்பட்டது",
    "listings.confirm_delete_variant": "இந்த விரிவானதை நீக்க விரும்புகிறீர்களா?",
    "listings.confirm_delete_listing": "இந்த பட்டியலை நீக்க விரும்புகிறீர்களா?",
    "listing_form.digital_delete_confirm": "இந்த டிஜிட்டல் உள்ளடக்கத்தை நீக்க விரும்புகிறீர்களா?",
    "Are you sure you want to delete this digital content?": "இந்த டிஜிட்டல் உள்ளடக்கத்தை நீக்க விரும்புகிறீர்களா?",
    "category.confirm_delete_attribute": "இந்த அம்சத்தை நீக்க விரும்புகிறீர்களா?",
    "common.permission_required": "இந்த செயலை மேற்கொள்ள உங்களுக்கு அனுமதி இல்லை.",
    "You do not have permission to perform this action.": "இந்த செயலை மேற்கொள்ள உங்களுக்கு அனுமதி இல்லை.",
    "common.copied": "நகலெடுக்கப்பட்டது",
    "attributes.editor_name_required": "அம்சத்தின் பெயரை உள்ளிடவும்",
    "onboarding.full_step.setup_payments.description": "பயனர்கள் பிரச்சனையின்றி தீர்வு காண உண்மையான பரிமாற்றங்களை செயல்படுத்தவும்.",
    "Enable real transactions so users can complete intent without friction.": "பயனர்கள் பிரச்சனையின்றி தீர்வு காண உண்மையான பரிமாற்றங்களை செயல்படுத்தவும்.",
    "onboarding.full_step.setup_payments.cta": "பேமென்ட்ஸை அமைக்கவும்",
    "Setup payments": "பேமென்ட்ஸை அமைக்கவும்",
    "onboarding.full_step.setup_payments.impact": "வருமான பாதை செயல்பாட்டில் உள்ளது.",
    "Revenue path enabled.": "வருமான பாதை செயல்பாட்டில் உள்ளது.",
    "onboarding.full_step.setup_payments.creator_description": "உங்கள் பயனர்கள் உங்கள் பணியை வாங்க அல்லது ஆதரிக்க வழியை தயாரிக்கவும்.",
    "Prepare the path for your audience to purchase or support your work.": "உங்கள் பயனர்கள் உங்கள் பணியை வாங்க அல்லது ஆதரிக்க வழியை தயாரிக்கவும்.",
    "onboarding.full_step.setup_delivery.description": "வாடிக்கையாளர்களுக்கு சரியான விலையில் ஆர்டர் நிறைவேற்றப்படும் வழியை வரையறுக்கவும்.",
    "onboarding.full_step.setup_delivery.impact": "நிறைவேற்றும் பாதை தெளிவாக உள்ளது.",
    "Fulfillment path clear.": "நிறைவேற்றும் பாதை தெளிவாக உள்ளது.",
    "onboarding.full_step.add_promotion.description": "முதல் முறை பயனர் செயல்பாட்டை அதிகரிக்க உங்கள் முதல் பிரமோஷனை உருவாக்கவும்.",
    "Create your first promotion to increase first-session action rate.": "முதல் முறை பயனர் செயல்பாட்டை அதிகரிக்க உங்கள் முதல் பிரமோஷனை உருவாக்கவும்.",
    "onboarding.full_step.add_promotion.impact": "லான்ச் சமயத்தில் மேம்பட்ட மாற்றம்.",
    "Stronger conversion during launch.": "லான்ச் சமயத்தில் மேம்பட்ட மாற்றம்.",
    "onboarding.full_step.create_coupon.description": "முதல் முறை வாங்குபவர்கள் அல்லது உறுப்பினர்களுக்கு தள்ளுபோக்குகளை சோதித்து செயல்பாட்டை மேம்படுத்தவும்.",
    "Test discounts and improve activation for first-time buyers or members.": "முதல் முறை வாங்குபவர்கள் அல்லது உறுப்பினர்களுக்கு தள்ளுபோக்குகளை சோதித்து செயல்பாட்டை மேம்படுத்தவும்.",
    "onboarding.full_step.create_coupon.impact": "முதல் அறிவிப்பு வழி திறக்கப்பட்டது.",
    "First-offer loop unlocked.": "முதல் அறிவிப்பு வழி திறக்கப்பட்டது.",
    "onboarding.full_step.collections_setup.description": "முன்னேற்றம் மற்றும் தேடல் பாதையை மேம்படுத்த உயர் ஆர்வம் கொண்ட பட்டியல்களை அமைக்கவும்.",
    "Organize high-intent listings to improve discovery and browsing flow.": "முன்னேற்றம் மற்றும் தேடல் பாதையை மேம்படுத்த உயர் ஆர்வம் கொண்ட பட்டியல்களை அமைக்கவும்.",
    "onboarding.full_step.collections_setup.impact": "தேடல் மற்றும் நேவிகேஷன் மேம்பட்டது.",
    "Navigation and discovery improved.": "தேடல் மற்றும் நேவிகேஷன் மேம்பட்டது.",
    "onboarding.full_step.configure_comms.description": "வளர்ச்சிக்கு முன் பதிவு செய்த பிறகு மற்றும் ஆர்டர் அறிவிப்புகளை உற்பத்தி தயாராக வைக்கவும்.",
    "Make post-signup and order notifications production-ready before growth.": "வளர்ச்சிக்கு முன் பதிவு செய்த பிறகு மற்றும் ஆர்டர் அறிவிப்புகளை உற்பத்தி தயாராக வைக்கவும்.",
    "onboarding.full_step.configure_comms.impact": "வாழ்க்கை சுற்று செய்திகள் தயார்.",
    "Lifecycle messaging ready.": "வாழ்க்கை சுற்று செய்திகள் தயார்.",
    "onboarding.full_step.customize_attributes.description": "பயனர்கள் முக்கியமானவற்றை தேர்வு செய்து ஒப்பிட முடியும் வகையில் அமைக்கப்பட்ட புலங்களை சேர்க்கவும்.",
    "onboarding.full_step.customize_attributes.impact": "தேடல் மற்றும் மாற்றம் மேம்பட்டது.",
    "Better search and conversion.": "தேடல் மற்றும் மாற்றம் மேம்பட்டது.",
    "onboarding.full_step.customize_attributes.creator_description": "உங்கள் உருவாக்கத்தை புரிந்து கொள்ளவும் ஒப்பிடவும் உதவும் விவரங்களைச் சேர்க்கவும்.",
    "Add the details that help people understand and compare what you create.": "உங்கள் உருவாக்கத்தை புரிந்து கொள்ளவும் ஒப்பிடவும் உதவும் விவரங்களைச் சேர்க்கவும்.",
    "onboarding.full_step.add_digital_asset.description": "பயனர்கள் தரம் மற்றும் தேர்வை மதிப்பீடு செய்ய முதல் கத்தாலாக்கை விரிவாக்கவும்.",
    "Expand initial catalog so users can evaluate quality and assortment.": "பயனர்கள் தரம் மற்றும் தேர்வை மதிப்பீடு செய்ய முதல் கத்தாலாக்கை விரிவாக்கவும்.",
    "onboarding.full_step.add_digital_asset.impact": "டிஜிட்டல் கத்தாலாக்கின் நம்பகத்தன்மை மேம்பட்டது.",
    "Digital catalog credibility improved.": "டிஜிட்டல் கத்தாலாக்கின் நம்பகத்தன்மை மேம்பட்டது.",
    "onboarding.full_step.open_live_site.description": "வாடிக்கையாளர்கள் பார்க்கும் விஷயத்திலிருந்து தொடங்கவும். இது அமைப்பு கற்பனையாக மாறும் முன் தயாராக உள்ள தோற்றத்தை உருவாக்குகிறது.",
    "onboarding.full_step.open_live_site.impact": "திட்டம் ஏற்கனவே ஆன்லைனில் உள்ளது என்பதை உறுதிப்படுத்துகிறது.",
    "onboarding.full_step.add_first_product.description": "உங்கள் பயனர்கள் கண்டுபிடிக்க விரும்பும் முதல் தயாரிப்பு, சேவை அல்லது வளத்தை வெளியிடவும்.",
    "Publish the first product, service, or resource you want your audience to discover.": "உங்கள் பயனர்கள் கண்டுபிடிக்க விரும்பும் முதல் தயாரிப்பு, சேவை அல்லது வளத்தை வெளியிடவும்.",
    "onboarding.full_step.add_first_product.impact": "உங்கள் முதல் கேட்டுக்கொள்ளப்பட்ட அறிவிப்பை உருவாக்குகிறது.",
    "Creates your first audience-ready offer.": "உங்கள் முதல் கேட்டுக்கொள்ளப்பட்ட அறிவிப்பை உருவாக்குகிறது.",
    "onboarding.full_step.customize_attributes.creator_impact": "உங்கள் அறிவிப்பை எளிதாக புரிந்துகொள்ள செய்கிறது.",
    "Makes your offer easier to understand.": "உங்கள் அறிவிப்பை எளிதாக புரிந்துகொள்ள செய்கிறது.",
    "onboarding.full_step.setup_payments.creator_impact": "வருமானத்திற்கு வழியைத் திறக்கிறது.",
    "listings.detail_preview_fx.title": "FX முன்னோட்டம்",
    "Preview FX": "FX முன்னோட்டம்",
    "listings.detail_preview_fx.base": "அடிப்படை",
    "Base": "அடிப்படை",
    "listings.detail_preview_fx.description": "இதே பட்டியலை செயல்பாட்டிலுள்ள அனைத்து நாணயங்களிலும் பார்க்கவும்.",
    "See this listing in each active currency.": "இதே பட்டியலை செயல்பாட்டிலுள்ள அனைத்து நாணயங்களிலும் பார்க்கவும்.",
    "listings.detail_preview_fx.refresh": "முன்னோட்டத்தை புதுப்பிக்கவும்",
    "Refresh preview": "முன்னோட்டத்தை புதுப்பிக்கவும்",
    "listings.detail_preview_fx.loading_rates": "மாற்று விகிதங்களை ஏற்றுகிறது…",
    "Loading exchange rates…": "மாற்று விகிதங்களை ஏற்றுகிறது…",
    "listings.detail_preview_fx.load_hint": "தற்போதைய விகிதங்களை ஏற்ற, FX முன்னோட்டத்தைத் தேர்வு செய்யவும்.",
    "Select Preview FX to load current rates.": "தற்போதைய விகிதங்களை ஏற்ற, FX முன்னோட்டத்தைத் தேர்வு செய்யவும்.",
    "listings.detail_preview_fx.preview_note": "முன்னோட்டம் மட்டுமே. சேமிக்கப்பட்ட பட்டியல் விலைகள் மாற்றமின்றி உள்ளன.",
    "Preview only. Saved listing prices remain unchanged.": "முன்னோட்டம் மட்டுமே. சேமிக்கப்பட்ட பட்டியல் விலைகள் மாற்றமின்றி உள்ளன.",
    "listings.detail_preview_fx.listing": "பட்டியல்",
    "listings.detail_preview_fx.variant": "வேரியண்ட்",
    "Variant": "வேரியண்ட்",
    "listings.detail_event_booking.event_details": "ஈவென்ட் விவரங்கள்",
    "Event Details": "ஈவென்ட் விவரங்கள்",
    "listings.detail_event_booking.booking_details": "புகலிட விவரங்கள்",
    "Booking Details": "புகலிட விவரங்கள்",
    "listings.unassigned_location": "விதிக்கப்படாத இடம்",
    "Unassigned location": "விதிக்கப்படாத இடம்",
    "listings.no_ratings_yet": "இன்னும் மதிப்பீடுகள் இல்லை.",
    "No ratings yet": "இன்னும் மதிப்பீடுகள் இல்லை.",
    "listing_form.loading_listing": "பட்டியலை ஏற்றுகிறது…",
    "Loading listing…": "பட்டியலை ஏற்றுகிறது…",
    "listing_form.preparing_form": "விண்ணப்பத்தை தயாரிக்கிறது…",
    "Preparing form…": "விண்ணப்பத்தை தயாரிக்கிறது…",
    "listing_form.edit_listing": "பட்டியலை தொகுத்துக்கொள்ளவும்",
    "Edit Listing": "பட்டியலை தொகுத்துக்கொள்ளவும்",
    "listing_form.add_new_listing": "புதிய பட்டியலைச் சேர்க்கவும்",
    "Add New Listing": "புதிய பட்டியலைச் சேர்க்கவும்",
    "workspace.catalog.templates": "தானியங்கிகள்",
    "Templates": "தானியங்கிகள்",
    "workspace.catalog.integrations": "ஒன்றிணைப்புகள்",
    "workspace.catalog.template": "தானியங்கி",
    "Template": "தானியங்கி",
    "workspace.catalog.integration": "ஒன்றிணைப்பு",
    "workspace.catalog.templates_heading": "உங்கள் ஐடியாவை தொடங்க ஒரு மாதிரி தேர்வு செய்யவும்",
    "Choose a template to kickstart your Idea": "உங்கள் ஐடியாவை தொடங்க ஒரு மாதிரி தேர்வு செய்யவும்",
    "workspace.catalog.integrations_heading": "கொடுக்கப்பட்ட வலைப்பக்க பயன்பாடுகளுக்கான ஒத்துழைப்புகள்",
    "Integrations for Hosted Web Apps": "கொடுக்கப்பட்ட வலைப்பக்க பயன்பாடுகளுக்கான ஒத்துழைப்புகள்",
    "workspace.catalog.templates_description": "உங்கள் சந்தைக்கான தனிப்பயனாக்கத்திற்கு முன்னதாக தயாரிக்கப்பட்ட மாதிரியை தொடங்கி பயன்படுத்தவும்.",
    "Start with a prebuilt template and customise it for your marketplace.": "உங்கள் சந்தைக்கான தனிப்பயனாக்கத்திற்கு முன்னதாக தயாரிக்கப்பட்ட மாதிரியை தொடங்கி பயன்படுத்தவும்.",
    "workspace.catalog.integrations_description": "உங்கள் பயன்பாட்டை ஏற்கனவே பயன்படுத்தும் கருவிகள் மற்றும் சேவைகளுடன் இணைக்கவும்.",
    "Connect your workspace to the tools and services you already use.": "உங்கள் பயன்பாட்டை ஏற்கனவே பயன்படுத்தும் கருவிகள் மற்றும் சேவைகளுடன் இணைக்கவும்.",
    "workspace.catalog.no_templates": "இந்த நேரத்தில் எந்த மாதிரிகளும் கிடைக்கவில்லை.",
    "No templates available at the moment.": "இந்த நேரத்தில் எந்த மாதிரிகளும் கிடைக்கவில்லை.",
    "workspace.catalog.no_integrations": "இந்த நேரத்தில் எந்த ஒத்துழைப்புகளும் கிடைக்கவில்லை.",
    "No integrations available at the moment.": "இந்த நேரத்தில் எந்த ஒத்துழைப்புகளும் கிடைக்கவில்லை.",
    "workspace.catalog.coming_soon": "விரைவில்",
    "Coming Soon": "விரைவில்",
    "workspace.catalog.configure": "அமைப்பு",
    "workspace.catalog.custom_development": "{type} க்கான தனிப்பயன் வளர்ச்சி",
    "Custom {type} Development": "{type} க்கான தனிப்பயன் வளர்ச்சி",
    "workspace.catalog.custom_help": "தனிப்பயனாக்கப்பட்ட விஷயம் தேவையா? தொகையைப் பெற நாங்கள் தொடர்புகொள்ளவும்.",
    "Looking for something custom? Contact us for a quote.": "தனிப்பயனாக்கப்பட்ட விஷயம் தேவையா? தொகையைப் பெற நாங்கள் தொடர்புகொள்ளவும்.",
    "workspace.catalog.contact_quote": "தொகையைப் பெற நாங்கள் தொடர்புகொள்ளவும்",
    "Contact for a Quote": "தொகையைப் பெற நாங்கள் தொடர்புகொள்ளவும்",
    "users.select_user": "பயனரைத் தேர்வு செய்யவும்",
    "Select User": "பயனரைத் தேர்வு செய்யவும்",
    "developer.api_keys.paid_feature_title": "API அணுகுமுறை கட்டண பண்பு",
    "API access is a paid feature": "API அணுகுமுறை கட்டண பண்பு",
    "developer.api_keys.paid_feature_description": "உங்கள் பொது மற்றும் ரகசிய குறியீடுகளை பார்க்க, நகலெடுக்க, பயன்படுத்த கட்டண திட்டத்தைத் தேர்வு செய்யவும்.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "உங்கள் பொது மற்றும் ரகசிய குறியீடுகளை பார்க்க, நகலெடுக்க, பயன்படுத்த கட்டண திட்டத்தைத் தேர்வு செய்யவும்.",
    "developer.api_keys.available_on_paid_plans": "கட்டண திட்டங்களில் கிடைக்கிறது",
    "Available on paid plans": "கட்டண திட்டங்களில் கிடைக்கிறது",
    "developer.api_keys.view_plans": "திட்டங்களைப் பார்க்கவும்",
    "currency.rates.title": "தற்போதைய மாற்று விகிதங்கள்",
    "Current FX rates": "தற்போதைய மாற்று விகிதங்கள்",
    "currency.rates.base": "அடிப்படை:",
    "Base:": "அடிப்படை:",
    "currency.rates.source": "· மூலம்:",
    "· Source:": "· மூலம்:",
    "currency.rates.cached_up_to": "{hours}h வரை கேஷ் செய்யப்பட்டுள்ளது",
    "Cached up to {hours}h": "{hours}h வரை கேஷ் செய்யப்பட்டுள்ளது",
    "currency.rates.refresh": "விகிதங்களை புதுப்பிக்கவும்",
    "Refresh rates": "விகிதங்களை புதுப்பிக்கவும்",
    "currency.rates.currency": "நாணயம்",
    "currency.rates.one_base_equals": "{code} ஒன்று சமம்",
    "1 {code} equals": "{code} ஒன்று சமம்",
    "currency.rates.empty": "மாற்று விகிதத்தைப் பார்க்க செயல்பாட்டு நாணயத்தைச் சேர்க்கவும்.",
    "Add an active currency to see its exchange rate.": "மாற்று விகிதத்தைப் பார்க்க செயல்பாட்டு நாணயத்தைச் சேர்க்கவும்.",
    "currency.rates.manual": "மேலாண்மை விகிதங்கள்",
    "currency.rates.load_error": "மாற்று விகிதங்களை ஏற்ற முடியவில்லை.",
    "Unable to load exchange rates.": "மாற்று விகிதங்களை ஏற்ற முடியவில்லை.",
    "chats.title": "வாடிக்கையாளர் உரையாடல்",
    "Customer chat": "வாடிக்கையாளர் உரையாடல்",
    "chats.conversations": "மேற்கோள்கள்",
    "Conversations": "மேற்கோள்கள்",
    "chats.empty_conversations": "வாடிக்கையாளர் உரையாடல்கள் இல்லை.",
    "No customer conversations yet.": "வாடிக்கையாளர் உரையாடல்கள் இல்லை.",
    "chats.customer_id": "வாடிக்கையாளர் {id}",
    "Customer {id}": "வாடிக்கையாளர் {id}",
    "chats.no_messages_yet": "செய்திகள் இல்லை.",
    "No messages yet": "செய்திகள் இல்லை.",
    "chats.conversation_id": "உரையாடல் #{id}",
    "Conversation #{id}": "உரையாடல் #{id}",
    "chats.status.closed": "மூடப்பட்டது",
    "closed": "மூடப்பட்டது",
    "chats.status.open": "திறந்தது",
    "chats.reopen": "மீண்டும் திறக்கவும்",
    "Reopen": "மீண்டும் திறக்கவும்",
    "chats.close_conversation": "உரையாடலை மூடு",
    "Close conversation": "உரையாடலை மூடு",
    "chats.your_team": "உங்கள் அணி",
    "Your team": "உங்கள் அணி",
    "chats.empty_messages": "இந்த உரையாடலில் செய்திகள் இல்லை.",
    "No messages in this conversation yet.": "இந்த உரையாடலில் செய்திகள் இல்லை.",
    "chats.write_reply": "பதில் எழுது",
    "Write a reply": "பதில் எழுது",
    "chats.send": "அனுப்பு",
    "Send": "அனுப்பு",
    "chats.select_conversation": "செய்திகளைப் பார்க்க ஒரு உரையாடலைத் தேர்வு செய்க.",
    "Select a conversation to view its messages.": "செய்திகளைப் பார்க்க ஒரு உரையாடலைத் தேர்வு செய்க.",
    "chats.error.session_not_ready": "உங்கள் அமர்வு தயாராக இல்லை. பக்கத்தை புதுப்பி மீண்டும் முயற்சிக்கவும்.",
    "Your session is not ready. Refresh the page and try again.": "உங்கள் அமர்வு தயாராக இல்லை. பக்கத்தை புதுப்பி மீண்டும் முயற்சிக்கவும்.",
    "chats.error.request_failed": "உரையாடல் கோரிக்கை தோல்வியடைந்தது ({status})",
    "Chat request failed ({status})": "உரையாடல் கோரிக்கை தோல்வியடைந்தது ({status})",
    "chats.error.load_conversations": "உரையாடல்களை ஏற்ற முடியவில்லை.",
    "Could not load conversations.": "உரையாடல்களை ஏற்ற முடியவில்லை.",
    "chats.error.load_messages": "செய்திகளை ஏற்ற முடியவில்லை.",
    "Could not load messages.": "செய்திகளை ஏற்ற முடியவில்லை.",
    "chats.error.send_message": "செய்தி அனுப்ப முடியவில்லை.",
    "Message could not be sent.": "செய்தி அனுப்ப முடியவில்லை.",
    "chats.error.update_status": "உரையாடலின் நிலையை மேம்படுத்த முடியவில்லை.",
    "Conversation status could not be updated.": "உரையாடலின் நிலையை மேம்படுத்த முடியவில்லை.",
    "accounts.select_account": "கணக்கைத் தேர்வு செய்க",
    "common.accounts": "கணக்குகள்",
    "common.listings": "பட்டியல்கள்",
    "communications.loading_preview": "முன்னோட்டம் ஏற்றுகிறது…",
    "Loading preview…": "முன்னோட்டம் ஏற்றுகிறது…",
    "communications.no_preview": "முன்னோட்டம் இல்லை",
    "No preview": "முன்னோட்டம் இல்லை",
    "collections.choose_type": "{type} தேர்வு செய்யவும்",
    "Choose {type}": "{type} தேர்வு செய்யவும்",
    "collections.create_type_category_first": "{type} வகையை முதலில் உருவாக்கவும்",
    "Create {type} category first": "{type} வகையை முதலில் உருவாக்கவும்",
    "web_config.customisation": "வலைப்பக்கம் தனிப்பயனாக்கம்",
    "web_config.configuration": "வலைப்பக்க அமைப்புகள்",
    "Web Configuration": "வலைப்பக்க அமைப்புகள்",
    "web_config.section_general": "பொதுவானது",
    "web_config.section_social": "சமூகம்",
    "web_config.section_footer": "கீழ்க்குறிப்பு",
    "web_config.assets": "பொருட்கள்",
    "Assets": "பொருட்கள்",
    "web_config.small_logo": "சிறிய லோகோ",
    "Small logo": "சிறிய லோகோ",
    "attributes.edit_attribute": "பண்பை தொகுத்தல்",
    "currency.rate_managed_automatically": "விகிதம் தானியங்கி மேலாண்மை செய்யப்படுகிறது.",
    "Rate is managed automatically.": "விகிதம் தானியங்கி மேலாண்மை செய்யப்படுகிறது.",
    "navigation.add_or_manage_mini_apps": "மினி பயன்பாடுகளை சேர்க்கவோ அல்லது மேலாண்மை செய்யவோ",
    "Add or manage Mini Apps": "மினி பயன்பாடுகளை சேர்க்கவோ அல்லது மேலாண்மை செய்யவோ",
    "listings.import.download_type_template": "{type} தாள் பதிவிறக்கம் செய்யவும்",
    "navigation.promo_banner": "{percent}% தள்ளுபோக்கு! முதல் முறை வாடிக்கையாளர்களுக்கு மட்டும். குறியீட்டைப் பயன்படுத்தவும்: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "{percent}% தள்ளுபோக்கு! முதல் முறை வாடிக்கையாளர்களுக்கு மட்டும். குறியீட்டைப் பயன்படுத்தவும்: {code}.",
    "orders.cash_refund_recorded": "பணம் திரும்பப் பெற்றது பதிவு செய்யப்பட்டுள்ளது. கணக்கு மாற்றம் கோரிக்கையாக இருக்கிறது.",
    "Cash refund recorded. The accounting reversal has been queued.": "பணம் திரும்பப் பெற்றது பதிவு செய்யப்பட்டுள்ளது. கணக்கு மாற்றம் கோரிக்கையாக இருக்கிறது.",
    "orders.cash_refund_failed": "பணம் திரும்பப் பெற்றதை பதிவு செய்ய முடியவில்லை. ஆர்டர் பேமென்ட் நிலையையும், திரும்பப் பெற்ற வரலாற்றையும் சரிபார்க்கவும்.",
    "Could not record the cash refund. Check the order payment status and refund history.": "பணம் திரும்பப் பெற்றதை பதிவு செய்ய முடியவில்லை. ஆர்டர் பேமென்ட் நிலையையும், திரும்பப் பெற்ற வரலாற்றையும் சரிபார்க்கவும்.",
    "orders.recording_cash_refund": "திரும்பப் பெற்றதை பதிவு செய்து கொண்டிருக்கிறது…",
    "Recording refund…": "திரும்பப் பெற்றதை பதிவு செய்து கொண்டிருக்கிறது…",
    "orders.record_cash_refund": "பணம் திரும்பப் பெற்றதை பதிவு செய்யவும்",
    "Record cash refund": "பணம் திரும்பப் பெற்றதை பதிவு செய்யவும்",
    "orders.confirm_cash_refund": "பணம் திரும்பப் பெற்றதை உறுதிப்படுத்தவும்",
    "Confirm cash refund": "பணம் திரும்பப் பெற்றதை உறுதிப்படுத்தவும்",
    "orders.cash_refund_order_amount": "{amount} மதிப்பிற்கான முழு பணம் திரும்பப் பெற்றதை {reference} ஆர்டருக்கு பதிவு செய்ய வேண்டுமா?",
    "Record a full cash refund of {amount} for order {reference}?": "{amount} மதிப்பிற்கான முழு பணம் திரும்பப் பெற்றதை {reference} ஆர்டருக்கு பதிவு செய்ய வேண்டுமா?",
    "orders.cash_refund_manual_notice": "இது கையேடு COD/பணம் மீட்டெடுப்பை பதிவு செய்து, அதன் கணக்கியல் மாற்றத்தை கொண்டு வருகிறது. எந்த பேமெண்ட் வழங்குநரும் தொடர்புகொள்ளப்படாது.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "இது கையேடு COD/பணம் மீட்டெடுப்பை பதிவு செய்து, அதன் கணக்கியல் மாற்றத்தை கொண்டு வருகிறது. எந்த பேமெண்ட் வழங்குநரும் தொடர்புகொள்ளப்படாது.",
    "currency_conversion.title": "முதலீட்டு மாற்றம்",
    "Currency conversion": "முதலீட்டு மாற்றம்",
    "currency_conversion.open_settings": "மாற்ற அமைப்புகள்",
    "Conversion settings": "மாற்ற அமைப்புகள்",
    "currency_conversion.load_failed": "முதலீட்டு மாற்ற அமைப்புகளை ஏற்றுமதி செய்ய முடியவில்லை.",
    "Could not load currency conversion settings.": "முதலீட்டு மாற்ற அமைப்புகளை ஏற்றுமதி செய்ய முடியவில்லை.",
    "currency_conversion.interval_error": "மாற்ற இடைவெளி 5 நிமிடங்களுக்கும் 24 மணிநேரத்திற்கும் இடையே இருக்க வேண்டும்.",
    "Refresh interval must be between 5 minutes and 24 hours.": "மாற்ற இடைவெளி 5 நிமிடங்களுக்கும் 24 மணிநேரத்திற்கும் இடையே இருக்க வேண்டும்.",
    "currency_conversion.save_failed": "முதலீட்டு மாற்ற அமைப்புகளை சேமிக்க முடியவில்லை.",
    "Could not save currency conversion settings.": "முதலீட்டு மாற்ற அமைப்புகளை சேமிக்க முடியவில்லை.",
    "currency_conversion.saved": "முதலீட்டு மாற்ற அமைப்புகள் சேமிக்கப்பட்டன.",
    "Currency conversion settings saved.": "முதலீட்டு மாற்ற அமைப்புகள் சேமிக்கப்பட்டன.",
    "currency_conversion.description": "காட்டப்படும் முதலீட்டு மாற்றங்களை எவ்வாறு கணக்கிடப்படுகிறது என்பதைத் தேர்வு செய்யவும்.",
    "Choose how displayed currency conversions are calculated.": "காட்டப்படும் முதலீட்டு மாற்றங்களை எவ்வாறு கணக்கிடப்படுகிறது என்பதைத் தேர்வு செய்யவும்.",
    "currency_conversion.manual_title": "கையேடு விகிதங்கள்",
    "currency_conversion.manual_help": "கீழே உள்ள ஒவ்வொரு நாட்டின் மாற்ற விகிதத்தை பயன்படுத்தவும்.",
    "Use the exchange rate entered for each currency below.": "கீழே உள்ள ஒவ்வொரு நாட்டின் மாற்ற விகிதத்தை பயன்படுத்தவும்.",
    "currency_conversion.frankfurter_title": "ஃப்ராங்க்பூர்ட்டர் (முன்னிருப்பு)",
    "Frankfurter (default)": "ஃப்ராங்க்பூர்ட்டர் (முன்னிருப்பு)",
    "currency_conversion.frankfurter_help": "தினமும் இலவச மாற்ற விகிதங்கள். வழங்குநர் API குறியீடு தேவையில்லை.",
    "Free daily exchange rates. No provider API key is required.": "தினமும் இலவச மாற்ற விகிதங்கள். வழங்குநர் API குறியீடு தேவையில்லை.",
    "currency_conversion.fixer_title": "ஃபிக்ஸர்",
    "Fixer": "ஃபிக்ஸர்",
    "currency_conversion.fixer_help": "தளத்தால் மேலாண்மை செய்யப்பட்ட ஃபிக்ஸர் சேவையைப் பயன்படுத்தவும். விகித மேம்பாடுகள் வழங்குநர் திட்டத்தைப் பொறுத்து இருக்கும்.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "தளத்தால் மேலாண்மை செய்யப்பட்ட ஃபிக்ஸர் சேவையைப் பயன்படுத்தவும். விகித மேம்பாடுகள் வழங்குநர் திட்டத்தைப் பொறுத்து இருக்கும்.",
    "currency_conversion.refresh_interval": "விகித மீண்டும் பார்வை இடைவெளி (நிமிடங்கள்)",
    "Rate re-check interval (minutes)": "விகித மீண்டும் பார்வை இடைவெளி (நிமிடங்கள்)",
    "workspace.currency_search_code": "தேடுதல் அல்லது தேர்வு செய்தல்",
    "Search or select": "தேடுதல் அல்லது தேர்வு செய்தல்",
    "workspace.currency_preset_hint": "பரிந்துரைக்கப்பட்ட முன்னேற்ற மதிப்புகள் பயன்படுத்தப்பட்டுள்ளன. நீங்கள் எந்த புலத்தையும் தொகுத்துக்கொள்ளலாம்.",
    "Recommended defaults applied. You can edit any field.": "பரிந்துரைக்கப்பட்ட முன்னேற்ற மதிப்புகள் பயன்படுத்தப்பட்டுள்ளன. நீங்கள் எந்த புலத்தையும் தொகுத்துக்கொள்ளலாம்.",
    "developer.api_keys.copy_unavailable": "குறியீடு இன்னும் கிடைக்கவில்லை.",
    "Key is not available yet.": "குறியீடு இன்னும் கிடைக்கவில்லை.",
    "developer.api_keys.copy_failed": "குறியீட்டை நகலெடுக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Unable to copy the key. Try again.": "குறியீட்டை நகலெடுக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "payroll.action.export_pdf": "PDF ஏற்றுமதி செய்தல்",
    "Export PDF": "PDF ஏற்றுமதி செய்தல்",
    "cms.category.name_prompt": "கத்திரிகை பெயர்",
    "cms.field.cover_image": "கவர் படம்",
    "Cover Image": "கவர் படம்",
    "cms.action.add_cover_photo": "கவர் படத்தை சேர்க்கவும்",
    "Add cover photo": "கவர் படத்தை சேர்க்கவும்",
    "cms.field.category": "கத்திரிகை",
    "cms.category.none": "கத்திரிகையில்லை",
    "No category": "கத்திரிகையில்லை",
    "cms.advanced": "மேம்படுத்தப்பட்ட",
    "media_picker.action.select_image": "படத்தைத் தேர்வுசெய்க",
    "Select image": "படத்தைத் தேர்வுசெய்க",
    "orders.confirm_record_cash_refund": "மீள்வழங்கலைப் பதிவுசெய்க",
    "Record refund": "மீள்வழங்கலைப் பதிவுசெய்க",
    "listing_form.no_repeat": "திரும்ப மீண்டும் எழுதாதே",
    "No repeat": "திரும்ப மீண்டும் எழுதாதே",
    "listing_form.custom_repeat_days": "தனிப்பயன்: {days}",
    "Custom: {days}": "தனிப்பயன்: {days}",
    "common.sending": "அனுப்பப்படுகிறது…",
    "listings.detail.unique_name": "ஒற்றைப்படை பெயர்",
    "Unique Name": "ஒற்றைப்படை பெயர்",
    "app_customization.username": "பயனர்பெயர்",
    "workspace.templates.name_required": "வடிவமைப்பு பெயர் தேவைப்படுகிறது.",
    "Template name is required.": "வடிவமைப்பு பெயர் தேவைப்படுகிறது.",
    "workspace.templates.saved": "பாடம் சேமிக்கப்பட்டது.",
    "Role template saved.": "பாடம் சேமிக்கப்பட்டது.",
    "workspace.templates.confirm_delete": " \"{name}\" வடிவமைப்பை நீக்கவா?",
    "Delete template \"{name}\"?": " \"{name}\" வடிவமைப்பை நீக்கவா?",
    "workspace.templates.deleted": "தானியங்கி நீக்கப்பட்டது.",
    "Template deleted.": "தானியங்கி நீக்கப்பட்டது.",
    "workspace.members.tab_members": "உறுப்பினர்கள்",
    "workspace.templates.tab": "பாதிப்பு தானியங்கிகள்",
    "Role Templates": "பாதிப்பு தானியங்கிகள்",
    "workspace.templates.title": "பாதிப்பு தானியங்கிகள்",
    "workspace.templates.new": "புதிய தானியங்கி",
    "New Template": "புதிய தானியங்கி",
    "workspace.templates.name": "பெயர்",
    "workspace.templates.empty": "முன்னதாக பாதிப்பு தானியங்கிகள் இல்லை.",
    "No role templates yet.": "முன்னதாக பாதிப்பு தானியங்கிகள் இல்லை.",
    "workspace.templates.edit": "தானியங்கியை தொகுக்கவும்",
    "Edit Template": "தானியங்கியை தொகுக்கவும்",
    "workspace.templates.name_label": "தானியங்கியின் பெயர்",
    "Template name": "தானியங்கியின் பெயர்",
    "workspace.templates.name_placeholder": "எ.கா. உள்ளடக்க மேலாளர்",
    "e.g. Content Manager": "எ.கா. உள்ளடக்க மேலாளர்",
    "listings.import.unknown_error": "வகைகளை இறக்குமதி செய்ய முடியவில்லை. CSV-ஐ சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "The categories could not be imported. Please check the CSV and try again.": "வகைகளை இறக்குமதி செய்ய முடியவில்லை. CSV-ஐ சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "common.no_access_to_page": "அணுகல் இல்லை",
    "No access": "அணுகல் இல்லை",
    "common.permission_to_view_page_denied": "இந்த பக்கத்தை பார்ப்பதற்கு உங்களுக்கு அனுமதி இல்லை.",
    "You do not have permission to view this page.": "இந்த பக்கத்தை பார்ப்பதற்கு உங்களுக்கு அனுமதி இல்லை.",
    "common.loading_permissions": "அனுமதிகளை ஏற்றுக்கொள்ளுதல்…",
    "Loading permissions…": "அனுமதிகளை ஏற்றுக்கொள்ளுதல்…",
    "attributes.added_successfully": "நல்லது 🎉, அம்சங்கள் வெற்றிகரமாக சேர்க்கப்பட்டன.",
    "Nice 🎉, Successfully added attributes": "நல்லது 🎉, அம்சங்கள் வெற்றிகரமாக சேர்க்கப்பட்டன.",
    "attributes.add_attribute_values": "அம்ச மதிப்புகளைச் சேர்",
    "attributes.attribute": "அம்சம்",
    "attributes.optional": "கூடுதல்",
    "attributes.private": "தனியார்",
    "attributes.hidden_field": "மறைக்கப்பட்ட புலம்",
    "attributes.show_in_filter": "தேர்வு செய்யப்பட்ட பட்டியலில் காட்டு",
    "attributes.status_not_active_active": "நிலை (ஆக்டிவ் இல்லை / ஆக்டிவ்)",
    "attributes.add_metadata": "மேம்பாடுகளைச் சேர்",
    "Add metadata": "மேம்பாடுகளைச் சேர்",
    "attributes.select_date_time": "தேதி மற்றும் நேரத்தைத் தேர்வுசெய்க",
    "listings.addons.column_title": "தலைப்பு",
    "listings.addons.column_image": "படம்",
    "listings.addons.column_price": "விலை",
    "listings.addons.column_max_quantity": "குறைந்தபட்ச அளவு",
    "Max Quantity": "குறைந்தபட்ச அளவு",
    "listings.addons.column_offer": "மலிவு",
    "listings.addons.column_stock": "கொள்ளுதல்",
    "listings.addons.column_action": "செயல்",
    "listings.addons.column_status": "நிலை",
    "listings.addons.confirm_delete": "இந்த கூடுதல் வகையை நீக்க விரும்புகிறீர்களா?",
    "Do you want to delete this add-on type?": "இந்த கூடுதல் வகையை நீக்க விரும்புகிறீர்களா?",
    "common.share_collection": "கூட்டு பகிர்வு",
    "Share collection": "கூட்டு பகிர்வு",
    "communications.view_modes": "தொடர்பு காட்சி முறைகள்",
    "Communication view modes": "தொடர்பு காட்சி முறைகள்",
    "payments.accessibility.gateway_logo": "செலுத்தும் வழித்தட லோகோ",
    "Payment gateway logo": "செலுத்தும் வழித்தட லோகோ",
    "common.build_version": "கட்டுமான பதிப்பு",
    "Build version": "கட்டுமான பதிப்பு",
    "common.build_label": "உருவாக்க எண்",
    "build": "உருவாக்க எண்",
    "listings.under_category_title": "{category}-இன் கீழ் பட்டியலிடப்பட்டவை",
    "Listings under {category}": "{category}-இன் கீழ் பட்டியலிடப்பட்டவை",
    "attributes.signup": "பதிவுசெய்தல்",
    "Signup": "பதிவுசெய்தல்",
    "common.toast.please_check_action": "இந்த செயலை சரிபார்க்கவும்",
    "Please check this action": "இந்த செயலை சரிபார்க்கவும்",
    "common.information": "தகவல்",
    "listing_form.error.load_listing_data": "பட்டியல் தரவுகளை ஏற்றுவதில் தோல்வி",
    "Failed to load listing data": "பட்டியல் தரவுகளை ஏற்றுவதில் தோல்வி",
    "listing_form.error.load_digital_contents": "மின்னணு உள்ளடக்கங்களை ஏற்றுவதில் தோல்வி",
    "Failed to load digital contents": "மின்னணு உள்ளடக்கங்களை ஏற்றுவதில் தோல்வி",
    "listing_form.validation.audio_file_or_url_required": "உருவாக்கும் முன் ஒரு ஒலி கோப்பை அல்லது பொது ஒலி URL-ஐ சேர்க்கவும்.",
    "Add an audio file or public audio URL before creating the episode.": "உருவாக்கும் முன் ஒரு ஒலி கோப்பை அல்லது பொது ஒலி URL-ஐ சேர்க்கவும்.",
    "listing_form.validation.rental_rate_greater_than_zero": "0-க்கு மேல் ஒரு வாடகை விகிதத்தை உள்ளிடவும்.",
    "Enter a rental rate greater than 0.": "0-க்கு மேல் ஒரு வாடகை விகிதத்தை உள்ளிடவும்.",
    "listing_form.validation.maximum_duration_gte_minimum": "குறைந்தபட்ச நேரத்தை விட அதிகபட்ச நேரம் அதிகமாக இருக்க வேண்டும்.",
    "Maximum duration must be greater than or equal to minimum duration.": "குறைந்தபட்ச நேரத்தை விட அதிகபட்ச நேரம் அதிகமாக இருக்க வேண்டும்.",
    "listing_form.updated_successfully": "பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "Listing updated successfully!": "பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "listing_form.created_successfully": "பட்டியல் வெற்றிகரமாக உருவாக்கப்பட்டது",
    "Listing created successfully!": "பட்டியல் வெற்றிகரமாக உருவாக்கப்பட்டது",
    "listing_form.error.save_failed": "பட்டியலை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Failed to save listing. Please try again.": "பட்டியலை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "listing_form.error.delete_variant_failed": "விருத்திப்பு {title} அகற்ற முடியவில்லை",
    "Failed to delete variant: {title}": "விருத்திப்பு {title} அகற்ற முடியவில்லை",
    "listing_form.error.variant_action_failed": "{action} விருத்திப்பை {title} செய்ய முடியவில்லை",
    "Failed to {action} variant: {title}": "{action} விருத்திப்பை {title} செய்ய முடியவில்லை",
    "listing_form.error.digital_content_action_failed": "{action} மின்னணு உள்ளடக்கத்தை {title} செய்ய முடியவில்லை",
    "Failed to {action} digital content: {title}": "{action} மின்னணு உள்ளடக்கத்தை {title} செய்ய முடியவில்லை",
    "listing_form.action.create": "உருவாக்க",
    "listing_form.action.update": "புதுப்பிக்க",
    "listing_form.action.delete": "அகற்ற",
    "delete": "அகற்ற",
    "listing_form.error.save_request_failed": "பட்டியலை சேமிக்க முடியவில்லை",
    "Failed to save listing": "பட்டியலை சேமிக்க முடியவில்லை",
    "listing_form.error.rental_settings_save_failed": "பட்டியல் சேமிக்கப்பட்டது, ஆனால் வாடகை அமைப்புகள் சேமிக்க முடியவில்லை.",
    "Listing saved, but rental settings could not be saved.": "பட்டியல் சேமிக்கப்பட்டது, ஆனால் வாடகை அமைப்புகள் சேமிக்க முடியவில்லை.",
    "users.action_failed": "செயல் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "Action failed. Please try again.": "செயல் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    "common.successfully_added": "வெற்றிகரமாக சேர்க்கப்பட்டது",
    "Successfully added": "வெற்றிகரமாக சேர்க்கப்பட்டது",
    "listing_form.validation.title_min_length": "தலைப்பு {count} எழுத்துகளுக்கு குறைவாக இருக்கக்கூடாது",
    "Title must be at least {count} characters": "தலைப்பு {count} எழுத்துகளுக்கு குறைவாக இருக்கக்கூடாது",
    "listing_form.validation.title_max_length": "தலைப்பு {count} எழுத்துகளை மீறக்கூடாது",
    "Title must not exceed {count} characters": "தலைப்பு {count} எழுத்துகளை மீறக்கூடாது",
    "listing_form.validation.price_minimum": "விலை {amount} ஐ விட குறைவாக இருக்கக்கூடாது",
    "Price must be at least {amount}": "விலை {amount} ஐ விட குறைவாக இருக்கக்கூடாது",
    "listing_form.validation.attribute_required": "{attribute} அவசியமானது",
    "listings.error.load_failed": "அறிவிப்புகளை ஏற்றுமதி செய்ய முடியவில்லை",
    "Unable to load listings": "அறிவிப்புகளை ஏற்றுமதி செய்ய முடியவில்லை",
    "communications.from_email_required_before_verification": "சரிபார்ப்பு செய்யும் முன், ஆதார மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "Please enter From email address before verifying.": "சரிபார்ப்பு செய்யும் முன், ஆதார மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "communications.verification_email_sent": "சரிபார்ப்பு மின்னஞ்சல் அனுப்பப்பட்டுள்ளது. தயவுசெய்து உங்கள் இன்பாக்ஸில் பார்த்து, இந்த மின்னஞ்சல் முகவரியை சரிபார்க்க வழிமுறைகளைப் பின்பற்றவும்.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "சரிபார்ப்பு மின்னஞ்சல் அனுப்பப்பட்டுள்ளது. தயவுசெய்து உங்கள் இன்பாக்ஸில் பார்த்து, இந்த மின்னஞ்சல் முகவரியை சரிபார்க்க வழிமுறைகளைப் பின்பற்றவும்.",
    "communications.verification_start_failed": "சரிபார்ப்பை தொடங்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to start verification. Please try again.": "சரிபார்ப்பை தொடங்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "common.uploaded_successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
    "upgrade_page.panel.yearly": "ஆண்டுதோறும்",
    "upgrade_page.panel.monthly": "மாதாந்திர",
    "orders.advance_paid": "முன்கூட்டிய செலுத்தப்பட்டது",
    "Advance paid": "முன்கூட்டிய செலுத்தப்பட்டது",
    "orders.balance_due": "மீதமுள்ள தொகை",
    "Balance due": "மீதமுள்ள தொகை",
    "orders.advance_invalid": "ஆர்டர் மொத்தத்தை விட குறைவான தொகையை உள்ளிடவும்.",
    "Enter an amount less than the order total.": "ஆர்டர் மொத்தத்தை விட குறைவான தொகையை உள்ளிடவும்.",
    "orders.advance_failed": "முன்பணம் சேமிக்க முடியவில்லை.",
    "Could not save the advance.": "முன்பணம் சேமிக்க முடியவில்லை.",
    "orders.edit_advance": "முன்பணத்தை தொகுத்துக்கொள்ள",
    "Edit advance": "முன்பணத்தை தொகுத்துக்கொள்ள",
    "orders.record_advance": "முன்பணத்தை பதிவு செய்ய",
    "Record advance": "முன்பணத்தை பதிவு செய்ய",
    "orders.advance_notice": "வாடிக்கையாளர் முன்னரே செலுத்திய தொகை, {total} ஆர்டர் மொத்தத்தை விட குறைவாக உள்ளது. பின்னர் பிடிப்பு செலுத்தப்பட்டதாக குறிப்பிடும் வரை ஆர்டர் செலுத்தப்படாமல் இருக்கும். முன்பணத்தை நீக்க, 0 உள்ளிடவும்.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "வாடிக்கையாளர் முன்னரே செலுத்திய தொகை, {total} ஆர்டர் மொத்தத்தை விட குறைவாக உள்ளது. பின்னர் பிடிப்பு செலுத்தப்பட்டதாக குறிப்பிடும் வரை ஆர்டர் செலுத்தப்படாமல் இருக்கும். முன்பணத்தை நீக்க, 0 உள்ளிடவும்.",
    "orders.save_advance": "சேமிக்க",
    "common.hide": "மறை",
    "listings.repeat.daily": "தினமும்",
    "listings.repeat.weekdays": "வேலை நாட்கள் (திங்கள்-வியாழன்)",
    "Weekdays (Mon-Fri)": "வேலை நாட்கள் (திங்கள்-வியாழன்)",
    "listings.repeat.weekend": "விடுமுறை நாட்கள் (சனி-ஞாயிறு)",
    "Weekend (Sat-Sun)": "விடுமுறை நாட்கள் (சனி-ஞாயிறு)",
    "listings.repeat.custom": "தனிப்பயன்",
    "listings.weekday.sun": "ஞாயிறு",
    "Sun": "ஞாயிறு",
    "listings.weekday.mon": "திங்கள்",
    "Mon": "திங்கள்",
    "listings.weekday.tue": "செவ்வாய்",
    "Tue": "செவ்வாய்",
    "listings.weekday.wed": "புதன்",
    "Wed": "புதன்",
    "listings.weekday.thu": "வியாழன்",
    "Thu": "வியாழன்",
    "listings.weekday.fri": "வெள்ளி",
    "Fri": "வெள்ளி",
    "listings.weekday.sat": "சனிக்கிழமை",
    "Sat": "சனிக்கிழமை",
    "orders.pay_balance": "செலுத்து {amount} பிடித்து",
    "Pay balance {amount}": "செலுத்து {amount} பிடித்து",
    "orders.partially_paid": "பாகமாக செலுத்தப்பட்டது",
    "Partially paid": "பாகமாக செலுத்தப்பட்டது",
    "orders.balance_amount": "செலுத்து {amount} பிடித்து",
    "Balance {amount}": "செலுத்து {amount} பிடித்து",
    "delivery.get_started.add_branch": "கிளையைச் சேர்க்கவும்",
    "Add branch": "கிளையைச் சேர்க்கவும்",
    "delivery.get_started.add_fleet": "வாகனக் குழுவைச் சேர்க்கவும்",
    "Add fleet": "வாகனக் குழுவைச் சேர்க்கவும்",
    "delivery.get_started.api_documentation": "API ஆவணம்",
    "API Documentation": "API ஆவணம்",
    "delivery.get_started.add_driver": "ஓட்டுநரைச் சேர்க்கவும்",
    "Add driver": "ஓட்டுநரைச் சேர்க்கவும்",
    "delivery.get_started.branch_title": "உங்கள் கிளையைச் சேர்க்கவும்",
    "Add your branch": "உங்கள் கிளையைச் சேர்க்கவும்",
    "delivery.get_started.branch_description": "ஒரு கிளையில் பல வாகனக் குழுக்களும் ஓட்டுநர்களும் இருக்கலாம்",
    "A branch can have many fleets and drivers": "ஒரு கிளையில் பல வாகனக் குழுக்களும் ஓட்டுநர்களும் இருக்கலாம்",
    "delivery.get_started.fleet_title": "உங்கள் வாகனக் குழுவைச் சேர்க்கவும்",
    "Add your fleet": "உங்கள் வாகனக் குழுவைச் சேர்க்கவும்",
    "delivery.get_started.fleet_description": "ஒரு வாகனக் குழுவை ஓட்டுநருக்கு ஒதுக்கலாம்",
    "A fleet can be assigned to a driver": "ஒரு வாகனக் குழுவை ஓட்டுநருக்கு ஒதுக்கலாம்",
    "delivery.get_started.driver_title": "உங்கள் ஓட்டுநரைச் சேர்க்கவும்",
    "Add your driver": "உங்கள் ஓட்டுநரைச் சேர்க்கவும்",
    "delivery.get_started.driver_description": "ஓட்டுநர் உங்கள் ஆர்டரை வழங்குவார்",
    "The driver will deliver your order": "ஓட்டுநர் உங்கள் ஆர்டரை வழங்குவார்",
    "delivery.get_started.order_title": "உங்கள் முதல் ஆர்டரை உருவாக்குங்கள்",
    "Create your first order": "உங்கள் முதல் ஆர்டரை உருவாக்குங்கள்",
    "delivery.get_started.order_description": "ஆர்டர்களை API மூலம் உருவாக்கலாம்",
    "Orders can be created through the API": "ஆர்டர்களை API மூலம் உருவாக்கலாம்",
    "delivery.get_started.progress.branches": "கிளைகள்",
    "Branches": "கிளைகள்",
    "delivery.get_started.progress.fleets": "வாகனக் குழுக்கள்",
    "Fleets": "வாகனக் குழுக்கள்",
    "delivery.get_started.progress.drivers": "ஓட்டுநர்கள்",
    "Drivers": "ஓட்டுநர்கள்",
    "delivery.get_started.progress.orders": "விநியோக ஆர்டர்கள்",
    "Delivery Orders": "விநியோக ஆர்டர்கள்",
    "delivery.get_started.welcome": "வரவேற்கிறோம்",
    "Welcome to": "வரவேற்கிறோம்",
    "delivery.get_started.question": "நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்؟",
    "What would you like to do?": "நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்؟",
    "workspace.templates.built_in": "உள்ளமைந்த",
    "Built-in": "உள்ளமைந்த",
    "workspace.templates.copy_of": "{name} இன் நகல்",
    "Copy of {name}": "{name} இன் நகல்",
    "workspace.members.role": "பங்கு",
    "Role": "பங்கு",
    "workspace.members.role_full_access": "முழு அணுகல்",
    "Full access": "முழு அணுகல்",
    "workspace.templates.duplicate": "நகலெடு",
    "workspace.members.role_custom": "தனிப்பயன் (கீழே அமைக்கவும்)",
    "Custom (set below)": "தனிப்பயன் (கீழே அமைக்கவும்)"
  },
  "ru": {
    "0": "0",
    "6100": "6100",
    "common.language": "Язык",
    "Language": "Язык",
    "common.english": "Английский",
    "English": "Английский",
    "common.french": "Французский",
    "French": "Французский",
    "common.arabic": "Арабский",
    "Arabic": "Арабский",
    "navigation.get_started": "Начать",
    "Get Started": "Начать",
    "navigation.dashboard": "Панель управления",
    "navigation.orders": "Заказы",
    "Orders": "Заказы",
    "navigation.schedule": "Расписание",
    "Schedule": "Расписание",
    "navigation.accounts": "Аккаунты",
    "navigation.account_categories": "Категории аккаунтов",
    "Account Categories": "Категории аккаунтов",
    "navigation.account_attributes": "Атрибуты аккаунта",
    "Account Attributes": "Атрибуты аккаунта",
    "navigation.account_configuration": "Настройки аккаунта",
    "Account Configuration": "Настройки аккаунта",
    "navigation.agents": "Агенты",
    "Agents": "Агенты",
    "navigation.listings": "Товары",
    "navigation.categories": "Категории",
    "Categories": "Категории",
    "navigation.custom_attributes": "Пользовательские атрибуты",
    "Custom Attributes": "Пользовательские атрибуты",
    "navigation.variant_types": "Типы вариантов",
    "Variant Types": "Типы вариантов",
    "navigation.additional_features": "Дополнительные функции",
    "Additional Features": "Дополнительные функции",
    "navigation.reported_listings": "Жалобы на товары",
    "navigation.report_accounts": "Жалобы на аккаунты",
    "Report Accounts": "Жалобы на аккаунты",
    "navigation.users": "Пользователи",
    "Users": "Пользователи",
    "navigation.user_attributes": "Атрибуты пользователя",
    "User Attributes": "Атрибуты пользователя",
    "navigation.reviews_ratings": "Отзывы и оценки",
    "Reviews & Ratings": "Отзывы и оценки",
    "navigation.report": "Отчёт",
    "Report": "Отчёт",
    "navigation.reports": "Отчёты",
    "navigation.platform_health": "Состояние платформы",
    "Platform Health": "Состояние платформы",
    "navigation.promotions": "Акции",
    "Promotions": "Акции",
    "navigation.collections": "Подборки",
    "navigation.promotion_ads": "Продвижение / реклама",
    "Promotion / Ads": "Продвижение / реклама",
    "navigation.coupons": "Купоны",
    "Coupons": "Купоны",
    "navigation.finance": "Финансы",
    "Finance": "Финансы",
    "navigation.transactions": "Транзакции",
    "Transactions": "Транзакции",
    "navigation.settlement": "Расчёты",
    "Settlement": "Расчёты",
    "navigation.expenses": "Расходы",
    "Expenses": "Расходы",
    "navigation.recurring_payments": "Регулярные платежи",
    "Recurring payments": "Регулярные платежи",
    "navigation.media": "Медиатека",
    "navigation.communication": "Коммуникации",
    "Communication": "Коммуникации",
    "navigation.web": "Веб",
    "Web": "Веб",
    "navigation.website_editor": "Редактор сайта",
    "Website Editor": "Редактор сайта",
    "navigation.change_templates": "Изменить шаблоны",
    "Change Templates": "Изменить шаблоны",
    "navigation.pages": "Страницы",
    "Pages": "Страницы",
    "navigation.blog": "Блог",
    "Blog": "Блог",
    "navigation.customise_texts": "Настроить тексты",
    "Customise texts": "Настроить тексты",
    "navigation.add_integrations": "Добавить интеграции",
    "Add Integrations": "Добавить интеграции",
    "navigation.domain": "Домен",
    "Domain": "Домен",
    "navigation.customise_seo": "Настроить SEO",
    "Customise SEO": "Настроить SEO",
    "navigation.app": "Приложение",
    "App": "Приложение",
    "navigation.apps": "Приложения",
    "Apps": "Приложения",
    "navigation.buy_app_templates": "Купить шаблоны приложений",
    "Buy App Templates": "Купить шаблоны приложений",
    "navigation.customisation": "Настройка",
    "Customisation": "Настройка",
    "navigation.integrations": "Интеграции",
    "Integrations": "Интеграции",
    "navigation.invite_team": "Пригласить команду",
    "Invite Team": "Пригласить команду",
    "navigation.help": "Помощь",
    "Help": "Помощь",
    "navigation.documentation": "Документация",
    "Documentation": "Документация",
    "navigation.community": "Сообщество",
    "Community": "Сообщество",
    "navigation.api_reference": "Справочник API",
    "API Reference": "Справочник API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Каналы",
    "Channels": "Каналы",
    "navigation.coding_kits": "Наборы для разработки",
    "Coding Kits": "Наборы для разработки",
    "navigation.vibe_coding": "Разработка с ИИ",
    "Vibe Coding": "Разработка с ИИ",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Настройки",
    "Settings": "Настройки",
    "navigation.more": "Ещё",
    "navigation.marketplace": "Маркетплейс",
    "Marketplace": "Маркетплейс",
    "navigation.commerce": "Коммерция",
    "navigation.marketing": "Маркетинг",
    "Marketing": "Маркетинг",
    "navigation.intelligence": "Интеллект",
    "navigation.subscription": "Подписка",
    "navigation.membership": "Членство",
    "Membership": "Членство",
    "navigation.rewards": "Награды",
    "Rewards": "Награды",
    "navigation.bundles": "Комплекты",
    "Bundles": "Комплекты",
    "navigation.supply_chain": "Цепочка поставок",
    "Supply Chain": "Цепочка поставок",
    "navigation.people": "Персонал",
    "navigation.workforce": "Рабочая сила",
    "navigation.payroll": "Расчёт зарплаты",
    "navigation.inventory": "Запасы",
    "Inventory": "Запасы",
    "navigation.inventory_operations": "Операции с запасами",
    "Inventory Operations": "Операции с запасами",
    "navigation.purchase_orders": "Заказы на закупку",
    "Purchase Orders": "Заказы на закупку",
    "navigation.stock_locations": "Места хранения запасов",
    "Stock Locations": "Места хранения запасов",
    "navigation.purchase_orders_2": "Заказы на закупку",
    "Purchase orders": "Заказы на закупку",
    "navigation.suppliers": "Поставщики",
    "Suppliers": "Поставщики",
    "navigation.locations": "Местоположения",
    "navigation.maps": "Карты",
    "Maps": "Карты",
    "navigation.accounting": "Бухгалтерия",
    "Accounting": "Бухгалтерия",
    "navigation.invoices": "Счета",
    "Invoices": "Счета",
    "navigation.plans": "Тарифы",
    "navigation.countries": "Страны",
    "Countries": "Страны",
    "navigation.currency": "Валюта",
    "Currency": "Валюта",
    "navigation.languages": "Языки",
    "Languages": "Языки",
    "navigation.payments": "Платежи",
    "Payments": "Платежи",
    "navigation.commissions": "Комиссии",
    "Commissions": "Комиссии",
    "navigation.taxes": "Налоги",
    "Taxes": "Налоги",
    "navigation.special_fees": "Специальные сборы",
    "Special Fees": "Специальные сборы",
    "navigation.service_shipping": "Услуги / доставка",
    "navigation.checkout_cart_attributes": "Атрибуты оформления заказа и корзины",
    "Checkout & Cart Attributes": "Атрибуты оформления заказа и корзины",
    "navigation.dark_mode_background_color": "Цвет фона тёмной темы",
    "Dark Mode Background Color": "Цвет фона тёмной темы",
    "navigation.dark_mode_text_color": "Цвет текста тёмной темы",
    "Dark Mode Text Color": "Цвет текста тёмной темы",
    "navigation.light_mode_background_color": "Цвет фона светлой темы",
    "Light Mode Background Color": "Цвет фона светлой темы",
    "navigation.light_mode_text_color": "Цвет текста светлой темы",
    "Light Mode Text Color": "Цвет текста светлой темы",
    "navigation.workspace": "Рабочее пространство",
    "navigation.user_management": "Управление пользователями",
    "User Management": "Управление пользователями",
    "navigation.privacy": "Конфиденциальность",
    "Privacy": "Конфиденциальность",
    "common.search": "Поиск...",
    "Search...": "Поиск...",
    "common.search_2": "Поиск",
    "common.no_results_found": "Ничего не найдено",
    "No results found": "Ничего не найдено",
    "common.no_record_found": "Записи не найдены",
    "No Record Found": "Записи не найдены",
    "common.open_in_a_new_tab": "Открыть в новой вкладке",
    "Open in a new tab": "Открыть в новой вкладке",
    "common.open": "Открыть",
    "common.in_a_new_tab": "в новой вкладке",
    "in a new tab": "в новой вкладке",
    "common.loading_page": "Загрузка страницы…",
    "Loading page…": "Загрузка страницы…",
    "common.close": "Закрыть",
    "Close": "Закрыть",
    "common.save": "Сохранить",
    "Save": "Сохранить",
    "common.cancel": "Отмена",
    "Cancel": "Отмена",
    "common.delete": "Удалить",
    "common.edit": "Изменить",
    "Edit": "Изменить",
    "common.add": "Добавить",
    "Add": "Добавить",
    "common.create": "Создать",
    "Create": "Создать",
    "common.update": "Обновить",
    "Update": "Обновить",
    "common.back": "Назад",
    "Back": "Назад",
    "common.next": "Далее",
    "Next": "Далее",
    "common.previous": "Предыдущий",
    "common.done": "Готово",
    "Done": "Готово",
    "common.yes": "Да",
    "Yes": "Да",
    "common.no": "Нет",
    "No": "Нет",
    "common.name": "Имя",
    "common.status": "Статус",
    "common.date": "Дата",
    "Date": "Дата",
    "common.actions": "Действия",
    "common.action": "Действие",
    "Action": "Действие",
    "orders.scan_order": "Сканировать заказ",
    "Scan order": "Сканировать заказ",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Отсканируйте штрихкод/QR-код заказа или введите его вручную.",
    "Scan a barcode/QR reference or enter it manually.": "Отсканируйте штрихкод/QR-код заказа или введите его вручную.",
    "orders.camera_scanner": "Сканер камеры",
    "Camera scanner": "Сканер камеры",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "Сканирование камерой здесь не поддерживается. Введите номер заказа ниже.",
    "Camera scanning is not supported here. Enter the order reference below.": "Сканирование камерой здесь не поддерживается. Введите номер заказа ниже.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "Нет доступа к камере. Введите номер заказа ниже.",
    "Camera access is unavailable. Enter the order reference below.": "Нет доступа к камере. Введите номер заказа ниже.",
    "orders.order_reference_number": "Номер заказа",
    "Order reference number": "Номер заказа",
    "orders.find_order": "Найти заказ",
    "Find order": "Найти заказ",
    "common.your_orders_will_be_shown_here": "Здесь будут отображаться ваши заказы.",
    "Your orders will be shown here.": "Здесь будут отображаться ваши заказы.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Здесь можно отслеживать заказы и бронирования, оформленные с других аккаунтов, а также следить за изменением их статуса.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Здесь можно отслеживать заказы и бронирования, оформленные с других аккаунтов, а также следить за изменением их статуса.",
    "common.reference": "Номер ссылки",
    "Reference #": "Номер ссылки",
    "common.amount": "Сумма",
    "Amount": "Сумма",
    "orders.order_status": "Статус заказа",
    "Order Status": "Статус заказа",
    "orders.payment_status": "Статус оплаты",
    "Payment Status": "Статус оплаты",
    "common.payment_method": "Способ оплаты",
    "Payment Method": "Способ оплаты",
    "common.shipping_method": "Способ доставки",
    "Shipping Method": "Способ доставки",
    "common.paid": "Оплачено",
    "Paid": "Оплачено",
    "common.not_paid": "Не оплачено",
    "Not Paid": "Не оплачено",
    "common.unpaid": "Не оплачено",
    "UnPaid": "Не оплачено",
    "common.failed": "Не удалось",
    "common.incomplete": "Не завершено",
    "Incomplete": "Не завершено",
    "common.order_placed": "Заказ оформлен",
    "Order placed": "Заказ оформлен",
    "common.order_in_progress": "Заказ выполняется",
    "Order in progress": "Заказ выполняется",
    "common.shipped": "Отправлено",
    "common.delivered": "Доставлено",
    "common.cancelled_by_customer": "Отменено покупателем",
    "Cancelled by customer": "Отменено покупателем",
    "common.order_completed": "Заказ завершён",
    "Order completed": "Заказ завершён",
    "common.n_a": "Н/Д",
    "N/A": "Н/Д",
    "orders.total_orders": "Всего заказов",
    "Total Orders": "Всего заказов",
    "orders.page_revenue": "Выручка страницы",
    "Page Revenue": "Выручка страницы",
    "orders.pending_payment": "Ожидает оплаты",
    "Pending Payment": "Ожидает оплаты",
    "common.failed_payments": "Неуспешные платежи",
    "Failed payments": "Неуспешные платежи",
    "common.abandoned": "Брошено",
    "Abandoned": "Брошено",
    "orders.search_orders_by_reference_number": "Поиск заказов по номеру",
    "Search orders by reference number": "Поиск заказов по номеру",
    "orders.search_by_reference_number": "Поиск по номеру…",
    "Search by reference number…": "Поиск по номеру…",
    "orders.export_orders_as_csv": "Экспортировать заказы в CSV",
    "Export orders as CSV": "Экспортировать заказы в CSV",
    "orders.manual_order": "Заказ вручную",
    "Manual Order": "Заказ вручную",
    "orders.scan_order_reference": "Сканировать номер заказа",
    "Scan order reference": "Сканировать номер заказа",
    "orders.change_status_to": "Изменить статус на…",
    "Change status to…": "Изменить статус на…",
    "common.apply": "Применить",
    "Apply": "Применить",
    "common.clear": "Очистить",
    "Clear": "Очистить",
    "orders.pay": "Оплатить",
    "Pay": "Оплатить",
    "orders.clear_selection": "Снять выделение",
    "Clear selection": "Снять выделение",
    "orders.list": "Список",
    "orders.board": "Доска",
    "Board": "Доска",
    "orders.filter_orders": "Фильтровать заказы",
    "Filter orders": "Фильтровать заказы",
    "orders.start_date": "Дата начала",
    "Start Date": "Дата начала",
    "orders.end_date": "Дата окончания",
    "End Date": "Дата окончания",
    "orders.select_date": "Выберите дату",
    "Select Date": "Выберите дату",
    "orders.show_rows": "Показать строки",
    "Show rows": "Показать строки",
    "common.order_selected": "заказ выбран",
    "order selected": "заказ выбран",
    "common.orders_selected": "заказов выбрано",
    "orders selected": "заказов выбрано",
    "common.order_updated": "заказ обновлён",
    "order updated": "заказ обновлён",
    "common.orders_updated": "заказы обновлены",
    "orders updated": "заказы обновлены",
    "orders.order_archived_successfully": "Заказ успешно архивирован",
    "Order archived successfully": "Заказ успешно архивирован",
    "orders.failed_to_archive_order": "Не удалось архивировать заказ",
    "Failed to archive order": "Не удалось архивировать заказ",
    "orders.loading_order": "Загрузка заказа…",
    "Loading order…": "Загрузка заказа…",
    "orders.order_created_successfully": "Заказ успешно создан",
    "Order created successfully": "Заказ успешно создан",
    "orders.the_order_has_been_created_and_is_ready_to_review": "Заказ создан и готов к проверке.",
    "The order has been created and is ready to review.": "Заказ создан и готов к проверке.",
    "orders.order_reference": "Номер заказа",
    "Order reference": "Номер заказа",
    "common.created": "Создано",
    "Created": "Создано",
    "common.total": "Итого",
    "Total": "Итого",
    "common.items": "Товары",
    "orders.print_save_pdf": "Печать / Сохранить PDF",
    "Print / Save PDF": "Печать / Сохранить PDF",
    "orders.view_order_details": "Посмотреть сведения о заказе",
    "View order details": "Посмотреть сведения о заказе",
    "orders.create_another_order": "Создать ещё один заказ",
    "Create another order": "Создать ещё один заказ",
    "orders.confirmed": "Подтверждён",
    "Confirmed": "Подтверждён",
    "orders.in_progress": "Выполняется",
    "In progress": "Выполняется",
    "orders.customer_unreachable": "Не удалось связаться с клиентом",
    "Customer unreachable": "Не удалось связаться с клиентом",
    "orders.out_for_delivery": "Передан курьеру",
    "orders.returned": "Возвращён",
    "Returned": "Возвращён",
    "orders.return_confirmed": "Возврат подтверждён",
    "Return confirmed": "Возврат подтверждён",
    "orders.delivery_confirmed": "Доставка подтверждена",
    "Delivery confirmed": "Доставка подтверждена",
    "orders.return_initiated": "Возврат начат",
    "Return initiated": "Возврат начат",
    "orders.return_picked": "Возврат забран",
    "Return picked": "Возврат забран",
    "orders.return_disputed": "Возврат оспорен",
    "Return disputed": "Возврат оспорен",
    "orders.canceled_by_seller": "Отменено продавцом",
    "Canceled by seller": "Отменено продавцом",
    "orders.canceled_by_customer": "Отменено покупателем",
    "Canceled by customer": "Отменено покупателем",
    "orders.ready_for_pickup": "Готов к выдаче",
    "orders.arrived_at_customer_location": "Прибыл по адресу клиента",
    "orders.undelivered_returned": "Не доставлено — возвращено",
    "Undelivered - Returned": "Не доставлено — возвращено",
    "orders.undelivered_return_confirmed": "Возврат недоставленного заказа подтверждён",
    "Undelivered - Return confirmed": "Возврат недоставленного заказа подтверждён",
    "orders.disputed": "Оспаривается",
    "Disputed": "Оспаривается",
    "orders.completed": "Завершён",
    "orders.detail_legacy.order_number": "Номер заказа:",
    "Order Number:": "Номер заказа:",
    "orders.detail_legacy.order_date": "Дата заказа:",
    "Order Date:": "Дата заказа:",
    "orders.detail_legacy.buyer_details": "Данные покупателя:",
    "Buyer Details:": "Данные покупателя:",
    "orders.detail_legacy.delivery_address": "Адрес доставки:",
    "Delivery Address:": "Адрес доставки:",
    "orders.detail_legacy.pickup_address": "Адрес получения:",
    "Pickup Address:": "Адрес получения:",
    "orders.detail_legacy.total_amount": "Общая сумма:",
    "Total Amount:": "Общая сумма:",
    "orders.detail_legacy.amount_in_words": "Сумма прописью:",
    "Amount in Words:": "Сумма прописью:",
    "orders.detail_legacy.amount_words_only": "Только",
    "Only": "Только",
    "orders.detail_legacy.payout_date": "Дата выплаты:",
    "Payout Date:": "Дата выплаты:",
    "orders.detail_legacy.change": "Изменить",
    "orders.detail_legacy.select_date_time": "Выберите дату и время",
    "Select Date & Time": "Выберите дату и время",
    "orders.detail_legacy.change_payout_date_time": "Изменить дату и время выплаты",
    "Change Payout Date and Time": "Изменить дату и время выплаты",
    "orders.detail_legacy.update_payout": "Обновить",
    "orders.detail_legacy.update_status": "Обновить статус",
    "Update Status": "Обновить статус",
    "orders.detail_legacy.change_order_status": "Изменить статус заказа",
    "Change Order Status": "Изменить статус заказа",
    "orders.detail_legacy.column_description": "Описание",
    "Description": "Описание",
    "orders.detail_legacy.column_unit_price": "Цена за единицу",
    "Unit Price": "Цена за единицу",
    "orders.detail_legacy.column_discount": "Скидка",
    "Discount": "Скидка",
    "orders.detail_legacy.column_tax_rate": "Налоговая ставка",
    "Tax Rate": "Налоговая ставка",
    "orders.item": "Товар",
    "Item": "Товар",
    "orders.order_details": "Сведения о заказе",
    "Order Details": "Сведения о заказе",
    "orders.copy_order_reference": "Скопировать номер заказа",
    "Copy order reference": "Скопировать номер заказа",
    "orders.order_summary": "Сводка заказа",
    "Order Summary": "Сводка заказа",
    "orders.order_created": "Заказ создан",
    "Order created": "Заказ создан",
    "orders.order_time": "Время заказа",
    "Order time": "Время заказа",
    "orders.total_earnings": "Общий доход",
    "Total earnings": "Общий доход",
    "orders.total_price": "Общая стоимость",
    "Total price": "Общая стоимость",
    "orders.delivery_fee": "Стоимость доставки",
    "Delivery fee": "Стоимость доставки",
    "orders.sub_total": "Промежуточный итог",
    "Sub total": "Промежуточный итог",
    "orders.customer_information": "Данные клиента",
    "Customer Information": "Данные клиента",
    "common.customer_name": "Имя клиента",
    "Customer Name": "Имя клиента",
    "common.phone": "Телефон",
    "Phone": "Телефон",
    "common.email": "Электронная почта",
    "orders.seller_details": "Данные продавца",
    "Seller Details": "Данные продавца",
    "common.seller_name": "Имя продавца",
    "Seller Name": "Имя продавца",
    "common.mobile": "Мобильный телефон",
    "orders.generate": "Создать",
    "Generate": "Создать",
    "orders.cancel_order": "Отменить заказ",
    "Cancel Order": "Отменить заказ",
    "orders.mark_as_paid": "Отметить как оплаченный",
    "Mark as Paid": "Отметить как оплаченный",
    "orders.failed_to_mark_as_paid": "Не удалось отметить как оплаченный",
    "Failed to mark as paid": "Не удалось отметить как оплаченный",
    "orders.order_cancelled_successfully": "Заказ успешно отменён",
    "Order cancelled successfully": "Заказ успешно отменён",
    "orders.failed_to_cancel_order_by_admin": "Администратору не удалось отменить заказ",
    "Failed to cancel order by admin": "Администратору не удалось отменить заказ",
    "orders.no_transactions_found": "Транзакции не найдены",
    "No transactions found": "Транзакции не найдены",
    "orders.transaction_no": "Номер транзакции",
    "Transaction No": "Номер транзакции",
    "orders.entity": "Объект",
    "Entity": "Объект",
    "orders.transaction_type": "Тип транзакции",
    "Transaction Type": "Тип транзакции",
    "common.seller": "Продавец",
    "Seller": "Продавец",
    "common.customer": "Клиент",
    "Customer": "Клиент",
    "common.platform_owner": "Владелец платформы",
    "Platform Owner": "Владелец платформы",
    "orders.items_summary": "Сводка товаров",
    "Items Summary": "Сводка товаров",
    "orders.qty": "Кол-во",
    "orders.price": "Цена",
    "Price": "Цена",
    "orders.total_price_2": "Общая стоимость",
    "Total Price": "Общая стоимость",
    "orders.membership_purchase": "Покупка членства",
    "Membership purchase": "Покупка членства",
    "orders.member_id": "ID участника",
    "Member ID": "ID участника",
    "orders.period": "Период",
    "Period": "Период",
    "orders.start_date_2": "Дата начала",
    "Start date": "Дата начала",
    "common.next_renewal": "Следующее продление",
    "Next renewal": "Следующее продление",
    "common.expiry_date": "Срок действия до",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Этот заказ учитывается как взнос участника, а не как отправление.",
    "This order is managed as a membership contribution, not a shipment.": "Этот заказ учитывается как взнос участника, а не как отправление.",
    "orders.months": "месяцев",
    "months": "месяцев",
    "orders.days": "дней",
    "days": "дней",
    "orders.address": "Адрес",
    "Address": "Адрес",
    "orders.address_1": "Адрес 1",
    "Address 1": "Адрес 1",
    "orders.address_2": "Адрес 2",
    "Address 2": "Адрес 2",
    "orders.zip_code": "Почтовый индекс",
    "Zip code": "Почтовый индекс",
    "orders.full_address": "Полный адрес",
    "Full Address": "Полный адрес",
    "orders.formatted_address": "Отформатированный адрес",
    "Formatted Address": "Отформатированный адрес",
    "orders.phone_number": "Номер телефона",
    "Phone Number": "Номер телефона",
    "orders.address_not_found": "Адрес не найден",
    "Address not found": "Адрес не найден",
    "orders.address_not_applicable": "Адрес не применим",
    "Address not applicable": "Адрес не применим",
    "orders.address_is_not_available": "Адрес недоступен",
    "Address is not available": "Адрес недоступен",
    "orders.add_pickup_address": "Добавить адрес получения",
    "Add Pickup Address": "Добавить адрес получения",
    "orders.edit_pickup_address": "Изменить адрес получения",
    "Edit Pickup Address": "Изменить адрес получения",
    "orders.discard_and_close": "Отменить изменения и закрыть",
    "Discard and close": "Отменить изменения и закрыть",
    "orders.state": "Регион",
    "State": "Регион",
    "common.country": "Страна",
    "Country": "Страна",
    "orders.sales_payout": "Выплата продавцу",
    "Sales Payout": "Выплата продавцу",
    "orders.sales_no_payout": "Продажи (без выплаты)",
    "Sales (No Payout)": "Продажи (без выплаты)",
    "orders.sales_payout_reversal": "Отмена выплаты по продажам",
    "Sales Payout Reversal": "Отмена выплаты по продажам",
    "orders.sales_no_payout_reversal": "Отмена продаж без выплаты",
    "Sales no payout reversal": "Отмена продаж без выплаты",
    "orders.seller_commission": "Комиссия продавца",
    "Seller Commission": "Комиссия продавца",
    "orders.seller_commission_reversal": "Возврат комиссии продавца",
    "Seller Commission Reversal": "Возврат комиссии продавца",
    "orders.seller_transfer": "Перевод продавцу",
    "Seller Transfer": "Перевод продавцу",
    "orders.seller_transfer_reversal": "Отмена перевода продавцу",
    "Seller Transfer Reversal": "Отмена перевода продавцу",
    "orders.seller_payout": "Выплата продавцу",
    "Seller Payout": "Выплата продавцу",
    "orders.seller_subscription": "Подписка продавца",
    "Seller Subscription": "Подписка продавца",
    "orders.seller_payment_processing_fee": "Комиссия за обработку платежа продавца",
    "Seller Payment processing fee": "Комиссия за обработку платежа продавца",
    "orders.seller_payment_processing_fee_reversal": "Возврат комиссии за обработку платежа продавца",
    "Seller Payment processing fee reversal": "Возврат комиссии за обработку платежа продавца",
    "orders.sub_total_2": "Промежуточный итог",
    "Sub Total": "Промежуточный итог",
    "orders.customer_commission": "Комиссия клиента",
    "Customer Commission": "Комиссия клиента",
    "orders.tax": "Налог",
    "Tax": "Налог",
    "orders.shipping_charge": "Стоимость доставки",
    "Shipping Charge": "Стоимость доставки",
    "orders.refund": "Возврат средств",
    "Refund": "Возврат средств",
    "orders.special_fee": "Специальный сбор",
    "Special Fee": "Специальный сбор",
    "orders.coupon": "Купон",
    "Coupon": "Купон",
    "orders.shipment": "Отправление",
    "Shipment": "Отправление",
    "orders.fulfilled_by_platform": "Обслуживается платформой",
    "Fulfilled by platform": "Обслуживается платформой",
    "orders.fulfilled_by": "Исполнитель:",
    "Fulfilled by": "Исполнитель:",
    "orders.fulfilled_by_seller": "Обслуживается продавцом",
    "Fulfilled by seller": "Обслуживается продавцом",
    "orders.on_seller_protection_policy": "По программе защиты продавца",
    "On Seller Protection Policy": "По программе защиты продавца",
    "orders.product_image": "Изображение товара",
    "Product image": "Изображение товара",
    "orders.status_changed_successfully": "Статус успешно изменён",
    "Status changed successfully": "Статус успешно изменён",
    "orders.pickup_address_not_available_please_add_pickup_address": "Адрес получения недоступен. Добавьте адрес получения.",
    "Pickup Address not available. Please Add Pickup Address": "Адрес получения недоступен. Добавьте адрес получения.",
    "orders.failed_to_save_pickup_address_please_try_again": "Не удалось сохранить адрес получения. Повторите попытку.",
    "Failed to save pickup address. Please try again.": "Не удалось сохранить адрес получения. Повторите попытку.",
    "orders.change_shipment_status": "Изменить статус отправления",
    "Change shipment status": "Изменить статус отправления",
    "orders.not_available": "Недоступно",
    "Not available": "Недоступно",
    "orders.shipment_created": "Отправление создано",
    "Shipment created": "Отправление создано",
    "orders.shipment_in_progress": "Отправление в пути",
    "Shipment in progress": "Отправление в пути",
    "orders.ship": "Отправить",
    "orders.undelivered_return": "Возврат недоставленного заказа",
    "orders.shipment_deliver": "Доставить отправление",
    "Shipment deliver": "Доставить отправление",
    "orders.shipment_delivery_confirm": "Подтвердить доставку отправления",
    "Shipment delivery confirm": "Подтвердить доставку отправления",
    "orders.return_initiate": "Начать возврат",
    "Return initiate": "Начать возврат",
    "orders.return_for_pickup": "Возврат готов к получению",
    "Return for pickup": "Возврат готов к получению",
    "orders.shipment_return_confirm": "Подтвердить возврат отправления",
    "Shipment return confirm": "Подтвердить возврат отправления",
    "orders.cancel_by_seller": "Отменить продавцом",
    "Cancel by seller": "Отменить продавцом",
    "orders.cancel_by_customer": "Отменить покупателем",
    "Cancel by customer": "Отменить покупателем",
    "orders.arrive_at_customer_location": "Прибыть по адресу клиента",
    "Arrive at customer location": "Прибыть по адресу клиента",
    "orders.shipment_delivered": "Отправление доставлено",
    "Shipment delivered": "Отправление доставлено",
    "orders.shipment_delivery_confirmed": "Доставка отправления подтверждена",
    "Shipment delivery confirmed": "Доставка отправления подтверждена",
    "orders.returned_for_pickup": "Возврат готов к получению",
    "orders.shipment_return_confirmed": "Возврат отправления подтверждён",
    "orders.cancelled_by_seller": "Отменено продавцом",
    "Cancelled by seller": "Отменено продавцом",
    "common.cancelled_by_admin": "Отменено администратором",
    "Cancelled by admin": "Отменено администратором",
    "orders.invoice": "Счёт",
    "Invoice": "Счёт",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Выберите файл допустимого формата (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Выберите файл допустимого формата (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "Размер файла должен быть меньше 5 МБ",
    "File size must be less than 5MB": "Размер файла должен быть меньше 5 МБ",
    "orders.please_upload_a_file_first": "Сначала загрузите файл",
    "Please upload a file first": "Сначала загрузите файл",
    "orders.invoice_uploaded_successfully": "Счёт успешно загружен!",
    "Invoice uploaded successfully!": "Счёт успешно загружен!",
    "orders.failed_to_upload_invoice_please_try_again": "Не удалось загрузить счёт. Повторите попытку.",
    "Failed to upload invoice. Please try again.": "Не удалось загрузить счёт. Повторите попытку.",
    "orders.upload_invoice": "Загрузить счёт",
    "Upload Invoice": "Загрузить счёт",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Поддерживаемые форматы: PDF, JPG, PNG, DOC (макс. 5 МБ)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Поддерживаемые форматы: PDF, JPG, PNG, DOC (макс. 5 МБ)",
    "orders.uploading": "Загрузка…",
    "Uploading...": "Загрузка…",
    "orders.choose_file": "Выбрать файл",
    "Choose File": "Выбрать файл",
    "common.download": "Скачать",
    "Download": "Скачать",
    "common.remove": "Удалить",
    "orders.upload_new_file": "Загрузить новый файл",
    "Upload New File": "Загрузить новый файл",
    "orders.saving": "Сохранение…",
    "Saving...": "Сохранение…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Удаление заказа сразу скроет его в интерфейсах продавца и покупателя. После удаления обновлять статус заказа будет нельзя, а сам заказ не будет учитываться в метриках и отчётах. Продолжить?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Удаление заказа сразу скроет его в интерфейсах продавца и покупателя. После удаления обновлять статус заказа будет нельзя, а сам заказ не будет учитываться в метриках и отчётах. Продолжить?",
    "common.showing": "Показано",
    "Showing": "Показано",
    "common.of": "из",
    "of": "из",
    "common.all": "Все",
    "All": "Все",
    "common.active": "Активен",
    "common.inactive": "Неактивен",
    "common.enabled": "Включено",
    "Enabled": "Включено",
    "common.disabled": "Отключено",
    "Disabled": "Отключено",
    "common.success": "Успешно",
    "Success": "Успешно",
    "common.error": "Ошибка",
    "Error": "Ошибка",
    "common.warning": "Предупреждение",
    "Warning": "Предупреждение",
    "common.required": "Обязательно",
    "Required": "Обязательно",
    "users.title": "Пользователи",
    "users.import": "Импорт",
    "Import": "Импорт",
    "users.import_users": "Импортировать пользователей",
    "Import users": "Импортировать пользователей",
    "users.smart_upload_users": "Умная загрузка пользователей",
    "Smart Upload Users": "Умная загрузка пользователей",
    "users.smart_upload_beta": "Умная загрузка пользователей (бета)",
    "Smart upload users (Beta)": "Умная загрузка пользователей (бета)",
    "users.export": "Экспорт",
    "Export": "Экспорт",
    "users.export_users": "Экспортировать пользователей",
    "Export users": "Экспортировать пользователей",
    "users.search_users": "Поиск пользователей",
    "Search users": "Поиск пользователей",
    "users.verified": "Подтверждён",
    "Verified": "Подтверждён",
    "users.not_verified": "Не подтверждён",
    "Non Verified": "Не подтверждён",
    "users.block": "Заблокировать",
    "Block": "Заблокировать",
    "users.unblock": "Разблокировать",
    "Unblock": "Разблокировать",
    "users.confirm_block": "Заблокировать этого пользователя?",
    "Do you want to block this user?": "Заблокировать этого пользователя?",
    "users.confirm_unblock": "Разблокировать этого пользователя?",
    "Do you want to unblock this user?": "Разблокировать этого пользователя?",
    "users.import_export": "Импорт и экспорт пользователей",
    "User import and export": "Импорт и экспорт пользователей",
    "users.user_id": "ID пользователя",
    "User ID": "ID пользователя",
    "users.first_name": "Имя",
    "First Name": "Имя",
    "users.last_name": "Фамилия",
    "Last Name": "Фамилия",
    "users.email": "Электронная почта",
    "users.phone_number": "Номер телефона",
    "users.country": "Страна",
    "users.profile": "Профиль",
    "Profile": "Профиль",
    "users.email_verified": "Электронная почта подтверждена",
    "Email Verified": "Электронная почта подтверждена",
    "users.blocked": "Заблокирован",
    "Blocked": "Заблокирован",
    "users.action": "Действие",
    "users.join_date": "Дата регистрации",
    "Join Date": "Дата регистрации",
    "users.last_login": "Последний вход",
    "Last Login": "Последний вход",
    "users.customer_type": "Тип клиента",
    "Customer Type": "Тип клиента",
    "common.and": "и",
    "and": "и",
    "users.import_failed": "Не удалось импортировать пользователей.",
    "User import failed.": "Не удалось импортировать пользователей.",
    "users.smart_upload.paid_title": "Умная загрузка пользователей — платная функция",
    "Smart user upload is a paid feature": "Умная загрузка пользователей — платная функция",
    "users.smart_upload.paid_description": "Перейдите на тариф Starter или Go, чтобы загружать пользователей из CSV-файла.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Перейдите на тариф Starter или Go, чтобы загружать пользователей из CSV-файла.",
    "users.smart_upload.view_plans": "Посмотреть тарифы",
    "View plans": "Посмотреть тарифы",
    "users.smart_upload.csv_needs_user": "В CSV должны быть строка заголовков и хотя бы один пользователь.",
    "The CSV must contain a header row and at least one user.": "В CSV должны быть строка заголовков и хотя бы один пользователь.",
    "users.smart_upload.unique_headers": "У каждого столбца пользователя должен быть уникальный непустой заголовок.",
    "Every user column needs a unique, non-empty header.": "У каждого столбца пользователя должен быть уникальный непустой заголовок.",
    "users.smart_upload.csv_read_error": "Не удалось прочитать этот CSV-файл.",
    "Unable to read this CSV.": "Не удалось прочитать этот CSV-файл.",
    "users.smart_upload.map_required": "Сопоставьте поля {fields}, чтобы продолжить.",
    "Map {fields} before continuing.": "Сопоставьте поля {fields}, чтобы продолжить.",
    "users.smart_upload.map_contact": "Сопоставьте столбец Email или Phone. В каждой строке должен быть хотя бы один способ связи.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Сопоставьте столбец Email или Phone. В каждой строке должен быть хотя бы один способ связи.",
    "users.smart_upload.invalid_row": "В строке {row} отсутствует обязательное имя или контактная информация.",
    "Row {row} is missing a required name or contact value.": "В строке {row} отсутствует обязательное имя или контактная информация.",
    "users.smart_upload.attribute_name_required": "Введите название атрибута для «{header}».",
    "Enter an attribute name for “{header}”.": "Введите название атрибута для «{header}».",
    "users.smart_upload.attribute_create_error": "Не удалось создать атрибут «{name}».",
    "Could not create the “{name}” attribute.": "Не удалось создать атрибут «{name}».",
    "users.smart_upload.attribute_missing": "Атрибут, сопоставленный со столбцом «{header}», больше недоступен.",
    "users.smart_upload.prepare_error": "Не удалось подготовить файл импорта.",
    "users.smart_upload.upload_error": "Не удалось загрузить файл импорта.",
    "users.smart_upload.all_duplicates": "Все строки в этом файле дублируют друг друга.",
    "Every row is a duplicate of another row in this file.": "Все строки в этом файле дублируют друг друга.",
    "users.smart_upload.source_attribute_error": "Не удалось создать атрибут contact_source.",
    "Could not create the contact_source attribute.": "Не удалось создать атрибут contact_source.",
    "users.smart_upload.duplicates_skipped": "Пропустить повторяющиеся строки: {count}.",
    "Duplicate rows to skip: {count}.": "Пропустить повторяющиеся строки: {count}.",
    "users.smart_upload.preparing_attributes": "Подготовка атрибутов",
    "Preparing attributes": "Подготовка атрибутов",
    "users.smart_upload.checking_users": "Проверка существующих пользователей",
    "Checking existing users": "Проверка существующих пользователей",
    "users.smart_upload.uploading_file": "Загрузка файла импорта",
    "Uploading import file": "Загрузка файла импорта",
    "users.smart_upload.importing_users": "Tradly импортирует пользователей",
    "Tradly is importing users": "Tradly импортирует пользователей",
    "users.smart_upload.import_stopped": "Импорт остановлен",
    "Import stopped": "Импорт остановлен",
    "users.smart_upload.title": "Умная загрузка пользователей",
    "Smart user upload": "Умная загрузка пользователей",
    "users.smart_upload.beta": "(Бета)",
    "(Beta)": "(Бета)",
    "users.smart_upload.start_over": "Начать заново",
    "Start over": "Начать заново",
    "users.smart_upload.description": "Загрузите контакты, сопоставьте столбцы с атрибутами пользователей и укажите, являются ли они исходящими контактами или зарегистрированными пользователями.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Загрузите контакты, сопоставьте столбцы с атрибутами пользователей и укажите, являются ли они исходящими контактами или зарегистрированными пользователями.",
    "users.smart_upload.step_upload": "Загрузка",
    "users.smart_upload.step_match": "Сопоставление столбцов",
    "Match columns": "Сопоставление столбцов",
    "users.smart_upload.step_review": "Проверка",
    "users.smart_upload.step_import": "Импорт",
    "users.smart_upload.choose_csv": "Выберите CSV-файл",
    "users.smart_upload.required_fields": "Обязательны имя, фамилия и электронная почта или телефон. Пароли создаются автоматически.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Обязательны имя, фамилия и электронная почта или телефон. Пароли создаются автоматически.",
    "users.smart_upload.select_csv": "Выбрать CSV-файл",
    "users.smart_upload.match_columns": "Сопоставить столбцы пользователей",
    "Match user columns": "Сопоставить столбцы пользователей",
    "users.smart_upload.first_name": "Имя",
    "First name": "Имя",
    "users.smart_upload.last_name": "Фамилия",
    "Last name": "Фамилия",
    "users.smart_upload.email": "Электронная почта",
    "users.smart_upload.phone": "Телефон",
    "users.smart_upload.username": "Имя пользователя",
    "Username": "Имя пользователя",
    "users.smart_upload.do_not_import": "Не импортировать",
    "Do not import": "Не импортировать",
    "users.smart_upload.additional_attributes": "Дополнительные атрибуты пользователя",
    "Additional user attributes": "Дополнительные атрибуты пользователя",
    "users.smart_upload.ignore_column": "Игнорировать этот столбец",
    "Ignore this column": "Игнорировать этот столбец",
    "users.smart_upload.create_attribute": "Создать атрибут пользователя",
    "Create a new user attribute": "Создать атрибут пользователя",
    "users.smart_upload.attribute_name": "Название атрибута",
    "Attribute name": "Название атрибута",
    "users.smart_upload.type_text": "Текст",
    "Text": "Текст",
    "users.smart_upload.type_long_text": "Длинный текст",
    "Long text": "Длинный текст",
    "users.smart_upload.type_number": "Число",
    "Number": "Число",
    "users.smart_upload.type_single_select": "Одиночный выбор",
    "Single select": "Одиночный выбор",
    "users.smart_upload.type_multi_select": "Множественный выбор",
    "Multi select": "Множественный выбор",
    "users.smart_upload.review_import": "Проверить импорт",
    "Review import": "Проверить импорт",
    "users.smart_upload.review_description": "К импорту: {count}. API может отклонить существующих пользователей Tradly; повторный импорт частичных данных может создать дубликаты успешно загруженных строк.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "К импорту: {count}. API может отклонить существующих пользователей Tradly; повторный импорт частичных данных может создать дубликаты успешно загруженных строк.",
    "users.smart_upload.contact_classification": "Классификация контактов",
    "Contact classification": "Классификация контактов",
    "users.smart_upload.outbound": "Исходящие (нет согласия)",
    "Outbound (not opted in)": "Исходящие (нет согласия)",
    "users.smart_upload.signed_up": "Зарегистрирован (дал согласие)",
    "Signed-up (opted in)": "Зарегистрирован (дал согласие)",
    "users.smart_upload.contact_source_help": "Значение сохраняется в атрибуте contact_source. Встроенный тип пользователя Tradly остаётся customer.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Значение сохраняется в атрибуте contact_source. Встроенный тип пользователя Tradly остаётся customer.",
    "users.smart_upload.import_complete": "Импорт пользователей завершён",
    "User import complete": "Импорт пользователей завершён",
    "users.smart_upload.imported_summary": "Импортировано пользователей: {imported} из {total}.",
    "{imported} of {total} users imported.": "Импортировано пользователей: {imported} из {total}.",
    "users.smart_upload.selected_file": "Выбрано: {name}",
    "Selected: {name}": "Выбрано: {name}",
    "users.smart_upload.review_action": "Проверить",
    "users.smart_upload.importing_action": "Импорт…",
    "Importing…": "Импорт…",
    "users.smart_upload.import_users_action": "Импортировать пользователей",
    "users.import.uploading": "Загрузка…",
    "Uploading…": "Загрузка…",
    "users.import.please_wait": "Подождите…",
    "Please wait…": "Подождите…",
    "users.import.error_prefix": "Ошибка",
    "users.import.select_file_error": "Выберите файл",
    "Please select a file": "Выберите файл",
    "users.import.download": "Скачать",
    "users.import.file_label": "Файл:",
    "File:": "Файл:",
    "users.import.select_file": "Выбрать файл",
    "users.import.upload": "Загрузить",
    "users.create.button": "Создать пользователя",
    "Create User": "Создать пользователя",
    "users.create.title": "Создать пользователя",
    "Create New User": "Создать пользователя",
    "users.create.please_wait": "Подождите…",
    "users.create.email": "Электронная почта",
    "users.create.first_name": "Имя",
    "users.create.last_name": "Фамилия",
    "users.create.email_required": "Укажите адрес электронной почты",
    "Email is required": "Укажите адрес электронной почты",
    "users.create.first_name_required": "Укажите имя",
    "First Name is required": "Укажите имя",
    "users.create.last_name_required": "Укажите фамилию",
    "Last Name is required": "Укажите фамилию",
    "users.create.session_expired": "Сеанс администратора истёк. Войдите снова, чтобы создать пользователя.",
    "Your admin session has expired. Please sign in again before creating a user.": "Сеанс администратора истёк. Войдите снова, чтобы создать пользователя.",
    "users.create.unable_to_create": "Не удалось создать пользователя.",
    "Unable to create this user.": "Не удалось создать пользователя.",
    "users.create.success": "Пользователь успешно создан",
    "User created successfully": "Пользователь успешно создан",
    "users.create.failed": "Не удалось создать пользователя. Повторите попытку.",
    "User creation failed. Please try again.": "Не удалось создать пользователя. Повторите попытку.",
    "common.feature_flow.eyebrow": "КАК ЭТО РАБОТАЕТ",
    "SEE HOW IT WORKS": "КАК ЭТО РАБОТАЕТ",
    "common.feature_flow.open_guide": "Открыть инструкцию",
    "Open flow guide": "Открыть инструкцию",
    "common.feature_flow.close_guide": "Закрыть инструкцию раздела",
    "Close section guide": "Закрыть инструкцию раздела",
    "common.feature_flow.section_guide": "Инструкция по разделу",
    "Section guide": "Инструкция по разделу",
    "users.flow.title": "Всё необходимое для управления пользователями",
    "Everything you need to manage your users": "Всё необходимое для управления пользователями",
    "users.flow.description": "Создавайте профили пользователей, настраивайте их данные и изучайте отзывы клиентов в одном месте.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Создавайте профили пользователей, настраивайте их данные и изучайте отзывы клиентов в одном месте.",
    "users.flow.lane_title": "Управление пользователями",
    "User management": "Управление пользователями",
    "users.flow.badge": "Основные инструменты",
    "Core tools": "Основные инструменты",
    "users.flow.attributes": "Атрибуты",
    "Attributes": "Атрибуты",
    "users.flow.reviews": "Отзывы",
    "Reviews": "Отзывы",
    "users.flow.lane_description": "Управляйте людьми, добавляйте нужные поля профиля и изучайте их опыт.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Управляйте людьми, добавляйте нужные поля профиля и изучайте их опыт.",
    "users.flow.primary_action": "Добавить первого пользователя",
    "Add your first user": "Добавить первого пользователя",
    "users.tooltip.title": "Каждый человек — отдельный пользователь",
    "Every individual is a unique user": "Каждый человек — отдельный пользователь",
    "users.tooltip.description": "Представьте на минуту, что вы владеете торговым центром.\n\nКаждый посетитель магазина считается пользователем.\n\nКаждый продавец, работающий в магазине, тоже считается пользователем.\n\nВ Tradly все участники — продавцы и покупатели — называются «Пользователями», а их уникальные данные хранятся в разделе пользователей. Здесь можно найти сведения об их покупках и принадлежащих им аккаунтах.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Представьте на минуту, что вы владеете торговым центром.\n\nКаждый посетитель магазина считается пользователем.\n\nКаждый продавец, работающий в магазине, тоже считается пользователем.\n\nВ Tradly все участники — продавцы и покупатели — называются «Пользователями», а их уникальные данные хранятся в разделе пользователей. Здесь можно найти сведения об их покупках и принадлежащих им аккаунтах.",
    "workspace.loading": "Çalışma alanı ayarları yükleniyor…",
    "Loading workspace settings…": "Çalışma alanı ayarları yükleniyor…",
    "workspace.kicker": "ÇALIŞMA ALANI",
    "WORKSPACE": "ÇALIŞMA ALANI",
    "workspace.fallback_name": "Çalışma alanı",
    "workspace.members.title": "Ekip üyesi davet et",
    "Invite Team Member": "Ekip üyesi davet et",
    "workspace.members.description": "Ekip arkadaşlarınızı ekleyin ve herkese yalnızca ihtiyaç duyduğu erişimi verin.",
    "Add teammates and give each person only the access they need.": "Ekip arkadaşlarınızı ekleyin ve herkese yalnızca ihtiyaç duyduğu erişimi verin.",
    "workspace.members.enter_name_email": "Üye adı ve e-posta adresi girin.",
    "Enter a member name and email address.": "Üye adı ve e-posta adresi girin.",
    "workspace.members.invitation_sent": "Davet gönderildi.",
    "Invitation sent.": "Davet gönderildi.",
    "workspace.members.confirm_remove": "{name} adlı kişiyi bu çalışma alanından kaldırmak istiyor musunuz?",
    "Remove {name} from this workspace?": "{name} adlı kişiyi bu çalışma alanından kaldırmak istiyor musunuz?",
    "workspace.members.removed": "Üye ekipten kaldırıldı.",
    "Team member removed.": "Üye ekipten kaldırıldı.",
    "workspace.members.roles_saved": "Üye rolleri kaydedildi.",
    "Member roles saved.": "Üye rolleri kaydedildi.",
    "workspace.members.read": "Oku",
    "workspace.members.write": "Yaz",
    "workspace.members.delete": "Sil",
    "workspace.members.select_all_permission": "{group} içindeki tüm {permission} izinlerini seçin",
    "Select all {permission} in {group}": "{group} içindeki tüm {permission} izinlerini seçin",
    "workspace.members.member_name": "Üye adı",
    "Member Name": "Üye adı",
    "workspace.members.email_address": "E-posta adresi",
    "Email Address": "E-posta adresi",
    "workspace.members.sending": "Gönderiliyor…",
    "workspace.members.send_invitation": "Davet gönder",
    "Send invitation": "Davet gönder",
    "workspace.members.team_members": "Ekip üyeleri",
    "Team members": "Ekip üyeleri",
    "workspace.members.search_members": "Üyelerde ara",
    "Search members": "Üyelerde ara",
    "workspace.members.search": "Ara",
    "workspace.members.member": "Üye",
    "Member": "Üye",
    "workspace.members.email": "E-posta",
    "workspace.members.status": "Durum",
    "workspace.members.actions": "İşlemler",
    "workspace.members.unnamed": "Adsız üye",
    "Unnamed member": "Adsız üye",
    "workspace.members.roles": "Roller",
    "Roles": "Roller",
    "workspace.members.empty": "Ekip üyesi bulunamadı.",
    "No team members found.": "Ekip üyesi bulunamadı.",
    "workspace.members.page_of": "{page} / {pages} sayfa",
    "Page {page} of {pages}": "{page} / {pages} sayfa",
    "workspace.members.assign_roles": "Rol ata",
    "Assign roles": "Rol ata",
    "workspace.members.save_roles": "Rolleri kaydet",
    "Save roles": "Rolleri kaydet",
    "workspace.members.saving": "Kaydediliyor…",
    "workspace.error.generic": "Bir hata oluştu. Lütfen tekrar deneyin.",
    "Something went wrong. Please try again.": "Bir hata oluştu. Lütfen tekrar deneyin.",
    "workspace.billing.view_label": "Çalışma alanı faturalandırma görünümü",
    "Billing workspace view": "Çalışma alanı faturalandırma görünümü",
    "workspace.billing.tab_usage": "Kullanım",
    "workspace.billing.tab_plans": "Planlar",
    "workspace.billing.tab_invoices": "Оплаченные счета",
    "Paid invoices": "Оплаченные счета",
    "workspace.billing.tab_account": "Аккаунт",
    "workspace.account.title": "Настройки бизнеса",
    "Business Settings": "Настройки бизнеса",
    "workspace.account.description": "Управляйте профилем компании, подключёнными продуктами и конфиденциальностью аккаунта.",
    "Manage your business profile, enabled products, and account privacy.": "Управляйте профилем компании, подключёнными продуктами и конфиденциальностью аккаунта.",
    "workspace.account.profile_updated": "Профиль компании обновлён.",
    "Business profile updated.": "Профиль компании обновлён.",
    "workspace.account.logo_updated": "Логотип обновлён.",
    "Logo updated.": "Логотип обновлён.",
    "workspace.account.logo_upload_error": "Не удалось загрузить логотип.",
    "Unable to upload logo.": "Не удалось загрузить логотип.",
    "workspace.account.confirm_delete": "Удалить этот аккаунт Tradly навсегда? Это действие нельзя отменить.",
    "Delete this Tradly account permanently? This cannot be undone.": "Удалить этот аккаунт Tradly навсегда? Это действие нельзя отменить.",
    "workspace.account.business_profile": "Профиль компании",
    "Business Profile": "Профиль компании",
    "workspace.account.logo": "Логотип",
    "Logo": "Логотип",
    "workspace.account.logo_alt": "Логотип компании",
    "Business logo": "Логотип компании",
    "workspace.account.add_photo": "Добавить фото",
    "Add photo": "Добавить фото",
    "workspace.account.logo_formats": "PNG, JPG, SVG или ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG или ICO",
    "workspace.account.business_name": "Название компании",
    "Business Name": "Название компании",
    "workspace.account.contact_name": "Контактное лицо компании",
    "Business Contact Name": "Контактное лицо компании",
    "workspace.account.business_address": "Адрес компании",
    "Business Address": "Адрес компании",
    "workspace.account.products_of_interest": "Интересующие продукты",
    "Products of Interest": "Интересующие продукты",
    "workspace.account.marketplace": "Маркетплейс",
    "workspace.account.single_store": "Интернет-магазин",
    "Single Store Commerce": "Интернет-магазин",
    "workspace.account.alacarte_products": "Отдельные продукты",
    "À la carte Products": "Отдельные продукты",
    "workspace.account.alacarte_description": "Отдельные продукты, подключённые для этой рабочей области, настраиваются в разделе «Тарифы и оплата».",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Отдельные продукты, подключённые для этой рабочей области, настраиваются в разделе «Тарифы и оплата».",
    "workspace.account.manage_alacarte": "Управлять отдельными продуктами",
    "Manage à la carte products": "Управлять отдельными продуктами",
    "workspace.account.delete_irreversible": "Удаление аккаунта: отменить нельзя",
    "Delete your Account: Irreversible": "Удаление аккаунта: отменить нельзя",
    "workspace.account.delete_description": "Это действие навсегда удалит клиента Tradly и все связанные данные.",
    "This permanently deletes the Tradly tenant and all associated data.": "Это действие навсегда удалит клиента Tradly и все связанные данные.",
    "workspace.account.deleting": "Удаление…",
    "Deleting…": "Удаление…",
    "workspace.account.delete_button": "Удалить аккаунт Tradly",
    "Delete Account With Tradly": "Удалить аккаунт Tradly",
    "workspace.privacy.title": "Конфиденциальность и обработчики данных",
    "Privacy & Data Processors": "Конфиденциальность и обработчики данных",
    "workspace.privacy.description": "Узнайте, какие обработчики помогают обеспечивать работу Tradly и как хранятся данные после запроса на удаление.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Узнайте, какие обработчики помогают обеспечивать работу Tradly и как хранятся данные после запроса на удаление.",
    "workspace.privacy.processor_retention": "Для работы сервиса, улучшения качества продукта, обработки платежей и обеспечения надёжности мы используем перечисленные ниже сервисы. Срок хранения применяется только после запроса пользователя на удаление аккаунта. Данные пользователей платформы Tradly хранятся примерно 90–180 дней в зависимости от операционных требований и требований соответствия.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Для работы сервиса, улучшения качества продукта, обработки платежей и обеспечения надёжности мы используем перечисленные ниже сервисы. Срок хранения применяется только после запроса пользователя на удаление аккаунта. Данные пользователей платформы Tradly хранятся примерно 90–180 дней в зависимости от операционных требований и требований соответствия.",
    "workspace.privacy.read_more": "Подробнее.",
    "Read more.": "Подробнее.",
    "workspace.privacy.tool": "Инструмент",
    "Tool": "Инструмент",
    "workspace.privacy.purpose": "Назначение",
    "Purpose": "Назначение",
    "workspace.privacy.data_category": "Категория данных",
    "Data Category": "Категория данных",
    "workspace.privacy.deletion_requests": "Запросы на удаление аккаунта и данных",
    "Account deletion and data requests": "Запросы на удаление аккаунта и данных",
    "workspace.privacy.deletion_description": "Чтобы запросить удаление аккаунта или данных из инструмента для работы с клиентами, обратитесь к администратору рабочей области или в службу поддержки. Перед публикацией этих действий требуется подтверждение на сервере.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Чтобы запросить удаление аккаунта или данных из инструмента для работы с клиентами, обратитесь к администратору рабочей области или в службу поддержки. Перед публикацией этих действий требуется подтверждение на сервере.",
    "workspace.privacy.open_account": "Открыть настройки аккаунта",
    "Open account settings": "Открыть настройки аккаунта",
    "workspace.privacy.core_operations": "Основные операции продукта",
    "Core product operations": "Основные операции продукта",
    "workspace.privacy.user_data_retention": "Данные пользователя (хранение: 90–180 дней)",
    "User data (retention: 90–180 days)": "Данные пользователя (хранение: 90–180 дней)",
    "workspace.privacy.crm_support_lifecycle": "CRM, поддержка, коммуникации на протяжении жизненного цикла клиента",
    "CRM, support, lifecycle communication": "CRM, поддержка, коммуникации на протяжении жизненного цикла клиента",
    "workspace.privacy.personal_data": "Персональные данные",
    "Personal data": "Персональные данные",
    "workspace.privacy.product_analytics": "Продуктовая аналитика и воронки вовлечённости",
    "Product analytics and engagement funnels": "Продуктовая аналитика и воронки вовлечённости",
    "workspace.privacy.usage_events": "Аналитика использования и событий",
    "Usage and event analytics": "Аналитика использования и событий",
    "workspace.privacy.billing_payments": "Выставление счетов и обработка платежей",
    "Billing and payment processing": "Выставление счетов и обработка платежей",
    "workspace.privacy.billing_data": "Данные о выставлении счетов",
    "Billing data": "Данные о выставлении счетов",
    "workspace.privacy.traffic_analytics": "Аналитика трафика и поведения",
    "Traffic and behavior analytics": "Аналитика трафика и поведения",
    "workspace.privacy.usage_analytics": "Аналитика использования",
    "Usage analytics": "Аналитика использования",
    "workspace.privacy.session_diagnostics": "Анализ сеансов и диагностика неработающих кнопок",
    "Session insights and broken-button diagnostics": "Анализ сеансов и диагностика неработающих кнопок",
    "workspace.privacy.ux_telemetry": "Телеметрия UX и сеансов",
    "UX/session telemetry": "Телеметрия UX и сеансов",
    "workspace.privacy.error_monitoring": "Мониторинг ошибок кода и стабильности",
    "Code error and stability monitoring": "Мониторинг ошибок кода и стабильности",
    "workspace.privacy.error_logs": "Журналы ошибок и диагностика",
    "Error logs and diagnostics": "Журналы ошибок и диагностика",
    "workspace.privacy.email_delivery": "Доставка транзакционных писем",
    "Transactional email delivery": "Доставка транзакционных писем",
    "workspace.privacy.email_metadata": "Метаданные электронной почты",
    "Email metadata": "Метаданные электронной почты",
    "workspace.privacy.hosting_infrastructure": "Хостинг и инфраструктура",
    "Hosting and infrastructure": "Хостинг и инфраструктура",
    "workspace.privacy.infrastructure_logs": "Журналы инфраструктуры и сервисов",
    "Infrastructure and service logs": "Журналы инфраструктуры и сервисов",
    "workspace.domain.title": "Домены",
    "Domains": "Домены",
    "workspace.domain.description": "Подключите собственный домен вместо стандартного домена Tradly.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Подключите собственный домен вместо стандартного домена Tradly.",
    "workspace.domain.invalid": "Введите корректный домен, например example.com.",
    "Enter a valid domain, such as example.com.": "Введите корректный домен, например example.com.",
    "workspace.domain.reserved": "tradly.co зарезервирован для размещённых доменов рабочих областей.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co зарезервирован для размещённых доменов рабочих областей.",
    "workspace.domain.missing_primary": "Основной домен рабочей области недоступен.",
    "No primary workspace domain is available.": "Основной домен рабочей области недоступен.",
    "workspace.domain.saved": "Пользовательский домен сохранён. Обновите записи DNS, затем проверьте его статус.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Пользовательский домен сохранён. Обновите записи DNS, затем проверьте его статус.",
    "workspace.domain.reset_success": "Домен сброшен до размещённого Tradly URL.",
    "Domain reset to the Tradly-hosted URL.": "Домен сброшен до размещённого Tradly URL.",
    "workspace.domain.current": "ТЕКУЩИЙ ДОМЕН",
    "CURRENT DOMAIN": "ТЕКУЩИЙ ДОМЕН",
    "workspace.domain.hosted": "Домен Tradly",
    "Tradly-hosted domain": "Домен Tradly",
    "workspace.domain.dns_status": "Статус DNS: {status}",
    "DNS status: {status}": "Статус DNS: {status}",
    "workspace.domain.checking": "Проверка статуса DNS…",
    "Checking DNS status…": "Проверка статуса DNS…",
    "workspace.domain.refresh": "Обновить статус",
    "Refresh status": "Обновить статус",
    "workspace.domain.reset": "Сбросить домен",
    "Reset domain": "Сбросить домен",
    "workspace.domain.connect_title": "Подключить пользовательский домен",
    "Connect a custom domain": "Подключить пользовательский домен",
    "workspace.domain.connect_description": "Введите домен, которым вы уже владеете. Мы покажем DNS-записи для его подключения.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Введите домен, которым вы уже владеете. Мы покажем DNS-записи для его подключения.",
    "workspace.domain.saving": "Сохранение…",
    "workspace.domain.add": "Добавить домен",
    "Add domain": "Добавить домен",
    "workspace.domain.dns_title": "Настройка DNS",
    "DNS setup": "Настройка DNS",
    "workspace.domain.a_record": "Запись A",
    "A record": "Запись A",
    "workspace.domain.root_description": "Используйте для корневого домена, например",
    "Use this for a root domain such as": "Используйте для корневого домена, например",
    "workspace.domain.cname_record": "Запись CNAME",
    "CNAME record": "Запись CNAME",
    "workspace.domain.subdomain_description": "Используйте для поддомена, например",
    "Use this for a subdomain such as": "Используйте для поддомена, например",
    "workspace.domain.host": "Хост",
    "Host": "Хост",
    "workspace.domain.value": "Значение",
    "workspace.domain.need_domain": "Нужен домен?",
    "Need a domain?": "Нужен домен?",
    "workspace.domain.buy_domain": "Купите домен в Google Domains или GoDaddy, затем вернитесь сюда, чтобы подключить его.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Купите домен в Google Domains или GoDaddy, затем вернитесь сюда, чтобы подключить его.",
    "workspace.billing.title": "Оплата и использование",
    "Billing & Usage": "Оплата и использование",
    "workspace.billing.description": "Управляйте тарифами, использованием и оплатой рабочей области.",
    "Manage workspace plans, usage, and billing.": "Управляйте тарифами, использованием и оплатой рабочей области.",
    "workspace.billing.invoice_description": "Управляйте тарифами, использованием и оплаченными счетами рабочей области.",
    "Manage workspace plans, usage, and paid invoices.": "Управляйте тарифами, использованием и оплаченными счетами рабочей области.",
    "workspace.billing.usage_description": "Просмотрите текущее использование и ограничения для этой рабочей области.",
    "workspace.invoices.loading": "Загрузка счетов…",
    "Loading invoices…": "Загрузка счетов…",
    "workspace.invoices.description": "Скачивайте счета или оплачивайте задолженность.",
    "Download invoices or complete payment for an outstanding balance.": "Скачивайте счета или оплачивайте задолженность.",
    "workspace.invoices.payment_failed": "Платёж не прошёл — доступ к сервису может быть ограничен.",
    "Payment failed — service access may be affected.": "Платёж не прошёл — доступ к сервису может быть ограничен.",
    "workspace.invoices.awaiting_payment": "По счёту {invoice} ожидается оплата.",
    "Invoice {invoice} is awaiting payment.": "По счёту {invoice} ожидается оплата.",
    "workspace.invoices.outstanding": "неоплачено",
    "outstanding": "неоплачено",
    "workspace.invoices.pay_invoice": "Оплатить счёт",
    "Pay invoice": "Оплатить счёт",
    "workspace.invoices.invoice": "Счёт",
    "workspace.invoices.date": "Дата",
    "workspace.invoices.amount": "Сумма",
    "workspace.invoices.paid": "Оплачено",
    "workspace.invoices.unpaid": "Не оплачено",
    "workspace.invoices.download_invoice": "Скачать счёт",
    "Download invoice": "Скачать счёт",
    "workspace.invoices.empty_title": "Нет счетов",
    "No invoices available": "Нет счетов",
    "workspace.invoices.empty_description": "Счета появятся после оформления подписки и оплаты. Если возникли вопросы, обратитесь в службу поддержки.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Счета появятся после оформления подписки и оплаты. Если возникли вопросы, обратитесь в службу поддержки.",
    "workspace.plans.heading": "Тарифы",
    "workspace.plans.tab_marketplace": "Маркетплейс",
    "workspace.plans.tab_marketplace_description": "Несколько продавцов",
    "Multi-vendor": "Несколько продавцов",
    "workspace.plans.tab_single": "Один магазин",
    "Single Store": "Один магазин",
    "workspace.plans.tab_single_description": "Для независимых компаний и авторов",
    "Indie & Creators": "Для независимых компаний и авторов",
    "workspace.plans.tab_alacarte": "Отдельные продукты",
    "A la carte": "Отдельные продукты",
    "workspace.plans.tab_alacarte_description": "Кредиты и дополнения",
    "Credits & add-ons": "Кредиты и дополнения",
    "workspace.plans.tab_services": "Услуги",
    "Services": "Услуги",
    "workspace.plans.tab_services_description": "Дополнительные услуги",
    "Additional services": "Дополнительные услуги",
    "workspace.plans.selected": "Выбрано",
    "Selected": "Выбрано",
    "workspace.plans.try_again": "Повторить попытку",
    "Try again": "Повторить попытку",
    "workspace.plans.bill_yearly": "Оплата за год",
    "Bill Yearly": "Оплата за год",
    "workspace.plans.bill_monthly": "Оплата за месяц",
    "Bill Monthly": "Оплата за месяц",
    "workspace.plans.compare": "Сравнить тарифы",
    "Compare Plans": "Сравнить тарифы",
    "workspace.plans.community": "Сообщество",
    "workspace.plans.community_description": "Бесплатно навсегда. Отлично подходит для личных и общественных проектов.",
    "Free forever. Perfect for hobbyists and community projects.": "Бесплатно навсегда. Отлично подходит для личных и общественных проектов.",
    "workspace.plans.different_configurations": "Нужна другая конфигурация?",
    "Looking for different configurations?": "Нужна другая конфигурация?",
    "workspace.plans.contact_us": "Связаться с нами",
    "Contact Us": "Связаться с нами",
    "workspace.plans.see_alacarte_pricing": "Посмотреть цены на отдельные продукты",
    "See à la carte pricing": "Посмотреть цены на отдельные продукты",
    "workspace.plans.available": "Доступно",
    "Available": "Доступно",
    "workspace.plans.used_90d": "Использовано (90 дн.)",
    "Used (90d)": "Использовано (90 дн.)",
    "workspace.plans.expired_90d": "Истекло (90 дн.)",
    "Expired (90d)": "Истекло (90 дн.)",
    "workspace.plans.expires_on": "Истекает {date}",
    "Expires {date}": "Истекает {date}",
    "workspace.plans.top_up_credits": "Пополнить кредиты",
    "Top Up Credits": "Пополнить кредиты",
    "workspace.plans.credits_description": "Кредиты используются для электронной почты, поиска с ИИ, рекомендаций и действий агентов. 100 кредитов = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Кредиты используются для электронной почты, поиска с ИИ, рекомендаций и действий агентов. 100 кредитов = $5.",
    "workspace.plans.credits": "кредитов",
    "credits": "кредитов",
    "workspace.plans.custom_amount": "Другая сумма",
    "Custom amount": "Другая сумма",
    "workspace.plans.amount_example": "например, 2500",
    "e.g. 2500": "например, 2500",
    "workspace.plans.opening_checkout": "Открытие страницы оплаты…",
    "Opening checkout…": "Открытие страницы оплаты…",
    "workspace.plans.buy_credits": "Купить кредитов: {count}",
    "Buy {count} credits": "Купить кредитов: {count}",
    "workspace.plans.select_amount": "Выберите сумму",
    "Select an amount": "Выберите сумму",
    "workspace.plans.alacarte_products": "Отдельные продукты",
    "A la carte Products": "Отдельные продукты",
    "workspace.plans.products_description": "Выберите используемые продукты. Так мы сможем настроить сервис для вас. Оплата за использование списывается в кредитах.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Выберите используемые продукты. Так мы сможем настроить сервис для вас. Оплата за использование списывается в кредитах.",
    "workspace.plans.enabled": "Включено",
    "workspace.plans.enable": "Включить",
    "Enable": "Включить",
    "workspace.plans.open_here": "Открыть здесь",
    "Open here": "Открыть здесь",
    "workspace.plans.open_marketing": "Открыть marketing.tradly.app",
    "Open marketing.tradly.app": "Открыть marketing.tradly.app",
    "workspace.plans.open_analytics": "Открыть analytics.tradly.app",
    "Open analytics.tradly.app": "Открыть analytics.tradly.app",
    "workspace.plans.open_external": "Открыть внешний сайт",
    "Open external": "Открыть внешний сайт",
    "workspace.plans.coming_soon": "Скоро",
    "Coming soon": "Скоро",
    "workspace.plans.services_title": "Разовая настройка и индивидуальные услуги",
    "One-Time Setup & Custom Services": "Разовая настройка и индивидуальные услуги",
    "workspace.plans.service_app_launch": "Запуск приложения под вашим брендом",
    "White-Label App Launch": "Запуск приложения под вашим брендом",
    "workspace.plans.service_frontend": "Настройка интерфейса",
    "Frontend Customization": "Настройка интерфейса",
    "workspace.plans.service_multilanguage": "Поддержка нескольких языков",
    "Multi-Language Support": "Поддержка нескольких языков",
    "workspace.plans.view_docs": "Посмотреть документацию",
    "View Docs": "Посмотреть документацию",
    "workspace.plans.confirm_change": "Подтвердите смену тарифа",
    "Confirm your plan change": "Подтвердите смену тарифа",
    "workspace.plans.confirm_charge": "Оплата авансовая; списание происходит в дату подписки.",
    "Charges are prepaid and billed on your subscription date.": "Оплата авансовая; списание происходит в дату подписки.",
    "workspace.plans.confirm_promo": "Если доступно, промокод можно ввести при оплате через Stripe.",
    "Promotional codes can be entered during Stripe checkout where available.": "Если доступно, промокод можно ввести при оплате через Stripe.",
    "workspace.plans.confirm_delay": "Изменение тарифа может появиться в рабочей области с небольшой задержкой.",
    "Plan changes may take a moment to appear in your workspace.": "Изменение тарифа может появиться в рабочей области с небольшой задержкой.",
    "workspace.plans.payment_active": "Платёж получен. Тариф активен.",
    "Payment received. Your plan is active.": "Платёж получен. Тариф активен.",
    "workspace.plans.payment_method_updated": "Способ оплаты обновлён.",
    "Payment method updated.": "Способ оплаты обновлён.",
    "workspace.plans.payment_cancelled": "Платёж не завершён, тариф не изменён.",
    "Payment was not completed, so your plan has not changed.": "Платёж не завершён, тариф не изменён.",
    "workspace.plans.activating": "Платёж получен. Активация тарифа…",
    "Payment received. Activating your plan…": "Платёж получен. Активация тарифа…",
    "workspace.plans.activation_delayed": "Платёж получен. Активация тарифа занимает больше времени. Обновите страницу через минуту.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Платёж получен. Активация тарифа занимает больше времени. Обновите страницу через минуту.",
    "workspace.plans.card_saved": "Карта сохранена, подписка обновлена.",
    "Card saved and subscription updated.": "Карта сохранена, подписка обновлена.",
    "workspace.plans.subscription_updated": "Подписка обновлена.",
    "Subscription updated.": "Подписка обновлена.",
    "workspace.plans.products_saved": "Отдельные продукты сохранены.",
    "À la carte products saved.": "Отдельные продукты сохранены.",
    "workspace.plans.minimum_credits": "Введите не менее 100 кредитов.",
    "Enter at least 100 credits.": "Введите не менее 100 кредитов.",
    "workspace.plans.credit_topup_description": "Пополнение кредитов ({count} кредитов)",
    "Credit Top-Up ({count} credits)": "Пополнение кредитов ({count} кредитов)",
    "workspace.plans.billing_details": "Текущие платёжные данные",
    "Current billing details": "Текущие платёжные данные",
    "workspace.plans.current_plan": "Текущий тариф",
    "Current Plan": "Текущий тариф",
    "workspace.plans.renews": "Продление",
    "Renews": "Продление",
    "workspace.plans.payment_method": "Способ оплаты",
    "Payment method": "Способ оплаты",
    "workspace.plans.opening": "Открытие…",
    "Opening…": "Открытие…",
    "workspace.plans.manage_payment_method": "Управление способом оплаты",
    "Manage payment method": "Управление способом оплаты",
    "workspace.plans.upgrade": "Перейти на более высокий тариф",
    "workspace.plans.downgrade": "Перейти на более низкий тариф",
    "Downgrade": "Перейти на более низкий тариф",
    "workspace.plans.custom_price": "Индивидуальная цена",
    "workspace.plans.per_month_short": "/мес.",
    "/month": "/мес.",
    "workspace.plans.per_year_amount": "в год ({amount})",
    "per year ({amount})": "в год ({amount})",
    "workspace.plans.per_month_amount": "в месяц ({amount})",
    "per month ({amount})": "в месяц ({amount})",
    "workspace.plans.yearly_savings": "Экономия за год: {amount}",
    "Save {amount} yearly": "Экономия за год: {amount}",
    "workspace.plans.billed_yearly": "оплата ежегодно",
    "billed yearly": "оплата ежегодно",
    "workspace.plans.billed_monthly": "оплата ежемесячно",
    "billed monthly": "оплата ежемесячно",
    "workspace.plans.free_trial": "У вас бесплатный пробный период.",
    "You are on a free trial.": "У вас бесплатный пробный период.",
    "workspace.plans.updating": "Обновление…",
    "Updating…": "Обновление…",
    "workspace.plans.temporarily_unavailable": "Временно недоступно",
    "Temporarily unavailable": "Временно недоступно",
    "workspace.plans.whats_included": "Что включено",
    "What's included": "Что включено",
    "workspace.plans.products.auth.title": "Авторизация",
    "workspace.plans.products.auth.description": "Идентификация, SSO, разрешения и управление пользователями.",
    "Identity, SSO, permissions, and user management.": "Идентификация, SSO, разрешения и управление пользователями.",
    "workspace.plans.products.email.title": "Электронная почта",
    "workspace.plans.products.email.description": "Транзакционные и маркетинговые письма уже встроены.",
    "Transactional and marketing email, built in.": "Транзакционные и маркетинговые письма уже встроены.",
    "workspace.plans.products.analytics.title": "Аналитика",
    "Analytics": "Аналитика",
    "workspace.plans.products.analytics.description": "Бесплатная аналитика для веб-сайта, приложения и агентов.",
    "Free analytics for web, app, and agents.": "Бесплатная аналитика для веб-сайта, приложения и агентов.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "CRM, который автоматически пополняется данными о действиях пользователей.",
    "A CRM that fills itself from user activity.": "CRM, который автоматически пополняется данными о действиях пользователей.",
    "workspace.plans.products.subscription.title": "Подписки",
    "Subscriptions": "Подписки",
    "workspace.plans.products.subscription.description": "Регулярные платежи, пробные периоды и работа с задолженностью — всё под контролем.",
    "Recurring billing, trials, and dunning — handled.": "Регулярные платежи, пробные периоды и работа с задолженностью — всё под контролем.",
    "workspace.plans.products.recommendation.title": "Рекомендации",
    "Recommendations": "Рекомендации",
    "workspace.plans.products.recommendation.description": "Показывайте каждому пользователю то, что ему действительно нужно.",
    "Show each user what they will actually want.": "Показывайте каждому пользователю то, что ему действительно нужно.",
    "workspace.plans.marketplace.2025-superstarter.title": "Базовый",
    "Basic": "Базовый",
    "workspace.plans.marketplace.2025-superstarter.description": "Для небольшой команды. Все функции тарифа Community, а также white-label оформление (убирает значок «Сделано с Tradly»).",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Для небольшой команды. Все функции тарифа Community, а также white-label оформление (убирает значок «Сделано с Tradly»).",
    "workspace.plans.marketplace.2025-superstarter.button": "Начать 7-дневный пробный период",
    "Start 7 Days Trial": "Начать 7-дневный пробный период",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Без комиссии за транзакции",
    "No transaction fee": "Без комиссии за транзакции",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Бесплатный сайт на Tradly",
    "Free Tradly hosted website": "Бесплатный сайт на Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Добавьте собственный домен",
    "Add your custom domain": "Добавьте собственный домен",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Редактор — история страниц за 3 дня",
    "Editor - 3 Day page history": "Редактор — история страниц за 3 дня",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Для стартапов, проверяющих бизнес-идею. Включает всё необходимое для тестирования рынка и привлечения первых клиентов.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Для стартапов, проверяющих бизнес-идею. Включает всё необходимое для тестирования рынка и привлечения первых клиентов.",
    "workspace.plans.marketplace.2025-starter.button": "Начать 7-дневный пробный период",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Без комиссии за транзакции",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Неограниченное количество пользовательских атрибутов",
    "Unlimited Custom Attributes": "Неограниченное количество пользовательских атрибутов",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "История страниц за 30 дней",
    "30 Day page history": "История страниц за 30 дней",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Платная подписка",
    "Gated Subscription": "Платная подписка",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Вход через соцсети",
    "Social Logins": "Вход через соцсети",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Вебхуки",
    "Webhooks": "Вебхуки",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Для проверенных бизнес-идей на этапе роста. Подходит тем, кому нужны индивидуальные решения и дополнительные интеграции.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Для проверенных бизнес-идей на этапе роста. Подходит тем, кому нужны индивидуальные решения и дополнительные интеграции.",
    "workspace.plans.marketplace.2025-growth.button": "Начать 7-дневный пробный период",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Без комиссии за транзакции",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Собственный адрес отправителя",
    "Custom 'From Email'": "Собственный адрес отправителя",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Дополнительные мини-инструменты и интеграции",
    "Additional Mini Tools & Integrations": "Дополнительные мини-инструменты и интеграции",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Индивидуальные ознакомительные звонки*",
    "Personalised Onboarding calls*": "Индивидуальные ознакомительные звонки*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "История страниц за 90 дней",
    "90 Day page history": "История страниц за 90 дней",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Несколько валют и языков",
    "Multi Currencies & Multi Languages": "Несколько валют и языков",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Ролевое управление доступом (RBAC)",
    "Role-based access control (RBAC)": "Ролевое управление доступом (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Встроенный чат для приложений",
    "Inbuilt Chat for Apps": "Встроенный чат для приложений",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Для компаний на этапе роста, которым нужны индивидуальные решения и особые требования.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Для компаний на этапе роста, которым нужны индивидуальные решения и особые требования.",
    "workspace.plans.marketplace.2025-scale.button": "Начать 7-дневный пробный период",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Без комиссии за транзакции",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Приоритетная поддержка",
    "Priority Support": "Приоритетная поддержка",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Поддержка нескольких каналов и приложений",
    "Multiple Channels (App Support)": "Поддержка нескольких каналов и приложений",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Единый вход (SSO)",
    "Single Sign-on (SSO)": "Единый вход (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Неограниченная история страниц",
    "Unlimited page history": "Неограниченная история страниц",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Встроенный чат для приложений",
    "In-built Chat for Apps": "Встроенный чат для приложений",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Всё необходимое для растущего магазина: уберите брендинг, добавьте домен и получите доступ к дополнительным инструментам.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Всё необходимое для растущего магазина: уберите брендинг, добавьте домен и получите доступ к дополнительным инструментам.",
    "workspace.plans.indie.go.button": "Начать 7-дневный пробный период",
    "Start 7-day trial": "Начать 7-дневный пробный период",
    "workspace.plans.indie.go.feature_1.title": "Без брендинга Tradly",
    "No Tradly branding": "Без брендинга Tradly",
    "workspace.plans.indie.go.feature_2.title": "Собственный домен",
    "Custom domain": "Собственный домен",
    "workspace.plans.indie.go.feature_3.title": "Неограниченное количество товаров",
    "Unlimited products": "Неограниченное количество товаров",
    "workspace.plans.indie.go.feature_4.title": "Рассылки по электронной почте",
    "Email campaigns": "Рассылки по электронной почте",
    "workspace.plans.indie.go.feature_5.title": "Рекомендации ИИ",
    "AI Recommendations": "Рекомендации ИИ",
    "workspace.plans.indie.go.feature_6.title": "Поддержка по заявкам",
    "Ticket-based support": "Поддержка по заявкам",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Полный набор ИИ-инструментов, продвинутый маркетинг и все функции для магазинов, нацеленных на рост.",
    "workspace.plans.indie.genius.button": "Начать 7-дневный пробный период",
    "workspace.plans.indie.genius.feature_1.title": "Всё, что входит в Pro",
    "Everything in Pro": "Всё, что входит в Pro",
    "workspace.plans.indie.genius.feature_2.title": "ИИ-агенты (помощник по покупкам и другие)",
    "AI Agents (Shopping Assistant, etc.)": "ИИ-агенты (помощник по покупкам и другие)",
    "workspace.plans.indie.genius.feature_3.title": "Поиск на естественном языке",
    "Natural language search": "Поиск на естественном языке",
    "workspace.plans.indie.genius.feature_4.title": "Расширенная автоматизация электронной почты",
    "Advanced email automation": "Расширенная автоматизация электронной почты",
    "workspace.plans.indie.genius.feature_5.title": "Неограниченное количество запросов рекомендаций",
    "Unlimited recommendation requests": "Неограниченное количество запросов рекомендаций",
    "workspace.plans.indie.genius.feature_6.title": "Поддержка по заявкам",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Подписка для пользователей, которые открывают аккаунты и размещают объявления.",
    "Subscription charges for people to open accounts & submit listings": "Подписка для пользователей, которые открывают аккаунты и размещают объявления.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Вход и регистрация через Google и Meta",
    "Signup/in via Google, Meta": "Вход и регистрация через Google и Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Для подключения к Zapier и Make",
    "To connect with Zapier & Make": "Для подключения к Zapier и Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Встроенные сообщения для пользователей приложения",
    "Native in-app messaging for your users": "Встроенные сообщения для пользователей приложения",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Ответ в течение 24 часов по несрочным вопросам",
    "24 hour response time for non-critical": "Ответ в течение 24 часов по несрочным вопросам",
    "common.continue": "Продолжить",
    "Continue": "Продолжить",
    "workspace.plans.free_plan": "Бесплатно",
    "Free": "Бесплатно",
    "workspace.usage.group_platform": "Платформа и рабочая область",
    "Platform & workspace": "Платформа и рабочая область",
    "workspace.usage.group_ai": "ИИ и использование",
    "AI & usage": "ИИ и использование",
    "workspace.usage.group_storage": "Контент и хранилище",
    "Content & storage": "Контент и хранилище",
    "workspace.usage.group_alacarte": "Отдельные продукты",
    "workspace.usage.accounts": "Аккаунты",
    "workspace.usage.listings": "Товары",
    "workspace.usage.sites": "Сайты в рабочей области",
    "Sites under workspace": "Сайты в рабочей области",
    "workspace.usage.external_users": "Внешние пользователи",
    "External users": "Внешние пользователи",
    "workspace.usage.internal_users": "Внутренние пользователи",
    "Internal users": "Внутренние пользователи",
    "workspace.usage.ai_credits": "Кредиты ИИ",
    "AI credits": "Кредиты ИИ",
    "workspace.usage.storage": "Хранилище",
    "Storage": "Хранилище",
    "workspace.usage.email": "Электронная почта",
    "workspace.usage.maps": "Карты",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Аналитика",
    "workspace.usage.recommendations": "Рекомендации",
    "workspace.usage.ai_agents": "ИИ-агенты",
    "AI agents": "ИИ-агенты",
    "workspace.usage.status_not_reported": "Нет данных",
    "Not reported": "Нет данных",
    "workspace.usage.status_nearly_full": "Почти заполнено",
    "Nearly full": "Почти заполнено",
    "workspace.usage.status_on_track": "В пределах нормы",
    "On track": "В пределах нормы",
    "workspace.usage.workspace_files": "Файлы рабочей области",
    "Workspace files": "Файлы рабочей области",
    "workspace.usage.workspace_usage": "Использование рабочей области",
    "Workspace usage": "Использование рабочей области",
    "workspace.usage.of_limit": "из {limit}",
    "of {limit}": "из {limit}",
    "workspace.usage.no_cap": "Лимит не задан",
    "No cap configured": "Лимит не задан",
    "workspace.usage.trend": "Динамика использования",
    "Usage trend": "Динамика использования",
    "workspace.usage.unavailable": "Данные об использовании временно недоступны.",
    "Usage data is temporarily unavailable.": "Данные об использовании временно недоступны.",
    "workspace.usage.loading": "Загрузка данных об использовании…",
    "Loading workspace usage…": "Загрузка данных об использовании…",
    "workspace.usage.overview": "Обзор рабочей области",
    "Workspace overview": "Обзор рабочей области",
    "workspace.usage.title": "Разбивка использования",
    "Usage breakdown": "Разбивка использования",
    "workspace.usage.description": "Посмотрите, сколько ресурсов использовала рабочая область и сколько осталось на текущем тарифе.",
    "See what your workspace has used and how much room remains on your current plan.": "Посмотрите, сколько ресурсов использовала рабочая область и сколько осталось на текущем тарифе.",
    "workspace.usage.view_plans": "Посмотреть тарифы",
    "workspace.usage.showing_available_limits": "Показаны лимиты, уже доступные в этой рабочей области.",
    "Showing the limits that are already available in this workspace.": "Показаны лимиты, уже доступные в этой рабочей области.",
    "workspace.usage.summary": "Сводка использования",
    "Usage summary": "Сводка использования",
    "workspace.usage.metrics_tracked": "Отслеживаемые показатели",
    "Metrics tracked": "Отслеживаемые показатели",
    "workspace.usage.metrics_count": "{count} из {total}",
    "{count} of {total}": "{count} из {total}",
    "workspace.usage.next_reset": "Следующий сброс",
    "Next reset": "Следующий сброс",
    "workspace.usage.not_provided": "Не указано",
    "Not provided": "Не указано",
    "workspace.usage.data_source": "Источник данных",
    "Data source": "Источник данных",
    "workspace.usage.clear_view": "Понятный обзор рабочей области",
    "A clear view of your workspace": "Понятный обзор рабочей области",
    "workspace.usage.by_resource": "По ресурсам",
    "Usage by resource": "По ресурсам",
    "workspace.usage.live_summary": "Актуальная сводка",
    "Live summary": "Актуальная сводка",
    "workspace.usage.resource": "Ресурс",
    "Resource": "Ресурс",
    "workspace.usage.used_limit": "Использовано / лимит",
    "Used / limit": "Использовано / лимит",
    "workspace.usage.progress": "Прогресс",
    "Progress": "Прогресс",
    "workspace.usage.cost": "Стоимость",
    "Cost": "Стоимость",
    "workspace.usage.footnote": "Данные об использовании и лимитах поступают из сервиса использования рабочей области. Прочерк означает, что текущий API пока не передаёт этот показатель.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "Данные об использовании и лимитах поступают из сервиса использования рабочей области. Прочерк означает, что текущий API пока не передаёт этот показатель.",
    "workspace.usage.refresh": "Обновить",
    "Refresh": "Обновить",
    "maps.title": "Карты",
    "maps.tab.analysis": "Анализ рынка",
    "Market scan": "Анализ рынка",
    "maps.tab.usage": "Использование",
    "maps.tab.settings": "Настройки",
    "maps.action.save": "Сохранить",
    "maps.action.saving": "Сохранение…",
    "maps.action.analyze_area": "Анализировать область",
    "Analyze area": "Анализировать область",
    "maps.action.analyzing": "Анализ…",
    "Analyzing…": "Анализ…",
    "maps.action.refresh": "Обновить",
    "maps.action.loading": "Загрузка…",
    "Loading…": "Загрузка…",
    "maps.action.open_in_maps": "Открыть в Картах",
    "Open in Maps": "Открыть в Картах",
    "maps.analysis.title": "Изучите местный рынок",
    "Explore a local market": "Изучите местный рынок",
    "maps.analysis.description": "Посмотрите компании, отмеченные Google рядом с предполагаемым местоположением. Это предварительный анализ конкурентов, а не прогноз спроса или жизнеспособности.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Посмотрите компании, отмеченные Google рядом с предполагаемым местоположением. Это предварительный анализ конкурентов, а не прогноз спроса или жизнеспособности.",
    "maps.analysis.address_label": "Адрес или населённый пункт",
    "Address or locality": "Адрес или населённый пункт",
    "maps.analysis.address_placeholder": "Улица, район или город",
    "Street, suburb, or city": "Улица, район или город",
    "maps.analysis.category_label": "Тип бизнеса",
    "Business type": "Тип бизнеса",
    "maps.analysis.radius_label": "Радиус поиска",
    "Search radius": "Радиус поиска",
    "maps.analysis.places_listings": "Объекты на карте",
    "Places listings": "Объекты на карте",
    "maps.analysis.within_radius": "{category} в радиусе {radius}",
    "{category} within {radius}": "{category} в радиусе {radius}",
    "maps.analysis.results_description": "Результаты отфильтрованы по категории и радиусу, затем отсортированы по расстоянию.",
    "Results are filtered by category and radius, then ordered by distance.": "Результаты отфильтрованы по категории и радиусу, затем отсортированы по расстоянию.",
    "maps.analysis.result_limit_notice": "Google вернул максимум — 20 объектов. Фактическое число может быть больше; уменьшите радиус для более подробного поиска.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google вернул максимум — 20 объектов. Фактическое число может быть больше; уменьшите радиус для более подробного поиска.",
    "maps.analysis.limitations": "Данные о местах могут быть неполными и не отражают спрос, посещаемость, население, аренду или прибыльность. Используйте их как один из источников при исследовании рынка.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Данные о местах могут быть неполными и не отражают спрос, посещаемость, население, аренду или прибыльность. Используйте их как один из источников при исследовании рынка.",
    "maps.analysis.nearby_businesses": "Компании поблизости ({count})",
    "Nearby businesses ({count})": "Компании поблизости ({count})",
    "maps.analysis.businesses": "Компании",
    "Businesses": "Компании",
    "maps.analysis.no_listings": "Для этой области и категории в Google Maps не найдено подходящих мест.",
    "No matching Google Maps listings were returned for this area and category.": "Для этой области и категории в Google Maps не найдено подходящих мест.",
    "maps.category.retail": "Розничная торговля",
    "Retail": "Розничная торговля",
    "maps.category.grocery": "Продукты питания",
    "Grocery": "Продукты питания",
    "maps.category.clothing": "Одежда",
    "Clothing": "Одежда",
    "maps.category.pharmacy": "Аптека",
    "Pharmacy": "Аптека",
    "maps.category.restaurant": "Ресторан / кафе",
    "Restaurant / café": "Ресторан / кафе",
    "maps.competition.limited": "Небольшое число конкурентов в списке",
    "Limited listed competition": "Небольшое число конкурентов в списке",
    "maps.competition.some": "Некоторые конкуренты в списке",
    "Some listed competition": "Некоторые конкуренты в списке",
    "maps.competition.many": "Много конкурентов в списке",
    "Many listed competitors": "Много конкурентов в списке",
    "maps.competition.limit_reached": "Не менее 20 объектов (достигнут лимит результатов)",
    "At least 20 listings (result limit reached)": "Не менее 20 объектов (достигнут лимит результатов)",
    "maps.competition.default": "Конкуренты в списке",
    "Listed competition": "Конкуренты в списке",
    "maps.distance_km": "{value} км",
    "{value} km": "{value} км",
    "maps.distance_m": "{value} м",
    "{value} m": "{value} м",
    "maps.business_status.operational": "Работает",
    "Operational": "Работает",
    "maps.usage.title": "Использование провайдера",
    "Provider usage": "Использование провайдера",
    "maps.usage.description": "Количество запросов, зарегистрированных сервисом Maps. Стоимость сверяется отдельно.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Количество запросов, зарегистрированных сервисом Maps. Стоимость сверяется отдельно.",
    "maps.usage.days": "{count} дн.",
    "maps.usage.provider_requests": "Запросы провайдера",
    "Provider requests": "Запросы провайдера",
    "maps.usage.range_detail": "Период: {count} дн.",
    "{count} day window": "Период: {count} дн.",
    "maps.usage.successful": "Успешно",
    "Successful": "Успешно",
    "maps.usage.completed_calls": "Выполненные запросы провайдера",
    "Completed provider calls": "Выполненные запросы провайдера",
    "maps.usage.errors": "Ошибки",
    "Errors": "Ошибки",
    "maps.usage.failed_calls": "Неудачные запросы провайдера",
    "Failed provider calls": "Неудачные запросы провайдера",
    "maps.usage.metered_units": "Расчётные единицы",
    "Metered units": "Расчётные единицы",
    "maps.usage.unit_detail": "Одна единица на зарегистрированный запрос",
    "One unit per recorded request": "Одна единица на зарегистрированный запрос",
    "maps.usage.by_operation": "Использование по операциям",
    "Usage by operation": "Использование по операциям",
    "maps.usage.group_description": "Количество сгруппировано по провайдеру, операции и результату.",
    "Counts are grouped by provider, operation, and outcome.": "Количество сгруппировано по провайдеру, операции и результату.",
    "maps.usage.empty": "За выбранный период запросов к картам не было.",
    "No map requests in this date range.": "За выбранный период запросов к картам не было.",
    "maps.usage.provider": "Провайдер",
    "Provider": "Провайдер",
    "maps.usage.operation": "Операция",
    "Operation": "Операция",
    "maps.usage.outcome": "Результат",
    "Outcome": "Результат",
    "maps.usage.requests": "Запросы",
    "Requests": "Запросы",
    "maps.usage.units": "Единицы",
    "Units": "Единицы",
    "maps.settings.provider_title": "Провайдер карт",
    "Map provider": "Провайдер карт",
    "maps.settings.provider_description": "Выберите провайдера, разрешённого политикой конфиденциальности данных. Учётные данные провайдера управляются Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Выберите провайдера, разрешённого политикой конфиденциальности данных. Учётные данные провайдера управляются Tradly.",
    "maps.settings.selected": "Выбрано",
    "maps.settings.available": "Доступно",
    "maps.settings.planned": "Запланировано",
    "Planned": "Запланировано",
    "maps.settings.origins_title": "Разрешённые источники веб-сайта",
    "Allowed website origins": "Разрешённые источники веб-сайта",
    "maps.settings.origins_description": "Зарегистрированные домены клиента разрешены автоматически. Добавьте сюда точные адреса других сайтов, например тестового.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Зарегистрированные домены клиента разрешены автоматически. Добавьте сюда точные адреса других сайтов, например тестового.",
    "maps.settings.registered_domains": "Зарегистрированные домены",
    "Registered domains": "Зарегистрированные домены",
    "maps.settings.no_domains": "Не удалось загрузить зарегистрированные домены.",
    "No registered domains were loaded.": "Не удалось загрузить зарегистрированные домены.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Добавить источник",
    "Add origin": "Добавить источник",
    "maps.settings.remove_origin": "Удалить",
    "maps.settings.no_origins": "Дополнительные источники не добавлены.",
    "No extra origins added.": "Дополнительные источники не добавлены.",
    "maps.error.session_not_ready": "Сеанс администратора ещё не готов.",
    "Your admin session is not ready yet.": "Сеанс администратора ещё не готов.",
    "maps.error.load_data": "Не удалось загрузить данные Maps ({status}).",
    "Unable to load Maps data ({status}).": "Не удалось загрузить данные Maps ({status}).",
    "maps.error.load_usage": "Не удалось загрузить данные использования Maps.",
    "Unable to load Maps usage.": "Не удалось загрузить данные использования Maps.",
    "maps.error.load_settings": "Не удалось загрузить настройки Maps.",
    "Unable to load Maps settings.": "Не удалось загрузить настройки Maps.",
    "maps.error.save_settings": "Не удалось сохранить настройки Maps.",
    "Unable to save Maps settings.": "Не удалось сохранить настройки Maps.",
    "maps.error.invalid_origin": "Введите полный источник, например https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Введите полный источник, например https://staging.example.com.",
    "maps.error.registered_origin": "Этот источник уже охватывается зарегистрированным доменом.",
    "This origin is already covered by a registered domain.": "Этот источник уже охватывается зарегистрированным доменом.",
    "maps.error.address_required": "Введите адрес или населённый пункт для поиска.",
    "Enter an address or locality to scan.": "Введите адрес или населённый пункт для поиска.",
    "maps.error.location_not_found": "Не удалось найти это место.",
    "Unable to find that location.": "Не удалось найти это место.",
    "maps.error.no_coordinates": "Для этого адреса координаты не найдены. Попробуйте указать ближайшую улицу, район или город.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Для этого адреса координаты не найдены. Попробуйте указать ближайшую улицу, район или город.",
    "maps.error.analyze_area": "Не удалось проанализировать эту область.",
    "Unable to analyze this area.": "Не удалось проанализировать эту область.",
    "maps.notice.settings_saved": "Настройки Maps сохранены.",
    "Maps settings saved.": "Настройки Maps сохранены.",
    "maps.status.success": "Успешно",
    "maps.status.error": "Ошибка",
    "maps.operation.geocode": "Геокодирование",
    "Geocode": "Геокодирование",
    "maps.operation.maps_geocode": "Геокодирование Maps",
    "Maps geocode": "Геокодирование Maps",
    "maps.operation.market_analysis": "Анализ рынка",
    "Market analysis": "Анализ рынка",
    "maps.operation.maps_market_analysis": "Анализ рынка Maps",
    "Maps market analysis": "Анализ рынка Maps",
    "maps.operation.places_search": "Поиск мест",
    "Places search": "Поиск мест",
    "maps.operation.places_nearby": "Места поблизости",
    "Nearby places": "Места поблизости",
    "maps.operation.place_details": "Сведения о месте",
    "Place details": "Сведения о месте",
    "common.loading": "Загрузка…",
    "common.saving": "Сохранение…",
    "common.searching": "Поиск…",
    "Searching…": "Поиск…",
    "common.no_matches": "Совпадений не найдено.",
    "No matches found.": "Совпадений не найдено.",
    "common.select": "Выберите…",
    "Select…": "Выберите…",
    "common.search_users": "Поиск пользователей по имени или электронной почте",
    "Search users by name or email": "Поиск пользователей по имени или электронной почте",
    "common.reset": "Сбросить",
    "Reset": "Сбросить",
    "common.validation.email": "Введите корректный адрес электронной почты.",
    "Enter a valid email address.": "Введите корректный адрес электронной почты.",
    "common.validation.phone": "Введите корректный номер телефона.",
    "Enter a valid phone number.": "Введите корректный номер телефона.",
    "common.validation.currency": "Используйте трёхбуквенный код валюты, например USD.",
    "Use a 3-letter currency code, such as USD.": "Используйте трёхбуквенный код валюты, например USD.",
    "common.validation.location": "Введите корректный адрес или местоположение.",
    "Enter a valid address or location.": "Введите корректный адрес или местоположение.",
    "common.validation.required": "Поле {label} обязательно.",
    "{label} is required.": "Поле {label} обязательно.",
    "common.validation.invalid": "Поле {label} заполнено неверно.",
    "{label} is invalid.": "Поле {label} заполнено неверно.",
    "common.status.active": "Активен",
    "common.status.inactive": "Неактивен",
    "common.status.open": "Открыт",
    "common.status.closed": "Закрыт",
    "common.status.posted": "Проведён",
    "Posted": "Проведён",
    "common.status.voided": "Аннулирован",
    "Voided": "Аннулирован",
    "common.status.draft": "Черновик",
    "Draft": "Черновик",
    "common.status.success": "Успешно",
    "common.status.error": "Ошибка",
    "accounting.title": "Бухгалтерия",
    "accounting.description": "Управляйте счетами, сопоставлениями, периодами, журналами и финансовой отчётностью.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Управляйте счетами, сопоставлениями, периодами, журналами и финансовой отчётностью.",
    "accounting.tab.overview": "Обзор",
    "Overview": "Обзор",
    "accounting.tab.accounts": "План счетов",
    "Chart of accounts": "План счетов",
    "accounting.tab.mappings": "Сопоставления счетов",
    "Account mappings": "Сопоставления счетов",
    "accounting.tab.periods": "Учётные периоды",
    "Accounting periods": "Учётные периоды",
    "accounting.tab.journals": "Журналы",
    "Journals": "Журналы",
    "accounting.tab.reports": "Отчёты",
    "accounting.account.edit_title": "Изменить счёт",
    "Edit account": "Изменить счёт",
    "accounting.account.new_title": "Новый счёт",
    "New account": "Новый счёт",
    "accounting.account.save": "Сохранить счёт",
    "Save account": "Сохранить счёт",
    "accounting.account.create": "Создать счёт",
    "Create account": "Создать счёт",
    "accounting.account.code": "Код счёта",
    "Account code": "Код счёта",
    "accounting.account.name": "Название счёта",
    "accounting.account.type": "Тип счёта",
    "accounting.account.currency_id": "ID валюты",
    "Currency ID": "ID валюты",
    "accounting.account.active": "Активен",
    "accounting.account.unnamed": "Счёт без названия",
    "Unnamed account": "Счёт без названия",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Расходы на оплату труда",
    "Payroll expense": "Расходы на оплату труда",
    "accounting.type.asset": "Актив",
    "Asset": "Актив",
    "accounting.type.liability": "Обязательство",
    "Liability": "Обязательство",
    "accounting.type.equity": "Капитал",
    "Equity": "Капитал",
    "accounting.type.revenue": "Доход",
    "accounting.type.expense": "Расход",
    "Expense": "Расход",
    "accounting.toast.account_updated": "Счёт обновлён",
    "Account updated": "Счёт обновлён",
    "accounting.toast.account_created": "Счёт создан",
    "Account created": "Счёт создан",
    "accounting.toast.defaults_created": "Созданы счета по умолчанию",
    "Default accounts created": "Созданы счета по умолчанию",
    "accounting.toast.mapping_saved": "Сопоставление сохранено",
    "Mapping saved": "Сопоставление сохранено",
    "accounting.toast.period_closed": "Учётный период закрыт",
    "Accounting period closed": "Учётный период закрыт",
    "accounting.toast.period_created": "Учётный период создан",
    "Period created": "Учётный период создан",
    "accounting.toast.journal_created": "Журнальная запись создана",
    "Journal created": "Журнальная запись создана",
    "accounting.toast.journal_voided": "Журнальная запись аннулирована",
    "Journal voided": "Журнальная запись аннулирована",
    "accounting.validation.journal_balanced": "В журнале должны быть указаны дата и описание, а суммы дебета и кредита должны совпадать.",
    "Journal must have a date, description, and balanced debit and credit totals.": "В журнале должны быть указаны дата и описание, а суммы дебета и кредита должны совпадать.",
    "accounting.filter.all_types": "Все типы счетов",
    "All account types": "Все типы счетов",
    "accounting.filter.all_statuses": "Все статусы",
    "All statuses": "Все статусы",
    "accounting.action.bootstrap": "Создать счета по умолчанию",
    "Bootstrap defaults": "Создать счета по умолчанию",
    "accounting.action.new_account": "Новый счёт",
    "accounting.empty.accounts": "Счета не найдены.",
    "No accounts found.": "Счета не найдены.",
    "accounting.column.code": "Код",
    "Code": "Код",
    "accounting.column.account": "Счёт",
    "accounting.column.type": "Тип",
    "Type": "Тип",
    "accounting.column.currency": "Валюта",
    "accounting.column.status": "Статус",
    "accounting.action.edit": "Изменить",
    "accounting.mapping.edit_title": "Изменить сопоставление счетов",
    "Edit account mapping": "Изменить сопоставление счетов",
    "accounting.mapping.new_title": "Новое сопоставление счетов",
    "New account mapping": "Новое сопоставление счетов",
    "accounting.mapping.save": "Сохранить сопоставление",
    "Save mapping": "Сохранить сопоставление",
    "accounting.mapping.create": "Создать сопоставление",
    "Create mapping": "Создать сопоставление",
    "accounting.mapping.source_type": "Тип источника",
    "Source type": "Тип источника",
    "accounting.mapping.event_key": "Ключ события",
    "Event key": "Ключ события",
    "accounting.mapping.debit_account": "Счёт дебета",
    "Debit account": "Счёт дебета",
    "accounting.mapping.credit_account": "Счёт кредита",
    "Credit account": "Счёт кредита",
    "accounting.mapping.tax_account": "Счёт налога",
    "Tax account": "Счёт налога",
    "accounting.mapping.none": "Нет",
    "None": "Нет",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Фильтр по типу источника",
    "Filter source type": "Фильтр по типу источника",
    "accounting.action.new_mapping": "Новое сопоставление",
    "New mapping": "Новое сопоставление",
    "accounting.empty.mappings": "Сопоставления счетов не найдены.",
    "No account mappings found.": "Сопоставления счетов не найдены.",
    "accounting.column.source": "Источник",
    "Source": "Источник",
    "accounting.column.event": "Событие",
    "Event": "Событие",
    "accounting.column.debit": "Дебет",
    "Debit": "Дебет",
    "accounting.column.credit": "Кредит",
    "Credit": "Кредит",
    "accounting.period.close_confirm": "Закрыть период {period}? Это действие нельзя отменить.",
    "Close {period}? This cannot be reversed.": "Закрыть период {period}? Это действие нельзя отменить.",
    "accounting.period.this": "этот учётный период",
    "this accounting period": "этот учётный период",
    "accounting.period.new_title": "Новый учётный период",
    "New accounting period": "Новый учётный период",
    "accounting.period.create": "Создать период",
    "Create period": "Создать период",
    "accounting.period.name": "Название периода",
    "Period name": "Название периода",
    "accounting.period.start": "Дата начала",
    "accounting.period.end": "Дата окончания",
    "End date": "Дата окончания",
    "accounting.period.name_placeholder": "Январь 2027",
    "January 2027": "Январь 2027",
    "accounting.period.open": "Открытый",
    "accounting.period.closed": "Закрытый",
    "accounting.action.new_period": "Новый период",
    "New period": "Новый период",
    "accounting.empty.periods": "Учётные периоды не найдены.",
    "No accounting periods found.": "Учётные периоды не найдены.",
    "accounting.column.period": "Период",
    "accounting.column.start": "Начало",
    "Start": "Начало",
    "accounting.column.end": "Окончание",
    "accounting.action.close_period": "Закрыть период",
    "Close period": "Закрыть период",
    "accounting.journal.new_title": "Новая журнальная запись",
    "New journal": "Новая журнальная запись",
    "accounting.journal.balance_help": "Перед сохранением дебет и кредит должны быть сбалансированы.",
    "Debits and credits must balance before saving.": "Перед сохранением дебет и кредит должны быть сбалансированы.",
    "accounting.journal.close": "Закрыть",
    "accounting.journal.entry_date": "Дата проводки",
    "Entry date": "Дата проводки",
    "accounting.journal.description": "Описание",
    "accounting.journal.source_type": "Тип источника",
    "accounting.journal.source_id": "ID источника",
    "Source ID": "ID источника",
    "accounting.journal.account": "Счёт",
    "accounting.journal.select_account": "Выберите счёт",
    "Select account": "Выберите счёт",
    "accounting.journal.debit_total": "Дебет: {debit} · Кредит: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Дебет: {debit} · Кредит: {credit} · {status}",
    "accounting.journal.balanced": "Сбалансировано",
    "Balanced": "Сбалансировано",
    "accounting.journal.unbalanced": "Не сбалансировано",
    "Unbalanced": "Не сбалансировано",
    "accounting.journal.add_line": "Добавить строку",
    "Add line": "Добавить строку",
    "accounting.journal.save": "Сохранить журнал",
    "Save journal": "Сохранить журнал",
    "accounting.journal.empty": "Нет строк журнала.",
    "No journal lines.": "Нет строк журнала.",
    "accounting.journal.reason_prompt": "Причина аннулирования этой журнальной записи:",
    "Reason for voiding this journal:": "Причина аннулирования этой журнальной записи:",
    "accounting.journal.details_title": "Журнальная запись №{id}",
    "Journal #{id}": "Журнальная запись №{id}",
    "accounting.action.view": "Просмотр",
    "View": "Просмотр",
    "accounting.action.void": "Аннулировать",
    "Void": "Аннулировать",
    "accounting.filter.all_accounts": "Все счета",
    "All accounts": "Все счета",
    "accounting.empty.journals": "Журналы не найдены.",
    "No journals found.": "Журналы не найдены.",
    "accounting.column.date": "Дата",
    "accounting.column.description": "Описание",
    "accounting.column.account_source": "Источник",
    "accounting.empty.journal_lines": "Нет строк журнала.",
    "accounting.report.trial_balance": "Оборотно-сальдовая ведомость",
    "Trial balance": "Оборотно-сальдовая ведомость",
    "accounting.report.general_ledger": "Главная книга",
    "General ledger": "Главная книга",
    "accounting.action.run_report": "Сформировать отчёт",
    "Run report": "Сформировать отчёт",
    "accounting.report.loading": "Загрузка отчёта…",
    "Loading report…": "Загрузка отчёта…",
    "accounting.empty.report": "Строки отчёта не найдены.",
    "No report rows found.": "Строки отчёта не найдены.",
    "accounting.report.choose_run": "Выберите отчёт и запустите его.",
    "Choose a report and run it.": "Выберите отчёт и запустите его.",
    "accounting.column.balance": "Баланс",
    "Balance": "Баланс",
    "accounting.overview.chart_title": "План счетов",
    "accounting.overview.chart_description": "Настройте счета, используемые в главной книге.",
    "Define the accounts used by your ledger.": "Настройте счета, используемые в главной книге.",
    "accounting.overview.journals_title": "Журналы",
    "accounting.overview.journals_description": "Создавайте и проверяйте сбалансированные журнальные записи.",
    "Create and review balanced journal entries.": "Создавайте и проверяйте сбалансированные журнальные записи.",
    "accounting.overview.reports_title": "Отчёты",
    "accounting.overview.reports_description": "Формируйте оборотно-сальдовую ведомость и главную книгу.",
    "Run trial balance and general ledger reports.": "Формируйте оборотно-сальдовую ведомость и главную книгу.",
    "common.refresh": "Обновить",
    "reports.search.title": "Поисковая аналитика",
    "Search analytics": "Поисковая аналитика",
    "reports.search.back_to_report": "Назад к отчёту",
    "Back to report": "Назад к отчёту",
    "reports.search.description": "Данные о поисковых запросах показывают, что ищут посетители и для каких запросов в каталоге не хватает предложений.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "Данные о поисковых запросах показывают, что ищут посетители и для каких запросов в каталоге не хватает предложений.",
    "reports.search.metric.searches": "Поисковые запросы",
    "Searches": "Поисковые запросы",
    "reports.search.metric.unique_keywords": "Уникальные ключевые слова",
    "Unique keywords": "Уникальные ключевые слова",
    "reports.search.metric.with_listings": "С объявлениями",
    "With listings": "С объявлениями",
    "reports.search.metric.no_matches": "Нет подходящих товаров",
    "No listing matches": "Нет подходящих товаров",
    "reports.search.metric.coverage": "Охват",
    "Coverage": "Охват",
    "reports.search.insights.title": "Статистика для администратора",
    "Admin insights": "Статистика для администратора",
    "reports.search.insights.no_results_one": "По запросу «{count}» не найдено ни одного объявления. Создайте объявление, добавьте запрос как категорию или тег либо улучшите название и описание объявления.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "По запросу «{count}» не найдено ни одного объявления. Создайте объявление, добавьте запрос как категорию или тег либо улучшите название и описание объявления.",
    "reports.search.insights.no_results_many": "По запросу {count} ключевых слов не найдено объявлений. Создайте объявления, добавьте эти термины как категории или теги либо улучшите названия и описания.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "По запросу {count} ключевых слов не найдено объявлений. Создайте объявления, добавьте эти термины как категории или теги либо улучшите названия и описания.",
    "reports.search.insights.all_covered": "По каждому отслеживаемому запросу найдено хотя бы одно объявление. Изучите самые частые запросы, чтобы улучшить подбор товаров и размещение по категориям.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "По каждому отслеживаемому запросу найдено хотя бы одно объявление. Изучите самые частые запросы, чтобы улучшить подбор товаров и размещение по категориям.",
    "reports.search.insights.empty": "Данные появятся после того, как посетители начнут искать товары на маркетплейсе.",
    "Search data will appear after visitors search the marketplace.": "Данные появятся после того, как посетители начнут искать товары на маркетплейсе.",
    "reports.search.insights.total_matches": "Всего найдено совпадений с объявлениями: {count} по загруженным записям поиска.",
    "{count} total listing matches were returned across the loaded search records.": "Всего найдено совпадений с объявлениями: {count} по загруженным записям поиска.",
    "reports.search.coverage_title": "Охват ключевых слов",
    "Keyword coverage": "Охват ключевых слов",
    "reports.search.loading": "Загрузка поисковой аналитики…",
    "Loading search analytics…": "Загрузка поисковой аналитики…",
    "reports.search.empty": "Поисковые фразы не найдены.",
    "No search phrases found.": "Поисковые фразы не найдены.",
    "reports.search.error.load": "Не удалось загрузить поисковую аналитику.",
    "Unable to load search analytics.": "Не удалось загрузить поисковую аналитику.",
    "reports.search.unknown": "Неизвестный запрос",
    "Unknown search": "Неизвестный запрос",
    "reports.search.column.keyword": "Ключевое слово",
    "Keyword": "Ключевое слово",
    "reports.search.column.listings": "Объявления",
    "reports.search.column.coverage": "Охват",
    "reports.search.column.last_searched": "Последний поиск",
    "Last searched": "Последний поиск",
    "reports.search.column.suggested_action": "Рекомендуемое действие",
    "Suggested action": "Рекомендуемое действие",
    "reports.search.status.covered": "Есть результаты",
    "Covered": "Есть результаты",
    "reports.search.status.no_matches": "Нет совпадений",
    "No matches": "Нет совпадений",
    "reports.search.action.review_ranking": "Проверить рейтинг",
    "Review ranking": "Проверить рейтинг",
    "reports.search.action.add_listing": "Добавить объявление или категорию",
    "Add listing or category": "Добавить объявление или категорию",
    "platform_health.title": "Состояние платформы",
    "Platform health": "Состояние платформы",
    "platform_health.tab.health": "Состояние",
    "Health": "Состояние",
    "platform_health.tab.configuration": "Настройки",
    "platform_health.action.refreshing": "Обновление…",
    "Refreshing…": "Обновление…",
    "platform_health.window_note": "В текущем представлении загружаются первые {count} записей для каждого типа события.",
    "The current view loads the first {count} records for each event type.": "В текущем представлении загружаются первые {count} записей для каждого типа события.",
    "platform_health.error.title": "Не удалось загрузить журналы аудита аутентификации",
    "Unable to load authentication audits": "Не удалось загрузить журналы аудита аутентификации",
    "platform_health.error.proxy_note": "Возможно, API требует отправлять этот запрос администратора через сервер, а не напрямую из браузера.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "Возможно, API требует отправлять этот запрос администратора через сервер, а не напрямую из браузера.",
    "platform_health.error.session": "Сеанс администратора ещё не готов. Войдите снова.",
    "Your admin session is not ready yet. Please sign in again.": "Сеанс администратора ещё не готов. Войдите снова.",
    "platform_health.error.load": "Не удалось загрузить журналы аудита аутентификации ({status}).",
    "Unable to load authentication audits ({status}).": "Не удалось загрузить журналы аудита аутентификации ({status}).",
    "platform_health.error.load_generic": "Не удалось загрузить журналы состояния платформы.",
    "Unable to load platform health audits.": "Не удалось загрузить журналы состояния платформы.",
    "platform_health.metric.login_attempts": "Попытки входа",
    "Login attempts": "Попытки входа",
    "platform_health.metric.signup_attempts": "Попытки регистрации",
    "Signup attempts": "Попытки регистрации",
    "platform_health.metric.audit_records": "Записи аудита",
    "Audit records": "Записи аудита",
    "platform_health.metric.successful": "Успешно",
    "platform_health.metric.failed": "Не удалось",
    "platform_health.metric.outcome_returned": "Только если получен результат",
    "Only when outcome is returned": "Только если получен результат",
    "platform_health.metric.failure_rate": "Доля ошибок",
    "Failure rate": "Доля ошибок",
    "platform_health.metric.classified_records": "Классифицированные записи",
    "Classified records": "Классифицированные записи",
    "platform_health.activity.title": "Активность аутентификации",
    "Authentication activity": "Активность аутентификации",
    "platform_health.activity.description": "Попытки за выбранный период аудита",
    "Attempts returned by the selected audit window": "Попытки за выбранный период аудита",
    "platform_health.activity.no_timestamps": "Записи аудита с отметками времени не получены.",
    "No timestamped audit records returned.": "Записи аудита с отметками времени не получены.",
    "platform_health.event.login": "Вход",
    "login": "Вход",
    "platform_health.event.signup": "Регистрация",
    "signup": "Регистрация",
    "platform_health.status.success": "Успешно",
    "platform_health.status.failed": "Не удалось",
    "platform_health.status.recorded": "Записано",
    "Recorded": "Записано",
    "platform_health.unknown_day": "Неизвестно",
    "Unknown": "Неизвестно",
    "platform_health.failure_reasons": "Причины ошибок",
    "Failure reasons": "Причины ошибок",
    "platform_health.no_failures": "Классифицированных ошибок не найдено.",
    "No classified failures returned.": "Классифицированных ошибок не найдено.",
    "platform_health.unspecified_failure": "Причина ошибки не указана",
    "Unspecified failure": "Причина ошибки не указана",
    "platform_health.recent_records": "Последние записи аудита",
    "Recent audit records": "Последние записи аудита",
    "platform_health.normalized_note": "Исходные поля приводятся к единому формату только для отображения.",
    "Raw fields are normalized only for display.": "Исходные поля приводятся к единому формату только для отображения.",
    "platform_health.loaded_count": "Загружено: {count}",
    "{count} loaded": "Загружено: {count}",
    "platform_health.loading_records": "Загрузка записей аудита…",
    "Loading audit records…": "Загрузка записей аудита…",
    "platform_health.no_records": "Записи аудита не получены.",
    "No audit records returned.": "Записи аудита не получены.",
    "platform_health.column.event": "Событие",
    "platform_health.column.status": "Статус",
    "platform_health.column.user": "Пользователь",
    "User": "Пользователь",
    "platform_health.column.time": "Время",
    "Time": "Время",
    "platform_health.column.reason": "Причина",
    "Reason": "Причина",
    "platform_health.config.sign_in": "Способ входа",
    "Sign-in method": "Способ входа",
    "platform_health.config.facebook": "Аутентификация Facebook",
    "platform_health.config.google": "Аутентификация Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Эти настройки применяются сразу. После сохранения они отображаются в приложениях и ответах API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Эти настройки применяются сразу. После сохранения они отображаются в приложениях и ответах API.",
    "integrations.note.mobile_release": "Настройки канала мобильного приложения применяются при выпуске или обновлении продукта. Чтобы получить новую сборку, запросите её на портале поддержки. Это относится к тарифу Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Настройки канала мобильного приложения применяются при выпуске или обновлении продукта. Чтобы получить новую сборку, запросите её на портале поддержки. Это относится к тарифу Starter.",
    "integrations.toast.saved": "Настройки интеграции сохранены.",
    "Integration settings saved.": "Настройки интеграции сохранены.",
    "integrations.error.save": "Не удалось сохранить настройки интеграции.",
    "Unable to save integration settings.": "Не удалось сохранить настройки интеграции.",
    "integrations.twilio.title": "Интеграция Twilio",
    "Twilio integration": "Интеграция Twilio",
    "integrations.twilio.account_sid": "Идентификатор аккаунта (SID)",
    "Account SID": "Идентификатор аккаунта (SID)",
    "integrations.twilio.account_sid_placeholder": "Введите SID аккаунта",
    "Enter account SID": "Введите SID аккаунта",
    "integrations.twilio.auth_token": "Токен авторизации",
    "Auth token": "Токен авторизации",
    "integrations.twilio.auth_token_placeholder": "Введите токен авторизации",
    "Enter auth token": "Введите токен авторизации",
    "integrations.twilio.source_phone": "Номер телефона отправителя",
    "Source phone number": "Номер телефона отправителя",
    "integrations.twilio.source_phone_placeholder": "Введите номер телефона отправителя",
    "Enter source phone number": "Введите номер телефона отправителя",
    "integrations.facebook.title": "Аутентификация Facebook",
    "integrations.facebook.enable_login": "Включить вход через Facebook",
    "Enable Facebook login": "Включить вход через Facebook",
    "integrations.facebook.app_id": "ID приложения",
    "App ID": "ID приложения",
    "integrations.facebook.app_id_placeholder": "Введите ID приложения",
    "Enter app ID": "Введите ID приложения",
    "integrations.google.title": "Аутентификация Google",
    "integrations.google.enable_sign_in": "Включить вход через Google",
    "Enable Google sign-in": "Включить вход через Google",
    "integrations.google.client_id": "ID клиента",
    "Client ID": "ID клиента",
    "integrations.google.client_id_placeholder": "Введите ID клиента",
    "Enter client ID": "Введите ID клиента",
    "integrations.auth.title": "Способ входа",
    "integrations.auth.description": "Выберите способ регистрации и входа пользователей. Для подтверждения по электронной почте и SMS используются настроенные параметры доставки клиента.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Выберите способ регистрации и входа пользователей. Для подтверждения по электронной почте и SMS используются настроенные параметры доставки клиента.",
    "integrations.auth.empty": "Поддерживаемый способ входа не настроен. Выберите один из вариантов, чтобы продолжить.",
    "No supported sign-in method is currently configured. Select one to continue.": "Поддерживаемый способ входа не настроен. Выберите один из вариантов, чтобы продолжить.",
    "integrations.auth.save_note": "После сохранения этот способ будет применяться к конечным точкам регистрации и входа клиента. Пользователи, созданные напрямую, управляются отдельно.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "После сохранения этот способ будет применяться к конечным точкам регистрации и входа клиента. Пользователи, созданные напрямую, управляются отдельно.",
    "integrations.auth.error.load": "Не удалось загрузить текущий способ входа.",
    "Unable to load the current sign-in method.": "Не удалось загрузить текущий способ входа.",
    "integrations.auth.error.save": "Не удалось сохранить способ входа.",
    "Unable to save the sign-in method.": "Не удалось сохранить способ входа.",
    "integrations.auth.toast.saved": "Способ входа сохранён.",
    "Sign-in method saved.": "Способ входа сохранён.",
    "integrations.auth.email_password": "Электронная почта и пароль",
    "Email and password": "Электронная почта и пароль",
    "integrations.auth.email_password_help": "Пользователи подтверждают электронную почту при регистрации, затем входят с паролем.",
    "Users verify their email during sign-up, then sign in with a password.": "Пользователи подтверждают электронную почту при регистрации, затем входят с паролем.",
    "integrations.auth.email_code": "Одноразовый код по электронной почте",
    "Email one-time code": "Одноразовый код по электронной почте",
    "integrations.auth.email_code_help": "Пользователи получают код подтверждения по электронной почте для регистрации и входа.",
    "Users receive a verification code by email for sign-up and sign-in.": "Пользователи получают код подтверждения по электронной почте для регистрации и входа.",
    "integrations.auth.phone_code": "Одноразовый код по телефону",
    "Phone one-time code": "Одноразовый код по телефону",
    "integrations.auth.phone_code_help": "Пользователи получают код подтверждения по SMS для регистрации и входа.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Пользователи получают код подтверждения по SMS для регистрации и входа.",
    "integrations.auth.phone_password": "Телефон и пароль",
    "Phone and password": "Телефон и пароль",
    "integrations.auth.phone_password_help": "Пользователи подтверждают телефон при регистрации, затем входят с паролем.",
    "Users verify their phone during sign-up, then sign in with a password.": "Пользователи подтверждают телефон при регистрации, затем входят с паролем.",
    "integrations.auth.email_password_unverified": "Электронная почта и пароль без подтверждения при регистрации",
    "Email and password without sign-up verification": "Электронная почта и пароль без подтверждения при регистрации",
    "integrations.auth.email_password_unverified_help": "Пользователи могут зарегистрироваться с электронной почтой и паролем без кода подтверждения.",
    "Users can sign up with an email and password without an email verification code.": "Пользователи могут зарегистрироваться с электронной почтой и паролем без кода подтверждения.",
    "integrations.auth.phone_password_unverified": "Телефон и пароль без подтверждения при регистрации",
    "Phone and password without sign-up verification": "Телефон и пароль без подтверждения при регистрации",
    "integrations.auth.phone_password_unverified_help": "Пользователи могут зарегистрироваться с телефоном и паролем без кода подтверждения по SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Пользователи могут зарегистрироваться с телефоном и паролем без кода подтверждения по SMS.",
    "integrations.page.title": "Интеграции приложений",
    "integrations.generic.id_placeholder": "Введите ID {name}",
    "Enter {name} ID": "Введите ID {name}",
    "integrations.generic.enable": "Включить интеграцию {name}",
    "Enable {name} integration": "Включить интеграцию {name}",
    "integrations.menu.map": "Карты",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Интеграция карт",
    "Maps integration": "Интеграция карт",
    "integrations.maps.google": "Google Карты",
    "Google Maps": "Google Карты",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Ключ API",
    "API key": "Ключ API",
    "integrations.maps.api_key_placeholder": "Введите ключ API",
    "Enter API key": "Введите ключ API",
    "integrations.maps.reverse_geocode_key": "Ключ API геокодирования Google Maps",
    "Google Maps reverse geocoding API key": "Ключ API геокодирования Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Введите ключ API геокодирования Google Maps",
    "Enter Google Maps reverse geocoding API key": "Введите ключ API геокодирования Google Maps",
    "integrations.maps.places_key": "Ключ Places API Google Maps",
    "Google Maps Places API key": "Ключ Places API Google Maps",
    "integrations.maps.places_key_placeholder": "Введите ключ Places API Google Maps",
    "Enter Google Maps Places API key": "Введите ключ Places API Google Maps",
    "integrations.maps.nearby_accounts": "Включить ближайшие аккаунты на главной странице",
    "Activate nearby accounts on the home page": "Включить ближайшие аккаунты на главной странице",
    "integrations.maps.listing_location": "Включить местоположение при размещении объявления",
    "Activate location in listing submission": "Включить местоположение при размещении объявления",
    "integrations.maps.account_location": "Включить местоположение при создании аккаунта",
    "Activate location in account submission": "Включить местоположение при создании аккаунта",
    "integrations.playstore.title": "Интеграция Google Play",
    "Google Play integration": "Интеграция Google Play",
    "integrations.playstore.application_id": "ID приложения",
    "Application ID": "ID приложения",
    "integrations.playstore.application_id_placeholder": "Введите ID приложения (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Введите ID приложения (com.tenantname.app)",
    "integrations.playstore.first_name": "Имя",
    "integrations.playstore.first_name_placeholder": "Введите имя",
    "Enter first name": "Введите имя",
    "integrations.playstore.last_name": "Фамилия",
    "integrations.playstore.last_name_placeholder": "Введите фамилию",
    "Enter last name": "Введите фамилию",
    "integrations.playstore.unit": "Подразделение",
    "Organizational unit": "Подразделение",
    "integrations.playstore.unit_placeholder": "Введите подразделение",
    "Enter organizational unit": "Введите подразделение",
    "integrations.playstore.organization": "Организация",
    "Organization": "Организация",
    "integrations.playstore.organization_placeholder": "Введите название организации",
    "Enter organization name": "Введите название организации",
    "integrations.playstore.city": "Город или населённый пункт",
    "City or locality": "Город или населённый пункт",
    "integrations.playstore.city_placeholder": "Введите город или населённый пункт",
    "Enter city or locality": "Введите город или населённый пункт",
    "integrations.playstore.state": "Штат или провинция",
    "State or province": "Штат или провинция",
    "integrations.playstore.state_placeholder": "Введите штат или провинцию",
    "Enter state or province": "Введите штат или провинцию",
    "integrations.playstore.country_code": "Код страны (XX)",
    "Country code (XX)": "Код страны (XX)",
    "integrations.playstore.country_code_placeholder": "Введите код страны",
    "Enter country code": "Введите код страны",
    "integrations.playstore.link": "Ссылка Google Play",
    "Google Play link": "Ссылка Google Play",
    "integrations.playstore.link_placeholder": "Введите ссылку на приложение в Google Play",
    "Enter your app Google Play link": "Введите ссылку на приложение в Google Play",
    "integrations.admob.title": "Интеграция AdMob",
    "AdMob integration": "Интеграция AdMob",
    "integrations.admob.app_id": "ID приложения",
    "integrations.admob.app_id_placeholder": "Введите ID приложения",
    "Enter App ID": "Введите ID приложения",
    "integrations.admob.unit_id": "ID рекламного блока",
    "Unit ID": "ID рекламного блока",
    "integrations.admob.unit_id_placeholder": "Введите ID рекламного блока AdMob",
    "Enter AdMob unit ID": "Введите ID рекламного блока AdMob",
    "integrations.admob.listings_id": "ID объявлений",
    "Listings ID": "ID объявлений",
    "integrations.admob.listings_id_placeholder": "Введите ID объявлений",
    "Enter listings ID": "Введите ID объявлений",
    "integrations.admob.listing_detail_id": "ID страницы объявления",
    "Listing detail ID": "ID страницы объявления",
    "integrations.admob.listing_detail_id_placeholder": "Введите ID страницы объявления",
    "Enter listing detail ID": "Введите ID страницы объявления",
    "integrations.admob.home_id": "ID главной страницы",
    "Home ID": "ID главной страницы",
    "integrations.admob.home_id_placeholder": "Введите ID главной страницы",
    "Enter home ID": "Введите ID главной страницы",
    "integrations.admob.enable_ads": "Включить рекламу",
    "Enable ads": "Включить рекламу",
    "integrations.admob.enable_listing_ads": "Включить рекламу в ленте объявлений",
    "Enable ads on the listings feed": "Включить рекламу в ленте объявлений",
    "integrations.admob.enable_listing_detail_ads": "Включить рекламу в карточке объявления",
    "Enable ads on listing details": "Включить рекламу в карточке объявления",
    "integrations.admob.enable_home_ads": "Включить рекламу в нижней навигации главной страницы",
    "Enable ads in the home bottom navigation": "Включить рекламу в нижней навигации главной страницы",
    "integrations.save_success": "Успешно сохранено",
    "Saved successfully": "Успешно сохранено",
    "integrations.note.release": "Эти настройки применяются при выпуске или обновлении мобильного приложения. После изменений запросите новую сборку на портале поддержки. Действует тариф Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Эти настройки применяются при выпуске или обновлении мобильного приложения. После изменений запросите новую сборку на портале поддержки. Действует тариф Starter.",
    "integrations.action.download": "Скачать",
    "integrations.branch.title": "Интеграция Branch",
    "Branch integration": "Интеграция Branch",
    "integrations.branch.app_id": "ID приложения",
    "integrations.branch.app_id_placeholder": "Введите ID приложения",
    "integrations.branch.live_key": "Рабочий ключ",
    "Live key": "Рабочий ключ",
    "integrations.branch.live_key_placeholder": "Введите рабочий ключ",
    "Enter live key": "Введите рабочий ключ",
    "integrations.branch.live_secret": "Рабочий секретный ключ",
    "Live secret": "Рабочий секретный ключ",
    "integrations.branch.live_secret_placeholder": "Введите рабочий секретный ключ",
    "Enter live secret": "Введите рабочий секретный ключ",
    "integrations.branch.uri_scheme": "Схема URI",
    "URI scheme": "Схема URI",
    "integrations.branch.uri_scheme_placeholder": "Введите схему URI",
    "Enter URI scheme": "Введите схему URI",
    "integrations.branch.link_domain": "Домен ссылки",
    "Link domain": "Домен ссылки",
    "integrations.branch.link_domain_placeholder": "Введите домен ссылки",
    "Enter link domain": "Введите домен ссылки",
    "integrations.branch.alternate_domain": "Дополнительный домен ссылки",
    "Alternate link domain": "Дополнительный домен ссылки",
    "integrations.branch.alternate_domain_placeholder": "Введите дополнительный домен ссылки",
    "Enter alternate link domain": "Введите дополнительный домен ссылки",
    "integrations.branch.link_description": "Описание ссылки",
    "Link description": "Описание ссылки",
    "integrations.branch.link_description_placeholder": "Введите описание ссылки",
    "Enter link description": "Введите описание ссылки",
    "integrations.branch.invite_friends": "Пригласить друзей",
    "Invite friends": "Пригласить друзей",
    "integrations.branch.invite_title": "Название",
    "integrations.branch.invite_description": "Описание",
    "integrations.branch.destination_link": "Целевая ссылка Branch (необязательно)",
    "Branch destination link (optional)": "Целевая ссылка Branch (необязательно)",
    "integrations.branch.web_app_note": "Применяется к пользователям веб-приложения",
    "Applies to web app users": "Применяется к пользователям веб-приложения",
    "integrations.branch.destination_placeholder": "Введите целевую ссылку Branch",
    "Enter branch destination link": "Введите целевую ссылку Branch",
    "integrations.ios.title": "Настройка App Store",
    "App Store provisioning": "Настройка App Store",
    "integrations.ios.bundle_id": "Идентификатор пакета",
    "Bundle ID": "Идентификатор пакета",
    "integrations.ios.bundle_id_placeholder": "Введите идентификатор пакета",
    "Enter bundle ID": "Введите идентификатор пакета",
    "integrations.ios.certificate_password": "Пароль сертификата распространения",
    "Distribution certificate password": "Пароль сертификата распространения",
    "integrations.ios.certificate_password_placeholder": "Введите пароль сертификата распространения",
    "Enter distribution certificate password": "Введите пароль сертификата распространения",
    "integrations.ios.push_key_id": "ID push-ключа",
    "Push key ID": "ID push-ключа",
    "integrations.ios.push_key_id_placeholder": "Введите ID push-ключа",
    "Enter push key ID": "Введите ID push-ключа",
    "integrations.ios.team_id": "ID команды",
    "Team ID": "ID команды",
    "integrations.ios.team_id_placeholder": "Введите ID команды",
    "Enter team ID": "Введите ID команды",
    "integrations.ios.apple_id": "Apple ID",
    "Apple ID": "Apple ID",
    "integrations.ios.apple_id_placeholder": "Введите Apple ID",
    "Enter Apple ID": "Введите Apple ID",
    "integrations.ios.distribution_certificate": "Сертификат распространения",
    "Distribution certificate": "Сертификат распространения",
    "integrations.ios.provisioning_profile": "Профиль подготовки распространения",
    "Distribution provisioning profile": "Профиль подготовки распространения",
    "integrations.ios.push_key": "Push-ключ",
    "Push key": "Push-ключ",
    "integrations.ios.app_store_link": "Ссылка на App Store",
    "Your App Store link": "Ссылка на App Store",
    "integrations.ios.app_store_link_placeholder": "Введите ссылку на приложение в App Store",
    "Enter your app App Store link": "Введите ссылку на приложение в App Store",
    "integrations.firebase.title": "Интеграция Firebase",
    "Firebase integration": "Интеграция Firebase",
    "integrations.firebase.choose_file": "Выбрать файл",
    "integrations.firebase.service_account": "Сервисный аккаунт Firebase",
    "Firebase service account": "Сервисный аккаунт Firebase",
    "integrations.firebase.android_json": "JSON-файл приложения Android",
    "Android app JSON file": "JSON-файл приложения Android",
    "integrations.firebase.ios_plist": "Файл plist приложения iOS",
    "iOS app plist file": "Файл plist приложения iOS",
    "integrations.firebase.create_project": "Создать проект Firebase",
    "Create Firebase project": "Создать проект Firebase",
    "integrations.firebase.create_android": "Создать приложение Android",
    "Create Android app": "Создать приложение Android",
    "integrations.firebase.create_ios": "Создать приложение iOS",
    "Create iOS app": "Создать приложение iOS",
    "integrations.firebase.create_database": "Создать базу данных реального времени",
    "Create realtime database": "Создать базу данных реального времени",
    "integrations.firebase.apply_rules": "Применить правила базы данных Firebase",
    "Apply Firebase database rules": "Применить правила базы данных Firebase",
    "bundles.listing_number": "Товар №{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Настроить комплект",
    "Configure bundle": "Настроить комплект",
    "bundles.configure.subtitle": "Комплект №{id} · добавьте существующие товары ниже.",
    "Bundle listing #{id} · add existing listings below.": "Комплект №{id} · добавьте существующие товары ниже.",
    "bundles.back": "Назад к комплектам",
    "Back to bundles": "Назад к комплектам",
    "bundles.fixed_components": "Фиксированные компоненты",
    "Fixed components": "Фиксированные компоненты",
    "bundles.selection_pool": "Набор товаров на выбор",
    "Mix-and-match pool": "Набор товаров на выбор",
    "bundles.available_listings": "Доступные товары",
    "Available listings": "Доступные товары",
    "bundles.available_description": "Найдите и добавьте товары, уже имеющиеся в каталоге.",
    "Search and add products already in your catalogue.": "Найдите и добавьте товары, уже имеющиеся в каталоге.",
    "bundles.search_listings": "Поиск товаров",
    "bundles.quantity_per_component": "Количество для компонента",
    "Quantity per component": "Количество для компонента",
    "bundles.loading_listings": "Загрузка товаров…",
    "Loading listings…": "Загрузка товаров…",
    "bundles.added": "Добавлено",
    "Added": "Добавлено",
    "bundles.adding": "Добавление…",
    "Adding…": "Добавление…",
    "bundles.add": "Добавить",
    "bundles.no_matching_listings": "Подходящие товары не найдены.",
    "No matching listings found.": "Подходящие товары не найдены.",
    "bundles.one_listing_added": "Добавлен 1 товар",
    "1 listing added": "Добавлен 1 товар",
    "bundles.many_listings_added": "Добавлено товаров: {count}",
    "{count} listings added": "Добавлено товаров: {count}",
    "bundles.quantity_short": "Кол-во: {count}",
    "Qty {count}": "Кол-во: {count}",
    "bundles.removing": "Удаление…",
    "Removing…": "Удаление…",
    "bundles.remove": "Убрать",
    "bundles.no_components": "Компоненты пока не добавлены.",
    "No components added yet.": "Компоненты пока не добавлены.",
    "bundles.pool_remove_note": "Для удаления из набора нужна серверная конечная точка; добавление уже доступно.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "Для удаления из набора нужна серверная конечная точка; добавление уже доступно.",
    "bundles.error.load_components": "Не удалось загрузить компоненты комплекта.",
    "Unable to load bundle components.": "Не удалось загрузить компоненты комплекта.",
    "bundles.error.add_listing": "Не удалось добавить товар в комплект.",
    "Unable to add listing to the bundle.": "Не удалось добавить товар в комплект.",
    "bundles.error.remove_component": "Не удалось удалить компонент комплекта.",
    "Unable to remove bundle component.": "Не удалось удалить компонент комплекта.",
    "bundles.error.load_listings": "Не удалось загрузить товары.",
    "Unable to load listings.": "Не удалось загрузить товары.",
    "bundles.components": "Компоненты комплекта",
    "Bundle components": "Компоненты комплекта",
    "bundles.picker_description": "Выберите товары из каталога. Они будут связаны после создания комплекта.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Выберите товары из каталога. Они будут связаны после создания комплекта.",
    "bundles.fixed_bundle": "Фиксированный комплект",
    "Fixed bundle": "Фиксированный комплект",
    "bundles.mix_match": "Соберите свой комплект",
    "Mix and match": "Соберите свой комплект",
    "bundles.quantity_per_selected": "Количество для каждого выбранного товара",
    "Quantity per selected listing": "Количество для каждого выбранного товара",
    "bundles.search_existing": "Поиск существующих товаров",
    "Search existing listings": "Поиск существующих товаров",
    "bundles.selected_count": "Выбрано ({count})",
    "Selected ({count})": "Выбрано ({count})",
    "bundles.choose_component_hint": "Выберите хотя бы один товар из каталога или сначала создайте комплект.",
    "Choose at least one existing listing, or create the bundle first.": "Выберите хотя бы один товар из каталога или сначала создайте комплект.",
    "bundles.error.attach_components": "Комплект создан, но не удалось прикрепить компоненты.",
    "The bundle was created, but components could not be attached.": "Комплект создан, но не удалось прикрепить компоненты.",
    "bundles.continue_configure_hint": "Настройку можно продолжить на странице комплекта.",
    "You can continue from the bundle configuration page.": "Настройку можно продолжить на странице комплекта.",
    "bundles.title": "Комплекты",
    "bundles.create": "Создать комплект",
    "Create bundle": "Создать комплект",
    "bundles.subtitle": "Создайте основной товар комплекта, затем добавьте фиксированные компоненты или набор товаров на выбор.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Создайте основной товар комплекта, затем добавьте фиксированные компоненты или набор товаров на выбор.",
    "bundles.workflow": "Процесс создания комплекта",
    "Bundle workflow": "Процесс создания комплекта",
    "bundles.how_it_works": "Как работают комплекты",
    "How bundles work": "Как работают комплекты",
    "bundles.parent_description": "Основной товар комплекта определяет, что увидит покупатель.",
    "One parent listing controls the customer-facing bundle.": "Основной товар комплекта определяет, что увидит покупатель.",
    "bundles.flow": "Этапы комплекта",
    "Bundle flow": "Этапы комплекта",
    "bundles.parent_listing": "Основной товар",
    "Parent listing": "Основной товар",
    "bundles.name_price_category": "Название, цена, категория",
    "Name, price, category": "Название, цена, категория",
    "bundles.fixed_or_pool": "Фиксированные товары или набор",
    "Fixed items or a pool": "Фиксированные товары или набор",
    "bundles.checkout_stock": "Оформление и остатки",
    "Checkout stock": "Оформление и остатки",
    "bundles.selection_availability": "Выбор и доступность",
    "Selection + availability": "Выбор и доступность",
    "bundles.fixed_bundles": "Фиксированные комплекты",
    "Fixed bundles": "Фиксированные комплекты",
    "bundles.fixed_description": "Продавайте заданную группу существующих товаров вместе.",
    "Sell a defined group of existing listings together.": "Продавайте заданную группу существующих товаров вместе.",
    "bundles.fixed_detail": "Добавьте существующие товары как фиксированные компоненты.",
    "Add existing listings as fixed components.": "Добавьте существующие товары как фиксированные компоненты.",
    "bundles.pool_description": "Позвольте покупателям выбирать подходящие товары из набора.",
    "Let customers choose eligible items from a bundle pool.": "Позвольте покупателям выбирать подходящие товары из набора.",
    "bundles.pool_detail": "Укажите минимальное и максимальное количество товаров при оформлении.",
    "Set the minimum and maximum selections at checkout.": "Укажите минимальное и максимальное количество товаров при оформлении.",
    "channels.opensource.title": "Стартовые наборы с открытым исходным кодом",
    "Open-source starter kits": "Стартовые наборы с открытым исходным кодом",
    "channels.opensource.view_org": "Открыть организацию GitHub",
    "View GitHub organization": "Открыть организацию GitHub",
    "channels.opensource.description": "Изучите репозитории Tradly с открытым исходным кодом и стартовые наборы организации TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Изучите репозитории Tradly с открытым исходным кодом и стартовые наборы организации TRADLY-PLATFORM.",
    "channels.opensource.loading": "Загрузка репозиториев…",
    "Loading repositories…": "Загрузка репозиториев…",
    "channels.opensource.error.http": "GitHub вернул {status}.",
    "GitHub returned {status}.": "GitHub вернул {status}.",
    "channels.opensource.error.load": "Не удалось загрузить репозитории. Повторите попытку позже.",
    "Unable to load repositories. Try again later.": "Не удалось загрузить репозитории. Повторите попытку позже.",
    "channels.opensource.empty": "Публичные репозитории не найдены.",
    "No public repositories found.": "Публичные репозитории не найдены.",
    "channels.opensource.repo_fallback": "Репозиторий Tradly с открытым исходным кодом.",
    "Open-source Tradly repository.": "Репозиторий Tradly с открытым исходным кодом.",
    "channels.opensource.language_code": "Код",
    "channels.opensource.view_repo": "Открыть репозиторий",
    "View repository": "Открыть репозиторий",
    "developer.mcp.select_all": "Выбрать все",
    "Select all": "Выбрать все",
    "developer.mcp.read": "Чтение",
    "developer.mcp.write": "Запись",
    "developer.mcp.delete": "Удаление",
    "developer.mcp.export": "Экспорт",
    "developer.mcp.copy": "Копировать",
    "Copy": "Копировать",
    "developer.mcp.copied": "Скопировано",
    "Copied": "Скопировано",
    "developer.mcp.connection_created": "Подключение создано",
    "Connection created": "Подключение создано",
    "developer.mcp.save_secret_warning": "Сохраните секретный ключ клиента сейчас — позже он больше не будет показан.",
    "Save your client secret now — it will not be shown again.": "Сохраните секретный ключ клиента сейчас — позже он больше не будет показан.",
    "developer.mcp.client_id": "ID клиента",
    "developer.mcp.client_secret": "Секретный ключ клиента",
    "developer.mcp.new_connection": "Новое подключение MCP",
    "New MCP connection": "Новое подключение MCP",
    "developer.mcp.platform": "Платформа",
    "Platform": "Платформа",
    "developer.mcp.platform_custom": "Другая",
    "developer.mcp.connection_name": "Название подключения",
    "Connection name": "Название подключения",
    "developer.mcp.connection_name_placeholder": "например, ChatGPT",
    "e.g. ChatGPT": "например, ChatGPT",
    "developer.mcp.redirect_uris": "URI перенаправления",
    "Redirect URIs": "URI перенаправления",
    "developer.mcp.one_per_line": "(по одному в строке)",
    "(one per line)": "(по одному в строке)",
    "developer.mcp.permissions": "Разрешения",
    "Permissions": "Разрешения",
    "developer.mcp.error.connection_name": "Введите название подключения",
    "Enter a connection name": "Введите название подключения",
    "developer.mcp.error.redirect_uri": "Введите хотя бы один URI перенаправления",
    "Enter at least one redirect URI": "Введите хотя бы один URI перенаправления",
    "developer.mcp.error.create": "Не удалось создать подключение",
    "Failed to create connection": "Не удалось создать подключение",
    "developer.mcp.creating": "Создание…",
    "Creating…": "Создание…",
    "developer.mcp.edit_permissions": "Изменить разрешения",
    "Edit permissions": "Изменить разрешения",
    "developer.mcp.permissions_updated": "Разрешения обновлены",
    "Permissions updated": "Разрешения обновлены",
    "developer.mcp.error.update_permissions": "Не удалось обновить разрешения",
    "Failed to update permissions": "Не удалось обновить разрешения",
    "developer.mcp.saving": "Сохранение…",
    "developer.mcp.error.load": "Не удалось загрузить подключения MCP.",
    "MCP connections could not be loaded.": "Не удалось загрузить подключения MCP.",
    "developer.mcp.confirm_delete": "Удалить это подключение? Оно будет удалено из списка, а доступ отозван.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Удалить это подключение? Оно будет удалено из списка, а доступ отозван.",
    "developer.mcp.connection_removed": "Подключение удалено",
    "Connection removed": "Подключение удалено",
    "developer.mcp.error.remove_connection": "Не удалось удалить подключение",
    "Failed to remove connection": "Не удалось удалить подключение",
    "developer.mcp.connection_deactivated": "Подключение отключено",
    "Connection deactivated": "Подключение отключено",
    "developer.mcp.error.deactivate_connection": "Не удалось отключить подключение",
    "Failed to deactivate connection": "Не удалось отключить подключение",
    "developer.mcp.title": "Подключения MCP",
    "MCP connections": "Подключения MCP",
    "developer.mcp.description": "Зарегистрированные у клиента OAuth-клиенты и приложения с ИИ, которым разрешено использовать сервер MCP этого клиента.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Зарегистрированные у клиента OAuth-клиенты и приложения с ИИ, которым разрешено использовать сервер MCP этого клиента.",
    "developer.mcp.empty": "Подключений пока нет. Создайте клиент или подключите приложение с ИИ к серверу MCP этого клиента.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Подключений пока нет. Создайте клиент или подключите приложение с ИИ к серверу MCP этого клиента.",
    "developer.mcp.status.connected_one": "Подключено · 1 пользователь",
    "Connected · 1 user": "Подключено · 1 пользователь",
    "developer.mcp.status.connected_many": "Подключено · пользователей: {count}",
    "Connected · {count} users": "Подключено · пользователей: {count}",
    "developer.mcp.status.deactivated": "Отключено",
    "Deactivated": "Отключено",
    "developer.mcp.status.previously_connected": "Подключалось ранее",
    "Previously connected": "Подключалось ранее",
    "developer.mcp.status.registered": "Зарегистрировано · не подключено",
    "Registered · not connected": "Зарегистрировано · не подключено",
    "developer.mcp.oauth_app": "Приложение OAuth",
    "OAuth app": "Приложение OAuth",
    "developer.mcp.created": "Создано",
    "developer.mcp.updated": "Обновлено",
    "Updated": "Обновлено",
    "developer.mcp.edit_scopes": "Изменить области доступа",
    "Edit scopes": "Изменить области доступа",
    "developer.mcp.edit_scopes_for": "Изменить области доступа для {name}",
    "Edit scopes for {name}": "Изменить области доступа для {name}",
    "developer.mcp.deactivate_hint": "Отключить (оставить в списке и журнале)",
    "Deactivate (keeps it listed and logged)": "Отключить (оставить в списке и журнале)",
    "developer.mcp.deactivate_named": "Отключить {name}",
    "Deactivate {name}": "Отключить {name}",
    "developer.mcp.delete_connection": "Удалить подключение",
    "Delete connection": "Удалить подключение",
    "developer.mcp.delete_named": "Удалить {name}",
    "Delete {name}": "Удалить {name}",
    "developer.mcp.resource.listings": "Товары",
    "developer.mcp.resource.orders": "Заказы",
    "developer.mcp.resource.users": "Пользователи",
    "developer.mcp.resource.accounts": "Аккаунты",
    "developer.mcp.resource.categories": "Категории",
    "developer.mcp.resource.attributes": "Атрибуты",
    "developer.mcp.resource.analytics": "Аналитика",
    "developer.mcp.resource.attribution": "Атрибуция",
    "Attribution": "Атрибуция",
    "developer.mcp.resource.rewards": "Награды",
    "developer.mcp.resource.layers": "Layers / CMS",
    "Layers / CMS": "Layers / CMS",
    "developer.mcp.resource.settings": "Настройки магазина",
    "Store settings": "Настройки магазина",
    "developer.mcp.resource.marketing": "Маркетинг",
    "developer.mcp.resource.market_research": "Исследование рынка",
    "Market research": "Исследование рынка",
    "developer.mcp.resource.audiences": "Маркетинговые аудитории",
    "Marketing audiences": "Маркетинговые аудитории",
    "developer.mcp.resource.agents": "ИИ-агенты",
    "developer.mcp.resource.assets": "Загрузка файлов",
    "File uploads": "Загрузка файлов",
    "developer.mcp.resource.workforce": "Персонал",
    "developer.mcp.resource.inventory": "Запасы",
    "developer.mcp.resource.memberships": "Членство",
    "Memberships": "Членство",
    "developer.mcp.resource.bundles": "Комплекты",
    "developer.mcp.resource.rentals": "Аренда",
    "Rentals": "Аренда",
    "developer.mcp.resource.accounting": "Бухгалтерия",
    "developer.mcp.nav.label": "Навигация MCP",
    "MCP navigation": "Навигация MCP",
    "developer.mcp.nav.connections": "Подключения",
    "Connections": "Подключения",
    "developer.mcp.nav.logs": "Журналы",
    "Logs": "Журналы",
    "developer.mcp.unknown_provider": "Неизвестный провайдер",
    "Unknown provider": "Неизвестный провайдер",
    "developer.mcp.tenant_user": "Клиент №{tenant} · Пользователь №{user}",
    "Tenant #{tenant} · User #{user}": "Клиент №{tenant} · Пользователь №{user}",
    "developer.mcp.logs.title": "Журналы MCP",
    "MCP logs": "Журналы MCP",
    "developer.mcp.logs.heading": "Последняя активность агентов",
    "Recent agent activity": "Последняя активность агентов",
    "developer.mcp.logs.description": "Показаны события MCP этого клиента. Представление активности обновляется каждые 15 секунд.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Показаны события MCP этого клиента. Представление активности обновляется каждые 15 секунд.",
    "developer.mcp.logs.error.audit": "Не удалось загрузить журналы аудита MCP.",
    "MCP audit logs could not be loaded.": "Не удалось загрузить журналы аудита MCP.",
    "developer.mcp.logs.error.load": "Не удалось загрузить журналы MCP.",
    "MCP logs could not be loaded.": "Не удалось загрузить журналы MCP.",
    "developer.mcp.logs.unknown_agent": "Неизвестный агент",
    "Unknown agent": "Неизвестный агент",
    "developer.mcp.logs.all_agents": "Все агенты",
    "All agents": "Все агенты",
    "developer.mcp.logs.updated": "Обновлено {time}",
    "Updated {time}": "Обновлено {time}",
    "developer.mcp.logs.loading": "Загрузка активности MCP…",
    "Loading MCP activity…": "Загрузка активности MCP…",
    "developer.mcp.logs.empty": "Недавние события MCP для этого клиента не найдены.",
    "No recent MCP events found for this tenant.": "Недавние события MCP для этого клиента не найдены.",
    "developer.mcp.logs.empty_agent": "Недавние события MCP для этого клиента и агента не найдены.",
    "No recent MCP events found for this tenant and agent.": "Недавние события MCP для этого клиента и агента не найдены.",
    "developer.mcp.logs.time": "Время",
    "developer.mcp.logs.event": "Событие",
    "developer.mcp.logs.tool": "Инструмент",
    "developer.mcp.logs.agent": "Агент",
    "Agent": "Агент",
    "developer.mcp.logs.tenant_user": "Пользователь / организация",
    "Tenant / user": "Пользователь / организация",
    "developer.mcp.logs.scope": "Область доступа",
    "developer.mcp.logs.result": "Результат",
    "Result": "Результат",
    "developer.mcp.logs.duration": "Длительность",
    "Duration": "Длительность",
    "developer.mcp.logs.view_details": "Подробности события: {event}",
    "View details for {event}": "Подробности события: {event}",
    "developer.mcp.logs.tenant": "Организация №{id}",
    "Tenant #{id}": "Организация №{id}",
    "developer.mcp.logs.user": "Пользователь №{id}",
    "User #{id}": "Пользователь №{id}",
    "developer.mcp.logs.view_granted_scopes": "Просмотреть предоставленные разрешения",
    "View granted scopes": "Просмотреть предоставленные разрешения",
    "developer.mcp.logs.succeeded": "Успешно",
    "developer.mcp.logs.failed": "Не выполнено",
    "developer.mcp.logs.duration_ms": "{count} мс",
    "{count} ms": "{count} мс",
    "developer.mcp.logs.details_title": "Сведения о событии MCP",
    "MCP event details": "Сведения о событии MCP",
    "developer.mcp.logs.required_scope": "Необходимое разрешение",
    "Required scope": "Необходимое разрешение",
    "developer.mcp.logs.granted_scopes": "Предоставленные разрешения",
    "Granted scopes": "Предоставленные разрешения",
    "developer.mcp.logs.event_generic": "Событие",
    "developer.mcp.logs.event.tool_called": "Вызван инструмент",
    "Tool called": "Вызван инструмент",
    "developer.mcp.logs.event.connection_requested": "Запрошено подключение",
    "Connection requested": "Запрошено подключение",
    "developer.mcp.logs.event.connection_connected": "Подключено",
    "Connection connected": "Подключено",
    "developer.mcp.logs.event.connection_deactivated": "Подключение отключено",
    "developer.mcp.logs.event.connection_deleted": "Подключение удалено",
    "Connection deleted": "Подключение удалено",
    "developer.mcp.logs.event.permissions_updated": "Разрешения обновлены",
    "common.status.label": "Статус",
    "suppliers.title": "Поставщики",
    "suppliers.search": "Поиск поставщиков",
    "Search suppliers": "Поиск поставщиков",
    "suppliers.add": "Добавить поставщика",
    "Add supplier": "Добавить поставщика",
    "suppliers.deactivate": "Отключить",
    "Deactivate": "Отключить",
    "suppliers.empty": "Поставщики не найдены.",
    "No suppliers found.": "Поставщики не найдены.",
    "suppliers.add_title": "Добавить поставщика",
    "suppliers.edit_title": "Изменить поставщика",
    "Edit supplier": "Изменить поставщика",
    "suppliers.save_changes": "Сохранить изменения",
    "Save changes": "Сохранить изменения",
    "suppliers.confirm_deactivate": "Отключить поставщика {name}?",
    "Deactivate {name}?": "Отключить поставщика {name}?",
    "suppliers.toast.updated": "Данные поставщика обновлены",
    "Supplier updated": "Данные поставщика обновлены",
    "suppliers.toast.added": "Поставщик добавлен",
    "Supplier added": "Поставщик добавлен",
    "suppliers.toast.deactivated": "Поставщик отключен",
    "Supplier deactivated": "Поставщик отключен",
    "suppliers.column.name": "Название",
    "suppliers.column.code": "Код",
    "suppliers.column.contact": "Контакт",
    "Contact": "Контакт",
    "suppliers.field.name": "Название",
    "suppliers.field.code": "Код",
    "suppliers.field.contact_name": "Контактное лицо",
    "suppliers.field.email": "Электронная почта",
    "suppliers.field.phone": "Телефон",
    "suppliers.field.currency": "Валюта",
    "suppliers.field.payment_terms": "Условия оплаты",
    "Payment terms": "Условия оплаты",
    "suppliers.field.address": "Адрес",
    "suppliers.field.note": "Примечание",
    "Note": "Примечание",
    "suppliers.placeholder.name": "Название компании или поставщика",
    "Company or supplier name": "Название компании или поставщика",
    "suppliers.placeholder.code": "Код поставщика",
    "Supplier code": "Код поставщика",
    "suppliers.placeholder.contact_name": "Имя контактного лица",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Оплата при получении",
    "Cash on delivery": "Оплата при получении",
    "suppliers.payment_terms.payment_on_receipt": "Оплата при получении счета",
    "Payment on receipt": "Оплата при получении счета",
    "suppliers.payment_terms.payment_in_advance": "Предоплата",
    "Payment in advance": "Предоплата",
    "suppliers.payment_terms.net_7": "Оплата в течение 7 дней",
    "Net 7 days": "Оплата в течение 7 дней",
    "suppliers.payment_terms.net_15": "Оплата в течение 15 дней",
    "Net 15 days": "Оплата в течение 15 дней",
    "suppliers.payment_terms.net_30": "Оплата в течение 30 дней",
    "Net 30 days": "Оплата в течение 30 дней",
    "suppliers.payment_terms.net_45": "Оплата в течение 45 дней",
    "Net 45 days": "Оплата в течение 45 дней",
    "suppliers.payment_terms.net_60": "Оплата в течение 60 дней",
    "Net 60 days": "Оплата в течение 60 дней",
    "suppliers.detail_title": "Данные поставщика",
    "Supplier details": "Данные поставщика",
    "suppliers.edit": "Изменить поставщика",
    "suppliers.back": "Назад к поставщикам",
    "Back to suppliers": "Назад к поставщикам",
    "suppliers.loading": "Загрузка данных поставщика…",
    "Loading supplier…": "Загрузка данных поставщика…",
    "suppliers.unnamed": "Поставщик без названия",
    "Unnamed supplier": "Поставщик без названия",
    "suppliers.profile_description": "Профиль и контактные данные поставщика",
    "Supplier profile and contact information": "Профиль и контактные данные поставщика",
    "suppliers.total_spend": "Общая сумма закупок",
    "Total spend": "Общая сумма закупок",
    "suppliers.outstanding": "К оплате",
    "Outstanding": "К оплате",
    "suppliers.paid": "Оплачено",
    "suppliers.draft": "Черновик",
    "suppliers.purchase_history": "История закупок",
    "Purchase history": "История закупок",
    "suppliers.bill.reference": "Номер ссылки",
    "suppliers.bill.date": "Дата",
    "suppliers.bill.amount": "Сумма",
    "suppliers.bill.number": "Счет №{id}",
    "Bill #{id}": "Счет №{id}",
    "suppliers.bills_empty": "Счета этого поставщика не найдены.",
    "No bills found for this supplier.": "Счета этого поставщика не найдены.",
    "inventory.locations.title": "Места хранения",
    "inventory.locations.add": "Добавить место хранения",
    "Add location": "Добавить место хранения",
    "inventory.locations.description": "Склады и магазины, где хранится товар. Заказы на закупку принимаются в выбранное место хранения.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Склады и магазины, где хранится товар. Заказы на закупку принимаются в выбранное место хранения.",
    "inventory.locations.field.name": "Название",
    "inventory.locations.field.code": "Код",
    "inventory.locations.field.address": "Адрес",
    "inventory.locations.field.linked_store": "Связанный магазин (необязательно)",
    "Linked store (optional)": "Связанный магазин (необязательно)",
    "inventory.locations.field.linked_store_short": "Связанный магазин",
    "Linked store": "Связанный магазин",
    "inventory.locations.placeholder.name": "Главный склад",
    "Main warehouse": "Главный склад",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Найти адрес или место",
    "Search an address or place": "Найти адрес или место",
    "inventory.locations.placeholder.linked_store": "Поиск продавцов или магазинов",
    "Search seller or store accounts": "Поиск продавцов или магазинов",
    "inventory.locations.confirm_deactivate": "Отключить место хранения {name}? Оно больше не будет доступно для новых заказов на закупку.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Отключить место хранения {name}? Оно больше не будет доступно для новых заказов на закупку.",
    "inventory.locations.toast.deactivated": "Место хранения отключено",
    "Location deactivated": "Место хранения отключено",
    "inventory.locations.deactivate": "Отключить",
    "inventory.locations.empty": "Мест хранения пока нет. Добавьте склад или магазин, чтобы начать приемку товаров.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Мест хранения пока нет. Добавьте склад или магазин, чтобы начать приемку товаров.",
    "inventory.locations.edit_title": "Изменить место хранения",
    "Edit location": "Изменить место хранения",
    "inventory.locations.add_title": "Добавить место хранения",
    "inventory.locations.form_description": "Связывайте магазин только в том случае, если это место хранения принадлежит конкретному продавцу.",
    "Link a store account only if this location belongs to a specific seller.": "Связывайте магазин только в том случае, если это место хранения принадлежит конкретному продавцу.",
    "inventory.locations.save_changes": "Сохранить изменения",
    "inventory.locations.toast.updated": "Место хранения обновлено",
    "Location updated": "Место хранения обновлено",
    "inventory.locations.toast.added": "Место хранения добавлено",
    "Location added": "Место хранения добавлено",
    "inventory.operations.title": "Операции с запасами",
    "Inventory operations": "Операции с запасами",
    "inventory.operations.tab.movements": "История перемещений",
    "Movement history": "История перемещений",
    "inventory.operations.tab.batches": "Партии и сроки годности",
    "Batches & expiry": "Партии и сроки годности",
    "inventory.operations.tab.transfers": "Заказы на перемещение",
    "Transfer orders": "Заказы на перемещение",
    "inventory.operations.tab.requisitions": "Заявки на пополнение",
    "Requisitions": "Заявки на пополнение",
    "inventory.operations.tab.receipts": "Приемка товаров",
    "Goods received": "Приемка товаров",
    "inventory.operations.description.movements": "Неизменяемая история всех приемок, продаж, перемещений, возвратов и корректировок.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Неизменяемая история всех приемок, продаж, перемещений, возвратов и корректировок.",
    "inventory.operations.description.batches": "Отслеживайте партии, сроки годности, состояние и единицы учета. Изменения запасов здесь не выполняются.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Отслеживайте партии, сроки годности, состояние и единицы учета. Изменения запасов здесь не выполняются.",
    "inventory.operations.description.transfers": "Перемещайте запасы между местами хранения, отслеживая отправку, приемку и расхождения.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Перемещайте запасы между местами хранения, отслеживая отправку, приемку и расхождения.",
    "inventory.operations.description.requisitions": "Проверяйте внутренние заявки на запасы. После одобрения автоматически создается заказ на перемещение.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Проверяйте внутренние заявки на запасы. После одобрения автоматически создается заказ на перемещение.",
    "inventory.operations.description.receipts": "Создавайте приемки и отслеживайте открытые, частичные и завершенные операции.",
    "Create receipts and track open, partial, and closed receiving work.": "Создавайте приемки и отслеживайте открытые, частичные и завершенные операции.",
    "inventory.operations.overview": "Обзор",
    "inventory.operations.new_transfer": "Новое перемещение",
    "New transfer": "Новое перемещение",
    "inventory.operations.new_requisition": "Новая заявка",
    "inventory.operations.new_receipt": "Новая приемка",
    "New receipt": "Новая приемка",
    "inventory.operations.search": "Поиск",
    "inventory.operations.search_view": "Поиск в этом представлении",
    "Search this view": "Поиск в этом представлении",
    "inventory.operations.search_products": "Поиск товаров",
    "Search products": "Поиск товаров",
    "inventory.operations.search_purchase_order": "Поиск заказов на закупку (необязательно)",
    "Search purchase orders (optional)": "Поиск заказов на закупку (необязательно)",
    "inventory.operations.listing_number": "Объявление №{id}",
    "inventory.operations.location_number": "Место хранения №{id}",
    "Location #{id}": "Место хранения №{id}",
    "inventory.operations.no_sku": "Нет артикула",
    "No SKU": "Нет артикула",
    "inventory.operations.order_status": "Статус: {status}",
    "Status: {status}": "Статус: {status}",
    "inventory.operations.field.receiving_location": "Место приемки",
    "Receiving location": "Место приемки",
    "inventory.operations.field.purchase_order": "Заказ на закупку",
    "Purchase order": "Заказ на закупку",
    "inventory.operations.field.reference": "Ссылка",
    "inventory.operations.field.note": "Примечание",
    "inventory.operations.field.from_location": "Место отправления",
    "From location": "Место отправления",
    "inventory.operations.field.supplying_location": "Место поставки",
    "Supplying location": "Место поставки",
    "inventory.operations.field.to_location": "Место назначения",
    "To location": "Место назначения",
    "inventory.operations.field.requesting_location": "Запрашивающее место",
    "Requesting location": "Запрашивающее место",
    "inventory.operations.field.product": "Товар",
    "Product": "Товар",
    "inventory.operations.field.quantity": "Количество",
    "Quantity": "Количество",
    "inventory.operations.field.location": "Место хранения",
    "inventory.operations.placeholder.delivery_note": "Накладная поставщика",
    "Supplier delivery note": "Накладная поставщика",
    "inventory.operations.placeholder.receiving_note": "Примечание о приемке (необязательно)",
    "Optional receiving note": "Примечание о приемке (необязательно)",
    "inventory.operations.placeholder.transfer_reference": "Номер перемещения",
    "Transfer reference": "Номер перемещения",
    "inventory.operations.placeholder.request_reference": "Номер заявки",
    "Request reference": "Номер заявки",
    "inventory.operations.placeholder.context": "Дополнительная информация (необязательно)",
    "Optional context": "Дополнительная информация (необязательно)",
    "inventory.operations.create.transfer_title": "Новый заказ на перемещение",
    "New transfer order": "Новый заказ на перемещение",
    "inventory.operations.create.requisition_title": "Новая заявка на пополнение",
    "inventory.operations.create.receipt_title": "Новая приемка товаров",
    "New goods receipt": "Новая приемка товаров",
    "inventory.operations.create.transfer_description": "Переместите запасы между двумя местами хранения.",
    "Move stock between two locations.": "Переместите запасы между двумя местами хранения.",
    "inventory.operations.create.requisition_description": "Запросите запасы из другого места хранения.",
    "Request stock from another location.": "Запросите запасы из другого места хранения.",
    "inventory.operations.create.receipt_description": "Создайте приемку перед сканированием или добавлением коробок.",
    "Create a receipt before scanning or adding boxes.": "Создайте приемку перед сканированием или добавлением коробок.",
    "inventory.operations.toast.transfer_created": "Заказ на перемещение создан",
    "Transfer order created": "Заказ на перемещение создан",
    "inventory.operations.toast.requisition_created": "Заявка создана",
    "Requisition created": "Заявка создана",
    "inventory.operations.toast.receipt_created": "Приемка товаров создана",
    "Goods receipt created": "Приемка товаров создана",
    "inventory.operations.toast.transfer_dispatched": "Перемещение отправлено",
    "Transfer dispatched": "Перемещение отправлено",
    "inventory.operations.toast.transfer_received": "Перемещение принято",
    "Transfer received": "Перемещение принято",
    "inventory.operations.toast.transfer_cancelled": "Перемещение отменено",
    "Transfer cancelled": "Перемещение отменено",
    "inventory.operations.toast.requisition_approved": "Заявка одобрена",
    "Requisition approved": "Заявка одобрена",
    "inventory.operations.toast.requisition_rejected": "Заявка отклонена",
    "Requisition rejected": "Заявка отклонена",
    "inventory.operations.action.dispatch": "Отправить",
    "Dispatch": "Отправить",
    "inventory.operations.action.receive": "Принять",
    "Receive": "Принять",
    "inventory.operations.action.approve": "Одобрить",
    "Approve": "Одобрить",
    "inventory.operations.action.reject": "Отклонить",
    "Reject": "Отклонить",
    "inventory.operations.column.when": "Когда",
    "When": "Когда",
    "inventory.operations.column.event": "Событие",
    "inventory.operations.column.change": "Изменение",
    "inventory.operations.column.after": "После",
    "After": "После",
    "inventory.operations.column.order": "Заказ",
    "inventory.operations.column.route": "Маршрут",
    "Route": "Маршрут",
    "inventory.operations.column.lines": "Строки",
    "Lines": "Строки",
    "inventory.operations.column.expected": "Ожидается",
    "Expected": "Ожидается",
    "inventory.operations.column.request": "Заявка",
    "Request": "Заявка",
    "inventory.operations.column.request_supply": "Заявка / поставка",
    "Request / supply": "Заявка / поставка",
    "inventory.operations.column.created": "Создано",
    "inventory.operations.column.receipt": "Приемка",
    "Receipt": "Приемка",
    "inventory.operations.empty.movements": "Движений запасов пока нет.",
    "No stock movements recorded yet.": "Движений запасов пока нет.",
    "inventory.operations.empty.batches": "Партии товаров пока не зарегистрированы.",
    "No inventory batches have been recorded yet.": "Партии товаров пока не зарегистрированы.",
    "inventory.operations.empty.transfers": "Заказов на перемещение пока нет.",
    "No transfer orders yet.": "Заказов на перемещение пока нет.",
    "inventory.operations.empty.requisitions": "Заявок на пополнение пока нет.",
    "No requisitions yet.": "Заявок на пополнение пока нет.",
    "inventory.operations.empty.receipts": "Приемок товаров пока нет.",
    "No goods receipts yet.": "Приемок товаров пока нет.",
    "inventory.operations.batch.edit_title": "Изменить партию",
    "Edit batch": "Изменить партию",
    "inventory.operations.batch.edit_description": "Количество партии меняется через корректировку запасов. Здесь можно изменить только идентификатор и данные отслеживания.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "Количество партии меняется через корректировку запасов. Здесь можно изменить только идентификатор и данные отслеживания.",
    "inventory.operations.batch.save": "Сохранить партию",
    "Save batch": "Сохранить партию",
    "inventory.operations.batch.lot_number": "Номер партии",
    "Lot number": "Номер партии",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Срок годности",
    "inventory.operations.batch.condition": "Состояние",
    "inventory.operations.batch.condition_placeholder": "хорошее",
    "good": "хорошее",
    "inventory.operations.batch.unit": "Единица измерения",
    "Unit of measure": "Единица измерения",
    "inventory.operations.batch.unit_placeholder": "коробка, штука, кг",
    "box, piece, kg": "коробка, штука, кг",
    "inventory.operations.batch.no_expiry": "Без срока годности",
    "No expiry": "Без срока годности",
    "inventory.operations.batch.updated": "Данные партии обновлены",
    "Batch updated": "Данные партии обновлены",
    "common.status.in_transit": "В пути",
    "In transit": "В пути",
    "common.status.pending": "Ожидает",
    "common.status.approved": "Одобрено",
    "common.status.rejected": "Отклонено",
    "Rejected": "Отклонено",
    "common.status.cancelled": "Отменено",
    "common.status.received": "Получено",
    "Received": "Получено",
    "common.status.sent": "Отправлено",
    "Sent": "Отправлено",
    "common.note": "Примечание",
    "common.optional": "Необязательно",
    "Optional": "Необязательно",
    "common.error.generic": "Что-то пошло не так.",
    "Something went wrong.": "Что-то пошло не так.",
    "purchase_orders.title": "Заказы на закупку",
    "purchase_orders.title_singular": "Заказ на закупку",
    "purchase_orders.tab.all": "Все",
    "purchase_orders.tab.partial": "Частично получено",
    "Partially received": "Частично получено",
    "purchase_orders.create.new": "Новый заказ на закупку",
    "New purchase order": "Новый заказ на закупку",
    "purchase_orders.create.title": "Новый заказ на закупку",
    "purchase_orders.create.subtitle": "Сохранено как черновик. Отметьте заказ как отправленный, когда передадите его поставщику.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Сохранено как черновик. Отметьте заказ как отправленный, когда передадите его поставщику.",
    "purchase_orders.create.submit": "Создать черновик",
    "Create draft": "Создать черновик",
    "purchase_orders.field.location": "Место приемки",
    "purchase_orders.field.supplier": "Поставщик",
    "Supplier": "Поставщик",
    "purchase_orders.field.reference": "Номер поставщика",
    "Supplier reference": "Номер поставщика",
    "purchase_orders.field.expected_delivery": "Ожидаемая дата доставки",
    "Expected delivery": "Ожидаемая дата доставки",
    "purchase_orders.field.products": "Товары",
    "Products": "Товары",
    "purchase_orders.select_location": "Выберите место хранения",
    "Select location": "Выберите место хранения",
    "purchase_orders.no_locations": "Места хранения не настроены",
    "No locations set up": "Места хранения не настроены",
    "purchase_orders.add_location": "Сначала добавьте место хранения →",
    "Add a location first →": "Сначала добавьте место хранения →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Все места хранения",
    "All locations": "Все места хранения",
    "purchase_orders.location_number": "Место хранения №{id}",
    "purchase_orders.search_products": "Поиск товаров для добавления",
    "Search products to add": "Поиск товаров для добавления",
    "purchase_orders.in_stock": "В наличии: {count}",
    "In stock: {count}": "В наличии: {count}",
    "purchase_orders.column.order": "Заказ",
    "purchase_orders.column.product": "Товар",
    "purchase_orders.column.quantity": "Количество",
    "purchase_orders.column.ordered": "Заказано",
    "Ordered": "Заказано",
    "purchase_orders.column.received": "Получено",
    "purchase_orders.column.remaining": "Осталось",
    "purchase_orders.column.unit_cost": "Цена за единицу",
    "Unit cost": "Цена за единицу",
    "purchase_orders.column.supplier": "Поставщик",
    "purchase_orders.column.location": "Место хранения",
    "purchase_orders.column.progress": "Получено",
    "purchase_orders.column.value": "Стоимость",
    "purchase_orders.column.expected": "Ожидается",
    "purchase_orders.column.status": "Статус",
    "purchase_orders.action.mark_sent": "Отметить как отправленный",
    "Mark as sent": "Отметить как отправленный",
    "purchase_orders.action.receive": "Принять",
    "purchase_orders.action.receive_stock": "Принять запасы",
    "Receive stock": "Принять запасы",
    "purchase_orders.action.cancel_order": "Отменить заказ",
    "Cancel order": "Отменить заказ",
    "purchase_orders.action.close_order": "Закрыть заказ",
    "Close order": "Закрыть заказ",
    "purchase_orders.receive.subtitle": "Укажите полученные товары. После подтверждения запасы будут обновлены для места приемки.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Укажите полученные товары. После подтверждения запасы будут обновлены для места приемки.",
    "purchase_orders.receive.now": "Принять сейчас",
    "Receive now": "Принять сейчас",
    "purchase_orders.receive.confirm": "Подтвердить приемку",
    "Confirm receipt": "Подтвердить приемку",
    "purchase_orders.confirm.cancel": "Отменить этот заказ на закупку?",
    "Cancel this purchase order?": "Отменить этот заказ на закупку?",
    "purchase_orders.empty.all": "Заказов на закупку пока нет. Создайте заказ, чтобы пополнить запасы.",
    "No purchase orders yet. Create one to restock inventory.": "Заказов на закупку пока нет. Создайте заказ, чтобы пополнить запасы.",
    "purchase_orders.empty.filtered": "Заказов на закупку с таким статусом нет.",
    "No purchase orders with this status.": "Заказов на закупку с таким статусом нет.",
    "purchase_orders.error.location_required": "Выберите место приемки.",
    "Choose a receiving location.": "Выберите место приемки.",
    "purchase_orders.error.product_required": "Добавьте хотя бы один товар.",
    "Add at least one product.": "Добавьте хотя бы один товар.",
    "purchase_orders.error.quantity_positive": "Количество должно быть больше 0.",
    "Every quantity must be greater than 0.": "Количество должно быть больше 0.",
    "purchase_orders.error.receive_quantity": "Укажите количество хотя бы для одного товара.",
    "Enter a quantity for at least one item.": "Укажите количество хотя бы для одного товара.",
    "purchase_orders.toast.created": "Заказ на закупку создан как черновик",
    "Purchase order created as draft": "Заказ на закупку создан как черновик",
    "purchase_orders.toast.sent": "Отмечено как отправленное",
    "Marked as sent": "Отмечено как отправленное",
    "purchase_orders.toast.received": "Запасы приняты, данные обновлены",
    "Stock received and inventory updated": "Запасы приняты, данные обновлены",
    "purchase_orders.toast.cancelled": "Заказ на закупку отменен",
    "Purchase order cancelled": "Заказ на закупку отменен",
    "purchase_orders.toast.closed": "Заказ на закупку закрыт",
    "Purchase order closed": "Заказ на закупку закрыт",
    "schedule.title": "Расписание",
    "schedule.view.month": "Месяц",
    "Month": "Месяц",
    "schedule.view.week": "Неделя",
    "Week": "Неделя",
    "schedule.view.day": "День",
    "Day": "День",
    "schedule.today": "Сегодня",
    "Today": "Сегодня",
    "schedule.order_number": "Заказ №{number}",
    "Order #{number}": "Заказ №{number}",
    "schedule.customer": "Клиент",
    "schedule.more_events": "Еще: {count}",
    "+{count} more": "Еще: {count}",
    "schedule.payment.paid": "Оплачено",
    "schedule.payment.pending": "Ожидает оплаты",
    "schedule.payment.failed": "Ошибка оплаты",
    "schedule.booking_details": "Сведения о бронировании",
    "Booking details": "Сведения о бронировании",
    "schedule.order_reference": "Номер заказа",
    "schedule.amount": "Сумма",
    "schedule.start": "Начало",
    "schedule.end": "Окончание",
    "schedule.item_number": "Позиция {number}",
    "Item {number}": "Позиция {number}",
    "schedule.view_order": "Открыть заказ",
    "View full order": "Открыть заказ",
    "onboarding.greeting.morning": "Доброе утро",
    "Good morning": "Доброе утро",
    "onboarding.greeting.morning_named": "Доброе утро, {name}",
    "Good morning {name}": "Доброе утро, {name}",
    "onboarding.greeting.afternoon": "Добрый день",
    "Good afternoon": "Добрый день",
    "onboarding.greeting.afternoon_named": "Добрый день, {name}",
    "Good afternoon {name}": "Добрый день, {name}",
    "onboarding.greeting.evening": "Добрый вечер",
    "Good evening": "Добрый вечер",
    "onboarding.greeting.evening_named": "Добрый вечер, {name}",
    "Good evening {name}": "Добрый вечер, {name}",
    "onboarding.greeting.night": "Здравствуйте",
    "Hello": "Здравствуйте",
    "onboarding.greeting.night_named": "Здравствуйте, {name}",
    "Hello {name}": "Здравствуйте, {name}",
    "onboarding.encouragement": "Создайте платформу, которой вам не хватало.",
    "Build the platform you wish existed.": "Создайте платформу, которой вам не хватало.",
    "onboarding.plan.personalized": "Персональный план запуска",
    "Personalized launch plan": "Персональный план запуска",
    "onboarding.plan.label": "План запуска",
    "Launch plan": "План запуска",
    "onboarding.plan.refining": "Уточняем ваш план…",
    "Refining your path…": "Уточняем ваш план…",
    "onboarding.plan.getting_ready": "Ваш персональный план готовится.",
    "Your personalized plan is getting ready.": "Ваш персональный план готовится.",
    "onboarding.checklist.preview": "Предварительный список задач",
    "Checklist preview": "Предварительный список задач",
    "onboarding.workspace.live": "Рабочая область активна",
    "Live workspace": "Рабочая область активна",
    "onboarding.workspace.no_tenant": "Нет подключенной рабочей области",
    "No live tenant connected": "Нет подключенной рабочей области",
    "onboarding.workspace.domain_pending": "Домен ожидает настройки",
    "Domain pending": "Домен ожидает настройки",
    "onboarding.progress.summary": "Выполнено действий: {completed} из {total}",
    "{completed} of {total} launch actions done": "Выполнено действий: {completed} из {total}",
    "onboarding.progress.auto_detected": "Автоматически определено: {count}",
    "{count} auto-detected": "Автоматически определено: {count}",
    "onboarding.progress.auto_detected_short": "Определено автоматически",
    "Auto-detected": "Определено автоматически",
    "onboarding.progress.saving": "Сохранение прогресса…",
    "Saving progress…": "Сохранение прогресса…",
    "onboarding.progress.checking": "Проверка…",
    "Checking…": "Проверка…",
    "onboarding.progress.mark_done": "Отметить выполненным",
    "Mark done": "Отметить выполненным",
    "onboarding.progress.unlocked": "Открыто: {impact}",
    "Unlocked: {impact}": "Открыто: {impact}",
    "onboarding.next_task": "Следующая важная задача",
    "Next best task": "Следующая важная задача",
    "onboarding.upcoming.title": "Предстоящие задачи",
    "Upcoming tasks": "Предстоящие задачи",
    "onboarding.upcoming.summary_one": "После текущего действия в очереди {count} задача.",
    "{count} task queued after the current action.": "После текущего действия в очереди {count} задача.",
    "onboarding.upcoming.summary_other": "После текущего действия в очереди {count} задач.",
    "{count} tasks queued after the current action.": "После текущего действия в очереди {count} задач.",
    "onboarding.upcoming.hide": "Скрыть задачи",
    "Hide tasks": "Скрыть задачи",
    "onboarding.upcoming.view_all": "Показать все задачи",
    "View all tasks": "Показать все задачи",
    "onboarding.complete.title": "Отличное начало. Основа платформы готова.",
    "Great start. Your foundation is live.": "Отличное начало. Основа платформы готова.",
    "onboarding.complete.description": "Продолжайте, чтобы открыть инструменты роста: акции, рассылки и другие возможности.",
    "Keep going to unlock growth essentials like promotions and communications.": "Продолжайте, чтобы открыть инструменты роста: акции, рассылки и другие возможности.",
    "onboarding.full_checklist.title": "Полный список задач",
    "Full checklist": "Полный список задач",
    "onboarding.full_checklist.description": "Продолжите настройку в том же интерфейсе.",
    "Continue setup in the same experience.": "Продолжите настройку в том же интерфейсе.",
    "onboarding.full_checklist.back": "Назад к плану запуска",
    "Back to launch path": "Назад к плану запуска",
    "onboarding.completed.title": "Выполнено",
    "onboarding.completed.summary_one": "Выполнена {count} задача",
    "{count} task completed": "Выполнена {count} задача",
    "onboarding.completed.summary_other": "Выполнено задач: {count}",
    "{count} tasks completed": "Выполнено задач: {count}",
    "onboarding.completed.open_again": "Открыть снова",
    "Open again": "Открыть снова",
    "onboarding.plan.marketplace.eyebrow": "План запуска маркетплейса",
    "Marketplace launch path": "План запуска маркетплейса",
    "onboarding.plan.marketplace.title": "Запустите свой маркетплейс",
    "Launch your marketplace": "Запустите свой маркетплейс",
    "onboarding.plan.marketplace.title_named": "Превратите {project} в работающий маркетплейс",
    "Turn {project} into a working marketplace": "Превратите {project} в работающий маркетплейс",
    "onboarding.plan.marketplace.subtitle": "Откройте сайт, создайте первое объявление и проверьте путь покупателя.",
    "Open the live site create the first listing and test the buyer journey.": "Откройте сайт, создайте первое объявление и проверьте путь покупателя.",
    "onboarding.plan.marketplace.value_moment": "Первый результат: продавец может опубликовать товар, а покупатель — выполнить действие.",
    "First value moment: a seller can publish and a buyer can act.": "Первый результат: продавец может опубликовать товар, а покупатель — выполнить действие.",
    "onboarding.plan.marketplace.why_title": "Зачем команды завершают этот этап",
    "Why teams finish this": "Зачем команды завершают этот этап",
    "onboarding.plan.marketplace.why_body": "Реальные действия покупателей и продавцов делают каждый следующий шаг полезным и поддерживают темп.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Реальные действия покупателей и продавцов делают каждый следующий шаг полезным и поддерживают темп.",
    "onboarding.plan.store.eyebrow": "План запуска магазина",
    "Store launch path": "План запуска магазина",
    "onboarding.plan.store.title": "Подготовьте магазин к первому заказу",
    "Get your store ready for the first order": "Подготовьте магазин к первому заказу",
    "onboarding.plan.store.title_named": "Подготовьте {project} к первому заказу",
    "Make {project} ready for the first order": "Подготовьте {project} к первому заказу",
    "onboarding.plan.store.subtitle": "Добавьте товар, проверьте витрину и настройте оформление заказа.",
    "Add a product check the storefront and complete checkout essentials.": "Добавьте товар, проверьте витрину и настройте оформление заказа.",
    "onboarding.plan.store.value_moment": "Первый результат: товар виден, и можно проверить оформление заказа.",
    "First value moment: a product is visible and checkout can be tested.": "Первый результат: товар виден, и можно проверить оформление заказа.",
    "onboarding.plan.store.why_title": "Зачем команды завершают этот этап",
    "onboarding.plan.store.why_body": "Быстрый переход от товара к оплате делает магазин реальным и помогает сохранять мотивацию.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Быстрый переход от товара к оплате делает магазин реальным и помогает сохранять мотивацию.",
    "onboarding.plan.booking.eyebrow": "План запуска бронирования",
    "Booking launch path": "План запуска бронирования",
    "onboarding.plan.booking.title": "Настройте бронирование на платформе",
    "Make your platform bookable": "Настройте бронирование на платформе",
    "onboarding.plan.booking.title_named": "Настройте бронирование в {project}",
    "Make {project} bookable": "Настройте бронирование в {project}",
    "onboarding.plan.booking.subtitle": "Создайте услугу, откройте клиентский интерфейс и проверьте бронирование.",
    "Create the first service open the customer experience and test a reservation.": "Создайте услугу, откройте клиентский интерфейс и проверьте бронирование.",
    "onboarding.plan.booking.value_moment": "Первый результат: клиент может запросить время или место.",
    "First value moment: a customer can request a time or slot.": "Первый результат: клиент может запросить время или место.",
    "onboarding.plan.booking.why_title": "Зачем команды завершают этот этап",
    "onboarding.plan.booking.why_body": "Проверьте весь путь бронирования заранее, чтобы обрести уверенность перед расширением.",
    "Validate the full booking journey early to build confidence before expanding.": "Проверьте весь путь бронирования заранее, чтобы обрести уверенность перед расширением.",
    "onboarding.plan.digital.eyebrow": "План запуска цифровых товаров",
    "Digital launch path": "План запуска цифровых товаров",
    "onboarding.plan.digital.title": "Начните продавать цифровые товары",
    "Start selling your digital products": "Начните продавать цифровые товары",
    "onboarding.plan.digital.title_named": "Подготовьте {project} к продаже цифровых товаров",
    "Make {project} ready to sell digital products": "Подготовьте {project} к продаже цифровых товаров",
    "onboarding.plan.digital.subtitle": "Загрузите цифровой товар, проверьте путь клиента и убедитесь, что оплата настроена.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Загрузите цифровой товар, проверьте путь клиента и убедитесь, что оплата настроена.",
    "onboarding.plan.digital.value_moment": "Первый результат: покупатель может найти и купить файл.",
    "First value moment: a buyer can discover and purchase a file.": "Первый результат: покупатель может найти и купить файл.",
    "onboarding.plan.digital.why_title": "Зачем команды завершают этот этап",
    "onboarding.plan.digital.why_body": "Быстро проверьте поиск и покупку, чтобы расширение каталога ощущалось как рост.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Быстро проверьте поиск и покупку, чтобы расширение каталога ощущалось как рост.",
    "onboarding.plan.campaign.eyebrow": "План запуска кампании",
    "Campaign launch path": "План запуска кампании",
    "onboarding.plan.campaign.title": "Запустите платформу кампаний",
    "Launch your campaign platform": "Запустите платформу кампаний",
    "onboarding.plan.campaign.title_named": "Подготовьте {project} для сторонников",
    "Make {project} ready for supporters": "Подготовьте {project} для сторонников",
    "onboarding.plan.campaign.subtitle": "Создайте кампанию, просмотрите публичную страницу и проверьте процесс пожертвования.",
    "Create a campaign preview the public page and test the contribution journey.": "Создайте кампанию, просмотрите публичную страницу и проверьте процесс пожертвования.",
    "onboarding.plan.campaign.value_moment": "Первый результат: сторонник понимает цель и может внести вклад.",
    "First value moment: a supporter can understand and contribute.": "Первый результат: сторонник понимает цель и может внести вклад.",
    "onboarding.plan.campaign.why_title": "Зачем команды завершают этот этап",
    "onboarding.plan.campaign.why_body": "Сразу проясните историю и процесс участия, чтобы сторонники могли доверять и действовать.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Сразу проясните историю и процесс участия, чтобы сторонники могли доверять и действовать.",
    "onboarding.plan.creator.eyebrow": "План запуска для автора",
    "Creator launch path": "План запуска для автора",
    "onboarding.plan.creator.title": "Подготовьтесь к первой аудитории",
    "Get ready for your first audience": "Подготовьтесь к первой аудитории",
    "onboarding.plan.creator.title_named": "Подготовьте {project} к первой аудитории",
    "Make {project} ready for its first audience": "Подготовьте {project} к первой аудитории",
    "onboarding.plan.creator.subtitle": "Опубликуйте понятное предложение, оформите страницу и упростите поиск и поддержку вашей работы.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Опубликуйте понятное предложение, оформите страницу и упростите поиск и поддержку вашей работы.",
    "onboarding.plan.creator.value_moment": "Первый результат: ваша работа опубликована и готова к распространению.",
    "First value moment: your work is visible and ready to share.": "Первый результат: ваша работа опубликована и готова к распространению.",
    "onboarding.plan.creator.why_title": "Почему это работает",
    "Why this works": "Почему это работает",
    "onboarding.plan.creator.why_body": "Сначала опубликуйте что-то реальное, прежде чем добавлять инструменты и усложнять процесс.",
    "Focus on publishing something real before adding more tools or complexity.": "Сначала опубликуйте что-то реальное, прежде чем добавлять инструменты и усложнять процесс.",
    "onboarding.step.open_live_site.title": "Откройте сайт",
    "Open the live experience": "Откройте сайт",
    "onboarding.step.open_live_site.description": "Начните с того, что видят клиенты. Так продукт станет реальным, пока настройка еще не превратилась в абстракцию.",
    "onboarding.step.open_live_site.description_domain": "Buka {domain} dan lihat tampilan pelanggan Anda. Ini membuat proses terasa nyata sebelum langkah berikutnya.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Buka {domain} dan lihat tampilan pelanggan Anda. Ini membuat proses terasa nyata sebelum langkah berikutnya.",
    "onboarding.step.open_live_site.cta": "Открыть сайт",
    "Open site": "Открыть сайт",
    "onboarding.step.open_live_site.cta_domain": "Открыть {domain}",
    "Open {domain}": "Открыть {domain}",
    "onboarding.step.open_live_site.impact": "Подтверждает, что проект уже запущен.",
    "onboarding.step.create_supply_shape.title": "Создайте первую категорию",
    "Create the first category": "Создайте первую категорию",
    "onboarding.step.create_supply_shape.description": "Создайте понятную отправную точку для продавцов и покупателей. Категории упорядочивают поиск.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Создайте понятную отправную точку для продавцов и покупателей. Категории упорядочивают поиск.",
    "onboarding.step.create_supply_shape.cta": "Добавить категорию",
    "Add category": "Добавить категорию",
    "onboarding.step.create_supply_shape.impact": "Превращает пустой маркетплейс в каталог, по которому можно искать.",
    "Turns a blank marketplace into a browsable one.": "Превращает пустой маркетплейс в каталог, по которому можно искать.",
    "onboarding.step.post_first_listing.title": "Опубликуйте тестовое объявление",
    "Post one test listing": "Опубликуйте тестовое объявление",
    "onboarding.step.post_first_listing.description": "Пройдите путь продавца и опубликуйте первый товар, который смогут посмотреть покупатели.",
    "Experience the seller path and publish the first item buyers can inspect.": "Пройдите путь продавца и опубликуйте первый товар, который смогут посмотреть покупатели.",
    "onboarding.step.post_first_listing.cta": "Опубликовать объявление",
    "Post listing": "Опубликовать объявление",
    "onboarding.step.post_first_listing.impact": "Создает предложение — ключевой шаг запуска маркетплейса.",
    "Creates supply the core marketplace activation event.": "Создает предложение — ключевой шаг запуска маркетплейса.",
    "onboarding.step.test_buyer_action.title": "Попробуйте путь покупателя",
    "Act like a buyer": "Попробуйте путь покупателя",
    "onboarding.step.test_buyer_action.description": "Просмотрите товары, проявите интерес и проверьте заказ, чтобы увидеть процесс глазами клиента.",
    "Browse add interest and test the order path to experience what customers will see.": "Просмотрите товары, проявите интерес и проверьте заказ, чтобы увидеть процесс глазами клиента.",
    "onboarding.step.test_buyer_action.cta": "Проверить путь покупателя",
    "Test buyer flow": "Проверить путь покупателя",
    "onboarding.step.test_buyer_action.impact": "Проверяет весь путь покупателя.",
    "Validates the buyer journey end to end.": "Проверяет весь путь покупателя.",
    "onboarding.step.add_first_product.title": "Добавьте настоящий товар",
    "Add one real product": "Добавьте настоящий товар",
    "onboarding.step.add_first_product.description": "Один готовый товар лучше долгого тура по настройкам показывает структуру каталога.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Один готовый товар лучше долгого тура по настройкам показывает структуру каталога.",
    "onboarding.step.add_first_product.cta": "Добавить товар",
    "Add product": "Добавить товар",
    "onboarding.step.add_first_product.impact": "Создает первый товар, готовый к продаже.",
    "Creates the first sellable item.": "Создает первый товар, готовый к продаже.",
    "onboarding.step.setup_payments.title": "Подключите платежи",
    "Connect payments": "Подключите платежи",
    "onboarding.step.setup_payments.description": "Включите реальные платежи, чтобы пользователи могли легко завершать покупки.",
    "Enable real transactions so users can complete purchases without friction.": "Включите реальные платежи, чтобы пользователи могли легко завершать покупки.",
    "onboarding.step.setup_payments.cta": "Настроить платежи",
    "Set up payments": "Настроить платежи",
    "onboarding.step.setup_payments.impact": "Открывает путь к доходу.",
    "onboarding.step.setup_delivery.title": "Настройте доставку или способ оказания услуги",
    "Set shipping or service method": "Настройте доставку или способ оказания услуги",
    "onboarding.step.setup_delivery.description": "Укажите, как выполняется заказ, чтобы оформление покупки было понятным для пользователей.",
    "onboarding.step.setup_delivery.cta": "Настроить доставку",
    "Configure delivery": "Настроить доставку",
    "onboarding.step.setup_delivery.impact": "Проясняет процесс выполнения заказа при оформлении.",
    "Makes fulfillment clear at checkout.": "Проясняет процесс выполнения заказа при оформлении.",
    "onboarding.step.create_bookable_listing.title": "Создайте предложение для бронирования",
    "Create one bookable offer": "Создайте предложение для бронирования",
    "onboarding.step.create_bookable_listing.description": "Добавьте услугу, мероприятие, аренду или запись, которую клиенты смогут заказать первой.",
    "Add the service event rental or appointment customers should book first.": "Добавьте услугу, мероприятие, аренду или запись, которую клиенты смогут заказать первой.",
    "onboarding.step.create_bookable_listing.cta": "Создать предложение",
    "Create offer": "Создать предложение",
    "onboarding.step.create_bookable_listing.impact": "Создает первую услугу или предложение для бронирования.",
    "Creates the first bookable unit.": "Создает первую услугу или предложение для бронирования.",
    "onboarding.step.shape_details.title": "Добавьте сведения о бронировании",
    "Add booking details": "Добавьте сведения о бронировании",
    "onboarding.step.shape_details.description": "Используйте категории и поля, чтобы собрать нужную информацию до подтверждения заказа.",
    "Use categories and fields to capture what customers need before they commit.": "Используйте категории и поля, чтобы собрать нужную информацию до подтверждения заказа.",
    "onboarding.step.shape_details.cta": "Настроить поля",
    "Set up fields": "Настроить поля",
    "onboarding.step.shape_details.impact": "Делает предложение понятнее и надежнее.",
    "Makes the offer easier to compare and trust.": "Делает предложение понятнее и надежнее.",
    "onboarding.step.test_booking.title": "Проверьте путь клиента",
    "Test the customer path": "Проверьте путь клиента",
    "onboarding.step.test_booking.description": "Откройте публичный интерфейс и убедитесь, что клиент может перейти от интереса к действию.",
    "Open the public flow and verify customers can move from interest to action.": "Откройте публичный интерфейс и убедитесь, что клиент может перейти от интереса к действию.",
    "onboarding.step.test_booking.cta": "Проверить бронирование",
    "Test booking": "Проверить бронирование",
    "onboarding.step.test_booking.impact": "Проверяет весь процесс бронирования.",
    "Validates the booking journey.": "Проверяет весь процесс бронирования.",
    "onboarding.step.upload_digital_product.title": "Загрузите цифровой товар",
    "Upload one digital product": "Загрузите цифровой товар",
    "onboarding.step.upload_digital_product.description": "Подготовьте первый загружаемый товар так, чтобы его можно было просмотреть и продавать.",
    "Make the first downloadable item complete enough to preview and sell.": "Подготовьте первый загружаемый товар так, чтобы его можно было просмотреть и продавать.",
    "onboarding.step.upload_digital_product.cta": "Добавить цифровой товар",
    "Add digital product": "Добавить цифровой товар",
    "onboarding.step.upload_digital_product.impact": "Создает первый цифровой товар, готовый к продаже.",
    "Creates your first sellable digital asset.": "Создает первый цифровой товар, готовый к продаже.",
    "onboarding.step.test_purchase.title": "Проверьте покупку",
    "Test purchase flow": "Проверьте покупку",
    "onboarding.step.test_purchase.description": "Предварительно просмотрите путь покупателя от поиска товара до оплаты.",
    "Preview what buyers see from discovery through checkout.": "Предварительно просмотрите путь покупателя от поиска товара до оплаты.",
    "onboarding.step.test_purchase.cta": "Проверить оформление заказа",
    "Test checkout": "Проверить оформление заказа",
    "onboarding.step.test_purchase.impact": "Подтверждает, что путь покупателя работает.",
    "Confirms the buyer journey.": "Подтверждает, что путь покупателя работает.",
    "onboarding.step.create_campaign.title": "Создайте первую кампанию",
    "Create the first campaign": "Создайте первую кампанию",
    "onboarding.step.create_campaign.description": "Добавьте страницу кампании или проекта, которую сторонники увидят в первую очередь.",
    "Add the campaign or cause page supporters should understand first.": "Добавьте страницу кампании или проекта, которую сторонники увидят в первую очередь.",
    "onboarding.step.create_campaign.cta": "Создать кампанию",
    "Create campaign": "Создать кампанию",
    "onboarding.step.create_campaign.impact": "Создает первую публичную цель для участия.",
    "Creates the first public reason to act.": "Создает первую публичную цель для участия.",
    "onboarding.step.setup_payments_campaign.title": "Подключите прием платежей от сторонников",
    "Connect contribution payments": "Подключите прием платежей от сторонников",
    "onboarding.step.setup_payments_campaign.description": "Сторонники смогут выполнить вклад, если намерение можно сразу превратить в действие.",
    "Supporter intent matters when they can complete a contribution.": "Сторонники смогут выполнить вклад, если намерение можно сразу превратить в действие.",
    "onboarding.step.setup_payments_campaign.cta": "Настроить платежи",
    "onboarding.step.setup_payments_campaign.impact": "Позволяет принимать реальные пожертвования.",
    "Enables real contributions.": "Позволяет принимать реальные пожертвования.",
    "onboarding.step.test_supporter_flow.title": "Проверьте путь сторонника",
    "Test supporter flow": "Проверьте путь сторонника",
    "onboarding.step.test_supporter_flow.description": "Откройте публичную страницу и убедитесь, что цель и действие понятны.",
    "Open the public journey and make sure the story and action are clear.": "Откройте публичную страницу и убедитесь, что цель и действие понятны.",
    "onboarding.step.test_supporter_flow.cta": "Проверить путь",
    "Test flow": "Проверить путь",
    "onboarding.step.test_supporter_flow.impact": "Проверяет публичный путь участия.",
    "Validates the public path.": "Проверяет публичный путь участия.",
    "onboarding.step.set_account_categories.title": "Настройте категории аккаунтов поставщиков",
    "Define supplier account categories": "Настройте категории аккаунтов поставщиков",
    "onboarding.step.set_account_categories.description": "Разделите профили поставщиков по типам, чтобы повысить доверие и упростить поиск для покупателей.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Разделите профили поставщиков по типам, чтобы повысить доверие и упростить поиск для покупателей.",
    "onboarding.step.set_account_categories.cta": "Категории аккаунтов",
    "Account categories": "Категории аккаунтов",
    "onboarding.step.set_account_categories.impact": "Структура поставщиков настроена.",
    "Supplier structure established.": "Структура поставщиков настроена.",
    "onboarding.step.set_account_attributes.title": "Добавьте атрибуты профиля поставщика",
    "Add supplier profile attributes": "Добавьте атрибуты профиля поставщика",
    "onboarding.step.set_account_attributes.description": "Соберите сведения, которые покупателям нужны перед обращением к поставщику или заказом.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Соберите сведения, которые покупателям нужны перед обращением к поставщику или заказом.",
    "onboarding.step.set_account_attributes.cta": "Атрибуты поставщика",
    "Supplier attributes": "Атрибуты поставщика",
    "onboarding.step.set_account_attributes.impact": "Повышает доверие покупателей.",
    "Higher buyer confidence.": "Повышает доверие покупателей.",
    "onboarding.step.add_promotion.title": "Добавьте стартовую акцию",
    "Add a launch promotion": "Добавьте стартовую акцию",
    "onboarding.step.add_promotion.description": "Создайте первую акцию, чтобы побудить посетителей к действию.",
    "Create your first promotion to encourage action during the first visit.": "Создайте первую акцию, чтобы побудить посетителей к действию.",
    "onboarding.step.add_promotion.cta": "Добавить акцию",
    "Add promotion": "Добавить акцию",
    "onboarding.step.add_promotion.impact": "Повышает конверсию при запуске.",
    "Strengthens launch conversion.": "Повышает конверсию при запуске.",
    "onboarding.step.create_coupon.title": "Создайте первый купон",
    "Create your first coupon": "Создайте первый купон",
    "onboarding.step.create_coupon.description": "Проверьте скидки для новых покупателей или участников.",
    "Test discounts for first-time buyers or members.": "Проверьте скидки для новых покупателей или участников.",
    "onboarding.step.create_coupon.cta": "Создать купон",
    "Create coupon": "Создать купон",
    "onboarding.step.create_coupon.impact": "Открывает первый цикл предложений.",
    "Unlocks your first offer loop.": "Открывает первый цикл предложений.",
    "onboarding.step.collections_setup.title": "Создайте подборку",
    "Create a collection": "Создайте подборку",
    "onboarding.step.collections_setup.description": "Сгруппируйте важные объявления, чтобы упростить поиск и просмотр.",
    "Organize important listings to improve discovery and browsing.": "Сгруппируйте важные объявления, чтобы упростить поиск и просмотр.",
    "onboarding.step.collections_setup.cta": "Создать подборку",
    "Create collection": "Создать подборку",
    "onboarding.step.collections_setup.impact": "Улучшает навигацию и поиск.",
    "Improves navigation and discovery.": "Улучшает навигацию и поиск.",
    "onboarding.step.configure_comms.title": "Проверьте шаблоны сообщений",
    "Review communication templates": "Проверьте шаблоны сообщений",
    "onboarding.step.configure_comms.description": "Подготовьте уведомления о регистрации и заказах до начала роста.",
    "Prepare signup and order notifications before growth.": "Подготовьте уведомления о регистрации и заказах до начала роста.",
    "onboarding.step.configure_comms.cta": "Открыть сообщения",
    "Open communications": "Открыть сообщения",
    "onboarding.step.configure_comms.impact": "Подготавливает общение с клиентами.",
    "Prepares customer communications.": "Подготавливает общение с клиентами.",
    "onboarding.step.customize_attributes.title": "Добавьте атрибуты объявления",
    "Add listing attributes": "Добавьте атрибуты объявления",
    "onboarding.step.customize_attributes.description": "Добавьте структурированные поля, чтобы пользователи могли фильтровать и сравнивать важные параметры.",
    "Add structured fields so users can filter and compare what matters.": "Добавьте структурированные поля, чтобы пользователи могли фильтровать и сравнивать важные параметры.",
    "onboarding.step.customize_attributes.cta": "Добавить атрибуты",
    "Add attributes": "Добавить атрибуты",
    "onboarding.step.customize_attributes.impact": "Упрощает сравнение объявлений.",
    "Makes listings easier to compare.": "Упрощает сравнение объявлений.",
    "onboarding.step.add_digital_asset.title": "Добавьте еще один цифровой товар",
    "Add another digital item": "Добавьте еще один цифровой товар",
    "onboarding.step.add_digital_asset.description": "Расширьте каталог, чтобы пользователи могли оценить качество и ассортимент.",
    "Expand the catalog so users can evaluate quality and assortment.": "Расширьте каталог, чтобы пользователи могли оценить качество и ассортимент.",
    "onboarding.step.add_digital_asset.cta": "Добавить цифровое объявление",
    "Add digital listing": "Добавить цифровое объявление",
    "onboarding.step.add_digital_asset.impact": "Повышает доверие к цифровому каталогу.",
    "Improves digital catalog credibility.": "Повышает доверие к цифровому каталогу.",
    "personal_assistant.title": "Персональный помощник",
    "Personal assistant": "Персональный помощник",
    "personal_assistant.heading": "Развивайте платформу шаг за шагом",
    "Grow your platform one step at a time": "Развивайте платформу шаг за шагом",
    "personal_assistant.subtitle": "Создано для: {launchType}. Мы расставляем приоритеты по влиянию и готовности.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Создано для: {launchType}. Мы расставляем приоритеты по влиянию и готовности.",
    "personal_assistant.launch.store": "магазина",
    "a store": "магазина",
    "personal_assistant.launch.marketplace": "маркетплейса",
    "a marketplace": "маркетплейса",
    "personal_assistant.launch.booking": "платформы бронирования",
    "a booking platform": "платформы бронирования",
    "personal_assistant.launch.digital": "цифрового бизнеса",
    "a digital business": "цифрового бизнеса",
    "personal_assistant.launch.campaign": "платформы кампаний",
    "a campaign platform": "платформы кампаний",
    "personal_assistant.metric.tasks_completed": "Выполненные задачи",
    "Tasks completed": "Выполненные задачи",
    "personal_assistant.metric.recommendation_clicks": "Переходы по рекомендациям",
    "Recommendation clicks": "Переходы по рекомендациям",
    "personal_assistant.metric.completed_by_recommendation": "Выполнено по рекомендациям",
    "Completed via recommendations": "Выполнено по рекомендациям",
    "personal_assistant.metric.assist_rate": "Доля выполненных с помощью",
    "Assist rate": "Доля выполненных с помощью",
    "personal_assistant.personalizing": "Подбираем рекомендации…",
    "Personalizing your recommendations…": "Подбираем рекомендации…",
    "personal_assistant.do_this_now": "Сделать сейчас",
    "Do this now": "Сделать сейчас",
    "personal_assistant.estimated_time": "Примерное время: {minutes} мин",
    "Estimated time: {minutes} min": "Примерное время: {minutes} мин",
    "personal_assistant.minutes_short": "{minutes} мин",
    "{minutes} min": "{minutes} мин",
    "personal_assistant.open": "Открыть",
    "personal_assistant.mark_done": "Отметить выполненным",
    "personal_assistant.up_next": "Далее",
    "Up next": "Далее",
    "personal_assistant.coming_after": "После этого",
    "Coming after this": "После этого",
    "personal_assistant.completed_count": "Выполнено ({count})",
    "Completed ({count})": "Выполнено ({count})",
    "personal_assistant.hide": "Скрыть",
    "Hide": "Скрыть",
    "personal_assistant.show": "Показать",
    "Show": "Показать",
    "personal_assistant.feature.open_live_site.name": "Откройте сайт",
    "personal_assistant.feature.open_live_site.outcome": "Вы убедитесь, что клиенты могут открыть работающую платформу.",
    "You confirm customers can reach the live platform.": "Вы убедитесь, что клиенты могут открыть работающую платформу.",
    "personal_assistant.feature.create_supply_shape.name": "Создайте первую категорию",
    "personal_assistant.feature.create_supply_shape.outcome": "Клиенты смогут просматривать каталог с понятной структурой.",
    "Customers can browse with a clear structure.": "Клиенты смогут просматривать каталог с понятной структурой.",
    "personal_assistant.feature.post_first_listing.name": "Опубликуйте тестовое объявление",
    "personal_assistant.feature.post_first_listing.outcome": "Теперь на платформе есть первое предложение для оценки.",
    "The platform now has first supply to evaluate.": "Теперь на платформе есть первое предложение для оценки.",
    "personal_assistant.feature.test_buyer_action.name": "Попробуйте путь покупателя",
    "personal_assistant.feature.test_buyer_action.outcome": "Вы проверите весь клиентский путь покупателя.",
    "You validate buyer-side experience end to end.": "Вы проверите весь клиентский путь покупателя.",
    "personal_assistant.feature.setup_payments.name": "Подключите платежи",
    "personal_assistant.feature.setup_payments.outcome": "Клиенты смогут совершать реальные платежи.",
    "Customers can complete real transactions.": "Клиенты смогут совершать реальные платежи.",
    "personal_assistant.feature.setup_delivery.name": "Настройте доставку или способ оказания услуги",
    "personal_assistant.feature.setup_delivery.outcome": "Клиенты смогут понять, как выполняется заказ.",
    "Customers can understand fulfillment clearly.": "Клиенты смогут понять, как выполняется заказ.",
    "personal_assistant.feature.add_promotion.name": "Добавьте стартовую акцию",
    "personal_assistant.feature.add_promotion.outcome": "Вы создадите стимул для ранней конверсии.",
    "You create an early conversion incentive.": "Вы создадите стимул для ранней конверсии.",
    "personal_assistant.feature.configure_comms.name": "Проверьте шаблоны сообщений",
    "personal_assistant.feature.configure_comms.outcome": "Пользователи будут получать понятные сообщения на каждом этапе.",
    "Users receive clear lifecycle communication.": "Пользователи будут получать понятные сообщения на каждом этапе.",
    "personal_assistant.feature.view_orders.name": "Откройте заказы",
    "Open orders": "Откройте заказы",
    "personal_assistant.feature.view_orders.outcome": "Вы сможете отслеживать и обрабатывать поступающие заказы.",
    "You can monitor and process incoming demand.": "Вы сможете отслеживать и обрабатывать поступающие заказы.",
    "personal_assistant.feature.view_accounts.name": "Откройте аккаунты",
    "Open accounts": "Откройте аккаунты",
    "personal_assistant.feature.view_accounts.outcome": "Вы сможете удобно проверять поставщиков или участников.",
    "You can review suppliers or members efficiently.": "Вы сможете удобно проверять поставщиков или участников.",
    "personal_assistant.feature.configure_account_categories.name": "Настройте категории аккаунтов",
    "Configure account categories": "Настройте категории аккаунтов",
    "personal_assistant.feature.configure_account_categories.outcome": "Структура поставщиков и участников станет понятнее, что упростит адаптацию и укрепит доверие.",
    "Supplier and member structure is clearer for onboarding and trust.": "Структура поставщиков и участников станет понятнее, что упростит адаптацию и укрепит доверие.",
    "personal_assistant.feature.configure_account_attributes.name": "Настройте атрибуты аккаунтов",
    "Configure account attributes": "Настройте атрибуты аккаунтов",
    "personal_assistant.feature.configure_account_attributes.outcome": "Профили будут содержать важные для выбора покупателей сведения.",
    "Profiles capture decision-critical info for buyers.": "Профили будут содержать важные для выбора покупателей сведения.",
    "personal_assistant.feature.review_account_config.name": "Проверьте настройки аккаунтов",
    "Review account configuration": "Проверьте настройки аккаунтов",
    "personal_assistant.feature.review_account_config.outcome": "Работа аккаунтов соответствует правилам маркетплейса.",
    "Account behavior matches your marketplace policy.": "Работа аккаунтов соответствует правилам маркетплейса.",
    "personal_assistant.feature.view_listings.name": "Откройте объявления",
    "Open listings": "Откройте объявления",
    "personal_assistant.feature.view_listings.outcome": "Вы сможете отслеживать качество и готовность каталога.",
    "You can monitor catalog quality and readiness.": "Вы сможете отслеживать качество и готовность каталога.",
    "personal_assistant.feature.configure_listing_categories.name": "Настройте категории объявлений",
    "Configure listing categories": "Настройте категории объявлений",
    "personal_assistant.feature.configure_listing_categories.outcome": "Каталог станет удобнее для навигации и поиска.",
    "The catalog becomes easier to navigate and discover.": "Каталог станет удобнее для навигации и поиска.",
    "personal_assistant.feature.configure_listing_attributes.name": "Настройте атрибуты объявлений",
    "Configure listing attributes": "Настройте атрибуты объявлений",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Пользователи смогут сравнивать объявления по структурированным данным.",
    "Users can compare listings with structured details.": "Пользователи смогут сравнивать объявления по структурированным данным.",
    "personal_assistant.feature.configure_variant_types.name": "Настройте типы вариантов",
    "Configure variant types": "Настройте типы вариантов",
    "personal_assistant.feature.configure_variant_types.outcome": "Каталог будет наглядно поддерживать варианты товаров и услуг.",
    "The catalog supports product and service variations clearly.": "Каталог будет наглядно поддерживать варианты товаров и услуг.",
    "personal_assistant.feature.review_listing_configs.name": "Проверьте дополнительные функции объявлений",
    "Review listing additional features": "Проверьте дополнительные функции объявлений",
    "personal_assistant.feature.review_listing_configs.outcome": "Работа объявлений соответствует вашей операционной модели.",
    "Listing behavior matches your operating model.": "Работа объявлений соответствует вашей операционной модели.",
    "personal_assistant.feature.manage_collections.name": "Управляйте подборками",
    "Manage collections": "Управляйте подборками",
    "personal_assistant.feature.manage_collections.outcome": "Подборки с интересующими товарами легче найти.",
    "High-intent browsing paths are easier to discover.": "Подборки с интересующими товарами легче найти.",
    "personal_assistant.feature.manage_coupons.name": "Управляйте купонами",
    "Manage coupons": "Управляйте купонами",
    "personal_assistant.feature.manage_coupons.outcome": "Вы сможете запускать целевые предложения для привлечения пользователей.",
    "You can run targeted offers for activation.": "Вы сможете запускать целевые предложения для привлечения пользователей.",
    "personal_assistant.feature.view_transactions.name": "Просмотрите транзакции",
    "View transactions": "Просмотрите транзакции",
    "personal_assistant.feature.view_transactions.outcome": "Платежи можно отслеживать для повышения доверия и контроля операций.",
    "Payment activity can be monitored for trust and operations.": "Платежи можно отслеживать для повышения доверия и контроля операций.",
    "personal_assistant.feature.view_users.name": "Откройте пользователей",
    "Open users": "Откройте пользователей",
    "personal_assistant.feature.view_users.outcome": "Вы сможете отслеживать качество роста клиентской базы и участников.",
    "You can monitor customer and member growth quality.": "Вы сможете отслеживать качество роста клиентской базы и участников.",
    "personal_assistant.feature.configure_user_attributes.name": "Настройте атрибуты пользователей",
    "Configure user attributes": "Настройте атрибуты пользователей",
    "personal_assistant.feature.configure_user_attributes.outcome": "Собирайте данные профиля, чтобы повышать вовлеченность.",
    "You can capture profile signals to improve engagement.": "Собирайте данные профиля, чтобы повышать вовлеченность.",
    "personal_assistant.feature.review_ratings.name": "Проверьте оценки и отзывы",
    "Review ratings and reviews": "Проверьте оценки и отзывы",
    "personal_assistant.feature.review_ratings.outcome": "Данные о доверии отслеживаются и улучшаются.",
    "Trust signals are monitored and improved.": "Данные о доверии отслеживаются и улучшаются.",
    "personal_assistant.feature.view_reports.name": "Откройте отчеты",
    "Open reports": "Откройте отчеты",
    "personal_assistant.feature.view_reports.outcome": "Отслеживайте показатели с помощью данных.",
    "You can track performance with a data view.": "Отслеживайте показатели с помощью данных.",
    "personal_assistant.feature.manage_media.name": "Управляйте медиатекой",
    "Manage media library": "Управляйте медиатекой",
    "personal_assistant.feature.manage_media.outcome": "Поддерживать фирменный стиль и визуальное оформление объявлений станет проще.",
    "Brand and listing visuals are easier to maintain.": "Поддерживать фирменный стиль и визуальное оформление объявлений станет проще.",
    "personal_assistant.feature.manage_reported_listings.name": "Проверьте жалобы на объявления",
    "Review reported listings": "Проверьте жалобы на объявления",
    "personal_assistant.feature.manage_reported_listings.outcome": "С рисковым или некачественным контентом можно быстро разобраться.",
    "Risky or low-quality content can be handled quickly.": "С рисковым или некачественным контентом можно быстро разобраться.",
    "personal_assistant.feature.app_customization.name": "Настройте приложение",
    "Customize app experience": "Настройте приложение",
    "personal_assistant.feature.app_customization.outcome": "Мобильное приложение будет соответствовать вашему бренду.",
    "The mobile app experience aligns with your brand.": "Мобильное приложение будет соответствовать вашему бренду.",
    "personal_assistant.feature.app_integrations.name": "Настройте интеграции приложения",
    "Configure app integrations": "Настройте интеграции приложения",
    "personal_assistant.feature.app_integrations.outcome": "Основные сервисы платформы будут связаны с процессами приложения.",
    "Core platform services connect with app workflows.": "Основные сервисы платформы будут связаны с процессами приложения.",
    "personal_assistant.feature.customize_strings.name": "Настройте текст интерфейса",
    "Customize interface text": "Настройте текст интерфейса",
    "personal_assistant.feature.customize_strings.outcome": "Тексты продукта будут соответствовать аудитории и тону вашего бренда.",
    "Product copy matches your audience and tone.": "Тексты продукта будут соответствовать аудитории и тону вашего бренда.",
    "personal_assistant.feature.review_settings_home.name": "Откройте настройки",
    "Open settings": "Откройте настройки",
    "personal_assistant.feature.review_settings_home.outcome": "Команде будет проще находить настройки для работы.",
    "Configuration is easy to find for team operations.": "Команде будет проще находить настройки для работы.",
    "personal_assistant.feature.configure_commission.name": "Настройте комиссию",
    "Configure commission": "Настройте комиссию",
    "personal_assistant.feature.configure_commission.outcome": "Распределение доходов будет соответствовать вашей бизнес-модели.",
    "Revenue sharing aligns with your business model.": "Распределение доходов будет соответствовать вашей бизнес-модели.",
    "personal_assistant.feature.configure_taxes.name": "Настройте налоги",
    "Configure taxes": "Настройте налоги",
    "personal_assistant.feature.configure_taxes.outcome": "Стоимость при оформлении заказа будет предсказуемой, а налоги — настроенными.",
    "Checkout pricing is predictable and tax settings are ready.": "Стоимость при оформлении заказа будет предсказуемой, а налоги — настроенными.",
    "personal_assistant.feature.configure_languages.name": "Настройте языки",
    "Configure languages": "Настройте языки",
    "personal_assistant.feature.configure_languages.outcome": "Платформа будет поддерживать пользователей на разных языках.",
    "The experience supports a multilingual audience.": "Платформа будет поддерживать пользователей на разных языках.",
    "personal_assistant.feature.configure_currency.name": "Настройте валюту",
    "Configure currency": "Настройте валюту",
    "personal_assistant.feature.configure_currency.outcome": "Цены будут соответствовать ожиданиям целевого рынка.",
    "Prices align with the expectations of your target market.": "Цены будут соответствовать ожиданиям целевого рынка.",
    "personal_assistant.feature.configure_countries.name": "Настройте страны",
    "Configure countries": "Настройте страны",
    "personal_assistant.feature.configure_countries.outcome": "География работы платформы будет задана к запуску.",
    "Geographic coverage is controlled for launch.": "География работы платформы будет задана к запуску.",
    "personal_assistant.feature.review_checkout_settings.name": "Проверьте настройки оплаты",
    "Review checkout settings": "Проверьте настройки оплаты",
    "personal_assistant.feature.review_checkout_settings.outcome": "Оформление заказа станет удобнее и надежнее.",
    "Checkout is cleaner and more reliable.": "Оформление заказа станет удобнее и надежнее.",
    "personal_assistant.feature.api_configuration.name": "Проверьте настройки API",
    "Review API configuration": "Проверьте настройки API",
    "personal_assistant.feature.api_configuration.outcome": "Интеграции и доступ для разработчиков готовы.",
    "Integrations and developer access are ready.": "Интеграции и доступ для разработчиков готовы.",
    "personal_assistant.feature.workspace_website_editor.name": "Откройте редактор сайта",
    "Open website editor": "Откройте редактор сайта",
    "personal_assistant.feature.workspace_website_editor.outcome": "Витрину можно улучшить для повышения конверсии.",
    "The storefront can be refined for conversion.": "Витрину можно улучшить для повышения конверсии.",
    "personal_assistant.feature.workspace_domain_setup.name": "Проверьте настройки домена",
    "Review domain setup": "Проверьте настройки домена",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Понятный домен повышает доверие к бренду.",
    "A clean domain improves brand trust.": "Понятный домен повышает доверие к бренду.",
    "personal_assistant.feature.workspace_pages.name": "Проверьте страницы сайта",
    "Review site pages": "Проверьте страницы сайта",
    "personal_assistant.feature.workspace_pages.outcome": "Основные целевые страницы и материалы укрепляют доверие пользователей.",
    "Core landing and content pages support user trust.": "Основные целевые страницы и материалы укрепляют доверие пользователей.",
    "reports.title": "Отчеты",
    "reports.metric.0": "Пользователи",
    "reports.metric.1": "Аккаунты",
    "reports.metric.2": "Объявления",
    "reports.metric.3": "Проданные объявления",
    "Listings Sold": "Проданные объявления",
    "reports.metric.4": "Общие продажи",
    "Total Sales": "Общие продажи",
    "reports.metric.5": "Всего заказов",
    "reports.metric.6": "Общий доход",
    "Total Earnings": "Общий доход",
    "reports.chart.activity": "Ежедневная активность маркетплейса",
    "Daily marketplace activity": "Ежедневная активность маркетплейса",
    "reports.chart.activity_description": "Объявления и новые пользователи с течением времени",
    "Listings and new users over time": "Объявления и новые пользователи с течением времени",
    "reports.chart.listings_monthly": "Объявления за месяц",
    "Listings monthly": "Объявления за месяц",
    "reports.chart.listings_daily": "Объявления за день",
    "Listings daily": "Объявления за день",
    "reports.chart.users_daily": "Пользователи за день",
    "Users daily": "Пользователи за день",
    "reports.chart.users_monthly": "Пользователи за месяц",
    "Users monthly": "Пользователи за месяц",
    "reports.series.listings": "Объявления",
    "reports.series.new_users": "Новые пользователи",
    "New users": "Новые пользователи",
    "reports.top_sold_listings": "Самые продаваемые объявления",
    "Top sold listings": "Самые продаваемые объявления",
    "reports.view_more_insights": "Другие аналитические данные",
    "View more insights": "Другие аналитические данные",
    "reports.ai.title": "Отчеты о продажах с помощью ИИ",
    "AI sales reports": "Отчеты о продажах с помощью ИИ",
    "reports.ai.generating": "Создание отчетов…",
    "Generating reports…": "Создание отчетов…",
    "reports.ai.value": "Значение",
    "reports.ai.more_info": "Подробнее о параметре «{label}»",
    "More information about {label}": "Подробнее о параметре «{label}»",
    "reports.ai.saved_snapshot": "Сохраненный снимок",
    "Saved snapshot": "Сохраненный снимок",
    "reports.ai.no_data": "Нет данных",
    "No data available": "Нет данных",
    "reports.ai.showing_top": "Показаны первые {shown} из {total} результатов",
    "Showing the top {shown} of {total} results": "Показаны первые {shown} из {total} результатов",
    "reports.ai.saved_report": "Сохраненный отчет ИИ",
    "Saved AI report": "Сохраненный отчет ИИ",
    "reports.ai.template.country": "Продажи по странам",
    "Sales by country": "Продажи по странам",
    "reports.ai.template.state": "Продажи по регионам",
    "Sales by state": "Продажи по регионам",
    "reports.ai.template.city": "Продажи по городам",
    "Sales by city": "Продажи по городам",
    "reports.ai.template.category": "Продажи по категориям",
    "Sales by category": "Продажи по категориям",
    "reports.ai.template.country_all_time": "Продажи по странам (за все время)",
    "Sales by country (all time)": "Продажи по странам (за все время)",
    "reports.ai.template.top_listings_all_time": "Самые продаваемые объявления (за все время)",
    "Top sold listings (all time)": "Самые продаваемые объявления (за все время)",
    "reports.ai.template.listings_by_category_all_time": "Объявления по категориям (за все время)",
    "Listings by category (all time)": "Объявления по категориям (за все время)",
    "reports.search_table.title": "Поиск объявлений",
    "Listing search": "Поиск объявлений",
    "reports.search_table.phrase": "Фраза",
    "Phrase": "Фраза",
    "reports.search_table.result": "Результат",
    "reports.search_table.created_at": "Создано",
    "Created at": "Создано",
    "reports.search_table.user_first_name": "Имя пользователя",
    "User first name": "Имя пользователя",
    "reports.search_table.user_last_name": "Фамилия пользователя",
    "User last name": "Фамилия пользователя",
    "reports.search_table.user_email": "Электронная почта пользователя",
    "User email": "Электронная почта пользователя",
    "intelligence.title": "Аналитика",
    "intelligence.description": "Создавайте отчеты с помощью ИИ, сохраняйте снимки графиков и закрепляйте полезные отчеты на панели.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Создавайте отчеты с помощью ИИ, сохраняйте снимки графиков и закрепляйте полезные отчеты на панели.",
    "intelligence.dashboard.label": "Панель",
    "intelligence.dashboard.pinned_title": "Закрепленные виджеты аналитики",
    "Pinned intelligence widgets": "Закрепленные виджеты аналитики",
    "intelligence.dashboard.pinned_count": "Закреплено: {count}",
    "{count} pinned": "Закреплено: {count}",
    "intelligence.dashboard.empty": "Закрепите сохраненные отчеты, чтобы создать удобную сетку на панели.",
    "Pin saved reports to build a reusable dashboard grid.": "Закрепите сохраненные отчеты, чтобы создать удобную сетку на панели.",
    "intelligence.action.open": "Открыть",
    "intelligence.action.pin": "Закрепить",
    "Pin": "Закрепить",
    "intelligence.action.unpin": "Открепить",
    "Unpin": "Открепить",
    "intelligence.action.generate": "Создать",
    "intelligence.action.save_snapshot": "Сохранить снимок",
    "Save snapshot": "Сохранить снимок",
    "intelligence.action.discard_draft": "Удалить черновик",
    "Discard draft": "Удалить черновик",
    "intelligence.action.load": "Загрузить",
    "Load": "Загрузить",
    "intelligence.action.refresh": "Обновить",
    "intelligence.action.delete": "Удалить",
    "intelligence.table.no_rows": "В отчете нет структурированных строк.",
    "No structured rows were returned for this report.": "В отчете нет структурированных строк.",
    "intelligence.table.no_rows_short": "Нет доступных строк.",
    "No rows available.": "Нет доступных строк.",
    "intelligence.field.template": "Шаблон отчета",
    "Report template": "Шаблон отчета",
    "intelligence.field.date_filter": "Фильтр по датам",
    "Date filter": "Фильтр по датам",
    "intelligence.field.prompt": "Предварительный просмотр запроса",
    "Prompt preview": "Предварительный просмотр запроса",
    "intelligence.field.report_name": "Название отчета",
    "Report name": "Название отчета",
    "intelligence.field.report_name_placeholder": "Например: Самые продаваемые товары — за последние 30 дней",
    "For example: Top Selling Products – Last 30 Days": "Например: Самые продаваемые товары — за последние 30 дней",
    "intelligence.field.chart": "Диаграмма",
    "Chart": "Диаграмма",
    "intelligence.field.prompt_label": "Запрос",
    "Prompt": "Запрос",
    "intelligence.date.relative": "Относительный период",
    "Relative": "Относительный период",
    "intelligence.date.absolute": "Точный период",
    "Absolute": "Точный период",
    "intelligence.date.last_n_days": "Последние N дней",
    "Last N days": "Последние N дней",
    "intelligence.date.last_days": "Последние {days} дней",
    "Last {days} days": "Последние {days} дней",
    "intelligence.date.from": "С",
    "intelligence.date.to": "По",
    "intelligence.saved_reports.title": "Сохраненные отчеты",
    "Saved reports": "Сохраненные отчеты",
    "intelligence.saved_reports.empty": "Сохраненных аналитических отчетов пока нет.",
    "No saved intelligence reports yet.": "Сохраненных аналитических отчетов пока нет.",
    "intelligence.active_report": "Текущий отчет",
    "Active report": "Текущий отчет",
    "intelligence.no_report_selected": "Отчет не выбран",
    "No report selected": "Отчет не выбран",
    "intelligence.active_report.empty_description": "Создайте отчет или загрузите сохраненный, чтобы просмотреть данные.",
    "Generate a report or load a saved one to inspect the data.": "Создайте отчет или загрузите сохраненный, чтобы просмотреть данные.",
    "intelligence.chart.value": "Значение",
    "intelligence.chart.unknown": "Неизвестно",
    "intelligence.chart_type.bar": "Столбчатая",
    "Barres": "Столбчатая",
    "intelligence.chart_type.line": "Линейная",
    "Line": "Линейная",
    "intelligence.chart_type.area": "С областями",
    "Area": "С областями",
    "intelligence.chart_type.pie": "Круговая",
    "Pie": "Круговая",
    "intelligence.chart.no_rows": "В отчете нет строк для построения диаграммы.",
    "This report did not return rows to plot.": "В отчете нет строк для построения диаграммы.",
    "intelligence.empty_report": "Используйте шаблон и фильтр дат, чтобы создать структурированный отчет ИИ, сохранить его и закрепить на панели.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Используйте шаблон и фильтр дат, чтобы создать структурированный отчет ИИ, сохранить его и закрепить на панели.",
    "intelligence.error.update": "Не удалось обновить сохраненный отчет.",
    "Unable to update the saved report.": "Не удалось обновить сохраненный отчет.",
    "intelligence.error.prompt_required": "Введите запрос, чтобы создать отчет.",
    "Enter a prompt to generate a report.": "Введите запрос, чтобы создать отчет.",
    "intelligence.error.invalid_response": "В ответе ИИ нет нормализованного отчета.",
    "The AI response did not include a normalized report.": "В ответе ИИ нет нормализованного отчета.",
    "intelligence.error.generate": "Не удалось создать отчет.",
    "Unable to generate the report right now.": "Не удалось создать отчет.",
    "intelligence.error.generate_before_save": "Сначала создайте отчет.",
    "Generate a report before saving.": "Сначала создайте отчет.",
    "intelligence.error.save": "Не удалось сохранить отчет.",
    "Unable to save the report.": "Не удалось сохранить отчет.",
    "intelligence.error.load": "Не удалось загрузить отчет.",
    "Unable to load the saved report.": "Не удалось загрузить отчет.",
    "intelligence.error.refresh": "Не удалось обновить отчет.",
    "Unable to refresh the saved report.": "Не удалось обновить отчет.",
    "intelligence.error.delete": "Не удалось удалить отчет.",
    "Unable to delete the saved report.": "Не удалось удалить отчет.",
    "intelligence.template.top_selling_products": "Самые продаваемые товары",
    "Top selling products": "Самые продаваемые товары",
    "intelligence.template.revenue_trend": "Динамика доходов",
    "Revenue trend": "Динамика доходов",
    "intelligence.template.low_stock_products": "Товары с низким запасом",
    "Low stock products": "Товары с низким запасом",
    "intelligence.template.top_categories_by_sales": "Топ категорий по продажам",
    "Top categories by sales": "Топ категорий по продажам",
    "intelligence.template.order_status_breakdown": "Распределение заказов по статусам",
    "Order status breakdown": "Распределение заказов по статусам",
    "intelligence.template.sales_by_day": "Продажи по дням",
    "Sales by day": "Продажи по дням",
    "intelligence.template.sales_by_country": "Продажи по странам",
    "intelligence.template.sales_by_state": "Продажи по регионам",
    "intelligence.template.sales_by_city": "Продажи по городам",
    "intelligence.template.sales_by_category": "Продажи по категориям",
    "intelligence.template.sales_by_subcategory": "Продажи по подкатегориям",
    "Sales by subcategory": "Продажи по подкатегориям",
    "intelligence.prompt.top_selling_products.relative": "Покажите самые продаваемые товары за последние {days} дней",
    "Show me top selling products for the last {days} days": "Покажите самые продаваемые товары за последние {days} дней",
    "intelligence.prompt.top_selling_products.absolute": "Покажите самые продаваемые товары с {from} по {to}",
    "Show me top selling products from {from} to {to}": "Покажите самые продаваемые товары с {from} по {to}",
    "intelligence.prompt.revenue_trend.relative": "Покажите динамику доходов за последние {days} дней",
    "What is my revenue trend for the last {days} days?": "Покажите динамику доходов за последние {days} дней",
    "intelligence.prompt.revenue_trend.absolute": "Покажите динамику доходов с {from} по {to}",
    "What is my revenue trend from {from} to {to}?": "Покажите динамику доходов с {from} по {to}",
    "intelligence.prompt.low_stock_products": "Покажите товары с низким запасом",
    "Show me low stock products": "Покажите товары с низким запасом",
    "intelligence.prompt.top_categories_by_sales.relative": "Покажите лучшие категории по продажам за последние {days} дней",
    "Show me top categories by sales for the last {days} days": "Покажите лучшие категории по продажам за последние {days} дней",
    "intelligence.prompt.top_categories_by_sales.absolute": "Покажите лучшие категории по продажам с {from} по {to}",
    "Show me top categories by sales from {from} to {to}": "Покажите лучшие категории по продажам с {from} по {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Покажите распределение заказов по статусам за последние {days} дней",
    "Show me order status breakdown for the last {days} days": "Покажите распределение заказов по статусам за последние {days} дней",
    "intelligence.prompt.order_status_breakdown.absolute": "Покажите распределение заказов по статусам с {from} по {to}",
    "Show me order status breakdown from {from} to {to}": "Покажите распределение заказов по статусам с {from} по {to}",
    "intelligence.prompt.sales_by_day.relative": "Покажите продажи по дням за последние {days} дней",
    "Show me sales by day for the last {days} days": "Покажите продажи по дням за последние {days} дней",
    "intelligence.prompt.sales_by_day.absolute": "Покажите продажи по дням с {from} по {to}",
    "Show me sales by day from {from} to {to}": "Покажите продажи по дням с {from} по {to}",
    "intelligence.prompt.sales_by_country.relative": "Покажите общую выручку и число заказов по странам за последние {days} дней",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Покажите общую выручку и число заказов по странам за последние {days} дней",
    "intelligence.prompt.sales_by_country.absolute": "Покажите общую выручку и число заказов по странам с {from} по {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Покажите общую выручку и число заказов по странам с {from} по {to}",
    "intelligence.prompt.sales_by_state.relative": "Покажите общую выручку и число заказов по регионам или провинциям за последние {days} дней",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Покажите общую выручку и число заказов по регионам или провинциям за последние {days} дней",
    "intelligence.prompt.sales_by_state.absolute": "Покажите общую выручку и число заказов по регионам или провинциям с {from} по {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Покажите общую выручку и число заказов по регионам или провинциям с {from} по {to}",
    "intelligence.prompt.sales_by_city.relative": "Покажите общую выручку и число заказов по городам за последние {days} дней",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Покажите общую выручку и число заказов по городам за последние {days} дней",
    "intelligence.prompt.sales_by_city.absolute": "Покажите общую выручку и число заказов по городам с {from} по {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Покажите общую выручку и число заказов по городам с {from} по {to}",
    "intelligence.prompt.sales_by_category.relative": "Покажите общую выручку и число заказов по основным категориям объявлений за последние {days} дней",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Покажите общую выручку и число заказов по основным категориям объявлений за последние {days} дней",
    "intelligence.prompt.sales_by_category.absolute": "Покажите общую выручку и число заказов по основным категориям объявлений с {from} по {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Покажите общую выручку и число заказов по основным категориям объявлений с {from} по {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Покажите общую выручку и число заказов по подкатегориям объявлений за последние {days} дней",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Покажите общую выручку и число заказов по подкатегориям объявлений за последние {days} дней",
    "intelligence.prompt.sales_by_subcategory.absolute": "Покажите общую выручку и число заказов по подкатегориям объявлений с {from} по {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Покажите общую выручку и число заказов по подкатегориям объявлений с {from} по {to}",
    "common.status.partial": "Частично",
    "Partial": "Частично",
    "common.status.dispatched": "Отправлено",
    "Dispatched": "Отправлено",
    "common.status.sale": "Продажа",
    "Sale": "Продажа",
    "common.status.transfer_in": "Поступление перемещения",
    "Transfer in": "Поступление перемещения",
    "common.status.transfer_out": "Отправка перемещения",
    "Transfer out": "Отправка перемещения",
    "common.status.return": "Возврат",
    "Return": "Возврат",
    "common.status.adjustment": "Корректировка",
    "Adjustment": "Корректировка",
    "common.status.receipt": "Приемка",
    "inventory.overview.title": "Запасы",
    "inventory.overview.tab.all": "Все запасы",
    "All stock": "Все запасы",
    "inventory.overview.tab.low": "Мало на складе",
    "Low stock": "Мало на складе",
    "inventory.overview.tab.expiring": "Партии с истекающим сроком",
    "Expiring batches": "Партии с истекающим сроком",
    "inventory.overview.manage_locations": "Места хранения",
    "Manage locations": "Места хранения",
    "inventory.overview.purchase_orders": "Заказы на закупку",
    "inventory.overview.operations": "Операции",
    "Operations": "Операции",
    "inventory.overview.adjust_stock": "Корректировать запасы",
    "inventory.overview.description": "Текущий обзор запасов во всех местах хранения.",
    "A live view of stock across your locations.": "Текущий обзор запасов во всех местах хранения.",
    "inventory.overview.adjustment_hint": "Используйте корректировки для инвентаризации, повреждений, возвратов и других исправлений.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Используйте корректировки для инвентаризации, повреждений, возвратов и других исправлений.",
    "inventory.overview.units_on_hand": "Единиц в наличии",
    "Units on hand": "Единиц в наличии",
    "inventory.overview.one_stock_row": "1 строка запасов",
    "1 stock row": "1 строка запасов",
    "inventory.overview.stock_rows": "Строк запасов: {count}",
    "{count} stock rows": "Строк запасов: {count}",
    "inventory.overview.low_stock": "Мало на складе",
    "inventory.overview.reorder_point_hint": "На уровне точки повторного заказа или ниже",
    "At or below reorder point": "На уровне точки повторного заказа или ниже",
    "inventory.overview.expiring_soon": "Скоро истекает срок годности",
    "Expiring soon": "Скоро истекает срок годности",
    "inventory.overview.next_90_days": "В течение следующих 90 дней",
    "Within the next 90 days": "В течение следующих 90 дней",
    "inventory.overview.stock_value": "Стоимость запасов",
    "Stock value": "Стоимость запасов",
    "inventory.overview.one_active_location": "1 активное место хранения",
    "1 active location": "1 активное место хранения",
    "inventory.overview.active_locations": "Активных мест хранения: {count}",
    "{count} active locations": "Активных мест хранения: {count}",
    "inventory.overview.search": "Поиск по запасам",
    "Search inventory": "Поиск по запасам",
    "inventory.overview.search_placeholder": "Поиск товара, артикула или места хранения",
    "Search product, SKU, or location": "Поиск товара, артикула или места хранения",
    "inventory.overview.filter_location": "Фильтр по месту хранения",
    "Filter by location": "Фильтр по месту хранения",
    "inventory.overview.all_locations": "Все места хранения",
    "inventory.overview.empty.all": "Запасы пока не зарегистрированы.",
    "No inventory stock has been recorded yet.": "Запасы пока не зарегистрированы.",
    "inventory.overview.empty.low": "Отлично — запасы не опустились ниже точки повторного заказа.",
    "Great — no stock is below its reorder point.": "Отлично — запасы не опустились ниже точки повторного заказа.",
    "inventory.overview.empty.expiring": "В ближайшие 90 дней срок годности партий не истекает.",
    "No batches are expiring within 90 days.": "В ближайшие 90 дней срок годности партий не истекает.",
    "inventory.overview.adjust": "Корректировать",
    "Adjust": "Корректировать",
    "inventory.overview.adjust_title": "Корректировка запасов",
    "inventory.overview.adjust_description": "Запишите корректировку и укажите причину, чтобы история запасов оставалась достоверной.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Запишите корректировку и укажите причину, чтобы история запасов оставалась достоверной.",
    "inventory.overview.save_adjustment": "Сохранить корректировку",
    "Save adjustment": "Сохранить корректировку",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Не назначено",
    "Unassigned": "Не назначено",
    "inventory.overview.quantity_change": "Изменение количества",
    "Quantity change": "Изменение количества",
    "inventory.overview.quantity_placeholder": "например, 5 или -2",
    "e.g. 5 or -2": "например, 5 или -2",
    "inventory.overview.reason": "Причина",
    "inventory.overview.reason_placeholder": "Пересчет, повреждение, возврат…",
    "Cycle count, damage, return…": "Пересчет, повреждение, возврат…",
    "inventory.overview.reason.cycle_count": "Пересчет запасов",
    "Cycle count": "Пересчет запасов",
    "inventory.overview.reason.damage": "Повреждение",
    "Damage": "Повреждение",
    "inventory.overview.reason.return": "Возврат",
    "inventory.overview.reason.stocktake": "Инвентаризация",
    "Stocktake": "Инвентаризация",
    "inventory.overview.note_placeholder": "Дополнительная информация для следующего сотрудника",
    "Optional context for the next person": "Дополнительная информация для следующего сотрудника",
    "inventory.overview.adjustment_saved": "Корректировка запасов сохранена",
    "Inventory adjustment saved": "Корректировка запасов сохранена",
    "inventory.overview.on_hand": "В наличии",
    "On hand": "В наличии",
    "inventory.overview.reorder_at": "Точка повторного заказа",
    "Reorder at": "Точка повторного заказа",
    "orders.create_order.payment_reference_missing": "Заказ создан, но номер заказа не получен.",
    "The order was created, but no order reference was returned.": "Заказ создан, но номер заказа не получен.",
    "orders.create_order.payment_domain_missing": "Домен организации недоступен для создания ссылок на оплату.",
    "The tenant domain is not available for payment links.": "Домен организации недоступен для создания ссылок на оплату.",
    "orders.create_order.payment_link_failed": "Не удалось создать ссылку на оплату.",
    "Unable to create payment link.": "Не удалось создать ссылку на оплату.",
    "orders.create_order.admin_session_expired": "Срок действия сеанса администратора истек. Войдите снова, прежде чем создавать заказ.",
    "Your admin session has expired. Please sign in again before creating an order.": "Срок действия сеанса администратора истек. Войдите снова, прежде чем создавать заказ.",
    "orders.create_order.user": "Пользователь",
    "orders.create_order.add_new_user": "Добавить пользователя",
    "Add New User": "Добавить пользователя",
    "orders.create_order.choose_existing_user": "Выбрать существующего пользователя",
    "Choose Existing User": "Выбрать существующего пользователя",
    "orders.create_order.preparing_customer": "Подготовка клиента…",
    "Preparing customer…": "Подготовка клиента…",
    "orders.create_order.select_user": "Выберите пользователя",
    "Select user": "Выберите пользователя",
    "orders.create_order.search_listing": "Поиск объявления",
    "Search Listing": "Поиск объявления",
    "orders.create_order.listings": "Объявления",
    "orders.create_order.no_image": "Нет изображения",
    "No image": "Нет изображения",
    "orders.create_order.add_to_cart": "Добавить в корзину",
    "Add to Cart": "Добавить в корзину",
    "orders.create_order.select_rental_dates": "Сначала выберите даты начала и окончания аренды.",
    "Select rental start and end dates first.": "Сначала выберите даты начала и окончания аренды.",
    "orders.create_order.rental_end_after_start": "Дата окончания аренды должна быть позже даты начала.",
    "Rental end must be after the start date.": "Дата окончания аренды должна быть позже даты начала.",
    "orders.create_order.cart_type_conflict": "У клиента уже есть товары другого типа. Удалите их при оформлении заказа, прежде чем добавлять этот товар.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "У клиента уже есть товары другого типа. Удалите их при оформлении заказа, прежде чем добавлять этот товар.",
    "orders.create_order.rental_period": "Период аренды",
    "Rental period": "Период аренды",
    "orders.create_order.select_start_end": "Выберите начало и окончание",
    "Select start and end": "Выберите начало и окончание",
    "orders.create_order.membership_no_shipping": "Для заказов на членство не требуется доставка.",
    "Membership orders do not require shipping or delivery.": "Для заказов на членство не требуется доставка.",
    "orders.create_order.preparing_payment_link": "Подготовка ссылки на оплату…",
    "Preparing payment link…": "Подготовка ссылки на оплату…",
    "orders.create_order.payment_link_ready": "Ссылка на оплату готова",
    "Payment link ready": "Ссылка на оплату готова",
    "orders.create_order.copy_payment_link": "Копировать ссылку на оплату",
    "Copy payment link": "Копировать ссылку на оплату",
    "orders.create_order.payment_method": "Способ оплаты",
    "orders.create_order.no_payment_methods": "Для этого проекта не настроены активные способы оплаты.",
    "No active payment methods are configured for this project.": "Для этого проекта не настроены активные способы оплаты.",
    "orders.create_order.shipping_method": "Способ доставки",
    "orders.create_order.no_shipping_methods": "Для этого проекта не настроены активные способы доставки.",
    "No active shipping methods are configured for this project.": "Для этого проекта не настроены активные способы доставки.",
    "orders.create_order.shipping_address": "Адрес доставки",
    "Shipping address": "Адрес доставки",
    "orders.create_order.loading_addresses": "Загрузка сохраненных адресов…",
    "Loading saved addresses…": "Загрузка сохраненных адресов…",
    "orders.create_order.no_saved_shipping_address": "У пользователя нет сохраненного адреса доставки. Добавьте адрес в профиль пользователя перед созданием заказа с доставкой.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "У пользователя нет сохраненного адреса доставки. Добавьте адрес в профиль пользователя перед созданием заказа с доставкой.",
    "orders.create_order.no_items": "Нет товаров",
    "No items": "Нет товаров",
    "orders.create_order.cart_empty": "Корзина пуста",
    "Your cart is empty": "Корзина пуста",
    "orders.create_order.create_order": "Создать заказ",
    "Create Order": "Создать заказ",
    "orders.create_order.create_payment_link": "Создать ссылку на оплату",
    "Create payment link": "Создать ссылку на оплату",
    "orders.create_order.order_summary": "Сводка заказа",
    "orders.create_order.coupon_value": "Сумма купона",
    "Coupon value": "Сумма купона",
    "orders.create_order.remove_coupon": "Удалить купон",
    "Remove Coupon": "Удалить купон",
    "orders.create_order.apply_coupon": "Применить купон",
    "Apply Coupon": "Применить купон",
    "orders.create_order.grand_amount": "Итоговая сумма",
    "Grand Amount": "Итоговая сумма",
    "orders.create_order.total": "Итого",
    "orders.create_order.shipping": "Доставка",
    "Shipping": "Доставка",
    "orders.create_order.subtotal": "Промежуточный итог",
    "Subtotal": "Промежуточный итог",
    "orders.create_order.stock_unavailable": "Товар отсутствует в наличии",
    "Stock is not available": "Товар отсутствует в наличии",
    "orders.create_order.max_quantity": "Максимальное количество: {quantity}",
    "Max quantity is {quantity}": "Максимальное количество: {quantity}",
    "orders.create_order.items_in_cart": "Товары в корзине",
    "Items in the cart": "Товары в корзине",
    "orders.create_order.products_in_stock": "Товаров в наличии: {count}",
    "{count} Products in Stock": "Товаров в наличии: {count}",
    "orders.create_order.order_items": "Позиции заказа",
    "orders.create_order.sold_by": "продавец: {name}",
    "by {name}": "продавец: {name}",
    "common.first_name": "Имя",
    "common.last_name": "Фамилия",
    "common.unlimited": "без ограничений",
    "unlimited": "без ограничений",
    "orders.reference": "Номер",
    "orders.amount": "Сумма",
    "orders.currency": "Валюта",
    "orders.transaction_date": "Дата транзакции",
    "Transaction Date": "Дата транзакции",
    "orders.volume_this_page": "Объем (на этой странице)",
    "Volume (this page)": "Объем (на этой странице)",
    "orders.seller_entries": "Операции продавца",
    "Seller Entries": "Операции продавца",
    "orders.customer_entries": "Операции клиента",
    "Customer Entries": "Операции клиента",
    "orders.filter_transactions": "Фильтр транзакций",
    "Filter Transactions": "Фильтр транзакций",
    "orders.reset_filters": "Сбросить фильтры",
    "Reset filters": "Сбросить фильтры",
    "orders.manage_transactions": "Управление транзакциями",
    "Manage your Transactions": "Управление транзакциями",
    "orders.empty_transactions_message": "Здесь можно отслеживать транзакции между пользователями. Например, комиссии, стоимость заказов, платежные сборы и специальные сборы.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Здесь можно отслеживать транзакции между пользователями. Например, комиссии, стоимость заказов, платежные сборы и специальные сборы.",
    "orders.super_type": "Основной тип",
    "Super Type": "Основной тип",
    "orders.exporting": "Экспорт…",
    "Exporting…": "Экспорт…",
    "orders.export_as_csv": "Экспорт в CSV",
    "Export as CSV": "Экспорт в CSV",
    "orders.search_transactions": "Поиск транзакций",
    "Search transactions": "Поиск транзакций",
    "orders.filter": "Фильтр",
    "Filter": "Фильтр",
    "orders.transaction_status": "Статус транзакции",
    "Transaction Status": "Статус транзакции",
    "orders.seller_protection_fee": "Сбор защиты продавца",
    "Seller Protection Fee": "Сбор защиты продавца",
    "common.show_rows": "Показать строки",
    "common.clear_all": "Очистить все",
    "Clear All": "Очистить все",
    "orders.order_number_value": "Заказ №{number}",
    "orders.transactions": "Транзакции",
    "reported_listings.report_detail": "Сведения о жалобе",
    "Report Detail": "Сведения о жалобе",
    "reported_listings.reported_listing": "Объявление с жалобой",
    "Reported Listing": "Объявление с жалобой",
    "reported_listings.pending": "Ожидает",
    "reported_listings.approved": "Одобрено",
    "reported_listings.rejected": "Отклонено",
    "reported_listings.view_marketplace": "Открыть на маркетплейсе",
    "View on marketplace": "Открыть на маркетплейсе",
    "reported_listings.approve_listing": "Одобрить объявление",
    "Approve listing": "Одобрить объявление",
    "reported_listings.reject_listing": "Отклонить объявление",
    "Reject listing": "Отклонить объявление",
    "reported_listings.reported_by": "Автор жалобы",
    "Reported By": "Автор жалобы",
    "reported_listings.blocked": "Заблокирован",
    "reported_listings.unblock_user": "Разблокировать пользователя",
    "Unblock user": "Разблокировать пользователя",
    "reported_listings.block_user": "Заблокировать пользователя",
    "Block user": "Заблокировать пользователя",
    "reported_listings.report_info": "Сведения о жалобе",
    "Report Info": "Сведения о жалобе",
    "reported_listings.reason": "Причина",
    "reported_listings.reported_on": "Дата жалобы",
    "Reported on": "Дата жалобы",
    "reported_listings.listing_id": "ID объявления",
    "Listing ID": "ID объявления",
    "reported_listings.reporter": "Автор",
    "Reporter": "Автор",
    "reported_listings.listing": "Объявление",
    "Listing": "Объявление",
    "reported_listings.status": "Статус",
    "reported_listings.title": "Жалобы на объявления",
    "reported_listings.report_count": "Жалоб: {count}",
    "Reports: {count}": "Жалоб: {count}",
    "reported_listings.empty_title": "Жалобы на объявления",
    "Viewing Reported listings": "Жалобы на объявления",
    "reported_listings.empty_message": "Здесь отображаются объявления, на которые пожаловались пользователи.",
    "You will find your users reported listings here": "Здесь отображаются объявления, на которые пожаловались пользователи.",
    "common.page_of": "Страница {page} из {total}",
    "Page {page} of {total}": "Страница {page} из {total}",
    "common.view": "Просмотр",
    "reviews.empty_title": "Оценки и отзывы",
    "Viewing Rate & Reviews": "Оценки и отзывы",
    "reviews.empty_message": "Здесь отображаются оценки и отзывы пользователей.",
    "You will find your users ratings and reviews here": "Здесь отображаются оценки и отзывы пользователей.",
    "reviews.list": "Список",
    "reviews.grid": "Сетка",
    "Grid": "Сетка",
    "reviews.title": "Отзывы и оценки",
    "reviews.review": "Отзыв",
    "reviews.name": "Имя",
    "reviews.rating": "Оценка",
    "reviews.title_column": "Заголовок",
    "reviews.content": "Содержание",
    "reviews.image": "Изображение",
    "Image": "Изображение",
    "reviews.images": "Изображения",
    "Images": "Изображения",
    "reviews.accounts": "Аккаунты",
    "reviews.listings": "Объявления",
    "reviews.star": "Звезда",
    "Star": "Звезда",
    "reviews.review_image": "Изображение отзыва",
    "Review image": "Изображение отзыва",
    "reviews.title_required": "Укажите заголовок",
    "reviews.content_required": "Укажите содержание",
    "Content is required": "Укажите содержание",
    "reviews.updated_successfully": "Отзыв обновлен",
    "Review updated successfully": "Отзыв обновлен",
    "reviews.edit_review": "Изменить отзыв",
    "Edit Review": "Изменить отзыв",
    "common.not_available": "Н/Д",
    "common.something_went_wrong": "Что-то пошло не так",
    "Something went wrong": "Что-то пошло не так",
    "media.load_failed": "Не удалось загрузить медиафайл.",
    "Unable to load media.": "Не удалось загрузить медиафайл.",
    "media.load_failed_retry": "Не удалось загрузить медиафайл. Повторите попытку.",
    "media.update_failed": "Не удалось обновить медиафайл",
    "Media update failed": "Не удалось обновить медиафайл",
    "media.renamed": "Имя медиафайла изменено",
    "Media renamed": "Имя медиафайла изменено",
    "media.moved": "Медиафайл перемещен",
    "Media moved": "Медиафайл перемещен",
    "media.rename_failed": "Не удалось переименовать медиафайл",
    "Unable to rename media": "Не удалось переименовать медиафайл",
    "media.move_failed": "Не удалось переместить медиафайл",
    "Unable to move media": "Не удалось переместить медиафайл",
    "media.deleted": "Медиафайл удален",
    "Media deleted": "Медиафайл удален",
    "media.delete_failed": "Не удалось удалить медиафайл",
    "Unable to delete media": "Не удалось удалить медиафайл",
    "media.confirm_delete": "Удалить этот медиафайл?",
    "Are you sure you want to delete this media?": "Удалить этот медиафайл?",
    "media.delete_media": "Удалить медиафайл",
    "Delete media": "Удалить медиафайл",
    "media.folder_creation_web_only": "Создание папок доступно в веб-версии",
    "Folder creation is available on web": "Создание папок доступно в веб-версии",
    "media.no_create_folder_permission": "У вас нет разрешения на создание папок",
    "You do not have permission to create folders": "У вас нет разрешения на создание папок",
    "media.folder_name": "Название папки",
    "Folder name": "Название папки",
    "media.folder_created": "Папка создана",
    "Folder created": "Папка создана",
    "media.folder_create_failed": "Не удалось создать папку",
    "Unable to create folder": "Не удалось создать папку",
    "media.link_copied": "Ссылка скопирована",
    "Link copied": "Ссылка скопирована",
    "media.copy_link_failed": "Не удалось скопировать ссылку",
    "Unable to copy link": "Не удалось скопировать ссылку",
    "media.urls_copied": "Скопировано ссылок: {count}",
    "{count} URLs copied": "Скопировано ссылок: {count}",
    "media.clipboard_unavailable": "Буфер обмена недоступен",
    "Clipboard is not available": "Буфер обмена недоступен",
    "media.copy_urls_failed": "Не удалось скопировать ссылки",
    "Unable to copy URLs": "Не удалось скопировать ссылки",
    "media.upload_failed": "Не удалось загрузить медиафайл",
    "Media upload failed": "Не удалось загрузить медиафайл",
    "media.replace_success": "Медиафайл заменен. Его ID и постоянная ссылка не изменились.",
    "Media replaced. The media ID and stable link are unchanged.": "Медиафайл заменен. Его ID и постоянная ссылка не изменились.",
    "media.replace_failed": "Не удалось заменить медиафайл",
    "Unable to replace media": "Не удалось заменить медиафайл",
    "media.csv_upload_failed": "Не удалось загрузить CSV",
    "CSV upload failed": "Не удалось загрузить CSV",
    "media.csv_metadata_failed": "Не удалось сохранить метаданные CSV",
    "Unable to save CSV metadata": "Не удалось сохранить метаданные CSV",
    "media.csv_saved_version": "CSV сохранен как новая версия",
    "CSV saved as a new version": "CSV сохранен как новая версия",
    "media.csv_save_failed": "Не удалось сохранить CSV",
    "Unable to save CSV": "Не удалось сохранить CSV",
    "media.uploading_files": "Загрузка файлов: {count}…",
    "Uploading {count} files…": "Загрузка файлов: {count}…",
    "media.upload_progress": "Загрузка файлов: {count} · {progress}%",
    "Uploading {count} files · {progress}%": "Загрузка файлов: {count} · {progress}%",
    "media.upload_success": "Файлов загружено: {count}.",
    "{count} files uploaded successfully.": "Файлов загружено: {count}.",
    "media.upload_failed_retry": "Не удалось загрузить медиафайл. Повторите попытку.",
    "Unable to upload media. Please try again.": "Не удалось загрузить медиафайл. Повторите попытку.",
    "media.register_failed": "Не удалось зарегистрировать медиафайл",
    "Unable to register media": "Не удалось зарегистрировать медиафайл",
    "media.list_view": "Вид списком",
    "List view": "Вид списком",
    "media.grid_view": "Вид сеткой",
    "Grid view": "Вид сеткой",
    "media.copy_uploaded_urls": "Копировать ссылки загруженных файлов",
    "Copy uploaded URLs": "Копировать ссылки загруженных файлов",
    "media.copy_visible_urls": "Копировать видимые ссылки",
    "Copy visible URLs": "Копировать видимые ссылки",
    "media.copy_all_urls": "Копировать все ссылки",
    "Copy all URLs": "Копировать все ссылки",
    "media.new_folder": "Новая папка",
    "New folder": "Новая папка",
    "media.uploading_progress": "Загрузка… {progress}%",
    "Uploading {progress}%": "Загрузка… {progress}%",
    "media.upload_media": "Загрузить медиафайлы",
    "media.manager_title": "Медиатека",
    "Media Manager": "Медиатека",
    "media.search": "Поиск медиафайлов",
    "Search media": "Поиск медиафайлов",
    "media.location": "Расположение",
    "media.media_root": "Медиафайлы",
    "media.show_type": "Показать медиафайлы типа {type}",
    "Show {type} media": "Показать медиафайлы типа {type}",
    "media.type_all": "все",
    "all": "все",
    "media.type_image": "изображение",
    "image": "изображение",
    "media.type_video": "видео",
    "video": "видео",
    "media.type_audio": "аудио",
    "audio": "аудио",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "папка",
    "folder": "папка",
    "media.sort_az": "А–Я",
    "A–Z": "А–Я",
    "media.oldest": "Сначала старые",
    "Oldest": "Сначала старые",
    "media.newest": "Сначала новые",
    "Newest": "Сначала новые",
    "media.sort_current": "Сортировка медиафайлов: {sort}",
    "Sort media, currently {sort}": "Сортировка медиафайлов: {sort}",
    "media.loading": "Загрузка медиафайлов…",
    "Loading media…": "Загрузка медиафайлов…",
    "media.no_filter_matches": "Нет медиафайлов, соответствующих фильтрам.",
    "No media matches these filters.": "Нет медиафайлов, соответствующих фильтрам.",
    "media.empty_title": "Медиатека пуста",
    "Your media library is empty": "Медиатека пуста",
    "media.empty_message": "Загрузите изображения, PDF и видео, чтобы использовать их повторно, например в акциях и статьях.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Загрузите изображения, PDF и видео, чтобы использовать их повторно, например в акциях и статьях.",
    "media.empty_hint": "Загрузите файлы или создайте папку, чтобы начать.",
    "Upload files or create a folder to get started.": "Загрузите файлы или создайте папку, чтобы начать.",
    "media.folder": "Папка",
    "Folder": "Папка",
    "media.file_folder_name": "Имя файла или папки",
    "File or folder name": "Имя файла или папки",
    "media.rename_media": "Переименовать медиафайл",
    "Rename media": "Переименовать медиафайл",
    "media.move_media": "Переместить медиафайл",
    "Move media": "Переместить медиафайл",
    "media.pdf_preview": "Предпросмотр PDF: {name}",
    "PDF preview: {name}": "Предпросмотр PDF: {name}",
    "media.pdf_preview_web": "Предпросмотр PDF доступен в веб-приложении.",
    "PDF preview is available in the web app.": "Предпросмотр PDF доступен в веб-приложении.",
    "media.csv_preview_web": "Предпросмотр CSV доступен в веб-приложении.",
    "CSV preview is available in the web app.": "Предпросмотр CSV доступен в веб-приложении.",
    "media.media_file": "Медиафайл",
    "Media file": "Медиафайл",
    "media.share_link": "Поделиться ссылкой",
    "Share link": "Поделиться ссылкой",
    "media.copy_link": "Копировать ссылку",
    "Copy link": "Копировать ссылку",
    "media.replace_media": "Заменить медиафайл",
    "Replace media": "Заменить медиафайл",
    "media.folders": "Папки",
    "Folders": "Папки",
    "media.create_new_folder": "Создать папку",
    "Create new folder": "Создать папку",
    "media.go_to_all_media": "Перейти ко всем медиафайлам",
    "Go to all media": "Перейти ко всем медиафайлам",
    "media.all_media": "Все медиафайлы",
    "All media": "Все медиафайлы",
    "media.open_folder_name": "Открыть папку {name}",
    "Open folder {name}": "Открыть папку {name}",
    "media.no_subfolders": "Нет вложенных папок",
    "No subfolders": "Нет вложенных папок",
    "media.no_files_in_folder": "В этой папке нет файлов.",
    "No files in this folder.": "В этой папке нет файлов.",
    "media.upload_folder": "Загрузить медиафайлы в эту папку",
    "Upload media to this folder": "Загрузить медиафайлы в эту папку",
    "media.discard_csv_confirm": "Отменить изменения CSV?",
    "Discard your CSV changes?": "Отменить изменения CSV?",
    "media.unsaved_changes": "Несохраненные изменения",
    "Unsaved changes": "Несохраненные изменения",
    "media.find_csv": "Найти в CSV",
    "Find in CSV": "Найти в CSV",
    "media.save_csv": "Сохранить CSV",
    "Save CSV": "Сохранить CSV",
    "media.loading_csv": "Загрузка CSV…",
    "Loading CSV…": "Загрузка CSV…",
    "media.prepare_folder_failed": "Не удалось подготовить папку для загрузки",
    "Unable to prepare the upload folder": "Не удалось подготовить папку для загрузки",
    "media.add_file_required": "Добавьте файл",
    "Please add a file": "Добавьте файл",
    "media.add_media": "Добавить медиафайл",
    "Add Media": "Добавить медиафайл",
    "media.store_uploaded_media_in": "Сохранить загруженные медиафайлы в",
    "Store uploaded media in": "Сохранить загруженные медиафайлы в",
    "media.destination_business_cards": "Визитные карточки",
    "Business Cards": "Визитные карточки",
    "media.destination_listings": "Объявления",
    "media.destination_accounts": "Аккаунты",
    "media.destination_users": "Пользователи",
    "media.upload_media_title": "Загрузка медиафайлов",
    "media.media_files": "Медиафайлы",
    "media.open_folder": "Открыть папку",
    "Open folder": "Открыть папку",
    "common.show": "Показать",
    "common.share": "Поделиться",
    "common.copy": "Копировать",
    "common.rename": "Переименовать",
    "Rename": "Переименовать",
    "common.move": "Переместить",
    "Move": "Переместить",
    "common.type": "Тип",
    "common.size": "Размер",
    "Size": "Размер",
    "common.preview": "Предпросмотр",
    "Preview": "Предпросмотр",
    "common.undo": "Отменить",
    "Undo": "Отменить",
    "common.redo": "Повторить",
    "Redo": "Повторить",
    "common.discard": "Отменить",
    "Discard": "Отменить",
    "common.try_again": "Повторить попытку",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Электронная таблица",
    "Spreadsheet": "Электронная таблица",
    "media.type_file": "Файл",
    "File": "Файл",
    "media.csv_load_failed": "Не удалось загрузить CSV. Повторите попытку.",
    "Unable to load CSV. Please try again.": "Не удалось загрузить CSV. Повторите попытку.",
    "workspace.settings_section.customisation": "Настройка",
    "workspace.settings_section.integrations": "Интеграции",
    "workspace.settings_section.platform_setup": "Настройка платформы",
    "Platform Setup": "Настройка платформы",
    "workspace.settings_section.business_operations": "Бизнес-операции",
    "Business Operations": "Бизнес-операции",
    "workspace.settings_section.system_setup": "Настройка системы",
    "System Setup": "Настройка системы",
    "workspace.settings_item.app_customisation": "Настройка приложения",
    "App Customisation": "Настройка приложения",
    "workspace.settings_item.web_customisation": "Настройка сайта",
    "workspace.settings_item.communications": "Сообщения",
    "Communications": "Сообщения",
    "workspace.settings_item.strings_customisation": "Настройка текстов",
    "Strings Customisation": "Настройка текстов",
    "workspace.settings_item.app_integrations": "Интеграции приложения",
    "workspace.settings_item.web_integrations": "Интеграции сайта",
    "Web Integrations": "Интеграции сайта",
    "workspace.settings_item.accounts": "Аккаунты",
    "workspace.settings_item.listings": "Объявления",
    "workspace.settings_item.checkout_and_cart_attributes": "Атрибуты оформления заказа и корзины",
    "workspace.settings_item.service_shipping": "Услуги и доставка",
    "workspace.settings_item.payments": "Платежи",
    "workspace.settings_item.commissions": "Комиссии",
    "workspace.settings_item.taxes": "Налоги",
    "workspace.settings_item.special_fees": "Специальные сборы",
    "workspace.settings_item.languages": "Языки",
    "workspace.settings_item.currency": "Валюта",
    "workspace.settings_item.countries": "Страны",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Расширения",
    "Extensions": "Расширения",
    "workspace.settings_item.manage_features": "Управление функциями",
    "Manage Features": "Управление функциями",
    "workspace.settings_item.audit_logs": "Журнал аудита",
    "Audit Logs": "Журнал аудита",
    "workspace.settings_item.auth": "Аутентификация",
    "workspace.settings_item.maps": "Карты",
    "workspace.settings_hint.accounts": "Например: магазин",
    "Example: Store": "Например: магазин",
    "workspace.settings_hint.listings": "Например: товары, мероприятия",
    "Example: Products, Events": "Например: товары, мероприятия",
    "workspace.settings_hint.audit_logs": "История соответствия требованиям и безопасности",
    "Compliance & security trail": "История соответствия требованиям и безопасности",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Использование провайдера и настройки конфиденциальности",
    "Provider usage and privacy settings": "Использование провайдера и настройки конфиденциальности",
    "workspace.settings_access_denied": "У вас нет доступа к разделу «{name}»",
    "You don't have access of {name}": "У вас нет доступа к разделу «{name}»",
    "app_customization.title": "Настройка приложения",
    "app_customization.tab_0": "Основные",
    "app_customization.tab_1": "Заставка",
    "Splash": "Заставка",
    "app_customization.tab_2": "Знакомство",
    "Onboarding": "Знакомство",
    "app_customization.tab_3": "Регистрация",
    "Registration": "Регистрация",
    "app_customization.tab_4": "Главная",
    "Home": "Главная",
    "app_customization.tab_5": "Push-уведомления",
    "Push Notification": "Push-уведомления",
    "app_customization.tab_6": "Чат",
    "Chat": "Чат",
    "app_customization.tab_7": "Дополнительное меню",
    "More Menu": "Дополнительное меню",
    "app_customization.tab_8": "Принудительное обновление",
    "Force Update": "Принудительное обновление",
    "app_customization.tab_9": "Адрес",
    "app_customization.hide_balances": "Скрыть балансы и выплаты в дополнительном разделе",
    "app_customization.more": "Еще",
    "app_customization.force_update": "Принудительное обновление",
    "Force To Update": "Принудительное обновление",
    "app_customization.android_version": "Версия приложения Android",
    "Android app version": "Версия приложения Android",
    "app_customization.enter_android_version": "Введите версию приложения Android",
    "Enter android app version": "Введите версию приложения Android",
    "app_customization.ios_version": "Версия приложения iOS",
    "iOS app version": "Версия приложения iOS",
    "app_customization.enter_ios_version": "Введите версию приложения iOS",
    "Enter iOS app version": "Введите версию приложения iOS",
    "app_customization.chat": "Чат",
    "app_customization.chat_send_listing": "Автоматически отправлять объявления при открытии чата (по умолчанию сверху показывается предпросмотр)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Автоматически отправлять объявления при открытии чата (по умолчанию сверху показывается предпросмотр)",
    "app_customization.make_offer": "Предложение / переговоры",
    "Make Offer / Negotiation": "Предложение / переговоры",
    "app_customization.negotiation_button_name": "Название кнопки переговоров:",
    "Negotiation button name:": "Название кнопки переговоров:",
    "app_customization.negotiation_button_example": "(например: Предложить цену, Обсудить, Запросить цену)",
    "(example: Make Offer, Negotiate, Quote)": "(например: Предложить цену, Обсудить, Запросить цену)",
    "app_customization.enter_negotiation_button_name": "Введите название кнопки переговоров",
    "Enter negotiation button name": "Введите название кнопки переговоров",
    "app_customization.address": "Адрес",
    "app_customization.address_option_0": "Показывать адрес 2",
    "Show Address 2": "Показывать адрес 2",
    "app_customization.address_option_1": "Показывать страну",
    "Show Country": "Показывать страну",
    "app_customization.address_option_2": "Показывать почтовый индекс",
    "Show Zipcode": "Показывать почтовый индекс",
    "app_customization.address_option_3": "Показывать регион",
    "Show State": "Показывать регион",
    "app_customization.address_option_4": "Показывать ориентир",
    "Show Landmark": "Показывать ориентир",
    "app_customization.address_option_5": "Показывать город",
    "Show City": "Показывать город",
    "app_customization.persistent_notification": "Постоянные уведомления",
    "Persistent Notification": "Постоянные уведомления",
    "app_customization.account_follow_content": "Текст уведомления о подписке на аккаунт",
    "Account follow notification content": "Текст уведомления о подписке на аккаунт",
    "app_customization.enter_account_follow_content": "Введите текст уведомления о подписке на аккаунт",
    "Enter Account follow notification content": "Введите текст уведомления о подписке на аккаунт",
    "app_customization.listing_like_content": "Текст уведомления о отметке объявления",
    "Listing like notification content": "Текст уведомления о отметке объявления",
    "app_customization.enter_listing_like_content": "Введите текст уведомления о отметке объявления",
    "Enter Listing like  notification content": "Введите текст уведомления о отметке объявления",
    "app_customization.order_status_content": "Текст уведомления о статусе заказа",
    "Order status notification content": "Текст уведомления о статусе заказа",
    "app_customization.enter_order_status_content": "Введите текст уведомления о статусе заказа",
    "Order status follow notification content": "Введите текст уведомления о статусе заказа",
    "app_customization.account_follow_required": "Уведомление о подписке на аккаунт должно содержать {account_name}",
    "app_customization.listing_like_required": "Текст уведомления о лайке должен содержать {user_name}",
    "Listing like notification content should contain {user_name}": "Текст уведомления о лайке должен содержать {user_name}",
    "app_customization.order_number_required": "Уведомление о статусе заказа должно содержать номер #{order_number}",
    "Order status notification content should contain #{order_number}": "Уведомление о статусе заказа должно содержать номер #{order_number}",
    "app_customization.order_status_required": "Уведомление о статусе заказа должно содержать {order_status}",
    "Order status notification content should contain {order_status}": "Уведомление о статусе заказа должно содержать {order_status}",
    "app_customization.preview": "Предпросмотр",
    "app_customization.splash": "Заставка",
    "app_customization.splash_image": "Изображение заставки",
    "Splash Screen Image": "Изображение заставки",
    "app_customization.registration": "Регистрация",
    "app_customization.registration_text": "Текст регистрации",
    "Registration text": "Текст регистрации",
    "app_customization.otp_note": "Примечание о проверке одноразового кода",
    "OTP Verification note": "Примечание о проверке одноразового кода",
    "app_customization.get_signup_first": "Сначала откройте регистрацию",
    "app_customization.mobile_in_email_signup": "Номер телефона при регистрации по электронной почте",
    "Mobile number in email signup": "Номер телефона при регистрации по электронной почте",
    "app_customization.preview_field_first_name": "Имя",
    "app_customization.preview_field_last_name": "Фамилия",
    "app_customization.preview_field_email": "Электронная почта",
    "app_customization.preview_field_password": "Пароль",
    "Password": "Пароль",
    "app_customization.preview_field_confirm_password": "Подтвердите пароль",
    "Confirm Password": "Подтвердите пароль",
    "app_customization.preview_field_dob": "Дата рождения",
    "DOB": "Дата рождения",
    "app_customization.preview_field_mobile_no": "Номер телефона",
    "Mobile No": "Номер телефона",
    "app_customization.create": "Создать",
    "app_customization.login": "Войти",
    "Login": "Войти",
    "app_customization.create_account": "Создайте аккаунт",
    "Create your account": "Создайте аккаунт",
    "app_customization.login_account": "Войдите в аккаунт",
    "Login to your account": "Войдите в аккаунт",
    "app_customization.onboarding_settings": "Настройки знакомства",
    "Onboarding Settings": "Настройки знакомства",
    "app_customization.onboarding_images": "Изображения знакомства",
    "Onboarding Images": "Изображения знакомства",
    "app_customization.onboarding_text_1": "Текст знакомства 1",
    "Onboarding text 1": "Текст знакомства 1",
    "app_customization.onboarding_text_2": "Текст знакомства 2",
    "Onboarding text 2": "Текст знакомства 2",
    "app_customization.onboarding_text_3": "Текст знакомства 3",
    "Onboarding text 3": "Текст знакомства 3",
    "app_customization.see_how_it_works": "Посмотрите, как это работает",
    "See how it works": "Посмотрите, как это работает",
    "app_customization.sell_icon_text": "Текст значка «Продать»",
    "Sell icon text": "Текст значка «Продать»",
    "app_customization.enter_sell_icon_text": "Введите текст значка «Продать»",
    "Enter sell icon text": "Введите текст значка «Продать»",
    "app_customization.sell_icon": "Значок «Продать»",
    "Sell Icon": "Значок «Продать»",
    "app_customization.enter_home_title": "Введите заголовок приложения на главном экране",
    "Enter app title in home": "Введите заголовок приложения на главном экране",
    "app_customization.app_details": "Сведения о приложении",
    "App Details": "Сведения о приложении",
    "app_customization.app_name": "Название приложения",
    "App Name": "Название приложения",
    "app_customization.primary_colour": "Основной цвет приложения",
    "App Primary Colour": "Основной цвет приложения",
    "app_customization.secondary_colour": "Дополнительный цвет приложения",
    "App Secondary Colour": "Дополнительный цвет приложения",
    "app_customization.android_app_icon": "Значок приложения Android",
    "App Icon Android": "Значок приложения Android",
    "app_customization.ios_app_icon": "Значок приложения iOS",
    "App Icon iOS": "Значок приложения iOS",
    "app_customization.screen_number": "Экран {number}",
    "Screen {number}": "Экран {number}",
    "app_customization.upload_here": "Загрузить сюда",
    "Upload here": "Загрузить сюда",
    "app_customization.next": "Далее",
    "app_customization.get_started": "Начать",
    "Get Start": "Начать",
    "app_customization.select": "Выбрать",
    "Select": "Выбрать",
    "app_customization.app_title_home_icon": "Значок заголовка приложения на главном экране",
    "App Title Home Icon": "Значок заголовка приложения на главном экране",
    "app_customization.home_icon_hint": "(значок должен быть белым и в формате PNG)",
    "(icon should be white and in png format)": "(значок должен быть белым и в формате PNG)",
    "app_customization.home_title": "Заголовок приложения на главном экране",
    "app_customization.default_collection_widgets": "Стандартные виджеты подборок",
    "Default Collection Widgets": "Стандартные виджеты подборок",
    "app_customization.accounts_follow_title": "Название подборки аккаунтов для подписки",
    "Accounts to follow collection title": "Название подборки аккаунтов для подписки",
    "app_customization.enter_accounts_follow_title": "Введите название подборки аккаунтов для подписки",
    "Enter accounts to follow collection title": "Введите название подборки аккаунтов для подписки",
    "app_customization.nearby_accounts_title": "Название подборки аккаунтов поблизости",
    "Nearby accounts collection title": "Название подборки аккаунтов поблизости",
    "app_customization.enter_nearby_accounts_title": "Введите название подборки аккаунтов поблизости",
    "Enter near by accounts collection title": "Введите название подборки аккаунтов поблизости",
    "app_customization.latest_listings_title": "Название подборки последних объявлений",
    "Latest listings collection title": "Название подборки последних объявлений",
    "app_customization.enter_latest_listings_title": "Введите название подборки последних объявлений",
    "Enter latest listings collection title": "Введите название подборки последних объявлений",
    "app_customization.enable_appearance_sections": "Выберите, чтобы включить разделы оформления",
    "Select to enable appearance sections": "Выберите, чтобы включить разделы оформления",
    "app_customization.choose_photo": "Выбрать фото",
    "Choose photo": "Выбрать фото",
    "app_customization.choose_icon": "Выбрать значок",
    "Choose icon": "Выбрать значок",
    "app_customization.enable_home_icon": "Использовать значок заголовка приложения вместо текста",
    "app_customization.account_name": "Название аккаунта",
    "Account Name": "Название аккаунта",
    "app_customization.product_name": "Название товара",
    "Product Name": "Название товара",
    "app_customization.home_option_0": "Показывать подборку поблизости",
    "Show nearby collection": "Показывать подборку поблизости",
    "app_customization.home_option_1": "Показывать раздел категорий",
    "Show category section": "Показывать раздел категорий",
    "app_customization.home_option_2": "Показывать рекламные баннеры",
    "Show promo banners": "Показывать рекламные баннеры",
    "app_customization.home_option_3": "Показывать приглашение друзей",
    "Show invite friends": "Показывать приглашение друзей",
    "app_customization.home_option_4": "Показывать напоминания об отзывах",
    "Show review reminders": "Показывать напоминания об отзывах",
    "app_customization.home_option_5": "Аккаунты для подписки",
    "Accounts to follow": "Аккаунты для подписки",
    "app_customization.download": "Скачать",
    "app_customization.cancel": "Отмена",
    "app_customization.uploaded_successfully": "Успешно загружено",
    "app_customization.image_limit": "Нельзя выбрать больше изображений",
    "You cannot select more images": "Нельзя выбрать больше изображений",
    "app_customization.choose_zip_file": "Выбрать ZIP-файл",
    "Choose zip file": "Выбрать ZIP-файл",
    "app_translation.title": "Настройка текстов",
    "app_translation.search": "Введите текст для поиска…",
    "Type to search...": "Введите текст для поиска…",
    "app_translation.default_language": "По умолчанию",
    "Default": "По умолчанию",
    "app_translation.default_text": "Текст по умолчанию",
    "Default text": "Текст по умолчанию",
    "communications.title": "Сообщения",
    "communications.tab_0": "Уведомления по электронной почте",
    "Email Notification": "Уведомления по электронной почте",
    "communications.tab_1": "Настройки электронной почты",
    "Email Configuration": "Настройки электронной почты",
    "communications.tab_2": "Уведомления о заказах",
    "Order Notification": "Уведомления о заказах",
    "communications.tab_3": "Форма обратной связи",
    "Feedback Form": "Форма обратной связи",
    "communications.translate": "Перевести",
    "Translate": "Перевести",
    "communications.edit_email_template": "Изменить шаблон письма",
    "Edit email template": "Изменить шаблон письма",
    "communications.feedback_email": "Электронная почта",
    "communications.feedback_phone": "Телефон",
    "communications.feedback_email_or_phone": "Электронная почта или телефон",
    "Email or Phone": "Электронная почта или телефон",
    "communications.select_type": "Выберите тип",
    "Select type": "Выберите тип",
    "communications.form_required_field": "Обязательное поле формы",
    "Form Required Field": "Обязательное поле формы",
    "communications.feedback_recipient_label": "Адреса для получения отзывов (несколько адресов укажите через запятую)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Адреса для получения отзывов (несколько адресов укажите через запятую)",
    "communications.enter_email": "Введите адрес электронной почты",
    "Enter email": "Введите адрес электронной почты",
    "communications.enable_feedback_form": "Включить форму обратной связи",
    "Enable feedback Form": "Включить форму обратной связи",
    "communications.feedback": "Обратная связь",
    "Feedback": "Обратная связь",
    "communications.realtime_config_notice": "Изменения настроек ниже применяются сразу. После нажатия «Сохранить» они отразятся в приложениях и ответах API.",
    "communications.uploaded_successfully": "Успешно загружено",
    "communications.email_whitelabeling": "Брендирование электронной почты",
    "Email Whitelabelling": "Брендирование электронной почты",
    "communications.from_name": "Имя отправителя",
    "From name": "Имя отправителя",
    "communications.enter_from_name": "Введите имя отправителя",
    "Enter from name": "Введите имя отправителя",
    "communications.from_email_address": "Адрес электронной почты отправителя",
    "From email address": "Адрес электронной почты отправителя",
    "communications.from_email_domain_hint": "Вы выбрали собственный домен для адреса отправителя. Чтобы письма доставлялись, подтвердите домен у нас. Обратитесь в службу поддержки за помощью с проверкой.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Вы выбрали собственный домен для адреса отправителя. Чтобы письма доставлялись, подтвердите домен у нас. Обратитесь в службу поддержки за помощью с проверкой.",
    "communications.reset": "Сбросить",
    "communications.enter_from_email": "Введите адрес отправителя",
    "Enter from email address": "Введите адрес отправителя",
    "communications.email_header_logo": "Логотип в заголовке письма",
    "Email Header Logo": "Логотип в заголовке письма",
    "communications.choose_logo": "Выберите файл 50 × 50",
    "Choose file 50*50": "Выберите файл 50 × 50",
    "communications.list_view": "Вид списком",
    "communications.gallery_view": "Вид галереей",
    "Gallery view": "Вид галереей",
    "communications.grid_view": "Вид сеткой",
    "communications.search": "Поиск сообщений",
    "Search communications": "Поиск сообщений",
    "communications.email_settings": "Настройки электронной почты",
    "Email settings": "Настройки электронной почты",
    "communications.category_all": "Все",
    "communications.category_buyer": "Покупатель",
    "Buyer": "Покупатель",
    "communications.category_seller": "Продавец",
    "communications.category_transactional": "Транзакции",
    "Transactional": "Транзакции",
    "communications.category_engagement": "Вовлечение",
    "Engagement": "Вовлечение",
    "communications.category_retention": "Удержание",
    "Retention": "Удержание",
    "communications.category_membership": "Членство",
    "communications.audience_buyer": "Покупатель",
    "communications.audience_seller": "Продавец",
    "communications.system_notification": "Системное уведомление",
    "System notification": "Системное уведомление",
    "communications.template": "шаблон",
    "template": "шаблон",
    "communications.edit": "Изменить",
    "communications.sent": "отправлено",
    "sent": "отправлено",
    "communications.open": "открыто",
    "communications.clicks": "переходы",
    "clicks": "переходы",
    "communications.no_email_matches": "Нет писем, соответствующих фильтру.",
    "No emails match your filter.": "Нет писем, соответствующих фильтру.",
    "communications.buyer_order_confirmation": "Письмо покупателю с подтверждением заказа",
    "Order confirmation email for buyer": "Письмо покупателю с подтверждением заказа",
    "communications.seller_order_confirmation": "Письмо продавцу с подтверждением заказа",
    "Order confirmation email for seller": "Письмо продавцу с подтверждением заказа",
    "communications.email_card_0": "Приветственное письмо",
    "Welcome Message": "Приветственное письмо",
    "communications.email_card_1": "Одноразовый код / подтверждение",
    "OTP / Verification": "Одноразовый код / подтверждение",
    "communications.email_card_2": "Ссылка на подписку",
    "Subscription Link": "Ссылка на подписку",
    "communications.email_card_3": "Подписка оформлена",
    "Subscription Success": "Подписка оформлена",
    "communications.email_card_4": "Подтверждение заказа — покупателю",
    "Order confirmation — buyer": "Подтверждение заказа — покупателю",
    "communications.email_card_5": "Подтверждение заказа — продавцу",
    "Order confirmation — seller": "Подтверждение заказа — продавцу",
    "communications.email_card_6": "Заказ отправлен — покупателю",
    "Shipment shipped — buyer": "Заказ отправлен — покупателю",
    "communications.email_card_7": "Заказ доставлен — покупателю",
    "Shipment delivered — buyer": "Заказ доставлен — покупателю",
    "communications.email_card_8": "Заказ отменен — покупателю",
    "Order cancelled — buyer": "Заказ отменен — покупателю",
    "communications.email_card_9": "Возврат оформлен — покупателю",
    "Refund processed — buyer": "Возврат оформлен — покупателю",
    "communications.email_card_10": "Новое объявление в магазине, на который вы подписаны — покупателю",
    "New listing from followed store — buyer": "Новое объявление в магазине, на который вы подписаны — покупателю",
    "communications.email_card_11": "Товар снова в наличии — покупателю",
    "Back in stock — buyer": "Товар снова в наличии — покупателю",
    "communications.email_card_12": "Скоро истекает срок объявления — продавцу",
    "Listing expiry warning — seller": "Скоро истекает срок объявления — продавцу",
    "communications.email_card_13": "Много отметок «Нравится» у объявления — продавцу",
    "Listing likes milestone — seller": "Много отметок «Нравится» у объявления — продавцу",
    "communications.email_card_14": "Аккаунт подтвержден — продавцу",
    "Account verified — seller": "Аккаунт подтвержден — продавцу",
    "communications.email_card_15": "Возвращение продавца — продавцу",
    "Seller win-back — seller": "Возвращение продавца — продавцу",
    "communications.email_card_16": "Низкий остаток — продавцу",
    "Low stock warning — seller": "Низкий остаток — продавцу",
    "communications.email_card_17": "Регистрация продавца завершена — продавцу",
    "Seller onboarded — seller": "Регистрация продавца завершена — продавцу",
    "communications.email_card_18": "Запрос отзыва — покупателю",
    "Review request — buyer": "Запрос отзыва — покупателю",
    "communications.email_card_19": "Первая продажа — продавцу",
    "First sale — seller": "Первая продажа — продавцу",
    "communications.email_card_20": "Достижение по продажам — продавцу",
    "Sales milestone — seller": "Достижение по продажам — продавцу",
    "communications.email_card_21": "Возвращение покупателя — покупателю",
    "Win-back — buyer": "Возвращение покупателя — покупателю",
    "communications.email_card_22": "Первая покупка — покупателю",
    "First purchase — buyer": "Первая покупка — покупателю",
    "communications.email_card_23": "Вопрос клиента — продавцу",
    "Customer question — seller": "Вопрос клиента — продавцу",
    "communications.email_card_24": "Ответ продавца — покупателю",
    "Seller answer — buyer": "Ответ продавца — покупателю",
    "communications.email_card_25": "Предложение о цене — продавцу",
    "Negotiation offer — seller": "Предложение о цене — продавцу",
    "communications.email_card_26": "Предложение принято — покупателю",
    "Offer accepted — buyer": "Предложение принято — покупателю",
    "communications.email_card_27": "Предложение отклонено — покупателю",
    "Offer rejected — buyer": "Предложение отклонено — покупателю",
    "communications.email_card_28": "Новый подписчик — продавцу",
    "New follower — seller": "Новый подписчик — продавцу",
    "communications.email_card_29": "Объявление понравилось — продавцу",
    "Listing liked — seller": "Объявление понравилось — продавцу",
    "communications.email_card_30": "Объявление одобрено — продавцу",
    "Listing approved — seller": "Объявление одобрено — продавцу",
    "communications.email_card_31": "Объявление отклонено — продавцу",
    "Listing rejected — seller": "Объявление отклонено — продавцу",
    "communications.email_card_32": "Первое объявление — продавцу",
    "First listing — seller": "Первое объявление — продавцу",
    "communications.email_card_33": "Забытая корзина — покупателю",
    "Abandoned cart — buyer": "Забытая корзина — покупателю",
    "communications.email_card_34": "Отзыв об объявлении — продавцу",
    "Listing review — seller": "Отзыв об объявлении — продавцу",
    "communications.email_card_35": "Напоминание о выполнении заказа — продавцу",
    "Fulfillment reminder — seller": "Напоминание о выполнении заказа — продавцу",
    "communications.email_card_36": "Снижение цены — покупателю",
    "Price drop — buyer": "Снижение цены — покупателю",
    "communications.email_card_37": "Скоро срок оплаты членства",
    "Membership payment due soon": "Скоро срок оплаты членства",
    "communications.email_card_38": "Просрочен платеж за членство",
    "Membership payment overdue": "Просрочен платеж за членство",
    "communications.order_status_notification": "Уведомление о статусе заказа",
    "Order Status Notification": "Уведомление о статусе заказа",
    "communications.order_group_lifecycle": "Жизненный цикл заказа",
    "Order lifecycle": "Жизненный цикл заказа",
    "communications.order_group_returns": "Возвраты и проблемы с доставкой",
    "Returns and delivery issues": "Возвраты и проблемы с доставкой",
    "communications.order_group_cancellations": "Отмена и самовывоз",
    "Cancellations and pickup": "Отмена и самовывоз",
    "communications.notification_settings_count": "Настроек уведомлений: {count}",
    "{count} notification settings": "Настроек уведомлений: {count}",
    "communications.enter_order_field": "Введите значение: {field}",
    "Enter {field}": "Введите значение: {field}",
    "communications.order_field_0": "Статус заказа: подтвержден",
    "Order status confirmed": "Статус заказа: подтвержден",
    "communications.order_field_1": "Статус заказа: выполняется",
    "Order status in progress": "Статус заказа: выполняется",
    "communications.order_field_2": "Статус заказа: отправлен",
    "Order status shipped": "Статус заказа: отправлен",
    "communications.order_field_3": "Статус заказа: клиент недоступен",
    "Order status customer unreachable": "Статус заказа: клиент недоступен",
    "communications.order_field_4": "Статус заказа: передан курьеру",
    "Order status out for delivery": "Статус заказа: передан курьеру",
    "communications.order_field_5": "Статус заказа: не доставлен, возвращен",
    "Order status undelivered returned": "Статус заказа: не доставлен, возвращен",
    "communications.order_field_6": "Статус заказа: возврат после недоставки подтвержден",
    "Order status undelivered return confirmed": "Статус заказа: возврат после недоставки подтвержден",
    "communications.order_field_7": "Статус заказа: доставлен",
    "Order status delivered": "Статус заказа: доставлен",
    "communications.order_field_8": "Статус заказа: доставка подтверждена",
    "Order status delivered confirmed": "Статус заказа: доставка подтверждена",
    "communications.order_field_9": "Статус заказа: клиент начал возврат",
    "Order status customer return initiated": "Статус заказа: клиент начал возврат",
    "communications.order_field_10": "Статус заказа: возврат забран",
    "Order status customer return picked": "Статус заказа: возврат забран",
    "communications.order_field_11": "Статус заказа: возврат подтвержден",
    "Order status customer return confirmed": "Статус заказа: возврат подтвержден",
    "communications.order_field_12": "Статус заказа: возврат оспорен",
    "Order status customer return disputed": "Статус заказа: возврат оспорен",
    "communications.order_field_13": "Статус заказа: отменен аккаунтом",
    "Order status cancelled by account": "Статус заказа: отменен аккаунтом",
    "communications.order_field_14": "Статус заказа: отменен клиентом",
    "Order status cancelled by customer": "Статус заказа: отменен клиентом",
    "communications.order_field_15": "Статус заказа: готов к выдаче",
    "Order status ready for pickup": "Статус заказа: готов к выдаче",
    "communications.order_field_16": "Статус заказа: завершен",
    "Order status completed": "Статус заказа: завершен",
    "communications.update": "Обновить",
    "communications.download_template": "Скачать шаблон",
    "Download Template": "Скачать шаблон",
    "communications.reset_to_default": "Вернуть настройки по умолчанию",
    "communications.send_test_email": "Отправить тестовое письмо",
    "Send test email": "Отправить тестовое письмо",
    "communications.enter_test_emails": "Введите адреса (через запятую)",
    "Enter email(s), comma-separated": "Введите адреса (через запятую)",
    "communications.send_test": "Отправить тест",
    "Send test": "Отправить тест",
    "communications.subject_required": "Тема не должна быть пустой",
    "Subject should not be empty": "Тема не должна быть пустой",
    "communications.body_required": "Текст письма не должен быть пустым",
    "Body should not be empty": "Текст письма не должен быть пустым",
    "communications.code_merge_tag_required": "Обязательный тег подстановки: {code}",
    "{code} merge tag is mandatory": "Обязательный тег подстановки: {code}",
    "communications.edit_template_named": "Изменить {name}",
    "Edit {name}": "Изменить {name}",
    "communications.subject": "Тема",
    "Subject": "Тема",
    "communications.enter_subject": "Введите тему",
    "Enter the Subject": "Введите тему",
    "communications.available_merge_tags": "Доступные теги подстановки:",
    "Available merge tags:": "Доступные теги подстановки:",
    "communications.body": "Текст",
    "Body": "Текст",
    "communications.write_here": "Введите текст…",
    "Write here...": "Введите текст…",
    "communications.subject_line": "Тема письма",
    "Subject Line": "Тема письма",
    "communications.enter_subject_line": "Введите тему письма…",
    "Enter the subject…": "Введите тему письма…",
    "communications.merge_tags": "Теги подстановки",
    "Merge tags": "Теги подстановки",
    "communications.loading_templates": "Загрузка шаблонов…",
    "Loading templates…": "Загрузка шаблонов…",
    "communications.hide_templates": "Скрыть шаблоны",
    "Hide templates": "Скрыть шаблоны",
    "communications.load_template": "Загрузить шаблон",
    "Load template": "Загрузить шаблон",
    "communications.html_body": "Текст HTML",
    "HTML Body": "Текст HTML",
    "communications.enter_html_body": "Вставьте или введите HTML-код…",
    "Paste or type your HTML here…": "Вставьте или введите HTML-код…",
    "communications.live_preview": "Предпросмотр",
    "Live Preview": "Предпросмотр",
    "communications.desktop": "Компьютер",
    "Desktop": "Компьютер",
    "communications.mobile": "Мобильное устройство",
    "communications.email_preview": "Предпросмотр письма",
    "Email preview": "Предпросмотр письма",
    "communications.start_typing_preview": "Начните вводить текст для предпросмотра",
    "Start typing to see a preview": "Начните вводить текст для предпросмотра",
    "communications.translations": "переводы",
    "translations": "переводы",
    "communications.validation_account_follow_tag": "Уведомление о подписке должно содержать {account_name}",
    "communications.validation_listing_like_tag": "Уведомление о лайке объявления должно содержать {user_name}",
    "Listing follow notification should contain {user_name}": "Уведомление о лайке объявления должно содержать {user_name}",
    "communications.validation_order_number_tag": "Уведомление о статусе заказа должно содержать #{order_number}",
    "Order status follow notification should contain #{order_number}": "Уведомление о статусе заказа должно содержать #{order_number}",
    "communications.validation_order_status_tag": "Уведомление о статусе заказа должно содержать {order_status}",
    "Order status follow notification should contain {order_status}": "Уведомление о статусе заказа должно содержать {order_status}",
    "communications.journey_title": "Карта писем по этапам",
    "Email Journey Map": "Карта писем по этапам",
    "communications.journey_subtitle": "Когда отправляется каждое письмо на жизненном цикле пользователя",
    "Where each email fires in the user lifecycle": "Когда отправляется каждое письмо на жизненном цикле пользователя",
    "communications.journey_buyer": "Путь покупателя",
    "Buyer Journey": "Путь покупателя",
    "communications.journey_seller": "Путь продавца",
    "Seller Journey": "Путь продавца",
    "communications.journey_buyer_stage_0": "Регистрация",
    "Sign Up": "Регистрация",
    "communications.journey_buyer_stage_1": "Просмотр",
    "Browse": "Просмотр",
    "communications.journey_buyer_stage_2": "Корзина",
    "Cart": "Корзина",
    "communications.journey_buyer_stage_3": "Заказ оформлен",
    "Order Placed": "Заказ оформлен",
    "communications.journey_buyer_stage_4": "Отправлено",
    "communications.journey_buyer_stage_5": "Доставлено",
    "communications.journey_buyer_stage_6": "Переговоры",
    "Negotiate": "Переговоры",
    "communications.journey_buyer_stage_7": "Неактивен",
    "communications.journey_seller_stage_0": "Начать работу",
    "Onboard": "Начать работу",
    "communications.journey_seller_stage_1": "Опубликовать объявление",
    "communications.journey_seller_stage_2": "Управление",
    "Manage": "Управление",
    "communications.journey_seller_stage_3": "Новый заказ",
    "Order In": "Новый заказ",
    "communications.journey_seller_stage_4": "Отправка",
    "communications.journey_seller_stage_5": "Завершить",
    "Complete": "Завершить",
    "communications.journey_seller_stage_6": "Неактивен",
    "accounts.title": "Аккаунты",
    "accounts.status_pending": "Ожидает",
    "accounts.status_approved": "Одобрено",
    "accounts.status_rejected": "Отклонено",
    "accounts.show_rows": "Показать строки",
    "accounts.next": "Далее",
    "accounts.previous": "Назад",
    "accounts.view_list": "Список",
    "accounts.view_map": "Карта",
    "Map": "Карта",
    "accounts.view_board": "Доска",
    "accounts.view_grid": "Сетка",
    "accounts.view_list_accessibility": "Вид списком",
    "accounts.view_map_accessibility": "Вид карты",
    "Map view": "Вид карты",
    "accounts.view_board_accessibility": "Вид доски",
    "Board view": "Вид доски",
    "accounts.view_grid_accessibility": "Вид сеткой",
    "accounts.column_name": "Название",
    "accounts.column_account_id": "ID аккаунта",
    "accounts.column_description": "Описание",
    "accounts.column_image": "Изображение",
    "accounts.column_user_name": "Имя пользователя",
    "User Name": "Имя пользователя",
    "accounts.column_email": "Электронная почта",
    "accounts.column_status": "Статус",
    "accounts.column_account_status": "Статус аккаунта",
    "Account Status": "Статус аккаунта",
    "accounts.column_location": "Расположение",
    "accounts.search": "Поиск аккаунтов",
    "Search accounts": "Поиск аккаунтов",
    "accounts.export": "Экспорт",
    "accounts.import": "Импорт",
    "accounts.export_accounts": "Экспорт аккаунтов",
    "Export accounts": "Экспорт аккаунтов",
    "accounts.import_accounts": "Импорт аккаунтов",
    "Import accounts": "Импорт аккаунтов",
    "accounts.smart_upload_accounts": "Умная загрузка аккаунтов",
    "Smart Upload accounts": "Умная загрузка аккаунтов",
    "accounts.export_all_question": "Экспортировать все аккаунты?",
    "Export all accounts?": "Экспортировать все аккаунты?",
    "accounts.export_all_description": "Будет подготовлен файл со всеми аккаунтами. Перед обновлением можно проверить этот процесс.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Будет подготовлен файл со всеми аккаунтами. Перед обновлением можно проверить этот процесс.",
    "accounts.export_all": "Экспортировать все аккаунты",
    "Export all accounts": "Экспортировать все аккаунты",
    "accounts.cancel": "Отмена",
    "accounts.active": "Активен",
    "accounts.inactive": "Неактивен",
    "accounts.not_available": "Н/Д",
    "accounts.approve": "Одобрить",
    "accounts.reject": "Отклонить",
    "accounts.manage": "Управление",
    "accounts.tooltip_title": "Аккаунты — это магазины.",
    "Accounts are like shops.": "Аккаунты — это магазины.",
    "accounts.tooltip_description": "Пользователи могут создать на платформе пространство для ведения бизнеса — это и есть аккаунт. Аккаунт нужен не каждому пользователю. С аккаунтом можно связать эскроу-счет для получения выплат.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Пользователи могут создать на платформе пространство для ведения бизнеса — это и есть аккаунт. Аккаунт нужен не каждому пользователю. С аккаунтом можно связать эскроу-счет для получения выплат.",
    "accounts.create_account": "Создать аккаунт",
    "Create Account": "Создать аккаунт",
    "accounts.create_new_account": "Создать новый аккаунт",
    "Create New Account": "Создать новый аккаунт",
    "accounts.save": "Сохранить",
    "accounts.please_wait": "Подождите…",
    "Please wait...": "Подождите…",
    "accounts.account_name": "Название аккаунта",
    "accounts.slug": "Короткий адрес",
    "accounts.account_slug": "Короткий адрес аккаунта",
    "Account Slug": "Короткий адрес аккаунта",
    "accounts.account_description": "Описание аккаунта",
    "Account Description": "Описание аккаунта",
    "accounts.enter_name_first": "Сначала укажите название",
    "accounts.user": "Пользователь",
    "accounts.select_user": "Выберите пользователя",
    "accounts.category": "Категория",
    "Category": "Категория",
    "accounts.select_type": "Выберите тип",
    "Select Type": "Выберите тип",
    "accounts.smart_upload_title": "Умная загрузка аккаунтов",
    "Smart account upload": "Умная загрузка аккаунтов",
    "accounts.start_over": "Начать заново",
    "accounts.smart_upload_description": "Загрузите аккаунты и сопоставьте столбцы CSV с полями аккаунта.",
    "Upload accounts and match your CSV columns to account fields.": "Загрузите аккаунты и сопоставьте столбцы CSV с полями аккаунта.",
    "accounts.smart_upload_step_0": "Загрузка",
    "accounts.smart_upload_step_1": "Сопоставление столбцов",
    "accounts.smart_upload_step_2": "Проверка",
    "accounts.smart_upload_step_3": "Импорт",
    "accounts.choose_csv": "Выберите файл CSV",
    "accounts.smart_upload_required_note": "Название обязательно. Адрес, короткий адрес, категория, владелец и координаты необязательны.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Название обязательно. Адрес, короткий адрес, категория, владелец и координаты необязательны.",
    "accounts.select_csv": "Выберите файл CSV",
    "accounts.match_columns": "Сопоставить столбцы аккаунта",
    "Match account columns": "Сопоставить столбцы аккаунта",
    "accounts.import_field_name": "Название",
    "accounts.import_field_description": "Описание",
    "accounts.import_field_slug": "Короткий адрес",
    "accounts.import_field_category_id": "ID категории",
    "Category ID": "ID категории",
    "accounts.import_field_user_id": "ID владельца",
    "Owner User ID": "ID владельца",
    "accounts.import_field_location": "Адрес",
    "accounts.import_field_latitude": "Широта",
    "Latitude": "Широта",
    "accounts.import_field_longitude": "Долгота",
    "Longitude": "Долгота",
    "accounts.do_not_import": "Не импортировать",
    "accounts.review_import": "Проверить импорт",
    "accounts.import_count": "Будет импортировано аккаунтов: {count}.",
    "{count} accounts will be imported.": "Будет импортировано аккаунтов: {count}.",
    "accounts.smart_upload_complete": "Умная загрузка завершена",
    "Smart Upload complete": "Умная загрузка завершена",
    "accounts.imported_count": "Импортировано аккаунтов: {imported} из {total}.",
    "{imported} of {total} accounts imported.": "Импортировано аккаунтов: {imported} из {total}.",
    "accounts.selected_file": "Выбрано: {filename}",
    "Selected: {filename}": "Выбрано: {filename}",
    "accounts.review": "Проверить",
    "accounts.importing": "Импорт…",
    "accounts.uploading": "Загрузка…",
    "accounts.download": "Скачать",
    "accounts.file_label": "Файл:",
    "accounts.select_file": "Выберите файл",
    "accounts.upload": "Загрузить",
    "accounts.download_template": "Скачать шаблон: {type}",
    "accounts.import_stage_prepare": "Подготовка файла для импорта",
    "accounts.import_prepare_failed": "Не удалось подготовить файл для импорта.",
    "accounts.import_stage_upload": "Загрузка файла импорта",
    "accounts.import_upload_failed": "Не удалось загрузить файл для импорта.",
    "accounts.import_stage_server": "Tradly выполняет импорт аккаунтов",
    "Tradly is importing accounts": "Tradly выполняет импорт аккаунтов",
    "accounts.import_stage_complete": "Импорт завершен",
    "Import complete": "Импорт завершен",
    "accounts.import_stage_stopped": "Импорт остановлен",
    "accounts.confirm_approve": "Одобрить этот аккаунт?",
    "Approve this account?": "Одобрить этот аккаунт?",
    "accounts.confirm_reject": "Отклонить этот аккаунт?",
    "Reject this account?": "Отклонить этот аккаунт?",
    "accounts.name_required": "Укажите название",
    "Name is required": "Укажите название",
    "accounts.user_required": "Укажите пользователя",
    "User is required": "Укажите пользователя",
    "accounts.attribute_required": "Заполните поле «{attribute}»",
    "accounts.overview": "Обзор аккаунта",
    "Account Overview": "Обзор аккаунта",
    "accounts.section_listings": "Объявления",
    "accounts.loading": "Загрузка…",
    "accounts.no_listings_owned": "Объявлений пока нет",
    "No listings yet": "Объявлений пока нет",
    "accounts.page_analytics": "Аналитика страницы",
    "Page Analytics": "Аналитика страницы",
    "accounts.analytics_key_missing": "Для этого арендатора не настроен ключ API аналитики.",
    "Analytics API key not configured for this tenant.": "Для этого арендатора не настроен ключ API аналитики.",
    "accounts.storefront_url_missing": "URL витрины этого аккаунта недоступен.",
    "No storefront URL available for this account.": "URL витрины этого аккаунта недоступен.",
    "accounts.no_analytics_loaded": "Аналитика еще не загружена.",
    "No analytics loaded yet.": "Аналитика еще не загружена.",
    "accounts.load_analytics": "Загрузить аналитику",
    "Load Analytics": "Загрузить аналитику",
    "accounts.attributes": "Атрибуты",
    "accounts.shipping": "Доставка",
    "accounts.commission": "Комиссия",
    "Commission": "Комиссия",
    "accounts.detail_title": "Название",
    "accounts.detail_description": "Описание",
    "accounts.detail_descriptions": "Описания",
    "Descriptions": "Описания",
    "accounts.detail_listings": "Объявления",
    "accounts.detail_categories": "Категории",
    "accounts.detail_location": "Расположение",
    "accounts.detail_account_status": "Статус аккаунта",
    "accounts.detail_status": "Статус",
    "accounts.detail_shipping_method": "Способ доставки",
    "accounts.detail_shipping_methods": "Способы доставки",
    "Shipping Methods": "Способы доставки",
    "accounts.detail_account_user": "Пользователь аккаунта",
    "Account User": "Пользователь аккаунта",
    "accounts.detail_pending": "Ожидает",
    "accounts.detail_approved": "Одобрено",
    "accounts.detail_rejected": "Отклонено",
    "accounts.detail_active": "Активен",
    "accounts.detail_inactive": "Неактивен",
    "accounts.detail_joined": "Дата регистрации",
    "Joined": "Дата регистрации",
    "accounts.detail_account_age": "Возраст аккаунта",
    "Account Age": "Возраст аккаунта",
    "accounts.detail_less_than_a_month": "Меньше месяца",
    "Less than a month": "Меньше месяца",
    "accounts.detail_page_views": "Просмотры страницы",
    "accounts.detail_unique_visitors": "Уникальные посетители",
    "Unique Visitors": "Уникальные посетители",
    "accounts.detail_sessions": "Сеансы",
    "Sessions": "Сеансы",
    "accounts.detail_clicks": "Переходы",
    "Clicks": "Переходы",
    "accounts.detail_goals": "Цели",
    "Goals": "Цели",
    "accounts.detail_bot_views": "Просмотры ботов",
    "Bot Views": "Просмотры ботов",
    "accounts.detail_followers": "Подписчики",
    "Followers": "Подписчики",
    "accounts.detail_total_orders": "Всего заказов",
    "accounts.detail_revenue": "Доход",
    "accounts.detail_avg_order": "Средний заказ",
    "Avg Order": "Средний заказ",
    "accounts.detail_paid_orders": "Оплаченные заказы",
    "Paid Orders": "Оплаченные заказы",
    "accounts.detail_owner": "Владелец",
    "Owner": "Владелец",
    "accounts.detail_account_id": "ID аккаунта",
    "accounts.detail_category": "Категория",
    "accounts.detail_profile_completeness": "Заполнение профиля",
    "Profile Completeness": "Заполнение профиля",
    "accounts.detail_total_listings": "Всего объявлений",
    "Total Listings": "Всего объявлений",
    "accounts.detail_loaded_listings": "Загруженные объявления",
    "Loaded Listings": "Загруженные объявления",
    "accounts.detail_active_listings": "Активные объявления",
    "Active Listings": "Активные объявления",
    "accounts.detail_last_updated": "Последнее обновление",
    "Last Updated": "Последнее обновление",
    "accounts.detail_last_activity": "Последняя активность",
    "Last Activity": "Последняя активность",
    "accounts.detail_verification": "Проверка",
    "Verification": "Проверка",
    "accounts.detail_subscription": "Подписка",
    "accounts.detail_attributes": "Атрибуты",
    "accounts.detail_shipping_charge_split": "Распределение стоимости доставки",
    "Shipping Charge Split": "Распределение стоимости доставки",
    "accounts.detail_value_type": "Тип значения",
    "Value Type": "Тип значения",
    "accounts.detail_value": "Значение",
    "accounts.detail_enter_value": "Введите значение",
    "Enter Value": "Введите значение",
    "accounts.detail_commission_percentage": "Процент комиссии",
    "Commission Percentage": "Процент комиссии",
    "accounts.detail_commission_percent": "Процент комиссии",
    "Commission Percent": "Процент комиссии",
    "accounts.detail_share": "Доля",
    "accounts.detail_view_account": "Просмотреть аккаунт",
    "View Account": "Просмотреть аккаунт",
    "accounts.detail_add_listing": "Добавить объявление",
    "Add Listing": "Добавить объявление",
    "accounts.detail_edit_account": "Изменить аккаунт",
    "Edit Account": "Изменить аккаунт",
    "accounts.no_attribute_values": "Нет значений атрибута «{name}»",
    "accounts.no_attributes_yet": "Атрибутов пока нет",
    "No attributes yet": "Атрибутов пока нет",
    "accounts.edit_account": "Изменить аккаунт",
    "accounts.detail_preview": "Предпросмотр",
    "accounts.detail_fixed": "Фиксированная сумма",
    "accounts.detail_percentage": "Процент",
    "accounts.detail_select_value_type": "Выберите тип значения",
    "Select Value Type": "Выберите тип значения",
    "accounts.detail_approve": "Одобрить",
    "accounts.detail_reject": "Отклонить",
    "accounts.detail_section": "Сведения",
    "Details": "Сведения",
    "category.add_child": "Добавить подкатегорию",
    "Add Child Category": "Добавить подкатегорию",
    "category.add_listing": "Добавить объявление",
    "category.manage": "Управление категориями",
    "Manage Categories": "Управление категориями",
    "category.account_overview_eyebrow": "ОБЗОР КАТЕГОРИИ АККАУНТА",
    "ACCOUNT CATEGORY OVERVIEW": "ОБЗОР КАТЕГОРИИ АККАУНТА",
    "category.overview_eyebrow": "ОБЗОР КАТЕГОРИИ",
    "CATEGORY OVERVIEW": "ОБЗОР КАТЕГОРИИ",
    "category.category": "Категория",
    "category.active": "Активна",
    "category.inactive": "Неактивна",
    "category.accounts": "Аккаунты",
    "category.listings": "Объявления",
    "category.child_categories": "Подкатегории",
    "Child Categories": "Подкатегории",
    "category.attributes": "Атрибуты",
    "category.category_age": "Возраст категории",
    "Category age": "Возраст категории",
    "category.category_overview": "Обзор категории",
    "Category Overview": "Обзор категории",
    "category.category_id": "ID категории",
    "category.name": "Название",
    "category.slug": "Короткий адрес",
    "category.description": "Описание",
    "category.parent_category": "Родительская категория",
    "Parent Category": "Родительская категория",
    "category.hierarchy": "Иерархия",
    "Hierarchy": "Иерархия",
    "category.status": "Статус",
    "category.display_order": "Порядок отображения",
    "Display Order": "Порядок отображения",
    "category.created": "Дата добавления",
    "Joined / Created": "Дата добавления",
    "category.configured": "Настроено",
    "Configured": "Настроено",
    "category.no_attributes": "Атрибуты не назначены.",
    "No attributes assigned.": "Атрибуты не назначены.",
    "category.no_child_categories": "Подкатегорий нет.",
    "No child categories.": "Подкатегорий нет.",
    "category.no_accounts": "В этой категории нет аккаунтов.",
    "No accounts in this category.": "В этой категории нет аккаунтов.",
    "category.no_listings": "В этой категории нет объявлений.",
    "No listings in this category.": "В этой категории нет объявлений.",
    "category.detail_title": "Сведения о категории",
    "Category Detail": "Сведения о категории",
    "category.age_less_month": "Меньше месяца",
    "category.age_month": "{count} месяц",
    "{count} month": "{count} месяц",
    "category.age_months": "{count} месяцев",
    "{count} months": "{count} месяцев",
    "category.age_year": "{count} год",
    "{count} year": "{count} год",
    "category.age_years": "{count} лет",
    "{count} years": "{count} лет",
    "category.header_name": "Название",
    "category.header_category_id": "ID категории",
    "category.header_image": "Изображение",
    "category.header_order": "Порядок",
    "category.header_parent": "Родительская категория",
    "Parent": "Родительская категория",
    "category.header_active": "Активна",
    "category.header_action": "Действие",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Категории",
    "category.translate": "Перевести",
    "category.import": "Импорт",
    "category.export": "Экспорт",
    "category.add_category": "Добавить категорию",
    "Add Category": "Добавить категорию",
    "category.import_categories": "Импорт категорий",
    "Import Categories": "Импорт категорий",
    "category.delete_warning": "Существующие объявления не будут открываться на сайте или в приложении, будет показана ошибка.",
    "Existing listings will not open in website or app, you will see an error.": "Существующие объявления не будут открываться на сайте или в приложении, будет показана ошибка.",
    "category.editor_edit_category": "Изменить категорию",
    "Edit Category": "Изменить категорию",
    "category.editor_add_category": "Добавить категорию",
    "category.editor_save": "Сохранить",
    "category.editor_select_category_level": "Выберите уровень категории",
    "Select Category Level": "Выберите уровень категории",
    "category.editor_parent_category": "Родительская категория",
    "category.editor_select": "Выбрать",
    "category.editor_category_name": "Название категории",
    "Category Name": "Название категории",
    "category.editor_enter_category_name": "Введите название категории",
    "Enter category name": "Введите название категории",
    "category.editor_slug": "Короткий адрес",
    "category.editor_enter_slug": "Введите короткий адрес",
    "Enter slug": "Введите короткий адрес",
    "category.editor_category_description": "Описание категории",
    "Category Description": "Описание категории",
    "category.editor_order": "Порядок",
    "category.editor_enter_order": "Введите порядок",
    "Enter order": "Введите порядок",
    "category.editor_status_not_active_active": "Статус (неактивна / активна)",
    "category.editor_upload_media": "Загрузить медиафайл",
    "category.editor_meta_title": "Мета-заголовок",
    "Meta Title": "Мета-заголовок",
    "category.editor_enter_meta_title": "Введите мета-заголовок",
    "Enter meta title": "Введите мета-заголовок",
    "category.editor_meta_description": "Мета-описание",
    "Meta Description": "Мета-описание",
    "category.editor_category": "Категория",
    "category.editor_name": "Название",
    "category.editor_status": "Статус",
    "category.editor_action": "Действие",
    "category.editor_add_attribute": "Добавить атрибут",
    "Add Attribute": "Добавить атрибут",
    "category.editor_attributes_list": "Список атрибутов",
    "Attributes List": "Список атрибутов",
    "category.editor_please_enter_a_category_name_first": "Сначала введите название категории",
    "Please enter a category name first": "Сначала введите название категории",
    "category.editor_successfully_added_category": "Категория успешно добавлена",
    "Successfully added category": "Категория успешно добавлена",
    "category.deleted": "Категория удалена",
    "Category deleted": "Категория удалена",
    "attributes.title": "Атрибуты",
    "attributes.cart_checkout": "Корзина и оформление заказа",
    "Cart & Checkout": "Корзина и оформление заказа",
    "attributes.cart_settings": "Настройки корзины",
    "Cart settings": "Настройки корзины",
    "attributes.order_status_notifications": "Уведомления о статусе заказа",
    "Order status notifications": "Уведомления о статусе заказа",
    "attributes.groups": "Группы атрибутов",
    "Attribute Groups": "Группы атрибутов",
    "attributes.add_attribute": "Добавить атрибут",
    "attributes.edit_bulk": "Массовое редактирование",
    "Edit Bulk": "Массовое редактирование",
    "attributes.confirm_delete": "Удалить этот атрибут?",
    "Do you want to delete this attribute?": "Удалить этот атрибут?",
    "attributes.header_attribute_name": "Название атрибута",
    "Attribute Name": "Название атрибута",
    "attributes.header_action": "Действие",
    "attributes.header_manage_attribute_values": "Управление значениями атрибута",
    "Manage Attribute Values": "Управление значениями атрибута",
    "attributes.header_type": "Тип",
    "attributes.header_optional": "Необязательно",
    "attributes.header_icon": "Значок",
    "Icon": "Значок",
    "attributes.header_categories": "Категории",
    "attributes.header_hidden_field": "Скрытое поле",
    "Hidden Field": "Скрытое поле",
    "attributes.header_values": "Значения",
    "Values": "Значения",
    "attributes.header_status": "Статус",
    "attributes.type_single_select": "Один вариант",
    "Single Select": "Один вариант",
    "attributes.type_multi_select": "Несколько вариантов",
    "Multi Select": "Несколько вариантов",
    "attributes.type_open_single_value": "Свободный ввод (одно значение)",
    "Open (Single Value)": "Свободный ввод (одно значение)",
    "attributes.type_open_multiple_value": "Свободный ввод (несколько значений)",
    "Open (Multiple Value)": "Свободный ввод (несколько значений)",
    "attributes.type_attachment": "Вложение",
    "Attachment": "Вложение",
    "attributes.type_text_area": "Текстовая область",
    "Text Area": "Текстовая область",
    "attributes.type_date_time": "Дата и время",
    "Date Time": "Дата и время",
    "attributes.type_number": "Число",
    "attributes.type_boolean": "Логический тип",
    "Boolean": "Логический тип",
    "attributes.type_color": "Цвет",
    "Color": "Цвет",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "Местоположение",
    "attributes.type_audio": "Аудио",
    "Audio": "Аудио",
    "attributes.type_video": "Видео",
    "Video": "Видео",
    "attributes.type_open_multi_value": "Свободный ввод (несколько значений)",
    "Open (Multi Value)": "Свободный ввод (несколько значений)",
    "attributes.editor_edit_attribute": "Изменить атрибут",
    "Edit Attribute": "Изменить атрибут",
    "attributes.editor_add_attribute": "Добавить атрибут",
    "attributes.editor_attribute_name": "Название атрибута",
    "attributes.editor_select_type": "Выберите тип",
    "attributes.prefill_user": "Пользователь",
    "common.search_placeholder": "Введите текст для поиска…",
    "attributes.prefill_accounts": "Аккаунты",
    "attributes.prefill_listings": "Объявления",
    "listings.detail_nav_gallery": "Галерея",
    "Gallery": "Галерея",
    "listings.detail_nav_details": "Сведения",
    "listings.detail_nav_inventory": "Запасы",
    "listings.detail_nav_social": "Социальное",
    "listings.detail_nav_orders": "Заказы",
    "listings.detail_nav_analytics": "Аналитика",
    "listings.detail_nav_schedule": "Расписание",
    "listings.detail_nav_rental": "Аренда",
    "Rental": "Аренда",
    "listings.detail_nav_attributes": "Атрибуты",
    "listings.detail_nav_seller": "Продавец",
    "attributes.editor_icon": "Значок",
    "attributes.editor_tool_tip": "Подсказка",
    "Tool tip": "Подсказка",
    "attributes.editor_enter_attribute_name": "Введите название атрибута",
    "Enter attribute name": "Введите название атрибута",
    "attributes.editor_enter_attribute_tool_tip": "Введите текст подсказки",
    "Enter attribute tool tip": "Введите текст подсказки",
    "attributes.editor_optional": "Необязательно",
    "attributes.editor_private": "Приватный",
    "attributes.editor_hidden_field": "Скрытое поле",
    "Hidden field": "Скрытое поле",
    "attributes.editor_show_in_filter": "Показывать в фильтре",
    "Show in filter": "Показывать в фильтре",
    "attributes.editor_status_not_active_active": "Статус (неактивен / активен)",
    "attributes.editor_add_meta_data": "Добавить метаданные",
    "Add meta data": "Добавить метаданные",
    "attributes.editor_select": "Выбрать",
    "attributes.editor_select_category": "Выберите категорию",
    "Select category": "Выберите категорию",
    "attributes.editor_select_all": "Выбрать все",
    "Select All": "Выбрать все",
    "attributes.editor_unselect_all": "Снять выделение",
    "UnSelect All": "Снять выделение",
    "attributes.editor_create_categories_in_this_configuration_first": "Сначала создайте категории в этой конфигурации",
    "Create categories in this configuration first": "Сначала создайте категории в этой конфигурации",
    "attributes.editor_please_enter_attribute_name": "Введите название атрибута",
    "Please enter attribute name": "Введите название атрибута",
    "attributes.editor_please_select_type": "Выберите тип",
    "Please select type": "Выберите тип",
    "attributes.editor_select_single_attribute_values": "Выберите одно значение атрибута",
    "attributes.editor_select_multiple_attribute_values": "Выберите несколько значений атрибута",
    "attributes.editor_enter_value": "Введите значение",
    "attributes.editor_enter_multiple_tag": "Введите несколько тегов",
    "Enter Multiple Tag": "Введите несколько тегов",
    "attributes.editor_upload_file": "Загрузить файл",
    "Upload file": "Загрузить файл",
    "attributes.editor_enter_text": "Введите текст",
    "Enter Text": "Введите текст",
    "attributes.editor_select_date": "Выберите дату",
    "attributes.editor_enter_number": "Введите число",
    "Enter Number": "Введите число",
    "attributes.editor_select_color": "Выберите цвет",
    "Select Color": "Выберите цвет",
    "attributes.editor_upload_json": "Загрузить JSON",
    "Upload Json": "Загрузить JSON",
    "attributes.editor_select_location": "Выберите местоположение",
    "Select Location": "Выберите местоположение",
    "attributes.editor_category": "Категория",
    "attributes.editor_price": "Цена",
    "attributes.editor_enter_price": "Введите цену",
    "Enter Price": "Введите цену",
    "attributes.editor_preview": "Предпросмотр",
    "attributes.editor_title": "Заголовок",
    "attributes.editor_enter_title": "Введите заголовок",
    "attributes.editor_description": "Описание",
    "attributes.editor_add_listing": "Добавить объявление",
    "attributes.editor_add_account": "Добавить аккаунт",
    "attributes.editor_successfully_added_attributes": "Атрибуты успешно добавлены",
    "Successfully added attributes": "Атрибуты успешно добавлены",
    "attributes.editor_add_attribute_values": "Добавить значения атрибута",
    "Add Attribute Values": "Добавить значения атрибута",
    "common.image": "Изображение",
    "common.please_wait": "Подождите…",
    "attribute_groups.title": "Группы атрибутов",
    "attribute_groups.title_singular": "Группа атрибутов",
    "Attribute Group": "Группа атрибутов",
    "attribute_groups.add": "Добавить группу атрибутов",
    "Add Attribute Group": "Добавить группу атрибутов",
    "attribute_groups.image_path": "Путь к изображению",
    "Image Path": "Путь к изображению",
    "attribute_groups.name_placeholder": "Название группы",
    "Group Name": "Название группы",
    "attribute_groups.select_attributes": "Выберите атрибуты",
    "Select Attributes": "Выберите атрибуты",
    "attribute_groups.select_attributes_placeholder": "Выберите атрибуты…",
    "Select Attributes...": "Выберите атрибуты…",
    "attribute_groups.added_successfully": "Группа атрибутов добавлена",
    "Attribute Group Added Successfully": "Группа атрибутов добавлена",
    "attribute_groups.deleted_successfully": "Успешно удалено",
    "Deleted successfully": "Успешно удалено",
    "attribute_groups.name_required": "Укажите название",
    "attribute_groups.save_attributes_failed": "Группа сохранена, но не удалось назначить ей атрибуты.",
    "The group was saved, but its attributes could not be assigned.": "Группа сохранена, но не удалось назначить ей атрибуты.",
    "attributes.editor_enter_description": "Введите описание",
    "Enter Description": "Введите описание",
    "account_config.title": "Настройки аккаунта",
    "account_config.account_detail_note": "Примечание к сведениям об аккаунте",
    "Account detail note": "Примечание к сведениям об аккаунте",
    "account_config.enter_account_detail_note": "Введите примечание к сведениям об аккаунте",
    "Enter account detail note": "Введите примечание к сведениям об аккаунте",
    "account_config.address_label": "Название адреса",
    "account_config.enter_address_label": "Введите название адреса",
    "Enter address label": "Введите название адреса",
    "account_config.category_label": "Название категории",
    "Category label": "Название категории",
    "account_config.enter_category_label": "Введите название категории",
    "Enter category label": "Введите название категории",
    "account_config.nearby_accounts_radius_km": "Радиус поиска аккаунтов поблизости (км)",
    "Nearby accounts radius (km)": "Радиус поиска аккаунтов поблизости (км)",
    "account_config.nearby_accounts_radius_placeholder": "Радиус поиска аккаунтов поблизости в км",
    "Account nearby radius in km": "Радиус поиска аккаунтов поблизости в км",
    "account_config.account_limit": "Лимит аккаунтов",
    "Account Limit": "Лимит аккаунтов",
    "account_config.account_limit_placeholder": "Лимит аккаунтов",
    "Account limit": "Лимит аккаунтов",
    "account_config.shipping_preference_note": "Примечание о предпочтительном способе доставки",
    "Shipping method preference note": "Примечание о предпочтительном способе доставки",
    "account_config.option_accounts_auto_approved": "Автоматически одобрять аккаунты",
    "Accounts auto approved": "Автоматически одобрять аккаунты",
    "account_config.option_shipping_methods_preference_for_accounts": "Предпочтительные способы доставки для аккаунтов",
    "Shipping methods preference for accounts": "Предпочтительные способы доставки для аккаунтов",
    "account_config.option_account_map_location_selector": "Выбор местоположения аккаунта на карте",
    "Account map location selector": "Выбор местоположения аккаунта на карте",
    "account_config.option_account_geo_location": "Геолокация аккаунта",
    "Account Geo Location": "Геолокация аккаунта",
    "account_config.option_slug": "Короткий адрес",
    "account_config.option_show_description": "Показывать описание",
    "Show Description": "Показывать описание",
    "account_config.option_formatted_text_description": "Форматированный текст описания",
    "Formatted Text Description": "Форматированный текст описания",
    "account_config.option_hide_address_from_account_detail": "Скрыть адрес в сведениях об аккаунте",
    "Hide Address from Account Detail": "Скрыть адрес в сведениях об аккаунте",
    "account_config.option_get_account_pickup_address_always": "Всегда запрашивать адрес самовывоза аккаунта",
    "Get Account Pickup Address Always": "Всегда запрашивать адрес самовывоза аккаунта",
    "account_config.option_get_pickup_address_for_delivery": "Запрашивать адрес самовывоза для доставки",
    "Get Pickup Address for Delivery": "Запрашивать адрес самовывоза для доставки",
    "account_config.uploaded_successfully": "Успешно загружено",
    "app_customization.realtime_config_notice": "Эти настройки применяются сразу. После сохранения изменения отразятся в приложениях и ответах API.",
    "app_customization.release_config_notice": "Примечание для мобильных приложений: эти настройки применяются только при выпуске или обновлении продукта и не обновляются в реальном времени. Чтобы собрать новую версию, отправьте запрос через портал поддержки. (Тариф Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Примечание для мобильных приложений: эти настройки применяются только при выпуске или обновлении продукта и не обновляются в реальном времени. Чтобы собрать новую версию, отправьте запрос через портал поддержки. (Тариф Starter)",
    "category.translation_title": "Перевод категории",
    "Translate Category": "Перевод категории",
    "category.translation_category_name": "Название категории",
    "category.translation_description": "Описание",
    "listing_configs.title": "Настройки объявлений",
    "Listing Configuration": "Настройки объявлений",
    "listing_configs.rules": "ПРАВИЛА (уровень проекта / арендатора)",
    "RULES (Projects/Tenant level)": "ПРАВИЛА (уровень проекта / арендатора)",
    "listing_configs.features": "ФУНКЦИИ (только для мобильного приложения)",
    "FEATURES (Only for mobile app)": "ФУНКЦИИ (только для мобильного приложения)",
    "listing_configs.ui_customisation": "Настройка интерфейса",
    "UI Customisation": "Настройка интерфейса",
    "listing_configs.overridden_max_quantity": "Максимальное количество в объявлении",
    "listing_configs.overridden_max_quantity_example": "(например: 100)",
    "listing_configs.listing_min_price": "Минимальная цена объявления",
    "Minimum listing price": "Минимальная цена объявления",
    "listing_configs.listing_min_price_example": "(например: 5 $)",
    "listing_configs.auto_approval": "Автоматически одобрять объявления?",
    "Auto approve listings?": "Автоматически одобрять объявления?",
    "listing_configs.listing_pictures_count": "Количество загружаемых изображений",
    "Number of uploadable pictures count": "Количество загружаемых изображений",
    "listing_configs.seller_can_place_order": "Продавец может оформить заказ",
    "Seller can place order": "Продавец может оформить заказ",
    "listing_configs.hide_offer_percent": "Процент предложения",
    "Offer percent": "Процент предложения",
    "listing_configs.show_max_quantity": "Ограничения количества в объявлении",
    "listing_configs.show_shipping_charges": "Стоимость доставки",
    "Shipping charges": "Стоимость доставки",
    "listing_configs.listing_address_label": "Название адреса объявления",
    "listing_configs.listing_address_label_example": "(например: ориентир)",
    "listing_configs.listing_map_location_selector_enabled": "Выбирать местоположение на карте вместо поиска адреса",
    "Use map marker instead of searching address": "Выбирать местоположение на карте вместо поиска адреса",
    "listing_configs.listing_hide_tags": "Теги",
    "Tags": "Теги",
    "listing_configs.enable_stock": "Запасы",
    "Stocks": "Запасы",
    "listing_configs.listing_address_enabled": "Географический адрес",
    "listing_configs.show_stock_out_listings": "Показывать объявления без запаса в ленте",
    "listing_configs.enable_slug": "Короткий адрес заголовка объявления",
    "listing_configs.show_variants": "Варианты",
    "Variants": "Варианты",
    "listing_configs.meta_title": "Мета-заголовок",
    "Meta title": "Мета-заголовок",
    "listing_configs.meta_description": "Мета-описание",
    "Meta description": "Мета-описание",
    "listing_configs.listing_enable_formatted_text_description": "Включить редактор текста",
    "listing_configs.listing_enable_weight": "Включить вес",
    "Enable Weight": "Включить вес",
    "listing_configs.listing_enable_dimensions": "Включить размеры",
    "Enable Dimensions": "Включить размеры",
    "listing_configs.enable_stocks_listing_schedules": "График запасов",
    "Stock Schedules": "График запасов",
    "listing_variants.title": "Типы вариантов",
    "listing_variants.add_type": "Добавить тип варианта",
    "Add Variant Type": "Добавить тип варианта",
    "listing_variants.edit_type": "Изменить тип варианта",
    "Edit Variant Type": "Изменить тип варианта",
    "listing_variants.name": "Название",
    "listing_variants.values": "Значения",
    "listing_variants.status": "Статус",
    "listing_variants.action": "Действие",
    "listing_variants.add_value": "Добавить значение",
    "Add Value": "Добавить значение",
    "listing_variants.active": "Активен",
    "listing_variants.inactive": "Неактивен",
    "listing_variants.details": "Сведения",
    "listing_variants.translate": "Перевести",
    "listing_variants.delete_confirm": "Удалить этот тип варианта?",
    "Do you want to delete this variant type?": "Удалить этот тип варианта?",
    "listing_variants.add_value_first": "Сначала добавьте значение, чтобы просмотреть варианты.",
    "Add a value before viewing variants.": "Сначала добавьте значение, чтобы просмотреть варианты.",
    "listing_variants.enter_name": "Введите название",
    "Enter name": "Введите название",
    "listing_variants.status_hint": "Статус (неактивен / активен)",
    "listing_variants.total_values": "Всего значений",
    "Total Values": "Всего значений",
    "listing_variants.type_id": "ID типа",
    "Type ID": "ID типа",
    "listing_variants.total_count": "Всего: {count}",
    "{count} total": "Всего: {count}",
    "listing_variants.loading": "Загрузка…",
    "listing_variants.loading_values": "Загрузка значений…",
    "Loading values…": "Загрузка значений…",
    "listing_variants.no_values": "Значений пока нет",
    "No values yet": "Значений пока нет",
    "listing_variants.add_first_value": "Добавить первое значение",
    "Add First Value": "Добавить первое значение",
    "listing_variants.actions": "Действия",
    "listing_variants.edit": "Изменить",
    "listing_variants.delete": "Удалить",
    "listing_variants.edit_value": "Изменить значение",
    "Edit Value": "Изменить значение",
    "listing_variants.value_name_required": "Название значения *",
    "Value Name *": "Название значения *",
    "listing_variants.value_examples": "например: красный, XL, хлопок…",
    "e.g. Red, XL, Cotton…": "например: красный, XL, хлопок…",
    "listing_variants.saving": "Сохранение…",
    "listing_variants.save_changes": "Сохранить изменения",
    "Save Changes": "Сохранить изменения",
    "listing_variants.delete_value_confirm": "Удалить это значение варианта?",
    "Do you want to delete this variant value?": "Удалить это значение варианта?",
    "listing_variants.clear_all": "Очистить все",
    "listing_variants.multiple_values_help": "Добавьте значения через запятую или вставьте столбец из Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Добавьте значения через запятую или вставьте столбец из Excel.",
    "listing_variants.save": "Сохранить",
    "listing_variants.close": "Закрыть",
    "listing_variants.update": "Обновить",
    "listing_variants.default_text": "Текст по умолчанию",
    "listing_variants.enter_value": "Введите значение варианта",
    "Enter variant value": "Введите значение варианта",
    "listing_variants.add_values": "Добавить значения",
    "Add Values": "Добавить значения",
    "listing_variants.add_variant_values": "Добавить значения типа варианта",
    "Add Variant Type Values": "Добавить значения типа варианта",
    "listing_variants.values_list": "Список значений типа варианта",
    "Variant Type Values List": "Список значений типа варианта",
    "listing_variants.cancel_editing": "Отменить редактирование",
    "Cancel Editing": "Отменить редактирование",
    "listing_variants.value_name": "Значение типа варианта",
    "Variant Type Value": "Значение типа варианта",
    "common.default_text": "Текст по умолчанию",
    "common.translation_heading": "Переводы: {title}",
    "{title} Translations": "Переводы: {title}",
    "attributes.value_delete_confirm": "Удалить это значение атрибута?",
    "Do you want to delete this attribute value?": "Удалить это значение атрибута?",
    "attributes.value_clear_all": "Очистить все",
    "attributes.value_multiple_help": "Добавьте значения через запятую или вставьте столбец из Excel.",
    "Add comma-separated values or paste a column from Excel.": "Добавьте значения через запятую или вставьте столбец из Excel.",
    "attributes.value_active": "Активно",
    "attributes.value_inactive": "Неактивно",
    "attributes.value_save": "Сохранить",
    "attributes.value_close": "Закрыть",
    "attributes.value_translate": "Перевести",
    "attributes.value_update": "Обновить",
    "attributes.value_sort_alpha": "Сортировать по алфавиту",
    "Sort Alphabetically": "Сортировать по алфавиту",
    "attributes.value_default_text": "Текст по умолчанию",
    "attributes.value_add_metadata": "Добавить метаданные",
    "Add Metadata": "Добавить метаданные",
    "attributes.value_cancel_edit": "Отменить редактирование",
    "attributes.value_success_help": "Отлично! Теперь этот пользовательский атрибут доступен на странице добавления объявления.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Отлично! Теперь этот пользовательский атрибут доступен на странице добавления объявления.",
    "attributes.value_add": "Добавить значения атрибута",
    "attributes.value_add_listing": "Добавить значения атрибута объявления",
    "Add Listing Attribute Values": "Добавить значения атрибута объявления",
    "attributes.value_metadata_for": "Метаданные для",
    "Metadata for": "Метаданные для",
    "attributes.value_enter": "Введите значение атрибута",
    "Enter attribute value": "Введите значение атрибута",
    "attributes.value_add_values": "Добавить значения",
    "attributes.value_status_hint": "Статус (неактивно / активно)",
    "attributes.value_list": "Список значений атрибута",
    "Attribute Values List": "Список значений атрибута",
    "attributes.value_table_name": "Значение атрибута",
    "Attribute Value": "Значение атрибута",
    "attributes.value_table_status": "Статус",
    "attributes.value_table_action": "Действие",
    "attributes.metadata_key": "Ключ",
    "Key": "Ключ",
    "attributes.metadata_value": "Значение",
    "attributes.metadata_add_row": "Добавить строку",
    "Add Row": "Добавить строку",
    "workspace.countries": "Страны",
    "workspace.country_add": "Добавить страну",
    "Add Country": "Добавить страну",
    "workspace.country_edit": "Изменить страну",
    "Edit Country": "Изменить страну",
    "workspace.country_name": "Название страны",
    "Country Name": "Название страны",
    "workspace.select_country": "Выберите страну",
    "Select country": "Выберите страну",
    "workspace.country_order": "Порядок",
    "workspace.country_order_placeholder": "Введите порядок",
    "workspace.country_status": "Статус (неактивна / активна)",
    "workspace.country_default": "По умолчанию",
    "workspace.country_active": "Активна",
    "workspace.country_inactive": "Неактивна",
    "workspace.country_delete_confirm": "Удалить эту страну?",
    "Do you want to delete this country?": "Удалить эту страну?",
    "workspace.country_table_name": "Название",
    "workspace.country_table_default": "По умолчанию",
    "workspace.country_table_order": "Порядок",
    "workspace.country_table_status": "Статус",
    "workspace.country_table_action": "Действие",
    "workspace.languages": "Языки",
    "workspace.language_add": "Добавить язык",
    "Add Language": "Добавить язык",
    "workspace.language_edit": "Изменить язык",
    "Edit Language": "Изменить язык",
    "workspace.language_name": "Язык",
    "workspace.language_select": "Выберите язык",
    "Select Language": "Выберите язык",
    "workspace.language_order": "Порядок",
    "workspace.language_order_placeholder": "Введите порядок",
    "workspace.language_status": "Статус",
    "workspace.language_default": "По умолчанию",
    "workspace.language_default_warning": "При смене языка по умолчанию изменится язык приложения.",
    "Changing the default language changes the app language setting.": "При смене языка по умолчанию изменится язык приложения.",
    "workspace.language_active": "Активен",
    "workspace.language_inactive": "Неактивен",
    "workspace.language_delete_confirm": "Удалить этот язык?",
    "Do you want to delete this language?": "Удалить этот язык?",
    "workspace.language_table_name": "Название",
    "workspace.language_table_default": "По умолчанию",
    "workspace.language_table_order": "Порядок",
    "workspace.language_table_status": "Статус",
    "workspace.language_table_action": "Действие",
    "workspace.language_add_photo": "Добавить изображение",
    "workspace.currency": "Валюта",
    "workspace.currency_add": "Добавить валюту",
    "Add Currency": "Добавить валюту",
    "workspace.currency_edit": "Изменить валюту",
    "Edit Currency": "Изменить валюту",
    "workspace.currency_delete_confirm": "Удалить эту валюту?",
    "Do you want to delete this currency?": "Удалить эту валюту?",
    "workspace.currency_show": "Показать",
    "workspace.currency_entries": "записей",
    "entries": "записей",
    "workspace.currency_search": "Поиск:",
    "Search:": "Поиск:",
    "workspace.currency_search_placeholder": "Поиск валют",
    "Search currencies": "Поиск валют",
    "workspace.currency_empty": "Валюты не найдены.",
    "No currencies found.": "Валюты не найдены.",
    "workspace.currency_active": "Активна",
    "workspace.currency_inactive": "Неактивна",
    "workspace.currency_name": "Название",
    "workspace.currency_name_placeholder": "Название валюты",
    "Currency Name": "Название валюты",
    "workspace.currency_upload_media": "Загрузить медиафайл",
    "workspace.currency_select_media": "Выбрать из медиафайлов",
    "Select from media": "Выбрать из медиафайлов",
    "workspace.currency_no_media": "У вас нет медиафайлов.",
    "You do not have any media files.": "У вас нет медиафайлов.",
    "workspace.currency_code": "Код",
    "workspace.currency_select_code": "Выбрать",
    "workspace.currency_exchange_rate": "Обменный курс",
    "Exchange Rate": "Обменный курс",
    "workspace.currency_precision": "Точность",
    "Precision": "Точность",
    "workspace.currency_thousand_separator": "Разделитель тысяч",
    "Thousand Separator": "Разделитель тысяч",
    "workspace.currency_decimal_point": "Десятичный разделитель",
    "Decimal Point": "Десятичный разделитель",
    "workspace.currency_status_hint": "Статус (неактивна / активна)",
    "workspace.currency_default": "По умолчанию",
    "workspace.currency_format": "Формат",
    "Format": "Формат",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Название",
    "workspace.currency_table_code": "Код",
    "workspace.currency_table_format": "Формат",
    "workspace.currency_table_exchange": "Обменный курс",
    "Exchange": "Обменный курс",
    "workspace.currency_table_status": "Статус",
    "workspace.currency_table_default": "По умолчанию",
    "workspace.currency_table_action": "Действие",
    "commissions.title": "Комиссии",
    "commissions.add": "Добавить комиссию",
    "Add Commission": "Добавить комиссию",
    "commissions.edit": "Изменить комиссию",
    "Edit Commission": "Изменить комиссию",
    "commissions.delete_confirm": "Удалить эту комиссию?",
    "Do you want to delete this commission?": "Удалить эту комиссию?",
    "commissions.yes": "Да",
    "commissions.no": "Нет",
    "commissions.filter_all": "Все",
    "commissions.filter_supply": "Предложение",
    "Supply": "Предложение",
    "commissions.filter_demand": "Спрос",
    "Demand": "Спрос",
    "commissions.filter_cart": "Корзина",
    "commissions.table_title": "Название",
    "commissions.table_default_value": "Значение по умолчанию",
    "Default Value": "Значение по умолчанию",
    "commissions.table_status": "Статус",
    "commissions.table_action": "Действие",
    "commissions.active": "Активна",
    "commissions.inactive": "Неактивна",
    "commissions.type": "Тип",
    "commissions.type_supply": "Предложение",
    "commissions.type_demand": "Спрос",
    "commissions.type_cart": "Корзина",
    "commissions.select_category": "Выберите категорию",
    "Select Category": "Выберите категорию",
    "commissions.title_label": "Название",
    "commissions.enter_title": "Введите название",
    "Enter title": "Введите название",
    "commissions.description": "Описание",
    "commissions.enter_description": "Введите описание",
    "Enter description": "Введите описание",
    "commissions.default_value_percent": "Значение по умолчанию (%)",
    "Default value (%)": "Значение по умолчанию (%)",
    "commissions.short_code": "Краткий код",
    "Short Code": "Краткий код",
    "commissions.short_code_tooltip_title": "Краткий код",
    "Short code": "Краткий код",
    "commissions.short_code_tooltip_description": "Введите краткий код для этой комиссии.",
    "Enter a short code for this commission.": "Введите краткий код для этой комиссии.",
    "commissions.enter_short_code": "Введите краткий код",
    "Enter short code": "Введите краткий код",
    "commissions.status_hint": "Статус (неактивна / активна)",
    "commissions.optional": "Необязательно",
    "commissions.advanced": "Дополнительно",
    "Advanced": "Дополнительно",
    "commissions.add_by_category": "Добавить комиссию по категории",
    "Add commission by category": "Добавить комиссию по категории",
    "commissions.select_calculation_type": "Выберите тип",
    "commissions.calc_fixed": "Фиксированная",
    "commissions.calc_slab": "Диапазонная",
    "Slab": "Диапазонная",
    "commissions.value": "Значение",
    "commissions.choose_category": "Выберите категорию",
    "Choose category": "Выберите категорию",
    "commissions.create_categories_first": "Сначала создайте категории в настройках объявлений",
    "Create categories in Listing Configuration first": "Сначала создайте категории в настройках объявлений",
    "commissions.select_type": "Выберите тип",
    "commissions.demand_fixed": "Фиксированная",
    "commissions.demand_percentage": "Процентная",
    "commissions.unlimited_hint": "* Введите -1 для неограниченного значения",
    "* Enter -1 for unlimited": "* Введите -1 для неограниченного значения",
    "commissions.from": "От",
    "commissions.enter_from": "Введите начало",
    "Enter from": "Введите начало",
    "commissions.to": "До",
    "commissions.enter_to": "Введите конец",
    "Enter to": "Введите конец",
    "commissions.enter_value": "Введите значение",
    "commissions.add_row": "Добавить строку",
    "commissions.minimum_amount": "Минимальная сумма",
    "Minimum amount": "Минимальная сумма",
    "commissions.enter_minimum_amount": "Введите минимальную сумму",
    "Enter minimum amount": "Введите минимальную сумму",
    "commissions.maximum_amount": "Максимальная сумма",
    "Maximum amount": "Максимальная сумма",
    "commissions.enter_maximum_amount": "Введите максимальную сумму",
    "Enter maximum amount": "Введите максимальную сумму",
    "commissions.notes": "Примечания",
    "Notes": "Примечания",
    "commissions.enter_note": "Введите примечание",
    "Enter note": "Введите примечание",
    "commissions.from_value": "Начальное значение",
    "From Value": "Начальное значение",
    "commissions.to_value": "Конечное значение",
    "To Value": "Конечное значение",
    "commissions.unlimited_short_hint": "(-1 — неограниченно)",
    "(-1 for unlimited)": "(-1 — неограниченно)",
    "commissions.value_percent": "Значение (%)",
    "Value (%)": "Значение (%)",
    "commissions.from_value_validation": "Начальное значение должно быть больше предыдущего конечного значения",
    "From value should be greater than the previous To value": "Начальное значение должно быть больше предыдущего конечного значения",
    "commissions.to_value_validation": "Конечное значение должно быть больше начального",
    "To value should be greater than From value": "Конечное значение должно быть больше начального",
    "taxes.title": "Налог",
    "taxes.title_plural": "Налоги",
    "taxes.add": "Добавить налог",
    "Add Tax": "Добавить налог",
    "taxes.edit": "Изменить налог",
    "Edit Tax": "Изменить налог",
    "taxes.delete_confirm": "Удалить этот налог?",
    "Are you sure you want to delete this tax?": "Удалить этот налог?",
    "taxes.table_title": "Название",
    "taxes.table_short_code": "Краткий код",
    "taxes.table_default_value": "Значение по умолчанию",
    "taxes.table_status": "Статус",
    "taxes.table_action": "Действие",
    "taxes.active": "Активен",
    "taxes.inactive": "Неактивен",
    "taxes.select_type": "Выберите тип",
    "taxes.type_order": "Заказ",
    "taxes.type_listing": "Объявление",
    "taxes.type_tax": "Налог",
    "taxes.demand_fixed": "Фиксированный",
    "taxes.demand_percentage": "Процентный",
    "taxes.from": "От",
    "taxes.enter_from": "Введите начало",
    "taxes.to": "До",
    "taxes.enter_to": "Введите конец",
    "taxes.unlimited_hint": "(-1 — неограниченно)",
    "taxes.value": "Значение",
    "taxes.enter_value": "Введите значение",
    "taxes.add_row": "Добавить строку",
    "taxes.note": "Примечание",
    "taxes.note_placeholder": "Введите примечание, которое увидят пользователи при оформлении заказа и в сведениях о заказе.",
    "Enter a note for users to see during checkout and in order details.": "Введите примечание, которое увидят пользователи при оформлении заказа и в сведениях о заказе.",
    "taxes.inclusive": "Налог включен в цену",
    "Tax Inclusive": "Налог включен в цену",
    "taxes.inclusive_tooltip": "Включите, если указанная цена уже включает налог.",
    "Enable this when the listed price already includes tax.": "Включите, если указанная цена уже включает налог.",
    "taxes.title_placeholder": "Введите название, которое увидят пользователи при оформлении заказа и в его сведениях.",
    "Enter a name shown to users at checkout and in order details.": "Введите название, которое увидят пользователи при оформлении заказа и в его сведениях.",
    "taxes.default_value": "Значение по умолчанию (%)",
    "taxes.default_placeholder": "Значение по умолчанию в %. Например: 6,5",
    "Default value in %. Example: 6.5": "Значение по умолчанию в %. Например: 6,5",
    "taxes.short_code": "Краткий код",
    "taxes.short_code_tooltip_title": "Краткий код",
    "taxes.short_code_tooltip_description": "Введите краткий код для этого налога.",
    "Enter a short code for this tax.": "Введите краткий код для этого налога.",
    "taxes.short_code_placeholder": "Используйте буквы и цифры, не более 10 символов. Например: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Используйте буквы и цифры, не более 10 символов. Например: GST10",
    "taxes.status_hint": "Статус (неактивен / активен)",
    "taxes.advanced": "Дополнительно",
    "special_fees.title": "Специальные сборы",
    "special_fees.description": "Настройте дополнительный фиксированный сбор или процент для каждого объявления.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Настройте дополнительный фиксированный сбор или процент для каждого объявления.",
    "special_fees.fixed": "Фиксированный специальный сбор",
    "Special fees fixed": "Фиксированный специальный сбор",
    "special_fees.fixed_placeholder": "Введите сумму сбора (например: 5)",
    "Enter special fee amount (example: 5)": "Введите сумму сбора (например: 5)",
    "special_fees.percentage": "Специальный сбор в процентах",
    "Special fees percentage": "Специальный сбор в процентах",
    "special_fees.percentage_placeholder": "Введите процент сбора (например: 10%)",
    "Enter special fee percentage (example: 10%)": "Введите процент сбора (например: 10%)",
    "special_fees.example": "Пример",
    "Example": "Пример",
    "special_fees.example_description": "К цене объявления можно добавить специальный сбор. Например, товар стоит 100 $, и вы добавляете два сбора.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "К цене объявления можно добавить специальный сбор. Например, товар стоит 100 $, и вы добавляете два сбора.",
    "special_fees.example_fixed": "Дополнительная фиксированная сумма = 10 $",
    "Additional fixed amount = $10": "Дополнительная фиксированная сумма = 10 $",
    "special_fees.example_percentage": "Дополнительный процент = 10%",
    "Additional fixed percentage = 10%": "Дополнительный процент = 10%",
    "special_fees.example_total": "Итоговая цена = 120 $",
    "Final price = $120": "Итоговая цена = 120 $",
    "delivery.methods_title": "Способы оказания услуг / доставки",
    "Service / Shipping Methods": "Способы оказания услуг / доставки",
    "delivery.shipping_service": "Доставка / Услуга",
    "Shipping / Service": "Доставка / Услуга",
    "delivery.table_name": "Название",
    "delivery.table_default": "По умолчанию",
    "delivery.table_order": "Порядок",
    "delivery.table_status": "Статус",
    "delivery.table_action": "Действие",
    "delivery.yes": "Да",
    "delivery.no": "Нет",
    "delivery.active": "Активен",
    "delivery.inactive": "Неактивен",
    "delivery.delete_confirm": "Удалить этот способ доставки?",
    "Do you want to delete this shipping method?": "Удалить этот способ доставки?",
    "delivery.schedule_time": "Время по расписанию",
    "Schedule Time": "Время по расписанию",
    "delivery.translate": "Перевести",
    "delivery.config": "Настройка",
    "Config": "Настройка",
    "delivery.add": "Добавить доставку / услугу",
    "Add Shipping/Service": "Добавить доставку / услугу",
    "delivery.save": "Сохранить",
    "delivery.edit": "Изменить доставку / услугу",
    "Edit Shipping/Service": "Изменить доставку / услугу",
    "delivery.stuart_config": "Настройки Stuart",
    "Stuart Configs": "Настройки Stuart",
    "delivery.shipping_configs": "Настройки способов доставки / услуг",
    "Service / Shipping Configs": "Настройки способов доставки / услуг",
    "delivery.settings": "Настройки",
    "delivery.preview": "Предпросмотр",
    "delivery.shipment_option": "Вариант доставки",
    "Shipment Option": "Вариант доставки",
    "delivery.name": "Название",
    "delivery.enter_name": "Введите название",
    "delivery.note": "Примечание",
    "delivery.enter_note": "Введите примечание",
    "delivery.note_tooltip_title": "Примечание",
    "delivery.note_tooltip_description": "Добавьте необязательное примечание, чтобы пояснить этот вариант доставки или услуги.",
    "Add an optional note to explain this shipping or service option.": "Добавьте необязательное примечание, чтобы пояснить этот вариант доставки или услуги.",
    "delivery.order": "Порядок",
    "delivery.enter_order": "Введите порядок",
    "delivery.status_hint": "Статус (неактивен / активен)",
    "delivery.default": "По умолчанию",
    "delivery.select_shipping_method": "Выберите способ доставки",
    "Select shipping method": "Выберите способ доставки",
    "delivery.select_extension": "Выберите расширение",
    "Select extension": "Выберите расширение",
    "delivery.add_photo": "Добавить фото",
    "delivery.config.flat_shipping_fee.title": "Фиксированная стоимость доставки",
    "Flat Shipping Fee": "Фиксированная стоимость доставки",
    "delivery.config.flat_shipping_fee.placeholder": "Введите фиксированную стоимость доставки",
    "Enter flat shipping fee": "Введите фиксированную стоимость доставки",
    "delivery.config.schedule_time.title": "Время по расписанию",
    "delivery.config.fulfillment_by_platform_enabled.title": "Доставка платформой",
    "Fulfillment by platform": "Доставка платформой",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Значок доставки платформой",
    "Fulfillment by Platform Icon": "Значок доставки платформой",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Значок доставки продавцом",
    "Seller Delivery Icon": "Значок доставки продавцом",
    "delivery.phone_number": "Номер телефона",
    "Phone number": "Номер телефона",
    "delivery.enter_phone_number": "Введите номер телефона",
    "Enter phone number": "Введите номер телефона",
    "delivery.address_line_1": "Адрес, строка 1",
    "Address line 1": "Адрес, строка 1",
    "delivery.enter_address_line_1": "Введите адрес, строка 1",
    "Enter address line 1": "Введите адрес, строка 1",
    "delivery.address_line_2": "Адрес, строка 2",
    "Address line 2": "Адрес, строка 2",
    "delivery.enter_address_line_2": "Введите адрес, строка 2",
    "Enter address line 2": "Введите адрес, строка 2",
    "delivery.landmark": "Ориентир",
    "Landmark": "Ориентир",
    "delivery.enter_landmark": "Введите ориентир",
    "Enter landmark": "Введите ориентир",
    "delivery.state": "Регион",
    "delivery.enter_state": "Введите регион",
    "Enter state": "Введите регион",
    "delivery.post_code": "Почтовый индекс",
    "Post code": "Почтовый индекс",
    "delivery.enter_post_code": "Введите почтовый индекс",
    "Enter post code": "Введите почтовый индекс",
    "delivery.country": "Страна",
    "delivery.enter_country": "Введите страну",
    "Enter country": "Введите страну",
    "delivery.required_information": "Заполните обязательные поля",
    "Please fill the required information": "Заполните обязательные поля",
    "delivery.saved_successfully": "Успешно сохранено",
    "delivery.storage_hub.title": "Пункты складского хранения",
    "Storage Hub Points": "Пункты складского хранения",
    "delivery.storage_hub.add": "Добавить складской пункт",
    "Add Storage Hub": "Добавить складской пункт",
    "delivery.storage_hub.edit": "Изменить складской пункт",
    "Edit Storage Hub": "Изменить складской пункт",
    "delivery.storage_hub.delete_confirm": "Удалить этот пункт хранения?",
    "Do you want to delete this storage hub point?": "Удалить этот пункт хранения?",
    "delivery.storage_hub.table_name": "Название",
    "delivery.storage_hub.table_phone": "Телефон",
    "delivery.storage_hub.table_address": "Адрес",
    "delivery.storage_hub.table_landmark": "Ориентир",
    "delivery.storage_hub.table_state": "Регион",
    "delivery.storage_hub.table_post_code": "Почтовый индекс",
    "Post Code": "Почтовый индекс",
    "delivery.storage_hub.table_country": "Страна",
    "delivery.storage_hub.table_action": "Действие",
    "delivery.select_environment": "Выберите среду",
    "Select environment": "Выберите среду",
    "delivery.environment_sandbox": "Тестовая среда",
    "Sandbox": "Тестовая среда",
    "delivery.environment_production": "Рабочая среда",
    "Production": "Рабочая среда",
    "delivery.stuart.client_id": "ID клиента",
    "delivery.stuart.enter_client_id": "Введите ID клиента",
    "delivery.stuart.client_secret": "Секрет клиента",
    "Client Secret": "Секрет клиента",
    "delivery.stuart.enter_client_secret": "Введите секрет клиента",
    "Enter client secret": "Введите секрет клиента",
    "delivery.stuart.webhook_key": "Ключ аутентификации вебхука",
    "Webhook Authentication Key": "Ключ аутентификации вебхука",
    "delivery.stuart.enter_webhook_key": "Введите ключ аутентификации вебхука",
    "Enter webhook authentication key": "Введите ключ аутентификации вебхука",
    "delivery.sendcloud.public_key": "Открытый ключ",
    "Public Key": "Открытый ключ",
    "delivery.sendcloud.enter_public_key": "Введите ключ API",
    "delivery.sendcloud.secret_key": "Секретный ключ",
    "Secret Key": "Секретный ключ",
    "delivery.sendcloud.enter_secret_key": "Введите секрет уведомлений",
    "Enter notification secret": "Введите секрет уведомлений",
    "delivery.sendcloud.default_shipping_address": "Адрес доставки по умолчанию",
    "Default Shipping Address": "Адрес доставки по умолчанию",
    "delivery.sendcloud.add_new": "+ Добавить",
    "+ Add New": "+ Добавить",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Способы оплаты",
    "Payment Methods": "Способы оплаты",
    "payments.add": "Добавить способ оплаты",
    "Add Payment Method": "Добавить способ оплаты",
    "payments.edit": "Изменить способ оплаты",
    "Edit Payment Method": "Изменить способ оплаты",
    "payments.delete_confirm": "Удалить этот способ оплаты?",
    "Do you want to delete this payment method?": "Удалить этот способ оплаты?",
    "payments.save_continue": "Сохранить и продолжить",
    "Save and continue": "Сохранить и продолжить",
    "payments.translate": "Перевод способов оплаты",
    "Translate Payments": "Перевод способов оплаты",
    "payments.config": "Настройка",
    "payments.integration_settings": "Настройки интеграции",
    "Integration Settings": "Настройки интеграции",
    "payments.opp_integration": "Интеграция OPP",
    "OPP Integration": "Интеграция OPP",
    "payments.billplz_integration": "Интеграция BillPlz",
    "BillPlz Integration": "Интеграция BillPlz",
    "payments.stripe_integration": "Интеграция Stripe",
    "Stripe Integration": "Интеграция Stripe",
    "payments.stripe_web_integration": "Интеграция Stripe Web",
    "Stripe Web Integration": "Интеграция Stripe Web",
    "payments.pawapay_integration": "Интеграция PawaPay",
    "PawaPay Integration": "Интеграция PawaPay",
    "payments.korapay_integration": "Интеграция KoraPay",
    "KoraPay Integration": "Интеграция KoraPay",
    "payments.flutterwave_integration": "Интеграция Flutterwave",
    "Flutterwave Integration": "Интеграция Flutterwave",
    "payments.commercepay_integration": "Интеграция CommercePay",
    "CommercePay Integration": "Интеграция CommercePay",
    "payments.checkout_com_integration": "Интеграция Checkout.com",
    "Checkout.com Integration": "Интеграция Checkout.com",
    "payments.paystack_integration": "Интеграция PayStack",
    "PayStack Integration": "Интеграция PayStack",
    "payments.razorpay_settings": "Настройки Razorpay",
    "Razorpay settings": "Настройки Razorpay",
    "payments.paydunya_settings": "Настройки Pay Dunya",
    "Pay Dunya settings": "Настройки Pay Dunya",
    "payments.mangopay_settings": "Настройки MangoPay",
    "MangoPay settings": "Настройки MangoPay",
    "payments.payu_latam_integration": "Интеграция PayU LATAM",
    "PayU LATAM Integration": "Интеграция PayU LATAM",
    "payments.table_name": "Название",
    "payments.table_actions": "Действия",
    "payments.table_min_amount": "Минимальная сумма",
    "Minimum Amount": "Минимальная сумма",
    "payments.table_max_amount": "Максимальная сумма",
    "Maximum Amount": "Максимальная сумма",
    "payments.table_default": "По умолчанию",
    "payments.table_order_by": "Порядок",
    "payments.table_status": "Статус",
    "payments.yes": "Да",
    "payments.no": "Нет",
    "payments.active": "Активен",
    "payments.inactive": "Неактивен",
    "payments.settings": "Настройки",
    "payments.not_available": "Н/Д",
    "payments.step_select_type": "Выберите тип",
    "payments.step_configure": "Настроить",
    "Configure": "Настроить",
    "payments.step_integration": "Интеграция",
    "Integration": "Интеграция",
    "payments.next": "Далее →",
    "Next →": "Далее →",
    "payments.save": "Сохранить",
    "payments.choose_method": "Выберите способ оплаты для настройки",
    "Choose a payment method to configure": "Выберите способ оплаты для настройки",
    "payments.name": "Название",
    "payments.enter_name": "Введите название",
    "payments.maximum_amount": "Максимальная сумма",
    "payments.enter_maximum_amount": "Введите максимальную сумму",
    "payments.minimum_amount": "Минимальная сумма",
    "payments.enter_minimum_amount": "Введите минимальную сумму",
    "payments.note": "Примечание",
    "payments.enter_note": "Введите примечание",
    "payments.note_tooltip": "Добавьте необязательное примечание для клиентов при оформлении заказа.",
    "Add an optional note for customers at checkout.": "Добавьте необязательное примечание для клиентов при оформлении заказа.",
    "payments.order": "Порядок",
    "payments.enter_order": "Введите порядок",
    "payments.default": "По умолчанию",
    "payments.config_title": "Настройка способов оплаты",
    "Payment Methods Configuration": "Настройка способов оплаты",
    "payments.wallet_enable": "Включить кошелек",
    "Wallet enabled": "Включить кошелек",
    "payments.account_type": "Тип аккаунта",
    "payments.select_account_type": "Выберите тип аккаунта",
    "Select account type": "Выберите тип аккаунта",
    "payments.connect_message_standard": "Сообщение подключения Standard",
    "Connect message standard": "Сообщение подключения Standard",
    "payments.enter_connect_message_standard": "Введите сообщение подключения Standard",
    "Enter connect message standard": "Введите сообщение подключения Standard",
    "payments.disconnect_message_standard": "Сообщение отключения Standard",
    "Disconnect message standard": "Сообщение отключения Standard",
    "payments.enter_disconnect_message_standard": "Введите сообщение отключения Standard",
    "Enter disconnect message standard": "Введите сообщение отключения Standard",
    "payments.connect_message_express": "Сообщение подключения Express",
    "Connect message express": "Сообщение подключения Express",
    "payments.enter_connect_message_express": "Введите сообщение подключения Express",
    "Enter connect message express": "Введите сообщение подключения Express",
    "payments.disconnect_message_express": "Сообщение отключения Express",
    "Disconnect message express": "Сообщение отключения Express",
    "payments.enter_disconnect_message_express": "Введите сообщение отключения Express",
    "Enter disconnect message express": "Введите сообщение отключения Express",
    "payments.enable_sandbox": "Включить тестовую среду",
    "Enable sandbox": "Включить тестовую среду",
    "payments.api_token": "Токен API",
    "API Token": "Токен API",
    "payments.enter_token": "Введите токен",
    "Enter token": "Введите токен",
    "payments.key_id": "ID ключа",
    "Key ID": "ID ключа",
    "payments.enter_key_id": "Введите ID ключа",
    "Enter key ID": "Введите ID ключа",
    "payments.key_secret": "Секретный ключ",
    "Key Secret": "Секретный ключ",
    "payments.enter_secret_key": "Введите секретный ключ",
    "Enter secret key": "Введите секретный ключ",
    "payments.webhook_secret_key": "Секретный ключ вебхука",
    "Webhook Secret Key": "Секретный ключ вебхука",
    "payments.enter_webhook_secret_key": "Введите секретный ключ вебхука",
    "Enter webhook secret key": "Введите секретный ключ вебхука",
    "payments.master_key": "Главный ключ",
    "Master Key": "Главный ключ",
    "payments.public_key": "Открытый ключ",
    "payments.enter_public_key": "Введите открытый ключ",
    "Enter public key": "Введите открытый ключ",
    "payments.private_key": "Закрытый ключ",
    "Private Key": "Закрытый ключ",
    "payments.merchant_id": "ID продавца",
    "Merchant ID": "ID продавца",
    "payments.enter_merchant_id": "Введите ID продавца",
    "Enter merchant id": "Введите ID продавца",
    "payments.processing_channel_id": "ID канала обработки",
    "Processing channel ID": "ID канала обработки",
    "payments.enter_processing_channel_id": "Введите ID канала обработки",
    "Enter processing channel id": "Введите ID канала обработки",
    "payments.api_key": "Ключ API",
    "payments.x_signature_key": "Ключ подписи X",
    "X Signature Key": "Ключ подписи X",
    "payments.account_id": "ID аккаунта",
    "payments.login_api_key": "Ключ API для входа",
    "Login API key": "Ключ API для входа",
    "payments.client_id": "ID клиента",
    "payments.client_api_key": "Ключ API клиента",
    "Client API Key": "Ключ API клиента",
    "payments.payin_fee": "Комиссия за прием платежа (%)",
    "PayIn fee (%)": "Комиссия за прием платежа (%)",
    "payments.withdraw_fee": "Комиссия за вывод средств (%)",
    "Withdraw fee (%)": "Комиссия за вывод средств (%)",
    "payments.enter_api_key": "Введите ключ API",
    "payments.enter_account_id": "Введите ID аккаунта",
    "Enter account ID": "Введите ID аккаунта",
    "payments.enter_login_api_key": "Введите ключ API для входа",
    "Enter login API key": "Введите ключ API для входа",
    "payments.enter_notification_secret": "Введите секрет уведомлений",
    "payments.enter_payin_fee": "Введите комиссию в процентах",
    "Enter fee as a percentage": "Введите комиссию в процентах",
    "payments.secret_key": "Секретный ключ",
    "Secret key": "Секретный ключ",
    "payments.publishable_key": "Публичный ключ",
    "Publishable key": "Публичный ключ",
    "payments.webhook_secret": "Секрет вебхука",
    "Webhook secret": "Секрет вебхука",
    "payments.enter_webhook_secret": "Введите секрет вебхука",
    "Enter webhook secret": "Введите секрет вебхука",
    "payments.enter_subscription_webhook_secret": "Введите секрет вебхука подписки",
    "Enter subscription webhook secret": "Введите секрет вебхука подписки",
    "payments.connect_client_id": "ID клиента Connect",
    "Connect client ID": "ID клиента Connect",
    "payments.enter_connect_client_id": "Введите ID клиента Connect",
    "Enter Connect client ID": "Введите ID клиента Connect",
    "payments.stripe_reminders": "Напоминания Stripe",
    "Stripe reminders": "Напоминания Stripe",
    "payments.stripe_sync_help": "Синхронизация проверяет секретный ключ в Stripe, заполняет сведения об аккаунте и создает необходимые Tradly конечные точки вебхуков. Секреты вебхуков заполняются автоматически. После завершения сохраните форму.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "Синхронизация проверяет секретный ключ в Stripe, заполняет сведения об аккаунте и создает необходимые Tradly конечные точки вебхуков. Секреты вебхуков заполняются автоматически. После завершения сохраните форму.",
    "payments.find_in_stripe": "Stripe Kontrol Panelinde Bul",
    "Find in Stripe Dashboard": "Stripe Kontrol Panelinde Bul",
    "payments.description": "Описание",
    "payments.learn_more_stripe": "Подробнее о платежах Stripe",
    "Learn more about Stripe Payments": "Подробнее о платежах Stripe",
    "payments.learn_more_stripe_connect": "Подробнее о Stripe Connect для маркетплейсов",
    "Learn more about Stripe Connect for marketplaces": "Подробнее о Stripe Connect для маркетплейсов",
    "payments.token": "Токен",
    "Token": "Токен",
    "payments.payment_options": "Варианты оплаты",
    "Payment options": "Варианты оплаты",
    "payments.enable_integration": "Включить интеграцию",
    "Enable integration": "Включить интеграцию",
    "payments.enter_provider_id": "Введите ID {provider}",
    "Enter {provider} ID": "Введите ID {provider}",
    "payments.integration_status_help": "Настройте этого провайдера в его параметрах.",
    "Configure this provider in its settings.": "Настройте этого провайдера в его параметрах.",
    "listings.title": "Объявления",
    "listings.manage": "Управление",
    "listings.show_rows": "Показать строки",
    "listings.clear": "Очистить",
    "listings.apply": "Применить",
    "listings.select_date": "Выберите дату",
    "Select date": "Выберите дату",
    "listings.start_date": "Дата начала",
    "listings.end_date": "Дата окончания",
    "listings.status_types": "Типы статусов",
    "Status types": "Типы статусов",
    "listings.categories": "Категории",
    "listings.attributes": "Атрибуты",
    "listings.clear_all_filters": "Сбросить все фильтры",
    "Clear all filters": "Сбросить все фильтры",
    "listings.import": "Импорт",
    "listings.export": "Экспорт",
    "listings.smart_upload": "Умная загрузка (бета)",
    "Smart Upload (Beta)": "Умная загрузка (бета)",
    "listings.filter_listings": "Фильтровать объявления",
    "Filter listings": "Фильтровать объявления",
    "listings.sort_listings": "Сортировать объявления",
    "Sort listings": "Сортировать объявления",
    "listings.import_listings": "Импорт объявлений",
    "listings.export_listings": "Экспорт объявлений",
    "Export listings": "Экспорт объявлений",
    "listings.list_view": "Вид списком",
    "listings.grid_view": "Вид сеткой",
    "listings.map_view": "Вид карты",
    "listings.board_view": "Вид доски",
    "listings.export_all_title": "Экспортировать все объявления?",
    "Export all listings?": "Экспортировать все объявления?",
    "listings.export_all_message": "Будет подготовлен файл со всеми объявлениями. Продолжить?",
    "This will prepare a file containing all listings. Do you want to continue?": "Будет подготовлен файл со всеми объявлениями. Продолжить?",
    "listings.export_all": "Экспортировать все объявления",
    "Export all listings": "Экспортировать все объявления",
    "listings.cancel": "Отмена",
    "listings.status_all": "Все",
    "listings.status_pending": "Ожидает",
    "listings.status_approved": "Одобрено",
    "listings.status_rejected": "Отклонено",
    "listings.status_archived": "В архиве",
    "listings.sort_newest_first": "Сначала новые",
    "Newest first": "Сначала новые",
    "listings.sort_price_high_to_low": "Цена: по убыванию",
    "Price: high to low": "Цена: по убыванию",
    "listings.sort_price_low_to_high": "Цена: по возрастанию",
    "Price: low to high": "Цена: по возрастанию",
    "listings.header_0": "Название",
    "listings.header_1": "Веб-сайт",
    "Website": "Веб-сайт",
    "listings.header_2": "Цена",
    "listings.header_3": "Процент предложения",
    "listings.header_4": "Изображение",
    "listings.header_5": "Цена предложения",
    "Offer price": "Цена предложения",
    "listings.header_6": "Статус",
    "listings.header_7": "ID объявления",
    "listings.header_8": "Статус объявления",
    "Listing status": "Статус объявления",
    "listings.header_9": "Аккаунты",
    "listings.header_10": "Валюта",
    "listings.header_11": "Продано",
    "Sold": "Продано",
    "listings.header_12": "Целевая сумма",
    "Goal amount": "Целевая сумма",
    "listings.filter_status": "Статус",
    "listings.filter_price": "Цена",
    "listings.filter_category": "Категория",
    "listings.filter_clear_all": "Сбросить все фильтры",
    "listings.status_count": "Статус ({count})",
    "Status ({count})": "Статус ({count})",
    "listings.price_count": "Цена ({count})",
    "Price ({count})": "Цена ({count})",
    "listings.category_count": "Категория ({count})",
    "Category ({count})": "Категория ({count})",
    "listings.search": "Поиск объявлений",
    "listings.clear_search": "Очистить поиск объявлений",
    "Clear listing search": "Очистить поиск объявлений",
    "listings.active": "Активно",
    "listings.inactive": "Неактивно",
    "listings.approve": "Одобрить",
    "listings.reject": "Отклонить",
    "listings.delete_confirm": "Удалить это объявление?",
    "listings.approve_confirm": "Одобрить это объявление?",
    "Do you want to approve this listing?": "Одобрить это объявление?",
    "listings.reject_confirm": "Отклонить это объявление?",
    "Do you want to reject this listing?": "Отклонить это объявление?",
    "listings.yes": "Да",
    "listings.no": "Нет",
    "listings.confirm_delete": "Удалить это объявление?",
    "listings.confirm_approve": "Одобрить это объявление?",
    "listings.confirm_reject": "Отклонить это объявление?",
    "listings.column.actions": "Действия",
    "listings.audio_episode": "Аудиоэпизод",
    "Audio episode": "Аудиоэпизод",
    "listings.video": "Видео",
    "listings.seller": "Продавец",
    "listings.rating": "Оценка",
    "listings.followers": "Подписчики",
    "listings.view_seller_account": "Просмотреть аккаунт продавца",
    "View seller account": "Просмотреть аккаунт продавца",
    "listings.add_variant": "Добавить вариант",
    "Add variant": "Добавить вариант",
    "listings.edit": "Изменить",
    "listings.preview": "Предпросмотр",
    "listings.share": "Поделиться",
    "listings.view_listing": "Просмотреть объявление",
    "View listing": "Просмотреть объявление",
    "listings.stock": "Запасы",
    "listings.variants": "Варианты",
    "listings.campaign": "Кампания",
    "Campaign": "Кампания",
    "listings.rental_details": "Сведения об аренде",
    "Rental details": "Сведения об аренде",
    "listings.copy": "Копировать",
    "listings.inventory": "Запасы",
    "listings.order_type": "Тип заказа",
    "Order type": "Тип заказа",
    "listings.stock_by_location": "Запасы по местам хранения",
    "Stock by location": "Запасы по местам хранения",
    "listings.loading_location_stock": "Загрузка запасов по местам хранения…",
    "Loading location stock…": "Загрузка запасов по местам хранения…",
    "listings.no_location_stock": "Запасы не привязаны к месту хранения.",
    "No stock assigned to a location.": "Запасы не привязаны к месту хранения.",
    "listings.page_analytics": "Аналитика страницы",
    "Page analytics": "Аналитика страницы",
    "listings.loading": "Загрузка…",
    "listings.analytics_key_missing": "Для этого арендатора не настроен ключ API аналитики.",
    "Analytics API key is not configured for this tenant.": "Для этого арендатора не настроен ключ API аналитики.",
    "listings.no_slug": "Для этого объявления нет короткого адреса.",
    "No slug is available for this listing.": "Для этого объявления нет короткого адреса.",
    "listings.no_analytics": "Аналитика еще не загружена.",
    "listings.load_analytics": "Загрузить аналитику",
    "Load analytics": "Загрузить аналитику",
    "listings.no_orders": "Заказов на это объявление пока нет",
    "No orders yet for this listing": "Заказов на это объявление пока нет",
    "listings.social_ratings": "Соцсети и оценки",
    "Social and ratings": "Соцсети и оценки",
    "listings.tags": "Теги",
    "listings.schedule": "Расписание",
    "listings.detail": "Сведения",
    "listings.update_stock": "Обновить запасы",
    "Update stock": "Обновить запасы",
    "listings.new_stock_quantity": "Новое количество запасов",
    "New stock quantity": "Новое количество запасов",
    "listings.location": "Место хранения",
    "listings.quantity": "Количество",
    "listings.current_stock": "Текущий запас: {quantity}",
    "Current stock: {quantity}": "Текущий запас: {quantity}",
    "listings.loading_rental": "Загрузка настроек аренды…",
    "Loading rental settings…": "Загрузка настроек аренды…",
    "payments.enter_publishable_key": "Введите публичный ключ",
    "Enter publishable key": "Введите публичный ключ",
    "listings.add_listing": "Добавить объявление",
    "Add listing": "Добавить объявление",
    "listings.edit_listing": "Изменить объявление",
    "Edit listing": "Изменить объявление",
    "listings.enter_title": "Введите название",
    "listings.account": "Аккаунт",
    "listings.list_price": "Цена",
    "listings.enter_list_price": "Введите цену",
    "listings.select_currency": "Выберите валюту",
    "Select currency": "Выберите валюту",
    "listings.select_category": "Выберите категорию",
    "listings.select_categories": "Выберите категории",
    "Select categories": "Выберите категории",
    "listings.add_category": "+ Добавить категорию",
    "+ Add category": "+ Добавить категорию",
    "listings.add_attribute": "Добавить атрибут",
    "Add attribute": "Добавить атрибут",
    "listings.enter_stock": "Введите запас",
    "Enter stock": "Введите запас",
    "listings.offer_percentage": "Процент предложения",
    "Offer percentage": "Процент предложения",
    "listings.enter_offer": "Введите предложение",
    "Enter offer": "Введите предложение",
    "listings.max_quantity_optional": "Максимальное количество (необязательно)",
    "Max quantity (optional)": "Максимальное количество (необязательно)",
    "listings.enter_max_quantity": "Введите максимальное количество",
    "Enter max quantity": "Введите максимальное количество",
    "listings.enter_slug": "Введите короткий адрес",
    "listings.enter_meta_title": "Введите мета-заголовок",
    "listings.repeat": "Повтор",
    "Repeat": "Повтор",
    "listings.start_time": "Время начала",
    "Start time": "Время начала",
    "listings.end_time": "Время окончания",
    "End time": "Время окончания",
    "listings.slot": "Слот",
    "Slot": "Слот",
    "listings.starts_from": "Начало:",
    "Starts from:": "Начало:",
    "listings.add_schedule": "+ Добавить расписание",
    "+ Add schedule": "+ Добавить расписание",
    "listings.upload_here": "Загрузить сюда",
    "listings.save": "Сохранить",
    "listings.update": "Обновить",
    "listings.tax": "Налог",
    "listings.title_required": "Введите название",
    "Please enter a title": "Введите название",
    "listings.select_tax": "Выберите налог",
    "Please select a tax": "Выберите налог",
    "listings.select_item": "Выберите: {item}",
    "Please select {item}": "Выберите: {item}",
    "listings.offer_percentage_validation": "Процент предложения должен быть от 0 до 100",
    "Offer percentage must be between 0 and 100": "Процент предложения должен быть от 0 до 100",
    "listings.custom_seo": "Пользовательские настройки SEO",
    "Custom SEO": "Пользовательские настройки SEO",
    "listings.select_value": "Выберите значение",
    "Select value": "Выберите значение",
    "listings.add_schedule_title": "Добавить расписание",
    "Add schedule": "Добавить расписание",
    "listings.select_from_media": "Выбрать из медиафайлов",
    "listing_form.create_listing": "Создать объявление",
    "Create listing": "Создать объявление",
    "listing_form.update_listing": "Обновить объявление",
    "Update listing": "Обновить объявление",
    "listing_form.saving": "Сохранение…",
    "listing_form.main_information": "Основная информация",
    "Main information": "Основная информация",
    "listing_form.audio_listing": "Аудиообъявление",
    "Audio listing": "Аудиообъявление",
    "listing_form.basic_information": "Основные сведения",
    "Basic information": "Основные сведения",
    "listing_form.listing_type": "Тип объявления",
    "Listing type": "Тип объявления",
    "listing_form.title": "Название",
    "listing_form.enter_listing_title": "Введите название объявления",
    "Enter listing title": "Введите название объявления",
    "listing_form.description": "Описание",
    "listing_form.enter_detailed_description": "Введите подробное описание",
    "Enter detailed description": "Введите подробное описание",
    "listing_form.tags": "Теги",
    "listing_form.tag_example": "например: электроника, гаджеты, новое",
    "e.g., electronics, gadgets, new": "например: электроника, гаджеты, новое",
    "listing_form.taxes": "Налоги",
    "listing_form.optional": "Необязательно",
    "listing_form.start_date": "Дата начала",
    "listing_form.end_date": "Дата окончания",
    "listing_form.currency": "Валюта",
    "listing_form.select_currency": "Выберите валюту",
    "listing_form.goal_price": "Целевая сумма",
    "Goal price": "Целевая сумма",
    "listing_form.set_fundraising_goal": "Укажите цель сбора средств",
    "Set your fundraising goal": "Укажите цель сбора средств",
    "listing_form.pricing": "Цена",
    "listing_form.select": "Выбрать",
    "listing_form.price": "Цена",
    "listing_form.offer_percent": "Скидка, %",
    "Offer %": "Скидка, %",
    "listing_form.listing_price": "Цена объявления:",
    "Listing price:": "Цена объявления:",
    "listing_form.set_fundraising_goal_amount": "Укажите целевую сумму сбора средств",
    "Set your fundraising goal amount": "Укажите целевую сумму сбора средств",
    "listing_form.category": "Категория",
    "listing_form.select_a_category": "Выберите категорию",
    "Select a category": "Выберите категорию",
    "listing_form.clear_selected_category": "Очистить выбранную категорию",
    "Clear selected category": "Очистить выбранную категорию",
    "listing_form.create_new_category": "Создать категорию",
    "Create a new category": "Создать категорию",
    "listing_form.search_categories": "Поиск категорий…",
    "Search categories…": "Поиск категорий…",
    "listing_form.no_categories_match": "Категории не найдены",
    "No categories found": "Категории не найдены",
    "listing_form.draft_found": "Найден сохраненный черновик.",
    "A saved draft was found.": "Найден сохраненный черновик.",
    "listing_form.restore": "Восстановить",
    "Restore": "Восстановить",
    "listing_form.discard": "Отменить",
    "listing_form.characters": "символов",
    "characters": "символов",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Физические товары",
    "Physical products": "Физические товары",
    "listing_form.type_events": "Мероприятия",
    "listing_form.type_digital": "Цифровые товары",
    "Digital products": "Цифровые товары",
    "listing_form.type_appointments": "Запись на прием",
    "Appointments": "Запись на прием",
    "listing_form.type_rentals": "Аренда",
    "listing_form.type_donation": "Краудфандинг",
    "Crowdfunding": "Краудфандинг",
    "listing_form.type_information_listing": "Информация",
    "Information": "Информация",
    "listing_form.type_video_listing": "Видео",
    "listing_form.type_audio_listing": "Аудио",
    "listing_form.select_taxes": "Выберите налоги (необязательно)",
    "Select taxes (optional)": "Выберите налоги (необязательно)",
    "listing_form.no_taxes": "Нет доступных налогов",
    "No taxes available": "Нет доступных налогов",
    "listing_form.inventory_shipping": "Запасы и доставка",
    "Inventory & shipping": "Запасы и доставка",
    "listing_form.stock": "Запасы",
    "listing_form.weight": "Вес",
    "Weight": "Вес",
    "listing_form.dimensions": "Размеры (Д×Ш×В)",
    "Dimensions (L×W×H)": "Размеры (Д×Ш×В)",
    "listing_form.sku": "Артикул",
    "SKU": "Артикул",
    "listing_form.barcode": "Штрихкод",
    "Barcode": "Штрихкод",
    "listing_form.length": "Длина",
    "Length": "Длина",
    "listing_form.width": "Ширина",
    "Width": "Ширина",
    "listing_form.height": "Высота",
    "Height": "Высота",
    "listing_form.seo_settings": "Настройки SEO",
    "SEO settings": "Настройки SEO",
    "listing_form.slug": "Короткий адрес",
    "listing_form.url_friendly_title": "Версия названия для URL",
    "URL-friendly version of the title": "Версия названия для URL",
    "listing_form.meta_title": "Мета-заголовок",
    "listing_form.recommended_meta_title": "Рекомендуется: 50–60 символов",
    "Recommended: 50–60 chars": "Рекомендуется: 50–60 символов",
    "listing_form.meta_keywords": "Ключевые слова",
    "Meta keywords": "Ключевые слова",
    "listing_form.separate_with_commas": "Разделяйте запятыми",
    "Separate with commas": "Разделяйте запятыми",
    "listing_form.meta_description": "Мета-описание",
    "listing_form.recommended_meta_description": "Рекомендуется: 150–160 символов",
    "Recommended: 150–160 chars": "Рекомендуется: 150–160 символов",
    "listing_form.hide": "Скрыть",
    "listing_form.show": "Показать",
    "listing_form.seo_fields": "поля поисковой оптимизации",
    "search engine optimization fields": "поля поисковой оптимизации",
    "listing_form.auto_generated_slug": "Создается автоматически из названия",
    "Auto-generated from title": "Создается автоматически из названия",
    "listing_form.seo_title_optional": "Заголовок SEO (необязательно)",
    "SEO title (optional)": "Заголовок SEO (необязательно)",
    "listing_form.keywords_comma_separated": "Ключевые слова через запятую",
    "Keywords separated by commas": "Ключевые слова через запятую",
    "listing_form.search_description_optional": "Краткое описание для результатов поиска (необязательно)",
    "Brief description for search results (optional)": "Краткое описание для результатов поиска (необязательно)",
    "listing_form.account": "Аккаунт",
    "listing_form.loading_accounts": "Загрузка аккаунтов…",
    "Loading accounts…": "Загрузка аккаунтов…",
    "listing_form.clear_selected_account": "Снять выбор аккаунта",
    "Clear selected account": "Снять выбор аккаунта",
    "listing_form.search_accounts": "Поиск аккаунтов…",
    "Search accounts…": "Поиск аккаунтов…",
    "listing_form.create_account": "Создать аккаунт",
    "Create a new account": "Создать аккаунт",
    "listing_form.no_accounts_found": "Аккаунты не найдены",
    "No accounts found": "Аккаунты не найдены",
    "listing_form.rental_settings": "Настройки аренды",
    "Rental settings": "Настройки аренды",
    "listing_form.rental_price_help": "Цена объявления рассчитывается на основе ставки аренды и ее продолжительности.",
    "The listing price is calculated from the rental rate and duration.": "Цена объявления рассчитывается на основе ставки аренды и ее продолжительности.",
    "listing_form.rate_unit": "Единица тарифа",
    "Rate unit": "Единица тарифа",
    "listing_form.hour": "Час",
    "Hour": "Час",
    "listing_form.day": "День",
    "listing_form.week": "Неделя",
    "listing_form.rental_rate_amount": "Ставка аренды",
    "Rental rate": "Ставка аренды",
    "listing_form.rental_min_duration": "Минимальная продолжительность",
    "Minimum duration": "Минимальная продолжительность",
    "listing_form.rental_max_duration": "Максимальная продолжительность",
    "Maximum duration": "Максимальная продолжительность",
    "listing_form.rental_buffer_time": "Буферное время (часы)",
    "Buffer time (hours)": "Буферное время (часы)",
    "listing_form.rental_deposit_amount": "Сумма залога",
    "Deposit amount": "Сумма залога",
    "listing_form.rental_max_units": "Максимальное количество единиц",
    "Maximum units": "Максимальное количество единиц",
    "listing_form.quick_create_title": "Создать: {entity}",
    "Create {entity}": "Создать: {entity}",
    "listing_form.close": "Закрыть",
    "listing_form.account_name": "Название аккаунта",
    "listing_form.category_name": "Название категории",
    "Category name": "Название категории",
    "listing_form.account_example": "например: магазин Acme",
    "e.g. Acme Store": "например: магазин Acme",
    "listing_form.category_example": "например: свежие продукты",
    "e.g. Fresh Produce": "например: свежие продукты",
    "listing_form.creating": "Создание…",
    "listing_form.create_entity": "Создать: {entity}",
    "listing_form.cancel": "Отмена",
    "listing_form.go_back": "Назад",
    "Go back": "Назад",
    "listing_form.upgrade_plan": "Улучшить тариф",
    "Upgrade plan": "Улучшить тариф",
    "listing_form.close_upgrade_dialog": "Закрыть окно обновления тарифа",
    "Close upgrade dialog": "Закрыть окно обновления тарифа",
    "listing_form.loading_attributes": "Загрузка атрибутов…",
    "Loading attributes…": "Загрузка атрибутов…",
    "listing_form.no_attributes": "Для этой категории нет атрибутов",
    "No attributes for this category": "Для этой категории нет атрибутов",
    "listing_form.unsupported_field_type": "Неподдерживаемый тип поля",
    "Unsupported field type": "Неподдерживаемый тип поля",
    "listing_form.delete_schedule_confirm": "Удалить это расписание?",
    "Are you sure you want to delete this schedule?": "Удалить это расписание?",
    "listing_form.no_schedules_added": "Расписание еще не добавлено",
    "No schedules added yet": "Расписание еще не добавлено",
    "listing_form.stock_label": "Запас:",
    "Stock:": "Запас:",
    "listing_form.active": "Активно",
    "listing_form.inactive": "Неактивно",
    "listing_form.edit": "Изменить",
    "listing_form.delete": "Удалить",
    "listing_form.schedules": "Расписания",
    "Schedules": "Расписания",
    "listing_form.no_schedules_yet": "Расписания пока нет",
    "No schedules yet": "Расписания пока нет",
    "listing_form.dates_label": "Даты:",
    "Dates:": "Даты:",
    "listing_form.time_label": "Время:",
    "Time:": "Время:",
    "listing_form.repeat_label": "Повтор:",
    "Repeat:": "Повтор:",
    "listing_form.capacity_label": "Вместимость:",
    "Capacity:": "Вместимость:",
    "listing_form.edit_schedule": "Изменить расписание",
    "Edit schedule": "Изменить расписание",
    "listing_form.add_new_schedule": "Добавить расписание",
    "Add new schedule": "Добавить расписание",
    "listing_form.repeat_pattern": "Периодичность",
    "Repeat pattern": "Периодичность",
    "listing_form.select_days": "Выберите дни",
    "Select days": "Выберите дни",
    "listing_form.total_stocks_capacity": "Общий запас (вместимость)",
    "Total stock (capacity)": "Общий запас (вместимость)",
    "listing_form.select_at_least_one_day": "Выберите хотя бы один день",
    "Please select at least one day": "Выберите хотя бы один день",
    "listing_form.unlimited_capacity_help": "Оставьте пустым для неограниченной вместимости",
    "Leave empty for unlimited capacity": "Оставьте пустым для неограниченной вместимости",
    "listing_form.add_schedule": "+ Добавить расписание",
    "listing_form.schedule_number": "Расписание №{number}",
    "Schedule #{number}": "Расписание №{number}",
    "listing_form.update_action": "обновить",
    "update": "обновить",
    "listing_form.create_action": "создать",
    "create": "создать",
    "listing_form.a_schedule": "расписание",
    "a schedule": "расписание",
    "listing_form.daily": "Ежедневно",
    "Daily": "Ежедневно",
    "listing_form.weekdays": "По будням (пн–пт)",
    "Weekdays (Mon - Fri)": "По будням (пн–пт)",
    "listing_form.weekend": "Выходные (сб–вс)",
    "Weekend (Sat - Sun)": "Выходные (сб–вс)",
    "listing_form.custom": "Настроить",
    "listing_form.weekday_0": "Понедельник",
    "Monday": "Понедельник",
    "listing_form.weekday_1": "Вторник",
    "Tuesday": "Вторник",
    "listing_form.weekday_2": "Среда",
    "Wednesday": "Среда",
    "listing_form.weekday_3": "Четверг",
    "Thursday": "Четверг",
    "listing_form.weekday_4": "Пятница",
    "Friday": "Пятница",
    "listing_form.weekday_5": "Суббота",
    "Saturday": "Суббота",
    "listing_form.weekday_6": "Воскресенье",
    "Sunday": "Воскресенье",
    "listing_form.media_max_files": "Максимум: {count} — {type}",
    "Maximum {count} {type} allowed": "Максимум: {count} — {type}",
    "listing_form.video_size_limit": "Размер каждого видео не должен превышать 1 ГБ",
    "Each video must be 1GB or smaller": "Размер каждого видео не должен превышать 1 ГБ",
    "listing_form.videos": "Видео",
    "Videos": "Видео",
    "listing_form.images": "Изображения",
    "listing_form.select_from_media": "Выбрать из медиафайлов",
    "listing_form.video_upload_help": "Загрузите видео в формате MP4, MOV, AVI, MKV или WebM (до 1 ГБ каждое)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Загрузите видео в формате MP4, MOV, AVI, MKV или WebM (до 1 ГБ каждое)",
    "listing_form.image_upload_help": "Загрузите изображения в формате JPG, PNG, GIF или WebP (до 10 МБ каждое)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Загрузите изображения в формате JPG, PNG, GIF или WebP (до 10 МБ каждое)",
    "listing_form.uploading_video": "Загрузка видео…",
    "Uploading video…": "Загрузка видео…",
    "listing_form.audio_episode": "Аудиоэпизод",
    "listing_form.audio_upload_help": "Загрузите аудиофайл или вставьте общедоступную ссылку для RSS-ленты.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Загрузите аудиофайл или вставьте общедоступную ссылку для RSS-ленты.",
    "listing_form.selected_file": "Выбрано: {name}",
    "listing_form.audio_url_help": "Если выбран файл, URL необязателен. Оставьте поле пустым, чтобы использовать загруженный файл.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "Если выбран файл, URL необязателен. Оставьте поле пустым, чтобы использовать загруженный файл.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Загрузка аудио…",
    "Uploading audio…": "Загрузка аудио…",
    "listing_form.validation_start_date": "Выберите дату начала",
    "Please select start date": "Выберите дату начала",
    "listing_form.validation_end_date": "Выберите дату окончания",
    "Please select end date": "Выберите дату окончания",
    "listing_form.validation_start_time": "Выберите время начала",
    "Please select start time": "Выберите время начала",
    "listing_form.validation_end_time": "Выберите время окончания",
    "Please select end time": "Выберите время окончания",
    "listing_form.weekdays_short": "Будни",
    "Weekdays": "Будни",
    "listing_form.weekend_short": "Выходные",
    "Weekend": "Выходные",
    "listing_form.click_add_schedule_help": "Нажмите «{action}», чтобы создать первое расписание",
    "Click \"{action}\" to create your first schedule": "Нажмите «{action}», чтобы создать первое расписание",
    "listing_form.schedule_form_intro": "Заполните следующие сведения, чтобы",
    "Fill in the details below to": "Заполните следующие сведения, чтобы",
    "listing_form.update": "Обновить",
    "listing_form.save": "Сохранить",
    "listing_form.variant_value_required": "Выберите хотя бы одно значение варианта (например, цвет или размер)",
    "Please select at least one variant value (e.g., Color, Size)": "Выберите хотя бы одно значение варианта (например, цвет или размер)",
    "listing_form.valid_price_required": "Введите корректную цену",
    "Please enter a valid price": "Введите корректную цену",
    "listing_form.delete_variant_confirm": "Удалить этот вариант?",
    "listing_form.product_variants": "Варианты товара",
    "Product Variants": "Варианты товара",
    "listing_form.add_variant": "+ Добавить вариант",
    "+ Add Variant": "+ Добавить вариант",
    "listing_form.select_all_variants": "Выбрать все варианты",
    "Select all variants": "Выбрать все варианты",
    "listing_form.set_quantity_selected": "Указать количество для выбранных",
    "Set quantity for selected": "Указать количество для выбранных",
    "listing_form.quantity": "Количество",
    "listing_form.apply_quantity": "Применить количество",
    "Apply quantity": "Применить количество",
    "listing_form.select_variant_number": "Выберите вариант {number}",
    "Select variant {number}": "Выберите вариант {number}",
    "listing_form.variant_number": "Вариант №{number}",
    "Variant #{number}": "Вариант №{number}",
    "listing_form.existing": "Существующий",
    "Existing": "Существующий",
    "listing_form.modified": "Изменен",
    "Modified": "Изменен",
    "listing_form.variant_name": "Название варианта",
    "Variant Name": "Название варианта",
    "listing_form.variant_values": "Значения вариантов",
    "Variant Values": "Значения вариантов",
    "listing_form.type": "Тип",
    "listing_form.no_variant_values": "Нет значений вариантов",
    "No variant values": "Нет значений вариантов",
    "listing_form.no_variants_yet": "Вариантов пока нет",
    "No variants yet": "Вариантов пока нет",
    "listing_form.click_add_variant_help": "Нажмите «{action}», чтобы создать первый вариант",
    "Click \"{action}\" to create your first variant": "Нажмите «{action}», чтобы создать первый вариант",
    "listing_form.select_variant_type": "Выберите: {type}",
    "Select {type}": "Выберите: {type}",
    "listing_form.no_variant_types": "Нет типов вариантов. Сначала создайте типы, например «Цвет» или «Размер».",
    "No variant types available. Please create variant types (like Color, Size) first.": "Нет типов вариантов. Сначала создайте типы, например «Цвет» или «Размер».",
    "listing_form.generated_name": "Созданное название:",
    "Generated Name:": "Созданное название:",
    "listing_form.custom_title": "Пользовательский заголовок",
    "Custom Title": "Пользовательский заголовок",
    "listing_form.auto_generate_help": "Оставьте пустым для автоматического создания",
    "Leave blank to auto-generate": "Оставьте пустым для автоматического создания",
    "listing_form.save_variant": "Сохранить вариант",
    "Save Variant": "Сохранить вариант",
    "listing_form.start_time": "Время начала",
    "Start Time": "Время начала",
    "listing_form.end_time": "Время окончания",
    "End Time": "Время окончания",
    "listing_form.enter_capacity_limit": "Введите ограничение вместимости",
    "Enter capacity limit": "Введите ограничение вместимости",
    "collections.validation_title": "Заголовок не должен быть пустым",
    "Title should not be empty": "Заголовок не должен быть пустым",
    "collections.validation_platform": "Выберите хотя бы одну платформу",
    "Select at least one platform": "Выберите хотя бы одну платформу",
    "collections.validation_dates": "Дата окончания должна быть позже даты начала",
    "End Date must be later than start date": "Дата окончания должна быть позже даты начала",
    "collections.validation_minimum_selection": "Выберите хотя бы один вариант: {type}",
    "Select at least one {type}": "Выберите хотя бы один вариант: {type}",
    "collections.account": "аккаунт",
    "account": "аккаунт",
    "collections.listing": "объявление",
    "listing": "объявление",
    "collections.edit_title": "Изменить подборку",
    "Edit Collection": "Изменить подборку",
    "collections.create_title": "Создать подборку",
    "collections.details": "Сведения о подборке",
    "Collection details": "Сведения о подборке",
    "collections.title_placeholder": "Введите название",
    "Enter title name": "Введите название",
    "collections.slug": "Короткий адрес",
    "collections.slug_placeholder": "Введите короткий адрес",
    "collections.enter_title_first": "Сначала введите название",
    "collections.scope": "Область",
    "collections.accounts": "Аккаунты",
    "collections.listings": "Объявления",
    "collections.choose_category": "Выберите категорию",
    "collections.conditions": "Условия",
    "Conditions": "Условия",
    "collections.condition_type": "Тип условия",
    "Condition type": "Тип условия",
    "collections.manual": "Вручную",
    "Manual": "Вручную",
    "collections.automated": "Автоматически",
    "Automated": "Автоматически",
    "collections.availability": "Доступность подборки",
    "Collections availability": "Доступность подборки",
    "collections.schedule": "Расписание",
    "collections.applicable_channels": "Выберите канал",
    "Select applicable channel": "Выберите канал",
    "collections.web": "Веб",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Поиск по названию",
    "Search by name": "Поиск по названию",
    "collections.not_found": "Подборка не найдена.",
    "Collection not found.": "Подборка не найдена.",
    "collections.featured_listings": "Рекомендуемые объявления",
    "Featured listings": "Рекомендуемые объявления",
    "collections.url_copied": "Публичная ссылка скопирована",
    "Public URL copied": "Публичная ссылка скопирована",
    "collections.url_copy_failed": "Не удалось скопировать публичную ссылку",
    "Unable to copy the public URL": "Не удалось скопировать публичную ссылку",
    "collections.collection": "Подборка",
    "Collection": "Подборка",
    "collections.this_collection": "эту подборку",
    "this collection": "эту подборку",
    "collections.share_text": "Просмотреть: {title}",
    "View {title}": "Просмотреть: {title}",
    "collections.public_url": "Публичный URL:",
    "Public URL:": "Публичный URL:",
    "collections.copy_url": "Копировать URL",
    "Copy URL": "Копировать URL",
    "collections.items": "Элементы",
    "collections.expires": "Срок действия",
    "collections.never": "Никогда",
    "Never": "Никогда",
    "collections.automatic_conditions": "Автоматические условия",
    "Automatic Conditions": "Автоматические условия",
    "collections.item_count": "Элементов: {count}",
    "{count} items": "Элементов: {count}",
    "collections.loading_items": "Загрузка элементов…",
    "Loading items…": "Загрузка элементов…",
    "collections.no_items": "В этой подборке пока нет элементов.",
    "No items in this collection yet.": "В этой подборке пока нет элементов.",
    "collections.delete_confirm": "Удалить эту подборку?",
    "Do you want to delete this collection?": "Удалить эту подборку?",
    "collections.title": "Подборки",
    "collections.header_title": "Название",
    "collections.header_action": "Действие",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Тип условия",
    "Condition Type": "Тип условия",
    "collections.header_scope": "Область",
    "collections.header_start_date": "Дата начала",
    "collections.header_end_date": "Дата окончания",
    "collections.header_status": "Статус",
    "collections.header_url": "URL",
    "common.calendar_view": "Вид календаря",
    "Calendar view": "Вид календаря",
    "common.deleted": "Удалено",
    "Deleted": "Удалено",
    "common.list_view": "Вид списком",
    "common.description": "Описание",
    "common.title": "Название",
    "common.end_date": "Дата окончания",
    "common.start_date": "Дата начала",
    "promotions.image_required": "Добавьте изображение",
    "Please add an image": "Добавьте изображение",
    "promotions.edit_title": "Изменить акцию",
    "Edit Promotion": "Изменить акцию",
    "promotions.add_title": "Добавить акцию",
    "Add Promotion": "Добавить акцию",
    "promotions.name": "Название акции",
    "Promotion Name": "Название акции",
    "promotions.select_medium": "Выберите тип медиа",
    "Select Medium": "Выберите тип медиа",
    "promotions.upload_media": "Загрузить медиафайл",
    "promotions.schedule": "Расписание",
    "promotions.destination_type": "Тип назначения",
    "Destination Type": "Тип назначения",
    "promotions.placement": "Размещение",
    "Placement": "Размещение",
    "promotions.status": "Статус (неактивна / активна)",
    "promotions.delete_confirm": "Удалить эту акцию?",
    "Do you want to delete this promotion?": "Удалить эту акцию?",
    "promotions.title": "Акции",
    "promotions.header_image": "Изображение",
    "promotions.header_medium": "Тип медиа",
    "promotions.header_placement": "Размещение",
    "promotions.header_type": "Тип",
    "promotions.header_value": "Значение",
    "promotions.header_active": "Активна",
    "promotions.header_action": "Действие",
    "promotions.header_start_at": "Начало",
    "Start At": "Начало",
    "promotions.header_end_at": "Окончание",
    "End At": "Окончание",
    "common.grid_view": "Вид сеткой",
    "promotions.type_general": "Общее",
    "promotions.type_listing": "Объявление",
    "promotions.type_account": "Аккаунт",
    "promotions.type_external_link": "Внешняя ссылка",
    "External link": "Внешняя ссылка",
    "promotions.preview": "Предпросмотр",
    "promotions.select_listing": "Выберите объявление",
    "Select Listing": "Выберите объявление",
    "promotions.select_account": "Выберите аккаунт",
    "promotions.home_placement": "Главная",
    "promotions.footer_placement": "Нижняя часть",
    "promotions.web_only": "(только веб)",
    "(Web Only)": "(только веб)",
    "coupons.edit_title": "Изменить купон",
    "Edit Coupon": "Изменить купон",
    "coupons.add_title": "Добавить купон",
    "Add Coupon": "Добавить купон",
    "coupons.reference_name": "Название для ссылки",
    "Reference Name": "Название для ссылки",
    "coupons.enter_name": "Введите название",
    "coupons.coupon_type": "Тип купона",
    "Coupon type": "Тип купона",
    "coupons.discount_value": "Размер скидки",
    "Discount Value": "Размер скидки",
    "coupons.enter_discount_value": "Введите размер скидки",
    "Enter discount value": "Введите размер скидки",
    "coupons.code": "Код",
    "coupons.code_example": "Например: HOLIDAY10",
    "Ex: HOLIDAY10": "Например: HOLIDAY10",
    "coupons.short_code": "Краткий код",
    "coupons.enter_short_code": "Введите краткий код",
    "coupons.advanced": "ДОПОЛНИТЕЛЬНО",
    "ADVANCED": "ДОПОЛНИТЕЛЬНО",
    "coupons.minimum_amount": "Минимальная сумма",
    "coupons.enter_minimum_amount": "Введите минимальную сумму",
    "coupons.maximum_amount": "Максимальная сумма",
    "coupons.enter_maximum_amount": "Введите максимальную сумму",
    "coupons.maximum_discount_amount": "Максимальная сумма скидки",
    "Maximum Discount Amount": "Максимальная сумма скидки",
    "coupons.enter_maximum_discount_amount": "Введите максимальную сумму скидки",
    "Enter maximum discount amount": "Введите максимальную сумму скидки",
    "coupons.maximum_uses": "Максимальное число применений",
    "Maximum Uses": "Максимальное число применений",
    "coupons.enter_maximum_uses": "Введите максимальное число применений",
    "Enter maximum uses": "Введите максимальное число применений",
    "coupons.maximum_uses_per_user": "Максимум применений на пользователя",
    "Maximum Uses Per User": "Максимум применений на пользователя",
    "coupons.enter_maximum_uses_per_user": "Введите максимум применений на пользователя",
    "Enter maximum uses per user": "Введите максимум применений на пользователя",
    "coupons.new_user_only": "Только для новых пользователей",
    "New User": "Только для новых пользователей",
    "coupons.enter_note": "Введите примечание",
    "coupons.start_date_time": "Дата и время начала",
    "Start Date Time": "Дата и время начала",
    "coupons.end_date_time": "Дата и время окончания",
    "End Date Time": "Дата и время окончания",
    "coupons.select_start_date_time": "Выберите дату и время начала",
    "Select start date time": "Выберите дату и время начала",
    "coupons.select_end_date_time": "Выберите дату и время окончания",
    "Select end date time": "Выберите дату и время окончания",
    "coupons.flat_example": "Фиксированная (например: 10 $)",
    "Flat (Ex: $10)": "Фиксированная (например: 10 $)",
    "coupons.percentage_example": "Процент (например: 10%)",
    "Percentage (Ex: 10%)": "Процент (например: 10%)",
    "coupons.delete_confirm": "Удалить этот купон?",
    "Do you want to delete this coupon?": "Удалить этот купон?",
    "coupons.title": "Купоны",
    "coupons.header_name": "Название",
    "coupons.header_code": "Код",
    "coupons.header_coupon_type": "Тип купона",
    "Coupon Type": "Тип купона",
    "coupons.header_start_date_time": "Дата и время начала",
    "coupons.header_end_date_time": "Дата и время окончания",
    "coupons.header_active": "Активен",
    "coupons.header_action": "Действие",
    "coupons.load_error": "Не удалось загрузить этот купон.",
    "Unable to load this coupon.": "Не удалось загрузить этот купон.",
    "coupons.expired": "Истек",
    "coupons.total_orders": "Всего заказов",
    "coupons.unique_customers": "Уникальные клиенты",
    "Unique Customers": "Уникальные клиенты",
    "coupons.revenue": "Доход",
    "coupons.average_transaction": "Средняя транзакция",
    "Avg Transaction": "Средняя транзакция",
    "coupons.paid_orders": "Оплаченные заказы",
    "coupons.uses_remaining": "Осталось применений",
    "Uses Remaining": "Осталось применений",
    "coupons.unlimited": "Без ограничений",
    "Unlimited": "Без ограничений",
    "coupons.performance": "Эффективность",
    "Performance": "Эффективность",
    "coupons.usage_against_limit": "Использование относительно лимита",
    "Usage against limit": "Использование относительно лимита",
    "coupons.details": "Сведения",
    "coupons.discount": "Скидка",
    "coupons.minimum_order": "Мин. заказ",
    "Min order": "Мин. заказ",
    "coupons.maximum_discount": "Макс. скидка",
    "Max discount": "Макс. скидка",
    "coupons.maximum_total_uses": "Максимум применений всего",
    "Max total uses": "Максимум применений всего",
    "coupons.maximum_per_user": "Макс. на пользователя",
    "Max / user": "Макс. на пользователя",
    "coupons.new_users_only": "Только для новых пользователей",
    "New users only": "Только для новых пользователей",
    "coupons.valid_from": "Действует с",
    "Valid from": "Действует с",
    "coupons.valid_until": "Действует до",
    "Valid until": "Действует до",
    "coupons.orders": "Заказы",
    "coupons.no_orders": "Этот купон еще не использовался в заказах",
    "No orders have used this coupon yet": "Этот купон еще не использовался в заказах",
    "coupons.orders_header_order": "Заказ",
    "coupons.orders_header_customer": "Клиент",
    "coupons.orders_header_date": "Дата",
    "coupons.orders_header_amount": "Сумма",
    "coupons.orders_header_status": "Статус",
    "coupons.paid": "Оплачено",
    "coupons.pending": "Ожидает",
    "coupons.coupon": "Купон",
    "coupons.detail_title": "Сведения о купоне",
    "Coupon Detail": "Сведения о купоне",
    "coupons.discount_percentage": "Скидка {value}%",
    "{value}% off": "Скидка {value}%",
    "coupons.discount_flat": "Фиксированная скидка {value}",
    "{value} flat off": "Фиксированная скидка {value}",
    "coupons.type_direct_discount": "Прямая скидка",
    "Direct discount": "Прямая скидка",
    "collections.condition_and": "И",
    "AND": "И",
    "collections.condition_or": "ИЛИ",
    "OR": "ИЛИ",
    "users.first_seen": "Впервые замечен",
    "First seen": "Впервые замечен",
    "users.last_seen": "Последний раз замечен",
    "Last seen": "Последний раз замечен",
    "users.avg_order": "Средний заказ",
    "Avg order": "Средний заказ",
    "users.purchase_value": "Сумма покупок",
    "Purchase value": "Сумма покупок",
    "users.price_range": "Диапазон цен",
    "Price range": "Диапазон цен",
    "users.attributes": "Атрибуты",
    "users.detail_title": "Сведения о пользователе",
    "User Detail": "Сведения о пользователе",
    "users.detail_orders_list": "Список заказов пользователя",
    "User Orders List": "Список заказов пользователя",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "Как покупатель",
    "As a Buyer": "Как покупатель",
    "users.as_seller": "Как продавец",
    "As a Seller": "Как продавец",
    "users.health": "Состояние",
    "users.no_listings": "Объявлений пока нет",
    "users.no_accounts": "Аккаунтов пока нет",
    "No accounts yet": "Аккаунтов пока нет",
    "users.top_categories": "Популярные категории",
    "Top categories": "Популярные категории",
    "users.top_listings": "Популярные объявления",
    "Top listings": "Популярные объявления",
    "users.recent_activity": "Недавняя активность",
    "Recent activity": "Недавняя активность",
    "users.acquisition": "Привлечение",
    "Acquisition": "Привлечение",
    "users.sent_emails": "Отправленные письма",
    "Sent Emails": "Отправленные письма",
    "users.no_emails_sent": "Письма не отправлялись",
    "No emails sent": "Письма не отправлялись",
    "users.load_more_emails": "Загрузить еще ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Загрузить еще ({loaded} / {total})",
    "users.email_to": "Кому: {email}",
    "To: {email}": "Кому: {email}",
    "users.sending_email": "Отправка…",
    "users.send_email": "Отправить письмо",
    "Send Email": "Отправить письмо",
    "users.send_email_title": "Отправить письмо — {name}",
    "Send Email — {name}": "Отправить письмо — {name}",
    "users.customer": "Клиент",
    "users.block_named": "Заблокировать {name}",
    "Block {name}": "Заблокировать {name}",
    "users.unblock_named": "Разблокировать {name}",
    "Unblock {name}": "Разблокировать {name}",
    "users.email_sent": "Письмо успешно отправлено",
    "Email sent successfully": "Письмо успешно отправлено",
    "users.email_send_failed": "Не удалось отправить письмо",
    "Failed to send email": "Не удалось отправить письмо",
    "common.value": "Значение",
    "users.email_bounced": "Возврат письма",
    "Bounced": "Возврат письма",
    "users.email_complained": "Жалоба на письмо",
    "Complained": "Жалоба на письмо",
    "users.unverified": "Не подтвержден",
    "Unverified": "Не подтвержден",
    "users.otp_enabled": "Одноразовый код включен",
    "OTP Enabled": "Одноразовый код включен",
    "users.account_info": "Информация об аккаунте",
    "Account Info": "Информация об аккаунте",
    "users.mobile": "Мобильный телефон",
    "users.locale": "Язык и регион",
    "Locale": "Язык и регион",
    "users.joined": "Дата регистрации",
    "users.following": "Подписки",
    "Following": "Подписки",
    "users.email_health": "Состояние электронной почты",
    "Email Health": "Состояние электронной почты",
    "users.orders": "Заказы",
    "users.no_orders": "Заказов нет",
    "No orders": "Заказов нет",
    "users.order_reference": "Заказ {number}",
    "Order {number}": "Заказ {number}",
    "users.order_ref": "Ссылка: {reference}",
    "Ref: {reference}": "Ссылка: {reference}",
    "users.unpaid": "Не оплачен",
    "users.revenue_ltv": "Доход и LTV",
    "Revenue & LTV": "Доход и LTV",
    "users.total_spent": "Всего потрачено",
    "Total Spent": "Всего потрачено",
    "users.paid_order_count": "Оплаченных заказов: {count}",
    "{count} paid orders": "Оплаченных заказов: {count}",
    "users.average_order": "Средний заказ",
    "users.of_total_orders": "из заказов: {count}",
    "of {count} total": "из заказов: {count}",
    "users.gmv": "Общий объем продаж",
    "GMV": "Общий объем продаж",
    "users.active_count": "Активных: {count}",
    "{count} active": "Активных: {count}",
    "users.at_risk": "Под угрозой оттока",
    "At Risk": "Под угрозой оттока",
    "common.today": "Сегодня",
    "common.yesterday": "Вчера",
    "Yesterday": "Вчера",
    "users.days_ago": "{count} дней назад",
    "{count} days ago": "{count} дней назад",
    "users.months_ago": "{count} месяцев назад",
    "{count} months ago": "{count} месяцев назад",
    "users.years_ago": "{count} лет назад",
    "{count} years ago": "{count} лет назад",
    "users.last_order": "Последний заказ",
    "Last order": "Последний заказ",
    "users.last_listing": "Последнее объявление",
    "Last listing": "Последнее объявление",
    "users.events": "События",
    "users.viewed": "Просмотрено",
    "Viewed": "Просмотрено",
    "users.cart": "Корзина",
    "users.checkouts": "Оформления заказа",
    "Checkouts": "Оформления заказа",
    "users.purchases": "Покупки",
    "Purchases": "Покупки",
    "users.last_30_days": "Последние 30 дней",
    "Last 30 days": "Последние 30 дней",
    "users.no_analytics": "Для этого пользователя пока нет аналитических данных.",
    "No analytics data for this user yet.": "Для этого пользователя пока нет аналитических данных.",
    "users.analytics_unavailable": "Аналитика недоступна для этого арендатора.",
    "Analytics unavailable for this tenant.": "Аналитика недоступна для этого арендатора.",
    "users.account_number": "Аккаунт №{number}",
    "Account #{number}": "Аккаунт №{number}",
    "users.no_subject": "Без темы",
    "No Subject": "Без темы",
    "common.unknown": "Неизвестно",
    "users.opened": "Открыто",
    "Opened": "Открыто",
    "users.not_opened": "Не открыто",
    "Not opened": "Не открыто",
    "users.user_action_success": "Действие с пользователем выполнено",
    "User action completed": "Действие с пользователем выполнено",
    "common.pending": "Ожидает",
    "common.never": "Никогда",
    "users.customer_analytics": "Аналитика клиентов",
    "Customer Analytics": "Аналитика клиентов",
    "users.analytics": "Аналитика",
    "users.emails": "Письма",
    "Emails": "Письма",
    "users.first_visit": "Первый визит",
    "First visit": "Первый визит",
    "users.latest_visit": "Последний визит",
    "Latest visit": "Последний визит",
    "users.landing_page": "Целевая страница",
    "Landing page": "Целевая страница",
    "users.referrer": "Источник перехода",
    "Referrer": "Источник перехода",
    "users.utm_source": "Источник UTM",
    "UTM source": "Источник UTM",
    "users.utm_medium": "Канал UTM",
    "UTM medium": "Канал UTM",
    "users.utm_campaign": "Кампания UTM",
    "UTM campaign": "Кампания UTM",
    "users.utm_term": "Термин UTM",
    "UTM term": "Термин UTM",
    "users.utm_content": "Содержание UTM",
    "UTM content": "Содержание UTM",
    "users.ai_source": "Источник ИИ",
    "AI source": "Источник ИИ",
    "rewards.edit_scope": "Изменить область",
    "Edit scope": "Изменить область",
    "rewards.add_scope": "Добавить область",
    "Add scope": "Добавить область",
    "rewards.save_scope": "Сохранить область",
    "Save scope": "Сохранить область",
    "rewards.scope_type": "Тип области",
    "Scope type": "Тип области",
    "rewards.scope_reference": "Ссылка на область",
    "Scope reference": "Ссылка на область",
    "rewards.match_config": "Настройка соответствия",
    "Match config": "Настройка соответствия",
    "rewards.priority_order": "Порядок приоритета",
    "Priority order": "Порядок приоритета",
    "rewards.active": "Активно",
    "rewards.scope_active": "Область активна",
    "Scope is active": "Область активна",
    "rewards.edit_rule": "Изменить правило",
    "Edit rule": "Изменить правило",
    "rewards.add_rule": "Добавить правило",
    "Add rule": "Добавить правило",
    "rewards.save_rule": "Сохранить правило",
    "Save rule": "Сохранить правило",
    "rewards.trigger_event": "Событие-триггер",
    "Trigger event": "Событие-триггер",
    "rewards.beneficiary_type": "Тип получателя",
    "Beneficiary type": "Тип получателя",
    "rewards.beneficiary_config": "Настройка получателя",
    "Beneficiary config": "Настройка получателя",
    "rewards.eligibility": "Право на участие",
    "Eligibility": "Право на участие",
    "rewards.conditions": "Условия",
    "rewards.priority": "Приоритет",
    "Priority": "Приоритет",
    "rewards.edit_component": "Изменить компонент рецепта",
    "Edit recipe component": "Изменить компонент рецепта",
    "rewards.add_component": "Добавить компонент рецепта",
    "Add recipe component": "Добавить компонент рецепта",
    "rewards.save_component": "Сохранить компонент",
    "Save component": "Сохранить компонент",
    "rewards.rule": "Правило",
    "Rule": "Правило",
    "rewards.component_key": "Ключ компонента",
    "Component key": "Ключ компонента",
    "rewards.component_type": "Тип компонента",
    "Component type": "Тип компонента",
    "rewards.commission_definition": "Определение комиссии",
    "Commission definition": "Определение комиссии",
    "rewards.config": "Настройка",
    "rewards.position": "Позиция",
    "Position": "Позиция",
    "rewards.component": "Компонент",
    "Component": "Компонент",
    "rewards.status.draft": "Черновик",
    "rewards.status.active": "Активно",
    "rewards.status.paused": "Приостановлено",
    "Paused": "Приостановлено",
    "rewards.status.archived": "В архиве",
    "rewards.configuration_updated": "Настройки вознаграждений обновлены",
    "Reward configuration updated": "Настройки вознаграждений обновлены",
    "rewards.configuration_added": "Настройки вознаграждений добавлены",
    "Reward configuration added": "Настройки вознаграждений добавлены",
    "rewards.archive_item_confirm": "Архивировать {name}?",
    "rewards.empty_scopes": "Области еще не настроены.",
    "No scopes configured yet.": "Области еще не настроены.",
    "rewards.empty_rules": "Правила еще не настроены.",
    "No rules configured yet.": "Правила еще не настроены.",
    "rewards.empty_components": "Компоненты еще не настроены.",
    "No components configured yet.": "Компоненты еще не настроены.",
    "rewards.edit_program": "Изменить программу вознаграждений",
    "Edit reward program": "Изменить программу вознаграждений",
    "rewards.new_program": "Новая программа вознаграждений",
    "New reward program": "Новая программа вознаграждений",
    "rewards.create_program": "Создать программу",
    "Create program": "Создать программу",
    "rewards.program_type": "Тип программы",
    "Program type": "Тип программы",
    "rewards.starts_at": "Начало",
    "Starts at": "Начало",
    "rewards.ends_at": "Окончание",
    "Ends at": "Окончание",
    "rewards.program_updated": "Программа вознаграждений обновлена",
    "Reward program updated": "Программа вознаграждений обновлена",
    "rewards.program_created": "Программа вознаграждений создана",
    "Reward program created": "Программа вознаграждений создана",
    "rewards.archive_program_confirm": "Архивировать {name}?",
    "rewards.program_archived": "Программа вознаграждений архивирована",
    "Reward program archived": "Программа вознаграждений архивирована",
    "rewards.tab.overview": "Обзор",
    "rewards.tab.programs": "Программы",
    "Programs": "Программы",
    "rewards.tab.impact": "Эффективность",
    "Impact": "Эффективность",
    "rewards.tab.attribution": "Отслеживание",
    "Tracking": "Отслеживание",
    "rewards.page_description": "Создавайте программы вознаграждений, настраивайте право на участие, правила и схемы начислений. Выполненные заказы автоматически добавляются в отчеты.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Создавайте программы вознаграждений, настраивайте право на участие, правила и схемы начислений. Выполненные заказы автоматически добавляются в отчеты.",
    "rewards.program": "Программа",
    "Program": "Программа",
    "rewards.starts": "Начало",
    "Starts": "Начало",
    "rewards.no_programs": "Программ вознаграждений пока нет.",
    "No reward programs yet.": "Программ вознаграждений пока нет.",
    "rewards.program_title": "Программа вознаграждений",
    "Reward program": "Программа вознаграждений",
    "rewards.back_to_rewards": "Назад к вознаграждениям",
    "Back to rewards": "Назад к вознаграждениям",
    "common.archive": "Архивировать",
    "Archive": "Архивировать",
    "common.save_changes": "Сохранить изменения",
    "common.none": "Нет",
    "common.this_item": "этот элемент",
    "this item": "этот элемент",
    "rewards.tab.scopes": "Области",
    "Scopes": "Области",
    "rewards.tab.rules": "Правила",
    "Rules": "Правила",
    "rewards.tab.components": "Компоненты начисления",
    "Recipe components": "Компоненты начисления",
    "rewards.reference": "Ссылка",
    "rewards.trigger": "Триггер",
    "Trigger": "Триггер",
    "rewards.beneficiary": "Получатель",
    "Beneficiary": "Получатель",
    "rewards.attributed_conversions": "Конверсии по атрибуции",
    "Attributed conversions": "Конверсии по атрибуции",
    "rewards.new_customers": "Новые клиенты",
    "New customers": "Новые клиенты",
    "rewards.revenue_influenced": "Доход под влиянием",
    "Revenue influenced": "Доход под влиянием",
    "rewards.rewards_issued": "Начислено вознаграждений",
    "Rewards issued": "Начислено вознаграждений",
    "rewards.live_business_results": "Актуальные результаты бизнеса",
    "Live business results": "Актуальные результаты бизнеса",
    "rewards.impact_at_a_glance": "Краткая оценка эффективности",
    "Impact at a glance": "Краткая оценка эффективности",
    "rewards.impact_last_30_days": "Актуальные данные о выполненных заказах и результатах партнеров за последние 30 дней.",
    "A live view of completed orders and partner results from the last 30 days.": "Актуальные данные о выполненных заказах и результатах партнеров за последние 30 дней.",
    "rewards.view_full_impact": "Подробнее об эффективности",
    "View full impact": "Подробнее об эффективности",
    "rewards.impact_load_error": "Не удалось загрузить данные эффективности: {error}",
    "Impact data could not be loaded: {error}": "Не удалось загрузить данные эффективности: {error}",
    "rewards.programs": "Программы",
    "rewards.programs_configured": "Программы вознаграждений, настроенные для этой рабочей области.",
    "Reward programs configured for this workspace.": "Программы вознаграждений, настроенные для этой рабочей области.",
    "rewards.programs_eligible": "Программы, которые сейчас подходят для оценки.",
    "Programs currently eligible for evaluation.": "Программы, которые сейчас подходят для оценки.",
    "rewards.drafts": "Черновики",
    "Drafts": "Черновики",
    "rewards.programs_being_configured": "Программы, настройка которых еще не завершена.",
    "Programs still being configured.": "Программы, настройка которых еще не завершена.",
    "rewards.clicks": "Переходы",
    "rewards.completed_orders": "Выполненные заказы",
    "Completed orders": "Выполненные заказы",
    "rewards.conversion_rate": "Коэффициент конверсии",
    "Conversion rate": "Коэффициент конверсии",
    "rewards.revenue": "Доход",
    "rewards.live_connection": "Активное подключение",
    "Live connection": "Активное подключение",
    "rewards.attribution_activity": "Активность отслеживания",
    "Attribution activity": "Активность отслеживания",
    "rewards.connected_workspace": "Подключено к {name}.",
    "Connected to {name}.": "Подключено к {name}.",
    "rewards.your_attribution_workspace": "вашей рабочей области Attribution",
    "your Attribution workspace": "вашей рабочей области Attribution",
    "rewards.loading_workspace": "Загрузка подключенной рабочей области Attribution.",
    "Loading your connected Attribution workspace.": "Загрузка подключенной рабочей области Attribution.",
    "rewards.open_attribution": "Открыть Attribution",
    "Open Attribution": "Открыть Attribution",
    "rewards.connection_attention": "Требуется проверить подключение",
    "Connection needs attention": "Требуется проверить подключение",
    "rewards.open_attribution_workspace": "Открыть рабочую область Attribution",
    "Open Attribution workspace": "Открыть рабочую область Attribution",
    "rewards.workspace_connected": "Рабочая область подключена",
    "Workspace connected": "Рабочая область подключена",
    "rewards.workspace_not_linked": "Рабочая область еще не подключена",
    "Workspace not linked yet": "Рабочая область еще не подключена",
    "rewards.attribution_data_connected": "Получаем данные об актуальных переходах, ссылках, кампаниях и выполненных заказах из Attribution.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Получаем данные об актуальных переходах, ссылках, кампаниях и выполненных заказах из Attribution.",
    "rewards.connect_workspace_prompt": "Откройте Attribution и подключите эту рабочую область, чтобы отслеживать активность.",
    "Open Attribution to connect this workspace before tracking activity.": "Откройте Attribution и подключите эту рабочую область, чтобы отслеживать активность.",
    "rewards.successful_referrals": "Успешные рекомендации",
    "Successful referrals": "Успешные рекомендации",
    "rewards.new_customers_acquired": "Привлечено новых клиентов",
    "New customers acquired": "Привлечено новых клиентов",
    "rewards.gross_revenue_influenced": "Валовый доход под влиянием",
    "Gross revenue influenced": "Валовый доход под влиянием",
    "rewards.reward_cost": "Затраты на вознаграждения",
    "Reward cost": "Затраты на вознаграждения",
    "rewards.net_revenue": "Чистый доход",
    "Net revenue": "Чистый доход",
    "rewards.average_order_value": "Средняя сумма заказа",
    "Average order value": "Средняя сумма заказа",
    "rewards.cost_per_acquisition": "Стоимость привлечения клиента",
    "Cost per acquisition": "Стоимость привлечения клиента",
    "rewards.repeat_purchase_rate": "Доля повторных покупок",
    "Repeat purchase rate": "Доля повторных покупок",
    "rewards.business_outcome_reporting": "Отчеты о результатах бизнеса",
    "Business outcome reporting": "Отчеты о результатах бизнеса",
    "rewards.impact": "Эффективность",
    "rewards.impact_description": "Конверсии, привлечение клиентов, доход под влиянием и затраты на вознаграждения за выбранный период.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Конверсии, привлечение клиентов, доход под влиянием и затраты на вознаграждения за выбранный период.",
    "rewards.from": "С",
    "rewards.to": "По",
    "rewards.trend": "Динамика",
    "Trend": "Динамика",
    "rewards.daily": "Ежедневно",
    "rewards.weekly": "Еженедельно",
    "Weekly": "Еженедельно",
    "rewards.top_partners": "Лучшие партнеры / источники рекомендаций",
    "Top partners / referrers": "Лучшие партнеры / источники рекомендаций",
    "rewards.partner": "Партнер",
    "Partner": "Партнер",
    "rewards.conversions": "Конверсии",
    "Conversions": "Конверсии",
    "rewards.no_partner_data": "Нет данных о партнерах-источниках за этот период.",
    "No attributed partner data for this period.": "Нет данных о партнерах-источниках за этот период.",
    "rewards.period": "Период",
    "rewards.no_trend_data": "Нет данных о динамике за этот период.",
    "No trend data for this period.": "Нет данных о динамике за этот период.",
    "rewards.campaign_performance": "Эффективность кампаний",
    "Campaign performance": "Эффективность кампаний",
    "rewards.campaign_count": "Кампаний: {count}",
    "{count} campaigns": "Кампаний: {count}",
    "rewards.campaign": "Кампания",
    "rewards.orders": "Заказы",
    "rewards.rate": "Ставка",
    "Rate": "Ставка",
    "rewards.no_campaign_activity": "Данных о кампаниях пока нет. Создайте ссылку отслеживания в Attribution, чтобы начать измерять результаты.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Данных о кампаниях пока нет. Создайте ссылку отслеживания в Attribution, чтобы начать измерять результаты.",
    "rewards.recent_completed_orders": "Недавно выполненные заказы",
    "Recent completed orders": "Недавно выполненные заказы",
    "rewards.recent_events_count": "Последние события: {count}",
    "{count} recent events": "Последние события: {count}",
    "rewards.event": "Событие",
    "rewards.completed_order": "Выполненный заказ",
    "Completed order": "Выполненный заказ",
    "rewards.no_completed_order_activity": "Данных о выполненных заказах пока нет.",
    "No completed order activity has arrived yet.": "Данных о выполненных заказах пока нет.",
    "rewards.impact_data_quality_note": "Объем переходов и конверсия недоступны, пока не подключена сводка кликов Attribution. Затраты на вознаграждения учитывают одобренные или начисленные записи реестра; возвраты пока не включены.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Объем переходов и конверсия недоступны, пока не подключена сводка кликов Attribution. Затраты на вознаграждения учитывают одобренные или начисленные записи реестра; возвраты пока не включены.",
    "subscriptions.type.free": "Бесплатная подписка",
    "Free Subscription": "Бесплатная подписка",
    "subscriptions.form.title_placeholder": "Название подписки",
    "Subscription Title": "Название подписки",
    "subscriptions.form.title_help": "Введите понятное название пакета подписки (например: «Премиум», «Базовый»).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Введите понятное название пакета подписки (например: «Премиум», «Базовый»).",
    "subscriptions.form.description_placeholder": "Описание подписки",
    "Subscription Description": "Описание подписки",
    "subscriptions.form.description_help": "Подробно опишите подписку, ее функции и преимущества.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Подробно опишите подписку, ее функции и преимущества.",
    "subscriptions.form.select_currency": "Выберите валюту",
    "Select Currency": "Выберите валюту",
    "subscriptions.form.currency_help": "Выберите валюту подписки из списка (валюта по умолчанию).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Выберите валюту подписки из списка (валюта по умолчанию).",
    "subscriptions.form.amount_placeholder": "Стоимость подписки",
    "Subscription Amount": "Стоимость подписки",
    "subscriptions.form.amount_help": "Введите цену подписки.",
    "Enter the subscription price.": "Введите цену подписки.",
    "subscriptions.form.sku_placeholder": "Артикул подписки",
    "Subscription SKU": "Артикул подписки",
    "subscriptions.form.sku_help": "Введите уникальный идентификатор подписки для удобства работы с данными и отслеживания.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Введите уникальный идентификатор подписки для удобства работы с данными и отслеживания.",
    "subscriptions.form.allowed_listings": "Доступные объявления",
    "Allowed Listings": "Доступные объявления",
    "subscriptions.form.allowed_listings_placeholder": "Количество разрешенных объявлений",
    "Subscription Allowed Listings": "Количество разрешенных объявлений",
    "subscriptions.form.allowed_listings_help": "Укажите, сколько объявлений доступно в этой подписке.",
    "Specify the number of listings allowed for this subscription.": "Укажите, сколько объявлений доступно в этой подписке.",
    "subscriptions.form.fixed_fee_per_order": "Фиксированный сбор за заказ",
    "Fixed Fee Per Order": "Фиксированный сбор за заказ",
    "subscriptions.form.fixed_fee_placeholder": "Фиксированный сбор за заказ",
    "Subscription Fee Fixed Per Order": "Фиксированный сбор за заказ",
    "subscriptions.form.fixed_fee_help": "Укажите фиксированный сбор за заказ, если он применяется.",
    "Enter a fixed fee per order, if applicable.": "Укажите фиксированный сбор за заказ, если он применяется.",
    "subscriptions.form.commission_percent_per_order": "Комиссия за заказ, %",
    "Commission % Per Order": "Комиссия за заказ, %",
    "subscriptions.form.commission_placeholder": "Комиссия за заказ, %",
    "Subscription Commission Percent Per Order": "Комиссия за заказ, %",
    "subscriptions.form.commission_help": "Укажите комиссию за заказ в процентах, если она применяется.",
    "Enter the commission percentage per order, if applicable.": "Укажите комиссию за заказ в процентах, если она применяется.",
    "subscriptions.form.expiry_days": "Срок действия, дней",
    "Expiry Days": "Срок действия, дней",
    "subscriptions.form.expiry_days_placeholder": "Срок действия подписки в днях",
    "Subscription Expiry Days": "Срок действия подписки в днях",
    "subscriptions.form.expiry_days_help": "Укажите срок действия подписки в днях. Например: 7 или 30.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Укажите срок действия подписки в днях. Например: 7 или 30.",
    "subscriptions.form.payment_method": "Способ оплаты",
    "subscriptions.form.select_type": "Выберите тип",
    "subscriptions.form.payment_method_help": "Выберите поддерживаемые способы оплаты (например, Stripe, MangoPay, Android, iOS или бесплатная подписка).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Выберите поддерживаемые способы оплаты (например, Stripe, MangoPay, Android, iOS или бесплатная подписка).",
    "subscriptions.form.active_placeholder": "Подписка активна",
    "Subscription Active": "Подписка активна",
    "subscriptions.form.active_help": "Включите или отключите подписку. Активная подписка доступна для покупки.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Включите или отключите подписку. Активная подписка доступна для покупки.",
    "subscriptions.add_title": "Добавить товар подписки",
    "Add new subscription product": "Добавить товар подписки",
    "subscriptions.edit_title": "Изменить товар подписки",
    "Edit subscription product": "Изменить товар подписки",
    "subscriptions.added_success": "Подписка успешно добавлена",
    "Subscription listing added successfully": "Подписка успешно добавлена",
    "subscriptions.updated_success": "Подписка успешно обновлена",
    "Subscription listing updated successfully": "Подписка успешно обновлена",
    "common.currency": "Валюта",
    "common.sku": "Артикул",
    "subscriptions.title": "Подписки",
    "subscriptions.add_subscription": "Добавить подписку",
    "Add subscription": "Добавить подписку",
    "subscriptions.plans": "Тарифы",
    "subscriptions.active_subscribers": "Активные подписчики",
    "Active Subscribers": "Активные подписчики",
    "subscriptions.total_mrr": "Общий регулярный доход за месяц",
    "Total MRR": "Общий регулярный доход за месяц",
    "subscriptions.churn_rate": "Доля оттока",
    "Churn Rate": "Доля оттока",
    "subscriptions.new_this_month": "Новые за этот месяц",
    "New This Month": "Новые за этот месяц",
    "subscriptions.average_duration": "Средняя продолжительность",
    "Avg Duration": "Средняя продолжительность",
    "subscriptions.monthly_recurring_revenue": "Регулярный ежемесячный доход",
    "Monthly Recurring Revenue": "Регулярный ежемесячный доход",
    "subscriptions.annual_run_rate": "Годовой темп дохода",
    "Annual Run Rate": "Годовой темп дохода",
    "subscriptions.last_30_days": "Последние 30 дней",
    "subscriptions.subscriber_lifetime": "Срок жизни подписчика",
    "Subscriber lifetime": "Срок жизни подписчика",
    "subscriptions.subscriber_distribution": "Распределение подписчиков",
    "Subscriber Distribution": "Распределение подписчиков",
    "subscriptions.billing_period": "Период оплаты",
    "Billing Period": "Период оплаты",
    "subscriptions.allowed_listings": "Доступные объявления",
    "subscriptions.commission_per_order": "Комиссия за заказ",
    "Commission per Order": "Комиссия за заказ",
    "subscriptions.fixed_fee_per_order": "Фиксированный сбор за заказ",
    "Fixed Fee per Order": "Фиксированный сбор за заказ",
    "subscriptions.payment_provider": "Платежный провайдер",
    "Payment Provider": "Платежный провайдер",
    "subscriptions.sku_product_id": "Артикул / ID товара",
    "SKU / Product ID": "Артикул / ID товара",
    "subscriptions.revenue_over_time": "Доход с течением времени",
    "Revenue Over Time": "Доход с течением времени",
    "subscriptions.revenue": "Доход",
    "subscriptions.subscriber_growth": "Рост числа подписчиков",
    "Subscriber Growth": "Рост числа подписчиков",
    "subscriptions.subscribers": "Подписчики",
    "Subscribers": "Подписчики",
    "subscriptions.set_inactive": "Отключить",
    "Set Inactive": "Отключить",
    "subscriptions.set_active": "Активировать",
    "Set Active": "Активировать",
    "subscriptions.plan_title": "Тариф подписки",
    "Subscription Plan": "Тариф подписки",
    "subscriptions.status.active": "Активна",
    "subscriptions.status.cancelled": "Отменена",
    "subscriptions.status.expired": "Истекла",
    "subscriptions.status.trial": "Пробная",
    "Trial": "Пробная",
    "subscriptions.status.pending": "Ожидает",
    "subscriptions.period.lifetime": "Пожизненно",
    "Lifetime": "Пожизненно",
    "subscriptions.period.daily": "Ежедневно",
    "subscriptions.period.weekly": "Еженедельно",
    "subscriptions.period.monthly": "Ежемесячно",
    "Monthly": "Ежемесячно",
    "subscriptions.period.quarterly": "Ежеквартально",
    "Quarterly": "Ежеквартально",
    "subscriptions.period.semi_annual": "Раз в полгода",
    "Semi-annual": "Раз в полгода",
    "subscriptions.period.annual": "Ежегодно",
    "Annual": "Ежегодно",
    "subscriptions.period.days": "{count} дней",
    "subscriptions.period.day": "/ день",
    "/ day": "/ день",
    "subscriptions.period.week": "/ неделя",
    "/ week": "/ неделя",
    "subscriptions.period.month": "/ месяц",
    "/ month": "/ месяц",
    "subscriptions.period.quarter": "/ квартал",
    "/ quarter": "/ квартал",
    "subscriptions.period.six_months": "/ 6 месяцев",
    "/ 6 months": "/ 6 месяцев",
    "subscriptions.period.year": "/ год",
    "/ year": "/ год",
    "subscriptions.listings_count": "Объявлений: {count}",
    "{count} listings": "Объявлений: {count}",
    "subscriptions.commission_percentage": "Комиссия {rate}%",
    "{rate}% commission": "Комиссия {rate}%",
    "subscriptions.per_order": "/ заказ",
    "/ order": "/ заказ",
    "subscriptions.view_details_subscribers": "Просмотреть сведения и подписчиков",
    "View details and subscribers": "Просмотреть сведения и подписчиков",
    "subscriptions.edit_subscription": "Изменить подписку",
    "Edit subscription": "Изменить подписку",
    "subscriptions.delete_subscription": "Удалить подписку",
    "Delete subscription": "Удалить подписку",
    "subscriptions.deleted": "Подписка удалена",
    "Subscription deleted": "Подписка удалена",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Покупки в приложении Android",
    "Android IAP": "Покупки в приложении Android",
    "subscriptions.type.ios": "Покупки в приложении iOS",
    "iOS IAP": "Покупки в приложении iOS",
    "subscriptions.type.free_subscription": "Бесплатно",
    "subscriptions.type.mangopay": "MangoPay",
    "Mangopay": "MangoPay",
    "subscriptions.loaded_count": "Загружено: {count}",
    "subscriptions.no_subscribers": "Нет подписчиков со статусом «{status}».",
    "No {status} subscribers.": "Нет подписчиков со статусом «{status}».",
    "subscriptions.billing_records": "Платежные записи",
    "Billing Records": "Платежные записи",
    "subscriptions.no_invoices": "Счета не найдены.",
    "No invoices found.": "Счета не найдены.",
    "subscriptions.column.account": "Аккаунт",
    "subscriptions.column.email": "Электронная почта",
    "subscriptions.column.status": "Статус",
    "subscriptions.column.subscribed": "Подписка оформлена",
    "Subscribed": "Подписка оформлена",
    "subscriptions.column.expires": "Истекает",
    "subscriptions.column.next_renewal": "Следующее продление",
    "Next Renewal": "Следующее продление",
    "subscriptions.column.amount_paid": "Оплаченная сумма",
    "Amount Paid": "Оплаченная сумма",
    "subscriptions.invoice_column.invoice_id": "ID счета",
    "Invoice ID": "ID счета",
    "subscriptions.invoice_column.account": "Аккаунт",
    "subscriptions.invoice_column.amount": "Сумма",
    "subscriptions.invoice_column.status": "Статус",
    "subscriptions.invoice_column.period": "Период",
    "subscriptions.invoice_column.paid_at": "Дата оплаты",
    "Paid At": "Дата оплаты",
    "subscriptions.validation.title_required": "Укажите название",
    "subscriptions.validation.allowed_listings_positive": "Количество доступных объявлений должно быть больше 0",
    "Allowed listings should be greater than 0": "Количество доступных объявлений должно быть больше 0",
    "subscriptions.validation.currency_required": "Укажите валюту",
    "Currency is required": "Укажите валюту",
    "subscriptions.validation.expiry_required": "Укажите срок действия в днях",
    "Expiry days are required": "Укажите срок действия в днях",
    "subscriptions.validation.payment_method_required": "Укажите способ оплаты",
    "Payment method is required": "Укажите способ оплаты",
    "subscriptions.error.save": "Не удалось сохранить подписку.",
    "Something went wrong while saving the subscription.": "Не удалось сохранить подписку.",
    "subscriptions.error.delete": "Не удалось удалить подписку.",
    "Something went wrong while deleting the subscription.": "Не удалось удалить подписку.",
    "common.configuration": "Настройки",
    "subscriptions.per_period": "за {period}",
    "per {period}": "за {period}",
    "subscriptions.tab.subscribers": "Подписчики",
    "subscriptions.tab.invoices": "Счета",
    "subscriptions.account_title": "Подписка аккаунта",
    "Account Subscription": "Подписка аккаунта",
    "subscriptions.config.description": "Управляйте подписками аккаунтов. После включения владельцам аккаунтов потребуется активная подписка для публикации объявлений. Для оплаты подписок используется платежный шлюз по умолчанию, выбранный в разделе «Способ оплаты».",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Управляйте подписками аккаунтов. После включения владельцам аккаунтов потребуется активная подписка для публикации объявлений. Для оплаты подписок используется платежный шлюз по умолчанию, выбранный в разделе «Способ оплаты».",
    "subscriptions.config.enable": "Включить подписки",
    "Enable subscriptions": "Включить подписки",
    "subscriptions.config.type": "Тип подписки",
    "Subscription type": "Тип подписки",
    "subscriptions.config.purchased_message": "Сообщение при уже оформленной подписке",
    "Message when a subscription is already purchased": "Сообщение при уже оформленной подписке",
    "subscriptions.config.purchased_placeholder": "Введите сообщение для уже оформленной подписки",
    "Enter the already-purchased message": "Введите сообщение для уже оформленной подписки",
    "subscriptions.config.listings_exhausted_message": "Сообщение при достижении лимита объявлений",
    "Message when the listing limit is reached": "Сообщение при достижении лимита объявлений",
    "subscriptions.config.listings_exhausted_placeholder": "Введите сообщение о лимите объявлений",
    "Enter the listing limit message": "Введите сообщение о лимите объявлений",
    "subscriptions.config.inactive_message": "Сообщение при неактивной подписке",
    "Message when the subscription is inactive": "Сообщение при неактивной подписке",
    "subscriptions.config.inactive_placeholder": "Введите сообщение о неактивной подписке",
    "Enter the inactive subscription message": "Введите сообщение о неактивной подписке",
    "subscriptions.config.saved": "Настройки подписки успешно сохранены",
    "Subscription settings saved successfully": "Настройки подписки успешно сохранены",
    "people.title": "Сотрудники",
    "people.tab.staff": "Персонал",
    "people.tab.departments": "Отделы",
    "Departments": "Отделы",
    "people.tab.job_profiles": "Должности",
    "Job profiles": "Должности",
    "people.tab.pay_grades": "Уровни оплаты",
    "Pay grades": "Уровни оплаты",
    "people.action.add_staff": "Добавить сотрудника",
    "Add staff": "Добавить сотрудника",
    "people.action.add_department": "Добавить отдел",
    "Add department": "Добавить отдел",
    "people.action.add_job_profile": "Добавить должность",
    "people.action.add_pay_grade": "Добавить уровень оплаты",
    "Add pay grade": "Добавить уровень оплаты",
    "people.currency_id": "ID валюты",
    "people.onboarding.eyebrow": "Начало работы с персоналом",
    "Get started with People": "Начало работы с персоналом",
    "people.onboarding.title": "Создайте справочник команды",
    "Build your team directory": "Создайте справочник команды",
    "people.onboarding.description": "Добавьте первого сотрудника, затем организуйте команду по отделам, должностям и уровням оплаты.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Добавьте первого сотрудника, затем организуйте команду по отделам, должностям и уровням оплаты.",
    "people.onboarding.add_first": "Добавить первого сотрудника",
    "Add your first staff member": "Добавить первого сотрудника",
    "people.onboarding.step_staff": "Добавить сотрудника",
    "people.onboarding.step_staff_description": "Свяжите существующего пользователя со справочником персонала.",
    "Link an existing user to your staff directory.": "Свяжите существующего пользователя со справочником персонала.",
    "people.onboarding.step_teams": "Организовать команды",
    "Organize teams": "Организовать команды",
    "people.onboarding.step_teams_description": "По мере роста создавайте отделы и должностные профили.",
    "Create departments and job profiles as you grow.": "По мере роста создавайте отделы и должностные профили.",
    "people.onboarding.step_pay": "Настроить оплату",
    "Set compensation": "Настроить оплату",
    "people.onboarding.step_pay_description": "Определите уровни оплаты для согласованной настройки расчета зарплат.",
    "Define pay grades for consistent payroll setup.": "Определите уровни оплаты для согласованной настройки расчета зарплат.",
    "people.staff_profile": "Профиль сотрудника",
    "Staff profile": "Профиль сотрудника",
    "people.field.employee_code": "Код сотрудника",
    "Employee code": "Код сотрудника",
    "people.field.job_title": "Должность",
    "Job title": "Должность",
    "people.field.department": "Отдел",
    "Department": "Отдел",
    "people.field.job_profile": "Должностной профиль",
    "Job profile": "Должностной профиль",
    "people.field.pay_grade": "Уровень оплаты",
    "Pay grade": "Уровень оплаты",
    "people.field.employment_type": "Тип занятости",
    "Employment type": "Тип занятости",
    "people.field.start_date": "Дата начала",
    "people.field.user_id": "ID пользователя",
    "people.field.user": "Пользователь",
    "people.field.grade": "Уровень",
    "Grade": "Уровень",
    "people.field.salary_range": "Диапазон зарплаты",
    "Salary range": "Диапазон зарплаты",
    "people.field.minimum_salary": "Минимальная зарплата",
    "Minimum salary": "Минимальная зарплата",
    "people.field.maximum_salary": "Максимальная зарплата",
    "Maximum salary": "Максимальная зарплата",
    "people.field.currency_id": "ID валюты",
    "people.form.staff.edit": "Изменить сотрудника",
    "Edit staff": "Изменить сотрудника",
    "people.form.staff.add": "Добавить сотрудника",
    "people.form.staff.description": "Свяжите существующего пользователя с профилем сотрудника.",
    "Link an existing user to a staff profile.": "Свяжите существующего пользователя с профилем сотрудника.",
    "people.form.department.edit": "Изменить отдел",
    "Edit department": "Изменить отдел",
    "people.form.department.add": "Добавить отдел",
    "people.form.job_profile.edit": "Изменить должностной профиль",
    "Edit job profile": "Изменить должностной профиль",
    "people.form.job_profile.add": "Добавить должностной профиль",
    "people.form.pay_grade.edit": "Изменить уровень оплаты",
    "Edit pay grade": "Изменить уровень оплаты",
    "people.form.pay_grade.add": "Добавить уровень оплаты",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Старший инженер",
    "Senior Engineer": "Старший инженер",
    "people.placeholder.department": "Разработка",
    "Engineering": "Разработка",
    "people.placeholder.department_description": "Команда продукта и разработки",
    "Product & Engineering team": "Команда продукта и разработки",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Полная занятость",
    "Full time": "Полная занятость",
    "people.employment.part_time": "Частичная занятость",
    "Part time": "Частичная занятость",
    "people.employment.contractor": "Подрядчик",
    "Contractor": "Подрядчик",
    "people.toast.staff_added": "Сотрудник добавлен",
    "Staff added": "Сотрудник добавлен",
    "people.toast.staff_updated": "Данные сотрудника обновлены",
    "Staff updated": "Данные сотрудника обновлены",
    "people.toast.department_added": "Отдел добавлен",
    "Department added": "Отдел добавлен",
    "people.toast.department_updated": "Отдел обновлен",
    "Department updated": "Отдел обновлен",
    "people.toast.job_profile_added": "Должность добавлена",
    "Job profile added": "Должность добавлена",
    "people.toast.job_profile_updated": "Должность обновлена",
    "Job profile updated": "Должность обновлена",
    "people.toast.pay_grade_added": "Уровень оплаты добавлен",
    "Pay grade added": "Уровень оплаты добавлен",
    "people.toast.pay_grade_updated": "Уровень оплаты обновлен",
    "Pay grade updated": "Уровень оплаты обновлен",
    "people.empty.staff": "Сотрудников пока нет. Добавьте профиль сотрудника, чтобы начать.",
    "No staff yet. Add a staff profile to get started.": "Сотрудников пока нет. Добавьте профиль сотрудника, чтобы начать.",
    "people.empty.departments": "Отделов пока нет.",
    "No departments yet.": "Отделов пока нет.",
    "people.empty.job_profiles": "Должностных профилей пока нет.",
    "No job profiles yet.": "Должностных профилей пока нет.",
    "people.empty.pay_grades": "Уровней оплаты пока нет.",
    "No pay grades yet.": "Уровней оплаты пока нет.",
    "people.pagination.page": "Страница {page}",
    "Page {page}": "Страница {page}",
    "workforce.title": "Персонал",
    "workforce.tab.shifts": "Смены",
    "Shifts": "Смены",
    "workforce.tab.attendance": "Посещаемость",
    "Attendance": "Посещаемость",
    "workforce.tab.leave_requests": "Заявки на отпуск",
    "Leave requests": "Заявки на отпуск",
    "workforce.tab.leave_balances": "Остатки отпусков",
    "Leave balances": "Остатки отпусков",
    "workforce.tab.leave_policies": "Правила отпусков",
    "Leave policies": "Правила отпусков",
    "workforce.action.add_shift": "Добавить смену",
    "Add shift": "Добавить смену",
    "workforce.action.new_leave_request": "Новая заявка на отпуск",
    "New leave request": "Новая заявка на отпуск",
    "workforce.action.set_balance": "Установить остаток",
    "Set balance": "Установить остаток",
    "workforce.action.add_policy": "Добавить правило",
    "Add policy": "Добавить правило",
    "workforce.action.create_request": "Создать заявку",
    "Create request": "Создать заявку",
    "workforce.action.save_balance": "Сохранить остаток",
    "Save balance": "Сохранить остаток",
    "workforce.action.clock_in": "Начать смену",
    "workforce.action.clock_out": "Завершить смену",
    "workforce.action.clocking_in": "Начало смены…",
    "Clocking in…": "Начало смены…",
    "workforce.action.clocking_out": "Завершение смены…",
    "Clocking out…": "Завершение смены…",
    "workforce.field.staff": "Сотрудник",
    "workforce.field.start_time": "Начало",
    "workforce.field.end_time": "Окончание",
    "workforce.field.location": "Расположение",
    "workforce.field.leave_type": "Тип отпуска",
    "Leave type": "Тип отпуска",
    "workforce.field.from": "С",
    "workforce.field.to": "По",
    "workforce.field.days": "Дней",
    "Days": "Дней",
    "workforce.field.total_days": "Всего дней",
    "Total days": "Всего дней",
    "workforce.field.days_per_year": "Дней в году",
    "Days per year": "Дней в году",
    "workforce.field.carry_over": "Перенос остатка",
    "Carry over": "Перенос остатка",
    "workforce.field.carry_over_hint": "Неиспользованные дни переносятся на следующий год",
    "Unused days carry over to next year": "Неиспользованные дни переносятся на следующий год",
    "workforce.field.reason": "Причина",
    "workforce.field.time": "Время",
    "workforce.field.clock_in": "Начало смены",
    "workforce.field.clock_out": "Окончание смены",
    "workforce.field.hours": "Часы",
    "Hours": "Часы",
    "workforce.field.dates": "Даты",
    "Dates": "Даты",
    "workforce.field.used_days": "Использовано",
    "Used": "Использовано",
    "workforce.field.remaining_days": "Осталось дней",
    "workforce.field.policy": "Правило",
    "Policy": "Правило",
    "workforce.placeholder.location": "Главный офис",
    "HQ": "Главный офис",
    "workforce.placeholder.leave_note": "Семейный отпуск",
    "Family holiday": "Семейный отпуск",
    "workforce.placeholder.policy_name": "Ежегодный отпуск",
    "Annual Leave": "Ежегодный отпуск",
    "workforce.placeholder.reject_reason": "Загруженный период",
    "Busy period": "Загруженный период",
    "workforce.placeholder.optional_note": "Необязательное примечание",
    "Optional note": "Необязательное примечание",
    "workforce.select.all_staff": "Весь персонал",
    "All staff": "Весь персонал",
    "workforce.form.shift.add": "Добавить смену",
    "workforce.form.leave_request.add": "Новая заявка на отпуск",
    "workforce.form.leave_balance.title": "Установить остаток отпуска",
    "Set leave balance": "Установить остаток отпуска",
    "workforce.form.leave_balance.description": "Укажите доступное сотруднику количество дней отпуска для типа отпуска и года.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Укажите доступное сотруднику количество дней отпуска для типа отпуска и года.",
    "workforce.form.leave_policy.add": "Добавить правило отпуска",
    "Add leave policy": "Добавить правило отпуска",
    "workforce.form.leave_request.reject": "Отклонить заявку на отпуск",
    "Reject leave request": "Отклонить заявку на отпуск",
    "workforce.form.clock_out": "Завершить смену",
    "workforce.toast.shift_added": "Смена добавлена",
    "Shift added": "Смена добавлена",
    "workforce.toast.leave_request_created": "Заявка на отпуск создана",
    "Leave request created": "Заявка на отпуск создана",
    "workforce.toast.leave_balance_saved": "Остаток отпуска сохранен",
    "Leave balance saved": "Остаток отпуска сохранен",
    "workforce.toast.leave_policy_added": "Правило отпуска добавлено",
    "Leave policy added": "Правило отпуска добавлено",
    "workforce.toast.leave_request_rejected": "Заявка на отпуск отклонена",
    "Leave request rejected": "Заявка на отпуск отклонена",
    "workforce.toast.leave_request_approved": "Заявка на отпуск одобрена",
    "Leave request approved": "Заявка на отпуск одобрена",
    "workforce.toast.clocked_in": "Смена начата",
    "Clocked in": "Смена начата",
    "workforce.toast.clocked_out": "Смена завершена",
    "Clocked out": "Смена завершена",
    "workforce.empty.shifts": "Смен за этот период нет.",
    "No shifts in this period.": "Смен за этот период нет.",
    "workforce.empty.attendance": "Записей о посещаемости нет.",
    "No attendance records.": "Записей о посещаемости нет.",
    "workforce.empty.leave_requests": "Заявок на отпуск нет.",
    "No leave requests.": "Заявок на отпуск нет.",
    "workforce.empty.leave_balances": "Остатков отпуска нет. Нажмите «Установить остаток», чтобы добавить.",
    "No leave balances. Use Set balance to add one.": "Остатков отпуска нет. Нажмите «Установить остаток», чтобы добавить.",
    "workforce.empty.leave_policies": "Правил отпусков пока нет.",
    "No leave policies yet.": "Правил отпусков пока нет.",
    "workforce.leave_type.annual": "Ежегодный отпуск",
    "Annual leave": "Ежегодный отпуск",
    "workforce.leave_type.sick": "Больничный",
    "Sick leave": "Больничный",
    "workforce.leave_type.unpaid": "Отпуск без оплаты",
    "Unpaid leave": "Отпуск без оплаты",
    "workforce.leave_type.parental": "Родительский отпуск",
    "Parental leave": "Родительский отпуск",
    "workforce.leave_type.compassionate": "Отпуск в связи с утратой",
    "Compassionate leave": "Отпуск в связи с утратой",
    "workforce.duration.hours_minutes": "{hours} ч {minutes} мин",
    "{hours}h {minutes}m": "{hours} ч {minutes} мин",
    "common.year": "Год",
    "Year": "Год",
    "common.approve": "Одобрить",
    "common.reject": "Отклонить",
    "payroll.title": "Расчет зарплаты",
    "payroll.tab.runs": "Расчеты",
    "Payroll runs": "Расчеты",
    "payroll.tab.components": "Компоненты оплаты",
    "Pay components": "Компоненты оплаты",
    "payroll.tab.claims": "Заявки на возмещение расходов",
    "Expense claims": "Заявки на возмещение расходов",
    "payroll.tab.categories": "Категории расходов",
    "Expense categories": "Категории расходов",
    "payroll.action.new_run": "Новый расчет зарплаты",
    "New payroll run": "Новый расчет зарплаты",
    "payroll.action.add_component": "Добавить компонент оплаты",
    "Add pay component": "Добавить компонент оплаты",
    "payroll.action.new_claim": "Новая заявка на расход",
    "New expense claim": "Новая заявка на расход",
    "payroll.action.add_category": "Добавить категорию",
    "payroll.action.create_run": "Создать расчет",
    "Create run": "Создать расчет",
    "payroll.action.create_component": "Создать компонент",
    "Create component": "Создать компонент",
    "payroll.action.create_claim": "Создать заявку",
    "Create claim": "Создать заявку",
    "payroll.action.submit_claim": "Отправить",
    "Submit": "Отправить",
    "payroll.action.approve_claim": "Одобрить",
    "payroll.action.reimburse_claim": "Возместить",
    "Reimburse": "Возместить",
    "payroll.action.approve_payroll": "Одобрить расчет зарплаты",
    "Approve payroll": "Одобрить расчет зарплаты",
    "payroll.action.activate": "Активировать",
    "Activate": "Активировать",
    "payroll.action.deactivate": "Отключить",
    "payroll.action.adjust": "Корректировать",
    "payroll.action.save_adjustment": "Сохранить корректировку",
    "payroll.action.export_csv": "Экспортировать CSV",
    "Export CSV": "Экспортировать CSV",
    "payroll.action.exporting": "Экспорт…",
    "payroll.action.view_staff_items": "Просмотреть начисления сотрудникам",
    "View staff items": "Просмотреть начисления сотрудникам",
    "payroll.action.view_payslips": "Просмотреть расчетные листки",
    "View payslips": "Просмотреть расчетные листки",
    "payroll.type.addition": "Начисление",
    "Addition": "Начисление",
    "payroll.type.deduction": "Удержание",
    "Deduction": "Удержание",
    "payroll.calculation.fixed": "Фиксированная сумма",
    "Fixed amount": "Фиксированная сумма",
    "payroll.calculation.percentage": "Процент",
    "payroll.applies_to.all": "Весь персонал",
    "payroll.applies_to.hourly": "Почасовые сотрудники",
    "Hourly staff": "Почасовые сотрудники",
    "payroll.applies_to.salaried": "Штатные сотрудники",
    "Salaried staff": "Штатные сотрудники",
    "payroll.category.archive_confirm": "Архивировать «{name}»?",
    "payroll.components.description": "Активные начисления и удержания автоматически применяются к новым расчетам зарплаты.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Активные начисления и удержания автоматически применяются к новым расчетам зарплаты.",
    "payroll.empty.categories": "Категорий расходов пока нет.",
    "No expense categories yet.": "Категорий расходов пока нет.",
    "payroll.empty.claims": "Заявок на расходы пока нет.",
    "No expense claims yet.": "Заявок на расходы пока нет.",
    "payroll.empty.components": "Компоненты оплаты не настроены.",
    "No pay components configured yet.": "Компоненты оплаты не настроены.",
    "payroll.empty.runs": "Расчетов зарплаты пока нет.",
    "No payroll runs yet.": "Расчетов зарплаты пока нет.",
    "payroll.field.staff": "Сотрудник",
    "payroll.field.base_pay": "Основная зарплата",
    "Base pay": "Основная зарплата",
    "payroll.field.allowances": "Надбавки",
    "Allowances": "Надбавки",
    "payroll.field.deductions": "Удержания",
    "Deductions": "Удержания",
    "payroll.field.commission": "Комиссия",
    "payroll.field.net_pay": "Чистая зарплата",
    "Net pay": "Чистая зарплата",
    "payroll.field.components": "Компоненты",
    "Components": "Компоненты",
    "payroll.field.commission_override": "Переопределение комиссии",
    "Commission override": "Переопределение комиссии",
    "payroll.field.calculation": "Расчет",
    "Calculation": "Расчет",
    "payroll.field.applies_to": "Применяется к",
    "Applies to": "Применяется к",
    "payroll.field.staff_optional_draft": "Сотрудник (необязательно для черновика)",
    "Staff (optional while drafting)": "Сотрудник (необязательно для черновика)",
    "payroll.field.category_optional_draft": "Категория (необязательно для черновика)",
    "Category (optional while drafting)": "Категория (необязательно для черновика)",
    "payroll.field.category": "Категория",
    "payroll.field.period": "Период",
    "payroll.field.period_start": "Начало периода",
    "Period start": "Начало периода",
    "payroll.field.period_end": "Окончание периода",
    "Period end": "Окончание периода",
    "payroll.field.generate_email_payslips": "Создать и отправить расчетные листки по электронной почте",
    "Generate and email payslips": "Создать и отправить расчетные листки по электронной почте",
    "payroll.field.gl_code": "Код главной книги",
    "GL code": "Код главной книги",
    "payroll.field.maximum_per_claim": "Максимум на заявку",
    "Maximum per claim": "Максимум на заявку",
    "payroll.field.maximum_per_transaction": "Максимум на транзакцию",
    "Maximum per transaction": "Максимум на транзакцию",
    "payroll.field.spending_cap": "Лимит расходов",
    "Spending cap": "Лимит расходов",
    "payroll.field.tax_rate": "Налоговая ставка (%)",
    "Tax rate (%)": "Налоговая ставка (%)",
    "payroll.field.no_limit": "Без ограничений",
    "No limit": "Без ограничений",
    "payroll.form.run.title": "Новый расчет зарплаты",
    "payroll.form.run.description": "Зарплата рассчитывается по уровням оплаты сотрудников за выбранный период.",
    "Pay is calculated from staff pay grades for the selected period.": "Зарплата рассчитывается по уровням оплаты сотрудников за выбранный период.",
    "payroll.form.component.title": "Добавить компонент оплаты",
    "payroll.form.component.description": "Компоненты автоматически включаются в будущие расчеты зарплаты.",
    "Components are automatically included in future payroll runs.": "Компоненты автоматически включаются в будущие расчеты зарплаты.",
    "payroll.form.claim.title": "Новая заявка на расход",
    "payroll.form.claim.description": "Заявка остается черновиком, пока ее не отправят на одобрение.",
    "Claims start as drafts until submitted for approval.": "Заявка остается черновиком, пока ее не отправят на одобрение.",
    "payroll.form.category.add": "Добавить категорию расходов",
    "Add expense category": "Добавить категорию расходов",
    "payroll.form.category.edit": "Изменить категорию расходов",
    "Edit expense category": "Изменить категорию расходов",
    "payroll.form.claim.approve_title": "Одобрить заявку на расход",
    "Approve expense claim": "Одобрить заявку на расход",
    "payroll.form.run.approve_title": "Одобрить расчет зарплаты",
    "Approve payroll run": "Одобрить расчет зарплаты",
    "payroll.form.run.approve_description": "Одобрение блокирует расчет зарплаты. Сейчас также можно создать и отправить расчетные листки.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "Одобрение блокирует расчет зарплаты. Сейчас также можно создать и отправить расчетные листки.",
    "payroll.items.title": "Начисления сотрудникам",
    "Staff payroll items": "Начисления сотрудникам",
    "payroll.items.loading": "Загрузка начислений…",
    "Loading payroll items…": "Загрузка начислений…",
    "payroll.items.empty": "Начисления не найдены.",
    "No payroll items found.": "Начисления не найдены.",
    "payroll.items.adjust_title": "Корректировка начисления",
    "Adjust payroll item": "Корректировка начисления",
    "payroll.items.adjust_description": "Измените удержания или скорректируйте сумму комиссии для этого сотрудника.",
    "Update deductions or override the commission amount for this staff member.": "Измените удержания или скорректируйте сумму комиссии для этого сотрудника.",
    "payroll.payslips.title": "Расчетные листки",
    "Payslips": "Расчетные листки",
    "payroll.payslips.generate": "Создать расчетные листки",
    "Generate payslips": "Создать расчетные листки",
    "payroll.payslips.generating": "Создание…",
    "Generating…": "Создание…",
    "payroll.payslips.empty": "Расчетные листки еще не созданы.",
    "No payslips generated yet.": "Расчетные листки еще не созданы.",
    "payroll.payslips.generated": "Создано",
    "Generated": "Создано",
    "payroll.payslips.sent_at": "Отправлено {date}",
    "Sent {date}": "Отправлено {date}",
    "payroll.payslips.not_sent": "Не отправлено",
    "Not sent": "Не отправлено",
    "payroll.payslips.send_email": "Отправить по электронной почте",
    "Send email": "Отправить по электронной почте",
    "payroll.payslips.sending": "Отправка…",
    "payroll.payslips.details": "Сведения о расчетном листке",
    "Payslip details": "Сведения о расчетном листке",
    "payroll.placeholder.approval_note": "Одобрено",
    "payroll.placeholder.category_name": "Поездки",
    "Travel": "Поездки",
    "payroll.placeholder.claim_description": "Перелет к клиенту",
    "Flight to client": "Перелет к клиенту",
    "payroll.placeholder.component_name": "Транспортная надбавка",
    "Transport Allowance": "Транспортная надбавка",
    "payroll.staff_number": "Сотрудник №{id}",
    "Staff #{id}": "Сотрудник №{id}",
    "payroll.toast.category_added": "Категория расходов добавлена",
    "Expense category added": "Категория расходов добавлена",
    "payroll.toast.category_archived": "Категория расходов архивирована",
    "Expense category archived": "Категория расходов архивирована",
    "payroll.toast.category_updated": "Категория расходов обновлена",
    "Expense category updated": "Категория расходов обновлена",
    "payroll.toast.claim_approved": "Заявка одобрена",
    "Claim approved": "Заявка одобрена",
    "payroll.toast.claim_created": "Заявка на расход создана",
    "Expense claim created": "Заявка на расход создана",
    "payroll.toast.claim_reimbursed": "Заявка отмечена как возмещенная",
    "Claim marked as reimbursed": "Заявка отмечена как возмещенная",
    "payroll.toast.claim_submitted": "Заявка отправлена",
    "Claim submitted": "Заявка отправлена",
    "payroll.toast.component_activated": "Компонент оплаты активирован",
    "Pay component activated": "Компонент оплаты активирован",
    "payroll.toast.component_created": "Компонент оплаты создан",
    "Pay component created": "Компонент оплаты создан",
    "payroll.toast.component_deactivated": "Компонент оплаты отключен",
    "Pay component deactivated": "Компонент оплаты отключен",
    "payroll.toast.item_updated": "Начисление обновлено",
    "Payroll item updated": "Начисление обновлено",
    "payroll.toast.payslip_email_sent": "Расчетный листок отправлен",
    "Payslip email sent": "Расчетный листок отправлен",
    "payroll.toast.payslips_generated": "Расчетные листки созданы",
    "Payslips generated": "Расчетные листки созданы",
    "payroll.toast.run_approved": "Расчет зарплаты одобрен",
    "Payroll run approved": "Расчет зарплаты одобрен",
    "payroll.toast.run_approved_payslips_queued": "Расчет одобрен, расчетные листки поставлены в очередь",
    "Payroll approved and payslips queued": "Расчет одобрен, расчетные листки поставлены в очередь",
    "payroll.toast.run_created": "Расчет зарплаты создан",
    "payroll.toast.exported": "Расчет зарплаты экспортирован",
    "Payroll exported": "Расчет зарплаты экспортирован",
    "common.notes": "Примечания",
    "expenses.title": "Расходы",
    "expenses.action.add": "Добавить расход",
    "Add expense": "Добавить расход",
    "expenses.action.create": "Создать расход",
    "Create expense": "Создать расход",
    "expenses.action.submit": "Отправить",
    "expenses.action.approve": "Одобрить",
    "expenses.action.reimburse": "Возместить",
    "expenses.action.pay": "Оплатить",
    "expenses.action.lifecycle": "Расход: {action}",
    "Expense {action}d": "Расход: {action}",
    "expenses.type.claim": "Заявка",
    "Claim": "Заявка",
    "expenses.type.claims": "Заявки",
    "Claims": "Заявки",
    "expenses.type.bill": "Счет",
    "Bill": "Счет",
    "expenses.type.bills": "Счета",
    "Bills": "Счета",
    "expenses.filter.all_types": "Все типы",
    "All types": "Все типы",
    "expenses.filter.all_statuses": "Все статусы",
    "expenses.summary.title": "Сводка",
    "Summary": "Сводка",
    "expenses.summary.by_category": "По категориям",
    "By category": "По категориям",
    "expenses.summary.by_status": "По статусу",
    "By status": "По статусу",
    "expenses.summary.by_party": "По поставщику / сотруднику",
    "By supplier / staff": "По поставщику / сотруднику",
    "expenses.summary.heading": "Сводка по параметру: {group}",
    "Summary by {group}": "Сводка по параметру: {group}",
    "expenses.summary.group.category": "категория",
    "category": "категория",
    "expenses.summary.group.status": "статус",
    "status": "статус",
    "expenses.summary.group.party": "поставщик / сотрудник",
    "supplier / staff": "поставщик / сотрудник",
    "expenses.summary.empty": "Сводка недоступна.",
    "No summary available.": "Сводка недоступна.",
    "expenses.column.type": "Тип",
    "expenses.column.party": "Сотрудник / Поставщик",
    "Staff / Supplier": "Сотрудник / Поставщик",
    "expenses.column.status": "Статус",
    "expenses.field.staff_optional": "Сотрудник (необязательно для черновика)",
    "expenses.field.supplier_optional": "Поставщик (необязательно для черновика)",
    "Supplier (optional while drafting)": "Поставщик (необязательно для черновика)",
    "expenses.field.category_optional": "Категория (необязательно для черновика)",
    "expenses.field.amount": "Сумма",
    "expenses.field.currency": "Валюта",
    "expenses.field.description": "Описание",
    "expenses.field.due_date": "Срок оплаты",
    "Due date": "Срок оплаты",
    "expenses.field.receipt_url": "Ссылка на чек",
    "Receipt URL": "Ссылка на чек",
    "expenses.empty": "Нет расходов, соответствующих выбранным фильтрам.",
    "No expenses found for the selected filters.": "Нет расходов, соответствующих выбранным фильтрам.",
    "expenses.modal.edit": "Изменить расход",
    "Edit expense": "Изменить расход",
    "expenses.modal.add": "Добавить: {type}",
    "Add {type}": "Добавить: {type}",
    "expenses.modal.bill_help": "Создайте черновик и укажите поставщика перед отправкой.",
    "Create the draft now and assign a supplier before submitting.": "Создайте черновик и укажите поставщика перед отправкой.",
    "expenses.modal.claim_help": "Создайте черновик и укажите сотрудника перед отправкой.",
    "Create the draft now and assign a staff member before submitting.": "Создайте черновик и укажите сотрудника перед отправкой.",
    "expenses.toast.updated": "Расход обновлен",
    "Expense updated": "Расход обновлен",
    "expenses.toast.created": "Расход создан",
    "Expense created": "Расход создан",
    "recurring_payments.title": "Регулярные платежи",
    "recurring_payments.action.add": "Добавить регулярный платеж",
    "Add recurring payment": "Добавить регулярный платеж",
    "recurring_payments.action.create": "Создать регулярный платеж",
    "Create recurring payment": "Создать регулярный платеж",
    "recurring_payments.action.pause": "Приостановить",
    "Pause": "Приостановить",
    "recurring_payments.action.resume": "Возобновить",
    "Resume": "Возобновить",
    "recurring_payments.action.remove": "Удалить",
    "recurring_payments.description": "Автоматически создавайте черновики счетов расходов для регулярных платежей поставщикам.",
    "Automatically create draft expense bills for regular supplier payments.": "Автоматически создавайте черновики счетов расходов для регулярных платежей поставщикам.",
    "recurring_payments.field.name": "Название",
    "recurring_payments.field.supplier": "Поставщик",
    "recurring_payments.field.supplier_optional": "Поставщик (необязательно)",
    "Supplier (optional)": "Поставщик (необязательно)",
    "recurring_payments.field.frequency": "Частота",
    "Frequency": "Частота",
    "recurring_payments.field.next_due": "Следующая дата оплаты",
    "Next due date": "Следующая дата оплаты",
    "recurring_payments.field.auto_create": "Автоматически создавать черновик счета",
    "Auto-create draft bill": "Автоматически создавать черновик счета",
    "recurring_payments.field.auto_create_help": "Автоматически создавать черновик счета расходов",
    "Create a draft expense bill automatically": "Автоматически создавать черновик счета расходов",
    "recurring_payments.field.one_time": "Разовый платеж",
    "One-time payment": "Разовый платеж",
    "recurring_payments.field.one_time_help": "Завершить после создания следующего счета",
    "End after the next generated bill": "Завершить после создания следующего счета",
    "recurring_payments.field.end_date": "Дата окончания",
    "recurring_payments.placeholder.name": "Аренда офиса",
    "Office Rent": "Аренда офиса",
    "recurring_payments.frequency.daily": "Ежедневно",
    "recurring_payments.frequency.weekly": "Еженедельно",
    "recurring_payments.frequency.monthly": "Ежемесячно",
    "recurring_payments.frequency.quarterly": "Ежеквартально",
    "recurring_payments.frequency.yearly": "Ежегодно",
    "Yearly": "Ежегодно",
    "recurring_payments.form.description": "При включенном автоматическом создании просроченные платежи создают черновики счетов в разделе «Расходы».",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "При включенном автоматическом создании просроченные платежи создают черновики счетов в разделе «Расходы».",
    "recurring_payments.empty": "Регулярных платежей пока нет.",
    "No recurring payments yet.": "Регулярных платежей пока нет.",
    "recurring_payments.this_payment": "этот регулярный платеж",
    "this recurring payment": "этот регулярный платеж",
    "recurring_payments.confirm_remove": "Удалить {name}?",
    "Remove {name}?": "Удалить {name}?",
    "recurring_payments.toast.pause": "Регулярный платеж приостановлен",
    "Recurring payment paused": "Регулярный платеж приостановлен",
    "recurring_payments.toast.resume": "Регулярный платеж возобновлен",
    "Recurring payment resumed": "Регулярный платеж возобновлен",
    "recurring_payments.toast.delete": "Регулярный платеж удален",
    "Recurring payment removed": "Регулярный платеж удален",
    "recurring_payments.toast.created": "Регулярный платеж создан",
    "Recurring payment created": "Регулярный платеж создан",
    "expenses.toast.submit": "Расход отправлен",
    "Expense submitted": "Расход отправлен",
    "expenses.toast.approve": "Расход одобрен",
    "Expense approved": "Расход одобрен",
    "expenses.toast.reimburse": "Расход возмещен",
    "Expense reimbursed": "Расход возмещен",
    "expenses.toast.pay": "Расход оплачен",
    "Expense paid": "Расход оплачен",
    "media_picker.title": "Выбрать медиафайл",
    "Select media": "Выбрать медиафайл",
    "media_picker.type.media": "Медиафайлы",
    "media_picker.type.all": "Все",
    "media_picker.type.image": "Изображение",
    "media_picker.type.video": "Видео",
    "media_picker.type.audio": "Аудио",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Папка",
    "media_picker.label.show": "Показать",
    "media_picker.label.media_type": "Тип медиафайла",
    "Media type": "Тип медиафайла",
    "media_picker.action.show_type": "Показать медиафайлы типа {type}",
    "media_picker.action.close": "Закрыть выбор медиафайла",
    "Close media picker": "Закрыть выбор медиафайла",
    "media_picker.action.upload": "Загрузить медиафайл",
    "media_picker.action.creating": "Создание…",
    "media_picker.action.create_folder": "Создать папку",
    "Create folder": "Создать папку",
    "media_picker.action.cancel": "Отмена",
    "media_picker.action.use_selected": "Использовать выбранное",
    "Use selected": "Использовать выбранное",
    "media_picker.placeholder.search": "Поиск медиафайлов",
    "media_picker.placeholder.folder": "Название новой папки",
    "New folder name": "Название новой папки",
    "media_picker.loading": "Загрузка медиафайлов…",
    "media_picker.empty": "В этой папке медиафайлы не найдены.",
    "No media found in this folder.": "В этой папке медиафайлы не найдены.",
    "media_picker.selection.count": "Выбрано: {count}",
    "{count} selected": "Выбрано: {count}",
    "media_picker.selection.prompt": "Выберите файл, чтобы продолжить",
    "Select a file to continue": "Выберите файл, чтобы продолжить",
    "media_picker.error.load": "Не удалось загрузить медиафайлы",
    "Unable to load media": "Не удалось загрузить медиафайлы",
    "media_picker.error.load_retry": "Не удалось загрузить медиафайлы. Повторите попытку.",
    "media_picker.error.create_folder": "Не удалось создать папку",
    "media_picker.error.create_folder_retry": "Не удалось создать папку. Повторите попытку.",
    "Unable to create folder. Please try again.": "Не удалось создать папку. Повторите попытку.",
    "media_picker.error.prepare_upload": "Не удалось подготовить загрузку",
    "Unable to prepare upload": "Не удалось подготовить загрузку",
    "media_picker.error.upload_url": "Отсутствует URL для загрузки",
    "Upload URL missing": "Отсутствует URL для загрузки",
    "media_picker.error.register_media": "Не удалось зарегистрировать медиафайл",
    "media_picker.error.upload_retry": "Не удалось загрузить медиафайл. Повторите попытку.",
    "membership.title": "Членство",
    "membership.description": "Управляйте программами членства, взносами участников, статусами платежей и правилами напоминаний.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Управляйте программами членства, взносами участников, статусами платежей и правилами напоминаний.",
    "membership.action.settings": "Настройки",
    "membership.action.manage_programs": "Управлять программами",
    "Manage programs": "Управлять программами",
    "membership.action.view_data": "Просмотреть данные",
    "View data": "Просмотреть данные",
    "membership.action.edit_listing": "Изменить объявление",
    "membership.action.go_to_listings": "Перейти к объявлениям",
    "Go to listings": "Перейти к объявлениям",
    "membership.action.view_order": "Просмотреть заказ",
    "View order": "Просмотреть заказ",
    "membership.action.configure_reminders": "Настроить напоминания",
    "Configure reminders": "Настроить напоминания",
    "membership.stat.programs": "Программы",
    "membership.stat.active_members": "Активные участники",
    "Active members": "Активные участники",
    "membership.stat.contributions": "Взносы",
    "Contributions": "Взносы",
    "membership.stat.units": "Начисленные единицы",
    "Units credited": "Начисленные единицы",
    "membership.programs.title": "Программы",
    "membership.programs.description": "Объявления типа «Членство», доступные клиентам.",
    "Membership-type listings available to your customers.": "Объявления типа «Членство», доступные клиентам.",
    "membership.programs.no_description": "Описания программы пока нет.",
    "No program description yet.": "Описания программы пока нет.",
    "membership.programs.empty_title": "Программ членства пока нет",
    "No membership programs yet": "Программ членства пока нет",
    "membership.programs.empty_description": "Создайте объявление типа «Членство», чтобы начать принимать взносы.",
    "Create a listing with type membership to start accepting contributions.": "Создайте объявление типа «Членство», чтобы начать принимать взносы.",
    "membership.programs.history_description": "История цен и зарегистрированные участники.",
    "Price history and enrolled members.": "История цен и зарегистрированные участники.",
    "membership.badge": "Членство",
    "membership.loading_program": "Загрузка данных программы…",
    "Loading program data…": "Загрузка данных программы…",
    "membership.price_logs.title": "История цен",
    "Price logs": "История цен",
    "membership.price_logs.empty": "Записей о ценах нет.",
    "No price logs recorded.": "Записей о ценах нет.",
    "membership.source.manual": "вручную",
    "manual": "вручную",
    "membership.members.title": "Участники",
    "Members": "Участники",
    "membership.members.empty_program": "В этой программе пока нет участников.",
    "No members enrolled in this program.": "В этой программе пока нет участников.",
    "membership.members.recent": "Новые участники",
    "Recent members": "Новые участники",
    "membership.members.empty_recent": "После регистрации здесь появятся участники и взносы.",
    "Members and contributions will appear here after enrolment.": "После регистрации здесь появятся участники и взносы.",
    "membership.member_heading": "Участник: {member}",
    "Member: {member}": "Участник: {member}",
    "membership.contributions.title": "Взносы",
    "membership.contributions.empty": "Взносов пока нет.",
    "No contributions recorded yet.": "Взносов пока нет.",
    "membership.payment_dues.title": "Предстоящие платежи",
    "Payment dues": "Предстоящие платежи",
    "membership.payment_dues.empty": "Запланированных платежей нет.",
    "No scheduled payment dues.": "Запланированных платежей нет.",
    "membership.unit": "единица",
    "unit": "единица",
    "membership.units": "единицы",
    "units": "единицы",
    "membership.months": "месяцев",
    "membership.automation.label": "АВТОМАТИЗАЦИЯ",
    "AUTOMATION": "АВТОМАТИЗАЦИЯ",
    "membership.automation.description": "Ежедневный процесс проверяет запланированные платежи членства.",
    "Daily worker checks scheduled membership payments.": "Ежедневный процесс проверяет запланированные платежи членства.",
    "membership.reminders.title": "Напоминания об оплате",
    "Payment reminders": "Напоминания об оплате",
    "membership.reminders.due_soon": "Напоминание о скором сроке оплаты",
    "Due-soon reminder": "Напоминание о скором сроке оплаты",
    "membership.reminders.due_soon_short": "Скоро срок оплаты",
    "Due soon": "Скоро срок оплаты",
    "membership.reminders.due_soon_help": "Отправить одно напоминание до наступления срока запланированного платежа.",
    "Send one reminder before a scheduled payment is due.": "Отправить одно напоминание до наступления срока запланированного платежа.",
    "membership.reminders.days_before": "За сколько дней до срока",
    "Days before due date": "За сколько дней до срока",
    "membership.reminders.days_before_value": "За {count} дней до срока",
    "{count} days before": "За {count} дней до срока",
    "membership.reminders.overdue": "Напоминание о просрочке",
    "Overdue reminder": "Напоминание о просрочке",
    "membership.reminders.overdue_help": "Отправить одно напоминание после даты платежа и льготного периода.",
    "Send one reminder after the due date and grace period.": "Отправить одно напоминание после даты платежа и льготного периода.",
    "membership.settings.title": "Настройки членства",
    "Membership settings": "Настройки членства",
    "membership.settings.description": "Настройте график напоминаний об оплате.",
    "Configure the payment reminder schedule.": "Настройте график напоминаний об оплате.",
    "membership.email_copy.title": "Пользовательский текст писем",
    "Custom email copy": "Пользовательский текст писем",
    "membership.email_copy.description": "Чтобы изменить темы и шаблоны писем о скором сроке и просрочке, откройте «Настройки → Уведомления → Членство».",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Чтобы изменить темы и шаблоны писем о скором сроке и просрочке, откройте «Настройки → Уведомления → Членство».",
    "membership.toast.saved": "Настройки напоминаний сохранены.",
    "Membership reminder settings saved.": "Настройки напоминаний сохранены.",
    "membership.toast.save_failed": "Не удалось сохранить настройки напоминаний.",
    "Unable to save membership reminder settings.": "Не удалось сохранить настройки напоминаний.",
    "common.status.off": "Выкл.",
    "Off": "Выкл.",
    "common.status.on": "Вкл.",
    "On": "Вкл.",
    "common.save_settings": "Сохранить настройки",
    "Save settings": "Сохранить настройки",
    "developer.page.title": "API и разработка",
    "API & Developer": "API и разработка",
    "developer.api_keys.title": "Ключи API",
    "API Keys": "Ключи API",
    "developer.api_keys.description": "Используйте эти ключи для аутентификации запросов к Tradly API. Храните секретный ключ в тайне и никогда не включайте его в клиентский код.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Используйте эти ключи для аутентификации запросов к Tradly API. Храните секретный ключ в тайне и никогда не включайте его в клиентский код.",
    "developer.api_keys.credentials_description": "Ниже приведены рабочие ключи. Они понадобятся для авторизации и создания приложений.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Ниже приведены рабочие ключи. Они понадобятся для авторизации и создания приложений.",
    "developer.api_keys.publishable": "Публичный ключ",
    "Publishable Key": "Публичный ключ",
    "developer.api_keys.publishable_placeholder": "Введите публичный ключ",
    "Enter Publishable Key": "Введите публичный ключ",
    "developer.api_keys.secret": "Секретный ключ",
    "developer.api_keys.secret_placeholder": "Введите секретный ключ",
    "Enter Secret Key": "Введите секретный ключ",
    "developer.api_keys.access_label": "Доступ к API",
    "API access": "Доступ к API",
    "developer.api_reference.title": "Справочник API",
    "developer.api_reference.description": "Полная документация REST API, руководства и примеры кода для работы с маркетплейсом Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Полная документация REST API, руководства и примеры кода для работы с маркетплейсом Tradly.",
    "developer.api_reference.card_description": "Изучите справочник API, руководства по аутентификации, вебхуки и документацию SDK. Все необходимое для интеграции и создания собственных интерфейсов поверх маркетплейса.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Изучите справочник API, руководства по аутентификации, вебхуки и документацию SDK. Все необходимое для интеграции и создания собственных интерфейсов поверх маркетплейса.",
    "developer.api_reference.open_docs": "Открыть документацию API",
    "Open API Docs": "Открыть документацию API",
    "developer.ai_agents.title": "ИИ и агенты",
    "AI & Agents": "ИИ и агенты",
    "developer.ai_agents.description": "Подключите маркетплейс к инструментам ИИ и позвольте клиентам создавать агентов на базе вашей платформы.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Подключите маркетплейс к инструментам ИИ и позвольте клиентам создавать агентов на базе вашей платформы.",
    "developer.mcp.action.create": "Создать",
    "developer.mcp.action.removing": "Удаление…",
    "developer.mcp.scope.resource": "Ресурс",
    "developer.customer_agents.description": "Позвольте клиентам создавать ИИ-агентов для работы с маркетплейсом. Поддерживаются ChatGPT, Claude и другие платформы ИИ. Подходит для автоматизации покупок, создания магазинов и интеллектуальных помощников.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Позвольте клиентам создавать ИИ-агентов для работы с маркетплейсом. Поддерживаются ChatGPT, Claude и другие платформы ИИ. Подходит для автоматизации покупок, создания магазинов и интеллектуальных помощников.",
    "whatsapp.title": "Коннектор WhatsApp",
    "WhatsApp connector": "Коннектор WhatsApp",
    "whatsapp.intro.title": "Отправляйте одноразовые коды и маркетинговые сообщения через WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Отправляйте одноразовые коды и маркетинговые сообщения через WhatsApp",
    "whatsapp.intro.help": "Подключите арендатора к Meta WhatsApp Cloud API. SMS остается каналом по умолчанию или резервным каналом. Этот же коннектор отправляет одобренные шаблоны кампаний WhatsApp.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Подключите арендатора к Meta WhatsApp Cloud API. SMS остается каналом по умолчанию или резервным каналом. Этот же коннектор отправляет одобренные шаблоны кампаний WhatsApp.",
    "whatsapp.status.disabled": "Отключено",
    "whatsapp.status.sms_otp": "Коннектор включен · SMS OTP",
    "Connector on · SMS OTP": "Коннектор включен · SMS OTP",
    "whatsapp.status.needs_configuration": "Требуется настройка",
    "Needs configuration": "Требуется настройка",
    "whatsapp.status.auto_fallback": "WhatsApp con fallback SMS",
    "WhatsApp with SMS fallback": "WhatsApp con fallback SMS",
    "whatsapp.status.sms_whatsapp_backup": "SMS с резервом WhatsApp",
    "SMS with WhatsApp backup": "SMS с резервом WhatsApp",
    "whatsapp.status.enabled": "WhatsApp включен",
    "WhatsApp enabled": "WhatsApp включен",
    "whatsapp.draft.notice": "Черновик настроек WhatsApp не сохранен.",
    "You have an unsaved WhatsApp settings draft.": "Черновик настроек WhatsApp не сохранен.",
    "whatsapp.connect.title": "Подключите аккаунт WhatsApp Business",
    "Connect your business WhatsApp": "Подключите аккаунт WhatsApp Business",
    "whatsapp.connect.description": "Введите номер компании, известный вашим клиентам. Meta откроет безопасное окно подтверждения; вам не нужно искать ID WABA, ID номера телефона, токен доступа или параметры API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Введите номер компании, известный вашим клиентам. Meta откроет безопасное окно подтверждения; вам не нужно искать ID WABA, ID номера телефона, токен доступа или параметры API.",
    "whatsapp.field.business_number": "Номер WhatsApp Business",
    "Business WhatsApp number": "Номер WhatsApp Business",
    "whatsapp.field.business_number_help": "Укажите номер, на который клиенты будут отправлять сообщения, включая код страны.",
    "Use the number you want customers to message, including country code.": "Укажите номер, на который клиенты будут отправлять сообщения, включая код страны.",
    "whatsapp.placeholder.business_number": "например, +60 13 333 1671",
    "e.g. +60 13 333 1671": "например, +60 13 333 1671",
    "whatsapp.field.connection_name": "Название подключения",
    "whatsapp.field.connection_name_help": "Укажите понятное название, например Kuala Lumpur, розничный бренд или поддержка.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Укажите понятное название, например Kuala Lumpur, розничный бренд или поддержка.",
    "whatsapp.placeholder.connection_name": "например, поддержка Kuala Lumpur",
    "e.g. Kuala Lumpur support": "например, поддержка Kuala Lumpur",
    "whatsapp.field.optional_details": "Дополнительные сведения о подключении",
    "Optional connection details": "Дополнительные сведения о подключении",
    "whatsapp.field.optional_details_help": "Заполните эти поля, если номер относится к определенному бренду, учетной записи или филиалу.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Заполните эти поля, если номер относится к определенному бренду, учетной записи или филиалу.",
    "whatsapp.field.brand_key": "Ключ бренда",
    "Brand key": "Ключ бренда",
    "whatsapp.field.brand_key_help": "Постоянный внутренний ключ бренда, например retail или wholesale.",
    "Stable internal key for a brand, such as retail or wholesale.": "Постоянный внутренний ключ бренда, например retail или wholesale.",
    "whatsapp.placeholder.brand_key": "например, retail",
    "e.g. retail": "например, retail",
    "whatsapp.field.account_id": "ID учетной записи",
    "whatsapp.field.account_id_help": "Свяжите этот номер с существующей учетной записью Tradly.",
    "Associate this number with an existing Tradly account.": "Свяжите этот номер с существующей учетной записью Tradly.",
    "whatsapp.placeholder.account_id": "например, 123",
    "e.g. 123": "например, 123",
    "whatsapp.field.branch_id": "ID филиала",
    "Branch ID": "ID филиала",
    "whatsapp.field.branch_id_help": "Свяжите этот номер с существующим филиалом Tradly.",
    "Associate this number with an existing Tradly branch.": "Свяжите этот номер с существующим филиалом Tradly.",
    "whatsapp.placeholder.branch_id": "например, 456",
    "e.g. 456": "например, 456",
    "whatsapp.field.default_connection": "Использовать как подключение по умолчанию",
    "Use as default connection": "Использовать как подключение по умолчанию",
    "whatsapp.field.default_connection_help": "Старые потоки OTP используют выбранное подключение по умолчанию, если для филиала не выбрано отдельное.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Старые потоки OTP используют выбранное подключение по умолчанию, если для филиала не выбрано отдельное.",
    "whatsapp.field.uses_business_app": "Я использую приложение WhatsApp Business на этом номере",
    "I use the WhatsApp Business app on this number": "Я использую приложение WhatsApp Business на этом номере",
    "whatsapp.field.uses_business_app_help": "Продолжайте общаться в приложении WhatsApp Business на телефоне. Meta попросит отсканировать QR-код в приложении, а контакты и недавние чаты будут синхронизированы. Нужна версия 2.24.17 или новее.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Продолжайте общаться в приложении WhatsApp Business на телефоне. Meta попросит отсканировать QR-код в приложении, а контакты и недавние чаты будут синхронизированы. Нужна версия 2.24.17 или новее.",
    "whatsapp.connected.business_account": "Аккаунт WhatsApp Business",
    "WhatsApp business account": "Аккаунт WhatsApp Business",
    "whatsapp.connected.template_ready": "Шаблон аутентификации готов · для одноразовых кодов можно использовать WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Шаблон аутентификации готов · для одноразовых кодов можно использовать WhatsApp.",
    "whatsapp.connected.template_pending": "Подключено · SMS остается резервным каналом, пока шаблон аутентификации не одобрен.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Подключено · SMS остается резервным каналом, пока шаблон аутентификации не одобрен.",
    "whatsapp.action.connect": "Подключить WhatsApp",
    "Connect WhatsApp": "Подключить WhatsApp",
    "whatsapp.action.reconnect": "Переподключить WhatsApp",
    "Reconnect WhatsApp": "Переподключить WhatsApp",
    "whatsapp.connections.title": "Подключенные номера WhatsApp",
    "Connected WhatsApp numbers": "Подключенные номера WhatsApp",
    "whatsapp.connections.description": "Каждый номер может относиться к разному бренду, аккаунту или филиалу. Выберите номер перед активацией шаблонов.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Каждый номер может относиться к разному бренду, аккаунту или филиалу. Выберите номер перед активацией шаблонов.",
    "whatsapp.connections.unnamed": "Подключение WhatsApp",
    "WhatsApp connection": "Подключение WhatsApp",
    "whatsapp.connections.default": "По умолчанию",
    "whatsapp.connections.account": "Аккаунт {id}",
    "Account {id}": "Аккаунт {id}",
    "whatsapp.connections.branch": "Филиал {id}",
    "Branch {id}": "Филиал {id}",
    "whatsapp.connections.tenant_wide": "Подключение для всего арендатора",
    "Tenant-wide connection": "Подключение для всего арендатора",
    "whatsapp.action.make_default": "Сделать основным",
    "Make default": "Сделать основным",
    "whatsapp.notice.default_updated": "Основное подключение WhatsApp обновлено.",
    "Default WhatsApp connection updated.": "Основное подключение WhatsApp обновлено.",
    "whatsapp.error.default_update": "Не удалось изменить основное подключение.",
    "Unable to change the default connection.": "Не удалось изменить основное подключение.",
    "whatsapp.templates.title": "Шаблоны сообщений",
    "Message templates": "Шаблоны сообщений",
    "whatsapp.templates.description": "Выберите готовый шаблон. Tradly отправит его в Meta на проверку и автоматически активирует после одобрения.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Выберите готовый шаблон. Tradly отправит его в Meta на проверку и автоматически активирует после одобрения.",
    "whatsapp.template.status.not_activated": "Не активирован",
    "Not activated": "Не активирован",
    "whatsapp.template.status.approved": "Одобрен",
    "whatsapp.template.status.pending": "Ожидает",
    "whatsapp.template.status.submitted": "Отправлен на проверку",
    "whatsapp.template.action.active": "Активен",
    "whatsapp.template.action.submitted": "Отправлен",
    "whatsapp.template.action.activate": "Активировать шаблон",
    "Activate template": "Активировать шаблон",
    "whatsapp.notice.template_active": "Шаблон {name} одобрен и активен.",
    "{name} is approved and active.": "Шаблон {name} одобрен и активен.",
    "whatsapp.notice.template_submitted": "Шаблон {name} отправлен в Meta на проверку. До одобрения можно использовать SMS.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "Шаблон {name} отправлен в Meta на проверку. До одобрения можно использовать SMS.",
    "whatsapp.channel.title": "Канал доставки",
    "Delivery channel": "Канал доставки",
    "whatsapp.channel.help": "Переключатель включает WhatsApp для вашего бизнеса. Коды входа можно отправлять только по SMS, только в WhatsApp или по SMS с резервом в WhatsApp; для вариантов с WhatsApp нужен одобренный шаблон кода.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "Переключатель включает WhatsApp для вашего бизнеса. Коды входа можно отправлять только по SMS, только в WhatsApp или по SMS с резервом в WhatsApp; для вариантов с WhatsApp нужен одобренный шаблон кода.",
    "whatsapp.channel.primary_otp": "Основной канал одноразовых кодов",
    "Primary OTP channel": "Основной канал одноразовых кодов",
    "whatsapp.channel.sms_description": "Оставить существующий способ отправки SMS.",
    "Keep the existing SMS delivery path.": "Оставить существующий способ отправки SMS.",
    "whatsapp.channel.whatsapp_description": "Использовать Meta Cloud API для этого арендатора.",
    "Use Meta Cloud API for this tenant.": "Использовать Meta Cloud API для этого арендатора.",
    "whatsapp.channel.automatic": "Автоматически",
    "Automatic": "Автоматически",
    "whatsapp.channel.automatic_description": "Использовать WhatsApp, если он настроен, иначе SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Использовать WhatsApp, если он настроен, иначе SMS.",
    "whatsapp.channel.fallback": "Резервный канал после сбоя WhatsApp",
    "Fallback after WhatsApp failure": "Резервный канал после сбоя WhatsApp",
    "whatsapp.channel.no_fallback": "Без резервного канала",
    "No fallback": "Без резервного канала",
    "whatsapp.channel.no_fallback_description": "Вернуть настроенный результат доставки.",
    "Return the configured delivery result.": "Вернуть настроенный результат доставки.",
    "whatsapp.channel.sms_fallback_description": "Повторить отправку с тем же кодом OTP через SMS.",
    "Try SMS with the same OTP code.": "Повторить отправку с тем же кодом OTP через SMS.",
    "whatsapp.channel.sms_only": "Только SMS",
    "SMS only": "Только SMS",
    "whatsapp.channel.sms_only_description": "Коды отправляются по SMS.",
    "Codes are sent by text message.": "Коды отправляются по SMS.",
    "whatsapp.channel.whatsapp_only": "Только WhatsApp",
    "WhatsApp only": "Только WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "Коды отправляются с вашего номера WhatsApp.",
    "Codes are sent from your WhatsApp number.": "Коды отправляются с вашего номера WhatsApp.",
    "whatsapp.channel.sms_whatsapp": "SMS, резерв — WhatsApp",
    "SMS, WhatsApp as backup": "SMS, резерв — WhatsApp",
    "whatsapp.channel.sms_whatsapp_description": "Коды отправляются по SMS; если SMS не доходит, тот же код приходит в WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Коды отправляются по SMS; если SMS не доходит, тот же код приходит в WhatsApp.",
    "whatsapp.advanced.title": "Технические настройки восстановления",
    "Technical recovery settings": "Технические настройки восстановления",
    "whatsapp.advanced.description": "Только для поддержки платформы. Большинству компаний достаточно кнопки «Подключить WhatsApp» выше.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Только для поддержки платформы. Большинству компаний достаточно кнопки «Подключить WhatsApp» выше.",
    "whatsapp.field.phone_number_id": "ID номера телефона WhatsApp",
    "WhatsApp phone number ID": "ID номера телефона WhatsApp",
    "whatsapp.field.phone_number_id_help": "ID номера телефона, связанный с аккаунтом WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "ID номера телефона, связанный с аккаунтом WhatsApp Business.",
    "whatsapp.field.waba_id": "ID аккаунта WhatsApp Business",
    "WhatsApp Business Account ID": "ID аккаунта WhatsApp Business",
    "whatsapp.field.waba_id_help": "Показан рядом с ID номера в Meta (WhatsApp > API Setup). Нужен для шаблонов и тестовых сообщений.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Показан рядом с ID номера в Meta (WhatsApp > API Setup). Нужен для шаблонов и тестовых сообщений.",
    "whatsapp.placeholder.phone_number_id": "например: 123456789012345",
    "e.g. 123456789012345": "например: 123456789012345",
    "whatsapp.field.access_token": "Токен доступа Meta",
    "Meta access token": "Токен доступа Meta",
    "whatsapp.field.access_token_saved_help": "Безопасно сохранен на сервере. Оставьте поле пустым, чтобы не менять его, или вставьте новый токен для замены.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Безопасно сохранен на сервере. Оставьте поле пустым, чтобы не менять его, или вставьте новый токен для замены.",
    "whatsapp.field.access_token_help": "Используйте токен системного пользователя с разрешением на отправку сообщений WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Используйте токен системного пользователя с разрешением на отправку сообщений WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Безопасно сохранен · оставьте пустым",
    "Saved securely · leave blank to keep": "Безопасно сохранен · оставьте пустым",
    "whatsapp.placeholder.access_token": "Вставьте токен",
    "Paste token": "Вставьте токен",
    "whatsapp.token.saved": "Токен доступа Meta безопасно сохранен",
    "Meta access token saved securely": "Токен доступа Meta безопасно сохранен",
    "whatsapp.field.otp_template": "Название одобренного шаблона OTP",
    "Approved OTP template name": "Название одобренного шаблона OTP",
    "whatsapp.field.otp_template_help": "В тексте шаблона одноразовый код должен передаваться как один текстовый параметр.",
    "The template body must accept the OTP as one text parameter.": "В тексте шаблона одноразовый код должен передаваться как один текстовый параметр.",
    "whatsapp.placeholder.otp_template": "например: login_verification",
    "e.g. login_verification": "например: login_verification",
    "whatsapp.field.template_language": "Язык шаблона",
    "Template language": "Язык шаблона",
    "whatsapp.field.marketing_template": "Название одобренного маркетингового шаблона (необязательно)",
    "Approved marketing template name (optional)": "Название одобренного маркетингового шаблона (необязательно)",
    "whatsapp.field.marketing_template_help": "Используйте одобренный маркетинговый шаблон Meta. Кампания может переопределить это название в content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Используйте одобренный маркетинговый шаблон Meta. Кампания может переопределить это название в content.template_name.",
    "whatsapp.placeholder.marketing_template": "например: monthly_offer",
    "e.g. monthly_offer": "например: monthly_offer",
    "whatsapp.field.marketing_language": "Язык маркетингового шаблона",
    "Marketing template language": "Язык маркетингового шаблона",
    "whatsapp.info.title": "Перед включением WhatsApp",
    "Before enabling WhatsApp": "Перед включением WhatsApp",
    "whatsapp.info.description": "Перед отправкой Meta должна одобрить каждый шаблон OTP или маркетинговый шаблон. Для сообщений WhatsApp в кампании используются template_name, template_language и необязательные параметры текста; номера получателей должны быть в формате E.164. При включенном резервном канале ArcticOwl повторно отправит исходный OTP по SMS, не создавая новый код.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Перед отправкой Meta должна одобрить каждый шаблон OTP или маркетинговый шаблон. Для сообщений WhatsApp в кампании используются template_name, template_language и необязательные параметры текста; номера получателей должны быть в формате E.164. При включенном резервном канале ArcticOwl повторно отправит исходный OTP по SMS, не создавая новый код.",
    "whatsapp.action.hide_token": "Токен доступа Meta скрыт",
    "Hide Meta access token": "Токен доступа Meta скрыт",
    "whatsapp.action.show_token": "Показать токен доступа Meta",
    "Show Meta access token": "Показать токен доступа Meta",
    "whatsapp.error.generic": "Не удалось сохранить настройки WhatsApp.",
    "Unable to save WhatsApp settings.": "Не удалось сохранить настройки WhatsApp.",
    "whatsapp.error.browser_required": "Подключение WhatsApp доступно только в браузере.",
    "WhatsApp connection is only available in a browser.": "Подключение WhatsApp доступно только в браузере.",
    "whatsapp.error.meta_load": "Не удалось загрузить Meta. Проверьте настройки конфиденциальности браузера и повторите попытку.",
    "Meta could not load. Check the browser privacy settings and try again.": "Не удалось загрузить Meta. Проверьте настройки конфиденциальности браузера и повторите попытку.",
    "whatsapp.error.load": "Не удалось загрузить настройки WhatsApp.",
    "Unable to load WhatsApp settings.": "Не удалось загрузить настройки WhatsApp.",
    "whatsapp.error.connect_before_template": "Сначала подключите WhatsApp, затем активируйте шаблон.",
    "Connect WhatsApp before activating a template.": "Сначала подключите WhatsApp, затем активируйте шаблон.",
    "whatsapp.error.template_submit": "Не удалось отправить шаблон WhatsApp на проверку.",
    "Unable to submit the WhatsApp template.": "Не удалось отправить шаблон WhatsApp на проверку.",
    "whatsapp.error.business_number_required": "Перед подключением введите номер WhatsApp Business. Meta проверит его на следующем шаге.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Перед подключением введите номер WhatsApp Business. Meta проверит его на следующем шаге.",
    "whatsapp.error.signup_not_ready": "Платформа еще настраивает подключение WhatsApp. Повторите попытку через некоторое время.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "Платформа еще настраивает подключение WhatsApp. Повторите попытку через некоторое время.",
    "whatsapp.error.signup_cancelled": "Подключение Meta отменено или код авторизации не получен.",
    "Meta connection was cancelled or did not return an authorization code.": "Подключение Meta отменено или код авторизации не получен.",
    "whatsapp.error.phone_number_missing": "Meta не вернула выбранный номер WhatsApp Business. Повторите подключение.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta не вернула выбранный номер WhatsApp Business. Повторите подключение.",
    "whatsapp.notice.connected_auto": "WhatsApp подключен. Для OTP сначала используется WhatsApp, а при сбое — SMS.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp подключен. Для OTP сначала используется WhatsApp, а при сбое — SMS.",
    "whatsapp.notice.connected_sms": "WhatsApp подключен. SMS останется активным, пока Meta не одобрит шаблон аутентификации.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp подключен. SMS останется активным, пока Meta не одобрит шаблон аутентификации.",
    "whatsapp.error.connect": "Не удалось подключить WhatsApp.",
    "Unable to connect WhatsApp.": "Не удалось подключить WhatsApp.",
    "whatsapp.error.otp_configuration": "Для OTP через WhatsApp или Автоматически требуются ID номера, название одобренного шаблона OTP и токен доступа Meta. Для маркетинговых сообщений выберите SMS как основной канал OTP и оставьте коннектор включенным.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "Для OTP через WhatsApp или Автоматически требуются ID номера, название одобренного шаблона OTP и токен доступа Meta. Для маркетинговых сообщений выберите SMS как основной канал OTP и оставьте коннектор включенным.",
    "whatsapp.notice.saved": "Настройки коннектора WhatsApp для этого клиента сохранены.",
    "WhatsApp connector settings saved for this tenant.": "Настройки коннектора WhatsApp для этого клиента сохранены.",
    "whatsapp.error.save": "Не удалось сохранить настройки WhatsApp.",
    "whatsapp.notice.discarded": "Taslak iptal edildi.",
    "whatsapp.test.title": "Отправить тестовое сообщение",
    "Send a test message": "Отправить тестовое сообщение",
    "whatsapp.test.description": "Отправьте одобренный шаблон на любой номер WhatsApp и проверьте что подключение работает.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Отправьте одобренный шаблон на любой номер WhatsApp и проверьте что подключение работает.",
    "whatsapp.test.refresh": "Обновить шаблоны",
    "Refresh templates": "Обновить шаблоны",
    "whatsapp.test.field.template": "Одобренный шаблон",
    "Approved template": "Одобренный шаблон",
    "whatsapp.test.field.parameter": "Значение для {{{number}}}",
    "Value for {{{number}}}": "Значение для {{{number}}}",
    "whatsapp.test.field.mobile": "Отправить на",
    "Send to": "Отправить на",
    "whatsapp.test.field.mobile_help": "Номер WhatsApp с кодом страны.",
    "WhatsApp number with country code.": "Номер WhatsApp с кодом страны.",
    "whatsapp.test.action.send": "Отправить тестовое сообщение",
    "Send test message": "Отправить тестовое сообщение",
    "whatsapp.test.sent": "Отправлено на {mobile}. ID сообщения Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Отправлено на {mobile}. ID сообщения Meta: {id}",
    "whatsapp.test.no_templates": "Одобренных шаблонов пока нет. Активируйте шаблон выше и отправьте его после одобрения Meta.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Одобренных шаблонов пока нет. Активируйте шаблон выше и отправьте его после одобрения Meta.",
    "common.discard_draft": "Удалить черновик",
    "common.status.connected": "Подключено",
    "Connected": "Подключено",
    "extensions.title": "Расширения",
    "extensions.action.add": "Добавить расширение",
    "Add Extension": "Добавить расширение",
    "extensions.action.add_new": "Добавить расширение",
    "Add New Extension": "Добавить расширение",
    "extensions.action.edit": "Изменить расширение",
    "Edit Extension": "Изменить расширение",
    "extensions.action.delete": "Удалить расширение",
    "Delete extension": "Удалить расширение",
    "extensions.field.name": "Название",
    "extensions.field.domain": "Домен",
    "extensions.field.configs": "Настройки",
    "Configs": "Настройки",
    "extensions.placeholder.name": "Название расширения",
    "Extension Name": "Название расширения",
    "extensions.placeholder.domain": "Домен расширения",
    "Extension Domain": "Домен расширения",
    "extensions.empty": "Расширения еще не настроены.",
    "No extensions configured yet.": "Расширения еще не настроены.",
    "extensions.toast.added": "Расширение успешно добавлено.",
    "Extension added successfully.": "Расширение успешно добавлено.",
    "extensions.toast.updated": "Расширение успешно обновлено.",
    "Extension updated successfully.": "Расширение успешно обновлено.",
    "extensions.toast.deleted": "Расширение успешно удалено.",
    "Extension deleted successfully.": "Расширение успешно удалено.",
    "extensions.error.name_required": "Укажите название",
    "extensions.error.domain_required": "Укажите домен",
    "Domain is required": "Укажите домен",
    "extensions.error.configs_required": "Укажите настройки",
    "Configs is required": "Укажите настройки",
    "extensions.error.save_failed": "Не удалось сохранить расширение.",
    "Unable to save the extension.": "Не удалось сохранить расширение.",
    "extensions.error.delete_failed": "Не удалось удалить расширение.",
    "Unable to delete the extension.": "Не удалось удалить расширение.",
    "automation_rules.kicker": "Автоматизация операций",
    "Operations automation": "Автоматизация операций",
    "automation_rules.title": "Правила автоматизации",
    "Automation rules": "Правила автоматизации",
    "automation_rules.description": "Преобразуйте события персонала и расходов в понятные этапы одобрения и проверки.",
    "Turn staff and expense events into clear approval and review steps.": "Преобразуйте события персонала и расходов в понятные этапы одобрения и проверки.",
    "automation_rules.action.new_rule": "Новое правило",
    "New rule": "Новое правило",
    "automation_rules.action.create_rule": "Создать правило",
    "Create rule": "Создать правило",
    "automation_rules.action.create_help": "Сохранить этот триггер, условия и действие как правило",
    "Save this trigger, conditions, and action as a rule": "Сохранить этот триггер, условия и действие как правило",
    "automation_rules.action.add_condition": "Добавить условие",
    "Add condition": "Добавить условие",
    "automation_rules.action.add_condition_help": "Добавить еще одно условие к этому правилу",
    "Add another condition to this rule": "Добавить еще одно условие к этому правилу",
    "automation_rules.action.remove_condition": "Удалить условие",
    "Remove condition": "Удалить условие",
    "automation_rules.action.choose": "Выберите действие",
    "Choose an action": "Выберите действие",
    "automation_rules.action.require_second_approver": "Запросить второго согласующего",
    "Require second approver": "Запросить второго согласующего",
    "automation_rules.action.require_second_approver_help": "Направить заявку другому согласующему.",
    "Route the claim to another approver.": "Направить заявку другому согласующему.",
    "automation_rules.action.auto_reject_expense": "Автоматически отклонить расход",
    "Auto-reject expense": "Автоматически отклонить расход",
    "automation_rules.action.auto_reject_expense_help": "Отклонить расход с указанием причины.",
    "Reject the expense with a reason.": "Отклонить расход с указанием причины.",
    "automation_rules.action.notify_role": "Уведомить роль",
    "Notify a role": "Уведомить роль",
    "automation_rules.action.notify_role_help": "Отправить уведомление сотруднику с указанной ролью.",
    "Send a notification to a staff role.": "Отправить уведомление сотруднику с указанной ролью.",
    "automation_rules.action.flag_for_review": "Отметить для проверки",
    "Flag for review": "Отметить для проверки",
    "automation_rules.action.flag_for_review_help": "Пометить ресурс для ручной проверки.",
    "Mark a resource for manual review.": "Пометить ресурс для ручной проверки.",
    "automation_rules.field.rule_name": "Название правила",
    "Rule name": "Название правила",
    "automation_rules.field.priority": "Приоритет",
    "automation_rules.field.module": "Модуль",
    "Module": "Модуль",
    "automation_rules.field.event": "Событие",
    "automation_rules.field.field": "Поле",
    "Field": "Поле",
    "automation_rules.field.operator": "Оператор",
    "Operator": "Оператор",
    "automation_rules.field.value": "Значение",
    "automation_rules.field.action": "Действие",
    "automation_rules.field.action_params": "Параметры действия",
    "Action parameters": "Параметры действия",
    "automation_rules.placeholder.rule_name": "Запрашивать второго согласующего для крупных расходов",
    "Require second approver for large claims": "Запрашивать второго согласующего для крупных расходов",
    "automation_rules.placeholder.field": "сумма",
    "amount": "сумма",
    "automation_rules.placeholder.value": "500 или false",
    "500 or false": "500 или false",
    "automation_rules.builder.description": "Настройте триггер, условия и действие ниже, затем сохраните их как одно правило.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Настройте триггер, условия и действие ниже, затем сохраните их как одно правило.",
    "automation_rules.error.load": "Не удалось загрузить правила автоматизации.",
    "Unable to load automation rules.": "Не удалось загрузить правила автоматизации.",
    "automation_rules.error.required_fields": "Обязательны название, модуль, событие и действие.",
    "Name, module, event, and action are required.": "Обязательны название, модуль, событие и действие.",
    "automation_rules.error.create": "Не удалось создать правило автоматизации.",
    "Unable to create automation rule.": "Не удалось создать правило автоматизации.",
    "automation_rules.error.valid_json": "Перед сохранением укажите корректный JSON.",
    "Use valid JSON before saving.": "Перед сохранением укажите корректный JSON.",
    "automation_rules.notice.created": "Правило автоматизации создано.",
    "Automation rule created.": "Правило автоматизации создано.",
    "automation_rules.notice.discarded": "Черновик отменен.",
    "automation_rules.draft.restored": "Восстановлен несохраненный черновик правила автоматизации.",
    "Your unsaved automation rule draft was restored.": "Восстановлен несохраненный черновик правила автоматизации.",
    "automation_rules.list.title": "Правила",
    "automation_rules.list.count": "Настроено: {count}",
    "{count} configured": "Настроено: {count}",
    "automation_rules.list.loading": "Загрузка правил…",
    "Loading rules…": "Загрузка правил…",
    "automation_rules.list.unnamed": "Правило без названия",
    "Unnamed rule": "Правило без названия",
    "automation_rules.list.no_action": "Действие не настроено",
    "No action configured": "Действие не настроено",
    "automation_rules.list.empty": "Правил пока нет. Создайте первое на схеме.",
    "No rules yet. Create the first one from the diagram.": "Правил пока нет. Создайте первое на схеме.",
    "automation_rules.status.draft": "Черновик",
    "automation_rules.status.active": "Активно",
    "automation_rules.inspector.title": "Настройки блока",
    "Block settings": "Настройки блока",
    "automation_rules.inspector.diagram": "Схема",
    "Diagram": "Схема",
    "automation_rules.inspector.select_block": "Выберите блок на схеме, чтобы настроить его.",
    "Select a block on the diagram to configure it.": "Выберите блок на схеме, чтобы настроить его.",
    "automation_rules.inspector.no_configuration": "Для этого блока настройка не требуется.",
    "This block does not need configuration.": "Для этого блока настройка не требуется.",
    "automation_rules.node.trigger": "Триггер",
    "automation_rules.node.condition": "Условие",
    "automation_rules.node.action": "Действие",
    "automation_rules.node.end": "Завершение",
    "automation_rules.node.completed": "Завершено",
    "automation_rules.node.finished": "Проверка правила завершена",
    "Rule evaluation finished": "Проверка правила завершена",
    "automation_rules.trigger.choose_event": "Выберите событие",
    "Choose an event": "Выберите событие",
    "automation_rules.trigger.module": "модуль",
    "module": "модуль",
    "automation_rules.trigger.module_event": "Событие модуля {module}",
    "{module} event": "Событие модуля {module}",
    "automation_rules.trigger.help": "Правило выполняется при возникновении этого события в модуле.",
    "The rule evaluates when this event is emitted by the module.": "Правило выполняется при возникновении этого события в модуле.",
    "automation_rules.condition.label": "Условие",
    "automation_rules.condition.none": "Без условий",
    "No conditions": "Без условий",
    "automation_rules.condition.always_fires": "Срабатывает всегда",
    "Always fires": "Срабатывает всегда",
    "automation_rules.condition.empty_help": "Добавьте условие, чтобы ограничить применение правила.",
    "Add a condition to restrict this rule.": "Добавьте условие, чтобы ограничить применение правила.",
    "automation_rules.condition.value_required": "Укажите значение",
    "Value required": "Укажите значение",
    "automation_rules.condition.value": "Значение: {value}",
    "Value: {value}": "Значение: {value}",
    "automation_rules.operator.equals": "Равно",
    "Equals": "Равно",
    "automation_rules.operator.gt": "Больше",
    "Greater than": "Больше",
    "automation_rules.operator.gte": "Больше или равно",
    "Greater than or equal": "Больше или равно",
    "automation_rules.operator.lt": "Меньше",
    "Less than": "Меньше",
    "automation_rules.operator.exists": "Существует",
    "Exists": "Существует",
    "automation_rules.module.expenses": "Расходы",
    "automation_rules.module.staff": "Персонал",
    "automation_rules.event.expense.submitted": "Расход отправлен",
    "automation_rules.event.leave.requested": "Запрошен отпуск",
    "Leave requested": "Запрошен отпуск",
    "automation_rules.event.payroll_run.created": "Создан расчет зарплаты",
    "automation_rules.meta.conditions": "Условий: {count} · действие выполняется, если выполнены все",
    "{count} condition(s) · all must match before the action runs": "Условий: {count} · действие выполняется, если выполнены все",
    "automation_rules.meta.no_conditions": "Без условий · действие выполняется после триггера",
    "No conditions · the action always runs after the trigger": "Без условий · действие выполняется после триггера",
    "automation_rules.draft.unsaved": "Есть несохраненный черновик правила автоматизации.",
    "You have an unsaved automation rule draft.": "Есть несохраненный черновик правила автоматизации.",
    "automation_rules.meta.one_condition": "1 условие · действие выполняется, если оно выполнено",
    "1 condition · all must match before the action runs": "1 условие · действие выполняется, если оно выполнено",
    "automation_rules.meta.many_conditions": "Условий: {count} · действие выполняется, если выполнены все",
    "{count} conditions · all must match before the action runs": "Условий: {count} · действие выполняется, если выполнены все",
    "cms.type.page": "Страница",
    "Page": "Страница",
    "cms.type.blog": "Блог",
    "cms.type.docs": "Документация",
    "Docs": "Документация",
    "cms.type.pages": "Страницы",
    "cms.type.blogs": "Блоги",
    "Blogs": "Блоги",
    "cms.action.add_content": "Добавить материал",
    "Add content": "Добавить материал",
    "cms.action.add_type": "Добавить: {type}",
    "cms.action.create_type": "Создать: {type}",
    "Create {type}": "Создать: {type}",
    "cms.action.edit": "Изменить",
    "cms.action.duplicate": "Дублировать",
    "Duplicate": "Дублировать",
    "cms.action.open": "Открыть",
    "cms.field.title": "Заголовок",
    "cms.field.slug": "Короткий адрес",
    "cms.field.content": "Содержимое",
    "cms.field.meta_title": "Мета-заголовок",
    "cms.field.meta_description": "Мета-описание",
    "cms.placeholder.title": "например: О нас",
    "e.g. About us": "например: О нас",
    "cms.placeholder.slug": "o-nas",
    "about-us": "o-nas",
    "cms.placeholder.page_title": "Заголовок страницы",
    "Page title": "Заголовок страницы",
    "cms.placeholder.page_slug": "korotkiy-adres-stranicy",
    "page-slug": "korotkiy-adres-stranicy",
    "cms.placeholder.content": "Введите содержимое…",
    "Write your content here…": "Введите содержимое…",
    "cms.placeholder.meta_title": "По умолчанию используется заголовок",
    "Defaults to title": "По умолчанию используется заголовок",
    "cms.placeholder.meta_description": "Краткое описание для поисковых систем",
    "Short description for search engines": "Краткое описание для поисковых систем",
    "cms.section.seo_optional": "SEO (необязательно)",
    "SEO (optional)": "SEO (необязательно)",
    "cms.error.title_required": "Укажите заголовок.",
    "Title is required.": "Укажите заголовок.",
    "cms.error.content_required": "Добавьте содержимое перед сохранением.",
    "Add some content before saving.": "Добавьте содержимое перед сохранением.",
    "cms.error.create": "Не удалось создать. Повторите попытку.",
    "Failed to create. Please try again.": "Не удалось создать. Повторите попытку.",
    "cms.error.save": "Не удалось сохранить.",
    "Failed to save.": "Не удалось сохранить.",
    "cms.error.load_layer": "Не удалось загрузить этот материал.",
    "Could not load this layer.": "Не удалось загрузить этот материал.",
    "cms.toast.created": "Материал «{type}» успешно создан.",
    "{type} created successfully.": "Материал «{type}» успешно создан.",
    "cms.toast.saved": "Сохранено",
    "Saved": "Сохранено",
    "cms.toast.changes_saved": "Изменения сохранены.",
    "Changes saved.": "Изменения сохранены.",
    "cms.toast.deleted": "Удалено",
    "cms.toast.duplicated": "Создана копия",
    "Duplicated": "Создана копия",
    "cms.error.delete": "Не удалось удалить",
    "Failed to delete": "Не удалось удалить",
    "cms.error.duplicate": "Не удалось создать копию",
    "Failed to duplicate": "Не удалось создать копию",
    "cms.confirm.delete": "Удалить «{title}»?",
    "Delete \"{title}\"?": "Удалить «{title}»?",
    "cms.duplicate.title": "{title} (копия)",
    "{title} (copy)": "{title} (копия)",
    "cms.draft.restored": "Восстановлен несохраненный черновик материала.",
    "Your unsaved content draft was restored.": "Восстановлен несохраненный черновик материала.",
    "cms.search": "Поиск…",
    "Search…": "Поиск…",
    "cms.list.no_results": "Результаты не найдены.",
    "No results found.": "Результаты не найдены.",
    "cms.list.empty_type": "Материалов типа «{type}» пока нет.",
    "No {type} yet.": "Материалов типа «{type}» пока нет.",
    "cms.list.untitled": "Без названия",
    "Untitled": "Без названия",
    "cms.editor.placeholder": "Введите содержимое…",
    "cms.editor.normal_text": "Обычный текст",
    "Normal text": "Обычный текст",
    "cms.editor.heading": "Заголовок {level}",
    "Heading {level}": "Заголовок {level}",
    "cms.editor.align_left": "Выровнять по левому краю",
    "Align Left": "Выровнять по левому краю",
    "cms.editor.align_center": "Выровнять по центру",
    "Align Center": "Выровнять по центру",
    "cms.editor.align_right": "Выровнять по правому краю",
    "Align Right": "Выровнять по правому краю",
    "cms.editor.insert_table": "Вставить таблицу",
    "Insert table": "Вставить таблицу",
    "cms.editor.add_column": "Добавить столбец",
    "Add column": "Добавить столбец",
    "cms.editor.add_row": "Добавить строку",
    "Add row": "Добавить строку",
    "cms.editor.delete_table": "Удалить таблицу",
    "Delete table": "Удалить таблицу",
    "cms.editor.delete_column": "Удалить столбец",
    "Delete column": "Удалить столбец",
    "cms.editor.delete_row": "Удалить строку",
    "Delete row": "Удалить строку",
    "cms.editor.underline": "Подчеркнутый",
    "Underline": "Подчеркнутый",
    "cms.editor.strikethrough": "Зачеркнутый",
    "Strikethrough": "Зачеркнутый",
    "cms.editor.code": "Код",
    "cms.editor.code_block": "Блок кода",
    "Code block": "Блок кода",
    "cms.editor.subscript": "Нижний индекс",
    "Subscript": "Нижний индекс",
    "cms.editor.superscript": "Верхний индекс",
    "Superscript": "Верхний индекс",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL изображения",
    "Image URL": "URL изображения",
    "cms.editor.prompt.youtube_url": "URL YouTube",
    "YouTube URL": "URL YouTube",
    "cms.editor.undo": "Отменить",
    "cms.editor.redo": "Повторить",
    "cms.editor.table": "Таблица",
    "Table": "Таблица",
    "cms.editor.more": "Дополнительно",
    "cms.editor.bold": "Полужирный",
    "Bold": "Полужирный",
    "cms.editor.italic": "Курсив",
    "Italic": "Курсив",
    "cms.editor.bullet_list": "Маркированный список",
    "Bullet list": "Маркированный список",
    "cms.editor.ordered_list": "Нумерованный список",
    "Ordered list": "Нумерованный список",
    "cms.editor.task_list": "Список задач",
    "Task list": "Список задач",
    "cms.editor.link": "Ссылка",
    "Link": "Ссылка",
    "cms.editor.image": "Изображение",
    "cms.editor.text_color": "Цвет текста",
    "Text color": "Цвет текста",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Страницы",
    "cms.test.type.pages_description": "Целевые страницы и структурированные материалы витрины.",
    "Landing pages and structured storefront content.": "Целевые страницы и структурированные материалы витрины.",
    "cms.test.type.blogs": "Блоги",
    "cms.test.type.blogs_description": "Статьи, истории и новости для вашей аудитории.",
    "Articles, stories, and updates for your audience.": "Статьи, истории и новости для вашей аудитории.",
    "cms.test.type.docs": "Документация",
    "cms.test.type.docs_description": "Документация, руководства и справочные материалы.",
    "Documentation, guides, and help content.": "Документация, руководства и справочные материалы.",
    "cms.test.operation.list": "Список материалов по типу",
    "List content by type": "Список материалов по типу",
    "cms.test.operation.fetch": "Загрузить один материал",
    "Fetch one Layer": "Загрузить один материал",
    "cms.test.operation.create": "Создать материал",
    "Create a Layer": "Создать материал",
    "cms.test.operation.update": "Обновить материал",
    "Update a Layer": "Обновить материал",
    "cms.test.operation.delete": "Удалить материал",
    "Delete a Layer": "Удалить материал",
    "cms.test.operation.search": "Поиск материалов",
    "Search content": "Поиск материалов",
    "cms.test.operation.categories": "Загрузить категории",
    "Load categories": "Загрузить категории",
    "cms.test.operation.translations": "Сохранить переводы",
    "Save translations": "Сохранить переводы",
    "cms.test.editor.placeholder": "Введите содержимое страницы…",
    "Write your page content...": "Введите содержимое страницы…",
    "cms.test.error.load_type": "Не удалось загрузить материалы типа «{type}»",
    "Unable to load {type} content": "Не удалось загрузить материалы типа «{type}»",
    "cms.test.error.load": "Не удалось загрузить материалы CMS.",
    "Unable to load CMS content.": "Не удалось загрузить материалы CMS.",
    "cms.test.error.required": "Перед сохранением добавьте заголовок и содержимое страницы.",
    "Add a page title and content before saving.": "Перед сохранением добавьте заголовок и содержимое страницы.",
    "cms.test.error.create": "Не удалось создать страницу.",
    "Unable to create this page.": "Не удалось создать страницу.",
    "cms.test.toast.created": "Страница успешно создана.",
    "Page created successfully.": "Страница успешно создана.",
    "cms.test.hero.eyebrow": "УПРАВЛЕНИЕ КОНТЕНТОМ",
    "CONTENT MANAGEMENT": "УПРАВЛЕНИЕ КОНТЕНТОМ",
    "cms.test.hero.title": "CMS Layers",
    "Layers CMS": "CMS Layers",
    "cms.test.hero.description": "Создавайте структурированный контент один раз и публикуйте его в витрине, приложениях и пользовательских интерфейсах.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Создавайте структурированный контент один раз и публикуйте его в витрине, приложениях и пользовательских интерфейсах.",
    "cms.test.hero.live_workspace": "Рабочая область: {tenant} · предварительный просмотр только для чтения",
    "Live workspace: {tenant} · read-only preview": "Рабочая область: {tenant} · предварительный просмотр только для чтения",
    "cms.test.current_tenant": "текущий арендатор",
    "current tenant": "текущий арендатор",
    "cms.test.content.title": "Ваш контент",
    "Your content": "Ваш контент",
    "cms.test.content.description": "Управляйте страницами, блогами и документацией в одном месте.",
    "Pages, blogs, and docs are ready to manage from one place.": "Управляйте страницами, блогами и документацией в одном месте.",
    "cms.test.action.create_page": "Создать страницу",
    "Create Page": "Создать страницу",
    "cms.test.form.description": "Создайте структурированную страницу в Layers. После сохранения она будет доступна через API.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Создайте структурированную страницу в Layers. После сохранения она будет доступна через API.",
    "cms.test.placeholder.slug": "o-nas (необязательно)",
    "about-us (optional)": "o-nas (необязательно)",
    "cms.test.draft.unsaved": "Есть несохраненный черновик страницы.",
    "You have an unsaved page draft.": "Есть несохраненный черновик страницы.",
    "cms.test.loading": "Загрузка материалов Layers…",
    "Loading live Layers content…": "Загрузка материалов Layers…",
    "cms.test.content.empty_title": "Материалов типа «{type}» пока нет",
    "No {type} yet": "Материалов типа «{type}» пока нет",
    "cms.test.content.empty_description": "Создайте первый материал Layers в рабочей области, чтобы он появился здесь.",
    "Create your first Layer in the workspace to see it here.": "Создайте первый материал Layers в рабочей области, чтобы он появился здесь.",
    "cms.test.feature.types": "Пользовательские типы контента",
    "Custom content types": "Пользовательские типы контента",
    "cms.test.feature.types_description": "Страницы, блоги и документация — это отправные точки. Создайте публикацию или любую другую модель для своего бизнеса.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Страницы, блоги и документация — это отправные точки. Создайте публикацию или любую другую модель для своего бизнеса.",
    "cms.test.feature.structured": "Структурированный контент с переводами",
    "Structured and localized": "Структурированный контент с переводами",
    "cms.test.feature.structured_description": "Используйте короткие адреса, категории, изображения, метаданные SEO и переводы для одного источника контента.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Используйте короткие адреса, категории, изображения, метаданные SEO и переводы для одного источника контента.",
    "cms.test.feature.headless": "Headless по умолчанию",
    "Headless by default": "Headless по умолчанию",
    "cms.test.feature.headless_description": "Используйте Layers API на сайте, в мобильном приложении, внутреннем инструменте или пользовательском интерфейсе.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Используйте Layers API на сайте, в мобильном приложении, внутреннем инструменте или пользовательском интерфейсе.",
    "cms.test.feature.ai": "Источник знаний для ИИ",
    "AI knowledge source": "Источник знаний для ИИ",
    "cms.test.feature.ai_description": "Передавайте контент Tradly CMS в iRyxo Agent Builder как источник знаний.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Передавайте контент Tradly CMS в iRyxo Agent Builder как источник знаний.",
    "cms.test.community.eyebrow": "КОНТЕНТ СООБЩЕСТВА",
    "COMMUNITY CONTENT": "КОНТЕНТ СООБЩЕСТВА",
    "cms.test.community.title": "Превратите Layers в ленту сообщества",
    "Turn Layers into a social feed": "Превратите Layers в ленту сообщества",
    "cms.test.community.description": "Создайте пользовательский тип «Публикация», позвольте пользователям делиться новостями и добавьте взаимодействие через интерфейс.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Создайте пользовательский тип «Публикация», позвольте пользователям делиться новостями и добавьте взаимодействие через интерфейс.",
    "cms.test.community.share_placeholder": "Поделитесь новостью…",
    "Share an update…": "Поделитесь новостью…",
    "cms.test.community.post": "Опубликовать",
    "Post": "Опубликовать",
    "cms.test.community.sample_author": "Алекс Морган",
    "Alex Morgan": "Алекс Морган",
    "cms.test.community.sample_post": "Новость сообщества, опубликованная через пользовательский материал Layers.",
    "A community update published from a custom Layer.": "Новость сообщества, опубликованная через пользовательский материал Layers.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 комментариев   ·   ↗ Поделиться",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 комментариев   ·   ↗ Поделиться",
    "cms.test.community.endpoints": "Примеры конечных точек",
    "Example endpoints": "Примеры конечных точек",
    "cms.test.developer.eyebrow": "ДОСТУП ДЛЯ РАЗРАБОТЧИКОВ",
    "DEVELOPER ACCESS": "ДОСТУП ДЛЯ РАЗРАБОТЧИКОВ",
    "cms.test.developer.title": "API Layers",
    "Layers API": "API Layers",
    "cms.test.developer.docs": "Документация для разработчиков",
    "Developer docs": "Документация для разработчиков",
    "auth.title": "Аутентификация",
    "auth.sign_in_method": "Способ входа",
    "auth.facebook_auth": "Аутентификация через Facebook",
    "auth.google_auth": "Аутентификация через Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "Корпоративная единая система входа",
    "Enterprise SSO": "Корпоративная единая система входа",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "Настройки оформления заказа",
    "Checkout Settings": "Настройки оформления заказа",
    "checkout.orders": "Заказы",
    "checkout.carts": "Корзины",
    "Carts": "Корзины",
    "audit_logs.action": "Действие",
    "audit_logs.resource": "Ресурс",
    "audit_logs.resource_id": "ID ресурса",
    "Resource ID": "ID ресурса",
    "audit_logs.agent_id": "ID агента",
    "Agent ID": "ID агента",
    "audit_logs.result": "Результат",
    "audit_logs.actor_id": "ID исполнителя",
    "Actor ID": "ID исполнителя",
    "audit_logs.ip": "IP-адрес",
    "IP": "IP-адрес",
    "audit_logs.timestamp": "Время",
    "Timestamp": "Время",
    "audit_logs.succeeded": "Выполнено",
    "audit_logs.failed": "Не выполнено",
    "audit_logs.source": "Источник",
    "audit_logs.all_sources": "Все источники",
    "All sources": "Все источники",
    "audit_logs.human_admin": "Человек (администратор)",
    "Human (admin)": "Человек (администратор)",
    "audit_logs.agent_mcp": "Агент (MCP)",
    "Agent (MCP)": "Агент (MCP)",
    "audit_logs.all_actions": "Все действия",
    "All actions": "Все действия",
    "audit_logs.from": "С",
    "audit_logs.to": "По",
    "audit_logs.apply": "Применить",
    "audit_logs.clear": "Очистить",
    "audit_logs.export_csv": "Экспортировать CSV",
    "audit_logs.exporting": "Экспорт…",
    "audit_logs.title": "Журнал аудита",
    "audit_logs.empty_title": "Журнал аудита не найден",
    "No audit logs found": "Журнал аудита не найден",
    "audit_logs.empty_subtitle": "Попробуйте изменить фильтры",
    "Try adjusting your filters": "Попробуйте изменить фильтры",
    "audit_logs.restriction_notice": "Показаны последние 5 записей аудита. Перейдите на тариф Growth, чтобы просматривать всю историю и экспортировать журналы.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Показаны последние 5 записей аудита. Перейдите на тариф Growth, чтобы просматривать всю историю и экспортировать журналы.",
    "audit_logs.extended_history": "Расширенная история аудита",
    "Extended audit log history": "Расширенная история аудита",
    "manage_features.title": "Управление функциями",
    "manage_features.general": "Общие",
    "manage_features.apps": "Приложения",
    "manage_features.marketplace": "Маркетплейс",
    "manage_features.commerce": "Торговля",
    "manage_features.channels": "Каналы",
    "manage_features.left_menu": "Левое меню",
    "Left Menu": "Левое меню",
    "manage_features.right_sidepanel": "Правая боковая панель",
    "Right Sidepanel": "Правая боковая панель",
    "workflow.integration": "Интеграция",
    "workflow.no_url_title": "URL интеграции отсутствует",
    "No Integration URL": "URL интеграции отсутствует",
    "workflow.no_url_description": "Настройте URL интеграции.",
    "Please configure the integration URL.": "Настройте URL интеграции.",
    "workflow.back": "Назад",
    "Go Back": "Назад",
    "workflow.loading": "Загрузка интеграции…",
    "Loading integration...": "Загрузка интеграции…",
    "workflow.loading_hint": "Подождите, идет подключение",
    "Please wait while we connect": "Подождите, идет подключение",
    "workflow.error_title": "Ошибка интеграции",
    "Integration Error": "Ошибка интеграции",
    "workflow.error_description": "Не удалось загрузить интеграцию. Проверьте подключение и повторите попытку.",
    "Unable to load the integration. Please check your connection and try again.": "Не удалось загрузить интеграцию. Проверьте подключение и повторите попытку.",
    "workflow.retry": "Повторить",
    "Try Again": "Повторить",
    "upgrade_preview.eyebrow": "Предпросмотр компонента",
    "Component preview": "Предпросмотр компонента",
    "upgrade_preview.title": "Возможности после обновления тарифа",
    "Upgrade experience": "Возможности после обновления тарифа",
    "upgrade_preview.description": "Общий доступ к функции с акцентом на то, что клиент сможет делать после обновления тарифа.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Общий доступ к функции с акцентом на то, что клиент сможет делать после обновления тарифа.",
    "upgrade_preview.feature": "Добавить вариант",
    "Add a variant": "Добавить вариант",
    "upgrade_preview.context": "Здесь пользователь тарифа Basic достигает границы доступности функции.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Здесь пользователь тарифа Basic достигает границы доступности функции.",
    "upgrade_preview.button": "Предпросмотр панели обновления",
    "Preview upgrade panel": "Предпросмотр панели обновления",
    "upgrade_preview.listing_context": "Для этого объявления",
    "For this listing": "Для этого объявления",
    "gamification_test.eyebrow": "ИГРОВОЕ ВОВЛЕЧЕНИЕ · ТЕСТОВЫЙ МАРШРУТ",
    "GROWTH GAMIFICATION · TEST ROUTE": "ИГРОВОЕ ВОВЛЕЧЕНИЕ · ТЕСТОВЫЙ МАРШРУТ",
    "gamification_test.title": "Развивайте свой бизнес",
    "Build momentum for your business": "Развивайте свой бизнес",
    "gamification_test.subtitle": "Предпросмотр заданий, монет, значков и серий для рабочей области {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Предпросмотр заданий, монет, значков и серий для рабочей области {workspace}.",
    "gamification_test.this_workspace": "этой рабочей области",
    "this workspace": "этой рабочей области",
    "gamification_test.coins": "МОНЕТЫ",
    "COINS": "МОНЕТЫ",
    "gamification_test.points": "БАЛЛЫ",
    "POINTS": "БАЛЛЫ",
    "gamification_test.streak": "СЕРИЯ",
    "STREAK": "СЕРИЯ",
    "gamification_test.week": "1 неделя",
    "1 week": "1 неделя",
    "gamification_test.launch": "Путь запуска",
    "Launch path": "Путь запуска",
    "gamification_test.progress": "Выполнено действий: {completed} из {total} · до {coins} монет",
    "{completed} of {total} actions complete · up to {coins} coins": "Выполнено действий: {completed} из {total} · до {coins} монет",
    "gamification_test.done": "Готово",
    "gamification_test.reward": "+{count} монет",
    "+{count} coins": "+{count} монет",
    "gamification_test.badges": "Значки",
    "Badges": "Значки",
    "gamification_test.mission_listing_created": "Создайте первое объявление",
    "Create your first listing": "Создайте первое объявление",
    "gamification_test.mission_collection_created": "Создайте первую подборку",
    "gamification_test.mission_payment_configured": "Настройте платежи",
    "Configure payments": "Настройте платежи",
    "gamification_test.mission_publish_completed": "Опубликуйте сайт",
    "Publish your site": "Опубликуйте сайт",
    "gamification_test.mission_analytics_enabled": "Включите аналитику",
    "Enable analytics": "Включите аналитику",
    "gamification_test.badge_first_step": "Первый шаг",
    "First Step": "Первый шаг",
    "gamification_test.badge_catalog_builder": "Создатель каталога",
    "Catalog Builder": "Создатель каталога",
    "gamification_test.badge_ready_to_sell": "Готов к продажам",
    "Ready to Sell": "Готов к продажам",
    "gamification_test.badge_data_driven": "На основе данных",
    "Data Driven": "На основе данных",
    "gamification_test.badge_growth_operator": "Специалист по росту",
    "Growth Operator": "Специалист по росту",
    "sentry_check.title": "Проверка настроек Sentry",
    "Sentry Configuration Check": "Проверка настроек Sentry",
    "sentry_check.subtitle": "Проверьте и протестируйте настройку отслеживания ошибок Sentry",
    "Test and verify Sentry error tracking setup": "Проверьте и протестируйте настройку отслеживания ошибок Sentry",
    "sentry_check.configuration": "Настройка",
    "sentry_check.check_configuration": "Проверить настройки",
    "Check Configuration": "Проверить настройки",
    "sentry_check.status": "Статус:",
    "Status:": "Статус:",
    "sentry_check.enabled": "✓ Включено",
    "✓ Enabled": "✓ Включено",
    "sentry_check.disabled": "✗ Отключено",
    "✗ Disabled": "✗ Отключено",
    "sentry_check.environment": "Среда:",
    "Environment:": "Среда:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Частота выборки трассировок:",
    "Traces Sample Rate:": "Частота выборки трассировок:",
    "sentry_check.test_functions": "Проверка функций",
    "Test Functions": "Проверка функций",
    "sentry_check.test_hint": "Нажмите кнопки ниже, чтобы проверить функции Sentry. Проверьте панель Sentry и убедитесь, что события записываются.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Нажмите кнопки ниже, чтобы проверить функции Sentry. Проверьте панель Sentry и убедитесь, что события записываются.",
    "sentry_check.test_results": "Результаты проверки",
    "Test Results": "Результаты проверки",
    "sentry_check.clear": "Очистить",
    "sentry_check.no_tests": "Проверки еще не запускались",
    "No tests run yet": "Проверки еще не запускались",
    "sentry_check.important_notes": "⚠️ Важные примечания",
    "⚠️ Important Notes": "⚠️ Важные примечания",
    "sentry_check.warning_real_events": "• Проверки создают реальные события ошибок на панели Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Проверки создают реальные события ошибок на панели Sentry",
    "sentry_check.warning_dashboard": "• Проверьте панель Sentry, чтобы убедиться, что события записываются",
    "• Check your Sentry dashboard to verify events are being captured": "• Проверьте панель Sentry, чтобы убедиться, что события записываются",
    "sentry_check.warning_traces": "• Некоторые проверки могут не отображаться в Sentry, если tracesSampleRate равен 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Некоторые проверки могут не отображаться в Sentry, если tracesSampleRate равен 0.0",
    "sentry_check.warning_dsn": "• Убедитесь, что DSN правильно настроен в переменных среды",
    "• Make sure your DSN is correctly configured in environment variables": "• Убедитесь, что DSN правильно настроен в переменных среды",
    "sentry_check.normal_error": "Проверить обычную ошибку",
    "Test Normal Error": "Проверить обычную ошибку",
    "sentry_check.test_normal_error": "Проверить обычную ошибку",
    "sentry_check.test_message": "Проверить сообщение",
    "Test Message": "Проверить сообщение",
    "sentry_check.test_breadcrumb": "Проверить навигационную метку",
    "Test Breadcrumb": "Проверить навигационную метку",
    "sentry_check.test_user_context": "Проверить контекст пользователя",
    "Test User Context": "Проверить контекст пользователя",
    "sentry_check.test_custom_exception": "Проверить пользовательское исключение",
    "Test Custom Exception": "Проверить пользовательское исключение",
    "sentry_check.test_promise_rejection": "Проверить отклонение Promise",
    "Test Promise Rejection": "Проверить отклонение Promise",
    "sentry_check.configuration_check": "Проверка конфигурации",
    "Configuration Check": "Проверка конфигурации",
    "sentry_check.config_loaded": "Конфигурация успешно загружена",
    "Config loaded successfully": "Конфигурация успешно загружена",
    "sentry_check.error_captured": "Ошибка записана и отправлена в Sentry",
    "Error captured and sent to Sentry": "Ошибка записана и отправлена в Sentry",
    "sentry_check.error_capture_failed": "Не удалось записать ошибку: {message}",
    "Failed to capture error: {message}": "Не удалось записать ошибку: {message}",
    "sentry_check.message": "Сообщение",
    "Message": "Сообщение",
    "sentry_check.message_captured": "Сообщение записано и отправлено в Sentry",
    "Message captured and sent to Sentry": "Сообщение записано и отправлено в Sentry",
    "sentry_check.message_capture_failed": "Не удалось записать сообщение: {message}",
    "Failed to capture message: {message}": "Не удалось записать сообщение: {message}",
    "sentry_check.breadcrumb": "Навигационная метка",
    "Breadcrumb": "Навигационная метка",
    "sentry_check.breadcrumb_added": "Навигационная метка добавлена в контекст Sentry",
    "Breadcrumb added to Sentry context": "Навигационная метка добавлена в контекст Sentry",
    "sentry_check.breadcrumb_failed": "Не удалось добавить навигационную метку: {message}",
    "Failed to add breadcrumb: {message}": "Не удалось добавить навигационную метку: {message}",
    "sentry_check.user_context": "Контекст пользователя",
    "User Context": "Контекст пользователя",
    "sentry_check.user_set": "Контекст пользователя задан в Sentry",
    "User context set in Sentry": "Контекст пользователя задан в Sentry",
    "sentry_check.user_failed": "Не удалось задать контекст пользователя: {message}",
    "Failed to set user context: {message}": "Не удалось задать контекст пользователя: {message}",
    "sentry_check.custom_exception": "Пользовательское исключение",
    "Custom Exception": "Пользовательское исключение",
    "sentry_check.custom_sent": "Пользовательское исключение с контекстом отправлено в Sentry",
    "Custom exception with context sent to Sentry": "Пользовательское исключение с контекстом отправлено в Sentry",
    "sentry_check.custom_failed": "Не удалось записать пользовательское исключение: {message}",
    "Failed to capture custom exception: {message}": "Не удалось записать пользовательское исключение: {message}",
    "sentry_check.promise_rejection": "Отклонение Promise",
    "Promise Rejection": "Отклонение Promise",
    "sentry_check.promise_captured": "Отклонение Promise записано и отправлено в Sentry",
    "Promise rejection captured and sent to Sentry": "Отклонение Promise записано и отправлено в Sentry",
    "sentry_check.promise_failed": "Не удалось обработать отклонение Promise: {message}",
    "Failed to handle promise rejection: {message}": "Не удалось обработать отклонение Promise: {message}",
    "checkout_settings.orders": "Заказы",
    "checkout_settings.return_policy_days": "Срок возврата, дней",
    "Return policy days": "Срок возврата, дней",
    "checkout_settings.enter_return_policy_days": "Введите срок возврата в днях",
    "Enter return policy days": "Введите срок возврата в днях",
    "checkout_settings.saved": "Успешно сохранено",
    "checkout_settings.cart": "Корзина",
    "checkout_settings.hide_quantity_selection": "Скрыть выбор количества (по умолчанию поле выбора показывается)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Скрыть выбор количества (по умолчанию поле выбора показывается)",
    "checkout_settings.enable_coupon": "Включить купоны",
    "Enable Coupon": "Включить купоны",
    "upgrade_page.copy.a_practical_next_step": "Практичный следующий шаг",
    "A practical next step": "Практичный следующий шаг",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Добавьте структурированную информацию, необходимую для вашего процесса.",
    "Add the structured information your workflow needs.": "Добавьте структурированную информацию, необходимую для вашего процесса.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Назначьте роли и разрешения каждому участнику команды.",
    "Assign roles and permissions to every teammate.": "Назначьте роли и разрешения каждому участнику команды.",
    "upgrade_page.copy.audit_log_export": "Экспорт журнала аудита",
    "Audit log export": "Экспорт журнала аудита",
    "upgrade_page.copy.best_next_step": "Лучший следующий шаг",
    "Best next step": "Лучший следующий шаг",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Импортируйте структурированные записи, вносите изменения офлайн и экспортируйте полный рабочий набор для команды.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Импортируйте структурированные записи, вносите изменения офлайн и экспортируйте полный рабочий набор для команды.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Создавайте интерфейсы за пределами стандартных возможностей",
    "Build beyond the standard interface": "Создавайте интерфейсы за пределами стандартных возможностей",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Соберите сведения, которые сделают каталог полезным.",
    "Capture the details that make your catalogue useful.": "Соберите сведения, которые сделают каталог полезным.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Получите гибкость для создания собственных клиентских интерфейсов на базе Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Получите гибкость для создания собственных клиентских интерфейсов на базе Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Объединяйте объявления в тематические наборы и позволяйте клиентам выбирать подходящие товары при оформлении заказа.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Объединяйте объявления в тематические наборы и позволяйте клиентам выбирать подходящие товары при оформлении заказа.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Настройте валюты, необходимые бизнесу для работы в разных регионах.",
    "Configure the currencies your business needs as you operate across regions.": "Настройте валюты, необходимые бизнесу для работы в разных регионах.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Свяжите маркетплейс с внутренними инструментами и автоматизацией, когда ручная работа перестанет масштабироваться.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Свяжите маркетплейс с внутренними инструментами и автоматизацией, когда ручная работа перестанет масштабироваться.",
    "upgrade_page.copy.connect_your_own_tools": "Подключите собственные инструменты",
    "Connect your own tools": "Подключите собственные инструменты",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Управляйте тем, кто что может просматривать и изменять.",
    "Control who can see and change what.": "Управляйте тем, кто что может просматривать и изменять.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Создайте пользовательские поля с данными, которые клиенты и команда должны видеть в каждом объявлении или аккаунте.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Создайте пользовательские поля с данными, которые клиенты и команда должны видеть в каждом объявлении или аккаунте.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Создавайте готовые наборы и комбинируйте товары.",
    "Create fixed and mix-and-match bundles.": "Создавайте готовые наборы и комбинируйте товары.",
    "upgrade_page.copy.custom_attributes": "Пользовательские атрибуты",
    "Custom attributes": "Пользовательские атрибуты",
    "upgrade_page.copy.custom_email_templates": "Пользовательские шаблоны писем",
    "Custom email templates": "Пользовательские шаблоны писем",
    "upgrade_page.copy.email_whitelabelling": "Брендирование электронной почты",
    "Email whitelabelling": "Брендирование электронной почты",
    "upgrade_page.copy.everything_in_growth": "Все возможности тарифа Growth",
    "Everything in Growth": "Все возможности тарифа Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Все возможности Growth с максимальными лимитами.",
    "Everything in Growth, with the highest limits.": "Все возможности Growth с максимальными лимитами.",
    "upgrade_page.copy.everything_in_starter": "Все возможности тарифа Starter",
    "Everything in Starter": "Все возможности тарифа Starter",
    "upgrade_page.copy.expand_your_workspace": "Расширьте рабочую область",
    "Expand your workspace": "Расширьте рабочую область",
    "upgrade_page.copy.feature_access": "Доступ к функциям",
    "Feature access": "Доступ к функциям",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Для растущего каталога, которому нужен более понятный выбор товаров.",
    "For a growing catalogue that needs clearer product choices.": "Для растущего каталога, которому нужен более понятный выбор товаров.",
    "upgrade_page.copy.for_established_businesses": "Для действующего бизнеса",
    "For established businesses": "Для действующего бизнеса",
    "upgrade_page.copy.for_growing_operations": "Для растущих операций",
    "For growing operations": "Для растущих операций",
    "upgrade_page.copy.for_growing_teams": "Для растущих команд",
    "For growing teams": "Для растущих команд",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Для команд с большим объемом операций и потребностью в масштабировании.",
    "For high-volume teams that need room to operate at scale.": "Для команд с большим объемом операций и потребностью в масштабировании.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Для команд с большим каталогом и большим числом процессов.",
    "For teams managing a larger catalogue and more workflows.": "Для команд с большим каталогом и большим числом процессов.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Для команд, которым нужно обрабатывать записи массово.",
    "For teams ready to work beyond one record at a time.": "Для команд, которым нужно обрабатывать записи массово.",
    "upgrade_page.copy.full_audit_history": "Полная история аудита",
    "Full audit history": "Полная история аудита",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Тарифы Growth и Scale дают доступ ко всей истории аудита и позволяют экспортировать ее для проверок соответствия требованиям.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Тарифы Growth и Scale дают доступ ко всей истории аудита и позволяют экспортировать ее для проверок соответствия требованиям.",
    "upgrade_page.copy.higher_usage_limits": "Повышенные лимиты использования",
    "Higher usage limits": "Повышенные лимиты использования",
    "upgrade_page.copy.highest_usage_limits": "Максимальные лимиты использования",
    "Highest usage limits": "Максимальные лимиты использования",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Импортируйте и экспортируйте записи без повторяющейся ручной работы.",
    "Import and export records without repetitive manual work.": "Импортируйте и экспортируйте записи без повторяющейся ручной работы.",
    "upgrade_page.copy.import_and_export_tools": "Инструменты импорта и экспорта",
    "Import and export tools": "Инструменты импорта и экспорта",
    "upgrade_page.copy.improve_important_customer_messages": "Улучшите важные сообщения для клиентов",
    "Improve important customer messages": "Улучшите важные сообщения для клиентов",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Храните историю соответствия требованиям дольше",
    "Keep a longer compliance history": "Храните историю соответствия требованиям дольше",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Сохраняйте полную прозрачность соответствия требованиям при больших объемах операций.",
    "Keep complete compliance visibility for high-volume operations.": "Сохраняйте полную прозрачность соответствия требованиям при больших объемах операций.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Поддерживайте порядок в данных и процессах по мере роста каталога.",
    "Keep more data and workflows organised as the catalogue grows.": "Поддерживайте порядок в данных и процессах по мере роста каталога.",
    "upgrade_page.copy.keep_your_workspace_secure": "Защитите рабочую область",
    "Keep your workspace secure": "Защитите рабочую область",
    "upgrade_page.copy.large": "Большой",
    "Large": "Большой",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Позвольте клиентам выбирать варианты в одном объявлении.",
    "Let customers choose options from one listing.": "Позвольте клиентам выбирать варианты в одном объявлении.",
    "upgrade_page.copy.listing_variants": "Варианты объявления",
    "Listing variants": "Варианты объявления",
    "upgrade_page.copy.make_every_customer_email_yours": "Добавьте индивидуальность каждому письму клиенту",
    "Make every customer email yours": "Добавьте индивидуальность каждому письму клиенту",
    "upgrade_page.copy.make_one_listing_work_harder": "Расширьте возможности одного объявления",
    "Make one listing work harder": "Расширьте возможности одного объявления",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Настройте системные письма под ваши процессы и стиль общения.",
    "Make system emails match your workflow and tone.": "Настройте системные письма под ваши процессы и стиль общения.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Добавьте проект на новые языки.",
    "Make your project available in more languages.": "Добавьте проект на новые языки.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Управляйте языками клиентского интерфейса при выходе в новые регионы и аудитории.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Управляйте языками клиентского интерфейса при выходе в новые регионы и аудитории.",
    "upgrade_page.copy.medium": "Средний",
    "upgrade_page.copy.more_capacity": "Больше ресурсов",
    "More capacity": "Больше ресурсов",
    "upgrade_page.copy.more_storage": "Больше места для хранения",
    "More storage": "Больше места для хранения",
    "upgrade_page.copy.more_team_capacity": "Больше мест для команды",
    "More team capacity": "Больше мест для команды",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Работайте с каталогом быстрее",
    "Move faster with your catalogue": "Работайте с каталогом быстрее",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Быстрее обрабатывайте большие каталоги и команды в повседневной работе",
    "Move larger catalogues and teams through routine work faster.": "Быстрее обрабатывайте большие каталоги и команды в повседневной работе",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Предлагайте размеры, цвета и другие варианты без дублирования объявлений и разделения учета запасов",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Предлагайте размеры, цвета и другие варианты без дублирования объявлений и разделения учета запасов",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Используйте максимально доступные лимиты",
    "Operate with the highest available limits.": "Используйте максимально доступные лимиты",
    "upgrade_page.copy.per_module_permissions": "Разрешения для каждого модуля",
    "Per-module permissions": "Разрешения для каждого модуля",
    "upgrade_page.copy.priority_support": "Приоритетная поддержка",
    "Priority support": "Приоритетная поддержка",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Просматривайте более пяти последних событий аудита",
    "Review more than the latest five audit events.": "Просматривайте более пяти последних событий аудита",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Просматривайте полную историю аудита по мере роста команды и активности",
    "Review the full audit history as your team and activity grow.": "Просматривайте полную историю аудита по мере роста команды и активности",
    "upgrade_page.copy.role_based_access_control": "Управление доступом на основе ролей",
    "Role-based access control": "Управление доступом на основе ролей",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Роли позволяют предоставить каждому участнику команды только нужный доступ. Доступно в тарифе Growth и выше.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Роли позволяют предоставить каждому участнику команды только нужный доступ. Доступно в тарифе Growth и выше.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Создайте более эффективный и продуманный процесс общения с клиентами",
    "Run a stronger, more polished customer communication workflow.": "Создайте более эффективный и продуманный процесс общения с клиентами",
    "upgrade_page.copy.sell_across_markets": "Продавайте на разных рынках",
    "Sell across markets": "Продавайте на разных рынках",
    "upgrade_page.copy.sell_products_together": "Продавайте товары комплектами",
    "Sell products together": "Продавайте товары комплектами",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Отправляйте письма от имени бренда, знакомого вашим клиентам",
    "Send email from a brand your customers recognise.": "Отправляйте письма от имени бренда, знакомого вашим клиентам",
    "upgrade_page.copy.shape_the_information_you_collect": "Настройте собираемую информацию",
    "Shape the information you collect": "Настройте собираемую информацию",
    "upgrade_page.copy.small": "Маленький",
    "Small": "Маленький",
    "upgrade_page.copy.speak_to_more_customers": "Общайтесь с большим числом клиентов",
    "Speak to more customers": "Общайтесь с большим числом клиентов",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Стандартизируйте более подробные данные при большом объеме операций",
    "Standardise richer data across a high-volume operation.": "Стандартизируйте более подробные данные при большом объеме операций",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Создайте более последовательный опыт для клиентов",
    "Start presenting a more consistent customer experience.": "Создайте более последовательный опыт для клиентов",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Обеспечьте полноценный клиентский опыт для корпоративного уровня",
    "Support a complete enterprise-ready customer experience.": "Обеспечьте полноценный клиентский опыт для корпоративного уровня",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Поддерживайте клиентов, которые совершают покупки в разных валютах",
    "Support customers who shop in different currencies.": "Поддерживайте клиентов, которые совершают покупки в разных валютах",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Поддерживайте масштабные рабочие процессы с большим объемом операций",
    "Support high-volume operational workflows at scale.": "Поддерживайте масштабные рабочие процессы с большим объемом операций",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Поддерживайте более масштабные процессы и команды",
    "Support larger workflows and teams.": "Поддерживайте более масштабные процессы и команды",
    "upgrade_page.copy.t_shirt": "Футболка",
    "T-shirt": "Футболка",
    "upgrade_page.copy.t_shirt_large": "Футболка — большая",
    "T-shirt — Large": "Футболка — большая",
    "upgrade_page.copy.t_shirt_medium": "Футболка — средняя",
    "T-shirt — Medium": "Футболка — средняя",
    "upgrade_page.copy.t_shirt_small": "Футболка — маленькая",
    "T-shirt — Small": "Футболка — маленькая",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Настраивайте сообщения для клиентов в ключевые моменты, не меняя конфигурацию маркетплейса",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Настраивайте сообщения для клиентов в ключевые моменты, не меняя конфигурацию маркетплейса",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Получите доступ к новым инструментам по мере роста рабочего пространства",
    "Unlock more tools as your workspace begins to grow.": "Получите доступ к новым инструментам по мере роста рабочего пространства",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Откройте эту функцию, когда будете готовы",
    "Unlock this feature when you are ready.": "Откройте эту функцию, когда будете готовы",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Используйте headless API для полностью индивидуального решения",
    "Use headless APIs for a fully custom experience.": "Используйте headless API для полностью индивидуального решения",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Используйте API, когда рабочему процессу нужны дополнительные возможности",
    "Use the API when your workflow needs to go further.": "Используйте API, когда рабочему процессу нужны дополнительные возможности",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Используйте собственные данные отправителя и фирменный стиль, чтобы сообщения маркетплейса оставались единообразными",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Используйте собственные данные отправителя и фирменный стиль, чтобы сообщения маркетплейса оставались единообразными",
    "upgrade_page.copy.with_variants": "С вариантами",
    "With variants": "С вариантами",
    "upgrade_page.copy.without_variants": "Без вариантов",
    "Without variants": "Без вариантов",
    "upgrade_page.copy.workflow_tools": "Инструменты рабочих процессов",
    "Workflow tools": "Инструменты рабочих процессов",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Текущая работа не изменится, пока вы сравниваете тарифы с этой возможностью",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Текущая работа не изменится, пока вы сравниваете тарифы с этой возможностью",
    "upgrade_page.copy.a_paid_plan": "платный тариф",
    "a paid plan": "платный тариф",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Все необходимое для растущего магазина: уберите фирменный брендинг, добавьте домен и откройте новые инструменты.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Все необходимое для растущего магазина: уберите фирменный брендинг, добавьте домен и откройте новые инструменты.",
    "upgrade_page.copy.everything_unlocked": "Все функции доступны",
    "Everything unlocked": "Все функции доступны",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Полный набор ИИ-инструментов, расширенный маркетинг и все функции для магазинов, нацеленных на рост",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Сообщение от команды Tradly",
    "A note from the Tradly team": "Сообщение от команды Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Помогите нам развивать Tradly",
    "Help us keep Tradly going": "Помогите нам развивать Tradly",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Наши расходы выросли, и чтобы продолжать развивать и поддерживать Tradly, нам нужна поддержка сообщества. Чтобы продолжить работу с вашим пространством, выберите тариф. Ваш магазин и данные в безопасности и ждут вас. Спасибо, что вы с Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Наши расходы выросли, и чтобы продолжать развивать и поддерживать Tradly, нам нужна поддержка сообщества. Чтобы продолжить работу с вашим пространством, выберите тариф. Ваш магазин и данные в безопасности и ждут вас. Спасибо, что вы с Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "С 2019 года мы предлагали бесплатный тариф Tradly с широкими возможностями, чтобы каждый мог начать свой проект. Мы рады, что сделали это, но больше не можем поддерживать его самостоятельно. Планируем вернуть бесплатный тариф, когда бизнес достигнет определенного уровня, чтобы отблагодарить сообщество, которое помогло нам прийти к этому.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "С 2019 года мы предлагали бесплатный тариф Tradly с широкими возможностями, чтобы каждый мог начать свой проект. Мы рады, что сделали это, но больше не можем поддерживать его самостоятельно. Планируем вернуть бесплатный тариф, когда бизнес достигнет определенного уровня, чтобы отблагодарить сообщество, которое помогло нам прийти к этому.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Выберите подходящий вам сегодня тариф. Его можно изменить в любое время.",
    "Choose the plan that fits you today. You can change it any time.": "Выберите подходящий вам сегодня тариф. Его можно изменить в любое время.",
    "upgrade_page.back_to_workspace": "Вернуться в рабочее пространство",
    "Back to workspace": "Вернуться в рабочее пространство",
    "upgrade_page.grow_when_ready": "Растите по мере необходимости",
    "Grow when the work calls for it": "Растите по мере необходимости",
    "upgrade_page.reassurance": "Ваши существующие данные, объявления и настройки останутся без изменений.",
    "Your existing data, listings, and setup stay exactly as they are.": "Ваши существующие данные, объявления и настройки останутся без изменений.",
    "upgrade_page.choose_plan": "Выбрать тариф",
    "Choose a plan": "Выбрать тариф",
    "upgrade_page.feature_availability": "Доступность функций",
    "Feature availability": "Доступность функций",
    "upgrade_page.available_from": "Доступно с тарифа",
    "Available from": "Доступно с тарифа",
    "upgrade_page.and_above": "и выше",
    "and above": "и выше",
    "upgrade_page.choose_when_useful": "Выбирайте тариф, только если эта функция полезна вашей команде.",
    "Choose a plan only when this capability is useful to your team.": "Выбирайте тариф, только если эта функция полезна вашей команде.",
    "upgrade_page.practical_difference": "Практическая разница",
    "The practical difference": "Практическая разница",
    "upgrade_page.keep_work_simple": "Упрощайте работу по мере роста.",
    "Keep the work simpler as you grow.": "Упрощайте работу по мере роста.",
    "upgrade_page.plan_path": "Путь по тарифам",
    "Plan path": "Путь по тарифам",
    "upgrade_page.plan_path_title": "Начните с тарифа, который поддерживает следующий шаг.",
    "Start with the plan that supports this next step.": "Начните с тарифа, который поддерживает следующий шаг.",
    "upgrade_page.best_next_step": "Лучший следующий шаг",
    "upgrade_page.includes_capability": "Включает эту функцию",
    "Includes this capability": "Включает эту функцию",
    "upgrade_page.not_included": "Не включено",
    "Not included": "Не включено",
    "upgrade_page.included": "✓ Включено",
    "✓ Included": "✓ Включено",
    "upgrade_page.ready_when_you_are": "Готово, когда будете готовы.",
    "Ready when you are.": "Готово, когда будете готовы.",
    "upgrade_page.billing_details": "Ознакомьтесь с полными сведениями о тарифе и безопасно продолжите оплату через Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Ознакомьтесь с полными сведениями о тарифе и безопасно продолжите оплату через Tradly.",
    "upgrade_page.panel.close": "Закрыть панель тарифов",
    "Close upgrade panel": "Закрыть панель тарифов",
    "upgrade_page.panel.show_less": "Свернуть",
    "Show less": "Свернуть",
    "upgrade_page.panel.see_more": "Подробнее",
    "See more": "Подробнее",
    "upgrade_page.panel.choose_to_continue": "Выберите тариф, чтобы продолжить",
    "Choose a plan to continue": "Выберите тариф, чтобы продолжить",
    "upgrade_page.panel.more_ways_to_grow": "Другие возможности для роста",
    "More ways to grow": "Другие возможности для роста",
    "upgrade_page.panel.plan_includes_feature": "Каждый тариф включает эту функцию и дополнительные возможности для следующего этапа.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Каждый тариф включает эту функцию и дополнительные возможности для следующего этапа.",
    "upgrade_page.panel.add_credits": "Добавить кредиты или товары",
    "Add credits or products": "Добавить кредиты или товары",
    "upgrade_page.panel.ala_carte_description": "Оплата рабочего пространства рассчитывается по отдельным позициям. Пополните кредиты или добавьте нужные продукты.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Оплата рабочего пространства рассчитывается по отдельным позициям. Пополните кредиты или добавьте нужные продукты.",
    "upgrade_page.panel.open_ala_carte": "Перейти к оплате по позициям",
    "Open à la carte": "Перейти к оплате по позициям",
    "upgrade_page.panel.recommended": "Рекомендуется",
    "Recommended": "Рекомендуется",
    "upgrade_page.panel.per_month": "/ месяц",
    "upgrade_page.panel.please_wait": "Подождите…",
    "upgrade_page.panel.unlock_plan": "Открыть тариф {plan}",
    "Unlock {plan}": "Открыть тариф {plan}",
    "upgrade_page.panel.choose_plan": "Выбрать тариф {plan}",
    "Choose {plan}": "Выбрать тариф {plan}",
    "upgrade_page.panel.compare_plans": "Сравнить все условия тарифов",
    "Compare all plan details": "Сравнить все условия тарифов",
    "workspace.usage.page_title": "Обзор использования",
    "Usage overview": "Обзор использования",
    "workspace.usage.page_description": "Просматривайте текущее использование и лимиты этого рабочего пространства.",
    "workspace.usage.not_available": "Недоступно",
    "workspace.usage.limit_not_configured": "Лимит не настроен",
    "Limit not configured": "Лимит не настроен",
    "workspace.usage.limit_value": "Лимит: {limit}",
    "Limit: {limit}": "Лимит: {limit}",
    "listings.photos": "Фотографии",
    "Photos": "Фотографии",
    "listings.listen_episode": "Прослушать этот эпизод",
    "Listen to this episode": "Прослушать этот эпизод",
    "listings.other_listings": "Другие объявления",
    "Other listings": "Другие объявления",
    "listings.delete": "Удалить",
    "listings.fulfilled_by_platform": "Выполняется платформой",
    "Fulfilled by Platform": "Выполняется платформой",
    "listings.no_attributes_set": "Атрибуты не заданы",
    "No attributes set": "Атрибуты не заданы",
    "listings.campaign_raised": "Собрано {amount}",
    "{amount} raised": "Собрано {amount}",
    "listings.campaign_progress": "{percent}% от {goal}",
    "{percent}% of {goal}": "{percent}% от {goal}",
    "listings.seat": "место",
    "seat": "место",
    "listings.seats": "мест",
    "seats": "мест",
    "listings.per_slot": "за слот",
    "per slot": "за слот",
    "listings.total_value": "Итого: {total}",
    "Total: {total}": "Итого: {total}",
    "listings.orders": "Заказы",
    "listings.total_orders": "Всего заказов",
    "Total orders": "Всего заказов",
    "listings.revenue": "Выручка",
    "listings.average_order": "Средний заказ",
    "listings.customers": "Клиенты",
    "Customers": "Клиенты",
    "listings.load_more": "Загрузить еще",
    "Load more": "Загрузить еще",
    "listings.filter": "Фильтр",
    "listings.sort": "Сортировка",
    "Sort": "Сортировка",
    "listings.value_price": "Цена значения",
    "Value Price": "Цена значения",
    "listings.detail_label_title": "Название",
    "listings.detail_label_slug": "ЧПУ",
    "listings.detail_label_description": "Описание",
    "listings.detail_label_categories": "Категории",
    "listings.detail_label_list_price": "Цена по прайсу",
    "List Price": "Цена по прайсу",
    "listings.detail_label_offer": "Предложение",
    "Offer": "Предложение",
    "listings.detail_label_currency": "Валюта",
    "listings.detail_label_listing_status": "Статус объявления",
    "Listing Status": "Статус объявления",
    "listings.detail_label_active": "Активно",
    "listings.detail_label_sold": "Продано",
    "listings.detail_label_meta_title": "Мета-заголовок",
    "listings.detail_label_meta_description": "Мета-описание",
    "listings.detail_label_goal": "Цель",
    "Goal": "Цель",
    "listings.detail_label_donors": "Спонсоры",
    "Donors": "Спонсоры",
    "listings.detail_label_start_date": "Дата начала",
    "listings.detail_label_end_date": "Дата окончания",
    "listings.detail_label_stock": "Запас",
    "listings.detail_label_max_qty_order": "Макс. количество в заказе",
    "Max qty / order": "Макс. количество в заказе",
    "listings.detail_label_weight": "Вес",
    "listings.detail_label_dimensions": "Размеры",
    "Dimensions": "Размеры",
    "listings.detail_label_listing_period": "Период размещения",
    "Listing period": "Период размещения",
    "listings.detail_label_max_tickets_booking": "Макс. билетов на бронирование",
    "Max tickets / booking": "Макс. билетов на бронирование",
    "listings.detail_label_rating": "Рейтинг",
    "listings.detail_label_reviews": "Отзывы",
    "listings.detail_label_likes": "Нравится",
    "Likes": "Нравится",
    "listings.detail_label_dislikes": "Не нравится",
    "Dislikes": "Не нравится",
    "listings.detail_label_barcode": "Штрихкод",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "Артикул",
    "listings.detail_section_basic_info": "Основная информация",
    "Basic Info": "Основная информация",
    "listings.detail_section_pricing": "Цены",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Выберите тип объявления выше, чтобы продолжить.",
    "Select a listing type above to continue.": "Выберите тип объявления выше, чтобы продолжить.",
    "listing_form.attributes": "Атрибуты",
    "category.status_active_help": "Статус (Неактивен / Активен)",
    "promotions.medium": "Средний",
    "users.listings": "Объявления",
    "users.accounts": "Учетные записи",
    "users.click_count_one": "{count} переход",
    "{count} click": "{count} переход",
    "users.click_count": "{count} переходов",
    "{count} clicks": "{count} переходов",
    "integrations.generic.provider_help": "Настройте выбранного поставщика с помощью полей ниже.",
    "Configure the selected provider using the fields below.": "Настройте выбранного поставщика с помощью полей ниже.",
    "attributes.editor_prefill_data_from": "Предварительно заполнить данными из",
    "Prefill Data From": "Предварительно заполнить данными из",
    "attributes.editor_select_attribute": "Выберите атрибут",
    "Select Attribute": "Выберите атрибут",
    "attributes.editor_select_attribute_group": "Выберите группу атрибутов",
    "Select Attribute Group": "Выберите группу атрибутов",
    "attributes.editor_attribute": "Атрибут",
    "Attribute": "Атрибут",
    "attributes.editor_attributes": "Атрибуты",
    "attributes.editor_cart_attributes": "Атрибуты корзины",
    "Cart Attributes": "Атрибуты корзины",
    "listings.add_photo": "Добавить фото",
    "accounts.analytics": "Аналитика",
    "listings.image_optional": "Изображения объявления (необязательно)",
    "Listing Images (Optional)": "Изображения объявления (необязательно)",
    "listings.currency": "Валюта",
    "listing_variants.number_sign": "№",
    "#": "№",
    "attributes.active": "Активно",
    "listing_form.digital_deleted_item_cannot_edit": "Этот элемент помечен для удаления и не может быть отредактирован",
    "This item is marked for deletion and cannot be edited": "Этот элемент помечен для удаления и не может быть отредактирован",
    "listing_form.digital_max_files": "Разрешено не более 10 файлов",
    "Maximum 10 files allowed": "Разрешено не более 10 файлов",
    "listing_form.digital_title_required": "Введите название",
    "listing_form.digital_version_required": "Введите название версии",
    "Please enter a version name": "Введите название версии",
    "listing_form.digital_contents": "Цифровые материалы",
    "Digital Contents": "Цифровые материалы",
    "listing_form.digital_add_content": "＋ Добавить материал",
    "+ Add Content": "＋ Добавить материал",
    "listing_form.no_description": "Нет описания",
    "No description": "Нет описания",
    "listing_form.digital_file_count": "Файлов: {count}",
    "{count} file(s)": "Файлов: {count}",
    "listing_form.digital_empty": "Цифровых материалов пока нет",
    "No digital contents yet": "Цифровых материалов пока нет",
    "listing_form.digital_empty_help": "Нажмите «{action}», чтобы создать первый цифровой материал",
    "Click \"{action}\" to create your first digital content": "Нажмите «{action}», чтобы создать первый цифровой материал",
    "listing_form.digital_marked_for_deletion": "Помечено для удаления ({count})",
    "Marked for Deletion ({count})": "Помечено для удаления ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Будет удалено при отправке",
    "✓ Will be deleted on submit": "✓ Будет удалено при отправке",
    "listing_form.digital_edit_title": "Изменить цифровой материал",
    "Edit Digital Content": "Изменить цифровой материал",
    "listing_form.digital_add_title": "Добавить цифровой материал",
    "Add New Digital Content": "Добавить цифровой материал",
    "listing_form.digital_form_description": "Заполните данные ниже, чтобы {action} цифровой материал",
    "Fill in the details below to {action} digital content": "Заполните данные ниже, чтобы {action} цифровой материал",
    "listing_form.digital_title_placeholder": "Введите название цифрового материала",
    "Enter digital content title": "Введите название цифрового материала",
    "listing_form.description_optional_placeholder": "Введите описание (необязательно)",
    "Enter description (optional)": "Введите описание (необязательно)",
    "listing_form.version": "Версия",
    "Version": "Версия",
    "listing_form.files": "Файлы",
    "Files": "Файлы",
    "listing_form.max_files": "(Макс. {count})",
    "(Max {count})": "(Макс. {count})",
    "listing_form.click_to_upload_files": "Нажмите, чтобы загрузить файлы",
    "Click to upload files": "Нажмите, чтобы загрузить файлы",
    "listing_form.files_uploaded_count": "Загружено файлов: {count}/10",
    "{count}/10 files uploaded": "Загружено файлов: {count}/10",
    "listing_form.unknown_size": "Неизвестный размер",
    "Unknown size": "Неизвестный размер",
    "listing_form.no_accounts_available": "Нет доступных учетных записей",
    "No accounts available": "Нет доступных учетных записей",
    "listing_form.select_account": "Выберите учетную запись",
    "Select an account": "Выберите учетную запись",
    "listing_form.searching": "Поиск…",
    "Searching...": "Поиск…",
    "listing_form.location_enter_address": "Введите адрес для поиска",
    "Please enter an address to search": "Введите адрес для поиска",
    "listing_form.location_no_addresses_search": "Адреса не найдены. Попробуйте другой запрос.",
    "No addresses found. Please try a different search.": "Адреса не найдены. Попробуйте другой запрос.",
    "listing_form.location_search_failed": "Не удалось найти адреса. Повторите попытку.",
    "Failed to search addresses. Please try again.": "Не удалось найти адреса. Повторите попытку.",
    "listing_form.location_place_details_failed": "Не удалось получить сведения о месте. Повторите попытку.",
    "Failed to get place details. Please try again.": "Не удалось получить сведения о месте. Повторите попытку.",
    "listing_form.location_access_denied": "Доступ к местоположению запрещен. Разрешите доступ к геоданным.",
    "Location access denied. Please enable location permissions.": "Доступ к местоположению запрещен. Разрешите доступ к геоданным.",
    "listing_form.location_unavailable": "Не удалось определить местоположение. Повторите попытку.",
    "Unable to determine location. Please try again.": "Не удалось определить местоположение. Повторите попытку.",
    "listing_form.location_timeout": "Время ожидания запроса местоположения истекло. Повторите попытку.",
    "Location request timed out. Please try again.": "Время ожидания запроса местоположения истекло. Повторите попытку.",
    "listing_form.location_current_failed": "Не удалось получить текущее местоположение. Повторите попытку.",
    "Failed to get current location. Please try again.": "Не удалось получить текущее местоположение. Повторите попытку.",
    "listing_form.location": "Местоположение",
    "listing_form.location_search_placeholder": "Поиск местоположения…",
    "Search for a location...": "Поиск местоположения…",
    "listing_form.location_searching": "Поиск адресов…",
    "Searching addresses...": "Поиск адресов…",
    "listing_form.location_no_addresses": "Адреса не найдены",
    "No addresses found": "Адреса не найдены",
    "listing_form.location_try_different_search": "Попробуйте другой поисковый запрос",
    "Try a different search term": "Попробуйте другой поисковый запрос",
    "listing_form.location_getting": "Получение местоположения…",
    "Getting location...": "Получение местоположения…",
    "listing_form.location_use_current": "Использовать текущее местоположение",
    "Use Current Location": "Использовать текущее местоположение",
    "listing_form.location_selected": "Выбранное местоположение",
    "Selected Location": "Выбранное местоположение",
    "listing_form.latitude": "Широта:",
    "Latitude:": "Широта:",
    "listing_form.longitude": "Долгота:",
    "Longitude:": "Долгота:",
    "listing_form.location_helper": "Введите адрес или используйте текущее местоположение",
    "Search for an address or use your current location": "Введите адрес или используйте текущее местоположение",
    "common.change": "Изменить",
    "listing_form.variant_id_tooltip": "ID типа: {typeId}, ID значения: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "ID типа: {typeId}, ID значения: {valueId}",
    "listing_form.variants_marked_for_deletion": "Помечено для удаления ({count} элементов):",
    "Marked for Deletion ({count} items):": "Помечено для удаления ({count} элементов):",
    "listing_form.add_new_variant": "Добавить вариант",
    "Add New Variant": "Добавить вариант",
    "listing_form.add_variant_description": "Заполните данные ниже, чтобы создать новый вариант",
    "Fill in the details below to create a new variant": "Заполните данные ниже, чтобы создать новый вариант",
    "listing_form.google_search_preview": "Предпросмотр в поиске Google",
    "Google Search Preview": "Предпросмотр в поиске Google",
    "listing_form.meta_title_preview": "Здесь будет мета-заголовок",
    "Your Meta Title Here": "Здесь будет мета-заголовок",
    "listing_form.meta_description_preview": "Здесь будет отображаться мета-описание. Оно помогает пользователям понять содержание страницы в результатах поиска.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Здесь будет отображаться мета-описание. Оно помогает пользователям понять содержание страницы в результатах поиска.",
    "listing_form.variant_name_placeholder": "Введите название",
    "listing_form.list_price_placeholder": "Введите цену по прайсу",
    "listing_form.offer_percent_placeholder": "Введите процент скидки",
    "Enter Offer Percent": "Введите процент скидки",
    "attributes.select_all": "Выбрать все",
    "attributes.unselect_all": "Снять выделение",
    "Unselect All": "Снять выделение",
    "attributes.select_category": "Выберите категорию",
    "attributes.create_category_configuration_first": "Сначала создайте категории в настройках {type}",
    "Create categories in {type} configuration first": "Сначала создайте категории в настройках {type}",
    "attributes.select_single_attribute_values": "Выберите значения одиночного атрибута",
    "attributes.select_multiple_attribute_values": "Выберите значения множественного атрибута",
    "attributes.enter_value": "Введите значение",
    "attributes.enter_multiple_tags": "Введите несколько тегов",
    "Enter Multiple Tags": "Введите несколько тегов",
    "attributes.upload_file": "Загрузить файл",
    "collections.add_condition": "＋ Добавить условие",
    "+ Add another condition": "＋ Добавить условие",
    "collections.add_photo": "Добавить фото",
    "collections.status": "Статус (Неактивно / Активно)",
    "collections.start_date_placeholder": "Выберите дату начала",
    "Select start date": "Выберите дату начала",
    "collections.end_date_placeholder": "Выберите дату окончания",
    "Select end date": "Выберите дату окончания",
    "navigation.editor": "Редактор",
    "Editor": "Редактор",
    "navigation.web_analytics": "Веб-аналитика",
    "Web Analytics": "Веб-аналитика",
    "navigation.ai_studio": "Студия ИИ",
    "AI Studio": "Студия ИИ",
    "navigation.docs": "Документация",
    "navigation.logout": "Выйти",
    "Logout": "Выйти",
    "navigation.tenant_name_placeholder": "(Название клиента)",
    "(Tenant name)": "(Название клиента)",
    "navigation.username_placeholder": "(Имя пользователя)",
    "(Username)": "(Имя пользователя)",
    "navigation.invite_description": "Отправьте приглашения участникам команды",
    "Send invitation links to team members": "Отправьте приглашения участникам команды",
    "navigation.invite": "Пригласить",
    "Invite": "Пригласить",
    "navigation.test_mode": "Тестовый режим",
    "Test Mode": "Тестовый режим",
    "navigation.upgrade": "Перейти на тариф выше",
    "navigation.open_account_menu": "Открыть меню аккаунта",
    "Open account menu": "Открыть меню аккаунта",
    "navigation.invite_name_required": "Укажите имя",
    "Please fill in the name": "Укажите имя",
    "navigation.invite_email_required": "Укажите электронную почту",
    "Please fill in the email": "Укажите электронную почту",
    "navigation.open_url_failed": "Не удалось открыть этот URL: {url}",
    "Don't know how to open this URL: {url}": "Не удалось открыть этот URL: {url}",
    "navigation.no_code_editor": "Редактор без кода",
    "No-code editor": "Редактор без кода",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Автоматизация маркетинга",
    "Marketing automation": "Автоматизация маркетинга",
    "navigation.analytics_recommendation": "Аналитика и рекомендации",
    "Analytics & Recommendation": "Аналитика и рекомендации",
    "navigation.ai_studio_iryxo": "Студия ИИ (Iryxo)",
    "AI Studio (Iryxo)": "Студия ИИ (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Текущий проект",
    "Current project": "Текущий проект",
    "navigation.current_user": "Текущий пользователь",
    "Current user": "Текущий пользователь",
    "navigation.switch_to_light_mode": "Переключить на светлую тему",
    "Switch to light mode": "Переключить на светлую тему",
    "navigation.switch_to_dark_mode": "Переключить на темную тему",
    "Switch to dark mode": "Переключить на темную тему",
    "navigation.download_android_app": "Скачать приложение для Android",
    "Download Android app": "Скачать приложение для Android",
    "navigation.download_ios_app": "Скачать приложение для iOS",
    "Download iOS app": "Скачать приложение для iOS",
    "navigation.subscribe_youtube": "Подписаться на YouTube",
    "Subscribe on YouTube": "Подписаться на YouTube",
    "navigation.open_app_switcher": "Открыть переключатель приложений",
    "Open app switcher": "Открыть переключатель приложений",
    "navigation.open_android_app": "Открыть приложение Android",
    "Open Android app": "Открыть приложение Android",
    "navigation.open_ios_app": "Открыть приложение iOS",
    "Open iOS app": "Открыть приложение iOS",
    "navigation.open_ai_support": "Открыть поддержку Tradly в ChatGPT",
    "Open Tradly ChatGPT support": "Открыть поддержку Tradly в ChatGPT",
    "navigation.open_youtube_channel": "Открыть канал Tradly на YouTube",
    "Open Tradly YouTube channel": "Открыть канал Tradly на YouTube",
    "navigation.demo": "Демонстрация",
    "Demo": "Демонстрация",
    "listings.smart_upload.listing_id_optional": "ID объявления (необязательно — обновить существующее)",
    "Listing ID (optional — update existing)": "ID объявления (необязательно — обновить существующее)",
    "listings.smart_upload.category_id": "ID категории",
    "listings.smart_upload.list_price": "Цена по прайсу",
    "listings.smart_upload.stock": "Запас",
    "listings.smart_upload.sku": "Артикул",
    "listings.smart_upload.barcode": "Штрихкод",
    "listings.smart_upload.account_id": "ID учетной записи",
    "listings.smart_upload.slug": "ЧПУ",
    "listings.smart_upload.text": "Текст",
    "listings.smart_upload.long_text": "Длинный текст",
    "listings.smart_upload.number": "Число",
    "listings.smart_upload.single_select": "Одиночный выбор",
    "listings.smart_upload.multi_select": "Множественный выбор",
    "listings.smart_upload.attribute_name_required": "Введите название атрибута для «{header}».",
    "listings.smart_upload.attribute_create_failed": "Tradly не вернула новый атрибут «{name}».",
    "Tradly did not return the new “{name}” attribute.": "Tradly не вернула новый атрибут «{name}».",
    "listings.smart_upload.attribute_option_create_failed": "Не удалось создать вариант «{value}» для {name}.",
    "Could not create the “{value}” option for {name}.": "Не удалось создать вариант «{value}» для {name}.",
    "listings.smart_upload.attribute_no_longer_available": "Атрибут, сопоставленный с «{header}», больше недоступен.",
    "listings.smart_upload.csv_needs_header_and_listing": "CSV-файл должен содержать строку заголовков и хотя бы одно объявление.",
    "The CSV must contain a header row and at least one listing.": "CSV-файл должен содержать строку заголовков и хотя бы одно объявление.",
    "listings.smart_upload.unique_headers_required": "У каждого столбца объявления должен быть уникальный непустой заголовок.",
    "Every listing column needs a unique, non-empty header.": "У каждого столбца объявления должен быть уникальный непустой заголовок.",
    "listings.smart_upload.csv_read_failed": "Не удалось прочитать этот CSV-файл.",
    "listings.smart_upload.map_required_fields": "Сопоставьте обязательные столбцы, чтобы продолжить: {fields}",
    "Map these required columns before continuing: {fields}": "Сопоставьте обязательные столбцы, чтобы продолжить: {fields}",
    "listings.smart_upload.row_missing_required_value": "В строке {row} отсутствует обязательное значение.",
    "Row {row} is missing a required value.": "В строке {row} отсутствует обязательное значение.",
    "listings.smart_upload.invalid_category_id_row": "В строке {row} укажите числовой ID категории или выберите «Сопоставить ID категории вручную».",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "В строке {row} укажите числовой ID категории или выберите «Сопоставить ID категории вручную».",
    "listings.smart_upload.invalid_listing_id_row": "В строке {row} укажите числовой ID объявления или оставьте поле пустым, чтобы создать объявление.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "В строке {row} укажите числовой ID объявления или оставьте поле пустым, чтобы создать объявление.",
    "listings.smart_upload.progress.checking_duplicates": "Поиск существующих объявлений",
    "Checking for existing listings": "Поиск существующих объявлений",
    "listings.smart_upload.duplicate_same_value_row": "Значение {field} уже указано в строке {row} этого файла.",
    "Same {field} appears in row {row} of this file.": "Значение {field} уже указано в строке {row} этого файла.",
    "listings.smart_upload.duplicate_same_value_multiple": "Значение {field} встречается в этом файле несколько раз.",
    "Same {field} appears more than once in this file.": "Значение {field} встречается в этом файле несколько раз.",
    "listings.smart_upload.duplicate_existing_listing": "Совпадает с существующим объявлением №{id} по полю {field}.",
    "Matches existing listing #{id} by {field}.": "Совпадает с существующим объявлением №{id} по полю {field}.",
    "listings.smart_upload.explicit_listing_update": "Объявление с указанным ID #{id} будет обновлено.",
    "Explicit listing ID #{id} will be updated.": "Объявление с указанным ID #{id} будет обновлено.",
    "listings.smart_upload.progress.duplicates_complete": "Проверка дубликатов завершена",
    "Duplicate check complete": "Проверка дубликатов завершена",
    "listings.smart_upload.duplicate_check_failed": "Не удалось проверить существующие объявления.",
    "Could not check existing listings.": "Не удалось проверить существующие объявления.",
    "listings.smart_upload.progress.duplicates_stopped": "Проверка дубликатов остановлена",
    "Duplicate check stopped": "Проверка дубликатов остановлена",
    "listings.smart_upload.prepare_file_failed": "Не удалось подготовить файл импорта.",
    "listings.smart_upload.progress.uploading_file": "Загрузка файла импорта",
    "listings.smart_upload.upload_file_failed": "Не удалось загрузить файл импорта.",
    "listings.smart_upload.all_rows_duplicates": "Все строки распознаны как дубликаты. Выберите «Импортировать в любом случае», чтобы отправить их в Tradly, или начните заново.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Все строки распознаны как дубликаты. Выберите «Импортировать в любом случае», чтобы отправить их в Tradly, или начните заново.",
    "listings.smart_upload.progress.preparing_attributes": "Подготовка атрибутов",
    "listings.smart_upload.attribute_mapped_once": "Каждый атрибут объявления можно сопоставить только один раз. Проверьте сопоставление столбцов перед импортом.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Каждый атрибут объявления можно сопоставить только один раз. Проверьте сопоставление столбцов перед импортом.",
    "listings.smart_upload.progress.preparing_file": "Подготовка файла импорта",
    "listings.smart_upload.progress.tradly_importing": "Tradly импортирует объявления",
    "Tradly is importing listings": "Tradly импортирует объявления",
    "listings.smart_upload.progress.import_complete": "Импорт завершен",
    "listings.smart_upload.progress.import_stopped": "Импорт остановлен",
    "listings.smart_upload.progress.preparing_import": "Подготовка к импорту…",
    "Preparing import…": "Подготовка к импорту…",
    "listings.smart_upload.progress.rows_prepared": "Подготовлено строк: {current} из {total}",
    "{current} of {total} rows prepared": "Подготовлено строк: {current} из {total}",
    "listings.smart_upload.progress.remote_processing": "Tradly обрабатывает загруженный CSV-файл. Это может занять некоторое время.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly обрабатывает загруженный CSV-файл. Это может занять некоторое время.",
    "listings.smart_upload.progress.partial_import": "Tradly импортировала {imported} из {total} строк{ending}. Проверьте результат перед повторной попыткой: полный повтор может создать дубликаты успешно импортированных строк.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly импортировала {imported} из {total} строк{ending}. Проверьте результат перед повторной попыткой: полный повтор может создать дубликаты успешно импортированных строк.",
    "listings.smart_upload.title": "Умная загрузка",
    "Smart Upload": "Умная загрузка",
    "listings.smart_upload.beta": "(Бета)",
    "listings.smart_upload.start_over": "Начать заново",
    "listings.smart_upload.description": "Загрузите объявления, сопоставьте столбцы с существующими полями или создайте новые атрибуты объявления перед импортом.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Загрузите объявления, сопоставьте столбцы с существующими полями или создайте новые атрибуты объявления перед импортом.",
    "listings.smart_upload.step_upload": "Загрузка",
    "listings.smart_upload.step_match": "Сопоставление столбцов",
    "listings.smart_upload.step_preview": "Предпросмотр",
    "listings.smart_upload.step_import": "Импорт",
    "listings.smart_upload.choose_csv": "Выберите CSV-файл",
    "listings.smart_upload.required_columns_help": "Обязательные столбцы: title и category_id. Остальные столбцы можно использовать как атрибуты объявления.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Обязательные столбцы: title и category_id. Остальные столбцы можно использовать как атрибуты объявления.",
    "listings.smart_upload.select_csv_file": "Выберите CSV-файл",
    "listings.smart_upload.match_columns": "Сопоставьте столбцы объявления",
    "Match listing columns": "Сопоставьте столбцы объявления",
    "listings.smart_upload.core_fields_help": "Основные поля отправляются в API объявлений. Дополнительные столбцы можно сохранить как атрибуты объявления.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Основные поля отправляются в API объявлений. Дополнительные столбцы можно сохранить как атрибуты объявления.",
    "listings.smart_upload.do_not_import": "Не импортировать",
    "listings.smart_upload.map_category_manually": "Сопоставить ID категории вручную",
    "Map Category ID manually": "Сопоставить ID категории вручную",
    "listings.smart_upload.category_assignment_help": "Выберите категорию, которая будет назначена каждому импортированному объявлению.",
    "Choose the category to assign to every imported listing.": "Выберите категорию, которая будет назначена каждому импортированному объявлению.",
    "listings.smart_upload.select_category": "Выберите категорию",
    "listings.smart_upload.no_categories": "Категории объявлений не найдены. Сначала создайте категорию, затем снова откройте Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "Категории объявлений не найдены. Сначала создайте категорию, затем снова откройте Smart Upload.",
    "listings.smart_upload.additional_attributes": "Дополнительные атрибуты объявления",
    "Additional listing attributes": "Дополнительные атрибуты объявления",
    "listings.smart_upload.ignore_column": "Игнорировать этот столбец",
    "listings.smart_upload.create_attribute": "＋ Создать атрибут объявления",
    "＋ Create a new listing attribute": "＋ Создать атрибут объявления",
    "listings.smart_upload.attribute_name": "Название атрибута",
    "listings.smart_upload.review_import": "Проверить импорт",
    "listings.smart_upload.rows_scanned_help": "Перед загрузкой проверено объявлений: {count}. Дубликаты ищутся по SKU, штрихкоду, ЧПУ и повторяющимся значениям в этом CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "Перед загрузкой проверено объявлений: {count}. Дубликаты ищутся по SKU, штрихкоду, ЧПУ и повторяющимся значениям в этом CSV.",
    "listings.smart_upload.duplicates_found": "Возможные дубликаты",
    "Potential duplicates found": "Возможные дубликаты",
    "listings.smart_upload.duplicate_rows_skipped": "По умолчанию будет пропущено строк: {count}.",
    "{count} row(s) will be skipped by default.": "По умолчанию будет пропущено строк: {count}.",
    "listings.smart_upload.row_label": "Строка",
    "Row": "Строка",
    "listings.smart_upload.explicit_ids_are_updates": "Строки с указанным ID объявления будут считаться обновлениями.",
    "Rows with an explicit listing ID are treated as updates.": "Строки с указанным ID объявления будут считаться обновлениями.",
    "listings.smart_upload.duplicate_action": "Действие с дубликатами",
    "Duplicate action": "Действие с дубликатами",
    "listings.smart_upload.skip_duplicates": "Пропустить возможные дубликаты (рекомендуется)",
    "Skip potential duplicates (recommended)": "Пропустить возможные дубликаты (рекомендуется)",
    "listings.smart_upload.import_all_anyway": "Импортировать все в любом случае",
    "Import all rows anyway": "Импортировать все в любом случае",
    "listings.smart_upload.untitled_listing": "Объявление без названия",
    "Untitled listing": "Объявление без названия",
    "listings.smart_upload.category_label": "Категория:",
    "Category:": "Категория:",
    "listings.smart_upload.complete": "Умная загрузка завершена",
    "listings.smart_upload.imported_count": "Импортировано объявлений: {imported} из {total}.",
    "{imported} of {total} listings imported.": "Импортировано объявлений: {imported} из {total}.",
    "listings.smart_upload.selected_file": "Выбрано: {name}",
    "listings.smart_upload.checking": "Проверка…",
    "listings.smart_upload.check_duplicates": "Проверить дубликаты",
    "Check duplicates": "Проверить дубликаты",
    "listings.smart_upload.importing": "Импорт…",
    "listings.smart_upload.import_listings": "Импортировать объявления",
    "listings.smart_upload.failed": "Не удалось выполнить умную загрузку.",
    "Smart Upload failed.": "Не удалось выполнить умную загрузку.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Статус (Неактивно / Активно)",
    "listings.upload_media": "Загрузить медиафайлы",
    "listing_form.stock_placeholder": "Введите запас",
    "orders.create_order.order_items_alt": "Состав заказа",
    "orders.create_order.by": "автор",
    "by": "автор",
    "orders.create_order.decrease_quantity": "Уменьшить количество",
    "Decrease quantity": "Уменьшить количество",
    "orders.create_order.increase_quantity": "Увеличить количество",
    "Increase quantity": "Увеличить количество",
    "orders.create_order.remove_item": "Удалить товар",
    "Remove item": "Удалить товар",
    "orders.create_order.rental_period_label": "Период аренды:",
    "Rental period:": "Период аренды:",
    "attributes.enter_text": "Введите текст",
    "attributes.select_date": "Выберите дату",
    "attributes.enter_number": "Введите число",
    "attributes.select_color": "Выберите цвет",
    "attributes.upload_json": "Загрузить JSON",
    "Upload JSON": "Загрузить JSON",
    "attributes.select_location": "Выберите местоположение",
    "attributes.add_listing_preview": "Добавить объявление",
    "attributes.add_account_preview": "Добавить учетную запись",
    "attributes.enter_price": "Введите цену",
    "attributes.preview": "Предпросмотр",
    "attributes.enter_title": "Введите название",
    "attributes.enter_description": "Введите описание",
    "attributes.category": "Категория",
    "attributes.attribute_name": "Название атрибута",
    "attributes.enter_attribute_name": "Введите название атрибута",
    "attributes.select_type": "Выберите тип",
    "attributes.icon": "Значок",
    "attributes.tooltip": "Подсказка",
    "Tooltip": "Подсказка",
    "attributes.enter_tooltip": "Введите текст подсказки атрибута",
    "Enter attribute tooltip": "Введите текст подсказки атрибута",
    "listings.detail.images": "Изображения",
    "listings.detail.posted_by": "Опубликовал(а)",
    "Posted by": "Опубликовал(а)",
    "listings.detail.fulfilled_by_platform": "Выполняется платформой",
    "listings.detail.preview": "Предпросмотр",
    "listings.detail.view_listing": "Посмотреть объявление",
    "View Listing": "Посмотреть объявление",
    "listings.detail.variants": "Варианты",
    "listings.detail.no_attribute_values": "Нет значений атрибута для {name}",
    "listings.detail.attributes": "Атрибуты",
    "listings.detail.starts_from": "Начинается от:",
    "Starts From:": "Начинается от:",
    "listings.detail.schedule": "Расписание",
    "listings.detail.detail": "Подробности",
    "web_config.download": "Скачать",
    "web_config.cancel": "Отмена",
    "web_config.choose_file": "Выберите файл",
    "web_config.title": "Настройки веб-сайта",
    "Web Configs": "Настройки веб-сайта",
    "web_config.favicon": "Фавикон",
    "Favicon": "Фавикон",
    "web_config.logo": "Логотип",
    "web_config.logo_width": "Ширина логотипа",
    "Logo Width": "Ширина логотипа",
    "web_config.width": "Ширина",
    "web_config.logo_height": "Высота логотипа",
    "Logo Height": "Высота логотипа",
    "web_config.height": "Высота",
    "web_config.social_share_image": "Изображение для публикации в соцсетях — Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Изображение для публикации в соцсетях — Open Graph",
    "web_config.business_name": "Название компании",
    "web_config.enter_web_name": "Введите название веб-сайта",
    "Enter web name": "Введите название веб-сайта",
    "web_config.title_font": "Шрифт заголовка",
    "Title Font": "Шрифт заголовка",
    "web_config.select_title_font": "Выберите шрифт заголовка",
    "Select title font": "Выберите шрифт заголовка",
    "web_config.body_font": "Шрифт основного текста",
    "Body Font": "Шрифт основного текста",
    "web_config.select_body_font": "Выберите шрифт основного текста",
    "Select body font": "Выберите шрифт основного текста",
    "web_config.primary_font": "Основной шрифт",
    "Primary Font": "Основной шрифт",
    "web_config.select_primary_font": "Выберите основной шрифт",
    "Select primary font": "Выберите основной шрифт",
    "web_config.uploaded_successfully": "Успешно загружено",
    "web_config.ios_download_icon": "Значок загрузки приложения для iOS",
    "iOS app download icon": "Значок загрузки приложения для iOS",
    "web_config.ios_download_link": "Ссылка для загрузки приложения iOS",
    "iOS app download link": "Ссылка для загрузки приложения iOS",
    "web_config.enter_ios_download_link": "Введите ссылку для загрузки приложения iOS",
    "Enter iOS app download link": "Введите ссылку для загрузки приложения iOS",
    "web_config.android_download_icon": "Значок загрузки приложения Android",
    "Android app download icon": "Значок загрузки приложения Android",
    "web_config.android_download_link": "Ссылка для загрузки приложения Android",
    "Android app download link": "Ссылка для загрузки приложения Android",
    "web_config.enter_android_download_link": "Введите ссылку для загрузки приложения Android",
    "Enter android app download link": "Введите ссылку для загрузки приложения Android",
    "coupons.preview.customer_checkout": "ОФОРМЛЕНИЕ ЗАКАЗА",
    "CUSTOMER CHECKOUT": "ОФОРМЛЕНИЕ ЗАКАЗА",
    "coupons.preview.title": "Купоны в действии",
    "Coupons in action": "Купоны в действии",
    "coupons.preview.featured_product": "Рекомендуемый товар",
    "Your featured product": "Рекомендуемый товар",
    "coupons.preview.product_meta": "1 товар · Стандартная доставка",
    "1 item · Standard delivery": "1 товар · Стандартная доставка",
    "coupons.preview.coupon_applied": "Купон применен",
    "Coupon applied": "Купон применен",
    "coupons.preview.remove": "Удалить",
    "coupons.preview.discount_applied": "Скидка применена к заказу",
    "Discount applied to the order": "Скидка применена к заказу",
    "coupons.preview.subtotal": "Промежуточный итог",
    "coupons.preview.coupon_label": "Купон · WELCOME10",
    "Coupon · WELCOME10": "Купон · WELCOME10",
    "coupons.preview.grand_total": "Итого к оплате",
    "Grand total": "Итого к оплате",
    "coupons.preview.checkout": "ОФОРМИТЬ ЗАКАЗ",
    "CHECKOUT": "ОФОРМИТЬ ЗАКАЗ",
    "payments.stripe_get_keys": "Получить ключи Stripe",
    "Get Stripe keys": "Получить ключи Stripe",
    "payments.stripe_syncing": "Синхронизация со Stripe…",
    "Syncing with Stripe...": "Синхронизация со Stripe…",
    "payments.stripe_verifying_key": "Проверка секретного ключа",
    "Verifying secret key": "Проверка секретного ключа",
    "payments.stripe_creating_webhook": "Создание веб-перехватчика платежей",
    "Creating payment webhook": "Создание веб-перехватчика платежей",
    "payments.stripe_account_summary": "{country} · режим {mode} · {id}",
    "{country} · {mode} mode · {id}": "{country} · режим {mode} · {id}",
    "payments.stripe_webhooks_configured": "✓ Веб-перехватчики настроены — секреты автоматически заполнены ниже. Сохраните форму, чтобы применить изменения.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Веб-перехватчики настроены — секреты автоматически заполнены ниже. Сохраните форму, чтобы применить изменения.",
    "payments.stripe_webhooks_error": "⚠ Не удалось настроить веб-перехватчик. Проверьте разрешения ключа и повторите синхронизацию.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Не удалось настроить веб-перехватчик. Проверьте разрешения ключа и повторите синхронизацию.",
    "payments.stripe_invalid_key": "Недействительный секретный ключ. Проверьте его и повторите попытку.",
    "Invalid secret key. Check and try again.": "Недействительный секретный ключ. Проверьте его и повторите попытку.",
    "payments.stripe_setup_failed": "Не удалось выполнить настройку. Сначала синхронизируйте секретный ключ.",
    "Setup failed. Make sure your secret key is synced first.": "Не удалось выполнить настройку. Сначала синхронизируйте секретный ключ.",
    "payments.stripe_marketplace_connect": "Stripe Connect для маркетплейса",
    "Marketplace Connect": "Stripe Connect для маркетплейса",
    "payments.stripe_marketplace_hint": "Нужно только при использовании Stripe Connect для выплат на маркетплейсе",
    "Only needed if you use Stripe Connect for marketplace payouts": "Нужно только при использовании Stripe Connect для выплат на маркетплейсе",
    "payments.stripe_subscription_hint": "Нужно только при продаже товаров по подписке на Tradly",
    "Only needed if you sell subscription products on Tradly": "Нужно только при продаже товаров по подписке на Tradly",
    "integrations.sso.title": "Единый вход для корпоративных клиентов",
    "Enterprise single sign-on": "Единый вход для корпоративных клиентов",
    "integrations.sso.description": "Подключите корпоративного поставщика идентификации, чтобы сотрудники подготовленного клиента могли входить в ArcticWhale через OIDC. Поддерживаются Okta, Microsoft Entra ID и поставщики OIDC, подписывающие ID-токены с помощью RS256.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Подключите корпоративного поставщика идентификации, чтобы сотрудники подготовленного клиента могли входить в ArcticWhale через OIDC. Поддерживаются Okta, Microsoft Entra ID и поставщики OIDC, подписывающие ID-токены с помощью RS256.",
    "integrations.sso.issuer_url": "URL издателя",
    "Issuer URL": "URL издателя",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID клиента",
    "integrations.sso.client_secret": "Секрет клиента",
    "integrations.sso.secret_replace_placeholder": "Сохранено безопасно. Введите значение, чтобы заменить его.",
    "Saved securely. Enter a value to replace it.": "Сохранено безопасно. Введите значение, чтобы заменить его.",
    "integrations.sso.secret_placeholder": "Введите секрет клиента",
    "Enter the client secret": "Введите секрет клиента",
    "integrations.sso.email_domains": "Домены корпоративной почты",
    "Company email domains": "Домены корпоративной почты",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "У сотрудников уже должна быть учетная запись ArcticWhale и доступ к этому клиенту. Используйте домены, принадлежащие вашей организации.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "У сотрудников уже должна быть учетная запись ArcticWhale и доступ к этому клиенту. Используйте домены, принадлежащие вашей организации.",
    "integrations.sso.callback_url": "URL обратного вызова OIDC",
    "OIDC callback URL": "URL обратного вызова OIDC",
    "integrations.sso.loading_callback_url": "Загрузка URL обратного вызова…",
    "Loading callback URL…": "Загрузка URL обратного вызова…",
    "integrations.sso.callback_help": "Добавьте этот URL без изменений в приложение поставщика идентификации как Web redirect URI.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Добавьте этот URL без изменений в приложение поставщика идентификации как Web redirect URI.",
    "integrations.sso.enable": "Включить корпоративный вход SSO",
    "Enable company SSO sign-in": "Включить корпоративный вход SSO",
    "integrations.sso.checking": "Проверка…",
    "integrations.sso.test_issuer": "Проверить издателя",
    "Test issuer": "Проверить издателя",
    "integrations.sso.saving": "Сохранение…",
    "integrations.sso.save": "Сохранить настройки SSO",
    "Save SSO settings": "Сохранить настройки SSO",
    "integrations.sso.security_help": "Секрет клиента шифруется перед сохранением. SSO добавляет способ входа для организации; вход по паролю в этой конфигурации остается доступен.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "Секрет клиента шифруется перед сохранением. SSO добавляет способ входа для организации; вход по паролю в этой конфигурации остается доступен.",
    "integrations.sso.load_error": "Не удалось загрузить настройки корпоративного SSO.",
    "Unable to load enterprise SSO settings.": "Не удалось загрузить настройки корпоративного SSO.",
    "integrations.sso.save_error": "Не удалось сохранить настройки корпоративного SSO.",
    "Unable to save enterprise SSO settings.": "Не удалось сохранить настройки корпоративного SSO.",
    "integrations.sso.saved": "Настройки корпоративного SSO сохранены.",
    "Enterprise SSO settings saved.": "Настройки корпоративного SSO сохранены.",
    "integrations.sso.connection_ok": "Обнаружение поставщика идентификации доступно.",
    "Identity provider discovery is reachable.": "Обнаружение поставщика идентификации доступно.",
    "integrations.sso.connection_error": "Не удалось подключиться к поставщику идентификации.",
    "Unable to connect to the identity provider.": "Не удалось подключиться к поставщику идентификации.",
    "listing_configs.maximum_quantity_per_listing": "Максимальное количество на объявление",
    "listing_configs.example_quantity": "(Например: 100)",
    "listing_configs.enter_maximum_quantity": "Введите максимальное количество на объявление",
    "Enter maximum quantity per listing": "Введите максимальное количество на объявление",
    "listing_configs.minimum_listing_price": "Минимальная цена объявления",
    "listing_configs.example_price": "(Например: $5)",
    "listing_configs.enter_minimum_price": "Введите минимальную цену объявления",
    "Enter minimum listing price": "Введите минимальную цену объявления",
    "listing_configs.picture_count": "Количество загружаемых изображений",
    "listing_configs.enter_picture_count": "Введите количество изображений",
    "Enter Pictures count": "Введите количество изображений",
    "listing_configs.feature_activation": "АКТИВАЦИЯ ФУНКЦИЙ",
    "FEATURE ACTIVATION": "АКТИВАЦИЯ ФУНКЦИЙ",
    "listing_configs.example_landmark": "(Например: ориентир)",
    "listing_configs.enter_address_label": "Введите подпись адреса",
    "Enter address Label": "Введите подпись адреса",
    "listing_configs.legacy_switch_0": "Автоматически одобрять объявления?",
    "listing_configs.legacy_switch_1": "Процент предложения",
    "listing_configs.legacy_switch_2": "Ограничения максимального количества на уровне объявления",
    "listing_configs.legacy_switch_3": "Стоимость доставки",
    "listing_configs.legacy_switch_4": "Использовать маркер карты вместо поиска адреса",
    "Use map marker instead \nof searching address": "Использовать маркер карты вместо поиска адреса",
    "listing_configs.legacy_switch_5": "Теги",
    "listing_configs.legacy_switch_6": "Запасы",
    "listing_configs.legacy_switch_7": "Геоадрес",
    "listing_configs.legacy_switch_8": "Показывать объявления, которых нет в наличии, в ленте",
    "listing_configs.legacy_switch_9": "ЧПУ-заголовок объявления",
    "listing_configs.legacy_switch_10": "Варианты",
    "listing_configs.legacy_switch_11": "Мета-заголовок",
    "listing_configs.legacy_switch_12": "Мета-описание",
    "listing_configs.legacy_switch_13": "Цифровой товар",
    "Digital Product": "Цифровой товар",
    "listing_configs.legacy_switch_14": "Включить Composer",
    "listing_configs.legacy_switch_15": "Включить вес",
    "listing_configs.legacy_switch_16": "Включить размеры",
    "navigation.app_download.close": "Закрыть",
    "navigation.app_download.eyebrow": "Мобильное приложение",
    "Mobile companion": "Мобильное приложение",
    "navigation.app_download.title": "Продолжайте развивать проект на ходу.",
    "Keep your project moving.": "Продолжайте развивать проект на ходу.",
    "navigation.app_download.description": "Управляйте основными задачами с телефона: одобряйте новые объявления, проверяйте заказы и следите за работой бизнеса.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Управляйте основными задачами с телефона: одобряйте новые объявления, проверяйте заказы и следите за работой бизнеса.",
    "navigation.app_download.approve_listings": "Одобрять объявления",
    "Approve listings": "Одобрять объявления",
    "navigation.app_download.manage_orders": "Управлять заказами",
    "Manage orders": "Управлять заказами",
    "navigation.app_download.check_performance": "Проверять показатели",
    "Check performance": "Проверять показатели",
    "navigation.app_download.download_title": "Скачать приложение SuperAdmin",
    "Download the SuperAdmin app": "Скачать приложение SuperAdmin",
    "navigation.app_download.download_on": "Скачать в",
    "Download on the": "Скачать в",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Доступно в",
    "Get it on": "Доступно в",
    "listing_configs.address_label": "Подпись адреса",
    "collections.add_another_condition": "＋ Добавить условие",
    "collections.search": "Поиск",
    "collections.status_inactive_active": "Статус (Неактивен / Активен)",
    "media_picker.add_photo": "Добавить фото",
    "payments.payment_intent_webhook_secret": "Секрет веб-перехватчика платежного намерения",
    "Payment Intent Webhook secret": "Секрет веб-перехватчика платежного намерения",
    "payments.subscription_webhook_secret": "Секрет веб-перехватчика подписки",
    "Subscription Webhook secret": "Секрет веб-перехватчика подписки",
    "payments.webhook_secret_autofilled": "Секрет веб-перехватчика автоматически заполнен выше — сохраните форму, чтобы применить его.",
    "Webhook secret auto-filled above — save the form to persist.": "Секрет веб-перехватчика автоматически заполнен выше — сохраните форму, чтобы применить его.",
    "app_customization.white_png_icon_help": "Значок должен быть белым и в формате PNG",
    "icon should be white and in png format": "Значок должен быть белым и в формате PNG",
    "app_customization.other_appearance": "Другие параметры оформления",
    "Other appearance": "Другие параметры оформления",
    "app_customization.notification_icon": "Значок уведомления",
    "Notification icon": "Значок уведомления",
    "app_customization.app_title_home": "Название приложения на главном экране",
    "app_customization.enable_app_title_icon": "Использовать значок вместо текста в названии приложения",
    "listings.quick_add.title": "Быстрое добавление объявления",
    "Quick Add Listing": "Быстрое добавление объявления",
    "listings.quick_add.success": "Объявление успешно добавлено",
    "Listing Added Successfully": "Объявление успешно добавлено",
    "listings.quick_add.image": "Изображение",
    "listings.quick_add.listing_name": "Название объявления",
    "Listing Name": "Название объявления",
    "listings.quick_add.title_placeholder": "Например, беспроводные наушники премиум-класса",
    "e.g., Premium Wireless Headphones": "Например, беспроводные наушники премиум-класса",
    "listings.quick_add.category": "Категория",
    "listings.quick_add.select_category": "Выберите категорию",
    "listings.quick_add.price": "Цена",
    "listings.quick_add.stock": "Запас",
    "listings.quick_add.description": "Описание",
    "listings.quick_add.description_placeholder": "Краткое описание товара…",
    "Brief Description of your product...": "Краткое описание товара…",
    "listings.quick_add.more_options": "Нужны дополнительные параметры? Используйте",
    "Need more options? Use the full": "Нужны дополнительные параметры? Используйте",
    "listings.quick_add.guided_form": "полную форму",
    "guided form": "полную форму",
    "listings.quick_add.instead": "вместо этого",
    "instead": "вместо этого",
    "listings.digital_product.title": "Добавить цифровой товар",
    "Add Digital Product": "Добавить цифровой товар",
    "listings.digital_product.select_file": "Выберите файл",
    "Select file": "Выберите файл",
    "listings.digital_product.name": "Название",
    "listings.digital_product.version": "Версия",
    "listings.digital_product.description": "Описание",
    "web_config.social_info": "Информация о соцсетях",
    "Social Info": "Информация о соцсетях",
    "web_config.social_facebook_pageurl": "URL страницы Facebook",
    "Facebook page URL": "URL страницы Facebook",
    "web_config.enter_social_facebook_pageurl": "Введите URL страницы Facebook",
    "Enter Facebook page URL": "Введите URL страницы Facebook",
    "web_config.social_twitter_handleurl": "URL профиля Twitter",
    "Twitter handle URL": "URL профиля Twitter",
    "web_config.enter_social_twitter_handleurl": "Введите URL профиля Twitter",
    "Enter Twitter handle URL": "Введите URL профиля Twitter",
    "web_config.social_instagram_url": "URL Instagram",
    "Instagram URL": "URL Instagram",
    "web_config.enter_social_instagram_url": "Введите URL Instagram",
    "Enter Instagram URL": "Введите URL Instagram",
    "web_config.social_youtube_channelurl": "URL канала YouTube",
    "Youtube channel URL": "URL канала YouTube",
    "web_config.enter_social_youtube_channelurl": "Введите URL канала YouTube",
    "Enter Youtube channel URL": "Введите URL канала YouTube",
    "web_config.social_tiktok_url": "URL TikTok",
    "Tiktok URL": "URL TikTok",
    "web_config.enter_social_tiktok_url": "Введите URL TikTok",
    "Enter Tiktok URL": "Введите URL TikTok",
    "web_config.social_spotify_url": "URL Spotify",
    "Spotify URL": "URL Spotify",
    "web_config.enter_social_spotify_url": "Введите URL Spotify",
    "Enter Spotify URL": "Введите URL Spotify",
    "web_config.social_whatsapp_number": "Номер WhatsApp",
    "Whatsapp number": "Номер WhatsApp",
    "web_config.enter_social_whatsapp_number": "Введите номер WhatsApp",
    "Enter Whatsapp number": "Введите номер WhatsApp",
    "web_config.social_telegram_url": "URL Telegram",
    "Telegram URL": "URL Telegram",
    "web_config.enter_social_telegram_url": "Введите URL Telegram",
    "Enter Telegram URL": "Введите URL Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Введите Snapchat",
    "Enter Snapchat": "Введите Snapchat",
    "payments.paydunya.title": "Интеграция PayDunya",
    "PayDunya Integration": "Интеграция PayDunya",
    "payments.paydunya.master_key": "Главный ключ",
    "Master key": "Главный ключ",
    "payments.paydunya.enter_master_key": "Введите главный ключ",
    "Enter master key": "Введите главный ключ",
    "payments.paydunya.public_key": "Открытый ключ",
    "Public key": "Открытый ключ",
    "payments.paydunya.enter_public_key": "Введите открытый ключ",
    "payments.paydunya.private_key": "Закрытый ключ",
    "Private key": "Закрытый ключ",
    "payments.paydunya.enter_private_key": "Введите закрытый ключ",
    "Enter private key": "Введите закрытый ключ",
    "payments.paydunya.token": "Токен",
    "payments.paydunya.enter_token": "Введите токен",
    "payments.paydunya.uploaded_successfully": "Успешно загружено",
    "communications.email_stats_open": "Отправлено: {sent} · открыто: {openRate}%",
    "{sent} sent · {openRate}% open": "Отправлено: {sent} · открыто: {openRate}%",
    "communications.email_stats_full": "Отправлено: {sent} · открыто: {openRate}% · переходы: {clicks}",
    "{sent} sent · {openRate}% open · {clicks} clicks": "Отправлено: {sent} · открыто: {openRate}% · переходы: {clicks}",
    "navigation.mini_apps.title": "Мини-приложения",
    "Mini Apps": "Мини-приложения",
    "navigation.mini_apps.subtitle": "Вспомогательные инструменты от Tradly — нажмите карточку, чтобы узнать подробности и стоимость",
    "Tradly-built companion tools — tap a card to see details and pricing": "Вспомогательные инструменты от Tradly — нажмите карточку, чтобы узнать подробности и стоимость",
    "navigation.mini_apps.soon": "Скоро",
    "Soon": "Скоро",
    "navigation.mini_apps.included_in_paid_plan": "Включено в платный тариф",
    "Included in a paid plan": "Включено в платный тариф",
    "navigation.mini_apps.know_more": "Подробнее",
    "Know more": "Подробнее",
    "navigation.mini_apps.hide_details": "Скрыть подробности",
    "Hide details": "Скрыть подробности",
    "navigation.mini_apps.view_plans": "Посмотреть тарифы",
    "navigation.mini_apps.remove": "Удалить",
    "navigation.mini_apps.add_to_sidebar": "Добавить на боковую панель",
    "Add to sidebar": "Добавить на боковую панель",
    "navigation.mini_apps.why_heading": "Зачем это нужно вашему бизнесу",
    "Why your business needs it": "Зачем это нужно вашему бизнесу",
    "navigation.mini_apps.coming_soon": "Скоро",
    "navigation.mini_apps.workflow.title": "Маркетинг",
    "navigation.mini_apps.workflow.description": "Запускайте email-кампании, push-уведомления и акции, чтобы расширять аудиторию.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Запускайте email-кампании, push-уведомления и акции, чтобы расширять аудиторию.",
    "navigation.mini_apps.workflow.why_1": "Отправляйте целевые email-кампании покупателям и продавцам с учетом их активности",
    "Send targeted email campaigns to buyers and sellers based on activity": "Отправляйте целевые email-кампании покупателям и продавцам с учетом их активности",
    "navigation.mini_apps.workflow.why_2": "Возвращайте пользователей, которые не заходили более 7 дней, с помощью push-уведомлений",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Возвращайте пользователей, которые не заходили более 7 дней, с помощью push-уведомлений",
    "navigation.mini_apps.workflow.why_3": "Запускайте акции с купонами к сезонным событиям",
    "Run promotions with coupon drops timed to your seasonal events": "Запускайте акции с купонами к сезонным событиям",
    "navigation.mini_apps.workflow.pricing_label": "Оплата кредитами",
    "Credits-based": "Оплата кредитами",
    "navigation.mini_apps.workflow.pricing_detail": "Оплата за отправку: 1 000 писем стоят 100 кредитов. Срок действия кредитов не истекает.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Оплата за отправку: 1 000 писем стоят 100 кредитов. Срок действия кредитов не истекает.",
    "navigation.mini_apps.intelligence_section.title": "Аналитика",
    "navigation.mini_apps.intelligence_section.description": "Изучайте рост с помощью аналитики, воронок и аналитических выводов на базе ИИ.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Изучайте рост с помощью аналитики, воронок и аналитических выводов на базе ИИ.",
    "navigation.mini_apps.intelligence_section.why_1": "Узнайте, какие объявления, учетные записи и категории приносят наибольший GMV",
    "See which listings, accounts, and categories drive the most GMV": "Узнайте, какие объявления, учетные записи и категории приносят наибольший GMV",
    "navigation.mini_apps.intelligence_section.why_2": "Воронки оттока точно показывают, где покупатели уходят до оформления заказа",
    "Drop-off funnels show exactly where buyers leave before checkout": "Воронки оттока точно показывают, где покупатели уходят до оформления заказа",
    "navigation.mini_apps.intelligence_section.why_3": "ИИ выявляет аномалии и возможности, которые можно не заметить в исходных данных",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "ИИ выявляет аномалии и возможности, которые можно не заметить в исходных данных",
    "navigation.mini_apps.intelligence_section.pricing_label": "Оплата кредитами",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Анализ ИИ и созданные отчеты расходуют кредиты. Просмотр данных всегда бесплатен.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Анализ ИИ и созданные отчеты расходуют кредиты. Просмотр данных всегда бесплатен.",
    "navigation.mini_apps.subscription_section.title": "Подписки",
    "navigation.mini_apps.subscription_section.description": "Управляйте тарифами, платежными циклами и доступом к функциям ваших клиентов.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Управляйте тарифами, платежными циклами и доступом к функциям ваших клиентов.",
    "navigation.mini_apps.subscription_section.why_1": "Создавайте многоуровневые тарифы (Free / Pro / Enterprise) с ограничениями по функциям",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Создавайте многоуровневые тарифы (Free / Pro / Enterprise) с ограничениями по функциям",
    "navigation.mini_apps.subscription_section.why_2": "Автоматизируйте платежные циклы: ежемесячные, годовые или произвольной длительности",
    "Automate billing cycles — monthly, annual, or custom durations": "Автоматизируйте платежные циклы: ежемесячные, годовые или произвольной длительности",
    "navigation.mini_apps.subscription_section.why_3": "Права доступа открывают или ограничивают функции для ваших клиентов",
    "Entitlements unlock or restrict features across your tenant base": "Права доступа открывают или ограничивают функции для ваших клиентов",
    "navigation.mini_apps.subscription_section.pricing_label": "Подключение",
    "navigation.mini_apps.subscription_section.pricing_detail": "Оплата за задачу — за каждое событие подписки (повышение тарифа, продление, отмена).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Оплата за задачу — за каждое событие подписки (повышение тарифа, продление, отмена).",
    "navigation.mini_apps.membership_section.title": "Членство",
    "navigation.mini_apps.membership_section.description": "Управляйте программами членства, участниками, взносами и платежами.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Управляйте программами членства, участниками, взносами и платежами.",
    "navigation.mini_apps.membership_section.why_1": "Управляйте программами членства и зарегистрированными участниками",
    "Manage membership programs and enrolled members": "Управляйте программами членства и зарегистрированными участниками",
    "navigation.mini_apps.membership_section.why_2": "Отслеживайте взносы, задолженности по платежам и статус членства",
    "Track contributions, payment dues, and membership status": "Отслеживайте взносы, задолженности по платежам и статус членства",
    "navigation.mini_apps.membership_section.why_3": "Связывайте взносы участников с соответствующими заказами",
    "Connect membership contributions back to their orders": "Связывайте взносы участников с соответствующими заказами",
    "navigation.mini_apps.membership_section.pricing_label": "Цена уточняется",
    "Pricing TBC": "Цена уточняется",
    "navigation.mini_apps.membership_section.pricing_detail": "Управляйте программами членства и историей взносов в одном месте.",
    "Manage membership programs and contribution history in one place.": "Управляйте программами членства и историей взносов в одном месте.",
    "navigation.mini_apps.reward_programs.title": "Награды",
    "navigation.mini_apps.reward_programs.description": "Создавайте программы вознаграждений с областями действия, правилами и повторно используемыми схемами.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Создавайте программы вознаграждений с областями действия, правилами и повторно используемыми схемами.",
    "navigation.mini_apps.reward_programs.why_1": "Определяйте партнерские, реферальные, региональные или магазинные программы вознаграждений",
    "Define affiliate, referral, regional, or store reward programs": "Определяйте партнерские, реферальные, региональные или магазинные программы вознаграждений",
    "navigation.mini_apps.reward_programs.why_2": "Создавайте правила из повторно используемых компонентов комиссий и вознаграждений",
    "Build rules from reusable commission and reward components": "Создавайте правила из повторно используемых компонентов комиссий и вознаграждений",
    "navigation.mini_apps.reward_programs.why_3": "Расчет вознаграждений и передачу в реестр выполняет ERP-система",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Расчет вознаграждений и передачу в реестр выполняет ERP-система",
    "navigation.mini_apps.reward_programs.pricing_label": "Цена уточняется",
    "navigation.mini_apps.reward_programs.pricing_detail": "Настройте программы вознаграждений и свяжите их с атрибуцией.",
    "Configure reward programs and connect them to attribution.": "Настройте программы вознаграждений и свяжите их с атрибуцией.",
    "navigation.mini_apps.bundles_app.title": "Комплекты",
    "navigation.mini_apps.bundles_app.description": "Создавайте фиксированные комплекты и наборы с выбором товаров из существующих объявлений.",
    "Create fixed and mix-and-match bundles from existing listings.": "Создавайте фиксированные комплекты и наборы с выбором товаров из существующих объявлений.",
    "navigation.mini_apps.bundles_app.why_1": "Объединяйте существующие объявления без дублирования данных о товарах",
    "Combine existing listings without duplicating product data": "Объединяйте существующие объявления без дублирования данных о товарах",
    "navigation.mini_apps.bundles_app.why_2": "Поддерживайте фиксированные комплекты и наборы, которые покупатели собирают сами",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Поддерживайте фиксированные комплекты и наборы, которые покупатели собирают сами",
    "navigation.mini_apps.bundles_app.why_3": "Проверяйте запасы компонентов перед оформлением и выполнением заказа",
    "Validate component stock before checkout and fulfilment": "Проверяйте запасы компонентов перед оформлением и выполнением заказа",
    "navigation.mini_apps.bundles_app.pricing_label": "Функция платного тарифа",
    "Paid package feature": "Функция платного тарифа",
    "navigation.mini_apps.bundles_app.pricing_detail": "Доступно в тарифах с поддержкой операций с комплектами.",
    "Available on plans that include bundle operations.": "Доступно в тарифах с поддержкой операций с комплектами.",
    "navigation.mini_apps.inventory_section.title": "Цепочка поставок",
    "navigation.mini_apps.inventory_section.description": "Запасы, заказы на закупку, места хранения, поставщики и операции.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Запасы, заказы на закупку, места хранения, поставщики и операции.",
    "navigation.mini_apps.inventory_section.why_1": "Отслеживайте запасы на нескольких складах и в торговых точках",
    "Track stock levels across multiple warehouses and store locations": "Отслеживайте запасы на нескольких складах и в торговых точках",
    "navigation.mini_apps.inventory_section.why_2": "Создавайте заказы поставщикам и принимайте по ним товары",
    "Raise purchase orders with suppliers and receive stock against them": "Создавайте заказы поставщикам и принимайте по ним товары",
    "navigation.mini_apps.inventory_section.why_3": "Записывайте операции с запасами: корректировки, перемещения и списания",
    "Record inventory operations — adjustments, transfers, and write-offs": "Записывайте операции с запасами: корректировки, перемещения и списания",
    "navigation.mini_apps.inventory_section.pricing_label": "Включено",
    "Included": "Включено",
    "navigation.mini_apps.inventory_section.pricing_detail": "Supply Chain включен в ваш тариф. Дополнительная плата не взимается.",
    "Supply Chain is included in your plan. No additional charge.": "Supply Chain включен в ваш тариф. Дополнительная плата не взимается.",
    "navigation.mini_apps.people_app.title": "Сотрудники",
    "navigation.mini_apps.people_app.description": "Каталог сотрудников, отделы, должности и уровни оплаты.",
    "Staff directory, departments, job profiles, and pay grades.": "Каталог сотрудников, отделы, должности и уровни оплаты.",
    "navigation.mini_apps.people_app.why_1": "Храните профиль, код и тип занятости каждого сотрудника в одном каталоге",
    "Keep every staff profile, code, and employment type in one directory": "Храните профиль, код и тип занятости каждого сотрудника в одном каталоге",
    "navigation.mini_apps.people_app.why_2": "Организуйте команды по отделам со стандартными должностями",
    "Organise teams into departments with standard job profiles": "Организуйте команды по отделам со стандартными должностями",
    "navigation.mini_apps.people_app.why_3": "Настройте уровни оплаты один раз и назначайте их сотрудникам",
    "Define pay grades once and assign them to staff": "Настройте уровни оплаты один раз и назначайте их сотрудникам",
    "navigation.mini_apps.people_app.pricing_label": "Цена уточняется",
    "navigation.mini_apps.people_app.pricing_detail": "Необходимо для Workforce и Payroll.",
    "Required by Workforce and Payroll.": "Необходимо для Workforce и Payroll.",
    "navigation.mini_apps.workforce_app.title": "Персонал",
    "navigation.mini_apps.workforce_app.description": "Смены, учет рабочего времени и управление отпусками команды.",
    "Shifts, attendance, and leave management for your team.": "Смены, учет рабочего времени и управление отпусками команды.",
    "navigation.mini_apps.workforce_app.why_1": "Назначайте сотрудникам смены по дате, времени и месту",
    "Roster staff into shifts by date, time, and location": "Назначайте сотрудникам смены по дате, времени и месту",
    "navigation.mini_apps.workforce_app.why_2": "Отмечайте начало и конец смены с полной историей посещаемости",
    "Clock in and out with a full attendance history": "Отмечайте начало и конец смены с полной историей посещаемости",
    "navigation.mini_apps.workforce_app.why_3": "Политики отпусков, остатки дней и процесс одобрения или отклонения",
    "Leave policies, balances, and an approve/reject workflow": "Политики отпусков, остатки дней и процесс одобрения или отклонения",
    "navigation.mini_apps.workforce_app.pricing_label": "Цена уточняется",
    "navigation.mini_apps.workforce_app.pricing_detail": "Автоматически включает People.",
    "Turns on People automatically.": "Автоматически включает People.",
    "navigation.mini_apps.payroll_app.title": "Расчет зарплаты",
    "navigation.mini_apps.payroll_app.description": "Расчет зарплаты, согласование, экспорт CSV и возмещение расходов.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Расчет зарплаты, согласование, экспорт CSV и возмещение расходов.",
    "navigation.mini_apps.payroll_app.why_1": "Создавайте расчетные ведомости за период на основе уровней оплаты сотрудников",
    "Create payroll runs per period from staff pay grades": "Создавайте расчетные ведомости за период на основе уровней оплаты сотрудников",
    "navigation.mini_apps.payroll_app.why_2": "Утверждайте ведомости и экспортируйте их в CSV для банка или бухгалтера",
    "Approve runs and export them as CSV for your bank or accountant": "Утверждайте ведомости и экспортируйте их в CSV для банка или бухгалтера",
    "navigation.mini_apps.payroll_app.why_3": "Обрабатывайте заявки сотрудников на возмещение расходов от подачи до выплаты",
    "Staff expense claims from submission to reimbursement": "Обрабатывайте заявки сотрудников на возмещение расходов от подачи до выплаты",
    "navigation.mini_apps.payroll_app.pricing_label": "Цена уточняется",
    "navigation.mini_apps.payroll_app.pricing_detail": "Автоматически включает People.",
    "navigation.mini_apps.unified_inbox.title": "Единый почтовый ящик",
    "Unified Inbox": "Единый почтовый ящик",
    "navigation.mini_apps.unified_inbox.description": "Вся переписка с клиентами — заказы, поддержка и чаты — в одном месте.",
    "All your customer communication — orders, support, and chat — from one place.": "Вся переписка с клиентами — заказы, поддержка и чаты — в одном месте.",
    "navigation.mini_apps.unified_inbox.why_1": "Запросы по заказам, обращения в поддержку и сообщения покупателей в одной ленте",
    "Order queries, support tickets, and buyer messages in one thread view": "Запросы по заказам, обращения в поддержку и сообщения покупателей в одной ленте",
    "navigation.mini_apps.unified_inbox.why_2": "Отвечайте с помощью ответов, предложенных ИИ и обученных на вашем каталоге",
    "Reply with AI-suggested responses trained on your catalogue": "Отвечайте с помощью ответов, предложенных ИИ и обученных на вашем каталоге",
    "navigation.mini_apps.unified_inbox.why_3": "Добавляйте теги, назначайте ответственных и закрывайте диалоги всей командой",
    "Tag, assign, and resolve conversations across your team": "Добавляйте теги, назначайте ответственных и закрывайте диалоги всей командой",
    "navigation.mini_apps.unified_inbox.pricing_label": "Подключение",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Оплата за каждое решенное обращение.",
    "Task-based pricing per resolved conversation.": "Оплата за каждое решенное обращение.",
    "navigation.mini_apps.social_connect.title": "Социальные сети",
    "Social Connect": "Социальные сети",
    "navigation.mini_apps.social_connect.description": "Публикуйте объявления в соцсетях по заданному расписанию.",
    "Share listings to social channels on a schedule you define.": "Публикуйте объявления в соцсетях по заданному расписанию.",
    "navigation.mini_apps.social_connect.why_1": "Автоматически планируйте публикации объявлений в Instagram, Facebook и X",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Автоматически планируйте публикации объявлений в Instagram, Facebook и X",
    "navigation.mini_apps.social_connect.why_2": "Задавайте расписание публикаций для каждого канала: ежедневные посты, флеш-распродажи или свой график",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Задавайте расписание публикаций для каждого канала: ежедневные посты, флеш-распродажи или свой график",
    "navigation.mini_apps.social_connect.why_3": "Отслеживайте переходы и вовлеченность по каждому объявлению на панели управления",
    "Track clicks and engagement back to each listing from the dashboard": "Отслеживайте переходы и вовлеченность по каждому объявлению на панели управления",
    "navigation.mini_apps.social_connect.pricing_label": "Подключение",
    "navigation.mini_apps.social_connect.pricing_detail": "Оплата за каждую опубликованную запланированную запись.",
    "Task-based pricing per scheduled post delivered.": "Оплата за каждую опубликованную запланированную запись.",
    "navigation.mini_apps.shopping_channels.title": "Каналы продаж",
    "Shopping Channels": "Каналы продаж",
    "navigation.mini_apps.shopping_channels.description": "Подключите каталог к TikTok Shop, Shopee, Meta Catalog, Uber Eats и другим сервисам.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Подключите каталог к TikTok Shop, Shopee, Meta Catalog, Uber Eats и другим сервисам.",
    "navigation.mini_apps.shopping_channels.why_1": "Мгновенно синхронизируйте объявления с TikTok Shop, Shopee и Meta Catalog",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Мгновенно синхронизируйте объявления с TikTok Shop, Shopee и Meta Catalog",
    "navigation.mini_apps.shopping_channels.why_2": "Подключайте каталоги еды и напитков к Uber Eats и Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Подключайте каталоги еды и напитков к Uber Eats и Grab",
    "navigation.mini_apps.shopping_channels.why_3": "Запасы и заказы синхронизируются автоматически — без повторного ввода данных",
    "Inventory and orders sync back automatically — no double-entry": "Запасы и заказы синхронизируются автоматически — без повторного ввода данных",
    "navigation.mini_apps.shopping_channels.pricing_label": "Подключение",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Оплата за каждый заказ, выполненный через подключенный канал.",
    "Task-based pricing per order fulfilled through a connected channel.": "Оплата за каждый заказ, выполненный через подключенный канал.",
    "listing_configs.customize_table": "Настроить таблицу",
    "Customize table": "Настроить таблицу",
    "listing_configs.fields_visible": "Столбцы таблицы",
    "Fields visible in table": "Столбцы таблицы",
    "listing_configs.fields_hidden": "Скрытые столбцы таблицы",
    "Fields not shown in table": "Скрытые столбцы таблицы",
    "listing_configs.reset_default": "Сбросить по умолчанию",
    "listing_configs.column_title": "Название",
    "listing_configs.column_actions": "Действия",
    "listing_configs.column_website": "Веб-сайт",
    "listing_configs.column_list_price": "Цена по прайсу",
    "listing_configs.column_offer_percent": "Процент скидки",
    "Offer Percent": "Процент скидки",
    "listing_configs.column_image": "Изображение",
    "listing_configs.column_offer_price": "Цена со скидкой",
    "Offer Price": "Цена со скидкой",
    "listing_configs.column_status": "Статус",
    "listing_configs.column_listing_id": "ID объявления",
    "listing_configs.column_listing_status": "Статус объявления",
    "listing_configs.column_accounts": "Учетные записи",
    "listing_configs.column_currency": "Валюта",
    "listing_configs.column_sold": "Продано",
    "listing_configs.column_goal_amount": "Целевая сумма",
    "Goal Amount": "Целевая сумма",
    "listing_configs.column_width": "Ширина",
    "listing_configs.column_height": "Высота",
    "listing_configs.column_weight": "Вес",
    "listing_configs.column_volume": "Объем",
    "Volume": "Объем",
    "listing_configs.column_order_type": "Тип заказа",
    "Order Type": "Тип заказа",
    "navigation.apps_group": "Приложения",
    "navigation.channels_group": "Каналы",
    "navigation.manage_mini_apps": "Управление мини-приложениями",
    "Manage Mini Apps": "Управление мини-приложениями",
    "navigation.manage_channels": "Управление каналами",
    "Manage Channels": "Управление каналами",
    "listings.import.uploading": "Загрузка…",
    "listings.import.complete": "Импорт завершен",
    "listings.import.error": "Ошибка: {message}",
    "Error: {message}": "Ошибка: {message}",
    "listings.import.file_label": "Файл:",
    "listings.import.select_file": "Выберите файл",
    "listings.import.response": "Ответ импорта",
    "Import response": "Ответ импорта",
    "listings.import.total_rows": "Всего строк:",
    "Total rows:": "Всего строк:",
    "listings.import.total_imported": "Всего импортировано:",
    "Total imported:": "Всего импортировано:",
    "listings.import.download_template": "Скачать шаблон объявлений",
    "Download listings template": "Скачать шаблон объявлений",
    "common.upload": "Загрузить",
    "common.kanban_unavailable": "Представление доски временно недоступно",
    "Board view is temporarily unavailable": "Представление доски временно недоступно",
    "common.retry": "Повторить",
    "Retry": "Повторить",
    "listings.digital_assets.title": "Цифровые материалы",
    "Digital assets": "Цифровые материалы",
    "listings.digital_assets.not_found": "Цифровые материалы не найдены",
    "Digital assets not found": "Цифровые материалы не найдены",
    "listings.addon.saved": "Дополнение успешно сохранено.",
    "Add-on saved successfully.": "Дополнение успешно сохранено.",
    "listings.addon.title_required": "Введите название.",
    "Please enter a title.": "Введите название.",
    "listings.addon.price_required": "Введите цену.",
    "Please enter a price.": "Введите цену.",
    "listings.addon.no_media": "У вас нет медиафайлов.",
    "listings.addon.price": "Цена",
    "listings.addon.offer_percentage": "Процент скидки",
    "Offer Percentage": "Процент скидки",
    "listings.addon.maximum_quantity": "Максимальное количество",
    "Maximum Quantity": "Максимальное количество",
    "listings.addon.stock": "Запас",
    "listings.addon.enter_price": "Введите цену",
    "Enter price": "Введите цену",
    "listings.addon.enter_offer_percentage": "Введите процент скидки",
    "Enter offer percentage": "Введите процент скидки",
    "listings.addon.enter_maximum_quantity": "Введите максимальное количество",
    "Enter maximum quantity": "Введите максимальное количество",
    "listings.addon.enter_stock": "Введите запас",
    "listings.addon.edit_title": "Изменить дополнение",
    "Edit Add-on": "Изменить дополнение",
    "listings.addon.add_title": "Добавить дополнение",
    "Add Add-on": "Добавить дополнение",
    "listings.addon.title": "Название",
    "listings.addon.enter_title": "Введите название",
    "listings.addon.status": "Статус (Неактивен / Активен)",
    "listings.addon.upload_media": "Загрузить медиафайлы",
    "attributes.prefill_for": "Предварительное заполнение для",
    "Prefill for": "Предварительное заполнение для",
    "attributes.first_item": "Первый элемент",
    "First Item": "Первый элемент",
    "attributes.all_items": "Все элементы",
    "All Items": "Все элементы",
    "common.uploading": "Загрузка…",
    "common.uploading_named": "Загрузка: {title}",
    "Uploading {title}": "Загрузка: {title}",
    "common.please_wait_short": "Подождите",
    "Please wait": "Подождите",
    "attributes.select_option": "Выбрать",
    "attributes.select_value": "Выберите значение…",
    "Select value...": "Выберите значение…",
    "attributes.type_placeholder": "Введите {name}",
    "Type {name}": "Введите {name}",
    "attributes.multiple_values_placeholder": "Чтобы ввести несколько значений, разделите их запятыми.",
    "Using a comma, you can enter several values.": "Чтобы ввести несколько значений, разделите их запятыми.",
    "attributes.upload_attachment": "Загрузить вложение",
    "Upload Attachment": "Загрузить вложение",
    "attributes.upload_json_file": "Загрузить файл JSON",
    "Upload JSON File": "Загрузить файл JSON",
    "attributes.copied_value": "Значение скопировано",
    "Copied the value": "Значение скопировано",
    "attributes.latitude_longitude_placeholder": "Введите широту и долготу (например, 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Введите широту и долготу (например, 12.34,56.78)",
    "navigation.sidebar_label": "Боковая панель",
    "Side bar": "Боковая панель",
    "checkout_settings.orders_option_0": "Календарь заказов",
    "Orders Calendar View": "Календарь заказов",
    "checkout_settings.show_cart_attributes": "Показывать атрибуты корзины",
    "Show cart attributes": "Показывать атрибуты корзины",
    "checkout_settings.select_order_status": "Выберите статус заказа",
    "Select order status": "Выберите статус заказа",
    "checkout_settings.order_status_0": "Успешно оформлен",
    "Placed success": "Успешно оформлен",
    "checkout_settings.order_status_1": "В обработке",
    "In process": "В обработке",
    "checkout_settings.order_status_2": "Отправлен",
    "checkout_settings.order_status_3": "Доставлен",
    "checkout_settings.order_status_4": "Завершен",
    "listing_form.no_categories_found": "Категории не найдены. Используйте кнопку «{action}» выше.",
    "No categories found. Use “{action}” above.": "Категории не найдены. Используйте кнопку «{action}» выше.",
    "common.learn_more": "Подробнее",
    "Learn more": "Подробнее",
    "common.show_information": "Показать сведения",
    "Show information": "Показать сведения",
    "common.paid_feature": "Платная функция",
    "Paid Feature": "Платная функция",
    "common.learn_more_about": "Подробнее о",
    "Learn more about": "Подробнее о",
    "attributes.categories": "Категории",
    "attributes.edit_bulk_title": "Массовое изменение: {title}",
    "{title} Edit Bulk": "Массовое изменение: {title}",
    "common.enter_description": "Введите описание",
    "common.empty_fetch_message": "Здесь пока нечего показать. Когда появится содержимое, оно отобразится на этой странице.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Здесь пока нечего показать. Когда появится содержимое, оно отобразится на этой странице.",
    "common.ai_credits_and_top_up": "Кредиты ИИ и пополнение",
    "AI credits and top up": "Кредиты ИИ и пополнение",
    "common.ai_credits_loading": "Загрузка кредитов ИИ",
    "Loading AI credits": "Загрузка кредитов ИИ",
    "common.ai_credits_unavailable": "Кредиты ИИ недоступны",
    "AI credits unavailable": "Кредиты ИИ недоступны",
    "common.ai_credits_available": "Доступно кредитов ИИ: {count}",
    "Available AI credits: {count}": "Доступно кредитов ИИ: {count}",
    "common.ai_credits_unavailable_top_up": "Кредиты ИИ недоступны — нажмите, чтобы пополнить",
    "AI credits unavailable — click to top up": "Кредиты ИИ недоступны — нажмите, чтобы пополнить",
    "common.ai_credits_available_top_up": "Доступно кредитов ИИ: {count} — нажмите, чтобы добавить кредиты",
    "Available AI credits: {count} — click to add credits": "Доступно кредитов ИИ: {count} — нажмите, чтобы добавить кредиты",
    "common.ai_credits_add": "Добавить кредиты",
    "Add credits": "Добавить кредиты",
    "navigation.switch_project": "Переключить проект",
    "Switch Project": "Переключить проект",
    "navigation.tenant_switch_failed": "Не удалось переключить клиента. Повторите попытку.",
    "Tenant switch failed. Please try again.": "Не удалось переключить клиента. Повторите попытку.",
    "navigation.select_project": "Выберите проект",
    "Select Project": "Выберите проект",
    "navigation.collapse_sidebar": "Свернуть боковую панель",
    "Collapse sidebar": "Свернуть боковую панель",
    "navigation.expand_sidebar": "Развернуть боковую панель",
    "Expand sidebar": "Развернуть боковую панель",
    "navigation.search": "Поиск",
    "navigation.loading": "Загрузка навигации",
    "Loading navigation": "Загрузка навигации",
    "navigation.help_documentation": "Документация",
    "navigation.help_community": "Сообщество",
    "navigation.help_api_reference": "Справочник API",
    "listings.quick_form": "Краткая форма",
    "Quick Form": "Краткая форма",
    "payments.notification_secret": "Секрет уведомлений",
    "Notification Secret": "Секрет уведомлений",
    "payments.user_type": "Тип пользователя",
    "User Type": "Тип пользователя",
    "payments.category_id": "ID категории",
    "app_customization.other_settings": "Другие настройки",
    "Other Settings": "Другие настройки",
    "app_customization.other_hide_balances": "Скрыть балансы и выплаты в разделе «Еще»",
    "app_customization.other_enable_logs": "Включить журналы",
    "Enable logs": "Включить журналы",
    "app_customization.other_signup_first": "Сначала получить регистрацию",
    "common.beta": "(бета)",
    "(beta)": "(бета)",
    "common.selected_image": "Выбранное изображение",
    "Selected image": "Выбранное изображение",
    "common.ai_no_response_to_copy": "Нет ответа для копирования",
    "No response to copy": "Нет ответа для копирования",
    "common.copied_to_clipboard": "Скопировано в буфер обмена",
    "Copied to clipboard": "Скопировано в буфер обмена",
    "common.ai_suggestions": "Предложения",
    "Suggestions": "Предложения",
    "common.regenerate": "Создать заново",
    "Regenerate": "Создать заново",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "Значок JSON",
    "JSON icon": "Значок JSON",
    "collections.generator_title": "Генератор коллекций",
    "Collection Generator": "Генератор коллекций",
    "collections.generator_create": "Создать коллекцию",
    "collections.generator_json_placeholder": "Введите данные JSON",
    "Enter JSON input": "Введите данные JSON",
    "collections.generator_invalid_data": "Введите корректные данные",
    "Please enter valid data": "Введите корректные данные",
    "category.editor_select_from_media": "Выбрать из медиафайлов",
    "payments.subscription": "Подписка",
    "payments.subscription_setting_up": "Настройка…",
    "Setting up...": "Настройка…",
    "payments.subscription_webhook_configured": "Веб-перехватчик подписок настроен",
    "Subscription webhook configured": "Веб-перехватчик подписок настроен",
    "payments.subscription_retry_setup": "Повторить настройку",
    "Retry setup": "Повторить настройку",
    "payments.setup_subscription_webhook": "Настроить веб-перехватчик подписок",
    "Setup Subscription Webhook": "Настроить веб-перехватчик подписок",
    "orders.shipment_number": "Отправление {number}",
    "Shipment {number}": "Отправление {number}",
    "orders.quantity_short": "КОЛ-ВО",
    "orders.shipment_status_1": "Отправление создано",
    "orders.shipment_status_2": "Отправление в пути",
    "orders.shipment_status_3": "Отправлено",
    "orders.shipment_status_4": "Готово к получению",
    "orders.shipment_status_5": "Передано курьеру",
    "orders.shipment_status_6": "Возврат не доставленного отправления",
    "orders.shipment_status_7": "Отправление доставлено",
    "orders.shipment_status_8": "Доставка отправления подтверждена",
    "orders.shipment_status_9": "Возврат начат",
    "orders.shipment_status_10": "Возвращено для получения",
    "orders.shipment_status_11": "Возврат отправления подтвержден",
    "orders.shipment_status_12": "Отменено продавцом",
    "orders.shipment_status_13": "Отменено покупателем",
    "orders.shipment_status_14": "Прибыло к покупателю",
    "orders.shipment_status_15": "Отменено администратором",
    "attributes.metadata_title": "Метаданные",
    "Metadata": "Метаданные",
    "common.add_row": "Добавить строку",
    "common.no_access": "Нет доступа",
    "You don't have access": "Нет доступа",
    "common.error_404_message": "К сожалению, запрашиваемая страница сейчас недоступна. Проверьте URL и повторите попытку или вернитесь позже. Если проблема сохраняется, обратитесь в службу поддержки.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "К сожалению, запрашиваемая страница сейчас недоступна. Проверьте URL и повторите попытку или вернитесь позже. Если проблема сохраняется, обратитесь в службу поддержки.",
    "accounts.smart_upload_beta_label": "(Бета)",
    "orders.transaction_direction": "Направление транзакции",
    "Transaction direction": "Направление транзакции",
    "category.default_text": "Текст по умолчанию",
    "collections.generator_open": "Открыть генератор коллекций",
    "Open collection generator": "Открыть генератор коллекций",
    "collections.duplicate_success": "Коллекция успешно дублирована",
    "Collection duplicated successfully": "Коллекция успешно дублирована",
    "collections.duplicate_failed": "Не удалось дублировать коллекцию",
    "Failed to duplicate collection": "Не удалось дублировать коллекцию",
    "listings.name_required": "Необходимо указать название объявления",
    "Listing Name is required": "Необходимо указать название объявления",
    "listings.category_required": "Необходимо указать категорию",
    "Category is required": "Необходимо указать категорию",
    "attribute_groups.edit_title": "Изменить группу атрибутов",
    "Edit Attribute Group": "Изменить группу атрибутов",
    "orders.create_order.validation.select_shipping_method": "Выберите способ доставки",
    "Please select shipping method": "Выберите способ доставки",
    "orders.create_order.validation.shipping_method_error": "Ошибка способа доставки",
    "Shipping Method Error": "Ошибка способа доставки",
    "orders.create_order.validation.select_shipping_address": "Выберите адрес доставки",
    "Please select shipping address": "Выберите адрес доставки",
    "orders.create_order.validation.shipping_address_error": "Ошибка адреса доставки",
    "Shipping Address Error": "Ошибка адреса доставки",
    "orders.create_order.validation.select_shipment_method": "Выберите способ отправки",
    "Please select shipment method": "Выберите способ отправки",
    "orders.create_order.validation.shipment_method_error": "Ошибка способа отправки",
    "Shipment Method Error": "Ошибка способа отправки",
    "orders.create_order.validation.select_payment_method": "Выберите способ оплаты",
    "Please select payment method": "Выберите способ оплаты",
    "orders.create_order.validation.payment_method_error": "Ошибка способа оплаты",
    "Payment Method Error": "Ошибка способа оплаты",
    "orders.create_order.validation.insufficient_balance": "Недостаточно средств",
    "Insufficient balance": "Недостаточно средств",
    "orders.create_order.validation.wallet_error": "Ошибка кошелька",
    "Wallet Error": "Ошибка кошелька",
    "attributes.value.preview_item": "Предпросмотр {count}",
    "Preview {count}": "Предпросмотр {count}",
    "attributes.value.click_to_upload": "Нажмите, чтобы загрузить: {type}",
    "Click to upload {type}": "Нажмите, чтобы загрузить: {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF, до 5 файлов",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF, до 5 файлов",
    "attributes.value.audio_upload_formats": "MP3, WAV, до 1 файла",
    "MP3, WAV up to 1 file": "MP3, WAV, до 1 файла",
    "attributes.value.video_upload_formats": "MP4, MOV, до 1 файла",
    "MP4, MOV up to 1 file": "MP4, MOV, до 1 файла",
    "attributes.value.upload_limit": "Загрузить файлы {type} (макс. {count})",
    "Upload {type} files (Max {count})": "Загрузить файлы {type} (макс. {count})",
    "attributes.value.json_format_failed": "Недопустимый JSON — форматирование невозможно",
    "Invalid JSON - cannot format": "Недопустимый JSON — форматирование невозможно",
    "attributes.value.json_file_invalid": "Выберите корректный JSON-файл",
    "Please select a valid JSON file": "Выберите корректный JSON-файл",
    "attributes.value.file_empty": "Файл пуст",
    "File is empty": "Файл пуст",
    "attributes.value.json_file_parse_failed": "Недопустимый JSON-файл: {message}",
    "Invalid JSON file: {message}": "Недопустимый JSON-файл: {message}",
    "attributes.value.file_read_failed": "Не удалось прочитать файл",
    "Failed to read file": "Не удалось прочитать файл",
    "attributes.value.invalid_json": "Недопустимый JSON",
    "Invalid JSON": "Недопустимый JSON",
    "attributes.value.json_editor_help": "Загрузите JSON-файл или введите/вставьте JSON напрямую",
    "Upload a JSON file or type/paste JSON directly": "Загрузите JSON-файл или введите/вставьте JSON напрямую",
    "attributes.value.hex_color_code": "Шестнадцатеричный код цвета",
    "Hex Color Code": "Шестнадцатеричный код цвета",
    "attributes.value.multi_text_placeholder": "Введите текст и нажмите Enter или запятую, чтобы добавить",
    "Type and press Enter or comma to add": "Введите текст и нажмите Enter или запятую, чтобы добавить",
    "attributes.value.multi_text_help": "Нажмите Enter или запятую, чтобы добавить каждый элемент",
    "Press Enter or comma to add each item": "Нажмите Enter или запятую, чтобы добавить каждый элемент",
    "attributes.value.item_count": "Элемент: {count}",
    "{count} item": "Элемент: {count}",
    "attributes.value.items_count": "Элементов: {count}",
    "attributes.value.search_options": "Поиск: {name}...",
    "Search {name}...": "Поиск: {name}...",
    "attributes.value.selected_count": "Выбрано: {count}",
    "attributes.value.no_options_found": "Варианты не найдены",
    "No options found": "Варианты не найдены",
    "attributes.value.select_named_option": "Выберите {name}",
    "Select {name}": "Выберите {name}",
    "attributes.value.enable_option": "Включить этот параметр",
    "Enable this option": "Включить этот параметр",
    "attributes.value.enter_named_value": "Введите {name}",
    "Enter {name}": "Введите {name}",
    "common.valid": "Действительно",
    "Valid": "Действительно",
    "common.invalid": "Недействительно",
    "Invalid": "Недействительно",
    "common.go_back_home": "Вернуться на главную",
    "Go back home": "Вернуться на главную",
    "attributes.value.enter_named_text": "Введите {name}...",
    "Enter {name}...": "Введите {name}...",
    "listings.analytics.page_views": "Просмотры страниц",
    "listings.analytics.unique_visitors": "Уникальные посетители",
    "listings.analytics.sessions": "Сеансы",
    "listings.analytics.clicks": "Переходы",
    "listings.analytics.goals": "Цели",
    "listings.analytics.bot_views": "Просмотры ботов",
    "listings.detail_summary.buyers": "Покупатели",
    "Buyers": "Покупатели",
    "listings.detail_summary.orders": "Заказы",
    "listings.detail_summary.revenue": "Выручка",
    "listings.detail_summary.average_order": "Средний заказ",
    "listings.add_advanced": "Дополнительно",
    "listings.add_audio": "Добавить аудио",
    "Add Audio": "Добавить аудио",
    "payments.updated_successfully": "Успешно обновлено",
    "Updated successfully": "Успешно обновлено",
    "users.deleted_successfully": "Пользователь удален",
    "User deleted successfully": "Пользователь удален",
    "users.deletion_failed": "Не удалось удалить пользователя",
    "User deletion failed": "Не удалось удалить пользователя",
    "accounts.flow.title": "Создайте удобный интерфейс учетной записи",
    "Shape the account experience": "Создайте удобный интерфейс учетной записи",
    "accounts.flow.description": "Организуйте типы учетных записей и укажите нужные для каждой сведения.",
    "Organize account types and define the information each account needs.": "Организуйте типы учетных записей и укажите нужные для каждой сведения.",
    "accounts.flow.lane_title": "Основа учетной записи",
    "Account foundation": "Основа учетной записи",
    "accounts.flow.badge": "Структура",
    "Structure": "Структура",
    "accounts.flow.node_accounts": "Учетные записи",
    "accounts.flow.node_categories": "Категории",
    "accounts.flow.node_attributes": "Атрибуты",
    "accounts.flow.lane_description": "Задайте каждой учетной записи место, тип и полезные сведения.",
    "Give every account a clear place, type, and set of useful details.": "Задайте каждой учетной записи место, тип и полезные сведения.",
    "accounts.flow.primary_action": "Добавить первую учетную запись",
    "Add your first account": "Добавить первую учетную запись",
    "listings.flow.title": "Создайте каталог объявлений",
    "Build your listing catalog": "Создайте каталог объявлений",
    "listings.flow.description": "Создайте структурированный каталог с категориями, атрибутами и вариантами.",
    "Create a structured catalog with categories, attributes, and variants.": "Создайте структурированный каталог с категориями, атрибутами и вариантами.",
    "listings.flow.lane_title": "Путь каталога",
    "Catalog path": "Путь каталога",
    "listings.flow.badge": "Создание",
    "Build": "Создание",
    "listings.flow.node_listings": "Объявления",
    "listings.flow.node_categories": "Категории",
    "listings.flow.node_attributes": "Атрибуты",
    "listings.flow.node_variants": "Варианты",
    "listings.flow.lane_description": "Определите, что вы продаете, и какую информацию нужно знать покупателям для выбора.",
    "Define what you sell and the information customers need to make a choice.": "Определите, что вы продаете, и какую информацию нужно знать покупателям для выбора.",
    "listings.flow.primary_action": "Добавить первое объявление",
    "Add your first listing": "Добавить первое объявление",
    "collections.flow.title": "Объедините содержимое маркетплейса",
    "Bring your marketplace content together": "Объедините содержимое маркетплейса",
    "collections.flow.description": "Группируйте объявления и учетные записи в подборки, которыми легко управлять и которые легко находить.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Группируйте объявления и учетные записи в подборки, которыми легко управлять и которые легко находить.",
    "collections.flow.lane_title": "Путь коллекции",
    "Collection path": "Путь коллекции",
    "collections.flow.badge": "Подборка",
    "Curate": "Подборка",
    "collections.flow.node_collections": "Коллекции",
    "collections.flow.node_rules": "Правила",
    "collections.flow.node_listings": "Объявления",
    "collections.flow.lane_description": "Выберите, что объединить, чтобы покупателям было проще найти нужное.",
    "Choose what belongs together and make it easy for customers to find.": "Выберите, что объединить, чтобы покупателям было проще найти нужное.",
    "collections.flow.audience_lane_title": "Путь аудитории",
    "Audience path": "Путь аудитории",
    "collections.flow.audience_badge": "Связь",
    "collections.flow.node_accounts": "Учетные записи",
    "collections.flow.node_users": "Пользователи",
    "collections.flow.node_storefront": "Витрина",
    "Storefront": "Витрина",
    "collections.flow.audience_description": "Свяжите подборки с людьми и витринами, для которых они предназначены.",
    "Connect curated content to the people and storefronts it is meant for.": "Свяжите подборки с людьми и витринами, для которых они предназначены.",
    "collections.flow.primary_action": "Создать первую коллекцию",
    "listings.addon.image_limit": "Нельзя выбрать больше изображений",
    "listings.schedule.start_time_before_end": "Время начала должно предшествовать времени окончания",
    "Start time must be before the end time": "Время начала должно предшествовать времени окончания",
    "listings.schedule.end_time_after_start": "Время окончания должно быть позже времени начала",
    "End time must be after the start time": "Время окончания должно быть позже времени начала",
    "listings.schedule.repeat_required": "Выберите шаблон повторения",
    "Select a repeat pattern": "Выберите шаблон повторения",
    "listing_variants.form.select_type": "Выберите тип варианта",
    "Select variant type": "Выберите тип варианта",
    "listing_variants.form.select_type_values": "Выберите значения варианта",
    "Select variant values": "Выберите значения варианта",
    "listing_variants.form.add_variant": "Добавить вариант",
    "listing_variants.form.edit_variant": "Изменить вариант",
    "Edit variant": "Изменить вариант",
    "listing_variants.form.variant_type": "Тип варианта",
    "Variant type": "Тип варианта",
    "listing_variants.form.variant_type_value": "Значение варианта",
    "Variant value": "Значение варианта",
    "listing_variants.form.variant_name": "Название варианта",
    "Variant name": "Название варианта",
    "listing_variants.form.description_placeholder": "Введите описание",
    "rewards.item_archived": "Архивировано",
    "listings.confirm_delete_variant": "Вы уверены, что хотите удалить этот вариант?",
    "listings.confirm_delete_listing": "Вы уверены, что хотите удалить это объявление?",
    "listing_form.digital_delete_confirm": "Вы уверены, что хотите удалить этот цифровой материал?",
    "Are you sure you want to delete this digital content?": "Вы уверены, что хотите удалить этот цифровой материал?",
    "category.confirm_delete_attribute": "Удалить этот атрибут?",
    "common.permission_required": "У вас нет разрешения на выполнение этого действия.",
    "You do not have permission to perform this action.": "У вас нет разрешения на выполнение этого действия.",
    "common.copied": "Скопировано",
    "attributes.editor_name_required": "Введите название атрибута",
    "onboarding.full_step.setup_payments.description": "Включите реальные платежи, чтобы пользователи могли легко совершать покупки.",
    "Enable real transactions so users can complete intent without friction.": "Включите реальные платежи, чтобы пользователи могли легко совершать покупки.",
    "onboarding.full_step.setup_payments.cta": "Настроить платежи",
    "Setup payments": "Настроить платежи",
    "onboarding.full_step.setup_payments.impact": "Доступен путь к выручке.",
    "Revenue path enabled.": "Доступен путь к выручке.",
    "onboarding.full_step.setup_payments.creator_description": "Подготовьте аудиторию к покупке или поддержке вашей работы.",
    "Prepare the path for your audience to purchase or support your work.": "Подготовьте аудиторию к покупке или поддержке вашей работы.",
    "onboarding.full_step.setup_delivery.description": "Определите способ выполнения заказа, чтобы оформление было понятным для пользователей.",
    "onboarding.full_step.setup_delivery.impact": "Способ выполнения заказа определен.",
    "Fulfillment path clear.": "Способ выполнения заказа определен.",
    "onboarding.full_step.add_promotion.description": "Создайте первую акцию, чтобы повысить конверсию при первом посещении.",
    "Create your first promotion to increase first-session action rate.": "Создайте первую акцию, чтобы повысить конверсию при первом посещении.",
    "onboarding.full_step.add_promotion.impact": "Более высокая конверсия при запуске.",
    "Stronger conversion during launch.": "Более высокая конверсия при запуске.",
    "onboarding.full_step.create_coupon.description": "Проверьте скидки и улучшите активацию новых покупателей или участников.",
    "Test discounts and improve activation for first-time buyers or members.": "Проверьте скидки и улучшите активацию новых покупателей или участников.",
    "onboarding.full_step.create_coupon.impact": "Цикл первого предложения запущен.",
    "First-offer loop unlocked.": "Цикл первого предложения запущен.",
    "onboarding.full_step.collections_setup.description": "Сгруппируйте востребованные объявления, чтобы упростить поиск и просмотр.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Сгруппируйте востребованные объявления, чтобы упростить поиск и просмотр.",
    "onboarding.full_step.collections_setup.impact": "Навигация и поиск улучшены.",
    "Navigation and discovery improved.": "Навигация и поиск улучшены.",
    "onboarding.full_step.configure_comms.description": "Подготовьте уведомления после регистрации и заказа к росту проекта.",
    "Make post-signup and order notifications production-ready before growth.": "Подготовьте уведомления после регистрации и заказа к росту проекта.",
    "onboarding.full_step.configure_comms.impact": "Сообщения для жизненного цикла готовы.",
    "Lifecycle messaging ready.": "Сообщения для жизненного цикла готовы.",
    "onboarding.full_step.customize_attributes.description": "Добавьте структурированные поля, чтобы пользователи могли фильтровать и сравнивать важные параметры.",
    "onboarding.full_step.customize_attributes.impact": "Поиск и конверсия улучшены.",
    "Better search and conversion.": "Поиск и конверсия улучшены.",
    "onboarding.full_step.customize_attributes.creator_description": "Добавьте сведения, которые помогут людям понять и сравнить ваши работы.",
    "Add the details that help people understand and compare what you create.": "Добавьте сведения, которые помогут людям понять и сравнить ваши работы.",
    "onboarding.full_step.add_digital_asset.description": "Расширьте начальный каталог, чтобы пользователи могли оценить качество и ассортимент.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Расширьте начальный каталог, чтобы пользователи могли оценить качество и ассортимент.",
    "onboarding.full_step.add_digital_asset.impact": "Доверие к цифровому каталогу укреплено.",
    "Digital catalog credibility improved.": "Доверие к цифровому каталогу укреплено.",
    "onboarding.full_step.open_live_site.description": "Начните с того, что видят клиенты. Так продукт станет реальным до перехода к настройкам.",
    "onboarding.full_step.open_live_site.impact": "Подтверждено, что проект уже опубликован.",
    "onboarding.full_step.add_first_product.description": "Опубликуйте первый товар, услугу или ресурс, который хотите показать аудитории.",
    "Publish the first product, service, or resource you want your audience to discover.": "Опубликуйте первый товар, услугу или ресурс, который хотите показать аудитории.",
    "onboarding.full_step.add_first_product.impact": "Создано первое предложение для аудитории.",
    "Creates your first audience-ready offer.": "Создано первое предложение для аудитории.",
    "onboarding.full_step.customize_attributes.creator_impact": "Предложение стало понятнее.",
    "Makes your offer easier to understand.": "Предложение стало понятнее.",
    "onboarding.full_step.setup_payments.creator_impact": "Открыт путь к получению дохода.",
    "listings.detail_preview_fx.title": "Предпросмотр валют",
    "Preview FX": "Предпросмотр валют",
    "listings.detail_preview_fx.base": "Базовая валюта",
    "Base": "Базовая валюта",
    "listings.detail_preview_fx.description": "Посмотрите это объявление в каждой активной валюте.",
    "See this listing in each active currency.": "Посмотрите это объявление в каждой активной валюте.",
    "listings.detail_preview_fx.refresh": "Обновить предпросмотр",
    "Refresh preview": "Обновить предпросмотр",
    "listings.detail_preview_fx.loading_rates": "Загрузка курсов валют…",
    "Loading exchange rates…": "Загрузка курсов валют…",
    "listings.detail_preview_fx.load_hint": "Выберите предпросмотр валют, чтобы загрузить текущие курсы.",
    "Select Preview FX to load current rates.": "Выберите предпросмотр валют, чтобы загрузить текущие курсы.",
    "listings.detail_preview_fx.preview_note": "Только предпросмотр. Сохраненные цены объявления не изменятся.",
    "Preview only. Saved listing prices remain unchanged.": "Только предпросмотр. Сохраненные цены объявления не изменятся.",
    "listings.detail_preview_fx.listing": "Объявление",
    "listings.detail_preview_fx.variant": "Вариант",
    "Variant": "Вариант",
    "listings.detail_event_booking.event_details": "Сведения о событии",
    "Event Details": "Сведения о событии",
    "listings.detail_event_booking.booking_details": "Сведения о бронировании",
    "Booking Details": "Сведения о бронировании",
    "listings.unassigned_location": "Местоположение не назначено",
    "Unassigned location": "Местоположение не назначено",
    "listings.no_ratings_yet": "Оценок пока нет",
    "No ratings yet": "Оценок пока нет",
    "listing_form.loading_listing": "Загрузка объявления…",
    "Loading listing…": "Загрузка объявления…",
    "listing_form.preparing_form": "Подготовка формы…",
    "Preparing form…": "Подготовка формы…",
    "listing_form.edit_listing": "Изменить объявление",
    "Edit Listing": "Изменить объявление",
    "listing_form.add_new_listing": "Добавить объявление",
    "Add New Listing": "Добавить объявление",
    "workspace.catalog.templates": "Шаблоны",
    "Templates": "Шаблоны",
    "workspace.catalog.integrations": "Интеграции",
    "workspace.catalog.template": "Шаблон",
    "Template": "Шаблон",
    "workspace.catalog.integration": "Интеграция",
    "workspace.catalog.templates_heading": "Выберите шаблон, чтобы быстро запустить идею",
    "Choose a template to kickstart your Idea": "Выберите шаблон, чтобы быстро запустить идею",
    "workspace.catalog.integrations_heading": "Интеграции для размещенных веб-приложений",
    "Integrations for Hosted Web Apps": "Интеграции для размещенных веб-приложений",
    "workspace.catalog.templates_description": "Начните с готового шаблона для своего маркетплейса.",
    "Start with a prebuilt template and customise it for your marketplace.": "Начните с готового шаблона для своего маркетплейса.",
    "workspace.catalog.integrations_description": "Подключите рабочее пространство к используемым вами инструментам и сервисам.",
    "Connect your workspace to the tools and services you already use.": "Подключите рабочее пространство к используемым вами инструментам и сервисам.",
    "workspace.catalog.no_templates": "Сейчас нет доступных шаблонов.",
    "No templates available at the moment.": "Сейчас нет доступных шаблонов.",
    "workspace.catalog.no_integrations": "Сейчас нет доступных интеграций.",
    "No integrations available at the moment.": "Сейчас нет доступных интеграций.",
    "workspace.catalog.coming_soon": "Скоро",
    "Coming Soon": "Скоро",
    "workspace.catalog.configure": "Настроить",
    "workspace.catalog.custom_development": "Разработка {type} на заказ",
    "Custom {type} Development": "Разработка {type} на заказ",
    "workspace.catalog.custom_help": "Нужно индивидуальное решение? Свяжитесь с нами, чтобы узнать стоимость.",
    "Looking for something custom? Contact us for a quote.": "Нужно индивидуальное решение? Свяжитесь с нами, чтобы узнать стоимость.",
    "workspace.catalog.contact_quote": "Запросить предложение",
    "Contact for a Quote": "Запросить предложение",
    "users.select_user": "Выберите пользователя",
    "Select User": "Выберите пользователя",
    "developer.api_keys.paid_feature_title": "Доступ к API доступен на платном тарифе",
    "API access is a paid feature": "Доступ к API доступен на платном тарифе",
    "developer.api_keys.paid_feature_description": "Выберите платный тариф, чтобы просматривать, копировать и использовать открытый и секретный ключи.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Выберите платный тариф, чтобы просматривать, копировать и использовать открытый и секретный ключи.",
    "developer.api_keys.available_on_paid_plans": "Доступно на платных тарифах",
    "Available on paid plans": "Доступно на платных тарифах",
    "developer.api_keys.view_plans": "Посмотреть тарифы",
    "currency.rates.title": "Текущие валютные курсы",
    "Current FX rates": "Текущие валютные курсы",
    "currency.rates.base": "Базовая валюта:",
    "Base:": "Базовая валюта:",
    "currency.rates.source": "· Источник:",
    "· Source:": "· Источник:",
    "currency.rates.cached_up_to": "Кэшировано до {hours} ч",
    "Cached up to {hours}h": "Кэшировано до {hours} ч",
    "currency.rates.refresh": "Обновить курсы",
    "Refresh rates": "Обновить курсы",
    "currency.rates.currency": "Валюта",
    "currency.rates.one_base_equals": "1 {code} равна",
    "1 {code} equals": "1 {code} равна",
    "currency.rates.empty": "Добавьте активную валюту, чтобы увидеть ее курс.",
    "Add an active currency to see its exchange rate.": "Добавьте активную валюту, чтобы увидеть ее курс.",
    "currency.rates.manual": "Ручные курсы",
    "Manual rates": "Ручные курсы",
    "currency.rates.load_error": "Не удалось загрузить валютные курсы.",
    "Unable to load exchange rates.": "Не удалось загрузить валютные курсы.",
    "chats.title": "Чат с клиентами",
    "Customer chat": "Чат с клиентами",
    "chats.conversations": "Диалоги",
    "Conversations": "Диалоги",
    "chats.empty_conversations": "Диалогов с клиентами пока нет.",
    "No customer conversations yet.": "Диалогов с клиентами пока нет.",
    "chats.customer_id": "Клиент {id}",
    "Customer {id}": "Клиент {id}",
    "chats.no_messages_yet": "Сообщений пока нет",
    "No messages yet": "Сообщений пока нет",
    "chats.conversation_id": "Диалог №{id}",
    "Conversation #{id}": "Диалог №{id}",
    "chats.status.closed": "закрыт",
    "closed": "закрыт",
    "chats.status.open": "открыт",
    "chats.reopen": "Открыть снова",
    "Reopen": "Открыть снова",
    "chats.close_conversation": "Закрыть диалог",
    "Close conversation": "Закрыть диалог",
    "chats.your_team": "Ваша команда",
    "Your team": "Ваша команда",
    "chats.empty_messages": "В этом диалоге пока нет сообщений.",
    "No messages in this conversation yet.": "В этом диалоге пока нет сообщений.",
    "chats.write_reply": "Напишите ответ",
    "Write a reply": "Напишите ответ",
    "chats.send": "Отправить",
    "Send": "Отправить",
    "chats.select_conversation": "Выберите диалог, чтобы просмотреть сообщения.",
    "Select a conversation to view its messages.": "Выберите диалог, чтобы просмотреть сообщения.",
    "chats.error.session_not_ready": "Сеанс не готов. Обновите страницу и повторите попытку.",
    "Your session is not ready. Refresh the page and try again.": "Сеанс не готов. Обновите страницу и повторите попытку.",
    "chats.error.request_failed": "Не удалось выполнить запрос чата ({status})",
    "Chat request failed ({status})": "Не удалось выполнить запрос чата ({status})",
    "chats.error.load_conversations": "Не удалось загрузить диалоги.",
    "Could not load conversations.": "Не удалось загрузить диалоги.",
    "chats.error.load_messages": "Не удалось загрузить сообщения.",
    "Could not load messages.": "Не удалось загрузить сообщения.",
    "chats.error.send_message": "Не удалось отправить сообщение.",
    "Message could not be sent.": "Не удалось отправить сообщение.",
    "chats.error.update_status": "Не удалось изменить статус диалога.",
    "Conversation status could not be updated.": "Не удалось изменить статус диалога.",
    "accounts.select_account": "Выберите учетную запись",
    "common.accounts": "Учетные записи",
    "common.listings": "Объявления",
    "communications.loading_preview": "Загрузка предпросмотра…",
    "Loading preview…": "Загрузка предпросмотра…",
    "communications.no_preview": "Нет предпросмотра",
    "No preview": "Нет предпросмотра",
    "collections.choose_type": "Выберите: {type}",
    "Choose {type}": "Выберите: {type}",
    "collections.create_type_category_first": "Сначала создайте категорию {type}",
    "Create {type} category first": "Сначала создайте категорию {type}",
    "web_config.customisation": "Настройка веб-сайта",
    "web_config.configuration": "Конфигурация веб-сайта",
    "Web Configuration": "Конфигурация веб-сайта",
    "web_config.section_general": "Основные",
    "web_config.section_social": "Соцсети",
    "web_config.section_footer": "Нижний колонтитул",
    "web_config.assets": "Ресурсы",
    "Assets": "Ресурсы",
    "web_config.small_logo": "Маленький логотип",
    "Small logo": "Маленький логотип",
    "attributes.edit_attribute": "Изменить атрибут",
    "currency.rate_managed_automatically": "Курс управляется автоматически.",
    "Rate is managed automatically.": "Курс управляется автоматически.",
    "navigation.add_or_manage_mini_apps": "Добавить или управлять мини-приложениями",
    "Add or manage Mini Apps": "Добавить или управлять мини-приложениями",
    "listings.import.download_type_template": "Скачать шаблон {type}",
    "navigation.promo_banner": "Скидка {percent}% только для новых клиентов! Используйте код: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Скидка {percent}% только для новых клиентов! Используйте код: {code}.",
    "orders.cash_refund_recorded": "Возврат наличных записан. Создана задача на обратную проводку.",
    "Cash refund recorded. The accounting reversal has been queued.": "Возврат наличных записан. Создана задача на обратную проводку.",
    "orders.cash_refund_failed": "Не удалось записать возврат наличных. Проверьте статус оплаты заказа и историю возвратов.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Не удалось записать возврат наличных. Проверьте статус оплаты заказа и историю возвратов.",
    "orders.recording_cash_refund": "Запись возврата…",
    "Recording refund…": "Запись возврата…",
    "orders.record_cash_refund": "Записать возврат наличных",
    "Record cash refund": "Записать возврат наличных",
    "orders.confirm_cash_refund": "Подтвердить возврат наличных",
    "Confirm cash refund": "Подтвердить возврат наличных",
    "orders.cash_refund_order_amount": "Записать полный возврат наличными на сумму {amount} по заказу {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "Записать полный возврат наличными на сумму {amount} по заказу {reference}?",
    "orders.cash_refund_manual_notice": "Будет записан ручной возврат наличных/COD и создана задача на обратную проводку. Платежный провайдер не используется.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Будет записан ручной возврат наличных/COD и создана задача на обратную проводку. Платежный провайдер не используется.",
    "currency_conversion.title": "Конвертация валют",
    "Currency conversion": "Конвертация валют",
    "currency_conversion.open_settings": "Настройки конвертации",
    "Conversion settings": "Настройки конвертации",
    "currency_conversion.load_failed": "Не удалось загрузить настройки конвертации валют.",
    "Could not load currency conversion settings.": "Не удалось загрузить настройки конвертации валют.",
    "currency_conversion.interval_error": "Интервал обновления должен составлять от 5 минут до 24 часов.",
    "Refresh interval must be between 5 minutes and 24 hours.": "Интервал обновления должен составлять от 5 минут до 24 часов.",
    "currency_conversion.save_failed": "Не удалось сохранить настройки конвертации валют.",
    "Could not save currency conversion settings.": "Не удалось сохранить настройки конвертации валют.",
    "currency_conversion.saved": "Настройки конвертации валют сохранены.",
    "Currency conversion settings saved.": "Настройки конвертации валют сохранены.",
    "currency_conversion.description": "Выберите способ расчета отображаемой конвертации валют.",
    "Choose how displayed currency conversions are calculated.": "Выберите способ расчета отображаемой конвертации валют.",
    "currency_conversion.manual_title": "Ручные курсы",
    "currency_conversion.manual_help": "Использовать введенный ниже курс для каждой валюты.",
    "Use the exchange rate entered for each currency below.": "Использовать введенный ниже курс для каждой валюты.",
    "currency_conversion.frankfurter_title": "Frankfurter (по умолчанию)",
    "Frankfurter (default)": "Frankfurter (по умолчанию)",
    "currency_conversion.frankfurter_help": "Бесплатные ежедневные курсы валют. Ключ API поставщика не требуется.",
    "Free daily exchange rates. No provider API key is required.": "Бесплатные ежедневные курсы валют. Ключ API поставщика не требуется.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Используйте сервис Fixer, управляемый платформой. Частота обновления курсов зависит от тарифного плана поставщика.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Используйте сервис Fixer, управляемый платформой. Частота обновления курсов зависит от тарифного плана поставщика.",
    "currency_conversion.refresh_interval": "Интервал проверки курса (минуты)",
    "Rate re-check interval (minutes)": "Интервал проверки курса (минуты)",
    "workspace.currency_search_code": "Найти или выбрать",
    "Search or select": "Найти или выбрать",
    "workspace.currency_preset_hint": "Применены рекомендуемые значения по умолчанию. Вы можете изменить любое поле.",
    "Recommended defaults applied. You can edit any field.": "Применены рекомендуемые значения по умолчанию. Вы можете изменить любое поле.",
    "developer.api_keys.copy_unavailable": "Ключ пока недоступен.",
    "Key is not available yet.": "Ключ пока недоступен.",
    "developer.api_keys.copy_failed": "Не удалось скопировать ключ. Повторите попытку.",
    "Unable to copy the key. Try again.": "Не удалось скопировать ключ. Повторите попытку.",
    "payroll.action.export_pdf": "Экспорт PDF",
    "Export PDF": "Экспорт PDF",
    "cms.category.name_prompt": "Название категории",
    "cms.field.cover_image": "Обложка",
    "Cover Image": "Обложка",
    "cms.action.add_cover_photo": "Добавить фото обложки",
    "Add cover photo": "Добавить фото обложки",
    "cms.field.category": "Категория",
    "cms.category.none": "Без категории",
    "No category": "Без категории",
    "cms.advanced": "Дополнительно",
    "media_picker.action.select_image": "Выбрать изображение",
    "Select image": "Выбрать изображение",
    "orders.confirm_record_cash_refund": "Записать возврат",
    "Record refund": "Записать возврат",
    "listing_form.no_repeat": "Без повторения",
    "No repeat": "Без повторения",
    "listing_form.custom_repeat_days": "Свой вариант: {days}",
    "Custom: {days}": "Свой вариант: {days}",
    "common.sending": "Отправка…",
    "listings.detail.unique_name": "Уникальное название",
    "Unique Name": "Уникальное название",
    "app_customization.username": "Имя пользователя",
    "workspace.templates.name_required": "Необходимо указать название шаблона.",
    "Template name is required.": "Необходимо указать название шаблона.",
    "workspace.templates.saved": "Шаблон ролей сохранен.",
    "Role template saved.": "Шаблон ролей сохранен.",
    "workspace.templates.confirm_delete": "Удалить шаблон «{name}»?",
    "Delete template \"{name}\"?": "Удалить шаблон «{name}»?",
    "workspace.templates.deleted": "Шаблон удален.",
    "Template deleted.": "Шаблон удален.",
    "workspace.members.tab_members": "Участники",
    "workspace.templates.tab": "Шаблоны ролей",
    "Role Templates": "Шаблоны ролей",
    "workspace.templates.title": "Шаблоны ролей",
    "workspace.templates.new": "Новый шаблон",
    "New Template": "Новый шаблон",
    "workspace.templates.name": "Название",
    "workspace.templates.empty": "Шаблонов ролей пока нет.",
    "No role templates yet.": "Шаблонов ролей пока нет.",
    "workspace.templates.edit": "Изменить шаблон",
    "Edit Template": "Изменить шаблон",
    "workspace.templates.name_label": "Название шаблона",
    "Template name": "Название шаблона",
    "workspace.templates.name_placeholder": "например, Менеджер контента",
    "e.g. Content Manager": "например, Менеджер контента",
    "listings.import.unknown_error": "Не удалось импортировать категории. Проверьте CSV-файл и повторите попытку.",
    "The categories could not be imported. Please check the CSV and try again.": "Не удалось импортировать категории. Проверьте CSV-файл и повторите попытку.",
    "common.no_access_to_page": "Нет доступа",
    "No access": "Нет доступа",
    "common.permission_to_view_page_denied": "У вас нет разрешения на просмотр этой страницы.",
    "You do not have permission to view this page.": "У вас нет разрешения на просмотр этой страницы.",
    "common.loading_permissions": "Загрузка разрешений…",
    "Loading permissions…": "Загрузка разрешений…",
    "attributes.added_successfully": "Отлично 🎉 Атрибуты успешно добавлены",
    "Nice 🎉, Successfully added attributes": "Отлично 🎉 Атрибуты успешно добавлены",
    "attributes.add_attribute_values": "Добавить значения атрибута",
    "attributes.attribute": "Атрибут",
    "attributes.optional": "Необязательно",
    "attributes.private": "Скрытый",
    "attributes.hidden_field": "Скрытое поле",
    "attributes.show_in_filter": "Показывать в фильтре",
    "attributes.status_not_active_active": "Статус (Неактивен / Активен)",
    "attributes.add_metadata": "Добавить метаданные",
    "Add metadata": "Добавить метаданные",
    "attributes.select_date_time": "Выберите дату и время",
    "listings.addons.column_title": "Название",
    "listings.addons.column_image": "Изображение",
    "listings.addons.column_price": "Цена",
    "listings.addons.column_max_quantity": "Максимальное количество",
    "Max Quantity": "Максимальное количество",
    "listings.addons.column_offer": "Предложение",
    "listings.addons.column_stock": "Запас",
    "listings.addons.column_action": "Действие",
    "listings.addons.column_status": "Статус",
    "listings.addons.confirm_delete": "Удалить этот тип дополнения?",
    "Do you want to delete this add-on type?": "Удалить этот тип дополнения?",
    "common.share_collection": "Поделиться коллекцией",
    "Share collection": "Поделиться коллекцией",
    "communications.view_modes": "Режимы просмотра коммуникаций",
    "Communication view modes": "Режимы просмотра коммуникаций",
    "payments.accessibility.gateway_logo": "Логотип платежного шлюза",
    "Payment gateway logo": "Логотип платежного шлюза",
    "common.build_version": "Версия сборки",
    "Build version": "Версия сборки",
    "common.build_label": "сборка",
    "build": "сборка",
    "listings.under_category_title": "Объявления в категории {category}",
    "Listings under {category}": "Объявления в категории {category}",
    "attributes.signup": "Регистрация",
    "Signup": "Регистрация",
    "common.toast.please_check_action": "Проверьте это действие",
    "Please check this action": "Проверьте это действие",
    "common.information": "Информация",
    "listing_form.error.load_listing_data": "Не удалось загрузить данные объявления",
    "Failed to load listing data": "Не удалось загрузить данные объявления",
    "listing_form.error.load_digital_contents": "Не удалось загрузить цифровые материалы",
    "Failed to load digital contents": "Не удалось загрузить цифровые материалы",
    "listing_form.validation.audio_file_or_url_required": "Перед созданием эпизода добавьте аудиофайл или общедоступную ссылку на аудио.",
    "Add an audio file or public audio URL before creating the episode.": "Перед созданием эпизода добавьте аудиофайл или общедоступную ссылку на аудио.",
    "listing_form.validation.rental_rate_greater_than_zero": "Введите ставку аренды больше 0.",
    "Enter a rental rate greater than 0.": "Введите ставку аренды больше 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "Максимальная продолжительность должна быть не меньше минимальной.",
    "Maximum duration must be greater than or equal to minimum duration.": "Максимальная продолжительность должна быть не меньше минимальной.",
    "listing_form.updated_successfully": "Объявление успешно обновлено!",
    "Listing updated successfully!": "Объявление успешно обновлено!",
    "listing_form.created_successfully": "Объявление успешно создано!",
    "Listing created successfully!": "Объявление успешно создано!",
    "listing_form.error.save_failed": "Не удалось сохранить объявление. Повторите попытку.",
    "Failed to save listing. Please try again.": "Не удалось сохранить объявление. Повторите попытку.",
    "listing_form.error.delete_variant_failed": "Не удалось удалить вариант: {title}",
    "Failed to delete variant: {title}": "Не удалось удалить вариант: {title}",
    "listing_form.error.variant_action_failed": "Не удалось выполнить действие {action} для варианта: {title}",
    "Failed to {action} variant: {title}": "Не удалось выполнить действие {action} для варианта: {title}",
    "listing_form.error.digital_content_action_failed": "Не удалось выполнить действие {action} для цифрового материала: {title}",
    "Failed to {action} digital content: {title}": "Не удалось выполнить действие {action} для цифрового материала: {title}",
    "listing_form.action.create": "создать",
    "listing_form.action.update": "обновить",
    "listing_form.action.delete": "удалить",
    "delete": "удалить",
    "listing_form.error.save_request_failed": "Не удалось сохранить объявление",
    "Failed to save listing": "Не удалось сохранить объявление",
    "listing_form.error.rental_settings_save_failed": "Объявление сохранено, но настройки аренды не удалось сохранить.",
    "Listing saved, but rental settings could not be saved.": "Объявление сохранено, но настройки аренды не удалось сохранить.",
    "users.action_failed": "Не удалось выполнить действие. Повторите попытку.",
    "Action failed. Please try again.": "Не удалось выполнить действие. Повторите попытку.",
    "common.successfully_added": "Успешно добавлено",
    "Successfully added": "Успешно добавлено",
    "listing_form.validation.title_min_length": "Название должно содержать не менее {count} символов",
    "Title must be at least {count} characters": "Название должно содержать не менее {count} символов",
    "listing_form.validation.title_max_length": "Название не должно превышать {count} символов",
    "Title must not exceed {count} characters": "Название не должно превышать {count} символов",
    "listing_form.validation.price_minimum": "Цена должна быть не меньше {amount}",
    "Price must be at least {amount}": "Цена должна быть не меньше {amount}",
    "listing_form.validation.attribute_required": "Поле {attribute} обязательно",
    "listings.error.load_failed": "Не удалось загрузить объявления",
    "Unable to load listings": "Не удалось загрузить объявления",
    "communications.from_email_required_before_verification": "Перед проверкой укажите адрес отправителя.",
    "Please enter From email address before verifying.": "Перед проверкой укажите адрес отправителя.",
    "communications.verification_email_sent": "Письмо для подтверждения отправлено. Проверьте почту и следуйте инструкциям, чтобы подтвердить этот адрес.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Письмо для подтверждения отправлено. Проверьте почту и следуйте инструкциям, чтобы подтвердить этот адрес.",
    "communications.verification_start_failed": "Не удалось начать проверку. Повторите попытку.",
    "Unable to start verification. Please try again.": "Не удалось начать проверку. Повторите попытку.",
    "common.uploaded_successfully": "Успешно загружено",
    "upgrade_page.panel.yearly": "Ежегодно",
    "upgrade_page.panel.monthly": "Ежемесячно",
    "orders.advance_paid": "Аванс оплачен",
    "Advance paid": "Аванс оплачен",
    "orders.balance_due": "Остаток к оплате",
    "Balance due": "Остаток к оплате",
    "orders.advance_invalid": "Введите сумму меньше общей суммы заказа.",
    "Enter an amount less than the order total.": "Введите сумму меньше общей суммы заказа.",
    "orders.advance_failed": "Не удалось сохранить аванс.",
    "Could not save the advance.": "Не удалось сохранить аванс.",
    "orders.edit_advance": "Изменить аванс",
    "Edit advance": "Изменить аванс",
    "orders.record_advance": "Записать аванс",
    "Record advance": "Записать аванс",
    "orders.advance_notice": "Сумма, уже оплаченная клиентом, должна быть меньше общей суммы заказа {total}. Заказ останется неоплаченным, пока вы не отметите остаток как оплаченный. Введите 0, чтобы удалить аванс.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Сумма, уже оплаченная клиентом, должна быть меньше общей суммы заказа {total}. Заказ останется неоплаченным, пока вы не отметите остаток как оплаченный. Введите 0, чтобы удалить аванс.",
    "orders.save_advance": "Сохранить",
    "common.hide": "Скрыть",
    "listings.repeat.daily": "Ежедневно",
    "listings.repeat.weekdays": "Будни (пн–пт)",
    "Weekdays (Mon-Fri)": "Будни (пн–пт)",
    "listings.repeat.weekend": "Выходные (сб–вс)",
    "Weekend (Sat-Sun)": "Выходные (сб–вс)",
    "listings.repeat.custom": "Пользовательский вариант",
    "listings.weekday.sun": "Вс",
    "Sun": "Вс",
    "listings.weekday.mon": "Пн",
    "Mon": "Пн",
    "listings.weekday.tue": "Вт",
    "Tue": "Вт",
    "listings.weekday.wed": "Ср",
    "Wed": "Ср",
    "listings.weekday.thu": "Чт",
    "Thu": "Чт",
    "listings.weekday.fri": "Пт",
    "Fri": "Пт",
    "listings.weekday.sat": "Сб",
    "Sat": "Сб",
    "orders.pay_balance": "Оплатить остаток {amount}",
    "Pay balance {amount}": "Оплатить остаток {amount}",
    "orders.partially_paid": "Оплачен частично",
    "Partially paid": "Оплачен частично",
    "orders.balance_amount": "Остаток {amount}",
    "Balance {amount}": "Остаток {amount}",
    "delivery.get_started.add_branch": "Добавить филиал",
    "Add branch": "Добавить филиал",
    "delivery.get_started.add_fleet": "Добавить автопарк",
    "Add fleet": "Добавить автопарк",
    "delivery.get_started.api_documentation": "Документация API",
    "API Documentation": "Документация API",
    "delivery.get_started.add_driver": "Добавить водителя",
    "Add driver": "Добавить водителя",
    "delivery.get_started.branch_title": "Добавьте филиал",
    "Add your branch": "Добавьте филиал",
    "delivery.get_started.branch_description": "В филиале может быть несколько автопарков и водителей",
    "A branch can have many fleets and drivers": "В филиале может быть несколько автопарков и водителей",
    "delivery.get_started.fleet_title": "Добавьте автопарк",
    "Add your fleet": "Добавьте автопарк",
    "delivery.get_started.fleet_description": "Автопарк можно назначить водителю",
    "A fleet can be assigned to a driver": "Автопарк можно назначить водителю",
    "delivery.get_started.driver_title": "Добавьте водителя",
    "Add your driver": "Добавьте водителя",
    "delivery.get_started.driver_description": "Водитель доставит ваш заказ",
    "The driver will deliver your order": "Водитель доставит ваш заказ",
    "delivery.get_started.order_title": "Создайте первый заказ",
    "Create your first order": "Создайте первый заказ",
    "delivery.get_started.order_description": "Заказы можно создавать через API",
    "Orders can be created through the API": "Заказы можно создавать через API",
    "delivery.get_started.progress.branches": "Филиалы",
    "Branches": "Филиалы",
    "delivery.get_started.progress.fleets": "Автопарки",
    "Fleets": "Автопарки",
    "delivery.get_started.progress.drivers": "Водители",
    "Drivers": "Водители",
    "delivery.get_started.progress.orders": "Заказы на доставку",
    "Delivery Orders": "Заказы на доставку",
    "delivery.get_started.welcome": "Добро пожаловать в",
    "Welcome to": "Добро пожаловать в",
    "delivery.get_started.question": "Что бы вы хотели сделать?",
    "What would you like to do?": "Что бы вы хотели сделать?",
    "workspace.templates.built_in": "Встроенный",
    "Built-in": "Встроенный",
    "workspace.templates.copy_of": "Копия: {name}",
    "Copy of {name}": "Копия: {name}",
    "workspace.members.role": "Роль",
    "Role": "Роль",
    "workspace.members.role_full_access": "Полный доступ",
    "Full access": "Полный доступ",
    "workspace.templates.duplicate": "Дублировать",
    "workspace.members.role_custom": "Пользовательская роль (настройте ниже)",
    "Custom (set below)": "Пользовательская роль (настройте ниже)"
  },
  "id": {
    "0": "0",
    "6100": "6100",
    "common.language": "Bahasa",
    "Language": "Bahasa",
    "common.english": "Inggris",
    "English": "Inggris",
    "common.french": "Prancis",
    "French": "Prancis",
    "common.arabic": "Arab",
    "Arabic": "Arab",
    "navigation.get_started": "Mulai",
    "Get Started": "Mulai",
    "navigation.dashboard": "Dasbor",
    "Dashboard": "Dasbor",
    "navigation.orders": "Pesanan",
    "Orders": "Pesanan",
    "navigation.schedule": "Jadwal",
    "Schedule": "Jadwal",
    "navigation.accounts": "Akun",
    "Accounts": "Akun",
    "navigation.account_categories": "Kategori akun",
    "Account Categories": "Kategori akun",
    "navigation.account_attributes": "Atribut akun",
    "Account Attributes": "Atribut akun",
    "navigation.account_configuration": "Konfigurasi akun",
    "Account Configuration": "Konfigurasi akun",
    "navigation.agents": "Agen",
    "Agents": "Agen",
    "navigation.listings": "Listing",
    "Listings": "Listing",
    "navigation.categories": "Kategori",
    "Categories": "Kategori",
    "navigation.custom_attributes": "Atribut khusus",
    "Custom Attributes": "Atribut khusus",
    "navigation.variant_types": "Jenis varian",
    "Variant Types": "Jenis varian",
    "navigation.additional_features": "Fitur tambahan",
    "Additional Features": "Fitur tambahan",
    "navigation.reported_listings": "Listing dilaporkan",
    "navigation.report_accounts": "Laporan akun",
    "Report Accounts": "Laporan akun",
    "navigation.users": "Pengguna",
    "Users": "Pengguna",
    "navigation.user_attributes": "Atribut pengguna",
    "User Attributes": "Atribut pengguna",
    "navigation.reviews_ratings": "Ulasan dan penilaian",
    "navigation.report": "Laporan",
    "Report": "Laporan",
    "navigation.reports": "Laporan",
    "Reports": "Laporan",
    "navigation.platform_health": "Kesehatan platform",
    "Platform Health": "Kesehatan platform",
    "navigation.promotions": "Promosi",
    "Promotions": "Promosi",
    "navigation.collections": "Koleksi",
    "Collections": "Koleksi",
    "navigation.promotion_ads": "Promosi / iklan",
    "Promotion / Ads": "Promosi / iklan",
    "navigation.coupons": "Kupon",
    "Coupons": "Kupon",
    "navigation.finance": "Keuangan",
    "Finance": "Keuangan",
    "navigation.transactions": "Transaksi",
    "Transactions": "Transaksi",
    "navigation.settlement": "Penyelesaian",
    "Settlement": "Penyelesaian",
    "navigation.expenses": "Pengeluaran",
    "Expenses": "Pengeluaran",
    "navigation.recurring_payments": "Pembayaran berulang",
    "Recurring payments": "Pembayaran berulang",
    "navigation.media": "Media",
    "Media": "Media",
    "navigation.communication": "Komunikasi",
    "Communication": "Komunikasi",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Editor situs web",
    "Website Editor": "Editor situs web",
    "navigation.change_templates": "Ubah template",
    "Change Templates": "Ubah template",
    "navigation.pages": "Halaman",
    "Pages": "Halaman",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Sesuaikan teks",
    "Customise texts": "Sesuaikan teks",
    "navigation.add_integrations": "Tambahkan integrasi",
    "Add Integrations": "Tambahkan integrasi",
    "navigation.domain": "Domain",
    "Domain": "Domain",
    "navigation.customise_seo": "Sesuaikan SEO",
    "Customise SEO": "Sesuaikan SEO",
    "navigation.app": "Aplikasi",
    "App": "Aplikasi",
    "navigation.apps": "Aplikasi",
    "Apps": "Aplikasi",
    "navigation.buy_app_templates": "Beli templat aplikasi",
    "Buy App Templates": "Beli templat aplikasi",
    "navigation.customisation": "Kustomisasi",
    "Customisation": "Kustomisasi",
    "navigation.integrations": "Integrasi",
    "Integrations": "Integrasi",
    "navigation.invite_team": "Undang tim",
    "Invite Team": "Undang tim",
    "navigation.help": "Bantuan",
    "Help": "Bantuan",
    "navigation.documentation": "Dokumentasi",
    "Documentation": "Dokumentasi",
    "navigation.community": "Komunitas",
    "Community": "Komunitas",
    "navigation.api_reference": "Referensi API",
    "API Reference": "Referensi API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Saluran",
    "navigation.coding_kits": "Kit pengembangan",
    "Coding Kits": "Kit pengembangan",
    "navigation.vibe_coding": "Pemrograman berbantuan AI",
    "Vibe Coding": "Pemrograman berbantuan AI",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Pengaturan",
    "Settings": "Pengaturan",
    "navigation.more": "Lainnya",
    "More": "Lainnya",
    "navigation.marketplace": "Marketplace",
    "Marketplace": "Marketplace",
    "navigation.commerce": "Perdagangan",
    "Commerce": "Perdagangan",
    "navigation.marketing": "Pemasaran",
    "Marketing": "Pemasaran",
    "navigation.intelligence": "Kecerdasan",
    "navigation.subscription": "Langganan",
    "Subscription": "Langganan",
    "navigation.membership": "Keanggotaan",
    "Membership": "Keanggotaan",
    "navigation.rewards": "Hadiah",
    "navigation.bundles": "Paket",
    "navigation.supply_chain": "Rantai pasok",
    "navigation.people": "Orang",
    "navigation.workforce": "Tenaga kerja",
    "navigation.payroll": "Penggajian",
    "Payroll": "Penggajian",
    "navigation.inventory": "Inventaris",
    "Inventory": "Inventaris",
    "navigation.inventory_operations": "Operasional inventaris",
    "Inventory Operations": "Operasional inventaris",
    "navigation.purchase_orders": "Pesanan pembelian",
    "Purchase Orders": "Pesanan pembelian",
    "navigation.stock_locations": "Lokasi stok",
    "Stock Locations": "Lokasi stok",
    "navigation.purchase_orders_2": "Pesanan pembelian",
    "Purchase orders": "Pesanan pembelian",
    "navigation.suppliers": "Pemasok",
    "Suppliers": "Pemasok",
    "navigation.locations": "Lokasi",
    "Locations": "Lokasi",
    "navigation.maps": "Peta",
    "Maps": "Peta",
    "navigation.accounting": "Akuntansi",
    "Accounting": "Akuntansi",
    "navigation.invoices": "Faktur",
    "Invoices": "Faktur",
    "navigation.plans": "Paket",
    "Plans": "Paket",
    "navigation.countries": "Negara",
    "Countries": "Negara",
    "navigation.currency": "Mata uang",
    "Currency": "Mata uang",
    "navigation.languages": "Bahasa",
    "Languages": "Bahasa",
    "navigation.payments": "Pembayaran",
    "Payments": "Pembayaran",
    "navigation.commissions": "Komisi",
    "Commissions": "Komisi",
    "navigation.taxes": "Pajak",
    "Taxes": "Pajak",
    "navigation.special_fees": "Biaya khusus",
    "Special Fees": "Biaya khusus",
    "navigation.service_shipping": "Layanan / pengiriman",
    "Service / Shipping": "Layanan / pengiriman",
    "navigation.checkout_cart_attributes": "Atribut checkout dan keranjang",
    "navigation.dark_mode_background_color": "Warna latar mode gelap",
    "Dark Mode Background Color": "Warna latar mode gelap",
    "navigation.dark_mode_text_color": "Warna teks mode gelap",
    "Dark Mode Text Color": "Warna teks mode gelap",
    "navigation.light_mode_background_color": "Warna latar mode terang",
    "Light Mode Background Color": "Warna latar mode terang",
    "navigation.light_mode_text_color": "Warna teks mode terang",
    "Light Mode Text Color": "Warna teks mode terang",
    "navigation.workspace": "Ruang kerja",
    "Workspace": "Ruang kerja",
    "navigation.user_management": "Manajemen pengguna",
    "User Management": "Manajemen pengguna",
    "navigation.privacy": "Privasi",
    "Privacy": "Privasi",
    "common.search": "Cari...",
    "Search...": "Cari...",
    "common.search_2": "Cari",
    "Search": "Cari",
    "common.no_results_found": "Hasil tidak ditemukan",
    "No results found": "Hasil tidak ditemukan",
    "common.no_record_found": "Tidak ada data",
    "No Record Found": "Tidak ada data",
    "common.open_in_a_new_tab": "Buka di tab baru",
    "Open in a new tab": "Buka di tab baru",
    "common.open": "Buka",
    "common.in_a_new_tab": "di tab baru",
    "in a new tab": "di tab baru",
    "common.loading_page": "Memuat halaman…",
    "Loading page…": "Memuat halaman…",
    "common.close": "Tutup",
    "Close": "Tutup",
    "common.save": "Simpan",
    "Save": "Simpan",
    "common.cancel": "Batal",
    "Cancel": "Batal",
    "common.delete": "Hapus",
    "Delete": "Hapus",
    "common.edit": "Edit",
    "Edit": "Edit",
    "common.add": "Tambah",
    "Add": "Tambah",
    "common.create": "Buat",
    "Create": "Buat",
    "common.update": "Perbarui",
    "Update": "Perbarui",
    "common.back": "Kembali",
    "Back": "Kembali",
    "common.next": "Berikutnya",
    "Next": "Berikutnya",
    "common.previous": "Sebelumnya",
    "Previous": "Sebelumnya",
    "common.done": "Selesai",
    "Done": "Selesai",
    "common.yes": "Ya",
    "Yes": "Ya",
    "common.no": "Tidak",
    "No": "Tidak",
    "common.name": "Nama",
    "Name": "Nama",
    "common.status": "Status",
    "Status": "Status",
    "common.date": "Tanggal",
    "Date": "Tanggal",
    "common.actions": "Tindakan",
    "Actions": "Tindakan",
    "common.action": "Tindakan",
    "Action": "Tindakan",
    "orders.scan_order": "Pindai pesanan",
    "Scan order": "Pindai pesanan",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Pindai barcode/QR pesanan atau masukkan secara manual.",
    "Scan a barcode/QR reference or enter it manually.": "Pindai barcode/QR pesanan atau masukkan secara manual.",
    "orders.camera_scanner": "Pemindai kamera",
    "Camera scanner": "Pemindai kamera",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "Pemindaian kamera tidak didukung di sini. Masukkan referensi pesanan di bawah.",
    "Camera scanning is not supported here. Enter the order reference below.": "Pemindaian kamera tidak didukung di sini. Masukkan referensi pesanan di bawah.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "Akses kamera tidak tersedia. Masukkan referensi pesanan di bawah.",
    "Camera access is unavailable. Enter the order reference below.": "Akses kamera tidak tersedia. Masukkan referensi pesanan di bawah.",
    "orders.order_reference_number": "Nomor referensi pesanan",
    "Order reference number": "Nomor referensi pesanan",
    "orders.find_order": "Cari pesanan",
    "Find order": "Cari pesanan",
    "common.your_orders_will_be_shown_here": "Pesanan Anda akan ditampilkan di sini.",
    "Your orders will be shown here.": "Pesanan Anda akan ditampilkan di sini.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Di sini Anda dapat melacak pesanan dan pemesanan yang dibuat dengan akun lain serta mengikuti perubahan statusnya.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Di sini Anda dapat melacak pesanan dan pemesanan yang dibuat dengan akun lain serta mengikuti perubahan statusnya.",
    "common.reference": "Referensi",
    "Reference #": "Referensi",
    "common.amount": "Jumlah",
    "Amount": "Jumlah",
    "orders.order_status": "Status pesanan",
    "Order Status": "Status pesanan",
    "orders.payment_status": "Status pembayaran",
    "Payment Status": "Status pembayaran",
    "common.payment_method": "Metode pembayaran",
    "Payment Method": "Metode pembayaran",
    "common.shipping_method": "Metode pengiriman",
    "Shipping Method": "Metode pengiriman",
    "common.paid": "Dibayar",
    "common.not_paid": "Belum dibayar",
    "Not Paid": "Belum dibayar",
    "common.unpaid": "Belum dibayar",
    "UnPaid": "Belum dibayar",
    "common.failed": "Gagal",
    "Failed": "Gagal",
    "common.incomplete": "Belum selesai",
    "Incomplete": "Belum selesai",
    "common.order_placed": "Pesanan dibuat",
    "Order placed": "Pesanan dibuat",
    "common.order_in_progress": "Pesanan sedang diproses",
    "Order in progress": "Pesanan sedang diproses",
    "common.shipped": "Dikirim",
    "Shipped": "Dikirim",
    "common.delivered": "Terkirim",
    "common.cancelled_by_customer": "Dibatalkan oleh pelanggan",
    "Cancelled by customer": "Dibatalkan oleh pelanggan",
    "common.order_completed": "Pesanan selesai",
    "Order completed": "Pesanan selesai",
    "common.n_a": "T/A",
    "orders.total_orders": "Total pesanan",
    "Total Orders": "Total pesanan",
    "orders.page_revenue": "Pendapatan halaman",
    "Page Revenue": "Pendapatan halaman",
    "orders.pending_payment": "Menunggu pembayaran",
    "Pending Payment": "Menunggu pembayaran",
    "common.failed_payments": "Pembayaran gagal",
    "Failed payments": "Pembayaran gagal",
    "common.abandoned": "Ditinggalkan",
    "Abandoned": "Ditinggalkan",
    "orders.search_orders_by_reference_number": "Cari pesanan berdasarkan nomor referensi",
    "Search orders by reference number": "Cari pesanan berdasarkan nomor referensi",
    "orders.search_by_reference_number": "Cari berdasarkan nomor referensi…",
    "Search by reference number…": "Cari berdasarkan nomor referensi…",
    "orders.export_orders_as_csv": "Ekspor pesanan sebagai CSV",
    "Export orders as CSV": "Ekspor pesanan sebagai CSV",
    "orders.manual_order": "Pesanan manual",
    "Manual Order": "Pesanan manual",
    "orders.scan_order_reference": "Pindai referensi pesanan",
    "Scan order reference": "Pindai referensi pesanan",
    "orders.change_status_to": "Ubah status menjadi…",
    "Change status to…": "Ubah status menjadi…",
    "common.apply": "Terapkan",
    "Apply": "Terapkan",
    "common.clear": "Hapus",
    "Clear": "Hapus",
    "orders.pay": "Bayar",
    "Pay": "Bayar",
    "orders.clear_selection": "Hapus pilihan",
    "Clear selection": "Hapus pilihan",
    "orders.list": "Daftar",
    "orders.board": "Papan",
    "Board": "Papan",
    "orders.filter_orders": "Filter pesanan",
    "Filter orders": "Filter pesanan",
    "orders.start_date": "Tanggal mulai",
    "Start Date": "Tanggal mulai",
    "orders.end_date": "Tanggal selesai",
    "orders.select_date": "Pilih tanggal",
    "Select Date": "Pilih tanggal",
    "orders.show_rows": "Tampilkan baris",
    "Show rows": "Tampilkan baris",
    "common.order_selected": "pesanan dipilih",
    "order selected": "pesanan dipilih",
    "common.orders_selected": "pesanan dipilih",
    "orders selected": "pesanan dipilih",
    "common.order_updated": "pesanan diperbarui",
    "order updated": "pesanan diperbarui",
    "common.orders_updated": "pesanan diperbarui",
    "orders updated": "pesanan diperbarui",
    "orders.order_archived_successfully": "Pesanan berhasil diarsipkan",
    "Order archived successfully": "Pesanan berhasil diarsipkan",
    "orders.failed_to_archive_order": "Gagal mengarsipkan pesanan",
    "Failed to archive order": "Gagal mengarsipkan pesanan",
    "orders.loading_order": "Memuat pesanan…",
    "Loading order…": "Memuat pesanan…",
    "orders.order_created_successfully": "Pesanan berhasil dibuat",
    "Order created successfully": "Pesanan berhasil dibuat",
    "orders.the_order_has_been_created_and_is_ready_to_review": "Pesanan telah dibuat dan siap ditinjau.",
    "The order has been created and is ready to review.": "Pesanan telah dibuat dan siap ditinjau.",
    "orders.order_reference": "Referensi pesanan",
    "Order reference": "Referensi pesanan",
    "common.created": "Dibuat",
    "Created": "Dibuat",
    "common.total": "Total",
    "Total": "Total",
    "common.items": "Item",
    "Items": "Item",
    "orders.print_save_pdf": "Cetak / Simpan PDF",
    "Print / Save PDF": "Cetak / Simpan PDF",
    "orders.view_order_details": "Lihat detail pesanan",
    "View order details": "Lihat detail pesanan",
    "orders.create_another_order": "Buat pesanan lain",
    "Create another order": "Buat pesanan lain",
    "orders.confirmed": "Dikonfirmasi",
    "Confirmed": "Dikonfirmasi",
    "orders.in_progress": "Sedang diproses",
    "In progress": "Sedang diproses",
    "orders.customer_unreachable": "Pelanggan tidak dapat dihubungi",
    "Customer unreachable": "Pelanggan tidak dapat dihubungi",
    "orders.out_for_delivery": "Dalam pengiriman",
    "orders.returned": "Dikembalikan",
    "Returned": "Dikembalikan",
    "orders.return_confirmed": "Pengembalian dikonfirmasi",
    "Return confirmed": "Pengembalian dikonfirmasi",
    "orders.delivery_confirmed": "Pengiriman dikonfirmasi",
    "Delivery confirmed": "Pengiriman dikonfirmasi",
    "orders.return_initiated": "Pengembalian dimulai",
    "Return initiated": "Pengembalian dimulai",
    "orders.return_picked": "Barang retur dijemput",
    "Return picked": "Barang retur dijemput",
    "orders.return_disputed": "Pengembalian disengketakan",
    "Return disputed": "Pengembalian disengketakan",
    "orders.canceled_by_seller": "Dibatalkan oleh penjual",
    "Canceled by seller": "Dibatalkan oleh penjual",
    "orders.canceled_by_customer": "Dibatalkan oleh pelanggan",
    "Canceled by customer": "Dibatalkan oleh pelanggan",
    "orders.ready_for_pickup": "Siap diambil",
    "Ready for pickup": "Siap diambil",
    "orders.arrived_at_customer_location": "Tiba di lokasi pelanggan",
    "Arrived at customer location": "Tiba di lokasi pelanggan",
    "orders.undelivered_returned": "Tidak terkirim — dikembalikan",
    "Undelivered - Returned": "Tidak terkirim — dikembalikan",
    "orders.undelivered_return_confirmed": "Pengembalian pesanan yang tidak terkirim dikonfirmasi",
    "Undelivered - Return confirmed": "Pengembalian pesanan yang tidak terkirim dikonfirmasi",
    "orders.disputed": "Disengketakan",
    "Disputed": "Disengketakan",
    "orders.completed": "Selesai",
    "Completed": "Selesai",
    "orders.detail_legacy.order_number": "Nomor pesanan:",
    "Order Number:": "Nomor pesanan:",
    "orders.detail_legacy.order_date": "Tanggal pesanan:",
    "Order Date:": "Tanggal pesanan:",
    "orders.detail_legacy.buyer_details": "Detail pembeli:",
    "Buyer Details:": "Detail pembeli:",
    "orders.detail_legacy.delivery_address": "Alamat pengiriman:",
    "Delivery Address:": "Alamat pengiriman:",
    "orders.detail_legacy.pickup_address": "Alamat pengambilan:",
    "Pickup Address:": "Alamat pengambilan:",
    "orders.detail_legacy.total_amount": "Jumlah total:",
    "Total Amount:": "Jumlah total:",
    "orders.detail_legacy.amount_in_words": "Jumlah dalam huruf:",
    "Amount in Words:": "Jumlah dalam huruf:",
    "orders.detail_legacy.amount_words_only": "Hanya",
    "Only": "Hanya",
    "orders.detail_legacy.payout_date": "Tanggal pencairan:",
    "Payout Date:": "Tanggal pencairan:",
    "orders.detail_legacy.change": "Ubah",
    "orders.detail_legacy.select_date_time": "Pilih tanggal dan waktu",
    "orders.detail_legacy.change_payout_date_time": "Ubah tanggal dan waktu pencairan",
    "Change Payout Date and Time": "Ubah tanggal dan waktu pencairan",
    "orders.detail_legacy.update_payout": "Perbarui",
    "orders.detail_legacy.update_status": "Perbarui status",
    "Update Status": "Perbarui status",
    "orders.detail_legacy.change_order_status": "Ubah status pesanan",
    "Change Order Status": "Ubah status pesanan",
    "orders.detail_legacy.column_description": "Deskripsi",
    "Description": "Deskripsi",
    "orders.detail_legacy.column_unit_price": "Harga satuan",
    "Unit Price": "Harga satuan",
    "orders.detail_legacy.column_discount": "Diskon",
    "Discount": "Diskon",
    "orders.detail_legacy.column_tax_rate": "Tarif pajak",
    "Tax Rate": "Tarif pajak",
    "orders.item": "Item",
    "Item": "Item",
    "orders.order_details": "Detail pesanan",
    "Order Details": "Detail pesanan",
    "orders.copy_order_reference": "Salin referensi pesanan",
    "Copy order reference": "Salin referensi pesanan",
    "orders.order_summary": "Ringkasan pesanan",
    "Order Summary": "Ringkasan pesanan",
    "orders.order_created": "Pesanan dibuat",
    "Order created": "Pesanan dibuat",
    "orders.order_time": "Waktu pesanan",
    "Order time": "Waktu pesanan",
    "orders.total_earnings": "Total penghasilan",
    "Total earnings": "Total penghasilan",
    "orders.total_price": "Harga total",
    "Total price": "Harga total",
    "orders.delivery_fee": "Biaya pengiriman",
    "Delivery fee": "Biaya pengiriman",
    "orders.sub_total": "Subtotal",
    "Sub total": "Subtotal",
    "orders.customer_information": "Informasi pelanggan",
    "Customer Information": "Informasi pelanggan",
    "common.customer_name": "Nama pelanggan",
    "Customer Name": "Nama pelanggan",
    "common.phone": "Telepon",
    "Phone": "Telepon",
    "common.email": "Email",
    "Email": "Email",
    "orders.seller_details": "Detail penjual",
    "Seller Details": "Detail penjual",
    "common.seller_name": "Nama penjual",
    "Seller Name": "Nama penjual",
    "common.mobile": "Ponsel",
    "Mobile": "Ponsel",
    "orders.generate": "Buat",
    "Generate": "Buat",
    "orders.cancel_order": "Batalkan pesanan",
    "Cancel Order": "Batalkan pesanan",
    "orders.mark_as_paid": "Tandai telah dibayar",
    "Mark as Paid": "Tandai telah dibayar",
    "orders.failed_to_mark_as_paid": "Gagal menandai sebagai dibayar",
    "Failed to mark as paid": "Gagal menandai sebagai dibayar",
    "orders.order_cancelled_successfully": "Pesanan berhasil dibatalkan",
    "Order cancelled successfully": "Pesanan berhasil dibatalkan",
    "orders.failed_to_cancel_order_by_admin": "Admin gagal membatalkan pesanan",
    "Failed to cancel order by admin": "Admin gagal membatalkan pesanan",
    "orders.no_transactions_found": "Transaksi tidak ditemukan",
    "No transactions found": "Transaksi tidak ditemukan",
    "orders.transaction_no": "No. transaksi",
    "Transaction No": "No. transaksi",
    "orders.entity": "Entitas",
    "Entity": "Entitas",
    "orders.transaction_type": "Jenis transaksi",
    "Transaction Type": "Jenis transaksi",
    "common.seller": "Penjual",
    "Seller": "Penjual",
    "common.customer": "Pelanggan",
    "Customer": "Pelanggan",
    "common.platform_owner": "Pemilik platform",
    "Platform Owner": "Pemilik platform",
    "orders.items_summary": "Ringkasan item",
    "Items Summary": "Ringkasan item",
    "orders.qty": "Jml",
    "orders.price": "Harga",
    "Price": "Harga",
    "orders.total_price_2": "Harga total",
    "Total Price": "Harga total",
    "orders.membership_purchase": "Pembelian keanggotaan",
    "Membership purchase": "Pembelian keanggotaan",
    "orders.member_id": "ID anggota",
    "Member ID": "ID anggota",
    "orders.period": "Periode",
    "Period": "Periode",
    "orders.start_date_2": "Tanggal mulai",
    "Start date": "Tanggal mulai",
    "common.next_renewal": "Perpanjangan berikutnya",
    "Next renewal": "Perpanjangan berikutnya",
    "common.expiry_date": "Tanggal kedaluwarsa",
    "Expiry date": "Tanggal kedaluwarsa",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Pesanan ini dicatat sebagai kontribusi keanggotaan, bukan pengiriman.",
    "This order is managed as a membership contribution, not a shipment.": "Pesanan ini dicatat sebagai kontribusi keanggotaan, bukan pengiriman.",
    "orders.months": "bulan",
    "months": "bulan",
    "orders.days": "hari",
    "days": "hari",
    "orders.address": "Alamat",
    "Address": "Alamat",
    "orders.address_1": "Alamat 1",
    "Address 1": "Alamat 1",
    "orders.address_2": "Alamat 2",
    "Address 2": "Alamat 2",
    "orders.zip_code": "Kode pos",
    "Zip code": "Kode pos",
    "orders.full_address": "Alamat lengkap",
    "Full Address": "Alamat lengkap",
    "orders.formatted_address": "Alamat terformat",
    "Formatted Address": "Alamat terformat",
    "orders.phone_number": "Nomor telepon",
    "Phone Number": "Nomor telepon",
    "orders.address_not_found": "Alamat tidak ditemukan",
    "Address not found": "Alamat tidak ditemukan",
    "orders.address_not_applicable": "Alamat tidak berlaku",
    "Address not applicable": "Alamat tidak berlaku",
    "orders.address_is_not_available": "Alamat tidak tersedia",
    "Address is not available": "Alamat tidak tersedia",
    "orders.add_pickup_address": "Tambahkan alamat pengambilan",
    "Add Pickup Address": "Tambahkan alamat pengambilan",
    "orders.edit_pickup_address": "Edit alamat pengambilan",
    "Edit Pickup Address": "Edit alamat pengambilan",
    "orders.discard_and_close": "Buang perubahan dan tutup",
    "Discard and close": "Buang perubahan dan tutup",
    "orders.state": "Provinsi",
    "State": "Provinsi",
    "common.country": "Negara",
    "Country": "Negara",
    "orders.sales_payout": "Pencairan penjualan",
    "Sales Payout": "Pencairan penjualan",
    "orders.sales_no_payout": "Penjualan (tanpa pencairan)",
    "Sales (No Payout)": "Penjualan (tanpa pencairan)",
    "orders.sales_payout_reversal": "Pembalikan pencairan penjualan",
    "Sales Payout Reversal": "Pembalikan pencairan penjualan",
    "orders.sales_no_payout_reversal": "Pembalikan penjualan tanpa pencairan",
    "Sales no payout reversal": "Pembalikan penjualan tanpa pencairan",
    "orders.seller_commission": "Komisi penjual",
    "Seller Commission": "Komisi penjual",
    "orders.seller_commission_reversal": "Pembalikan komisi penjual",
    "Seller Commission Reversal": "Pembalikan komisi penjual",
    "orders.seller_transfer": "Transfer ke penjual",
    "Seller Transfer": "Transfer ke penjual",
    "orders.seller_transfer_reversal": "Pembatalan transfer ke penjual",
    "Seller Transfer Reversal": "Pembatalan transfer ke penjual",
    "orders.seller_payout": "Pencairan dana penjual",
    "Seller Payout": "Pencairan dana penjual",
    "orders.seller_subscription": "Langganan penjual",
    "Seller Subscription": "Langganan penjual",
    "orders.seller_payment_processing_fee": "Biaya pemrosesan pembayaran penjual",
    "Seller Payment processing fee": "Biaya pemrosesan pembayaran penjual",
    "orders.seller_payment_processing_fee_reversal": "Pembalikan biaya pemrosesan pembayaran penjual",
    "Seller Payment processing fee reversal": "Pembalikan biaya pemrosesan pembayaran penjual",
    "orders.sub_total_2": "Subtotal",
    "Sub Total": "Subtotal",
    "orders.customer_commission": "Komisi pelanggan",
    "Customer Commission": "Komisi pelanggan",
    "orders.tax": "Pajak",
    "Tax": "Pajak",
    "orders.shipping_charge": "Biaya pengiriman",
    "Shipping Charge": "Biaya pengiriman",
    "orders.refund": "Pengembalian dana",
    "Refund": "Pengembalian dana",
    "orders.special_fee": "Biaya khusus",
    "Special Fee": "Biaya khusus",
    "orders.coupon": "Kupon",
    "Coupon": "Kupon",
    "orders.shipment": "Pengiriman",
    "Shipment": "Pengiriman",
    "orders.fulfilled_by_platform": "Dipenuhi oleh platform",
    "Fulfilled by platform": "Dipenuhi oleh platform",
    "orders.fulfilled_by": "Dipenuhi oleh",
    "Fulfilled by": "Dipenuhi oleh",
    "orders.fulfilled_by_seller": "Dipenuhi oleh penjual",
    "Fulfilled by seller": "Dipenuhi oleh penjual",
    "orders.on_seller_protection_policy": "Dalam kebijakan perlindungan penjual",
    "On Seller Protection Policy": "Dalam kebijakan perlindungan penjual",
    "orders.product_image": "Gambar produk",
    "Product image": "Gambar produk",
    "orders.status_changed_successfully": "Status berhasil diubah",
    "Status changed successfully": "Status berhasil diubah",
    "orders.pickup_address_not_available_please_add_pickup_address": "Alamat pengambilan tidak tersedia. Tambahkan alamat pengambilan.",
    "Pickup Address not available. Please Add Pickup Address": "Alamat pengambilan tidak tersedia. Tambahkan alamat pengambilan.",
    "orders.failed_to_save_pickup_address_please_try_again": "Gagal menyimpan alamat pengambilan. Silakan coba lagi.",
    "Failed to save pickup address. Please try again.": "Gagal menyimpan alamat pengambilan. Silakan coba lagi.",
    "orders.change_shipment_status": "Ubah status pengiriman",
    "Change shipment status": "Ubah status pengiriman",
    "orders.not_available": "Tidak tersedia",
    "Not available": "Tidak tersedia",
    "orders.shipment_created": "Pengiriman dibuat",
    "Shipment created": "Pengiriman dibuat",
    "orders.shipment_in_progress": "Pengiriman sedang diproses",
    "Shipment in progress": "Pengiriman sedang diproses",
    "orders.ship": "Kirim",
    "Ship": "Kirim",
    "orders.undelivered_return": "Pengembalian barang tidak terkirim",
    "orders.shipment_deliver": "Antarkan kiriman",
    "Shipment deliver": "Antarkan kiriman",
    "orders.shipment_delivery_confirm": "Konfirmasi pengiriman telah diterima",
    "Shipment delivery confirm": "Konfirmasi pengiriman telah diterima",
    "orders.return_initiate": "Mulai pengembalian",
    "Return initiate": "Mulai pengembalian",
    "orders.return_for_pickup": "Siap untuk dijemput sebagai retur",
    "Return for pickup": "Siap untuk dijemput sebagai retur",
    "orders.shipment_return_confirm": "Konfirmasi pengembalian kiriman",
    "Shipment return confirm": "Konfirmasi pengembalian kiriman",
    "orders.cancel_by_seller": "Dibatalkan oleh penjual",
    "Cancel by seller": "Dibatalkan oleh penjual",
    "orders.cancel_by_customer": "Dibatalkan oleh pelanggan",
    "Cancel by customer": "Dibatalkan oleh pelanggan",
    "orders.arrive_at_customer_location": "Tiba di lokasi pelanggan",
    "Arrive at customer location": "Tiba di lokasi pelanggan",
    "orders.shipment_delivered": "Kiriman terkirim",
    "orders.shipment_delivery_confirmed": "Pengiriman kiriman dikonfirmasi",
    "orders.returned_for_pickup": "Dikembalikan untuk dijemput",
    "orders.shipment_return_confirmed": "Pengembalian kiriman dikonfirmasi",
    "orders.cancelled_by_seller": "Dibatalkan oleh penjual",
    "Cancelled by seller": "Dibatalkan oleh penjual",
    "common.cancelled_by_admin": "Dibatalkan oleh admin",
    "Cancelled by admin": "Dibatalkan oleh admin",
    "orders.invoice": "Faktur",
    "Invoice": "Faktur",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Pilih jenis file yang valid (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Pilih jenis file yang valid (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "Ukuran file harus kurang dari 5 MB",
    "File size must be less than 5MB": "Ukuran file harus kurang dari 5 MB",
    "orders.please_upload_a_file_first": "Unggah file terlebih dahulu",
    "Please upload a file first": "Unggah file terlebih dahulu",
    "orders.invoice_uploaded_successfully": "Faktur berhasil diunggah!",
    "Invoice uploaded successfully!": "Faktur berhasil diunggah!",
    "orders.failed_to_upload_invoice_please_try_again": "Gagal mengunggah faktur. Silakan coba lagi.",
    "Failed to upload invoice. Please try again.": "Gagal mengunggah faktur. Silakan coba lagi.",
    "orders.upload_invoice": "Unggah faktur",
    "Upload Invoice": "Unggah faktur",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Format yang didukung: PDF, JPG, PNG, DOC (maks. 5 MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Format yang didukung: PDF, JPG, PNG, DOC (maks. 5 MB)",
    "orders.uploading": "Mengunggah…",
    "orders.choose_file": "Pilih file",
    "Choose File": "Pilih file",
    "common.download": "Unduh",
    "Download": "Unduh",
    "common.remove": "Hapus",
    "Remove": "Hapus",
    "orders.upload_new_file": "Unggah file baru",
    "Upload New File": "Unggah file baru",
    "orders.saving": "Menyimpan…",
    "Saving...": "Menyimpan…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Menghapus pesanan akan langsung menghilangkannya dari tampilan penjual dan pembeli. Setelah dihapus, status tidak dapat diperbarui dan pesanan tidak akan disertakan dalam metrik atau laporan. Lanjutkan?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Menghapus pesanan akan langsung menghilangkannya dari tampilan penjual dan pembeli. Setelah dihapus, status tidak dapat diperbarui dan pesanan tidak akan disertakan dalam metrik atau laporan. Lanjutkan?",
    "common.showing": "Menampilkan",
    "Showing": "Menampilkan",
    "common.of": "dari",
    "of": "dari",
    "common.all": "Semua",
    "All": "Semua",
    "common.active": "Aktif",
    "Active": "Aktif",
    "common.inactive": "Tidak aktif",
    "Inactive": "Tidak aktif",
    "common.enabled": "Diaktifkan",
    "Enabled": "Diaktifkan",
    "common.disabled": "Dinonaktifkan",
    "common.success": "Berhasil",
    "Success": "Berhasil",
    "common.error": "Error",
    "Error": "Error",
    "common.warning": "Peringatan",
    "Warning": "Peringatan",
    "common.required": "Wajib diisi",
    "Required": "Wajib diisi",
    "users.title": "Pengguna",
    "users.import": "Impor",
    "Import": "Impor",
    "users.import_users": "Impor pengguna",
    "Import users": "Impor pengguna",
    "users.smart_upload_users": "Unggah pengguna pintar",
    "Smart Upload Users": "Unggah pengguna pintar",
    "users.smart_upload_beta": "Unggah pengguna pintar (Beta)",
    "Smart upload users (Beta)": "Unggah pengguna pintar (Beta)",
    "users.export": "Ekspor",
    "Export": "Ekspor",
    "users.export_users": "Ekspor pengguna",
    "Export users": "Ekspor pengguna",
    "users.search_users": "Cari pengguna",
    "Search users": "Cari pengguna",
    "users.verified": "Terverifikasi",
    "Verified": "Terverifikasi",
    "users.not_verified": "Belum diverifikasi",
    "Non Verified": "Belum diverifikasi",
    "users.block": "Blokir",
    "Block": "Blokir",
    "users.unblock": "Buka blokir",
    "Unblock": "Buka blokir",
    "users.confirm_block": "Apakah Anda ingin memblokir pengguna ini?",
    "Do you want to block this user?": "Apakah Anda ingin memblokir pengguna ini?",
    "users.confirm_unblock": "Apakah Anda ingin membuka blokir pengguna ini?",
    "Do you want to unblock this user?": "Apakah Anda ingin membuka blokir pengguna ini?",
    "users.import_export": "Impor dan ekspor pengguna",
    "User import and export": "Impor dan ekspor pengguna",
    "users.user_id": "ID pengguna",
    "User ID": "ID pengguna",
    "users.first_name": "Nama depan",
    "First Name": "Nama depan",
    "users.last_name": "Nama belakang",
    "Last Name": "Nama belakang",
    "users.email": "Email",
    "users.phone_number": "Nomor telepon",
    "Phone No": "Nomor telepon",
    "users.country": "Negara",
    "users.profile": "Profil",
    "Profile": "Profil",
    "users.email_verified": "Email terverifikasi",
    "Email Verified": "Email terverifikasi",
    "users.blocked": "Diblokir",
    "Blocked": "Diblokir",
    "users.action": "Tindakan",
    "users.join_date": "Tanggal bergabung",
    "Join Date": "Tanggal bergabung",
    "users.last_login": "Login terakhir",
    "Last Login": "Login terakhir",
    "users.customer_type": "Jenis pelanggan",
    "Customer Type": "Jenis pelanggan",
    "common.and": "dan",
    "and": "dan",
    "users.import_failed": "Impor pengguna gagal.",
    "User import failed.": "Impor pengguna gagal.",
    "users.smart_upload.paid_title": "Fitur unggah pengguna pintar berbayar",
    "Smart user upload is a paid feature": "Fitur unggah pengguna pintar berbayar",
    "users.smart_upload.paid_description": "Upgrade ruang kerja Anda ke Starter atau Go untuk mengunggah pengguna dari file CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Upgrade ruang kerja Anda ke Starter atau Go untuk mengunggah pengguna dari file CSV.",
    "users.smart_upload.view_plans": "Lihat paket",
    "View plans": "Lihat paket",
    "users.smart_upload.csv_needs_user": "CSV harus memiliki baris header dan setidaknya satu pengguna.",
    "The CSV must contain a header row and at least one user.": "CSV harus memiliki baris header dan setidaknya satu pengguna.",
    "users.smart_upload.unique_headers": "Setiap kolom pengguna harus memiliki header unik dan tidak kosong.",
    "Every user column needs a unique, non-empty header.": "Setiap kolom pengguna harus memiliki header unik dan tidak kosong.",
    "users.smart_upload.csv_read_error": "CSV ini tidak dapat dibaca.",
    "Unable to read this CSV.": "CSV ini tidak dapat dibaca.",
    "users.smart_upload.map_required": "Petakan {fields} sebelum melanjutkan.",
    "Map {fields} before continuing.": "Petakan {fields} sebelum melanjutkan.",
    "users.smart_upload.map_contact": "Petakan kolom Email atau Phone. Setiap baris harus memiliki setidaknya satu metode kontak.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Petakan kolom Email atau Phone. Setiap baris harus memiliki setidaknya satu metode kontak.",
    "users.smart_upload.invalid_row": "Baris {row} tidak memiliki nama atau informasi kontak yang wajib.",
    "Row {row} is missing a required name or contact value.": "Baris {row} tidak memiliki nama atau informasi kontak yang wajib.",
    "users.smart_upload.attribute_name_required": "Masukkan nama atribut untuk “{header}”.",
    "Enter an attribute name for “{header}”.": "Masukkan nama atribut untuk “{header}”.",
    "users.smart_upload.attribute_create_error": "Tidak dapat membuat atribut “{name}”.",
    "Could not create the “{name}” attribute.": "Tidak dapat membuat atribut “{name}”.",
    "users.smart_upload.attribute_missing": "Atribut yang dipetakan dari “{header}” tidak lagi tersedia.",
    "The attribute mapped from “{header}” is no longer available.": "Atribut yang dipetakan dari “{header}” tidak lagi tersedia.",
    "users.smart_upload.prepare_error": "File impor tidak dapat disiapkan.",
    "users.smart_upload.upload_error": "File impor tidak dapat diunggah.",
    "The import file could not be uploaded.": "File impor tidak dapat diunggah.",
    "users.smart_upload.all_duplicates": "Semua baris dalam file ini merupakan duplikat.",
    "Every row is a duplicate of another row in this file.": "Semua baris dalam file ini merupakan duplikat.",
    "users.smart_upload.source_attribute_error": "Atribut contact_source tidak dapat dibuat.",
    "Could not create the contact_source attribute.": "Atribut contact_source tidak dapat dibuat.",
    "users.smart_upload.duplicates_skipped": "Baris duplikat yang dilewati: {count}.",
    "Duplicate rows to skip: {count}.": "Baris duplikat yang dilewati: {count}.",
    "users.smart_upload.preparing_attributes": "Menyiapkan atribut",
    "Preparing attributes": "Menyiapkan atribut",
    "users.smart_upload.checking_users": "Memeriksa pengguna yang ada",
    "Checking existing users": "Memeriksa pengguna yang ada",
    "users.smart_upload.uploading_file": "Mengunggah file impor",
    "Uploading import file": "Mengunggah file impor",
    "users.smart_upload.importing_users": "Tradly sedang mengimpor pengguna",
    "Tradly is importing users": "Tradly sedang mengimpor pengguna",
    "users.smart_upload.import_stopped": "Impor dihentikan",
    "Import stopped": "Impor dihentikan",
    "users.smart_upload.title": "Unggah pengguna pintar",
    "Smart user upload": "Unggah pengguna pintar",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Mulai ulang",
    "Start over": "Mulai ulang",
    "users.smart_upload.description": "Unggah kontak, petakan kolom ke atribut pengguna, lalu klasifikasikan sebagai kontak keluar atau pengguna terdaftar.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Unggah kontak, petakan kolom ke atribut pengguna, lalu klasifikasikan sebagai kontak keluar atau pengguna terdaftar.",
    "users.smart_upload.step_upload": "Unggah",
    "Upload": "Unggah",
    "users.smart_upload.step_match": "Cocokkan kolom",
    "Match columns": "Cocokkan kolom",
    "users.smart_upload.step_review": "Tinjau",
    "users.smart_upload.step_import": "Impor",
    "users.smart_upload.choose_csv": "Pilih file CSV",
    "Choose a CSV file": "Pilih file CSV",
    "users.smart_upload.required_fields": "Nama depan, nama belakang, serta email atau telepon wajib diisi. Kata sandi dibuat otomatis.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Nama depan, nama belakang, serta email atau telepon wajib diisi. Kata sandi dibuat otomatis.",
    "users.smart_upload.select_csv": "Pilih file CSV",
    "Select CSV file": "Pilih file CSV",
    "users.smart_upload.match_columns": "Cocokkan kolom pengguna",
    "Match user columns": "Cocokkan kolom pengguna",
    "users.smart_upload.first_name": "Nama depan",
    "First name": "Nama depan",
    "users.smart_upload.last_name": "Nama belakang",
    "Last name": "Nama belakang",
    "users.smart_upload.email": "Email",
    "users.smart_upload.phone": "Telepon",
    "users.smart_upload.username": "Nama pengguna",
    "Username": "Nama pengguna",
    "users.smart_upload.do_not_import": "Jangan impor",
    "Do not import": "Jangan impor",
    "users.smart_upload.additional_attributes": "Atribut pengguna tambahan",
    "Additional user attributes": "Atribut pengguna tambahan",
    "users.smart_upload.ignore_column": "Abaikan kolom ini",
    "Ignore this column": "Abaikan kolom ini",
    "users.smart_upload.create_attribute": "Buat atribut pengguna baru",
    "Create a new user attribute": "Buat atribut pengguna baru",
    "users.smart_upload.attribute_name": "Nama atribut",
    "Attribute name": "Nama atribut",
    "users.smart_upload.type_text": "Teks",
    "Text": "Teks",
    "users.smart_upload.type_long_text": "Teks panjang",
    "Long text": "Teks panjang",
    "users.smart_upload.type_number": "Angka",
    "Number": "Angka",
    "users.smart_upload.type_single_select": "Pilih satu",
    "users.smart_upload.type_multi_select": "Pilih beberapa",
    "users.smart_upload.review_import": "Tinjau impor",
    "Review import": "Tinjau impor",
    "users.smart_upload.review_description": "Kontak untuk diimpor: {count}. API mungkin menolak pengguna Tradly yang sudah ada; mengulangi impor sebagian dapat menggandakan baris yang berhasil.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Kontak untuk diimpor: {count}. API mungkin menolak pengguna Tradly yang sudah ada; mengulangi impor sebagian dapat menggandakan baris yang berhasil.",
    "users.smart_upload.contact_classification": "Klasifikasi kontak",
    "Contact classification": "Klasifikasi kontak",
    "users.smart_upload.outbound": "Kontak keluar (belum menyetujui)",
    "Outbound (not opted in)": "Kontak keluar (belum menyetujui)",
    "users.smart_upload.signed_up": "Terdaftar (telah menyetujui)",
    "Signed-up (opted in)": "Terdaftar (telah menyetujui)",
    "users.smart_upload.contact_source_help": "Nilai ini disimpan sebagai atribut contact_source. Jenis pengguna bawaan Tradly tetap customer.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Nilai ini disimpan sebagai atribut contact_source. Jenis pengguna bawaan Tradly tetap customer.",
    "users.smart_upload.import_complete": "Impor pengguna selesai",
    "User import complete": "Impor pengguna selesai",
    "users.smart_upload.imported_summary": "{imported} dari {total} pengguna berhasil diimpor.",
    "{imported} of {total} users imported.": "{imported} dari {total} pengguna berhasil diimpor.",
    "users.smart_upload.selected_file": "Dipilih: {name}",
    "Selected: {name}": "Dipilih: {name}",
    "users.smart_upload.review_action": "Tinjau",
    "users.smart_upload.importing_action": "Mengimpor…",
    "Importing…": "Mengimpor…",
    "users.smart_upload.import_users_action": "Impor pengguna",
    "users.import.uploading": "Mengunggah…",
    "Uploading…": "Mengunggah…",
    "users.import.please_wait": "Mohon tunggu…",
    "users.import.error_prefix": "Error",
    "users.import.select_file_error": "Pilih file",
    "Please select a file": "Pilih file",
    "users.import.download": "Unduh",
    "users.import.file_label": "File:",
    "File:": "File:",
    "users.import.select_file": "Pilih file",
    "Select File": "Pilih file",
    "users.import.upload": "Unggah",
    "users.create.button": "Buat pengguna",
    "Create User": "Buat pengguna",
    "users.create.title": "Buat pengguna baru",
    "Create New User": "Buat pengguna baru",
    "users.create.please_wait": "Mohon tunggu…",
    "users.create.email": "Email",
    "users.create.first_name": "Nama depan",
    "users.create.last_name": "Nama belakang",
    "users.create.email_required": "Email wajib diisi",
    "Email is required": "Email wajib diisi",
    "users.create.first_name_required": "Nama depan wajib diisi",
    "First Name is required": "Nama depan wajib diisi",
    "users.create.last_name_required": "Nama belakang wajib diisi",
    "Last Name is required": "Nama belakang wajib diisi",
    "users.create.session_expired": "Sesi admin Anda telah berakhir. Silakan masuk lagi sebelum membuat pengguna.",
    "Your admin session has expired. Please sign in again before creating a user.": "Sesi admin Anda telah berakhir. Silakan masuk lagi sebelum membuat pengguna.",
    "users.create.unable_to_create": "Pengguna ini tidak dapat dibuat.",
    "Unable to create this user.": "Pengguna ini tidak dapat dibuat.",
    "users.create.success": "Pengguna berhasil dibuat",
    "User created successfully": "Pengguna berhasil dibuat",
    "users.create.failed": "Pembuatan pengguna gagal. Silakan coba lagi.",
    "User creation failed. Please try again.": "Pembuatan pengguna gagal. Silakan coba lagi.",
    "common.feature_flow.eyebrow": "LIHAT CARA KERJANYA",
    "SEE HOW IT WORKS": "LIHAT CARA KERJANYA",
    "common.feature_flow.open_guide": "Buka panduan alur",
    "Open flow guide": "Buka panduan alur",
    "common.feature_flow.close_guide": "Tutup panduan bagian",
    "Close section guide": "Tutup panduan bagian",
    "common.feature_flow.section_guide": "Panduan bagian",
    "Section guide": "Panduan bagian",
    "users.flow.title": "Semua yang Anda perlukan untuk mengelola pengguna",
    "Everything you need to manage your users": "Semua yang Anda perlukan untuk mengelola pengguna",
    "users.flow.description": "Buat profil pengguna, sesuaikan data pengguna, dan pahami masukan pelanggan di satu tempat.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Buat profil pengguna, sesuaikan data pengguna, dan pahami masukan pelanggan di satu tempat.",
    "users.flow.lane_title": "Manajemen pengguna",
    "User management": "Manajemen pengguna",
    "users.flow.badge": "Alat inti",
    "Core tools": "Alat inti",
    "users.flow.attributes": "Atribut",
    "Attributes": "Atribut",
    "users.flow.reviews": "Ulasan",
    "Reviews": "Ulasan",
    "users.flow.lane_description": "Kelola pengguna, tambahkan kolom profil yang diperlukan, dan pelajari pengalaman mereka.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Kelola pengguna, tambahkan kolom profil yang diperlukan, dan pelajari pengalaman mereka.",
    "users.flow.primary_action": "Tambahkan pengguna pertama",
    "Add your first user": "Tambahkan pengguna pertama",
    "users.tooltip.title": "Setiap orang adalah pengguna tersendiri",
    "Every individual is a unique user": "Setiap orang adalah pengguna tersendiri",
    "users.tooltip.description": "Stel sejenak Anda memiliki sebuah pusat perbelanjaan.\n\nSetiap orang yang masuk ke toko dianggap sebagai pengguna.\n\nSetiap pedagang yang menjalankan toko juga dianggap sebagai pengguna.\n\nDi Tradly, semua pihak—pedagang maupun pelanggan—disebut “Pengguna”. Detail unik mereka disimpan di bagian pengguna. Anda dapat melihat detail pembelian atau akun yang mereka miliki.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Stel sejenak Anda memiliki sebuah pusat perbelanjaan.\n\nSetiap orang yang masuk ke toko dianggap sebagai pengguna.\n\nSetiap pedagang yang menjalankan toko juga dianggap sebagai pengguna.\n\nDi Tradly, semua pihak—pedagang maupun pelanggan—disebut “Pengguna”. Detail unik mereka disimpan di bagian pengguna. Anda dapat melihat detail pembelian atau akun yang mereka miliki.",
    "workspace.loading": "Memuat pengaturan ruang kerja…",
    "Loading workspace settings…": "Memuat pengaturan ruang kerja…",
    "workspace.kicker": "RUANG KERJA",
    "WORKSPACE": "RUANG KERJA",
    "workspace.fallback_name": "Ruang kerja",
    "workspace.members.title": "Undang anggota tim",
    "Invite Team Member": "Undang anggota tim",
    "workspace.members.description": "Tambahkan rekan tim dan berikan akses hanya sesuai kebutuhan masing-masing.",
    "Add teammates and give each person only the access they need.": "Tambahkan rekan tim dan berikan akses hanya sesuai kebutuhan masing-masing.",
    "workspace.members.enter_name_email": "Masukkan nama anggota dan alamat email.",
    "Enter a member name and email address.": "Masukkan nama anggota dan alamat email.",
    "workspace.members.invitation_sent": "Undangan terkirim.",
    "Invitation sent.": "Undangan terkirim.",
    "workspace.members.confirm_remove": "Hapus {name} dari ruang kerja ini?",
    "Remove {name} from this workspace?": "Hapus {name} dari ruang kerja ini?",
    "workspace.members.removed": "Anggota tim dihapus.",
    "Team member removed.": "Anggota tim dihapus.",
    "workspace.members.roles_saved": "Peran anggota disimpan.",
    "Member roles saved.": "Peran anggota disimpan.",
    "workspace.members.read": "Baca",
    "Read": "Baca",
    "workspace.members.write": "Tulis",
    "Write": "Tulis",
    "workspace.members.delete": "Hapus",
    "workspace.members.select_all_permission": "Pilih semua {permission} di {group}",
    "Select all {permission} in {group}": "Pilih semua {permission} di {group}",
    "workspace.members.member_name": "Nama anggota",
    "Member Name": "Nama anggota",
    "workspace.members.email_address": "Alamat email",
    "Email Address": "Alamat email",
    "workspace.members.sending": "Mengirim…",
    "Sending…": "Mengirim…",
    "workspace.members.send_invitation": "Kirim undangan",
    "Send invitation": "Kirim undangan",
    "workspace.members.team_members": "Anggota tim",
    "Team members": "Anggota tim",
    "workspace.members.search_members": "Cari anggota",
    "Search members": "Cari anggota",
    "workspace.members.search": "Cari",
    "workspace.members.member": "Anggota",
    "Member": "Anggota",
    "workspace.members.email": "Email",
    "workspace.members.status": "Status",
    "workspace.members.actions": "Tindakan",
    "workspace.members.unnamed": "Anggota tanpa nama",
    "Unnamed member": "Anggota tanpa nama",
    "workspace.members.roles": "Peran",
    "Roles": "Peran",
    "workspace.members.empty": "Anggota tim tidak ditemukan.",
    "No team members found.": "Anggota tim tidak ditemukan.",
    "workspace.members.page_of": "Halaman {page} dari {pages}",
    "Page {page} of {pages}": "Halaman {page} dari {pages}",
    "workspace.members.assign_roles": "Tetapkan peran",
    "Assign roles": "Tetapkan peran",
    "workspace.members.save_roles": "Simpan peran",
    "Save roles": "Simpan peran",
    "workspace.members.saving": "Menyimpan…",
    "Saving…": "Menyimpan…",
    "workspace.error.generic": "Terjadi kesalahan. Silakan coba lagi.",
    "Something went wrong. Please try again.": "Terjadi kesalahan. Silakan coba lagi.",
    "workspace.billing.view_label": "Tampilan penagihan ruang kerja",
    "Billing workspace view": "Tampilan penagihan ruang kerja",
    "workspace.billing.tab_usage": "Penggunaan",
    "Usage": "Penggunaan",
    "workspace.billing.tab_plans": "Paket",
    "workspace.billing.tab_invoices": "Faktur lunas",
    "Paid invoices": "Faktur lunas",
    "workspace.billing.tab_account": "Akun",
    "Account": "Akun",
    "workspace.account.title": "Pengaturan bisnis",
    "Business Settings": "Pengaturan bisnis",
    "workspace.account.description": "Kelola profil bisnis, produk yang diaktifkan, dan privasi akun Anda.",
    "Manage your business profile, enabled products, and account privacy.": "Kelola profil bisnis, produk yang diaktifkan, dan privasi akun Anda.",
    "workspace.account.profile_updated": "Profil bisnis diperbarui.",
    "Business profile updated.": "Profil bisnis diperbarui.",
    "workspace.account.logo_updated": "Logo diperbarui.",
    "Logo updated.": "Logo diperbarui.",
    "workspace.account.logo_upload_error": "Logo tidak dapat diunggah.",
    "Unable to upload logo.": "Logo tidak dapat diunggah.",
    "workspace.account.confirm_delete": "Hapus akun Tradly ini secara permanen? Tindakan ini tidak dapat dibatalkan.",
    "Delete this Tradly account permanently? This cannot be undone.": "Hapus akun Tradly ini secara permanen? Tindakan ini tidak dapat dibatalkan.",
    "workspace.account.business_profile": "Profil bisnis",
    "Business Profile": "Profil bisnis",
    "workspace.account.logo": "Logo",
    "Logo": "Logo",
    "workspace.account.logo_alt": "Logo bisnis",
    "Business logo": "Logo bisnis",
    "workspace.account.add_photo": "Tambahkan foto",
    "Add photo": "Tambahkan foto",
    "workspace.account.logo_formats": "PNG, JPG, SVG atau ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG atau ICO",
    "workspace.account.business_name": "Nama bisnis",
    "Business Name": "Nama bisnis",
    "workspace.account.contact_name": "Nama kontak bisnis",
    "Business Contact Name": "Nama kontak bisnis",
    "workspace.account.business_address": "Alamat bisnis",
    "Business Address": "Alamat bisnis",
    "workspace.account.products_of_interest": "Produk yang diminati",
    "Products of Interest": "Produk yang diminati",
    "workspace.account.marketplace": "Marketplace",
    "workspace.account.single_store": "Toko online tunggal",
    "Single Store Commerce": "Toko online tunggal",
    "workspace.account.alacarte_products": "Produk satuan",
    "À la carte Products": "Produk satuan",
    "workspace.account.alacarte_description": "Produk satuan yang diaktifkan untuk ruang kerja ini dikelola melalui Paket & Penagihan.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Produk satuan yang diaktifkan untuk ruang kerja ini dikelola melalui Paket & Penagihan.",
    "workspace.account.manage_alacarte": "Kelola produk satuan",
    "Manage à la carte products": "Kelola produk satuan",
    "workspace.account.delete_irreversible": "Penghapusan akun: tidak dapat dibatalkan",
    "Delete your Account: Irreversible": "Penghapusan akun: tidak dapat dibatalkan",
    "workspace.account.delete_description": "Tindakan ini akan menghapus tenant Tradly beserta semua data terkait secara permanen.",
    "This permanently deletes the Tradly tenant and all associated data.": "Tindakan ini akan menghapus tenant Tradly beserta semua data terkait secara permanen.",
    "workspace.account.deleting": "Menghapus…",
    "Deleting…": "Menghapus…",
    "workspace.account.delete_button": "Hapus akun Tradly",
    "Delete Account With Tradly": "Hapus akun Tradly",
    "workspace.privacy.title": "Privasi dan pemroses data",
    "Privacy & Data Processors": "Privasi dan pemroses data",
    "workspace.privacy.description": "Pelajari penyedia pemroses yang membantu menjalankan Tradly dan cara penyimpanan data setelah permintaan penghapusan.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Pelajari penyedia pemroses yang membantu menjalankan Tradly dan cara penyimpanan data setelah permintaan penghapusan.",
    "workspace.privacy.processor_retention": "Kami menggunakan layanan dan alat berikut untuk menjalankan layanan, meningkatkan kualitas produk, mendukung penagihan, dan menjaga keandalan. Masa retensi ini hanya berlaku setelah pengguna meminta penghapusan akun. Data pengguna Tradly Platform disimpan sekitar 90–180 hari, sesuai kebutuhan operasional dan kepatuhan.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Kami menggunakan layanan dan alat berikut untuk menjalankan layanan, meningkatkan kualitas produk, mendukung penagihan, dan menjaga keandalan. Masa retensi ini hanya berlaku setelah pengguna meminta penghapusan akun. Data pengguna Tradly Platform disimpan sekitar 90–180 hari, sesuai kebutuhan operasional dan kepatuhan.",
    "workspace.privacy.read_more": "Baca selengkapnya.",
    "Read more.": "Baca selengkapnya.",
    "workspace.privacy.tool": "Alat",
    "Tool": "Alat",
    "workspace.privacy.purpose": "Tujuan",
    "Purpose": "Tujuan",
    "workspace.privacy.data_category": "Kategori data",
    "Data Category": "Kategori data",
    "workspace.privacy.deletion_requests": "Permintaan penghapusan akun dan data",
    "Account deletion and data requests": "Permintaan penghapusan akun dan data",
    "workspace.privacy.deletion_description": "Untuk meminta penghapusan akun atau penghapusan dari alat pengelolaan relasi pelanggan, hubungi administrator ruang kerja atau dukungan. Tindakan ini memerlukan konfirmasi backend sebelum tersedia di sini.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Untuk meminta penghapusan akun atau penghapusan dari alat pengelolaan relasi pelanggan, hubungi administrator ruang kerja atau dukungan. Tindakan ini memerlukan konfirmasi backend sebelum tersedia di sini.",
    "workspace.privacy.open_account": "Buka pengaturan akun",
    "Open account settings": "Buka pengaturan akun",
    "workspace.privacy.core_operations": "Operasional inti produk",
    "Core product operations": "Operasional inti produk",
    "workspace.privacy.user_data_retention": "Data pengguna (retensi: 90–180 hari)",
    "User data (retention: 90–180 days)": "Data pengguna (retensi: 90–180 hari)",
    "workspace.privacy.crm_support_lifecycle": "CRM, dukungan, komunikasi sepanjang siklus pengguna",
    "CRM, support, lifecycle communication": "CRM, dukungan, komunikasi sepanjang siklus pengguna",
    "workspace.privacy.personal_data": "Data pribadi",
    "Personal data": "Data pribadi",
    "workspace.privacy.product_analytics": "Analitik produk dan funnel keterlibatan",
    "Product analytics and engagement funnels": "Analitik produk dan funnel keterlibatan",
    "workspace.privacy.usage_events": "Analitik penggunaan dan peristiwa",
    "Usage and event analytics": "Analitik penggunaan dan peristiwa",
    "workspace.privacy.billing_payments": "Penagihan dan pemrosesan pembayaran",
    "Billing and payment processing": "Penagihan dan pemrosesan pembayaran",
    "workspace.privacy.billing_data": "Data penagihan",
    "Billing data": "Data penagihan",
    "workspace.privacy.traffic_analytics": "Analitik trafik dan perilaku",
    "Traffic and behavior analytics": "Analitik trafik dan perilaku",
    "workspace.privacy.usage_analytics": "Analitik penggunaan",
    "Usage analytics": "Analitik penggunaan",
    "workspace.privacy.session_diagnostics": "Wawasan sesi dan diagnostik tombol yang tidak berfungsi",
    "Session insights and broken-button diagnostics": "Wawasan sesi dan diagnostik tombol yang tidak berfungsi",
    "workspace.privacy.ux_telemetry": "Telemetri UX/sesi",
    "UX/session telemetry": "Telemetri UX/sesi",
    "workspace.privacy.error_monitoring": "Pemantauan kesalahan kode dan stabilitas",
    "Code error and stability monitoring": "Pemantauan kesalahan kode dan stabilitas",
    "workspace.privacy.error_logs": "Log kesalahan dan diagnostik",
    "Error logs and diagnostics": "Log kesalahan dan diagnostik",
    "workspace.privacy.email_delivery": "Pengiriman email transaksional",
    "Transactional email delivery": "Pengiriman email transaksional",
    "workspace.privacy.email_metadata": "Metadata email",
    "Email metadata": "Metadata email",
    "workspace.privacy.hosting_infrastructure": "Hosting dan infrastruktur",
    "Hosting and infrastructure": "Hosting dan infrastruktur",
    "workspace.privacy.infrastructure_logs": "Log infrastruktur dan layanan",
    "Infrastructure and service logs": "Log infrastruktur dan layanan",
    "workspace.domain.title": "Domain",
    "Domains": "Domain",
    "workspace.domain.description": "Hubungkan domain Anda untuk menggantikan URL Tradly bawaan.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Hubungkan domain Anda untuk menggantikan URL Tradly bawaan.",
    "workspace.domain.invalid": "Masukkan domain yang valid, seperti example.com.",
    "Enter a valid domain, such as example.com.": "Masukkan domain yang valid, seperti example.com.",
    "workspace.domain.reserved": "tradly.co dicadangkan untuk domain ruang kerja yang dihosting.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co dicadangkan untuk domain ruang kerja yang dihosting.",
    "workspace.domain.missing_primary": "Domain utama ruang kerja tidak tersedia.",
    "No primary workspace domain is available.": "Domain utama ruang kerja tidak tersedia.",
    "workspace.domain.saved": "Domain khusus disimpan. Perbarui data DNS, lalu periksa statusnya kembali.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Domain khusus disimpan. Perbarui data DNS, lalu periksa statusnya kembali.",
    "workspace.domain.reset_success": "Domain diatur ulang ke URL Tradly yang dihosting.",
    "Domain reset to the Tradly-hosted URL.": "Domain diatur ulang ke URL Tradly yang dihosting.",
    "workspace.domain.current": "DOMAIN SAAT INI",
    "CURRENT DOMAIN": "DOMAIN SAAT INI",
    "workspace.domain.hosted": "Domain yang dihosting Tradly",
    "Tradly-hosted domain": "Domain yang dihosting Tradly",
    "workspace.domain.dns_status": "Status DNS: {status}",
    "DNS status: {status}": "Status DNS: {status}",
    "workspace.domain.checking": "Memeriksa status DNS…",
    "Checking DNS status…": "Memeriksa status DNS…",
    "workspace.domain.refresh": "Perbarui status",
    "Refresh status": "Perbarui status",
    "workspace.domain.reset": "Atur ulang domain",
    "Reset domain": "Atur ulang domain",
    "workspace.domain.connect_title": "Hubungkan domain khusus",
    "Connect a custom domain": "Hubungkan domain khusus",
    "workspace.domain.connect_description": "Masukkan domain yang sudah Anda miliki. Kami akan menampilkan data DNS yang diperlukan untuk menghubungkannya.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Masukkan domain yang sudah Anda miliki. Kami akan menampilkan data DNS yang diperlukan untuk menghubungkannya.",
    "workspace.domain.saving": "Menyimpan…",
    "workspace.domain.add": "Tambahkan domain",
    "Add domain": "Tambahkan domain",
    "workspace.domain.dns_title": "Penyiapan DNS",
    "DNS setup": "Penyiapan DNS",
    "workspace.domain.a_record": "Data A",
    "A record": "Data A",
    "workspace.domain.root_description": "Gunakan untuk domain root, seperti",
    "Use this for a root domain such as": "Gunakan untuk domain root, seperti",
    "workspace.domain.cname_record": "Data CNAME",
    "CNAME record": "Data CNAME",
    "workspace.domain.subdomain_description": "Gunakan untuk subdomain, seperti",
    "Use this for a subdomain such as": "Gunakan untuk subdomain, seperti",
    "workspace.domain.host": "Host",
    "Host": "Host",
    "workspace.domain.value": "Nilai",
    "Value": "Nilai",
    "workspace.domain.need_domain": "Perlu domain?",
    "Need a domain?": "Perlu domain?",
    "workspace.domain.buy_domain": "Beli domain melalui Google Domains atau GoDaddy, lalu kembali ke sini untuk menghubungkannya.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Beli domain melalui Google Domains atau GoDaddy, lalu kembali ke sini untuk menghubungkannya.",
    "workspace.billing.title": "Penagihan dan penggunaan",
    "Billing & Usage": "Penagihan dan penggunaan",
    "workspace.billing.description": "Kelola paket, penggunaan, dan penagihan ruang kerja.",
    "Manage workspace plans, usage, and billing.": "Kelola paket, penggunaan, dan penagihan ruang kerja.",
    "workspace.billing.invoice_description": "Kelola paket, penggunaan, dan faktur lunas ruang kerja.",
    "Manage workspace plans, usage, and paid invoices.": "Kelola paket, penggunaan, dan faktur lunas ruang kerja.",
    "workspace.billing.usage_description": "Lihat penggunaan saat ini dan batas yang berlaku untuk ruang kerja ini.",
    "See current usage and the limits applied to this workspace.": "Lihat penggunaan saat ini dan batas yang berlaku untuk ruang kerja ini.",
    "workspace.invoices.loading": "Memuat faktur…",
    "Loading invoices…": "Memuat faktur…",
    "workspace.invoices.description": "Unduh faktur atau lunasi saldo yang belum dibayar.",
    "Download invoices or complete payment for an outstanding balance.": "Unduh faktur atau lunasi saldo yang belum dibayar.",
    "workspace.invoices.payment_failed": "Pembayaran gagal — akses layanan mungkin terdampak.",
    "Payment failed — service access may be affected.": "Pembayaran gagal — akses layanan mungkin terdampak.",
    "workspace.invoices.awaiting_payment": "Faktur {invoice} menunggu pembayaran.",
    "Invoice {invoice} is awaiting payment.": "Faktur {invoice} menunggu pembayaran.",
    "workspace.invoices.outstanding": "belum dibayar",
    "outstanding": "belum dibayar",
    "workspace.invoices.pay_invoice": "Bayar faktur",
    "Pay invoice": "Bayar faktur",
    "workspace.invoices.invoice": "Faktur",
    "workspace.invoices.date": "Tanggal",
    "workspace.invoices.amount": "Jumlah",
    "workspace.invoices.paid": "Lunas",
    "workspace.invoices.unpaid": "Belum dibayar",
    "Unpaid": "Belum dibayar",
    "workspace.invoices.download_invoice": "Unduh faktur",
    "Download invoice": "Unduh faktur",
    "workspace.invoices.empty_title": "Tidak ada faktur",
    "No invoices available": "Tidak ada faktur",
    "workspace.invoices.empty_description": "Faktur dibuat setelah Anda berlangganan dan melakukan pembayaran. Hubungi dukungan jika Anda memiliki pertanyaan.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Faktur dibuat setelah Anda berlangganan dan melakukan pembayaran. Hubungi dukungan jika Anda memiliki pertanyaan.",
    "workspace.plans.heading": "Paket",
    "workspace.plans.tab_marketplace": "Marketplace",
    "workspace.plans.tab_marketplace_description": "Multi-vendor",
    "Multi-vendor": "Multi-vendor",
    "workspace.plans.tab_single": "Toko tunggal",
    "Single Store": "Toko tunggal",
    "workspace.plans.tab_single_description": "Untuk kreator dan bisnis independen",
    "Indie & Creators": "Untuk kreator dan bisnis independen",
    "workspace.plans.tab_alacarte": "Satuan",
    "A la carte": "Satuan",
    "workspace.plans.tab_alacarte_description": "Kredit dan add-on",
    "Credits & add-ons": "Kredit dan add-on",
    "workspace.plans.tab_services": "Layanan",
    "Services": "Layanan",
    "workspace.plans.tab_services_description": "Layanan tambahan",
    "Additional services": "Layanan tambahan",
    "workspace.plans.selected": "Dipilih",
    "Selected": "Dipilih",
    "workspace.plans.try_again": "Coba lagi",
    "Try again": "Coba lagi",
    "workspace.plans.bill_yearly": "Tagih tahunan",
    "Bill Yearly": "Tagih tahunan",
    "workspace.plans.bill_monthly": "Tagih bulanan",
    "Bill Monthly": "Tagih bulanan",
    "workspace.plans.compare": "Bandingkan paket",
    "Compare Plans": "Bandingkan paket",
    "workspace.plans.community": "Komunitas",
    "workspace.plans.community_description": "Gratis selamanya. Cocok untuk proyek hobi dan komunitas.",
    "Free forever. Perfect for hobbyists and community projects.": "Gratis selamanya. Cocok untuk proyek hobi dan komunitas.",
    "workspace.plans.different_configurations": "Mencari konfigurasi lain?",
    "Looking for different configurations?": "Mencari konfigurasi lain?",
    "workspace.plans.contact_us": "Hubungi kami",
    "Contact Us": "Hubungi kami",
    "workspace.plans.see_alacarte_pricing": "Lihat harga produk satuan",
    "See à la carte pricing": "Lihat harga produk satuan",
    "workspace.plans.available": "Tersedia",
    "Available": "Tersedia",
    "workspace.plans.used_90d": "Digunakan (90 hr)",
    "Used (90d)": "Digunakan (90 hr)",
    "workspace.plans.expired_90d": "Kedaluwarsa (90 hr)",
    "Expired (90d)": "Kedaluwarsa (90 hr)",
    "workspace.plans.expires_on": "Berakhir pada {date}",
    "Expires {date}": "Berakhir pada {date}",
    "workspace.plans.top_up_credits": "Isi ulang kredit",
    "Top Up Credits": "Isi ulang kredit",
    "workspace.plans.credits_description": "Kredit digunakan untuk Email, AI Search, Recommendations, dan tindakan Agen. 100 kredit = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Kredit digunakan untuk Email, AI Search, Recommendations, dan tindakan Agen. 100 kredit = $5.",
    "workspace.plans.credits": "kredit",
    "credits": "kredit",
    "workspace.plans.custom_amount": "Jumlah khusus",
    "Custom amount": "Jumlah khusus",
    "workspace.plans.amount_example": "mis. 2500",
    "e.g. 2500": "mis. 2500",
    "workspace.plans.opening_checkout": "Membuka checkout…",
    "Opening checkout…": "Membuka checkout…",
    "workspace.plans.buy_credits": "Beli {count} kredit",
    "Buy {count} credits": "Beli {count} kredit",
    "workspace.plans.select_amount": "Pilih jumlah",
    "Select an amount": "Pilih jumlah",
    "workspace.plans.alacarte_products": "Produk satuan",
    "A la carte Products": "Produk satuan",
    "workspace.plans.products_description": "Pilih produk yang Anda gunakan agar kami dapat menyesuaikan pengalaman Anda. Penggunaan dibayar dengan kredit.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Pilih produk yang Anda gunakan agar kami dapat menyesuaikan pengalaman Anda. Penggunaan dibayar dengan kredit.",
    "workspace.plans.enabled": "Diaktifkan",
    "workspace.plans.enable": "Aktifkan",
    "Enable": "Aktifkan",
    "workspace.plans.open_here": "Buka di sini",
    "Open here": "Buka di sini",
    "workspace.plans.open_marketing": "Buka marketing.tradly.app",
    "Open marketing.tradly.app": "Buka marketing.tradly.app",
    "workspace.plans.open_analytics": "Buka analytics.tradly.app",
    "Open analytics.tradly.app": "Buka analytics.tradly.app",
    "workspace.plans.open_external": "Buka eksternal",
    "Open external": "Buka eksternal",
    "workspace.plans.coming_soon": "Segera hadir",
    "Coming soon": "Segera hadir",
    "workspace.plans.services_title": "Penyiapan satu kali dan layanan khusus",
    "One-Time Setup & Custom Services": "Penyiapan satu kali dan layanan khusus",
    "workspace.plans.service_app_launch": "Peluncuran aplikasi white-label",
    "White-Label App Launch": "Peluncuran aplikasi white-label",
    "workspace.plans.service_frontend": "Kustomisasi frontend",
    "Frontend Customization": "Kustomisasi frontend",
    "workspace.plans.service_multilanguage": "Dukungan multibahasa",
    "Multi-Language Support": "Dukungan multibahasa",
    "workspace.plans.view_docs": "Lihat dokumentasi",
    "View Docs": "Lihat dokumentasi",
    "workspace.plans.confirm_change": "Konfirmasikan perubahan paket",
    "Confirm your plan change": "Konfirmasikan perubahan paket",
    "workspace.plans.confirm_charge": "Tagihan dibayar di muka pada tanggal berlangganan Anda.",
    "Charges are prepaid and billed on your subscription date.": "Tagihan dibayar di muka pada tanggal berlangganan Anda.",
    "workspace.plans.confirm_promo": "Kode promo dapat dimasukkan saat checkout Stripe jika tersedia.",
    "Promotional codes can be entered during Stripe checkout where available.": "Kode promo dapat dimasukkan saat checkout Stripe jika tersedia.",
    "workspace.plans.confirm_delay": "Perubahan paket mungkin perlu waktu sebelum terlihat di ruang kerja.",
    "Plan changes may take a moment to appear in your workspace.": "Perubahan paket mungkin perlu waktu sebelum terlihat di ruang kerja.",
    "workspace.plans.payment_active": "Pembayaran diterima. Paket Anda aktif.",
    "Payment received. Your plan is active.": "Pembayaran diterima. Paket Anda aktif.",
    "workspace.plans.payment_method_updated": "Metode pembayaran diperbarui.",
    "Payment method updated.": "Metode pembayaran diperbarui.",
    "workspace.plans.payment_cancelled": "Pembayaran belum selesai, jadi paket Anda tidak berubah.",
    "Payment was not completed, so your plan has not changed.": "Pembayaran belum selesai, jadi paket Anda tidak berubah.",
    "workspace.plans.activating": "Pembayaran diterima. Mengaktifkan paket…",
    "Payment received. Activating your plan…": "Pembayaran diterima. Mengaktifkan paket…",
    "workspace.plans.activation_delayed": "Pembayaran diterima. Paket Anda membutuhkan waktu lebih lama untuk aktif. Silakan segarkan halaman sebentar lagi.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Pembayaran diterima. Paket Anda membutuhkan waktu lebih lama untuk aktif. Silakan segarkan halaman sebentar lagi.",
    "workspace.plans.card_saved": "Kartu tersimpan dan langganan diperbarui.",
    "Card saved and subscription updated.": "Kartu tersimpan dan langganan diperbarui.",
    "workspace.plans.subscription_updated": "Langganan diperbarui.",
    "Subscription updated.": "Langganan diperbarui.",
    "workspace.plans.products_saved": "Produk satuan disimpan.",
    "À la carte products saved.": "Produk satuan disimpan.",
    "workspace.plans.minimum_credits": "Masukkan minimal 100 kredit.",
    "Enter at least 100 credits.": "Masukkan minimal 100 kredit.",
    "workspace.plans.credit_topup_description": "Isi ulang kredit ({count} kredit)",
    "Credit Top-Up ({count} credits)": "Isi ulang kredit ({count} kredit)",
    "workspace.plans.billing_details": "Detail penagihan saat ini",
    "Current billing details": "Detail penagihan saat ini",
    "workspace.plans.current_plan": "Paket saat ini",
    "Current Plan": "Paket saat ini",
    "workspace.plans.renews": "Diperpanjang",
    "Renews": "Diperpanjang",
    "workspace.plans.payment_method": "Metode pembayaran",
    "Payment method": "Metode pembayaran",
    "workspace.plans.opening": "Membuka…",
    "Opening…": "Membuka…",
    "workspace.plans.manage_payment_method": "Kelola metode pembayaran",
    "Manage payment method": "Kelola metode pembayaran",
    "workspace.plans.upgrade": "Upgrade",
    "workspace.plans.downgrade": "Downgrade",
    "Downgrade": "Downgrade",
    "workspace.plans.custom_price": "Harga khusus",
    "workspace.plans.per_month_short": "/bulan",
    "/month": "/bulan",
    "workspace.plans.per_year_amount": "per tahun ({amount})",
    "per year ({amount})": "per tahun ({amount})",
    "workspace.plans.per_month_amount": "per bulan ({amount})",
    "per month ({amount})": "per bulan ({amount})",
    "workspace.plans.yearly_savings": "Hemat {amount} per tahun",
    "Save {amount} yearly": "Hemat {amount} per tahun",
    "workspace.plans.billed_yearly": "ditagih tahunan",
    "billed yearly": "ditagih tahunan",
    "workspace.plans.billed_monthly": "ditagih bulanan",
    "billed monthly": "ditagih bulanan",
    "workspace.plans.free_trial": "Anda sedang menggunakan uji coba gratis.",
    "You are on a free trial.": "Anda sedang menggunakan uji coba gratis.",
    "workspace.plans.updating": "Memperbarui…",
    "Updating…": "Memperbarui…",
    "workspace.plans.temporarily_unavailable": "Untuk sementara tidak tersedia",
    "Temporarily unavailable": "Untuk sementara tidak tersedia",
    "workspace.plans.whats_included": "Yang termasuk",
    "What's included": "Yang termasuk",
    "workspace.plans.products.auth.title": "Autentikasi",
    "Auth": "Autentikasi",
    "workspace.plans.products.auth.description": "Identitas, SSO, izin, dan manajemen pengguna.",
    "Identity, SSO, permissions, and user management.": "Identitas, SSO, izin, dan manajemen pengguna.",
    "workspace.plans.products.email.title": "Email",
    "workspace.plans.products.email.description": "Email transaksional dan pemasaran sudah tersedia.",
    "Transactional and marketing email, built in.": "Email transaksional dan pemasaran sudah tersedia.",
    "workspace.plans.products.analytics.title": "Analitik",
    "Analytics": "Analitik",
    "workspace.plans.products.analytics.description": "Analitik gratis untuk web, aplikasi, dan agen.",
    "Free analytics for web, app, and agents.": "Analitik gratis untuk web, aplikasi, dan agen.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "CRM yang terisi otomatis dari aktivitas pengguna.",
    "A CRM that fills itself from user activity.": "CRM yang terisi otomatis dari aktivitas pengguna.",
    "workspace.plans.products.subscription.title": "Langganan",
    "Subscriptions": "Langganan",
    "workspace.plans.products.subscription.description": "Penagihan berulang, uji coba, dan penagihan tunggakan ditangani.",
    "Recurring billing, trials, and dunning — handled.": "Penagihan berulang, uji coba, dan penagihan tunggakan ditangani.",
    "workspace.plans.products.recommendation.title": "Rekomendasi",
    "Recommendations": "Rekomendasi",
    "workspace.plans.products.recommendation.description": "Tampilkan kepada setiap pengguna hal yang benar-benar mereka inginkan.",
    "Show each user what they will actually want.": "Tampilkan kepada setiap pengguna hal yang benar-benar mereka inginkan.",
    "workspace.plans.marketplace.2025-superstarter.title": "Dasar",
    "Basic": "Dasar",
    "workspace.plans.marketplace.2025-superstarter.description": "Cocok untuk tim kecil. Mencakup semua fitur Community serta white-label (menghapus lencana “Built with Tradly”).",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Cocok untuk tim kecil. Mencakup semua fitur Community serta white-label (menghapus lencana “Built with Tradly”).",
    "workspace.plans.marketplace.2025-superstarter.button": "Mulai uji coba 7 hari",
    "Start 7 Days Trial": "Mulai uji coba 7 hari",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Tanpa biaya transaksi",
    "No transaction fee": "Tanpa biaya transaksi",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Situs web gratis yang dihosting Tradly",
    "Free Tradly hosted website": "Situs web gratis yang dihosting Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Tambahkan domain khusus",
    "Add your custom domain": "Tambahkan domain khusus",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Editor — riwayat halaman 3 hari",
    "Editor - 3 Day page history": "Editor — riwayat halaman 3 hari",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Untuk startup yang menguji ide bisnis. Mencakup kebutuhan utama untuk menguji pasar dan mendapatkan pelanggan awal.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Untuk startup yang menguji ide bisnis. Mencakup kebutuhan utama untuk menguji pasar dan mendapatkan pelanggan awal.",
    "workspace.plans.marketplace.2025-starter.button": "Mulai uji coba 7 hari",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Tanpa biaya transaksi",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Atribut khusus tanpa batas",
    "Unlimited Custom Attributes": "Atribut khusus tanpa batas",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "Riwayat halaman 30 hari",
    "30 Day page history": "Riwayat halaman 30 hari",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Langganan berbayar",
    "Gated Subscription": "Langganan berbayar",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Login sosial",
    "Social Logins": "Login sosial",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhook",
    "Webhooks": "Webhook",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Untuk ide bisnis yang sudah terbukti dan sedang berkembang. Cocok jika Anda memerlukan kebutuhan khusus dan integrasi tambahan.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Untuk ide bisnis yang sudah terbukti dan sedang berkembang. Cocok jika Anda memerlukan kebutuhan khusus dan integrasi tambahan.",
    "workspace.plans.marketplace.2025-growth.button": "Mulai uji coba 7 hari",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Tanpa biaya transaksi",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Email pengirim khusus",
    "Custom 'From Email'": "Email pengirim khusus",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Mini tools dan integrasi tambahan",
    "Additional Mini Tools & Integrations": "Mini tools dan integrasi tambahan",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Panggilan orientasi personal*",
    "Personalised Onboarding calls*": "Panggilan orientasi personal*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "Riwayat halaman 90 hari",
    "90 Day page history": "Riwayat halaman 90 hari",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Berbagai mata uang dan bahasa",
    "Multi Currencies & Multi Languages": "Berbagai mata uang dan bahasa",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Kontrol akses berbasis peran (RBAC)",
    "Role-based access control (RBAC)": "Kontrol akses berbasis peran (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Chat bawaan untuk aplikasi",
    "Inbuilt Chat for Apps": "Chat bawaan untuk aplikasi",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Untuk bisnis yang sedang berkembang dan membutuhkan solusi khusus serta persyaratan lain.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Untuk bisnis yang sedang berkembang dan membutuhkan solusi khusus serta persyaratan lain.",
    "workspace.plans.marketplace.2025-scale.button": "Mulai uji coba 7 hari",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Tanpa biaya transaksi",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Dukungan prioritas",
    "Priority Support": "Dukungan prioritas",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Berbagai kanal (dukungan aplikasi)",
    "Multiple Channels (App Support)": "Berbagai kanal (dukungan aplikasi)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Single Sign-on (SSO)",
    "Single Sign-on (SSO)": "Single Sign-on (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Riwayat halaman tanpa batas",
    "Unlimited page history": "Riwayat halaman tanpa batas",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Chat bawaan untuk aplikasi",
    "In-built Chat for Apps": "Chat bawaan untuk aplikasi",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Semua yang dibutuhkan toko yang berkembang—hapus branding, tambahkan domain, dan buka lebih banyak alat.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Semua yang dibutuhkan toko yang berkembang—hapus branding, tambahkan domain, dan buka lebih banyak alat.",
    "workspace.plans.indie.go.button": "Mulai uji coba 7 hari",
    "Start 7-day trial": "Mulai uji coba 7 hari",
    "workspace.plans.indie.go.feature_1.title": "Tanpa branding Tradly",
    "No Tradly branding": "Tanpa branding Tradly",
    "workspace.plans.indie.go.feature_2.title": "Domain khusus",
    "Custom domain": "Domain khusus",
    "workspace.plans.indie.go.feature_3.title": "Produk tanpa batas",
    "Unlimited products": "Produk tanpa batas",
    "workspace.plans.indie.go.feature_4.title": "Kampanye email",
    "Email campaigns": "Kampanye email",
    "workspace.plans.indie.go.feature_5.title": "Rekomendasi AI",
    "AI Recommendations": "Rekomendasi AI",
    "workspace.plans.indie.go.feature_6.title": "Dukungan berbasis tiket",
    "Ticket-based support": "Dukungan berbasis tiket",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Paket AI lengkap, pemasaran lanjutan, dan semua fitur untuk toko yang serius berkembang.",
    "workspace.plans.indie.genius.button": "Mulai uji coba 7 hari",
    "workspace.plans.indie.genius.feature_1.title": "Semua fitur Pro",
    "Everything in Pro": "Semua fitur Pro",
    "workspace.plans.indie.genius.feature_2.title": "Agen AI (Asisten Belanja, dll.)",
    "AI Agents (Shopping Assistant, etc.)": "Agen AI (Asisten Belanja, dll.)",
    "workspace.plans.indie.genius.feature_3.title": "Pencarian bahasa alami",
    "Natural language search": "Pencarian bahasa alami",
    "workspace.plans.indie.genius.feature_4.title": "Otomatisasi email lanjutan",
    "Advanced email automation": "Otomatisasi email lanjutan",
    "workspace.plans.indie.genius.feature_5.title": "Permintaan rekomendasi tanpa batas",
    "Unlimited recommendation requests": "Permintaan rekomendasi tanpa batas",
    "workspace.plans.indie.genius.feature_6.title": "Dukungan berbasis tiket",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Biaya langganan bagi pengguna untuk membuka akun dan mengirim listing.",
    "Subscription charges for people to open accounts & submit listings": "Biaya langganan bagi pengguna untuk membuka akun dan mengirim listing.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Daftar/masuk melalui Google dan Meta",
    "Signup/in via Google, Meta": "Daftar/masuk melalui Google dan Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Untuk terhubung dengan Zapier & Make",
    "To connect with Zapier & Make": "Untuk terhubung dengan Zapier & Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Pesan dalam aplikasi untuk pengguna",
    "Native in-app messaging for your users": "Pesan dalam aplikasi untuk pengguna",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Waktu respons 24 jam untuk masalah non-kritis",
    "24 hour response time for non-critical": "Waktu respons 24 jam untuk masalah non-kritis",
    "common.continue": "Lanjutkan",
    "Continue": "Lanjutkan",
    "workspace.plans.free_plan": "Gratis",
    "Free": "Gratis",
    "workspace.usage.group_platform": "Platform dan ruang kerja",
    "Platform & workspace": "Platform dan ruang kerja",
    "workspace.usage.group_ai": "AI dan penggunaan",
    "AI & usage": "AI dan penggunaan",
    "workspace.usage.group_storage": "Konten dan penyimpanan",
    "Content & storage": "Konten dan penyimpanan",
    "workspace.usage.group_alacarte": "Satuan",
    "workspace.usage.accounts": "Akun",
    "workspace.usage.listings": "Listing",
    "workspace.usage.sites": "Situs dalam ruang kerja",
    "Sites under workspace": "Situs dalam ruang kerja",
    "workspace.usage.external_users": "Pengguna eksternal",
    "External users": "Pengguna eksternal",
    "workspace.usage.internal_users": "Pengguna internal",
    "Internal users": "Pengguna internal",
    "workspace.usage.ai_credits": "Kredit AI",
    "AI credits": "Kredit AI",
    "workspace.usage.storage": "Penyimpanan",
    "Storage": "Penyimpanan",
    "workspace.usage.email": "Email",
    "workspace.usage.maps": "Peta",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analitik",
    "workspace.usage.recommendations": "Rekomendasi",
    "workspace.usage.ai_agents": "Agen AI",
    "AI agents": "Agen AI",
    "workspace.usage.status_not_reported": "Tidak dilaporkan",
    "Not reported": "Tidak dilaporkan",
    "workspace.usage.status_nearly_full": "Hampir penuh",
    "Nearly full": "Hampir penuh",
    "workspace.usage.status_on_track": "Sesuai target",
    "On track": "Sesuai target",
    "workspace.usage.workspace_files": "File ruang kerja",
    "Workspace files": "File ruang kerja",
    "workspace.usage.workspace_usage": "Penggunaan ruang kerja",
    "Workspace usage": "Penggunaan ruang kerja",
    "workspace.usage.of_limit": "dari {limit}",
    "of {limit}": "dari {limit}",
    "workspace.usage.no_cap": "Tidak ada batas yang dikonfigurasi",
    "No cap configured": "Tidak ada batas yang dikonfigurasi",
    "workspace.usage.trend": "Tren penggunaan",
    "Usage trend": "Tren penggunaan",
    "workspace.usage.unavailable": "Data penggunaan untuk sementara tidak tersedia.",
    "Usage data is temporarily unavailable.": "Data penggunaan untuk sementara tidak tersedia.",
    "workspace.usage.loading": "Memuat penggunaan ruang kerja…",
    "Loading workspace usage…": "Memuat penggunaan ruang kerja…",
    "workspace.usage.overview": "Ringkasan ruang kerja",
    "Workspace overview": "Ringkasan ruang kerja",
    "workspace.usage.title": "Rincian penggunaan",
    "Usage breakdown": "Rincian penggunaan",
    "workspace.usage.description": "Lihat penggunaan ruang kerja dan sisa kuota pada paket Anda saat ini.",
    "See what your workspace has used and how much room remains on your current plan.": "Lihat penggunaan ruang kerja dan sisa kuota pada paket Anda saat ini.",
    "workspace.usage.view_plans": "Lihat paket",
    "workspace.usage.showing_available_limits": "Menampilkan batas yang sudah tersedia di ruang kerja ini.",
    "Showing the limits that are already available in this workspace.": "Menampilkan batas yang sudah tersedia di ruang kerja ini.",
    "workspace.usage.summary": "Ringkasan penggunaan",
    "Usage summary": "Ringkasan penggunaan",
    "workspace.usage.metrics_tracked": "Metrik yang dilacak",
    "Metrics tracked": "Metrik yang dilacak",
    "workspace.usage.metrics_count": "{count} dari {total}",
    "{count} of {total}": "{count} dari {total}",
    "workspace.usage.next_reset": "Reset berikutnya",
    "Next reset": "Reset berikutnya",
    "workspace.usage.not_provided": "Tidak diberikan",
    "Not provided": "Tidak diberikan",
    "workspace.usage.data_source": "Sumber data",
    "Data source": "Sumber data",
    "workspace.usage.clear_view": "Tampilan ruang kerja yang jelas",
    "A clear view of your workspace": "Tampilan ruang kerja yang jelas",
    "workspace.usage.by_resource": "Berdasarkan sumber daya",
    "Usage by resource": "Berdasarkan sumber daya",
    "workspace.usage.live_summary": "Ringkasan langsung",
    "Live summary": "Ringkasan langsung",
    "workspace.usage.resource": "Sumber daya",
    "Resource": "Sumber daya",
    "workspace.usage.used_limit": "Digunakan / batas",
    "Used / limit": "Digunakan / batas",
    "workspace.usage.progress": "Progres",
    "Progress": "Progres",
    "workspace.usage.cost": "Biaya",
    "Cost": "Biaya",
    "workspace.usage.footnote": "Data penggunaan dan batas berasal dari layanan penggunaan ruang kerja. Tanda pisah berarti metrik tersebut belum dilaporkan oleh API saat ini.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "Data penggunaan dan batas berasal dari layanan penggunaan ruang kerja. Tanda pisah berarti metrik tersebut belum dilaporkan oleh API saat ini.",
    "workspace.usage.refresh": "Segarkan",
    "maps.title": "Peta",
    "maps.tab.analysis": "Analisis pasar",
    "Market scan": "Analisis pasar",
    "maps.tab.usage": "Penggunaan",
    "maps.tab.settings": "Pengaturan",
    "maps.action.save": "Simpan",
    "maps.action.saving": "Menyimpan…",
    "maps.action.analyze_area": "Analisis area",
    "Analyze area": "Analisis area",
    "maps.action.analyzing": "Menganalisis…",
    "Analyzing…": "Menganalisis…",
    "maps.action.refresh": "Segarkan",
    "maps.action.loading": "Memuat…",
    "Loading…": "Memuat…",
    "maps.action.open_in_maps": "Buka di Maps",
    "Open in Maps": "Buka di Maps",
    "maps.analysis.title": "Jelajahi pasar lokal",
    "Explore a local market": "Jelajahi pasar lokal",
    "maps.analysis.description": "Lihat bisnis yang ditampilkan Google di sekitar lokasi yang direncanakan. Ini hanya pemindaian awal persaingan, bukan perkiraan permintaan atau kelayakan.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Lihat bisnis yang ditampilkan Google di sekitar lokasi yang direncanakan. Ini hanya pemindaian awal persaingan, bukan perkiraan permintaan atau kelayakan.",
    "maps.analysis.address_label": "Alamat atau wilayah",
    "Address or locality": "Alamat atau wilayah",
    "maps.analysis.address_placeholder": "Jalan, kawasan, atau kota",
    "Street, suburb, or city": "Jalan, kawasan, atau kota",
    "maps.analysis.category_label": "Jenis bisnis",
    "Business type": "Jenis bisnis",
    "maps.analysis.radius_label": "Radius pencarian",
    "Search radius": "Radius pencarian",
    "maps.analysis.places_listings": "Daftar tempat",
    "Places listings": "Daftar tempat",
    "maps.analysis.within_radius": "{category} dalam radius {radius}",
    "{category} within {radius}": "{category} dalam radius {radius}",
    "maps.analysis.results_description": "Hasil difilter berdasarkan kategori dan radius, lalu diurutkan menurut jarak.",
    "Results are filtered by category and radius, then ordered by distance.": "Hasil difilter berdasarkan kategori dan radius, lalu diurutkan menurut jarak.",
    "maps.analysis.result_limit_notice": "Google menampilkan maksimum 20 tempat. Jumlah sebenarnya mungkin lebih banyak; perkecil radius untuk hasil yang lebih terperinci.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google menampilkan maksimum 20 tempat. Jumlah sebenarnya mungkin lebih banyak; perkecil radius untuk hasil yang lebih terperinci.",
    "maps.analysis.limitations": "Daftar tempat mungkin tidak lengkap dan tidak mengukur permintaan pelanggan, jumlah pengunjung, populasi, biaya sewa, atau profitabilitas. Gunakan data ini sebagai salah satu masukan riset lokal.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Daftar tempat mungkin tidak lengkap dan tidak mengukur permintaan pelanggan, jumlah pengunjung, populasi, biaya sewa, atau profitabilitas. Gunakan data ini sebagai salah satu masukan riset lokal.",
    "maps.analysis.nearby_businesses": "Bisnis terdekat ({count})",
    "Nearby businesses ({count})": "Bisnis terdekat ({count})",
    "maps.analysis.businesses": "Bisnis",
    "Businesses": "Bisnis",
    "maps.analysis.no_listings": "Tidak ditemukan tempat yang cocok di Google Maps untuk area dan kategori ini.",
    "No matching Google Maps listings were returned for this area and category.": "Tidak ditemukan tempat yang cocok di Google Maps untuk area dan kategori ini.",
    "maps.category.retail": "Ritel",
    "Retail": "Ritel",
    "maps.category.grocery": "Bahan makanan",
    "Grocery": "Bahan makanan",
    "maps.category.clothing": "Pakaian",
    "Clothing": "Pakaian",
    "maps.category.pharmacy": "Apotek",
    "Pharmacy": "Apotek",
    "maps.category.restaurant": "Restoran / kafe",
    "Restaurant / café": "Restoran / kafe",
    "maps.competition.limited": "Persaingan terdaftar terbatas",
    "Limited listed competition": "Persaingan terdaftar terbatas",
    "maps.competition.some": "Ada persaingan terdaftar",
    "Some listed competition": "Ada persaingan terdaftar",
    "maps.competition.many": "Banyak pesaing terdaftar",
    "Many listed competitors": "Banyak pesaing terdaftar",
    "maps.competition.limit_reached": "Setidaknya 20 tempat (batas hasil tercapai)",
    "At least 20 listings (result limit reached)": "Setidaknya 20 tempat (batas hasil tercapai)",
    "maps.competition.default": "Persaingan terdaftar",
    "Listed competition": "Persaingan terdaftar",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Beroperasi",
    "Operational": "Beroperasi",
    "maps.usage.title": "Penggunaan penyedia",
    "Provider usage": "Penggunaan penyedia",
    "maps.usage.description": "Jumlah permintaan yang dicatat layanan Maps. Biaya direkonsiliasi secara terpisah.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Jumlah permintaan yang dicatat layanan Maps. Biaya direkonsiliasi secara terpisah.",
    "maps.usage.days": "{count} hari",
    "{count} days": "{count} hari",
    "maps.usage.provider_requests": "Permintaan penyedia",
    "Provider requests": "Permintaan penyedia",
    "maps.usage.range_detail": "Rentang {count} hari",
    "{count} day window": "Rentang {count} hari",
    "maps.usage.successful": "Berhasil",
    "Successful": "Berhasil",
    "maps.usage.completed_calls": "Panggilan penyedia selesai",
    "Completed provider calls": "Panggilan penyedia selesai",
    "maps.usage.errors": "Kesalahan",
    "Errors": "Kesalahan",
    "maps.usage.failed_calls": "Panggilan penyedia gagal",
    "Failed provider calls": "Panggilan penyedia gagal",
    "maps.usage.metered_units": "Unit terukur",
    "Metered units": "Unit terukur",
    "maps.usage.unit_detail": "Satu unit untuk setiap permintaan tercatat",
    "One unit per recorded request": "Satu unit untuk setiap permintaan tercatat",
    "maps.usage.by_operation": "Penggunaan per operasi",
    "Usage by operation": "Penggunaan per operasi",
    "maps.usage.group_description": "Jumlah dikelompokkan menurut penyedia, operasi, dan hasil.",
    "Counts are grouped by provider, operation, and outcome.": "Jumlah dikelompokkan menurut penyedia, operasi, dan hasil.",
    "maps.usage.empty": "Tidak ada permintaan peta dalam rentang tanggal ini.",
    "No map requests in this date range.": "Tidak ada permintaan peta dalam rentang tanggal ini.",
    "maps.usage.provider": "Penyedia",
    "Provider": "Penyedia",
    "maps.usage.operation": "Operasi",
    "Operation": "Operasi",
    "maps.usage.outcome": "Hasil",
    "Outcome": "Hasil",
    "maps.usage.requests": "Permintaan",
    "Requests": "Permintaan",
    "maps.usage.units": "Unit",
    "Units": "Unit",
    "maps.settings.provider_title": "Penyedia peta",
    "Map provider": "Penyedia peta",
    "maps.settings.provider_description": "Pilih penyedia yang diizinkan oleh kebijakan privasi data Anda. Kredensial penyedia dikelola oleh Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Pilih penyedia yang diizinkan oleh kebijakan privasi data Anda. Kredensial penyedia dikelola oleh Tradly.",
    "maps.settings.selected": "Dipilih",
    "maps.settings.available": "Tersedia",
    "maps.settings.planned": "Direncanakan",
    "Planned": "Direncanakan",
    "maps.settings.origins_title": "Asal situs web yang diizinkan",
    "Allowed website origins": "Asal situs web yang diizinkan",
    "maps.settings.origins_description": "Domain tenant terdaftar diizinkan otomatis. Tambahkan alamat persis situs lain seperti staging di sini.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Domain tenant terdaftar diizinkan otomatis. Tambahkan alamat persis situs lain seperti staging di sini.",
    "maps.settings.registered_domains": "Domain terdaftar",
    "Registered domains": "Domain terdaftar",
    "maps.settings.no_domains": "Domain terdaftar tidak dimuat.",
    "No registered domains were loaded.": "Domain terdaftar tidak dimuat.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Tambahkan asal",
    "Add origin": "Tambahkan asal",
    "maps.settings.remove_origin": "Hapus",
    "maps.settings.no_origins": "Tidak ada asal tambahan.",
    "No extra origins added.": "Tidak ada asal tambahan.",
    "maps.error.session_not_ready": "Sesi admin Anda belum siap.",
    "Your admin session is not ready yet.": "Sesi admin Anda belum siap.",
    "maps.error.load_data": "Data Maps tidak dapat dimuat ({status}).",
    "Unable to load Maps data ({status}).": "Data Maps tidak dapat dimuat ({status}).",
    "maps.error.load_usage": "Penggunaan Maps tidak dapat dimuat.",
    "Unable to load Maps usage.": "Penggunaan Maps tidak dapat dimuat.",
    "maps.error.load_settings": "Pengaturan Maps tidak dapat dimuat.",
    "Unable to load Maps settings.": "Pengaturan Maps tidak dapat dimuat.",
    "maps.error.save_settings": "Pengaturan Maps tidak dapat disimpan.",
    "Unable to save Maps settings.": "Pengaturan Maps tidak dapat disimpan.",
    "maps.error.invalid_origin": "Masukkan asal lengkap, seperti https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Masukkan asal lengkap, seperti https://staging.example.com.",
    "maps.error.registered_origin": "Asal ini sudah tercakup dalam domain terdaftar.",
    "This origin is already covered by a registered domain.": "Asal ini sudah tercakup dalam domain terdaftar.",
    "maps.error.address_required": "Masukkan alamat atau wilayah untuk dipindai.",
    "Enter an address or locality to scan.": "Masukkan alamat atau wilayah untuk dipindai.",
    "maps.error.location_not_found": "Lokasi tersebut tidak ditemukan.",
    "Unable to find that location.": "Lokasi tersebut tidak ditemukan.",
    "maps.error.no_coordinates": "Koordinat untuk alamat tersebut tidak ditemukan. Coba jalan, kawasan, atau kota terdekat.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Koordinat untuk alamat tersebut tidak ditemukan. Coba jalan, kawasan, atau kota terdekat.",
    "maps.error.analyze_area": "Area ini tidak dapat dianalisis.",
    "Unable to analyze this area.": "Area ini tidak dapat dianalisis.",
    "maps.notice.settings_saved": "Pengaturan Maps disimpan.",
    "Maps settings saved.": "Pengaturan Maps disimpan.",
    "maps.status.success": "Berhasil",
    "maps.status.error": "Error",
    "maps.operation.geocode": "Geocode",
    "Geocode": "Geocode",
    "maps.operation.maps_geocode": "Geocode Maps",
    "Maps geocode": "Geocode Maps",
    "maps.operation.market_analysis": "Analisis pasar",
    "Market analysis": "Analisis pasar",
    "maps.operation.maps_market_analysis": "Analisis pasar Maps",
    "Maps market analysis": "Analisis pasar Maps",
    "maps.operation.places_search": "Pencarian tempat",
    "Places search": "Pencarian tempat",
    "maps.operation.places_nearby": "Tempat terdekat",
    "Nearby places": "Tempat terdekat",
    "maps.operation.place_details": "Detail tempat",
    "Place details": "Detail tempat",
    "common.loading": "Memuat…",
    "common.saving": "Menyimpan…",
    "common.searching": "Mencari…",
    "Searching…": "Mencari…",
    "common.no_matches": "Tidak ada hasil yang cocok.",
    "No matches found.": "Tidak ada hasil yang cocok.",
    "common.select": "Pilih…",
    "Select…": "Pilih…",
    "common.search_users": "Cari pengguna berdasarkan nama atau email",
    "Search users by name or email": "Cari pengguna berdasarkan nama atau email",
    "common.reset": "Atur ulang",
    "Reset": "Atur ulang",
    "common.validation.email": "Masukkan alamat email yang valid.",
    "Enter a valid email address.": "Masukkan alamat email yang valid.",
    "common.validation.phone": "Masukkan nomor telepon yang valid.",
    "Enter a valid phone number.": "Masukkan nomor telepon yang valid.",
    "common.validation.currency": "Gunakan kode mata uang 3 huruf, seperti USD.",
    "Use a 3-letter currency code, such as USD.": "Gunakan kode mata uang 3 huruf, seperti USD.",
    "common.validation.location": "Masukkan alamat atau lokasi yang valid.",
    "Enter a valid address or location.": "Masukkan alamat atau lokasi yang valid.",
    "common.validation.required": "{label} wajib diisi.",
    "{label} is required.": "{label} wajib diisi.",
    "common.validation.invalid": "{label} tidak valid.",
    "{label} is invalid.": "{label} tidak valid.",
    "common.status.active": "Aktif",
    "common.status.inactive": "Tidak aktif",
    "common.status.open": "Terbuka",
    "common.status.closed": "Ditutup",
    "Closed": "Ditutup",
    "common.status.posted": "Dibukukan",
    "Posted": "Dibukukan",
    "common.status.voided": "Dibatalkan",
    "Voided": "Dibatalkan",
    "common.status.draft": "Draf",
    "Draft": "Draf",
    "common.status.success": "Berhasil",
    "common.status.error": "Error",
    "accounting.title": "Akuntansi",
    "accounting.description": "Kelola akun, pemetaan, periode, jurnal, dan laporan keuangan.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Kelola akun, pemetaan, periode, jurnal, dan laporan keuangan.",
    "accounting.tab.overview": "Ringkasan",
    "Overview": "Ringkasan",
    "accounting.tab.accounts": "Bagan akun",
    "Chart of accounts": "Bagan akun",
    "accounting.tab.mappings": "Pemetaan akun",
    "Account mappings": "Pemetaan akun",
    "accounting.tab.periods": "Periode akuntansi",
    "Accounting periods": "Periode akuntansi",
    "accounting.tab.journals": "Jurnal",
    "Journals": "Jurnal",
    "accounting.tab.reports": "Laporan",
    "accounting.account.edit_title": "Edit akun",
    "Edit account": "Edit akun",
    "accounting.account.new_title": "Akun baru",
    "New account": "Akun baru",
    "accounting.account.save": "Simpan akun",
    "Save account": "Simpan akun",
    "accounting.account.create": "Buat akun",
    "Create account": "Buat akun",
    "accounting.account.code": "Kode akun",
    "Account code": "Kode akun",
    "accounting.account.name": "Nama akun",
    "Account name": "Nama akun",
    "accounting.account.type": "Jenis akun",
    "Account type": "Jenis akun",
    "accounting.account.currency_id": "ID mata uang",
    "Currency ID": "ID mata uang",
    "accounting.account.active": "Aktif",
    "accounting.account.unnamed": "Akun tanpa nama",
    "Unnamed account": "Akun tanpa nama",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Beban gaji",
    "Payroll expense": "Beban gaji",
    "accounting.type.asset": "Aset",
    "Asset": "Aset",
    "accounting.type.liability": "Liabilitas",
    "Liability": "Liabilitas",
    "accounting.type.equity": "Ekuitas",
    "Equity": "Ekuitas",
    "accounting.type.revenue": "Pendapatan",
    "Revenue": "Pendapatan",
    "accounting.type.expense": "Beban",
    "Expense": "Beban",
    "accounting.toast.account_updated": "Akun diperbarui",
    "Account updated": "Akun diperbarui",
    "accounting.toast.account_created": "Akun dibuat",
    "Account created": "Akun dibuat",
    "accounting.toast.defaults_created": "Akun default dibuat",
    "Default accounts created": "Akun default dibuat",
    "accounting.toast.mapping_saved": "Pemetaan disimpan",
    "Mapping saved": "Pemetaan disimpan",
    "accounting.toast.period_closed": "Periode akuntansi ditutup",
    "Accounting period closed": "Periode akuntansi ditutup",
    "accounting.toast.period_created": "Periode akuntansi dibuat",
    "Period created": "Periode akuntansi dibuat",
    "accounting.toast.journal_created": "Jurnal dibuat",
    "Journal created": "Jurnal dibuat",
    "accounting.toast.journal_voided": "Jurnal dibatalkan",
    "Journal voided": "Jurnal dibatalkan",
    "accounting.validation.journal_balanced": "Jurnal harus memiliki tanggal dan deskripsi serta total debit dan kredit yang seimbang.",
    "Journal must have a date, description, and balanced debit and credit totals.": "Jurnal harus memiliki tanggal dan deskripsi serta total debit dan kredit yang seimbang.",
    "accounting.filter.all_types": "Semua jenis akun",
    "All account types": "Semua jenis akun",
    "accounting.filter.all_statuses": "Semua status",
    "All statuses": "Semua status",
    "accounting.action.bootstrap": "Buat akun default",
    "Bootstrap defaults": "Buat akun default",
    "accounting.action.new_account": "Akun baru",
    "accounting.empty.accounts": "Akun tidak ditemukan.",
    "No accounts found.": "Akun tidak ditemukan.",
    "accounting.column.code": "Kode",
    "Code": "Kode",
    "accounting.column.account": "Akun",
    "accounting.column.type": "Jenis",
    "Type": "Jenis",
    "accounting.column.currency": "Mata uang",
    "accounting.column.status": "Status",
    "accounting.action.edit": "Edit",
    "accounting.mapping.edit_title": "Edit pemetaan akun",
    "Edit account mapping": "Edit pemetaan akun",
    "accounting.mapping.new_title": "Pemetaan akun baru",
    "New account mapping": "Pemetaan akun baru",
    "accounting.mapping.save": "Simpan pemetaan",
    "Save mapping": "Simpan pemetaan",
    "accounting.mapping.create": "Buat pemetaan",
    "Create mapping": "Buat pemetaan",
    "accounting.mapping.source_type": "Jenis sumber",
    "Source type": "Jenis sumber",
    "accounting.mapping.event_key": "Kunci peristiwa",
    "Event key": "Kunci peristiwa",
    "accounting.mapping.debit_account": "Akun debit",
    "Debit account": "Akun debit",
    "accounting.mapping.credit_account": "Akun kredit",
    "Credit account": "Akun kredit",
    "accounting.mapping.tax_account": "Akun pajak",
    "Tax account": "Akun pajak",
    "accounting.mapping.none": "Tidak ada",
    "None": "Tidak ada",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filter jenis sumber",
    "Filter source type": "Filter jenis sumber",
    "accounting.action.new_mapping": "Pemetaan baru",
    "New mapping": "Pemetaan baru",
    "accounting.empty.mappings": "Pemetaan akun tidak ditemukan.",
    "No account mappings found.": "Pemetaan akun tidak ditemukan.",
    "accounting.column.source": "Sumber",
    "Source": "Sumber",
    "accounting.column.event": "Peristiwa",
    "Event": "Peristiwa",
    "accounting.column.debit": "Debit",
    "Debit": "Debit",
    "accounting.column.credit": "Kredit",
    "Credit": "Kredit",
    "accounting.period.close_confirm": "Tutup {period}? Tindakan ini tidak dapat dibatalkan.",
    "Close {period}? This cannot be reversed.": "Tutup {period}? Tindakan ini tidak dapat dibatalkan.",
    "accounting.period.this": "periode akuntansi ini",
    "this accounting period": "periode akuntansi ini",
    "accounting.period.new_title": "Periode akuntansi baru",
    "New accounting period": "Periode akuntansi baru",
    "accounting.period.create": "Buat periode",
    "Create period": "Buat periode",
    "accounting.period.name": "Nama periode",
    "Period name": "Nama periode",
    "accounting.period.start": "Tanggal mulai",
    "accounting.period.end": "Tanggal akhir",
    "accounting.period.name_placeholder": "Januari 2027",
    "January 2027": "Januari 2027",
    "accounting.period.open": "Terbuka",
    "accounting.period.closed": "Ditutup",
    "accounting.action.new_period": "Periode baru",
    "New period": "Periode baru",
    "accounting.empty.periods": "Periode akuntansi tidak ditemukan.",
    "No accounting periods found.": "Periode akuntansi tidak ditemukan.",
    "accounting.column.period": "Periode",
    "accounting.column.start": "Mulai",
    "Start": "Mulai",
    "accounting.column.end": "Selesai",
    "accounting.action.close_period": "Tutup periode",
    "Close period": "Tutup periode",
    "accounting.journal.new_title": "Jurnal baru",
    "New journal": "Jurnal baru",
    "accounting.journal.balance_help": "Total debit dan kredit harus seimbang sebelum disimpan.",
    "Debits and credits must balance before saving.": "Total debit dan kredit harus seimbang sebelum disimpan.",
    "accounting.journal.close": "Tutup",
    "accounting.journal.entry_date": "Tanggal pencatatan",
    "Entry date": "Tanggal pencatatan",
    "accounting.journal.description": "Deskripsi",
    "accounting.journal.source_type": "Jenis sumber",
    "accounting.journal.source_id": "ID sumber",
    "Source ID": "ID sumber",
    "accounting.journal.account": "Akun",
    "accounting.journal.select_account": "Pilih akun",
    "Select account": "Pilih akun",
    "accounting.journal.debit_total": "Debit: {debit} · Kredit: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Debit: {debit} · Kredit: {credit} · {status}",
    "accounting.journal.balanced": "Seimbang",
    "Balanced": "Seimbang",
    "accounting.journal.unbalanced": "Tidak seimbang",
    "Unbalanced": "Tidak seimbang",
    "accounting.journal.add_line": "Tambahkan baris",
    "Add line": "Tambahkan baris",
    "accounting.journal.save": "Simpan jurnal",
    "Save journal": "Simpan jurnal",
    "accounting.journal.empty": "Tidak ada baris jurnal.",
    "No journal lines.": "Tidak ada baris jurnal.",
    "accounting.journal.reason_prompt": "Alasan pembatalan jurnal ini:",
    "Reason for voiding this journal:": "Alasan pembatalan jurnal ini:",
    "accounting.journal.details_title": "Jurnal #{id}",
    "Journal #{id}": "Jurnal #{id}",
    "accounting.action.view": "Lihat",
    "View": "Lihat",
    "accounting.action.void": "Batalkan",
    "Void": "Batalkan",
    "accounting.filter.all_accounts": "Semua akun",
    "All accounts": "Semua akun",
    "accounting.empty.journals": "Jurnal tidak ditemukan.",
    "No journals found.": "Jurnal tidak ditemukan.",
    "accounting.column.date": "Tanggal",
    "accounting.column.description": "Deskripsi",
    "accounting.column.account_source": "Sumber",
    "accounting.empty.journal_lines": "Tidak ada baris jurnal.",
    "accounting.report.trial_balance": "Neraca saldo",
    "Trial balance": "Neraca saldo",
    "accounting.report.general_ledger": "Buku besar",
    "General ledger": "Buku besar",
    "accounting.action.run_report": "Jalankan laporan",
    "Run report": "Jalankan laporan",
    "accounting.report.loading": "Memuat laporan…",
    "Loading report…": "Memuat laporan…",
    "accounting.empty.report": "Baris laporan tidak ditemukan.",
    "No report rows found.": "Baris laporan tidak ditemukan.",
    "accounting.report.choose_run": "Pilih laporan lalu jalankan.",
    "Choose a report and run it.": "Pilih laporan lalu jalankan.",
    "accounting.column.balance": "Saldo",
    "Balance": "Saldo",
    "accounting.overview.chart_title": "Bagan akun",
    "accounting.overview.chart_description": "Tentukan akun yang digunakan dalam buku besar Anda.",
    "Define the accounts used by your ledger.": "Tentukan akun yang digunakan dalam buku besar Anda.",
    "accounting.overview.journals_title": "Jurnal",
    "accounting.overview.journals_description": "Buat dan tinjau jurnal dengan debit dan kredit seimbang.",
    "Create and review balanced journal entries.": "Buat dan tinjau jurnal dengan debit dan kredit seimbang.",
    "accounting.overview.reports_title": "Laporan",
    "accounting.overview.reports_description": "Jalankan laporan neraca saldo dan buku besar.",
    "Run trial balance and general ledger reports.": "Jalankan laporan neraca saldo dan buku besar.",
    "common.refresh": "Segarkan",
    "reports.search.title": "Analitik pencarian",
    "Search analytics": "Analitik pencarian",
    "reports.search.back_to_report": "Kembali ke laporan",
    "Back to report": "Kembali ke laporan",
    "reports.search.description": "Permintaan pencarian menunjukkan apa yang dicari pengunjung dan bagian katalog yang perlu dilengkapi.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "Permintaan pencarian menunjukkan apa yang dicari pengunjung dan bagian katalog yang perlu dilengkapi.",
    "reports.search.metric.searches": "Pencarian",
    "Searches": "Pencarian",
    "reports.search.metric.unique_keywords": "Kata kunci unik",
    "Unique keywords": "Kata kunci unik",
    "reports.search.metric.with_listings": "Memiliki listing",
    "With listings": "Memiliki listing",
    "reports.search.metric.no_matches": "Tidak ada listing yang cocok",
    "No listing matches": "Tidak ada listing yang cocok",
    "reports.search.metric.coverage": "Cakupan",
    "Coverage": "Cakupan",
    "reports.search.insights.title": "Wawasan admin",
    "Admin insights": "Wawasan admin",
    "reports.search.insights.no_results_one": "Kata kunci {count} tidak menghasilkan listing. Pertimbangkan untuk membuat listing, menambahkan istilah sebagai kategori atau tag, atau memperbaiki judul dan deskripsi listing.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "Kata kunci {count} tidak menghasilkan listing. Pertimbangkan untuk membuat listing, menambahkan istilah sebagai kategori atau tag, atau memperbaiki judul dan deskripsi listing.",
    "reports.search.insights.no_results_many": "{count} kata kunci tidak menghasilkan listing. Buat listing, tambahkan istilah sebagai kategori atau tag, atau perbaiki judul dan deskripsi listing.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} kata kunci tidak menghasilkan listing. Buat listing, tambahkan istilah sebagai kategori atau tag, atau perbaiki judul dan deskripsi listing.",
    "reports.search.insights.all_covered": "Setiap kata kunci yang dilacak menghasilkan setidaknya satu listing. Tinjau istilah terpopuler untuk meningkatkan penataan produk dan penempatan kategori.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Setiap kata kunci yang dilacak menghasilkan setidaknya satu listing. Tinjau istilah terpopuler untuk meningkatkan penataan produk dan penempatan kategori.",
    "reports.search.insights.empty": "Data pencarian akan muncul setelah pengunjung mencari di marketplace.",
    "Search data will appear after visitors search the marketplace.": "Data pencarian akan muncul setelah pengunjung mencari di marketplace.",
    "reports.search.insights.total_matches": "Total {count} listing yang cocok ditemukan dari catatan pencarian yang dimuat.",
    "{count} total listing matches were returned across the loaded search records.": "Total {count} listing yang cocok ditemukan dari catatan pencarian yang dimuat.",
    "reports.search.coverage_title": "Cakupan kata kunci",
    "Keyword coverage": "Cakupan kata kunci",
    "reports.search.loading": "Memuat analitik pencarian…",
    "Loading search analytics…": "Memuat analitik pencarian…",
    "reports.search.empty": "Frasa pencarian tidak ditemukan.",
    "No search phrases found.": "Frasa pencarian tidak ditemukan.",
    "reports.search.error.load": "Analitik pencarian tidak dapat dimuat.",
    "Unable to load search analytics.": "Analitik pencarian tidak dapat dimuat.",
    "reports.search.unknown": "Pencarian tidak diketahui",
    "Unknown search": "Pencarian tidak diketahui",
    "reports.search.column.keyword": "Kata kunci",
    "Keyword": "Kata kunci",
    "reports.search.column.listings": "Listing",
    "reports.search.column.coverage": "Cakupan",
    "reports.search.column.last_searched": "Terakhir dicari",
    "Last searched": "Terakhir dicari",
    "reports.search.column.suggested_action": "Tindakan yang disarankan",
    "Suggested action": "Tindakan yang disarankan",
    "reports.search.status.covered": "Tercakup",
    "Covered": "Tercakup",
    "reports.search.status.no_matches": "Tidak ada yang cocok",
    "No matches": "Tidak ada yang cocok",
    "reports.search.action.review_ranking": "Tinjau peringkat",
    "Review ranking": "Tinjau peringkat",
    "reports.search.action.add_listing": "Tambahkan listing atau kategori",
    "Add listing or category": "Tambahkan listing atau kategori",
    "platform_health.title": "Kesehatan platform",
    "Platform health": "Kesehatan platform",
    "platform_health.tab.health": "Kesehatan",
    "Health": "Kesehatan",
    "platform_health.tab.configuration": "Konfigurasi",
    "Configuration": "Konfigurasi",
    "platform_health.action.refreshing": "Menyegarkan…",
    "Refreshing…": "Menyegarkan…",
    "platform_health.window_note": "Tampilan saat ini memuat {count} catatan pertama untuk setiap jenis peristiwa.",
    "The current view loads the first {count} records for each event type.": "Tampilan saat ini memuat {count} catatan pertama untuk setiap jenis peristiwa.",
    "platform_health.error.title": "Audit autentikasi tidak dapat dimuat",
    "Unable to load authentication audits": "Audit autentikasi tidak dapat dimuat",
    "platform_health.error.proxy_note": "API mungkin mengharuskan permintaan admin ini diteruskan melalui server, bukan dikirim langsung dari browser.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "API mungkin mengharuskan permintaan admin ini diteruskan melalui server, bukan dikirim langsung dari browser.",
    "platform_health.error.session": "Sesi admin Anda belum siap. Silakan masuk lagi.",
    "Your admin session is not ready yet. Please sign in again.": "Sesi admin Anda belum siap. Silakan masuk lagi.",
    "platform_health.error.load": "Audit autentikasi tidak dapat dimuat ({status}).",
    "Unable to load authentication audits ({status}).": "Audit autentikasi tidak dapat dimuat ({status}).",
    "platform_health.error.load_generic": "Audit kesehatan platform tidak dapat dimuat.",
    "Unable to load platform health audits.": "Audit kesehatan platform tidak dapat dimuat.",
    "platform_health.metric.login_attempts": "Percobaan login",
    "Login attempts": "Percobaan login",
    "platform_health.metric.signup_attempts": "Percobaan pendaftaran",
    "Signup attempts": "Percobaan pendaftaran",
    "platform_health.metric.audit_records": "Catatan audit",
    "Audit records": "Catatan audit",
    "platform_health.metric.successful": "Berhasil",
    "platform_health.metric.failed": "Gagal",
    "platform_health.metric.outcome_returned": "Hanya jika hasil dikembalikan",
    "Only when outcome is returned": "Hanya jika hasil dikembalikan",
    "platform_health.metric.failure_rate": "Tingkat kegagalan",
    "Failure rate": "Tingkat kegagalan",
    "platform_health.metric.classified_records": "Catatan terklasifikasi",
    "Classified records": "Catatan terklasifikasi",
    "platform_health.activity.title": "Aktivitas autentikasi",
    "Authentication activity": "Aktivitas autentikasi",
    "platform_health.activity.description": "Percobaan dalam rentang audit yang dipilih",
    "Attempts returned by the selected audit window": "Percobaan dalam rentang audit yang dipilih",
    "platform_health.activity.no_timestamps": "Tidak ada catatan audit bertimestamp yang ditemukan.",
    "No timestamped audit records returned.": "Tidak ada catatan audit bertimestamp yang ditemukan.",
    "platform_health.event.login": "Login",
    "login": "Login",
    "platform_health.event.signup": "Pendaftaran",
    "signup": "Pendaftaran",
    "platform_health.status.success": "Berhasil",
    "platform_health.status.failed": "Gagal",
    "platform_health.status.recorded": "Tercatat",
    "Recorded": "Tercatat",
    "platform_health.unknown_day": "Tidak diketahui",
    "Unknown": "Tidak diketahui",
    "platform_health.failure_reasons": "Alasan kegagalan",
    "Failure reasons": "Alasan kegagalan",
    "platform_health.no_failures": "Tidak ada kegagalan terklasifikasi yang ditemukan.",
    "No classified failures returned.": "Tidak ada kegagalan terklasifikasi yang ditemukan.",
    "platform_health.unspecified_failure": "Kegagalan tidak disebutkan",
    "Unspecified failure": "Kegagalan tidak disebutkan",
    "platform_health.recent_records": "Catatan audit terbaru",
    "Recent audit records": "Catatan audit terbaru",
    "platform_health.normalized_note": "Kolom mentah dinormalisasi hanya untuk tampilan.",
    "Raw fields are normalized only for display.": "Kolom mentah dinormalisasi hanya untuk tampilan.",
    "platform_health.loaded_count": "Dimuat: {count}",
    "platform_health.loading_records": "Memuat catatan audit…",
    "Loading audit records…": "Memuat catatan audit…",
    "platform_health.no_records": "Tidak ada catatan audit yang diterima.",
    "No audit records returned.": "Tidak ada catatan audit yang diterima.",
    "platform_health.column.event": "Peristiwa",
    "platform_health.column.status": "Status",
    "platform_health.column.user": "Pengguna",
    "User": "Pengguna",
    "platform_health.column.time": "Waktu",
    "Time": "Waktu",
    "platform_health.column.reason": "Alasan",
    "Reason": "Alasan",
    "platform_health.config.sign_in": "Metode login",
    "platform_health.config.facebook": "Autentikasi Facebook",
    "Facebook Auth": "Autentikasi Facebook",
    "platform_health.config.google": "Autentikasi Google",
    "Google Auth": "Autentikasi Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Pengaturan ini langsung berlaku. Setelah disimpan, pengaturan akan muncul di aplikasi dan respons API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Pengaturan ini langsung berlaku. Setelah disimpan, pengaturan akan muncul di aplikasi dan respons API.",
    "integrations.note.mobile_release": "Pengaturan kanal aplikasi seluler berlaku saat produk dirilis atau diperbarui. Untuk mendapatkan build baru, ajukan permintaan melalui Portal Dukungan. Ini berlaku untuk paket Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Pengaturan kanal aplikasi seluler berlaku saat produk dirilis atau diperbarui. Untuk mendapatkan build baru, ajukan permintaan melalui Portal Dukungan. Ini berlaku untuk paket Starter.",
    "integrations.toast.saved": "Pengaturan integrasi disimpan.",
    "Integration settings saved.": "Pengaturan integrasi disimpan.",
    "integrations.error.save": "Pengaturan integrasi tidak dapat disimpan.",
    "Unable to save integration settings.": "Pengaturan integrasi tidak dapat disimpan.",
    "integrations.twilio.title": "Integrasi Twilio",
    "Twilio integration": "Integrasi Twilio",
    "integrations.twilio.account_sid": "SID akun",
    "Account SID": "SID akun",
    "integrations.twilio.account_sid_placeholder": "Masukkan SID akun",
    "Enter account SID": "Masukkan SID akun",
    "integrations.twilio.auth_token": "Token autentikasi",
    "Auth token": "Token autentikasi",
    "integrations.twilio.auth_token_placeholder": "Masukkan token autentikasi",
    "Enter auth token": "Masukkan token autentikasi",
    "integrations.twilio.source_phone": "Nomor telepon sumber",
    "Source phone number": "Nomor telepon sumber",
    "integrations.twilio.source_phone_placeholder": "Masukkan nomor telepon sumber",
    "Enter source phone number": "Masukkan nomor telepon sumber",
    "integrations.facebook.title": "Autentikasi Facebook",
    "integrations.facebook.enable_login": "Aktifkan login Facebook",
    "Enable Facebook login": "Aktifkan login Facebook",
    "integrations.facebook.app_id": "ID aplikasi",
    "App ID": "ID aplikasi",
    "integrations.facebook.app_id_placeholder": "Masukkan ID aplikasi",
    "Enter app ID": "Masukkan ID aplikasi",
    "integrations.google.title": "Autentikasi Google",
    "integrations.google.enable_sign_in": "Aktifkan login Google",
    "Enable Google sign-in": "Aktifkan login Google",
    "integrations.google.client_id": "ID klien",
    "Client ID": "ID klien",
    "integrations.google.client_id_placeholder": "Masukkan ID klien",
    "Enter client ID": "Masukkan ID klien",
    "integrations.auth.title": "Metode login",
    "integrations.auth.description": "Pilih cara pengguna mendaftar dan login. Verifikasi email dan SMS menggunakan pengaturan pengiriman tenant.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Pilih cara pengguna mendaftar dan login. Verifikasi email dan SMS menggunakan pengaturan pengiriman tenant.",
    "integrations.auth.empty": "Belum ada metode login yang didukung. Pilih salah satu untuk melanjutkan.",
    "No supported sign-in method is currently configured. Select one to continue.": "Belum ada metode login yang didukung. Pilih salah satu untuk melanjutkan.",
    "integrations.auth.save_note": "Setelah disimpan, metode ini diterapkan ke endpoint pendaftaran dan login tenant. Pengguna yang dibuat langsung dikelola secara terpisah.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Setelah disimpan, metode ini diterapkan ke endpoint pendaftaran dan login tenant. Pengguna yang dibuat langsung dikelola secara terpisah.",
    "integrations.auth.error.load": "Metode login saat ini tidak dapat dimuat.",
    "Unable to load the current sign-in method.": "Metode login saat ini tidak dapat dimuat.",
    "integrations.auth.error.save": "Metode login tidak dapat disimpan.",
    "Unable to save the sign-in method.": "Metode login tidak dapat disimpan.",
    "integrations.auth.toast.saved": "Metode login disimpan.",
    "Sign-in method saved.": "Metode login disimpan.",
    "integrations.auth.email_password": "Email dan kata sandi",
    "Email and password": "Email dan kata sandi",
    "integrations.auth.email_password_help": "Pengguna memverifikasi email saat mendaftar, lalu login dengan kata sandi.",
    "Users verify their email during sign-up, then sign in with a password.": "Pengguna memverifikasi email saat mendaftar, lalu login dengan kata sandi.",
    "integrations.auth.email_code": "Kode sekali pakai melalui email",
    "Email one-time code": "Kode sekali pakai melalui email",
    "integrations.auth.email_code_help": "Pengguna menerima kode verifikasi melalui email untuk mendaftar dan login.",
    "Users receive a verification code by email for sign-up and sign-in.": "Pengguna menerima kode verifikasi melalui email untuk mendaftar dan login.",
    "integrations.auth.phone_code": "Kode sekali pakai melalui telepon",
    "Phone one-time code": "Kode sekali pakai melalui telepon",
    "integrations.auth.phone_code_help": "Pengguna menerima kode verifikasi melalui SMS untuk mendaftar dan login.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Pengguna menerima kode verifikasi melalui SMS untuk mendaftar dan login.",
    "integrations.auth.phone_password": "Telepon dan kata sandi",
    "Phone and password": "Telepon dan kata sandi",
    "integrations.auth.phone_password_help": "Pengguna memverifikasi telepon saat mendaftar, lalu login dengan kata sandi.",
    "Users verify their phone during sign-up, then sign in with a password.": "Pengguna memverifikasi telepon saat mendaftar, lalu login dengan kata sandi.",
    "integrations.auth.email_password_unverified": "Email dan kata sandi tanpa verifikasi pendaftaran",
    "Email and password without sign-up verification": "Email dan kata sandi tanpa verifikasi pendaftaran",
    "integrations.auth.email_password_unverified_help": "Pengguna dapat mendaftar dengan email dan kata sandi tanpa kode verifikasi email.",
    "Users can sign up with an email and password without an email verification code.": "Pengguna dapat mendaftar dengan email dan kata sandi tanpa kode verifikasi email.",
    "integrations.auth.phone_password_unverified": "Telepon dan kata sandi tanpa verifikasi pendaftaran",
    "Phone and password without sign-up verification": "Telepon dan kata sandi tanpa verifikasi pendaftaran",
    "integrations.auth.phone_password_unverified_help": "Pengguna dapat mendaftar dengan telepon dan kata sandi tanpa kode verifikasi SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Pengguna dapat mendaftar dengan telepon dan kata sandi tanpa kode verifikasi SMS.",
    "integrations.page.title": "Integrasi aplikasi",
    "App Integrations": "Integrasi aplikasi",
    "integrations.generic.id_placeholder": "Masukkan ID {name}",
    "Enter {name} ID": "Masukkan ID {name}",
    "integrations.generic.enable": "Aktifkan integrasi {name}",
    "Enable {name} integration": "Aktifkan integrasi {name}",
    "integrations.menu.map": "Peta",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Integrasi peta",
    "Maps integration": "Integrasi peta",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Kunci API",
    "API key": "Kunci API",
    "integrations.maps.api_key_placeholder": "Masukkan kunci API",
    "Enter API key": "Masukkan kunci API",
    "integrations.maps.reverse_geocode_key": "Kunci API geocoding terbalik Google Maps",
    "Google Maps reverse geocoding API key": "Kunci API geocoding terbalik Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Masukkan kunci API geocoding terbalik Google Maps",
    "Enter Google Maps reverse geocoding API key": "Masukkan kunci API geocoding terbalik Google Maps",
    "integrations.maps.places_key": "Kunci Places API Google Maps",
    "Google Maps Places API key": "Kunci Places API Google Maps",
    "integrations.maps.places_key_placeholder": "Masukkan kunci Places API Google Maps",
    "Enter Google Maps Places API key": "Masukkan kunci Places API Google Maps",
    "integrations.maps.nearby_accounts": "Aktifkan akun terdekat di halaman utama",
    "Activate nearby accounts on the home page": "Aktifkan akun terdekat di halaman utama",
    "integrations.maps.listing_location": "Aktifkan lokasi saat mengirim listing",
    "Activate location in listing submission": "Aktifkan lokasi saat mengirim listing",
    "integrations.maps.account_location": "Aktifkan lokasi saat membuat akun",
    "Activate location in account submission": "Aktifkan lokasi saat membuat akun",
    "integrations.playstore.title": "Integrasi Google Play",
    "Google Play integration": "Integrasi Google Play",
    "integrations.playstore.application_id": "ID aplikasi",
    "Application ID": "ID aplikasi",
    "integrations.playstore.application_id_placeholder": "Masukkan ID aplikasi (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Masukkan ID aplikasi (com.tenantname.app)",
    "integrations.playstore.first_name": "Nama depan",
    "integrations.playstore.first_name_placeholder": "Masukkan nama depan",
    "Enter first name": "Masukkan nama depan",
    "integrations.playstore.last_name": "Nama belakang",
    "integrations.playstore.last_name_placeholder": "Masukkan nama belakang",
    "Enter last name": "Masukkan nama belakang",
    "integrations.playstore.unit": "Unit organisasi",
    "Organizational unit": "Unit organisasi",
    "integrations.playstore.unit_placeholder": "Masukkan unit organisasi",
    "Enter organizational unit": "Masukkan unit organisasi",
    "integrations.playstore.organization": "Organisasi",
    "Organization": "Organisasi",
    "integrations.playstore.organization_placeholder": "Masukkan nama organisasi",
    "Enter organization name": "Masukkan nama organisasi",
    "integrations.playstore.city": "Kota atau wilayah",
    "City or locality": "Kota atau wilayah",
    "integrations.playstore.city_placeholder": "Masukkan kota atau wilayah",
    "Enter city or locality": "Masukkan kota atau wilayah",
    "integrations.playstore.state": "Provinsi",
    "State or province": "Provinsi",
    "integrations.playstore.state_placeholder": "Masukkan provinsi",
    "Enter state or province": "Masukkan provinsi",
    "integrations.playstore.country_code": "Kode negara (XX)",
    "Country code (XX)": "Kode negara (XX)",
    "integrations.playstore.country_code_placeholder": "Masukkan kode negara",
    "Enter country code": "Masukkan kode negara",
    "integrations.playstore.link": "Link Google Play",
    "Google Play link": "Link Google Play",
    "integrations.playstore.link_placeholder": "Masukkan link aplikasi Google Play Anda",
    "Enter your app Google Play link": "Masukkan link aplikasi Google Play Anda",
    "integrations.admob.title": "Integrasi AdMob",
    "AdMob integration": "Integrasi AdMob",
    "integrations.admob.app_id": "ID aplikasi",
    "integrations.admob.app_id_placeholder": "Masukkan ID aplikasi",
    "Enter App ID": "Masukkan ID aplikasi",
    "integrations.admob.unit_id": "ID unit iklan",
    "Unit ID": "ID unit iklan",
    "integrations.admob.unit_id_placeholder": "Masukkan ID unit iklan AdMob",
    "Enter AdMob unit ID": "Masukkan ID unit iklan AdMob",
    "integrations.admob.listings_id": "ID listing",
    "Listings ID": "ID listing",
    "integrations.admob.listings_id_placeholder": "Masukkan ID listing",
    "Enter listings ID": "Masukkan ID listing",
    "integrations.admob.listing_detail_id": "ID detail listing",
    "Listing detail ID": "ID detail listing",
    "integrations.admob.listing_detail_id_placeholder": "Masukkan ID detail listing",
    "Enter listing detail ID": "Masukkan ID detail listing",
    "integrations.admob.home_id": "ID halaman utama",
    "Home ID": "ID halaman utama",
    "integrations.admob.home_id_placeholder": "Masukkan ID halaman utama",
    "Enter home ID": "Masukkan ID halaman utama",
    "integrations.admob.enable_ads": "Aktifkan iklan",
    "Enable ads": "Aktifkan iklan",
    "integrations.admob.enable_listing_ads": "Aktifkan iklan di feed listing",
    "Enable ads on the listings feed": "Aktifkan iklan di feed listing",
    "integrations.admob.enable_listing_detail_ads": "Aktifkan iklan di detail listing",
    "Enable ads on listing details": "Aktifkan iklan di detail listing",
    "integrations.admob.enable_home_ads": "Aktifkan iklan di navigasi bawah halaman utama",
    "Enable ads in the home bottom navigation": "Aktifkan iklan di navigasi bawah halaman utama",
    "integrations.save_success": "Berhasil disimpan",
    "Saved successfully": "Berhasil disimpan",
    "integrations.note.release": "Pengaturan ini berlaku saat aplikasi seluler dirilis atau diperbarui. Minta build baru melalui Portal Dukungan setelah melakukan perubahan. Berlaku untuk paket Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Pengaturan ini berlaku saat aplikasi seluler dirilis atau diperbarui. Minta build baru melalui Portal Dukungan setelah melakukan perubahan. Berlaku untuk paket Starter.",
    "integrations.action.download": "Unduh",
    "integrations.branch.title": "Integrasi Branch",
    "Branch integration": "Integrasi Branch",
    "integrations.branch.app_id": "ID aplikasi",
    "integrations.branch.app_id_placeholder": "Masukkan ID aplikasi",
    "integrations.branch.live_key": "Kunci live",
    "Live key": "Kunci live",
    "integrations.branch.live_key_placeholder": "Masukkan kunci live",
    "Enter live key": "Masukkan kunci live",
    "integrations.branch.live_secret": "Secret live",
    "Live secret": "Secret live",
    "integrations.branch.live_secret_placeholder": "Masukkan secret live",
    "Enter live secret": "Masukkan secret live",
    "integrations.branch.uri_scheme": "Skema URI",
    "URI scheme": "Skema URI",
    "integrations.branch.uri_scheme_placeholder": "Masukkan skema URI",
    "Enter URI scheme": "Masukkan skema URI",
    "integrations.branch.link_domain": "Domain tautan",
    "Link domain": "Domain tautan",
    "integrations.branch.link_domain_placeholder": "Masukkan domain tautan",
    "Enter link domain": "Masukkan domain tautan",
    "integrations.branch.alternate_domain": "Domain tautan alternatif",
    "Alternate link domain": "Domain tautan alternatif",
    "integrations.branch.alternate_domain_placeholder": "Masukkan domain tautan alternatif",
    "Enter alternate link domain": "Masukkan domain tautan alternatif",
    "integrations.branch.link_description": "Deskripsi tautan",
    "Link description": "Deskripsi tautan",
    "integrations.branch.link_description_placeholder": "Masukkan deskripsi tautan",
    "Enter link description": "Masukkan deskripsi tautan",
    "integrations.branch.invite_friends": "Undang teman",
    "Invite friends": "Undang teman",
    "integrations.branch.invite_title": "Judul",
    "Title": "Judul",
    "integrations.branch.invite_description": "Deskripsi",
    "integrations.branch.destination_link": "Tautan tujuan Branch (opsional)",
    "Branch destination link (optional)": "Tautan tujuan Branch (opsional)",
    "integrations.branch.web_app_note": "Berlaku untuk pengguna aplikasi web",
    "Applies to web app users": "Berlaku untuk pengguna aplikasi web",
    "integrations.branch.destination_placeholder": "Masukkan tautan tujuan Branch",
    "Enter branch destination link": "Masukkan tautan tujuan Branch",
    "integrations.ios.title": "Penyediaan App Store",
    "App Store provisioning": "Penyediaan App Store",
    "integrations.ios.bundle_id": "ID bundel",
    "Bundle ID": "ID bundel",
    "integrations.ios.bundle_id_placeholder": "Masukkan ID bundel",
    "Enter bundle ID": "Masukkan ID bundel",
    "integrations.ios.certificate_password": "Kata sandi sertifikat distribusi",
    "Distribution certificate password": "Kata sandi sertifikat distribusi",
    "integrations.ios.certificate_password_placeholder": "Masukkan kata sandi sertifikat distribusi",
    "Enter distribution certificate password": "Masukkan kata sandi sertifikat distribusi",
    "integrations.ios.push_key_id": "ID kunci push",
    "Push key ID": "ID kunci push",
    "integrations.ios.push_key_id_placeholder": "Masukkan ID kunci push",
    "Enter push key ID": "Masukkan ID kunci push",
    "integrations.ios.team_id": "ID tim",
    "Team ID": "ID tim",
    "integrations.ios.team_id_placeholder": "Masukkan ID tim",
    "Enter team ID": "Masukkan ID tim",
    "integrations.ios.apple_id": "Apple ID",
    "Apple ID": "Apple ID",
    "integrations.ios.apple_id_placeholder": "Masukkan Apple ID",
    "Enter Apple ID": "Masukkan Apple ID",
    "integrations.ios.distribution_certificate": "Sertifikat distribusi",
    "Distribution certificate": "Sertifikat distribusi",
    "integrations.ios.provisioning_profile": "Profil penyediaan distribusi",
    "Distribution provisioning profile": "Profil penyediaan distribusi",
    "integrations.ios.push_key": "Kunci push",
    "Push key": "Kunci push",
    "integrations.ios.app_store_link": "Tautan App Store Anda",
    "Your App Store link": "Tautan App Store Anda",
    "integrations.ios.app_store_link_placeholder": "Masukkan tautan App Store aplikasi Anda",
    "Enter your app App Store link": "Masukkan tautan App Store aplikasi Anda",
    "integrations.firebase.title": "Integrasi Firebase",
    "Firebase integration": "Integrasi Firebase",
    "integrations.firebase.choose_file": "Pilih file",
    "Choose file": "Pilih file",
    "integrations.firebase.service_account": "Akun layanan Firebase",
    "Firebase service account": "Akun layanan Firebase",
    "integrations.firebase.android_json": "File JSON aplikasi Android",
    "Android app JSON file": "File JSON aplikasi Android",
    "integrations.firebase.ios_plist": "File plist aplikasi iOS",
    "iOS app plist file": "File plist aplikasi iOS",
    "integrations.firebase.create_project": "Buat project Firebase",
    "Create Firebase project": "Buat project Firebase",
    "integrations.firebase.create_android": "Buat aplikasi Android",
    "Create Android app": "Buat aplikasi Android",
    "integrations.firebase.create_ios": "Buat aplikasi iOS",
    "Create iOS app": "Buat aplikasi iOS",
    "integrations.firebase.create_database": "Buat database real-time",
    "Create realtime database": "Buat database real-time",
    "integrations.firebase.apply_rules": "Terapkan aturan database Firebase",
    "Apply Firebase database rules": "Terapkan aturan database Firebase",
    "bundles.listing_number": "Listing #{id}",
    "Listing #{id}": "Listing #{id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Konfigurasikan bundel",
    "Configure bundle": "Konfigurasikan bundel",
    "bundles.configure.subtitle": "Listing bundel #{id} · tambahkan listing yang sudah ada di bawah.",
    "Bundle listing #{id} · add existing listings below.": "Listing bundel #{id} · tambahkan listing yang sudah ada di bawah.",
    "bundles.back": "Kembali ke bundel",
    "Back to bundles": "Kembali ke bundel",
    "bundles.fixed_components": "Komponen tetap",
    "Fixed components": "Komponen tetap",
    "bundles.selection_pool": "Pilihan campuran",
    "Mix-and-match pool": "Pilihan campuran",
    "bundles.available_listings": "Listing tersedia",
    "Available listings": "Listing tersedia",
    "bundles.available_description": "Cari dan tambahkan produk yang sudah ada di katalog Anda.",
    "Search and add products already in your catalogue.": "Cari dan tambahkan produk yang sudah ada di katalog Anda.",
    "bundles.search_listings": "Cari listing",
    "Search listings": "Cari listing",
    "bundles.quantity_per_component": "Jumlah per komponen",
    "Quantity per component": "Jumlah per komponen",
    "bundles.loading_listings": "Memuat listing…",
    "Loading listings…": "Memuat listing…",
    "bundles.added": "Ditambahkan",
    "Added": "Ditambahkan",
    "bundles.adding": "Menambahkan…",
    "Adding…": "Menambahkan…",
    "bundles.add": "Tambah",
    "bundles.no_matching_listings": "Listing yang cocok tidak ditemukan.",
    "No matching listings found.": "Listing yang cocok tidak ditemukan.",
    "bundles.one_listing_added": "1 listing ditambahkan",
    "1 listing added": "1 listing ditambahkan",
    "bundles.many_listings_added": "{count} listing ditambahkan",
    "{count} listings added": "{count} listing ditambahkan",
    "bundles.quantity_short": "Jml {count}",
    "Qty {count}": "Jml {count}",
    "bundles.removing": "Menghapus…",
    "Removing…": "Menghapus…",
    "bundles.remove": "Hapus",
    "bundles.no_components": "Belum ada komponen yang ditambahkan.",
    "No components added yet.": "Belum ada komponen yang ditambahkan.",
    "bundles.pool_remove_note": "Penghapusan dari pilihan memerlukan endpoint backend; penambahan sudah tersedia.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "Penghapusan dari pilihan memerlukan endpoint backend; penambahan sudah tersedia.",
    "bundles.error.load_components": "Komponen bundel tidak dapat dimuat.",
    "Unable to load bundle components.": "Komponen bundel tidak dapat dimuat.",
    "bundles.error.add_listing": "Listing tidak dapat ditambahkan ke bundel.",
    "Unable to add listing to the bundle.": "Listing tidak dapat ditambahkan ke bundel.",
    "bundles.error.remove_component": "Komponen bundel tidak dapat dihapus.",
    "Unable to remove bundle component.": "Komponen bundel tidak dapat dihapus.",
    "bundles.error.load_listings": "Listing tidak dapat dimuat.",
    "Unable to load listings.": "Listing tidak dapat dimuat.",
    "bundles.components": "Komponen bundel",
    "Bundle components": "Komponen bundel",
    "bundles.picker_description": "Pilih listing yang sudah ada di katalog. Listing akan ditautkan setelah bundel dibuat.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Pilih listing yang sudah ada di katalog. Listing akan ditautkan setelah bundel dibuat.",
    "bundles.fixed_bundle": "Bundel tetap",
    "Fixed bundle": "Bundel tetap",
    "bundles.mix_match": "Campur dan cocokkan",
    "Mix and match": "Campur dan cocokkan",
    "bundles.quantity_per_selected": "Jumlah per listing yang dipilih",
    "Quantity per selected listing": "Jumlah per listing yang dipilih",
    "bundles.search_existing": "Cari listing yang ada",
    "Search existing listings": "Cari listing yang ada",
    "bundles.selected_count": "Dipilih ({count})",
    "Selected ({count})": "Dipilih ({count})",
    "bundles.choose_component_hint": "Pilih minimal satu listing yang ada atau buat bundel terlebih dahulu.",
    "Choose at least one existing listing, or create the bundle first.": "Pilih minimal satu listing yang ada atau buat bundel terlebih dahulu.",
    "bundles.error.attach_components": "Bundel berhasil dibuat, tetapi komponennya tidak dapat ditautkan.",
    "The bundle was created, but components could not be attached.": "Bundel berhasil dibuat, tetapi komponennya tidak dapat ditautkan.",
    "bundles.continue_configure_hint": "Anda dapat melanjutkan dari halaman konfigurasi bundel.",
    "You can continue from the bundle configuration page.": "Anda dapat melanjutkan dari halaman konfigurasi bundel.",
    "bundles.title": "Bundel",
    "bundles.create": "Buat bundel",
    "Create bundle": "Buat bundel",
    "bundles.subtitle": "Buat listing utama bundel, lalu tambahkan komponen tetap atau pilihan campuran.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Buat listing utama bundel, lalu tambahkan komponen tetap atau pilihan campuran.",
    "bundles.workflow": "Alur bundel",
    "Bundle workflow": "Alur bundel",
    "bundles.how_it_works": "Cara kerja bundel",
    "How bundles work": "Cara kerja bundel",
    "bundles.parent_description": "Satu listing induk mengontrol tampilan bundel bagi pelanggan.",
    "One parent listing controls the customer-facing bundle.": "Satu listing induk mengontrol tampilan bundel bagi pelanggan.",
    "bundles.flow": "Alur bundel",
    "Bundle flow": "Alur bundel",
    "bundles.parent_listing": "Listing induk",
    "Parent listing": "Listing induk",
    "bundles.name_price_category": "Nama, harga, kategori",
    "Name, price, category": "Nama, harga, kategori",
    "bundles.fixed_or_pool": "Item tetap atau pilihan",
    "Fixed items or a pool": "Item tetap atau pilihan",
    "bundles.checkout_stock": "Checkout dan stok",
    "Checkout stock": "Checkout dan stok",
    "bundles.selection_availability": "Pilihan dan ketersediaan",
    "Selection + availability": "Pilihan dan ketersediaan",
    "bundles.fixed_bundles": "Bundel tetap",
    "Fixed bundles": "Bundel tetap",
    "bundles.fixed_description": "Jual sekelompok listing yang sudah ada sebagai satu paket.",
    "Sell a defined group of existing listings together.": "Jual sekelompok listing yang sudah ada sebagai satu paket.",
    "bundles.fixed_detail": "Tambahkan listing yang ada sebagai komponen tetap.",
    "Add existing listings as fixed components.": "Tambahkan listing yang ada sebagai komponen tetap.",
    "bundles.pool_description": "Biarkan pelanggan memilih item yang memenuhi syarat dari pilihan bundel.",
    "Let customers choose eligible items from a bundle pool.": "Biarkan pelanggan memilih item yang memenuhi syarat dari pilihan bundel.",
    "bundles.pool_detail": "Atur jumlah pilihan minimum dan maksimum saat checkout.",
    "Set the minimum and maximum selections at checkout.": "Atur jumlah pilihan minimum dan maksimum saat checkout.",
    "channels.opensource.title": "Starter kit open source",
    "Open-source starter kits": "Starter kit open source",
    "channels.opensource.view_org": "Lihat organisasi GitHub",
    "View GitHub organization": "Lihat organisasi GitHub",
    "channels.opensource.description": "Jelajahi repositori open source dan starter kit Tradly dari organisasi TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Jelajahi repositori open source dan starter kit Tradly dari organisasi TRADLY-PLATFORM.",
    "channels.opensource.loading": "Memuat repositori…",
    "Loading repositories…": "Memuat repositori…",
    "channels.opensource.error.http": "GitHub mengembalikan {status}.",
    "GitHub returned {status}.": "GitHub mengembalikan {status}.",
    "channels.opensource.error.load": "Repositori tidak dapat dimuat. Coba lagi nanti.",
    "Unable to load repositories. Try again later.": "Repositori tidak dapat dimuat. Coba lagi nanti.",
    "channels.opensource.empty": "Repositori publik tidak ditemukan.",
    "No public repositories found.": "Repositori publik tidak ditemukan.",
    "channels.opensource.repo_fallback": "Repositori open source Tradly.",
    "Open-source Tradly repository.": "Repositori open source Tradly.",
    "channels.opensource.language_code": "Kode",
    "channels.opensource.view_repo": "Lihat repositori",
    "View repository": "Lihat repositori",
    "developer.mcp.select_all": "Pilih semua",
    "Select all": "Pilih semua",
    "developer.mcp.read": "Baca",
    "developer.mcp.write": "Tulis",
    "developer.mcp.delete": "Hapus",
    "developer.mcp.export": "Ekspor",
    "developer.mcp.copy": "Salin",
    "Copy": "Salin",
    "developer.mcp.copied": "Disalin",
    "Copied": "Disalin",
    "developer.mcp.connection_created": "Koneksi dibuat",
    "Connection created": "Koneksi dibuat",
    "developer.mcp.save_secret_warning": "Simpan secret klien sekarang—secret ini tidak akan ditampilkan lagi.",
    "Save your client secret now — it will not be shown again.": "Simpan secret klien sekarang—secret ini tidak akan ditampilkan lagi.",
    "developer.mcp.client_id": "ID klien",
    "developer.mcp.client_secret": "Secret klien",
    "developer.mcp.new_connection": "Koneksi MCP baru",
    "New MCP connection": "Koneksi MCP baru",
    "developer.mcp.platform": "Platform",
    "Platform": "Platform",
    "developer.mcp.platform_custom": "Khusus",
    "developer.mcp.connection_name": "Nama koneksi",
    "Connection name": "Nama koneksi",
    "developer.mcp.connection_name_placeholder": "mis. ChatGPT",
    "e.g. ChatGPT": "mis. ChatGPT",
    "developer.mcp.redirect_uris": "URI pengalihan",
    "Redirect URIs": "URI pengalihan",
    "developer.mcp.one_per_line": "(satu per baris)",
    "(one per line)": "(satu per baris)",
    "developer.mcp.permissions": "Izin",
    "Permissions": "Izin",
    "developer.mcp.error.connection_name": "Masukkan nama koneksi",
    "Enter a connection name": "Masukkan nama koneksi",
    "developer.mcp.error.redirect_uri": "Masukkan setidaknya satu URI pengalihan",
    "Enter at least one redirect URI": "Masukkan setidaknya satu URI pengalihan",
    "developer.mcp.error.create": "Koneksi gagal dibuat",
    "Failed to create connection": "Koneksi gagal dibuat",
    "developer.mcp.creating": "Membuat…",
    "Creating…": "Membuat…",
    "developer.mcp.edit_permissions": "Edit izin",
    "Edit permissions": "Edit izin",
    "developer.mcp.permissions_updated": "Izin diperbarui",
    "Permissions updated": "Izin diperbarui",
    "developer.mcp.error.update_permissions": "Izin tidak dapat diperbarui",
    "Failed to update permissions": "Izin tidak dapat diperbarui",
    "developer.mcp.saving": "Menyimpan…",
    "developer.mcp.error.load": "Koneksi MCP tidak dapat dimuat.",
    "MCP connections could not be loaded.": "Koneksi MCP tidak dapat dimuat.",
    "developer.mcp.confirm_delete": "Hapus koneksi ini? Koneksi akan dihapus dari daftar dan aksesnya dicabut.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Hapus koneksi ini? Koneksi akan dihapus dari daftar dan aksesnya dicabut.",
    "developer.mcp.connection_removed": "Koneksi dihapus",
    "Connection removed": "Koneksi dihapus",
    "developer.mcp.error.remove_connection": "Koneksi gagal dihapus",
    "Failed to remove connection": "Koneksi gagal dihapus",
    "developer.mcp.connection_deactivated": "Koneksi dinonaktifkan",
    "Connection deactivated": "Koneksi dinonaktifkan",
    "developer.mcp.error.deactivate_connection": "Koneksi gagal dinonaktifkan",
    "Failed to deactivate connection": "Koneksi gagal dinonaktifkan",
    "developer.mcp.title": "Koneksi MCP",
    "MCP connections": "Koneksi MCP",
    "developer.mcp.description": "Klien OAuth terdaftar tenant dan aplikasi AI yang diizinkan menggunakan server MCP tenant ini.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Klien OAuth terdaftar tenant dan aplikasi AI yang diizinkan menggunakan server MCP tenant ini.",
    "developer.mcp.empty": "Belum ada koneksi. Buat klien atau hubungkan aplikasi AI ke server MCP tenant ini.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Belum ada koneksi. Buat klien atau hubungkan aplikasi AI ke server MCP tenant ini.",
    "developer.mcp.status.connected_one": "Terhubung · 1 pengguna",
    "Connected · 1 user": "Terhubung · 1 pengguna",
    "developer.mcp.status.connected_many": "Terhubung · {count} pengguna",
    "Connected · {count} users": "Terhubung · {count} pengguna",
    "developer.mcp.status.deactivated": "Dinonaktifkan",
    "Deactivated": "Dinonaktifkan",
    "developer.mcp.status.previously_connected": "Pernah terhubung",
    "Previously connected": "Pernah terhubung",
    "developer.mcp.status.registered": "Terdaftar · belum terhubung",
    "Registered · not connected": "Terdaftar · belum terhubung",
    "developer.mcp.oauth_app": "Aplikasi OAuth",
    "OAuth app": "Aplikasi OAuth",
    "developer.mcp.created": "Dibuat",
    "developer.mcp.updated": "Diperbarui",
    "Updated": "Diperbarui",
    "developer.mcp.edit_scopes": "Edit cakupan",
    "Edit scopes": "Edit cakupan",
    "developer.mcp.edit_scopes_for": "Edit cakupan untuk {name}",
    "Edit scopes for {name}": "Edit cakupan untuk {name}",
    "developer.mcp.deactivate_hint": "Nonaktifkan (tetap ditampilkan dan dicatat)",
    "Deactivate (keeps it listed and logged)": "Nonaktifkan (tetap ditampilkan dan dicatat)",
    "developer.mcp.deactivate_named": "Nonaktifkan {name}",
    "Deactivate {name}": "Nonaktifkan {name}",
    "developer.mcp.delete_connection": "Hapus koneksi",
    "Delete connection": "Hapus koneksi",
    "developer.mcp.delete_named": "Hapus {name}",
    "Delete {name}": "Hapus {name}",
    "developer.mcp.resource.listings": "Listing",
    "developer.mcp.resource.orders": "Pesanan",
    "developer.mcp.resource.users": "Pengguna",
    "developer.mcp.resource.accounts": "Akun",
    "developer.mcp.resource.categories": "Kategori",
    "developer.mcp.resource.attributes": "Atribut",
    "developer.mcp.resource.analytics": "Analitik",
    "developer.mcp.resource.attribution": "Atribusi",
    "Attribution": "Atribusi",
    "developer.mcp.resource.rewards": "Hadiah",
    "developer.mcp.resource.layers": "Layers / CMS",
    "Layers / CMS": "Layers / CMS",
    "developer.mcp.resource.settings": "Pengaturan toko",
    "Store settings": "Pengaturan toko",
    "developer.mcp.resource.marketing": "Pemasaran",
    "developer.mcp.resource.market_research": "Riset pasar",
    "Market research": "Riset pasar",
    "developer.mcp.resource.audiences": "Audiens pemasaran",
    "Marketing audiences": "Audiens pemasaran",
    "developer.mcp.resource.agents": "Agen AI",
    "developer.mcp.resource.assets": "Unggahan file",
    "File uploads": "Unggahan file",
    "developer.mcp.resource.workforce": "Tenaga kerja",
    "developer.mcp.resource.inventory": "Inventaris",
    "developer.mcp.resource.memberships": "Keanggotaan",
    "Memberships": "Keanggotaan",
    "developer.mcp.resource.bundles": "Bundel",
    "developer.mcp.resource.rentals": "Penyewaan",
    "Rentals": "Penyewaan",
    "developer.mcp.resource.accounting": "Akuntansi",
    "developer.mcp.nav.label": "Navigasi MCP",
    "MCP navigation": "Navigasi MCP",
    "developer.mcp.nav.connections": "Koneksi",
    "Connections": "Koneksi",
    "developer.mcp.nav.logs": "Log",
    "Logs": "Log",
    "developer.mcp.unknown_provider": "Penyedia tidak diketahui",
    "Unknown provider": "Penyedia tidak diketahui",
    "developer.mcp.tenant_user": "Tenant #{tenant} · Pengguna #{user}",
    "Tenant #{tenant} · User #{user}": "Tenant #{tenant} · Pengguna #{user}",
    "developer.mcp.logs.title": "Log MCP",
    "MCP logs": "Log MCP",
    "developer.mcp.logs.heading": "Aktivitas agen terbaru",
    "Recent agent activity": "Aktivitas agen terbaru",
    "developer.mcp.logs.description": "Menampilkan peristiwa MCP tenant ini. Tampilan aktivitas diperbarui setiap 15 detik.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Menampilkan peristiwa MCP tenant ini. Tampilan aktivitas diperbarui setiap 15 detik.",
    "developer.mcp.logs.error.audit": "Log audit MCP tidak dapat dimuat.",
    "MCP audit logs could not be loaded.": "Log audit MCP tidak dapat dimuat.",
    "developer.mcp.logs.error.load": "Log MCP tidak dapat dimuat.",
    "MCP logs could not be loaded.": "Log MCP tidak dapat dimuat.",
    "developer.mcp.logs.unknown_agent": "Agen tidak diketahui",
    "Unknown agent": "Agen tidak diketahui",
    "developer.mcp.logs.all_agents": "Semua agen",
    "All agents": "Semua agen",
    "developer.mcp.logs.updated": "Diperbarui {time}",
    "Updated {time}": "Diperbarui {time}",
    "developer.mcp.logs.loading": "Memuat aktivitas MCP…",
    "Loading MCP activity…": "Memuat aktivitas MCP…",
    "developer.mcp.logs.empty": "Tidak ada peristiwa MCP terbaru untuk tenant ini.",
    "No recent MCP events found for this tenant.": "Tidak ada peristiwa MCP terbaru untuk tenant ini.",
    "developer.mcp.logs.empty_agent": "Tidak ada peristiwa MCP terbaru untuk tenant dan agen ini.",
    "No recent MCP events found for this tenant and agent.": "Tidak ada peristiwa MCP terbaru untuk tenant dan agen ini.",
    "developer.mcp.logs.time": "Waktu",
    "developer.mcp.logs.event": "Peristiwa",
    "developer.mcp.logs.tool": "Alat",
    "developer.mcp.logs.agent": "Agen",
    "Agent": "Agen",
    "developer.mcp.logs.tenant_user": "Tenant / pengguna",
    "Tenant / user": "Tenant / pengguna",
    "developer.mcp.logs.scope": "Cakupan",
    "Scope": "Cakupan",
    "developer.mcp.logs.result": "Hasil",
    "Result": "Hasil",
    "developer.mcp.logs.duration": "Durasi",
    "Duration": "Durasi",
    "developer.mcp.logs.view_details": "Lihat detail {event}",
    "View details for {event}": "Lihat detail {event}",
    "developer.mcp.logs.tenant": "Tenant #{id}",
    "Tenant #{id}": "Tenant #{id}",
    "developer.mcp.logs.user": "Pengguna #{id}",
    "User #{id}": "Pengguna #{id}",
    "developer.mcp.logs.view_granted_scopes": "Lihat cakupan yang diberikan",
    "View granted scopes": "Lihat cakupan yang diberikan",
    "developer.mcp.logs.succeeded": "Berhasil",
    "Succeeded": "Berhasil",
    "developer.mcp.logs.failed": "Gagal",
    "developer.mcp.logs.duration_ms": "{count} md",
    "{count} ms": "{count} md",
    "developer.mcp.logs.details_title": "Detail peristiwa MCP",
    "MCP event details": "Detail peristiwa MCP",
    "developer.mcp.logs.required_scope": "Cakupan yang diperlukan",
    "Required scope": "Cakupan yang diperlukan",
    "developer.mcp.logs.granted_scopes": "Cakupan yang diberikan",
    "Granted scopes": "Cakupan yang diberikan",
    "developer.mcp.logs.event_generic": "Peristiwa",
    "developer.mcp.logs.event.tool_called": "Alat dipanggil",
    "Tool called": "Alat dipanggil",
    "developer.mcp.logs.event.connection_requested": "Koneksi diminta",
    "Connection requested": "Koneksi diminta",
    "developer.mcp.logs.event.connection_connected": "Terhubung",
    "Connection connected": "Terhubung",
    "developer.mcp.logs.event.connection_deactivated": "Koneksi dinonaktifkan",
    "developer.mcp.logs.event.connection_deleted": "Koneksi dihapus",
    "Connection deleted": "Koneksi dihapus",
    "developer.mcp.logs.event.permissions_updated": "Izin diperbarui",
    "common.status.label": "Status",
    "suppliers.title": "Pemasok",
    "suppliers.search": "Cari pemasok",
    "Search suppliers": "Cari pemasok",
    "suppliers.add": "Tambah pemasok",
    "Add supplier": "Tambah pemasok",
    "suppliers.deactivate": "Nonaktifkan",
    "Deactivate": "Nonaktifkan",
    "suppliers.empty": "Pemasok tidak ditemukan.",
    "No suppliers found.": "Pemasok tidak ditemukan.",
    "suppliers.add_title": "Tambah pemasok",
    "suppliers.edit_title": "Edit pemasok",
    "Edit supplier": "Edit pemasok",
    "suppliers.save_changes": "Simpan perubahan",
    "Save changes": "Simpan perubahan",
    "suppliers.confirm_deactivate": "Nonaktifkan {name}?",
    "Deactivate {name}?": "Nonaktifkan {name}?",
    "suppliers.toast.updated": "Pemasok diperbarui",
    "Supplier updated": "Pemasok diperbarui",
    "suppliers.toast.added": "Pemasok ditambahkan",
    "Supplier added": "Pemasok ditambahkan",
    "suppliers.toast.deactivated": "Pemasok dinonaktifkan",
    "Supplier deactivated": "Pemasok dinonaktifkan",
    "suppliers.column.name": "Nama",
    "suppliers.column.code": "Kode",
    "suppliers.column.contact": "Kontak",
    "Contact": "Kontak",
    "suppliers.field.name": "Nama",
    "suppliers.field.code": "Kode",
    "suppliers.field.contact_name": "Nama kontak",
    "Contact name": "Nama kontak",
    "suppliers.field.email": "Email",
    "suppliers.field.phone": "Telepon",
    "suppliers.field.currency": "Mata uang",
    "suppliers.field.payment_terms": "Ketentuan pembayaran",
    "Payment terms": "Ketentuan pembayaran",
    "suppliers.field.address": "Alamat",
    "suppliers.field.note": "Catatan",
    "Note": "Catatan",
    "suppliers.placeholder.name": "Nama perusahaan atau pemasok",
    "Company or supplier name": "Nama perusahaan atau pemasok",
    "suppliers.placeholder.code": "Kode pemasok",
    "Supplier code": "Kode pemasok",
    "suppliers.placeholder.contact_name": "Nama kontak",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Bayar di tempat",
    "Cash on delivery": "Bayar di tempat",
    "suppliers.payment_terms.payment_on_receipt": "Bayar saat tagihan diterima",
    "Payment on receipt": "Bayar saat tagihan diterima",
    "suppliers.payment_terms.payment_in_advance": "Bayar di muka",
    "Payment in advance": "Bayar di muka",
    "suppliers.payment_terms.net_7": "Net 7 hari",
    "Net 7 days": "Net 7 hari",
    "suppliers.payment_terms.net_15": "Net 15 hari",
    "Net 15 days": "Net 15 hari",
    "suppliers.payment_terms.net_30": "Net 30 hari",
    "Net 30 days": "Net 30 hari",
    "suppliers.payment_terms.net_45": "Net 45 hari",
    "Net 45 days": "Net 45 hari",
    "suppliers.payment_terms.net_60": "Net 60 hari",
    "Net 60 days": "Net 60 hari",
    "suppliers.detail_title": "Detail pemasok",
    "Supplier details": "Detail pemasok",
    "suppliers.edit": "Edit pemasok",
    "suppliers.back": "Kembali ke pemasok",
    "Back to suppliers": "Kembali ke pemasok",
    "suppliers.loading": "Memuat pemasok…",
    "Loading supplier…": "Memuat pemasok…",
    "suppliers.unnamed": "Pemasok tanpa nama",
    "Unnamed supplier": "Pemasok tanpa nama",
    "suppliers.profile_description": "Profil dan informasi kontak pemasok",
    "Supplier profile and contact information": "Profil dan informasi kontak pemasok",
    "suppliers.total_spend": "Total belanja",
    "Total spend": "Total belanja",
    "suppliers.outstanding": "Belum dibayar",
    "Outstanding": "Belum dibayar",
    "suppliers.paid": "Dibayar",
    "suppliers.draft": "Draf",
    "suppliers.purchase_history": "Riwayat pembelian",
    "Purchase history": "Riwayat pembelian",
    "suppliers.bill.reference": "Referensi",
    "Reference": "Referensi",
    "suppliers.bill.date": "Tanggal",
    "suppliers.bill.amount": "Jumlah",
    "suppliers.bill.number": "Tagihan #{id}",
    "Bill #{id}": "Tagihan #{id}",
    "suppliers.bills_empty": "Tagihan untuk pemasok ini tidak ditemukan.",
    "No bills found for this supplier.": "Tagihan untuk pemasok ini tidak ditemukan.",
    "inventory.locations.title": "Lokasi",
    "inventory.locations.add": "Tambah lokasi",
    "Add location": "Tambah lokasi",
    "inventory.locations.description": "Gudang dan toko tempat stok disimpan. Pesanan pembelian diterima di suatu lokasi.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Gudang dan toko tempat stok disimpan. Pesanan pembelian diterima di suatu lokasi.",
    "inventory.locations.field.name": "Nama",
    "inventory.locations.field.code": "Kode",
    "inventory.locations.field.address": "Alamat",
    "inventory.locations.field.linked_store": "Toko tertaut (opsional)",
    "Linked store (optional)": "Toko tertaut (opsional)",
    "inventory.locations.field.linked_store_short": "Toko tertaut",
    "Linked store": "Toko tertaut",
    "inventory.locations.placeholder.name": "Gudang utama",
    "Main warehouse": "Gudang utama",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Cari alamat atau tempat",
    "Search an address or place": "Cari alamat atau tempat",
    "inventory.locations.placeholder.linked_store": "Cari akun penjual atau toko",
    "Search seller or store accounts": "Cari akun penjual atau toko",
    "inventory.locations.confirm_deactivate": "Nonaktifkan {name}? Lokasi ini tidak akan tersedia untuk pesanan pembelian baru.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Nonaktifkan {name}? Lokasi ini tidak akan tersedia untuk pesanan pembelian baru.",
    "inventory.locations.toast.deactivated": "Lokasi dinonaktifkan",
    "Location deactivated": "Lokasi dinonaktifkan",
    "inventory.locations.deactivate": "Nonaktifkan",
    "inventory.locations.empty": "Belum ada lokasi. Tambahkan gudang atau toko untuk mulai menerima stok.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Belum ada lokasi. Tambahkan gudang atau toko untuk mulai menerima stok.",
    "inventory.locations.edit_title": "Edit lokasi",
    "Edit location": "Edit lokasi",
    "inventory.locations.add_title": "Tambah lokasi",
    "inventory.locations.form_description": "Hubungkan akun toko hanya jika lokasi ini milik penjual tertentu.",
    "Link a store account only if this location belongs to a specific seller.": "Hubungkan akun toko hanya jika lokasi ini milik penjual tertentu.",
    "inventory.locations.save_changes": "Simpan perubahan",
    "inventory.locations.toast.updated": "Lokasi diperbarui",
    "Location updated": "Lokasi diperbarui",
    "inventory.locations.toast.added": "Lokasi ditambahkan",
    "Location added": "Lokasi ditambahkan",
    "inventory.operations.title": "Operasi inventaris",
    "Inventory operations": "Operasi inventaris",
    "inventory.operations.tab.movements": "Riwayat pergerakan",
    "Movement history": "Riwayat pergerakan",
    "inventory.operations.tab.batches": "Batch & kedaluwarsa",
    "Batches & expiry": "Batch & kedaluwarsa",
    "inventory.operations.tab.transfers": "Pesanan transfer",
    "Transfer orders": "Pesanan transfer",
    "inventory.operations.tab.requisitions": "Permintaan stok",
    "Requisitions": "Permintaan stok",
    "inventory.operations.tab.receipts": "Penerimaan barang",
    "Goods received": "Penerimaan barang",
    "inventory.operations.description.movements": "Catatan permanen setiap penerimaan, penjualan, transfer, pengembalian, dan penyesuaian.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Catatan permanen setiap penerimaan, penjualan, transfer, pengembalian, dan penyesuaian.",
    "inventory.operations.description.batches": "Lacak batch, tanggal kedaluwarsa, kondisi, dan unit tanpa mengubah catatan stok di sini.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Lacak batch, tanggal kedaluwarsa, kondisi, dan unit tanpa mengubah catatan stok di sini.",
    "inventory.operations.description.transfers": "Pindahkan stok antar lokasi dengan pelacakan status pengiriman, penerimaan, dan selisih.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Pindahkan stok antar lokasi dengan pelacakan status pengiriman, penerimaan, dan selisih.",
    "inventory.operations.description.requisitions": "Tinjau permintaan stok internal. Persetujuan akan membuat pesanan transfer secara otomatis.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Tinjau permintaan stok internal. Persetujuan akan membuat pesanan transfer secara otomatis.",
    "inventory.operations.description.receipts": "Buat penerimaan dan lacak proses penerimaan yang terbuka, sebagian, dan selesai.",
    "Create receipts and track open, partial, and closed receiving work.": "Buat penerimaan dan lacak proses penerimaan yang terbuka, sebagian, dan selesai.",
    "inventory.operations.overview": "Ringkasan",
    "inventory.operations.new_transfer": "Transfer baru",
    "New transfer": "Transfer baru",
    "inventory.operations.new_requisition": "Permintaan baru",
    "inventory.operations.new_receipt": "Penerimaan baru",
    "New receipt": "Penerimaan baru",
    "inventory.operations.search": "Cari",
    "inventory.operations.search_view": "Cari di tampilan ini",
    "Search this view": "Cari di tampilan ini",
    "inventory.operations.search_products": "Cari produk",
    "Search products": "Cari produk",
    "inventory.operations.search_purchase_order": "Cari pesanan pembelian (opsional)",
    "Search purchase orders (optional)": "Cari pesanan pembelian (opsional)",
    "inventory.operations.listing_number": "Listing #{id}",
    "inventory.operations.location_number": "Lokasi #{id}",
    "Location #{id}": "Lokasi #{id}",
    "inventory.operations.no_sku": "Tanpa SKU",
    "No SKU": "Tanpa SKU",
    "inventory.operations.order_status": "Status: {status}",
    "Status: {status}": "Status: {status}",
    "inventory.operations.field.receiving_location": "Lokasi penerimaan",
    "Receiving location": "Lokasi penerimaan",
    "inventory.operations.field.purchase_order": "Pesanan pembelian",
    "Purchase order": "Pesanan pembelian",
    "inventory.operations.field.reference": "Referensi",
    "inventory.operations.field.note": "Catatan",
    "inventory.operations.field.from_location": "Lokasi asal",
    "From location": "Lokasi asal",
    "inventory.operations.field.supplying_location": "Lokasi pemasok",
    "Supplying location": "Lokasi pemasok",
    "inventory.operations.field.to_location": "Lokasi tujuan",
    "To location": "Lokasi tujuan",
    "inventory.operations.field.requesting_location": "Lokasi peminta",
    "Requesting location": "Lokasi peminta",
    "inventory.operations.field.product": "Produk",
    "Product": "Produk",
    "inventory.operations.field.quantity": "Jumlah",
    "Quantity": "Jumlah",
    "inventory.operations.field.location": "Lokasi",
    "Location": "Lokasi",
    "inventory.operations.placeholder.delivery_note": "Surat jalan pemasok",
    "Supplier delivery note": "Surat jalan pemasok",
    "inventory.operations.placeholder.receiving_note": "Catatan penerimaan (opsional)",
    "Optional receiving note": "Catatan penerimaan (opsional)",
    "inventory.operations.placeholder.transfer_reference": "Referensi transfer",
    "Transfer reference": "Referensi transfer",
    "inventory.operations.placeholder.request_reference": "Referensi permintaan",
    "Request reference": "Referensi permintaan",
    "inventory.operations.placeholder.context": "Konteks opsional",
    "Optional context": "Konteks opsional",
    "inventory.operations.create.transfer_title": "Pesanan transfer baru",
    "New transfer order": "Pesanan transfer baru",
    "inventory.operations.create.requisition_title": "Permintaan stok baru",
    "inventory.operations.create.receipt_title": "Penerimaan barang baru",
    "New goods receipt": "Penerimaan barang baru",
    "inventory.operations.create.transfer_description": "Pindahkan stok antara dua lokasi.",
    "Move stock between two locations.": "Pindahkan stok antara dua lokasi.",
    "inventory.operations.create.requisition_description": "Minta stok dari lokasi lain.",
    "Request stock from another location.": "Minta stok dari lokasi lain.",
    "inventory.operations.create.receipt_description": "Buat penerimaan sebelum memindai atau menambahkan kotak.",
    "Create a receipt before scanning or adding boxes.": "Buat penerimaan sebelum memindai atau menambahkan kotak.",
    "inventory.operations.toast.transfer_created": "Pesanan transfer dibuat",
    "Transfer order created": "Pesanan transfer dibuat",
    "inventory.operations.toast.requisition_created": "Permintaan dibuat",
    "Requisition created": "Permintaan dibuat",
    "inventory.operations.toast.receipt_created": "Penerimaan barang dibuat",
    "Goods receipt created": "Penerimaan barang dibuat",
    "inventory.operations.toast.transfer_dispatched": "Transfer dikirim",
    "Transfer dispatched": "Transfer dikirim",
    "inventory.operations.toast.transfer_received": "Transfer diterima",
    "Transfer received": "Transfer diterima",
    "inventory.operations.toast.transfer_cancelled": "Transfer dibatalkan",
    "Transfer cancelled": "Transfer dibatalkan",
    "inventory.operations.toast.requisition_approved": "Permintaan disetujui",
    "Requisition approved": "Permintaan disetujui",
    "inventory.operations.toast.requisition_rejected": "Permintaan ditolak",
    "Requisition rejected": "Permintaan ditolak",
    "inventory.operations.action.dispatch": "Kirim",
    "Dispatch": "Kirim",
    "inventory.operations.action.receive": "Terima",
    "Receive": "Terima",
    "inventory.operations.action.approve": "Setujui",
    "Approve": "Setujui",
    "inventory.operations.action.reject": "Tolak",
    "Reject": "Tolak",
    "inventory.operations.column.when": "Waktu",
    "When": "Waktu",
    "inventory.operations.column.event": "Peristiwa",
    "inventory.operations.column.change": "Perubahan",
    "inventory.operations.column.after": "Setelah",
    "After": "Setelah",
    "inventory.operations.column.order": "Pesanan",
    "inventory.operations.column.route": "Rute",
    "Route": "Rute",
    "inventory.operations.column.lines": "Baris",
    "Lines": "Baris",
    "inventory.operations.column.expected": "Diharapkan",
    "inventory.operations.column.request": "Permintaan",
    "Request": "Permintaan",
    "inventory.operations.column.request_supply": "Permintaan / pasokan",
    "Request / supply": "Permintaan / pasokan",
    "inventory.operations.column.created": "Dibuat",
    "inventory.operations.column.receipt": "Penerimaan",
    "Receipt": "Penerimaan",
    "inventory.operations.empty.movements": "Belum ada pergerakan stok.",
    "No stock movements recorded yet.": "Belum ada pergerakan stok.",
    "inventory.operations.empty.batches": "Belum ada batch inventaris yang dicatat.",
    "No inventory batches have been recorded yet.": "Belum ada batch inventaris yang dicatat.",
    "inventory.operations.empty.transfers": "Belum ada pesanan transfer.",
    "No transfer orders yet.": "Belum ada pesanan transfer.",
    "inventory.operations.empty.requisitions": "Belum ada permintaan stok.",
    "No requisitions yet.": "Belum ada permintaan stok.",
    "inventory.operations.empty.receipts": "Belum ada penerimaan barang.",
    "No goods receipts yet.": "Belum ada penerimaan barang.",
    "inventory.operations.batch.edit_title": "Edit batch",
    "Edit batch": "Edit batch",
    "inventory.operations.batch.edit_description": "Jumlah batch diubah melalui penyesuaian stok; formulir ini hanya memperbarui identitas dan data pelacakan.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "Jumlah batch diubah melalui penyesuaian stok; formulir ini hanya memperbarui identitas dan data pelacakan.",
    "inventory.operations.batch.save": "Simpan batch",
    "Save batch": "Simpan batch",
    "inventory.operations.batch.lot_number": "Nomor batch",
    "Lot number": "Nomor batch",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Tanggal kedaluwarsa",
    "inventory.operations.batch.condition": "Kondisi",
    "Condition": "Kondisi",
    "inventory.operations.batch.condition_placeholder": "baik",
    "good": "baik",
    "inventory.operations.batch.unit": "Satuan",
    "Unit of measure": "Satuan",
    "inventory.operations.batch.unit_placeholder": "kotak, buah, kg",
    "box, piece, kg": "kotak, buah, kg",
    "inventory.operations.batch.no_expiry": "Tanpa kedaluwarsa",
    "No expiry": "Tanpa kedaluwarsa",
    "inventory.operations.batch.updated": "Batch diperbarui",
    "Batch updated": "Batch diperbarui",
    "common.status.in_transit": "Dalam perjalanan",
    "In transit": "Dalam perjalanan",
    "common.status.pending": "Menunggu",
    "Pending": "Menunggu",
    "common.status.approved": "Disetujui",
    "Approved": "Disetujui",
    "common.status.rejected": "Ditolak",
    "Rejected": "Ditolak",
    "common.status.cancelled": "Dibatalkan",
    "Cancelled": "Dibatalkan",
    "common.status.received": "Diterima",
    "Received": "Diterima",
    "common.status.sent": "Dikirim",
    "Sent": "Dikirim",
    "common.note": "Catatan",
    "common.optional": "Opsional",
    "Optional": "Opsional",
    "common.error.generic": "Terjadi kesalahan.",
    "Something went wrong.": "Terjadi kesalahan.",
    "purchase_orders.title": "Pesanan pembelian",
    "purchase_orders.title_singular": "Pesanan pembelian",
    "purchase_orders.tab.all": "Semua",
    "purchase_orders.tab.partial": "Diterima sebagian",
    "Partially received": "Diterima sebagian",
    "purchase_orders.create.new": "Pesanan pembelian baru",
    "New purchase order": "Pesanan pembelian baru",
    "purchase_orders.create.title": "Pesanan pembelian baru",
    "purchase_orders.create.subtitle": "Disimpan sebagai draf. Tandai sebagai terkirim setelah dikirim ke pemasok.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Disimpan sebagai draf. Tandai sebagai terkirim setelah dikirim ke pemasok.",
    "purchase_orders.create.submit": "Buat draf",
    "Create draft": "Buat draf",
    "purchase_orders.field.location": "Lokasi penerimaan",
    "purchase_orders.field.supplier": "Pemasok",
    "Supplier": "Pemasok",
    "purchase_orders.field.reference": "Referensi pemasok",
    "Supplier reference": "Referensi pemasok",
    "purchase_orders.field.expected_delivery": "Perkiraan pengiriman",
    "Expected delivery": "Perkiraan pengiriman",
    "purchase_orders.field.products": "Produk",
    "Products": "Produk",
    "purchase_orders.select_location": "Pilih lokasi",
    "Select location": "Pilih lokasi",
    "purchase_orders.no_locations": "Belum ada lokasi",
    "No locations set up": "Belum ada lokasi",
    "purchase_orders.add_location": "Tambahkan lokasi terlebih dahulu →",
    "Add a location first →": "Tambahkan lokasi terlebih dahulu →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Semua lokasi",
    "All locations": "Semua lokasi",
    "purchase_orders.location_number": "Lokasi #{id}",
    "purchase_orders.search_products": "Cari produk untuk ditambahkan",
    "Search products to add": "Cari produk untuk ditambahkan",
    "purchase_orders.in_stock": "Stok: {count}",
    "In stock: {count}": "Stok: {count}",
    "purchase_orders.column.order": "Pesanan",
    "purchase_orders.column.product": "Produk",
    "purchase_orders.column.quantity": "Jumlah",
    "purchase_orders.column.ordered": "Dipesan",
    "Ordered": "Dipesan",
    "purchase_orders.column.received": "Diterima",
    "purchase_orders.column.remaining": "Sisa",
    "purchase_orders.column.unit_cost": "Biaya per unit",
    "Unit cost": "Biaya per unit",
    "purchase_orders.column.supplier": "Pemasok",
    "purchase_orders.column.location": "Lokasi",
    "purchase_orders.column.progress": "Diterima",
    "purchase_orders.column.value": "Nilai",
    "purchase_orders.column.expected": "Perkiraan",
    "purchase_orders.column.status": "Status",
    "purchase_orders.action.mark_sent": "Tandai sebagai terkirim",
    "Mark as sent": "Tandai sebagai terkirim",
    "purchase_orders.action.receive": "Terima",
    "purchase_orders.action.receive_stock": "Terima stok",
    "Receive stock": "Terima stok",
    "purchase_orders.action.cancel_order": "Batalkan pesanan",
    "Cancel order": "Batalkan pesanan",
    "purchase_orders.action.close_order": "Tutup pesanan",
    "Close order": "Tutup pesanan",
    "purchase_orders.receive.subtitle": "Masukkan barang yang tiba. Stok di lokasi penerimaan akan diperbarui setelah dikonfirmasi.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Masukkan barang yang tiba. Stok di lokasi penerimaan akan diperbarui setelah dikonfirmasi.",
    "purchase_orders.receive.now": "Terima sekarang",
    "Receive now": "Terima sekarang",
    "purchase_orders.receive.confirm": "Konfirmasi penerimaan",
    "Confirm receipt": "Konfirmasi penerimaan",
    "purchase_orders.confirm.cancel": "Batalkan pesanan pembelian ini?",
    "Cancel this purchase order?": "Batalkan pesanan pembelian ini?",
    "purchase_orders.empty.all": "Belum ada pesanan pembelian. Buat pesanan untuk mengisi kembali stok.",
    "No purchase orders yet. Create one to restock inventory.": "Belum ada pesanan pembelian. Buat pesanan untuk mengisi kembali stok.",
    "purchase_orders.empty.filtered": "Tidak ada pesanan pembelian dengan status ini.",
    "No purchase orders with this status.": "Tidak ada pesanan pembelian dengan status ini.",
    "purchase_orders.error.location_required": "Pilih lokasi penerimaan.",
    "Choose a receiving location.": "Pilih lokasi penerimaan.",
    "purchase_orders.error.product_required": "Tambahkan setidaknya satu produk.",
    "Add at least one product.": "Tambahkan setidaknya satu produk.",
    "purchase_orders.error.quantity_positive": "Setiap jumlah harus lebih dari 0.",
    "Every quantity must be greater than 0.": "Setiap jumlah harus lebih dari 0.",
    "purchase_orders.error.receive_quantity": "Masukkan jumlah untuk setidaknya satu item.",
    "Enter a quantity for at least one item.": "Masukkan jumlah untuk setidaknya satu item.",
    "purchase_orders.toast.created": "Pesanan pembelian dibuat sebagai draf",
    "Purchase order created as draft": "Pesanan pembelian dibuat sebagai draf",
    "purchase_orders.toast.sent": "Ditandai sebagai terkirim",
    "Marked as sent": "Ditandai sebagai terkirim",
    "purchase_orders.toast.received": "Stok diterima dan inventaris diperbarui",
    "Stock received and inventory updated": "Stok diterima dan inventaris diperbarui",
    "purchase_orders.toast.cancelled": "Pesanan pembelian dibatalkan",
    "Purchase order cancelled": "Pesanan pembelian dibatalkan",
    "purchase_orders.toast.closed": "Pesanan pembelian ditutup",
    "Purchase order closed": "Pesanan pembelian ditutup",
    "schedule.title": "Jadwal",
    "schedule.view.month": "Bulan",
    "Month": "Bulan",
    "schedule.view.week": "Minggu",
    "Week": "Minggu",
    "schedule.view.day": "Hari",
    "Day": "Hari",
    "schedule.today": "Hari ini",
    "Today": "Hari ini",
    "schedule.order_number": "Pesanan #{number}",
    "Order #{number}": "Pesanan #{number}",
    "schedule.customer": "Pelanggan",
    "schedule.more_events": "+{count} lainnya",
    "+{count} more": "+{count} lainnya",
    "schedule.payment.paid": "Dibayar",
    "schedule.payment.pending": "Menunggu",
    "schedule.payment.failed": "Gagal",
    "schedule.booking_details": "Detail pemesanan",
    "Booking details": "Detail pemesanan",
    "schedule.order_reference": "Referensi pesanan",
    "schedule.amount": "Jumlah",
    "schedule.start": "Mulai",
    "schedule.end": "Selesai",
    "schedule.item_number": "Item {number}",
    "Item {number}": "Item {number}",
    "schedule.view_order": "Lihat pesanan lengkap",
    "View full order": "Lihat pesanan lengkap",
    "onboarding.greeting.morning": "Selamat pagi",
    "Good morning": "Selamat pagi",
    "onboarding.greeting.morning_named": "Selamat pagi, {name}",
    "Good morning {name}": "Selamat pagi, {name}",
    "onboarding.greeting.afternoon": "Selamat siang",
    "Good afternoon": "Selamat siang",
    "onboarding.greeting.afternoon_named": "Selamat siang, {name}",
    "Good afternoon {name}": "Selamat siang, {name}",
    "onboarding.greeting.evening": "Selamat sore",
    "Good evening": "Selamat sore",
    "onboarding.greeting.evening_named": "Selamat sore, {name}",
    "Good evening {name}": "Selamat sore, {name}",
    "onboarding.greeting.night": "Halo",
    "Hello": "Halo",
    "onboarding.greeting.night_named": "Halo, {name}",
    "Hello {name}": "Halo, {name}",
    "onboarding.encouragement": "Bangun platform yang Anda harapkan ada.",
    "Build the platform you wish existed.": "Bangun platform yang Anda harapkan ada.",
    "onboarding.plan.personalized": "Rencana peluncuran yang dipersonalisasi",
    "Personalized launch plan": "Rencana peluncuran yang dipersonalisasi",
    "onboarding.plan.label": "Rencana peluncuran",
    "Launch plan": "Rencana peluncuran",
    "onboarding.plan.refining": "Menyempurnakan rencana Anda…",
    "Refining your path…": "Menyempurnakan rencana Anda…",
    "onboarding.plan.getting_ready": "Rencana personal Anda sedang disiapkan.",
    "Your personalized plan is getting ready.": "Rencana personal Anda sedang disiapkan.",
    "onboarding.checklist.preview": "Pratinjau daftar periksa",
    "Checklist preview": "Pratinjau daftar periksa",
    "onboarding.workspace.live": "Workspace aktif",
    "Live workspace": "Workspace aktif",
    "onboarding.workspace.no_tenant": "Tidak ada tenant aktif yang terhubung",
    "No live tenant connected": "Tidak ada tenant aktif yang terhubung",
    "onboarding.workspace.domain_pending": "Domain tertunda",
    "Domain pending": "Domain tertunda",
    "onboarding.progress.summary": "{completed} dari {total} langkah peluncuran selesai",
    "{completed} of {total} launch actions done": "{completed} dari {total} langkah peluncuran selesai",
    "onboarding.progress.auto_detected": "Terdeteksi otomatis: {count}",
    "{count} auto-detected": "Terdeteksi otomatis: {count}",
    "onboarding.progress.auto_detected_short": "Terdeteksi otomatis",
    "Auto-detected": "Terdeteksi otomatis",
    "onboarding.progress.saving": "Menyimpan progres…",
    "Saving progress…": "Menyimpan progres…",
    "onboarding.progress.checking": "Memeriksa…",
    "Checking…": "Memeriksa…",
    "onboarding.progress.mark_done": "Tandai selesai",
    "Mark done": "Tandai selesai",
    "onboarding.progress.unlocked": "Terbuka: {impact}",
    "Unlocked: {impact}": "Terbuka: {impact}",
    "onboarding.next_task": "Tugas terbaik berikutnya",
    "Next best task": "Tugas terbaik berikutnya",
    "onboarding.upcoming.title": "Tugas mendatang",
    "Upcoming tasks": "Tugas mendatang",
    "onboarding.upcoming.summary_one": "{count} tugas berikutnya dalam antrean setelah tindakan ini.",
    "{count} task queued after the current action.": "{count} tugas berikutnya dalam antrean setelah tindakan ini.",
    "onboarding.upcoming.summary_other": "{count} tugas berikutnya dalam antrean setelah tindakan ini.",
    "{count} tasks queued after the current action.": "{count} tugas berikutnya dalam antrean setelah tindakan ini.",
    "onboarding.upcoming.hide": "Sembunyikan tugas",
    "Hide tasks": "Sembunyikan tugas",
    "onboarding.upcoming.view_all": "Lihat semua tugas",
    "View all tasks": "Lihat semua tugas",
    "onboarding.complete.title": "Awal yang baik. Fondasi platform Anda sudah aktif.",
    "Great start. Your foundation is live.": "Awal yang baik. Fondasi platform Anda sudah aktif.",
    "onboarding.complete.description": "Lanjutkan untuk membuka fitur pertumbuhan seperti promosi dan komunikasi.",
    "Keep going to unlock growth essentials like promotions and communications.": "Lanjutkan untuk membuka fitur pertumbuhan seperti promosi dan komunikasi.",
    "onboarding.full_checklist.title": "Daftar periksa lengkap",
    "Full checklist": "Daftar periksa lengkap",
    "onboarding.full_checklist.description": "Lanjutkan penyiapan di pengalaman yang sama.",
    "Continue setup in the same experience.": "Lanjutkan penyiapan di pengalaman yang sama.",
    "onboarding.full_checklist.back": "Kembali ke alur peluncuran",
    "Back to launch path": "Kembali ke alur peluncuran",
    "onboarding.completed.title": "Selesai",
    "onboarding.completed.summary_one": "{count} tugas selesai",
    "{count} task completed": "{count} tugas selesai",
    "onboarding.completed.summary_other": "{count} tugas selesai",
    "{count} tasks completed": "{count} tugas selesai",
    "onboarding.completed.open_again": "Buka lagi",
    "Open again": "Buka lagi",
    "onboarding.plan.marketplace.eyebrow": "Alur peluncuran marketplace",
    "Marketplace launch path": "Alur peluncuran marketplace",
    "onboarding.plan.marketplace.title": "Luncurkan marketplace Anda",
    "Launch your marketplace": "Luncurkan marketplace Anda",
    "onboarding.plan.marketplace.title_named": "Ubah {project} menjadi marketplace yang berfungsi",
    "Turn {project} into a working marketplace": "Ubah {project} menjadi marketplace yang berfungsi",
    "onboarding.plan.marketplace.subtitle": "Buka situs aktif, buat listing pertama, dan uji perjalanan pembeli.",
    "Open the live site create the first listing and test the buyer journey.": "Buka situs aktif, buat listing pertama, dan uji perjalanan pembeli.",
    "onboarding.plan.marketplace.value_moment": "Momen nilai pertama: penjual dapat menerbitkan produk dan pembeli dapat bertindak.",
    "First value moment: a seller can publish and a buyer can act.": "Momen nilai pertama: penjual dapat menerbitkan produk dan pembeli dapat bertindak.",
    "onboarding.plan.marketplace.why_title": "Mengapa tim menyelesaikan ini",
    "Why teams finish this": "Mengapa tim menyelesaikan ini",
    "onboarding.plan.marketplace.why_body": "Hasil nyata bagi pembeli dan penjual membuat setiap langkah berikutnya berguna dan menjaga momentum.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Hasil nyata bagi pembeli dan penjual membuat setiap langkah berikutnya berguna dan menjaga momentum.",
    "onboarding.plan.store.eyebrow": "Alur peluncuran toko",
    "Store launch path": "Alur peluncuran toko",
    "onboarding.plan.store.title": "Siapkan toko untuk pesanan pertama",
    "Get your store ready for the first order": "Siapkan toko untuk pesanan pertama",
    "onboarding.plan.store.title_named": "Siapkan {project} untuk pesanan pertama",
    "Make {project} ready for the first order": "Siapkan {project} untuk pesanan pertama",
    "onboarding.plan.store.subtitle": "Tambahkan produk, periksa etalase, dan lengkapi pembayaran.",
    "Add a product check the storefront and complete checkout essentials.": "Tambahkan produk, periksa etalase, dan lengkapi pembayaran.",
    "onboarding.plan.store.value_moment": "Momen nilai pertama: produk terlihat dan pembayaran dapat diuji.",
    "First value moment: a product is visible and checkout can be tested.": "Momen nilai pertama: produk terlihat dan pembayaran dapat diuji.",
    "onboarding.plan.store.why_title": "Mengapa tim menyelesaikan ini",
    "onboarding.plan.store.why_body": "Beralih cepat dari produk ke pembayaran membuat toko terasa nyata dan menjaga motivasi.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Beralih cepat dari produk ke pembayaran membuat toko terasa nyata dan menjaga motivasi.",
    "onboarding.plan.booking.eyebrow": "Alur peluncuran pemesanan",
    "Booking launch path": "Alur peluncuran pemesanan",
    "onboarding.plan.booking.title": "Siapkan platform agar dapat dipesan",
    "Make your platform bookable": "Siapkan platform agar dapat dipesan",
    "onboarding.plan.booking.title_named": "Siapkan {project} agar dapat dipesan",
    "Make {project} bookable": "Siapkan {project} agar dapat dipesan",
    "onboarding.plan.booking.subtitle": "Buat layanan pertama, buka pengalaman pelanggan, dan uji pemesanan.",
    "Create the first service open the customer experience and test a reservation.": "Buat layanan pertama, buka pengalaman pelanggan, dan uji pemesanan.",
    "onboarding.plan.booking.value_moment": "Momen nilai pertama: pelanggan dapat meminta waktu atau slot.",
    "First value moment: a customer can request a time or slot.": "Momen nilai pertama: pelanggan dapat meminta waktu atau slot.",
    "onboarding.plan.booking.why_title": "Mengapa tim menyelesaikan ini",
    "onboarding.plan.booking.why_body": "Validasi seluruh alur pemesanan sejak awal agar lebih yakin sebelum berkembang.",
    "Validate the full booking journey early to build confidence before expanding.": "Validasi seluruh alur pemesanan sejak awal agar lebih yakin sebelum berkembang.",
    "onboarding.plan.digital.eyebrow": "Alur peluncuran produk digital",
    "Digital launch path": "Alur peluncuran produk digital",
    "onboarding.plan.digital.title": "Mulai jual produk digital",
    "Start selling your digital products": "Mulai jual produk digital",
    "onboarding.plan.digital.title_named": "Siapkan {project} untuk menjual produk digital",
    "Make {project} ready to sell digital products": "Siapkan {project} untuk menjual produk digital",
    "onboarding.plan.digital.subtitle": "Unggah produk digital, pratinjau alur pelanggan, dan pastikan pembayaran siap.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Unggah produk digital, pratinjau alur pelanggan, dan pastikan pembayaran siap.",
    "onboarding.plan.digital.value_moment": "Momen nilai pertama: pembeli dapat menemukan dan membeli file.",
    "First value moment: a buyer can discover and purchase a file.": "Momen nilai pertama: pembeli dapat menemukan dan membeli file.",
    "onboarding.plan.digital.why_title": "Mengapa tim menyelesaikan ini",
    "onboarding.plan.digital.why_body": "Buktikan penemuan dan pembelian dengan cepat agar penambahan katalog terasa seperti pertumbuhan.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Buktikan penemuan dan pembelian dengan cepat agar penambahan katalog terasa seperti pertumbuhan.",
    "onboarding.plan.campaign.eyebrow": "Alur peluncuran kampanye",
    "Campaign launch path": "Alur peluncuran kampanye",
    "onboarding.plan.campaign.title": "Luncurkan platform kampanye",
    "Launch your campaign platform": "Luncurkan platform kampanye",
    "onboarding.plan.campaign.title_named": "Siapkan {project} untuk para pendukung",
    "Make {project} ready for supporters": "Siapkan {project} untuk para pendukung",
    "onboarding.plan.campaign.subtitle": "Buat kampanye, pratinjau halaman publik, dan uji proses kontribusi.",
    "Create a campaign preview the public page and test the contribution journey.": "Buat kampanye, pratinjau halaman publik, dan uji proses kontribusi.",
    "onboarding.plan.campaign.value_moment": "Momen nilai pertama: pendukung memahami kampanye dan dapat berkontribusi.",
    "First value moment: a supporter can understand and contribute.": "Momen nilai pertama: pendukung memahami kampanye dan dapat berkontribusi.",
    "onboarding.plan.campaign.why_title": "Mengapa tim menyelesaikan ini",
    "onboarding.plan.campaign.why_body": "Jelaskan cerita dan alur kontribusi sejak awal agar pendukung yakin dan mau bertindak.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Jelaskan cerita dan alur kontribusi sejak awal agar pendukung yakin dan mau bertindak.",
    "onboarding.plan.creator.eyebrow": "Alur peluncuran kreator",
    "Creator launch path": "Alur peluncuran kreator",
    "onboarding.plan.creator.title": "Bersiap untuk audiens pertama",
    "Get ready for your first audience": "Bersiap untuk audiens pertama",
    "onboarding.plan.creator.title_named": "Siapkan {project} untuk audiens pertamanya",
    "Make {project} ready for its first audience": "Siapkan {project} untuk audiens pertamanya",
    "onboarding.plan.creator.subtitle": "Terbitkan penawaran yang jelas, bentuk pengalaman, dan mudahkan orang menemukan serta mendukung karya Anda.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Terbitkan penawaran yang jelas, bentuk pengalaman, dan mudahkan orang menemukan serta mendukung karya Anda.",
    "onboarding.plan.creator.value_moment": "Momen nilai pertama: karya Anda terlihat dan siap dibagikan.",
    "First value moment: your work is visible and ready to share.": "Momen nilai pertama: karya Anda terlihat dan siap dibagikan.",
    "onboarding.plan.creator.why_title": "Mengapa ini berhasil",
    "Why this works": "Mengapa ini berhasil",
    "onboarding.plan.creator.why_body": "Fokus menerbitkan sesuatu yang nyata sebelum menambahkan alat atau kerumitan.",
    "Focus on publishing something real before adding more tools or complexity.": "Fokus menerbitkan sesuatu yang nyata sebelum menambahkan alat atau kerumitan.",
    "onboarding.step.open_live_site.title": "Buka situs aktif",
    "Open the live experience": "Buka situs aktif",
    "onboarding.step.open_live_site.description": "Mulai dari tampilan pelanggan. Ini membuat produk terasa nyata sebelum penyiapan menjadi abstrak.",
    "onboarding.step.open_live_site.description_domain": "Apri {domain} e guarda ciò che vedono i clienti. Così il progetto diventa concreto prima del passaggio successivo.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Apri {domain} e guarda ciò che vedono i clienti. Così il progetto diventa concreto prima del passaggio successivo.",
    "onboarding.step.open_live_site.cta": "Buka situs",
    "Open site": "Buka situs",
    "onboarding.step.open_live_site.cta_domain": "Buka {domain}",
    "Open {domain}": "Buka {domain}",
    "onboarding.step.open_live_site.impact": "Memastikan proyek sudah aktif.",
    "Confirms the project is already live.": "Memastikan proyek sudah aktif.",
    "onboarding.step.create_supply_shape.title": "Buat kategori pertama",
    "Create the first category": "Buat kategori pertama",
    "onboarding.step.create_supply_shape.description": "Sediakan titik awal yang jelas bagi penjual dan pembeli. Kategori membantu penemuan.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Sediakan titik awal yang jelas bagi penjual dan pembeli. Kategori membantu penemuan.",
    "onboarding.step.create_supply_shape.cta": "Tambah kategori",
    "Add category": "Tambah kategori",
    "onboarding.step.create_supply_shape.impact": "Mengubah marketplace kosong menjadi katalog yang dapat dijelajahi.",
    "Turns a blank marketplace into a browsable one.": "Mengubah marketplace kosong menjadi katalog yang dapat dijelajahi.",
    "onboarding.step.post_first_listing.title": "Terbitkan listing uji coba",
    "Post one test listing": "Terbitkan listing uji coba",
    "onboarding.step.post_first_listing.description": "Coba alur penjual dan terbitkan produk pertama yang dapat dilihat pembeli.",
    "Experience the seller path and publish the first item buyers can inspect.": "Coba alur penjual dan terbitkan produk pertama yang dapat dilihat pembeli.",
    "onboarding.step.post_first_listing.cta": "Terbitkan listing",
    "Post listing": "Terbitkan listing",
    "onboarding.step.post_first_listing.impact": "Menciptakan pasokan, langkah utama aktivasi marketplace.",
    "Creates supply the core marketplace activation event.": "Menciptakan pasokan, langkah utama aktivasi marketplace.",
    "onboarding.step.test_buyer_action.title": "Coba sebagai pembeli",
    "Act like a buyer": "Coba sebagai pembeli",
    "onboarding.step.test_buyer_action.description": "Jelajahi, tunjukkan minat, dan uji pesanan untuk melihat pengalaman pelanggan.",
    "Browse add interest and test the order path to experience what customers will see.": "Jelajahi, tunjukkan minat, dan uji pesanan untuk melihat pengalaman pelanggan.",
    "onboarding.step.test_buyer_action.cta": "Uji alur pembeli",
    "Test buyer flow": "Uji alur pembeli",
    "onboarding.step.test_buyer_action.impact": "Memvalidasi seluruh alur pembeli.",
    "Validates the buyer journey end to end.": "Memvalidasi seluruh alur pembeli.",
    "onboarding.step.add_first_product.title": "Tambahkan produk nyata",
    "Add one real product": "Tambahkan produk nyata",
    "onboarding.step.add_first_product.description": "Satu produk lengkap membantu sistem memahami katalog lebih baik daripada tur pengaturan yang panjang.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Satu produk lengkap membantu sistem memahami katalog lebih baik daripada tur pengaturan yang panjang.",
    "onboarding.step.add_first_product.cta": "Tambah produk",
    "Add product": "Tambah produk",
    "onboarding.step.add_first_product.impact": "Membuat item pertama yang siap dijual.",
    "Creates the first sellable item.": "Membuat item pertama yang siap dijual.",
    "onboarding.step.setup_payments.title": "Siapkan pembayaran",
    "Connect payments": "Siapkan pembayaran",
    "onboarding.step.setup_payments.description": "Aktifkan transaksi nyata agar pengguna dapat menyelesaikan pembelian dengan mudah.",
    "Enable real transactions so users can complete purchases without friction.": "Aktifkan transaksi nyata agar pengguna dapat menyelesaikan pembelian dengan mudah.",
    "onboarding.step.setup_payments.cta": "Siapkan pembayaran",
    "Set up payments": "Siapkan pembayaran",
    "onboarding.step.setup_payments.impact": "Membuka peluang pendapatan.",
    "onboarding.step.setup_delivery.title": "Atur pengiriman atau metode layanan",
    "Set shipping or service method": "Atur pengiriman atau metode layanan",
    "onboarding.step.setup_delivery.description": "Tentukan cara pesanan dipenuhi agar proses pembayaran jelas bagi pengguna.",
    "onboarding.step.setup_delivery.cta": "Atur pengiriman",
    "Configure delivery": "Atur pengiriman",
    "onboarding.step.setup_delivery.impact": "Memperjelas pemenuhan pesanan saat checkout.",
    "Makes fulfillment clear at checkout.": "Memperjelas pemenuhan pesanan saat checkout.",
    "onboarding.step.create_bookable_listing.title": "Buat penawaran yang dapat dipesan",
    "Create one bookable offer": "Buat penawaran yang dapat dipesan",
    "onboarding.step.create_bookable_listing.description": "Tambahkan layanan, acara, penyewaan, atau janji temu yang ingin dipesan pelanggan terlebih dahulu.",
    "Add the service event rental or appointment customers should book first.": "Tambahkan layanan, acara, penyewaan, atau janji temu yang ingin dipesan pelanggan terlebih dahulu.",
    "onboarding.step.create_bookable_listing.cta": "Buat penawaran",
    "Create offer": "Buat penawaran",
    "onboarding.step.create_bookable_listing.impact": "Membuat unit pertama yang dapat dipesan.",
    "Creates the first bookable unit.": "Membuat unit pertama yang dapat dipesan.",
    "onboarding.step.shape_details.title": "Tambahkan detail pemesanan",
    "Add booking details": "Tambahkan detail pemesanan",
    "onboarding.step.shape_details.description": "Gunakan kategori dan kolom untuk mengumpulkan informasi yang dibutuhkan sebelum pelanggan memesan.",
    "Use categories and fields to capture what customers need before they commit.": "Gunakan kategori dan kolom untuk mengumpulkan informasi yang dibutuhkan sebelum pelanggan memesan.",
    "onboarding.step.shape_details.cta": "Atur kolom",
    "Set up fields": "Atur kolom",
    "onboarding.step.shape_details.impact": "Membuat penawaran lebih mudah dibandingkan dan dipercaya.",
    "Makes the offer easier to compare and trust.": "Membuat penawaran lebih mudah dibandingkan dan dipercaya.",
    "onboarding.step.test_booking.title": "Uji alur pelanggan",
    "Test the customer path": "Uji alur pelanggan",
    "onboarding.step.test_booking.description": "Buka alur publik dan pastikan pelanggan dapat beralih dari minat ke tindakan.",
    "Open the public flow and verify customers can move from interest to action.": "Buka alur publik dan pastikan pelanggan dapat beralih dari minat ke tindakan.",
    "onboarding.step.test_booking.cta": "Uji pemesanan",
    "Test booking": "Uji pemesanan",
    "onboarding.step.test_booking.impact": "Memvalidasi alur pemesanan.",
    "Validates the booking journey.": "Memvalidasi alur pemesanan.",
    "onboarding.step.upload_digital_product.title": "Unggah produk digital",
    "Upload one digital product": "Unggah produk digital",
    "onboarding.step.upload_digital_product.description": "Lengkapi item unduhan pertama agar dapat dipratinjau dan dijual.",
    "Make the first downloadable item complete enough to preview and sell.": "Lengkapi item unduhan pertama agar dapat dipratinjau dan dijual.",
    "onboarding.step.upload_digital_product.cta": "Tambah produk digital",
    "Add digital product": "Tambah produk digital",
    "onboarding.step.upload_digital_product.impact": "Membuat aset digital pertama yang siap dijual.",
    "Creates your first sellable digital asset.": "Membuat aset digital pertama yang siap dijual.",
    "onboarding.step.test_purchase.title": "Uji alur pembelian",
    "Test purchase flow": "Uji alur pembelian",
    "onboarding.step.test_purchase.description": "Pratinjau pengalaman pembeli dari penemuan produk hingga pembayaran.",
    "Preview what buyers see from discovery through checkout.": "Pratinjau pengalaman pembeli dari penemuan produk hingga pembayaran.",
    "onboarding.step.test_purchase.cta": "Uji checkout",
    "Test checkout": "Uji checkout",
    "onboarding.step.test_purchase.impact": "Memastikan alur pembeli berjalan.",
    "Confirms the buyer journey.": "Memastikan alur pembeli berjalan.",
    "onboarding.step.create_campaign.title": "Buat kampanye pertama",
    "Create the first campaign": "Buat kampanye pertama",
    "onboarding.step.create_campaign.description": "Tambahkan halaman kampanye atau tujuan yang perlu dipahami pendukung terlebih dahulu.",
    "Add the campaign or cause page supporters should understand first.": "Tambahkan halaman kampanye atau tujuan yang perlu dipahami pendukung terlebih dahulu.",
    "onboarding.step.create_campaign.cta": "Buat kampanye",
    "Create campaign": "Buat kampanye",
    "onboarding.step.create_campaign.impact": "Membuat alasan publik pertama untuk bertindak.",
    "Creates the first public reason to act.": "Membuat alasan publik pertama untuk bertindak.",
    "onboarding.step.setup_payments_campaign.title": "Siapkan pembayaran kontribusi",
    "Connect contribution payments": "Siapkan pembayaran kontribusi",
    "onboarding.step.setup_payments_campaign.description": "Niat pendukung penting saat mereka dapat menyelesaikan kontribusi.",
    "Supporter intent matters when they can complete a contribution.": "Niat pendukung penting saat mereka dapat menyelesaikan kontribusi.",
    "onboarding.step.setup_payments_campaign.cta": "Siapkan pembayaran",
    "onboarding.step.setup_payments_campaign.impact": "Memungkinkan kontribusi nyata.",
    "Enables real contributions.": "Memungkinkan kontribusi nyata.",
    "onboarding.step.test_supporter_flow.title": "Uji alur pendukung",
    "Test supporter flow": "Uji alur pendukung",
    "onboarding.step.test_supporter_flow.description": "Buka alur publik dan pastikan cerita serta tindakannya jelas.",
    "Open the public journey and make sure the story and action are clear.": "Buka alur publik dan pastikan cerita serta tindakannya jelas.",
    "onboarding.step.test_supporter_flow.cta": "Uji alur",
    "Test flow": "Uji alur",
    "onboarding.step.test_supporter_flow.impact": "Memvalidasi alur publik.",
    "Validates the public path.": "Memvalidasi alur publik.",
    "onboarding.step.set_account_categories.title": "Tentukan kategori akun pemasok",
    "Define supplier account categories": "Tentukan kategori akun pemasok",
    "onboarding.step.set_account_categories.description": "Pisahkan profil pemasok berdasarkan jenis untuk meningkatkan kepercayaan dan navigasi pembeli.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Pisahkan profil pemasok berdasarkan jenis untuk meningkatkan kepercayaan dan navigasi pembeli.",
    "onboarding.step.set_account_categories.cta": "Kategori akun",
    "Account categories": "Kategori akun",
    "onboarding.step.set_account_categories.impact": "Struktur pemasok sudah dibuat.",
    "Supplier structure established.": "Struktur pemasok sudah dibuat.",
    "onboarding.step.set_account_attributes.title": "Tambahkan atribut profil pemasok",
    "Add supplier profile attributes": "Tambahkan atribut profil pemasok",
    "onboarding.step.set_account_attributes.description": "Kumpulkan detail yang dibutuhkan pembeli sebelum menghubungi atau memesan dari pemasok.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Kumpulkan detail yang dibutuhkan pembeli sebelum menghubungi atau memesan dari pemasok.",
    "onboarding.step.set_account_attributes.cta": "Atribut pemasok",
    "Supplier attributes": "Atribut pemasok",
    "onboarding.step.set_account_attributes.impact": "Meningkatkan kepercayaan pembeli.",
    "Higher buyer confidence.": "Meningkatkan kepercayaan pembeli.",
    "onboarding.step.add_promotion.title": "Tambahkan promosi peluncuran",
    "Add a launch promotion": "Tambahkan promosi peluncuran",
    "onboarding.step.add_promotion.description": "Buat promosi pertama untuk mendorong tindakan saat kunjungan pertama.",
    "Create your first promotion to encourage action during the first visit.": "Buat promosi pertama untuk mendorong tindakan saat kunjungan pertama.",
    "onboarding.step.add_promotion.cta": "Tambah promosi",
    "Add promotion": "Tambah promosi",
    "onboarding.step.add_promotion.impact": "Meningkatkan konversi saat peluncuran.",
    "Strengthens launch conversion.": "Meningkatkan konversi saat peluncuran.",
    "onboarding.step.create_coupon.title": "Buat kupon pertama",
    "Create your first coupon": "Buat kupon pertama",
    "onboarding.step.create_coupon.description": "Uji diskon untuk pembeli atau anggota baru.",
    "Test discounts for first-time buyers or members.": "Uji diskon untuk pembeli atau anggota baru.",
    "onboarding.step.create_coupon.cta": "Buat kupon",
    "Create coupon": "Buat kupon",
    "onboarding.step.create_coupon.impact": "Membuka rangkaian penawaran pertama.",
    "Unlocks your first offer loop.": "Membuka rangkaian penawaran pertama.",
    "onboarding.step.collections_setup.title": "Buat koleksi",
    "Create a collection": "Buat koleksi",
    "onboarding.step.collections_setup.description": "Atur listing penting agar lebih mudah ditemukan dan dijelajahi.",
    "Organize important listings to improve discovery and browsing.": "Atur listing penting agar lebih mudah ditemukan dan dijelajahi.",
    "onboarding.step.collections_setup.cta": "Buat koleksi",
    "Create collection": "Buat koleksi",
    "onboarding.step.collections_setup.impact": "Meningkatkan navigasi dan penemuan.",
    "Improves navigation and discovery.": "Meningkatkan navigasi dan penemuan.",
    "onboarding.step.configure_comms.title": "Tinjau templat komunikasi",
    "Review communication templates": "Tinjau templat komunikasi",
    "onboarding.step.configure_comms.description": "Siapkan notifikasi pendaftaran dan pesanan sebelum bisnis berkembang.",
    "Prepare signup and order notifications before growth.": "Siapkan notifikasi pendaftaran dan pesanan sebelum bisnis berkembang.",
    "onboarding.step.configure_comms.cta": "Buka komunikasi",
    "Open communications": "Buka komunikasi",
    "onboarding.step.configure_comms.impact": "Menyiapkan komunikasi pelanggan.",
    "Prepares customer communications.": "Menyiapkan komunikasi pelanggan.",
    "onboarding.step.customize_attributes.title": "Tambahkan atribut listing",
    "Add listing attributes": "Tambahkan atribut listing",
    "onboarding.step.customize_attributes.description": "Tambahkan kolom terstruktur agar pengguna dapat memfilter dan membandingkan hal penting.",
    "Add structured fields so users can filter and compare what matters.": "Tambahkan kolom terstruktur agar pengguna dapat memfilter dan membandingkan hal penting.",
    "onboarding.step.customize_attributes.cta": "Tambah atribut",
    "Add attributes": "Tambah atribut",
    "onboarding.step.customize_attributes.impact": "Memudahkan perbandingan listing.",
    "Makes listings easier to compare.": "Memudahkan perbandingan listing.",
    "onboarding.step.add_digital_asset.title": "Tambahkan item digital lain",
    "Add another digital item": "Tambahkan item digital lain",
    "onboarding.step.add_digital_asset.description": "Perluas katalog agar pengguna dapat menilai kualitas dan variasi.",
    "Expand the catalog so users can evaluate quality and assortment.": "Perluas katalog agar pengguna dapat menilai kualitas dan variasi.",
    "onboarding.step.add_digital_asset.cta": "Tambah listing digital",
    "Add digital listing": "Tambah listing digital",
    "onboarding.step.add_digital_asset.impact": "Meningkatkan kredibilitas katalog digital.",
    "Improves digital catalog credibility.": "Meningkatkan kredibilitas katalog digital.",
    "personal_assistant.title": "Asisten pribadi",
    "Personal assistant": "Asisten pribadi",
    "personal_assistant.heading": "Kembangkan platform selangkah demi selangkah",
    "Grow your platform one step at a time": "Kembangkan platform selangkah demi selangkah",
    "personal_assistant.subtitle": "Dirancang untuk {launchType}. Kami memprioritaskan tindakan berdasarkan dampak dan kesiapan.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Dirancang untuk {launchType}. Kami memprioritaskan tindakan berdasarkan dampak dan kesiapan.",
    "personal_assistant.launch.store": "toko",
    "a store": "toko",
    "personal_assistant.launch.marketplace": "marketplace",
    "a marketplace": "marketplace",
    "personal_assistant.launch.booking": "platform pemesanan",
    "a booking platform": "platform pemesanan",
    "personal_assistant.launch.digital": "bisnis digital",
    "a digital business": "bisnis digital",
    "personal_assistant.launch.campaign": "platform kampanye",
    "a campaign platform": "platform kampanye",
    "personal_assistant.metric.tasks_completed": "Tugas selesai",
    "Tasks completed": "Tugas selesai",
    "personal_assistant.metric.recommendation_clicks": "Klik rekomendasi",
    "Recommendation clicks": "Klik rekomendasi",
    "personal_assistant.metric.completed_by_recommendation": "Selesai melalui rekomendasi",
    "Completed via recommendations": "Selesai melalui rekomendasi",
    "personal_assistant.metric.assist_rate": "Tingkat bantuan",
    "Assist rate": "Tingkat bantuan",
    "personal_assistant.personalizing": "Menyesuaikan rekomendasi…",
    "Personalizing your recommendations…": "Menyesuaikan rekomendasi…",
    "personal_assistant.do_this_now": "Lakukan sekarang",
    "Do this now": "Lakukan sekarang",
    "personal_assistant.estimated_time": "Perkiraan waktu: {minutes} mnt",
    "Estimated time: {minutes} min": "Perkiraan waktu: {minutes} mnt",
    "personal_assistant.minutes_short": "{minutes} mnt",
    "{minutes} min": "{minutes} mnt",
    "personal_assistant.open": "Buka",
    "personal_assistant.mark_done": "Tandai selesai",
    "personal_assistant.up_next": "Berikutnya",
    "Up next": "Berikutnya",
    "personal_assistant.coming_after": "Setelah ini",
    "Coming after this": "Setelah ini",
    "personal_assistant.completed_count": "Selesai ({count})",
    "Completed ({count})": "Selesai ({count})",
    "personal_assistant.hide": "Sembunyikan",
    "Hide": "Sembunyikan",
    "personal_assistant.show": "Tampilkan",
    "Show": "Tampilkan",
    "personal_assistant.feature.open_live_site.name": "Buka situs aktif",
    "personal_assistant.feature.open_live_site.outcome": "Anda memastikan pelanggan dapat mengakses platform aktif.",
    "You confirm customers can reach the live platform.": "Anda memastikan pelanggan dapat mengakses platform aktif.",
    "personal_assistant.feature.create_supply_shape.name": "Buat kategori pertama",
    "personal_assistant.feature.create_supply_shape.outcome": "Pelanggan dapat menjelajahi struktur yang jelas.",
    "Customers can browse with a clear structure.": "Pelanggan dapat menjelajahi struktur yang jelas.",
    "personal_assistant.feature.post_first_listing.name": "Terbitkan listing uji coba",
    "personal_assistant.feature.post_first_listing.outcome": "Kini platform memiliki pasokan pertama untuk dinilai.",
    "The platform now has first supply to evaluate.": "Kini platform memiliki pasokan pertama untuk dinilai.",
    "personal_assistant.feature.test_buyer_action.name": "Coba sebagai pembeli",
    "personal_assistant.feature.test_buyer_action.outcome": "Anda memvalidasi pengalaman pembeli dari awal hingga akhir.",
    "You validate buyer-side experience end to end.": "Anda memvalidasi pengalaman pembeli dari awal hingga akhir.",
    "personal_assistant.feature.setup_payments.name": "Siapkan pembayaran",
    "personal_assistant.feature.setup_payments.outcome": "Pelanggan dapat menyelesaikan transaksi nyata.",
    "Customers can complete real transactions.": "Pelanggan dapat menyelesaikan transaksi nyata.",
    "personal_assistant.feature.setup_delivery.name": "Atur pengiriman atau metode layanan",
    "personal_assistant.feature.setup_delivery.outcome": "Pelanggan dapat memahami proses pemenuhan dengan jelas.",
    "Customers can understand fulfillment clearly.": "Pelanggan dapat memahami proses pemenuhan dengan jelas.",
    "personal_assistant.feature.add_promotion.name": "Tambahkan promosi peluncuran",
    "personal_assistant.feature.add_promotion.outcome": "Anda membuat insentif konversi awal.",
    "You create an early conversion incentive.": "Anda membuat insentif konversi awal.",
    "personal_assistant.feature.configure_comms.name": "Tinjau templat komunikasi",
    "personal_assistant.feature.configure_comms.outcome": "Pengguna menerima komunikasi yang jelas sepanjang siklus.",
    "Users receive clear lifecycle communication.": "Pengguna menerima komunikasi yang jelas sepanjang siklus.",
    "personal_assistant.feature.view_orders.name": "Buka pesanan",
    "Open orders": "Buka pesanan",
    "personal_assistant.feature.view_orders.outcome": "Anda dapat memantau dan memproses permintaan yang masuk.",
    "You can monitor and process incoming demand.": "Anda dapat memantau dan memproses permintaan yang masuk.",
    "personal_assistant.feature.view_accounts.name": "Buka akun",
    "Open accounts": "Buka akun",
    "personal_assistant.feature.view_accounts.outcome": "Anda dapat meninjau pemasok atau anggota dengan efisien.",
    "You can review suppliers or members efficiently.": "Anda dapat meninjau pemasok atau anggota dengan efisien.",
    "personal_assistant.feature.configure_account_categories.name": "Atur kategori akun",
    "Configure account categories": "Atur kategori akun",
    "personal_assistant.feature.configure_account_categories.outcome": "Struktur pemasok dan anggota lebih jelas untuk orientasi dan kepercayaan.",
    "Supplier and member structure is clearer for onboarding and trust.": "Struktur pemasok dan anggota lebih jelas untuk orientasi dan kepercayaan.",
    "personal_assistant.feature.configure_account_attributes.name": "Atur atribut akun",
    "Configure account attributes": "Atur atribut akun",
    "personal_assistant.feature.configure_account_attributes.outcome": "Profil menangkap informasi penting bagi keputusan pembeli.",
    "Profiles capture decision-critical info for buyers.": "Profil menangkap informasi penting bagi keputusan pembeli.",
    "personal_assistant.feature.review_account_config.name": "Tinjau konfigurasi akun",
    "Review account configuration": "Tinjau konfigurasi akun",
    "personal_assistant.feature.review_account_config.outcome": "Perilaku akun sesuai dengan kebijakan marketplace.",
    "Account behavior matches your marketplace policy.": "Perilaku akun sesuai dengan kebijakan marketplace.",
    "personal_assistant.feature.view_listings.name": "Buka listing",
    "Open listings": "Buka listing",
    "personal_assistant.feature.view_listings.outcome": "Anda dapat memantau kualitas dan kesiapan katalog.",
    "You can monitor catalog quality and readiness.": "Anda dapat memantau kualitas dan kesiapan katalog.",
    "personal_assistant.feature.configure_listing_categories.name": "Atur kategori listing",
    "Configure listing categories": "Atur kategori listing",
    "personal_assistant.feature.configure_listing_categories.outcome": "Katalog lebih mudah dijelajahi dan ditemukan.",
    "The catalog becomes easier to navigate and discover.": "Katalog lebih mudah dijelajahi dan ditemukan.",
    "personal_assistant.feature.configure_listing_attributes.name": "Atur atribut listing",
    "Configure listing attributes": "Atur atribut listing",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Pengguna dapat membandingkan listing melalui detail terstruktur.",
    "Users can compare listings with structured details.": "Pengguna dapat membandingkan listing melalui detail terstruktur.",
    "personal_assistant.feature.configure_variant_types.name": "Atur jenis varian",
    "Configure variant types": "Atur jenis varian",
    "personal_assistant.feature.configure_variant_types.outcome": "Katalog mendukung variasi produk dan layanan dengan jelas.",
    "The catalog supports product and service variations clearly.": "Katalog mendukung variasi produk dan layanan dengan jelas.",
    "personal_assistant.feature.review_listing_configs.name": "Tinjau fitur tambahan listing",
    "Review listing additional features": "Tinjau fitur tambahan listing",
    "personal_assistant.feature.review_listing_configs.outcome": "Perilaku listing sesuai dengan model operasional Anda.",
    "Listing behavior matches your operating model.": "Perilaku listing sesuai dengan model operasional Anda.",
    "personal_assistant.feature.manage_collections.name": "Kelola koleksi",
    "Manage collections": "Kelola koleksi",
    "personal_assistant.feature.manage_collections.outcome": "Koleksi yang diminati lebih mudah ditemukan.",
    "High-intent browsing paths are easier to discover.": "Koleksi yang diminati lebih mudah ditemukan.",
    "personal_assistant.feature.manage_coupons.name": "Kelola kupon",
    "Manage coupons": "Kelola kupon",
    "personal_assistant.feature.manage_coupons.outcome": "Anda dapat menjalankan penawaran khusus untuk aktivasi.",
    "You can run targeted offers for activation.": "Anda dapat menjalankan penawaran khusus untuk aktivasi.",
    "personal_assistant.feature.view_transactions.name": "Lihat transaksi",
    "View transactions": "Lihat transaksi",
    "personal_assistant.feature.view_transactions.outcome": "Aktivitas pembayaran dapat dipantau untuk kepercayaan dan operasional.",
    "Payment activity can be monitored for trust and operations.": "Aktivitas pembayaran dapat dipantau untuk kepercayaan dan operasional.",
    "personal_assistant.feature.view_users.name": "Buka pengguna",
    "Open users": "Buka pengguna",
    "personal_assistant.feature.view_users.outcome": "Anda dapat memantau kualitas pertumbuhan pelanggan dan anggota.",
    "You can monitor customer and member growth quality.": "Anda dapat memantau kualitas pertumbuhan pelanggan dan anggota.",
    "personal_assistant.feature.configure_user_attributes.name": "Atur atribut pengguna",
    "Configure user attributes": "Atur atribut pengguna",
    "personal_assistant.feature.configure_user_attributes.outcome": "Kumpulkan sinyal profil untuk meningkatkan keterlibatan.",
    "You can capture profile signals to improve engagement.": "Kumpulkan sinyal profil untuk meningkatkan keterlibatan.",
    "personal_assistant.feature.review_ratings.name": "Tinjau rating dan ulasan",
    "Review ratings and reviews": "Tinjau rating dan ulasan",
    "personal_assistant.feature.review_ratings.outcome": "Sinyal kepercayaan dipantau dan ditingkatkan.",
    "Trust signals are monitored and improved.": "Sinyal kepercayaan dipantau dan ditingkatkan.",
    "personal_assistant.feature.view_reports.name": "Buka laporan",
    "Open reports": "Buka laporan",
    "personal_assistant.feature.view_reports.outcome": "Anda dapat melacak kinerja melalui tampilan data.",
    "You can track performance with a data view.": "Anda dapat melacak kinerja melalui tampilan data.",
    "personal_assistant.feature.manage_media.name": "Kelola pustaka media",
    "Manage media library": "Kelola pustaka media",
    "personal_assistant.feature.manage_media.outcome": "Visual merek dan listing lebih mudah dikelola.",
    "Brand and listing visuals are easier to maintain.": "Visual merek dan listing lebih mudah dikelola.",
    "personal_assistant.feature.manage_reported_listings.name": "Tinjau listing yang dilaporkan",
    "Review reported listings": "Tinjau listing yang dilaporkan",
    "personal_assistant.feature.manage_reported_listings.outcome": "Konten berisiko atau berkualitas rendah dapat ditangani dengan cepat.",
    "Risky or low-quality content can be handled quickly.": "Konten berisiko atau berkualitas rendah dapat ditangani dengan cepat.",
    "personal_assistant.feature.app_customization.name": "Sesuaikan pengalaman aplikasi",
    "Customize app experience": "Sesuaikan pengalaman aplikasi",
    "personal_assistant.feature.app_customization.outcome": "Pengalaman aplikasi selaras dengan merek Anda.",
    "The mobile app experience aligns with your brand.": "Pengalaman aplikasi selaras dengan merek Anda.",
    "personal_assistant.feature.app_integrations.name": "Atur integrasi aplikasi",
    "Configure app integrations": "Atur integrasi aplikasi",
    "personal_assistant.feature.app_integrations.outcome": "Layanan inti platform terhubung dengan alur aplikasi.",
    "Core platform services connect with app workflows.": "Layanan inti platform terhubung dengan alur aplikasi.",
    "personal_assistant.feature.customize_strings.name": "Sesuaikan teks antarmuka",
    "Customize interface text": "Sesuaikan teks antarmuka",
    "personal_assistant.feature.customize_strings.outcome": "Teks produk sesuai dengan audiens dan gaya Anda.",
    "Product copy matches your audience and tone.": "Teks produk sesuai dengan audiens dan gaya Anda.",
    "personal_assistant.feature.review_settings_home.name": "Buka pengaturan",
    "Open settings": "Buka pengaturan",
    "personal_assistant.feature.review_settings_home.outcome": "Konfigurasi mudah ditemukan untuk operasional tim.",
    "Configuration is easy to find for team operations.": "Konfigurasi mudah ditemukan untuk operasional tim.",
    "personal_assistant.feature.configure_commission.name": "Atur komisi",
    "Configure commission": "Atur komisi",
    "personal_assistant.feature.configure_commission.outcome": "Pembagian pendapatan sesuai dengan model bisnis Anda.",
    "Revenue sharing aligns with your business model.": "Pembagian pendapatan sesuai dengan model bisnis Anda.",
    "personal_assistant.feature.configure_taxes.name": "Atur pajak",
    "Configure taxes": "Atur pajak",
    "personal_assistant.feature.configure_taxes.outcome": "Harga checkout dapat diprediksi dan pengaturan pajak siap.",
    "Checkout pricing is predictable and tax settings are ready.": "Harga checkout dapat diprediksi dan pengaturan pajak siap.",
    "personal_assistant.feature.configure_languages.name": "Atur bahasa",
    "Configure languages": "Atur bahasa",
    "personal_assistant.feature.configure_languages.outcome": "Pengalaman mendukung audiens multibahasa.",
    "The experience supports a multilingual audience.": "Pengalaman mendukung audiens multibahasa.",
    "personal_assistant.feature.configure_currency.name": "Atur mata uang",
    "Configure currency": "Atur mata uang",
    "personal_assistant.feature.configure_currency.outcome": "Harga sesuai dengan ekspektasi pasar sasaran.",
    "Prices align with the expectations of your target market.": "Harga sesuai dengan ekspektasi pasar sasaran.",
    "personal_assistant.feature.configure_countries.name": "Atur negara",
    "Configure countries": "Atur negara",
    "personal_assistant.feature.configure_countries.outcome": "Cakupan geografis dikendalikan untuk peluncuran.",
    "Geographic coverage is controlled for launch.": "Cakupan geografis dikendalikan untuk peluncuran.",
    "personal_assistant.feature.review_checkout_settings.name": "Tinjau pengaturan checkout",
    "Review checkout settings": "Tinjau pengaturan checkout",
    "personal_assistant.feature.review_checkout_settings.outcome": "Checkout lebih sederhana dan andal.",
    "Checkout is cleaner and more reliable.": "Checkout lebih sederhana dan andal.",
    "personal_assistant.feature.api_configuration.name": "Tinjau konfigurasi API",
    "Review API configuration": "Tinjau konfigurasi API",
    "personal_assistant.feature.api_configuration.outcome": "Integrasi dan akses pengembang siap.",
    "Integrations and developer access are ready.": "Integrasi dan akses pengembang siap.",
    "personal_assistant.feature.workspace_website_editor.name": "Buka editor situs",
    "Open website editor": "Buka editor situs",
    "personal_assistant.feature.workspace_website_editor.outcome": "Etalase dapat disempurnakan untuk meningkatkan konversi.",
    "The storefront can be refined for conversion.": "Etalase dapat disempurnakan untuk meningkatkan konversi.",
    "personal_assistant.feature.workspace_domain_setup.name": "Tinjau penyiapan domain",
    "Review domain setup": "Tinjau penyiapan domain",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Domain yang rapi meningkatkan kepercayaan merek.",
    "A clean domain improves brand trust.": "Domain yang rapi meningkatkan kepercayaan merek.",
    "personal_assistant.feature.workspace_pages.name": "Tinjau halaman situs",
    "Review site pages": "Tinjau halaman situs",
    "personal_assistant.feature.workspace_pages.outcome": "Halaman landing dan konten utama mendukung kepercayaan pengguna.",
    "Core landing and content pages support user trust.": "Halaman landing dan konten utama mendukung kepercayaan pengguna.",
    "reports.title": "Laporan",
    "reports.metric.0": "Pengguna",
    "reports.metric.1": "Akun",
    "reports.metric.2": "Listing",
    "reports.metric.3": "Listing terjual",
    "Listings Sold": "Listing terjual",
    "reports.metric.4": "Total penjualan",
    "Total Sales": "Total penjualan",
    "reports.metric.5": "Total pesanan",
    "reports.metric.6": "Total pendapatan",
    "Total Earnings": "Total pendapatan",
    "reports.chart.activity": "Aktivitas marketplace harian",
    "Daily marketplace activity": "Aktivitas marketplace harian",
    "reports.chart.activity_description": "Listing dan pengguna baru dari waktu ke waktu",
    "Listings and new users over time": "Listing dan pengguna baru dari waktu ke waktu",
    "reports.chart.listings_monthly": "Listing bulanan",
    "Listings monthly": "Listing bulanan",
    "reports.chart.listings_daily": "Listing harian",
    "Listings daily": "Listing harian",
    "reports.chart.users_daily": "Pengguna harian",
    "Users daily": "Pengguna harian",
    "reports.chart.users_monthly": "Pengguna bulanan",
    "Users monthly": "Pengguna bulanan",
    "reports.series.listings": "Listing",
    "reports.series.new_users": "Pengguna baru",
    "New users": "Pengguna baru",
    "reports.top_sold_listings": "Listing terlaris",
    "Top sold listings": "Listing terlaris",
    "reports.view_more_insights": "Lihat insight lainnya",
    "View more insights": "Lihat insight lainnya",
    "reports.ai.title": "Laporan penjualan AI",
    "AI sales reports": "Laporan penjualan AI",
    "reports.ai.generating": "Membuat laporan…",
    "Generating reports…": "Membuat laporan…",
    "reports.ai.value": "Nilai",
    "reports.ai.more_info": "Informasi selengkapnya tentang {label}",
    "More information about {label}": "Informasi selengkapnya tentang {label}",
    "reports.ai.saved_snapshot": "Snapshot tersimpan",
    "Saved snapshot": "Snapshot tersimpan",
    "reports.ai.no_data": "Tidak ada data",
    "No data available": "Tidak ada data",
    "reports.ai.showing_top": "Menampilkan {shown} teratas dari {total} hasil",
    "Showing the top {shown} of {total} results": "Menampilkan {shown} teratas dari {total} hasil",
    "reports.ai.saved_report": "Laporan AI tersimpan",
    "Saved AI report": "Laporan AI tersimpan",
    "reports.ai.template.country": "Penjualan berdasarkan negara",
    "Sales by country": "Penjualan berdasarkan negara",
    "reports.ai.template.state": "Penjualan berdasarkan provinsi",
    "Sales by state": "Penjualan berdasarkan provinsi",
    "reports.ai.template.city": "Penjualan berdasarkan kota",
    "Sales by city": "Penjualan berdasarkan kota",
    "reports.ai.template.category": "Penjualan berdasarkan kategori",
    "Sales by category": "Penjualan berdasarkan kategori",
    "reports.ai.template.country_all_time": "Penjualan berdasarkan negara (sepanjang waktu)",
    "Sales by country (all time)": "Penjualan berdasarkan negara (sepanjang waktu)",
    "reports.ai.template.top_listings_all_time": "Listing terlaris (sepanjang waktu)",
    "Top sold listings (all time)": "Listing terlaris (sepanjang waktu)",
    "reports.ai.template.listings_by_category_all_time": "Listing berdasarkan kategori (sepanjang waktu)",
    "Listings by category (all time)": "Listing berdasarkan kategori (sepanjang waktu)",
    "reports.search_table.title": "Pencarian listing",
    "Listing search": "Pencarian listing",
    "reports.search_table.phrase": "Frasa",
    "Phrase": "Frasa",
    "reports.search_table.result": "Hasil",
    "reports.search_table.created_at": "Dibuat pada",
    "Created at": "Dibuat pada",
    "reports.search_table.user_first_name": "Nama depan pengguna",
    "User first name": "Nama depan pengguna",
    "reports.search_table.user_last_name": "Nama belakang pengguna",
    "User last name": "Nama belakang pengguna",
    "reports.search_table.user_email": "Email pengguna",
    "User email": "Email pengguna",
    "intelligence.title": "Intelligence",
    "intelligence.description": "Buat laporan AI, simpan snapshot grafik, dan sematkan laporan berguna ke dasbor.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Buat laporan AI, simpan snapshot grafik, dan sematkan laporan berguna ke dasbor.",
    "intelligence.dashboard.label": "Dasbor",
    "intelligence.dashboard.pinned_title": "Widget intelligence yang disematkan",
    "Pinned intelligence widgets": "Widget intelligence yang disematkan",
    "intelligence.dashboard.pinned_count": "{count} disematkan",
    "{count} pinned": "{count} disematkan",
    "intelligence.dashboard.empty": "Sematkan laporan tersimpan untuk membuat kisi dasbor yang dapat digunakan kembali.",
    "Pin saved reports to build a reusable dashboard grid.": "Sematkan laporan tersimpan untuk membuat kisi dasbor yang dapat digunakan kembali.",
    "intelligence.action.open": "Buka",
    "intelligence.action.pin": "Sematkan",
    "Pin": "Sematkan",
    "intelligence.action.unpin": "Lepas sematan",
    "Unpin": "Lepas sematan",
    "intelligence.action.generate": "Buat",
    "intelligence.action.save_snapshot": "Simpan snapshot",
    "Save snapshot": "Simpan snapshot",
    "intelligence.action.discard_draft": "Buang draf",
    "Discard draft": "Buang draf",
    "intelligence.action.load": "Muat",
    "Load": "Muat",
    "intelligence.action.refresh": "Muat ulang",
    "intelligence.action.delete": "Hapus",
    "intelligence.table.no_rows": "Tidak ada baris terstruktur untuk laporan ini.",
    "No structured rows were returned for this report.": "Tidak ada baris terstruktur untuk laporan ini.",
    "intelligence.table.no_rows_short": "Tidak ada baris.",
    "No rows available.": "Tidak ada baris.",
    "intelligence.field.template": "Templat laporan",
    "Report template": "Templat laporan",
    "intelligence.field.date_filter": "Filter tanggal",
    "Date filter": "Filter tanggal",
    "intelligence.field.prompt": "Pratinjau prompt",
    "Prompt preview": "Pratinjau prompt",
    "intelligence.field.report_name": "Nama laporan",
    "Report name": "Nama laporan",
    "intelligence.field.report_name_placeholder": "Contoh: Produk Terlaris – 30 Hari Terakhir",
    "For example: Top Selling Products – Last 30 Days": "Contoh: Produk Terlaris – 30 Hari Terakhir",
    "intelligence.field.chart": "Grafik",
    "Chart": "Grafik",
    "intelligence.field.prompt_label": "Prompt",
    "Prompt": "Prompt",
    "intelligence.date.relative": "Relatif",
    "Relative": "Relatif",
    "intelligence.date.absolute": "Absolut",
    "Absolute": "Absolut",
    "intelligence.date.last_n_days": "N hari terakhir",
    "Last N days": "N hari terakhir",
    "intelligence.date.last_days": "{days} hari terakhir",
    "Last {days} days": "{days} hari terakhir",
    "intelligence.date.from": "Dari",
    "From": "Dari",
    "intelligence.date.to": "Sampai",
    "To": "Sampai",
    "intelligence.saved_reports.title": "Laporan tersimpan",
    "Saved reports": "Laporan tersimpan",
    "intelligence.saved_reports.empty": "Belum ada laporan analitik tersimpan.",
    "No saved intelligence reports yet.": "Belum ada laporan analitik tersimpan.",
    "intelligence.active_report": "Laporan aktif",
    "Active report": "Laporan aktif",
    "intelligence.no_report_selected": "Belum ada laporan dipilih",
    "No report selected": "Belum ada laporan dipilih",
    "intelligence.active_report.empty_description": "Buat laporan atau muat laporan tersimpan untuk melihat datanya.",
    "Generate a report or load a saved one to inspect the data.": "Buat laporan atau muat laporan tersimpan untuk melihat datanya.",
    "intelligence.chart.value": "Nilai",
    "intelligence.chart.unknown": "Tidak diketahui",
    "intelligence.chart_type.bar": "Batang",
    "Barres": "Batang",
    "intelligence.chart_type.line": "Garis",
    "Line": "Garis",
    "intelligence.chart_type.area": "Area",
    "Area": "Area",
    "intelligence.chart_type.pie": "Pai",
    "Pie": "Pai",
    "intelligence.chart.no_rows": "Laporan ini tidak memiliki baris untuk dibuat grafik.",
    "This report did not return rows to plot.": "Laporan ini tidak memiliki baris untuk dibuat grafik.",
    "intelligence.empty_report": "Gunakan templat dan filter tanggal untuk membuat laporan AI terstruktur, lalu simpan dan sematkan ke dasbor.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Gunakan templat dan filter tanggal untuk membuat laporan AI terstruktur, lalu simpan dan sematkan ke dasbor.",
    "intelligence.error.update": "Gagal memperbarui laporan tersimpan.",
    "Unable to update the saved report.": "Gagal memperbarui laporan tersimpan.",
    "intelligence.error.prompt_required": "Masukkan prompt untuk membuat laporan.",
    "Enter a prompt to generate a report.": "Masukkan prompt untuk membuat laporan.",
    "intelligence.error.invalid_response": "Respons AI tidak menyertakan laporan yang dinormalisasi.",
    "The AI response did not include a normalized report.": "Respons AI tidak menyertakan laporan yang dinormalisasi.",
    "intelligence.error.generate": "Laporan tidak dapat dibuat saat ini.",
    "Unable to generate the report right now.": "Laporan tidak dapat dibuat saat ini.",
    "intelligence.error.generate_before_save": "Buat laporan sebelum menyimpan.",
    "Generate a report before saving.": "Buat laporan sebelum menyimpan.",
    "intelligence.error.save": "Gagal menyimpan laporan.",
    "Unable to save the report.": "Gagal menyimpan laporan.",
    "intelligence.error.load": "Gagal memuat laporan.",
    "Unable to load the saved report.": "Gagal memuat laporan.",
    "intelligence.error.refresh": "Gagal memuat ulang laporan.",
    "Unable to refresh the saved report.": "Gagal memuat ulang laporan.",
    "intelligence.error.delete": "Gagal menghapus laporan.",
    "Unable to delete the saved report.": "Gagal menghapus laporan.",
    "intelligence.template.top_selling_products": "Produk terlaris",
    "Top selling products": "Produk terlaris",
    "intelligence.template.revenue_trend": "Tren pendapatan",
    "Revenue trend": "Tren pendapatan",
    "intelligence.template.low_stock_products": "Produk dengan stok rendah",
    "Low stock products": "Produk dengan stok rendah",
    "intelligence.template.top_categories_by_sales": "Kategori teratas berdasarkan penjualan",
    "Top categories by sales": "Kategori teratas berdasarkan penjualan",
    "intelligence.template.order_status_breakdown": "Rincian status pesanan",
    "Order status breakdown": "Rincian status pesanan",
    "intelligence.template.sales_by_day": "Penjualan per hari",
    "Sales by day": "Penjualan per hari",
    "intelligence.template.sales_by_country": "Penjualan berdasarkan negara",
    "intelligence.template.sales_by_state": "Penjualan berdasarkan provinsi",
    "intelligence.template.sales_by_city": "Penjualan berdasarkan kota",
    "intelligence.template.sales_by_category": "Penjualan berdasarkan kategori",
    "intelligence.template.sales_by_subcategory": "Penjualan berdasarkan subkategori",
    "Sales by subcategory": "Penjualan berdasarkan subkategori",
    "intelligence.prompt.top_selling_products.relative": "Tampilkan produk terlaris selama {days} hari terakhir",
    "Show me top selling products for the last {days} days": "Tampilkan produk terlaris selama {days} hari terakhir",
    "intelligence.prompt.top_selling_products.absolute": "Tampilkan produk terlaris dari {from} sampai {to}",
    "Show me top selling products from {from} to {to}": "Tampilkan produk terlaris dari {from} sampai {to}",
    "intelligence.prompt.revenue_trend.relative": "Tampilkan tren pendapatan selama {days} hari terakhir",
    "What is my revenue trend for the last {days} days?": "Tampilkan tren pendapatan selama {days} hari terakhir",
    "intelligence.prompt.revenue_trend.absolute": "Tampilkan tren pendapatan dari {from} sampai {to}",
    "What is my revenue trend from {from} to {to}?": "Tampilkan tren pendapatan dari {from} sampai {to}",
    "intelligence.prompt.low_stock_products": "Tampilkan produk dengan stok rendah",
    "Show me low stock products": "Tampilkan produk dengan stok rendah",
    "intelligence.prompt.top_categories_by_sales.relative": "Tampilkan kategori teratas berdasarkan penjualan selama {days} hari terakhir",
    "Show me top categories by sales for the last {days} days": "Tampilkan kategori teratas berdasarkan penjualan selama {days} hari terakhir",
    "intelligence.prompt.top_categories_by_sales.absolute": "Tampilkan kategori teratas berdasarkan penjualan dari {from} sampai {to}",
    "Show me top categories by sales from {from} to {to}": "Tampilkan kategori teratas berdasarkan penjualan dari {from} sampai {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Tampilkan rincian status pesanan selama {days} hari terakhir",
    "Show me order status breakdown for the last {days} days": "Tampilkan rincian status pesanan selama {days} hari terakhir",
    "intelligence.prompt.order_status_breakdown.absolute": "Tampilkan rincian status pesanan dari {from} sampai {to}",
    "Show me order status breakdown from {from} to {to}": "Tampilkan rincian status pesanan dari {from} sampai {to}",
    "intelligence.prompt.sales_by_day.relative": "Tampilkan penjualan per hari selama {days} hari terakhir",
    "Show me sales by day for the last {days} days": "Tampilkan penjualan per hari selama {days} hari terakhir",
    "intelligence.prompt.sales_by_day.absolute": "Tampilkan penjualan per hari dari {from} sampai {to}",
    "Show me sales by day from {from} to {to}": "Tampilkan penjualan per hari dari {from} sampai {to}",
    "intelligence.prompt.sales_by_country.relative": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan negara selama {days} hari terakhir",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan negara selama {days} hari terakhir",
    "intelligence.prompt.sales_by_country.absolute": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan negara dari {from} sampai {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan negara dari {from} sampai {to}",
    "intelligence.prompt.sales_by_state.relative": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan provinsi selama {days} hari terakhir",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan provinsi selama {days} hari terakhir",
    "intelligence.prompt.sales_by_state.absolute": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan provinsi dari {from} sampai {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan provinsi dari {from} sampai {to}",
    "intelligence.prompt.sales_by_city.relative": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kota selama {days} hari terakhir",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kota selama {days} hari terakhir",
    "intelligence.prompt.sales_by_city.absolute": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kota dari {from} sampai {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kota dari {from} sampai {to}",
    "intelligence.prompt.sales_by_category.relative": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kategori listing utama selama {days} hari terakhir",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kategori listing utama selama {days} hari terakhir",
    "intelligence.prompt.sales_by_category.absolute": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kategori listing utama dari {from} sampai {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan kategori listing utama dari {from} sampai {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan subkategori listing selama {days} hari terakhir",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan subkategori listing selama {days} hari terakhir",
    "intelligence.prompt.sales_by_subcategory.absolute": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan subkategori listing dari {from} sampai {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Tampilkan total pendapatan dan jumlah pesanan berdasarkan subkategori listing dari {from} sampai {to}",
    "common.status.partial": "Sebagian",
    "Partial": "Sebagian",
    "common.status.dispatched": "Dikirim",
    "Dispatched": "Dikirim",
    "common.status.sale": "Penjualan",
    "Sale": "Penjualan",
    "common.status.transfer_in": "Transfer masuk",
    "Transfer in": "Transfer masuk",
    "common.status.transfer_out": "Transfer keluar",
    "Transfer out": "Transfer keluar",
    "common.status.return": "Pengembalian",
    "Return": "Pengembalian",
    "common.status.adjustment": "Penyesuaian",
    "Adjustment": "Penyesuaian",
    "common.status.receipt": "Penerimaan",
    "inventory.overview.title": "Inventaris",
    "inventory.overview.tab.all": "Semua stok",
    "All stock": "Semua stok",
    "inventory.overview.tab.low": "Stok rendah",
    "Low stock": "Stok rendah",
    "inventory.overview.tab.expiring": "Batch yang segera kedaluwarsa",
    "Expiring batches": "Batch yang segera kedaluwarsa",
    "inventory.overview.manage_locations": "Kelola lokasi",
    "Manage locations": "Kelola lokasi",
    "inventory.overview.purchase_orders": "Pesanan pembelian",
    "inventory.overview.operations": "Operasi",
    "Operations": "Operasi",
    "inventory.overview.adjust_stock": "Sesuaikan stok",
    "inventory.overview.description": "Tampilan stok terkini di semua lokasi.",
    "A live view of stock across your locations.": "Tampilan stok terkini di semua lokasi.",
    "inventory.overview.adjustment_hint": "Gunakan penyesuaian untuk penghitungan, kerusakan, pengembalian, atau koreksi lainnya.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Gunakan penyesuaian untuk penghitungan, kerusakan, pengembalian, atau koreksi lainnya.",
    "inventory.overview.units_on_hand": "Unit tersedia",
    "Units on hand": "Unit tersedia",
    "inventory.overview.one_stock_row": "1 baris stok",
    "1 stock row": "1 baris stok",
    "inventory.overview.stock_rows": "{count} baris stok",
    "{count} stock rows": "{count} baris stok",
    "inventory.overview.low_stock": "Stok rendah",
    "inventory.overview.reorder_point_hint": "Pada atau di bawah titik pemesanan ulang",
    "At or below reorder point": "Pada atau di bawah titik pemesanan ulang",
    "inventory.overview.expiring_soon": "Segera kedaluwarsa",
    "Expiring soon": "Segera kedaluwarsa",
    "inventory.overview.next_90_days": "Dalam 90 hari ke depan",
    "Within the next 90 days": "Dalam 90 hari ke depan",
    "inventory.overview.stock_value": "Nilai stok",
    "Stock value": "Nilai stok",
    "inventory.overview.one_active_location": "1 lokasi aktif",
    "1 active location": "1 lokasi aktif",
    "inventory.overview.active_locations": "{count} lokasi aktif",
    "{count} active locations": "{count} lokasi aktif",
    "inventory.overview.search": "Cari inventaris",
    "Search inventory": "Cari inventaris",
    "inventory.overview.search_placeholder": "Cari produk, SKU, atau lokasi",
    "Search product, SKU, or location": "Cari produk, SKU, atau lokasi",
    "inventory.overview.filter_location": "Filter berdasarkan lokasi",
    "Filter by location": "Filter berdasarkan lokasi",
    "inventory.overview.all_locations": "Semua lokasi",
    "inventory.overview.empty.all": "Belum ada stok inventaris.",
    "No inventory stock has been recorded yet.": "Belum ada stok inventaris.",
    "inventory.overview.empty.low": "Bagus — tidak ada stok di bawah titik pemesanan ulang.",
    "Great — no stock is below its reorder point.": "Bagus — tidak ada stok di bawah titik pemesanan ulang.",
    "inventory.overview.empty.expiring": "Tidak ada batch yang kedaluwarsa dalam 90 hari ke depan.",
    "No batches are expiring within 90 days.": "Tidak ada batch yang kedaluwarsa dalam 90 hari ke depan.",
    "inventory.overview.adjust": "Sesuaikan",
    "Adjust": "Sesuaikan",
    "inventory.overview.adjust_title": "Penyesuaian stok",
    "inventory.overview.adjust_description": "Catat koreksi beserta alasannya agar riwayat inventaris tetap tepercaya.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Catat koreksi beserta alasannya agar riwayat inventaris tetap tepercaya.",
    "inventory.overview.save_adjustment": "Simpan penyesuaian",
    "Save adjustment": "Simpan penyesuaian",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Belum ditetapkan",
    "Unassigned": "Belum ditetapkan",
    "inventory.overview.quantity_change": "Perubahan jumlah",
    "Quantity change": "Perubahan jumlah",
    "inventory.overview.quantity_placeholder": "mis. 5 atau -2",
    "e.g. 5 or -2": "mis. 5 atau -2",
    "inventory.overview.reason": "Alasan",
    "inventory.overview.reason_placeholder": "Hitung stok, kerusakan, pengembalian…",
    "Cycle count, damage, return…": "Hitung stok, kerusakan, pengembalian…",
    "inventory.overview.reason.cycle_count": "Hitung stok",
    "Cycle count": "Hitung stok",
    "inventory.overview.reason.damage": "Kerusakan",
    "Damage": "Kerusakan",
    "inventory.overview.reason.return": "Pengembalian",
    "inventory.overview.reason.stocktake": "Stock opname",
    "Stocktake": "Stock opname",
    "inventory.overview.note_placeholder": "Konteks opsional untuk petugas berikutnya",
    "Optional context for the next person": "Konteks opsional untuk petugas berikutnya",
    "inventory.overview.adjustment_saved": "Penyesuaian stok disimpan",
    "Inventory adjustment saved": "Penyesuaian stok disimpan",
    "inventory.overview.on_hand": "Tersedia",
    "On hand": "Tersedia",
    "inventory.overview.reorder_at": "Pesan ulang pada",
    "Reorder at": "Pesan ulang pada",
    "orders.create_order.payment_reference_missing": "Pesanan dibuat, tetapi referensi pesanan tidak dikembalikan.",
    "The order was created, but no order reference was returned.": "Pesanan dibuat, tetapi referensi pesanan tidak dikembalikan.",
    "orders.create_order.payment_domain_missing": "Domain tenant tidak tersedia untuk tautan pembayaran.",
    "The tenant domain is not available for payment links.": "Domain tenant tidak tersedia untuk tautan pembayaran.",
    "orders.create_order.payment_link_failed": "Gagal membuat tautan pembayaran.",
    "Unable to create payment link.": "Gagal membuat tautan pembayaran.",
    "orders.create_order.admin_session_expired": "Sesi admin Anda berakhir. Silakan masuk lagi sebelum membuat pesanan.",
    "Your admin session has expired. Please sign in again before creating an order.": "Sesi admin Anda berakhir. Silakan masuk lagi sebelum membuat pesanan.",
    "orders.create_order.user": "Pengguna",
    "orders.create_order.add_new_user": "Tambah pengguna",
    "Add New User": "Tambah pengguna",
    "orders.create_order.choose_existing_user": "Pilih pengguna yang ada",
    "Choose Existing User": "Pilih pengguna yang ada",
    "orders.create_order.preparing_customer": "Menyiapkan pelanggan…",
    "Preparing customer…": "Menyiapkan pelanggan…",
    "orders.create_order.select_user": "Pilih pengguna",
    "Select user": "Pilih pengguna",
    "orders.create_order.search_listing": "Cari listing",
    "Search Listing": "Cari listing",
    "orders.create_order.listings": "Listing",
    "orders.create_order.no_image": "Tidak ada gambar",
    "No image": "Tidak ada gambar",
    "orders.create_order.add_to_cart": "Tambahkan ke keranjang",
    "Add to Cart": "Tambahkan ke keranjang",
    "orders.create_order.select_rental_dates": "Pilih tanggal mulai dan akhir sewa terlebih dahulu.",
    "Select rental start and end dates first.": "Pilih tanggal mulai dan akhir sewa terlebih dahulu.",
    "orders.create_order.rental_end_after_start": "Tanggal akhir sewa harus setelah tanggal mulai.",
    "Rental end must be after the start date.": "Tanggal akhir sewa harus setelah tanggal mulai.",
    "orders.create_order.cart_type_conflict": "Pelanggan ini sudah memiliki item dengan jenis listing berbeda. Hapus item tersebut di Checkout sebelum menambahkan item ini.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Pelanggan ini sudah memiliki item dengan jenis listing berbeda. Hapus item tersebut di Checkout sebelum menambahkan item ini.",
    "orders.create_order.rental_period": "Periode sewa",
    "Rental period": "Periode sewa",
    "orders.create_order.select_start_end": "Pilih tanggal mulai dan akhir",
    "Select start and end": "Pilih tanggal mulai dan akhir",
    "orders.create_order.membership_no_shipping": "Pesanan keanggotaan tidak memerlukan pengiriman.",
    "Membership orders do not require shipping or delivery.": "Pesanan keanggotaan tidak memerlukan pengiriman.",
    "orders.create_order.preparing_payment_link": "Menyiapkan tautan pembayaran…",
    "Preparing payment link…": "Menyiapkan tautan pembayaran…",
    "orders.create_order.payment_link_ready": "Tautan pembayaran siap",
    "Payment link ready": "Tautan pembayaran siap",
    "orders.create_order.copy_payment_link": "Salin tautan pembayaran",
    "Copy payment link": "Salin tautan pembayaran",
    "orders.create_order.payment_method": "Metode pembayaran",
    "orders.create_order.no_payment_methods": "Belum ada metode pembayaran aktif untuk proyek ini.",
    "No active payment methods are configured for this project.": "Belum ada metode pembayaran aktif untuk proyek ini.",
    "orders.create_order.shipping_method": "Metode pengiriman",
    "orders.create_order.no_shipping_methods": "Belum ada metode pengiriman aktif untuk proyek ini.",
    "No active shipping methods are configured for this project.": "Belum ada metode pengiriman aktif untuk proyek ini.",
    "orders.create_order.shipping_address": "Alamat pengiriman",
    "Shipping address": "Alamat pengiriman",
    "orders.create_order.loading_addresses": "Memuat alamat tersimpan…",
    "Loading saved addresses…": "Memuat alamat tersimpan…",
    "orders.create_order.no_saved_shipping_address": "Pengguna ini tidak memiliki alamat pengiriman tersimpan. Tambahkan alamat ke profil sebelum membuat pesanan pengiriman.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "Pengguna ini tidak memiliki alamat pengiriman tersimpan. Tambahkan alamat ke profil sebelum membuat pesanan pengiriman.",
    "orders.create_order.no_items": "Tidak ada item",
    "No items": "Tidak ada item",
    "orders.create_order.cart_empty": "Keranjang kosong",
    "Your cart is empty": "Keranjang kosong",
    "orders.create_order.create_order": "Buat pesanan",
    "Create Order": "Buat pesanan",
    "orders.create_order.create_payment_link": "Buat tautan pembayaran",
    "Create payment link": "Buat tautan pembayaran",
    "orders.create_order.order_summary": "Ringkasan pesanan",
    "orders.create_order.coupon_value": "Nilai kupon",
    "Coupon value": "Nilai kupon",
    "orders.create_order.remove_coupon": "Hapus kupon",
    "Remove Coupon": "Hapus kupon",
    "orders.create_order.apply_coupon": "Terapkan kupon",
    "Apply Coupon": "Terapkan kupon",
    "orders.create_order.grand_amount": "Jumlah akhir",
    "Grand Amount": "Jumlah akhir",
    "orders.create_order.total": "Total",
    "orders.create_order.shipping": "Pengiriman",
    "Shipping": "Pengiriman",
    "orders.create_order.subtotal": "Subtotal",
    "Subtotal": "Subtotal",
    "orders.create_order.stock_unavailable": "Stok tidak tersedia",
    "Stock is not available": "Stok tidak tersedia",
    "orders.create_order.max_quantity": "Jumlah maksimum adalah {quantity}",
    "Max quantity is {quantity}": "Jumlah maksimum adalah {quantity}",
    "orders.create_order.items_in_cart": "Item di keranjang",
    "Items in the cart": "Item di keranjang",
    "orders.create_order.products_in_stock": "{count} produk tersedia",
    "{count} Products in Stock": "{count} produk tersedia",
    "orders.create_order.order_items": "Item pesanan",
    "Order Items": "Item pesanan",
    "orders.create_order.sold_by": "oleh {name}",
    "by {name}": "oleh {name}",
    "common.first_name": "Nama depan",
    "common.last_name": "Nama belakang",
    "common.unlimited": "tanpa batas",
    "unlimited": "tanpa batas",
    "orders.reference": "Referensi",
    "orders.amount": "Jumlah",
    "orders.currency": "Mata uang",
    "orders.transaction_date": "Tanggal transaksi",
    "Transaction Date": "Tanggal transaksi",
    "orders.volume_this_page": "Volume (halaman ini)",
    "Volume (this page)": "Volume (halaman ini)",
    "orders.seller_entries": "Entri penjual",
    "Seller Entries": "Entri penjual",
    "orders.customer_entries": "Entri pelanggan",
    "Customer Entries": "Entri pelanggan",
    "orders.filter_transactions": "Filter transaksi",
    "Filter Transactions": "Filter transaksi",
    "orders.reset_filters": "Atur ulang filter",
    "Reset filters": "Atur ulang filter",
    "orders.manage_transactions": "Kelola transaksi",
    "Manage your Transactions": "Kelola transaksi",
    "orders.empty_transactions_message": "Di sini Anda dapat melacak transaksi antar pengguna, seperti komisi, harga pesanan, biaya pembayaran, dan biaya khusus.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Di sini Anda dapat melacak transaksi antar pengguna, seperti komisi, harga pesanan, biaya pembayaran, dan biaya khusus.",
    "orders.super_type": "Jenis utama",
    "Super Type": "Jenis utama",
    "orders.exporting": "Mengekspor…",
    "Exporting…": "Mengekspor…",
    "orders.export_as_csv": "Ekspor sebagai CSV",
    "Export as CSV": "Ekspor sebagai CSV",
    "orders.search_transactions": "Cari transaksi",
    "Search transactions": "Cari transaksi",
    "orders.filter": "Filter",
    "Filter": "Filter",
    "orders.transaction_status": "Status transaksi",
    "Transaction Status": "Status transaksi",
    "orders.seller_protection_fee": "Biaya Perlindungan Penjual",
    "Seller Protection Fee": "Biaya Perlindungan Penjual",
    "common.show_rows": "Tampilkan baris",
    "common.clear_all": "Hapus semua",
    "Clear All": "Hapus semua",
    "orders.order_number_value": "Pesanan #{number}",
    "orders.transactions": "Transaksi",
    "reported_listings.report_detail": "Detail laporan",
    "Report Detail": "Detail laporan",
    "reported_listings.reported_listing": "Listing yang dilaporkan",
    "Reported Listing": "Listing yang dilaporkan",
    "reported_listings.pending": "Menunggu",
    "reported_listings.approved": "Disetujui",
    "reported_listings.rejected": "Ditolak",
    "reported_listings.view_marketplace": "Lihat di marketplace",
    "View on marketplace": "Lihat di marketplace",
    "reported_listings.approve_listing": "Setujui listing",
    "Approve listing": "Setujui listing",
    "reported_listings.reject_listing": "Tolak listing",
    "Reject listing": "Tolak listing",
    "reported_listings.reported_by": "Dilaporkan oleh",
    "Reported By": "Dilaporkan oleh",
    "reported_listings.blocked": "Diblokir",
    "reported_listings.unblock_user": "Buka blokir pengguna",
    "Unblock user": "Buka blokir pengguna",
    "reported_listings.block_user": "Blokir pengguna",
    "Block user": "Blokir pengguna",
    "reported_listings.report_info": "Info laporan",
    "Report Info": "Info laporan",
    "reported_listings.reason": "Alasan",
    "reported_listings.reported_on": "Tanggal laporan",
    "Reported on": "Tanggal laporan",
    "reported_listings.listing_id": "ID listing",
    "Listing ID": "ID listing",
    "reported_listings.reporter": "Pelapor",
    "Reporter": "Pelapor",
    "reported_listings.listing": "Listing",
    "Listing": "Listing",
    "reported_listings.status": "Status",
    "reported_listings.title": "Listing yang dilaporkan",
    "reported_listings.report_count": "Laporan: {count}",
    "Reports: {count}": "Laporan: {count}",
    "reported_listings.empty_title": "Melihat listing yang dilaporkan",
    "Viewing Reported listings": "Melihat listing yang dilaporkan",
    "reported_listings.empty_message": "Di sini Anda akan menemukan listing yang dilaporkan pengguna.",
    "You will find your users reported listings here": "Di sini Anda akan menemukan listing yang dilaporkan pengguna.",
    "common.page_of": "Halaman {page} dari {total}",
    "Page {page} of {total}": "Halaman {page} dari {total}",
    "common.view": "Lihat",
    "reviews.empty_title": "Melihat rating & ulasan",
    "Viewing Rate & Reviews": "Melihat rating & ulasan",
    "reviews.empty_message": "Di sini Anda akan menemukan rating dan ulasan pengguna.",
    "You will find your users ratings and reviews here": "Di sini Anda akan menemukan rating dan ulasan pengguna.",
    "reviews.list": "Daftar",
    "reviews.grid": "Kisi-kisi",
    "Grid": "Kisi-kisi",
    "reviews.title": "Ulasan & Rating",
    "reviews.review": "Ulasan",
    "reviews.name": "Nama",
    "reviews.rating": "Rating",
    "reviews.title_column": "Judul",
    "reviews.content": "Konten",
    "Content": "Konten",
    "reviews.image": "Gambar",
    "Image": "Gambar",
    "reviews.images": "Gambar",
    "Images": "Gambar",
    "reviews.accounts": "Akun",
    "reviews.listings": "Listing",
    "reviews.star": "Bintang",
    "Star": "Bintang",
    "reviews.review_image": "Gambar ulasan",
    "Review image": "Gambar ulasan",
    "reviews.title_required": "Judul wajib diisi",
    "Title is required": "Judul wajib diisi",
    "reviews.content_required": "Konten wajib diisi",
    "Content is required": "Konten wajib diisi",
    "reviews.updated_successfully": "Ulasan berhasil diperbarui",
    "Review updated successfully": "Ulasan berhasil diperbarui",
    "reviews.edit_review": "Edit ulasan",
    "Edit Review": "Edit ulasan",
    "common.not_available": "Tidak tersedia",
    "common.something_went_wrong": "Terjadi kesalahan",
    "Something went wrong": "Terjadi kesalahan",
    "media.load_failed": "Gagal memuat media.",
    "Unable to load media.": "Gagal memuat media.",
    "media.load_failed_retry": "Gagal memuat media. Silakan coba lagi.",
    "media.update_failed": "Media gagal diperbarui",
    "Media update failed": "Media gagal diperbarui",
    "media.renamed": "Nama media diubah",
    "Media renamed": "Nama media diubah",
    "media.moved": "Media dipindahkan",
    "Media moved": "Media dipindahkan",
    "media.rename_failed": "Media gagal diganti namanya",
    "Unable to rename media": "Media gagal diganti namanya",
    "media.move_failed": "Media gagal dipindahkan",
    "Unable to move media": "Media gagal dipindahkan",
    "media.deleted": "Media dihapus",
    "Media deleted": "Media dihapus",
    "media.delete_failed": "Media gagal dihapus",
    "Unable to delete media": "Media gagal dihapus",
    "media.confirm_delete": "Yakin ingin menghapus media ini?",
    "Are you sure you want to delete this media?": "Yakin ingin menghapus media ini?",
    "media.delete_media": "Hapus media",
    "Delete media": "Hapus media",
    "media.folder_creation_web_only": "Pembuatan folder tersedia di web",
    "Folder creation is available on web": "Pembuatan folder tersedia di web",
    "media.no_create_folder_permission": "Anda tidak memiliki izin untuk membuat folder",
    "You do not have permission to create folders": "Anda tidak memiliki izin untuk membuat folder",
    "media.folder_name": "Nama folder",
    "Folder name": "Nama folder",
    "media.folder_created": "Folder dibuat",
    "Folder created": "Folder dibuat",
    "media.folder_create_failed": "Gagal membuat folder",
    "Unable to create folder": "Gagal membuat folder",
    "media.link_copied": "Tautan disalin",
    "Link copied": "Tautan disalin",
    "media.copy_link_failed": "Gagal menyalin tautan",
    "Unable to copy link": "Gagal menyalin tautan",
    "media.urls_copied": "{count} URL disalin",
    "{count} URLs copied": "{count} URL disalin",
    "media.clipboard_unavailable": "Clipboard tidak tersedia",
    "Clipboard is not available": "Clipboard tidak tersedia",
    "media.copy_urls_failed": "Gagal menyalin URL",
    "Unable to copy URLs": "Gagal menyalin URL",
    "media.upload_failed": "Media gagal diunggah",
    "Media upload failed": "Media gagal diunggah",
    "media.replace_success": "Media diganti. ID dan tautan tetap tidak berubah.",
    "Media replaced. The media ID and stable link are unchanged.": "Media diganti. ID dan tautan tetap tidak berubah.",
    "media.replace_failed": "Media gagal diganti",
    "Unable to replace media": "Media gagal diganti",
    "media.csv_upload_failed": "CSV gagal diunggah",
    "CSV upload failed": "CSV gagal diunggah",
    "media.csv_metadata_failed": "Gagal menyimpan metadata CSV",
    "Unable to save CSV metadata": "Gagal menyimpan metadata CSV",
    "media.csv_saved_version": "CSV disimpan sebagai versi baru",
    "CSV saved as a new version": "CSV disimpan sebagai versi baru",
    "media.csv_save_failed": "Gagal menyimpan CSV",
    "Unable to save CSV": "Gagal menyimpan CSV",
    "media.uploading_files": "Mengunggah {count} file…",
    "Uploading {count} files…": "Mengunggah {count} file…",
    "media.upload_progress": "Mengunggah {count} file · {progress}%",
    "Uploading {count} files · {progress}%": "Mengunggah {count} file · {progress}%",
    "media.upload_success": "{count} file berhasil diunggah.",
    "{count} files uploaded successfully.": "{count} file berhasil diunggah.",
    "media.upload_failed_retry": "Media gagal diunggah. Silakan coba lagi.",
    "Unable to upload media. Please try again.": "Media gagal diunggah. Silakan coba lagi.",
    "media.register_failed": "Media gagal didaftarkan",
    "Unable to register media": "Media gagal didaftarkan",
    "media.list_view": "Tampilan daftar",
    "List view": "Tampilan daftar",
    "media.grid_view": "Tampilan kisi",
    "Grid view": "Tampilan kisi",
    "media.copy_uploaded_urls": "Salin URL yang diunggah",
    "Copy uploaded URLs": "Salin URL yang diunggah",
    "media.copy_visible_urls": "Salin URL yang terlihat",
    "Copy visible URLs": "Salin URL yang terlihat",
    "media.copy_all_urls": "Salin semua URL",
    "Copy all URLs": "Salin semua URL",
    "media.new_folder": "Folder baru",
    "New folder": "Folder baru",
    "media.uploading_progress": "Mengunggah {progress}%",
    "Uploading {progress}%": "Mengunggah {progress}%",
    "media.upload_media": "Unggah media",
    "Upload media": "Unggah media",
    "media.manager_title": "Pengelola Media",
    "Media Manager": "Pengelola Media",
    "media.search": "Cari media",
    "Search media": "Cari media",
    "media.location": "Lokasi",
    "media.media_root": "Media",
    "media.show_type": "Tampilkan media {type}",
    "Show {type} media": "Tampilkan media {type}",
    "media.type_all": "semua",
    "all": "semua",
    "media.type_image": "gambar",
    "image": "gambar",
    "media.type_video": "video",
    "video": "video",
    "media.type_audio": "audio",
    "audio": "audio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "folder",
    "folder": "folder",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Terlama",
    "Oldest": "Terlama",
    "media.newest": "Terbaru",
    "Newest": "Terbaru",
    "media.sort_current": "Urutkan media, saat ini {sort}",
    "Sort media, currently {sort}": "Urutkan media, saat ini {sort}",
    "media.loading": "Memuat media…",
    "Loading media…": "Memuat media…",
    "media.no_filter_matches": "Tidak ada media yang cocok dengan filter ini.",
    "No media matches these filters.": "Tidak ada media yang cocok dengan filter ini.",
    "media.empty_title": "Pustaka media Anda kosong",
    "Your media library is empty": "Pustaka media Anda kosong",
    "media.empty_message": "Unggah gambar, PDF, dan video untuk digunakan kembali, misalnya dalam promosi atau artikel.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Unggah gambar, PDF, dan video untuk digunakan kembali, misalnya dalam promosi atau artikel.",
    "media.empty_hint": "Unggah file atau buat folder untuk memulai.",
    "Upload files or create a folder to get started.": "Unggah file atau buat folder untuk memulai.",
    "media.folder": "Folder",
    "Folder": "Folder",
    "media.file_folder_name": "Nama file atau folder",
    "File or folder name": "Nama file atau folder",
    "media.rename_media": "Ganti nama media",
    "Rename media": "Ganti nama media",
    "media.move_media": "Pindahkan media",
    "Move media": "Pindahkan media",
    "media.pdf_preview": "Pratinjau PDF: {name}",
    "PDF preview: {name}": "Pratinjau PDF: {name}",
    "media.pdf_preview_web": "Pratinjau PDF tersedia di aplikasi web.",
    "PDF preview is available in the web app.": "Pratinjau PDF tersedia di aplikasi web.",
    "media.csv_preview_web": "Pratinjau CSV tersedia di aplikasi web.",
    "CSV preview is available in the web app.": "Pratinjau CSV tersedia di aplikasi web.",
    "media.media_file": "File media",
    "Media file": "File media",
    "media.share_link": "Bagikan tautan",
    "Share link": "Bagikan tautan",
    "media.copy_link": "Salin tautan",
    "Copy link": "Salin tautan",
    "media.replace_media": "Ganti media",
    "Replace media": "Ganti media",
    "media.folders": "Folder",
    "Folders": "Folder",
    "media.create_new_folder": "Buat folder baru",
    "Create new folder": "Buat folder baru",
    "media.go_to_all_media": "Buka semua media",
    "Go to all media": "Buka semua media",
    "media.all_media": "Semua media",
    "All media": "Semua media",
    "media.open_folder_name": "Buka folder {name}",
    "Open folder {name}": "Buka folder {name}",
    "media.no_subfolders": "Tidak ada subfolder",
    "No subfolders": "Tidak ada subfolder",
    "media.no_files_in_folder": "Tidak ada file di folder ini.",
    "No files in this folder.": "Tidak ada file di folder ini.",
    "media.upload_folder": "Unggah media ke folder ini",
    "Upload media to this folder": "Unggah media ke folder ini",
    "media.discard_csv_confirm": "Buang perubahan CSV?",
    "Discard your CSV changes?": "Buang perubahan CSV?",
    "media.unsaved_changes": "Perubahan belum disimpan",
    "Unsaved changes": "Perubahan belum disimpan",
    "media.find_csv": "Cari di CSV",
    "Find in CSV": "Cari di CSV",
    "media.save_csv": "Simpan CSV",
    "Save CSV": "Simpan CSV",
    "media.loading_csv": "Memuat CSV…",
    "Loading CSV…": "Memuat CSV…",
    "media.prepare_folder_failed": "Gagal menyiapkan folder unggahan",
    "Unable to prepare the upload folder": "Gagal menyiapkan folder unggahan",
    "media.add_file_required": "Tambahkan file",
    "Please add a file": "Tambahkan file",
    "media.add_media": "Tambahkan media",
    "Add Media": "Tambahkan media",
    "media.store_uploaded_media_in": "Simpan media yang diunggah di",
    "Store uploaded media in": "Simpan media yang diunggah di",
    "media.destination_business_cards": "Kartu nama bisnis",
    "Business Cards": "Kartu nama bisnis",
    "media.destination_listings": "Listing",
    "media.destination_accounts": "Akun",
    "media.destination_users": "Pengguna",
    "media.upload_media_title": "Unggah media",
    "Upload Media": "Unggah media",
    "media.media_files": "Media",
    "media.open_folder": "Buka folder",
    "Open folder": "Buka folder",
    "common.show": "Tampilkan",
    "common.share": "Bagikan",
    "common.copy": "Salin",
    "common.rename": "Ganti nama",
    "Rename": "Ganti nama",
    "common.move": "Pindahkan",
    "Move": "Pindahkan",
    "common.type": "Jenis",
    "common.size": "Ukuran",
    "Size": "Ukuran",
    "common.preview": "Pratinjau",
    "Preview": "Pratinjau",
    "common.undo": "Urungkan",
    "Undo": "Urungkan",
    "common.redo": "Ulangi",
    "Redo": "Ulangi",
    "common.discard": "Buang",
    "Discard": "Buang",
    "common.try_again": "Coba lagi",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Spreadsheet",
    "Spreadsheet": "Spreadsheet",
    "media.type_file": "File",
    "File": "File",
    "media.csv_load_failed": "Gagal memuat CSV. Silakan coba lagi.",
    "Unable to load CSV. Please try again.": "Gagal memuat CSV. Silakan coba lagi.",
    "workspace.settings_section.customisation": "Kustomisasi",
    "workspace.settings_section.integrations": "Integrasi",
    "workspace.settings_section.platform_setup": "Penyiapan platform",
    "Platform Setup": "Penyiapan platform",
    "workspace.settings_section.business_operations": "Operasi bisnis",
    "Business Operations": "Operasi bisnis",
    "workspace.settings_section.system_setup": "Penyiapan sistem",
    "System Setup": "Penyiapan sistem",
    "workspace.settings_item.app_customisation": "Kustomisasi aplikasi",
    "App Customisation": "Kustomisasi aplikasi",
    "workspace.settings_item.web_customisation": "Kustomisasi web",
    "workspace.settings_item.communications": "Komunikasi",
    "Communications": "Komunikasi",
    "workspace.settings_item.strings_customisation": "Kustomisasi teks",
    "Strings Customisation": "Kustomisasi teks",
    "workspace.settings_item.app_integrations": "Integrasi aplikasi",
    "workspace.settings_item.web_integrations": "Integrasi web",
    "Web Integrations": "Integrasi web",
    "workspace.settings_item.accounts": "Akun",
    "workspace.settings_item.listings": "Listing",
    "workspace.settings_item.checkout_and_cart_attributes": "Atribut checkout & keranjang",
    "workspace.settings_item.service_shipping": "Layanan / pengiriman",
    "workspace.settings_item.payments": "Pembayaran",
    "workspace.settings_item.commissions": "Komisi",
    "workspace.settings_item.taxes": "Pajak",
    "workspace.settings_item.special_fees": "Biaya khusus",
    "workspace.settings_item.languages": "Bahasa",
    "workspace.settings_item.currency": "Mata uang",
    "workspace.settings_item.countries": "Negara",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Ekstensi",
    "Extensions": "Ekstensi",
    "workspace.settings_item.manage_features": "Kelola fitur",
    "workspace.settings_item.audit_logs": "Log audit",
    "Audit Logs": "Log audit",
    "workspace.settings_item.auth": "Autentikasi",
    "workspace.settings_item.maps": "Peta",
    "workspace.settings_hint.accounts": "Contoh: Toko",
    "Example: Store": "Contoh: Toko",
    "workspace.settings_hint.listings": "Contoh: Produk, Acara",
    "Example: Products, Events": "Contoh: Produk, Acara",
    "workspace.settings_hint.audit_logs": "Jejak kepatuhan & keamanan",
    "Compliance & security trail": "Jejak kepatuhan & keamanan",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Penggunaan penyedia dan pengaturan privasi",
    "Provider usage and privacy settings": "Penggunaan penyedia dan pengaturan privasi",
    "workspace.settings_access_denied": "Anda tidak memiliki akses ke {name}",
    "You don't have access of {name}": "Anda tidak memiliki akses ke {name}",
    "app_customization.title": "Kustomisasi aplikasi",
    "app_customization.tab_0": "Umum",
    "General": "Umum",
    "app_customization.tab_1": "Splash",
    "Splash": "Splash",
    "app_customization.tab_2": "Onboarding",
    "Onboarding": "Onboarding",
    "app_customization.tab_3": "Pendaftaran",
    "Registration": "Pendaftaran",
    "app_customization.tab_4": "Beranda",
    "Home": "Beranda",
    "app_customization.tab_5": "Notifikasi push",
    "Push Notification": "Notifikasi push",
    "app_customization.tab_6": "Chat",
    "Chat": "Chat",
    "app_customization.tab_7": "Menu lainnya",
    "More Menu": "Menu lainnya",
    "app_customization.tab_8": "Pembaruan wajib",
    "Force Update": "Pembaruan wajib",
    "app_customization.tab_9": "Alamat",
    "app_customization.hide_balances": "Sembunyikan saldo & pembayaran di menu lainnya",
    "app_customization.more": "Lainnya",
    "app_customization.force_update": "Paksa pembaruan",
    "Force To Update": "Paksa pembaruan",
    "app_customization.android_version": "Versi aplikasi Android",
    "Android app version": "Versi aplikasi Android",
    "app_customization.enter_android_version": "Masukkan versi aplikasi Android",
    "Enter android app version": "Masukkan versi aplikasi Android",
    "app_customization.ios_version": "Versi aplikasi iOS",
    "iOS app version": "Versi aplikasi iOS",
    "app_customization.enter_ios_version": "Masukkan versi aplikasi iOS",
    "Enter iOS app version": "Masukkan versi aplikasi iOS",
    "app_customization.chat": "Chat",
    "app_customization.chat_send_listing": "Otomatis kirim listing saat chat dibuka (default menampilkan pratinjau di atas)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Otomatis kirim listing saat chat dibuka (default menampilkan pratinjau di atas)",
    "app_customization.make_offer": "Ajukan penawaran / negosiasi",
    "Make Offer / Negotiation": "Ajukan penawaran / negosiasi",
    "app_customization.negotiation_button_name": "Nama tombol negosiasi:",
    "Negotiation button name:": "Nama tombol negosiasi:",
    "app_customization.negotiation_button_example": "(contoh: Ajukan Penawaran, Negosiasi, Minta Harga)",
    "(example: Make Offer, Negotiate, Quote)": "(contoh: Ajukan Penawaran, Negosiasi, Minta Harga)",
    "app_customization.enter_negotiation_button_name": "Masukkan nama tombol negosiasi",
    "Enter negotiation button name": "Masukkan nama tombol negosiasi",
    "app_customization.address": "Alamat",
    "app_customization.address_option_0": "Tampilkan Alamat 2",
    "Show Address 2": "Tampilkan Alamat 2",
    "app_customization.address_option_1": "Tampilkan Negara",
    "Show Country": "Tampilkan Negara",
    "app_customization.address_option_2": "Tampilkan Kode Pos",
    "Show Zipcode": "Tampilkan Kode Pos",
    "app_customization.address_option_3": "Tampilkan Provinsi",
    "Show State": "Tampilkan Provinsi",
    "app_customization.address_option_4": "Tampilkan Patokan",
    "Show Landmark": "Tampilkan Patokan",
    "app_customization.address_option_5": "Tampilkan Kota",
    "Show City": "Tampilkan Kota",
    "app_customization.persistent_notification": "Notifikasi persisten",
    "Persistent Notification": "Notifikasi persisten",
    "app_customization.account_follow_content": "Konten notifikasi mengikuti akun",
    "Account follow notification content": "Konten notifikasi mengikuti akun",
    "app_customization.enter_account_follow_content": "Masukkan konten notifikasi mengikuti akun",
    "Enter Account follow notification content": "Masukkan konten notifikasi mengikuti akun",
    "app_customization.listing_like_content": "Konten notifikasi suka listing",
    "Listing like notification content": "Konten notifikasi suka listing",
    "app_customization.enter_listing_like_content": "Masukkan konten notifikasi suka listing",
    "Enter Listing like  notification content": "Masukkan konten notifikasi suka listing",
    "app_customization.order_status_content": "Konten notifikasi status pesanan",
    "Order status notification content": "Konten notifikasi status pesanan",
    "app_customization.enter_order_status_content": "Masukkan konten notifikasi status pesanan",
    "Order status follow notification content": "Masukkan konten notifikasi status pesanan",
    "app_customization.account_follow_required": "Notifikasi mengikuti akun harus berisi {account_name}",
    "Account follow notification should contain {account_name}": "Notifikasi mengikuti akun harus berisi {account_name}",
    "app_customization.listing_like_required": "Konten notifikasi suka listing harus berisi {user_name}",
    "Listing like notification content should contain {user_name}": "Konten notifikasi suka listing harus berisi {user_name}",
    "app_customization.order_number_required": "Notifikasi status pesanan harus berisi #{order_number}",
    "Order status notification content should contain #{order_number}": "Notifikasi status pesanan harus berisi #{order_number}",
    "app_customization.order_status_required": "Notifikasi status pesanan harus berisi {order_status}",
    "Order status notification content should contain {order_status}": "Notifikasi status pesanan harus berisi {order_status}",
    "app_customization.preview": "Pratinjau",
    "app_customization.splash": "Splash",
    "app_customization.splash_image": "Gambar layar splash",
    "Splash Screen Image": "Gambar layar splash",
    "app_customization.registration": "Pendaftaran",
    "app_customization.registration_text": "Teks pendaftaran",
    "Registration text": "Teks pendaftaran",
    "app_customization.otp_note": "Catatan verifikasi OTP",
    "OTP Verification note": "Catatan verifikasi OTP",
    "app_customization.get_signup_first": "Buka pendaftaran terlebih dahulu",
    "app_customization.mobile_in_email_signup": "Nomor ponsel pada pendaftaran email",
    "Mobile number in email signup": "Nomor ponsel pada pendaftaran email",
    "app_customization.preview_field_first_name": "Nama depan",
    "app_customization.preview_field_last_name": "Nama belakang",
    "app_customization.preview_field_email": "Email",
    "app_customization.preview_field_password": "Kata sandi",
    "Password": "Kata sandi",
    "app_customization.preview_field_confirm_password": "Konfirmasi kata sandi",
    "Confirm Password": "Konfirmasi kata sandi",
    "app_customization.preview_field_dob": "Tanggal lahir",
    "DOB": "Tanggal lahir",
    "app_customization.preview_field_mobile_no": "Nomor ponsel",
    "Mobile No": "Nomor ponsel",
    "app_customization.create": "Buat",
    "app_customization.login": "Masuk",
    "Login": "Masuk",
    "app_customization.create_account": "Buat akun",
    "Create your account": "Buat akun",
    "app_customization.login_account": "Masuk ke akun",
    "Login to your account": "Masuk ke akun",
    "app_customization.onboarding_settings": "Pengaturan onboarding",
    "Onboarding Settings": "Pengaturan onboarding",
    "app_customization.onboarding_images": "Gambar onboarding",
    "Onboarding Images": "Gambar onboarding",
    "app_customization.onboarding_text_1": "Teks onboarding 1",
    "Onboarding text 1": "Teks onboarding 1",
    "app_customization.onboarding_text_2": "Teks onboarding 2",
    "Onboarding text 2": "Teks onboarding 2",
    "app_customization.onboarding_text_3": "Teks onboarding 3",
    "Onboarding text 3": "Teks onboarding 3",
    "app_customization.see_how_it_works": "Lihat cara kerjanya",
    "See how it works": "Lihat cara kerjanya",
    "app_customization.sell_icon_text": "Teks ikon jual",
    "Sell icon text": "Teks ikon jual",
    "app_customization.enter_sell_icon_text": "Masukkan teks ikon jual",
    "Enter sell icon text": "Masukkan teks ikon jual",
    "app_customization.sell_icon": "Ikon jual",
    "Sell Icon": "Ikon jual",
    "app_customization.enter_home_title": "Masukkan judul aplikasi di beranda",
    "Enter app title in home": "Masukkan judul aplikasi di beranda",
    "app_customization.app_details": "Detail aplikasi",
    "App Details": "Detail aplikasi",
    "app_customization.app_name": "Nama aplikasi",
    "App Name": "Nama aplikasi",
    "app_customization.primary_colour": "Warna utama aplikasi",
    "App Primary Colour": "Warna utama aplikasi",
    "app_customization.secondary_colour": "Warna sekunder aplikasi",
    "App Secondary Colour": "Warna sekunder aplikasi",
    "app_customization.android_app_icon": "Ikon aplikasi Android",
    "App Icon Android": "Ikon aplikasi Android",
    "app_customization.ios_app_icon": "Ikon aplikasi iOS",
    "App Icon iOS": "Ikon aplikasi iOS",
    "app_customization.screen_number": "Layar {number}",
    "Screen {number}": "Layar {number}",
    "app_customization.upload_here": "Unggah di sini",
    "Upload here": "Unggah di sini",
    "app_customization.next": "Berikutnya",
    "app_customization.get_started": "Mulai",
    "Get Start": "Mulai",
    "app_customization.select": "Pilih",
    "Select": "Pilih",
    "app_customization.app_title_home_icon": "Ikon judul aplikasi di beranda",
    "App Title Home Icon": "Ikon judul aplikasi di beranda",
    "app_customization.home_icon_hint": "(ikon harus berwarna putih dan berformat PNG)",
    "(icon should be white and in png format)": "(ikon harus berwarna putih dan berformat PNG)",
    "app_customization.home_title": "Judul aplikasi di beranda",
    "app_customization.default_collection_widgets": "Widget koleksi default",
    "Default Collection Widgets": "Widget koleksi default",
    "app_customization.accounts_follow_title": "Judul koleksi akun untuk diikuti",
    "Accounts to follow collection title": "Judul koleksi akun untuk diikuti",
    "app_customization.enter_accounts_follow_title": "Masukkan judul koleksi akun untuk diikuti",
    "Enter accounts to follow collection title": "Masukkan judul koleksi akun untuk diikuti",
    "app_customization.nearby_accounts_title": "Judul koleksi akun terdekat",
    "Nearby accounts collection title": "Judul koleksi akun terdekat",
    "app_customization.enter_nearby_accounts_title": "Masukkan judul koleksi akun terdekat",
    "Enter near by accounts collection title": "Masukkan judul koleksi akun terdekat",
    "app_customization.latest_listings_title": "Judul koleksi listing terbaru",
    "Latest listings collection title": "Judul koleksi listing terbaru",
    "app_customization.enter_latest_listings_title": "Masukkan judul koleksi listing terbaru",
    "Enter latest listings collection title": "Masukkan judul koleksi listing terbaru",
    "app_customization.enable_appearance_sections": "Pilih untuk mengaktifkan bagian tampilan",
    "Select to enable appearance sections": "Pilih untuk mengaktifkan bagian tampilan",
    "app_customization.choose_photo": "Pilih foto",
    "Choose photo": "Pilih foto",
    "app_customization.choose_icon": "Pilih ikon",
    "Choose icon": "Pilih ikon",
    "app_customization.enable_home_icon": "Gunakan ikon judul aplikasi, bukan teks",
    "app_customization.account_name": "Nama akun",
    "Account Name": "Nama akun",
    "app_customization.product_name": "Nama produk",
    "Product Name": "Nama produk",
    "app_customization.home_option_0": "Tampilkan koleksi terdekat",
    "Show nearby collection": "Tampilkan koleksi terdekat",
    "app_customization.home_option_1": "Tampilkan bagian kategori",
    "Show category section": "Tampilkan bagian kategori",
    "app_customization.home_option_2": "Tampilkan banner promosi",
    "Show promo banners": "Tampilkan banner promosi",
    "app_customization.home_option_3": "Tampilkan ajakan teman",
    "Show invite friends": "Tampilkan ajakan teman",
    "app_customization.home_option_4": "Tampilkan pengingat ulasan",
    "Show review reminders": "Tampilkan pengingat ulasan",
    "app_customization.home_option_5": "Akun untuk diikuti",
    "Accounts to follow": "Akun untuk diikuti",
    "app_customization.download": "Unduh",
    "app_customization.cancel": "Batal",
    "app_customization.uploaded_successfully": "Berhasil diunggah",
    "app_customization.image_limit": "Anda tidak dapat memilih lebih banyak gambar",
    "You cannot select more images": "Anda tidak dapat memilih lebih banyak gambar",
    "app_customization.choose_zip_file": "Pilih file ZIP",
    "Choose zip file": "Pilih file ZIP",
    "app_translation.title": "Kustomisasi teks",
    "app_translation.search": "Ketik untuk mencari…",
    "Type to search...": "Ketik untuk mencari…",
    "app_translation.default_language": "Default",
    "Default": "Default",
    "app_translation.default_text": "Teks default",
    "Default text": "Teks default",
    "communications.title": "Komunikasi",
    "communications.tab_0": "Notifikasi email",
    "Email Notification": "Notifikasi email",
    "communications.tab_1": "Konfigurasi email",
    "Email Configuration": "Konfigurasi email",
    "communications.tab_2": "Notifikasi pesanan",
    "Order Notification": "Notifikasi pesanan",
    "communications.tab_3": "Formulir masukan",
    "Feedback Form": "Formulir masukan",
    "communications.translate": "Terjemahkan",
    "Translate": "Terjemahkan",
    "communications.edit_email_template": "Edit templat email",
    "Edit email template": "Edit templat email",
    "communications.feedback_email": "Email",
    "communications.feedback_phone": "Telepon",
    "communications.feedback_email_or_phone": "Email atau telepon",
    "Email or Phone": "Email atau telepon",
    "communications.select_type": "Pilih jenis",
    "Select type": "Pilih jenis",
    "communications.form_required_field": "Kolom wajib formulir",
    "Form Required Field": "Kolom wajib formulir",
    "communications.feedback_recipient_label": "Email penerima masukan (pisahkan beberapa email dengan koma)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Email penerima masukan (pisahkan beberapa email dengan koma)",
    "communications.enter_email": "Masukkan email",
    "Enter email": "Masukkan email",
    "communications.enable_feedback_form": "Aktifkan formulir masukan",
    "Enable feedback Form": "Aktifkan formulir masukan",
    "communications.feedback": "Masukan",
    "Feedback": "Masukan",
    "communications.realtime_config_notice": "Konfigurasi di bawah diterapkan secara langsung. Setelah disimpan, perubahan akan terlihat di aplikasi dan respons API.",
    "communications.uploaded_successfully": "Berhasil diunggah",
    "communications.email_whitelabeling": "White label email",
    "Email Whitelabelling": "White label email",
    "communications.from_name": "Nama pengirim",
    "From name": "Nama pengirim",
    "communications.enter_from_name": "Masukkan nama pengirim",
    "Enter from name": "Masukkan nama pengirim",
    "communications.from_email_address": "Alamat email pengirim",
    "From email address": "Alamat email pengirim",
    "communications.from_email_domain_hint": "Anda menggunakan domain khusus untuk alamat pengirim. Agar email terkirim, verifikasi domain Anda kepada kami. Hubungi tim dukungan untuk bantuan.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Anda menggunakan domain khusus untuk alamat pengirim. Agar email terkirim, verifikasi domain Anda kepada kami. Hubungi tim dukungan untuk bantuan.",
    "communications.reset": "Atur ulang",
    "communications.enter_from_email": "Masukkan email pengirim",
    "Enter from email address": "Masukkan email pengirim",
    "communications.email_header_logo": "Logo header email",
    "Email Header Logo": "Logo header email",
    "communications.choose_logo": "Pilih file 50*50",
    "Choose file 50*50": "Pilih file 50*50",
    "communications.list_view": "Tampilan daftar",
    "communications.gallery_view": "Tampilan galeri",
    "Gallery view": "Tampilan galeri",
    "communications.grid_view": "Tampilan kisi",
    "communications.search": "Cari komunikasi",
    "Search communications": "Cari komunikasi",
    "communications.email_settings": "Pengaturan email",
    "Email settings": "Pengaturan email",
    "communications.category_all": "Semua",
    "communications.category_buyer": "Pembeli",
    "Buyer": "Pembeli",
    "communications.category_seller": "Penjual",
    "communications.category_transactional": "Transaksional",
    "Transactional": "Transaksional",
    "communications.category_engagement": "Keterlibatan",
    "Engagement": "Keterlibatan",
    "communications.category_retention": "Retensi",
    "Retention": "Retensi",
    "communications.category_membership": "Keanggotaan",
    "communications.audience_buyer": "Pembeli",
    "communications.audience_seller": "Penjual",
    "communications.system_notification": "Notifikasi sistem",
    "System notification": "Notifikasi sistem",
    "communications.template": "templat",
    "template": "templat",
    "communications.edit": "Edit",
    "communications.sent": "terkirim",
    "sent": "terkirim",
    "communications.open": "dibuka",
    "communications.clicks": "klik",
    "clicks": "klik",
    "communications.no_email_matches": "Tidak ada email yang cocok dengan filter.",
    "No emails match your filter.": "Tidak ada email yang cocok dengan filter.",
    "communications.buyer_order_confirmation": "Email konfirmasi pesanan untuk pembeli",
    "Order confirmation email for buyer": "Email konfirmasi pesanan untuk pembeli",
    "communications.seller_order_confirmation": "Email konfirmasi pesanan untuk penjual",
    "Order confirmation email for seller": "Email konfirmasi pesanan untuk penjual",
    "communications.email_card_0": "Email sambutan",
    "Welcome Message": "Email sambutan",
    "communications.email_card_1": "OTP / verifikasi",
    "OTP / Verification": "OTP / verifikasi",
    "communications.email_card_2": "Tautan langganan",
    "Subscription Link": "Tautan langganan",
    "communications.email_card_3": "Langganan berhasil",
    "Subscription Success": "Langganan berhasil",
    "communications.email_card_4": "Konfirmasi pesanan — pembeli",
    "Order confirmation — buyer": "Konfirmasi pesanan — pembeli",
    "communications.email_card_5": "Konfirmasi pesanan — penjual",
    "Order confirmation — seller": "Konfirmasi pesanan — penjual",
    "communications.email_card_6": "Pesanan dikirim — pembeli",
    "Shipment shipped — buyer": "Pesanan dikirim — pembeli",
    "communications.email_card_7": "Pesanan diantar — pembeli",
    "Shipment delivered — buyer": "Pesanan diantar — pembeli",
    "communications.email_card_8": "Pesanan dibatalkan — pembeli",
    "Order cancelled — buyer": "Pesanan dibatalkan — pembeli",
    "communications.email_card_9": "Refund diproses — pembeli",
    "Refund processed — buyer": "Refund diproses — pembeli",
    "communications.email_card_10": "Listing baru dari toko yang diikuti — pembeli",
    "New listing from followed store — buyer": "Listing baru dari toko yang diikuti — pembeli",
    "communications.email_card_11": "Stok tersedia kembali — pembeli",
    "Back in stock — buyer": "Stok tersedia kembali — pembeli",
    "communications.email_card_12": "Peringatan listing akan kedaluwarsa — penjual",
    "Listing expiry warning — seller": "Peringatan listing akan kedaluwarsa — penjual",
    "communications.email_card_13": "Pencapaian suka listing — penjual",
    "Listing likes milestone — seller": "Pencapaian suka listing — penjual",
    "communications.email_card_14": "Akun terverifikasi — penjual",
    "Account verified — seller": "Akun terverifikasi — penjual",
    "communications.email_card_15": "Mengajak penjual kembali — penjual",
    "Seller win-back — seller": "Mengajak penjual kembali — penjual",
    "communications.email_card_16": "Peringatan stok rendah — penjual",
    "Low stock warning — seller": "Peringatan stok rendah — penjual",
    "communications.email_card_17": "Penjual berhasil bergabung — penjual",
    "Seller onboarded — seller": "Penjual berhasil bergabung — penjual",
    "communications.email_card_18": "Permintaan ulasan — pembeli",
    "Review request — buyer": "Permintaan ulasan — pembeli",
    "communications.email_card_19": "Penjualan pertama — penjual",
    "First sale — seller": "Penjualan pertama — penjual",
    "communications.email_card_20": "Tonggak penjualan — penjual",
    "Sales milestone — seller": "Tonggak penjualan — penjual",
    "communications.email_card_21": "Mengajak pembeli kembali — pembeli",
    "Win-back — buyer": "Mengajak pembeli kembali — pembeli",
    "communications.email_card_22": "Pembelian pertama — pembeli",
    "First purchase — buyer": "Pembelian pertama — pembeli",
    "communications.email_card_23": "Pertanyaan pelanggan — penjual",
    "Customer question — seller": "Pertanyaan pelanggan — penjual",
    "communications.email_card_24": "Jawaban penjual — pembeli",
    "Seller answer — buyer": "Jawaban penjual — pembeli",
    "communications.email_card_25": "Tawaran negosiasi — penjual",
    "Negotiation offer — seller": "Tawaran negosiasi — penjual",
    "communications.email_card_26": "Penawaran diterima — pembeli",
    "Offer accepted — buyer": "Penawaran diterima — pembeli",
    "communications.email_card_27": "Penawaran ditolak — pembeli",
    "Offer rejected — buyer": "Penawaran ditolak — pembeli",
    "communications.email_card_28": "Pengikut baru — penjual",
    "New follower — seller": "Pengikut baru — penjual",
    "communications.email_card_29": "Listing disukai — penjual",
    "Listing liked — seller": "Listing disukai — penjual",
    "communications.email_card_30": "Listing disetujui — penjual",
    "Listing approved — seller": "Listing disetujui — penjual",
    "communications.email_card_31": "Listing ditolak — penjual",
    "Listing rejected — seller": "Listing ditolak — penjual",
    "communications.email_card_32": "Listing pertama — penjual",
    "First listing — seller": "Listing pertama — penjual",
    "communications.email_card_33": "Keranjang tertinggal — pembeli",
    "Abandoned cart — buyer": "Keranjang tertinggal — pembeli",
    "communications.email_card_34": "Ulasan listing — penjual",
    "Listing review — seller": "Ulasan listing — penjual",
    "communications.email_card_35": "Pengingat pemenuhan — penjual",
    "Fulfillment reminder — seller": "Pengingat pemenuhan — penjual",
    "communications.email_card_36": "Harga turun — pembeli",
    "Price drop — buyer": "Harga turun — pembeli",
    "communications.email_card_37": "Pembayaran keanggotaan segera jatuh tempo",
    "Membership payment due soon": "Pembayaran keanggotaan segera jatuh tempo",
    "communications.email_card_38": "Pembayaran keanggotaan terlambat",
    "Membership payment overdue": "Pembayaran keanggotaan terlambat",
    "communications.order_status_notification": "Notifikasi status pesanan",
    "Order Status Notification": "Notifikasi status pesanan",
    "communications.order_group_lifecycle": "Siklus pesanan",
    "Order lifecycle": "Siklus pesanan",
    "communications.order_group_returns": "Pengembalian dan masalah pengiriman",
    "Returns and delivery issues": "Pengembalian dan masalah pengiriman",
    "communications.order_group_cancellations": "Pembatalan dan pengambilan",
    "Cancellations and pickup": "Pembatalan dan pengambilan",
    "communications.notification_settings_count": "{count} pengaturan notifikasi",
    "{count} notification settings": "{count} pengaturan notifikasi",
    "communications.enter_order_field": "Masukkan {field}",
    "Enter {field}": "Masukkan {field}",
    "communications.order_field_0": "Status pesanan dikonfirmasi",
    "Order status confirmed": "Status pesanan dikonfirmasi",
    "communications.order_field_1": "Status pesanan sedang diproses",
    "Order status in progress": "Status pesanan sedang diproses",
    "communications.order_field_2": "Status pesanan dikirim",
    "Order status shipped": "Status pesanan dikirim",
    "communications.order_field_3": "Status pesanan: pelanggan tidak dapat dihubungi",
    "Order status customer unreachable": "Status pesanan: pelanggan tidak dapat dihubungi",
    "communications.order_field_4": "Status pesanan: sedang diantar",
    "Order status out for delivery": "Status pesanan: sedang diantar",
    "communications.order_field_5": "Status pesanan: gagal diantar, dikembalikan",
    "Order status undelivered returned": "Status pesanan: gagal diantar, dikembalikan",
    "communications.order_field_6": "Status pesanan: pengembalian karena gagal antar dikonfirmasi",
    "Order status undelivered return confirmed": "Status pesanan: pengembalian karena gagal antar dikonfirmasi",
    "communications.order_field_7": "Status pesanan: diantar",
    "Order status delivered": "Status pesanan: diantar",
    "communications.order_field_8": "Status pesanan: pengiriman dikonfirmasi",
    "Order status delivered confirmed": "Status pesanan: pengiriman dikonfirmasi",
    "communications.order_field_9": "Status pesanan: pelanggan memulai pengembalian",
    "Order status customer return initiated": "Status pesanan: pelanggan memulai pengembalian",
    "communications.order_field_10": "Status pesanan: barang retur dijemput",
    "Order status customer return picked": "Status pesanan: barang retur dijemput",
    "communications.order_field_11": "Status pesanan: pengembalian dikonfirmasi",
    "Order status customer return confirmed": "Status pesanan: pengembalian dikonfirmasi",
    "communications.order_field_12": "Status pesanan: pengembalian disengketakan",
    "Order status customer return disputed": "Status pesanan: pengembalian disengketakan",
    "communications.order_field_13": "Status pesanan: dibatalkan oleh akun",
    "Order status cancelled by account": "Status pesanan: dibatalkan oleh akun",
    "communications.order_field_14": "Status pesanan: dibatalkan oleh pelanggan",
    "Order status cancelled by customer": "Status pesanan: dibatalkan oleh pelanggan",
    "communications.order_field_15": "Status pesanan: siap diambil",
    "Order status ready for pickup": "Status pesanan: siap diambil",
    "communications.order_field_16": "Status pesanan: selesai",
    "Order status completed": "Status pesanan: selesai",
    "communications.update": "Perbarui",
    "communications.download_template": "Unduh templat",
    "Download Template": "Unduh templat",
    "communications.reset_to_default": "Kembalikan ke default",
    "communications.send_test_email": "Kirim email uji",
    "Send test email": "Kirim email uji",
    "communications.enter_test_emails": "Masukkan email (pisahkan dengan koma)",
    "Enter email(s), comma-separated": "Masukkan email (pisahkan dengan koma)",
    "communications.send_test": "Kirim uji",
    "Send test": "Kirim uji",
    "communications.subject_required": "Subjek tidak boleh kosong",
    "Subject should not be empty": "Subjek tidak boleh kosong",
    "communications.body_required": "Isi email tidak boleh kosong",
    "Body should not be empty": "Isi email tidak boleh kosong",
    "communications.code_merge_tag_required": "Tag penggabungan {code} wajib ada",
    "{code} merge tag is mandatory": "Tag penggabungan {code} wajib ada",
    "communications.edit_template_named": "Edit {name}",
    "Edit {name}": "Edit {name}",
    "communications.subject": "Subjek",
    "Subject": "Subjek",
    "communications.enter_subject": "Masukkan subjek",
    "Enter the Subject": "Masukkan subjek",
    "communications.available_merge_tags": "Tag penggabungan yang tersedia:",
    "Available merge tags:": "Tag penggabungan yang tersedia:",
    "communications.body": "Isi email",
    "Body": "Isi email",
    "communications.write_here": "Tulis di sini…",
    "Write here...": "Tulis di sini…",
    "communications.subject_line": "Baris subjek",
    "Subject Line": "Baris subjek",
    "communications.enter_subject_line": "Masukkan subjek…",
    "Enter the subject…": "Masukkan subjek…",
    "communications.merge_tags": "Tag penggabungan",
    "Merge tags": "Tag penggabungan",
    "communications.loading_templates": "Memuat templat…",
    "Loading templates…": "Memuat templat…",
    "communications.hide_templates": "Sembunyikan templat",
    "Hide templates": "Sembunyikan templat",
    "communications.load_template": "Muat templat",
    "Load template": "Muat templat",
    "communications.html_body": "Isi HTML",
    "HTML Body": "Isi HTML",
    "communications.enter_html_body": "Tempel atau ketik HTML di sini…",
    "Paste or type your HTML here…": "Tempel atau ketik HTML di sini…",
    "communications.live_preview": "Pratinjau langsung",
    "Live Preview": "Pratinjau langsung",
    "communications.desktop": "Desktop",
    "Desktop": "Desktop",
    "communications.mobile": "Ponsel",
    "communications.email_preview": "Pratinjau email",
    "Email preview": "Pratinjau email",
    "communications.start_typing_preview": "Mulai mengetik untuk melihat pratinjau",
    "Start typing to see a preview": "Mulai mengetik untuk melihat pratinjau",
    "communications.translations": "terjemahan",
    "translations": "terjemahan",
    "communications.validation_account_follow_tag": "Notifikasi mengikuti akun harus berisi {account_name}",
    "communications.validation_listing_like_tag": "Notifikasi suka listing harus berisi {user_name}",
    "Listing follow notification should contain {user_name}": "Notifikasi suka listing harus berisi {user_name}",
    "communications.validation_order_number_tag": "Notifikasi status pesanan harus berisi #{order_number}",
    "Order status follow notification should contain #{order_number}": "Notifikasi status pesanan harus berisi #{order_number}",
    "communications.validation_order_status_tag": "Notifikasi status pesanan harus berisi {order_status}",
    "Order status follow notification should contain {order_status}": "Notifikasi status pesanan harus berisi {order_status}",
    "communications.journey_title": "Peta perjalanan email",
    "Email Journey Map": "Peta perjalanan email",
    "communications.journey_subtitle": "Kapan setiap email dikirim dalam siklus pengguna",
    "Where each email fires in the user lifecycle": "Kapan setiap email dikirim dalam siklus pengguna",
    "communications.journey_buyer": "Perjalanan pembeli",
    "Buyer Journey": "Perjalanan pembeli",
    "communications.journey_seller": "Perjalanan penjual",
    "Seller Journey": "Perjalanan penjual",
    "communications.journey_buyer_stage_0": "Daftar",
    "Sign Up": "Daftar",
    "communications.journey_buyer_stage_1": "Jelajahi",
    "Browse": "Jelajahi",
    "communications.journey_buyer_stage_2": "Keranjang",
    "Cart": "Keranjang",
    "communications.journey_buyer_stage_3": "Pesanan dibuat",
    "Order Placed": "Pesanan dibuat",
    "communications.journey_buyer_stage_4": "Dikirim",
    "communications.journey_buyer_stage_5": "Diantar",
    "communications.journey_buyer_stage_6": "Negosiasi",
    "Negotiate": "Negosiasi",
    "communications.journey_buyer_stage_7": "Tidak aktif",
    "communications.journey_seller_stage_0": "Mulai bergabung",
    "Onboard": "Mulai bergabung",
    "communications.journey_seller_stage_1": "Buat listing",
    "communications.journey_seller_stage_2": "Kelola",
    "Manage": "Kelola",
    "communications.journey_seller_stage_3": "Pesanan masuk",
    "Order In": "Pesanan masuk",
    "communications.journey_seller_stage_4": "Kirim",
    "communications.journey_seller_stage_5": "Selesai",
    "Complete": "Selesai",
    "communications.journey_seller_stage_6": "Tidak aktif",
    "accounts.title": "Akun",
    "accounts.status_pending": "Menunggu",
    "accounts.status_approved": "Disetujui",
    "accounts.status_rejected": "Ditolak",
    "accounts.show_rows": "Tampilkan baris",
    "accounts.next": "Berikutnya",
    "accounts.previous": "Sebelumnya",
    "accounts.view_list": "Daftar",
    "accounts.view_map": "Peta",
    "Map": "Peta",
    "accounts.view_board": "Papan",
    "accounts.view_grid": "Kisi-kisi",
    "accounts.view_list_accessibility": "Tampilan daftar",
    "accounts.view_map_accessibility": "Tampilan peta",
    "Map view": "Tampilan peta",
    "accounts.view_board_accessibility": "Tampilan papan",
    "Board view": "Tampilan papan",
    "accounts.view_grid_accessibility": "Tampilan kisi",
    "accounts.column_name": "Nama",
    "accounts.column_account_id": "ID akun",
    "Account ID": "ID akun",
    "accounts.column_description": "Deskripsi",
    "accounts.column_image": "Gambar",
    "accounts.column_user_name": "Nama pengguna",
    "User Name": "Nama pengguna",
    "accounts.column_email": "Email",
    "accounts.column_status": "Status",
    "accounts.column_account_status": "Status akun",
    "Account Status": "Status akun",
    "accounts.column_location": "Lokasi",
    "accounts.search": "Cari akun",
    "Search accounts": "Cari akun",
    "accounts.export": "Ekspor",
    "accounts.import": "Impor",
    "accounts.export_accounts": "Ekspor akun",
    "Export accounts": "Ekspor akun",
    "accounts.import_accounts": "Impor akun",
    "Import accounts": "Impor akun",
    "accounts.smart_upload_accounts": "Smart Upload akun",
    "Smart Upload accounts": "Smart Upload akun",
    "accounts.export_all_question": "Ekspor semua akun?",
    "Export all accounts?": "Ekspor semua akun?",
    "accounts.export_all_description": "File yang berisi semua akun akan disiapkan. Anda dapat meninjau alur ini sebelum meningkatkan paket.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "File yang berisi semua akun akan disiapkan. Anda dapat meninjau alur ini sebelum meningkatkan paket.",
    "accounts.export_all": "Ekspor semua akun",
    "Export all accounts": "Ekspor semua akun",
    "accounts.cancel": "Batal",
    "accounts.active": "Aktif",
    "accounts.inactive": "Tidak aktif",
    "accounts.not_available": "Tidak tersedia",
    "accounts.approve": "Setujui",
    "accounts.reject": "Tolak",
    "accounts.manage": "Kelola",
    "accounts.tooltip_title": "Akun ibarat toko.",
    "Accounts are like shops.": "Akun ibarat toko.",
    "accounts.tooltip_description": "Pengguna dapat membuat ruang di platform untuk menjalankan bisnis. Ruang ini disebut akun. Pengguna belum tentu memerlukan akun, dan akun dapat dihubungkan ke escrow untuk menerima pembayaran.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Pengguna dapat membuat ruang di platform untuk menjalankan bisnis. Ruang ini disebut akun. Pengguna belum tentu memerlukan akun, dan akun dapat dihubungkan ke escrow untuk menerima pembayaran.",
    "accounts.create_account": "Buat akun",
    "Create Account": "Buat akun",
    "accounts.create_new_account": "Buat akun baru",
    "Create New Account": "Buat akun baru",
    "accounts.save": "Simpan",
    "accounts.please_wait": "Harap tunggu…",
    "Please wait...": "Harap tunggu…",
    "accounts.account_name": "Nama akun",
    "accounts.slug": "Slug",
    "Slug": "Slug",
    "accounts.account_slug": "Slug akun",
    "Account Slug": "Slug akun",
    "accounts.account_description": "Deskripsi akun",
    "Account Description": "Deskripsi akun",
    "accounts.enter_name_first": "Masukkan judul terlebih dahulu",
    "Please enter a title first": "Masukkan judul terlebih dahulu",
    "accounts.user": "Pengguna",
    "accounts.select_user": "Pilih pengguna",
    "accounts.category": "Kategori",
    "Category": "Kategori",
    "accounts.select_type": "Pilih jenis",
    "Select Type": "Pilih jenis",
    "accounts.smart_upload_title": "Smart upload akun",
    "Smart account upload": "Smart upload akun",
    "accounts.start_over": "Mulai ulang",
    "accounts.smart_upload_description": "Unggah akun dan cocokkan kolom CSV dengan kolom akun.",
    "Upload accounts and match your CSV columns to account fields.": "Unggah akun dan cocokkan kolom CSV dengan kolom akun.",
    "accounts.smart_upload_step_0": "Unggah",
    "accounts.smart_upload_step_1": "Cocokkan kolom",
    "accounts.smart_upload_step_2": "Tinjau",
    "accounts.smart_upload_step_3": "Impor",
    "accounts.choose_csv": "Pilih file CSV",
    "accounts.smart_upload_required_note": "Nama wajib diisi. Alamat, slug, kategori, pemilik, dan koordinat bersifat opsional.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Nama wajib diisi. Alamat, slug, kategori, pemilik, dan koordinat bersifat opsional.",
    "accounts.select_csv": "Pilih file CSV",
    "accounts.match_columns": "Cocokkan kolom akun",
    "Match account columns": "Cocokkan kolom akun",
    "accounts.import_field_name": "Nama",
    "accounts.import_field_description": "Deskripsi",
    "accounts.import_field_slug": "Slug",
    "accounts.import_field_category_id": "ID kategori",
    "Category ID": "ID kategori",
    "accounts.import_field_user_id": "ID pengguna pemilik",
    "Owner User ID": "ID pengguna pemilik",
    "accounts.import_field_location": "Alamat",
    "accounts.import_field_latitude": "Lintang",
    "Latitude": "Lintang",
    "accounts.import_field_longitude": "Bujur",
    "Longitude": "Bujur",
    "accounts.do_not_import": "Jangan impor",
    "accounts.review_import": "Tinjau impor",
    "accounts.import_count": "{count} akun akan diimpor.",
    "{count} accounts will be imported.": "{count} akun akan diimpor.",
    "accounts.smart_upload_complete": "Smart Upload selesai",
    "Smart Upload complete": "Smart Upload selesai",
    "accounts.imported_count": "{imported} dari {total} akun diimpor.",
    "{imported} of {total} accounts imported.": "{imported} dari {total} akun diimpor.",
    "accounts.selected_file": "Dipilih: {filename}",
    "Selected: {filename}": "Dipilih: {filename}",
    "accounts.review": "Tinjau",
    "accounts.importing": "Mengimpor…",
    "accounts.uploading": "Mengunggah…",
    "accounts.download": "Unduh",
    "accounts.file_label": "File:",
    "accounts.select_file": "Pilih file",
    "accounts.upload": "Unggah",
    "accounts.download_template": "Unduh templat {type}",
    "accounts.import_stage_prepare": "Menyiapkan file impor",
    "Preparing import file": "Menyiapkan file impor",
    "accounts.import_prepare_failed": "File impor tidak dapat disiapkan.",
    "accounts.import_stage_upload": "Mengunggah file impor",
    "accounts.import_upload_failed": "File impor tidak dapat diunggah.",
    "accounts.import_stage_server": "Tradly sedang mengimpor akun",
    "Tradly is importing accounts": "Tradly sedang mengimpor akun",
    "accounts.import_stage_complete": "Impor selesai",
    "Import complete": "Impor selesai",
    "accounts.import_stage_stopped": "Impor dihentikan",
    "accounts.confirm_approve": "Setujui akun ini?",
    "Approve this account?": "Setujui akun ini?",
    "accounts.confirm_reject": "Tolak akun ini?",
    "Reject this account?": "Tolak akun ini?",
    "accounts.name_required": "Nama wajib diisi",
    "Name is required": "Nama wajib diisi",
    "accounts.user_required": "Pengguna wajib diisi",
    "User is required": "Pengguna wajib diisi",
    "accounts.attribute_required": "{attribute} wajib diisi",
    "{attribute} is required": "{attribute} wajib diisi",
    "accounts.overview": "Ringkasan akun",
    "Account Overview": "Ringkasan akun",
    "accounts.section_listings": "Listing",
    "accounts.loading": "Memuat…",
    "accounts.no_listings_owned": "Belum ada listing",
    "No listings yet": "Belum ada listing",
    "accounts.page_analytics": "Analitik halaman",
    "Page Analytics": "Analitik halaman",
    "accounts.analytics_key_missing": "Kunci API analitik belum dikonfigurasi untuk tenant ini.",
    "Analytics API key not configured for this tenant.": "Kunci API analitik belum dikonfigurasi untuk tenant ini.",
    "accounts.storefront_url_missing": "URL etalase untuk akun ini tidak tersedia.",
    "No storefront URL available for this account.": "URL etalase untuk akun ini tidak tersedia.",
    "accounts.no_analytics_loaded": "Analitik belum dimuat.",
    "No analytics loaded yet.": "Analitik belum dimuat.",
    "accounts.load_analytics": "Muat analitik",
    "Load Analytics": "Muat analitik",
    "accounts.attributes": "Atribut",
    "accounts.shipping": "Pengiriman",
    "accounts.commission": "Komisi",
    "Commission": "Komisi",
    "accounts.detail_title": "Judul",
    "accounts.detail_description": "Deskripsi",
    "accounts.detail_descriptions": "Deskripsi",
    "Descriptions": "Deskripsi",
    "accounts.detail_listings": "Listing",
    "accounts.detail_categories": "Kategori",
    "accounts.detail_location": "Lokasi",
    "accounts.detail_account_status": "Status akun",
    "accounts.detail_status": "Status",
    "accounts.detail_shipping_method": "Metode pengiriman",
    "accounts.detail_shipping_methods": "Metode pengiriman",
    "Shipping Methods": "Metode pengiriman",
    "accounts.detail_account_user": "Pengguna akun",
    "Account User": "Pengguna akun",
    "accounts.detail_pending": "Menunggu",
    "accounts.detail_approved": "Disetujui",
    "accounts.detail_rejected": "Ditolak",
    "accounts.detail_active": "Aktif",
    "accounts.detail_inactive": "Tidak aktif",
    "accounts.detail_joined": "Bergabung",
    "Joined": "Bergabung",
    "accounts.detail_account_age": "Usia akun",
    "Account Age": "Usia akun",
    "accounts.detail_less_than_a_month": "Kurang dari sebulan",
    "Less than a month": "Kurang dari sebulan",
    "accounts.detail_page_views": "Tampilan halaman",
    "Page Views": "Tampilan halaman",
    "accounts.detail_unique_visitors": "Pengunjung unik",
    "Unique Visitors": "Pengunjung unik",
    "accounts.detail_sessions": "Sesi",
    "Sessions": "Sesi",
    "accounts.detail_clicks": "Klik",
    "Clicks": "Klik",
    "accounts.detail_goals": "Sasaran",
    "accounts.detail_bot_views": "Tampilan bot",
    "Bot Views": "Tampilan bot",
    "accounts.detail_followers": "Pengikut",
    "Followers": "Pengikut",
    "accounts.detail_total_orders": "Total pesanan",
    "accounts.detail_revenue": "Pendapatan",
    "accounts.detail_avg_order": "Rata-rata pesanan",
    "Avg Order": "Rata-rata pesanan",
    "accounts.detail_paid_orders": "Pesanan dibayar",
    "Paid Orders": "Pesanan dibayar",
    "accounts.detail_owner": "Pemilik",
    "Owner": "Pemilik",
    "accounts.detail_account_id": "ID akun",
    "accounts.detail_category": "Kategori",
    "accounts.detail_profile_completeness": "Kelengkapan profil",
    "Profile Completeness": "Kelengkapan profil",
    "accounts.detail_total_listings": "Total listing",
    "Total Listings": "Total listing",
    "accounts.detail_loaded_listings": "Listing dimuat",
    "Loaded Listings": "Listing dimuat",
    "accounts.detail_active_listings": "Listing aktif",
    "Active Listings": "Listing aktif",
    "accounts.detail_last_updated": "Terakhir diperbarui",
    "Last Updated": "Terakhir diperbarui",
    "accounts.detail_last_activity": "Aktivitas terakhir",
    "Last Activity": "Aktivitas terakhir",
    "accounts.detail_verification": "Verifikasi",
    "Verification": "Verifikasi",
    "accounts.detail_subscription": "Langganan",
    "accounts.detail_attributes": "Atribut",
    "accounts.detail_shipping_charge_split": "Pembagian biaya pengiriman",
    "Shipping Charge Split": "Pembagian biaya pengiriman",
    "accounts.detail_value_type": "Jenis nilai",
    "Value Type": "Jenis nilai",
    "accounts.detail_value": "Nilai",
    "accounts.detail_enter_value": "Masukkan nilai",
    "Enter Value": "Masukkan nilai",
    "accounts.detail_commission_percentage": "Persentase komisi",
    "Commission Percentage": "Persentase komisi",
    "accounts.detail_commission_percent": "Persen komisi",
    "Commission Percent": "Persen komisi",
    "accounts.detail_share": "Bagian",
    "accounts.detail_view_account": "Lihat akun",
    "View Account": "Lihat akun",
    "accounts.detail_add_listing": "Tambah listing",
    "Add Listing": "Tambah listing",
    "accounts.detail_edit_account": "Edit akun",
    "Edit Account": "Edit akun",
    "accounts.no_attribute_values": "Tidak ada nilai atribut untuk {name}",
    "No attribute values for {name}": "Tidak ada nilai atribut untuk {name}",
    "accounts.no_attributes_yet": "Belum ada atribut",
    "No attributes yet": "Belum ada atribut",
    "accounts.edit_account": "Edit akun",
    "accounts.detail_preview": "Pratinjau",
    "accounts.detail_fixed": "Tetap",
    "Fixed": "Tetap",
    "accounts.detail_percentage": "Persentase",
    "Percentage": "Persentase",
    "accounts.detail_select_value_type": "Pilih jenis nilai",
    "Select Value Type": "Pilih jenis nilai",
    "accounts.detail_approve": "Setujui",
    "accounts.detail_reject": "Tolak",
    "accounts.detail_section": "Detail",
    "Details": "Detail",
    "category.add_child": "Tambah kategori turunan",
    "Add Child Category": "Tambah kategori turunan",
    "category.add_listing": "Tambah listing",
    "category.manage": "Kelola kategori",
    "Manage Categories": "Kelola kategori",
    "category.account_overview_eyebrow": "RINGKASAN KATEGORI AKUN",
    "ACCOUNT CATEGORY OVERVIEW": "RINGKASAN KATEGORI AKUN",
    "category.overview_eyebrow": "RINGKASAN KATEGORI",
    "CATEGORY OVERVIEW": "RINGKASAN KATEGORI",
    "category.category": "Kategori",
    "category.active": "Aktif",
    "category.inactive": "Tidak aktif",
    "category.accounts": "Akun",
    "category.listings": "Listing",
    "category.child_categories": "Kategori turunan",
    "Child Categories": "Kategori turunan",
    "category.attributes": "Atribut",
    "category.category_age": "Usia kategori",
    "Category age": "Usia kategori",
    "category.category_overview": "Ringkasan kategori",
    "Category Overview": "Ringkasan kategori",
    "category.category_id": "ID kategori",
    "category.name": "Nama",
    "category.slug": "Slug",
    "category.description": "Deskripsi",
    "category.parent_category": "Kategori induk",
    "Parent Category": "Kategori induk",
    "category.hierarchy": "Hierarki",
    "Hierarchy": "Hierarki",
    "category.status": "Status",
    "category.display_order": "Urutan tampilan",
    "Display Order": "Urutan tampilan",
    "category.created": "Bergabung / dibuat",
    "Joined / Created": "Bergabung / dibuat",
    "category.configured": "Dikonfigurasi",
    "Configured": "Dikonfigurasi",
    "category.no_attributes": "Belum ada atribut.",
    "No attributes assigned.": "Belum ada atribut.",
    "category.no_child_categories": "Tidak ada kategori turunan.",
    "No child categories.": "Tidak ada kategori turunan.",
    "category.no_accounts": "Tidak ada akun dalam kategori ini.",
    "No accounts in this category.": "Tidak ada akun dalam kategori ini.",
    "category.no_listings": "Tidak ada listing dalam kategori ini.",
    "No listings in this category.": "Tidak ada listing dalam kategori ini.",
    "category.detail_title": "Detail kategori",
    "Category Detail": "Detail kategori",
    "category.age_less_month": "Kurang dari sebulan",
    "category.age_month": "{count} bulan",
    "{count} month": "{count} bulan",
    "category.age_months": "{count} bulan",
    "{count} months": "{count} bulan",
    "category.age_year": "{count} tahun",
    "{count} year": "{count} tahun",
    "category.age_years": "{count} tahun",
    "{count} years": "{count} tahun",
    "category.header_name": "Nama",
    "category.header_category_id": "ID kategori",
    "category.header_image": "Gambar",
    "category.header_order": "Urutan",
    "category.header_parent": "Induk",
    "Parent": "Induk",
    "category.header_active": "Aktif",
    "category.header_action": "Tindakan",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Kategori",
    "category.translate": "Terjemahkan",
    "category.import": "Impor",
    "category.export": "Ekspor",
    "category.add_category": "Tambah kategori",
    "Add Category": "Tambah kategori",
    "category.import_categories": "Impor kategori",
    "Import Categories": "Impor kategori",
    "category.delete_warning": "Listing yang ada tidak akan terbuka di situs atau aplikasi dan akan menampilkan error.",
    "Existing listings will not open in website or app, you will see an error.": "Listing yang ada tidak akan terbuka di situs atau aplikasi dan akan menampilkan error.",
    "category.editor_edit_category": "Edit kategori",
    "Edit Category": "Edit kategori",
    "category.editor_add_category": "Tambah kategori",
    "category.editor_save": "Simpan",
    "category.editor_select_category_level": "Pilih tingkat kategori",
    "Select Category Level": "Pilih tingkat kategori",
    "category.editor_parent_category": "Kategori induk",
    "category.editor_select": "Pilih",
    "category.editor_category_name": "Nama kategori",
    "Category Name": "Nama kategori",
    "category.editor_enter_category_name": "Masukkan nama kategori",
    "Enter category name": "Masukkan nama kategori",
    "category.editor_slug": "Slug",
    "category.editor_enter_slug": "Masukkan slug",
    "Enter slug": "Masukkan slug",
    "category.editor_category_description": "Deskripsi kategori",
    "Category Description": "Deskripsi kategori",
    "category.editor_order": "Urutan",
    "category.editor_enter_order": "Masukkan urutan",
    "Enter order": "Masukkan urutan",
    "category.editor_status_not_active_active": "Status (Tidak Aktif / Aktif)",
    "category.editor_upload_media": "Unggah media",
    "category.editor_meta_title": "Judul meta",
    "Meta Title": "Judul meta",
    "category.editor_enter_meta_title": "Masukkan judul meta",
    "Enter meta title": "Masukkan judul meta",
    "category.editor_meta_description": "Deskripsi meta",
    "Meta Description": "Deskripsi meta",
    "category.editor_category": "Kategori",
    "category.editor_name": "Nama",
    "category.editor_status": "Status",
    "category.editor_action": "Tindakan",
    "category.editor_add_attribute": "Tambah atribut",
    "Add Attribute": "Tambah atribut",
    "category.editor_attributes_list": "Daftar atribut",
    "Attributes List": "Daftar atribut",
    "category.editor_please_enter_a_category_name_first": "Masukkan nama kategori terlebih dahulu",
    "Please enter a category name first": "Masukkan nama kategori terlebih dahulu",
    "category.editor_successfully_added_category": "Kategori berhasil ditambahkan",
    "Successfully added category": "Kategori berhasil ditambahkan",
    "category.deleted": "Kategori dihapus",
    "Category deleted": "Kategori dihapus",
    "attributes.title": "Atribut",
    "attributes.cart_checkout": "Keranjang & checkout",
    "Cart & Checkout": "Keranjang & checkout",
    "attributes.cart_settings": "Pengaturan keranjang",
    "Cart settings": "Pengaturan keranjang",
    "attributes.order_status_notifications": "Notifikasi status pesanan",
    "Order status notifications": "Notifikasi status pesanan",
    "attributes.groups": "Grup atribut",
    "Attribute Groups": "Grup atribut",
    "attributes.add_attribute": "Tambah atribut",
    "attributes.edit_bulk": "Edit massal",
    "Edit Bulk": "Edit massal",
    "attributes.confirm_delete": "Hapus atribut ini?",
    "Do you want to delete this attribute?": "Hapus atribut ini?",
    "attributes.header_attribute_name": "Nama atribut",
    "Attribute Name": "Nama atribut",
    "attributes.header_action": "Tindakan",
    "attributes.header_manage_attribute_values": "Kelola nilai atribut",
    "Manage Attribute Values": "Kelola nilai atribut",
    "attributes.header_type": "Jenis",
    "attributes.header_optional": "Opsional",
    "attributes.header_icon": "Ikon",
    "Icon": "Ikon",
    "attributes.header_categories": "Kategori",
    "attributes.header_hidden_field": "Kolom tersembunyi",
    "Hidden Field": "Kolom tersembunyi",
    "attributes.header_values": "Nilai",
    "Values": "Nilai",
    "attributes.header_status": "Status",
    "attributes.type_single_select": "Pilihan tunggal",
    "Single Select": "Pilihan tunggal",
    "attributes.type_multi_select": "Pilihan ganda",
    "Multi Select": "Pilihan ganda",
    "attributes.type_open_single_value": "Isian bebas (satu nilai)",
    "Open (Single Value)": "Isian bebas (satu nilai)",
    "attributes.type_open_multiple_value": "Isian bebas (beberapa nilai)",
    "Open (Multiple Value)": "Isian bebas (beberapa nilai)",
    "attributes.type_attachment": "Lampiran",
    "Attachment": "Lampiran",
    "attributes.type_text_area": "Area teks",
    "Text Area": "Area teks",
    "attributes.type_date_time": "Tanggal dan waktu",
    "Date Time": "Tanggal dan waktu",
    "attributes.type_number": "Angka",
    "attributes.type_boolean": "Boolean",
    "Boolean": "Boolean",
    "attributes.type_color": "Warna",
    "Color": "Warna",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "Lokasi",
    "attributes.type_audio": "Audio",
    "Audio": "Audio",
    "attributes.type_video": "Video",
    "Video": "Video",
    "attributes.type_open_multi_value": "Isian bebas (beberapa nilai)",
    "Open (Multi Value)": "Isian bebas (beberapa nilai)",
    "attributes.editor_edit_attribute": "Edit atribut",
    "Edit Attribute": "Edit atribut",
    "attributes.editor_add_attribute": "Tambah atribut",
    "attributes.editor_attribute_name": "Nama atribut",
    "attributes.editor_select_type": "Pilih jenis",
    "attributes.prefill_user": "Pengguna",
    "common.search_placeholder": "Ketik untuk mencari…",
    "attributes.prefill_accounts": "Akun",
    "attributes.prefill_listings": "Listing",
    "listings.detail_nav_gallery": "Galeri",
    "Gallery": "Galeri",
    "listings.detail_nav_details": "Detail",
    "listings.detail_nav_inventory": "Inventaris",
    "listings.detail_nav_social": "Sosial",
    "Social": "Sosial",
    "listings.detail_nav_orders": "Pesanan",
    "listings.detail_nav_analytics": "Analitik",
    "listings.detail_nav_schedule": "Jadwal",
    "listings.detail_nav_rental": "Sewa",
    "Rental": "Sewa",
    "listings.detail_nav_attributes": "Atribut",
    "listings.detail_nav_seller": "Penjual",
    "attributes.editor_icon": "Ikon",
    "attributes.editor_tool_tip": "Tooltip",
    "Tool tip": "Tooltip",
    "attributes.editor_enter_attribute_name": "Masukkan nama atribut",
    "Enter attribute name": "Masukkan nama atribut",
    "attributes.editor_enter_attribute_tool_tip": "Masukkan teks tooltip",
    "Enter attribute tool tip": "Masukkan teks tooltip",
    "attributes.editor_optional": "Opsional",
    "attributes.editor_private": "Pribadi",
    "attributes.editor_hidden_field": "Kolom tersembunyi",
    "Hidden field": "Kolom tersembunyi",
    "attributes.editor_show_in_filter": "Tampilkan di filter",
    "Show in filter": "Tampilkan di filter",
    "attributes.editor_status_not_active_active": "Status (Tidak Aktif / Aktif)",
    "attributes.editor_add_meta_data": "Tambah metadata",
    "Add meta data": "Tambah metadata",
    "attributes.editor_select": "Pilih",
    "attributes.editor_select_category": "Pilih kategori",
    "Select category": "Pilih kategori",
    "attributes.editor_select_all": "Pilih semua",
    "Select All": "Pilih semua",
    "attributes.editor_unselect_all": "Batalkan pilihan semua",
    "UnSelect All": "Batalkan pilihan semua",
    "attributes.editor_create_categories_in_this_configuration_first": "Buat kategori di konfigurasi ini terlebih dahulu",
    "Create categories in this configuration first": "Buat kategori di konfigurasi ini terlebih dahulu",
    "attributes.editor_please_enter_attribute_name": "Masukkan nama atribut",
    "Please enter attribute name": "Masukkan nama atribut",
    "attributes.editor_please_select_type": "Pilih jenis",
    "Please select type": "Pilih jenis",
    "attributes.editor_select_single_attribute_values": "Pilih satu nilai atribut",
    "attributes.editor_select_multiple_attribute_values": "Pilih beberapa nilai atribut",
    "attributes.editor_enter_value": "Masukkan nilai",
    "attributes.editor_enter_multiple_tag": "Masukkan beberapa tag",
    "Enter Multiple Tag": "Masukkan beberapa tag",
    "attributes.editor_upload_file": "Unggah file",
    "Upload file": "Unggah file",
    "attributes.editor_enter_text": "Masukkan teks",
    "Enter Text": "Masukkan teks",
    "attributes.editor_select_date": "Pilih tanggal",
    "attributes.editor_enter_number": "Masukkan angka",
    "Enter Number": "Masukkan angka",
    "attributes.editor_select_color": "Pilih warna",
    "Select Color": "Pilih warna",
    "attributes.editor_upload_json": "Unggah JSON",
    "Upload Json": "Unggah JSON",
    "attributes.editor_select_location": "Pilih lokasi",
    "Select Location": "Pilih lokasi",
    "attributes.editor_category": "Kategori",
    "attributes.editor_price": "Harga",
    "attributes.editor_enter_price": "Masukkan harga",
    "Enter Price": "Masukkan harga",
    "attributes.editor_preview": "Pratinjau",
    "attributes.editor_title": "Judul",
    "attributes.editor_enter_title": "Masukkan judul",
    "Enter Title": "Masukkan judul",
    "attributes.editor_description": "Deskripsi",
    "attributes.editor_add_listing": "Tambah listing",
    "attributes.editor_add_account": "Tambah akun",
    "Add Account": "Tambah akun",
    "attributes.editor_successfully_added_attributes": "Atribut berhasil ditambahkan",
    "Successfully added attributes": "Atribut berhasil ditambahkan",
    "attributes.editor_add_attribute_values": "Tambah nilai atribut",
    "common.image": "Gambar",
    "common.please_wait": "Harap tunggu…",
    "attribute_groups.title": "Grup atribut",
    "attribute_groups.title_singular": "Grup atribut",
    "Attribute Group": "Grup atribut",
    "attribute_groups.add": "Tambah grup atribut",
    "Add Attribute Group": "Tambah grup atribut",
    "attribute_groups.image_path": "Lokasi gambar",
    "Image Path": "Lokasi gambar",
    "attribute_groups.name_placeholder": "Nama grup",
    "Group Name": "Nama grup",
    "attribute_groups.select_attributes": "Pilih atribut",
    "Select Attributes": "Pilih atribut",
    "attribute_groups.select_attributes_placeholder": "Pilih atribut…",
    "Select Attributes...": "Pilih atribut…",
    "attribute_groups.added_successfully": "Grup atribut berhasil ditambahkan",
    "Attribute Group Added Successfully": "Grup atribut berhasil ditambahkan",
    "attribute_groups.deleted_successfully": "Berhasil dihapus",
    "Deleted successfully": "Berhasil dihapus",
    "attribute_groups.name_required": "Nama wajib diisi",
    "attribute_groups.save_attributes_failed": "Grup tersimpan, tetapi atributnya tidak dapat ditetapkan.",
    "The group was saved, but its attributes could not be assigned.": "Grup tersimpan, tetapi atributnya tidak dapat ditetapkan.",
    "attributes.editor_enter_description": "Masukkan deskripsi",
    "Enter Description": "Masukkan deskripsi",
    "account_config.title": "Konfigurasi akun",
    "account_config.account_detail_note": "Catatan detail akun",
    "Account detail note": "Catatan detail akun",
    "account_config.enter_account_detail_note": "Masukkan catatan detail akun",
    "Enter account detail note": "Masukkan catatan detail akun",
    "account_config.address_label": "Label alamat",
    "account_config.enter_address_label": "Masukkan label alamat",
    "Enter address label": "Masukkan label alamat",
    "account_config.category_label": "Label kategori",
    "Category label": "Label kategori",
    "account_config.enter_category_label": "Masukkan label kategori",
    "Enter category label": "Masukkan label kategori",
    "account_config.nearby_accounts_radius_km": "Radius akun sekitar (km)",
    "Nearby accounts radius (km)": "Radius akun sekitar (km)",
    "account_config.nearby_accounts_radius_placeholder": "Radius akun sekitar dalam km",
    "Account nearby radius in km": "Radius akun sekitar dalam km",
    "account_config.account_limit": "Batas akun",
    "Account Limit": "Batas akun",
    "account_config.account_limit_placeholder": "Batas akun",
    "Account limit": "Batas akun",
    "account_config.shipping_preference_note": "Catatan preferensi metode pengiriman",
    "Shipping method preference note": "Catatan preferensi metode pengiriman",
    "account_config.option_accounts_auto_approved": "Akun disetujui otomatis",
    "Accounts auto approved": "Akun disetujui otomatis",
    "account_config.option_shipping_methods_preference_for_accounts": "Preferensi metode pengiriman akun",
    "Shipping methods preference for accounts": "Preferensi metode pengiriman akun",
    "account_config.option_account_map_location_selector": "Pemilih lokasi akun di peta",
    "Account map location selector": "Pemilih lokasi akun di peta",
    "account_config.option_account_geo_location": "Lokasi geografis akun",
    "Account Geo Location": "Lokasi geografis akun",
    "account_config.option_slug": "Slug",
    "account_config.option_show_description": "Tampilkan deskripsi",
    "Show Description": "Tampilkan deskripsi",
    "account_config.option_formatted_text_description": "Deskripsi teks berformat",
    "Formatted Text Description": "Deskripsi teks berformat",
    "account_config.option_hide_address_from_account_detail": "Sembunyikan alamat dari detail akun",
    "Hide Address from Account Detail": "Sembunyikan alamat dari detail akun",
    "account_config.option_get_account_pickup_address_always": "Selalu minta alamat pengambilan akun",
    "Get Account Pickup Address Always": "Selalu minta alamat pengambilan akun",
    "account_config.option_get_pickup_address_for_delivery": "Minta alamat pengambilan untuk pengiriman",
    "Get Pickup Address for Delivery": "Minta alamat pengambilan untuk pengiriman",
    "account_config.uploaded_successfully": "Berhasil diunggah",
    "app_customization.realtime_config_notice": "Konfigurasi ini diterapkan langsung. Setelah disimpan, perubahan terlihat di aplikasi dan respons API.",
    "app_customization.release_config_notice": "Catatan untuk aplikasi seluler: konfigurasi ini hanya diterapkan saat rilis dan pembaruan produk, bukan secara langsung. Untuk build baru, ajukan permintaan melalui Portal Dukungan. (Paket Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Catatan untuk aplikasi seluler: konfigurasi ini hanya diterapkan saat rilis dan pembaruan produk, bukan secara langsung. Untuk build baru, ajukan permintaan melalui Portal Dukungan. (Paket Starter)",
    "category.translation_title": "Terjemahkan kategori",
    "Translate Category": "Terjemahkan kategori",
    "category.translation_category_name": "Nama kategori",
    "category.translation_description": "Deskripsi",
    "listing_configs.title": "Konfigurasi listing",
    "Listing Configuration": "Konfigurasi listing",
    "listing_configs.rules": "ATURAN (tingkat proyek/tenant)",
    "RULES (Projects/Tenant level)": "ATURAN (tingkat proyek/tenant)",
    "listing_configs.features": "FITUR (khusus aplikasi seluler)",
    "FEATURES (Only for mobile app)": "FITUR (khusus aplikasi seluler)",
    "listing_configs.ui_customisation": "Kustomisasi UI",
    "UI Customisation": "Kustomisasi UI",
    "listing_configs.overridden_max_quantity": "Jumlah maksimum per listing",
    "Maximum quantity per listing": "Jumlah maksimum per listing",
    "listing_configs.overridden_max_quantity_example": "(Contoh: 100)",
    "(Example: 100)": "(Contoh: 100)",
    "listing_configs.listing_min_price": "Harga minimum listing",
    "Minimum listing price": "Harga minimum listing",
    "listing_configs.listing_min_price_example": "(Contoh: $5)",
    "(Example: $5)": "(Contoh: $5)",
    "listing_configs.auto_approval": "Setujui listing otomatis?",
    "listing_configs.listing_pictures_count": "Jumlah gambar yang dapat diunggah",
    "Number of uploadable pictures count": "Jumlah gambar yang dapat diunggah",
    "listing_configs.seller_can_place_order": "Penjual dapat membuat pesanan",
    "Seller can place order": "Penjual dapat membuat pesanan",
    "listing_configs.hide_offer_percent": "Persentase penawaran",
    "Offer percent": "Persentase penawaran",
    "listing_configs.show_max_quantity": "Batas jumlah pada listing",
    "listing_configs.show_shipping_charges": "Biaya pengiriman",
    "Shipping charges": "Biaya pengiriman",
    "listing_configs.listing_address_label": "Label alamat listing",
    "listing_configs.listing_address_label_example": "(Contoh: Patokan)",
    "listing_configs.listing_map_location_selector_enabled": "Gunakan penanda peta, bukan pencarian alamat",
    "Use map marker instead of searching address": "Gunakan penanda peta, bukan pencarian alamat",
    "listing_configs.listing_hide_tags": "Tag",
    "Tags": "Tag",
    "listing_configs.enable_stock": "Stok",
    "Stocks": "Stok",
    "listing_configs.listing_address_enabled": "Alamat geografis",
    "listing_configs.show_stock_out_listings": "Tampilkan listing tanpa stok di feed",
    "listing_configs.enable_slug": "Slug judul listing",
    "Listing title slug": "Slug judul listing",
    "listing_configs.show_variants": "Varian",
    "Variants": "Varian",
    "listing_configs.meta_title": "Judul meta",
    "Meta title": "Judul meta",
    "listing_configs.meta_description": "Deskripsi meta",
    "Meta description": "Deskripsi meta",
    "listing_configs.listing_enable_formatted_text_description": "Aktifkan editor teks",
    "listing_configs.listing_enable_weight": "Aktifkan berat",
    "Enable Weight": "Aktifkan berat",
    "listing_configs.listing_enable_dimensions": "Aktifkan dimensi",
    "Enable Dimensions": "Aktifkan dimensi",
    "listing_configs.enable_stocks_listing_schedules": "Jadwal stok",
    "Stock Schedules": "Jadwal stok",
    "listing_variants.title": "Jenis varian",
    "listing_variants.add_type": "Tambah jenis varian",
    "Add Variant Type": "Tambah jenis varian",
    "listing_variants.edit_type": "Edit jenis varian",
    "Edit Variant Type": "Edit jenis varian",
    "listing_variants.name": "Nama",
    "listing_variants.values": "Nilai",
    "listing_variants.status": "Status",
    "listing_variants.action": "Tindakan",
    "listing_variants.add_value": "Tambah nilai",
    "Add Value": "Tambah nilai",
    "listing_variants.active": "Aktif",
    "listing_variants.inactive": "Tidak aktif",
    "listing_variants.details": "Detail",
    "listing_variants.translate": "Terjemahkan",
    "listing_variants.delete_confirm": "Hapus jenis varian ini?",
    "Do you want to delete this variant type?": "Hapus jenis varian ini?",
    "listing_variants.add_value_first": "Tambahkan nilai sebelum melihat varian.",
    "Add a value before viewing variants.": "Tambahkan nilai sebelum melihat varian.",
    "listing_variants.enter_name": "Masukkan nama",
    "Enter name": "Masukkan nama",
    "listing_variants.status_hint": "Status (Tidak Aktif / Aktif)",
    "listing_variants.total_values": "Total nilai",
    "Total Values": "Total nilai",
    "listing_variants.type_id": "ID jenis",
    "Type ID": "ID jenis",
    "listing_variants.total_count": "Total {count}",
    "{count} total": "Total {count}",
    "listing_variants.loading": "Memuat…",
    "listing_variants.loading_values": "Memuat nilai…",
    "Loading values…": "Memuat nilai…",
    "listing_variants.no_values": "Belum ada nilai",
    "No values yet": "Belum ada nilai",
    "listing_variants.add_first_value": "Tambah nilai pertama",
    "Add First Value": "Tambah nilai pertama",
    "listing_variants.actions": "Tindakan",
    "listing_variants.edit": "Edit",
    "listing_variants.delete": "Hapus",
    "listing_variants.edit_value": "Edit nilai",
    "Edit Value": "Edit nilai",
    "listing_variants.value_name_required": "Nama nilai *",
    "Value Name *": "Nama nilai *",
    "listing_variants.value_examples": "mis. Merah, XL, Katun…",
    "e.g. Red, XL, Cotton…": "mis. Merah, XL, Katun…",
    "listing_variants.saving": "Menyimpan…",
    "listing_variants.save_changes": "Simpan perubahan",
    "Save Changes": "Simpan perubahan",
    "listing_variants.delete_value_confirm": "Hapus nilai varian ini?",
    "Do you want to delete this variant value?": "Hapus nilai varian ini?",
    "listing_variants.clear_all": "Hapus semua",
    "listing_variants.multiple_values_help": "Tambahkan nilai yang dipisahkan koma atau tempel kolom dari Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Tambahkan nilai yang dipisahkan koma atau tempel kolom dari Excel.",
    "listing_variants.save": "Simpan",
    "listing_variants.close": "Tutup",
    "listing_variants.update": "Perbarui",
    "listing_variants.default_text": "Teks default",
    "listing_variants.enter_value": "Masukkan nilai varian",
    "Enter variant value": "Masukkan nilai varian",
    "listing_variants.add_values": "Tambah nilai",
    "Add Values": "Tambah nilai",
    "listing_variants.add_variant_values": "Tambah nilai jenis varian",
    "Add Variant Type Values": "Tambah nilai jenis varian",
    "listing_variants.values_list": "Daftar nilai jenis varian",
    "Variant Type Values List": "Daftar nilai jenis varian",
    "listing_variants.cancel_editing": "Batalkan pengeditan",
    "Cancel Editing": "Batalkan pengeditan",
    "listing_variants.value_name": "Nilai jenis varian",
    "Variant Type Value": "Nilai jenis varian",
    "common.default_text": "Teks default",
    "common.translation_heading": "Terjemahan {title}",
    "{title} Translations": "Terjemahan {title}",
    "attributes.value_delete_confirm": "Hapus nilai atribut ini?",
    "Do you want to delete this attribute value?": "Hapus nilai atribut ini?",
    "attributes.value_clear_all": "Hapus semua",
    "attributes.value_multiple_help": "Tambahkan nilai dipisahkan koma atau tempel kolom dari Excel.",
    "Add comma-separated values or paste a column from Excel.": "Tambahkan nilai dipisahkan koma atau tempel kolom dari Excel.",
    "attributes.value_active": "Aktif",
    "attributes.value_inactive": "Tidak aktif",
    "attributes.value_save": "Simpan",
    "attributes.value_close": "Tutup",
    "attributes.value_translate": "Terjemahkan",
    "attributes.value_update": "Perbarui",
    "attributes.value_sort_alpha": "Urutkan alfabetis",
    "Sort Alphabetically": "Urutkan alfabetis",
    "attributes.value_default_text": "Teks default",
    "attributes.value_add_metadata": "Tambah metadata",
    "Add Metadata": "Tambah metadata",
    "attributes.value_cancel_edit": "Batalkan pengeditan",
    "attributes.value_success_help": "Berhasil! Atribut khusus ini kini tersedia di halaman Tambah Listing.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Berhasil! Atribut khusus ini kini tersedia di halaman Tambah Listing.",
    "attributes.value_add": "Tambah nilai atribut",
    "attributes.value_add_listing": "Tambah nilai atribut listing",
    "Add Listing Attribute Values": "Tambah nilai atribut listing",
    "attributes.value_metadata_for": "Metadata untuk",
    "Metadata for": "Metadata untuk",
    "attributes.value_enter": "Masukkan nilai atribut",
    "Enter attribute value": "Masukkan nilai atribut",
    "attributes.value_add_values": "Tambah nilai",
    "attributes.value_status_hint": "Status (Tidak Aktif / Aktif)",
    "attributes.value_list": "Daftar nilai atribut",
    "Attribute Values List": "Daftar nilai atribut",
    "attributes.value_table_name": "Nilai atribut",
    "Attribute Value": "Nilai atribut",
    "attributes.value_table_status": "Status",
    "attributes.value_table_action": "Tindakan",
    "attributes.metadata_key": "Kunci",
    "Key": "Kunci",
    "attributes.metadata_value": "Nilai",
    "attributes.metadata_add_row": "Tambah baris",
    "workspace.countries": "Negara",
    "workspace.country_add": "Tambah negara",
    "Add Country": "Tambah negara",
    "workspace.country_edit": "Edit negara",
    "Edit Country": "Edit negara",
    "workspace.country_name": "Nama negara",
    "Country Name": "Nama negara",
    "workspace.select_country": "Pilih negara",
    "Select country": "Pilih negara",
    "workspace.country_order": "Urutan",
    "workspace.country_order_placeholder": "Masukkan urutan",
    "workspace.country_status": "Status (Tidak Aktif / Aktif)",
    "workspace.country_default": "Default",
    "workspace.country_active": "Aktif",
    "workspace.country_inactive": "Tidak aktif",
    "workspace.country_delete_confirm": "Hapus negara ini?",
    "Do you want to delete this country?": "Hapus negara ini?",
    "workspace.country_table_name": "Nama",
    "workspace.country_table_default": "Default",
    "workspace.country_table_order": "Urutan",
    "workspace.country_table_status": "Status",
    "workspace.country_table_action": "Tindakan",
    "workspace.languages": "Bahasa",
    "workspace.language_add": "Tambah bahasa",
    "Add Language": "Tambah bahasa",
    "workspace.language_edit": "Edit bahasa",
    "Edit Language": "Edit bahasa",
    "workspace.language_name": "Bahasa",
    "workspace.language_select": "Pilih bahasa",
    "Select Language": "Pilih bahasa",
    "workspace.language_order": "Urutan",
    "workspace.language_order_placeholder": "Masukkan urutan",
    "workspace.language_status": "Status",
    "workspace.language_default": "Default",
    "workspace.language_default_warning": "Mengubah bahasa default akan mengubah pengaturan bahasa aplikasi.",
    "Changing the default language changes the app language setting.": "Mengubah bahasa default akan mengubah pengaturan bahasa aplikasi.",
    "workspace.language_active": "Aktif",
    "workspace.language_inactive": "Tidak aktif",
    "workspace.language_delete_confirm": "Hapus bahasa ini?",
    "Do you want to delete this language?": "Hapus bahasa ini?",
    "workspace.language_table_name": "Nama",
    "workspace.language_table_default": "Default",
    "workspace.language_table_order": "Urutan",
    "workspace.language_table_status": "Status",
    "workspace.language_table_action": "Tindakan",
    "workspace.language_add_photo": "Tambah foto",
    "Add Photo": "Tambah foto",
    "workspace.currency": "Mata uang",
    "workspace.currency_add": "Tambah mata uang",
    "Add Currency": "Tambah mata uang",
    "workspace.currency_edit": "Edit mata uang",
    "Edit Currency": "Edit mata uang",
    "workspace.currency_delete_confirm": "Hapus mata uang ini?",
    "Do you want to delete this currency?": "Hapus mata uang ini?",
    "workspace.currency_show": "Tampilkan",
    "workspace.currency_entries": "entri",
    "entries": "entri",
    "workspace.currency_search": "Cari:",
    "Search:": "Cari:",
    "workspace.currency_search_placeholder": "Cari mata uang",
    "Search currencies": "Cari mata uang",
    "workspace.currency_empty": "Mata uang tidak ditemukan.",
    "No currencies found.": "Mata uang tidak ditemukan.",
    "workspace.currency_active": "Aktif",
    "workspace.currency_inactive": "Tidak aktif",
    "workspace.currency_name": "Nama",
    "workspace.currency_name_placeholder": "Nama mata uang",
    "Currency Name": "Nama mata uang",
    "workspace.currency_upload_media": "Unggah media",
    "workspace.currency_select_media": "Pilih dari media",
    "Select from media": "Pilih dari media",
    "workspace.currency_no_media": "Anda tidak memiliki file media.",
    "You do not have any media files.": "Anda tidak memiliki file media.",
    "workspace.currency_code": "Kode",
    "workspace.currency_select_code": "Pilih",
    "workspace.currency_exchange_rate": "Nilai tukar",
    "Exchange Rate": "Nilai tukar",
    "workspace.currency_precision": "Presisi",
    "Precision": "Presisi",
    "workspace.currency_thousand_separator": "Pemisah ribuan",
    "Thousand Separator": "Pemisah ribuan",
    "workspace.currency_decimal_point": "Pemisah desimal",
    "Decimal Point": "Pemisah desimal",
    "workspace.currency_status_hint": "Status (Tidak Aktif / Aktif)",
    "workspace.currency_default": "Default",
    "workspace.currency_format": "Format",
    "Format": "Format",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Nama",
    "workspace.currency_table_code": "Kode",
    "workspace.currency_table_format": "Format",
    "workspace.currency_table_exchange": "Nilai tukar",
    "Exchange": "Nilai tukar",
    "workspace.currency_table_status": "Status",
    "workspace.currency_table_default": "Default",
    "workspace.currency_table_action": "Tindakan",
    "commissions.title": "Komisi",
    "commissions.add": "Tambah komisi",
    "Add Commission": "Tambah komisi",
    "commissions.edit": "Edit komisi",
    "Edit Commission": "Edit komisi",
    "commissions.delete_confirm": "Hapus komisi ini?",
    "Do you want to delete this commission?": "Hapus komisi ini?",
    "commissions.yes": "Ya",
    "commissions.no": "Tidak",
    "commissions.filter_all": "Semua",
    "commissions.filter_supply": "Pasokan",
    "Supply": "Pasokan",
    "commissions.filter_demand": "Permintaan",
    "Demand": "Permintaan",
    "commissions.filter_cart": "Keranjang",
    "commissions.table_title": "Judul",
    "commissions.table_default_value": "Nilai default",
    "Default Value": "Nilai default",
    "commissions.table_status": "Status",
    "commissions.table_action": "Tindakan",
    "commissions.active": "Aktif",
    "commissions.inactive": "Tidak aktif",
    "commissions.type": "Jenis",
    "commissions.type_supply": "Pasokan",
    "commissions.type_demand": "Permintaan",
    "commissions.type_cart": "Keranjang",
    "commissions.select_category": "Pilih kategori",
    "Select Category": "Pilih kategori",
    "commissions.title_label": "Judul",
    "commissions.enter_title": "Masukkan judul",
    "Enter title": "Masukkan judul",
    "commissions.description": "Deskripsi",
    "commissions.enter_description": "Masukkan deskripsi",
    "Enter description": "Masukkan deskripsi",
    "commissions.default_value_percent": "Nilai default (%)",
    "Default value (%)": "Nilai default (%)",
    "commissions.short_code": "Kode singkat",
    "Short Code": "Kode singkat",
    "commissions.short_code_tooltip_title": "Kode singkat",
    "Short code": "Kode singkat",
    "commissions.short_code_tooltip_description": "Masukkan kode singkat untuk komisi ini.",
    "Enter a short code for this commission.": "Masukkan kode singkat untuk komisi ini.",
    "commissions.enter_short_code": "Masukkan kode singkat",
    "Enter short code": "Masukkan kode singkat",
    "commissions.status_hint": "Status (Tidak Aktif / Aktif)",
    "commissions.optional": "Opsional",
    "commissions.advanced": "Lanjutan",
    "Advanced": "Lanjutan",
    "commissions.add_by_category": "Tambah komisi berdasarkan kategori",
    "Add commission by category": "Tambah komisi berdasarkan kategori",
    "commissions.select_calculation_type": "Pilih jenis",
    "commissions.calc_fixed": "Tetap",
    "commissions.calc_slab": "Bertingkat",
    "Slab": "Bertingkat",
    "commissions.value": "Nilai",
    "commissions.choose_category": "Pilih kategori",
    "Choose category": "Pilih kategori",
    "commissions.create_categories_first": "Buat kategori di Konfigurasi Listing terlebih dahulu",
    "Create categories in Listing Configuration first": "Buat kategori di Konfigurasi Listing terlebih dahulu",
    "commissions.select_type": "Pilih jenis",
    "commissions.demand_fixed": "Tetap",
    "commissions.demand_percentage": "Persentase",
    "commissions.unlimited_hint": "* Masukkan -1 untuk tanpa batas",
    "* Enter -1 for unlimited": "* Masukkan -1 untuk tanpa batas",
    "commissions.from": "Dari",
    "commissions.enter_from": "Masukkan nilai awal",
    "Enter from": "Masukkan nilai awal",
    "commissions.to": "Sampai",
    "commissions.enter_to": "Masukkan nilai akhir",
    "Enter to": "Masukkan nilai akhir",
    "commissions.enter_value": "Masukkan nilai",
    "commissions.add_row": "Tambah baris",
    "commissions.minimum_amount": "Jumlah minimum",
    "Minimum amount": "Jumlah minimum",
    "commissions.enter_minimum_amount": "Masukkan jumlah minimum",
    "Enter minimum amount": "Masukkan jumlah minimum",
    "commissions.maximum_amount": "Jumlah maksimum",
    "Maximum amount": "Jumlah maksimum",
    "commissions.enter_maximum_amount": "Masukkan jumlah maksimum",
    "Enter maximum amount": "Masukkan jumlah maksimum",
    "commissions.notes": "Catatan",
    "Notes": "Catatan",
    "commissions.enter_note": "Masukkan catatan",
    "Enter note": "Masukkan catatan",
    "commissions.from_value": "Nilai awal",
    "From Value": "Nilai awal",
    "commissions.to_value": "Nilai akhir",
    "To Value": "Nilai akhir",
    "commissions.unlimited_short_hint": "(-1 tanpa batas)",
    "(-1 for unlimited)": "(-1 tanpa batas)",
    "commissions.value_percent": "Nilai (%)",
    "Value (%)": "Nilai (%)",
    "commissions.from_value_validation": "Nilai awal harus lebih besar dari nilai akhir sebelumnya",
    "From value should be greater than the previous To value": "Nilai awal harus lebih besar dari nilai akhir sebelumnya",
    "commissions.to_value_validation": "Nilai akhir harus lebih besar dari nilai awal",
    "To value should be greater than From value": "Nilai akhir harus lebih besar dari nilai awal",
    "taxes.title": "Pajak",
    "taxes.title_plural": "Pajak",
    "taxes.add": "Tambah pajak",
    "Add Tax": "Tambah pajak",
    "taxes.edit": "Edit pajak",
    "Edit Tax": "Edit pajak",
    "taxes.delete_confirm": "Yakin ingin menghapus pajak ini?",
    "Are you sure you want to delete this tax?": "Yakin ingin menghapus pajak ini?",
    "taxes.table_title": "Judul",
    "taxes.table_short_code": "Kode singkat",
    "taxes.table_default_value": "Nilai default",
    "taxes.table_status": "Status",
    "taxes.table_action": "Tindakan",
    "taxes.active": "Aktif",
    "taxes.inactive": "Tidak aktif",
    "taxes.select_type": "Pilih jenis",
    "taxes.type_order": "Pesanan",
    "taxes.type_listing": "Listing",
    "taxes.type_tax": "Pajak",
    "taxes.demand_fixed": "Tetap",
    "taxes.demand_percentage": "Persentase",
    "taxes.from": "Dari",
    "taxes.enter_from": "Masukkan nilai awal",
    "taxes.to": "Sampai",
    "taxes.enter_to": "Masukkan nilai akhir",
    "taxes.unlimited_hint": "(-1 tanpa batas)",
    "taxes.value": "Nilai",
    "taxes.enter_value": "Masukkan nilai",
    "taxes.add_row": "Tambah baris",
    "taxes.note": "Catatan",
    "taxes.note_placeholder": "Masukkan catatan yang dapat dilihat pengguna saat checkout dan di detail pesanan.",
    "Enter a note for users to see during checkout and in order details.": "Masukkan catatan yang dapat dilihat pengguna saat checkout dan di detail pesanan.",
    "taxes.inclusive": "Termasuk pajak",
    "Tax Inclusive": "Termasuk pajak",
    "taxes.inclusive_tooltip": "Aktifkan jika harga yang tercantum sudah termasuk pajak.",
    "Enable this when the listed price already includes tax.": "Aktifkan jika harga yang tercantum sudah termasuk pajak.",
    "taxes.title_placeholder": "Masukkan nama yang akan dilihat pengguna saat checkout dan di detail pesanan.",
    "Enter a name shown to users at checkout and in order details.": "Masukkan nama yang akan dilihat pengguna saat checkout dan di detail pesanan.",
    "taxes.default_value": "Nilai default (%)",
    "taxes.default_placeholder": "Nilai default dalam %. Contoh: 6,5",
    "Default value in %. Example: 6.5": "Nilai default dalam %. Contoh: 6,5",
    "taxes.short_code": "Kode singkat",
    "taxes.short_code_tooltip_title": "Kode singkat",
    "taxes.short_code_tooltip_description": "Masukkan kode singkat untuk pajak ini.",
    "Enter a short code for this tax.": "Masukkan kode singkat untuk pajak ini.",
    "taxes.short_code_placeholder": "Gunakan huruf dan angka, maks. 10 karakter. Contoh: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Gunakan huruf dan angka, maks. 10 karakter. Contoh: GST10",
    "taxes.status_hint": "Status (Tidak Aktif / Aktif)",
    "taxes.advanced": "Lanjutan",
    "special_fees.title": "Biaya khusus",
    "special_fees.description": "Atur biaya tambahan tetap atau persentase untuk setiap listing.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Atur biaya tambahan tetap atau persentase untuk setiap listing.",
    "special_fees.fixed": "Biaya khusus tetap",
    "Special fees fixed": "Biaya khusus tetap",
    "special_fees.fixed_placeholder": "Masukkan jumlah biaya (contoh: 5)",
    "Enter special fee amount (example: 5)": "Masukkan jumlah biaya (contoh: 5)",
    "special_fees.percentage": "Biaya khusus persentase",
    "Special fees percentage": "Biaya khusus persentase",
    "special_fees.percentage_placeholder": "Masukkan persentase biaya (contoh: 10%)",
    "Enter special fee percentage (example: 10%)": "Masukkan persentase biaya (contoh: 10%)",
    "special_fees.example": "Contoh",
    "Example": "Contoh",
    "special_fees.example_description": "Anda dapat menambahkan biaya khusus di atas harga listing. Contoh: produk seharga $100 dikenai dua biaya.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "Anda dapat menambahkan biaya khusus di atas harga listing. Contoh: produk seharga $100 dikenai dua biaya.",
    "special_fees.example_fixed": "Biaya tetap tambahan = $10",
    "Additional fixed amount = $10": "Biaya tetap tambahan = $10",
    "special_fees.example_percentage": "Persentase tambahan = 10%",
    "Additional fixed percentage = 10%": "Persentase tambahan = 10%",
    "special_fees.example_total": "Harga akhir = $120",
    "Final price = $120": "Harga akhir = $120",
    "delivery.methods_title": "Metode Layanan / Pengiriman",
    "Service / Shipping Methods": "Metode Layanan / Pengiriman",
    "delivery.shipping_service": "Pengiriman / Layanan",
    "Shipping / Service": "Pengiriman / Layanan",
    "delivery.table_name": "Nama",
    "delivery.table_default": "Default",
    "delivery.table_order": "Urutan",
    "delivery.table_status": "Status",
    "delivery.table_action": "Tindakan",
    "delivery.yes": "Ya",
    "delivery.no": "Tidak",
    "delivery.active": "Aktif",
    "delivery.inactive": "Tidak aktif",
    "delivery.delete_confirm": "Hapus metode pengiriman ini?",
    "Do you want to delete this shipping method?": "Hapus metode pengiriman ini?",
    "delivery.schedule_time": "Waktu terjadwal",
    "Schedule Time": "Waktu terjadwal",
    "delivery.translate": "Terjemahkan",
    "delivery.config": "Konfigurasi",
    "Config": "Konfigurasi",
    "delivery.add": "Tambah Pengiriman/Layanan",
    "Add Shipping/Service": "Tambah Pengiriman/Layanan",
    "delivery.save": "Simpan",
    "delivery.edit": "Edit Pengiriman/Layanan",
    "Edit Shipping/Service": "Edit Pengiriman/Layanan",
    "delivery.stuart_config": "Konfigurasi Stuart",
    "Stuart Configs": "Konfigurasi Stuart",
    "delivery.shipping_configs": "Konfigurasi Pengiriman / Layanan",
    "Service / Shipping Configs": "Konfigurasi Pengiriman / Layanan",
    "delivery.settings": "Pengaturan",
    "delivery.preview": "Pratinjau",
    "delivery.shipment_option": "Opsi pengiriman",
    "Shipment Option": "Opsi pengiriman",
    "delivery.name": "Nama",
    "delivery.enter_name": "Masukkan nama",
    "delivery.note": "Catatan",
    "delivery.enter_note": "Masukkan catatan",
    "delivery.note_tooltip_title": "Catatan",
    "delivery.note_tooltip_description": "Tambahkan catatan opsional untuk menjelaskan opsi pengiriman atau layanan ini.",
    "Add an optional note to explain this shipping or service option.": "Tambahkan catatan opsional untuk menjelaskan opsi pengiriman atau layanan ini.",
    "delivery.order": "Urutan",
    "delivery.enter_order": "Masukkan urutan",
    "delivery.status_hint": "Status (Tidak Aktif / Aktif)",
    "delivery.default": "Default",
    "delivery.select_shipping_method": "Pilih metode pengiriman",
    "Select shipping method": "Pilih metode pengiriman",
    "delivery.select_extension": "Pilih ekstensi",
    "Select extension": "Pilih ekstensi",
    "delivery.add_photo": "Tambah foto",
    "delivery.config.flat_shipping_fee.title": "Biaya pengiriman tetap",
    "Flat Shipping Fee": "Biaya pengiriman tetap",
    "delivery.config.flat_shipping_fee.placeholder": "Masukkan biaya pengiriman tetap",
    "Enter flat shipping fee": "Masukkan biaya pengiriman tetap",
    "delivery.config.schedule_time.title": "Waktu terjadwal",
    "delivery.config.fulfillment_by_platform_enabled.title": "Pengiriman oleh platform",
    "Fulfillment by platform": "Pengiriman oleh platform",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Ikon pengiriman oleh platform",
    "Fulfillment by Platform Icon": "Ikon pengiriman oleh platform",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Ikon pengiriman penjual",
    "Seller Delivery Icon": "Ikon pengiriman penjual",
    "delivery.phone_number": "Nomor telepon",
    "Phone number": "Nomor telepon",
    "delivery.enter_phone_number": "Masukkan nomor telepon",
    "Enter phone number": "Masukkan nomor telepon",
    "delivery.address_line_1": "Alamat baris 1",
    "Address line 1": "Alamat baris 1",
    "delivery.enter_address_line_1": "Masukkan alamat baris 1",
    "Enter address line 1": "Masukkan alamat baris 1",
    "delivery.address_line_2": "Alamat baris 2",
    "Address line 2": "Alamat baris 2",
    "delivery.enter_address_line_2": "Masukkan alamat baris 2",
    "Enter address line 2": "Masukkan alamat baris 2",
    "delivery.landmark": "Patokan",
    "Landmark": "Patokan",
    "delivery.enter_landmark": "Masukkan patokan",
    "Enter landmark": "Masukkan patokan",
    "delivery.state": "Provinsi",
    "delivery.enter_state": "Masukkan provinsi",
    "Enter state": "Masukkan provinsi",
    "delivery.post_code": "Kode pos",
    "Post code": "Kode pos",
    "delivery.enter_post_code": "Masukkan kode pos",
    "Enter post code": "Masukkan kode pos",
    "delivery.country": "Negara",
    "delivery.enter_country": "Masukkan negara",
    "Enter country": "Masukkan negara",
    "delivery.required_information": "Harap isi informasi yang wajib diisi",
    "Please fill the required information": "Harap isi informasi yang wajib diisi",
    "delivery.saved_successfully": "Berhasil diunggah",
    "delivery.storage_hub.title": "Titik hub penyimpanan",
    "Storage Hub Points": "Titik hub penyimpanan",
    "delivery.storage_hub.add": "Tambah hub penyimpanan",
    "Add Storage Hub": "Tambah hub penyimpanan",
    "delivery.storage_hub.edit": "Edit hub penyimpanan",
    "Edit Storage Hub": "Edit hub penyimpanan",
    "delivery.storage_hub.delete_confirm": "Hapus titik hub penyimpanan ini?",
    "Do you want to delete this storage hub point?": "Hapus titik hub penyimpanan ini?",
    "delivery.storage_hub.table_name": "Nama",
    "delivery.storage_hub.table_phone": "Nomor telepon",
    "delivery.storage_hub.table_address": "Alamat",
    "delivery.storage_hub.table_landmark": "Patokan",
    "delivery.storage_hub.table_state": "Provinsi",
    "delivery.storage_hub.table_post_code": "Kode pos",
    "Post Code": "Kode pos",
    "delivery.storage_hub.table_country": "Negara",
    "delivery.storage_hub.table_action": "Tindakan",
    "delivery.select_environment": "Pilih lingkungan",
    "Select environment": "Pilih lingkungan",
    "delivery.environment_sandbox": "Sandbox",
    "Sandbox": "Sandbox",
    "delivery.environment_production": "Produksi",
    "Production": "Produksi",
    "delivery.stuart.client_id": "ID klien",
    "delivery.stuart.enter_client_id": "Masukkan ID klien",
    "delivery.stuart.client_secret": "Rahasia klien",
    "Client Secret": "Rahasia klien",
    "delivery.stuart.enter_client_secret": "Masukkan rahasia klien",
    "Enter client secret": "Masukkan rahasia klien",
    "delivery.stuart.webhook_key": "Kunci autentikasi webhook",
    "Webhook Authentication Key": "Kunci autentikasi webhook",
    "delivery.stuart.enter_webhook_key": "Masukkan kunci autentikasi webhook",
    "Enter webhook authentication key": "Masukkan kunci autentikasi webhook",
    "delivery.sendcloud.public_key": "Kunci publik",
    "Public Key": "Kunci publik",
    "delivery.sendcloud.enter_public_key": "Masukkan kunci API",
    "delivery.sendcloud.secret_key": "Kunci rahasia",
    "Secret Key": "Kunci rahasia",
    "delivery.sendcloud.enter_secret_key": "Masukkan rahasia notifikasi",
    "Enter notification secret": "Masukkan rahasia notifikasi",
    "delivery.sendcloud.default_shipping_address": "Alamat pengiriman default",
    "Default Shipping Address": "Alamat pengiriman default",
    "delivery.sendcloud.add_new": "+ Tambah Baru",
    "+ Add New": "+ Tambah Baru",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Metode pembayaran",
    "Payment Methods": "Metode pembayaran",
    "payments.add": "Tambah metode pembayaran",
    "Add Payment Method": "Tambah metode pembayaran",
    "payments.edit": "Edit metode pembayaran",
    "Edit Payment Method": "Edit metode pembayaran",
    "payments.delete_confirm": "Hapus metode pembayaran ini?",
    "Do you want to delete this payment method?": "Hapus metode pembayaran ini?",
    "payments.save_continue": "Simpan dan lanjutkan",
    "Save and continue": "Simpan dan lanjutkan",
    "payments.translate": "Terjemahkan pembayaran",
    "Translate Payments": "Terjemahkan pembayaran",
    "payments.config": "Konfigurasi",
    "payments.integration_settings": "Pengaturan integrasi",
    "Integration Settings": "Pengaturan integrasi",
    "payments.opp_integration": "Integrasi OPP",
    "OPP Integration": "Integrasi OPP",
    "payments.billplz_integration": "Integrasi BillPlz",
    "BillPlz Integration": "Integrasi BillPlz",
    "payments.stripe_integration": "Integrasi Stripe",
    "Stripe Integration": "Integrasi Stripe",
    "payments.stripe_web_integration": "Integrasi Stripe Web",
    "Stripe Web Integration": "Integrasi Stripe Web",
    "payments.pawapay_integration": "Integrasi PawaPay",
    "PawaPay Integration": "Integrasi PawaPay",
    "payments.korapay_integration": "Integrasi KoraPay",
    "KoraPay Integration": "Integrasi KoraPay",
    "payments.flutterwave_integration": "Integrasi Flutterwave",
    "Flutterwave Integration": "Integrasi Flutterwave",
    "payments.commercepay_integration": "Integrasi CommercePay",
    "CommercePay Integration": "Integrasi CommercePay",
    "payments.checkout_com_integration": "Integrasi Checkout.com",
    "Checkout.com Integration": "Integrasi Checkout.com",
    "payments.paystack_integration": "Integrasi PayStack",
    "PayStack Integration": "Integrasi PayStack",
    "payments.razorpay_settings": "Pengaturan Razorpay",
    "Razorpay settings": "Pengaturan Razorpay",
    "payments.paydunya_settings": "Pengaturan Pay Dunya",
    "Pay Dunya settings": "Pengaturan Pay Dunya",
    "payments.mangopay_settings": "Pengaturan MangoPay",
    "MangoPay settings": "Pengaturan MangoPay",
    "payments.payu_latam_integration": "Integrasi PayU LATAM",
    "PayU LATAM Integration": "Integrasi PayU LATAM",
    "payments.table_name": "Nama",
    "payments.table_actions": "Tindakan",
    "payments.table_min_amount": "Jumlah minimum",
    "Minimum Amount": "Jumlah minimum",
    "payments.table_max_amount": "Jumlah maksimum",
    "Maximum Amount": "Jumlah maksimum",
    "payments.table_default": "Default",
    "payments.table_order_by": "Urutan",
    "payments.table_status": "Status",
    "payments.yes": "Ya",
    "payments.no": "Tidak",
    "payments.active": "Aktif",
    "payments.inactive": "Tidak aktif",
    "payments.settings": "Pengaturan",
    "payments.not_available": "Tidak tersedia",
    "payments.step_select_type": "Pilih jenis",
    "payments.step_configure": "Konfigurasi",
    "payments.step_integration": "Integrasi",
    "Integration": "Integrasi",
    "payments.next": "Berikutnya →",
    "Next →": "Berikutnya →",
    "payments.save": "Simpan",
    "payments.choose_method": "Pilih metode pembayaran untuk dikonfigurasi",
    "Choose a payment method to configure": "Pilih metode pembayaran untuk dikonfigurasi",
    "payments.name": "Nama",
    "payments.enter_name": "Masukkan nama",
    "payments.maximum_amount": "Jumlah maksimum",
    "payments.enter_maximum_amount": "Masukkan jumlah maksimum",
    "payments.minimum_amount": "Jumlah minimum",
    "payments.enter_minimum_amount": "Masukkan jumlah minimum",
    "payments.note": "Catatan",
    "payments.enter_note": "Masukkan catatan",
    "payments.note_tooltip": "Tambahkan catatan opsional untuk pelanggan saat checkout.",
    "Add an optional note for customers at checkout.": "Tambahkan catatan opsional untuk pelanggan saat checkout.",
    "payments.order": "Urutan",
    "payments.enter_order": "Masukkan urutan",
    "payments.default": "Default",
    "payments.config_title": "Konfigurasi Metode Pembayaran",
    "Payment Methods Configuration": "Konfigurasi Metode Pembayaran",
    "payments.wallet_enable": "Aktifkan dompet",
    "Wallet enabled": "Aktifkan dompet",
    "payments.account_type": "Jenis akun",
    "payments.select_account_type": "Pilih jenis akun",
    "Select account type": "Pilih jenis akun",
    "payments.connect_message_standard": "Pesan koneksi Standard",
    "Connect message standard": "Pesan koneksi Standard",
    "payments.enter_connect_message_standard": "Masukkan pesan koneksi Standard",
    "Enter connect message standard": "Masukkan pesan koneksi Standard",
    "payments.disconnect_message_standard": "Pesan pemutusan Standard",
    "Disconnect message standard": "Pesan pemutusan Standard",
    "payments.enter_disconnect_message_standard": "Masukkan pesan pemutusan Standard",
    "Enter disconnect message standard": "Masukkan pesan pemutusan Standard",
    "payments.connect_message_express": "Pesan koneksi Express",
    "Connect message express": "Pesan koneksi Express",
    "payments.enter_connect_message_express": "Masukkan pesan koneksi Express",
    "Enter connect message express": "Masukkan pesan koneksi Express",
    "payments.disconnect_message_express": "Pesan pemutusan Express",
    "Disconnect message express": "Pesan pemutusan Express",
    "payments.enter_disconnect_message_express": "Masukkan pesan pemutusan Express",
    "Enter disconnect message express": "Masukkan pesan pemutusan Express",
    "payments.enable_sandbox": "Aktifkan sandbox",
    "Enable sandbox": "Aktifkan sandbox",
    "payments.api_token": "Token API",
    "API Token": "Token API",
    "payments.enter_token": "Masukkan token",
    "Enter token": "Masukkan token",
    "payments.key_id": "ID kunci",
    "Key ID": "ID kunci",
    "payments.enter_key_id": "Masukkan ID kunci",
    "Enter key ID": "Masukkan ID kunci",
    "payments.key_secret": "Rahasia kunci",
    "Key Secret": "Rahasia kunci",
    "payments.enter_secret_key": "Masukkan kunci rahasia",
    "Enter secret key": "Masukkan kunci rahasia",
    "payments.webhook_secret_key": "Kunci rahasia webhook",
    "Webhook Secret Key": "Kunci rahasia webhook",
    "payments.enter_webhook_secret_key": "Masukkan kunci rahasia webhook",
    "Enter webhook secret key": "Masukkan kunci rahasia webhook",
    "payments.master_key": "Kunci utama",
    "Master Key": "Kunci utama",
    "payments.public_key": "Kunci publik",
    "payments.enter_public_key": "Masukkan kunci publik",
    "Enter public key": "Masukkan kunci publik",
    "payments.private_key": "Kunci privat",
    "Private Key": "Kunci privat",
    "payments.merchant_id": "ID merchant",
    "Merchant ID": "ID merchant",
    "payments.enter_merchant_id": "Masukkan ID merchant",
    "Enter merchant id": "Masukkan ID merchant",
    "payments.processing_channel_id": "ID saluran pemrosesan",
    "Processing channel ID": "ID saluran pemrosesan",
    "payments.enter_processing_channel_id": "Masukkan ID saluran pemrosesan",
    "Enter processing channel id": "Masukkan ID saluran pemrosesan",
    "payments.api_key": "Kunci API",
    "payments.x_signature_key": "Kunci tanda tangan X",
    "X Signature Key": "Kunci tanda tangan X",
    "payments.account_id": "ID akun",
    "payments.login_api_key": "Kunci API login",
    "Login API key": "Kunci API login",
    "payments.client_id": "ID klien",
    "payments.client_api_key": "Kunci API klien",
    "Client API Key": "Kunci API klien",
    "payments.payin_fee": "Biaya PayIn (%)",
    "PayIn fee (%)": "Biaya PayIn (%)",
    "payments.withdraw_fee": "Biaya penarikan (%)",
    "Withdraw fee (%)": "Biaya penarikan (%)",
    "payments.enter_api_key": "Masukkan kunci API",
    "payments.enter_account_id": "Masukkan ID akun",
    "Enter account ID": "Masukkan ID akun",
    "payments.enter_login_api_key": "Masukkan kunci API login",
    "Enter login API key": "Masukkan kunci API login",
    "payments.enter_notification_secret": "Masukkan rahasia notifikasi",
    "payments.enter_payin_fee": "Masukkan biaya dalam persen",
    "Enter fee as a percentage": "Masukkan biaya dalam persen",
    "payments.secret_key": "Kunci rahasia",
    "Secret key": "Kunci rahasia",
    "payments.publishable_key": "Kunci publishable",
    "Publishable key": "Kunci publishable",
    "payments.webhook_secret": "Rahasia webhook",
    "Webhook secret": "Rahasia webhook",
    "payments.enter_webhook_secret": "Masukkan rahasia webhook",
    "Enter webhook secret": "Masukkan rahasia webhook",
    "payments.enter_subscription_webhook_secret": "Masukkan rahasia webhook langganan",
    "Enter subscription webhook secret": "Masukkan rahasia webhook langganan",
    "payments.connect_client_id": "ID klien Connect",
    "Connect client ID": "ID klien Connect",
    "payments.enter_connect_client_id": "Masukkan ID klien Connect",
    "Enter Connect client ID": "Masukkan ID klien Connect",
    "payments.stripe_reminders": "Pengingat Stripe",
    "Stripe reminders": "Pengingat Stripe",
    "payments.stripe_sync_help": "Sinkronisasi memverifikasi kunci rahasia dengan Stripe, mengisi informasi akun, dan membuat endpoint webhook yang dibutuhkan Tradly. Rahasia webhook diisi otomatis; simpan formulir setelah selesai.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "Sinkronisasi memverifikasi kunci rahasia dengan Stripe, mengisi informasi akun, dan membuat endpoint webhook yang dibutuhkan Tradly. Rahasia webhook diisi otomatis; simpan formulir setelah selesai.",
    "payments.find_in_stripe": "Temukan di Stripe Dashboard",
    "Find in Stripe Dashboard": "Temukan di Stripe Dashboard",
    "payments.description": "Deskripsi",
    "payments.learn_more_stripe": "Pelajari Stripe Payments",
    "Learn more about Stripe Payments": "Pelajari Stripe Payments",
    "payments.learn_more_stripe_connect": "Pelajari Stripe Connect untuk marketplace",
    "Learn more about Stripe Connect for marketplaces": "Pelajari Stripe Connect untuk marketplace",
    "payments.token": "Token",
    "Token": "Token",
    "payments.payment_options": "Opsi pembayaran",
    "Payment options": "Opsi pembayaran",
    "payments.enable_integration": "Aktifkan integrasi",
    "Enable integration": "Aktifkan integrasi",
    "payments.enter_provider_id": "Masukkan ID {provider}",
    "Enter {provider} ID": "Masukkan ID {provider}",
    "payments.integration_status_help": "Konfigurasikan penyedia ini di pengaturannya.",
    "Configure this provider in its settings.": "Konfigurasikan penyedia ini di pengaturannya.",
    "listings.title": "Listing",
    "listings.manage": "Kelola",
    "listings.show_rows": "Tampilkan baris",
    "listings.clear": "Hapus",
    "listings.apply": "Terapkan",
    "listings.select_date": "Pilih tanggal",
    "Select date": "Pilih tanggal",
    "listings.start_date": "Tanggal mulai",
    "listings.end_date": "Tanggal akhir",
    "listings.status_types": "Jenis status",
    "Status types": "Jenis status",
    "listings.categories": "Kategori",
    "listings.attributes": "Atribut",
    "listings.clear_all_filters": "Hapus semua filter",
    "Clear all filters": "Hapus semua filter",
    "listings.import": "Impor",
    "listings.export": "Ekspor",
    "listings.smart_upload": "Smart Upload (Beta)",
    "Smart Upload (Beta)": "Smart Upload (Beta)",
    "listings.filter_listings": "Filter listing",
    "Filter listings": "Filter listing",
    "listings.sort_listings": "Urutkan listing",
    "Sort listings": "Urutkan listing",
    "listings.import_listings": "Impor listing",
    "Import listings": "Impor listing",
    "listings.export_listings": "Ekspor listing",
    "Export listings": "Ekspor listing",
    "listings.list_view": "Tampilan daftar",
    "listings.grid_view": "Tampilan kisi",
    "listings.map_view": "Tampilan peta",
    "listings.board_view": "Tampilan papan",
    "listings.export_all_title": "Ekspor semua listing?",
    "Export all listings?": "Ekspor semua listing?",
    "listings.export_all_message": "File berisi semua listing akan disiapkan. Lanjutkan?",
    "This will prepare a file containing all listings. Do you want to continue?": "File berisi semua listing akan disiapkan. Lanjutkan?",
    "listings.export_all": "Ekspor semua listing",
    "Export all listings": "Ekspor semua listing",
    "listings.cancel": "Batal",
    "listings.status_all": "Semua",
    "listings.status_pending": "Menunggu",
    "listings.status_approved": "Disetujui",
    "listings.status_rejected": "Ditolak",
    "listings.status_archived": "Diarsipkan",
    "Archived": "Diarsipkan",
    "listings.sort_newest_first": "Terbaru dahulu",
    "Newest first": "Terbaru dahulu",
    "listings.sort_price_high_to_low": "Harga: tertinggi ke terendah",
    "Price: high to low": "Harga: tertinggi ke terendah",
    "listings.sort_price_low_to_high": "Harga: terendah ke tertinggi",
    "Price: low to high": "Harga: terendah ke tertinggi",
    "listings.header_0": "Judul",
    "listings.header_1": "Situs web",
    "Website": "Situs web",
    "listings.header_2": "Harga",
    "listings.header_3": "Persentase penawaran",
    "listings.header_4": "Gambar",
    "listings.header_5": "Harga penawaran",
    "Offer price": "Harga penawaran",
    "listings.header_6": "Status",
    "listings.header_7": "ID listing",
    "listings.header_8": "Status listing",
    "Listing status": "Status listing",
    "listings.header_9": "Akun",
    "listings.header_10": "Mata uang",
    "listings.header_11": "Terjual",
    "Sold": "Terjual",
    "listings.header_12": "Jumlah target",
    "Goal amount": "Jumlah target",
    "listings.filter_status": "Status",
    "listings.filter_price": "Harga",
    "listings.filter_category": "Kategori",
    "listings.filter_clear_all": "Hapus semua filter",
    "listings.status_count": "Status ({count})",
    "Status ({count})": "Status ({count})",
    "listings.price_count": "Harga ({count})",
    "Price ({count})": "Harga ({count})",
    "listings.category_count": "Kategori ({count})",
    "Category ({count})": "Kategori ({count})",
    "listings.search": "Cari listing",
    "listings.clear_search": "Hapus pencarian listing",
    "Clear listing search": "Hapus pencarian listing",
    "listings.active": "Aktif",
    "listings.inactive": "Tidak aktif",
    "listings.approve": "Setujui",
    "listings.reject": "Tolak",
    "listings.delete_confirm": "Yakin ingin menghapus listing ini?",
    "Are you sure you want to delete this listing?": "Yakin ingin menghapus listing ini?",
    "listings.approve_confirm": "Setujui listing ini?",
    "Do you want to approve this listing?": "Setujui listing ini?",
    "listings.reject_confirm": "Tolak listing ini?",
    "Do you want to reject this listing?": "Tolak listing ini?",
    "listings.yes": "Ya",
    "listings.no": "Tidak",
    "listings.confirm_delete": "Yakin ingin menghapus listing ini?",
    "listings.confirm_approve": "Setujui listing ini?",
    "listings.confirm_reject": "Tolak listing ini?",
    "listings.column.actions": "Tindakan",
    "listings.audio_episode": "Episode audio",
    "Audio episode": "Episode audio",
    "listings.video": "Video",
    "listings.seller": "Penjual",
    "listings.rating": "Rating",
    "listings.followers": "Pengikut",
    "listings.view_seller_account": "Lihat akun penjual",
    "View seller account": "Lihat akun penjual",
    "listings.add_variant": "Tambah varian",
    "Add variant": "Tambah varian",
    "listings.edit": "Edit",
    "listings.preview": "Pratinjau",
    "listings.share": "Bagikan",
    "listings.view_listing": "Lihat listing",
    "View listing": "Lihat listing",
    "listings.stock": "Stok",
    "Stock": "Stok",
    "listings.variants": "Varian",
    "listings.campaign": "Kampanye",
    "Campaign": "Kampanye",
    "listings.rental_details": "Detail sewa",
    "Rental details": "Detail sewa",
    "listings.copy": "Salin",
    "listings.inventory": "Inventaris",
    "listings.order_type": "Jenis pesanan",
    "Order type": "Jenis pesanan",
    "listings.stock_by_location": "Stok berdasarkan lokasi",
    "Stock by location": "Stok berdasarkan lokasi",
    "listings.loading_location_stock": "Memuat stok lokasi…",
    "Loading location stock…": "Memuat stok lokasi…",
    "listings.no_location_stock": "Tidak ada stok yang ditetapkan ke lokasi.",
    "No stock assigned to a location.": "Tidak ada stok yang ditetapkan ke lokasi.",
    "listings.page_analytics": "Analitik halaman",
    "Page analytics": "Analitik halaman",
    "listings.loading": "Memuat…",
    "listings.analytics_key_missing": "Kunci API analitik belum dikonfigurasi untuk tenant ini.",
    "Analytics API key is not configured for this tenant.": "Kunci API analitik belum dikonfigurasi untuk tenant ini.",
    "listings.no_slug": "Listing ini tidak memiliki slug.",
    "No slug is available for this listing.": "Listing ini tidak memiliki slug.",
    "listings.no_analytics": "Analitik belum dimuat.",
    "listings.load_analytics": "Muat analitik",
    "Load analytics": "Muat analitik",
    "listings.no_orders": "Belum ada pesanan untuk listing ini",
    "No orders yet for this listing": "Belum ada pesanan untuk listing ini",
    "listings.social_ratings": "Sosial dan rating",
    "Social and ratings": "Sosial dan rating",
    "listings.tags": "Tag",
    "listings.schedule": "Jadwal",
    "listings.detail": "Detail",
    "Detail": "Detail",
    "listings.update_stock": "Perbarui stok",
    "Update stock": "Perbarui stok",
    "listings.new_stock_quantity": "Jumlah stok baru",
    "New stock quantity": "Jumlah stok baru",
    "listings.location": "Lokasi",
    "listings.quantity": "Jumlah",
    "listings.current_stock": "Stok saat ini: {quantity}",
    "Current stock: {quantity}": "Stok saat ini: {quantity}",
    "listings.loading_rental": "Memuat pengaturan sewa…",
    "Loading rental settings…": "Memuat pengaturan sewa…",
    "payments.enter_publishable_key": "Masukkan kunci publishable",
    "Enter publishable key": "Masukkan kunci publishable",
    "listings.add_listing": "Tambah listing",
    "Add listing": "Tambah listing",
    "listings.edit_listing": "Edit listing",
    "Edit listing": "Edit listing",
    "listings.enter_title": "Masukkan judul",
    "listings.account": "Akun",
    "listings.list_price": "Harga",
    "listings.enter_list_price": "Masukkan harga",
    "listings.select_currency": "Pilih mata uang",
    "Select currency": "Pilih mata uang",
    "listings.select_category": "Pilih kategori",
    "listings.select_categories": "Pilih kategori",
    "Select categories": "Pilih kategori",
    "listings.add_category": "+ Tambah kategori",
    "+ Add category": "+ Tambah kategori",
    "listings.add_attribute": "Tambah atribut",
    "Add attribute": "Tambah atribut",
    "listings.enter_stock": "Masukkan stok",
    "Enter stock": "Masukkan stok",
    "listings.offer_percentage": "Persentase penawaran",
    "Offer percentage": "Persentase penawaran",
    "listings.enter_offer": "Masukkan penawaran",
    "Enter offer": "Masukkan penawaran",
    "listings.max_quantity_optional": "Jumlah maksimum (opsional)",
    "Max quantity (optional)": "Jumlah maksimum (opsional)",
    "listings.enter_max_quantity": "Masukkan jumlah maksimum",
    "Enter max quantity": "Masukkan jumlah maksimum",
    "listings.enter_slug": "Masukkan slug",
    "listings.enter_meta_title": "Masukkan judul meta",
    "listings.repeat": "Ulangi",
    "Repeat": "Ulangi",
    "listings.start_time": "Waktu mulai",
    "Start time": "Waktu mulai",
    "listings.end_time": "Waktu selesai",
    "End time": "Waktu selesai",
    "listings.slot": "Slot",
    "Slot": "Slot",
    "listings.starts_from": "Mulai dari:",
    "Starts from:": "Mulai dari:",
    "listings.add_schedule": "+ Tambah jadwal",
    "+ Add schedule": "+ Tambah jadwal",
    "listings.upload_here": "Unggah di sini",
    "listings.save": "Simpan",
    "listings.update": "Perbarui",
    "listings.tax": "Pajak",
    "listings.title_required": "Judul wajib diisi",
    "listings.select_tax": "Pilih pajak",
    "Please select a tax": "Pilih pajak",
    "listings.select_item": "Pilih {item}",
    "Please select {item}": "Pilih {item}",
    "listings.offer_percentage_validation": "Persentase penawaran harus antara 0 dan 100",
    "Offer percentage must be between 0 and 100": "Persentase penawaran harus antara 0 dan 100",
    "listings.custom_seo": "SEO khusus",
    "Custom SEO": "SEO khusus",
    "listings.select_value": "Pilih nilai",
    "Select value": "Pilih nilai",
    "listings.add_schedule_title": "Tambah jadwal",
    "Add schedule": "Tambah jadwal",
    "listings.select_from_media": "Pilih dari media",
    "listing_form.create_listing": "Buat listing",
    "Create listing": "Buat listing",
    "listing_form.update_listing": "Perbarui listing",
    "Update listing": "Perbarui listing",
    "listing_form.saving": "Menyimpan…",
    "listing_form.main_information": "Informasi utama",
    "Main information": "Informasi utama",
    "listing_form.audio_listing": "Listing audio",
    "Audio listing": "Listing audio",
    "listing_form.basic_information": "Informasi dasar",
    "Basic information": "Informasi dasar",
    "listing_form.listing_type": "Jenis listing",
    "Listing type": "Jenis listing",
    "listing_form.title": "Judul",
    "listing_form.enter_listing_title": "Masukkan judul listing",
    "Enter listing title": "Masukkan judul listing",
    "listing_form.description": "Deskripsi",
    "listing_form.enter_detailed_description": "Masukkan deskripsi lengkap",
    "Enter detailed description": "Masukkan deskripsi lengkap",
    "listing_form.tags": "Tag",
    "listing_form.tag_example": "mis. elektronik, gadget, baru",
    "e.g., electronics, gadgets, new": "mis. elektronik, gadget, baru",
    "listing_form.taxes": "Pajak",
    "listing_form.optional": "Opsional",
    "listing_form.start_date": "Tanggal mulai",
    "listing_form.end_date": "Tanggal akhir",
    "listing_form.currency": "Mata uang",
    "listing_form.select_currency": "Pilih mata uang",
    "listing_form.goal_price": "Harga target",
    "Goal price": "Harga target",
    "listing_form.set_fundraising_goal": "Tetapkan target penggalangan dana",
    "Set your fundraising goal": "Tetapkan target penggalangan dana",
    "listing_form.pricing": "Harga",
    "Pricing": "Harga",
    "listing_form.select": "Pilih",
    "listing_form.price": "Harga",
    "listing_form.offer_percent": "Diskon %",
    "Offer %": "Diskon %",
    "listing_form.listing_price": "Harga listing:",
    "Listing price:": "Harga listing:",
    "listing_form.set_fundraising_goal_amount": "Tetapkan jumlah target penggalangan dana",
    "Set your fundraising goal amount": "Tetapkan jumlah target penggalangan dana",
    "listing_form.category": "Kategori",
    "listing_form.select_a_category": "Pilih kategori",
    "Select a category": "Pilih kategori",
    "listing_form.clear_selected_category": "Hapus kategori terpilih",
    "Clear selected category": "Hapus kategori terpilih",
    "listing_form.create_new_category": "Buat kategori baru",
    "Create a new category": "Buat kategori baru",
    "listing_form.search_categories": "Cari kategori…",
    "Search categories…": "Cari kategori…",
    "listing_form.no_categories_match": "Kategori tidak ditemukan",
    "No categories found": "Kategori tidak ditemukan",
    "listing_form.draft_found": "Draf tersimpan ditemukan.",
    "A saved draft was found.": "Draf tersimpan ditemukan.",
    "listing_form.restore": "Pulihkan",
    "Restore": "Pulihkan",
    "listing_form.discard": "Buang",
    "listing_form.characters": "karakter",
    "characters": "karakter",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Produk fisik",
    "Physical products": "Produk fisik",
    "listing_form.type_events": "Acara",
    "listing_form.type_digital": "Produk digital",
    "Digital products": "Produk digital",
    "listing_form.type_appointments": "Janji temu",
    "Appointments": "Janji temu",
    "listing_form.type_rentals": "Penyewaan",
    "listing_form.type_donation": "Crowdfunding",
    "Crowdfunding": "Crowdfunding",
    "listing_form.type_information_listing": "Informasi",
    "Information": "Informasi",
    "listing_form.type_video_listing": "Video",
    "listing_form.type_audio_listing": "Audio",
    "listing_form.select_taxes": "Pilih pajak (opsional)",
    "Select taxes (optional)": "Pilih pajak (opsional)",
    "listing_form.no_taxes": "Tidak ada pajak",
    "No taxes available": "Tidak ada pajak",
    "listing_form.inventory_shipping": "Inventaris & pengiriman",
    "Inventory & shipping": "Inventaris & pengiriman",
    "listing_form.stock": "Stok",
    "listing_form.weight": "Berat",
    "Weight": "Berat",
    "listing_form.dimensions": "Dimensi (P×L×T)",
    "Dimensions (L×W×H)": "Dimensi (P×L×T)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Barcode",
    "Barcode": "Barcode",
    "listing_form.length": "Panjang",
    "Length": "Panjang",
    "listing_form.width": "Lebar",
    "Width": "Lebar",
    "listing_form.height": "Tinggi",
    "Height": "Tinggi",
    "listing_form.seo_settings": "Pengaturan SEO",
    "SEO settings": "Pengaturan SEO",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "Versi judul yang ramah URL",
    "URL-friendly version of the title": "Versi judul yang ramah URL",
    "listing_form.meta_title": "Judul meta",
    "listing_form.recommended_meta_title": "Disarankan: 50–60 karakter",
    "Recommended: 50–60 chars": "Disarankan: 50–60 karakter",
    "listing_form.meta_keywords": "Kata kunci meta",
    "Meta keywords": "Kata kunci meta",
    "listing_form.separate_with_commas": "Pisahkan dengan koma",
    "Separate with commas": "Pisahkan dengan koma",
    "listing_form.meta_description": "Deskripsi meta",
    "listing_form.recommended_meta_description": "Disarankan: 150–160 karakter",
    "Recommended: 150–160 chars": "Disarankan: 150–160 karakter",
    "listing_form.hide": "Sembunyikan",
    "listing_form.show": "Tampilkan",
    "listing_form.seo_fields": "kolom optimasi mesin pencari",
    "search engine optimization fields": "kolom optimasi mesin pencari",
    "listing_form.auto_generated_slug": "Dibuat otomatis dari judul",
    "Auto-generated from title": "Dibuat otomatis dari judul",
    "listing_form.seo_title_optional": "Judul SEO (opsional)",
    "SEO title (optional)": "Judul SEO (opsional)",
    "listing_form.keywords_comma_separated": "Kata kunci dipisahkan dengan koma",
    "Keywords separated by commas": "Kata kunci dipisahkan dengan koma",
    "listing_form.search_description_optional": "Deskripsi singkat untuk hasil pencarian (opsional)",
    "Brief description for search results (optional)": "Deskripsi singkat untuk hasil pencarian (opsional)",
    "listing_form.account": "Akun",
    "listing_form.loading_accounts": "Memuat akun…",
    "Loading accounts…": "Memuat akun…",
    "listing_form.clear_selected_account": "Hapus pilihan akun",
    "Clear selected account": "Hapus pilihan akun",
    "listing_form.search_accounts": "Cari akun…",
    "Search accounts…": "Cari akun…",
    "listing_form.create_account": "Buat akun baru",
    "Create a new account": "Buat akun baru",
    "listing_form.no_accounts_found": "Akun tidak ditemukan",
    "No accounts found": "Akun tidak ditemukan",
    "listing_form.rental_settings": "Pengaturan sewa",
    "Rental settings": "Pengaturan sewa",
    "listing_form.rental_price_help": "Harga listing dihitung dari tarif dan durasi sewa.",
    "The listing price is calculated from the rental rate and duration.": "Harga listing dihitung dari tarif dan durasi sewa.",
    "listing_form.rate_unit": "Satuan tarif",
    "Rate unit": "Satuan tarif",
    "listing_form.hour": "Jam",
    "Hour": "Jam",
    "listing_form.day": "Hari",
    "listing_form.week": "Minggu",
    "listing_form.rental_rate_amount": "Tarif sewa",
    "Rental rate": "Tarif sewa",
    "listing_form.rental_min_duration": "Durasi minimum",
    "Minimum duration": "Durasi minimum",
    "listing_form.rental_max_duration": "Durasi maksimum",
    "Maximum duration": "Durasi maksimum",
    "listing_form.rental_buffer_time": "Waktu jeda (jam)",
    "Buffer time (hours)": "Waktu jeda (jam)",
    "listing_form.rental_deposit_amount": "Jumlah deposit",
    "Deposit amount": "Jumlah deposit",
    "listing_form.rental_max_units": "Jumlah unit maksimum",
    "Maximum units": "Jumlah unit maksimum",
    "listing_form.quick_create_title": "Buat {entity}",
    "Create {entity}": "Buat {entity}",
    "listing_form.close": "Tutup",
    "listing_form.account_name": "Nama akun",
    "listing_form.category_name": "Nama kategori",
    "Category name": "Nama kategori",
    "listing_form.account_example": "mis. Toko Acme",
    "e.g. Acme Store": "mis. Toko Acme",
    "listing_form.category_example": "mis. Produk Segar",
    "e.g. Fresh Produce": "mis. Produk Segar",
    "listing_form.creating": "Membuat…",
    "listing_form.create_entity": "Buat {entity}",
    "listing_form.cancel": "Batal",
    "listing_form.go_back": "Kembali",
    "Go back": "Kembali",
    "listing_form.upgrade_plan": "Tingkatkan paket",
    "Upgrade plan": "Tingkatkan paket",
    "listing_form.close_upgrade_dialog": "Tutup dialog peningkatan paket",
    "Close upgrade dialog": "Tutup dialog peningkatan paket",
    "listing_form.loading_attributes": "Memuat atribut…",
    "Loading attributes…": "Memuat atribut…",
    "listing_form.no_attributes": "Tidak ada atribut untuk kategori ini",
    "No attributes for this category": "Tidak ada atribut untuk kategori ini",
    "listing_form.unsupported_field_type": "Jenis kolom tidak didukung",
    "Unsupported field type": "Jenis kolom tidak didukung",
    "listing_form.delete_schedule_confirm": "Yakin ingin menghapus jadwal ini?",
    "Are you sure you want to delete this schedule?": "Yakin ingin menghapus jadwal ini?",
    "listing_form.no_schedules_added": "Belum ada jadwal",
    "No schedules added yet": "Belum ada jadwal",
    "listing_form.stock_label": "Stok:",
    "Stock:": "Stok:",
    "listing_form.active": "Aktif",
    "listing_form.inactive": "Tidak aktif",
    "listing_form.edit": "Edit",
    "listing_form.delete": "Hapus",
    "listing_form.schedules": "Jadwal",
    "Schedules": "Jadwal",
    "listing_form.no_schedules_yet": "Belum ada jadwal",
    "No schedules yet": "Belum ada jadwal",
    "listing_form.dates_label": "Tanggal:",
    "Dates:": "Tanggal:",
    "listing_form.time_label": "Waktu:",
    "Time:": "Waktu:",
    "listing_form.repeat_label": "Ulangi:",
    "Repeat:": "Ulangi:",
    "listing_form.capacity_label": "Kapasitas:",
    "Capacity:": "Kapasitas:",
    "listing_form.edit_schedule": "Edit jadwal",
    "Edit schedule": "Edit jadwal",
    "listing_form.add_new_schedule": "Tambah jadwal",
    "Add new schedule": "Tambah jadwal",
    "listing_form.repeat_pattern": "Pola pengulangan",
    "Repeat pattern": "Pola pengulangan",
    "listing_form.select_days": "Pilih hari",
    "Select days": "Pilih hari",
    "listing_form.total_stocks_capacity": "Total stok (kapasitas)",
    "Total stock (capacity)": "Total stok (kapasitas)",
    "listing_form.select_at_least_one_day": "Pilih setidaknya satu hari",
    "Please select at least one day": "Pilih setidaknya satu hari",
    "listing_form.unlimited_capacity_help": "Kosongkan untuk kapasitas tanpa batas",
    "Leave empty for unlimited capacity": "Kosongkan untuk kapasitas tanpa batas",
    "listing_form.add_schedule": "+ Tambah jadwal",
    "listing_form.schedule_number": "Jadwal #{number}",
    "Schedule #{number}": "Jadwal #{number}",
    "listing_form.update_action": "perbarui",
    "update": "perbarui",
    "listing_form.create_action": "buat",
    "create": "buat",
    "listing_form.a_schedule": "jadwal",
    "a schedule": "jadwal",
    "listing_form.daily": "Harian",
    "Daily": "Harian",
    "listing_form.weekdays": "Hari kerja (Sen–Jum)",
    "Weekdays (Mon - Fri)": "Hari kerja (Sen–Jum)",
    "listing_form.weekend": "Akhir pekan (Sab–Min)",
    "Weekend (Sat - Sun)": "Akhir pekan (Sab–Min)",
    "listing_form.custom": "Kustom",
    "listing_form.weekday_0": "Senin",
    "Monday": "Senin",
    "listing_form.weekday_1": "Selasa",
    "Tuesday": "Selasa",
    "listing_form.weekday_2": "Rabu",
    "Wednesday": "Rabu",
    "listing_form.weekday_3": "Kamis",
    "Thursday": "Kamis",
    "listing_form.weekday_4": "Jumat",
    "Friday": "Jumat",
    "listing_form.weekday_5": "Sabtu",
    "Saturday": "Sabtu",
    "listing_form.weekday_6": "Minggu",
    "Sunday": "Minggu",
    "listing_form.media_max_files": "Maksimal {count} {type}",
    "Maximum {count} {type} allowed": "Maksimal {count} {type}",
    "listing_form.video_size_limit": "Ukuran setiap video maksimal 1 GB",
    "Each video must be 1GB or smaller": "Ukuran setiap video maksimal 1 GB",
    "listing_form.videos": "Video",
    "Videos": "Video",
    "listing_form.images": "Gambar",
    "listing_form.select_from_media": "Pilih dari media",
    "listing_form.video_upload_help": "Unggah video MP4, MOV, AVI, MKV, WebM (maks. 1 GB per file)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Unggah video MP4, MOV, AVI, MKV, WebM (maks. 1 GB per file)",
    "listing_form.image_upload_help": "Unggah gambar JPG, PNG, GIF, WebP (maks. 10 MB per file)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Unggah gambar JPG, PNG, GIF, WebP (maks. 10 MB per file)",
    "listing_form.uploading_video": "Mengunggah video…",
    "Uploading video…": "Mengunggah video…",
    "listing_form.audio_episode": "Episode audio",
    "listing_form.audio_upload_help": "Unggah file audio atau tempel URL publik untuk feed RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Unggah file audio atau tempel URL publik untuk feed RSS.",
    "listing_form.selected_file": "Dipilih: {name}",
    "listing_form.audio_url_help": "URL opsional jika file dipilih. Kosongkan untuk menggunakan file yang diunggah.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "URL opsional jika file dipilih. Kosongkan untuk menggunakan file yang diunggah.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Mengunggah audio…",
    "Uploading audio…": "Mengunggah audio…",
    "listing_form.validation_start_date": "Pilih tanggal mulai",
    "Please select start date": "Pilih tanggal mulai",
    "listing_form.validation_end_date": "Pilih tanggal akhir",
    "Please select end date": "Pilih tanggal akhir",
    "listing_form.validation_start_time": "Pilih waktu mulai",
    "Please select start time": "Pilih waktu mulai",
    "listing_form.validation_end_time": "Pilih waktu selesai",
    "Please select end time": "Pilih waktu selesai",
    "listing_form.weekdays_short": "Hari kerja",
    "Weekdays": "Hari kerja",
    "listing_form.weekend_short": "Akhir pekan",
    "Weekend": "Akhir pekan",
    "listing_form.click_add_schedule_help": "Klik “{action}” untuk membuat jadwal pertama",
    "Click \"{action}\" to create your first schedule": "Klik “{action}” untuk membuat jadwal pertama",
    "listing_form.schedule_form_intro": "Isi detail berikut untuk",
    "Fill in the details below to": "Isi detail berikut untuk",
    "listing_form.update": "Perbarui",
    "listing_form.save": "Simpan",
    "listing_form.variant_value_required": "Pilih setidaknya satu nilai varian (mis. Warna, Ukuran)",
    "Please select at least one variant value (e.g., Color, Size)": "Pilih setidaknya satu nilai varian (mis. Warna, Ukuran)",
    "listing_form.valid_price_required": "Masukkan harga yang valid",
    "Please enter a valid price": "Masukkan harga yang valid",
    "listing_form.delete_variant_confirm": "Yakin ingin menghapus varian ini?",
    "Are you sure you want to delete this variant?": "Yakin ingin menghapus varian ini?",
    "listing_form.product_variants": "Varian produk",
    "Product Variants": "Varian produk",
    "listing_form.add_variant": "+ Tambah varian",
    "+ Add Variant": "+ Tambah varian",
    "listing_form.select_all_variants": "Pilih semua varian",
    "Select all variants": "Pilih semua varian",
    "listing_form.set_quantity_selected": "Atur jumlah untuk yang dipilih",
    "Set quantity for selected": "Atur jumlah untuk yang dipilih",
    "listing_form.quantity": "Jumlah",
    "listing_form.apply_quantity": "Terapkan jumlah",
    "Apply quantity": "Terapkan jumlah",
    "listing_form.select_variant_number": "Pilih varian {number}",
    "Select variant {number}": "Pilih varian {number}",
    "listing_form.variant_number": "Varian #{number}",
    "Variant #{number}": "Varian #{number}",
    "listing_form.existing": "Ada",
    "Existing": "Ada",
    "listing_form.modified": "Diubah",
    "Modified": "Diubah",
    "listing_form.variant_name": "Nama varian",
    "Variant Name": "Nama varian",
    "listing_form.variant_values": "Nilai varian",
    "Variant Values": "Nilai varian",
    "listing_form.type": "Jenis",
    "listing_form.no_variant_values": "Tidak ada nilai varian",
    "No variant values": "Tidak ada nilai varian",
    "listing_form.no_variants_yet": "Belum ada varian",
    "No variants yet": "Belum ada varian",
    "listing_form.click_add_variant_help": "Klik “{action}” untuk membuat varian pertama",
    "Click \"{action}\" to create your first variant": "Klik “{action}” untuk membuat varian pertama",
    "listing_form.select_variant_type": "Pilih {type}",
    "Select {type}": "Pilih {type}",
    "listing_form.no_variant_types": "Tidak ada jenis varian. Buat jenis varian terlebih dahulu (seperti Warna, Ukuran).",
    "No variant types available. Please create variant types (like Color, Size) first.": "Tidak ada jenis varian. Buat jenis varian terlebih dahulu (seperti Warna, Ukuran).",
    "listing_form.generated_name": "Nama yang dibuat:",
    "Generated Name:": "Nama yang dibuat:",
    "listing_form.custom_title": "Judul khusus",
    "Custom Title": "Judul khusus",
    "listing_form.auto_generate_help": "Kosongkan untuk membuat otomatis",
    "Leave blank to auto-generate": "Kosongkan untuk membuat otomatis",
    "listing_form.save_variant": "Simpan varian",
    "Save Variant": "Simpan varian",
    "listing_form.start_time": "Waktu mulai",
    "Start Time": "Waktu mulai",
    "listing_form.end_time": "Waktu selesai",
    "End Time": "Waktu selesai",
    "listing_form.enter_capacity_limit": "Masukkan batas kapasitas",
    "Enter capacity limit": "Masukkan batas kapasitas",
    "collections.validation_title": "Judul tidak boleh kosong",
    "Title should not be empty": "Judul tidak boleh kosong",
    "collections.validation_platform": "Pilih setidaknya satu platform",
    "Select at least one platform": "Pilih setidaknya satu platform",
    "collections.validation_dates": "Tanggal akhir harus setelah tanggal mulai",
    "End Date must be later than start date": "Tanggal akhir harus setelah tanggal mulai",
    "collections.validation_minimum_selection": "Pilih setidaknya satu {type}",
    "Select at least one {type}": "Pilih setidaknya satu {type}",
    "collections.account": "akun",
    "account": "akun",
    "collections.listing": "listing",
    "listing": "listing",
    "collections.edit_title": "Edit koleksi",
    "Edit Collection": "Edit koleksi",
    "collections.create_title": "Buat koleksi",
    "Create Collection": "Buat koleksi",
    "collections.details": "Detail koleksi",
    "Collection details": "Detail koleksi",
    "collections.title_placeholder": "Masukkan judul",
    "Enter title name": "Masukkan judul",
    "collections.slug": "Slug",
    "collections.slug_placeholder": "Masukkan slug",
    "collections.enter_title_first": "Masukkan judul terlebih dahulu",
    "collections.scope": "Cakupan",
    "collections.accounts": "Akun",
    "collections.listings": "Listing",
    "collections.choose_category": "Pilih kategori",
    "collections.conditions": "Ketentuan",
    "Conditions": "Ketentuan",
    "collections.condition_type": "Jenis ketentuan",
    "Condition type": "Jenis ketentuan",
    "collections.manual": "Manual",
    "Manual": "Manual",
    "collections.automated": "Otomatis",
    "Automated": "Otomatis",
    "collections.availability": "Ketersediaan koleksi",
    "Collections availability": "Ketersediaan koleksi",
    "collections.schedule": "Jadwal",
    "collections.applicable_channels": "Pilih saluran",
    "Select applicable channel": "Pilih saluran",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Cari berdasarkan nama",
    "Search by name": "Cari berdasarkan nama",
    "collections.not_found": "Koleksi tidak ditemukan.",
    "Collection not found.": "Koleksi tidak ditemukan.",
    "collections.featured_listings": "Listing unggulan",
    "Featured listings": "Listing unggulan",
    "collections.url_copied": "URL publik disalin",
    "Public URL copied": "URL publik disalin",
    "collections.url_copy_failed": "Gagal menyalin URL publik",
    "Unable to copy the public URL": "Gagal menyalin URL publik",
    "collections.collection": "Koleksi",
    "Collection": "Koleksi",
    "collections.this_collection": "koleksi ini",
    "this collection": "koleksi ini",
    "collections.share_text": "Lihat {title}",
    "View {title}": "Lihat {title}",
    "collections.public_url": "URL publik:",
    "Public URL:": "URL publik:",
    "collections.copy_url": "Salin URL",
    "Copy URL": "Salin URL",
    "collections.items": "Item",
    "collections.expires": "Kedaluwarsa",
    "Expires": "Kedaluwarsa",
    "collections.never": "Tidak pernah",
    "Never": "Tidak pernah",
    "collections.automatic_conditions": "Ketentuan otomatis",
    "Automatic Conditions": "Ketentuan otomatis",
    "collections.item_count": "{count} item",
    "{count} items": "{count} item",
    "collections.loading_items": "Memuat item…",
    "Loading items…": "Memuat item…",
    "collections.no_items": "Belum ada item dalam koleksi ini.",
    "No items in this collection yet.": "Belum ada item dalam koleksi ini.",
    "collections.delete_confirm": "Hapus koleksi ini?",
    "Do you want to delete this collection?": "Hapus koleksi ini?",
    "collections.title": "Koleksi",
    "collections.header_title": "Judul",
    "collections.header_action": "Tindakan",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Jenis ketentuan",
    "Condition Type": "Jenis ketentuan",
    "collections.header_scope": "Cakupan",
    "collections.header_start_date": "Tanggal mulai",
    "collections.header_end_date": "Tanggal akhir",
    "collections.header_status": "Status",
    "collections.header_url": "URL",
    "common.calendar_view": "Tampilan kalender",
    "Calendar view": "Tampilan kalender",
    "common.deleted": "Dihapus",
    "Deleted": "Dihapus",
    "common.list_view": "Tampilan daftar",
    "common.description": "Deskripsi",
    "common.title": "Judul",
    "common.end_date": "Tanggal akhir",
    "common.start_date": "Tanggal mulai",
    "promotions.image_required": "Tambahkan gambar",
    "Please add an image": "Tambahkan gambar",
    "promotions.edit_title": "Edit promosi",
    "Edit Promotion": "Edit promosi",
    "promotions.add_title": "Tambah promosi",
    "Add Promotion": "Tambah promosi",
    "promotions.name": "Nama promosi",
    "Promotion Name": "Nama promosi",
    "promotions.select_medium": "Pilih media",
    "Select Medium": "Pilih media",
    "promotions.upload_media": "Unggah media",
    "promotions.schedule": "Jadwal",
    "promotions.destination_type": "Jenis tujuan",
    "Destination Type": "Jenis tujuan",
    "promotions.placement": "Penempatan",
    "Placement": "Penempatan",
    "promotions.status": "Status (Tidak Aktif / Aktif)",
    "promotions.delete_confirm": "Hapus promosi ini?",
    "Do you want to delete this promotion?": "Hapus promosi ini?",
    "promotions.title": "Promosi",
    "promotions.header_image": "Gambar",
    "promotions.header_medium": "Media",
    "promotions.header_placement": "Penempatan",
    "promotions.header_type": "Jenis",
    "promotions.header_value": "Nilai",
    "promotions.header_active": "Aktif",
    "promotions.header_action": "Tindakan",
    "promotions.header_start_at": "Mulai",
    "Start At": "Mulai",
    "promotions.header_end_at": "Selesai",
    "End At": "Selesai",
    "common.grid_view": "Tampilan kisi",
    "promotions.type_general": "Umum",
    "promotions.type_listing": "Listing",
    "promotions.type_account": "Akun",
    "promotions.type_external_link": "Tautan eksternal",
    "External link": "Tautan eksternal",
    "promotions.preview": "Pratinjau",
    "promotions.select_listing": "Pilih listing",
    "Select Listing": "Pilih listing",
    "promotions.select_account": "Pilih akun",
    "Select Account": "Pilih akun",
    "promotions.home_placement": "Beranda",
    "promotions.footer_placement": "Footer",
    "Footer": "Footer",
    "promotions.web_only": "(khusus web)",
    "(Web Only)": "(khusus web)",
    "coupons.edit_title": "Edit kupon",
    "Edit Coupon": "Edit kupon",
    "coupons.add_title": "Tambah kupon",
    "Add Coupon": "Tambah kupon",
    "coupons.reference_name": "Nama referensi",
    "Reference Name": "Nama referensi",
    "coupons.enter_name": "Masukkan nama",
    "coupons.coupon_type": "Jenis kupon",
    "Coupon type": "Jenis kupon",
    "coupons.discount_value": "Nilai diskon",
    "Discount Value": "Nilai diskon",
    "coupons.enter_discount_value": "Masukkan nilai diskon",
    "Enter discount value": "Masukkan nilai diskon",
    "coupons.code": "Kode",
    "coupons.code_example": "Contoh: HOLIDAY10",
    "Ex: HOLIDAY10": "Contoh: HOLIDAY10",
    "coupons.short_code": "Kode singkat",
    "coupons.enter_short_code": "Masukkan kode singkat",
    "coupons.advanced": "LANJUTAN",
    "ADVANCED": "LANJUTAN",
    "coupons.minimum_amount": "Jumlah minimum",
    "coupons.enter_minimum_amount": "Masukkan jumlah minimum",
    "coupons.maximum_amount": "Jumlah maksimum",
    "coupons.enter_maximum_amount": "Masukkan jumlah maksimum",
    "coupons.maximum_discount_amount": "Jumlah diskon maksimum",
    "Maximum Discount Amount": "Jumlah diskon maksimum",
    "coupons.enter_maximum_discount_amount": "Masukkan jumlah diskon maksimum",
    "Enter maximum discount amount": "Masukkan jumlah diskon maksimum",
    "coupons.maximum_uses": "Jumlah penggunaan maksimum",
    "Maximum Uses": "Jumlah penggunaan maksimum",
    "coupons.enter_maximum_uses": "Masukkan jumlah penggunaan maksimum",
    "Enter maximum uses": "Masukkan jumlah penggunaan maksimum",
    "coupons.maximum_uses_per_user": "Penggunaan maksimum per pengguna",
    "Maximum Uses Per User": "Penggunaan maksimum per pengguna",
    "coupons.enter_maximum_uses_per_user": "Masukkan penggunaan maksimum per pengguna",
    "Enter maximum uses per user": "Masukkan penggunaan maksimum per pengguna",
    "coupons.new_user_only": "Khusus pengguna baru",
    "New User": "Khusus pengguna baru",
    "coupons.enter_note": "Masukkan catatan",
    "coupons.start_date_time": "Tanggal dan waktu mulai",
    "Start Date Time": "Tanggal dan waktu mulai",
    "coupons.end_date_time": "Tanggal dan waktu berakhir",
    "End Date Time": "Tanggal dan waktu berakhir",
    "coupons.select_start_date_time": "Pilih tanggal dan waktu mulai",
    "Select start date time": "Pilih tanggal dan waktu mulai",
    "coupons.select_end_date_time": "Pilih tanggal dan waktu berakhir",
    "Select end date time": "Pilih tanggal dan waktu berakhir",
    "coupons.flat_example": "Tetap (contoh: $10)",
    "Flat (Ex: $10)": "Tetap (contoh: $10)",
    "coupons.percentage_example": "Persentase (contoh: 10%)",
    "Percentage (Ex: 10%)": "Persentase (contoh: 10%)",
    "coupons.delete_confirm": "Hapus kupon ini?",
    "Do you want to delete this coupon?": "Hapus kupon ini?",
    "coupons.title": "Kupon",
    "coupons.header_name": "Nama",
    "coupons.header_code": "Kode",
    "coupons.header_coupon_type": "Jenis kupon",
    "Coupon Type": "Jenis kupon",
    "coupons.header_start_date_time": "Tanggal dan waktu mulai",
    "coupons.header_end_date_time": "Tanggal dan waktu berakhir",
    "coupons.header_active": "Aktif",
    "coupons.header_action": "Tindakan",
    "coupons.load_error": "Kupon ini tidak dapat dimuat.",
    "Unable to load this coupon.": "Kupon ini tidak dapat dimuat.",
    "coupons.expired": "Kedaluwarsa",
    "Expired": "Kedaluwarsa",
    "coupons.total_orders": "Total pesanan",
    "coupons.unique_customers": "Pelanggan unik",
    "Unique Customers": "Pelanggan unik",
    "coupons.revenue": "Pendapatan",
    "coupons.average_transaction": "Rata-rata transaksi",
    "Avg Transaction": "Rata-rata transaksi",
    "coupons.paid_orders": "Pesanan dibayar",
    "coupons.uses_remaining": "Sisa penggunaan",
    "Uses Remaining": "Sisa penggunaan",
    "coupons.unlimited": "Tanpa batas",
    "Unlimited": "Tanpa batas",
    "coupons.performance": "Kinerja",
    "Performance": "Kinerja",
    "coupons.usage_against_limit": "Penggunaan terhadap batas",
    "Usage against limit": "Penggunaan terhadap batas",
    "coupons.details": "Detail",
    "coupons.discount": "Diskon",
    "coupons.minimum_order": "Pesanan minimum",
    "Min order": "Pesanan minimum",
    "coupons.maximum_discount": "Diskon maksimum",
    "Max discount": "Diskon maksimum",
    "coupons.maximum_total_uses": "Total penggunaan maksimum",
    "Max total uses": "Total penggunaan maksimum",
    "coupons.maximum_per_user": "Maks. per pengguna",
    "Max / user": "Maks. per pengguna",
    "coupons.new_users_only": "Khusus pengguna baru",
    "New users only": "Khusus pengguna baru",
    "coupons.valid_from": "Berlaku mulai",
    "Valid from": "Berlaku mulai",
    "coupons.valid_until": "Berlaku sampai",
    "Valid until": "Berlaku sampai",
    "coupons.orders": "Pesanan",
    "coupons.no_orders": "Belum ada pesanan yang menggunakan kupon ini",
    "No orders have used this coupon yet": "Belum ada pesanan yang menggunakan kupon ini",
    "coupons.orders_header_order": "Pesanan",
    "coupons.orders_header_customer": "Pelanggan",
    "coupons.orders_header_date": "Tanggal",
    "coupons.orders_header_amount": "Jumlah",
    "coupons.orders_header_status": "Status",
    "coupons.paid": "Dibayar",
    "coupons.pending": "Menunggu",
    "coupons.coupon": "Kupon",
    "coupons.detail_title": "Detail kupon",
    "Coupon Detail": "Detail kupon",
    "coupons.discount_percentage": "Diskon {value}%",
    "{value}% off": "Diskon {value}%",
    "coupons.discount_flat": "Diskon tetap {value}",
    "{value} flat off": "Diskon tetap {value}",
    "coupons.type_direct_discount": "Diskon langsung",
    "Direct discount": "Diskon langsung",
    "collections.condition_and": "DAN",
    "AND": "DAN",
    "collections.condition_or": "ATAU",
    "OR": "ATAU",
    "users.first_seen": "Pertama terlihat",
    "First seen": "Pertama terlihat",
    "users.last_seen": "Terakhir terlihat",
    "Last seen": "Terakhir terlihat",
    "users.avg_order": "Rata-rata pesanan",
    "Avg order": "Rata-rata pesanan",
    "users.purchase_value": "Nilai pembelian",
    "Purchase value": "Nilai pembelian",
    "users.price_range": "Rentang harga",
    "Price range": "Rentang harga",
    "users.attributes": "Atribut",
    "users.detail_title": "Detail pengguna",
    "User Detail": "Detail pengguna",
    "users.detail_orders_list": "Daftar pesanan pengguna",
    "User Orders List": "Daftar pesanan pengguna",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "Sebagai Pembeli",
    "As a Buyer": "Sebagai Pembeli",
    "users.as_seller": "Sebagai Penjual",
    "As a Seller": "Sebagai Penjual",
    "users.health": "Kesehatan",
    "users.no_listings": "Belum ada listing",
    "users.no_accounts": "Belum ada akun",
    "No accounts yet": "Belum ada akun",
    "users.top_categories": "Kategori teratas",
    "Top categories": "Kategori teratas",
    "users.top_listings": "Listing teratas",
    "Top listings": "Listing teratas",
    "users.recent_activity": "Aktivitas terbaru",
    "Recent activity": "Aktivitas terbaru",
    "users.acquisition": "Akuisisi",
    "Acquisition": "Akuisisi",
    "users.sent_emails": "Email terkirim",
    "Sent Emails": "Email terkirim",
    "users.no_emails_sent": "Belum ada email terkirim",
    "No emails sent": "Belum ada email terkirim",
    "users.load_more_emails": "Muat lainnya ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Muat lainnya ({loaded} / {total})",
    "users.email_to": "Kepada: {email}",
    "To: {email}": "Kepada: {email}",
    "users.sending_email": "Mengirim…",
    "users.send_email": "Kirim email",
    "Send Email": "Kirim email",
    "users.send_email_title": "Kirim Email — {name}",
    "Send Email — {name}": "Kirim Email — {name}",
    "users.customer": "Pelanggan",
    "users.block_named": "Blokir {name}",
    "Block {name}": "Blokir {name}",
    "users.unblock_named": "Buka blokir {name}",
    "Unblock {name}": "Buka blokir {name}",
    "users.email_sent": "Email berhasil dikirim",
    "Email sent successfully": "Email berhasil dikirim",
    "users.email_send_failed": "Gagal mengirim email",
    "Failed to send email": "Gagal mengirim email",
    "common.value": "Nilai",
    "users.email_bounced": "Email dikembalikan",
    "Bounced": "Email dikembalikan",
    "users.email_complained": "Email dilaporkan",
    "Complained": "Email dilaporkan",
    "users.unverified": "Belum diverifikasi",
    "Unverified": "Belum diverifikasi",
    "users.otp_enabled": "OTP aktif",
    "OTP Enabled": "OTP aktif",
    "users.account_info": "Info akun",
    "Account Info": "Info akun",
    "users.mobile": "Ponsel",
    "users.locale": "Lokal",
    "Locale": "Lokal",
    "users.joined": "Bergabung",
    "users.following": "Mengikuti",
    "Following": "Mengikuti",
    "users.email_health": "Kesehatan email",
    "Email Health": "Kesehatan email",
    "users.orders": "Pesanan",
    "users.no_orders": "Tidak ada pesanan",
    "No orders": "Tidak ada pesanan",
    "users.order_reference": "Pesanan {number}",
    "Order {number}": "Pesanan {number}",
    "users.order_ref": "Ref: {reference}",
    "Ref: {reference}": "Ref: {reference}",
    "users.unpaid": "Belum dibayar",
    "users.revenue_ltv": "Pendapatan & LTV",
    "Revenue & LTV": "Pendapatan & LTV",
    "users.total_spent": "Total belanja",
    "Total Spent": "Total belanja",
    "users.paid_order_count": "{count} pesanan dibayar",
    "{count} paid orders": "{count} pesanan dibayar",
    "users.average_order": "Rata-rata pesanan",
    "users.of_total_orders": "dari total {count}",
    "of {count} total": "dari total {count}",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} aktif",
    "{count} active": "{count} aktif",
    "users.at_risk": "Berisiko",
    "At Risk": "Berisiko",
    "common.today": "Hari ini",
    "common.yesterday": "Kemarin",
    "Yesterday": "Kemarin",
    "users.days_ago": "{count} hari lalu",
    "{count} days ago": "{count} hari lalu",
    "users.months_ago": "{count} bulan lalu",
    "{count} months ago": "{count} bulan lalu",
    "users.years_ago": "{count} tahun lalu",
    "{count} years ago": "{count} tahun lalu",
    "users.last_order": "Pesanan terakhir",
    "Last order": "Pesanan terakhir",
    "users.last_listing": "Listing terakhir",
    "Last listing": "Listing terakhir",
    "users.events": "Peristiwa",
    "users.viewed": "Dilihat",
    "Viewed": "Dilihat",
    "users.cart": "Keranjang",
    "users.checkouts": "Checkout",
    "Checkouts": "Checkout",
    "users.purchases": "Pembelian",
    "Purchases": "Pembelian",
    "users.last_30_days": "30 hari terakhir",
    "Last 30 days": "30 hari terakhir",
    "users.no_analytics": "Belum ada data analitik untuk pengguna ini.",
    "No analytics data for this user yet.": "Belum ada data analitik untuk pengguna ini.",
    "users.analytics_unavailable": "Analitik tidak tersedia untuk tenant ini.",
    "Analytics unavailable for this tenant.": "Analitik tidak tersedia untuk tenant ini.",
    "users.account_number": "Akun #{number}",
    "Account #{number}": "Akun #{number}",
    "users.no_subject": "Tanpa subjek",
    "No Subject": "Tanpa subjek",
    "common.unknown": "Tidak diketahui",
    "users.opened": "Dibuka",
    "Opened": "Dibuka",
    "users.not_opened": "Belum dibuka",
    "Not opened": "Belum dibuka",
    "users.user_action_success": "Tindakan pengguna selesai",
    "User action completed": "Tindakan pengguna selesai",
    "common.pending": "Menunggu",
    "common.never": "Tidak pernah",
    "users.customer_analytics": "Analitik pelanggan",
    "Customer Analytics": "Analitik pelanggan",
    "users.analytics": "Analitik",
    "users.emails": "Email",
    "Emails": "Email",
    "users.first_visit": "Kunjungan pertama",
    "First visit": "Kunjungan pertama",
    "users.latest_visit": "Kunjungan terakhir",
    "Latest visit": "Kunjungan terakhir",
    "users.landing_page": "Halaman landing",
    "Landing page": "Halaman landing",
    "users.referrer": "Perujuk",
    "Referrer": "Perujuk",
    "users.utm_source": "Sumber UTM",
    "UTM source": "Sumber UTM",
    "users.utm_medium": "Medium UTM",
    "UTM medium": "Medium UTM",
    "users.utm_campaign": "Kampanye UTM",
    "UTM campaign": "Kampanye UTM",
    "users.utm_term": "Istilah UTM",
    "UTM term": "Istilah UTM",
    "users.utm_content": "Konten UTM",
    "UTM content": "Konten UTM",
    "users.ai_source": "Sumber AI",
    "AI source": "Sumber AI",
    "rewards.edit_scope": "Edit cakupan",
    "Edit scope": "Edit cakupan",
    "rewards.add_scope": "Tambah cakupan",
    "Add scope": "Tambah cakupan",
    "rewards.save_scope": "Simpan cakupan",
    "Save scope": "Simpan cakupan",
    "rewards.scope_type": "Jenis cakupan",
    "Scope type": "Jenis cakupan",
    "rewards.scope_reference": "Referensi cakupan",
    "Scope reference": "Referensi cakupan",
    "rewards.match_config": "Konfigurasi pencocokan",
    "Match config": "Konfigurasi pencocokan",
    "rewards.priority_order": "Urutan prioritas",
    "Priority order": "Urutan prioritas",
    "rewards.active": "Aktif",
    "rewards.scope_active": "Cakupan aktif",
    "Scope is active": "Cakupan aktif",
    "rewards.edit_rule": "Edit aturan",
    "Edit rule": "Edit aturan",
    "rewards.add_rule": "Tambah aturan",
    "Add rule": "Tambah aturan",
    "rewards.save_rule": "Simpan aturan",
    "Save rule": "Simpan aturan",
    "rewards.trigger_event": "Peristiwa pemicu",
    "Trigger event": "Peristiwa pemicu",
    "rewards.beneficiary_type": "Jenis penerima manfaat",
    "Beneficiary type": "Jenis penerima manfaat",
    "rewards.beneficiary_config": "Konfigurasi penerima",
    "Beneficiary config": "Konfigurasi penerima",
    "rewards.eligibility": "Kelayakan",
    "Eligibility": "Kelayakan",
    "rewards.conditions": "Ketentuan",
    "rewards.priority": "Prioritas",
    "Priority": "Prioritas",
    "rewards.edit_component": "Edit komponen resep",
    "Edit recipe component": "Edit komponen resep",
    "rewards.add_component": "Tambah komponen resep",
    "Add recipe component": "Tambah komponen resep",
    "rewards.save_component": "Simpan komponen",
    "Save component": "Simpan komponen",
    "rewards.rule": "Aturan",
    "Rule": "Aturan",
    "rewards.component_key": "Kunci komponen",
    "Component key": "Kunci komponen",
    "rewards.component_type": "Jenis komponen",
    "Component type": "Jenis komponen",
    "rewards.commission_definition": "Definisi komisi",
    "Commission definition": "Definisi komisi",
    "rewards.config": "Konfigurasi",
    "rewards.position": "Posisi",
    "Position": "Posisi",
    "rewards.component": "Komponen",
    "Component": "Komponen",
    "rewards.status.draft": "Draf",
    "rewards.status.active": "Aktif",
    "rewards.status.paused": "Dijeda",
    "Paused": "Dijeda",
    "rewards.status.archived": "Diarsipkan",
    "rewards.configuration_updated": "Konfigurasi reward diperbarui",
    "Reward configuration updated": "Konfigurasi reward diperbarui",
    "rewards.configuration_added": "Konfigurasi reward ditambahkan",
    "Reward configuration added": "Konfigurasi reward ditambahkan",
    "rewards.archive_item_confirm": "Arsipkan {name}?",
    "Archive {name}?": "Arsipkan {name}?",
    "rewards.empty_scopes": "Belum ada cakupan.",
    "No scopes configured yet.": "Belum ada cakupan.",
    "rewards.empty_rules": "Belum ada aturan.",
    "No rules configured yet.": "Belum ada aturan.",
    "rewards.empty_components": "Belum ada komponen.",
    "No components configured yet.": "Belum ada komponen.",
    "rewards.edit_program": "Edit program reward",
    "Edit reward program": "Edit program reward",
    "rewards.new_program": "Program reward baru",
    "New reward program": "Program reward baru",
    "rewards.create_program": "Buat program",
    "Create program": "Buat program",
    "rewards.program_type": "Jenis program",
    "Program type": "Jenis program",
    "rewards.starts_at": "Mulai",
    "Starts at": "Mulai",
    "rewards.ends_at": "Berakhir",
    "Ends at": "Berakhir",
    "rewards.program_updated": "Program reward diperbarui",
    "Reward program updated": "Program reward diperbarui",
    "rewards.program_created": "Program reward dibuat",
    "Reward program created": "Program reward dibuat",
    "rewards.archive_program_confirm": "Arsipkan {name}?",
    "rewards.program_archived": "Program reward diarsipkan",
    "Reward program archived": "Program reward diarsipkan",
    "rewards.tab.overview": "Ringkasan",
    "rewards.tab.programs": "Program",
    "Programs": "Program",
    "rewards.tab.impact": "Dampak",
    "Impact": "Dampak",
    "rewards.tab.attribution": "Atribusi",
    "Tracking": "Atribusi",
    "rewards.page_description": "Buat dan kelola program reward, kelayakan, aturan, dan resep reward. Pesanan selesai otomatis masuk ke laporan.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Buat dan kelola program reward, kelayakan, aturan, dan resep reward. Pesanan selesai otomatis masuk ke laporan.",
    "rewards.program": "Program",
    "Program": "Program",
    "rewards.starts": "Mulai",
    "Starts": "Mulai",
    "rewards.no_programs": "Belum ada program reward.",
    "No reward programs yet.": "Belum ada program reward.",
    "rewards.program_title": "Program reward",
    "Reward program": "Program reward",
    "rewards.back_to_rewards": "Kembali ke reward",
    "Back to rewards": "Kembali ke reward",
    "common.archive": "Arsipkan",
    "Archive": "Arsipkan",
    "common.save_changes": "Simpan perubahan",
    "common.none": "Tidak ada",
    "common.this_item": "item ini",
    "this item": "item ini",
    "rewards.tab.scopes": "Cakupan",
    "Scopes": "Cakupan",
    "rewards.tab.rules": "Aturan",
    "Rules": "Aturan",
    "rewards.tab.components": "Komponen resep",
    "Recipe components": "Komponen resep",
    "rewards.reference": "Referensi",
    "rewards.trigger": "Pemicu",
    "Trigger": "Pemicu",
    "rewards.beneficiary": "Penerima",
    "Beneficiary": "Penerima",
    "rewards.attributed_conversions": "Konversi teratribusi",
    "Attributed conversions": "Konversi teratribusi",
    "rewards.new_customers": "Pelanggan baru",
    "New customers": "Pelanggan baru",
    "rewards.revenue_influenced": "Pendapatan terpengaruh",
    "Revenue influenced": "Pendapatan terpengaruh",
    "rewards.rewards_issued": "Reward diberikan",
    "Rewards issued": "Reward diberikan",
    "rewards.live_business_results": "Hasil bisnis langsung",
    "Live business results": "Hasil bisnis langsung",
    "rewards.impact_at_a_glance": "Ringkasan dampak",
    "Impact at a glance": "Ringkasan dampak",
    "rewards.impact_last_30_days": "Tampilan langsung pesanan selesai dan hasil mitra selama 30 hari terakhir.",
    "A live view of completed orders and partner results from the last 30 days.": "Tampilan langsung pesanan selesai dan hasil mitra selama 30 hari terakhir.",
    "rewards.view_full_impact": "Lihat dampak lengkap",
    "View full impact": "Lihat dampak lengkap",
    "rewards.impact_load_error": "Data dampak tidak dapat dimuat: {error}",
    "Impact data could not be loaded: {error}": "Data dampak tidak dapat dimuat: {error}",
    "rewards.programs": "Program",
    "rewards.programs_configured": "Program reward yang dikonfigurasi untuk workspace ini.",
    "Reward programs configured for this workspace.": "Program reward yang dikonfigurasi untuk workspace ini.",
    "rewards.programs_eligible": "Program yang saat ini memenuhi syarat untuk dievaluasi.",
    "Programs currently eligible for evaluation.": "Program yang saat ini memenuhi syarat untuk dievaluasi.",
    "rewards.drafts": "Draf",
    "Drafts": "Draf",
    "rewards.programs_being_configured": "Program yang masih dikonfigurasi.",
    "Programs still being configured.": "Program yang masih dikonfigurasi.",
    "rewards.clicks": "Klik",
    "rewards.completed_orders": "Pesanan selesai",
    "Completed orders": "Pesanan selesai",
    "rewards.conversion_rate": "Tingkat konversi",
    "Conversion rate": "Tingkat konversi",
    "rewards.revenue": "Pendapatan",
    "rewards.live_connection": "Koneksi aktif",
    "Live connection": "Koneksi aktif",
    "rewards.attribution_activity": "Aktivitas atribusi",
    "Attribution activity": "Aktivitas atribusi",
    "rewards.connected_workspace": "Terhubung ke {name}.",
    "Connected to {name}.": "Terhubung ke {name}.",
    "rewards.your_attribution_workspace": "workspace Attribution Anda",
    "your Attribution workspace": "workspace Attribution Anda",
    "rewards.loading_workspace": "Memuat workspace Attribution yang terhubung.",
    "Loading your connected Attribution workspace.": "Memuat workspace Attribution yang terhubung.",
    "rewards.open_attribution": "Buka Attribution",
    "Open Attribution": "Buka Attribution",
    "rewards.connection_attention": "Koneksi perlu diperiksa",
    "Connection needs attention": "Koneksi perlu diperiksa",
    "rewards.open_attribution_workspace": "Buka workspace Attribution",
    "Open Attribution workspace": "Buka workspace Attribution",
    "rewards.workspace_connected": "Workspace terhubung",
    "Workspace connected": "Workspace terhubung",
    "rewards.workspace_not_linked": "Workspace belum ditautkan",
    "Workspace not linked yet": "Workspace belum ditautkan",
    "rewards.attribution_data_connected": "Data klik, tautan, kampanye, dan pesanan selesai dibaca langsung dari Attribution.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Data klik, tautan, kampanye, dan pesanan selesai dibaca langsung dari Attribution.",
    "rewards.connect_workspace_prompt": "Buka Attribution untuk menghubungkan workspace ini sebelum melacak aktivitas.",
    "Open Attribution to connect this workspace before tracking activity.": "Buka Attribution untuk menghubungkan workspace ini sebelum melacak aktivitas.",
    "rewards.successful_referrals": "Referral berhasil",
    "Successful referrals": "Referral berhasil",
    "rewards.new_customers_acquired": "Pelanggan baru diperoleh",
    "New customers acquired": "Pelanggan baru diperoleh",
    "rewards.gross_revenue_influenced": "Pendapatan bruto terpengaruh",
    "Gross revenue influenced": "Pendapatan bruto terpengaruh",
    "rewards.reward_cost": "Biaya reward",
    "Reward cost": "Biaya reward",
    "rewards.net_revenue": "Pendapatan bersih",
    "Net revenue": "Pendapatan bersih",
    "rewards.average_order_value": "Nilai rata-rata pesanan",
    "Average order value": "Nilai rata-rata pesanan",
    "rewards.cost_per_acquisition": "Biaya akuisisi",
    "Cost per acquisition": "Biaya akuisisi",
    "rewards.repeat_purchase_rate": "Tingkat pembelian ulang",
    "Repeat purchase rate": "Tingkat pembelian ulang",
    "rewards.business_outcome_reporting": "Pelaporan hasil bisnis",
    "Business outcome reporting": "Pelaporan hasil bisnis",
    "rewards.impact": "Dampak",
    "rewards.impact_description": "Konversi, akuisisi pelanggan, pendapatan terpengaruh, dan biaya reward dari periode yang dipilih.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Konversi, akuisisi pelanggan, pendapatan terpengaruh, dan biaya reward dari periode yang dipilih.",
    "rewards.from": "Dari",
    "rewards.to": "Sampai",
    "rewards.trend": "Tren",
    "Trend": "Tren",
    "rewards.daily": "Harian",
    "rewards.weekly": "Mingguan",
    "Weekly": "Mingguan",
    "rewards.top_partners": "Mitra / perujuk teratas",
    "Top partners / referrers": "Mitra / perujuk teratas",
    "rewards.partner": "Mitra",
    "Partner": "Mitra",
    "rewards.conversions": "Konversi",
    "Conversions": "Konversi",
    "rewards.no_partner_data": "Tidak ada data mitra teratribusi untuk periode ini.",
    "No attributed partner data for this period.": "Tidak ada data mitra teratribusi untuk periode ini.",
    "rewards.period": "Periode",
    "rewards.no_trend_data": "Tidak ada data tren untuk periode ini.",
    "No trend data for this period.": "Tidak ada data tren untuk periode ini.",
    "rewards.campaign_performance": "Kinerja kampanye",
    "Campaign performance": "Kinerja kampanye",
    "rewards.campaign_count": "{count} kampanye",
    "{count} campaigns": "{count} kampanye",
    "rewards.campaign": "Kampanye",
    "rewards.orders": "Pesanan",
    "rewards.rate": "Tarif",
    "Rate": "Tarif",
    "rewards.no_campaign_activity": "Belum ada aktivitas kampanye. Buat tautan pelacakan di Attribution untuk mulai mengukur hasil.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Belum ada aktivitas kampanye. Buat tautan pelacakan di Attribution untuk mulai mengukur hasil.",
    "rewards.recent_completed_orders": "Pesanan selesai terbaru",
    "Recent completed orders": "Pesanan selesai terbaru",
    "rewards.recent_events_count": "{count} peristiwa terbaru",
    "{count} recent events": "{count} peristiwa terbaru",
    "rewards.event": "Peristiwa",
    "rewards.completed_order": "Pesanan selesai",
    "Completed order": "Pesanan selesai",
    "rewards.no_completed_order_activity": "Belum ada aktivitas pesanan selesai.",
    "No completed order activity has arrived yet.": "Belum ada aktivitas pesanan selesai.",
    "rewards.impact_data_quality_note": "Volume klik dan tingkat konversi belum tersedia sampai agregat klik Attribution terhubung. Biaya reward memakai baris ledger yang disetujui atau diterbitkan; refund belum disertakan.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Volume klik dan tingkat konversi belum tersedia sampai agregat klik Attribution terhubung. Biaya reward memakai baris ledger yang disetujui atau diterbitkan; refund belum disertakan.",
    "subscriptions.type.free": "Langganan gratis",
    "Free Subscription": "Langganan gratis",
    "subscriptions.form.title_placeholder": "Judul langganan",
    "Subscription Title": "Judul langganan",
    "subscriptions.form.title_help": "Masukkan nama paket langganan yang jelas (misalnya, “Premium”, “Basic”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Masukkan nama paket langganan yang jelas (misalnya, “Premium”, “Basic”).",
    "subscriptions.form.description_placeholder": "Deskripsi langganan",
    "Subscription Description": "Deskripsi langganan",
    "subscriptions.form.description_help": "Jelaskan detail langganan beserta fitur dan manfaatnya.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Jelaskan detail langganan beserta fitur dan manfaatnya.",
    "subscriptions.form.select_currency": "Pilih mata uang",
    "Select Currency": "Pilih mata uang",
    "subscriptions.form.currency_help": "Pilih mata uang langganan dari daftar (mata uang default Anda).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Pilih mata uang langganan dari daftar (mata uang default Anda).",
    "subscriptions.form.amount_placeholder": "Jumlah langganan",
    "Subscription Amount": "Jumlah langganan",
    "subscriptions.form.amount_help": "Masukkan harga langganan.",
    "Enter the subscription price.": "Masukkan harga langganan.",
    "subscriptions.form.sku_placeholder": "SKU langganan",
    "Subscription SKU": "SKU langganan",
    "subscriptions.form.sku_help": "Masukkan ID unik langganan untuk memudahkan pengelolaan dan pelacakan data.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Masukkan ID unik langganan untuk memudahkan pengelolaan dan pelacakan data.",
    "subscriptions.form.allowed_listings": "Listing yang diizinkan",
    "Allowed Listings": "Listing yang diizinkan",
    "subscriptions.form.allowed_listings_placeholder": "Listing yang diizinkan",
    "Subscription Allowed Listings": "Listing yang diizinkan",
    "subscriptions.form.allowed_listings_help": "Tentukan jumlah listing yang diizinkan untuk langganan ini.",
    "Specify the number of listings allowed for this subscription.": "Tentukan jumlah listing yang diizinkan untuk langganan ini.",
    "subscriptions.form.fixed_fee_per_order": "Biaya tetap per pesanan",
    "Fixed Fee Per Order": "Biaya tetap per pesanan",
    "subscriptions.form.fixed_fee_placeholder": "Biaya tetap per pesanan",
    "Subscription Fee Fixed Per Order": "Biaya tetap per pesanan",
    "subscriptions.form.fixed_fee_help": "Masukkan biaya tetap per pesanan jika berlaku.",
    "Enter a fixed fee per order, if applicable.": "Masukkan biaya tetap per pesanan jika berlaku.",
    "subscriptions.form.commission_percent_per_order": "Komisi per pesanan, %",
    "Commission % Per Order": "Komisi per pesanan, %",
    "subscriptions.form.commission_placeholder": "Komisi per pesanan, %",
    "Subscription Commission Percent Per Order": "Komisi per pesanan, %",
    "subscriptions.form.commission_help": "Masukkan persentase komisi per pesanan jika berlaku.",
    "Enter the commission percentage per order, if applicable.": "Masukkan persentase komisi per pesanan jika berlaku.",
    "subscriptions.form.expiry_days": "Masa berlaku (hari)",
    "Expiry Days": "Masa berlaku (hari)",
    "subscriptions.form.expiry_days_placeholder": "Masa berlaku langganan dalam hari",
    "Subscription Expiry Days": "Masa berlaku langganan dalam hari",
    "subscriptions.form.expiry_days_help": "Tentukan jumlah hari sebelum paket langganan berakhir. Contoh: 7 atau 30 hari.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Tentukan jumlah hari sebelum paket langganan berakhir. Contoh: 7 atau 30 hari.",
    "subscriptions.form.payment_method": "Metode pembayaran",
    "subscriptions.form.select_type": "Pilih jenis",
    "subscriptions.form.payment_method_help": "Pilih metode pembayaran yang didukung untuk langganan ini (mis. Stripe, MangoPay, Android, iOS, atau Langganan Gratis).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Pilih metode pembayaran yang didukung untuk langganan ini (mis. Stripe, MangoPay, Android, iOS, atau Langganan Gratis).",
    "subscriptions.form.active_placeholder": "Langganan aktif",
    "Subscription Active": "Langganan aktif",
    "subscriptions.form.active_help": "Aktifkan atau nonaktifkan langganan. Langganan aktif tersedia untuk dibeli.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Aktifkan atau nonaktifkan langganan. Langganan aktif tersedia untuk dibeli.",
    "subscriptions.add_title": "Tambah produk langganan",
    "Add new subscription product": "Tambah produk langganan",
    "subscriptions.edit_title": "Edit produk langganan",
    "Edit subscription product": "Edit produk langganan",
    "subscriptions.added_success": "Listing langganan berhasil ditambahkan",
    "Subscription listing added successfully": "Listing langganan berhasil ditambahkan",
    "subscriptions.updated_success": "Listing langganan berhasil diperbarui",
    "Subscription listing updated successfully": "Listing langganan berhasil diperbarui",
    "common.currency": "Mata uang",
    "common.sku": "SKU",
    "subscriptions.title": "Langganan",
    "subscriptions.add_subscription": "Tambah langganan",
    "Add subscription": "Tambah langganan",
    "subscriptions.plans": "Paket",
    "subscriptions.active_subscribers": "Pelanggan aktif",
    "Active Subscribers": "Pelanggan aktif",
    "subscriptions.total_mrr": "Total MRR",
    "Total MRR": "Total MRR",
    "subscriptions.churn_rate": "Tingkat churn",
    "Churn Rate": "Tingkat churn",
    "subscriptions.new_this_month": "Baru bulan ini",
    "New This Month": "Baru bulan ini",
    "subscriptions.average_duration": "Durasi rata-rata",
    "Avg Duration": "Durasi rata-rata",
    "subscriptions.monthly_recurring_revenue": "Pendapatan berulang bulanan",
    "Monthly Recurring Revenue": "Pendapatan berulang bulanan",
    "subscriptions.annual_run_rate": "Proyeksi pendapatan tahunan",
    "Annual Run Rate": "Proyeksi pendapatan tahunan",
    "subscriptions.last_30_days": "30 hari terakhir",
    "subscriptions.subscriber_lifetime": "Masa berlangganan",
    "Subscriber lifetime": "Masa berlangganan",
    "subscriptions.subscriber_distribution": "Distribusi pelanggan",
    "Subscriber Distribution": "Distribusi pelanggan",
    "subscriptions.billing_period": "Periode penagihan",
    "Billing Period": "Periode penagihan",
    "subscriptions.allowed_listings": "Listing yang diizinkan",
    "subscriptions.commission_per_order": "Komisi per pesanan",
    "Commission per Order": "Komisi per pesanan",
    "subscriptions.fixed_fee_per_order": "Biaya tetap per pesanan",
    "Fixed Fee per Order": "Biaya tetap per pesanan",
    "subscriptions.payment_provider": "Penyedia pembayaran",
    "Payment Provider": "Penyedia pembayaran",
    "subscriptions.sku_product_id": "SKU / ID produk",
    "SKU / Product ID": "SKU / ID produk",
    "subscriptions.revenue_over_time": "Pendapatan dari waktu ke waktu",
    "Revenue Over Time": "Pendapatan dari waktu ke waktu",
    "subscriptions.revenue": "Pendapatan",
    "subscriptions.subscriber_growth": "Pertumbuhan pelanggan",
    "Subscriber Growth": "Pertumbuhan pelanggan",
    "subscriptions.subscribers": "Pelanggan",
    "Subscribers": "Pelanggan",
    "subscriptions.set_inactive": "Nonaktifkan",
    "Set Inactive": "Nonaktifkan",
    "subscriptions.set_active": "Aktifkan",
    "Set Active": "Aktifkan",
    "subscriptions.plan_title": "Paket langganan",
    "Subscription Plan": "Paket langganan",
    "subscriptions.status.active": "Aktif",
    "subscriptions.status.cancelled": "Dibatalkan",
    "subscriptions.status.expired": "Kedaluwarsa",
    "subscriptions.status.trial": "Uji coba",
    "Trial": "Uji coba",
    "subscriptions.status.pending": "Menunggu",
    "subscriptions.period.lifetime": "Seumur hidup",
    "Lifetime": "Seumur hidup",
    "subscriptions.period.daily": "Harian",
    "subscriptions.period.weekly": "Mingguan",
    "subscriptions.period.monthly": "Bulanan",
    "Monthly": "Bulanan",
    "subscriptions.period.quarterly": "Triwulanan",
    "Quarterly": "Triwulanan",
    "subscriptions.period.semi_annual": "Setengah tahunan",
    "Semi-annual": "Setengah tahunan",
    "subscriptions.period.annual": "Tahunan",
    "Annual": "Tahunan",
    "subscriptions.period.days": "{count} hari",
    "subscriptions.period.day": "/ hari",
    "/ day": "/ hari",
    "subscriptions.period.week": "/ minggu",
    "/ week": "/ minggu",
    "subscriptions.period.month": "/ bulan",
    "/ month": "/ bulan",
    "subscriptions.period.quarter": "/ kuartal",
    "/ quarter": "/ kuartal",
    "subscriptions.period.six_months": "/ 6 bulan",
    "/ 6 months": "/ 6 bulan",
    "subscriptions.period.year": "/ tahun",
    "/ year": "/ tahun",
    "subscriptions.listings_count": "{count} listing",
    "{count} listings": "{count} listing",
    "subscriptions.commission_percentage": "Komisi {rate}%",
    "{rate}% commission": "Komisi {rate}%",
    "subscriptions.per_order": "/ pesanan",
    "/ order": "/ pesanan",
    "subscriptions.view_details_subscribers": "Lihat detail dan pelanggan",
    "View details and subscribers": "Lihat detail dan pelanggan",
    "subscriptions.edit_subscription": "Edit langganan",
    "Edit subscription": "Edit langganan",
    "subscriptions.delete_subscription": "Hapus langganan",
    "Delete subscription": "Hapus langganan",
    "subscriptions.deleted": "Langganan dihapus",
    "Subscription deleted": "Langganan dihapus",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "IAP Android",
    "Android IAP": "IAP Android",
    "subscriptions.type.ios": "IAP iOS",
    "iOS IAP": "IAP iOS",
    "subscriptions.type.free_subscription": "Gratis",
    "subscriptions.type.mangopay": "MangoPay",
    "Mangopay": "MangoPay",
    "subscriptions.loaded_count": "{count} dimuat",
    "subscriptions.no_subscribers": "Tidak ada pelanggan dengan status {status}.",
    "No {status} subscribers.": "Tidak ada pelanggan dengan status {status}.",
    "subscriptions.billing_records": "Catatan tagihan",
    "Billing Records": "Catatan tagihan",
    "subscriptions.no_invoices": "Tidak ada faktur.",
    "No invoices found.": "Tidak ada faktur.",
    "subscriptions.column.account": "Akun",
    "subscriptions.column.email": "Email",
    "subscriptions.column.status": "Status",
    "subscriptions.column.subscribed": "Berlangganan sejak",
    "Subscribed": "Berlangganan sejak",
    "subscriptions.column.expires": "Kedaluwarsa",
    "subscriptions.column.next_renewal": "Perpanjangan berikutnya",
    "Next Renewal": "Perpanjangan berikutnya",
    "subscriptions.column.amount_paid": "Jumlah dibayar",
    "Amount Paid": "Jumlah dibayar",
    "subscriptions.invoice_column.invoice_id": "ID faktur",
    "Invoice ID": "ID faktur",
    "subscriptions.invoice_column.account": "Akun",
    "subscriptions.invoice_column.amount": "Jumlah",
    "subscriptions.invoice_column.status": "Status",
    "subscriptions.invoice_column.period": "Periode",
    "subscriptions.invoice_column.paid_at": "Dibayar pada",
    "Paid At": "Dibayar pada",
    "subscriptions.validation.title_required": "Judul wajib diisi",
    "subscriptions.validation.allowed_listings_positive": "Jumlah listing yang diizinkan harus lebih dari 0",
    "Allowed listings should be greater than 0": "Jumlah listing yang diizinkan harus lebih dari 0",
    "subscriptions.validation.currency_required": "Mata uang wajib diisi",
    "Currency is required": "Mata uang wajib diisi",
    "subscriptions.validation.expiry_required": "Masa berlaku (hari) wajib diisi",
    "Expiry days are required": "Masa berlaku (hari) wajib diisi",
    "subscriptions.validation.payment_method_required": "Metode pembayaran wajib diisi",
    "Payment method is required": "Metode pembayaran wajib diisi",
    "subscriptions.error.save": "Terjadi kesalahan saat menyimpan langganan.",
    "Something went wrong while saving the subscription.": "Terjadi kesalahan saat menyimpan langganan.",
    "subscriptions.error.delete": "Terjadi kesalahan saat menghapus langganan.",
    "Something went wrong while deleting the subscription.": "Terjadi kesalahan saat menghapus langganan.",
    "common.configuration": "Konfigurasi",
    "subscriptions.per_period": "per {period}",
    "per {period}": "per {period}",
    "subscriptions.tab.subscribers": "Pelanggan",
    "subscriptions.tab.invoices": "Faktur",
    "subscriptions.account_title": "Langganan akun",
    "Account Subscription": "Langganan akun",
    "subscriptions.config.description": "Kelola langganan akun. Jika diaktifkan, pemilik akun memerlukan langganan aktif untuk menerbitkan listing. Gerbang pembayaran default di bagian Metode Pembayaran digunakan untuk pembayaran langganan.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Kelola langganan akun. Jika diaktifkan, pemilik akun memerlukan langganan aktif untuk menerbitkan listing. Gerbang pembayaran default di bagian Metode Pembayaran digunakan untuk pembayaran langganan.",
    "subscriptions.config.enable": "Aktifkan langganan",
    "Enable subscriptions": "Aktifkan langganan",
    "subscriptions.config.type": "Jenis langganan",
    "Subscription type": "Jenis langganan",
    "subscriptions.config.purchased_message": "Pesan saat langganan sudah dibeli",
    "Message when a subscription is already purchased": "Pesan saat langganan sudah dibeli",
    "subscriptions.config.purchased_placeholder": "Masukkan pesan untuk langganan yang sudah dibeli",
    "Enter the already-purchased message": "Masukkan pesan untuk langganan yang sudah dibeli",
    "subscriptions.config.listings_exhausted_message": "Pesan saat batas listing tercapai",
    "Message when the listing limit is reached": "Pesan saat batas listing tercapai",
    "subscriptions.config.listings_exhausted_placeholder": "Masukkan pesan batas listing",
    "Enter the listing limit message": "Masukkan pesan batas listing",
    "subscriptions.config.inactive_message": "Pesan saat langganan tidak aktif",
    "Message when the subscription is inactive": "Pesan saat langganan tidak aktif",
    "subscriptions.config.inactive_placeholder": "Masukkan pesan langganan tidak aktif",
    "Enter the inactive subscription message": "Masukkan pesan langganan tidak aktif",
    "subscriptions.config.saved": "Pengaturan langganan berhasil disimpan",
    "Subscription settings saved successfully": "Pengaturan langganan berhasil disimpan",
    "people.title": "People",
    "people.tab.staff": "Staf",
    "Staff": "Staf",
    "people.tab.departments": "Departemen",
    "Departments": "Departemen",
    "people.tab.job_profiles": "Profil jabatan",
    "Job profiles": "Profil jabatan",
    "people.tab.pay_grades": "Golongan gaji",
    "Pay grades": "Golongan gaji",
    "people.action.add_staff": "Tambah staf",
    "Add staff": "Tambah staf",
    "people.action.add_department": "Tambah departemen",
    "Add department": "Tambah departemen",
    "people.action.add_job_profile": "Tambah profil jabatan",
    "Add job profile": "Tambah profil jabatan",
    "people.action.add_pay_grade": "Tambah golongan gaji",
    "Add pay grade": "Tambah golongan gaji",
    "people.currency_id": "ID mata uang",
    "people.onboarding.eyebrow": "Mulai menggunakan People",
    "Get started with People": "Mulai menggunakan People",
    "people.onboarding.title": "Buat direktori tim",
    "Build your team directory": "Buat direktori tim",
    "people.onboarding.description": "Tambahkan staf pertama, lalu atur tim dengan departemen, profil jabatan, dan golongan gaji.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Tambahkan staf pertama, lalu atur tim dengan departemen, profil jabatan, dan golongan gaji.",
    "people.onboarding.add_first": "Tambah staf pertama",
    "Add your first staff member": "Tambah staf pertama",
    "people.onboarding.step_staff": "Tambah staf",
    "people.onboarding.step_staff_description": "Hubungkan pengguna yang ada ke direktori staf.",
    "Link an existing user to your staff directory.": "Hubungkan pengguna yang ada ke direktori staf.",
    "people.onboarding.step_teams": "Atur tim",
    "Organize teams": "Atur tim",
    "people.onboarding.step_teams_description": "Buat departemen dan profil jabatan seiring pertumbuhan tim.",
    "Create departments and job profiles as you grow.": "Buat departemen dan profil jabatan seiring pertumbuhan tim.",
    "people.onboarding.step_pay": "Atur kompensasi",
    "Set compensation": "Atur kompensasi",
    "people.onboarding.step_pay_description": "Tentukan golongan gaji agar pengaturan penggajian konsisten.",
    "Define pay grades for consistent payroll setup.": "Tentukan golongan gaji agar pengaturan penggajian konsisten.",
    "people.staff_profile": "Profil staf",
    "Staff profile": "Profil staf",
    "people.field.employee_code": "Kode karyawan",
    "Employee code": "Kode karyawan",
    "people.field.job_title": "Jabatan",
    "Job title": "Jabatan",
    "people.field.department": "Departemen",
    "Department": "Departemen",
    "people.field.job_profile": "Profil jabatan",
    "Job profile": "Profil jabatan",
    "people.field.pay_grade": "Golongan gaji",
    "Pay grade": "Golongan gaji",
    "people.field.employment_type": "Jenis pekerjaan",
    "Employment type": "Jenis pekerjaan",
    "people.field.start_date": "Tanggal mulai",
    "people.field.user_id": "ID pengguna",
    "people.field.user": "Pengguna",
    "people.field.grade": "Tingkat",
    "Grade": "Tingkat",
    "people.field.salary_range": "Rentang gaji",
    "Salary range": "Rentang gaji",
    "people.field.minimum_salary": "Gaji minimum",
    "Minimum salary": "Gaji minimum",
    "people.field.maximum_salary": "Gaji maksimum",
    "Maximum salary": "Gaji maksimum",
    "people.field.currency_id": "ID mata uang",
    "people.form.staff.edit": "Edit staf",
    "Edit staff": "Edit staf",
    "people.form.staff.add": "Tambah staf",
    "people.form.staff.description": "Hubungkan pengguna yang ada ke profil staf.",
    "Link an existing user to a staff profile.": "Hubungkan pengguna yang ada ke profil staf.",
    "people.form.department.edit": "Edit departemen",
    "Edit department": "Edit departemen",
    "people.form.department.add": "Tambah departemen",
    "people.form.job_profile.edit": "Edit profil jabatan",
    "Edit job profile": "Edit profil jabatan",
    "people.form.job_profile.add": "Tambah profil jabatan",
    "people.form.pay_grade.edit": "Edit golongan gaji",
    "Edit pay grade": "Edit golongan gaji",
    "people.form.pay_grade.add": "Tambah golongan gaji",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Senior Engineer",
    "Senior Engineer": "Senior Engineer",
    "people.placeholder.department": "Engineering",
    "Engineering": "Engineering",
    "people.placeholder.department_description": "Tim Produk & Engineering",
    "Product & Engineering team": "Tim Produk & Engineering",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Penuh waktu",
    "Full time": "Penuh waktu",
    "people.employment.part_time": "Paruh waktu",
    "Part time": "Paruh waktu",
    "people.employment.contractor": "Kontraktor",
    "Contractor": "Kontraktor",
    "people.toast.staff_added": "Staf ditambahkan",
    "Staff added": "Staf ditambahkan",
    "people.toast.staff_updated": "Staf diperbarui",
    "Staff updated": "Staf diperbarui",
    "people.toast.department_added": "Departemen ditambahkan",
    "Department added": "Departemen ditambahkan",
    "people.toast.department_updated": "Departemen diperbarui",
    "Department updated": "Departemen diperbarui",
    "people.toast.job_profile_added": "Profil jabatan ditambahkan",
    "Job profile added": "Profil jabatan ditambahkan",
    "people.toast.job_profile_updated": "Profil jabatan diperbarui",
    "Job profile updated": "Profil jabatan diperbarui",
    "people.toast.pay_grade_added": "Golongan gaji ditambahkan",
    "Pay grade added": "Golongan gaji ditambahkan",
    "people.toast.pay_grade_updated": "Golongan gaji diperbarui",
    "Pay grade updated": "Golongan gaji diperbarui",
    "people.empty.staff": "Belum ada staf. Tambahkan profil staf untuk memulai.",
    "No staff yet. Add a staff profile to get started.": "Belum ada staf. Tambahkan profil staf untuk memulai.",
    "people.empty.departments": "Belum ada departemen.",
    "No departments yet.": "Belum ada departemen.",
    "people.empty.job_profiles": "Belum ada profil jabatan.",
    "No job profiles yet.": "Belum ada profil jabatan.",
    "people.empty.pay_grades": "Belum ada golongan gaji.",
    "No pay grades yet.": "Belum ada golongan gaji.",
    "people.pagination.page": "Halaman {page}",
    "Page {page}": "Halaman {page}",
    "workforce.title": "Tenaga kerja",
    "workforce.tab.shifts": "Shift",
    "Shifts": "Shift",
    "workforce.tab.attendance": "Kehadiran",
    "Attendance": "Kehadiran",
    "workforce.tab.leave_requests": "Permintaan cuti",
    "Leave requests": "Permintaan cuti",
    "workforce.tab.leave_balances": "Saldo cuti",
    "Leave balances": "Saldo cuti",
    "workforce.tab.leave_policies": "Kebijakan cuti",
    "Leave policies": "Kebijakan cuti",
    "workforce.action.add_shift": "Tambah shift",
    "Add shift": "Tambah shift",
    "workforce.action.new_leave_request": "Permintaan cuti baru",
    "New leave request": "Permintaan cuti baru",
    "workforce.action.set_balance": "Atur saldo",
    "Set balance": "Atur saldo",
    "workforce.action.add_policy": "Tambah kebijakan",
    "Add policy": "Tambah kebijakan",
    "workforce.action.create_request": "Buat permintaan",
    "Create request": "Buat permintaan",
    "workforce.action.save_balance": "Simpan saldo",
    "Save balance": "Simpan saldo",
    "workforce.action.clock_in": "Absen masuk",
    "Clock in": "Absen masuk",
    "workforce.action.clock_out": "Absen pulang",
    "Clock out": "Absen pulang",
    "workforce.action.clocking_in": "Absen masuk…",
    "Clocking in…": "Absen masuk…",
    "workforce.action.clocking_out": "Absen pulang…",
    "Clocking out…": "Absen pulang…",
    "workforce.field.staff": "Staf",
    "workforce.field.start_time": "Mulai",
    "workforce.field.end_time": "Selesai",
    "workforce.field.location": "Lokasi",
    "workforce.field.leave_type": "Jenis cuti",
    "Leave type": "Jenis cuti",
    "workforce.field.from": "Dari",
    "workforce.field.to": "Sampai",
    "workforce.field.days": "Hari",
    "Days": "Hari",
    "workforce.field.total_days": "Total hari",
    "Total days": "Total hari",
    "workforce.field.days_per_year": "Hari per tahun",
    "Days per year": "Hari per tahun",
    "workforce.field.carry_over": "Bawa ke tahun berikutnya",
    "Carry over": "Bawa ke tahun berikutnya",
    "workforce.field.carry_over_hint": "Sisa hari yang belum digunakan dibawa ke tahun berikutnya",
    "Unused days carry over to next year": "Sisa hari yang belum digunakan dibawa ke tahun berikutnya",
    "workforce.field.reason": "Alasan",
    "workforce.field.time": "Waktu",
    "workforce.field.clock_in": "Absen masuk",
    "workforce.field.clock_out": "Absen pulang",
    "workforce.field.hours": "Jam",
    "Hours": "Jam",
    "workforce.field.dates": "Tanggal",
    "Dates": "Tanggal",
    "workforce.field.used_days": "Terpakai",
    "Used": "Terpakai",
    "workforce.field.remaining_days": "Sisa hari",
    "workforce.field.policy": "Kebijakan",
    "Policy": "Kebijakan",
    "workforce.placeholder.location": "Kantor pusat",
    "HQ": "Kantor pusat",
    "workforce.placeholder.leave_note": "Liburan keluarga",
    "Family holiday": "Liburan keluarga",
    "workforce.placeholder.policy_name": "Cuti tahunan",
    "Annual Leave": "Cuti tahunan",
    "workforce.placeholder.reject_reason": "Periode sibuk",
    "Busy period": "Periode sibuk",
    "workforce.placeholder.optional_note": "Catatan opsional",
    "Optional note": "Catatan opsional",
    "workforce.select.all_staff": "Semua staf",
    "All staff": "Semua staf",
    "workforce.form.shift.add": "Tambah shift",
    "workforce.form.leave_request.add": "Permintaan cuti baru",
    "workforce.form.leave_balance.title": "Atur saldo cuti",
    "Set leave balance": "Atur saldo cuti",
    "workforce.form.leave_balance.description": "Atur jatah cuti staf untuk jenis cuti dan tahun tertentu.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Atur jatah cuti staf untuk jenis cuti dan tahun tertentu.",
    "workforce.form.leave_policy.add": "Tambah kebijakan cuti",
    "Add leave policy": "Tambah kebijakan cuti",
    "workforce.form.leave_request.reject": "Tolak permintaan cuti",
    "Reject leave request": "Tolak permintaan cuti",
    "workforce.form.clock_out": "Absen pulang",
    "workforce.toast.shift_added": "Shift ditambahkan",
    "Shift added": "Shift ditambahkan",
    "workforce.toast.leave_request_created": "Permintaan cuti dibuat",
    "Leave request created": "Permintaan cuti dibuat",
    "workforce.toast.leave_balance_saved": "Saldo cuti disimpan",
    "Leave balance saved": "Saldo cuti disimpan",
    "workforce.toast.leave_policy_added": "Kebijakan cuti ditambahkan",
    "Leave policy added": "Kebijakan cuti ditambahkan",
    "workforce.toast.leave_request_rejected": "Permintaan cuti ditolak",
    "Leave request rejected": "Permintaan cuti ditolak",
    "workforce.toast.leave_request_approved": "Permintaan cuti disetujui",
    "Leave request approved": "Permintaan cuti disetujui",
    "workforce.toast.clocked_in": "Absen masuk tercatat",
    "Clocked in": "Absen masuk tercatat",
    "workforce.toast.clocked_out": "Absen pulang tercatat",
    "Clocked out": "Absen pulang tercatat",
    "workforce.empty.shifts": "Tidak ada shift pada periode ini.",
    "No shifts in this period.": "Tidak ada shift pada periode ini.",
    "workforce.empty.attendance": "Tidak ada catatan kehadiran.",
    "No attendance records.": "Tidak ada catatan kehadiran.",
    "workforce.empty.leave_requests": "Tidak ada permintaan cuti.",
    "No leave requests.": "Tidak ada permintaan cuti.",
    "workforce.empty.leave_balances": "Belum ada saldo cuti. Gunakan Atur saldo untuk menambahkannya.",
    "No leave balances. Use Set balance to add one.": "Belum ada saldo cuti. Gunakan Atur saldo untuk menambahkannya.",
    "workforce.empty.leave_policies": "Belum ada kebijakan cuti.",
    "No leave policies yet.": "Belum ada kebijakan cuti.",
    "workforce.leave_type.annual": "Cuti tahunan",
    "Annual leave": "Cuti tahunan",
    "workforce.leave_type.sick": "Cuti sakit",
    "Sick leave": "Cuti sakit",
    "workforce.leave_type.unpaid": "Cuti tanpa gaji",
    "Unpaid leave": "Cuti tanpa gaji",
    "workforce.leave_type.parental": "Cuti orang tua",
    "Parental leave": "Cuti orang tua",
    "workforce.leave_type.compassionate": "Cuti belasungkawa",
    "Compassionate leave": "Cuti belasungkawa",
    "workforce.duration.hours_minutes": "{hours}j {minutes}m",
    "{hours}h {minutes}m": "{hours}j {minutes}m",
    "common.year": "Tahun",
    "Year": "Tahun",
    "common.approve": "Setujui",
    "common.reject": "Tolak",
    "payroll.title": "Penggajian",
    "payroll.tab.runs": "Proses penggajian",
    "Payroll runs": "Proses penggajian",
    "payroll.tab.components": "Komponen gaji",
    "Pay components": "Komponen gaji",
    "payroll.tab.claims": "Klaim pengeluaran",
    "Expense claims": "Klaim pengeluaran",
    "payroll.tab.categories": "Kategori pengeluaran",
    "Expense categories": "Kategori pengeluaran",
    "payroll.action.new_run": "Proses penggajian baru",
    "New payroll run": "Proses penggajian baru",
    "payroll.action.add_component": "Tambah komponen gaji",
    "Add pay component": "Tambah komponen gaji",
    "payroll.action.new_claim": "Klaim pengeluaran baru",
    "New expense claim": "Klaim pengeluaran baru",
    "payroll.action.add_category": "Tambah kategori",
    "payroll.action.create_run": "Buat proses",
    "Create run": "Buat proses",
    "payroll.action.create_component": "Buat komponen",
    "Create component": "Buat komponen",
    "payroll.action.create_claim": "Buat klaim",
    "Create claim": "Buat klaim",
    "payroll.action.submit_claim": "Kirim",
    "Submit": "Kirim",
    "payroll.action.approve_claim": "Setujui",
    "payroll.action.reimburse_claim": "Ganti rugi",
    "Reimburse": "Ganti rugi",
    "payroll.action.approve_payroll": "Setujui penggajian",
    "Approve payroll": "Setujui penggajian",
    "payroll.action.activate": "Aktifkan",
    "Activate": "Aktifkan",
    "payroll.action.deactivate": "Nonaktifkan",
    "payroll.action.adjust": "Sesuaikan",
    "payroll.action.save_adjustment": "Simpan penyesuaian",
    "payroll.action.export_csv": "Ekspor CSV",
    "Export CSV": "Ekspor CSV",
    "payroll.action.exporting": "Mengekspor…",
    "payroll.action.view_staff_items": "Lihat item staf",
    "View staff items": "Lihat item staf",
    "payroll.action.view_payslips": "Lihat slip gaji",
    "View payslips": "Lihat slip gaji",
    "payroll.type.addition": "Penambahan",
    "Addition": "Penambahan",
    "payroll.type.deduction": "Potongan",
    "Deduction": "Potongan",
    "payroll.calculation.fixed": "Jumlah tetap",
    "Fixed amount": "Jumlah tetap",
    "payroll.calculation.percentage": "Persentase",
    "payroll.applies_to.all": "Semua staf",
    "payroll.applies_to.hourly": "Staf per jam",
    "Hourly staff": "Staf per jam",
    "payroll.applies_to.salaried": "Staf bergaji",
    "Salaried staff": "Staf bergaji",
    "payroll.category.archive_confirm": "Arsipkan {name}?",
    "payroll.components.description": "Penambahan dan potongan aktif diterapkan otomatis ke proses penggajian baru.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Penambahan dan potongan aktif diterapkan otomatis ke proses penggajian baru.",
    "payroll.empty.categories": "Belum ada kategori pengeluaran.",
    "No expense categories yet.": "Belum ada kategori pengeluaran.",
    "payroll.empty.claims": "Belum ada klaim pengeluaran.",
    "No expense claims yet.": "Belum ada klaim pengeluaran.",
    "payroll.empty.components": "Belum ada komponen gaji.",
    "No pay components configured yet.": "Belum ada komponen gaji.",
    "payroll.empty.runs": "Belum ada proses penggajian.",
    "No payroll runs yet.": "Belum ada proses penggajian.",
    "payroll.field.staff": "Staf",
    "payroll.field.base_pay": "Gaji pokok",
    "Base pay": "Gaji pokok",
    "payroll.field.allowances": "Tunjangan",
    "Allowances": "Tunjangan",
    "payroll.field.deductions": "Potongan",
    "Deductions": "Potongan",
    "payroll.field.commission": "Komisi",
    "payroll.field.net_pay": "Gaji bersih",
    "Net pay": "Gaji bersih",
    "payroll.field.components": "Komponen",
    "Components": "Komponen",
    "payroll.field.commission_override": "Penggantian komisi",
    "Commission override": "Penggantian komisi",
    "payroll.field.calculation": "Perhitungan",
    "Calculation": "Perhitungan",
    "payroll.field.applies_to": "Berlaku untuk",
    "Applies to": "Berlaku untuk",
    "payroll.field.staff_optional_draft": "Staf (opsional saat draf)",
    "Staff (optional while drafting)": "Staf (opsional saat draf)",
    "payroll.field.category_optional_draft": "Kategori (opsional saat draf)",
    "Category (optional while drafting)": "Kategori (opsional saat draf)",
    "payroll.field.category": "Kategori",
    "payroll.field.period": "Periode",
    "payroll.field.period_start": "Awal periode",
    "Period start": "Awal periode",
    "payroll.field.period_end": "Akhir periode",
    "Period end": "Akhir periode",
    "payroll.field.generate_email_payslips": "Buat dan kirim slip gaji melalui email",
    "Generate and email payslips": "Buat dan kirim slip gaji melalui email",
    "payroll.field.gl_code": "Kode buku besar",
    "GL code": "Kode buku besar",
    "payroll.field.maximum_per_claim": "Maksimum per klaim",
    "Maximum per claim": "Maksimum per klaim",
    "payroll.field.maximum_per_transaction": "Maksimum per transaksi",
    "Maximum per transaction": "Maksimum per transaksi",
    "payroll.field.spending_cap": "Batas pengeluaran",
    "Spending cap": "Batas pengeluaran",
    "payroll.field.tax_rate": "Tarif pajak (%)",
    "Tax rate (%)": "Tarif pajak (%)",
    "payroll.field.no_limit": "Tanpa batas",
    "No limit": "Tanpa batas",
    "payroll.form.run.title": "Proses penggajian baru",
    "payroll.form.run.description": "Gaji dihitung berdasarkan golongan gaji staf untuk periode yang dipilih.",
    "Pay is calculated from staff pay grades for the selected period.": "Gaji dihitung berdasarkan golongan gaji staf untuk periode yang dipilih.",
    "payroll.form.component.title": "Tambah komponen gaji",
    "payroll.form.component.description": "Komponen otomatis disertakan dalam proses penggajian berikutnya.",
    "Components are automatically included in future payroll runs.": "Komponen otomatis disertakan dalam proses penggajian berikutnya.",
    "payroll.form.claim.title": "Klaim pengeluaran baru",
    "payroll.form.claim.description": "Klaim tetap berupa draf hingga dikirim untuk disetujui.",
    "Claims start as drafts until submitted for approval.": "Klaim tetap berupa draf hingga dikirim untuk disetujui.",
    "payroll.form.category.add": "Tambah kategori pengeluaran",
    "Add expense category": "Tambah kategori pengeluaran",
    "payroll.form.category.edit": "Edit kategori pengeluaran",
    "Edit expense category": "Edit kategori pengeluaran",
    "payroll.form.claim.approve_title": "Setujui klaim pengeluaran",
    "Approve expense claim": "Setujui klaim pengeluaran",
    "payroll.form.run.approve_title": "Setujui penggajian",
    "Approve payroll run": "Setujui penggajian",
    "payroll.form.run.approve_description": "Persetujuan mengunci proses penggajian. Anda juga dapat membuat dan mengirim slip gaji sekarang.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "Persetujuan mengunci proses penggajian. Anda juga dapat membuat dan mengirim slip gaji sekarang.",
    "payroll.items.title": "Item penggajian staf",
    "Staff payroll items": "Item penggajian staf",
    "payroll.items.loading": "Memuat item penggajian…",
    "Loading payroll items…": "Memuat item penggajian…",
    "payroll.items.empty": "Item penggajian tidak ditemukan.",
    "No payroll items found.": "Item penggajian tidak ditemukan.",
    "payroll.items.adjust_title": "Sesuaikan item penggajian",
    "Adjust payroll item": "Sesuaikan item penggajian",
    "payroll.items.adjust_description": "Perbarui potongan atau sesuaikan jumlah komisi untuk staf ini.",
    "Update deductions or override the commission amount for this staff member.": "Perbarui potongan atau sesuaikan jumlah komisi untuk staf ini.",
    "payroll.payslips.title": "Slip gaji",
    "Payslips": "Slip gaji",
    "payroll.payslips.generate": "Buat slip gaji",
    "Generate payslips": "Buat slip gaji",
    "payroll.payslips.generating": "Membuat…",
    "Generating…": "Membuat…",
    "payroll.payslips.empty": "Belum ada slip gaji.",
    "No payslips generated yet.": "Belum ada slip gaji.",
    "payroll.payslips.generated": "Dibuat",
    "Generated": "Dibuat",
    "payroll.payslips.sent_at": "Dikirim {date}",
    "Sent {date}": "Dikirim {date}",
    "payroll.payslips.not_sent": "Belum dikirim",
    "Not sent": "Belum dikirim",
    "payroll.payslips.send_email": "Kirim email",
    "Send email": "Kirim email",
    "payroll.payslips.sending": "Mengirim…",
    "payroll.payslips.details": "Detail slip gaji",
    "Payslip details": "Detail slip gaji",
    "payroll.placeholder.approval_note": "Disetujui",
    "payroll.placeholder.category_name": "Perjalanan",
    "Travel": "Perjalanan",
    "payroll.placeholder.claim_description": "Penerbangan ke klien",
    "Flight to client": "Penerbangan ke klien",
    "payroll.placeholder.component_name": "Tunjangan transportasi",
    "Transport Allowance": "Tunjangan transportasi",
    "payroll.staff_number": "Staf #{id}",
    "Staff #{id}": "Staf #{id}",
    "payroll.toast.category_added": "Kategori pengeluaran ditambahkan",
    "Expense category added": "Kategori pengeluaran ditambahkan",
    "payroll.toast.category_archived": "Kategori pengeluaran diarsipkan",
    "Expense category archived": "Kategori pengeluaran diarsipkan",
    "payroll.toast.category_updated": "Kategori pengeluaran diperbarui",
    "Expense category updated": "Kategori pengeluaran diperbarui",
    "payroll.toast.claim_approved": "Klaim disetujui",
    "Claim approved": "Klaim disetujui",
    "payroll.toast.claim_created": "Klaim pengeluaran dibuat",
    "Expense claim created": "Klaim pengeluaran dibuat",
    "payroll.toast.claim_reimbursed": "Klaim ditandai telah diganti",
    "Claim marked as reimbursed": "Klaim ditandai telah diganti",
    "payroll.toast.claim_submitted": "Klaim dikirim",
    "Claim submitted": "Klaim dikirim",
    "payroll.toast.component_activated": "Komponen gaji diaktifkan",
    "Pay component activated": "Komponen gaji diaktifkan",
    "payroll.toast.component_created": "Komponen gaji dibuat",
    "Pay component created": "Komponen gaji dibuat",
    "payroll.toast.component_deactivated": "Komponen gaji dinonaktifkan",
    "Pay component deactivated": "Komponen gaji dinonaktifkan",
    "payroll.toast.item_updated": "Item penggajian diperbarui",
    "Payroll item updated": "Item penggajian diperbarui",
    "payroll.toast.payslip_email_sent": "Email slip gaji terkirim",
    "Payslip email sent": "Email slip gaji terkirim",
    "payroll.toast.payslips_generated": "Slip gaji dibuat",
    "Payslips generated": "Slip gaji dibuat",
    "payroll.toast.run_approved": "Penggajian disetujui",
    "Payroll run approved": "Penggajian disetujui",
    "payroll.toast.run_approved_payslips_queued": "Penggajian disetujui dan slip gaji masuk antrean",
    "Payroll approved and payslips queued": "Penggajian disetujui dan slip gaji masuk antrean",
    "payroll.toast.run_created": "Proses penggajian dibuat",
    "Payroll run created": "Proses penggajian dibuat",
    "payroll.toast.exported": "Penggajian diekspor",
    "Payroll exported": "Penggajian diekspor",
    "common.notes": "Catatan",
    "expenses.title": "Pengeluaran",
    "expenses.action.add": "Tambah pengeluaran",
    "Add expense": "Tambah pengeluaran",
    "expenses.action.create": "Buat pengeluaran",
    "Create expense": "Buat pengeluaran",
    "expenses.action.submit": "Kirim",
    "expenses.action.approve": "Setujui",
    "expenses.action.reimburse": "Ganti rugi",
    "expenses.action.pay": "Bayar",
    "expenses.action.lifecycle": "Pengeluaran {action}",
    "Expense {action}d": "Pengeluaran {action}",
    "expenses.type.claim": "Klaim",
    "Claim": "Klaim",
    "expenses.type.claims": "Klaim",
    "Claims": "Klaim",
    "expenses.type.bill": "Tagihan",
    "Bill": "Tagihan",
    "expenses.type.bills": "Tagihan",
    "Bills": "Tagihan",
    "expenses.filter.all_types": "Semua jenis",
    "All types": "Semua jenis",
    "expenses.filter.all_statuses": "Semua status",
    "expenses.summary.title": "Ringkasan",
    "Summary": "Ringkasan",
    "expenses.summary.by_category": "Berdasarkan kategori",
    "By category": "Berdasarkan kategori",
    "expenses.summary.by_status": "Berdasarkan status",
    "By status": "Berdasarkan status",
    "expenses.summary.by_party": "Berdasarkan pemasok / staf",
    "By supplier / staff": "Berdasarkan pemasok / staf",
    "expenses.summary.heading": "Ringkasan berdasarkan {group}",
    "Summary by {group}": "Ringkasan berdasarkan {group}",
    "expenses.summary.group.category": "kategori",
    "category": "kategori",
    "expenses.summary.group.status": "status",
    "status": "status",
    "expenses.summary.group.party": "pemasok / staf",
    "supplier / staff": "pemasok / staf",
    "expenses.summary.empty": "Ringkasan tidak tersedia.",
    "No summary available.": "Ringkasan tidak tersedia.",
    "expenses.column.type": "Jenis",
    "expenses.column.party": "Staf / Pemasok",
    "Staff / Supplier": "Staf / Pemasok",
    "expenses.column.status": "Status",
    "expenses.field.staff_optional": "Staf (opsional saat draf)",
    "expenses.field.supplier_optional": "Pemasok (opsional saat draf)",
    "Supplier (optional while drafting)": "Pemasok (opsional saat draf)",
    "expenses.field.category_optional": "Kategori (opsional saat draf)",
    "expenses.field.amount": "Jumlah",
    "expenses.field.currency": "Mata uang",
    "expenses.field.description": "Deskripsi",
    "expenses.field.due_date": "Tanggal jatuh tempo",
    "Due date": "Tanggal jatuh tempo",
    "expenses.field.receipt_url": "URL bukti",
    "Receipt URL": "URL bukti",
    "expenses.empty": "Tidak ada pengeluaran yang cocok dengan filter yang dipilih.",
    "No expenses found for the selected filters.": "Tidak ada pengeluaran yang cocok dengan filter yang dipilih.",
    "expenses.modal.edit": "Edit pengeluaran",
    "Edit expense": "Edit pengeluaran",
    "expenses.modal.add": "Tambah {type}",
    "Add {type}": "Tambah {type}",
    "expenses.modal.bill_help": "Buat draf sekarang dan tetapkan pemasok sebelum mengirim.",
    "Create the draft now and assign a supplier before submitting.": "Buat draf sekarang dan tetapkan pemasok sebelum mengirim.",
    "expenses.modal.claim_help": "Buat draf sekarang dan tetapkan staf sebelum mengirim.",
    "Create the draft now and assign a staff member before submitting.": "Buat draf sekarang dan tetapkan staf sebelum mengirim.",
    "expenses.toast.updated": "Pengeluaran diperbarui",
    "Expense updated": "Pengeluaran diperbarui",
    "expenses.toast.created": "Pengeluaran dibuat",
    "Expense created": "Pengeluaran dibuat",
    "recurring_payments.title": "Pembayaran berulang",
    "recurring_payments.action.add": "Tambah pembayaran berulang",
    "Add recurring payment": "Tambah pembayaran berulang",
    "recurring_payments.action.create": "Buat pembayaran berulang",
    "Create recurring payment": "Buat pembayaran berulang",
    "recurring_payments.action.pause": "Jeda",
    "Pause": "Jeda",
    "recurring_payments.action.resume": "Lanjutkan",
    "Resume": "Lanjutkan",
    "recurring_payments.action.remove": "Hapus",
    "recurring_payments.description": "Buat draf tagihan pengeluaran otomatis untuk pembayaran pemasok rutin.",
    "Automatically create draft expense bills for regular supplier payments.": "Buat draf tagihan pengeluaran otomatis untuk pembayaran pemasok rutin.",
    "recurring_payments.field.name": "Nama",
    "recurring_payments.field.supplier": "Pemasok",
    "recurring_payments.field.supplier_optional": "Pemasok (opsional)",
    "Supplier (optional)": "Pemasok (opsional)",
    "recurring_payments.field.frequency": "Frekuensi",
    "Frequency": "Frekuensi",
    "recurring_payments.field.next_due": "Tanggal jatuh tempo berikutnya",
    "Next due date": "Tanggal jatuh tempo berikutnya",
    "recurring_payments.field.auto_create": "Buat draf tagihan otomatis",
    "Auto-create draft bill": "Buat draf tagihan otomatis",
    "recurring_payments.field.auto_create_help": "Buat draf tagihan pengeluaran secara otomatis",
    "Create a draft expense bill automatically": "Buat draf tagihan pengeluaran secara otomatis",
    "recurring_payments.field.one_time": "Pembayaran satu kali",
    "One-time payment": "Pembayaran satu kali",
    "recurring_payments.field.one_time_help": "Akhiri setelah tagihan berikutnya dibuat",
    "End after the next generated bill": "Akhiri setelah tagihan berikutnya dibuat",
    "recurring_payments.field.end_date": "Tanggal akhir",
    "recurring_payments.placeholder.name": "Sewa Kantor",
    "Office Rent": "Sewa Kantor",
    "recurring_payments.frequency.daily": "Harian",
    "recurring_payments.frequency.weekly": "Mingguan",
    "recurring_payments.frequency.monthly": "Bulanan",
    "recurring_payments.frequency.quarterly": "Triwulanan",
    "recurring_payments.frequency.yearly": "Tahunan",
    "Yearly": "Tahunan",
    "recurring_payments.form.description": "Jika otomatisasi aktif, pembayaran jatuh tempo membuat draf tagihan di Pengeluaran.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Jika otomatisasi aktif, pembayaran jatuh tempo membuat draf tagihan di Pengeluaran.",
    "recurring_payments.empty": "Belum ada pembayaran berulang.",
    "No recurring payments yet.": "Belum ada pembayaran berulang.",
    "recurring_payments.this_payment": "pembayaran berulang ini",
    "this recurring payment": "pembayaran berulang ini",
    "recurring_payments.confirm_remove": "Hapus {name}?",
    "Remove {name}?": "Hapus {name}?",
    "recurring_payments.toast.pause": "Pembayaran berulang dijeda",
    "Recurring payment paused": "Pembayaran berulang dijeda",
    "recurring_payments.toast.resume": "Pembayaran berulang dilanjutkan",
    "Recurring payment resumed": "Pembayaran berulang dilanjutkan",
    "recurring_payments.toast.delete": "Pembayaran berulang dihapus",
    "Recurring payment removed": "Pembayaran berulang dihapus",
    "recurring_payments.toast.created": "Pembayaran berulang dibuat",
    "Recurring payment created": "Pembayaran berulang dibuat",
    "expenses.toast.submit": "Pengeluaran dikirim",
    "Expense submitted": "Pengeluaran dikirim",
    "expenses.toast.approve": "Pengeluaran disetujui",
    "Expense approved": "Pengeluaran disetujui",
    "expenses.toast.reimburse": "Pengeluaran diganti",
    "Expense reimbursed": "Pengeluaran diganti",
    "expenses.toast.pay": "Pengeluaran dibayar",
    "Expense paid": "Pengeluaran dibayar",
    "media_picker.title": "Pilih media",
    "Select media": "Pilih media",
    "media_picker.type.media": "Media",
    "media_picker.type.all": "Semua",
    "media_picker.type.image": "Gambar",
    "media_picker.type.video": "Video",
    "media_picker.type.audio": "Audio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Folder",
    "media_picker.label.show": "Tampilkan",
    "media_picker.label.media_type": "Jenis media",
    "Media type": "Jenis media",
    "media_picker.action.show_type": "Tampilkan media {type}",
    "media_picker.action.close": "Tutup pemilih media",
    "Close media picker": "Tutup pemilih media",
    "media_picker.action.upload": "Unggah media",
    "media_picker.action.creating": "Membuat…",
    "media_picker.action.create_folder": "Buat folder",
    "Create folder": "Buat folder",
    "media_picker.action.cancel": "Batal",
    "media_picker.action.use_selected": "Gunakan yang dipilih",
    "Use selected": "Gunakan yang dipilih",
    "media_picker.placeholder.search": "Cari media",
    "media_picker.placeholder.folder": "Nama folder baru",
    "New folder name": "Nama folder baru",
    "media_picker.loading": "Memuat media…",
    "media_picker.empty": "Tidak ada media di folder ini.",
    "No media found in this folder.": "Tidak ada media di folder ini.",
    "media_picker.selection.count": "{count} dipilih",
    "{count} selected": "{count} dipilih",
    "media_picker.selection.prompt": "Pilih file untuk melanjutkan",
    "Select a file to continue": "Pilih file untuk melanjutkan",
    "media_picker.error.load": "Media gagal dimuat",
    "Unable to load media": "Media gagal dimuat",
    "media_picker.error.load_retry": "Media gagal dimuat. Silakan coba lagi.",
    "media_picker.error.create_folder": "Gagal membuat folder",
    "media_picker.error.create_folder_retry": "Gagal membuat folder. Silakan coba lagi.",
    "Unable to create folder. Please try again.": "Gagal membuat folder. Silakan coba lagi.",
    "media_picker.error.prepare_upload": "Gagal menyiapkan unggahan",
    "Unable to prepare upload": "Gagal menyiapkan unggahan",
    "media_picker.error.upload_url": "URL unggahan tidak tersedia",
    "Upload URL missing": "URL unggahan tidak tersedia",
    "media_picker.error.register_media": "Media gagal didaftarkan",
    "media_picker.error.upload_retry": "Media gagal diunggah. Silakan coba lagi.",
    "membership.title": "Keanggotaan",
    "membership.description": "Kelola program keanggotaan, kontribusi anggota, status pembayaran, dan aturan pengingat.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Kelola program keanggotaan, kontribusi anggota, status pembayaran, dan aturan pengingat.",
    "membership.action.settings": "Pengaturan",
    "membership.action.manage_programs": "Kelola program",
    "Manage programs": "Kelola program",
    "membership.action.view_data": "Lihat data",
    "View data": "Lihat data",
    "membership.action.edit_listing": "Edit listing",
    "membership.action.go_to_listings": "Buka listing",
    "Go to listings": "Buka listing",
    "membership.action.view_order": "Lihat pesanan",
    "View order": "Lihat pesanan",
    "membership.action.configure_reminders": "Atur pengingat",
    "Configure reminders": "Atur pengingat",
    "membership.stat.programs": "Program",
    "membership.stat.active_members": "Anggota aktif",
    "Active members": "Anggota aktif",
    "membership.stat.contributions": "Kontribusi",
    "Contributions": "Kontribusi",
    "membership.stat.units": "Unit yang diberikan",
    "Units credited": "Unit yang diberikan",
    "membership.programs.title": "Program",
    "membership.programs.description": "Listing jenis keanggotaan yang tersedia untuk pelanggan.",
    "Membership-type listings available to your customers.": "Listing jenis keanggotaan yang tersedia untuk pelanggan.",
    "membership.programs.no_description": "Belum ada deskripsi program.",
    "No program description yet.": "Belum ada deskripsi program.",
    "membership.programs.empty_title": "Belum ada program keanggotaan",
    "No membership programs yet": "Belum ada program keanggotaan",
    "membership.programs.empty_description": "Buat listing jenis keanggotaan untuk mulai menerima kontribusi.",
    "Create a listing with type membership to start accepting contributions.": "Buat listing jenis keanggotaan untuk mulai menerima kontribusi.",
    "membership.programs.history_description": "Riwayat harga dan anggota terdaftar.",
    "Price history and enrolled members.": "Riwayat harga dan anggota terdaftar.",
    "membership.badge": "Keanggotaan",
    "membership.loading_program": "Memuat data program…",
    "Loading program data…": "Memuat data program…",
    "membership.price_logs.title": "Log harga",
    "Price logs": "Log harga",
    "membership.price_logs.empty": "Belum ada catatan harga.",
    "No price logs recorded.": "Belum ada catatan harga.",
    "membership.source.manual": "manual",
    "manual": "manual",
    "membership.members.title": "Anggota",
    "Members": "Anggota",
    "membership.members.empty_program": "Belum ada anggota dalam program ini.",
    "No members enrolled in this program.": "Belum ada anggota dalam program ini.",
    "membership.members.recent": "Anggota terbaru",
    "Recent members": "Anggota terbaru",
    "membership.members.empty_recent": "Anggota dan kontribusi akan muncul di sini setelah pendaftaran.",
    "Members and contributions will appear here after enrolment.": "Anggota dan kontribusi akan muncul di sini setelah pendaftaran.",
    "membership.member_heading": "Anggota: {member}",
    "Member: {member}": "Anggota: {member}",
    "membership.contributions.title": "Kontribusi",
    "membership.contributions.empty": "Belum ada kontribusi.",
    "No contributions recorded yet.": "Belum ada kontribusi.",
    "membership.payment_dues.title": "Tagihan pembayaran",
    "Payment dues": "Tagihan pembayaran",
    "membership.payment_dues.empty": "Tidak ada tagihan terjadwal.",
    "No scheduled payment dues.": "Tidak ada tagihan terjadwal.",
    "membership.unit": "unit",
    "unit": "unit",
    "membership.units": "unit",
    "units": "unit",
    "membership.months": "bulan",
    "membership.automation.label": "OTOMATISASI",
    "AUTOMATION": "OTOMATISASI",
    "membership.automation.description": "Proses harian memeriksa pembayaran keanggotaan terjadwal.",
    "Daily worker checks scheduled membership payments.": "Proses harian memeriksa pembayaran keanggotaan terjadwal.",
    "membership.reminders.title": "Pengingat pembayaran",
    "Payment reminders": "Pengingat pembayaran",
    "membership.reminders.due_soon": "Pengingat pembayaran segera jatuh tempo",
    "Due-soon reminder": "Pengingat pembayaran segera jatuh tempo",
    "membership.reminders.due_soon_short": "Segera jatuh tempo",
    "Due soon": "Segera jatuh tempo",
    "membership.reminders.due_soon_help": "Kirim satu pengingat sebelum pembayaran terjadwal jatuh tempo.",
    "Send one reminder before a scheduled payment is due.": "Kirim satu pengingat sebelum pembayaran terjadwal jatuh tempo.",
    "membership.reminders.days_before": "Hari sebelum jatuh tempo",
    "Days before due date": "Hari sebelum jatuh tempo",
    "membership.reminders.days_before_value": "{count} hari sebelumnya",
    "{count} days before": "{count} hari sebelumnya",
    "membership.reminders.overdue": "Pengingat keterlambatan",
    "Overdue reminder": "Pengingat keterlambatan",
    "membership.reminders.overdue_help": "Kirim satu pengingat setelah tanggal jatuh tempo dan masa tenggang.",
    "Send one reminder after the due date and grace period.": "Kirim satu pengingat setelah tanggal jatuh tempo dan masa tenggang.",
    "membership.settings.title": "Pengaturan keanggotaan",
    "Membership settings": "Pengaturan keanggotaan",
    "membership.settings.description": "Atur jadwal pengingat pembayaran.",
    "Configure the payment reminder schedule.": "Atur jadwal pengingat pembayaran.",
    "membership.email_copy.title": "Konten email khusus",
    "Custom email copy": "Konten email khusus",
    "membership.email_copy.description": "Untuk mengedit subjek dan templat pengingat pembayaran, buka Pengaturan → Notifikasi → Keanggotaan.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Untuk mengedit subjek dan templat pengingat pembayaran, buka Pengaturan → Notifikasi → Keanggotaan.",
    "membership.toast.saved": "Pengaturan pengingat keanggotaan disimpan.",
    "Membership reminder settings saved.": "Pengaturan pengingat keanggotaan disimpan.",
    "membership.toast.save_failed": "Gagal menyimpan pengaturan pengingat.",
    "Unable to save membership reminder settings.": "Gagal menyimpan pengaturan pengingat.",
    "common.status.off": "Nonaktif",
    "Off": "Nonaktif",
    "common.status.on": "Aktif",
    "On": "Aktif",
    "common.save_settings": "Simpan pengaturan",
    "Save settings": "Simpan pengaturan",
    "developer.page.title": "API & Developer",
    "API & Developer": "API & Developer",
    "developer.api_keys.title": "Kunci API",
    "API Keys": "Kunci API",
    "developer.api_keys.description": "Gunakan kunci ini untuk mengautentikasi permintaan ke Tradly API. Jaga kerahasiaan Secret Key dan jangan pernah menaruhnya di kode sisi klien.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Gunakan kunci ini untuk mengautentikasi permintaan ke Tradly API. Jaga kerahasiaan Secret Key dan jangan pernah menaruhnya di kode sisi klien.",
    "developer.api_keys.credentials_description": "Berikut adalah kunci produksi. Anda membutuhkannya untuk mengotorisasi dan membangun aplikasi.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Berikut adalah kunci produksi. Anda membutuhkannya untuk mengotorisasi dan membangun aplikasi.",
    "developer.api_keys.publishable": "Kunci publishable",
    "Publishable Key": "Kunci publishable",
    "developer.api_keys.publishable_placeholder": "Masukkan kunci publishable",
    "Enter Publishable Key": "Masukkan kunci publishable",
    "developer.api_keys.secret": "Kunci rahasia",
    "developer.api_keys.secret_placeholder": "Masukkan kunci rahasia",
    "Enter Secret Key": "Masukkan kunci rahasia",
    "developer.api_keys.access_label": "Akses API",
    "API access": "Akses API",
    "developer.api_reference.title": "Referensi API",
    "developer.api_reference.description": "Dokumentasi REST API lengkap, panduan, dan contoh kode untuk membangun marketplace Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Dokumentasi REST API lengkap, panduan, dan contoh kode untuk membangun marketplace Tradly.",
    "developer.api_reference.card_description": "Pelajari referensi API, panduan autentikasi, webhook, dan dokumentasi SDK. Semua yang dibutuhkan untuk integrasi atau membangun frontend khusus di marketplace Anda.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Pelajari referensi API, panduan autentikasi, webhook, dan dokumentasi SDK. Semua yang dibutuhkan untuk integrasi atau membangun frontend khusus di marketplace Anda.",
    "developer.api_reference.open_docs": "Buka Dokumen API",
    "Open API Docs": "Buka Dokumen API",
    "developer.ai_agents.title": "AI & Agent",
    "AI & Agents": "AI & Agent",
    "developer.ai_agents.description": "Hubungkan marketplace ke alat AI dan biarkan pelanggan membuat agen yang didukung platform Anda.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Hubungkan marketplace ke alat AI dan biarkan pelanggan membuat agen yang didukung platform Anda.",
    "developer.mcp.action.create": "Buat",
    "developer.mcp.action.removing": "Menghapus…",
    "developer.mcp.scope.resource": "Sumber daya",
    "developer.customer_agents.description": "Biarkan pelanggan membuat agen AI yang berinteraksi dengan marketplace Anda. Kompatibel dengan ChatGPT, Claude, dan platform AI lainnya. Cocok untuk mengotomatiskan alur pembeli, membuat etalase khusus, atau asisten belanja cerdas.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Biarkan pelanggan membuat agen AI yang berinteraksi dengan marketplace Anda. Kompatibel dengan ChatGPT, Claude, dan platform AI lainnya. Cocok untuk mengotomatiskan alur pembeli, membuat etalase khusus, atau asisten belanja cerdas.",
    "whatsapp.title": "Konektor WhatsApp",
    "WhatsApp connector": "Konektor WhatsApp",
    "whatsapp.intro.title": "Kirim OTP dan pesan pemasaran melalui WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Kirim OTP dan pesan pemasaran melalui WhatsApp",
    "whatsapp.intro.help": "Hubungkan tenant ini ke Meta WhatsApp Cloud API. SMS tetap tersedia sebagai kanal default atau cadangan, dan konektor yang sama dapat mengirim templat kampanye WhatsApp yang disetujui.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Hubungkan tenant ini ke Meta WhatsApp Cloud API. SMS tetap tersedia sebagai kanal default atau cadangan, dan konektor yang sama dapat mengirim templat kampanye WhatsApp yang disetujui.",
    "whatsapp.status.disabled": "Nonaktif",
    "whatsapp.status.sms_otp": "Konektor aktif · OTP SMS",
    "Connector on · SMS OTP": "Konektor aktif · OTP SMS",
    "whatsapp.status.needs_configuration": "Perlu konfigurasi",
    "Needs configuration": "Perlu konfigurasi",
    "whatsapp.status.auto_fallback": "WhatsApp dengan SMS cadangan",
    "WhatsApp with SMS fallback": "WhatsApp dengan SMS cadangan",
    "whatsapp.status.sms_whatsapp_backup": "SMS dengan cadangan WhatsApp",
    "SMS with WhatsApp backup": "SMS dengan cadangan WhatsApp",
    "whatsapp.status.enabled": "WhatsApp aktif",
    "WhatsApp enabled": "WhatsApp aktif",
    "whatsapp.draft.notice": "Anda memiliki draf pengaturan WhatsApp yang belum disimpan.",
    "You have an unsaved WhatsApp settings draft.": "Anda memiliki draf pengaturan WhatsApp yang belum disimpan.",
    "whatsapp.connect.title": "Hubungkan WhatsApp bisnis Anda",
    "Connect your business WhatsApp": "Hubungkan WhatsApp bisnis Anda",
    "whatsapp.connect.description": "Masukkan nomor bisnis yang dikenal pelanggan. Meta akan membuka jendela verifikasi aman; Anda tidak perlu mencari ID WABA, ID nomor telepon, token akses, atau pengaturan API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Masukkan nomor bisnis yang dikenal pelanggan. Meta akan membuka jendela verifikasi aman; Anda tidak perlu mencari ID WABA, ID nomor telepon, token akses, atau pengaturan API.",
    "whatsapp.field.business_number": "Nomor WhatsApp bisnis",
    "Business WhatsApp number": "Nomor WhatsApp bisnis",
    "whatsapp.field.business_number_help": "Gunakan nomor yang ingin Anda gunakan untuk menerima pesan pelanggan, termasuk kode negara.",
    "Use the number you want customers to message, including country code.": "Gunakan nomor yang ingin Anda gunakan untuk menerima pesan pelanggan, termasuk kode negara.",
    "whatsapp.placeholder.business_number": "mis. +60 13 333 1671",
    "e.g. +60 13 333 1671": "mis. +60 13 333 1671",
    "whatsapp.field.connection_name": "Nama koneksi",
    "whatsapp.field.connection_name_help": "Gunakan nama yang jelas seperti Kuala Lumpur, Merek Retail, atau Dukungan.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Gunakan nama yang jelas seperti Kuala Lumpur, Merek Retail, atau Dukungan.",
    "whatsapp.placeholder.connection_name": "mis. Dukungan Kuala Lumpur",
    "e.g. Kuala Lumpur support": "mis. Dukungan Kuala Lumpur",
    "whatsapp.field.optional_details": "Detail koneksi opsional",
    "Optional connection details": "Detail koneksi opsional",
    "whatsapp.field.optional_details_help": "Gunakan ini hanya jika nomor tersebut milik merek, akun, atau cabang tertentu.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Gunakan ini hanya jika nomor tersebut milik merek, akun, atau cabang tertentu.",
    "whatsapp.field.brand_key": "Kunci merek",
    "Brand key": "Kunci merek",
    "whatsapp.field.brand_key_help": "Kunci internal merek yang stabil, seperti retail atau grosir.",
    "Stable internal key for a brand, such as retail or wholesale.": "Kunci internal merek yang stabil, seperti retail atau grosir.",
    "whatsapp.placeholder.brand_key": "mis. retail",
    "e.g. retail": "mis. retail",
    "whatsapp.field.account_id": "ID akun",
    "whatsapp.field.account_id_help": "Hubungkan nomor ini dengan akun Tradly yang ada.",
    "Associate this number with an existing Tradly account.": "Hubungkan nomor ini dengan akun Tradly yang ada.",
    "whatsapp.placeholder.account_id": "mis. 123",
    "e.g. 123": "mis. 123",
    "whatsapp.field.branch_id": "ID cabang",
    "Branch ID": "ID cabang",
    "whatsapp.field.branch_id_help": "Hubungkan nomor ini dengan cabang Tradly yang ada.",
    "Associate this number with an existing Tradly branch.": "Hubungkan nomor ini dengan cabang Tradly yang ada.",
    "whatsapp.placeholder.branch_id": "mis. 456",
    "e.g. 456": "mis. 456",
    "whatsapp.field.default_connection": "Gunakan sebagai koneksi default",
    "Use as default connection": "Gunakan sebagai koneksi default",
    "whatsapp.field.default_connection_help": "Alur OTP lama menggunakan koneksi default ini jika tidak ada koneksi khusus cabang.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Alur OTP lama menggunakan koneksi default ini jika tidak ada koneksi khusus cabang.",
    "whatsapp.field.uses_business_app": "Saya memakai aplikasi WhatsApp Business di nomor ini",
    "I use the WhatsApp Business app on this number": "Saya memakai aplikasi WhatsApp Business di nomor ini",
    "whatsapp.field.uses_business_app_help": "Tetap mengobrol di aplikasi WhatsApp Business di ponsel Anda. Meta akan meminta Anda memindai kode QR dari aplikasi, lalu kontak dan obrolan terbaru Anda disinkronkan. Memerlukan versi 2.24.17 atau lebih baru.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Tetap mengobrol di aplikasi WhatsApp Business di ponsel Anda. Meta akan meminta Anda memindai kode QR dari aplikasi, lalu kontak dan obrolan terbaru Anda disinkronkan. Memerlukan versi 2.24.17 atau lebih baru.",
    "whatsapp.connected.business_account": "Akun bisnis WhatsApp",
    "WhatsApp business account": "Akun bisnis WhatsApp",
    "whatsapp.connected.template_ready": "Templat autentikasi siap · OTP otomatis dapat menggunakan WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Templat autentikasi siap · OTP otomatis dapat menggunakan WhatsApp.",
    "whatsapp.connected.template_pending": "Terhubung · SMS tetap menjadi cadangan aman hingga templat autentikasi disetujui.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Terhubung · SMS tetap menjadi cadangan aman hingga templat autentikasi disetujui.",
    "whatsapp.action.connect": "Hubungkan WhatsApp",
    "Connect WhatsApp": "Hubungkan WhatsApp",
    "whatsapp.action.reconnect": "Hubungkan ulang WhatsApp",
    "Reconnect WhatsApp": "Hubungkan ulang WhatsApp",
    "whatsapp.connections.title": "Nomor WhatsApp terhubung",
    "Connected WhatsApp numbers": "Nomor WhatsApp terhubung",
    "whatsapp.connections.description": "Setiap nomor dapat dimiliki merek, akun, atau cabang berbeda. Pilih nomor sebelum mengaktifkan templat.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Setiap nomor dapat dimiliki merek, akun, atau cabang berbeda. Pilih nomor sebelum mengaktifkan templat.",
    "whatsapp.connections.unnamed": "Koneksi WhatsApp",
    "WhatsApp connection": "Koneksi WhatsApp",
    "whatsapp.connections.default": "Default",
    "whatsapp.connections.account": "Akun {id}",
    "Account {id}": "Akun {id}",
    "whatsapp.connections.branch": "Cabang {id}",
    "Branch {id}": "Cabang {id}",
    "whatsapp.connections.tenant_wide": "Koneksi seluruh tenant",
    "Tenant-wide connection": "Koneksi seluruh tenant",
    "whatsapp.action.make_default": "Jadikan default",
    "Make default": "Jadikan default",
    "whatsapp.notice.default_updated": "Koneksi default WhatsApp diperbarui.",
    "Default WhatsApp connection updated.": "Koneksi default WhatsApp diperbarui.",
    "whatsapp.error.default_update": "Gagal mengubah koneksi default.",
    "Unable to change the default connection.": "Gagal mengubah koneksi default.",
    "whatsapp.templates.title": "Templat pesan",
    "Message templates": "Templat pesan",
    "whatsapp.templates.description": "Pilih templat siap pakai. Tradly akan mengirimkannya ke Meta untuk disetujui dan mengaktifkannya otomatis setelah disetujui.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Pilih templat siap pakai. Tradly akan mengirimkannya ke Meta untuk disetujui dan mengaktifkannya otomatis setelah disetujui.",
    "whatsapp.template.status.not_activated": "Belum aktif",
    "Not activated": "Belum aktif",
    "whatsapp.template.status.approved": "Disetujui",
    "whatsapp.template.status.pending": "Menunggu",
    "whatsapp.template.status.submitted": "Diajukan",
    "Submitted": "Diajukan",
    "whatsapp.template.action.active": "Aktif",
    "whatsapp.template.action.submitted": "Diajukan",
    "whatsapp.template.action.activate": "Aktifkan templat",
    "Activate template": "Aktifkan templat",
    "whatsapp.notice.template_active": "{name} disetujui dan aktif.",
    "{name} is approved and active.": "{name} disetujui dan aktif.",
    "whatsapp.notice.template_submitted": "Templat {name} dikirim ke Meta untuk ditinjau. Anda dapat terus menggunakan SMS hingga disetujui.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "Templat {name} dikirim ke Meta untuk ditinjau. Anda dapat terus menggunakan SMS hingga disetujui.",
    "whatsapp.channel.title": "Kanal pengiriman",
    "Delivery channel": "Kanal pengiriman",
    "whatsapp.channel.help": "Sakelar ini mengaktifkan WhatsApp untuk bisnis Anda. Kode masuk dapat dikirim hanya lewat SMS, hanya lewat WhatsApp, atau SMS dengan WhatsApp sebagai cadangan; opsi WhatsApp memerlukan template kode yang disetujui.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "Sakelar ini mengaktifkan WhatsApp untuk bisnis Anda. Kode masuk dapat dikirim hanya lewat SMS, hanya lewat WhatsApp, atau SMS dengan WhatsApp sebagai cadangan; opsi WhatsApp memerlukan template kode yang disetujui.",
    "whatsapp.channel.primary_otp": "Kanal OTP utama",
    "Primary OTP channel": "Kanal OTP utama",
    "whatsapp.channel.sms_description": "Pertahankan jalur pengiriman SMS yang ada.",
    "Keep the existing SMS delivery path.": "Pertahankan jalur pengiriman SMS yang ada.",
    "whatsapp.channel.whatsapp_description": "Gunakan Meta Cloud API untuk tenant ini.",
    "Use Meta Cloud API for this tenant.": "Gunakan Meta Cloud API untuk tenant ini.",
    "whatsapp.channel.automatic": "Otomatis",
    "Automatic": "Otomatis",
    "whatsapp.channel.automatic_description": "Gunakan WhatsApp jika dikonfigurasi, jika tidak gunakan SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Gunakan WhatsApp jika dikonfigurasi, jika tidak gunakan SMS.",
    "whatsapp.channel.fallback": "Cadangan jika WhatsApp gagal",
    "Fallback after WhatsApp failure": "Cadangan jika WhatsApp gagal",
    "whatsapp.channel.no_fallback": "Tanpa cadangan",
    "No fallback": "Tanpa cadangan",
    "whatsapp.channel.no_fallback_description": "Kembalikan hasil pengiriman yang dikonfigurasi.",
    "Return the configured delivery result.": "Kembalikan hasil pengiriman yang dikonfigurasi.",
    "whatsapp.channel.sms_fallback_description": "Coba kirim lewat SMS dengan kode OTP yang sama.",
    "Try SMS with the same OTP code.": "Coba kirim lewat SMS dengan kode OTP yang sama.",
    "whatsapp.channel.sms_only": "Hanya SMS",
    "SMS only": "Hanya SMS",
    "whatsapp.channel.sms_only_description": "Kode dikirim lewat SMS.",
    "Codes are sent by text message.": "Kode dikirim lewat SMS.",
    "whatsapp.channel.whatsapp_only": "Hanya WhatsApp",
    "WhatsApp only": "Hanya WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "Kode dikirim dari nomor WhatsApp Anda.",
    "Codes are sent from your WhatsApp number.": "Kode dikirim dari nomor WhatsApp Anda.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp sebagai cadangan",
    "SMS, WhatsApp as backup": "SMS, WhatsApp sebagai cadangan",
    "whatsapp.channel.sms_whatsapp_description": "Kode dikirim lewat SMS; jika SMS gagal, kode yang sama dikirim lewat WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Kode dikirim lewat SMS; jika SMS gagal, kode yang sama dikirim lewat WhatsApp.",
    "whatsapp.advanced.title": "Pengaturan pemulihan teknis",
    "Technical recovery settings": "Pengaturan pemulihan teknis",
    "whatsapp.advanced.description": "Khusus dukungan platform. Sebagian besar bisnis sebaiknya menggunakan Hubungkan WhatsApp di atas.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Khusus dukungan platform. Sebagian besar bisnis sebaiknya menggunakan Hubungkan WhatsApp di atas.",
    "whatsapp.field.phone_number_id": "ID nomor telepon WhatsApp",
    "WhatsApp phone number ID": "ID nomor telepon WhatsApp",
    "whatsapp.field.phone_number_id_help": "ID nomor telepon yang terhubung ke akun WhatsApp Business Anda.",
    "The phone number ID attached to your WhatsApp Business account.": "ID nomor telepon yang terhubung ke akun WhatsApp Business Anda.",
    "whatsapp.field.waba_id": "ID Akun WhatsApp Business",
    "WhatsApp Business Account ID": "ID Akun WhatsApp Business",
    "whatsapp.field.waba_id_help": "Ditampilkan di samping ID nomor di Meta (WhatsApp > API Setup). Diperlukan untuk templat dan pesan uji.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Ditampilkan di samping ID nomor di Meta (WhatsApp > API Setup). Diperlukan untuk templat dan pesan uji.",
    "whatsapp.placeholder.phone_number_id": "mis. 123456789012345",
    "e.g. 123456789012345": "mis. 123456789012345",
    "whatsapp.field.access_token": "Token akses Meta",
    "Meta access token": "Token akses Meta",
    "whatsapp.field.access_token_saved_help": "Disimpan dengan aman di server. Kosongkan agar tidak berubah, atau tempel token baru untuk menggantinya.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Disimpan dengan aman di server. Kosongkan agar tidak berubah, atau tempel token baru untuk menggantinya.",
    "whatsapp.field.access_token_help": "Gunakan token pengguna sistem dengan izin pengiriman pesan WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Gunakan token pengguna sistem dengan izin pengiriman pesan WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Disimpan dengan aman · kosongkan",
    "Saved securely · leave blank to keep": "Disimpan dengan aman · kosongkan",
    "whatsapp.placeholder.access_token": "Tempel token",
    "Paste token": "Tempel token",
    "whatsapp.token.saved": "Token akses Meta disimpan dengan aman",
    "Meta access token saved securely": "Token akses Meta disimpan dengan aman",
    "whatsapp.field.otp_template": "Nama templat OTP yang disetujui",
    "Approved OTP template name": "Nama templat OTP yang disetujui",
    "whatsapp.field.otp_template_help": "Isi templat harus menerima OTP sebagai satu parameter teks.",
    "The template body must accept the OTP as one text parameter.": "Isi templat harus menerima OTP sebagai satu parameter teks.",
    "whatsapp.placeholder.otp_template": "mis. login_verification",
    "e.g. login_verification": "mis. login_verification",
    "whatsapp.field.template_language": "Bahasa templat",
    "Template language": "Bahasa templat",
    "whatsapp.field.marketing_template": "Nama templat pemasaran yang disetujui (opsional)",
    "Approved marketing template name (optional)": "Nama templat pemasaran yang disetujui (opsional)",
    "whatsapp.field.marketing_template_help": "Gunakan templat pemasaran Meta yang disetujui. Kampanye dapat mengganti nama ini di content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Gunakan templat pemasaran Meta yang disetujui. Kampanye dapat mengganti nama ini di content.template_name.",
    "whatsapp.placeholder.marketing_template": "mis. monthly_offer",
    "e.g. monthly_offer": "mis. monthly_offer",
    "whatsapp.field.marketing_language": "Bahasa templat pemasaran",
    "Marketing template language": "Bahasa templat pemasaran",
    "whatsapp.info.title": "Sebelum mengaktifkan WhatsApp",
    "Before enabling WhatsApp": "Sebelum mengaktifkan WhatsApp",
    "whatsapp.info.description": "Meta harus menyetujui setiap templat OTP atau pemasaran sebelum dikirim. Konten WhatsApp kampanye menggunakan template_name, template_language, dan parameter isi opsional; nomor penerima harus berformat E.164. Jika fallback otomatis aktif, ArcticOwl mencoba ulang SMS dengan OTP asli, bukan membuat kode kedua.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta harus menyetujui setiap templat OTP atau pemasaran sebelum dikirim. Konten WhatsApp kampanye menggunakan template_name, template_language, dan parameter isi opsional; nomor penerima harus berformat E.164. Jika fallback otomatis aktif, ArcticOwl mencoba ulang SMS dengan OTP asli, bukan membuat kode kedua.",
    "whatsapp.action.hide_token": "Sembunyikan token akses Meta",
    "Hide Meta access token": "Sembunyikan token akses Meta",
    "whatsapp.action.show_token": "Tampilkan token akses Meta",
    "Show Meta access token": "Tampilkan token akses Meta",
    "whatsapp.error.generic": "Pengaturan WhatsApp tidak dapat disimpan.",
    "Unable to save WhatsApp settings.": "Pengaturan WhatsApp tidak dapat disimpan.",
    "whatsapp.error.browser_required": "Koneksi WhatsApp hanya tersedia di browser.",
    "WhatsApp connection is only available in a browser.": "Koneksi WhatsApp hanya tersedia di browser.",
    "whatsapp.error.meta_load": "Meta tidak dapat dimuat. Periksa pengaturan privasi browser lalu coba lagi.",
    "Meta could not load. Check the browser privacy settings and try again.": "Meta tidak dapat dimuat. Periksa pengaturan privasi browser lalu coba lagi.",
    "whatsapp.error.load": "Pengaturan WhatsApp tidak dapat dimuat.",
    "Unable to load WhatsApp settings.": "Pengaturan WhatsApp tidak dapat dimuat.",
    "whatsapp.error.connect_before_template": "Hubungkan WhatsApp sebelum mengaktifkan templat.",
    "Connect WhatsApp before activating a template.": "Hubungkan WhatsApp sebelum mengaktifkan templat.",
    "whatsapp.error.template_submit": "Templat WhatsApp tidak dapat dikirim.",
    "Unable to submit the WhatsApp template.": "Templat WhatsApp tidak dapat dikirim.",
    "whatsapp.error.business_number_required": "Masukkan nomor WhatsApp bisnis sebelum menghubungkan. Meta akan memverifikasinya di langkah berikutnya.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Masukkan nomor WhatsApp bisnis sebelum menghubungkan. Meta akan memverifikasinya di langkah berikutnya.",
    "whatsapp.error.signup_not_ready": "Koneksi WhatsApp masih disiapkan oleh platform. Silakan coba lagi sebentar lagi.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "Koneksi WhatsApp masih disiapkan oleh platform. Silakan coba lagi sebentar lagi.",
    "whatsapp.error.signup_cancelled": "Koneksi Meta dibatalkan atau tidak mengembalikan kode otorisasi.",
    "Meta connection was cancelled or did not return an authorization code.": "Koneksi Meta dibatalkan atau tidak mengembalikan kode otorisasi.",
    "whatsapp.error.phone_number_missing": "Meta tidak mengembalikan nomor WhatsApp bisnis yang dipilih. Silakan hubungkan lagi.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta tidak mengembalikan nomor WhatsApp bisnis yang dipilih. Silakan hubungkan lagi.",
    "whatsapp.notice.connected_auto": "WhatsApp terhubung. Pengiriman OTP otomatis mencoba WhatsApp terlebih dahulu, lalu SMS jika gagal.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp terhubung. Pengiriman OTP otomatis mencoba WhatsApp terlebih dahulu, lalu SMS jika gagal.",
    "whatsapp.notice.connected_sms": "WhatsApp terhubung. SMS tetap aktif hingga Meta menyetujui templat autentikasi.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp terhubung. SMS tetap aktif hingga Meta menyetujui templat autentikasi.",
    "whatsapp.error.connect": "WhatsApp tidak dapat dihubungkan.",
    "Unable to connect WhatsApp.": "WhatsApp tidak dapat dihubungkan.",
    "whatsapp.error.otp_configuration": "OTP WhatsApp atau Otomatis memerlukan ID nomor telepon, nama templat OTP yang disetujui, dan token akses Meta. Untuk WhatsApp khusus pemasaran, pilih SMS sebagai kanal OTP utama dan biarkan konektor aktif.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "OTP WhatsApp atau Otomatis memerlukan ID nomor telepon, nama templat OTP yang disetujui, dan token akses Meta. Untuk WhatsApp khusus pemasaran, pilih SMS sebagai kanal OTP utama dan biarkan konektor aktif.",
    "whatsapp.notice.saved": "Pengaturan konektor WhatsApp untuk tenant ini disimpan.",
    "WhatsApp connector settings saved for this tenant.": "Pengaturan konektor WhatsApp untuk tenant ini disimpan.",
    "whatsapp.error.save": "Pengaturan WhatsApp tidak dapat disimpan.",
    "whatsapp.notice.discarded": "Draf dibuang.",
    "Draft discarded.": "Draf dibuang.",
    "whatsapp.test.title": "Kirim pesan uji",
    "Send a test message": "Kirim pesan uji",
    "whatsapp.test.description": "Kirim templat yang disetujui ke nomor WhatsApp mana pun untuk memastikan koneksi Anda berfungsi.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Kirim templat yang disetujui ke nomor WhatsApp mana pun untuk memastikan koneksi Anda berfungsi.",
    "whatsapp.test.refresh": "Muat ulang templat",
    "Refresh templates": "Muat ulang templat",
    "whatsapp.test.field.template": "Templat disetujui",
    "Approved template": "Templat disetujui",
    "whatsapp.test.field.parameter": "Nilai untuk {{{number}}}",
    "Value for {{{number}}}": "Nilai untuk {{{number}}}",
    "whatsapp.test.field.mobile": "Kirim ke",
    "Send to": "Kirim ke",
    "whatsapp.test.field.mobile_help": "Nomor WhatsApp dengan kode negara.",
    "WhatsApp number with country code.": "Nomor WhatsApp dengan kode negara.",
    "whatsapp.test.action.send": "Kirim pesan uji",
    "Send test message": "Kirim pesan uji",
    "whatsapp.test.sent": "Terkirim ke {mobile}. ID pesan Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Terkirim ke {mobile}. ID pesan Meta: {id}",
    "whatsapp.test.no_templates": "Belum ada templat yang disetujui. Aktifkan templat di atas dan kirim setelah Meta menyetujuinya.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Belum ada templat yang disetujui. Aktifkan templat di atas dan kirim setelah Meta menyetujuinya.",
    "common.discard_draft": "Buang draf",
    "common.status.connected": "Terhubung",
    "Connected": "Terhubung",
    "extensions.title": "Ekstensi",
    "extensions.action.add": "Tambah ekstensi",
    "Add Extension": "Tambah ekstensi",
    "extensions.action.add_new": "Tambah ekstensi baru",
    "Add New Extension": "Tambah ekstensi baru",
    "extensions.action.edit": "Edit ekstensi",
    "Edit Extension": "Edit ekstensi",
    "extensions.action.delete": "Hapus ekstensi",
    "Delete extension": "Hapus ekstensi",
    "extensions.field.name": "Nama",
    "extensions.field.domain": "Domain",
    "extensions.field.configs": "Konfigurasi",
    "Configs": "Konfigurasi",
    "extensions.placeholder.name": "Nama ekstensi",
    "Extension Name": "Nama ekstensi",
    "extensions.placeholder.domain": "Domain ekstensi",
    "Extension Domain": "Domain ekstensi",
    "extensions.empty": "Belum ada ekstensi yang dikonfigurasi.",
    "No extensions configured yet.": "Belum ada ekstensi yang dikonfigurasi.",
    "extensions.toast.added": "Ekstensi berhasil ditambahkan.",
    "Extension added successfully.": "Ekstensi berhasil ditambahkan.",
    "extensions.toast.updated": "Ekstensi berhasil diperbarui.",
    "Extension updated successfully.": "Ekstensi berhasil diperbarui.",
    "extensions.toast.deleted": "Ekstensi berhasil dihapus.",
    "Extension deleted successfully.": "Ekstensi berhasil dihapus.",
    "extensions.error.name_required": "Nama wajib diisi",
    "extensions.error.domain_required": "Domain wajib diisi",
    "Domain is required": "Domain wajib diisi",
    "extensions.error.configs_required": "Konfigurasi wajib diisi",
    "Configs is required": "Konfigurasi wajib diisi",
    "extensions.error.save_failed": "Ekstensi tidak dapat disimpan.",
    "Unable to save the extension.": "Ekstensi tidak dapat disimpan.",
    "extensions.error.delete_failed": "Ekstensi tidak dapat dihapus.",
    "Unable to delete the extension.": "Ekstensi tidak dapat dihapus.",
    "automation_rules.kicker": "Otomatisasi operasi",
    "Operations automation": "Otomatisasi operasi",
    "automation_rules.title": "Aturan otomatisasi",
    "Automation rules": "Aturan otomatisasi",
    "automation_rules.description": "Ubah peristiwa staf dan pengeluaran menjadi langkah persetujuan dan peninjauan yang jelas.",
    "Turn staff and expense events into clear approval and review steps.": "Ubah peristiwa staf dan pengeluaran menjadi langkah persetujuan dan peninjauan yang jelas.",
    "automation_rules.action.new_rule": "Aturan baru",
    "New rule": "Aturan baru",
    "automation_rules.action.create_rule": "Buat aturan",
    "Create rule": "Buat aturan",
    "automation_rules.action.create_help": "Simpan pemicu, kondisi, dan tindakan ini sebagai aturan",
    "Save this trigger, conditions, and action as a rule": "Simpan pemicu, kondisi, dan tindakan ini sebagai aturan",
    "automation_rules.action.add_condition": "Tambah kondisi",
    "Add condition": "Tambah kondisi",
    "automation_rules.action.add_condition_help": "Tambahkan kondisi lain ke aturan ini",
    "Add another condition to this rule": "Tambahkan kondisi lain ke aturan ini",
    "automation_rules.action.remove_condition": "Hapus kondisi",
    "Remove condition": "Hapus kondisi",
    "automation_rules.action.choose": "Pilih tindakan",
    "Choose an action": "Pilih tindakan",
    "automation_rules.action.require_second_approver": "Minta pemberi persetujuan kedua",
    "Require second approver": "Minta pemberi persetujuan kedua",
    "automation_rules.action.require_second_approver_help": "Teruskan klaim ke pemberi persetujuan lain.",
    "Route the claim to another approver.": "Teruskan klaim ke pemberi persetujuan lain.",
    "automation_rules.action.auto_reject_expense": "Tolak pengeluaran otomatis",
    "Auto-reject expense": "Tolak pengeluaran otomatis",
    "automation_rules.action.auto_reject_expense_help": "Tolak pengeluaran dengan alasan.",
    "Reject the expense with a reason.": "Tolak pengeluaran dengan alasan.",
    "automation_rules.action.notify_role": "Beri tahu peran",
    "Notify a role": "Beri tahu peran",
    "automation_rules.action.notify_role_help": "Kirim notifikasi ke staf dengan peran tertentu.",
    "Send a notification to a staff role.": "Kirim notifikasi ke staf dengan peran tertentu.",
    "automation_rules.action.flag_for_review": "Tandai untuk ditinjau",
    "Flag for review": "Tandai untuk ditinjau",
    "automation_rules.action.flag_for_review_help": "Tandai sumber daya untuk ditinjau manual.",
    "Mark a resource for manual review.": "Tandai sumber daya untuk ditinjau manual.",
    "automation_rules.field.rule_name": "Nama aturan",
    "Rule name": "Nama aturan",
    "automation_rules.field.priority": "Prioritas",
    "automation_rules.field.module": "Modul",
    "Module": "Modul",
    "automation_rules.field.event": "Peristiwa",
    "automation_rules.field.field": "Kolom",
    "Field": "Kolom",
    "automation_rules.field.operator": "Operator",
    "Operator": "Operator",
    "automation_rules.field.value": "Nilai",
    "automation_rules.field.action": "Tindakan",
    "automation_rules.field.action_params": "Parameter tindakan",
    "Action parameters": "Parameter tindakan",
    "automation_rules.placeholder.rule_name": "Minta persetujuan kedua untuk klaim besar",
    "Require second approver for large claims": "Minta persetujuan kedua untuk klaim besar",
    "automation_rules.placeholder.field": "jumlah",
    "amount": "jumlah",
    "automation_rules.placeholder.value": "500 atau false",
    "500 or false": "500 atau false",
    "automation_rules.builder.description": "Buat pemicu, kondisi, dan tindakan di bawah, lalu simpan sebagai satu aturan.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Buat pemicu, kondisi, dan tindakan di bawah, lalu simpan sebagai satu aturan.",
    "automation_rules.error.load": "Aturan otomatisasi tidak dapat dimuat.",
    "Unable to load automation rules.": "Aturan otomatisasi tidak dapat dimuat.",
    "automation_rules.error.required_fields": "Nama, modul, peristiwa, dan tindakan wajib diisi.",
    "Name, module, event, and action are required.": "Nama, modul, peristiwa, dan tindakan wajib diisi.",
    "automation_rules.error.create": "Aturan otomatisasi tidak dapat dibuat.",
    "Unable to create automation rule.": "Aturan otomatisasi tidak dapat dibuat.",
    "automation_rules.error.valid_json": "Gunakan JSON valid sebelum menyimpan.",
    "Use valid JSON before saving.": "Gunakan JSON valid sebelum menyimpan.",
    "automation_rules.notice.created": "Aturan otomatisasi dibuat.",
    "Automation rule created.": "Aturan otomatisasi dibuat.",
    "automation_rules.notice.discarded": "Draf dibuang.",
    "automation_rules.draft.restored": "Draf aturan otomatisasi yang belum disimpan dipulihkan.",
    "Your unsaved automation rule draft was restored.": "Draf aturan otomatisasi yang belum disimpan dipulihkan.",
    "automation_rules.list.title": "Aturan",
    "automation_rules.list.count": "{count} dikonfigurasi",
    "{count} configured": "{count} dikonfigurasi",
    "automation_rules.list.loading": "Memuat aturan…",
    "Loading rules…": "Memuat aturan…",
    "automation_rules.list.unnamed": "Aturan tanpa nama",
    "Unnamed rule": "Aturan tanpa nama",
    "automation_rules.list.no_action": "Tidak ada tindakan",
    "No action configured": "Tidak ada tindakan",
    "automation_rules.list.empty": "Belum ada aturan. Buat aturan pertama dari diagram.",
    "No rules yet. Create the first one from the diagram.": "Belum ada aturan. Buat aturan pertama dari diagram.",
    "automation_rules.status.draft": "Draf",
    "automation_rules.status.active": "Aktif",
    "automation_rules.inspector.title": "Pengaturan blok",
    "Block settings": "Pengaturan blok",
    "automation_rules.inspector.diagram": "Diagram",
    "Diagram": "Diagram",
    "automation_rules.inspector.select_block": "Pilih blok pada diagram untuk mengonfigurasinya.",
    "Select a block on the diagram to configure it.": "Pilih blok pada diagram untuk mengonfigurasinya.",
    "automation_rules.inspector.no_configuration": "Blok ini tidak memerlukan konfigurasi.",
    "This block does not need configuration.": "Blok ini tidak memerlukan konfigurasi.",
    "automation_rules.node.trigger": "Pemicu",
    "automation_rules.node.condition": "Kondisi",
    "automation_rules.node.action": "Tindakan",
    "automation_rules.node.end": "Akhir",
    "automation_rules.node.completed": "Selesai",
    "automation_rules.node.finished": "Evaluasi aturan selesai",
    "Rule evaluation finished": "Evaluasi aturan selesai",
    "automation_rules.trigger.choose_event": "Pilih peristiwa",
    "Choose an event": "Pilih peristiwa",
    "automation_rules.trigger.module": "modul",
    "module": "modul",
    "automation_rules.trigger.module_event": "Peristiwa modul {module}",
    "{module} event": "Peristiwa modul {module}",
    "automation_rules.trigger.help": "Aturan dievaluasi saat peristiwa ini dipicu oleh modul.",
    "The rule evaluates when this event is emitted by the module.": "Aturan dievaluasi saat peristiwa ini dipicu oleh modul.",
    "automation_rules.condition.label": "Kondisi",
    "automation_rules.condition.none": "Tanpa kondisi",
    "No conditions": "Tanpa kondisi",
    "automation_rules.condition.always_fires": "Selalu berjalan",
    "Always fires": "Selalu berjalan",
    "automation_rules.condition.empty_help": "Tambahkan kondisi untuk membatasi aturan ini.",
    "Add a condition to restrict this rule.": "Tambahkan kondisi untuk membatasi aturan ini.",
    "automation_rules.condition.value_required": "Nilai wajib diisi",
    "Value required": "Nilai wajib diisi",
    "automation_rules.condition.value": "Nilai: {value}",
    "Value: {value}": "Nilai: {value}",
    "automation_rules.operator.equals": "Sama dengan",
    "Equals": "Sama dengan",
    "automation_rules.operator.gt": "Lebih besar dari",
    "Greater than": "Lebih besar dari",
    "automation_rules.operator.gte": "Lebih besar dari atau sama dengan",
    "Greater than or equal": "Lebih besar dari atau sama dengan",
    "automation_rules.operator.lt": "Lebih kecil dari",
    "Less than": "Lebih kecil dari",
    "automation_rules.operator.exists": "Ada",
    "Exists": "Ada",
    "automation_rules.module.expenses": "Pengeluaran",
    "automation_rules.module.staff": "Staf",
    "automation_rules.event.expense.submitted": "Pengeluaran dikirim",
    "automation_rules.event.leave.requested": "Cuti diminta",
    "Leave requested": "Cuti diminta",
    "automation_rules.event.payroll_run.created": "Proses penggajian dibuat",
    "automation_rules.meta.conditions": "{count} kondisi · semua harus cocok sebelum tindakan dijalankan",
    "{count} condition(s) · all must match before the action runs": "{count} kondisi · semua harus cocok sebelum tindakan dijalankan",
    "automation_rules.meta.no_conditions": "Tanpa kondisi · tindakan selalu berjalan setelah pemicu",
    "No conditions · the action always runs after the trigger": "Tanpa kondisi · tindakan selalu berjalan setelah pemicu",
    "automation_rules.draft.unsaved": "Ada draf aturan otomatisasi yang belum disimpan.",
    "You have an unsaved automation rule draft.": "Ada draf aturan otomatisasi yang belum disimpan.",
    "automation_rules.meta.one_condition": "1 kondisi · kondisi harus cocok sebelum tindakan dijalankan",
    "1 condition · all must match before the action runs": "1 kondisi · kondisi harus cocok sebelum tindakan dijalankan",
    "automation_rules.meta.many_conditions": "{count} kondisi · semua harus cocok sebelum tindakan dijalankan",
    "{count} conditions · all must match before the action runs": "{count} kondisi · semua harus cocok sebelum tindakan dijalankan",
    "cms.type.page": "Halaman",
    "Page": "Halaman",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Dokumentasi",
    "Docs": "Dokumentasi",
    "cms.type.pages": "Halaman",
    "cms.type.blogs": "Blog",
    "Blogs": "Blog",
    "cms.action.add_content": "Tambah konten",
    "Add content": "Tambah konten",
    "cms.action.add_type": "Tambah {type}",
    "cms.action.create_type": "Buat {type}",
    "Create {type}": "Buat {type}",
    "cms.action.edit": "Edit",
    "cms.action.duplicate": "Duplikat",
    "Duplicate": "Duplikat",
    "cms.action.open": "Buka",
    "cms.field.title": "Judul",
    "cms.field.slug": "Slug",
    "cms.field.content": "Konten",
    "cms.field.meta_title": "Judul meta",
    "cms.field.meta_description": "Deskripsi meta",
    "cms.placeholder.title": "mis. Tentang Kami",
    "e.g. About us": "mis. Tentang Kami",
    "cms.placeholder.slug": "tentang-kami",
    "about-us": "tentang-kami",
    "cms.placeholder.page_title": "Judul halaman",
    "Page title": "Judul halaman",
    "cms.placeholder.page_slug": "slug-halaman",
    "page-slug": "slug-halaman",
    "cms.placeholder.content": "Tulis konten di sini…",
    "Write your content here…": "Tulis konten di sini…",
    "cms.placeholder.meta_title": "Default mengikuti judul",
    "Defaults to title": "Default mengikuti judul",
    "cms.placeholder.meta_description": "Deskripsi singkat untuk mesin pencari",
    "Short description for search engines": "Deskripsi singkat untuk mesin pencari",
    "cms.section.seo_optional": "SEO (opsional)",
    "SEO (optional)": "SEO (opsional)",
    "cms.error.title_required": "Judul wajib diisi.",
    "Title is required.": "Judul wajib diisi.",
    "cms.error.content_required": "Tambahkan konten sebelum menyimpan.",
    "Add some content before saving.": "Tambahkan konten sebelum menyimpan.",
    "cms.error.create": "Gagal membuat. Silakan coba lagi.",
    "Failed to create. Please try again.": "Gagal membuat. Silakan coba lagi.",
    "cms.error.save": "Gagal menyimpan.",
    "Failed to save.": "Gagal menyimpan.",
    "cms.error.load_layer": "Layer ini tidak dapat dimuat.",
    "Could not load this layer.": "Layer ini tidak dapat dimuat.",
    "cms.toast.created": "{type} berhasil dibuat.",
    "{type} created successfully.": "{type} berhasil dibuat.",
    "cms.toast.saved": "Disimpan",
    "Saved": "Disimpan",
    "cms.toast.changes_saved": "Perubahan disimpan.",
    "Changes saved.": "Perubahan disimpan.",
    "cms.toast.deleted": "Dihapus",
    "cms.toast.duplicated": "Diduplikasi",
    "Duplicated": "Diduplikasi",
    "cms.error.delete": "Gagal menghapus",
    "Failed to delete": "Gagal menghapus",
    "cms.error.duplicate": "Gagal menduplikasi",
    "Failed to duplicate": "Gagal menduplikasi",
    "cms.confirm.delete": "Hapus “{title}”?",
    "Delete \"{title}\"?": "Hapus “{title}”?",
    "cms.duplicate.title": "{title} (salinan)",
    "{title} (copy)": "{title} (salinan)",
    "cms.draft.restored": "Draf konten yang belum disimpan dipulihkan.",
    "Your unsaved content draft was restored.": "Draf konten yang belum disimpan dipulihkan.",
    "cms.search": "Cari…",
    "Search…": "Cari…",
    "cms.list.no_results": "Tidak ada hasil.",
    "No results found.": "Tidak ada hasil.",
    "cms.list.empty_type": "Belum ada {type}.",
    "No {type} yet.": "Belum ada {type}.",
    "cms.list.untitled": "Tanpa judul",
    "Untitled": "Tanpa judul",
    "cms.editor.placeholder": "Tulis konten di sini…",
    "cms.editor.normal_text": "Teks biasa",
    "Normal text": "Teks biasa",
    "cms.editor.heading": "Judul {level}",
    "Heading {level}": "Judul {level}",
    "cms.editor.align_left": "Rata kiri",
    "Align Left": "Rata kiri",
    "cms.editor.align_center": "Rata tengah",
    "Align Center": "Rata tengah",
    "cms.editor.align_right": "Rata kanan",
    "Align Right": "Rata kanan",
    "cms.editor.insert_table": "Sisipkan tabel",
    "Insert table": "Sisipkan tabel",
    "cms.editor.add_column": "Tambah kolom",
    "Add column": "Tambah kolom",
    "cms.editor.add_row": "Tambah baris",
    "Add row": "Tambah baris",
    "cms.editor.delete_table": "Hapus tabel",
    "Delete table": "Hapus tabel",
    "cms.editor.delete_column": "Hapus kolom",
    "Delete column": "Hapus kolom",
    "cms.editor.delete_row": "Hapus baris",
    "Delete row": "Hapus baris",
    "cms.editor.underline": "Garis bawah",
    "Underline": "Garis bawah",
    "cms.editor.strikethrough": "Coret",
    "Strikethrough": "Coret",
    "cms.editor.code": "Kode",
    "cms.editor.code_block": "Blok kode",
    "Code block": "Blok kode",
    "cms.editor.subscript": "Subskrip",
    "Subscript": "Subskrip",
    "cms.editor.superscript": "Superskrip",
    "Superscript": "Superskrip",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL gambar",
    "Image URL": "URL gambar",
    "cms.editor.prompt.youtube_url": "URL YouTube",
    "YouTube URL": "URL YouTube",
    "cms.editor.undo": "Urungkan",
    "cms.editor.redo": "Ulangi",
    "cms.editor.table": "Tabel",
    "Table": "Tabel",
    "cms.editor.more": "Lainnya",
    "cms.editor.bold": "Tebal",
    "Bold": "Tebal",
    "cms.editor.italic": "Miring",
    "Italic": "Miring",
    "cms.editor.bullet_list": "Daftar berpoin",
    "Bullet list": "Daftar berpoin",
    "cms.editor.ordered_list": "Daftar bernomor",
    "Ordered list": "Daftar bernomor",
    "cms.editor.task_list": "Daftar tugas",
    "Task list": "Daftar tugas",
    "cms.editor.link": "Tautan",
    "Link": "Tautan",
    "cms.editor.image": "Gambar",
    "cms.editor.text_color": "Warna teks",
    "Text color": "Warna teks",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Halaman",
    "cms.test.type.pages_description": "Halaman landing dan konten etalase terstruktur.",
    "Landing pages and structured storefront content.": "Halaman landing dan konten etalase terstruktur.",
    "cms.test.type.blogs": "Blog",
    "cms.test.type.blogs_description": "Artikel, cerita, dan kabar terbaru untuk audiens Anda.",
    "Articles, stories, and updates for your audience.": "Artikel, cerita, dan kabar terbaru untuk audiens Anda.",
    "cms.test.type.docs": "Dokumentasi",
    "cms.test.type.docs_description": "Dokumentasi, panduan, dan konten bantuan.",
    "Documentation, guides, and help content.": "Dokumentasi, panduan, dan konten bantuan.",
    "cms.test.operation.list": "Daftar konten berdasarkan jenis",
    "List content by type": "Daftar konten berdasarkan jenis",
    "cms.test.operation.fetch": "Ambil satu Layer",
    "Fetch one Layer": "Ambil satu Layer",
    "cms.test.operation.create": "Buat Layer",
    "Create a Layer": "Buat Layer",
    "cms.test.operation.update": "Perbarui Layer",
    "Update a Layer": "Perbarui Layer",
    "cms.test.operation.delete": "Hapus Layer",
    "Delete a Layer": "Hapus Layer",
    "cms.test.operation.search": "Cari konten",
    "Search content": "Cari konten",
    "cms.test.operation.categories": "Muat kategori",
    "Load categories": "Muat kategori",
    "cms.test.operation.translations": "Simpan terjemahan",
    "Save translations": "Simpan terjemahan",
    "cms.test.editor.placeholder": "Tulis konten halaman…",
    "Write your page content...": "Tulis konten halaman…",
    "cms.test.error.load_type": "Konten {type} tidak dapat dimuat",
    "Unable to load {type} content": "Konten {type} tidak dapat dimuat",
    "cms.test.error.load": "Konten CMS tidak dapat dimuat.",
    "Unable to load CMS content.": "Konten CMS tidak dapat dimuat.",
    "cms.test.error.required": "Tambahkan judul dan konten halaman sebelum menyimpan.",
    "Add a page title and content before saving.": "Tambahkan judul dan konten halaman sebelum menyimpan.",
    "cms.test.error.create": "Halaman ini tidak dapat dibuat.",
    "Unable to create this page.": "Halaman ini tidak dapat dibuat.",
    "cms.test.toast.created": "Halaman berhasil dibuat.",
    "Page created successfully.": "Halaman berhasil dibuat.",
    "cms.test.hero.eyebrow": "MANAJEMEN KONTEN",
    "CONTENT MANAGEMENT": "MANAJEMEN KONTEN",
    "cms.test.hero.title": "CMS Layers",
    "Layers CMS": "CMS Layers",
    "cms.test.hero.description": "Buat konten terstruktur sekali, lalu tampilkan di etalase, aplikasi, dan pengalaman khusus.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Buat konten terstruktur sekali, lalu tampilkan di etalase, aplikasi, dan pengalaman khusus.",
    "cms.test.hero.live_workspace": "Workspace aktif: {tenant} · pratinjau hanya baca",
    "Live workspace: {tenant} · read-only preview": "Workspace aktif: {tenant} · pratinjau hanya baca",
    "cms.test.current_tenant": "tenant saat ini",
    "current tenant": "tenant saat ini",
    "cms.test.content.title": "Konten Anda",
    "Your content": "Konten Anda",
    "cms.test.content.description": "Kelola halaman, blog, dan dokumentasi dari satu tempat.",
    "Pages, blogs, and docs are ready to manage from one place.": "Kelola halaman, blog, dan dokumentasi dari satu tempat.",
    "cms.test.action.create_page": "Buat halaman",
    "Create Page": "Buat halaman",
    "cms.test.form.description": "Buat konten halaman terstruktur di Layers. Halaman tersedia melalui API setelah disimpan.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Buat konten halaman terstruktur di Layers. Halaman tersedia melalui API setelah disimpan.",
    "cms.test.placeholder.slug": "tentang-kami (opsional)",
    "about-us (optional)": "tentang-kami (opsional)",
    "cms.test.draft.unsaved": "Ada draf halaman yang belum disimpan.",
    "You have an unsaved page draft.": "Ada draf halaman yang belum disimpan.",
    "cms.test.loading": "Memuat konten Layers…",
    "Loading live Layers content…": "Memuat konten Layers…",
    "cms.test.content.empty_title": "Belum ada {type}",
    "No {type} yet": "Belum ada {type}",
    "cms.test.content.empty_description": "Buat Layer pertama di workspace agar muncul di sini.",
    "Create your first Layer in the workspace to see it here.": "Buat Layer pertama di workspace agar muncul di sini.",
    "cms.test.feature.types": "Jenis konten khusus",
    "Custom content types": "Jenis konten khusus",
    "cms.test.feature.types_description": "Halaman, blog, dan dokumen adalah awal. Tentukan Post atau model lain yang dibutuhkan bisnis.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Halaman, blog, dan dokumen adalah awal. Tentukan Post atau model lain yang dibutuhkan bisnis.",
    "cms.test.feature.structured": "Terstruktur dan terlokalisasi",
    "Structured and localized": "Terstruktur dan terlokalisasi",
    "cms.test.feature.structured_description": "Gunakan slug, kategori, gambar, metadata SEO, dan terjemahan dari sumber konten yang sama.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Gunakan slug, kategori, gambar, metadata SEO, dan terjemahan dari sumber konten yang sama.",
    "cms.test.feature.headless": "Headless secara default",
    "Headless by default": "Headless secara default",
    "cms.test.feature.headless_description": "Gunakan Layers API di situs, aplikasi seluler, alat internal, atau frontend khusus.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Gunakan Layers API di situs, aplikasi seluler, alat internal, atau frontend khusus.",
    "cms.test.feature.ai": "Sumber pengetahuan AI",
    "AI knowledge source": "Sumber pengetahuan AI",
    "cms.test.feature.ai_description": "Kirim konten Tradly CMS ke iRyxo Agent Builder sebagai sumber pengetahuan.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Kirim konten Tradly CMS ke iRyxo Agent Builder sebagai sumber pengetahuan.",
    "cms.test.community.eyebrow": "KONTEN KOMUNITAS",
    "COMMUNITY CONTENT": "KONTEN KOMUNITAS",
    "cms.test.community.title": "Ubah Layers menjadi feed sosial",
    "Turn Layers into a social feed": "Ubah Layers menjadi feed sosial",
    "cms.test.community.description": "Buat jenis Post khusus, biarkan pengguna menerbitkan pembaruan, dan tambahkan interaksi melalui frontend Anda.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Buat jenis Post khusus, biarkan pengguna menerbitkan pembaruan, dan tambahkan interaksi melalui frontend Anda.",
    "cms.test.community.share_placeholder": "Bagikan kabar…",
    "Share an update…": "Bagikan kabar…",
    "cms.test.community.post": "Posting",
    "Post": "Posting",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Pembaruan komunitas yang diterbitkan dari Layer khusus.",
    "A community update published from a custom Layer.": "Pembaruan komunitas yang diterbitkan dari Layer khusus.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 komentar   ·   ↗ Bagikan",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 komentar   ·   ↗ Bagikan",
    "cms.test.community.endpoints": "Contoh endpoint",
    "Example endpoints": "Contoh endpoint",
    "cms.test.developer.eyebrow": "AKSES PENGEMBANG",
    "DEVELOPER ACCESS": "AKSES PENGEMBANG",
    "cms.test.developer.title": "API Layers",
    "Layers API": "API Layers",
    "cms.test.developer.docs": "Dokumentasi pengembang",
    "Developer docs": "Dokumentasi pengembang",
    "auth.title": "Autentikasi",
    "auth.sign_in_method": "Metode masuk",
    "auth.facebook_auth": "Autentikasi Facebook",
    "auth.google_auth": "Autentikasi Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "SSO perusahaan",
    "Enterprise SSO": "SSO perusahaan",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "Pengaturan checkout",
    "Checkout Settings": "Pengaturan checkout",
    "checkout.orders": "Pesanan",
    "checkout.carts": "Keranjang",
    "Carts": "Keranjang",
    "audit_logs.action": "Tindakan",
    "audit_logs.resource": "Sumber daya",
    "audit_logs.resource_id": "ID sumber daya",
    "Resource ID": "ID sumber daya",
    "audit_logs.agent_id": "ID agen",
    "Agent ID": "ID agen",
    "audit_logs.result": "Hasil",
    "audit_logs.actor_id": "ID pelaku",
    "Actor ID": "ID pelaku",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Waktu",
    "Timestamp": "Waktu",
    "audit_logs.succeeded": "Berhasil",
    "audit_logs.failed": "Gagal",
    "audit_logs.source": "Sumber",
    "audit_logs.all_sources": "Semua sumber",
    "All sources": "Semua sumber",
    "audit_logs.human_admin": "Manusia (admin)",
    "Human (admin)": "Manusia (admin)",
    "audit_logs.agent_mcp": "Agen (MCP)",
    "Agent (MCP)": "Agen (MCP)",
    "audit_logs.all_actions": "Semua tindakan",
    "All actions": "Semua tindakan",
    "audit_logs.from": "Dari",
    "audit_logs.to": "Sampai",
    "audit_logs.apply": "Terapkan",
    "audit_logs.clear": "Hapus",
    "audit_logs.export_csv": "Ekspor CSV",
    "audit_logs.exporting": "Mengekspor…",
    "audit_logs.title": "Log audit",
    "audit_logs.empty_title": "Log audit tidak ditemukan",
    "No audit logs found": "Log audit tidak ditemukan",
    "audit_logs.empty_subtitle": "Coba sesuaikan filter",
    "Try adjusting your filters": "Coba sesuaikan filter",
    "audit_logs.restriction_notice": "Menampilkan 5 log audit terbaru. Tingkatkan ke paket Growth untuk melihat riwayat lengkap dan mengekspor log.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Menampilkan 5 log audit terbaru. Tingkatkan ke paket Growth untuk melihat riwayat lengkap dan mengekspor log.",
    "audit_logs.extended_history": "Riwayat audit lengkap",
    "Extended audit log history": "Riwayat audit lengkap",
    "manage_features.title": "Kelola Fitur",
    "manage_features.general": "Umum",
    "manage_features.apps": "Aplikasi",
    "manage_features.marketplace": "Marketplace",
    "manage_features.commerce": "Perdagangan",
    "manage_features.channels": "Saluran",
    "manage_features.left_menu": "Menu kiri",
    "Left Menu": "Menu kiri",
    "manage_features.right_sidepanel": "Panel samping kanan",
    "Right Sidepanel": "Panel samping kanan",
    "workflow.integration": "Integrasi",
    "workflow.no_url_title": "URL Integrasi Tidak Ada",
    "No Integration URL": "URL Integrasi Tidak Ada",
    "workflow.no_url_description": "Harap konfigurasi URL integrasi.",
    "Please configure the integration URL.": "Harap konfigurasi URL integrasi.",
    "workflow.back": "Kembali",
    "Go Back": "Kembali",
    "workflow.loading": "Memuat integrasi…",
    "Loading integration...": "Memuat integrasi…",
    "workflow.loading_hint": "Harap tunggu saat kami menghubungkan",
    "Please wait while we connect": "Harap tunggu saat kami menghubungkan",
    "workflow.error_title": "Error Integrasi",
    "Integration Error": "Error Integrasi",
    "workflow.error_description": "Integrasi tidak dapat dimuat. Periksa koneksi lalu coba lagi.",
    "Unable to load the integration. Please check your connection and try again.": "Integrasi tidak dapat dimuat. Periksa koneksi lalu coba lagi.",
    "workflow.retry": "Coba Lagi",
    "Try Again": "Coba Lagi",
    "upgrade_preview.eyebrow": "Pratinjau komponen",
    "Component preview": "Pratinjau komponen",
    "upgrade_preview.title": "Pengalaman peningkatan",
    "Upgrade experience": "Pengalaman peningkatan",
    "upgrade_preview.description": "Gerbang fitur bersama yang berfokus pada kemampuan pelanggan setelah meningkatkan paket.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Gerbang fitur bersama yang berfokus pada kemampuan pelanggan setelah meningkatkan paket.",
    "upgrade_preview.feature": "Tambah varian",
    "Add a variant": "Tambah varian",
    "upgrade_preview.context": "Di sinilah pengguna paket Basic mencapai batas fitur saat ini.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Di sinilah pengguna paket Basic mencapai batas fitur saat ini.",
    "upgrade_preview.button": "Pratinjau panel peningkatan",
    "Preview upgrade panel": "Pratinjau panel peningkatan",
    "upgrade_preview.listing_context": "Untuk listing ini",
    "For this listing": "Untuk listing ini",
    "gamification_test.eyebrow": "GAMIFIKASI PERTUMBUHAN · RUTE UJI",
    "GROWTH GAMIFICATION · TEST ROUTE": "GAMIFIKASI PERTUMBUHAN · RUTE UJI",
    "gamification_test.title": "Kembangkan bisnis Anda",
    "Build momentum for your business": "Kembangkan bisnis Anda",
    "gamification_test.subtitle": "Pratinjau misi, koin, lencana, dan streak untuk {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Pratinjau misi, koin, lencana, dan streak untuk {workspace}.",
    "gamification_test.this_workspace": "workspace ini",
    "this workspace": "workspace ini",
    "gamification_test.coins": "KOIN",
    "COINS": "KOIN",
    "gamification_test.points": "POIN",
    "POINTS": "POIN",
    "gamification_test.streak": "STREAK",
    "STREAK": "STREAK",
    "gamification_test.week": "1 minggu",
    "1 week": "1 minggu",
    "gamification_test.launch": "Alur peluncuran",
    "Launch path": "Alur peluncuran",
    "gamification_test.progress": "{completed} dari {total} tindakan selesai · hingga {coins} koin",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} dari {total} tindakan selesai · hingga {coins} koin",
    "gamification_test.done": "Selesai",
    "gamification_test.reward": "+{count} koin",
    "+{count} coins": "+{count} koin",
    "gamification_test.badges": "Lencana",
    "Badges": "Lencana",
    "gamification_test.mission_listing_created": "Buat listing pertama Anda",
    "Create your first listing": "Buat listing pertama Anda",
    "gamification_test.mission_collection_created": "Buat koleksi pertama Anda",
    "gamification_test.mission_payment_configured": "Siapkan pembayaran",
    "Configure payments": "Siapkan pembayaran",
    "gamification_test.mission_publish_completed": "Publikasikan situs Anda",
    "Publish your site": "Publikasikan situs Anda",
    "gamification_test.mission_analytics_enabled": "Aktifkan analitik",
    "Enable analytics": "Aktifkan analitik",
    "gamification_test.badge_first_step": "Langkah pertama",
    "First Step": "Langkah pertama",
    "gamification_test.badge_catalog_builder": "Pembuat katalog",
    "Catalog Builder": "Pembuat katalog",
    "gamification_test.badge_ready_to_sell": "Siap berjualan",
    "Ready to Sell": "Siap berjualan",
    "gamification_test.badge_data_driven": "Berbasis data",
    "Data Driven": "Berbasis data",
    "gamification_test.badge_growth_operator": "Operator pertumbuhan",
    "Growth Operator": "Operator pertumbuhan",
    "sentry_check.title": "Pemeriksaan Konfigurasi Sentry",
    "Sentry Configuration Check": "Pemeriksaan Konfigurasi Sentry",
    "sentry_check.subtitle": "Uji dan verifikasi pengaturan pelacakan error Sentry",
    "Test and verify Sentry error tracking setup": "Uji dan verifikasi pengaturan pelacakan error Sentry",
    "sentry_check.configuration": "Konfigurasi",
    "sentry_check.check_configuration": "Periksa konfigurasi",
    "Check Configuration": "Periksa konfigurasi",
    "sentry_check.status": "Status:",
    "Status:": "Status:",
    "sentry_check.enabled": "✓ Aktif",
    "✓ Enabled": "✓ Aktif",
    "sentry_check.disabled": "✗ Nonaktif",
    "✗ Disabled": "✗ Nonaktif",
    "sentry_check.environment": "Lingkungan:",
    "Environment:": "Lingkungan:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Sample rate traces:",
    "Traces Sample Rate:": "Sample rate traces:",
    "sentry_check.test_functions": "Fungsi pengujian",
    "Test Functions": "Fungsi pengujian",
    "sentry_check.test_hint": "Klik tombol di bawah untuk menguji fungsi Sentry. Periksa dasbor Sentry untuk memastikan peristiwa tercatat.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Klik tombol di bawah untuk menguji fungsi Sentry. Periksa dasbor Sentry untuk memastikan peristiwa tercatat.",
    "sentry_check.test_results": "Hasil pengujian",
    "Test Results": "Hasil pengujian",
    "sentry_check.clear": "Hapus",
    "sentry_check.no_tests": "Belum ada pengujian",
    "No tests run yet": "Belum ada pengujian",
    "sentry_check.important_notes": "⚠️ Catatan penting",
    "⚠️ Important Notes": "⚠️ Catatan penting",
    "sentry_check.warning_real_events": "• Pengujian ini membuat peristiwa error nyata di dasbor Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Pengujian ini membuat peristiwa error nyata di dasbor Sentry",
    "sentry_check.warning_dashboard": "• Periksa dasbor Sentry untuk memastikan peristiwa tercatat",
    "• Check your Sentry dashboard to verify events are being captured": "• Periksa dasbor Sentry untuk memastikan peristiwa tercatat",
    "sentry_check.warning_traces": "• Beberapa pengujian mungkin tidak muncul jika tracesSampleRate bernilai 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Beberapa pengujian mungkin tidak muncul jika tracesSampleRate bernilai 0.0",
    "sentry_check.warning_dsn": "• Pastikan DSN dikonfigurasi dengan benar di variabel lingkungan",
    "• Make sure your DSN is correctly configured in environment variables": "• Pastikan DSN dikonfigurasi dengan benar di variabel lingkungan",
    "sentry_check.normal_error": "Uji error biasa",
    "Test Normal Error": "Uji error biasa",
    "sentry_check.test_normal_error": "Uji error biasa",
    "sentry_check.test_message": "Uji pesan",
    "Test Message": "Uji pesan",
    "sentry_check.test_breadcrumb": "Uji breadcrumb",
    "Test Breadcrumb": "Uji breadcrumb",
    "sentry_check.test_user_context": "Uji konteks pengguna",
    "Test User Context": "Uji konteks pengguna",
    "sentry_check.test_custom_exception": "Uji pengecualian khusus",
    "Test Custom Exception": "Uji pengecualian khusus",
    "sentry_check.test_promise_rejection": "Uji penolakan Promise",
    "Test Promise Rejection": "Uji penolakan Promise",
    "sentry_check.configuration_check": "Pemeriksaan konfigurasi",
    "Configuration Check": "Pemeriksaan konfigurasi",
    "sentry_check.config_loaded": "Konfigurasi berhasil dimuat",
    "Config loaded successfully": "Konfigurasi berhasil dimuat",
    "sentry_check.error_captured": "Error ditangkap dan dikirim ke Sentry",
    "Error captured and sent to Sentry": "Error ditangkap dan dikirim ke Sentry",
    "sentry_check.error_capture_failed": "Gagal menangkap error: {message}",
    "Failed to capture error: {message}": "Gagal menangkap error: {message}",
    "sentry_check.message": "Pesan",
    "Message": "Pesan",
    "sentry_check.message_captured": "Pesan ditangkap dan dikirim ke Sentry",
    "Message captured and sent to Sentry": "Pesan ditangkap dan dikirim ke Sentry",
    "sentry_check.message_capture_failed": "Gagal menangkap pesan: {message}",
    "Failed to capture message: {message}": "Gagal menangkap pesan: {message}",
    "sentry_check.breadcrumb": "Breadcrumb",
    "Breadcrumb": "Breadcrumb",
    "sentry_check.breadcrumb_added": "Breadcrumb ditambahkan ke konteks Sentry",
    "Breadcrumb added to Sentry context": "Breadcrumb ditambahkan ke konteks Sentry",
    "sentry_check.breadcrumb_failed": "Gagal menambahkan breadcrumb: {message}",
    "Failed to add breadcrumb: {message}": "Gagal menambahkan breadcrumb: {message}",
    "sentry_check.user_context": "Konteks pengguna",
    "User Context": "Konteks pengguna",
    "sentry_check.user_set": "Konteks pengguna ditetapkan di Sentry",
    "User context set in Sentry": "Konteks pengguna ditetapkan di Sentry",
    "sentry_check.user_failed": "Gagal menetapkan konteks pengguna: {message}",
    "Failed to set user context: {message}": "Gagal menetapkan konteks pengguna: {message}",
    "sentry_check.custom_exception": "Pengecualian khusus",
    "Custom Exception": "Pengecualian khusus",
    "sentry_check.custom_sent": "Pengecualian khusus dengan konteks dikirim ke Sentry",
    "Custom exception with context sent to Sentry": "Pengecualian khusus dengan konteks dikirim ke Sentry",
    "sentry_check.custom_failed": "Gagal menangkap pengecualian khusus: {message}",
    "Failed to capture custom exception: {message}": "Gagal menangkap pengecualian khusus: {message}",
    "sentry_check.promise_rejection": "Penolakan Promise",
    "Promise Rejection": "Penolakan Promise",
    "sentry_check.promise_captured": "Penolakan Promise ditangkap dan dikirim ke Sentry",
    "Promise rejection captured and sent to Sentry": "Penolakan Promise ditangkap dan dikirim ke Sentry",
    "sentry_check.promise_failed": "Gagal menangani penolakan Promise: {message}",
    "Failed to handle promise rejection: {message}": "Gagal menangani penolakan Promise: {message}",
    "checkout_settings.orders": "Pesanan",
    "checkout_settings.return_policy_days": "Hari kebijakan pengembalian",
    "Return policy days": "Hari kebijakan pengembalian",
    "checkout_settings.enter_return_policy_days": "Masukkan hari kebijakan pengembalian",
    "Enter return policy days": "Masukkan hari kebijakan pengembalian",
    "checkout_settings.saved": "Berhasil disimpan",
    "checkout_settings.cart": "Keranjang",
    "checkout_settings.hide_quantity_selection": "Sembunyikan pilihan jumlah (default: kolom jumlah ditampilkan)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Sembunyikan pilihan jumlah (default: kolom jumlah ditampilkan)",
    "checkout_settings.enable_coupon": "Aktifkan kupon",
    "Enable Coupon": "Aktifkan kupon",
    "upgrade_page.copy.a_practical_next_step": "Langkah praktis berikutnya",
    "A practical next step": "Langkah praktis berikutnya",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Tambahkan informasi terstruktur yang dibutuhkan alur kerja Anda.",
    "Add the structured information your workflow needs.": "Tambahkan informasi terstruktur yang dibutuhkan alur kerja Anda.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Tetapkan peran dan izin untuk setiap anggota tim.",
    "Assign roles and permissions to every teammate.": "Tetapkan peran dan izin untuk setiap anggota tim.",
    "upgrade_page.copy.audit_log_export": "Ekspor log audit",
    "Audit log export": "Ekspor log audit",
    "upgrade_page.copy.best_next_step": "Langkah terbaik berikutnya",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Impor data terstruktur, ubah secara offline, lalu ekspor salinan kerja lengkap sesuai kebutuhan tim.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Impor data terstruktur, ubah secara offline, lalu ekspor salinan kerja lengkap sesuai kebutuhan tim.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Bangun melampaui antarmuka standar",
    "Build beyond the standard interface": "Bangun melampaui antarmuka standar",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Catat detail yang membuat katalog Anda bermanfaat.",
    "Capture the details that make your catalogue useful.": "Catat detail yang membuat katalog Anda bermanfaat.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Pilih fleksibilitas untuk membangun pengalaman pelanggan sendiri di atas Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Pilih fleksibilitas untuk membangun pengalaman pelanggan sendiri di atas Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Gabungkan listing menjadi bundel pilihan dan biarkan pelanggan memilih item yang memenuhi syarat saat checkout.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Gabungkan listing menjadi bundel pilihan dan biarkan pelanggan memilih item yang memenuhi syarat saat checkout.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Atur mata uang yang diperlukan bisnis saat beroperasi lintas wilayah.",
    "Configure the currencies your business needs as you operate across regions.": "Atur mata uang yang diperlukan bisnis saat beroperasi lintas wilayah.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Hubungkan marketplace dengan alat internal dan otomatisasi saat pekerjaan manual tidak lagi dapat diskalakan.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Hubungkan marketplace dengan alat internal dan otomatisasi saat pekerjaan manual tidak lagi dapat diskalakan.",
    "upgrade_page.copy.connect_your_own_tools": "Hubungkan alat Anda sendiri",
    "Connect your own tools": "Hubungkan alat Anda sendiri",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Atur siapa yang dapat melihat dan mengubah sesuatu.",
    "Control who can see and change what.": "Atur siapa yang dapat melihat dan mengubah sesuatu.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Buat kolom khusus untuk informasi yang perlu dilihat pelanggan dan tim pada setiap listing atau akun.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Buat kolom khusus untuk informasi yang perlu dilihat pelanggan dan tim pada setiap listing atau akun.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Buat bundel tetap dan kombinasi fleksibel.",
    "Create fixed and mix-and-match bundles.": "Buat bundel tetap dan kombinasi fleksibel.",
    "upgrade_page.copy.custom_attributes": "Atribut khusus",
    "Custom attributes": "Atribut khusus",
    "upgrade_page.copy.custom_email_templates": "Templat email khusus",
    "Custom email templates": "Templat email khusus",
    "upgrade_page.copy.email_whitelabelling": "White label email",
    "Email whitelabelling": "White label email",
    "upgrade_page.copy.everything_in_growth": "Semua fitur di Growth",
    "Everything in Growth": "Semua fitur di Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Semua fitur Growth dengan batas tertinggi.",
    "Everything in Growth, with the highest limits.": "Semua fitur Growth dengan batas tertinggi.",
    "upgrade_page.copy.everything_in_starter": "Semua fitur di Starter",
    "Everything in Starter": "Semua fitur di Starter",
    "upgrade_page.copy.expand_your_workspace": "Perluas workspace",
    "Expand your workspace": "Perluas workspace",
    "upgrade_page.copy.feature_access": "Akses fitur",
    "Feature access": "Akses fitur",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Untuk katalog yang berkembang dan membutuhkan pilihan produk lebih jelas.",
    "For a growing catalogue that needs clearer product choices.": "Untuk katalog yang berkembang dan membutuhkan pilihan produk lebih jelas.",
    "upgrade_page.copy.for_established_businesses": "Untuk bisnis mapan",
    "For established businesses": "Untuk bisnis mapan",
    "upgrade_page.copy.for_growing_operations": "Untuk operasional yang berkembang",
    "For growing operations": "Untuk operasional yang berkembang",
    "upgrade_page.copy.for_growing_teams": "Untuk tim yang berkembang",
    "For growing teams": "Untuk tim yang berkembang",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Untuk tim bervolume tinggi yang membutuhkan ruang untuk berkembang.",
    "For high-volume teams that need room to operate at scale.": "Untuk tim bervolume tinggi yang membutuhkan ruang untuk berkembang.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Untuk tim yang mengelola katalog lebih besar dan lebih banyak alur kerja.",
    "For teams managing a larger catalogue and more workflows.": "Untuk tim yang mengelola katalog lebih besar dan lebih banyak alur kerja.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Untuk tim yang perlu bekerja dengan banyak data sekaligus.",
    "For teams ready to work beyond one record at a time.": "Untuk tim yang perlu bekerja dengan banyak data sekaligus.",
    "upgrade_page.copy.full_audit_history": "Riwayat audit lengkap",
    "Full audit history": "Riwayat audit lengkap",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Paket Growth dan Scale dapat melihat seluruh riwayat audit dan mengekspornya untuk alur kepatuhan.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Paket Growth dan Scale dapat melihat seluruh riwayat audit dan mengekspornya untuk alur kepatuhan.",
    "upgrade_page.copy.higher_usage_limits": "Batas penggunaan lebih tinggi",
    "Higher usage limits": "Batas penggunaan lebih tinggi",
    "upgrade_page.copy.highest_usage_limits": "Batas penggunaan tertinggi",
    "Highest usage limits": "Batas penggunaan tertinggi",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Impor dan ekspor data tanpa pekerjaan manual yang berulang.",
    "Import and export records without repetitive manual work.": "Impor dan ekspor data tanpa pekerjaan manual yang berulang.",
    "upgrade_page.copy.import_and_export_tools": "Alat impor dan ekspor",
    "Import and export tools": "Alat impor dan ekspor",
    "upgrade_page.copy.improve_important_customer_messages": "Tingkatkan pesan penting untuk pelanggan",
    "Improve important customer messages": "Tingkatkan pesan penting untuk pelanggan",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Simpan riwayat kepatuhan lebih lama",
    "Keep a longer compliance history": "Simpan riwayat kepatuhan lebih lama",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Jaga visibilitas kepatuhan penuh untuk operasional bervolume tinggi.",
    "Keep complete compliance visibility for high-volume operations.": "Jaga visibilitas kepatuhan penuh untuk operasional bervolume tinggi.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Atur lebih banyak data dan alur kerja seiring pertumbuhan katalog.",
    "Keep more data and workflows organised as the catalogue grows.": "Atur lebih banyak data dan alur kerja seiring pertumbuhan katalog.",
    "upgrade_page.copy.keep_your_workspace_secure": "Jaga keamanan workspace",
    "Keep your workspace secure": "Jaga keamanan workspace",
    "upgrade_page.copy.large": "Besar",
    "Large": "Besar",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Biarkan pelanggan memilih opsi dari satu listing.",
    "Let customers choose options from one listing.": "Biarkan pelanggan memilih opsi dari satu listing.",
    "upgrade_page.copy.listing_variants": "Varian listing",
    "Listing variants": "Varian listing",
    "upgrade_page.copy.make_every_customer_email_yours": "Jadikan setiap email pelanggan sesuai merek Anda",
    "Make every customer email yours": "Jadikan setiap email pelanggan sesuai merek Anda",
    "upgrade_page.copy.make_one_listing_work_harder": "Maksimalkan satu listing",
    "Make one listing work harder": "Maksimalkan satu listing",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Sesuaikan email sistem dengan alur kerja dan gaya Anda.",
    "Make system emails match your workflow and tone.": "Sesuaikan email sistem dengan alur kerja dan gaya Anda.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Sediakan proyek Anda dalam lebih banyak bahasa.",
    "Make your project available in more languages.": "Sediakan proyek Anda dalam lebih banyak bahasa.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Kelola pengalaman bahasa pelanggan saat memperluas ke wilayah dan audiens baru.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Kelola pengalaman bahasa pelanggan saat memperluas ke wilayah dan audiens baru.",
    "upgrade_page.copy.medium": "Sedang",
    "upgrade_page.copy.more_capacity": "Kapasitas lebih besar",
    "More capacity": "Kapasitas lebih besar",
    "upgrade_page.copy.more_storage": "Penyimpanan lebih besar",
    "More storage": "Penyimpanan lebih besar",
    "upgrade_page.copy.more_team_capacity": "Kapasitas tim lebih besar",
    "More team capacity": "Kapasitas tim lebih besar",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Bekerja lebih cepat dengan katalog Anda",
    "Move faster with your catalogue": "Bekerja lebih cepat dengan katalog Anda",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Proses katalog dan tim yang lebih besar dengan lebih cepat",
    "Move larger catalogues and teams through routine work faster.": "Proses katalog dan tim yang lebih besar dengan lebih cepat",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Tawarkan ukuran, warna, atau pilihan lain tanpa menggandakan listing atau memisahkan pengelolaan stok",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Tawarkan ukuran, warna, atau pilihan lain tanpa menggandakan listing atau memisahkan pengelolaan stok",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Gunakan batas tertinggi yang tersedia",
    "Operate with the highest available limits.": "Gunakan batas tertinggi yang tersedia",
    "upgrade_page.copy.per_module_permissions": "Izin per modul",
    "Per-module permissions": "Izin per modul",
    "upgrade_page.copy.priority_support": "Dukungan prioritas",
    "Priority support": "Dukungan prioritas",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Tinjau lebih dari lima aktivitas audit terbaru",
    "Review more than the latest five audit events.": "Tinjau lebih dari lima aktivitas audit terbaru",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Tinjau seluruh riwayat audit seiring bertambahnya tim dan aktivitas",
    "Review the full audit history as your team and activity grow.": "Tinjau seluruh riwayat audit seiring bertambahnya tim dan aktivitas",
    "upgrade_page.copy.role_based_access_control": "Kontrol akses berbasis peran",
    "Role-based access control": "Kontrol akses berbasis peran",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Peran memungkinkan Anda memberi setiap anggota tim akses sesuai kebutuhannya. Tersedia pada paket Growth ke atas.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Peran memungkinkan Anda memberi setiap anggota tim akses sesuai kebutuhannya. Tersedia pada paket Growth ke atas.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Bangun alur komunikasi pelanggan yang lebih efektif dan rapi",
    "Run a stronger, more polished customer communication workflow.": "Bangun alur komunikasi pelanggan yang lebih efektif dan rapi",
    "upgrade_page.copy.sell_across_markets": "Jual di berbagai pasar",
    "Sell across markets": "Jual di berbagai pasar",
    "upgrade_page.copy.sell_products_together": "Jual produk secara bersamaan",
    "Sell products together": "Jual produk secara bersamaan",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Kirim email dengan identitas merek yang dikenal pelanggan Anda",
    "Send email from a brand your customers recognise.": "Kirim email dengan identitas merek yang dikenal pelanggan Anda",
    "upgrade_page.copy.shape_the_information_you_collect": "Atur informasi yang Anda kumpulkan",
    "Shape the information you collect": "Atur informasi yang Anda kumpulkan",
    "upgrade_page.copy.small": "Kecil",
    "Small": "Kecil",
    "upgrade_page.copy.speak_to_more_customers": "Jangkau lebih banyak pelanggan",
    "Speak to more customers": "Jangkau lebih banyak pelanggan",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Standarkan data yang lebih lengkap untuk operasi bervolume tinggi",
    "Standardise richer data across a high-volume operation.": "Standarkan data yang lebih lengkap untuk operasi bervolume tinggi",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Berikan pengalaman pelanggan yang lebih konsisten",
    "Start presenting a more consistent customer experience.": "Berikan pengalaman pelanggan yang lebih konsisten",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Dukung pengalaman pelanggan lengkap yang siap untuk perusahaan",
    "Support a complete enterprise-ready customer experience.": "Dukung pengalaman pelanggan lengkap yang siap untuk perusahaan",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Dukung pelanggan yang berbelanja dengan mata uang berbeda",
    "Support customers who shop in different currencies.": "Dukung pelanggan yang berbelanja dengan mata uang berbeda",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Dukung alur kerja operasional bervolume tinggi dalam skala besar",
    "Support high-volume operational workflows at scale.": "Dukung alur kerja operasional bervolume tinggi dalam skala besar",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Dukung alur kerja dan tim yang lebih besar",
    "Support larger workflows and teams.": "Dukung alur kerja dan tim yang lebih besar",
    "upgrade_page.copy.t_shirt": "Kaos",
    "T-shirt": "Kaos",
    "upgrade_page.copy.t_shirt_large": "Kaos — besar",
    "T-shirt — Large": "Kaos — besar",
    "upgrade_page.copy.t_shirt_medium": "Kaos — sedang",
    "T-shirt — Medium": "Kaos — sedang",
    "upgrade_page.copy.t_shirt_small": "Kaos — kecil",
    "T-shirt — Small": "Kaos — kecil",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Sesuaikan pesan yang diterima pelanggan pada momen penting tanpa mengubah pengaturan marketplace",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Sesuaikan pesan yang diterima pelanggan pada momen penting tanpa mengubah pengaturan marketplace",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Buka lebih banyak alat saat ruang kerja Anda mulai berkembang",
    "Unlock more tools as your workspace begins to grow.": "Buka lebih banyak alat saat ruang kerja Anda mulai berkembang",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Aktifkan fitur ini saat Anda siap",
    "Unlock this feature when you are ready.": "Aktifkan fitur ini saat Anda siap",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Gunakan API headless untuk pengalaman yang sepenuhnya disesuaikan",
    "Use headless APIs for a fully custom experience.": "Gunakan API headless untuk pengalaman yang sepenuhnya disesuaikan",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Gunakan API saat alur kerja Anda membutuhkan kemampuan lebih lanjut",
    "Use the API when your workflow needs to go further.": "Gunakan API saat alur kerja Anda membutuhkan kemampuan lebih lanjut",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Gunakan identitas pengirim dan merek visual Anda agar komunikasi marketplace tetap konsisten",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Gunakan identitas pengirim dan merek visual Anda agar komunikasi marketplace tetap konsisten",
    "upgrade_page.copy.with_variants": "Dengan varian",
    "With variants": "Dengan varian",
    "upgrade_page.copy.without_variants": "Tanpa varian",
    "Without variants": "Tanpa varian",
    "upgrade_page.copy.workflow_tools": "Alat alur kerja",
    "Workflow tools": "Alat alur kerja",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Pekerjaan Anda saat ini tetap seperti semula saat membandingkan paket yang mencakup kemampuan ini",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Pekerjaan Anda saat ini tetap seperti semula saat membandingkan paket yang mencakup kemampuan ini",
    "upgrade_page.copy.a_paid_plan": "paket berbayar",
    "a paid plan": "paket berbayar",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Semua yang dibutuhkan toko yang berkembang: hapus branding, tambahkan domain, dan buka lebih banyak alat.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Semua yang dibutuhkan toko yang berkembang: hapus branding, tambahkan domain, dan buka lebih banyak alat.",
    "upgrade_page.copy.everything_unlocked": "Semua fitur terbuka",
    "Everything unlocked": "Semua fitur terbuka",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Paket AI lengkap, pemasaran tingkat lanjut, dan semua fitur terbuka untuk toko yang serius ingin berkembang",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Pesan dari tim Tradly",
    "A note from the Tradly team": "Pesan dari tim Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Bantu kami menjaga Tradly tetap berjalan",
    "Help us keep Tradly going": "Bantu kami menjaga Tradly tetap berjalan",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Biaya kami meningkat. Agar dapat terus mengembangkan dan mendukung Tradly, kami membutuhkan dukungan komunitas. Untuk melanjutkan ruang kerja Anda, silakan pilih paket. Toko dan data Anda aman. Terima kasih telah menjadi bagian dari Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Biaya kami meningkat. Agar dapat terus mengembangkan dan mendukung Tradly, kami membutuhkan dukungan komunitas. Untuk melanjutkan ruang kerja Anda, silakan pilih paket. Toko dan data Anda aman. Terima kasih telah menjadi bagian dari Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Sejak 2019 kami menyediakan paket gratis Tradly dengan banyak fitur agar siapa pun dapat memulai sesuatu. Kami senang melakukannya, tetapi kini kami tidak dapat terus menanggungnya sendiri. Kami berencana menghadirkan kembali paket gratis setelah bisnis mencapai tahap tertentu agar dapat membalas dukungan komunitas yang membantu kami sampai di sini.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Sejak 2019 kami menyediakan paket gratis Tradly dengan banyak fitur agar siapa pun dapat memulai sesuatu. Kami senang melakukannya, tetapi kini kami tidak dapat terus menanggungnya sendiri. Kami berencana menghadirkan kembali paket gratis setelah bisnis mencapai tahap tertentu agar dapat membalas dukungan komunitas yang membantu kami sampai di sini.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Pilih paket yang sesuai untuk Anda hari ini. Anda dapat mengubahnya kapan saja.",
    "Choose the plan that fits you today. You can change it any time.": "Pilih paket yang sesuai untuk Anda hari ini. Anda dapat mengubahnya kapan saja.",
    "upgrade_page.back_to_workspace": "Kembali ke ruang kerja",
    "Back to workspace": "Kembali ke ruang kerja",
    "upgrade_page.grow_when_ready": "Berkembang saat diperlukan",
    "Grow when the work calls for it": "Berkembang saat diperlukan",
    "upgrade_page.reassurance": "Data, listing, dan pengaturan Anda yang ada akan tetap sama.",
    "Your existing data, listings, and setup stay exactly as they are.": "Data, listing, dan pengaturan Anda yang ada akan tetap sama.",
    "upgrade_page.choose_plan": "Pilih paket",
    "Choose a plan": "Pilih paket",
    "upgrade_page.feature_availability": "Ketersediaan fitur",
    "Feature availability": "Ketersediaan fitur",
    "upgrade_page.available_from": "Tersedia mulai",
    "Available from": "Tersedia mulai",
    "upgrade_page.and_above": "ke atas",
    "and above": "ke atas",
    "upgrade_page.choose_when_useful": "Pilih paket hanya saat fitur ini berguna bagi tim Anda.",
    "Choose a plan only when this capability is useful to your team.": "Pilih paket hanya saat fitur ini berguna bagi tim Anda.",
    "upgrade_page.practical_difference": "Perbedaan praktis",
    "The practical difference": "Perbedaan praktis",
    "upgrade_page.keep_work_simple": "Jaga pekerjaan tetap sederhana seiring pertumbuhan.",
    "Keep the work simpler as you grow.": "Jaga pekerjaan tetap sederhana seiring pertumbuhan.",
    "upgrade_page.plan_path": "Jalur paket",
    "Plan path": "Jalur paket",
    "upgrade_page.plan_path_title": "Mulai dengan paket yang mendukung langkah berikutnya.",
    "Start with the plan that supports this next step.": "Mulai dengan paket yang mendukung langkah berikutnya.",
    "upgrade_page.best_next_step": "Langkah berikutnya yang disarankan",
    "upgrade_page.includes_capability": "Mencakup fitur ini",
    "Includes this capability": "Mencakup fitur ini",
    "upgrade_page.not_included": "Tidak termasuk",
    "Not included": "Tidak termasuk",
    "upgrade_page.included": "✓ Termasuk",
    "✓ Included": "✓ Termasuk",
    "upgrade_page.ready_when_you_are": "Siap saat Anda siap.",
    "Ready when you are.": "Siap saat Anda siap.",
    "upgrade_page.billing_details": "Tinjau detail paket lengkap dan lanjutkan dengan aman melalui penagihan Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Tinjau detail paket lengkap dan lanjutkan dengan aman melalui penagihan Tradly.",
    "upgrade_page.panel.close": "Tutup panel peningkatan",
    "Close upgrade panel": "Tutup panel peningkatan",
    "upgrade_page.panel.show_less": "Tampilkan lebih sedikit",
    "Show less": "Tampilkan lebih sedikit",
    "upgrade_page.panel.see_more": "Lihat selengkapnya",
    "See more": "Lihat selengkapnya",
    "upgrade_page.panel.choose_to_continue": "Pilih paket untuk melanjutkan",
    "Choose a plan to continue": "Pilih paket untuk melanjutkan",
    "upgrade_page.panel.more_ways_to_grow": "Lebih banyak cara untuk berkembang",
    "More ways to grow": "Lebih banyak cara untuk berkembang",
    "upgrade_page.panel.plan_includes_feature": "Setiap paket mencakup fitur ini serta kapasitas tambahan untuk tahap berikutnya.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Setiap paket mencakup fitur ini serta kapasitas tambahan untuk tahap berikutnya.",
    "upgrade_page.panel.add_credits": "Tambahkan kredit atau produk",
    "Add credits or products": "Tambahkan kredit atau produk",
    "upgrade_page.panel.ala_carte_description": "Ruang kerja Anda ditagih à la carte. Isi kredit atau tambahkan produk yang diperlukan.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Ruang kerja Anda ditagih à la carte. Isi kredit atau tambahkan produk yang diperlukan.",
    "upgrade_page.panel.open_ala_carte": "Buka à la carte",
    "Open à la carte": "Buka à la carte",
    "upgrade_page.panel.recommended": "Direkomendasikan",
    "Recommended": "Direkomendasikan",
    "upgrade_page.panel.per_month": "/ bulan",
    "upgrade_page.panel.please_wait": "Harap tunggu…",
    "upgrade_page.panel.unlock_plan": "Buka paket {plan}",
    "Unlock {plan}": "Buka paket {plan}",
    "upgrade_page.panel.choose_plan": "Pilih paket {plan}",
    "Choose {plan}": "Pilih paket {plan}",
    "upgrade_page.panel.compare_plans": "Bandingkan semua detail paket",
    "Compare all plan details": "Bandingkan semua detail paket",
    "workspace.usage.page_title": "Ringkasan penggunaan",
    "Usage overview": "Ringkasan penggunaan",
    "workspace.usage.page_description": "Lihat penggunaan saat ini dan batas yang berlaku untuk ruang kerja ini.",
    "workspace.usage.not_available": "Tidak tersedia",
    "workspace.usage.limit_not_configured": "Batas belum dikonfigurasi",
    "Limit not configured": "Batas belum dikonfigurasi",
    "workspace.usage.limit_value": "Batas: {limit}",
    "Limit: {limit}": "Batas: {limit}",
    "listings.photos": "Foto",
    "Photos": "Foto",
    "listings.listen_episode": "Dengarkan episode ini",
    "Listen to this episode": "Dengarkan episode ini",
    "listings.other_listings": "Listing lainnya",
    "Other listings": "Listing lainnya",
    "listings.delete": "Hapus",
    "listings.fulfilled_by_platform": "Dipenuhi oleh Platform",
    "Fulfilled by Platform": "Dipenuhi oleh Platform",
    "listings.no_attributes_set": "Tidak ada atribut yang ditetapkan",
    "No attributes set": "Tidak ada atribut yang ditetapkan",
    "listings.campaign_raised": "Terkumpul {amount}",
    "{amount} raised": "Terkumpul {amount}",
    "listings.campaign_progress": "{percent}% dari {goal}",
    "{percent}% of {goal}": "{percent}% dari {goal}",
    "listings.seat": "kursi",
    "seat": "kursi",
    "listings.seats": "kursi",
    "seats": "kursi",
    "listings.per_slot": "per slot",
    "per slot": "per slot",
    "listings.total_value": "Total: {total}",
    "Total: {total}": "Total: {total}",
    "listings.orders": "Pesanan",
    "listings.total_orders": "Total pesanan",
    "Total orders": "Total pesanan",
    "listings.revenue": "Pendapatan",
    "listings.average_order": "Rata-rata pesanan",
    "listings.customers": "Pelanggan",
    "Customers": "Pelanggan",
    "listings.load_more": "Muat lebih banyak",
    "Load more": "Muat lebih banyak",
    "listings.filter": "Filter",
    "listings.sort": "Urutkan",
    "Sort": "Urutkan",
    "listings.value_price": "Harga Nilai",
    "Value Price": "Harga Nilai",
    "listings.detail_label_title": "Judul",
    "listings.detail_label_slug": "Slug",
    "listings.detail_label_description": "Deskripsi",
    "listings.detail_label_categories": "Kategori",
    "listings.detail_label_list_price": "Harga daftar",
    "List Price": "Harga daftar",
    "listings.detail_label_offer": "Penawaran",
    "Offer": "Penawaran",
    "listings.detail_label_currency": "Mata uang",
    "listings.detail_label_listing_status": "Status listing",
    "Listing Status": "Status listing",
    "listings.detail_label_active": "Aktif",
    "listings.detail_label_sold": "Terjual",
    "listings.detail_label_meta_title": "Judul meta",
    "listings.detail_label_meta_description": "Deskripsi meta",
    "listings.detail_label_goal": "Target",
    "Goal": "Target",
    "listings.detail_label_donors": "Donatur",
    "Donors": "Donatur",
    "listings.detail_label_start_date": "Tanggal mulai",
    "listings.detail_label_end_date": "Tanggal berakhir",
    "listings.detail_label_stock": "Stok",
    "listings.detail_label_max_qty_order": "Maks. jumlah per pesanan",
    "Max qty / order": "Maks. jumlah per pesanan",
    "listings.detail_label_weight": "Berat",
    "listings.detail_label_dimensions": "Dimensi",
    "Dimensions": "Dimensi",
    "listings.detail_label_listing_period": "Periode listing",
    "Listing period": "Periode listing",
    "listings.detail_label_max_tickets_booking": "Maks. tiket per pemesanan",
    "Max tickets / booking": "Maks. tiket per pemesanan",
    "listings.detail_label_rating": "Peringkat",
    "listings.detail_label_reviews": "Ulasan",
    "listings.detail_label_likes": "Suka",
    "Likes": "Suka",
    "listings.detail_label_dislikes": "Tidak suka",
    "Dislikes": "Tidak suka",
    "listings.detail_label_barcode": "Barcode",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Info dasar",
    "Basic Info": "Info dasar",
    "listings.detail_section_pricing": "Harga",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Pilih jenis listing di atas untuk melanjutkan.",
    "Select a listing type above to continue.": "Pilih jenis listing di atas untuk melanjutkan.",
    "listing_form.attributes": "Atribut",
    "category.status_active_help": "Status (Nonaktif / Aktif)",
    "promotions.medium": "Sedang",
    "users.listings": "Listing",
    "users.accounts": "Akun",
    "users.click_count_one": "{count} klik",
    "{count} click": "{count} klik",
    "users.click_count": "{count} klik",
    "{count} clicks": "{count} klik",
    "integrations.generic.provider_help": "Konfigurasikan penyedia yang dipilih menggunakan kolom di bawah.",
    "Configure the selected provider using the fields below.": "Konfigurasikan penyedia yang dipilih menggunakan kolom di bawah.",
    "attributes.editor_prefill_data_from": "Isi data awal dari",
    "Prefill Data From": "Isi data awal dari",
    "attributes.editor_select_attribute": "Pilih atribut",
    "Select Attribute": "Pilih atribut",
    "attributes.editor_select_attribute_group": "Pilih grup atribut",
    "Select Attribute Group": "Pilih grup atribut",
    "attributes.editor_attribute": "Atribut",
    "Attribute": "Atribut",
    "attributes.editor_attributes": "Atribut",
    "attributes.editor_cart_attributes": "Atribut keranjang",
    "Cart Attributes": "Atribut keranjang",
    "listings.add_photo": "Tambah foto",
    "accounts.analytics": "Analitik",
    "listings.image_optional": "Gambar listing (opsional)",
    "Listing Images (Optional)": "Gambar listing (opsional)",
    "listings.currency": "Mata uang",
    "listing_variants.number_sign": "No.",
    "#": "No.",
    "attributes.active": "Aktif",
    "listing_form.digital_deleted_item_cannot_edit": "Item ini ditandai untuk dihapus dan tidak dapat diedit",
    "This item is marked for deletion and cannot be edited": "Item ini ditandai untuk dihapus dan tidak dapat diedit",
    "listing_form.digital_max_files": "Maksimal 10 file diperbolehkan",
    "Maximum 10 files allowed": "Maksimal 10 file diperbolehkan",
    "listing_form.digital_title_required": "Masukkan judul",
    "listing_form.digital_version_required": "Masukkan nama versi",
    "Please enter a version name": "Masukkan nama versi",
    "listing_form.digital_contents": "Konten digital",
    "Digital Contents": "Konten digital",
    "listing_form.digital_add_content": "＋ Tambah konten",
    "+ Add Content": "＋ Tambah konten",
    "listing_form.no_description": "Tidak ada deskripsi",
    "No description": "Tidak ada deskripsi",
    "listing_form.digital_file_count": "{count} file",
    "{count} file(s)": "{count} file",
    "listing_form.digital_empty": "Belum ada konten digital",
    "No digital contents yet": "Belum ada konten digital",
    "listing_form.digital_empty_help": "Klik “{action}” untuk membuat konten digital pertama",
    "Click \"{action}\" to create your first digital content": "Klik “{action}” untuk membuat konten digital pertama",
    "listing_form.digital_marked_for_deletion": "Ditandai untuk dihapus ({count})",
    "Marked for Deletion ({count})": "Ditandai untuk dihapus ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Akan dihapus saat dikirim",
    "✓ Will be deleted on submit": "✓ Akan dihapus saat dikirim",
    "listing_form.digital_edit_title": "Edit konten digital",
    "Edit Digital Content": "Edit konten digital",
    "listing_form.digital_add_title": "Tambah konten digital",
    "Add New Digital Content": "Tambah konten digital",
    "listing_form.digital_form_description": "Isi detail di bawah untuk {action} konten digital",
    "Fill in the details below to {action} digital content": "Isi detail di bawah untuk {action} konten digital",
    "listing_form.digital_title_placeholder": "Masukkan judul konten digital",
    "Enter digital content title": "Masukkan judul konten digital",
    "listing_form.description_optional_placeholder": "Masukkan deskripsi (opsional)",
    "Enter description (optional)": "Masukkan deskripsi (opsional)",
    "listing_form.version": "Versi",
    "Version": "Versi",
    "listing_form.files": "File",
    "Files": "File",
    "listing_form.max_files": "(Maks. {count})",
    "(Max {count})": "(Maks. {count})",
    "listing_form.click_to_upload_files": "Klik untuk mengunggah file",
    "Click to upload files": "Klik untuk mengunggah file",
    "listing_form.files_uploaded_count": "{count}/10 file diunggah",
    "{count}/10 files uploaded": "{count}/10 file diunggah",
    "listing_form.unknown_size": "Ukuran tidak diketahui",
    "Unknown size": "Ukuran tidak diketahui",
    "listing_form.no_accounts_available": "Tidak ada akun yang tersedia",
    "No accounts available": "Tidak ada akun yang tersedia",
    "listing_form.select_account": "Pilih akun",
    "Select an account": "Pilih akun",
    "listing_form.searching": "Mencari…",
    "Searching...": "Mencari…",
    "listing_form.location_enter_address": "Masukkan alamat untuk mencari",
    "Please enter an address to search": "Masukkan alamat untuk mencari",
    "listing_form.location_no_addresses_search": "Alamat tidak ditemukan. Coba kata kunci lain.",
    "No addresses found. Please try a different search.": "Alamat tidak ditemukan. Coba kata kunci lain.",
    "listing_form.location_search_failed": "Gagal mencari alamat. Silakan coba lagi.",
    "Failed to search addresses. Please try again.": "Gagal mencari alamat. Silakan coba lagi.",
    "listing_form.location_place_details_failed": "Gagal mendapatkan detail tempat. Silakan coba lagi.",
    "Failed to get place details. Please try again.": "Gagal mendapatkan detail tempat. Silakan coba lagi.",
    "listing_form.location_access_denied": "Akses lokasi ditolak. Aktifkan izin lokasi.",
    "Location access denied. Please enable location permissions.": "Akses lokasi ditolak. Aktifkan izin lokasi.",
    "listing_form.location_unavailable": "Lokasi tidak dapat ditentukan. Silakan coba lagi.",
    "Unable to determine location. Please try again.": "Lokasi tidak dapat ditentukan. Silakan coba lagi.",
    "listing_form.location_timeout": "Permintaan lokasi kehabisan waktu. Silakan coba lagi.",
    "Location request timed out. Please try again.": "Permintaan lokasi kehabisan waktu. Silakan coba lagi.",
    "listing_form.location_current_failed": "Gagal mendapatkan lokasi saat ini. Silakan coba lagi.",
    "Failed to get current location. Please try again.": "Gagal mendapatkan lokasi saat ini. Silakan coba lagi.",
    "listing_form.location": "Lokasi",
    "listing_form.location_search_placeholder": "Cari lokasi…",
    "Search for a location...": "Cari lokasi…",
    "listing_form.location_searching": "Mencari alamat…",
    "Searching addresses...": "Mencari alamat…",
    "listing_form.location_no_addresses": "Alamat tidak ditemukan",
    "No addresses found": "Alamat tidak ditemukan",
    "listing_form.location_try_different_search": "Coba kata pencarian lain",
    "Try a different search term": "Coba kata pencarian lain",
    "listing_form.location_getting": "Mengambil lokasi…",
    "Getting location...": "Mengambil lokasi…",
    "listing_form.location_use_current": "Gunakan lokasi saat ini",
    "Use Current Location": "Gunakan lokasi saat ini",
    "listing_form.location_selected": "Lokasi yang dipilih",
    "Selected Location": "Lokasi yang dipilih",
    "listing_form.latitude": "Lintang:",
    "Latitude:": "Lintang:",
    "listing_form.longitude": "Bujur:",
    "Longitude:": "Bujur:",
    "listing_form.location_helper": "Cari alamat atau gunakan lokasi Anda saat ini",
    "Search for an address or use your current location": "Cari alamat atau gunakan lokasi Anda saat ini",
    "common.change": "Ubah",
    "listing_form.variant_id_tooltip": "ID jenis: {typeId}, ID nilai: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "ID jenis: {typeId}, ID nilai: {valueId}",
    "listing_form.variants_marked_for_deletion": "Ditandai untuk dihapus ({count} item):",
    "Marked for Deletion ({count} items):": "Ditandai untuk dihapus ({count} item):",
    "listing_form.add_new_variant": "Tambah varian",
    "Add New Variant": "Tambah varian",
    "listing_form.add_variant_description": "Isi detail di bawah untuk membuat varian baru",
    "Fill in the details below to create a new variant": "Isi detail di bawah untuk membuat varian baru",
    "listing_form.google_search_preview": "Pratinjau Google Penelusuran",
    "Google Search Preview": "Pratinjau Google Penelusuran",
    "listing_form.meta_title_preview": "Pratinjau judul meta Anda",
    "Your Meta Title Here": "Pratinjau judul meta Anda",
    "listing_form.meta_description_preview": "Deskripsi meta Anda akan muncul di sini. Ini membantu pengguna memahami konten halaman Anda di hasil pencarian.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Deskripsi meta Anda akan muncul di sini. Ini membantu pengguna memahami konten halaman Anda di hasil pencarian.",
    "listing_form.variant_name_placeholder": "Masukkan nama",
    "listing_form.list_price_placeholder": "Masukkan harga daftar",
    "listing_form.offer_percent_placeholder": "Masukkan persentase penawaran",
    "Enter Offer Percent": "Masukkan persentase penawaran",
    "attributes.select_all": "Pilih semua",
    "attributes.unselect_all": "Batalkan semua pilihan",
    "Unselect All": "Batalkan semua pilihan",
    "attributes.select_category": "Pilih kategori",
    "attributes.create_category_configuration_first": "Buat kategori terlebih dahulu di konfigurasi {type}",
    "Create categories in {type} configuration first": "Buat kategori terlebih dahulu di konfigurasi {type}",
    "attributes.select_single_attribute_values": "Pilih nilai atribut tunggal",
    "attributes.select_multiple_attribute_values": "Pilih nilai atribut jamak",
    "attributes.enter_value": "Masukkan nilai",
    "attributes.enter_multiple_tags": "Masukkan beberapa tag",
    "Enter Multiple Tags": "Masukkan beberapa tag",
    "attributes.upload_file": "Unggah file",
    "collections.add_condition": "＋ Tambahkan kondisi",
    "collections.add_photo": "Tambah foto",
    "collections.status": "Status (Nonaktif / Aktif)",
    "collections.start_date_placeholder": "Pilih tanggal mulai",
    "Select start date": "Pilih tanggal mulai",
    "collections.end_date_placeholder": "Pilih tanggal berakhir",
    "Select end date": "Pilih tanggal berakhir",
    "navigation.editor": "Editor",
    "Editor": "Editor",
    "navigation.web_analytics": "Analitik web",
    "Web Analytics": "Analitik web",
    "navigation.ai_studio": "Studio AI",
    "AI Studio": "Studio AI",
    "navigation.docs": "Dokumentasi",
    "navigation.logout": "Keluar",
    "Logout": "Keluar",
    "navigation.tenant_name_placeholder": "(Nama tenant)",
    "(Tenant name)": "(Nama tenant)",
    "navigation.username_placeholder": "(Nama pengguna)",
    "(Username)": "(Nama pengguna)",
    "navigation.invite_description": "Kirim tautan undangan kepada anggota tim",
    "Send invitation links to team members": "Kirim tautan undangan kepada anggota tim",
    "navigation.invite": "Undang",
    "Invite": "Undang",
    "navigation.test_mode": "Mode uji",
    "Test Mode": "Mode uji",
    "navigation.upgrade": "Tingkatkan paket",
    "navigation.open_account_menu": "Buka menu akun",
    "Open account menu": "Buka menu akun",
    "navigation.invite_name_required": "Isi nama",
    "Please fill in the name": "Isi nama",
    "navigation.invite_email_required": "Isi email",
    "Please fill in the email": "Isi email",
    "navigation.open_url_failed": "Tidak tahu cara membuka URL ini: {url}",
    "Don't know how to open this URL: {url}": "Tidak tahu cara membuka URL ini: {url}",
    "navigation.no_code_editor": "Editor tanpa kode",
    "No-code editor": "Editor tanpa kode",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Otomatisasi pemasaran",
    "Marketing automation": "Otomatisasi pemasaran",
    "navigation.analytics_recommendation": "Analitik & Rekomendasi",
    "Analytics & Recommendation": "Analitik & Rekomendasi",
    "navigation.ai_studio_iryxo": "Studio AI (Iryxo)",
    "AI Studio (Iryxo)": "Studio AI (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Proyek saat ini",
    "Current project": "Proyek saat ini",
    "navigation.current_user": "Pengguna saat ini",
    "Current user": "Pengguna saat ini",
    "navigation.switch_to_light_mode": "Beralih ke mode terang",
    "Switch to light mode": "Beralih ke mode terang",
    "navigation.switch_to_dark_mode": "Beralih ke mode gelap",
    "Switch to dark mode": "Beralih ke mode gelap",
    "navigation.download_android_app": "Unduh aplikasi Android",
    "Download Android app": "Unduh aplikasi Android",
    "navigation.download_ios_app": "Unduh aplikasi iOS",
    "Download iOS app": "Unduh aplikasi iOS",
    "navigation.subscribe_youtube": "Berlangganan YouTube",
    "Subscribe on YouTube": "Berlangganan YouTube",
    "navigation.open_app_switcher": "Buka pengalih aplikasi",
    "Open app switcher": "Buka pengalih aplikasi",
    "navigation.open_android_app": "Buka aplikasi Android",
    "Open Android app": "Buka aplikasi Android",
    "navigation.open_ios_app": "Buka aplikasi iOS",
    "Open iOS app": "Buka aplikasi iOS",
    "navigation.open_ai_support": "Buka dukungan Tradly ChatGPT",
    "Open Tradly ChatGPT support": "Buka dukungan Tradly ChatGPT",
    "navigation.open_youtube_channel": "Buka kanal YouTube Tradly",
    "Open Tradly YouTube channel": "Buka kanal YouTube Tradly",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "ID listing (opsional — perbarui yang ada)",
    "Listing ID (optional — update existing)": "ID listing (opsional — perbarui yang ada)",
    "listings.smart_upload.category_id": "ID kategori",
    "listings.smart_upload.list_price": "Harga daftar",
    "listings.smart_upload.stock": "Stok",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Barcode",
    "listings.smart_upload.account_id": "ID akun",
    "listings.smart_upload.slug": "Slug",
    "listings.smart_upload.text": "Teks",
    "listings.smart_upload.long_text": "Teks panjang",
    "listings.smart_upload.number": "Angka",
    "listings.smart_upload.single_select": "Pilihan tunggal",
    "listings.smart_upload.multi_select": "Pilihan jamak",
    "listings.smart_upload.attribute_name_required": "Masukkan nama atribut untuk “{header}”.",
    "listings.smart_upload.attribute_create_failed": "Tradly tidak mengembalikan atribut baru “{name}”.",
    "Tradly did not return the new “{name}” attribute.": "Tradly tidak mengembalikan atribut baru “{name}”.",
    "listings.smart_upload.attribute_option_create_failed": "Tidak dapat membuat opsi “{value}” untuk {name}.",
    "Could not create the “{value}” option for {name}.": "Tidak dapat membuat opsi “{value}” untuk {name}.",
    "listings.smart_upload.attribute_no_longer_available": "Atribut yang dipetakan dari “{header}” tidak lagi tersedia.",
    "listings.smart_upload.csv_needs_header_and_listing": "File CSV harus berisi baris header dan setidaknya satu listing.",
    "The CSV must contain a header row and at least one listing.": "File CSV harus berisi baris header dan setidaknya satu listing.",
    "listings.smart_upload.unique_headers_required": "Setiap kolom listing harus memiliki header unik dan tidak kosong.",
    "Every listing column needs a unique, non-empty header.": "Setiap kolom listing harus memiliki header unik dan tidak kosong.",
    "listings.smart_upload.csv_read_failed": "CSV ini tidak dapat dibaca.",
    "listings.smart_upload.map_required_fields": "Petakan kolom wajib berikut sebelum melanjutkan: {fields}",
    "Map these required columns before continuing: {fields}": "Petakan kolom wajib berikut sebelum melanjutkan: {fields}",
    "listings.smart_upload.row_missing_required_value": "Baris {row} tidak memiliki nilai wajib.",
    "Row {row} is missing a required value.": "Baris {row} tidak memiliki nilai wajib.",
    "listings.smart_upload.invalid_category_id_row": "Baris {row} memerlukan ID kategori numerik yang valid, atau pilih “Petakan ID Kategori secara manual”.",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "Baris {row} memerlukan ID kategori numerik yang valid, atau pilih “Petakan ID Kategori secara manual”.",
    "listings.smart_upload.invalid_listing_id_row": "Baris {row} memerlukan ID listing numerik yang valid, atau kosongkan ID untuk membuat listing baru.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "Baris {row} memerlukan ID listing numerik yang valid, atau kosongkan ID untuk membuat listing baru.",
    "listings.smart_upload.progress.checking_duplicates": "Memeriksa listing yang ada",
    "Checking for existing listings": "Memeriksa listing yang ada",
    "listings.smart_upload.duplicate_same_value_row": "Nilai {field} yang sama muncul di baris {row} file ini.",
    "Same {field} appears in row {row} of this file.": "Nilai {field} yang sama muncul di baris {row} file ini.",
    "listings.smart_upload.duplicate_same_value_multiple": "Nilai {field} yang sama muncul lebih dari sekali di file ini.",
    "Same {field} appears more than once in this file.": "Nilai {field} yang sama muncul lebih dari sekali di file ini.",
    "listings.smart_upload.duplicate_existing_listing": "Cocok dengan listing yang ada #{id} berdasarkan {field}.",
    "Matches existing listing #{id} by {field}.": "Cocok dengan listing yang ada #{id} berdasarkan {field}.",
    "listings.smart_upload.explicit_listing_update": "Listing dengan ID eksplisit #{id} akan diperbarui.",
    "Explicit listing ID #{id} will be updated.": "Listing dengan ID eksplisit #{id} akan diperbarui.",
    "listings.smart_upload.progress.duplicates_complete": "Pemeriksaan duplikat selesai",
    "Duplicate check complete": "Pemeriksaan duplikat selesai",
    "listings.smart_upload.duplicate_check_failed": "Tidak dapat memeriksa listing yang ada.",
    "Could not check existing listings.": "Tidak dapat memeriksa listing yang ada.",
    "listings.smart_upload.progress.duplicates_stopped": "Pemeriksaan duplikat dihentikan",
    "Duplicate check stopped": "Pemeriksaan duplikat dihentikan",
    "listings.smart_upload.prepare_file_failed": "Tidak dapat menyiapkan file impor.",
    "listings.smart_upload.progress.uploading_file": "Mengunggah file impor",
    "listings.smart_upload.upload_file_failed": "File impor tidak dapat diunggah.",
    "listings.smart_upload.all_rows_duplicates": "Semua baris terdeteksi sebagai duplikat. Pilih “Impor saja” untuk mengirimkannya ke Tradly, atau mulai ulang.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Semua baris terdeteksi sebagai duplikat. Pilih “Impor saja” untuk mengirimkannya ke Tradly, atau mulai ulang.",
    "listings.smart_upload.progress.preparing_attributes": "Menyiapkan atribut",
    "listings.smart_upload.attribute_mapped_once": "Setiap atribut listing hanya dapat dipetakan sekali. Periksa pemetaan kolom sebelum mengimpor.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Setiap atribut listing hanya dapat dipetakan sekali. Periksa pemetaan kolom sebelum mengimpor.",
    "listings.smart_upload.progress.preparing_file": "Menyiapkan file impor",
    "listings.smart_upload.progress.tradly_importing": "Tradly sedang mengimpor listing",
    "Tradly is importing listings": "Tradly sedang mengimpor listing",
    "listings.smart_upload.progress.import_complete": "Impor selesai",
    "listings.smart_upload.progress.import_stopped": "Impor dihentikan",
    "listings.smart_upload.progress.preparing_import": "Menyiapkan impor…",
    "Preparing import…": "Menyiapkan impor…",
    "listings.smart_upload.progress.rows_prepared": "{current} dari {total} baris disiapkan",
    "{current} of {total} rows prepared": "{current} dari {total} baris disiapkan",
    "listings.smart_upload.progress.remote_processing": "Tradly sedang memproses CSV yang diunggah. Ini mungkin memerlukan waktu.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly sedang memproses CSV yang diunggah. Ini mungkin memerlukan waktu.",
    "listings.smart_upload.progress.partial_import": "Tradly mengimpor {imported} dari {total} baris{ending}. Tinjau hasilnya sebelum mencoba lagi; impor ulang penuh dapat menggandakan baris yang berhasil.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly mengimpor {imported} dari {total} baris{ending}. Tinjau hasilnya sebelum mencoba lagi; impor ulang penuh dapat menggandakan baris yang berhasil.",
    "listings.smart_upload.title": "Smart Upload",
    "Smart Upload": "Smart Upload",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Mulai ulang",
    "listings.smart_upload.description": "Unggah listing, petakan kolom ke kolom yang tersedia, atau buat atribut listing baru sebelum mengimpor.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Unggah listing, petakan kolom ke kolom yang tersedia, atau buat atribut listing baru sebelum mengimpor.",
    "listings.smart_upload.step_upload": "Unggah",
    "listings.smart_upload.step_match": "Cocokkan kolom",
    "listings.smart_upload.step_preview": "Pratinjau",
    "listings.smart_upload.step_import": "Impor",
    "listings.smart_upload.choose_csv": "Pilih file CSV",
    "listings.smart_upload.required_columns_help": "Kolom wajib adalah title dan category_id. Kolom lainnya dapat menjadi atribut listing.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Kolom wajib adalah title dan category_id. Kolom lainnya dapat menjadi atribut listing.",
    "listings.smart_upload.select_csv_file": "Pilih file CSV",
    "listings.smart_upload.match_columns": "Cocokkan kolom listing",
    "Match listing columns": "Cocokkan kolom listing",
    "listings.smart_upload.core_fields_help": "Kolom inti dikirim ke API listing. Kolom tambahan dapat disimpan sebagai atribut listing.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Kolom inti dikirim ke API listing. Kolom tambahan dapat disimpan sebagai atribut listing.",
    "listings.smart_upload.do_not_import": "Jangan impor",
    "listings.smart_upload.map_category_manually": "Petakan ID Kategori secara manual",
    "Map Category ID manually": "Petakan ID Kategori secara manual",
    "listings.smart_upload.category_assignment_help": "Pilih kategori untuk setiap listing yang diimpor.",
    "Choose the category to assign to every imported listing.": "Pilih kategori untuk setiap listing yang diimpor.",
    "listings.smart_upload.select_category": "Pilih kategori",
    "listings.smart_upload.no_categories": "Tidak ada kategori listing. Buat kategori terlebih dahulu, lalu buka kembali Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "Tidak ada kategori listing. Buat kategori terlebih dahulu, lalu buka kembali Smart Upload.",
    "listings.smart_upload.additional_attributes": "Atribut listing tambahan",
    "Additional listing attributes": "Atribut listing tambahan",
    "listings.smart_upload.ignore_column": "Abaikan kolom ini",
    "listings.smart_upload.create_attribute": "＋ Buat atribut listing baru",
    "＋ Create a new listing attribute": "＋ Buat atribut listing baru",
    "listings.smart_upload.attribute_name": "Nama atribut",
    "listings.smart_upload.review_import": "Tinjau impor",
    "listings.smart_upload.rows_scanned_help": "{count} listing dipindai sebelum diunggah. Duplikat diperiksa berdasarkan SKU, barcode, slug, dan nilai berulang dalam CSV ini.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} listing dipindai sebelum diunggah. Duplikat diperiksa berdasarkan SKU, barcode, slug, dan nilai berulang dalam CSV ini.",
    "listings.smart_upload.duplicates_found": "Potensi duplikat",
    "Potential duplicates found": "Potensi duplikat",
    "listings.smart_upload.duplicate_rows_skipped": "{count} baris akan dilewati secara default.",
    "{count} row(s) will be skipped by default.": "{count} baris akan dilewati secara default.",
    "listings.smart_upload.row_label": "Baris",
    "Row": "Baris",
    "listings.smart_upload.explicit_ids_are_updates": "Baris dengan ID listing yang ditentukan akan dianggap sebagai pembaruan.",
    "Rows with an explicit listing ID are treated as updates.": "Baris dengan ID listing yang ditentukan akan dianggap sebagai pembaruan.",
    "listings.smart_upload.duplicate_action": "Tindakan duplikat",
    "Duplicate action": "Tindakan duplikat",
    "listings.smart_upload.skip_duplicates": "Lewati potensi duplikat (disarankan)",
    "Skip potential duplicates (recommended)": "Lewati potensi duplikat (disarankan)",
    "listings.smart_upload.import_all_anyway": "Tetap impor semua",
    "Import all rows anyway": "Tetap impor semua",
    "listings.smart_upload.untitled_listing": "Listing tanpa judul",
    "Untitled listing": "Listing tanpa judul",
    "listings.smart_upload.category_label": "Kategori:",
    "Category:": "Kategori:",
    "listings.smart_upload.complete": "Smart Upload selesai",
    "listings.smart_upload.imported_count": "{imported} dari {total} listing diimpor.",
    "{imported} of {total} listings imported.": "{imported} dari {total} listing diimpor.",
    "listings.smart_upload.selected_file": "Dipilih: {name}",
    "listings.smart_upload.checking": "Memeriksa…",
    "listings.smart_upload.check_duplicates": "Periksa duplikat",
    "Check duplicates": "Periksa duplikat",
    "listings.smart_upload.importing": "Mengimpor…",
    "listings.smart_upload.import_listings": "Impor listing",
    "listings.smart_upload.failed": "Smart Upload gagal.",
    "Smart Upload failed.": "Smart Upload gagal.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Status (Nonaktif / Aktif)",
    "listings.upload_media": "Unggah media",
    "listing_form.stock_placeholder": "Masukkan stok",
    "orders.create_order.order_items_alt": "Item pesanan",
    "orders.create_order.by": "oleh",
    "by": "oleh",
    "orders.create_order.decrease_quantity": "Kurangi jumlah",
    "Decrease quantity": "Kurangi jumlah",
    "orders.create_order.increase_quantity": "Tambah jumlah",
    "Increase quantity": "Tambah jumlah",
    "orders.create_order.remove_item": "Hapus item",
    "Remove item": "Hapus item",
    "orders.create_order.rental_period_label": "Periode sewa:",
    "Rental period:": "Periode sewa:",
    "attributes.enter_text": "Masukkan teks",
    "attributes.select_date": "Pilih tanggal",
    "attributes.enter_number": "Masukkan angka",
    "attributes.select_color": "Pilih warna",
    "attributes.upload_json": "Unggah JSON",
    "Upload JSON": "Unggah JSON",
    "attributes.select_location": "Pilih lokasi",
    "attributes.add_listing_preview": "Tambah listing",
    "attributes.add_account_preview": "Tambah akun",
    "attributes.enter_price": "Masukkan harga",
    "attributes.preview": "Pratinjau",
    "attributes.enter_title": "Masukkan judul",
    "attributes.enter_description": "Masukkan deskripsi",
    "attributes.category": "Kategori",
    "attributes.attribute_name": "Nama atribut",
    "attributes.enter_attribute_name": "Masukkan nama atribut",
    "attributes.select_type": "Pilih jenis",
    "attributes.icon": "Ikon",
    "attributes.tooltip": "Tooltip",
    "Tooltip": "Tooltip",
    "attributes.enter_tooltip": "Masukkan tooltip atribut",
    "Enter attribute tooltip": "Masukkan tooltip atribut",
    "listings.detail.images": "Gambar",
    "listings.detail.posted_by": "Diposting oleh",
    "Posted by": "Diposting oleh",
    "listings.detail.fulfilled_by_platform": "Dipenuhi oleh Platform",
    "listings.detail.preview": "Pratinjau",
    "listings.detail.view_listing": "Lihat listing",
    "View Listing": "Lihat listing",
    "listings.detail.variants": "Varian",
    "listings.detail.no_attribute_values": "Tidak ada nilai atribut untuk {name}",
    "listings.detail.attributes": "Atribut",
    "listings.detail.starts_from": "Mulai dari:",
    "Starts From:": "Mulai dari:",
    "listings.detail.schedule": "Jadwal",
    "listings.detail.detail": "Detail",
    "web_config.download": "Unduh",
    "web_config.cancel": "Batal",
    "web_config.choose_file": "Pilih file",
    "web_config.title": "Konfigurasi Web",
    "Web Configs": "Konfigurasi Web",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Lebar logo",
    "Logo Width": "Lebar logo",
    "web_config.width": "Lebar",
    "web_config.logo_height": "Tinggi logo",
    "Logo Height": "Tinggi logo",
    "web_config.height": "Tinggi",
    "web_config.social_share_image": "Gambar unggulan web untuk dibagikan di media sosial - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Gambar unggulan web untuk dibagikan di media sosial - Open Graph",
    "web_config.business_name": "Nama bisnis",
    "web_config.enter_web_name": "Masukkan nama web",
    "Enter web name": "Masukkan nama web",
    "web_config.title_font": "Font judul",
    "Title Font": "Font judul",
    "web_config.select_title_font": "Pilih font judul",
    "Select title font": "Pilih font judul",
    "web_config.body_font": "Font isi",
    "Body Font": "Font isi",
    "web_config.select_body_font": "Pilih font isi",
    "Select body font": "Pilih font isi",
    "web_config.primary_font": "Font utama",
    "Primary Font": "Font utama",
    "web_config.select_primary_font": "Pilih font utama",
    "Select primary font": "Pilih font utama",
    "web_config.uploaded_successfully": "Berhasil diunggah",
    "web_config.ios_download_icon": "Ikon unduhan aplikasi iOS",
    "iOS app download icon": "Ikon unduhan aplikasi iOS",
    "web_config.ios_download_link": "Tautan unduhan aplikasi iOS",
    "iOS app download link": "Tautan unduhan aplikasi iOS",
    "web_config.enter_ios_download_link": "Masukkan tautan unduhan aplikasi iOS",
    "Enter iOS app download link": "Masukkan tautan unduhan aplikasi iOS",
    "web_config.android_download_icon": "Ikon unduhan aplikasi Android",
    "Android app download icon": "Ikon unduhan aplikasi Android",
    "web_config.android_download_link": "Tautan unduhan aplikasi Android",
    "Android app download link": "Tautan unduhan aplikasi Android",
    "web_config.enter_android_download_link": "Masukkan tautan unduhan aplikasi Android",
    "Enter android app download link": "Masukkan tautan unduhan aplikasi Android",
    "coupons.preview.customer_checkout": "CHECKOUT PELANGGAN",
    "CUSTOMER CHECKOUT": "CHECKOUT PELANGGAN",
    "coupons.preview.title": "Contoh penggunaan kupon",
    "Coupons in action": "Contoh penggunaan kupon",
    "coupons.preview.featured_product": "Produk unggulan Anda",
    "Your featured product": "Produk unggulan Anda",
    "coupons.preview.product_meta": "1 item · Pengiriman standar",
    "1 item · Standard delivery": "1 item · Pengiriman standar",
    "coupons.preview.coupon_applied": "Kupon diterapkan",
    "Coupon applied": "Kupon diterapkan",
    "coupons.preview.remove": "Hapus",
    "coupons.preview.discount_applied": "Diskon diterapkan ke pesanan",
    "Discount applied to the order": "Diskon diterapkan ke pesanan",
    "coupons.preview.subtotal": "Subtotal",
    "coupons.preview.coupon_label": "Kupon · WELCOME10",
    "Coupon · WELCOME10": "Kupon · WELCOME10",
    "coupons.preview.grand_total": "Total akhir",
    "Grand total": "Total akhir",
    "coupons.preview.checkout": "CHECKOUT",
    "CHECKOUT": "CHECKOUT",
    "payments.stripe_get_keys": "Dapatkan kunci Stripe",
    "Get Stripe keys": "Dapatkan kunci Stripe",
    "payments.stripe_syncing": "Menyinkronkan dengan Stripe...",
    "Syncing with Stripe...": "Menyinkronkan dengan Stripe...",
    "payments.stripe_verifying_key": "Memverifikasi kunci rahasia",
    "Verifying secret key": "Memverifikasi kunci rahasia",
    "payments.stripe_creating_webhook": "Membuat webhook pembayaran",
    "Creating payment webhook": "Membuat webhook pembayaran",
    "payments.stripe_account_summary": "{country} · mode {mode} · {id}",
    "{country} · {mode} mode · {id}": "{country} · mode {mode} · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhook dikonfigurasi — rahasia diisi otomatis di bawah. Simpan formulir untuk menyimpan perubahan.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhook dikonfigurasi — rahasia diisi otomatis di bawah. Simpan formulir untuk menyimpan perubahan.",
    "payments.stripe_webhooks_error": "⚠ Penyiapan webhook gagal. Periksa izin kunci Anda lalu coba sinkronkan kembali.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Penyiapan webhook gagal. Periksa izin kunci Anda lalu coba sinkronkan kembali.",
    "payments.stripe_invalid_key": "Kunci rahasia tidak valid. Periksa dan coba lagi.",
    "Invalid secret key. Check and try again.": "Kunci rahasia tidak valid. Periksa dan coba lagi.",
    "payments.stripe_setup_failed": "Penyiapan gagal. Pastikan kunci rahasia disinkronkan terlebih dahulu.",
    "Setup failed. Make sure your secret key is synced first.": "Penyiapan gagal. Pastikan kunci rahasia disinkronkan terlebih dahulu.",
    "payments.stripe_marketplace_connect": "Marketplace Connect",
    "Marketplace Connect": "Marketplace Connect",
    "payments.stripe_marketplace_hint": "Hanya diperlukan jika Anda menggunakan Stripe Connect untuk pembayaran marketplace",
    "Only needed if you use Stripe Connect for marketplace payouts": "Hanya diperlukan jika Anda menggunakan Stripe Connect untuk pembayaran marketplace",
    "payments.stripe_subscription_hint": "Hanya diperlukan jika Anda menjual produk langganan di Tradly",
    "Only needed if you sell subscription products on Tradly": "Hanya diperlukan jika Anda menjual produk langganan di Tradly",
    "integrations.sso.title": "Single sign-on perusahaan",
    "Enterprise single sign-on": "Single sign-on perusahaan",
    "integrations.sso.description": "Hubungkan penyedia identitas perusahaan agar staf tenant yang telah disediakan dapat masuk ke ArcticWhale dengan OIDC. Mendukung Okta, Microsoft Entra ID, dan penyedia OIDC yang menandatangani token ID dengan RS256.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Hubungkan penyedia identitas perusahaan agar staf tenant yang telah disediakan dapat masuk ke ArcticWhale dengan OIDC. Mendukung Okta, Microsoft Entra ID, dan penyedia OIDC yang menandatangani token ID dengan RS256.",
    "integrations.sso.issuer_url": "URL penerbit",
    "Issuer URL": "URL penerbit",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID klien",
    "integrations.sso.client_secret": "Rahasia klien",
    "integrations.sso.secret_replace_placeholder": "Disimpan dengan aman. Masukkan nilai untuk menggantinya.",
    "Saved securely. Enter a value to replace it.": "Disimpan dengan aman. Masukkan nilai untuk menggantinya.",
    "integrations.sso.secret_placeholder": "Masukkan rahasia klien",
    "Enter the client secret": "Masukkan rahasia klien",
    "integrations.sso.email_domains": "Domain email perusahaan",
    "Company email domains": "Domain email perusahaan",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "Staf harus sudah memiliki akun ArcticWhale dan akses ke tenant ini. Gunakan domain yang dimiliki organisasi Anda.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "Staf harus sudah memiliki akun ArcticWhale dan akses ke tenant ini. Gunakan domain yang dimiliki organisasi Anda.",
    "integrations.sso.callback_url": "URL callback OIDC",
    "OIDC callback URL": "URL callback OIDC",
    "integrations.sso.loading_callback_url": "Memuat URL callback…",
    "Loading callback URL…": "Memuat URL callback…",
    "integrations.sso.callback_help": "Tambahkan URL persis ini ke aplikasi penyedia identitas sebagai Web redirect URI.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Tambahkan URL persis ini ke aplikasi penyedia identitas sebagai Web redirect URI.",
    "integrations.sso.enable": "Aktifkan login SSO perusahaan",
    "Enable company SSO sign-in": "Aktifkan login SSO perusahaan",
    "integrations.sso.checking": "Memeriksa…",
    "integrations.sso.test_issuer": "Uji penerbit",
    "Test issuer": "Uji penerbit",
    "integrations.sso.saving": "Menyimpan…",
    "integrations.sso.save": "Simpan pengaturan SSO",
    "Save SSO settings": "Simpan pengaturan SSO",
    "integrations.sso.security_help": "Rahasia klien dienkripsi sebelum disimpan. SSO menambahkan opsi login organisasi; login kata sandi tetap tersedia dalam konfigurasi ini.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "Rahasia klien dienkripsi sebelum disimpan. SSO menambahkan opsi login organisasi; login kata sandi tetap tersedia dalam konfigurasi ini.",
    "integrations.sso.load_error": "Tidak dapat memuat pengaturan SSO perusahaan.",
    "Unable to load enterprise SSO settings.": "Tidak dapat memuat pengaturan SSO perusahaan.",
    "integrations.sso.save_error": "Tidak dapat menyimpan pengaturan SSO perusahaan.",
    "Unable to save enterprise SSO settings.": "Tidak dapat menyimpan pengaturan SSO perusahaan.",
    "integrations.sso.saved": "Pengaturan SSO perusahaan disimpan.",
    "Enterprise SSO settings saved.": "Pengaturan SSO perusahaan disimpan.",
    "integrations.sso.connection_ok": "Penemuan penyedia identitas dapat dijangkau.",
    "Identity provider discovery is reachable.": "Penemuan penyedia identitas dapat dijangkau.",
    "integrations.sso.connection_error": "Tidak dapat terhubung ke penyedia identitas.",
    "Unable to connect to the identity provider.": "Tidak dapat terhubung ke penyedia identitas.",
    "listing_configs.maximum_quantity_per_listing": "Jumlah maksimum per listing",
    "listing_configs.example_quantity": "(Contoh: 100)",
    "listing_configs.enter_maximum_quantity": "Masukkan jumlah maksimum per listing",
    "Enter maximum quantity per listing": "Masukkan jumlah maksimum per listing",
    "listing_configs.minimum_listing_price": "Harga minimum listing",
    "listing_configs.example_price": "(Contoh: $5)",
    "listing_configs.enter_minimum_price": "Masukkan harga minimum listing",
    "Enter minimum listing price": "Masukkan harga minimum listing",
    "listing_configs.picture_count": "Jumlah gambar yang dapat diunggah",
    "listing_configs.enter_picture_count": "Masukkan jumlah gambar",
    "Enter Pictures count": "Masukkan jumlah gambar",
    "listing_configs.feature_activation": "AKTIVASI FITUR",
    "FEATURE ACTIVATION": "AKTIVASI FITUR",
    "listing_configs.example_landmark": "(Contoh: Tengara)",
    "listing_configs.enter_address_label": "Masukkan label alamat",
    "Enter address Label": "Masukkan label alamat",
    "listing_configs.legacy_switch_0": "Setujui listing secara otomatis?",
    "listing_configs.legacy_switch_1": "Persentase penawaran",
    "listing_configs.legacy_switch_2": "Batas jumlah maksimum pada tingkat listing",
    "listing_configs.legacy_switch_3": "Biaya pengiriman",
    "listing_configs.legacy_switch_4": "Gunakan penanda peta alih-alih mencari alamat",
    "Use map marker instead \nof searching address": "Gunakan penanda peta alih-alih mencari alamat",
    "listing_configs.legacy_switch_5": "Tag",
    "listing_configs.legacy_switch_6": "Stok",
    "listing_configs.legacy_switch_7": "Alamat geo",
    "listing_configs.legacy_switch_8": "Tampilkan listing yang stoknya habis di feed",
    "listing_configs.legacy_switch_9": "Slug judul listing",
    "listing_configs.legacy_switch_10": "Varian",
    "listing_configs.legacy_switch_11": "Judul meta",
    "listing_configs.legacy_switch_12": "Deskripsi meta",
    "listing_configs.legacy_switch_13": "Produk digital",
    "Digital Product": "Produk digital",
    "listing_configs.legacy_switch_14": "Aktifkan Composer",
    "listing_configs.legacy_switch_15": "Aktifkan berat",
    "listing_configs.legacy_switch_16": "Aktifkan dimensi",
    "navigation.app_download.close": "Tutup",
    "navigation.app_download.eyebrow": "Aplikasi pendamping seluler",
    "Mobile companion": "Aplikasi pendamping seluler",
    "navigation.app_download.title": "Lanjutkan mengelola proyek Anda di mana saja.",
    "Keep your project moving.": "Lanjutkan mengelola proyek Anda di mana saja.",
    "navigation.app_download.description": "Kelola hal penting dari ponsel—setujui listing baru, periksa pesanan, dan pastikan bisnis berjalan lancar.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Kelola hal penting dari ponsel—setujui listing baru, periksa pesanan, dan pastikan bisnis berjalan lancar.",
    "navigation.app_download.approve_listings": "Setujui listing",
    "Approve listings": "Setujui listing",
    "navigation.app_download.manage_orders": "Kelola pesanan",
    "Manage orders": "Kelola pesanan",
    "navigation.app_download.check_performance": "Periksa kinerja",
    "Check performance": "Periksa kinerja",
    "navigation.app_download.download_title": "Unduh aplikasi SuperAdmin",
    "Download the SuperAdmin app": "Unduh aplikasi SuperAdmin",
    "navigation.app_download.download_on": "Unduh di",
    "Download on the": "Unduh di",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Dapatkan di",
    "Get it on": "Dapatkan di",
    "listing_configs.address_label": "Label alamat",
    "collections.add_another_condition": "＋ Tambahkan kondisi lain",
    "collections.search": "Cari",
    "collections.status_inactive_active": "Status (Nonaktif / Aktif)",
    "media_picker.add_photo": "Tambah foto",
    "payments.payment_intent_webhook_secret": "Rahasia webhook Payment Intent",
    "Payment Intent Webhook secret": "Rahasia webhook Payment Intent",
    "payments.subscription_webhook_secret": "Rahasia webhook langganan",
    "Subscription Webhook secret": "Rahasia webhook langganan",
    "payments.webhook_secret_autofilled": "Rahasia webhook diisi otomatis di atas — simpan formulir untuk menerapkannya.",
    "Webhook secret auto-filled above — save the form to persist.": "Rahasia webhook diisi otomatis di atas — simpan formulir untuk menerapkannya.",
    "app_customization.white_png_icon_help": "Ikon harus berwarna putih dan dalam format PNG",
    "icon should be white and in png format": "Ikon harus berwarna putih dan dalam format PNG",
    "app_customization.other_appearance": "Tampilan lainnya",
    "Other appearance": "Tampilan lainnya",
    "app_customization.notification_icon": "Ikon notifikasi",
    "Notification icon": "Ikon notifikasi",
    "app_customization.app_title_home": "Judul aplikasi di layar utama",
    "app_customization.enable_app_title_icon": "Gunakan ikon judul aplikasi sebagai pengganti teks",
    "listings.quick_add.title": "Tambah listing cepat",
    "Quick Add Listing": "Tambah listing cepat",
    "listings.quick_add.success": "Listing berhasil ditambahkan",
    "Listing Added Successfully": "Listing berhasil ditambahkan",
    "listings.quick_add.image": "Gambar",
    "listings.quick_add.listing_name": "Nama listing",
    "Listing Name": "Nama listing",
    "listings.quick_add.title_placeholder": "misalnya, Headphone Nirkabel Premium",
    "e.g., Premium Wireless Headphones": "misalnya, Headphone Nirkabel Premium",
    "listings.quick_add.category": "Kategori",
    "listings.quick_add.select_category": "Pilih kategori",
    "listings.quick_add.price": "Harga",
    "listings.quick_add.stock": "Stok",
    "listings.quick_add.description": "Deskripsi",
    "listings.quick_add.description_placeholder": "Deskripsi singkat produk Anda...",
    "Brief Description of your product...": "Deskripsi singkat produk Anda...",
    "listings.quick_add.more_options": "Perlu opsi lainnya? Gunakan",
    "Need more options? Use the full": "Perlu opsi lainnya? Gunakan",
    "listings.quick_add.guided_form": "formulir lengkap",
    "guided form": "formulir lengkap",
    "listings.quick_add.instead": "sebagai gantinya",
    "instead": "sebagai gantinya",
    "listings.digital_product.title": "Tambah produk digital",
    "Add Digital Product": "Tambah produk digital",
    "listings.digital_product.select_file": "Pilih file",
    "Select file": "Pilih file",
    "listings.digital_product.name": "Judul",
    "listings.digital_product.version": "Versi",
    "listings.digital_product.description": "Deskripsi",
    "web_config.social_info": "Info media sosial",
    "Social Info": "Info media sosial",
    "web_config.social_facebook_pageurl": "URL halaman Facebook",
    "Facebook page URL": "URL halaman Facebook",
    "web_config.enter_social_facebook_pageurl": "Masukkan URL halaman Facebook",
    "Enter Facebook page URL": "Masukkan URL halaman Facebook",
    "web_config.social_twitter_handleurl": "URL akun Twitter",
    "Twitter handle URL": "URL akun Twitter",
    "web_config.enter_social_twitter_handleurl": "Masukkan URL akun Twitter",
    "Enter Twitter handle URL": "Masukkan URL akun Twitter",
    "web_config.social_instagram_url": "URL Instagram",
    "Instagram URL": "URL Instagram",
    "web_config.enter_social_instagram_url": "Masukkan URL Instagram",
    "Enter Instagram URL": "Masukkan URL Instagram",
    "web_config.social_youtube_channelurl": "URL kanal YouTube",
    "Youtube channel URL": "URL kanal YouTube",
    "web_config.enter_social_youtube_channelurl": "Masukkan URL kanal YouTube",
    "Enter Youtube channel URL": "Masukkan URL kanal YouTube",
    "web_config.social_tiktok_url": "URL TikTok",
    "Tiktok URL": "URL TikTok",
    "web_config.enter_social_tiktok_url": "Masukkan URL TikTok",
    "Enter Tiktok URL": "Masukkan URL TikTok",
    "web_config.social_spotify_url": "URL Spotify",
    "Spotify URL": "URL Spotify",
    "web_config.enter_social_spotify_url": "Masukkan URL Spotify",
    "Enter Spotify URL": "Masukkan URL Spotify",
    "web_config.social_whatsapp_number": "Nomor WhatsApp",
    "Whatsapp number": "Nomor WhatsApp",
    "web_config.enter_social_whatsapp_number": "Masukkan nomor WhatsApp",
    "Enter Whatsapp number": "Masukkan nomor WhatsApp",
    "web_config.social_telegram_url": "URL Telegram",
    "Telegram URL": "URL Telegram",
    "web_config.enter_social_telegram_url": "Masukkan URL Telegram",
    "Enter Telegram URL": "Masukkan URL Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Masukkan Snapchat",
    "Enter Snapchat": "Masukkan Snapchat",
    "payments.paydunya.title": "Integrasi PayDunya",
    "PayDunya Integration": "Integrasi PayDunya",
    "payments.paydunya.master_key": "Kunci utama",
    "Master key": "Kunci utama",
    "payments.paydunya.enter_master_key": "Masukkan kunci utama",
    "Enter master key": "Masukkan kunci utama",
    "payments.paydunya.public_key": "Kunci publik",
    "Public key": "Kunci publik",
    "payments.paydunya.enter_public_key": "Masukkan kunci publik",
    "payments.paydunya.private_key": "Kunci privat",
    "Private key": "Kunci privat",
    "payments.paydunya.enter_private_key": "Masukkan kunci privat",
    "Enter private key": "Masukkan kunci privat",
    "payments.paydunya.token": "Token",
    "payments.paydunya.enter_token": "Masukkan token",
    "payments.paydunya.uploaded_successfully": "Berhasil diunggah",
    "communications.email_stats_open": "{sent} terkirim · dibuka {openRate}%",
    "{sent} sent · {openRate}% open": "{sent} terkirim · dibuka {openRate}%",
    "communications.email_stats_full": "{sent} terkirim · dibuka {openRate}% · klik {clicks}",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} terkirim · dibuka {openRate}% · klik {clicks}",
    "navigation.mini_apps.title": "Mini Apps",
    "Mini Apps": "Mini Apps",
    "navigation.mini_apps.subtitle": "Alat pendamping buatan Tradly — ketuk kartu untuk melihat detail dan harga",
    "Tradly-built companion tools — tap a card to see details and pricing": "Alat pendamping buatan Tradly — ketuk kartu untuk melihat detail dan harga",
    "navigation.mini_apps.soon": "Segera",
    "Soon": "Segera",
    "navigation.mini_apps.included_in_paid_plan": "Termasuk dalam paket berbayar",
    "Included in a paid plan": "Termasuk dalam paket berbayar",
    "navigation.mini_apps.know_more": "Pelajari lebih lanjut",
    "Know more": "Pelajari lebih lanjut",
    "navigation.mini_apps.hide_details": "Sembunyikan detail",
    "Hide details": "Sembunyikan detail",
    "navigation.mini_apps.view_plans": "Lihat paket",
    "navigation.mini_apps.remove": "Hapus",
    "navigation.mini_apps.add_to_sidebar": "Tambahkan ke sidebar",
    "Add to sidebar": "Tambahkan ke sidebar",
    "navigation.mini_apps.why_heading": "Manfaatnya untuk bisnis Anda",
    "Why your business needs it": "Manfaatnya untuk bisnis Anda",
    "navigation.mini_apps.coming_soon": "Segera hadir",
    "navigation.mini_apps.workflow.title": "Pemasaran",
    "navigation.mini_apps.workflow.description": "Jalankan kampanye email, notifikasi push, dan promosi untuk mengembangkan audiens Anda.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Jalankan kampanye email, notifikasi push, dan promosi untuk mengembangkan audiens Anda.",
    "navigation.mini_apps.workflow.why_1": "Kirim kampanye email bertarget kepada pembeli dan penjual berdasarkan aktivitas",
    "Send targeted email campaigns to buyers and sellers based on activity": "Kirim kampanye email bertarget kepada pembeli dan penjual berdasarkan aktivitas",
    "navigation.mini_apps.workflow.why_2": "Gunakan notifikasi push untuk melibatkan kembali pengguna yang tidak berkunjung selama 7+ hari",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Gunakan notifikasi push untuk melibatkan kembali pengguna yang tidak berkunjung selama 7+ hari",
    "navigation.mini_apps.workflow.why_3": "Jalankan promosi kupon yang dijadwalkan sesuai acara musiman Anda",
    "Run promotions with coupon drops timed to your seasonal events": "Jalankan promosi kupon yang dijadwalkan sesuai acara musiman Anda",
    "navigation.mini_apps.workflow.pricing_label": "Berbasis kredit",
    "Credits-based": "Berbasis kredit",
    "navigation.mini_apps.workflow.pricing_detail": "Bayar per pengiriman — 1.000 email seharga 100 kredit. Kredit tidak pernah kedaluwarsa.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Bayar per pengiriman — 1.000 email seharga 100 kredit. Kredit tidak pernah kedaluwarsa.",
    "navigation.mini_apps.intelligence_section.title": "Intelijen",
    "navigation.mini_apps.intelligence_section.description": "Pahami pertumbuhan melalui analitik, funnel, dan insight berbasis AI.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Pahami pertumbuhan melalui analitik, funnel, dan insight berbasis AI.",
    "navigation.mini_apps.intelligence_section.why_1": "Lihat listing, akun, dan kategori yang menghasilkan GMV terbesar",
    "See which listings, accounts, and categories drive the most GMV": "Lihat listing, akun, dan kategori yang menghasilkan GMV terbesar",
    "navigation.mini_apps.intelligence_section.why_2": "Funnel drop-off menunjukkan tepat di mana pembeli pergi sebelum checkout",
    "Drop-off funnels show exactly where buyers leave before checkout": "Funnel drop-off menunjukkan tepat di mana pembeli pergi sebelum checkout",
    "navigation.mini_apps.intelligence_section.why_3": "AI menampilkan anomali dan peluang yang mungkin terlewat dalam data mentah",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "AI menampilkan anomali dan peluang yang mungkin terlewat dalam data mentah",
    "navigation.mini_apps.intelligence_section.pricing_label": "Berbasis kredit",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Analisis AI dan laporan yang dibuat menggunakan kredit. Tampilan data selalu gratis.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Analisis AI dan laporan yang dibuat menggunakan kredit. Tampilan data selalu gratis.",
    "navigation.mini_apps.subscription_section.title": "Langganan",
    "navigation.mini_apps.subscription_section.description": "Kelola paket, siklus penagihan, dan hak fitur untuk tenant Anda.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Kelola paket, siklus penagihan, dan hak fitur untuk tenant Anda.",
    "navigation.mini_apps.subscription_section.why_1": "Buat paket bertingkat (Free / Pro / Enterprise) dengan batasan per fitur",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Buat paket bertingkat (Free / Pro / Enterprise) dengan batasan per fitur",
    "navigation.mini_apps.subscription_section.why_2": "Otomatiskan siklus penagihan — bulanan, tahunan, atau durasi khusus",
    "Automate billing cycles — monthly, annual, or custom durations": "Otomatiskan siklus penagihan — bulanan, tahunan, atau durasi khusus",
    "navigation.mini_apps.subscription_section.why_3": "Hak fitur membuka atau membatasi fitur di seluruh tenant Anda",
    "Entitlements unlock or restrict features across your tenant base": "Hak fitur membuka atau membatasi fitur di seluruh tenant Anda",
    "navigation.mini_apps.subscription_section.pricing_label": "Koneksi",
    "navigation.mini_apps.subscription_section.pricing_detail": "Harga berbasis tugas — dikenakan per peristiwa langganan (peningkatan, perpanjangan, pembatalan).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Harga berbasis tugas — dikenakan per peristiwa langganan (peningkatan, perpanjangan, pembatalan).",
    "navigation.mini_apps.membership_section.title": "Keanggotaan",
    "navigation.mini_apps.membership_section.description": "Kelola program keanggotaan, anggota terdaftar, kontribusi, dan iuran pembayaran.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Kelola program keanggotaan, anggota terdaftar, kontribusi, dan iuran pembayaran.",
    "navigation.mini_apps.membership_section.why_1": "Kelola program keanggotaan dan anggota terdaftar",
    "Manage membership programs and enrolled members": "Kelola program keanggotaan dan anggota terdaftar",
    "navigation.mini_apps.membership_section.why_2": "Pantau kontribusi, iuran pembayaran, dan status keanggotaan",
    "Track contributions, payment dues, and membership status": "Pantau kontribusi, iuran pembayaran, dan status keanggotaan",
    "navigation.mini_apps.membership_section.why_3": "Hubungkan kontribusi anggota dengan pesanan terkait",
    "Connect membership contributions back to their orders": "Hubungkan kontribusi anggota dengan pesanan terkait",
    "navigation.mini_apps.membership_section.pricing_label": "Harga belum ditentukan",
    "Pricing TBC": "Harga belum ditentukan",
    "navigation.mini_apps.membership_section.pricing_detail": "Kelola program keanggotaan dan riwayat kontribusi di satu tempat.",
    "Manage membership programs and contribution history in one place.": "Kelola program keanggotaan dan riwayat kontribusi di satu tempat.",
    "navigation.mini_apps.reward_programs.title": "Reward",
    "navigation.mini_apps.reward_programs.description": "Buat program reward dengan cakupan, aturan, dan resep reward yang dapat digunakan kembali.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Buat program reward dengan cakupan, aturan, dan resep reward yang dapat digunakan kembali.",
    "navigation.mini_apps.reward_programs.why_1": "Tentukan program reward afiliasi, rujukan, regional, atau toko",
    "Define affiliate, referral, regional, or store reward programs": "Tentukan program reward afiliasi, rujukan, regional, atau toko",
    "navigation.mini_apps.reward_programs.why_2": "Buat aturan dari komponen komisi dan reward yang dapat digunakan kembali",
    "Build rules from reusable commission and reward components": "Buat aturan dari komponen komisi dan reward yang dapat digunakan kembali",
    "navigation.mini_apps.reward_programs.why_3": "Perhitungan reward dan pengiriman ledger dikelola oleh backend ERP",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Perhitungan reward dan pengiriman ledger dikelola oleh backend ERP",
    "navigation.mini_apps.reward_programs.pricing_label": "Harga belum ditentukan",
    "navigation.mini_apps.reward_programs.pricing_detail": "Konfigurasikan program reward dan hubungkan dengan atribusi.",
    "Configure reward programs and connect them to attribution.": "Konfigurasikan program reward dan hubungkan dengan atribusi.",
    "navigation.mini_apps.bundles_app.title": "Bundel",
    "navigation.mini_apps.bundles_app.description": "Buat bundel tetap dan kombinasi pilihan dari listing yang ada.",
    "Create fixed and mix-and-match bundles from existing listings.": "Buat bundel tetap dan kombinasi pilihan dari listing yang ada.",
    "navigation.mini_apps.bundles_app.why_1": "Gabungkan listing yang ada tanpa menggandakan data produk",
    "Combine existing listings without duplicating product data": "Gabungkan listing yang ada tanpa menggandakan data produk",
    "navigation.mini_apps.bundles_app.why_2": "Dukung bundel tetap dan kombinasi pilihan pelanggan",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Dukung bundel tetap dan kombinasi pilihan pelanggan",
    "navigation.mini_apps.bundles_app.why_3": "Validasi stok komponen sebelum checkout dan pemenuhan pesanan",
    "Validate component stock before checkout and fulfilment": "Validasi stok komponen sebelum checkout dan pemenuhan pesanan",
    "navigation.mini_apps.bundles_app.pricing_label": "Fitur paket berbayar",
    "Paid package feature": "Fitur paket berbayar",
    "navigation.mini_apps.bundles_app.pricing_detail": "Tersedia pada paket yang mencakup operasi bundel.",
    "Available on plans that include bundle operations.": "Tersedia pada paket yang mencakup operasi bundel.",
    "navigation.mini_apps.inventory_section.title": "Rantai Pasok",
    "navigation.mini_apps.inventory_section.description": "Inventaris, pesanan pembelian, lokasi stok, pemasok, dan operasional.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Inventaris, pesanan pembelian, lokasi stok, pemasok, dan operasional.",
    "navigation.mini_apps.inventory_section.why_1": "Pantau stok di berbagai gudang dan lokasi toko",
    "Track stock levels across multiple warehouses and store locations": "Pantau stok di berbagai gudang dan lokasi toko",
    "navigation.mini_apps.inventory_section.why_2": "Buat pesanan pembelian ke pemasok dan terima stok berdasarkan pesanan",
    "Raise purchase orders with suppliers and receive stock against them": "Buat pesanan pembelian ke pemasok dan terima stok berdasarkan pesanan",
    "navigation.mini_apps.inventory_section.why_3": "Catat operasi inventaris — penyesuaian, transfer, dan penghapusan stok",
    "Record inventory operations — adjustments, transfers, and write-offs": "Catat operasi inventaris — penyesuaian, transfer, dan penghapusan stok",
    "navigation.mini_apps.inventory_section.pricing_label": "Termasuk",
    "Included": "Termasuk",
    "navigation.mini_apps.inventory_section.pricing_detail": "Supply Chain termasuk dalam paket Anda. Tanpa biaya tambahan.",
    "Supply Chain is included in your plan. No additional charge.": "Supply Chain termasuk dalam paket Anda. Tanpa biaya tambahan.",
    "navigation.mini_apps.people_app.title": "People",
    "navigation.mini_apps.people_app.description": "Direktori staf, departemen, profil pekerjaan, dan golongan gaji.",
    "Staff directory, departments, job profiles, and pay grades.": "Direktori staf, departemen, profil pekerjaan, dan golongan gaji.",
    "navigation.mini_apps.people_app.why_1": "Simpan profil, kode, dan jenis pekerjaan setiap staf dalam satu direktori",
    "Keep every staff profile, code, and employment type in one directory": "Simpan profil, kode, dan jenis pekerjaan setiap staf dalam satu direktori",
    "navigation.mini_apps.people_app.why_2": "Atur tim ke dalam departemen dengan profil pekerjaan standar",
    "Organise teams into departments with standard job profiles": "Atur tim ke dalam departemen dengan profil pekerjaan standar",
    "navigation.mini_apps.people_app.why_3": "Tetapkan golongan gaji sekali lalu berikan kepada staf",
    "Define pay grades once and assign them to staff": "Tetapkan golongan gaji sekali lalu berikan kepada staf",
    "navigation.mini_apps.people_app.pricing_label": "Harga belum ditentukan",
    "navigation.mini_apps.people_app.pricing_detail": "Diperlukan oleh Workforce dan Payroll.",
    "Required by Workforce and Payroll.": "Diperlukan oleh Workforce dan Payroll.",
    "navigation.mini_apps.workforce_app.title": "Workforce",
    "navigation.mini_apps.workforce_app.description": "Jadwal kerja, kehadiran, dan pengelolaan cuti untuk tim Anda.",
    "Shifts, attendance, and leave management for your team.": "Jadwal kerja, kehadiran, dan pengelolaan cuti untuk tim Anda.",
    "navigation.mini_apps.workforce_app.why_1": "Jadwalkan staf ke shift berdasarkan tanggal, waktu, dan lokasi",
    "Roster staff into shifts by date, time, and location": "Jadwalkan staf ke shift berdasarkan tanggal, waktu, dan lokasi",
    "navigation.mini_apps.workforce_app.why_2": "Catat waktu masuk dan keluar dengan riwayat kehadiran lengkap",
    "Clock in and out with a full attendance history": "Catat waktu masuk dan keluar dengan riwayat kehadiran lengkap",
    "navigation.mini_apps.workforce_app.why_3": "Kebijakan cuti, saldo, serta alur persetujuan atau penolakan",
    "Leave policies, balances, and an approve/reject workflow": "Kebijakan cuti, saldo, serta alur persetujuan atau penolakan",
    "navigation.mini_apps.workforce_app.pricing_label": "Harga belum ditentukan",
    "navigation.mini_apps.workforce_app.pricing_detail": "Mengaktifkan People secara otomatis.",
    "Turns on People automatically.": "Mengaktifkan People secara otomatis.",
    "navigation.mini_apps.payroll_app.title": "Penggajian",
    "navigation.mini_apps.payroll_app.description": "Proses penggajian, persetujuan, ekspor CSV, dan penggantian biaya.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Proses penggajian, persetujuan, ekspor CSV, dan penggantian biaya.",
    "navigation.mini_apps.payroll_app.why_1": "Buat penggajian per periode berdasarkan golongan gaji staf",
    "Create payroll runs per period from staff pay grades": "Buat penggajian per periode berdasarkan golongan gaji staf",
    "navigation.mini_apps.payroll_app.why_2": "Setujui penggajian dan ekspor sebagai CSV untuk bank atau akuntan Anda",
    "Approve runs and export them as CSV for your bank or accountant": "Setujui penggajian dan ekspor sebagai CSV untuk bank atau akuntan Anda",
    "navigation.mini_apps.payroll_app.why_3": "Kelola klaim biaya staf dari pengajuan hingga penggantian",
    "Staff expense claims from submission to reimbursement": "Kelola klaim biaya staf dari pengajuan hingga penggantian",
    "navigation.mini_apps.payroll_app.pricing_label": "Harga belum ditentukan",
    "navigation.mini_apps.payroll_app.pricing_detail": "Mengaktifkan People secara otomatis.",
    "navigation.mini_apps.unified_inbox.title": "Kotak Masuk Terpadu",
    "Unified Inbox": "Kotak Masuk Terpadu",
    "navigation.mini_apps.unified_inbox.description": "Semua komunikasi pelanggan — pesanan, dukungan, dan chat — di satu tempat.",
    "All your customer communication — orders, support, and chat — from one place.": "Semua komunikasi pelanggan — pesanan, dukungan, dan chat — di satu tempat.",
    "navigation.mini_apps.unified_inbox.why_1": "Pertanyaan pesanan, tiket dukungan, dan pesan pembeli dalam satu tampilan",
    "Order queries, support tickets, and buyer messages in one thread view": "Pertanyaan pesanan, tiket dukungan, dan pesan pembeli dalam satu tampilan",
    "navigation.mini_apps.unified_inbox.why_2": "Balas dengan saran AI yang dilatih berdasarkan katalog Anda",
    "Reply with AI-suggested responses trained on your catalogue": "Balas dengan saran AI yang dilatih berdasarkan katalog Anda",
    "navigation.mini_apps.unified_inbox.why_3": "Beri tag, tetapkan penanggung jawab, dan selesaikan percakapan bersama tim",
    "Tag, assign, and resolve conversations across your team": "Beri tag, tetapkan penanggung jawab, dan selesaikan percakapan bersama tim",
    "navigation.mini_apps.unified_inbox.pricing_label": "Koneksi",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Harga berbasis tugas per percakapan yang diselesaikan.",
    "Task-based pricing per resolved conversation.": "Harga berbasis tugas per percakapan yang diselesaikan.",
    "navigation.mini_apps.social_connect.title": "Social Connect",
    "Social Connect": "Social Connect",
    "navigation.mini_apps.social_connect.description": "Bagikan listing ke kanal sosial sesuai jadwal yang Anda tentukan.",
    "Share listings to social channels on a schedule you define.": "Bagikan listing ke kanal sosial sesuai jadwal yang Anda tentukan.",
    "navigation.mini_apps.social_connect.why_1": "Jadwalkan posting listing ke Instagram, Facebook, dan X secara otomatis",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Jadwalkan posting listing ke Instagram, Facebook, dan X secara otomatis",
    "navigation.mini_apps.social_connect.why_2": "Tentukan jadwal posting untuk tiap kanal — unggahan harian, flash sale, atau jadwal khusus",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Tentukan jadwal posting untuk tiap kanal — unggahan harian, flash sale, atau jadwal khusus",
    "navigation.mini_apps.social_connect.why_3": "Lacak klik dan interaksi untuk setiap listing dari dasbor",
    "Track clicks and engagement back to each listing from the dashboard": "Lacak klik dan interaksi untuk setiap listing dari dasbor",
    "navigation.mini_apps.social_connect.pricing_label": "Koneksi",
    "navigation.mini_apps.social_connect.pricing_detail": "Harga berbasis tugas per posting terjadwal yang dikirim.",
    "Task-based pricing per scheduled post delivered.": "Harga berbasis tugas per posting terjadwal yang dikirim.",
    "navigation.mini_apps.shopping_channels.title": "Kanal Belanja",
    "Shopping Channels": "Kanal Belanja",
    "navigation.mini_apps.shopping_channels.description": "Hubungkan katalog Anda ke TikTok Shop, Shopee, Meta Catalog, Uber Eats, dan lainnya.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Hubungkan katalog Anda ke TikTok Shop, Shopee, Meta Catalog, Uber Eats, dan lainnya.",
    "navigation.mini_apps.shopping_channels.why_1": "Sinkronkan listing Anda ke TikTok Shop, Shopee, dan Meta Catalog secara instan",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Sinkronkan listing Anda ke TikTok Shop, Shopee, dan Meta Catalog secara instan",
    "navigation.mini_apps.shopping_channels.why_2": "Hubungkan katalog makanan dan minuman ke Uber Eats dan Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Hubungkan katalog makanan dan minuman ke Uber Eats dan Grab",
    "navigation.mini_apps.shopping_channels.why_3": "Inventaris dan pesanan tersinkron otomatis — tanpa entri ganda",
    "Inventory and orders sync back automatically — no double-entry": "Inventaris dan pesanan tersinkron otomatis — tanpa entri ganda",
    "navigation.mini_apps.shopping_channels.pricing_label": "Koneksi",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Harga berbasis tugas per pesanan yang dipenuhi melalui kanal terhubung.",
    "Task-based pricing per order fulfilled through a connected channel.": "Harga berbasis tugas per pesanan yang dipenuhi melalui kanal terhubung.",
    "listing_configs.customize_table": "Sesuaikan tabel",
    "Customize table": "Sesuaikan tabel",
    "listing_configs.fields_visible": "Kolom yang terlihat di tabel",
    "Fields visible in table": "Kolom yang terlihat di tabel",
    "listing_configs.fields_hidden": "Kolom yang tidak ditampilkan",
    "Fields not shown in table": "Kolom yang tidak ditampilkan",
    "listing_configs.reset_default": "Atur ulang ke default",
    "listing_configs.column_title": "Judul",
    "listing_configs.column_actions": "Tindakan",
    "listing_configs.column_website": "Situs web",
    "listing_configs.column_list_price": "Harga daftar",
    "listing_configs.column_offer_percent": "Persentase penawaran",
    "Offer Percent": "Persentase penawaran",
    "listing_configs.column_image": "Gambar",
    "listing_configs.column_offer_price": "Harga penawaran",
    "Offer Price": "Harga penawaran",
    "listing_configs.column_status": "Status",
    "listing_configs.column_listing_id": "ID listing",
    "listing_configs.column_listing_status": "Status listing",
    "listing_configs.column_accounts": "Akun",
    "listing_configs.column_currency": "Mata uang",
    "listing_configs.column_sold": "Terjual",
    "listing_configs.column_goal_amount": "Jumlah target",
    "Goal Amount": "Jumlah target",
    "listing_configs.column_width": "Lebar",
    "listing_configs.column_height": "Tinggi",
    "listing_configs.column_weight": "Berat",
    "listing_configs.column_volume": "Volume",
    "Volume": "Volume",
    "listing_configs.column_order_type": "Jenis pesanan",
    "Order Type": "Jenis pesanan",
    "navigation.apps_group": "Aplikasi",
    "navigation.channels_group": "Kanal",
    "navigation.manage_mini_apps": "Kelola Mini Apps",
    "Manage Mini Apps": "Kelola Mini Apps",
    "navigation.manage_channels": "Kelola kanal",
    "Manage Channels": "Kelola kanal",
    "listings.import.uploading": "Mengunggah...",
    "listings.import.complete": "Impor selesai",
    "listings.import.error": "Kesalahan: {message}",
    "Error: {message}": "Kesalahan: {message}",
    "listings.import.file_label": "File:",
    "listings.import.select_file": "Pilih file",
    "listings.import.response": "Respons impor",
    "Import response": "Respons impor",
    "listings.import.total_rows": "Total baris:",
    "Total rows:": "Total baris:",
    "listings.import.total_imported": "Total diimpor:",
    "Total imported:": "Total diimpor:",
    "listings.import.download_template": "Unduh template listing",
    "Download listings template": "Unduh template listing",
    "common.upload": "Unggah",
    "common.kanban_unavailable": "Tampilan papan sementara tidak tersedia",
    "Board view is temporarily unavailable": "Tampilan papan sementara tidak tersedia",
    "common.retry": "Coba lagi",
    "Retry": "Coba lagi",
    "listings.digital_assets.title": "Aset digital",
    "Digital assets": "Aset digital",
    "listings.digital_assets.not_found": "Aset digital tidak ditemukan",
    "Digital assets not found": "Aset digital tidak ditemukan",
    "listings.addon.saved": "Add-on berhasil disimpan.",
    "Add-on saved successfully.": "Add-on berhasil disimpan.",
    "listings.addon.title_required": "Masukkan judul.",
    "Please enter a title.": "Masukkan judul.",
    "listings.addon.price_required": "Masukkan harga.",
    "Please enter a price.": "Masukkan harga.",
    "listings.addon.no_media": "Anda tidak memiliki file media.",
    "listings.addon.price": "Harga",
    "listings.addon.offer_percentage": "Persentase penawaran",
    "Offer Percentage": "Persentase penawaran",
    "listings.addon.maximum_quantity": "Jumlah maksimum",
    "Maximum Quantity": "Jumlah maksimum",
    "listings.addon.stock": "Stok",
    "listings.addon.enter_price": "Masukkan harga",
    "Enter price": "Masukkan harga",
    "listings.addon.enter_offer_percentage": "Masukkan persentase penawaran",
    "Enter offer percentage": "Masukkan persentase penawaran",
    "listings.addon.enter_maximum_quantity": "Masukkan jumlah maksimum",
    "Enter maximum quantity": "Masukkan jumlah maksimum",
    "listings.addon.enter_stock": "Masukkan stok",
    "listings.addon.edit_title": "Edit add-on",
    "Edit Add-on": "Edit add-on",
    "listings.addon.add_title": "Tambah add-on",
    "Add Add-on": "Tambah add-on",
    "listings.addon.title": "Judul",
    "listings.addon.enter_title": "Masukkan judul",
    "listings.addon.status": "Status (Nonaktif / Aktif)",
    "listings.addon.upload_media": "Unggah media",
    "attributes.prefill_for": "Isi awal untuk",
    "Prefill for": "Isi awal untuk",
    "attributes.first_item": "Item pertama",
    "First Item": "Item pertama",
    "attributes.all_items": "Semua item",
    "All Items": "Semua item",
    "common.uploading": "Mengunggah...",
    "common.uploading_named": "Mengunggah {title}",
    "Uploading {title}": "Mengunggah {title}",
    "common.please_wait_short": "Harap tunggu",
    "Please wait": "Harap tunggu",
    "attributes.select_option": "Pilih",
    "attributes.select_value": "Pilih nilai...",
    "Select value...": "Pilih nilai...",
    "attributes.type_placeholder": "Ketik {name}",
    "Type {name}": "Ketik {name}",
    "attributes.multiple_values_placeholder": "Gunakan koma untuk memasukkan beberapa nilai.",
    "Using a comma, you can enter several values.": "Gunakan koma untuk memasukkan beberapa nilai.",
    "attributes.upload_attachment": "Unggah lampiran",
    "Upload Attachment": "Unggah lampiran",
    "attributes.upload_json_file": "Unggah file JSON",
    "Upload JSON File": "Unggah file JSON",
    "attributes.copied_value": "Nilai berhasil disalin",
    "Copied the value": "Nilai berhasil disalin",
    "attributes.latitude_longitude_placeholder": "Masukkan lintang,bujur (mis. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Masukkan lintang,bujur (mis. 12.34,56.78)",
    "navigation.sidebar_label": "Bilah samping",
    "Side bar": "Bilah samping",
    "checkout_settings.orders_option_0": "Kalender pesanan",
    "Orders Calendar View": "Kalender pesanan",
    "checkout_settings.show_cart_attributes": "Tampilkan atribut keranjang",
    "Show cart attributes": "Tampilkan atribut keranjang",
    "checkout_settings.select_order_status": "Pilih status pesanan",
    "Select order status": "Pilih status pesanan",
    "checkout_settings.order_status_0": "Berhasil dibuat",
    "Placed success": "Berhasil dibuat",
    "checkout_settings.order_status_1": "Sedang diproses",
    "In process": "Sedang diproses",
    "checkout_settings.order_status_2": "Dikirim",
    "checkout_settings.order_status_3": "Terkirim",
    "checkout_settings.order_status_4": "Selesai",
    "listing_form.no_categories_found": "Kategori tidak ditemukan. Gunakan “{action}” di atas.",
    "No categories found. Use “{action}” above.": "Kategori tidak ditemukan. Gunakan “{action}” di atas.",
    "common.learn_more": "Pelajari lebih lanjut",
    "Learn more": "Pelajari lebih lanjut",
    "common.show_information": "Tampilkan informasi",
    "Show information": "Tampilkan informasi",
    "common.paid_feature": "Fitur berbayar",
    "Paid Feature": "Fitur berbayar",
    "common.learn_more_about": "Pelajari selengkapnya tentang",
    "Learn more about": "Pelajari selengkapnya tentang",
    "attributes.categories": "Kategori",
    "attributes.edit_bulk_title": "Edit massal {title}",
    "{title} Edit Bulk": "Edit massal {title}",
    "common.enter_description": "Masukkan deskripsi",
    "common.empty_fetch_message": "Belum ada yang ditampilkan di sini. Setelah konten tersedia, konten akan muncul di halaman ini.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Belum ada yang ditampilkan di sini. Setelah konten tersedia, konten akan muncul di halaman ini.",
    "common.ai_credits_and_top_up": "Kredit AI dan isi ulang",
    "AI credits and top up": "Kredit AI dan isi ulang",
    "common.ai_credits_loading": "Memuat kredit AI",
    "Loading AI credits": "Memuat kredit AI",
    "common.ai_credits_unavailable": "Kredit AI tidak tersedia",
    "AI credits unavailable": "Kredit AI tidak tersedia",
    "common.ai_credits_available": "Kredit AI tersedia: {count}",
    "Available AI credits: {count}": "Kredit AI tersedia: {count}",
    "common.ai_credits_unavailable_top_up": "Kredit AI tidak tersedia — klik untuk mengisi ulang",
    "AI credits unavailable — click to top up": "Kredit AI tidak tersedia — klik untuk mengisi ulang",
    "common.ai_credits_available_top_up": "Kredit AI tersedia: {count} — klik untuk menambah kredit",
    "Available AI credits: {count} — click to add credits": "Kredit AI tersedia: {count} — klik untuk menambah kredit",
    "common.ai_credits_add": "Tambah kredit",
    "Add credits": "Tambah kredit",
    "navigation.switch_project": "Ganti proyek",
    "Switch Project": "Ganti proyek",
    "navigation.tenant_switch_failed": "Gagal mengganti tenant. Silakan coba lagi.",
    "Tenant switch failed. Please try again.": "Gagal mengganti tenant. Silakan coba lagi.",
    "navigation.select_project": "Pilih proyek",
    "Select Project": "Pilih proyek",
    "navigation.collapse_sidebar": "Ciutkan bilah samping",
    "Collapse sidebar": "Ciutkan bilah samping",
    "navigation.expand_sidebar": "Perluas bilah samping",
    "Expand sidebar": "Perluas bilah samping",
    "navigation.search": "Cari",
    "navigation.loading": "Memuat navigasi",
    "Loading navigation": "Memuat navigasi",
    "navigation.help_documentation": "Dokumentasi",
    "navigation.help_community": "Komunitas",
    "navigation.help_api_reference": "Referensi API",
    "listings.quick_form": "Formulir cepat",
    "Quick Form": "Formulir cepat",
    "payments.notification_secret": "Rahasia notifikasi",
    "Notification Secret": "Rahasia notifikasi",
    "payments.user_type": "Jenis pengguna",
    "User Type": "Jenis pengguna",
    "payments.category_id": "ID kategori",
    "app_customization.other_settings": "Pengaturan lainnya",
    "Other Settings": "Pengaturan lainnya",
    "app_customization.other_hide_balances": "Sembunyikan saldo & pembayaran di bagian lainnya",
    "app_customization.other_enable_logs": "Aktifkan log",
    "Enable logs": "Aktifkan log",
    "app_customization.other_signup_first": "Dapatkan pendaftaran terlebih dahulu",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Gambar yang dipilih",
    "Selected image": "Gambar yang dipilih",
    "common.ai_no_response_to_copy": "Tidak ada respons untuk disalin",
    "No response to copy": "Tidak ada respons untuk disalin",
    "common.copied_to_clipboard": "Disalin ke papan klip",
    "Copied to clipboard": "Disalin ke papan klip",
    "common.ai_suggestions": "Saran",
    "Suggestions": "Saran",
    "common.regenerate": "Buat ulang",
    "Regenerate": "Buat ulang",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "Ikon JSON",
    "JSON icon": "Ikon JSON",
    "collections.generator_title": "Generator Koleksi",
    "Collection Generator": "Generator Koleksi",
    "collections.generator_create": "Buat koleksi",
    "collections.generator_json_placeholder": "Masukkan input JSON",
    "Enter JSON input": "Masukkan input JSON",
    "collections.generator_invalid_data": "Masukkan data yang valid",
    "Please enter valid data": "Masukkan data yang valid",
    "category.editor_select_from_media": "Pilih dari media",
    "payments.subscription": "Langganan",
    "payments.subscription_setting_up": "Menyiapkan...",
    "Setting up...": "Menyiapkan...",
    "payments.subscription_webhook_configured": "Webhook langganan dikonfigurasi",
    "Subscription webhook configured": "Webhook langganan dikonfigurasi",
    "payments.subscription_retry_setup": "Coba siapkan lagi",
    "Retry setup": "Coba siapkan lagi",
    "payments.setup_subscription_webhook": "Siapkan webhook langganan",
    "Setup Subscription Webhook": "Siapkan webhook langganan",
    "orders.shipment_number": "Pengiriman {number}",
    "Shipment {number}": "Pengiriman {number}",
    "orders.quantity_short": "JML",
    "orders.shipment_status_1": "Pengiriman dibuat",
    "orders.shipment_status_2": "Pengiriman sedang diproses",
    "orders.shipment_status_3": "Dikirim",
    "orders.shipment_status_4": "Siap diambil",
    "orders.shipment_status_5": "Sedang diantar",
    "orders.shipment_status_6": "Pengembalian kiriman gagal antar",
    "orders.shipment_status_7": "Pengiriman terkirim",
    "orders.shipment_status_8": "Pengiriman telah dikonfirmasi",
    "orders.shipment_status_9": "Pengembalian dimulai",
    "orders.shipment_status_10": "Dikembalikan untuk diambil",
    "orders.shipment_status_11": "Pengembalian pengiriman dikonfirmasi",
    "orders.shipment_status_12": "Dibatalkan oleh penjual",
    "orders.shipment_status_13": "Dibatalkan oleh pelanggan",
    "orders.shipment_status_14": "Tiba di lokasi pelanggan",
    "orders.shipment_status_15": "Dibatalkan oleh admin",
    "attributes.metadata_title": "Metadata",
    "Metadata": "Metadata",
    "common.add_row": "Tambahkan baris",
    "common.no_access": "Anda tidak memiliki akses",
    "You don't have access": "Anda tidak memiliki akses",
    "common.error_404_message": "Maaf, halaman yang Anda cari saat ini tidak tersedia. Periksa URL dan coba lagi, atau kembali nanti. Jika masalah berlanjut, hubungi dukungan.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "Maaf, halaman yang Anda cari saat ini tidak tersedia. Periksa URL dan coba lagi, atau kembali nanti. Jika masalah berlanjut, hubungi dukungan.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "Arah transaksi",
    "Transaction direction": "Arah transaksi",
    "category.default_text": "Teks default",
    "collections.generator_open": "Buka generator koleksi",
    "Open collection generator": "Buka generator koleksi",
    "collections.duplicate_success": "Koleksi berhasil diduplikasi",
    "Collection duplicated successfully": "Koleksi berhasil diduplikasi",
    "collections.duplicate_failed": "Gagal menduplikasi koleksi",
    "Failed to duplicate collection": "Gagal menduplikasi koleksi",
    "listings.name_required": "Nama listing wajib diisi",
    "Listing Name is required": "Nama listing wajib diisi",
    "listings.category_required": "Kategori wajib diisi",
    "Category is required": "Kategori wajib diisi",
    "attribute_groups.edit_title": "Edit grup atribut",
    "Edit Attribute Group": "Edit grup atribut",
    "orders.create_order.validation.select_shipping_method": "Pilih metode pengiriman",
    "Please select shipping method": "Pilih metode pengiriman",
    "orders.create_order.validation.shipping_method_error": "Kesalahan metode pengiriman",
    "Shipping Method Error": "Kesalahan metode pengiriman",
    "orders.create_order.validation.select_shipping_address": "Pilih alamat pengiriman",
    "Please select shipping address": "Pilih alamat pengiriman",
    "orders.create_order.validation.shipping_address_error": "Kesalahan alamat pengiriman",
    "Shipping Address Error": "Kesalahan alamat pengiriman",
    "orders.create_order.validation.select_shipment_method": "Pilih metode pengiriman",
    "Please select shipment method": "Pilih metode pengiriman",
    "orders.create_order.validation.shipment_method_error": "Kesalahan metode pengiriman",
    "Shipment Method Error": "Kesalahan metode pengiriman",
    "orders.create_order.validation.select_payment_method": "Pilih metode pembayaran",
    "Please select payment method": "Pilih metode pembayaran",
    "orders.create_order.validation.payment_method_error": "Kesalahan metode pembayaran",
    "Payment Method Error": "Kesalahan metode pembayaran",
    "orders.create_order.validation.insufficient_balance": "Saldo tidak mencukupi",
    "Insufficient balance": "Saldo tidak mencukupi",
    "orders.create_order.validation.wallet_error": "Kesalahan dompet",
    "Wallet Error": "Kesalahan dompet",
    "attributes.value.preview_item": "Pratinjau {count}",
    "Preview {count}": "Pratinjau {count}",
    "attributes.value.click_to_upload": "Klik untuk mengunggah {type}",
    "Click to upload {type}": "Klik untuk mengunggah {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF hingga 5 file",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF hingga 5 file",
    "attributes.value.audio_upload_formats": "MP3, WAV hingga 1 file",
    "MP3, WAV up to 1 file": "MP3, WAV hingga 1 file",
    "attributes.value.video_upload_formats": "MP4, MOV hingga 1 file",
    "MP4, MOV up to 1 file": "MP4, MOV hingga 1 file",
    "attributes.value.upload_limit": "Unggah file {type} (maks. {count})",
    "Upload {type} files (Max {count})": "Unggah file {type} (maks. {count})",
    "attributes.value.json_format_failed": "JSON tidak valid - tidak dapat diformat",
    "Invalid JSON - cannot format": "JSON tidak valid - tidak dapat diformat",
    "attributes.value.json_file_invalid": "Pilih file JSON yang valid",
    "Please select a valid JSON file": "Pilih file JSON yang valid",
    "attributes.value.file_empty": "File kosong",
    "File is empty": "File kosong",
    "attributes.value.json_file_parse_failed": "File JSON tidak valid: {message}",
    "Invalid JSON file: {message}": "File JSON tidak valid: {message}",
    "attributes.value.file_read_failed": "Gagal membaca file",
    "Failed to read file": "Gagal membaca file",
    "attributes.value.invalid_json": "JSON tidak valid",
    "Invalid JSON": "JSON tidak valid",
    "attributes.value.json_editor_help": "Unggah file JSON atau ketik/tempel JSON langsung",
    "Upload a JSON file or type/paste JSON directly": "Unggah file JSON atau ketik/tempel JSON langsung",
    "attributes.value.hex_color_code": "Kode warna heksadesimal",
    "Hex Color Code": "Kode warna heksadesimal",
    "attributes.value.multi_text_placeholder": "Ketik lalu tekan Enter atau koma untuk menambahkan",
    "Type and press Enter or comma to add": "Ketik lalu tekan Enter atau koma untuk menambahkan",
    "attributes.value.multi_text_help": "Tekan Enter atau koma untuk menambahkan setiap item",
    "Press Enter or comma to add each item": "Tekan Enter atau koma untuk menambahkan setiap item",
    "attributes.value.item_count": "{count} item",
    "{count} item": "{count} item",
    "attributes.value.items_count": "{count} item",
    "attributes.value.search_options": "Cari {name}...",
    "Search {name}...": "Cari {name}...",
    "attributes.value.selected_count": "{count} dipilih",
    "attributes.value.no_options_found": "Tidak ada opsi ditemukan",
    "No options found": "Tidak ada opsi ditemukan",
    "attributes.value.select_named_option": "Pilih {name}",
    "Select {name}": "Pilih {name}",
    "attributes.value.enable_option": "Aktifkan opsi ini",
    "Enable this option": "Aktifkan opsi ini",
    "attributes.value.enter_named_value": "Masukkan {name}",
    "Enter {name}": "Masukkan {name}",
    "common.valid": "Valid",
    "Valid": "Valid",
    "common.invalid": "Tidak valid",
    "Invalid": "Tidak valid",
    "common.go_back_home": "Kembali ke beranda",
    "Go back home": "Kembali ke beranda",
    "attributes.value.enter_named_text": "Masukkan {name}...",
    "Enter {name}...": "Masukkan {name}...",
    "listings.analytics.page_views": "Tampilan halaman",
    "listings.analytics.unique_visitors": "Pengunjung unik",
    "listings.analytics.sessions": "Sesi",
    "listings.analytics.clicks": "Klik",
    "listings.analytics.goals": "Target",
    "listings.analytics.bot_views": "Tampilan bot",
    "listings.detail_summary.buyers": "Pembeli",
    "Buyers": "Pembeli",
    "listings.detail_summary.orders": "Pesanan",
    "listings.detail_summary.revenue": "Pendapatan",
    "listings.detail_summary.average_order": "Rata-rata pesanan",
    "listings.add_advanced": "Lanjutan",
    "listings.add_audio": "Tambah audio",
    "Add Audio": "Tambah audio",
    "payments.updated_successfully": "Berhasil diperbarui",
    "Updated successfully": "Berhasil diperbarui",
    "users.deleted_successfully": "Pengguna berhasil dihapus",
    "User deleted successfully": "Pengguna berhasil dihapus",
    "users.deletion_failed": "Penghapusan pengguna gagal",
    "User deletion failed": "Penghapusan pengguna gagal",
    "accounts.flow.title": "Atur pengalaman akun",
    "Shape the account experience": "Atur pengalaman akun",
    "accounts.flow.description": "Atur jenis akun dan tentukan informasi yang dibutuhkan setiap akun.",
    "Organize account types and define the information each account needs.": "Atur jenis akun dan tentukan informasi yang dibutuhkan setiap akun.",
    "accounts.flow.lane_title": "Dasar akun",
    "Account foundation": "Dasar akun",
    "accounts.flow.badge": "Struktur",
    "Structure": "Struktur",
    "accounts.flow.node_accounts": "Akun",
    "accounts.flow.node_categories": "Kategori",
    "accounts.flow.node_attributes": "Atribut",
    "accounts.flow.lane_description": "Berikan setiap akun tempat, jenis, dan detail yang berguna.",
    "Give every account a clear place, type, and set of useful details.": "Berikan setiap akun tempat, jenis, dan detail yang berguna.",
    "accounts.flow.primary_action": "Tambahkan akun pertama",
    "Add your first account": "Tambahkan akun pertama",
    "listings.flow.title": "Bangun katalog listing",
    "Build your listing catalog": "Bangun katalog listing",
    "listings.flow.description": "Buat katalog terstruktur dengan kategori, atribut, dan varian.",
    "Create a structured catalog with categories, attributes, and variants.": "Buat katalog terstruktur dengan kategori, atribut, dan varian.",
    "listings.flow.lane_title": "Jalur katalog",
    "Catalog path": "Jalur katalog",
    "listings.flow.badge": "Bangun",
    "Build": "Bangun",
    "listings.flow.node_listings": "Listing",
    "listings.flow.node_categories": "Kategori",
    "listings.flow.node_attributes": "Atribut",
    "listings.flow.node_variants": "Varian",
    "listings.flow.lane_description": "Tentukan apa yang Anda jual dan informasi yang dibutuhkan pelanggan untuk memilih.",
    "Define what you sell and the information customers need to make a choice.": "Tentukan apa yang Anda jual dan informasi yang dibutuhkan pelanggan untuk memilih.",
    "listings.flow.primary_action": "Tambahkan listing pertama",
    "Add your first listing": "Tambahkan listing pertama",
    "collections.flow.title": "Satukan konten marketplace Anda",
    "Bring your marketplace content together": "Satukan konten marketplace Anda",
    "collections.flow.description": "Kelompokkan listing dan akun ke dalam koleksi pilihan yang mudah ditemukan dan dikelola.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Kelompokkan listing dan akun ke dalam koleksi pilihan yang mudah ditemukan dan dikelola.",
    "collections.flow.lane_title": "Jalur koleksi",
    "Collection path": "Jalur koleksi",
    "collections.flow.badge": "Kurasi",
    "Curate": "Kurasi",
    "collections.flow.node_collections": "Koleksi",
    "collections.flow.node_rules": "Aturan",
    "collections.flow.node_listings": "Listing",
    "collections.flow.lane_description": "Tentukan item yang dikelompokkan agar pelanggan mudah menemukannya.",
    "Choose what belongs together and make it easy for customers to find.": "Tentukan item yang dikelompokkan agar pelanggan mudah menemukannya.",
    "collections.flow.audience_lane_title": "Jalur audiens",
    "Audience path": "Jalur audiens",
    "collections.flow.audience_badge": "Hubungkan",
    "collections.flow.node_accounts": "Akun",
    "collections.flow.node_users": "Pengguna",
    "collections.flow.node_storefront": "Etalase",
    "Storefront": "Etalase",
    "collections.flow.audience_description": "Hubungkan konten pilihan dengan orang dan etalase yang dituju.",
    "Connect curated content to the people and storefronts it is meant for.": "Hubungkan konten pilihan dengan orang dan etalase yang dituju.",
    "collections.flow.primary_action": "Buat koleksi pertama",
    "listings.addon.image_limit": "Anda tidak dapat memilih lebih banyak gambar",
    "listings.schedule.start_time_before_end": "Waktu mulai harus sebelum waktu selesai",
    "Start time must be before the end time": "Waktu mulai harus sebelum waktu selesai",
    "listings.schedule.end_time_after_start": "Waktu selesai harus setelah waktu mulai",
    "End time must be after the start time": "Waktu selesai harus setelah waktu mulai",
    "listings.schedule.repeat_required": "Pilih pola pengulangan",
    "Select a repeat pattern": "Pilih pola pengulangan",
    "listing_variants.form.select_type": "Pilih jenis varian",
    "Select variant type": "Pilih jenis varian",
    "listing_variants.form.select_type_values": "Pilih nilai varian",
    "Select variant values": "Pilih nilai varian",
    "listing_variants.form.add_variant": "Tambah varian",
    "listing_variants.form.edit_variant": "Edit varian",
    "Edit variant": "Edit varian",
    "listing_variants.form.variant_type": "Jenis varian",
    "Variant type": "Jenis varian",
    "listing_variants.form.variant_type_value": "Nilai varian",
    "Variant value": "Nilai varian",
    "listing_variants.form.variant_name": "Nama varian",
    "Variant name": "Nama varian",
    "listing_variants.form.description_placeholder": "Masukkan deskripsi",
    "rewards.item_archived": "Diarsipkan",
    "listings.confirm_delete_variant": "Yakin ingin menghapus varian ini?",
    "listings.confirm_delete_listing": "Yakin ingin menghapus listing ini?",
    "listing_form.digital_delete_confirm": "Yakin ingin menghapus konten digital ini?",
    "Are you sure you want to delete this digital content?": "Yakin ingin menghapus konten digital ini?",
    "category.confirm_delete_attribute": "Hapus atribut ini?",
    "common.permission_required": "Anda tidak memiliki izin untuk melakukan tindakan ini.",
    "You do not have permission to perform this action.": "Anda tidak memiliki izin untuk melakukan tindakan ini.",
    "common.copied": "Disalin",
    "attributes.editor_name_required": "Masukkan nama atribut",
    "onboarding.full_step.setup_payments.description": "Aktifkan transaksi nyata agar pengguna dapat menyelesaikan pembelian dengan mudah.",
    "Enable real transactions so users can complete intent without friction.": "Aktifkan transaksi nyata agar pengguna dapat menyelesaikan pembelian dengan mudah.",
    "onboarding.full_step.setup_payments.cta": "Siapkan pembayaran",
    "Setup payments": "Siapkan pembayaran",
    "onboarding.full_step.setup_payments.impact": "Alur pendapatan diaktifkan.",
    "Revenue path enabled.": "Alur pendapatan diaktifkan.",
    "onboarding.full_step.setup_payments.creator_description": "Siapkan audiens Anda untuk membeli atau mendukung karya Anda.",
    "Prepare the path for your audience to purchase or support your work.": "Siapkan audiens Anda untuk membeli atau mendukung karya Anda.",
    "onboarding.full_step.setup_delivery.description": "Tentukan cara pesanan dipenuhi agar proses checkout dapat diprediksi pengguna.",
    "onboarding.full_step.setup_delivery.impact": "Alur pemenuhan jelas.",
    "Fulfillment path clear.": "Alur pemenuhan jelas.",
    "onboarding.full_step.add_promotion.description": "Buat promosi pertama untuk meningkatkan tindakan pada sesi pertama.",
    "Create your first promotion to increase first-session action rate.": "Buat promosi pertama untuk meningkatkan tindakan pada sesi pertama.",
    "onboarding.full_step.add_promotion.impact": "Konversi lebih tinggi saat peluncuran.",
    "Stronger conversion during launch.": "Konversi lebih tinggi saat peluncuran.",
    "onboarding.full_step.create_coupon.description": "Uji diskon dan tingkatkan aktivasi pembeli atau anggota baru.",
    "Test discounts and improve activation for first-time buyers or members.": "Uji diskon dan tingkatkan aktivasi pembeli atau anggota baru.",
    "onboarding.full_step.create_coupon.impact": "Siklus penawaran pertama terbuka.",
    "First-offer loop unlocked.": "Siklus penawaran pertama terbuka.",
    "onboarding.full_step.collections_setup.description": "Kelompokkan listing yang diminati agar lebih mudah ditemukan dan dijelajahi.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Kelompokkan listing yang diminati agar lebih mudah ditemukan dan dijelajahi.",
    "onboarding.full_step.collections_setup.impact": "Navigasi dan penemuan meningkat.",
    "Navigation and discovery improved.": "Navigasi dan penemuan meningkat.",
    "onboarding.full_step.configure_comms.description": "Siapkan notifikasi setelah pendaftaran dan pesanan sebelum bisnis berkembang.",
    "Make post-signup and order notifications production-ready before growth.": "Siapkan notifikasi setelah pendaftaran dan pesanan sebelum bisnis berkembang.",
    "onboarding.full_step.configure_comms.impact": "Pesan siklus hidup siap.",
    "Lifecycle messaging ready.": "Pesan siklus hidup siap.",
    "onboarding.full_step.customize_attributes.description": "Tambahkan kolom terstruktur agar pengguna dapat memfilter dan membandingkan hal penting.",
    "onboarding.full_step.customize_attributes.impact": "Pencarian dan konversi meningkat.",
    "Better search and conversion.": "Pencarian dan konversi meningkat.",
    "onboarding.full_step.customize_attributes.creator_description": "Tambahkan detail untuk membantu orang memahami dan membandingkan karya Anda.",
    "Add the details that help people understand and compare what you create.": "Tambahkan detail untuk membantu orang memahami dan membandingkan karya Anda.",
    "onboarding.full_step.add_digital_asset.description": "Perluas katalog awal agar pengguna dapat menilai kualitas dan pilihan.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Perluas katalog awal agar pengguna dapat menilai kualitas dan pilihan.",
    "onboarding.full_step.add_digital_asset.impact": "Kredibilitas katalog digital meningkat.",
    "Digital catalog credibility improved.": "Kredibilitas katalog digital meningkat.",
    "onboarding.full_step.open_live_site.description": "Mulai dari hal yang dilihat pelanggan. Ini membuat produk terasa nyata sebelum pengaturan menjadi abstrak.",
    "onboarding.full_step.open_live_site.impact": "Memastikan proyek sudah aktif.",
    "onboarding.full_step.add_first_product.description": "Terbitkan produk, layanan, atau sumber daya pertama yang ingin Anda tampilkan kepada audiens.",
    "Publish the first product, service, or resource you want your audience to discover.": "Terbitkan produk, layanan, atau sumber daya pertama yang ingin Anda tampilkan kepada audiens.",
    "onboarding.full_step.add_first_product.impact": "Penawaran pertama siap untuk audiens.",
    "Creates your first audience-ready offer.": "Penawaran pertama siap untuk audiens.",
    "onboarding.full_step.customize_attributes.creator_impact": "Penawaran Anda lebih mudah dipahami.",
    "Makes your offer easier to understand.": "Penawaran Anda lebih mudah dipahami.",
    "onboarding.full_step.setup_payments.creator_impact": "Membuka jalur menuju pendapatan.",
    "listings.detail_preview_fx.title": "Pratinjau FX",
    "Preview FX": "Pratinjau FX",
    "listings.detail_preview_fx.base": "Mata uang dasar",
    "Base": "Mata uang dasar",
    "listings.detail_preview_fx.description": "Lihat listing ini dalam setiap mata uang aktif.",
    "See this listing in each active currency.": "Lihat listing ini dalam setiap mata uang aktif.",
    "listings.detail_preview_fx.refresh": "Segarkan pratinjau",
    "Refresh preview": "Segarkan pratinjau",
    "listings.detail_preview_fx.loading_rates": "Memuat nilai tukar…",
    "Loading exchange rates…": "Memuat nilai tukar…",
    "listings.detail_preview_fx.load_hint": "Pilih Pratinjau FX untuk memuat kurs terkini.",
    "Select Preview FX to load current rates.": "Pilih Pratinjau FX untuk memuat kurs terkini.",
    "listings.detail_preview_fx.preview_note": "Hanya pratinjau. Harga listing yang tersimpan tidak berubah.",
    "Preview only. Saved listing prices remain unchanged.": "Hanya pratinjau. Harga listing yang tersimpan tidak berubah.",
    "listings.detail_preview_fx.listing": "Listing",
    "listings.detail_preview_fx.variant": "Varian",
    "Variant": "Varian",
    "listings.detail_event_booking.event_details": "Detail acara",
    "Event Details": "Detail acara",
    "listings.detail_event_booking.booking_details": "Detail pemesanan",
    "Booking Details": "Detail pemesanan",
    "listings.unassigned_location": "Lokasi belum ditetapkan",
    "Unassigned location": "Lokasi belum ditetapkan",
    "listings.no_ratings_yet": "Belum ada penilaian",
    "No ratings yet": "Belum ada penilaian",
    "listing_form.loading_listing": "Memuat listing…",
    "Loading listing…": "Memuat listing…",
    "listing_form.preparing_form": "Menyiapkan formulir…",
    "Preparing form…": "Menyiapkan formulir…",
    "listing_form.edit_listing": "Edit listing",
    "Edit Listing": "Edit listing",
    "listing_form.add_new_listing": "Tambah listing baru",
    "Add New Listing": "Tambah listing baru",
    "workspace.catalog.templates": "Template",
    "Templates": "Template",
    "workspace.catalog.integrations": "Integrasi",
    "workspace.catalog.template": "Template",
    "Template": "Template",
    "workspace.catalog.integration": "Integrasi",
    "workspace.catalog.templates_heading": "Pilih template untuk memulai Ide Anda",
    "Choose a template to kickstart your Idea": "Pilih template untuk memulai Ide Anda",
    "workspace.catalog.integrations_heading": "Integrasi untuk aplikasi web yang di-host",
    "Integrations for Hosted Web Apps": "Integrasi untuk aplikasi web yang di-host",
    "workspace.catalog.templates_description": "Mulai dengan template siap pakai untuk marketplace Anda.",
    "Start with a prebuilt template and customise it for your marketplace.": "Mulai dengan template siap pakai untuk marketplace Anda.",
    "workspace.catalog.integrations_description": "Hubungkan ruang kerja dengan alat dan layanan yang sudah Anda gunakan.",
    "Connect your workspace to the tools and services you already use.": "Hubungkan ruang kerja dengan alat dan layanan yang sudah Anda gunakan.",
    "workspace.catalog.no_templates": "Saat ini tidak ada template.",
    "No templates available at the moment.": "Saat ini tidak ada template.",
    "workspace.catalog.no_integrations": "Saat ini tidak ada integrasi.",
    "No integrations available at the moment.": "Saat ini tidak ada integrasi.",
    "workspace.catalog.coming_soon": "Segera hadir",
    "Coming Soon": "Segera hadir",
    "workspace.catalog.configure": "Konfigurasikan",
    "workspace.catalog.custom_development": "Pengembangan {type} khusus",
    "Custom {type} Development": "Pengembangan {type} khusus",
    "workspace.catalog.custom_help": "Butuh sesuatu yang khusus? Hubungi kami untuk mendapatkan penawaran.",
    "Looking for something custom? Contact us for a quote.": "Butuh sesuatu yang khusus? Hubungi kami untuk mendapatkan penawaran.",
    "workspace.catalog.contact_quote": "Hubungi untuk penawaran",
    "Contact for a Quote": "Hubungi untuk penawaran",
    "users.select_user": "Pilih pengguna",
    "Select User": "Pilih pengguna",
    "developer.api_keys.paid_feature_title": "Akses API adalah fitur berbayar",
    "API access is a paid feature": "Akses API adalah fitur berbayar",
    "developer.api_keys.paid_feature_description": "Pilih paket berbayar untuk melihat, menyalin, dan menggunakan Publishable Key dan Secret Key.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Pilih paket berbayar untuk melihat, menyalin, dan menggunakan Publishable Key dan Secret Key.",
    "developer.api_keys.available_on_paid_plans": "Tersedia pada paket berbayar",
    "Available on paid plans": "Tersedia pada paket berbayar",
    "developer.api_keys.view_plans": "Lihat paket",
    "currency.rates.title": "Nilai tukar saat ini",
    "Current FX rates": "Nilai tukar saat ini",
    "currency.rates.base": "Mata uang dasar:",
    "Base:": "Mata uang dasar:",
    "currency.rates.source": "· Sumber:",
    "· Source:": "· Sumber:",
    "currency.rates.cached_up_to": "Disimpan hingga {hours} jam",
    "Cached up to {hours}h": "Disimpan hingga {hours} jam",
    "currency.rates.refresh": "Segarkan nilai tukar",
    "Refresh rates": "Segarkan nilai tukar",
    "currency.rates.currency": "Mata uang",
    "currency.rates.one_base_equals": "1 {code} setara dengan",
    "1 {code} equals": "1 {code} setara dengan",
    "currency.rates.empty": "Tambahkan mata uang aktif untuk melihat nilai tukarnya.",
    "Add an active currency to see its exchange rate.": "Tambahkan mata uang aktif untuk melihat nilai tukarnya.",
    "currency.rates.manual": "Nilai tukar manual",
    "Manual rates": "Nilai tukar manual",
    "currency.rates.load_error": "Tidak dapat memuat nilai tukar.",
    "Unable to load exchange rates.": "Tidak dapat memuat nilai tukar.",
    "chats.title": "Chat pelanggan",
    "Customer chat": "Chat pelanggan",
    "chats.conversations": "Percakapan",
    "Conversations": "Percakapan",
    "chats.empty_conversations": "Belum ada percakapan pelanggan.",
    "No customer conversations yet.": "Belum ada percakapan pelanggan.",
    "chats.customer_id": "Pelanggan {id}",
    "Customer {id}": "Pelanggan {id}",
    "chats.no_messages_yet": "Belum ada pesan",
    "No messages yet": "Belum ada pesan",
    "chats.conversation_id": "Percakapan #{id}",
    "Conversation #{id}": "Percakapan #{id}",
    "chats.status.closed": "ditutup",
    "closed": "ditutup",
    "chats.status.open": "terbuka",
    "chats.reopen": "Buka kembali",
    "Reopen": "Buka kembali",
    "chats.close_conversation": "Tutup percakapan",
    "Close conversation": "Tutup percakapan",
    "chats.your_team": "Tim Anda",
    "Your team": "Tim Anda",
    "chats.empty_messages": "Belum ada pesan dalam percakapan ini.",
    "No messages in this conversation yet.": "Belum ada pesan dalam percakapan ini.",
    "chats.write_reply": "Tulis balasan",
    "Write a reply": "Tulis balasan",
    "chats.send": "Kirim",
    "Send": "Kirim",
    "chats.select_conversation": "Pilih percakapan untuk melihat pesannya.",
    "Select a conversation to view its messages.": "Pilih percakapan untuk melihat pesannya.",
    "chats.error.session_not_ready": "Sesi Anda belum siap. Muat ulang halaman lalu coba lagi.",
    "Your session is not ready. Refresh the page and try again.": "Sesi Anda belum siap. Muat ulang halaman lalu coba lagi.",
    "chats.error.request_failed": "Permintaan chat gagal ({status})",
    "Chat request failed ({status})": "Permintaan chat gagal ({status})",
    "chats.error.load_conversations": "Percakapan tidak dapat dimuat.",
    "Could not load conversations.": "Percakapan tidak dapat dimuat.",
    "chats.error.load_messages": "Pesan tidak dapat dimuat.",
    "Could not load messages.": "Pesan tidak dapat dimuat.",
    "chats.error.send_message": "Pesan tidak dapat dikirim.",
    "Message could not be sent.": "Pesan tidak dapat dikirim.",
    "chats.error.update_status": "Status percakapan tidak dapat diperbarui.",
    "Conversation status could not be updated.": "Status percakapan tidak dapat diperbarui.",
    "accounts.select_account": "Pilih akun",
    "common.accounts": "Akun",
    "common.listings": "Listing",
    "communications.loading_preview": "Memuat pratinjau…",
    "Loading preview…": "Memuat pratinjau…",
    "communications.no_preview": "Tidak ada pratinjau",
    "No preview": "Tidak ada pratinjau",
    "collections.choose_type": "Pilih {type}",
    "Choose {type}": "Pilih {type}",
    "collections.create_type_category_first": "Buat kategori {type} terlebih dahulu",
    "Create {type} category first": "Buat kategori {type} terlebih dahulu",
    "web_config.customisation": "Kustomisasi Web",
    "web_config.configuration": "Konfigurasi Web",
    "Web Configuration": "Konfigurasi Web",
    "web_config.section_general": "Umum",
    "web_config.section_social": "Sosial",
    "web_config.section_footer": "Footer",
    "web_config.assets": "Aset",
    "Assets": "Aset",
    "web_config.small_logo": "Logo kecil",
    "Small logo": "Logo kecil",
    "attributes.edit_attribute": "Edit atribut",
    "currency.rate_managed_automatically": "Nilai tukar dikelola secara otomatis.",
    "Rate is managed automatically.": "Nilai tukar dikelola secara otomatis.",
    "navigation.add_or_manage_mini_apps": "Tambahkan atau kelola Mini Apps",
    "Add or manage Mini Apps": "Tambahkan atau kelola Mini Apps",
    "listings.import.download_type_template": "Unduh template {type}",
    "navigation.promo_banner": "Diskon {percent}% hanya untuk pelanggan baru! Gunakan kode: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Diskon {percent}% hanya untuk pelanggan baru! Gunakan kode: {code}.",
    "orders.cash_refund_recorded": "Pengembalian tunai dicatat. Pembalikan akuntansi telah dijadwalkan.",
    "Cash refund recorded. The accounting reversal has been queued.": "Pengembalian tunai dicatat. Pembalikan akuntansi telah dijadwalkan.",
    "orders.cash_refund_failed": "Pengembalian tunai tidak dapat dicatat. Periksa status pembayaran pesanan dan riwayat pengembalian.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Pengembalian tunai tidak dapat dicatat. Periksa status pembayaran pesanan dan riwayat pengembalian.",
    "orders.recording_cash_refund": "Mencatat pengembalian…",
    "Recording refund…": "Mencatat pengembalian…",
    "orders.record_cash_refund": "Catat pengembalian tunai",
    "Record cash refund": "Catat pengembalian tunai",
    "orders.confirm_cash_refund": "Konfirmasi pengembalian tunai",
    "Confirm cash refund": "Konfirmasi pengembalian tunai",
    "orders.cash_refund_order_amount": "Catat pengembalian tunai penuh sebesar {amount} untuk pesanan {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "Catat pengembalian tunai penuh sebesar {amount} untuk pesanan {reference}?",
    "orders.cash_refund_manual_notice": "Ini mencatat pengembalian COD/tunai manual dan menjadwalkan pembalikan akuntansi. Penyedia pembayaran tidak akan dihubungi.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Ini mencatat pengembalian COD/tunai manual dan menjadwalkan pembalikan akuntansi. Penyedia pembayaran tidak akan dihubungi.",
    "currency_conversion.title": "Konversi mata uang",
    "Currency conversion": "Konversi mata uang",
    "currency_conversion.open_settings": "Pengaturan konversi",
    "Conversion settings": "Pengaturan konversi",
    "currency_conversion.load_failed": "Pengaturan konversi mata uang tidak dapat dimuat.",
    "Could not load currency conversion settings.": "Pengaturan konversi mata uang tidak dapat dimuat.",
    "currency_conversion.interval_error": "Interval penyegaran harus antara 5 menit dan 24 jam.",
    "Refresh interval must be between 5 minutes and 24 hours.": "Interval penyegaran harus antara 5 menit dan 24 jam.",
    "currency_conversion.save_failed": "Pengaturan konversi mata uang tidak dapat disimpan.",
    "Could not save currency conversion settings.": "Pengaturan konversi mata uang tidak dapat disimpan.",
    "currency_conversion.saved": "Pengaturan konversi mata uang disimpan.",
    "Currency conversion settings saved.": "Pengaturan konversi mata uang disimpan.",
    "currency_conversion.description": "Pilih cara menghitung konversi mata uang yang ditampilkan.",
    "Choose how displayed currency conversions are calculated.": "Pilih cara menghitung konversi mata uang yang ditampilkan.",
    "currency_conversion.manual_title": "Nilai tukar manual",
    "currency_conversion.manual_help": "Gunakan nilai tukar yang dimasukkan untuk setiap mata uang di bawah ini.",
    "Use the exchange rate entered for each currency below.": "Gunakan nilai tukar yang dimasukkan untuk setiap mata uang di bawah ini.",
    "currency_conversion.frankfurter_title": "Frankfurter (default)",
    "Frankfurter (default)": "Frankfurter (default)",
    "currency_conversion.frankfurter_help": "Nilai tukar harian gratis. Tidak diperlukan kunci API penyedia.",
    "Free daily exchange rates. No provider API key is required.": "Nilai tukar harian gratis. Tidak diperlukan kunci API penyedia.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Gunakan layanan Fixer yang dikelola platform. Pembaruan nilai tukar bergantung pada paket penyedia.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Gunakan layanan Fixer yang dikelola platform. Pembaruan nilai tukar bergantung pada paket penyedia.",
    "currency_conversion.refresh_interval": "Interval pemeriksaan nilai tukar (menit)",
    "Rate re-check interval (minutes)": "Interval pemeriksaan nilai tukar (menit)",
    "workspace.currency_search_code": "Cari atau pilih",
    "Search or select": "Cari atau pilih",
    "workspace.currency_preset_hint": "Default yang disarankan telah diterapkan. Anda dapat mengubah kolom apa pun.",
    "Recommended defaults applied. You can edit any field.": "Default yang disarankan telah diterapkan. Anda dapat mengubah kolom apa pun.",
    "developer.api_keys.copy_unavailable": "Kunci belum tersedia.",
    "Key is not available yet.": "Kunci belum tersedia.",
    "developer.api_keys.copy_failed": "Kunci tidak dapat disalin. Silakan coba lagi.",
    "Unable to copy the key. Try again.": "Kunci tidak dapat disalin. Silakan coba lagi.",
    "payroll.action.export_pdf": "Ekspor PDF",
    "Export PDF": "Ekspor PDF",
    "cms.category.name_prompt": "Nama kategori",
    "cms.field.cover_image": "Gambar sampul",
    "Cover Image": "Gambar sampul",
    "cms.action.add_cover_photo": "Tambah foto sampul",
    "Add cover photo": "Tambah foto sampul",
    "cms.field.category": "Kategori",
    "cms.category.none": "Tanpa kategori",
    "No category": "Tanpa kategori",
    "cms.advanced": "Lanjutan",
    "media_picker.action.select_image": "Pilih gambar",
    "Select image": "Pilih gambar",
    "orders.confirm_record_cash_refund": "Konfirmasi pengembalian",
    "Record refund": "Konfirmasi pengembalian",
    "listing_form.no_repeat": "Tanpa pengulangan",
    "No repeat": "Tanpa pengulangan",
    "listing_form.custom_repeat_days": "Kustom: {days}",
    "Custom: {days}": "Kustom: {days}",
    "common.sending": "Mengirim…",
    "listings.detail.unique_name": "Nama unik",
    "Unique Name": "Nama unik",
    "app_customization.username": "Nama pengguna",
    "workspace.templates.name_required": "Nama template wajib diisi.",
    "Template name is required.": "Nama template wajib diisi.",
    "workspace.templates.saved": "Template peran disimpan.",
    "Role template saved.": "Template peran disimpan.",
    "workspace.templates.confirm_delete": "Hapus template “{name}”?",
    "Delete template \"{name}\"?": "Hapus template “{name}”?",
    "workspace.templates.deleted": "Template dihapus.",
    "Template deleted.": "Template dihapus.",
    "workspace.members.tab_members": "Anggota",
    "workspace.templates.tab": "Template Peran",
    "Role Templates": "Template Peran",
    "workspace.templates.title": "Template Peran",
    "workspace.templates.new": "Template baru",
    "New Template": "Template baru",
    "workspace.templates.name": "Nama",
    "workspace.templates.empty": "Belum ada template peran.",
    "No role templates yet.": "Belum ada template peran.",
    "workspace.templates.edit": "Edit template",
    "Edit Template": "Edit template",
    "workspace.templates.name_label": "Nama template",
    "Template name": "Nama template",
    "workspace.templates.name_placeholder": "mis. Manajer Konten",
    "e.g. Content Manager": "mis. Manajer Konten",
    "listings.import.unknown_error": "Kategori tidak dapat diimpor. Periksa CSV lalu coba lagi.",
    "The categories could not be imported. Please check the CSV and try again.": "Kategori tidak dapat diimpor. Periksa CSV lalu coba lagi.",
    "common.no_access_to_page": "Tidak ada akses",
    "No access": "Tidak ada akses",
    "common.permission_to_view_page_denied": "Anda tidak memiliki izin untuk melihat halaman ini.",
    "You do not have permission to view this page.": "Anda tidak memiliki izin untuk melihat halaman ini.",
    "common.loading_permissions": "Memuat izin…",
    "Loading permissions…": "Memuat izin…",
    "attributes.added_successfully": "Bagus 🎉, atribut berhasil ditambahkan",
    "Nice 🎉, Successfully added attributes": "Bagus 🎉, atribut berhasil ditambahkan",
    "attributes.add_attribute_values": "Tambahkan nilai atribut",
    "attributes.attribute": "Atribut",
    "attributes.optional": "Opsional",
    "attributes.private": "Privat",
    "attributes.hidden_field": "Kolom tersembunyi",
    "attributes.show_in_filter": "Tampilkan di filter",
    "attributes.status_not_active_active": "Status (Tidak aktif / Aktif)",
    "attributes.add_metadata": "Tambahkan metadata",
    "Add metadata": "Tambahkan metadata",
    "attributes.select_date_time": "Pilih tanggal & waktu",
    "listings.addons.column_title": "Judul",
    "listings.addons.column_image": "Gambar",
    "listings.addons.column_price": "Harga",
    "listings.addons.column_max_quantity": "Jumlah maksimum",
    "Max Quantity": "Jumlah maksimum",
    "listings.addons.column_offer": "Penawaran",
    "listings.addons.column_stock": "Stok",
    "listings.addons.column_action": "Tindakan",
    "listings.addons.column_status": "Status",
    "listings.addons.confirm_delete": "Hapus jenis add-on ini?",
    "Do you want to delete this add-on type?": "Hapus jenis add-on ini?",
    "common.share_collection": "Bagikan koleksi",
    "Share collection": "Bagikan koleksi",
    "communications.view_modes": "Mode tampilan komunikasi",
    "Communication view modes": "Mode tampilan komunikasi",
    "payments.accessibility.gateway_logo": "Logo gateway pembayaran",
    "Payment gateway logo": "Logo gateway pembayaran",
    "common.build_version": "Versi build",
    "Build version": "Versi build",
    "common.build_label": "build",
    "build": "build",
    "listings.under_category_title": "Listing dalam kategori {category}",
    "Listings under {category}": "Listing dalam kategori {category}",
    "attributes.signup": "Pendaftaran",
    "Signup": "Pendaftaran",
    "common.toast.please_check_action": "Periksa tindakan ini",
    "Please check this action": "Periksa tindakan ini",
    "common.information": "Informasi",
    "listing_form.error.load_listing_data": "Gagal memuat data listing",
    "Failed to load listing data": "Gagal memuat data listing",
    "listing_form.error.load_digital_contents": "Gagal memuat konten digital",
    "Failed to load digital contents": "Gagal memuat konten digital",
    "listing_form.validation.audio_file_or_url_required": "Tambahkan file audio atau URL audio publik sebelum membuat episode.",
    "Add an audio file or public audio URL before creating the episode.": "Tambahkan file audio atau URL audio publik sebelum membuat episode.",
    "listing_form.validation.rental_rate_greater_than_zero": "Masukkan tarif sewa lebih dari 0.",
    "Enter a rental rate greater than 0.": "Masukkan tarif sewa lebih dari 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "Durasi maksimum harus sama dengan atau lebih besar dari durasi minimum.",
    "Maximum duration must be greater than or equal to minimum duration.": "Durasi maksimum harus sama dengan atau lebih besar dari durasi minimum.",
    "listing_form.updated_successfully": "Listing berhasil diperbarui!",
    "Listing updated successfully!": "Listing berhasil diperbarui!",
    "listing_form.created_successfully": "Listing berhasil dibuat!",
    "Listing created successfully!": "Listing berhasil dibuat!",
    "listing_form.error.save_failed": "Gagal menyimpan listing. Silakan coba lagi.",
    "Failed to save listing. Please try again.": "Gagal menyimpan listing. Silakan coba lagi.",
    "listing_form.error.delete_variant_failed": "Gagal menghapus varian: {title}",
    "Failed to delete variant: {title}": "Gagal menghapus varian: {title}",
    "listing_form.error.variant_action_failed": "Gagal {action} varian: {title}",
    "Failed to {action} variant: {title}": "Gagal {action} varian: {title}",
    "listing_form.error.digital_content_action_failed": "Gagal {action} konten digital: {title}",
    "Failed to {action} digital content: {title}": "Gagal {action} konten digital: {title}",
    "listing_form.action.create": "buat",
    "listing_form.action.update": "perbarui",
    "listing_form.action.delete": "hapus",
    "delete": "hapus",
    "listing_form.error.save_request_failed": "Gagal menyimpan listing",
    "Failed to save listing": "Gagal menyimpan listing",
    "listing_form.error.rental_settings_save_failed": "Listing berhasil disimpan, tetapi pengaturan sewa tidak dapat disimpan.",
    "Listing saved, but rental settings could not be saved.": "Listing berhasil disimpan, tetapi pengaturan sewa tidak dapat disimpan.",
    "users.action_failed": "Tindakan gagal. Silakan coba lagi.",
    "Action failed. Please try again.": "Tindakan gagal. Silakan coba lagi.",
    "common.successfully_added": "Berhasil ditambahkan",
    "Successfully added": "Berhasil ditambahkan",
    "listing_form.validation.title_min_length": "Judul minimal harus {count} karakter",
    "Title must be at least {count} characters": "Judul minimal harus {count} karakter",
    "listing_form.validation.title_max_length": "Judul tidak boleh lebih dari {count} karakter",
    "Title must not exceed {count} characters": "Judul tidak boleh lebih dari {count} karakter",
    "listing_form.validation.price_minimum": "Harga minimal {amount}",
    "Price must be at least {amount}": "Harga minimal {amount}",
    "listing_form.validation.attribute_required": "{attribute} wajib diisi",
    "listings.error.load_failed": "Gagal memuat listing",
    "Unable to load listings": "Gagal memuat listing",
    "communications.from_email_required_before_verification": "Masukkan alamat email pengirim sebelum verifikasi.",
    "Please enter From email address before verifying.": "Masukkan alamat email pengirim sebelum verifikasi.",
    "communications.verification_email_sent": "Email verifikasi telah dikirim. Periksa kotak masuk dan ikuti petunjuk untuk memverifikasi alamat email ini.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Email verifikasi telah dikirim. Periksa kotak masuk dan ikuti petunjuk untuk memverifikasi alamat email ini.",
    "communications.verification_start_failed": "Tidak dapat memulai verifikasi. Silakan coba lagi.",
    "Unable to start verification. Please try again.": "Tidak dapat memulai verifikasi. Silakan coba lagi.",
    "common.uploaded_successfully": "Berhasil diunggah",
    "upgrade_page.panel.yearly": "Tahunan",
    "upgrade_page.panel.monthly": "Bulanan",
    "orders.advance_paid": "Uang muka dibayar",
    "Advance paid": "Uang muka dibayar",
    "orders.balance_due": "Sisa tagihan",
    "Balance due": "Sisa tagihan",
    "orders.advance_invalid": "Masukkan jumlah yang lebih kecil dari total pesanan.",
    "Enter an amount less than the order total.": "Masukkan jumlah yang lebih kecil dari total pesanan.",
    "orders.advance_failed": "Uang muka tidak dapat disimpan.",
    "Could not save the advance.": "Uang muka tidak dapat disimpan.",
    "orders.edit_advance": "Edit uang muka",
    "Edit advance": "Edit uang muka",
    "orders.record_advance": "Catat uang muka",
    "Record advance": "Catat uang muka",
    "orders.advance_notice": "Jumlah yang telah dibayar pelanggan harus kurang dari total pesanan {total}. Pesanan tetap belum dibayar sampai Anda menandai sisanya sebagai lunas. Masukkan 0 untuk menghapus uang muka.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Jumlah yang telah dibayar pelanggan harus kurang dari total pesanan {total}. Pesanan tetap belum dibayar sampai Anda menandai sisanya sebagai lunas. Masukkan 0 untuk menghapus uang muka.",
    "orders.save_advance": "Simpan",
    "common.hide": "Sembunyikan",
    "listings.repeat.daily": "Harian",
    "listings.repeat.weekdays": "Hari kerja (Sen-Jum)",
    "Weekdays (Mon-Fri)": "Hari kerja (Sen-Jum)",
    "listings.repeat.weekend": "Akhir pekan (Sab-Min)",
    "Weekend (Sat-Sun)": "Akhir pekan (Sab-Min)",
    "listings.repeat.custom": "Kustom",
    "listings.weekday.sun": "Min",
    "Sun": "Min",
    "listings.weekday.mon": "Sen",
    "Mon": "Sen",
    "listings.weekday.tue": "Sel",
    "Tue": "Sel",
    "listings.weekday.wed": "Rab",
    "Wed": "Rab",
    "listings.weekday.thu": "Kam",
    "Thu": "Kam",
    "listings.weekday.fri": "Jum",
    "Fri": "Jum",
    "listings.weekday.sat": "Sab",
    "Sat": "Sab",
    "orders.pay_balance": "Bayar sisa {amount}",
    "Pay balance {amount}": "Bayar sisa {amount}",
    "orders.partially_paid": "Dibayar sebagian",
    "Partially paid": "Dibayar sebagian",
    "orders.balance_amount": "Sisa {amount}",
    "Balance {amount}": "Sisa {amount}",
    "delivery.get_started.add_branch": "Tambah cabang",
    "Add branch": "Tambah cabang",
    "delivery.get_started.add_fleet": "Tambah armada",
    "Add fleet": "Tambah armada",
    "delivery.get_started.api_documentation": "Dokumentasi API",
    "API Documentation": "Dokumentasi API",
    "delivery.get_started.add_driver": "Tambah pengemudi",
    "Add driver": "Tambah pengemudi",
    "delivery.get_started.branch_title": "Tambahkan cabang Anda",
    "Add your branch": "Tambahkan cabang Anda",
    "delivery.get_started.branch_description": "Satu cabang dapat memiliki banyak armada dan pengemudi",
    "A branch can have many fleets and drivers": "Satu cabang dapat memiliki banyak armada dan pengemudi",
    "delivery.get_started.fleet_title": "Tambahkan armada Anda",
    "Add your fleet": "Tambahkan armada Anda",
    "delivery.get_started.fleet_description": "Armada dapat ditugaskan kepada pengemudi",
    "A fleet can be assigned to a driver": "Armada dapat ditugaskan kepada pengemudi",
    "delivery.get_started.driver_title": "Tambahkan pengemudi Anda",
    "Add your driver": "Tambahkan pengemudi Anda",
    "delivery.get_started.driver_description": "Pengemudi akan mengantarkan pesanan Anda",
    "The driver will deliver your order": "Pengemudi akan mengantarkan pesanan Anda",
    "delivery.get_started.order_title": "Buat pesanan pertama Anda",
    "Create your first order": "Buat pesanan pertama Anda",
    "delivery.get_started.order_description": "Pesanan dapat dibuat melalui API",
    "Orders can be created through the API": "Pesanan dapat dibuat melalui API",
    "delivery.get_started.progress.branches": "Cabang",
    "Branches": "Cabang",
    "delivery.get_started.progress.fleets": "Armada",
    "Fleets": "Armada",
    "delivery.get_started.progress.drivers": "Pengemudi",
    "Drivers": "Pengemudi",
    "delivery.get_started.progress.orders": "Pesanan pengiriman",
    "Delivery Orders": "Pesanan pengiriman",
    "delivery.get_started.welcome": "Selamat datang di",
    "Welcome to": "Selamat datang di",
    "delivery.get_started.question": "Apa yang ingin Anda lakukan?",
    "What would you like to do?": "Apa yang ingin Anda lakukan?",
    "workspace.templates.built_in": "Bawaan",
    "Built-in": "Bawaan",
    "workspace.templates.copy_of": "Salinan {name}",
    "Copy of {name}": "Salinan {name}",
    "workspace.members.role": "Peran",
    "Role": "Peran",
    "workspace.members.role_full_access": "Akses penuh",
    "Full access": "Akses penuh",
    "workspace.templates.duplicate": "Duplikat",
    "workspace.members.role_custom": "Khusus (atur di bawah)",
    "Custom (set below)": "Khusus (atur di bawah)"
  },
  "it": {
    "0": "0",
    "6100": "6100",
    "common.language": "Lingua",
    "Language": "Lingua",
    "common.english": "Inglese",
    "English": "Inglese",
    "common.french": "Francese",
    "French": "Francese",
    "common.arabic": "Arabo",
    "Arabic": "Arabo",
    "navigation.get_started": "Inizia",
    "Get Started": "Inizia",
    "navigation.dashboard": "Cruscotto",
    "navigation.orders": "Ordini",
    "Orders": "Ordini",
    "navigation.schedule": "Programma",
    "navigation.accounts": "Account",
    "Accounts": "Account",
    "navigation.account_categories": "Categorie account",
    "Account Categories": "Categorie account",
    "navigation.account_attributes": "Attributi account",
    "Account Attributes": "Attributi account",
    "navigation.account_configuration": "Configurazione account",
    "Account Configuration": "Configurazione account",
    "navigation.agents": "Agenti",
    "Agents": "Agenti",
    "navigation.listings": "Inserzioni",
    "navigation.categories": "Categorie",
    "Categories": "Categorie",
    "navigation.custom_attributes": "Attributi personalizzati",
    "Custom Attributes": "Attributi personalizzati",
    "navigation.variant_types": "Tipi di variante",
    "Variant Types": "Tipi di variante",
    "navigation.additional_features": "Funzionalità aggiuntive",
    "Additional Features": "Funzionalità aggiuntive",
    "navigation.reported_listings": "Inserzioni segnalate",
    "Reported Listings": "Inserzioni segnalate",
    "navigation.report_accounts": "Segnalazioni account",
    "Report Accounts": "Segnalazioni account",
    "navigation.users": "Utenti",
    "Users": "Utenti",
    "navigation.user_attributes": "Attributi utente",
    "User Attributes": "Attributi utente",
    "navigation.reviews_ratings": "Recensioni e valutazioni",
    "Reviews & Ratings": "Recensioni e valutazioni",
    "navigation.report": "Segnalazione",
    "Report": "Segnalazione",
    "navigation.reports": "Segnalazioni",
    "navigation.platform_health": "Stato della piattaforma",
    "Platform Health": "Stato della piattaforma",
    "navigation.promotions": "Promozioni",
    "Promotions": "Promozioni",
    "navigation.collections": "Collezioni",
    "navigation.promotion_ads": "Promozioni / annunci",
    "Promotion / Ads": "Promozioni / annunci",
    "navigation.coupons": "Coupon",
    "Coupons": "Coupon",
    "navigation.finance": "Finanza",
    "Finance": "Finanza",
    "navigation.transactions": "Transazioni",
    "Transactions": "Transazioni",
    "navigation.settlement": "Liquidazione",
    "Settlement": "Liquidazione",
    "navigation.expenses": "Spese",
    "Expenses": "Spese",
    "navigation.recurring_payments": "Pagamenti ricorrenti",
    "Recurring payments": "Pagamenti ricorrenti",
    "navigation.media": "Media",
    "navigation.communication": "Comunicazioni",
    "Communication": "Comunicazioni",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Editor del sito web",
    "Website Editor": "Editor del sito web",
    "navigation.change_templates": "Modifica modelli",
    "Change Templates": "Modifica modelli",
    "navigation.pages": "Pagine",
    "Pages": "Pagine",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Personalizza i testi",
    "Customise texts": "Personalizza i testi",
    "navigation.add_integrations": "Aggiungi integrazioni",
    "Add Integrations": "Aggiungi integrazioni",
    "navigation.domain": "Dominio",
    "Domain": "Dominio",
    "navigation.customise_seo": "Personalizza SEO",
    "Customise SEO": "Personalizza SEO",
    "navigation.app": "App",
    "App": "App",
    "navigation.apps": "App",
    "Apps": "App",
    "navigation.buy_app_templates": "Acquista modelli per app",
    "Buy App Templates": "Acquista modelli per app",
    "navigation.customisation": "Personalizzazione",
    "Customisation": "Personalizzazione",
    "navigation.integrations": "Integrazioni",
    "Integrations": "Integrazioni",
    "navigation.invite_team": "Invita il team",
    "Invite Team": "Invita il team",
    "navigation.help": "Aiuto",
    "Help": "Aiuto",
    "navigation.documentation": "Documentazione",
    "Documentation": "Documentazione",
    "navigation.community": "Comunità",
    "navigation.api_reference": "Riferimento API",
    "API Reference": "Riferimento API",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Canali",
    "Channels": "Canali",
    "navigation.coding_kits": "Kit di sviluppo",
    "Coding Kits": "Kit di sviluppo",
    "navigation.vibe_coding": "Programmazione assistita dall’IA",
    "Vibe Coding": "Programmazione assistita dall’IA",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Impostazioni",
    "Settings": "Impostazioni",
    "navigation.more": "Altro",
    "More": "Altro",
    "navigation.marketplace": "Marketplace",
    "Marketplace": "Marketplace",
    "navigation.commerce": "Commercio",
    "Commerce": "Commercio",
    "navigation.marketing": "Marketing",
    "Marketing": "Marketing",
    "navigation.intelligence": "Intelligenza",
    "navigation.subscription": "Abbonamento",
    "navigation.membership": "Iscrizione",
    "navigation.rewards": "Premi",
    "Rewards": "Premi",
    "navigation.bundles": "Pacchetti",
    "navigation.supply_chain": "Catena di fornitura",
    "Supply Chain": "Catena di fornitura",
    "navigation.people": "Persone",
    "navigation.workforce": "Personale",
    "Workforce": "Personale",
    "navigation.payroll": "Buste paga",
    "navigation.inventory": "Inventario",
    "navigation.inventory_operations": "Operazioni di magazzino",
    "Inventory Operations": "Operazioni di magazzino",
    "navigation.purchase_orders": "Ordini di acquisto",
    "Purchase Orders": "Ordini di acquisto",
    "navigation.stock_locations": "Ubicazioni di magazzino",
    "Stock Locations": "Ubicazioni di magazzino",
    "navigation.purchase_orders_2": "Ordini di acquisto",
    "Purchase orders": "Ordini di acquisto",
    "navigation.suppliers": "Fornitori",
    "Suppliers": "Fornitori",
    "navigation.locations": "Sedi",
    "Locations": "Sedi",
    "navigation.maps": "Mappe",
    "Maps": "Mappe",
    "navigation.accounting": "Contabilità",
    "Accounting": "Contabilità",
    "navigation.invoices": "Fatture",
    "Invoices": "Fatture",
    "navigation.plans": "Piani",
    "Plans": "Piani",
    "navigation.countries": "Paesi",
    "Countries": "Paesi",
    "navigation.currency": "Valuta",
    "Currency": "Valuta",
    "navigation.languages": "Lingue",
    "Languages": "Lingue",
    "navigation.payments": "Pagamenti",
    "Payments": "Pagamenti",
    "navigation.commissions": "Commissioni",
    "Commissions": "Commissioni",
    "navigation.taxes": "Tasse",
    "navigation.special_fees": "Tariffe speciali",
    "navigation.service_shipping": "Servizi / spedizione",
    "Service / Shipping": "Servizi / spedizione",
    "navigation.checkout_cart_attributes": "Attributi di checkout e carrello",
    "navigation.dark_mode_background_color": "Colore di sfondo modalità scura",
    "Dark Mode Background Color": "Colore di sfondo modalità scura",
    "navigation.dark_mode_text_color": "Colore del testo modalità scura",
    "Dark Mode Text Color": "Colore del testo modalità scura",
    "navigation.light_mode_background_color": "Colore di sfondo modalità chiara",
    "Light Mode Background Color": "Colore di sfondo modalità chiara",
    "navigation.light_mode_text_color": "Colore del testo modalità chiara",
    "Light Mode Text Color": "Colore del testo modalità chiara",
    "navigation.workspace": "Area di lavoro",
    "Workspace": "Area di lavoro",
    "navigation.user_management": "Gestione utenti",
    "User Management": "Gestione utenti",
    "navigation.privacy": "Privacy",
    "Privacy": "Privacy",
    "common.search": "Cerca...",
    "Search...": "Cerca...",
    "common.search_2": "Cerca",
    "Search": "Cerca",
    "common.no_results_found": "Nessun risultato trovato",
    "No results found": "Nessun risultato trovato",
    "common.no_record_found": "Nessun record trovato",
    "No Record Found": "Nessun record trovato",
    "common.open_in_a_new_tab": "Apri in una nuova scheda",
    "Open in a new tab": "Apri in una nuova scheda",
    "common.open": "Apri",
    "common.in_a_new_tab": "in una nuova scheda",
    "in a new tab": "in una nuova scheda",
    "common.loading_page": "Caricamento della pagina…",
    "Loading page…": "Caricamento della pagina…",
    "common.close": "Chiudi",
    "Close": "Chiudi",
    "common.save": "Salva",
    "Save": "Salva",
    "common.cancel": "Annulla",
    "Cancel": "Annulla",
    "common.delete": "Elimina",
    "common.edit": "Modifica",
    "Edit": "Modifica",
    "common.add": "Aggiungi",
    "Add": "Aggiungi",
    "common.create": "Crea",
    "Create": "Crea",
    "common.update": "Aggiorna",
    "Update": "Aggiorna",
    "common.back": "Indietro",
    "Back": "Indietro",
    "common.next": "Avanti",
    "Next": "Avanti",
    "common.previous": "Precedente",
    "common.done": "Fatto",
    "Done": "Fatto",
    "common.yes": "Sì",
    "Yes": "Sì",
    "common.no": "No",
    "No": "No",
    "common.name": "Nome",
    "Name": "Nome",
    "common.status": "Stato",
    "Status": "Stato",
    "common.date": "Data",
    "Date": "Data",
    "common.actions": "Azioni",
    "Actions": "Azioni",
    "common.action": "Azione",
    "Action": "Azione",
    "orders.scan_order": "Scansiona l’ordine",
    "Scan order": "Scansiona l’ordine",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Scansiona il codice a barre/QR dell’ordine o inseriscilo manualmente.",
    "Scan a barcode/QR reference or enter it manually.": "Scansiona il codice a barre/QR dell’ordine o inseriscilo manualmente.",
    "orders.camera_scanner": "Scanner fotocamera",
    "Camera scanner": "Scanner fotocamera",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "La scansione con la fotocamera non è supportata qui. Inserisci il riferimento dell’ordine qui sotto.",
    "Camera scanning is not supported here. Enter the order reference below.": "La scansione con la fotocamera non è supportata qui. Inserisci il riferimento dell’ordine qui sotto.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "L’accesso alla fotocamera non è disponibile. Inserisci il riferimento dell’ordine qui sotto.",
    "Camera access is unavailable. Enter the order reference below.": "L’accesso alla fotocamera non è disponibile. Inserisci il riferimento dell’ordine qui sotto.",
    "orders.order_reference_number": "Numero di riferimento dell’ordine",
    "Order reference number": "Numero di riferimento dell’ordine",
    "orders.find_order": "Trova ordine",
    "Find order": "Trova ordine",
    "common.your_orders_will_be_shown_here": "I tuoi ordini verranno mostrati qui.",
    "Your orders will be shown here.": "I tuoi ordini verranno mostrati qui.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Qui puoi tenere traccia di ordini e prenotazioni effettuati con altri account e seguirne gli aggiornamenti di stato.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Qui puoi tenere traccia di ordini e prenotazioni effettuati con altri account e seguirne gli aggiornamenti di stato.",
    "common.reference": "Riferimento",
    "Reference #": "Riferimento",
    "common.amount": "Importo",
    "Amount": "Importo",
    "orders.order_status": "Stato dell’ordine",
    "Order Status": "Stato dell’ordine",
    "orders.payment_status": "Stato del pagamento",
    "Payment Status": "Stato del pagamento",
    "common.payment_method": "Metodo di pagamento",
    "Payment Method": "Metodo di pagamento",
    "common.shipping_method": "Metodo di spedizione",
    "Shipping Method": "Metodo di spedizione",
    "common.paid": "Pagato",
    "common.not_paid": "Non pagato",
    "Not Paid": "Non pagato",
    "common.unpaid": "Non pagato",
    "UnPaid": "Non pagato",
    "common.failed": "Non riuscito",
    "Failed": "Non riuscito",
    "common.incomplete": "Incompleto",
    "Incomplete": "Incompleto",
    "common.order_placed": "Ordine effettuato",
    "Order placed": "Ordine effettuato",
    "common.order_in_progress": "Ordine in corso",
    "Order in progress": "Ordine in corso",
    "common.shipped": "Spedito",
    "Shipped": "Spedito",
    "common.delivered": "Consegnato",
    "Delivered": "Consegnato",
    "common.cancelled_by_customer": "Annullato dal cliente",
    "Cancelled by customer": "Annullato dal cliente",
    "common.order_completed": "Ordine completato",
    "Order completed": "Ordine completato",
    "common.n_a": "N/D",
    "N/A": "N/D",
    "orders.total_orders": "Ordini totali",
    "Total Orders": "Ordini totali",
    "orders.page_revenue": "Ricavi della pagina",
    "Page Revenue": "Ricavi della pagina",
    "orders.pending_payment": "In attesa di pagamento",
    "Pending Payment": "In attesa di pagamento",
    "common.failed_payments": "Pagamenti non riusciti",
    "Failed payments": "Pagamenti non riusciti",
    "common.abandoned": "Abbandonato",
    "Abandoned": "Abbandonato",
    "orders.search_orders_by_reference_number": "Cerca ordini per numero di riferimento",
    "Search orders by reference number": "Cerca ordini per numero di riferimento",
    "orders.search_by_reference_number": "Cerca per numero di riferimento…",
    "Search by reference number…": "Cerca per numero di riferimento…",
    "orders.export_orders_as_csv": "Esporta ordini in CSV",
    "Export orders as CSV": "Esporta ordini in CSV",
    "orders.manual_order": "Ordine manuale",
    "Manual Order": "Ordine manuale",
    "orders.scan_order_reference": "Scansiona il riferimento dell’ordine",
    "Scan order reference": "Scansiona il riferimento dell’ordine",
    "orders.change_status_to": "Cambia stato in…",
    "Change status to…": "Cambia stato in…",
    "common.apply": "Applica",
    "Apply": "Applica",
    "common.clear": "Cancella",
    "Clear": "Cancella",
    "orders.pay": "Paga",
    "Pay": "Paga",
    "orders.clear_selection": "Deseleziona",
    "Clear selection": "Deseleziona",
    "orders.list": "Elenco",
    "orders.board": "Bacheca",
    "Board": "Bacheca",
    "orders.filter_orders": "Filtra ordini",
    "Filter orders": "Filtra ordini",
    "orders.start_date": "Data di inizio",
    "orders.end_date": "Data di fine",
    "orders.select_date": "Seleziona data",
    "orders.show_rows": "Mostra righe",
    "Show rows": "Mostra righe",
    "common.order_selected": "ordine selezionato",
    "order selected": "ordine selezionato",
    "common.orders_selected": "ordini selezionati",
    "orders selected": "ordini selezionati",
    "common.order_updated": "ordine aggiornato",
    "order updated": "ordine aggiornato",
    "common.orders_updated": "ordini aggiornati",
    "orders updated": "ordini aggiornati",
    "orders.order_archived_successfully": "Ordine archiviato con successo",
    "Order archived successfully": "Ordine archiviato con successo",
    "orders.failed_to_archive_order": "Impossibile archiviare l’ordine",
    "Failed to archive order": "Impossibile archiviare l’ordine",
    "orders.loading_order": "Caricamento ordine…",
    "Loading order…": "Caricamento ordine…",
    "orders.order_created_successfully": "Ordine creato con successo",
    "Order created successfully": "Ordine creato con successo",
    "orders.the_order_has_been_created_and_is_ready_to_review": "L’ordine è stato creato ed è pronto per la revisione.",
    "The order has been created and is ready to review.": "L’ordine è stato creato ed è pronto per la revisione.",
    "orders.order_reference": "Riferimento ordine",
    "Order reference": "Riferimento ordine",
    "common.created": "Creato",
    "Created": "Creato",
    "common.total": "Totale",
    "Total": "Totale",
    "common.items": "Articoli",
    "orders.print_save_pdf": "Stampa / Salva PDF",
    "Print / Save PDF": "Stampa / Salva PDF",
    "orders.view_order_details": "Visualizza dettagli ordine",
    "View order details": "Visualizza dettagli ordine",
    "orders.create_another_order": "Crea un altro ordine",
    "Create another order": "Crea un altro ordine",
    "orders.confirmed": "Confermato",
    "Confirmed": "Confermato",
    "orders.in_progress": "In corso",
    "In progress": "In corso",
    "orders.customer_unreachable": "Cliente non raggiungibile",
    "Customer unreachable": "Cliente non raggiungibile",
    "orders.out_for_delivery": "In consegna",
    "Out for delivery": "In consegna",
    "orders.returned": "Restituito",
    "Returned": "Restituito",
    "orders.return_confirmed": "Reso confermato",
    "Return confirmed": "Reso confermato",
    "orders.delivery_confirmed": "Consegna confermata",
    "Delivery confirmed": "Consegna confermata",
    "orders.return_initiated": "Reso avviato",
    "Return initiated": "Reso avviato",
    "orders.return_picked": "Reso ritirato",
    "Return picked": "Reso ritirato",
    "orders.return_disputed": "Reso contestato",
    "Return disputed": "Reso contestato",
    "orders.canceled_by_seller": "Annullato dal venditore",
    "Canceled by seller": "Annullato dal venditore",
    "orders.canceled_by_customer": "Annullato dal cliente",
    "Canceled by customer": "Annullato dal cliente",
    "orders.ready_for_pickup": "Pronto per il ritiro",
    "Ready for pickup": "Pronto per il ritiro",
    "orders.arrived_at_customer_location": "Arrivato all’indirizzo del cliente",
    "orders.undelivered_returned": "Non consegnato — restituito",
    "Undelivered - Returned": "Non consegnato — restituito",
    "orders.undelivered_return_confirmed": "Reso dell’ordine non consegnato confermato",
    "Undelivered - Return confirmed": "Reso dell’ordine non consegnato confermato",
    "orders.disputed": "Contestato",
    "Disputed": "Contestato",
    "orders.completed": "Completato",
    "Completed": "Completato",
    "orders.detail_legacy.order_number": "Numero ordine:",
    "Order Number:": "Numero ordine:",
    "orders.detail_legacy.order_date": "Data ordine:",
    "Order Date:": "Data ordine:",
    "orders.detail_legacy.buyer_details": "Dati acquirente:",
    "Buyer Details:": "Dati acquirente:",
    "orders.detail_legacy.delivery_address": "Indirizzo di consegna:",
    "Delivery Address:": "Indirizzo di consegna:",
    "orders.detail_legacy.pickup_address": "Indirizzo di ritiro:",
    "Pickup Address:": "Indirizzo di ritiro:",
    "orders.detail_legacy.total_amount": "Importo totale:",
    "Total Amount:": "Importo totale:",
    "orders.detail_legacy.amount_in_words": "Importo in lettere:",
    "Amount in Words:": "Importo in lettere:",
    "orders.detail_legacy.amount_words_only": "Solo",
    "Only": "Solo",
    "orders.detail_legacy.payout_date": "Data del pagamento:",
    "Payout Date:": "Data del pagamento:",
    "orders.detail_legacy.change": "Modifica",
    "orders.detail_legacy.select_date_time": "Seleziona data e ora",
    "Select Date & Time": "Seleziona data e ora",
    "orders.detail_legacy.change_payout_date_time": "Modifica data e ora del pagamento",
    "Change Payout Date and Time": "Modifica data e ora del pagamento",
    "orders.detail_legacy.update_payout": "Aggiorna",
    "orders.detail_legacy.update_status": "Aggiorna stato",
    "Update Status": "Aggiorna stato",
    "orders.detail_legacy.change_order_status": "Cambia stato dell’ordine",
    "Change Order Status": "Cambia stato dell’ordine",
    "orders.detail_legacy.column_description": "Descrizione",
    "Description": "Descrizione",
    "orders.detail_legacy.column_unit_price": "Prezzo unitario",
    "Unit Price": "Prezzo unitario",
    "orders.detail_legacy.column_discount": "Sconto",
    "Discount": "Sconto",
    "orders.detail_legacy.column_tax_rate": "Aliquota fiscale",
    "Tax Rate": "Aliquota fiscale",
    "orders.item": "Articolo",
    "Item": "Articolo",
    "orders.order_details": "Dettagli ordine",
    "Order Details": "Dettagli ordine",
    "orders.copy_order_reference": "Copia riferimento ordine",
    "Copy order reference": "Copia riferimento ordine",
    "orders.order_summary": "Riepilogo ordine",
    "Order Summary": "Riepilogo ordine",
    "orders.order_created": "Ordine creato",
    "Order created": "Ordine creato",
    "orders.order_time": "Ora dell’ordine",
    "Order time": "Ora dell’ordine",
    "orders.total_earnings": "Guadagni totali",
    "Total earnings": "Guadagni totali",
    "orders.total_price": "Prezzo totale",
    "Total price": "Prezzo totale",
    "orders.delivery_fee": "Costo di consegna",
    "Delivery fee": "Costo di consegna",
    "orders.sub_total": "Subtotale",
    "Sub total": "Subtotale",
    "orders.customer_information": "Informazioni cliente",
    "Customer Information": "Informazioni cliente",
    "common.customer_name": "Nome cliente",
    "Customer Name": "Nome cliente",
    "common.phone": "Telefono",
    "Phone": "Telefono",
    "common.email": "Email",
    "Email": "Email",
    "orders.seller_details": "Dettagli venditore",
    "Seller Details": "Dettagli venditore",
    "common.seller_name": "Nome venditore",
    "Seller Name": "Nome venditore",
    "common.mobile": "Cellulare",
    "orders.generate": "Genera",
    "Generate": "Genera",
    "orders.cancel_order": "Annulla ordine",
    "Cancel Order": "Annulla ordine",
    "orders.mark_as_paid": "Segna come pagato",
    "Mark as Paid": "Segna come pagato",
    "orders.failed_to_mark_as_paid": "Impossibile segnare come pagato",
    "Failed to mark as paid": "Impossibile segnare come pagato",
    "orders.order_cancelled_successfully": "Ordine annullato con successo",
    "Order cancelled successfully": "Ordine annullato con successo",
    "orders.failed_to_cancel_order_by_admin": "L’amministratore non è riuscito ad annullare l’ordine",
    "Failed to cancel order by admin": "L’amministratore non è riuscito ad annullare l’ordine",
    "orders.no_transactions_found": "Nessuna transazione trovata",
    "No transactions found": "Nessuna transazione trovata",
    "orders.transaction_no": "N. transazione",
    "Transaction No": "N. transazione",
    "orders.entity": "Entità",
    "Entity": "Entità",
    "orders.transaction_type": "Tipo di transazione",
    "Transaction Type": "Tipo di transazione",
    "common.seller": "Venditore",
    "Seller": "Venditore",
    "common.customer": "Cliente",
    "Customer": "Cliente",
    "common.platform_owner": "Proprietario della piattaforma",
    "Platform Owner": "Proprietario della piattaforma",
    "orders.items_summary": "Riepilogo articoli",
    "Items Summary": "Riepilogo articoli",
    "orders.qty": "Qtà",
    "orders.price": "Prezzo",
    "Price": "Prezzo",
    "orders.total_price_2": "Prezzo totale",
    "Total Price": "Prezzo totale",
    "orders.membership_purchase": "Acquisto iscrizione",
    "Membership purchase": "Acquisto iscrizione",
    "orders.member_id": "ID membro",
    "Member ID": "ID membro",
    "orders.period": "Periodo",
    "Period": "Periodo",
    "orders.start_date_2": "Data di inizio",
    "common.next_renewal": "Prossimo rinnovo",
    "Next renewal": "Prossimo rinnovo",
    "common.expiry_date": "Data di scadenza",
    "Expiry date": "Data di scadenza",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Questo ordine è gestito come un contributo di iscrizione, non come una spedizione.",
    "This order is managed as a membership contribution, not a shipment.": "Questo ordine è gestito come un contributo di iscrizione, non come una spedizione.",
    "orders.months": "mesi",
    "months": "mesi",
    "orders.days": "giorni",
    "days": "giorni",
    "orders.address": "Indirizzo",
    "Address": "Indirizzo",
    "orders.address_1": "Indirizzo 1",
    "Address 1": "Indirizzo 1",
    "orders.address_2": "Indirizzo 2",
    "Address 2": "Indirizzo 2",
    "orders.zip_code": "CAP",
    "Zip code": "CAP",
    "orders.full_address": "Indirizzo completo",
    "Full Address": "Indirizzo completo",
    "orders.formatted_address": "Indirizzo formattato",
    "Formatted Address": "Indirizzo formattato",
    "orders.phone_number": "Numero di telefono",
    "Phone Number": "Numero di telefono",
    "orders.address_not_found": "Indirizzo non trovato",
    "Address not found": "Indirizzo non trovato",
    "orders.address_not_applicable": "Indirizzo non applicabile",
    "Address not applicable": "Indirizzo non applicabile",
    "orders.address_is_not_available": "Indirizzo non disponibile",
    "Address is not available": "Indirizzo non disponibile",
    "orders.add_pickup_address": "Aggiungi indirizzo di ritiro",
    "Add Pickup Address": "Aggiungi indirizzo di ritiro",
    "orders.edit_pickup_address": "Modifica indirizzo di ritiro",
    "Edit Pickup Address": "Modifica indirizzo di ritiro",
    "orders.discard_and_close": "Annulla le modifiche e chiudi",
    "Discard and close": "Annulla le modifiche e chiudi",
    "orders.state": "Provincia",
    "common.country": "Paese",
    "Country": "Paese",
    "orders.sales_payout": "Pagamento vendite",
    "Sales Payout": "Pagamento vendite",
    "orders.sales_no_payout": "Vendite (senza pagamento)",
    "Sales (No Payout)": "Vendite (senza pagamento)",
    "orders.sales_payout_reversal": "Storno del pagamento vendite",
    "Sales Payout Reversal": "Storno del pagamento vendite",
    "orders.sales_no_payout_reversal": "Storno vendite senza pagamento",
    "Sales no payout reversal": "Storno vendite senza pagamento",
    "orders.seller_commission": "Commissione venditore",
    "Seller Commission": "Commissione venditore",
    "orders.seller_commission_reversal": "Storno commissione venditore",
    "Seller Commission Reversal": "Storno commissione venditore",
    "orders.seller_transfer": "Trasferimento al venditore",
    "Seller Transfer": "Trasferimento al venditore",
    "orders.seller_transfer_reversal": "Storno trasferimento al venditore",
    "Seller Transfer Reversal": "Storno trasferimento al venditore",
    "orders.seller_payout": "Pagamento al venditore",
    "Seller Payout": "Pagamento al venditore",
    "orders.seller_subscription": "Abbonamento venditore",
    "Seller Subscription": "Abbonamento venditore",
    "orders.seller_payment_processing_fee": "Commissione di elaborazione del pagamento del venditore",
    "Seller Payment processing fee": "Commissione di elaborazione del pagamento del venditore",
    "orders.seller_payment_processing_fee_reversal": "Storno della commissione di elaborazione del pagamento del venditore",
    "Seller Payment processing fee reversal": "Storno della commissione di elaborazione del pagamento del venditore",
    "orders.sub_total_2": "Subtotale",
    "Sub Total": "Subtotale",
    "orders.customer_commission": "Commissione cliente",
    "Customer Commission": "Commissione cliente",
    "orders.tax": "Imposta",
    "Tax": "Imposta",
    "orders.shipping_charge": "Costo di spedizione",
    "Shipping Charge": "Costo di spedizione",
    "orders.refund": "Rimborso",
    "Refund": "Rimborso",
    "orders.special_fee": "Tariffa speciale",
    "Special Fee": "Tariffa speciale",
    "orders.coupon": "Coupon",
    "Coupon": "Coupon",
    "orders.shipment": "Spedizione",
    "Shipment": "Spedizione",
    "orders.fulfilled_by_platform": "Gestito dalla piattaforma",
    "Fulfilled by platform": "Gestito dalla piattaforma",
    "orders.fulfilled_by": "Gestito da",
    "Fulfilled by": "Gestito da",
    "orders.fulfilled_by_seller": "Gestito dal venditore",
    "Fulfilled by seller": "Gestito dal venditore",
    "orders.on_seller_protection_policy": "Nella protezione venditore",
    "On Seller Protection Policy": "Nella protezione venditore",
    "orders.product_image": "Immagine prodotto",
    "Product image": "Immagine prodotto",
    "orders.status_changed_successfully": "Stato modificato con successo",
    "Status changed successfully": "Stato modificato con successo",
    "orders.pickup_address_not_available_please_add_pickup_address": "Indirizzo di ritiro non disponibile. Aggiungilo.",
    "Pickup Address not available. Please Add Pickup Address": "Indirizzo di ritiro non disponibile. Aggiungilo.",
    "orders.failed_to_save_pickup_address_please_try_again": "Impossibile salvare l’indirizzo di ritiro. Riprova.",
    "Failed to save pickup address. Please try again.": "Impossibile salvare l’indirizzo di ritiro. Riprova.",
    "orders.change_shipment_status": "Cambia stato della spedizione",
    "Change shipment status": "Cambia stato della spedizione",
    "orders.not_available": "Non disponibile",
    "Not available": "Non disponibile",
    "orders.shipment_created": "Spedizione creata",
    "Shipment created": "Spedizione creata",
    "orders.shipment_in_progress": "Spedizione in corso",
    "Shipment in progress": "Spedizione in corso",
    "orders.ship": "Spedisci",
    "orders.undelivered_return": "Reso per mancata consegna",
    "Undelivered return": "Reso per mancata consegna",
    "orders.shipment_deliver": "Consegna spedizione",
    "Shipment deliver": "Consegna spedizione",
    "orders.shipment_delivery_confirm": "Conferma consegna della spedizione",
    "Shipment delivery confirm": "Conferma consegna della spedizione",
    "orders.return_initiate": "Avvia il reso",
    "Return initiate": "Avvia il reso",
    "orders.return_for_pickup": "Reso pronto per il ritiro",
    "Return for pickup": "Reso pronto per il ritiro",
    "orders.shipment_return_confirm": "Conferma il reso della spedizione",
    "Shipment return confirm": "Conferma il reso della spedizione",
    "orders.cancel_by_seller": "Annulla dal venditore",
    "Cancel by seller": "Annulla dal venditore",
    "orders.cancel_by_customer": "Annulla dal cliente",
    "Cancel by customer": "Annulla dal cliente",
    "orders.arrive_at_customer_location": "Arriva all’indirizzo del cliente",
    "Arrive at customer location": "Arriva all’indirizzo del cliente",
    "orders.shipment_delivered": "Spedizione consegnata",
    "Shipment delivered": "Spedizione consegnata",
    "orders.shipment_delivery_confirmed": "Consegna della spedizione confermata",
    "Shipment delivery confirmed": "Consegna della spedizione confermata",
    "orders.returned_for_pickup": "Reso pronto per il ritiro",
    "orders.shipment_return_confirmed": "Reso della spedizione confermato",
    "Shipment return confirmed": "Reso della spedizione confermato",
    "orders.cancelled_by_seller": "Annullato dal venditore",
    "Cancelled by seller": "Annullato dal venditore",
    "common.cancelled_by_admin": "Annullato dall’amministratore",
    "Cancelled by admin": "Annullato dall’amministratore",
    "orders.invoice": "Fattura",
    "Invoice": "Fattura",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Seleziona un tipo di file valido (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Seleziona un tipo di file valido (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "Il file deve essere inferiore a 5 MB",
    "File size must be less than 5MB": "Il file deve essere inferiore a 5 MB",
    "orders.please_upload_a_file_first": "Carica prima un file",
    "Please upload a file first": "Carica prima un file",
    "orders.invoice_uploaded_successfully": "Fattura caricata correttamente!",
    "Invoice uploaded successfully!": "Fattura caricata correttamente!",
    "orders.failed_to_upload_invoice_please_try_again": "Impossibile caricare la fattura. Riprova.",
    "Failed to upload invoice. Please try again.": "Impossibile caricare la fattura. Riprova.",
    "orders.upload_invoice": "Carica fattura",
    "Upload Invoice": "Carica fattura",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Formati supportati: PDF, JPG, PNG, DOC (max 5 MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Formati supportati: PDF, JPG, PNG, DOC (max 5 MB)",
    "orders.uploading": "Caricamento…",
    "orders.choose_file": "Scegli file",
    "Choose File": "Scegli file",
    "common.download": "Scarica",
    "Download": "Scarica",
    "common.remove": "Rimuovi",
    "Remove": "Rimuovi",
    "orders.upload_new_file": "Carica un nuovo file",
    "Upload New File": "Carica un nuovo file",
    "orders.saving": "Salvataggio…",
    "Saving...": "Salvataggio…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "L’eliminazione rimuoverà subito l’ordine dalle viste del venditore e dell’acquirente. Dopo l’eliminazione non sarà più possibile aggiornare lo stato e l’ordine verrà escluso da metriche e report. Vuoi continuare?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "L’eliminazione rimuoverà subito l’ordine dalle viste del venditore e dell’acquirente. Dopo l’eliminazione non sarà più possibile aggiornare lo stato e l’ordine verrà escluso da metriche e report. Vuoi continuare?",
    "common.showing": "Visualizzazione",
    "Showing": "Visualizzazione",
    "common.of": "di",
    "of": "di",
    "common.all": "Tutti",
    "common.active": "Attivo",
    "common.inactive": "Inattivo",
    "common.enabled": "Abilitato",
    "Enabled": "Abilitato",
    "common.disabled": "Disabilitato",
    "Disabled": "Disabilitato",
    "common.success": "Operazione riuscita",
    "common.error": "Errore",
    "Error": "Errore",
    "common.warning": "Avviso",
    "Warning": "Avviso",
    "common.required": "Obbligatorio",
    "Required": "Obbligatorio",
    "users.title": "Utenti",
    "users.import": "Importa",
    "Import": "Importa",
    "users.import_users": "Importa utenti",
    "Import users": "Importa utenti",
    "users.smart_upload_users": "Caricamento smart degli utenti",
    "Smart Upload Users": "Caricamento smart degli utenti",
    "users.smart_upload_beta": "Caricamento smart degli utenti (Beta)",
    "Smart upload users (Beta)": "Caricamento smart degli utenti (Beta)",
    "users.export": "Esporta",
    "Export": "Esporta",
    "users.export_users": "Esporta utenti",
    "Export users": "Esporta utenti",
    "users.search_users": "Cerca utenti",
    "Search users": "Cerca utenti",
    "users.verified": "Verificato",
    "Verified": "Verificato",
    "users.not_verified": "Non verificato",
    "Non Verified": "Non verificato",
    "users.block": "Blocca",
    "Block": "Blocca",
    "users.unblock": "Sblocca",
    "Unblock": "Sblocca",
    "users.confirm_block": "Vuoi bloccare questo utente?",
    "Do you want to block this user?": "Vuoi bloccare questo utente?",
    "users.confirm_unblock": "Vuoi sbloccare questo utente?",
    "Do you want to unblock this user?": "Vuoi sbloccare questo utente?",
    "users.import_export": "Importazione ed esportazione utenti",
    "User import and export": "Importazione ed esportazione utenti",
    "users.user_id": "ID utente",
    "User ID": "ID utente",
    "users.first_name": "Nome",
    "First Name": "Nome",
    "users.last_name": "Cognome",
    "Last Name": "Cognome",
    "users.email": "Email",
    "users.phone_number": "Numero di telefono",
    "users.country": "Paese",
    "users.profile": "Profilo",
    "Profile": "Profilo",
    "users.email_verified": "Email verificata",
    "Email Verified": "Email verificata",
    "users.blocked": "Bloccato",
    "Blocked": "Bloccato",
    "users.action": "Azione",
    "users.join_date": "Data di iscrizione",
    "Join Date": "Data di iscrizione",
    "users.last_login": "Ultimo accesso",
    "Last Login": "Ultimo accesso",
    "users.customer_type": "Tipo cliente",
    "Customer Type": "Tipo cliente",
    "common.and": "e",
    "and": "e",
    "users.import_failed": "Importazione utenti non riuscita.",
    "User import failed.": "Importazione utenti non riuscita.",
    "users.smart_upload.paid_title": "Il caricamento smart degli utenti è una funzionalità a pagamento",
    "Smart user upload is a paid feature": "Il caricamento smart degli utenti è una funzionalità a pagamento",
    "users.smart_upload.paid_description": "Passa al piano Starter o Go per caricare utenti da un file CSV.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "Passa al piano Starter o Go per caricare utenti da un file CSV.",
    "users.smart_upload.view_plans": "Visualizza piani",
    "users.smart_upload.csv_needs_user": "Il CSV deve contenere una riga di intestazione e almeno un utente.",
    "The CSV must contain a header row and at least one user.": "Il CSV deve contenere una riga di intestazione e almeno un utente.",
    "users.smart_upload.unique_headers": "Ogni colonna utente deve avere un’intestazione univoca e non vuota.",
    "Every user column needs a unique, non-empty header.": "Ogni colonna utente deve avere un’intestazione univoca e non vuota.",
    "users.smart_upload.csv_read_error": "Impossibile leggere questo CSV.",
    "Unable to read this CSV.": "Impossibile leggere questo CSV.",
    "users.smart_upload.map_required": "Mappa {fields} prima di continuare.",
    "Map {fields} before continuing.": "Mappa {fields} prima di continuare.",
    "users.smart_upload.map_contact": "Mappa una colonna Email o Phone. Ogni riga deve avere almeno un metodo di contatto.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Mappa una colonna Email o Phone. Ogni riga deve avere almeno un metodo di contatto.",
    "users.smart_upload.invalid_row": "Nella riga {row} manca il nome o un recapito obbligatorio.",
    "Row {row} is missing a required name or contact value.": "Nella riga {row} manca il nome o un recapito obbligatorio.",
    "users.smart_upload.attribute_name_required": "Inserisci un nome per l’attributo “{header}”.",
    "Enter an attribute name for “{header}”.": "Inserisci un nome per l’attributo “{header}”.",
    "users.smart_upload.attribute_create_error": "Impossibile creare l’attributo “{name}”.",
    "Could not create the “{name}” attribute.": "Impossibile creare l’attributo “{name}”.",
    "users.smart_upload.attribute_missing": "L’attributo associato a “{header}” non è più disponibile.",
    "The attribute mapped from “{header}” is no longer available.": "L’attributo associato a “{header}” non è più disponibile.",
    "users.smart_upload.prepare_error": "Impossibile preparare il file di importazione.",
    "Could not prepare the import file.": "Impossibile preparare il file di importazione.",
    "users.smart_upload.upload_error": "Impossibile caricare il file di importazione.",
    "The import file could not be uploaded.": "Impossibile caricare il file di importazione.",
    "users.smart_upload.all_duplicates": "Tutte le righe di questo file sono duplicate.",
    "Every row is a duplicate of another row in this file.": "Tutte le righe di questo file sono duplicate.",
    "users.smart_upload.source_attribute_error": "Impossibile creare l’attributo contact_source.",
    "Could not create the contact_source attribute.": "Impossibile creare l’attributo contact_source.",
    "users.smart_upload.duplicates_skipped": "Righe duplicate da ignorare: {count}.",
    "Duplicate rows to skip: {count}.": "Righe duplicate da ignorare: {count}.",
    "users.smart_upload.preparing_attributes": "Preparazione degli attributi",
    "Preparing attributes": "Preparazione degli attributi",
    "users.smart_upload.checking_users": "Verifica degli utenti esistenti",
    "Checking existing users": "Verifica degli utenti esistenti",
    "users.smart_upload.uploading_file": "Caricamento del file di importazione",
    "Uploading import file": "Caricamento del file di importazione",
    "users.smart_upload.importing_users": "Tradly sta importando gli utenti",
    "Tradly is importing users": "Tradly sta importando gli utenti",
    "users.smart_upload.import_stopped": "Importazione interrotta",
    "Import stopped": "Importazione interrotta",
    "users.smart_upload.title": "Caricamento smart degli utenti",
    "Smart user upload": "Caricamento smart degli utenti",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Ricomincia",
    "Start over": "Ricomincia",
    "users.smart_upload.description": "Carica i contatti, associa le colonne agli attributi utente e classificali come contatti in uscita o utenti registrati.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Carica i contatti, associa le colonne agli attributi utente e classificali come contatti in uscita o utenti registrati.",
    "users.smart_upload.step_upload": "Carica",
    "users.smart_upload.step_match": "Associa colonne",
    "Match columns": "Associa colonne",
    "users.smart_upload.step_review": "Revisione",
    "users.smart_upload.step_import": "Importa",
    "users.smart_upload.choose_csv": "Scegli un file CSV",
    "Choose a CSV file": "Scegli un file CSV",
    "users.smart_upload.required_fields": "Sono obbligatori nome, cognome ed email o telefono. Le password vengono generate automaticamente.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Sono obbligatori nome, cognome ed email o telefono. Le password vengono generate automaticamente.",
    "users.smart_upload.select_csv": "Seleziona file CSV",
    "Select CSV file": "Seleziona file CSV",
    "users.smart_upload.match_columns": "Associa le colonne utente",
    "Match user columns": "Associa le colonne utente",
    "users.smart_upload.first_name": "Nome",
    "First name": "Nome",
    "users.smart_upload.last_name": "Cognome",
    "Last name": "Cognome",
    "users.smart_upload.email": "Email",
    "users.smart_upload.phone": "Telefono",
    "users.smart_upload.username": "Nome utente",
    "Username": "Nome utente",
    "users.smart_upload.do_not_import": "Non importare",
    "Do not import": "Non importare",
    "users.smart_upload.additional_attributes": "Attributi utente aggiuntivi",
    "Additional user attributes": "Attributi utente aggiuntivi",
    "users.smart_upload.ignore_column": "Ignora questa colonna",
    "Ignore this column": "Ignora questa colonna",
    "users.smart_upload.create_attribute": "Crea un nuovo attributo utente",
    "Create a new user attribute": "Crea un nuovo attributo utente",
    "users.smart_upload.attribute_name": "Nome attributo",
    "Attribute name": "Nome attributo",
    "users.smart_upload.type_text": "Testo",
    "Text": "Testo",
    "users.smart_upload.type_long_text": "Testo lungo",
    "Long text": "Testo lungo",
    "users.smart_upload.type_number": "Numero",
    "Number": "Numero",
    "users.smart_upload.type_single_select": "Selezione singola",
    "Single select": "Selezione singola",
    "users.smart_upload.type_multi_select": "Selezione multipla",
    "Multi select": "Selezione multipla",
    "users.smart_upload.review_import": "Rivedi importazione",
    "Review import": "Rivedi importazione",
    "users.smart_upload.review_description": "Contatti da importare: {count}. L’API potrebbe rifiutare gli utenti Tradly già esistenti; ripetere un’importazione parziale può duplicare le righe già riuscite.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "Contatti da importare: {count}. L’API potrebbe rifiutare gli utenti Tradly già esistenti; ripetere un’importazione parziale può duplicare le righe già riuscite.",
    "users.smart_upload.contact_classification": "Classificazione contatti",
    "Contact classification": "Classificazione contatti",
    "users.smart_upload.outbound": "Contatto in uscita (non ha acconsentito)",
    "Outbound (not opted in)": "Contatto in uscita (non ha acconsentito)",
    "users.smart_upload.signed_up": "Registrato (ha acconsentito)",
    "Signed-up (opted in)": "Registrato (ha acconsentito)",
    "users.smart_upload.contact_source_help": "Il valore viene salvato nell’attributo contact_source. Il tipo utente integrato di Tradly resta customer.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Il valore viene salvato nell’attributo contact_source. Il tipo utente integrato di Tradly resta customer.",
    "users.smart_upload.import_complete": "Importazione utenti completata",
    "User import complete": "Importazione utenti completata",
    "users.smart_upload.imported_summary": "Importati {imported} utenti su {total}.",
    "{imported} of {total} users imported.": "Importati {imported} utenti su {total}.",
    "users.smart_upload.selected_file": "Selezionato: {name}",
    "Selected: {name}": "Selezionato: {name}",
    "users.smart_upload.review_action": "Rivedi",
    "users.smart_upload.importing_action": "Importazione…",
    "Importing…": "Importazione…",
    "users.smart_upload.import_users_action": "Importa utenti",
    "users.import.uploading": "Caricamento…",
    "Uploading…": "Caricamento…",
    "users.import.please_wait": "Attendi…",
    "Please wait…": "Attendi…",
    "users.import.error_prefix": "Errore",
    "users.import.select_file_error": "Seleziona un file",
    "Please select a file": "Seleziona un file",
    "users.import.download": "Scarica",
    "users.import.file_label": "File:",
    "File:": "File:",
    "users.import.select_file": "Seleziona file",
    "Select File": "Seleziona file",
    "users.import.upload": "Carica",
    "users.create.button": "Crea utente",
    "Create User": "Crea utente",
    "users.create.title": "Crea nuovo utente",
    "Create New User": "Crea nuovo utente",
    "users.create.please_wait": "Attendi…",
    "users.create.email": "Email",
    "users.create.first_name": "Nome",
    "users.create.last_name": "Cognome",
    "users.create.email_required": "L’email è obbligatoria",
    "Email is required": "L’email è obbligatoria",
    "users.create.first_name_required": "Il nome è obbligatorio",
    "First Name is required": "Il nome è obbligatorio",
    "users.create.last_name_required": "Il cognome è obbligatorio",
    "Last Name is required": "Il cognome è obbligatorio",
    "users.create.session_expired": "La sessione di amministrazione è scaduta. Accedi di nuovo prima di creare un utente.",
    "Your admin session has expired. Please sign in again before creating a user.": "La sessione di amministrazione è scaduta. Accedi di nuovo prima di creare un utente.",
    "users.create.unable_to_create": "Impossibile creare questo utente.",
    "Unable to create this user.": "Impossibile creare questo utente.",
    "users.create.success": "Utente creato correttamente",
    "User created successfully": "Utente creato correttamente",
    "users.create.failed": "Creazione utente non riuscita. Riprova.",
    "User creation failed. Please try again.": "Creazione utente non riuscita. Riprova.",
    "common.feature_flow.eyebrow": "SCOPRI COME FUNZIONA",
    "SEE HOW IT WORKS": "SCOPRI COME FUNZIONA",
    "common.feature_flow.open_guide": "Apri la guida",
    "Open flow guide": "Apri la guida",
    "common.feature_flow.close_guide": "Chiudi la guida della sezione",
    "Close section guide": "Chiudi la guida della sezione",
    "common.feature_flow.section_guide": "Guida della sezione",
    "Section guide": "Guida della sezione",
    "users.flow.title": "Tutto ciò che ti serve per gestire gli utenti",
    "Everything you need to manage your users": "Tutto ciò che ti serve per gestire gli utenti",
    "users.flow.description": "Crea profili utente, personalizza i dati e analizza i feedback dei clienti in un unico posto.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Crea profili utente, personalizza i dati e analizza i feedback dei clienti in un unico posto.",
    "users.flow.lane_title": "Gestione utenti",
    "User management": "Gestione utenti",
    "users.flow.badge": "Strumenti essenziali",
    "Core tools": "Strumenti essenziali",
    "users.flow.attributes": "Attributi",
    "Attributes": "Attributi",
    "users.flow.reviews": "Recensioni",
    "Reviews": "Recensioni",
    "users.flow.lane_description": "Gestisci le persone, aggiungi i campi del profilo necessari e scopri la loro esperienza.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Gestisci le persone, aggiungi i campi del profilo necessari e scopri la loro esperienza.",
    "users.flow.primary_action": "Aggiungi il primo utente",
    "Add your first user": "Aggiungi il primo utente",
    "users.tooltip.title": "Ogni persona è un utente distinto",
    "Every individual is a unique user": "Ogni persona è un utente distinto",
    "users.tooltip.description": "Immagina per un momento di possedere un centro commerciale.\n\nOgni persona che entra in un negozio è considerata un utente.\n\nAnche ogni commerciante che gestisce un negozio è considerato un utente.\n\nIn Tradly tutti, commercianti o clienti, sono chiamati “Utenti” e i loro dati univoci sono salvati nella sezione utenti. Qui puoi trovare i dettagli degli acquisti o degli account che possiedono.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Immagina per un momento di possedere un centro commerciale.\n\nOgni persona che entra in un negozio è considerata un utente.\n\nAnche ogni commerciante che gestisce un negozio è considerato un utente.\n\nIn Tradly tutti, commercianti o clienti, sono chiamati “Utenti” e i loro dati univoci sono salvati nella sezione utenti. Qui puoi trovare i dettagli degli acquisti o degli account che possiedono.",
    "workspace.loading": "Caricamento delle impostazioni dello spazio di lavoro…",
    "Loading workspace settings…": "Caricamento delle impostazioni dello spazio di lavoro…",
    "workspace.kicker": "SPAZIO DI LAVORO",
    "WORKSPACE": "SPAZIO DI LAVORO",
    "workspace.fallback_name": "Area di lavoro",
    "workspace.members.title": "Invita un membro del team",
    "Invite Team Member": "Invita un membro del team",
    "workspace.members.description": "Aggiungi i colleghi e assegna a ciascuno solo gli accessi necessari.",
    "Add teammates and give each person only the access they need.": "Aggiungi i colleghi e assegna a ciascuno solo gli accessi necessari.",
    "workspace.members.enter_name_email": "Inserisci il nome del membro e l’indirizzo email.",
    "Enter a member name and email address.": "Inserisci il nome del membro e l’indirizzo email.",
    "workspace.members.invitation_sent": "Invito inviato.",
    "Invitation sent.": "Invito inviato.",
    "workspace.members.confirm_remove": "Rimuovere {name} da questo spazio di lavoro?",
    "Remove {name} from this workspace?": "Rimuovere {name} da questo spazio di lavoro?",
    "workspace.members.removed": "Membro del team rimosso.",
    "Team member removed.": "Membro del team rimosso.",
    "workspace.members.roles_saved": "Ruoli del membro salvati.",
    "Member roles saved.": "Ruoli del membro salvati.",
    "workspace.members.read": "Lettura",
    "Read": "Lettura",
    "workspace.members.write": "Scrittura",
    "Write": "Scrittura",
    "workspace.members.delete": "Eliminazione",
    "workspace.members.select_all_permission": "Seleziona tutti i permessi {permission} in {group}",
    "Select all {permission} in {group}": "Seleziona tutti i permessi {permission} in {group}",
    "workspace.members.member_name": "Nome membro",
    "Member Name": "Nome membro",
    "workspace.members.email_address": "Indirizzo email",
    "Email Address": "Indirizzo email",
    "workspace.members.sending": "Invio…",
    "Sending…": "Invio…",
    "workspace.members.send_invitation": "Invia invito",
    "Send invitation": "Invia invito",
    "workspace.members.team_members": "Membri del team",
    "Team members": "Membri del team",
    "workspace.members.search_members": "Cerca membri",
    "Search members": "Cerca membri",
    "workspace.members.search": "Cerca",
    "workspace.members.member": "Membro",
    "Member": "Membro",
    "workspace.members.email": "Email",
    "workspace.members.status": "Stato",
    "workspace.members.actions": "Azioni",
    "workspace.members.unnamed": "Membro senza nome",
    "Unnamed member": "Membro senza nome",
    "workspace.members.roles": "Ruoli",
    "Roles": "Ruoli",
    "workspace.members.empty": "Nessun membro del team trovato.",
    "No team members found.": "Nessun membro del team trovato.",
    "workspace.members.page_of": "Pagina {page} di {pages}",
    "Page {page} of {pages}": "Pagina {page} di {pages}",
    "workspace.members.assign_roles": "Assegna ruoli",
    "Assign roles": "Assegna ruoli",
    "workspace.members.save_roles": "Salva ruoli",
    "Save roles": "Salva ruoli",
    "workspace.members.saving": "Salvataggio…",
    "Saving…": "Salvataggio…",
    "workspace.error.generic": "Qualcosa è andato storto. Riprova.",
    "Something went wrong. Please try again.": "Qualcosa è andato storto. Riprova.",
    "workspace.billing.view_label": "Vista fatturazione dello spazio di lavoro",
    "Billing workspace view": "Vista fatturazione dello spazio di lavoro",
    "workspace.billing.tab_usage": "Utilizzo",
    "Usage": "Utilizzo",
    "workspace.billing.tab_plans": "Piani",
    "workspace.billing.tab_invoices": "Fatture pagate",
    "Paid invoices": "Fatture pagate",
    "workspace.billing.tab_account": "Account",
    "workspace.account.title": "Impostazioni aziendali",
    "Business Settings": "Impostazioni aziendali",
    "workspace.account.description": "Gestisci il profilo aziendale, i prodotti attivati e la privacy dell’account.",
    "Manage your business profile, enabled products, and account privacy.": "Gestisci il profilo aziendale, i prodotti attivati e la privacy dell’account.",
    "workspace.account.profile_updated": "Profilo aziendale aggiornato.",
    "Business profile updated.": "Profilo aziendale aggiornato.",
    "workspace.account.logo_updated": "Logo aggiornato.",
    "Logo updated.": "Logo aggiornato.",
    "workspace.account.logo_upload_error": "Impossibile caricare il logo.",
    "Unable to upload logo.": "Impossibile caricare il logo.",
    "workspace.account.confirm_delete": "Eliminare definitivamente questo account Tradly? L’operazione non può essere annullata.",
    "Delete this Tradly account permanently? This cannot be undone.": "Eliminare definitivamente questo account Tradly? L’operazione non può essere annullata.",
    "workspace.account.business_profile": "Profilo aziendale",
    "Business Profile": "Profilo aziendale",
    "workspace.account.logo": "Logo",
    "Logo": "Logo",
    "workspace.account.logo_alt": "Logo aziendale",
    "Business logo": "Logo aziendale",
    "workspace.account.add_photo": "Aggiungi foto",
    "Add photo": "Aggiungi foto",
    "workspace.account.logo_formats": "PNG, JPG, SVG o ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG o ICO",
    "workspace.account.business_name": "Nome azienda",
    "Business Name": "Nome azienda",
    "workspace.account.contact_name": "Referente aziendale",
    "Business Contact Name": "Referente aziendale",
    "workspace.account.business_address": "Indirizzo aziendale",
    "Business Address": "Indirizzo aziendale",
    "workspace.account.products_of_interest": "Prodotti di interesse",
    "Products of Interest": "Prodotti di interesse",
    "workspace.account.marketplace": "Marketplace",
    "workspace.account.single_store": "E-commerce con un solo negozio",
    "Single Store Commerce": "E-commerce con un solo negozio",
    "workspace.account.alacarte_products": "Prodotti singoli",
    "À la carte Products": "Prodotti singoli",
    "workspace.account.alacarte_description": "I singoli prodotti attivati per questo spazio di lavoro si gestiscono in Piani e fatturazione.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "I singoli prodotti attivati per questo spazio di lavoro si gestiscono in Piani e fatturazione.",
    "workspace.account.manage_alacarte": "Gestisci i prodotti singoli",
    "Manage à la carte products": "Gestisci i prodotti singoli",
    "workspace.account.delete_irreversible": "Eliminazione account: irreversibile",
    "Delete your Account: Irreversible": "Eliminazione account: irreversibile",
    "workspace.account.delete_description": "Questa operazione elimina definitivamente il tenant Tradly e tutti i dati associati.",
    "This permanently deletes the Tradly tenant and all associated data.": "Questa operazione elimina definitivamente il tenant Tradly e tutti i dati associati.",
    "workspace.account.deleting": "Eliminazione…",
    "Deleting…": "Eliminazione…",
    "workspace.account.delete_button": "Elimina account Tradly",
    "Delete Account With Tradly": "Elimina account Tradly",
    "workspace.privacy.title": "Privacy e responsabili del trattamento",
    "Privacy & Data Processors": "Privacy e responsabili del trattamento",
    "workspace.privacy.description": "Scopri quali responsabili supportano Tradly e come vengono conservati i dati dopo una richiesta di eliminazione.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Scopri quali responsabili supportano Tradly e come vengono conservati i dati dopo una richiesta di eliminazione.",
    "workspace.privacy.processor_retention": "Utilizziamo i seguenti servizi e strumenti per gestire il servizio, migliorare la qualità del prodotto e supportare fatturazione e affidabilità. Il periodo di conservazione si applica solo dopo che un utente richiede l’eliminazione dell’account. I dati degli utenti Tradly Platform vengono conservati per circa 90–180 giorni, in base a esigenze operative e di conformità.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Utilizziamo i seguenti servizi e strumenti per gestire il servizio, migliorare la qualità del prodotto e supportare fatturazione e affidabilità. Il periodo di conservazione si applica solo dopo che un utente richiede l’eliminazione dell’account. I dati degli utenti Tradly Platform vengono conservati per circa 90–180 giorni, in base a esigenze operative e di conformità.",
    "workspace.privacy.read_more": "Scopri di più.",
    "Read more.": "Scopri di più.",
    "workspace.privacy.tool": "Strumento",
    "Tool": "Strumento",
    "workspace.privacy.purpose": "Finalità",
    "Purpose": "Finalità",
    "workspace.privacy.data_category": "Categoria di dati",
    "Data Category": "Categoria di dati",
    "workspace.privacy.deletion_requests": "Richieste di eliminazione account e dati",
    "Account deletion and data requests": "Richieste di eliminazione account e dati",
    "workspace.privacy.deletion_description": "Per richiedere l’eliminazione dell’account o la rimozione da uno strumento per le relazioni con i clienti, contatta l’amministratore dello spazio di lavoro o l’assistenza. Queste azioni richiedono una conferma backend prima di essere rese disponibili qui.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Per richiedere l’eliminazione dell’account o la rimozione da uno strumento per le relazioni con i clienti, contatta l’amministratore dello spazio di lavoro o l’assistenza. Queste azioni richiedono una conferma backend prima di essere rese disponibili qui.",
    "workspace.privacy.open_account": "Apri le impostazioni account",
    "Open account settings": "Apri le impostazioni account",
    "workspace.privacy.core_operations": "Operazioni principali del prodotto",
    "Core product operations": "Operazioni principali del prodotto",
    "workspace.privacy.user_data_retention": "Dati utente (conservazione: 90–180 giorni)",
    "User data (retention: 90–180 days)": "Dati utente (conservazione: 90–180 giorni)",
    "workspace.privacy.crm_support_lifecycle": "CRM, assistenza, comunicazioni durante il ciclo di vita",
    "CRM, support, lifecycle communication": "CRM, assistenza, comunicazioni durante il ciclo di vita",
    "workspace.privacy.personal_data": "Dati personali",
    "Personal data": "Dati personali",
    "workspace.privacy.product_analytics": "Analisi del prodotto e funnel di coinvolgimento",
    "Product analytics and engagement funnels": "Analisi del prodotto e funnel di coinvolgimento",
    "workspace.privacy.usage_events": "Analisi di utilizzo ed eventi",
    "Usage and event analytics": "Analisi di utilizzo ed eventi",
    "workspace.privacy.billing_payments": "Fatturazione ed elaborazione dei pagamenti",
    "Billing and payment processing": "Fatturazione ed elaborazione dei pagamenti",
    "workspace.privacy.billing_data": "Dati di fatturazione",
    "Billing data": "Dati di fatturazione",
    "workspace.privacy.traffic_analytics": "Analisi del traffico e del comportamento",
    "Traffic and behavior analytics": "Analisi del traffico e del comportamento",
    "workspace.privacy.usage_analytics": "Analisi di utilizzo",
    "Usage analytics": "Analisi di utilizzo",
    "workspace.privacy.session_diagnostics": "Analisi delle sessioni e diagnostica dei pulsanti non funzionanti",
    "Session insights and broken-button diagnostics": "Analisi delle sessioni e diagnostica dei pulsanti non funzionanti",
    "workspace.privacy.ux_telemetry": "Telemetria UX e delle sessioni",
    "UX/session telemetry": "Telemetria UX e delle sessioni",
    "workspace.privacy.error_monitoring": "Monitoraggio degli errori del codice e della stabilità",
    "Code error and stability monitoring": "Monitoraggio degli errori del codice e della stabilità",
    "workspace.privacy.error_logs": "Log degli errori e diagnostica",
    "Error logs and diagnostics": "Log degli errori e diagnostica",
    "workspace.privacy.email_delivery": "Invio di email transazionali",
    "Transactional email delivery": "Invio di email transazionali",
    "workspace.privacy.email_metadata": "Metadati email",
    "Email metadata": "Metadati email",
    "workspace.privacy.hosting_infrastructure": "Hosting e infrastruttura",
    "Hosting and infrastructure": "Hosting e infrastruttura",
    "workspace.privacy.infrastructure_logs": "Log dell’infrastruttura e del servizio",
    "Infrastructure and service logs": "Log dell’infrastruttura e del servizio",
    "workspace.domain.title": "Domini",
    "Domains": "Domini",
    "workspace.domain.description": "Collega un tuo dominio per sostituire l’URL Tradly predefinito.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Collega un tuo dominio per sostituire l’URL Tradly predefinito.",
    "workspace.domain.invalid": "Inserisci un dominio valido, ad esempio example.com.",
    "Enter a valid domain, such as example.com.": "Inserisci un dominio valido, ad esempio example.com.",
    "workspace.domain.reserved": "tradly.co è riservato ai domini ospitati degli spazi di lavoro.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co è riservato ai domini ospitati degli spazi di lavoro.",
    "workspace.domain.missing_primary": "Il dominio principale dello spazio di lavoro non è disponibile.",
    "No primary workspace domain is available.": "Il dominio principale dello spazio di lavoro non è disponibile.",
    "workspace.domain.saved": "Dominio personalizzato salvato. Aggiorna i record DNS, quindi controlla di nuovo lo stato.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Dominio personalizzato salvato. Aggiorna i record DNS, quindi controlla di nuovo lo stato.",
    "workspace.domain.reset_success": "Dominio ripristinato all’URL Tradly ospitato.",
    "Domain reset to the Tradly-hosted URL.": "Dominio ripristinato all’URL Tradly ospitato.",
    "workspace.domain.current": "DOMINIO ATTUALE",
    "CURRENT DOMAIN": "DOMINIO ATTUALE",
    "workspace.domain.hosted": "Dominio ospitato da Tradly",
    "Tradly-hosted domain": "Dominio ospitato da Tradly",
    "workspace.domain.dns_status": "Stato DNS: {status}",
    "DNS status: {status}": "Stato DNS: {status}",
    "workspace.domain.checking": "Verifica dello stato DNS…",
    "Checking DNS status…": "Verifica dello stato DNS…",
    "workspace.domain.refresh": "Aggiorna stato",
    "Refresh status": "Aggiorna stato",
    "workspace.domain.reset": "Reimposta dominio",
    "Reset domain": "Reimposta dominio",
    "workspace.domain.connect_title": "Collega un dominio personalizzato",
    "Connect a custom domain": "Collega un dominio personalizzato",
    "workspace.domain.connect_description": "Inserisci un dominio di tua proprietà. Ti mostreremo i record DNS necessari per collegarlo.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Inserisci un dominio di tua proprietà. Ti mostreremo i record DNS necessari per collegarlo.",
    "workspace.domain.saving": "Salvataggio…",
    "workspace.domain.add": "Aggiungi dominio",
    "Add domain": "Aggiungi dominio",
    "workspace.domain.dns_title": "Configurazione DNS",
    "DNS setup": "Configurazione DNS",
    "workspace.domain.a_record": "Record A",
    "A record": "Record A",
    "workspace.domain.root_description": "Usalo per un dominio radice, ad esempio",
    "Use this for a root domain such as": "Usalo per un dominio radice, ad esempio",
    "workspace.domain.cname_record": "Record CNAME",
    "CNAME record": "Record CNAME",
    "workspace.domain.subdomain_description": "Usalo per un sottodominio, ad esempio",
    "Use this for a subdomain such as": "Usalo per un sottodominio, ad esempio",
    "workspace.domain.host": "Host",
    "Host": "Host",
    "workspace.domain.value": "Valore",
    "Value": "Valore",
    "workspace.domain.need_domain": "Ti serve un dominio?",
    "Need a domain?": "Ti serve un dominio?",
    "workspace.domain.buy_domain": "Acquista un dominio da Google Domains o GoDaddy, poi torna qui per collegarlo.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Acquista un dominio da Google Domains o GoDaddy, poi torna qui per collegarlo.",
    "workspace.billing.title": "Fatturazione e utilizzo",
    "Billing & Usage": "Fatturazione e utilizzo",
    "workspace.billing.description": "Gestisci piani, utilizzo e fatturazione dello spazio di lavoro.",
    "Manage workspace plans, usage, and billing.": "Gestisci piani, utilizzo e fatturazione dello spazio di lavoro.",
    "workspace.billing.invoice_description": "Gestisci piani, utilizzo e fatture pagate dello spazio di lavoro.",
    "Manage workspace plans, usage, and paid invoices.": "Gestisci piani, utilizzo e fatture pagate dello spazio di lavoro.",
    "workspace.billing.usage_description": "Consulta l’utilizzo corrente e i limiti applicati a questo spazio di lavoro.",
    "workspace.invoices.loading": "Caricamento fatture…",
    "Loading invoices…": "Caricamento fatture…",
    "workspace.invoices.description": "Scarica le fatture o completa il pagamento del saldo dovuto.",
    "Download invoices or complete payment for an outstanding balance.": "Scarica le fatture o completa il pagamento del saldo dovuto.",
    "workspace.invoices.payment_failed": "Pagamento non riuscito — l’accesso al servizio potrebbe essere compromesso.",
    "Payment failed — service access may be affected.": "Pagamento non riuscito — l’accesso al servizio potrebbe essere compromesso.",
    "workspace.invoices.awaiting_payment": "La fattura {invoice} è in attesa di pagamento.",
    "Invoice {invoice} is awaiting payment.": "La fattura {invoice} è in attesa di pagamento.",
    "workspace.invoices.outstanding": "in sospeso",
    "outstanding": "in sospeso",
    "workspace.invoices.pay_invoice": "Paga fattura",
    "Pay invoice": "Paga fattura",
    "workspace.invoices.invoice": "Fattura",
    "workspace.invoices.date": "Data",
    "workspace.invoices.amount": "Importo",
    "workspace.invoices.paid": "Pagata",
    "workspace.invoices.unpaid": "Non pagata",
    "workspace.invoices.download_invoice": "Scarica fattura",
    "Download invoice": "Scarica fattura",
    "workspace.invoices.empty_title": "Nessuna fattura disponibile",
    "No invoices available": "Nessuna fattura disponibile",
    "workspace.invoices.empty_description": "Le fatture vengono create dopo l’iscrizione e il pagamento. Contatta l’assistenza per qualsiasi domanda.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Le fatture vengono create dopo l’iscrizione e il pagamento. Contatta l’assistenza per qualsiasi domanda.",
    "workspace.plans.heading": "Piani",
    "workspace.plans.tab_marketplace": "Marketplace",
    "workspace.plans.tab_marketplace_description": "Multi-venditore",
    "Multi-vendor": "Multi-venditore",
    "workspace.plans.tab_single": "Negozio singolo",
    "Single Store": "Negozio singolo",
    "workspace.plans.tab_single_description": "Per creator e aziende indipendenti",
    "Indie & Creators": "Per creator e aziende indipendenti",
    "workspace.plans.tab_alacarte": "Singoli prodotti",
    "A la carte": "Singoli prodotti",
    "workspace.plans.tab_alacarte_description": "Crediti e componenti aggiuntivi",
    "Credits & add-ons": "Crediti e componenti aggiuntivi",
    "workspace.plans.tab_services": "Servizi",
    "Services": "Servizi",
    "workspace.plans.tab_services_description": "Servizi aggiuntivi",
    "Additional services": "Servizi aggiuntivi",
    "workspace.plans.selected": "Selezionato",
    "Selected": "Selezionato",
    "workspace.plans.try_again": "Riprova",
    "Try again": "Riprova",
    "workspace.plans.bill_yearly": "Fatturazione annuale",
    "Bill Yearly": "Fatturazione annuale",
    "workspace.plans.bill_monthly": "Fatturazione mensile",
    "Bill Monthly": "Fatturazione mensile",
    "workspace.plans.compare": "Confronta i piani",
    "Compare Plans": "Confronta i piani",
    "workspace.plans.community": "Community",
    "workspace.plans.community_description": "Gratis per sempre. Perfetto per progetti personali e comunitari.",
    "Free forever. Perfect for hobbyists and community projects.": "Gratis per sempre. Perfetto per progetti personali e comunitari.",
    "workspace.plans.different_configurations": "Cerchi una configurazione diversa?",
    "Looking for different configurations?": "Cerchi una configurazione diversa?",
    "workspace.plans.contact_us": "Contattaci",
    "Contact Us": "Contattaci",
    "workspace.plans.see_alacarte_pricing": "Vedi i prezzi dei singoli prodotti",
    "See à la carte pricing": "Vedi i prezzi dei singoli prodotti",
    "workspace.plans.available": "Disponibile",
    "Available": "Disponibile",
    "workspace.plans.used_90d": "Usato (90 gg)",
    "Used (90d)": "Usato (90 gg)",
    "workspace.plans.expired_90d": "Scaduto (90 gg)",
    "Expired (90d)": "Scaduto (90 gg)",
    "workspace.plans.expires_on": "Scade il {date}",
    "Expires {date}": "Scade il {date}",
    "workspace.plans.top_up_credits": "Ricarica crediti",
    "Top Up Credits": "Ricarica crediti",
    "workspace.plans.credits_description": "I crediti servono per email, ricerca AI, consigli e azioni degli agenti. 100 crediti = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "I crediti servono per email, ricerca AI, consigli e azioni degli agenti. 100 crediti = $5.",
    "workspace.plans.credits": "crediti",
    "credits": "crediti",
    "workspace.plans.custom_amount": "Importo personalizzato",
    "Custom amount": "Importo personalizzato",
    "workspace.plans.amount_example": "es. 2500",
    "e.g. 2500": "es. 2500",
    "workspace.plans.opening_checkout": "Apertura del checkout…",
    "Opening checkout…": "Apertura del checkout…",
    "workspace.plans.buy_credits": "Acquista {count} crediti",
    "Buy {count} credits": "Acquista {count} crediti",
    "workspace.plans.select_amount": "Seleziona un importo",
    "Select an amount": "Seleziona un importo",
    "workspace.plans.alacarte_products": "Prodotti singoli",
    "A la carte Products": "Prodotti singoli",
    "workspace.plans.products_description": "Seleziona i prodotti che utilizzi per personalizzare la tua esperienza. L’utilizzo si paga con i crediti.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Seleziona i prodotti che utilizzi per personalizzare la tua esperienza. L’utilizzo si paga con i crediti.",
    "workspace.plans.enabled": "Abilitato",
    "workspace.plans.enable": "Abilita",
    "Enable": "Abilita",
    "workspace.plans.open_here": "Apri qui",
    "Open here": "Apri qui",
    "workspace.plans.open_marketing": "Apri marketing.tradly.app",
    "Open marketing.tradly.app": "Apri marketing.tradly.app",
    "workspace.plans.open_analytics": "Apri analytics.tradly.app",
    "Open analytics.tradly.app": "Apri analytics.tradly.app",
    "workspace.plans.open_external": "Apri link esterno",
    "Open external": "Apri link esterno",
    "workspace.plans.coming_soon": "In arrivo",
    "workspace.plans.services_title": "Configurazione una tantum e servizi personalizzati",
    "One-Time Setup & Custom Services": "Configurazione una tantum e servizi personalizzati",
    "workspace.plans.service_app_launch": "Lancio app white-label",
    "White-Label App Launch": "Lancio app white-label",
    "workspace.plans.service_frontend": "Personalizzazione frontend",
    "Frontend Customization": "Personalizzazione frontend",
    "workspace.plans.service_multilanguage": "Supporto multilingue",
    "Multi-Language Support": "Supporto multilingue",
    "workspace.plans.view_docs": "Visualizza documentazione",
    "View Docs": "Visualizza documentazione",
    "workspace.plans.confirm_change": "Conferma la modifica del piano",
    "Confirm your plan change": "Conferma la modifica del piano",
    "workspace.plans.confirm_charge": "Gli addebiti sono anticipati e avvengono alla data di abbonamento.",
    "Charges are prepaid and billed on your subscription date.": "Gli addebiti sono anticipati e avvengono alla data di abbonamento.",
    "workspace.plans.confirm_promo": "Se disponibile, puoi inserire un codice promozionale durante il checkout Stripe.",
    "Promotional codes can be entered during Stripe checkout where available.": "Se disponibile, puoi inserire un codice promozionale durante il checkout Stripe.",
    "workspace.plans.confirm_delay": "La modifica del piano potrebbe richiedere qualche istante per apparire nello spazio di lavoro.",
    "Plan changes may take a moment to appear in your workspace.": "La modifica del piano potrebbe richiedere qualche istante per apparire nello spazio di lavoro.",
    "workspace.plans.payment_active": "Pagamento ricevuto. Il piano è attivo.",
    "Payment received. Your plan is active.": "Pagamento ricevuto. Il piano è attivo.",
    "workspace.plans.payment_method_updated": "Metodo di pagamento aggiornato.",
    "Payment method updated.": "Metodo di pagamento aggiornato.",
    "workspace.plans.payment_cancelled": "Il pagamento non è stato completato, quindi il piano non è cambiato.",
    "Payment was not completed, so your plan has not changed.": "Il pagamento non è stato completato, quindi il piano non è cambiato.",
    "workspace.plans.activating": "Pagamento ricevuto. Attivazione del piano…",
    "Payment received. Activating your plan…": "Pagamento ricevuto. Attivazione del piano…",
    "workspace.plans.activation_delayed": "Pagamento ricevuto. L’attivazione del piano sta richiedendo più tempo. Aggiorna la pagina tra un minuto.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Pagamento ricevuto. L’attivazione del piano sta richiedendo più tempo. Aggiorna la pagina tra un minuto.",
    "workspace.plans.card_saved": "Carta salvata e abbonamento aggiornato.",
    "Card saved and subscription updated.": "Carta salvata e abbonamento aggiornato.",
    "workspace.plans.subscription_updated": "Abbonamento aggiornato.",
    "Subscription updated.": "Abbonamento aggiornato.",
    "workspace.plans.products_saved": "Prodotti singoli salvati.",
    "À la carte products saved.": "Prodotti singoli salvati.",
    "workspace.plans.minimum_credits": "Inserisci almeno 100 crediti.",
    "Enter at least 100 credits.": "Inserisci almeno 100 crediti.",
    "workspace.plans.credit_topup_description": "Ricarica crediti ({count} crediti)",
    "Credit Top-Up ({count} credits)": "Ricarica crediti ({count} crediti)",
    "workspace.plans.billing_details": "Dati di fatturazione attuali",
    "Current billing details": "Dati di fatturazione attuali",
    "workspace.plans.current_plan": "Piano attuale",
    "Current Plan": "Piano attuale",
    "workspace.plans.renews": "Rinnovo",
    "Renews": "Rinnovo",
    "workspace.plans.payment_method": "Metodo di pagamento",
    "Payment method": "Metodo di pagamento",
    "workspace.plans.opening": "Apertura…",
    "Opening…": "Apertura…",
    "workspace.plans.manage_payment_method": "Gestisci metodo di pagamento",
    "Manage payment method": "Gestisci metodo di pagamento",
    "workspace.plans.upgrade": "Passa a un piano superiore",
    "Upgrade": "Passa a un piano superiore",
    "workspace.plans.downgrade": "Passa a un piano inferiore",
    "Downgrade": "Passa a un piano inferiore",
    "workspace.plans.custom_price": "Prezzo personalizzato",
    "workspace.plans.per_month_short": "/mese",
    "/month": "/mese",
    "workspace.plans.per_year_amount": "all’anno ({amount})",
    "per year ({amount})": "all’anno ({amount})",
    "workspace.plans.per_month_amount": "al mese ({amount})",
    "per month ({amount})": "al mese ({amount})",
    "workspace.plans.yearly_savings": "Risparmia {amount} all’anno",
    "Save {amount} yearly": "Risparmia {amount} all’anno",
    "workspace.plans.billed_yearly": "fatturato annualmente",
    "billed yearly": "fatturato annualmente",
    "workspace.plans.billed_monthly": "fatturato mensilmente",
    "billed monthly": "fatturato mensilmente",
    "workspace.plans.free_trial": "Stai usando una prova gratuita.",
    "You are on a free trial.": "Stai usando una prova gratuita.",
    "workspace.plans.updating": "Aggiornamento…",
    "Updating…": "Aggiornamento…",
    "workspace.plans.temporarily_unavailable": "Temporaneamente non disponibile",
    "Temporarily unavailable": "Temporaneamente non disponibile",
    "workspace.plans.whats_included": "Cosa è incluso",
    "What's included": "Cosa è incluso",
    "workspace.plans.products.auth.title": "Autenticazione",
    "Auth": "Autenticazione",
    "workspace.plans.products.auth.description": "Identità, SSO, autorizzazioni e gestione utenti.",
    "Identity, SSO, permissions, and user management.": "Identità, SSO, autorizzazioni e gestione utenti.",
    "workspace.plans.products.email.title": "Email",
    "workspace.plans.products.email.description": "Email transazionali e di marketing integrati.",
    "Transactional and marketing email, built in.": "Email transazionali e di marketing integrati.",
    "workspace.plans.products.analytics.title": "Analisi",
    "Analytics": "Analisi",
    "workspace.plans.products.analytics.description": "Analisi gratuite per web, app e agenti.",
    "Free analytics for web, app, and agents.": "Analisi gratuite per web, app e agenti.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "Un CRM che si aggiorna automaticamente con l’attività degli utenti.",
    "A CRM that fills itself from user activity.": "Un CRM che si aggiorna automaticamente con l’attività degli utenti.",
    "workspace.plans.products.subscription.title": "Abbonamenti",
    "Subscriptions": "Abbonamenti",
    "workspace.plans.products.subscription.description": "Pagamenti ricorrenti, prove e solleciti gestiti.",
    "Recurring billing, trials, and dunning — handled.": "Pagamenti ricorrenti, prove e solleciti gestiti.",
    "workspace.plans.products.recommendation.title": "Consigli",
    "Recommendations": "Consigli",
    "workspace.plans.products.recommendation.description": "Mostra a ogni utente ciò che desidera davvero.",
    "Show each user what they will actually want.": "Mostra a ogni utente ciò che desidera davvero.",
    "workspace.plans.marketplace.2025-superstarter.title": "Base",
    "Basic": "Base",
    "workspace.plans.marketplace.2025-superstarter.description": "Per piccoli team. Include tutte le funzioni Community e il white labeling (rimuove il badge “Built with Tradly”).",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Per piccoli team. Include tutte le funzioni Community e il white labeling (rimuove il badge “Built with Tradly”).",
    "workspace.plans.marketplace.2025-superstarter.button": "Inizia la prova di 7 giorni",
    "Start 7 Days Trial": "Inizia la prova di 7 giorni",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "Nessuna commissione sulle transazioni",
    "No transaction fee": "Nessuna commissione sulle transazioni",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Sito web gratuito ospitato da Tradly",
    "Free Tradly hosted website": "Sito web gratuito ospitato da Tradly",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Aggiungi il tuo dominio",
    "Add your custom domain": "Aggiungi il tuo dominio",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Editor — cronologia pagine di 3 giorni",
    "Editor - 3 Day page history": "Editor — cronologia pagine di 3 giorni",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "Per startup che convalidano un’idea imprenditoriale. Include tutto il necessario per testare il mercato e acquisire i primi clienti.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "Per startup che convalidano un’idea imprenditoriale. Include tutto il necessario per testare il mercato e acquisire i primi clienti.",
    "workspace.plans.marketplace.2025-starter.button": "Inizia la prova di 7 giorni",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "Nessuna commissione sulle transazioni",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Attributi personalizzati illimitati",
    "Unlimited Custom Attributes": "Attributi personalizzati illimitati",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "Cronologia delle pagine di 30 giorni",
    "30 Day page history": "Cronologia delle pagine di 30 giorni",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Abbonamento a pagamento",
    "Gated Subscription": "Abbonamento a pagamento",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Accesso social",
    "Social Logins": "Accesso social",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhook",
    "Webhooks": "Webhook",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Per idee consolidate in fase di crescita, con esigenze specifiche e integrazioni aggiuntive.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Per idee consolidate in fase di crescita, con esigenze specifiche e integrazioni aggiuntive.",
    "workspace.plans.marketplace.2025-growth.button": "Inizia la prova di 7 giorni",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "Nessuna commissione sulle transazioni",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Indirizzo mittente personalizzato",
    "Custom 'From Email'": "Indirizzo mittente personalizzato",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Mini strumenti e integrazioni aggiuntivi",
    "Additional Mini Tools & Integrations": "Mini strumenti e integrazioni aggiuntivi",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Chiamate di onboarding personalizzate*",
    "Personalised Onboarding calls*": "Chiamate di onboarding personalizzate*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "Cronologia delle pagine di 90 giorni",
    "90 Day page history": "Cronologia delle pagine di 90 giorni",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Valute e lingue multiple",
    "Multi Currencies & Multi Languages": "Valute e lingue multiple",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Controllo degli accessi basato sui ruoli (RBAC)",
    "Role-based access control (RBAC)": "Controllo degli accessi basato sui ruoli (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Chat integrata nelle app",
    "Inbuilt Chat for Apps": "Chat integrata nelle app",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Per aziende in crescita che cercano soluzioni su misura e altri requisiti personalizzati.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Per aziende in crescita che cercano soluzioni su misura e altri requisiti personalizzati.",
    "workspace.plans.marketplace.2025-scale.button": "Inizia la prova di 7 giorni",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "Nessuna commissione sulle transazioni",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Assistenza prioritaria",
    "Priority Support": "Assistenza prioritaria",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Canali multipli (supporto app)",
    "Multiple Channels (App Support)": "Canali multipli (supporto app)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Accesso singolo (SSO)",
    "Single Sign-on (SSO)": "Accesso singolo (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Cronologia pagine illimitata",
    "Unlimited page history": "Cronologia pagine illimitata",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Chat integrata nelle app",
    "In-built Chat for Apps": "Chat integrata nelle app",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Tutto ciò che serve a un negozio in crescita: rimuovi il marchio, aggiungi il tuo dominio e sblocca altri strumenti.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Tutto ciò che serve a un negozio in crescita: rimuovi il marchio, aggiungi il tuo dominio e sblocca altri strumenti.",
    "workspace.plans.indie.go.button": "Inizia la prova di 7 giorni",
    "Start 7-day trial": "Inizia la prova di 7 giorni",
    "workspace.plans.indie.go.feature_1.title": "Senza marchio Tradly",
    "No Tradly branding": "Senza marchio Tradly",
    "workspace.plans.indie.go.feature_2.title": "Dominio personalizzato",
    "Custom domain": "Dominio personalizzato",
    "workspace.plans.indie.go.feature_3.title": "Prodotti illimitati",
    "Unlimited products": "Prodotti illimitati",
    "workspace.plans.indie.go.feature_4.title": "Campagne email",
    "Email campaigns": "Campagne email",
    "workspace.plans.indie.go.feature_5.title": "Consigli AI",
    "AI Recommendations": "Consigli AI",
    "workspace.plans.indie.go.feature_6.title": "Assistenza tramite ticket",
    "Ticket-based support": "Assistenza tramite ticket",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Suite completa di strumenti AI, marketing avanzato e tutte le funzioni per i negozi orientati alla crescita.",
    "workspace.plans.indie.genius.button": "Inizia la prova di 7 giorni",
    "workspace.plans.indie.genius.feature_1.title": "Tutto ciò che include Pro",
    "Everything in Pro": "Tutto ciò che include Pro",
    "workspace.plans.indie.genius.feature_2.title": "Agenti AI (assistente agli acquisti e altro)",
    "AI Agents (Shopping Assistant, etc.)": "Agenti AI (assistente agli acquisti e altro)",
    "workspace.plans.indie.genius.feature_3.title": "Ricerca in linguaggio naturale",
    "Natural language search": "Ricerca in linguaggio naturale",
    "workspace.plans.indie.genius.feature_4.title": "Automazione email avanzata",
    "Advanced email automation": "Automazione email avanzata",
    "workspace.plans.indie.genius.feature_5.title": "Richieste di consigli illimitate",
    "Unlimited recommendation requests": "Richieste di consigli illimitate",
    "workspace.plans.indie.genius.feature_6.title": "Assistenza tramite ticket",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Addebiti di abbonamento per aprire account e inviare inserzioni.",
    "Subscription charges for people to open accounts & submit listings": "Addebiti di abbonamento per aprire account e inviare inserzioni.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Registrazione/accesso tramite Google e Meta",
    "Signup/in via Google, Meta": "Registrazione/accesso tramite Google e Meta",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Per connettersi a Zapier e Make",
    "To connect with Zapier & Make": "Per connettersi a Zapier e Make",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Messaggistica nativa nell’app per gli utenti",
    "Native in-app messaging for your users": "Messaggistica nativa nell’app per gli utenti",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Risposta entro 24 ore per richieste non urgenti",
    "24 hour response time for non-critical": "Risposta entro 24 ore per richieste non urgenti",
    "common.continue": "Continua",
    "Continue": "Continua",
    "workspace.plans.free_plan": "Gratis",
    "Free": "Gratis",
    "workspace.usage.group_platform": "Piattaforma e spazio di lavoro",
    "Platform & workspace": "Piattaforma e spazio di lavoro",
    "workspace.usage.group_ai": "AI e utilizzo",
    "AI & usage": "AI e utilizzo",
    "workspace.usage.group_storage": "Contenuti e archiviazione",
    "Content & storage": "Contenuti e archiviazione",
    "workspace.usage.group_alacarte": "Singoli prodotti",
    "workspace.usage.accounts": "Account",
    "workspace.usage.listings": "Inserzioni",
    "workspace.usage.sites": "Siti nello spazio di lavoro",
    "Sites under workspace": "Siti nello spazio di lavoro",
    "workspace.usage.external_users": "Utenti esterni",
    "External users": "Utenti esterni",
    "workspace.usage.internal_users": "Utenti interni",
    "Internal users": "Utenti interni",
    "workspace.usage.ai_credits": "Crediti AI",
    "AI credits": "Crediti AI",
    "workspace.usage.storage": "Spazio di archiviazione",
    "Storage": "Spazio di archiviazione",
    "workspace.usage.email": "Email",
    "workspace.usage.maps": "Mappe",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analisi",
    "workspace.usage.recommendations": "Consigli",
    "workspace.usage.ai_agents": "Agenti AI",
    "AI agents": "Agenti AI",
    "workspace.usage.status_not_reported": "Non segnalato",
    "Not reported": "Non segnalato",
    "workspace.usage.status_nearly_full": "Quasi esaurito",
    "Nearly full": "Quasi esaurito",
    "workspace.usage.status_on_track": "Regolare",
    "On track": "Regolare",
    "workspace.usage.workspace_files": "File dello spazio di lavoro",
    "Workspace files": "File dello spazio di lavoro",
    "workspace.usage.workspace_usage": "Utilizzo dello spazio di lavoro",
    "Workspace usage": "Utilizzo dello spazio di lavoro",
    "workspace.usage.of_limit": "di {limit}",
    "of {limit}": "di {limit}",
    "workspace.usage.no_cap": "Nessun limite configurato",
    "No cap configured": "Nessun limite configurato",
    "workspace.usage.trend": "Andamento dell’utilizzo",
    "Usage trend": "Andamento dell’utilizzo",
    "workspace.usage.unavailable": "I dati di utilizzo sono temporaneamente non disponibili.",
    "Usage data is temporarily unavailable.": "I dati di utilizzo sono temporaneamente non disponibili.",
    "workspace.usage.loading": "Caricamento dell’utilizzo dello spazio di lavoro…",
    "Loading workspace usage…": "Caricamento dell’utilizzo dello spazio di lavoro…",
    "workspace.usage.overview": "Panoramica dello spazio di lavoro",
    "Workspace overview": "Panoramica dello spazio di lavoro",
    "workspace.usage.title": "Dettaglio utilizzo",
    "Usage breakdown": "Dettaglio utilizzo",
    "workspace.usage.description": "Consulta le risorse utilizzate dallo spazio di lavoro e quelle ancora disponibili nel piano attuale.",
    "See what your workspace has used and how much room remains on your current plan.": "Consulta le risorse utilizzate dallo spazio di lavoro e quelle ancora disponibili nel piano attuale.",
    "workspace.usage.view_plans": "Visualizza piani",
    "workspace.usage.showing_available_limits": "Sono mostrati i limiti già disponibili in questo spazio di lavoro.",
    "Showing the limits that are already available in this workspace.": "Sono mostrati i limiti già disponibili in questo spazio di lavoro.",
    "workspace.usage.summary": "Riepilogo utilizzo",
    "Usage summary": "Riepilogo utilizzo",
    "workspace.usage.metrics_tracked": "Metriche monitorate",
    "Metrics tracked": "Metriche monitorate",
    "workspace.usage.metrics_count": "{count} di {total}",
    "{count} of {total}": "{count} di {total}",
    "workspace.usage.next_reset": "Prossimo azzeramento",
    "Next reset": "Prossimo azzeramento",
    "workspace.usage.not_provided": "Non fornito",
    "Not provided": "Non fornito",
    "workspace.usage.data_source": "Fonte dati",
    "Data source": "Fonte dati",
    "workspace.usage.clear_view": "Una panoramica chiara dello spazio di lavoro",
    "A clear view of your workspace": "Una panoramica chiara dello spazio di lavoro",
    "workspace.usage.by_resource": "Per risorsa",
    "Usage by resource": "Per risorsa",
    "workspace.usage.live_summary": "Riepilogo in tempo reale",
    "Live summary": "Riepilogo in tempo reale",
    "workspace.usage.resource": "Risorsa",
    "Resource": "Risorsa",
    "workspace.usage.used_limit": "Utilizzato / limite",
    "Used / limit": "Utilizzato / limite",
    "workspace.usage.progress": "Avanzamento",
    "Progress": "Avanzamento",
    "workspace.usage.cost": "Costo",
    "Cost": "Costo",
    "workspace.usage.footnote": "I dati di utilizzo e i limiti provengono dal servizio dello spazio di lavoro. Un trattino indica che l’API attuale non fornisce ancora la metrica.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "I dati di utilizzo e i limiti provengono dal servizio dello spazio di lavoro. Un trattino indica che l’API attuale non fornisce ancora la metrica.",
    "workspace.usage.refresh": "Aggiorna",
    "Refresh": "Aggiorna",
    "maps.title": "Mappe",
    "maps.tab.analysis": "Analisi di mercato",
    "Market scan": "Analisi di mercato",
    "maps.tab.usage": "Utilizzo",
    "maps.tab.settings": "Impostazioni",
    "maps.action.save": "Salva",
    "maps.action.saving": "Salvataggio…",
    "maps.action.analyze_area": "Analizza area",
    "Analyze area": "Analizza area",
    "maps.action.analyzing": "Analisi…",
    "Analyzing…": "Analisi…",
    "maps.action.refresh": "Aggiorna",
    "maps.action.loading": "Caricamento…",
    "Loading…": "Caricamento…",
    "maps.action.open_in_maps": "Apri in Maps",
    "Open in Maps": "Apri in Maps",
    "maps.analysis.title": "Esplora il mercato locale",
    "Explore a local market": "Esplora il mercato locale",
    "maps.analysis.description": "Visualizza le attività indicate da Google vicino alla posizione proposta. È un’analisi iniziale della concorrenza, non una previsione della domanda o della fattibilità.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Visualizza le attività indicate da Google vicino alla posizione proposta. È un’analisi iniziale della concorrenza, non una previsione della domanda o della fattibilità.",
    "maps.analysis.address_label": "Indirizzo o località",
    "Address or locality": "Indirizzo o località",
    "maps.analysis.address_placeholder": "Via, quartiere o città",
    "Street, suburb, or city": "Via, quartiere o città",
    "maps.analysis.category_label": "Tipo di attività",
    "Business type": "Tipo di attività",
    "maps.analysis.radius_label": "Raggio di ricerca",
    "Search radius": "Raggio di ricerca",
    "maps.analysis.places_listings": "Attività su Maps",
    "Places listings": "Attività su Maps",
    "maps.analysis.within_radius": "{category} entro {radius}",
    "{category} within {radius}": "{category} entro {radius}",
    "maps.analysis.results_description": "I risultati sono filtrati per categoria e raggio, quindi ordinati per distanza.",
    "Results are filtered by category and radius, then ordered by distance.": "I risultati sono filtrati per categoria e raggio, quindi ordinati per distanza.",
    "maps.analysis.result_limit_notice": "Google ha restituito il massimo di 20 luoghi. Il numero reale potrebbe essere maggiore; riduci il raggio per un’analisi più dettagliata.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google ha restituito il massimo di 20 luoghi. Il numero reale potrebbe essere maggiore; riduci il raggio per un’analisi più dettagliata.",
    "maps.analysis.limitations": "Gli elenchi potrebbero essere incompleti e non misurano domanda, affluenza, popolazione, affitti o redditività. Usali come uno degli elementi della ricerca locale.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Gli elenchi potrebbero essere incompleti e non misurano domanda, affluenza, popolazione, affitti o redditività. Usali come uno degli elementi della ricerca locale.",
    "maps.analysis.nearby_businesses": "Attività vicine ({count})",
    "Nearby businesses ({count})": "Attività vicine ({count})",
    "maps.analysis.businesses": "Attività",
    "Businesses": "Attività",
    "maps.analysis.no_listings": "Nessun luogo corrispondente trovato su Google Maps per quest’area e categoria.",
    "No matching Google Maps listings were returned for this area and category.": "Nessun luogo corrispondente trovato su Google Maps per quest’area e categoria.",
    "maps.category.retail": "Vendita al dettaglio",
    "Retail": "Vendita al dettaglio",
    "maps.category.grocery": "Alimentari",
    "Grocery": "Alimentari",
    "maps.category.clothing": "Abbigliamento",
    "Clothing": "Abbigliamento",
    "maps.category.pharmacy": "Farmacia",
    "Pharmacy": "Farmacia",
    "maps.category.restaurant": "Ristorante / caffè",
    "Restaurant / café": "Ristorante / caffè",
    "maps.competition.limited": "Pochi concorrenti elencati",
    "Limited listed competition": "Pochi concorrenti elencati",
    "maps.competition.some": "Alcuni concorrenti elencati",
    "Some listed competition": "Alcuni concorrenti elencati",
    "maps.competition.many": "Molti concorrenti elencati",
    "Many listed competitors": "Molti concorrenti elencati",
    "maps.competition.limit_reached": "Almeno 20 luoghi (limite dei risultati raggiunto)",
    "At least 20 listings (result limit reached)": "Almeno 20 luoghi (limite dei risultati raggiunto)",
    "maps.competition.default": "Concorrenza elencata",
    "Listed competition": "Concorrenza elencata",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Operativo",
    "Operational": "Operativo",
    "maps.usage.title": "Utilizzo del provider",
    "Provider usage": "Utilizzo del provider",
    "maps.usage.description": "Numero di richieste registrate dal servizio Maps. Gli addebiti vengono riconciliati separatamente.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Numero di richieste registrate dal servizio Maps. Gli addebiti vengono riconciliati separatamente.",
    "maps.usage.days": "{count} giorni",
    "{count} days": "{count} giorni",
    "maps.usage.provider_requests": "Richieste al provider",
    "Provider requests": "Richieste al provider",
    "maps.usage.range_detail": "Intervallo di {count} giorni",
    "{count} day window": "Intervallo di {count} giorni",
    "maps.usage.successful": "Riuscite",
    "maps.usage.completed_calls": "Chiamate al provider completate",
    "Completed provider calls": "Chiamate al provider completate",
    "maps.usage.errors": "Errori",
    "Errors": "Errori",
    "maps.usage.failed_calls": "Chiamate al provider non riuscite",
    "Failed provider calls": "Chiamate al provider non riuscite",
    "maps.usage.metered_units": "Unità conteggiate",
    "Metered units": "Unità conteggiate",
    "maps.usage.unit_detail": "Un’unità per ogni richiesta registrata",
    "One unit per recorded request": "Un’unità per ogni richiesta registrata",
    "maps.usage.by_operation": "Utilizzo per operazione",
    "Usage by operation": "Utilizzo per operazione",
    "maps.usage.group_description": "I conteggi sono raggruppati per provider, operazione ed esito.",
    "Counts are grouped by provider, operation, and outcome.": "I conteggi sono raggruppati per provider, operazione ed esito.",
    "maps.usage.empty": "Nessuna richiesta di mappe nell’intervallo selezionato.",
    "No map requests in this date range.": "Nessuna richiesta di mappe nell’intervallo selezionato.",
    "maps.usage.provider": "Provider",
    "Provider": "Provider",
    "maps.usage.operation": "Operazione",
    "Operation": "Operazione",
    "maps.usage.outcome": "Esito",
    "Outcome": "Esito",
    "maps.usage.requests": "Richieste",
    "Requests": "Richieste",
    "maps.usage.units": "Unità",
    "Units": "Unità",
    "maps.settings.provider_title": "Provider mappe",
    "Map provider": "Provider mappe",
    "maps.settings.provider_description": "Scegli il provider consentito dalla tua informativa sulla privacy. Le credenziali sono gestite da Tradly.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Scegli il provider consentito dalla tua informativa sulla privacy. Le credenziali sono gestite da Tradly.",
    "maps.settings.selected": "Selezionato",
    "maps.settings.available": "Disponibile",
    "maps.settings.planned": "Pianificato",
    "Planned": "Pianificato",
    "maps.settings.origins_title": "Origini web consentite",
    "Allowed website origins": "Origini web consentite",
    "maps.settings.origins_description": "I domini tenant registrati sono consentiti automaticamente. Aggiungi qui gli indirizzi esatti di altri siti, ad esempio staging.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "I domini tenant registrati sono consentiti automaticamente. Aggiungi qui gli indirizzi esatti di altri siti, ad esempio staging.",
    "maps.settings.registered_domains": "Domini registrati",
    "Registered domains": "Domini registrati",
    "maps.settings.no_domains": "Nessun dominio registrato caricato.",
    "No registered domains were loaded.": "Nessun dominio registrato caricato.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Aggiungi origine",
    "Add origin": "Aggiungi origine",
    "maps.settings.remove_origin": "Rimuovi",
    "maps.settings.no_origins": "Nessuna origine aggiuntiva aggiunta.",
    "No extra origins added.": "Nessuna origine aggiuntiva aggiunta.",
    "maps.error.session_not_ready": "La sessione amministratore non è ancora pronta.",
    "Your admin session is not ready yet.": "La sessione amministratore non è ancora pronta.",
    "maps.error.load_data": "Impossibile caricare i dati di Maps ({status}).",
    "Unable to load Maps data ({status}).": "Impossibile caricare i dati di Maps ({status}).",
    "maps.error.load_usage": "Impossibile caricare i dati di utilizzo di Maps.",
    "Unable to load Maps usage.": "Impossibile caricare i dati di utilizzo di Maps.",
    "maps.error.load_settings": "Impossibile caricare le impostazioni di Maps.",
    "Unable to load Maps settings.": "Impossibile caricare le impostazioni di Maps.",
    "maps.error.save_settings": "Impossibile salvare le impostazioni di Maps.",
    "Unable to save Maps settings.": "Impossibile salvare le impostazioni di Maps.",
    "maps.error.invalid_origin": "Inserisci un’origine completa, ad esempio https://staging.example.com.",
    "Enter a complete origin, such as https://staging.example.com.": "Inserisci un’origine completa, ad esempio https://staging.example.com.",
    "maps.error.registered_origin": "Questa origine è già coperta da un dominio registrato.",
    "This origin is already covered by a registered domain.": "Questa origine è già coperta da un dominio registrato.",
    "maps.error.address_required": "Inserisci un indirizzo o una località da analizzare.",
    "Enter an address or locality to scan.": "Inserisci un indirizzo o una località da analizzare.",
    "maps.error.location_not_found": "Impossibile trovare la località.",
    "Unable to find that location.": "Impossibile trovare la località.",
    "maps.error.no_coordinates": "Non sono state trovate coordinate per l’indirizzo. Prova con una via, un quartiere o una città vicina.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Non sono state trovate coordinate per l’indirizzo. Prova con una via, un quartiere o una città vicina.",
    "maps.error.analyze_area": "Impossibile analizzare quest’area.",
    "Unable to analyze this area.": "Impossibile analizzare quest’area.",
    "maps.notice.settings_saved": "Impostazioni di Maps salvate.",
    "Maps settings saved.": "Impostazioni di Maps salvate.",
    "maps.status.success": "Riuscito",
    "maps.status.error": "Errore",
    "maps.operation.geocode": "Geocodifica",
    "Geocode": "Geocodifica",
    "maps.operation.maps_geocode": "Geocodifica Maps",
    "Maps geocode": "Geocodifica Maps",
    "maps.operation.market_analysis": "Analisi di mercato",
    "Market analysis": "Analisi di mercato",
    "maps.operation.maps_market_analysis": "Analisi di mercato Maps",
    "Maps market analysis": "Analisi di mercato Maps",
    "maps.operation.places_search": "Ricerca di luoghi",
    "Places search": "Ricerca di luoghi",
    "maps.operation.places_nearby": "Luoghi vicini",
    "Nearby places": "Luoghi vicini",
    "maps.operation.place_details": "Dettagli luogo",
    "Place details": "Dettagli luogo",
    "common.loading": "Caricamento…",
    "common.saving": "Salvataggio…",
    "common.searching": "Ricerca…",
    "Searching…": "Ricerca…",
    "common.no_matches": "Nessuna corrispondenza trovata.",
    "No matches found.": "Nessuna corrispondenza trovata.",
    "common.select": "Seleziona…",
    "Select…": "Seleziona…",
    "common.search_users": "Cerca utenti per nome o email",
    "Search users by name or email": "Cerca utenti per nome o email",
    "common.reset": "Reimposta",
    "common.validation.email": "Inserisci un indirizzo email valido.",
    "Enter a valid email address.": "Inserisci un indirizzo email valido.",
    "common.validation.phone": "Inserisci un numero di telefono valido.",
    "Enter a valid phone number.": "Inserisci un numero di telefono valido.",
    "common.validation.currency": "Usa un codice valuta di 3 lettere, ad esempio USD.",
    "Use a 3-letter currency code, such as USD.": "Usa un codice valuta di 3 lettere, ad esempio USD.",
    "common.validation.location": "Inserisci un indirizzo o una posizione valida.",
    "Enter a valid address or location.": "Inserisci un indirizzo o una posizione valida.",
    "common.validation.required": "{label} è obbligatorio.",
    "{label} is required.": "{label} è obbligatorio.",
    "common.validation.invalid": "{label} non è valido.",
    "{label} is invalid.": "{label} non è valido.",
    "common.status.active": "Attivo",
    "common.status.inactive": "Inattivo",
    "common.status.open": "Aperto",
    "common.status.closed": "Chiuso",
    "Closed": "Chiuso",
    "common.status.posted": "Registrato",
    "Posted": "Registrato",
    "common.status.voided": "Stornato",
    "Voided": "Stornato",
    "common.status.draft": "Bozza",
    "Draft": "Bozza",
    "common.status.success": "Riuscito",
    "common.status.error": "Errore",
    "accounting.title": "Contabilità",
    "accounting.description": "Gestisci conti, mappature, periodi, registri e report finanziari.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Gestisci conti, mappature, periodi, registri e report finanziari.",
    "accounting.tab.overview": "Panoramica",
    "Overview": "Panoramica",
    "accounting.tab.accounts": "Piano dei conti",
    "Chart of accounts": "Piano dei conti",
    "accounting.tab.mappings": "Mappature conti",
    "Account mappings": "Mappature conti",
    "accounting.tab.periods": "Periodi contabili",
    "Accounting periods": "Periodi contabili",
    "accounting.tab.journals": "Registri",
    "Journals": "Registri",
    "accounting.tab.reports": "Report",
    "accounting.account.edit_title": "Modifica conto",
    "Edit account": "Modifica conto",
    "accounting.account.new_title": "Nuovo conto",
    "New account": "Nuovo conto",
    "accounting.account.save": "Salva conto",
    "Save account": "Salva conto",
    "accounting.account.create": "Crea conto",
    "Create account": "Crea conto",
    "accounting.account.code": "Codice conto",
    "Account code": "Codice conto",
    "accounting.account.name": "Nome conto",
    "accounting.account.type": "Tipo di conto",
    "accounting.account.currency_id": "ID valuta",
    "Currency ID": "ID valuta",
    "accounting.account.active": "Attivo",
    "accounting.account.unnamed": "Conto senza nome",
    "Unnamed account": "Conto senza nome",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Spese per il personale",
    "Payroll expense": "Spese per il personale",
    "accounting.type.asset": "Attività",
    "Asset": "Attività",
    "accounting.type.liability": "Passività",
    "Liability": "Passività",
    "accounting.type.equity": "Patrimonio netto",
    "Equity": "Patrimonio netto",
    "accounting.type.revenue": "Ricavo",
    "accounting.type.expense": "Spesa",
    "Expense": "Spesa",
    "accounting.toast.account_updated": "Conto aggiornato",
    "Account updated": "Conto aggiornato",
    "accounting.toast.account_created": "Conto creato",
    "Account created": "Conto creato",
    "accounting.toast.defaults_created": "Conti predefiniti creati",
    "Default accounts created": "Conti predefiniti creati",
    "accounting.toast.mapping_saved": "Mappatura salvata",
    "Mapping saved": "Mappatura salvata",
    "accounting.toast.period_closed": "Periodo contabile chiuso",
    "Accounting period closed": "Periodo contabile chiuso",
    "accounting.toast.period_created": "Periodo contabile creato",
    "Period created": "Periodo contabile creato",
    "accounting.toast.journal_created": "Registro creato",
    "Journal created": "Registro creato",
    "accounting.toast.journal_voided": "Registro stornato",
    "Journal voided": "Registro stornato",
    "accounting.validation.journal_balanced": "Il registro deve avere data e descrizione e i totali di dare e avere devono essere in pareggio.",
    "Journal must have a date, description, and balanced debit and credit totals.": "Il registro deve avere data e descrizione e i totali di dare e avere devono essere in pareggio.",
    "accounting.filter.all_types": "Tutti i tipi di conto",
    "All account types": "Tutti i tipi di conto",
    "accounting.filter.all_statuses": "Tutti gli stati",
    "All statuses": "Tutti gli stati",
    "accounting.action.bootstrap": "Crea conti predefiniti",
    "Bootstrap defaults": "Crea conti predefiniti",
    "accounting.action.new_account": "Nuovo conto",
    "accounting.empty.accounts": "Nessun conto trovato.",
    "No accounts found.": "Nessun conto trovato.",
    "accounting.column.code": "Codice",
    "Code": "Codice",
    "accounting.column.account": "Conto",
    "accounting.column.type": "Tipo",
    "Type": "Tipo",
    "accounting.column.currency": "Valuta",
    "accounting.column.status": "Stato",
    "accounting.action.edit": "Modifica",
    "accounting.mapping.edit_title": "Modifica mappatura conti",
    "Edit account mapping": "Modifica mappatura conti",
    "accounting.mapping.new_title": "Nuova mappatura conti",
    "New account mapping": "Nuova mappatura conti",
    "accounting.mapping.save": "Salva mappatura",
    "Save mapping": "Salva mappatura",
    "accounting.mapping.create": "Crea mappatura",
    "Create mapping": "Crea mappatura",
    "accounting.mapping.source_type": "Tipo di origine",
    "Source type": "Tipo di origine",
    "accounting.mapping.event_key": "Chiave evento",
    "Event key": "Chiave evento",
    "accounting.mapping.debit_account": "Conto dare",
    "Debit account": "Conto dare",
    "accounting.mapping.credit_account": "Conto avere",
    "Credit account": "Conto avere",
    "accounting.mapping.tax_account": "Conto imposte",
    "Tax account": "Conto imposte",
    "accounting.mapping.none": "Nessuno",
    "None": "Nessuno",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Filtra tipo di origine",
    "Filter source type": "Filtra tipo di origine",
    "accounting.action.new_mapping": "Nuova mappatura",
    "New mapping": "Nuova mappatura",
    "accounting.empty.mappings": "Nessuna mappatura conti trovata.",
    "No account mappings found.": "Nessuna mappatura conti trovata.",
    "accounting.column.source": "Origine",
    "accounting.column.event": "Evento",
    "Event": "Evento",
    "accounting.column.debit": "Dare",
    "Debit": "Dare",
    "accounting.column.credit": "Avere",
    "Credit": "Avere",
    "accounting.period.close_confirm": "Chiudere {period}? L’operazione non può essere annullata.",
    "Close {period}? This cannot be reversed.": "Chiudere {period}? L’operazione non può essere annullata.",
    "accounting.period.this": "questo periodo contabile",
    "this accounting period": "questo periodo contabile",
    "accounting.period.new_title": "Nuovo periodo contabile",
    "New accounting period": "Nuovo periodo contabile",
    "accounting.period.create": "Crea periodo",
    "Create period": "Crea periodo",
    "accounting.period.name": "Nome periodo",
    "Period name": "Nome periodo",
    "accounting.period.start": "Data di inizio",
    "accounting.period.end": "Data di fine",
    "accounting.period.name_placeholder": "Gennaio 2027",
    "January 2027": "Gennaio 2027",
    "accounting.period.open": "Aperto",
    "accounting.period.closed": "Chiuso",
    "accounting.action.new_period": "Nuovo periodo",
    "New period": "Nuovo periodo",
    "accounting.empty.periods": "Nessun periodo contabile trovato.",
    "No accounting periods found.": "Nessun periodo contabile trovato.",
    "accounting.column.period": "Periodo",
    "accounting.column.start": "Inizio",
    "Start": "Inizio",
    "accounting.column.end": "Fine",
    "End": "Fine",
    "accounting.action.close_period": "Chiudi periodo",
    "Close period": "Chiudi periodo",
    "accounting.journal.new_title": "Nuovo registro",
    "New journal": "Nuovo registro",
    "accounting.journal.balance_help": "Dare e avere devono essere in pareggio prima del salvataggio.",
    "Debits and credits must balance before saving.": "Dare e avere devono essere in pareggio prima del salvataggio.",
    "accounting.journal.close": "Chiudi",
    "accounting.journal.entry_date": "Data registrazione",
    "Entry date": "Data registrazione",
    "accounting.journal.description": "Descrizione",
    "accounting.journal.source_type": "Tipo di origine",
    "accounting.journal.source_id": "ID origine",
    "Source ID": "ID origine",
    "accounting.journal.account": "Conto",
    "accounting.journal.select_account": "Seleziona conto",
    "Select account": "Seleziona conto",
    "accounting.journal.debit_total": "Dare: {debit} · Avere: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Dare: {debit} · Avere: {credit} · {status}",
    "accounting.journal.balanced": "In pareggio",
    "Balanced": "In pareggio",
    "accounting.journal.unbalanced": "Non in pareggio",
    "Unbalanced": "Non in pareggio",
    "accounting.journal.add_line": "Aggiungi riga",
    "Add line": "Aggiungi riga",
    "accounting.journal.save": "Salva registro",
    "Save journal": "Salva registro",
    "accounting.journal.empty": "Nessuna riga nel registro.",
    "No journal lines.": "Nessuna riga nel registro.",
    "accounting.journal.reason_prompt": "Motivo dello storno di questo registro:",
    "Reason for voiding this journal:": "Motivo dello storno di questo registro:",
    "accounting.journal.details_title": "Registro n. {id}",
    "Journal #{id}": "Registro n. {id}",
    "accounting.action.view": "Visualizza",
    "View": "Visualizza",
    "accounting.action.void": "Storna",
    "Void": "Storna",
    "accounting.filter.all_accounts": "Tutti i conti",
    "All accounts": "Tutti i conti",
    "accounting.empty.journals": "Nessun registro trovato.",
    "No journals found.": "Nessun registro trovato.",
    "accounting.column.date": "Data",
    "accounting.column.description": "Descrizione",
    "accounting.column.account_source": "Origine",
    "accounting.empty.journal_lines": "Nessuna riga nel registro.",
    "accounting.report.trial_balance": "Bilancio di verifica",
    "Trial balance": "Bilancio di verifica",
    "accounting.report.general_ledger": "Libro mastro",
    "General ledger": "Libro mastro",
    "accounting.action.run_report": "Genera report",
    "Run report": "Genera report",
    "accounting.report.loading": "Caricamento report…",
    "Loading report…": "Caricamento report…",
    "accounting.empty.report": "Nessuna riga del report trovata.",
    "No report rows found.": "Nessuna riga del report trovata.",
    "accounting.report.choose_run": "Scegli un report e avvialo.",
    "Choose a report and run it.": "Scegli un report e avvialo.",
    "accounting.column.balance": "Saldo",
    "Balance": "Saldo",
    "accounting.overview.chart_title": "Piano dei conti",
    "accounting.overview.chart_description": "Definisci i conti utilizzati nel libro mastro.",
    "Define the accounts used by your ledger.": "Definisci i conti utilizzati nel libro mastro.",
    "accounting.overview.journals_title": "Registri",
    "accounting.overview.journals_description": "Crea e rivedi registri con dare e avere in pareggio.",
    "Create and review balanced journal entries.": "Crea e rivedi registri con dare e avere in pareggio.",
    "accounting.overview.reports_title": "Report",
    "accounting.overview.reports_description": "Genera il bilancio di verifica e il libro mastro.",
    "Run trial balance and general ledger reports.": "Genera il bilancio di verifica e il libro mastro.",
    "common.refresh": "Aggiorna",
    "reports.search.title": "Analisi delle ricerche",
    "Search analytics": "Analisi delle ricerche",
    "reports.search.back_to_report": "Torna al report",
    "Back to report": "Torna al report",
    "reports.search.description": "La domanda di ricerca mostra cosa cercano i visitatori e dove il catalogo deve essere ampliato.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "La domanda di ricerca mostra cosa cercano i visitatori e dove il catalogo deve essere ampliato.",
    "reports.search.metric.searches": "Ricerche",
    "Searches": "Ricerche",
    "reports.search.metric.unique_keywords": "Parole chiave uniche",
    "Unique keywords": "Parole chiave uniche",
    "reports.search.metric.with_listings": "Con inserzioni",
    "With listings": "Con inserzioni",
    "reports.search.metric.no_matches": "Nessuna inserzione corrispondente",
    "No listing matches": "Nessuna inserzione corrispondente",
    "reports.search.metric.coverage": "Copertura",
    "Coverage": "Copertura",
    "reports.search.insights.title": "Analisi amministratore",
    "Admin insights": "Analisi amministratore",
    "reports.search.insights.no_results_one": "La parola chiave {count} non ha restituito inserzioni. Valuta di crearne una, aggiungere il termine come categoria o tag oppure migliorare titolo e descrizione.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "La parola chiave {count} non ha restituito inserzioni. Valuta di crearne una, aggiungere il termine come categoria o tag oppure migliorare titolo e descrizione.",
    "reports.search.insights.no_results_many": "Le parole chiave {count} non hanno restituito inserzioni. Creane alcune, aggiungi i termini come categorie o tag oppure migliora titoli e descrizioni.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "Le parole chiave {count} non hanno restituito inserzioni. Creane alcune, aggiungi i termini come categorie o tag oppure migliora titoli e descrizioni.",
    "reports.search.insights.all_covered": "Ogni parola chiave monitorata ha restituito almeno un’inserzione. Esamina i termini più frequenti per migliorare l’esposizione e il posizionamento nelle categorie.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "Ogni parola chiave monitorata ha restituito almeno un’inserzione. Esamina i termini più frequenti per migliorare l’esposizione e il posizionamento nelle categorie.",
    "reports.search.insights.empty": "I dati appariranno quando i visitatori cercheranno prodotti nel marketplace.",
    "Search data will appear after visitors search the marketplace.": "I dati appariranno quando i visitatori cercheranno prodotti nel marketplace.",
    "reports.search.insights.total_matches": "Sono state trovate {count} corrispondenze totali tra le inserzioni nei dati di ricerca caricati.",
    "{count} total listing matches were returned across the loaded search records.": "Sono state trovate {count} corrispondenze totali tra le inserzioni nei dati di ricerca caricati.",
    "reports.search.coverage_title": "Copertura parole chiave",
    "Keyword coverage": "Copertura parole chiave",
    "reports.search.loading": "Caricamento analisi delle ricerche…",
    "Loading search analytics…": "Caricamento analisi delle ricerche…",
    "reports.search.empty": "Nessuna frase di ricerca trovata.",
    "No search phrases found.": "Nessuna frase di ricerca trovata.",
    "reports.search.error.load": "Impossibile caricare l’analisi delle ricerche.",
    "Unable to load search analytics.": "Impossibile caricare l’analisi delle ricerche.",
    "reports.search.unknown": "Ricerca sconosciuta",
    "Unknown search": "Ricerca sconosciuta",
    "reports.search.column.keyword": "Parola chiave",
    "Keyword": "Parola chiave",
    "reports.search.column.listings": "Inserzioni",
    "reports.search.column.coverage": "Copertura",
    "reports.search.column.last_searched": "Ultima ricerca",
    "Last searched": "Ultima ricerca",
    "reports.search.column.suggested_action": "Azione consigliata",
    "Suggested action": "Azione consigliata",
    "reports.search.status.covered": "Coperto",
    "Covered": "Coperto",
    "reports.search.status.no_matches": "Nessuna corrispondenza",
    "No matches": "Nessuna corrispondenza",
    "reports.search.action.review_ranking": "Rivedi il posizionamento",
    "Review ranking": "Rivedi il posizionamento",
    "reports.search.action.add_listing": "Aggiungi un’inserzione o una categoria",
    "Add listing or category": "Aggiungi un’inserzione o una categoria",
    "platform_health.title": "Stato della piattaforma",
    "Platform health": "Stato della piattaforma",
    "platform_health.tab.health": "Stato",
    "Health": "Stato",
    "platform_health.tab.configuration": "Configurazione",
    "Configuration": "Configurazione",
    "platform_health.action.refreshing": "Aggiornamento…",
    "Refreshing…": "Aggiornamento…",
    "platform_health.window_note": "La vista corrente carica i primi {count} record per ogni tipo di evento.",
    "The current view loads the first {count} records for each event type.": "La vista corrente carica i primi {count} record per ogni tipo di evento.",
    "platform_health.error.title": "Impossibile caricare i controlli di autenticazione",
    "Unable to load authentication audits": "Impossibile caricare i controlli di autenticazione",
    "platform_health.error.proxy_note": "L’API potrebbe richiedere che questa richiesta amministrativa passi dal server anziché essere inviata direttamente dal browser.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "L’API potrebbe richiedere che questa richiesta amministrativa passi dal server anziché essere inviata direttamente dal browser.",
    "platform_health.error.session": "La sessione amministratore non è ancora pronta. Accedi di nuovo.",
    "Your admin session is not ready yet. Please sign in again.": "La sessione amministratore non è ancora pronta. Accedi di nuovo.",
    "platform_health.error.load": "Impossibile caricare i controlli di autenticazione ({status}).",
    "Unable to load authentication audits ({status}).": "Impossibile caricare i controlli di autenticazione ({status}).",
    "platform_health.error.load_generic": "Impossibile caricare i controlli sullo stato della piattaforma.",
    "Unable to load platform health audits.": "Impossibile caricare i controlli sullo stato della piattaforma.",
    "platform_health.metric.login_attempts": "Tentativi di accesso",
    "Login attempts": "Tentativi di accesso",
    "platform_health.metric.signup_attempts": "Tentativi di registrazione",
    "Signup attempts": "Tentativi di registrazione",
    "platform_health.metric.audit_records": "Record di audit",
    "Audit records": "Record di audit",
    "platform_health.metric.successful": "Riuscito",
    "platform_health.metric.failed": "Non riuscito",
    "platform_health.metric.outcome_returned": "Solo quando viene restituito un esito",
    "Only when outcome is returned": "Solo quando viene restituito un esito",
    "platform_health.metric.failure_rate": "Tasso di errore",
    "Failure rate": "Tasso di errore",
    "platform_health.metric.classified_records": "Record classificati",
    "Classified records": "Record classificati",
    "platform_health.activity.title": "Attività di autenticazione",
    "Authentication activity": "Attività di autenticazione",
    "platform_health.activity.description": "Tentativi restituiti nell’intervallo di audit selezionato",
    "Attempts returned by the selected audit window": "Tentativi restituiti nell’intervallo di audit selezionato",
    "platform_health.activity.no_timestamps": "Nessun record di audit con timestamp restituito.",
    "No timestamped audit records returned.": "Nessun record di audit con timestamp restituito.",
    "platform_health.event.login": "Accesso",
    "login": "Accesso",
    "platform_health.event.signup": "Registrazione",
    "signup": "Registrazione",
    "platform_health.status.success": "Riuscito",
    "platform_health.status.failed": "Non riuscito",
    "platform_health.status.recorded": "Registrato",
    "Recorded": "Registrato",
    "platform_health.unknown_day": "Sconosciuto",
    "Unknown": "Sconosciuto",
    "platform_health.failure_reasons": "Motivi degli errori",
    "Failure reasons": "Motivi degli errori",
    "platform_health.no_failures": "Nessun errore classificato restituito.",
    "No classified failures returned.": "Nessun errore classificato restituito.",
    "platform_health.unspecified_failure": "Errore non specificato",
    "Unspecified failure": "Errore non specificato",
    "platform_health.recent_records": "Record di audit recenti",
    "Recent audit records": "Record di audit recenti",
    "platform_health.normalized_note": "I campi grezzi vengono normalizzati solo per la visualizzazione.",
    "Raw fields are normalized only for display.": "I campi grezzi vengono normalizzati solo per la visualizzazione.",
    "platform_health.loaded_count": "Caricati: {count}",
    "platform_health.loading_records": "Caricamento record di audit…",
    "Loading audit records…": "Caricamento record di audit…",
    "platform_health.no_records": "Nessun record di audit restituito.",
    "No audit records returned.": "Nessun record di audit restituito.",
    "platform_health.column.event": "Evento",
    "platform_health.column.status": "Stato",
    "platform_health.column.user": "Utente",
    "User": "Utente",
    "platform_health.column.time": "Ora",
    "Time": "Ora",
    "platform_health.column.reason": "Motivo",
    "Reason": "Motivo",
    "platform_health.config.sign_in": "Metodo di accesso",
    "Sign-in method": "Metodo di accesso",
    "platform_health.config.facebook": "Autenticazione Facebook",
    "Facebook Auth": "Autenticazione Facebook",
    "platform_health.config.google": "Autenticazione Google",
    "Google Auth": "Autenticazione Google",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Queste impostazioni si applicano subito. Dopo il salvataggio, compaiono nelle app e nelle risposte API.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Queste impostazioni si applicano subito. Dopo il salvataggio, compaiono nelle app e nelle risposte API.",
    "integrations.note.mobile_release": "Le impostazioni del canale dell’app mobile si applicano al rilascio o all’aggiornamento del prodotto. Per una nuova build, invia una richiesta dal Portale di supporto. Valido per il piano Starter.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Le impostazioni del canale dell’app mobile si applicano al rilascio o all’aggiornamento del prodotto. Per una nuova build, invia una richiesta dal Portale di supporto. Valido per il piano Starter.",
    "integrations.toast.saved": "Impostazioni di integrazione salvate.",
    "Integration settings saved.": "Impostazioni di integrazione salvate.",
    "integrations.error.save": "Impossibile salvare le impostazioni di integrazione.",
    "Unable to save integration settings.": "Impossibile salvare le impostazioni di integrazione.",
    "integrations.twilio.title": "Integrazione Twilio",
    "Twilio integration": "Integrazione Twilio",
    "integrations.twilio.account_sid": "SID account",
    "Account SID": "SID account",
    "integrations.twilio.account_sid_placeholder": "Inserisci il SID dell’account",
    "Enter account SID": "Inserisci il SID dell’account",
    "integrations.twilio.auth_token": "Token di autenticazione",
    "Auth token": "Token di autenticazione",
    "integrations.twilio.auth_token_placeholder": "Inserisci il token di autenticazione",
    "Enter auth token": "Inserisci il token di autenticazione",
    "integrations.twilio.source_phone": "Numero di telefono mittente",
    "Source phone number": "Numero di telefono mittente",
    "integrations.twilio.source_phone_placeholder": "Inserisci il numero del mittente",
    "Enter source phone number": "Inserisci il numero del mittente",
    "integrations.facebook.title": "Autenticazione Facebook",
    "integrations.facebook.enable_login": "Abilita accesso Facebook",
    "Enable Facebook login": "Abilita accesso Facebook",
    "integrations.facebook.app_id": "ID app",
    "App ID": "ID app",
    "integrations.facebook.app_id_placeholder": "Inserisci l’ID app",
    "Enter app ID": "Inserisci l’ID app",
    "integrations.google.title": "Autenticazione Google",
    "integrations.google.enable_sign_in": "Abilita accesso Google",
    "Enable Google sign-in": "Abilita accesso Google",
    "integrations.google.client_id": "ID client",
    "Client ID": "ID client",
    "integrations.google.client_id_placeholder": "Inserisci l’ID client",
    "integrations.auth.title": "Metodo di accesso",
    "integrations.auth.description": "Scegli come gli utenti si registrano e accedono. Le verifiche email e SMS usano le impostazioni di invio configurate per il tenant.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Scegli come gli utenti si registrano e accedono. Le verifiche email e SMS usano le impostazioni di invio configurate per il tenant.",
    "integrations.auth.empty": "Non è configurato alcun metodo di accesso supportato. Selezionane uno per continuare.",
    "No supported sign-in method is currently configured. Select one to continue.": "Non è configurato alcun metodo di accesso supportato. Selezionane uno per continuare.",
    "integrations.auth.save_note": "Il salvataggio applica questo metodo agli endpoint di registrazione e accesso del tenant. Gli utenti creati direttamente vengono gestiti separatamente.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Il salvataggio applica questo metodo agli endpoint di registrazione e accesso del tenant. Gli utenti creati direttamente vengono gestiti separatamente.",
    "integrations.auth.error.load": "Impossibile caricare il metodo di accesso attuale.",
    "Unable to load the current sign-in method.": "Impossibile caricare il metodo di accesso attuale.",
    "integrations.auth.error.save": "Impossibile salvare il metodo di accesso.",
    "Unable to save the sign-in method.": "Impossibile salvare il metodo di accesso.",
    "integrations.auth.toast.saved": "Metodo di accesso salvato.",
    "Sign-in method saved.": "Metodo di accesso salvato.",
    "integrations.auth.email_password": "Email e password",
    "Email and password": "Email e password",
    "integrations.auth.email_password_help": "Gli utenti verificano l’email durante la registrazione, poi accedono con una password.",
    "Users verify their email during sign-up, then sign in with a password.": "Gli utenti verificano l’email durante la registrazione, poi accedono con una password.",
    "integrations.auth.email_code": "Codice monouso via email",
    "Email one-time code": "Codice monouso via email",
    "integrations.auth.email_code_help": "Gli utenti ricevono via email un codice di verifica per registrarsi e accedere.",
    "Users receive a verification code by email for sign-up and sign-in.": "Gli utenti ricevono via email un codice di verifica per registrarsi e accedere.",
    "integrations.auth.phone_code": "Codice monouso via telefono",
    "Phone one-time code": "Codice monouso via telefono",
    "integrations.auth.phone_code_help": "Gli utenti ricevono via SMS un codice di verifica per registrarsi e accedere.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Gli utenti ricevono via SMS un codice di verifica per registrarsi e accedere.",
    "integrations.auth.phone_password": "Telefono e password",
    "Phone and password": "Telefono e password",
    "integrations.auth.phone_password_help": "Gli utenti verificano il telefono durante la registrazione, poi accedono con una password.",
    "Users verify their phone during sign-up, then sign in with a password.": "Gli utenti verificano il telefono durante la registrazione, poi accedono con una password.",
    "integrations.auth.email_password_unverified": "Email e password senza verifica in fase di registrazione",
    "Email and password without sign-up verification": "Email e password senza verifica in fase di registrazione",
    "integrations.auth.email_password_unverified_help": "Gli utenti possono registrarsi con email e password senza codice di verifica.",
    "Users can sign up with an email and password without an email verification code.": "Gli utenti possono registrarsi con email e password senza codice di verifica.",
    "integrations.auth.phone_password_unverified": "Telefono e password senza verifica in fase di registrazione",
    "Phone and password without sign-up verification": "Telefono e password senza verifica in fase di registrazione",
    "integrations.auth.phone_password_unverified_help": "Gli utenti possono registrarsi con telefono e password senza codice di verifica SMS.",
    "Users can sign up with a phone and password without an SMS verification code.": "Gli utenti possono registrarsi con telefono e password senza codice di verifica SMS.",
    "integrations.page.title": "Integrazioni app",
    "App Integrations": "Integrazioni app",
    "integrations.generic.id_placeholder": "Inserisci ID {name}",
    "Enter {name} ID": "Inserisci ID {name}",
    "integrations.generic.enable": "Abilita integrazione {name}",
    "Enable {name} integration": "Abilita integrazione {name}",
    "integrations.menu.map": "Mappe",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Integrazione mappe",
    "Maps integration": "Integrazione mappe",
    "integrations.maps.google": "Google Maps",
    "Google Maps": "Google Maps",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "Chiave API",
    "API key": "Chiave API",
    "integrations.maps.api_key_placeholder": "Inserisci la chiave API",
    "Enter API key": "Inserisci la chiave API",
    "integrations.maps.reverse_geocode_key": "Chiave API di geocodifica inversa di Google Maps",
    "Google Maps reverse geocoding API key": "Chiave API di geocodifica inversa di Google Maps",
    "integrations.maps.reverse_geocode_key_placeholder": "Inserisci la chiave API di geocodifica inversa di Google Maps",
    "Enter Google Maps reverse geocoding API key": "Inserisci la chiave API di geocodifica inversa di Google Maps",
    "integrations.maps.places_key": "Chiave Places API di Google Maps",
    "Google Maps Places API key": "Chiave Places API di Google Maps",
    "integrations.maps.places_key_placeholder": "Inserisci la chiave Places API di Google Maps",
    "Enter Google Maps Places API key": "Inserisci la chiave Places API di Google Maps",
    "integrations.maps.nearby_accounts": "Attiva gli account vicini nella home page",
    "Activate nearby accounts on the home page": "Attiva gli account vicini nella home page",
    "integrations.maps.listing_location": "Attiva la posizione durante l’inserimento di un annuncio",
    "Activate location in listing submission": "Attiva la posizione durante l’inserimento di un annuncio",
    "integrations.maps.account_location": "Attiva la posizione durante la creazione di un account",
    "Activate location in account submission": "Attiva la posizione durante la creazione di un account",
    "integrations.playstore.title": "Integrazione Google Play",
    "Google Play integration": "Integrazione Google Play",
    "integrations.playstore.application_id": "ID applicazione",
    "Application ID": "ID applicazione",
    "integrations.playstore.application_id_placeholder": "Inserisci l’ID applicazione (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Inserisci l’ID applicazione (com.tenantname.app)",
    "integrations.playstore.first_name": "Nome",
    "integrations.playstore.first_name_placeholder": "Inserisci il nome",
    "Enter first name": "Inserisci il nome",
    "integrations.playstore.last_name": "Cognome",
    "integrations.playstore.last_name_placeholder": "Inserisci il cognome",
    "Enter last name": "Inserisci il cognome",
    "integrations.playstore.unit": "Unità organizzativa",
    "Organizational unit": "Unità organizzativa",
    "integrations.playstore.unit_placeholder": "Inserisci l’unità organizzativa",
    "Enter organizational unit": "Inserisci l’unità organizzativa",
    "integrations.playstore.organization": "Organizzazione",
    "Organization": "Organizzazione",
    "integrations.playstore.organization_placeholder": "Inserisci il nome dell’organizzazione",
    "Enter organization name": "Inserisci il nome dell’organizzazione",
    "integrations.playstore.city": "Città o località",
    "City or locality": "Città o località",
    "integrations.playstore.city_placeholder": "Inserisci città o località",
    "Enter city or locality": "Inserisci città o località",
    "integrations.playstore.state": "Stato o provincia",
    "State or province": "Stato o provincia",
    "integrations.playstore.state_placeholder": "Inserisci stato o provincia",
    "Enter state or province": "Inserisci stato o provincia",
    "integrations.playstore.country_code": "Codice paese (XX)",
    "Country code (XX)": "Codice paese (XX)",
    "integrations.playstore.country_code_placeholder": "Inserisci il codice paese",
    "Enter country code": "Inserisci il codice paese",
    "integrations.playstore.link": "Link Google Play",
    "Google Play link": "Link Google Play",
    "integrations.playstore.link_placeholder": "Inserisci il link della tua app su Google Play",
    "Enter your app Google Play link": "Inserisci il link della tua app su Google Play",
    "integrations.admob.title": "Integrazione AdMob",
    "AdMob integration": "Integrazione AdMob",
    "integrations.admob.app_id": "ID app",
    "integrations.admob.app_id_placeholder": "Inserisci l’ID app",
    "Enter App ID": "Inserisci l’ID app",
    "integrations.admob.unit_id": "ID unità pubblicitaria",
    "Unit ID": "ID unità pubblicitaria",
    "integrations.admob.unit_id_placeholder": "Inserisci l’ID dell’unità pubblicitaria AdMob",
    "Enter AdMob unit ID": "Inserisci l’ID dell’unità pubblicitaria AdMob",
    "integrations.admob.listings_id": "ID inserzioni",
    "Listings ID": "ID inserzioni",
    "integrations.admob.listings_id_placeholder": "Inserisci l’ID delle inserzioni",
    "Enter listings ID": "Inserisci l’ID delle inserzioni",
    "integrations.admob.listing_detail_id": "ID dettaglio inserzione",
    "Listing detail ID": "ID dettaglio inserzione",
    "integrations.admob.listing_detail_id_placeholder": "Inserisci l’ID del dettaglio inserzione",
    "Enter listing detail ID": "Inserisci l’ID del dettaglio inserzione",
    "integrations.admob.home_id": "ID home",
    "Home ID": "ID home",
    "integrations.admob.home_id_placeholder": "Inserisci l’ID home",
    "Enter home ID": "Inserisci l’ID home",
    "integrations.admob.enable_ads": "Abilita annunci",
    "Enable ads": "Abilita annunci",
    "integrations.admob.enable_listing_ads": "Abilita gli annunci nel feed delle inserzioni",
    "Enable ads on the listings feed": "Abilita gli annunci nel feed delle inserzioni",
    "integrations.admob.enable_listing_detail_ads": "Abilita gli annunci nei dettagli dell’inserzione",
    "Enable ads on listing details": "Abilita gli annunci nei dettagli dell’inserzione",
    "integrations.admob.enable_home_ads": "Abilita gli annunci nella barra di navigazione inferiore della home",
    "Enable ads in the home bottom navigation": "Abilita gli annunci nella barra di navigazione inferiore della home",
    "integrations.save_success": "Salvato correttamente",
    "Saved successfully": "Salvato correttamente",
    "integrations.note.release": "Queste impostazioni si applicano al rilascio o all’aggiornamento dell’app mobile. Dopo le modifiche, richiedi una nuova build dal Portale di supporto. Si applica al piano Starter.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Queste impostazioni si applicano al rilascio o all’aggiornamento dell’app mobile. Dopo le modifiche, richiedi una nuova build dal Portale di supporto. Si applica al piano Starter.",
    "integrations.action.download": "Scarica",
    "integrations.branch.title": "Integrazione Branch",
    "Branch integration": "Integrazione Branch",
    "integrations.branch.app_id": "ID app",
    "integrations.branch.app_id_placeholder": "Inserisci l’ID app",
    "integrations.branch.live_key": "Chiave live",
    "Live key": "Chiave live",
    "integrations.branch.live_key_placeholder": "Inserisci la chiave live",
    "Enter live key": "Inserisci la chiave live",
    "integrations.branch.live_secret": "Secret live",
    "Live secret": "Secret live",
    "integrations.branch.live_secret_placeholder": "Inserisci il secret live",
    "Enter live secret": "Inserisci il secret live",
    "integrations.branch.uri_scheme": "Schema URI",
    "URI scheme": "Schema URI",
    "integrations.branch.uri_scheme_placeholder": "Inserisci lo schema URI",
    "Enter URI scheme": "Inserisci lo schema URI",
    "integrations.branch.link_domain": "Dominio link",
    "Link domain": "Dominio link",
    "integrations.branch.link_domain_placeholder": "Inserisci il dominio del link",
    "Enter link domain": "Inserisci il dominio del link",
    "integrations.branch.alternate_domain": "Dominio link alternativo",
    "Alternate link domain": "Dominio link alternativo",
    "integrations.branch.alternate_domain_placeholder": "Inserisci il dominio link alternativo",
    "Enter alternate link domain": "Inserisci il dominio link alternativo",
    "integrations.branch.link_description": "Descrizione del link",
    "Link description": "Descrizione del link",
    "integrations.branch.link_description_placeholder": "Inserisci la descrizione del link",
    "Enter link description": "Inserisci la descrizione del link",
    "integrations.branch.invite_friends": "Invita amici",
    "Invite friends": "Invita amici",
    "integrations.branch.invite_title": "Titolo",
    "Title": "Titolo",
    "integrations.branch.invite_description": "Descrizione",
    "integrations.branch.destination_link": "Link di destinazione Branch (facoltativo)",
    "Branch destination link (optional)": "Link di destinazione Branch (facoltativo)",
    "integrations.branch.web_app_note": "Si applica agli utenti dell’app web",
    "Applies to web app users": "Si applica agli utenti dell’app web",
    "integrations.branch.destination_placeholder": "Inserisci il link di destinazione Branch",
    "Enter branch destination link": "Inserisci il link di destinazione Branch",
    "integrations.ios.title": "Configurazione App Store",
    "App Store provisioning": "Configurazione App Store",
    "integrations.ios.bundle_id": "ID bundle",
    "Bundle ID": "ID bundle",
    "integrations.ios.bundle_id_placeholder": "Inserisci l’ID bundle",
    "Enter bundle ID": "Inserisci l’ID bundle",
    "integrations.ios.certificate_password": "Password del certificato di distribuzione",
    "Distribution certificate password": "Password del certificato di distribuzione",
    "integrations.ios.certificate_password_placeholder": "Inserisci la password del certificato di distribuzione",
    "Enter distribution certificate password": "Inserisci la password del certificato di distribuzione",
    "integrations.ios.push_key_id": "ID chiave push",
    "Push key ID": "ID chiave push",
    "integrations.ios.push_key_id_placeholder": "Inserisci l’ID della chiave push",
    "Enter push key ID": "Inserisci l’ID della chiave push",
    "integrations.ios.team_id": "ID team",
    "Team ID": "ID team",
    "integrations.ios.team_id_placeholder": "Inserisci l’ID team",
    "Enter team ID": "Inserisci l’ID team",
    "integrations.ios.apple_id": "Apple ID",
    "Apple ID": "Apple ID",
    "integrations.ios.apple_id_placeholder": "Inserisci l’Apple ID",
    "Enter Apple ID": "Inserisci l’Apple ID",
    "integrations.ios.distribution_certificate": "Certificato di distribuzione",
    "Distribution certificate": "Certificato di distribuzione",
    "integrations.ios.provisioning_profile": "Profilo di provisioning per la distribuzione",
    "Distribution provisioning profile": "Profilo di provisioning per la distribuzione",
    "integrations.ios.push_key": "Chiave push",
    "Push key": "Chiave push",
    "integrations.ios.app_store_link": "Link App Store",
    "Your App Store link": "Link App Store",
    "integrations.ios.app_store_link_placeholder": "Inserisci il link App Store della tua app",
    "Enter your app App Store link": "Inserisci il link App Store della tua app",
    "integrations.firebase.title": "Integrazione Firebase",
    "Firebase integration": "Integrazione Firebase",
    "integrations.firebase.choose_file": "Scegli file",
    "Choose file": "Scegli file",
    "integrations.firebase.service_account": "Account di servizio Firebase",
    "Firebase service account": "Account di servizio Firebase",
    "integrations.firebase.android_json": "File JSON dell’app Android",
    "Android app JSON file": "File JSON dell’app Android",
    "integrations.firebase.ios_plist": "File plist dell’app iOS",
    "iOS app plist file": "File plist dell’app iOS",
    "integrations.firebase.create_project": "Crea progetto Firebase",
    "Create Firebase project": "Crea progetto Firebase",
    "integrations.firebase.create_android": "Crea app Android",
    "Create Android app": "Crea app Android",
    "integrations.firebase.create_ios": "Crea app iOS",
    "Create iOS app": "Crea app iOS",
    "integrations.firebase.create_database": "Crea database in tempo reale",
    "Create realtime database": "Crea database in tempo reale",
    "integrations.firebase.apply_rules": "Applica le regole del database Firebase",
    "Apply Firebase database rules": "Applica le regole del database Firebase",
    "bundles.listing_number": "Inserzione n. {id}",
    "Listing #{id}": "Inserzione n. {id}",
    "bundles.listing_id": "ID {id}",
    "ID {id}": "ID {id}",
    "bundles.configure.title": "Configura bundle",
    "Configure bundle": "Configura bundle",
    "bundles.configure.subtitle": "Bundle n. {id} · aggiungi qui sotto le inserzioni esistenti.",
    "Bundle listing #{id} · add existing listings below.": "Bundle n. {id} · aggiungi qui sotto le inserzioni esistenti.",
    "bundles.back": "Torna ai bundle",
    "Back to bundles": "Torna ai bundle",
    "bundles.fixed_components": "Componenti fissi",
    "Fixed components": "Componenti fissi",
    "bundles.selection_pool": "Gruppo di scelta",
    "Mix-and-match pool": "Gruppo di scelta",
    "bundles.available_listings": "Inserzioni disponibili",
    "Available listings": "Inserzioni disponibili",
    "bundles.available_description": "Cerca e aggiungi prodotti già presenti nel catalogo.",
    "Search and add products already in your catalogue.": "Cerca e aggiungi prodotti già presenti nel catalogo.",
    "bundles.search_listings": "Cerca inserzioni",
    "Search listings": "Cerca inserzioni",
    "bundles.quantity_per_component": "Quantità per componente",
    "Quantity per component": "Quantità per componente",
    "bundles.loading_listings": "Caricamento inserzioni…",
    "Loading listings…": "Caricamento inserzioni…",
    "bundles.added": "Aggiunto",
    "Added": "Aggiunto",
    "bundles.adding": "Aggiunta…",
    "Adding…": "Aggiunta…",
    "bundles.add": "Aggiungi",
    "bundles.no_matching_listings": "Nessuna inserzione corrispondente trovata.",
    "No matching listings found.": "Nessuna inserzione corrispondente trovata.",
    "bundles.one_listing_added": "1 inserzione aggiunta",
    "1 listing added": "1 inserzione aggiunta",
    "bundles.many_listings_added": "Aggiunte {count} inserzioni",
    "{count} listings added": "Aggiunte {count} inserzioni",
    "bundles.quantity_short": "Qtà {count}",
    "Qty {count}": "Qtà {count}",
    "bundles.removing": "Rimozione…",
    "Removing…": "Rimozione…",
    "bundles.remove": "Rimuovi",
    "bundles.no_components": "Nessun componente aggiunto.",
    "No components added yet.": "Nessun componente aggiunto.",
    "bundles.pool_remove_note": "La rimozione dal gruppo richiede un endpoint backend; l’aggiunta è già disponibile.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "La rimozione dal gruppo richiede un endpoint backend; l’aggiunta è già disponibile.",
    "bundles.error.load_components": "Impossibile caricare i componenti del bundle.",
    "Unable to load bundle components.": "Impossibile caricare i componenti del bundle.",
    "bundles.error.add_listing": "Impossibile aggiungere l’inserzione al bundle.",
    "Unable to add listing to the bundle.": "Impossibile aggiungere l’inserzione al bundle.",
    "bundles.error.remove_component": "Impossibile rimuovere il componente del bundle.",
    "Unable to remove bundle component.": "Impossibile rimuovere il componente del bundle.",
    "bundles.error.load_listings": "Impossibile caricare le inserzioni.",
    "Unable to load listings.": "Impossibile caricare le inserzioni.",
    "bundles.components": "Componenti del bundle",
    "Bundle components": "Componenti del bundle",
    "bundles.picker_description": "Seleziona le inserzioni già presenti nel catalogo. Verranno collegate dopo la creazione del bundle.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Seleziona le inserzioni già presenti nel catalogo. Verranno collegate dopo la creazione del bundle.",
    "bundles.fixed_bundle": "Bundle fisso",
    "Fixed bundle": "Bundle fisso",
    "bundles.mix_match": "Componi il tuo bundle",
    "Mix and match": "Componi il tuo bundle",
    "bundles.quantity_per_selected": "Quantità per inserzione selezionata",
    "Quantity per selected listing": "Quantità per inserzione selezionata",
    "bundles.search_existing": "Cerca inserzioni esistenti",
    "Search existing listings": "Cerca inserzioni esistenti",
    "bundles.selected_count": "Selezionati ({count})",
    "Selected ({count})": "Selezionati ({count})",
    "bundles.choose_component_hint": "Seleziona almeno un’inserzione esistente oppure crea prima il bundle.",
    "Choose at least one existing listing, or create the bundle first.": "Seleziona almeno un’inserzione esistente oppure crea prima il bundle.",
    "bundles.error.attach_components": "Il bundle è stato creato, ma non è stato possibile collegare i componenti.",
    "The bundle was created, but components could not be attached.": "Il bundle è stato creato, ma non è stato possibile collegare i componenti.",
    "bundles.continue_configure_hint": "Puoi continuare dalla pagina di configurazione del bundle.",
    "You can continue from the bundle configuration page.": "Puoi continuare dalla pagina di configurazione del bundle.",
    "bundles.title": "Bundle",
    "bundles.create": "Crea bundle",
    "Create bundle": "Crea bundle",
    "bundles.subtitle": "Crea l’inserzione principale del bundle, poi aggiungi componenti fissi o un gruppo di scelta.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Crea l’inserzione principale del bundle, poi aggiungi componenti fissi o un gruppo di scelta.",
    "bundles.workflow": "Procedura bundle",
    "Bundle workflow": "Procedura bundle",
    "bundles.how_it_works": "Come funzionano i bundle",
    "How bundles work": "Come funzionano i bundle",
    "bundles.parent_description": "Un’inserzione principale definisce il bundle visibile al cliente.",
    "One parent listing controls the customer-facing bundle.": "Un’inserzione principale definisce il bundle visibile al cliente.",
    "bundles.flow": "Flusso bundle",
    "Bundle flow": "Flusso bundle",
    "bundles.parent_listing": "Inserzione principale",
    "Parent listing": "Inserzione principale",
    "bundles.name_price_category": "Nome, prezzo, categoria",
    "Name, price, category": "Nome, prezzo, categoria",
    "bundles.fixed_or_pool": "Articoli fissi o gruppo",
    "Fixed items or a pool": "Articoli fissi o gruppo",
    "bundles.checkout_stock": "Checkout e disponibilità",
    "Checkout stock": "Checkout e disponibilità",
    "bundles.selection_availability": "Selezione e disponibilità",
    "Selection + availability": "Selezione e disponibilità",
    "bundles.fixed_bundles": "Bundle fissi",
    "Fixed bundles": "Bundle fissi",
    "bundles.fixed_description": "Vendi insieme un gruppo definito di inserzioni esistenti.",
    "Sell a defined group of existing listings together.": "Vendi insieme un gruppo definito di inserzioni esistenti.",
    "bundles.fixed_detail": "Aggiungi inserzioni esistenti come componenti fissi.",
    "Add existing listings as fixed components.": "Aggiungi inserzioni esistenti come componenti fissi.",
    "bundles.pool_description": "Consenti ai clienti di scegliere gli articoli idonei dal gruppo.",
    "Let customers choose eligible items from a bundle pool.": "Consenti ai clienti di scegliere gli articoli idonei dal gruppo.",
    "bundles.pool_detail": "Imposta il numero minimo e massimo di selezioni al checkout.",
    "Set the minimum and maximum selections at checkout.": "Imposta il numero minimo e massimo di selezioni al checkout.",
    "channels.opensource.title": "Kit di partenza open source",
    "Open-source starter kits": "Kit di partenza open source",
    "channels.opensource.view_org": "Visualizza organizzazione GitHub",
    "View GitHub organization": "Visualizza organizzazione GitHub",
    "channels.opensource.description": "Esplora i repository open source e i kit di partenza Tradly dell’organizzazione TRADLY-PLATFORM.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "Esplora i repository open source e i kit di partenza Tradly dell’organizzazione TRADLY-PLATFORM.",
    "channels.opensource.loading": "Caricamento repository…",
    "Loading repositories…": "Caricamento repository…",
    "channels.opensource.error.http": "GitHub ha restituito {status}.",
    "GitHub returned {status}.": "GitHub ha restituito {status}.",
    "channels.opensource.error.load": "Impossibile caricare i repository. Riprova più tardi.",
    "Unable to load repositories. Try again later.": "Impossibile caricare i repository. Riprova più tardi.",
    "channels.opensource.empty": "Nessun repository pubblico trovato.",
    "No public repositories found.": "Nessun repository pubblico trovato.",
    "channels.opensource.repo_fallback": "Repository Tradly open source.",
    "Open-source Tradly repository.": "Repository Tradly open source.",
    "channels.opensource.language_code": "Codice",
    "channels.opensource.view_repo": "Visualizza repository",
    "View repository": "Visualizza repository",
    "developer.mcp.select_all": "Seleziona tutto",
    "Select all": "Seleziona tutto",
    "developer.mcp.read": "Lettura",
    "developer.mcp.write": "Scrittura",
    "developer.mcp.delete": "Eliminazione",
    "developer.mcp.export": "Esporta",
    "developer.mcp.copy": "Copia",
    "Copy": "Copia",
    "developer.mcp.copied": "Copiato",
    "Copied": "Copiato",
    "developer.mcp.connection_created": "Connessione creata",
    "Connection created": "Connessione creata",
    "developer.mcp.save_secret_warning": "Salva subito il secret client: non verrà mostrato di nuovo.",
    "Save your client secret now — it will not be shown again.": "Salva subito il secret client: non verrà mostrato di nuovo.",
    "developer.mcp.client_id": "ID client",
    "developer.mcp.client_secret": "Secret client",
    "developer.mcp.new_connection": "Nuova connessione MCP",
    "New MCP connection": "Nuova connessione MCP",
    "developer.mcp.platform": "Piattaforma",
    "Platform": "Piattaforma",
    "developer.mcp.platform_custom": "Personalizzata",
    "developer.mcp.connection_name": "Nome connessione",
    "Connection name": "Nome connessione",
    "developer.mcp.connection_name_placeholder": "es. ChatGPT",
    "e.g. ChatGPT": "es. ChatGPT",
    "developer.mcp.redirect_uris": "URI di reindirizzamento",
    "Redirect URIs": "URI di reindirizzamento",
    "developer.mcp.one_per_line": "(uno per riga)",
    "(one per line)": "(uno per riga)",
    "developer.mcp.permissions": "Autorizzazioni",
    "Permissions": "Autorizzazioni",
    "developer.mcp.error.connection_name": "Inserisci il nome della connessione",
    "Enter a connection name": "Inserisci il nome della connessione",
    "developer.mcp.error.redirect_uri": "Inserisci almeno un URI di reindirizzamento",
    "Enter at least one redirect URI": "Inserisci almeno un URI di reindirizzamento",
    "developer.mcp.error.create": "Impossibile creare la connessione",
    "Failed to create connection": "Impossibile creare la connessione",
    "developer.mcp.creating": "Creazione…",
    "Creating…": "Creazione…",
    "developer.mcp.edit_permissions": "Modifica autorizzazioni",
    "Edit permissions": "Modifica autorizzazioni",
    "developer.mcp.permissions_updated": "Autorizzazioni aggiornate",
    "developer.mcp.error.update_permissions": "Impossibile aggiornare le autorizzazioni",
    "Failed to update permissions": "Impossibile aggiornare le autorizzazioni",
    "developer.mcp.saving": "Salvataggio…",
    "developer.mcp.error.load": "Impossibile caricare le connessioni MCP.",
    "MCP connections could not be loaded.": "Impossibile caricare le connessioni MCP.",
    "developer.mcp.confirm_delete": "Eliminare questa connessione? Verrà rimossa dall’elenco e il relativo accesso sarà revocato.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Eliminare questa connessione? Verrà rimossa dall’elenco e il relativo accesso sarà revocato.",
    "developer.mcp.connection_removed": "Connessione rimossa",
    "Connection removed": "Connessione rimossa",
    "developer.mcp.error.remove_connection": "Impossibile rimuovere la connessione",
    "Failed to remove connection": "Impossibile rimuovere la connessione",
    "developer.mcp.connection_deactivated": "Connessione disattivata",
    "Connection deactivated": "Connessione disattivata",
    "developer.mcp.error.deactivate_connection": "Impossibile disattivare la connessione",
    "Failed to deactivate connection": "Impossibile disattivare la connessione",
    "developer.mcp.title": "Connessioni MCP",
    "MCP connections": "Connessioni MCP",
    "developer.mcp.description": "Client OAuth registrati nel tenant e app AI autorizzate a usare il server MCP del tenant.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Client OAuth registrati nel tenant e app AI autorizzate a usare il server MCP del tenant.",
    "developer.mcp.empty": "Nessuna connessione. Crea un client o collega un’app AI al server MCP del tenant.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Nessuna connessione. Crea un client o collega un’app AI al server MCP del tenant.",
    "developer.mcp.status.connected_one": "Connesso · 1 utente",
    "Connected · 1 user": "Connesso · 1 utente",
    "developer.mcp.status.connected_many": "Connesso · {count} utenti",
    "Connected · {count} users": "Connesso · {count} utenti",
    "developer.mcp.status.deactivated": "Disattivato",
    "Deactivated": "Disattivato",
    "developer.mcp.status.previously_connected": "Connesso in precedenza",
    "Previously connected": "Connesso in precedenza",
    "developer.mcp.status.registered": "Registrato · non connesso",
    "Registered · not connected": "Registrato · non connesso",
    "developer.mcp.oauth_app": "App OAuth",
    "OAuth app": "App OAuth",
    "developer.mcp.created": "Creato",
    "developer.mcp.updated": "Aggiornato",
    "Updated": "Aggiornato",
    "developer.mcp.edit_scopes": "Modifica ambiti",
    "Edit scopes": "Modifica ambiti",
    "developer.mcp.edit_scopes_for": "Modifica gli ambiti per {name}",
    "Edit scopes for {name}": "Modifica gli ambiti per {name}",
    "developer.mcp.deactivate_hint": "Disattiva (mantieni nell’elenco e nei log)",
    "Deactivate (keeps it listed and logged)": "Disattiva (mantieni nell’elenco e nei log)",
    "developer.mcp.deactivate_named": "Disattiva {name}",
    "Deactivate {name}": "Disattiva {name}",
    "developer.mcp.delete_connection": "Elimina connessione",
    "Delete connection": "Elimina connessione",
    "developer.mcp.delete_named": "Elimina {name}",
    "Delete {name}": "Elimina {name}",
    "developer.mcp.resource.listings": "Inserzioni",
    "developer.mcp.resource.orders": "Ordini",
    "developer.mcp.resource.users": "Utenti",
    "developer.mcp.resource.accounts": "Account",
    "developer.mcp.resource.categories": "Categorie",
    "developer.mcp.resource.attributes": "Attributi",
    "developer.mcp.resource.analytics": "Analisi",
    "developer.mcp.resource.attribution": "Attribuzione",
    "Attribution": "Attribuzione",
    "developer.mcp.resource.rewards": "Premi",
    "developer.mcp.resource.layers": "Layers / CMS",
    "Layers / CMS": "Layers / CMS",
    "developer.mcp.resource.settings": "Impostazioni del negozio",
    "Store settings": "Impostazioni del negozio",
    "developer.mcp.resource.marketing": "Marketing",
    "developer.mcp.resource.market_research": "Ricerca di mercato",
    "Market research": "Ricerca di mercato",
    "developer.mcp.resource.audiences": "Pubblici marketing",
    "Marketing audiences": "Pubblici marketing",
    "developer.mcp.resource.agents": "Agenti AI",
    "developer.mcp.resource.assets": "Caricamento file",
    "File uploads": "Caricamento file",
    "developer.mcp.resource.workforce": "Personale",
    "developer.mcp.resource.inventory": "Inventario",
    "developer.mcp.resource.memberships": "Iscrizioni",
    "Memberships": "Iscrizioni",
    "developer.mcp.resource.bundles": "Bundle",
    "developer.mcp.resource.rentals": "Noleggi",
    "Rentals": "Noleggi",
    "developer.mcp.resource.accounting": "Contabilità",
    "developer.mcp.nav.label": "Navigazione MCP",
    "MCP navigation": "Navigazione MCP",
    "developer.mcp.nav.connections": "Connessioni",
    "Connections": "Connessioni",
    "developer.mcp.nav.logs": "Log",
    "Logs": "Log",
    "developer.mcp.unknown_provider": "Provider sconosciuto",
    "Unknown provider": "Provider sconosciuto",
    "developer.mcp.tenant_user": "Tenant n. {tenant} · Utente n. {user}",
    "Tenant #{tenant} · User #{user}": "Tenant n. {tenant} · Utente n. {user}",
    "developer.mcp.logs.title": "Log MCP",
    "MCP logs": "Log MCP",
    "developer.mcp.logs.heading": "Attività recenti degli agenti",
    "Recent agent activity": "Attività recenti degli agenti",
    "developer.mcp.logs.description": "Sono mostrati gli eventi MCP di questo tenant. La vista attività si aggiorna ogni 15 secondi.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Sono mostrati gli eventi MCP di questo tenant. La vista attività si aggiorna ogni 15 secondi.",
    "developer.mcp.logs.error.audit": "Impossibile caricare i log di audit MCP.",
    "MCP audit logs could not be loaded.": "Impossibile caricare i log di audit MCP.",
    "developer.mcp.logs.error.load": "Impossibile caricare i log MCP.",
    "MCP logs could not be loaded.": "Impossibile caricare i log MCP.",
    "developer.mcp.logs.unknown_agent": "Agente sconosciuto",
    "Unknown agent": "Agente sconosciuto",
    "developer.mcp.logs.all_agents": "Tutti gli agenti",
    "All agents": "Tutti gli agenti",
    "developer.mcp.logs.updated": "Aggiornato {time}",
    "Updated {time}": "Aggiornato {time}",
    "developer.mcp.logs.loading": "Caricamento attività MCP…",
    "Loading MCP activity…": "Caricamento attività MCP…",
    "developer.mcp.logs.empty": "Nessun evento MCP recente per questo tenant.",
    "No recent MCP events found for this tenant.": "Nessun evento MCP recente per questo tenant.",
    "developer.mcp.logs.empty_agent": "Nessun evento MCP recente per questo tenant e agente.",
    "No recent MCP events found for this tenant and agent.": "Nessun evento MCP recente per questo tenant e agente.",
    "developer.mcp.logs.time": "Ora",
    "developer.mcp.logs.event": "Evento",
    "developer.mcp.logs.tool": "Strumento",
    "developer.mcp.logs.agent": "Agente",
    "Agent": "Agente",
    "developer.mcp.logs.tenant_user": "Tenant / utente",
    "Tenant / user": "Tenant / utente",
    "developer.mcp.logs.scope": "Ambito",
    "Scope": "Ambito",
    "developer.mcp.logs.result": "Risultato",
    "Result": "Risultato",
    "developer.mcp.logs.duration": "Durata",
    "Duration": "Durata",
    "developer.mcp.logs.view_details": "Visualizza i dettagli di {event}",
    "View details for {event}": "Visualizza i dettagli di {event}",
    "developer.mcp.logs.tenant": "Tenant n. {id}",
    "Tenant #{id}": "Tenant n. {id}",
    "developer.mcp.logs.user": "Utente n. {id}",
    "User #{id}": "Utente n. {id}",
    "developer.mcp.logs.view_granted_scopes": "Visualizza gli ambiti concessi",
    "View granted scopes": "Visualizza gli ambiti concessi",
    "developer.mcp.logs.succeeded": "Riuscito",
    "Succeeded": "Riuscito",
    "developer.mcp.logs.failed": "Non riuscito",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "Dettagli evento MCP",
    "MCP event details": "Dettagli evento MCP",
    "developer.mcp.logs.required_scope": "Ambito richiesto",
    "Required scope": "Ambito richiesto",
    "developer.mcp.logs.granted_scopes": "Ambiti concessi",
    "Granted scopes": "Ambiti concessi",
    "developer.mcp.logs.event_generic": "Evento",
    "developer.mcp.logs.event.tool_called": "Strumento chiamato",
    "Tool called": "Strumento chiamato",
    "developer.mcp.logs.event.connection_requested": "Connessione richiesta",
    "Connection requested": "Connessione richiesta",
    "developer.mcp.logs.event.connection_connected": "Connesso",
    "Connection connected": "Connesso",
    "developer.mcp.logs.event.connection_deactivated": "Connessione disattivata",
    "developer.mcp.logs.event.connection_deleted": "Connessione eliminata",
    "Connection deleted": "Connessione eliminata",
    "developer.mcp.logs.event.permissions_updated": "Permessi aggiornati",
    "common.status.label": "Stato",
    "suppliers.title": "Fornitori",
    "suppliers.search": "Cerca fornitori",
    "Search suppliers": "Cerca fornitori",
    "suppliers.add": "Aggiungi fornitore",
    "Add supplier": "Aggiungi fornitore",
    "suppliers.deactivate": "Disattiva",
    "Deactivate": "Disattiva",
    "suppliers.empty": "Nessun fornitore trovato.",
    "No suppliers found.": "Nessun fornitore trovato.",
    "suppliers.add_title": "Aggiungi fornitore",
    "suppliers.edit_title": "Modifica fornitore",
    "Edit supplier": "Modifica fornitore",
    "suppliers.save_changes": "Salva modifiche",
    "Save changes": "Salva modifiche",
    "suppliers.confirm_deactivate": "Disattivare {name}?",
    "Deactivate {name}?": "Disattivare {name}?",
    "suppliers.toast.updated": "Fornitore aggiornato",
    "Supplier updated": "Fornitore aggiornato",
    "suppliers.toast.added": "Fornitore aggiunto",
    "Supplier added": "Fornitore aggiunto",
    "suppliers.toast.deactivated": "Fornitore disattivato",
    "Supplier deactivated": "Fornitore disattivato",
    "suppliers.column.name": "Nome",
    "suppliers.column.code": "Codice",
    "suppliers.column.contact": "Contatto",
    "Contact": "Contatto",
    "suppliers.field.name": "Nome",
    "suppliers.field.code": "Codice",
    "suppliers.field.contact_name": "Nome del referente",
    "Contact name": "Nome del referente",
    "suppliers.field.email": "Email",
    "suppliers.field.phone": "Telefono",
    "suppliers.field.currency": "Valuta",
    "suppliers.field.payment_terms": "Termini di pagamento",
    "Payment terms": "Termini di pagamento",
    "suppliers.field.address": "Indirizzo",
    "suppliers.field.note": "Nota",
    "Note": "Nota",
    "suppliers.placeholder.name": "Nome dell’azienda o del fornitore",
    "Company or supplier name": "Nome dell’azienda o del fornitore",
    "suppliers.placeholder.code": "Codice fornitore",
    "Supplier code": "Codice fornitore",
    "suppliers.placeholder.contact_name": "Nome del referente",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Pagamento alla consegna",
    "Cash on delivery": "Pagamento alla consegna",
    "suppliers.payment_terms.payment_on_receipt": "Pagamento alla ricezione",
    "Payment on receipt": "Pagamento alla ricezione",
    "suppliers.payment_terms.payment_in_advance": "Pagamento anticipato",
    "Payment in advance": "Pagamento anticipato",
    "suppliers.payment_terms.net_7": "Pagamento entro 7 giorni",
    "Net 7 days": "Pagamento entro 7 giorni",
    "suppliers.payment_terms.net_15": "Pagamento entro 15 giorni",
    "Net 15 days": "Pagamento entro 15 giorni",
    "suppliers.payment_terms.net_30": "Pagamento entro 30 giorni",
    "Net 30 days": "Pagamento entro 30 giorni",
    "suppliers.payment_terms.net_45": "Pagamento entro 45 giorni",
    "Net 45 days": "Pagamento entro 45 giorni",
    "suppliers.payment_terms.net_60": "Pagamento entro 60 giorni",
    "Net 60 days": "Pagamento entro 60 giorni",
    "suppliers.detail_title": "Dettagli fornitore",
    "Supplier details": "Dettagli fornitore",
    "suppliers.edit": "Modifica fornitore",
    "suppliers.back": "Torna ai fornitori",
    "Back to suppliers": "Torna ai fornitori",
    "suppliers.loading": "Caricamento fornitore…",
    "Loading supplier…": "Caricamento fornitore…",
    "suppliers.unnamed": "Fornitore senza nome",
    "Unnamed supplier": "Fornitore senza nome",
    "suppliers.profile_description": "Profilo e informazioni di contatto del fornitore",
    "Supplier profile and contact information": "Profilo e informazioni di contatto del fornitore",
    "suppliers.total_spend": "Spesa totale",
    "Total spend": "Spesa totale",
    "suppliers.outstanding": "Da saldare",
    "Outstanding": "Da saldare",
    "suppliers.paid": "Pagato",
    "suppliers.draft": "Bozza",
    "suppliers.purchase_history": "Cronologia acquisti",
    "Purchase history": "Cronologia acquisti",
    "suppliers.bill.reference": "Riferimento",
    "Reference": "Riferimento",
    "suppliers.bill.date": "Data",
    "suppliers.bill.amount": "Importo",
    "suppliers.bill.number": "Fattura n. {id}",
    "Bill #{id}": "Fattura n. {id}",
    "suppliers.bills_empty": "Nessuna fattura trovata per questo fornitore.",
    "No bills found for this supplier.": "Nessuna fattura trovata per questo fornitore.",
    "inventory.locations.title": "Sedi",
    "inventory.locations.add": "Aggiungi sede",
    "Add location": "Aggiungi sede",
    "inventory.locations.description": "Magazzini e negozi che custodiscono le scorte. Gli ordini di acquisto vengono ricevuti in una sede.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Magazzini e negozi che custodiscono le scorte. Gli ordini di acquisto vengono ricevuti in una sede.",
    "inventory.locations.field.name": "Nome",
    "inventory.locations.field.code": "Codice",
    "inventory.locations.field.address": "Indirizzo",
    "inventory.locations.field.linked_store": "Negozio collegato (facoltativo)",
    "Linked store (optional)": "Negozio collegato (facoltativo)",
    "inventory.locations.field.linked_store_short": "Negozio collegato",
    "Linked store": "Negozio collegato",
    "inventory.locations.placeholder.name": "Magazzino principale",
    "Main warehouse": "Magazzino principale",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Cerca un indirizzo o un luogo",
    "Search an address or place": "Cerca un indirizzo o un luogo",
    "inventory.locations.placeholder.linked_store": "Cerca account venditore o negozio",
    "Search seller or store accounts": "Cerca account venditore o negozio",
    "inventory.locations.confirm_deactivate": "Disattivare {name}? Non sarà più disponibile per i nuovi ordini di acquisto.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "Disattivare {name}? Non sarà più disponibile per i nuovi ordini di acquisto.",
    "inventory.locations.toast.deactivated": "Sede disattivata",
    "Location deactivated": "Sede disattivata",
    "inventory.locations.deactivate": "Disattiva",
    "inventory.locations.empty": "Nessuna sede. Aggiungi un magazzino o un negozio per iniziare a ricevere le scorte.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Nessuna sede. Aggiungi un magazzino o un negozio per iniziare a ricevere le scorte.",
    "inventory.locations.edit_title": "Modifica sede",
    "Edit location": "Modifica sede",
    "inventory.locations.add_title": "Aggiungi sede",
    "inventory.locations.form_description": "Collega un account del negozio solo se la sede appartiene a un venditore specifico.",
    "Link a store account only if this location belongs to a specific seller.": "Collega un account del negozio solo se la sede appartiene a un venditore specifico.",
    "inventory.locations.save_changes": "Salva modifiche",
    "inventory.locations.toast.updated": "Sede aggiornata",
    "Location updated": "Sede aggiornata",
    "inventory.locations.toast.added": "Sede aggiunta",
    "Location added": "Sede aggiunta",
    "inventory.operations.title": "Operazioni di magazzino",
    "Inventory operations": "Operazioni di magazzino",
    "inventory.operations.tab.movements": "Cronologia movimenti",
    "Movement history": "Cronologia movimenti",
    "inventory.operations.tab.batches": "Lotti e scadenze",
    "Batches & expiry": "Lotti e scadenze",
    "inventory.operations.tab.transfers": "Ordini di trasferimento",
    "Transfer orders": "Ordini di trasferimento",
    "inventory.operations.tab.requisitions": "Richieste",
    "Requisitions": "Richieste",
    "inventory.operations.tab.receipts": "Ricezioni merci",
    "Goods received": "Ricezioni merci",
    "inventory.operations.description.movements": "Registro immutabile di ogni ricezione, vendita, trasferimento, reso e rettifica.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Registro immutabile di ogni ricezione, vendita, trasferimento, reso e rettifica.",
    "inventory.operations.description.batches": "Monitora lotti, scadenze, condizioni e unità senza modificare qui il registro delle scorte.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Monitora lotti, scadenze, condizioni e unità senza modificare qui il registro delle scorte.",
    "inventory.operations.description.transfers": "Sposta le scorte tra sedi monitorando spedizione, ricezione e discrepanze.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Sposta le scorte tra sedi monitorando spedizione, ricezione e discrepanze.",
    "inventory.operations.description.requisitions": "Esamina le richieste interne di scorte. L’approvazione crea automaticamente un ordine di trasferimento.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Esamina le richieste interne di scorte. L’approvazione crea automaticamente un ordine di trasferimento.",
    "inventory.operations.description.receipts": "Crea ricezioni e monitora le attività aperte, parziali e completate.",
    "Create receipts and track open, partial, and closed receiving work.": "Crea ricezioni e monitora le attività aperte, parziali e completate.",
    "inventory.operations.overview": "Panoramica",
    "inventory.operations.new_transfer": "Nuovo trasferimento",
    "New transfer": "Nuovo trasferimento",
    "inventory.operations.new_requisition": "Nuova richiesta",
    "inventory.operations.new_receipt": "Nuova ricezione",
    "New receipt": "Nuova ricezione",
    "inventory.operations.search": "Cerca",
    "inventory.operations.search_view": "Cerca in questa vista",
    "Search this view": "Cerca in questa vista",
    "inventory.operations.search_products": "Cerca prodotti",
    "Search products": "Cerca prodotti",
    "inventory.operations.search_purchase_order": "Cerca ordini di acquisto (facoltativo)",
    "Search purchase orders (optional)": "Cerca ordini di acquisto (facoltativo)",
    "inventory.operations.listing_number": "Inserzione n. {id}",
    "inventory.operations.location_number": "Sede n. {id}",
    "Location #{id}": "Sede n. {id}",
    "inventory.operations.no_sku": "Nessuno SKU",
    "No SKU": "Nessuno SKU",
    "inventory.operations.order_status": "Stato: {status}",
    "Status: {status}": "Stato: {status}",
    "inventory.operations.field.receiving_location": "Sede di ricezione",
    "Receiving location": "Sede di ricezione",
    "inventory.operations.field.purchase_order": "Ordine di acquisto",
    "Purchase order": "Ordine di acquisto",
    "inventory.operations.field.reference": "Riferimento",
    "inventory.operations.field.note": "Nota",
    "inventory.operations.field.from_location": "Sede di partenza",
    "From location": "Sede di partenza",
    "inventory.operations.field.supplying_location": "Sede fornitrice",
    "Supplying location": "Sede fornitrice",
    "inventory.operations.field.to_location": "Sede di destinazione",
    "To location": "Sede di destinazione",
    "inventory.operations.field.requesting_location": "Sede richiedente",
    "Requesting location": "Sede richiedente",
    "inventory.operations.field.product": "Prodotto",
    "Product": "Prodotto",
    "inventory.operations.field.quantity": "Quantità",
    "Quantity": "Quantità",
    "inventory.operations.field.location": "Sede",
    "inventory.operations.placeholder.delivery_note": "Documento di consegna del fornitore",
    "Supplier delivery note": "Documento di consegna del fornitore",
    "inventory.operations.placeholder.receiving_note": "Nota di ricezione (facoltativa)",
    "Optional receiving note": "Nota di ricezione (facoltativa)",
    "inventory.operations.placeholder.transfer_reference": "Riferimento trasferimento",
    "Transfer reference": "Riferimento trasferimento",
    "inventory.operations.placeholder.request_reference": "Riferimento richiesta",
    "Request reference": "Riferimento richiesta",
    "inventory.operations.placeholder.context": "Contesto facoltativo",
    "Optional context": "Contesto facoltativo",
    "inventory.operations.create.transfer_title": "Nuovo ordine di trasferimento",
    "New transfer order": "Nuovo ordine di trasferimento",
    "inventory.operations.create.requisition_title": "Nuova richiesta scorte",
    "inventory.operations.create.receipt_title": "Nuova ricezione merci",
    "New goods receipt": "Nuova ricezione merci",
    "inventory.operations.create.transfer_description": "Sposta le scorte tra due sedi.",
    "Move stock between two locations.": "Sposta le scorte tra due sedi.",
    "inventory.operations.create.requisition_description": "Richiedi scorte da un’altra sede.",
    "Request stock from another location.": "Richiedi scorte da un’altra sede.",
    "inventory.operations.create.receipt_description": "Crea una ricezione prima di scansionare o aggiungere colli.",
    "Create a receipt before scanning or adding boxes.": "Crea una ricezione prima di scansionare o aggiungere colli.",
    "inventory.operations.toast.transfer_created": "Ordine di trasferimento creato",
    "Transfer order created": "Ordine di trasferimento creato",
    "inventory.operations.toast.requisition_created": "Richiesta creata",
    "Requisition created": "Richiesta creata",
    "inventory.operations.toast.receipt_created": "Ricezione merci creata",
    "Goods receipt created": "Ricezione merci creata",
    "inventory.operations.toast.transfer_dispatched": "Trasferimento spedito",
    "Transfer dispatched": "Trasferimento spedito",
    "inventory.operations.toast.transfer_received": "Trasferimento ricevuto",
    "Transfer received": "Trasferimento ricevuto",
    "inventory.operations.toast.transfer_cancelled": "Trasferimento annullato",
    "Transfer cancelled": "Trasferimento annullato",
    "inventory.operations.toast.requisition_approved": "Richiesta approvata",
    "Requisition approved": "Richiesta approvata",
    "inventory.operations.toast.requisition_rejected": "Richiesta rifiutata",
    "Requisition rejected": "Richiesta rifiutata",
    "inventory.operations.action.dispatch": "Spedisci",
    "Dispatch": "Spedisci",
    "inventory.operations.action.receive": "Ricevi",
    "Receive": "Ricevi",
    "inventory.operations.action.approve": "Approva",
    "Approve": "Approva",
    "inventory.operations.action.reject": "Rifiuta",
    "Reject": "Rifiuta",
    "inventory.operations.column.when": "Quando",
    "When": "Quando",
    "inventory.operations.column.event": "Evento",
    "inventory.operations.column.change": "Variazione",
    "inventory.operations.column.after": "Dopo",
    "After": "Dopo",
    "inventory.operations.column.order": "Ordine",
    "Order": "Ordine",
    "inventory.operations.column.route": "Percorso",
    "Route": "Percorso",
    "inventory.operations.column.lines": "Righe",
    "Lines": "Righe",
    "inventory.operations.column.expected": "Previsto",
    "Expected": "Previsto",
    "inventory.operations.column.request": "Richiesta",
    "Request": "Richiesta",
    "inventory.operations.column.request_supply": "Richiesta / fornitura",
    "Request / supply": "Richiesta / fornitura",
    "inventory.operations.column.created": "Creato",
    "inventory.operations.column.receipt": "Ricezione",
    "Receipt": "Ricezione",
    "inventory.operations.empty.movements": "Nessun movimento di scorte registrato.",
    "No stock movements recorded yet.": "Nessun movimento di scorte registrato.",
    "inventory.operations.empty.batches": "Nessun lotto di magazzino registrato.",
    "No inventory batches have been recorded yet.": "Nessun lotto di magazzino registrato.",
    "inventory.operations.empty.transfers": "Nessun ordine di trasferimento.",
    "No transfer orders yet.": "Nessun ordine di trasferimento.",
    "inventory.operations.empty.requisitions": "Nessuna richiesta di scorte.",
    "No requisitions yet.": "Nessuna richiesta di scorte.",
    "inventory.operations.empty.receipts": "Nessuna ricezione merci.",
    "No goods receipts yet.": "Nessuna ricezione merci.",
    "inventory.operations.batch.edit_title": "Modifica lotto",
    "Edit batch": "Modifica lotto",
    "inventory.operations.batch.edit_description": "La quantità del lotto si modifica tramite una rettifica delle scorte; questo modulo aggiorna solo l’identificativo e i dati di tracciamento.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "La quantità del lotto si modifica tramite una rettifica delle scorte; questo modulo aggiorna solo l’identificativo e i dati di tracciamento.",
    "inventory.operations.batch.save": "Salva lotto",
    "Save batch": "Salva lotto",
    "inventory.operations.batch.lot_number": "Numero lotto",
    "Lot number": "Numero lotto",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Data di scadenza",
    "inventory.operations.batch.condition": "Condizione",
    "Condition": "Condizione",
    "inventory.operations.batch.condition_placeholder": "buono",
    "good": "buono",
    "inventory.operations.batch.unit": "Unità di misura",
    "Unit of measure": "Unità di misura",
    "inventory.operations.batch.unit_placeholder": "scatola, pezzo, kg",
    "box, piece, kg": "scatola, pezzo, kg",
    "inventory.operations.batch.no_expiry": "Senza scadenza",
    "No expiry": "Senza scadenza",
    "inventory.operations.batch.updated": "Lotto aggiornato",
    "Batch updated": "Lotto aggiornato",
    "common.status.in_transit": "In transito",
    "In transit": "In transito",
    "common.status.pending": "In attesa",
    "Pending": "In attesa",
    "common.status.approved": "Approvato",
    "Approved": "Approvato",
    "common.status.rejected": "Rifiutato",
    "Rejected": "Rifiutato",
    "common.status.cancelled": "Annullato",
    "Cancelled": "Annullato",
    "common.status.received": "Ricevuto",
    "Received": "Ricevuto",
    "common.status.sent": "Inviato",
    "Sent": "Inviato",
    "common.note": "Nota",
    "common.optional": "Facoltativo",
    "Optional": "Facoltativo",
    "common.error.generic": "Si è verificato un errore.",
    "Something went wrong.": "Si è verificato un errore.",
    "purchase_orders.title": "Ordini di acquisto",
    "purchase_orders.title_singular": "Ordine di acquisto",
    "purchase_orders.tab.all": "Tutti",
    "purchase_orders.tab.partial": "Ricevuto parzialmente",
    "Partially received": "Ricevuto parzialmente",
    "purchase_orders.create.new": "Nuovo ordine di acquisto",
    "New purchase order": "Nuovo ordine di acquisto",
    "purchase_orders.create.title": "Nuovo ordine di acquisto",
    "purchase_orders.create.subtitle": "Salvato come bozza. Contrassegnalo come inviato quando lo invii al fornitore.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Salvato come bozza. Contrassegnalo come inviato quando lo invii al fornitore.",
    "purchase_orders.create.submit": "Crea bozza",
    "Create draft": "Crea bozza",
    "purchase_orders.field.location": "Sede di ricezione",
    "purchase_orders.field.supplier": "Fornitore",
    "Supplier": "Fornitore",
    "purchase_orders.field.reference": "Riferimento fornitore",
    "Supplier reference": "Riferimento fornitore",
    "purchase_orders.field.expected_delivery": "Consegna prevista",
    "Expected delivery": "Consegna prevista",
    "purchase_orders.field.products": "Prodotti",
    "Products": "Prodotti",
    "purchase_orders.select_location": "Seleziona sede",
    "Select location": "Seleziona sede",
    "purchase_orders.no_locations": "Nessuna sede configurata",
    "No locations set up": "Nessuna sede configurata",
    "purchase_orders.add_location": "Aggiungi prima una sede →",
    "Add a location first →": "Aggiungi prima una sede →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Tutte le sedi",
    "All locations": "Tutte le sedi",
    "purchase_orders.location_number": "Sede n. {id}",
    "purchase_orders.search_products": "Cerca prodotti da aggiungere",
    "Search products to add": "Cerca prodotti da aggiungere",
    "purchase_orders.in_stock": "Disponibili: {count}",
    "In stock: {count}": "Disponibili: {count}",
    "purchase_orders.column.order": "Ordine",
    "purchase_orders.column.product": "Prodotto",
    "purchase_orders.column.quantity": "Quantità",
    "purchase_orders.column.ordered": "Ordinato",
    "Ordered": "Ordinato",
    "purchase_orders.column.received": "Ricevuto",
    "purchase_orders.column.remaining": "Rimanente",
    "purchase_orders.column.unit_cost": "Costo unitario",
    "Unit cost": "Costo unitario",
    "purchase_orders.column.supplier": "Fornitore",
    "purchase_orders.column.location": "Sede",
    "purchase_orders.column.progress": "Ricevuto",
    "purchase_orders.column.value": "Valore",
    "purchase_orders.column.expected": "Previsto",
    "purchase_orders.column.status": "Stato",
    "purchase_orders.action.mark_sent": "Segna come inviato",
    "Mark as sent": "Segna come inviato",
    "purchase_orders.action.receive": "Ricevi",
    "purchase_orders.action.receive_stock": "Ricevi scorte",
    "Receive stock": "Ricevi scorte",
    "purchase_orders.action.cancel_order": "Annulla ordine",
    "Cancel order": "Annulla ordine",
    "purchase_orders.action.close_order": "Chiudi ordine",
    "Close order": "Chiudi ordine",
    "purchase_orders.receive.subtitle": "Inserisci ciò che è arrivato. Le scorte della sede di ricezione si aggiornano alla conferma.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Inserisci ciò che è arrivato. Le scorte della sede di ricezione si aggiornano alla conferma.",
    "purchase_orders.receive.now": "Ricevi ora",
    "Receive now": "Ricevi ora",
    "purchase_orders.receive.confirm": "Conferma ricezione",
    "Confirm receipt": "Conferma ricezione",
    "purchase_orders.confirm.cancel": "Annullare questo ordine di acquisto?",
    "Cancel this purchase order?": "Annullare questo ordine di acquisto?",
    "purchase_orders.empty.all": "Nessun ordine di acquisto. Creane uno per rifornire il magazzino.",
    "No purchase orders yet. Create one to restock inventory.": "Nessun ordine di acquisto. Creane uno per rifornire il magazzino.",
    "purchase_orders.empty.filtered": "Nessun ordine di acquisto con questo stato.",
    "No purchase orders with this status.": "Nessun ordine di acquisto con questo stato.",
    "purchase_orders.error.location_required": "Seleziona una sede di ricezione.",
    "Choose a receiving location.": "Seleziona una sede di ricezione.",
    "purchase_orders.error.product_required": "Aggiungi almeno un prodotto.",
    "Add at least one product.": "Aggiungi almeno un prodotto.",
    "purchase_orders.error.quantity_positive": "Ogni quantità deve essere maggiore di 0.",
    "Every quantity must be greater than 0.": "Ogni quantità deve essere maggiore di 0.",
    "purchase_orders.error.receive_quantity": "Inserisci una quantità per almeno un articolo.",
    "Enter a quantity for at least one item.": "Inserisci una quantità per almeno un articolo.",
    "purchase_orders.toast.created": "Ordine di acquisto creato come bozza",
    "Purchase order created as draft": "Ordine di acquisto creato come bozza",
    "purchase_orders.toast.sent": "Contrassegnato come inviato",
    "Marked as sent": "Contrassegnato come inviato",
    "purchase_orders.toast.received": "Scorte ricevute e magazzino aggiornato",
    "Stock received and inventory updated": "Scorte ricevute e magazzino aggiornato",
    "purchase_orders.toast.cancelled": "Ordine di acquisto annullato",
    "Purchase order cancelled": "Ordine di acquisto annullato",
    "purchase_orders.toast.closed": "Ordine di acquisto chiuso",
    "Purchase order closed": "Ordine di acquisto chiuso",
    "schedule.title": "Agenda",
    "schedule.view.month": "Mese",
    "Month": "Mese",
    "schedule.view.week": "Settimana",
    "Week": "Settimana",
    "schedule.view.day": "Giorno",
    "Day": "Giorno",
    "schedule.today": "Oggi",
    "Today": "Oggi",
    "schedule.order_number": "Ordine n. {number}",
    "Order #{number}": "Ordine n. {number}",
    "schedule.customer": "Cliente",
    "schedule.more_events": "Altri {count}",
    "+{count} more": "Altri {count}",
    "schedule.payment.paid": "Pagato",
    "schedule.payment.pending": "In attesa",
    "schedule.payment.failed": "Non riuscito",
    "schedule.booking_details": "Dettagli prenotazione",
    "Booking details": "Dettagli prenotazione",
    "schedule.order_reference": "Riferimento ordine",
    "schedule.amount": "Importo",
    "schedule.start": "Inizio",
    "schedule.end": "Fine",
    "schedule.item_number": "Articolo {number}",
    "Item {number}": "Articolo {number}",
    "schedule.view_order": "Visualizza ordine completo",
    "View full order": "Visualizza ordine completo",
    "onboarding.greeting.morning": "Buongiorno",
    "Good morning": "Buongiorno",
    "onboarding.greeting.morning_named": "Buongiorno, {name}",
    "Good morning {name}": "Buongiorno, {name}",
    "onboarding.greeting.afternoon": "Buon pomeriggio",
    "Good afternoon": "Buon pomeriggio",
    "onboarding.greeting.afternoon_named": "Buon pomeriggio, {name}",
    "Good afternoon {name}": "Buon pomeriggio, {name}",
    "onboarding.greeting.evening": "Buonasera",
    "Good evening": "Buonasera",
    "onboarding.greeting.evening_named": "Buonasera, {name}",
    "Good evening {name}": "Buonasera, {name}",
    "onboarding.greeting.night": "Salve",
    "Hello": "Salve",
    "onboarding.greeting.night_named": "Salve, {name}",
    "Hello {name}": "Salve, {name}",
    "onboarding.encouragement": "Crea la piattaforma che avresti voluto trovare.",
    "Build the platform you wish existed.": "Crea la piattaforma che avresti voluto trovare.",
    "onboarding.plan.personalized": "Piano di lancio personalizzato",
    "Personalized launch plan": "Piano di lancio personalizzato",
    "onboarding.plan.label": "Piano di lancio",
    "Launch plan": "Piano di lancio",
    "onboarding.plan.refining": "Definizione del tuo percorso…",
    "Refining your path…": "Definizione del tuo percorso…",
    "onboarding.plan.getting_ready": "Il tuo piano personalizzato è in preparazione.",
    "Your personalized plan is getting ready.": "Il tuo piano personalizzato è in preparazione.",
    "onboarding.checklist.preview": "Anteprima della checklist",
    "Checklist preview": "Anteprima della checklist",
    "onboarding.workspace.live": "Workspace attivo",
    "Live workspace": "Workspace attivo",
    "onboarding.workspace.no_tenant": "Nessun tenant attivo collegato",
    "No live tenant connected": "Nessun tenant attivo collegato",
    "onboarding.workspace.domain_pending": "Dominio in attesa",
    "Domain pending": "Dominio in attesa",
    "onboarding.progress.summary": "{completed} di {total} azioni di lancio completate",
    "{completed} of {total} launch actions done": "{completed} di {total} azioni di lancio completate",
    "onboarding.progress.auto_detected": "Rilevati automaticamente: {count}",
    "{count} auto-detected": "Rilevati automaticamente: {count}",
    "onboarding.progress.auto_detected_short": "Rilevato automaticamente",
    "Auto-detected": "Rilevato automaticamente",
    "onboarding.progress.saving": "Salvataggio dei progressi…",
    "Saving progress…": "Salvataggio dei progressi…",
    "onboarding.progress.checking": "Verifica…",
    "Checking…": "Verifica…",
    "onboarding.progress.mark_done": "Segna come completato",
    "Mark done": "Segna come completato",
    "onboarding.progress.unlocked": "Sbloccato: {impact}",
    "Unlocked: {impact}": "Sbloccato: {impact}",
    "onboarding.next_task": "Prossima attività consigliata",
    "Next best task": "Prossima attività consigliata",
    "onboarding.upcoming.title": "Attività in programma",
    "Upcoming tasks": "Attività in programma",
    "onboarding.upcoming.summary_one": "Dopo l’attività corrente è in coda {count} attività.",
    "{count} task queued after the current action.": "Dopo l’attività corrente è in coda {count} attività.",
    "onboarding.upcoming.summary_other": "Dopo l’attività corrente sono in coda {count} attività.",
    "{count} tasks queued after the current action.": "Dopo l’attività corrente sono in coda {count} attività.",
    "onboarding.upcoming.hide": "Nascondi attività",
    "Hide tasks": "Nascondi attività",
    "onboarding.upcoming.view_all": "Visualizza tutte le attività",
    "View all tasks": "Visualizza tutte le attività",
    "onboarding.complete.title": "Ottimo inizio. Le basi della piattaforma sono pronte.",
    "Great start. Your foundation is live.": "Ottimo inizio. Le basi della piattaforma sono pronte.",
    "onboarding.complete.description": "Continua per sbloccare strumenti di crescita come promozioni e comunicazioni.",
    "Keep going to unlock growth essentials like promotions and communications.": "Continua per sbloccare strumenti di crescita come promozioni e comunicazioni.",
    "onboarding.full_checklist.title": "Checklist completa",
    "Full checklist": "Checklist completa",
    "onboarding.full_checklist.description": "Continua la configurazione nella stessa esperienza.",
    "Continue setup in the same experience.": "Continua la configurazione nella stessa esperienza.",
    "onboarding.full_checklist.back": "Torna al percorso di lancio",
    "Back to launch path": "Torna al percorso di lancio",
    "onboarding.completed.title": "Completato",
    "onboarding.completed.summary_one": "{count} attività completata",
    "{count} task completed": "{count} attività completata",
    "onboarding.completed.summary_other": "{count} attività completate",
    "{count} tasks completed": "{count} attività completate",
    "onboarding.completed.open_again": "Apri di nuovo",
    "Open again": "Apri di nuovo",
    "onboarding.plan.marketplace.eyebrow": "Percorso di lancio marketplace",
    "Marketplace launch path": "Percorso di lancio marketplace",
    "onboarding.plan.marketplace.title": "Lancia il tuo marketplace",
    "Launch your marketplace": "Lancia il tuo marketplace",
    "onboarding.plan.marketplace.title_named": "Trasforma {project} in un marketplace operativo",
    "Turn {project} into a working marketplace": "Trasforma {project} in un marketplace operativo",
    "onboarding.plan.marketplace.subtitle": "Apri il sito attivo, crea la prima inserzione e prova il percorso dell’acquirente.",
    "Open the live site create the first listing and test the buyer journey.": "Apri il sito attivo, crea la prima inserzione e prova il percorso dell’acquirente.",
    "onboarding.plan.marketplace.value_moment": "Primo risultato: un venditore può pubblicare e un acquirente può agire.",
    "First value moment: a seller can publish and a buyer can act.": "Primo risultato: un venditore può pubblicare e un acquirente può agire.",
    "onboarding.plan.marketplace.why_title": "Perché i team completano questo passaggio",
    "Why teams finish this": "Perché i team completano questo passaggio",
    "onboarding.plan.marketplace.why_body": "Risultati reali per acquirenti e venditori rendono utile ogni passaggio e mantengono lo slancio.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Risultati reali per acquirenti e venditori rendono utile ogni passaggio e mantengono lo slancio.",
    "onboarding.plan.store.eyebrow": "Percorso di lancio del negozio",
    "Store launch path": "Percorso di lancio del negozio",
    "onboarding.plan.store.title": "Prepara il negozio per il primo ordine",
    "Get your store ready for the first order": "Prepara il negozio per il primo ordine",
    "onboarding.plan.store.title_named": "Prepara {project} per il primo ordine",
    "Make {project} ready for the first order": "Prepara {project} per il primo ordine",
    "onboarding.plan.store.subtitle": "Aggiungi un prodotto, controlla la vetrina e completa il checkout.",
    "Add a product check the storefront and complete checkout essentials.": "Aggiungi un prodotto, controlla la vetrina e completa il checkout.",
    "onboarding.plan.store.value_moment": "Primo risultato: il prodotto è visibile e puoi provare il checkout.",
    "First value moment: a product is visible and checkout can be tested.": "Primo risultato: il prodotto è visibile e puoi provare il checkout.",
    "onboarding.plan.store.why_title": "Perché i team completano questo passaggio",
    "onboarding.plan.store.why_body": "Passare rapidamente dal prodotto al checkout rende concreto il negozio e mantiene alta la motivazione.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Passare rapidamente dal prodotto al checkout rende concreto il negozio e mantiene alta la motivazione.",
    "onboarding.plan.booking.eyebrow": "Percorso di lancio delle prenotazioni",
    "Booking launch path": "Percorso di lancio delle prenotazioni",
    "onboarding.plan.booking.title": "Rendi prenotabile la tua piattaforma",
    "Make your platform bookable": "Rendi prenotabile la tua piattaforma",
    "onboarding.plan.booking.title_named": "Rendi prenotabile {project}",
    "Make {project} bookable": "Rendi prenotabile {project}",
    "onboarding.plan.booking.subtitle": "Crea il primo servizio, apri l’esperienza cliente e prova una prenotazione.",
    "Create the first service open the customer experience and test a reservation.": "Crea il primo servizio, apri l’esperienza cliente e prova una prenotazione.",
    "onboarding.plan.booking.value_moment": "Primo risultato: un cliente può richiedere un orario o uno slot.",
    "First value moment: a customer can request a time or slot.": "Primo risultato: un cliente può richiedere un orario o uno slot.",
    "onboarding.plan.booking.why_title": "Perché i team completano questo passaggio",
    "onboarding.plan.booking.why_body": "Convalida subito l’intero percorso di prenotazione per acquisire fiducia prima di espanderti.",
    "Validate the full booking journey early to build confidence before expanding.": "Convalida subito l’intero percorso di prenotazione per acquisire fiducia prima di espanderti.",
    "onboarding.plan.digital.eyebrow": "Percorso di lancio digitale",
    "Digital launch path": "Percorso di lancio digitale",
    "onboarding.plan.digital.title": "Inizia a vendere prodotti digitali",
    "Start selling your digital products": "Inizia a vendere prodotti digitali",
    "onboarding.plan.digital.title_named": "Prepara {project} alla vendita di prodotti digitali",
    "Make {project} ready to sell digital products": "Prepara {project} alla vendita di prodotti digitali",
    "onboarding.plan.digital.subtitle": "Carica un prodotto digitale, prova il flusso cliente e verifica che i pagamenti siano pronti.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Carica un prodotto digitale, prova il flusso cliente e verifica che i pagamenti siano pronti.",
    "onboarding.plan.digital.value_moment": "Primo risultato: un acquirente può trovare e acquistare un file.",
    "First value moment: a buyer can discover and purchase a file.": "Primo risultato: un acquirente può trovare e acquistare un file.",
    "onboarding.plan.digital.why_title": "Perché i team completano questo passaggio",
    "onboarding.plan.digital.why_body": "Verifica rapidamente scoperta e acquisto, così ampliare il catalogo diventa un segno di crescita.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Verifica rapidamente scoperta e acquisto, così ampliare il catalogo diventa un segno di crescita.",
    "onboarding.plan.campaign.eyebrow": "Percorso di lancio della campagna",
    "Campaign launch path": "Percorso di lancio della campagna",
    "onboarding.plan.campaign.title": "Lancia la piattaforma per le campagne",
    "Launch your campaign platform": "Lancia la piattaforma per le campagne",
    "onboarding.plan.campaign.title_named": "Prepara {project} per i sostenitori",
    "Make {project} ready for supporters": "Prepara {project} per i sostenitori",
    "onboarding.plan.campaign.subtitle": "Crea una campagna, visualizza l’anteprima della pagina pubblica e prova il percorso di contribuzione.",
    "Create a campaign preview the public page and test the contribution journey.": "Crea una campagna, visualizza l’anteprima della pagina pubblica e prova il percorso di contribuzione.",
    "onboarding.plan.campaign.value_moment": "Primo risultato: un sostenitore comprende la campagna e può contribuire.",
    "First value moment: a supporter can understand and contribute.": "Primo risultato: un sostenitore comprende la campagna e può contribuire.",
    "onboarding.plan.campaign.why_title": "Perché i team completano questo passaggio",
    "onboarding.plan.campaign.why_body": "Chiarisci subito la storia e il processo di contribuzione, così i sostenitori possono fidarsi e agire.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Chiarisci subito la storia e il processo di contribuzione, così i sostenitori possono fidarsi e agire.",
    "onboarding.plan.creator.eyebrow": "Percorso di lancio creator",
    "Creator launch path": "Percorso di lancio creator",
    "onboarding.plan.creator.title": "Preparati a raggiungere il primo pubblico",
    "Get ready for your first audience": "Preparati a raggiungere il primo pubblico",
    "onboarding.plan.creator.title_named": "Prepara {project} per il suo primo pubblico",
    "Make {project} ready for its first audience": "Prepara {project} per il suo primo pubblico",
    "onboarding.plan.creator.subtitle": "Pubblica un’offerta chiara, definisci l’esperienza e facilita la scoperta e il supporto del tuo lavoro.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Pubblica un’offerta chiara, definisci l’esperienza e facilita la scoperta e il supporto del tuo lavoro.",
    "onboarding.plan.creator.value_moment": "Primo risultato: il tuo lavoro è visibile e pronto per essere condiviso.",
    "First value moment: your work is visible and ready to share.": "Primo risultato: il tuo lavoro è visibile e pronto per essere condiviso.",
    "onboarding.plan.creator.why_title": "Perché funziona",
    "Why this works": "Perché funziona",
    "onboarding.plan.creator.why_body": "Concentrati sulla pubblicazione di qualcosa di concreto prima di aggiungere strumenti o complessità.",
    "Focus on publishing something real before adding more tools or complexity.": "Concentrati sulla pubblicazione di qualcosa di concreto prima di aggiungere strumenti o complessità.",
    "onboarding.step.open_live_site.title": "Apri il sito attivo",
    "Open the live experience": "Apri il sito attivo",
    "onboarding.step.open_live_site.description": "Inizia da ciò che vedono i clienti. Così il prodotto diventa concreto prima che la configurazione sembri astratta.",
    "onboarding.step.open_live_site.description_domain": "{domain} adresini açıp müşterilerinizin gördüklerini inceleyin. Bu, sonraki adımdan önce çalışmayı somutlaştırır.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "{domain} adresini açıp müşterilerinizin gördüklerini inceleyin. Bu, sonraki adımdan önce çalışmayı somutlaştırır.",
    "onboarding.step.open_live_site.cta": "Apri il sito",
    "Open site": "Apri il sito",
    "onboarding.step.open_live_site.cta_domain": "Apri {domain}",
    "Open {domain}": "Apri {domain}",
    "onboarding.step.open_live_site.impact": "Conferma che il progetto è già attivo.",
    "onboarding.step.create_supply_shape.title": "Crea la prima categoria",
    "Create the first category": "Crea la prima categoria",
    "onboarding.step.create_supply_shape.description": "Offri a venditori e acquirenti un punto di partenza chiaro. Le categorie organizzano la ricerca.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Offri a venditori e acquirenti un punto di partenza chiaro. Le categorie organizzano la ricerca.",
    "onboarding.step.create_supply_shape.cta": "Aggiungi categoria",
    "Add category": "Aggiungi categoria",
    "onboarding.step.create_supply_shape.impact": "Trasforma un marketplace vuoto in uno consultabile.",
    "Turns a blank marketplace into a browsable one.": "Trasforma un marketplace vuoto in uno consultabile.",
    "onboarding.step.post_first_listing.title": "Pubblica un’inserzione di prova",
    "Post one test listing": "Pubblica un’inserzione di prova",
    "onboarding.step.post_first_listing.description": "Prova il percorso del venditore e pubblica il primo articolo che gli acquirenti potranno consultare.",
    "Experience the seller path and publish the first item buyers can inspect.": "Prova il percorso del venditore e pubblica il primo articolo che gli acquirenti potranno consultare.",
    "onboarding.step.post_first_listing.cta": "Pubblica inserzione",
    "Post listing": "Pubblica inserzione",
    "onboarding.step.post_first_listing.impact": "Crea l’offerta, elemento centrale per avviare il marketplace.",
    "Creates supply the core marketplace activation event.": "Crea l’offerta, elemento centrale per avviare il marketplace.",
    "onboarding.step.test_buyer_action.title": "Prova il percorso dell’acquirente",
    "Act like a buyer": "Prova il percorso dell’acquirente",
    "onboarding.step.test_buyer_action.description": "Esplora, mostra interesse e prova il flusso dell’ordine come farebbe un cliente.",
    "Browse add interest and test the order path to experience what customers will see.": "Esplora, mostra interesse e prova il flusso dell’ordine come farebbe un cliente.",
    "onboarding.step.test_buyer_action.cta": "Prova il flusso acquirente",
    "Test buyer flow": "Prova il flusso acquirente",
    "onboarding.step.test_buyer_action.impact": "Convalida l’intero percorso dell’acquirente.",
    "Validates the buyer journey end to end.": "Convalida l’intero percorso dell’acquirente.",
    "onboarding.step.add_first_product.title": "Aggiungi un prodotto reale",
    "Add one real product": "Aggiungi un prodotto reale",
    "onboarding.step.add_first_product.description": "Un prodotto completo aiuta il sistema a capire il catalogo meglio di una lunga guida alle impostazioni.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Un prodotto completo aiuta il sistema a capire il catalogo meglio di una lunga guida alle impostazioni.",
    "onboarding.step.add_first_product.cta": "Aggiungi prodotto",
    "Add product": "Aggiungi prodotto",
    "onboarding.step.add_first_product.impact": "Crea il primo articolo vendibile.",
    "Creates the first sellable item.": "Crea il primo articolo vendibile.",
    "onboarding.step.setup_payments.title": "Collega i pagamenti",
    "Connect payments": "Collega i pagamenti",
    "onboarding.step.setup_payments.description": "Abilita le transazioni reali per consentire agli utenti di completare gli acquisti facilmente.",
    "Enable real transactions so users can complete purchases without friction.": "Abilita le transazioni reali per consentire agli utenti di completare gli acquisti facilmente.",
    "onboarding.step.setup_payments.cta": "Configura i pagamenti",
    "Set up payments": "Configura i pagamenti",
    "onboarding.step.setup_payments.impact": "Apre la strada ai ricavi.",
    "onboarding.step.setup_delivery.title": "Imposta la spedizione o il metodo di erogazione",
    "Set shipping or service method": "Imposta la spedizione o il metodo di erogazione",
    "onboarding.step.setup_delivery.description": "Definisci come viene evaso l’ordine, così il checkout sarà chiaro agli utenti.",
    "onboarding.step.setup_delivery.cta": "Configura la consegna",
    "Configure delivery": "Configura la consegna",
    "onboarding.step.setup_delivery.impact": "Chiarisce l’evasione dell’ordine durante il checkout.",
    "Makes fulfillment clear at checkout.": "Chiarisce l’evasione dell’ordine durante il checkout.",
    "onboarding.step.create_bookable_listing.title": "Crea un’offerta prenotabile",
    "Create one bookable offer": "Crea un’offerta prenotabile",
    "onboarding.step.create_bookable_listing.description": "Aggiungi il servizio, l’evento, il noleggio o l’appuntamento che i clienti dovrebbero prenotare per primo.",
    "Add the service event rental or appointment customers should book first.": "Aggiungi il servizio, l’evento, il noleggio o l’appuntamento che i clienti dovrebbero prenotare per primo.",
    "onboarding.step.create_bookable_listing.cta": "Crea offerta",
    "Create offer": "Crea offerta",
    "onboarding.step.create_bookable_listing.impact": "Crea la prima unità prenotabile.",
    "Creates the first bookable unit.": "Crea la prima unità prenotabile.",
    "onboarding.step.shape_details.title": "Aggiungi i dettagli della prenotazione",
    "Add booking details": "Aggiungi i dettagli della prenotazione",
    "onboarding.step.shape_details.description": "Usa categorie e campi per raccogliere le informazioni necessarie prima della conferma.",
    "Use categories and fields to capture what customers need before they commit.": "Usa categorie e campi per raccogliere le informazioni necessarie prima della conferma.",
    "onboarding.step.shape_details.cta": "Configura i campi",
    "Set up fields": "Configura i campi",
    "onboarding.step.shape_details.impact": "Rende l’offerta più facile da confrontare e affidabile.",
    "Makes the offer easier to compare and trust.": "Rende l’offerta più facile da confrontare e affidabile.",
    "onboarding.step.test_booking.title": "Prova il percorso cliente",
    "Test the customer path": "Prova il percorso cliente",
    "onboarding.step.test_booking.description": "Apri il flusso pubblico e verifica che i clienti possano passare dall’interesse all’azione.",
    "Open the public flow and verify customers can move from interest to action.": "Apri il flusso pubblico e verifica che i clienti possano passare dall’interesse all’azione.",
    "onboarding.step.test_booking.cta": "Prova la prenotazione",
    "Test booking": "Prova la prenotazione",
    "onboarding.step.test_booking.impact": "Convalida il percorso di prenotazione.",
    "Validates the booking journey.": "Convalida il percorso di prenotazione.",
    "onboarding.step.upload_digital_product.title": "Carica un prodotto digitale",
    "Upload one digital product": "Carica un prodotto digitale",
    "onboarding.step.upload_digital_product.description": "Completa il primo articolo scaricabile in modo che sia pronto per l’anteprima e la vendita.",
    "Make the first downloadable item complete enough to preview and sell.": "Completa il primo articolo scaricabile in modo che sia pronto per l’anteprima e la vendita.",
    "onboarding.step.upload_digital_product.cta": "Aggiungi prodotto digitale",
    "Add digital product": "Aggiungi prodotto digitale",
    "onboarding.step.upload_digital_product.impact": "Crea il primo contenuto digitale vendibile.",
    "Creates your first sellable digital asset.": "Crea il primo contenuto digitale vendibile.",
    "onboarding.step.test_purchase.title": "Prova il flusso di acquisto",
    "Test purchase flow": "Prova il flusso di acquisto",
    "onboarding.step.test_purchase.description": "Visualizza il percorso dell’acquirente, dalla scoperta al checkout.",
    "Preview what buyers see from discovery through checkout.": "Visualizza il percorso dell’acquirente, dalla scoperta al checkout.",
    "onboarding.step.test_purchase.cta": "Prova il checkout",
    "Test checkout": "Prova il checkout",
    "onboarding.step.test_purchase.impact": "Conferma il funzionamento del percorso di acquisto.",
    "Confirms the buyer journey.": "Conferma il funzionamento del percorso di acquisto.",
    "onboarding.step.create_campaign.title": "Crea la prima campagna",
    "Create the first campaign": "Crea la prima campagna",
    "onboarding.step.create_campaign.description": "Aggiungi la pagina della campagna o della causa che i sostenitori dovrebbero conoscere per prima.",
    "Add the campaign or cause page supporters should understand first.": "Aggiungi la pagina della campagna o della causa che i sostenitori dovrebbero conoscere per prima.",
    "onboarding.step.create_campaign.cta": "Crea campagna",
    "Create campaign": "Crea campagna",
    "onboarding.step.create_campaign.impact": "Crea il primo motivo pubblico per partecipare.",
    "Creates the first public reason to act.": "Crea il primo motivo pubblico per partecipare.",
    "onboarding.step.setup_payments_campaign.title": "Collega i pagamenti delle donazioni",
    "Connect contribution payments": "Collega i pagamenti delle donazioni",
    "onboarding.step.setup_payments_campaign.description": "La motivazione dei sostenitori conta quando possono completare una donazione.",
    "Supporter intent matters when they can complete a contribution.": "La motivazione dei sostenitori conta quando possono completare una donazione.",
    "onboarding.step.setup_payments_campaign.cta": "Configura i pagamenti",
    "onboarding.step.setup_payments_campaign.impact": "Consente di ricevere contributi reali.",
    "Enables real contributions.": "Consente di ricevere contributi reali.",
    "onboarding.step.test_supporter_flow.title": "Prova il percorso del sostenitore",
    "Test supporter flow": "Prova il percorso del sostenitore",
    "onboarding.step.test_supporter_flow.description": "Apri il percorso pubblico e assicurati che la storia e l’azione siano chiare.",
    "Open the public journey and make sure the story and action are clear.": "Apri il percorso pubblico e assicurati che la storia e l’azione siano chiare.",
    "onboarding.step.test_supporter_flow.cta": "Prova il percorso",
    "Test flow": "Prova il percorso",
    "onboarding.step.test_supporter_flow.impact": "Convalida il percorso pubblico.",
    "Validates the public path.": "Convalida il percorso pubblico.",
    "onboarding.step.set_account_categories.title": "Definisci le categorie degli account fornitori",
    "Define supplier account categories": "Definisci le categorie degli account fornitori",
    "onboarding.step.set_account_categories.description": "Separa i profili dei fornitori per tipologia per migliorare la fiducia e la navigazione degli acquirenti.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Separa i profili dei fornitori per tipologia per migliorare la fiducia e la navigazione degli acquirenti.",
    "onboarding.step.set_account_categories.cta": "Categorie account",
    "Account categories": "Categorie account",
    "onboarding.step.set_account_categories.impact": "Struttura dei fornitori definita.",
    "Supplier structure established.": "Struttura dei fornitori definita.",
    "onboarding.step.set_account_attributes.title": "Aggiungi attributi al profilo fornitore",
    "Add supplier profile attributes": "Aggiungi attributi al profilo fornitore",
    "onboarding.step.set_account_attributes.description": "Raccogli i dettagli necessari agli acquirenti prima di contattare o ordinare dai fornitori.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Raccogli i dettagli necessari agli acquirenti prima di contattare o ordinare dai fornitori.",
    "onboarding.step.set_account_attributes.cta": "Attributi fornitore",
    "Supplier attributes": "Attributi fornitore",
    "onboarding.step.set_account_attributes.impact": "Aumenta la fiducia degli acquirenti.",
    "Higher buyer confidence.": "Aumenta la fiducia degli acquirenti.",
    "onboarding.step.add_promotion.title": "Aggiungi una promozione di lancio",
    "Add a launch promotion": "Aggiungi una promozione di lancio",
    "onboarding.step.add_promotion.description": "Crea la prima promozione per incoraggiare l’azione alla prima visita.",
    "Create your first promotion to encourage action during the first visit.": "Crea la prima promozione per incoraggiare l’azione alla prima visita.",
    "onboarding.step.add_promotion.cta": "Aggiungi promozione",
    "Add promotion": "Aggiungi promozione",
    "onboarding.step.add_promotion.impact": "Migliora la conversione al lancio.",
    "Strengthens launch conversion.": "Migliora la conversione al lancio.",
    "onboarding.step.create_coupon.title": "Crea il primo coupon",
    "Create your first coupon": "Crea il primo coupon",
    "onboarding.step.create_coupon.description": "Prova gli sconti per i nuovi acquirenti o membri.",
    "Test discounts for first-time buyers or members.": "Prova gli sconti per i nuovi acquirenti o membri.",
    "onboarding.step.create_coupon.cta": "Crea coupon",
    "Create coupon": "Crea coupon",
    "onboarding.step.create_coupon.impact": "Attiva il primo ciclo di offerte.",
    "Unlocks your first offer loop.": "Attiva il primo ciclo di offerte.",
    "onboarding.step.collections_setup.title": "Crea una raccolta",
    "Create a collection": "Crea una raccolta",
    "onboarding.step.collections_setup.description": "Organizza le inserzioni importanti per migliorare la scoperta e la navigazione.",
    "Organize important listings to improve discovery and browsing.": "Organizza le inserzioni importanti per migliorare la scoperta e la navigazione.",
    "onboarding.step.collections_setup.cta": "Crea raccolta",
    "Create collection": "Crea raccolta",
    "onboarding.step.collections_setup.impact": "Migliora la navigazione e la scoperta.",
    "Improves navigation and discovery.": "Migliora la navigazione e la scoperta.",
    "onboarding.step.configure_comms.title": "Rivedi i modelli di comunicazione",
    "Review communication templates": "Rivedi i modelli di comunicazione",
    "onboarding.step.configure_comms.description": "Prepara le notifiche di registrazione e ordine prima della crescita.",
    "Prepare signup and order notifications before growth.": "Prepara le notifiche di registrazione e ordine prima della crescita.",
    "onboarding.step.configure_comms.cta": "Apri comunicazioni",
    "Open communications": "Apri comunicazioni",
    "onboarding.step.configure_comms.impact": "Prepara le comunicazioni con i clienti.",
    "Prepares customer communications.": "Prepara le comunicazioni con i clienti.",
    "onboarding.step.customize_attributes.title": "Aggiungi attributi alle inserzioni",
    "Add listing attributes": "Aggiungi attributi alle inserzioni",
    "onboarding.step.customize_attributes.description": "Aggiungi campi strutturati per consentire agli utenti di filtrare e confrontare gli aspetti importanti.",
    "onboarding.step.customize_attributes.cta": "Aggiungi attributi",
    "Add attributes": "Aggiungi attributi",
    "onboarding.step.customize_attributes.impact": "Semplifica il confronto tra inserzioni.",
    "Makes listings easier to compare.": "Semplifica il confronto tra inserzioni.",
    "onboarding.step.add_digital_asset.title": "Aggiungi un altro prodotto digitale",
    "Add another digital item": "Aggiungi un altro prodotto digitale",
    "onboarding.step.add_digital_asset.description": "Amplia il catalogo affinché gli utenti possano valutare qualità e assortimento.",
    "Expand the catalog so users can evaluate quality and assortment.": "Amplia il catalogo affinché gli utenti possano valutare qualità e assortimento.",
    "onboarding.step.add_digital_asset.cta": "Aggiungi inserzione digitale",
    "Add digital listing": "Aggiungi inserzione digitale",
    "onboarding.step.add_digital_asset.impact": "Aumenta la credibilità del catalogo digitale.",
    "Improves digital catalog credibility.": "Aumenta la credibilità del catalogo digitale.",
    "personal_assistant.title": "Assistente personale",
    "Personal assistant": "Assistente personale",
    "personal_assistant.heading": "Fai crescere la piattaforma un passo alla volta",
    "Grow your platform one step at a time": "Fai crescere la piattaforma un passo alla volta",
    "personal_assistant.subtitle": "Pensato per {launchType}. Diamo priorità alle azioni in base all’impatto e alla preparazione.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "Pensato per {launchType}. Diamo priorità alle azioni in base all’impatto e alla preparazione.",
    "personal_assistant.launch.store": "un negozio",
    "a store": "un negozio",
    "personal_assistant.launch.marketplace": "un marketplace",
    "a marketplace": "un marketplace",
    "personal_assistant.launch.booking": "una piattaforma di prenotazione",
    "a booking platform": "una piattaforma di prenotazione",
    "personal_assistant.launch.digital": "un’attività digitale",
    "a digital business": "un’attività digitale",
    "personal_assistant.launch.campaign": "una piattaforma per campagne",
    "a campaign platform": "una piattaforma per campagne",
    "personal_assistant.metric.tasks_completed": "Attività completate",
    "Tasks completed": "Attività completate",
    "personal_assistant.metric.recommendation_clicks": "Clic sui suggerimenti",
    "Recommendation clicks": "Clic sui suggerimenti",
    "personal_assistant.metric.completed_by_recommendation": "Completate tramite suggerimenti",
    "Completed via recommendations": "Completate tramite suggerimenti",
    "personal_assistant.metric.assist_rate": "Tasso di assistenza",
    "Assist rate": "Tasso di assistenza",
    "personal_assistant.personalizing": "Personalizzazione dei suggerimenti…",
    "Personalizing your recommendations…": "Personalizzazione dei suggerimenti…",
    "personal_assistant.do_this_now": "Fallo ora",
    "Do this now": "Fallo ora",
    "personal_assistant.estimated_time": "Tempo stimato: {minutes} min",
    "Estimated time: {minutes} min": "Tempo stimato: {minutes} min",
    "personal_assistant.minutes_short": "{minutes} min",
    "{minutes} min": "{minutes} min",
    "personal_assistant.open": "Apri",
    "personal_assistant.mark_done": "Segna come completato",
    "personal_assistant.up_next": "A seguire",
    "Up next": "A seguire",
    "personal_assistant.coming_after": "Dopo questa attività",
    "Coming after this": "Dopo questa attività",
    "personal_assistant.completed_count": "Completate ({count})",
    "Completed ({count})": "Completate ({count})",
    "personal_assistant.hide": "Nascondi",
    "Hide": "Nascondi",
    "personal_assistant.show": "Mostra",
    "Show": "Mostra",
    "personal_assistant.feature.open_live_site.name": "Apri il sito attivo",
    "personal_assistant.feature.open_live_site.outcome": "Verifichi che i clienti possano raggiungere la piattaforma attiva.",
    "You confirm customers can reach the live platform.": "Verifichi che i clienti possano raggiungere la piattaforma attiva.",
    "personal_assistant.feature.create_supply_shape.name": "Crea la prima categoria",
    "personal_assistant.feature.create_supply_shape.outcome": "I clienti possono navigare con una struttura chiara.",
    "Customers can browse with a clear structure.": "I clienti possono navigare con una struttura chiara.",
    "personal_assistant.feature.post_first_listing.name": "Pubblica un’inserzione di prova",
    "personal_assistant.feature.post_first_listing.outcome": "La piattaforma ora offre il primo articolo da valutare.",
    "The platform now has first supply to evaluate.": "La piattaforma ora offre il primo articolo da valutare.",
    "personal_assistant.feature.test_buyer_action.name": "Prova il percorso dell’acquirente",
    "personal_assistant.feature.test_buyer_action.outcome": "Convalidi l’esperienza dell’acquirente dall’inizio alla fine.",
    "You validate buyer-side experience end to end.": "Convalidi l’esperienza dell’acquirente dall’inizio alla fine.",
    "personal_assistant.feature.setup_payments.name": "Collega i pagamenti",
    "personal_assistant.feature.setup_payments.outcome": "I clienti possono completare transazioni reali.",
    "Customers can complete real transactions.": "I clienti possono completare transazioni reali.",
    "personal_assistant.feature.setup_delivery.name": "Imposta la spedizione o il metodo di erogazione",
    "personal_assistant.feature.setup_delivery.outcome": "I clienti possono capire chiaramente come verrà evaso l’ordine.",
    "Customers can understand fulfillment clearly.": "I clienti possono capire chiaramente come verrà evaso l’ordine.",
    "personal_assistant.feature.add_promotion.name": "Aggiungi una promozione di lancio",
    "personal_assistant.feature.add_promotion.outcome": "Crei un incentivo per le prime conversioni.",
    "You create an early conversion incentive.": "Crei un incentivo per le prime conversioni.",
    "personal_assistant.feature.configure_comms.name": "Rivedi i modelli di comunicazione",
    "personal_assistant.feature.configure_comms.outcome": "Gli utenti ricevono comunicazioni chiare durante tutto il ciclo.",
    "Users receive clear lifecycle communication.": "Gli utenti ricevono comunicazioni chiare durante tutto il ciclo.",
    "personal_assistant.feature.view_orders.name": "Apri gli ordini",
    "Open orders": "Apri gli ordini",
    "personal_assistant.feature.view_orders.outcome": "Puoi monitorare ed elaborare la domanda in arrivo.",
    "You can monitor and process incoming demand.": "Puoi monitorare ed elaborare la domanda in arrivo.",
    "personal_assistant.feature.view_accounts.name": "Apri gli account",
    "Open accounts": "Apri gli account",
    "personal_assistant.feature.view_accounts.outcome": "Puoi esaminare fornitori o membri in modo efficiente.",
    "You can review suppliers or members efficiently.": "Puoi esaminare fornitori o membri in modo efficiente.",
    "personal_assistant.feature.configure_account_categories.name": "Configura le categorie account",
    "Configure account categories": "Configura le categorie account",
    "personal_assistant.feature.configure_account_categories.outcome": "La struttura di fornitori e membri è più chiara per l’onboarding e la fiducia.",
    "Supplier and member structure is clearer for onboarding and trust.": "La struttura di fornitori e membri è più chiara per l’onboarding e la fiducia.",
    "personal_assistant.feature.configure_account_attributes.name": "Configura gli attributi account",
    "Configure account attributes": "Configura gli attributi account",
    "personal_assistant.feature.configure_account_attributes.outcome": "I profili raccolgono le informazioni decisive per gli acquirenti.",
    "Profiles capture decision-critical info for buyers.": "I profili raccolgono le informazioni decisive per gli acquirenti.",
    "personal_assistant.feature.review_account_config.name": "Rivedi la configurazione account",
    "Review account configuration": "Rivedi la configurazione account",
    "personal_assistant.feature.review_account_config.outcome": "Il comportamento degli account rispetta le regole del marketplace.",
    "Account behavior matches your marketplace policy.": "Il comportamento degli account rispetta le regole del marketplace.",
    "personal_assistant.feature.view_listings.name": "Apri le inserzioni",
    "Open listings": "Apri le inserzioni",
    "personal_assistant.feature.view_listings.outcome": "Puoi monitorare qualità e preparazione del catalogo.",
    "You can monitor catalog quality and readiness.": "Puoi monitorare qualità e preparazione del catalogo.",
    "personal_assistant.feature.configure_listing_categories.name": "Configura le categorie delle inserzioni",
    "Configure listing categories": "Configura le categorie delle inserzioni",
    "personal_assistant.feature.configure_listing_categories.outcome": "Il catalogo diventa più facile da navigare e consultare.",
    "The catalog becomes easier to navigate and discover.": "Il catalogo diventa più facile da navigare e consultare.",
    "personal_assistant.feature.configure_listing_attributes.name": "Configura gli attributi delle inserzioni",
    "Configure listing attributes": "Configura gli attributi delle inserzioni",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Gli utenti possono confrontare le inserzioni con dettagli strutturati.",
    "Users can compare listings with structured details.": "Gli utenti possono confrontare le inserzioni con dettagli strutturati.",
    "personal_assistant.feature.configure_variant_types.name": "Configura i tipi di variante",
    "Configure variant types": "Configura i tipi di variante",
    "personal_assistant.feature.configure_variant_types.outcome": "Il catalogo supporta chiaramente le varianti di prodotti e servizi.",
    "The catalog supports product and service variations clearly.": "Il catalogo supporta chiaramente le varianti di prodotti e servizi.",
    "personal_assistant.feature.review_listing_configs.name": "Rivedi le funzionalità aggiuntive delle inserzioni",
    "Review listing additional features": "Rivedi le funzionalità aggiuntive delle inserzioni",
    "personal_assistant.feature.review_listing_configs.outcome": "Il comportamento delle inserzioni rispecchia il tuo modello operativo.",
    "Listing behavior matches your operating model.": "Il comportamento delle inserzioni rispecchia il tuo modello operativo.",
    "personal_assistant.feature.manage_collections.name": "Gestisci le raccolte",
    "Manage collections": "Gestisci le raccolte",
    "personal_assistant.feature.manage_collections.outcome": "Le raccolte più rilevanti sono più facili da trovare.",
    "High-intent browsing paths are easier to discover.": "Le raccolte più rilevanti sono più facili da trovare.",
    "personal_assistant.feature.manage_coupons.name": "Gestisci i coupon",
    "Manage coupons": "Gestisci i coupon",
    "personal_assistant.feature.manage_coupons.outcome": "Puoi proporre offerte mirate per favorire l’attivazione.",
    "You can run targeted offers for activation.": "Puoi proporre offerte mirate per favorire l’attivazione.",
    "personal_assistant.feature.view_transactions.name": "Visualizza le transazioni",
    "View transactions": "Visualizza le transazioni",
    "personal_assistant.feature.view_transactions.outcome": "L’attività di pagamento può essere monitorata per garantire fiducia e operatività.",
    "Payment activity can be monitored for trust and operations.": "L’attività di pagamento può essere monitorata per garantire fiducia e operatività.",
    "personal_assistant.feature.view_users.name": "Apri gli utenti",
    "Open users": "Apri gli utenti",
    "personal_assistant.feature.view_users.outcome": "Puoi monitorare la qualità della crescita di clienti e membri.",
    "You can monitor customer and member growth quality.": "Puoi monitorare la qualità della crescita di clienti e membri.",
    "personal_assistant.feature.configure_user_attributes.name": "Configura gli attributi utente",
    "Configure user attributes": "Configura gli attributi utente",
    "personal_assistant.feature.configure_user_attributes.outcome": "Raccogli segnali dai profili per migliorare il coinvolgimento.",
    "You can capture profile signals to improve engagement.": "Raccogli segnali dai profili per migliorare il coinvolgimento.",
    "personal_assistant.feature.review_ratings.name": "Rivedi valutazioni e recensioni",
    "Review ratings and reviews": "Rivedi valutazioni e recensioni",
    "personal_assistant.feature.review_ratings.outcome": "Gli indicatori di fiducia vengono monitorati e migliorati.",
    "Trust signals are monitored and improved.": "Gli indicatori di fiducia vengono monitorati e migliorati.",
    "personal_assistant.feature.view_reports.name": "Apri i report",
    "Open reports": "Apri i report",
    "personal_assistant.feature.view_reports.outcome": "Puoi monitorare le prestazioni con una vista dei dati.",
    "You can track performance with a data view.": "Puoi monitorare le prestazioni con una vista dei dati.",
    "personal_assistant.feature.manage_media.name": "Gestisci la libreria multimediale",
    "Manage media library": "Gestisci la libreria multimediale",
    "personal_assistant.feature.manage_media.outcome": "È più facile mantenere le immagini del brand e delle inserzioni.",
    "Brand and listing visuals are easier to maintain.": "È più facile mantenere le immagini del brand e delle inserzioni.",
    "personal_assistant.feature.manage_reported_listings.name": "Rivedi le inserzioni segnalate",
    "Review reported listings": "Rivedi le inserzioni segnalate",
    "personal_assistant.feature.manage_reported_listings.outcome": "I contenuti rischiosi o di bassa qualità possono essere gestiti rapidamente.",
    "Risky or low-quality content can be handled quickly.": "I contenuti rischiosi o di bassa qualità possono essere gestiti rapidamente.",
    "personal_assistant.feature.app_customization.name": "Personalizza l’esperienza dell’app",
    "Customize app experience": "Personalizza l’esperienza dell’app",
    "personal_assistant.feature.app_customization.outcome": "L’esperienza dell’app mobile è in linea con il tuo brand.",
    "The mobile app experience aligns with your brand.": "L’esperienza dell’app mobile è in linea con il tuo brand.",
    "personal_assistant.feature.app_integrations.name": "Configura le integrazioni dell’app",
    "Configure app integrations": "Configura le integrazioni dell’app",
    "personal_assistant.feature.app_integrations.outcome": "I servizi principali della piattaforma si integrano con i flussi dell’app.",
    "Core platform services connect with app workflows.": "I servizi principali della piattaforma si integrano con i flussi dell’app.",
    "personal_assistant.feature.customize_strings.name": "Personalizza i testi dell’interfaccia",
    "Customize interface text": "Personalizza i testi dell’interfaccia",
    "personal_assistant.feature.customize_strings.outcome": "I testi del prodotto rispecchiano il pubblico e il tono desiderati.",
    "Product copy matches your audience and tone.": "I testi del prodotto rispecchiano il pubblico e il tono desiderati.",
    "personal_assistant.feature.review_settings_home.name": "Apri le impostazioni",
    "Open settings": "Apri le impostazioni",
    "personal_assistant.feature.review_settings_home.outcome": "La configurazione è facile da trovare per il team.",
    "Configuration is easy to find for team operations.": "La configurazione è facile da trovare per il team.",
    "personal_assistant.feature.configure_commission.name": "Configura le commissioni",
    "Configure commission": "Configura le commissioni",
    "personal_assistant.feature.configure_commission.outcome": "La ripartizione dei ricavi rispecchia il tuo modello aziendale.",
    "Revenue sharing aligns with your business model.": "La ripartizione dei ricavi rispecchia il tuo modello aziendale.",
    "personal_assistant.feature.configure_taxes.name": "Configura le imposte",
    "Configure taxes": "Configura le imposte",
    "personal_assistant.feature.configure_taxes.outcome": "I prezzi al checkout sono chiari e le imposte configurate.",
    "Checkout pricing is predictable and tax settings are ready.": "I prezzi al checkout sono chiari e le imposte configurate.",
    "personal_assistant.feature.configure_languages.name": "Configura le lingue",
    "Configure languages": "Configura le lingue",
    "personal_assistant.feature.configure_languages.outcome": "La piattaforma supporta un pubblico multilingue.",
    "The experience supports a multilingual audience.": "La piattaforma supporta un pubblico multilingue.",
    "personal_assistant.feature.configure_currency.name": "Configura la valuta",
    "Configure currency": "Configura la valuta",
    "personal_assistant.feature.configure_currency.outcome": "I prezzi rispecchiano le aspettative del mercato di riferimento.",
    "Prices align with the expectations of your target market.": "I prezzi rispecchiano le aspettative del mercato di riferimento.",
    "personal_assistant.feature.configure_countries.name": "Configura i paesi",
    "Configure countries": "Configura i paesi",
    "personal_assistant.feature.configure_countries.outcome": "La copertura geografica è definita per il lancio.",
    "Geographic coverage is controlled for launch.": "La copertura geografica è definita per il lancio.",
    "personal_assistant.feature.review_checkout_settings.name": "Rivedi le impostazioni di checkout",
    "Review checkout settings": "Rivedi le impostazioni di checkout",
    "personal_assistant.feature.review_checkout_settings.outcome": "Il checkout è più semplice e affidabile.",
    "Checkout is cleaner and more reliable.": "Il checkout è più semplice e affidabile.",
    "personal_assistant.feature.api_configuration.name": "Rivedi la configurazione API",
    "Review API configuration": "Rivedi la configurazione API",
    "personal_assistant.feature.api_configuration.outcome": "Le integrazioni e l’accesso per gli sviluppatori sono pronti.",
    "Integrations and developer access are ready.": "Le integrazioni e l’accesso per gli sviluppatori sono pronti.",
    "personal_assistant.feature.workspace_website_editor.name": "Apri l’editor del sito",
    "Open website editor": "Apri l’editor del sito",
    "personal_assistant.feature.workspace_website_editor.outcome": "La vetrina può essere perfezionata per migliorare la conversione.",
    "The storefront can be refined for conversion.": "La vetrina può essere perfezionata per migliorare la conversione.",
    "personal_assistant.feature.workspace_domain_setup.name": "Rivedi la configurazione del dominio",
    "Review domain setup": "Rivedi la configurazione del dominio",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Un dominio chiaro migliora la fiducia nel brand.",
    "A clean domain improves brand trust.": "Un dominio chiaro migliora la fiducia nel brand.",
    "personal_assistant.feature.workspace_pages.name": "Rivedi le pagine del sito",
    "Review site pages": "Rivedi le pagine del sito",
    "personal_assistant.feature.workspace_pages.outcome": "Le pagine principali e i contenuti favoriscono la fiducia degli utenti.",
    "Core landing and content pages support user trust.": "Le pagine principali e i contenuti favoriscono la fiducia degli utenti.",
    "reports.title": "Report",
    "reports.metric.0": "Utenti",
    "reports.metric.1": "Account",
    "reports.metric.2": "Inserzioni",
    "reports.metric.3": "Inserzioni vendute",
    "Listings Sold": "Inserzioni vendute",
    "reports.metric.4": "Vendite totali",
    "Total Sales": "Vendite totali",
    "reports.metric.5": "Ordini totali",
    "reports.metric.6": "Ricavi totali",
    "Total Earnings": "Ricavi totali",
    "reports.chart.activity": "Attività giornaliera del marketplace",
    "Daily marketplace activity": "Attività giornaliera del marketplace",
    "reports.chart.activity_description": "Inserzioni e nuovi utenti nel tempo",
    "Listings and new users over time": "Inserzioni e nuovi utenti nel tempo",
    "reports.chart.listings_monthly": "Inserzioni mensili",
    "Listings monthly": "Inserzioni mensili",
    "reports.chart.listings_daily": "Inserzioni giornaliere",
    "Listings daily": "Inserzioni giornaliere",
    "reports.chart.users_daily": "Utenti giornalieri",
    "Users daily": "Utenti giornalieri",
    "reports.chart.users_monthly": "Utenti mensili",
    "Users monthly": "Utenti mensili",
    "reports.series.listings": "Inserzioni",
    "reports.series.new_users": "Nuovi utenti",
    "New users": "Nuovi utenti",
    "reports.top_sold_listings": "Inserzioni più vendute",
    "Top sold listings": "Inserzioni più vendute",
    "reports.view_more_insights": "Visualizza altri approfondimenti",
    "View more insights": "Visualizza altri approfondimenti",
    "reports.ai.title": "Report di vendita AI",
    "AI sales reports": "Report di vendita AI",
    "reports.ai.generating": "Generazione report…",
    "Generating reports…": "Generazione report…",
    "reports.ai.value": "Valore",
    "reports.ai.more_info": "Maggiori informazioni su {label}",
    "More information about {label}": "Maggiori informazioni su {label}",
    "reports.ai.saved_snapshot": "Snapshot salvato",
    "Saved snapshot": "Snapshot salvato",
    "reports.ai.no_data": "Nessun dato disponibile",
    "No data available": "Nessun dato disponibile",
    "reports.ai.showing_top": "Visualizzati i primi {shown} risultati su {total}",
    "Showing the top {shown} of {total} results": "Visualizzati i primi {shown} risultati su {total}",
    "reports.ai.saved_report": "Report AI salvato",
    "Saved AI report": "Report AI salvato",
    "reports.ai.template.country": "Vendite per paese",
    "Sales by country": "Vendite per paese",
    "reports.ai.template.state": "Vendite per regione",
    "Sales by state": "Vendite per regione",
    "reports.ai.template.city": "Vendite per città",
    "Sales by city": "Vendite per città",
    "reports.ai.template.category": "Vendite per categoria",
    "Sales by category": "Vendite per categoria",
    "reports.ai.template.country_all_time": "Vendite per paese (totale)",
    "Sales by country (all time)": "Vendite per paese (totale)",
    "reports.ai.template.top_listings_all_time": "Inserzioni più vendute (totale)",
    "Top sold listings (all time)": "Inserzioni più vendute (totale)",
    "reports.ai.template.listings_by_category_all_time": "Inserzioni per categoria (totale)",
    "Listings by category (all time)": "Inserzioni per categoria (totale)",
    "reports.search_table.title": "Ricerca inserzioni",
    "Listing search": "Ricerca inserzioni",
    "reports.search_table.phrase": "Frase",
    "Phrase": "Frase",
    "reports.search_table.result": "Risultato",
    "reports.search_table.created_at": "Creato il",
    "Created at": "Creato il",
    "reports.search_table.user_first_name": "Nome utente",
    "User first name": "Nome utente",
    "reports.search_table.user_last_name": "Cognome utente",
    "User last name": "Cognome utente",
    "reports.search_table.user_email": "Email utente",
    "User email": "Email utente",
    "intelligence.title": "Intelligence",
    "intelligence.description": "Genera report AI, salva snapshot dei grafici e aggiungi i report utili alla dashboard.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Genera report AI, salva snapshot dei grafici e aggiungi i report utili alla dashboard.",
    "intelligence.dashboard.label": "Dashboard",
    "intelligence.dashboard.pinned_title": "Widget di intelligence fissati",
    "Pinned intelligence widgets": "Widget di intelligence fissati",
    "intelligence.dashboard.pinned_count": "{count} fissati",
    "{count} pinned": "{count} fissati",
    "intelligence.dashboard.empty": "Fissa i report salvati per creare una dashboard riutilizzabile.",
    "Pin saved reports to build a reusable dashboard grid.": "Fissa i report salvati per creare una dashboard riutilizzabile.",
    "intelligence.action.open": "Apri",
    "intelligence.action.pin": "Fissa",
    "Pin": "Fissa",
    "intelligence.action.unpin": "Rimuovi",
    "Unpin": "Rimuovi",
    "intelligence.action.generate": "Genera",
    "intelligence.action.save_snapshot": "Salva snapshot",
    "Save snapshot": "Salva snapshot",
    "intelligence.action.discard_draft": "Elimina bozza",
    "Discard draft": "Elimina bozza",
    "intelligence.action.load": "Carica",
    "Load": "Carica",
    "intelligence.action.refresh": "Aggiorna",
    "intelligence.action.delete": "Elimina",
    "intelligence.table.no_rows": "Il report non ha restituito righe strutturate.",
    "No structured rows were returned for this report.": "Il report non ha restituito righe strutturate.",
    "intelligence.table.no_rows_short": "Nessuna riga disponibile.",
    "No rows available.": "Nessuna riga disponibile.",
    "intelligence.field.template": "Modello di report",
    "Report template": "Modello di report",
    "intelligence.field.date_filter": "Filtro data",
    "Date filter": "Filtro data",
    "intelligence.field.prompt": "Anteprima del prompt",
    "Prompt preview": "Anteprima del prompt",
    "intelligence.field.report_name": "Nome del report",
    "Report name": "Nome del report",
    "intelligence.field.report_name_placeholder": "Ad esempio: Prodotti più venduti – ultimi 30 giorni",
    "For example: Top Selling Products – Last 30 Days": "Ad esempio: Prodotti più venduti – ultimi 30 giorni",
    "intelligence.field.chart": "Grafico",
    "Chart": "Grafico",
    "intelligence.field.prompt_label": "Prompt",
    "Prompt": "Prompt",
    "intelligence.date.relative": "Relativo",
    "Relative": "Relativo",
    "intelligence.date.absolute": "Assoluto",
    "Absolute": "Assoluto",
    "intelligence.date.last_n_days": "Ultimi N giorni",
    "Last N days": "Ultimi N giorni",
    "intelligence.date.last_days": "Ultimi {days} giorni",
    "Last {days} days": "Ultimi {days} giorni",
    "intelligence.date.from": "Dal",
    "intelligence.date.to": "Al",
    "intelligence.saved_reports.title": "Report salvati",
    "Saved reports": "Report salvati",
    "intelligence.saved_reports.empty": "Nessun report analitico salvato.",
    "No saved intelligence reports yet.": "Nessun report analitico salvato.",
    "intelligence.active_report": "Report attivo",
    "Active report": "Report attivo",
    "intelligence.no_report_selected": "Nessun report selezionato",
    "No report selected": "Nessun report selezionato",
    "intelligence.active_report.empty_description": "Genera un report o caricane uno salvato per esaminare i dati.",
    "Generate a report or load a saved one to inspect the data.": "Genera un report o caricane uno salvato per esaminare i dati.",
    "intelligence.chart.value": "Valore",
    "intelligence.chart.unknown": "Sconosciuto",
    "intelligence.chart_type.bar": "Barre",
    "Barres": "Barre",
    "intelligence.chart_type.line": "Linee",
    "Line": "Linee",
    "intelligence.chart_type.area": "Area",
    "Area": "Area",
    "intelligence.chart_type.pie": "Torta",
    "Pie": "Torta",
    "intelligence.chart.no_rows": "Il report non contiene righe da rappresentare.",
    "This report did not return rows to plot.": "Il report non contiene righe da rappresentare.",
    "intelligence.empty_report": "Usa il modello e i filtri data per generare un report AI strutturato, quindi salvalo e fissalo alla dashboard.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Usa il modello e i filtri data per generare un report AI strutturato, quindi salvalo e fissalo alla dashboard.",
    "intelligence.error.update": "Impossibile aggiornare il report salvato.",
    "Unable to update the saved report.": "Impossibile aggiornare il report salvato.",
    "intelligence.error.prompt_required": "Inserisci un prompt per generare un report.",
    "Enter a prompt to generate a report.": "Inserisci un prompt per generare un report.",
    "intelligence.error.invalid_response": "La risposta AI non includeva un report normalizzato.",
    "The AI response did not include a normalized report.": "La risposta AI non includeva un report normalizzato.",
    "intelligence.error.generate": "Impossibile generare il report.",
    "Unable to generate the report right now.": "Impossibile generare il report.",
    "intelligence.error.generate_before_save": "Genera un report prima di salvarlo.",
    "Generate a report before saving.": "Genera un report prima di salvarlo.",
    "intelligence.error.save": "Impossibile salvare il report.",
    "Unable to save the report.": "Impossibile salvare il report.",
    "intelligence.error.load": "Impossibile caricare il report.",
    "Unable to load the saved report.": "Impossibile caricare il report.",
    "intelligence.error.refresh": "Impossibile aggiornare il report.",
    "Unable to refresh the saved report.": "Impossibile aggiornare il report.",
    "intelligence.error.delete": "Impossibile eliminare il report.",
    "Unable to delete the saved report.": "Impossibile eliminare il report.",
    "intelligence.template.top_selling_products": "Prodotti più venduti",
    "Top selling products": "Prodotti più venduti",
    "intelligence.template.revenue_trend": "Andamento dei ricavi",
    "Revenue trend": "Andamento dei ricavi",
    "intelligence.template.low_stock_products": "Prodotti con scorte basse",
    "Low stock products": "Prodotti con scorte basse",
    "intelligence.template.top_categories_by_sales": "Categorie principali per vendite",
    "Top categories by sales": "Categorie principali per vendite",
    "intelligence.template.order_status_breakdown": "Ripartizione per stato ordine",
    "Order status breakdown": "Ripartizione per stato ordine",
    "intelligence.template.sales_by_day": "Vendite per giorno",
    "Sales by day": "Vendite per giorno",
    "intelligence.template.sales_by_country": "Vendite per paese",
    "intelligence.template.sales_by_state": "Vendite per regione",
    "intelligence.template.sales_by_city": "Vendite per città",
    "intelligence.template.sales_by_category": "Vendite per categoria",
    "intelligence.template.sales_by_subcategory": "Vendite per sottocategoria",
    "Sales by subcategory": "Vendite per sottocategoria",
    "intelligence.prompt.top_selling_products.relative": "Mostra i prodotti più venduti negli ultimi {days} giorni",
    "Show me top selling products for the last {days} days": "Mostra i prodotti più venduti negli ultimi {days} giorni",
    "intelligence.prompt.top_selling_products.absolute": "Mostra i prodotti più venduti dal {from} al {to}",
    "Show me top selling products from {from} to {to}": "Mostra i prodotti più venduti dal {from} al {to}",
    "intelligence.prompt.revenue_trend.relative": "Mostra l’andamento dei ricavi negli ultimi {days} giorni",
    "What is my revenue trend for the last {days} days?": "Mostra l’andamento dei ricavi negli ultimi {days} giorni",
    "intelligence.prompt.revenue_trend.absolute": "Mostra l’andamento dei ricavi dal {from} al {to}",
    "What is my revenue trend from {from} to {to}?": "Mostra l’andamento dei ricavi dal {from} al {to}",
    "intelligence.prompt.low_stock_products": "Mostra i prodotti con scorte basse",
    "Show me low stock products": "Mostra i prodotti con scorte basse",
    "intelligence.prompt.top_categories_by_sales.relative": "Mostra le categorie principali per vendite negli ultimi {days} giorni",
    "Show me top categories by sales for the last {days} days": "Mostra le categorie principali per vendite negli ultimi {days} giorni",
    "intelligence.prompt.top_categories_by_sales.absolute": "Mostra le categorie principali per vendite dal {from} al {to}",
    "Show me top categories by sales from {from} to {to}": "Mostra le categorie principali per vendite dal {from} al {to}",
    "intelligence.prompt.order_status_breakdown.relative": "Mostra la ripartizione degli ordini per stato negli ultimi {days} giorni",
    "Show me order status breakdown for the last {days} days": "Mostra la ripartizione degli ordini per stato negli ultimi {days} giorni",
    "intelligence.prompt.order_status_breakdown.absolute": "Mostra la ripartizione degli ordini per stato dal {from} al {to}",
    "Show me order status breakdown from {from} to {to}": "Mostra la ripartizione degli ordini per stato dal {from} al {to}",
    "intelligence.prompt.sales_by_day.relative": "Mostra le vendite giornaliere negli ultimi {days} giorni",
    "Show me sales by day for the last {days} days": "Mostra le vendite giornaliere negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_day.absolute": "Mostra le vendite giornaliere dal {from} al {to}",
    "Show me sales by day from {from} to {to}": "Mostra le vendite giornaliere dal {from} al {to}",
    "intelligence.prompt.sales_by_country.relative": "Mostra i ricavi totali e il numero di ordini per paese negli ultimi {days} giorni",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "Mostra i ricavi totali e il numero di ordini per paese negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_country.absolute": "Mostra i ricavi totali e il numero di ordini per paese dal {from} al {to}",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "Mostra i ricavi totali e il numero di ordini per paese dal {from} al {to}",
    "intelligence.prompt.sales_by_state.relative": "Mostra i ricavi totali e il numero di ordini per regione o provincia negli ultimi {days} giorni",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "Mostra i ricavi totali e il numero di ordini per regione o provincia negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_state.absolute": "Mostra i ricavi totali e il numero di ordini per regione o provincia dal {from} al {to}",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "Mostra i ricavi totali e il numero di ordini per regione o provincia dal {from} al {to}",
    "intelligence.prompt.sales_by_city.relative": "Mostra i ricavi totali e il numero di ordini per città negli ultimi {days} giorni",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "Mostra i ricavi totali e il numero di ordini per città negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_city.absolute": "Mostra i ricavi totali e il numero di ordini per città dal {from} al {to}",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "Mostra i ricavi totali e il numero di ordini per città dal {from} al {to}",
    "intelligence.prompt.sales_by_category.relative": "Mostra i ricavi totali e il numero di ordini per categoria principale delle inserzioni negli ultimi {days} giorni",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "Mostra i ricavi totali e il numero di ordini per categoria principale delle inserzioni negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_category.absolute": "Mostra i ricavi totali e il numero di ordini per categoria principale delle inserzioni dal {from} al {to}",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "Mostra i ricavi totali e il numero di ordini per categoria principale delle inserzioni dal {from} al {to}",
    "intelligence.prompt.sales_by_subcategory.relative": "Mostra i ricavi totali e il numero di ordini per sottocategoria delle inserzioni negli ultimi {days} giorni",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "Mostra i ricavi totali e il numero di ordini per sottocategoria delle inserzioni negli ultimi {days} giorni",
    "intelligence.prompt.sales_by_subcategory.absolute": "Mostra i ricavi totali e il numero di ordini per sottocategoria delle inserzioni dal {from} al {to}",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "Mostra i ricavi totali e il numero di ordini per sottocategoria delle inserzioni dal {from} al {to}",
    "common.status.partial": "Parziale",
    "Partial": "Parziale",
    "common.status.dispatched": "Spedito",
    "Dispatched": "Spedito",
    "common.status.sale": "Vendita",
    "Sale": "Vendita",
    "common.status.transfer_in": "Trasferimento in entrata",
    "Transfer in": "Trasferimento in entrata",
    "common.status.transfer_out": "Trasferimento in uscita",
    "Transfer out": "Trasferimento in uscita",
    "common.status.return": "Reso",
    "Return": "Reso",
    "common.status.adjustment": "Rettifica",
    "Adjustment": "Rettifica",
    "common.status.receipt": "Ricezione",
    "inventory.overview.title": "Magazzino",
    "inventory.overview.tab.all": "Tutte le scorte",
    "All stock": "Tutte le scorte",
    "inventory.overview.tab.low": "Scorte basse",
    "Low stock": "Scorte basse",
    "inventory.overview.tab.expiring": "Lotti in scadenza",
    "Expiring batches": "Lotti in scadenza",
    "inventory.overview.manage_locations": "Gestisci sedi",
    "Manage locations": "Gestisci sedi",
    "inventory.overview.purchase_orders": "Ordini di acquisto",
    "inventory.overview.operations": "Operazioni",
    "Operations": "Operazioni",
    "inventory.overview.adjust_stock": "Rettifica scorte",
    "Adjust stock": "Rettifica scorte",
    "inventory.overview.description": "Vista aggiornata delle scorte in tutte le sedi.",
    "A live view of stock across your locations.": "Vista aggiornata delle scorte in tutte le sedi.",
    "inventory.overview.adjustment_hint": "Usa le rettifiche per conteggi, danni, resi o altre correzioni.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Usa le rettifiche per conteggi, danni, resi o altre correzioni.",
    "inventory.overview.units_on_hand": "Unità disponibili",
    "Units on hand": "Unità disponibili",
    "inventory.overview.one_stock_row": "1 riga di scorte",
    "1 stock row": "1 riga di scorte",
    "inventory.overview.stock_rows": "{count} righe di scorte",
    "{count} stock rows": "{count} righe di scorte",
    "inventory.overview.low_stock": "Scorte basse",
    "inventory.overview.reorder_point_hint": "Al livello di riordino o inferiore",
    "At or below reorder point": "Al livello di riordino o inferiore",
    "inventory.overview.expiring_soon": "In scadenza",
    "Expiring soon": "In scadenza",
    "inventory.overview.next_90_days": "Nei prossimi 90 giorni",
    "Within the next 90 days": "Nei prossimi 90 giorni",
    "inventory.overview.stock_value": "Valore delle scorte",
    "Stock value": "Valore delle scorte",
    "inventory.overview.one_active_location": "1 sede attiva",
    "1 active location": "1 sede attiva",
    "inventory.overview.active_locations": "{count} sedi attive",
    "{count} active locations": "{count} sedi attive",
    "inventory.overview.search": "Cerca nel magazzino",
    "Search inventory": "Cerca nel magazzino",
    "inventory.overview.search_placeholder": "Cerca prodotto, SKU o sede",
    "Search product, SKU, or location": "Cerca prodotto, SKU o sede",
    "inventory.overview.filter_location": "Filtra per sede",
    "Filter by location": "Filtra per sede",
    "inventory.overview.all_locations": "Tutte le sedi",
    "inventory.overview.empty.all": "Nessuna scorta registrata.",
    "No inventory stock has been recorded yet.": "Nessuna scorta registrata.",
    "inventory.overview.empty.low": "Ottimo: nessuna scorta è sotto il livello di riordino.",
    "Great — no stock is below its reorder point.": "Ottimo: nessuna scorta è sotto il livello di riordino.",
    "inventory.overview.empty.expiring": "Nessun lotto scade nei prossimi 90 giorni.",
    "No batches are expiring within 90 days.": "Nessun lotto scade nei prossimi 90 giorni.",
    "inventory.overview.adjust": "Rettifica",
    "Adjust": "Rettifica",
    "inventory.overview.adjust_title": "Rettifica scorte",
    "inventory.overview.adjust_description": "Registra una rettifica con il motivo per mantenere affidabile la cronologia del magazzino.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Registra una rettifica con il motivo per mantenere affidabile la cronologia del magazzino.",
    "inventory.overview.save_adjustment": "Salva rettifica",
    "Save adjustment": "Salva rettifica",
    "inventory.overview.listing_id": "ID {id}",
    "inventory.overview.unassigned": "Non assegnato",
    "Unassigned": "Non assegnato",
    "inventory.overview.quantity_change": "Variazione quantità",
    "Quantity change": "Variazione quantità",
    "inventory.overview.quantity_placeholder": "ad es. 5 o -2",
    "e.g. 5 or -2": "ad es. 5 o -2",
    "inventory.overview.reason": "Motivo",
    "inventory.overview.reason_placeholder": "Conteggio, danno, reso…",
    "Cycle count, damage, return…": "Conteggio, danno, reso…",
    "inventory.overview.reason.cycle_count": "Conteggio ciclico",
    "Cycle count": "Conteggio ciclico",
    "inventory.overview.reason.damage": "Danno",
    "Damage": "Danno",
    "inventory.overview.reason.return": "Reso",
    "inventory.overview.reason.stocktake": "Inventario",
    "Stocktake": "Inventario",
    "inventory.overview.note_placeholder": "Contesto facoltativo per il prossimo operatore",
    "Optional context for the next person": "Contesto facoltativo per il prossimo operatore",
    "inventory.overview.adjustment_saved": "Rettifica del magazzino salvata",
    "Inventory adjustment saved": "Rettifica del magazzino salvata",
    "inventory.overview.on_hand": "Disponibile",
    "On hand": "Disponibile",
    "inventory.overview.reorder_at": "Riordina a",
    "Reorder at": "Riordina a",
    "orders.create_order.payment_reference_missing": "Ordine creato, ma non è stato restituito alcun riferimento.",
    "The order was created, but no order reference was returned.": "Ordine creato, ma non è stato restituito alcun riferimento.",
    "orders.create_order.payment_domain_missing": "Il dominio del tenant non è disponibile per i link di pagamento.",
    "The tenant domain is not available for payment links.": "Il dominio del tenant non è disponibile per i link di pagamento.",
    "orders.create_order.payment_link_failed": "Impossibile creare il link di pagamento.",
    "Unable to create payment link.": "Impossibile creare il link di pagamento.",
    "orders.create_order.admin_session_expired": "La sessione amministratore è scaduta. Accedi di nuovo prima di creare un ordine.",
    "Your admin session has expired. Please sign in again before creating an order.": "La sessione amministratore è scaduta. Accedi di nuovo prima di creare un ordine.",
    "orders.create_order.user": "Utente",
    "orders.create_order.add_new_user": "Aggiungi utente",
    "Add New User": "Aggiungi utente",
    "orders.create_order.choose_existing_user": "Scegli un utente esistente",
    "Choose Existing User": "Scegli un utente esistente",
    "orders.create_order.preparing_customer": "Preparazione del cliente…",
    "Preparing customer…": "Preparazione del cliente…",
    "orders.create_order.select_user": "Seleziona utente",
    "Select user": "Seleziona utente",
    "orders.create_order.search_listing": "Cerca inserzione",
    "Search Listing": "Cerca inserzione",
    "orders.create_order.listings": "Inserzioni",
    "orders.create_order.no_image": "Nessuna immagine",
    "No image": "Nessuna immagine",
    "orders.create_order.add_to_cart": "Aggiungi al carrello",
    "Add to Cart": "Aggiungi al carrello",
    "orders.create_order.select_rental_dates": "Seleziona prima le date di inizio e fine del noleggio.",
    "Select rental start and end dates first.": "Seleziona prima le date di inizio e fine del noleggio.",
    "orders.create_order.rental_end_after_start": "La fine del noleggio deve essere successiva all’inizio.",
    "Rental end must be after the start date.": "La fine del noleggio deve essere successiva all’inizio.",
    "orders.create_order.cart_type_conflict": "Il cliente ha già articoli di un altro tipo. Rimuovili dal checkout prima di aggiungere questo articolo.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Il cliente ha già articoli di un altro tipo. Rimuovili dal checkout prima di aggiungere questo articolo.",
    "orders.create_order.rental_period": "Periodo di noleggio",
    "Rental period": "Periodo di noleggio",
    "orders.create_order.select_start_end": "Seleziona inizio e fine",
    "Select start and end": "Seleziona inizio e fine",
    "orders.create_order.membership_no_shipping": "Gli ordini di abbonamento non richiedono spedizione o consegna.",
    "Membership orders do not require shipping or delivery.": "Gli ordini di abbonamento non richiedono spedizione o consegna.",
    "orders.create_order.preparing_payment_link": "Preparazione del link di pagamento…",
    "Preparing payment link…": "Preparazione del link di pagamento…",
    "orders.create_order.payment_link_ready": "Link di pagamento pronto",
    "Payment link ready": "Link di pagamento pronto",
    "orders.create_order.copy_payment_link": "Copia link di pagamento",
    "Copy payment link": "Copia link di pagamento",
    "orders.create_order.payment_method": "Metodo di pagamento",
    "orders.create_order.no_payment_methods": "Non sono configurati metodi di pagamento attivi per questo progetto.",
    "No active payment methods are configured for this project.": "Non sono configurati metodi di pagamento attivi per questo progetto.",
    "orders.create_order.shipping_method": "Metodo di spedizione",
    "orders.create_order.no_shipping_methods": "Non sono configurati metodi di spedizione attivi per questo progetto.",
    "No active shipping methods are configured for this project.": "Non sono configurati metodi di spedizione attivi per questo progetto.",
    "orders.create_order.shipping_address": "Indirizzo di spedizione",
    "Shipping address": "Indirizzo di spedizione",
    "orders.create_order.loading_addresses": "Caricamento degli indirizzi salvati…",
    "Loading saved addresses…": "Caricamento degli indirizzi salvati…",
    "orders.create_order.no_saved_shipping_address": "L’utente non ha un indirizzo salvato. Aggiungilo al profilo prima di creare un ordine con consegna.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "L’utente non ha un indirizzo salvato. Aggiungilo al profilo prima di creare un ordine con consegna.",
    "orders.create_order.no_items": "Nessun articolo",
    "No items": "Nessun articolo",
    "orders.create_order.cart_empty": "Il carrello è vuoto",
    "Your cart is empty": "Il carrello è vuoto",
    "orders.create_order.create_order": "Crea ordine",
    "Create Order": "Crea ordine",
    "orders.create_order.create_payment_link": "Crea link di pagamento",
    "Create payment link": "Crea link di pagamento",
    "orders.create_order.order_summary": "Riepilogo ordine",
    "orders.create_order.coupon_value": "Valore coupon",
    "Coupon value": "Valore coupon",
    "orders.create_order.remove_coupon": "Rimuovi coupon",
    "Remove Coupon": "Rimuovi coupon",
    "orders.create_order.apply_coupon": "Applica coupon",
    "Apply Coupon": "Applica coupon",
    "orders.create_order.grand_amount": "Totale complessivo",
    "Grand Amount": "Totale complessivo",
    "orders.create_order.total": "Totale",
    "orders.create_order.shipping": "Spedizione",
    "Shipping": "Spedizione",
    "orders.create_order.subtotal": "Subtotale",
    "Subtotal": "Subtotale",
    "orders.create_order.stock_unavailable": "Scorte non disponibili",
    "Stock is not available": "Scorte non disponibili",
    "orders.create_order.max_quantity": "La quantità massima è {quantity}",
    "Max quantity is {quantity}": "La quantità massima è {quantity}",
    "orders.create_order.items_in_cart": "Articoli nel carrello",
    "Items in the cart": "Articoli nel carrello",
    "orders.create_order.products_in_stock": "{count} prodotti disponibili",
    "{count} Products in Stock": "{count} prodotti disponibili",
    "orders.create_order.order_items": "Articoli dell’ordine",
    "Order Items": "Articoli dell’ordine",
    "orders.create_order.sold_by": "da {name}",
    "by {name}": "da {name}",
    "common.first_name": "Nome",
    "common.last_name": "Cognome",
    "common.unlimited": "illimitato",
    "unlimited": "illimitato",
    "orders.reference": "Riferimento",
    "orders.amount": "Importo",
    "orders.currency": "Valuta",
    "orders.transaction_date": "Data transazione",
    "Transaction Date": "Data transazione",
    "orders.volume_this_page": "Volume (questa pagina)",
    "Volume (this page)": "Volume (questa pagina)",
    "orders.seller_entries": "Voci venditore",
    "Seller Entries": "Voci venditore",
    "orders.customer_entries": "Voci cliente",
    "Customer Entries": "Voci cliente",
    "orders.filter_transactions": "Filtra transazioni",
    "Filter Transactions": "Filtra transazioni",
    "orders.reset_filters": "Reimposta filtri",
    "Reset filters": "Reimposta filtri",
    "orders.manage_transactions": "Gestisci le transazioni",
    "Manage your Transactions": "Gestisci le transazioni",
    "orders.empty_transactions_message": "Qui puoi monitorare le transazioni tra utenti: commissioni, importi degli ordini, costi di pagamento e commissioni speciali.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Qui puoi monitorare le transazioni tra utenti: commissioni, importi degli ordini, costi di pagamento e commissioni speciali.",
    "orders.super_type": "Tipo principale",
    "Super Type": "Tipo principale",
    "orders.exporting": "Esportazione…",
    "Exporting…": "Esportazione…",
    "orders.export_as_csv": "Esporta come CSV",
    "Export as CSV": "Esporta come CSV",
    "orders.search_transactions": "Cerca transazioni",
    "Search transactions": "Cerca transazioni",
    "orders.filter": "Filtro",
    "orders.transaction_status": "Stato transazione",
    "Transaction Status": "Stato transazione",
    "orders.seller_protection_fee": "Commissione Protezione Venditore",
    "Seller Protection Fee": "Commissione Protezione Venditore",
    "common.show_rows": "Mostra righe",
    "common.clear_all": "Cancella tutto",
    "Clear All": "Cancella tutto",
    "orders.order_number_value": "Ordine n. {number}",
    "orders.transactions": "Transazioni",
    "reported_listings.report_detail": "Dettagli segnalazione",
    "Report Detail": "Dettagli segnalazione",
    "reported_listings.reported_listing": "Inserzione segnalata",
    "Reported Listing": "Inserzione segnalata",
    "reported_listings.pending": "In attesa",
    "reported_listings.approved": "Approvato",
    "reported_listings.rejected": "Rifiutato",
    "reported_listings.view_marketplace": "Visualizza nel marketplace",
    "View on marketplace": "Visualizza nel marketplace",
    "reported_listings.approve_listing": "Approva inserzione",
    "Approve listing": "Approva inserzione",
    "reported_listings.reject_listing": "Rifiuta inserzione",
    "Reject listing": "Rifiuta inserzione",
    "reported_listings.reported_by": "Segnalato da",
    "Reported By": "Segnalato da",
    "reported_listings.blocked": "Bloccato",
    "reported_listings.unblock_user": "Sblocca utente",
    "Unblock user": "Sblocca utente",
    "reported_listings.block_user": "Blocca utente",
    "Block user": "Blocca utente",
    "reported_listings.report_info": "Informazioni segnalazione",
    "Report Info": "Informazioni segnalazione",
    "reported_listings.reason": "Motivo",
    "reported_listings.reported_on": "Segnalato il",
    "Reported on": "Segnalato il",
    "reported_listings.listing_id": "ID inserzione",
    "reported_listings.reporter": "Segnalante",
    "Reporter": "Segnalante",
    "reported_listings.listing": "Inserzione",
    "reported_listings.status": "Stato",
    "reported_listings.title": "Inserzioni segnalate",
    "reported_listings.report_count": "Segnalazioni: {count}",
    "Reports: {count}": "Segnalazioni: {count}",
    "reported_listings.empty_title": "Visualizzazione delle inserzioni segnalate",
    "Viewing Reported listings": "Visualizzazione delle inserzioni segnalate",
    "reported_listings.empty_message": "Qui trovi le inserzioni segnalate dagli utenti.",
    "You will find your users reported listings here": "Qui trovi le inserzioni segnalate dagli utenti.",
    "common.page_of": "Pagina {page} di {total}",
    "Page {page} of {total}": "Pagina {page} di {total}",
    "common.view": "Visualizza",
    "reviews.empty_title": "Valutazioni e recensioni",
    "Viewing Rate & Reviews": "Valutazioni e recensioni",
    "reviews.empty_message": "Qui trovi le valutazioni e le recensioni degli utenti.",
    "You will find your users ratings and reviews here": "Qui trovi le valutazioni e le recensioni degli utenti.",
    "reviews.list": "Elenco",
    "reviews.grid": "Griglia",
    "Grid": "Griglia",
    "reviews.title": "Recensioni e valutazioni",
    "reviews.review": "Recensione",
    "reviews.name": "Nome",
    "reviews.rating": "Valutazione",
    "Rating": "Valutazione",
    "reviews.title_column": "Titolo",
    "reviews.content": "Contenuto",
    "Content": "Contenuto",
    "reviews.image": "Immagine",
    "Image": "Immagine",
    "reviews.images": "Immagini",
    "Images": "Immagini",
    "reviews.accounts": "Account",
    "reviews.listings": "Inserzioni",
    "reviews.star": "Stella",
    "Star": "Stella",
    "reviews.review_image": "Immagine della recensione",
    "Review image": "Immagine della recensione",
    "reviews.title_required": "Il titolo è obbligatorio",
    "Title is required": "Il titolo è obbligatorio",
    "reviews.content_required": "Il contenuto è obbligatorio",
    "Content is required": "Il contenuto è obbligatorio",
    "reviews.updated_successfully": "Recensione aggiornata",
    "Review updated successfully": "Recensione aggiornata",
    "reviews.edit_review": "Modifica recensione",
    "Edit Review": "Modifica recensione",
    "common.not_available": "N/D",
    "common.something_went_wrong": "Si è verificato un errore",
    "Something went wrong": "Si è verificato un errore",
    "media.load_failed": "Impossibile caricare il contenuto multimediale.",
    "Unable to load media.": "Impossibile caricare il contenuto multimediale.",
    "media.load_failed_retry": "Impossibile caricare il contenuto multimediale. Riprova.",
    "media.update_failed": "Aggiornamento del contenuto multimediale non riuscito",
    "Media update failed": "Aggiornamento del contenuto multimediale non riuscito",
    "media.renamed": "Contenuto multimediale rinominato",
    "Media renamed": "Contenuto multimediale rinominato",
    "media.moved": "Contenuto multimediale spostato",
    "Media moved": "Contenuto multimediale spostato",
    "media.rename_failed": "Impossibile rinominare il contenuto",
    "Unable to rename media": "Impossibile rinominare il contenuto",
    "media.move_failed": "Impossibile spostare il contenuto",
    "Unable to move media": "Impossibile spostare il contenuto",
    "media.deleted": "Contenuto multimediale eliminato",
    "Media deleted": "Contenuto multimediale eliminato",
    "media.delete_failed": "Impossibile eliminare il contenuto",
    "Unable to delete media": "Impossibile eliminare il contenuto",
    "media.confirm_delete": "Vuoi eliminare questo contenuto multimediale?",
    "Are you sure you want to delete this media?": "Vuoi eliminare questo contenuto multimediale?",
    "media.delete_media": "Elimina contenuto multimediale",
    "Delete media": "Elimina contenuto multimediale",
    "media.folder_creation_web_only": "La creazione di cartelle è disponibile sul web",
    "Folder creation is available on web": "La creazione di cartelle è disponibile sul web",
    "media.no_create_folder_permission": "Non hai l’autorizzazione per creare cartelle",
    "You do not have permission to create folders": "Non hai l’autorizzazione per creare cartelle",
    "media.folder_name": "Nome cartella",
    "Folder name": "Nome cartella",
    "media.folder_created": "Cartella creata",
    "Folder created": "Cartella creata",
    "media.folder_create_failed": "Impossibile creare la cartella",
    "Unable to create folder": "Impossibile creare la cartella",
    "media.link_copied": "Link copiato",
    "Link copied": "Link copiato",
    "media.copy_link_failed": "Impossibile copiare il link",
    "Unable to copy link": "Impossibile copiare il link",
    "media.urls_copied": "Copiati {count} URL",
    "{count} URLs copied": "Copiati {count} URL",
    "media.clipboard_unavailable": "Appunti non disponibili",
    "Clipboard is not available": "Appunti non disponibili",
    "media.copy_urls_failed": "Impossibile copiare gli URL",
    "Unable to copy URLs": "Impossibile copiare gli URL",
    "media.upload_failed": "Caricamento del contenuto non riuscito",
    "Media upload failed": "Caricamento del contenuto non riuscito",
    "media.replace_success": "Contenuto sostituito. L’ID e il link permanente non sono cambiati.",
    "Media replaced. The media ID and stable link are unchanged.": "Contenuto sostituito. L’ID e il link permanente non sono cambiati.",
    "media.replace_failed": "Impossibile sostituire il contenuto",
    "Unable to replace media": "Impossibile sostituire il contenuto",
    "media.csv_upload_failed": "Caricamento CSV non riuscito",
    "CSV upload failed": "Caricamento CSV non riuscito",
    "media.csv_metadata_failed": "Impossibile salvare i metadati CSV",
    "Unable to save CSV metadata": "Impossibile salvare i metadati CSV",
    "media.csv_saved_version": "CSV salvato come nuova versione",
    "CSV saved as a new version": "CSV salvato come nuova versione",
    "media.csv_save_failed": "Impossibile salvare il CSV",
    "Unable to save CSV": "Impossibile salvare il CSV",
    "media.uploading_files": "Caricamento di {count} file…",
    "Uploading {count} files…": "Caricamento di {count} file…",
    "media.upload_progress": "Caricamento di {count} file · {progress}%",
    "Uploading {count} files · {progress}%": "Caricamento di {count} file · {progress}%",
    "media.upload_success": "Caricati correttamente {count} file.",
    "{count} files uploaded successfully.": "Caricati correttamente {count} file.",
    "media.upload_failed_retry": "Impossibile caricare il contenuto. Riprova.",
    "Unable to upload media. Please try again.": "Impossibile caricare il contenuto. Riprova.",
    "media.register_failed": "Impossibile registrare il contenuto",
    "Unable to register media": "Impossibile registrare il contenuto",
    "media.list_view": "Vista elenco",
    "List view": "Vista elenco",
    "media.grid_view": "Vista griglia",
    "Grid view": "Vista griglia",
    "media.copy_uploaded_urls": "Copia gli URL caricati",
    "Copy uploaded URLs": "Copia gli URL caricati",
    "media.copy_visible_urls": "Copia gli URL visibili",
    "Copy visible URLs": "Copia gli URL visibili",
    "media.copy_all_urls": "Copia tutti gli URL",
    "Copy all URLs": "Copia tutti gli URL",
    "media.new_folder": "Nuova cartella",
    "New folder": "Nuova cartella",
    "media.uploading_progress": "Caricamento {progress}%",
    "Uploading {progress}%": "Caricamento {progress}%",
    "media.upload_media": "Carica contenuti",
    "media.manager_title": "Gestione contenuti multimediali",
    "Media Manager": "Gestione contenuti multimediali",
    "media.search": "Cerca contenuti",
    "Search media": "Cerca contenuti",
    "media.location": "Posizione",
    "media.media_root": "Contenuti",
    "media.show_type": "Mostra contenuti di tipo {type}",
    "Show {type} media": "Mostra contenuti di tipo {type}",
    "media.type_all": "tutti",
    "all": "tutti",
    "media.type_image": "immagine",
    "image": "immagine",
    "media.type_video": "video",
    "video": "video",
    "media.type_audio": "audio",
    "audio": "audio",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "cartella",
    "folder": "cartella",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "Meno recenti",
    "Oldest": "Meno recenti",
    "media.newest": "Più recenti",
    "Newest": "Più recenti",
    "media.sort_current": "Ordina contenuti, attualmente {sort}",
    "Sort media, currently {sort}": "Ordina contenuti, attualmente {sort}",
    "media.loading": "Caricamento contenuti…",
    "Loading media…": "Caricamento contenuti…",
    "media.no_filter_matches": "Nessun contenuto corrisponde ai filtri.",
    "No media matches these filters.": "Nessun contenuto corrisponde ai filtri.",
    "media.empty_title": "La libreria multimediale è vuota",
    "Your media library is empty": "La libreria multimediale è vuota",
    "media.empty_message": "Carica immagini, PDF e video da riutilizzare, ad esempio per promozioni e articoli.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Carica immagini, PDF e video da riutilizzare, ad esempio per promozioni e articoli.",
    "media.empty_hint": "Carica file o crea una cartella per iniziare.",
    "Upload files or create a folder to get started.": "Carica file o crea una cartella per iniziare.",
    "media.folder": "Cartella",
    "Folder": "Cartella",
    "media.file_folder_name": "Nome file o cartella",
    "File or folder name": "Nome file o cartella",
    "media.rename_media": "Rinomina contenuto",
    "Rename media": "Rinomina contenuto",
    "media.move_media": "Sposta contenuto",
    "Move media": "Sposta contenuto",
    "media.pdf_preview": "Anteprima PDF: {name}",
    "PDF preview: {name}": "Anteprima PDF: {name}",
    "media.pdf_preview_web": "L’anteprima PDF è disponibile nell’app web.",
    "PDF preview is available in the web app.": "L’anteprima PDF è disponibile nell’app web.",
    "media.csv_preview_web": "L’anteprima CSV è disponibile nell’app web.",
    "CSV preview is available in the web app.": "L’anteprima CSV è disponibile nell’app web.",
    "media.media_file": "File multimediale",
    "Media file": "File multimediale",
    "media.share_link": "Condividi link",
    "Share link": "Condividi link",
    "media.copy_link": "Copia link",
    "Copy link": "Copia link",
    "media.replace_media": "Sostituisci contenuto",
    "Replace media": "Sostituisci contenuto",
    "media.folders": "Cartelle",
    "Folders": "Cartelle",
    "media.create_new_folder": "Crea nuova cartella",
    "Create new folder": "Crea nuova cartella",
    "media.go_to_all_media": "Vai a tutti i contenuti",
    "Go to all media": "Vai a tutti i contenuti",
    "media.all_media": "Tutti i contenuti",
    "All media": "Tutti i contenuti",
    "media.open_folder_name": "Apri la cartella {name}",
    "Open folder {name}": "Apri la cartella {name}",
    "media.no_subfolders": "Nessuna sottocartella",
    "No subfolders": "Nessuna sottocartella",
    "media.no_files_in_folder": "Nessun file in questa cartella.",
    "No files in this folder.": "Nessun file in questa cartella.",
    "media.upload_folder": "Carica contenuti in questa cartella",
    "Upload media to this folder": "Carica contenuti in questa cartella",
    "media.discard_csv_confirm": "Annullare le modifiche al CSV?",
    "Discard your CSV changes?": "Annullare le modifiche al CSV?",
    "media.unsaved_changes": "Modifiche non salvate",
    "Unsaved changes": "Modifiche non salvate",
    "media.find_csv": "Trova nel CSV",
    "Find in CSV": "Trova nel CSV",
    "media.save_csv": "Salva CSV",
    "Save CSV": "Salva CSV",
    "media.loading_csv": "Caricamento CSV…",
    "Loading CSV…": "Caricamento CSV…",
    "media.prepare_folder_failed": "Impossibile preparare la cartella di caricamento",
    "Unable to prepare the upload folder": "Impossibile preparare la cartella di caricamento",
    "media.add_file_required": "Aggiungi un file",
    "Please add a file": "Aggiungi un file",
    "media.add_media": "Aggiungi contenuto",
    "Add Media": "Aggiungi contenuto",
    "media.store_uploaded_media_in": "Salva i contenuti caricati in",
    "Store uploaded media in": "Salva i contenuti caricati in",
    "media.destination_business_cards": "Biglietti da visita",
    "Business Cards": "Biglietti da visita",
    "media.destination_listings": "Inserzioni",
    "media.destination_accounts": "Account",
    "media.destination_users": "Utenti",
    "media.upload_media_title": "Carica contenuti",
    "media.media_files": "Contenuti multimediali",
    "media.open_folder": "Apri cartella",
    "Open folder": "Apri cartella",
    "common.show": "Mostra",
    "common.share": "Condividi",
    "common.copy": "Copia",
    "common.rename": "Rinomina",
    "Rename": "Rinomina",
    "common.move": "Sposta",
    "Move": "Sposta",
    "common.type": "Tipo",
    "common.size": "Dimensione",
    "Size": "Dimensione",
    "common.preview": "Anteprima",
    "Preview": "Anteprima",
    "common.undo": "Annulla",
    "Undo": "Annulla",
    "common.redo": "Ripeti",
    "Redo": "Ripeti",
    "common.discard": "Scarta",
    "Discard": "Scarta",
    "common.try_again": "Riprova",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "Foglio di calcolo",
    "Spreadsheet": "Foglio di calcolo",
    "media.type_file": "File",
    "File": "File",
    "media.csv_load_failed": "Impossibile caricare il CSV. Riprova.",
    "Unable to load CSV. Please try again.": "Impossibile caricare il CSV. Riprova.",
    "workspace.settings_section.customisation": "Personalizzazione",
    "workspace.settings_section.integrations": "Integrazioni",
    "workspace.settings_section.platform_setup": "Configurazione piattaforma",
    "Platform Setup": "Configurazione piattaforma",
    "workspace.settings_section.business_operations": "Operazioni aziendali",
    "Business Operations": "Operazioni aziendali",
    "workspace.settings_section.system_setup": "Configurazione sistema",
    "System Setup": "Configurazione sistema",
    "workspace.settings_item.app_customisation": "Personalizzazione app",
    "App Customisation": "Personalizzazione app",
    "workspace.settings_item.web_customisation": "Personalizzazione web",
    "Web Customisation": "Personalizzazione web",
    "workspace.settings_item.communications": "Comunicazioni",
    "Communications": "Comunicazioni",
    "workspace.settings_item.strings_customisation": "Personalizzazione testi",
    "Strings Customisation": "Personalizzazione testi",
    "workspace.settings_item.app_integrations": "Integrazioni app",
    "workspace.settings_item.web_integrations": "Integrazioni web",
    "Web Integrations": "Integrazioni web",
    "workspace.settings_item.accounts": "Account",
    "workspace.settings_item.listings": "Inserzioni",
    "workspace.settings_item.checkout_and_cart_attributes": "Attributi checkout e carrello",
    "workspace.settings_item.service_shipping": "Servizi / spedizione",
    "workspace.settings_item.payments": "Pagamenti",
    "workspace.settings_item.commissions": "Commissioni",
    "workspace.settings_item.taxes": "Imposte",
    "workspace.settings_item.special_fees": "Commissioni speciali",
    "workspace.settings_item.languages": "Lingue",
    "workspace.settings_item.currency": "Valuta",
    "workspace.settings_item.countries": "Paesi",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Estensioni",
    "Extensions": "Estensioni",
    "workspace.settings_item.manage_features": "Gestisci funzionalità",
    "Manage Features": "Gestisci funzionalità",
    "workspace.settings_item.audit_logs": "Registri di controllo",
    "workspace.settings_item.auth": "Autenticazione",
    "workspace.settings_item.maps": "Mappe",
    "workspace.settings_hint.accounts": "Ad esempio: Negozio",
    "Example: Store": "Ad esempio: Negozio",
    "workspace.settings_hint.listings": "Ad esempio: Prodotti, eventi",
    "Example: Products, Events": "Ad esempio: Prodotti, eventi",
    "workspace.settings_hint.audit_logs": "Registro di conformità e sicurezza",
    "Compliance & security trail": "Registro di conformità e sicurezza",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Utilizzo del provider e impostazioni privacy",
    "Provider usage and privacy settings": "Utilizzo del provider e impostazioni privacy",
    "workspace.settings_access_denied": "Non hai accesso a {name}",
    "You don't have access of {name}": "Non hai accesso a {name}",
    "app_customization.title": "Personalizzazione app",
    "app_customization.tab_0": "Generale",
    "General": "Generale",
    "app_customization.tab_1": "Schermata iniziale",
    "Splash": "Schermata iniziale",
    "app_customization.tab_2": "Onboarding",
    "Onboarding": "Onboarding",
    "app_customization.tab_3": "Registrazione",
    "Registration": "Registrazione",
    "app_customization.tab_4": "Home",
    "Home": "Home",
    "app_customization.tab_5": "Notifiche push",
    "Push Notification": "Notifiche push",
    "app_customization.tab_6": "Chat",
    "Chat": "Chat",
    "app_customization.tab_7": "Menu Altro",
    "More Menu": "Menu Altro",
    "app_customization.tab_8": "Aggiornamento obbligatorio",
    "Force Update": "Aggiornamento obbligatorio",
    "app_customization.tab_9": "Indirizzo",
    "app_customization.hide_balances": "Nascondi saldi e pagamenti nella sezione Altro",
    "Hide balances & payouts in more section": "Nascondi saldi e pagamenti nella sezione Altro",
    "app_customization.more": "Altro",
    "app_customization.force_update": "Forza aggiornamento",
    "Force To Update": "Forza aggiornamento",
    "app_customization.android_version": "Versione app Android",
    "Android app version": "Versione app Android",
    "app_customization.enter_android_version": "Inserisci la versione dell’app Android",
    "Enter android app version": "Inserisci la versione dell’app Android",
    "app_customization.ios_version": "Versione app iOS",
    "iOS app version": "Versione app iOS",
    "app_customization.enter_ios_version": "Inserisci la versione dell’app iOS",
    "Enter iOS app version": "Inserisci la versione dell’app iOS",
    "app_customization.chat": "Chat",
    "app_customization.chat_send_listing": "Invia automaticamente l’inserzione all’apertura della chat (in genere mostra l’anteprima in alto)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Invia automaticamente l’inserzione all’apertura della chat (in genere mostra l’anteprima in alto)",
    "app_customization.make_offer": "Fai un’offerta / negozia",
    "Make Offer / Negotiation": "Fai un’offerta / negozia",
    "app_customization.negotiation_button_name": "Nome del pulsante di negoziazione:",
    "Negotiation button name:": "Nome del pulsante di negoziazione:",
    "app_customization.negotiation_button_example": "(ad es.: Fai un’offerta, Negozia, Richiedi un preventivo)",
    "(example: Make Offer, Negotiate, Quote)": "(ad es.: Fai un’offerta, Negozia, Richiedi un preventivo)",
    "app_customization.enter_negotiation_button_name": "Inserisci il nome del pulsante di negoziazione",
    "Enter negotiation button name": "Inserisci il nome del pulsante di negoziazione",
    "app_customization.address": "Indirizzo",
    "app_customization.address_option_0": "Mostra indirizzo 2",
    "Show Address 2": "Mostra indirizzo 2",
    "app_customization.address_option_1": "Mostra paese",
    "Show Country": "Mostra paese",
    "app_customization.address_option_2": "Mostra CAP",
    "Show Zipcode": "Mostra CAP",
    "app_customization.address_option_3": "Mostra regione",
    "Show State": "Mostra regione",
    "app_customization.address_option_4": "Mostra punto di riferimento",
    "Show Landmark": "Mostra punto di riferimento",
    "app_customization.address_option_5": "Mostra città",
    "Show City": "Mostra città",
    "app_customization.persistent_notification": "Notifiche persistenti",
    "Persistent Notification": "Notifiche persistenti",
    "app_customization.account_follow_content": "Testo notifica per il follow di un account",
    "Account follow notification content": "Testo notifica per il follow di un account",
    "app_customization.enter_account_follow_content": "Inserisci il testo della notifica di follow account",
    "Enter Account follow notification content": "Inserisci il testo della notifica di follow account",
    "app_customization.listing_like_content": "Testo notifica per i like alle inserzioni",
    "Listing like notification content": "Testo notifica per i like alle inserzioni",
    "app_customization.enter_listing_like_content": "Inserisci il testo della notifica di like all’inserzione",
    "Enter Listing like  notification content": "Inserisci il testo della notifica di like all’inserzione",
    "app_customization.order_status_content": "Testo notifica sullo stato dell’ordine",
    "Order status notification content": "Testo notifica sullo stato dell’ordine",
    "app_customization.enter_order_status_content": "Inserisci il testo della notifica sullo stato dell’ordine",
    "Order status follow notification content": "Inserisci il testo della notifica sullo stato dell’ordine",
    "app_customization.account_follow_required": "La notifica di follow deve contenere {account_name}",
    "Account follow notification should contain {account_name}": "La notifica di follow deve contenere {account_name}",
    "app_customization.listing_like_required": "La notifica di like deve contenere {user_name}",
    "Listing like notification content should contain {user_name}": "La notifica di like deve contenere {user_name}",
    "app_customization.order_number_required": "La notifica sullo stato dell’ordine deve contenere #{order_number}",
    "Order status notification content should contain #{order_number}": "La notifica sullo stato dell’ordine deve contenere #{order_number}",
    "app_customization.order_status_required": "La notifica sullo stato dell’ordine deve contenere {order_status}",
    "Order status notification content should contain {order_status}": "La notifica sullo stato dell’ordine deve contenere {order_status}",
    "app_customization.preview": "Anteprima",
    "app_customization.splash": "Schermata iniziale",
    "app_customization.splash_image": "Immagine schermata iniziale",
    "Splash Screen Image": "Immagine schermata iniziale",
    "app_customization.registration": "Registrazione",
    "app_customization.registration_text": "Testo di registrazione",
    "Registration text": "Testo di registrazione",
    "app_customization.otp_note": "Nota sulla verifica OTP",
    "OTP Verification note": "Nota sulla verifica OTP",
    "app_customization.get_signup_first": "Apri prima la registrazione",
    "app_customization.mobile_in_email_signup": "Numero di cellulare nella registrazione email",
    "Mobile number in email signup": "Numero di cellulare nella registrazione email",
    "app_customization.preview_field_first_name": "Nome",
    "app_customization.preview_field_last_name": "Cognome",
    "app_customization.preview_field_email": "Email",
    "app_customization.preview_field_password": "Password",
    "Password": "Password",
    "app_customization.preview_field_confirm_password": "Conferma password",
    "Confirm Password": "Conferma password",
    "app_customization.preview_field_dob": "Data di nascita",
    "DOB": "Data di nascita",
    "app_customization.preview_field_mobile_no": "Numero di cellulare",
    "Mobile No": "Numero di cellulare",
    "app_customization.create": "Crea",
    "app_customization.login": "Accedi",
    "Login": "Accedi",
    "app_customization.create_account": "Crea il tuo account",
    "Create your account": "Crea il tuo account",
    "app_customization.login_account": "Accedi al tuo account",
    "Login to your account": "Accedi al tuo account",
    "app_customization.onboarding_settings": "Impostazioni onboarding",
    "Onboarding Settings": "Impostazioni onboarding",
    "app_customization.onboarding_images": "Immagini onboarding",
    "Onboarding Images": "Immagini onboarding",
    "app_customization.onboarding_text_1": "Testo onboarding 1",
    "Onboarding text 1": "Testo onboarding 1",
    "app_customization.onboarding_text_2": "Testo onboarding 2",
    "Onboarding text 2": "Testo onboarding 2",
    "app_customization.onboarding_text_3": "Testo onboarding 3",
    "Onboarding text 3": "Testo onboarding 3",
    "app_customization.see_how_it_works": "Scopri come funziona",
    "See how it works": "Scopri come funziona",
    "app_customization.sell_icon_text": "Testo dell’icona Vendi",
    "Sell icon text": "Testo dell’icona Vendi",
    "app_customization.enter_sell_icon_text": "Inserisci il testo dell’icona Vendi",
    "Enter sell icon text": "Inserisci il testo dell’icona Vendi",
    "app_customization.sell_icon": "Icona Vendi",
    "Sell Icon": "Icona Vendi",
    "app_customization.enter_home_title": "Inserisci il titolo dell’app nella home",
    "Enter app title in home": "Inserisci il titolo dell’app nella home",
    "app_customization.app_details": "Dettagli app",
    "App Details": "Dettagli app",
    "app_customization.app_name": "Nome app",
    "App Name": "Nome app",
    "app_customization.primary_colour": "Colore principale app",
    "App Primary Colour": "Colore principale app",
    "app_customization.secondary_colour": "Colore secondario app",
    "App Secondary Colour": "Colore secondario app",
    "app_customization.android_app_icon": "Icona app Android",
    "App Icon Android": "Icona app Android",
    "app_customization.ios_app_icon": "Icona app iOS",
    "App Icon iOS": "Icona app iOS",
    "app_customization.screen_number": "Schermata {number}",
    "Screen {number}": "Schermata {number}",
    "app_customization.upload_here": "Carica qui",
    "Upload here": "Carica qui",
    "app_customization.next": "Avanti",
    "app_customization.get_started": "Inizia",
    "Get Start": "Inizia",
    "app_customization.select": "Seleziona",
    "Select": "Seleziona",
    "app_customization.app_title_home_icon": "Icona del titolo app nella home",
    "App Title Home Icon": "Icona del titolo app nella home",
    "app_customization.home_icon_hint": "(l’icona deve essere bianca e in formato PNG)",
    "(icon should be white and in png format)": "(l’icona deve essere bianca e in formato PNG)",
    "app_customization.home_title": "Titolo app nella home",
    "app_customization.default_collection_widgets": "Widget raccolte predefiniti",
    "Default Collection Widgets": "Widget raccolte predefiniti",
    "app_customization.accounts_follow_title": "Titolo raccolta account da seguire",
    "Accounts to follow collection title": "Titolo raccolta account da seguire",
    "app_customization.enter_accounts_follow_title": "Inserisci il titolo della raccolta di account da seguire",
    "Enter accounts to follow collection title": "Inserisci il titolo della raccolta di account da seguire",
    "app_customization.nearby_accounts_title": "Titolo raccolta account nelle vicinanze",
    "Nearby accounts collection title": "Titolo raccolta account nelle vicinanze",
    "app_customization.enter_nearby_accounts_title": "Inserisci il titolo della raccolta di account vicini",
    "Enter near by accounts collection title": "Inserisci il titolo della raccolta di account vicini",
    "app_customization.latest_listings_title": "Titolo raccolta ultime inserzioni",
    "Latest listings collection title": "Titolo raccolta ultime inserzioni",
    "app_customization.enter_latest_listings_title": "Inserisci il titolo della raccolta delle ultime inserzioni",
    "Enter latest listings collection title": "Inserisci il titolo della raccolta delle ultime inserzioni",
    "app_customization.enable_appearance_sections": "Seleziona per attivare le sezioni di aspetto",
    "Select to enable appearance sections": "Seleziona per attivare le sezioni di aspetto",
    "app_customization.choose_photo": "Scegli foto",
    "Choose photo": "Scegli foto",
    "app_customization.choose_icon": "Scegli icona",
    "Choose icon": "Scegli icona",
    "app_customization.enable_home_icon": "Usa l’icona del titolo app al posto del testo",
    "app_customization.account_name": "Nome account",
    "Account Name": "Nome account",
    "app_customization.product_name": "Nome prodotto",
    "Product Name": "Nome prodotto",
    "app_customization.home_option_0": "Mostra raccolta nelle vicinanze",
    "Show nearby collection": "Mostra raccolta nelle vicinanze",
    "app_customization.home_option_1": "Mostra sezione categorie",
    "Show category section": "Mostra sezione categorie",
    "app_customization.home_option_2": "Mostra banner promozionali",
    "Show promo banners": "Mostra banner promozionali",
    "app_customization.home_option_3": "Mostra invito amici",
    "Show invite friends": "Mostra invito amici",
    "app_customization.home_option_4": "Mostra promemoria recensioni",
    "Show review reminders": "Mostra promemoria recensioni",
    "app_customization.home_option_5": "Account da seguire",
    "Accounts to follow": "Account da seguire",
    "app_customization.download": "Scarica",
    "app_customization.cancel": "Annulla",
    "app_customization.uploaded_successfully": "Caricato correttamente",
    "app_customization.image_limit": "Non puoi selezionare altre immagini",
    "You cannot select more images": "Non puoi selezionare altre immagini",
    "app_customization.choose_zip_file": "Scegli file ZIP",
    "Choose zip file": "Scegli file ZIP",
    "app_translation.title": "Personalizzazione testi",
    "app_translation.search": "Digita per cercare…",
    "Type to search...": "Digita per cercare…",
    "app_translation.default_language": "Predefinita",
    "app_translation.default_text": "Testo predefinito",
    "Default text": "Testo predefinito",
    "communications.title": "Comunicazioni",
    "communications.tab_0": "Notifiche email",
    "Email Notification": "Notifiche email",
    "communications.tab_1": "Configurazione email",
    "Email Configuration": "Configurazione email",
    "communications.tab_2": "Notifiche ordine",
    "Order Notification": "Notifiche ordine",
    "communications.tab_3": "Modulo feedback",
    "Feedback Form": "Modulo feedback",
    "communications.translate": "Traduci",
    "Translate": "Traduci",
    "communications.edit_email_template": "Modifica modello email",
    "Edit email template": "Modifica modello email",
    "communications.feedback_email": "Email",
    "communications.feedback_phone": "Telefono",
    "communications.feedback_email_or_phone": "Email o telefono",
    "Email or Phone": "Email o telefono",
    "communications.select_type": "Seleziona tipo",
    "communications.form_required_field": "Campo obbligatorio",
    "Form Required Field": "Campo obbligatorio",
    "communications.feedback_recipient_label": "Email per ricevere feedback (separa gli indirizzi con una virgola)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Email per ricevere feedback (separa gli indirizzi con una virgola)",
    "communications.enter_email": "Inserisci email",
    "Enter email": "Inserisci email",
    "communications.enable_feedback_form": "Abilita modulo feedback",
    "Enable feedback Form": "Abilita modulo feedback",
    "communications.feedback": "Feedback",
    "Feedback": "Feedback",
    "communications.realtime_config_notice": "Le configurazioni seguenti si applicano in tempo reale. Dopo aver salvato, saranno visibili nelle app e nelle risposte API.",
    "communications.uploaded_successfully": "Caricato correttamente",
    "communications.email_whitelabeling": "Personalizzazione brand email",
    "Email Whitelabelling": "Personalizzazione brand email",
    "communications.from_name": "Nome mittente",
    "From name": "Nome mittente",
    "communications.enter_from_name": "Inserisci il nome del mittente",
    "Enter from name": "Inserisci il nome del mittente",
    "communications.from_email_address": "Indirizzo email del mittente",
    "From email address": "Indirizzo email del mittente",
    "communications.from_email_domain_hint": "Hai scelto un dominio personalizzato per il mittente. Per garantire la consegna delle email, verifica il dominio con noi. Contatta il supporto per assistenza.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Hai scelto un dominio personalizzato per il mittente. Per garantire la consegna delle email, verifica il dominio con noi. Contatta il supporto per assistenza.",
    "communications.reset": "Ripristina",
    "communications.enter_from_email": "Inserisci l’email del mittente",
    "Enter from email address": "Inserisci l’email del mittente",
    "communications.email_header_logo": "Logo intestazione email",
    "Email Header Logo": "Logo intestazione email",
    "communications.choose_logo": "Scegli file 50*50",
    "Choose file 50*50": "Scegli file 50*50",
    "communications.list_view": "Vista elenco",
    "communications.gallery_view": "Vista galleria",
    "Gallery view": "Vista galleria",
    "communications.grid_view": "Vista griglia",
    "communications.search": "Cerca comunicazioni",
    "Search communications": "Cerca comunicazioni",
    "communications.email_settings": "Impostazioni email",
    "Email settings": "Impostazioni email",
    "communications.category_all": "Tutte",
    "communications.category_buyer": "Acquirente",
    "Buyer": "Acquirente",
    "communications.category_seller": "Venditore",
    "communications.category_transactional": "Transazionali",
    "Transactional": "Transazionali",
    "communications.category_engagement": "Coinvolgimento",
    "Engagement": "Coinvolgimento",
    "communications.category_retention": "Fidelizzazione",
    "Retention": "Fidelizzazione",
    "communications.category_membership": "Abbonamento",
    "communications.audience_buyer": "Acquirente",
    "communications.audience_seller": "Venditore",
    "communications.system_notification": "Notifica di sistema",
    "System notification": "Notifica di sistema",
    "communications.template": "modello",
    "template": "modello",
    "communications.edit": "Modifica",
    "communications.sent": "inviato",
    "sent": "inviato",
    "communications.open": "aperto",
    "communications.clicks": "clic",
    "clicks": "clic",
    "communications.no_email_matches": "Nessuna email corrisponde al filtro.",
    "No emails match your filter.": "Nessuna email corrisponde al filtro.",
    "communications.buyer_order_confirmation": "Email di conferma ordine per l’acquirente",
    "Order confirmation email for buyer": "Email di conferma ordine per l’acquirente",
    "communications.seller_order_confirmation": "Email di conferma ordine per il venditore",
    "Order confirmation email for seller": "Email di conferma ordine per il venditore",
    "communications.email_card_0": "Email di benvenuto",
    "Welcome Message": "Email di benvenuto",
    "communications.email_card_1": "OTP / verifica",
    "OTP / Verification": "OTP / verifica",
    "communications.email_card_2": "Link di iscrizione",
    "Subscription Link": "Link di iscrizione",
    "communications.email_card_3": "Iscrizione completata",
    "Subscription Success": "Iscrizione completata",
    "communications.email_card_4": "Conferma ordine — acquirente",
    "Order confirmation — buyer": "Conferma ordine — acquirente",
    "communications.email_card_5": "Conferma ordine — venditore",
    "Order confirmation — seller": "Conferma ordine — venditore",
    "communications.email_card_6": "Ordine spedito — acquirente",
    "Shipment shipped — buyer": "Ordine spedito — acquirente",
    "communications.email_card_7": "Ordine consegnato — acquirente",
    "Shipment delivered — buyer": "Ordine consegnato — acquirente",
    "communications.email_card_8": "Ordine annullato — acquirente",
    "Order cancelled — buyer": "Ordine annullato — acquirente",
    "communications.email_card_9": "Rimborso elaborato — acquirente",
    "Refund processed — buyer": "Rimborso elaborato — acquirente",
    "communications.email_card_10": "Nuova inserzione dal negozio seguito — acquirente",
    "New listing from followed store — buyer": "Nuova inserzione dal negozio seguito — acquirente",
    "communications.email_card_11": "Articolo di nuovo disponibile — acquirente",
    "Back in stock — buyer": "Articolo di nuovo disponibile — acquirente",
    "communications.email_card_12": "Avviso di scadenza inserzione — venditore",
    "Listing expiry warning — seller": "Avviso di scadenza inserzione — venditore",
    "communications.email_card_13": "Traguardo di like all’inserzione — venditore",
    "Listing likes milestone — seller": "Traguardo di like all’inserzione — venditore",
    "communications.email_card_14": "Account verificato — venditore",
    "Account verified — seller": "Account verificato — venditore",
    "communications.email_card_15": "Ritorno del venditore — venditore",
    "Seller win-back — seller": "Ritorno del venditore — venditore",
    "communications.email_card_16": "Avviso scorte basse — venditore",
    "Low stock warning — seller": "Avviso scorte basse — venditore",
    "communications.email_card_17": "Venditore registrato — venditore",
    "Seller onboarded — seller": "Venditore registrato — venditore",
    "communications.email_card_18": "Richiesta di recensione — acquirente",
    "Review request — buyer": "Richiesta di recensione — acquirente",
    "communications.email_card_19": "Prima vendita — venditore",
    "First sale — seller": "Prima vendita — venditore",
    "communications.email_card_20": "Traguardo vendite — venditore",
    "Sales milestone — seller": "Traguardo vendite — venditore",
    "communications.email_card_21": "Ritorno dell’acquirente — acquirente",
    "Win-back — buyer": "Ritorno dell’acquirente — acquirente",
    "communications.email_card_22": "Primo acquisto — acquirente",
    "First purchase — buyer": "Primo acquisto — acquirente",
    "communications.email_card_23": "Domanda del cliente — venditore",
    "Customer question — seller": "Domanda del cliente — venditore",
    "communications.email_card_24": "Risposta del venditore — acquirente",
    "Seller answer — buyer": "Risposta del venditore — acquirente",
    "communications.email_card_25": "Offerta di negoziazione — venditore",
    "Negotiation offer — seller": "Offerta di negoziazione — venditore",
    "communications.email_card_26": "Offerta accettata — acquirente",
    "Offer accepted — buyer": "Offerta accettata — acquirente",
    "communications.email_card_27": "Offerta rifiutata — acquirente",
    "Offer rejected — buyer": "Offerta rifiutata — acquirente",
    "communications.email_card_28": "Nuovo follower — venditore",
    "New follower — seller": "Nuovo follower — venditore",
    "communications.email_card_29": "Inserzione apprezzata — venditore",
    "Listing liked — seller": "Inserzione apprezzata — venditore",
    "communications.email_card_30": "Inserzione approvata — venditore",
    "Listing approved — seller": "Inserzione approvata — venditore",
    "communications.email_card_31": "Inserzione rifiutata — venditore",
    "Listing rejected — seller": "Inserzione rifiutata — venditore",
    "communications.email_card_32": "Prima inserzione — venditore",
    "First listing — seller": "Prima inserzione — venditore",
    "communications.email_card_33": "Carrello abbandonato — acquirente",
    "Abandoned cart — buyer": "Carrello abbandonato — acquirente",
    "communications.email_card_34": "Recensione inserzione — venditore",
    "Listing review — seller": "Recensione inserzione — venditore",
    "communications.email_card_35": "Promemoria evasione ordine — venditore",
    "Fulfillment reminder — seller": "Promemoria evasione ordine — venditore",
    "communications.email_card_36": "Riduzione prezzo — acquirente",
    "Price drop — buyer": "Riduzione prezzo — acquirente",
    "communications.email_card_37": "Pagamento abbonamento in scadenza",
    "Membership payment due soon": "Pagamento abbonamento in scadenza",
    "communications.email_card_38": "Pagamento abbonamento scaduto",
    "Membership payment overdue": "Pagamento abbonamento scaduto",
    "communications.order_status_notification": "Notifica sullo stato dell’ordine",
    "Order Status Notification": "Notifica sullo stato dell’ordine",
    "communications.order_group_lifecycle": "Ciclo di vita dell’ordine",
    "Order lifecycle": "Ciclo di vita dell’ordine",
    "communications.order_group_returns": "Resi e problemi di consegna",
    "Returns and delivery issues": "Resi e problemi di consegna",
    "communications.order_group_cancellations": "Annullamenti e ritiro",
    "Cancellations and pickup": "Annullamenti e ritiro",
    "communications.notification_settings_count": "{count} impostazioni di notifica",
    "{count} notification settings": "{count} impostazioni di notifica",
    "communications.enter_order_field": "Inserisci {field}",
    "Enter {field}": "Inserisci {field}",
    "communications.order_field_0": "Stato ordine confermato",
    "Order status confirmed": "Stato ordine confermato",
    "communications.order_field_1": "Stato ordine in elaborazione",
    "Order status in progress": "Stato ordine in elaborazione",
    "communications.order_field_2": "Stato ordine spedito",
    "Order status shipped": "Stato ordine spedito",
    "communications.order_field_3": "Stato ordine: cliente irreperibile",
    "Order status customer unreachable": "Stato ordine: cliente irreperibile",
    "communications.order_field_4": "Stato ordine: in consegna",
    "Order status out for delivery": "Stato ordine: in consegna",
    "communications.order_field_5": "Stato ordine: non consegnato, restituito",
    "Order status undelivered returned": "Stato ordine: non consegnato, restituito",
    "communications.order_field_6": "Stato ordine: reso per mancata consegna confermato",
    "Order status undelivered return confirmed": "Stato ordine: reso per mancata consegna confermato",
    "communications.order_field_7": "Stato ordine: consegnato",
    "Order status delivered": "Stato ordine: consegnato",
    "communications.order_field_8": "Stato ordine: consegna confermata",
    "Order status delivered confirmed": "Stato ordine: consegna confermata",
    "communications.order_field_9": "Stato ordine: reso avviato dal cliente",
    "Order status customer return initiated": "Stato ordine: reso avviato dal cliente",
    "communications.order_field_10": "Stato ordine: reso ritirato",
    "Order status customer return picked": "Stato ordine: reso ritirato",
    "communications.order_field_11": "Stato ordine: reso confermato",
    "Order status customer return confirmed": "Stato ordine: reso confermato",
    "communications.order_field_12": "Stato ordine: reso contestato",
    "Order status customer return disputed": "Stato ordine: reso contestato",
    "communications.order_field_13": "Stato ordine: annullato dall’account",
    "Order status cancelled by account": "Stato ordine: annullato dall’account",
    "communications.order_field_14": "Stato ordine: annullato dal cliente",
    "Order status cancelled by customer": "Stato ordine: annullato dal cliente",
    "communications.order_field_15": "Stato ordine: pronto per il ritiro",
    "Order status ready for pickup": "Stato ordine: pronto per il ritiro",
    "communications.order_field_16": "Stato ordine: completato",
    "Order status completed": "Stato ordine: completato",
    "communications.update": "Aggiorna",
    "communications.download_template": "Scarica modello",
    "Download Template": "Scarica modello",
    "communications.reset_to_default": "Ripristina impostazioni predefinite",
    "communications.send_test_email": "Invia email di prova",
    "Send test email": "Invia email di prova",
    "communications.enter_test_emails": "Inserisci le email separate da virgole",
    "Enter email(s), comma-separated": "Inserisci le email separate da virgole",
    "communications.send_test": "Invia test",
    "Send test": "Invia test",
    "communications.subject_required": "L’oggetto non può essere vuoto",
    "Subject should not be empty": "L’oggetto non può essere vuoto",
    "communications.body_required": "Il corpo non può essere vuoto",
    "Body should not be empty": "Il corpo non può essere vuoto",
    "communications.code_merge_tag_required": "Il tag di unione {code} è obbligatorio",
    "{code} merge tag is mandatory": "Il tag di unione {code} è obbligatorio",
    "communications.edit_template_named": "Modifica {name}",
    "Edit {name}": "Modifica {name}",
    "communications.subject": "Oggetto",
    "Subject": "Oggetto",
    "communications.enter_subject": "Inserisci l’oggetto",
    "Enter the Subject": "Inserisci l’oggetto",
    "communications.available_merge_tags": "Tag di unione disponibili:",
    "Available merge tags:": "Tag di unione disponibili:",
    "communications.body": "Corpo",
    "Body": "Corpo",
    "communications.write_here": "Scrivi qui…",
    "Write here...": "Scrivi qui…",
    "communications.subject_line": "Oggetto",
    "Subject Line": "Oggetto",
    "communications.enter_subject_line": "Inserisci l’oggetto…",
    "Enter the subject…": "Inserisci l’oggetto…",
    "communications.merge_tags": "Tag di unione",
    "Merge tags": "Tag di unione",
    "communications.loading_templates": "Caricamento modelli…",
    "Loading templates…": "Caricamento modelli…",
    "communications.hide_templates": "Nascondi modelli",
    "Hide templates": "Nascondi modelli",
    "communications.load_template": "Carica modello",
    "Load template": "Carica modello",
    "communications.html_body": "Corpo HTML",
    "HTML Body": "Corpo HTML",
    "communications.enter_html_body": "Incolla o scrivi qui il codice HTML…",
    "Paste or type your HTML here…": "Incolla o scrivi qui il codice HTML…",
    "communications.live_preview": "Anteprima live",
    "Live Preview": "Anteprima live",
    "communications.desktop": "Desktop",
    "Desktop": "Desktop",
    "communications.mobile": "Mobile",
    "communications.email_preview": "Anteprima email",
    "Email preview": "Anteprima email",
    "communications.start_typing_preview": "Inizia a scrivere per vedere l’anteprima",
    "Start typing to see a preview": "Inizia a scrivere per vedere l’anteprima",
    "communications.translations": "traduzioni",
    "translations": "traduzioni",
    "communications.validation_account_follow_tag": "La notifica di follow deve contenere {account_name}",
    "communications.validation_listing_like_tag": "La notifica di like deve contenere {user_name}",
    "Listing follow notification should contain {user_name}": "La notifica di like deve contenere {user_name}",
    "communications.validation_order_number_tag": "La notifica sullo stato dell’ordine deve contenere #{order_number}",
    "Order status follow notification should contain #{order_number}": "La notifica sullo stato dell’ordine deve contenere #{order_number}",
    "communications.validation_order_status_tag": "La notifica sullo stato dell’ordine deve contenere {order_status}",
    "Order status follow notification should contain {order_status}": "La notifica sullo stato dell’ordine deve contenere {order_status}",
    "communications.journey_title": "Mappa del percorso email",
    "Email Journey Map": "Mappa del percorso email",
    "communications.journey_subtitle": "Quando viene inviata ogni email nel ciclo di vita utente",
    "Where each email fires in the user lifecycle": "Quando viene inviata ogni email nel ciclo di vita utente",
    "communications.journey_buyer": "Percorso acquirente",
    "Buyer Journey": "Percorso acquirente",
    "communications.journey_seller": "Percorso venditore",
    "Seller Journey": "Percorso venditore",
    "communications.journey_buyer_stage_0": "Registrazione",
    "Sign Up": "Registrazione",
    "communications.journey_buyer_stage_1": "Esplorazione",
    "Browse": "Esplorazione",
    "communications.journey_buyer_stage_2": "Carrello",
    "Cart": "Carrello",
    "communications.journey_buyer_stage_3": "Ordine effettuato",
    "Order Placed": "Ordine effettuato",
    "communications.journey_buyer_stage_4": "Spedito",
    "communications.journey_buyer_stage_5": "Consegnato",
    "communications.journey_buyer_stage_6": "Negoziazione",
    "Negotiate": "Negoziazione",
    "communications.journey_buyer_stage_7": "Inattivo",
    "communications.journey_seller_stage_0": "Avvio",
    "Onboard": "Avvio",
    "communications.journey_seller_stage_1": "Pubblica inserzione",
    "communications.journey_seller_stage_2": "Gestione",
    "communications.journey_seller_stage_3": "Ordine ricevuto",
    "Order In": "Ordine ricevuto",
    "communications.journey_seller_stage_4": "Spedizione",
    "communications.journey_seller_stage_5": "Completa",
    "Complete": "Completa",
    "communications.journey_seller_stage_6": "Inattivo",
    "accounts.title": "Account",
    "accounts.status_pending": "In attesa",
    "accounts.status_approved": "Approvato",
    "accounts.status_rejected": "Rifiutato",
    "accounts.show_rows": "Mostra righe",
    "accounts.next": "Avanti",
    "accounts.previous": "Indietro",
    "accounts.view_list": "Elenco",
    "accounts.view_map": "Mappa",
    "Map": "Mappa",
    "accounts.view_board": "Bacheca",
    "accounts.view_grid": "Griglia",
    "accounts.view_list_accessibility": "Vista elenco",
    "accounts.view_map_accessibility": "Vista mappa",
    "Map view": "Vista mappa",
    "accounts.view_board_accessibility": "Vista bacheca",
    "Board view": "Vista bacheca",
    "accounts.view_grid_accessibility": "Vista griglia",
    "accounts.column_name": "Nome",
    "accounts.column_account_id": "ID account",
    "Account ID": "ID account",
    "accounts.column_description": "Descrizione",
    "accounts.column_image": "Immagine",
    "accounts.column_user_name": "Nome utente",
    "User Name": "Nome utente",
    "accounts.column_email": "Email",
    "accounts.column_status": "Stato",
    "accounts.column_account_status": "Stato account",
    "Account Status": "Stato account",
    "accounts.column_location": "Posizione",
    "accounts.search": "Cerca account",
    "Search accounts": "Cerca account",
    "accounts.export": "Esporta",
    "accounts.import": "Importa",
    "accounts.export_accounts": "Esporta account",
    "Export accounts": "Esporta account",
    "accounts.import_accounts": "Importa account",
    "Import accounts": "Importa account",
    "accounts.smart_upload_accounts": "Caricamento smart account",
    "Smart Upload accounts": "Caricamento smart account",
    "accounts.export_all_question": "Esportare tutti gli account?",
    "Export all accounts?": "Esportare tutti gli account?",
    "accounts.export_all_description": "Verrà preparato un file con tutti gli account. Puoi esaminare questa procedura prima di passare a un piano superiore.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Verrà preparato un file con tutti gli account. Puoi esaminare questa procedura prima di passare a un piano superiore.",
    "accounts.export_all": "Esporta tutti gli account",
    "Export all accounts": "Esporta tutti gli account",
    "accounts.cancel": "Annulla",
    "accounts.active": "Attivo",
    "accounts.inactive": "Inattivo",
    "accounts.not_available": "N/D",
    "accounts.approve": "Approva",
    "accounts.reject": "Rifiuta",
    "accounts.manage": "Gestisci",
    "accounts.tooltip_title": "Gli account sono come negozi.",
    "Accounts are like shops.": "Gli account sono come negozi.",
    "accounts.tooltip_description": "Gli utenti possono creare sulla piattaforma uno spazio per gestire un’attività: un account. Non tutti gli utenti ne hanno bisogno e gli account possono collegare un conto escrow per ricevere i pagamenti.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Gli utenti possono creare sulla piattaforma uno spazio per gestire un’attività: un account. Non tutti gli utenti ne hanno bisogno e gli account possono collegare un conto escrow per ricevere i pagamenti.",
    "accounts.create_account": "Crea account",
    "Create Account": "Crea account",
    "accounts.create_new_account": "Crea nuovo account",
    "Create New Account": "Crea nuovo account",
    "accounts.save": "Salva",
    "accounts.please_wait": "Attendi…",
    "Please wait...": "Attendi…",
    "accounts.account_name": "Nome account",
    "accounts.slug": "Slug",
    "Slug": "Slug",
    "accounts.account_slug": "Slug account",
    "Account Slug": "Slug account",
    "accounts.account_description": "Descrizione account",
    "Account Description": "Descrizione account",
    "accounts.enter_name_first": "Inserisci prima un titolo",
    "Please enter a title first": "Inserisci prima un titolo",
    "accounts.user": "Utente",
    "accounts.select_user": "Seleziona utente",
    "accounts.category": "Categoria",
    "Category": "Categoria",
    "accounts.select_type": "Seleziona tipo",
    "Select Type": "Seleziona tipo",
    "accounts.smart_upload_title": "Caricamento smart degli account",
    "Smart account upload": "Caricamento smart degli account",
    "accounts.start_over": "Ricomincia",
    "accounts.smart_upload_description": "Carica gli account e abbina le colonne CSV ai campi account.",
    "Upload accounts and match your CSV columns to account fields.": "Carica gli account e abbina le colonne CSV ai campi account.",
    "accounts.smart_upload_step_0": "Caricamento",
    "accounts.smart_upload_step_1": "Associa colonne",
    "accounts.smart_upload_step_2": "Revisione",
    "accounts.smart_upload_step_3": "Importa",
    "accounts.choose_csv": "Scegli un file CSV",
    "accounts.smart_upload_required_note": "Il nome è obbligatorio. Indirizzo, slug, categoria, proprietario e coordinate sono facoltativi.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Il nome è obbligatorio. Indirizzo, slug, categoria, proprietario e coordinate sono facoltativi.",
    "accounts.select_csv": "Seleziona file CSV",
    "accounts.match_columns": "Abbina colonne account",
    "Match account columns": "Abbina colonne account",
    "accounts.import_field_name": "Nome",
    "accounts.import_field_description": "Descrizione",
    "accounts.import_field_slug": "Slug",
    "accounts.import_field_category_id": "ID categoria",
    "Category ID": "ID categoria",
    "accounts.import_field_user_id": "ID utente proprietario",
    "Owner User ID": "ID utente proprietario",
    "accounts.import_field_location": "Indirizzo",
    "accounts.import_field_latitude": "Latitudine",
    "Latitude": "Latitudine",
    "accounts.import_field_longitude": "Longitudine",
    "Longitude": "Longitudine",
    "accounts.do_not_import": "Non importare",
    "accounts.review_import": "Rivedi importazione",
    "accounts.import_count": "Verranno importati {count} account.",
    "{count} accounts will be imported.": "Verranno importati {count} account.",
    "accounts.smart_upload_complete": "Caricamento smart completato",
    "accounts.imported_count": "Importati {imported} account su {total}.",
    "{imported} of {total} accounts imported.": "Importati {imported} account su {total}.",
    "accounts.selected_file": "Selezionato: {filename}",
    "Selected: {filename}": "Selezionato: {filename}",
    "accounts.review": "Rivedi",
    "accounts.importing": "Importazione…",
    "accounts.uploading": "Caricamento…",
    "accounts.download": "Scarica",
    "accounts.file_label": "File:",
    "accounts.select_file": "Seleziona file",
    "accounts.upload": "Carica",
    "accounts.download_template": "Scarica modello {type}",
    "Download {type} template": "Scarica modello {type}",
    "accounts.import_stage_prepare": "Preparazione del file di importazione",
    "Preparing import file": "Preparazione del file di importazione",
    "accounts.import_prepare_failed": "Impossibile preparare il file di importazione.",
    "accounts.import_stage_upload": "Caricamento del file di importazione",
    "accounts.import_upload_failed": "Impossibile caricare il file di importazione.",
    "accounts.import_stage_server": "Tradly sta importando gli account",
    "Tradly is importing accounts": "Tradly sta importando gli account",
    "accounts.import_stage_complete": "Importazione completata",
    "Import complete": "Importazione completata",
    "accounts.import_stage_stopped": "Importazione interrotta",
    "accounts.confirm_approve": "Approvare questo account?",
    "Approve this account?": "Approvare questo account?",
    "accounts.confirm_reject": "Rifiutare questo account?",
    "Reject this account?": "Rifiutare questo account?",
    "accounts.name_required": "Il nome è obbligatorio",
    "Name is required": "Il nome è obbligatorio",
    "accounts.user_required": "L’utente è obbligatorio",
    "User is required": "L’utente è obbligatorio",
    "accounts.attribute_required": "{attribute} è obbligatorio",
    "{attribute} is required": "{attribute} è obbligatorio",
    "accounts.overview": "Panoramica account",
    "Account Overview": "Panoramica account",
    "accounts.section_listings": "Inserzioni",
    "accounts.loading": "Caricamento…",
    "accounts.no_listings_owned": "Nessuna inserzione",
    "No listings yet": "Nessuna inserzione",
    "accounts.page_analytics": "Analisi pagina",
    "Page Analytics": "Analisi pagina",
    "accounts.analytics_key_missing": "La chiave API Analytics non è configurata per questo tenant.",
    "Analytics API key not configured for this tenant.": "La chiave API Analytics non è configurata per questo tenant.",
    "accounts.storefront_url_missing": "L’URL del negozio non è disponibile per questo account.",
    "No storefront URL available for this account.": "L’URL del negozio non è disponibile per questo account.",
    "accounts.no_analytics_loaded": "Nessuna analisi ancora caricata.",
    "No analytics loaded yet.": "Nessuna analisi ancora caricata.",
    "accounts.load_analytics": "Carica analisi",
    "Load Analytics": "Carica analisi",
    "accounts.attributes": "Attributi",
    "accounts.shipping": "Spedizione",
    "accounts.commission": "Commissione",
    "Commission": "Commissione",
    "accounts.detail_title": "Titolo",
    "accounts.detail_description": "Descrizione",
    "accounts.detail_descriptions": "Descrizioni",
    "Descriptions": "Descrizioni",
    "accounts.detail_listings": "Inserzioni",
    "accounts.detail_categories": "Categorie",
    "accounts.detail_location": "Posizione",
    "accounts.detail_account_status": "Stato account",
    "accounts.detail_status": "Stato",
    "accounts.detail_shipping_method": "Metodo di spedizione",
    "accounts.detail_shipping_methods": "Metodi di spedizione",
    "Shipping Methods": "Metodi di spedizione",
    "accounts.detail_account_user": "Utente account",
    "Account User": "Utente account",
    "accounts.detail_pending": "In attesa",
    "accounts.detail_approved": "Approvato",
    "accounts.detail_rejected": "Rifiutato",
    "accounts.detail_active": "Attivo",
    "accounts.detail_inactive": "Inattivo",
    "accounts.detail_joined": "Iscritto il",
    "Joined": "Iscritto il",
    "accounts.detail_account_age": "Età account",
    "Account Age": "Età account",
    "accounts.detail_less_than_a_month": "Meno di un mese",
    "Less than a month": "Meno di un mese",
    "accounts.detail_page_views": "Visualizzazioni pagina",
    "Page Views": "Visualizzazioni pagina",
    "accounts.detail_unique_visitors": "Visitatori unici",
    "Unique Visitors": "Visitatori unici",
    "accounts.detail_sessions": "Sessioni",
    "Sessions": "Sessioni",
    "accounts.detail_clicks": "Clic",
    "Clicks": "Clic",
    "accounts.detail_goals": "Obiettivi",
    "Goals": "Obiettivi",
    "accounts.detail_bot_views": "Visualizzazioni bot",
    "Bot Views": "Visualizzazioni bot",
    "accounts.detail_followers": "Follower",
    "Followers": "Follower",
    "accounts.detail_total_orders": "Ordini totali",
    "accounts.detail_revenue": "Ricavi",
    "accounts.detail_avg_order": "Ordine medio",
    "Avg Order": "Ordine medio",
    "accounts.detail_paid_orders": "Ordini pagati",
    "Paid Orders": "Ordini pagati",
    "accounts.detail_owner": "Proprietario",
    "Owner": "Proprietario",
    "accounts.detail_account_id": "ID account",
    "accounts.detail_category": "Categoria",
    "accounts.detail_profile_completeness": "Completezza profilo",
    "Profile Completeness": "Completezza profilo",
    "accounts.detail_total_listings": "Inserzioni totali",
    "Total Listings": "Inserzioni totali",
    "accounts.detail_loaded_listings": "Inserzioni caricate",
    "Loaded Listings": "Inserzioni caricate",
    "accounts.detail_active_listings": "Inserzioni attive",
    "Active Listings": "Inserzioni attive",
    "accounts.detail_last_updated": "Ultimo aggiornamento",
    "Last Updated": "Ultimo aggiornamento",
    "accounts.detail_last_activity": "Ultima attività",
    "Last Activity": "Ultima attività",
    "accounts.detail_verification": "Verifica",
    "Verification": "Verifica",
    "accounts.detail_subscription": "Abbonamento",
    "accounts.detail_attributes": "Attributi",
    "accounts.detail_shipping_charge_split": "Ripartizione spese di spedizione",
    "Shipping Charge Split": "Ripartizione spese di spedizione",
    "accounts.detail_value_type": "Tipo di valore",
    "Value Type": "Tipo di valore",
    "accounts.detail_value": "Valore",
    "accounts.detail_enter_value": "Inserisci valore",
    "accounts.detail_commission_percentage": "Percentuale commissione",
    "Commission Percentage": "Percentuale commissione",
    "accounts.detail_commission_percent": "Percentuale commissione",
    "Commission Percent": "Percentuale commissione",
    "accounts.detail_share": "Quota",
    "accounts.detail_view_account": "Visualizza account",
    "View Account": "Visualizza account",
    "accounts.detail_add_listing": "Aggiungi inserzione",
    "accounts.detail_edit_account": "Modifica account",
    "Edit Account": "Modifica account",
    "accounts.no_attribute_values": "Nessun valore per l’attributo {name}",
    "accounts.no_attributes_yet": "Nessun attributo",
    "No attributes yet": "Nessun attributo",
    "accounts.edit_account": "Modifica account",
    "accounts.detail_preview": "Anteprima",
    "accounts.detail_fixed": "Fisso",
    "Fixed": "Fisso",
    "accounts.detail_percentage": "Percentuale",
    "Percentage": "Percentuale",
    "accounts.detail_select_value_type": "Seleziona tipo valore",
    "Select Value Type": "Seleziona tipo valore",
    "accounts.detail_approve": "Approva",
    "accounts.detail_reject": "Rifiuta",
    "accounts.detail_section": "Dettagli",
    "Details": "Dettagli",
    "category.add_child": "Aggiungi sottocategoria",
    "Add Child Category": "Aggiungi sottocategoria",
    "category.add_listing": "Aggiungi inserzione",
    "category.manage": "Gestisci categorie",
    "Manage Categories": "Gestisci categorie",
    "category.account_overview_eyebrow": "PANORAMICA CATEGORIA ACCOUNT",
    "ACCOUNT CATEGORY OVERVIEW": "PANORAMICA CATEGORIA ACCOUNT",
    "category.overview_eyebrow": "PANORAMICA CATEGORIA",
    "CATEGORY OVERVIEW": "PANORAMICA CATEGORIA",
    "category.category": "Categoria",
    "category.active": "Attiva",
    "category.inactive": "Inattiva",
    "category.accounts": "Account",
    "category.listings": "Inserzioni",
    "category.child_categories": "Sottocategorie",
    "Child Categories": "Sottocategorie",
    "category.attributes": "Attributi",
    "category.category_age": "Età categoria",
    "Category age": "Età categoria",
    "category.category_overview": "Panoramica categoria",
    "Category Overview": "Panoramica categoria",
    "category.category_id": "ID categoria",
    "category.name": "Nome",
    "category.slug": "Slug",
    "category.description": "Descrizione",
    "category.parent_category": "Categoria principale",
    "Parent Category": "Categoria principale",
    "category.hierarchy": "Gerarchia",
    "Hierarchy": "Gerarchia",
    "category.status": "Stato",
    "category.display_order": "Ordine di visualizzazione",
    "Display Order": "Ordine di visualizzazione",
    "category.created": "Iscritto / creato",
    "Joined / Created": "Iscritto / creato",
    "category.configured": "Configurato",
    "Configured": "Configurato",
    "category.no_attributes": "Nessun attributo assegnato.",
    "No attributes assigned.": "Nessun attributo assegnato.",
    "category.no_child_categories": "Nessuna sottocategoria.",
    "No child categories.": "Nessuna sottocategoria.",
    "category.no_accounts": "Nessun account in questa categoria.",
    "No accounts in this category.": "Nessun account in questa categoria.",
    "category.no_listings": "Nessuna inserzione in questa categoria.",
    "No listings in this category.": "Nessuna inserzione in questa categoria.",
    "category.detail_title": "Dettagli categoria",
    "Category Detail": "Dettagli categoria",
    "category.age_less_month": "Meno di un mese",
    "category.age_month": "{count} mese",
    "{count} month": "{count} mese",
    "category.age_months": "{count} mesi",
    "{count} months": "{count} mesi",
    "category.age_year": "{count} anno",
    "{count} year": "{count} anno",
    "category.age_years": "{count} anni",
    "{count} years": "{count} anni",
    "category.header_name": "Nome",
    "category.header_category_id": "ID categoria",
    "category.header_image": "Immagine",
    "category.header_order": "Ordine",
    "category.header_parent": "Principale",
    "Parent": "Principale",
    "category.header_active": "Attiva",
    "category.header_action": "Azione",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Categorie",
    "category.translate": "Traduci",
    "category.import": "Importa",
    "category.export": "Esporta",
    "category.add_category": "Aggiungi categoria",
    "Add Category": "Aggiungi categoria",
    "category.import_categories": "Importa categorie",
    "Import Categories": "Importa categorie",
    "category.delete_warning": "Le inserzioni esistenti non si apriranno sul sito o nell’app e verrà mostrato un errore.",
    "Existing listings will not open in website or app, you will see an error.": "Le inserzioni esistenti non si apriranno sul sito o nell’app e verrà mostrato un errore.",
    "category.editor_edit_category": "Modifica categoria",
    "Edit Category": "Modifica categoria",
    "category.editor_add_category": "Aggiungi categoria",
    "category.editor_save": "Salva",
    "category.editor_select_category_level": "Seleziona livello categoria",
    "Select Category Level": "Seleziona livello categoria",
    "category.editor_parent_category": "Categoria principale",
    "category.editor_select": "Seleziona",
    "category.editor_category_name": "Nome categoria",
    "Category Name": "Nome categoria",
    "category.editor_enter_category_name": "Inserisci il nome della categoria",
    "Enter category name": "Inserisci il nome della categoria",
    "category.editor_slug": "Slug",
    "category.editor_enter_slug": "Inserisci lo slug",
    "Enter slug": "Inserisci lo slug",
    "category.editor_category_description": "Descrizione categoria",
    "Category Description": "Descrizione categoria",
    "category.editor_order": "Ordine",
    "category.editor_enter_order": "Inserisci l’ordine",
    "category.editor_status_not_active_active": "Stato (inattivo / attivo)",
    "category.editor_upload_media": "Carica contenuto",
    "category.editor_meta_title": "Meta titolo",
    "category.editor_enter_meta_title": "Inserisci il meta titolo",
    "Enter meta title": "Inserisci il meta titolo",
    "category.editor_meta_description": "Meta descrizione",
    "category.editor_category": "Categoria",
    "category.editor_name": "Nome",
    "category.editor_status": "Stato",
    "category.editor_action": "Azione",
    "category.editor_add_attribute": "Aggiungi attributo",
    "Add Attribute": "Aggiungi attributo",
    "category.editor_attributes_list": "Elenco attributi",
    "Attributes List": "Elenco attributi",
    "category.editor_please_enter_a_category_name_first": "Inserisci prima il nome della categoria",
    "Please enter a category name first": "Inserisci prima il nome della categoria",
    "category.editor_successfully_added_category": "Categoria aggiunta correttamente",
    "Successfully added category": "Categoria aggiunta correttamente",
    "category.deleted": "Categoria eliminata",
    "Category deleted": "Categoria eliminata",
    "attributes.title": "Attributi",
    "attributes.cart_checkout": "Carrello e checkout",
    "Cart & Checkout": "Carrello e checkout",
    "attributes.cart_settings": "Impostazioni carrello",
    "Cart settings": "Impostazioni carrello",
    "attributes.order_status_notifications": "Notifiche stato ordine",
    "Order status notifications": "Notifiche stato ordine",
    "attributes.groups": "Gruppi attributi",
    "Attribute Groups": "Gruppi attributi",
    "attributes.add_attribute": "Aggiungi attributo",
    "attributes.edit_bulk": "Modifica multipla",
    "Edit Bulk": "Modifica multipla",
    "attributes.confirm_delete": "Vuoi eliminare questo attributo?",
    "Do you want to delete this attribute?": "Vuoi eliminare questo attributo?",
    "attributes.header_attribute_name": "Nome attributo",
    "Attribute Name": "Nome attributo",
    "attributes.header_action": "Azione",
    "attributes.header_manage_attribute_values": "Gestisci valori attributo",
    "Manage Attribute Values": "Gestisci valori attributo",
    "attributes.header_type": "Tipo",
    "attributes.header_optional": "Facoltativo",
    "attributes.header_icon": "Icona",
    "Icon": "Icona",
    "attributes.header_categories": "Categorie",
    "attributes.header_hidden_field": "Campo nascosto",
    "Hidden Field": "Campo nascosto",
    "attributes.header_values": "Valori",
    "Values": "Valori",
    "attributes.header_status": "Stato",
    "attributes.type_single_select": "Selezione singola",
    "Single Select": "Selezione singola",
    "attributes.type_multi_select": "Selezione multipla",
    "Multi Select": "Selezione multipla",
    "attributes.type_open_single_value": "Testo libero (valore singolo)",
    "Open (Single Value)": "Testo libero (valore singolo)",
    "attributes.type_open_multiple_value": "Testo libero (valori multipli)",
    "Open (Multiple Value)": "Testo libero (valori multipli)",
    "attributes.type_attachment": "Allegato",
    "Attachment": "Allegato",
    "attributes.type_text_area": "Area di testo",
    "Text Area": "Area di testo",
    "attributes.type_date_time": "Data e ora",
    "Date Time": "Data e ora",
    "attributes.type_number": "Numero",
    "attributes.type_boolean": "Booleano",
    "Boolean": "Booleano",
    "attributes.type_color": "Colore",
    "Color": "Colore",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "Posizione",
    "attributes.type_audio": "Audio",
    "Audio": "Audio",
    "attributes.type_video": "Video",
    "Video": "Video",
    "attributes.type_open_multi_value": "Testo libero (valori multipli)",
    "Open (Multi Value)": "Testo libero (valori multipli)",
    "attributes.editor_edit_attribute": "Modifica attributo",
    "Edit Attribute": "Modifica attributo",
    "attributes.editor_add_attribute": "Aggiungi attributo",
    "attributes.editor_attribute_name": "Nome attributo",
    "attributes.editor_select_type": "Seleziona tipo",
    "attributes.prefill_user": "Utente",
    "common.search_placeholder": "Digita per cercare…",
    "attributes.prefill_accounts": "Account",
    "attributes.prefill_listings": "Inserzioni",
    "listings.detail_nav_gallery": "Galleria",
    "Gallery": "Galleria",
    "listings.detail_nav_details": "Dettagli",
    "listings.detail_nav_inventory": "Magazzino",
    "listings.detail_nav_social": "Social",
    "Social": "Social",
    "listings.detail_nav_orders": "Ordini",
    "listings.detail_nav_analytics": "Analisi",
    "listings.detail_nav_schedule": "Agenda",
    "listings.detail_nav_rental": "Noleggio",
    "Rental": "Noleggio",
    "listings.detail_nav_attributes": "Attributi",
    "listings.detail_nav_seller": "Venditore",
    "attributes.editor_icon": "Icona",
    "attributes.editor_tool_tip": "Suggerimento",
    "Tool tip": "Suggerimento",
    "attributes.editor_enter_attribute_name": "Inserisci il nome dell’attributo",
    "Enter attribute name": "Inserisci il nome dell’attributo",
    "attributes.editor_enter_attribute_tool_tip": "Inserisci il testo del suggerimento",
    "Enter attribute tool tip": "Inserisci il testo del suggerimento",
    "attributes.editor_optional": "Facoltativo",
    "attributes.editor_private": "Privato",
    "Private": "Privato",
    "attributes.editor_hidden_field": "Campo nascosto",
    "Hidden field": "Campo nascosto",
    "attributes.editor_show_in_filter": "Mostra nel filtro",
    "Show in filter": "Mostra nel filtro",
    "attributes.editor_status_not_active_active": "Stato (inattivo / attivo)",
    "attributes.editor_add_meta_data": "Aggiungi metadati",
    "Add meta data": "Aggiungi metadati",
    "attributes.editor_select": "Seleziona",
    "attributes.editor_select_category": "Seleziona categoria",
    "Select category": "Seleziona categoria",
    "attributes.editor_select_all": "Seleziona tutto",
    "Select All": "Seleziona tutto",
    "attributes.editor_unselect_all": "Deseleziona tutto",
    "UnSelect All": "Deseleziona tutto",
    "attributes.editor_create_categories_in_this_configuration_first": "Crea prima le categorie in questa configurazione",
    "Create categories in this configuration first": "Crea prima le categorie in questa configurazione",
    "attributes.editor_please_enter_attribute_name": "Inserisci il nome dell’attributo",
    "Please enter attribute name": "Inserisci il nome dell’attributo",
    "attributes.editor_please_select_type": "Seleziona un tipo",
    "Please select type": "Seleziona un tipo",
    "attributes.editor_select_single_attribute_values": "Seleziona i valori singoli dell’attributo",
    "attributes.editor_select_multiple_attribute_values": "Seleziona più valori dell’attributo",
    "attributes.editor_enter_value": "Inserisci valore",
    "attributes.editor_enter_multiple_tag": "Inserisci più tag",
    "Enter Multiple Tag": "Inserisci più tag",
    "attributes.editor_upload_file": "Carica file",
    "Upload file": "Carica file",
    "attributes.editor_enter_text": "Inserisci testo",
    "attributes.editor_select_date": "Seleziona data",
    "attributes.editor_enter_number": "Inserisci un numero",
    "Enter Number": "Inserisci un numero",
    "attributes.editor_select_color": "Seleziona colore",
    "attributes.editor_upload_json": "Carica JSON",
    "Upload Json": "Carica JSON",
    "attributes.editor_select_location": "Seleziona posizione",
    "attributes.editor_category": "Categoria",
    "attributes.editor_price": "Prezzo",
    "attributes.editor_enter_price": "Inserisci il prezzo",
    "Enter Price": "Inserisci il prezzo",
    "attributes.editor_preview": "Anteprima",
    "attributes.editor_title": "Titolo",
    "attributes.editor_enter_title": "Inserisci il titolo",
    "Enter Title": "Inserisci il titolo",
    "attributes.editor_description": "Descrizione",
    "attributes.editor_add_listing": "Aggiungi inserzione",
    "attributes.editor_add_account": "Aggiungi account",
    "Add Account": "Aggiungi account",
    "attributes.editor_successfully_added_attributes": "Attributi aggiunti correttamente",
    "Successfully added attributes": "Attributi aggiunti correttamente",
    "attributes.editor_add_attribute_values": "Aggiungi valori attributo",
    "Add Attribute Values": "Aggiungi valori attributo",
    "common.image": "Immagine",
    "common.please_wait": "Attendi…",
    "attribute_groups.title": "Gruppi attributi",
    "attribute_groups.title_singular": "Gruppo attributi",
    "Attribute Group": "Gruppo attributi",
    "attribute_groups.add": "Aggiungi gruppo attributi",
    "Add Attribute Group": "Aggiungi gruppo attributi",
    "attribute_groups.image_path": "Percorso immagine",
    "Image Path": "Percorso immagine",
    "attribute_groups.name_placeholder": "Nome gruppo",
    "Group Name": "Nome gruppo",
    "attribute_groups.select_attributes": "Seleziona attributi",
    "Select Attributes": "Seleziona attributi",
    "attribute_groups.select_attributes_placeholder": "Seleziona attributi…",
    "Select Attributes...": "Seleziona attributi…",
    "attribute_groups.added_successfully": "Gruppo attributi aggiunto",
    "Attribute Group Added Successfully": "Gruppo attributi aggiunto",
    "attribute_groups.deleted_successfully": "Eliminato correttamente",
    "Deleted successfully": "Eliminato correttamente",
    "attribute_groups.name_required": "Il nome è obbligatorio",
    "attribute_groups.save_attributes_failed": "Il gruppo è stato salvato, ma non è stato possibile assegnargli gli attributi.",
    "The group was saved, but its attributes could not be assigned.": "Il gruppo è stato salvato, ma non è stato possibile assegnargli gli attributi.",
    "attributes.editor_enter_description": "Inserisci descrizione",
    "account_config.title": "Configurazione account",
    "account_config.account_detail_note": "Nota dettagli account",
    "Account detail note": "Nota dettagli account",
    "account_config.enter_account_detail_note": "Inserisci una nota per i dettagli dell’account",
    "Enter account detail note": "Inserisci una nota per i dettagli dell’account",
    "account_config.address_label": "Etichetta indirizzo",
    "account_config.enter_address_label": "Inserisci l’etichetta dell’indirizzo",
    "Enter address label": "Inserisci l’etichetta dell’indirizzo",
    "account_config.category_label": "Etichetta categoria",
    "Category label": "Etichetta categoria",
    "account_config.enter_category_label": "Inserisci l’etichetta della categoria",
    "Enter category label": "Inserisci l’etichetta della categoria",
    "account_config.nearby_accounts_radius_km": "Raggio account vicini (km)",
    "Nearby accounts radius (km)": "Raggio account vicini (km)",
    "account_config.nearby_accounts_radius_placeholder": "Raggio account nelle vicinanze in km",
    "Account nearby radius in km": "Raggio account nelle vicinanze in km",
    "account_config.account_limit": "Limite account",
    "Account Limit": "Limite account",
    "account_config.account_limit_placeholder": "Limite account",
    "Account limit": "Limite account",
    "account_config.shipping_preference_note": "Nota sulle preferenze di spedizione",
    "Shipping method preference note": "Nota sulle preferenze di spedizione",
    "account_config.option_accounts_auto_approved": "Account approvati automaticamente",
    "Accounts auto approved": "Account approvati automaticamente",
    "account_config.option_shipping_methods_preference_for_accounts": "Preferenze di spedizione degli account",
    "Shipping methods preference for accounts": "Preferenze di spedizione degli account",
    "account_config.option_account_map_location_selector": "Selettore posizione account sulla mappa",
    "Account map location selector": "Selettore posizione account sulla mappa",
    "account_config.option_account_geo_location": "Geolocalizzazione account",
    "Account Geo Location": "Geolocalizzazione account",
    "account_config.option_slug": "Slug",
    "account_config.option_show_description": "Mostra descrizione",
    "Show Description": "Mostra descrizione",
    "account_config.option_formatted_text_description": "Descrizione con testo formattato",
    "Formatted Text Description": "Descrizione con testo formattato",
    "account_config.option_hide_address_from_account_detail": "Nascondi indirizzo dai dettagli account",
    "Hide Address from Account Detail": "Nascondi indirizzo dai dettagli account",
    "account_config.option_get_account_pickup_address_always": "Richiedi sempre l’indirizzo di ritiro dell’account",
    "Get Account Pickup Address Always": "Richiedi sempre l’indirizzo di ritiro dell’account",
    "account_config.option_get_pickup_address_for_delivery": "Richiedi indirizzo di ritiro per la consegna",
    "Get Pickup Address for Delivery": "Richiedi indirizzo di ritiro per la consegna",
    "account_config.uploaded_successfully": "Caricato correttamente",
    "app_customization.realtime_config_notice": "Queste configurazioni si applicano in tempo reale. Dopo il salvataggio saranno visibili nelle app e nelle risposte API.",
    "app_customization.release_config_notice": "Nota per le app mobili: queste configurazioni si applicano solo al rilascio o all’aggiornamento del prodotto, non in tempo reale. Per una nuova build, invia una richiesta dal Portale di supporto. (Piano Starter)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Nota per le app mobili: queste configurazioni si applicano solo al rilascio o all’aggiornamento del prodotto, non in tempo reale. Per una nuova build, invia una richiesta dal Portale di supporto. (Piano Starter)",
    "category.translation_title": "Traduci categoria",
    "Translate Category": "Traduci categoria",
    "category.translation_category_name": "Nome categoria",
    "category.translation_description": "Descrizione",
    "listing_configs.title": "Configurazione inserzioni",
    "Listing Configuration": "Configurazione inserzioni",
    "listing_configs.rules": "REGOLE (livello progetto/tenant)",
    "RULES (Projects/Tenant level)": "REGOLE (livello progetto/tenant)",
    "listing_configs.features": "FUNZIONALITÀ (solo app mobile)",
    "FEATURES (Only for mobile app)": "FUNZIONALITÀ (solo app mobile)",
    "listing_configs.ui_customisation": "Personalizzazione UI",
    "UI Customisation": "Personalizzazione UI",
    "listing_configs.overridden_max_quantity": "Quantità massima per inserzione",
    "listing_configs.overridden_max_quantity_example": "(Ad esempio: 100)",
    "listing_configs.listing_min_price": "Prezzo minimo inserzione",
    "listing_configs.listing_min_price_example": "(Ad esempio: 5 $)",
    "listing_configs.auto_approval": "Approvare automaticamente le inserzioni?",
    "listing_configs.listing_pictures_count": "Numero di immagini caricabili",
    "Number of uploadable pictures count": "Numero di immagini caricabili",
    "listing_configs.seller_can_place_order": "Il venditore può effettuare un ordine",
    "Seller can place order": "Il venditore può effettuare un ordine",
    "listing_configs.hide_offer_percent": "Percentuale offerta",
    "Offer percent": "Percentuale offerta",
    "listing_configs.show_max_quantity": "Limiti quantità per inserzione",
    "listing_configs.show_shipping_charges": "Costi di spedizione",
    "listing_configs.listing_address_label": "Etichetta indirizzo inserzione",
    "listing_configs.listing_address_label_example": "(Ad esempio: punto di riferimento)",
    "listing_configs.listing_map_location_selector_enabled": "Usa il segnaposto sulla mappa invece di cercare l’indirizzo",
    "Use map marker instead of searching address": "Usa il segnaposto sulla mappa invece di cercare l’indirizzo",
    "listing_configs.listing_hide_tags": "Tag",
    "Tags": "Tag",
    "listing_configs.enable_stock": "Scorte",
    "Stocks": "Scorte",
    "listing_configs.listing_address_enabled": "Indirizzo geografico",
    "Geo address": "Indirizzo geografico",
    "listing_configs.show_stock_out_listings": "Mostra nel feed le inserzioni esaurite",
    "listing_configs.enable_slug": "Slug titolo inserzione",
    "listing_configs.show_variants": "Varianti",
    "Variants": "Varianti",
    "listing_configs.meta_title": "Meta titolo",
    "listing_configs.meta_description": "Meta descrizione",
    "listing_configs.listing_enable_formatted_text_description": "Abilita editor di testo",
    "listing_configs.listing_enable_weight": "Abilita peso",
    "Enable Weight": "Abilita peso",
    "listing_configs.listing_enable_dimensions": "Abilita dimensioni",
    "Enable Dimensions": "Abilita dimensioni",
    "listing_configs.enable_stocks_listing_schedules": "Programmazione scorte",
    "Stock Schedules": "Programmazione scorte",
    "listing_variants.title": "Tipi di variante",
    "listing_variants.add_type": "Aggiungi tipo di variante",
    "Add Variant Type": "Aggiungi tipo di variante",
    "listing_variants.edit_type": "Modifica tipo di variante",
    "Edit Variant Type": "Modifica tipo di variante",
    "listing_variants.name": "Nome",
    "listing_variants.values": "Valori",
    "listing_variants.status": "Stato",
    "listing_variants.action": "Azione",
    "listing_variants.add_value": "Aggiungi valore",
    "Add Value": "Aggiungi valore",
    "listing_variants.active": "Attivo",
    "listing_variants.inactive": "Inattivo",
    "listing_variants.details": "Dettagli",
    "listing_variants.translate": "Traduci",
    "listing_variants.delete_confirm": "Vuoi eliminare questo tipo di variante?",
    "Do you want to delete this variant type?": "Vuoi eliminare questo tipo di variante?",
    "listing_variants.add_value_first": "Aggiungi un valore prima di visualizzare le varianti.",
    "Add a value before viewing variants.": "Aggiungi un valore prima di visualizzare le varianti.",
    "listing_variants.enter_name": "Inserisci nome",
    "listing_variants.status_hint": "Stato (inattivo / attivo)",
    "listing_variants.total_values": "Valori totali",
    "Total Values": "Valori totali",
    "listing_variants.type_id": "ID tipo",
    "Type ID": "ID tipo",
    "listing_variants.total_count": "Totale {count}",
    "{count} total": "Totale {count}",
    "listing_variants.loading": "Caricamento…",
    "listing_variants.loading_values": "Caricamento valori…",
    "Loading values…": "Caricamento valori…",
    "listing_variants.no_values": "Nessun valore",
    "No values yet": "Nessun valore",
    "listing_variants.add_first_value": "Aggiungi il primo valore",
    "Add First Value": "Aggiungi il primo valore",
    "listing_variants.actions": "Azioni",
    "listing_variants.edit": "Modifica",
    "listing_variants.delete": "Elimina",
    "listing_variants.edit_value": "Modifica valore",
    "Edit Value": "Modifica valore",
    "listing_variants.value_name_required": "Nome valore *",
    "Value Name *": "Nome valore *",
    "listing_variants.value_examples": "ad es. Rosso, XL, Cotone…",
    "e.g. Red, XL, Cotton…": "ad es. Rosso, XL, Cotone…",
    "listing_variants.saving": "Salvataggio…",
    "listing_variants.save_changes": "Salva modifiche",
    "Save Changes": "Salva modifiche",
    "listing_variants.delete_value_confirm": "Vuoi eliminare questo valore della variante?",
    "Do you want to delete this variant value?": "Vuoi eliminare questo valore della variante?",
    "listing_variants.clear_all": "Cancella tutto",
    "listing_variants.multiple_values_help": "Aggiungi valori separati da virgole o incolla una colonna da Excel.",
    "You can add comma-separated values or paste a column from Excel.": "Aggiungi valori separati da virgole o incolla una colonna da Excel.",
    "listing_variants.save": "Salva",
    "listing_variants.close": "Chiudi",
    "listing_variants.update": "Aggiorna",
    "listing_variants.default_text": "Testo predefinito",
    "listing_variants.enter_value": "Inserisci il valore della variante",
    "Enter variant value": "Inserisci il valore della variante",
    "listing_variants.add_values": "Aggiungi valori",
    "Add Values": "Aggiungi valori",
    "listing_variants.add_variant_values": "Aggiungi valori del tipo di variante",
    "Add Variant Type Values": "Aggiungi valori del tipo di variante",
    "listing_variants.values_list": "Elenco valori del tipo di variante",
    "Variant Type Values List": "Elenco valori del tipo di variante",
    "listing_variants.cancel_editing": "Annulla modifica",
    "Cancel Editing": "Annulla modifica",
    "listing_variants.value_name": "Valore tipo variante",
    "Variant Type Value": "Valore tipo variante",
    "common.default_text": "Testo predefinito",
    "common.translation_heading": "Traduzioni di {title}",
    "{title} Translations": "Traduzioni di {title}",
    "attributes.value_delete_confirm": "Vuoi eliminare questo valore dell’attributo?",
    "Do you want to delete this attribute value?": "Vuoi eliminare questo valore dell’attributo?",
    "attributes.value_clear_all": "Cancella tutto",
    "attributes.value_multiple_help": "Aggiungi valori separati da virgole o incolla una colonna da Excel.",
    "Add comma-separated values or paste a column from Excel.": "Aggiungi valori separati da virgole o incolla una colonna da Excel.",
    "attributes.value_active": "Attivo",
    "attributes.value_inactive": "Inattivo",
    "attributes.value_save": "Salva",
    "attributes.value_close": "Chiudi",
    "attributes.value_translate": "Traduci",
    "attributes.value_update": "Aggiorna",
    "attributes.value_sort_alpha": "Ordina alfabeticamente",
    "Sort Alphabetically": "Ordina alfabeticamente",
    "attributes.value_default_text": "Testo predefinito",
    "attributes.value_add_metadata": "Aggiungi metadati",
    "Add Metadata": "Aggiungi metadati",
    "attributes.value_cancel_edit": "Annulla modifica",
    "attributes.value_success_help": "Ottimo. Ora trovi questo attributo personalizzato nella pagina Aggiungi inserzione.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Ottimo. Ora trovi questo attributo personalizzato nella pagina Aggiungi inserzione.",
    "attributes.value_add": "Aggiungi valori attributo",
    "attributes.value_add_listing": "Aggiungi valori attributo inserzione",
    "Add Listing Attribute Values": "Aggiungi valori attributo inserzione",
    "attributes.value_metadata_for": "Metadati per",
    "Metadata for": "Metadati per",
    "attributes.value_enter": "Inserisci il valore dell’attributo",
    "Enter attribute value": "Inserisci il valore dell’attributo",
    "attributes.value_add_values": "Aggiungi valori",
    "attributes.value_status_hint": "Stato (inattivo / attivo)",
    "attributes.value_list": "Elenco valori attributo",
    "Attribute Values List": "Elenco valori attributo",
    "attributes.value_table_name": "Valore attributo",
    "Attribute Value": "Valore attributo",
    "attributes.value_table_status": "Stato",
    "attributes.value_table_action": "Azione",
    "attributes.metadata_key": "Chiave",
    "Key": "Chiave",
    "attributes.metadata_value": "Valore",
    "attributes.metadata_add_row": "Aggiungi riga",
    "Add Row": "Aggiungi riga",
    "workspace.countries": "Paesi",
    "workspace.country_add": "Aggiungi paese",
    "Add Country": "Aggiungi paese",
    "workspace.country_edit": "Modifica paese",
    "Edit Country": "Modifica paese",
    "workspace.country_name": "Nome paese",
    "Country Name": "Nome paese",
    "workspace.select_country": "Seleziona paese",
    "Select country": "Seleziona paese",
    "workspace.country_order": "Ordine",
    "workspace.country_order_placeholder": "Inserisci l’ordine",
    "workspace.country_status": "Stato (inattivo / attivo)",
    "workspace.country_default": "Predefinito",
    "workspace.country_active": "Attivo",
    "workspace.country_inactive": "Inattivo",
    "workspace.country_delete_confirm": "Vuoi eliminare questo paese?",
    "Do you want to delete this country?": "Vuoi eliminare questo paese?",
    "workspace.country_table_name": "Nome",
    "workspace.country_table_default": "Predefinito",
    "workspace.country_table_order": "Ordine",
    "workspace.country_table_status": "Stato",
    "workspace.country_table_action": "Azione",
    "workspace.languages": "Lingue",
    "workspace.language_add": "Aggiungi lingua",
    "Add Language": "Aggiungi lingua",
    "workspace.language_edit": "Modifica lingua",
    "Edit Language": "Modifica lingua",
    "workspace.language_name": "Lingua",
    "workspace.language_select": "Seleziona lingua",
    "Select Language": "Seleziona lingua",
    "workspace.language_order": "Ordine",
    "workspace.language_order_placeholder": "Inserisci l’ordine",
    "workspace.language_status": "Stato",
    "workspace.language_default": "Predefinita",
    "workspace.language_default_warning": "Cambiare la lingua predefinita modifica la lingua dell’app.",
    "Changing the default language changes the app language setting.": "Cambiare la lingua predefinita modifica la lingua dell’app.",
    "workspace.language_active": "Attiva",
    "workspace.language_inactive": "Inattiva",
    "workspace.language_delete_confirm": "Vuoi eliminare questa lingua?",
    "Do you want to delete this language?": "Vuoi eliminare questa lingua?",
    "workspace.language_table_name": "Nome",
    "workspace.language_table_default": "Predefinita",
    "workspace.language_table_order": "Ordine",
    "workspace.language_table_status": "Stato",
    "workspace.language_table_action": "Azione",
    "workspace.language_add_photo": "Aggiungi foto",
    "Add Photo": "Aggiungi foto",
    "workspace.currency": "Valuta",
    "workspace.currency_add": "Aggiungi valuta",
    "Add Currency": "Aggiungi valuta",
    "workspace.currency_edit": "Modifica valuta",
    "Edit Currency": "Modifica valuta",
    "workspace.currency_delete_confirm": "Vuoi eliminare questa valuta?",
    "Do you want to delete this currency?": "Vuoi eliminare questa valuta?",
    "workspace.currency_show": "Mostra",
    "workspace.currency_entries": "voci",
    "entries": "voci",
    "workspace.currency_search": "Cerca:",
    "Search:": "Cerca:",
    "workspace.currency_search_placeholder": "Cerca valute",
    "Search currencies": "Cerca valute",
    "workspace.currency_empty": "Nessuna valuta trovata.",
    "No currencies found.": "Nessuna valuta trovata.",
    "workspace.currency_active": "Attiva",
    "workspace.currency_inactive": "Inattiva",
    "workspace.currency_name": "Nome",
    "workspace.currency_name_placeholder": "Nome valuta",
    "Currency Name": "Nome valuta",
    "workspace.currency_upload_media": "Carica contenuto",
    "workspace.currency_select_media": "Seleziona dai contenuti",
    "workspace.currency_no_media": "Non hai contenuti multimediali.",
    "workspace.currency_code": "Codice",
    "workspace.currency_select_code": "Seleziona",
    "workspace.currency_exchange_rate": "Tasso di cambio",
    "Exchange Rate": "Tasso di cambio",
    "workspace.currency_precision": "Precisione",
    "Precision": "Precisione",
    "workspace.currency_thousand_separator": "Separatore delle migliaia",
    "Thousand Separator": "Separatore delle migliaia",
    "workspace.currency_decimal_point": "Separatore decimale",
    "Decimal Point": "Separatore decimale",
    "workspace.currency_status_hint": "Stato (inattivo / attivo)",
    "workspace.currency_default": "Predefinita",
    "workspace.currency_format": "Formato",
    "Format": "Formato",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Nome",
    "workspace.currency_table_code": "Codice",
    "workspace.currency_table_format": "Formato",
    "workspace.currency_table_exchange": "Cambio",
    "Exchange": "Cambio",
    "workspace.currency_table_status": "Stato",
    "workspace.currency_table_default": "Predefinita",
    "workspace.currency_table_action": "Azione",
    "commissions.title": "Commissioni",
    "commissions.add": "Aggiungi commissione",
    "Add Commission": "Aggiungi commissione",
    "commissions.edit": "Modifica commissione",
    "Edit Commission": "Modifica commissione",
    "commissions.delete_confirm": "Vuoi eliminare questa commissione?",
    "Do you want to delete this commission?": "Vuoi eliminare questa commissione?",
    "commissions.yes": "Sì",
    "commissions.no": "No",
    "commissions.filter_all": "Tutte",
    "commissions.filter_supply": "Offerta",
    "Supply": "Offerta",
    "commissions.filter_demand": "Domanda",
    "Demand": "Domanda",
    "commissions.filter_cart": "Carrello",
    "commissions.table_title": "Titolo",
    "commissions.table_default_value": "Valore predefinito",
    "Default Value": "Valore predefinito",
    "commissions.table_status": "Stato",
    "commissions.table_action": "Azione",
    "commissions.active": "Attiva",
    "commissions.inactive": "Inattiva",
    "commissions.type": "Tipo",
    "commissions.type_supply": "Offerta",
    "commissions.type_demand": "Domanda",
    "commissions.type_cart": "Carrello",
    "commissions.select_category": "Seleziona categoria",
    "Select Category": "Seleziona categoria",
    "commissions.title_label": "Titolo",
    "commissions.enter_title": "Inserisci il titolo",
    "Enter title": "Inserisci il titolo",
    "commissions.description": "Descrizione",
    "commissions.enter_description": "Inserisci descrizione",
    "commissions.default_value_percent": "Valore predefinito (%)",
    "Default value (%)": "Valore predefinito (%)",
    "commissions.short_code": "Codice breve",
    "Short Code": "Codice breve",
    "commissions.short_code_tooltip_title": "Codice breve",
    "Short code": "Codice breve",
    "commissions.short_code_tooltip_description": "Inserisci un codice breve per questa commissione.",
    "Enter a short code for this commission.": "Inserisci un codice breve per questa commissione.",
    "commissions.enter_short_code": "Inserisci il codice breve",
    "Enter short code": "Inserisci il codice breve",
    "commissions.status_hint": "Stato (inattivo / attivo)",
    "commissions.optional": "Facoltativo",
    "commissions.advanced": "Avanzate",
    "Advanced": "Avanzate",
    "commissions.add_by_category": "Aggiungi commissione per categoria",
    "Add commission by category": "Aggiungi commissione per categoria",
    "commissions.select_calculation_type": "Seleziona tipo",
    "commissions.calc_fixed": "Fisso",
    "commissions.calc_slab": "A scaglioni",
    "Slab": "A scaglioni",
    "commissions.value": "Valore",
    "commissions.choose_category": "Scegli categoria",
    "Choose category": "Scegli categoria",
    "commissions.create_categories_first": "Crea prima le categorie nella configurazione inserzioni",
    "Create categories in Listing Configuration first": "Crea prima le categorie nella configurazione inserzioni",
    "commissions.select_type": "Seleziona tipo",
    "commissions.demand_fixed": "Fisso",
    "commissions.demand_percentage": "Percentuale",
    "commissions.unlimited_hint": "* Inserisci -1 per illimitato",
    "* Enter -1 for unlimited": "* Inserisci -1 per illimitato",
    "commissions.from": "Da",
    "commissions.enter_from": "Inserisci valore iniziale",
    "Enter from": "Inserisci valore iniziale",
    "commissions.to": "A",
    "commissions.enter_to": "Inserisci valore finale",
    "Enter to": "Inserisci valore finale",
    "commissions.enter_value": "Inserisci valore",
    "commissions.add_row": "Aggiungi riga",
    "commissions.minimum_amount": "Importo minimo",
    "Minimum amount": "Importo minimo",
    "commissions.enter_minimum_amount": "Inserisci l’importo minimo",
    "Enter minimum amount": "Inserisci l’importo minimo",
    "commissions.maximum_amount": "Importo massimo",
    "Maximum amount": "Importo massimo",
    "commissions.enter_maximum_amount": "Inserisci l’importo massimo",
    "Enter maximum amount": "Inserisci l’importo massimo",
    "commissions.notes": "Note",
    "Notes": "Note",
    "commissions.enter_note": "Inserisci una nota",
    "Enter note": "Inserisci una nota",
    "commissions.from_value": "Valore iniziale",
    "From Value": "Valore iniziale",
    "commissions.to_value": "Valore finale",
    "To Value": "Valore finale",
    "commissions.unlimited_short_hint": "(-1 per illimitato",
    "commissions.value_percent": "Valore (%)",
    "Value (%)": "Valore (%)",
    "commissions.from_value_validation": "Il valore iniziale deve essere maggiore del precedente valore finale",
    "From value should be greater than the previous To value": "Il valore iniziale deve essere maggiore del precedente valore finale",
    "commissions.to_value_validation": "Il valore finale deve essere maggiore di quello iniziale",
    "To value should be greater than From value": "Il valore finale deve essere maggiore di quello iniziale",
    "taxes.title": "Imposta",
    "taxes.title_plural": "Imposte",
    "taxes.add": "Aggiungi imposta",
    "Add Tax": "Aggiungi imposta",
    "taxes.edit": "Modifica imposta",
    "Edit Tax": "Modifica imposta",
    "taxes.delete_confirm": "Vuoi eliminare questa imposta?",
    "Are you sure you want to delete this tax?": "Vuoi eliminare questa imposta?",
    "taxes.table_title": "Titolo",
    "taxes.table_short_code": "Codice breve",
    "taxes.table_default_value": "Valore predefinito",
    "taxes.table_status": "Stato",
    "taxes.table_action": "Azione",
    "taxes.active": "Attiva",
    "taxes.inactive": "Inattiva",
    "taxes.select_type": "Seleziona tipo",
    "taxes.type_order": "Ordine",
    "taxes.type_listing": "Inserzione",
    "taxes.type_tax": "Imposta",
    "taxes.demand_fixed": "Fisso",
    "taxes.demand_percentage": "Percentuale",
    "taxes.from": "Da",
    "taxes.enter_from": "Inserisci valore iniziale",
    "taxes.to": "A",
    "taxes.enter_to": "Inserisci valore finale",
    "taxes.unlimited_hint": "(-1 per illimitato)",
    "taxes.value": "Valore",
    "taxes.enter_value": "Inserisci valore",
    "taxes.add_row": "Aggiungi riga",
    "taxes.note": "Nota",
    "taxes.note_placeholder": "Inserisci una nota visibile agli utenti durante il checkout e nei dettagli dell’ordine.",
    "Enter a note for users to see during checkout and in order details.": "Inserisci una nota visibile agli utenti durante il checkout e nei dettagli dell’ordine.",
    "taxes.inclusive": "Imposta inclusa",
    "Tax Inclusive": "Imposta inclusa",
    "taxes.inclusive_tooltip": "Attiva se il prezzo indicato include già l’imposta.",
    "Enable this when the listed price already includes tax.": "Attiva se il prezzo indicato include già l’imposta.",
    "taxes.title_placeholder": "Inserisci un nome visibile agli utenti durante il checkout e nei dettagli dell’ordine.",
    "Enter a name shown to users at checkout and in order details.": "Inserisci un nome visibile agli utenti durante il checkout e nei dettagli dell’ordine.",
    "taxes.default_value": "Valore predefinito (%)",
    "taxes.default_placeholder": "Valore predefinito in %. Ad esempio: 6,5",
    "Default value in %. Example: 6.5": "Valore predefinito in %. Ad esempio: 6,5",
    "taxes.short_code": "Codice breve",
    "taxes.short_code_tooltip_title": "Codice breve",
    "taxes.short_code_tooltip_description": "Inserisci un codice breve per questa imposta.",
    "Enter a short code for this tax.": "Inserisci un codice breve per questa imposta.",
    "taxes.short_code_placeholder": "Usa lettere e numeri, fino a 10 caratteri. Ad es.: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "Usa lettere e numeri, fino a 10 caratteri. Ad es.: GST10",
    "taxes.status_hint": "Stato (inattivo / attivo)",
    "taxes.advanced": "Avanzate",
    "special_fees.title": "Commissioni speciali",
    "special_fees.description": "Configura una commissione aggiuntiva fissa o percentuale per ogni inserzione.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Configura una commissione aggiuntiva fissa o percentuale per ogni inserzione.",
    "special_fees.fixed": "Commissione speciale fissa",
    "Special fees fixed": "Commissione speciale fissa",
    "special_fees.fixed_placeholder": "Inserisci l’importo (ad esempio: 5)",
    "Enter special fee amount (example: 5)": "Inserisci l’importo (ad esempio: 5)",
    "special_fees.percentage": "Commissione speciale percentuale",
    "Special fees percentage": "Commissione speciale percentuale",
    "special_fees.percentage_placeholder": "Inserisci la percentuale (ad esempio: 10%)",
    "Enter special fee percentage (example: 10%)": "Inserisci la percentuale (ad esempio: 10%)",
    "special_fees.example": "Esempio",
    "Example": "Esempio",
    "special_fees.example_description": "Puoi aggiungere una commissione al prezzo dell’inserzione. Ad esempio, un prodotto costa 100 $ e aggiungi due commissioni.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "Puoi aggiungere una commissione al prezzo dell’inserzione. Ad esempio, un prodotto costa 100 $ e aggiungi due commissioni.",
    "special_fees.example_fixed": "Importo fisso aggiuntivo = 10 $",
    "Additional fixed amount = $10": "Importo fisso aggiuntivo = 10 $",
    "special_fees.example_percentage": "Percentuale aggiuntiva = 10%",
    "Additional fixed percentage = 10%": "Percentuale aggiuntiva = 10%",
    "special_fees.example_total": "Prezzo finale = 120 $",
    "Final price = $120": "Prezzo finale = 120 $",
    "delivery.methods_title": "Metodi di servizio / spedizione",
    "Service / Shipping Methods": "Metodi di servizio / spedizione",
    "delivery.shipping_service": "Spedizione / Servizio",
    "Shipping / Service": "Spedizione / Servizio",
    "delivery.table_name": "Nome",
    "delivery.table_default": "Predefinito",
    "delivery.table_order": "Ordine",
    "delivery.table_status": "Stato",
    "delivery.table_action": "Azione",
    "delivery.yes": "Sì",
    "delivery.no": "No",
    "delivery.active": "Attivo",
    "delivery.inactive": "Inattivo",
    "delivery.delete_confirm": "Vuoi eliminare questo metodo di spedizione?",
    "Do you want to delete this shipping method?": "Vuoi eliminare questo metodo di spedizione?",
    "delivery.schedule_time": "Orario programmato",
    "Schedule Time": "Orario programmato",
    "delivery.translate": "Traduci",
    "delivery.config": "Configurazione",
    "Config": "Configurazione",
    "delivery.add": "Aggiungi spedizione/servizio",
    "Add Shipping/Service": "Aggiungi spedizione/servizio",
    "delivery.save": "Salva",
    "delivery.edit": "Modifica spedizione/servizio",
    "Edit Shipping/Service": "Modifica spedizione/servizio",
    "delivery.stuart_config": "Configurazioni Stuart",
    "Stuart Configs": "Configurazioni Stuart",
    "delivery.shipping_configs": "Configurazioni spedizione / servizio",
    "Service / Shipping Configs": "Configurazioni spedizione / servizio",
    "delivery.settings": "Impostazioni",
    "delivery.preview": "Anteprima",
    "delivery.shipment_option": "Opzione di spedizione",
    "Shipment Option": "Opzione di spedizione",
    "delivery.name": "Nome",
    "delivery.enter_name": "Inserisci nome",
    "delivery.note": "Nota",
    "delivery.enter_note": "Inserisci una nota",
    "delivery.note_tooltip_title": "Nota",
    "delivery.note_tooltip_description": "Aggiungi una nota facoltativa per spiegare questa opzione di spedizione o servizio.",
    "Add an optional note to explain this shipping or service option.": "Aggiungi una nota facoltativa per spiegare questa opzione di spedizione o servizio.",
    "delivery.order": "Ordine",
    "delivery.enter_order": "Inserisci l’ordine",
    "delivery.status_hint": "Stato (inattivo / attivo)",
    "delivery.default": "Predefinito",
    "delivery.select_shipping_method": "Seleziona metodo di spedizione",
    "Select shipping method": "Seleziona metodo di spedizione",
    "delivery.select_extension": "Seleziona estensione",
    "Select extension": "Seleziona estensione",
    "delivery.add_photo": "Aggiungi foto",
    "delivery.config.flat_shipping_fee.title": "Tariffa di spedizione fissa",
    "Flat Shipping Fee": "Tariffa di spedizione fissa",
    "delivery.config.flat_shipping_fee.placeholder": "Inserisci la tariffa di spedizione fissa",
    "Enter flat shipping fee": "Inserisci la tariffa di spedizione fissa",
    "delivery.config.schedule_time.title": "Orario programmato",
    "delivery.config.fulfillment_by_platform_enabled.title": "Evasione tramite piattaforma",
    "Fulfillment by platform": "Evasione tramite piattaforma",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Icona evasione tramite piattaforma",
    "Fulfillment by Platform Icon": "Icona evasione tramite piattaforma",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Icona consegna venditore",
    "Seller Delivery Icon": "Icona consegna venditore",
    "delivery.phone_number": "Numero di telefono",
    "Phone number": "Numero di telefono",
    "delivery.enter_phone_number": "Inserisci il numero di telefono",
    "Enter phone number": "Inserisci il numero di telefono",
    "delivery.address_line_1": "Indirizzo riga 1",
    "Address line 1": "Indirizzo riga 1",
    "delivery.enter_address_line_1": "Inserisci l’indirizzo riga 1",
    "Enter address line 1": "Inserisci l’indirizzo riga 1",
    "delivery.address_line_2": "Indirizzo riga 2",
    "Address line 2": "Indirizzo riga 2",
    "delivery.enter_address_line_2": "Inserisci l’indirizzo riga 2",
    "Enter address line 2": "Inserisci l’indirizzo riga 2",
    "delivery.landmark": "Punto di riferimento",
    "Landmark": "Punto di riferimento",
    "delivery.enter_landmark": "Inserisci un punto di riferimento",
    "Enter landmark": "Inserisci un punto di riferimento",
    "delivery.state": "Regione",
    "delivery.enter_state": "Inserisci la regione",
    "Enter state": "Inserisci la regione",
    "delivery.post_code": "CAP",
    "Post code": "CAP",
    "delivery.enter_post_code": "Inserisci il CAP",
    "Enter post code": "Inserisci il CAP",
    "delivery.country": "Paese",
    "delivery.enter_country": "Inserisci il paese",
    "Enter country": "Inserisci il paese",
    "delivery.required_information": "Compila le informazioni obbligatorie",
    "Please fill the required information": "Compila le informazioni obbligatorie",
    "delivery.saved_successfully": "Salvato correttamente",
    "delivery.storage_hub.title": "Punti hub di stoccaggio",
    "Storage Hub Points": "Punti hub di stoccaggio",
    "delivery.storage_hub.add": "Aggiungi hub di stoccaggio",
    "Add Storage Hub": "Aggiungi hub di stoccaggio",
    "delivery.storage_hub.edit": "Modifica hub di stoccaggio",
    "Edit Storage Hub": "Modifica hub di stoccaggio",
    "delivery.storage_hub.delete_confirm": "Vuoi eliminare questo punto di stoccaggio?",
    "Do you want to delete this storage hub point?": "Vuoi eliminare questo punto di stoccaggio?",
    "delivery.storage_hub.table_name": "Nome",
    "delivery.storage_hub.table_phone": "Telefono",
    "delivery.storage_hub.table_address": "Indirizzo",
    "delivery.storage_hub.table_landmark": "Punto di riferimento",
    "delivery.storage_hub.table_state": "Regione",
    "delivery.storage_hub.table_post_code": "CAP",
    "Post Code": "CAP",
    "delivery.storage_hub.table_country": "Paese",
    "delivery.storage_hub.table_action": "Azione",
    "delivery.select_environment": "Seleziona ambiente",
    "Select environment": "Seleziona ambiente",
    "delivery.environment_sandbox": "Sandbox",
    "Sandbox": "Sandbox",
    "delivery.environment_production": "Produzione",
    "Production": "Produzione",
    "delivery.stuart.client_id": "ID client",
    "delivery.stuart.enter_client_id": "Inserisci ID client",
    "delivery.stuart.client_secret": "Segreto client",
    "Client Secret": "Segreto client",
    "delivery.stuart.enter_client_secret": "Inserisci il segreto client",
    "Enter client secret": "Inserisci il segreto client",
    "delivery.stuart.webhook_key": "Chiave di autenticazione webhook",
    "Webhook Authentication Key": "Chiave di autenticazione webhook",
    "delivery.stuart.enter_webhook_key": "Inserisci la chiave di autenticazione webhook",
    "Enter webhook authentication key": "Inserisci la chiave di autenticazione webhook",
    "delivery.sendcloud.public_key": "Chiave pubblica",
    "Public Key": "Chiave pubblica",
    "delivery.sendcloud.enter_public_key": "Inserisci la chiave API",
    "delivery.sendcloud.secret_key": "Chiave segreta",
    "Secret Key": "Chiave segreta",
    "delivery.sendcloud.enter_secret_key": "Inserisci il segreto di notifica",
    "Enter notification secret": "Inserisci il segreto di notifica",
    "delivery.sendcloud.default_shipping_address": "Indirizzo di spedizione predefinito",
    "Default Shipping Address": "Indirizzo di spedizione predefinito",
    "delivery.sendcloud.add_new": "+ Aggiungi",
    "+ Add New": "+ Aggiungi",
    "delivery.sendcloud.country_id": "ID",
    "ID": "ID",
    "payments.title": "Metodi di pagamento",
    "Payment Methods": "Metodi di pagamento",
    "payments.add": "Aggiungi metodo di pagamento",
    "Add Payment Method": "Aggiungi metodo di pagamento",
    "payments.edit": "Modifica metodo di pagamento",
    "Edit Payment Method": "Modifica metodo di pagamento",
    "payments.delete_confirm": "Vuoi eliminare questo metodo di pagamento?",
    "Do you want to delete this payment method?": "Vuoi eliminare questo metodo di pagamento?",
    "payments.save_continue": "Salva e continua",
    "Save and continue": "Salva e continua",
    "payments.translate": "Traduci pagamenti",
    "Translate Payments": "Traduci pagamenti",
    "payments.config": "Configurazione",
    "payments.integration_settings": "Impostazioni integrazione",
    "Integration Settings": "Impostazioni integrazione",
    "payments.opp_integration": "Integrazione OPP",
    "OPP Integration": "Integrazione OPP",
    "payments.billplz_integration": "Integrazione BillPlz",
    "BillPlz Integration": "Integrazione BillPlz",
    "payments.stripe_integration": "Integrazione Stripe",
    "Stripe Integration": "Integrazione Stripe",
    "payments.stripe_web_integration": "Integrazione Stripe Web",
    "Stripe Web Integration": "Integrazione Stripe Web",
    "payments.pawapay_integration": "Integrazione PawaPay",
    "PawaPay Integration": "Integrazione PawaPay",
    "payments.korapay_integration": "Integrazione KoraPay",
    "KoraPay Integration": "Integrazione KoraPay",
    "payments.flutterwave_integration": "Integrazione Flutterwave",
    "Flutterwave Integration": "Integrazione Flutterwave",
    "payments.commercepay_integration": "Integrazione CommercePay",
    "CommercePay Integration": "Integrazione CommercePay",
    "payments.checkout_com_integration": "Integrazione Checkout.com",
    "Checkout.com Integration": "Integrazione Checkout.com",
    "payments.paystack_integration": "Integrazione PayStack",
    "PayStack Integration": "Integrazione PayStack",
    "payments.razorpay_settings": "Impostazioni Razorpay",
    "Razorpay settings": "Impostazioni Razorpay",
    "payments.paydunya_settings": "Impostazioni Pay Dunya",
    "Pay Dunya settings": "Impostazioni Pay Dunya",
    "payments.mangopay_settings": "Impostazioni MangoPay",
    "MangoPay settings": "Impostazioni MangoPay",
    "payments.payu_latam_integration": "Integrazione PayU LATAM",
    "PayU LATAM Integration": "Integrazione PayU LATAM",
    "payments.table_name": "Nome",
    "payments.table_actions": "Azioni",
    "payments.table_min_amount": "Importo minimo",
    "Minimum Amount": "Importo minimo",
    "payments.table_max_amount": "Importo massimo",
    "Maximum Amount": "Importo massimo",
    "payments.table_default": "Predefinito",
    "payments.table_order_by": "Ordine",
    "payments.table_status": "Stato",
    "payments.yes": "Sì",
    "payments.no": "No",
    "payments.active": "Attivo",
    "payments.inactive": "Inattivo",
    "payments.settings": "Impostazioni",
    "payments.not_available": "N/D",
    "payments.step_select_type": "Seleziona tipo",
    "payments.step_configure": "Configura",
    "Configure": "Configura",
    "payments.step_integration": "Integrazione",
    "Integration": "Integrazione",
    "payments.next": "Avanti →",
    "Next →": "Avanti →",
    "payments.save": "Salva",
    "payments.choose_method": "Scegli un metodo di pagamento da configurare",
    "Choose a payment method to configure": "Scegli un metodo di pagamento da configurare",
    "payments.name": "Nome",
    "payments.enter_name": "Inserisci nome",
    "payments.maximum_amount": "Importo massimo",
    "payments.enter_maximum_amount": "Inserisci l’importo massimo",
    "payments.minimum_amount": "Importo minimo",
    "payments.enter_minimum_amount": "Inserisci l’importo minimo",
    "payments.note": "Nota",
    "payments.enter_note": "Inserisci una nota",
    "payments.note_tooltip": "Aggiungi una nota facoltativa per i clienti durante il checkout.",
    "Add an optional note for customers at checkout.": "Aggiungi una nota facoltativa per i clienti durante il checkout.",
    "payments.order": "Ordine",
    "payments.enter_order": "Inserisci ordine",
    "payments.default": "Predefinito",
    "payments.config_title": "Configurazione metodi di pagamento",
    "Payment Methods Configuration": "Configurazione metodi di pagamento",
    "payments.wallet_enable": "Abilita wallet",
    "Wallet enabled": "Abilita wallet",
    "payments.account_type": "Tipo account",
    "payments.select_account_type": "Seleziona tipo account",
    "Select account type": "Seleziona tipo account",
    "payments.connect_message_standard": "Messaggio di connessione Standard",
    "Connect message standard": "Messaggio di connessione Standard",
    "payments.enter_connect_message_standard": "Inserisci il messaggio di connessione Standard",
    "Enter connect message standard": "Inserisci il messaggio di connessione Standard",
    "payments.disconnect_message_standard": "Messaggio di disconnessione Standard",
    "Disconnect message standard": "Messaggio di disconnessione Standard",
    "payments.enter_disconnect_message_standard": "Inserisci il messaggio di disconnessione Standard",
    "Enter disconnect message standard": "Inserisci il messaggio di disconnessione Standard",
    "payments.connect_message_express": "Messaggio di connessione Express",
    "Connect message express": "Messaggio di connessione Express",
    "payments.enter_connect_message_express": "Inserisci il messaggio di connessione Express",
    "Enter connect message express": "Inserisci il messaggio di connessione Express",
    "payments.disconnect_message_express": "Messaggio di disconnessione Express",
    "Disconnect message express": "Messaggio di disconnessione Express",
    "payments.enter_disconnect_message_express": "Inserisci il messaggio di disconnessione Express",
    "Enter disconnect message express": "Inserisci il messaggio di disconnessione Express",
    "payments.enable_sandbox": "Abilita sandbox",
    "Enable sandbox": "Abilita sandbox",
    "payments.api_token": "Token API",
    "API Token": "Token API",
    "payments.enter_token": "Inserisci il token",
    "Enter token": "Inserisci il token",
    "payments.key_id": "ID chiave",
    "Key ID": "ID chiave",
    "payments.enter_key_id": "Inserisci l’ID chiave",
    "Enter key ID": "Inserisci l’ID chiave",
    "payments.key_secret": "Segreto chiave",
    "Key Secret": "Segreto chiave",
    "payments.enter_secret_key": "Inserisci la chiave segreta",
    "Enter secret key": "Inserisci la chiave segreta",
    "payments.webhook_secret_key": "Chiave segreta webhook",
    "Webhook Secret Key": "Chiave segreta webhook",
    "payments.enter_webhook_secret_key": "Inserisci la chiave segreta webhook",
    "Enter webhook secret key": "Inserisci la chiave segreta webhook",
    "payments.master_key": "Chiave principale",
    "Master Key": "Chiave principale",
    "payments.public_key": "Chiave pubblica",
    "payments.enter_public_key": "Inserisci la chiave pubblica",
    "Enter public key": "Inserisci la chiave pubblica",
    "payments.private_key": "Chiave privata",
    "Private Key": "Chiave privata",
    "payments.merchant_id": "ID commerciante",
    "Merchant ID": "ID commerciante",
    "payments.enter_merchant_id": "Inserisci l’ID commerciante",
    "Enter merchant id": "Inserisci l’ID commerciante",
    "payments.processing_channel_id": "ID canale di elaborazione",
    "Processing channel ID": "ID canale di elaborazione",
    "payments.enter_processing_channel_id": "Inserisci l’ID del canale di elaborazione",
    "Enter processing channel id": "Inserisci l’ID del canale di elaborazione",
    "payments.api_key": "Chiave API",
    "payments.x_signature_key": "Chiave firma X",
    "X Signature Key": "Chiave firma X",
    "payments.account_id": "ID account",
    "payments.login_api_key": "Chiave API di accesso",
    "Login API key": "Chiave API di accesso",
    "payments.client_id": "ID client",
    "payments.client_api_key": "Chiave API client",
    "Client API Key": "Chiave API client",
    "payments.payin_fee": "Commissione PayIn (%)",
    "PayIn fee (%)": "Commissione PayIn (%)",
    "payments.withdraw_fee": "Commissione di prelievo (%)",
    "Withdraw fee (%)": "Commissione di prelievo (%)",
    "payments.enter_api_key": "Inserisci la chiave API",
    "payments.enter_account_id": "Inserisci l’ID account",
    "Enter account ID": "Inserisci l’ID account",
    "payments.enter_login_api_key": "Inserisci la chiave API di accesso",
    "Enter login API key": "Inserisci la chiave API di accesso",
    "payments.enter_notification_secret": "Inserisci il segreto di notifica",
    "payments.enter_payin_fee": "Inserisci la commissione in percentuale",
    "Enter fee as a percentage": "Inserisci la commissione in percentuale",
    "payments.secret_key": "Chiave segreta",
    "Secret key": "Chiave segreta",
    "payments.publishable_key": "Chiave pubblicabile",
    "Publishable key": "Chiave pubblicabile",
    "payments.webhook_secret": "Segreto webhook",
    "Webhook secret": "Segreto webhook",
    "payments.enter_webhook_secret": "Inserisci il segreto webhook",
    "Enter webhook secret": "Inserisci il segreto webhook",
    "payments.enter_subscription_webhook_secret": "Inserisci il segreto webhook dell’abbonamento",
    "Enter subscription webhook secret": "Inserisci il segreto webhook dell’abbonamento",
    "payments.connect_client_id": "ID client Connect",
    "Connect client ID": "ID client Connect",
    "payments.enter_connect_client_id": "Inserisci l’ID client Connect",
    "Enter Connect client ID": "Inserisci l’ID client Connect",
    "payments.stripe_reminders": "Promemoria Stripe",
    "Stripe reminders": "Promemoria Stripe",
    "payments.stripe_sync_help": "La sincronizzazione verifica la chiave segreta con Stripe, compila le informazioni dell’account e crea gli endpoint webhook richiesti da Tradly. I segreti webhook vengono compilati automaticamente; al termine salva il modulo.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "La sincronizzazione verifica la chiave segreta con Stripe, compila le informazioni dell’account e crea gli endpoint webhook richiesti da Tradly. I segreti webhook vengono compilati automaticamente; al termine salva il modulo.",
    "payments.find_in_stripe": "Trova nella Dashboard Stripe",
    "Find in Stripe Dashboard": "Trova nella Dashboard Stripe",
    "payments.description": "Descrizione",
    "payments.learn_more_stripe": "Scopri di più sui pagamenti Stripe",
    "Learn more about Stripe Payments": "Scopri di più sui pagamenti Stripe",
    "payments.learn_more_stripe_connect": "Scopri Stripe Connect per marketplace",
    "Learn more about Stripe Connect for marketplaces": "Scopri Stripe Connect per marketplace",
    "payments.token": "Token",
    "Token": "Token",
    "payments.payment_options": "Opzioni di pagamento",
    "Payment options": "Opzioni di pagamento",
    "payments.enable_integration": "Abilita integrazione",
    "Enable integration": "Abilita integrazione",
    "payments.enter_provider_id": "Inserisci l’ID {provider}",
    "Enter {provider} ID": "Inserisci l’ID {provider}",
    "payments.integration_status_help": "Configura questo provider nelle relative impostazioni.",
    "Configure this provider in its settings.": "Configura questo provider nelle relative impostazioni.",
    "listings.title": "Inserzioni",
    "listings.manage": "Gestisci",
    "listings.show_rows": "Mostra righe",
    "listings.clear": "Cancella",
    "listings.apply": "Applica",
    "listings.select_date": "Seleziona data",
    "Select date": "Seleziona data",
    "listings.start_date": "Data inizio",
    "listings.end_date": "Data fine",
    "listings.status_types": "Tipi di stato",
    "Status types": "Tipi di stato",
    "listings.categories": "Categorie",
    "listings.attributes": "Attributi",
    "listings.clear_all_filters": "Cancella tutti i filtri",
    "Clear all filters": "Cancella tutti i filtri",
    "listings.import": "Importa",
    "listings.export": "Esporta",
    "listings.smart_upload": "Caricamento smart (Beta)",
    "Smart Upload (Beta)": "Caricamento smart (Beta)",
    "listings.filter_listings": "Filtra inserzioni",
    "Filter listings": "Filtra inserzioni",
    "listings.sort_listings": "Ordina inserzioni",
    "Sort listings": "Ordina inserzioni",
    "listings.import_listings": "Importa inserzioni",
    "listings.export_listings": "Esporta inserzioni",
    "Export listings": "Esporta inserzioni",
    "listings.list_view": "Vista elenco",
    "listings.grid_view": "Vista griglia",
    "listings.map_view": "Vista mappa",
    "listings.board_view": "Vista bacheca",
    "listings.export_all_title": "Esportare tutte le inserzioni?",
    "Export all listings?": "Esportare tutte le inserzioni?",
    "listings.export_all_message": "Verrà preparato un file con tutte le inserzioni. Vuoi continuare?",
    "This will prepare a file containing all listings. Do you want to continue?": "Verrà preparato un file con tutte le inserzioni. Vuoi continuare?",
    "listings.export_all": "Esporta tutte le inserzioni",
    "Export all listings": "Esporta tutte le inserzioni",
    "listings.cancel": "Annulla",
    "listings.status_all": "Tutti",
    "listings.status_pending": "In attesa",
    "listings.status_approved": "Approvato",
    "listings.status_rejected": "Rifiutato",
    "listings.status_archived": "Archiviato",
    "Archived": "Archiviato",
    "listings.sort_newest_first": "Prima i più recenti",
    "Newest first": "Prima i più recenti",
    "listings.sort_price_high_to_low": "Prezzo: dal più alto al più basso",
    "Price: high to low": "Prezzo: dal più alto al più basso",
    "listings.sort_price_low_to_high": "Prezzo: dal più basso al più alto",
    "Price: low to high": "Prezzo: dal più basso al più alto",
    "listings.header_0": "Titolo",
    "listings.header_1": "Sito web",
    "Website": "Sito web",
    "listings.header_2": "Prezzo",
    "listings.header_3": "Percentuale offerta",
    "listings.header_4": "Immagine",
    "listings.header_5": "Prezzo offerta",
    "Offer price": "Prezzo offerta",
    "listings.header_6": "Stato",
    "listings.header_7": "ID inserzione",
    "listings.header_8": "Stato inserzione",
    "Listing status": "Stato inserzione",
    "listings.header_9": "Account",
    "listings.header_10": "Valuta",
    "listings.header_11": "Venduto",
    "Sold": "Venduto",
    "listings.header_12": "Importo obiettivo",
    "Goal amount": "Importo obiettivo",
    "listings.filter_status": "Stato",
    "listings.filter_price": "Prezzo",
    "listings.filter_category": "Categoria",
    "listings.filter_clear_all": "Cancella tutti i filtri",
    "listings.status_count": "Stato ({count})",
    "Status ({count})": "Stato ({count})",
    "listings.price_count": "Prezzo ({count})",
    "Price ({count})": "Prezzo ({count})",
    "listings.category_count": "Categoria ({count})",
    "Category ({count})": "Categoria ({count})",
    "listings.search": "Cerca inserzioni",
    "listings.clear_search": "Cancella ricerca inserzioni",
    "Clear listing search": "Cancella ricerca inserzioni",
    "listings.active": "Attivo",
    "listings.inactive": "Inattivo",
    "listings.approve": "Approva",
    "listings.reject": "Rifiuta",
    "listings.delete_confirm": "Vuoi eliminare questa inserzione?",
    "listings.approve_confirm": "Vuoi approvare questa inserzione?",
    "Do you want to approve this listing?": "Vuoi approvare questa inserzione?",
    "listings.reject_confirm": "Vuoi rifiutare questa inserzione?",
    "Do you want to reject this listing?": "Vuoi rifiutare questa inserzione?",
    "listings.yes": "Sì",
    "listings.no": "No",
    "listings.confirm_delete": "Vuoi eliminare questa inserzione?",
    "listings.confirm_approve": "Vuoi approvare questa inserzione?",
    "listings.confirm_reject": "Vuoi rifiutare questa inserzione?",
    "listings.column.actions": "Azioni",
    "listings.audio_episode": "Episodio audio",
    "Audio episode": "Episodio audio",
    "listings.video": "Video",
    "listings.seller": "Venditore",
    "listings.rating": "Valutazione",
    "listings.followers": "Follower",
    "listings.view_seller_account": "Visualizza account venditore",
    "View seller account": "Visualizza account venditore",
    "listings.add_variant": "Aggiungi variante",
    "Add variant": "Aggiungi variante",
    "listings.edit": "Modifica",
    "listings.preview": "Anteprima",
    "listings.share": "Condividi",
    "listings.view_listing": "Visualizza inserzione",
    "View listing": "Visualizza inserzione",
    "listings.stock": "Scorte",
    "Stock": "Scorte",
    "listings.variants": "Varianti",
    "listings.campaign": "Campagna",
    "Campaign": "Campagna",
    "listings.rental_details": "Dettagli noleggio",
    "Rental details": "Dettagli noleggio",
    "listings.copy": "Copia",
    "listings.inventory": "Magazzino",
    "listings.order_type": "Tipo di ordine",
    "Order type": "Tipo di ordine",
    "listings.stock_by_location": "Scorte per sede",
    "Stock by location": "Scorte per sede",
    "listings.loading_location_stock": "Caricamento scorte per sede…",
    "Loading location stock…": "Caricamento scorte per sede…",
    "listings.no_location_stock": "Nessuna scorta assegnata a una sede.",
    "No stock assigned to a location.": "Nessuna scorta assegnata a una sede.",
    "listings.page_analytics": "Analisi pagina",
    "Page analytics": "Analisi pagina",
    "listings.loading": "Caricamento…",
    "listings.analytics_key_missing": "La chiave API Analytics non è configurata per questo tenant.",
    "Analytics API key is not configured for this tenant.": "La chiave API Analytics non è configurata per questo tenant.",
    "listings.no_slug": "Non è disponibile uno slug per questa inserzione.",
    "No slug is available for this listing.": "Non è disponibile uno slug per questa inserzione.",
    "listings.no_analytics": "Nessuna analisi ancora caricata.",
    "listings.load_analytics": "Carica analisi",
    "Load analytics": "Carica analisi",
    "listings.no_orders": "Nessun ordine per questa inserzione",
    "No orders yet for this listing": "Nessun ordine per questa inserzione",
    "listings.social_ratings": "Social e valutazioni",
    "Social and ratings": "Social e valutazioni",
    "listings.tags": "Tag",
    "listings.schedule": "Agenda",
    "listings.detail": "Dettagli",
    "Detail": "Dettagli",
    "listings.update_stock": "Aggiorna scorte",
    "Update stock": "Aggiorna scorte",
    "listings.new_stock_quantity": "Nuova quantità scorte",
    "New stock quantity": "Nuova quantità scorte",
    "listings.location": "Sede",
    "listings.quantity": "Quantità",
    "listings.current_stock": "Scorte attuali: {quantity}",
    "Current stock: {quantity}": "Scorte attuali: {quantity}",
    "listings.loading_rental": "Caricamento impostazioni noleggio…",
    "Loading rental settings…": "Caricamento impostazioni noleggio…",
    "payments.enter_publishable_key": "Inserisci la chiave pubblicabile",
    "Enter publishable key": "Inserisci la chiave pubblicabile",
    "listings.add_listing": "Aggiungi inserzione",
    "Add listing": "Aggiungi inserzione",
    "listings.edit_listing": "Modifica inserzione",
    "Edit listing": "Modifica inserzione",
    "listings.enter_title": "Inserisci il titolo",
    "listings.account": "Account",
    "listings.list_price": "Prezzo di listino",
    "listings.enter_list_price": "Inserisci il prezzo",
    "listings.select_currency": "Seleziona valuta",
    "Select currency": "Seleziona valuta",
    "listings.select_category": "Seleziona categoria",
    "listings.select_categories": "Seleziona categorie",
    "Select categories": "Seleziona categorie",
    "listings.add_category": "+ Aggiungi categoria",
    "+ Add category": "+ Aggiungi categoria",
    "listings.add_attribute": "Aggiungi attributo",
    "Add attribute": "Aggiungi attributo",
    "listings.enter_stock": "Inserisci quantità",
    "listings.offer_percentage": "Percentuale offerta",
    "Offer percentage": "Percentuale offerta",
    "listings.enter_offer": "Inserisci l’offerta",
    "Enter offer": "Inserisci l’offerta",
    "listings.max_quantity_optional": "Quantità massima (facoltativa)",
    "Max quantity (optional)": "Quantità massima (facoltativa)",
    "listings.enter_max_quantity": "Inserisci la quantità massima",
    "Enter max quantity": "Inserisci la quantità massima",
    "listings.enter_slug": "Inserisci lo slug",
    "listings.enter_meta_title": "Inserisci il meta titolo",
    "listings.repeat": "Ripeti",
    "Repeat": "Ripeti",
    "listings.start_time": "Ora di inizio",
    "Start time": "Ora di inizio",
    "listings.end_time": "Ora di fine",
    "End time": "Ora di fine",
    "listings.slot": "Fascia",
    "Slot": "Fascia",
    "listings.starts_from": "Inizia da:",
    "Starts from:": "Inizia da:",
    "listings.add_schedule": "+ Aggiungi programma",
    "+ Add schedule": "+ Aggiungi programma",
    "listings.upload_here": "Carica qui",
    "listings.save": "Salva",
    "listings.update": "Aggiorna",
    "listings.tax": "Imposta",
    "listings.title_required": "Inserisci un titolo",
    "Please enter a title": "Inserisci un titolo",
    "listings.select_tax": "Seleziona un’imposta",
    "Please select a tax": "Seleziona un’imposta",
    "listings.select_item": "Seleziona {item}",
    "Please select {item}": "Seleziona {item}",
    "listings.offer_percentage_validation": "La percentuale offerta deve essere compresa tra 0 e 100",
    "Offer percentage must be between 0 and 100": "La percentuale offerta deve essere compresa tra 0 e 100",
    "listings.custom_seo": "SEO personalizzato",
    "Custom SEO": "SEO personalizzato",
    "listings.select_value": "Seleziona un valore",
    "Select value": "Seleziona un valore",
    "listings.add_schedule_title": "Aggiungi programma",
    "Add schedule": "Aggiungi programma",
    "listings.select_from_media": "Seleziona dai contenuti",
    "listing_form.create_listing": "Crea inserzione",
    "Create listing": "Crea inserzione",
    "listing_form.update_listing": "Aggiorna inserzione",
    "Update listing": "Aggiorna inserzione",
    "listing_form.saving": "Salvataggio…",
    "listing_form.main_information": "Informazioni principali",
    "Main information": "Informazioni principali",
    "listing_form.audio_listing": "Inserzione audio",
    "Audio listing": "Inserzione audio",
    "listing_form.basic_information": "Informazioni di base",
    "Basic information": "Informazioni di base",
    "listing_form.listing_type": "Tipo di inserzione",
    "Listing type": "Tipo di inserzione",
    "listing_form.title": "Titolo",
    "listing_form.enter_listing_title": "Inserisci il titolo dell’inserzione",
    "Enter listing title": "Inserisci il titolo dell’inserzione",
    "listing_form.description": "Descrizione",
    "listing_form.enter_detailed_description": "Inserisci una descrizione dettagliata",
    "Enter detailed description": "Inserisci una descrizione dettagliata",
    "listing_form.tags": "Tag",
    "listing_form.tag_example": "ad es. elettronica, gadget, nuovo",
    "e.g., electronics, gadgets, new": "ad es. elettronica, gadget, nuovo",
    "listing_form.taxes": "Imposte",
    "listing_form.optional": "Facoltativo",
    "listing_form.start_date": "Data inizio",
    "listing_form.end_date": "Data fine",
    "listing_form.currency": "Valuta",
    "listing_form.select_currency": "Seleziona valuta",
    "listing_form.goal_price": "Prezzo obiettivo",
    "Goal price": "Prezzo obiettivo",
    "listing_form.set_fundraising_goal": "Imposta l’obiettivo di raccolta fondi",
    "Set your fundraising goal": "Imposta l’obiettivo di raccolta fondi",
    "listing_form.pricing": "Prezzi",
    "Pricing": "Prezzi",
    "listing_form.select": "Seleziona",
    "listing_form.price": "Prezzo",
    "listing_form.offer_percent": "Sconto %",
    "Offer %": "Sconto %",
    "listing_form.listing_price": "Prezzo inserzione:",
    "Listing price:": "Prezzo inserzione:",
    "listing_form.set_fundraising_goal_amount": "Imposta l’importo obiettivo della raccolta fondi",
    "Set your fundraising goal amount": "Imposta l’importo obiettivo della raccolta fondi",
    "listing_form.category": "Categoria",
    "listing_form.select_a_category": "Seleziona una categoria",
    "Select a category": "Seleziona una categoria",
    "listing_form.clear_selected_category": "Cancella la categoria selezionata",
    "Clear selected category": "Cancella la categoria selezionata",
    "listing_form.create_new_category": "Crea nuova categoria",
    "Create a new category": "Crea nuova categoria",
    "listing_form.search_categories": "Cerca categorie…",
    "Search categories…": "Cerca categorie…",
    "listing_form.no_categories_match": "Nessuna categoria trovata",
    "No categories found": "Nessuna categoria trovata",
    "listing_form.draft_found": "È stata trovata una bozza salvata.",
    "A saved draft was found.": "È stata trovata una bozza salvata.",
    "listing_form.restore": "Ripristina",
    "Restore": "Ripristina",
    "listing_form.discard": "Scarta",
    "listing_form.characters": "caratteri",
    "characters": "caratteri",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Prodotti fisici",
    "Physical products": "Prodotti fisici",
    "listing_form.type_events": "Eventi",
    "Events": "Eventi",
    "listing_form.type_digital": "Prodotti digitali",
    "Digital products": "Prodotti digitali",
    "listing_form.type_appointments": "Appuntamenti",
    "Appointments": "Appuntamenti",
    "listing_form.type_rentals": "Noleggi",
    "listing_form.type_donation": "Crowdfunding",
    "Crowdfunding": "Crowdfunding",
    "listing_form.type_information_listing": "Informazioni",
    "Information": "Informazioni",
    "listing_form.type_video_listing": "Video",
    "listing_form.type_audio_listing": "Audio",
    "listing_form.select_taxes": "Seleziona imposte (facoltativo)",
    "Select taxes (optional)": "Seleziona imposte (facoltativo)",
    "listing_form.no_taxes": "Nessuna imposta disponibile",
    "No taxes available": "Nessuna imposta disponibile",
    "listing_form.inventory_shipping": "Magazzino e spedizione",
    "Inventory & shipping": "Magazzino e spedizione",
    "listing_form.stock": "Scorte",
    "listing_form.weight": "Peso",
    "Weight": "Peso",
    "listing_form.dimensions": "Dimensioni (L×P×A)",
    "Dimensions (L×W×H)": "Dimensioni (L×P×A)",
    "listing_form.sku": "SKU",
    "SKU": "SKU",
    "listing_form.barcode": "Codice a barre",
    "Barcode": "Codice a barre",
    "listing_form.length": "Lunghezza",
    "Length": "Lunghezza",
    "listing_form.width": "Larghezza",
    "Width": "Larghezza",
    "listing_form.height": "Altezza",
    "Height": "Altezza",
    "listing_form.seo_settings": "Impostazioni SEO",
    "SEO settings": "Impostazioni SEO",
    "listing_form.slug": "Slug",
    "listing_form.url_friendly_title": "Versione URL del titolo",
    "URL-friendly version of the title": "Versione URL del titolo",
    "listing_form.meta_title": "Meta titolo",
    "listing_form.recommended_meta_title": "Consigliato: 50–60 caratteri",
    "Recommended: 50–60 chars": "Consigliato: 50–60 caratteri",
    "listing_form.meta_keywords": "Parole chiave meta",
    "Meta keywords": "Parole chiave meta",
    "listing_form.separate_with_commas": "Separa con virgole",
    "Separate with commas": "Separa con virgole",
    "listing_form.meta_description": "Meta descrizione",
    "listing_form.recommended_meta_description": "Consigliato: 150–160 caratteri",
    "Recommended: 150–160 chars": "Consigliato: 150–160 caratteri",
    "listing_form.hide": "Nascondi",
    "listing_form.show": "Mostra",
    "listing_form.seo_fields": "campi di ottimizzazione per i motori di ricerca",
    "search engine optimization fields": "campi di ottimizzazione per i motori di ricerca",
    "listing_form.auto_generated_slug": "Generato automaticamente dal titolo",
    "Auto-generated from title": "Generato automaticamente dal titolo",
    "listing_form.seo_title_optional": "Titolo SEO (facoltativo)",
    "SEO title (optional)": "Titolo SEO (facoltativo)",
    "listing_form.keywords_comma_separated": "Parole chiave separate da virgole",
    "Keywords separated by commas": "Parole chiave separate da virgole",
    "listing_form.search_description_optional": "Breve descrizione per i risultati di ricerca (facoltativa)",
    "Brief description for search results (optional)": "Breve descrizione per i risultati di ricerca (facoltativa)",
    "listing_form.account": "Account",
    "listing_form.loading_accounts": "Caricamento account…",
    "Loading accounts…": "Caricamento account…",
    "listing_form.clear_selected_account": "Deseleziona account",
    "Clear selected account": "Deseleziona account",
    "listing_form.search_accounts": "Cerca account…",
    "Search accounts…": "Cerca account…",
    "listing_form.create_account": "Crea un nuovo account",
    "Create a new account": "Crea un nuovo account",
    "listing_form.no_accounts_found": "Nessun account trovato",
    "No accounts found": "Nessun account trovato",
    "listing_form.rental_settings": "Impostazioni noleggio",
    "Rental settings": "Impostazioni noleggio",
    "listing_form.rental_price_help": "Il prezzo dell’inserzione viene calcolato in base alla tariffa e alla durata del noleggio.",
    "The listing price is calculated from the rental rate and duration.": "Il prezzo dell’inserzione viene calcolato in base alla tariffa e alla durata del noleggio.",
    "listing_form.rate_unit": "Unità tariffa",
    "Rate unit": "Unità tariffa",
    "listing_form.hour": "Ora",
    "Hour": "Ora",
    "listing_form.day": "Giorno",
    "listing_form.week": "Settimana",
    "listing_form.rental_rate_amount": "Tariffa noleggio",
    "Rental rate": "Tariffa noleggio",
    "listing_form.rental_min_duration": "Durata minima",
    "Minimum duration": "Durata minima",
    "listing_form.rental_max_duration": "Durata massima",
    "Maximum duration": "Durata massima",
    "listing_form.rental_buffer_time": "Tempo cuscinetto (ore)",
    "Buffer time (hours)": "Tempo cuscinetto (ore)",
    "listing_form.rental_deposit_amount": "Importo deposito",
    "Deposit amount": "Importo deposito",
    "listing_form.rental_max_units": "Numero massimo di unità",
    "Maximum units": "Numero massimo di unità",
    "listing_form.quick_create_title": "Crea {entity}",
    "Create {entity}": "Crea {entity}",
    "listing_form.close": "Chiudi",
    "listing_form.account_name": "Nome account",
    "listing_form.category_name": "Nome categoria",
    "Category name": "Nome categoria",
    "listing_form.account_example": "ad es.: Negozio Acme",
    "e.g. Acme Store": "ad es.: Negozio Acme",
    "listing_form.category_example": "ad es.: Prodotti freschi",
    "e.g. Fresh Produce": "ad es.: Prodotti freschi",
    "listing_form.creating": "Creazione…",
    "listing_form.create_entity": "Crea {entity}",
    "listing_form.cancel": "Annulla",
    "listing_form.go_back": "Indietro",
    "Go back": "Indietro",
    "listing_form.upgrade_plan": "Passa a un piano superiore",
    "Upgrade plan": "Passa a un piano superiore",
    "listing_form.close_upgrade_dialog": "Chiudi la finestra di upgrade",
    "Close upgrade dialog": "Chiudi la finestra di upgrade",
    "listing_form.loading_attributes": "Caricamento attributi…",
    "Loading attributes…": "Caricamento attributi…",
    "listing_form.no_attributes": "Nessun attributo per questa categoria",
    "No attributes for this category": "Nessun attributo per questa categoria",
    "listing_form.unsupported_field_type": "Tipo di campo non supportato",
    "Unsupported field type": "Tipo di campo non supportato",
    "listing_form.delete_schedule_confirm": "Vuoi eliminare questo programma?",
    "Are you sure you want to delete this schedule?": "Vuoi eliminare questo programma?",
    "listing_form.no_schedules_added": "Nessun programma aggiunto",
    "No schedules added yet": "Nessun programma aggiunto",
    "listing_form.stock_label": "Scorte:",
    "Stock:": "Scorte:",
    "listing_form.active": "Attivo",
    "listing_form.inactive": "Inattivo",
    "listing_form.edit": "Modifica",
    "listing_form.delete": "Elimina",
    "listing_form.schedules": "Programmi",
    "Schedules": "Programmi",
    "listing_form.no_schedules_yet": "Nessun programma",
    "No schedules yet": "Nessun programma",
    "listing_form.dates_label": "Date:",
    "Dates:": "Date:",
    "listing_form.time_label": "Ora:",
    "Time:": "Ora:",
    "listing_form.repeat_label": "Ripeti:",
    "Repeat:": "Ripeti:",
    "listing_form.capacity_label": "Capacità:",
    "Capacity:": "Capacità:",
    "listing_form.edit_schedule": "Modifica programma",
    "Edit schedule": "Modifica programma",
    "listing_form.add_new_schedule": "Aggiungi programma",
    "Add new schedule": "Aggiungi programma",
    "listing_form.repeat_pattern": "Schema di ripetizione",
    "Repeat pattern": "Schema di ripetizione",
    "listing_form.select_days": "Seleziona i giorni",
    "Select days": "Seleziona i giorni",
    "listing_form.total_stocks_capacity": "Scorte totali (capacità)",
    "Total stock (capacity)": "Scorte totali (capacità)",
    "listing_form.select_at_least_one_day": "Seleziona almeno un giorno",
    "Please select at least one day": "Seleziona almeno un giorno",
    "listing_form.unlimited_capacity_help": "Lascia vuoto per una capacità illimitata",
    "Leave empty for unlimited capacity": "Lascia vuoto per una capacità illimitata",
    "listing_form.add_schedule": "+ Aggiungi programma",
    "listing_form.schedule_number": "Programma n. {number}",
    "Schedule #{number}": "Programma n. {number}",
    "listing_form.update_action": "aggiorna",
    "listing_form.create_action": "crea",
    "listing_form.a_schedule": "un programma",
    "a schedule": "un programma",
    "listing_form.daily": "Ogni giorno",
    "listing_form.weekdays": "Giorni feriali (lun–ven)",
    "Weekdays (Mon - Fri)": "Giorni feriali (lun–ven)",
    "listing_form.weekend": "Weekend (sab–dom)",
    "Weekend (Sat - Sun)": "Weekend (sab–dom)",
    "listing_form.custom": "Personalizzato",
    "listing_form.weekday_0": "Lunedì",
    "Monday": "Lunedì",
    "listing_form.weekday_1": "Martedì",
    "Tuesday": "Martedì",
    "listing_form.weekday_2": "Mercoledì",
    "Wednesday": "Mercoledì",
    "listing_form.weekday_3": "Giovedì",
    "Thursday": "Giovedì",
    "listing_form.weekday_4": "Venerdì",
    "Friday": "Venerdì",
    "listing_form.weekday_5": "Sabato",
    "Saturday": "Sabato",
    "listing_form.weekday_6": "Domenica",
    "Sunday": "Domenica",
    "listing_form.media_max_files": "Massimo {count} {type}",
    "Maximum {count} {type} allowed": "Massimo {count} {type}",
    "listing_form.video_size_limit": "Ogni video deve avere dimensioni pari o inferiori a 1 GB",
    "Each video must be 1GB or smaller": "Ogni video deve avere dimensioni pari o inferiori a 1 GB",
    "listing_form.videos": "Video",
    "Videos": "Video",
    "listing_form.images": "Immagini",
    "listing_form.select_from_media": "Seleziona dai contenuti",
    "listing_form.video_upload_help": "Carica video in formato MP4, MOV, AVI, MKV, WebM (max 1 GB ciascuno)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "Carica video in formato MP4, MOV, AVI, MKV, WebM (max 1 GB ciascuno)",
    "listing_form.image_upload_help": "Carica immagini JPG, PNG, GIF, WebP (max 10 MB ciascuna)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "Carica immagini JPG, PNG, GIF, WebP (max 10 MB ciascuna)",
    "listing_form.uploading_video": "Caricamento video…",
    "Uploading video…": "Caricamento video…",
    "listing_form.audio_episode": "Episodio audio",
    "listing_form.audio_upload_help": "Carica un file audio o incolla un URL pubblico per il feed RSS.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "Carica un file audio o incolla un URL pubblico per il feed RSS.",
    "listing_form.selected_file": "Selezionato: {name}",
    "listing_form.audio_url_help": "L’URL è facoltativo se scegli un file. Lascialo vuoto per usare il file caricato.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "L’URL è facoltativo se scegli un file. Lascialo vuoto per usare il file caricato.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Caricamento audio…",
    "Uploading audio…": "Caricamento audio…",
    "listing_form.validation_start_date": "Seleziona la data di inizio",
    "Please select start date": "Seleziona la data di inizio",
    "listing_form.validation_end_date": "Seleziona la data di fine",
    "Please select end date": "Seleziona la data di fine",
    "listing_form.validation_start_time": "Seleziona l’ora di inizio",
    "Please select start time": "Seleziona l’ora di inizio",
    "listing_form.validation_end_time": "Seleziona l’ora di fine",
    "Please select end time": "Seleziona l’ora di fine",
    "listing_form.weekdays_short": "Feriali",
    "Weekdays": "Feriali",
    "listing_form.weekend_short": "Weekend",
    "Weekend": "Weekend",
    "listing_form.click_add_schedule_help": "Fai clic su “{action}” per creare il primo programma",
    "Click \"{action}\" to create your first schedule": "Fai clic su “{action}” per creare il primo programma",
    "listing_form.schedule_form_intro": "Compila i dettagli seguenti per",
    "Fill in the details below to": "Compila i dettagli seguenti per",
    "listing_form.update": "Aggiorna",
    "listing_form.save": "Salva",
    "listing_form.variant_value_required": "Seleziona almeno un valore variante (ad es. Colore, Taglia)",
    "Please select at least one variant value (e.g., Color, Size)": "Seleziona almeno un valore variante (ad es. Colore, Taglia)",
    "listing_form.valid_price_required": "Inserisci un prezzo valido",
    "Please enter a valid price": "Inserisci un prezzo valido",
    "listing_form.delete_variant_confirm": "Vuoi eliminare questa variante?",
    "Are you sure you want to delete this variant?": "Vuoi eliminare questa variante?",
    "listing_form.product_variants": "Varianti prodotto",
    "Product Variants": "Varianti prodotto",
    "listing_form.add_variant": "+ Aggiungi variante",
    "+ Add Variant": "+ Aggiungi variante",
    "listing_form.select_all_variants": "Seleziona tutte le varianti",
    "Select all variants": "Seleziona tutte le varianti",
    "listing_form.set_quantity_selected": "Imposta quantità per gli elementi selezionati",
    "Set quantity for selected": "Imposta quantità per gli elementi selezionati",
    "listing_form.quantity": "Quantità",
    "listing_form.apply_quantity": "Applica quantità",
    "Apply quantity": "Applica quantità",
    "listing_form.select_variant_number": "Seleziona variante {number}",
    "Select variant {number}": "Seleziona variante {number}",
    "listing_form.variant_number": "Variante n. {number}",
    "Variant #{number}": "Variante n. {number}",
    "listing_form.existing": "Esistente",
    "Existing": "Esistente",
    "listing_form.modified": "Modificato",
    "Modified": "Modificato",
    "listing_form.variant_name": "Nome variante",
    "Variant Name": "Nome variante",
    "listing_form.variant_values": "Valori variante",
    "Variant Values": "Valori variante",
    "listing_form.type": "Tipo",
    "listing_form.no_variant_values": "Nessun valore variante",
    "No variant values": "Nessun valore variante",
    "listing_form.no_variants_yet": "Nessuna variante",
    "No variants yet": "Nessuna variante",
    "listing_form.click_add_variant_help": "Fai clic su “{action}” per creare la prima variante",
    "Click \"{action}\" to create your first variant": "Fai clic su “{action}” per creare la prima variante",
    "listing_form.select_variant_type": "Seleziona {type}",
    "Select {type}": "Seleziona {type}",
    "listing_form.no_variant_types": "Nessun tipo di variante disponibile. Crea prima tipi come Colore o Taglia.",
    "No variant types available. Please create variant types (like Color, Size) first.": "Nessun tipo di variante disponibile. Crea prima tipi come Colore o Taglia.",
    "listing_form.generated_name": "Nome generato:",
    "Generated Name:": "Nome generato:",
    "listing_form.custom_title": "Titolo personalizzato",
    "Custom Title": "Titolo personalizzato",
    "listing_form.auto_generate_help": "Lascia vuoto per la generazione automatica",
    "Leave blank to auto-generate": "Lascia vuoto per la generazione automatica",
    "listing_form.save_variant": "Salva variante",
    "Save Variant": "Salva variante",
    "listing_form.start_time": "Ora di inizio",
    "Start Time": "Ora di inizio",
    "listing_form.end_time": "Ora di fine",
    "End Time": "Ora di fine",
    "listing_form.enter_capacity_limit": "Inserisci il limite di capienza",
    "Enter capacity limit": "Inserisci il limite di capienza",
    "collections.validation_title": "Il titolo non può essere vuoto",
    "Title should not be empty": "Il titolo non può essere vuoto",
    "collections.validation_platform": "Seleziona almeno una piattaforma",
    "Select at least one platform": "Seleziona almeno una piattaforma",
    "collections.validation_dates": "La data di fine deve essere successiva alla data di inizio",
    "End Date must be later than start date": "La data di fine deve essere successiva alla data di inizio",
    "collections.validation_minimum_selection": "Seleziona almeno {type}",
    "Select at least one {type}": "Seleziona almeno {type}",
    "collections.account": "account",
    "account": "account",
    "collections.listing": "inserzione",
    "listing": "inserzione",
    "collections.edit_title": "Modifica raccolta",
    "Edit Collection": "Modifica raccolta",
    "collections.create_title": "Crea raccolta",
    "Create Collection": "Crea raccolta",
    "collections.details": "Dettagli raccolta",
    "Collection details": "Dettagli raccolta",
    "collections.title_placeholder": "Inserisci il titolo",
    "Enter title name": "Inserisci il titolo",
    "collections.slug": "Slug",
    "collections.slug_placeholder": "Inserisci lo slug",
    "collections.enter_title_first": "Inserisci prima un titolo",
    "collections.scope": "Ambito",
    "collections.accounts": "Account",
    "collections.listings": "Inserzioni",
    "collections.choose_category": "Scegli categoria",
    "collections.conditions": "Condizioni",
    "Conditions": "Condizioni",
    "collections.condition_type": "Tipo di condizione",
    "Condition type": "Tipo di condizione",
    "collections.manual": "Manuale",
    "Manual": "Manuale",
    "collections.automated": "Automatica",
    "Automated": "Automatica",
    "collections.availability": "Disponibilità raccolta",
    "Collections availability": "Disponibilità raccolta",
    "collections.schedule": "Programma",
    "collections.applicable_channels": "Seleziona canale",
    "Select applicable channel": "Seleziona canale",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Cerca per nome",
    "Search by name": "Cerca per nome",
    "collections.not_found": "Raccolta non trovata.",
    "Collection not found.": "Raccolta non trovata.",
    "collections.featured_listings": "Inserzioni in evidenza",
    "Featured listings": "Inserzioni in evidenza",
    "collections.url_copied": "URL pubblico copiato",
    "Public URL copied": "URL pubblico copiato",
    "collections.url_copy_failed": "Impossibile copiare l’URL pubblico",
    "Unable to copy the public URL": "Impossibile copiare l’URL pubblico",
    "collections.collection": "Raccolta",
    "Collection": "Raccolta",
    "collections.this_collection": "questa raccolta",
    "this collection": "questa raccolta",
    "collections.share_text": "Visualizza {title}",
    "View {title}": "Visualizza {title}",
    "collections.public_url": "URL pubblico:",
    "Public URL:": "URL pubblico:",
    "collections.copy_url": "Copia URL",
    "Copy URL": "Copia URL",
    "collections.items": "Elementi",
    "collections.expires": "Scade",
    "Expires": "Scade",
    "collections.never": "Mai",
    "Never": "Mai",
    "collections.automatic_conditions": "Condizioni automatiche",
    "Automatic Conditions": "Condizioni automatiche",
    "collections.item_count": "{count} elementi",
    "{count} items": "{count} elementi",
    "collections.loading_items": "Caricamento elementi…",
    "Loading items…": "Caricamento elementi…",
    "collections.no_items": "Nessun elemento in questa raccolta.",
    "No items in this collection yet.": "Nessun elemento in questa raccolta.",
    "collections.delete_confirm": "Vuoi eliminare questa raccolta?",
    "Do you want to delete this collection?": "Vuoi eliminare questa raccolta?",
    "collections.title": "Raccolte",
    "collections.header_title": "Titolo",
    "collections.header_action": "Azione",
    "collections.header_id": "ID",
    "collections.header_condition_type": "Tipo condizione",
    "Condition Type": "Tipo condizione",
    "collections.header_scope": "Ambito",
    "collections.header_start_date": "Data inizio",
    "collections.header_end_date": "Data fine",
    "collections.header_status": "Stato",
    "collections.header_url": "URL",
    "common.calendar_view": "Vista calendario",
    "Calendar view": "Vista calendario",
    "common.deleted": "Eliminato",
    "Deleted": "Eliminato",
    "common.list_view": "Vista elenco",
    "common.description": "Descrizione",
    "common.title": "Titolo",
    "common.end_date": "Data fine",
    "common.start_date": "Data inizio",
    "promotions.image_required": "Aggiungi un’immagine",
    "Please add an image": "Aggiungi un’immagine",
    "promotions.edit_title": "Modifica promozione",
    "Edit Promotion": "Modifica promozione",
    "promotions.add_title": "Aggiungi promozione",
    "Add Promotion": "Aggiungi promozione",
    "promotions.name": "Nome promozione",
    "Promotion Name": "Nome promozione",
    "promotions.select_medium": "Seleziona supporto",
    "Select Medium": "Seleziona supporto",
    "promotions.upload_media": "Carica contenuto",
    "promotions.schedule": "Programma",
    "promotions.destination_type": "Tipo destinazione",
    "Destination Type": "Tipo destinazione",
    "promotions.placement": "Posizionamento",
    "Placement": "Posizionamento",
    "promotions.status": "Stato (inattivo / attivo)",
    "promotions.delete_confirm": "Vuoi eliminare questa promozione?",
    "Do you want to delete this promotion?": "Vuoi eliminare questa promozione?",
    "promotions.title": "Promozioni",
    "promotions.header_image": "Immagine",
    "promotions.header_medium": "Supporto",
    "promotions.header_placement": "Posizionamento",
    "promotions.header_type": "Tipo",
    "promotions.header_value": "Valore",
    "promotions.header_active": "Attiva",
    "promotions.header_action": "Azione",
    "promotions.header_start_at": "Inizio",
    "Start At": "Inizio",
    "promotions.header_end_at": "Fine",
    "End At": "Fine",
    "common.grid_view": "Vista griglia",
    "promotions.type_general": "Generale",
    "promotions.type_listing": "Inserzione",
    "promotions.type_account": "Account",
    "promotions.type_external_link": "Link esterno",
    "External link": "Link esterno",
    "promotions.preview": "Anteprima",
    "promotions.select_listing": "Seleziona inserzione",
    "Select Listing": "Seleziona inserzione",
    "promotions.select_account": "Seleziona account",
    "Select Account": "Seleziona account",
    "promotions.home_placement": "Home",
    "promotions.footer_placement": "Piè di pagina",
    "Footer": "Piè di pagina",
    "promotions.web_only": "(solo web)",
    "(Web Only)": "(solo web)",
    "coupons.edit_title": "Modifica coupon",
    "Edit Coupon": "Modifica coupon",
    "coupons.add_title": "Aggiungi coupon",
    "Add Coupon": "Aggiungi coupon",
    "coupons.reference_name": "Nome di riferimento",
    "Reference Name": "Nome di riferimento",
    "coupons.enter_name": "Inserisci nome",
    "coupons.coupon_type": "Tipo coupon",
    "Coupon type": "Tipo coupon",
    "coupons.discount_value": "Valore sconto",
    "Discount Value": "Valore sconto",
    "coupons.enter_discount_value": "Inserisci il valore dello sconto",
    "Enter discount value": "Inserisci il valore dello sconto",
    "coupons.code": "Codice",
    "coupons.code_example": "Es.: HOLIDAY10",
    "Ex: HOLIDAY10": "Es.: HOLIDAY10",
    "coupons.short_code": "Codice breve",
    "coupons.enter_short_code": "Inserisci il codice breve",
    "coupons.advanced": "AVANZATE",
    "ADVANCED": "AVANZATE",
    "coupons.minimum_amount": "Importo minimo",
    "coupons.enter_minimum_amount": "Inserisci l’importo minimo",
    "coupons.maximum_amount": "Importo massimo",
    "coupons.enter_maximum_amount": "Inserisci l’importo massimo",
    "coupons.maximum_discount_amount": "Importo massimo dello sconto",
    "Maximum Discount Amount": "Importo massimo dello sconto",
    "coupons.enter_maximum_discount_amount": "Inserisci l’importo massimo dello sconto",
    "Enter maximum discount amount": "Inserisci l’importo massimo dello sconto",
    "coupons.maximum_uses": "Utilizzi massimi",
    "Maximum Uses": "Utilizzi massimi",
    "coupons.enter_maximum_uses": "Inserisci il numero massimo di utilizzi",
    "Enter maximum uses": "Inserisci il numero massimo di utilizzi",
    "coupons.maximum_uses_per_user": "Utilizzi massimi per utente",
    "Maximum Uses Per User": "Utilizzi massimi per utente",
    "coupons.enter_maximum_uses_per_user": "Inserisci il numero massimo di utilizzi per utente",
    "Enter maximum uses per user": "Inserisci il numero massimo di utilizzi per utente",
    "coupons.new_user_only": "Solo nuovi utenti",
    "New User": "Solo nuovi utenti",
    "coupons.enter_note": "Inserisci una nota",
    "coupons.start_date_time": "Data e ora di inizio",
    "Start Date Time": "Data e ora di inizio",
    "coupons.end_date_time": "Data e ora di fine",
    "End Date Time": "Data e ora di fine",
    "coupons.select_start_date_time": "Seleziona data e ora di inizio",
    "Select start date time": "Seleziona data e ora di inizio",
    "coupons.select_end_date_time": "Seleziona data e ora di fine",
    "Select end date time": "Seleziona data e ora di fine",
    "coupons.flat_example": "Fisso (es.: 10 $)",
    "Flat (Ex: $10)": "Fisso (es.: 10 $)",
    "coupons.percentage_example": "Percentuale (es.: 10%)",
    "Percentage (Ex: 10%)": "Percentuale (es.: 10%)",
    "coupons.delete_confirm": "Vuoi eliminare questo coupon?",
    "Do you want to delete this coupon?": "Vuoi eliminare questo coupon?",
    "coupons.title": "Coupon",
    "coupons.header_name": "Nome",
    "coupons.header_code": "Codice",
    "coupons.header_coupon_type": "Tipo coupon",
    "Coupon Type": "Tipo coupon",
    "coupons.header_start_date_time": "Data e ora di inizio",
    "coupons.header_end_date_time": "Data e ora di fine",
    "coupons.header_active": "Attivo",
    "coupons.header_action": "Azione",
    "coupons.load_error": "Impossibile caricare questo coupon.",
    "Unable to load this coupon.": "Impossibile caricare questo coupon.",
    "coupons.expired": "Scaduto",
    "Expired": "Scaduto",
    "coupons.total_orders": "Ordini totali",
    "coupons.unique_customers": "Clienti unici",
    "Unique Customers": "Clienti unici",
    "coupons.revenue": "Ricavi",
    "coupons.average_transaction": "Transazione media",
    "Avg Transaction": "Transazione media",
    "coupons.paid_orders": "Ordini pagati",
    "coupons.uses_remaining": "Utilizzi rimanenti",
    "Uses Remaining": "Utilizzi rimanenti",
    "coupons.unlimited": "Illimitato",
    "Unlimited": "Illimitato",
    "coupons.performance": "Prestazioni",
    "Performance": "Prestazioni",
    "coupons.usage_against_limit": "Utilizzo rispetto al limite",
    "Usage against limit": "Utilizzo rispetto al limite",
    "coupons.details": "Dettagli",
    "coupons.discount": "Sconto",
    "coupons.minimum_order": "Ordine minimo",
    "Min order": "Ordine minimo",
    "coupons.maximum_discount": "Sconto massimo",
    "Max discount": "Sconto massimo",
    "coupons.maximum_total_uses": "Utilizzi massimi totali",
    "Max total uses": "Utilizzi massimi totali",
    "coupons.maximum_per_user": "Massimo per utente",
    "Max / user": "Massimo per utente",
    "coupons.new_users_only": "Solo nuovi utenti",
    "New users only": "Solo nuovi utenti",
    "coupons.valid_from": "Valido dal",
    "Valid from": "Valido dal",
    "coupons.valid_until": "Valido fino al",
    "Valid until": "Valido fino al",
    "coupons.orders": "Ordini",
    "coupons.no_orders": "Nessun ordine ha ancora utilizzato questo coupon",
    "No orders have used this coupon yet": "Nessun ordine ha ancora utilizzato questo coupon",
    "coupons.orders_header_order": "Ordine",
    "coupons.orders_header_customer": "Cliente",
    "coupons.orders_header_date": "Data",
    "coupons.orders_header_amount": "Importo",
    "coupons.orders_header_status": "Stato",
    "coupons.paid": "Pagato",
    "coupons.pending": "In attesa",
    "coupons.coupon": "Coupon",
    "coupons.detail_title": "Dettagli coupon",
    "Coupon Detail": "Dettagli coupon",
    "coupons.discount_percentage": "Sconto del {value}%",
    "{value}% off": "Sconto del {value}%",
    "coupons.discount_flat": "Sconto fisso di {value}",
    "{value} flat off": "Sconto fisso di {value}",
    "coupons.type_direct_discount": "Sconto diretto",
    "Direct discount": "Sconto diretto",
    "collections.condition_and": "E",
    "AND": "E",
    "collections.condition_or": "O",
    "OR": "O",
    "users.first_seen": "Visto per la prima volta",
    "First seen": "Visto per la prima volta",
    "users.last_seen": "Visto l’ultima volta",
    "Last seen": "Visto l’ultima volta",
    "users.avg_order": "Ordine medio",
    "Avg order": "Ordine medio",
    "users.purchase_value": "Valore acquisti",
    "Purchase value": "Valore acquisti",
    "users.price_range": "Fascia di prezzo",
    "Price range": "Fascia di prezzo",
    "users.attributes": "Attributi",
    "users.detail_title": "Dettagli utente",
    "User Detail": "Dettagli utente",
    "users.detail_orders_list": "Elenco ordini utente",
    "User Orders List": "Elenco ordini utente",
    "users.confirm_user_action": "{action} {name}?",
    "{action} {name}?": "{action} {name}?",
    "users.as_buyer": "Come acquirente",
    "As a Buyer": "Come acquirente",
    "users.as_seller": "Come venditore",
    "As a Seller": "Come venditore",
    "users.health": "Stato",
    "users.no_listings": "Nessuna inserzione",
    "users.no_accounts": "Nessun account",
    "No accounts yet": "Nessun account",
    "users.top_categories": "Categorie principali",
    "Top categories": "Categorie principali",
    "users.top_listings": "Inserzioni principali",
    "Top listings": "Inserzioni principali",
    "users.recent_activity": "Attività recente",
    "Recent activity": "Attività recente",
    "users.acquisition": "Acquisizione",
    "Acquisition": "Acquisizione",
    "users.sent_emails": "Email inviate",
    "Sent Emails": "Email inviate",
    "users.no_emails_sent": "Nessuna email inviata",
    "No emails sent": "Nessuna email inviata",
    "users.load_more_emails": "Carica altro ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Carica altro ({loaded} / {total})",
    "users.email_to": "A: {email}",
    "To: {email}": "A: {email}",
    "users.sending_email": "Invio…",
    "users.send_email": "Invia email",
    "Send Email": "Invia email",
    "users.send_email_title": "Invia email — {name}",
    "Send Email — {name}": "Invia email — {name}",
    "users.customer": "Cliente",
    "users.block_named": "Blocca {name}",
    "Block {name}": "Blocca {name}",
    "users.unblock_named": "Sblocca {name}",
    "Unblock {name}": "Sblocca {name}",
    "users.email_sent": "Email inviata correttamente",
    "Email sent successfully": "Email inviata correttamente",
    "users.email_send_failed": "Invio email non riuscito",
    "Failed to send email": "Invio email non riuscito",
    "common.value": "Valore",
    "users.email_bounced": "Email respinta",
    "Bounced": "Email respinta",
    "users.email_complained": "Email segnalata",
    "Complained": "Email segnalata",
    "users.unverified": "Non verificato",
    "Unverified": "Non verificato",
    "users.otp_enabled": "OTP attivo",
    "OTP Enabled": "OTP attivo",
    "users.account_info": "Informazioni account",
    "Account Info": "Informazioni account",
    "users.mobile": "Cellulare",
    "users.locale": "Lingua e area geografica",
    "Locale": "Lingua e area geografica",
    "users.joined": "Iscritto il",
    "users.following": "Seguiti",
    "Following": "Seguiti",
    "users.email_health": "Stato email",
    "Email Health": "Stato email",
    "users.orders": "Ordini",
    "users.no_orders": "Nessun ordine",
    "No orders": "Nessun ordine",
    "users.order_reference": "Ordine {number}",
    "Order {number}": "Ordine {number}",
    "users.order_ref": "Rif.: {reference}",
    "Ref: {reference}": "Rif.: {reference}",
    "users.unpaid": "Non pagato",
    "users.revenue_ltv": "Ricavi e LTV",
    "Revenue & LTV": "Ricavi e LTV",
    "users.total_spent": "Totale speso",
    "Total Spent": "Totale speso",
    "users.paid_order_count": "{count} ordini pagati",
    "{count} paid orders": "{count} ordini pagati",
    "users.average_order": "Ordine medio",
    "users.of_total_orders": "su {count} totali",
    "of {count} total": "su {count} totali",
    "users.gmv": "GMV",
    "GMV": "GMV",
    "users.active_count": "{count} attivi",
    "{count} active": "{count} attivi",
    "users.at_risk": "A rischio",
    "At Risk": "A rischio",
    "common.today": "Oggi",
    "common.yesterday": "Ieri",
    "Yesterday": "Ieri",
    "users.days_ago": "{count} giorni fa",
    "{count} days ago": "{count} giorni fa",
    "users.months_ago": "{count} mesi fa",
    "{count} months ago": "{count} mesi fa",
    "users.years_ago": "{count} anni fa",
    "{count} years ago": "{count} anni fa",
    "users.last_order": "Ultimo ordine",
    "Last order": "Ultimo ordine",
    "users.last_listing": "Ultima inserzione",
    "Last listing": "Ultima inserzione",
    "users.events": "Eventi",
    "users.viewed": "Visualizzato",
    "Viewed": "Visualizzato",
    "users.cart": "Carrello",
    "users.checkouts": "Checkout",
    "Checkouts": "Checkout",
    "users.purchases": "Acquisti",
    "Purchases": "Acquisti",
    "users.last_30_days": "Ultimi 30 giorni",
    "Last 30 days": "Ultimi 30 giorni",
    "users.no_analytics": "Nessun dato analitico per questo utente.",
    "No analytics data for this user yet.": "Nessun dato analitico per questo utente.",
    "users.analytics_unavailable": "Analisi non disponibile per questo tenant.",
    "Analytics unavailable for this tenant.": "Analisi non disponibile per questo tenant.",
    "users.account_number": "Account n. {number}",
    "Account #{number}": "Account n. {number}",
    "users.no_subject": "Senza oggetto",
    "No Subject": "Senza oggetto",
    "common.unknown": "Sconosciuto",
    "users.opened": "Aperto",
    "Opened": "Aperto",
    "users.not_opened": "Non aperto",
    "Not opened": "Non aperto",
    "users.user_action_success": "Azione utente completata",
    "User action completed": "Azione utente completata",
    "common.pending": "In attesa",
    "common.never": "Mai",
    "users.customer_analytics": "Analisi clienti",
    "Customer Analytics": "Analisi clienti",
    "users.analytics": "Analisi",
    "users.emails": "Email",
    "Emails": "Email",
    "users.first_visit": "Prima visita",
    "First visit": "Prima visita",
    "users.latest_visit": "Ultima visita",
    "Latest visit": "Ultima visita",
    "users.landing_page": "Pagina di destinazione",
    "Landing page": "Pagina di destinazione",
    "users.referrer": "Referrer",
    "Referrer": "Referrer",
    "users.utm_source": "Sorgente UTM",
    "UTM source": "Sorgente UTM",
    "users.utm_medium": "Mezzo UTM",
    "UTM medium": "Mezzo UTM",
    "users.utm_campaign": "Campagna UTM",
    "UTM campaign": "Campagna UTM",
    "users.utm_term": "Termine UTM",
    "UTM term": "Termine UTM",
    "users.utm_content": "Contenuto UTM",
    "UTM content": "Contenuto UTM",
    "users.ai_source": "Sorgente AI",
    "AI source": "Sorgente AI",
    "rewards.edit_scope": "Modifica ambito",
    "Edit scope": "Modifica ambito",
    "rewards.add_scope": "Aggiungi ambito",
    "Add scope": "Aggiungi ambito",
    "rewards.save_scope": "Salva ambito",
    "Save scope": "Salva ambito",
    "rewards.scope_type": "Tipo ambito",
    "Scope type": "Tipo ambito",
    "rewards.scope_reference": "Riferimento ambito",
    "Scope reference": "Riferimento ambito",
    "rewards.match_config": "Configurazione corrispondenza",
    "Match config": "Configurazione corrispondenza",
    "rewards.priority_order": "Ordine di priorità",
    "Priority order": "Ordine di priorità",
    "rewards.active": "Attivo",
    "rewards.scope_active": "Ambito attivo",
    "Scope is active": "Ambito attivo",
    "rewards.edit_rule": "Modifica regola",
    "Edit rule": "Modifica regola",
    "rewards.add_rule": "Aggiungi regola",
    "Add rule": "Aggiungi regola",
    "rewards.save_rule": "Salva regola",
    "Save rule": "Salva regola",
    "rewards.trigger_event": "Evento di attivazione",
    "Trigger event": "Evento di attivazione",
    "rewards.beneficiary_type": "Tipo beneficiario",
    "Beneficiary type": "Tipo beneficiario",
    "rewards.beneficiary_config": "Configurazione beneficiario",
    "Beneficiary config": "Configurazione beneficiario",
    "rewards.eligibility": "Idoneità",
    "Eligibility": "Idoneità",
    "rewards.conditions": "Condizioni",
    "rewards.priority": "Priorità",
    "Priority": "Priorità",
    "rewards.edit_component": "Modifica componente della ricetta",
    "Edit recipe component": "Modifica componente della ricetta",
    "rewards.add_component": "Aggiungi componente ricetta",
    "Add recipe component": "Aggiungi componente ricetta",
    "rewards.save_component": "Salva componente",
    "Save component": "Salva componente",
    "rewards.rule": "Regola",
    "Rule": "Regola",
    "rewards.component_key": "Chiave componente",
    "Component key": "Chiave componente",
    "rewards.component_type": "Tipo componente",
    "Component type": "Tipo componente",
    "rewards.commission_definition": "Definizione commissione",
    "Commission definition": "Definizione commissione",
    "rewards.config": "Configurazione",
    "rewards.position": "Posizione",
    "Position": "Posizione",
    "rewards.component": "Componente",
    "Component": "Componente",
    "rewards.status.draft": "Bozza",
    "rewards.status.active": "Attivo",
    "rewards.status.paused": "In pausa",
    "Paused": "In pausa",
    "rewards.status.archived": "Archiviato",
    "rewards.configuration_updated": "Configurazione premi aggiornata",
    "Reward configuration updated": "Configurazione premi aggiornata",
    "rewards.configuration_added": "Configurazione premi aggiunta",
    "Reward configuration added": "Configurazione premi aggiunta",
    "rewards.archive_item_confirm": "Archiviare {name}?",
    "Archive {name}?": "Archiviare {name}?",
    "rewards.empty_scopes": "Nessun ambito configurato.",
    "No scopes configured yet.": "Nessun ambito configurato.",
    "rewards.empty_rules": "Nessuna regola configurata.",
    "No rules configured yet.": "Nessuna regola configurata.",
    "rewards.empty_components": "Nessun componente configurato.",
    "No components configured yet.": "Nessun componente configurato.",
    "rewards.edit_program": "Modifica programma premi",
    "Edit reward program": "Modifica programma premi",
    "rewards.new_program": "Nuovo programma premi",
    "New reward program": "Nuovo programma premi",
    "rewards.create_program": "Crea programma",
    "Create program": "Crea programma",
    "rewards.program_type": "Tipo programma",
    "Program type": "Tipo programma",
    "rewards.starts_at": "Inizio",
    "Starts at": "Inizio",
    "rewards.ends_at": "Fine",
    "Ends at": "Fine",
    "rewards.program_updated": "Programma premi aggiornato",
    "Reward program updated": "Programma premi aggiornato",
    "rewards.program_created": "Programma premi creato",
    "Reward program created": "Programma premi creato",
    "rewards.archive_program_confirm": "Archiviare {name}?",
    "rewards.program_archived": "Programma premi archiviato",
    "Reward program archived": "Programma premi archiviato",
    "rewards.tab.overview": "Panoramica",
    "rewards.tab.programs": "Programmi",
    "Programs": "Programmi",
    "rewards.tab.impact": "Impatto",
    "Impact": "Impatto",
    "rewards.tab.attribution": "Attribuzione",
    "Tracking": "Attribuzione",
    "rewards.page_description": "Crea e gestisci programmi premi, idoneità, regole e componenti. Gli ordini completati vengono aggiunti automaticamente ai report.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Crea e gestisci programmi premi, idoneità, regole e componenti. Gli ordini completati vengono aggiunti automaticamente ai report.",
    "rewards.program": "Programma",
    "Program": "Programma",
    "rewards.starts": "Inizio",
    "Starts": "Inizio",
    "rewards.no_programs": "Nessun programma premi.",
    "No reward programs yet.": "Nessun programma premi.",
    "rewards.program_title": "Programma premi",
    "Reward program": "Programma premi",
    "rewards.back_to_rewards": "Torna ai premi",
    "Back to rewards": "Torna ai premi",
    "common.archive": "Archivia",
    "Archive": "Archivia",
    "common.save_changes": "Salva modifiche",
    "common.none": "Nessuno",
    "common.this_item": "questo elemento",
    "this item": "questo elemento",
    "rewards.tab.scopes": "Ambiti",
    "Scopes": "Ambiti",
    "rewards.tab.rules": "Regole",
    "Rules": "Regole",
    "rewards.tab.components": "Componenti premio",
    "Recipe components": "Componenti premio",
    "rewards.reference": "Riferimento",
    "rewards.trigger": "Trigger",
    "Trigger": "Trigger",
    "rewards.beneficiary": "Beneficiario",
    "Beneficiary": "Beneficiario",
    "rewards.attributed_conversions": "Conversioni attribuite",
    "Attributed conversions": "Conversioni attribuite",
    "rewards.new_customers": "Nuovi clienti",
    "New customers": "Nuovi clienti",
    "rewards.revenue_influenced": "Ricavi influenzati",
    "Revenue influenced": "Ricavi influenzati",
    "rewards.rewards_issued": "Premi assegnati",
    "Rewards issued": "Premi assegnati",
    "rewards.live_business_results": "Risultati aziendali aggiornati",
    "Live business results": "Risultati aziendali aggiornati",
    "rewards.impact_at_a_glance": "Impatto in sintesi",
    "Impact at a glance": "Impatto in sintesi",
    "rewards.impact_last_30_days": "Vista aggiornata degli ordini completati e dei risultati dei partner negli ultimi 30 giorni.",
    "A live view of completed orders and partner results from the last 30 days.": "Vista aggiornata degli ordini completati e dei risultati dei partner negli ultimi 30 giorni.",
    "rewards.view_full_impact": "Visualizza impatto completo",
    "View full impact": "Visualizza impatto completo",
    "rewards.impact_load_error": "Impossibile caricare i dati sull’impatto: {error}",
    "Impact data could not be loaded: {error}": "Impossibile caricare i dati sull’impatto: {error}",
    "rewards.programs": "Programmi",
    "rewards.programs_configured": "Programmi premi configurati per questa area di lavoro.",
    "Reward programs configured for this workspace.": "Programmi premi configurati per questa area di lavoro.",
    "rewards.programs_eligible": "Programmi attualmente idonei alla valutazione.",
    "Programs currently eligible for evaluation.": "Programmi attualmente idonei alla valutazione.",
    "rewards.drafts": "Bozze",
    "Drafts": "Bozze",
    "rewards.programs_being_configured": "Programmi ancora in fase di configurazione.",
    "Programs still being configured.": "Programmi ancora in fase di configurazione.",
    "rewards.clicks": "Clic",
    "rewards.completed_orders": "Ordini completati",
    "Completed orders": "Ordini completati",
    "rewards.conversion_rate": "Tasso di conversione",
    "Conversion rate": "Tasso di conversione",
    "rewards.revenue": "Ricavi",
    "rewards.live_connection": "Connessione attiva",
    "Live connection": "Connessione attiva",
    "rewards.attribution_activity": "Attività di attribuzione",
    "Attribution activity": "Attività di attribuzione",
    "rewards.connected_workspace": "Connesso a {name}.",
    "Connected to {name}.": "Connesso a {name}.",
    "rewards.your_attribution_workspace": "la tua area di lavoro Attribution",
    "your Attribution workspace": "la tua area di lavoro Attribution",
    "rewards.loading_workspace": "Caricamento dell’area Attribution collegata.",
    "Loading your connected Attribution workspace.": "Caricamento dell’area Attribution collegata.",
    "rewards.open_attribution": "Apri Attribution",
    "Open Attribution": "Apri Attribution",
    "rewards.connection_attention": "La connessione richiede attenzione",
    "Connection needs attention": "La connessione richiede attenzione",
    "rewards.open_attribution_workspace": "Apri area di lavoro Attribution",
    "Open Attribution workspace": "Apri area di lavoro Attribution",
    "rewards.workspace_connected": "Area di lavoro connessa",
    "Workspace connected": "Area di lavoro connessa",
    "rewards.workspace_not_linked": "Area di lavoro non collegata",
    "Workspace not linked yet": "Area di lavoro non collegata",
    "rewards.attribution_data_connected": "I dati aggiornati su clic, link, campagne e ordini completati provengono da Attribution.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "I dati aggiornati su clic, link, campagne e ordini completati provengono da Attribution.",
    "rewards.connect_workspace_prompt": "Apri Attribution e collega quest’area di lavoro per monitorare le attività.",
    "Open Attribution to connect this workspace before tracking activity.": "Apri Attribution e collega quest’area di lavoro per monitorare le attività.",
    "rewards.successful_referrals": "Referral riusciti",
    "Successful referrals": "Referral riusciti",
    "rewards.new_customers_acquired": "Nuovi clienti acquisiti",
    "New customers acquired": "Nuovi clienti acquisiti",
    "rewards.gross_revenue_influenced": "Ricavi lordi influenzati",
    "Gross revenue influenced": "Ricavi lordi influenzati",
    "rewards.reward_cost": "Costo dei premi",
    "Reward cost": "Costo dei premi",
    "rewards.net_revenue": "Ricavi netti",
    "Net revenue": "Ricavi netti",
    "rewards.average_order_value": "Valore medio ordine",
    "Average order value": "Valore medio ordine",
    "rewards.cost_per_acquisition": "Costo di acquisizione",
    "Cost per acquisition": "Costo di acquisizione",
    "rewards.repeat_purchase_rate": "Tasso di acquisto ripetuto",
    "Repeat purchase rate": "Tasso di acquisto ripetuto",
    "rewards.business_outcome_reporting": "Report sui risultati aziendali",
    "Business outcome reporting": "Report sui risultati aziendali",
    "rewards.impact": "Impatto",
    "rewards.impact_description": "Conversioni, acquisizione clienti, ricavi influenzati e costo dei premi nel periodo selezionato.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Conversioni, acquisizione clienti, ricavi influenzati e costo dei premi nel periodo selezionato.",
    "rewards.from": "Da",
    "rewards.to": "A",
    "rewards.trend": "Andamento",
    "Trend": "Andamento",
    "rewards.daily": "Giornaliero",
    "rewards.weekly": "Settimanale",
    "Weekly": "Settimanale",
    "rewards.top_partners": "Partner / referrer principali",
    "Top partners / referrers": "Partner / referrer principali",
    "rewards.partner": "Partner",
    "Partner": "Partner",
    "rewards.conversions": "Conversioni",
    "Conversions": "Conversioni",
    "rewards.no_partner_data": "Nessun dato sui partner attribuiti per questo periodo.",
    "No attributed partner data for this period.": "Nessun dato sui partner attribuiti per questo periodo.",
    "rewards.period": "Periodo",
    "rewards.no_trend_data": "Nessun dato sull’andamento per questo periodo.",
    "No trend data for this period.": "Nessun dato sull’andamento per questo periodo.",
    "rewards.campaign_performance": "Prestazioni campagne",
    "Campaign performance": "Prestazioni campagne",
    "rewards.campaign_count": "{count} campagne",
    "{count} campaigns": "{count} campagne",
    "rewards.campaign": "Campagna",
    "rewards.orders": "Ordini",
    "rewards.rate": "Tasso",
    "Rate": "Tasso",
    "rewards.no_campaign_activity": "Nessuna attività di campagna. Crea un link di tracciamento in Attribution per iniziare a misurare i risultati.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Nessuna attività di campagna. Crea un link di tracciamento in Attribution per iniziare a misurare i risultati.",
    "rewards.recent_completed_orders": "Ordini completati di recente",
    "Recent completed orders": "Ordini completati di recente",
    "rewards.recent_events_count": "{count} eventi recenti",
    "{count} recent events": "{count} eventi recenti",
    "rewards.event": "Evento",
    "rewards.completed_order": "Ordine completato",
    "Completed order": "Ordine completato",
    "rewards.no_completed_order_activity": "Nessuna attività di ordini completati.",
    "No completed order activity has arrived yet.": "Nessuna attività di ordini completati.",
    "rewards.impact_data_quality_note": "Volume dei clic e tasso di conversione non sono disponibili finché non viene collegato l’aggregato dei clic Attribution. Il costo dei premi usa le righe approvate o emesse del registro; i rimborsi non sono ancora inclusi.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Volume dei clic e tasso di conversione non sono disponibili finché non viene collegato l’aggregato dei clic Attribution. Il costo dei premi usa le righe approvate o emesse del registro; i rimborsi non sono ancora inclusi.",
    "subscriptions.type.free": "Abbonamento gratuito",
    "Free Subscription": "Abbonamento gratuito",
    "subscriptions.form.title_placeholder": "Titolo abbonamento",
    "Subscription Title": "Titolo abbonamento",
    "subscriptions.form.title_help": "Inserisci un titolo descrittivo per il piano (ad es. “Premium”, “Base”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Inserisci un titolo descrittivo per il piano (ad es. “Premium”, “Base”).",
    "subscriptions.form.description_placeholder": "Descrizione abbonamento",
    "Subscription Description": "Descrizione abbonamento",
    "subscriptions.form.description_help": "Descrivi in dettaglio l’abbonamento, le sue funzionalità e i vantaggi.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Descrivi in dettaglio l’abbonamento, le sue funzionalità e i vantaggi.",
    "subscriptions.form.select_currency": "Seleziona valuta",
    "Select Currency": "Seleziona valuta",
    "subscriptions.form.currency_help": "Seleziona la valuta dell’abbonamento dall’elenco (valuta predefinita).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Seleziona la valuta dell’abbonamento dall’elenco (valuta predefinita).",
    "subscriptions.form.amount_placeholder": "Importo abbonamento",
    "Subscription Amount": "Importo abbonamento",
    "subscriptions.form.amount_help": "Inserisci il prezzo dell’abbonamento.",
    "Enter the subscription price.": "Inserisci il prezzo dell’abbonamento.",
    "subscriptions.form.sku_placeholder": "SKU abbonamento",
    "Subscription SKU": "SKU abbonamento",
    "subscriptions.form.sku_help": "Inserisci un identificativo univoco per semplificare i dati e il monitoraggio.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Inserisci un identificativo univoco per semplificare i dati e il monitoraggio.",
    "subscriptions.form.allowed_listings": "Inserzioni consentite",
    "Allowed Listings": "Inserzioni consentite",
    "subscriptions.form.allowed_listings_placeholder": "Numero di inserzioni consentite",
    "Subscription Allowed Listings": "Numero di inserzioni consentite",
    "subscriptions.form.allowed_listings_help": "Specifica il numero di inserzioni consentite per questo abbonamento.",
    "Specify the number of listings allowed for this subscription.": "Specifica il numero di inserzioni consentite per questo abbonamento.",
    "subscriptions.form.fixed_fee_per_order": "Commissione fissa per ordine",
    "Fixed Fee Per Order": "Commissione fissa per ordine",
    "subscriptions.form.fixed_fee_placeholder": "Commissione fissa per ordine",
    "Subscription Fee Fixed Per Order": "Commissione fissa per ordine",
    "subscriptions.form.fixed_fee_help": "Inserisci una commissione fissa per ordine, se prevista.",
    "Enter a fixed fee per order, if applicable.": "Inserisci una commissione fissa per ordine, se prevista.",
    "subscriptions.form.commission_percent_per_order": "Commissione per ordine, %",
    "Commission % Per Order": "Commissione per ordine, %",
    "subscriptions.form.commission_placeholder": "Commissione per ordine, %",
    "Subscription Commission Percent Per Order": "Commissione per ordine, %",
    "subscriptions.form.commission_help": "Inserisci la percentuale di commissione per ordine, se prevista.",
    "Enter the commission percentage per order, if applicable.": "Inserisci la percentuale di commissione per ordine, se prevista.",
    "subscriptions.form.expiry_days": "Giorni alla scadenza",
    "Expiry Days": "Giorni alla scadenza",
    "subscriptions.form.expiry_days_placeholder": "Giorni di validità dell’abbonamento",
    "Subscription Expiry Days": "Giorni di validità dell’abbonamento",
    "subscriptions.form.expiry_days_help": "Imposta i giorni alla scadenza dell’abbonamento. Ad esempio: 7 o 30 giorni.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Imposta i giorni alla scadenza dell’abbonamento. Ad esempio: 7 o 30 giorni.",
    "subscriptions.form.payment_method": "Metodo di pagamento",
    "subscriptions.form.select_type": "Seleziona tipo",
    "subscriptions.form.payment_method_help": "Seleziona i metodi di pagamento supportati (ad es. Stripe, MangoPay, Android, iOS o Abbonamento gratuito).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Seleziona i metodi di pagamento supportati (ad es. Stripe, MangoPay, Android, iOS o Abbonamento gratuito).",
    "subscriptions.form.active_placeholder": "Abbonamento attivo",
    "Subscription Active": "Abbonamento attivo",
    "subscriptions.form.active_help": "Attiva o disattiva l’abbonamento. Un abbonamento attivo è acquistabile.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Attiva o disattiva l’abbonamento. Un abbonamento attivo è acquistabile.",
    "subscriptions.add_title": "Aggiungi prodotto in abbonamento",
    "Add new subscription product": "Aggiungi prodotto in abbonamento",
    "subscriptions.edit_title": "Modifica prodotto in abbonamento",
    "Edit subscription product": "Modifica prodotto in abbonamento",
    "subscriptions.added_success": "Inserzione abbonamento aggiunta correttamente",
    "Subscription listing added successfully": "Inserzione abbonamento aggiunta correttamente",
    "subscriptions.updated_success": "Inserzione abbonamento aggiornata correttamente",
    "Subscription listing updated successfully": "Inserzione abbonamento aggiornata correttamente",
    "common.currency": "Valuta",
    "common.sku": "SKU",
    "subscriptions.title": "Abbonamenti",
    "subscriptions.add_subscription": "Aggiungi abbonamento",
    "Add subscription": "Aggiungi abbonamento",
    "subscriptions.plans": "Piani",
    "subscriptions.active_subscribers": "Abbonati attivi",
    "Active Subscribers": "Abbonati attivi",
    "subscriptions.total_mrr": "MRR totale",
    "Total MRR": "MRR totale",
    "subscriptions.churn_rate": "Tasso di abbandono",
    "Churn Rate": "Tasso di abbandono",
    "subscriptions.new_this_month": "Nuovi questo mese",
    "New This Month": "Nuovi questo mese",
    "subscriptions.average_duration": "Durata media",
    "Avg Duration": "Durata media",
    "subscriptions.monthly_recurring_revenue": "Ricavi ricorrenti mensili",
    "Monthly Recurring Revenue": "Ricavi ricorrenti mensili",
    "subscriptions.annual_run_rate": "Ricavi annualizzati",
    "Annual Run Rate": "Ricavi annualizzati",
    "subscriptions.last_30_days": "Ultimi 30 giorni",
    "subscriptions.subscriber_lifetime": "Durata abbonamento",
    "Subscriber lifetime": "Durata abbonamento",
    "subscriptions.subscriber_distribution": "Distribuzione abbonati",
    "Subscriber Distribution": "Distribuzione abbonati",
    "subscriptions.billing_period": "Periodo di fatturazione",
    "Billing Period": "Periodo di fatturazione",
    "subscriptions.allowed_listings": "Inserzioni consentite",
    "subscriptions.commission_per_order": "Commissione per ordine",
    "Commission per Order": "Commissione per ordine",
    "subscriptions.fixed_fee_per_order": "Commissione fissa per ordine",
    "Fixed Fee per Order": "Commissione fissa per ordine",
    "subscriptions.payment_provider": "Provider di pagamento",
    "Payment Provider": "Provider di pagamento",
    "subscriptions.sku_product_id": "SKU / ID prodotto",
    "SKU / Product ID": "SKU / ID prodotto",
    "subscriptions.revenue_over_time": "Ricavi nel tempo",
    "Revenue Over Time": "Ricavi nel tempo",
    "subscriptions.revenue": "Ricavi",
    "subscriptions.subscriber_growth": "Crescita abbonati",
    "Subscriber Growth": "Crescita abbonati",
    "subscriptions.subscribers": "Abbonati",
    "Subscribers": "Abbonati",
    "subscriptions.set_inactive": "Disattiva",
    "Set Inactive": "Disattiva",
    "subscriptions.set_active": "Attiva",
    "Set Active": "Attiva",
    "subscriptions.plan_title": "Piano abbonamento",
    "Subscription Plan": "Piano abbonamento",
    "subscriptions.status.active": "Attivo",
    "subscriptions.status.cancelled": "Annullato",
    "subscriptions.status.expired": "Scaduto",
    "subscriptions.status.trial": "Prova",
    "Trial": "Prova",
    "subscriptions.status.pending": "In attesa",
    "subscriptions.period.lifetime": "A vita",
    "Lifetime": "A vita",
    "subscriptions.period.daily": "Giornaliero",
    "subscriptions.period.weekly": "Settimanale",
    "subscriptions.period.monthly": "Mensile",
    "Monthly": "Mensile",
    "subscriptions.period.quarterly": "Trimestrale",
    "Quarterly": "Trimestrale",
    "subscriptions.period.semi_annual": "Semestrale",
    "Semi-annual": "Semestrale",
    "subscriptions.period.annual": "Annuale",
    "Annual": "Annuale",
    "subscriptions.period.days": "{count} giorni",
    "subscriptions.period.day": "/ giorno",
    "/ day": "/ giorno",
    "subscriptions.period.week": "/ settimana",
    "/ week": "/ settimana",
    "subscriptions.period.month": "/ mese",
    "/ month": "/ mese",
    "subscriptions.period.quarter": "/ trimestre",
    "/ quarter": "/ trimestre",
    "subscriptions.period.six_months": "/ 6 mesi",
    "/ 6 months": "/ 6 mesi",
    "subscriptions.period.year": "/ anno",
    "/ year": "/ anno",
    "subscriptions.listings_count": "{count} inserzioni",
    "{count} listings": "{count} inserzioni",
    "subscriptions.commission_percentage": "Commissione {rate}%",
    "{rate}% commission": "Commissione {rate}%",
    "subscriptions.per_order": "/ ordine",
    "/ order": "/ ordine",
    "subscriptions.view_details_subscribers": "Visualizza dettagli e abbonati",
    "View details and subscribers": "Visualizza dettagli e abbonati",
    "subscriptions.edit_subscription": "Modifica abbonamento",
    "Edit subscription": "Modifica abbonamento",
    "subscriptions.delete_subscription": "Elimina abbonamento",
    "Delete subscription": "Elimina abbonamento",
    "subscriptions.deleted": "Abbonamento eliminato",
    "Subscription deleted": "Abbonamento eliminato",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Acquisti in-app Android",
    "Android IAP": "Acquisti in-app Android",
    "subscriptions.type.ios": "Acquisti in-app iOS",
    "iOS IAP": "Acquisti in-app iOS",
    "subscriptions.type.free_subscription": "Gratis",
    "subscriptions.type.mangopay": "MangoPay",
    "Mangopay": "MangoPay",
    "subscriptions.loaded_count": "{count} caricati",
    "subscriptions.no_subscribers": "Nessun abbonato con stato {status}.",
    "No {status} subscribers.": "Nessun abbonato con stato {status}.",
    "subscriptions.billing_records": "Registrazioni di fatturazione",
    "Billing Records": "Registrazioni di fatturazione",
    "subscriptions.no_invoices": "Nessuna fattura trovata.",
    "No invoices found.": "Nessuna fattura trovata.",
    "subscriptions.column.account": "Account",
    "subscriptions.column.email": "Email",
    "subscriptions.column.status": "Stato",
    "subscriptions.column.subscribed": "Iscritto il",
    "Subscribed": "Iscritto il",
    "subscriptions.column.expires": "Scade",
    "subscriptions.column.next_renewal": "Prossimo rinnovo",
    "Next Renewal": "Prossimo rinnovo",
    "subscriptions.column.amount_paid": "Importo pagato",
    "Amount Paid": "Importo pagato",
    "subscriptions.invoice_column.invoice_id": "ID fattura",
    "Invoice ID": "ID fattura",
    "subscriptions.invoice_column.account": "Account",
    "subscriptions.invoice_column.amount": "Importo",
    "subscriptions.invoice_column.status": "Stato",
    "subscriptions.invoice_column.period": "Periodo",
    "subscriptions.invoice_column.paid_at": "Pagato il",
    "Paid At": "Pagato il",
    "subscriptions.validation.title_required": "Il titolo è obbligatorio",
    "subscriptions.validation.allowed_listings_positive": "Le inserzioni consentite devono essere più di 0",
    "Allowed listings should be greater than 0": "Le inserzioni consentite devono essere più di 0",
    "subscriptions.validation.currency_required": "La valuta è obbligatoria",
    "Currency is required": "La valuta è obbligatoria",
    "subscriptions.validation.expiry_required": "I giorni di scadenza sono obbligatori",
    "Expiry days are required": "I giorni di scadenza sono obbligatori",
    "subscriptions.validation.payment_method_required": "Il metodo di pagamento è obbligatorio",
    "Payment method is required": "Il metodo di pagamento è obbligatorio",
    "subscriptions.error.save": "Si è verificato un errore durante il salvataggio dell’abbonamento.",
    "Something went wrong while saving the subscription.": "Si è verificato un errore durante il salvataggio dell’abbonamento.",
    "subscriptions.error.delete": "Si è verificato un errore durante l’eliminazione dell’abbonamento.",
    "Something went wrong while deleting the subscription.": "Si è verificato un errore durante l’eliminazione dell’abbonamento.",
    "common.configuration": "Configurazione",
    "subscriptions.per_period": "per {period}",
    "per {period}": "per {period}",
    "subscriptions.tab.subscribers": "Abbonati",
    "subscriptions.tab.invoices": "Fatture",
    "subscriptions.account_title": "Abbonamento account",
    "Account Subscription": "Abbonamento account",
    "subscriptions.config.description": "Gestisci gli abbonamenti account. Se attivi, i proprietari devono avere un abbonamento attivo per pubblicare inserzioni. Per i pagamenti viene usato il gateway predefinito selezionato in Metodo di pagamento.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Gestisci gli abbonamenti account. Se attivi, i proprietari devono avere un abbonamento attivo per pubblicare inserzioni. Per i pagamenti viene usato il gateway predefinito selezionato in Metodo di pagamento.",
    "subscriptions.config.enable": "Abilita abbonamenti",
    "Enable subscriptions": "Abilita abbonamenti",
    "subscriptions.config.type": "Tipo di abbonamento",
    "Subscription type": "Tipo di abbonamento",
    "subscriptions.config.purchased_message": "Messaggio se l’abbonamento è già acquistato",
    "Message when a subscription is already purchased": "Messaggio se l’abbonamento è già acquistato",
    "subscriptions.config.purchased_placeholder": "Inserisci il messaggio per un abbonamento già acquistato",
    "Enter the already-purchased message": "Inserisci il messaggio per un abbonamento già acquistato",
    "subscriptions.config.listings_exhausted_message": "Messaggio al raggiungimento del limite di inserzioni",
    "Message when the listing limit is reached": "Messaggio al raggiungimento del limite di inserzioni",
    "subscriptions.config.listings_exhausted_placeholder": "Inserisci il messaggio sul limite di inserzioni",
    "Enter the listing limit message": "Inserisci il messaggio sul limite di inserzioni",
    "subscriptions.config.inactive_message": "Messaggio per abbonamento inattivo",
    "Message when the subscription is inactive": "Messaggio per abbonamento inattivo",
    "subscriptions.config.inactive_placeholder": "Inserisci il messaggio per un abbonamento inattivo",
    "Enter the inactive subscription message": "Inserisci il messaggio per un abbonamento inattivo",
    "subscriptions.config.saved": "Impostazioni abbonamento salvate correttamente",
    "Subscription settings saved successfully": "Impostazioni abbonamento salvate correttamente",
    "people.title": "Personale",
    "people.tab.staff": "Personale",
    "Staff": "Personale",
    "people.tab.departments": "Reparti",
    "Departments": "Reparti",
    "people.tab.job_profiles": "Profili professionali",
    "Job profiles": "Profili professionali",
    "people.tab.pay_grades": "Fasce retributive",
    "Pay grades": "Fasce retributive",
    "people.action.add_staff": "Aggiungi personale",
    "Add staff": "Aggiungi personale",
    "people.action.add_department": "Aggiungi reparto",
    "Add department": "Aggiungi reparto",
    "people.action.add_job_profile": "Aggiungi profilo professionale",
    "Add job profile": "Aggiungi profilo professionale",
    "people.action.add_pay_grade": "Aggiungi fascia retributiva",
    "Add pay grade": "Aggiungi fascia retributiva",
    "people.currency_id": "ID valuta",
    "people.onboarding.eyebrow": "Inizia con il personale",
    "Get started with People": "Inizia con il personale",
    "people.onboarding.title": "Crea la directory del team",
    "Build your team directory": "Crea la directory del team",
    "people.onboarding.description": "Aggiungi il primo membro del personale, poi organizza il team per reparti, ruoli e fasce retributive.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "Aggiungi il primo membro del personale, poi organizza il team per reparti, ruoli e fasce retributive.",
    "people.onboarding.add_first": "Aggiungi il primo membro del personale",
    "Add your first staff member": "Aggiungi il primo membro del personale",
    "people.onboarding.step_staff": "Aggiungi personale",
    "people.onboarding.step_staff_description": "Collega un utente esistente alla directory del personale.",
    "Link an existing user to your staff directory.": "Collega un utente esistente alla directory del personale.",
    "people.onboarding.step_teams": "Organizza i team",
    "Organize teams": "Organizza i team",
    "people.onboarding.step_teams_description": "Crea reparti e profili professionali man mano che cresci.",
    "Create departments and job profiles as you grow.": "Crea reparti e profili professionali man mano che cresci.",
    "people.onboarding.step_pay": "Definisci la retribuzione",
    "Set compensation": "Definisci la retribuzione",
    "people.onboarding.step_pay_description": "Definisci fasce retributive per impostare le paghe in modo coerente.",
    "Define pay grades for consistent payroll setup.": "Definisci fasce retributive per impostare le paghe in modo coerente.",
    "people.staff_profile": "Profilo personale",
    "Staff profile": "Profilo personale",
    "people.field.employee_code": "Codice dipendente",
    "Employee code": "Codice dipendente",
    "people.field.job_title": "Titolo professionale",
    "Job title": "Titolo professionale",
    "people.field.department": "Reparto",
    "Department": "Reparto",
    "people.field.job_profile": "Profilo professionale",
    "Job profile": "Profilo professionale",
    "people.field.pay_grade": "Fascia retributiva",
    "Pay grade": "Fascia retributiva",
    "people.field.employment_type": "Tipo di impiego",
    "Employment type": "Tipo di impiego",
    "people.field.start_date": "Data inizio",
    "people.field.user_id": "ID utente",
    "people.field.user": "Utente",
    "people.field.grade": "Livello",
    "Grade": "Livello",
    "people.field.salary_range": "Fascia salariale",
    "Salary range": "Fascia salariale",
    "people.field.minimum_salary": "Stipendio minimo",
    "Minimum salary": "Stipendio minimo",
    "people.field.maximum_salary": "Stipendio massimo",
    "Maximum salary": "Stipendio massimo",
    "people.field.currency_id": "ID valuta",
    "people.form.staff.edit": "Modifica personale",
    "Edit staff": "Modifica personale",
    "people.form.staff.add": "Aggiungi personale",
    "people.form.staff.description": "Collega un utente esistente a un profilo personale.",
    "Link an existing user to a staff profile.": "Collega un utente esistente a un profilo personale.",
    "people.form.department.edit": "Modifica reparto",
    "Edit department": "Modifica reparto",
    "people.form.department.add": "Aggiungi reparto",
    "people.form.job_profile.edit": "Modifica profilo professionale",
    "Edit job profile": "Modifica profilo professionale",
    "people.form.job_profile.add": "Aggiungi profilo professionale",
    "people.form.pay_grade.edit": "Modifica fascia retributiva",
    "Edit pay grade": "Modifica fascia retributiva",
    "people.form.pay_grade.add": "Aggiungi fascia retributiva",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Ingegnere senior",
    "Senior Engineer": "Ingegnere senior",
    "people.placeholder.department": "Ingegneria",
    "Engineering": "Ingegneria",
    "people.placeholder.department_description": "Team prodotto e ingegneria",
    "Product & Engineering team": "Team prodotto e ingegneria",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Tempo pieno",
    "Full time": "Tempo pieno",
    "people.employment.part_time": "Part-time",
    "Part time": "Part-time",
    "people.employment.contractor": "Collaboratore esterno",
    "Contractor": "Collaboratore esterno",
    "people.toast.staff_added": "Personale aggiunto",
    "Staff added": "Personale aggiunto",
    "people.toast.staff_updated": "Personale aggiornato",
    "Staff updated": "Personale aggiornato",
    "people.toast.department_added": "Reparto aggiunto",
    "Department added": "Reparto aggiunto",
    "people.toast.department_updated": "Reparto aggiornato",
    "Department updated": "Reparto aggiornato",
    "people.toast.job_profile_added": "Profilo professionale aggiunto",
    "Job profile added": "Profilo professionale aggiunto",
    "people.toast.job_profile_updated": "Profilo professionale aggiornato",
    "Job profile updated": "Profilo professionale aggiornato",
    "people.toast.pay_grade_added": "Fascia retributiva aggiunta",
    "Pay grade added": "Fascia retributiva aggiunta",
    "people.toast.pay_grade_updated": "Fascia retributiva aggiornata",
    "Pay grade updated": "Fascia retributiva aggiornata",
    "people.empty.staff": "Nessun membro del personale. Aggiungi un profilo per iniziare.",
    "No staff yet. Add a staff profile to get started.": "Nessun membro del personale. Aggiungi un profilo per iniziare.",
    "people.empty.departments": "Nessun reparto.",
    "No departments yet.": "Nessun reparto.",
    "people.empty.job_profiles": "Nessun profilo professionale.",
    "No job profiles yet.": "Nessun profilo professionale.",
    "people.empty.pay_grades": "Nessuna fascia retributiva.",
    "No pay grades yet.": "Nessuna fascia retributiva.",
    "people.pagination.page": "Pagina {page}",
    "Page {page}": "Pagina {page}",
    "workforce.title": "Personale",
    "workforce.tab.shifts": "Turni",
    "Shifts": "Turni",
    "workforce.tab.attendance": "Presenze",
    "Attendance": "Presenze",
    "workforce.tab.leave_requests": "Richieste di congedo",
    "Leave requests": "Richieste di congedo",
    "workforce.tab.leave_balances": "Saldi congedi",
    "Leave balances": "Saldi congedi",
    "workforce.tab.leave_policies": "Politiche congedi",
    "Leave policies": "Politiche congedi",
    "workforce.action.add_shift": "Aggiungi turno",
    "Add shift": "Aggiungi turno",
    "workforce.action.new_leave_request": "Nuova richiesta di congedo",
    "New leave request": "Nuova richiesta di congedo",
    "workforce.action.set_balance": "Imposta saldo",
    "Set balance": "Imposta saldo",
    "workforce.action.add_policy": "Aggiungi politica",
    "Add policy": "Aggiungi politica",
    "workforce.action.create_request": "Crea richiesta",
    "Create request": "Crea richiesta",
    "workforce.action.save_balance": "Salva saldo",
    "Save balance": "Salva saldo",
    "workforce.action.clock_in": "Entrata",
    "Clock in": "Entrata",
    "workforce.action.clock_out": "Uscita",
    "Clock out": "Uscita",
    "workforce.action.clocking_in": "Timbratura in entrata…",
    "Clocking in…": "Timbratura in entrata…",
    "workforce.action.clocking_out": "Timbratura in uscita…",
    "Clocking out…": "Timbratura in uscita…",
    "workforce.field.staff": "Personale",
    "workforce.field.start_time": "Inizio",
    "workforce.field.end_time": "Fine",
    "workforce.field.location": "Posizione",
    "workforce.field.leave_type": "Tipo di congedo",
    "Leave type": "Tipo di congedo",
    "workforce.field.from": "Da",
    "workforce.field.to": "A",
    "workforce.field.days": "Giorni",
    "Days": "Giorni",
    "workforce.field.total_days": "Giorni totali",
    "Total days": "Giorni totali",
    "workforce.field.days_per_year": "Giorni all’anno",
    "Days per year": "Giorni all’anno",
    "workforce.field.carry_over": "Riporto",
    "Carry over": "Riporto",
    "workforce.field.carry_over_hint": "I giorni non utilizzati vengono riportati all’anno successivo",
    "Unused days carry over to next year": "I giorni non utilizzati vengono riportati all’anno successivo",
    "workforce.field.reason": "Motivo",
    "workforce.field.time": "Ora",
    "workforce.field.clock_in": "Entrata",
    "workforce.field.clock_out": "Uscita",
    "workforce.field.hours": "Ore",
    "Hours": "Ore",
    "workforce.field.dates": "Date",
    "Dates": "Date",
    "workforce.field.used_days": "Utilizzati",
    "Used": "Utilizzati",
    "workforce.field.remaining_days": "Giorni rimanenti",
    "workforce.field.policy": "Politica",
    "Policy": "Politica",
    "workforce.placeholder.location": "Sede centrale",
    "HQ": "Sede centrale",
    "workforce.placeholder.leave_note": "Vacanza in famiglia",
    "Family holiday": "Vacanza in famiglia",
    "workforce.placeholder.policy_name": "Ferie annuali",
    "Annual Leave": "Ferie annuali",
    "workforce.placeholder.reject_reason": "Periodo intenso",
    "Busy period": "Periodo intenso",
    "workforce.placeholder.optional_note": "Nota facoltativa",
    "Optional note": "Nota facoltativa",
    "workforce.select.all_staff": "Tutto il personale",
    "All staff": "Tutto il personale",
    "workforce.form.shift.add": "Aggiungi turno",
    "workforce.form.leave_request.add": "Nuova richiesta di congedo",
    "workforce.form.leave_balance.title": "Imposta saldo congedi",
    "Set leave balance": "Imposta saldo congedi",
    "workforce.form.leave_balance.description": "Imposta il diritto del personale per tipo di congedo e anno.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Imposta il diritto del personale per tipo di congedo e anno.",
    "workforce.form.leave_policy.add": "Aggiungi politica congedi",
    "Add leave policy": "Aggiungi politica congedi",
    "workforce.form.leave_request.reject": "Rifiuta richiesta di congedo",
    "Reject leave request": "Rifiuta richiesta di congedo",
    "workforce.form.clock_out": "Uscita",
    "workforce.toast.shift_added": "Turno aggiunto",
    "Shift added": "Turno aggiunto",
    "workforce.toast.leave_request_created": "Richiesta di congedo creata",
    "Leave request created": "Richiesta di congedo creata",
    "workforce.toast.leave_balance_saved": "Saldo congedi salvato",
    "Leave balance saved": "Saldo congedi salvato",
    "workforce.toast.leave_policy_added": "Politica congedi aggiunta",
    "Leave policy added": "Politica congedi aggiunta",
    "workforce.toast.leave_request_rejected": "Richiesta di congedo rifiutata",
    "Leave request rejected": "Richiesta di congedo rifiutata",
    "workforce.toast.leave_request_approved": "Richiesta di congedo approvata",
    "Leave request approved": "Richiesta di congedo approvata",
    "workforce.toast.clocked_in": "Entrata registrata",
    "Clocked in": "Entrata registrata",
    "workforce.toast.clocked_out": "Uscita registrata",
    "Clocked out": "Uscita registrata",
    "workforce.empty.shifts": "Nessun turno in questo periodo.",
    "No shifts in this period.": "Nessun turno in questo periodo.",
    "workforce.empty.attendance": "Nessun registro presenze.",
    "No attendance records.": "Nessun registro presenze.",
    "workforce.empty.leave_requests": "Nessuna richiesta di congedo.",
    "No leave requests.": "Nessuna richiesta di congedo.",
    "workforce.empty.leave_balances": "Nessun saldo congedi. Usa Imposta saldo per aggiungerne uno.",
    "No leave balances. Use Set balance to add one.": "Nessun saldo congedi. Usa Imposta saldo per aggiungerne uno.",
    "workforce.empty.leave_policies": "Nessuna politica di congedo.",
    "No leave policies yet.": "Nessuna politica di congedo.",
    "workforce.leave_type.annual": "Ferie annuali",
    "Annual leave": "Ferie annuali",
    "workforce.leave_type.sick": "Congedo per malattia",
    "Sick leave": "Congedo per malattia",
    "workforce.leave_type.unpaid": "Congedo non retribuito",
    "Unpaid leave": "Congedo non retribuito",
    "workforce.leave_type.parental": "Congedo parentale",
    "Parental leave": "Congedo parentale",
    "workforce.leave_type.compassionate": "Congedo per lutto",
    "Compassionate leave": "Congedo per lutto",
    "workforce.duration.hours_minutes": "{hours}h {minutes}m",
    "{hours}h {minutes}m": "{hours}h {minutes}m",
    "common.year": "Anno",
    "Year": "Anno",
    "common.approve": "Approva",
    "common.reject": "Rifiuta",
    "payroll.title": "Paghe",
    "payroll.tab.runs": "Elaborazioni",
    "Payroll runs": "Elaborazioni",
    "payroll.tab.components": "Componenti retributive",
    "Pay components": "Componenti retributive",
    "payroll.tab.claims": "Richieste spese",
    "Expense claims": "Richieste spese",
    "payroll.tab.categories": "Categorie spese",
    "Expense categories": "Categorie spese",
    "payroll.action.new_run": "Nuova elaborazione paghe",
    "New payroll run": "Nuova elaborazione paghe",
    "payroll.action.add_component": "Aggiungi componente retributiva",
    "Add pay component": "Aggiungi componente retributiva",
    "payroll.action.new_claim": "Nuova richiesta spese",
    "New expense claim": "Nuova richiesta spese",
    "payroll.action.add_category": "Aggiungi categoria",
    "payroll.action.create_run": "Crea elaborazione",
    "Create run": "Crea elaborazione",
    "payroll.action.create_component": "Crea componente",
    "Create component": "Crea componente",
    "payroll.action.create_claim": "Crea richiesta",
    "Create claim": "Crea richiesta",
    "payroll.action.submit_claim": "Invia",
    "Submit": "Invia",
    "payroll.action.approve_claim": "Approva",
    "payroll.action.reimburse_claim": "Rimborsa",
    "Reimburse": "Rimborsa",
    "payroll.action.approve_payroll": "Approva paghe",
    "Approve payroll": "Approva paghe",
    "payroll.action.activate": "Attiva",
    "Activate": "Attiva",
    "payroll.action.deactivate": "Disattiva",
    "payroll.action.adjust": "Rettifica",
    "payroll.action.save_adjustment": "Salva rettifica",
    "payroll.action.export_csv": "Esporta CSV",
    "Export CSV": "Esporta CSV",
    "payroll.action.exporting": "Esportazione…",
    "payroll.action.view_staff_items": "Visualizza voci del personale",
    "View staff items": "Visualizza voci del personale",
    "payroll.action.view_payslips": "Visualizza buste paga",
    "View payslips": "Visualizza buste paga",
    "payroll.type.addition": "Aggiunta",
    "Addition": "Aggiunta",
    "payroll.type.deduction": "Trattenuta",
    "Deduction": "Trattenuta",
    "payroll.calculation.fixed": "Importo fisso",
    "Fixed amount": "Importo fisso",
    "payroll.calculation.percentage": "Percentuale",
    "payroll.applies_to.all": "Tutto il personale",
    "payroll.applies_to.hourly": "Personale a ore",
    "Hourly staff": "Personale a ore",
    "payroll.applies_to.salaried": "Personale stipendiato",
    "Salaried staff": "Personale stipendiato",
    "payroll.category.archive_confirm": "Archiviare {name}?",
    "payroll.components.description": "Le aggiunte e le trattenute attive vengono applicate automaticamente alle nuove elaborazioni paghe.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Le aggiunte e le trattenute attive vengono applicate automaticamente alle nuove elaborazioni paghe.",
    "payroll.empty.categories": "Nessuna categoria di spesa.",
    "No expense categories yet.": "Nessuna categoria di spesa.",
    "payroll.empty.claims": "Nessuna richiesta di rimborso spese.",
    "No expense claims yet.": "Nessuna richiesta di rimborso spese.",
    "payroll.empty.components": "Nessun componente retributivo configurato.",
    "No pay components configured yet.": "Nessun componente retributivo configurato.",
    "payroll.empty.runs": "Nessuna elaborazione paghe.",
    "No payroll runs yet.": "Nessuna elaborazione paghe.",
    "payroll.field.staff": "Personale",
    "payroll.field.base_pay": "Paga base",
    "Base pay": "Paga base",
    "payroll.field.allowances": "Indennità",
    "Allowances": "Indennità",
    "payroll.field.deductions": "Trattenute",
    "Deductions": "Trattenute",
    "payroll.field.commission": "Commissione",
    "payroll.field.net_pay": "Retribuzione netta",
    "Net pay": "Retribuzione netta",
    "payroll.field.components": "Componenti",
    "Components": "Componenti",
    "payroll.field.commission_override": "Override commissione",
    "Commission override": "Override commissione",
    "payroll.field.calculation": "Calcolo",
    "Calculation": "Calcolo",
    "payroll.field.applies_to": "Si applica a",
    "Applies to": "Si applica a",
    "payroll.field.staff_optional_draft": "Personale (facoltativo durante la bozza)",
    "payroll.field.category_optional_draft": "Categoria (facoltativa durante la bozza)",
    "payroll.field.category": "Categoria",
    "payroll.field.period": "Periodo",
    "payroll.field.period_start": "Inizio periodo",
    "Period start": "Inizio periodo",
    "payroll.field.period_end": "Fine periodo",
    "Period end": "Fine periodo",
    "payroll.field.generate_email_payslips": "Genera e invia le buste paga via email",
    "Generate and email payslips": "Genera e invia le buste paga via email",
    "payroll.field.gl_code": "Codice contabilità generale",
    "GL code": "Codice contabilità generale",
    "payroll.field.maximum_per_claim": "Massimo per richiesta",
    "Maximum per claim": "Massimo per richiesta",
    "payroll.field.maximum_per_transaction": "Massimo per transazione",
    "Maximum per transaction": "Massimo per transazione",
    "payroll.field.spending_cap": "Limite di spesa",
    "Spending cap": "Limite di spesa",
    "payroll.field.tax_rate": "Aliquota fiscale (%)",
    "Tax rate (%)": "Aliquota fiscale (%)",
    "payroll.field.no_limit": "Nessun limite",
    "No limit": "Nessun limite",
    "payroll.form.run.title": "Nuova elaborazione paghe",
    "payroll.form.run.description": "La retribuzione viene calcolata in base alle fasce del personale per il periodo selezionato.",
    "Pay is calculated from staff pay grades for the selected period.": "La retribuzione viene calcolata in base alle fasce del personale per il periodo selezionato.",
    "payroll.form.component.title": "Aggiungi componente retributiva",
    "payroll.form.component.description": "I componenti vengono inclusi automaticamente nelle elaborazioni future.",
    "Components are automatically included in future payroll runs.": "I componenti vengono inclusi automaticamente nelle elaborazioni future.",
    "payroll.form.claim.title": "Nuova richiesta spese",
    "payroll.form.claim.description": "La richiesta resta una bozza finché non viene inviata per l’approvazione.",
    "Claims start as drafts until submitted for approval.": "La richiesta resta una bozza finché non viene inviata per l’approvazione.",
    "payroll.form.category.add": "Aggiungi categoria di spesa",
    "Add expense category": "Aggiungi categoria di spesa",
    "payroll.form.category.edit": "Modifica categoria di spesa",
    "Edit expense category": "Modifica categoria di spesa",
    "payroll.form.claim.approve_title": "Approva richiesta spese",
    "Approve expense claim": "Approva richiesta spese",
    "payroll.form.run.approve_title": "Approva elaborazione paghe",
    "Approve payroll run": "Approva elaborazione paghe",
    "payroll.form.run.approve_description": "L’approvazione blocca l’elaborazione paghe. Ora puoi anche generare e inviare le buste paga.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "L’approvazione blocca l’elaborazione paghe. Ora puoi anche generare e inviare le buste paga.",
    "payroll.items.title": "Voci paga personale",
    "Staff payroll items": "Voci paga personale",
    "payroll.items.loading": "Caricamento voci paga…",
    "Loading payroll items…": "Caricamento voci paga…",
    "payroll.items.empty": "Nessuna voce paga trovata.",
    "No payroll items found.": "Nessuna voce paga trovata.",
    "payroll.items.adjust_title": "Rettifica voce paga",
    "Adjust payroll item": "Rettifica voce paga",
    "payroll.items.adjust_description": "Aggiorna le trattenute o modifica l’importo della commissione per questo membro del personale.",
    "Update deductions or override the commission amount for this staff member.": "Aggiorna le trattenute o modifica l’importo della commissione per questo membro del personale.",
    "payroll.payslips.title": "Buste paga",
    "Payslips": "Buste paga",
    "payroll.payslips.generate": "Genera buste paga",
    "Generate payslips": "Genera buste paga",
    "payroll.payslips.generating": "Generazione…",
    "Generating…": "Generazione…",
    "payroll.payslips.empty": "Nessuna busta paga generata.",
    "No payslips generated yet.": "Nessuna busta paga generata.",
    "payroll.payslips.generated": "Generato",
    "Generated": "Generato",
    "payroll.payslips.sent_at": "Inviato il {date}",
    "Sent {date}": "Inviato il {date}",
    "payroll.payslips.not_sent": "Non inviato",
    "Not sent": "Non inviato",
    "payroll.payslips.send_email": "Invia email",
    "Send email": "Invia email",
    "payroll.payslips.sending": "Invio…",
    "payroll.payslips.details": "Dettagli busta paga",
    "Payslip details": "Dettagli busta paga",
    "payroll.placeholder.approval_note": "Approvato",
    "payroll.placeholder.category_name": "Viaggi",
    "Travel": "Viaggi",
    "payroll.placeholder.claim_description": "Volo per un cliente",
    "Flight to client": "Volo per un cliente",
    "payroll.placeholder.component_name": "Indennità trasporto",
    "Transport Allowance": "Indennità trasporto",
    "payroll.staff_number": "Personale n. {id}",
    "Staff #{id}": "Personale n. {id}",
    "payroll.toast.category_added": "Categoria spese aggiunta",
    "Expense category added": "Categoria spese aggiunta",
    "payroll.toast.category_archived": "Categoria spese archiviata",
    "Expense category archived": "Categoria spese archiviata",
    "payroll.toast.category_updated": "Categoria spese aggiornata",
    "Expense category updated": "Categoria spese aggiornata",
    "payroll.toast.claim_approved": "Richiesta approvata",
    "Claim approved": "Richiesta approvata",
    "payroll.toast.claim_created": "Richiesta spese creata",
    "Expense claim created": "Richiesta spese creata",
    "payroll.toast.claim_reimbursed": "Richiesta contrassegnata come rimborsata",
    "Claim marked as reimbursed": "Richiesta contrassegnata come rimborsata",
    "payroll.toast.claim_submitted": "Richiesta inviata",
    "Claim submitted": "Richiesta inviata",
    "payroll.toast.component_activated": "Componente retributiva attivata",
    "Pay component activated": "Componente retributiva attivata",
    "payroll.toast.component_created": "Componente retributiva creata",
    "Pay component created": "Componente retributiva creata",
    "payroll.toast.component_deactivated": "Componente retributiva disattivata",
    "Pay component deactivated": "Componente retributiva disattivata",
    "payroll.toast.item_updated": "Voce paga aggiornata",
    "Payroll item updated": "Voce paga aggiornata",
    "payroll.toast.payslip_email_sent": "Email busta paga inviata",
    "Payslip email sent": "Email busta paga inviata",
    "payroll.toast.payslips_generated": "Buste paga generate",
    "Payslips generated": "Buste paga generate",
    "payroll.toast.run_approved": "Elaborazione paghe approvata",
    "Payroll run approved": "Elaborazione paghe approvata",
    "payroll.toast.run_approved_payslips_queued": "Elaborazione paghe approvata e buste paga in coda",
    "Payroll approved and payslips queued": "Elaborazione paghe approvata e buste paga in coda",
    "payroll.toast.run_created": "Elaborazione paghe creata",
    "Payroll run created": "Elaborazione paghe creata",
    "payroll.toast.exported": "Paghe esportate",
    "Payroll exported": "Paghe esportate",
    "common.notes": "Note",
    "expenses.title": "Spese",
    "expenses.action.add": "Aggiungi spesa",
    "Add expense": "Aggiungi spesa",
    "expenses.action.create": "Crea spesa",
    "Create expense": "Crea spesa",
    "expenses.action.submit": "Invia",
    "expenses.action.approve": "Approva",
    "expenses.action.reimburse": "Rimborsa",
    "expenses.action.pay": "Paga",
    "expenses.action.lifecycle": "Spesa {action}",
    "Expense {action}d": "Spesa {action}",
    "expenses.type.claim": "Richiesta",
    "Claim": "Richiesta",
    "expenses.type.claims": "Richieste",
    "Claims": "Richieste",
    "expenses.type.bill": "Fattura",
    "Bill": "Fattura",
    "expenses.type.bills": "Fatture",
    "Bills": "Fatture",
    "expenses.filter.all_types": "Tutti i tipi",
    "All types": "Tutti i tipi",
    "expenses.filter.all_statuses": "Tutti gli stati",
    "expenses.summary.title": "Riepilogo",
    "Summary": "Riepilogo",
    "expenses.summary.by_category": "Per categoria",
    "By category": "Per categoria",
    "expenses.summary.by_status": "Per stato",
    "By status": "Per stato",
    "expenses.summary.by_party": "Per fornitore / personale",
    "By supplier / staff": "Per fornitore / personale",
    "expenses.summary.heading": "Riepilogo per {group}",
    "Summary by {group}": "Riepilogo per {group}",
    "expenses.summary.group.category": "categoria",
    "category": "categoria",
    "expenses.summary.group.status": "stato",
    "status": "stato",
    "expenses.summary.group.party": "fornitore / personale",
    "supplier / staff": "fornitore / personale",
    "expenses.summary.empty": "Nessun riepilogo disponibile.",
    "No summary available.": "Nessun riepilogo disponibile.",
    "expenses.column.type": "Tipo",
    "expenses.column.party": "Personale / Fornitore",
    "Staff / Supplier": "Personale / Fornitore",
    "expenses.column.status": "Stato",
    "expenses.field.staff_optional": "Personale (facoltativo in bozza)",
    "expenses.field.supplier_optional": "Fornitore (facoltativo in bozza)",
    "Supplier (optional while drafting)": "Fornitore (facoltativo in bozza)",
    "expenses.field.category_optional": "Categoria (facoltativa in bozza)",
    "expenses.field.amount": "Importo",
    "expenses.field.currency": "Valuta",
    "expenses.field.description": "Descrizione",
    "expenses.field.due_date": "Data di scadenza",
    "Due date": "Data di scadenza",
    "expenses.field.receipt_url": "URL ricevuta",
    "Receipt URL": "URL ricevuta",
    "expenses.empty": "Nessuna spesa corrisponde ai filtri selezionati.",
    "No expenses found for the selected filters.": "Nessuna spesa corrisponde ai filtri selezionati.",
    "expenses.modal.edit": "Modifica spesa",
    "Edit expense": "Modifica spesa",
    "expenses.modal.add": "Aggiungi {type}",
    "Add {type}": "Aggiungi {type}",
    "expenses.modal.bill_help": "Crea una bozza e assegna un fornitore prima dell’invio.",
    "Create the draft now and assign a supplier before submitting.": "Crea una bozza e assegna un fornitore prima dell’invio.",
    "expenses.modal.claim_help": "Crea una bozza e assegna un membro del personale prima dell’invio.",
    "Create the draft now and assign a staff member before submitting.": "Crea una bozza e assegna un membro del personale prima dell’invio.",
    "expenses.toast.updated": "Spesa aggiornata",
    "Expense updated": "Spesa aggiornata",
    "expenses.toast.created": "Spesa creata",
    "Expense created": "Spesa creata",
    "recurring_payments.title": "Pagamenti ricorrenti",
    "recurring_payments.action.add": "Aggiungi pagamento ricorrente",
    "Add recurring payment": "Aggiungi pagamento ricorrente",
    "recurring_payments.action.create": "Crea pagamento ricorrente",
    "Create recurring payment": "Crea pagamento ricorrente",
    "recurring_payments.action.pause": "Sospendi",
    "Pause": "Sospendi",
    "recurring_payments.action.resume": "Riprendi",
    "Resume": "Riprendi",
    "recurring_payments.action.remove": "Rimuovi",
    "recurring_payments.description": "Crea automaticamente bozze di fatture per i pagamenti ricorrenti ai fornitori.",
    "Automatically create draft expense bills for regular supplier payments.": "Crea automaticamente bozze di fatture per i pagamenti ricorrenti ai fornitori.",
    "recurring_payments.field.name": "Nome",
    "recurring_payments.field.supplier": "Fornitore",
    "recurring_payments.field.supplier_optional": "Fornitore (facoltativo)",
    "Supplier (optional)": "Fornitore (facoltativo)",
    "recurring_payments.field.frequency": "Frequenza",
    "Frequency": "Frequenza",
    "recurring_payments.field.next_due": "Prossima scadenza",
    "Next due date": "Prossima scadenza",
    "recurring_payments.field.auto_create": "Crea automaticamente una bozza di fattura",
    "Auto-create draft bill": "Crea automaticamente una bozza di fattura",
    "recurring_payments.field.auto_create_help": "Crea automaticamente una bozza di fattura spese",
    "Create a draft expense bill automatically": "Crea automaticamente una bozza di fattura spese",
    "recurring_payments.field.one_time": "Pagamento una tantum",
    "One-time payment": "Pagamento una tantum",
    "recurring_payments.field.one_time_help": "Termina dopo la prossima fattura generata",
    "End after the next generated bill": "Termina dopo la prossima fattura generata",
    "recurring_payments.field.end_date": "Data fine",
    "recurring_payments.placeholder.name": "Affitto ufficio",
    "Office Rent": "Affitto ufficio",
    "recurring_payments.frequency.daily": "Giornaliera",
    "recurring_payments.frequency.weekly": "Settimanale",
    "recurring_payments.frequency.monthly": "Mensile",
    "recurring_payments.frequency.quarterly": "Trimestrale",
    "recurring_payments.frequency.yearly": "Annuale",
    "Yearly": "Annuale",
    "recurring_payments.form.description": "Con la creazione automatica attiva, le scadenze generano bozze di fatture in Spese.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Con la creazione automatica attiva, le scadenze generano bozze di fatture in Spese.",
    "recurring_payments.empty": "Nessun pagamento ricorrente.",
    "No recurring payments yet.": "Nessun pagamento ricorrente.",
    "recurring_payments.this_payment": "questo pagamento ricorrente",
    "this recurring payment": "questo pagamento ricorrente",
    "recurring_payments.confirm_remove": "Rimuovere {name}?",
    "Remove {name}?": "Rimuovere {name}?",
    "recurring_payments.toast.pause": "Pagamento ricorrente sospeso",
    "Recurring payment paused": "Pagamento ricorrente sospeso",
    "recurring_payments.toast.resume": "Pagamento ricorrente ripreso",
    "Recurring payment resumed": "Pagamento ricorrente ripreso",
    "recurring_payments.toast.delete": "Pagamento ricorrente rimosso",
    "Recurring payment removed": "Pagamento ricorrente rimosso",
    "recurring_payments.toast.created": "Pagamento ricorrente creato",
    "Recurring payment created": "Pagamento ricorrente creato",
    "expenses.toast.submit": "Spesa inviata",
    "Expense submitted": "Spesa inviata",
    "expenses.toast.approve": "Spesa approvata",
    "Expense approved": "Spesa approvata",
    "expenses.toast.reimburse": "Spesa rimborsata",
    "Expense reimbursed": "Spesa rimborsata",
    "expenses.toast.pay": "Spesa pagata",
    "Expense paid": "Spesa pagata",
    "media_picker.title": "Seleziona contenuto",
    "Select media": "Seleziona contenuto",
    "media_picker.type.media": "Contenuti",
    "media_picker.type.all": "Tutti",
    "media_picker.type.image": "Immagine",
    "media_picker.type.video": "Video",
    "media_picker.type.audio": "Audio",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Cartella",
    "media_picker.label.show": "Mostra",
    "media_picker.label.media_type": "Tipo di contenuto",
    "Media type": "Tipo di contenuto",
    "media_picker.action.show_type": "Mostra contenuti di tipo {type}",
    "media_picker.action.close": "Chiudi selettore contenuti",
    "Close media picker": "Chiudi selettore contenuti",
    "media_picker.action.upload": "Carica contenuto",
    "media_picker.action.creating": "Creazione…",
    "media_picker.action.create_folder": "Crea cartella",
    "Create folder": "Crea cartella",
    "media_picker.action.cancel": "Annulla",
    "media_picker.action.use_selected": "Usa selezionato",
    "Use selected": "Usa selezionato",
    "media_picker.placeholder.search": "Cerca contenuti",
    "media_picker.placeholder.folder": "Nome nuova cartella",
    "New folder name": "Nome nuova cartella",
    "media_picker.loading": "Caricamento contenuti…",
    "media_picker.empty": "Nessun contenuto trovato in questa cartella.",
    "No media found in this folder.": "Nessun contenuto trovato in questa cartella.",
    "media_picker.selection.count": "{count} selezionati",
    "{count} selected": "{count} selezionati",
    "media_picker.selection.prompt": "Seleziona un file per continuare",
    "Select a file to continue": "Seleziona un file per continuare",
    "media_picker.error.load": "Impossibile caricare i contenuti",
    "Unable to load media": "Impossibile caricare i contenuti",
    "media_picker.error.load_retry": "Impossibile caricare i contenuti. Riprova.",
    "media_picker.error.create_folder": "Impossibile creare la cartella",
    "media_picker.error.create_folder_retry": "Impossibile creare la cartella. Riprova.",
    "Unable to create folder. Please try again.": "Impossibile creare la cartella. Riprova.",
    "media_picker.error.prepare_upload": "Impossibile preparare il caricamento",
    "Unable to prepare upload": "Impossibile preparare il caricamento",
    "media_picker.error.upload_url": "URL di caricamento mancante",
    "Upload URL missing": "URL di caricamento mancante",
    "media_picker.error.register_media": "Impossibile registrare il contenuto",
    "media_picker.error.upload_retry": "Impossibile caricare il contenuto. Riprova.",
    "membership.title": "Abbonamento",
    "membership.description": "Gestisci programmi di iscrizione, contributi dei membri, stato dei pagamenti e promemoria.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Gestisci programmi di iscrizione, contributi dei membri, stato dei pagamenti e promemoria.",
    "membership.action.settings": "Impostazioni",
    "membership.action.manage_programs": "Gestisci programmi",
    "Manage programs": "Gestisci programmi",
    "membership.action.view_data": "Visualizza dati",
    "View data": "Visualizza dati",
    "membership.action.edit_listing": "Modifica inserzione",
    "membership.action.go_to_listings": "Vai alle inserzioni",
    "Go to listings": "Vai alle inserzioni",
    "membership.action.view_order": "Visualizza ordine",
    "View order": "Visualizza ordine",
    "membership.action.configure_reminders": "Configura promemoria",
    "Configure reminders": "Configura promemoria",
    "membership.stat.programs": "Programmi",
    "membership.stat.active_members": "Membri attivi",
    "Active members": "Membri attivi",
    "membership.stat.contributions": "Contributi",
    "Contributions": "Contributi",
    "membership.stat.units": "Unità accreditate",
    "Units credited": "Unità accreditate",
    "membership.programs.title": "Programmi",
    "membership.programs.description": "Inserzioni di tipo abbonamento disponibili per i clienti.",
    "Membership-type listings available to your customers.": "Inserzioni di tipo abbonamento disponibili per i clienti.",
    "membership.programs.no_description": "Nessuna descrizione del programma.",
    "No program description yet.": "Nessuna descrizione del programma.",
    "membership.programs.empty_title": "Nessun programma di abbonamento",
    "No membership programs yet": "Nessun programma di abbonamento",
    "membership.programs.empty_description": "Crea un’inserzione di tipo abbonamento per iniziare a ricevere contributi.",
    "Create a listing with type membership to start accepting contributions.": "Crea un’inserzione di tipo abbonamento per iniziare a ricevere contributi.",
    "membership.programs.history_description": "Cronologia prezzi e membri iscritti.",
    "Price history and enrolled members.": "Cronologia prezzi e membri iscritti.",
    "membership.badge": "Abbonamento",
    "membership.loading_program": "Caricamento dati programma…",
    "Loading program data…": "Caricamento dati programma…",
    "membership.price_logs.title": "Registro prezzi",
    "Price logs": "Registro prezzi",
    "membership.price_logs.empty": "Nessuna registrazione prezzi.",
    "No price logs recorded.": "Nessuna registrazione prezzi.",
    "membership.source.manual": "manuale",
    "manual": "manuale",
    "membership.members.title": "Membri",
    "Members": "Membri",
    "membership.members.empty_program": "Nessun membro iscritto a questo programma.",
    "No members enrolled in this program.": "Nessun membro iscritto a questo programma.",
    "membership.members.recent": "Membri recenti",
    "Recent members": "Membri recenti",
    "membership.members.empty_recent": "I membri e i contributi appariranno qui dopo l’iscrizione.",
    "Members and contributions will appear here after enrolment.": "I membri e i contributi appariranno qui dopo l’iscrizione.",
    "membership.member_heading": "Membro: {member}",
    "Member: {member}": "Membro: {member}",
    "membership.contributions.title": "Contributi",
    "membership.contributions.empty": "Nessun contributo registrato.",
    "No contributions recorded yet.": "Nessun contributo registrato.",
    "membership.payment_dues.title": "Scadenze di pagamento",
    "Payment dues": "Scadenze di pagamento",
    "membership.payment_dues.empty": "Nessuna scadenza programmata.",
    "No scheduled payment dues.": "Nessuna scadenza programmata.",
    "membership.unit": "unità",
    "unit": "unità",
    "membership.units": "unità",
    "units": "unità",
    "membership.months": "mesi",
    "membership.automation.label": "AUTOMAZIONE",
    "AUTOMATION": "AUTOMAZIONE",
    "membership.automation.description": "Un processo giornaliero verifica i pagamenti programmati.",
    "Daily worker checks scheduled membership payments.": "Un processo giornaliero verifica i pagamenti programmati.",
    "membership.reminders.title": "Promemoria di pagamento",
    "Payment reminders": "Promemoria di pagamento",
    "membership.reminders.due_soon": "Promemoria scadenza imminente",
    "Due-soon reminder": "Promemoria scadenza imminente",
    "membership.reminders.due_soon_short": "In scadenza",
    "Due soon": "In scadenza",
    "membership.reminders.due_soon_help": "Invia un promemoria prima della scadenza del pagamento.",
    "Send one reminder before a scheduled payment is due.": "Invia un promemoria prima della scadenza del pagamento.",
    "membership.reminders.days_before": "Giorni prima della scadenza",
    "Days before due date": "Giorni prima della scadenza",
    "membership.reminders.days_before_value": "{count} giorni prima",
    "{count} days before": "{count} giorni prima",
    "membership.reminders.overdue": "Promemoria pagamento scaduto",
    "Overdue reminder": "Promemoria pagamento scaduto",
    "membership.reminders.overdue_help": "Invia un promemoria dopo la scadenza e il periodo di tolleranza.",
    "Send one reminder after the due date and grace period.": "Invia un promemoria dopo la scadenza e il periodo di tolleranza.",
    "membership.settings.title": "Impostazioni abbonamento",
    "Membership settings": "Impostazioni abbonamento",
    "membership.settings.description": "Configura la pianificazione dei promemoria di pagamento.",
    "Configure the payment reminder schedule.": "Configura la pianificazione dei promemoria di pagamento.",
    "membership.email_copy.title": "Testo email personalizzato",
    "Custom email copy": "Testo email personalizzato",
    "membership.email_copy.description": "Per modificare oggetti e modelli dei promemoria, vai a Impostazioni → Notifiche → Abbonamento.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Per modificare oggetti e modelli dei promemoria, vai a Impostazioni → Notifiche → Abbonamento.",
    "membership.toast.saved": "Impostazioni promemoria salvate.",
    "Membership reminder settings saved.": "Impostazioni promemoria salvate.",
    "membership.toast.save_failed": "Impossibile salvare le impostazioni dei promemoria.",
    "Unable to save membership reminder settings.": "Impossibile salvare le impostazioni dei promemoria.",
    "common.status.off": "Off",
    "Off": "Off",
    "common.status.on": "On",
    "On": "On",
    "common.save_settings": "Salva impostazioni",
    "Save settings": "Salva impostazioni",
    "developer.page.title": "API e sviluppo",
    "API & Developer": "API e sviluppo",
    "developer.api_keys.title": "Chiavi API",
    "API Keys": "Chiavi API",
    "developer.api_keys.description": "Usa queste chiavi per autenticare le richieste all’API Tradly. Tieni segreta la Secret Key e non inserirla mai nel codice client.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Usa queste chiavi per autenticare le richieste all’API Tradly. Tieni segreta la Secret Key e non inserirla mai nel codice client.",
    "developer.api_keys.credentials_description": "Di seguito trovi le chiavi di produzione, necessarie per autorizzare e creare le app.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Di seguito trovi le chiavi di produzione, necessarie per autorizzare e creare le app.",
    "developer.api_keys.publishable": "Chiave pubblicabile",
    "Publishable Key": "Chiave pubblicabile",
    "developer.api_keys.publishable_placeholder": "Inserisci la chiave pubblicabile",
    "Enter Publishable Key": "Inserisci la chiave pubblicabile",
    "developer.api_keys.secret": "Chiave segreta",
    "developer.api_keys.secret_placeholder": "Inserisci la chiave segreta",
    "Enter Secret Key": "Inserisci la chiave segreta",
    "developer.api_keys.access_label": "Accesso API",
    "API access": "Accesso API",
    "developer.api_reference.title": "Riferimento API",
    "developer.api_reference.description": "Documentazione completa delle API REST, guide ed esempi di codice per la piattaforma Tradly.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Documentazione completa delle API REST, guide ed esempi di codice per la piattaforma Tradly.",
    "developer.api_reference.card_description": "Consulta il riferimento API, le guide di autenticazione, i webhook e la documentazione SDK. Tutto ciò che serve per integrare o creare frontend personalizzati sul marketplace.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Consulta il riferimento API, le guide di autenticazione, i webhook e la documentazione SDK. Tutto ciò che serve per integrare o creare frontend personalizzati sul marketplace.",
    "developer.api_reference.open_docs": "Apri documentazione API",
    "Open API Docs": "Apri documentazione API",
    "developer.ai_agents.title": "AI e agenti",
    "AI & Agents": "AI e agenti",
    "developer.ai_agents.description": "Collega il marketplace agli strumenti AI e consenti ai clienti di creare agenti basati sulla piattaforma.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Collega il marketplace agli strumenti AI e consenti ai clienti di creare agenti basati sulla piattaforma.",
    "developer.mcp.action.create": "Crea",
    "developer.mcp.action.removing": "Rimozione…",
    "developer.mcp.scope.resource": "Risorsa",
    "developer.customer_agents.description": "Consenti ai clienti di creare agenti AI che interagiscono con il marketplace. Compatibile con ChatGPT, Claude e altre piattaforme AI. Ideale per automatizzare i flussi d’acquisto, creare negozi personalizzati o assistenti intelligenti.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Consenti ai clienti di creare agenti AI che interagiscono con il marketplace. Compatibile con ChatGPT, Claude e altre piattaforme AI. Ideale per automatizzare i flussi d’acquisto, creare negozi personalizzati o assistenti intelligenti.",
    "whatsapp.title": "Connettore WhatsApp",
    "WhatsApp connector": "Connettore WhatsApp",
    "whatsapp.intro.title": "Invia OTP e messaggi di marketing tramite WhatsApp",
    "Send OTPs and marketing messages through WhatsApp": "Invia OTP e messaggi di marketing tramite WhatsApp",
    "whatsapp.intro.help": "Collega questo tenant alla Meta WhatsApp Cloud API. Gli SMS restano il canale predefinito o di fallback; lo stesso connettore invia anche modelli WhatsApp approvati.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Collega questo tenant alla Meta WhatsApp Cloud API. Gli SMS restano il canale predefinito o di fallback; lo stesso connettore invia anche modelli WhatsApp approvati.",
    "whatsapp.status.disabled": "Disabilitato",
    "whatsapp.status.sms_otp": "Connettore attivo · OTP SMS",
    "Connector on · SMS OTP": "Connettore attivo · OTP SMS",
    "whatsapp.status.needs_configuration": "Configurazione necessaria",
    "Needs configuration": "Configurazione necessaria",
    "whatsapp.status.auto_fallback": "WhatsApp con fallback SMS",
    "WhatsApp with SMS fallback": "WhatsApp con fallback SMS",
    "whatsapp.status.sms_whatsapp_backup": "SMS con riserva WhatsApp",
    "SMS with WhatsApp backup": "SMS con riserva WhatsApp",
    "whatsapp.status.enabled": "WhatsApp abilitato",
    "WhatsApp enabled": "WhatsApp abilitato",
    "whatsapp.draft.notice": "Hai una bozza non salvata delle impostazioni WhatsApp.",
    "You have an unsaved WhatsApp settings draft.": "Hai una bozza non salvata delle impostazioni WhatsApp.",
    "whatsapp.connect.title": "Collega il WhatsApp aziendale",
    "Connect your business WhatsApp": "Collega il WhatsApp aziendale",
    "whatsapp.connect.description": "Inserisci il numero aziendale conosciuto dai clienti. Meta aprirà una finestra di verifica sicura; non serve cercare ID WABA, ID numero, token di accesso o impostazioni API.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Inserisci il numero aziendale conosciuto dai clienti. Meta aprirà una finestra di verifica sicura; non serve cercare ID WABA, ID numero, token di accesso o impostazioni API.",
    "whatsapp.field.business_number": "Numero WhatsApp aziendale",
    "Business WhatsApp number": "Numero WhatsApp aziendale",
    "whatsapp.field.business_number_help": "Usa il numero a cui vuoi ricevere i messaggi dei clienti, incluso il prefisso internazionale.",
    "Use the number you want customers to message, including country code.": "Usa il numero a cui vuoi ricevere i messaggi dei clienti, incluso il prefisso internazionale.",
    "whatsapp.placeholder.business_number": "ad es. +60 13 333 1671",
    "e.g. +60 13 333 1671": "ad es. +60 13 333 1671",
    "whatsapp.field.connection_name": "Nome connessione",
    "whatsapp.field.connection_name_help": "Usa un nome chiaro come Kuala Lumpur, Brand retail o Supporto.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Usa un nome chiaro come Kuala Lumpur, Brand retail o Supporto.",
    "whatsapp.placeholder.connection_name": "ad es. Supporto Kuala Lumpur",
    "e.g. Kuala Lumpur support": "ad es. Supporto Kuala Lumpur",
    "whatsapp.field.optional_details": "Dettagli facoltativi connessione",
    "Optional connection details": "Dettagli facoltativi connessione",
    "whatsapp.field.optional_details_help": "Usali solo se il numero appartiene a un brand, account o filiale specifici.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Usali solo se il numero appartiene a un brand, account o filiale specifici.",
    "whatsapp.field.brand_key": "Chiave brand",
    "Brand key": "Chiave brand",
    "whatsapp.field.brand_key_help": "Chiave interna stabile del brand, ad esempio retail o wholesale.",
    "Stable internal key for a brand, such as retail or wholesale.": "Chiave interna stabile del brand, ad esempio retail o wholesale.",
    "whatsapp.placeholder.brand_key": "ad es. retail",
    "e.g. retail": "ad es. retail",
    "whatsapp.field.account_id": "ID account",
    "whatsapp.field.account_id_help": "Associa questo numero a un account Tradly esistente.",
    "Associate this number with an existing Tradly account.": "Associa questo numero a un account Tradly esistente.",
    "whatsapp.placeholder.account_id": "ad es. 123",
    "e.g. 123": "ad es. 123",
    "whatsapp.field.branch_id": "ID filiale",
    "Branch ID": "ID filiale",
    "whatsapp.field.branch_id_help": "Associa questo numero a una filiale Tradly esistente.",
    "Associate this number with an existing Tradly branch.": "Associa questo numero a una filiale Tradly esistente.",
    "whatsapp.placeholder.branch_id": "ad es. 456",
    "e.g. 456": "ad es. 456",
    "whatsapp.field.default_connection": "Usa come connessione predefinita",
    "Use as default connection": "Usa come connessione predefinita",
    "whatsapp.field.default_connection_help": "I flussi OTP legacy usano la connessione predefinita se non ne viene selezionata una specifica per filiale.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "I flussi OTP legacy usano la connessione predefinita se non ne viene selezionata una specifica per filiale.",
    "whatsapp.field.uses_business_app": "Uso l’app WhatsApp Business su questo numero",
    "I use the WhatsApp Business app on this number": "Uso l’app WhatsApp Business su questo numero",
    "whatsapp.field.uses_business_app_help": "Continua a chattare nell’app WhatsApp Business sul telefono. Meta ti chiederà di scansionare un codice QR dall’app e i tuoi contatti e le chat recenti verranno sincronizzati. Richiede la versione 2.24.17 o successiva.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Continua a chattare nell’app WhatsApp Business sul telefono. Meta ti chiederà di scansionare un codice QR dall’app e i tuoi contatti e le chat recenti verranno sincronizzati. Richiede la versione 2.24.17 o successiva.",
    "whatsapp.connected.business_account": "Account WhatsApp Business",
    "WhatsApp business account": "Account WhatsApp Business",
    "whatsapp.connected.template_ready": "Modello di autenticazione pronto · gli OTP possono usare WhatsApp.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Modello di autenticazione pronto · gli OTP possono usare WhatsApp.",
    "whatsapp.connected.template_pending": "Connesso · gli SMS restano il fallback sicuro finché il modello di autenticazione non viene approvato.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Connesso · gli SMS restano il fallback sicuro finché il modello di autenticazione non viene approvato.",
    "whatsapp.action.connect": "Collega WhatsApp",
    "Connect WhatsApp": "Collega WhatsApp",
    "whatsapp.action.reconnect": "Ricollega WhatsApp",
    "Reconnect WhatsApp": "Ricollega WhatsApp",
    "whatsapp.connections.title": "Numeri WhatsApp collegati",
    "Connected WhatsApp numbers": "Numeri WhatsApp collegati",
    "whatsapp.connections.description": "Ogni numero può appartenere a un brand, account o filiale diverso. Selezionane uno prima di attivare i modelli.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Ogni numero può appartenere a un brand, account o filiale diverso. Selezionane uno prima di attivare i modelli.",
    "whatsapp.connections.unnamed": "Connessione WhatsApp",
    "WhatsApp connection": "Connessione WhatsApp",
    "whatsapp.connections.default": "Predefinito",
    "whatsapp.connections.account": "Account {id}",
    "Account {id}": "Account {id}",
    "whatsapp.connections.branch": "Filiale {id}",
    "Branch {id}": "Filiale {id}",
    "whatsapp.connections.tenant_wide": "Connessione valida per tutto il tenant",
    "Tenant-wide connection": "Connessione valida per tutto il tenant",
    "whatsapp.action.make_default": "Imposta come predefinito",
    "Make default": "Imposta come predefinito",
    "whatsapp.notice.default_updated": "Connessione WhatsApp predefinita aggiornata.",
    "Default WhatsApp connection updated.": "Connessione WhatsApp predefinita aggiornata.",
    "whatsapp.error.default_update": "Impossibile modificare la connessione predefinita.",
    "Unable to change the default connection.": "Impossibile modificare la connessione predefinita.",
    "whatsapp.templates.title": "Modelli di messaggio",
    "Message templates": "Modelli di messaggio",
    "whatsapp.templates.description": "Scegli un modello pronto. Tradly lo invierà a Meta per l’approvazione e lo attiverà automaticamente quando sarà approvato.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Scegli un modello pronto. Tradly lo invierà a Meta per l’approvazione e lo attiverà automaticamente quando sarà approvato.",
    "whatsapp.template.status.not_activated": "Non attivato",
    "Not activated": "Non attivato",
    "whatsapp.template.status.approved": "Approvato",
    "whatsapp.template.status.pending": "In attesa",
    "whatsapp.template.status.submitted": "Inviato",
    "Submitted": "Inviato",
    "whatsapp.template.action.active": "Attivo",
    "whatsapp.template.action.submitted": "Inviato",
    "whatsapp.template.action.activate": "Attiva modello",
    "Activate template": "Attiva modello",
    "whatsapp.notice.template_active": "{name} è approvato e attivo.",
    "{name} is approved and active.": "{name} è approvato e attivo.",
    "whatsapp.notice.template_submitted": "Il modello {name} è stato inviato a Meta per la revisione. Puoi continuare a usare gli SMS fino all’approvazione.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "Il modello {name} è stato inviato a Meta per la revisione. Puoi continuare a usare gli SMS fino all’approvazione.",
    "whatsapp.channel.title": "Canale di consegna",
    "Delivery channel": "Canale di consegna",
    "whatsapp.channel.help": "L’interruttore attiva WhatsApp per la tua attività. I codici di accesso possono essere inviati solo via SMS, solo su WhatsApp o via SMS con WhatsApp come riserva; le opzioni WhatsApp richiedono un modello di codice approvato.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "L’interruttore attiva WhatsApp per la tua attività. I codici di accesso possono essere inviati solo via SMS, solo su WhatsApp o via SMS con WhatsApp come riserva; le opzioni WhatsApp richiedono un modello di codice approvato.",
    "whatsapp.channel.primary_otp": "Canale OTP principale",
    "Primary OTP channel": "Canale OTP principale",
    "whatsapp.channel.sms_description": "Mantieni l’attuale modalità di invio SMS.",
    "Keep the existing SMS delivery path.": "Mantieni l’attuale modalità di invio SMS.",
    "whatsapp.channel.whatsapp_description": "Usa Meta Cloud API per questo tenant.",
    "Use Meta Cloud API for this tenant.": "Usa Meta Cloud API per questo tenant.",
    "whatsapp.channel.automatic": "Automatico",
    "Automatic": "Automatico",
    "whatsapp.channel.automatic_description": "Usa WhatsApp se configurato, altrimenti gli SMS.",
    "Use WhatsApp when configured, otherwise SMS.": "Usa WhatsApp se configurato, altrimenti gli SMS.",
    "whatsapp.channel.fallback": "Fallback dopo un errore WhatsApp",
    "Fallback after WhatsApp failure": "Fallback dopo un errore WhatsApp",
    "whatsapp.channel.no_fallback": "Nessun fallback",
    "No fallback": "Nessun fallback",
    "whatsapp.channel.no_fallback_description": "Restituisci il risultato di consegna configurato.",
    "Return the configured delivery result.": "Restituisci il risultato di consegna configurato.",
    "whatsapp.channel.sms_fallback_description": "Riprova tramite SMS con lo stesso codice OTP.",
    "Try SMS with the same OTP code.": "Riprova tramite SMS con lo stesso codice OTP.",
    "whatsapp.channel.sms_only": "Solo SMS",
    "SMS only": "Solo SMS",
    "whatsapp.channel.sms_only_description": "I codici vengono inviati via SMS.",
    "Codes are sent by text message.": "I codici vengono inviati via SMS.",
    "whatsapp.channel.whatsapp_only": "Solo WhatsApp",
    "WhatsApp only": "Solo WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "I codici vengono inviati dal tuo numero WhatsApp.",
    "Codes are sent from your WhatsApp number.": "I codici vengono inviati dal tuo numero WhatsApp.",
    "whatsapp.channel.sms_whatsapp": "SMS, WhatsApp come riserva",
    "SMS, WhatsApp as backup": "SMS, WhatsApp come riserva",
    "whatsapp.channel.sms_whatsapp_description": "I codici vengono inviati via SMS; se l’SMS non arriva, lo stesso codice viene inviato su WhatsApp.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "I codici vengono inviati via SMS; se l’SMS non arriva, lo stesso codice viene inviato su WhatsApp.",
    "whatsapp.advanced.title": "Impostazioni tecniche di ripristino",
    "Technical recovery settings": "Impostazioni tecniche di ripristino",
    "whatsapp.advanced.description": "Solo per il supporto della piattaforma. La maggior parte delle aziende dovrebbe usare Collega WhatsApp qui sopra.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Solo per il supporto della piattaforma. La maggior parte delle aziende dovrebbe usare Collega WhatsApp qui sopra.",
    "whatsapp.field.phone_number_id": "ID numero di telefono WhatsApp",
    "WhatsApp phone number ID": "ID numero di telefono WhatsApp",
    "whatsapp.field.phone_number_id_help": "L’ID del numero di telefono associato all’account WhatsApp Business.",
    "The phone number ID attached to your WhatsApp Business account.": "L’ID del numero di telefono associato all’account WhatsApp Business.",
    "whatsapp.field.waba_id": "ID account WhatsApp Business",
    "WhatsApp Business Account ID": "ID account WhatsApp Business",
    "whatsapp.field.waba_id_help": "Mostrato accanto all’ID del numero in Meta (WhatsApp > API Setup). Necessario per modelli e messaggi di prova.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Mostrato accanto all’ID del numero in Meta (WhatsApp > API Setup). Necessario per modelli e messaggi di prova.",
    "whatsapp.placeholder.phone_number_id": "ad es. 123456789012345",
    "e.g. 123456789012345": "ad es. 123456789012345",
    "whatsapp.field.access_token": "Token di accesso Meta",
    "Meta access token": "Token di accesso Meta",
    "whatsapp.field.access_token_saved_help": "Salvato in modo sicuro sul server. Lascialo vuoto per mantenerlo o inserisci un nuovo token per sostituirlo.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Salvato in modo sicuro sul server. Lascialo vuoto per mantenerlo o inserisci un nuovo token per sostituirlo.",
    "whatsapp.field.access_token_help": "Usa un token utente di sistema con autorizzazione per la messaggistica WhatsApp Business.",
    "Use a system-user token with WhatsApp Business messaging permission.": "Usa un token utente di sistema con autorizzazione per la messaggistica WhatsApp Business.",
    "whatsapp.placeholder.access_token_saved": "Salvato in modo sicuro · lascia vuoto",
    "Saved securely · leave blank to keep": "Salvato in modo sicuro · lascia vuoto",
    "whatsapp.placeholder.access_token": "Incolla il token",
    "Paste token": "Incolla il token",
    "whatsapp.token.saved": "Token di accesso Meta salvato in modo sicuro",
    "Meta access token saved securely": "Token di accesso Meta salvato in modo sicuro",
    "whatsapp.field.otp_template": "Nome del modello OTP approvato",
    "Approved OTP template name": "Nome del modello OTP approvato",
    "whatsapp.field.otp_template_help": "Il corpo del modello deve accettare l’OTP come singolo parametro di testo.",
    "The template body must accept the OTP as one text parameter.": "Il corpo del modello deve accettare l’OTP come singolo parametro di testo.",
    "whatsapp.placeholder.otp_template": "ad es. login_verification",
    "e.g. login_verification": "ad es. login_verification",
    "whatsapp.field.template_language": "Lingua del modello",
    "Template language": "Lingua del modello",
    "whatsapp.field.marketing_template": "Nome modello marketing approvato (facoltativo)",
    "Approved marketing template name (optional)": "Nome modello marketing approvato (facoltativo)",
    "whatsapp.field.marketing_template_help": "Usa un modello marketing approvato da Meta. Una campagna può sovrascrivere questo nome in content.template_name.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Usa un modello marketing approvato da Meta. Una campagna può sovrascrivere questo nome in content.template_name.",
    "whatsapp.placeholder.marketing_template": "ad es. monthly_offer",
    "e.g. monthly_offer": "ad es. monthly_offer",
    "whatsapp.field.marketing_language": "Lingua modello marketing",
    "Marketing template language": "Lingua modello marketing",
    "whatsapp.info.title": "Prima di abilitare WhatsApp",
    "Before enabling WhatsApp": "Prima di abilitare WhatsApp",
    "whatsapp.info.description": "Meta deve approvare ogni modello OTP o marketing prima dell’invio. I contenuti WhatsApp delle campagne usano template_name, template_language e parametri del corpo facoltativi; i numeri destinatari devono essere in formato E.164. Con il fallback automatico, ArcticOwl riprova via SMS con l’OTP originale senza generarne un altro.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta deve approvare ogni modello OTP o marketing prima dell’invio. I contenuti WhatsApp delle campagne usano template_name, template_language e parametri del corpo facoltativi; i numeri destinatari devono essere in formato E.164. Con il fallback automatico, ArcticOwl riprova via SMS con l’OTP originale senza generarne un altro.",
    "whatsapp.action.hide_token": "Nascondi token di accesso Meta",
    "Hide Meta access token": "Nascondi token di accesso Meta",
    "whatsapp.action.show_token": "Mostra token di accesso Meta",
    "Show Meta access token": "Mostra token di accesso Meta",
    "whatsapp.error.generic": "Impossibile salvare le impostazioni WhatsApp.",
    "Unable to save WhatsApp settings.": "Impossibile salvare le impostazioni WhatsApp.",
    "whatsapp.error.browser_required": "La connessione WhatsApp è disponibile solo in un browser.",
    "WhatsApp connection is only available in a browser.": "La connessione WhatsApp è disponibile solo in un browser.",
    "whatsapp.error.meta_load": "Impossibile caricare Meta. Controlla le impostazioni sulla privacy del browser e riprova.",
    "Meta could not load. Check the browser privacy settings and try again.": "Impossibile caricare Meta. Controlla le impostazioni sulla privacy del browser e riprova.",
    "whatsapp.error.load": "Impossibile caricare le impostazioni WhatsApp.",
    "Unable to load WhatsApp settings.": "Impossibile caricare le impostazioni WhatsApp.",
    "whatsapp.error.connect_before_template": "Collega WhatsApp prima di attivare un modello.",
    "Connect WhatsApp before activating a template.": "Collega WhatsApp prima di attivare un modello.",
    "whatsapp.error.template_submit": "Impossibile inviare il modello WhatsApp.",
    "Unable to submit the WhatsApp template.": "Impossibile inviare il modello WhatsApp.",
    "whatsapp.error.business_number_required": "Inserisci il numero WhatsApp Business prima di connetterti. Meta lo verificherà nel passaggio successivo.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Inserisci il numero WhatsApp Business prima di connetterti. Meta lo verificherà nel passaggio successivo.",
    "whatsapp.error.signup_not_ready": "La piattaforma sta ancora preparando la connessione WhatsApp. Riprova tra poco.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "La piattaforma sta ancora preparando la connessione WhatsApp. Riprova tra poco.",
    "whatsapp.error.signup_cancelled": "La connessione Meta è stata annullata o non ha restituito un codice di autorizzazione.",
    "Meta connection was cancelled or did not return an authorization code.": "La connessione Meta è stata annullata o non ha restituito un codice di autorizzazione.",
    "whatsapp.error.phone_number_missing": "Meta non ha restituito il numero WhatsApp Business selezionato. Riprova la connessione.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta non ha restituito il numero WhatsApp Business selezionato. Riprova la connessione.",
    "whatsapp.notice.connected_auto": "WhatsApp è connesso. L’invio OTP automatico usa prima WhatsApp e poi gli SMS in caso di errore.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp è connesso. L’invio OTP automatico usa prima WhatsApp e poi gli SMS in caso di errore.",
    "whatsapp.notice.connected_sms": "WhatsApp è connesso. Gli SMS restano attivi finché Meta non approva un modello di autenticazione.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp è connesso. Gli SMS restano attivi finché Meta non approva un modello di autenticazione.",
    "whatsapp.error.connect": "Impossibile connettere WhatsApp.",
    "Unable to connect WhatsApp.": "Impossibile connettere WhatsApp.",
    "whatsapp.error.otp_configuration": "Per OTP WhatsApp o Automatico servono ID del numero, nome di un modello OTP approvato e token di accesso Meta. Per il solo marketing WhatsApp, scegli gli SMS come canale OTP principale e lascia attivo il connettore.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "Per OTP WhatsApp o Automatico servono ID del numero, nome di un modello OTP approvato e token di accesso Meta. Per il solo marketing WhatsApp, scegli gli SMS come canale OTP principale e lascia attivo il connettore.",
    "whatsapp.notice.saved": "Impostazioni del connettore WhatsApp salvate per questo tenant.",
    "WhatsApp connector settings saved for this tenant.": "Impostazioni del connettore WhatsApp salvate per questo tenant.",
    "whatsapp.error.save": "Impossibile salvare le impostazioni WhatsApp.",
    "whatsapp.notice.discarded": "Bozza eliminata.",
    "Draft discarded.": "Bozza eliminata.",
    "whatsapp.test.title": "Invia un messaggio di prova",
    "Send a test message": "Invia un messaggio di prova",
    "whatsapp.test.description": "Invia un modello approvato a qualsiasi numero WhatsApp per verificare che la connessione funzioni.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Invia un modello approvato a qualsiasi numero WhatsApp per verificare che la connessione funzioni.",
    "whatsapp.test.refresh": "Aggiorna modelli",
    "Refresh templates": "Aggiorna modelli",
    "whatsapp.test.field.template": "Modello approvato",
    "Approved template": "Modello approvato",
    "whatsapp.test.field.parameter": "Valore per {{{number}}}",
    "Value for {{{number}}}": "Valore per {{{number}}}",
    "whatsapp.test.field.mobile": "Invia a",
    "Send to": "Invia a",
    "whatsapp.test.field.mobile_help": "Numero WhatsApp con prefisso internazionale.",
    "WhatsApp number with country code.": "Numero WhatsApp con prefisso internazionale.",
    "whatsapp.test.action.send": "Invia messaggio di prova",
    "Send test message": "Invia messaggio di prova",
    "whatsapp.test.sent": "Inviato a {mobile}. ID messaggio Meta: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "Inviato a {mobile}. ID messaggio Meta: {id}",
    "whatsapp.test.no_templates": "Nessun modello approvato. Attiva un modello qui sopra e invialo quando Meta lo approva.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Nessun modello approvato. Attiva un modello qui sopra e invialo quando Meta lo approva.",
    "common.discard_draft": "Elimina bozza",
    "common.status.connected": "Connesso",
    "Connected": "Connesso",
    "extensions.title": "Estensioni",
    "extensions.action.add": "Aggiungi estensione",
    "Add Extension": "Aggiungi estensione",
    "extensions.action.add_new": "Aggiungi nuova estensione",
    "Add New Extension": "Aggiungi nuova estensione",
    "extensions.action.edit": "Modifica estensione",
    "Edit Extension": "Modifica estensione",
    "extensions.action.delete": "Elimina estensione",
    "Delete extension": "Elimina estensione",
    "extensions.field.name": "Nome",
    "extensions.field.domain": "Dominio",
    "extensions.field.configs": "Configurazioni",
    "Configs": "Configurazioni",
    "extensions.placeholder.name": "Nome estensione",
    "Extension Name": "Nome estensione",
    "extensions.placeholder.domain": "Dominio estensione",
    "Extension Domain": "Dominio estensione",
    "extensions.empty": "Nessuna estensione configurata.",
    "No extensions configured yet.": "Nessuna estensione configurata.",
    "extensions.toast.added": "Estensione aggiunta correttamente.",
    "Extension added successfully.": "Estensione aggiunta correttamente.",
    "extensions.toast.updated": "Estensione aggiornata correttamente.",
    "Extension updated successfully.": "Estensione aggiornata correttamente.",
    "extensions.toast.deleted": "Estensione eliminata correttamente.",
    "Extension deleted successfully.": "Estensione eliminata correttamente.",
    "extensions.error.name_required": "Il nome è obbligatorio",
    "extensions.error.domain_required": "Il dominio è obbligatorio",
    "Domain is required": "Il dominio è obbligatorio",
    "extensions.error.configs_required": "La configurazione è obbligatoria",
    "Configs is required": "La configurazione è obbligatoria",
    "extensions.error.save_failed": "Impossibile salvare l’estensione.",
    "Unable to save the extension.": "Impossibile salvare l’estensione.",
    "extensions.error.delete_failed": "Impossibile eliminare l’estensione.",
    "Unable to delete the extension.": "Impossibile eliminare l’estensione.",
    "automation_rules.kicker": "Automazione operativa",
    "Operations automation": "Automazione operativa",
    "automation_rules.title": "Regole di automazione",
    "Automation rules": "Regole di automazione",
    "automation_rules.description": "Trasforma gli eventi del personale e delle spese in passaggi chiari di approvazione e verifica.",
    "Turn staff and expense events into clear approval and review steps.": "Trasforma gli eventi del personale e delle spese in passaggi chiari di approvazione e verifica.",
    "automation_rules.action.new_rule": "Nuova regola",
    "New rule": "Nuova regola",
    "automation_rules.action.create_rule": "Crea regola",
    "Create rule": "Crea regola",
    "automation_rules.action.create_help": "Salva questo trigger, le condizioni e l’azione come regola",
    "Save this trigger, conditions, and action as a rule": "Salva questo trigger, le condizioni e l’azione come regola",
    "automation_rules.action.add_condition": "Aggiungi condizione",
    "Add condition": "Aggiungi condizione",
    "automation_rules.action.add_condition_help": "Aggiungi un’altra condizione a questa regola",
    "Add another condition to this rule": "Aggiungi un’altra condizione a questa regola",
    "automation_rules.action.remove_condition": "Rimuovi condizione",
    "Remove condition": "Rimuovi condizione",
    "automation_rules.action.choose": "Scegli un’azione",
    "Choose an action": "Scegli un’azione",
    "automation_rules.action.require_second_approver": "Richiedi un secondo approvatore",
    "Require second approver": "Richiedi un secondo approvatore",
    "automation_rules.action.require_second_approver_help": "Invia la richiesta a un altro approvatore.",
    "Route the claim to another approver.": "Invia la richiesta a un altro approvatore.",
    "automation_rules.action.auto_reject_expense": "Rifiuta automaticamente la spesa",
    "Auto-reject expense": "Rifiuta automaticamente la spesa",
    "automation_rules.action.auto_reject_expense_help": "Rifiuta la spesa specificando il motivo.",
    "Reject the expense with a reason.": "Rifiuta la spesa specificando il motivo.",
    "automation_rules.action.notify_role": "Notifica un ruolo",
    "Notify a role": "Notifica un ruolo",
    "automation_rules.action.notify_role_help": "Invia una notifica al personale con un determinato ruolo.",
    "Send a notification to a staff role.": "Invia una notifica al personale con un determinato ruolo.",
    "automation_rules.action.flag_for_review": "Contrassegna per revisione",
    "Flag for review": "Contrassegna per revisione",
    "automation_rules.action.flag_for_review_help": "Contrassegna una risorsa per la revisione manuale.",
    "Mark a resource for manual review.": "Contrassegna una risorsa per la revisione manuale.",
    "automation_rules.field.rule_name": "Nome regola",
    "Rule name": "Nome regola",
    "automation_rules.field.priority": "Priorità",
    "automation_rules.field.module": "Modulo",
    "Module": "Modulo",
    "automation_rules.field.event": "Evento",
    "automation_rules.field.field": "Campo",
    "Field": "Campo",
    "automation_rules.field.operator": "Operatore",
    "Operator": "Operatore",
    "automation_rules.field.value": "Valore",
    "automation_rules.field.action": "Azione",
    "automation_rules.field.action_params": "Parametri azione",
    "Action parameters": "Parametri azione",
    "automation_rules.placeholder.rule_name": "Richiedi un secondo approvatore per le spese elevate",
    "Require second approver for large claims": "Richiedi un secondo approvatore per le spese elevate",
    "automation_rules.placeholder.field": "importo",
    "amount": "importo",
    "automation_rules.placeholder.value": "500 o false",
    "500 or false": "500 o false",
    "automation_rules.builder.description": "Configura il trigger, le condizioni e l’azione, quindi salvali come un’unica regola.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Configura il trigger, le condizioni e l’azione, quindi salvali come un’unica regola.",
    "automation_rules.error.load": "Impossibile caricare le regole di automazione.",
    "Unable to load automation rules.": "Impossibile caricare le regole di automazione.",
    "automation_rules.error.required_fields": "Nome, modulo, evento e azione sono obbligatori.",
    "Name, module, event, and action are required.": "Nome, modulo, evento e azione sono obbligatori.",
    "automation_rules.error.create": "Impossibile creare la regola di automazione.",
    "Unable to create automation rule.": "Impossibile creare la regola di automazione.",
    "automation_rules.error.valid_json": "Usa un JSON valido prima di salvare.",
    "Use valid JSON before saving.": "Usa un JSON valido prima di salvare.",
    "automation_rules.notice.created": "Regola di automazione creata.",
    "Automation rule created.": "Regola di automazione creata.",
    "automation_rules.notice.discarded": "Bozza eliminata.",
    "automation_rules.draft.restored": "È stata ripristinata la bozza non salvata della regola di automazione.",
    "Your unsaved automation rule draft was restored.": "È stata ripristinata la bozza non salvata della regola di automazione.",
    "automation_rules.list.title": "Regole",
    "automation_rules.list.count": "{count} configurate",
    "{count} configured": "{count} configurate",
    "automation_rules.list.loading": "Caricamento regole…",
    "Loading rules…": "Caricamento regole…",
    "automation_rules.list.unnamed": "Regola senza nome",
    "Unnamed rule": "Regola senza nome",
    "automation_rules.list.no_action": "Nessuna azione configurata",
    "No action configured": "Nessuna azione configurata",
    "automation_rules.list.empty": "Nessuna regola. Crea la prima dal diagramma.",
    "No rules yet. Create the first one from the diagram.": "Nessuna regola. Crea la prima dal diagramma.",
    "automation_rules.status.draft": "Bozza",
    "automation_rules.status.active": "Attiva",
    "automation_rules.inspector.title": "Impostazioni blocco",
    "Block settings": "Impostazioni blocco",
    "automation_rules.inspector.diagram": "Diagramma",
    "Diagram": "Diagramma",
    "automation_rules.inspector.select_block": "Seleziona un blocco nel diagramma per configurarlo.",
    "Select a block on the diagram to configure it.": "Seleziona un blocco nel diagramma per configurarlo.",
    "automation_rules.inspector.no_configuration": "Questo blocco non richiede configurazione.",
    "This block does not need configuration.": "Questo blocco non richiede configurazione.",
    "automation_rules.node.trigger": "Trigger",
    "automation_rules.node.condition": "Condizione",
    "automation_rules.node.action": "Azione",
    "automation_rules.node.end": "Fine",
    "automation_rules.node.completed": "Completato",
    "automation_rules.node.finished": "Valutazione regola completata",
    "Rule evaluation finished": "Valutazione regola completata",
    "automation_rules.trigger.choose_event": "Scegli un evento",
    "Choose an event": "Scegli un evento",
    "automation_rules.trigger.module": "modulo",
    "module": "modulo",
    "automation_rules.trigger.module_event": "Evento del modulo {module}",
    "{module} event": "Evento del modulo {module}",
    "automation_rules.trigger.help": "La regola viene valutata quando il modulo genera questo evento.",
    "The rule evaluates when this event is emitted by the module.": "La regola viene valutata quando il modulo genera questo evento.",
    "automation_rules.condition.label": "Condizione",
    "automation_rules.condition.none": "Nessuna condizione",
    "No conditions": "Nessuna condizione",
    "automation_rules.condition.always_fires": "Si attiva sempre",
    "Always fires": "Si attiva sempre",
    "automation_rules.condition.empty_help": "Aggiungi una condizione per limitare questa regola.",
    "Add a condition to restrict this rule.": "Aggiungi una condizione per limitare questa regola.",
    "automation_rules.condition.value_required": "Il valore è obbligatorio",
    "Value required": "Il valore è obbligatorio",
    "automation_rules.condition.value": "Valore: {value}",
    "Value: {value}": "Valore: {value}",
    "automation_rules.operator.equals": "Uguale a",
    "Equals": "Uguale a",
    "automation_rules.operator.gt": "Maggiore di",
    "Greater than": "Maggiore di",
    "automation_rules.operator.gte": "Maggiore o uguale a",
    "Greater than or equal": "Maggiore o uguale a",
    "automation_rules.operator.lt": "Minore di",
    "Less than": "Minore di",
    "automation_rules.operator.exists": "Esiste",
    "Exists": "Esiste",
    "automation_rules.module.expenses": "Spese",
    "automation_rules.module.staff": "Personale",
    "automation_rules.event.expense.submitted": "Spesa inviata",
    "automation_rules.event.leave.requested": "Congedo richiesto",
    "Leave requested": "Congedo richiesto",
    "automation_rules.event.payroll_run.created": "Elaborazione paghe creata",
    "automation_rules.meta.conditions": "{count} condizioni · devono corrispondere tutte prima dell’azione",
    "{count} condition(s) · all must match before the action runs": "{count} condizioni · devono corrispondere tutte prima dell’azione",
    "automation_rules.meta.no_conditions": "Nessuna condizione · l’azione viene eseguita dopo il trigger",
    "No conditions · the action always runs after the trigger": "Nessuna condizione · l’azione viene eseguita dopo il trigger",
    "automation_rules.draft.unsaved": "È presente una bozza non salvata di una regola di automazione.",
    "You have an unsaved automation rule draft.": "È presente una bozza non salvata di una regola di automazione.",
    "automation_rules.meta.one_condition": "1 condizione · deve corrispondere prima dell’azione",
    "1 condition · all must match before the action runs": "1 condizione · deve corrispondere prima dell’azione",
    "automation_rules.meta.many_conditions": "{count} condizioni · devono corrispondere tutte prima dell’azione",
    "{count} conditions · all must match before the action runs": "{count} condizioni · devono corrispondere tutte prima dell’azione",
    "cms.type.page": "Pagina",
    "Page": "Pagina",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Documenti",
    "cms.type.pages": "Pagine",
    "cms.type.blogs": "Blog",
    "Blogs": "Blog",
    "cms.action.add_content": "Aggiungi contenuto",
    "Add content": "Aggiungi contenuto",
    "cms.action.add_type": "Aggiungi {type}",
    "cms.action.create_type": "Crea {type}",
    "Create {type}": "Crea {type}",
    "cms.action.edit": "Modifica",
    "cms.action.duplicate": "Duplica",
    "Duplicate": "Duplica",
    "cms.action.open": "Apri",
    "cms.field.title": "Titolo",
    "cms.field.slug": "Slug",
    "cms.field.content": "Contenuto",
    "cms.field.meta_title": "Meta titolo",
    "cms.field.meta_description": "Meta descrizione",
    "cms.placeholder.title": "ad es. Chi siamo",
    "e.g. About us": "ad es. Chi siamo",
    "cms.placeholder.slug": "chi-siamo",
    "about-us": "chi-siamo",
    "cms.placeholder.page_title": "Titolo pagina",
    "Page title": "Titolo pagina",
    "cms.placeholder.page_slug": "slug-pagina",
    "page-slug": "slug-pagina",
    "cms.placeholder.content": "Scrivi qui il contenuto…",
    "Write your content here…": "Scrivi qui il contenuto…",
    "cms.placeholder.meta_title": "Per impostazione predefinita usa il titolo",
    "Defaults to title": "Per impostazione predefinita usa il titolo",
    "cms.placeholder.meta_description": "Breve descrizione per i motori di ricerca",
    "Short description for search engines": "Breve descrizione per i motori di ricerca",
    "cms.section.seo_optional": "SEO (facoltativo)",
    "SEO (optional)": "SEO (facoltativo)",
    "cms.error.title_required": "Il titolo è obbligatorio.",
    "Title is required.": "Il titolo è obbligatorio.",
    "cms.error.content_required": "Aggiungi contenuto prima di salvare.",
    "Add some content before saving.": "Aggiungi contenuto prima di salvare.",
    "cms.error.create": "Creazione non riuscita. Riprova.",
    "Failed to create. Please try again.": "Creazione non riuscita. Riprova.",
    "cms.error.save": "Salvataggio non riuscito.",
    "Failed to save.": "Salvataggio non riuscito.",
    "cms.error.load_layer": "Impossibile caricare questo contenuto.",
    "Could not load this layer.": "Impossibile caricare questo contenuto.",
    "cms.toast.created": "{type} creato correttamente.",
    "{type} created successfully.": "{type} creato correttamente.",
    "cms.toast.saved": "Salvato",
    "Saved": "Salvato",
    "cms.toast.changes_saved": "Modifiche salvate.",
    "Changes saved.": "Modifiche salvate.",
    "cms.toast.deleted": "Eliminato",
    "cms.toast.duplicated": "Duplicato",
    "Duplicated": "Duplicato",
    "cms.error.delete": "Eliminazione non riuscita",
    "Failed to delete": "Eliminazione non riuscita",
    "cms.error.duplicate": "Duplicazione non riuscita",
    "Failed to duplicate": "Duplicazione non riuscita",
    "cms.confirm.delete": "Eliminare “{title}”?",
    "Delete \"{title}\"?": "Eliminare “{title}”?",
    "cms.duplicate.title": "{title} (copia)",
    "{title} (copy)": "{title} (copia)",
    "cms.draft.restored": "È stata ripristinata la bozza non salvata.",
    "Your unsaved content draft was restored.": "È stata ripristinata la bozza non salvata.",
    "cms.search": "Cerca…",
    "Search…": "Cerca…",
    "cms.list.no_results": "Nessun risultato.",
    "No results found.": "Nessun risultato.",
    "cms.list.empty_type": "Nessun elemento di tipo {type}.",
    "No {type} yet.": "Nessun elemento di tipo {type}.",
    "cms.list.untitled": "Senza titolo",
    "Untitled": "Senza titolo",
    "cms.editor.placeholder": "Scrivi qui il contenuto…",
    "cms.editor.normal_text": "Testo normale",
    "Normal text": "Testo normale",
    "cms.editor.heading": "Titolo {level}",
    "Heading {level}": "Titolo {level}",
    "cms.editor.align_left": "Allinea a sinistra",
    "Align Left": "Allinea a sinistra",
    "cms.editor.align_center": "Allinea al centro",
    "Align Center": "Allinea al centro",
    "cms.editor.align_right": "Allinea a destra",
    "Align Right": "Allinea a destra",
    "cms.editor.insert_table": "Inserisci tabella",
    "Insert table": "Inserisci tabella",
    "cms.editor.add_column": "Aggiungi colonna",
    "Add column": "Aggiungi colonna",
    "cms.editor.add_row": "Aggiungi riga",
    "Add row": "Aggiungi riga",
    "cms.editor.delete_table": "Elimina tabella",
    "Delete table": "Elimina tabella",
    "cms.editor.delete_column": "Elimina colonna",
    "Delete column": "Elimina colonna",
    "cms.editor.delete_row": "Elimina riga",
    "Delete row": "Elimina riga",
    "cms.editor.underline": "Sottolineato",
    "Underline": "Sottolineato",
    "cms.editor.strikethrough": "Barrato",
    "Strikethrough": "Barrato",
    "cms.editor.code": "Codice",
    "cms.editor.code_block": "Blocco di codice",
    "Code block": "Blocco di codice",
    "cms.editor.subscript": "Pedice",
    "Subscript": "Pedice",
    "cms.editor.superscript": "Apice",
    "Superscript": "Apice",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "URL immagine",
    "Image URL": "URL immagine",
    "cms.editor.prompt.youtube_url": "URL YouTube",
    "YouTube URL": "URL YouTube",
    "cms.editor.undo": "Annulla",
    "cms.editor.redo": "Ripeti",
    "cms.editor.table": "Tabella",
    "Table": "Tabella",
    "cms.editor.more": "Altro",
    "cms.editor.bold": "Grassetto",
    "Bold": "Grassetto",
    "cms.editor.italic": "Corsivo",
    "Italic": "Corsivo",
    "cms.editor.bullet_list": "Elenco puntato",
    "Bullet list": "Elenco puntato",
    "cms.editor.ordered_list": "Elenco numerato",
    "Ordered list": "Elenco numerato",
    "cms.editor.task_list": "Elenco attività",
    "Task list": "Elenco attività",
    "cms.editor.link": "Link",
    "Link": "Link",
    "cms.editor.image": "Immagine",
    "cms.editor.text_color": "Colore testo",
    "Text color": "Colore testo",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Pagine",
    "cms.test.type.pages_description": "Pagine di destinazione e contenuti strutturati del negozio.",
    "Landing pages and structured storefront content.": "Pagine di destinazione e contenuti strutturati del negozio.",
    "cms.test.type.blogs": "Blog",
    "cms.test.type.blogs_description": "Articoli, storie e aggiornamenti per il tuo pubblico.",
    "Articles, stories, and updates for your audience.": "Articoli, storie e aggiornamenti per il tuo pubblico.",
    "cms.test.type.docs": "Documenti",
    "cms.test.type.docs_description": "Documentazione, guide e contenuti di supporto.",
    "Documentation, guides, and help content.": "Documentazione, guide e contenuti di supporto.",
    "cms.test.operation.list": "Elenca contenuti per tipo",
    "List content by type": "Elenca contenuti per tipo",
    "cms.test.operation.fetch": "Recupera un Layer",
    "Fetch one Layer": "Recupera un Layer",
    "cms.test.operation.create": "Crea un Layer",
    "Create a Layer": "Crea un Layer",
    "cms.test.operation.update": "Aggiorna un Layer",
    "Update a Layer": "Aggiorna un Layer",
    "cms.test.operation.delete": "Elimina un Layer",
    "Delete a Layer": "Elimina un Layer",
    "cms.test.operation.search": "Cerca contenuti",
    "Search content": "Cerca contenuti",
    "cms.test.operation.categories": "Carica categorie",
    "Load categories": "Carica categorie",
    "cms.test.operation.translations": "Salva traduzioni",
    "Save translations": "Salva traduzioni",
    "cms.test.editor.placeholder": "Scrivi il contenuto della pagina…",
    "Write your page content...": "Scrivi il contenuto della pagina…",
    "cms.test.error.load_type": "Impossibile caricare i contenuti {type}",
    "Unable to load {type} content": "Impossibile caricare i contenuti {type}",
    "cms.test.error.load": "Impossibile caricare i contenuti CMS.",
    "Unable to load CMS content.": "Impossibile caricare i contenuti CMS.",
    "cms.test.error.required": "Aggiungi titolo e contenuto prima di salvare.",
    "Add a page title and content before saving.": "Aggiungi titolo e contenuto prima di salvare.",
    "cms.test.error.create": "Impossibile creare la pagina.",
    "Unable to create this page.": "Impossibile creare la pagina.",
    "cms.test.toast.created": "Pagina creata correttamente.",
    "Page created successfully.": "Pagina creata correttamente.",
    "cms.test.hero.eyebrow": "GESTIONE CONTENUTI",
    "CONTENT MANAGEMENT": "GESTIONE CONTENUTI",
    "cms.test.hero.title": "CMS Layers",
    "Layers CMS": "CMS Layers",
    "cms.test.hero.description": "Crea contenuti strutturati una sola volta e rendili disponibili su vetrina, app ed esperienze personalizzate.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Crea contenuti strutturati una sola volta e rendili disponibili su vetrina, app ed esperienze personalizzate.",
    "cms.test.hero.live_workspace": "Area di lavoro attiva: {tenant} · anteprima di sola lettura",
    "Live workspace: {tenant} · read-only preview": "Area di lavoro attiva: {tenant} · anteprima di sola lettura",
    "cms.test.current_tenant": "tenant corrente",
    "current tenant": "tenant corrente",
    "cms.test.content.title": "I tuoi contenuti",
    "Your content": "I tuoi contenuti",
    "cms.test.content.description": "Gestisci pagine, blog e documenti da un unico posto.",
    "Pages, blogs, and docs are ready to manage from one place.": "Gestisci pagine, blog e documenti da un unico posto.",
    "cms.test.action.create_page": "Crea pagina",
    "Create Page": "Crea pagina",
    "cms.test.form.description": "Crea contenuti strutturati in Layers. La pagina sarà disponibile tramite API dopo il salvataggio.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Crea contenuti strutturati in Layers. La pagina sarà disponibile tramite API dopo il salvataggio.",
    "cms.test.placeholder.slug": "chi-siamo (facoltativo)",
    "about-us (optional)": "chi-siamo (facoltativo)",
    "cms.test.draft.unsaved": "È presente una bozza di pagina non salvata.",
    "You have an unsaved page draft.": "È presente una bozza di pagina non salvata.",
    "cms.test.loading": "Caricamento contenuti Layers…",
    "Loading live Layers content…": "Caricamento contenuti Layers…",
    "cms.test.content.empty_title": "Nessun contenuto {type}",
    "No {type} yet": "Nessun contenuto {type}",
    "cms.test.content.empty_description": "Crea il primo Layer nell’area di lavoro per visualizzarlo qui.",
    "Create your first Layer in the workspace to see it here.": "Crea il primo Layer nell’area di lavoro per visualizzarlo qui.",
    "cms.test.feature.types": "Tipi di contenuto personalizzati",
    "Custom content types": "Tipi di contenuto personalizzati",
    "cms.test.feature.types_description": "Pagine, blog e documenti sono un punto di partenza. Definisci Post o qualsiasi modello serva alla tua attività.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Pagine, blog e documenti sono un punto di partenza. Definisci Post o qualsiasi modello serva alla tua attività.",
    "cms.test.feature.structured": "Strutturati e localizzati",
    "Structured and localized": "Strutturati e localizzati",
    "cms.test.feature.structured_description": "Usa slug, categorie, immagini, metadati SEO e traduzioni per la stessa fonte di contenuti.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Usa slug, categorie, immagini, metadati SEO e traduzioni per la stessa fonte di contenuti.",
    "cms.test.feature.headless": "Headless per impostazione predefinita",
    "Headless by default": "Headless per impostazione predefinita",
    "cms.test.feature.headless_description": "Usa le API Layers su siti web, app mobile, strumenti interni o frontend personalizzati.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Usa le API Layers su siti web, app mobile, strumenti interni o frontend personalizzati.",
    "cms.test.feature.ai": "Fonte di conoscenza AI",
    "AI knowledge source": "Fonte di conoscenza AI",
    "cms.test.feature.ai_description": "Invia i contenuti Tradly CMS a iRyxo Agent Builder come fonte di conoscenza.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Invia i contenuti Tradly CMS a iRyxo Agent Builder come fonte di conoscenza.",
    "cms.test.community.eyebrow": "CONTENUTI DELLA COMMUNITY",
    "COMMUNITY CONTENT": "CONTENUTI DELLA COMMUNITY",
    "cms.test.community.title": "Trasforma Layers in un feed social",
    "Turn Layers into a social feed": "Trasforma Layers in un feed social",
    "cms.test.community.description": "Crea un tipo personalizzato Post, consenti agli utenti di pubblicare aggiornamenti e aggiungi interazioni tramite il frontend.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Crea un tipo personalizzato Post, consenti agli utenti di pubblicare aggiornamenti e aggiungi interazioni tramite il frontend.",
    "cms.test.community.share_placeholder": "Condividi un aggiornamento…",
    "Share an update…": "Condividi un aggiornamento…",
    "cms.test.community.post": "Pubblica",
    "Post": "Pubblica",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Aggiornamento della community pubblicato da un Layer personalizzato.",
    "A community update published from a custom Layer.": "Aggiornamento della community pubblicato da un Layer personalizzato.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 commenti   ·   ↗ Condividi",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 commenti   ·   ↗ Condividi",
    "cms.test.community.endpoints": "Esempi di endpoint",
    "Example endpoints": "Esempi di endpoint",
    "cms.test.developer.eyebrow": "ACCESSO SVILUPPATORI",
    "DEVELOPER ACCESS": "ACCESSO SVILUPPATORI",
    "cms.test.developer.title": "API Layers",
    "Layers API": "API Layers",
    "cms.test.developer.docs": "Documentazione sviluppatori",
    "Developer docs": "Documentazione sviluppatori",
    "auth.title": "Autenticazione",
    "auth.sign_in_method": "Metodo di accesso",
    "auth.facebook_auth": "Autenticazione Facebook",
    "auth.google_auth": "Autenticazione Google",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "SSO aziendale",
    "Enterprise SSO": "SSO aziendale",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "Impostazioni checkout",
    "Checkout Settings": "Impostazioni checkout",
    "checkout.orders": "Ordini",
    "checkout.carts": "Carrelli",
    "Carts": "Carrelli",
    "audit_logs.action": "Azione",
    "audit_logs.resource": "Risorsa",
    "audit_logs.resource_id": "ID risorsa",
    "Resource ID": "ID risorsa",
    "audit_logs.agent_id": "ID agente",
    "Agent ID": "ID agente",
    "audit_logs.result": "Risultato",
    "audit_logs.actor_id": "ID autore",
    "Actor ID": "ID autore",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Data e ora",
    "Timestamp": "Data e ora",
    "audit_logs.succeeded": "Riuscito",
    "audit_logs.failed": "Non riuscito",
    "audit_logs.source": "Fonte",
    "audit_logs.all_sources": "Tutte le fonti",
    "All sources": "Tutte le fonti",
    "audit_logs.human_admin": "Persona (amministratore)",
    "Human (admin)": "Persona (amministratore)",
    "audit_logs.agent_mcp": "Agente (MCP)",
    "Agent (MCP)": "Agente (MCP)",
    "audit_logs.all_actions": "Tutte le azioni",
    "All actions": "Tutte le azioni",
    "audit_logs.from": "Da",
    "audit_logs.to": "A",
    "audit_logs.apply": "Applica",
    "audit_logs.clear": "Cancella",
    "audit_logs.export_csv": "Esporta CSV",
    "audit_logs.exporting": "Esportazione…",
    "audit_logs.title": "Registro di controllo",
    "audit_logs.empty_title": "Nessun registro di controllo trovato",
    "No audit logs found": "Nessun registro di controllo trovato",
    "audit_logs.empty_subtitle": "Prova a modificare i filtri",
    "Try adjusting your filters": "Prova a modificare i filtri",
    "audit_logs.restriction_notice": "Sono visualizzati gli ultimi 5 log di controllo. Passa a Growth per vedere tutta la cronologia ed esportare i log.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Sono visualizzati gli ultimi 5 log di controllo. Passa a Growth per vedere tutta la cronologia ed esportare i log.",
    "audit_logs.extended_history": "Cronologia di controllo estesa",
    "Extended audit log history": "Cronologia di controllo estesa",
    "manage_features.title": "Gestisci funzionalità",
    "manage_features.general": "Generale",
    "manage_features.apps": "App",
    "manage_features.marketplace": "Marketplace",
    "manage_features.commerce": "Commercio",
    "manage_features.channels": "Canali",
    "manage_features.left_menu": "Menu sinistro",
    "Left Menu": "Menu sinistro",
    "manage_features.right_sidepanel": "Pannello laterale destro",
    "Right Sidepanel": "Pannello laterale destro",
    "workflow.integration": "Integrazione",
    "workflow.no_url_title": "URL di integrazione mancante",
    "No Integration URL": "URL di integrazione mancante",
    "workflow.no_url_description": "Configura l’URL di integrazione.",
    "Please configure the integration URL.": "Configura l’URL di integrazione.",
    "workflow.back": "Indietro",
    "Go Back": "Indietro",
    "workflow.loading": "Caricamento integrazione…",
    "Loading integration...": "Caricamento integrazione…",
    "workflow.loading_hint": "Attendi mentre ci connettiamo",
    "Please wait while we connect": "Attendi mentre ci connettiamo",
    "workflow.error_title": "Errore di integrazione",
    "Integration Error": "Errore di integrazione",
    "workflow.error_description": "Impossibile caricare l’integrazione. Controlla la connessione e riprova.",
    "Unable to load the integration. Please check your connection and try again.": "Impossibile caricare l’integrazione. Controlla la connessione e riprova.",
    "workflow.retry": "Riprova",
    "Try Again": "Riprova",
    "upgrade_preview.eyebrow": "Anteprima componente",
    "Component preview": "Anteprima componente",
    "upgrade_preview.title": "Esperienza di upgrade",
    "Upgrade experience": "Esperienza di upgrade",
    "upgrade_preview.description": "Un punto di accesso condiviso alle funzionalità, incentrato su ciò che il cliente può fare dopo l’upgrade.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Un punto di accesso condiviso alle funzionalità, incentrato su ciò che il cliente può fare dopo l’upgrade.",
    "upgrade_preview.feature": "Aggiungi variante",
    "Add a variant": "Aggiungi variante",
    "upgrade_preview.context": "Questo è il punto in cui un utente Basic raggiunge il limite della funzionalità.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Questo è il punto in cui un utente Basic raggiunge il limite della funzionalità.",
    "upgrade_preview.button": "Anteprima pannello upgrade",
    "Preview upgrade panel": "Anteprima pannello upgrade",
    "upgrade_preview.listing_context": "Per questa inserzione",
    "For this listing": "Per questa inserzione",
    "gamification_test.eyebrow": "GAMIFICATION CRESCITA · PERCORSO TEST",
    "GROWTH GAMIFICATION · TEST ROUTE": "GAMIFICATION CRESCITA · PERCORSO TEST",
    "gamification_test.title": "Dai slancio alla tua attività",
    "Build momentum for your business": "Dai slancio alla tua attività",
    "gamification_test.subtitle": "Anteprima di missioni, monete, badge e serie per {workspace}.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "Anteprima di missioni, monete, badge e serie per {workspace}.",
    "gamification_test.this_workspace": "questa area di lavoro",
    "this workspace": "questa area di lavoro",
    "gamification_test.coins": "MONETE",
    "COINS": "MONETE",
    "gamification_test.points": "PUNTI",
    "POINTS": "PUNTI",
    "gamification_test.streak": "SERIE",
    "STREAK": "SERIE",
    "gamification_test.week": "1 settimana",
    "1 week": "1 settimana",
    "gamification_test.launch": "Percorso di lancio",
    "Launch path": "Percorso di lancio",
    "gamification_test.progress": "{completed} di {total} azioni completate · fino a {coins} monete",
    "{completed} of {total} actions complete · up to {coins} coins": "{completed} di {total} azioni completate · fino a {coins} monete",
    "gamification_test.done": "Fatto",
    "gamification_test.reward": "+{count} monete",
    "+{count} coins": "+{count} monete",
    "gamification_test.badges": "Badge",
    "Badges": "Badge",
    "gamification_test.mission_listing_created": "Crea la tua prima inserzione",
    "Create your first listing": "Crea la tua prima inserzione",
    "gamification_test.mission_collection_created": "Crea la tua prima raccolta",
    "gamification_test.mission_payment_configured": "Configura i pagamenti",
    "Configure payments": "Configura i pagamenti",
    "gamification_test.mission_publish_completed": "Pubblica il tuo sito",
    "Publish your site": "Pubblica il tuo sito",
    "gamification_test.mission_analytics_enabled": "Abilita le analisi",
    "Enable analytics": "Abilita le analisi",
    "gamification_test.badge_first_step": "Primo passo",
    "First Step": "Primo passo",
    "gamification_test.badge_catalog_builder": "Creatore del catalogo",
    "Catalog Builder": "Creatore del catalogo",
    "gamification_test.badge_ready_to_sell": "Pronto a vendere",
    "Ready to Sell": "Pronto a vendere",
    "gamification_test.badge_data_driven": "Basato sui dati",
    "Data Driven": "Basato sui dati",
    "gamification_test.badge_growth_operator": "Operatore della crescita",
    "Growth Operator": "Operatore della crescita",
    "sentry_check.title": "Verifica configurazione Sentry",
    "Sentry Configuration Check": "Verifica configurazione Sentry",
    "sentry_check.subtitle": "Verifica e testa la configurazione del monitoraggio errori Sentry",
    "Test and verify Sentry error tracking setup": "Verifica e testa la configurazione del monitoraggio errori Sentry",
    "sentry_check.configuration": "Configurazione",
    "sentry_check.check_configuration": "Verifica configurazione",
    "Check Configuration": "Verifica configurazione",
    "sentry_check.status": "Stato:",
    "Status:": "Stato:",
    "sentry_check.enabled": "✓ Abilitato",
    "✓ Enabled": "✓ Abilitato",
    "sentry_check.disabled": "✗ Disabilitato",
    "✗ Disabled": "✗ Disabilitato",
    "sentry_check.environment": "Ambiente:",
    "Environment:": "Ambiente:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "Frequenza campionamento tracce:",
    "Traces Sample Rate:": "Frequenza campionamento tracce:",
    "sentry_check.test_functions": "Funzioni di test",
    "Test Functions": "Funzioni di test",
    "sentry_check.test_hint": "Fai clic sui pulsanti per testare Sentry. Controlla la dashboard per verificare che gli eventi vengano acquisiti.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Fai clic sui pulsanti per testare Sentry. Controlla la dashboard per verificare che gli eventi vengano acquisiti.",
    "sentry_check.test_results": "Risultati test",
    "Test Results": "Risultati test",
    "sentry_check.clear": "Cancella",
    "sentry_check.no_tests": "Nessun test eseguito",
    "No tests run yet": "Nessun test eseguito",
    "sentry_check.important_notes": "⚠️ Note importanti",
    "⚠️ Important Notes": "⚠️ Note importanti",
    "sentry_check.warning_real_events": "• Questi test creano eventi di errore reali nella dashboard Sentry",
    "• These tests will create real error events in your Sentry dashboard": "• Questi test creano eventi di errore reali nella dashboard Sentry",
    "sentry_check.warning_dashboard": "• Controlla la dashboard Sentry per verificare che gli eventi vengano acquisiti",
    "• Check your Sentry dashboard to verify events are being captured": "• Controlla la dashboard Sentry per verificare che gli eventi vengano acquisiti",
    "sentry_check.warning_traces": "• Alcuni test potrebbero non apparire se tracesSampleRate è 0.0",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• Alcuni test potrebbero non apparire se tracesSampleRate è 0.0",
    "sentry_check.warning_dsn": "• Verifica che il DSN sia configurato correttamente nelle variabili d’ambiente",
    "• Make sure your DSN is correctly configured in environment variables": "• Verifica che il DSN sia configurato correttamente nelle variabili d’ambiente",
    "sentry_check.normal_error": "Test errore normale",
    "Test Normal Error": "Test errore normale",
    "sentry_check.test_normal_error": "Test errore normale",
    "sentry_check.test_message": "Test messaggio",
    "Test Message": "Test messaggio",
    "sentry_check.test_breadcrumb": "Test breadcrumb",
    "Test Breadcrumb": "Test breadcrumb",
    "sentry_check.test_user_context": "Test contesto utente",
    "Test User Context": "Test contesto utente",
    "sentry_check.test_custom_exception": "Test eccezione personalizzata",
    "Test Custom Exception": "Test eccezione personalizzata",
    "sentry_check.test_promise_rejection": "Test rifiuto Promise",
    "Test Promise Rejection": "Test rifiuto Promise",
    "sentry_check.configuration_check": "Verifica configurazione",
    "Configuration Check": "Verifica configurazione",
    "sentry_check.config_loaded": "Configurazione caricata correttamente",
    "Config loaded successfully": "Configurazione caricata correttamente",
    "sentry_check.error_captured": "Errore acquisito e inviato a Sentry",
    "Error captured and sent to Sentry": "Errore acquisito e inviato a Sentry",
    "sentry_check.error_capture_failed": "Acquisizione errore non riuscita: {message}",
    "Failed to capture error: {message}": "Acquisizione errore non riuscita: {message}",
    "sentry_check.message": "Messaggio",
    "Message": "Messaggio",
    "sentry_check.message_captured": "Messaggio acquisito e inviato a Sentry",
    "Message captured and sent to Sentry": "Messaggio acquisito e inviato a Sentry",
    "sentry_check.message_capture_failed": "Acquisizione messaggio non riuscita: {message}",
    "Failed to capture message: {message}": "Acquisizione messaggio non riuscita: {message}",
    "sentry_check.breadcrumb": "Breadcrumb",
    "Breadcrumb": "Breadcrumb",
    "sentry_check.breadcrumb_added": "Breadcrumb aggiunto al contesto Sentry",
    "Breadcrumb added to Sentry context": "Breadcrumb aggiunto al contesto Sentry",
    "sentry_check.breadcrumb_failed": "Aggiunta breadcrumb non riuscita: {message}",
    "Failed to add breadcrumb: {message}": "Aggiunta breadcrumb non riuscita: {message}",
    "sentry_check.user_context": "Contesto utente",
    "User Context": "Contesto utente",
    "sentry_check.user_set": "Contesto utente impostato in Sentry",
    "User context set in Sentry": "Contesto utente impostato in Sentry",
    "sentry_check.user_failed": "Impostazione contesto utente non riuscita: {message}",
    "Failed to set user context: {message}": "Impostazione contesto utente non riuscita: {message}",
    "sentry_check.custom_exception": "Eccezione personalizzata",
    "Custom Exception": "Eccezione personalizzata",
    "sentry_check.custom_sent": "Eccezione personalizzata con contesto inviata a Sentry",
    "Custom exception with context sent to Sentry": "Eccezione personalizzata con contesto inviata a Sentry",
    "sentry_check.custom_failed": "Acquisizione eccezione personalizzata non riuscita: {message}",
    "Failed to capture custom exception: {message}": "Acquisizione eccezione personalizzata non riuscita: {message}",
    "sentry_check.promise_rejection": "Rifiuto Promise",
    "Promise Rejection": "Rifiuto Promise",
    "sentry_check.promise_captured": "Rifiuto Promise acquisito e inviato a Sentry",
    "Promise rejection captured and sent to Sentry": "Rifiuto Promise acquisito e inviato a Sentry",
    "sentry_check.promise_failed": "Gestione rifiuto Promise non riuscita: {message}",
    "Failed to handle promise rejection: {message}": "Gestione rifiuto Promise non riuscita: {message}",
    "checkout_settings.orders": "Ordini",
    "checkout_settings.return_policy_days": "Giorni per il reso",
    "Return policy days": "Giorni per il reso",
    "checkout_settings.enter_return_policy_days": "Inserisci i giorni per il reso",
    "Enter return policy days": "Inserisci i giorni per il reso",
    "checkout_settings.saved": "Salvato correttamente",
    "checkout_settings.cart": "Carrello",
    "checkout_settings.hide_quantity_selection": "Nascondi selezione quantità (in genere il campo è visibile)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Nascondi selezione quantità (in genere il campo è visibile)",
    "checkout_settings.enable_coupon": "Abilita coupon",
    "Enable Coupon": "Abilita coupon",
    "upgrade_page.copy.a_practical_next_step": "Un prossimo passo concreto",
    "A practical next step": "Un prossimo passo concreto",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "Aggiungi le informazioni strutturate necessarie al tuo flusso di lavoro.",
    "Add the structured information your workflow needs.": "Aggiungi le informazioni strutturate necessarie al tuo flusso di lavoro.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Assegna ruoli e autorizzazioni a ogni membro del team.",
    "Assign roles and permissions to every teammate.": "Assegna ruoli e autorizzazioni a ogni membro del team.",
    "upgrade_page.copy.audit_log_export": "Esportazione registro di controllo",
    "Audit log export": "Esportazione registro di controllo",
    "upgrade_page.copy.best_next_step": "Prossimo passo consigliato",
    "Best next step": "Prossimo passo consigliato",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Importa record strutturati, modificali offline ed esportali quando serve una copia di lavoro completa.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Importa record strutturati, modificali offline ed esportali quando serve una copia di lavoro completa.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Vai oltre l’interfaccia standard",
    "Build beyond the standard interface": "Vai oltre l’interfaccia standard",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Raccogli i dettagli che rendono utile il catalogo.",
    "Capture the details that make your catalogue useful.": "Raccogli i dettagli che rendono utile il catalogo.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Scegli la flessibilità per creare esperienze rivolte ai clienti basate su Tradly.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Scegli la flessibilità per creare esperienze rivolte ai clienti basate su Tradly.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Raggruppa le inserzioni in bundle curati e consenti ai clienti di scegliere gli articoli idonei al checkout.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Raggruppa le inserzioni in bundle curati e consenti ai clienti di scegliere gli articoli idonei al checkout.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Configura le valute necessarie alla tua attività nei diversi mercati.",
    "Configure the currencies your business needs as you operate across regions.": "Configura le valute necessarie alla tua attività nei diversi mercati.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Collega il marketplace agli strumenti interni e all’automazione quando il lavoro manuale non è più scalabile.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Collega il marketplace agli strumenti interni e all’automazione quando il lavoro manuale non è più scalabile.",
    "upgrade_page.copy.connect_your_own_tools": "Collega i tuoi strumenti",
    "Connect your own tools": "Collega i tuoi strumenti",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Controlla chi può vedere e modificare cosa.",
    "Control who can see and change what.": "Controlla chi può vedere e modificare cosa.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Crea campi personalizzati con le informazioni che clienti e team devono vedere in ogni inserzione o account.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Crea campi personalizzati con le informazioni che clienti e team devono vedere in ogni inserzione o account.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Crea bundle fissi e combinabili.",
    "Create fixed and mix-and-match bundles.": "Crea bundle fissi e combinabili.",
    "upgrade_page.copy.custom_attributes": "Attributi personalizzati",
    "Custom attributes": "Attributi personalizzati",
    "upgrade_page.copy.custom_email_templates": "Modelli email personalizzati",
    "Custom email templates": "Modelli email personalizzati",
    "upgrade_page.copy.email_whitelabelling": "Personalizzazione brand email",
    "Email whitelabelling": "Personalizzazione brand email",
    "upgrade_page.copy.everything_in_growth": "Tutto ciò che include Growth",
    "Everything in Growth": "Tutto ciò che include Growth",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "Tutto ciò che include Growth, con i limiti più alti.",
    "Everything in Growth, with the highest limits.": "Tutto ciò che include Growth, con i limiti più alti.",
    "upgrade_page.copy.everything_in_starter": "Tutto ciò che include Starter",
    "Everything in Starter": "Tutto ciò che include Starter",
    "upgrade_page.copy.expand_your_workspace": "Espandi la tua area di lavoro",
    "Expand your workspace": "Espandi la tua area di lavoro",
    "upgrade_page.copy.feature_access": "Accesso alle funzionalità",
    "Feature access": "Accesso alle funzionalità",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Per un catalogo in crescita che richiede opzioni di prodotto più chiare.",
    "For a growing catalogue that needs clearer product choices.": "Per un catalogo in crescita che richiede opzioni di prodotto più chiare.",
    "upgrade_page.copy.for_established_businesses": "Per aziende consolidate",
    "For established businesses": "Per aziende consolidate",
    "upgrade_page.copy.for_growing_operations": "Per attività in crescita",
    "For growing operations": "Per attività in crescita",
    "upgrade_page.copy.for_growing_teams": "Per team in crescita",
    "For growing teams": "Per team in crescita",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Per team con volumi elevati che devono poter operare su scala.",
    "For high-volume teams that need room to operate at scale.": "Per team con volumi elevati che devono poter operare su scala.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Per team che gestiscono un catalogo più ampio e più flussi di lavoro.",
    "For teams managing a larger catalogue and more workflows.": "Per team che gestiscono un catalogo più ampio e più flussi di lavoro.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Per team pronte a lavorare su più record alla volta.",
    "For teams ready to work beyond one record at a time.": "Per team pronte a lavorare su più record alla volta.",
    "upgrade_page.copy.full_audit_history": "Cronologia di controllo completa",
    "Full audit history": "Cronologia di controllo completa",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "I piani Growth e Scale possono consultare l’intera cronologia di controllo ed esportarla per i processi di conformità.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "I piani Growth e Scale possono consultare l’intera cronologia di controllo ed esportarla per i processi di conformità.",
    "upgrade_page.copy.higher_usage_limits": "Limiti di utilizzo maggiori",
    "Higher usage limits": "Limiti di utilizzo maggiori",
    "upgrade_page.copy.highest_usage_limits": "Limiti di utilizzo massimi",
    "Highest usage limits": "Limiti di utilizzo massimi",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Importa ed esporta record senza operazioni manuali ripetitive.",
    "Import and export records without repetitive manual work.": "Importa ed esporta record senza operazioni manuali ripetitive.",
    "upgrade_page.copy.import_and_export_tools": "Strumenti di importazione ed esportazione",
    "Import and export tools": "Strumenti di importazione ed esportazione",
    "upgrade_page.copy.improve_important_customer_messages": "Migliora i messaggi importanti per i clienti",
    "Improve important customer messages": "Migliora i messaggi importanti per i clienti",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Conserva più a lungo la cronologia di conformità",
    "Keep a longer compliance history": "Conserva più a lungo la cronologia di conformità",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Mantieni visibilità completa sulla conformità per operazioni ad alto volume.",
    "Keep complete compliance visibility for high-volume operations.": "Mantieni visibilità completa sulla conformità per operazioni ad alto volume.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Organizza più dati e flussi di lavoro man mano che cresce il catalogo.",
    "Keep more data and workflows organised as the catalogue grows.": "Organizza più dati e flussi di lavoro man mano che cresce il catalogo.",
    "upgrade_page.copy.keep_your_workspace_secure": "Proteggi la tua area di lavoro",
    "Keep your workspace secure": "Proteggi la tua area di lavoro",
    "upgrade_page.copy.large": "Grande",
    "Large": "Grande",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Consenti ai clienti di scegliere le opzioni da un’unica inserzione.",
    "Let customers choose options from one listing.": "Consenti ai clienti di scegliere le opzioni da un’unica inserzione.",
    "upgrade_page.copy.listing_variants": "Varianti inserzione",
    "Listing variants": "Varianti inserzione",
    "upgrade_page.copy.make_every_customer_email_yours": "Personalizza ogni email per i clienti",
    "Make every customer email yours": "Personalizza ogni email per i clienti",
    "upgrade_page.copy.make_one_listing_work_harder": "Sfrutta al meglio un’inserzione",
    "Make one listing work harder": "Sfrutta al meglio un’inserzione",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Adatta le email di sistema al tuo flusso di lavoro e tono.",
    "Make system emails match your workflow and tone.": "Adatta le email di sistema al tuo flusso di lavoro e tono.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Rendi il progetto disponibile in più lingue.",
    "Make your project available in more languages.": "Rendi il progetto disponibile in più lingue.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Gestisci le lingue rivolte ai clienti mentre raggiungi nuove regioni e audience.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Gestisci le lingue rivolte ai clienti mentre raggiungi nuove regioni e audience.",
    "upgrade_page.copy.medium": "Medio",
    "upgrade_page.copy.more_capacity": "Maggiore capacità",
    "More capacity": "Maggiore capacità",
    "upgrade_page.copy.more_storage": "Più spazio di archiviazione",
    "More storage": "Più spazio di archiviazione",
    "upgrade_page.copy.more_team_capacity": "Più capacità per il team",
    "More team capacity": "Più capacità per il team",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Lavora più rapidamente con il tuo catalogo",
    "Move faster with your catalogue": "Lavora più rapidamente con il tuo catalogo",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Gestisci più rapidamente cataloghi e team più ampi nelle attività quotidiane",
    "Move larger catalogues and teams through routine work faster.": "Gestisci più rapidamente cataloghi e team più ampi nelle attività quotidiane",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "Offri taglie, colori e altre opzioni senza duplicare gli annunci o suddividere la gestione delle scorte",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "Offri taglie, colori e altre opzioni senza duplicare gli annunci o suddividere la gestione delle scorte",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Usa i limiti massimi disponibili",
    "Operate with the highest available limits.": "Usa i limiti massimi disponibili",
    "upgrade_page.copy.per_module_permissions": "Autorizzazioni per modulo",
    "Per-module permissions": "Autorizzazioni per modulo",
    "upgrade_page.copy.priority_support": "Assistenza prioritaria",
    "Priority support": "Assistenza prioritaria",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Consulta più degli ultimi cinque eventi di audit",
    "Review more than the latest five audit events.": "Consulta più degli ultimi cinque eventi di audit",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Consulta l’intera cronologia di audit mentre crescono il team e le attività",
    "Review the full audit history as your team and activity grow.": "Consulta l’intera cronologia di audit mentre crescono il team e le attività",
    "upgrade_page.copy.role_based_access_control": "Controllo degli accessi basato sui ruoli",
    "Role-based access control": "Controllo degli accessi basato sui ruoli",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "I ruoli consentono di assegnare a ogni membro del team solo gli accessi necessari. Disponibile con Growth e piani superiori.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "I ruoli consentono di assegnare a ogni membro del team solo gli accessi necessari. Disponibile con Growth e piani superiori.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Crea un flusso di comunicazione con i clienti più efficace e curato",
    "Run a stronger, more polished customer communication workflow.": "Crea un flusso di comunicazione con i clienti più efficace e curato",
    "upgrade_page.copy.sell_across_markets": "Vendi in più mercati",
    "Sell across markets": "Vendi in più mercati",
    "upgrade_page.copy.sell_products_together": "Vendi i prodotti insieme",
    "Sell products together": "Vendi i prodotti insieme",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Invia email con un’identità di marca riconoscibile dai clienti",
    "Send email from a brand your customers recognise.": "Invia email con un’identità di marca riconoscibile dai clienti",
    "upgrade_page.copy.shape_the_information_you_collect": "Definisci le informazioni che raccogli",
    "Shape the information you collect": "Definisci le informazioni che raccogli",
    "upgrade_page.copy.small": "Piccolo",
    "Small": "Piccolo",
    "upgrade_page.copy.speak_to_more_customers": "Raggiungi più clienti",
    "Speak to more customers": "Raggiungi più clienti",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Standardizza dati più ricchi nelle operazioni ad alto volume",
    "Standardise richer data across a high-volume operation.": "Standardizza dati più ricchi nelle operazioni ad alto volume",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Offri un’esperienza cliente più coerente",
    "Start presenting a more consistent customer experience.": "Offri un’esperienza cliente più coerente",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Offri un’esperienza cliente completa e pronta per le aziende",
    "Support a complete enterprise-ready customer experience.": "Offri un’esperienza cliente completa e pronta per le aziende",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Supporta i clienti che acquistano in valute diverse",
    "Support customers who shop in different currencies.": "Supporta i clienti che acquistano in valute diverse",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Supporta flussi operativi ad alto volume su larga scala",
    "Support high-volume operational workflows at scale.": "Supporta flussi operativi ad alto volume su larga scala",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Supporta flussi di lavoro e team più ampi",
    "Support larger workflows and teams.": "Supporta flussi di lavoro e team più ampi",
    "upgrade_page.copy.t_shirt": "Maglietta",
    "T-shirt": "Maglietta",
    "upgrade_page.copy.t_shirt_large": "Maglietta — grande",
    "T-shirt — Large": "Maglietta — grande",
    "upgrade_page.copy.t_shirt_medium": "Maglietta — media",
    "T-shirt — Medium": "Maglietta — media",
    "upgrade_page.copy.t_shirt_small": "Maglietta — piccola",
    "T-shirt — Small": "Maglietta — piccola",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Personalizza i messaggi ricevuti dai clienti nei momenti chiave senza modificare la configurazione del marketplace",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Personalizza i messaggi ricevuti dai clienti nei momenti chiave senza modificare la configurazione del marketplace",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Sblocca altri strumenti man mano che cresce il tuo spazio di lavoro",
    "Unlock more tools as your workspace begins to grow.": "Sblocca altri strumenti man mano che cresce il tuo spazio di lavoro",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Sblocca questa funzionalità quando sei pronto",
    "Unlock this feature when you are ready.": "Sblocca questa funzionalità quando sei pronto",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Usa API headless per un’esperienza completamente personalizzata",
    "Use headless APIs for a fully custom experience.": "Usa API headless per un’esperienza completamente personalizzata",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "Usa l’API quando il tuo flusso di lavoro richiede di più",
    "Use the API when your workflow needs to go further.": "Usa l’API quando il tuo flusso di lavoro richiede di più",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Usa la tua identità del mittente e il tuo stile visivo per mantenere coerenti le comunicazioni del marketplace",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Usa la tua identità del mittente e il tuo stile visivo per mantenere coerenti le comunicazioni del marketplace",
    "upgrade_page.copy.with_variants": "Con varianti",
    "With variants": "Con varianti",
    "upgrade_page.copy.without_variants": "Senza varianti",
    "Without variants": "Senza varianti",
    "upgrade_page.copy.workflow_tools": "Strumenti per i flussi di lavoro",
    "Workflow tools": "Strumenti per i flussi di lavoro",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Il lavoro attuale resta invariato mentre confronti i piani che includono questa funzionalità",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Il lavoro attuale resta invariato mentre confronti i piani che includono questa funzionalità",
    "upgrade_page.copy.a_paid_plan": "un piano a pagamento",
    "a paid plan": "un piano a pagamento",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Tutto ciò che serve a un negozio in crescita: rimuovi il branding, aggiungi il tuo dominio e sblocca altri strumenti.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Tutto ciò che serve a un negozio in crescita: rimuovi il branding, aggiungi il tuo dominio e sblocca altri strumenti.",
    "upgrade_page.copy.everything_unlocked": "Tutto sbloccato",
    "Everything unlocked": "Tutto sbloccato",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Suite AI completa, marketing avanzato e tutto sbloccato per i negozi orientati alla crescita",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Un messaggio dal team Tradly",
    "A note from the Tradly team": "Un messaggio dal team Tradly",
    "upgrade_page.copy.help_us_keep_tradly_going": "Aiutaci a far crescere Tradly",
    "Help us keep Tradly going": "Aiutaci a far crescere Tradly",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "I nostri costi sono aumentati e, per continuare a sviluppare e supportare Tradly, abbiamo bisogno del sostegno della community. Scegli un piano per continuare a usare il tuo spazio di lavoro: il negozio e i dati sono al sicuro. Grazie per far parte di Tradly.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "I nostri costi sono aumentati e, per continuare a sviluppare e supportare Tradly, abbiamo bisogno del sostegno della community. Scegli un piano per continuare a usare il tuo spazio di lavoro: il negozio e i dati sono al sicuro. Grazie per far parte di Tradly.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "Dal 2019 abbiamo offerto un piano gratuito Tradly con molte funzionalità, per permettere a chiunque di iniziare. Siamo stati felici di farlo, ma non possiamo più sostenerlo da soli. Contiamo di ripristinare un piano gratuito quando l’attività raggiungerà una certa fase, così da restituire qualcosa alla community che ci ha aiutato ad arrivare fin qui.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "Dal 2019 abbiamo offerto un piano gratuito Tradly con molte funzionalità, per permettere a chiunque di iniziare. Siamo stati felici di farlo, ma non possiamo più sostenerlo da soli. Contiamo di ripristinare un piano gratuito quando l’attività raggiungerà una certa fase, così da restituire qualcosa alla community che ci ha aiutato ad arrivare fin qui.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Scegli il piano più adatto a te oggi. Puoi cambiarlo in qualsiasi momento.",
    "Choose the plan that fits you today. You can change it any time.": "Scegli il piano più adatto a te oggi. Puoi cambiarlo in qualsiasi momento.",
    "upgrade_page.back_to_workspace": "Torna allo spazio di lavoro",
    "Back to workspace": "Torna allo spazio di lavoro",
    "upgrade_page.grow_when_ready": "Cresci quando sarà il momento",
    "Grow when the work calls for it": "Cresci quando sarà il momento",
    "upgrade_page.reassurance": "I dati, gli annunci e la configurazione esistenti resteranno invariati.",
    "Your existing data, listings, and setup stay exactly as they are.": "I dati, gli annunci e la configurazione esistenti resteranno invariati.",
    "upgrade_page.choose_plan": "Scegli un piano",
    "Choose a plan": "Scegli un piano",
    "upgrade_page.feature_availability": "Disponibilità delle funzionalità",
    "Feature availability": "Disponibilità delle funzionalità",
    "upgrade_page.available_from": "Disponibile da",
    "Available from": "Disponibile da",
    "upgrade_page.and_above": "e superiori",
    "and above": "e superiori",
    "upgrade_page.choose_when_useful": "Scegli un piano solo quando questa funzionalità è utile al tuo team.",
    "Choose a plan only when this capability is useful to your team.": "Scegli un piano solo quando questa funzionalità è utile al tuo team.",
    "upgrade_page.practical_difference": "La differenza pratica",
    "The practical difference": "La differenza pratica",
    "upgrade_page.keep_work_simple": "Semplifica il lavoro man mano che cresci.",
    "Keep the work simpler as you grow.": "Semplifica il lavoro man mano che cresci.",
    "upgrade_page.plan_path": "Percorso dei piani",
    "Plan path": "Percorso dei piani",
    "upgrade_page.plan_path_title": "Inizia con il piano che supporta il prossimo passo.",
    "Start with the plan that supports this next step.": "Inizia con il piano che supporta il prossimo passo.",
    "upgrade_page.best_next_step": "Prossimo passo consigliato",
    "upgrade_page.includes_capability": "Include questa funzionalità",
    "Includes this capability": "Include questa funzionalità",
    "upgrade_page.not_included": "Non incluso",
    "Not included": "Non incluso",
    "upgrade_page.included": "✓ Incluso",
    "✓ Included": "✓ Incluso",
    "upgrade_page.ready_when_you_are": "Pronto quando vuoi.",
    "Ready when you are.": "Pronto quando vuoi.",
    "upgrade_page.billing_details": "Consulta tutti i dettagli del piano e continua in sicurezza con la fatturazione Tradly.",
    "Review the complete plan details and continue securely with Tradly billing.": "Consulta tutti i dettagli del piano e continua in sicurezza con la fatturazione Tradly.",
    "upgrade_page.panel.close": "Chiudi pannello piani",
    "Close upgrade panel": "Chiudi pannello piani",
    "upgrade_page.panel.show_less": "Mostra meno",
    "Show less": "Mostra meno",
    "upgrade_page.panel.see_more": "Vedi altro",
    "See more": "Vedi altro",
    "upgrade_page.panel.choose_to_continue": "Scegli un piano per continuare",
    "Choose a plan to continue": "Scegli un piano per continuare",
    "upgrade_page.panel.more_ways_to_grow": "Altri modi per crescere",
    "More ways to grow": "Altri modi per crescere",
    "upgrade_page.panel.plan_includes_feature": "Ogni piano include questa funzionalità e capacità aggiuntiva per la fase successiva.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Ogni piano include questa funzionalità e capacità aggiuntiva per la fase successiva.",
    "upgrade_page.panel.add_credits": "Aggiungi crediti o prodotti",
    "Add credits or products": "Aggiungi crediti o prodotti",
    "upgrade_page.panel.ala_carte_description": "Lo spazio di lavoro viene fatturato à la carte. Ricarica i crediti o aggiungi i prodotti necessari.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Lo spazio di lavoro viene fatturato à la carte. Ricarica i crediti o aggiungi i prodotti necessari.",
    "upgrade_page.panel.open_ala_carte": "Apri à la carte",
    "Open à la carte": "Apri à la carte",
    "upgrade_page.panel.recommended": "Consigliato",
    "Recommended": "Consigliato",
    "upgrade_page.panel.per_month": "/ mese",
    "upgrade_page.panel.please_wait": "Attendi…",
    "upgrade_page.panel.unlock_plan": "Sblocca il piano {plan}",
    "Unlock {plan}": "Sblocca il piano {plan}",
    "upgrade_page.panel.choose_plan": "Scegli il piano {plan}",
    "Choose {plan}": "Scegli il piano {plan}",
    "upgrade_page.panel.compare_plans": "Confronta tutti i dettagli dei piani",
    "Compare all plan details": "Confronta tutti i dettagli dei piani",
    "workspace.usage.page_title": "Panoramica utilizzo",
    "Usage overview": "Panoramica utilizzo",
    "workspace.usage.page_description": "Visualizza l’utilizzo attuale e i limiti applicati a questo spazio di lavoro.",
    "workspace.usage.not_available": "Non disponibile",
    "workspace.usage.limit_not_configured": "Limite non configurato",
    "Limit not configured": "Limite non configurato",
    "workspace.usage.limit_value": "Limite: {limit}",
    "Limit: {limit}": "Limite: {limit}",
    "listings.photos": "Foto",
    "Photos": "Foto",
    "listings.listen_episode": "Ascolta questo episodio",
    "Listen to this episode": "Ascolta questo episodio",
    "listings.other_listings": "Altri annunci",
    "Other listings": "Altri annunci",
    "listings.delete": "Elimina",
    "listings.fulfilled_by_platform": "Gestito dalla piattaforma",
    "Fulfilled by Platform": "Gestito dalla piattaforma",
    "listings.no_attributes_set": "Nessun attributo impostato",
    "No attributes set": "Nessun attributo impostato",
    "listings.campaign_raised": "Raccolti {amount}",
    "{amount} raised": "Raccolti {amount}",
    "listings.campaign_progress": "{percent}% di {goal}",
    "{percent}% of {goal}": "{percent}% di {goal}",
    "listings.seat": "posto",
    "seat": "posto",
    "listings.seats": "posti",
    "seats": "posti",
    "listings.per_slot": "per slot",
    "per slot": "per slot",
    "listings.total_value": "Totale: {total}",
    "Total: {total}": "Totale: {total}",
    "listings.orders": "Ordini",
    "listings.total_orders": "Ordini totali",
    "Total orders": "Ordini totali",
    "listings.revenue": "Ricavi",
    "listings.average_order": "Ordine medio",
    "listings.customers": "Clienti",
    "Customers": "Clienti",
    "listings.load_more": "Carica altro",
    "Load more": "Carica altro",
    "listings.filter": "Filtra",
    "listings.sort": "Ordina",
    "Sort": "Ordina",
    "listings.value_price": "Prezzo valore",
    "Value Price": "Prezzo valore",
    "listings.detail_label_title": "Titolo",
    "listings.detail_label_slug": "Slug",
    "listings.detail_label_description": "Descrizione",
    "listings.detail_label_categories": "Categorie",
    "listings.detail_label_list_price": "Prezzo di listino",
    "List Price": "Prezzo di listino",
    "listings.detail_label_offer": "Offerta",
    "Offer": "Offerta",
    "listings.detail_label_currency": "Valuta",
    "listings.detail_label_listing_status": "Stato annuncio",
    "Listing Status": "Stato annuncio",
    "listings.detail_label_active": "Attivo",
    "listings.detail_label_sold": "Venduto",
    "listings.detail_label_meta_title": "Titolo meta",
    "listings.detail_label_meta_description": "Descrizione meta",
    "listings.detail_label_goal": "Obiettivo",
    "Goal": "Obiettivo",
    "listings.detail_label_donors": "Donatori",
    "Donors": "Donatori",
    "listings.detail_label_start_date": "Data di inizio",
    "listings.detail_label_end_date": "Data di fine",
    "listings.detail_label_stock": "Scorte",
    "listings.detail_label_max_qty_order": "Quantità max per ordine",
    "Max qty / order": "Quantità max per ordine",
    "listings.detail_label_weight": "Peso",
    "listings.detail_label_dimensions": "Dimensioni",
    "Dimensions": "Dimensioni",
    "listings.detail_label_listing_period": "Periodo annuncio",
    "Listing period": "Periodo annuncio",
    "listings.detail_label_max_tickets_booking": "Biglietti max per prenotazione",
    "Max tickets / booking": "Biglietti max per prenotazione",
    "listings.detail_label_rating": "Valutazione",
    "listings.detail_label_reviews": "Recensioni",
    "listings.detail_label_likes": "Mi piace",
    "Likes": "Mi piace",
    "listings.detail_label_dislikes": "Non mi piace",
    "Dislikes": "Non mi piace",
    "listings.detail_label_barcode": "Codice a barre",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "SKU",
    "listings.detail_section_basic_info": "Informazioni di base",
    "Basic Info": "Informazioni di base",
    "listings.detail_section_pricing": "Prezzi",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Seleziona un tipo di annuncio qui sopra per continuare.",
    "Select a listing type above to continue.": "Seleziona un tipo di annuncio qui sopra per continuare.",
    "listing_form.attributes": "Attributi",
    "category.status_active_help": "Stato (Inattivo / Attivo)",
    "promotions.medium": "Medio",
    "users.listings": "Annunci",
    "users.accounts": "Account",
    "users.click_count_one": "{count} clic",
    "{count} click": "{count} clic",
    "users.click_count": "{count} clic",
    "{count} clicks": "{count} clic",
    "integrations.generic.provider_help": "Configura il provider selezionato usando i campi qui sotto.",
    "Configure the selected provider using the fields below.": "Configura il provider selezionato usando i campi qui sotto.",
    "attributes.editor_prefill_data_from": "Precompila i dati da",
    "Prefill Data From": "Precompila i dati da",
    "attributes.editor_select_attribute": "Seleziona attributo",
    "Select Attribute": "Seleziona attributo",
    "attributes.editor_select_attribute_group": "Seleziona gruppo di attributi",
    "Select Attribute Group": "Seleziona gruppo di attributi",
    "attributes.editor_attribute": "Attributo",
    "Attribute": "Attributo",
    "attributes.editor_attributes": "Attributi",
    "attributes.editor_cart_attributes": "Attributi del carrello",
    "Cart Attributes": "Attributi del carrello",
    "listings.add_photo": "Aggiungi foto",
    "accounts.analytics": "Analisi",
    "listings.image_optional": "Immagini annuncio (facoltative)",
    "Listing Images (Optional)": "Immagini annuncio (facoltative)",
    "listings.currency": "Valuta",
    "listing_variants.number_sign": "N.",
    "#": "N.",
    "attributes.active": "Attivo",
    "listing_form.digital_deleted_item_cannot_edit": "Questo elemento è contrassegnato per l’eliminazione e non può essere modificato",
    "This item is marked for deletion and cannot be edited": "Questo elemento è contrassegnato per l’eliminazione e non può essere modificato",
    "listing_form.digital_max_files": "Sono consentiti al massimo 10 file",
    "Maximum 10 files allowed": "Sono consentiti al massimo 10 file",
    "listing_form.digital_title_required": "Inserisci un titolo",
    "listing_form.digital_version_required": "Inserisci il nome della versione",
    "Please enter a version name": "Inserisci il nome della versione",
    "listing_form.digital_contents": "Contenuti digitali",
    "Digital Contents": "Contenuti digitali",
    "listing_form.digital_add_content": "＋ Aggiungi contenuto",
    "+ Add Content": "＋ Aggiungi contenuto",
    "listing_form.no_description": "Nessuna descrizione",
    "No description": "Nessuna descrizione",
    "listing_form.digital_file_count": "{count} file",
    "{count} file(s)": "{count} file",
    "listing_form.digital_empty": "Nessun contenuto digitale",
    "No digital contents yet": "Nessun contenuto digitale",
    "listing_form.digital_empty_help": "Fai clic su “{action}” per creare il primo contenuto digitale",
    "Click \"{action}\" to create your first digital content": "Fai clic su “{action}” per creare il primo contenuto digitale",
    "listing_form.digital_marked_for_deletion": "Contrassegnati per l’eliminazione ({count})",
    "Marked for Deletion ({count})": "Contrassegnati per l’eliminazione ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Verrà eliminato all’invio",
    "✓ Will be deleted on submit": "✓ Verrà eliminato all’invio",
    "listing_form.digital_edit_title": "Modifica contenuto digitale",
    "Edit Digital Content": "Modifica contenuto digitale",
    "listing_form.digital_add_title": "Aggiungi contenuto digitale",
    "Add New Digital Content": "Aggiungi contenuto digitale",
    "listing_form.digital_form_description": "Compila i dettagli qui sotto per {action} il contenuto digitale",
    "Fill in the details below to {action} digital content": "Compila i dettagli qui sotto per {action} il contenuto digitale",
    "listing_form.digital_title_placeholder": "Inserisci il titolo del contenuto digitale",
    "Enter digital content title": "Inserisci il titolo del contenuto digitale",
    "listing_form.description_optional_placeholder": "Inserisci una descrizione (facoltativa)",
    "Enter description (optional)": "Inserisci una descrizione (facoltativa)",
    "listing_form.version": "Versione",
    "Version": "Versione",
    "listing_form.files": "File",
    "Files": "File",
    "listing_form.max_files": "(Max {count})",
    "(Max {count})": "(Max {count})",
    "listing_form.click_to_upload_files": "Fai clic per caricare i file",
    "Click to upload files": "Fai clic per caricare i file",
    "listing_form.files_uploaded_count": "{count}/10 file caricati",
    "{count}/10 files uploaded": "{count}/10 file caricati",
    "listing_form.unknown_size": "Dimensione sconosciuta",
    "Unknown size": "Dimensione sconosciuta",
    "listing_form.no_accounts_available": "Nessun account disponibile",
    "No accounts available": "Nessun account disponibile",
    "listing_form.select_account": "Seleziona un account",
    "Select an account": "Seleziona un account",
    "listing_form.searching": "Ricerca…",
    "Searching...": "Ricerca…",
    "listing_form.location_enter_address": "Inserisci un indirizzo da cercare",
    "Please enter an address to search": "Inserisci un indirizzo da cercare",
    "listing_form.location_no_addresses_search": "Nessun indirizzo trovato. Prova una ricerca diversa.",
    "No addresses found. Please try a different search.": "Nessun indirizzo trovato. Prova una ricerca diversa.",
    "listing_form.location_search_failed": "Ricerca degli indirizzi non riuscita. Riprova.",
    "Failed to search addresses. Please try again.": "Ricerca degli indirizzi non riuscita. Riprova.",
    "listing_form.location_place_details_failed": "Impossibile ottenere i dettagli del luogo. Riprova.",
    "Failed to get place details. Please try again.": "Impossibile ottenere i dettagli del luogo. Riprova.",
    "listing_form.location_access_denied": "Accesso alla posizione negato. Abilita i permessi di localizzazione.",
    "Location access denied. Please enable location permissions.": "Accesso alla posizione negato. Abilita i permessi di localizzazione.",
    "listing_form.location_unavailable": "Impossibile determinare la posizione. Riprova.",
    "Unable to determine location. Please try again.": "Impossibile determinare la posizione. Riprova.",
    "listing_form.location_timeout": "Richiesta di posizione scaduta. Riprova.",
    "Location request timed out. Please try again.": "Richiesta di posizione scaduta. Riprova.",
    "listing_form.location_current_failed": "Impossibile ottenere la posizione attuale. Riprova.",
    "Failed to get current location. Please try again.": "Impossibile ottenere la posizione attuale. Riprova.",
    "listing_form.location": "Posizione",
    "listing_form.location_search_placeholder": "Cerca una posizione…",
    "Search for a location...": "Cerca una posizione…",
    "listing_form.location_searching": "Ricerca indirizzi…",
    "Searching addresses...": "Ricerca indirizzi…",
    "listing_form.location_no_addresses": "Nessun indirizzo trovato",
    "No addresses found": "Nessun indirizzo trovato",
    "listing_form.location_try_different_search": "Prova un termine di ricerca diverso",
    "Try a different search term": "Prova un termine di ricerca diverso",
    "listing_form.location_getting": "Recupero della posizione…",
    "Getting location...": "Recupero della posizione…",
    "listing_form.location_use_current": "Usa la posizione attuale",
    "Use Current Location": "Usa la posizione attuale",
    "listing_form.location_selected": "Posizione selezionata",
    "Selected Location": "Posizione selezionata",
    "listing_form.latitude": "Latitudine:",
    "Latitude:": "Latitudine:",
    "listing_form.longitude": "Longitudine:",
    "Longitude:": "Longitudine:",
    "listing_form.location_helper": "Cerca un indirizzo o usa la posizione attuale",
    "Search for an address or use your current location": "Cerca un indirizzo o usa la posizione attuale",
    "common.change": "Modifica",
    "listing_form.variant_id_tooltip": "ID tipo: {typeId}, ID valore: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "ID tipo: {typeId}, ID valore: {valueId}",
    "listing_form.variants_marked_for_deletion": "Contrassegnate per l’eliminazione ({count} elementi):",
    "Marked for Deletion ({count} items):": "Contrassegnate per l’eliminazione ({count} elementi):",
    "listing_form.add_new_variant": "Aggiungi variante",
    "Add New Variant": "Aggiungi variante",
    "listing_form.add_variant_description": "Compila i dettagli qui sotto per creare una nuova variante",
    "Fill in the details below to create a new variant": "Compila i dettagli qui sotto per creare una nuova variante",
    "listing_form.google_search_preview": "Anteprima ricerca Google",
    "Google Search Preview": "Anteprima ricerca Google",
    "listing_form.meta_title_preview": "Anteprima del titolo meta",
    "Your Meta Title Here": "Anteprima del titolo meta",
    "listing_form.meta_description_preview": "La meta descrizione apparirà qui. Aiuta gli utenti a capire il contenuto della pagina nei risultati di ricerca.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "La meta descrizione apparirà qui. Aiuta gli utenti a capire il contenuto della pagina nei risultati di ricerca.",
    "listing_form.variant_name_placeholder": "Inserisci il nome",
    "listing_form.list_price_placeholder": "Inserisci il prezzo di listino",
    "listing_form.offer_percent_placeholder": "Inserisci la percentuale di offerta",
    "Enter Offer Percent": "Inserisci la percentuale di offerta",
    "attributes.select_all": "Seleziona tutto",
    "attributes.unselect_all": "Deseleziona tutto",
    "Unselect All": "Deseleziona tutto",
    "attributes.select_category": "Seleziona categoria",
    "attributes.create_category_configuration_first": "Crea prima le categorie nella configurazione {type}",
    "Create categories in {type} configuration first": "Crea prima le categorie nella configurazione {type}",
    "attributes.select_single_attribute_values": "Seleziona i valori dell’attributo singolo",
    "attributes.select_multiple_attribute_values": "Seleziona i valori dell’attributo multiplo",
    "attributes.enter_value": "Inserisci un valore",
    "attributes.enter_multiple_tags": "Inserisci più tag",
    "Enter Multiple Tags": "Inserisci più tag",
    "attributes.upload_file": "Carica file",
    "collections.add_condition": "＋ Aggiungi condizione",
    "collections.add_photo": "Aggiungi foto",
    "collections.status": "Stato (Inattivo / Attivo)",
    "collections.start_date_placeholder": "Seleziona la data di inizio",
    "Select start date": "Seleziona la data di inizio",
    "collections.end_date_placeholder": "Seleziona la data di fine",
    "Select end date": "Seleziona la data di fine",
    "navigation.editor": "Editor",
    "Editor": "Editor",
    "navigation.web_analytics": "Analisi web",
    "Web Analytics": "Analisi web",
    "navigation.ai_studio": "Studio AI",
    "AI Studio": "Studio AI",
    "navigation.docs": "Documentazione",
    "navigation.logout": "Esci",
    "Logout": "Esci",
    "navigation.tenant_name_placeholder": "(Nome tenant)",
    "(Tenant name)": "(Nome tenant)",
    "navigation.username_placeholder": "(Nome utente)",
    "(Username)": "(Nome utente)",
    "navigation.invite_description": "Invia link di invito ai membri del team",
    "Send invitation links to team members": "Invia link di invito ai membri del team",
    "navigation.invite": "Invita",
    "Invite": "Invita",
    "navigation.test_mode": "Modalità test",
    "Test Mode": "Modalità test",
    "navigation.upgrade": "Passa a un piano superiore",
    "navigation.open_account_menu": "Apri il menu account",
    "Open account menu": "Apri il menu account",
    "navigation.invite_name_required": "Inserisci il nome",
    "Please fill in the name": "Inserisci il nome",
    "navigation.invite_email_required": "Inserisci l’email",
    "Please fill in the email": "Inserisci l’email",
    "navigation.open_url_failed": "Impossibile aprire questo URL: {url}",
    "Don't know how to open this URL: {url}": "Impossibile aprire questo URL: {url}",
    "navigation.no_code_editor": "Editor no-code",
    "No-code editor": "Editor no-code",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Automazione marketing",
    "Marketing automation": "Automazione marketing",
    "navigation.analytics_recommendation": "Analisi e consigli",
    "Analytics & Recommendation": "Analisi e consigli",
    "navigation.ai_studio_iryxo": "Studio AI (Iryxo)",
    "AI Studio (Iryxo)": "Studio AI (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Progetto attuale",
    "Current project": "Progetto attuale",
    "navigation.current_user": "Utente attuale",
    "Current user": "Utente attuale",
    "navigation.switch_to_light_mode": "Passa alla modalità chiara",
    "Switch to light mode": "Passa alla modalità chiara",
    "navigation.switch_to_dark_mode": "Passa alla modalità scura",
    "Switch to dark mode": "Passa alla modalità scura",
    "navigation.download_android_app": "Scarica l’app Android",
    "Download Android app": "Scarica l’app Android",
    "navigation.download_ios_app": "Scarica l’app iOS",
    "Download iOS app": "Scarica l’app iOS",
    "navigation.subscribe_youtube": "Iscriviti su YouTube",
    "Subscribe on YouTube": "Iscriviti su YouTube",
    "navigation.open_app_switcher": "Apri selettore app",
    "Open app switcher": "Apri selettore app",
    "navigation.open_android_app": "Apri l’app Android",
    "Open Android app": "Apri l’app Android",
    "navigation.open_ios_app": "Apri l’app iOS",
    "Open iOS app": "Apri l’app iOS",
    "navigation.open_ai_support": "Apri l’assistenza Tradly su ChatGPT",
    "Open Tradly ChatGPT support": "Apri l’assistenza Tradly su ChatGPT",
    "navigation.open_youtube_channel": "Apri il canale YouTube Tradly",
    "Open Tradly YouTube channel": "Apri il canale YouTube Tradly",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "ID annuncio (facoltativo — aggiorna esistente)",
    "Listing ID (optional — update existing)": "ID annuncio (facoltativo — aggiorna esistente)",
    "listings.smart_upload.category_id": "ID categoria",
    "listings.smart_upload.list_price": "Prezzo di listino",
    "listings.smart_upload.stock": "Scorte",
    "listings.smart_upload.sku": "SKU",
    "listings.smart_upload.barcode": "Codice a barre",
    "listings.smart_upload.account_id": "ID account",
    "listings.smart_upload.slug": "Slug",
    "listings.smart_upload.text": "Testo",
    "listings.smart_upload.long_text": "Testo lungo",
    "listings.smart_upload.number": "Numero",
    "listings.smart_upload.single_select": "Selezione singola",
    "listings.smart_upload.multi_select": "Selezione multipla",
    "listings.smart_upload.attribute_name_required": "Inserisci un nome per l’attributo “{header}”.",
    "listings.smart_upload.attribute_create_failed": "Tradly non ha restituito il nuovo attributo “{name}”.",
    "Tradly did not return the new “{name}” attribute.": "Tradly non ha restituito il nuovo attributo “{name}”.",
    "listings.smart_upload.attribute_option_create_failed": "Impossibile creare l’opzione “{value}” per {name}.",
    "Could not create the “{value}” option for {name}.": "Impossibile creare l’opzione “{value}” per {name}.",
    "listings.smart_upload.attribute_no_longer_available": "L’attributo associato a “{header}” non è più disponibile.",
    "listings.smart_upload.csv_needs_header_and_listing": "Il CSV deve contenere una riga di intestazione e almeno un annuncio.",
    "The CSV must contain a header row and at least one listing.": "Il CSV deve contenere una riga di intestazione e almeno un annuncio.",
    "listings.smart_upload.unique_headers_required": "Ogni colonna dell’annuncio deve avere un’intestazione univoca e non vuota.",
    "Every listing column needs a unique, non-empty header.": "Ogni colonna dell’annuncio deve avere un’intestazione univoca e non vuota.",
    "listings.smart_upload.csv_read_failed": "Impossibile leggere questo CSV.",
    "listings.smart_upload.map_required_fields": "Mappa questi campi obbligatori prima di continuare: {fields}",
    "Map these required columns before continuing: {fields}": "Mappa questi campi obbligatori prima di continuare: {fields}",
    "listings.smart_upload.row_missing_required_value": "La riga {row} non contiene un valore obbligatorio.",
    "Row {row} is missing a required value.": "La riga {row} non contiene un valore obbligatorio.",
    "listings.smart_upload.invalid_category_id_row": "La riga {row} richiede un ID categoria numerico valido oppure scegli “Mappa manualmente l’ID categoria”.",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "La riga {row} richiede un ID categoria numerico valido oppure scegli “Mappa manualmente l’ID categoria”.",
    "listings.smart_upload.invalid_listing_id_row": "La riga {row} richiede un ID annuncio numerico valido oppure lascia vuoto l’ID per crearne uno nuovo.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "La riga {row} richiede un ID annuncio numerico valido oppure lascia vuoto l’ID per crearne uno nuovo.",
    "listings.smart_upload.progress.checking_duplicates": "Verifica degli annunci esistenti",
    "Checking for existing listings": "Verifica degli annunci esistenti",
    "listings.smart_upload.duplicate_same_value_row": "Lo stesso valore {field} compare alla riga {row} di questo file.",
    "Same {field} appears in row {row} of this file.": "Lo stesso valore {field} compare alla riga {row} di questo file.",
    "listings.smart_upload.duplicate_same_value_multiple": "Lo stesso valore {field} compare più volte in questo file.",
    "Same {field} appears more than once in this file.": "Lo stesso valore {field} compare più volte in questo file.",
    "listings.smart_upload.duplicate_existing_listing": "Corrisponde all’annuncio esistente n. {id} tramite {field}.",
    "Matches existing listing #{id} by {field}.": "Corrisponde all’annuncio esistente n. {id} tramite {field}.",
    "listings.smart_upload.explicit_listing_update": "L’annuncio con ID esplicito #{id} verrà aggiornato.",
    "Explicit listing ID #{id} will be updated.": "L’annuncio con ID esplicito #{id} verrà aggiornato.",
    "listings.smart_upload.progress.duplicates_complete": "Controllo duplicati completato",
    "Duplicate check complete": "Controllo duplicati completato",
    "listings.smart_upload.duplicate_check_failed": "Impossibile verificare gli annunci esistenti.",
    "Could not check existing listings.": "Impossibile verificare gli annunci esistenti.",
    "listings.smart_upload.progress.duplicates_stopped": "Controllo duplicati interrotto",
    "Duplicate check stopped": "Controllo duplicati interrotto",
    "listings.smart_upload.prepare_file_failed": "Impossibile preparare il file di importazione.",
    "listings.smart_upload.progress.uploading_file": "Caricamento del file di importazione",
    "listings.smart_upload.upload_file_failed": "Impossibile caricare il file di importazione.",
    "listings.smart_upload.all_rows_duplicates": "Tutte le righe sono state identificate come duplicati. Scegli “Importa comunque” per inviarle a Tradly o ricomincia.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Tutte le righe sono state identificate come duplicati. Scegli “Importa comunque” per inviarle a Tradly o ricomincia.",
    "listings.smart_upload.progress.preparing_attributes": "Preparazione degli attributi",
    "listings.smart_upload.attribute_mapped_once": "Ogni attributo può essere mappato una sola volta. Controlla la mappatura delle colonne prima di importare.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Ogni attributo può essere mappato una sola volta. Controlla la mappatura delle colonne prima di importare.",
    "listings.smart_upload.progress.preparing_file": "Preparazione del file di importazione",
    "listings.smart_upload.progress.tradly_importing": "Tradly sta importando gli annunci",
    "Tradly is importing listings": "Tradly sta importando gli annunci",
    "listings.smart_upload.progress.import_complete": "Importazione completata",
    "listings.smart_upload.progress.import_stopped": "Importazione interrotta",
    "listings.smart_upload.progress.preparing_import": "Preparazione dell’importazione…",
    "Preparing import…": "Preparazione dell’importazione…",
    "listings.smart_upload.progress.rows_prepared": "{current} righe preparate su {total}",
    "{current} of {total} rows prepared": "{current} righe preparate su {total}",
    "listings.smart_upload.progress.remote_processing": "Tradly sta elaborando il CSV caricato. Potrebbe volerci qualche istante.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly sta elaborando il CSV caricato. Potrebbe volerci qualche istante.",
    "listings.smart_upload.progress.partial_import": "Tradly ha importato {imported} righe su {total}{ending}. Controlla il risultato prima di riprovare; un nuovo import completo potrebbe duplicare le righe già importate.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly ha importato {imported} righe su {total}{ending}. Controlla il risultato prima di riprovare; un nuovo import completo potrebbe duplicare le righe già importate.",
    "listings.smart_upload.title": "Caricamento intelligente",
    "Smart Upload": "Caricamento intelligente",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Ricomincia",
    "listings.smart_upload.description": "Carica gli annunci, associa le colonne ai campi esistenti o crea nuovi attributi prima di importare.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "Carica gli annunci, associa le colonne ai campi esistenti o crea nuovi attributi prima di importare.",
    "listings.smart_upload.step_upload": "Caricamento",
    "listings.smart_upload.step_match": "Associa colonne",
    "listings.smart_upload.step_preview": "Anteprima",
    "listings.smart_upload.step_import": "Importa",
    "listings.smart_upload.choose_csv": "Scegli un file CSV",
    "listings.smart_upload.required_columns_help": "Le colonne obbligatorie sono title e category_id. Le altre possono diventare attributi dell’annuncio.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Le colonne obbligatorie sono title e category_id. Le altre possono diventare attributi dell’annuncio.",
    "listings.smart_upload.select_csv_file": "Seleziona file CSV",
    "listings.smart_upload.match_columns": "Associa le colonne dell’annuncio",
    "Match listing columns": "Associa le colonne dell’annuncio",
    "listings.smart_upload.core_fields_help": "I campi principali vengono inviati all’API degli annunci. Le colonne aggiuntive possono essere salvate come attributi.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "I campi principali vengono inviati all’API degli annunci. Le colonne aggiuntive possono essere salvate come attributi.",
    "listings.smart_upload.do_not_import": "Non importare",
    "listings.smart_upload.map_category_manually": "Mappa manualmente l’ID categoria",
    "Map Category ID manually": "Mappa manualmente l’ID categoria",
    "listings.smart_upload.category_assignment_help": "Scegli la categoria da assegnare a ogni annuncio importato.",
    "Choose the category to assign to every imported listing.": "Scegli la categoria da assegnare a ogni annuncio importato.",
    "listings.smart_upload.select_category": "Seleziona una categoria",
    "listings.smart_upload.no_categories": "Nessuna categoria annuncio restituita. Crea prima una categoria, poi riapri Smart Upload.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "Nessuna categoria annuncio restituita. Crea prima una categoria, poi riapri Smart Upload.",
    "listings.smart_upload.additional_attributes": "Attributi aggiuntivi dell’annuncio",
    "Additional listing attributes": "Attributi aggiuntivi dell’annuncio",
    "listings.smart_upload.ignore_column": "Ignora questa colonna",
    "listings.smart_upload.create_attribute": "＋ Crea un nuovo attributo annuncio",
    "＋ Create a new listing attribute": "＋ Crea un nuovo attributo annuncio",
    "listings.smart_upload.attribute_name": "Nome attributo",
    "listings.smart_upload.review_import": "Rivedi importazione",
    "listings.smart_upload.rows_scanned_help": "{count} annunci analizzati prima del caricamento. I duplicati vengono cercati tramite SKU, codice a barre, slug e valori ripetuti nel CSV.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "{count} annunci analizzati prima del caricamento. I duplicati vengono cercati tramite SKU, codice a barre, slug e valori ripetuti nel CSV.",
    "listings.smart_upload.duplicates_found": "Possibili duplicati",
    "Potential duplicates found": "Possibili duplicati",
    "listings.smart_upload.duplicate_rows_skipped": "Per impostazione predefinita verranno saltate {count} righe.",
    "{count} row(s) will be skipped by default.": "Per impostazione predefinita verranno saltate {count} righe.",
    "listings.smart_upload.row_label": "Riga",
    "Row": "Riga",
    "listings.smart_upload.explicit_ids_are_updates": "Le righe con un ID annuncio esplicito verranno trattate come aggiornamenti.",
    "Rows with an explicit listing ID are treated as updates.": "Le righe con un ID annuncio esplicito verranno trattate come aggiornamenti.",
    "listings.smart_upload.duplicate_action": "Azione per i duplicati",
    "Duplicate action": "Azione per i duplicati",
    "listings.smart_upload.skip_duplicates": "Salta i possibili duplicati (consigliato)",
    "Skip potential duplicates (recommended)": "Salta i possibili duplicati (consigliato)",
    "listings.smart_upload.import_all_anyway": "Importa comunque tutto",
    "Import all rows anyway": "Importa comunque tutto",
    "listings.smart_upload.untitled_listing": "Annuncio senza titolo",
    "Untitled listing": "Annuncio senza titolo",
    "listings.smart_upload.category_label": "Categoria:",
    "Category:": "Categoria:",
    "listings.smart_upload.complete": "Caricamento intelligente completato",
    "listings.smart_upload.imported_count": "Importati {imported} annunci su {total}.",
    "{imported} of {total} listings imported.": "Importati {imported} annunci su {total}.",
    "listings.smart_upload.selected_file": "Selezionato: {name}",
    "listings.smart_upload.checking": "Verifica…",
    "listings.smart_upload.check_duplicates": "Controlla duplicati",
    "Check duplicates": "Controlla duplicati",
    "listings.smart_upload.importing": "Importazione…",
    "listings.smart_upload.import_listings": "Importa annunci",
    "listings.smart_upload.failed": "Caricamento intelligente non riuscito.",
    "Smart Upload failed.": "Caricamento intelligente non riuscito.",
    "listings.smart_upload.id_label": "ID",
    "listings.status_toggle_hint": "Stato (Inattivo / Attivo)",
    "listings.upload_media": "Carica contenuti multimediali",
    "listing_form.stock_placeholder": "Inserisci le scorte",
    "orders.create_order.order_items_alt": "Articoli dell’ordine",
    "orders.create_order.by": "da",
    "by": "da",
    "orders.create_order.decrease_quantity": "Riduci quantità",
    "Decrease quantity": "Riduci quantità",
    "orders.create_order.increase_quantity": "Aumenta quantità",
    "Increase quantity": "Aumenta quantità",
    "orders.create_order.remove_item": "Rimuovi articolo",
    "Remove item": "Rimuovi articolo",
    "orders.create_order.rental_period_label": "Periodo di noleggio:",
    "Rental period:": "Periodo di noleggio:",
    "attributes.enter_text": "Inserisci il testo",
    "attributes.select_date": "Seleziona la data",
    "attributes.enter_number": "Inserisci un numero",
    "attributes.select_color": "Seleziona un colore",
    "attributes.upload_json": "Carica JSON",
    "Upload JSON": "Carica JSON",
    "attributes.select_location": "Seleziona una posizione",
    "attributes.add_listing_preview": "Aggiungi annuncio",
    "attributes.add_account_preview": "Aggiungi account",
    "attributes.enter_price": "Inserisci il prezzo",
    "attributes.preview": "Anteprima",
    "attributes.enter_title": "Inserisci il titolo",
    "attributes.enter_description": "Inserisci la descrizione",
    "attributes.category": "Categoria",
    "attributes.attribute_name": "Nome attributo",
    "attributes.enter_attribute_name": "Inserisci il nome dell’attributo",
    "attributes.select_type": "Seleziona il tipo",
    "attributes.icon": "Icona",
    "attributes.tooltip": "Suggerimento",
    "Tooltip": "Suggerimento",
    "attributes.enter_tooltip": "Inserisci il suggerimento dell’attributo",
    "Enter attribute tooltip": "Inserisci il suggerimento dell’attributo",
    "listings.detail.images": "Immagini",
    "listings.detail.posted_by": "Pubblicato da",
    "Posted by": "Pubblicato da",
    "listings.detail.fulfilled_by_platform": "Gestito dalla piattaforma",
    "listings.detail.preview": "Anteprima",
    "listings.detail.view_listing": "Visualizza annuncio",
    "View Listing": "Visualizza annuncio",
    "listings.detail.variants": "Varianti",
    "listings.detail.no_attribute_values": "Nessun valore attributo per {name}",
    "listings.detail.attributes": "Attributi",
    "listings.detail.starts_from": "A partire da:",
    "Starts From:": "A partire da:",
    "listings.detail.schedule": "Programma",
    "listings.detail.detail": "Dettagli",
    "web_config.download": "Scarica",
    "web_config.cancel": "Annulla",
    "web_config.choose_file": "Scegli file",
    "web_config.title": "Configurazione web",
    "Web Configs": "Configurazione web",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Larghezza logo",
    "Logo Width": "Larghezza logo",
    "web_config.width": "Larghezza",
    "web_config.logo_height": "Altezza logo",
    "Logo Height": "Altezza logo",
    "web_config.height": "Altezza",
    "web_config.social_share_image": "Immagine web in evidenza per la condivisione social - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Immagine web in evidenza per la condivisione social - Open Graph",
    "web_config.business_name": "Nome azienda",
    "web_config.enter_web_name": "Inserisci il nome del sito web",
    "Enter web name": "Inserisci il nome del sito web",
    "web_config.title_font": "Font del titolo",
    "Title Font": "Font del titolo",
    "web_config.select_title_font": "Seleziona il font del titolo",
    "Select title font": "Seleziona il font del titolo",
    "web_config.body_font": "Font del corpo",
    "Body Font": "Font del corpo",
    "web_config.select_body_font": "Seleziona il font del corpo",
    "Select body font": "Seleziona il font del corpo",
    "web_config.primary_font": "Font principale",
    "Primary Font": "Font principale",
    "web_config.select_primary_font": "Seleziona il font principale",
    "Select primary font": "Seleziona il font principale",
    "web_config.uploaded_successfully": "Caricato con successo",
    "web_config.ios_download_icon": "Icona per scaricare l’app iOS",
    "iOS app download icon": "Icona per scaricare l’app iOS",
    "web_config.ios_download_link": "Link per scaricare l’app iOS",
    "iOS app download link": "Link per scaricare l’app iOS",
    "web_config.enter_ios_download_link": "Inserisci il link per scaricare l’app iOS",
    "Enter iOS app download link": "Inserisci il link per scaricare l’app iOS",
    "web_config.android_download_icon": "Icona per scaricare l’app Android",
    "Android app download icon": "Icona per scaricare l’app Android",
    "web_config.android_download_link": "Link per scaricare l’app Android",
    "Android app download link": "Link per scaricare l’app Android",
    "web_config.enter_android_download_link": "Inserisci il link per scaricare l’app Android",
    "Enter android app download link": "Inserisci il link per scaricare l’app Android",
    "coupons.preview.customer_checkout": "CHECKOUT CLIENTE",
    "CUSTOMER CHECKOUT": "CHECKOUT CLIENTE",
    "coupons.preview.title": "I coupon in azione",
    "Coupons in action": "I coupon in azione",
    "coupons.preview.featured_product": "Il tuo prodotto in evidenza",
    "Your featured product": "Il tuo prodotto in evidenza",
    "coupons.preview.product_meta": "1 articolo · Spedizione standard",
    "1 item · Standard delivery": "1 articolo · Spedizione standard",
    "coupons.preview.coupon_applied": "Coupon applicato",
    "Coupon applied": "Coupon applicato",
    "coupons.preview.remove": "Rimuovi",
    "coupons.preview.discount_applied": "Sconto applicato all’ordine",
    "Discount applied to the order": "Sconto applicato all’ordine",
    "coupons.preview.subtotal": "Subtotale",
    "coupons.preview.coupon_label": "Coupon · WELCOME10",
    "Coupon · WELCOME10": "Coupon · WELCOME10",
    "coupons.preview.grand_total": "Totale complessivo",
    "Grand total": "Totale complessivo",
    "coupons.preview.checkout": "CHECKOUT",
    "CHECKOUT": "CHECKOUT",
    "payments.stripe_get_keys": "Ottieni le chiavi Stripe",
    "Get Stripe keys": "Ottieni le chiavi Stripe",
    "payments.stripe_syncing": "Sincronizzazione con Stripe...",
    "Syncing with Stripe...": "Sincronizzazione con Stripe...",
    "payments.stripe_verifying_key": "Verifica della chiave segreta",
    "Verifying secret key": "Verifica della chiave segreta",
    "payments.stripe_creating_webhook": "Creazione del webhook di pagamento",
    "Creating payment webhook": "Creazione del webhook di pagamento",
    "payments.stripe_account_summary": "{country} · modalità {mode} · {id}",
    "{country} · {mode} mode · {id}": "{country} · modalità {mode} · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhook configurati — i segreti sono compilati automaticamente qui sotto. Salva il modulo per applicare le modifiche.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhook configurati — i segreti sono compilati automaticamente qui sotto. Salva il modulo per applicare le modifiche.",
    "payments.stripe_webhooks_error": "⚠ Configurazione webhook non riuscita. Controlla i permessi della chiave e riprova a sincronizzare.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Configurazione webhook non riuscita. Controlla i permessi della chiave e riprova a sincronizzare.",
    "payments.stripe_invalid_key": "Chiave segreta non valida. Controlla e riprova.",
    "Invalid secret key. Check and try again.": "Chiave segreta non valida. Controlla e riprova.",
    "payments.stripe_setup_failed": "Configurazione non riuscita. Assicurati di sincronizzare prima la chiave segreta.",
    "Setup failed. Make sure your secret key is synced first.": "Configurazione non riuscita. Assicurati di sincronizzare prima la chiave segreta.",
    "payments.stripe_marketplace_connect": "Marketplace Connect",
    "Marketplace Connect": "Marketplace Connect",
    "payments.stripe_marketplace_hint": "Necessario solo se usi Stripe Connect per i pagamenti del marketplace",
    "Only needed if you use Stripe Connect for marketplace payouts": "Necessario solo se usi Stripe Connect per i pagamenti del marketplace",
    "payments.stripe_subscription_hint": "Necessario solo se vendi prodotti in abbonamento su Tradly",
    "Only needed if you sell subscription products on Tradly": "Necessario solo se vendi prodotti in abbonamento su Tradly",
    "integrations.sso.title": "Single sign-on aziendale",
    "Enterprise single sign-on": "Single sign-on aziendale",
    "integrations.sso.description": "Collega il provider di identità aziendale per consentire al personale del tenant di accedere ad ArcticWhale tramite OIDC. Supporta Okta, Microsoft Entra ID e provider OIDC che firmano i token ID con RS256.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Collega il provider di identità aziendale per consentire al personale del tenant di accedere ad ArcticWhale tramite OIDC. Supporta Okta, Microsoft Entra ID e provider OIDC che firmano i token ID con RS256.",
    "integrations.sso.issuer_url": "URL dell’issuer",
    "Issuer URL": "URL dell’issuer",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "ID client",
    "integrations.sso.client_secret": "Segreto client",
    "integrations.sso.secret_replace_placeholder": "Salvato in modo sicuro. Inserisci un valore per sostituirlo.",
    "Saved securely. Enter a value to replace it.": "Salvato in modo sicuro. Inserisci un valore per sostituirlo.",
    "integrations.sso.secret_placeholder": "Inserisci il segreto client",
    "Enter the client secret": "Inserisci il segreto client",
    "integrations.sso.email_domains": "Domini email aziendali",
    "Company email domains": "Domini email aziendali",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "Il personale deve già avere un account ArcticWhale e l’accesso a questo tenant. Usa domini di proprietà della tua organizzazione.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "Il personale deve già avere un account ArcticWhale e l’accesso a questo tenant. Usa domini di proprietà della tua organizzazione.",
    "integrations.sso.callback_url": "URL di callback OIDC",
    "OIDC callback URL": "URL di callback OIDC",
    "integrations.sso.loading_callback_url": "Caricamento URL di callback…",
    "Loading callback URL…": "Caricamento URL di callback…",
    "integrations.sso.callback_help": "Aggiungi questo URL esatto all’applicazione del provider di identità come Web redirect URI.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Aggiungi questo URL esatto all’applicazione del provider di identità come Web redirect URI.",
    "integrations.sso.enable": "Abilita l’accesso SSO aziendale",
    "Enable company SSO sign-in": "Abilita l’accesso SSO aziendale",
    "integrations.sso.checking": "Verifica…",
    "integrations.sso.test_issuer": "Verifica issuer",
    "Test issuer": "Verifica issuer",
    "integrations.sso.saving": "Salvataggio…",
    "integrations.sso.save": "Salva impostazioni SSO",
    "Save SSO settings": "Salva impostazioni SSO",
    "integrations.sso.security_help": "Il segreto client viene cifrato prima di essere salvato. SSO aggiunge un’opzione di accesso aziendale; l’accesso con password resta invariato in questa configurazione.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "Il segreto client viene cifrato prima di essere salvato. SSO aggiunge un’opzione di accesso aziendale; l’accesso con password resta invariato in questa configurazione.",
    "integrations.sso.load_error": "Impossibile caricare le impostazioni SSO aziendali.",
    "Unable to load enterprise SSO settings.": "Impossibile caricare le impostazioni SSO aziendali.",
    "integrations.sso.save_error": "Impossibile salvare le impostazioni SSO aziendali.",
    "Unable to save enterprise SSO settings.": "Impossibile salvare le impostazioni SSO aziendali.",
    "integrations.sso.saved": "Impostazioni SSO aziendali salvate.",
    "Enterprise SSO settings saved.": "Impostazioni SSO aziendali salvate.",
    "integrations.sso.connection_ok": "Il servizio di discovery del provider di identità è raggiungibile.",
    "Identity provider discovery is reachable.": "Il servizio di discovery del provider di identità è raggiungibile.",
    "integrations.sso.connection_error": "Impossibile connettersi al provider di identità.",
    "Unable to connect to the identity provider.": "Impossibile connettersi al provider di identità.",
    "listing_configs.maximum_quantity_per_listing": "Quantità massima per annuncio",
    "listing_configs.example_quantity": "(Esempio: 100)",
    "listing_configs.enter_maximum_quantity": "Inserisci la quantità massima per annuncio",
    "Enter maximum quantity per listing": "Inserisci la quantità massima per annuncio",
    "listing_configs.minimum_listing_price": "Prezzo minimo annuncio",
    "listing_configs.example_price": "(Esempio: $5)",
    "listing_configs.enter_minimum_price": "Inserisci il prezzo minimo dell’annuncio",
    "Enter minimum listing price": "Inserisci il prezzo minimo dell’annuncio",
    "listing_configs.picture_count": "Numero di immagini caricabili",
    "listing_configs.enter_picture_count": "Inserisci il numero di immagini",
    "Enter Pictures count": "Inserisci il numero di immagini",
    "listing_configs.feature_activation": "ATTIVAZIONE FUNZIONALITÀ",
    "FEATURE ACTIVATION": "ATTIVAZIONE FUNZIONALITÀ",
    "listing_configs.example_landmark": "(Esempio: Punto di riferimento)",
    "listing_configs.enter_address_label": "Inserisci etichetta indirizzo",
    "Enter address Label": "Inserisci etichetta indirizzo",
    "listing_configs.legacy_switch_0": "Approvare automaticamente gli annunci?",
    "listing_configs.legacy_switch_1": "Percentuale offerta",
    "listing_configs.legacy_switch_2": "Limiti quantità massima a livello di annuncio",
    "listing_configs.legacy_switch_3": "Spese di spedizione",
    "listing_configs.legacy_switch_4": "Usa il marcatore sulla mappa invece di cercare l’indirizzo",
    "Use map marker instead \nof searching address": "Usa il marcatore sulla mappa invece di cercare l’indirizzo",
    "listing_configs.legacy_switch_5": "Tag",
    "listing_configs.legacy_switch_6": "Scorte",
    "listing_configs.legacy_switch_7": "Indirizzo geografico",
    "listing_configs.legacy_switch_8": "Mostra nel feed gli annunci esauriti",
    "listing_configs.legacy_switch_9": "Slug del titolo annuncio",
    "listing_configs.legacy_switch_10": "Varianti",
    "listing_configs.legacy_switch_11": "Titolo meta",
    "listing_configs.legacy_switch_12": "Descrizione meta",
    "listing_configs.legacy_switch_13": "Prodotto digitale",
    "Digital Product": "Prodotto digitale",
    "listing_configs.legacy_switch_14": "Abilita Composer",
    "listing_configs.legacy_switch_15": "Abilita peso",
    "listing_configs.legacy_switch_16": "Abilita dimensioni",
    "navigation.app_download.close": "Chiudi",
    "navigation.app_download.eyebrow": "App mobile complementare",
    "Mobile companion": "App mobile complementare",
    "navigation.app_download.title": "Continua a seguire il tuo progetto ovunque.",
    "Keep your project moving.": "Continua a seguire il tuo progetto ovunque.",
    "navigation.app_download.description": "Gestisci le attività essenziali dal telefono: approva nuovi annunci, controlla gli ordini e tieni sotto controllo l’attività.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Gestisci le attività essenziali dal telefono: approva nuovi annunci, controlla gli ordini e tieni sotto controllo l’attività.",
    "navigation.app_download.approve_listings": "Approva annunci",
    "Approve listings": "Approva annunci",
    "navigation.app_download.manage_orders": "Gestisci ordini",
    "Manage orders": "Gestisci ordini",
    "navigation.app_download.check_performance": "Controlla le prestazioni",
    "Check performance": "Controlla le prestazioni",
    "navigation.app_download.download_title": "Scarica l’app SuperAdmin",
    "Download the SuperAdmin app": "Scarica l’app SuperAdmin",
    "navigation.app_download.download_on": "Scarica su",
    "Download on the": "Scarica su",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Disponibile su",
    "Get it on": "Disponibile su",
    "listing_configs.address_label": "Etichetta indirizzo",
    "collections.add_another_condition": "＋ Aggiungi un’altra condizione",
    "collections.search": "Cerca",
    "collections.status_inactive_active": "Stato (Inattivo / Attivo)",
    "media_picker.add_photo": "Aggiungi foto",
    "payments.payment_intent_webhook_secret": "Segreto webhook Payment Intent",
    "Payment Intent Webhook secret": "Segreto webhook Payment Intent",
    "payments.subscription_webhook_secret": "Segreto webhook abbonamento",
    "Subscription Webhook secret": "Segreto webhook abbonamento",
    "payments.webhook_secret_autofilled": "Il segreto webhook è stato compilato automaticamente sopra: salva il modulo per conservarlo.",
    "Webhook secret auto-filled above — save the form to persist.": "Il segreto webhook è stato compilato automaticamente sopra: salva il modulo per conservarlo.",
    "app_customization.white_png_icon_help": "L’icona deve essere bianca e in formato PNG",
    "icon should be white and in png format": "L’icona deve essere bianca e in formato PNG",
    "app_customization.other_appearance": "Altri aspetti",
    "Other appearance": "Altri aspetti",
    "app_customization.notification_icon": "Icona di notifica",
    "Notification icon": "Icona di notifica",
    "app_customization.app_title_home": "Titolo app nella schermata Home",
    "app_customization.enable_app_title_icon": "Usa l’icona del titolo dell’app invece del testo",
    "listings.quick_add.title": "Aggiunta rapida annuncio",
    "Quick Add Listing": "Aggiunta rapida annuncio",
    "listings.quick_add.success": "Annuncio aggiunto correttamente",
    "Listing Added Successfully": "Annuncio aggiunto correttamente",
    "listings.quick_add.image": "Immagine",
    "listings.quick_add.listing_name": "Nome annuncio",
    "Listing Name": "Nome annuncio",
    "listings.quick_add.title_placeholder": "ad es. cuffie wireless premium",
    "e.g., Premium Wireless Headphones": "ad es. cuffie wireless premium",
    "listings.quick_add.category": "Categoria",
    "listings.quick_add.select_category": "Seleziona categoria",
    "listings.quick_add.price": "Prezzo",
    "listings.quick_add.stock": "Scorte",
    "listings.quick_add.description": "Descrizione",
    "listings.quick_add.description_placeholder": "Breve descrizione del prodotto...",
    "Brief Description of your product...": "Breve descrizione del prodotto...",
    "listings.quick_add.more_options": "Ti servono altre opzioni? Usa il",
    "Need more options? Use the full": "Ti servono altre opzioni? Usa il",
    "listings.quick_add.guided_form": "modulo completo",
    "guided form": "modulo completo",
    "listings.quick_add.instead": "invece",
    "instead": "invece",
    "listings.digital_product.title": "Aggiungi prodotto digitale",
    "Add Digital Product": "Aggiungi prodotto digitale",
    "listings.digital_product.select_file": "Seleziona file",
    "Select file": "Seleziona file",
    "listings.digital_product.name": "Titolo",
    "listings.digital_product.version": "Versione",
    "listings.digital_product.description": "Descrizione",
    "web_config.social_info": "Informazioni social",
    "Social Info": "Informazioni social",
    "web_config.social_facebook_pageurl": "URL della pagina Facebook",
    "Facebook page URL": "URL della pagina Facebook",
    "web_config.enter_social_facebook_pageurl": "Inserisci l’URL della pagina Facebook",
    "Enter Facebook page URL": "Inserisci l’URL della pagina Facebook",
    "web_config.social_twitter_handleurl": "URL del profilo Twitter",
    "Twitter handle URL": "URL del profilo Twitter",
    "web_config.enter_social_twitter_handleurl": "Inserisci l’URL del profilo Twitter",
    "Enter Twitter handle URL": "Inserisci l’URL del profilo Twitter",
    "web_config.social_instagram_url": "URL Instagram",
    "Instagram URL": "URL Instagram",
    "web_config.enter_social_instagram_url": "Inserisci l’URL Instagram",
    "Enter Instagram URL": "Inserisci l’URL Instagram",
    "web_config.social_youtube_channelurl": "URL del canale YouTube",
    "Youtube channel URL": "URL del canale YouTube",
    "web_config.enter_social_youtube_channelurl": "Inserisci l’URL del canale YouTube",
    "Enter Youtube channel URL": "Inserisci l’URL del canale YouTube",
    "web_config.social_tiktok_url": "URL TikTok",
    "Tiktok URL": "URL TikTok",
    "web_config.enter_social_tiktok_url": "Inserisci l’URL TikTok",
    "Enter Tiktok URL": "Inserisci l’URL TikTok",
    "web_config.social_spotify_url": "URL Spotify",
    "Spotify URL": "URL Spotify",
    "web_config.enter_social_spotify_url": "Inserisci l’URL Spotify",
    "Enter Spotify URL": "Inserisci l’URL Spotify",
    "web_config.social_whatsapp_number": "Numero WhatsApp",
    "Whatsapp number": "Numero WhatsApp",
    "web_config.enter_social_whatsapp_number": "Inserisci il numero WhatsApp",
    "Enter Whatsapp number": "Inserisci il numero WhatsApp",
    "web_config.social_telegram_url": "URL Telegram",
    "Telegram URL": "URL Telegram",
    "web_config.enter_social_telegram_url": "Inserisci l’URL Telegram",
    "Enter Telegram URL": "Inserisci l’URL Telegram",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Inserisci Snapchat",
    "Enter Snapchat": "Inserisci Snapchat",
    "payments.paydunya.title": "Integrazione PayDunya",
    "PayDunya Integration": "Integrazione PayDunya",
    "payments.paydunya.master_key": "Chiave principale",
    "Master key": "Chiave principale",
    "payments.paydunya.enter_master_key": "Inserisci la chiave principale",
    "Enter master key": "Inserisci la chiave principale",
    "payments.paydunya.public_key": "Chiave pubblica",
    "Public key": "Chiave pubblica",
    "payments.paydunya.enter_public_key": "Inserisci la chiave pubblica",
    "payments.paydunya.private_key": "Chiave privata",
    "Private key": "Chiave privata",
    "payments.paydunya.enter_private_key": "Inserisci la chiave privata",
    "Enter private key": "Inserisci la chiave privata",
    "payments.paydunya.token": "Token",
    "payments.paydunya.enter_token": "Inserisci il token",
    "payments.paydunya.uploaded_successfully": "Caricato con successo",
    "communications.email_stats_open": "{sent} inviati · apertura {openRate}%",
    "{sent} sent · {openRate}% open": "{sent} inviati · apertura {openRate}%",
    "communications.email_stats_full": "{sent} inviati · apertura {openRate}% · clic {clicks}",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} inviati · apertura {openRate}% · clic {clicks}",
    "navigation.mini_apps.title": "Mini app",
    "Mini Apps": "Mini app",
    "navigation.mini_apps.subtitle": "Strumenti complementari creati da Tradly: seleziona una scheda per dettagli e prezzi",
    "Tradly-built companion tools — tap a card to see details and pricing": "Strumenti complementari creati da Tradly: seleziona una scheda per dettagli e prezzi",
    "navigation.mini_apps.soon": "Presto",
    "Soon": "Presto",
    "navigation.mini_apps.included_in_paid_plan": "Incluso in un piano a pagamento",
    "Included in a paid plan": "Incluso in un piano a pagamento",
    "navigation.mini_apps.know_more": "Scopri di più",
    "Know more": "Scopri di più",
    "navigation.mini_apps.hide_details": "Nascondi dettagli",
    "Hide details": "Nascondi dettagli",
    "navigation.mini_apps.view_plans": "Visualizza i piani",
    "navigation.mini_apps.remove": "Rimuovi",
    "navigation.mini_apps.add_to_sidebar": "Aggiungi alla barra laterale",
    "Add to sidebar": "Aggiungi alla barra laterale",
    "navigation.mini_apps.why_heading": "Perché serve alla tua attività",
    "Why your business needs it": "Perché serve alla tua attività",
    "navigation.mini_apps.coming_soon": "Prossimamente",
    "navigation.mini_apps.workflow.title": "Marketing",
    "navigation.mini_apps.workflow.description": "Crea campagne email, notifiche push e promozioni per ampliare il tuo pubblico.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Crea campagne email, notifiche push e promozioni per ampliare il tuo pubblico.",
    "navigation.mini_apps.workflow.why_1": "Invia campagne email mirate ad acquirenti e venditori in base alla loro attività",
    "Send targeted email campaigns to buyers and sellers based on activity": "Invia campagne email mirate ad acquirenti e venditori in base alla loro attività",
    "navigation.mini_apps.workflow.why_2": "Coinvolgi di nuovo con notifiche push gli utenti che non visitano da oltre 7 giorni",
    "Push notifications to re-engage users who haven't visited in 7+ days": "Coinvolgi di nuovo con notifiche push gli utenti che non visitano da oltre 7 giorni",
    "navigation.mini_apps.workflow.why_3": "Crea promozioni con coupon in occasione degli eventi stagionali",
    "Run promotions with coupon drops timed to your seasonal events": "Crea promozioni con coupon in occasione degli eventi stagionali",
    "navigation.mini_apps.workflow.pricing_label": "A crediti",
    "Credits-based": "A crediti",
    "navigation.mini_apps.workflow.pricing_detail": "Paghi per invio: 1.000 email costano 100 crediti. I crediti non scadono.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Paghi per invio: 1.000 email costano 100 crediti. I crediti non scadono.",
    "navigation.mini_apps.intelligence_section.title": "Intelligence",
    "navigation.mini_apps.intelligence_section.description": "Comprendi la crescita con analisi, funnel e approfondimenti basati sull’AI.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Comprendi la crescita con analisi, funnel e approfondimenti basati sull’AI.",
    "navigation.mini_apps.intelligence_section.why_1": "Scopri quali annunci, account e categorie generano il GMV maggiore",
    "See which listings, accounts, and categories drive the most GMV": "Scopri quali annunci, account e categorie generano il GMV maggiore",
    "navigation.mini_apps.intelligence_section.why_2": "I funnel di abbandono mostrano esattamente dove gli acquirenti escono prima del checkout",
    "Drop-off funnels show exactly where buyers leave before checkout": "I funnel di abbandono mostrano esattamente dove gli acquirenti escono prima del checkout",
    "navigation.mini_apps.intelligence_section.why_3": "L’AI individua anomalie e opportunità che potresti non notare nei dati grezzi",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "L’AI individua anomalie e opportunità che potresti non notare nei dati grezzi",
    "navigation.mini_apps.intelligence_section.pricing_label": "A crediti",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Le analisi AI e i report generati consumano crediti. La consultazione dei dati è sempre gratuita.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Le analisi AI e i report generati consumano crediti. La consultazione dei dati è sempre gratuita.",
    "navigation.mini_apps.subscription_section.title": "Abbonamenti",
    "navigation.mini_apps.subscription_section.description": "Gestisci piani, cicli di fatturazione e diritti alle funzionalità dei tenant.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Gestisci piani, cicli di fatturazione e diritti alle funzionalità dei tenant.",
    "navigation.mini_apps.subscription_section.why_1": "Crea piani a più livelli (Free / Pro / Enterprise) con limiti per funzionalità",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Crea piani a più livelli (Free / Pro / Enterprise) con limiti per funzionalità",
    "navigation.mini_apps.subscription_section.why_2": "Automatizza i cicli di fatturazione: mensili, annuali o di durata personalizzata",
    "Automate billing cycles — monthly, annual, or custom durations": "Automatizza i cicli di fatturazione: mensili, annuali o di durata personalizzata",
    "navigation.mini_apps.subscription_section.why_3": "I diritti sbloccano o limitano le funzionalità per tutti i tenant",
    "Entitlements unlock or restrict features across your tenant base": "I diritti sbloccano o limitano le funzionalità per tutti i tenant",
    "navigation.mini_apps.subscription_section.pricing_label": "Connessione",
    "navigation.mini_apps.subscription_section.pricing_detail": "Prezzo basato sulle attività: addebito per ogni evento dell’abbonamento (upgrade, rinnovo, annullamento).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Prezzo basato sulle attività: addebito per ogni evento dell’abbonamento (upgrade, rinnovo, annullamento).",
    "navigation.mini_apps.membership_section.title": "Iscrizioni",
    "navigation.mini_apps.membership_section.description": "Gestisci programmi di iscrizione, membri, contributi e quote di pagamento.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Gestisci programmi di iscrizione, membri, contributi e quote di pagamento.",
    "navigation.mini_apps.membership_section.why_1": "Gestisci i programmi di iscrizione e i membri registrati",
    "Manage membership programs and enrolled members": "Gestisci i programmi di iscrizione e i membri registrati",
    "navigation.mini_apps.membership_section.why_2": "Monitora contributi, quote dovute e stato dell’iscrizione",
    "Track contributions, payment dues, and membership status": "Monitora contributi, quote dovute e stato dell’iscrizione",
    "navigation.mini_apps.membership_section.why_3": "Collega i contributi dei membri ai relativi ordini",
    "Connect membership contributions back to their orders": "Collega i contributi dei membri ai relativi ordini",
    "navigation.mini_apps.membership_section.pricing_label": "Prezzo da definire",
    "Pricing TBC": "Prezzo da definire",
    "navigation.mini_apps.membership_section.pricing_detail": "Gestisci i programmi di iscrizione e lo storico dei contributi in un unico posto.",
    "Manage membership programs and contribution history in one place.": "Gestisci i programmi di iscrizione e lo storico dei contributi in un unico posto.",
    "navigation.mini_apps.reward_programs.title": "Premi",
    "navigation.mini_apps.reward_programs.description": "Crea programmi di premi con ambiti, regole e modelli riutilizzabili.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Crea programmi di premi con ambiti, regole e modelli riutilizzabili.",
    "navigation.mini_apps.reward_programs.why_1": "Definisci programmi premi per affiliazioni, referral, aree geografiche o negozi",
    "Define affiliate, referral, regional, or store reward programs": "Definisci programmi premi per affiliazioni, referral, aree geografiche o negozi",
    "navigation.mini_apps.reward_programs.why_2": "Crea regole con componenti riutilizzabili di commissione e premio",
    "Build rules from reusable commission and reward components": "Crea regole con componenti riutilizzabili di commissione e premio",
    "navigation.mini_apps.reward_programs.why_3": "Il calcolo dei premi e la registrazione nel ledger sono gestiti dal backend ERP",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Il calcolo dei premi e la registrazione nel ledger sono gestiti dal backend ERP",
    "navigation.mini_apps.reward_programs.pricing_label": "Prezzo da definire",
    "navigation.mini_apps.reward_programs.pricing_detail": "Configura i programmi premio e collegali all’attribuzione.",
    "Configure reward programs and connect them to attribution.": "Configura i programmi premio e collegali all’attribuzione.",
    "navigation.mini_apps.bundles_app.title": "Bundle",
    "navigation.mini_apps.bundles_app.description": "Crea bundle fissi e combinabili a partire dagli annunci esistenti.",
    "Create fixed and mix-and-match bundles from existing listings.": "Crea bundle fissi e combinabili a partire dagli annunci esistenti.",
    "navigation.mini_apps.bundles_app.why_1": "Combina gli annunci esistenti senza duplicare i dati dei prodotti",
    "Combine existing listings without duplicating product data": "Combina gli annunci esistenti senza duplicare i dati dei prodotti",
    "navigation.mini_apps.bundles_app.why_2": "Supporta bundle fissi e bundle componibili scelti dai clienti",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Supporta bundle fissi e bundle componibili scelti dai clienti",
    "navigation.mini_apps.bundles_app.why_3": "Verifica la disponibilità dei componenti prima del checkout e dell’evasione",
    "Validate component stock before checkout and fulfilment": "Verifica la disponibilità dei componenti prima del checkout e dell’evasione",
    "navigation.mini_apps.bundles_app.pricing_label": "Funzionalità del piano a pagamento",
    "Paid package feature": "Funzionalità del piano a pagamento",
    "navigation.mini_apps.bundles_app.pricing_detail": "Disponibile nei piani che includono le operazioni sui bundle.",
    "Available on plans that include bundle operations.": "Disponibile nei piani che includono le operazioni sui bundle.",
    "navigation.mini_apps.inventory_section.title": "Catena di fornitura",
    "navigation.mini_apps.inventory_section.description": "Scorte, ordini di acquisto, ubicazioni, fornitori e operazioni.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Scorte, ordini di acquisto, ubicazioni, fornitori e operazioni.",
    "navigation.mini_apps.inventory_section.why_1": "Monitora le scorte in più magazzini e punti vendita",
    "Track stock levels across multiple warehouses and store locations": "Monitora le scorte in più magazzini e punti vendita",
    "navigation.mini_apps.inventory_section.why_2": "Emetti ordini di acquisto ai fornitori e ricevi le scorte",
    "Raise purchase orders with suppliers and receive stock against them": "Emetti ordini di acquisto ai fornitori e ricevi le scorte",
    "navigation.mini_apps.inventory_section.why_3": "Registra le operazioni di magazzino: rettifiche, trasferimenti e cancellazioni",
    "Record inventory operations — adjustments, transfers, and write-offs": "Registra le operazioni di magazzino: rettifiche, trasferimenti e cancellazioni",
    "navigation.mini_apps.inventory_section.pricing_label": "Incluso",
    "Included": "Incluso",
    "navigation.mini_apps.inventory_section.pricing_detail": "Supply Chain è incluso nel tuo piano. Nessun costo aggiuntivo.",
    "Supply Chain is included in your plan. No additional charge.": "Supply Chain è incluso nel tuo piano. Nessun costo aggiuntivo.",
    "navigation.mini_apps.people_app.title": "Personale",
    "navigation.mini_apps.people_app.description": "Rubrica del personale, reparti, profili professionali e fasce retributive.",
    "Staff directory, departments, job profiles, and pay grades.": "Rubrica del personale, reparti, profili professionali e fasce retributive.",
    "navigation.mini_apps.people_app.why_1": "Conserva in un’unica rubrica il profilo, il codice e il tipo di impiego di ogni dipendente",
    "Keep every staff profile, code, and employment type in one directory": "Conserva in un’unica rubrica il profilo, il codice e il tipo di impiego di ogni dipendente",
    "navigation.mini_apps.people_app.why_2": "Organizza i team in reparti con profili professionali standard",
    "Organise teams into departments with standard job profiles": "Organizza i team in reparti con profili professionali standard",
    "navigation.mini_apps.people_app.why_3": "Definisci le fasce retributive una volta e assegnale al personale",
    "Define pay grades once and assign them to staff": "Definisci le fasce retributive una volta e assegnale al personale",
    "navigation.mini_apps.people_app.pricing_label": "Prezzo da definire",
    "navigation.mini_apps.people_app.pricing_detail": "Richiesto da Workforce e Payroll.",
    "Required by Workforce and Payroll.": "Richiesto da Workforce e Payroll.",
    "navigation.mini_apps.workforce_app.title": "Personale",
    "navigation.mini_apps.workforce_app.description": "Turni, presenze e gestione dei permessi per il team.",
    "Shifts, attendance, and leave management for your team.": "Turni, presenze e gestione dei permessi per il team.",
    "navigation.mini_apps.workforce_app.why_1": "Assegna i turni al personale per data, orario e luogo",
    "Roster staff into shifts by date, time, and location": "Assegna i turni al personale per data, orario e luogo",
    "navigation.mini_apps.workforce_app.why_2": "Registra entrate e uscite con una cronologia completa delle presenze",
    "Clock in and out with a full attendance history": "Registra entrate e uscite con una cronologia completa delle presenze",
    "navigation.mini_apps.workforce_app.why_3": "Politiche ferie, saldi e flusso di approvazione o rifiuto",
    "Leave policies, balances, and an approve/reject workflow": "Politiche ferie, saldi e flusso di approvazione o rifiuto",
    "navigation.mini_apps.workforce_app.pricing_label": "Prezzo da definire",
    "navigation.mini_apps.workforce_app.pricing_detail": "Attiva automaticamente People.",
    "Turns on People automatically.": "Attiva automaticamente People.",
    "navigation.mini_apps.payroll_app.title": "Paghe",
    "navigation.mini_apps.payroll_app.description": "Elaborazione paghe, approvazioni, esportazione CSV e rimborsi spese.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Elaborazione paghe, approvazioni, esportazione CSV e rimborsi spese.",
    "navigation.mini_apps.payroll_app.why_1": "Crea elaborazioni paghe per periodo in base alle fasce retributive del personale",
    "Create payroll runs per period from staff pay grades": "Crea elaborazioni paghe per periodo in base alle fasce retributive del personale",
    "navigation.mini_apps.payroll_app.why_2": "Approva le paghe ed esportale in CSV per la banca o il commercialista",
    "Approve runs and export them as CSV for your bank or accountant": "Approva le paghe ed esportale in CSV per la banca o il commercialista",
    "navigation.mini_apps.payroll_app.why_3": "Gestisci le richieste di rimborso spese del personale, dall’invio al pagamento",
    "Staff expense claims from submission to reimbursement": "Gestisci le richieste di rimborso spese del personale, dall’invio al pagamento",
    "navigation.mini_apps.payroll_app.pricing_label": "Prezzo da definire",
    "navigation.mini_apps.payroll_app.pricing_detail": "Attiva automaticamente People.",
    "navigation.mini_apps.unified_inbox.title": "Posta in arrivo unificata",
    "Unified Inbox": "Posta in arrivo unificata",
    "navigation.mini_apps.unified_inbox.description": "Tutte le comunicazioni con i clienti — ordini, assistenza e chat — in un unico posto.",
    "All your customer communication — orders, support, and chat — from one place.": "Tutte le comunicazioni con i clienti — ordini, assistenza e chat — in un unico posto.",
    "navigation.mini_apps.unified_inbox.why_1": "Richieste sugli ordini, ticket di assistenza e messaggi degli acquirenti in un’unica vista",
    "Order queries, support tickets, and buyer messages in one thread view": "Richieste sugli ordini, ticket di assistenza e messaggi degli acquirenti in un’unica vista",
    "navigation.mini_apps.unified_inbox.why_2": "Rispondi con suggerimenti AI basati sul tuo catalogo",
    "Reply with AI-suggested responses trained on your catalogue": "Rispondi con suggerimenti AI basati sul tuo catalogo",
    "navigation.mini_apps.unified_inbox.why_3": "Assegna tag e responsabili e risolvi le conversazioni con il team",
    "Tag, assign, and resolve conversations across your team": "Assegna tag e responsabili e risolvi le conversazioni con il team",
    "navigation.mini_apps.unified_inbox.pricing_label": "Connessione",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Prezzo basato sulle attività per ogni conversazione risolta.",
    "Task-based pricing per resolved conversation.": "Prezzo basato sulle attività per ogni conversazione risolta.",
    "navigation.mini_apps.social_connect.title": "Social Connect",
    "Social Connect": "Social Connect",
    "navigation.mini_apps.social_connect.description": "Condividi gli annunci sui social secondo una pianificazione definita da te.",
    "Share listings to social channels on a schedule you define.": "Condividi gli annunci sui social secondo una pianificazione definita da te.",
    "navigation.mini_apps.social_connect.why_1": "Programma automaticamente i post degli annunci su Instagram, Facebook e X",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "Programma automaticamente i post degli annunci su Instagram, Facebook e X",
    "navigation.mini_apps.social_connect.why_2": "Definisci la pianificazione per ogni canale: post giornalieri, offerte lampo o cadenze personalizzate",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Definisci la pianificazione per ogni canale: post giornalieri, offerte lampo o cadenze personalizzate",
    "navigation.mini_apps.social_connect.why_3": "Monitora clic e interazioni per ogni annuncio dalla dashboard",
    "Track clicks and engagement back to each listing from the dashboard": "Monitora clic e interazioni per ogni annuncio dalla dashboard",
    "navigation.mini_apps.social_connect.pricing_label": "Connessione",
    "navigation.mini_apps.social_connect.pricing_detail": "Prezzo basato sulle attività per ogni post programmato pubblicato.",
    "Task-based pricing per scheduled post delivered.": "Prezzo basato sulle attività per ogni post programmato pubblicato.",
    "navigation.mini_apps.shopping_channels.title": "Canali di vendita",
    "Shopping Channels": "Canali di vendita",
    "navigation.mini_apps.shopping_channels.description": "Collega il tuo catalogo a TikTok Shop, Shopee, Meta Catalog, Uber Eats e altri.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Collega il tuo catalogo a TikTok Shop, Shopee, Meta Catalog, Uber Eats e altri.",
    "navigation.mini_apps.shopping_channels.why_1": "Sincronizza subito gli annunci con TikTok Shop, Shopee e Meta Catalog",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "Sincronizza subito gli annunci con TikTok Shop, Shopee e Meta Catalog",
    "navigation.mini_apps.shopping_channels.why_2": "Collega i cataloghi di cibo e bevande a Uber Eats e Grab",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Collega i cataloghi di cibo e bevande a Uber Eats e Grab",
    "navigation.mini_apps.shopping_channels.why_3": "Scorte e ordini si sincronizzano automaticamente, senza inserimenti doppi",
    "Inventory and orders sync back automatically — no double-entry": "Scorte e ordini si sincronizzano automaticamente, senza inserimenti doppi",
    "navigation.mini_apps.shopping_channels.pricing_label": "Connessione",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Prezzo basato sulle attività per ogni ordine evaso tramite un canale connesso.",
    "Task-based pricing per order fulfilled through a connected channel.": "Prezzo basato sulle attività per ogni ordine evaso tramite un canale connesso.",
    "listing_configs.customize_table": "Personalizza tabella",
    "Customize table": "Personalizza tabella",
    "listing_configs.fields_visible": "Campi visibili nella tabella",
    "Fields visible in table": "Campi visibili nella tabella",
    "listing_configs.fields_hidden": "Campi nascosti nella tabella",
    "Fields not shown in table": "Campi nascosti nella tabella",
    "listing_configs.reset_default": "Ripristina predefiniti",
    "listing_configs.column_title": "Titolo",
    "listing_configs.column_actions": "Azioni",
    "listing_configs.column_website": "Sito web",
    "listing_configs.column_list_price": "Prezzo di listino",
    "listing_configs.column_offer_percent": "Percentuale offerta",
    "Offer Percent": "Percentuale offerta",
    "listing_configs.column_image": "Immagine",
    "listing_configs.column_offer_price": "Prezzo scontato",
    "Offer Price": "Prezzo scontato",
    "listing_configs.column_status": "Stato",
    "listing_configs.column_listing_id": "ID annuncio",
    "listing_configs.column_listing_status": "Stato annuncio",
    "listing_configs.column_accounts": "Account",
    "listing_configs.column_currency": "Valuta",
    "listing_configs.column_sold": "Venduto",
    "listing_configs.column_goal_amount": "Importo obiettivo",
    "Goal Amount": "Importo obiettivo",
    "listing_configs.column_width": "Larghezza",
    "listing_configs.column_height": "Altezza",
    "listing_configs.column_weight": "Peso",
    "listing_configs.column_volume": "Volume",
    "Volume": "Volume",
    "listing_configs.column_order_type": "Tipo di ordine",
    "Order Type": "Tipo di ordine",
    "navigation.apps_group": "App",
    "navigation.channels_group": "Canali",
    "navigation.manage_mini_apps": "Gestisci mini app",
    "Manage Mini Apps": "Gestisci mini app",
    "navigation.manage_channels": "Gestisci canali",
    "Manage Channels": "Gestisci canali",
    "listings.import.uploading": "Caricamento...",
    "listings.import.complete": "Importazione completata",
    "listings.import.error": "Errore: {message}",
    "Error: {message}": "Errore: {message}",
    "listings.import.file_label": "File:",
    "listings.import.select_file": "Seleziona file",
    "listings.import.response": "Risposta importazione",
    "Import response": "Risposta importazione",
    "listings.import.total_rows": "Righe totali:",
    "Total rows:": "Righe totali:",
    "listings.import.total_imported": "Totale importato:",
    "Total imported:": "Totale importato:",
    "listings.import.download_template": "Scarica modello annunci",
    "Download listings template": "Scarica modello annunci",
    "common.upload": "Carica",
    "common.kanban_unavailable": "La vista bacheca è temporaneamente non disponibile",
    "Board view is temporarily unavailable": "La vista bacheca è temporaneamente non disponibile",
    "common.retry": "Riprova",
    "Retry": "Riprova",
    "listings.digital_assets.title": "Risorse digitali",
    "Digital assets": "Risorse digitali",
    "listings.digital_assets.not_found": "Risorse digitali non trovate",
    "Digital assets not found": "Risorse digitali non trovate",
    "listings.addon.saved": "Componente aggiuntivo salvato.",
    "Add-on saved successfully.": "Componente aggiuntivo salvato.",
    "listings.addon.title_required": "Inserisci un titolo.",
    "Please enter a title.": "Inserisci un titolo.",
    "listings.addon.price_required": "Inserisci un prezzo.",
    "Please enter a price.": "Inserisci un prezzo.",
    "listings.addon.no_media": "Non hai file multimediali.",
    "listings.addon.price": "Prezzo",
    "listings.addon.offer_percentage": "Percentuale offerta",
    "Offer Percentage": "Percentuale offerta",
    "listings.addon.maximum_quantity": "Quantità massima",
    "Maximum Quantity": "Quantità massima",
    "listings.addon.stock": "Scorte",
    "listings.addon.enter_price": "Inserisci il prezzo",
    "Enter price": "Inserisci il prezzo",
    "listings.addon.enter_offer_percentage": "Inserisci la percentuale di offerta",
    "Enter offer percentage": "Inserisci la percentuale di offerta",
    "listings.addon.enter_maximum_quantity": "Inserisci la quantità massima",
    "Enter maximum quantity": "Inserisci la quantità massima",
    "listings.addon.enter_stock": "Inserisci le scorte",
    "listings.addon.edit_title": "Modifica componente aggiuntivo",
    "Edit Add-on": "Modifica componente aggiuntivo",
    "listings.addon.add_title": "Aggiungi componente aggiuntivo",
    "Add Add-on": "Aggiungi componente aggiuntivo",
    "listings.addon.title": "Titolo",
    "listings.addon.enter_title": "Inserisci il titolo",
    "listings.addon.status": "Stato (Inattivo / Attivo)",
    "listings.addon.upload_media": "Carica contenuti multimediali",
    "attributes.prefill_for": "Precompila per",
    "Prefill for": "Precompila per",
    "attributes.first_item": "Primo elemento",
    "First Item": "Primo elemento",
    "attributes.all_items": "Tutti gli elementi",
    "All Items": "Tutti gli elementi",
    "common.uploading": "Caricamento...",
    "common.uploading_named": "Caricamento di {title}",
    "Uploading {title}": "Caricamento di {title}",
    "common.please_wait_short": "Attendi",
    "Please wait": "Attendi",
    "attributes.select_option": "Seleziona",
    "attributes.select_value": "Seleziona un valore...",
    "Select value...": "Seleziona un valore...",
    "attributes.type_placeholder": "Inserisci {name}",
    "Type {name}": "Inserisci {name}",
    "attributes.multiple_values_placeholder": "Puoi inserire più valori separandoli con una virgola.",
    "Using a comma, you can enter several values.": "Puoi inserire più valori separandoli con una virgola.",
    "attributes.upload_attachment": "Carica allegato",
    "Upload Attachment": "Carica allegato",
    "attributes.upload_json_file": "Carica file JSON",
    "Upload JSON File": "Carica file JSON",
    "attributes.copied_value": "Valore copiato",
    "Copied the value": "Valore copiato",
    "attributes.latitude_longitude_placeholder": "Inserisci latitudine,longitudine (es. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Inserisci latitudine,longitudine (es. 12.34,56.78)",
    "navigation.sidebar_label": "Barra laterale",
    "Side bar": "Barra laterale",
    "checkout_settings.orders_option_0": "Calendario ordini",
    "Orders Calendar View": "Calendario ordini",
    "checkout_settings.show_cart_attributes": "Mostra attributi del carrello",
    "Show cart attributes": "Mostra attributi del carrello",
    "checkout_settings.select_order_status": "Seleziona lo stato dell’ordine",
    "Select order status": "Seleziona lo stato dell’ordine",
    "checkout_settings.order_status_0": "Inserito correttamente",
    "Placed success": "Inserito correttamente",
    "checkout_settings.order_status_1": "In elaborazione",
    "In process": "In elaborazione",
    "checkout_settings.order_status_2": "Spedito",
    "checkout_settings.order_status_3": "Consegnato",
    "checkout_settings.order_status_4": "Completato",
    "listing_form.no_categories_found": "Nessuna categoria trovata. Usa “{action}” qui sopra.",
    "No categories found. Use “{action}” above.": "Nessuna categoria trovata. Usa “{action}” qui sopra.",
    "common.learn_more": "Scopri di più",
    "Learn more": "Scopri di più",
    "common.show_information": "Mostra informazioni",
    "Show information": "Mostra informazioni",
    "common.paid_feature": "Funzionalità a pagamento",
    "Paid Feature": "Funzionalità a pagamento",
    "common.learn_more_about": "Scopri di più su",
    "Learn more about": "Scopri di più su",
    "attributes.categories": "Categorie",
    "attributes.edit_bulk_title": "Modifica in blocco {title}",
    "{title} Edit Bulk": "Modifica in blocco {title}",
    "common.enter_description": "Inserisci una descrizione",
    "common.empty_fetch_message": "Non c’è ancora nulla da mostrare. Quando sarà disponibile, apparirà in questa pagina.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Non c’è ancora nulla da mostrare. Quando sarà disponibile, apparirà in questa pagina.",
    "common.ai_credits_and_top_up": "Crediti AI e ricarica",
    "AI credits and top up": "Crediti AI e ricarica",
    "common.ai_credits_loading": "Caricamento crediti AI",
    "Loading AI credits": "Caricamento crediti AI",
    "common.ai_credits_unavailable": "Crediti AI non disponibili",
    "AI credits unavailable": "Crediti AI non disponibili",
    "common.ai_credits_available": "Crediti AI disponibili: {count}",
    "Available AI credits: {count}": "Crediti AI disponibili: {count}",
    "common.ai_credits_unavailable_top_up": "Crediti AI non disponibili: fai clic per ricaricare",
    "AI credits unavailable — click to top up": "Crediti AI non disponibili: fai clic per ricaricare",
    "common.ai_credits_available_top_up": "Crediti AI disponibili: {count}: fai clic per aggiungerne",
    "Available AI credits: {count} — click to add credits": "Crediti AI disponibili: {count}: fai clic per aggiungerne",
    "common.ai_credits_add": "Aggiungi crediti",
    "Add credits": "Aggiungi crediti",
    "navigation.switch_project": "Cambia progetto",
    "Switch Project": "Cambia progetto",
    "navigation.tenant_switch_failed": "Impossibile cambiare tenant. Riprova.",
    "Tenant switch failed. Please try again.": "Impossibile cambiare tenant. Riprova.",
    "navigation.select_project": "Seleziona progetto",
    "Select Project": "Seleziona progetto",
    "navigation.collapse_sidebar": "Comprimi barra laterale",
    "Collapse sidebar": "Comprimi barra laterale",
    "navigation.expand_sidebar": "Espandi barra laterale",
    "Expand sidebar": "Espandi barra laterale",
    "navigation.search": "Cerca",
    "navigation.loading": "Caricamento navigazione",
    "Loading navigation": "Caricamento navigazione",
    "navigation.help_documentation": "Documentazione",
    "navigation.help_community": "Community",
    "navigation.help_api_reference": "Riferimento API",
    "listings.quick_form": "Modulo rapido",
    "Quick Form": "Modulo rapido",
    "payments.notification_secret": "Segreto notifiche",
    "Notification Secret": "Segreto notifiche",
    "payments.user_type": "Tipo utente",
    "User Type": "Tipo utente",
    "payments.category_id": "ID categoria",
    "app_customization.other_settings": "Altre impostazioni",
    "Other Settings": "Altre impostazioni",
    "app_customization.other_hide_balances": "Nascondi saldi e pagamenti nella sezione Altro",
    "app_customization.other_enable_logs": "Abilita registri",
    "Enable logs": "Abilita registri",
    "app_customization.other_signup_first": "Ottieni prima la registrazione",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Immagine selezionata",
    "Selected image": "Immagine selezionata",
    "common.ai_no_response_to_copy": "Nessuna risposta da copiare",
    "No response to copy": "Nessuna risposta da copiare",
    "common.copied_to_clipboard": "Copiato negli appunti",
    "Copied to clipboard": "Copiato negli appunti",
    "common.ai_suggestions": "Suggerimenti",
    "Suggestions": "Suggerimenti",
    "common.regenerate": "Rigenera",
    "Regenerate": "Rigenera",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "Icona JSON",
    "JSON icon": "Icona JSON",
    "collections.generator_title": "Generatore raccolte",
    "Collection Generator": "Generatore raccolte",
    "collections.generator_create": "Crea raccolta",
    "collections.generator_json_placeholder": "Inserisci input JSON",
    "Enter JSON input": "Inserisci input JSON",
    "collections.generator_invalid_data": "Inserisci dati validi",
    "Please enter valid data": "Inserisci dati validi",
    "category.editor_select_from_media": "Seleziona dai contenuti multimediali",
    "payments.subscription": "Abbonamento",
    "payments.subscription_setting_up": "Configurazione...",
    "Setting up...": "Configurazione...",
    "payments.subscription_webhook_configured": "Webhook abbonamento configurato",
    "Subscription webhook configured": "Webhook abbonamento configurato",
    "payments.subscription_retry_setup": "Riprova configurazione",
    "Retry setup": "Riprova configurazione",
    "payments.setup_subscription_webhook": "Configura webhook abbonamento",
    "Setup Subscription Webhook": "Configura webhook abbonamento",
    "orders.shipment_number": "Spedizione {number}",
    "Shipment {number}": "Spedizione {number}",
    "orders.quantity_short": "QTÀ",
    "orders.shipment_status_1": "Spedizione creata",
    "orders.shipment_status_2": "Spedizione in corso",
    "orders.shipment_status_3": "Spedito",
    "orders.shipment_status_4": "Pronto per il ritiro",
    "orders.shipment_status_5": "In consegna",
    "orders.shipment_status_6": "Reso per mancata consegna",
    "orders.shipment_status_7": "Spedizione consegnata",
    "orders.shipment_status_8": "Consegna della spedizione confermata",
    "orders.shipment_status_9": "Reso avviato",
    "orders.shipment_status_10": "Restituito per il ritiro",
    "orders.shipment_status_11": "Reso della spedizione confermato",
    "orders.shipment_status_12": "Annullato dal venditore",
    "orders.shipment_status_13": "Annullato dal cliente",
    "orders.shipment_status_14": "Arrivato presso il cliente",
    "orders.shipment_status_15": "Annullato dall’amministratore",
    "attributes.metadata_title": "Metadati",
    "Metadata": "Metadati",
    "common.add_row": "Aggiungi riga",
    "common.no_access": "Non hai accesso",
    "You don't have access": "Non hai accesso",
    "common.error_404_message": "La pagina che stai cercando non è al momento disponibile. Controlla l’URL e riprova, oppure torna più tardi. Se il problema persiste, contatta l’assistenza.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "La pagina che stai cercando non è al momento disponibile. Controlla l’URL e riprova, oppure torna più tardi. Se il problema persiste, contatta l’assistenza.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "Direzione della transazione",
    "Transaction direction": "Direzione della transazione",
    "category.default_text": "Testo predefinito",
    "collections.generator_open": "Apri generatore raccolte",
    "Open collection generator": "Apri generatore raccolte",
    "collections.duplicate_success": "Raccolta duplicata correttamente",
    "Collection duplicated successfully": "Raccolta duplicata correttamente",
    "collections.duplicate_failed": "Impossibile duplicare la raccolta",
    "Failed to duplicate collection": "Impossibile duplicare la raccolta",
    "listings.name_required": "Il nome dell’annuncio è obbligatorio",
    "Listing Name is required": "Il nome dell’annuncio è obbligatorio",
    "listings.category_required": "La categoria è obbligatoria",
    "Category is required": "La categoria è obbligatoria",
    "attribute_groups.edit_title": "Modifica gruppo attributi",
    "Edit Attribute Group": "Modifica gruppo attributi",
    "orders.create_order.validation.select_shipping_method": "Seleziona il metodo di spedizione",
    "Please select shipping method": "Seleziona il metodo di spedizione",
    "orders.create_order.validation.shipping_method_error": "Errore metodo di spedizione",
    "Shipping Method Error": "Errore metodo di spedizione",
    "orders.create_order.validation.select_shipping_address": "Seleziona l’indirizzo di spedizione",
    "Please select shipping address": "Seleziona l’indirizzo di spedizione",
    "orders.create_order.validation.shipping_address_error": "Errore indirizzo di spedizione",
    "Shipping Address Error": "Errore indirizzo di spedizione",
    "orders.create_order.validation.select_shipment_method": "Seleziona il metodo di spedizione",
    "Please select shipment method": "Seleziona il metodo di spedizione",
    "orders.create_order.validation.shipment_method_error": "Errore metodo di spedizione",
    "Shipment Method Error": "Errore metodo di spedizione",
    "orders.create_order.validation.select_payment_method": "Seleziona il metodo di pagamento",
    "Please select payment method": "Seleziona il metodo di pagamento",
    "orders.create_order.validation.payment_method_error": "Errore metodo di pagamento",
    "Payment Method Error": "Errore metodo di pagamento",
    "orders.create_order.validation.insufficient_balance": "Saldo insufficiente",
    "Insufficient balance": "Saldo insufficiente",
    "orders.create_order.validation.wallet_error": "Errore portafoglio",
    "Wallet Error": "Errore portafoglio",
    "attributes.value.preview_item": "Anteprima {count}",
    "Preview {count}": "Anteprima {count}",
    "attributes.value.click_to_upload": "Fai clic per caricare {type}",
    "Click to upload {type}": "Fai clic per caricare {type}",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF fino a 5 file",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF fino a 5 file",
    "attributes.value.audio_upload_formats": "MP3, WAV fino a 1 file",
    "MP3, WAV up to 1 file": "MP3, WAV fino a 1 file",
    "attributes.value.video_upload_formats": "MP4, MOV fino a 1 file",
    "MP4, MOV up to 1 file": "MP4, MOV fino a 1 file",
    "attributes.value.upload_limit": "Carica file {type} (max {count})",
    "Upload {type} files (Max {count})": "Carica file {type} (max {count})",
    "attributes.value.json_format_failed": "JSON non valido: impossibile formattare",
    "Invalid JSON - cannot format": "JSON non valido: impossibile formattare",
    "attributes.value.json_file_invalid": "Seleziona un file JSON valido",
    "Please select a valid JSON file": "Seleziona un file JSON valido",
    "attributes.value.file_empty": "Il file è vuoto",
    "File is empty": "Il file è vuoto",
    "attributes.value.json_file_parse_failed": "File JSON non valido: {message}",
    "Invalid JSON file: {message}": "File JSON non valido: {message}",
    "attributes.value.file_read_failed": "Impossibile leggere il file",
    "Failed to read file": "Impossibile leggere il file",
    "attributes.value.invalid_json": "JSON non valido",
    "Invalid JSON": "JSON non valido",
    "attributes.value.json_editor_help": "Carica un file JSON oppure digita/incolla direttamente il JSON",
    "Upload a JSON file or type/paste JSON directly": "Carica un file JSON oppure digita/incolla direttamente il JSON",
    "attributes.value.hex_color_code": "Codice colore esadecimale",
    "Hex Color Code": "Codice colore esadecimale",
    "attributes.value.multi_text_placeholder": "Digita e premi Invio o la virgola per aggiungere",
    "Type and press Enter or comma to add": "Digita e premi Invio o la virgola per aggiungere",
    "attributes.value.multi_text_help": "Premi Invio o la virgola per aggiungere ogni elemento",
    "Press Enter or comma to add each item": "Premi Invio o la virgola per aggiungere ogni elemento",
    "attributes.value.item_count": "{count} elemento",
    "{count} item": "{count} elemento",
    "attributes.value.items_count": "{count} elementi",
    "attributes.value.search_options": "Cerca {name}...",
    "Search {name}...": "Cerca {name}...",
    "attributes.value.selected_count": "{count} selezionati",
    "attributes.value.no_options_found": "Nessuna opzione trovata",
    "No options found": "Nessuna opzione trovata",
    "attributes.value.select_named_option": "Seleziona {name}",
    "Select {name}": "Seleziona {name}",
    "attributes.value.enable_option": "Abilita questa opzione",
    "Enable this option": "Abilita questa opzione",
    "attributes.value.enter_named_value": "Inserisci {name}",
    "Enter {name}": "Inserisci {name}",
    "common.valid": "Valido",
    "Valid": "Valido",
    "common.invalid": "Non valido",
    "Invalid": "Non valido",
    "common.go_back_home": "Torna alla home",
    "Go back home": "Torna alla home",
    "attributes.value.enter_named_text": "Inserisci {name}...",
    "Enter {name}...": "Inserisci {name}...",
    "listings.analytics.page_views": "Visualizzazioni pagina",
    "listings.analytics.unique_visitors": "Visitatori unici",
    "listings.analytics.sessions": "Sessioni",
    "listings.analytics.clicks": "Clic",
    "listings.analytics.goals": "Obiettivi",
    "listings.analytics.bot_views": "Visualizzazioni bot",
    "listings.detail_summary.buyers": "Acquirenti",
    "Buyers": "Acquirenti",
    "listings.detail_summary.orders": "Ordini",
    "listings.detail_summary.revenue": "Ricavi",
    "listings.detail_summary.average_order": "Ordine medio",
    "listings.add_advanced": "Avanzate",
    "listings.add_audio": "Aggiungi audio",
    "Add Audio": "Aggiungi audio",
    "payments.updated_successfully": "Aggiornato correttamente",
    "Updated successfully": "Aggiornato correttamente",
    "users.deleted_successfully": "Utente eliminato",
    "User deleted successfully": "Utente eliminato",
    "users.deletion_failed": "Eliminazione utente non riuscita",
    "User deletion failed": "Eliminazione utente non riuscita",
    "accounts.flow.title": "Definisci l’esperienza degli account",
    "Shape the account experience": "Definisci l’esperienza degli account",
    "accounts.flow.description": "Organizza i tipi di account e definisci le informazioni necessarie per ciascuno.",
    "Organize account types and define the information each account needs.": "Organizza i tipi di account e definisci le informazioni necessarie per ciascuno.",
    "accounts.flow.lane_title": "Fondamenta degli account",
    "Account foundation": "Fondamenta degli account",
    "accounts.flow.badge": "Struttura",
    "Structure": "Struttura",
    "accounts.flow.node_accounts": "Account",
    "accounts.flow.node_categories": "Categorie",
    "accounts.flow.node_attributes": "Attributi",
    "accounts.flow.lane_description": "Assegna a ogni account un posto, un tipo e dettagli utili.",
    "Give every account a clear place, type, and set of useful details.": "Assegna a ogni account un posto, un tipo e dettagli utili.",
    "accounts.flow.primary_action": "Aggiungi il primo account",
    "Add your first account": "Aggiungi il primo account",
    "listings.flow.title": "Crea il catalogo dei tuoi annunci",
    "Build your listing catalog": "Crea il catalogo dei tuoi annunci",
    "listings.flow.description": "Crea un catalogo strutturato con categorie, attributi e varianti.",
    "Create a structured catalog with categories, attributes, and variants.": "Crea un catalogo strutturato con categorie, attributi e varianti.",
    "listings.flow.lane_title": "Percorso catalogo",
    "Catalog path": "Percorso catalogo",
    "listings.flow.badge": "Crea",
    "Build": "Crea",
    "listings.flow.node_listings": "Annunci",
    "listings.flow.node_categories": "Categorie",
    "listings.flow.node_attributes": "Attributi",
    "listings.flow.node_variants": "Varianti",
    "listings.flow.lane_description": "Definisci cosa vendi e quali informazioni servono ai clienti per scegliere.",
    "Define what you sell and the information customers need to make a choice.": "Definisci cosa vendi e quali informazioni servono ai clienti per scegliere.",
    "listings.flow.primary_action": "Aggiungi il primo annuncio",
    "Add your first listing": "Aggiungi il primo annuncio",
    "collections.flow.title": "Riunisci i contenuti del marketplace",
    "Bring your marketplace content together": "Riunisci i contenuti del marketplace",
    "collections.flow.description": "Raggruppa annunci e account in raccolte curate, facili da trovare e gestire.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "Raggruppa annunci e account in raccolte curate, facili da trovare e gestire.",
    "collections.flow.lane_title": "Percorso raccolta",
    "Collection path": "Percorso raccolta",
    "collections.flow.badge": "Seleziona",
    "Curate": "Seleziona",
    "collections.flow.node_collections": "Raccolte",
    "collections.flow.node_rules": "Regole",
    "collections.flow.node_listings": "Annunci",
    "collections.flow.lane_description": "Scegli cosa riunire e rendilo facile da trovare per i clienti.",
    "Choose what belongs together and make it easy for customers to find.": "Scegli cosa riunire e rendilo facile da trovare per i clienti.",
    "collections.flow.audience_lane_title": "Percorso pubblico",
    "Audience path": "Percorso pubblico",
    "collections.flow.audience_badge": "Collega",
    "collections.flow.node_accounts": "Account",
    "collections.flow.node_users": "Utenti",
    "collections.flow.node_storefront": "Vetrina",
    "Storefront": "Vetrina",
    "collections.flow.audience_description": "Collega i contenuti selezionati alle persone e alle vetrine a cui sono destinati.",
    "Connect curated content to the people and storefronts it is meant for.": "Collega i contenuti selezionati alle persone e alle vetrine a cui sono destinati.",
    "collections.flow.primary_action": "Crea la prima raccolta",
    "listings.addon.image_limit": "Non puoi selezionare altre immagini",
    "listings.schedule.start_time_before_end": "L’ora di inizio deve precedere quella di fine",
    "Start time must be before the end time": "L’ora di inizio deve precedere quella di fine",
    "listings.schedule.end_time_after_start": "L’ora di fine deve essere successiva a quella di inizio",
    "End time must be after the start time": "L’ora di fine deve essere successiva a quella di inizio",
    "listings.schedule.repeat_required": "Seleziona una ripetizione",
    "Select a repeat pattern": "Seleziona una ripetizione",
    "listing_variants.form.select_type": "Seleziona il tipo di variante",
    "Select variant type": "Seleziona il tipo di variante",
    "listing_variants.form.select_type_values": "Seleziona i valori della variante",
    "Select variant values": "Seleziona i valori della variante",
    "listing_variants.form.add_variant": "Aggiungi variante",
    "listing_variants.form.edit_variant": "Modifica variante",
    "Edit variant": "Modifica variante",
    "listing_variants.form.variant_type": "Tipo di variante",
    "Variant type": "Tipo di variante",
    "listing_variants.form.variant_type_value": "Valore variante",
    "Variant value": "Valore variante",
    "listing_variants.form.variant_name": "Nome variante",
    "Variant name": "Nome variante",
    "listing_variants.form.description_placeholder": "Inserisci una descrizione",
    "rewards.item_archived": "Archiviato",
    "listings.confirm_delete_variant": "Vuoi eliminare questa variante?",
    "listings.confirm_delete_listing": "Vuoi eliminare questo annuncio?",
    "listing_form.digital_delete_confirm": "Vuoi eliminare questo contenuto digitale?",
    "Are you sure you want to delete this digital content?": "Vuoi eliminare questo contenuto digitale?",
    "category.confirm_delete_attribute": "Vuoi eliminare questo attributo?",
    "common.permission_required": "Non hai l’autorizzazione per eseguire questa azione.",
    "You do not have permission to perform this action.": "Non hai l’autorizzazione per eseguire questa azione.",
    "common.copied": "Copiato",
    "attributes.editor_name_required": "Inserisci il nome dell’attributo",
    "onboarding.full_step.setup_payments.description": "Abilita le transazioni reali affinché gli utenti possano completare gli acquisti senza difficoltà.",
    "Enable real transactions so users can complete intent without friction.": "Abilita le transazioni reali affinché gli utenti possano completare gli acquisti senza difficoltà.",
    "onboarding.full_step.setup_payments.cta": "Configura i pagamenti",
    "Setup payments": "Configura i pagamenti",
    "onboarding.full_step.setup_payments.impact": "Percorso verso i ricavi abilitato.",
    "Revenue path enabled.": "Percorso verso i ricavi abilitato.",
    "onboarding.full_step.setup_payments.creator_description": "Prepara il percorso affinché il tuo pubblico possa acquistare o sostenere il tuo lavoro.",
    "Prepare the path for your audience to purchase or support your work.": "Prepara il percorso affinché il tuo pubblico possa acquistare o sostenere il tuo lavoro.",
    "onboarding.full_step.setup_delivery.description": "Definisci come verrà evaso l’ordine, così il checkout sarà chiaro per gli utenti.",
    "onboarding.full_step.setup_delivery.impact": "Percorso di evasione definito.",
    "Fulfillment path clear.": "Percorso di evasione definito.",
    "onboarding.full_step.add_promotion.description": "Crea la tua prima promozione per aumentare le conversioni alla prima visita.",
    "Create your first promotion to increase first-session action rate.": "Crea la tua prima promozione per aumentare le conversioni alla prima visita.",
    "onboarding.full_step.add_promotion.impact": "Conversione più efficace al lancio.",
    "Stronger conversion during launch.": "Conversione più efficace al lancio.",
    "onboarding.full_step.create_coupon.description": "Prova gli sconti e migliora l’attivazione dei nuovi acquirenti o membri.",
    "Test discounts and improve activation for first-time buyers or members.": "Prova gli sconti e migliora l’attivazione dei nuovi acquirenti o membri.",
    "onboarding.full_step.create_coupon.impact": "Percorso della prima offerta attivato.",
    "First-offer loop unlocked.": "Percorso della prima offerta attivato.",
    "onboarding.full_step.collections_setup.description": "Raggruppa gli annunci più richiesti per migliorare la scoperta e la navigazione.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Raggruppa gli annunci più richiesti per migliorare la scoperta e la navigazione.",
    "onboarding.full_step.collections_setup.impact": "Navigazione e scoperta migliorate.",
    "Navigation and discovery improved.": "Navigazione e scoperta migliorate.",
    "onboarding.full_step.configure_comms.description": "Rendi pronte per la produzione le notifiche post-registrazione e ordine prima della crescita.",
    "Make post-signup and order notifications production-ready before growth.": "Rendi pronte per la produzione le notifiche post-registrazione e ordine prima della crescita.",
    "onboarding.full_step.configure_comms.impact": "Messaggi del ciclo di vita pronti.",
    "Lifecycle messaging ready.": "Messaggi del ciclo di vita pronti.",
    "onboarding.full_step.customize_attributes.description": "Aggiungi campi strutturati per consentire agli utenti di filtrare e confrontare ciò che conta.",
    "onboarding.full_step.customize_attributes.impact": "Ricerca e conversione migliorate.",
    "Better search and conversion.": "Ricerca e conversione migliorate.",
    "onboarding.full_step.customize_attributes.creator_description": "Aggiungi dettagli che aiutino le persone a comprendere e confrontare ciò che crei.",
    "Add the details that help people understand and compare what you create.": "Aggiungi dettagli che aiutino le persone a comprendere e confrontare ciò che crei.",
    "onboarding.full_step.add_digital_asset.description": "Amplia il catalogo iniziale affinché gli utenti possano valutare qualità e assortimento.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Amplia il catalogo iniziale affinché gli utenti possano valutare qualità e assortimento.",
    "onboarding.full_step.add_digital_asset.impact": "Credibilità del catalogo digitale migliorata.",
    "Digital catalog credibility improved.": "Credibilità del catalogo digitale migliorata.",
    "onboarding.full_step.open_live_site.description": "Parti da ciò che vedono i clienti: il prodotto diventa concreto prima di passare alla configurazione.",
    "onboarding.full_step.open_live_site.impact": "Conferma che il progetto è già online.",
    "onboarding.full_step.add_first_product.description": "Pubblica il primo prodotto, servizio o risorsa che vuoi far scoprire al tuo pubblico.",
    "Publish the first product, service, or resource you want your audience to discover.": "Pubblica il primo prodotto, servizio o risorsa che vuoi far scoprire al tuo pubblico.",
    "onboarding.full_step.add_first_product.impact": "Creata la prima offerta per il pubblico.",
    "Creates your first audience-ready offer.": "Creata la prima offerta per il pubblico.",
    "onboarding.full_step.customize_attributes.creator_impact": "La tua offerta è più facile da comprendere.",
    "Makes your offer easier to understand.": "La tua offerta è più facile da comprendere.",
    "onboarding.full_step.setup_payments.creator_impact": "Sblocca il percorso verso i ricavi.",
    "listings.detail_preview_fx.title": "Anteprima valute",
    "Preview FX": "Anteprima valute",
    "listings.detail_preview_fx.base": "Valuta base",
    "Base": "Valuta base",
    "listings.detail_preview_fx.description": "Visualizza questo annuncio in ogni valuta attiva.",
    "See this listing in each active currency.": "Visualizza questo annuncio in ogni valuta attiva.",
    "listings.detail_preview_fx.refresh": "Aggiorna anteprima",
    "Refresh preview": "Aggiorna anteprima",
    "listings.detail_preview_fx.loading_rates": "Caricamento tassi di cambio…",
    "Loading exchange rates…": "Caricamento tassi di cambio…",
    "listings.detail_preview_fx.load_hint": "Seleziona Anteprima valute per caricare i tassi aggiornati.",
    "Select Preview FX to load current rates.": "Seleziona Anteprima valute per caricare i tassi aggiornati.",
    "listings.detail_preview_fx.preview_note": "Solo anteprima. I prezzi salvati dell’annuncio restano invariati.",
    "Preview only. Saved listing prices remain unchanged.": "Solo anteprima. I prezzi salvati dell’annuncio restano invariati.",
    "listings.detail_preview_fx.listing": "Annuncio",
    "listings.detail_preview_fx.variant": "Variante",
    "Variant": "Variante",
    "listings.detail_event_booking.event_details": "Dettagli evento",
    "Event Details": "Dettagli evento",
    "listings.detail_event_booking.booking_details": "Dettagli prenotazione",
    "Booking Details": "Dettagli prenotazione",
    "listings.unassigned_location": "Posizione non assegnata",
    "Unassigned location": "Posizione non assegnata",
    "listings.no_ratings_yet": "Ancora nessuna valutazione",
    "No ratings yet": "Ancora nessuna valutazione",
    "listing_form.loading_listing": "Caricamento annuncio…",
    "Loading listing…": "Caricamento annuncio…",
    "listing_form.preparing_form": "Preparazione modulo…",
    "Preparing form…": "Preparazione modulo…",
    "listing_form.edit_listing": "Modifica annuncio",
    "Edit Listing": "Modifica annuncio",
    "listing_form.add_new_listing": "Aggiungi nuovo annuncio",
    "Add New Listing": "Aggiungi nuovo annuncio",
    "workspace.catalog.templates": "Modelli",
    "Templates": "Modelli",
    "workspace.catalog.integrations": "Integrazioni",
    "workspace.catalog.template": "Modello",
    "Template": "Modello",
    "workspace.catalog.integration": "Integrazione",
    "workspace.catalog.templates_heading": "Scegli un modello per avviare la tua idea",
    "Choose a template to kickstart your Idea": "Scegli un modello per avviare la tua idea",
    "workspace.catalog.integrations_heading": "Integrazioni per app web ospitate",
    "Integrations for Hosted Web Apps": "Integrazioni per app web ospitate",
    "workspace.catalog.templates_description": "Inizia con un modello predefinito per il tuo marketplace.",
    "Start with a prebuilt template and customise it for your marketplace.": "Inizia con un modello predefinito per il tuo marketplace.",
    "workspace.catalog.integrations_description": "Collega lo spazio di lavoro agli strumenti e ai servizi che già usi.",
    "Connect your workspace to the tools and services you already use.": "Collega lo spazio di lavoro agli strumenti e ai servizi che già usi.",
    "workspace.catalog.no_templates": "Nessun modello disponibile al momento.",
    "No templates available at the moment.": "Nessun modello disponibile al momento.",
    "workspace.catalog.no_integrations": "Nessuna integrazione disponibile al momento.",
    "No integrations available at the moment.": "Nessuna integrazione disponibile al momento.",
    "workspace.catalog.coming_soon": "Prossimamente",
    "Coming Soon": "Prossimamente",
    "workspace.catalog.configure": "Configura",
    "workspace.catalog.custom_development": "Sviluppo personalizzato {type}",
    "Custom {type} Development": "Sviluppo personalizzato {type}",
    "workspace.catalog.custom_help": "Cerchi una soluzione personalizzata? Contattaci per un preventivo.",
    "Looking for something custom? Contact us for a quote.": "Cerchi una soluzione personalizzata? Contattaci per un preventivo.",
    "workspace.catalog.contact_quote": "Contatta per un preventivo",
    "Contact for a Quote": "Contatta per un preventivo",
    "users.select_user": "Seleziona utente",
    "Select User": "Seleziona utente",
    "developer.api_keys.paid_feature_title": "L’accesso API è una funzionalità a pagamento",
    "API access is a paid feature": "L’accesso API è una funzionalità a pagamento",
    "developer.api_keys.paid_feature_description": "Scegli un piano a pagamento per visualizzare, copiare e usare le chiavi Publishable e Secret.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Scegli un piano a pagamento per visualizzare, copiare e usare le chiavi Publishable e Secret.",
    "developer.api_keys.available_on_paid_plans": "Disponibile nei piani a pagamento",
    "Available on paid plans": "Disponibile nei piani a pagamento",
    "developer.api_keys.view_plans": "Visualizza piani",
    "currency.rates.title": "Tassi di cambio attuali",
    "Current FX rates": "Tassi di cambio attuali",
    "currency.rates.base": "Valuta base:",
    "Base:": "Valuta base:",
    "currency.rates.source": "· Fonte:",
    "· Source:": "· Fonte:",
    "currency.rates.cached_up_to": "Memorizzato fino a {hours} h",
    "Cached up to {hours}h": "Memorizzato fino a {hours} h",
    "currency.rates.refresh": "Aggiorna tassi",
    "Refresh rates": "Aggiorna tassi",
    "currency.rates.currency": "Valuta",
    "currency.rates.one_base_equals": "1 {code} equivale a",
    "1 {code} equals": "1 {code} equivale a",
    "currency.rates.empty": "Aggiungi una valuta attiva per visualizzarne il tasso.",
    "Add an active currency to see its exchange rate.": "Aggiungi una valuta attiva per visualizzarne il tasso.",
    "currency.rates.manual": "Tassi manuali",
    "Manual rates": "Tassi manuali",
    "currency.rates.load_error": "Impossibile caricare i tassi di cambio.",
    "Unable to load exchange rates.": "Impossibile caricare i tassi di cambio.",
    "chats.title": "Chat clienti",
    "Customer chat": "Chat clienti",
    "chats.conversations": "Conversazioni",
    "Conversations": "Conversazioni",
    "chats.empty_conversations": "Ancora nessuna conversazione con i clienti.",
    "No customer conversations yet.": "Ancora nessuna conversazione con i clienti.",
    "chats.customer_id": "Cliente {id}",
    "Customer {id}": "Cliente {id}",
    "chats.no_messages_yet": "Ancora nessun messaggio",
    "No messages yet": "Ancora nessun messaggio",
    "chats.conversation_id": "Conversazione n. {id}",
    "Conversation #{id}": "Conversazione n. {id}",
    "chats.status.closed": "chiusa",
    "closed": "chiusa",
    "chats.status.open": "aperta",
    "chats.reopen": "Riapri",
    "Reopen": "Riapri",
    "chats.close_conversation": "Chiudi conversazione",
    "Close conversation": "Chiudi conversazione",
    "chats.your_team": "Il tuo team",
    "Your team": "Il tuo team",
    "chats.empty_messages": "Non ci sono ancora messaggi in questa conversazione.",
    "No messages in this conversation yet.": "Non ci sono ancora messaggi in questa conversazione.",
    "chats.write_reply": "Scrivi una risposta",
    "Write a reply": "Scrivi una risposta",
    "chats.send": "Invia",
    "Send": "Invia",
    "chats.select_conversation": "Seleziona una conversazione per visualizzarne i messaggi.",
    "Select a conversation to view its messages.": "Seleziona una conversazione per visualizzarne i messaggi.",
    "chats.error.session_not_ready": "La sessione non è pronta. Aggiorna la pagina e riprova.",
    "Your session is not ready. Refresh the page and try again.": "La sessione non è pronta. Aggiorna la pagina e riprova.",
    "chats.error.request_failed": "Richiesta chat non riuscita ({status})",
    "Chat request failed ({status})": "Richiesta chat non riuscita ({status})",
    "chats.error.load_conversations": "Impossibile caricare le conversazioni.",
    "Could not load conversations.": "Impossibile caricare le conversazioni.",
    "chats.error.load_messages": "Impossibile caricare i messaggi.",
    "Could not load messages.": "Impossibile caricare i messaggi.",
    "chats.error.send_message": "Impossibile inviare il messaggio.",
    "Message could not be sent.": "Impossibile inviare il messaggio.",
    "chats.error.update_status": "Impossibile aggiornare lo stato della conversazione.",
    "Conversation status could not be updated.": "Impossibile aggiornare lo stato della conversazione.",
    "accounts.select_account": "Seleziona account",
    "common.accounts": "Account",
    "common.listings": "Annunci",
    "communications.loading_preview": "Caricamento anteprima…",
    "Loading preview…": "Caricamento anteprima…",
    "communications.no_preview": "Nessuna anteprima",
    "No preview": "Nessuna anteprima",
    "collections.choose_type": "Scegli {type}",
    "Choose {type}": "Scegli {type}",
    "collections.create_type_category_first": "Crea prima la categoria {type}",
    "Create {type} category first": "Crea prima la categoria {type}",
    "web_config.customisation": "Personalizzazione web",
    "web_config.configuration": "Configurazione web",
    "Web Configuration": "Configurazione web",
    "web_config.section_general": "Generale",
    "web_config.section_social": "Social",
    "web_config.section_footer": "Piè di pagina",
    "web_config.assets": "Risorse",
    "Assets": "Risorse",
    "web_config.small_logo": "Logo piccolo",
    "Small logo": "Logo piccolo",
    "attributes.edit_attribute": "Modifica attributo",
    "currency.rate_managed_automatically": "Il tasso viene gestito automaticamente.",
    "Rate is managed automatically.": "Il tasso viene gestito automaticamente.",
    "navigation.add_or_manage_mini_apps": "Aggiungi o gestisci mini app",
    "Add or manage Mini Apps": "Aggiungi o gestisci mini app",
    "listings.import.download_type_template": "Scarica modello {type}",
    "navigation.promo_banner": "Sconto del {percent}% solo per i nuovi clienti! Usa il codice: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Sconto del {percent}% solo per i nuovi clienti! Usa il codice: {code}.",
    "orders.cash_refund_recorded": "Rimborso in contanti registrato. È stata accodata la rettifica contabile.",
    "Cash refund recorded. The accounting reversal has been queued.": "Rimborso in contanti registrato. È stata accodata la rettifica contabile.",
    "orders.cash_refund_failed": "Impossibile registrare il rimborso in contanti. Controlla lo stato del pagamento e la cronologia dei rimborsi.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Impossibile registrare il rimborso in contanti. Controlla lo stato del pagamento e la cronologia dei rimborsi.",
    "orders.recording_cash_refund": "Registrazione rimborso…",
    "Recording refund…": "Registrazione rimborso…",
    "orders.record_cash_refund": "Registra rimborso in contanti",
    "Record cash refund": "Registra rimborso in contanti",
    "orders.confirm_cash_refund": "Conferma rimborso in contanti",
    "Confirm cash refund": "Conferma rimborso in contanti",
    "orders.cash_refund_order_amount": "Registrare un rimborso completo in contanti di {amount} per l’ordine {reference}?",
    "Record a full cash refund of {amount} for order {reference}?": "Registrare un rimborso completo in contanti di {amount} per l’ordine {reference}?",
    "orders.cash_refund_manual_notice": "Registra un rimborso manuale COD/in contanti e accoda la rettifica contabile. Nessun provider di pagamento verrà contattato.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Registra un rimborso manuale COD/in contanti e accoda la rettifica contabile. Nessun provider di pagamento verrà contattato.",
    "currency_conversion.title": "Conversione valuta",
    "Currency conversion": "Conversione valuta",
    "currency_conversion.open_settings": "Impostazioni conversione",
    "Conversion settings": "Impostazioni conversione",
    "currency_conversion.load_failed": "Impossibile caricare le impostazioni di conversione valuta.",
    "Could not load currency conversion settings.": "Impossibile caricare le impostazioni di conversione valuta.",
    "currency_conversion.interval_error": "L’intervallo di aggiornamento deve essere compreso tra 5 minuti e 24 ore.",
    "Refresh interval must be between 5 minutes and 24 hours.": "L’intervallo di aggiornamento deve essere compreso tra 5 minuti e 24 ore.",
    "currency_conversion.save_failed": "Impossibile salvare le impostazioni di conversione valuta.",
    "Could not save currency conversion settings.": "Impossibile salvare le impostazioni di conversione valuta.",
    "currency_conversion.saved": "Impostazioni di conversione valuta salvate.",
    "Currency conversion settings saved.": "Impostazioni di conversione valuta salvate.",
    "currency_conversion.description": "Scegli come calcolare le conversioni valutarie visualizzate.",
    "Choose how displayed currency conversions are calculated.": "Scegli come calcolare le conversioni valutarie visualizzate.",
    "currency_conversion.manual_title": "Tassi manuali",
    "currency_conversion.manual_help": "Usa il tasso inserito qui sotto per ogni valuta.",
    "Use the exchange rate entered for each currency below.": "Usa il tasso inserito qui sotto per ogni valuta.",
    "currency_conversion.frankfurter_title": "Frankfurter (predefinito)",
    "Frankfurter (default)": "Frankfurter (predefinito)",
    "currency_conversion.frankfurter_help": "Tassi di cambio giornalieri gratuiti. Non è richiesta una chiave API del provider.",
    "Free daily exchange rates. No provider API key is required.": "Tassi di cambio giornalieri gratuiti. Non è richiesta una chiave API del provider.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Usa il servizio Fixer gestito dalla piattaforma. Gli aggiornamenti dei tassi dipendono dal piano del provider.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Usa il servizio Fixer gestito dalla piattaforma. Gli aggiornamenti dei tassi dipendono dal piano del provider.",
    "currency_conversion.refresh_interval": "Intervallo di aggiornamento del tasso (minuti)",
    "Rate re-check interval (minutes)": "Intervallo di aggiornamento del tasso (minuti)",
    "workspace.currency_search_code": "Cerca o seleziona",
    "Search or select": "Cerca o seleziona",
    "workspace.currency_preset_hint": "Sono stati applicati i valori predefiniti consigliati. Puoi modificare qualsiasi campo.",
    "Recommended defaults applied. You can edit any field.": "Sono stati applicati i valori predefiniti consigliati. Puoi modificare qualsiasi campo.",
    "developer.api_keys.copy_unavailable": "La chiave non è ancora disponibile.",
    "Key is not available yet.": "La chiave non è ancora disponibile.",
    "developer.api_keys.copy_failed": "Impossibile copiare la chiave. Riprova.",
    "Unable to copy the key. Try again.": "Impossibile copiare la chiave. Riprova.",
    "payroll.action.export_pdf": "Esporta PDF",
    "Export PDF": "Esporta PDF",
    "cms.category.name_prompt": "Nome categoria",
    "cms.field.cover_image": "Immagine di copertina",
    "Cover Image": "Immagine di copertina",
    "cms.action.add_cover_photo": "Aggiungi foto di copertina",
    "Add cover photo": "Aggiungi foto di copertina",
    "cms.field.category": "Categoria",
    "cms.category.none": "Nessuna categoria",
    "No category": "Nessuna categoria",
    "cms.advanced": "Avanzate",
    "media_picker.action.select_image": "Seleziona immagine",
    "Select image": "Seleziona immagine",
    "orders.confirm_record_cash_refund": "Registra rimborso",
    "Record refund": "Registra rimborso",
    "listing_form.no_repeat": "Nessuna ripetizione",
    "No repeat": "Nessuna ripetizione",
    "listing_form.custom_repeat_days": "Personalizzato: {days}",
    "Custom: {days}": "Personalizzato: {days}",
    "common.sending": "Invio…",
    "listings.detail.unique_name": "Nome univoco",
    "Unique Name": "Nome univoco",
    "app_customization.username": "Nome utente",
    "workspace.templates.name_required": "Il nome del modello è obbligatorio.",
    "Template name is required.": "Il nome del modello è obbligatorio.",
    "workspace.templates.saved": "Modello di ruolo salvato.",
    "Role template saved.": "Modello di ruolo salvato.",
    "workspace.templates.confirm_delete": "Eliminare il modello “{name}”?",
    "Delete template \"{name}\"?": "Eliminare il modello “{name}”?",
    "workspace.templates.deleted": "Modello eliminato.",
    "Template deleted.": "Modello eliminato.",
    "workspace.members.tab_members": "Membri",
    "workspace.templates.tab": "Modelli di ruolo",
    "Role Templates": "Modelli di ruolo",
    "workspace.templates.title": "Modelli di ruolo",
    "workspace.templates.new": "Nuovo modello",
    "New Template": "Nuovo modello",
    "workspace.templates.name": "Nome",
    "workspace.templates.empty": "Ancora nessun modello di ruolo.",
    "No role templates yet.": "Ancora nessun modello di ruolo.",
    "workspace.templates.edit": "Modifica modello",
    "Edit Template": "Modifica modello",
    "workspace.templates.name_label": "Nome modello",
    "Template name": "Nome modello",
    "workspace.templates.name_placeholder": "ad es. Content Manager",
    "e.g. Content Manager": "ad es. Content Manager",
    "listings.import.unknown_error": "Impossibile importare le categorie. Controlla il CSV e riprova.",
    "The categories could not be imported. Please check the CSV and try again.": "Impossibile importare le categorie. Controlla il CSV e riprova.",
    "common.no_access_to_page": "Nessun accesso",
    "No access": "Nessun accesso",
    "common.permission_to_view_page_denied": "Non hai l’autorizzazione per visualizzare questa pagina.",
    "You do not have permission to view this page.": "Non hai l’autorizzazione per visualizzare questa pagina.",
    "common.loading_permissions": "Caricamento autorizzazioni…",
    "Loading permissions…": "Caricamento autorizzazioni…",
    "attributes.added_successfully": "Ottimo 🎉, attributi aggiunti correttamente",
    "Nice 🎉, Successfully added attributes": "Ottimo 🎉, attributi aggiunti correttamente",
    "attributes.add_attribute_values": "Aggiungi valori attributo",
    "attributes.attribute": "Attributo",
    "attributes.optional": "Facoltativo",
    "attributes.private": "Privato",
    "attributes.hidden_field": "Campo nascosto",
    "attributes.show_in_filter": "Mostra nel filtro",
    "attributes.status_not_active_active": "Stato (Non attivo / Attivo)",
    "attributes.add_metadata": "Aggiungi metadati",
    "Add metadata": "Aggiungi metadati",
    "attributes.select_date_time": "Seleziona data e ora",
    "listings.addons.column_title": "Titolo",
    "listings.addons.column_image": "Immagine",
    "listings.addons.column_price": "Prezzo",
    "listings.addons.column_max_quantity": "Quantità massima",
    "Max Quantity": "Quantità massima",
    "listings.addons.column_offer": "Offerta",
    "listings.addons.column_stock": "Scorte",
    "listings.addons.column_action": "Azione",
    "listings.addons.column_status": "Stato",
    "listings.addons.confirm_delete": "Vuoi eliminare questo tipo di componente aggiuntivo?",
    "Do you want to delete this add-on type?": "Vuoi eliminare questo tipo di componente aggiuntivo?",
    "common.share_collection": "Condividi raccolta",
    "Share collection": "Condividi raccolta",
    "communications.view_modes": "Modalità di visualizzazione comunicazioni",
    "Communication view modes": "Modalità di visualizzazione comunicazioni",
    "payments.accessibility.gateway_logo": "Logo del gateway di pagamento",
    "Payment gateway logo": "Logo del gateway di pagamento",
    "common.build_version": "Versione build",
    "Build version": "Versione build",
    "common.build_label": "build",
    "build": "build",
    "listings.under_category_title": "Annunci nella categoria {category}",
    "Listings under {category}": "Annunci nella categoria {category}",
    "attributes.signup": "Registrazione",
    "Signup": "Registrazione",
    "common.toast.please_check_action": "Controlla questa azione",
    "Please check this action": "Controlla questa azione",
    "common.information": "Informazioni",
    "listing_form.error.load_listing_data": "Impossibile caricare i dati dell’annuncio",
    "Failed to load listing data": "Impossibile caricare i dati dell’annuncio",
    "listing_form.error.load_digital_contents": "Impossibile caricare i contenuti digitali",
    "Failed to load digital contents": "Impossibile caricare i contenuti digitali",
    "listing_form.validation.audio_file_or_url_required": "Aggiungi un file audio o un URL audio pubblico prima di creare l’episodio.",
    "Add an audio file or public audio URL before creating the episode.": "Aggiungi un file audio o un URL audio pubblico prima di creare l’episodio.",
    "listing_form.validation.rental_rate_greater_than_zero": "Inserisci una tariffa di noleggio maggiore di 0.",
    "Enter a rental rate greater than 0.": "Inserisci una tariffa di noleggio maggiore di 0.",
    "listing_form.validation.maximum_duration_gte_minimum": "La durata massima deve essere maggiore o uguale a quella minima.",
    "Maximum duration must be greater than or equal to minimum duration.": "La durata massima deve essere maggiore o uguale a quella minima.",
    "listing_form.updated_successfully": "Annuncio aggiornato correttamente!",
    "Listing updated successfully!": "Annuncio aggiornato correttamente!",
    "listing_form.created_successfully": "Annuncio creato correttamente!",
    "Listing created successfully!": "Annuncio creato correttamente!",
    "listing_form.error.save_failed": "Impossibile salvare l’annuncio. Riprova.",
    "Failed to save listing. Please try again.": "Impossibile salvare l’annuncio. Riprova.",
    "listing_form.error.delete_variant_failed": "Impossibile eliminare la variante: {title}",
    "Failed to delete variant: {title}": "Impossibile eliminare la variante: {title}",
    "listing_form.error.variant_action_failed": "Impossibile {action} la variante: {title}",
    "Failed to {action} variant: {title}": "Impossibile {action} la variante: {title}",
    "listing_form.error.digital_content_action_failed": "Impossibile {action} il contenuto digitale: {title}",
    "Failed to {action} digital content: {title}": "Impossibile {action} il contenuto digitale: {title}",
    "listing_form.action.create": "creare",
    "listing_form.action.update": "aggiornare",
    "listing_form.action.delete": "eliminare",
    "delete": "eliminare",
    "listing_form.error.save_request_failed": "Impossibile salvare l’annuncio",
    "Failed to save listing": "Impossibile salvare l’annuncio",
    "listing_form.error.rental_settings_save_failed": "Annuncio salvato, ma non è stato possibile salvare le impostazioni di noleggio.",
    "Listing saved, but rental settings could not be saved.": "Annuncio salvato, ma non è stato possibile salvare le impostazioni di noleggio.",
    "users.action_failed": "Azione non riuscita. Riprova.",
    "Action failed. Please try again.": "Azione non riuscita. Riprova.",
    "common.successfully_added": "Aggiunto correttamente",
    "Successfully added": "Aggiunto correttamente",
    "listing_form.validation.title_min_length": "Il titolo deve contenere almeno {count} caratteri",
    "Title must be at least {count} characters": "Il titolo deve contenere almeno {count} caratteri",
    "listing_form.validation.title_max_length": "Il titolo non deve superare {count} caratteri",
    "Title must not exceed {count} characters": "Il titolo non deve superare {count} caratteri",
    "listing_form.validation.price_minimum": "Il prezzo deve essere almeno {amount}",
    "Price must be at least {amount}": "Il prezzo deve essere almeno {amount}",
    "listing_form.validation.attribute_required": "{attribute} è obbligatorio",
    "listings.error.load_failed": "Impossibile caricare gli annunci",
    "Unable to load listings": "Impossibile caricare gli annunci",
    "communications.from_email_required_before_verification": "Inserisci l’indirizzo email mittente prima di verificare.",
    "Please enter From email address before verifying.": "Inserisci l’indirizzo email mittente prima di verificare.",
    "communications.verification_email_sent": "È stata inviata un’email di verifica. Controlla la posta in arrivo e segui le istruzioni per verificare questo indirizzo.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "È stata inviata un’email di verifica. Controlla la posta in arrivo e segui le istruzioni per verificare questo indirizzo.",
    "communications.verification_start_failed": "Impossibile avviare la verifica. Riprova.",
    "Unable to start verification. Please try again.": "Impossibile avviare la verifica. Riprova.",
    "common.uploaded_successfully": "Caricato con successo",
    "upgrade_page.panel.yearly": "Annuale",
    "upgrade_page.panel.monthly": "Mensile",
    "orders.advance_paid": "Acconto pagato",
    "Advance paid": "Acconto pagato",
    "orders.balance_due": "Saldo dovuto",
    "Balance due": "Saldo dovuto",
    "orders.advance_invalid": "Inserisci un importo inferiore al totale dell’ordine.",
    "Enter an amount less than the order total.": "Inserisci un importo inferiore al totale dell’ordine.",
    "orders.advance_failed": "Impossibile salvare l’acconto.",
    "Could not save the advance.": "Impossibile salvare l’acconto.",
    "orders.edit_advance": "Modifica acconto",
    "Edit advance": "Modifica acconto",
    "orders.record_advance": "Registra acconto",
    "Record advance": "Registra acconto",
    "orders.advance_notice": "L’importo già pagato dal cliente deve essere inferiore al totale dell’ordine di {total}. L’ordine resta non pagato finché non segni il saldo come pagato. Inserisci 0 per rimuovere l’acconto.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "L’importo già pagato dal cliente deve essere inferiore al totale dell’ordine di {total}. L’ordine resta non pagato finché non segni il saldo come pagato. Inserisci 0 per rimuovere l’acconto.",
    "orders.save_advance": "Salva",
    "common.hide": "Nascondi",
    "listings.repeat.daily": "Ogni giorno",
    "listings.repeat.weekdays": "Giorni feriali (lun-ven)",
    "Weekdays (Mon-Fri)": "Giorni feriali (lun-ven)",
    "listings.repeat.weekend": "Fine settimana (sab-dom)",
    "Weekend (Sat-Sun)": "Fine settimana (sab-dom)",
    "listings.repeat.custom": "Personalizzato",
    "listings.weekday.sun": "Dom",
    "Sun": "Dom",
    "listings.weekday.mon": "Lun",
    "Mon": "Lun",
    "listings.weekday.tue": "Mar",
    "Tue": "Mar",
    "listings.weekday.wed": "Mer",
    "Wed": "Mer",
    "listings.weekday.thu": "Gio",
    "Thu": "Gio",
    "listings.weekday.fri": "Ven",
    "Fri": "Ven",
    "listings.weekday.sat": "Sab",
    "Sat": "Sab",
    "orders.pay_balance": "Paga il saldo {amount}",
    "Pay balance {amount}": "Paga il saldo {amount}",
    "orders.partially_paid": "Pagato parzialmente",
    "Partially paid": "Pagato parzialmente",
    "orders.balance_amount": "Saldo {amount}",
    "Balance {amount}": "Saldo {amount}",
    "delivery.get_started.add_branch": "Aggiungi filiale",
    "Add branch": "Aggiungi filiale",
    "delivery.get_started.add_fleet": "Aggiungi flotta",
    "Add fleet": "Aggiungi flotta",
    "delivery.get_started.api_documentation": "Documentazione API",
    "API Documentation": "Documentazione API",
    "delivery.get_started.add_driver": "Aggiungi autista",
    "Add driver": "Aggiungi autista",
    "delivery.get_started.branch_title": "Aggiungi la tua filiale",
    "Add your branch": "Aggiungi la tua filiale",
    "delivery.get_started.branch_description": "Una filiale può avere più flotte e autisti",
    "A branch can have many fleets and drivers": "Una filiale può avere più flotte e autisti",
    "delivery.get_started.fleet_title": "Aggiungi la tua flotta",
    "Add your fleet": "Aggiungi la tua flotta",
    "delivery.get_started.fleet_description": "Una flotta può essere assegnata a un autista",
    "A fleet can be assigned to a driver": "Una flotta può essere assegnata a un autista",
    "delivery.get_started.driver_title": "Aggiungi il tuo autista",
    "Add your driver": "Aggiungi il tuo autista",
    "delivery.get_started.driver_description": "L’autista consegnerà il tuo ordine",
    "The driver will deliver your order": "L’autista consegnerà il tuo ordine",
    "delivery.get_started.order_title": "Crea il tuo primo ordine",
    "Create your first order": "Crea il tuo primo ordine",
    "delivery.get_started.order_description": "Gli ordini possono essere creati tramite API",
    "Orders can be created through the API": "Gli ordini possono essere creati tramite API",
    "delivery.get_started.progress.branches": "Filiali",
    "Branches": "Filiali",
    "delivery.get_started.progress.fleets": "Flotte",
    "Fleets": "Flotte",
    "delivery.get_started.progress.drivers": "Autisti",
    "Drivers": "Autisti",
    "delivery.get_started.progress.orders": "Ordini di consegna",
    "Delivery Orders": "Ordini di consegna",
    "delivery.get_started.welcome": "Benvenuto su",
    "Welcome to": "Benvenuto su",
    "delivery.get_started.question": "Cosa vuoi fare?",
    "What would you like to do?": "Cosa vuoi fare?",
    "workspace.templates.built_in": "Integrato",
    "Built-in": "Integrato",
    "workspace.templates.copy_of": "Copia di {name}",
    "Copy of {name}": "Copia di {name}",
    "workspace.members.role": "Ruolo",
    "Role": "Ruolo",
    "workspace.members.role_full_access": "Accesso completo",
    "Full access": "Accesso completo",
    "workspace.templates.duplicate": "Duplica",
    "workspace.members.role_custom": "Personalizzato (imposta sotto)",
    "Custom (set below)": "Personalizzato (imposta sotto)"
  },
  "tr": {
    "0": "0",
    "6100": "6100",
    "common.language": "Dil",
    "Language": "Dil",
    "common.english": "İngilizce",
    "English": "İngilizce",
    "common.french": "Fransızca",
    "French": "Fransızca",
    "common.arabic": "Arapça",
    "Arabic": "Arapça",
    "navigation.get_started": "Başlayın",
    "Get Started": "Başlayın",
    "navigation.dashboard": "Kontrol paneli",
    "navigation.orders": "Siparişler",
    "Orders": "Siparişler",
    "navigation.schedule": "Takvim",
    "navigation.accounts": "Hesaplar",
    "Accounts": "Hesaplar",
    "navigation.account_categories": "Hesap kategorileri",
    "Account Categories": "Hesap kategorileri",
    "navigation.account_attributes": "Hesap özellikleri",
    "Account Attributes": "Hesap özellikleri",
    "navigation.account_configuration": "Hesap yapılandırması",
    "Account Configuration": "Hesap yapılandırması",
    "navigation.agents": "Temsilciler",
    "Agents": "Temsilciler",
    "navigation.listings": "İlanlar",
    "Listings": "İlanlar",
    "navigation.categories": "Kategoriler",
    "Categories": "Kategoriler",
    "navigation.custom_attributes": "Özel özellikler",
    "Custom Attributes": "Özel özellikler",
    "navigation.variant_types": "Varyant türleri",
    "Variant Types": "Varyant türleri",
    "navigation.additional_features": "Ek özellikler",
    "Additional Features": "Ek özellikler",
    "navigation.reported_listings": "Bildirilen ilanlar",
    "Reported Listings": "Bildirilen ilanlar",
    "navigation.report_accounts": "Hesap bildirimleri",
    "Report Accounts": "Hesap bildirimleri",
    "navigation.users": "Kullanıcılar",
    "Users": "Kullanıcılar",
    "navigation.user_attributes": "Kullanıcı özellikleri",
    "User Attributes": "Kullanıcı özellikleri",
    "navigation.reviews_ratings": "Yorumlar ve puanlar",
    "Reviews & Ratings": "Yorumlar ve puanlar",
    "navigation.report": "Rapor",
    "Report": "Rapor",
    "navigation.reports": "Raporlar",
    "Reports": "Raporlar",
    "navigation.platform_health": "Platform sağlığı",
    "Platform Health": "Platform sağlığı",
    "navigation.promotions": "Kampanyalar",
    "navigation.collections": "Koleksiyonlar",
    "Collections": "Koleksiyonlar",
    "navigation.promotion_ads": "Tanıtım / reklamlar",
    "Promotion / Ads": "Tanıtım / reklamlar",
    "navigation.coupons": "Kuponlar",
    "Coupons": "Kuponlar",
    "navigation.finance": "Finans",
    "Finance": "Finans",
    "navigation.transactions": "İşlemler",
    "Transactions": "İşlemler",
    "navigation.settlement": "Mutabakat",
    "Settlement": "Mutabakat",
    "navigation.expenses": "Giderler",
    "navigation.recurring_payments": "Yinelenen ödemeler",
    "Recurring payments": "Yinelenen ödemeler",
    "navigation.media": "Medya",
    "Media": "Medya",
    "navigation.communication": "İletişim",
    "Communication": "İletişim",
    "navigation.web": "Web",
    "Web": "Web",
    "navigation.website_editor": "Web sitesi düzenleyicisi",
    "Website Editor": "Web sitesi düzenleyicisi",
    "navigation.change_templates": "Şablonları değiştir",
    "Change Templates": "Şablonları değiştir",
    "navigation.pages": "Sayfalar",
    "Pages": "Sayfalar",
    "navigation.blog": "Blog",
    "Blog": "Blog",
    "navigation.customise_texts": "Metinleri özelleştir",
    "Customise texts": "Metinleri özelleştir",
    "navigation.add_integrations": "Entegrasyon ekle",
    "Add Integrations": "Entegrasyon ekle",
    "navigation.domain": "Alan adı",
    "Domain": "Alan adı",
    "navigation.customise_seo": "SEO'yu özelleştir",
    "Customise SEO": "SEO'yu özelleştir",
    "navigation.app": "Uygulama",
    "App": "Uygulama",
    "navigation.apps": "Uygulamalar",
    "Apps": "Uygulamalar",
    "navigation.buy_app_templates": "Uygulama şablonlarını satın al",
    "Buy App Templates": "Uygulama şablonlarını satın al",
    "navigation.customisation": "Özelleştirme",
    "Customisation": "Özelleştirme",
    "navigation.integrations": "Entegrasyonlar",
    "Integrations": "Entegrasyonlar",
    "navigation.invite_team": "Ekibi davet et",
    "Invite Team": "Ekibi davet et",
    "navigation.help": "Yardım",
    "Help": "Yardım",
    "navigation.documentation": "Dokümantasyon",
    "navigation.community": "Topluluk",
    "Community": "Topluluk",
    "navigation.api_reference": "API referansı",
    "navigation.api": "API",
    "API": "API",
    "navigation.channels": "Kanallar",
    "Channels": "Kanallar",
    "navigation.coding_kits": "Kodlama kitleri",
    "Coding Kits": "Kodlama kitleri",
    "navigation.vibe_coding": "Yapay zekâ destekli kodlama",
    "Vibe Coding": "Yapay zekâ destekli kodlama",
    "navigation.mcp": "MCP",
    "MCP": "MCP",
    "navigation.settings": "Ayarlar",
    "Settings": "Ayarlar",
    "navigation.more": "Daha fazla",
    "More": "Daha fazla",
    "navigation.marketplace": "Pazar yeri",
    "navigation.commerce": "Ticaret",
    "Commerce": "Ticaret",
    "navigation.marketing": "Pazarlama",
    "Marketing": "Pazarlama",
    "navigation.intelligence": "İş zekâsı",
    "navigation.subscription": "Abonelik",
    "Subscription": "Abonelik",
    "navigation.membership": "Üyelik",
    "Membership": "Üyelik",
    "navigation.rewards": "Ödüller",
    "Rewards": "Ödüller",
    "navigation.bundles": "Paketler",
    "Bundles": "Paketler",
    "navigation.supply_chain": "Tedarik zinciri",
    "Supply Chain": "Tedarik zinciri",
    "navigation.people": "Çalışanlar",
    "People": "Çalışanlar",
    "navigation.workforce": "İş gücü",
    "navigation.payroll": "Bordro",
    "Payroll": "Bordro",
    "navigation.inventory": "Envanter",
    "Inventory": "Envanter",
    "navigation.inventory_operations": "Envanter işlemleri",
    "Inventory Operations": "Envanter işlemleri",
    "navigation.purchase_orders": "Satın alma siparişleri",
    "Purchase Orders": "Satın alma siparişleri",
    "navigation.stock_locations": "Stok konumları",
    "Stock Locations": "Stok konumları",
    "navigation.purchase_orders_2": "Satın alma siparişleri",
    "Purchase orders": "Satın alma siparişleri",
    "navigation.suppliers": "Tedarikçiler",
    "Suppliers": "Tedarikçiler",
    "navigation.locations": "Konumlar",
    "Locations": "Konumlar",
    "navigation.maps": "Haritalar",
    "Maps": "Haritalar",
    "navigation.accounting": "Muhasebe",
    "Accounting": "Muhasebe",
    "navigation.invoices": "Faturalar",
    "Invoices": "Faturalar",
    "navigation.plans": "Planlar",
    "Plans": "Planlar",
    "navigation.countries": "Ülkeler",
    "Countries": "Ülkeler",
    "navigation.currency": "Para birimi",
    "Currency": "Para birimi",
    "navigation.languages": "Diller",
    "Languages": "Diller",
    "navigation.payments": "Ödemeler",
    "Payments": "Ödemeler",
    "navigation.commissions": "Komisyonlar",
    "Commissions": "Komisyonlar",
    "navigation.taxes": "Vergiler",
    "Taxes": "Vergiler",
    "navigation.special_fees": "Özel ücretler",
    "Special Fees": "Özel ücretler",
    "navigation.service_shipping": "Hizmet / gönderim",
    "navigation.checkout_cart_attributes": "Ödeme ve sepet özellikleri",
    "Checkout & Cart Attributes": "Ödeme ve sepet özellikleri",
    "navigation.dark_mode_background_color": "Koyu mod arka plan rengi",
    "Dark Mode Background Color": "Koyu mod arka plan rengi",
    "navigation.dark_mode_text_color": "Koyu mod metin rengi",
    "Dark Mode Text Color": "Koyu mod metin rengi",
    "navigation.light_mode_background_color": "Açık mod arka plan rengi",
    "Light Mode Background Color": "Açık mod arka plan rengi",
    "navigation.light_mode_text_color": "Açık mod metin rengi",
    "Light Mode Text Color": "Açık mod metin rengi",
    "navigation.workspace": "Çalışma alanı",
    "Workspace": "Çalışma alanı",
    "navigation.user_management": "Kullanıcı yönetimi",
    "User Management": "Kullanıcı yönetimi",
    "navigation.privacy": "Gizlilik",
    "Privacy": "Gizlilik",
    "common.search": "Ara...",
    "Search...": "Ara...",
    "common.search_2": "Ara",
    "Search": "Ara",
    "common.no_results_found": "Sonuç bulunamadı",
    "No results found": "Sonuç bulunamadı",
    "common.no_record_found": "Kayıt bulunamadı",
    "No Record Found": "Kayıt bulunamadı",
    "common.open_in_a_new_tab": "Yeni sekmede aç",
    "Open in a new tab": "Yeni sekmede aç",
    "common.open": "Aç",
    "common.in_a_new_tab": "yeni sekmede",
    "in a new tab": "yeni sekmede",
    "common.loading_page": "Sayfa yükleniyor…",
    "Loading page…": "Sayfa yükleniyor…",
    "common.close": "Kapat",
    "Close": "Kapat",
    "common.save": "Kaydet",
    "Save": "Kaydet",
    "common.cancel": "İptal",
    "Cancel": "İptal",
    "common.delete": "Sil",
    "Delete": "Sil",
    "common.edit": "Düzenle",
    "Edit": "Düzenle",
    "common.add": "Ekle",
    "Add": "Ekle",
    "common.create": "Oluştur",
    "Create": "Oluştur",
    "common.update": "Güncelle",
    "Update": "Güncelle",
    "common.back": "Geri",
    "Back": "Geri",
    "common.next": "İleri",
    "Next": "İleri",
    "common.previous": "Önceki",
    "common.done": "Tamam",
    "Done": "Tamam",
    "common.yes": "Evet",
    "Yes": "Evet",
    "common.no": "Hayır",
    "No": "Hayır",
    "common.name": "Ad",
    "Name": "Ad",
    "common.status": "Durum",
    "Status": "Durum",
    "common.date": "Tarih",
    "Date": "Tarih",
    "common.actions": "İşlemler",
    "Actions": "İşlemler",
    "common.action": "İşlem",
    "orders.scan_order": "Siparişi tara",
    "Scan order": "Siparişi tara",
    "orders.scan_a_barcode_qr_reference_or_enter_it_manually": "Sipariş barkodunu/QR kodunu tarayın ya da elle girin.",
    "Scan a barcode/QR reference or enter it manually.": "Sipariş barkodunu/QR kodunu tarayın ya da elle girin.",
    "orders.camera_scanner": "Kamera tarayıcısı",
    "Camera scanner": "Kamera tarayıcısı",
    "common.camera_scanning_is_not_supported_here_enter_the_order_reference_below": "Kamera ile tarama burada desteklenmiyor. Sipariş referansını aşağıya girin.",
    "Camera scanning is not supported here. Enter the order reference below.": "Kamera ile tarama burada desteklenmiyor. Sipariş referansını aşağıya girin.",
    "common.camera_access_is_unavailable_enter_the_order_reference_below": "Kamera erişimi kullanılamıyor. Sipariş referansını aşağıya girin.",
    "Camera access is unavailable. Enter the order reference below.": "Kamera erişimi kullanılamıyor. Sipariş referansını aşağıya girin.",
    "orders.order_reference_number": "Sipariş referans numarası",
    "Order reference number": "Sipariş referans numarası",
    "orders.find_order": "Sipariş bul",
    "Find order": "Sipariş bul",
    "common.your_orders_will_be_shown_here": "Siparişleriniz burada gösterilecek.",
    "Your orders will be shown here.": "Siparişleriniz burada gösterilecek.",
    "common.here_you_can_keep_track_of_the_orders_bookings_etc_made_with_other_accounts_and_foll": "Burada diğer hesaplarla verilen siparişleri ve rezervasyonları takip edip durum güncellemelerini görebilirsiniz.",
    "Here, you can keep track of the orders, bookings, etc made with \nother accounts and follow the status updates.": "Burada diğer hesaplarla verilen siparişleri ve rezervasyonları takip edip durum güncellemelerini görebilirsiniz.",
    "common.reference": "Referans",
    "Reference #": "Referans",
    "common.amount": "Tutar",
    "Amount": "Tutar",
    "orders.order_status": "Sipariş durumu",
    "Order Status": "Sipariş durumu",
    "orders.payment_status": "Ödeme durumu",
    "Payment Status": "Ödeme durumu",
    "common.payment_method": "Ödeme yöntemi",
    "Payment Method": "Ödeme yöntemi",
    "common.shipping_method": "Gönderim yöntemi",
    "common.paid": "Ödendi",
    "Paid": "Ödendi",
    "common.not_paid": "Ödenmedi",
    "Not Paid": "Ödenmedi",
    "common.unpaid": "Ödenmedi",
    "UnPaid": "Ödenmedi",
    "common.failed": "Başarısız",
    "Failed": "Başarısız",
    "common.incomplete": "Tamamlanmadı",
    "Incomplete": "Tamamlanmadı",
    "common.order_placed": "Sipariş verildi",
    "Order placed": "Sipariş verildi",
    "common.order_in_progress": "Sipariş işleniyor",
    "Order in progress": "Sipariş işleniyor",
    "common.shipped": "Gönderildi",
    "common.delivered": "Teslim edildi",
    "Delivered": "Teslim edildi",
    "common.cancelled_by_customer": "Müşteri tarafından iptal edildi",
    "Cancelled by customer": "Müşteri tarafından iptal edildi",
    "common.order_completed": "Sipariş tamamlandı",
    "Order completed": "Sipariş tamamlandı",
    "common.n_a": "Yok",
    "N/A": "Yok",
    "orders.total_orders": "Toplam sipariş",
    "Total Orders": "Toplam sipariş",
    "orders.page_revenue": "Sayfa geliri",
    "Page Revenue": "Sayfa geliri",
    "orders.pending_payment": "Ödeme bekleniyor",
    "Pending Payment": "Ödeme bekleniyor",
    "common.failed_payments": "Başarısız ödemeler",
    "Failed payments": "Başarısız ödemeler",
    "common.abandoned": "Terk edildi",
    "Abandoned": "Terk edildi",
    "orders.search_orders_by_reference_number": "Referans numarasına göre sipariş ara",
    "Search orders by reference number": "Referans numarasına göre sipariş ara",
    "orders.search_by_reference_number": "Referans numarasına göre ara…",
    "Search by reference number…": "Referans numarasına göre ara…",
    "orders.export_orders_as_csv": "Siparişleri CSV olarak dışa aktar",
    "Export orders as CSV": "Siparişleri CSV olarak dışa aktar",
    "orders.manual_order": "Manuel sipariş",
    "Manual Order": "Manuel sipariş",
    "orders.scan_order_reference": "Sipariş referansını tara",
    "Scan order reference": "Sipariş referansını tara",
    "orders.change_status_to": "Durumu şuna değiştir…",
    "Change status to…": "Durumu şuna değiştir…",
    "common.apply": "Uygula",
    "Apply": "Uygula",
    "common.clear": "Temizle",
    "Clear": "Temizle",
    "orders.pay": "Öde",
    "Pay": "Öde",
    "orders.clear_selection": "Seçimi temizle",
    "Clear selection": "Seçimi temizle",
    "orders.list": "Liste",
    "orders.board": "Pano",
    "Board": "Pano",
    "orders.filter_orders": "Siparişleri filtrele",
    "Filter orders": "Siparişleri filtrele",
    "orders.start_date": "Başlangıç tarihi",
    "Start Date": "Başlangıç tarihi",
    "orders.end_date": "Bitiş tarihi",
    "End Date": "Bitiş tarihi",
    "orders.select_date": "Tarih seçin",
    "orders.show_rows": "Satırları göster",
    "Show rows": "Satırları göster",
    "common.order_selected": "sipariş seçildi",
    "order selected": "sipariş seçildi",
    "common.orders_selected": "sipariş seçildi",
    "orders selected": "sipariş seçildi",
    "common.order_updated": "sipariş güncellendi",
    "order updated": "sipariş güncellendi",
    "common.orders_updated": "siparişler güncellendi",
    "orders updated": "siparişler güncellendi",
    "orders.order_archived_successfully": "Sipariş başarıyla arşivlendi",
    "Order archived successfully": "Sipariş başarıyla arşivlendi",
    "orders.failed_to_archive_order": "Sipariş arşivlenemedi",
    "Failed to archive order": "Sipariş arşivlenemedi",
    "orders.loading_order": "Sipariş yükleniyor…",
    "Loading order…": "Sipariş yükleniyor…",
    "orders.order_created_successfully": "Sipariş başarıyla oluşturuldu",
    "Order created successfully": "Sipariş başarıyla oluşturuldu",
    "orders.the_order_has_been_created_and_is_ready_to_review": "Sipariş oluşturuldu ve incelenmeye hazır.",
    "The order has been created and is ready to review.": "Sipariş oluşturuldu ve incelenmeye hazır.",
    "orders.order_reference": "Sipariş referansı",
    "Order reference": "Sipariş referansı",
    "common.created": "Oluşturuldu",
    "common.total": "Toplam",
    "Total": "Toplam",
    "common.items": "Ürünler",
    "orders.print_save_pdf": "Yazdır / PDF olarak kaydet",
    "Print / Save PDF": "Yazdır / PDF olarak kaydet",
    "orders.view_order_details": "Sipariş ayrıntılarını görüntüle",
    "View order details": "Sipariş ayrıntılarını görüntüle",
    "orders.create_another_order": "Başka bir sipariş oluştur",
    "Create another order": "Başka bir sipariş oluştur",
    "orders.confirmed": "Onaylandı",
    "Confirmed": "Onaylandı",
    "orders.in_progress": "Devam ediyor",
    "In progress": "Devam ediyor",
    "orders.customer_unreachable": "Müşteriye ulaşılamıyor",
    "Customer unreachable": "Müşteriye ulaşılamıyor",
    "orders.out_for_delivery": "Dağıtımda",
    "orders.returned": "İade edildi",
    "Returned": "İade edildi",
    "orders.return_confirmed": "İade onaylandı",
    "Return confirmed": "İade onaylandı",
    "orders.delivery_confirmed": "Teslimat onaylandı",
    "Delivery confirmed": "Teslimat onaylandı",
    "orders.return_initiated": "İade başlatıldı",
    "Return initiated": "İade başlatıldı",
    "orders.return_picked": "İade alındı",
    "Return picked": "İade alındı",
    "orders.return_disputed": "İadeye itiraz edildi",
    "Return disputed": "İadeye itiraz edildi",
    "orders.canceled_by_seller": "Satıcı tarafından iptal edildi",
    "Canceled by seller": "Satıcı tarafından iptal edildi",
    "orders.canceled_by_customer": "Müşteri tarafından iptal edildi",
    "Canceled by customer": "Müşteri tarafından iptal edildi",
    "orders.ready_for_pickup": "Teslim alınmaya hazır",
    "Ready for pickup": "Teslim alınmaya hazır",
    "orders.arrived_at_customer_location": "Müşteri konumuna ulaştı",
    "orders.undelivered_returned": "Teslim edilemedi — iade edildi",
    "Undelivered - Returned": "Teslim edilemedi — iade edildi",
    "orders.undelivered_return_confirmed": "Teslim edilemeyen siparişin iadesi onaylandı",
    "Undelivered - Return confirmed": "Teslim edilemeyen siparişin iadesi onaylandı",
    "orders.disputed": "İtiraz edildi",
    "Disputed": "İtiraz edildi",
    "orders.completed": "Tamamlandı",
    "Completed": "Tamamlandı",
    "orders.detail_legacy.order_number": "Sipariş numarası:",
    "Order Number:": "Sipariş numarası:",
    "orders.detail_legacy.order_date": "Sipariş tarihi:",
    "Order Date:": "Sipariş tarihi:",
    "orders.detail_legacy.buyer_details": "Alıcı bilgileri:",
    "Buyer Details:": "Alıcı bilgileri:",
    "orders.detail_legacy.delivery_address": "Teslimat adresi:",
    "Delivery Address:": "Teslimat adresi:",
    "orders.detail_legacy.pickup_address": "Teslim alma adresi:",
    "Pickup Address:": "Teslim alma adresi:",
    "orders.detail_legacy.total_amount": "Toplam tutar:",
    "Total Amount:": "Toplam tutar:",
    "orders.detail_legacy.amount_in_words": "Yazıyla tutar:",
    "Amount in Words:": "Yazıyla tutar:",
    "orders.detail_legacy.amount_words_only": "Yalnızca",
    "Only": "Yalnızca",
    "orders.detail_legacy.payout_date": "Ödeme tarihi:",
    "Payout Date:": "Ödeme tarihi:",
    "orders.detail_legacy.change": "Değiştir",
    "orders.detail_legacy.select_date_time": "Tarih ve saat seçin",
    "orders.detail_legacy.change_payout_date_time": "Ödeme tarihini ve saatini değiştir",
    "Change Payout Date and Time": "Ödeme tarihini ve saatini değiştir",
    "orders.detail_legacy.update_payout": "Güncelle",
    "orders.detail_legacy.update_status": "Durumu güncelle",
    "Update Status": "Durumu güncelle",
    "orders.detail_legacy.change_order_status": "Sipariş durumunu değiştir",
    "Change Order Status": "Sipariş durumunu değiştir",
    "orders.detail_legacy.column_description": "Açıklama",
    "Description": "Açıklama",
    "orders.detail_legacy.column_unit_price": "Birim fiyat",
    "Unit Price": "Birim fiyat",
    "orders.detail_legacy.column_discount": "İndirim",
    "Discount": "İndirim",
    "orders.detail_legacy.column_tax_rate": "Vergi oranı",
    "Tax Rate": "Vergi oranı",
    "orders.item": "Ürün",
    "Item": "Ürün",
    "orders.order_details": "Sipariş ayrıntıları",
    "Order Details": "Sipariş ayrıntıları",
    "orders.copy_order_reference": "Sipariş referansını kopyala",
    "Copy order reference": "Sipariş referansını kopyala",
    "orders.order_summary": "Sipariş özeti",
    "Order Summary": "Sipariş özeti",
    "orders.order_created": "Sipariş oluşturuldu",
    "Order created": "Sipariş oluşturuldu",
    "orders.order_time": "Sipariş zamanı",
    "Order time": "Sipariş zamanı",
    "orders.total_earnings": "Toplam kazanç",
    "Total earnings": "Toplam kazanç",
    "orders.total_price": "Toplam fiyat",
    "Total price": "Toplam fiyat",
    "orders.delivery_fee": "Teslimat ücreti",
    "Delivery fee": "Teslimat ücreti",
    "orders.sub_total": "Ara toplam",
    "Sub total": "Ara toplam",
    "orders.customer_information": "Müşteri bilgileri",
    "Customer Information": "Müşteri bilgileri",
    "common.customer_name": "Müşteri adı",
    "Customer Name": "Müşteri adı",
    "common.phone": "Telefon",
    "Phone": "Telefon",
    "common.email": "E-posta",
    "Email": "E-posta",
    "orders.seller_details": "Satıcı bilgileri",
    "Seller Details": "Satıcı bilgileri",
    "common.seller_name": "Satıcı adı",
    "Seller Name": "Satıcı adı",
    "common.mobile": "Cep telefonu",
    "orders.generate": "Oluştur",
    "Generate": "Oluştur",
    "orders.cancel_order": "Siparişi iptal et",
    "Cancel Order": "Siparişi iptal et",
    "orders.mark_as_paid": "Ödendi olarak işaretle",
    "Mark as Paid": "Ödendi olarak işaretle",
    "orders.failed_to_mark_as_paid": "Ödendi olarak işaretlenemedi",
    "Failed to mark as paid": "Ödendi olarak işaretlenemedi",
    "orders.order_cancelled_successfully": "Sipariş başarıyla iptal edildi",
    "Order cancelled successfully": "Sipariş başarıyla iptal edildi",
    "orders.failed_to_cancel_order_by_admin": "Yönetici siparişi iptal edemedi",
    "Failed to cancel order by admin": "Yönetici siparişi iptal edemedi",
    "orders.no_transactions_found": "İşlem bulunamadı",
    "No transactions found": "İşlem bulunamadı",
    "orders.transaction_no": "İşlem no.",
    "Transaction No": "İşlem no.",
    "orders.entity": "Varlık",
    "Entity": "Varlık",
    "orders.transaction_type": "İşlem türü",
    "Transaction Type": "İşlem türü",
    "common.seller": "Satıcı",
    "Seller": "Satıcı",
    "common.customer": "Müşteri",
    "Customer": "Müşteri",
    "common.platform_owner": "Platform sahibi",
    "Platform Owner": "Platform sahibi",
    "orders.items_summary": "Ürün özeti",
    "Items Summary": "Ürün özeti",
    "orders.qty": "Adet",
    "orders.price": "Fiyat",
    "Price": "Fiyat",
    "orders.total_price_2": "Toplam fiyat",
    "Total Price": "Toplam fiyat",
    "orders.membership_purchase": "Üyelik satın alımı",
    "Membership purchase": "Üyelik satın alımı",
    "orders.member_id": "Üye kimliği",
    "Member ID": "Üye kimliği",
    "orders.period": "Dönem",
    "Period": "Dönem",
    "orders.start_date_2": "Başlangıç tarihi",
    "Start date": "Başlangıç tarihi",
    "common.next_renewal": "Sonraki yenileme",
    "Next renewal": "Sonraki yenileme",
    "common.expiry_date": "Son kullanma tarihi",
    "Expiry date": "Son kullanma tarihi",
    "orders.this_order_is_managed_as_a_membership_contribution_not_a_shipment": "Bu sipariş gönderi olarak değil, üyelik katkısı olarak işlenir.",
    "This order is managed as a membership contribution, not a shipment.": "Bu sipariş gönderi olarak değil, üyelik katkısı olarak işlenir.",
    "orders.months": "ay",
    "months": "ay",
    "orders.days": "gün",
    "days": "gün",
    "orders.address": "Adres",
    "Address": "Adres",
    "orders.address_1": "Adres 1",
    "Address 1": "Adres 1",
    "orders.address_2": "Adres 2",
    "Address 2": "Adres 2",
    "orders.zip_code": "Posta kodu",
    "Zip code": "Posta kodu",
    "orders.full_address": "Tam adres",
    "Full Address": "Tam adres",
    "orders.formatted_address": "Biçimlendirilmiş adres",
    "Formatted Address": "Biçimlendirilmiş adres",
    "orders.phone_number": "Telefon numarası",
    "Phone Number": "Telefon numarası",
    "orders.address_not_found": "Adres bulunamadı",
    "Address not found": "Adres bulunamadı",
    "orders.address_not_applicable": "Adres geçerli değil",
    "Address not applicable": "Adres geçerli değil",
    "orders.address_is_not_available": "Adres mevcut değil",
    "Address is not available": "Adres mevcut değil",
    "orders.add_pickup_address": "Teslim alma adresi ekle",
    "Add Pickup Address": "Teslim alma adresi ekle",
    "orders.edit_pickup_address": "Teslim alma adresini düzenle",
    "Edit Pickup Address": "Teslim alma adresini düzenle",
    "orders.discard_and_close": "Değişiklikleri at ve kapat",
    "Discard and close": "Değişiklikleri at ve kapat",
    "orders.state": "Eyalet",
    "State": "Eyalet",
    "common.country": "Ülke",
    "Country": "Ülke",
    "orders.sales_payout": "Satış ödemesi",
    "Sales Payout": "Satış ödemesi",
    "orders.sales_no_payout": "Satışlar (ödeme yok)",
    "Sales (No Payout)": "Satışlar (ödeme yok)",
    "orders.sales_payout_reversal": "Satış ödemesi iptali",
    "Sales Payout Reversal": "Satış ödemesi iptali",
    "orders.sales_no_payout_reversal": "Ödemesiz satışların iptali",
    "Sales no payout reversal": "Ödemesiz satışların iptali",
    "orders.seller_commission": "Satıcı komisyonu",
    "Seller Commission": "Satıcı komisyonu",
    "orders.seller_commission_reversal": "Satıcı komisyonu iptali",
    "Seller Commission Reversal": "Satıcı komisyonu iptali",
    "orders.seller_transfer": "Satıcıya aktarım",
    "Seller Transfer": "Satıcıya aktarım",
    "orders.seller_transfer_reversal": "Satıcıya aktarım iptali",
    "Seller Transfer Reversal": "Satıcıya aktarım iptali",
    "orders.seller_payout": "Satıcı ödemesi",
    "Seller Payout": "Satıcı ödemesi",
    "orders.seller_subscription": "Satıcı aboneliği",
    "Seller Subscription": "Satıcı aboneliği",
    "orders.seller_payment_processing_fee": "Satıcı ödeme işlem ücreti",
    "Seller Payment processing fee": "Satıcı ödeme işlem ücreti",
    "orders.seller_payment_processing_fee_reversal": "Satıcı ödeme işlem ücretinin iptali",
    "Seller Payment processing fee reversal": "Satıcı ödeme işlem ücretinin iptali",
    "orders.sub_total_2": "Ara toplam",
    "Sub Total": "Ara toplam",
    "orders.customer_commission": "Müşteri komisyonu",
    "Customer Commission": "Müşteri komisyonu",
    "orders.tax": "Vergi",
    "Tax": "Vergi",
    "orders.shipping_charge": "Kargo ücreti",
    "Shipping Charge": "Kargo ücreti",
    "orders.refund": "Para iadesi",
    "Refund": "Para iadesi",
    "orders.special_fee": "Özel ücret",
    "Special Fee": "Özel ücret",
    "orders.coupon": "Kupon",
    "Coupon": "Kupon",
    "orders.shipment": "Gönderi",
    "Shipment": "Gönderi",
    "orders.fulfilled_by_platform": "Platform tarafından karşılanır",
    "Fulfilled by platform": "Platform tarafından karşılanır",
    "orders.fulfilled_by": "Sağlayan:",
    "Fulfilled by": "Sağlayan:",
    "orders.fulfilled_by_seller": "Satıcı tarafından karşılanır",
    "Fulfilled by seller": "Satıcı tarafından karşılanır",
    "orders.on_seller_protection_policy": "Satıcı koruma politikası kapsamında",
    "On Seller Protection Policy": "Satıcı koruma politikası kapsamında",
    "orders.product_image": "Ürün görseli",
    "Product image": "Ürün görseli",
    "orders.status_changed_successfully": "Durum başarıyla değiştirildi",
    "Status changed successfully": "Durum başarıyla değiştirildi",
    "orders.pickup_address_not_available_please_add_pickup_address": "Teslim alma adresi mevcut değil. Lütfen ekleyin.",
    "Pickup Address not available. Please Add Pickup Address": "Teslim alma adresi mevcut değil. Lütfen ekleyin.",
    "orders.failed_to_save_pickup_address_please_try_again": "Teslim alma adresi kaydedilemedi. Lütfen tekrar deneyin.",
    "Failed to save pickup address. Please try again.": "Teslim alma adresi kaydedilemedi. Lütfen tekrar deneyin.",
    "orders.change_shipment_status": "Gönderi durumunu değiştir",
    "Change shipment status": "Gönderi durumunu değiştir",
    "orders.not_available": "Mevcut değil",
    "orders.shipment_created": "Gönderi oluşturuldu",
    "Shipment created": "Gönderi oluşturuldu",
    "orders.shipment_in_progress": "Gönderi devam ediyor",
    "orders.ship": "Gönder",
    "orders.undelivered_return": "Teslim edilemeyen siparişin iadesi",
    "orders.shipment_deliver": "Gönderiyi teslim et",
    "Shipment deliver": "Gönderiyi teslim et",
    "orders.shipment_delivery_confirm": "Gönderi teslimatını onayla",
    "Shipment delivery confirm": "Gönderi teslimatını onayla",
    "orders.return_initiate": "İade sürecini başlat",
    "Return initiate": "İade sürecini başlat",
    "orders.return_for_pickup": "İade teslim alınmaya hazır",
    "Return for pickup": "İade teslim alınmaya hazır",
    "orders.shipment_return_confirm": "Gönderi iadesini onayla",
    "Shipment return confirm": "Gönderi iadesini onayla",
    "orders.cancel_by_seller": "Satıcı tarafından iptal et",
    "Cancel by seller": "Satıcı tarafından iptal et",
    "orders.cancel_by_customer": "Müşteri tarafından iptal et",
    "Cancel by customer": "Müşteri tarafından iptal et",
    "orders.arrive_at_customer_location": "Müşteri konumuna var",
    "Arrive at customer location": "Müşteri konumuna var",
    "orders.shipment_delivered": "Gönderi teslim edildi",
    "Shipment delivered": "Gönderi teslim edildi",
    "orders.shipment_delivery_confirmed": "Gönderi teslimatı onaylandı",
    "Shipment delivery confirmed": "Gönderi teslimatı onaylandı",
    "orders.returned_for_pickup": "İade alınmak üzere geri gönderildi",
    "orders.shipment_return_confirmed": "Gönderi iadesi onaylandı",
    "Shipment return confirmed": "Gönderi iadesi onaylandı",
    "orders.cancelled_by_seller": "Satıcı tarafından iptal edildi",
    "Cancelled by seller": "Satıcı tarafından iptal edildi",
    "common.cancelled_by_admin": "Yönetici tarafından iptal edildi",
    "Cancelled by admin": "Yönetici tarafından iptal edildi",
    "orders.invoice": "Fatura",
    "Invoice": "Fatura",
    "orders.please_select_a_valid_file_type_pdf_jpg_png_doc": "Geçerli bir dosya türü seçin (PDF, JPG, PNG, DOC)",
    "Please select a valid file type (PDF, JPG, PNG, DOC)": "Geçerli bir dosya türü seçin (PDF, JPG, PNG, DOC)",
    "orders.file_size_must_be_less_than_5mb": "Dosya boyutu 5 MB’tan küçük olmalıdır",
    "File size must be less than 5MB": "Dosya boyutu 5 MB’tan küçük olmalıdır",
    "orders.please_upload_a_file_first": "Önce bir dosya yükleyin",
    "Please upload a file first": "Önce bir dosya yükleyin",
    "orders.invoice_uploaded_successfully": "Fatura başarıyla yüklendi!",
    "Invoice uploaded successfully!": "Fatura başarıyla yüklendi!",
    "orders.failed_to_upload_invoice_please_try_again": "Fatura yüklenemedi. Lütfen tekrar deneyin.",
    "Failed to upload invoice. Please try again.": "Fatura yüklenemedi. Lütfen tekrar deneyin.",
    "orders.upload_invoice": "Fatura yükle",
    "Upload Invoice": "Fatura yükle",
    "orders.supported_formats_pdf_jpg_png_doc_max_size_5mb": "Desteklenen biçimler: PDF, JPG, PNG, DOC (en fazla 5 MB)",
    "Supported formats: PDF, JPG, PNG, DOC (Max size: 5MB)": "Desteklenen biçimler: PDF, JPG, PNG, DOC (en fazla 5 MB)",
    "orders.uploading": "Yükleniyor…",
    "orders.choose_file": "Dosya seç",
    "Choose File": "Dosya seç",
    "common.download": "İndir",
    "Download": "İndir",
    "common.remove": "Kaldır",
    "Remove": "Kaldır",
    "orders.upload_new_file": "Yeni dosya yükle",
    "Upload New File": "Yeni dosya yükle",
    "orders.saving": "Kaydediliyor…",
    "Saving...": "Kaydediliyor…",
    "orders.deleting_an_order_will_immediately_remove_it_from_both_the_seller_s_and_buyer_s_view": "Sipariş silindiğinde satıcı ve alıcı görünümlerinden hemen kaldırılır. Silindikten sonra durumu güncellenemez ve sipariş ölçüm ve raporlara dahil edilmez. Devam etmek istiyor musunuz?",
    "Deleting an order will immediately remove it from both the seller's and buyer's view. Once deleted, no further status updates will be allowed, and the order will be excluded from all metrics and reports. Are you sure you want to proceed?": "Sipariş silindiğinde satıcı ve alıcı görünümlerinden hemen kaldırılır. Silindikten sonra durumu güncellenemez ve sipariş ölçüm ve raporlara dahil edilmez. Devam etmek istiyor musunuz?",
    "common.showing": "Gösterilen",
    "Showing": "Gösterilen",
    "common.of": "/",
    "of": "/",
    "common.all": "Tümü",
    "All": "Tümü",
    "common.active": "Etkin",
    "Active": "Etkin",
    "common.inactive": "Etkin değil",
    "Inactive": "Etkin değil",
    "common.enabled": "Etkin",
    "Enabled": "Etkin",
    "common.disabled": "Devre dışı",
    "Disabled": "Devre dışı",
    "common.success": "Başarılı",
    "Success": "Başarılı",
    "common.error": "Hata",
    "Error": "Hata",
    "common.warning": "Uyarı",
    "Warning": "Uyarı",
    "common.required": "Zorunlu",
    "Required": "Zorunlu",
    "users.title": "Kullanıcılar",
    "users.import": "İçe aktar",
    "Import": "İçe aktar",
    "users.import_users": "Kullanıcıları içe aktar",
    "Import users": "Kullanıcıları içe aktar",
    "users.smart_upload_users": "Akıllı kullanıcı yükleme",
    "Smart Upload Users": "Akıllı kullanıcı yükleme",
    "users.smart_upload_beta": "Akıllı kullanıcı yükleme (Beta)",
    "Smart upload users (Beta)": "Akıllı kullanıcı yükleme (Beta)",
    "users.export": "Dışa aktar",
    "Export": "Dışa aktar",
    "users.export_users": "Kullanıcıları dışa aktar",
    "Export users": "Kullanıcıları dışa aktar",
    "users.search_users": "Kullanıcı ara",
    "Search users": "Kullanıcı ara",
    "users.verified": "Doğrulandı",
    "Verified": "Doğrulandı",
    "users.not_verified": "Doğrulanmadı",
    "Non Verified": "Doğrulanmadı",
    "users.block": "Engelle",
    "Block": "Engelle",
    "users.unblock": "Engeli kaldır",
    "Unblock": "Engeli kaldır",
    "users.confirm_block": "Bu kullanıcıyı engellemek istiyor musunuz?",
    "Do you want to block this user?": "Bu kullanıcıyı engellemek istiyor musunuz?",
    "users.confirm_unblock": "Bu kullanıcının engelini kaldırmak istiyor musunuz?",
    "Do you want to unblock this user?": "Bu kullanıcının engelini kaldırmak istiyor musunuz?",
    "users.import_export": "Kullanıcı içe ve dışa aktarma",
    "User import and export": "Kullanıcı içe ve dışa aktarma",
    "users.user_id": "Kullanıcı kimliği",
    "User ID": "Kullanıcı kimliği",
    "users.first_name": "Ad",
    "First Name": "Ad",
    "users.last_name": "Soyadı",
    "users.email": "E-posta",
    "users.phone_number": "Telefon numarası",
    "users.country": "Ülke",
    "users.profile": "Profil",
    "Profile": "Profil",
    "users.email_verified": "E-posta doğrulandı",
    "Email Verified": "E-posta doğrulandı",
    "users.blocked": "Engellendi",
    "Blocked": "Engellendi",
    "users.action": "İşlem",
    "users.join_date": "Kayıt tarihi",
    "Join Date": "Kayıt tarihi",
    "users.last_login": "Son giriş",
    "Last Login": "Son giriş",
    "users.customer_type": "Müşteri türü",
    "Customer Type": "Müşteri türü",
    "common.and": "ve",
    "and": "ve",
    "users.import_failed": "Kullanıcı içe aktarma başarısız oldu.",
    "User import failed.": "Kullanıcı içe aktarma başarısız oldu.",
    "users.smart_upload.paid_title": "Akıllı kullanıcı yükleme ücretli bir özelliktir",
    "Smart user upload is a paid feature": "Akıllı kullanıcı yükleme ücretli bir özelliktir",
    "users.smart_upload.paid_description": "CSV dosyasından kullanıcı yüklemek için çalışma alanınızı Starter veya Go planına yükseltin.",
    "Upgrade your workspace to Starter or Go to upload users from a CSV file.": "CSV dosyasından kullanıcı yüklemek için çalışma alanınızı Starter veya Go planına yükseltin.",
    "users.smart_upload.view_plans": "Planları görüntüle",
    "View plans": "Planları görüntüle",
    "users.smart_upload.csv_needs_user": "CSV dosyasında bir başlık satırı ve en az bir kullanıcı bulunmalıdır.",
    "The CSV must contain a header row and at least one user.": "CSV dosyasında bir başlık satırı ve en az bir kullanıcı bulunmalıdır.",
    "users.smart_upload.unique_headers": "Her kullanıcı sütununun benzersiz ve boş olmayan bir başlığı olmalıdır.",
    "Every user column needs a unique, non-empty header.": "Her kullanıcı sütununun benzersiz ve boş olmayan bir başlığı olmalıdır.",
    "users.smart_upload.csv_read_error": "Bu CSV dosyası okunamadı.",
    "Unable to read this CSV.": "Bu CSV dosyası okunamadı.",
    "users.smart_upload.map_required": "Devam etmeden önce {fields} alanlarını eşleyin.",
    "Map {fields} before continuing.": "Devam etmeden önce {fields} alanlarını eşleyin.",
    "users.smart_upload.map_contact": "Email veya Phone sütununu eşleyin. Her satırda en az bir iletişim yöntemi bulunmalıdır.",
    "Map an Email or Phone column. Each row needs at least one contact method.": "Email veya Phone sütununu eşleyin. Her satırda en az bir iletişim yöntemi bulunmalıdır.",
    "users.smart_upload.invalid_row": "{row}. satırda gerekli ad veya iletişim bilgisi eksik.",
    "Row {row} is missing a required name or contact value.": "{row}. satırda gerekli ad veya iletişim bilgisi eksik.",
    "users.smart_upload.attribute_name_required": "“{header}” için bir özellik adı girin.",
    "users.smart_upload.attribute_create_error": "“{name}” özelliği oluşturulamadı.",
    "Could not create the “{name}” attribute.": "“{name}” özelliği oluşturulamadı.",
    "users.smart_upload.attribute_missing": "“{header}” ile eşlenen özellik artık kullanılamıyor.",
    "users.smart_upload.prepare_error": "İçe aktarma dosyası hazırlanamadı.",
    "Could not prepare the import file.": "İçe aktarma dosyası hazırlanamadı.",
    "users.smart_upload.upload_error": "İçe aktarma dosyası yüklenemedi.",
    "The import file could not be uploaded.": "İçe aktarma dosyası yüklenemedi.",
    "users.smart_upload.all_duplicates": "Bu dosyadaki tüm satırlar birbirinin kopyası.",
    "Every row is a duplicate of another row in this file.": "Bu dosyadaki tüm satırlar birbirinin kopyası.",
    "users.smart_upload.source_attribute_error": "contact_source özelliği oluşturulamadı.",
    "Could not create the contact_source attribute.": "contact_source özelliği oluşturulamadı.",
    "users.smart_upload.duplicates_skipped": "Atlanacak yinelenen satır: {count}.",
    "Duplicate rows to skip: {count}.": "Atlanacak yinelenen satır: {count}.",
    "users.smart_upload.preparing_attributes": "Özellikler hazırlanıyor",
    "users.smart_upload.checking_users": "Mevcut kullanıcılar denetleniyor",
    "Checking existing users": "Mevcut kullanıcılar denetleniyor",
    "users.smart_upload.uploading_file": "İçe aktarma dosyası yükleniyor",
    "Uploading import file": "İçe aktarma dosyası yükleniyor",
    "users.smart_upload.importing_users": "Tradly kullanıcıları içe aktarıyor",
    "Tradly is importing users": "Tradly kullanıcıları içe aktarıyor",
    "users.smart_upload.import_stopped": "İçe aktarma durduruldu",
    "Import stopped": "İçe aktarma durduruldu",
    "users.smart_upload.title": "Akıllı kullanıcı yükleme",
    "Smart user upload": "Akıllı kullanıcı yükleme",
    "users.smart_upload.beta": "(Beta)",
    "(Beta)": "(Beta)",
    "users.smart_upload.start_over": "Baştan başla",
    "Start over": "Baştan başla",
    "users.smart_upload.description": "Kişileri yükleyin, sütunları kullanıcı özellikleriyle eşleyin ve kişileri giden iletişim ya da kayıtlı kullanıcı olarak sınıflandırın.",
    "Upload contacts, map columns to user attributes, and classify them as outbound or signed-up.": "Kişileri yükleyin, sütunları kullanıcı özellikleriyle eşleyin ve kişileri giden iletişim ya da kayıtlı kullanıcı olarak sınıflandırın.",
    "users.smart_upload.step_upload": "Yükle",
    "Upload": "Yükle",
    "users.smart_upload.step_match": "Sütunları eşle",
    "users.smart_upload.step_review": "İncele",
    "users.smart_upload.step_import": "İçe aktar",
    "users.smart_upload.choose_csv": "CSV dosyası seçin",
    "users.smart_upload.required_fields": "Ad, soyad ve e-posta veya telefon gereklidir. Şifreler otomatik oluşturulur.",
    "First name, last name, and email or phone are required. Passwords are generated automatically.": "Ad, soyad ve e-posta veya telefon gereklidir. Şifreler otomatik oluşturulur.",
    "users.smart_upload.select_csv": "CSV dosyası seç",
    "users.smart_upload.match_columns": "Kullanıcı sütunlarını eşle",
    "Match user columns": "Kullanıcı sütunlarını eşle",
    "users.smart_upload.first_name": "Ad",
    "First name": "Ad",
    "users.smart_upload.last_name": "Soyadı",
    "Last name": "Soyadı",
    "users.smart_upload.email": "E-posta",
    "users.smart_upload.phone": "Telefon",
    "users.smart_upload.username": "Kullanıcı adı",
    "Username": "Kullanıcı adı",
    "users.smart_upload.do_not_import": "İçe aktarma",
    "Do not import": "İçe aktarma",
    "users.smart_upload.additional_attributes": "Ek kullanıcı özellikleri",
    "Additional user attributes": "Ek kullanıcı özellikleri",
    "users.smart_upload.ignore_column": "Bu sütunu yoksay",
    "Ignore this column": "Bu sütunu yoksay",
    "users.smart_upload.create_attribute": "Yeni kullanıcı özelliği oluştur",
    "Create a new user attribute": "Yeni kullanıcı özelliği oluştur",
    "users.smart_upload.attribute_name": "Özellik adı",
    "users.smart_upload.type_text": "Metin",
    "Text": "Metin",
    "users.smart_upload.type_long_text": "Uzun metin",
    "Long text": "Uzun metin",
    "users.smart_upload.type_number": "Sayı",
    "Number": "Sayı",
    "users.smart_upload.type_single_select": "Tek seçim",
    "users.smart_upload.type_multi_select": "Çoklu seçim",
    "Multi select": "Çoklu seçim",
    "users.smart_upload.review_import": "İçe aktarmayı incele",
    "users.smart_upload.review_description": "İçe aktarılacak kişi: {count}. API mevcut Tradly kullanıcılarını reddedebilir; kısmi içe aktarmayı yinelemek başarılı satırları çoğaltabilir.",
    "Contacts to import: {count}. Existing Tradly users may be rejected by the API; retrying a partial import can duplicate successful rows.": "İçe aktarılacak kişi: {count}. API mevcut Tradly kullanıcılarını reddedebilir; kısmi içe aktarmayı yinelemek başarılı satırları çoğaltabilir.",
    "users.smart_upload.contact_classification": "Kişi sınıflandırması",
    "Contact classification": "Kişi sınıflandırması",
    "users.smart_upload.outbound": "Giden (onay vermedi)",
    "Outbound (not opted in)": "Giden (onay vermedi)",
    "users.smart_upload.signed_up": "Kayıtlı (onay verdi)",
    "Signed-up (opted in)": "Kayıtlı (onay verdi)",
    "users.smart_upload.contact_source_help": "Bu değer contact_source özelliğine kaydedilir. Tradly yerleşik kullanıcı türü customer olarak kalır.",
    "This is saved as the contact_source attribute. Tradly’s built-in user type remains customer.": "Bu değer contact_source özelliğine kaydedilir. Tradly yerleşik kullanıcı türü customer olarak kalır.",
    "users.smart_upload.import_complete": "Kullanıcı içe aktarma tamamlandı",
    "User import complete": "Kullanıcı içe aktarma tamamlandı",
    "users.smart_upload.imported_summary": "{total} kullanıcının {imported} tanesi içe aktarıldı.",
    "{imported} of {total} users imported.": "{total} kullanıcının {imported} tanesi içe aktarıldı.",
    "users.smart_upload.selected_file": "Seçildi: {name}",
    "Selected: {name}": "Seçildi: {name}",
    "users.smart_upload.review_action": "İncele",
    "users.smart_upload.importing_action": "İçe aktarılıyor…",
    "Importing…": "İçe aktarılıyor…",
    "users.smart_upload.import_users_action": "Kullanıcıları içe aktar",
    "users.import.uploading": "Yükleniyor…",
    "Uploading…": "Yükleniyor…",
    "users.import.please_wait": "Lütfen bekleyin…",
    "Please wait…": "Lütfen bekleyin…",
    "users.import.error_prefix": "Hata",
    "users.import.select_file_error": "Dosya seçin",
    "Please select a file": "Dosya seçin",
    "users.import.download": "İndir",
    "users.import.file_label": "Dosya:",
    "File:": "Dosya:",
    "users.import.select_file": "Dosya seç",
    "Select File": "Dosya seç",
    "users.import.upload": "Yükle",
    "users.create.button": "Kullanıcı oluştur",
    "Create User": "Kullanıcı oluştur",
    "users.create.title": "Yeni kullanıcı oluştur",
    "Create New User": "Yeni kullanıcı oluştur",
    "users.create.please_wait": "Lütfen bekleyin…",
    "users.create.email": "E-posta",
    "users.create.first_name": "Ad",
    "users.create.last_name": "Soyadı",
    "users.create.email_required": "E-posta gereklidir",
    "Email is required": "E-posta gereklidir",
    "users.create.first_name_required": "Ad gereklidir",
    "First Name is required": "Ad gereklidir",
    "users.create.last_name_required": "Soyadı gereklidir",
    "Last Name is required": "Soyadı gereklidir",
    "users.create.session_expired": "Yönetici oturumunuz sona erdi. Kullanıcı oluşturmadan önce yeniden giriş yapın.",
    "Your admin session has expired. Please sign in again before creating a user.": "Yönetici oturumunuz sona erdi. Kullanıcı oluşturmadan önce yeniden giriş yapın.",
    "users.create.unable_to_create": "Bu kullanıcı oluşturulamadı.",
    "Unable to create this user.": "Bu kullanıcı oluşturulamadı.",
    "users.create.success": "Kullanıcı başarıyla oluşturuldu",
    "User created successfully": "Kullanıcı başarıyla oluşturuldu",
    "users.create.failed": "Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.",
    "User creation failed. Please try again.": "Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.",
    "common.feature_flow.eyebrow": "NASIL ÇALIŞTIĞINI GÖRÜN",
    "SEE HOW IT WORKS": "NASIL ÇALIŞTIĞINI GÖRÜN",
    "common.feature_flow.open_guide": "Akış kılavuzunu aç",
    "Open flow guide": "Akış kılavuzunu aç",
    "common.feature_flow.close_guide": "Bölüm kılavuzunu kapat",
    "Close section guide": "Bölüm kılavuzunu kapat",
    "common.feature_flow.section_guide": "Bölüm kılavuzu",
    "Section guide": "Bölüm kılavuzu",
    "users.flow.title": "Kullanıcılarınızı yönetmek için ihtiyacınız olan her şey",
    "Everything you need to manage your users": "Kullanıcılarınızı yönetmek için ihtiyacınız olan her şey",
    "users.flow.description": "Kullanıcı profilleri oluşturun, verilerini özelleştirin ve müşteri geri bildirimlerini tek yerde inceleyin.",
    "Build user profiles, personalize user data, and understand customer feedback in one place.": "Kullanıcı profilleri oluşturun, verilerini özelleştirin ve müşteri geri bildirimlerini tek yerde inceleyin.",
    "users.flow.lane_title": "Kullanıcı yönetimi",
    "User management": "Kullanıcı yönetimi",
    "users.flow.badge": "Temel araçlar",
    "Core tools": "Temel araçlar",
    "users.flow.attributes": "Özellikler",
    "users.flow.reviews": "Yorumlar",
    "Reviews": "Yorumlar",
    "users.flow.lane_description": "Kişileri yönetin, gerekli profil alanlarını ekleyin ve deneyimlerini öğrenin.",
    "Manage people, add the profile fields you need, and learn from their experience.": "Kişileri yönetin, gerekli profil alanlarını ekleyin ve deneyimlerini öğrenin.",
    "users.flow.primary_action": "İlk kullanıcınızı ekleyin",
    "Add your first user": "İlk kullanıcınızı ekleyin",
    "users.tooltip.title": "Her kişi ayrı bir kullanıcıdır",
    "Every individual is a unique user": "Her kişi ayrı bir kullanıcıdır",
    "users.tooltip.description": "Bir alışveriş merkezinin sahibi olduğunuzu düşünün.\n\nBir mağazaya giren herkes kullanıcı sayılır.\n\nBir mağazayı işleten her satıcı da kullanıcı sayılır.\n\nTradly’de satıcı veya müşteri olsun herkes “Kullanıcı” olarak adlandırılır ve kendilerine ait bilgiler kullanıcı bölümünde saklanır. Satın alma ayrıntılarını ve sahip oldukları hesapları burada bulabilirsiniz.",
    "Imagine, for a moment, that you own a shopping mall.\n\nEvery user who walks into a shop is considered a user.\n\nEvery merchant who runs a shop is considered a user.\n\nIn Tradly, all different (merchant or customer) users are called “Users”, and their unique details are stored in the user section. You can find their purchase details or the accounts they own.": "Bir alışveriş merkezinin sahibi olduğunuzu düşünün.\n\nBir mağazaya giren herkes kullanıcı sayılır.\n\nBir mağazayı işleten her satıcı da kullanıcı sayılır.\n\nTradly’de satıcı veya müşteri olsun herkes “Kullanıcı” olarak adlandırılır ve kendilerine ait bilgiler kullanıcı bölümünde saklanır. Satın alma ayrıntılarını ve sahip oldukları hesapları burada bulabilirsiniz.",
    "workspace.loading": "Çalışma alanı ayarları yükleniyor…",
    "Loading workspace settings…": "Çalışma alanı ayarları yükleniyor…",
    "workspace.kicker": "ÇALIŞMA ALANI",
    "WORKSPACE": "ÇALIŞMA ALANI",
    "workspace.fallback_name": "Çalışma alanı",
    "workspace.members.title": "Ekip üyesi davet et",
    "Invite Team Member": "Ekip üyesi davet et",
    "workspace.members.description": "Ekip arkadaşlarınızı ekleyin ve herkese yalnızca ihtiyaç duyduğu erişimi verin.",
    "Add teammates and give each person only the access they need.": "Ekip arkadaşlarınızı ekleyin ve herkese yalnızca ihtiyaç duyduğu erişimi verin.",
    "workspace.members.enter_name_email": "Üye adı ve e-posta adresi girin.",
    "Enter a member name and email address.": "Üye adı ve e-posta adresi girin.",
    "workspace.members.invitation_sent": "Davet gönderildi.",
    "Invitation sent.": "Davet gönderildi.",
    "workspace.members.confirm_remove": "{name} adlı kişiyi bu çalışma alanından kaldırmak istiyor musunuz?",
    "Remove {name} from this workspace?": "{name} adlı kişiyi bu çalışma alanından kaldırmak istiyor musunuz?",
    "workspace.members.removed": "Üye ekipten kaldırıldı.",
    "Team member removed.": "Üye ekipten kaldırıldı.",
    "workspace.members.roles_saved": "Üye rolleri kaydedildi.",
    "Member roles saved.": "Üye rolleri kaydedildi.",
    "workspace.members.read": "Oku",
    "Read": "Oku",
    "workspace.members.write": "Yaz",
    "Write": "Yaz",
    "workspace.members.delete": "Sil",
    "workspace.members.select_all_permission": "{group} içindeki tüm {permission} izinlerini seçin",
    "Select all {permission} in {group}": "{group} içindeki tüm {permission} izinlerini seçin",
    "workspace.members.member_name": "Üye adı",
    "Member Name": "Üye adı",
    "workspace.members.email_address": "E-posta adresi",
    "Email Address": "E-posta adresi",
    "workspace.members.sending": "Gönderiliyor…",
    "Sending…": "Gönderiliyor…",
    "workspace.members.send_invitation": "Davet gönder",
    "Send invitation": "Davet gönder",
    "workspace.members.team_members": "Ekip üyeleri",
    "Team members": "Ekip üyeleri",
    "workspace.members.search_members": "Üyelerde ara",
    "Search members": "Üyelerde ara",
    "workspace.members.search": "Ara",
    "workspace.members.member": "Üye",
    "Member": "Üye",
    "workspace.members.email": "E-posta",
    "workspace.members.status": "Durum",
    "workspace.members.actions": "İşlemler",
    "workspace.members.unnamed": "Adsız üye",
    "Unnamed member": "Adsız üye",
    "workspace.members.roles": "Roller",
    "Roles": "Roller",
    "workspace.members.empty": "Ekip üyesi bulunamadı.",
    "No team members found.": "Ekip üyesi bulunamadı.",
    "workspace.members.page_of": "{pages} sayfadan {page}.",
    "Page {page} of {pages}": "{pages} sayfadan {page}.",
    "workspace.members.assign_roles": "Rol ata",
    "Assign roles": "Rol ata",
    "workspace.members.save_roles": "Rolleri kaydet",
    "Save roles": "Rolleri kaydet",
    "workspace.members.saving": "Kaydediliyor…",
    "Saving…": "Kaydediliyor…",
    "workspace.error.generic": "Bir hata oluştu. Lütfen tekrar deneyin.",
    "Something went wrong. Please try again.": "Bir hata oluştu. Lütfen tekrar deneyin.",
    "workspace.billing.view_label": "Çalışma alanı faturalandırma görünümü",
    "Billing workspace view": "Çalışma alanı faturalandırma görünümü",
    "workspace.billing.tab_usage": "Kullanım",
    "Usage": "Kullanım",
    "workspace.billing.tab_plans": "Planlar",
    "workspace.billing.tab_invoices": "Ödenen faturalar",
    "Paid invoices": "Ödenen faturalar",
    "workspace.billing.tab_account": "Hesap",
    "Account": "Hesap",
    "workspace.account.title": "İşletme ayarları",
    "Business Settings": "İşletme ayarları",
    "workspace.account.description": "İşletme profilinizi, etkin ürünleri ve hesap gizliliğini yönetin.",
    "Manage your business profile, enabled products, and account privacy.": "İşletme profilinizi, etkin ürünleri ve hesap gizliliğini yönetin.",
    "workspace.account.profile_updated": "İşletme profili güncellendi.",
    "Business profile updated.": "İşletme profili güncellendi.",
    "workspace.account.logo_updated": "Logo güncellendi.",
    "Logo updated.": "Logo güncellendi.",
    "workspace.account.logo_upload_error": "Logo yüklenemedi.",
    "Unable to upload logo.": "Logo yüklenemedi.",
    "workspace.account.confirm_delete": "Bu Tradly hesabı kalıcı olarak silinsin mi? Bu işlem geri alınamaz.",
    "Delete this Tradly account permanently? This cannot be undone.": "Bu Tradly hesabı kalıcı olarak silinsin mi? Bu işlem geri alınamaz.",
    "workspace.account.business_profile": "İşletme profili",
    "Business Profile": "İşletme profili",
    "workspace.account.logo": "Logo",
    "Logo": "Logo",
    "workspace.account.logo_alt": "İşletme logosu",
    "Business logo": "İşletme logosu",
    "workspace.account.add_photo": "Fotoğraf ekle",
    "Add photo": "Fotoğraf ekle",
    "workspace.account.logo_formats": "PNG, JPG, SVG veya ICO",
    "PNG, JPG, SVG or ICO": "PNG, JPG, SVG veya ICO",
    "workspace.account.business_name": "İşletme adı",
    "Business Name": "İşletme adı",
    "workspace.account.contact_name": "İşletme iletişim kişisi",
    "Business Contact Name": "İşletme iletişim kişisi",
    "workspace.account.business_address": "İşletme adresi",
    "Business Address": "İşletme adresi",
    "workspace.account.products_of_interest": "İlgilenilen ürünler",
    "Products of Interest": "İlgilenilen ürünler",
    "workspace.account.marketplace": "Pazaryeri",
    "workspace.account.single_store": "Tek mağazalı e-ticaret",
    "Single Store Commerce": "Tek mağazalı e-ticaret",
    "workspace.account.alacarte_products": "Tek tek ürünler",
    "À la carte Products": "Tek tek ürünler",
    "workspace.account.alacarte_description": "Bu çalışma alanı için etkinleştirilen tekil ürünler Planlar ve Faturalandırma bölümünden yönetilir.",
    "Individual products enabled for this workspace are managed from Plans & Billing.": "Bu çalışma alanı için etkinleştirilen tekil ürünler Planlar ve Faturalandırma bölümünden yönetilir.",
    "workspace.account.manage_alacarte": "Tek tek ürünleri yönet",
    "Manage à la carte products": "Tek tek ürünleri yönet",
    "workspace.account.delete_irreversible": "Hesabı silme: geri alınamaz",
    "Delete your Account: Irreversible": "Hesabı silme: geri alınamaz",
    "workspace.account.delete_description": "Bu işlem Tradly kiracısını ve ilişkili tüm verileri kalıcı olarak siler.",
    "This permanently deletes the Tradly tenant and all associated data.": "Bu işlem Tradly kiracısını ve ilişkili tüm verileri kalıcı olarak siler.",
    "workspace.account.deleting": "Siliniyor…",
    "Deleting…": "Siliniyor…",
    "workspace.account.delete_button": "Tradly hesabını sil",
    "Delete Account With Tradly": "Tradly hesabını sil",
    "workspace.privacy.title": "Gizlilik ve veri işleyenler",
    "Privacy & Data Processors": "Gizlilik ve veri işleyenler",
    "workspace.privacy.description": "Tradly hizmetini yürüten veri işleyenleri ve silme talebinden sonra verilerin nasıl saklandığını öğrenin.",
    "Understand which processors help operate Tradly and how retention works after a deletion request.": "Tradly hizmetini yürüten veri işleyenleri ve silme talebinden sonra verilerin nasıl saklandığını öğrenin.",
    "workspace.privacy.processor_retention": "Hizmeti yürütmek, ürün kalitesini artırmak, faturalandırmayı desteklemek ve güvenilirliği sağlamak için aşağıdaki hizmet ve araçları kullanıyoruz. Bu saklama süresi yalnızca kullanıcı hesap silme talebinde bulunduğunda geçerlidir. Tradly Platform kullanıcı verileri, operasyonel ve uyumluluk gereksinimlerine bağlı olarak yaklaşık 90–180 gün saklanır.",
    "We use the following processors and tools to operate the service, improve product quality, and support billing and reliability. This retention window applies only after a user requests account deletion. Tradly Platform user data is retained for approximately 90–180 days based on operational and compliance needs.": "Hizmeti yürütmek, ürün kalitesini artırmak, faturalandırmayı desteklemek ve güvenilirliği sağlamak için aşağıdaki hizmet ve araçları kullanıyoruz. Bu saklama süresi yalnızca kullanıcı hesap silme talebinde bulunduğunda geçerlidir. Tradly Platform kullanıcı verileri, operasyonel ve uyumluluk gereksinimlerine bağlı olarak yaklaşık 90–180 gün saklanır.",
    "workspace.privacy.read_more": "Daha fazla bilgi.",
    "Read more.": "Daha fazla bilgi.",
    "workspace.privacy.tool": "Araç",
    "Tool": "Araç",
    "workspace.privacy.purpose": "Amaç",
    "Purpose": "Amaç",
    "workspace.privacy.data_category": "Veri kategorisi",
    "Data Category": "Veri kategorisi",
    "workspace.privacy.deletion_requests": "Hesap ve veri silme talepleri",
    "Account deletion and data requests": "Hesap ve veri silme talepleri",
    "workspace.privacy.deletion_description": "Hesabın silinmesini veya müşteri ilişkileri aracından kaldırılmayı talep etmek için çalışma alanı yöneticinizle ya da destek ekibiyle iletişime geçin. Bu işlemler burada sunulmadan önce arka uç onayı gerektirir.",
    "To request account deletion or removal from a customer relationship tool, contact your workspace administrator or support. These actions require backend confirmation before they are exposed here.": "Hesabın silinmesini veya müşteri ilişkileri aracından kaldırılmayı talep etmek için çalışma alanı yöneticinizle ya da destek ekibiyle iletişime geçin. Bu işlemler burada sunulmadan önce arka uç onayı gerektirir.",
    "workspace.privacy.open_account": "Hesap ayarlarını aç",
    "Open account settings": "Hesap ayarlarını aç",
    "workspace.privacy.core_operations": "Temel ürün işlemleri",
    "Core product operations": "Temel ürün işlemleri",
    "workspace.privacy.user_data_retention": "Kullanıcı verileri (saklama: 90–180 gün)",
    "User data (retention: 90–180 days)": "Kullanıcı verileri (saklama: 90–180 gün)",
    "workspace.privacy.crm_support_lifecycle": "CRM, destek ve yaşam döngüsü iletişimi",
    "CRM, support, lifecycle communication": "CRM, destek ve yaşam döngüsü iletişimi",
    "workspace.privacy.personal_data": "Kişisel veriler",
    "Personal data": "Kişisel veriler",
    "workspace.privacy.product_analytics": "Ürün analitiği ve etkileşim hunileri",
    "Product analytics and engagement funnels": "Ürün analitiği ve etkileşim hunileri",
    "workspace.privacy.usage_events": "Kullanım ve etkinlik analitiği",
    "Usage and event analytics": "Kullanım ve etkinlik analitiği",
    "workspace.privacy.billing_payments": "Faturalandırma ve ödeme işleme",
    "Billing and payment processing": "Faturalandırma ve ödeme işleme",
    "workspace.privacy.billing_data": "Faturalandırma verileri",
    "Billing data": "Faturalandırma verileri",
    "workspace.privacy.traffic_analytics": "Trafik ve davranış analitiği",
    "Traffic and behavior analytics": "Trafik ve davranış analitiği",
    "workspace.privacy.usage_analytics": "Kullanım analitiği",
    "Usage analytics": "Kullanım analitiği",
    "workspace.privacy.session_diagnostics": "Oturum içgörüleri ve çalışmayan düğme tanılaması",
    "Session insights and broken-button diagnostics": "Oturum içgörüleri ve çalışmayan düğme tanılaması",
    "workspace.privacy.ux_telemetry": "UX/oturum telemetrisi",
    "UX/session telemetry": "UX/oturum telemetrisi",
    "workspace.privacy.error_monitoring": "Kod hatası ve kararlılık izleme",
    "Code error and stability monitoring": "Kod hatası ve kararlılık izleme",
    "workspace.privacy.error_logs": "Hata günlükleri ve tanılama",
    "Error logs and diagnostics": "Hata günlükleri ve tanılama",
    "workspace.privacy.email_delivery": "İşlemsel e-posta gönderimi",
    "Transactional email delivery": "İşlemsel e-posta gönderimi",
    "workspace.privacy.email_metadata": "E-posta üst verileri",
    "Email metadata": "E-posta üst verileri",
    "workspace.privacy.hosting_infrastructure": "Barındırma ve altyapı",
    "Hosting and infrastructure": "Barındırma ve altyapı",
    "workspace.privacy.infrastructure_logs": "Altyapı ve hizmet günlükleri",
    "Infrastructure and service logs": "Altyapı ve hizmet günlükleri",
    "workspace.domain.title": "Alan adları",
    "Domains": "Alan adları",
    "workspace.domain.description": "Varsayılan Tradly adresini kullanmak yerine kendi alan adınızı bağlayın.",
    "Connect your own domain to replace the default hosted Tradly URL.": "Varsayılan Tradly adresini kullanmak yerine kendi alan adınızı bağlayın.",
    "workspace.domain.invalid": "example.com gibi geçerli bir alan adı girin.",
    "Enter a valid domain, such as example.com.": "example.com gibi geçerli bir alan adı girin.",
    "workspace.domain.reserved": "tradly.co barındırılan çalışma alanı alan adları için ayrılmıştır.",
    "tradly.co is reserved for hosted workspace domains.": "tradly.co barındırılan çalışma alanı alan adları için ayrılmıştır.",
    "workspace.domain.missing_primary": "Birincil çalışma alanı alan adı mevcut değil.",
    "No primary workspace domain is available.": "Birincil çalışma alanı alan adı mevcut değil.",
    "workspace.domain.saved": "Özel alan adı kaydedildi. DNS kayıtlarınızı güncelleyin ve durumu yenileyin.",
    "Custom domain saved. Update your DNS records, then refresh its status.": "Özel alan adı kaydedildi. DNS kayıtlarınızı güncelleyin ve durumu yenileyin.",
    "workspace.domain.reset_success": "Alan adı barındırılan Tradly URL’sine sıfırlandı.",
    "Domain reset to the Tradly-hosted URL.": "Alan adı barındırılan Tradly URL’sine sıfırlandı.",
    "workspace.domain.current": "MEVCUT ALAN ADI",
    "CURRENT DOMAIN": "MEVCUT ALAN ADI",
    "workspace.domain.hosted": "Tradly tarafından barındırılan alan adı",
    "Tradly-hosted domain": "Tradly tarafından barındırılan alan adı",
    "workspace.domain.dns_status": "DNS durumu: {status}",
    "DNS status: {status}": "DNS durumu: {status}",
    "workspace.domain.checking": "DNS durumu denetleniyor…",
    "Checking DNS status…": "DNS durumu denetleniyor…",
    "workspace.domain.refresh": "Durumu yenile",
    "Refresh status": "Durumu yenile",
    "workspace.domain.reset": "Alan adını sıfırla",
    "Reset domain": "Alan adını sıfırla",
    "workspace.domain.connect_title": "Özel alan adı bağla",
    "Connect a custom domain": "Özel alan adı bağla",
    "workspace.domain.connect_description": "Sahip olduğunuz alan adını girin. Bağlamak için gereken DNS kayıtlarını göstereceğiz.",
    "Enter a domain you already own. We’ll show the DNS records required to connect it.": "Sahip olduğunuz alan adını girin. Bağlamak için gereken DNS kayıtlarını göstereceğiz.",
    "workspace.domain.saving": "Kaydediliyor…",
    "workspace.domain.add": "Alan adı ekle",
    "Add domain": "Alan adı ekle",
    "workspace.domain.dns_title": "DNS kurulumu",
    "DNS setup": "DNS kurulumu",
    "workspace.domain.a_record": "A kaydı",
    "A record": "A kaydı",
    "workspace.domain.root_description": "Kök alan adı için kullanın, örneğin",
    "Use this for a root domain such as": "Kök alan adı için kullanın, örneğin",
    "workspace.domain.cname_record": "CNAME kaydı",
    "CNAME record": "CNAME kaydı",
    "workspace.domain.subdomain_description": "Alt alan adı için kullanın, örneğin",
    "Use this for a subdomain such as": "Alt alan adı için kullanın, örneğin",
    "workspace.domain.host": "Ana makine",
    "Host": "Ana makine",
    "workspace.domain.value": "Değer",
    "Value": "Değer",
    "workspace.domain.need_domain": "Bir alan adına mı ihtiyacınız var?",
    "Need a domain?": "Bir alan adına mı ihtiyacınız var?",
    "workspace.domain.buy_domain": "Google Domains veya GoDaddy üzerinden alan adı satın alıp bağlamak için buraya dönün.",
    "Buy a domain from Google Domains or GoDaddy, then return here to connect it.": "Google Domains veya GoDaddy üzerinden alan adı satın alıp bağlamak için buraya dönün.",
    "workspace.billing.title": "Faturalandırma ve kullanım",
    "Billing & Usage": "Faturalandırma ve kullanım",
    "workspace.billing.description": "Çalışma alanı planlarını, kullanımını ve faturalandırmasını yönetin.",
    "Manage workspace plans, usage, and billing.": "Çalışma alanı planlarını, kullanımını ve faturalandırmasını yönetin.",
    "workspace.billing.invoice_description": "Çalışma alanı planlarını, kullanımını ve ödenen faturaları yönetin.",
    "Manage workspace plans, usage, and paid invoices.": "Çalışma alanı planlarını, kullanımını ve ödenen faturaları yönetin.",
    "workspace.billing.usage_description": "Mevcut kullanımı ve bu çalışma alanına uygulanan sınırları görün.",
    "workspace.invoices.loading": "Faturalar yükleniyor…",
    "Loading invoices…": "Faturalar yükleniyor…",
    "workspace.invoices.description": "Faturaları indirin veya bekleyen bakiyeyi ödeyin.",
    "Download invoices or complete payment for an outstanding balance.": "Faturaları indirin veya bekleyen bakiyeyi ödeyin.",
    "workspace.invoices.payment_failed": "Ödeme başarısız — hizmet erişimi etkilenebilir.",
    "Payment failed — service access may be affected.": "Ödeme başarısız — hizmet erişimi etkilenebilir.",
    "workspace.invoices.awaiting_payment": "{invoice} numaralı faturanın ödemesi bekleniyor.",
    "Invoice {invoice} is awaiting payment.": "{invoice} numaralı faturanın ödemesi bekleniyor.",
    "workspace.invoices.outstanding": "ödenmemiş",
    "outstanding": "ödenmemiş",
    "workspace.invoices.pay_invoice": "Faturayı öde",
    "Pay invoice": "Faturayı öde",
    "workspace.invoices.invoice": "Fatura",
    "workspace.invoices.date": "Tarih",
    "workspace.invoices.amount": "Tutar",
    "workspace.invoices.paid": "Ödendi",
    "workspace.invoices.unpaid": "Ödenmedi",
    "Unpaid": "Ödenmedi",
    "workspace.invoices.download_invoice": "Faturayı indir",
    "Download invoice": "Faturayı indir",
    "workspace.invoices.empty_title": "Fatura bulunamadı",
    "No invoices available": "Fatura bulunamadı",
    "workspace.invoices.empty_description": "Faturalar abone olup ödeme yaptıktan sonra oluşturulur. Sorularınız varsa destek ekibiyle iletişime geçin.",
    "Invoices are created after you subscribe and make a payment. Contact support if you have any questions.": "Faturalar abone olup ödeme yaptıktan sonra oluşturulur. Sorularınız varsa destek ekibiyle iletişime geçin.",
    "workspace.plans.heading": "Planlar",
    "workspace.plans.tab_marketplace": "Pazaryeri",
    "workspace.plans.tab_marketplace_description": "Çok satıcılı",
    "Multi-vendor": "Çok satıcılı",
    "workspace.plans.tab_single": "Tek mağaza",
    "Single Store": "Tek mağaza",
    "workspace.plans.tab_single_description": "Bağımsız üreticiler ve işletmeler için",
    "Indie & Creators": "Bağımsız üreticiler ve işletmeler için",
    "workspace.plans.tab_alacarte": "Tek tek ürünler",
    "A la carte": "Tek tek ürünler",
    "workspace.plans.tab_alacarte_description": "Krediler ve eklentiler",
    "Credits & add-ons": "Krediler ve eklentiler",
    "workspace.plans.tab_services": "Hizmetler",
    "Services": "Hizmetler",
    "workspace.plans.tab_services_description": "Ek hizmetler",
    "Additional services": "Ek hizmetler",
    "workspace.plans.selected": "Seçildi",
    "Selected": "Seçildi",
    "workspace.plans.try_again": "Tekrar dene",
    "workspace.plans.bill_yearly": "Yıllık faturalandır",
    "Bill Yearly": "Yıllık faturalandır",
    "workspace.plans.bill_monthly": "Aylık faturalandır",
    "Bill Monthly": "Aylık faturalandır",
    "workspace.plans.compare": "Planları karşılaştır",
    "Compare Plans": "Planları karşılaştır",
    "workspace.plans.community": "Topluluk",
    "workspace.plans.community_description": "Sonsuza kadar ücretsiz. Hobi ve topluluk projeleri için ideal.",
    "Free forever. Perfect for hobbyists and community projects.": "Sonsuza kadar ücretsiz. Hobi ve topluluk projeleri için ideal.",
    "workspace.plans.different_configurations": "Farklı bir yapılandırma mı arıyorsunuz?",
    "Looking for different configurations?": "Farklı bir yapılandırma mı arıyorsunuz?",
    "workspace.plans.contact_us": "Bize ulaşın",
    "Contact Us": "Bize ulaşın",
    "workspace.plans.see_alacarte_pricing": "Tek tek ürünlerin fiyatlarına bakın",
    "See à la carte pricing": "Tek tek ürünlerin fiyatlarına bakın",
    "workspace.plans.available": "Kullanılabilir",
    "Available": "Kullanılabilir",
    "workspace.plans.used_90d": "Kullanılan (90 gün)",
    "Used (90d)": "Kullanılan (90 gün)",
    "workspace.plans.expired_90d": "Süresi dolan (90 gün)",
    "Expired (90d)": "Süresi dolan (90 gün)",
    "workspace.plans.expires_on": "Son kullanma tarihi: {date}",
    "Expires {date}": "Son kullanma tarihi: {date}",
    "workspace.plans.top_up_credits": "Kredi yükle",
    "Top Up Credits": "Kredi yükle",
    "workspace.plans.credits_description": "Krediler e-posta, yapay zekâ araması, öneriler ve aracı işlemlerinde kullanılır. 100 kredi = $5.",
    "Credits power Email, AI Search, Recommendations, and Agent actions. 100 credits = $5.": "Krediler e-posta, yapay zekâ araması, öneriler ve aracı işlemlerinde kullanılır. 100 kredi = $5.",
    "workspace.plans.credits": "kredi",
    "credits": "kredi",
    "workspace.plans.custom_amount": "Özel tutar",
    "Custom amount": "Özel tutar",
    "workspace.plans.amount_example": "ör. 2500",
    "e.g. 2500": "ör. 2500",
    "workspace.plans.opening_checkout": "Ödeme sayfası açılıyor…",
    "Opening checkout…": "Ödeme sayfası açılıyor…",
    "workspace.plans.buy_credits": "{count} kredi satın al",
    "Buy {count} credits": "{count} kredi satın al",
    "workspace.plans.select_amount": "Tutar seçin",
    "Select an amount": "Tutar seçin",
    "workspace.plans.alacarte_products": "Tek tek ürünler",
    "A la carte Products": "Tek tek ürünler",
    "workspace.plans.products_description": "Kullandığınız ürünleri seçin. Böylece deneyiminizi size göre düzenleyebiliriz. Kullanım kredilerle ödenir.",
    "Select the products you use. This helps us tailor your experience. Usage is paid with credits.": "Kullandığınız ürünleri seçin. Böylece deneyiminizi size göre düzenleyebiliriz. Kullanım kredilerle ödenir.",
    "workspace.plans.enabled": "Etkin",
    "workspace.plans.enable": "Etkinleştir",
    "Enable": "Etkinleştir",
    "workspace.plans.open_here": "Burada aç",
    "Open here": "Burada aç",
    "workspace.plans.open_marketing": "marketing.tradly.app adresini aç",
    "Open marketing.tradly.app": "marketing.tradly.app adresini aç",
    "workspace.plans.open_analytics": "analytics.tradly.app adresini aç",
    "Open analytics.tradly.app": "analytics.tradly.app adresini aç",
    "workspace.plans.open_external": "Harici bağlantıyı aç",
    "Open external": "Harici bağlantıyı aç",
    "workspace.plans.coming_soon": "Yakında",
    "workspace.plans.services_title": "Tek seferlik kurulum ve özel hizmetler",
    "One-Time Setup & Custom Services": "Tek seferlik kurulum ve özel hizmetler",
    "workspace.plans.service_app_launch": "Markanıza özel uygulama yayını",
    "White-Label App Launch": "Markanıza özel uygulama yayını",
    "workspace.plans.service_frontend": "Ön yüz özelleştirmesi",
    "Frontend Customization": "Ön yüz özelleştirmesi",
    "workspace.plans.service_multilanguage": "Çoklu dil desteği",
    "Multi-Language Support": "Çoklu dil desteği",
    "workspace.plans.view_docs": "Belgeleri görüntüle",
    "View Docs": "Belgeleri görüntüle",
    "workspace.plans.confirm_change": "Plan değişikliğini onaylayın",
    "Confirm your plan change": "Plan değişikliğini onaylayın",
    "workspace.plans.confirm_charge": "Ücretler peşin alınır ve abonelik tarihinizde faturalandırılır.",
    "Charges are prepaid and billed on your subscription date.": "Ücretler peşin alınır ve abonelik tarihinizde faturalandırılır.",
    "workspace.plans.confirm_promo": "Varsa promosyon kodlarını Stripe ödeme sırasında girebilirsiniz.",
    "Promotional codes can be entered during Stripe checkout where available.": "Varsa promosyon kodlarını Stripe ödeme sırasında girebilirsiniz.",
    "workspace.plans.confirm_delay": "Plan değişikliklerinin çalışma alanınızda görünmesi biraz zaman alabilir.",
    "Plan changes may take a moment to appear in your workspace.": "Plan değişikliklerinin çalışma alanınızda görünmesi biraz zaman alabilir.",
    "workspace.plans.payment_active": "Ödeme alındı. Planınız etkin.",
    "Payment received. Your plan is active.": "Ödeme alındı. Planınız etkin.",
    "workspace.plans.payment_method_updated": "Ödeme yöntemi güncellendi.",
    "Payment method updated.": "Ödeme yöntemi güncellendi.",
    "workspace.plans.payment_cancelled": "Ödeme tamamlanmadı, bu nedenle planınız değişmedi.",
    "Payment was not completed, so your plan has not changed.": "Ödeme tamamlanmadı, bu nedenle planınız değişmedi.",
    "workspace.plans.activating": "Ödeme alındı. Planınız etkinleştiriliyor…",
    "Payment received. Activating your plan…": "Ödeme alındı. Planınız etkinleştiriliyor…",
    "workspace.plans.activation_delayed": "Ödeme alındı. Planınızın etkinleştirilmesi biraz daha uzun sürüyor. Bir dakika sonra yenileyin.",
    "Payment received. Your plan is taking a little longer to activate. Please refresh in a minute.": "Ödeme alındı. Planınızın etkinleştirilmesi biraz daha uzun sürüyor. Bir dakika sonra yenileyin.",
    "workspace.plans.card_saved": "Kart kaydedildi ve abonelik güncellendi.",
    "Card saved and subscription updated.": "Kart kaydedildi ve abonelik güncellendi.",
    "workspace.plans.subscription_updated": "Abonelik güncellendi.",
    "Subscription updated.": "Abonelik güncellendi.",
    "workspace.plans.products_saved": "Tek tek ürünler kaydedildi.",
    "À la carte products saved.": "Tek tek ürünler kaydedildi.",
    "workspace.plans.minimum_credits": "En az 100 kredi girin.",
    "Enter at least 100 credits.": "En az 100 kredi girin.",
    "workspace.plans.credit_topup_description": "Kredi yüklemesi ({count} kredi)",
    "Credit Top-Up ({count} credits)": "Kredi yüklemesi ({count} kredi)",
    "workspace.plans.billing_details": "Mevcut fatura bilgileri",
    "Current billing details": "Mevcut fatura bilgileri",
    "workspace.plans.current_plan": "Mevcut plan",
    "Current Plan": "Mevcut plan",
    "workspace.plans.renews": "Yenilenme",
    "Renews": "Yenilenme",
    "workspace.plans.payment_method": "Ödeme yöntemi",
    "Payment method": "Ödeme yöntemi",
    "workspace.plans.opening": "Açılıyor…",
    "Opening…": "Açılıyor…",
    "workspace.plans.manage_payment_method": "Ödeme yöntemini yönet",
    "Manage payment method": "Ödeme yöntemini yönet",
    "workspace.plans.upgrade": "Planı yükselt",
    "Upgrade": "Planı yükselt",
    "workspace.plans.downgrade": "Planı düşür",
    "Downgrade": "Planı düşür",
    "workspace.plans.custom_price": "Özel fiyat",
    "workspace.plans.per_month_short": "/ay",
    "/month": "/ay",
    "workspace.plans.per_year_amount": "yıllık ({amount})",
    "per year ({amount})": "yıllık ({amount})",
    "workspace.plans.per_month_amount": "aylık ({amount})",
    "per month ({amount})": "aylık ({amount})",
    "workspace.plans.yearly_savings": "Yıllık {amount} tasarruf",
    "Save {amount} yearly": "Yıllık {amount} tasarruf",
    "workspace.plans.billed_yearly": "yıllık faturalandırılır",
    "billed yearly": "yıllık faturalandırılır",
    "workspace.plans.billed_monthly": "aylık faturalandırılır",
    "billed monthly": "aylık faturalandırılır",
    "workspace.plans.free_trial": "Ücretsiz deneme sürümündesiniz.",
    "You are on a free trial.": "Ücretsiz deneme sürümündesiniz.",
    "workspace.plans.updating": "Güncelleniyor…",
    "Updating…": "Güncelleniyor…",
    "workspace.plans.temporarily_unavailable": "Geçici olarak kullanılamıyor",
    "Temporarily unavailable": "Geçici olarak kullanılamıyor",
    "workspace.plans.whats_included": "Neler dahil",
    "What's included": "Neler dahil",
    "workspace.plans.products.auth.title": "Kimlik doğrulama",
    "Auth": "Kimlik doğrulama",
    "workspace.plans.products.auth.description": "Kimlik, SSO, izinler ve kullanıcı yönetimi.",
    "Identity, SSO, permissions, and user management.": "Kimlik, SSO, izinler ve kullanıcı yönetimi.",
    "workspace.plans.products.email.title": "E-posta",
    "workspace.plans.products.email.description": "İşlemsel ve pazarlama e-postaları yerleşik olarak sunulur.",
    "Transactional and marketing email, built in.": "İşlemsel ve pazarlama e-postaları yerleşik olarak sunulur.",
    "workspace.plans.products.analytics.title": "Analitik",
    "workspace.plans.products.analytics.description": "Web, uygulama ve aracılar için ücretsiz analitik.",
    "Free analytics for web, app, and agents.": "Web, uygulama ve aracılar için ücretsiz analitik.",
    "workspace.plans.products.crm.title": "CRM",
    "CRM": "CRM",
    "workspace.plans.products.crm.description": "Kullanıcı etkinliklerinden otomatik olarak veri alan CRM.",
    "A CRM that fills itself from user activity.": "Kullanıcı etkinliklerinden otomatik olarak veri alan CRM.",
    "workspace.plans.products.subscription.title": "Abonelikler",
    "Subscriptions": "Abonelikler",
    "workspace.plans.products.subscription.description": "Yinelenen faturalandırma, denemeler ve gecikmiş ödemeler yönetilir.",
    "Recurring billing, trials, and dunning — handled.": "Yinelenen faturalandırma, denemeler ve gecikmiş ödemeler yönetilir.",
    "workspace.plans.products.recommendation.title": "Öneriler",
    "Recommendations": "Öneriler",
    "workspace.plans.products.recommendation.description": "Her kullanıcıya gerçekten isteyeceği içerikleri gösterin.",
    "Show each user what they will actually want.": "Her kullanıcıya gerçekten isteyeceği içerikleri gösterin.",
    "workspace.plans.marketplace.2025-superstarter.title": "Temel",
    "Basic": "Temel",
    "workspace.plans.marketplace.2025-superstarter.description": "Küçük ekipler için idealdir. Community özelliklerine ek olarak white-label sunar (“Built with Tradly” rozetini kaldırır).",
    "Ideal for Small team. All Community features plus white-labeling (removes \"Built with Tradly\" badge).": "Küçük ekipler için idealdir. Community özelliklerine ek olarak white-label sunar (“Built with Tradly” rozetini kaldırır).",
    "workspace.plans.marketplace.2025-superstarter.button": "7 günlük denemeyi başlat",
    "Start 7 Days Trial": "7 günlük denemeyi başlat",
    "workspace.plans.marketplace.2025-superstarter.feature_1.title": "İşlem ücreti yok",
    "No transaction fee": "İşlem ücreti yok",
    "workspace.plans.marketplace.2025-superstarter.feature_2.title": "Tradly barındırmalı ücretsiz web sitesi",
    "Free Tradly hosted website": "Tradly barındırmalı ücretsiz web sitesi",
    "workspace.plans.marketplace.2025-superstarter.feature_3.title": "Özel alan adınızı ekleyin",
    "Add your custom domain": "Özel alan adınızı ekleyin",
    "workspace.plans.marketplace.2025-superstarter.feature_4.title": "Düzenleyici — 3 günlük sayfa geçmişi",
    "Editor - 3 Day page history": "Düzenleyici — 3 günlük sayfa geçmişi",
    "workspace.plans.marketplace.2025-starter.title": "Starter",
    "Starter": "Starter",
    "workspace.plans.marketplace.2025-starter.description": "İş fikrini doğrulayan girişimler için. Pazar testi ve ilk müşterileri kazanmak için gereken temel özellikleri içerir.",
    "For startups validating their business idea. Includes all essentials for market testing and initial customer acquisition.": "İş fikrini doğrulayan girişimler için. Pazar testi ve ilk müşterileri kazanmak için gereken temel özellikleri içerir.",
    "workspace.plans.marketplace.2025-starter.button": "7 günlük denemeyi başlat",
    "workspace.plans.marketplace.2025-starter.feature_1.title": "İşlem ücreti yok",
    "workspace.plans.marketplace.2025-starter.feature_2.title": "Sınırsız özel özellik",
    "Unlimited Custom Attributes": "Sınırsız özel özellik",
    "workspace.plans.marketplace.2025-starter.feature_3.title": "30 günlük sayfa geçmişi",
    "30 Day page history": "30 günlük sayfa geçmişi",
    "workspace.plans.marketplace.2025-starter.feature_4.title": "Ücretli abonelik",
    "Gated Subscription": "Ücretli abonelik",
    "workspace.plans.marketplace.2025-starter.feature_5.title": "Sosyal medya ile giriş",
    "Social Logins": "Sosyal medya ile giriş",
    "workspace.plans.marketplace.2025-starter.feature_6.title": "Webhook",
    "Webhooks": "Webhook",
    "workspace.plans.marketplace.2025-growth.title": "Growth",
    "Growth": "Growth",
    "workspace.plans.marketplace.2025-growth.description": "Büyüme aşamasındaki kanıtlanmış iş fikirleri için; özel ihtiyaçlar ve ek entegrasyonlar sunar.",
    "For proven ideas on their growth Stage. Have custom needs and additional integrations to grow.": "Büyüme aşamasındaki kanıtlanmış iş fikirleri için; özel ihtiyaçlar ve ek entegrasyonlar sunar.",
    "workspace.plans.marketplace.2025-growth.button": "7 günlük denemeyi başlat",
    "workspace.plans.marketplace.2025-growth.feature_1.title": "İşlem ücreti yok",
    "workspace.plans.marketplace.2025-growth.feature_2.title": "Özel gönderen e-postası",
    "Custom 'From Email'": "Özel gönderen e-postası",
    "workspace.plans.marketplace.2025-growth.feature_3.title": "Ek mini araçlar ve entegrasyonlar",
    "Additional Mini Tools & Integrations": "Ek mini araçlar ve entegrasyonlar",
    "workspace.plans.marketplace.2025-growth.feature_4.title": "Kişiye özel başlangıç görüşmeleri*",
    "Personalised Onboarding calls*": "Kişiye özel başlangıç görüşmeleri*",
    "workspace.plans.marketplace.2025-growth.feature_5.title": "90 günlük sayfa geçmişi",
    "90 Day page history": "90 günlük sayfa geçmişi",
    "workspace.plans.marketplace.2025-growth.feature_6.title": "Birden fazla para birimi ve dil",
    "Multi Currencies & Multi Languages": "Birden fazla para birimi ve dil",
    "workspace.plans.marketplace.2025-growth.feature_7.title": "Rol tabanlı erişim denetimi (RBAC)",
    "Role-based access control (RBAC)": "Rol tabanlı erişim denetimi (RBAC)",
    "workspace.plans.marketplace.2025-growth.feature_8.title": "Uygulamalar için yerleşik sohbet",
    "Inbuilt Chat for Apps": "Uygulamalar için yerleşik sohbet",
    "workspace.plans.marketplace.2025-scale.title": "Scale",
    "Scale": "Scale",
    "workspace.plans.marketplace.2025-scale.description": "Büyüme aşamasındaki ve özel çözümler ile farklı gereksinimler arayan işletmeler için.",
    "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.": "Büyüme aşamasındaki ve özel çözümler ile farklı gereksinimler arayan işletmeler için.",
    "workspace.plans.marketplace.2025-scale.button": "7 günlük denemeyi başlat",
    "workspace.plans.marketplace.2025-scale.feature_1.title": "İşlem ücreti yok",
    "workspace.plans.marketplace.2025-scale.feature_2.title": "Öncelikli destek",
    "Priority Support": "Öncelikli destek",
    "workspace.plans.marketplace.2025-scale.feature_3.title": "Birden fazla kanal (uygulama desteği)",
    "Multiple Channels (App Support)": "Birden fazla kanal (uygulama desteği)",
    "workspace.plans.marketplace.2025-scale.feature_4.title": "Tek oturum açma (SSO)",
    "Single Sign-on (SSO)": "Tek oturum açma (SSO)",
    "workspace.plans.marketplace.2025-scale.feature_5.title": "Sınırsız sayfa geçmişi",
    "Unlimited page history": "Sınırsız sayfa geçmişi",
    "workspace.plans.marketplace.2025-scale.feature_6.title": "Uygulamalar için yerleşik sohbet",
    "In-built Chat for Apps": "Uygulamalar için yerleşik sohbet",
    "workspace.plans.indie.go.title": "Pro",
    "Pro": "Pro",
    "workspace.plans.indie.go.description": "Büyüyen bir mağazanın ihtiyaçları: markalamayı kaldırın, alan adınızı ekleyin ve daha fazla araca erişin.",
    "Everything a growing store needs — remove branding, add your domain, and unlock more tools.": "Büyüyen bir mağazanın ihtiyaçları: markalamayı kaldırın, alan adınızı ekleyin ve daha fazla araca erişin.",
    "workspace.plans.indie.go.button": "7 günlük denemeyi başlat",
    "Start 7-day trial": "7 günlük denemeyi başlat",
    "workspace.plans.indie.go.feature_1.title": "Tradly markalaması yok",
    "No Tradly branding": "Tradly markalaması yok",
    "workspace.plans.indie.go.feature_2.title": "Özel alan adı",
    "Custom domain": "Özel alan adı",
    "workspace.plans.indie.go.feature_3.title": "Sınırsız ürün",
    "Unlimited products": "Sınırsız ürün",
    "workspace.plans.indie.go.feature_4.title": "E-posta kampanyaları",
    "Email campaigns": "E-posta kampanyaları",
    "workspace.plans.indie.go.feature_5.title": "Yapay zekâ önerileri",
    "AI Recommendations": "Yapay zekâ önerileri",
    "workspace.plans.indie.go.feature_6.title": "Talep bazlı destek",
    "Ticket-based support": "Talep bazlı destek",
    "workspace.plans.indie.genius.title": "Genius",
    "Genius": "Genius",
    "workspace.plans.indie.genius.description": "Büyümeyi hedefleyen mağazalar için tam yapay zekâ paketi, gelişmiş pazarlama ve tüm özellikler.",
    "workspace.plans.indie.genius.button": "7 günlük denemeyi başlat",
    "workspace.plans.indie.genius.feature_1.title": "Pro planındaki her şey",
    "Everything in Pro": "Pro planındaki her şey",
    "workspace.plans.indie.genius.feature_2.title": "Yapay zekâ aracıları (alışveriş asistanı vb.)",
    "AI Agents (Shopping Assistant, etc.)": "Yapay zekâ aracıları (alışveriş asistanı vb.)",
    "workspace.plans.indie.genius.feature_3.title": "Doğal dilde arama",
    "Natural language search": "Doğal dilde arama",
    "workspace.plans.indie.genius.feature_4.title": "Gelişmiş e-posta otomasyonu",
    "Advanced email automation": "Gelişmiş e-posta otomasyonu",
    "workspace.plans.indie.genius.feature_5.title": "Sınırsız öneri isteği",
    "Unlimited recommendation requests": "Sınırsız öneri isteği",
    "workspace.plans.indie.genius.feature_6.title": "Talep bazlı destek",
    "workspace.plans.marketplace.2025-starter.feature_4.info": "Kullanıcıların hesap açıp ilan göndermesi için abonelik ücreti.",
    "Subscription charges for people to open accounts & submit listings": "Kullanıcıların hesap açıp ilan göndermesi için abonelik ücreti.",
    "workspace.plans.marketplace.2025-starter.feature_5.info": "Google ve Meta ile kaydolma/giriş",
    "Signup/in via Google, Meta": "Google ve Meta ile kaydolma/giriş",
    "workspace.plans.marketplace.2025-starter.feature_6.info": "Zapier ve Make bağlantısı için",
    "To connect with Zapier & Make": "Zapier ve Make bağlantısı için",
    "workspace.plans.marketplace.2025-growth.feature_8.info": "Uygulama kullanıcıları için yerleşik mesajlaşma",
    "Native in-app messaging for your users": "Uygulama kullanıcıları için yerleşik mesajlaşma",
    "workspace.plans.marketplace.2025-scale.feature_2.info": "Kritik olmayan konularda 24 saat içinde yanıt",
    "24 hour response time for non-critical": "Kritik olmayan konularda 24 saat içinde yanıt",
    "common.continue": "Devam et",
    "Continue": "Devam et",
    "workspace.plans.free_plan": "Ücretsiz",
    "Free": "Ücretsiz",
    "workspace.usage.group_platform": "Platform ve çalışma alanı",
    "Platform & workspace": "Platform ve çalışma alanı",
    "workspace.usage.group_ai": "Yapay zekâ ve kullanım",
    "AI & usage": "Yapay zekâ ve kullanım",
    "workspace.usage.group_storage": "İçerik ve depolama",
    "Content & storage": "İçerik ve depolama",
    "workspace.usage.group_alacarte": "Tek tek ürünler",
    "workspace.usage.accounts": "Hesaplar",
    "workspace.usage.listings": "İlanlar",
    "workspace.usage.sites": "Çalışma alanındaki siteler",
    "Sites under workspace": "Çalışma alanındaki siteler",
    "workspace.usage.external_users": "Harici kullanıcılar",
    "External users": "Harici kullanıcılar",
    "workspace.usage.internal_users": "Dahili kullanıcılar",
    "Internal users": "Dahili kullanıcılar",
    "workspace.usage.ai_credits": "Yapay zekâ kredileri",
    "AI credits": "Yapay zekâ kredileri",
    "workspace.usage.storage": "Depolama",
    "Storage": "Depolama",
    "workspace.usage.email": "E-posta",
    "workspace.usage.maps": "Haritalar",
    "workspace.usage.sms": "SMS",
    "SMS": "SMS",
    "workspace.usage.whatsapp": "WhatsApp",
    "WhatsApp": "WhatsApp",
    "workspace.usage.analytics": "Analitik",
    "workspace.usage.recommendations": "Öneriler",
    "workspace.usage.ai_agents": "Yapay zekâ aracıları",
    "AI agents": "Yapay zekâ aracıları",
    "workspace.usage.status_not_reported": "Raporlanmadı",
    "Not reported": "Raporlanmadı",
    "workspace.usage.status_nearly_full": "Neredeyse dolu",
    "Nearly full": "Neredeyse dolu",
    "workspace.usage.status_on_track": "Yolunda",
    "On track": "Yolunda",
    "workspace.usage.workspace_files": "Çalışma alanı dosyaları",
    "Workspace files": "Çalışma alanı dosyaları",
    "workspace.usage.workspace_usage": "Çalışma alanı kullanımı",
    "Workspace usage": "Çalışma alanı kullanımı",
    "workspace.usage.of_limit": "/ {limit}",
    "of {limit}": "/ {limit}",
    "workspace.usage.no_cap": "Limit yapılandırılmamış",
    "No cap configured": "Limit yapılandırılmamış",
    "workspace.usage.trend": "Kullanım eğilimi",
    "Usage trend": "Kullanım eğilimi",
    "workspace.usage.unavailable": "Kullanım verileri geçici olarak kullanılamıyor.",
    "Usage data is temporarily unavailable.": "Kullanım verileri geçici olarak kullanılamıyor.",
    "workspace.usage.loading": "Çalışma alanı kullanımı yükleniyor…",
    "Loading workspace usage…": "Çalışma alanı kullanımı yükleniyor…",
    "workspace.usage.overview": "Çalışma alanına genel bakış",
    "Workspace overview": "Çalışma alanına genel bakış",
    "workspace.usage.title": "Kullanım dökümü",
    "Usage breakdown": "Kullanım dökümü",
    "workspace.usage.description": "Çalışma alanınızın ne kadar kullandığını ve mevcut planınızda ne kadar alan kaldığını görün.",
    "See what your workspace has used and how much room remains on your current plan.": "Çalışma alanınızın ne kadar kullandığını ve mevcut planınızda ne kadar alan kaldığını görün.",
    "workspace.usage.view_plans": "Planları görüntüle",
    "workspace.usage.showing_available_limits": "Bu çalışma alanında mevcut olan limitler gösteriliyor.",
    "Showing the limits that are already available in this workspace.": "Bu çalışma alanında mevcut olan limitler gösteriliyor.",
    "workspace.usage.summary": "Kullanım özeti",
    "Usage summary": "Kullanım özeti",
    "workspace.usage.metrics_tracked": "İzlenen ölçümler",
    "Metrics tracked": "İzlenen ölçümler",
    "workspace.usage.metrics_count": "{total} ölçümden {count}",
    "{count} of {total}": "{total} ölçümden {count}",
    "workspace.usage.next_reset": "Sonraki sıfırlama",
    "Next reset": "Sonraki sıfırlama",
    "workspace.usage.not_provided": "Belirtilmedi",
    "Not provided": "Belirtilmedi",
    "workspace.usage.data_source": "Veri kaynağı",
    "Data source": "Veri kaynağı",
    "workspace.usage.clear_view": "Çalışma alanınızın net görünümü",
    "A clear view of your workspace": "Çalışma alanınızın net görünümü",
    "workspace.usage.by_resource": "Kaynağa göre",
    "Usage by resource": "Kaynağa göre",
    "workspace.usage.live_summary": "Canlı özet",
    "Live summary": "Canlı özet",
    "workspace.usage.resource": "Kaynak",
    "Resource": "Kaynak",
    "workspace.usage.used_limit": "Kullanım / limit",
    "Used / limit": "Kullanım / limit",
    "workspace.usage.progress": "İlerleme",
    "Progress": "İlerleme",
    "workspace.usage.cost": "Maliyet",
    "Cost": "Maliyet",
    "workspace.usage.footnote": "Kullanım ve limitler çalışma alanı kullanım hizmetinden alınır. Tire işareti, bu ölçümün mevcut API tarafından henüz bildirilmediğini gösterir.",
    "Usage and limits come from the workspace usage service. A dash means that metric is not reported by the current API yet.": "Kullanım ve limitler çalışma alanı kullanım hizmetinden alınır. Tire işareti, bu ölçümün mevcut API tarafından henüz bildirilmediğini gösterir.",
    "workspace.usage.refresh": "Yenile",
    "Refresh": "Yenile",
    "maps.title": "Haritalar",
    "maps.tab.analysis": "Pazar taraması",
    "Market scan": "Pazar taraması",
    "maps.tab.usage": "Kullanım",
    "maps.tab.settings": "Ayarlar",
    "maps.action.save": "Kaydet",
    "maps.action.saving": "Kaydediliyor…",
    "maps.action.analyze_area": "Bölgeyi analiz et",
    "Analyze area": "Bölgeyi analiz et",
    "maps.action.analyzing": "Analiz ediliyor…",
    "Analyzing…": "Analiz ediliyor…",
    "maps.action.refresh": "Yenile",
    "maps.action.loading": "Yükleniyor…",
    "Loading…": "Yükleniyor…",
    "maps.action.open_in_maps": "Haritalar’da aç",
    "Open in Maps": "Haritalar’da aç",
    "maps.analysis.title": "Yerel pazarı keşfedin",
    "Explore a local market": "Yerel pazarı keşfedin",
    "maps.analysis.description": "Google’ın önerilen konum çevresinde listelediği işletmeleri görün. Bu, talep veya uygulanabilirlik tahmini değil, ilk rekabet taramasıdır.",
    "See businesses Google lists around a proposed location. This is an initial competition scan, not a demand or viability forecast.": "Google’ın önerilen konum çevresinde listelediği işletmeleri görün. Bu, talep veya uygulanabilirlik tahmini değil, ilk rekabet taramasıdır.",
    "maps.analysis.address_label": "Adres veya yerleşim yeri",
    "Address or locality": "Adres veya yerleşim yeri",
    "maps.analysis.address_placeholder": "Cadde, semt veya şehir",
    "Street, suburb, or city": "Cadde, semt veya şehir",
    "maps.analysis.category_label": "İşletme türü",
    "Business type": "İşletme türü",
    "maps.analysis.radius_label": "Arama yarıçapı",
    "Search radius": "Arama yarıçapı",
    "maps.analysis.places_listings": "Harita kayıtları",
    "Places listings": "Harita kayıtları",
    "maps.analysis.within_radius": "{radius} içinde {category}",
    "{category} within {radius}": "{radius} içinde {category}",
    "maps.analysis.results_description": "Sonuçlar kategori ve yarıçapa göre filtrelenir, ardından mesafeye göre sıralanır.",
    "Results are filtered by category and radius, then ordered by distance.": "Sonuçlar kategori ve yarıçapa göre filtrelenir, ardından mesafeye göre sıralanır.",
    "maps.analysis.result_limit_notice": "Google en fazla 20 yer gösterdi. Gerçek sayı daha fazla olabilir; daha ayrıntılı sonuç için yarıçapı küçültün.",
    "Google returned the maximum of 20 places. The actual number may be higher; try a smaller radius for a more detailed scan.": "Google en fazla 20 yer gösterdi. Gerçek sayı daha fazla olabilir; daha ayrıntılı sonuç için yarıçapı küçültün.",
    "maps.analysis.limitations": "Kayıtlar eksik olabilir; müşteri talebini, yaya trafiğini, nüfusu, kirayı veya kârlılığı ölçmez. Yerel araştırmanızda bunu girdilerden biri olarak kullanın.",
    "Listings can be incomplete and do not measure customer demand, footfall, population, rent, or profitability. Use this as one input to local research.": "Kayıtlar eksik olabilir; müşteri talebini, yaya trafiğini, nüfusu, kirayı veya kârlılığı ölçmez. Yerel araştırmanızda bunu girdilerden biri olarak kullanın.",
    "maps.analysis.nearby_businesses": "Yakındaki işletmeler ({count})",
    "Nearby businesses ({count})": "Yakındaki işletmeler ({count})",
    "maps.analysis.businesses": "İşletmeler",
    "Businesses": "İşletmeler",
    "maps.analysis.no_listings": "Bu bölge ve kategori için Google Haritalar’da eşleşen kayıt bulunamadı.",
    "No matching Google Maps listings were returned for this area and category.": "Bu bölge ve kategori için Google Haritalar’da eşleşen kayıt bulunamadı.",
    "maps.category.retail": "Perakende",
    "Retail": "Perakende",
    "maps.category.grocery": "Market ürünleri",
    "Grocery": "Market ürünleri",
    "maps.category.clothing": "Giyim",
    "Clothing": "Giyim",
    "maps.category.pharmacy": "Eczane",
    "Pharmacy": "Eczane",
    "maps.category.restaurant": "Restoran / kafe",
    "Restaurant / café": "Restoran / kafe",
    "maps.competition.limited": "Listelenen rakip sayısı az",
    "Limited listed competition": "Listelenen rakip sayısı az",
    "maps.competition.some": "Listelenen bazı rakipler",
    "Some listed competition": "Listelenen bazı rakipler",
    "maps.competition.many": "Listelenen çok sayıda rakip",
    "Many listed competitors": "Listelenen çok sayıda rakip",
    "maps.competition.limit_reached": "En az 20 kayıt (sonuç sınırına ulaşıldı)",
    "At least 20 listings (result limit reached)": "En az 20 kayıt (sonuç sınırına ulaşıldı)",
    "maps.competition.default": "Listelenen rekabet",
    "Listed competition": "Listelenen rekabet",
    "maps.distance_km": "{value} km",
    "{value} km": "{value} km",
    "maps.distance_m": "{value} m",
    "{value} m": "{value} m",
    "maps.business_status.operational": "Faaliyette",
    "Operational": "Faaliyette",
    "maps.usage.title": "Sağlayıcı kullanımı",
    "Provider usage": "Sağlayıcı kullanımı",
    "maps.usage.description": "Maps hizmetinin kaydettiği istek sayısı. Ücretler ayrıca mutabık hale getirilir.",
    "Request counts recorded by the Maps service. Charges are reconciled separately.": "Maps hizmetinin kaydettiği istek sayısı. Ücretler ayrıca mutabık hale getirilir.",
    "maps.usage.days": "{count} gün",
    "{count} days": "{count} gün",
    "maps.usage.provider_requests": "Sağlayıcı istekleri",
    "Provider requests": "Sağlayıcı istekleri",
    "maps.usage.range_detail": "{count} günlük dönem",
    "{count} day window": "{count} günlük dönem",
    "maps.usage.successful": "Başarılı",
    "Successful": "Başarılı",
    "maps.usage.completed_calls": "Tamamlanan sağlayıcı çağrıları",
    "Completed provider calls": "Tamamlanan sağlayıcı çağrıları",
    "maps.usage.errors": "Hatalar",
    "Errors": "Hatalar",
    "maps.usage.failed_calls": "Başarısız sağlayıcı çağrıları",
    "Failed provider calls": "Başarısız sağlayıcı çağrıları",
    "maps.usage.metered_units": "Ölçümlenen birimler",
    "Metered units": "Ölçümlenen birimler",
    "maps.usage.unit_detail": "Kaydedilen her istek için bir birim",
    "One unit per recorded request": "Kaydedilen her istek için bir birim",
    "maps.usage.by_operation": "İşleme göre kullanım",
    "Usage by operation": "İşleme göre kullanım",
    "maps.usage.group_description": "Sayılar sağlayıcı, işlem ve sonuca göre gruplandırılır.",
    "Counts are grouped by provider, operation, and outcome.": "Sayılar sağlayıcı, işlem ve sonuca göre gruplandırılır.",
    "maps.usage.empty": "Bu tarih aralığında harita isteği yok.",
    "No map requests in this date range.": "Bu tarih aralığında harita isteği yok.",
    "maps.usage.provider": "Sağlayıcı",
    "Provider": "Sağlayıcı",
    "maps.usage.operation": "İşlem",
    "Operation": "İşlem",
    "maps.usage.outcome": "Sonuç",
    "Outcome": "Sonuç",
    "maps.usage.requests": "İstekler",
    "Requests": "İstekler",
    "maps.usage.units": "Birimler",
    "Units": "Birimler",
    "maps.settings.provider_title": "Harita sağlayıcısı",
    "Map provider": "Harita sağlayıcısı",
    "maps.settings.provider_description": "Veri gizliliği politikanızın izin verdiği sağlayıcıyı seçin. Sağlayıcı kimlik bilgileri Tradly tarafından yönetilir.",
    "Choose the provider allowed by your data privacy policy. Provider credentials are managed by Tradly.": "Veri gizliliği politikanızın izin verdiği sağlayıcıyı seçin. Sağlayıcı kimlik bilgileri Tradly tarafından yönetilir.",
    "maps.settings.selected": "Seçildi",
    "maps.settings.available": "Kullanılabilir",
    "maps.settings.planned": "Planlandı",
    "Planned": "Planlandı",
    "maps.settings.origins_title": "İzin verilen web sitesi kaynakları",
    "Allowed website origins": "İzin verilen web sitesi kaynakları",
    "maps.settings.origins_description": "Kayıtlı kiracı alan adlarına otomatik olarak izin verilir. Hazırlık ortamı gibi diğer sitelerin tam kaynak adreslerini buraya ekleyin.",
    "Registered tenant domains are allowed automatically. Add exact origins here for other sites such as staging.": "Kayıtlı kiracı alan adlarına otomatik olarak izin verilir. Hazırlık ortamı gibi diğer sitelerin tam kaynak adreslerini buraya ekleyin.",
    "maps.settings.registered_domains": "Kayıtlı alan adları",
    "Registered domains": "Kayıtlı alan adları",
    "maps.settings.no_domains": "Kayıtlı alan adı yüklenmedi.",
    "No registered domains were loaded.": "Kayıtlı alan adı yüklenmedi.",
    "maps.settings.origin_placeholder": "https://staging.example.com",
    "https://staging.example.com": "https://staging.example.com",
    "maps.settings.add_origin": "Kaynak ekle",
    "Add origin": "Kaynak ekle",
    "maps.settings.remove_origin": "Kaldır",
    "maps.settings.no_origins": "Ek kaynak eklenmedi.",
    "No extra origins added.": "Ek kaynak eklenmedi.",
    "maps.error.session_not_ready": "Yönetici oturumunuz henüz hazır değil.",
    "Your admin session is not ready yet.": "Yönetici oturumunuz henüz hazır değil.",
    "maps.error.load_data": "Maps verileri yüklenemedi ({status}).",
    "Unable to load Maps data ({status}).": "Maps verileri yüklenemedi ({status}).",
    "maps.error.load_usage": "Maps kullanım verileri yüklenemedi.",
    "Unable to load Maps usage.": "Maps kullanım verileri yüklenemedi.",
    "maps.error.load_settings": "Maps ayarları yüklenemedi.",
    "Unable to load Maps settings.": "Maps ayarları yüklenemedi.",
    "maps.error.save_settings": "Maps ayarları kaydedilemedi.",
    "Unable to save Maps settings.": "Maps ayarları kaydedilemedi.",
    "maps.error.invalid_origin": "https://staging.example.com gibi tam bir kaynak adresi girin.",
    "Enter a complete origin, such as https://staging.example.com.": "https://staging.example.com gibi tam bir kaynak adresi girin.",
    "maps.error.registered_origin": "Bu kaynak zaten kayıtlı bir alan adı tarafından kapsanıyor.",
    "This origin is already covered by a registered domain.": "Bu kaynak zaten kayıtlı bir alan adı tarafından kapsanıyor.",
    "maps.error.address_required": "Taramak için bir adres veya yerleşim yeri girin.",
    "Enter an address or locality to scan.": "Taramak için bir adres veya yerleşim yeri girin.",
    "maps.error.location_not_found": "Bu konum bulunamadı.",
    "Unable to find that location.": "Bu konum bulunamadı.",
    "maps.error.no_coordinates": "Bu adres için koordinat bulunamadı. Yakındaki bir caddeyi, semti veya şehri deneyin.",
    "No coordinates were found for that address. Try a nearby street, suburb, or city.": "Bu adres için koordinat bulunamadı. Yakındaki bir caddeyi, semti veya şehri deneyin.",
    "maps.error.analyze_area": "Bu bölge analiz edilemedi.",
    "Unable to analyze this area.": "Bu bölge analiz edilemedi.",
    "maps.notice.settings_saved": "Maps ayarları kaydedildi.",
    "Maps settings saved.": "Maps ayarları kaydedildi.",
    "maps.status.success": "Başarılı",
    "maps.status.error": "Hata",
    "maps.operation.geocode": "Coğrafi kodlama",
    "Geocode": "Coğrafi kodlama",
    "maps.operation.maps_geocode": "Maps coğrafi kodlama",
    "Maps geocode": "Maps coğrafi kodlama",
    "maps.operation.market_analysis": "Pazar analizi",
    "Market analysis": "Pazar analizi",
    "maps.operation.maps_market_analysis": "Maps pazar analizi",
    "Maps market analysis": "Maps pazar analizi",
    "maps.operation.places_search": "Yer arama",
    "Places search": "Yer arama",
    "maps.operation.places_nearby": "Yakındaki yerler",
    "Nearby places": "Yakındaki yerler",
    "maps.operation.place_details": "Yer ayrıntıları",
    "Place details": "Yer ayrıntıları",
    "common.loading": "Yükleniyor…",
    "common.saving": "Kaydediliyor…",
    "common.searching": "Aranıyor…",
    "Searching…": "Aranıyor…",
    "common.no_matches": "Eşleşme bulunamadı.",
    "No matches found.": "Eşleşme bulunamadı.",
    "common.select": "Seçin…",
    "Select…": "Seçin…",
    "common.search_users": "Kullanıcıları ada veya e-postaya göre ara",
    "Search users by name or email": "Kullanıcıları ada veya e-postaya göre ara",
    "common.reset": "Sıfırla",
    "Reset": "Sıfırla",
    "common.validation.email": "Geçerli bir e-posta adresi girin.",
    "Enter a valid email address.": "Geçerli bir e-posta adresi girin.",
    "common.validation.phone": "Geçerli bir telefon numarası girin.",
    "Enter a valid phone number.": "Geçerli bir telefon numarası girin.",
    "common.validation.currency": "USD gibi 3 harfli bir para birimi kodu kullanın.",
    "Use a 3-letter currency code, such as USD.": "USD gibi 3 harfli bir para birimi kodu kullanın.",
    "common.validation.location": "Geçerli bir adres veya konum girin.",
    "Enter a valid address or location.": "Geçerli bir adres veya konum girin.",
    "common.validation.required": "{label} gereklidir.",
    "{label} is required.": "{label} gereklidir.",
    "common.validation.invalid": "{label} geçersiz.",
    "{label} is invalid.": "{label} geçersiz.",
    "common.status.active": "Etkin",
    "common.status.inactive": "Etkin değil",
    "common.status.open": "Açık",
    "common.status.closed": "Kapalı",
    "Closed": "Kapalı",
    "common.status.posted": "Kaydedildi",
    "Posted": "Kaydedildi",
    "common.status.voided": "Geçersiz kılındı",
    "Voided": "Geçersiz kılındı",
    "common.status.draft": "Taslak",
    "Draft": "Taslak",
    "common.status.success": "Başarılı",
    "common.status.error": "Hata",
    "accounting.title": "Muhasebe",
    "accounting.description": "Hesapları, eşlemeleri, dönemleri, yevmiye kayıtlarını ve finansal raporları yönetin.",
    "Manage accounts, mappings, periods, journals, and financial reports.": "Hesapları, eşlemeleri, dönemleri, yevmiye kayıtlarını ve finansal raporları yönetin.",
    "accounting.tab.overview": "Genel bakış",
    "Overview": "Genel bakış",
    "accounting.tab.accounts": "Hesap planı",
    "Chart of accounts": "Hesap planı",
    "accounting.tab.mappings": "Hesap eşlemeleri",
    "Account mappings": "Hesap eşlemeleri",
    "accounting.tab.periods": "Muhasebe dönemleri",
    "Accounting periods": "Muhasebe dönemleri",
    "accounting.tab.journals": "Yevmiye kayıtları",
    "Journals": "Yevmiye kayıtları",
    "accounting.tab.reports": "Raporlar",
    "accounting.account.edit_title": "Hesabı düzenle",
    "Edit account": "Hesabı düzenle",
    "accounting.account.new_title": "Yeni hesap",
    "New account": "Yeni hesap",
    "accounting.account.save": "Hesabı kaydet",
    "Save account": "Hesabı kaydet",
    "accounting.account.create": "Hesap oluştur",
    "Create account": "Hesap oluştur",
    "accounting.account.code": "Hesap kodu",
    "Account code": "Hesap kodu",
    "accounting.account.name": "Hesap adı",
    "Account name": "Hesap adı",
    "accounting.account.type": "Hesap türü",
    "Account type": "Hesap türü",
    "accounting.account.currency_id": "Para birimi kimliği",
    "Currency ID": "Para birimi kimliği",
    "accounting.account.active": "Etkin",
    "accounting.account.unnamed": "Adsız hesap",
    "Unnamed account": "Adsız hesap",
    "accounting.account.code_placeholder": "6100",
    "accounting.account.name_placeholder": "Bordro gideri",
    "Payroll expense": "Bordro gideri",
    "accounting.type.asset": "Varlık",
    "Asset": "Varlık",
    "accounting.type.liability": "Yükümlülük",
    "Liability": "Yükümlülük",
    "accounting.type.equity": "Özkaynak",
    "Equity": "Özkaynak",
    "accounting.type.revenue": "Gelir",
    "Revenue": "Gelir",
    "accounting.type.expense": "Gider",
    "Expense": "Gider",
    "accounting.toast.account_updated": "Hesap güncellendi",
    "Account updated": "Hesap güncellendi",
    "accounting.toast.account_created": "Hesap oluşturuldu",
    "Account created": "Hesap oluşturuldu",
    "accounting.toast.defaults_created": "Varsayılan hesaplar oluşturuldu",
    "Default accounts created": "Varsayılan hesaplar oluşturuldu",
    "accounting.toast.mapping_saved": "Eşleme kaydedildi",
    "Mapping saved": "Eşleme kaydedildi",
    "accounting.toast.period_closed": "Muhasebe dönemi kapatıldı",
    "Accounting period closed": "Muhasebe dönemi kapatıldı",
    "accounting.toast.period_created": "Muhasebe dönemi oluşturuldu",
    "Period created": "Muhasebe dönemi oluşturuldu",
    "accounting.toast.journal_created": "Yevmiye kaydı oluşturuldu",
    "Journal created": "Yevmiye kaydı oluşturuldu",
    "accounting.toast.journal_voided": "Yevmiye kaydı iptal edildi",
    "Journal voided": "Yevmiye kaydı iptal edildi",
    "accounting.validation.journal_balanced": "Yevmiye kaydında tarih ve açıklama bulunmalı; borç ve alacak toplamları dengelenmelidir.",
    "Journal must have a date, description, and balanced debit and credit totals.": "Yevmiye kaydında tarih ve açıklama bulunmalı; borç ve alacak toplamları dengelenmelidir.",
    "accounting.filter.all_types": "Tüm hesap türleri",
    "All account types": "Tüm hesap türleri",
    "accounting.filter.all_statuses": "Tüm durumlar",
    "All statuses": "Tüm durumlar",
    "accounting.action.bootstrap": "Varsayılan hesapları oluştur",
    "Bootstrap defaults": "Varsayılan hesapları oluştur",
    "accounting.action.new_account": "Yeni hesap",
    "accounting.empty.accounts": "Hesap bulunamadı.",
    "No accounts found.": "Hesap bulunamadı.",
    "accounting.column.code": "Kod",
    "Code": "Kod",
    "accounting.column.account": "Hesap",
    "accounting.column.type": "Tür",
    "Type": "Tür",
    "accounting.column.currency": "Para birimi",
    "accounting.column.status": "Durum",
    "accounting.action.edit": "Düzenle",
    "accounting.mapping.edit_title": "Hesap eşlemesini düzenle",
    "Edit account mapping": "Hesap eşlemesini düzenle",
    "accounting.mapping.new_title": "Yeni hesap eşlemesi",
    "New account mapping": "Yeni hesap eşlemesi",
    "accounting.mapping.save": "Eşlemeyi kaydet",
    "Save mapping": "Eşlemeyi kaydet",
    "accounting.mapping.create": "Eşleme oluştur",
    "Create mapping": "Eşleme oluştur",
    "accounting.mapping.source_type": "Kaynak türü",
    "Source type": "Kaynak türü",
    "accounting.mapping.event_key": "Etkinlik anahtarı",
    "Event key": "Etkinlik anahtarı",
    "accounting.mapping.debit_account": "Borç hesabı",
    "Debit account": "Borç hesabı",
    "accounting.mapping.credit_account": "Alacak hesabı",
    "Credit account": "Alacak hesabı",
    "accounting.mapping.tax_account": "Vergi hesabı",
    "Tax account": "Vergi hesabı",
    "accounting.mapping.none": "Yok",
    "None": "Yok",
    "accounting.mapping.source_placeholder": "order",
    "order": "order",
    "accounting.mapping.event_placeholder": "payment_captured",
    "payment_captured": "payment_captured",
    "accounting.mapping.filter_placeholder": "Kaynak türünü filtrele",
    "Filter source type": "Kaynak türünü filtrele",
    "accounting.action.new_mapping": "Yeni eşleme",
    "New mapping": "Yeni eşleme",
    "accounting.empty.mappings": "Hesap eşlemesi bulunamadı.",
    "No account mappings found.": "Hesap eşlemesi bulunamadı.",
    "accounting.column.source": "Kaynak",
    "Source": "Kaynak",
    "accounting.column.event": "Etkinlik",
    "Event": "Etkinlik",
    "accounting.column.debit": "Borç",
    "Debit": "Borç",
    "accounting.column.credit": "Alacak",
    "Credit": "Alacak",
    "accounting.period.close_confirm": "{period} kapatılsın mı? Bu işlem geri alınamaz.",
    "Close {period}? This cannot be reversed.": "{period} kapatılsın mı? Bu işlem geri alınamaz.",
    "accounting.period.this": "bu muhasebe dönemi",
    "this accounting period": "bu muhasebe dönemi",
    "accounting.period.new_title": "Yeni muhasebe dönemi",
    "New accounting period": "Yeni muhasebe dönemi",
    "accounting.period.create": "Dönem oluştur",
    "Create period": "Dönem oluştur",
    "accounting.period.name": "Dönem adı",
    "Period name": "Dönem adı",
    "accounting.period.start": "Başlangıç tarihi",
    "accounting.period.end": "Bitiş tarihi",
    "End date": "Bitiş tarihi",
    "accounting.period.name_placeholder": "Ocak 2027",
    "January 2027": "Ocak 2027",
    "accounting.period.open": "Açık",
    "accounting.period.closed": "Kapalı",
    "accounting.action.new_period": "Yeni dönem",
    "New period": "Yeni dönem",
    "accounting.empty.periods": "Muhasebe dönemi bulunamadı.",
    "No accounting periods found.": "Muhasebe dönemi bulunamadı.",
    "accounting.column.period": "Dönem",
    "accounting.column.start": "Başlangıç",
    "Start": "Başlangıç",
    "accounting.column.end": "Bitiş",
    "End": "Bitiş",
    "accounting.action.close_period": "Dönemi kapat",
    "Close period": "Dönemi kapat",
    "accounting.journal.new_title": "Yeni yevmiye kaydı",
    "New journal": "Yeni yevmiye kaydı",
    "accounting.journal.balance_help": "Kaydetmeden önce borç ve alacak dengelenmelidir.",
    "Debits and credits must balance before saving.": "Kaydetmeden önce borç ve alacak dengelenmelidir.",
    "accounting.journal.close": "Kapat",
    "accounting.journal.entry_date": "Kayıt tarihi",
    "Entry date": "Kayıt tarihi",
    "accounting.journal.description": "Açıklama",
    "accounting.journal.source_type": "Kaynak türü",
    "accounting.journal.source_id": "Kaynak kimliği",
    "Source ID": "Kaynak kimliği",
    "accounting.journal.account": "Hesap",
    "accounting.journal.select_account": "Hesap seçin",
    "Select account": "Hesap seçin",
    "accounting.journal.debit_total": "Borç: {debit} · Alacak: {credit} · {status}",
    "Debit: {debit} · Credit: {credit} · {status}": "Borç: {debit} · Alacak: {credit} · {status}",
    "accounting.journal.balanced": "Dengeli",
    "Balanced": "Dengeli",
    "accounting.journal.unbalanced": "Dengeli değil",
    "Unbalanced": "Dengeli değil",
    "accounting.journal.add_line": "Satır ekle",
    "Add line": "Satır ekle",
    "accounting.journal.save": "Yevmiye kaydını kaydet",
    "Save journal": "Yevmiye kaydını kaydet",
    "accounting.journal.empty": "Yevmiye satırı yok.",
    "No journal lines.": "Yevmiye satırı yok.",
    "accounting.journal.reason_prompt": "Bu yevmiye kaydını geçersiz kılma nedeni:",
    "Reason for voiding this journal:": "Bu yevmiye kaydını geçersiz kılma nedeni:",
    "accounting.journal.details_title": "Yevmiye kaydı no. {id}",
    "Journal #{id}": "Yevmiye kaydı no. {id}",
    "accounting.action.view": "Görüntüle",
    "View": "Görüntüle",
    "accounting.action.void": "Geçersiz kıl",
    "Void": "Geçersiz kıl",
    "accounting.filter.all_accounts": "Tüm hesaplar",
    "All accounts": "Tüm hesaplar",
    "accounting.empty.journals": "Yevmiye kaydı bulunamadı.",
    "No journals found.": "Yevmiye kaydı bulunamadı.",
    "accounting.column.date": "Tarih",
    "accounting.column.description": "Açıklama",
    "accounting.column.account_source": "Kaynak",
    "accounting.empty.journal_lines": "Yevmiye satırı yok.",
    "accounting.report.trial_balance": "Mizan",
    "Trial balance": "Mizan",
    "accounting.report.general_ledger": "Büyük defter",
    "General ledger": "Büyük defter",
    "accounting.action.run_report": "Raporu çalıştır",
    "Run report": "Raporu çalıştır",
    "accounting.report.loading": "Rapor yükleniyor…",
    "Loading report…": "Rapor yükleniyor…",
    "accounting.empty.report": "Rapor satırı bulunamadı.",
    "No report rows found.": "Rapor satırı bulunamadı.",
    "accounting.report.choose_run": "Bir rapor seçip çalıştırın.",
    "Choose a report and run it.": "Bir rapor seçip çalıştırın.",
    "accounting.column.balance": "Bakiye",
    "Balance": "Bakiye",
    "accounting.overview.chart_title": "Hesap planı",
    "accounting.overview.chart_description": "Büyük defterinizde kullanılan hesapları tanımlayın.",
    "Define the accounts used by your ledger.": "Büyük defterinizde kullanılan hesapları tanımlayın.",
    "accounting.overview.journals_title": "Yevmiye kayıtları",
    "accounting.overview.journals_description": "Dengeli yevmiye kayıtları oluşturun ve inceleyin.",
    "Create and review balanced journal entries.": "Dengeli yevmiye kayıtları oluşturun ve inceleyin.",
    "accounting.overview.reports_title": "Raporlar",
    "accounting.overview.reports_description": "Mizan ve büyük defter raporlarını oluşturun.",
    "Run trial balance and general ledger reports.": "Mizan ve büyük defter raporlarını oluşturun.",
    "common.refresh": "Yenile",
    "reports.search.title": "Arama analitiği",
    "Search analytics": "Arama analitiği",
    "reports.search.back_to_report": "Rapora dön",
    "Back to report": "Rapora dön",
    "reports.search.description": "Arama talebi, ziyaretçilerin ne aradığını ve kataloğun hangi alanlarının geliştirilmesi gerektiğini gösterir.",
    "Search demand shows what visitors are looking for and where your catalog needs coverage.": "Arama talebi, ziyaretçilerin ne aradığını ve kataloğun hangi alanlarının geliştirilmesi gerektiğini gösterir.",
    "reports.search.metric.searches": "Aramalar",
    "Searches": "Aramalar",
    "reports.search.metric.unique_keywords": "Benzersiz anahtar kelimeler",
    "Unique keywords": "Benzersiz anahtar kelimeler",
    "reports.search.metric.with_listings": "İlanı olanlar",
    "With listings": "İlanı olanlar",
    "reports.search.metric.no_matches": "Eşleşen ilan yok",
    "No listing matches": "Eşleşen ilan yok",
    "reports.search.metric.coverage": "Kapsama",
    "Coverage": "Kapsama",
    "reports.search.insights.title": "Yönetici analizleri",
    "Admin insights": "Yönetici analizleri",
    "reports.search.insights.no_results_one": "{count} anahtar kelime için ilan bulunamadı. İlan oluşturmayı, terimi kategori veya etiket olarak eklemeyi ya da ilan başlığı ve açıklamasını iyileştirmeyi deneyin.",
    "{count} keyword returned no listings. Consider creating a listing, adding the term as a category or tag, or improving the listing title and description.": "{count} anahtar kelime için ilan bulunamadı. İlan oluşturmayı, terimi kategori veya etiket olarak eklemeyi ya da ilan başlığı ve açıklamasını iyileştirmeyi deneyin.",
    "reports.search.insights.no_results_many": "{count} anahtar kelime için ilan bulunamadı. İlan oluşturun, terimleri kategori veya etiket olarak ekleyin ya da ilan başlıklarını ve açıklamalarını iyileştirin.",
    "{count} keywords returned no listings. Consider creating listings, adding the terms as categories or tags, or improving listing titles and descriptions.": "{count} anahtar kelime için ilan bulunamadı. İlan oluşturun, terimleri kategori veya etiket olarak ekleyin ya da ilan başlıklarını ve açıklamalarını iyileştirin.",
    "reports.search.insights.all_covered": "İzlenen her anahtar kelime en az bir ilanla eşleşti. Ürün yerleşimini ve kategori konumlandırmasını iyileştirmek için sık kullanılan terimleri inceleyin.",
    "Every tracked keyword returned at least one listing. Review the most frequent terms to improve merchandising and category placement.": "İzlenen her anahtar kelime en az bir ilanla eşleşti. Ürün yerleşimini ve kategori konumlandırmasını iyileştirmek için sık kullanılan terimleri inceleyin.",
    "reports.search.insights.empty": "Ziyaretçiler pazaryerinde arama yaptığında veriler burada görünür.",
    "Search data will appear after visitors search the marketplace.": "Ziyaretçiler pazaryerinde arama yaptığında veriler burada görünür.",
    "reports.search.insights.total_matches": "Yüklenen arama kayıtlarında toplam {count} ilan eşleşmesi bulundu.",
    "{count} total listing matches were returned across the loaded search records.": "Yüklenen arama kayıtlarında toplam {count} ilan eşleşmesi bulundu.",
    "reports.search.coverage_title": "Anahtar kelime kapsamı",
    "Keyword coverage": "Anahtar kelime kapsamı",
    "reports.search.loading": "Arama analitiği yükleniyor…",
    "Loading search analytics…": "Arama analitiği yükleniyor…",
    "reports.search.empty": "Arama ifadesi bulunamadı.",
    "No search phrases found.": "Arama ifadesi bulunamadı.",
    "reports.search.error.load": "Arama analitiği yüklenemedi.",
    "Unable to load search analytics.": "Arama analitiği yüklenemedi.",
    "reports.search.unknown": "Bilinmeyen arama",
    "Unknown search": "Bilinmeyen arama",
    "reports.search.column.keyword": "Anahtar kelime",
    "Keyword": "Anahtar kelime",
    "reports.search.column.listings": "İlanlar",
    "reports.search.column.coverage": "Kapsama",
    "reports.search.column.last_searched": "Son arama",
    "Last searched": "Son arama",
    "reports.search.column.suggested_action": "Önerilen işlem",
    "Suggested action": "Önerilen işlem",
    "reports.search.status.covered": "Kapsandı",
    "Covered": "Kapsandı",
    "reports.search.status.no_matches": "Eşleşme yok",
    "No matches": "Eşleşme yok",
    "reports.search.action.review_ranking": "Sıralamayı incele",
    "Review ranking": "Sıralamayı incele",
    "reports.search.action.add_listing": "İlan veya kategori ekle",
    "Add listing or category": "İlan veya kategori ekle",
    "platform_health.title": "Platform sağlığı",
    "Platform health": "Platform sağlığı",
    "platform_health.tab.health": "Sağlık",
    "Health": "Sağlık",
    "platform_health.tab.configuration": "Yapılandırma",
    "Configuration": "Yapılandırma",
    "platform_health.action.refreshing": "Yenileniyor…",
    "Refreshing…": "Yenileniyor…",
    "platform_health.window_note": "Geçerli görünüm her etkinlik türü için ilk {count} kaydı yükler.",
    "The current view loads the first {count} records for each event type.": "Geçerli görünüm her etkinlik türü için ilk {count} kaydı yükler.",
    "platform_health.error.title": "Kimlik doğrulama denetimleri yüklenemedi",
    "Unable to load authentication audits": "Kimlik doğrulama denetimleri yüklenemedi",
    "platform_health.error.proxy_note": "API, bu yönetici isteğinin tarayıcıdan doğrudan değil sunucu üzerinden iletilmesini gerektirebilir.",
    "The API may require this admin request to be proxied server-side rather than sent directly by the browser.": "API, bu yönetici isteğinin tarayıcıdan doğrudan değil sunucu üzerinden iletilmesini gerektirebilir.",
    "platform_health.error.session": "Yönetici oturumunuz henüz hazır değil. Lütfen yeniden giriş yapın.",
    "Your admin session is not ready yet. Please sign in again.": "Yönetici oturumunuz henüz hazır değil. Lütfen yeniden giriş yapın.",
    "platform_health.error.load": "Kimlik doğrulama denetimleri yüklenemedi ({status}).",
    "Unable to load authentication audits ({status}).": "Kimlik doğrulama denetimleri yüklenemedi ({status}).",
    "platform_health.error.load_generic": "Platform sağlığı denetimleri yüklenemedi.",
    "Unable to load platform health audits.": "Platform sağlığı denetimleri yüklenemedi.",
    "platform_health.metric.login_attempts": "Giriş denemeleri",
    "Login attempts": "Giriş denemeleri",
    "platform_health.metric.signup_attempts": "Kayıt denemeleri",
    "Signup attempts": "Kayıt denemeleri",
    "platform_health.metric.audit_records": "Denetim kayıtları",
    "Audit records": "Denetim kayıtları",
    "platform_health.metric.successful": "Başarılı",
    "platform_health.metric.failed": "Başarısız",
    "platform_health.metric.outcome_returned": "Yalnızca sonuç döndürüldüğünde",
    "Only when outcome is returned": "Yalnızca sonuç döndürüldüğünde",
    "platform_health.metric.failure_rate": "Başarısızlık oranı",
    "Failure rate": "Başarısızlık oranı",
    "platform_health.metric.classified_records": "Sınıflandırılan kayıtlar",
    "Classified records": "Sınıflandırılan kayıtlar",
    "platform_health.activity.title": "Kimlik doğrulama etkinliği",
    "Authentication activity": "Kimlik doğrulama etkinliği",
    "platform_health.activity.description": "Seçili denetim aralığında döndürülen denemeler",
    "Attempts returned by the selected audit window": "Seçili denetim aralığında döndürülen denemeler",
    "platform_health.activity.no_timestamps": "Zaman damgalı denetim kaydı döndürülmedi.",
    "No timestamped audit records returned.": "Zaman damgalı denetim kaydı döndürülmedi.",
    "platform_health.event.login": "Giriş",
    "login": "Giriş",
    "platform_health.event.signup": "Kayıt",
    "signup": "Kayıt",
    "platform_health.status.success": "Başarılı",
    "platform_health.status.failed": "Başarısız",
    "platform_health.status.recorded": "Kaydedildi",
    "Recorded": "Kaydedildi",
    "platform_health.unknown_day": "Bilinmiyor",
    "Unknown": "Bilinmiyor",
    "platform_health.failure_reasons": "Başarısızlık nedenleri",
    "Failure reasons": "Başarısızlık nedenleri",
    "platform_health.no_failures": "Sınıflandırılmış başarısızlık bulunamadı.",
    "No classified failures returned.": "Sınıflandırılmış başarısızlık bulunamadı.",
    "platform_health.unspecified_failure": "Belirtilmemiş hata",
    "Unspecified failure": "Belirtilmemiş hata",
    "platform_health.recent_records": "Son denetim kayıtları",
    "Recent audit records": "Son denetim kayıtları",
    "platform_health.normalized_note": "Ham alanlar yalnızca görüntüleme için normalleştirilir.",
    "Raw fields are normalized only for display.": "Ham alanlar yalnızca görüntüleme için normalleştirilir.",
    "platform_health.loaded_count": "Yüklenen: {count}",
    "platform_health.loading_records": "Denetim kayıtları yükleniyor…",
    "Loading audit records…": "Denetim kayıtları yükleniyor…",
    "platform_health.no_records": "Denetim kaydı döndürülmedi.",
    "No audit records returned.": "Denetim kaydı döndürülmedi.",
    "platform_health.column.event": "Etkinlik",
    "platform_health.column.status": "Durum",
    "platform_health.column.user": "Kullanıcı",
    "User": "Kullanıcı",
    "platform_health.column.time": "Saat",
    "Time": "Saat",
    "platform_health.column.reason": "Neden",
    "Reason": "Neden",
    "platform_health.config.sign_in": "Giriş yöntemi",
    "Sign-in method": "Giriş yöntemi",
    "platform_health.config.facebook": "Facebook kimlik doğrulaması",
    "Facebook Auth": "Facebook kimlik doğrulaması",
    "platform_health.config.google": "Google kimlik doğrulaması",
    "Google Auth": "Google kimlik doğrulaması",
    "platform_health.config.twilio": "Twilio",
    "Twilio": "Twilio",
    "integrations.note.realtime": "Bu ayarlar hemen uygulanır. Kaydedildikten sonra uygulamalarda ve API yanıtlarında görünür.",
    "These settings apply immediately. After you save them, they appear in apps and API responses.": "Bu ayarlar hemen uygulanır. Kaydedildikten sonra uygulamalarda ve API yanıtlarında görünür.",
    "integrations.note.mobile_release": "Mobil uygulama kanalı ayarları ürün yayımlandığında veya güncellendiğinde geçerli olur. Yeni bir derleme için Destek Portalı’ndan talepte bulunun. Starter planı için geçerlidir.",
    "Mobile app channel settings apply when a product is released or updated. To get a new build, request one from the Support Portal. This applies to the Starter plan.": "Mobil uygulama kanalı ayarları ürün yayımlandığında veya güncellendiğinde geçerli olur. Yeni bir derleme için Destek Portalı’ndan talepte bulunun. Starter planı için geçerlidir.",
    "integrations.toast.saved": "Entegrasyon ayarları kaydedildi.",
    "Integration settings saved.": "Entegrasyon ayarları kaydedildi.",
    "integrations.error.save": "Entegrasyon ayarları kaydedilemedi.",
    "Unable to save integration settings.": "Entegrasyon ayarları kaydedilemedi.",
    "integrations.twilio.title": "Twilio entegrasyonu",
    "Twilio integration": "Twilio entegrasyonu",
    "integrations.twilio.account_sid": "Hesap SID’si",
    "Account SID": "Hesap SID’si",
    "integrations.twilio.account_sid_placeholder": "Hesap SID’sini girin",
    "Enter account SID": "Hesap SID’sini girin",
    "integrations.twilio.auth_token": "Kimlik doğrulama belirteci",
    "Auth token": "Kimlik doğrulama belirteci",
    "integrations.twilio.auth_token_placeholder": "Kimlik doğrulama belirtecini girin",
    "Enter auth token": "Kimlik doğrulama belirtecini girin",
    "integrations.twilio.source_phone": "Kaynak telefon numarası",
    "Source phone number": "Kaynak telefon numarası",
    "integrations.twilio.source_phone_placeholder": "Kaynak telefon numarasını girin",
    "Enter source phone number": "Kaynak telefon numarasını girin",
    "integrations.facebook.title": "Facebook kimlik doğrulaması",
    "integrations.facebook.enable_login": "Facebook girişini etkinleştir",
    "Enable Facebook login": "Facebook girişini etkinleştir",
    "integrations.facebook.app_id": "Uygulama kimliği",
    "App ID": "Uygulama kimliği",
    "integrations.facebook.app_id_placeholder": "Uygulama kimliğini girin",
    "Enter app ID": "Uygulama kimliğini girin",
    "integrations.google.title": "Google kimlik doğrulaması",
    "integrations.google.enable_sign_in": "Google ile girişi etkinleştir",
    "Enable Google sign-in": "Google ile girişi etkinleştir",
    "integrations.google.client_id": "İstemci kimliği",
    "integrations.google.client_id_placeholder": "İstemci kimliğini girin",
    "Enter client ID": "İstemci kimliğini girin",
    "integrations.auth.title": "Giriş yöntemi",
    "integrations.auth.description": "Kullanıcıların nasıl kayıt olup giriş yapacağını seçin. E-posta ve SMS doğrulaması kiracının teslimat ayarlarını kullanır.",
    "Choose how users register and sign in. Email and SMS verification use the tenant’s configured delivery settings.": "Kullanıcıların nasıl kayıt olup giriş yapacağını seçin. E-posta ve SMS doğrulaması kiracının teslimat ayarlarını kullanır.",
    "integrations.auth.empty": "Desteklenen bir giriş yöntemi yapılandırılmadı. Devam etmek için birini seçin.",
    "No supported sign-in method is currently configured. Select one to continue.": "Desteklenen bir giriş yöntemi yapılandırılmadı. Devam etmek için birini seçin.",
    "integrations.auth.save_note": "Kaydedildiğinde bu yöntem kiracının kayıt ve giriş uç noktalarına uygulanır. Doğrudan oluşturulan kullanıcılar ayrı yönetilir.",
    "Saving applies this method to the tenant’s sign-up and sign-in endpoints. Directly provisioned users are managed separately.": "Kaydedildiğinde bu yöntem kiracının kayıt ve giriş uç noktalarına uygulanır. Doğrudan oluşturulan kullanıcılar ayrı yönetilir.",
    "integrations.auth.error.load": "Geçerli giriş yöntemi yüklenemedi.",
    "Unable to load the current sign-in method.": "Geçerli giriş yöntemi yüklenemedi.",
    "integrations.auth.error.save": "Giriş yöntemi kaydedilemedi.",
    "Unable to save the sign-in method.": "Giriş yöntemi kaydedilemedi.",
    "integrations.auth.toast.saved": "Giriş yöntemi kaydedildi.",
    "Sign-in method saved.": "Giriş yöntemi kaydedildi.",
    "integrations.auth.email_password": "E-posta ve şifre",
    "Email and password": "E-posta ve şifre",
    "integrations.auth.email_password_help": "Kullanıcılar kayıt sırasında e-postalarını doğrular, ardından şifreyle giriş yapar.",
    "Users verify their email during sign-up, then sign in with a password.": "Kullanıcılar kayıt sırasında e-postalarını doğrular, ardından şifreyle giriş yapar.",
    "integrations.auth.email_code": "E-posta tek kullanımlık kodu",
    "Email one-time code": "E-posta tek kullanımlık kodu",
    "integrations.auth.email_code_help": "Kullanıcılar kayıt ve giriş için e-posta ile doğrulama kodu alır.",
    "Users receive a verification code by email for sign-up and sign-in.": "Kullanıcılar kayıt ve giriş için e-posta ile doğrulama kodu alır.",
    "integrations.auth.phone_code": "Telefon tek kullanımlık kodu",
    "Phone one-time code": "Telefon tek kullanımlık kodu",
    "integrations.auth.phone_code_help": "Kullanıcılar kayıt ve giriş için SMS ile doğrulama kodu alır.",
    "Users receive a verification code by SMS for sign-up and sign-in.": "Kullanıcılar kayıt ve giriş için SMS ile doğrulama kodu alır.",
    "integrations.auth.phone_password": "Telefon ve şifre",
    "Phone and password": "Telefon ve şifre",
    "integrations.auth.phone_password_help": "Kullanıcılar kayıt sırasında telefonlarını doğrular, ardından şifreyle giriş yapar.",
    "Users verify their phone during sign-up, then sign in with a password.": "Kullanıcılar kayıt sırasında telefonlarını doğrular, ardından şifreyle giriş yapar.",
    "integrations.auth.email_password_unverified": "Kayıt doğrulaması olmadan e-posta ve şifre",
    "Email and password without sign-up verification": "Kayıt doğrulaması olmadan e-posta ve şifre",
    "integrations.auth.email_password_unverified_help": "Kullanıcılar e-posta doğrulama kodu olmadan e-posta ve şifreyle kaydolabilir.",
    "Users can sign up with an email and password without an email verification code.": "Kullanıcılar e-posta doğrulama kodu olmadan e-posta ve şifreyle kaydolabilir.",
    "integrations.auth.phone_password_unverified": "Kayıt doğrulaması olmadan telefon ve şifre",
    "Phone and password without sign-up verification": "Kayıt doğrulaması olmadan telefon ve şifre",
    "integrations.auth.phone_password_unverified_help": "Kullanıcılar SMS doğrulama kodu olmadan telefon ve şifreyle kaydolabilir.",
    "Users can sign up with a phone and password without an SMS verification code.": "Kullanıcılar SMS doğrulama kodu olmadan telefon ve şifreyle kaydolabilir.",
    "integrations.page.title": "Uygulama entegrasyonları",
    "App Integrations": "Uygulama entegrasyonları",
    "integrations.generic.id_placeholder": "{name} kimliğini girin",
    "Enter {name} ID": "{name} kimliğini girin",
    "integrations.generic.enable": "{name} entegrasyonunu etkinleştir",
    "Enable {name} integration": "{name} entegrasyonunu etkinleştir",
    "integrations.menu.map": "Haritalar",
    "integrations.menu.firebase": "Firebase",
    "Firebase": "Firebase",
    "integrations.menu.branch": "Branch",
    "Branch": "Branch",
    "integrations.menu.appstore": "App Store",
    "App Store": "App Store",
    "integrations.menu.playstore": "Google Play",
    "Google Play": "Google Play",
    "integrations.menu.admob": "AdMob",
    "AdMob": "AdMob",
    "integrations.maps.title": "Harita entegrasyonu",
    "Maps integration": "Harita entegrasyonu",
    "integrations.maps.google": "Google Haritalar",
    "Google Maps": "Google Haritalar",
    "integrations.maps.openstreet": "OpenStreetMap",
    "OpenStreetMap": "OpenStreetMap",
    "integrations.maps.api_key": "API anahtarı",
    "API key": "API anahtarı",
    "integrations.maps.api_key_placeholder": "API anahtarını girin",
    "Enter API key": "API anahtarını girin",
    "integrations.maps.reverse_geocode_key": "Google Maps ters coğrafi kodlama API anahtarı",
    "Google Maps reverse geocoding API key": "Google Maps ters coğrafi kodlama API anahtarı",
    "integrations.maps.reverse_geocode_key_placeholder": "Google Maps ters coğrafi kodlama API anahtarını girin",
    "Enter Google Maps reverse geocoding API key": "Google Maps ters coğrafi kodlama API anahtarını girin",
    "integrations.maps.places_key": "Google Maps Places API anahtarı",
    "Google Maps Places API key": "Google Maps Places API anahtarı",
    "integrations.maps.places_key_placeholder": "Google Maps Places API anahtarını girin",
    "Enter Google Maps Places API key": "Google Maps Places API anahtarını girin",
    "integrations.maps.nearby_accounts": "Ana sayfada yakındaki hesapları etkinleştir",
    "Activate nearby accounts on the home page": "Ana sayfada yakındaki hesapları etkinleştir",
    "integrations.maps.listing_location": "İlan gönderiminde konumu etkinleştir",
    "Activate location in listing submission": "İlan gönderiminde konumu etkinleştir",
    "integrations.maps.account_location": "Hesap oluştururken konumu etkinleştir",
    "Activate location in account submission": "Hesap oluştururken konumu etkinleştir",
    "integrations.playstore.title": "Google Play entegrasyonu",
    "Google Play integration": "Google Play entegrasyonu",
    "integrations.playstore.application_id": "Uygulama kimliği",
    "Application ID": "Uygulama kimliği",
    "integrations.playstore.application_id_placeholder": "Uygulama kimliğini girin (com.tenantname.app)",
    "Enter application ID (com.tenantname.app)": "Uygulama kimliğini girin (com.tenantname.app)",
    "integrations.playstore.first_name": "Ad",
    "integrations.playstore.first_name_placeholder": "Adı girin",
    "Enter first name": "Adı girin",
    "integrations.playstore.last_name": "Soyadı",
    "integrations.playstore.last_name_placeholder": "Soyadını girin",
    "Enter last name": "Soyadını girin",
    "integrations.playstore.unit": "Organizasyon birimi",
    "Organizational unit": "Organizasyon birimi",
    "integrations.playstore.unit_placeholder": "Organizasyon birimini girin",
    "Enter organizational unit": "Organizasyon birimini girin",
    "integrations.playstore.organization": "Kuruluş",
    "Organization": "Kuruluş",
    "integrations.playstore.organization_placeholder": "Kuruluş adını girin",
    "Enter organization name": "Kuruluş adını girin",
    "integrations.playstore.city": "Şehir veya yerleşim yeri",
    "City or locality": "Şehir veya yerleşim yeri",
    "integrations.playstore.city_placeholder": "Şehir veya yerleşim yeri girin",
    "Enter city or locality": "Şehir veya yerleşim yeri girin",
    "integrations.playstore.state": "Eyalet veya il",
    "State or province": "Eyalet veya il",
    "integrations.playstore.state_placeholder": "Eyalet veya il girin",
    "Enter state or province": "Eyalet veya il girin",
    "integrations.playstore.country_code": "Ülke kodu (XX)",
    "Country code (XX)": "Ülke kodu (XX)",
    "integrations.playstore.country_code_placeholder": "Ülke kodunu girin",
    "Enter country code": "Ülke kodunu girin",
    "integrations.playstore.link": "Google Play bağlantısı",
    "Google Play link": "Google Play bağlantısı",
    "integrations.playstore.link_placeholder": "Google Play uygulama bağlantınızı girin",
    "Enter your app Google Play link": "Google Play uygulama bağlantınızı girin",
    "integrations.admob.title": "AdMob entegrasyonu",
    "AdMob integration": "AdMob entegrasyonu",
    "integrations.admob.app_id": "Uygulama kimliği",
    "integrations.admob.app_id_placeholder": "Uygulama kimliğini girin",
    "Enter App ID": "Uygulama kimliğini girin",
    "integrations.admob.unit_id": "Reklam birimi kimliği",
    "Unit ID": "Reklam birimi kimliği",
    "integrations.admob.unit_id_placeholder": "AdMob reklam birimi kimliğini girin",
    "Enter AdMob unit ID": "AdMob reklam birimi kimliğini girin",
    "integrations.admob.listings_id": "İlan kimliği",
    "Listings ID": "İlan kimliği",
    "integrations.admob.listings_id_placeholder": "İlan kimliğini girin",
    "Enter listings ID": "İlan kimliğini girin",
    "integrations.admob.listing_detail_id": "İlan ayrıntısı kimliği",
    "Listing detail ID": "İlan ayrıntısı kimliği",
    "integrations.admob.listing_detail_id_placeholder": "İlan ayrıntısı kimliğini girin",
    "Enter listing detail ID": "İlan ayrıntısı kimliğini girin",
    "integrations.admob.home_id": "Ana sayfa kimliği",
    "Home ID": "Ana sayfa kimliği",
    "integrations.admob.home_id_placeholder": "Ana sayfa kimliğini girin",
    "Enter home ID": "Ana sayfa kimliğini girin",
    "integrations.admob.enable_ads": "Reklamları etkinleştir",
    "Enable ads": "Reklamları etkinleştir",
    "integrations.admob.enable_listing_ads": "İlan akışında reklamları etkinleştir",
    "Enable ads on the listings feed": "İlan akışında reklamları etkinleştir",
    "integrations.admob.enable_listing_detail_ads": "İlan ayrıntılarında reklamları etkinleştir",
    "Enable ads on listing details": "İlan ayrıntılarında reklamları etkinleştir",
    "integrations.admob.enable_home_ads": "Ana sayfa alt gezinmesinde reklamları etkinleştir",
    "Enable ads in the home bottom navigation": "Ana sayfa alt gezinmesinde reklamları etkinleştir",
    "integrations.save_success": "Başarıyla kaydedildi",
    "Saved successfully": "Başarıyla kaydedildi",
    "integrations.note.release": "Bu ayarlar mobil uygulama yayımlandığında veya güncellendiğinde geçerli olur. Değişikliklerden sonra Destek Portalı’ndan yeni bir derleme isteyin. Starter planı için geçerlidir.",
    "These settings apply when the mobile app is released or updated. Request a new build from the Support Portal after making changes. Starter plan applies.": "Bu ayarlar mobil uygulama yayımlandığında veya güncellendiğinde geçerli olur. Değişikliklerden sonra Destek Portalı’ndan yeni bir derleme isteyin. Starter planı için geçerlidir.",
    "integrations.action.download": "İndir",
    "integrations.branch.title": "Branch entegrasyonu",
    "Branch integration": "Branch entegrasyonu",
    "integrations.branch.app_id": "Uygulama kimliği",
    "integrations.branch.app_id_placeholder": "Uygulama kimliğini girin",
    "integrations.branch.live_key": "Canlı anahtar",
    "Live key": "Canlı anahtar",
    "integrations.branch.live_key_placeholder": "Canlı anahtarı girin",
    "Enter live key": "Canlı anahtarı girin",
    "integrations.branch.live_secret": "Canlı gizli anahtar",
    "Live secret": "Canlı gizli anahtar",
    "integrations.branch.live_secret_placeholder": "Canlı gizli anahtarı girin",
    "Enter live secret": "Canlı gizli anahtarı girin",
    "integrations.branch.uri_scheme": "URI şeması",
    "URI scheme": "URI şeması",
    "integrations.branch.uri_scheme_placeholder": "URI şemasını girin",
    "Enter URI scheme": "URI şemasını girin",
    "integrations.branch.link_domain": "Bağlantı alan adı",
    "Link domain": "Bağlantı alan adı",
    "integrations.branch.link_domain_placeholder": "Bağlantı alan adını girin",
    "Enter link domain": "Bağlantı alan adını girin",
    "integrations.branch.alternate_domain": "Alternatif bağlantı alan adı",
    "Alternate link domain": "Alternatif bağlantı alan adı",
    "integrations.branch.alternate_domain_placeholder": "Alternatif bağlantı alan adını girin",
    "Enter alternate link domain": "Alternatif bağlantı alan adını girin",
    "integrations.branch.link_description": "Bağlantı açıklaması",
    "Link description": "Bağlantı açıklaması",
    "integrations.branch.link_description_placeholder": "Bağlantı açıklamasını girin",
    "Enter link description": "Bağlantı açıklamasını girin",
    "integrations.branch.invite_friends": "Arkadaşlarını davet et",
    "Invite friends": "Arkadaşlarını davet et",
    "integrations.branch.invite_title": "Başlık",
    "Title": "Başlık",
    "integrations.branch.invite_description": "Açıklama",
    "integrations.branch.destination_link": "Branch hedef bağlantısı (isteğe bağlı)",
    "Branch destination link (optional)": "Branch hedef bağlantısı (isteğe bağlı)",
    "integrations.branch.web_app_note": "Web uygulaması kullanıcıları için geçerlidir",
    "Applies to web app users": "Web uygulaması kullanıcıları için geçerlidir",
    "integrations.branch.destination_placeholder": "Branch hedef bağlantısını girin",
    "Enter branch destination link": "Branch hedef bağlantısını girin",
    "integrations.ios.title": "App Store hazırlığı",
    "App Store provisioning": "App Store hazırlığı",
    "integrations.ios.bundle_id": "Paket kimliği",
    "Bundle ID": "Paket kimliği",
    "integrations.ios.bundle_id_placeholder": "Paket kimliğini girin",
    "Enter bundle ID": "Paket kimliğini girin",
    "integrations.ios.certificate_password": "Dağıtım sertifikası şifresi",
    "Distribution certificate password": "Dağıtım sertifikası şifresi",
    "integrations.ios.certificate_password_placeholder": "Dağıtım sertifikası şifresini girin",
    "Enter distribution certificate password": "Dağıtım sertifikası şifresini girin",
    "integrations.ios.push_key_id": "Push anahtarı kimliği",
    "Push key ID": "Push anahtarı kimliği",
    "integrations.ios.push_key_id_placeholder": "Push anahtarı kimliğini girin",
    "Enter push key ID": "Push anahtarı kimliğini girin",
    "integrations.ios.team_id": "Ekip kimliği",
    "Team ID": "Ekip kimliği",
    "integrations.ios.team_id_placeholder": "Ekip kimliğini girin",
    "Enter team ID": "Ekip kimliğini girin",
    "integrations.ios.apple_id": "Apple ID",
    "Apple ID": "Apple ID",
    "integrations.ios.apple_id_placeholder": "Apple ID girin",
    "Enter Apple ID": "Apple ID girin",
    "integrations.ios.distribution_certificate": "Dağıtım sertifikası",
    "Distribution certificate": "Dağıtım sertifikası",
    "integrations.ios.provisioning_profile": "Dağıtım hazırlama profili",
    "Distribution provisioning profile": "Dağıtım hazırlama profili",
    "integrations.ios.push_key": "Push anahtarı",
    "Push key": "Push anahtarı",
    "integrations.ios.app_store_link": "App Store bağlantınız",
    "Your App Store link": "App Store bağlantınız",
    "integrations.ios.app_store_link_placeholder": "App Store uygulama bağlantınızı girin",
    "Enter your app App Store link": "App Store uygulama bağlantınızı girin",
    "integrations.firebase.title": "Firebase entegrasyonu",
    "Firebase integration": "Firebase entegrasyonu",
    "integrations.firebase.choose_file": "Dosya seç",
    "Choose file": "Dosya seç",
    "integrations.firebase.service_account": "Firebase hizmet hesabı",
    "Firebase service account": "Firebase hizmet hesabı",
    "integrations.firebase.android_json": "Android uygulaması JSON dosyası",
    "Android app JSON file": "Android uygulaması JSON dosyası",
    "integrations.firebase.ios_plist": "iOS uygulaması plist dosyası",
    "iOS app plist file": "iOS uygulaması plist dosyası",
    "integrations.firebase.create_project": "Firebase projesi oluştur",
    "Create Firebase project": "Firebase projesi oluştur",
    "integrations.firebase.create_android": "Android uygulaması oluştur",
    "Create Android app": "Android uygulaması oluştur",
    "integrations.firebase.create_ios": "iOS uygulaması oluştur",
    "Create iOS app": "iOS uygulaması oluştur",
    "integrations.firebase.create_database": "Gerçek zamanlı veritabanı oluştur",
    "Create realtime database": "Gerçek zamanlı veritabanı oluştur",
    "integrations.firebase.apply_rules": "Firebase veritabanı kurallarını uygula",
    "Apply Firebase database rules": "Firebase veritabanı kurallarını uygula",
    "bundles.listing_number": "İlan no. {id}",
    "bundles.listing_id": "{id} kimliği",
    "bundles.configure.title": "Paketi yapılandır",
    "Configure bundle": "Paketi yapılandır",
    "bundles.configure.subtitle": "Paket ilanı no. {id} · mevcut ilanları aşağıya ekleyin.",
    "Bundle listing #{id} · add existing listings below.": "Paket ilanı no. {id} · mevcut ilanları aşağıya ekleyin.",
    "bundles.back": "Paketlere dön",
    "Back to bundles": "Paketlere dön",
    "bundles.fixed_components": "Sabit bileşenler",
    "Fixed components": "Sabit bileşenler",
    "bundles.selection_pool": "Seçim havuzu",
    "Mix-and-match pool": "Seçim havuzu",
    "bundles.available_listings": "Mevcut ilanlar",
    "Available listings": "Mevcut ilanlar",
    "bundles.available_description": "Kataloğunuzda bulunan ürünleri arayıp ekleyin.",
    "Search and add products already in your catalogue.": "Kataloğunuzda bulunan ürünleri arayıp ekleyin.",
    "bundles.search_listings": "İlan ara",
    "Search listings": "İlan ara",
    "bundles.quantity_per_component": "Bileşen başına miktar",
    "Quantity per component": "Bileşen başına miktar",
    "bundles.loading_listings": "İlanlar yükleniyor…",
    "Loading listings…": "İlanlar yükleniyor…",
    "bundles.added": "Eklendi",
    "Added": "Eklendi",
    "bundles.adding": "Ekleniyor…",
    "Adding…": "Ekleniyor…",
    "bundles.add": "Ekle",
    "bundles.no_matching_listings": "Eşleşen ilan bulunamadı.",
    "No matching listings found.": "Eşleşen ilan bulunamadı.",
    "bundles.one_listing_added": "1 ilan eklendi",
    "1 listing added": "1 ilan eklendi",
    "bundles.many_listings_added": "{count} ilan eklendi",
    "{count} listings added": "{count} ilan eklendi",
    "bundles.quantity_short": "Adet {count}",
    "Qty {count}": "Adet {count}",
    "bundles.removing": "Kaldırılıyor…",
    "Removing…": "Kaldırılıyor…",
    "bundles.remove": "Kaldır",
    "bundles.no_components": "Henüz bileşen eklenmedi.",
    "No components added yet.": "Henüz bileşen eklenmedi.",
    "bundles.pool_remove_note": "Havuzdan kaldırmak için arka uç uç noktası gerekir; ekleme şu anda kullanılabilir.",
    "Pool removal needs the backend delete endpoint; additions are enabled now.": "Havuzdan kaldırmak için arka uç uç noktası gerekir; ekleme şu anda kullanılabilir.",
    "bundles.error.load_components": "Paket bileşenleri yüklenemedi.",
    "Unable to load bundle components.": "Paket bileşenleri yüklenemedi.",
    "bundles.error.add_listing": "İlan pakete eklenemedi.",
    "Unable to add listing to the bundle.": "İlan pakete eklenemedi.",
    "bundles.error.remove_component": "Paket bileşeni kaldırılamadı.",
    "Unable to remove bundle component.": "Paket bileşeni kaldırılamadı.",
    "bundles.error.load_listings": "İlanlar yüklenemedi.",
    "Unable to load listings.": "İlanlar yüklenemedi.",
    "bundles.components": "Paket bileşenleri",
    "Bundle components": "Paket bileşenleri",
    "bundles.picker_description": "Kataloğunuzdaki mevcut ilanları seçin. Paket oluşturulduktan sonra bağlanırlar.",
    "Select listings that already exist in your catalogue. They will be linked after the bundle is created.": "Kataloğunuzdaki mevcut ilanları seçin. Paket oluşturulduktan sonra bağlanırlar.",
    "bundles.fixed_bundle": "Sabit paket",
    "Fixed bundle": "Sabit paket",
    "bundles.mix_match": "Karıştır ve eşleştir",
    "Mix and match": "Karıştır ve eşleştir",
    "bundles.quantity_per_selected": "Seçilen ilan başına miktar",
    "Quantity per selected listing": "Seçilen ilan başına miktar",
    "bundles.search_existing": "Mevcut ilanları ara",
    "Search existing listings": "Mevcut ilanları ara",
    "bundles.selected_count": "Seçilen ({count})",
    "Selected ({count})": "Seçilen ({count})",
    "bundles.choose_component_hint": "Mevcut ilanlardan en az birini seçin veya önce paketi oluşturun.",
    "Choose at least one existing listing, or create the bundle first.": "Mevcut ilanlardan en az birini seçin veya önce paketi oluşturun.",
    "bundles.error.attach_components": "Paket oluşturuldu ancak bileşenler eklenemedi.",
    "The bundle was created, but components could not be attached.": "Paket oluşturuldu ancak bileşenler eklenemedi.",
    "bundles.continue_configure_hint": "Paket yapılandırma sayfasından devam edebilirsiniz.",
    "You can continue from the bundle configuration page.": "Paket yapılandırma sayfasından devam edebilirsiniz.",
    "bundles.title": "Paketler",
    "bundles.create": "Paket oluştur",
    "Create bundle": "Paket oluştur",
    "bundles.subtitle": "Ana paket ilanını oluşturun, ardından sabit bileşenler veya seçim havuzu ekleyin.",
    "Create a parent bundle listing, then attach fixed components or a mix-and-match selection pool.": "Ana paket ilanını oluşturun, ardından sabit bileşenler veya seçim havuzu ekleyin.",
    "bundles.workflow": "Paket iş akışı",
    "Bundle workflow": "Paket iş akışı",
    "bundles.how_it_works": "Paketler nasıl çalışır",
    "How bundles work": "Paketler nasıl çalışır",
    "bundles.parent_description": "Ana ilan müşteriye gösterilen paketi belirler.",
    "One parent listing controls the customer-facing bundle.": "Ana ilan müşteriye gösterilen paketi belirler.",
    "bundles.flow": "Paket akışı",
    "Bundle flow": "Paket akışı",
    "bundles.parent_listing": "Ana ilan",
    "Parent listing": "Ana ilan",
    "bundles.name_price_category": "Ad, fiyat, kategori",
    "Name, price, category": "Ad, fiyat, kategori",
    "bundles.fixed_or_pool": "Sabit ürünler veya havuz",
    "Fixed items or a pool": "Sabit ürünler veya havuz",
    "bundles.checkout_stock": "Ödeme ve stok",
    "Checkout stock": "Ödeme ve stok",
    "bundles.selection_availability": "Seçim ve stok durumu",
    "Selection + availability": "Seçim ve stok durumu",
    "bundles.fixed_bundles": "Sabit paketler",
    "Fixed bundles": "Sabit paketler",
    "bundles.fixed_description": "Mevcut ilanlardan oluşan belirli bir grubu birlikte satın.",
    "Sell a defined group of existing listings together.": "Mevcut ilanlardan oluşan belirli bir grubu birlikte satın.",
    "bundles.fixed_detail": "Mevcut ilanları sabit bileşen olarak ekleyin.",
    "Add existing listings as fixed components.": "Mevcut ilanları sabit bileşen olarak ekleyin.",
    "bundles.pool_description": "Müşterilerin paket havuzundan uygun ürünleri seçmesine izin verin.",
    "Let customers choose eligible items from a bundle pool.": "Müşterilerin paket havuzundan uygun ürünleri seçmesine izin verin.",
    "bundles.pool_detail": "Ödeme sırasında seçilecek en az ve en çok ürün sayısını belirleyin.",
    "Set the minimum and maximum selections at checkout.": "Ödeme sırasında seçilecek en az ve en çok ürün sayısını belirleyin.",
    "channels.opensource.title": "Açık kaynaklı başlangıç kitleri",
    "Open-source starter kits": "Açık kaynaklı başlangıç kitleri",
    "channels.opensource.view_org": "GitHub kuruluşunu görüntüle",
    "View GitHub organization": "GitHub kuruluşunu görüntüle",
    "channels.opensource.description": "TRADLY-PLATFORM kuruluşunun açık kaynak Tradly depolarını ve başlangıç kitlerini keşfedin.",
    "Explore open-source Tradly repositories and starter kits from the TRADLY-PLATFORM organization.": "TRADLY-PLATFORM kuruluşunun açık kaynak Tradly depolarını ve başlangıç kitlerini keşfedin.",
    "channels.opensource.loading": "Depolar yükleniyor…",
    "Loading repositories…": "Depolar yükleniyor…",
    "channels.opensource.error.http": "GitHub {status} yanıtını döndürdü.",
    "GitHub returned {status}.": "GitHub {status} yanıtını döndürdü.",
    "channels.opensource.error.load": "Depolar yüklenemedi. Daha sonra tekrar deneyin.",
    "Unable to load repositories. Try again later.": "Depolar yüklenemedi. Daha sonra tekrar deneyin.",
    "channels.opensource.empty": "Herkese açık depo bulunamadı.",
    "No public repositories found.": "Herkese açık depo bulunamadı.",
    "channels.opensource.repo_fallback": "Açık kaynaklı Tradly deposu.",
    "Open-source Tradly repository.": "Açık kaynaklı Tradly deposu.",
    "channels.opensource.language_code": "Kod",
    "channels.opensource.view_repo": "Depoyu görüntüle",
    "View repository": "Depoyu görüntüle",
    "developer.mcp.select_all": "Tümünü seç",
    "Select all": "Tümünü seç",
    "developer.mcp.read": "Oku",
    "developer.mcp.write": "Yaz",
    "developer.mcp.delete": "Sil",
    "developer.mcp.export": "Dışa aktar",
    "developer.mcp.copy": "Kopyala",
    "Copy": "Kopyala",
    "developer.mcp.copied": "Kopyalandı",
    "Copied": "Kopyalandı",
    "developer.mcp.connection_created": "Bağlantı oluşturuldu",
    "Connection created": "Bağlantı oluşturuldu",
    "developer.mcp.save_secret_warning": "İstemci gizli anahtarını şimdi kaydedin; daha sonra tekrar gösterilmez.",
    "Save your client secret now — it will not be shown again.": "İstemci gizli anahtarını şimdi kaydedin; daha sonra tekrar gösterilmez.",
    "developer.mcp.client_id": "İstemci kimliği",
    "developer.mcp.client_secret": "İstemci gizli anahtarı",
    "Client secret": "İstemci gizli anahtarı",
    "developer.mcp.new_connection": "Yeni MCP bağlantısı",
    "New MCP connection": "Yeni MCP bağlantısı",
    "developer.mcp.platform": "Platform",
    "Platform": "Platform",
    "developer.mcp.platform_custom": "Özel",
    "developer.mcp.connection_name": "Bağlantı adı",
    "Connection name": "Bağlantı adı",
    "developer.mcp.connection_name_placeholder": "ör. ChatGPT",
    "e.g. ChatGPT": "ör. ChatGPT",
    "developer.mcp.redirect_uris": "Yönlendirme URI’leri",
    "Redirect URIs": "Yönlendirme URI’leri",
    "developer.mcp.one_per_line": "(her satıra bir tane)",
    "(one per line)": "(her satıra bir tane)",
    "developer.mcp.permissions": "İzinler",
    "Permissions": "İzinler",
    "developer.mcp.error.connection_name": "Bir bağlantı adı girin",
    "Enter a connection name": "Bir bağlantı adı girin",
    "developer.mcp.error.redirect_uri": "En az bir yönlendirme URI’si girin",
    "Enter at least one redirect URI": "En az bir yönlendirme URI’si girin",
    "developer.mcp.error.create": "Bağlantı oluşturulamadı",
    "Failed to create connection": "Bağlantı oluşturulamadı",
    "developer.mcp.creating": "Oluşturuluyor…",
    "Creating…": "Oluşturuluyor…",
    "developer.mcp.edit_permissions": "İzinleri düzenle",
    "Edit permissions": "İzinleri düzenle",
    "developer.mcp.permissions_updated": "İzinler güncellendi",
    "Permissions updated": "İzinler güncellendi",
    "developer.mcp.error.update_permissions": "İzinler güncellenemedi",
    "Failed to update permissions": "İzinler güncellenemedi",
    "developer.mcp.saving": "Kaydediliyor…",
    "developer.mcp.error.load": "MCP bağlantıları yüklenemedi.",
    "MCP connections could not be loaded.": "MCP bağlantıları yüklenemedi.",
    "developer.mcp.confirm_delete": "Bu bağlantı silinsin mi? Listeden kaldırılır ve erişimi iptal edilir.",
    "Delete this connection? It will be removed from the list and its access revoked.": "Bu bağlantı silinsin mi? Listeden kaldırılır ve erişimi iptal edilir.",
    "developer.mcp.connection_removed": "Bağlantı kaldırıldı",
    "Connection removed": "Bağlantı kaldırıldı",
    "developer.mcp.error.remove_connection": "Bağlantı kaldırılamadı",
    "Failed to remove connection": "Bağlantı kaldırılamadı",
    "developer.mcp.connection_deactivated": "Bağlantı devre dışı bırakıldı",
    "Connection deactivated": "Bağlantı devre dışı bırakıldı",
    "developer.mcp.error.deactivate_connection": "Bağlantı devre dışı bırakılamadı",
    "Failed to deactivate connection": "Bağlantı devre dışı bırakılamadı",
    "developer.mcp.title": "MCP bağlantıları",
    "MCP connections": "MCP bağlantıları",
    "developer.mcp.description": "Kiracıya kayıtlı OAuth istemcileri ve bu kiracının MCP sunucusunu kullanma yetkisi olan yapay zekâ uygulamaları.",
    "Tenant-registered OAuth clients and AI apps authorized to use this tenant’s MCP server.": "Kiracıya kayıtlı OAuth istemcileri ve bu kiracının MCP sunucusunu kullanma yetkisi olan yapay zekâ uygulamaları.",
    "developer.mcp.empty": "Henüz bağlantı yok. Bir istemci oluşturun veya yapay zekâ uygulamasını kiracının MCP sunucusuna bağlayın.",
    "No connections yet. Create a client or connect an AI app to this tenant’s MCP server.": "Henüz bağlantı yok. Bir istemci oluşturun veya yapay zekâ uygulamasını kiracının MCP sunucusuna bağlayın.",
    "developer.mcp.status.connected_one": "Bağlandı · 1 kullanıcı",
    "Connected · 1 user": "Bağlandı · 1 kullanıcı",
    "developer.mcp.status.connected_many": "Bağlandı · {count} kullanıcı",
    "Connected · {count} users": "Bağlandı · {count} kullanıcı",
    "developer.mcp.status.deactivated": "Devre dışı",
    "Deactivated": "Devre dışı",
    "developer.mcp.status.previously_connected": "Daha önce bağlandı",
    "Previously connected": "Daha önce bağlandı",
    "developer.mcp.status.registered": "Kayıtlı · bağlı değil",
    "Registered · not connected": "Kayıtlı · bağlı değil",
    "developer.mcp.oauth_app": "OAuth uygulaması",
    "OAuth app": "OAuth uygulaması",
    "developer.mcp.created": "Oluşturuldu",
    "developer.mcp.updated": "Güncellendi",
    "Updated": "Güncellendi",
    "developer.mcp.edit_scopes": "Kapsamları düzenle",
    "Edit scopes": "Kapsamları düzenle",
    "developer.mcp.edit_scopes_for": "{name} için kapsamları düzenle",
    "Edit scopes for {name}": "{name} için kapsamları düzenle",
    "developer.mcp.deactivate_hint": "Devre dışı bırak (listede ve günlüklerde tut)",
    "Deactivate (keeps it listed and logged)": "Devre dışı bırak (listede ve günlüklerde tut)",
    "developer.mcp.deactivate_named": "{name} öğesini devre dışı bırak",
    "Deactivate {name}": "{name} öğesini devre dışı bırak",
    "developer.mcp.delete_connection": "Bağlantıyı sil",
    "Delete connection": "Bağlantıyı sil",
    "developer.mcp.delete_named": "{name} öğesini sil",
    "Delete {name}": "{name} öğesini sil",
    "developer.mcp.resource.listings": "İlanlar",
    "developer.mcp.resource.orders": "Siparişler",
    "developer.mcp.resource.users": "Kullanıcılar",
    "developer.mcp.resource.accounts": "Hesaplar",
    "developer.mcp.resource.categories": "Kategoriler",
    "developer.mcp.resource.attributes": "Özellikler",
    "developer.mcp.resource.analytics": "Analitik",
    "developer.mcp.resource.attribution": "İlişkilendirme",
    "Attribution": "İlişkilendirme",
    "developer.mcp.resource.rewards": "Ödüller",
    "developer.mcp.resource.layers": "Layers / CMS",
    "Layers / CMS": "Layers / CMS",
    "developer.mcp.resource.settings": "Mağaza ayarları",
    "Store settings": "Mağaza ayarları",
    "developer.mcp.resource.marketing": "Pazarlama",
    "developer.mcp.resource.market_research": "Pazar araştırması",
    "Market research": "Pazar araştırması",
    "developer.mcp.resource.audiences": "Pazarlama hedef kitleleri",
    "Marketing audiences": "Pazarlama hedef kitleleri",
    "developer.mcp.resource.agents": "Yapay zekâ aracıları",
    "developer.mcp.resource.assets": "Dosya yüklemeleri",
    "File uploads": "Dosya yüklemeleri",
    "developer.mcp.resource.workforce": "İş gücü",
    "developer.mcp.resource.inventory": "Envanter",
    "developer.mcp.resource.memberships": "Üyelikler",
    "Memberships": "Üyelikler",
    "developer.mcp.resource.bundles": "Paketler",
    "developer.mcp.resource.rentals": "Kiralamalar",
    "Rentals": "Kiralamalar",
    "developer.mcp.resource.accounting": "Muhasebe",
    "developer.mcp.nav.label": "MCP gezinme",
    "MCP navigation": "MCP gezinme",
    "developer.mcp.nav.connections": "Bağlantılar",
    "Connections": "Bağlantılar",
    "developer.mcp.nav.logs": "Günlükler",
    "Logs": "Günlükler",
    "developer.mcp.unknown_provider": "Bilinmeyen sağlayıcı",
    "Unknown provider": "Bilinmeyen sağlayıcı",
    "developer.mcp.tenant_user": "Kiracı no. {tenant} · Kullanıcı no. {user}",
    "Tenant #{tenant} · User #{user}": "Kiracı no. {tenant} · Kullanıcı no. {user}",
    "developer.mcp.logs.title": "MCP günlükleri",
    "MCP logs": "MCP günlükleri",
    "developer.mcp.logs.heading": "Son aracı etkinliği",
    "Recent agent activity": "Son aracı etkinliği",
    "developer.mcp.logs.description": "Bu kiracının MCP etkinlikleri gösteriliyor. Etkinlik görünümü 15 saniyede bir yenilenir.",
    "Showing this tenant’s MCP events. The activity view refreshes every 15 seconds.": "Bu kiracının MCP etkinlikleri gösteriliyor. Etkinlik görünümü 15 saniyede bir yenilenir.",
    "developer.mcp.logs.error.audit": "MCP denetim günlükleri yüklenemedi.",
    "MCP audit logs could not be loaded.": "MCP denetim günlükleri yüklenemedi.",
    "developer.mcp.logs.error.load": "MCP günlükleri yüklenemedi.",
    "MCP logs could not be loaded.": "MCP günlükleri yüklenemedi.",
    "developer.mcp.logs.unknown_agent": "Bilinmeyen aracı",
    "Unknown agent": "Bilinmeyen aracı",
    "developer.mcp.logs.all_agents": "Tüm aracılar",
    "All agents": "Tüm aracılar",
    "developer.mcp.logs.updated": "{time} tarihinde güncellendi",
    "Updated {time}": "{time} tarihinde güncellendi",
    "developer.mcp.logs.loading": "MCP etkinliği yükleniyor…",
    "Loading MCP activity…": "MCP etkinliği yükleniyor…",
    "developer.mcp.logs.empty": "Bu kiracı için yakın tarihli MCP etkinliği yok.",
    "No recent MCP events found for this tenant.": "Bu kiracı için yakın tarihli MCP etkinliği yok.",
    "developer.mcp.logs.empty_agent": "Bu kiracı ve aracı için yakın tarihli MCP etkinliği yok.",
    "No recent MCP events found for this tenant and agent.": "Bu kiracı ve aracı için yakın tarihli MCP etkinliği yok.",
    "developer.mcp.logs.time": "Saat",
    "developer.mcp.logs.event": "Etkinlik",
    "developer.mcp.logs.tool": "Araç",
    "developer.mcp.logs.agent": "Aracı",
    "Agent": "Aracı",
    "developer.mcp.logs.tenant_user": "Kiracı / kullanıcı",
    "Tenant / user": "Kiracı / kullanıcı",
    "developer.mcp.logs.scope": "Kapsam",
    "Scope": "Kapsam",
    "developer.mcp.logs.result": "Sonuç",
    "Result": "Sonuç",
    "developer.mcp.logs.duration": "Süre",
    "Duration": "Süre",
    "developer.mcp.logs.view_details": "{event} ayrıntılarını görüntüle",
    "View details for {event}": "{event} ayrıntılarını görüntüle",
    "developer.mcp.logs.tenant": "Kiracı #{id}",
    "Tenant #{id}": "Kiracı #{id}",
    "developer.mcp.logs.user": "Kullanıcı #{id}",
    "User #{id}": "Kullanıcı #{id}",
    "developer.mcp.logs.view_granted_scopes": "Verilen kapsamları görüntüle",
    "View granted scopes": "Verilen kapsamları görüntüle",
    "developer.mcp.logs.succeeded": "Başarılı",
    "Succeeded": "Başarılı",
    "developer.mcp.logs.failed": "Başarısız",
    "developer.mcp.logs.duration_ms": "{count} ms",
    "{count} ms": "{count} ms",
    "developer.mcp.logs.details_title": "MCP etkinliği ayrıntıları",
    "MCP event details": "MCP etkinliği ayrıntıları",
    "developer.mcp.logs.required_scope": "Gerekli kapsam",
    "Required scope": "Gerekli kapsam",
    "developer.mcp.logs.granted_scopes": "Verilen kapsamlar",
    "Granted scopes": "Verilen kapsamlar",
    "developer.mcp.logs.event_generic": "Etkinlik",
    "developer.mcp.logs.event.tool_called": "Araç çağrıldı",
    "Tool called": "Araç çağrıldı",
    "developer.mcp.logs.event.connection_requested": "Bağlantı istendi",
    "Connection requested": "Bağlantı istendi",
    "developer.mcp.logs.event.connection_connected": "Bağlandı",
    "Connection connected": "Bağlandı",
    "developer.mcp.logs.event.connection_deactivated": "Bağlantı devre dışı bırakıldı",
    "developer.mcp.logs.event.connection_deleted": "Bağlantı silindi",
    "Connection deleted": "Bağlantı silindi",
    "developer.mcp.logs.event.permissions_updated": "İzinler güncellendi",
    "common.status.label": "Durum",
    "suppliers.title": "Tedarikçiler",
    "suppliers.search": "Tedarikçi ara",
    "Search suppliers": "Tedarikçi ara",
    "suppliers.add": "Tedarikçi ekle",
    "Add supplier": "Tedarikçi ekle",
    "suppliers.deactivate": "Devre dışı bırak",
    "Deactivate": "Devre dışı bırak",
    "suppliers.empty": "Tedarikçi bulunamadı.",
    "No suppliers found.": "Tedarikçi bulunamadı.",
    "suppliers.add_title": "Tedarikçi ekle",
    "suppliers.edit_title": "Tedarikçiyi düzenle",
    "Edit supplier": "Tedarikçiyi düzenle",
    "suppliers.save_changes": "Değişiklikleri kaydet",
    "Save changes": "Değişiklikleri kaydet",
    "suppliers.confirm_deactivate": "{name} devre dışı bırakılsın mı?",
    "Deactivate {name}?": "{name} devre dışı bırakılsın mı?",
    "suppliers.toast.updated": "Tedarikçi güncellendi",
    "Supplier updated": "Tedarikçi güncellendi",
    "suppliers.toast.added": "Tedarikçi eklendi",
    "Supplier added": "Tedarikçi eklendi",
    "suppliers.toast.deactivated": "Tedarikçi devre dışı bırakıldı",
    "Supplier deactivated": "Tedarikçi devre dışı bırakıldı",
    "suppliers.column.name": "Ad",
    "suppliers.column.code": "Kod",
    "suppliers.column.contact": "İletişim",
    "Contact": "İletişim",
    "suppliers.field.name": "Ad",
    "suppliers.field.code": "Kod",
    "suppliers.field.contact_name": "Yetkili kişi",
    "suppliers.field.email": "E-posta",
    "suppliers.field.phone": "Telefon",
    "suppliers.field.currency": "Para birimi",
    "suppliers.field.payment_terms": "Ödeme koşulları",
    "Payment terms": "Ödeme koşulları",
    "suppliers.field.address": "Adres",
    "suppliers.field.note": "Not",
    "Note": "Not",
    "suppliers.placeholder.name": "Şirket veya tedarikçi adı",
    "Company or supplier name": "Şirket veya tedarikçi adı",
    "suppliers.placeholder.code": "Tedarikçi kodu",
    "Supplier code": "Tedarikçi kodu",
    "suppliers.placeholder.contact_name": "Yetkili kişinin adı",
    "suppliers.placeholder.currency": "USD",
    "USD": "USD",
    "suppliers.payment_terms.cod": "Teslimatta ödeme",
    "Cash on delivery": "Teslimatta ödeme",
    "suppliers.payment_terms.payment_on_receipt": "Fatura alındığında ödeme",
    "Payment on receipt": "Fatura alındığında ödeme",
    "suppliers.payment_terms.payment_in_advance": "Peşin ödeme",
    "Payment in advance": "Peşin ödeme",
    "suppliers.payment_terms.net_7": "7 gün vadeli",
    "Net 7 days": "7 gün vadeli",
    "suppliers.payment_terms.net_15": "15 gün vadeli",
    "Net 15 days": "15 gün vadeli",
    "suppliers.payment_terms.net_30": "30 gün vadeli",
    "Net 30 days": "30 gün vadeli",
    "suppliers.payment_terms.net_45": "45 gün vadeli",
    "Net 45 days": "45 gün vadeli",
    "suppliers.payment_terms.net_60": "60 gün vadeli",
    "Net 60 days": "60 gün vadeli",
    "suppliers.detail_title": "Tedarikçi ayrıntıları",
    "Supplier details": "Tedarikçi ayrıntıları",
    "suppliers.edit": "Tedarikçiyi düzenle",
    "suppliers.back": "Tedarikçilere dön",
    "Back to suppliers": "Tedarikçilere dön",
    "suppliers.loading": "Tedarikçi yükleniyor…",
    "Loading supplier…": "Tedarikçi yükleniyor…",
    "suppliers.unnamed": "Adsız tedarikçi",
    "Unnamed supplier": "Adsız tedarikçi",
    "suppliers.profile_description": "Tedarikçi profili ve iletişim bilgileri",
    "Supplier profile and contact information": "Tedarikçi profili ve iletişim bilgileri",
    "suppliers.total_spend": "Toplam harcama",
    "Total spend": "Toplam harcama",
    "suppliers.outstanding": "Ödenmemiş",
    "Outstanding": "Ödenmemiş",
    "suppliers.paid": "Ödendi",
    "suppliers.draft": "Taslak",
    "suppliers.purchase_history": "Satın alma geçmişi",
    "Purchase history": "Satın alma geçmişi",
    "suppliers.bill.reference": "Referans",
    "Reference": "Referans",
    "suppliers.bill.date": "Tarih",
    "suppliers.bill.amount": "Tutar",
    "suppliers.bill.number": "Fatura #{id}",
    "Bill #{id}": "Fatura #{id}",
    "suppliers.bills_empty": "Bu tedarikçi için fatura bulunamadı.",
    "No bills found for this supplier.": "Bu tedarikçi için fatura bulunamadı.",
    "inventory.locations.title": "Konumlar",
    "inventory.locations.add": "Konum ekle",
    "Add location": "Konum ekle",
    "inventory.locations.description": "Stokların bulunduğu depo ve mağazalar. Satın alma siparişleri bir konuma teslim alınır.",
    "Warehouses and stores that hold stock. Purchase orders are received into a location.": "Stokların bulunduğu depo ve mağazalar. Satın alma siparişleri bir konuma teslim alınır.",
    "inventory.locations.field.name": "Ad",
    "inventory.locations.field.code": "Kod",
    "inventory.locations.field.address": "Adres",
    "inventory.locations.field.linked_store": "Bağlı mağaza (isteğe bağlı)",
    "Linked store (optional)": "Bağlı mağaza (isteğe bağlı)",
    "inventory.locations.field.linked_store_short": "Bağlı mağaza",
    "Linked store": "Bağlı mağaza",
    "inventory.locations.placeholder.name": "Ana depo",
    "Main warehouse": "Ana depo",
    "inventory.locations.placeholder.code": "WH-001",
    "WH-001": "WH-001",
    "inventory.locations.placeholder.address": "Adres veya yer ara",
    "Search an address or place": "Adres veya yer ara",
    "inventory.locations.placeholder.linked_store": "Satıcı veya mağaza hesaplarını ara",
    "Search seller or store accounts": "Satıcı veya mağaza hesaplarını ara",
    "inventory.locations.confirm_deactivate": "{name} devre dışı bırakılsın mı? Bu konum yeni satın alma siparişlerinde kullanılamaz.",
    "Deactivate {name}? It will no longer be available for new purchase orders.": "{name} devre dışı bırakılsın mı? Bu konum yeni satın alma siparişlerinde kullanılamaz.",
    "inventory.locations.toast.deactivated": "Konum devre dışı bırakıldı",
    "Location deactivated": "Konum devre dışı bırakıldı",
    "inventory.locations.deactivate": "Devre dışı bırak",
    "inventory.locations.empty": "Henüz konum yok. Stok kabul etmeye başlamak için depo veya mağaza ekleyin.",
    "No locations yet. Add a warehouse or store to start receiving stock.": "Henüz konum yok. Stok kabul etmeye başlamak için depo veya mağaza ekleyin.",
    "inventory.locations.edit_title": "Konumu düzenle",
    "Edit location": "Konumu düzenle",
    "inventory.locations.add_title": "Konum ekle",
    "inventory.locations.form_description": "Mağaza hesabını yalnızca bu konum belirli bir satıcıya aitse bağlayın.",
    "Link a store account only if this location belongs to a specific seller.": "Mağaza hesabını yalnızca bu konum belirli bir satıcıya aitse bağlayın.",
    "inventory.locations.save_changes": "Değişiklikleri kaydet",
    "inventory.locations.toast.updated": "Konum güncellendi",
    "Location updated": "Konum güncellendi",
    "inventory.locations.toast.added": "Konum eklendi",
    "Location added": "Konum eklendi",
    "inventory.operations.title": "Envanter işlemleri",
    "Inventory operations": "Envanter işlemleri",
    "inventory.operations.tab.movements": "Hareket geçmişi",
    "Movement history": "Hareket geçmişi",
    "inventory.operations.tab.batches": "Partiler ve son kullanma tarihleri",
    "Batches & expiry": "Partiler ve son kullanma tarihleri",
    "inventory.operations.tab.transfers": "Transfer siparişleri",
    "Transfer orders": "Transfer siparişleri",
    "inventory.operations.tab.requisitions": "Permintaan stok",
    "Requisitions": "Permintaan stok",
    "inventory.operations.tab.receipts": "Mal kabulü",
    "Goods received": "Mal kabulü",
    "inventory.operations.description.movements": "Her mal kabulü, satış, transfer, iade ve düzeltmenin değiştirilemez kaydı.",
    "An immutable trail of every receive, sale, transfer, return, and adjustment.": "Her mal kabulü, satış, transfer, iade ve düzeltmenin değiştirilemez kaydı.",
    "inventory.operations.description.batches": "Stok kayıtlarını burada değiştirmeden partileri, son kullanma tarihlerini, durumu ve birimleri izleyin.",
    "Track lots, expiry dates, condition, and units without changing the stock ledger here.": "Stok kayıtlarını burada değiştirmeden partileri, son kullanma tarihlerini, durumu ve birimleri izleyin.",
    "inventory.operations.description.transfers": "Sevkiyat, teslim alma ve fark durumlarını izleyerek konumlar arasında stok taşıyın.",
    "Move stock between locations with dispatch, receive, and discrepancy-safe status tracking.": "Sevkiyat, teslim alma ve fark durumlarını izleyerek konumlar arasında stok taşıyın.",
    "inventory.operations.description.requisitions": "Dahili stok taleplerini inceleyin. Onaylandığında otomatik olarak transfer siparişi oluşturulur.",
    "Review internal stock requests. Approval creates a transfer order automatically.": "Dahili stok taleplerini inceleyin. Onaylandığında otomatik olarak transfer siparişi oluşturulur.",
    "inventory.operations.description.receipts": "Mal kabulü oluşturun; açık, kısmi ve tamamlanan işlemleri izleyin.",
    "Create receipts and track open, partial, and closed receiving work.": "Mal kabulü oluşturun; açık, kısmi ve tamamlanan işlemleri izleyin.",
    "inventory.operations.overview": "Genel bakış",
    "inventory.operations.new_transfer": "Yeni transfer",
    "New transfer": "Yeni transfer",
    "inventory.operations.new_requisition": "Yeni talep",
    "inventory.operations.new_receipt": "Yeni mal kabulü",
    "New receipt": "Yeni mal kabulü",
    "inventory.operations.search": "Ara",
    "inventory.operations.search_view": "Bu görünümde ara",
    "Search this view": "Bu görünümde ara",
    "inventory.operations.search_products": "Ürün ara",
    "Search products": "Ürün ara",
    "inventory.operations.search_purchase_order": "Satın alma siparişlerini ara (isteğe bağlı)",
    "Search purchase orders (optional)": "Satın alma siparişlerini ara (isteğe bağlı)",
    "inventory.operations.listing_number": "İlan #{id}",
    "inventory.operations.location_number": "Konum #{id}",
    "Location #{id}": "Konum #{id}",
    "inventory.operations.no_sku": "SKU yok",
    "No SKU": "SKU yok",
    "inventory.operations.order_status": "Durum: {status}",
    "Status: {status}": "Durum: {status}",
    "inventory.operations.field.receiving_location": "Teslim alma konumu",
    "Receiving location": "Teslim alma konumu",
    "inventory.operations.field.purchase_order": "Satın alma siparişi",
    "Purchase order": "Satın alma siparişi",
    "inventory.operations.field.reference": "Referans",
    "inventory.operations.field.note": "Not",
    "inventory.operations.field.from_location": "Çıkış konumu",
    "From location": "Çıkış konumu",
    "inventory.operations.field.supplying_location": "Tedarik konumu",
    "Supplying location": "Tedarik konumu",
    "inventory.operations.field.to_location": "Varış konumu",
    "To location": "Varış konumu",
    "inventory.operations.field.requesting_location": "Talep eden konum",
    "Requesting location": "Talep eden konum",
    "inventory.operations.field.product": "Ürün",
    "Product": "Ürün",
    "inventory.operations.field.quantity": "Miktar",
    "Quantity": "Miktar",
    "inventory.operations.field.location": "Konum",
    "Location": "Konum",
    "inventory.operations.placeholder.delivery_note": "Tedarikçi teslimat notu",
    "Supplier delivery note": "Tedarikçi teslimat notu",
    "inventory.operations.placeholder.receiving_note": "Mal kabul notu (isteğe bağlı)",
    "Optional receiving note": "Mal kabul notu (isteğe bağlı)",
    "inventory.operations.placeholder.transfer_reference": "Transfer referansı",
    "Transfer reference": "Transfer referansı",
    "inventory.operations.placeholder.request_reference": "Talep referansı",
    "Request reference": "Talep referansı",
    "inventory.operations.placeholder.context": "Ek bağlam",
    "Optional context": "Ek bağlam",
    "inventory.operations.create.transfer_title": "Yeni transfer siparişi",
    "New transfer order": "Yeni transfer siparişi",
    "inventory.operations.create.requisition_title": "Yeni stok talebi",
    "inventory.operations.create.receipt_title": "Yeni mal kabulü",
    "New goods receipt": "Yeni mal kabulü",
    "inventory.operations.create.transfer_description": "İki konum arasında stok taşıyın.",
    "Move stock between two locations.": "İki konum arasında stok taşıyın.",
    "inventory.operations.create.requisition_description": "Başka bir konumdan stok talep edin.",
    "Request stock from another location.": "Başka bir konumdan stok talep edin.",
    "inventory.operations.create.receipt_description": "Kutuları taramadan veya eklemeden önce mal kabulü oluşturun.",
    "Create a receipt before scanning or adding boxes.": "Kutuları taramadan veya eklemeden önce mal kabulü oluşturun.",
    "inventory.operations.toast.transfer_created": "Transfer siparişi oluşturuldu",
    "Transfer order created": "Transfer siparişi oluşturuldu",
    "inventory.operations.toast.requisition_created": "Talep oluşturuldu",
    "Requisition created": "Talep oluşturuldu",
    "inventory.operations.toast.receipt_created": "Mal kabulü oluşturuldu",
    "Goods receipt created": "Mal kabulü oluşturuldu",
    "inventory.operations.toast.transfer_dispatched": "Transfer gönderildi",
    "Transfer dispatched": "Transfer gönderildi",
    "inventory.operations.toast.transfer_received": "Transfer teslim alındı",
    "Transfer received": "Transfer teslim alındı",
    "inventory.operations.toast.transfer_cancelled": "Transfer iptal edildi",
    "Transfer cancelled": "Transfer iptal edildi",
    "inventory.operations.toast.requisition_approved": "Talep onaylandı",
    "Requisition approved": "Talep onaylandı",
    "inventory.operations.toast.requisition_rejected": "Talep reddedildi",
    "Requisition rejected": "Talep reddedildi",
    "inventory.operations.action.dispatch": "Gönder",
    "Dispatch": "Gönder",
    "inventory.operations.action.receive": "Teslim al",
    "Receive": "Teslim al",
    "inventory.operations.action.approve": "Onayla",
    "Approve": "Onayla",
    "inventory.operations.action.reject": "Reddet",
    "Reject": "Reddet",
    "inventory.operations.column.when": "Zaman",
    "When": "Zaman",
    "inventory.operations.column.event": "Etkinlik",
    "inventory.operations.column.change": "Değişiklik",
    "inventory.operations.column.after": "Sonra",
    "After": "Sonra",
    "inventory.operations.column.order": "Sipariş",
    "inventory.operations.column.route": "Rota",
    "Route": "Rota",
    "inventory.operations.column.lines": "Satırlar",
    "Lines": "Satırlar",
    "inventory.operations.column.expected": "Beklenen",
    "Expected": "Beklenen",
    "inventory.operations.column.request": "Talep",
    "Request": "Talep",
    "inventory.operations.column.request_supply": "Talep / tedarik",
    "Request / supply": "Talep / tedarik",
    "inventory.operations.column.created": "Oluşturulma",
    "inventory.operations.column.receipt": "Mal kabulü",
    "Receipt": "Mal kabulü",
    "inventory.operations.empty.movements": "Henüz stok hareketi kaydedilmedi.",
    "No stock movements recorded yet.": "Henüz stok hareketi kaydedilmedi.",
    "inventory.operations.empty.batches": "Henüz envanter partisi kaydedilmedi.",
    "No inventory batches have been recorded yet.": "Henüz envanter partisi kaydedilmedi.",
    "inventory.operations.empty.transfers": "Henüz transfer siparişi yok.",
    "No transfer orders yet.": "Henüz transfer siparişi yok.",
    "inventory.operations.empty.requisitions": "Henüz stok talebi yok.",
    "No requisitions yet.": "Henüz stok talebi yok.",
    "inventory.operations.empty.receipts": "Henüz mal kabulü yok.",
    "No goods receipts yet.": "Henüz mal kabulü yok.",
    "inventory.operations.batch.edit_title": "Partiyi düzenle",
    "Edit batch": "Partiyi düzenle",
    "inventory.operations.batch.edit_description": "Parti miktarı stok düzeltmesiyle değiştirilir; bu form yalnızca kimlik ve takip alanlarını günceller.",
    "Batch quantity is changed through a stock adjustment; this form only updates its identity and tracking fields.": "Parti miktarı stok düzeltmesiyle değiştirilir; bu form yalnızca kimlik ve takip alanlarını günceller.",
    "inventory.operations.batch.save": "Partiyi kaydet",
    "Save batch": "Partiyi kaydet",
    "inventory.operations.batch.lot_number": "Parti numarası",
    "Lot number": "Parti numarası",
    "inventory.operations.batch.lot_placeholder": "LOT-001",
    "LOT-001": "LOT-001",
    "inventory.operations.batch.expiry_date": "Son kullanma tarihi",
    "inventory.operations.batch.condition": "Durum",
    "inventory.operations.batch.condition_placeholder": "iyi",
    "good": "iyi",
    "inventory.operations.batch.unit": "Ölçü birimi",
    "Unit of measure": "Ölçü birimi",
    "inventory.operations.batch.unit_placeholder": "kutu, adet, kg",
    "box, piece, kg": "kutu, adet, kg",
    "inventory.operations.batch.no_expiry": "Son kullanma tarihi yok",
    "No expiry": "Son kullanma tarihi yok",
    "inventory.operations.batch.updated": "Parti güncellendi",
    "Batch updated": "Parti güncellendi",
    "common.status.in_transit": "Yolda",
    "In transit": "Yolda",
    "common.status.pending": "Bekliyor",
    "Pending": "Bekliyor",
    "common.status.approved": "Onaylandı",
    "Approved": "Onaylandı",
    "common.status.rejected": "Reddedildi",
    "Rejected": "Reddedildi",
    "common.status.cancelled": "İptal edildi",
    "Cancelled": "İptal edildi",
    "common.status.received": "Teslim alındı",
    "common.status.sent": "Gönderildi",
    "Sent": "Gönderildi",
    "common.note": "Not",
    "common.optional": "İsteğe bağlı",
    "Optional": "İsteğe bağlı",
    "common.error.generic": "Bir şeyler ters gitti.",
    "Something went wrong.": "Bir şeyler ters gitti.",
    "purchase_orders.title": "Satın alma siparişleri",
    "purchase_orders.title_singular": "Satın alma siparişi",
    "purchase_orders.tab.all": "Tümü",
    "purchase_orders.tab.partial": "Kısmen teslim alındı",
    "Partially received": "Kısmen teslim alındı",
    "purchase_orders.create.new": "Yeni satın alma siparişi",
    "New purchase order": "Yeni satın alma siparişi",
    "purchase_orders.create.title": "Yeni satın alma siparişi",
    "purchase_orders.create.subtitle": "Taslak olarak kaydedildi. Tedarikçiye ilettiğinizde gönderildi olarak işaretleyin.",
    "Saved as a draft. Mark it as sent once it’s with the supplier.": "Taslak olarak kaydedildi. Tedarikçiye ilettiğinizde gönderildi olarak işaretleyin.",
    "purchase_orders.create.submit": "Taslak oluştur",
    "Create draft": "Taslak oluştur",
    "purchase_orders.field.location": "Teslim alma konumu",
    "purchase_orders.field.supplier": "Tedarikçi",
    "Supplier": "Tedarikçi",
    "purchase_orders.field.reference": "Tedarikçi referansı",
    "Supplier reference": "Tedarikçi referansı",
    "purchase_orders.field.expected_delivery": "Beklenen teslimat",
    "Expected delivery": "Beklenen teslimat",
    "purchase_orders.field.products": "Ürünler",
    "Products": "Ürünler",
    "purchase_orders.select_location": "Konum seçin",
    "Select location": "Konum seçin",
    "purchase_orders.no_locations": "Tanımlı konum yok",
    "No locations set up": "Tanımlı konum yok",
    "purchase_orders.add_location": "Önce bir konum ekleyin →",
    "Add a location first →": "Önce bir konum ekleyin →",
    "purchase_orders.supplier_placeholder": "ACME Ltd",
    "ACME Ltd": "ACME Ltd",
    "purchase_orders.reference_placeholder": "EXT-PO-001",
    "EXT-PO-001": "EXT-PO-001",
    "purchase_orders.all_locations": "Tüm konumlar",
    "All locations": "Tüm konumlar",
    "purchase_orders.location_number": "Konum #{id}",
    "purchase_orders.search_products": "Eklenecek ürünleri ara",
    "Search products to add": "Eklenecek ürünleri ara",
    "purchase_orders.in_stock": "Stokta: {count}",
    "In stock: {count}": "Stokta: {count}",
    "purchase_orders.column.order": "Sipariş",
    "purchase_orders.column.product": "Ürün",
    "purchase_orders.column.quantity": "Miktar",
    "purchase_orders.column.ordered": "Sipariş edilen",
    "Ordered": "Sipariş edilen",
    "purchase_orders.column.received": "Teslim alınan",
    "purchase_orders.column.remaining": "Kalan",
    "purchase_orders.column.unit_cost": "Birim maliyet",
    "Unit cost": "Birim maliyet",
    "purchase_orders.column.supplier": "Tedarikçi",
    "purchase_orders.column.location": "Konum",
    "purchase_orders.column.progress": "Teslim alınan",
    "purchase_orders.column.value": "Değer",
    "purchase_orders.column.expected": "Beklenen",
    "purchase_orders.column.status": "Durum",
    "purchase_orders.action.mark_sent": "Gönderildi olarak işaretle",
    "Mark as sent": "Gönderildi olarak işaretle",
    "purchase_orders.action.receive": "Teslim al",
    "purchase_orders.action.receive_stock": "Stok teslim al",
    "Receive stock": "Stok teslim al",
    "purchase_orders.action.cancel_order": "Siparişi iptal et",
    "Cancel order": "Siparişi iptal et",
    "purchase_orders.action.close_order": "Siparişi kapat",
    "Close order": "Siparişi kapat",
    "purchase_orders.receive.subtitle": "Gelen ürünleri girin. Onaylandığında teslim alma konumundaki stok güncellenir.",
    "Enter what arrived. Stock at the receiving location updates on confirm.": "Gelen ürünleri girin. Onaylandığında teslim alma konumundaki stok güncellenir.",
    "purchase_orders.receive.now": "Şimdi teslim al",
    "Receive now": "Şimdi teslim al",
    "purchase_orders.receive.confirm": "Teslim almayı onayla",
    "Confirm receipt": "Teslim almayı onayla",
    "purchase_orders.confirm.cancel": "Bu satın alma siparişi iptal edilsin mi?",
    "Cancel this purchase order?": "Bu satın alma siparişi iptal edilsin mi?",
    "purchase_orders.empty.all": "Henüz satın alma siparişi yok. Stok yenilemek için sipariş oluşturun.",
    "No purchase orders yet. Create one to restock inventory.": "Henüz satın alma siparişi yok. Stok yenilemek için sipariş oluşturun.",
    "purchase_orders.empty.filtered": "Bu durumda satın alma siparişi yok.",
    "No purchase orders with this status.": "Bu durumda satın alma siparişi yok.",
    "purchase_orders.error.location_required": "Teslim alma konumu seçin.",
    "Choose a receiving location.": "Teslim alma konumu seçin.",
    "purchase_orders.error.product_required": "En az bir ürün ekleyin.",
    "Add at least one product.": "En az bir ürün ekleyin.",
    "purchase_orders.error.quantity_positive": "Her miktar 0’dan büyük olmalıdır.",
    "Every quantity must be greater than 0.": "Her miktar 0’dan büyük olmalıdır.",
    "purchase_orders.error.receive_quantity": "En az bir ürün için miktar girin.",
    "Enter a quantity for at least one item.": "En az bir ürün için miktar girin.",
    "purchase_orders.toast.created": "Satın alma siparişi taslak olarak oluşturuldu",
    "Purchase order created as draft": "Satın alma siparişi taslak olarak oluşturuldu",
    "purchase_orders.toast.sent": "Gönderildi olarak işaretlendi",
    "Marked as sent": "Gönderildi olarak işaretlendi",
    "purchase_orders.toast.received": "Stok teslim alındı ve envanter güncellendi",
    "Stock received and inventory updated": "Stok teslim alındı ve envanter güncellendi",
    "purchase_orders.toast.cancelled": "Satın alma siparişi iptal edildi",
    "Purchase order cancelled": "Satın alma siparişi iptal edildi",
    "purchase_orders.toast.closed": "Satın alma siparişi kapatıldı",
    "Purchase order closed": "Satın alma siparişi kapatıldı",
    "schedule.title": "Program",
    "schedule.view.month": "Ay",
    "Month": "Ay",
    "schedule.view.week": "Hafta",
    "Week": "Hafta",
    "schedule.view.day": "Gün",
    "Day": "Gün",
    "schedule.today": "Bugün",
    "Today": "Bugün",
    "schedule.order_number": "Sipariş #{number}",
    "Order #{number}": "Sipariş #{number}",
    "schedule.customer": "Müşteri",
    "schedule.more_events": "+{count} tane daha",
    "+{count} more": "+{count} tane daha",
    "schedule.payment.paid": "Ödendi",
    "schedule.payment.pending": "Bekliyor",
    "schedule.payment.failed": "Başarısız",
    "schedule.booking_details": "Rezervasyon ayrıntıları",
    "Booking details": "Rezervasyon ayrıntıları",
    "schedule.order_reference": "Sipariş referansı",
    "schedule.amount": "Tutar",
    "schedule.start": "Başlangıç",
    "schedule.end": "Bitiş",
    "schedule.item_number": "Öğe {number}",
    "Item {number}": "Öğe {number}",
    "schedule.view_order": "Siparişin tamamını görüntüle",
    "View full order": "Siparişin tamamını görüntüle",
    "onboarding.greeting.morning": "Günaydın",
    "Good morning": "Günaydın",
    "onboarding.greeting.morning_named": "Günaydın, {name}",
    "Good morning {name}": "Günaydın, {name}",
    "onboarding.greeting.afternoon": "İyi günler",
    "Good afternoon": "İyi günler",
    "onboarding.greeting.afternoon_named": "İyi günler, {name}",
    "Good afternoon {name}": "İyi günler, {name}",
    "onboarding.greeting.evening": "İyi akşamlar",
    "Good evening": "İyi akşamlar",
    "onboarding.greeting.evening_named": "İyi akşamlar, {name}",
    "Good evening {name}": "İyi akşamlar, {name}",
    "onboarding.greeting.night": "Merhaba",
    "Hello": "Merhaba",
    "onboarding.greeting.night_named": "Merhaba, {name}",
    "Hello {name}": "Merhaba, {name}",
    "onboarding.encouragement": "Var olmasını istediğiniz platformu oluşturun.",
    "Build the platform you wish existed.": "Var olmasını istediğiniz platformu oluşturun.",
    "onboarding.plan.personalized": "Kişiselleştirilmiş lansman planı",
    "Personalized launch plan": "Kişiselleştirilmiş lansman planı",
    "onboarding.plan.label": "Lansman planı",
    "Launch plan": "Lansman planı",
    "onboarding.plan.refining": "Yol haritanız iyileştiriliyor…",
    "Refining your path…": "Yol haritanız iyileştiriliyor…",
    "onboarding.plan.getting_ready": "Kişisel planınız hazırlanıyor.",
    "Your personalized plan is getting ready.": "Kişisel planınız hazırlanıyor.",
    "onboarding.checklist.preview": "Kontrol listesi önizlemesi",
    "Checklist preview": "Kontrol listesi önizlemesi",
    "onboarding.workspace.live": "Çalışma alanı yayında",
    "Live workspace": "Çalışma alanı yayında",
    "onboarding.workspace.no_tenant": "Bağlı etkin kiracı yok",
    "No live tenant connected": "Bağlı etkin kiracı yok",
    "onboarding.workspace.domain_pending": "Alan adı beklemede",
    "Domain pending": "Alan adı beklemede",
    "onboarding.progress.summary": "{total} lansman adımından {completed} tamamlandı",
    "{completed} of {total} launch actions done": "{total} lansman adımından {completed} tamamlandı",
    "onboarding.progress.auto_detected": "Otomatik algılanan: {count}",
    "{count} auto-detected": "Otomatik algılanan: {count}",
    "onboarding.progress.auto_detected_short": "Otomatik algılandı",
    "Auto-detected": "Otomatik algılandı",
    "onboarding.progress.saving": "İlerleme kaydediliyor…",
    "Saving progress…": "İlerleme kaydediliyor…",
    "onboarding.progress.checking": "Kontrol ediliyor…",
    "Checking…": "Kontrol ediliyor…",
    "onboarding.progress.mark_done": "Tamamlandı olarak işaretle",
    "Mark done": "Tamamlandı olarak işaretle",
    "onboarding.progress.unlocked": "Kilidi açıldı: {impact}",
    "Unlocked: {impact}": "Kilidi açıldı: {impact}",
    "onboarding.next_task": "Sıradaki en iyi görev",
    "Next best task": "Sıradaki en iyi görev",
    "onboarding.upcoming.title": "Yaklaşan görevler",
    "Upcoming tasks": "Yaklaşan görevler",
    "onboarding.upcoming.summary_one": "Mevcut adımdan sonra sırada {count} görev var.",
    "{count} task queued after the current action.": "Mevcut adımdan sonra sırada {count} görev var.",
    "onboarding.upcoming.summary_other": "Mevcut adımdan sonra sırada {count} görev var.",
    "{count} tasks queued after the current action.": "Mevcut adımdan sonra sırada {count} görev var.",
    "onboarding.upcoming.hide": "Görevleri gizle",
    "Hide tasks": "Görevleri gizle",
    "onboarding.upcoming.view_all": "Tüm görevleri görüntüle",
    "View all tasks": "Tüm görevleri görüntüle",
    "onboarding.complete.title": "Harika bir başlangıç. Platformunuzun temeli hazır.",
    "Great start. Your foundation is live.": "Harika bir başlangıç. Platformunuzun temeli hazır.",
    "onboarding.complete.description": "Promosyonlar ve iletişim araçları gibi büyüme özelliklerinin kilidini açmak için devam edin.",
    "Keep going to unlock growth essentials like promotions and communications.": "Promosyonlar ve iletişim araçları gibi büyüme özelliklerinin kilidini açmak için devam edin.",
    "onboarding.full_checklist.title": "Tam kontrol listesi",
    "Full checklist": "Tam kontrol listesi",
    "onboarding.full_checklist.description": "Kuruluma aynı deneyimde devam edin.",
    "Continue setup in the same experience.": "Kuruluma aynı deneyimde devam edin.",
    "onboarding.full_checklist.back": "Lansman planına dön",
    "Back to launch path": "Lansman planına dön",
    "onboarding.completed.title": "Tamamlandı",
    "onboarding.completed.summary_one": "{count} görev tamamlandı",
    "{count} task completed": "{count} görev tamamlandı",
    "onboarding.completed.summary_other": "{count} görev tamamlandı",
    "{count} tasks completed": "{count} görev tamamlandı",
    "onboarding.completed.open_again": "Yeniden aç",
    "Open again": "Yeniden aç",
    "onboarding.plan.marketplace.eyebrow": "Pazaryeri lansman yolu",
    "Marketplace launch path": "Pazaryeri lansman yolu",
    "onboarding.plan.marketplace.title": "Pazaryerinizi başlatın",
    "Launch your marketplace": "Pazaryerinizi başlatın",
    "onboarding.plan.marketplace.title_named": "{project} projesini çalışan bir pazaryerine dönüştürün",
    "Turn {project} into a working marketplace": "{project} projesini çalışan bir pazaryerine dönüştürün",
    "onboarding.plan.marketplace.subtitle": "Canlı siteyi açın, ilk ilanı oluşturun ve alıcı yolculuğunu deneyin.",
    "Open the live site create the first listing and test the buyer journey.": "Canlı siteyi açın, ilk ilanı oluşturun ve alıcı yolculuğunu deneyin.",
    "onboarding.plan.marketplace.value_moment": "İlk değer anı: satıcı ilan yayınlayabilir, alıcı da işlem yapabilir.",
    "First value moment: a seller can publish and a buyer can act.": "İlk değer anı: satıcı ilan yayınlayabilir, alıcı da işlem yapabilir.",
    "onboarding.plan.marketplace.why_title": "Ekipler bunu neden tamamlıyor",
    "Why teams finish this": "Ekipler bunu neden tamamlıyor",
    "onboarding.plan.marketplace.why_body": "Alıcı ve satıcılar için gerçek sonuçlar her adımı anlamlı kılar ve ivmeyi korur.",
    "Real buyer and seller outcomes make every next step useful and keep momentum.": "Alıcı ve satıcılar için gerçek sonuçlar her adımı anlamlı kılar ve ivmeyi korur.",
    "onboarding.plan.store.eyebrow": "Mağaza lansman yolu",
    "Store launch path": "Mağaza lansman yolu",
    "onboarding.plan.store.title": "Mağazanızı ilk siparişe hazırlayın",
    "Get your store ready for the first order": "Mağazanızı ilk siparişe hazırlayın",
    "onboarding.plan.store.title_named": "{project} projesini ilk siparişe hazırlayın",
    "Make {project} ready for the first order": "{project} projesini ilk siparişe hazırlayın",
    "onboarding.plan.store.subtitle": "Ürün ekleyin, mağazayı kontrol edin ve ödeme adımlarını tamamlayın.",
    "Add a product check the storefront and complete checkout essentials.": "Ürün ekleyin, mağazayı kontrol edin ve ödeme adımlarını tamamlayın.",
    "onboarding.plan.store.value_moment": "İlk değer anı: ürün görünür ve ödeme süreci test edilebilir.",
    "First value moment: a product is visible and checkout can be tested.": "İlk değer anı: ürün görünür ve ödeme süreci test edilebilir.",
    "onboarding.plan.store.why_title": "Ekipler bunu neden tamamlıyor",
    "onboarding.plan.store.why_body": "Üründen ödemeye hızla geçmek mağazayı gerçek kılar ve motivasyonu sürdürür.",
    "Move from product to checkout quickly so the store feels real and progress stays motivating.": "Üründen ödemeye hızla geçmek mağazayı gerçek kılar ve motivasyonu sürdürür.",
    "onboarding.plan.booking.eyebrow": "Rezervasyon lansman yolu",
    "Booking launch path": "Rezervasyon lansman yolu",
    "onboarding.plan.booking.title": "Platformunuzu rezervasyona açın",
    "Make your platform bookable": "Platformunuzu rezervasyona açın",
    "onboarding.plan.booking.title_named": "{project} projesini rezervasyona açın",
    "Make {project} bookable": "{project} projesini rezervasyona açın",
    "onboarding.plan.booking.subtitle": "İlk hizmeti oluşturun, müşteri deneyimini açın ve rezervasyonu test edin.",
    "Create the first service open the customer experience and test a reservation.": "İlk hizmeti oluşturun, müşteri deneyimini açın ve rezervasyonu test edin.",
    "onboarding.plan.booking.value_moment": "İlk değer anı: müşteri bir saat veya kontenjan talep edebilir.",
    "First value moment: a customer can request a time or slot.": "İlk değer anı: müşteri bir saat veya kontenjan talep edebilir.",
    "onboarding.plan.booking.why_title": "Ekipler bunu neden tamamlıyor",
    "onboarding.plan.booking.why_body": "Büyümeden önce güven kazanmak için rezervasyon akışının tamamını erkenden doğrulayın.",
    "Validate the full booking journey early to build confidence before expanding.": "Büyümeden önce güven kazanmak için rezervasyon akışının tamamını erkenden doğrulayın.",
    "onboarding.plan.digital.eyebrow": "Dijital ürün lansman yolu",
    "Digital launch path": "Dijital ürün lansman yolu",
    "onboarding.plan.digital.title": "Dijital ürünlerinizi satmaya başlayın",
    "Start selling your digital products": "Dijital ürünlerinizi satmaya başlayın",
    "onboarding.plan.digital.title_named": "{project} projesini dijital ürün satışına hazırlayın",
    "Make {project} ready to sell digital products": "{project} projesini dijital ürün satışına hazırlayın",
    "onboarding.plan.digital.subtitle": "Dijital ürün yükleyin, müşteri akışını önizleyin ve ödemenin hazır olduğunu doğrulayın.",
    "Upload a digital product preview the customer flow and confirm payment readiness.": "Dijital ürün yükleyin, müşteri akışını önizleyin ve ödemenin hazır olduğunu doğrulayın.",
    "onboarding.plan.digital.value_moment": "İlk değer anı: alıcı bir dosyayı bulup satın alabilir.",
    "First value moment: a buyer can discover and purchase a file.": "İlk değer anı: alıcı bir dosyayı bulup satın alabilir.",
    "onboarding.plan.digital.why_title": "Ekipler bunu neden tamamlıyor",
    "onboarding.plan.digital.why_body": "Kataloğu genişletmenin büyüme hissi vermesi için keşif ve satın almayı hızla doğrulayın.",
    "Prove discovery and purchase quickly so expanding the catalog feels like growth.": "Kataloğu genişletmenin büyüme hissi vermesi için keşif ve satın almayı hızla doğrulayın.",
    "onboarding.plan.campaign.eyebrow": "Kampanya lansman yolu",
    "Campaign launch path": "Kampanya lansman yolu",
    "onboarding.plan.campaign.title": "Kampanya platformunuzu başlatın",
    "Launch your campaign platform": "Kampanya platformunuzu başlatın",
    "onboarding.plan.campaign.title_named": "{project} projesini destekçilere hazırlayın",
    "Make {project} ready for supporters": "{project} projesini destekçilere hazırlayın",
    "onboarding.plan.campaign.subtitle": "Kampanya oluşturun, herkese açık sayfayı önizleyin ve katkı sürecini test edin.",
    "Create a campaign preview the public page and test the contribution journey.": "Kampanya oluşturun, herkese açık sayfayı önizleyin ve katkı sürecini test edin.",
    "onboarding.plan.campaign.value_moment": "İlk değer anı: destekçi kampanyayı anlayıp katkıda bulunabilir.",
    "First value moment: a supporter can understand and contribute.": "İlk değer anı: destekçi kampanyayı anlayıp katkıda bulunabilir.",
    "onboarding.plan.campaign.why_title": "Ekipler bunu neden tamamlıyor",
    "onboarding.plan.campaign.why_body": "Destekçilerin güvenip harekete geçmesi için hikâyeyi ve katkı akışını erkenden netleştirin.",
    "Clarify the story and contribution flow early so supporters can trust and act.": "Destekçilerin güvenip harekete geçmesi için hikâyeyi ve katkı akışını erkenden netleştirin.",
    "onboarding.plan.creator.eyebrow": "İçerik üreticisi lansman yolu",
    "Creator launch path": "İçerik üreticisi lansman yolu",
    "onboarding.plan.creator.title": "İlk kitlenize hazır olun",
    "Get ready for your first audience": "İlk kitlenize hazır olun",
    "onboarding.plan.creator.title_named": "{project} projesini ilk kitlesine hazırlayın",
    "Make {project} ready for its first audience": "{project} projesini ilk kitlesine hazırlayın",
    "onboarding.plan.creator.subtitle": "Net bir teklif yayınlayın, deneyimi şekillendirin ve çalışmanızın bulunup desteklenmesini kolaylaştırın.",
    "Publish one clear offer shape the experience and make it easy to discover and support your work.": "Net bir teklif yayınlayın, deneyimi şekillendirin ve çalışmanızın bulunup desteklenmesini kolaylaştırın.",
    "onboarding.plan.creator.value_moment": "İlk değer anı: çalışmanız görünür ve paylaşılmaya hazır.",
    "First value moment: your work is visible and ready to share.": "İlk değer anı: çalışmanız görünür ve paylaşılmaya hazır.",
    "onboarding.plan.creator.why_title": "Neden işe yarıyor",
    "Why this works": "Neden işe yarıyor",
    "onboarding.plan.creator.why_body": "Daha fazla araç veya karmaşıklık eklemeden önce gerçek bir şey yayınlamaya odaklanın.",
    "Focus on publishing something real before adding more tools or complexity.": "Daha fazla araç veya karmaşıklık eklemeden önce gerçek bir şey yayınlamaya odaklanın.",
    "onboarding.step.open_live_site.title": "Canlı siteyi açın",
    "Open the live experience": "Canlı siteyi açın",
    "onboarding.step.open_live_site.description": "Müşterilerin gördükleriyle başlayın. Böylece kurulum soyutlaşmadan ürün gerçek görünür.",
    "onboarding.step.open_live_site.description_domain": "Откройте {domain} и посмотрите, что видят ваши клиенты. Так проект станет реальным перед следующим шагом.",
    "Open {domain} and see what your customers see. This makes the build feel real before the next step.": "Откройте {domain} и посмотрите, что видят ваши клиенты. Так проект станет реальным перед следующим шагом.",
    "onboarding.step.open_live_site.cta": "Siteyi aç",
    "Open site": "Siteyi aç",
    "onboarding.step.open_live_site.cta_domain": "{domain} adresini aç",
    "Open {domain}": "{domain} adresini aç",
    "onboarding.step.open_live_site.impact": "Projenin yayında olduğunu doğrular.",
    "onboarding.step.create_supply_shape.title": "İlk kategoriyi oluşturun",
    "Create the first category": "İlk kategoriyi oluşturun",
    "onboarding.step.create_supply_shape.description": "Satıcılar ve alıcılar için net bir başlangıç noktası oluşturun. Kategoriler keşfi düzenler.",
    "Give sellers and buyers a clear place to start. Categories create structure for discovery.": "Satıcılar ve alıcılar için net bir başlangıç noktası oluşturun. Kategoriler keşfi düzenler.",
    "onboarding.step.create_supply_shape.cta": "Kategori ekle",
    "Add category": "Kategori ekle",
    "onboarding.step.create_supply_shape.impact": "Boş pazaryerini göz atılabilir bir kataloğa dönüştürür.",
    "Turns a blank marketplace into a browsable one.": "Boş pazaryerini göz atılabilir bir kataloğa dönüştürür.",
    "onboarding.step.post_first_listing.title": "Bir test ilanı yayınlayın",
    "Post one test listing": "Bir test ilanı yayınlayın",
    "onboarding.step.post_first_listing.description": "Satıcı adımlarını deneyin ve alıcıların inceleyebileceği ilk ürünü yayınlayın.",
    "Experience the seller path and publish the first item buyers can inspect.": "Satıcı adımlarını deneyin ve alıcıların inceleyebileceği ilk ürünü yayınlayın.",
    "onboarding.step.post_first_listing.cta": "İlan yayınla",
    "Post listing": "İlan yayınla",
    "onboarding.step.post_first_listing.impact": "Pazaryerini etkinleştiren temel adım olan ürün arzını oluşturur.",
    "Creates supply the core marketplace activation event.": "Pazaryerini etkinleştiren temel adım olan ürün arzını oluşturur.",
    "onboarding.step.test_buyer_action.title": "Alıcı gibi deneyin",
    "Act like a buyer": "Alıcı gibi deneyin",
    "onboarding.step.test_buyer_action.description": "Göz atın, ilgi gösterin ve müşteri deneyimini görmek için sipariş adımlarını deneyin.",
    "Browse add interest and test the order path to experience what customers will see.": "Göz atın, ilgi gösterin ve müşteri deneyimini görmek için sipariş adımlarını deneyin.",
    "onboarding.step.test_buyer_action.cta": "Alıcı akışını test et",
    "Test buyer flow": "Alıcı akışını test et",
    "onboarding.step.test_buyer_action.impact": "Alıcı yolculuğunu baştan sona doğrular.",
    "Validates the buyer journey end to end.": "Alıcı yolculuğunu baştan sona doğrular.",
    "onboarding.step.add_first_product.title": "Gerçek bir ürün ekleyin",
    "Add one real product": "Gerçek bir ürün ekleyin",
    "onboarding.step.add_first_product.description": "Tek bir eksiksiz ürün, sisteme katalog yapısını uzun bir ayar turundan daha iyi anlatır.",
    "One complete product teaches the system your catalog shape better than a long settings tour.": "Tek bir eksiksiz ürün, sisteme katalog yapısını uzun bir ayar turundan daha iyi anlatır.",
    "onboarding.step.add_first_product.cta": "Ürün ekle",
    "Add product": "Ürün ekle",
    "onboarding.step.add_first_product.impact": "Satışa hazır ilk ürünü oluşturur.",
    "Creates the first sellable item.": "Satışa hazır ilk ürünü oluşturur.",
    "onboarding.step.setup_payments.title": "Ödemeleri bağlayın",
    "Connect payments": "Ödemeleri bağlayın",
    "onboarding.step.setup_payments.description": "Kullanıcıların alışverişlerini kolayca tamamlaması için gerçek ödemeleri etkinleştirin.",
    "Enable real transactions so users can complete purchases without friction.": "Kullanıcıların alışverişlerini kolayca tamamlaması için gerçek ödemeleri etkinleştirin.",
    "onboarding.step.setup_payments.cta": "Ödemeleri ayarla",
    "Set up payments": "Ödemeleri ayarla",
    "onboarding.step.setup_payments.impact": "Gelir elde etme yolunu açar.",
    "onboarding.step.setup_delivery.title": "Teslimat veya hizmet yöntemini ayarlayın",
    "Set shipping or service method": "Teslimat veya hizmet yöntemini ayarlayın",
    "onboarding.step.setup_delivery.description": "Kullanıcıların ödeme sırasında süreci anlayabilmesi için siparişin nasıl karşılanacağını belirleyin.",
    "onboarding.step.setup_delivery.cta": "Teslimatı ayarla",
    "Configure delivery": "Teslimatı ayarla",
    "onboarding.step.setup_delivery.impact": "Ödeme sırasında siparişin nasıl karşılanacağını netleştirir.",
    "Makes fulfillment clear at checkout.": "Ödeme sırasında siparişin nasıl karşılanacağını netleştirir.",
    "onboarding.step.create_bookable_listing.title": "Rezervasyon yapılabilir bir teklif oluşturun",
    "Create one bookable offer": "Rezervasyon yapılabilir bir teklif oluşturun",
    "onboarding.step.create_bookable_listing.description": "Müşterilerin önce rezerve etmesini istediğiniz hizmeti, etkinliği, kiralamayı veya randevuyu ekleyin.",
    "Add the service event rental or appointment customers should book first.": "Müşterilerin önce rezerve etmesini istediğiniz hizmeti, etkinliği, kiralamayı veya randevuyu ekleyin.",
    "onboarding.step.create_bookable_listing.cta": "Teklif oluştur",
    "Create offer": "Teklif oluştur",
    "onboarding.step.create_bookable_listing.impact": "İlk rezervasyon yapılabilir birimi oluşturur.",
    "Creates the first bookable unit.": "İlk rezervasyon yapılabilir birimi oluşturur.",
    "onboarding.step.shape_details.title": "Rezervasyon ayrıntılarını ekleyin",
    "Add booking details": "Rezervasyon ayrıntılarını ekleyin",
    "onboarding.step.shape_details.description": "Müşteriler karar vermeden önce gerekli bilgileri almak için kategori ve alanları kullanın.",
    "Use categories and fields to capture what customers need before they commit.": "Müşteriler karar vermeden önce gerekli bilgileri almak için kategori ve alanları kullanın.",
    "onboarding.step.shape_details.cta": "Alanları ayarla",
    "Set up fields": "Alanları ayarla",
    "onboarding.step.shape_details.impact": "Teklifin karşılaştırılmasını ve güvenilmesini kolaylaştırır.",
    "Makes the offer easier to compare and trust.": "Teklifin karşılaştırılmasını ve güvenilmesini kolaylaştırır.",
    "onboarding.step.test_booking.title": "Müşteri akışını test edin",
    "Test the customer path": "Müşteri akışını test edin",
    "onboarding.step.test_booking.description": "Herkese açık akışı açın ve müşterilerin ilgiden eyleme geçebildiğini doğrulayın.",
    "Open the public flow and verify customers can move from interest to action.": "Herkese açık akışı açın ve müşterilerin ilgiden eyleme geçebildiğini doğrulayın.",
    "onboarding.step.test_booking.cta": "Rezervasyonu test et",
    "Test booking": "Rezervasyonu test et",
    "onboarding.step.test_booking.impact": "Rezervasyon akışını doğrular.",
    "Validates the booking journey.": "Rezervasyon akışını doğrular.",
    "onboarding.step.upload_digital_product.title": "Dijital ürün yükleyin",
    "Upload one digital product": "Dijital ürün yükleyin",
    "onboarding.step.upload_digital_product.description": "İlk indirilebilir ürünü önizlenip satılabilecek şekilde hazırlayın.",
    "Make the first downloadable item complete enough to preview and sell.": "İlk indirilebilir ürünü önizlenip satılabilecek şekilde hazırlayın.",
    "onboarding.step.upload_digital_product.cta": "Dijital ürün ekle",
    "Add digital product": "Dijital ürün ekle",
    "onboarding.step.upload_digital_product.impact": "Satışa hazır ilk dijital varlığınızı oluşturur.",
    "Creates your first sellable digital asset.": "Satışa hazır ilk dijital varlığınızı oluşturur.",
    "onboarding.step.test_purchase.title": "Satın alma akışını test edin",
    "Test purchase flow": "Satın alma akışını test edin",
    "onboarding.step.test_purchase.description": "Ürünü keşfetmeden ödemeye kadar alıcı deneyimini önizleyin.",
    "Preview what buyers see from discovery through checkout.": "Ürünü keşfetmeden ödemeye kadar alıcı deneyimini önizleyin.",
    "onboarding.step.test_purchase.cta": "Ödemeyi test et",
    "Test checkout": "Ödemeyi test et",
    "onboarding.step.test_purchase.impact": "Alıcı yolculuğunun çalıştığını doğrular.",
    "Confirms the buyer journey.": "Alıcı yolculuğunun çalıştığını doğrular.",
    "onboarding.step.create_campaign.title": "İlk kampanyayı oluşturun",
    "Create the first campaign": "İlk kampanyayı oluşturun",
    "onboarding.step.create_campaign.description": "Destekçilerin önce anlaması gereken kampanya veya amaç sayfasını ekleyin.",
    "Add the campaign or cause page supporters should understand first.": "Destekçilerin önce anlaması gereken kampanya veya amaç sayfasını ekleyin.",
    "onboarding.step.create_campaign.cta": "Kampanya oluştur",
    "Create campaign": "Kampanya oluştur",
    "onboarding.step.create_campaign.impact": "Harekete geçmek için ilk herkese açık nedeni oluşturur.",
    "Creates the first public reason to act.": "Harekete geçmek için ilk herkese açık nedeni oluşturur.",
    "onboarding.step.setup_payments_campaign.title": "Katkı ödemelerini bağlayın",
    "Connect contribution payments": "Katkı ödemelerini bağlayın",
    "onboarding.step.setup_payments_campaign.description": "Destekçiler katkılarını tamamlayabildiğinde niyetleri önem kazanır.",
    "Supporter intent matters when they can complete a contribution.": "Destekçiler katkılarını tamamlayabildiğinde niyetleri önem kazanır.",
    "onboarding.step.setup_payments_campaign.cta": "Ödemeleri ayarla",
    "onboarding.step.setup_payments_campaign.impact": "Gerçek katkıların alınmasını sağlar.",
    "Enables real contributions.": "Gerçek katkıların alınmasını sağlar.",
    "onboarding.step.test_supporter_flow.title": "Destekçi akışını test edin",
    "Test supporter flow": "Destekçi akışını test edin",
    "onboarding.step.test_supporter_flow.description": "Herkese açık akışı açın; hikâyenin ve eylemin net olduğundan emin olun.",
    "Open the public journey and make sure the story and action are clear.": "Herkese açık akışı açın; hikâyenin ve eylemin net olduğundan emin olun.",
    "onboarding.step.test_supporter_flow.cta": "Akışı test et",
    "Test flow": "Akışı test et",
    "onboarding.step.test_supporter_flow.impact": "Herkese açık yolu doğrular.",
    "Validates the public path.": "Herkese açık yolu doğrular.",
    "onboarding.step.set_account_categories.title": "Tedarikçi hesap kategorilerini tanımlayın",
    "Define supplier account categories": "Tedarikçi hesap kategorilerini tanımlayın",
    "onboarding.step.set_account_categories.description": "Güveni ve alıcıların gezinmesini iyileştirmek için tedarikçi profillerini türlere ayırın.",
    "Separate supplier profiles by type to improve trust and buyer navigation.": "Güveni ve alıcıların gezinmesini iyileştirmek için tedarikçi profillerini türlere ayırın.",
    "onboarding.step.set_account_categories.cta": "Hesap kategorileri",
    "Account categories": "Hesap kategorileri",
    "onboarding.step.set_account_categories.impact": "Tedarikçi yapısı oluşturuldu.",
    "Supplier structure established.": "Tedarikçi yapısı oluşturuldu.",
    "onboarding.step.set_account_attributes.title": "Tedarikçi profili özellikleri ekleyin",
    "Add supplier profile attributes": "Tedarikçi profili özellikleri ekleyin",
    "onboarding.step.set_account_attributes.description": "Alıcıların tedarikçilerle iletişime geçmeden veya sipariş vermeden önce ihtiyaç duyduğu bilgileri alın.",
    "Capture details buyers need before contacting or ordering from suppliers.": "Alıcıların tedarikçilerle iletişime geçmeden veya sipariş vermeden önce ihtiyaç duyduğu bilgileri alın.",
    "onboarding.step.set_account_attributes.cta": "Tedarikçi özellikleri",
    "Supplier attributes": "Tedarikçi özellikleri",
    "onboarding.step.set_account_attributes.impact": "Alıcı güvenini artırır.",
    "Higher buyer confidence.": "Alıcı güvenini artırır.",
    "onboarding.step.add_promotion.title": "Lansman promosyonu ekleyin",
    "Add a launch promotion": "Lansman promosyonu ekleyin",
    "onboarding.step.add_promotion.description": "İlk ziyarette harekete geçmeyi teşvik etmek için ilk promosyonu oluşturun.",
    "Create your first promotion to encourage action during the first visit.": "İlk ziyarette harekete geçmeyi teşvik etmek için ilk promosyonu oluşturun.",
    "onboarding.step.add_promotion.cta": "Promosyon ekle",
    "Add promotion": "Promosyon ekle",
    "onboarding.step.add_promotion.impact": "Lansman dönüşümünü artırır.",
    "Strengthens launch conversion.": "Lansman dönüşümünü artırır.",
    "onboarding.step.create_coupon.title": "İlk kuponunuzu oluşturun",
    "Create your first coupon": "İlk kuponunuzu oluşturun",
    "onboarding.step.create_coupon.description": "İlk kez alışveriş yapanlara veya üyelere yönelik indirimleri deneyin.",
    "Test discounts for first-time buyers or members.": "İlk kez alışveriş yapanlara veya üyelere yönelik indirimleri deneyin.",
    "onboarding.step.create_coupon.cta": "Kupon oluştur",
    "Create coupon": "Kupon oluştur",
    "onboarding.step.create_coupon.impact": "İlk teklif döngüsünü başlatır.",
    "Unlocks your first offer loop.": "İlk teklif döngüsünü başlatır.",
    "onboarding.step.collections_setup.title": "Koleksiyon oluşturun",
    "Create a collection": "Koleksiyon oluşturun",
    "onboarding.step.collections_setup.description": "Önemli ilanları keşfetmeyi ve göz atmayı kolaylaştıracak şekilde düzenleyin.",
    "Organize important listings to improve discovery and browsing.": "Önemli ilanları keşfetmeyi ve göz atmayı kolaylaştıracak şekilde düzenleyin.",
    "onboarding.step.collections_setup.cta": "Koleksiyon oluştur",
    "Create collection": "Koleksiyon oluştur",
    "onboarding.step.collections_setup.impact": "Gezinmeyi ve keşfi iyileştirir.",
    "Improves navigation and discovery.": "Gezinmeyi ve keşfi iyileştirir.",
    "onboarding.step.configure_comms.title": "İletişim şablonlarını inceleyin",
    "Review communication templates": "İletişim şablonlarını inceleyin",
    "onboarding.step.configure_comms.description": "Büyümeden önce kayıt ve sipariş bildirimlerini hazırlayın.",
    "Prepare signup and order notifications before growth.": "Büyümeden önce kayıt ve sipariş bildirimlerini hazırlayın.",
    "onboarding.step.configure_comms.cta": "İletişimleri aç",
    "Open communications": "İletişimleri aç",
    "onboarding.step.configure_comms.impact": "Müşteri iletişimini hazırlar.",
    "Prepares customer communications.": "Müşteri iletişimini hazırlar.",
    "onboarding.step.customize_attributes.title": "İlan özellikleri ekleyin",
    "Add listing attributes": "İlan özellikleri ekleyin",
    "onboarding.step.customize_attributes.description": "Kullanıcıların önemli özellikleri filtreleyip karşılaştırabilmesi için yapılandırılmış alanlar ekleyin.",
    "onboarding.step.customize_attributes.cta": "Özellik ekle",
    "Add attributes": "Özellik ekle",
    "onboarding.step.customize_attributes.impact": "İlanları karşılaştırmayı kolaylaştırır.",
    "Makes listings easier to compare.": "İlanları karşılaştırmayı kolaylaştırır.",
    "onboarding.step.add_digital_asset.title": "Başka bir dijital ürün ekleyin",
    "Add another digital item": "Başka bir dijital ürün ekleyin",
    "onboarding.step.add_digital_asset.description": "Kullanıcıların kaliteyi ve çeşitliliği değerlendirebilmesi için kataloğu genişletin.",
    "Expand the catalog so users can evaluate quality and assortment.": "Kullanıcıların kaliteyi ve çeşitliliği değerlendirebilmesi için kataloğu genişletin.",
    "onboarding.step.add_digital_asset.cta": "Dijital ilan ekle",
    "Add digital listing": "Dijital ilan ekle",
    "onboarding.step.add_digital_asset.impact": "Dijital kataloğun güvenilirliğini artırır.",
    "Improves digital catalog credibility.": "Dijital kataloğun güvenilirliğini artırır.",
    "personal_assistant.title": "Kişisel asistan",
    "Personal assistant": "Kişisel asistan",
    "personal_assistant.heading": "Platformunuzu adım adım büyütün",
    "Grow your platform one step at a time": "Platformunuzu adım adım büyütün",
    "personal_assistant.subtitle": "{launchType} için hazırlandı. Eylemleri etki ve hazırlık durumuna göre önceliklendiriyoruz.",
    "Built for {launchType}. We prioritize actions by impact and readiness.": "{launchType} için hazırlandı. Eylemleri etki ve hazırlık durumuna göre önceliklendiriyoruz.",
    "personal_assistant.launch.store": "bir mağaza",
    "a store": "bir mağaza",
    "personal_assistant.launch.marketplace": "bir pazaryeri",
    "a marketplace": "bir pazaryeri",
    "personal_assistant.launch.booking": "bir rezervasyon platformu",
    "a booking platform": "bir rezervasyon platformu",
    "personal_assistant.launch.digital": "bir dijital işletme",
    "a digital business": "bir dijital işletme",
    "personal_assistant.launch.campaign": "bir kampanya platformu",
    "a campaign platform": "bir kampanya platformu",
    "personal_assistant.metric.tasks_completed": "Tamamlanan görevler",
    "Tasks completed": "Tamamlanan görevler",
    "personal_assistant.metric.recommendation_clicks": "Öneri tıklamaları",
    "Recommendation clicks": "Öneri tıklamaları",
    "personal_assistant.metric.completed_by_recommendation": "Önerilerle tamamlanan",
    "Completed via recommendations": "Önerilerle tamamlanan",
    "personal_assistant.metric.assist_rate": "Yardım oranı",
    "Assist rate": "Yardım oranı",
    "personal_assistant.personalizing": "Öneriler kişiselleştiriliyor…",
    "Personalizing your recommendations…": "Öneriler kişiselleştiriliyor…",
    "personal_assistant.do_this_now": "Şimdi yap",
    "Do this now": "Şimdi yap",
    "personal_assistant.estimated_time": "Tahmini süre: {minutes} dk",
    "Estimated time: {minutes} min": "Tahmini süre: {minutes} dk",
    "personal_assistant.minutes_short": "{minutes} dk",
    "{minutes} min": "{minutes} dk",
    "personal_assistant.open": "Aç",
    "personal_assistant.mark_done": "Tamamlandı olarak işaretle",
    "personal_assistant.up_next": "Sırada",
    "Up next": "Sırada",
    "personal_assistant.coming_after": "Bundan sonra",
    "Coming after this": "Bundan sonra",
    "personal_assistant.completed_count": "Tamamlandı ({count})",
    "Completed ({count})": "Tamamlandı ({count})",
    "personal_assistant.hide": "Gizle",
    "Hide": "Gizle",
    "personal_assistant.show": "Göster",
    "Show": "Göster",
    "personal_assistant.feature.open_live_site.name": "Canlı siteyi açın",
    "personal_assistant.feature.open_live_site.outcome": "Müşterilerin canlı platforma ulaşabildiğini doğrularsınız.",
    "You confirm customers can reach the live platform.": "Müşterilerin canlı platforma ulaşabildiğini doğrularsınız.",
    "personal_assistant.feature.create_supply_shape.name": "İlk kategoriyi oluşturun",
    "personal_assistant.feature.create_supply_shape.outcome": "Müşteriler net bir yapıda gezinebilir.",
    "Customers can browse with a clear structure.": "Müşteriler net bir yapıda gezinebilir.",
    "personal_assistant.feature.post_first_listing.name": "Bir test ilanı yayınlayın",
    "personal_assistant.feature.post_first_listing.outcome": "Platformda değerlendirilecek ilk ürün artık mevcut.",
    "The platform now has first supply to evaluate.": "Platformda değerlendirilecek ilk ürün artık mevcut.",
    "personal_assistant.feature.test_buyer_action.name": "Alıcı gibi deneyin",
    "personal_assistant.feature.test_buyer_action.outcome": "Alıcı deneyimini baştan sona doğrularsınız.",
    "You validate buyer-side experience end to end.": "Alıcı deneyimini baştan sona doğrularsınız.",
    "personal_assistant.feature.setup_payments.name": "Ödemeleri bağlayın",
    "personal_assistant.feature.setup_payments.outcome": "Müşteriler gerçek işlemleri tamamlayabilir.",
    "Customers can complete real transactions.": "Müşteriler gerçek işlemleri tamamlayabilir.",
    "personal_assistant.feature.setup_delivery.name": "Teslimat veya hizmet yöntemini ayarlayın",
    "personal_assistant.feature.setup_delivery.outcome": "Müşteriler siparişin nasıl karşılanacağını net biçimde anlar.",
    "Customers can understand fulfillment clearly.": "Müşteriler siparişin nasıl karşılanacağını net biçimde anlar.",
    "personal_assistant.feature.add_promotion.name": "Lansman promosyonu ekleyin",
    "personal_assistant.feature.add_promotion.outcome": "İlk dönüşümler için teşvik oluşturursunuz.",
    "You create an early conversion incentive.": "İlk dönüşümler için teşvik oluşturursunuz.",
    "personal_assistant.feature.configure_comms.name": "İletişim şablonlarını inceleyin",
    "personal_assistant.feature.configure_comms.outcome": "Kullanıcılar süreç boyunca net bilgilendirmeler alır.",
    "Users receive clear lifecycle communication.": "Kullanıcılar süreç boyunca net bilgilendirmeler alır.",
    "personal_assistant.feature.view_orders.name": "Siparişleri açın",
    "Open orders": "Siparişleri açın",
    "personal_assistant.feature.view_orders.outcome": "Gelen talepleri izleyip işleyebilirsiniz.",
    "You can monitor and process incoming demand.": "Gelen talepleri izleyip işleyebilirsiniz.",
    "personal_assistant.feature.view_accounts.name": "Hesapları açın",
    "Open accounts": "Hesapları açın",
    "personal_assistant.feature.view_accounts.outcome": "Tedarikçileri veya üyeleri verimli biçimde inceleyebilirsiniz.",
    "You can review suppliers or members efficiently.": "Tedarikçileri veya üyeleri verimli biçimde inceleyebilirsiniz.",
    "personal_assistant.feature.configure_account_categories.name": "Hesap kategorilerini yapılandırın",
    "Configure account categories": "Hesap kategorilerini yapılandırın",
    "personal_assistant.feature.configure_account_categories.outcome": "Tedarikçi ve üye yapısı, katılım ve güven için daha net hale gelir.",
    "Supplier and member structure is clearer for onboarding and trust.": "Tedarikçi ve üye yapısı, katılım ve güven için daha net hale gelir.",
    "personal_assistant.feature.configure_account_attributes.name": "Hesap özelliklerini yapılandırın",
    "Configure account attributes": "Hesap özelliklerini yapılandırın",
    "personal_assistant.feature.configure_account_attributes.outcome": "Profiller, alıcıların kararları için kritik bilgileri içerir.",
    "Profiles capture decision-critical info for buyers.": "Profiller, alıcıların kararları için kritik bilgileri içerir.",
    "personal_assistant.feature.review_account_config.name": "Hesap yapılandırmasını inceleyin",
    "Review account configuration": "Hesap yapılandırmasını inceleyin",
    "personal_assistant.feature.review_account_config.outcome": "Hesap davranışı pazaryeri politikanızla uyumludur.",
    "Account behavior matches your marketplace policy.": "Hesap davranışı pazaryeri politikanızla uyumludur.",
    "personal_assistant.feature.view_listings.name": "İlanları açın",
    "Open listings": "İlanları açın",
    "personal_assistant.feature.view_listings.outcome": "Katalog kalitesini ve hazır olma durumunu izleyebilirsiniz.",
    "You can monitor catalog quality and readiness.": "Katalog kalitesini ve hazır olma durumunu izleyebilirsiniz.",
    "personal_assistant.feature.configure_listing_categories.name": "İlan kategorilerini yapılandırın",
    "Configure listing categories": "İlan kategorilerini yapılandırın",
    "personal_assistant.feature.configure_listing_categories.outcome": "Katalogda gezinmek ve arama yapmak kolaylaşır.",
    "The catalog becomes easier to navigate and discover.": "Katalogda gezinmek ve arama yapmak kolaylaşır.",
    "personal_assistant.feature.configure_listing_attributes.name": "İlan özelliklerini yapılandırın",
    "Configure listing attributes": "İlan özelliklerini yapılandırın",
    "personal_assistant.feature.configure_listing_attributes.outcome": "Kullanıcılar ilanları yapılandırılmış ayrıntılarla karşılaştırabilir.",
    "Users can compare listings with structured details.": "Kullanıcılar ilanları yapılandırılmış ayrıntılarla karşılaştırabilir.",
    "personal_assistant.feature.configure_variant_types.name": "Varyant türlerini yapılandırın",
    "Configure variant types": "Varyant türlerini yapılandırın",
    "personal_assistant.feature.configure_variant_types.outcome": "Katalog, ürün ve hizmet çeşitlerini açıkça destekler.",
    "The catalog supports product and service variations clearly.": "Katalog, ürün ve hizmet çeşitlerini açıkça destekler.",
    "personal_assistant.feature.review_listing_configs.name": "İlan ek özelliklerini inceleyin",
    "Review listing additional features": "İlan ek özelliklerini inceleyin",
    "personal_assistant.feature.review_listing_configs.outcome": "İlan davranışı operasyon modelinizle uyumludur.",
    "Listing behavior matches your operating model.": "İlan davranışı operasyon modelinizle uyumludur.",
    "personal_assistant.feature.manage_collections.name": "Koleksiyonları yönetin",
    "Manage collections": "Koleksiyonları yönetin",
    "personal_assistant.feature.manage_collections.outcome": "İlgi çekici koleksiyonları bulmak daha kolay olur.",
    "High-intent browsing paths are easier to discover.": "İlgi çekici koleksiyonları bulmak daha kolay olur.",
    "personal_assistant.feature.manage_coupons.name": "Kuponları yönetin",
    "Manage coupons": "Kuponları yönetin",
    "personal_assistant.feature.manage_coupons.outcome": "Etkinleştirme için hedefli teklifler sunabilirsiniz.",
    "You can run targeted offers for activation.": "Etkinleştirme için hedefli teklifler sunabilirsiniz.",
    "personal_assistant.feature.view_transactions.name": "İşlemleri görüntüleyin",
    "View transactions": "İşlemleri görüntüleyin",
    "personal_assistant.feature.view_transactions.outcome": "Güven ve operasyonlar için ödeme hareketleri izlenebilir.",
    "Payment activity can be monitored for trust and operations.": "Güven ve operasyonlar için ödeme hareketleri izlenebilir.",
    "personal_assistant.feature.view_users.name": "Kullanıcıları açın",
    "Open users": "Kullanıcıları açın",
    "personal_assistant.feature.view_users.outcome": "Müşteri ve üye büyümesinin kalitesini izleyebilirsiniz.",
    "You can monitor customer and member growth quality.": "Müşteri ve üye büyümesinin kalitesini izleyebilirsiniz.",
    "personal_assistant.feature.configure_user_attributes.name": "Kullanıcı özelliklerini yapılandırın",
    "Configure user attributes": "Kullanıcı özelliklerini yapılandırın",
    "personal_assistant.feature.configure_user_attributes.outcome": "Etkileşimi artırmak için profil verileri toplayabilirsiniz.",
    "You can capture profile signals to improve engagement.": "Etkileşimi artırmak için profil verileri toplayabilirsiniz.",
    "personal_assistant.feature.review_ratings.name": "Puanları ve yorumları inceleyin",
    "Review ratings and reviews": "Puanları ve yorumları inceleyin",
    "personal_assistant.feature.review_ratings.outcome": "Güven göstergeleri izlenir ve iyileştirilir.",
    "Trust signals are monitored and improved.": "Güven göstergeleri izlenir ve iyileştirilir.",
    "personal_assistant.feature.view_reports.name": "Raporları açın",
    "Open reports": "Raporları açın",
    "personal_assistant.feature.view_reports.outcome": "Veri görünümüyle performansı takip edebilirsiniz.",
    "You can track performance with a data view.": "Veri görünümüyle performansı takip edebilirsiniz.",
    "personal_assistant.feature.manage_media.name": "Medya kitaplığını yönetin",
    "Manage media library": "Medya kitaplığını yönetin",
    "personal_assistant.feature.manage_media.outcome": "Marka ve ilan görsellerini korumak kolaylaşır.",
    "Brand and listing visuals are easier to maintain.": "Marka ve ilan görsellerini korumak kolaylaşır.",
    "personal_assistant.feature.manage_reported_listings.name": "Bildirilen ilanları inceleyin",
    "Review reported listings": "Bildirilen ilanları inceleyin",
    "personal_assistant.feature.manage_reported_listings.outcome": "Riskli veya düşük kaliteli içerikler hızla ele alınabilir.",
    "Risky or low-quality content can be handled quickly.": "Riskli veya düşük kaliteli içerikler hızla ele alınabilir.",
    "personal_assistant.feature.app_customization.name": "Uygulama deneyimini özelleştirin",
    "Customize app experience": "Uygulama deneyimini özelleştirin",
    "personal_assistant.feature.app_customization.outcome": "Mobil uygulama deneyimi markanızla uyumlu olur.",
    "The mobile app experience aligns with your brand.": "Mobil uygulama deneyimi markanızla uyumlu olur.",
    "personal_assistant.feature.app_integrations.name": "Uygulama entegrasyonlarını yapılandırın",
    "Configure app integrations": "Uygulama entegrasyonlarını yapılandırın",
    "personal_assistant.feature.app_integrations.outcome": "Temel platform hizmetleri uygulama akışlarına bağlanır.",
    "Core platform services connect with app workflows.": "Temel platform hizmetleri uygulama akışlarına bağlanır.",
    "personal_assistant.feature.customize_strings.name": "Arayüz metinlerini özelleştirin",
    "Customize interface text": "Arayüz metinlerini özelleştirin",
    "personal_assistant.feature.customize_strings.outcome": "Ürün metinleri hedef kitlenize ve üslubunuza uyar.",
    "Product copy matches your audience and tone.": "Ürün metinleri hedef kitlenize ve üslubunuza uyar.",
    "personal_assistant.feature.review_settings_home.name": "Ayarları açın",
    "Open settings": "Ayarları açın",
    "personal_assistant.feature.review_settings_home.outcome": "Ekip işlemleri için yapılandırmaya erişmek kolaylaşır.",
    "Configuration is easy to find for team operations.": "Ekip işlemleri için yapılandırmaya erişmek kolaylaşır.",
    "personal_assistant.feature.configure_commission.name": "Komisyonu yapılandırın",
    "Configure commission": "Komisyonu yapılandırın",
    "personal_assistant.feature.configure_commission.outcome": "Gelir paylaşımı iş modelinize uyar.",
    "Revenue sharing aligns with your business model.": "Gelir paylaşımı iş modelinize uyar.",
    "personal_assistant.feature.configure_taxes.name": "Vergileri yapılandırın",
    "Configure taxes": "Vergileri yapılandırın",
    "personal_assistant.feature.configure_taxes.outcome": "Ödeme fiyatları öngörülebilir olur ve vergi ayarları hazırlanır.",
    "Checkout pricing is predictable and tax settings are ready.": "Ödeme fiyatları öngörülebilir olur ve vergi ayarları hazırlanır.",
    "personal_assistant.feature.configure_languages.name": "Dilleri yapılandırın",
    "Configure languages": "Dilleri yapılandırın",
    "personal_assistant.feature.configure_languages.outcome": "Deneyim çok dilli kitleleri destekler.",
    "The experience supports a multilingual audience.": "Deneyim çok dilli kitleleri destekler.",
    "personal_assistant.feature.configure_currency.name": "Para birimini yapılandırın",
    "Configure currency": "Para birimini yapılandırın",
    "personal_assistant.feature.configure_currency.outcome": "Fiyatlar hedef pazarın beklentilerine uyar.",
    "Prices align with the expectations of your target market.": "Fiyatlar hedef pazarın beklentilerine uyar.",
    "personal_assistant.feature.configure_countries.name": "Ülkeleri yapılandırın",
    "Configure countries": "Ülkeleri yapılandırın",
    "personal_assistant.feature.configure_countries.outcome": "Lansman için coğrafi kapsam belirlenir.",
    "Geographic coverage is controlled for launch.": "Lansman için coğrafi kapsam belirlenir.",
    "personal_assistant.feature.review_checkout_settings.name": "Ödeme ayarlarını inceleyin",
    "Review checkout settings": "Ödeme ayarlarını inceleyin",
    "personal_assistant.feature.review_checkout_settings.outcome": "Ödeme adımları daha sade ve güvenilir olur.",
    "Checkout is cleaner and more reliable.": "Ödeme adımları daha sade ve güvenilir olur.",
    "personal_assistant.feature.api_configuration.name": "API yapılandırmasını inceleyin",
    "Review API configuration": "API yapılandırmasını inceleyin",
    "personal_assistant.feature.api_configuration.outcome": "Entegrasyonlar ve geliştirici erişimi hazır.",
    "Integrations and developer access are ready.": "Entegrasyonlar ve geliştirici erişimi hazır.",
    "personal_assistant.feature.workspace_website_editor.name": "Web sitesi düzenleyicisini açın",
    "Open website editor": "Web sitesi düzenleyicisini açın",
    "personal_assistant.feature.workspace_website_editor.outcome": "Dönüşümü artırmak için mağaza düzenlenebilir.",
    "The storefront can be refined for conversion.": "Dönüşümü artırmak için mağaza düzenlenebilir.",
    "personal_assistant.feature.workspace_domain_setup.name": "Alan adı kurulumunu inceleyin",
    "Review domain setup": "Alan adı kurulumunu inceleyin",
    "personal_assistant.feature.workspace_domain_setup.outcome": "Düzgün bir alan adı marka güvenini artırır.",
    "A clean domain improves brand trust.": "Düzgün bir alan adı marka güvenini artırır.",
    "personal_assistant.feature.workspace_pages.name": "Site sayfalarını inceleyin",
    "Review site pages": "Site sayfalarını inceleyin",
    "personal_assistant.feature.workspace_pages.outcome": "Temel açılış ve içerik sayfaları kullanıcı güvenini destekler.",
    "Core landing and content pages support user trust.": "Temel açılış ve içerik sayfaları kullanıcı güvenini destekler.",
    "reports.title": "Raporlar",
    "reports.metric.0": "Kullanıcılar",
    "reports.metric.1": "Hesaplar",
    "reports.metric.2": "İlanlar",
    "reports.metric.3": "Satılan ilanlar",
    "Listings Sold": "Satılan ilanlar",
    "reports.metric.4": "Toplam satış",
    "Total Sales": "Toplam satış",
    "reports.metric.5": "Toplam sipariş",
    "reports.metric.6": "Toplam kazanç",
    "Total Earnings": "Toplam kazanç",
    "reports.chart.activity": "Günlük pazaryeri etkinliği",
    "Daily marketplace activity": "Günlük pazaryeri etkinliği",
    "reports.chart.activity_description": "Zaman içindeki ilanlar ve yeni kullanıcılar",
    "Listings and new users over time": "Zaman içindeki ilanlar ve yeni kullanıcılar",
    "reports.chart.listings_monthly": "Aylık ilanlar",
    "Listings monthly": "Aylık ilanlar",
    "reports.chart.listings_daily": "Günlük ilanlar",
    "Listings daily": "Günlük ilanlar",
    "reports.chart.users_daily": "Günlük kullanıcılar",
    "Users daily": "Günlük kullanıcılar",
    "reports.chart.users_monthly": "Aylık kullanıcılar",
    "Users monthly": "Aylık kullanıcılar",
    "reports.series.listings": "İlanlar",
    "reports.series.new_users": "Yeni kullanıcılar",
    "New users": "Yeni kullanıcılar",
    "reports.top_sold_listings": "En çok satılan ilanlar",
    "Top sold listings": "En çok satılan ilanlar",
    "reports.view_more_insights": "Daha fazla içgörü görüntüle",
    "View more insights": "Daha fazla içgörü görüntüle",
    "reports.ai.title": "Yapay zekâ satış raporları",
    "AI sales reports": "Yapay zekâ satış raporları",
    "reports.ai.generating": "Raporlar oluşturuluyor…",
    "Generating reports…": "Raporlar oluşturuluyor…",
    "reports.ai.value": "Değer",
    "reports.ai.more_info": "{label} hakkında daha fazla bilgi",
    "More information about {label}": "{label} hakkında daha fazla bilgi",
    "reports.ai.saved_snapshot": "Kaydedilmiş anlık görüntü",
    "Saved snapshot": "Kaydedilmiş anlık görüntü",
    "reports.ai.no_data": "Kullanılabilir veri yok",
    "No data available": "Kullanılabilir veri yok",
    "reports.ai.showing_top": "Toplam {total} sonuçtan ilk {shown} tanesi gösteriliyor",
    "Showing the top {shown} of {total} results": "Toplam {total} sonuçtan ilk {shown} tanesi gösteriliyor",
    "reports.ai.saved_report": "Kaydedilmiş yapay zekâ raporu",
    "Saved AI report": "Kaydedilmiş yapay zekâ raporu",
    "reports.ai.template.country": "Ülkeye göre satışlar",
    "Sales by country": "Ülkeye göre satışlar",
    "reports.ai.template.state": "Bölgeye göre satışlar",
    "Sales by state": "Bölgeye göre satışlar",
    "reports.ai.template.city": "Şehre göre satışlar",
    "Sales by city": "Şehre göre satışlar",
    "reports.ai.template.category": "Kategoriye göre satışlar",
    "Sales by category": "Kategoriye göre satışlar",
    "reports.ai.template.country_all_time": "Ülkeye göre satışlar (tüm zamanlar)",
    "Sales by country (all time)": "Ülkeye göre satışlar (tüm zamanlar)",
    "reports.ai.template.top_listings_all_time": "En çok satılan ilanlar (tüm zamanlar)",
    "Top sold listings (all time)": "En çok satılan ilanlar (tüm zamanlar)",
    "reports.ai.template.listings_by_category_all_time": "Kategoriye göre ilanlar (tüm zamanlar)",
    "Listings by category (all time)": "Kategoriye göre ilanlar (tüm zamanlar)",
    "reports.search_table.title": "İlan arama",
    "Listing search": "İlan arama",
    "reports.search_table.phrase": "İfade",
    "Phrase": "İfade",
    "reports.search_table.result": "Sonuç",
    "reports.search_table.created_at": "Oluşturulma tarihi",
    "Created at": "Oluşturulma tarihi",
    "reports.search_table.user_first_name": "Kullanıcı adı",
    "User first name": "Kullanıcı adı",
    "reports.search_table.user_last_name": "Kullanıcı soyadı",
    "User last name": "Kullanıcı soyadı",
    "reports.search_table.user_email": "Kullanıcı e-postası",
    "User email": "Kullanıcı e-postası",
    "intelligence.title": "İçgörüler",
    "intelligence.description": "Yapay zekâ raporları oluşturun, grafik anlık görüntülerini kaydedin ve yararlı raporları panoya sabitleyin.",
    "Generate AI reports save chart snapshots and pin useful reports to your dashboard.": "Yapay zekâ raporları oluşturun, grafik anlık görüntülerini kaydedin ve yararlı raporları panoya sabitleyin.",
    "intelligence.dashboard.label": "Pano",
    "intelligence.dashboard.pinned_title": "Sabitlenmiş içgörü widget’ları",
    "Pinned intelligence widgets": "Sabitlenmiş içgörü widget’ları",
    "intelligence.dashboard.pinned_count": "{count} sabitlendi",
    "{count} pinned": "{count} sabitlendi",
    "intelligence.dashboard.empty": "Yeniden kullanılabilir bir pano düzeni oluşturmak için kayıtlı raporları sabitleyin.",
    "Pin saved reports to build a reusable dashboard grid.": "Yeniden kullanılabilir bir pano düzeni oluşturmak için kayıtlı raporları sabitleyin.",
    "intelligence.action.open": "Aç",
    "intelligence.action.pin": "Sabitle",
    "Pin": "Sabitle",
    "intelligence.action.unpin": "Sabitlemeyi kaldır",
    "Unpin": "Sabitlemeyi kaldır",
    "intelligence.action.generate": "Oluştur",
    "intelligence.action.save_snapshot": "Anlık görüntüyü kaydet",
    "Save snapshot": "Anlık görüntüyü kaydet",
    "intelligence.action.discard_draft": "Taslağı sil",
    "Discard draft": "Taslağı sil",
    "intelligence.action.load": "Yükle",
    "Load": "Yükle",
    "intelligence.action.refresh": "Yenile",
    "intelligence.action.delete": "Sil",
    "intelligence.table.no_rows": "Bu rapor için yapılandırılmış satır döndürülmedi.",
    "No structured rows were returned for this report.": "Bu rapor için yapılandırılmış satır döndürülmedi.",
    "intelligence.table.no_rows_short": "Kullanılabilir satır yok.",
    "No rows available.": "Kullanılabilir satır yok.",
    "intelligence.field.template": "Rapor şablonu",
    "Report template": "Rapor şablonu",
    "intelligence.field.date_filter": "Tarih filtresi",
    "Date filter": "Tarih filtresi",
    "intelligence.field.prompt": "İstem önizlemesi",
    "Prompt preview": "İstem önizlemesi",
    "intelligence.field.report_name": "Rapor adı",
    "Report name": "Rapor adı",
    "intelligence.field.report_name_placeholder": "Örneğin: En Çok Satan Ürünler – Son 30 Gün",
    "For example: Top Selling Products – Last 30 Days": "Örneğin: En Çok Satan Ürünler – Son 30 Gün",
    "intelligence.field.chart": "Grafik",
    "Chart": "Grafik",
    "intelligence.field.prompt_label": "İstem",
    "Prompt": "İstem",
    "intelligence.date.relative": "Göreli",
    "Relative": "Göreli",
    "intelligence.date.absolute": "Mutlak",
    "Absolute": "Mutlak",
    "intelligence.date.last_n_days": "Son N gün",
    "Last N days": "Son N gün",
    "intelligence.date.last_days": "Son {days} gün",
    "Last {days} days": "Son {days} gün",
    "intelligence.date.from": "Başlangıç",
    "From": "Başlangıç",
    "intelligence.date.to": "Bitiş",
    "To": "Bitiş",
    "intelligence.saved_reports.title": "Kaydedilmiş raporlar",
    "Saved reports": "Kaydedilmiş raporlar",
    "intelligence.saved_reports.empty": "Henüz kaydedilmiş analiz raporu yok.",
    "No saved intelligence reports yet.": "Henüz kaydedilmiş analiz raporu yok.",
    "intelligence.active_report": "Etkin rapor",
    "Active report": "Etkin rapor",
    "intelligence.no_report_selected": "Rapor seçilmedi",
    "No report selected": "Rapor seçilmedi",
    "intelligence.active_report.empty_description": "Verileri incelemek için rapor oluşturun veya kayıtlı rapor yükleyin.",
    "Generate a report or load a saved one to inspect the data.": "Verileri incelemek için rapor oluşturun veya kayıtlı rapor yükleyin.",
    "intelligence.chart.value": "Değer",
    "intelligence.chart.unknown": "Bilinmiyor",
    "intelligence.chart_type.bar": "Çubuk",
    "Barres": "Çubuk",
    "intelligence.chart_type.line": "Çizgi",
    "Line": "Çizgi",
    "intelligence.chart_type.area": "Alan",
    "Area": "Alan",
    "intelligence.chart_type.pie": "Pasta",
    "Pie": "Pasta",
    "intelligence.chart.no_rows": "Bu raporda grafiği çizilecek satır yok.",
    "This report did not return rows to plot.": "Bu raporda grafiği çizilecek satır yok.",
    "intelligence.empty_report": "Yapılandırılmış bir yapay zekâ raporu oluşturmak için şablon ve tarih kontrollerini kullanın; ardından kaydedip panoya sabitleyin.",
    "Use the template and date controls to generate a structured AI report then save it and pin it to your dashboard.": "Yapılandırılmış bir yapay zekâ raporu oluşturmak için şablon ve tarih kontrollerini kullanın; ardından kaydedip panoya sabitleyin.",
    "intelligence.error.update": "Kaydedilmiş rapor güncellenemedi.",
    "Unable to update the saved report.": "Kaydedilmiş rapor güncellenemedi.",
    "intelligence.error.prompt_required": "Rapor oluşturmak için bir istem girin.",
    "Enter a prompt to generate a report.": "Rapor oluşturmak için bir istem girin.",
    "intelligence.error.invalid_response": "Yapay zekâ yanıtı standartlaştırılmış bir rapor içermiyor.",
    "The AI response did not include a normalized report.": "Yapay zekâ yanıtı standartlaştırılmış bir rapor içermiyor.",
    "intelligence.error.generate": "Rapor oluşturulamadı.",
    "Unable to generate the report right now.": "Rapor oluşturulamadı.",
    "intelligence.error.generate_before_save": "Kaydetmeden önce rapor oluşturun.",
    "Generate a report before saving.": "Kaydetmeden önce rapor oluşturun.",
    "intelligence.error.save": "Rapor kaydedilemedi.",
    "Unable to save the report.": "Rapor kaydedilemedi.",
    "intelligence.error.load": "Rapor yüklenemedi.",
    "Unable to load the saved report.": "Rapor yüklenemedi.",
    "intelligence.error.refresh": "Rapor yenilenemedi.",
    "Unable to refresh the saved report.": "Rapor yenilenemedi.",
    "intelligence.error.delete": "Rapor silinemedi.",
    "Unable to delete the saved report.": "Rapor silinemedi.",
    "intelligence.template.top_selling_products": "En çok satan ürünler",
    "Top selling products": "En çok satan ürünler",
    "intelligence.template.revenue_trend": "Gelir eğilimi",
    "Revenue trend": "Gelir eğilimi",
    "intelligence.template.low_stock_products": "Stoku azalan ürünler",
    "Low stock products": "Stoku azalan ürünler",
    "intelligence.template.top_categories_by_sales": "Satışa göre önde gelen kategoriler",
    "Top categories by sales": "Satışa göre önde gelen kategoriler",
    "intelligence.template.order_status_breakdown": "Sipariş durumlarına göre dağılım",
    "Order status breakdown": "Sipariş durumlarına göre dağılım",
    "intelligence.template.sales_by_day": "Güne göre satışlar",
    "Sales by day": "Güne göre satışlar",
    "intelligence.template.sales_by_country": "Ülkeye göre satışlar",
    "intelligence.template.sales_by_state": "Bölgeye göre satışlar",
    "intelligence.template.sales_by_city": "Şehre göre satışlar",
    "intelligence.template.sales_by_category": "Kategoriye göre satışlar",
    "intelligence.template.sales_by_subcategory": "Alt kategoriye göre satışlar",
    "Sales by subcategory": "Alt kategoriye göre satışlar",
    "intelligence.prompt.top_selling_products.relative": "Son {days} gündeki en çok satan ürünleri göster",
    "Show me top selling products for the last {days} days": "Son {days} gündeki en çok satan ürünleri göster",
    "intelligence.prompt.top_selling_products.absolute": "{from} ile {to} arasındaki en çok satan ürünleri göster",
    "Show me top selling products from {from} to {to}": "{from} ile {to} arasındaki en çok satan ürünleri göster",
    "intelligence.prompt.revenue_trend.relative": "Son {days} gündeki gelir eğilimini göster",
    "What is my revenue trend for the last {days} days?": "Son {days} gündeki gelir eğilimini göster",
    "intelligence.prompt.revenue_trend.absolute": "{from} ile {to} arasındaki gelir eğilimini göster",
    "What is my revenue trend from {from} to {to}?": "{from} ile {to} arasındaki gelir eğilimini göster",
    "intelligence.prompt.low_stock_products": "Stoku azalan ürünleri göster",
    "Show me low stock products": "Stoku azalan ürünleri göster",
    "intelligence.prompt.top_categories_by_sales.relative": "Son {days} günde satışa göre önde gelen kategorileri göster",
    "Show me top categories by sales for the last {days} days": "Son {days} günde satışa göre önde gelen kategorileri göster",
    "intelligence.prompt.top_categories_by_sales.absolute": "{from} ile {to} arasında satışa göre önde gelen kategorileri göster",
    "Show me top categories by sales from {from} to {to}": "{from} ile {to} arasında satışa göre önde gelen kategorileri göster",
    "intelligence.prompt.order_status_breakdown.relative": "Son {days} gündeki sipariş durumlarının dağılımını göster",
    "Show me order status breakdown for the last {days} days": "Son {days} gündeki sipariş durumlarının dağılımını göster",
    "intelligence.prompt.order_status_breakdown.absolute": "{from} ile {to} arasındaki sipariş durumlarının dağılımını göster",
    "Show me order status breakdown from {from} to {to}": "{from} ile {to} arasındaki sipariş durumlarının dağılımını göster",
    "intelligence.prompt.sales_by_day.relative": "Son {days} gündeki günlük satışları göster",
    "Show me sales by day for the last {days} days": "Son {days} gündeki günlük satışları göster",
    "intelligence.prompt.sales_by_day.absolute": "{from} ile {to} arasındaki günlük satışları göster",
    "Show me sales by day from {from} to {to}": "{from} ile {to} arasındaki günlük satışları göster",
    "intelligence.prompt.sales_by_country.relative": "dalam {days} hari terakhir ülkeye göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by country for the last {days} days": "dalam {days} hari terakhir ülkeye göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_country.absolute": "{from} ile {to} arasında ülkeye göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by country from {from} to {to}": "{from} ile {to} arasında ülkeye göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_state.relative": "dalam {days} hari terakhir bölgeye veya ile göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by state or province for the last {days} days": "dalam {days} hari terakhir bölgeye veya ile göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_state.absolute": "{from} ile {to} arasında bölgeye veya ile göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by state or province from {from} to {to}": "{from} ile {to} arasında bölgeye veya ile göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_city.relative": "dalam {days} hari terakhir şehre göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by city for the last {days} days": "dalam {days} hari terakhir şehre göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_city.absolute": "{from} ile {to} arasında şehre göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by city from {from} to {to}": "{from} ile {to} arasında şehre göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_category.relative": "dalam {days} hari terakhir üst düzey ilan kategorisine göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by top-level listing category for the last {days} days": "dalam {days} hari terakhir üst düzey ilan kategorisine göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_category.absolute": "{from} ile {to} arasında üst düzey ilan kategorisine göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by top-level listing category from {from} to {to}": "{from} ile {to} arasında üst düzey ilan kategorisine göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_subcategory.relative": "dalam {days} hari terakhir ilan alt kategorisine göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by listing sub-category for the last {days} days": "dalam {days} hari terakhir ilan alt kategorisine göre toplam geliri ve sipariş sayısını göster",
    "intelligence.prompt.sales_by_subcategory.absolute": "{from} ile {to} arasında ilan alt kategorisine göre toplam geliri ve sipariş sayısını göster",
    "Show me total sales revenue and order count grouped by listing sub-category from {from} to {to}": "{from} ile {to} arasında ilan alt kategorisine göre toplam geliri ve sipariş sayısını göster",
    "common.status.partial": "Kısmi",
    "Partial": "Kısmi",
    "common.status.dispatched": "Sevk edildi",
    "Dispatched": "Sevk edildi",
    "common.status.sale": "Satış",
    "Sale": "Satış",
    "common.status.transfer_in": "Transfer girişi",
    "Transfer in": "Transfer girişi",
    "common.status.transfer_out": "Transfer çıkışı",
    "Transfer out": "Transfer çıkışı",
    "common.status.return": "İade",
    "Return": "İade",
    "common.status.adjustment": "Düzeltme",
    "Adjustment": "Düzeltme",
    "common.status.receipt": "Mal kabulü",
    "inventory.overview.title": "Envanter",
    "inventory.overview.tab.all": "Tüm stoklar",
    "All stock": "Tüm stoklar",
    "inventory.overview.tab.low": "Stoku az",
    "inventory.overview.tab.expiring": "Süresi yaklaşan partiler",
    "Expiring batches": "Süresi yaklaşan partiler",
    "inventory.overview.manage_locations": "Konumları yönet",
    "Manage locations": "Konumları yönet",
    "inventory.overview.purchase_orders": "Satın alma siparişleri",
    "inventory.overview.operations": "İşlemler",
    "Operations": "İşlemler",
    "inventory.overview.adjust_stock": "Stoku düzelt",
    "inventory.overview.description": "Tüm konumlardaki stokların güncel görünümü.",
    "A live view of stock across your locations.": "Tüm konumlardaki stokların güncel görünümü.",
    "inventory.overview.adjustment_hint": "Sayım, hasar, iade veya diğer düzeltmeler için stok düzeltmelerini kullanın.",
    "Use adjustments for counts, damage, returns, or other corrections.": "Sayım, hasar, iade veya diğer düzeltmeler için stok düzeltmelerini kullanın.",
    "inventory.overview.units_on_hand": "Eldeki birim",
    "Units on hand": "Eldeki birim",
    "inventory.overview.one_stock_row": "1 stok satırı",
    "1 stock row": "1 stok satırı",
    "inventory.overview.stock_rows": "{count} stok satırı",
    "{count} stock rows": "{count} stok satırı",
    "inventory.overview.low_stock": "Stok az",
    "inventory.overview.reorder_point_hint": "Yeniden sipariş noktasında veya altında",
    "At or below reorder point": "Yeniden sipariş noktasında veya altında",
    "inventory.overview.expiring_soon": "Son kullanma tarihi yaklaşıyor",
    "Expiring soon": "Son kullanma tarihi yaklaşıyor",
    "inventory.overview.next_90_days": "Önümüzdeki 90 gün içinde",
    "Within the next 90 days": "Önümüzdeki 90 gün içinde",
    "inventory.overview.stock_value": "Stok değeri",
    "Stock value": "Stok değeri",
    "inventory.overview.one_active_location": "1 etkin konum",
    "1 active location": "1 etkin konum",
    "inventory.overview.active_locations": "{count} etkin konum",
    "{count} active locations": "{count} etkin konum",
    "inventory.overview.search": "Envanterde ara",
    "Search inventory": "Envanterde ara",
    "inventory.overview.search_placeholder": "Ürün, SKU veya konum ara",
    "Search product, SKU, or location": "Ürün, SKU veya konum ara",
    "inventory.overview.filter_location": "Konuma göre filtrele",
    "Filter by location": "Konuma göre filtrele",
    "inventory.overview.all_locations": "Tüm konumlar",
    "inventory.overview.empty.all": "Henüz envanter stoğu kaydedilmedi.",
    "No inventory stock has been recorded yet.": "Henüz envanter stoğu kaydedilmedi.",
    "inventory.overview.empty.low": "Harika — stok yeniden sipariş noktasının altına düşmedi.",
    "Great — no stock is below its reorder point.": "Harika — stok yeniden sipariş noktasının altına düşmedi.",
    "inventory.overview.empty.expiring": "Önümüzdeki 90 gün içinde süresi dolacak parti yok.",
    "No batches are expiring within 90 days.": "Önümüzdeki 90 gün içinde süresi dolacak parti yok.",
    "inventory.overview.adjust": "Düzelt",
    "Adjust": "Düzelt",
    "inventory.overview.adjust_title": "Stok düzeltmesi",
    "inventory.overview.adjust_description": "Stok geçmişinin güvenilir kalması için nedeni belirterek düzeltme kaydedin.",
    "Record a correction with a reason so the inventory history stays trustworthy.": "Stok geçmişinin güvenilir kalması için nedeni belirterek düzeltme kaydedin.",
    "inventory.overview.save_adjustment": "Düzeltmeyi kaydet",
    "Save adjustment": "Düzeltmeyi kaydet",
    "inventory.overview.listing_id": "Kimlik {id}",
    "inventory.overview.unassigned": "Atanmamış",
    "Unassigned": "Atanmamış",
    "inventory.overview.quantity_change": "Miktar değişikliği",
    "Quantity change": "Miktar değişikliği",
    "inventory.overview.quantity_placeholder": "ör. 5 veya -2",
    "e.g. 5 or -2": "ör. 5 veya -2",
    "inventory.overview.reason": "Neden",
    "inventory.overview.reason_placeholder": "Sayım, hasar, iade…",
    "Cycle count, damage, return…": "Sayım, hasar, iade…",
    "inventory.overview.reason.cycle_count": "Döngüsel sayım",
    "Cycle count": "Döngüsel sayım",
    "inventory.overview.reason.damage": "Hasar",
    "Damage": "Hasar",
    "inventory.overview.reason.return": "İade",
    "inventory.overview.reason.stocktake": "Stok sayımı",
    "Stocktake": "Stok sayımı",
    "inventory.overview.note_placeholder": "Sonraki kişi için isteğe bağlı bağlam",
    "Optional context for the next person": "Sonraki kişi için isteğe bağlı bağlam",
    "inventory.overview.adjustment_saved": "Stok düzeltmesi kaydedildi",
    "Inventory adjustment saved": "Stok düzeltmesi kaydedildi",
    "inventory.overview.on_hand": "Eldeki",
    "On hand": "Eldeki",
    "inventory.overview.reorder_at": "Yeniden sipariş seviyesi",
    "Reorder at": "Yeniden sipariş seviyesi",
    "orders.create_order.payment_reference_missing": "Sipariş oluşturuldu ancak sipariş referansı alınamadı.",
    "The order was created, but no order reference was returned.": "Sipariş oluşturuldu ancak sipariş referansı alınamadı.",
    "orders.create_order.payment_domain_missing": "Kiracı alan adı ödeme bağlantıları için kullanılamıyor.",
    "The tenant domain is not available for payment links.": "Kiracı alan adı ödeme bağlantıları için kullanılamıyor.",
    "orders.create_order.payment_link_failed": "Ödeme bağlantısı oluşturulamadı.",
    "Unable to create payment link.": "Ödeme bağlantısı oluşturulamadı.",
    "orders.create_order.admin_session_expired": "Yönetici oturumunuzun süresi doldu. Sipariş oluşturmadan önce yeniden giriş yapın.",
    "Your admin session has expired. Please sign in again before creating an order.": "Yönetici oturumunuzun süresi doldu. Sipariş oluşturmadan önce yeniden giriş yapın.",
    "orders.create_order.user": "Kullanıcı",
    "orders.create_order.add_new_user": "Yeni kullanıcı ekle",
    "Add New User": "Yeni kullanıcı ekle",
    "orders.create_order.choose_existing_user": "Mevcut kullanıcıyı seç",
    "Choose Existing User": "Mevcut kullanıcıyı seç",
    "orders.create_order.preparing_customer": "Müşteri hazırlanıyor…",
    "Preparing customer…": "Müşteri hazırlanıyor…",
    "orders.create_order.select_user": "Kullanıcı seçin",
    "Select user": "Kullanıcı seçin",
    "orders.create_order.search_listing": "İlan ara",
    "Search Listing": "İlan ara",
    "orders.create_order.listings": "İlanlar",
    "orders.create_order.no_image": "Görsel yok",
    "No image": "Görsel yok",
    "orders.create_order.add_to_cart": "Sepete ekle",
    "Add to Cart": "Sepete ekle",
    "orders.create_order.select_rental_dates": "Önce kiralama başlangıç ve bitiş tarihlerini seçin.",
    "Select rental start and end dates first.": "Önce kiralama başlangıç ve bitiş tarihlerini seçin.",
    "orders.create_order.rental_end_after_start": "Kiralama bitiş tarihi başlangıç tarihinden sonra olmalıdır.",
    "Rental end must be after the start date.": "Kiralama bitiş tarihi başlangıç tarihinden sonra olmalıdır.",
    "orders.create_order.cart_type_conflict": "Bu müşterinin sepetinde farklı türde ilanlar var. Bunu eklemeden önce ödeme adımında diğerlerini kaldırın.",
    "This customer already has items with a different listing type. Remove those items in Checkout before adding this one.": "Bu müşterinin sepetinde farklı türde ilanlar var. Bunu eklemeden önce ödeme adımında diğerlerini kaldırın.",
    "orders.create_order.rental_period": "Kiralama süresi",
    "Rental period": "Kiralama süresi",
    "orders.create_order.select_start_end": "Başlangıç ve bitişi seçin",
    "Select start and end": "Başlangıç ve bitişi seçin",
    "orders.create_order.membership_no_shipping": "Üyelik siparişleri için kargo veya teslimat gerekmez.",
    "Membership orders do not require shipping or delivery.": "Üyelik siparişleri için kargo veya teslimat gerekmez.",
    "orders.create_order.preparing_payment_link": "Ödeme bağlantısı hazırlanıyor…",
    "Preparing payment link…": "Ödeme bağlantısı hazırlanıyor…",
    "orders.create_order.payment_link_ready": "Ödeme bağlantısı hazır",
    "Payment link ready": "Ödeme bağlantısı hazır",
    "orders.create_order.copy_payment_link": "Ödeme bağlantısını kopyala",
    "Copy payment link": "Ödeme bağlantısını kopyala",
    "orders.create_order.payment_method": "Ödeme yöntemi",
    "orders.create_order.no_payment_methods": "Bu proje için etkin ödeme yöntemi yapılandırılmamış.",
    "No active payment methods are configured for this project.": "Bu proje için etkin ödeme yöntemi yapılandırılmamış.",
    "orders.create_order.shipping_method": "Kargo yöntemi",
    "orders.create_order.no_shipping_methods": "Bu proje için etkin kargo yöntemi yapılandırılmamış.",
    "No active shipping methods are configured for this project.": "Bu proje için etkin kargo yöntemi yapılandırılmamış.",
    "orders.create_order.shipping_address": "Teslimat adresi",
    "Shipping address": "Teslimat adresi",
    "orders.create_order.loading_addresses": "Kayıtlı adresler yükleniyor…",
    "Loading saved addresses…": "Kayıtlı adresler yükleniyor…",
    "orders.create_order.no_saved_shipping_address": "Kullanıcının kayıtlı teslimat adresi yok. Teslimat siparişi oluşturmadan önce kullanıcıya adres ekleyin.",
    "This user has no saved shipping address. Add one to the user before creating a delivery order.": "Kullanıcının kayıtlı teslimat adresi yok. Teslimat siparişi oluşturmadan önce kullanıcıya adres ekleyin.",
    "orders.create_order.no_items": "Ürün yok",
    "No items": "Ürün yok",
    "orders.create_order.cart_empty": "Sepetiniz boş",
    "Your cart is empty": "Sepetiniz boş",
    "orders.create_order.create_order": "Sipariş oluştur",
    "Create Order": "Sipariş oluştur",
    "orders.create_order.create_payment_link": "Ödeme bağlantısı oluştur",
    "Create payment link": "Ödeme bağlantısı oluştur",
    "orders.create_order.order_summary": "Sipariş özeti",
    "orders.create_order.coupon_value": "Kupon tutarı",
    "Coupon value": "Kupon tutarı",
    "orders.create_order.remove_coupon": "Kuponu kaldır",
    "Remove Coupon": "Kuponu kaldır",
    "orders.create_order.apply_coupon": "Kuponu uygula",
    "Apply Coupon": "Kuponu uygula",
    "orders.create_order.grand_amount": "Genel toplam",
    "Grand Amount": "Genel toplam",
    "orders.create_order.total": "Toplam",
    "orders.create_order.shipping": "Kargo",
    "Shipping": "Kargo",
    "orders.create_order.subtotal": "Ara toplam",
    "Subtotal": "Ara toplam",
    "orders.create_order.stock_unavailable": "Stokta yok",
    "Stock is not available": "Stokta yok",
    "orders.create_order.max_quantity": "En fazla miktar {quantity}",
    "Max quantity is {quantity}": "En fazla miktar {quantity}",
    "orders.create_order.items_in_cart": "Sepetteki ürünler",
    "Items in the cart": "Sepetteki ürünler",
    "orders.create_order.products_in_stock": "Stokta {count} ürün",
    "{count} Products in Stock": "Stokta {count} ürün",
    "orders.create_order.order_items": "Sipariş ürünleri",
    "orders.create_order.sold_by": "Satıcı: {name}",
    "by {name}": "Satıcı: {name}",
    "common.first_name": "Ad",
    "common.last_name": "Soyad",
    "common.unlimited": "sınırsız",
    "unlimited": "sınırsız",
    "orders.reference": "Referans",
    "orders.amount": "Tutar",
    "orders.currency": "Para birimi",
    "orders.transaction_date": "İşlem tarihi",
    "Transaction Date": "İşlem tarihi",
    "orders.volume_this_page": "Hacim (bu sayfa)",
    "Volume (this page)": "Hacim (bu sayfa)",
    "orders.seller_entries": "Satıcı kayıtları",
    "Seller Entries": "Satıcı kayıtları",
    "orders.customer_entries": "Müşteri kayıtları",
    "Customer Entries": "Müşteri kayıtları",
    "orders.filter_transactions": "İşlemleri filtrele",
    "Filter Transactions": "İşlemleri filtrele",
    "orders.reset_filters": "Filtreleri sıfırla",
    "Reset filters": "Filtreleri sıfırla",
    "orders.manage_transactions": "İşlemleri yönetin",
    "Manage your Transactions": "İşlemleri yönetin",
    "orders.empty_transactions_message": "Kullanıcılar arasındaki komisyon, sipariş tutarı, ödeme ücreti ve özel ücret gibi işlemleri burada takip edebilirsiniz.",
    "Here you can track all the transactions between users.\nTransactions such as commissions, Order price, payment charges, special fees, etc.": "Kullanıcılar arasındaki komisyon, sipariş tutarı, ödeme ücreti ve özel ücret gibi işlemleri burada takip edebilirsiniz.",
    "orders.super_type": "Üst tür",
    "Super Type": "Üst tür",
    "orders.exporting": "Dışa aktarılıyor…",
    "Exporting…": "Dışa aktarılıyor…",
    "orders.export_as_csv": "CSV olarak dışa aktar",
    "Export as CSV": "CSV olarak dışa aktar",
    "orders.search_transactions": "İşlemleri ara",
    "Search transactions": "İşlemleri ara",
    "orders.filter": "Filtre",
    "Filter": "Filtre",
    "orders.transaction_status": "İşlem durumu",
    "Transaction Status": "İşlem durumu",
    "orders.seller_protection_fee": "Satıcı Koruma Ücreti",
    "Seller Protection Fee": "Satıcı Koruma Ücreti",
    "common.show_rows": "Satırları göster",
    "common.clear_all": "Tümünü temizle",
    "Clear All": "Tümünü temizle",
    "orders.order_number_value": "Sipariş #{number}",
    "orders.transactions": "İşlemler",
    "reported_listings.report_detail": "Rapor ayrıntısı",
    "Report Detail": "Rapor ayrıntısı",
    "reported_listings.reported_listing": "Bildirilen ilan",
    "Reported Listing": "Bildirilen ilan",
    "reported_listings.pending": "Bekliyor",
    "reported_listings.approved": "Onaylandı",
    "reported_listings.rejected": "Reddedildi",
    "reported_listings.view_marketplace": "Pazaryerinde görüntüle",
    "View on marketplace": "Pazaryerinde görüntüle",
    "reported_listings.approve_listing": "İlanı onayla",
    "Approve listing": "İlanı onayla",
    "reported_listings.reject_listing": "İlanı reddet",
    "Reject listing": "İlanı reddet",
    "reported_listings.reported_by": "Bildirimi yapan",
    "Reported By": "Bildirimi yapan",
    "reported_listings.blocked": "Engellendi",
    "reported_listings.unblock_user": "Kullanıcının engelini kaldır",
    "Unblock user": "Kullanıcının engelini kaldır",
    "reported_listings.block_user": "Kullanıcıyı engelle",
    "Block user": "Kullanıcıyı engelle",
    "reported_listings.report_info": "Rapor bilgisi",
    "Report Info": "Rapor bilgisi",
    "reported_listings.reason": "Neden",
    "reported_listings.reported_on": "Bildirim tarihi",
    "Reported on": "Bildirim tarihi",
    "reported_listings.listing_id": "İlan kimliği",
    "reported_listings.reporter": "Bildiren",
    "Reporter": "Bildiren",
    "reported_listings.listing": "İlan",
    "Listing": "İlan",
    "reported_listings.status": "Durum",
    "reported_listings.title": "Bildirilen ilanlar",
    "reported_listings.report_count": "Bildirimler: {count}",
    "Reports: {count}": "Bildirimler: {count}",
    "reported_listings.empty_title": "Bildirilen ilanları görüntüleme",
    "Viewing Reported listings": "Bildirilen ilanları görüntüleme",
    "reported_listings.empty_message": "Kullanıcıların bildirdiği ilanları burada bulabilirsiniz.",
    "You will find your users reported listings here": "Kullanıcıların bildirdiği ilanları burada bulabilirsiniz.",
    "common.page_of": "{total} sayfadan {page}. sayfa",
    "Page {page} of {total}": "{total} sayfadan {page}. sayfa",
    "common.view": "Görüntüle",
    "reviews.empty_title": "Puanları ve yorumları görüntüleme",
    "Viewing Rate & Reviews": "Puanları ve yorumları görüntüleme",
    "reviews.empty_message": "Kullanıcı puanlarını ve yorumlarını burada bulabilirsiniz.",
    "You will find your users ratings and reviews here": "Kullanıcı puanlarını ve yorumlarını burada bulabilirsiniz.",
    "reviews.list": "Liste",
    "reviews.grid": "Izgara",
    "Grid": "Izgara",
    "reviews.title": "Yorumlar ve puanlar",
    "reviews.review": "Yorum",
    "reviews.name": "Ad",
    "reviews.rating": "Puan",
    "reviews.title_column": "Başlık",
    "reviews.content": "İçerik",
    "Content": "İçerik",
    "reviews.image": "Görsel",
    "Image": "Görsel",
    "reviews.images": "Görseller",
    "Images": "Görseller",
    "reviews.accounts": "Hesaplar",
    "reviews.listings": "İlanlar",
    "reviews.star": "Yıldız",
    "Star": "Yıldız",
    "reviews.review_image": "Yorum görseli",
    "Review image": "Yorum görseli",
    "reviews.title_required": "Başlık gereklidir",
    "Title is required": "Başlık gereklidir",
    "reviews.content_required": "İçerik gereklidir",
    "Content is required": "İçerik gereklidir",
    "reviews.updated_successfully": "Yorum başarıyla güncellendi",
    "Review updated successfully": "Yorum başarıyla güncellendi",
    "reviews.edit_review": "Yorumu düzenle",
    "Edit Review": "Yorumu düzenle",
    "common.not_available": "Yok",
    "common.something_went_wrong": "Bir şeyler ters gitti",
    "Something went wrong": "Bir şeyler ters gitti",
    "media.load_failed": "Medya yüklenemedi.",
    "Unable to load media.": "Medya yüklenemedi.",
    "media.load_failed_retry": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "Unable to load media. Please try again.": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "media.update_failed": "Medya güncellenemedi",
    "Media update failed": "Medya güncellenemedi",
    "media.renamed": "Medya yeniden adlandırıldı",
    "Media renamed": "Medya yeniden adlandırıldı",
    "media.moved": "Medya taşındı",
    "Media moved": "Medya taşındı",
    "media.rename_failed": "Medya yeniden adlandırılamadı",
    "Unable to rename media": "Medya yeniden adlandırılamadı",
    "media.move_failed": "Medya taşınamadı",
    "Unable to move media": "Medya taşınamadı",
    "media.deleted": "Medya silindi",
    "Media deleted": "Medya silindi",
    "media.delete_failed": "Medya silinemedi",
    "Unable to delete media": "Medya silinemedi",
    "media.confirm_delete": "Bu medya silinsin mi?",
    "Are you sure you want to delete this media?": "Bu medya silinsin mi?",
    "media.delete_media": "Medyayı sil",
    "Delete media": "Medyayı sil",
    "media.folder_creation_web_only": "Klasör oluşturma web sürümünde kullanılabilir",
    "Folder creation is available on web": "Klasör oluşturma web sürümünde kullanılabilir",
    "media.no_create_folder_permission": "Klasör oluşturma izniniz yok",
    "You do not have permission to create folders": "Klasör oluşturma izniniz yok",
    "media.folder_name": "Klasör adı",
    "Folder name": "Klasör adı",
    "media.folder_created": "Klasör oluşturuldu",
    "Folder created": "Klasör oluşturuldu",
    "media.folder_create_failed": "Klasör oluşturulamadı",
    "Unable to create folder": "Klasör oluşturulamadı",
    "media.link_copied": "Bağlantı kopyalandı",
    "Link copied": "Bağlantı kopyalandı",
    "media.copy_link_failed": "Bağlantı kopyalanamadı",
    "Unable to copy link": "Bağlantı kopyalanamadı",
    "media.urls_copied": "{count} URL kopyalandı",
    "{count} URLs copied": "{count} URL kopyalandı",
    "media.clipboard_unavailable": "Pano kullanılamıyor",
    "Clipboard is not available": "Pano kullanılamıyor",
    "media.copy_urls_failed": "URL’ler kopyalanamadı",
    "Unable to copy URLs": "URL’ler kopyalanamadı",
    "media.upload_failed": "Medya yüklenemedi",
    "Media upload failed": "Medya yüklenemedi",
    "media.replace_success": "Medya değiştirildi. Medya kimliği ve kalıcı bağlantı aynı kaldı.",
    "Media replaced. The media ID and stable link are unchanged.": "Medya değiştirildi. Medya kimliği ve kalıcı bağlantı aynı kaldı.",
    "media.replace_failed": "Medya değiştirilemedi",
    "Unable to replace media": "Medya değiştirilemedi",
    "media.csv_upload_failed": "CSV yüklenemedi",
    "CSV upload failed": "CSV yüklenemedi",
    "media.csv_metadata_failed": "CSV meta verileri kaydedilemedi",
    "Unable to save CSV metadata": "CSV meta verileri kaydedilemedi",
    "media.csv_saved_version": "CSV yeni sürüm olarak kaydedildi",
    "CSV saved as a new version": "CSV yeni sürüm olarak kaydedildi",
    "media.csv_save_failed": "CSV kaydedilemedi",
    "Unable to save CSV": "CSV kaydedilemedi",
    "media.uploading_files": "{count} dosya yükleniyor…",
    "Uploading {count} files…": "{count} dosya yükleniyor…",
    "media.upload_progress": "{count} dosya yükleniyor · %{progress}",
    "Uploading {count} files · {progress}%": "{count} dosya yükleniyor · %{progress}",
    "media.upload_success": "{count} dosya başarıyla yüklendi.",
    "{count} files uploaded successfully.": "{count} dosya başarıyla yüklendi.",
    "media.upload_failed_retry": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "Unable to upload media. Please try again.": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "media.register_failed": "Medya kaydedilemedi",
    "Unable to register media": "Medya kaydedilemedi",
    "media.list_view": "Liste görünümü",
    "List view": "Liste görünümü",
    "media.grid_view": "Izgara görünümü",
    "Grid view": "Izgara görünümü",
    "media.copy_uploaded_urls": "Yüklenen URL’leri kopyala",
    "Copy uploaded URLs": "Yüklenen URL’leri kopyala",
    "media.copy_visible_urls": "Görünür URL’leri kopyala",
    "Copy visible URLs": "Görünür URL’leri kopyala",
    "media.copy_all_urls": "Tüm URL’leri kopyala",
    "Copy all URLs": "Tüm URL’leri kopyala",
    "media.new_folder": "Yeni klasör",
    "New folder": "Yeni klasör",
    "media.uploading_progress": "Yükleniyor %{progress}",
    "Uploading {progress}%": "Yükleniyor %{progress}",
    "media.upload_media": "Medya yükle",
    "Upload media": "Medya yükle",
    "media.manager_title": "Medya yöneticisi",
    "Media Manager": "Medya yöneticisi",
    "media.search": "Medya ara",
    "Search media": "Medya ara",
    "media.location": "Konum",
    "media.media_root": "Medya",
    "media.show_type": "{type} medyalarını göster",
    "Show {type} media": "{type} medyalarını göster",
    "media.type_all": "tümü",
    "all": "tümü",
    "media.type_image": "görsel",
    "image": "görsel",
    "media.type_video": "video",
    "video": "video",
    "media.type_audio": "ses",
    "audio": "ses",
    "media.type_pdf": "PDF",
    "PDF": "PDF",
    "media.type_csv": "CSV",
    "CSV": "CSV",
    "media.type_folder": "klasör",
    "folder": "klasör",
    "media.sort_az": "A–Z",
    "A–Z": "A–Z",
    "media.oldest": "En eski",
    "Oldest": "En eski",
    "media.newest": "En yeni",
    "Newest": "En yeni",
    "media.sort_current": "Medyayı sırala, şu an {sort}",
    "Sort media, currently {sort}": "Medyayı sırala, şu an {sort}",
    "media.loading": "Medya yükleniyor…",
    "Loading media…": "Medya yükleniyor…",
    "media.no_filter_matches": "Filtrelerle eşleşen medya yok.",
    "No media matches these filters.": "Filtrelerle eşleşen medya yok.",
    "media.empty_title": "Medya kitaplığınız boş",
    "Your media library is empty": "Medya kitaplığınız boş",
    "media.empty_message": "Tanıtım ve makale gibi farklı alanlarda yeniden kullanmak için görsel, PDF ve video yükleyin.",
    "Upload images, PDF, videos to be re-used in different cases like promo, article, etc": "Tanıtım ve makale gibi farklı alanlarda yeniden kullanmak için görsel, PDF ve video yükleyin.",
    "media.empty_hint": "Başlamak için dosya yükleyin veya klasör oluşturun.",
    "Upload files or create a folder to get started.": "Başlamak için dosya yükleyin veya klasör oluşturun.",
    "media.folder": "Klasör",
    "Folder": "Klasör",
    "media.file_folder_name": "Dosya veya klasör adı",
    "File or folder name": "Dosya veya klasör adı",
    "media.rename_media": "Medyayı yeniden adlandır",
    "Rename media": "Medyayı yeniden adlandır",
    "media.move_media": "Medyayı taşı",
    "Move media": "Medyayı taşı",
    "media.pdf_preview": "PDF önizlemesi: {name}",
    "PDF preview: {name}": "PDF önizlemesi: {name}",
    "media.pdf_preview_web": "PDF önizlemesi web uygulamasında kullanılabilir.",
    "PDF preview is available in the web app.": "PDF önizlemesi web uygulamasında kullanılabilir.",
    "media.csv_preview_web": "CSV önizlemesi web uygulamasında kullanılabilir.",
    "CSV preview is available in the web app.": "CSV önizlemesi web uygulamasında kullanılabilir.",
    "media.media_file": "Medya dosyası",
    "Media file": "Medya dosyası",
    "media.share_link": "Bağlantıyı paylaş",
    "Share link": "Bağlantıyı paylaş",
    "media.copy_link": "Bağlantıyı kopyala",
    "Copy link": "Bağlantıyı kopyala",
    "media.replace_media": "Medyayı değiştir",
    "Replace media": "Medyayı değiştir",
    "media.folders": "Klasörler",
    "Folders": "Klasörler",
    "media.create_new_folder": "Yeni klasör oluştur",
    "Create new folder": "Yeni klasör oluştur",
    "media.go_to_all_media": "Tüm medyalara git",
    "Go to all media": "Tüm medyalara git",
    "media.all_media": "Tüm medya",
    "All media": "Tüm medya",
    "media.open_folder_name": "{name} klasörünü aç",
    "Open folder {name}": "{name} klasörünü aç",
    "media.no_subfolders": "Alt klasör yok",
    "No subfolders": "Alt klasör yok",
    "media.no_files_in_folder": "Bu klasörde dosya yok.",
    "No files in this folder.": "Bu klasörde dosya yok.",
    "media.upload_folder": "Bu klasöre medya yükle",
    "Upload media to this folder": "Bu klasöre medya yükle",
    "media.discard_csv_confirm": "CSV değişiklikleri atılsın mı?",
    "Discard your CSV changes?": "CSV değişiklikleri atılsın mı?",
    "media.unsaved_changes": "Kaydedilmemiş değişiklikler",
    "Unsaved changes": "Kaydedilmemiş değişiklikler",
    "media.find_csv": "CSV içinde bul",
    "Find in CSV": "CSV içinde bul",
    "media.save_csv": "CSV’yi kaydet",
    "Save CSV": "CSV’yi kaydet",
    "media.loading_csv": "CSV yükleniyor…",
    "Loading CSV…": "CSV yükleniyor…",
    "media.prepare_folder_failed": "Yükleme klasörü hazırlanamadı",
    "Unable to prepare the upload folder": "Yükleme klasörü hazırlanamadı",
    "media.add_file_required": "Lütfen dosya ekleyin",
    "Please add a file": "Lütfen dosya ekleyin",
    "media.add_media": "Medya ekle",
    "Add Media": "Medya ekle",
    "media.store_uploaded_media_in": "Yüklenen medyayı şuraya kaydet",
    "Store uploaded media in": "Yüklenen medyayı şuraya kaydet",
    "media.destination_business_cards": "Kartvizitler",
    "Business Cards": "Kartvizitler",
    "media.destination_listings": "İlanlar",
    "media.destination_accounts": "Hesaplar",
    "media.destination_users": "Kullanıcılar",
    "media.upload_media_title": "Medya yükle",
    "Upload Media": "Medya yükle",
    "media.media_files": "Medya",
    "media.open_folder": "Klasörü aç",
    "Open folder": "Klasörü aç",
    "common.show": "Göster",
    "common.share": "Paylaş",
    "common.copy": "Kopyala",
    "common.rename": "Yeniden adlandır",
    "Rename": "Yeniden adlandır",
    "common.move": "Taşı",
    "Move": "Taşı",
    "common.type": "Tür",
    "common.size": "Boyut",
    "Size": "Boyut",
    "common.preview": "Önizleme",
    "Preview": "Önizleme",
    "common.undo": "Geri al",
    "Undo": "Geri al",
    "common.redo": "Yinele",
    "Redo": "Yinele",
    "common.discard": "Vazgeç",
    "Discard": "Vazgeç",
    "common.try_again": "Tekrar deneyin",
    "media.type_json": "JSON",
    "JSON": "JSON",
    "media.type_spreadsheet": "E-tablo",
    "Spreadsheet": "E-tablo",
    "media.type_file": "Dosya",
    "File": "Dosya",
    "media.csv_load_failed": "CSV yüklenemedi. Lütfen tekrar deneyin.",
    "Unable to load CSV. Please try again.": "CSV yüklenemedi. Lütfen tekrar deneyin.",
    "workspace.settings_section.customisation": "Özelleştirme",
    "workspace.settings_section.integrations": "Entegrasyonlar",
    "workspace.settings_section.platform_setup": "Platform kurulumu",
    "Platform Setup": "Platform kurulumu",
    "workspace.settings_section.business_operations": "İşletme işlemleri",
    "Business Operations": "İşletme işlemleri",
    "workspace.settings_section.system_setup": "Sistem kurulumu",
    "System Setup": "Sistem kurulumu",
    "workspace.settings_item.app_customisation": "Uygulama özelleştirme",
    "App Customisation": "Uygulama özelleştirme",
    "workspace.settings_item.web_customisation": "Web özelleştirme",
    "Web Customisation": "Web özelleştirme",
    "workspace.settings_item.communications": "İletişim",
    "Communications": "İletişim",
    "workspace.settings_item.strings_customisation": "Metin özelleştirme",
    "Strings Customisation": "Metin özelleştirme",
    "workspace.settings_item.app_integrations": "Uygulama entegrasyonları",
    "workspace.settings_item.web_integrations": "Web entegrasyonları",
    "Web Integrations": "Web entegrasyonları",
    "workspace.settings_item.accounts": "Hesaplar",
    "workspace.settings_item.listings": "İlanlar",
    "workspace.settings_item.checkout_and_cart_attributes": "Ödeme ve sepet özellikleri",
    "workspace.settings_item.service_shipping": "Hizmet / kargo",
    "workspace.settings_item.payments": "Ödemeler",
    "workspace.settings_item.commissions": "Komisyonlar",
    "workspace.settings_item.taxes": "Vergiler",
    "workspace.settings_item.special_fees": "Özel ücretler",
    "workspace.settings_item.languages": "Diller",
    "workspace.settings_item.currency": "Para birimi",
    "workspace.settings_item.countries": "Ülkeler",
    "workspace.settings_item.api": "API",
    "workspace.settings_item.extensions": "Uzantılar",
    "Extensions": "Uzantılar",
    "workspace.settings_item.manage_features": "Özellikleri yönet",
    "Manage Features": "Özellikleri yönet",
    "workspace.settings_item.audit_logs": "Denetim günlükleri",
    "Audit Logs": "Denetim günlükleri",
    "workspace.settings_item.auth": "Kimlik doğrulama",
    "workspace.settings_item.maps": "Haritalar",
    "workspace.settings_hint.accounts": "Örnek: Mağaza",
    "Example: Store": "Örnek: Mağaza",
    "workspace.settings_hint.listings": "Örnek: Ürünler, Etkinlikler",
    "Example: Products, Events": "Örnek: Ürünler, Etkinlikler",
    "workspace.settings_hint.audit_logs": "Uyumluluk ve güvenlik kaydı",
    "Compliance & security trail": "Uyumluluk ve güvenlik kaydı",
    "workspace.settings_hint.auth": "Facebook, Google, Twilio",
    "Facebook, Google, Twilio": "Facebook, Google, Twilio",
    "workspace.settings_hint.maps": "Sağlayıcı kullanımı ve gizlilik ayarları",
    "Provider usage and privacy settings": "Sağlayıcı kullanımı ve gizlilik ayarları",
    "workspace.settings_access_denied": "{name} erişiminiz yok",
    "You don't have access of {name}": "{name} erişiminiz yok",
    "app_customization.title": "Uygulama özelleştirme",
    "app_customization.tab_0": "Genel",
    "General": "Genel",
    "app_customization.tab_1": "Açılış ekranı",
    "Splash": "Açılış ekranı",
    "app_customization.tab_2": "İlk kullanım",
    "Onboarding": "İlk kullanım",
    "app_customization.tab_3": "Kayıt",
    "Registration": "Kayıt",
    "app_customization.tab_4": "Ana sayfa",
    "Home": "Ana sayfa",
    "app_customization.tab_5": "Anlık bildirimler",
    "Push Notification": "Anlık bildirimler",
    "app_customization.tab_6": "Sohbet",
    "Chat": "Sohbet",
    "app_customization.tab_7": "Diğer menüsü",
    "More Menu": "Diğer menüsü",
    "app_customization.tab_8": "Zorunlu güncelleme",
    "Force Update": "Zorunlu güncelleme",
    "app_customization.tab_9": "Adres",
    "app_customization.hide_balances": "Diğer bölümündeki bakiyeleri ve ödemeleri gizle",
    "app_customization.more": "Daha fazla",
    "app_customization.force_update": "Güncellemeye zorla",
    "Force To Update": "Güncellemeye zorla",
    "app_customization.android_version": "Android uygulama sürümü",
    "Android app version": "Android uygulama sürümü",
    "app_customization.enter_android_version": "Android uygulama sürümünü girin",
    "Enter android app version": "Android uygulama sürümünü girin",
    "app_customization.ios_version": "iOS uygulama sürümü",
    "iOS app version": "iOS uygulama sürümü",
    "app_customization.enter_ios_version": "iOS uygulama sürümünü girin",
    "Enter iOS app version": "iOS uygulama sürümünü girin",
    "app_customization.chat": "Sohbet",
    "app_customization.chat_send_listing": "Sohbet açıldığında ilanı otomatik gönder (varsayılan olarak üstte önizleme gösterilir)",
    "Enable automatic send of listings when chat clicked ( Default shows preview on top)": "Sohbet açıldığında ilanı otomatik gönder (varsayılan olarak üstte önizleme gösterilir)",
    "app_customization.make_offer": "Teklif ver / pazarlık yap",
    "Make Offer / Negotiation": "Teklif ver / pazarlık yap",
    "app_customization.negotiation_button_name": "Pazarlık düğmesi adı:",
    "Negotiation button name:": "Pazarlık düğmesi adı:",
    "app_customization.negotiation_button_example": "(örnek: Teklif Ver, Pazarlık Yap, Fiyat Al)",
    "(example: Make Offer, Negotiate, Quote)": "(örnek: Teklif Ver, Pazarlık Yap, Fiyat Al)",
    "app_customization.enter_negotiation_button_name": "Pazarlık düğmesi adını girin",
    "Enter negotiation button name": "Pazarlık düğmesi adını girin",
    "app_customization.address": "Adres",
    "app_customization.address_option_0": "Adres 2’yi göster",
    "Show Address 2": "Adres 2’yi göster",
    "app_customization.address_option_1": "Ülkeyi göster",
    "Show Country": "Ülkeyi göster",
    "app_customization.address_option_2": "Posta kodunu göster",
    "Show Zipcode": "Posta kodunu göster",
    "app_customization.address_option_3": "Eyaleti göster",
    "Show State": "Eyaleti göster",
    "app_customization.address_option_4": "Tarifi göster",
    "Show Landmark": "Tarifi göster",
    "app_customization.address_option_5": "Şehri göster",
    "Show City": "Şehri göster",
    "app_customization.persistent_notification": "Kalıcı bildirimler",
    "Persistent Notification": "Kalıcı bildirimler",
    "app_customization.account_follow_content": "Hesap takip bildirimi metni",
    "Account follow notification content": "Hesap takip bildirimi metni",
    "app_customization.enter_account_follow_content": "Hesap takip bildirimi metnini girin",
    "Enter Account follow notification content": "Hesap takip bildirimi metnini girin",
    "app_customization.listing_like_content": "İlan beğenisi bildirimi metni",
    "Listing like notification content": "İlan beğenisi bildirimi metni",
    "app_customization.enter_listing_like_content": "İlan beğenisi bildirimi metnini girin",
    "Enter Listing like  notification content": "İlan beğenisi bildirimi metnini girin",
    "app_customization.order_status_content": "Sipariş durumu bildirimi metni",
    "Order status notification content": "Sipariş durumu bildirimi metni",
    "app_customization.enter_order_status_content": "Sipariş durumu bildirimi metnini girin",
    "Order status follow notification content": "Sipariş durumu bildirimi metnini girin",
    "app_customization.account_follow_required": "Hesap takip bildirimi {account_name} içermelidir",
    "Account follow notification should contain {account_name}": "Hesap takip bildirimi {account_name} içermelidir",
    "app_customization.listing_like_required": "İlan beğenisi bildirimi {user_name} içermelidir",
    "Listing like notification content should contain {user_name}": "İlan beğenisi bildirimi {user_name} içermelidir",
    "app_customization.order_number_required": "Sipariş durumu bildirimi #{order_number} içermelidir",
    "Order status notification content should contain #{order_number}": "Sipariş durumu bildirimi #{order_number} içermelidir",
    "app_customization.order_status_required": "Sipariş durumu bildirimi {order_status} içermelidir",
    "Order status notification content should contain {order_status}": "Sipariş durumu bildirimi {order_status} içermelidir",
    "app_customization.preview": "Önizleme",
    "app_customization.splash": "Açılış ekranı",
    "app_customization.splash_image": "Açılış ekranı görseli",
    "Splash Screen Image": "Açılış ekranı görseli",
    "app_customization.registration": "Kayıt",
    "app_customization.registration_text": "Kayıt metni",
    "Registration text": "Kayıt metni",
    "app_customization.otp_note": "OTP doğrulama notu",
    "OTP Verification note": "OTP doğrulama notu",
    "app_customization.get_signup_first": "Önce kaydı açın",
    "app_customization.mobile_in_email_signup": "E-posta kaydında cep telefonu",
    "Mobile number in email signup": "E-posta kaydında cep telefonu",
    "app_customization.preview_field_first_name": "Ad",
    "app_customization.preview_field_last_name": "Soyad",
    "app_customization.preview_field_email": "E-posta",
    "app_customization.preview_field_password": "Parola",
    "Password": "Parola",
    "app_customization.preview_field_confirm_password": "Parolayı onayla",
    "Confirm Password": "Parolayı onayla",
    "app_customization.preview_field_dob": "Doğum tarihi",
    "DOB": "Doğum tarihi",
    "app_customization.preview_field_mobile_no": "Cep telefonu",
    "Mobile No": "Cep telefonu",
    "app_customization.create": "Oluştur",
    "app_customization.login": "Giriş yap",
    "Login": "Giriş yap",
    "app_customization.create_account": "Hesabınızı oluşturun",
    "Create your account": "Hesabınızı oluşturun",
    "app_customization.login_account": "Hesabınıza giriş yapın",
    "Login to your account": "Hesabınıza giriş yapın",
    "app_customization.onboarding_settings": "İlk kullanım ayarları",
    "Onboarding Settings": "İlk kullanım ayarları",
    "app_customization.onboarding_images": "İlk kullanım görselleri",
    "Onboarding Images": "İlk kullanım görselleri",
    "app_customization.onboarding_text_1": "İlk kullanım metni 1",
    "Onboarding text 1": "İlk kullanım metni 1",
    "app_customization.onboarding_text_2": "İlk kullanım metni 2",
    "Onboarding text 2": "İlk kullanım metni 2",
    "app_customization.onboarding_text_3": "İlk kullanım metni 3",
    "Onboarding text 3": "İlk kullanım metni 3",
    "app_customization.see_how_it_works": "Nasıl çalıştığını görün",
    "See how it works": "Nasıl çalıştığını görün",
    "app_customization.sell_icon_text": "Sat simgesi metni",
    "Sell icon text": "Sat simgesi metni",
    "app_customization.enter_sell_icon_text": "Sat simgesi metnini girin",
    "Enter sell icon text": "Sat simgesi metnini girin",
    "app_customization.sell_icon": "Sat simgesi",
    "Sell Icon": "Sat simgesi",
    "app_customization.enter_home_title": "Ana ekranda uygulama başlığını girin",
    "Enter app title in home": "Ana ekranda uygulama başlığını girin",
    "app_customization.app_details": "Uygulama ayrıntıları",
    "App Details": "Uygulama ayrıntıları",
    "app_customization.app_name": "Uygulama adı",
    "App Name": "Uygulama adı",
    "app_customization.primary_colour": "Uygulama ana rengi",
    "App Primary Colour": "Uygulama ana rengi",
    "app_customization.secondary_colour": "Uygulama ikincil rengi",
    "App Secondary Colour": "Uygulama ikincil rengi",
    "app_customization.android_app_icon": "Android uygulama simgesi",
    "App Icon Android": "Android uygulama simgesi",
    "app_customization.ios_app_icon": "iOS uygulama simgesi",
    "App Icon iOS": "iOS uygulama simgesi",
    "app_customization.screen_number": "Ekran {number}",
    "Screen {number}": "Ekran {number}",
    "app_customization.upload_here": "Buraya yükleyin",
    "Upload here": "Buraya yükleyin",
    "app_customization.next": "İleri",
    "app_customization.get_started": "Başlayın",
    "Get Start": "Başlayın",
    "app_customization.select": "Seç",
    "Select": "Seç",
    "app_customization.app_title_home_icon": "Ana ekran uygulama başlığı simgesi",
    "App Title Home Icon": "Ana ekran uygulama başlığı simgesi",
    "app_customization.home_icon_hint": "(simge beyaz ve PNG biçiminde olmalıdır)",
    "(icon should be white and in png format)": "(simge beyaz ve PNG biçiminde olmalıdır)",
    "app_customization.home_title": "Ana ekrandaki uygulama başlığı",
    "App title in home screen": "Ana ekrandaki uygulama başlığı",
    "app_customization.default_collection_widgets": "Varsayılan koleksiyon widget’ları",
    "Default Collection Widgets": "Varsayılan koleksiyon widget’ları",
    "app_customization.accounts_follow_title": "Takip edilecek hesap koleksiyonu başlığı",
    "Accounts to follow collection title": "Takip edilecek hesap koleksiyonu başlığı",
    "app_customization.enter_accounts_follow_title": "Takip edilecek hesap koleksiyonu başlığını girin",
    "Enter accounts to follow collection title": "Takip edilecek hesap koleksiyonu başlığını girin",
    "app_customization.nearby_accounts_title": "Yakındaki hesap koleksiyonu başlığı",
    "Nearby accounts collection title": "Yakındaki hesap koleksiyonu başlığı",
    "app_customization.enter_nearby_accounts_title": "Yakındaki hesap koleksiyonu başlığını girin",
    "Enter near by accounts collection title": "Yakındaki hesap koleksiyonu başlığını girin",
    "app_customization.latest_listings_title": "Son ilanlar koleksiyonu başlığı",
    "Latest listings collection title": "Son ilanlar koleksiyonu başlığı",
    "app_customization.enter_latest_listings_title": "Son ilanlar koleksiyonu başlığını girin",
    "Enter latest listings collection title": "Son ilanlar koleksiyonu başlığını girin",
    "app_customization.enable_appearance_sections": "Görünüm bölümlerini etkinleştirmek için seçin",
    "Select to enable appearance sections": "Görünüm bölümlerini etkinleştirmek için seçin",
    "app_customization.choose_photo": "Fotoğraf seç",
    "Choose photo": "Fotoğraf seç",
    "app_customization.choose_icon": "Simge seç",
    "Choose icon": "Simge seç",
    "app_customization.enable_home_icon": "Metin yerine uygulama başlığı simgesini kullan",
    "app_customization.account_name": "Hesap adı",
    "Account Name": "Hesap adı",
    "app_customization.product_name": "Ürün adı",
    "Product Name": "Ürün adı",
    "app_customization.home_option_0": "Yakındaki koleksiyonu göster",
    "Show nearby collection": "Yakındaki koleksiyonu göster",
    "app_customization.home_option_1": "Kategori bölümünü göster",
    "Show category section": "Kategori bölümünü göster",
    "app_customization.home_option_2": "Tanıtım bannerlarını göster",
    "Show promo banners": "Tanıtım bannerlarını göster",
    "app_customization.home_option_3": "Arkadaş davetini göster",
    "Show invite friends": "Arkadaş davetini göster",
    "app_customization.home_option_4": "Yorum hatırlatıcılarını göster",
    "Show review reminders": "Yorum hatırlatıcılarını göster",
    "app_customization.home_option_5": "Takip edilecek hesaplar",
    "Accounts to follow": "Takip edilecek hesaplar",
    "app_customization.download": "İndir",
    "app_customization.cancel": "İptal",
    "app_customization.uploaded_successfully": "Başarıyla yüklendi",
    "app_customization.image_limit": "Daha fazla görsel seçemezsiniz",
    "You cannot select more images": "Daha fazla görsel seçemezsiniz",
    "app_customization.choose_zip_file": "ZIP dosyası seç",
    "Choose zip file": "ZIP dosyası seç",
    "app_translation.title": "Metin özelleştirme",
    "app_translation.search": "Aramak için yazın…",
    "Type to search...": "Aramak için yazın…",
    "app_translation.default_language": "Varsayılan",
    "Default": "Varsayılan",
    "app_translation.default_text": "Varsayılan metin",
    "Default text": "Varsayılan metin",
    "communications.title": "İletişim",
    "communications.tab_0": "E-posta bildirimleri",
    "Email Notification": "E-posta bildirimleri",
    "communications.tab_1": "E-posta yapılandırması",
    "Email Configuration": "E-posta yapılandırması",
    "communications.tab_2": "Sipariş bildirimleri",
    "Order Notification": "Sipariş bildirimleri",
    "communications.tab_3": "Geri bildirim formu",
    "Feedback Form": "Geri bildirim formu",
    "communications.translate": "Çevir",
    "Translate": "Çevir",
    "communications.edit_email_template": "E-posta şablonunu düzenle",
    "Edit email template": "E-posta şablonunu düzenle",
    "communications.feedback_email": "E-posta",
    "communications.feedback_phone": "Telefon",
    "communications.feedback_email_or_phone": "E-posta veya telefon",
    "Email or Phone": "E-posta veya telefon",
    "communications.select_type": "Tür seçin",
    "communications.form_required_field": "Form alanı gerekli",
    "Form Required Field": "Form alanı gerekli",
    "communications.feedback_recipient_label": "Geri bildirim e-postası (birden fazla adresi virgülle ayırın)",
    "Email to receive feedback (For more than one email, enter as comma separated)": "Geri bildirim e-postası (birden fazla adresi virgülle ayırın)",
    "communications.enter_email": "E-posta girin",
    "Enter email": "E-posta girin",
    "communications.enable_feedback_form": "Geri bildirim formunu etkinleştir",
    "Enable feedback Form": "Geri bildirim formunu etkinleştir",
    "communications.feedback": "Geri bildirim",
    "Feedback": "Geri bildirim",
    "communications.realtime_config_notice": "Aşağıdaki yapılandırmalar anında uygulanır. Kaydettiğinizde değişiklikler uygulamalara ve API yanıtlarına yansır.",
    "communications.uploaded_successfully": "Başarıyla yüklendi",
    "communications.email_whitelabeling": "E-posta markalama",
    "Email Whitelabelling": "E-posta markalama",
    "communications.from_name": "Gönderen adı",
    "From name": "Gönderen adı",
    "communications.enter_from_name": "Gönderen adını girin",
    "Enter from name": "Gönderen adını girin",
    "communications.from_email_address": "Gönderen e-posta adresi",
    "From email address": "Gönderen e-posta adresi",
    "communications.from_email_domain_hint": "Gönderen adresiniz için özel alan adı seçtiniz. E-postaların teslim edilmesi için alan adınızı doğrulayın. Yardım için destek ekibimize başvurun.",
    "You have chosen a custom domain for your From email address. To ensure your emails are delivered, please verify your domain with us. Contact our support team for assistance with the verification process.": "Gönderen adresiniz için özel alan adı seçtiniz. E-postaların teslim edilmesi için alan adınızı doğrulayın. Yardım için destek ekibimize başvurun.",
    "communications.reset": "Sıfırla",
    "communications.enter_from_email": "Gönderen e-postasını girin",
    "Enter from email address": "Gönderen e-postasını girin",
    "communications.email_header_logo": "E-posta başlık logosu",
    "Email Header Logo": "E-posta başlık logosu",
    "communications.choose_logo": "50*50 dosya seç",
    "Choose file 50*50": "50*50 dosya seç",
    "communications.list_view": "Liste görünümü",
    "communications.gallery_view": "Galeri görünümü",
    "Gallery view": "Galeri görünümü",
    "communications.grid_view": "Izgara görünümü",
    "communications.search": "İletişimlerde ara",
    "Search communications": "İletişimlerde ara",
    "communications.email_settings": "E-posta ayarları",
    "Email settings": "E-posta ayarları",
    "communications.category_all": "Tümü",
    "communications.category_buyer": "Alıcı",
    "Buyer": "Alıcı",
    "communications.category_seller": "Satıcı",
    "communications.category_transactional": "İşlemsel",
    "Transactional": "İşlemsel",
    "communications.category_engagement": "Etkileşim",
    "Engagement": "Etkileşim",
    "communications.category_retention": "Elde tutma",
    "Retention": "Elde tutma",
    "communications.category_membership": "Üyelik",
    "communications.audience_buyer": "Alıcı",
    "communications.audience_seller": "Satıcı",
    "communications.system_notification": "Sistem bildirimi",
    "System notification": "Sistem bildirimi",
    "communications.template": "şablon",
    "template": "şablon",
    "communications.edit": "Düzenle",
    "communications.sent": "gönderildi",
    "sent": "gönderildi",
    "communications.open": "açıldı",
    "communications.clicks": "tıklama",
    "clicks": "tıklama",
    "communications.no_email_matches": "Filtrenizle eşleşen e-posta yok.",
    "No emails match your filter.": "Filtrenizle eşleşen e-posta yok.",
    "communications.buyer_order_confirmation": "Alıcı sipariş onay e-postası",
    "Order confirmation email for buyer": "Alıcı sipariş onay e-postası",
    "communications.seller_order_confirmation": "Satıcı sipariş onay e-postası",
    "Order confirmation email for seller": "Satıcı sipariş onay e-postası",
    "communications.email_card_0": "Hoş geldiniz e-postası",
    "Welcome Message": "Hoş geldiniz e-postası",
    "communications.email_card_1": "OTP / doğrulama",
    "OTP / Verification": "OTP / doğrulama",
    "communications.email_card_2": "Abonelik bağlantısı",
    "Subscription Link": "Abonelik bağlantısı",
    "communications.email_card_3": "Abonelik başarılı",
    "Subscription Success": "Abonelik başarılı",
    "communications.email_card_4": "Sipariş onayı — alıcı",
    "Order confirmation — buyer": "Sipariş onayı — alıcı",
    "communications.email_card_5": "Sipariş onayı — satıcı",
    "Order confirmation — seller": "Sipariş onayı — satıcı",
    "communications.email_card_6": "Sipariş gönderildi — alıcı",
    "Shipment shipped — buyer": "Sipariş gönderildi — alıcı",
    "communications.email_card_7": "Sipariş teslim edildi — alıcı",
    "Shipment delivered — buyer": "Sipariş teslim edildi — alıcı",
    "communications.email_card_8": "Sipariş iptal edildi — alıcı",
    "Order cancelled — buyer": "Sipariş iptal edildi — alıcı",
    "communications.email_card_9": "İade işlendi — alıcı",
    "Refund processed — buyer": "İade işlendi — alıcı",
    "communications.email_card_10": "Takip edilen mağazadan yeni ilan — alıcı",
    "New listing from followed store — buyer": "Takip edilen mağazadan yeni ilan — alıcı",
    "communications.email_card_11": "Ürün yeniden stokta — alıcı",
    "Back in stock — buyer": "Ürün yeniden stokta — alıcı",
    "communications.email_card_12": "İlan süresi dolmak üzere — satıcı",
    "Listing expiry warning — seller": "İlan süresi dolmak üzere — satıcı",
    "communications.email_card_13": "İlan beğeni dönüm noktası — satıcı",
    "Listing likes milestone — seller": "İlan beğeni dönüm noktası — satıcı",
    "communications.email_card_14": "Hesap doğrulandı — satıcı",
    "Account verified — seller": "Hesap doğrulandı — satıcı",
    "communications.email_card_15": "Satıcıyı geri kazanma — satıcı",
    "Seller win-back — seller": "Satıcıyı geri kazanma — satıcı",
    "communications.email_card_16": "Stok azalıyor — satıcı",
    "Low stock warning — seller": "Stok azalıyor — satıcı",
    "communications.email_card_17": "Satıcı katıldı — satıcı",
    "Seller onboarded — seller": "Satıcı katıldı — satıcı",
    "communications.email_card_18": "Yorum isteği — alıcı",
    "Review request — buyer": "Yorum isteği — alıcı",
    "communications.email_card_19": "İlk satış — satıcı",
    "First sale — seller": "İlk satış — satıcı",
    "communications.email_card_20": "Satış dönüm noktası — satıcı",
    "Sales milestone — seller": "Satış dönüm noktası — satıcı",
    "communications.email_card_21": "Alıcıyı geri kazanma — alıcı",
    "Win-back — buyer": "Alıcıyı geri kazanma — alıcı",
    "communications.email_card_22": "İlk satın alma — alıcı",
    "First purchase — buyer": "İlk satın alma — alıcı",
    "communications.email_card_23": "Müşteri sorusu — satıcı",
    "Customer question — seller": "Müşteri sorusu — satıcı",
    "communications.email_card_24": "Satıcı yanıtı — alıcı",
    "Seller answer — buyer": "Satıcı yanıtı — alıcı",
    "communications.email_card_25": "Pazarlık teklifi — satıcı",
    "Negotiation offer — seller": "Pazarlık teklifi — satıcı",
    "communications.email_card_26": "Teklif kabul edildi — alıcı",
    "Offer accepted — buyer": "Teklif kabul edildi — alıcı",
    "communications.email_card_27": "Teklif reddedildi — alıcı",
    "Offer rejected — buyer": "Teklif reddedildi — alıcı",
    "communications.email_card_28": "Yeni takipçi — satıcı",
    "New follower — seller": "Yeni takipçi — satıcı",
    "communications.email_card_29": "İlan beğenildi — satıcı",
    "Listing liked — seller": "İlan beğenildi — satıcı",
    "communications.email_card_30": "İlan onaylandı — satıcı",
    "Listing approved — seller": "İlan onaylandı — satıcı",
    "communications.email_card_31": "İlan reddedildi — satıcı",
    "Listing rejected — seller": "İlan reddedildi — satıcı",
    "communications.email_card_32": "İlk ilan — satıcı",
    "First listing — seller": "İlk ilan — satıcı",
    "communications.email_card_33": "Terk edilmiş sepet — alıcı",
    "Abandoned cart — buyer": "Terk edilmiş sepet — alıcı",
    "communications.email_card_34": "İlan yorumu — satıcı",
    "Listing review — seller": "İlan yorumu — satıcı",
    "communications.email_card_35": "Sipariş karşılama hatırlatması — satıcı",
    "Fulfillment reminder — seller": "Sipariş karşılama hatırlatması — satıcı",
    "communications.email_card_36": "Fiyat düştü — alıcı",
    "Price drop — buyer": "Fiyat düştü — alıcı",
    "communications.email_card_37": "Üyelik ödemesinin vadesi yaklaşıyor",
    "Membership payment due soon": "Üyelik ödemesinin vadesi yaklaşıyor",
    "communications.email_card_38": "Üyelik ödemesi gecikti",
    "Membership payment overdue": "Üyelik ödemesi gecikti",
    "communications.order_status_notification": "Sipariş durumu bildirimi",
    "Order Status Notification": "Sipariş durumu bildirimi",
    "communications.order_group_lifecycle": "Sipariş yaşam döngüsü",
    "Order lifecycle": "Sipariş yaşam döngüsü",
    "communications.order_group_returns": "İadeler ve teslimat sorunları",
    "Returns and delivery issues": "İadeler ve teslimat sorunları",
    "communications.order_group_cancellations": "İptal ve teslim alma",
    "Cancellations and pickup": "İptal ve teslim alma",
    "communications.notification_settings_count": "{count} bildirim ayarı",
    "{count} notification settings": "{count} bildirim ayarı",
    "communications.enter_order_field": "{field} girin",
    "Enter {field}": "{field} girin",
    "communications.order_field_0": "Sipariş durumu onaylandı",
    "Order status confirmed": "Sipariş durumu onaylandı",
    "communications.order_field_1": "Sipariş durumu işleniyor",
    "Order status in progress": "Sipariş durumu işleniyor",
    "communications.order_field_2": "Sipariş durumu gönderildi",
    "Order status shipped": "Sipariş durumu gönderildi",
    "communications.order_field_3": "Sipariş durumu: müşteriye ulaşılamıyor",
    "Order status customer unreachable": "Sipariş durumu: müşteriye ulaşılamıyor",
    "communications.order_field_4": "Sipariş durumu: dağıtımda",
    "Order status out for delivery": "Sipariş durumu: dağıtımda",
    "communications.order_field_5": "Sipariş durumu: teslim edilemedi, iade edildi",
    "Order status undelivered returned": "Sipariş durumu: teslim edilemedi, iade edildi",
    "communications.order_field_6": "Sipariş durumu: teslim edilemeyen ürünün iadesi onaylandı",
    "Order status undelivered return confirmed": "Sipariş durumu: teslim edilemeyen ürünün iadesi onaylandı",
    "communications.order_field_7": "Sipariş durumu: teslim edildi",
    "Order status delivered": "Sipariş durumu: teslim edildi",
    "communications.order_field_8": "Sipariş durumu: teslimat onaylandı",
    "Order status delivered confirmed": "Sipariş durumu: teslimat onaylandı",
    "communications.order_field_9": "Sipariş durumu: müşteri iadeyi başlattı",
    "Order status customer return initiated": "Sipariş durumu: müşteri iadeyi başlattı",
    "communications.order_field_10": "Sipariş durumu: iade alındı",
    "Order status customer return picked": "Sipariş durumu: iade alındı",
    "communications.order_field_11": "Sipariş durumu: iade onaylandı",
    "Order status customer return confirmed": "Sipariş durumu: iade onaylandı",
    "communications.order_field_12": "Sipariş durumu: iadeye itiraz edildi",
    "Order status customer return disputed": "Sipariş durumu: iadeye itiraz edildi",
    "communications.order_field_13": "Sipariş durumu: hesap tarafından iptal edildi",
    "Order status cancelled by account": "Sipariş durumu: hesap tarafından iptal edildi",
    "communications.order_field_14": "Sipariş durumu: müşteri tarafından iptal edildi",
    "Order status cancelled by customer": "Sipariş durumu: müşteri tarafından iptal edildi",
    "communications.order_field_15": "Sipariş durumu: teslim almaya hazır",
    "Order status ready for pickup": "Sipariş durumu: teslim almaya hazır",
    "communications.order_field_16": "Sipariş durumu: tamamlandı",
    "Order status completed": "Sipariş durumu: tamamlandı",
    "communications.update": "Güncelle",
    "communications.download_template": "Şablonu indir",
    "Download Template": "Şablonu indir",
    "communications.reset_to_default": "Varsayılana sıfırla",
    "Reset to default": "Varsayılana sıfırla",
    "communications.send_test_email": "Test e-postası gönder",
    "Send test email": "Test e-postası gönder",
    "communications.enter_test_emails": "E-postaları virgülle ayırarak girin",
    "Enter email(s), comma-separated": "E-postaları virgülle ayırarak girin",
    "communications.send_test": "Test gönder",
    "Send test": "Test gönder",
    "communications.subject_required": "Konu boş olamaz",
    "Subject should not be empty": "Konu boş olamaz",
    "communications.body_required": "E-posta içeriği boş olamaz",
    "Body should not be empty": "E-posta içeriği boş olamaz",
    "communications.code_merge_tag_required": "{code} birleştirme etiketi zorunludur",
    "{code} merge tag is mandatory": "{code} birleştirme etiketi zorunludur",
    "communications.edit_template_named": "{name} öğesini düzenle",
    "Edit {name}": "{name} öğesini düzenle",
    "communications.subject": "Konu",
    "Subject": "Konu",
    "communications.enter_subject": "Konu girin",
    "Enter the Subject": "Konu girin",
    "communications.available_merge_tags": "Kullanılabilir birleştirme etiketleri:",
    "Available merge tags:": "Kullanılabilir birleştirme etiketleri:",
    "communications.body": "Gövde",
    "Body": "Gövde",
    "communications.write_here": "Buraya yazın…",
    "Write here...": "Buraya yazın…",
    "communications.subject_line": "Konu satırı",
    "Subject Line": "Konu satırı",
    "communications.enter_subject_line": "E-posta konusunu girin…",
    "Enter the subject…": "E-posta konusunu girin…",
    "communications.merge_tags": "Birleştirme etiketleri",
    "Merge tags": "Birleştirme etiketleri",
    "communications.loading_templates": "Şablonlar yükleniyor…",
    "Loading templates…": "Şablonlar yükleniyor…",
    "communications.hide_templates": "Şablonları gizle",
    "Hide templates": "Şablonları gizle",
    "communications.load_template": "Şablonu yükle",
    "Load template": "Şablonu yükle",
    "communications.html_body": "HTML gövdesi",
    "HTML Body": "HTML gövdesi",
    "communications.enter_html_body": "HTML kodunu buraya yapıştırın veya yazın…",
    "Paste or type your HTML here…": "HTML kodunu buraya yapıştırın veya yazın…",
    "communications.live_preview": "Canlı önizleme",
    "Live Preview": "Canlı önizleme",
    "communications.desktop": "Masaüstü",
    "Desktop": "Masaüstü",
    "communications.mobile": "Mobil",
    "communications.email_preview": "E-posta önizlemesi",
    "Email preview": "E-posta önizlemesi",
    "communications.start_typing_preview": "Önizlemeyi görmek için yazmaya başlayın",
    "Start typing to see a preview": "Önizlemeyi görmek için yazmaya başlayın",
    "communications.translations": "çeviriler",
    "translations": "çeviriler",
    "communications.validation_account_follow_tag": "Hesap takip bildirimi {account_name} içermelidir",
    "communications.validation_listing_like_tag": "İlan beğenisi bildirimi {user_name} içermelidir",
    "Listing follow notification should contain {user_name}": "İlan beğenisi bildirimi {user_name} içermelidir",
    "communications.validation_order_number_tag": "Sipariş durumu bildirimi #{order_number} içermelidir",
    "Order status follow notification should contain #{order_number}": "Sipariş durumu bildirimi #{order_number} içermelidir",
    "communications.validation_order_status_tag": "Sipariş durumu bildirimi {order_status} içermelidir",
    "Order status follow notification should contain {order_status}": "Sipariş durumu bildirimi {order_status} içermelidir",
    "communications.journey_title": "E-posta yolculuğu haritası",
    "Email Journey Map": "E-posta yolculuğu haritası",
    "communications.journey_subtitle": "Kullanıcı yaşam döngüsünde her e-postanın gönderildiği nokta",
    "Where each email fires in the user lifecycle": "Kullanıcı yaşam döngüsünde her e-postanın gönderildiği nokta",
    "communications.journey_buyer": "Alıcı yolculuğu",
    "Buyer Journey": "Alıcı yolculuğu",
    "communications.journey_seller": "Satıcı yolculuğu",
    "Seller Journey": "Satıcı yolculuğu",
    "communications.journey_buyer_stage_0": "Kayıt",
    "Sign Up": "Kayıt",
    "communications.journey_buyer_stage_1": "Göz atma",
    "Browse": "Göz atma",
    "communications.journey_buyer_stage_2": "Sepet",
    "Cart": "Sepet",
    "communications.journey_buyer_stage_3": "Sipariş verildi",
    "Order Placed": "Sipariş verildi",
    "communications.journey_buyer_stage_4": "Gönderildi",
    "communications.journey_buyer_stage_5": "Teslim edildi",
    "communications.journey_buyer_stage_6": "Pazarlık",
    "Negotiate": "Pazarlık",
    "communications.journey_buyer_stage_7": "Etkin değil",
    "communications.journey_seller_stage_0": "Başlangıç",
    "Onboard": "Başlangıç",
    "communications.journey_seller_stage_1": "İlan oluştur",
    "communications.journey_seller_stage_2": "Yönetim",
    "communications.journey_seller_stage_3": "Yeni sipariş",
    "Order In": "Yeni sipariş",
    "communications.journey_seller_stage_4": "Sevkiyat",
    "communications.journey_seller_stage_5": "Tamamla",
    "Complete": "Tamamla",
    "communications.journey_seller_stage_6": "Etkin değil",
    "accounts.title": "Hesaplar",
    "accounts.status_pending": "Bekliyor",
    "accounts.status_approved": "Onaylandı",
    "accounts.status_rejected": "Reddedildi",
    "accounts.show_rows": "Satırları göster",
    "accounts.next": "İleri",
    "accounts.previous": "Geri",
    "accounts.view_list": "Liste",
    "accounts.view_map": "Harita",
    "Map": "Harita",
    "accounts.view_board": "Pano",
    "accounts.view_grid": "Izgara",
    "accounts.view_list_accessibility": "Liste görünümü",
    "accounts.view_map_accessibility": "Harita görünümü",
    "Map view": "Harita görünümü",
    "accounts.view_board_accessibility": "Pano görünümü",
    "Board view": "Pano görünümü",
    "accounts.view_grid_accessibility": "Izgara görünümü",
    "accounts.column_name": "Ad",
    "accounts.column_account_id": "Hesap kimliği",
    "accounts.column_description": "Açıklama",
    "accounts.column_image": "Görsel",
    "accounts.column_user_name": "Kullanıcı adı",
    "User Name": "Kullanıcı adı",
    "accounts.column_email": "E-posta",
    "accounts.column_status": "Durum",
    "accounts.column_account_status": "Hesap durumu",
    "Account Status": "Hesap durumu",
    "accounts.column_location": "Konum",
    "accounts.search": "Hesap ara",
    "Search accounts": "Hesap ara",
    "accounts.export": "Dışa aktar",
    "accounts.import": "İçe aktar",
    "accounts.export_accounts": "Hesapları dışa aktar",
    "Export accounts": "Hesapları dışa aktar",
    "accounts.import_accounts": "Hesapları içe aktar",
    "Import accounts": "Hesapları içe aktar",
    "accounts.smart_upload_accounts": "Akıllı hesap yükleme",
    "Smart Upload accounts": "Akıllı hesap yükleme",
    "accounts.export_all_question": "Tüm hesaplar dışa aktarılsın mı?",
    "Export all accounts?": "Tüm hesaplar dışa aktarılsın mı?",
    "accounts.export_all_description": "Tüm hesapları içeren bir dosya hazırlanır. Yükseltmeden önce bu iş akışını inceleyebilirsiniz.",
    "This will prepare a file containing all accounts. You can review this workflow before upgrading.": "Tüm hesapları içeren bir dosya hazırlanır. Yükseltmeden önce bu iş akışını inceleyebilirsiniz.",
    "accounts.export_all": "Tüm hesapları dışa aktar",
    "Export all accounts": "Tüm hesapları dışa aktar",
    "accounts.cancel": "İptal",
    "accounts.active": "Etkin",
    "accounts.inactive": "Etkin değil",
    "accounts.not_available": "Yok",
    "accounts.approve": "Onayla",
    "accounts.reject": "Reddet",
    "accounts.manage": "Yönet",
    "accounts.tooltip_title": "Hesaplar mağazalar gibidir.",
    "Accounts are like shops.": "Hesaplar mağazalar gibidir.",
    "accounts.tooltip_description": "Kullanıcılar platformunuzda işletme yürütmek için bir alan oluşturabilir; bu alan hesaptır. Her kullanıcının hesaba ihtiyacı olmayabilir. Ödemeleri almak için hesaplara emanet hesap bağlanabilir.",
    "Users can create a space on your platform to run a business. These are accounts. A user may not need an account, and accounts can connect escrow accounts to receive payouts.": "Kullanıcılar platformunuzda işletme yürütmek için bir alan oluşturabilir; bu alan hesaptır. Her kullanıcının hesaba ihtiyacı olmayabilir. Ödemeleri almak için hesaplara emanet hesap bağlanabilir.",
    "accounts.create_account": "Hesap oluştur",
    "Create Account": "Hesap oluştur",
    "accounts.create_new_account": "Yeni hesap oluştur",
    "Create New Account": "Yeni hesap oluştur",
    "accounts.save": "Kaydet",
    "accounts.please_wait": "Lütfen bekleyin…",
    "Please wait...": "Lütfen bekleyin…",
    "accounts.account_name": "Hesap adı",
    "accounts.slug": "Kısa ad",
    "Slug": "Kısa ad",
    "accounts.account_slug": "Hesap kısa adı",
    "Account Slug": "Hesap kısa adı",
    "accounts.account_description": "Hesap açıklaması",
    "Account Description": "Hesap açıklaması",
    "accounts.enter_name_first": "Önce bir başlık girin",
    "accounts.user": "Kullanıcı",
    "accounts.select_user": "Kullanıcı seçin",
    "accounts.category": "Kategori",
    "Category": "Kategori",
    "accounts.select_type": "Tür seçin",
    "Select Type": "Tür seçin",
    "accounts.smart_upload_title": "Akıllı hesap yükleme",
    "Smart account upload": "Akıllı hesap yükleme",
    "accounts.start_over": "Baştan başla",
    "accounts.smart_upload_description": "Hesapları yükleyin ve CSV sütunlarını hesap alanlarıyla eşleştirin.",
    "Upload accounts and match your CSV columns to account fields.": "Hesapları yükleyin ve CSV sütunlarını hesap alanlarıyla eşleştirin.",
    "accounts.smart_upload_step_0": "Yükle",
    "accounts.smart_upload_step_1": "Sütunları eşleştir",
    "accounts.smart_upload_step_2": "İncele",
    "accounts.smart_upload_step_3": "İçe aktar",
    "accounts.choose_csv": "CSV dosyası seç",
    "accounts.smart_upload_required_note": "Ad zorunludur. Adres, kısa ad, kategori, sahip ve koordinatlar isteğe bağlıdır.",
    "Name is required. Address, slug, category, owner, and coordinates are optional.": "Ad zorunludur. Adres, kısa ad, kategori, sahip ve koordinatlar isteğe bağlıdır.",
    "accounts.select_csv": "CSV dosyası seç",
    "accounts.match_columns": "Hesap sütunlarını eşleştir",
    "Match account columns": "Hesap sütunlarını eşleştir",
    "accounts.import_field_name": "Ad",
    "accounts.import_field_description": "Açıklama",
    "accounts.import_field_slug": "Kısa ad",
    "accounts.import_field_category_id": "Kategori kimliği",
    "accounts.import_field_user_id": "Sahip kullanıcı kimliği",
    "Owner User ID": "Sahip kullanıcı kimliği",
    "accounts.import_field_location": "Adres",
    "accounts.import_field_latitude": "Enlem",
    "Latitude": "Enlem",
    "accounts.import_field_longitude": "Boylam",
    "Longitude": "Boylam",
    "accounts.do_not_import": "İçe aktarma",
    "accounts.review_import": "İçe aktarmayı incele",
    "accounts.import_count": "{count} hesap içe aktarılacak.",
    "{count} accounts will be imported.": "{count} hesap içe aktarılacak.",
    "accounts.smart_upload_complete": "Akıllı yükleme tamamlandı",
    "Smart Upload complete": "Akıllı yükleme tamamlandı",
    "accounts.imported_count": "{total} hesaptan {imported} tanesi içe aktarıldı.",
    "{imported} of {total} accounts imported.": "{total} hesaptan {imported} tanesi içe aktarıldı.",
    "accounts.selected_file": "Seçildi: {filename}",
    "Selected: {filename}": "Seçildi: {filename}",
    "accounts.review": "İncele",
    "accounts.importing": "İçe aktarılıyor…",
    "accounts.uploading": "Yükleniyor…",
    "accounts.download": "İndir",
    "accounts.file_label": "Dosya:",
    "accounts.select_file": "Dosya seç",
    "accounts.upload": "Yükle",
    "accounts.download_template": "{type} şablonunu indir",
    "Download {type} template": "{type} şablonunu indir",
    "accounts.import_stage_prepare": "İçe aktarma dosyası hazırlanıyor",
    "Preparing import file": "İçe aktarma dosyası hazırlanıyor",
    "accounts.import_prepare_failed": "İçe aktarma dosyası hazırlanamadı.",
    "accounts.import_stage_upload": "İçe aktarma dosyası yükleniyor",
    "accounts.import_upload_failed": "İçe aktarma dosyası yüklenemedi.",
    "accounts.import_stage_server": "Tradly hesapları içe aktarıyor",
    "Tradly is importing accounts": "Tradly hesapları içe aktarıyor",
    "accounts.import_stage_complete": "İçe aktarma tamamlandı",
    "Import complete": "İçe aktarma tamamlandı",
    "accounts.import_stage_stopped": "İçe aktarma durduruldu",
    "accounts.confirm_approve": "Bu hesap onaylansın mı?",
    "Approve this account?": "Bu hesap onaylansın mı?",
    "accounts.confirm_reject": "Bu hesap reddedilsin mi?",
    "Reject this account?": "Bu hesap reddedilsin mi?",
    "accounts.name_required": "Ad gereklidir",
    "Name is required": "Ad gereklidir",
    "accounts.user_required": "Kullanıcı gereklidir",
    "User is required": "Kullanıcı gereklidir",
    "accounts.attribute_required": "{attribute} gereklidir",
    "{attribute} is required": "{attribute} gereklidir",
    "accounts.overview": "Hesap özeti",
    "Account Overview": "Hesap özeti",
    "accounts.section_listings": "İlanlar",
    "accounts.loading": "Yükleniyor…",
    "accounts.no_listings_owned": "Henüz ilan yok",
    "No listings yet": "Henüz ilan yok",
    "accounts.page_analytics": "Sayfa analizi",
    "Page Analytics": "Sayfa analizi",
    "accounts.analytics_key_missing": "Bu kiracı için analiz API anahtarı yapılandırılmamış.",
    "Analytics API key not configured for this tenant.": "Bu kiracı için analiz API anahtarı yapılandırılmamış.",
    "accounts.storefront_url_missing": "Bu hesap için mağaza URL’si kullanılamıyor.",
    "No storefront URL available for this account.": "Bu hesap için mağaza URL’si kullanılamıyor.",
    "accounts.no_analytics_loaded": "Henüz analiz yüklenmedi.",
    "No analytics loaded yet.": "Henüz analiz yüklenmedi.",
    "accounts.load_analytics": "Analizi yükle",
    "Load Analytics": "Analizi yükle",
    "accounts.attributes": "Özellikler",
    "accounts.shipping": "Kargo",
    "accounts.commission": "Komisyon",
    "Commission": "Komisyon",
    "accounts.detail_title": "Başlık",
    "accounts.detail_description": "Açıklama",
    "accounts.detail_descriptions": "Açıklamalar",
    "Descriptions": "Açıklamalar",
    "accounts.detail_listings": "İlanlar",
    "accounts.detail_categories": "Kategoriler",
    "accounts.detail_location": "Konum",
    "accounts.detail_account_status": "Hesap durumu",
    "accounts.detail_status": "Durum",
    "accounts.detail_shipping_method": "Kargo yöntemi",
    "accounts.detail_shipping_methods": "Kargo yöntemleri",
    "Shipping Methods": "Kargo yöntemleri",
    "accounts.detail_account_user": "Hesap kullanıcısı",
    "Account User": "Hesap kullanıcısı",
    "accounts.detail_pending": "Bekliyor",
    "accounts.detail_approved": "Onaylandı",
    "accounts.detail_rejected": "Reddedildi",
    "accounts.detail_active": "Etkin",
    "accounts.detail_inactive": "Etkin değil",
    "accounts.detail_joined": "Katılma tarihi",
    "Joined": "Katılma tarihi",
    "accounts.detail_account_age": "Hesap yaşı",
    "Account Age": "Hesap yaşı",
    "accounts.detail_less_than_a_month": "Bir aydan az",
    "Less than a month": "Bir aydan az",
    "accounts.detail_page_views": "Sayfa görüntülemeleri",
    "Page Views": "Sayfa görüntülemeleri",
    "accounts.detail_unique_visitors": "Tekil ziyaretçiler",
    "Unique Visitors": "Tekil ziyaretçiler",
    "accounts.detail_sessions": "Oturumlar",
    "Sessions": "Oturumlar",
    "accounts.detail_clicks": "Tıklamalar",
    "Clicks": "Tıklamalar",
    "accounts.detail_goals": "Hedefler",
    "Goals": "Hedefler",
    "accounts.detail_bot_views": "Bot görüntülemeleri",
    "Bot Views": "Bot görüntülemeleri",
    "accounts.detail_followers": "Takipçiler",
    "Followers": "Takipçiler",
    "accounts.detail_total_orders": "Toplam sipariş",
    "accounts.detail_revenue": "Gelir",
    "accounts.detail_avg_order": "Ort. sipariş",
    "accounts.detail_paid_orders": "Ödenen siparişler",
    "Paid Orders": "Ödenen siparişler",
    "accounts.detail_owner": "Sahip",
    "Owner": "Sahip",
    "accounts.detail_account_id": "Hesap kimliği",
    "accounts.detail_category": "Kategori",
    "accounts.detail_profile_completeness": "Profil tamamlama",
    "Profile Completeness": "Profil tamamlama",
    "accounts.detail_total_listings": "Toplam ilan",
    "Total Listings": "Toplam ilan",
    "accounts.detail_loaded_listings": "Yüklenen ilanlar",
    "Loaded Listings": "Yüklenen ilanlar",
    "accounts.detail_active_listings": "Etkin ilanlar",
    "Active Listings": "Etkin ilanlar",
    "accounts.detail_last_updated": "Son güncelleme",
    "Last Updated": "Son güncelleme",
    "accounts.detail_last_activity": "Son etkinlik",
    "Last Activity": "Son etkinlik",
    "accounts.detail_verification": "Doğrulama",
    "Verification": "Doğrulama",
    "accounts.detail_subscription": "Abonelik",
    "accounts.detail_attributes": "Özellikler",
    "accounts.detail_shipping_charge_split": "Kargo ücreti paylaşımı",
    "Shipping Charge Split": "Kargo ücreti paylaşımı",
    "accounts.detail_value_type": "Değer türü",
    "Value Type": "Değer türü",
    "accounts.detail_value": "Değer",
    "accounts.detail_enter_value": "Değer girin",
    "Enter Value": "Değer girin",
    "accounts.detail_commission_percentage": "Komisyon yüzdesi",
    "Commission Percentage": "Komisyon yüzdesi",
    "accounts.detail_commission_percent": "Komisyon yüzdesi",
    "Commission Percent": "Komisyon yüzdesi",
    "accounts.detail_share": "Pay",
    "accounts.detail_view_account": "Hesabı görüntüle",
    "View Account": "Hesabı görüntüle",
    "accounts.detail_add_listing": "İlan ekle",
    "Add Listing": "İlan ekle",
    "accounts.detail_edit_account": "Hesabı düzenle",
    "Edit Account": "Hesabı düzenle",
    "accounts.no_attribute_values": "{name} için özellik değeri yok",
    "accounts.no_attributes_yet": "Henüz özellik yok",
    "No attributes yet": "Henüz özellik yok",
    "accounts.edit_account": "Hesabı düzenle",
    "accounts.detail_preview": "Önizleme",
    "accounts.detail_fixed": "Sabit",
    "Fixed": "Sabit",
    "accounts.detail_percentage": "Yüzde",
    "Percentage": "Yüzde",
    "accounts.detail_select_value_type": "Değer türünü seç",
    "Select Value Type": "Değer türünü seç",
    "accounts.detail_approve": "Onayla",
    "accounts.detail_reject": "Reddet",
    "accounts.detail_section": "Ayrıntılar",
    "Details": "Ayrıntılar",
    "category.add_child": "Alt kategori ekle",
    "Add Child Category": "Alt kategori ekle",
    "category.add_listing": "İlan ekle",
    "category.manage": "Kategorileri yönet",
    "Manage Categories": "Kategorileri yönet",
    "category.account_overview_eyebrow": "HESAP KATEGORİSİNE GENEL BAKIŞ",
    "ACCOUNT CATEGORY OVERVIEW": "HESAP KATEGORİSİNE GENEL BAKIŞ",
    "category.overview_eyebrow": "KATEGORİYE GENEL BAKIŞ",
    "CATEGORY OVERVIEW": "KATEGORİYE GENEL BAKIŞ",
    "category.category": "Kategori",
    "category.active": "Etkin",
    "category.inactive": "Etkin değil",
    "category.accounts": "Hesaplar",
    "category.listings": "İlanlar",
    "category.child_categories": "Alt kategoriler",
    "Child Categories": "Alt kategoriler",
    "category.attributes": "Özellikler",
    "category.category_age": "Kategori yaşı",
    "Category age": "Kategori yaşı",
    "category.category_overview": "Kategori özeti",
    "Category Overview": "Kategori özeti",
    "category.category_id": "Kategori kimliği",
    "category.name": "Ad",
    "category.slug": "Kısa ad",
    "category.description": "Açıklama",
    "category.parent_category": "Üst kategori",
    "Parent Category": "Üst kategori",
    "category.hierarchy": "Hiyerarşi",
    "Hierarchy": "Hiyerarşi",
    "category.status": "Durum",
    "category.display_order": "Görüntüleme sırası",
    "Display Order": "Görüntüleme sırası",
    "category.created": "Katılma / oluşturulma",
    "Joined / Created": "Katılma / oluşturulma",
    "category.configured": "Yapılandırıldı",
    "Configured": "Yapılandırıldı",
    "category.no_attributes": "Özellik atanmadı.",
    "No attributes assigned.": "Özellik atanmadı.",
    "category.no_child_categories": "Alt kategori yok.",
    "No child categories.": "Alt kategori yok.",
    "category.no_accounts": "Bu kategoride hesap yok.",
    "No accounts in this category.": "Bu kategoride hesap yok.",
    "category.no_listings": "Bu kategoride ilan yok.",
    "No listings in this category.": "Bu kategoride ilan yok.",
    "category.detail_title": "Kategori ayrıntısı",
    "Category Detail": "Kategori ayrıntısı",
    "category.age_less_month": "Bir aydan az",
    "category.age_month": "{count} ay",
    "{count} month": "{count} ay",
    "category.age_months": "{count} ay",
    "{count} months": "{count} ay",
    "category.age_year": "{count} yıl",
    "{count} year": "{count} yıl",
    "category.age_years": "{count} yıl",
    "{count} years": "{count} yıl",
    "category.header_name": "Ad",
    "category.header_category_id": "Kategori kimliği",
    "category.header_image": "Görsel",
    "category.header_order": "Sıra",
    "category.header_parent": "Üst kategori",
    "Parent": "Üst kategori",
    "category.header_active": "Etkin",
    "category.header_action": "İşlem",
    "category.header_url": "URL",
    "URL": "URL",
    "category.categories": "Kategoriler",
    "category.translate": "Çevir",
    "category.import": "İçe aktar",
    "category.export": "Dışa aktar",
    "category.add_category": "Kategori ekle",
    "Add Category": "Kategori ekle",
    "category.import_categories": "Kategorileri içe aktar",
    "Import Categories": "Kategorileri içe aktar",
    "category.delete_warning": "Mevcut ilanlar web sitesinde veya uygulamada açılmaz ve hata gösterilir.",
    "Existing listings will not open in website or app, you will see an error.": "Mevcut ilanlar web sitesinde veya uygulamada açılmaz ve hata gösterilir.",
    "category.editor_edit_category": "Kategoriyi düzenle",
    "Edit Category": "Kategoriyi düzenle",
    "category.editor_add_category": "Kategori ekle",
    "category.editor_save": "Kaydet",
    "category.editor_select_category_level": "Kategori düzeyi seçin",
    "Select Category Level": "Kategori düzeyi seçin",
    "category.editor_parent_category": "Üst kategori",
    "category.editor_select": "Seç",
    "category.editor_category_name": "Kategori adı",
    "Category Name": "Kategori adı",
    "category.editor_enter_category_name": "Kategori adını girin",
    "Enter category name": "Kategori adını girin",
    "category.editor_slug": "Kısa ad",
    "category.editor_enter_slug": "Kısa adı girin",
    "Enter slug": "Kısa adı girin",
    "category.editor_category_description": "Kategori açıklaması",
    "Category Description": "Kategori açıklaması",
    "category.editor_order": "Sıra",
    "category.editor_enter_order": "Sıra girin",
    "Enter order": "Sıra girin",
    "category.editor_status_not_active_active": "Durum (Etkin değil / Etkin)",
    "Status (Not Active / Active)": "Durum (Etkin değil / Etkin)",
    "category.editor_upload_media": "Medya yükle",
    "category.editor_meta_title": "Meta başlık",
    "category.editor_enter_meta_title": "Meta başlığı girin",
    "Enter meta title": "Meta başlığı girin",
    "category.editor_meta_description": "Meta açıklama",
    "category.editor_category": "Kategori",
    "category.editor_name": "Ad",
    "category.editor_status": "Durum",
    "category.editor_action": "İşlem",
    "category.editor_add_attribute": "Özellik ekle",
    "Add Attribute": "Özellik ekle",
    "category.editor_attributes_list": "Özellik listesi",
    "Attributes List": "Özellik listesi",
    "category.editor_please_enter_a_category_name_first": "Önce kategori adını girin",
    "Please enter a category name first": "Önce kategori adını girin",
    "category.editor_successfully_added_category": "Kategori başarıyla eklendi",
    "Successfully added category": "Kategori başarıyla eklendi",
    "category.deleted": "Kategori silindi",
    "Category deleted": "Kategori silindi",
    "attributes.title": "Özellikler",
    "attributes.cart_checkout": "Sepet ve ödeme",
    "Cart & Checkout": "Sepet ve ödeme",
    "attributes.cart_settings": "Sepet ayarları",
    "Cart settings": "Sepet ayarları",
    "attributes.order_status_notifications": "Sipariş durumu bildirimleri",
    "Order status notifications": "Sipariş durumu bildirimleri",
    "attributes.groups": "Özellik grupları",
    "Attribute Groups": "Özellik grupları",
    "attributes.add_attribute": "Özellik ekle",
    "attributes.edit_bulk": "Toplu düzenle",
    "Edit Bulk": "Toplu düzenle",
    "attributes.confirm_delete": "Bu özellik silinsin mi?",
    "attributes.header_attribute_name": "Özellik adı",
    "Attribute Name": "Özellik adı",
    "attributes.header_action": "İşlem",
    "attributes.header_manage_attribute_values": "Özellik değerlerini yönet",
    "Manage Attribute Values": "Özellik değerlerini yönet",
    "attributes.header_type": "Tür",
    "attributes.header_optional": "İsteğe bağlı",
    "attributes.header_icon": "Simge",
    "Icon": "Simge",
    "attributes.header_categories": "Kategoriler",
    "attributes.header_hidden_field": "Gizli alan",
    "Hidden Field": "Gizli alan",
    "attributes.header_values": "Değerler",
    "Values": "Değerler",
    "attributes.header_status": "Durum",
    "attributes.type_single_select": "Tek seçim",
    "Single Select": "Tek seçim",
    "attributes.type_multi_select": "Çoklu seçim",
    "Multi Select": "Çoklu seçim",
    "attributes.type_open_single_value": "Serbest giriş (tek değer)",
    "Open (Single Value)": "Serbest giriş (tek değer)",
    "attributes.type_open_multiple_value": "Serbest giriş (çoklu değer)",
    "Open (Multiple Value)": "Serbest giriş (çoklu değer)",
    "attributes.type_attachment": "Ek",
    "Attachment": "Ek",
    "attributes.type_text_area": "Metin alanı",
    "Text Area": "Metin alanı",
    "attributes.type_date_time": "Tarih ve saat",
    "Date Time": "Tarih ve saat",
    "attributes.type_number": "Sayı",
    "attributes.type_boolean": "Boole",
    "Boolean": "Boole",
    "attributes.type_color": "Renk",
    "Color": "Renk",
    "attributes.type_json": "JSON",
    "Json": "JSON",
    "attributes.type_location": "Konum",
    "attributes.type_audio": "Ses",
    "Audio": "Ses",
    "attributes.type_video": "Video",
    "Video": "Video",
    "attributes.type_open_multi_value": "Serbest giriş (çoklu değer)",
    "Open (Multi Value)": "Serbest giriş (çoklu değer)",
    "attributes.editor_edit_attribute": "Özelliği düzenle",
    "attributes.editor_add_attribute": "Özellik ekle",
    "attributes.editor_attribute_name": "Özellik adı",
    "attributes.editor_select_type": "Tür seçin",
    "attributes.prefill_user": "Kullanıcı",
    "common.search_placeholder": "Aramak için yazın…",
    "attributes.prefill_accounts": "Hesaplar",
    "attributes.prefill_listings": "İlanlar",
    "listings.detail_nav_gallery": "Galeri",
    "Gallery": "Galeri",
    "listings.detail_nav_details": "Ayrıntılar",
    "listings.detail_nav_inventory": "Envanter",
    "listings.detail_nav_social": "Sosyal",
    "Social": "Sosyal",
    "listings.detail_nav_orders": "Siparişler",
    "listings.detail_nav_analytics": "Analiz",
    "listings.detail_nav_schedule": "Program",
    "listings.detail_nav_rental": "Kiralama",
    "Rental": "Kiralama",
    "listings.detail_nav_attributes": "Özellikler",
    "listings.detail_nav_seller": "Satıcı",
    "attributes.editor_icon": "Simge",
    "attributes.editor_tool_tip": "Araç ipucu",
    "Tool tip": "Araç ipucu",
    "attributes.editor_enter_attribute_name": "Özellik adını girin",
    "attributes.editor_enter_attribute_tool_tip": "Araç ipucu metnini girin",
    "Enter attribute tool tip": "Araç ipucu metnini girin",
    "attributes.editor_optional": "İsteğe bağlı",
    "attributes.editor_private": "Özel",
    "Private": "Özel",
    "attributes.editor_hidden_field": "Gizli alan",
    "Hidden field": "Gizli alan",
    "attributes.editor_show_in_filter": "Filtrede göster",
    "Show in filter": "Filtrede göster",
    "attributes.editor_status_not_active_active": "Durum (Etkin değil / Etkin)",
    "attributes.editor_add_meta_data": "Meta veri ekle",
    "Add meta data": "Meta veri ekle",
    "attributes.editor_select": "Seç",
    "attributes.editor_select_category": "Kategori seçin",
    "attributes.editor_select_all": "Tümünü seç",
    "Select All": "Tümünü seç",
    "attributes.editor_unselect_all": "Tüm seçimleri kaldır",
    "UnSelect All": "Tüm seçimleri kaldır",
    "attributes.editor_create_categories_in_this_configuration_first": "Önce bu yapılandırmada kategori oluşturun",
    "Create categories in this configuration first": "Önce bu yapılandırmada kategori oluşturun",
    "attributes.editor_please_enter_attribute_name": "Özellik adını girin",
    "attributes.editor_please_select_type": "Tür seçin",
    "Please select type": "Tür seçin",
    "attributes.editor_select_single_attribute_values": "Tek özellik değerlerini seçin",
    "attributes.editor_select_multiple_attribute_values": "Birden çok özellik değeri seçin",
    "attributes.editor_enter_value": "Değer girin",
    "attributes.editor_enter_multiple_tag": "Birden çok etiket girin",
    "Enter Multiple Tag": "Birden çok etiket girin",
    "attributes.editor_upload_file": "Dosya yükle",
    "Upload file": "Dosya yükle",
    "attributes.editor_enter_text": "Metin girin",
    "Enter Text": "Metin girin",
    "attributes.editor_select_date": "Tarih seçin",
    "attributes.editor_enter_number": "Sayı girin",
    "Enter Number": "Sayı girin",
    "attributes.editor_select_color": "Renk seçin",
    "attributes.editor_upload_json": "JSON yükle",
    "Upload Json": "JSON yükle",
    "attributes.editor_select_location": "Konum seçin",
    "attributes.editor_category": "Kategori",
    "attributes.editor_price": "Fiyat",
    "attributes.editor_enter_price": "Fiyat girin",
    "Enter Price": "Fiyat girin",
    "attributes.editor_preview": "Önizleme",
    "attributes.editor_title": "Başlık",
    "attributes.editor_enter_title": "Başlık girin",
    "Enter Title": "Başlık girin",
    "attributes.editor_description": "Açıklama",
    "attributes.editor_add_listing": "İlan ekle",
    "attributes.editor_add_account": "Hesap ekle",
    "Add Account": "Hesap ekle",
    "attributes.editor_successfully_added_attributes": "Özellikler başarıyla eklendi",
    "Successfully added attributes": "Özellikler başarıyla eklendi",
    "attributes.editor_add_attribute_values": "Özellik değerleri ekle",
    "common.image": "Görsel",
    "common.please_wait": "Lütfen bekleyin…",
    "attribute_groups.title": "Özellik grupları",
    "attribute_groups.title_singular": "Özellik grubu",
    "Attribute Group": "Özellik grubu",
    "attribute_groups.add": "Özellik grubu ekle",
    "Add Attribute Group": "Özellik grubu ekle",
    "attribute_groups.image_path": "Görsel yolu",
    "Image Path": "Görsel yolu",
    "attribute_groups.name_placeholder": "Grup adı",
    "Group Name": "Grup adı",
    "attribute_groups.select_attributes": "Özellikleri seç",
    "Select Attributes": "Özellikleri seç",
    "attribute_groups.select_attributes_placeholder": "Özellikleri seçin…",
    "Select Attributes...": "Özellikleri seçin…",
    "attribute_groups.added_successfully": "Özellik grubu eklendi",
    "Attribute Group Added Successfully": "Özellik grubu eklendi",
    "attribute_groups.deleted_successfully": "Başarıyla silindi",
    "Deleted successfully": "Başarıyla silindi",
    "attribute_groups.name_required": "Ad gereklidir",
    "attribute_groups.save_attributes_failed": "Grup kaydedildi ancak özellikleri atanamadı.",
    "The group was saved, but its attributes could not be assigned.": "Grup kaydedildi ancak özellikleri atanamadı.",
    "attributes.editor_enter_description": "Açıklama girin",
    "Enter Description": "Açıklama girin",
    "account_config.title": "Hesap yapılandırması",
    "account_config.account_detail_note": "Hesap ayrıntısı notu",
    "Account detail note": "Hesap ayrıntısı notu",
    "account_config.enter_account_detail_note": "Hesap ayrıntısı notunu girin",
    "Enter account detail note": "Hesap ayrıntısı notunu girin",
    "account_config.address_label": "Adres etiketi",
    "account_config.enter_address_label": "Adres etiketini girin",
    "Enter address label": "Adres etiketini girin",
    "account_config.category_label": "Kategori etiketi",
    "Category label": "Kategori etiketi",
    "account_config.enter_category_label": "Kategori etiketini girin",
    "Enter category label": "Kategori etiketini girin",
    "account_config.nearby_accounts_radius_km": "Yakındaki hesap yarıçapı (km)",
    "Nearby accounts radius (km)": "Yakındaki hesap yarıçapı (km)",
    "account_config.nearby_accounts_radius_placeholder": "Km cinsinden yakındaki hesap yarıçapı",
    "Account nearby radius in km": "Km cinsinden yakındaki hesap yarıçapı",
    "account_config.account_limit": "Hesap sınırı",
    "Account Limit": "Hesap sınırı",
    "account_config.account_limit_placeholder": "Hesap sınırı",
    "Account limit": "Hesap sınırı",
    "account_config.shipping_preference_note": "Kargo tercihi notu",
    "Shipping method preference note": "Kargo tercihi notu",
    "account_config.option_accounts_auto_approved": "Hesapları otomatik onayla",
    "Accounts auto approved": "Hesapları otomatik onayla",
    "account_config.option_shipping_methods_preference_for_accounts": "Hesaplar için tercih edilen kargo yöntemleri",
    "Shipping methods preference for accounts": "Hesaplar için tercih edilen kargo yöntemleri",
    "account_config.option_account_map_location_selector": "Hesap harita konum seçicisi",
    "Account map location selector": "Hesap harita konum seçicisi",
    "account_config.option_account_geo_location": "Hesap coğrafi konumu",
    "Account Geo Location": "Hesap coğrafi konumu",
    "account_config.option_slug": "Kısa ad",
    "account_config.option_show_description": "Açıklamayı göster",
    "Show Description": "Açıklamayı göster",
    "account_config.option_formatted_text_description": "Biçimlendirilmiş açıklama metni",
    "Formatted Text Description": "Biçimlendirilmiş açıklama metni",
    "account_config.option_hide_address_from_account_detail": "Hesap ayrıntılarında adresi gizle",
    "Hide Address from Account Detail": "Hesap ayrıntılarında adresi gizle",
    "account_config.option_get_account_pickup_address_always": "Hesap teslim alma adresini her zaman al",
    "Get Account Pickup Address Always": "Hesap teslim alma adresini her zaman al",
    "account_config.option_get_pickup_address_for_delivery": "Teslimat için teslim alma adresini al",
    "Get Pickup Address for Delivery": "Teslimat için teslim alma adresini al",
    "account_config.uploaded_successfully": "Başarıyla yüklendi",
    "app_customization.realtime_config_notice": "Bu ayarlar anında uygulanır. Kaydedildiğinde değişiklikler uygulamalara ve API yanıtlarına yansır.",
    "app_customization.release_config_notice": "Mobil uygulamalar için not: Bu ayarlar yalnızca ürün sürümünde ve güncelleme zamanında uygulanır, anlık olarak güncellenmez. Yeni derleme için Destek Portalı’ndan istek gönderin. (Starter planı)",
    "Note for Mobile App Channels: This below configs are applied only on product release and updates time. And will never be updated in realtime. When you make changes here and need an updated build, do a build request from Support Portal. (Applicable to Starter plan)": "Mobil uygulamalar için not: Bu ayarlar yalnızca ürün sürümünde ve güncelleme zamanında uygulanır, anlık olarak güncellenmez. Yeni derleme için Destek Portalı’ndan istek gönderin. (Starter planı)",
    "category.translation_title": "Kategoriyi çevir",
    "Translate Category": "Kategoriyi çevir",
    "category.translation_category_name": "Kategori adı",
    "category.translation_description": "Açıklama",
    "listing_configs.title": "İlan yapılandırması",
    "Listing Configuration": "İlan yapılandırması",
    "listing_configs.rules": "KURALLAR (proje/kiracı düzeyi)",
    "RULES (Projects/Tenant level)": "KURALLAR (proje/kiracı düzeyi)",
    "listing_configs.features": "ÖZELLİKLER (yalnızca mobil uygulama)",
    "FEATURES (Only for mobile app)": "ÖZELLİKLER (yalnızca mobil uygulama)",
    "listing_configs.ui_customisation": "Arayüz özelleştirme",
    "UI Customisation": "Arayüz özelleştirme",
    "listing_configs.overridden_max_quantity": "İlan başına en fazla miktar",
    "Maximum quantity per listing": "İlan başına en fazla miktar",
    "listing_configs.overridden_max_quantity_example": "(Örnek: 100)",
    "(Example: 100)": "(Örnek: 100)",
    "listing_configs.listing_min_price": "En düşük ilan fiyatı",
    "Minimum listing price": "En düşük ilan fiyatı",
    "listing_configs.listing_min_price_example": "(Örnek: $5)",
    "(Example: $5)": "(Örnek: $5)",
    "listing_configs.auto_approval": "İlanlar otomatik onaylansın mı?",
    "Auto approve listings?": "İlanlar otomatik onaylansın mı?",
    "listing_configs.listing_pictures_count": "Yüklenebilir görsel sayısı",
    "listing_configs.seller_can_place_order": "Satıcı sipariş verebilir",
    "Seller can place order": "Satıcı sipariş verebilir",
    "listing_configs.hide_offer_percent": "Teklif yüzdesi",
    "Offer percent": "Teklif yüzdesi",
    "listing_configs.show_max_quantity": "İlan düzeyinde miktar sınırı",
    "listing_configs.show_shipping_charges": "Kargo ücretleri",
    "Shipping charges": "Kargo ücretleri",
    "listing_configs.listing_address_label": "İlan adres etiketi",
    "listing_configs.listing_address_label_example": "(Örnek: Tarifi)",
    "listing_configs.listing_map_location_selector_enabled": "Adres aramak yerine harita işaretçisi kullan",
    "Use map marker instead of searching address": "Adres aramak yerine harita işaretçisi kullan",
    "listing_configs.listing_hide_tags": "Etiketler",
    "Tags": "Etiketler",
    "listing_configs.enable_stock": "Stoklar",
    "Stocks": "Stoklar",
    "listing_configs.listing_address_enabled": "Coğrafi adres",
    "Geo address": "Coğrafi adres",
    "listing_configs.show_stock_out_listings": "Stokta olmayan ilanları akışta göster",
    "Show out of stock listings in feed": "Stokta olmayan ilanları akışta göster",
    "listing_configs.enable_slug": "İlan başlığı kısa adı",
    "listing_configs.show_variants": "Varyantlar",
    "Variants": "Varyantlar",
    "listing_configs.meta_title": "Meta başlık",
    "listing_configs.meta_description": "Meta açıklama",
    "listing_configs.listing_enable_formatted_text_description": "Metin düzenleyiciyi etkinleştir",
    "listing_configs.listing_enable_weight": "Ağırlığı etkinleştir",
    "Enable Weight": "Ağırlığı etkinleştir",
    "listing_configs.listing_enable_dimensions": "Boyutları etkinleştir",
    "Enable Dimensions": "Boyutları etkinleştir",
    "listing_configs.enable_stocks_listing_schedules": "Stok planlaması",
    "Stock Schedules": "Stok planlaması",
    "listing_variants.title": "Varyant türleri",
    "listing_variants.add_type": "Varyant türü ekle",
    "Add Variant Type": "Varyant türü ekle",
    "listing_variants.edit_type": "Varyant türünü düzenle",
    "Edit Variant Type": "Varyant türünü düzenle",
    "listing_variants.name": "Ad",
    "listing_variants.values": "Değerler",
    "listing_variants.status": "Durum",
    "listing_variants.action": "İşlem",
    "listing_variants.add_value": "Değer ekle",
    "Add Value": "Değer ekle",
    "listing_variants.active": "Etkin",
    "listing_variants.inactive": "Etkin değil",
    "listing_variants.details": "Ayrıntılar",
    "listing_variants.translate": "Çevir",
    "listing_variants.delete_confirm": "Bu varyant türü silinsin mi?",
    "Do you want to delete this variant type?": "Bu varyant türü silinsin mi?",
    "listing_variants.add_value_first": "Varyantları görüntülemeden önce değer ekleyin.",
    "Add a value before viewing variants.": "Varyantları görüntülemeden önce değer ekleyin.",
    "listing_variants.enter_name": "Ad girin",
    "Enter name": "Ad girin",
    "listing_variants.status_hint": "Durum (Etkin değil / Etkin)",
    "Status (Inactive / Active)": "Durum (Etkin değil / Etkin)",
    "listing_variants.total_values": "Toplam değer",
    "Total Values": "Toplam değer",
    "listing_variants.type_id": "Tür kimliği",
    "Type ID": "Tür kimliği",
    "listing_variants.total_count": "Toplam {count}",
    "{count} total": "Toplam {count}",
    "listing_variants.loading": "Yükleniyor…",
    "listing_variants.loading_values": "Değerler yükleniyor…",
    "Loading values…": "Değerler yükleniyor…",
    "listing_variants.no_values": "Henüz değer yok",
    "No values yet": "Henüz değer yok",
    "listing_variants.add_first_value": "İlk değeri ekle",
    "Add First Value": "İlk değeri ekle",
    "listing_variants.actions": "İşlemler",
    "listing_variants.edit": "Düzenle",
    "listing_variants.delete": "Sil",
    "listing_variants.edit_value": "Değeri düzenle",
    "Edit Value": "Değeri düzenle",
    "listing_variants.value_name_required": "Değer adı *",
    "Value Name *": "Değer adı *",
    "listing_variants.value_examples": "ör. Kırmızı, XL, Pamuk…",
    "e.g. Red, XL, Cotton…": "ör. Kırmızı, XL, Pamuk…",
    "listing_variants.saving": "Kaydediliyor…",
    "listing_variants.save_changes": "Değişiklikleri kaydet",
    "Save Changes": "Değişiklikleri kaydet",
    "listing_variants.delete_value_confirm": "Bu varyant değeri silinsin mi?",
    "Do you want to delete this variant value?": "Bu varyant değeri silinsin mi?",
    "listing_variants.clear_all": "Tümünü temizle",
    "listing_variants.multiple_values_help": "Virgülle ayrılmış değerler ekleyin veya Excel’den sütun yapıştırın.",
    "You can add comma-separated values or paste a column from Excel.": "Virgülle ayrılmış değerler ekleyin veya Excel’den sütun yapıştırın.",
    "listing_variants.save": "Kaydet",
    "listing_variants.close": "Kapat",
    "listing_variants.update": "Güncelle",
    "listing_variants.default_text": "Varsayılan metin",
    "listing_variants.enter_value": "Varyant değerini girin",
    "Enter variant value": "Varyant değerini girin",
    "listing_variants.add_values": "Değer ekle",
    "Add Values": "Değer ekle",
    "listing_variants.add_variant_values": "Varyant türü değerleri ekle",
    "Add Variant Type Values": "Varyant türü değerleri ekle",
    "listing_variants.values_list": "Varyant türü değer listesi",
    "Variant Type Values List": "Varyant türü değer listesi",
    "listing_variants.cancel_editing": "Düzenlemeyi iptal et",
    "Cancel Editing": "Düzenlemeyi iptal et",
    "listing_variants.value_name": "Varyant türü değeri",
    "Variant Type Value": "Varyant türü değeri",
    "common.default_text": "Varsayılan metin",
    "common.translation_heading": "{title} çevirileri",
    "{title} Translations": "{title} çevirileri",
    "attributes.value_delete_confirm": "Bu özellik değeri silinsin mi?",
    "Do you want to delete this attribute value?": "Bu özellik değeri silinsin mi?",
    "attributes.value_clear_all": "Tümünü temizle",
    "attributes.value_multiple_help": "Virgülle ayrılmış değerler ekleyin veya Excel’den sütun yapıştırın.",
    "Add comma-separated values or paste a column from Excel.": "Virgülle ayrılmış değerler ekleyin veya Excel’den sütun yapıştırın.",
    "attributes.value_active": "Etkin",
    "attributes.value_inactive": "Etkin değil",
    "attributes.value_save": "Kaydet",
    "attributes.value_close": "Kapat",
    "attributes.value_translate": "Çevir",
    "attributes.value_update": "Güncelle",
    "attributes.value_sort_alpha": "Alfabetik sırala",
    "Sort Alphabetically": "Alfabetik sırala",
    "attributes.value_default_text": "Varsayılan metin",
    "attributes.value_add_metadata": "Meta veri ekle",
    "Add Metadata": "Meta veri ekle",
    "attributes.value_cancel_edit": "Düzenlemeyi iptal et",
    "attributes.value_success_help": "Harika! Bu özel özelliği artık İlan Ekle sayfasında bulabilirsiniz.",
    "Great! You can now find this custom attribute on the Add Listing page.": "Harika! Bu özel özelliği artık İlan Ekle sayfasında bulabilirsiniz.",
    "attributes.value_add": "Özellik değerleri ekle",
    "attributes.value_add_listing": "İlan özellik değerleri ekle",
    "Add Listing Attribute Values": "İlan özellik değerleri ekle",
    "attributes.value_metadata_for": "Şunun meta verileri",
    "Metadata for": "Şunun meta verileri",
    "attributes.value_enter": "Özellik değerini girin",
    "Enter attribute value": "Özellik değerini girin",
    "attributes.value_add_values": "Değer ekle",
    "attributes.value_status_hint": "Durum (Etkin değil / Etkin)",
    "attributes.value_list": "Özellik değer listesi",
    "Attribute Values List": "Özellik değer listesi",
    "attributes.value_table_name": "Özellik değeri",
    "Attribute Value": "Özellik değeri",
    "attributes.value_table_status": "Durum",
    "attributes.value_table_action": "İşlem",
    "attributes.metadata_key": "Anahtar",
    "Key": "Anahtar",
    "attributes.metadata_value": "Değer",
    "attributes.metadata_add_row": "Satır ekle",
    "Add Row": "Satır ekle",
    "workspace.countries": "Ülkeler",
    "workspace.country_add": "Ülke ekle",
    "Add Country": "Ülke ekle",
    "workspace.country_edit": "Ülkeyi düzenle",
    "Edit Country": "Ülkeyi düzenle",
    "workspace.country_name": "Ülke adı",
    "Country Name": "Ülke adı",
    "workspace.select_country": "Ülke seçin",
    "Select country": "Ülke seçin",
    "workspace.country_order": "Sıra",
    "workspace.country_order_placeholder": "Sıra girin",
    "workspace.country_status": "Durum (Etkin değil / Etkin)",
    "workspace.country_default": "Varsayılan",
    "workspace.country_active": "Etkin",
    "workspace.country_inactive": "Etkin değil",
    "workspace.country_delete_confirm": "Bu ülke silinsin mi?",
    "Do you want to delete this country?": "Bu ülke silinsin mi?",
    "workspace.country_table_name": "Ad",
    "workspace.country_table_default": "Varsayılan",
    "workspace.country_table_order": "Sıra",
    "workspace.country_table_status": "Durum",
    "workspace.country_table_action": "İşlem",
    "workspace.languages": "Diller",
    "workspace.language_add": "Dil ekle",
    "Add Language": "Dil ekle",
    "workspace.language_edit": "Dili düzenle",
    "Edit Language": "Dili düzenle",
    "workspace.language_name": "Dil",
    "workspace.language_select": "Dil seçin",
    "Select Language": "Dil seçin",
    "workspace.language_order": "Sıra",
    "workspace.language_order_placeholder": "Sıra girin",
    "workspace.language_status": "Durum",
    "workspace.language_default": "Varsayılan",
    "workspace.language_default_warning": "Varsayılan dili değiştirmek uygulama dili ayarını değiştirir.",
    "Changing the default language changes the app language setting.": "Varsayılan dili değiştirmek uygulama dili ayarını değiştirir.",
    "workspace.language_active": "Etkin",
    "workspace.language_inactive": "Etkin değil",
    "workspace.language_delete_confirm": "Bu dil silinsin mi?",
    "Do you want to delete this language?": "Bu dil silinsin mi?",
    "workspace.language_table_name": "Ad",
    "workspace.language_table_default": "Varsayılan",
    "workspace.language_table_order": "Sıra",
    "workspace.language_table_status": "Durum",
    "workspace.language_table_action": "İşlem",
    "workspace.language_add_photo": "Fotoğraf ekle",
    "Add Photo": "Fotoğraf ekle",
    "workspace.currency": "Para birimi",
    "workspace.currency_add": "Para birimi ekle",
    "Add Currency": "Para birimi ekle",
    "workspace.currency_edit": "Para birimini düzenle",
    "Edit Currency": "Para birimini düzenle",
    "workspace.currency_delete_confirm": "Bu para birimi silinsin mi?",
    "Do you want to delete this currency?": "Bu para birimi silinsin mi?",
    "workspace.currency_show": "Göster",
    "workspace.currency_entries": "kayıt",
    "entries": "kayıt",
    "workspace.currency_search": "Ara:",
    "Search:": "Ara:",
    "workspace.currency_search_placeholder": "Para birimi ara",
    "Search currencies": "Para birimi ara",
    "workspace.currency_empty": "Para birimi bulunamadı.",
    "No currencies found.": "Para birimi bulunamadı.",
    "workspace.currency_active": "Etkin",
    "workspace.currency_inactive": "Etkin değil",
    "workspace.currency_name": "Ad",
    "workspace.currency_name_placeholder": "Para birimi adı",
    "Currency Name": "Para birimi adı",
    "workspace.currency_upload_media": "Medya yükle",
    "workspace.currency_select_media": "Medyadan seç",
    "Select from media": "Medyadan seç",
    "workspace.currency_no_media": "Medya dosyanız yok.",
    "You do not have any media files.": "Medya dosyanız yok.",
    "workspace.currency_code": "Kod",
    "workspace.currency_select_code": "Seç",
    "workspace.currency_exchange_rate": "Döviz kuru",
    "Exchange Rate": "Döviz kuru",
    "workspace.currency_precision": "Hassasiyet",
    "Precision": "Hassasiyet",
    "workspace.currency_thousand_separator": "Binlik ayırıcı",
    "Thousand Separator": "Binlik ayırıcı",
    "workspace.currency_decimal_point": "Ondalık ayırıcı",
    "Decimal Point": "Ondalık ayırıcı",
    "workspace.currency_status_hint": "Durum (Etkin değil / Etkin)",
    "workspace.currency_default": "Varsayılan",
    "workspace.currency_format": "Biçim",
    "Format": "Biçim",
    "workspace.currency_format_example": "USD {amount}",
    "USD {amount}": "USD {amount}",
    "workspace.currency_table_name": "Ad",
    "workspace.currency_table_code": "Kod",
    "workspace.currency_table_format": "Biçim",
    "workspace.currency_table_exchange": "Döviz kuru",
    "Exchange": "Döviz kuru",
    "workspace.currency_table_status": "Durum",
    "workspace.currency_table_default": "Varsayılan",
    "workspace.currency_table_action": "İşlem",
    "commissions.title": "Komisyonlar",
    "commissions.add": "Komisyon ekle",
    "Add Commission": "Komisyon ekle",
    "commissions.edit": "Komisyonu düzenle",
    "Edit Commission": "Komisyonu düzenle",
    "commissions.delete_confirm": "Bu komisyon silinsin mi?",
    "Do you want to delete this commission?": "Bu komisyon silinsin mi?",
    "commissions.yes": "Evet",
    "commissions.no": "Hayır",
    "commissions.filter_all": "Tümü",
    "commissions.filter_supply": "Arz",
    "Supply": "Arz",
    "commissions.filter_demand": "Talep",
    "Demand": "Talep",
    "commissions.filter_cart": "Sepet",
    "commissions.table_title": "Başlık",
    "commissions.table_default_value": "Varsayılan değer",
    "Default Value": "Varsayılan değer",
    "commissions.table_status": "Durum",
    "commissions.table_action": "İşlem",
    "commissions.active": "Etkin",
    "commissions.inactive": "Etkin değil",
    "commissions.type": "Tür",
    "commissions.type_supply": "Arz",
    "commissions.type_demand": "Talep",
    "commissions.type_cart": "Sepet",
    "commissions.select_category": "Kategori seçin",
    "commissions.title_label": "Başlık",
    "commissions.enter_title": "Başlık girin",
    "Enter title": "Başlık girin",
    "commissions.description": "Açıklama",
    "commissions.enter_description": "Açıklama girin",
    "Enter description": "Açıklama girin",
    "commissions.default_value_percent": "Varsayılan değer (%)",
    "Default value (%)": "Varsayılan değer (%)",
    "commissions.short_code": "Kısa kod",
    "Short Code": "Kısa kod",
    "commissions.short_code_tooltip_title": "Kısa kod",
    "Short code": "Kısa kod",
    "commissions.short_code_tooltip_description": "Bu komisyon için kısa kod girin.",
    "Enter a short code for this commission.": "Bu komisyon için kısa kod girin.",
    "commissions.enter_short_code": "Kısa kodu girin",
    "commissions.status_hint": "Durum (Etkin değil / Etkin)",
    "commissions.optional": "İsteğe bağlı",
    "commissions.advanced": "Gelişmiş",
    "Advanced": "Gelişmiş",
    "commissions.add_by_category": "Kategoriye göre komisyon ekle",
    "Add commission by category": "Kategoriye göre komisyon ekle",
    "commissions.select_calculation_type": "Tür seçin",
    "commissions.calc_fixed": "Sabit",
    "commissions.calc_slab": "Kademeli",
    "Slab": "Kademeli",
    "commissions.value": "Değer",
    "commissions.choose_category": "Kategori seçin",
    "Choose category": "Kategori seçin",
    "commissions.create_categories_first": "Önce İlan Yapılandırması’nda kategori oluşturun",
    "Create categories in Listing Configuration first": "Önce İlan Yapılandırması’nda kategori oluşturun",
    "commissions.select_type": "Tür seçin",
    "commissions.demand_fixed": "Sabit",
    "commissions.demand_percentage": "Yüzde",
    "commissions.unlimited_hint": "* Sınırsız için -1 girin",
    "* Enter -1 for unlimited": "* Sınırsız için -1 girin",
    "commissions.from": "Başlangıç",
    "commissions.enter_from": "Başlangıç değerini girin",
    "commissions.to": "Bitiş",
    "commissions.enter_to": "Bitiş değerini girin",
    "commissions.enter_value": "Değer girin",
    "commissions.add_row": "Satır ekle",
    "commissions.minimum_amount": "En düşük tutar",
    "Minimum amount": "En düşük tutar",
    "commissions.enter_minimum_amount": "En düşük tutarı girin",
    "Enter minimum amount": "En düşük tutarı girin",
    "commissions.maximum_amount": "En yüksek tutar",
    "Maximum amount": "En yüksek tutar",
    "commissions.enter_maximum_amount": "En yüksek tutarı girin",
    "Enter maximum amount": "En yüksek tutarı girin",
    "commissions.notes": "Notlar",
    "Notes": "Notlar",
    "commissions.enter_note": "Not girin",
    "Enter note": "Not girin",
    "commissions.from_value": "Başlangıç değeri",
    "From Value": "Başlangıç değeri",
    "commissions.to_value": "Bitiş değeri",
    "To Value": "Bitiş değeri",
    "commissions.unlimited_short_hint": "(-1 sınırsız)",
    "(-1 for unlimited)": "(-1 sınırsız)",
    "commissions.value_percent": "Değer (%)",
    "Value (%)": "Değer (%)",
    "commissions.from_value_validation": "Başlangıç değeri önceki bitiş değerinden büyük olmalıdır",
    "From value should be greater than the previous To value": "Başlangıç değeri önceki bitiş değerinden büyük olmalıdır",
    "commissions.to_value_validation": "Bitiş değeri başlangıç değerinden büyük olmalıdır",
    "To value should be greater than From value": "Bitiş değeri başlangıç değerinden büyük olmalıdır",
    "taxes.title": "Vergi",
    "taxes.title_plural": "Vergiler",
    "taxes.add": "Vergi ekle",
    "Add Tax": "Vergi ekle",
    "taxes.edit": "Vergiyi düzenle",
    "Edit Tax": "Vergiyi düzenle",
    "taxes.delete_confirm": "Bu vergi silinsin mi?",
    "Are you sure you want to delete this tax?": "Bu vergi silinsin mi?",
    "taxes.table_title": "Başlık",
    "taxes.table_short_code": "Kısa kod",
    "taxes.table_default_value": "Varsayılan değer",
    "taxes.table_status": "Durum",
    "taxes.table_action": "İşlem",
    "taxes.active": "Etkin",
    "taxes.inactive": "Etkin değil",
    "taxes.select_type": "Tür seçin",
    "taxes.type_order": "Sipariş",
    "taxes.type_listing": "İlan",
    "taxes.type_tax": "Vergi",
    "taxes.demand_fixed": "Sabit",
    "taxes.demand_percentage": "Yüzde",
    "taxes.from": "Başlangıç",
    "taxes.enter_from": "Başlangıç girin",
    "taxes.to": "Bitiş",
    "taxes.enter_to": "Bitiş girin",
    "taxes.unlimited_hint": "(-1 sınırsız)",
    "taxes.value": "Değer",
    "taxes.enter_value": "Değer girin",
    "taxes.add_row": "Satır ekle",
    "taxes.note": "Not",
    "taxes.note_placeholder": "Ödeme sırasında ve sipariş ayrıntılarında kullanıcılara gösterilecek notu girin.",
    "Enter a note for users to see during checkout and in order details.": "Ödeme sırasında ve sipariş ayrıntılarında kullanıcılara gösterilecek notu girin.",
    "taxes.inclusive": "Vergi dahil",
    "Tax Inclusive": "Vergi dahil",
    "taxes.inclusive_tooltip": "Listelenen fiyata vergi dahilse bunu etkinleştirin.",
    "Enable this when the listed price already includes tax.": "Listelenen fiyata vergi dahilse bunu etkinleştirin.",
    "taxes.title_placeholder": "Ödeme sırasında ve sipariş ayrıntılarında kullanıcıların göreceği adı girin.",
    "Enter a name shown to users at checkout and in order details.": "Ödeme sırasında ve sipariş ayrıntılarında kullanıcıların göreceği adı girin.",
    "taxes.default_value": "Varsayılan değer (%)",
    "taxes.default_placeholder": "% cinsinden varsayılan değer. Örnek: 6,5",
    "Default value in %. Example: 6.5": "% cinsinden varsayılan değer. Örnek: 6,5",
    "taxes.short_code": "Kısa kod",
    "taxes.short_code_tooltip_title": "Kısa kod",
    "taxes.short_code_tooltip_description": "Bu vergi için kısa kod girin.",
    "Enter a short code for this tax.": "Bu vergi için kısa kod girin.",
    "taxes.short_code_placeholder": "En fazla 10 harf ve rakam kullanın. Örnek: GST10",
    "Use letters and numbers, up to 10 characters. Example: GST10": "En fazla 10 harf ve rakam kullanın. Örnek: GST10",
    "taxes.status_hint": "Durum (Etkin değil / Etkin)",
    "taxes.advanced": "Gelişmiş",
    "special_fees.title": "Özel ücretler",
    "special_fees.description": "Her ilan için ek sabit ücret veya yüzde belirleyin.",
    "Configure an additional fixed amount or percentage fee for each listing.": "Her ilan için ek sabit ücret veya yüzde belirleyin.",
    "special_fees.fixed": "Sabit özel ücret",
    "Special fees fixed": "Sabit özel ücret",
    "special_fees.fixed_placeholder": "Ücret tutarını girin (örnek: 5)",
    "Enter special fee amount (example: 5)": "Ücret tutarını girin (örnek: 5)",
    "special_fees.percentage": "Yüzde özel ücret",
    "Special fees percentage": "Yüzde özel ücret",
    "special_fees.percentage_placeholder": "Ücret yüzdesini girin (örnek: %10)",
    "Enter special fee percentage (example: 10%)": "Ücret yüzdesini girin (örnek: %10)",
    "special_fees.example": "Örnek",
    "Example": "Örnek",
    "special_fees.example_description": "İlan fiyatına özel ücret ekleyebilirsiniz. Örneğin, ürün 100 $ ve ilana iki ücret ekleniyor.",
    "You can add a special fee on top of the listing price. For example, a listed product costs $100 and you add two fees per listing.": "İlan fiyatına özel ücret ekleyebilirsiniz. Örneğin, ürün 100 $ ve ilana iki ücret ekleniyor.",
    "special_fees.example_fixed": "Ek sabit tutar = 10 $",
    "Additional fixed amount = $10": "Ek sabit tutar = 10 $",
    "special_fees.example_percentage": "Ek yüzde = %10",
    "Additional fixed percentage = 10%": "Ek yüzde = %10",
    "special_fees.example_total": "Son fiyat = 120 $",
    "Final price = $120": "Son fiyat = 120 $",
    "delivery.methods_title": "Hizmet / Kargo yöntemleri",
    "Service / Shipping Methods": "Hizmet / Kargo yöntemleri",
    "delivery.shipping_service": "Kargo / Hizmet",
    "Shipping / Service": "Kargo / Hizmet",
    "delivery.table_name": "Ad",
    "delivery.table_default": "Varsayılan",
    "delivery.table_order": "Sıra",
    "delivery.table_status": "Durum",
    "delivery.table_action": "İşlem",
    "delivery.yes": "Evet",
    "delivery.no": "Hayır",
    "delivery.active": "Etkin",
    "delivery.inactive": "Etkin değil",
    "delivery.delete_confirm": "Bu kargo yöntemi silinsin mi?",
    "Do you want to delete this shipping method?": "Bu kargo yöntemi silinsin mi?",
    "delivery.schedule_time": "Planlanan saat",
    "Schedule Time": "Planlanan saat",
    "delivery.translate": "Çevir",
    "delivery.config": "Yapılandırma",
    "Config": "Yapılandırma",
    "delivery.add": "Kargo / hizmet ekle",
    "Add Shipping/Service": "Kargo / hizmet ekle",
    "delivery.save": "Kaydet",
    "delivery.edit": "Kargo / hizmeti düzenle",
    "Edit Shipping/Service": "Kargo / hizmeti düzenle",
    "delivery.stuart_config": "Stuart yapılandırması",
    "Stuart Configs": "Stuart yapılandırması",
    "delivery.shipping_configs": "Kargo / hizmet yapılandırmaları",
    "Service / Shipping Configs": "Kargo / hizmet yapılandırmaları",
    "delivery.settings": "Ayarlar",
    "delivery.preview": "Önizleme",
    "delivery.shipment_option": "Gönderi seçeneği",
    "Shipment Option": "Gönderi seçeneği",
    "delivery.name": "Ad",
    "delivery.enter_name": "Ad girin",
    "delivery.note": "Not",
    "delivery.enter_note": "Not girin",
    "delivery.note_tooltip_title": "Not",
    "delivery.note_tooltip_description": "Bu kargo veya hizmet seçeneğini açıklamak için isteğe bağlı not ekleyin.",
    "Add an optional note to explain this shipping or service option.": "Bu kargo veya hizmet seçeneğini açıklamak için isteğe bağlı not ekleyin.",
    "delivery.order": "Sıra",
    "delivery.enter_order": "Sıra girin",
    "delivery.status_hint": "Durum (Etkin değil / Etkin)",
    "delivery.default": "Varsayılan",
    "delivery.select_shipping_method": "Kargo yöntemi seçin",
    "Select shipping method": "Kargo yöntemi seçin",
    "delivery.select_extension": "Uzantı seçin",
    "Select extension": "Uzantı seçin",
    "delivery.add_photo": "Fotoğraf ekle",
    "delivery.config.flat_shipping_fee.title": "Sabit kargo ücreti",
    "Flat Shipping Fee": "Sabit kargo ücreti",
    "delivery.config.flat_shipping_fee.placeholder": "Sabit kargo ücretini girin",
    "Enter flat shipping fee": "Sabit kargo ücretini girin",
    "delivery.config.schedule_time.title": "Planlanan saat",
    "delivery.config.fulfillment_by_platform_enabled.title": "Platform tarafından karşılama",
    "Fulfillment by platform": "Platform tarafından karşılama",
    "delivery.config.fulfilled_by_platform_icon_path.title": "Platform teslimat simgesi",
    "Fulfillment by Platform Icon": "Platform teslimat simgesi",
    "delivery.config.fulfilled_by_seller_icon_path.title": "Satıcı teslimat simgesi",
    "Seller Delivery Icon": "Satıcı teslimat simgesi",
    "delivery.phone_number": "Telefon numarası",
    "Phone number": "Telefon numarası",
    "delivery.enter_phone_number": "Telefon numarasını girin",
    "Enter phone number": "Telefon numarasını girin",
    "delivery.address_line_1": "Adres satırı 1",
    "Address line 1": "Adres satırı 1",
    "delivery.enter_address_line_1": "Adres satırı 1’i girin",
    "Enter address line 1": "Adres satırı 1’i girin",
    "delivery.address_line_2": "Adres satırı 2",
    "Address line 2": "Adres satırı 2",
    "delivery.enter_address_line_2": "Adres satırı 2’yi girin",
    "Enter address line 2": "Adres satırı 2’yi girin",
    "delivery.landmark": "Tarif",
    "Landmark": "Tarif",
    "delivery.enter_landmark": "Tarif girin",
    "Enter landmark": "Tarif girin",
    "delivery.state": "Eyalet",
    "delivery.enter_state": "Eyaleti girin",
    "Enter state": "Eyaleti girin",
    "delivery.post_code": "Posta kodu",
    "Post code": "Posta kodu",
    "delivery.enter_post_code": "Posta kodunu girin",
    "Enter post code": "Posta kodunu girin",
    "delivery.country": "Ülke",
    "delivery.enter_country": "Ülkeyi girin",
    "Enter country": "Ülkeyi girin",
    "delivery.required_information": "Lütfen gerekli bilgileri doldurun",
    "Please fill the required information": "Lütfen gerekli bilgileri doldurun",
    "delivery.saved_successfully": "Başarıyla yüklendi",
    "delivery.storage_hub.title": "Depolama merkezi noktaları",
    "Storage Hub Points": "Depolama merkezi noktaları",
    "delivery.storage_hub.add": "Depolama merkezi ekle",
    "Add Storage Hub": "Depolama merkezi ekle",
    "delivery.storage_hub.edit": "Depolama merkezini düzenle",
    "Edit Storage Hub": "Depolama merkezini düzenle",
    "delivery.storage_hub.delete_confirm": "Bu depolama merkezi silinsin mi?",
    "Do you want to delete this storage hub point?": "Bu depolama merkezi silinsin mi?",
    "delivery.storage_hub.table_name": "Ad",
    "delivery.storage_hub.table_phone": "Telefon",
    "delivery.storage_hub.table_address": "Adres",
    "delivery.storage_hub.table_landmark": "Tarif",
    "delivery.storage_hub.table_state": "Eyalet",
    "delivery.storage_hub.table_post_code": "Posta kodu",
    "Post Code": "Posta kodu",
    "delivery.storage_hub.table_country": "Ülke",
    "delivery.storage_hub.table_action": "İşlem",
    "delivery.select_environment": "Ortam seçin",
    "Select environment": "Ortam seçin",
    "delivery.environment_sandbox": "Sandbox",
    "Sandbox": "Sandbox",
    "delivery.environment_production": "Üretim",
    "Production": "Üretim",
    "delivery.stuart.client_id": "İstemci kimliği",
    "delivery.stuart.enter_client_id": "İstemci kimliğini girin",
    "delivery.stuart.client_secret": "İstemci gizli anahtarı",
    "Client Secret": "İstemci gizli anahtarı",
    "delivery.stuart.enter_client_secret": "İstemci gizli anahtarını girin",
    "Enter client secret": "İstemci gizli anahtarını girin",
    "delivery.stuart.webhook_key": "Webhook kimlik doğrulama anahtarı",
    "Webhook Authentication Key": "Webhook kimlik doğrulama anahtarı",
    "delivery.stuart.enter_webhook_key": "Webhook kimlik doğrulama anahtarını girin",
    "Enter webhook authentication key": "Webhook kimlik doğrulama anahtarını girin",
    "delivery.sendcloud.public_key": "Genel anahtar",
    "Public Key": "Genel anahtar",
    "delivery.sendcloud.enter_public_key": "API anahtarını girin",
    "delivery.sendcloud.secret_key": "Gizli anahtar",
    "delivery.sendcloud.enter_secret_key": "Bildirim gizli anahtarını girin",
    "Enter notification secret": "Bildirim gizli anahtarını girin",
    "delivery.sendcloud.default_shipping_address": "Varsayılan kargo adresi",
    "Default Shipping Address": "Varsayılan kargo adresi",
    "delivery.sendcloud.add_new": "+ Yeni ekle",
    "+ Add New": "+ Yeni ekle",
    "delivery.sendcloud.country_id": "Kimlik",
    "ID": "Kimlik",
    "payments.title": "Ödeme yöntemleri",
    "Payment Methods": "Ödeme yöntemleri",
    "payments.add": "Ödeme yöntemi ekle",
    "Add Payment Method": "Ödeme yöntemi ekle",
    "payments.edit": "Ödeme yöntemini düzenle",
    "Edit Payment Method": "Ödeme yöntemini düzenle",
    "payments.delete_confirm": "Bu ödeme yöntemi silinsin mi?",
    "Do you want to delete this payment method?": "Bu ödeme yöntemi silinsin mi?",
    "payments.save_continue": "Kaydet ve devam et",
    "Save and continue": "Kaydet ve devam et",
    "payments.translate": "Ödeme yöntemlerini çevir",
    "Translate Payments": "Ödeme yöntemlerini çevir",
    "payments.config": "Yapılandırma",
    "payments.integration_settings": "Entegrasyon ayarları",
    "Integration Settings": "Entegrasyon ayarları",
    "payments.opp_integration": "OPP entegrasyonu",
    "OPP Integration": "OPP entegrasyonu",
    "payments.billplz_integration": "BillPlz entegrasyonu",
    "BillPlz Integration": "BillPlz entegrasyonu",
    "payments.stripe_integration": "Stripe entegrasyonu",
    "Stripe Integration": "Stripe entegrasyonu",
    "payments.stripe_web_integration": "Stripe Web entegrasyonu",
    "Stripe Web Integration": "Stripe Web entegrasyonu",
    "payments.pawapay_integration": "PawaPay entegrasyonu",
    "PawaPay Integration": "PawaPay entegrasyonu",
    "payments.korapay_integration": "KoraPay entegrasyonu",
    "KoraPay Integration": "KoraPay entegrasyonu",
    "payments.flutterwave_integration": "Flutterwave entegrasyonu",
    "Flutterwave Integration": "Flutterwave entegrasyonu",
    "payments.commercepay_integration": "CommercePay entegrasyonu",
    "CommercePay Integration": "CommercePay entegrasyonu",
    "payments.checkout_com_integration": "Checkout.com entegrasyonu",
    "Checkout.com Integration": "Checkout.com entegrasyonu",
    "payments.paystack_integration": "PayStack entegrasyonu",
    "PayStack Integration": "PayStack entegrasyonu",
    "payments.razorpay_settings": "Razorpay ayarları",
    "Razorpay settings": "Razorpay ayarları",
    "payments.paydunya_settings": "Pay Dunya ayarları",
    "Pay Dunya settings": "Pay Dunya ayarları",
    "payments.mangopay_settings": "MangoPay ayarları",
    "MangoPay settings": "MangoPay ayarları",
    "payments.payu_latam_integration": "PayU LATAM entegrasyonu",
    "PayU LATAM Integration": "PayU LATAM entegrasyonu",
    "payments.table_name": "Ad",
    "payments.table_actions": "İşlemler",
    "payments.table_min_amount": "En düşük tutar",
    "Minimum Amount": "En düşük tutar",
    "payments.table_max_amount": "En yüksek tutar",
    "Maximum Amount": "En yüksek tutar",
    "payments.table_default": "Varsayılan",
    "payments.table_order_by": "Sıra",
    "payments.table_status": "Durum",
    "payments.yes": "Evet",
    "payments.no": "Hayır",
    "payments.active": "Etkin",
    "payments.inactive": "Etkin değil",
    "payments.settings": "Ayarlar",
    "payments.not_available": "Yok",
    "payments.step_select_type": "Tür seçin",
    "payments.step_configure": "Yapılandır",
    "Configure": "Yapılandır",
    "payments.step_integration": "Entegrasyon",
    "Integration": "Entegrasyon",
    "payments.next": "İleri →",
    "Next →": "İleri →",
    "payments.save": "Kaydet",
    "payments.choose_method": "Yapılandırılacak ödeme yöntemini seçin",
    "Choose a payment method to configure": "Yapılandırılacak ödeme yöntemini seçin",
    "payments.name": "Ad",
    "payments.enter_name": "Ad girin",
    "payments.maximum_amount": "En yüksek tutar",
    "payments.enter_maximum_amount": "En yüksek tutarı girin",
    "payments.minimum_amount": "En düşük tutar",
    "payments.enter_minimum_amount": "En düşük tutarı girin",
    "payments.note": "Not",
    "payments.enter_note": "Not girin",
    "payments.note_tooltip": "Ödeme sırasında müşteriler için isteğe bağlı not ekleyin.",
    "Add an optional note for customers at checkout.": "Ödeme sırasında müşteriler için isteğe bağlı not ekleyin.",
    "payments.order": "Sıra",
    "payments.enter_order": "Sıra girin",
    "payments.default": "Varsayılan",
    "payments.config_title": "Ödeme yöntemleri yapılandırması",
    "Payment Methods Configuration": "Ödeme yöntemleri yapılandırması",
    "payments.wallet_enable": "Cüzdanı etkinleştir",
    "Wallet enabled": "Cüzdanı etkinleştir",
    "payments.account_type": "Hesap türü",
    "payments.select_account_type": "Hesap türü seçin",
    "Select account type": "Hesap türü seçin",
    "payments.connect_message_standard": "Standard bağlantı mesajı",
    "Connect message standard": "Standard bağlantı mesajı",
    "payments.enter_connect_message_standard": "Standard bağlantı mesajını girin",
    "Enter connect message standard": "Standard bağlantı mesajını girin",
    "payments.disconnect_message_standard": "Standard bağlantı kesme mesajı",
    "Disconnect message standard": "Standard bağlantı kesme mesajı",
    "payments.enter_disconnect_message_standard": "Standard bağlantı kesme mesajını girin",
    "Enter disconnect message standard": "Standard bağlantı kesme mesajını girin",
    "payments.connect_message_express": "Express bağlantı mesajı",
    "Connect message express": "Express bağlantı mesajı",
    "payments.enter_connect_message_express": "Express bağlantı mesajını girin",
    "Enter connect message express": "Express bağlantı mesajını girin",
    "payments.disconnect_message_express": "Express bağlantı kesme mesajı",
    "Disconnect message express": "Express bağlantı kesme mesajı",
    "payments.enter_disconnect_message_express": "Express bağlantı kesme mesajını girin",
    "Enter disconnect message express": "Express bağlantı kesme mesajını girin",
    "payments.enable_sandbox": "Sandbox’ı etkinleştir",
    "Enable sandbox": "Sandbox’ı etkinleştir",
    "payments.api_token": "API belirteci",
    "API Token": "API belirteci",
    "payments.enter_token": "Belirteci girin",
    "Enter token": "Belirteci girin",
    "payments.key_id": "Anahtar kimliği",
    "Key ID": "Anahtar kimliği",
    "payments.enter_key_id": "Anahtar kimliğini girin",
    "Enter key ID": "Anahtar kimliğini girin",
    "payments.key_secret": "Anahtar gizlisi",
    "Key Secret": "Anahtar gizlisi",
    "payments.enter_secret_key": "Gizli anahtarı girin",
    "Enter secret key": "Gizli anahtarı girin",
    "payments.webhook_secret_key": "Webhook gizli anahtarı",
    "Webhook Secret Key": "Webhook gizli anahtarı",
    "payments.enter_webhook_secret_key": "Webhook gizli anahtarını girin",
    "Enter webhook secret key": "Webhook gizli anahtarını girin",
    "payments.master_key": "Ana anahtar",
    "Master Key": "Ana anahtar",
    "payments.public_key": "Genel anahtar",
    "payments.enter_public_key": "Genel anahtarı girin",
    "Enter public key": "Genel anahtarı girin",
    "payments.private_key": "Özel anahtar",
    "Private Key": "Özel anahtar",
    "payments.merchant_id": "Satıcı kimliği",
    "Merchant ID": "Satıcı kimliği",
    "payments.enter_merchant_id": "Satıcı kimliğini girin",
    "Enter merchant id": "Satıcı kimliğini girin",
    "payments.processing_channel_id": "İşlem kanalı kimliği",
    "Processing channel ID": "İşlem kanalı kimliği",
    "payments.enter_processing_channel_id": "İşlem kanalı kimliğini girin",
    "Enter processing channel id": "İşlem kanalı kimliğini girin",
    "payments.api_key": "API anahtarı",
    "payments.x_signature_key": "X imza anahtarı",
    "X Signature Key": "X imza anahtarı",
    "payments.account_id": "Hesap kimliği",
    "payments.login_api_key": "Giriş API anahtarı",
    "Login API key": "Giriş API anahtarı",
    "payments.client_id": "İstemci kimliği",
    "payments.client_api_key": "İstemci API anahtarı",
    "Client API Key": "İstemci API anahtarı",
    "payments.payin_fee": "PayIn ücreti (%)",
    "PayIn fee (%)": "PayIn ücreti (%)",
    "payments.withdraw_fee": "Para çekme ücreti (%)",
    "Withdraw fee (%)": "Para çekme ücreti (%)",
    "payments.enter_api_key": "API anahtarını girin",
    "payments.enter_account_id": "Hesap kimliğini girin",
    "Enter account ID": "Hesap kimliğini girin",
    "payments.enter_login_api_key": "Giriş API anahtarını girin",
    "Enter login API key": "Giriş API anahtarını girin",
    "payments.enter_notification_secret": "Bildirim gizli anahtarını girin",
    "payments.enter_payin_fee": "Ücreti yüzde olarak girin",
    "Enter fee as a percentage": "Ücreti yüzde olarak girin",
    "payments.secret_key": "Gizli anahtar",
    "Secret key": "Gizli anahtar",
    "payments.publishable_key": "Yayınlanabilir anahtar",
    "Publishable key": "Yayınlanabilir anahtar",
    "payments.webhook_secret": "Webhook gizli anahtarı",
    "Webhook secret": "Webhook gizli anahtarı",
    "payments.enter_webhook_secret": "Webhook gizli anahtarını girin",
    "Enter webhook secret": "Webhook gizli anahtarını girin",
    "payments.enter_subscription_webhook_secret": "Abonelik webhook gizli anahtarını girin",
    "Enter subscription webhook secret": "Abonelik webhook gizli anahtarını girin",
    "payments.connect_client_id": "Connect istemci kimliği",
    "Connect client ID": "Connect istemci kimliği",
    "payments.enter_connect_client_id": "Connect istemci kimliğini girin",
    "Enter Connect client ID": "Connect istemci kimliğini girin",
    "payments.stripe_reminders": "Stripe hatırlatıcıları",
    "Stripe reminders": "Stripe hatırlatıcıları",
    "payments.stripe_sync_help": "Eşitleme, gizli anahtarınızı Stripe ile doğrular, hesap bilgilerini doldurur ve Tradly’nin ihtiyaç duyduğu webhook uç noktalarını oluşturur. Webhook gizli anahtarları otomatik doldurulur; bitince formu kaydedin.",
    "Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.": "Eşitleme, gizli anahtarınızı Stripe ile doğrular, hesap bilgilerini doldurur ve Tradly’nin ihtiyaç duyduğu webhook uç noktalarını oluşturur. Webhook gizli anahtarları otomatik doldurulur; bitince formu kaydedin.",
    "payments.find_in_stripe": "Stripe Kontrol Paneli’nde bul",
    "Find in Stripe Dashboard": "Stripe Kontrol Paneli’nde bul",
    "payments.description": "Açıklama",
    "payments.learn_more_stripe": "Stripe Payments hakkında daha fazla bilgi",
    "Learn more about Stripe Payments": "Stripe Payments hakkında daha fazla bilgi",
    "payments.learn_more_stripe_connect": "Pazaryerleri için Stripe Connect hakkında daha fazla bilgi",
    "Learn more about Stripe Connect for marketplaces": "Pazaryerleri için Stripe Connect hakkında daha fazla bilgi",
    "payments.token": "Belirteç",
    "Token": "Belirteç",
    "payments.payment_options": "Ödeme seçenekleri",
    "Payment options": "Ödeme seçenekleri",
    "payments.enable_integration": "Entegrasyonu etkinleştir",
    "Enable integration": "Entegrasyonu etkinleştir",
    "payments.enter_provider_id": "{provider} kimliğini girin",
    "Enter {provider} ID": "{provider} kimliğini girin",
    "payments.integration_status_help": "Bu sağlayıcıyı ayarlarından yapılandırın.",
    "Configure this provider in its settings.": "Bu sağlayıcıyı ayarlarından yapılandırın.",
    "listings.title": "İlanlar",
    "listings.manage": "Yönet",
    "listings.show_rows": "Satırları göster",
    "listings.clear": "Temizle",
    "listings.apply": "Uygula",
    "listings.select_date": "Tarih seçin",
    "Select date": "Tarih seçin",
    "listings.start_date": "Başlangıç tarihi",
    "listings.end_date": "Bitiş tarihi",
    "listings.status_types": "Durum türleri",
    "Status types": "Durum türleri",
    "listings.categories": "Kategoriler",
    "listings.attributes": "Özellikler",
    "listings.clear_all_filters": "Tüm filtreleri temizle",
    "Clear all filters": "Tüm filtreleri temizle",
    "listings.import": "İçe aktar",
    "listings.export": "Dışa aktar",
    "listings.smart_upload": "Akıllı yükleme (Beta)",
    "Smart Upload (Beta)": "Akıllı yükleme (Beta)",
    "listings.filter_listings": "İlanları filtrele",
    "Filter listings": "İlanları filtrele",
    "listings.sort_listings": "İlanları sırala",
    "Sort listings": "İlanları sırala",
    "listings.import_listings": "İlanları içe aktar",
    "Import listings": "İlanları içe aktar",
    "listings.export_listings": "İlanları dışa aktar",
    "Export listings": "İlanları dışa aktar",
    "listings.list_view": "Liste görünümü",
    "listings.grid_view": "Izgara görünümü",
    "listings.map_view": "Harita görünümü",
    "listings.board_view": "Pano görünümü",
    "listings.export_all_title": "Tüm ilanlar dışa aktarılsın mı?",
    "Export all listings?": "Tüm ilanlar dışa aktarılsın mı?",
    "listings.export_all_message": "Tüm ilanları içeren bir dosya hazırlanacak. Devam edilsin mi?",
    "This will prepare a file containing all listings. Do you want to continue?": "Tüm ilanları içeren bir dosya hazırlanacak. Devam edilsin mi?",
    "listings.export_all": "Tüm ilanları dışa aktar",
    "Export all listings": "Tüm ilanları dışa aktar",
    "listings.cancel": "İptal",
    "listings.status_all": "Tümü",
    "listings.status_pending": "Bekliyor",
    "listings.status_approved": "Onaylandı",
    "listings.status_rejected": "Reddedildi",
    "listings.status_archived": "Arşivlendi",
    "Archived": "Arşivlendi",
    "listings.sort_newest_first": "Önce en yeni",
    "Newest first": "Önce en yeni",
    "listings.sort_price_high_to_low": "Fiyat: yüksekten düşüğe",
    "Price: high to low": "Fiyat: yüksekten düşüğe",
    "listings.sort_price_low_to_high": "Fiyat: düşükten yükseğe",
    "Price: low to high": "Fiyat: düşükten yükseğe",
    "listings.header_0": "Başlık",
    "listings.header_1": "Web sitesi",
    "Website": "Web sitesi",
    "listings.header_2": "Liste fiyatı",
    "List price": "Liste fiyatı",
    "listings.header_3": "Teklif yüzdesi",
    "listings.header_4": "Görsel",
    "listings.header_5": "Teklif fiyatı",
    "Offer price": "Teklif fiyatı",
    "listings.header_6": "Durum",
    "listings.header_7": "İlan kimliği",
    "listings.header_8": "İlan durumu",
    "Listing status": "İlan durumu",
    "listings.header_9": "Hesaplar",
    "listings.header_10": "Para birimi",
    "listings.header_11": "Satıldı",
    "Sold": "Satıldı",
    "listings.header_12": "Hedef tutar",
    "Goal amount": "Hedef tutar",
    "listings.filter_status": "Durum",
    "listings.filter_price": "Fiyat",
    "listings.filter_category": "Kategori",
    "listings.filter_clear_all": "Tüm filtreleri temizle",
    "listings.status_count": "Durum ({count})",
    "Status ({count})": "Durum ({count})",
    "listings.price_count": "Fiyat ({count})",
    "Price ({count})": "Fiyat ({count})",
    "listings.category_count": "Kategori ({count})",
    "Category ({count})": "Kategori ({count})",
    "listings.search": "İlan ara",
    "listings.clear_search": "İlan aramasını temizle",
    "Clear listing search": "İlan aramasını temizle",
    "listings.active": "Etkin",
    "listings.inactive": "Etkin değil",
    "listings.approve": "Onayla",
    "listings.reject": "Reddet",
    "listings.delete_confirm": "Bu ilan silinsin mi?",
    "listings.approve_confirm": "Bu ilan onaylansın mı?",
    "Do you want to approve this listing?": "Bu ilan onaylansın mı?",
    "listings.reject_confirm": "Bu ilan reddedilsin mi?",
    "Do you want to reject this listing?": "Bu ilan reddedilsin mi?",
    "listings.yes": "Evet",
    "listings.no": "Hayır",
    "listings.confirm_delete": "Bu ilan silinsin mi?",
    "listings.confirm_approve": "Bu ilan onaylansın mı?",
    "listings.confirm_reject": "Bu ilan reddedilsin mi?",
    "listings.column.actions": "İşlemler",
    "listings.audio_episode": "Ses bölümü",
    "Audio episode": "Ses bölümü",
    "listings.video": "Video",
    "listings.seller": "Satıcı",
    "listings.rating": "Puan",
    "listings.followers": "Takipçiler",
    "listings.view_seller_account": "Satıcı hesabını görüntüle",
    "View seller account": "Satıcı hesabını görüntüle",
    "listings.add_variant": "Varyant ekle",
    "Add variant": "Varyant ekle",
    "listings.edit": "Düzenle",
    "listings.preview": "Önizleme",
    "listings.share": "Paylaş",
    "listings.view_listing": "İlanı görüntüle",
    "View listing": "İlanı görüntüle",
    "listings.stock": "Stok",
    "Stock": "Stok",
    "listings.variants": "Varyantlar",
    "listings.campaign": "Kampanya",
    "Campaign": "Kampanya",
    "listings.rental_details": "Kiralama ayrıntıları",
    "Rental details": "Kiralama ayrıntıları",
    "listings.copy": "Kopyala",
    "listings.inventory": "Envanter",
    "listings.order_type": "Sipariş türü",
    "Order type": "Sipariş türü",
    "listings.stock_by_location": "Konuma göre stok",
    "Stock by location": "Konuma göre stok",
    "listings.loading_location_stock": "Konum stokları yükleniyor…",
    "Loading location stock…": "Konum stokları yükleniyor…",
    "listings.no_location_stock": "Bir konuma atanmış stok yok.",
    "No stock assigned to a location.": "Bir konuma atanmış stok yok.",
    "listings.page_analytics": "Sayfa analizi",
    "Page analytics": "Sayfa analizi",
    "listings.loading": "Yükleniyor…",
    "listings.analytics_key_missing": "Bu kiracı için analiz API anahtarı yapılandırılmamış.",
    "Analytics API key is not configured for this tenant.": "Bu kiracı için analiz API anahtarı yapılandırılmamış.",
    "listings.no_slug": "Bu ilan için kısa ad yok.",
    "No slug is available for this listing.": "Bu ilan için kısa ad yok.",
    "listings.no_analytics": "Henüz analiz yüklenmedi.",
    "listings.load_analytics": "Analizi yükle",
    "Load analytics": "Analizi yükle",
    "listings.no_orders": "Bu ilan için henüz sipariş yok",
    "No orders yet for this listing": "Bu ilan için henüz sipariş yok",
    "listings.social_ratings": "Sosyal ve puanlar",
    "Social and ratings": "Sosyal ve puanlar",
    "listings.tags": "Etiketler",
    "listings.schedule": "Program",
    "listings.detail": "Ayrıntılar",
    "listings.update_stock": "Stoku güncelle",
    "Update stock": "Stoku güncelle",
    "listings.new_stock_quantity": "Yeni stok miktarı",
    "New stock quantity": "Yeni stok miktarı",
    "listings.location": "Konum",
    "listings.quantity": "Miktar",
    "listings.current_stock": "Mevcut stok: {quantity}",
    "Current stock: {quantity}": "Mevcut stok: {quantity}",
    "listings.loading_rental": "Kiralama ayarları yükleniyor…",
    "Loading rental settings…": "Kiralama ayarları yükleniyor…",
    "payments.enter_publishable_key": "Yayınlanabilir anahtarı girin",
    "Enter publishable key": "Yayınlanabilir anahtarı girin",
    "listings.add_listing": "İlan ekle",
    "Add listing": "İlan ekle",
    "listings.edit_listing": "İlanı düzenle",
    "Edit listing": "İlanı düzenle",
    "listings.enter_title": "Başlık girin",
    "listings.account": "Hesap",
    "listings.list_price": "Liste fiyatı",
    "listings.enter_list_price": "Liste fiyatını girin",
    "Enter list price": "Liste fiyatını girin",
    "listings.select_currency": "Para birimi seç",
    "Select currency": "Para birimi seç",
    "listings.select_category": "Kategori seçin",
    "listings.select_categories": "Kategorileri seç",
    "Select categories": "Kategorileri seç",
    "listings.add_category": "+ Kategori ekle",
    "+ Add category": "+ Kategori ekle",
    "listings.add_attribute": "Özellik ekle",
    "Add attribute": "Özellik ekle",
    "listings.enter_stock": "Stok girin",
    "listings.offer_percentage": "Teklif yüzdesi",
    "Offer percentage": "Teklif yüzdesi",
    "listings.enter_offer": "Teklif girin",
    "Enter offer": "Teklif girin",
    "listings.max_quantity_optional": "En fazla miktar (isteğe bağlı)",
    "Max quantity (optional)": "En fazla miktar (isteğe bağlı)",
    "listings.enter_max_quantity": "En fazla miktarı girin",
    "Enter max quantity": "En fazla miktarı girin",
    "listings.enter_slug": "Kısa adı girin",
    "listings.enter_meta_title": "Meta başlığı girin",
    "listings.repeat": "Tekrarla",
    "Repeat": "Tekrarla",
    "listings.start_time": "Başlangıç saati",
    "Start time": "Başlangıç saati",
    "listings.end_time": "Bitiş saati",
    "End time": "Bitiş saati",
    "listings.slot": "Zaman aralığı",
    "Slot": "Zaman aralığı",
    "listings.starts_from": "Başlangıç:",
    "Starts from:": "Başlangıç:",
    "listings.add_schedule": "+ Program ekle",
    "+ Add schedule": "+ Program ekle",
    "listings.upload_here": "Buraya yükleyin",
    "listings.save": "Kaydet",
    "listings.update": "Güncelle",
    "listings.tax": "Vergi",
    "listings.title_required": "Lütfen başlık girin",
    "listings.select_tax": "Vergi seçin",
    "Please select a tax": "Vergi seçin",
    "listings.select_item": "{item} seçin",
    "Please select {item}": "{item} seçin",
    "listings.offer_percentage_validation": "Teklif yüzdesi 0 ile 100 arasında olmalıdır",
    "Offer percentage must be between 0 and 100": "Teklif yüzdesi 0 ile 100 arasında olmalıdır",
    "listings.custom_seo": "Özel SEO",
    "Custom SEO": "Özel SEO",
    "listings.select_value": "Değer seçin",
    "Select value": "Değer seçin",
    "listings.add_schedule_title": "Program ekle",
    "Add schedule": "Program ekle",
    "listings.select_from_media": "Medyadan seç",
    "listing_form.create_listing": "İlan oluştur",
    "Create listing": "İlan oluştur",
    "listing_form.update_listing": "İlanı güncelle",
    "Update listing": "İlanı güncelle",
    "listing_form.saving": "Kaydediliyor…",
    "listing_form.main_information": "Temel bilgiler",
    "Main information": "Temel bilgiler",
    "listing_form.audio_listing": "Ses ilanı",
    "Audio listing": "Ses ilanı",
    "listing_form.basic_information": "Temel bilgiler",
    "Basic information": "Temel bilgiler",
    "listing_form.listing_type": "İlan türü",
    "Listing type": "İlan türü",
    "listing_form.title": "Başlık",
    "listing_form.enter_listing_title": "İlan başlığını girin",
    "Enter listing title": "İlan başlığını girin",
    "listing_form.description": "Açıklama",
    "listing_form.enter_detailed_description": "Ayrıntılı açıklama girin",
    "Enter detailed description": "Ayrıntılı açıklama girin",
    "listing_form.tags": "Etiketler",
    "listing_form.tag_example": "ör. elektronik, cihazlar, yeni",
    "e.g., electronics, gadgets, new": "ör. elektronik, cihazlar, yeni",
    "listing_form.taxes": "Vergiler",
    "listing_form.optional": "İsteğe bağlı",
    "listing_form.start_date": "Başlangıç tarihi",
    "listing_form.end_date": "Bitiş tarihi",
    "listing_form.currency": "Para birimi",
    "listing_form.select_currency": "Para birimi seç",
    "listing_form.goal_price": "Hedef fiyat",
    "Goal price": "Hedef fiyat",
    "listing_form.set_fundraising_goal": "Bağış toplama hedefinizi belirleyin",
    "Set your fundraising goal": "Bağış toplama hedefinizi belirleyin",
    "listing_form.pricing": "Fiyatlandırma",
    "Pricing": "Fiyatlandırma",
    "listing_form.select": "Seç",
    "listing_form.price": "Fiyat",
    "listing_form.offer_percent": "Teklif %",
    "Offer %": "Teklif %",
    "listing_form.listing_price": "İlan fiyatı:",
    "Listing price:": "İlan fiyatı:",
    "listing_form.set_fundraising_goal_amount": "Bağış toplama hedef tutarını belirleyin",
    "Set your fundraising goal amount": "Bağış toplama hedef tutarını belirleyin",
    "listing_form.category": "Kategori",
    "listing_form.select_a_category": "Kategori seçin",
    "listing_form.clear_selected_category": "Seçili kategoriyi temizle",
    "Clear selected category": "Seçili kategoriyi temizle",
    "listing_form.create_new_category": "Yeni kategori oluştur",
    "Create a new category": "Yeni kategori oluştur",
    "listing_form.search_categories": "Kategori ara…",
    "Search categories…": "Kategori ara…",
    "listing_form.no_categories_match": "Kategori bulunamadı",
    "No categories found": "Kategori bulunamadı",
    "listing_form.draft_found": "Kaydedilmiş taslak bulundu.",
    "A saved draft was found.": "Kaydedilmiş taslak bulundu.",
    "listing_form.restore": "Geri yükle",
    "Restore": "Geri yükle",
    "listing_form.discard": "Vazgeç",
    "listing_form.characters": "karakter",
    "characters": "karakter",
    "listing_form.zero_amount": "0,00",
    "0.00": "0,00",
    "listing_form.zero": "0",
    "listing_form.type_listings": "Fiziksel ürünler",
    "Physical products": "Fiziksel ürünler",
    "listing_form.type_events": "Etkinlikler",
    "Events": "Etkinlikler",
    "listing_form.type_digital": "Dijital ürünler",
    "Digital products": "Dijital ürünler",
    "listing_form.type_appointments": "Randevular",
    "Appointments": "Randevular",
    "listing_form.type_rentals": "Kiralamalar",
    "listing_form.type_donation": "Kitlesel fonlama",
    "Crowdfunding": "Kitlesel fonlama",
    "listing_form.type_information_listing": "Bilgi",
    "Information": "Bilgi",
    "listing_form.type_video_listing": "Video",
    "listing_form.type_audio_listing": "Ses",
    "listing_form.select_taxes": "Vergileri seçin (isteğe bağlı)",
    "Select taxes (optional)": "Vergileri seçin (isteğe bağlı)",
    "listing_form.no_taxes": "Kullanılabilir vergi yok",
    "No taxes available": "Kullanılabilir vergi yok",
    "listing_form.inventory_shipping": "Envanter ve kargo",
    "Inventory & shipping": "Envanter ve kargo",
    "listing_form.stock": "Stok",
    "listing_form.weight": "Ağırlık",
    "Weight": "Ağırlık",
    "listing_form.dimensions": "Boyutlar (U×G×Y)",
    "Dimensions (L×W×H)": "Boyutlar (U×G×Y)",
    "listing_form.sku": "SKU",
    "listing_form.barcode": "Barkod",
    "Barcode": "Barkod",
    "listing_form.length": "Uzunluk",
    "Length": "Uzunluk",
    "listing_form.width": "Genişlik",
    "Width": "Genişlik",
    "listing_form.height": "Yükseklik",
    "Height": "Yükseklik",
    "listing_form.seo_settings": "SEO ayarları",
    "SEO settings": "SEO ayarları",
    "listing_form.slug": "Kısa ad",
    "listing_form.url_friendly_title": "URL uyumlu başlık",
    "URL-friendly version of the title": "URL uyumlu başlık",
    "listing_form.meta_title": "Meta başlık",
    "listing_form.recommended_meta_title": "Önerilen: 50–60 karakter",
    "Recommended: 50–60 chars": "Önerilen: 50–60 karakter",
    "listing_form.meta_keywords": "Meta anahtar kelimeleri",
    "Meta keywords": "Meta anahtar kelimeleri",
    "listing_form.separate_with_commas": "Virgülle ayırın",
    "Separate with commas": "Virgülle ayırın",
    "listing_form.meta_description": "Meta açıklama",
    "listing_form.recommended_meta_description": "Önerilen: 150–160 karakter",
    "Recommended: 150–160 chars": "Önerilen: 150–160 karakter",
    "listing_form.hide": "Gizle",
    "listing_form.show": "Göster",
    "listing_form.seo_fields": "arama motoru optimizasyonu alanları",
    "search engine optimization fields": "arama motoru optimizasyonu alanları",
    "listing_form.auto_generated_slug": "Başlıktan otomatik oluşturulur",
    "Auto-generated from title": "Başlıktan otomatik oluşturulur",
    "listing_form.seo_title_optional": "SEO başlığı (isteğe bağlı)",
    "SEO title (optional)": "SEO başlığı (isteğe bağlı)",
    "listing_form.keywords_comma_separated": "Anahtar kelimeleri virgülle ayırın",
    "Keywords separated by commas": "Anahtar kelimeleri virgülle ayırın",
    "listing_form.search_description_optional": "Arama sonuçları için kısa açıklama (isteğe bağlı)",
    "Brief description for search results (optional)": "Arama sonuçları için kısa açıklama (isteğe bağlı)",
    "listing_form.account": "Hesap",
    "listing_form.loading_accounts": "Hesaplar yükleniyor…",
    "Loading accounts…": "Hesaplar yükleniyor…",
    "listing_form.clear_selected_account": "Seçili hesabı temizle",
    "Clear selected account": "Seçili hesabı temizle",
    "listing_form.search_accounts": "Hesap ara…",
    "Search accounts…": "Hesap ara…",
    "listing_form.create_account": "Yeni hesap oluştur",
    "Create a new account": "Yeni hesap oluştur",
    "listing_form.no_accounts_found": "Hesap bulunamadı",
    "No accounts found": "Hesap bulunamadı",
    "listing_form.rental_settings": "Kiralama ayarları",
    "Rental settings": "Kiralama ayarları",
    "listing_form.rental_price_help": "İlan fiyatı kiralama ücreti ve süresine göre hesaplanır.",
    "The listing price is calculated from the rental rate and duration.": "İlan fiyatı kiralama ücreti ve süresine göre hesaplanır.",
    "listing_form.rate_unit": "Ücret birimi",
    "Rate unit": "Ücret birimi",
    "listing_form.hour": "Saat",
    "Hour": "Saat",
    "listing_form.day": "Gün",
    "listing_form.week": "Hafta",
    "listing_form.rental_rate_amount": "Kiralama ücreti",
    "Rental rate": "Kiralama ücreti",
    "listing_form.rental_min_duration": "En kısa süre",
    "Minimum duration": "En kısa süre",
    "listing_form.rental_max_duration": "En uzun süre",
    "Maximum duration": "En uzun süre",
    "listing_form.rental_buffer_time": "Ara süresi (saat)",
    "Buffer time (hours)": "Ara süresi (saat)",
    "listing_form.rental_deposit_amount": "Depozito tutarı",
    "Deposit amount": "Depozito tutarı",
    "listing_form.rental_max_units": "En fazla birim",
    "Maximum units": "En fazla birim",
    "listing_form.quick_create_title": "{entity} oluştur",
    "Create {entity}": "{entity} oluştur",
    "listing_form.close": "Kapat",
    "listing_form.account_name": "Hesap adı",
    "listing_form.category_name": "Kategori adı",
    "Category name": "Kategori adı",
    "listing_form.account_example": "ör. Acme Mağazası",
    "e.g. Acme Store": "ör. Acme Mağazası",
    "listing_form.category_example": "ör. Taze Ürünler",
    "e.g. Fresh Produce": "ör. Taze Ürünler",
    "listing_form.creating": "Oluşturuluyor…",
    "listing_form.create_entity": "{entity} oluştur",
    "listing_form.cancel": "İptal",
    "listing_form.go_back": "Geri dön",
    "Go back": "Geri dön",
    "listing_form.upgrade_plan": "Planı yükselt",
    "Upgrade plan": "Planı yükselt",
    "listing_form.close_upgrade_dialog": "Plan yükseltme penceresini kapat",
    "Close upgrade dialog": "Plan yükseltme penceresini kapat",
    "listing_form.loading_attributes": "Özellikler yükleniyor…",
    "Loading attributes…": "Özellikler yükleniyor…",
    "listing_form.no_attributes": "Bu kategoride özellik yok",
    "No attributes for this category": "Bu kategoride özellik yok",
    "listing_form.unsupported_field_type": "Desteklenmeyen alan türü",
    "Unsupported field type": "Desteklenmeyen alan türü",
    "listing_form.delete_schedule_confirm": "Bu program silinsin mi?",
    "Are you sure you want to delete this schedule?": "Bu program silinsin mi?",
    "listing_form.no_schedules_added": "Henüz program eklenmedi",
    "No schedules added yet": "Henüz program eklenmedi",
    "listing_form.stock_label": "Stok:",
    "Stock:": "Stok:",
    "listing_form.active": "Etkin",
    "listing_form.inactive": "Etkin değil",
    "listing_form.edit": "Düzenle",
    "listing_form.delete": "Sil",
    "listing_form.schedules": "Programlar",
    "Schedules": "Programlar",
    "listing_form.no_schedules_yet": "Henüz program yok",
    "No schedules yet": "Henüz program yok",
    "listing_form.dates_label": "Tarihler:",
    "Dates:": "Tarihler:",
    "listing_form.time_label": "Saat:",
    "Time:": "Saat:",
    "listing_form.repeat_label": "Tekrar:",
    "Repeat:": "Tekrar:",
    "listing_form.capacity_label": "Kapasite:",
    "Capacity:": "Kapasite:",
    "listing_form.edit_schedule": "Programı düzenle",
    "Edit schedule": "Programı düzenle",
    "listing_form.add_new_schedule": "Yeni program ekle",
    "Add new schedule": "Yeni program ekle",
    "listing_form.repeat_pattern": "Tekrarlama düzeni",
    "Repeat pattern": "Tekrarlama düzeni",
    "listing_form.select_days": "Günleri seçin",
    "Select days": "Günleri seçin",
    "listing_form.total_stocks_capacity": "Toplam stok (kapasite)",
    "Total stock (capacity)": "Toplam stok (kapasite)",
    "listing_form.select_at_least_one_day": "En az bir gün seçin",
    "Please select at least one day": "En az bir gün seçin",
    "listing_form.unlimited_capacity_help": "Sınırsız kapasite için boş bırakın",
    "Leave empty for unlimited capacity": "Sınırsız kapasite için boş bırakın",
    "listing_form.add_schedule": "+ Program ekle",
    "listing_form.schedule_number": "Program #{number}",
    "Schedule #{number}": "Program #{number}",
    "listing_form.update_action": "güncelle",
    "update": "güncelle",
    "listing_form.create_action": "oluştur",
    "create": "oluştur",
    "listing_form.a_schedule": "bir program",
    "a schedule": "bir program",
    "listing_form.daily": "Her gün",
    "listing_form.weekdays": "Hafta içi (Pzt–Cum)",
    "Weekdays (Mon - Fri)": "Hafta içi (Pzt–Cum)",
    "listing_form.weekend": "Hafta sonu (Cmt–Paz)",
    "Weekend (Sat - Sun)": "Hafta sonu (Cmt–Paz)",
    "listing_form.custom": "Özel",
    "listing_form.weekday_0": "Pazartesi",
    "Monday": "Pazartesi",
    "listing_form.weekday_1": "Salı",
    "Tuesday": "Salı",
    "listing_form.weekday_2": "Çarşamba",
    "Wednesday": "Çarşamba",
    "listing_form.weekday_3": "Perşembe",
    "Thursday": "Perşembe",
    "listing_form.weekday_4": "Cuma",
    "Friday": "Cuma",
    "listing_form.weekday_5": "Cumartesi",
    "Saturday": "Cumartesi",
    "listing_form.weekday_6": "Pazar",
    "Sunday": "Pazar",
    "listing_form.media_max_files": "En fazla {count} {type}",
    "Maximum {count} {type} allowed": "En fazla {count} {type}",
    "listing_form.video_size_limit": "Her video en fazla 1 GB olmalıdır",
    "Each video must be 1GB or smaller": "Her video en fazla 1 GB olmalıdır",
    "listing_form.videos": "Videolar",
    "Videos": "Videolar",
    "listing_form.images": "Görseller",
    "listing_form.select_from_media": "Medyadan seç",
    "listing_form.video_upload_help": "MP4, MOV, AVI, MKV veya WebM video yükleyin (her biri en fazla 1 GB)",
    "Upload videos in MP4, MOV, AVI, MKV, WebM format (max 1GB each)": "MP4, MOV, AVI, MKV veya WebM video yükleyin (her biri en fazla 1 GB)",
    "listing_form.image_upload_help": "JPG, PNG, GIF veya WebP görseller yükleyin (her biri en fazla 10 MB)",
    "Upload images in JPG, PNG, GIF, WebP format (max 10MB each)": "JPG, PNG, GIF veya WebP görseller yükleyin (her biri en fazla 10 MB)",
    "listing_form.uploading_video": "Video yükleniyor…",
    "Uploading video…": "Video yükleniyor…",
    "listing_form.audio_episode": "Ses bölümü",
    "listing_form.audio_upload_help": "RSS akışı için ses dosyası yükleyin veya herkese açık URL yapıştırın.",
    "Upload an audio file or paste a public audio URL for the RSS feed.": "RSS akışı için ses dosyası yükleyin veya herkese açık URL yapıştırın.",
    "listing_form.selected_file": "Seçildi: {name}",
    "listing_form.audio_url_help": "Dosya seçiliyse URL isteğe bağlıdır. Yüklenen dosyayı kullanmak için boş bırakın.",
    "The URL is optional when a file is selected. Leave it blank to use the uploaded file.": "Dosya seçiliyse URL isteğe bağlıdır. Yüklenen dosyayı kullanmak için boş bırakın.",
    "listing_form.audio_url_placeholder": "https://example.com/episode.mp3",
    "https://example.com/episode.mp3": "https://example.com/episode.mp3",
    "listing_form.uploading_audio": "Ses yükleniyor…",
    "Uploading audio…": "Ses yükleniyor…",
    "listing_form.validation_start_date": "Başlangıç tarihini seçin",
    "Please select start date": "Başlangıç tarihini seçin",
    "listing_form.validation_end_date": "Bitiş tarihini seçin",
    "Please select end date": "Bitiş tarihini seçin",
    "listing_form.validation_start_time": "Başlangıç saatini seçin",
    "Please select start time": "Başlangıç saatini seçin",
    "listing_form.validation_end_time": "Bitiş saatini seçin",
    "Please select end time": "Bitiş saatini seçin",
    "listing_form.weekdays_short": "Hafta içi",
    "Weekdays": "Hafta içi",
    "listing_form.weekend_short": "Hafta sonu",
    "Weekend": "Hafta sonu",
    "listing_form.click_add_schedule_help": "İlk programı oluşturmak için “{action}” düğmesine tıklayın",
    "Click \"{action}\" to create your first schedule": "İlk programı oluşturmak için “{action}” düğmesine tıklayın",
    "listing_form.schedule_form_intro": "Şunun için aşağıdaki bilgileri doldurun:",
    "Fill in the details below to": "Şunun için aşağıdaki bilgileri doldurun:",
    "listing_form.update": "Güncelle",
    "listing_form.save": "Kaydet",
    "listing_form.variant_value_required": "En az bir varyant değeri seçin (ör. Renk, Beden)",
    "Please select at least one variant value (e.g., Color, Size)": "En az bir varyant değeri seçin (ör. Renk, Beden)",
    "listing_form.valid_price_required": "Geçerli bir fiyat girin",
    "Please enter a valid price": "Geçerli bir fiyat girin",
    "listing_form.delete_variant_confirm": "Bu varyant silinsin mi?",
    "listing_form.product_variants": "Ürün varyantları",
    "Product Variants": "Ürün varyantları",
    "listing_form.add_variant": "+ Varyant ekle",
    "+ Add Variant": "+ Varyant ekle",
    "listing_form.select_all_variants": "Tüm varyantları seç",
    "Select all variants": "Tüm varyantları seç",
    "listing_form.set_quantity_selected": "Seçilenler için miktar belirle",
    "Set quantity for selected": "Seçilenler için miktar belirle",
    "listing_form.quantity": "Miktar",
    "listing_form.apply_quantity": "Miktarı uygula",
    "Apply quantity": "Miktarı uygula",
    "listing_form.select_variant_number": "{number} numaralı varyantı seçin",
    "Select variant {number}": "{number} numaralı varyantı seçin",
    "listing_form.variant_number": "Varyant #{number}",
    "Variant #{number}": "Varyant #{number}",
    "listing_form.existing": "Mevcut",
    "Existing": "Mevcut",
    "listing_form.modified": "Değiştirildi",
    "Modified": "Değiştirildi",
    "listing_form.variant_name": "Varyant adı",
    "Variant Name": "Varyant adı",
    "listing_form.variant_values": "Varyant değerleri",
    "Variant Values": "Varyant değerleri",
    "listing_form.type": "Tür",
    "listing_form.no_variant_values": "Varyant değeri yok",
    "No variant values": "Varyant değeri yok",
    "listing_form.no_variants_yet": "Henüz varyant yok",
    "No variants yet": "Henüz varyant yok",
    "listing_form.click_add_variant_help": "İlk varyantı oluşturmak için “{action}” düğmesine tıklayın",
    "Click \"{action}\" to create your first variant": "İlk varyantı oluşturmak için “{action}” düğmesine tıklayın",
    "listing_form.select_variant_type": "{type} seçin",
    "Select {type}": "{type} seçin",
    "listing_form.no_variant_types": "Kullanılabilir varyant türü yok. Önce Renk veya Beden gibi türler oluşturun.",
    "No variant types available. Please create variant types (like Color, Size) first.": "Kullanılabilir varyant türü yok. Önce Renk veya Beden gibi türler oluşturun.",
    "listing_form.generated_name": "Oluşturulan ad:",
    "Generated Name:": "Oluşturulan ad:",
    "listing_form.custom_title": "Özel başlık",
    "Custom Title": "Özel başlık",
    "listing_form.auto_generate_help": "Otomatik oluşturmak için boş bırakın",
    "Leave blank to auto-generate": "Otomatik oluşturmak için boş bırakın",
    "listing_form.save_variant": "Varyantı kaydet",
    "Save Variant": "Varyantı kaydet",
    "listing_form.start_time": "Başlangıç saati",
    "Start Time": "Başlangıç saati",
    "listing_form.end_time": "Bitiş saati",
    "End Time": "Bitiş saati",
    "listing_form.enter_capacity_limit": "Kapasite sınırını girin",
    "Enter capacity limit": "Kapasite sınırını girin",
    "collections.validation_title": "Başlık boş olamaz",
    "Title should not be empty": "Başlık boş olamaz",
    "collections.validation_platform": "En az bir platform seçin",
    "Select at least one platform": "En az bir platform seçin",
    "collections.validation_dates": "Bitiş tarihi başlangıç tarihinden sonra olmalıdır",
    "End Date must be later than start date": "Bitiş tarihi başlangıç tarihinden sonra olmalıdır",
    "collections.validation_minimum_selection": "En az bir {type} seçin",
    "Select at least one {type}": "En az bir {type} seçin",
    "collections.account": "hesap",
    "account": "hesap",
    "collections.listing": "ilan",
    "listing": "ilan",
    "collections.edit_title": "Koleksiyonu düzenle",
    "Edit Collection": "Koleksiyonu düzenle",
    "collections.create_title": "Koleksiyon oluştur",
    "Create Collection": "Koleksiyon oluştur",
    "collections.details": "Koleksiyon ayrıntıları",
    "Collection details": "Koleksiyon ayrıntıları",
    "collections.title_placeholder": "Başlık girin",
    "Enter title name": "Başlık girin",
    "collections.slug": "Kısa ad",
    "collections.slug_placeholder": "Kısa adı girin",
    "collections.enter_title_first": "Önce başlık girin",
    "collections.scope": "Kapsam",
    "collections.accounts": "Hesaplar",
    "collections.listings": "İlanlar",
    "collections.choose_category": "Kategori seçin",
    "collections.conditions": "Koşullar",
    "Conditions": "Koşullar",
    "collections.condition_type": "Koşul türü",
    "Condition type": "Koşul türü",
    "collections.manual": "Manuel",
    "Manual": "Manuel",
    "collections.automated": "Otomatik",
    "Automated": "Otomatik",
    "collections.availability": "Koleksiyon kullanılabilirliği",
    "Collections availability": "Koleksiyon kullanılabilirliği",
    "collections.schedule": "Program",
    "collections.applicable_channels": "Uygulanabilir kanalı seç",
    "Select applicable channel": "Uygulanabilir kanalı seç",
    "collections.web": "Web",
    "collections.ios": "iOS",
    "iOS": "iOS",
    "collections.android": "Android",
    "Android": "Android",
    "collections.search_key": "Ada göre ara",
    "Search by name": "Ada göre ara",
    "collections.not_found": "Koleksiyon bulunamadı.",
    "Collection not found.": "Koleksiyon bulunamadı.",
    "collections.featured_listings": "Öne çıkan ilanlar",
    "Featured listings": "Öne çıkan ilanlar",
    "collections.url_copied": "Herkese açık URL kopyalandı",
    "Public URL copied": "Herkese açık URL kopyalandı",
    "collections.url_copy_failed": "Herkese açık URL kopyalanamadı",
    "Unable to copy the public URL": "Herkese açık URL kopyalanamadı",
    "collections.collection": "Koleksiyon",
    "Collection": "Koleksiyon",
    "collections.this_collection": "bu koleksiyon",
    "this collection": "bu koleksiyon",
    "collections.share_text": "{title} öğesini görüntüle",
    "View {title}": "{title} öğesini görüntüle",
    "collections.public_url": "Herkese açık URL:",
    "Public URL:": "Herkese açık URL:",
    "collections.copy_url": "URL’yi kopyala",
    "Copy URL": "URL’yi kopyala",
    "collections.items": "Öğeler",
    "collections.expires": "Sona erme",
    "Expires": "Sona erme",
    "collections.never": "Asla",
    "Never": "Asla",
    "collections.automatic_conditions": "Otomatik koşullar",
    "Automatic Conditions": "Otomatik koşullar",
    "collections.item_count": "{count} öğe",
    "{count} items": "{count} öğe",
    "collections.loading_items": "Öğeler yükleniyor…",
    "Loading items…": "Öğeler yükleniyor…",
    "collections.no_items": "Bu koleksiyonda henüz öğe yok.",
    "No items in this collection yet.": "Bu koleksiyonda henüz öğe yok.",
    "collections.delete_confirm": "Bu koleksiyon silinsin mi?",
    "Do you want to delete this collection?": "Bu koleksiyon silinsin mi?",
    "collections.title": "Koleksiyonlar",
    "collections.header_title": "Başlık",
    "collections.header_action": "İşlem",
    "collections.header_id": "Kimlik",
    "collections.header_condition_type": "Koşul türü",
    "Condition Type": "Koşul türü",
    "collections.header_scope": "Kapsam",
    "collections.header_start_date": "Başlangıç tarihi",
    "collections.header_end_date": "Bitiş tarihi",
    "collections.header_status": "Durum",
    "collections.header_url": "URL",
    "common.calendar_view": "Takvim görünümü",
    "Calendar view": "Takvim görünümü",
    "common.deleted": "Silindi",
    "Deleted": "Silindi",
    "common.list_view": "Liste görünümü",
    "common.description": "Açıklama",
    "common.title": "Başlık",
    "common.end_date": "Bitiş tarihi",
    "common.start_date": "Başlangıç tarihi",
    "promotions.image_required": "Lütfen görsel ekleyin",
    "Please add an image": "Lütfen görsel ekleyin",
    "promotions.edit_title": "Promosyonu düzenle",
    "Edit Promotion": "Promosyonu düzenle",
    "promotions.add_title": "Promosyon ekle",
    "Add Promotion": "Promosyon ekle",
    "promotions.name": "Promosyon adı",
    "Promotion Name": "Promosyon adı",
    "promotions.select_medium": "Ortam seçin",
    "Select Medium": "Ortam seçin",
    "promotions.upload_media": "Medya yükle",
    "promotions.schedule": "Program",
    "promotions.destination_type": "Hedef türü",
    "Destination Type": "Hedef türü",
    "promotions.placement": "Yerleşim",
    "Placement": "Yerleşim",
    "promotions.status": "Durum (Etkin değil / Etkin)",
    "promotions.delete_confirm": "Bu promosyon silinsin mi?",
    "Do you want to delete this promotion?": "Bu promosyon silinsin mi?",
    "promotions.title": "Promosyonlar",
    "promotions.header_image": "Görsel",
    "promotions.header_medium": "Ortam",
    "promotions.header_placement": "Yerleşim",
    "promotions.header_type": "Tür",
    "promotions.header_value": "Değer",
    "promotions.header_active": "Etkin",
    "promotions.header_action": "İşlem",
    "promotions.header_start_at": "Başlangıç",
    "Start At": "Başlangıç",
    "promotions.header_end_at": "Bitiş",
    "End At": "Bitiş",
    "common.grid_view": "Izgara görünümü",
    "promotions.type_general": "Genel",
    "promotions.type_listing": "İlan",
    "promotions.type_account": "Hesap",
    "promotions.type_external_link": "Harici bağlantı",
    "External link": "Harici bağlantı",
    "promotions.preview": "Önizleme",
    "promotions.select_listing": "İlan seç",
    "Select Listing": "İlan seç",
    "promotions.select_account": "Hesap seç",
    "Select Account": "Hesap seç",
    "promotions.home_placement": "Ana sayfa",
    "promotions.footer_placement": "Alt bilgi",
    "promotions.web_only": "(yalnızca web)",
    "(Web Only)": "(yalnızca web)",
    "coupons.edit_title": "Kuponu düzenle",
    "Edit Coupon": "Kuponu düzenle",
    "coupons.add_title": "Kupon ekle",
    "Add Coupon": "Kupon ekle",
    "coupons.reference_name": "Referans adı",
    "Reference Name": "Referans adı",
    "coupons.enter_name": "Ad girin",
    "coupons.coupon_type": "Kupon türü",
    "Coupon type": "Kupon türü",
    "coupons.discount_value": "İndirim tutarı",
    "Discount Value": "İndirim tutarı",
    "coupons.enter_discount_value": "İndirim tutarını girin",
    "Enter discount value": "İndirim tutarını girin",
    "coupons.code": "Kod",
    "coupons.code_example": "Ör.: HOLIDAY10",
    "Ex: HOLIDAY10": "Ör.: HOLIDAY10",
    "coupons.short_code": "Kısa kod",
    "coupons.enter_short_code": "Kısa kod girin",
    "coupons.advanced": "GELİŞMİŞ",
    "ADVANCED": "GELİŞMİŞ",
    "coupons.minimum_amount": "En düşük tutar",
    "coupons.enter_minimum_amount": "En düşük tutarı girin",
    "coupons.maximum_amount": "En yüksek tutar",
    "coupons.enter_maximum_amount": "En yüksek tutarı girin",
    "coupons.maximum_discount_amount": "En yüksek indirim tutarı",
    "Maximum Discount Amount": "En yüksek indirim tutarı",
    "coupons.enter_maximum_discount_amount": "En yüksek indirim tutarını girin",
    "Enter maximum discount amount": "En yüksek indirim tutarını girin",
    "coupons.maximum_uses": "En fazla kullanım",
    "Maximum Uses": "En fazla kullanım",
    "coupons.enter_maximum_uses": "En fazla kullanım sayısını girin",
    "Enter maximum uses": "En fazla kullanım sayısını girin",
    "coupons.maximum_uses_per_user": "Kullanıcı başına en fazla kullanım",
    "Maximum Uses Per User": "Kullanıcı başına en fazla kullanım",
    "coupons.enter_maximum_uses_per_user": "Kullanıcı başına en fazla kullanım sayısını girin",
    "Enter maximum uses per user": "Kullanıcı başına en fazla kullanım sayısını girin",
    "coupons.new_user_only": "Yalnızca yeni kullanıcılar",
    "New User": "Yalnızca yeni kullanıcılar",
    "coupons.enter_note": "Not girin",
    "coupons.start_date_time": "Başlangıç tarih ve saati",
    "Start Date Time": "Başlangıç tarih ve saati",
    "coupons.end_date_time": "Bitiş tarih ve saati",
    "End Date Time": "Bitiş tarih ve saati",
    "coupons.select_start_date_time": "Başlangıç tarih ve saatini seçin",
    "Select start date time": "Başlangıç tarih ve saatini seçin",
    "coupons.select_end_date_time": "Bitiş tarih ve saatini seçin",
    "Select end date time": "Bitiş tarih ve saatini seçin",
    "coupons.flat_example": "Sabit (ör.: 10 $)",
    "Flat (Ex: $10)": "Sabit (ör.: 10 $)",
    "coupons.percentage_example": "Yüzde (ör.: %10)",
    "Percentage (Ex: 10%)": "Yüzde (ör.: %10)",
    "coupons.delete_confirm": "Bu kupon silinsin mi?",
    "Do you want to delete this coupon?": "Bu kupon silinsin mi?",
    "coupons.title": "Kuponlar",
    "coupons.header_name": "Ad",
    "coupons.header_code": "Kod",
    "coupons.header_coupon_type": "Kupon türü",
    "Coupon Type": "Kupon türü",
    "coupons.header_start_date_time": "Başlangıç tarih ve saati",
    "coupons.header_end_date_time": "Bitiş tarih ve saati",
    "coupons.header_active": "Etkin",
    "coupons.header_action": "İşlem",
    "coupons.load_error": "Bu kupon yüklenemedi.",
    "Unable to load this coupon.": "Bu kupon yüklenemedi.",
    "coupons.expired": "Süresi doldu",
    "Expired": "Süresi doldu",
    "coupons.total_orders": "Toplam sipariş",
    "coupons.unique_customers": "Tekil müşteriler",
    "Unique Customers": "Tekil müşteriler",
    "coupons.revenue": "Gelir",
    "coupons.average_transaction": "Ortalama işlem",
    "Avg Transaction": "Ortalama işlem",
    "coupons.paid_orders": "Ödenen siparişler",
    "coupons.uses_remaining": "Kalan kullanım",
    "Uses Remaining": "Kalan kullanım",
    "coupons.unlimited": "Sınırsız",
    "Unlimited": "Sınırsız",
    "coupons.performance": "Performans",
    "Performance": "Performans",
    "coupons.usage_against_limit": "Limite göre kullanım",
    "Usage against limit": "Limite göre kullanım",
    "coupons.details": "Ayrıntılar",
    "coupons.discount": "İndirim",
    "coupons.minimum_order": "En düşük sipariş",
    "Min order": "En düşük sipariş",
    "coupons.maximum_discount": "En yüksek indirim",
    "Max discount": "En yüksek indirim",
    "coupons.maximum_total_uses": "Toplam en fazla kullanım",
    "Max total uses": "Toplam en fazla kullanım",
    "coupons.maximum_per_user": "Kullanıcı başına en fazla",
    "Max / user": "Kullanıcı başına en fazla",
    "coupons.new_users_only": "Yalnızca yeni kullanıcılar",
    "New users only": "Yalnızca yeni kullanıcılar",
    "coupons.valid_from": "Başlangıç tarihi",
    "Valid from": "Başlangıç tarihi",
    "coupons.valid_until": "Son geçerlilik tarihi",
    "Valid until": "Son geçerlilik tarihi",
    "coupons.orders": "Siparişler",
    "coupons.no_orders": "Bu kupon henüz hiçbir siparişte kullanılmadı",
    "No orders have used this coupon yet": "Bu kupon henüz hiçbir siparişte kullanılmadı",
    "coupons.orders_header_order": "Sipariş",
    "coupons.orders_header_customer": "Müşteri",
    "coupons.orders_header_date": "Tarih",
    "coupons.orders_header_amount": "Tutar",
    "coupons.orders_header_status": "Durum",
    "coupons.paid": "Ödendi",
    "coupons.pending": "Bekliyor",
    "coupons.coupon": "Kupon",
    "coupons.detail_title": "Kupon ayrıntısı",
    "Coupon Detail": "Kupon ayrıntısı",
    "coupons.discount_percentage": "%{value} indirim",
    "{value}% off": "%{value} indirim",
    "coupons.discount_flat": "{value} sabit indirim",
    "{value} flat off": "{value} sabit indirim",
    "coupons.type_direct_discount": "Doğrudan indirim",
    "Direct discount": "Doğrudan indirim",
    "collections.condition_and": "VE",
    "AND": "VE",
    "collections.condition_or": "VEYA",
    "OR": "VEYA",
    "users.first_seen": "İlk görülme",
    "First seen": "İlk görülme",
    "users.last_seen": "Son görülme",
    "Last seen": "Son görülme",
    "users.avg_order": "Ort. sipariş",
    "Avg order": "Ort. sipariş",
    "users.purchase_value": "Satın alma değeri",
    "Purchase value": "Satın alma değeri",
    "users.price_range": "Fiyat aralığı",
    "Price range": "Fiyat aralığı",
    "users.attributes": "Özellikler",
    "users.detail_title": "Kullanıcı ayrıntısı",
    "User Detail": "Kullanıcı ayrıntısı",
    "users.detail_orders_list": "Kullanıcı sipariş listesi",
    "User Orders List": "Kullanıcı sipariş listesi",
    "users.confirm_user_action": "{name} {action} edilsin mi?",
    "{action} {name}?": "{name} {action} edilsin mi?",
    "users.as_buyer": "Alıcı olarak",
    "As a Buyer": "Alıcı olarak",
    "users.as_seller": "Satıcı olarak",
    "As a Seller": "Satıcı olarak",
    "users.health": "Sağlık",
    "users.no_listings": "Henüz ilan yok",
    "users.no_accounts": "Henüz hesap yok",
    "No accounts yet": "Henüz hesap yok",
    "users.top_categories": "En iyi kategoriler",
    "Top categories": "En iyi kategoriler",
    "users.top_listings": "En iyi ilanlar",
    "Top listings": "En iyi ilanlar",
    "users.recent_activity": "Son etkinlik",
    "Recent activity": "Son etkinlik",
    "users.acquisition": "Edinme",
    "Acquisition": "Edinme",
    "users.sent_emails": "Gönderilen e-postalar",
    "Sent Emails": "Gönderilen e-postalar",
    "users.no_emails_sent": "E-posta gönderilmedi",
    "No emails sent": "E-posta gönderilmedi",
    "users.load_more_emails": "Daha fazla yükle ({loaded} / {total})",
    "Load More ({loaded} / {total})": "Daha fazla yükle ({loaded} / {total})",
    "users.email_to": "Kime: {email}",
    "To: {email}": "Kime: {email}",
    "users.sending_email": "Gönderiliyor…",
    "users.send_email": "E-posta gönder",
    "Send Email": "E-posta gönder",
    "users.send_email_title": "E-posta gönder — {name}",
    "Send Email — {name}": "E-posta gönder — {name}",
    "users.customer": "Müşteri",
    "users.block_named": "{name} kişisini engelle",
    "Block {name}": "{name} kişisini engelle",
    "users.unblock_named": "{name} engelini kaldır",
    "Unblock {name}": "{name} engelini kaldır",
    "users.email_sent": "E-posta başarıyla gönderildi",
    "Email sent successfully": "E-posta başarıyla gönderildi",
    "users.email_send_failed": "E-posta gönderilemedi",
    "Failed to send email": "E-posta gönderilemedi",
    "common.value": "Değer",
    "users.email_bounced": "E-posta geri döndü",
    "Bounced": "E-posta geri döndü",
    "users.email_complained": "E-posta şikayet edildi",
    "Complained": "E-posta şikayet edildi",
    "users.unverified": "Doğrulanmadı",
    "Unverified": "Doğrulanmadı",
    "users.otp_enabled": "OTP etkin",
    "OTP Enabled": "OTP etkin",
    "users.account_info": "Hesap bilgisi",
    "Account Info": "Hesap bilgisi",
    "users.mobile": "Cep telefonu",
    "users.locale": "Yerel ayar",
    "Locale": "Yerel ayar",
    "users.joined": "Katılma tarihi",
    "users.following": "Takip edilenler",
    "Following": "Takip edilenler",
    "users.email_health": "E-posta durumu",
    "Email Health": "E-posta durumu",
    "users.orders": "Siparişler",
    "users.no_orders": "Sipariş yok",
    "No orders": "Sipariş yok",
    "users.order_reference": "Sipariş {number}",
    "Order {number}": "Sipariş {number}",
    "users.order_ref": "Ref: {reference}",
    "Ref: {reference}": "Ref: {reference}",
    "users.unpaid": "Ödenmedi",
    "users.revenue_ltv": "Gelir ve LTV",
    "Revenue & LTV": "Gelir ve LTV",
    "users.total_spent": "Toplam harcama",
    "Total Spent": "Toplam harcama",
    "users.paid_order_count": "{count} ödenen sipariş",
    "{count} paid orders": "{count} ödenen sipariş",
    "users.average_order": "Ort. sipariş",
    "users.of_total_orders": "toplam {count} siparişin",
    "of {count} total": "toplam {count} siparişin",
    "users.gmv": "Brüt mal hacmi",
    "GMV": "Brüt mal hacmi",
    "users.active_count": "{count} etkin",
    "{count} active": "{count} etkin",
    "users.at_risk": "Risk altında",
    "At Risk": "Risk altında",
    "common.today": "Bugün",
    "common.yesterday": "Dün",
    "Yesterday": "Dün",
    "users.days_ago": "{count} gün önce",
    "{count} days ago": "{count} gün önce",
    "users.months_ago": "{count} ay önce",
    "{count} months ago": "{count} ay önce",
    "users.years_ago": "{count} yıl önce",
    "{count} years ago": "{count} yıl önce",
    "users.last_order": "Son sipariş",
    "Last order": "Son sipariş",
    "users.last_listing": "Son ilan",
    "Last listing": "Son ilan",
    "users.events": "Etkinlikler",
    "users.viewed": "Görüntülendi",
    "Viewed": "Görüntülendi",
    "users.cart": "Sepet",
    "users.checkouts": "Ödemeler",
    "Checkouts": "Ödemeler",
    "users.purchases": "Satın almalar",
    "Purchases": "Satın almalar",
    "users.last_30_days": "Son 30 gün",
    "Last 30 days": "Son 30 gün",
    "users.no_analytics": "Bu kullanıcı için henüz analiz verisi yok.",
    "No analytics data for this user yet.": "Bu kullanıcı için henüz analiz verisi yok.",
    "users.analytics_unavailable": "Bu kiracı için analiz kullanılamıyor.",
    "Analytics unavailable for this tenant.": "Bu kiracı için analiz kullanılamıyor.",
    "users.account_number": "Hesap #{number}",
    "Account #{number}": "Hesap #{number}",
    "users.no_subject": "Konu yok",
    "No Subject": "Konu yok",
    "common.unknown": "Bilinmiyor",
    "users.opened": "Açıldı",
    "Opened": "Açıldı",
    "users.not_opened": "Açılmadı",
    "Not opened": "Açılmadı",
    "users.user_action_success": "Kullanıcı işlemi tamamlandı",
    "User action completed": "Kullanıcı işlemi tamamlandı",
    "common.pending": "Bekliyor",
    "common.never": "Asla",
    "users.customer_analytics": "Müşteri analizi",
    "Customer Analytics": "Müşteri analizi",
    "users.analytics": "Analiz",
    "users.emails": "E-postalar",
    "Emails": "E-postalar",
    "users.first_visit": "İlk ziyaret",
    "First visit": "İlk ziyaret",
    "users.latest_visit": "Son ziyaret",
    "Latest visit": "Son ziyaret",
    "users.landing_page": "Açılış sayfası",
    "Landing page": "Açılış sayfası",
    "users.referrer": "Yönlendiren",
    "Referrer": "Yönlendiren",
    "users.utm_source": "UTM kaynağı",
    "UTM source": "UTM kaynağı",
    "users.utm_medium": "UTM aracı",
    "UTM medium": "UTM aracı",
    "users.utm_campaign": "UTM kampanyası",
    "UTM campaign": "UTM kampanyası",
    "users.utm_term": "UTM terimi",
    "UTM term": "UTM terimi",
    "users.utm_content": "UTM içeriği",
    "UTM content": "UTM içeriği",
    "users.ai_source": "Yapay zekâ kaynağı",
    "AI source": "Yapay zekâ kaynağı",
    "rewards.edit_scope": "Kapsamı düzenle",
    "Edit scope": "Kapsamı düzenle",
    "rewards.add_scope": "Kapsam ekle",
    "Add scope": "Kapsam ekle",
    "rewards.save_scope": "Kapsamı kaydet",
    "Save scope": "Kapsamı kaydet",
    "rewards.scope_type": "Kapsam türü",
    "Scope type": "Kapsam türü",
    "rewards.scope_reference": "Kapsam referansı",
    "Scope reference": "Kapsam referansı",
    "rewards.match_config": "Eşleşme yapılandırması",
    "Match config": "Eşleşme yapılandırması",
    "rewards.priority_order": "Öncelik sırası",
    "Priority order": "Öncelik sırası",
    "rewards.active": "Etkin",
    "rewards.scope_active": "Kapsam etkin",
    "Scope is active": "Kapsam etkin",
    "rewards.edit_rule": "Kuralı düzenle",
    "Edit rule": "Kuralı düzenle",
    "rewards.add_rule": "Kural ekle",
    "Add rule": "Kural ekle",
    "rewards.save_rule": "Kuralı kaydet",
    "Save rule": "Kuralı kaydet",
    "rewards.trigger_event": "Tetikleyici etkinlik",
    "Trigger event": "Tetikleyici etkinlik",
    "rewards.beneficiary_type": "Faydalanıcı türü",
    "Beneficiary type": "Faydalanıcı türü",
    "rewards.beneficiary_config": "Faydalanıcı yapılandırması",
    "Beneficiary config": "Faydalanıcı yapılandırması",
    "rewards.eligibility": "Uygunluk",
    "Eligibility": "Uygunluk",
    "rewards.conditions": "Koşullar",
    "rewards.priority": "Öncelik",
    "Priority": "Öncelik",
    "rewards.edit_component": "Tarif bileşenini düzenle",
    "Edit recipe component": "Tarif bileşenini düzenle",
    "rewards.add_component": "Tarif bileşeni ekle",
    "Add recipe component": "Tarif bileşeni ekle",
    "rewards.save_component": "Bileşeni kaydet",
    "Save component": "Bileşeni kaydet",
    "rewards.rule": "Kural",
    "Rule": "Kural",
    "rewards.component_key": "Bileşen anahtarı",
    "Component key": "Bileşen anahtarı",
    "rewards.component_type": "Bileşen türü",
    "Component type": "Bileşen türü",
    "rewards.commission_definition": "Komisyon tanımı",
    "Commission definition": "Komisyon tanımı",
    "rewards.config": "Yapılandırma",
    "rewards.position": "Konum",
    "Position": "Konum",
    "rewards.component": "Bileşen",
    "Component": "Bileşen",
    "rewards.status.draft": "Taslak",
    "rewards.status.active": "Etkin",
    "rewards.status.paused": "Duraklatıldı",
    "Paused": "Duraklatıldı",
    "rewards.status.archived": "Arşivlendi",
    "rewards.configuration_updated": "Ödül yapılandırması güncellendi",
    "Reward configuration updated": "Ödül yapılandırması güncellendi",
    "rewards.configuration_added": "Ödül yapılandırması eklendi",
    "Reward configuration added": "Ödül yapılandırması eklendi",
    "rewards.archive_item_confirm": "{name} arşivlensin mi?",
    "Archive {name}?": "{name} arşivlensin mi?",
    "rewards.empty_scopes": "Henüz kapsam yapılandırılmadı.",
    "No scopes configured yet.": "Henüz kapsam yapılandırılmadı.",
    "rewards.empty_rules": "Henüz kural yapılandırılmadı.",
    "No rules configured yet.": "Henüz kural yapılandırılmadı.",
    "rewards.empty_components": "Henüz bileşen yapılandırılmadı.",
    "No components configured yet.": "Henüz bileşen yapılandırılmadı.",
    "rewards.edit_program": "Ödül programını düzenle",
    "Edit reward program": "Ödül programını düzenle",
    "rewards.new_program": "Yeni ödül programı",
    "New reward program": "Yeni ödül programı",
    "rewards.create_program": "Program oluştur",
    "Create program": "Program oluştur",
    "rewards.program_type": "Program türü",
    "Program type": "Program türü",
    "rewards.starts_at": "Başlangıç",
    "Starts at": "Başlangıç",
    "rewards.ends_at": "Bitiş",
    "Ends at": "Bitiş",
    "rewards.program_updated": "Ödül programı güncellendi",
    "Reward program updated": "Ödül programı güncellendi",
    "rewards.program_created": "Ödül programı oluşturuldu",
    "Reward program created": "Ödül programı oluşturuldu",
    "rewards.archive_program_confirm": "{name} arşivlensin mi?",
    "rewards.program_archived": "Ödül programı arşivlendi",
    "Reward program archived": "Ödül programı arşivlendi",
    "rewards.tab.overview": "Genel bakış",
    "rewards.tab.programs": "Programlar",
    "Programs": "Programlar",
    "rewards.tab.impact": "Etki",
    "Impact": "Etki",
    "rewards.tab.attribution": "İlişkilendirme",
    "Tracking": "İlişkilendirme",
    "rewards.page_description": "Ödül programları, uygunluk ayarları, kurallar ve ödül tarifleri oluşturup yönetin. Tamamlanan siparişler raporlarınıza otomatik eklenir.",
    "Create and manage reward programs, eligibility settings, reward rules, and reward recipes. Completed orders are added to your reports automatically.": "Ödül programları, uygunluk ayarları, kurallar ve ödül tarifleri oluşturup yönetin. Tamamlanan siparişler raporlarınıza otomatik eklenir.",
    "rewards.program": "Program",
    "Program": "Program",
    "rewards.starts": "Başlangıç",
    "Starts": "Başlangıç",
    "rewards.no_programs": "Henüz ödül programı yok.",
    "No reward programs yet.": "Henüz ödül programı yok.",
    "rewards.program_title": "Ödül programı",
    "Reward program": "Ödül programı",
    "rewards.back_to_rewards": "Ödüllere dön",
    "Back to rewards": "Ödüllere dön",
    "common.archive": "Arşivle",
    "Archive": "Arşivle",
    "common.save_changes": "Değişiklikleri kaydet",
    "common.none": "Yok",
    "common.this_item": "bu öğe",
    "this item": "bu öğe",
    "rewards.tab.scopes": "Kapsamlar",
    "Scopes": "Kapsamlar",
    "rewards.tab.rules": "Kurallar",
    "Rules": "Kurallar",
    "rewards.tab.components": "Tarif bileşenleri",
    "Recipe components": "Tarif bileşenleri",
    "rewards.reference": "Referans",
    "rewards.trigger": "Tetikleyici",
    "Trigger": "Tetikleyici",
    "rewards.beneficiary": "Faydalanıcı",
    "Beneficiary": "Faydalanıcı",
    "rewards.attributed_conversions": "İlişkilendirilen dönüşümler",
    "Attributed conversions": "İlişkilendirilen dönüşümler",
    "rewards.new_customers": "Yeni müşteriler",
    "New customers": "Yeni müşteriler",
    "rewards.revenue_influenced": "Etkilenen gelir",
    "Revenue influenced": "Etkilenen gelir",
    "rewards.rewards_issued": "Verilen ödüller",
    "Rewards issued": "Verilen ödüller",
    "rewards.live_business_results": "Canlı işletme sonuçları",
    "Live business results": "Canlı işletme sonuçları",
    "rewards.impact_at_a_glance": "Etkiye genel bakış",
    "Impact at a glance": "Etkiye genel bakış",
    "rewards.impact_last_30_days": "Son 30 gündeki tamamlanmış siparişleri ve iş ortağı sonuçlarını canlı görüntüleyin.",
    "A live view of completed orders and partner results from the last 30 days.": "Son 30 gündeki tamamlanmış siparişleri ve iş ortağı sonuçlarını canlı görüntüleyin.",
    "rewards.view_full_impact": "Tüm etkiyi görüntüle",
    "View full impact": "Tüm etkiyi görüntüle",
    "rewards.impact_load_error": "Etki verileri yüklenemedi: {error}",
    "Impact data could not be loaded: {error}": "Etki verileri yüklenemedi: {error}",
    "rewards.programs": "Programlar",
    "rewards.programs_configured": "Bu çalışma alanı için yapılandırılan ödül programları.",
    "Reward programs configured for this workspace.": "Bu çalışma alanı için yapılandırılan ödül programları.",
    "rewards.programs_eligible": "Şu anda değerlendirmeye uygun programlar.",
    "Programs currently eligible for evaluation.": "Şu anda değerlendirmeye uygun programlar.",
    "rewards.drafts": "Taslaklar",
    "Drafts": "Taslaklar",
    "rewards.programs_being_configured": "Yapılandırılmaya devam eden programlar.",
    "Programs still being configured.": "Yapılandırılmaya devam eden programlar.",
    "rewards.clicks": "Tıklamalar",
    "rewards.completed_orders": "Tamamlanan siparişler",
    "Completed orders": "Tamamlanan siparişler",
    "rewards.conversion_rate": "Dönüşüm oranı",
    "Conversion rate": "Dönüşüm oranı",
    "rewards.revenue": "Gelir",
    "rewards.live_connection": "Canlı bağlantı",
    "Live connection": "Canlı bağlantı",
    "rewards.attribution_activity": "İlişkilendirme etkinliği",
    "Attribution activity": "İlişkilendirme etkinliği",
    "rewards.connected_workspace": "{name} uygulamasına bağlandı.",
    "Connected to {name}.": "{name} uygulamasına bağlandı.",
    "rewards.your_attribution_workspace": "Attribution çalışma alanınız",
    "your Attribution workspace": "Attribution çalışma alanınız",
    "rewards.loading_workspace": "Bağlı Attribution çalışma alanı yükleniyor.",
    "Loading your connected Attribution workspace.": "Bağlı Attribution çalışma alanı yükleniyor.",
    "rewards.open_attribution": "Attribution’ı aç",
    "Open Attribution": "Attribution’ı aç",
    "rewards.connection_attention": "Bağlantının kontrol edilmesi gerekiyor",
    "Connection needs attention": "Bağlantının kontrol edilmesi gerekiyor",
    "rewards.open_attribution_workspace": "Attribution çalışma alanını aç",
    "Open Attribution workspace": "Attribution çalışma alanını aç",
    "rewards.workspace_connected": "Çalışma alanı bağlı",
    "Workspace connected": "Çalışma alanı bağlı",
    "rewards.workspace_not_linked": "Çalışma alanı henüz bağlı değil",
    "Workspace not linked yet": "Çalışma alanı henüz bağlı değil",
    "rewards.attribution_data_connected": "Canlı tıklamalar, bağlantılar, kampanyalar ve tamamlanan siparişler Attribution’dan okunuyor.",
    "Live clicks, links, campaigns, and completed orders are being read from Attribution.": "Canlı tıklamalar, bağlantılar, kampanyalar ve tamamlanan siparişler Attribution’dan okunuyor.",
    "rewards.connect_workspace_prompt": "Etkinliği izlemek için bu çalışma alanını bağlamak üzere Attribution’ı açın.",
    "Open Attribution to connect this workspace before tracking activity.": "Etkinliği izlemek için bu çalışma alanını bağlamak üzere Attribution’ı açın.",
    "rewards.successful_referrals": "Başarılı yönlendirmeler",
    "Successful referrals": "Başarılı yönlendirmeler",
    "rewards.new_customers_acquired": "Kazanılan yeni müşteriler",
    "New customers acquired": "Kazanılan yeni müşteriler",
    "rewards.gross_revenue_influenced": "Etkilenen brüt gelir",
    "Gross revenue influenced": "Etkilenen brüt gelir",
    "rewards.reward_cost": "Ödül maliyeti",
    "Reward cost": "Ödül maliyeti",
    "rewards.net_revenue": "Net gelir",
    "Net revenue": "Net gelir",
    "rewards.average_order_value": "Ortalama sipariş değeri",
    "Average order value": "Ortalama sipariş değeri",
    "rewards.cost_per_acquisition": "Edinme maliyeti",
    "Cost per acquisition": "Edinme maliyeti",
    "rewards.repeat_purchase_rate": "Tekrar satın alma oranı",
    "Repeat purchase rate": "Tekrar satın alma oranı",
    "rewards.business_outcome_reporting": "İşletme sonucu raporlaması",
    "Business outcome reporting": "İşletme sonucu raporlaması",
    "rewards.impact": "Etki",
    "rewards.impact_description": "Seçilen dönemdeki dönüşümler, müşteri edinimi, etkilenen gelir ve ödül maliyeti.",
    "Conversions, customer acquisition, influenced revenue, and reward cost from the selected period.": "Seçilen dönemdeki dönüşümler, müşteri edinimi, etkilenen gelir ve ödül maliyeti.",
    "rewards.from": "Başlangıç",
    "rewards.to": "Bitiş",
    "rewards.trend": "Eğilim",
    "Trend": "Eğilim",
    "rewards.daily": "Günlük",
    "rewards.weekly": "Haftalık",
    "Weekly": "Haftalık",
    "rewards.top_partners": "En iyi iş ortakları / yönlendirenler",
    "Top partners / referrers": "En iyi iş ortakları / yönlendirenler",
    "rewards.partner": "İş ortağı",
    "Partner": "İş ortağı",
    "rewards.conversions": "Dönüşümler",
    "Conversions": "Dönüşümler",
    "rewards.no_partner_data": "Bu dönem için ilişkilendirilen iş ortağı verisi yok.",
    "No attributed partner data for this period.": "Bu dönem için ilişkilendirilen iş ortağı verisi yok.",
    "rewards.period": "Dönem",
    "rewards.no_trend_data": "Bu dönem için eğilim verisi yok.",
    "No trend data for this period.": "Bu dönem için eğilim verisi yok.",
    "rewards.campaign_performance": "Kampanya performansı",
    "Campaign performance": "Kampanya performansı",
    "rewards.campaign_count": "{count} kampanya",
    "{count} campaigns": "{count} kampanya",
    "rewards.campaign": "Kampanya",
    "rewards.orders": "Siparişler",
    "rewards.rate": "Oran",
    "Rate": "Oran",
    "rewards.no_campaign_activity": "Henüz kampanya etkinliği yok. Sonuçları ölçmeye başlamak için Attribution’da takip bağlantısı oluşturun.",
    "No campaign activity yet. Create a tracking link in Attribution to start measuring results.": "Henüz kampanya etkinliği yok. Sonuçları ölçmeye başlamak için Attribution’da takip bağlantısı oluşturun.",
    "rewards.recent_completed_orders": "Son tamamlanan siparişler",
    "Recent completed orders": "Son tamamlanan siparişler",
    "rewards.recent_events_count": "{count} son etkinlik",
    "{count} recent events": "{count} son etkinlik",
    "rewards.event": "Etkinlik",
    "rewards.completed_order": "Tamamlanan sipariş",
    "Completed order": "Tamamlanan sipariş",
    "rewards.no_completed_order_activity": "Henüz tamamlanan sipariş etkinliği yok.",
    "No completed order activity has arrived yet.": "Henüz tamamlanan sipariş etkinliği yok.",
    "rewards.impact_data_quality_note": "Attribution tıklama özeti bağlanana kadar tıklama hacmi ve dönüşüm oranı burada kullanılamaz. Ödül maliyeti onaylanan veya verilen ödül kayıtlarını kullanır; iadeler henüz dahil değildir.",
    "Click volume and conversion rate remain unavailable here until the Attribution click aggregate is connected. Reward cost uses approved or issued reward-ledger rows; refunds are not included yet.": "Attribution tıklama özeti bağlanana kadar tıklama hacmi ve dönüşüm oranı burada kullanılamaz. Ödül maliyeti onaylanan veya verilen ödül kayıtlarını kullanır; iadeler henüz dahil değildir.",
    "subscriptions.type.free": "Ücretsiz abonelik",
    "Free Subscription": "Ücretsiz abonelik",
    "subscriptions.form.title_placeholder": "Abonelik başlığı",
    "Subscription Title": "Abonelik başlığı",
    "subscriptions.form.title_help": "Abonelik paketi için açıklayıcı bir ad girin (ör. “Premium Plan”, “Temel Paket”).",
    "Enter a descriptive title for the subscription package (e.g., “Premium Plan”, “Basic Tier”).": "Abonelik paketi için açıklayıcı bir ad girin (ör. “Premium Plan”, “Temel Paket”).",
    "subscriptions.form.description_placeholder": "Abonelik açıklaması",
    "Subscription Description": "Abonelik açıklaması",
    "subscriptions.form.description_help": "Aboneliği, özelliklerini ve avantajlarını ayrıntılı biçimde açıklayın.",
    "Provide a detailed description of the subscription, outlining its features and benefits.": "Aboneliği, özelliklerini ve avantajlarını ayrıntılı biçimde açıklayın.",
    "subscriptions.form.select_currency": "Para birimi seç",
    "Select Currency": "Para birimi seç",
    "subscriptions.form.currency_help": "Abonelik para birimini listeden seçin (varsayılan para biriminiz).",
    "Select the currency for the subscription from the dropdown menu (Your default currency)": "Abonelik para birimini listeden seçin (varsayılan para biriminiz).",
    "subscriptions.form.amount_placeholder": "Abonelik tutarı",
    "Subscription Amount": "Abonelik tutarı",
    "subscriptions.form.amount_help": "Abonelik fiyatını girin.",
    "Enter the subscription price.": "Abonelik fiyatını girin.",
    "subscriptions.form.sku_placeholder": "Abonelik SKU’su",
    "Subscription SKU": "Abonelik SKU’su",
    "subscriptions.form.sku_help": "Veri yönetimi ve takip için aboneliğe benzersiz bir tanımlayıcı girin.",
    "Enter a unique identifier for the subscription (often used for data simplicity, uniqueness and tracking).": "Veri yönetimi ve takip için aboneliğe benzersiz bir tanımlayıcı girin.",
    "subscriptions.form.allowed_listings": "İzin verilen ilanlar",
    "Allowed Listings": "İzin verilen ilanlar",
    "subscriptions.form.allowed_listings_placeholder": "İzin verilen ilan sayısı",
    "Subscription Allowed Listings": "İzin verilen ilan sayısı",
    "subscriptions.form.allowed_listings_help": "Bu abonelikte izin verilen ilan sayısını belirtin.",
    "Specify the number of listings allowed for this subscription.": "Bu abonelikte izin verilen ilan sayısını belirtin.",
    "subscriptions.form.fixed_fee_per_order": "Sipariş başına sabit ücret",
    "Fixed Fee Per Order": "Sipariş başına sabit ücret",
    "subscriptions.form.fixed_fee_placeholder": "Sipariş başına sabit ücret",
    "Subscription Fee Fixed Per Order": "Sipariş başına sabit ücret",
    "subscriptions.form.fixed_fee_help": "Varsa sipariş başına sabit ücreti girin.",
    "Enter a fixed fee per order, if applicable.": "Varsa sipariş başına sabit ücreti girin.",
    "subscriptions.form.commission_percent_per_order": "Sipariş başına komisyon, %",
    "Commission % Per Order": "Sipariş başına komisyon, %",
    "subscriptions.form.commission_placeholder": "Sipariş başına komisyon, %",
    "Subscription Commission Percent Per Order": "Sipariş başına komisyon, %",
    "subscriptions.form.commission_help": "Varsa sipariş başına komisyon yüzdesini girin.",
    "Enter the commission percentage per order, if applicable.": "Varsa sipariş başına komisyon yüzdesini girin.",
    "subscriptions.form.expiry_days": "Son kullanma süresi (gün)",
    "Expiry Days": "Son kullanma süresi (gün)",
    "subscriptions.form.expiry_days_placeholder": "Abonelik geçerlilik süresi (gün)",
    "Subscription Expiry Days": "Abonelik geçerlilik süresi (gün)",
    "subscriptions.form.expiry_days_help": "Aboneliğin sona ereceği gün sayısını belirleyin. Örnek: 7 veya 30 gün.",
    "Set the number of days before the subscription(plan,package) expires. Example: 7 days, 30 days": "Aboneliğin sona ereceği gün sayısını belirleyin. Örnek: 7 veya 30 gün.",
    "subscriptions.form.payment_method": "Ödeme yöntemi",
    "subscriptions.form.select_type": "Tür seçin",
    "subscriptions.form.payment_method_help": "Bu abonelikte desteklenen ödeme yöntemlerini seçin (ör. Stripe, MangoPay, Android, iOS veya ücretsiz abonelik).",
    "Select the payment method(s) supported for this subscription (e.g., Stripe, Mangopay, Android, iOS, Free Subscription).": "Bu abonelikte desteklenen ödeme yöntemlerini seçin (ör. Stripe, MangoPay, Android, iOS veya ücretsiz abonelik).",
    "subscriptions.form.active_placeholder": "Abonelik etkin",
    "Subscription Active": "Abonelik etkin",
    "subscriptions.form.active_help": "Aboneliği etkinleştirmek veya devre dışı bırakmak için geçişi kullanın. Etkin abonelik satın alınabilir.",
    "Toggle the switch to activate or deactivate the subscription. An active subscription is available for purchase.": "Aboneliği etkinleştirmek veya devre dışı bırakmak için geçişi kullanın. Etkin abonelik satın alınabilir.",
    "subscriptions.add_title": "Abonelik ürünü ekle",
    "Add new subscription product": "Abonelik ürünü ekle",
    "subscriptions.edit_title": "Abonelik ürününü düzenle",
    "Edit subscription product": "Abonelik ürününü düzenle",
    "subscriptions.added_success": "Abonelik ilanı başarıyla eklendi",
    "Subscription listing added successfully": "Abonelik ilanı başarıyla eklendi",
    "subscriptions.updated_success": "Abonelik ilanı başarıyla güncellendi",
    "Subscription listing updated successfully": "Abonelik ilanı başarıyla güncellendi",
    "common.currency": "Para birimi",
    "common.sku": "SKU",
    "subscriptions.title": "Abonelikler",
    "subscriptions.add_subscription": "Abonelik ekle",
    "Add subscription": "Abonelik ekle",
    "subscriptions.plans": "Planlar",
    "subscriptions.active_subscribers": "Etkin aboneler",
    "Active Subscribers": "Etkin aboneler",
    "subscriptions.total_mrr": "Toplam aylık yinelenen gelir",
    "Total MRR": "Toplam aylık yinelenen gelir",
    "subscriptions.churn_rate": "Kaybedilen abone oranı",
    "Churn Rate": "Kaybedilen abone oranı",
    "subscriptions.new_this_month": "Bu ay yeni",
    "New This Month": "Bu ay yeni",
    "subscriptions.average_duration": "Ortalama süre",
    "Avg Duration": "Ortalama süre",
    "subscriptions.monthly_recurring_revenue": "Aylık yinelenen gelir",
    "Monthly Recurring Revenue": "Aylık yinelenen gelir",
    "subscriptions.annual_run_rate": "Yıllık gelir hızı",
    "Annual Run Rate": "Yıllık gelir hızı",
    "subscriptions.last_30_days": "Son 30 gün",
    "subscriptions.subscriber_lifetime": "Abone ömrü",
    "Subscriber lifetime": "Abone ömrü",
    "subscriptions.subscriber_distribution": "Abone dağılımı",
    "Subscriber Distribution": "Abone dağılımı",
    "subscriptions.billing_period": "Fatura dönemi",
    "Billing Period": "Fatura dönemi",
    "subscriptions.allowed_listings": "İzin verilen ilanlar",
    "subscriptions.commission_per_order": "Sipariş başına komisyon",
    "Commission per Order": "Sipariş başına komisyon",
    "subscriptions.fixed_fee_per_order": "Sipariş başına sabit ücret",
    "Fixed Fee per Order": "Sipariş başına sabit ücret",
    "subscriptions.payment_provider": "Ödeme sağlayıcısı",
    "Payment Provider": "Ödeme sağlayıcısı",
    "subscriptions.sku_product_id": "SKU / ürün kimliği",
    "SKU / Product ID": "SKU / ürün kimliği",
    "subscriptions.revenue_over_time": "Zaman içindeki gelir",
    "Revenue Over Time": "Zaman içindeki gelir",
    "subscriptions.revenue": "Gelir",
    "subscriptions.subscriber_growth": "Abone artışı",
    "Subscriber Growth": "Abone artışı",
    "subscriptions.subscribers": "Aboneler",
    "Subscribers": "Aboneler",
    "subscriptions.set_inactive": "Devre dışı bırak",
    "Set Inactive": "Devre dışı bırak",
    "subscriptions.set_active": "Etkinleştir",
    "Set Active": "Etkinleştir",
    "subscriptions.plan_title": "Abonelik planı",
    "Subscription Plan": "Abonelik planı",
    "subscriptions.status.active": "Etkin",
    "subscriptions.status.cancelled": "İptal edildi",
    "subscriptions.status.expired": "Süresi doldu",
    "subscriptions.status.trial": "Deneme",
    "Trial": "Deneme",
    "subscriptions.status.pending": "Bekliyor",
    "subscriptions.period.lifetime": "Ömür boyu",
    "Lifetime": "Ömür boyu",
    "subscriptions.period.daily": "Günlük",
    "subscriptions.period.weekly": "Haftalık",
    "subscriptions.period.monthly": "Aylık",
    "Monthly": "Aylık",
    "subscriptions.period.quarterly": "Üç aylık",
    "Quarterly": "Üç aylık",
    "subscriptions.period.semi_annual": "Altı aylık",
    "Semi-annual": "Altı aylık",
    "subscriptions.period.annual": "Yıllık",
    "Annual": "Yıllık",
    "subscriptions.period.days": "{count} gün",
    "subscriptions.period.day": "/ gün",
    "/ day": "/ gün",
    "subscriptions.period.week": "/ hafta",
    "/ week": "/ hafta",
    "subscriptions.period.month": "/ ay",
    "/ month": "/ ay",
    "subscriptions.period.quarter": "/ çeyrek",
    "/ quarter": "/ çeyrek",
    "subscriptions.period.six_months": "/ 6 ay",
    "/ 6 months": "/ 6 ay",
    "subscriptions.period.year": "/ yıl",
    "/ year": "/ yıl",
    "subscriptions.listings_count": "{count} ilan",
    "{count} listings": "{count} ilan",
    "subscriptions.commission_percentage": "%{rate} komisyon",
    "{rate}% commission": "%{rate} komisyon",
    "subscriptions.per_order": "/ sipariş",
    "/ order": "/ sipariş",
    "subscriptions.view_details_subscribers": "Ayrıntıları ve aboneleri görüntüle",
    "View details and subscribers": "Ayrıntıları ve aboneleri görüntüle",
    "subscriptions.edit_subscription": "Aboneliği düzenle",
    "Edit subscription": "Aboneliği düzenle",
    "subscriptions.delete_subscription": "Aboneliği sil",
    "Delete subscription": "Aboneliği sil",
    "subscriptions.deleted": "Abonelik silindi",
    "Subscription deleted": "Abonelik silindi",
    "subscriptions.type.stripe": "Stripe",
    "Stripe": "Stripe",
    "subscriptions.type.android": "Android uygulama içi satın alma",
    "Android IAP": "Android uygulama içi satın alma",
    "subscriptions.type.ios": "iOS uygulama içi satın alma",
    "iOS IAP": "iOS uygulama içi satın alma",
    "subscriptions.type.free_subscription": "Ücretsiz",
    "subscriptions.type.mangopay": "MangoPay",
    "Mangopay": "MangoPay",
    "subscriptions.loaded_count": "{count} yüklendi",
    "subscriptions.no_subscribers": "{status} durumunda abone yok.",
    "No {status} subscribers.": "{status} durumunda abone yok.",
    "subscriptions.billing_records": "Fatura kayıtları",
    "Billing Records": "Fatura kayıtları",
    "subscriptions.no_invoices": "Fatura bulunamadı.",
    "No invoices found.": "Fatura bulunamadı.",
    "subscriptions.column.account": "Hesap",
    "subscriptions.column.email": "E-posta",
    "subscriptions.column.status": "Durum",
    "subscriptions.column.subscribed": "Abonelik tarihi",
    "Subscribed": "Abonelik tarihi",
    "subscriptions.column.expires": "Sona erme",
    "subscriptions.column.next_renewal": "Sonraki yenileme",
    "Next Renewal": "Sonraki yenileme",
    "subscriptions.column.amount_paid": "Ödenen tutar",
    "Amount Paid": "Ödenen tutar",
    "subscriptions.invoice_column.invoice_id": "Fatura kimliği",
    "Invoice ID": "Fatura kimliği",
    "subscriptions.invoice_column.account": "Hesap",
    "subscriptions.invoice_column.amount": "Tutar",
    "subscriptions.invoice_column.status": "Durum",
    "subscriptions.invoice_column.period": "Dönem",
    "subscriptions.invoice_column.paid_at": "Ödeme tarihi",
    "Paid At": "Ödeme tarihi",
    "subscriptions.validation.title_required": "Başlık gereklidir",
    "subscriptions.validation.allowed_listings_positive": "İzin verilen ilan sayısı 0’dan büyük olmalıdır",
    "Allowed listings should be greater than 0": "İzin verilen ilan sayısı 0’dan büyük olmalıdır",
    "subscriptions.validation.currency_required": "Para birimi gereklidir",
    "Currency is required": "Para birimi gereklidir",
    "subscriptions.validation.expiry_required": "Son kullanma süresi (gün) gereklidir",
    "Expiry days are required": "Son kullanma süresi (gün) gereklidir",
    "subscriptions.validation.payment_method_required": "Ödeme yöntemi gereklidir",
    "Payment method is required": "Ödeme yöntemi gereklidir",
    "subscriptions.error.save": "Abonelik kaydedilirken hata oluştu.",
    "Something went wrong while saving the subscription.": "Abonelik kaydedilirken hata oluştu.",
    "subscriptions.error.delete": "Abonelik silinirken hata oluştu.",
    "Something went wrong while deleting the subscription.": "Abonelik silinirken hata oluştu.",
    "common.configuration": "Yapılandırma",
    "subscriptions.per_period": "{period} başına",
    "per {period}": "{period} başına",
    "subscriptions.tab.subscribers": "Aboneler",
    "subscriptions.tab.invoices": "Faturalar",
    "subscriptions.account_title": "Hesap aboneliği",
    "Account Subscription": "Hesap aboneliği",
    "subscriptions.config.description": "Hesap aboneliklerini yönetin. Etkinleştirildiğinde hesap sahiplerinin ilan yayınlamak için etkin aboneliği olmalıdır. Abonelik ödemelerinde Ödeme Yöntemi bölümünde seçili varsayılan ödeme ağ geçidi kullanılır.",
    "Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.": "Hesap aboneliklerini yönetin. Etkinleştirildiğinde hesap sahiplerinin ilan yayınlamak için etkin aboneliği olmalıdır. Abonelik ödemelerinde Ödeme Yöntemi bölümünde seçili varsayılan ödeme ağ geçidi kullanılır.",
    "subscriptions.config.enable": "Abonelikleri etkinleştir",
    "Enable subscriptions": "Abonelikleri etkinleştir",
    "subscriptions.config.type": "Abonelik türü",
    "Subscription type": "Abonelik türü",
    "subscriptions.config.purchased_message": "Abonelik zaten satın alındığında gösterilen mesaj",
    "Message when a subscription is already purchased": "Abonelik zaten satın alındığında gösterilen mesaj",
    "subscriptions.config.purchased_placeholder": "Satın alınmış abonelik mesajını girin",
    "Enter the already-purchased message": "Satın alınmış abonelik mesajını girin",
    "subscriptions.config.listings_exhausted_message": "İlan sınırına ulaşıldığında gösterilen mesaj",
    "Message when the listing limit is reached": "İlan sınırına ulaşıldığında gösterilen mesaj",
    "subscriptions.config.listings_exhausted_placeholder": "İlan sınırı mesajını girin",
    "Enter the listing limit message": "İlan sınırı mesajını girin",
    "subscriptions.config.inactive_message": "Abonelik etkin olmadığında gösterilen mesaj",
    "Message when the subscription is inactive": "Abonelik etkin olmadığında gösterilen mesaj",
    "subscriptions.config.inactive_placeholder": "Etkin olmayan abonelik mesajını girin",
    "Enter the inactive subscription message": "Etkin olmayan abonelik mesajını girin",
    "subscriptions.config.saved": "Abonelik ayarları başarıyla kaydedildi",
    "Subscription settings saved successfully": "Abonelik ayarları başarıyla kaydedildi",
    "people.title": "Çalışanlar",
    "people.tab.staff": "Personel",
    "Staff": "Personel",
    "people.tab.departments": "Departmanlar",
    "Departments": "Departmanlar",
    "people.tab.job_profiles": "İş profilleri",
    "Job profiles": "İş profilleri",
    "people.tab.pay_grades": "Ücret kademeleri",
    "Pay grades": "Ücret kademeleri",
    "people.action.add_staff": "Personel ekle",
    "Add staff": "Personel ekle",
    "people.action.add_department": "Departman ekle",
    "Add department": "Departman ekle",
    "people.action.add_job_profile": "İş profili ekle",
    "Add job profile": "İş profili ekle",
    "people.action.add_pay_grade": "Ücret kademesi ekle",
    "Add pay grade": "Ücret kademesi ekle",
    "people.currency_id": "Para birimi kimliği",
    "people.onboarding.eyebrow": "Çalışanlarla çalışmaya başlayın",
    "Get started with People": "Çalışanlarla çalışmaya başlayın",
    "people.onboarding.title": "Ekip dizininizi oluşturun",
    "Build your team directory": "Ekip dizininizi oluşturun",
    "people.onboarding.description": "İlk personelinizi ekleyin, ardından ekibinizi departman, iş profili ve ücret kademelerine göre düzenleyin.",
    "Add your first staff member, then organize your team with departments, job profiles, and pay grades.": "İlk personelinizi ekleyin, ardından ekibinizi departman, iş profili ve ücret kademelerine göre düzenleyin.",
    "people.onboarding.add_first": "İlk personelinizi ekleyin",
    "Add your first staff member": "İlk personelinizi ekleyin",
    "people.onboarding.step_staff": "Personel ekle",
    "people.onboarding.step_staff_description": "Mevcut bir kullanıcıyı personel dizinine bağlayın.",
    "Link an existing user to your staff directory.": "Mevcut bir kullanıcıyı personel dizinine bağlayın.",
    "people.onboarding.step_teams": "Ekipleri düzenleyin",
    "Organize teams": "Ekipleri düzenleyin",
    "people.onboarding.step_teams_description": "Büyüdükçe departmanlar ve iş profilleri oluşturun.",
    "Create departments and job profiles as you grow.": "Büyüdükçe departmanlar ve iş profilleri oluşturun.",
    "people.onboarding.step_pay": "Ücretlendirmeyi belirleyin",
    "Set compensation": "Ücretlendirmeyi belirleyin",
    "people.onboarding.step_pay_description": "Tutarlı bordro ayarı için ücret kademelerini belirleyin.",
    "Define pay grades for consistent payroll setup.": "Tutarlı bordro ayarı için ücret kademelerini belirleyin.",
    "people.staff_profile": "Personel profili",
    "Staff profile": "Personel profili",
    "people.field.employee_code": "Çalışan kodu",
    "Employee code": "Çalışan kodu",
    "people.field.job_title": "İş unvanı",
    "Job title": "İş unvanı",
    "people.field.department": "Departman",
    "Department": "Departman",
    "people.field.job_profile": "İş profili",
    "Job profile": "İş profili",
    "people.field.pay_grade": "Ücret kademesi",
    "Pay grade": "Ücret kademesi",
    "people.field.employment_type": "Çalışma türü",
    "Employment type": "Çalışma türü",
    "people.field.start_date": "Başlangıç tarihi",
    "people.field.user_id": "Kullanıcı kimliği",
    "people.field.user": "Kullanıcı",
    "people.field.grade": "Kademe",
    "Grade": "Kademe",
    "people.field.salary_range": "Maaş aralığı",
    "Salary range": "Maaş aralığı",
    "people.field.minimum_salary": "En düşük maaş",
    "Minimum salary": "En düşük maaş",
    "people.field.maximum_salary": "En yüksek maaş",
    "Maximum salary": "En yüksek maaş",
    "people.field.currency_id": "Para birimi kimliği",
    "people.form.staff.edit": "Personeli düzenle",
    "Edit staff": "Personeli düzenle",
    "people.form.staff.add": "Personel ekle",
    "people.form.staff.description": "Mevcut bir kullanıcıyı personel profiline bağlayın.",
    "Link an existing user to a staff profile.": "Mevcut bir kullanıcıyı personel profiline bağlayın.",
    "people.form.department.edit": "Departmanı düzenle",
    "Edit department": "Departmanı düzenle",
    "people.form.department.add": "Departman ekle",
    "people.form.job_profile.edit": "İş profilini düzenle",
    "Edit job profile": "İş profilini düzenle",
    "people.form.job_profile.add": "İş profili ekle",
    "people.form.pay_grade.edit": "Ücret kademesini düzenle",
    "Edit pay grade": "Ücret kademesini düzenle",
    "people.form.pay_grade.add": "Ücret kademesi ekle",
    "people.placeholder.employee_code": "EMP-001",
    "EMP-001": "EMP-001",
    "people.placeholder.job_title": "Kıdemli Mühendis",
    "Senior Engineer": "Kıdemli Mühendis",
    "people.placeholder.department": "Mühendislik",
    "Engineering": "Mühendislik",
    "people.placeholder.department_description": "Ürün ve mühendislik ekibi",
    "Product & Engineering team": "Ürün ve mühendislik ekibi",
    "people.placeholder.pay_grade": "L3",
    "L3": "L3",
    "people.employment.full_time": "Tam zamanlı",
    "Full time": "Tam zamanlı",
    "people.employment.part_time": "Yarı zamanlı",
    "Part time": "Yarı zamanlı",
    "people.employment.contractor": "Yüklenici",
    "Contractor": "Yüklenici",
    "people.toast.staff_added": "Personel eklendi",
    "Staff added": "Personel eklendi",
    "people.toast.staff_updated": "Personel güncellendi",
    "Staff updated": "Personel güncellendi",
    "people.toast.department_added": "Departman eklendi",
    "Department added": "Departman eklendi",
    "people.toast.department_updated": "Departman güncellendi",
    "Department updated": "Departman güncellendi",
    "people.toast.job_profile_added": "İş profili eklendi",
    "Job profile added": "İş profili eklendi",
    "people.toast.job_profile_updated": "İş profili güncellendi",
    "Job profile updated": "İş profili güncellendi",
    "people.toast.pay_grade_added": "Ücret kademesi eklendi",
    "Pay grade added": "Ücret kademesi eklendi",
    "people.toast.pay_grade_updated": "Ücret kademesi güncellendi",
    "Pay grade updated": "Ücret kademesi güncellendi",
    "people.empty.staff": "Henüz personel yok. Başlamak için personel profili ekleyin.",
    "No staff yet. Add a staff profile to get started.": "Henüz personel yok. Başlamak için personel profili ekleyin.",
    "people.empty.departments": "Henüz departman yok.",
    "No departments yet.": "Henüz departman yok.",
    "people.empty.job_profiles": "Henüz iş profili yok.",
    "No job profiles yet.": "Henüz iş profili yok.",
    "people.empty.pay_grades": "Henüz ücret kademesi yok.",
    "No pay grades yet.": "Henüz ücret kademesi yok.",
    "people.pagination.page": "{page}. sayfa",
    "Page {page}": "{page}. sayfa",
    "workforce.title": "İş gücü",
    "workforce.tab.shifts": "Vardiyalar",
    "Shifts": "Vardiyalar",
    "workforce.tab.attendance": "Devam durumu",
    "Attendance": "Devam durumu",
    "workforce.tab.leave_requests": "İzin talepleri",
    "Leave requests": "İzin talepleri",
    "workforce.tab.leave_balances": "İzin bakiyeleri",
    "Leave balances": "İzin bakiyeleri",
    "workforce.tab.leave_policies": "İzin politikaları",
    "Leave policies": "İzin politikaları",
    "workforce.action.add_shift": "Vardiya ekle",
    "Add shift": "Vardiya ekle",
    "workforce.action.new_leave_request": "Yeni izin talebi",
    "New leave request": "Yeni izin talebi",
    "workforce.action.set_balance": "Bakiye belirle",
    "Set balance": "Bakiye belirle",
    "workforce.action.add_policy": "Politika ekle",
    "Add policy": "Politika ekle",
    "workforce.action.create_request": "Talep oluştur",
    "Create request": "Talep oluştur",
    "workforce.action.save_balance": "Bakiyeyi kaydet",
    "Save balance": "Bakiyeyi kaydet",
    "workforce.action.clock_in": "Mesaiye başla",
    "workforce.action.clock_out": "Mesaiyi bitir",
    "workforce.action.clocking_in": "Mesai başlatılıyor…",
    "Clocking in…": "Mesai başlatılıyor…",
    "workforce.action.clocking_out": "Mesai bitiriliyor…",
    "Clocking out…": "Mesai bitiriliyor…",
    "workforce.field.staff": "Personel",
    "workforce.field.start_time": "Başlangıç",
    "workforce.field.end_time": "Bitiş",
    "workforce.field.location": "Konum",
    "workforce.field.leave_type": "İzin türü",
    "Leave type": "İzin türü",
    "workforce.field.from": "Başlangıç",
    "workforce.field.to": "Bitiş",
    "workforce.field.days": "Gün",
    "Days": "Gün",
    "workforce.field.total_days": "Toplam gün",
    "Total days": "Toplam gün",
    "workforce.field.days_per_year": "Yıllık gün sayısı",
    "Days per year": "Yıllık gün sayısı",
    "workforce.field.carry_over": "Devret",
    "Carry over": "Devret",
    "workforce.field.carry_over_hint": "Kullanılmayan günler sonraki yıla devredilir",
    "Unused days carry over to next year": "Kullanılmayan günler sonraki yıla devredilir",
    "workforce.field.reason": "Neden",
    "workforce.field.time": "Saat",
    "workforce.field.clock_in": "Mesai başlangıcı",
    "workforce.field.clock_out": "Mesai bitişi",
    "workforce.field.hours": "Saat",
    "Hours": "Saat",
    "workforce.field.dates": "Tarihler",
    "Dates": "Tarihler",
    "workforce.field.used_days": "Kullanılan",
    "Used": "Kullanılan",
    "workforce.field.remaining_days": "Kalan gün",
    "workforce.field.policy": "Politika",
    "Policy": "Politika",
    "workforce.placeholder.location": "Merkez ofis",
    "HQ": "Merkez ofis",
    "workforce.placeholder.leave_note": "Aile tatili",
    "Family holiday": "Aile tatili",
    "workforce.placeholder.policy_name": "Yıllık izin",
    "Annual Leave": "Yıllık izin",
    "workforce.placeholder.reject_reason": "Yoğun dönem",
    "Busy period": "Yoğun dönem",
    "workforce.placeholder.optional_note": "İsteğe bağlı not",
    "Optional note": "İsteğe bağlı not",
    "workforce.select.all_staff": "Tüm personel",
    "All staff": "Tüm personel",
    "workforce.form.shift.add": "Vardiya ekle",
    "workforce.form.leave_request.add": "Yeni izin talebi",
    "workforce.form.leave_balance.title": "İzin bakiyesi belirle",
    "Set leave balance": "İzin bakiyesi belirle",
    "workforce.form.leave_balance.description": "Bir izin türü ve yıl için personelin kullanabileceği gün hakkını belirleyin.",
    "Initialize a staff member’s entitlement for a leave type and year.": "Bir izin türü ve yıl için personelin kullanabileceği gün hakkını belirleyin.",
    "workforce.form.leave_policy.add": "İzin politikası ekle",
    "Add leave policy": "İzin politikası ekle",
    "workforce.form.leave_request.reject": "İzin talebini reddet",
    "Reject leave request": "İzin talebini reddet",
    "workforce.form.clock_out": "Mesaiyi bitir",
    "workforce.toast.shift_added": "Vardiya eklendi",
    "Shift added": "Vardiya eklendi",
    "workforce.toast.leave_request_created": "İzin talebi oluşturuldu",
    "Leave request created": "İzin talebi oluşturuldu",
    "workforce.toast.leave_balance_saved": "İzin bakiyesi kaydedildi",
    "Leave balance saved": "İzin bakiyesi kaydedildi",
    "workforce.toast.leave_policy_added": "İzin politikası eklendi",
    "Leave policy added": "İzin politikası eklendi",
    "workforce.toast.leave_request_rejected": "İzin talebi reddedildi",
    "Leave request rejected": "İzin talebi reddedildi",
    "workforce.toast.leave_request_approved": "İzin talebi onaylandı",
    "Leave request approved": "İzin talebi onaylandı",
    "workforce.toast.clocked_in": "Mesai başladı",
    "Clocked in": "Mesai başladı",
    "workforce.toast.clocked_out": "Mesai bitti",
    "Clocked out": "Mesai bitti",
    "workforce.empty.shifts": "Bu dönemde vardiya yok.",
    "No shifts in this period.": "Bu dönemde vardiya yok.",
    "workforce.empty.attendance": "Devam kaydı yok.",
    "No attendance records.": "Devam kaydı yok.",
    "workforce.empty.leave_requests": "İzin talebi yok.",
    "No leave requests.": "İzin talebi yok.",
    "workforce.empty.leave_balances": "İzin bakiyesi yok. Eklemek için Bakiye belirle’yi kullanın.",
    "No leave balances. Use Set balance to add one.": "İzin bakiyesi yok. Eklemek için Bakiye belirle’yi kullanın.",
    "workforce.empty.leave_policies": "Henüz izin politikası yok.",
    "No leave policies yet.": "Henüz izin politikası yok.",
    "workforce.leave_type.annual": "Yıllık izin",
    "Annual leave": "Yıllık izin",
    "workforce.leave_type.sick": "Hastalık izni",
    "Sick leave": "Hastalık izni",
    "workforce.leave_type.unpaid": "Ücretsiz izin",
    "Unpaid leave": "Ücretsiz izin",
    "workforce.leave_type.parental": "Ebeveyn izni",
    "Parental leave": "Ebeveyn izni",
    "workforce.leave_type.compassionate": "Yas izni",
    "Compassionate leave": "Yas izni",
    "workforce.duration.hours_minutes": "{hours} sa {minutes} dk",
    "{hours}h {minutes}m": "{hours} sa {minutes} dk",
    "common.year": "Yıl",
    "Year": "Yıl",
    "common.approve": "Onayla",
    "common.reject": "Reddet",
    "payroll.title": "Bordro",
    "payroll.tab.runs": "Bordro çalıştırmaları",
    "Payroll runs": "Bordro çalıştırmaları",
    "payroll.tab.components": "Ücret bileşenleri",
    "Pay components": "Ücret bileşenleri",
    "payroll.tab.claims": "Masraf talepleri",
    "Expense claims": "Masraf talepleri",
    "payroll.tab.categories": "Masraf kategorileri",
    "Expense categories": "Masraf kategorileri",
    "payroll.action.new_run": "Yeni bordro çalıştırması",
    "New payroll run": "Yeni bordro çalıştırması",
    "payroll.action.add_component": "Ücret bileşeni ekle",
    "Add pay component": "Ücret bileşeni ekle",
    "payroll.action.new_claim": "Yeni masraf talebi",
    "New expense claim": "Yeni masraf talebi",
    "payroll.action.add_category": "Kategori ekle",
    "payroll.action.create_run": "Çalıştırma oluştur",
    "Create run": "Çalıştırma oluştur",
    "payroll.action.create_component": "Bileşen oluştur",
    "Create component": "Bileşen oluştur",
    "payroll.action.create_claim": "Talep oluştur",
    "Create claim": "Talep oluştur",
    "payroll.action.submit_claim": "Gönder",
    "Submit": "Gönder",
    "payroll.action.approve_claim": "Onayla",
    "payroll.action.reimburse_claim": "Geri öde",
    "Reimburse": "Geri öde",
    "payroll.action.approve_payroll": "Bordroyu onayla",
    "Approve payroll": "Bordroyu onayla",
    "payroll.action.activate": "Etkinleştir",
    "Activate": "Etkinleştir",
    "payroll.action.deactivate": "Devre dışı bırak",
    "payroll.action.adjust": "Düzelt",
    "payroll.action.save_adjustment": "Düzeltmeyi kaydet",
    "payroll.action.export_csv": "CSV dışa aktar",
    "Export CSV": "CSV dışa aktar",
    "payroll.action.exporting": "Dışa aktarılıyor…",
    "payroll.action.view_staff_items": "Personel kalemlerini görüntüle",
    "View staff items": "Personel kalemlerini görüntüle",
    "payroll.action.view_payslips": "Maaş bordrolarını görüntüle",
    "View payslips": "Maaş bordrolarını görüntüle",
    "payroll.type.addition": "Ek ödeme",
    "Addition": "Ek ödeme",
    "payroll.type.deduction": "Kesinti",
    "Deduction": "Kesinti",
    "payroll.calculation.fixed": "Sabit tutar",
    "Fixed amount": "Sabit tutar",
    "payroll.calculation.percentage": "Yüzde",
    "payroll.applies_to.all": "Tüm personel",
    "payroll.applies_to.hourly": "Saatlik çalışanlar",
    "Hourly staff": "Saatlik çalışanlar",
    "payroll.applies_to.salaried": "Maaşlı çalışanlar",
    "Salaried staff": "Maaşlı çalışanlar",
    "payroll.category.archive_confirm": "{name} arşivlensin mi?",
    "payroll.components.description": "Etkin ek ödemeler ve kesintiler yeni bordro çalışmalarına otomatik uygulanır.",
    "Active additions and deductions are applied automatically to new payroll runs.": "Etkin ek ödemeler ve kesintiler yeni bordro çalışmalarına otomatik uygulanır.",
    "payroll.empty.categories": "Henüz masraf kategorisi yok.",
    "No expense categories yet.": "Henüz masraf kategorisi yok.",
    "payroll.empty.claims": "Henüz masraf talebi yok.",
    "No expense claims yet.": "Henüz masraf talebi yok.",
    "payroll.empty.components": "Henüz ücret bileşeni yapılandırılmadı.",
    "No pay components configured yet.": "Henüz ücret bileşeni yapılandırılmadı.",
    "payroll.empty.runs": "Henüz bordro çalıştırması yok.",
    "No payroll runs yet.": "Henüz bordro çalıştırması yok.",
    "payroll.field.staff": "Personel",
    "payroll.field.base_pay": "Temel ücret",
    "Base pay": "Temel ücret",
    "payroll.field.allowances": "Ödenekler",
    "Allowances": "Ödenekler",
    "payroll.field.deductions": "Kesintiler",
    "Deductions": "Kesintiler",
    "payroll.field.commission": "Komisyon",
    "payroll.field.net_pay": "Net ücret",
    "Net pay": "Net ücret",
    "payroll.field.components": "Bileşenler",
    "Components": "Bileşenler",
    "payroll.field.commission_override": "Komisyonu geçersiz kıl",
    "Commission override": "Komisyonu geçersiz kıl",
    "payroll.field.calculation": "Hesaplama",
    "Calculation": "Hesaplama",
    "payroll.field.applies_to": "Uygulandığı kişiler",
    "Applies to": "Uygulandığı kişiler",
    "payroll.field.staff_optional_draft": "Personel (taslakta isteğe bağlı)",
    "Staff (optional while drafting)": "Personel (taslakta isteğe bağlı)",
    "payroll.field.category_optional_draft": "Kategori (taslakta isteğe bağlı)",
    "Category (optional while drafting)": "Kategori (taslakta isteğe bağlı)",
    "payroll.field.category": "Kategori",
    "payroll.field.period": "Dönem",
    "payroll.field.period_start": "Dönem başlangıcı",
    "Period start": "Dönem başlangıcı",
    "payroll.field.period_end": "Dönem bitişi",
    "Period end": "Dönem bitişi",
    "payroll.field.generate_email_payslips": "Maaş bordrolarını oluşturup e-postayla gönder",
    "Generate and email payslips": "Maaş bordrolarını oluşturup e-postayla gönder",
    "payroll.field.gl_code": "Büyük defter kodu",
    "GL code": "Büyük defter kodu",
    "payroll.field.maximum_per_claim": "Talep başına en fazla",
    "Maximum per claim": "Talep başına en fazla",
    "payroll.field.maximum_per_transaction": "İşlem başına en fazla",
    "Maximum per transaction": "İşlem başına en fazla",
    "payroll.field.spending_cap": "Harcama sınırı",
    "Spending cap": "Harcama sınırı",
    "payroll.field.tax_rate": "Vergi oranı (%)",
    "Tax rate (%)": "Vergi oranı (%)",
    "payroll.field.no_limit": "Sınır yok",
    "No limit": "Sınır yok",
    "payroll.form.run.title": "Yeni bordro çalıştırması",
    "payroll.form.run.description": "Ücret, seçilen dönem için personel ücret kademelerine göre hesaplanır.",
    "Pay is calculated from staff pay grades for the selected period.": "Ücret, seçilen dönem için personel ücret kademelerine göre hesaplanır.",
    "payroll.form.component.title": "Ücret bileşeni ekle",
    "payroll.form.component.description": "Bileşenler sonraki bordro çalışmalarına otomatik eklenir.",
    "Components are automatically included in future payroll runs.": "Bileşenler sonraki bordro çalışmalarına otomatik eklenir.",
    "payroll.form.claim.title": "Yeni masraf talebi",
    "payroll.form.claim.description": "Talep onaya gönderilene kadar taslak olarak kalır.",
    "Claims start as drafts until submitted for approval.": "Talep onaya gönderilene kadar taslak olarak kalır.",
    "payroll.form.category.add": "Masraf kategorisi ekle",
    "Add expense category": "Masraf kategorisi ekle",
    "payroll.form.category.edit": "Masraf kategorisini düzenle",
    "Edit expense category": "Masraf kategorisini düzenle",
    "payroll.form.claim.approve_title": "Masraf talebini onayla",
    "Approve expense claim": "Masraf talebini onayla",
    "payroll.form.run.approve_title": "Bordro çalışmasını onayla",
    "Approve payroll run": "Bordro çalışmasını onayla",
    "payroll.form.run.approve_description": "Onay bordro çalışmasını kilitler. Maaş bordrolarını şimdi oluşturup e-postayla gönderebilirsiniz.",
    "Approval locks the payroll run. You can also generate and email payslips now.": "Onay bordro çalışmasını kilitler. Maaş bordrolarını şimdi oluşturup e-postayla gönderebilirsiniz.",
    "payroll.items.title": "Personel bordro kalemleri",
    "Staff payroll items": "Personel bordro kalemleri",
    "payroll.items.loading": "Bordro kalemleri yükleniyor…",
    "Loading payroll items…": "Bordro kalemleri yükleniyor…",
    "payroll.items.empty": "Bordro kalemi bulunamadı.",
    "No payroll items found.": "Bordro kalemi bulunamadı.",
    "payroll.items.adjust_title": "Bordro kalemini düzelt",
    "Adjust payroll item": "Bordro kalemini düzelt",
    "payroll.items.adjust_description": "Bu personel için kesintileri veya komisyon tutarını düzenleyin.",
    "Update deductions or override the commission amount for this staff member.": "Bu personel için kesintileri veya komisyon tutarını düzenleyin.",
    "payroll.payslips.title": "Maaş bordroları",
    "Payslips": "Maaş bordroları",
    "payroll.payslips.generate": "Maaş bordrosu oluştur",
    "Generate payslips": "Maaş bordrosu oluştur",
    "payroll.payslips.generating": "Oluşturuluyor…",
    "Generating…": "Oluşturuluyor…",
    "payroll.payslips.empty": "Henüz maaş bordrosu oluşturulmadı.",
    "No payslips generated yet.": "Henüz maaş bordrosu oluşturulmadı.",
    "payroll.payslips.generated": "Oluşturuldu",
    "Generated": "Oluşturuldu",
    "payroll.payslips.sent_at": "{date} tarihinde gönderildi",
    "Sent {date}": "{date} tarihinde gönderildi",
    "payroll.payslips.not_sent": "Gönderilmedi",
    "Not sent": "Gönderilmedi",
    "payroll.payslips.send_email": "E-posta gönder",
    "Send email": "E-posta gönder",
    "payroll.payslips.sending": "Gönderiliyor…",
    "payroll.payslips.details": "Maaş bordrosu ayrıntıları",
    "Payslip details": "Maaş bordrosu ayrıntıları",
    "payroll.placeholder.approval_note": "Onaylandı",
    "payroll.placeholder.category_name": "Seyahat",
    "Travel": "Seyahat",
    "payroll.placeholder.claim_description": "Müşteriye uçuş",
    "Flight to client": "Müşteriye uçuş",
    "payroll.placeholder.component_name": "Ulaşım ödeneği",
    "Transport Allowance": "Ulaşım ödeneği",
    "payroll.staff_number": "Personel #{id}",
    "Staff #{id}": "Personel #{id}",
    "payroll.toast.category_added": "Masraf kategorisi eklendi",
    "Expense category added": "Masraf kategorisi eklendi",
    "payroll.toast.category_archived": "Masraf kategorisi arşivlendi",
    "Expense category archived": "Masraf kategorisi arşivlendi",
    "payroll.toast.category_updated": "Masraf kategorisi güncellendi",
    "Expense category updated": "Masraf kategorisi güncellendi",
    "payroll.toast.claim_approved": "Talep onaylandı",
    "Claim approved": "Talep onaylandı",
    "payroll.toast.claim_created": "Masraf talebi oluşturuldu",
    "Expense claim created": "Masraf talebi oluşturuldu",
    "payroll.toast.claim_reimbursed": "Talep geri ödendi olarak işaretlendi",
    "Claim marked as reimbursed": "Talep geri ödendi olarak işaretlendi",
    "payroll.toast.claim_submitted": "Talep gönderildi",
    "Claim submitted": "Talep gönderildi",
    "payroll.toast.component_activated": "Ücret bileşeni etkinleştirildi",
    "Pay component activated": "Ücret bileşeni etkinleştirildi",
    "payroll.toast.component_created": "Ücret bileşeni oluşturuldu",
    "Pay component created": "Ücret bileşeni oluşturuldu",
    "payroll.toast.component_deactivated": "Ücret bileşeni devre dışı bırakıldı",
    "Pay component deactivated": "Ücret bileşeni devre dışı bırakıldı",
    "payroll.toast.item_updated": "Bordro kalemi güncellendi",
    "Payroll item updated": "Bordro kalemi güncellendi",
    "payroll.toast.payslip_email_sent": "Maaş bordrosu e-postası gönderildi",
    "Payslip email sent": "Maaş bordrosu e-postası gönderildi",
    "payroll.toast.payslips_generated": "Maaş bordroları oluşturuldu",
    "Payslips generated": "Maaş bordroları oluşturuldu",
    "payroll.toast.run_approved": "Bordro çalışması onaylandı",
    "Payroll run approved": "Bordro çalışması onaylandı",
    "payroll.toast.run_approved_payslips_queued": "Bordro onaylandı ve maaş bordroları sıraya alındı",
    "Payroll approved and payslips queued": "Bordro onaylandı ve maaş bordroları sıraya alındı",
    "payroll.toast.run_created": "Bordro çalışması oluşturuldu",
    "Payroll run created": "Bordro çalışması oluşturuldu",
    "payroll.toast.exported": "Bordro dışa aktarıldı",
    "Payroll exported": "Bordro dışa aktarıldı",
    "common.notes": "Notlar",
    "expenses.title": "Masraflar",
    "expenses.action.add": "Masraf ekle",
    "Add expense": "Masraf ekle",
    "expenses.action.create": "Masraf oluştur",
    "Create expense": "Masraf oluştur",
    "expenses.action.submit": "Gönder",
    "expenses.action.approve": "Onayla",
    "expenses.action.reimburse": "Geri öde",
    "expenses.action.pay": "Öde",
    "expenses.action.lifecycle": "Masraf {action}",
    "Expense {action}d": "Masraf {action}",
    "expenses.type.claim": "Talep",
    "Claim": "Talep",
    "expenses.type.claims": "Talepler",
    "Claims": "Talepler",
    "expenses.type.bill": "Fatura",
    "Bill": "Fatura",
    "expenses.type.bills": "Faturalar",
    "Bills": "Faturalar",
    "expenses.filter.all_types": "Tüm türler",
    "All types": "Tüm türler",
    "expenses.filter.all_statuses": "Tüm durumlar",
    "expenses.summary.title": "Özet",
    "Summary": "Özet",
    "expenses.summary.by_category": "Kategoriye göre",
    "By category": "Kategoriye göre",
    "expenses.summary.by_status": "Duruma göre",
    "By status": "Duruma göre",
    "expenses.summary.by_party": "Tedarikçi / personele göre",
    "By supplier / staff": "Tedarikçi / personele göre",
    "expenses.summary.heading": "{group} özeti",
    "Summary by {group}": "{group} özeti",
    "expenses.summary.group.category": "kategori",
    "category": "kategori",
    "expenses.summary.group.status": "durum",
    "status": "durum",
    "expenses.summary.group.party": "tedarikçi / personel",
    "supplier / staff": "tedarikçi / personel",
    "expenses.summary.empty": "Özet yok.",
    "No summary available.": "Özet yok.",
    "expenses.column.type": "Tür",
    "expenses.column.party": "Personel / Tedarikçi",
    "Staff / Supplier": "Personel / Tedarikçi",
    "expenses.column.status": "Durum",
    "expenses.field.staff_optional": "Personel (taslakta isteğe bağlı)",
    "expenses.field.supplier_optional": "Tedarikçi (taslakta isteğe bağlı)",
    "Supplier (optional while drafting)": "Tedarikçi (taslakta isteğe bağlı)",
    "expenses.field.category_optional": "Kategori (taslakta isteğe bağlı)",
    "expenses.field.amount": "Tutar",
    "expenses.field.currency": "Para birimi",
    "expenses.field.description": "Açıklama",
    "expenses.field.due_date": "Son ödeme tarihi",
    "Due date": "Son ödeme tarihi",
    "expenses.field.receipt_url": "Makbuz URL’si",
    "Receipt URL": "Makbuz URL’si",
    "expenses.empty": "Seçilen filtrelerle eşleşen masraf yok.",
    "No expenses found for the selected filters.": "Seçilen filtrelerle eşleşen masraf yok.",
    "expenses.modal.edit": "Masrafı düzenle",
    "Edit expense": "Masrafı düzenle",
    "expenses.modal.add": "{type} ekle",
    "Add {type}": "{type} ekle",
    "expenses.modal.bill_help": "Taslağı oluşturun ve göndermeden önce tedarikçi atayın.",
    "Create the draft now and assign a supplier before submitting.": "Taslağı oluşturun ve göndermeden önce tedarikçi atayın.",
    "expenses.modal.claim_help": "Taslağı oluşturun ve göndermeden önce personel atayın.",
    "Create the draft now and assign a staff member before submitting.": "Taslağı oluşturun ve göndermeden önce personel atayın.",
    "expenses.toast.updated": "Masraf güncellendi",
    "Expense updated": "Masraf güncellendi",
    "expenses.toast.created": "Masraf oluşturuldu",
    "Expense created": "Masraf oluşturuldu",
    "recurring_payments.title": "Yinelenen ödemeler",
    "recurring_payments.action.add": "Yinelenen ödeme ekle",
    "Add recurring payment": "Yinelenen ödeme ekle",
    "recurring_payments.action.create": "Yinelenen ödeme oluştur",
    "Create recurring payment": "Yinelenen ödeme oluştur",
    "recurring_payments.action.pause": "Duraklat",
    "Pause": "Duraklat",
    "recurring_payments.action.resume": "Sürdür",
    "Resume": "Sürdür",
    "recurring_payments.action.remove": "Kaldır",
    "recurring_payments.description": "Düzenli tedarikçi ödemeleri için masraf faturası taslaklarını otomatik oluşturun.",
    "Automatically create draft expense bills for regular supplier payments.": "Düzenli tedarikçi ödemeleri için masraf faturası taslaklarını otomatik oluşturun.",
    "recurring_payments.field.name": "Ad",
    "recurring_payments.field.supplier": "Tedarikçi",
    "recurring_payments.field.supplier_optional": "Tedarikçi (isteğe bağlı)",
    "Supplier (optional)": "Tedarikçi (isteğe bağlı)",
    "recurring_payments.field.frequency": "Sıklık",
    "Frequency": "Sıklık",
    "recurring_payments.field.next_due": "Sonraki vade tarihi",
    "Next due date": "Sonraki vade tarihi",
    "recurring_payments.field.auto_create": "Fatura taslağını otomatik oluştur",
    "Auto-create draft bill": "Fatura taslağını otomatik oluştur",
    "recurring_payments.field.auto_create_help": "Masraf faturası taslağını otomatik oluştur",
    "Create a draft expense bill automatically": "Masraf faturası taslağını otomatik oluştur",
    "recurring_payments.field.one_time": "Tek seferlik ödeme",
    "One-time payment": "Tek seferlik ödeme",
    "recurring_payments.field.one_time_help": "Sonraki fatura oluşturulduktan sonra bitir",
    "End after the next generated bill": "Sonraki fatura oluşturulduktan sonra bitir",
    "recurring_payments.field.end_date": "Bitiş tarihi",
    "recurring_payments.placeholder.name": "Ofis kirası",
    "Office Rent": "Ofis kirası",
    "recurring_payments.frequency.daily": "Günlük",
    "recurring_payments.frequency.weekly": "Haftalık",
    "recurring_payments.frequency.monthly": "Aylık",
    "recurring_payments.frequency.quarterly": "Üç aylık",
    "recurring_payments.frequency.yearly": "Yıllık",
    "Yearly": "Yıllık",
    "recurring_payments.form.description": "Otomatik oluşturma etkinse vadesi gelen ödemeler Masraflar’da fatura taslakları oluşturur.",
    "Due payments automatically create draft bills in Expenses when auto-create is enabled.": "Otomatik oluşturma etkinse vadesi gelen ödemeler Masraflar’da fatura taslakları oluşturur.",
    "recurring_payments.empty": "Henüz yinelenen ödeme yok.",
    "No recurring payments yet.": "Henüz yinelenen ödeme yok.",
    "recurring_payments.this_payment": "bu yinelenen ödeme",
    "this recurring payment": "bu yinelenen ödeme",
    "recurring_payments.confirm_remove": "{name} kaldırılsın mı?",
    "Remove {name}?": "{name} kaldırılsın mı?",
    "recurring_payments.toast.pause": "Yinelenen ödeme duraklatıldı",
    "Recurring payment paused": "Yinelenen ödeme duraklatıldı",
    "recurring_payments.toast.resume": "Yinelenen ödeme sürdürüldü",
    "Recurring payment resumed": "Yinelenen ödeme sürdürüldü",
    "recurring_payments.toast.delete": "Yinelenen ödeme kaldırıldı",
    "Recurring payment removed": "Yinelenen ödeme kaldırıldı",
    "recurring_payments.toast.created": "Yinelenen ödeme oluşturuldu",
    "Recurring payment created": "Yinelenen ödeme oluşturuldu",
    "expenses.toast.submit": "Masraf gönderildi",
    "Expense submitted": "Masraf gönderildi",
    "expenses.toast.approve": "Masraf onaylandı",
    "Expense approved": "Masraf onaylandı",
    "expenses.toast.reimburse": "Masraf geri ödendi",
    "Expense reimbursed": "Masraf geri ödendi",
    "expenses.toast.pay": "Masraf ödendi",
    "Expense paid": "Masraf ödendi",
    "media_picker.title": "Medya seç",
    "Select media": "Medya seç",
    "media_picker.type.media": "Medya",
    "media_picker.type.all": "Tümü",
    "media_picker.type.image": "Görsel",
    "media_picker.type.video": "Video",
    "media_picker.type.audio": "Ses",
    "media_picker.type.pdf": "PDF",
    "media_picker.type.csv": "CSV",
    "media_picker.type.folder": "Klasör",
    "media_picker.label.show": "Göster",
    "media_picker.label.media_type": "Medya türü",
    "Media type": "Medya türü",
    "media_picker.action.show_type": "{type} medyalarını göster",
    "media_picker.action.close": "Medya seçiciyi kapat",
    "Close media picker": "Medya seçiciyi kapat",
    "media_picker.action.upload": "Medya yükle",
    "media_picker.action.creating": "Oluşturuluyor…",
    "media_picker.action.create_folder": "Klasör oluştur",
    "Create folder": "Klasör oluştur",
    "media_picker.action.cancel": "İptal",
    "media_picker.action.use_selected": "Seçileni kullan",
    "Use selected": "Seçileni kullan",
    "media_picker.placeholder.search": "Medya ara",
    "media_picker.placeholder.folder": "Yeni klasör adı",
    "New folder name": "Yeni klasör adı",
    "media_picker.loading": "Medya yükleniyor…",
    "media_picker.empty": "Bu klasörde medya bulunamadı.",
    "No media found in this folder.": "Bu klasörde medya bulunamadı.",
    "media_picker.selection.count": "{count} seçildi",
    "{count} selected": "{count} seçildi",
    "media_picker.selection.prompt": "Devam etmek için dosya seçin",
    "Select a file to continue": "Devam etmek için dosya seçin",
    "media_picker.error.load": "Medya yüklenemedi",
    "Unable to load media": "Medya yüklenemedi",
    "media_picker.error.load_retry": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "media_picker.error.create_folder": "Klasör oluşturulamadı",
    "media_picker.error.create_folder_retry": "Klasör oluşturulamadı. Lütfen tekrar deneyin.",
    "Unable to create folder. Please try again.": "Klasör oluşturulamadı. Lütfen tekrar deneyin.",
    "media_picker.error.prepare_upload": "Yükleme hazırlanamadı",
    "Unable to prepare upload": "Yükleme hazırlanamadı",
    "media_picker.error.upload_url": "Yükleme URL’si eksik",
    "Upload URL missing": "Yükleme URL’si eksik",
    "media_picker.error.register_media": "Medya kaydedilemedi",
    "media_picker.error.upload_retry": "Medya yüklenemedi. Lütfen tekrar deneyin.",
    "membership.title": "Üyelik",
    "membership.description": "Üyelik programlarını, üye katkılarını, ödeme durumlarını ve hatırlatma kurallarını yönetin.",
    "Manage membership programs, member contributions, payment status, and reminder rules.": "Üyelik programlarını, üye katkılarını, ödeme durumlarını ve hatırlatma kurallarını yönetin.",
    "membership.action.settings": "Ayarlar",
    "membership.action.manage_programs": "Programları yönet",
    "Manage programs": "Programları yönet",
    "membership.action.view_data": "Verileri görüntüle",
    "View data": "Verileri görüntüle",
    "membership.action.edit_listing": "İlanı düzenle",
    "membership.action.go_to_listings": "İlanlara git",
    "Go to listings": "İlanlara git",
    "membership.action.view_order": "Siparişi görüntüle",
    "View order": "Siparişi görüntüle",
    "membership.action.configure_reminders": "Hatırlatıcıları yapılandır",
    "Configure reminders": "Hatırlatıcıları yapılandır",
    "membership.stat.programs": "Programlar",
    "membership.stat.active_members": "Etkin üyeler",
    "Active members": "Etkin üyeler",
    "membership.stat.contributions": "Katkılar",
    "Contributions": "Katkılar",
    "membership.stat.units": "Yüklenen birimler",
    "Units credited": "Yüklenen birimler",
    "membership.programs.title": "Programlar",
    "membership.programs.description": "Müşterilerinize sunulan üyelik türündeki ilanlar.",
    "Membership-type listings available to your customers.": "Müşterilerinize sunulan üyelik türündeki ilanlar.",
    "membership.programs.no_description": "Henüz program açıklaması yok.",
    "No program description yet.": "Henüz program açıklaması yok.",
    "membership.programs.empty_title": "Henüz üyelik programı yok",
    "No membership programs yet": "Henüz üyelik programı yok",
    "membership.programs.empty_description": "Katkı almaya başlamak için üyelik türünde ilan oluşturun.",
    "Create a listing with type membership to start accepting contributions.": "Katkı almaya başlamak için üyelik türünde ilan oluşturun.",
    "membership.programs.history_description": "Fiyat geçmişi ve kayıtlı üyeler.",
    "Price history and enrolled members.": "Fiyat geçmişi ve kayıtlı üyeler.",
    "membership.badge": "Üyelik",
    "membership.loading_program": "Program verileri yükleniyor…",
    "Loading program data…": "Program verileri yükleniyor…",
    "membership.price_logs.title": "Fiyat kayıtları",
    "Price logs": "Fiyat kayıtları",
    "membership.price_logs.empty": "Fiyat kaydı yok.",
    "No price logs recorded.": "Fiyat kaydı yok.",
    "membership.source.manual": "manuel",
    "manual": "manuel",
    "membership.members.title": "Üyeler",
    "Members": "Üyeler",
    "membership.members.empty_program": "Bu programa henüz üye yok.",
    "No members enrolled in this program.": "Bu programa henüz üye yok.",
    "membership.members.recent": "Son üyeler",
    "Recent members": "Son üyeler",
    "membership.members.empty_recent": "Kayıt sonrasında üyeler ve katkılar burada görünür.",
    "Members and contributions will appear here after enrolment.": "Kayıt sonrasında üyeler ve katkılar burada görünür.",
    "membership.member_heading": "Üye: {member}",
    "Member: {member}": "Üye: {member}",
    "membership.contributions.title": "Katkılar",
    "membership.contributions.empty": "Henüz katkı yok.",
    "No contributions recorded yet.": "Henüz katkı yok.",
    "membership.payment_dues.title": "Ödeme vadeleri",
    "Payment dues": "Ödeme vadeleri",
    "membership.payment_dues.empty": "Planlanmış ödeme vadesi yok.",
    "No scheduled payment dues.": "Planlanmış ödeme vadesi yok.",
    "membership.unit": "birim",
    "unit": "birim",
    "membership.units": "birim",
    "units": "birim",
    "membership.months": "ay",
    "membership.automation.label": "OTOMASYON",
    "AUTOMATION": "OTOMASYON",
    "membership.automation.description": "Günlük işlem, planlanmış üyelik ödemelerini kontrol eder.",
    "Daily worker checks scheduled membership payments.": "Günlük işlem, planlanmış üyelik ödemelerini kontrol eder.",
    "membership.reminders.title": "Ödeme hatırlatıcıları",
    "Payment reminders": "Ödeme hatırlatıcıları",
    "membership.reminders.due_soon": "Yaklaşan ödeme hatırlatması",
    "Due-soon reminder": "Yaklaşan ödeme hatırlatması",
    "membership.reminders.due_soon_short": "Vadesi yaklaşıyor",
    "Due soon": "Vadesi yaklaşıyor",
    "membership.reminders.due_soon_help": "Planlanan ödeme vadesinden önce bir hatırlatma gönderin.",
    "Send one reminder before a scheduled payment is due.": "Planlanan ödeme vadesinden önce bir hatırlatma gönderin.",
    "membership.reminders.days_before": "Vade öncesi gün sayısı",
    "Days before due date": "Vade öncesi gün sayısı",
    "membership.reminders.days_before_value": "{count} gün önce",
    "{count} days before": "{count} gün önce",
    "membership.reminders.overdue": "Gecikmiş ödeme hatırlatması",
    "Overdue reminder": "Gecikmiş ödeme hatırlatması",
    "membership.reminders.overdue_help": "Vade ve ek süre geçtikten sonra bir hatırlatma gönderin.",
    "Send one reminder after the due date and grace period.": "Vade ve ek süre geçtikten sonra bir hatırlatma gönderin.",
    "membership.settings.title": "Üyelik ayarları",
    "Membership settings": "Üyelik ayarları",
    "membership.settings.description": "Ödeme hatırlatma takvimini yapılandırın.",
    "Configure the payment reminder schedule.": "Ödeme hatırlatma takvimini yapılandırın.",
    "membership.email_copy.title": "Özel e-posta metni",
    "Custom email copy": "Özel e-posta metni",
    "membership.email_copy.description": "Vadesi yaklaşan ve geciken ödemelerin konu ve şablonlarını düzenlemek için Ayarlar → Bildirimler → Üyelik bölümüne gidin.",
    "Use Settings → Notifications → Membership to edit the due-soon and overdue subjects and templates.": "Vadesi yaklaşan ve geciken ödemelerin konu ve şablonlarını düzenlemek için Ayarlar → Bildirimler → Üyelik bölümüne gidin.",
    "membership.toast.saved": "Üyelik hatırlatma ayarları kaydedildi.",
    "Membership reminder settings saved.": "Üyelik hatırlatma ayarları kaydedildi.",
    "membership.toast.save_failed": "Hatırlatma ayarları kaydedilemedi.",
    "Unable to save membership reminder settings.": "Hatırlatma ayarları kaydedilemedi.",
    "common.status.off": "Kapalı",
    "Off": "Kapalı",
    "common.status.on": "Açık",
    "On": "Açık",
    "common.save_settings": "Ayarları kaydet",
    "Save settings": "Ayarları kaydet",
    "developer.page.title": "API ve Geliştirici",
    "API & Developer": "API ve Geliştirici",
    "developer.api_keys.title": "API anahtarları",
    "API Keys": "API anahtarları",
    "developer.api_keys.description": "Tradly API isteklerini doğrulamak için bu anahtarları kullanın. Gizli Anahtarınızı saklayın ve istemci tarafı kodda asla paylaşmayın.",
    "Use these keys to authenticate requests to the Tradly API. Keep your Secret Key private — never expose it in client-side code.": "Tradly API isteklerini doğrulamak için bu anahtarları kullanın. Gizli Anahtarınızı saklayın ve istemci tarafı kodda asla paylaşmayın.",
    "developer.api_keys.credentials_description": "Aşağıda üretim anahtarlarınız bulunur. Uygulamalarınızı yetkilendirmek ve oluşturmak için bunları kullanın.",
    "Find below your production keys. You will need to use these keys to authorise and build your apps.": "Aşağıda üretim anahtarlarınız bulunur. Uygulamalarınızı yetkilendirmek ve oluşturmak için bunları kullanın.",
    "developer.api_keys.publishable": "Yayınlanabilir Anahtar",
    "Publishable Key": "Yayınlanabilir Anahtar",
    "developer.api_keys.publishable_placeholder": "Yayınlanabilir Anahtarı girin",
    "Enter Publishable Key": "Yayınlanabilir Anahtarı girin",
    "developer.api_keys.secret": "Gizli Anahtar",
    "developer.api_keys.secret_placeholder": "Gizli Anahtarı girin",
    "Enter Secret Key": "Gizli Anahtarı girin",
    "developer.api_keys.access_label": "API erişimi",
    "API access": "API erişimi",
    "developer.api_reference.title": "API başvurusu",
    "developer.api_reference.description": "Tradly pazaryeriniz üzerinde geliştirme için REST API belgeleri, kılavuzlar ve kod örnekleri.",
    "Full REST API documentation, guides, and code examples for building on top of your Tradly marketplace.": "Tradly pazaryeriniz üzerinde geliştirme için REST API belgeleri, kılavuzlar ve kod örnekleri.",
    "developer.api_reference.card_description": "Pazaryerinizde entegrasyon veya özel arayüz geliştirmek için API başvurusu, kimlik doğrulama kılavuzları, webhook ve SDK belgelerini inceleyin.",
    "Explore the complete API reference, authentication guides, webhooks, and SDK documentation. Everything you need to integrate or build custom frontends on top of your marketplace.": "Pazaryerinizde entegrasyon veya özel arayüz geliştirmek için API başvurusu, kimlik doğrulama kılavuzları, webhook ve SDK belgelerini inceleyin.",
    "developer.api_reference.open_docs": "API belgelerini aç",
    "Open API Docs": "API belgelerini aç",
    "developer.ai_agents.title": "Yapay zekâ ve ajanlar",
    "AI & Agents": "Yapay zekâ ve ajanlar",
    "developer.ai_agents.description": "Pazaryerinizi yapay zekâ araçlarına bağlayın ve müşterilerinizin platformunuzla çalışan ajanlar oluşturmasını sağlayın.",
    "Connect your marketplace to AI tools and let customers build agents powered by your platform.": "Pazaryerinizi yapay zekâ araçlarına bağlayın ve müşterilerinizin platformunuzla çalışan ajanlar oluşturmasını sağlayın.",
    "developer.mcp.action.create": "Oluştur",
    "developer.mcp.action.removing": "Kaldırılıyor…",
    "developer.mcp.scope.resource": "Kaynak",
    "developer.customer_agents.description": "Müşterilerinizin pazaryerinizle etkileşim kuran yapay zekâ ajanları oluşturmasını sağlayın. ChatGPT, Claude ve diğer platformlarla uyumludur. Alıcı iş akışlarını otomatikleştirmek, özel mağazalar kurmak veya akıllı alışveriş asistanları oluşturmak için idealdir.",
    "Let your customers build AI agents that interact with your marketplace. Compatible with ChatGPT, Claude, and other AI platforms. Ideal for automating buyer workflows, building custom storefronts, or creating intelligent shopping assistants.": "Müşterilerinizin pazaryerinizle etkileşim kuran yapay zekâ ajanları oluşturmasını sağlayın. ChatGPT, Claude ve diğer platformlarla uyumludur. Alıcı iş akışlarını otomatikleştirmek, özel mağazalar kurmak veya akıllı alışveriş asistanları oluşturmak için idealdir.",
    "whatsapp.title": "WhatsApp bağlayıcısı",
    "WhatsApp connector": "WhatsApp bağlayıcısı",
    "whatsapp.intro.title": "WhatsApp üzerinden OTP ve pazarlama mesajları gönderin",
    "Send OTPs and marketing messages through WhatsApp": "WhatsApp üzerinden OTP ve pazarlama mesajları gönderin",
    "whatsapp.intro.help": "Bu kiracıyı Meta WhatsApp Cloud API’ye bağlayın. SMS varsayılan veya yedek kanal olarak kullanılabilir; aynı bağlayıcı onaylı WhatsApp kampanya şablonlarını da gönderebilir.",
    "Connect this tenant to Meta WhatsApp Cloud API. SMS remains available as the default or fallback channel, and the same connector can deliver approved WhatsApp campaign templates.": "Bu kiracıyı Meta WhatsApp Cloud API’ye bağlayın. SMS varsayılan veya yedek kanal olarak kullanılabilir; aynı bağlayıcı onaylı WhatsApp kampanya şablonlarını da gönderebilir.",
    "whatsapp.status.disabled": "Devre dışı",
    "whatsapp.status.sms_otp": "Bağlayıcı açık · SMS OTP",
    "Connector on · SMS OTP": "Bağlayıcı açık · SMS OTP",
    "whatsapp.status.needs_configuration": "Yapılandırma gerekiyor",
    "Needs configuration": "Yapılandırma gerekiyor",
    "whatsapp.status.auto_fallback": "SMS yedekli WhatsApp",
    "WhatsApp with SMS fallback": "SMS yedekli WhatsApp",
    "whatsapp.status.sms_whatsapp_backup": "WhatsApp yedekli SMS",
    "SMS with WhatsApp backup": "WhatsApp yedekli SMS",
    "whatsapp.status.enabled": "WhatsApp etkin",
    "WhatsApp enabled": "WhatsApp etkin",
    "whatsapp.draft.notice": "Kaydedilmemiş WhatsApp ayar taslağınız var.",
    "You have an unsaved WhatsApp settings draft.": "Kaydedilmemiş WhatsApp ayar taslağınız var.",
    "whatsapp.connect.title": "İşletme WhatsApp hesabınızı bağlayın",
    "Connect your business WhatsApp": "İşletme WhatsApp hesabınızı bağlayın",
    "whatsapp.connect.description": "Müşterilerinizin bildiği işletme numarasını girin. Meta güvenli doğrulama penceresi açar; WABA kimliği, telefon numarası kimliği, erişim belirteci veya API ayarı bulmanız gerekmez.",
    "Enter the business number your customers know. Meta will open a secure verification window; you do not need to find a WABA ID, phone number ID, access token, or API setting.": "Müşterilerinizin bildiği işletme numarasını girin. Meta güvenli doğrulama penceresi açar; WABA kimliği, telefon numarası kimliği, erişim belirteci veya API ayarı bulmanız gerekmez.",
    "whatsapp.field.business_number": "İşletme WhatsApp numarası",
    "Business WhatsApp number": "İşletme WhatsApp numarası",
    "whatsapp.field.business_number_help": "Ülke kodu dahil müşterilerinizin mesaj göndermesini istediğiniz numarayı kullanın.",
    "Use the number you want customers to message, including country code.": "Ülke kodu dahil müşterilerinizin mesaj göndermesini istediğiniz numarayı kullanın.",
    "whatsapp.placeholder.business_number": "ör. +60 13 333 1671",
    "e.g. +60 13 333 1671": "ör. +60 13 333 1671",
    "whatsapp.field.connection_name": "Bağlantı adı",
    "whatsapp.field.connection_name_help": "Kuala Lumpur, Perakende markası veya Destek gibi net bir ad kullanın.",
    "Use a clear name such as Kuala Lumpur, Retail brand, or Support.": "Kuala Lumpur, Perakende markası veya Destek gibi net bir ad kullanın.",
    "whatsapp.placeholder.connection_name": "ör. Kuala Lumpur desteği",
    "e.g. Kuala Lumpur support": "ör. Kuala Lumpur desteği",
    "whatsapp.field.optional_details": "İsteğe bağlı bağlantı ayrıntıları",
    "Optional connection details": "İsteğe bağlı bağlantı ayrıntıları",
    "whatsapp.field.optional_details_help": "Bu numara belirli bir markaya, hesaba veya şubeye aitse bunları kullanın.",
    "Use these only when this number belongs to a specific brand, account, or branch.": "Bu numara belirli bir markaya, hesaba veya şubeye aitse bunları kullanın.",
    "whatsapp.field.brand_key": "Marka anahtarı",
    "Brand key": "Marka anahtarı",
    "whatsapp.field.brand_key_help": "Perakende veya toptan satış gibi sabit bir dahili marka anahtarı kullanın.",
    "Stable internal key for a brand, such as retail or wholesale.": "Perakende veya toptan satış gibi sabit bir dahili marka anahtarı kullanın.",
    "whatsapp.placeholder.brand_key": "ör. retail",
    "e.g. retail": "ör. retail",
    "whatsapp.field.account_id": "Hesap kimliği",
    "whatsapp.field.account_id_help": "Bu numarayı mevcut bir Tradly hesabıyla ilişkilendirin.",
    "Associate this number with an existing Tradly account.": "Bu numarayı mevcut bir Tradly hesabıyla ilişkilendirin.",
    "whatsapp.placeholder.account_id": "ör. 123",
    "e.g. 123": "ör. 123",
    "whatsapp.field.branch_id": "Şube kimliği",
    "Branch ID": "Şube kimliği",
    "whatsapp.field.branch_id_help": "Bu numarayı mevcut bir Tradly şubesiyle ilişkilendirin.",
    "Associate this number with an existing Tradly branch.": "Bu numarayı mevcut bir Tradly şubesiyle ilişkilendirin.",
    "whatsapp.placeholder.branch_id": "ör. 456",
    "e.g. 456": "ör. 456",
    "whatsapp.field.default_connection": "Varsayılan bağlantı olarak kullan",
    "Use as default connection": "Varsayılan bağlantı olarak kullan",
    "whatsapp.field.default_connection_help": "Şubeye özel bağlantı seçilmediğinde eski OTP akışları seçilen varsayılan bağlantıyı kullanır.",
    "Legacy OTP flows use the selected default when no branch-specific connection is chosen.": "Şubeye özel bağlantı seçilmediğinde eski OTP akışları seçilen varsayılan bağlantıyı kullanır.",
    "whatsapp.field.uses_business_app": "Bu numarada WhatsApp Business uygulamasını kullanıyorum",
    "I use the WhatsApp Business app on this number": "Bu numarada WhatsApp Business uygulamasını kullanıyorum",
    "whatsapp.field.uses_business_app_help": "Telefonunuzdaki WhatsApp Business uygulamasında sohbet etmeye devam edin. Meta uygulamadan bir QR kod taratmanızı isteyecek; kişileriniz ve son sohbetleriniz eşitlenecek. 2.24.17 veya daha yeni sürüm gerekir.",
    "Keep chatting in the WhatsApp Business app on your phone. Meta will ask you to scan a QR code from the app, and your contacts and recent chats are synced. Needs app version 2.24.17 or later.": "Telefonunuzdaki WhatsApp Business uygulamasında sohbet etmeye devam edin. Meta uygulamadan bir QR kod taratmanızı isteyecek; kişileriniz ve son sohbetleriniz eşitlenecek. 2.24.17 veya daha yeni sürüm gerekir.",
    "whatsapp.connected.business_account": "WhatsApp Business hesabı",
    "WhatsApp business account": "WhatsApp Business hesabı",
    "whatsapp.connected.template_ready": "Kimlik doğrulama şablonu hazır · otomatik OTP için WhatsApp kullanılabilir.",
    "Authentication template ready · Automatic OTP can use WhatsApp.": "Kimlik doğrulama şablonu hazır · otomatik OTP için WhatsApp kullanılabilir.",
    "whatsapp.connected.template_pending": "Bağlandı · kimlik doğrulama şablonu onaylanana kadar güvenli yedek kanal SMS’tir.",
    "Connected · SMS remains the safe fallback while the authentication template is approved.": "Bağlandı · kimlik doğrulama şablonu onaylanana kadar güvenli yedek kanal SMS’tir.",
    "whatsapp.action.connect": "WhatsApp’ı bağla",
    "Connect WhatsApp": "WhatsApp’ı bağla",
    "whatsapp.action.reconnect": "WhatsApp’ı yeniden bağla",
    "Reconnect WhatsApp": "WhatsApp’ı yeniden bağla",
    "whatsapp.connections.title": "Bağlı WhatsApp numaraları",
    "Connected WhatsApp numbers": "Bağlı WhatsApp numaraları",
    "whatsapp.connections.description": "Her numara farklı marka, hesap veya şubeye ait olabilir. Şablonları etkinleştirmeden önce bir numara seçin.",
    "Each number can belong to a different brand, account, or branch. Select one before activating templates.": "Her numara farklı marka, hesap veya şubeye ait olabilir. Şablonları etkinleştirmeden önce bir numara seçin.",
    "whatsapp.connections.unnamed": "WhatsApp bağlantısı",
    "WhatsApp connection": "WhatsApp bağlantısı",
    "whatsapp.connections.default": "Varsayılan",
    "whatsapp.connections.account": "Hesap {id}",
    "Account {id}": "Hesap {id}",
    "whatsapp.connections.branch": "Şube {id}",
    "Branch {id}": "Şube {id}",
    "whatsapp.connections.tenant_wide": "Kiracı genelinde bağlantı",
    "Tenant-wide connection": "Kiracı genelinde bağlantı",
    "whatsapp.action.make_default": "Varsayılan yap",
    "Make default": "Varsayılan yap",
    "whatsapp.notice.default_updated": "Varsayılan WhatsApp bağlantısı güncellendi.",
    "Default WhatsApp connection updated.": "Varsayılan WhatsApp bağlantısı güncellendi.",
    "whatsapp.error.default_update": "Varsayılan bağlantı değiştirilemedi.",
    "Unable to change the default connection.": "Varsayılan bağlantı değiştirilemedi.",
    "whatsapp.templates.title": "Mesaj şablonları",
    "Message templates": "Mesaj şablonları",
    "whatsapp.templates.description": "Hazır bir şablon seçin. Tradly onay için Meta’ya gönderir ve Meta onayladığında otomatik etkinleştirir.",
    "Choose a ready-made template. Tradly submits it to Meta for approval and activates it automatically when Meta approves it.": "Hazır bir şablon seçin. Tradly onay için Meta’ya gönderir ve Meta onayladığında otomatik etkinleştirir.",
    "whatsapp.template.status.not_activated": "Etkin değil",
    "Not activated": "Etkin değil",
    "whatsapp.template.status.approved": "Onaylandı",
    "whatsapp.template.status.pending": "Bekliyor",
    "whatsapp.template.status.submitted": "Gönderildi",
    "Submitted": "Gönderildi",
    "whatsapp.template.action.active": "Etkin",
    "whatsapp.template.action.submitted": "Gönderildi",
    "whatsapp.template.action.activate": "Şablonu etkinleştir",
    "Activate template": "Şablonu etkinleştir",
    "whatsapp.notice.template_active": "{name} onaylandı ve etkin.",
    "{name} is approved and active.": "{name} onaylandı ve etkin.",
    "whatsapp.notice.template_submitted": "{name} şablonu inceleme için Meta’ya gönderildi. Onaylanana kadar SMS kullanabilirsiniz.",
    "{name} was sent to Meta for review. You can keep using SMS until it is approved.": "{name} şablonu inceleme için Meta’ya gönderildi. Onaylanana kadar SMS kullanabilirsiniz.",
    "whatsapp.channel.title": "Teslimat kanalı",
    "Delivery channel": "Teslimat kanalı",
    "whatsapp.channel.help": "Anahtar, işletmeniz için WhatsApp’ı açar. Giriş kodları yalnızca SMS, yalnızca WhatsApp veya WhatsApp yedekli SMS ile gönderilebilir; WhatsApp seçenekleri onaylı bir kod şablonu gerektirir.",
    "The switch turns WhatsApp on for your business. Login codes can go by SMS only, WhatsApp only, or SMS with WhatsApp as backup; WhatsApp options need an approved login code template.": "Anahtar, işletmeniz için WhatsApp’ı açar. Giriş kodları yalnızca SMS, yalnızca WhatsApp veya WhatsApp yedekli SMS ile gönderilebilir; WhatsApp seçenekleri onaylı bir kod şablonu gerektirir.",
    "whatsapp.channel.primary_otp": "Birincil OTP kanalı",
    "Primary OTP channel": "Birincil OTP kanalı",
    "whatsapp.channel.sms_description": "Mevcut SMS teslimat yolunu koruyun.",
    "Keep the existing SMS delivery path.": "Mevcut SMS teslimat yolunu koruyun.",
    "whatsapp.channel.whatsapp_description": "Bu kiracı için Meta Cloud API’yi kullanın.",
    "Use Meta Cloud API for this tenant.": "Bu kiracı için Meta Cloud API’yi kullanın.",
    "whatsapp.channel.automatic": "Otomatik",
    "Automatic": "Otomatik",
    "whatsapp.channel.automatic_description": "Yapılandırılmışsa WhatsApp, değilse SMS kullanın.",
    "Use WhatsApp when configured, otherwise SMS.": "Yapılandırılmışsa WhatsApp, değilse SMS kullanın.",
    "whatsapp.channel.fallback": "WhatsApp başarısız olursa yedek kanal",
    "Fallback after WhatsApp failure": "WhatsApp başarısız olursa yedek kanal",
    "whatsapp.channel.no_fallback": "Yedek kanal yok",
    "No fallback": "Yedek kanal yok",
    "whatsapp.channel.no_fallback_description": "Yapılandırılmış teslimat sonucunu döndürün.",
    "Return the configured delivery result.": "Yapılandırılmış teslimat sonucunu döndürün.",
    "whatsapp.channel.sms_fallback_description": "Aynı OTP koduyla SMS göndermeyi deneyin.",
    "Try SMS with the same OTP code.": "Aynı OTP koduyla SMS göndermeyi deneyin.",
    "whatsapp.channel.sms_only": "Yalnızca SMS",
    "SMS only": "Yalnızca SMS",
    "whatsapp.channel.sms_only_description": "Kodlar SMS ile gönderilir.",
    "Codes are sent by text message.": "Kodlar SMS ile gönderilir.",
    "whatsapp.channel.whatsapp_only": "Yalnızca WhatsApp",
    "WhatsApp only": "Yalnızca WhatsApp",
    "whatsapp.channel.whatsapp_only_description": "Kodlar WhatsApp numaranızdan gönderilir.",
    "Codes are sent from your WhatsApp number.": "Kodlar WhatsApp numaranızdan gönderilir.",
    "whatsapp.channel.sms_whatsapp": "SMS, yedek olarak WhatsApp",
    "SMS, WhatsApp as backup": "SMS, yedek olarak WhatsApp",
    "whatsapp.channel.sms_whatsapp_description": "Kodlar SMS ile gönderilir; SMS başarısız olursa aynı kod WhatsApp ile gönderilir.",
    "Codes go by text message; if SMS fails, the same code is sent on WhatsApp.": "Kodlar SMS ile gönderilir; SMS başarısız olursa aynı kod WhatsApp ile gönderilir.",
    "whatsapp.advanced.title": "Teknik kurtarma ayarları",
    "Technical recovery settings": "Teknik kurtarma ayarları",
    "whatsapp.advanced.description": "Yalnızca platform desteği içindir. Çoğu işletme yukarıdaki WhatsApp’ı Bağla seçeneğini kullanmalıdır.",
    "For platform support only. Most businesses should use Connect WhatsApp above.": "Yalnızca platform desteği içindir. Çoğu işletme yukarıdaki WhatsApp’ı Bağla seçeneğini kullanmalıdır.",
    "whatsapp.field.phone_number_id": "WhatsApp telefon numarası kimliği",
    "WhatsApp phone number ID": "WhatsApp telefon numarası kimliği",
    "whatsapp.field.phone_number_id_help": "WhatsApp Business hesabınıza bağlı telefon numarası kimliği.",
    "The phone number ID attached to your WhatsApp Business account.": "WhatsApp Business hesabınıza bağlı telefon numarası kimliği.",
    "whatsapp.field.waba_id": "WhatsApp Business Hesap Kimliği",
    "WhatsApp Business Account ID": "WhatsApp Business Hesap Kimliği",
    "whatsapp.field.waba_id_help": "Meta’da (WhatsApp > API Setup) numara kimliğinin yanında gösterilir. Şablonlar ve test mesajları için gerekir.",
    "Shown next to the phone number ID in Meta (WhatsApp > API Setup). Needed for templates and test messages.": "Meta’da (WhatsApp > API Setup) numara kimliğinin yanında gösterilir. Şablonlar ve test mesajları için gerekir.",
    "whatsapp.placeholder.phone_number_id": "ör. 123456789012345",
    "e.g. 123456789012345": "ör. 123456789012345",
    "whatsapp.field.access_token": "Meta erişim belirteci",
    "Meta access token": "Meta erişim belirteci",
    "whatsapp.field.access_token_saved_help": "Sunucuda güvenle saklanır. Değiştirmemek için boş bırakın veya yenisiyle değiştirmek için yeni belirteç girin.",
    "Saved securely on the server. Leave blank to keep it unchanged, or paste a new token to replace it.": "Sunucuda güvenle saklanır. Değiştirmemek için boş bırakın veya yenisiyle değiştirmek için yeni belirteç girin.",
    "whatsapp.field.access_token_help": "WhatsApp Business mesajlaşma izni olan sistem kullanıcısı belirtecini kullanın.",
    "Use a system-user token with WhatsApp Business messaging permission.": "WhatsApp Business mesajlaşma izni olan sistem kullanıcısı belirtecini kullanın.",
    "whatsapp.placeholder.access_token_saved": "Güvenle kaydedildi · değiştirmemek için boş bırakın",
    "Saved securely · leave blank to keep": "Güvenle kaydedildi · değiştirmemek için boş bırakın",
    "whatsapp.placeholder.access_token": "Belirteci yapıştırın",
    "Paste token": "Belirteci yapıştırın",
    "whatsapp.token.saved": "Meta erişim belirteci güvenle kaydedildi",
    "Meta access token saved securely": "Meta erişim belirteci güvenle kaydedildi",
    "whatsapp.field.otp_template": "Onaylı OTP şablon adı",
    "Approved OTP template name": "Onaylı OTP şablon adı",
    "whatsapp.field.otp_template_help": "Şablon gövdesi OTP’yi tek bir metin parametresi olarak kabul etmelidir.",
    "The template body must accept the OTP as one text parameter.": "Şablon gövdesi OTP’yi tek bir metin parametresi olarak kabul etmelidir.",
    "whatsapp.placeholder.otp_template": "ör. login_verification",
    "e.g. login_verification": "ör. login_verification",
    "whatsapp.field.template_language": "Şablon dili",
    "Template language": "Şablon dili",
    "whatsapp.field.marketing_template": "Onaylı pazarlama şablon adı (isteğe bağlı)",
    "Approved marketing template name (optional)": "Onaylı pazarlama şablon adı (isteğe bağlı)",
    "whatsapp.field.marketing_template_help": "Onaylı Meta pazarlama şablonu kullanın. Kampanya content.template_name içinde bu adı geçersiz kılabilir.",
    "Use an approved Meta marketing template. A campaign can override this name in its content.template_name.": "Onaylı Meta pazarlama şablonu kullanın. Kampanya content.template_name içinde bu adı geçersiz kılabilir.",
    "whatsapp.placeholder.marketing_template": "ör. monthly_offer",
    "e.g. monthly_offer": "ör. monthly_offer",
    "whatsapp.field.marketing_language": "Pazarlama şablonu dili",
    "Marketing template language": "Pazarlama şablonu dili",
    "whatsapp.info.title": "WhatsApp’ı etkinleştirmeden önce",
    "Before enabling WhatsApp": "WhatsApp’ı etkinleştirmeden önce",
    "whatsapp.info.description": "Meta, gönderilmeden önce her OTP veya pazarlama şablonunu onaylamalıdır. Kampanya WhatsApp içeriği template_name, template_language ve isteğe bağlı gövde parametrelerini kullanır; alıcı numaraları E.164 biçiminde olmalıdır. Otomatik yedek etkinse ArcticOwl ikinci kod oluşturmak yerine aynı OTP’yi SMS ile yeniden dener.",
    "Meta must approve each OTP or marketing template before it can be sent. Campaign WhatsApp content uses template_name, template_language, and optional body parameters; recipient numbers must be in E.164 format. If automatic fallback is enabled, ArcticOwl retries SMS with the original OTP instead of generating a second code.": "Meta, gönderilmeden önce her OTP veya pazarlama şablonunu onaylamalıdır. Kampanya WhatsApp içeriği template_name, template_language ve isteğe bağlı gövde parametrelerini kullanır; alıcı numaraları E.164 biçiminde olmalıdır. Otomatik yedek etkinse ArcticOwl ikinci kod oluşturmak yerine aynı OTP’yi SMS ile yeniden dener.",
    "whatsapp.action.hide_token": "Meta erişim belirtecini gizle",
    "Hide Meta access token": "Meta erişim belirtecini gizle",
    "whatsapp.action.show_token": "Meta erişim belirtecini göster",
    "Show Meta access token": "Meta erişim belirtecini göster",
    "whatsapp.error.generic": "WhatsApp ayarları kaydedilemedi.",
    "Unable to save WhatsApp settings.": "WhatsApp ayarları kaydedilemedi.",
    "whatsapp.error.browser_required": "WhatsApp bağlantısı yalnızca tarayıcıda kullanılabilir.",
    "WhatsApp connection is only available in a browser.": "WhatsApp bağlantısı yalnızca tarayıcıda kullanılabilir.",
    "whatsapp.error.meta_load": "Meta yüklenemedi. Tarayıcı gizlilik ayarlarını kontrol edip tekrar deneyin.",
    "Meta could not load. Check the browser privacy settings and try again.": "Meta yüklenemedi. Tarayıcı gizlilik ayarlarını kontrol edip tekrar deneyin.",
    "whatsapp.error.load": "WhatsApp ayarları yüklenemedi.",
    "Unable to load WhatsApp settings.": "WhatsApp ayarları yüklenemedi.",
    "whatsapp.error.connect_before_template": "Şablonu etkinleştirmeden önce WhatsApp’ı bağlayın.",
    "Connect WhatsApp before activating a template.": "Şablonu etkinleştirmeden önce WhatsApp’ı bağlayın.",
    "whatsapp.error.template_submit": "WhatsApp şablonu gönderilemedi.",
    "Unable to submit the WhatsApp template.": "WhatsApp şablonu gönderilemedi.",
    "whatsapp.error.business_number_required": "Bağlanmadan önce WhatsApp Business numarasını girin. Meta sonraki adımda doğrulayacak.",
    "Enter the business WhatsApp number before connecting. Meta will verify it in the next step.": "Bağlanmadan önce WhatsApp Business numarasını girin. Meta sonraki adımda doğrulayacak.",
    "whatsapp.error.signup_not_ready": "Platform WhatsApp bağlantısını hazırlıyor. Lütfen kısa süre sonra tekrar deneyin.",
    "WhatsApp connection is still being prepared by the platform. Please try again shortly.": "Platform WhatsApp bağlantısını hazırlıyor. Lütfen kısa süre sonra tekrar deneyin.",
    "whatsapp.error.signup_cancelled": "Meta bağlantısı iptal edildi veya yetkilendirme kodu döndürülmedi.",
    "Meta connection was cancelled or did not return an authorization code.": "Meta bağlantısı iptal edildi veya yetkilendirme kodu döndürülmedi.",
    "whatsapp.error.phone_number_missing": "Meta seçili WhatsApp Business numarasını döndürmedi. Yeniden bağlanmayı deneyin.",
    "Meta did not return the selected WhatsApp business number. Please try the connection again.": "Meta seçili WhatsApp Business numarasını döndürmedi. Yeniden bağlanmayı deneyin.",
    "whatsapp.notice.connected_auto": "WhatsApp bağlandı. Otomatik OTP önce WhatsApp’ı, başarısız olursa SMS’i kullanır.",
    "WhatsApp is connected. Automatic OTP delivery will use WhatsApp first and SMS if it fails.": "WhatsApp bağlandı. Otomatik OTP önce WhatsApp’ı, başarısız olursa SMS’i kullanır.",
    "whatsapp.notice.connected_sms": "WhatsApp bağlandı. Meta bir kimlik doğrulama şablonunu onaylayana kadar SMS etkin kalır.",
    "WhatsApp is connected. SMS remains active until Meta approves an authentication template.": "WhatsApp bağlandı. Meta bir kimlik doğrulama şablonunu onaylayana kadar SMS etkin kalır.",
    "whatsapp.error.connect": "WhatsApp bağlanamadı.",
    "Unable to connect WhatsApp.": "WhatsApp bağlanamadı.",
    "whatsapp.error.otp_configuration": "WhatsApp veya Otomatik OTP için telefon numarası kimliği, onaylı OTP şablon adı ve Meta erişim belirteci gerekir. Yalnızca pazarlama WhatsApp’ı için birincil OTP kanalı olarak SMS’i seçin ve bağlayıcıyı etkin bırakın.",
    "WhatsApp or Automatic OTP needs a phone number ID, an approved OTP template name, and a Meta access token. For marketing-only WhatsApp, choose SMS as the primary OTP channel and keep the connector enabled.": "WhatsApp veya Otomatik OTP için telefon numarası kimliği, onaylı OTP şablon adı ve Meta erişim belirteci gerekir. Yalnızca pazarlama WhatsApp’ı için birincil OTP kanalı olarak SMS’i seçin ve bağlayıcıyı etkin bırakın.",
    "whatsapp.notice.saved": "Bu kiracı için WhatsApp bağlayıcı ayarları kaydedildi.",
    "WhatsApp connector settings saved for this tenant.": "Bu kiracı için WhatsApp bağlayıcı ayarları kaydedildi.",
    "whatsapp.error.save": "WhatsApp ayarları kaydedilemedi.",
    "whatsapp.notice.discarded": "Taslak silindi.",
    "Draft discarded.": "Taslak silindi.",
    "whatsapp.test.title": "Test mesajı gönder",
    "Send a test message": "Test mesajı gönder",
    "whatsapp.test.description": "Bağlantınızın çalıştığını kontrol etmek için onaylı bir şablonu herhangi bir WhatsApp numarasına gönderin.",
    "Send an approved template to any WhatsApp number to check that your connection works.": "Bağlantınızın çalıştığını kontrol etmek için onaylı bir şablonu herhangi bir WhatsApp numarasına gönderin.",
    "whatsapp.test.refresh": "Şablonları yenile",
    "Refresh templates": "Şablonları yenile",
    "whatsapp.test.field.template": "Onaylı şablon",
    "Approved template": "Onaylı şablon",
    "whatsapp.test.field.parameter": "{{{number}}} için değer",
    "Value for {{{number}}}": "{{{number}}} için değer",
    "whatsapp.test.field.mobile": "Gönderilecek numara",
    "Send to": "Gönderilecek numara",
    "whatsapp.test.field.mobile_help": "Ülke koduyla WhatsApp numarası.",
    "WhatsApp number with country code.": "Ülke koduyla WhatsApp numarası.",
    "whatsapp.test.action.send": "Test mesajını gönder",
    "Send test message": "Test mesajını gönder",
    "whatsapp.test.sent": "{mobile} numarasına gönderildi. Meta mesaj kimliği: {id}",
    "Sent to {mobile}. Meta message ID: {id}": "{mobile} numarasına gönderildi. Meta mesaj kimliği: {id}",
    "whatsapp.test.no_templates": "Henüz onaylı şablon yok. Yukarıdan bir şablon etkinleştirin ve Meta onayladığında gönderin.",
    "No approved templates yet. Activate a template above and send once Meta approves it.": "Henüz onaylı şablon yok. Yukarıdan bir şablon etkinleştirin ve Meta onayladığında gönderin.",
    "common.discard_draft": "Taslağı sil",
    "common.status.connected": "Bağlandı",
    "Connected": "Bağlandı",
    "extensions.title": "Uzantılar",
    "extensions.action.add": "Uzantı ekle",
    "Add Extension": "Uzantı ekle",
    "extensions.action.add_new": "Yeni uzantı ekle",
    "Add New Extension": "Yeni uzantı ekle",
    "extensions.action.edit": "Uzantıyı düzenle",
    "Edit Extension": "Uzantıyı düzenle",
    "extensions.action.delete": "Uzantıyı sil",
    "Delete extension": "Uzantıyı sil",
    "extensions.field.name": "Ad",
    "extensions.field.domain": "Alan adı",
    "extensions.field.configs": "Yapılandırmalar",
    "Configs": "Yapılandırmalar",
    "extensions.placeholder.name": "Uzantı adı",
    "Extension Name": "Uzantı adı",
    "extensions.placeholder.domain": "Uzantı alan adı",
    "Extension Domain": "Uzantı alan adı",
    "extensions.empty": "Henüz uzantı yapılandırılmadı.",
    "No extensions configured yet.": "Henüz uzantı yapılandırılmadı.",
    "extensions.toast.added": "Uzantı başarıyla eklendi.",
    "Extension added successfully.": "Uzantı başarıyla eklendi.",
    "extensions.toast.updated": "Uzantı başarıyla güncellendi.",
    "Extension updated successfully.": "Uzantı başarıyla güncellendi.",
    "extensions.toast.deleted": "Uzantı başarıyla silindi.",
    "Extension deleted successfully.": "Uzantı başarıyla silindi.",
    "extensions.error.name_required": "Ad gereklidir",
    "extensions.error.domain_required": "Alan adı gereklidir",
    "Domain is required": "Alan adı gereklidir",
    "extensions.error.configs_required": "Yapılandırma gereklidir",
    "Configs is required": "Yapılandırma gereklidir",
    "extensions.error.save_failed": "Uzantı kaydedilemedi.",
    "Unable to save the extension.": "Uzantı kaydedilemedi.",
    "extensions.error.delete_failed": "Uzantı silinemedi.",
    "Unable to delete the extension.": "Uzantı silinemedi.",
    "automation_rules.kicker": "Operasyon otomasyonu",
    "Operations automation": "Operasyon otomasyonu",
    "automation_rules.title": "Otomasyon kuralları",
    "Automation rules": "Otomasyon kuralları",
    "automation_rules.description": "Personel ve masraf etkinliklerini net onay ve inceleme adımlarına dönüştürün.",
    "Turn staff and expense events into clear approval and review steps.": "Personel ve masraf etkinliklerini net onay ve inceleme adımlarına dönüştürün.",
    "automation_rules.action.new_rule": "Yeni kural",
    "New rule": "Yeni kural",
    "automation_rules.action.create_rule": "Kural oluştur",
    "Create rule": "Kural oluştur",
    "automation_rules.action.create_help": "Bu tetikleyici, koşullar ve eylemi kural olarak kaydedin",
    "Save this trigger, conditions, and action as a rule": "Bu tetikleyici, koşullar ve eylemi kural olarak kaydedin",
    "automation_rules.action.add_condition": "Koşul ekle",
    "Add condition": "Koşul ekle",
    "automation_rules.action.add_condition_help": "Bu kurala başka bir koşul ekleyin",
    "Add another condition to this rule": "Bu kurala başka bir koşul ekleyin",
    "automation_rules.action.remove_condition": "Koşulu kaldır",
    "Remove condition": "Koşulu kaldır",
    "automation_rules.action.choose": "Eylem seçin",
    "Choose an action": "Eylem seçin",
    "automation_rules.action.require_second_approver": "İkinci onaylayıcı iste",
    "Require second approver": "İkinci onaylayıcı iste",
    "automation_rules.action.require_second_approver_help": "Talebi başka bir onaylayıcıya yönlendirin.",
    "Route the claim to another approver.": "Talebi başka bir onaylayıcıya yönlendirin.",
    "automation_rules.action.auto_reject_expense": "Masrafı otomatik reddet",
    "Auto-reject expense": "Masrafı otomatik reddet",
    "automation_rules.action.auto_reject_expense_help": "Masrafı bir neden belirterek reddedin.",
    "Reject the expense with a reason.": "Masrafı bir neden belirterek reddedin.",
    "automation_rules.action.notify_role": "Bir rolü bilgilendir",
    "Notify a role": "Bir rolü bilgilendir",
    "automation_rules.action.notify_role_help": "Belirli bir roldeki personele bildirim gönderin.",
    "Send a notification to a staff role.": "Belirli bir roldeki personele bildirim gönderin.",
    "automation_rules.action.flag_for_review": "İnceleme için işaretle",
    "Flag for review": "İnceleme için işaretle",
    "automation_rules.action.flag_for_review_help": "Kaynağı elle incelenmek üzere işaretleyin.",
    "Mark a resource for manual review.": "Kaynağı elle incelenmek üzere işaretleyin.",
    "automation_rules.field.rule_name": "Kural adı",
    "Rule name": "Kural adı",
    "automation_rules.field.priority": "Öncelik",
    "automation_rules.field.module": "Modül",
    "Module": "Modül",
    "automation_rules.field.event": "Etkinlik",
    "automation_rules.field.field": "Alan",
    "Field": "Alan",
    "automation_rules.field.operator": "Operatör",
    "Operator": "Operatör",
    "automation_rules.field.value": "Değer",
    "automation_rules.field.action": "Eylem",
    "automation_rules.field.action_params": "Eylem parametreleri",
    "Action parameters": "Eylem parametreleri",
    "automation_rules.placeholder.rule_name": "Yüksek tutarlı masraflar için ikinci onay iste",
    "Require second approver for large claims": "Yüksek tutarlı masraflar için ikinci onay iste",
    "automation_rules.placeholder.field": "tutar",
    "amount": "tutar",
    "automation_rules.placeholder.value": "500 veya false",
    "500 or false": "500 veya false",
    "automation_rules.builder.description": "Aşağıda tetikleyici, koşullar ve eylemi oluşturup tek kural olarak kaydedin.",
    "Build the trigger, conditions, and action below, then save them as one rule.": "Aşağıda tetikleyici, koşullar ve eylemi oluşturup tek kural olarak kaydedin.",
    "automation_rules.error.load": "Otomasyon kuralları yüklenemedi.",
    "Unable to load automation rules.": "Otomasyon kuralları yüklenemedi.",
    "automation_rules.error.required_fields": "Ad, modül, etkinlik ve eylem gereklidir.",
    "Name, module, event, and action are required.": "Ad, modül, etkinlik ve eylem gereklidir.",
    "automation_rules.error.create": "Otomasyon kuralı oluşturulamadı.",
    "Unable to create automation rule.": "Otomasyon kuralı oluşturulamadı.",
    "automation_rules.error.valid_json": "Kaydetmeden önce geçerli JSON kullanın.",
    "Use valid JSON before saving.": "Kaydetmeden önce geçerli JSON kullanın.",
    "automation_rules.notice.created": "Otomasyon kuralı oluşturuldu.",
    "Automation rule created.": "Otomasyon kuralı oluşturuldu.",
    "automation_rules.notice.discarded": "Taslak silindi.",
    "automation_rules.draft.restored": "Kaydedilmemiş otomasyon kuralı taslağınız geri yüklendi.",
    "Your unsaved automation rule draft was restored.": "Kaydedilmemiş otomasyon kuralı taslağınız geri yüklendi.",
    "automation_rules.list.title": "Kurallar",
    "automation_rules.list.count": "{count} yapılandırıldı",
    "{count} configured": "{count} yapılandırıldı",
    "automation_rules.list.loading": "Kurallar yükleniyor…",
    "Loading rules…": "Kurallar yükleniyor…",
    "automation_rules.list.unnamed": "Adsız kural",
    "Unnamed rule": "Adsız kural",
    "automation_rules.list.no_action": "Eylem yapılandırılmadı",
    "No action configured": "Eylem yapılandırılmadı",
    "automation_rules.list.empty": "Henüz kural yok. İlkini diyagramdan oluşturun.",
    "No rules yet. Create the first one from the diagram.": "Henüz kural yok. İlkini diyagramdan oluşturun.",
    "automation_rules.status.draft": "Taslak",
    "automation_rules.status.active": "Etkin",
    "automation_rules.inspector.title": "Blok ayarları",
    "Block settings": "Blok ayarları",
    "automation_rules.inspector.diagram": "Diyagram",
    "Diagram": "Diyagram",
    "automation_rules.inspector.select_block": "Yapılandırmak için diyagramdaki bir bloğu seçin.",
    "Select a block on the diagram to configure it.": "Yapılandırmak için diyagramdaki bir bloğu seçin.",
    "automation_rules.inspector.no_configuration": "Bu blok için yapılandırma gerekmez.",
    "This block does not need configuration.": "Bu blok için yapılandırma gerekmez.",
    "automation_rules.node.trigger": "Tetikleyici",
    "automation_rules.node.condition": "Koşul",
    "automation_rules.node.action": "Eylem",
    "automation_rules.node.end": "Bitiş",
    "automation_rules.node.completed": "Tamamlandı",
    "automation_rules.node.finished": "Kural değerlendirmesi tamamlandı",
    "Rule evaluation finished": "Kural değerlendirmesi tamamlandı",
    "automation_rules.trigger.choose_event": "Etkinlik seçin",
    "Choose an event": "Etkinlik seçin",
    "automation_rules.trigger.module": "modül",
    "module": "modül",
    "automation_rules.trigger.module_event": "{module} modülü etkinliği",
    "{module} event": "{module} modülü etkinliği",
    "automation_rules.trigger.help": "Modül bu etkinliği oluşturduğunda kural değerlendirilir.",
    "The rule evaluates when this event is emitted by the module.": "Modül bu etkinliği oluşturduğunda kural değerlendirilir.",
    "automation_rules.condition.label": "Koşul",
    "automation_rules.condition.none": "Koşul yok",
    "No conditions": "Koşul yok",
    "automation_rules.condition.always_fires": "Her zaman çalışır",
    "Always fires": "Her zaman çalışır",
    "automation_rules.condition.empty_help": "Bu kuralı sınırlandırmak için koşul ekleyin.",
    "Add a condition to restrict this rule.": "Bu kuralı sınırlandırmak için koşul ekleyin.",
    "automation_rules.condition.value_required": "Değer gerekli",
    "Value required": "Değer gerekli",
    "automation_rules.condition.value": "Değer: {value}",
    "Value: {value}": "Değer: {value}",
    "automation_rules.operator.equals": "Eşittir",
    "Equals": "Eşittir",
    "automation_rules.operator.gt": "Büyüktür",
    "Greater than": "Büyüktür",
    "automation_rules.operator.gte": "Büyük veya eşittir",
    "Greater than or equal": "Büyük veya eşittir",
    "automation_rules.operator.lt": "Küçüktür",
    "Less than": "Küçüktür",
    "automation_rules.operator.exists": "Mevcut",
    "Exists": "Mevcut",
    "automation_rules.module.expenses": "Masraflar",
    "automation_rules.module.staff": "Personel",
    "automation_rules.event.expense.submitted": "Masraf gönderildi",
    "automation_rules.event.leave.requested": "İzin talep edildi",
    "Leave requested": "İzin talep edildi",
    "automation_rules.event.payroll_run.created": "Bordro çalışması oluşturuldu",
    "automation_rules.meta.conditions": "{count} koşul · eylemin çalışması için tümü eşleşmeli",
    "{count} condition(s) · all must match before the action runs": "{count} koşul · eylemin çalışması için tümü eşleşmeli",
    "automation_rules.meta.no_conditions": "Koşul yok · tetikleyiciden sonra eylem her zaman çalışır",
    "No conditions · the action always runs after the trigger": "Koşul yok · tetikleyiciden sonra eylem her zaman çalışır",
    "automation_rules.draft.unsaved": "Kaydedilmemiş otomasyon kuralı taslağınız var.",
    "You have an unsaved automation rule draft.": "Kaydedilmemiş otomasyon kuralı taslağınız var.",
    "automation_rules.meta.one_condition": "1 koşul · eylemin çalışması için eşleşmeli",
    "1 condition · all must match before the action runs": "1 koşul · eylemin çalışması için eşleşmeli",
    "automation_rules.meta.many_conditions": "{count} koşul · eylemin çalışması için tümü eşleşmeli",
    "{count} conditions · all must match before the action runs": "{count} koşul · eylemin çalışması için tümü eşleşmeli",
    "cms.type.page": "Sayfa",
    "Page": "Sayfa",
    "cms.type.blog": "Blog",
    "cms.type.docs": "Belgeler",
    "Docs": "Belgeler",
    "cms.type.pages": "Sayfalar",
    "cms.type.blogs": "Blog",
    "Blogs": "Blog",
    "cms.action.add_content": "İçerik ekle",
    "Add content": "İçerik ekle",
    "cms.action.add_type": "{type} ekle",
    "cms.action.create_type": "{type} oluştur",
    "Create {type}": "{type} oluştur",
    "cms.action.edit": "Düzenle",
    "cms.action.duplicate": "Çoğalt",
    "Duplicate": "Çoğalt",
    "cms.action.open": "Aç",
    "cms.field.title": "Başlık",
    "cms.field.slug": "Kısa ad",
    "cms.field.content": "İçerik",
    "cms.field.meta_title": "Meta başlık",
    "cms.field.meta_description": "Meta açıklama",
    "cms.placeholder.title": "ör. Hakkımızda",
    "e.g. About us": "ör. Hakkımızda",
    "cms.placeholder.slug": "hakkimizda",
    "about-us": "hakkimizda",
    "cms.placeholder.page_title": "Sayfa başlığı",
    "Page title": "Sayfa başlığı",
    "cms.placeholder.page_slug": "sayfa-kisa-adi",
    "page-slug": "sayfa-kisa-adi",
    "cms.placeholder.content": "İçeriğinizi buraya yazın…",
    "Write your content here…": "İçeriğinizi buraya yazın…",
    "cms.placeholder.meta_title": "Varsayılan olarak başlık kullanılır",
    "Defaults to title": "Varsayılan olarak başlık kullanılır",
    "cms.placeholder.meta_description": "Arama motorları için kısa açıklama",
    "Short description for search engines": "Arama motorları için kısa açıklama",
    "cms.section.seo_optional": "SEO (isteğe bağlı)",
    "SEO (optional)": "SEO (isteğe bağlı)",
    "cms.error.title_required": "Başlık gereklidir.",
    "Title is required.": "Başlık gereklidir.",
    "cms.error.content_required": "Kaydetmeden önce içerik ekleyin.",
    "Add some content before saving.": "Kaydetmeden önce içerik ekleyin.",
    "cms.error.create": "Oluşturulamadı. Lütfen tekrar deneyin.",
    "Failed to create. Please try again.": "Oluşturulamadı. Lütfen tekrar deneyin.",
    "cms.error.save": "Kaydedilemedi.",
    "Failed to save.": "Kaydedilemedi.",
    "cms.error.load_layer": "Bu katman yüklenemedi.",
    "Could not load this layer.": "Bu katman yüklenemedi.",
    "cms.toast.created": "{type} başarıyla oluşturuldu.",
    "{type} created successfully.": "{type} başarıyla oluşturuldu.",
    "cms.toast.saved": "Kaydedildi",
    "Saved": "Kaydedildi",
    "cms.toast.changes_saved": "Değişiklikler kaydedildi.",
    "Changes saved.": "Değişiklikler kaydedildi.",
    "cms.toast.deleted": "Silindi",
    "cms.toast.duplicated": "Çoğaltıldı",
    "Duplicated": "Çoğaltıldı",
    "cms.error.delete": "Silinemedi",
    "Failed to delete": "Silinemedi",
    "cms.error.duplicate": "Çoğaltılamadı",
    "Failed to duplicate": "Çoğaltılamadı",
    "cms.confirm.delete": "“{title}” silinsin mi?",
    "Delete \"{title}\"?": "“{title}” silinsin mi?",
    "cms.duplicate.title": "{title} (kopya)",
    "{title} (copy)": "{title} (kopya)",
    "cms.draft.restored": "Kaydedilmemiş içerik taslağınız geri yüklendi.",
    "Your unsaved content draft was restored.": "Kaydedilmemiş içerik taslağınız geri yüklendi.",
    "cms.search": "Ara…",
    "Search…": "Ara…",
    "cms.list.no_results": "Sonuç bulunamadı.",
    "No results found.": "Sonuç bulunamadı.",
    "cms.list.empty_type": "Henüz {type} yok.",
    "No {type} yet.": "Henüz {type} yok.",
    "cms.list.untitled": "Başlıksız",
    "Untitled": "Başlıksız",
    "cms.editor.placeholder": "İçeriğinizi buraya yazın…",
    "cms.editor.normal_text": "Normal metin",
    "Normal text": "Normal metin",
    "cms.editor.heading": "Başlık {level}",
    "Heading {level}": "Başlık {level}",
    "cms.editor.align_left": "Sola hizala",
    "Align Left": "Sola hizala",
    "cms.editor.align_center": "Ortala",
    "Align Center": "Ortala",
    "cms.editor.align_right": "Sağa hizala",
    "Align Right": "Sağa hizala",
    "cms.editor.insert_table": "Tablo ekle",
    "Insert table": "Tablo ekle",
    "cms.editor.add_column": "Sütun ekle",
    "Add column": "Sütun ekle",
    "cms.editor.add_row": "Satır ekle",
    "Add row": "Satır ekle",
    "cms.editor.delete_table": "Tabloyu sil",
    "Delete table": "Tabloyu sil",
    "cms.editor.delete_column": "Sütunu sil",
    "Delete column": "Sütunu sil",
    "cms.editor.delete_row": "Satırı sil",
    "Delete row": "Satırı sil",
    "cms.editor.underline": "Altı çizili",
    "Underline": "Altı çizili",
    "cms.editor.strikethrough": "Üstü çizili",
    "Strikethrough": "Üstü çizili",
    "cms.editor.code": "Kod",
    "cms.editor.code_block": "Kod bloğu",
    "Code block": "Kod bloğu",
    "cms.editor.subscript": "Alt simge",
    "Subscript": "Alt simge",
    "cms.editor.superscript": "Üst simge",
    "Superscript": "Üst simge",
    "cms.editor.prompt.url": "URL",
    "cms.editor.prompt.image_url": "Görsel URL’si",
    "Image URL": "Görsel URL’si",
    "cms.editor.prompt.youtube_url": "YouTube URL’si",
    "YouTube URL": "YouTube URL’si",
    "cms.editor.undo": "Geri al",
    "cms.editor.redo": "Yinele",
    "cms.editor.table": "Tablo",
    "Table": "Tablo",
    "cms.editor.more": "Daha fazla",
    "cms.editor.bold": "Kalın",
    "Bold": "Kalın",
    "cms.editor.italic": "İtalik",
    "Italic": "İtalik",
    "cms.editor.bullet_list": "Madde işaretli liste",
    "Bullet list": "Madde işaretli liste",
    "cms.editor.ordered_list": "Numaralı liste",
    "Ordered list": "Numaralı liste",
    "cms.editor.task_list": "Görev listesi",
    "Task list": "Görev listesi",
    "cms.editor.link": "Bağlantı",
    "Link": "Bağlantı",
    "cms.editor.image": "Görsel",
    "cms.editor.text_color": "Metin rengi",
    "Text color": "Metin rengi",
    "cms.editor.youtube": "YouTube",
    "YouTube": "YouTube",
    "cms.test.type.pages": "Sayfalar",
    "cms.test.type.pages_description": "Açılış sayfaları ve yapılandırılmış mağaza içeriği.",
    "Landing pages and structured storefront content.": "Açılış sayfaları ve yapılandırılmış mağaza içeriği.",
    "cms.test.type.blogs": "Blog",
    "cms.test.type.blogs_description": "Kitleniz için makaleler, hikâyeler ve güncellemeler.",
    "Articles, stories, and updates for your audience.": "Kitleniz için makaleler, hikâyeler ve güncellemeler.",
    "cms.test.type.docs": "Belgeler",
    "cms.test.type.docs_description": "Belgeler, kılavuzlar ve yardım içeriği.",
    "Documentation, guides, and help content.": "Belgeler, kılavuzlar ve yardım içeriği.",
    "cms.test.operation.list": "Türe göre içerikleri listele",
    "List content by type": "Türe göre içerikleri listele",
    "cms.test.operation.fetch": "Bir katmanı getir",
    "Fetch one Layer": "Bir katmanı getir",
    "cms.test.operation.create": "Katman oluştur",
    "Create a Layer": "Katman oluştur",
    "cms.test.operation.update": "Katmanı güncelle",
    "Update a Layer": "Katmanı güncelle",
    "cms.test.operation.delete": "Katmanı sil",
    "Delete a Layer": "Katmanı sil",
    "cms.test.operation.search": "İçerik ara",
    "Search content": "İçerik ara",
    "cms.test.operation.categories": "Kategorileri yükle",
    "Load categories": "Kategorileri yükle",
    "cms.test.operation.translations": "Çevirileri kaydet",
    "Save translations": "Çevirileri kaydet",
    "cms.test.editor.placeholder": "Sayfa içeriğinizi yazın…",
    "Write your page content...": "Sayfa içeriğinizi yazın…",
    "cms.test.error.load_type": "{type} içeriği yüklenemedi",
    "Unable to load {type} content": "{type} içeriği yüklenemedi",
    "cms.test.error.load": "CMS içeriği yüklenemedi.",
    "Unable to load CMS content.": "CMS içeriği yüklenemedi.",
    "cms.test.error.required": "Kaydetmeden önce sayfa başlığı ve içeriği ekleyin.",
    "Add a page title and content before saving.": "Kaydetmeden önce sayfa başlığı ve içeriği ekleyin.",
    "cms.test.error.create": "Bu sayfa oluşturulamadı.",
    "Unable to create this page.": "Bu sayfa oluşturulamadı.",
    "cms.test.toast.created": "Sayfa başarıyla oluşturuldu.",
    "Page created successfully.": "Sayfa başarıyla oluşturuldu.",
    "cms.test.hero.eyebrow": "İÇERİK YÖNETİMİ",
    "CONTENT MANAGEMENT": "İÇERİK YÖNETİMİ",
    "cms.test.hero.title": "Layers CMS",
    "Layers CMS": "Layers CMS",
    "cms.test.hero.description": "Yapılandırılmış içeriği bir kez oluşturun; mağaza, uygulama ve özel deneyimlerde sunun.",
    "Create structured content once, then make it available across your storefront, applications, and custom experiences.": "Yapılandırılmış içeriği bir kez oluşturun; mağaza, uygulama ve özel deneyimlerde sunun.",
    "cms.test.hero.live_workspace": "Canlı çalışma alanı: {tenant} · salt okunur önizleme",
    "Live workspace: {tenant} · read-only preview": "Canlı çalışma alanı: {tenant} · salt okunur önizleme",
    "cms.test.current_tenant": "geçerli kiracı",
    "current tenant": "geçerli kiracı",
    "cms.test.content.title": "İçeriğiniz",
    "Your content": "İçeriğiniz",
    "cms.test.content.description": "Sayfaları, blogları ve belgeleri tek yerden yönetin.",
    "Pages, blogs, and docs are ready to manage from one place.": "Sayfaları, blogları ve belgeleri tek yerden yönetin.",
    "cms.test.action.create_page": "Sayfa oluştur",
    "Create Page": "Sayfa oluştur",
    "cms.test.form.description": "Layers’da yapılandırılmış sayfa içeriği oluşturun. Kaydedildikten sonra sayfa API üzerinden kullanılabilir.",
    "Create structured page content in Layers. The page will be available through the API after saving.": "Layers’da yapılandırılmış sayfa içeriği oluşturun. Kaydedildikten sonra sayfa API üzerinden kullanılabilir.",
    "cms.test.placeholder.slug": "hakkimizda (isteğe bağlı)",
    "about-us (optional)": "hakkimizda (isteğe bağlı)",
    "cms.test.draft.unsaved": "Kaydedilmemiş sayfa taslağınız var.",
    "You have an unsaved page draft.": "Kaydedilmemiş sayfa taslağınız var.",
    "cms.test.loading": "Layers içeriği yükleniyor…",
    "Loading live Layers content…": "Layers içeriği yükleniyor…",
    "cms.test.content.empty_title": "Henüz {type} yok",
    "No {type} yet": "Henüz {type} yok",
    "cms.test.content.empty_description": "Burada görüntülemek için çalışma alanında ilk Layers içeriğinizi oluşturun.",
    "Create your first Layer in the workspace to see it here.": "Burada görüntülemek için çalışma alanında ilk Layers içeriğinizi oluşturun.",
    "cms.test.feature.types": "Özel içerik türleri",
    "Custom content types": "Özel içerik türleri",
    "cms.test.feature.types_description": "Sayfalar, bloglar ve belgeler başlangıçtır. Gönderi veya işletmenizin ihtiyaç duyduğu başka modeller tanımlayın.",
    "Pages, blogs, and docs are starting points. Define a Post or any other model your business needs.": "Sayfalar, bloglar ve belgeler başlangıçtır. Gönderi veya işletmenizin ihtiyaç duyduğu başka modeller tanımlayın.",
    "cms.test.feature.structured": "Yapılandırılmış ve yerelleştirilmiş",
    "Structured and localized": "Yapılandırılmış ve yerelleştirilmiş",
    "cms.test.feature.structured_description": "Aynı içerik kaynağı için kısa adlar, kategoriler, görseller, SEO meta verileri ve çeviriler kullanın.",
    "Use slugs, categories, images, SEO metadata, and translations for the same content source.": "Aynı içerik kaynağı için kısa adlar, kategoriler, görseller, SEO meta verileri ve çeviriler kullanın.",
    "cms.test.feature.headless": "Varsayılan olarak headless",
    "Headless by default": "Varsayılan olarak headless",
    "cms.test.feature.headless_description": "Layers API’yi web sitesinde, mobil uygulamada, dahili araçta veya özel arayüzde kullanın.",
    "Use the Layers API in a website, mobile app, internal tool, or custom frontend.": "Layers API’yi web sitesinde, mobil uygulamada, dahili araçta veya özel arayüzde kullanın.",
    "cms.test.feature.ai": "Yapay zekâ bilgi kaynağı",
    "AI knowledge source": "Yapay zekâ bilgi kaynağı",
    "cms.test.feature.ai_description": "Tradly CMS içeriğini bilgi kaynağı olarak iRyxo Agent Builder’a gönderin.",
    "Send Tradly CMS content to the iRyxo Agent Builder as a knowledge source.": "Tradly CMS içeriğini bilgi kaynağı olarak iRyxo Agent Builder’a gönderin.",
    "cms.test.community.eyebrow": "TOPLULUK İÇERİĞİ",
    "COMMUNITY CONTENT": "TOPLULUK İÇERİĞİ",
    "cms.test.community.title": "Layers’ı sosyal akışa dönüştürün",
    "Turn Layers into a social feed": "Layers’ı sosyal akışa dönüştürün",
    "cms.test.community.description": "Özel bir Gönderi türü oluşturun, kullanıcıların güncelleme yayınlamasına izin verin ve arayüzünüz üzerinden etkileşim ekleyin.",
    "Create a custom Post type, let users publish updates, and add interaction through your frontend.": "Özel bir Gönderi türü oluşturun, kullanıcıların güncelleme yayınlamasına izin verin ve arayüzünüz üzerinden etkileşim ekleyin.",
    "cms.test.community.share_placeholder": "Bir güncelleme paylaşın…",
    "Share an update…": "Bir güncelleme paylaşın…",
    "cms.test.community.post": "Gönder",
    "Post": "Gönder",
    "cms.test.community.sample_author": "Alex Morgan",
    "Alex Morgan": "Alex Morgan",
    "cms.test.community.sample_post": "Özel bir Layers katmanından yayınlanan topluluk güncellemesi.",
    "A community update published from a custom Layer.": "Özel bir Layers katmanından yayınlanan topluluk güncellemesi.",
    "cms.test.community.sample_actions": "♡ 24   ·   💬 6 yorum   ·   ↗ Paylaş",
    "♡ 24   ·   💬 6 comments   ·   ↗ Share": "♡ 24   ·   💬 6 yorum   ·   ↗ Paylaş",
    "cms.test.community.endpoints": "Örnek uç noktalar",
    "Example endpoints": "Örnek uç noktalar",
    "cms.test.developer.eyebrow": "GELİŞTİRİCİ ERİŞİMİ",
    "DEVELOPER ACCESS": "GELİŞTİRİCİ ERİŞİMİ",
    "cms.test.developer.title": "Layers API",
    "Layers API": "Layers API",
    "cms.test.developer.docs": "Geliştirici belgeleri",
    "Developer docs": "Geliştirici belgeleri",
    "auth.title": "Kimlik doğrulama",
    "auth.sign_in_method": "Giriş yöntemi",
    "auth.facebook_auth": "Facebook kimlik doğrulaması",
    "auth.google_auth": "Google kimlik doğrulaması",
    "auth.twilio": "Twilio",
    "auth.enterprise_sso": "Kurumsal SSO",
    "Enterprise SSO": "Kurumsal SSO",
    "auth.admob": "AdMob",
    "Admob": "AdMob",
    "checkout.title": "Ödeme ayarları",
    "Checkout Settings": "Ödeme ayarları",
    "checkout.orders": "Siparişler",
    "checkout.carts": "Sepetler",
    "Carts": "Sepetler",
    "audit_logs.action": "İşlem",
    "audit_logs.resource": "Kaynak",
    "audit_logs.resource_id": "Kaynak kimliği",
    "Resource ID": "Kaynak kimliği",
    "audit_logs.agent_id": "Ajan kimliği",
    "Agent ID": "Ajan kimliği",
    "audit_logs.result": "Sonuç",
    "audit_logs.actor_id": "İşlemi yapan kimliği",
    "Actor ID": "İşlemi yapan kimliği",
    "audit_logs.ip": "IP",
    "IP": "IP",
    "audit_logs.timestamp": "Zaman damgası",
    "Timestamp": "Zaman damgası",
    "audit_logs.succeeded": "Başarılı",
    "audit_logs.failed": "Başarısız",
    "audit_logs.source": "Kaynak",
    "audit_logs.all_sources": "Tüm kaynaklar",
    "All sources": "Tüm kaynaklar",
    "audit_logs.human_admin": "Kişi (yönetici)",
    "Human (admin)": "Kişi (yönetici)",
    "audit_logs.agent_mcp": "Ajan (MCP)",
    "Agent (MCP)": "Ajan (MCP)",
    "audit_logs.all_actions": "Tüm işlemler",
    "All actions": "Tüm işlemler",
    "audit_logs.from": "Başlangıç",
    "audit_logs.to": "Bitiş",
    "audit_logs.apply": "Uygula",
    "audit_logs.clear": "Temizle",
    "audit_logs.export_csv": "CSV dışa aktar",
    "audit_logs.exporting": "Dışa aktarılıyor…",
    "audit_logs.title": "Denetim günlükleri",
    "audit_logs.empty_title": "Denetim günlüğü bulunamadı",
    "No audit logs found": "Denetim günlüğü bulunamadı",
    "audit_logs.empty_subtitle": "Filtreleri değiştirmeyi deneyin",
    "Try adjusting your filters": "Filtreleri değiştirmeyi deneyin",
    "audit_logs.restriction_notice": "Son 5 denetim kaydı gösteriliyor. Tüm geçmişi görüntülemek ve günlükleri dışa aktarmak için Growth planına yükseltin.",
    "Showing the latest 5 audit logs. Upgrade to Growth to view the full history and export logs.": "Son 5 denetim kaydı gösteriliyor. Tüm geçmişi görüntülemek ve günlükleri dışa aktarmak için Growth planına yükseltin.",
    "audit_logs.extended_history": "Genişletilmiş denetim geçmişi",
    "Extended audit log history": "Genişletilmiş denetim geçmişi",
    "manage_features.title": "Özellikleri yönet",
    "manage_features.general": "Genel",
    "manage_features.apps": "Uygulamalar",
    "manage_features.marketplace": "Pazaryeri",
    "manage_features.commerce": "Ticaret",
    "manage_features.channels": "Kanallar",
    "manage_features.left_menu": "Sol menü",
    "Left Menu": "Sol menü",
    "manage_features.right_sidepanel": "Sağ yan panel",
    "Right Sidepanel": "Sağ yan panel",
    "workflow.integration": "Entegrasyon",
    "workflow.no_url_title": "Entegrasyon URL’si yok",
    "No Integration URL": "Entegrasyon URL’si yok",
    "workflow.no_url_description": "Lütfen entegrasyon URL’sini yapılandırın.",
    "Please configure the integration URL.": "Lütfen entegrasyon URL’sini yapılandırın.",
    "workflow.back": "Geri dön",
    "Go Back": "Geri dön",
    "workflow.loading": "Entegrasyon yükleniyor…",
    "Loading integration...": "Entegrasyon yükleniyor…",
    "workflow.loading_hint": "Bağlanırken lütfen bekleyin",
    "Please wait while we connect": "Bağlanırken lütfen bekleyin",
    "workflow.error_title": "Entegrasyon hatası",
    "Integration Error": "Entegrasyon hatası",
    "workflow.error_description": "Entegrasyon yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "Unable to load the integration. Please check your connection and try again.": "Entegrasyon yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "workflow.retry": "Tekrar dene",
    "Try Again": "Tekrar dene",
    "upgrade_preview.eyebrow": "Bileşen önizlemesi",
    "Component preview": "Bileşen önizlemesi",
    "upgrade_preview.title": "Yükseltme deneyimi",
    "Upgrade experience": "Yükseltme deneyimi",
    "upgrade_preview.description": "Yükseltme sonrasında müşterinin neler yapabileceğine odaklanan ortak özellik erişimi.",
    "A shared feature gate focused on what a customer can accomplish after upgrading.": "Yükseltme sonrasında müşterinin neler yapabileceğine odaklanan ortak özellik erişimi.",
    "upgrade_preview.feature": "Varyant ekle",
    "Add a variant": "Varyant ekle",
    "upgrade_preview.context": "Basic plan kullanıcısının özellik sınırına ulaştığı mevcut nokta burasıdır.",
    "This is the current point where a Basic-plan user reaches the feature boundary.": "Basic plan kullanıcısının özellik sınırına ulaştığı mevcut nokta burasıdır.",
    "upgrade_preview.button": "Yükseltme panelini önizle",
    "Preview upgrade panel": "Yükseltme panelini önizle",
    "upgrade_preview.listing_context": "Bu ilan için",
    "For this listing": "Bu ilan için",
    "gamification_test.eyebrow": "BÜYÜME OYUNLAŞTIRMASI · TEST ROTASI",
    "GROWTH GAMIFICATION · TEST ROUTE": "BÜYÜME OYUNLAŞTIRMASI · TEST ROTASI",
    "gamification_test.title": "İşletmenizi büyütün",
    "Build momentum for your business": "İşletmenizi büyütün",
    "gamification_test.subtitle": "{workspace} için görevleri, jetonları, rozetleri ve serileri önizleyin.",
    "Preview missions, coins, badges, and streaks for {workspace}.": "{workspace} için görevleri, jetonları, rozetleri ve serileri önizleyin.",
    "gamification_test.this_workspace": "bu çalışma alanı",
    "this workspace": "bu çalışma alanı",
    "gamification_test.coins": "JETON",
    "COINS": "JETON",
    "gamification_test.points": "PUAN",
    "POINTS": "PUAN",
    "gamification_test.streak": "SERİ",
    "STREAK": "SERİ",
    "gamification_test.week": "1 hafta",
    "1 week": "1 hafta",
    "gamification_test.launch": "Lansman yolu",
    "Launch path": "Lansman yolu",
    "gamification_test.progress": "{total} eylemden {completed} tamamlandı · {coins} jetona kadar",
    "{completed} of {total} actions complete · up to {coins} coins": "{total} eylemden {completed} tamamlandı · {coins} jetona kadar",
    "gamification_test.done": "Tamam",
    "gamification_test.reward": "+{count} jeton",
    "+{count} coins": "+{count} jeton",
    "gamification_test.badges": "Rozetler",
    "Badges": "Rozetler",
    "gamification_test.mission_listing_created": "İlk ilanınızı oluşturun",
    "Create your first listing": "İlk ilanınızı oluşturun",
    "gamification_test.mission_collection_created": "İlk koleksiyonunuzu oluşturun",
    "Create your first collection": "İlk koleksiyonunuzu oluşturun",
    "gamification_test.mission_payment_configured": "Ödemeleri yapılandırın",
    "Configure payments": "Ödemeleri yapılandırın",
    "gamification_test.mission_publish_completed": "Sitenizi yayınlayın",
    "Publish your site": "Sitenizi yayınlayın",
    "gamification_test.mission_analytics_enabled": "Analizi etkinleştirin",
    "Enable analytics": "Analizi etkinleştirin",
    "gamification_test.badge_first_step": "İlk adım",
    "First Step": "İlk adım",
    "gamification_test.badge_catalog_builder": "Katalog oluşturucu",
    "Catalog Builder": "Katalog oluşturucu",
    "gamification_test.badge_ready_to_sell": "Satışa hazır",
    "Ready to Sell": "Satışa hazır",
    "gamification_test.badge_data_driven": "Veri odaklı",
    "Data Driven": "Veri odaklı",
    "gamification_test.badge_growth_operator": "Büyüme operatörü",
    "Growth Operator": "Büyüme operatörü",
    "sentry_check.title": "Sentry yapılandırma kontrolü",
    "Sentry Configuration Check": "Sentry yapılandırma kontrolü",
    "sentry_check.subtitle": "Sentry hata izleme kurulumunu test edin ve doğrulayın",
    "Test and verify Sentry error tracking setup": "Sentry hata izleme kurulumunu test edin ve doğrulayın",
    "sentry_check.configuration": "Yapılandırma",
    "sentry_check.check_configuration": "Yapılandırmayı kontrol et",
    "Check Configuration": "Yapılandırmayı kontrol et",
    "sentry_check.status": "Durum:",
    "Status:": "Durum:",
    "sentry_check.enabled": "✓ Etkin",
    "✓ Enabled": "✓ Etkin",
    "sentry_check.disabled": "✗ Devre dışı",
    "✗ Disabled": "✗ Devre dışı",
    "sentry_check.environment": "Ortam:",
    "Environment:": "Ortam:",
    "sentry_check.dsn": "DSN:",
    "DSN:": "DSN:",
    "sentry_check.traces_sample_rate": "İz örnekleme oranı:",
    "Traces Sample Rate:": "İz örnekleme oranı:",
    "sentry_check.test_functions": "Test işlevleri",
    "Test Functions": "Test işlevleri",
    "sentry_check.test_hint": "Sentry işlevlerini test etmek için aşağıdaki düğmelere tıklayın. Olayların kaydedildiğini görmek için Sentry panosunu kontrol edin.",
    "Click the buttons below to test different Sentry functionalities. Check your Sentry dashboard to verify the events are being captured.": "Sentry işlevlerini test etmek için aşağıdaki düğmelere tıklayın. Olayların kaydedildiğini görmek için Sentry panosunu kontrol edin.",
    "sentry_check.test_results": "Test sonuçları",
    "Test Results": "Test sonuçları",
    "sentry_check.clear": "Temizle",
    "sentry_check.no_tests": "Henüz test çalıştırılmadı",
    "No tests run yet": "Henüz test çalıştırılmadı",
    "sentry_check.important_notes": "⚠️ Önemli notlar",
    "⚠️ Important Notes": "⚠️ Önemli notlar",
    "sentry_check.warning_real_events": "• Bu testler Sentry panonuzda gerçek hata olayları oluşturur",
    "• These tests will create real error events in your Sentry dashboard": "• Bu testler Sentry panonuzda gerçek hata olayları oluşturur",
    "sentry_check.warning_dashboard": "• Olayların kaydedildiğini doğrulamak için Sentry panosunu kontrol edin",
    "• Check your Sentry dashboard to verify events are being captured": "• Olayların kaydedildiğini doğrulamak için Sentry panosunu kontrol edin",
    "sentry_check.warning_traces": "• tracesSampleRate 0.0 ise bazı testler Sentry’de görünmeyebilir",
    "• Some tests may not show in Sentry if tracesSampleRate is 0.0": "• tracesSampleRate 0.0 ise bazı testler Sentry’de görünmeyebilir",
    "sentry_check.warning_dsn": "• DSN’nin ortam değişkenlerinde doğru yapılandırıldığından emin olun",
    "• Make sure your DSN is correctly configured in environment variables": "• DSN’nin ortam değişkenlerinde doğru yapılandırıldığından emin olun",
    "sentry_check.normal_error": "Normal hatayı test et",
    "Test Normal Error": "Normal hatayı test et",
    "sentry_check.test_normal_error": "Normal hatayı test et",
    "sentry_check.test_message": "Mesajı test et",
    "Test Message": "Mesajı test et",
    "sentry_check.test_breadcrumb": "Breadcrumb’u test et",
    "Test Breadcrumb": "Breadcrumb’u test et",
    "sentry_check.test_user_context": "Kullanıcı bağlamını test et",
    "Test User Context": "Kullanıcı bağlamını test et",
    "sentry_check.test_custom_exception": "Özel istisnayı test et",
    "Test Custom Exception": "Özel istisnayı test et",
    "sentry_check.test_promise_rejection": "Promise reddini test et",
    "Test Promise Rejection": "Promise reddini test et",
    "sentry_check.configuration_check": "Yapılandırma kontrolü",
    "Configuration Check": "Yapılandırma kontrolü",
    "sentry_check.config_loaded": "Yapılandırma başarıyla yüklendi",
    "Config loaded successfully": "Yapılandırma başarıyla yüklendi",
    "sentry_check.error_captured": "Hata yakalandı ve Sentry’ye gönderildi",
    "Error captured and sent to Sentry": "Hata yakalandı ve Sentry’ye gönderildi",
    "sentry_check.error_capture_failed": "Hata yakalanamadı: {message}",
    "Failed to capture error: {message}": "Hata yakalanamadı: {message}",
    "sentry_check.message": "Mesaj",
    "Message": "Mesaj",
    "sentry_check.message_captured": "Mesaj yakalandı ve Sentry’ye gönderildi",
    "Message captured and sent to Sentry": "Mesaj yakalandı ve Sentry’ye gönderildi",
    "sentry_check.message_capture_failed": "Mesaj yakalanamadı: {message}",
    "Failed to capture message: {message}": "Mesaj yakalanamadı: {message}",
    "sentry_check.breadcrumb": "Breadcrumb",
    "Breadcrumb": "Breadcrumb",
    "sentry_check.breadcrumb_added": "Breadcrumb Sentry bağlamına eklendi",
    "Breadcrumb added to Sentry context": "Breadcrumb Sentry bağlamına eklendi",
    "sentry_check.breadcrumb_failed": "Breadcrumb eklenemedi: {message}",
    "Failed to add breadcrumb: {message}": "Breadcrumb eklenemedi: {message}",
    "sentry_check.user_context": "Kullanıcı bağlamı",
    "User Context": "Kullanıcı bağlamı",
    "sentry_check.user_set": "Kullanıcı bağlamı Sentry’de ayarlandı",
    "User context set in Sentry": "Kullanıcı bağlamı Sentry’de ayarlandı",
    "sentry_check.user_failed": "Kullanıcı bağlamı ayarlanamadı: {message}",
    "Failed to set user context: {message}": "Kullanıcı bağlamı ayarlanamadı: {message}",
    "sentry_check.custom_exception": "Özel istisna",
    "Custom Exception": "Özel istisna",
    "sentry_check.custom_sent": "Bağlam içeren özel istisna Sentry’ye gönderildi",
    "Custom exception with context sent to Sentry": "Bağlam içeren özel istisna Sentry’ye gönderildi",
    "sentry_check.custom_failed": "Özel istisna yakalanamadı: {message}",
    "Failed to capture custom exception: {message}": "Özel istisna yakalanamadı: {message}",
    "sentry_check.promise_rejection": "Promise reddi",
    "Promise Rejection": "Promise reddi",
    "sentry_check.promise_captured": "Promise reddi yakalandı ve Sentry’ye gönderildi",
    "Promise rejection captured and sent to Sentry": "Promise reddi yakalandı ve Sentry’ye gönderildi",
    "sentry_check.promise_failed": "Promise reddi işlenemedi: {message}",
    "Failed to handle promise rejection: {message}": "Promise reddi işlenemedi: {message}",
    "checkout_settings.orders": "Siparişler",
    "checkout_settings.return_policy_days": "İade süresi (gün)",
    "Return policy days": "İade süresi (gün)",
    "checkout_settings.enter_return_policy_days": "İade süresini gün olarak girin",
    "Enter return policy days": "İade süresini gün olarak girin",
    "checkout_settings.saved": "Başarıyla kaydedildi",
    "checkout_settings.cart": "Sepet",
    "checkout_settings.hide_quantity_selection": "Miktar seçimini gizle (varsayılan: miktar alanı gösterilir)",
    "Hide quantity selection (Default: Shows field to select quantity)": "Miktar seçimini gizle (varsayılan: miktar alanı gösterilir)",
    "checkout_settings.enable_coupon": "Kuponları etkinleştir",
    "Enable Coupon": "Kuponları etkinleştir",
    "upgrade_page.copy.a_practical_next_step": "Pratik bir sonraki adım",
    "A practical next step": "Pratik bir sonraki adım",
    "upgrade_page.copy.add_the_structured_information_your_workflow_needs": "İş akışınızın ihtiyaç duyduğu yapılandırılmış bilgileri ekleyin.",
    "Add the structured information your workflow needs.": "İş akışınızın ihtiyaç duyduğu yapılandırılmış bilgileri ekleyin.",
    "upgrade_page.copy.assign_roles_and_permissions_to_every_teammate": "Her ekip arkadaşına rol ve izin atayın.",
    "Assign roles and permissions to every teammate.": "Her ekip arkadaşına rol ve izin atayın.",
    "upgrade_page.copy.audit_log_export": "Denetim günlüğünü dışa aktar",
    "Audit log export": "Denetim günlüğünü dışa aktar",
    "upgrade_page.copy.best_next_step": "En iyi sonraki adım",
    "Best next step": "En iyi sonraki adım",
    "upgrade_page.copy.bring_structured_records_in_make_offline_changes_and_export_them_when_your_team_needs_a_complete_working_copy": "Yapılandırılmış kayıtları içe aktarın, çevrimdışı değiştirin ve ekibinizin ihtiyaç duyduğu eksiksiz çalışma kopyasını dışa aktarın.",
    "Bring structured records in, make offline changes, and export them when your team needs a complete working copy.": "Yapılandırılmış kayıtları içe aktarın, çevrimdışı değiştirin ve ekibinizin ihtiyaç duyduğu eksiksiz çalışma kopyasını dışa aktarın.",
    "upgrade_page.copy.build_beyond_the_standard_interface": "Standart arayüzün ötesinde oluşturun",
    "Build beyond the standard interface": "Standart arayüzün ötesinde oluşturun",
    "upgrade_page.copy.capture_the_details_that_make_your_catalogue_useful": "Kataloğunuzu kullanışlı kılan ayrıntıları ekleyin.",
    "Capture the details that make your catalogue useful.": "Kataloğunuzu kullanışlı kılan ayrıntıları ekleyin.",
    "upgrade_page.copy.choose_the_flexibility_to_build_your_own_customer_facing_experiences_on_top_of_tradly": "Tradly üzerinde müşterilere yönelik kendi deneyimlerinizi oluşturma esnekliğini seçin.",
    "Choose the flexibility to build your own customer-facing experiences on top of Tradly.": "Tradly üzerinde müşterilere yönelik kendi deneyimlerinizi oluşturma esnekliğini seçin.",
    "upgrade_page.copy.combine_existing_listings_into_curated_bundles_and_let_customers_select_eligible_items_at_checkout": "Mevcut ilanları seçilmiş paketlerde birleştirin ve müşterilerin ödeme sırasında uygun ürünleri seçmesini sağlayın.",
    "Combine existing listings into curated bundles and let customers select eligible items at checkout.": "Mevcut ilanları seçilmiş paketlerde birleştirin ve müşterilerin ödeme sırasında uygun ürünleri seçmesini sağlayın.",
    "upgrade_page.copy.configure_the_currencies_your_business_needs_as_you_operate_across_regions": "Farklı bölgelerde faaliyet gösterirken işletmenizin ihtiyaç duyduğu para birimlerini yapılandırın.",
    "Configure the currencies your business needs as you operate across regions.": "Farklı bölgelerde faaliyet gösterirken işletmenizin ihtiyaç duyduğu para birimlerini yapılandırın.",
    "upgrade_page.copy.connect_your_marketplace_with_internal_tools_and_automation_when_manual_work_no_longer_scales": "Manuel işler ölçeklenmediğinde pazaryerinizi dahili araçlara ve otomasyona bağlayın.",
    "Connect your marketplace with internal tools and automation when manual work no longer scales.": "Manuel işler ölçeklenmediğinde pazaryerinizi dahili araçlara ve otomasyona bağlayın.",
    "upgrade_page.copy.connect_your_own_tools": "Kendi araçlarınızı bağlayın",
    "Connect your own tools": "Kendi araçlarınızı bağlayın",
    "upgrade_page.copy.control_who_can_see_and_change_what": "Kimin neleri görebileceğini ve değiştirebileceğini yönetin.",
    "Control who can see and change what.": "Kimin neleri görebileceğini ve değiştirebileceğini yönetin.",
    "upgrade_page.copy.create_custom_fields_for_the_facts_customers_and_your_team_need_to_see_on_every_listing_or_account": "Müşterilerin ve ekibinizin her ilanda veya hesapta görmesi gereken bilgiler için özel alanlar oluşturun.",
    "Create custom fields for the facts customers and your team need to see on every listing or account.": "Müşterilerin ve ekibinizin her ilanda veya hesapta görmesi gereken bilgiler için özel alanlar oluşturun.",
    "upgrade_page.copy.create_fixed_and_mix_and_match_bundles": "Sabit ve karışık paketler oluşturun.",
    "Create fixed and mix-and-match bundles.": "Sabit ve karışık paketler oluşturun.",
    "upgrade_page.copy.custom_attributes": "Özel özellikler",
    "Custom attributes": "Özel özellikler",
    "upgrade_page.copy.custom_email_templates": "Özel e-posta şablonları",
    "Custom email templates": "Özel e-posta şablonları",
    "upgrade_page.copy.email_whitelabelling": "E-posta markalama",
    "Email whitelabelling": "E-posta markalama",
    "upgrade_page.copy.everything_in_growth": "Growth planındaki her şey",
    "Everything in Growth": "Growth planındaki her şey",
    "upgrade_page.copy.everything_in_growth_with_the_highest_limits": "En yüksek limitlerle Growth planındaki her şey.",
    "Everything in Growth, with the highest limits.": "En yüksek limitlerle Growth planındaki her şey.",
    "upgrade_page.copy.everything_in_starter": "Starter planındaki her şey",
    "Everything in Starter": "Starter planındaki her şey",
    "upgrade_page.copy.expand_your_workspace": "Çalışma alanınızı genişletin",
    "Expand your workspace": "Çalışma alanınızı genişletin",
    "upgrade_page.copy.feature_access": "Özellik erişimi",
    "Feature access": "Özellik erişimi",
    "upgrade_page.copy.for_a_growing_catalogue_that_needs_clearer_product_choices": "Daha net ürün seçeneklerine ihtiyaç duyan büyüyen kataloglar için.",
    "For a growing catalogue that needs clearer product choices.": "Daha net ürün seçeneklerine ihtiyaç duyan büyüyen kataloglar için.",
    "upgrade_page.copy.for_established_businesses": "Yerleşik işletmeler için",
    "For established businesses": "Yerleşik işletmeler için",
    "upgrade_page.copy.for_growing_operations": "Büyüyen operasyonlar için",
    "For growing operations": "Büyüyen operasyonlar için",
    "upgrade_page.copy.for_growing_teams": "Büyüyen ekipler için",
    "For growing teams": "Büyüyen ekipler için",
    "upgrade_page.copy.for_high_volume_teams_that_need_room_to_operate_at_scale": "Ölçekli çalışmak için daha fazla alana ihtiyaç duyan yüksek hacimli ekipler için.",
    "For high-volume teams that need room to operate at scale.": "Ölçekli çalışmak için daha fazla alana ihtiyaç duyan yüksek hacimli ekipler için.",
    "upgrade_page.copy.for_teams_managing_a_larger_catalogue_and_more_workflows": "Daha geniş katalog ve daha fazla iş akışını yöneten ekipler için.",
    "For teams managing a larger catalogue and more workflows.": "Daha geniş katalog ve daha fazla iş akışını yöneten ekipler için.",
    "upgrade_page.copy.for_teams_ready_to_work_beyond_one_record_at_a_time": "Tek seferde birden fazla kayıtla çalışmaya hazır ekipler için.",
    "For teams ready to work beyond one record at a time.": "Tek seferde birden fazla kayıtla çalışmaya hazır ekipler için.",
    "upgrade_page.copy.full_audit_history": "Tam denetim geçmişi",
    "Full audit history": "Tam denetim geçmişi",
    "upgrade_page.copy.growth_and_scale_plans_can_review_the_complete_audit_history_and_export_it_for_compliance_workflows": "Growth ve Scale planları tüm denetim geçmişini görüntüleyip uyumluluk iş akışları için dışa aktarabilir.",
    "Growth and Scale plans can review the complete audit history and export it for compliance workflows.": "Growth ve Scale planları tüm denetim geçmişini görüntüleyip uyumluluk iş akışları için dışa aktarabilir.",
    "upgrade_page.copy.higher_usage_limits": "Daha yüksek kullanım limitleri",
    "Higher usage limits": "Daha yüksek kullanım limitleri",
    "upgrade_page.copy.highest_usage_limits": "En yüksek kullanım limitleri",
    "Highest usage limits": "En yüksek kullanım limitleri",
    "upgrade_page.copy.import_and_export_records_without_repetitive_manual_work": "Tekrarlayan manuel işler olmadan kayıtları içe ve dışa aktarın.",
    "Import and export records without repetitive manual work.": "Tekrarlayan manuel işler olmadan kayıtları içe ve dışa aktarın.",
    "upgrade_page.copy.import_and_export_tools": "İçe ve dışa aktarma araçları",
    "Import and export tools": "İçe ve dışa aktarma araçları",
    "upgrade_page.copy.improve_important_customer_messages": "Önemli müşteri mesajlarını iyileştirin",
    "Improve important customer messages": "Önemli müşteri mesajlarını iyileştirin",
    "upgrade_page.copy.keep_a_longer_compliance_history": "Uyumluluk geçmişini daha uzun süre saklayın",
    "Keep a longer compliance history": "Uyumluluk geçmişini daha uzun süre saklayın",
    "upgrade_page.copy.keep_complete_compliance_visibility_for_high_volume_operations": "Yüksek hacimli operasyonlarda tam uyumluluk görünürlüğünü koruyun.",
    "Keep complete compliance visibility for high-volume operations.": "Yüksek hacimli operasyonlarda tam uyumluluk görünürlüğünü koruyun.",
    "upgrade_page.copy.keep_more_data_and_workflows_organised_as_the_catalogue_grows": "Katalog büyüdükçe daha fazla veriyi ve iş akışını düzenli tutun.",
    "Keep more data and workflows organised as the catalogue grows.": "Katalog büyüdükçe daha fazla veriyi ve iş akışını düzenli tutun.",
    "upgrade_page.copy.keep_your_workspace_secure": "Çalışma alanınızı güvende tutun",
    "Keep your workspace secure": "Çalışma alanınızı güvende tutun",
    "upgrade_page.copy.large": "Büyük",
    "Large": "Büyük",
    "upgrade_page.copy.let_customers_choose_options_from_one_listing": "Müşterilerin tek bir ilandan seçenekleri seçmesine izin verin.",
    "Let customers choose options from one listing.": "Müşterilerin tek bir ilandan seçenekleri seçmesine izin verin.",
    "upgrade_page.copy.listing_variants": "İlan varyantları",
    "Listing variants": "İlan varyantları",
    "upgrade_page.copy.make_every_customer_email_yours": "Her müşteri e-postasını markanıza uyarlayın",
    "Make every customer email yours": "Her müşteri e-postasını markanıza uyarlayın",
    "upgrade_page.copy.make_one_listing_work_harder": "Tek bir ilandan daha fazla yararlanın",
    "Make one listing work harder": "Tek bir ilandan daha fazla yararlanın",
    "upgrade_page.copy.make_system_emails_match_your_workflow_and_tone": "Sistem e-postalarını iş akışınıza ve üslubunuza uydurun.",
    "Make system emails match your workflow and tone.": "Sistem e-postalarını iş akışınıza ve üslubunuza uydurun.",
    "upgrade_page.copy.make_your_project_available_in_more_languages": "Projenizi daha fazla dilde kullanıma açın.",
    "Make your project available in more languages.": "Projenizi daha fazla dilde kullanıma açın.",
    "upgrade_page.copy.manage_the_customer_facing_language_experience_as_you_expand_into_new_regions_and_audiences": "Yeni bölgelere ve kitlelere açılırken müşteriye sunulan dil deneyimini yönetin.",
    "Manage the customer-facing language experience as you expand into new regions and audiences.": "Yeni bölgelere ve kitlelere açılırken müşteriye sunulan dil deneyimini yönetin.",
    "upgrade_page.copy.medium": "Orta",
    "upgrade_page.copy.more_capacity": "Daha fazla kapasite",
    "More capacity": "Daha fazla kapasite",
    "upgrade_page.copy.more_storage": "Daha fazla depolama",
    "More storage": "Daha fazla depolama",
    "upgrade_page.copy.more_team_capacity": "Daha fazla ekip kapasitesi",
    "More team capacity": "Daha fazla ekip kapasitesi",
    "upgrade_page.copy.move_faster_with_your_catalogue": "Kataloğunuzla daha hızlı çalışın",
    "Move faster with your catalogue": "Kataloğunuzla daha hızlı çalışın",
    "upgrade_page.copy.move_larger_catalogues_and_teams_through_routine_work_faster": "Büyük katalogları ve ekipleri günlük işlerde daha hızlı yönetin",
    "Move larger catalogues and teams through routine work faster.": "Büyük katalogları ve ekipleri günlük işlerde daha hızlı yönetin",
    "upgrade_page.copy.offer_sizes_colours_or_other_choices_without_duplicating_listings_or_splitting_your_stock_management": "İlanları çoğaltmadan veya stok yönetimini bölmeden beden, renk ve diğer seçenekleri sunun",
    "Offer sizes, colours, or other choices without duplicating listings or splitting your stock management.": "İlanları çoğaltmadan veya stok yönetimini bölmeden beden, renk ve diğer seçenekleri sunun",
    "upgrade_page.copy.operate_with_the_highest_available_limits": "Mevcut en yüksek limitlerle çalışın",
    "Operate with the highest available limits.": "Mevcut en yüksek limitlerle çalışın",
    "upgrade_page.copy.per_module_permissions": "Modül bazında izinler",
    "Per-module permissions": "Modül bazında izinler",
    "upgrade_page.copy.priority_support": "Öncelikli destek",
    "Priority support": "Öncelikli destek",
    "upgrade_page.copy.review_more_than_the_latest_five_audit_events": "Son beşten fazla denetim olayını inceleyin",
    "Review more than the latest five audit events.": "Son beşten fazla denetim olayını inceleyin",
    "upgrade_page.copy.review_the_full_audit_history_as_your_team_and_activity_grow": "Ekibiniz ve etkinlikleriniz büyüdükçe tüm denetim geçmişini inceleyin",
    "Review the full audit history as your team and activity grow.": "Ekibiniz ve etkinlikleriniz büyüdükçe tüm denetim geçmişini inceleyin",
    "upgrade_page.copy.role_based_access_control": "Rol tabanlı erişim denetimi",
    "Role-based access control": "Rol tabanlı erişim denetimi",
    "upgrade_page.copy.roles_let_you_give_each_teammate_only_the_access_they_need_available_on_growth_and_above": "Roller, her ekip üyesine yalnızca ihtiyaç duyduğu erişimi vermenizi sağlar. Growth ve üstü planlarda kullanılabilir.",
    "Roles let you give each teammate only the access they need. Available on Growth and above.": "Roller, her ekip üyesine yalnızca ihtiyaç duyduğu erişimi vermenizi sağlar. Growth ve üstü planlarda kullanılabilir.",
    "upgrade_page.copy.run_a_stronger_more_polished_customer_communication_workflow": "Daha etkili ve özenli bir müşteri iletişim süreci oluşturun",
    "Run a stronger, more polished customer communication workflow.": "Daha etkili ve özenli bir müşteri iletişim süreci oluşturun",
    "upgrade_page.copy.sell_across_markets": "Farklı pazarlarda satış yapın",
    "Sell across markets": "Farklı pazarlarda satış yapın",
    "upgrade_page.copy.sell_products_together": "Ürünleri birlikte satın",
    "Sell products together": "Ürünleri birlikte satın",
    "upgrade_page.copy.send_email_from_a_brand_your_customers_recognise": "Müşterilerinizin tanıdığı bir markadan e-posta gönderin",
    "Send email from a brand your customers recognise.": "Müşterilerinizin tanıdığı bir markadan e-posta gönderin",
    "upgrade_page.copy.shape_the_information_you_collect": "Topladığınız bilgileri belirleyin",
    "Shape the information you collect": "Topladığınız bilgileri belirleyin",
    "upgrade_page.copy.small": "Küçük",
    "Small": "Küçük",
    "upgrade_page.copy.speak_to_more_customers": "Daha fazla müşteriye ulaşın",
    "Speak to more customers": "Daha fazla müşteriye ulaşın",
    "upgrade_page.copy.standardise_richer_data_across_a_high_volume_operation": "Yüksek hacimli operasyonlarda daha kapsamlı verileri standartlaştırın",
    "Standardise richer data across a high-volume operation.": "Yüksek hacimli operasyonlarda daha kapsamlı verileri standartlaştırın",
    "upgrade_page.copy.start_presenting_a_more_consistent_customer_experience": "Daha tutarlı bir müşteri deneyimi sunmaya başlayın",
    "Start presenting a more consistent customer experience.": "Daha tutarlı bir müşteri deneyimi sunmaya başlayın",
    "upgrade_page.copy.support_a_complete_enterprise_ready_customer_experience": "Kurumsal kullanıma hazır eksiksiz bir müşteri deneyimi sunun",
    "Support a complete enterprise-ready customer experience.": "Kurumsal kullanıma hazır eksiksiz bir müşteri deneyimi sunun",
    "upgrade_page.copy.support_customers_who_shop_in_different_currencies": "Farklı para birimleriyle alışveriş yapan müşterileri destekleyin",
    "Support customers who shop in different currencies.": "Farklı para birimleriyle alışveriş yapan müşterileri destekleyin",
    "upgrade_page.copy.support_high_volume_operational_workflows_at_scale": "Yüksek hacimli operasyonel iş akışlarını büyük ölçekte destekleyin",
    "Support high-volume operational workflows at scale.": "Yüksek hacimli operasyonel iş akışlarını büyük ölçekte destekleyin",
    "upgrade_page.copy.support_larger_workflows_and_teams": "Daha büyük iş akışlarını ve ekipleri destekleyin",
    "Support larger workflows and teams.": "Daha büyük iş akışlarını ve ekipleri destekleyin",
    "upgrade_page.copy.t_shirt": "Tişört",
    "T-shirt": "Tişört",
    "upgrade_page.copy.t_shirt_large": "Tişört — büyük",
    "T-shirt — Large": "Tişört — büyük",
    "upgrade_page.copy.t_shirt_medium": "Tişört — orta",
    "T-shirt — Medium": "Tişört — orta",
    "upgrade_page.copy.t_shirt_small": "Tişört — küçük",
    "T-shirt — Small": "Tişört — küçük",
    "upgrade_page.copy.tailor_the_messages_customers_receive_at_key_moments_without_changing_your_marketplace_setup": "Pazar yeri kurulumunuzu değiştirmeden müşterilerin önemli anlarda aldığı mesajları özelleştirin",
    "Tailor the messages customers receive at key moments without changing your marketplace setup.": "Pazar yeri kurulumunuzu değiştirmeden müşterilerin önemli anlarda aldığı mesajları özelleştirin",
    "upgrade_page.copy.unlock_more_tools_as_your_workspace_begins_to_grow": "Çalışma alanınız büyümeye başladıkça daha fazla aracın kilidini açın",
    "Unlock more tools as your workspace begins to grow.": "Çalışma alanınız büyümeye başladıkça daha fazla aracın kilidini açın",
    "upgrade_page.copy.unlock_this_feature_when_you_are_ready": "Hazır olduğunuzda bu özelliği etkinleştirin",
    "Unlock this feature when you are ready.": "Hazır olduğunuzda bu özelliği etkinleştirin",
    "upgrade_page.copy.use_headless_apis_for_a_fully_custom_experience": "Tamamen özelleştirilmiş bir deneyim için headless API kullanın",
    "Use headless APIs for a fully custom experience.": "Tamamen özelleştirilmiş bir deneyim için headless API kullanın",
    "upgrade_page.copy.use_the_api_when_your_workflow_needs_to_go_further": "İş akışınız daha fazlasını gerektirdiğinde API’yi kullanın",
    "Use the API when your workflow needs to go further.": "İş akışınız daha fazlasını gerektirdiğinde API’yi kullanın",
    "upgrade_page.copy.use_your_own_sender_identity_and_visual_branding_so_marketplace_communications_stay_consistent": "Pazar yeri iletişiminin tutarlı kalması için kendi gönderen kimliğinizi ve görsel markanızı kullanın",
    "Use your own sender identity and visual branding so marketplace communications stay consistent.": "Pazar yeri iletişiminin tutarlı kalması için kendi gönderen kimliğinizi ve görsel markanızı kullanın",
    "upgrade_page.copy.with_variants": "Varyantlı",
    "With variants": "Varyantlı",
    "upgrade_page.copy.without_variants": "Varyantsız",
    "Without variants": "Varyantsız",
    "upgrade_page.copy.workflow_tools": "İş akışı araçları",
    "Workflow tools": "İş akışı araçları",
    "upgrade_page.copy.your_current_work_remains_unchanged_while_you_compare_the_plan_that_includes_this_capability": "Bu özelliği içeren planları karşılaştırırken mevcut çalışmalarınız değişmeden kalır",
    "Your current work remains unchanged while you compare the plan that includes this capability.": "Bu özelliği içeren planları karşılaştırırken mevcut çalışmalarınız değişmeden kalır",
    "upgrade_page.copy.a_paid_plan": "ücretli plan",
    "a paid plan": "ücretli plan",
    "upgrade_page.copy.everything_a_growing_store_needs_remove_branding_add_your_domain_and_unlock_more_tools": "Büyüyen bir mağazanın ihtiyaç duyduğu her şey: markalamayı kaldırın, alan adınızı ekleyin ve daha fazla aracın kilidini açın.",
    "Everything a growing store needs: remove branding, add your domain, and unlock more tools.": "Büyüyen bir mağazanın ihtiyaç duyduğu her şey: markalamayı kaldırın, alan adınızı ekleyin ve daha fazla aracın kilidini açın.",
    "upgrade_page.copy.everything_unlocked": "Tüm özellikler açık",
    "Everything unlocked": "Tüm özellikler açık",
    "upgrade_page.copy.full_ai_stack_advanced_marketing_and_everything_unlocked_for_stores_serious_about_growth": "Büyümeyi hedefleyen mağazalar için tam yapay zeka paketi, gelişmiş pazarlama ve tüm özellikler",
    "upgrade_page.copy.a_note_from_the_tradly_team": "Tradly ekibinden bir not",
    "A note from the Tradly team": "Tradly ekibinden bir not",
    "upgrade_page.copy.help_us_keep_tradly_going": "Tradly’yi sürdürmemize yardımcı olun",
    "Help us keep Tradly going": "Tradly’yi sürdürmemize yardımcı olun",
    "upgrade_page.copy.our_costs_have_gone_up_and_to_keep_building_and_supporting_tradly_we_need_our_community_s_support_to_continue_with_your_workspace_please_choose_a_plan_your_store_and_your_data_are_safe_and_waiting_for_you_thank_you_for_being_part_of_tradly": "Maliyetlerimiz arttı. Tradly’yi geliştirmeye ve desteklemeye devam edebilmemiz için topluluğumuzun desteğine ihtiyacımız var. Çalışma alanınızı kullanmaya devam etmek için lütfen bir plan seçin. Mağazanız ve verileriniz güvende. Tradly’nin bir parçası olduğunuz için teşekkürler.",
    "Our costs have gone up, and to keep building and supporting Tradly we need our community's support. To continue with your workspace, please choose a plan. Your store and your data are safe and waiting for you. Thank you for being part of Tradly.": "Maliyetlerimiz arttı. Tradly’yi geliştirmeye ve desteklemeye devam edebilmemiz için topluluğumuzun desteğine ihtiyacımız var. Çalışma alanınızı kullanmaya devam etmek için lütfen bir plan seçin. Mağazanız ve verileriniz güvende. Tradly’nin bir parçası olduğunuz için teşekkürler.",
    "upgrade_page.copy.since_2019_we_have_offered_tradly_with_a_free_package_with_a_lot_included_at_no_cost_because_we_wanted_anyone_to_be_able_to_start_something_we_were_glad_to_do_it_but_it_is_no_longer_something_we_can_sustain_on_our_own_we_plan_to_bring_a_free_plan_back_once_the_business_crosses_a_certain_stage_so_we_can_give_back_to_the_community_that_got_us_here": "2019’dan beri herkes bir şeyler başlatabilsin diye birçok özelliği ücretsiz sunan bir Tradly planı sağladık. Bunu yapmaktan mutluyduk, ancak artık tek başımıza sürdüremiyoruz. Bizi bugüne taşıyan topluluğa katkıda bulunabilmek için işletmemiz belirli bir aşamaya ulaştığında ücretsiz planı geri getirmeyi umuyoruz.",
    "Since 2019 we have offered Tradly with a free package, with a lot included at no cost, because we wanted anyone to be able to start something. We were glad to do it, but it is no longer something we can sustain on our own. We plan to bring a free plan back once the business crosses a certain stage, so we can give back to the community that got us here.": "2019’dan beri herkes bir şeyler başlatabilsin diye birçok özelliği ücretsiz sunan bir Tradly planı sağladık. Bunu yapmaktan mutluyduk, ancak artık tek başımıza sürdüremiyoruz. Bizi bugüne taşıyan topluluğa katkıda bulunabilmek için işletmemiz belirli bir aşamaya ulaştığında ücretsiz planı geri getirmeyi umuyoruz.",
    "upgrade_page.copy.choose_the_plan_that_fits_you_today_you_can_change_it_any_time": "Bugün ihtiyaçlarınıza uygun planı seçin. İstediğiniz zaman değiştirebilirsiniz.",
    "Choose the plan that fits you today. You can change it any time.": "Bugün ihtiyaçlarınıza uygun planı seçin. İstediğiniz zaman değiştirebilirsiniz.",
    "upgrade_page.back_to_workspace": "Çalışma alanına dön",
    "Back to workspace": "Çalışma alanına dön",
    "upgrade_page.grow_when_ready": "İhtiyaç duyduğunuzda büyüyün",
    "Grow when the work calls for it": "İhtiyaç duyduğunuzda büyüyün",
    "upgrade_page.reassurance": "Mevcut verileriniz, ilanlarınız ve kurulumunuz aynen kalır.",
    "Your existing data, listings, and setup stay exactly as they are.": "Mevcut verileriniz, ilanlarınız ve kurulumunuz aynen kalır.",
    "upgrade_page.choose_plan": "Plan seç",
    "Choose a plan": "Plan seç",
    "upgrade_page.feature_availability": "Özellik kullanılabilirliği",
    "Feature availability": "Özellik kullanılabilirliği",
    "upgrade_page.available_from": "Şu plandan itibaren kullanılabilir",
    "Available from": "Şu plandan itibaren kullanılabilir",
    "upgrade_page.and_above": "ve üzeri",
    "and above": "ve üzeri",
    "upgrade_page.choose_when_useful": "Bu özelliğin ekibiniz için yararlı olduğu zaman bir plan seçin.",
    "Choose a plan only when this capability is useful to your team.": "Bu özelliğin ekibiniz için yararlı olduğu zaman bir plan seçin.",
    "upgrade_page.practical_difference": "Pratik fark",
    "The practical difference": "Pratik fark",
    "upgrade_page.keep_work_simple": "Büyüdükçe işlerinizi kolaylaştırın.",
    "Keep the work simpler as you grow.": "Büyüdükçe işlerinizi kolaylaştırın.",
    "upgrade_page.plan_path": "Plan yolu",
    "Plan path": "Plan yolu",
    "upgrade_page.plan_path_title": "Bir sonraki adımı destekleyen planla başlayın.",
    "Start with the plan that supports this next step.": "Bir sonraki adımı destekleyen planla başlayın.",
    "upgrade_page.best_next_step": "En iyi sonraki adım",
    "upgrade_page.includes_capability": "Bu özelliği içerir",
    "Includes this capability": "Bu özelliği içerir",
    "upgrade_page.not_included": "Dahil değil",
    "Not included": "Dahil değil",
    "upgrade_page.included": "✓ Dahil",
    "✓ Included": "✓ Dahil",
    "upgrade_page.ready_when_you_are": "Hazır olduğunuzda kullanıma hazır.",
    "Ready when you are.": "Hazır olduğunuzda kullanıma hazır.",
    "upgrade_page.billing_details": "Plan ayrıntılarını inceleyin ve Tradly ödemesiyle güvenli biçimde devam edin.",
    "Review the complete plan details and continue securely with Tradly billing.": "Plan ayrıntılarını inceleyin ve Tradly ödemesiyle güvenli biçimde devam edin.",
    "upgrade_page.panel.close": "Yükseltme panelini kapat",
    "Close upgrade panel": "Yükseltme panelini kapat",
    "upgrade_page.panel.show_less": "Daha az göster",
    "Show less": "Daha az göster",
    "upgrade_page.panel.see_more": "Daha fazlasını gör",
    "See more": "Daha fazlasını gör",
    "upgrade_page.panel.choose_to_continue": "Devam etmek için bir plan seçin",
    "Choose a plan to continue": "Devam etmek için bir plan seçin",
    "upgrade_page.panel.more_ways_to_grow": "Daha fazla büyüme yolu",
    "More ways to grow": "Daha fazla büyüme yolu",
    "upgrade_page.panel.plan_includes_feature": "Her plan bu özelliğin yanı sıra sonraki aşamanız için ek kapasite içerir.",
    "Each plan includes this feature plus additional capacity for your next stage.": "Her plan bu özelliğin yanı sıra sonraki aşamanız için ek kapasite içerir.",
    "upgrade_page.panel.add_credits": "Kredi veya ürün ekle",
    "Add credits or products": "Kredi veya ürün ekle",
    "upgrade_page.panel.ala_carte_description": "Çalışma alanınız kullandıkça ödenir. Kredi yükleyin veya ihtiyacınız olan ürünleri ekleyin.",
    "Your workspace is billed à la carte. Top up credits or add the products you need.": "Çalışma alanınız kullandıkça ödenir. Kredi yükleyin veya ihtiyacınız olan ürünleri ekleyin.",
    "upgrade_page.panel.open_ala_carte": "Kullandıkça ödemeyi aç",
    "Open à la carte": "Kullandıkça ödemeyi aç",
    "upgrade_page.panel.recommended": "Önerilen",
    "Recommended": "Önerilen",
    "upgrade_page.panel.per_month": "/ ay",
    "upgrade_page.panel.please_wait": "Lütfen bekleyin…",
    "upgrade_page.panel.unlock_plan": "{plan} planının kilidini aç",
    "Unlock {plan}": "{plan} planının kilidini aç",
    "upgrade_page.panel.choose_plan": "{plan} planını seç",
    "Choose {plan}": "{plan} planını seç",
    "upgrade_page.panel.compare_plans": "Tüm plan ayrıntılarını karşılaştır",
    "Compare all plan details": "Tüm plan ayrıntılarını karşılaştır",
    "workspace.usage.page_title": "Kullanım özeti",
    "Usage overview": "Kullanım özeti",
    "workspace.usage.page_description": "Bu çalışma alanının mevcut kullanımını ve uygulanan limitleri görün.",
    "workspace.usage.not_available": "Kullanılamıyor",
    "workspace.usage.limit_not_configured": "Limit yapılandırılmadı",
    "Limit not configured": "Limit yapılandırılmadı",
    "workspace.usage.limit_value": "Limit: {limit}",
    "Limit: {limit}": "Limit: {limit}",
    "listings.photos": "Fotoğraflar",
    "Photos": "Fotoğraflar",
    "listings.listen_episode": "Bu bölümü dinle",
    "Listen to this episode": "Bu bölümü dinle",
    "listings.other_listings": "Diğer ilanlar",
    "Other listings": "Diğer ilanlar",
    "listings.delete": "Sil",
    "listings.fulfilled_by_platform": "Platform tarafından karşılanır",
    "Fulfilled by Platform": "Platform tarafından karşılanır",
    "listings.no_attributes_set": "Öznitelik ayarlanmadı",
    "No attributes set": "Öznitelik ayarlanmadı",
    "listings.campaign_raised": "{amount} toplandı",
    "{amount} raised": "{amount} toplandı",
    "listings.campaign_progress": "{goal} tutarının %{percent} kadarı",
    "{percent}% of {goal}": "{goal} tutarının %{percent} kadarı",
    "listings.seat": "koltuk",
    "seat": "koltuk",
    "listings.seats": "koltuk",
    "seats": "koltuk",
    "listings.per_slot": "slot başına",
    "per slot": "slot başına",
    "listings.total_value": "Toplam: {total}",
    "Total: {total}": "Toplam: {total}",
    "listings.orders": "Siparişler",
    "listings.total_orders": "Toplam sipariş",
    "Total orders": "Toplam sipariş",
    "listings.revenue": "Gelir",
    "listings.average_order": "Ort. sipariş",
    "listings.customers": "Müşteriler",
    "Customers": "Müşteriler",
    "listings.load_more": "Daha fazla yükle",
    "Load more": "Daha fazla yükle",
    "listings.filter": "Filtre",
    "listings.sort": "Sırala",
    "Sort": "Sırala",
    "listings.value_price": "Değer fiyatı",
    "Value Price": "Değer fiyatı",
    "listings.detail_label_title": "Başlık",
    "listings.detail_label_slug": "Kısa ad",
    "listings.detail_label_description": "Açıklama",
    "listings.detail_label_categories": "Kategoriler",
    "listings.detail_label_list_price": "Liste fiyatı",
    "List Price": "Liste fiyatı",
    "listings.detail_label_offer": "Teklif",
    "Offer": "Teklif",
    "listings.detail_label_currency": "Para birimi",
    "listings.detail_label_listing_status": "İlan durumu",
    "Listing Status": "İlan durumu",
    "listings.detail_label_active": "Etkin",
    "listings.detail_label_sold": "Satıldı",
    "listings.detail_label_meta_title": "Meta başlığı",
    "listings.detail_label_meta_description": "Meta açıklaması",
    "listings.detail_label_goal": "Hedef",
    "Goal": "Hedef",
    "listings.detail_label_donors": "Bağışçılar",
    "Donors": "Bağışçılar",
    "listings.detail_label_start_date": "Başlangıç tarihi",
    "listings.detail_label_end_date": "Bitiş tarihi",
    "listings.detail_label_stock": "Stok",
    "listings.detail_label_max_qty_order": "Sipariş başına maks. adet",
    "Max qty / order": "Sipariş başına maks. adet",
    "listings.detail_label_weight": "Ağırlık",
    "listings.detail_label_dimensions": "Boyutlar",
    "Dimensions": "Boyutlar",
    "listings.detail_label_listing_period": "İlan dönemi",
    "Listing period": "İlan dönemi",
    "listings.detail_label_max_tickets_booking": "Rezervasyon başına maks. bilet",
    "Max tickets / booking": "Rezervasyon başına maks. bilet",
    "listings.detail_label_rating": "Değerlendirme",
    "listings.detail_label_reviews": "Yorumlar",
    "listings.detail_label_likes": "Beğeni",
    "Likes": "Beğeni",
    "listings.detail_label_dislikes": "Beğenmeme",
    "Dislikes": "Beğenmeme",
    "listings.detail_label_barcode": "Barkod",
    "listings.detail_label_gtin": "GTIN",
    "GTIN": "GTIN",
    "listings.detail_label_mpn": "MPN",
    "MPN": "MPN",
    "listings.detail_label_sku": "Stok kodu",
    "listings.detail_section_basic_info": "Temel bilgiler",
    "Basic Info": "Temel bilgiler",
    "listings.detail_section_pricing": "Fiyatlandırma",
    "listings.detail_section_seo": "SEO",
    "SEO": "SEO",
    "listing_form.select_type_hint": "Devam etmek için yukarıdan bir ilan türü seçin.",
    "Select a listing type above to continue.": "Devam etmek için yukarıdan bir ilan türü seçin.",
    "listing_form.attributes": "Öznitelikler",
    "category.status_active_help": "Durum (Etkin değil / Etkin)",
    "promotions.medium": "Orta",
    "users.listings": "İlanlar",
    "users.accounts": "Hesaplar",
    "users.click_count_one": "{count} tıklama",
    "{count} click": "{count} tıklama",
    "users.click_count": "{count} tıklama",
    "{count} clicks": "{count} tıklama",
    "integrations.generic.provider_help": "Aşağıdaki alanları kullanarak seçilen sağlayıcıyı yapılandırın.",
    "Configure the selected provider using the fields below.": "Aşağıdaki alanları kullanarak seçilen sağlayıcıyı yapılandırın.",
    "attributes.editor_prefill_data_from": "Ön doldurma kaynağı",
    "Prefill Data From": "Ön doldurma kaynağı",
    "attributes.editor_select_attribute": "Öznitelik seç",
    "Select Attribute": "Öznitelik seç",
    "attributes.editor_select_attribute_group": "Öznitelik grubunu seç",
    "Select Attribute Group": "Öznitelik grubunu seç",
    "attributes.editor_attribute": "Öznitelik",
    "Attribute": "Öznitelik",
    "attributes.editor_attributes": "Öznitelikler",
    "attributes.editor_cart_attributes": "Sepet öznitelikleri",
    "Cart Attributes": "Sepet öznitelikleri",
    "listings.add_photo": "Fotoğraf ekle",
    "accounts.analytics": "Analizler",
    "listings.image_optional": "İlan görselleri (isteğe bağlı)",
    "Listing Images (Optional)": "İlan görselleri (isteğe bağlı)",
    "listings.currency": "Para birimi",
    "listing_variants.number_sign": "No.",
    "#": "No.",
    "attributes.active": "Etkin",
    "listing_form.digital_deleted_item_cannot_edit": "Bu öğe silinmek üzere işaretlendi ve düzenlenemez",
    "This item is marked for deletion and cannot be edited": "Bu öğe silinmek üzere işaretlendi ve düzenlenemez",
    "listing_form.digital_max_files": "En fazla 10 dosyaya izin verilir",
    "Maximum 10 files allowed": "En fazla 10 dosyaya izin verilir",
    "listing_form.digital_title_required": "Lütfen bir başlık girin",
    "listing_form.digital_version_required": "Lütfen sürüm adını girin",
    "Please enter a version name": "Lütfen sürüm adını girin",
    "listing_form.digital_contents": "Dijital içerikler",
    "Digital Contents": "Dijital içerikler",
    "listing_form.digital_add_content": "＋ İçerik ekle",
    "+ Add Content": "＋ İçerik ekle",
    "listing_form.no_description": "Açıklama yok",
    "No description": "Açıklama yok",
    "listing_form.digital_file_count": "{count} dosya",
    "{count} file(s)": "{count} dosya",
    "listing_form.digital_empty": "Henüz dijital içerik yok",
    "No digital contents yet": "Henüz dijital içerik yok",
    "listing_form.digital_empty_help": "İlk dijital içeriğinizi oluşturmak için “{action}” düğmesine tıklayın",
    "Click \"{action}\" to create your first digital content": "İlk dijital içeriğinizi oluşturmak için “{action}” düğmesine tıklayın",
    "listing_form.digital_marked_for_deletion": "Silinmek üzere işaretlendi ({count})",
    "Marked for Deletion ({count})": "Silinmek üzere işaretlendi ({count})",
    "listing_form.digital_will_delete_on_submit": "✓ Gönderildiğinde silinecek",
    "✓ Will be deleted on submit": "✓ Gönderildiğinde silinecek",
    "listing_form.digital_edit_title": "Dijital içeriği düzenle",
    "Edit Digital Content": "Dijital içeriği düzenle",
    "listing_form.digital_add_title": "Yeni dijital içerik ekle",
    "Add New Digital Content": "Yeni dijital içerik ekle",
    "listing_form.digital_form_description": "Dijital içeriği {action} için aşağıdaki bilgileri doldurun",
    "Fill in the details below to {action} digital content": "Dijital içeriği {action} için aşağıdaki bilgileri doldurun",
    "listing_form.digital_title_placeholder": "Dijital içerik başlığını girin",
    "Enter digital content title": "Dijital içerik başlığını girin",
    "listing_form.description_optional_placeholder": "Açıklama girin (isteğe bağlı)",
    "Enter description (optional)": "Açıklama girin (isteğe bağlı)",
    "listing_form.version": "Sürüm",
    "Version": "Sürüm",
    "listing_form.files": "Dosyalar",
    "Files": "Dosyalar",
    "listing_form.max_files": "(Maks. {count})",
    "(Max {count})": "(Maks. {count})",
    "listing_form.click_to_upload_files": "Dosyaları yüklemek için tıklayın",
    "Click to upload files": "Dosyaları yüklemek için tıklayın",
    "listing_form.files_uploaded_count": "{count}/10 dosya yüklendi",
    "{count}/10 files uploaded": "{count}/10 dosya yüklendi",
    "listing_form.unknown_size": "Bilinmeyen boyut",
    "Unknown size": "Bilinmeyen boyut",
    "listing_form.no_accounts_available": "Kullanılabilir hesap yok",
    "No accounts available": "Kullanılabilir hesap yok",
    "listing_form.select_account": "Bir hesap seçin",
    "Select an account": "Bir hesap seçin",
    "listing_form.searching": "Aranıyor…",
    "Searching...": "Aranıyor…",
    "listing_form.location_enter_address": "Aramak için bir adres girin",
    "Please enter an address to search": "Aramak için bir adres girin",
    "listing_form.location_no_addresses_search": "Adres bulunamadı. Farklı bir arama deneyin.",
    "No addresses found. Please try a different search.": "Adres bulunamadı. Farklı bir arama deneyin.",
    "listing_form.location_search_failed": "Adresler aranamadı. Lütfen tekrar deneyin.",
    "Failed to search addresses. Please try again.": "Adresler aranamadı. Lütfen tekrar deneyin.",
    "listing_form.location_place_details_failed": "Yer ayrıntıları alınamadı. Lütfen tekrar deneyin.",
    "Failed to get place details. Please try again.": "Yer ayrıntıları alınamadı. Lütfen tekrar deneyin.",
    "listing_form.location_access_denied": "Konum erişimi reddedildi. Lütfen konum iznini etkinleştirin.",
    "Location access denied. Please enable location permissions.": "Konum erişimi reddedildi. Lütfen konum iznini etkinleştirin.",
    "listing_form.location_unavailable": "Konum belirlenemedi. Lütfen tekrar deneyin.",
    "Unable to determine location. Please try again.": "Konum belirlenemedi. Lütfen tekrar deneyin.",
    "listing_form.location_timeout": "Konum isteğinin zaman aşımına uğradı. Lütfen tekrar deneyin.",
    "Location request timed out. Please try again.": "Konum isteğinin zaman aşımına uğradı. Lütfen tekrar deneyin.",
    "listing_form.location_current_failed": "Mevcut konum alınamadı. Lütfen tekrar deneyin.",
    "Failed to get current location. Please try again.": "Mevcut konum alınamadı. Lütfen tekrar deneyin.",
    "listing_form.location": "Konum",
    "listing_form.location_search_placeholder": "Konum ara…",
    "Search for a location...": "Konum ara…",
    "listing_form.location_searching": "Adresler aranıyor…",
    "Searching addresses...": "Adresler aranıyor…",
    "listing_form.location_no_addresses": "Adres bulunamadı",
    "No addresses found": "Adres bulunamadı",
    "listing_form.location_try_different_search": "Farklı bir arama terimi deneyin",
    "Try a different search term": "Farklı bir arama terimi deneyin",
    "listing_form.location_getting": "Konum alınıyor…",
    "Getting location...": "Konum alınıyor…",
    "listing_form.location_use_current": "Mevcut konumu kullan",
    "Use Current Location": "Mevcut konumu kullan",
    "listing_form.location_selected": "Seçilen konum",
    "Selected Location": "Seçilen konum",
    "listing_form.latitude": "Enlem:",
    "Latitude:": "Enlem:",
    "listing_form.longitude": "Boylam:",
    "Longitude:": "Boylam:",
    "listing_form.location_helper": "Bir adres arayın veya mevcut konumunuzu kullanın",
    "Search for an address or use your current location": "Bir adres arayın veya mevcut konumunuzu kullanın",
    "common.change": "Değiştir",
    "listing_form.variant_id_tooltip": "Tür Kimliği: {typeId}, Değer Kimliği: {valueId}",
    "Type ID: {typeId}, Value ID: {valueId}": "Tür Kimliği: {typeId}, Değer Kimliği: {valueId}",
    "listing_form.variants_marked_for_deletion": "Silinmek üzere işaretlendi ({count} öğe):",
    "Marked for Deletion ({count} items):": "Silinmek üzere işaretlendi ({count} öğe):",
    "listing_form.add_new_variant": "Yeni varyant ekle",
    "Add New Variant": "Yeni varyant ekle",
    "listing_form.add_variant_description": "Yeni bir varyant oluşturmak için aşağıdaki bilgileri doldurun",
    "Fill in the details below to create a new variant": "Yeni bir varyant oluşturmak için aşağıdaki bilgileri doldurun",
    "listing_form.google_search_preview": "Google arama önizlemesi",
    "Google Search Preview": "Google arama önizlemesi",
    "listing_form.meta_title_preview": "Meta başlığınız burada görünecek",
    "Your Meta Title Here": "Meta başlığınız burada görünecek",
    "listing_form.meta_description_preview": "Meta açıklamanız burada görünür. Kullanıcıların arama sonuçlarında sayfa içeriğinizi anlamasına yardımcı olur.",
    "Your meta description will appear here. This helps users understand your page content in search results.": "Meta açıklamanız burada görünür. Kullanıcıların arama sonuçlarında sayfa içeriğinizi anlamasına yardımcı olur.",
    "listing_form.variant_name_placeholder": "Ad girin",
    "listing_form.list_price_placeholder": "Liste fiyatını girin",
    "listing_form.offer_percent_placeholder": "Teklif yüzdesini girin",
    "Enter Offer Percent": "Teklif yüzdesini girin",
    "attributes.select_all": "Tümünü seç",
    "attributes.unselect_all": "Tüm seçimi kaldır",
    "Unselect All": "Tüm seçimi kaldır",
    "attributes.select_category": "Kategori seç",
    "attributes.create_category_configuration_first": "Önce {type} yapılandırmasında kategoriler oluşturun",
    "Create categories in {type} configuration first": "Önce {type} yapılandırmasında kategoriler oluşturun",
    "attributes.select_single_attribute_values": "Tekli öznitelik değerlerini seçin",
    "attributes.select_multiple_attribute_values": "Çoklu öznitelik değerlerini seçin",
    "attributes.enter_value": "Değer girin",
    "attributes.enter_multiple_tags": "Birden fazla etiket girin",
    "Enter Multiple Tags": "Birden fazla etiket girin",
    "attributes.upload_file": "Dosya yükle",
    "collections.add_condition": "＋ Başka koşul ekle",
    "+ Add another condition": "＋ Başka koşul ekle",
    "collections.add_photo": "Fotoğraf ekle",
    "collections.status": "Durum (Etkin değil / Etkin)",
    "collections.start_date_placeholder": "Başlangıç tarihini seçin",
    "Select start date": "Başlangıç tarihini seçin",
    "collections.end_date_placeholder": "Bitiş tarihini seçin",
    "Select end date": "Bitiş tarihini seçin",
    "navigation.editor": "Düzenleyici",
    "Editor": "Düzenleyici",
    "navigation.web_analytics": "Web analitiği",
    "Web Analytics": "Web analitiği",
    "navigation.ai_studio": "Yapay zeka stüdyosu",
    "AI Studio": "Yapay zeka stüdyosu",
    "navigation.docs": "Belgeler",
    "navigation.logout": "Çıkış yap",
    "Logout": "Çıkış yap",
    "navigation.tenant_name_placeholder": "(Kiracı adı)",
    "(Tenant name)": "(Kiracı adı)",
    "navigation.username_placeholder": "(Kullanıcı adı)",
    "(Username)": "(Kullanıcı adı)",
    "navigation.invite_description": "Ekip üyelerine davet bağlantıları gönderin",
    "Send invitation links to team members": "Ekip üyelerine davet bağlantıları gönderin",
    "navigation.invite": "Davet et",
    "Invite": "Davet et",
    "navigation.test_mode": "Test modu",
    "Test Mode": "Test modu",
    "navigation.upgrade": "Planı yükselt",
    "navigation.open_account_menu": "Hesap menüsünü aç",
    "Open account menu": "Hesap menüsünü aç",
    "navigation.invite_name_required": "Lütfen adı girin",
    "Please fill in the name": "Lütfen adı girin",
    "navigation.invite_email_required": "Lütfen e-posta adresini girin",
    "Please fill in the email": "Lütfen e-posta adresini girin",
    "navigation.open_url_failed": "Bu URL nasıl açılacak bilinmiyor: {url}",
    "Don't know how to open this URL: {url}": "Bu URL nasıl açılacak bilinmiyor: {url}",
    "navigation.no_code_editor": "Kodsuz düzenleyici",
    "No-code editor": "Kodsuz düzenleyici",
    "navigation.api_sdk": "API/SDK",
    "API/SDK": "API/SDK",
    "navigation.cms": "CMS",
    "CMS": "CMS",
    "navigation.marketing_automation": "Pazarlama otomasyonu",
    "Marketing automation": "Pazarlama otomasyonu",
    "navigation.analytics_recommendation": "Analiz ve öneriler",
    "Analytics & Recommendation": "Analiz ve öneriler",
    "navigation.ai_studio_iryxo": "Yapay zeka stüdyosu (Iryxo)",
    "AI Studio (Iryxo)": "Yapay zeka stüdyosu (Iryxo)",
    "navigation.tradly_mcp": "Tradly MCP",
    "Tradly MCP": "Tradly MCP",
    "navigation.current_project": "Mevcut proje",
    "Current project": "Mevcut proje",
    "navigation.current_user": "Mevcut kullanıcı",
    "Current user": "Mevcut kullanıcı",
    "navigation.switch_to_light_mode": "Açık moda geç",
    "Switch to light mode": "Açık moda geç",
    "navigation.switch_to_dark_mode": "Koyu moda geç",
    "Switch to dark mode": "Koyu moda geç",
    "navigation.download_android_app": "Android uygulamasını indir",
    "Download Android app": "Android uygulamasını indir",
    "navigation.download_ios_app": "iOS uygulamasını indir",
    "Download iOS app": "iOS uygulamasını indir",
    "navigation.subscribe_youtube": "YouTube kanalına abone ol",
    "Subscribe on YouTube": "YouTube kanalına abone ol",
    "navigation.open_app_switcher": "Uygulama değiştiriciyi aç",
    "Open app switcher": "Uygulama değiştiriciyi aç",
    "navigation.open_android_app": "Android uygulamasını aç",
    "Open Android app": "Android uygulamasını aç",
    "navigation.open_ios_app": "iOS uygulamasını aç",
    "Open iOS app": "iOS uygulamasını aç",
    "navigation.open_ai_support": "Tradly ChatGPT desteğini aç",
    "Open Tradly ChatGPT support": "Tradly ChatGPT desteğini aç",
    "navigation.open_youtube_channel": "Tradly YouTube kanalını aç",
    "Open Tradly YouTube channel": "Tradly YouTube kanalını aç",
    "navigation.demo": "Demo",
    "Demo": "Demo",
    "listings.smart_upload.listing_id_optional": "İlan Kimliği (isteğe bağlı — mevcut olanı güncelle)",
    "Listing ID (optional — update existing)": "İlan Kimliği (isteğe bağlı — mevcut olanı güncelle)",
    "listings.smart_upload.category_id": "Kategori Kimliği",
    "listings.smart_upload.list_price": "Liste fiyatı",
    "listings.smart_upload.stock": "Stok",
    "listings.smart_upload.sku": "Stok kodu",
    "listings.smart_upload.barcode": "Barkod",
    "listings.smart_upload.account_id": "Hesap Kimliği",
    "listings.smart_upload.slug": "Kısa ad",
    "listings.smart_upload.text": "Metin",
    "listings.smart_upload.long_text": "Uzun metin",
    "listings.smart_upload.number": "Sayı",
    "listings.smart_upload.single_select": "Tekli seçim",
    "listings.smart_upload.multi_select": "Çoklu seçim",
    "listings.smart_upload.attribute_name_required": "“{header}” için bir öznitelik adı girin.",
    "listings.smart_upload.attribute_create_failed": "Tradly yeni “{name}” özniteliğini döndürmedi.",
    "Tradly did not return the new “{name}” attribute.": "Tradly yeni “{name}” özniteliğini döndürmedi.",
    "listings.smart_upload.attribute_option_create_failed": "{name} için “{value}” seçeneği oluşturulamadı.",
    "Could not create the “{value}” option for {name}.": "{name} için “{value}” seçeneği oluşturulamadı.",
    "listings.smart_upload.attribute_no_longer_available": "“{header}” ile eşlenen öznitelik artık kullanılamıyor.",
    "listings.smart_upload.csv_needs_header_and_listing": "CSV dosyasında bir başlık satırı ve en az bir ilan bulunmalıdır.",
    "The CSV must contain a header row and at least one listing.": "CSV dosyasında bir başlık satırı ve en az bir ilan bulunmalıdır.",
    "listings.smart_upload.unique_headers_required": "Her ilan sütununun benzersiz ve boş olmayan bir başlığı olmalıdır.",
    "Every listing column needs a unique, non-empty header.": "Her ilan sütununun benzersiz ve boş olmayan bir başlığı olmalıdır.",
    "listings.smart_upload.csv_read_failed": "Bu CSV dosyası okunamadı.",
    "listings.smart_upload.map_required_fields": "Devam etmeden önce zorunlu sütunları eşleyin: {fields}",
    "Map these required columns before continuing: {fields}": "Devam etmeden önce zorunlu sütunları eşleyin: {fields}",
    "listings.smart_upload.row_missing_required_value": "{row}. satırda zorunlu bir değer eksik.",
    "Row {row} is missing a required value.": "{row}. satırda zorunlu bir değer eksik.",
    "listings.smart_upload.invalid_category_id_row": "{row}. satırda geçerli bir sayısal kategori kimliği girin veya “Kategori Kimliğini manuel eşle” seçeneğini belirleyin.",
    "Row {row} needs a valid numeric category ID, or choose “Map Category ID manually”.": "{row}. satırda geçerli bir sayısal kategori kimliği girin veya “Kategori Kimliğini manuel eşle” seçeneğini belirleyin.",
    "listings.smart_upload.invalid_listing_id_row": "{row}. satırda geçerli bir sayısal ilan kimliği girin veya yeni ilan oluşturmak için boş bırakın.",
    "Row {row} needs a valid numeric listing ID, or leave the ID blank to create a new listing.": "{row}. satırda geçerli bir sayısal ilan kimliği girin veya yeni ilan oluşturmak için boş bırakın.",
    "listings.smart_upload.progress.checking_duplicates": "Mevcut ilanlar kontrol ediliyor",
    "Checking for existing listings": "Mevcut ilanlar kontrol ediliyor",
    "listings.smart_upload.duplicate_same_value_row": "Aynı {field} değeri bu dosyanın {row}. satırında da var.",
    "Same {field} appears in row {row} of this file.": "Aynı {field} değeri bu dosyanın {row}. satırında da var.",
    "listings.smart_upload.duplicate_same_value_multiple": "Aynı {field} değeri bu dosyada birden fazla kez kullanılmış.",
    "Same {field} appears more than once in this file.": "Aynı {field} değeri bu dosyada birden fazla kez kullanılmış.",
    "listings.smart_upload.duplicate_existing_listing": "{field} alanında mevcut #{id} numaralı ilanla eşleşiyor.",
    "Matches existing listing #{id} by {field}.": "{field} alanında mevcut #{id} numaralı ilanla eşleşiyor.",
    "listings.smart_upload.explicit_listing_update": "Açıkça belirtilen #{id} ilan kimliği güncellenecek.",
    "Explicit listing ID #{id} will be updated.": "Açıkça belirtilen #{id} ilan kimliği güncellenecek.",
    "listings.smart_upload.progress.duplicates_complete": "Yinelenen kayıt kontrolü tamamlandı",
    "Duplicate check complete": "Yinelenen kayıt kontrolü tamamlandı",
    "listings.smart_upload.duplicate_check_failed": "Mevcut ilanlar kontrol edilemedi.",
    "Could not check existing listings.": "Mevcut ilanlar kontrol edilemedi.",
    "listings.smart_upload.progress.duplicates_stopped": "Yinelenen kayıt kontrolü durduruldu",
    "Duplicate check stopped": "Yinelenen kayıt kontrolü durduruldu",
    "listings.smart_upload.prepare_file_failed": "İçe aktarma dosyası hazırlanamadı.",
    "listings.smart_upload.progress.uploading_file": "İçe aktarma dosyası yükleniyor",
    "listings.smart_upload.upload_file_failed": "İçe aktarma dosyası yüklenemedi.",
    "listings.smart_upload.all_rows_duplicates": "Tüm satırlar yinelenen kayıt olarak belirlendi. Tradly’ye göndermek için “Yine de içe aktar” seçeneğini belirleyin veya baştan başlayın.",
    "All rows were identified as duplicates. Choose “Import anyway” to send them to Tradly, or start over.": "Tüm satırlar yinelenen kayıt olarak belirlendi. Tradly’ye göndermek için “Yine de içe aktar” seçeneğini belirleyin veya baştan başlayın.",
    "listings.smart_upload.progress.preparing_attributes": "Öznitelikler hazırlanıyor",
    "listings.smart_upload.attribute_mapped_once": "Her ilan özniteliği yalnızca bir kez eşlenebilir. İçe aktarmadan önce sütun eşlemelerini gözden geçirin.",
    "Each listing attribute can be mapped only once. Review the column mappings before importing.": "Her ilan özniteliği yalnızca bir kez eşlenebilir. İçe aktarmadan önce sütun eşlemelerini gözden geçirin.",
    "listings.smart_upload.progress.preparing_file": "İçe aktarma dosyası hazırlanıyor",
    "listings.smart_upload.progress.tradly_importing": "Tradly ilanları içe aktarıyor",
    "Tradly is importing listings": "Tradly ilanları içe aktarıyor",
    "listings.smart_upload.progress.import_complete": "İçe aktarma tamamlandı",
    "listings.smart_upload.progress.import_stopped": "İçe aktarma durduruldu",
    "listings.smart_upload.progress.preparing_import": "İçe aktarma hazırlanıyor…",
    "Preparing import…": "İçe aktarma hazırlanıyor…",
    "listings.smart_upload.progress.rows_prepared": "{total} satırdan {current} tanesi hazırlandı",
    "{current} of {total} rows prepared": "{total} satırdan {current} tanesi hazırlandı",
    "listings.smart_upload.progress.remote_processing": "Tradly yüklenen CSV dosyasını işliyor. Bu biraz zaman alabilir.",
    "Tradly is processing the uploaded CSV. This may take a moment.": "Tradly yüklenen CSV dosyasını işliyor. Bu biraz zaman alabilir.",
    "listings.smart_upload.progress.partial_import": "Tradly {total} satırın {imported} tanesini içe aktardı{ending}. Yeniden denemeden önce sonucu inceleyin; tümünü yeniden aktarmak başarılı satırları çoğaltabilir.",
    "Tradly imported {imported} of {total} rows{ending} Review the result before retrying; a full retry may duplicate successful rows.": "Tradly {total} satırın {imported} tanesini içe aktardı{ending}. Yeniden denemeden önce sonucu inceleyin; tümünü yeniden aktarmak başarılı satırları çoğaltabilir.",
    "listings.smart_upload.title": "Akıllı yükleme",
    "Smart Upload": "Akıllı yükleme",
    "listings.smart_upload.beta": "(Beta)",
    "listings.smart_upload.start_over": "Baştan başla",
    "listings.smart_upload.description": "İçe aktarmadan önce ilanları yükleyin, sütunları mevcut alanlarla eşleyin veya yeni ilan öznitelikleri oluşturun.",
    "Upload listings, map columns to existing fields, or create new listing attributes before importing.": "İçe aktarmadan önce ilanları yükleyin, sütunları mevcut alanlarla eşleyin veya yeni ilan öznitelikleri oluşturun.",
    "listings.smart_upload.step_upload": "Yükle",
    "listings.smart_upload.step_match": "Sütunları eşle",
    "listings.smart_upload.step_preview": "Önizleme",
    "listings.smart_upload.step_import": "İçe aktar",
    "listings.smart_upload.choose_csv": "CSV dosyası seçin",
    "listings.smart_upload.required_columns_help": "Zorunlu sütunlar title ve category_id alanlarıdır. Diğer sütunlar ilan özniteliği olabilir.",
    "Required columns are title and category_id. Any other columns can become listing attributes.": "Zorunlu sütunlar title ve category_id alanlarıdır. Diğer sütunlar ilan özniteliği olabilir.",
    "listings.smart_upload.select_csv_file": "CSV dosyası seçin",
    "listings.smart_upload.match_columns": "İlan sütunlarını eşle",
    "Match listing columns": "İlan sütunlarını eşle",
    "listings.smart_upload.core_fields_help": "Temel alanlar ilan API’sine gönderilir. Ek sütunlar ilan özniteliği olarak kaydedilebilir.",
    "Core fields are sent to the listing API. Additional columns can be saved as listing attributes.": "Temel alanlar ilan API’sine gönderilir. Ek sütunlar ilan özniteliği olarak kaydedilebilir.",
    "listings.smart_upload.do_not_import": "İçe aktarma",
    "listings.smart_upload.map_category_manually": "Kategori Kimliğini manuel eşle",
    "Map Category ID manually": "Kategori Kimliğini manuel eşle",
    "listings.smart_upload.category_assignment_help": "İçe aktarılan tüm ilanlara atanacak kategoriyi seçin.",
    "Choose the category to assign to every imported listing.": "İçe aktarılan tüm ilanlara atanacak kategoriyi seçin.",
    "listings.smart_upload.select_category": "Kategori seç",
    "listings.smart_upload.no_categories": "İlan kategorisi bulunamadı. Önce bir kategori oluşturun, ardından Akıllı Yükleme’yi yeniden açın.",
    "No listing categories were returned. Create a category first, then reopen Smart Upload.": "İlan kategorisi bulunamadı. Önce bir kategori oluşturun, ardından Akıllı Yükleme’yi yeniden açın.",
    "listings.smart_upload.additional_attributes": "Ek ilan öznitelikleri",
    "Additional listing attributes": "Ek ilan öznitelikleri",
    "listings.smart_upload.ignore_column": "Bu sütunu yoksay",
    "listings.smart_upload.create_attribute": "＋ Yeni ilan özniteliği oluştur",
    "＋ Create a new listing attribute": "＋ Yeni ilan özniteliği oluştur",
    "listings.smart_upload.attribute_name": "Öznitelik adı",
    "listings.smart_upload.review_import": "İçe aktarmayı gözden geçir",
    "listings.smart_upload.rows_scanned_help": "Yüklemeden önce {count} ilan tarandı. Yinelenenler SKU, barkod, kısa ad ve bu CSV’de tekrarlanan değerlere göre kontrol edilir.",
    "{count} listings scanned before upload. Duplicate checks use SKU, barcode, slug, and repeated values in this CSV.": "Yüklemeden önce {count} ilan tarandı. Yinelenenler SKU, barkod, kısa ad ve bu CSV’de tekrarlanan değerlere göre kontrol edilir.",
    "listings.smart_upload.duplicates_found": "Olası yinelenen kayıtlar",
    "Potential duplicates found": "Olası yinelenen kayıtlar",
    "listings.smart_upload.duplicate_rows_skipped": "Varsayılan olarak {count} satır atlanacak.",
    "{count} row(s) will be skipped by default.": "Varsayılan olarak {count} satır atlanacak.",
    "listings.smart_upload.row_label": "Satır",
    "Row": "Satır",
    "listings.smart_upload.explicit_ids_are_updates": "Açıkça belirtilen ilan kimliklerine sahip satırlar güncelleme olarak işlenir.",
    "Rows with an explicit listing ID are treated as updates.": "Açıkça belirtilen ilan kimliklerine sahip satırlar güncelleme olarak işlenir.",
    "listings.smart_upload.duplicate_action": "Yinelenen kayıt işlemi",
    "Duplicate action": "Yinelenen kayıt işlemi",
    "listings.smart_upload.skip_duplicates": "Olası yinelenenleri atla (önerilir)",
    "Skip potential duplicates (recommended)": "Olası yinelenenleri atla (önerilir)",
    "listings.smart_upload.import_all_anyway": "Yine de tümünü içe aktar",
    "Import all rows anyway": "Yine de tümünü içe aktar",
    "listings.smart_upload.untitled_listing": "Başlıksız ilan",
    "Untitled listing": "Başlıksız ilan",
    "listings.smart_upload.category_label": "Kategori:",
    "Category:": "Kategori:",
    "listings.smart_upload.complete": "Akıllı yükleme tamamlandı",
    "listings.smart_upload.imported_count": "{total} ilandan {imported} tanesi içe aktarıldı.",
    "{imported} of {total} listings imported.": "{total} ilandan {imported} tanesi içe aktarıldı.",
    "listings.smart_upload.selected_file": "Seçildi: {name}",
    "listings.smart_upload.checking": "Kontrol ediliyor…",
    "listings.smart_upload.check_duplicates": "Yinelenenleri kontrol et",
    "Check duplicates": "Yinelenenleri kontrol et",
    "listings.smart_upload.importing": "İçe aktarılıyor…",
    "listings.smart_upload.import_listings": "İlanları içe aktar",
    "listings.smart_upload.failed": "Akıllı yükleme başarısız oldu.",
    "Smart Upload failed.": "Akıllı yükleme başarısız oldu.",
    "listings.smart_upload.id_label": "Kimlik",
    "listings.status_toggle_hint": "Durum (Etkin değil / Etkin)",
    "listings.upload_media": "Medya yükle",
    "listing_form.stock_placeholder": "Stok miktarını girin",
    "orders.create_order.order_items_alt": "Sipariş kalemleri",
    "orders.create_order.by": "tarafından",
    "by": "tarafından",
    "orders.create_order.decrease_quantity": "Miktarı azalt",
    "Decrease quantity": "Miktarı azalt",
    "orders.create_order.increase_quantity": "Miktarı artır",
    "Increase quantity": "Miktarı artır",
    "orders.create_order.remove_item": "Öğeyi kaldır",
    "Remove item": "Öğeyi kaldır",
    "orders.create_order.rental_period_label": "Kiralama süresi:",
    "Rental period:": "Kiralama süresi:",
    "attributes.enter_text": "Metin girin",
    "attributes.select_date": "Tarih seç",
    "attributes.enter_number": "Sayı girin",
    "attributes.select_color": "Renk seç",
    "attributes.upload_json": "JSON yükle",
    "Upload JSON": "JSON yükle",
    "attributes.select_location": "Konum seç",
    "attributes.add_listing_preview": "İlan ekle",
    "attributes.add_account_preview": "Hesap ekle",
    "attributes.enter_price": "Fiyat girin",
    "attributes.preview": "Önizleme",
    "attributes.enter_title": "Başlık girin",
    "attributes.enter_description": "Açıklama girin",
    "attributes.category": "Kategori",
    "attributes.attribute_name": "Öznitelik adı",
    "attributes.enter_attribute_name": "Öznitelik adını girin",
    "attributes.select_type": "Tür seç",
    "attributes.icon": "Simge",
    "attributes.tooltip": "Araç ipucu",
    "Tooltip": "Araç ipucu",
    "attributes.enter_tooltip": "Öznitelik araç ipucunu girin",
    "Enter attribute tooltip": "Öznitelik araç ipucunu girin",
    "listings.detail.images": "Görseller",
    "listings.detail.posted_by": "Yayınlayan",
    "Posted by": "Yayınlayan",
    "listings.detail.fulfilled_by_platform": "Platform tarafından karşılanır",
    "listings.detail.preview": "Önizleme",
    "listings.detail.view_listing": "İlanı görüntüle",
    "View Listing": "İlanı görüntüle",
    "listings.detail.variants": "Varyantlar",
    "listings.detail.no_attribute_values": "{name} için öznitelik değeri yok",
    "listings.detail.attributes": "Öznitelikler",
    "listings.detail.starts_from": "Başlangıç fiyatı:",
    "Starts From:": "Başlangıç fiyatı:",
    "listings.detail.schedule": "Program",
    "listings.detail.detail": "Ayrıntı",
    "web_config.download": "İndir",
    "web_config.cancel": "İptal",
    "web_config.choose_file": "Dosya seç",
    "web_config.title": "Web yapılandırmaları",
    "Web Configs": "Web yapılandırmaları",
    "web_config.favicon": "Favicon",
    "Favicon": "Favicon",
    "web_config.logo": "Logo",
    "web_config.logo_width": "Logo genişliği",
    "Logo Width": "Logo genişliği",
    "web_config.width": "Genişlik",
    "web_config.logo_height": "Logo yüksekliği",
    "Logo Height": "Logo yüksekliği",
    "web_config.height": "Yükseklik",
    "web_config.social_share_image": "Sosyal paylaşım için web görseli - Open Graph",
    "Web Featured Image for Social Share - Open Graph": "Sosyal paylaşım için web görseli - Open Graph",
    "web_config.business_name": "İşletme adı",
    "web_config.enter_web_name": "Web adını girin",
    "Enter web name": "Web adını girin",
    "web_config.title_font": "Başlık yazı tipi",
    "Title Font": "Başlık yazı tipi",
    "web_config.select_title_font": "Başlık yazı tipini seç",
    "Select title font": "Başlık yazı tipini seç",
    "web_config.body_font": "Gövde yazı tipi",
    "Body Font": "Gövde yazı tipi",
    "web_config.select_body_font": "Gövde yazı tipini seç",
    "Select body font": "Gövde yazı tipini seç",
    "web_config.primary_font": "Birincil yazı tipi",
    "Primary Font": "Birincil yazı tipi",
    "web_config.select_primary_font": "Birincil yazı tipini seç",
    "Select primary font": "Birincil yazı tipini seç",
    "web_config.uploaded_successfully": "Başarıyla yüklendi",
    "web_config.ios_download_icon": "iOS uygulama indirme simgesi",
    "iOS app download icon": "iOS uygulama indirme simgesi",
    "web_config.ios_download_link": "iOS uygulama indirme bağlantısı",
    "iOS app download link": "iOS uygulama indirme bağlantısı",
    "web_config.enter_ios_download_link": "iOS uygulama indirme bağlantısını girin",
    "Enter iOS app download link": "iOS uygulama indirme bağlantısını girin",
    "web_config.android_download_icon": "Android uygulama indirme simgesi",
    "Android app download icon": "Android uygulama indirme simgesi",
    "web_config.android_download_link": "Android uygulama indirme bağlantısı",
    "Android app download link": "Android uygulama indirme bağlantısı",
    "web_config.enter_android_download_link": "Android uygulama indirme bağlantısını girin",
    "Enter android app download link": "Android uygulama indirme bağlantısını girin",
    "coupons.preview.customer_checkout": "MÜŞTERİ ÖDEME SAYFASI",
    "CUSTOMER CHECKOUT": "MÜŞTERİ ÖDEME SAYFASI",
    "coupons.preview.title": "Kuponlar iş başında",
    "Coupons in action": "Kuponlar iş başında",
    "coupons.preview.featured_product": "Öne çıkan ürününüz",
    "Your featured product": "Öne çıkan ürününüz",
    "coupons.preview.product_meta": "1 ürün · Standart teslimat",
    "1 item · Standard delivery": "1 ürün · Standart teslimat",
    "coupons.preview.coupon_applied": "Kupon uygulandı",
    "Coupon applied": "Kupon uygulandı",
    "coupons.preview.remove": "Kaldır",
    "coupons.preview.discount_applied": "Siparişe indirim uygulandı",
    "Discount applied to the order": "Siparişe indirim uygulandı",
    "coupons.preview.subtotal": "Ara toplam",
    "coupons.preview.coupon_label": "Kupon · WELCOME10",
    "Coupon · WELCOME10": "Kupon · WELCOME10",
    "coupons.preview.grand_total": "Genel toplam",
    "Grand total": "Genel toplam",
    "coupons.preview.checkout": "ÖDEME",
    "CHECKOUT": "ÖDEME",
    "payments.stripe_get_keys": "Stripe anahtarlarını al",
    "Get Stripe keys": "Stripe anahtarlarını al",
    "payments.stripe_syncing": "Stripe ile senkronize ediliyor...",
    "Syncing with Stripe...": "Stripe ile senkronize ediliyor...",
    "payments.stripe_verifying_key": "Gizli anahtar doğrulanıyor",
    "Verifying secret key": "Gizli anahtar doğrulanıyor",
    "payments.stripe_creating_webhook": "Ödeme web kancası oluşturuluyor",
    "Creating payment webhook": "Ödeme web kancası oluşturuluyor",
    "payments.stripe_account_summary": "{country} · {mode} modu · {id}",
    "{country} · {mode} mode · {id}": "{country} · {mode} modu · {id}",
    "payments.stripe_webhooks_configured": "✓ Webhook’ler yapılandırıldı — gizli anahtarlar aşağıya otomatik dolduruldu. Kaydetmek için formu gönderin.",
    "✓ Webhooks configured — secrets auto-filled below. Save the form to persist.": "✓ Webhook’ler yapılandırıldı — gizli anahtarlar aşağıya otomatik dolduruldu. Kaydetmek için formu gönderin.",
    "payments.stripe_webhooks_error": "⚠ Web kancası kurulumu başarısız oldu. Anahtar izinlerinizi kontrol edip yeniden senkronize edin.",
    "⚠ Webhook setup failed. Check your key permissions and try Sync again.": "⚠ Web kancası kurulumu başarısız oldu. Anahtar izinlerinizi kontrol edip yeniden senkronize edin.",
    "payments.stripe_invalid_key": "Gizli anahtar geçersiz. Kontrol edip tekrar deneyin.",
    "Invalid secret key. Check and try again.": "Gizli anahtar geçersiz. Kontrol edip tekrar deneyin.",
    "payments.stripe_setup_failed": "Kurulum başarısız oldu. Önce gizli anahtarınızı senkronize edin.",
    "Setup failed. Make sure your secret key is synced first.": "Kurulum başarısız oldu. Önce gizli anahtarınızı senkronize edin.",
    "payments.stripe_marketplace_connect": "Pazar yeri Connect",
    "Marketplace Connect": "Pazar yeri Connect",
    "payments.stripe_marketplace_hint": "Yalnızca pazar yeri ödemeleri için Stripe Connect kullanıyorsanız gereklidir",
    "Only needed if you use Stripe Connect for marketplace payouts": "Yalnızca pazar yeri ödemeleri için Stripe Connect kullanıyorsanız gereklidir",
    "payments.stripe_subscription_hint": "Yalnızca Tradly’de abonelik ürünleri satıyorsanız gereklidir",
    "Only needed if you sell subscription products on Tradly": "Yalnızca Tradly’de abonelik ürünleri satıyorsanız gereklidir",
    "integrations.sso.title": "Kurumsal tek oturum açma",
    "Enterprise single sign-on": "Kurumsal tek oturum açma",
    "integrations.sso.description": "Şirket kimlik sağlayıcınızı bağlayarak sağlanan kiracı personelinin ArcticWhale’e OIDC ile giriş yapmasını sağlayın. Okta, Microsoft Entra ID ve ID belirteçlerini RS256 ile imzalayan OIDC sağlayıcıları desteklenir.",
    "Connect your company identity provider so provisioned tenant staff can sign in to ArcticWhale with OIDC. Okta, Microsoft Entra ID, and OIDC providers that sign ID tokens with RS256 are supported.": "Şirket kimlik sağlayıcınızı bağlayarak sağlanan kiracı personelinin ArcticWhale’e OIDC ile giriş yapmasını sağlayın. Okta, Microsoft Entra ID ve ID belirteçlerini RS256 ile imzalayan OIDC sağlayıcıları desteklenir.",
    "integrations.sso.issuer_url": "Yayıncı URL’si",
    "Issuer URL": "Yayıncı URL’si",
    "integrations.sso.issuer_placeholder": "https://your-company.okta.com/oauth2/default",
    "https://your-company.okta.com/oauth2/default": "https://your-company.okta.com/oauth2/default",
    "integrations.sso.client_id": "İstemci Kimliği",
    "integrations.sso.client_secret": "İstemci gizli anahtarı",
    "integrations.sso.secret_replace_placeholder": "Güvenli şekilde kaydedildi. Değiştirmek için bir değer girin.",
    "Saved securely. Enter a value to replace it.": "Güvenli şekilde kaydedildi. Değiştirmek için bir değer girin.",
    "integrations.sso.secret_placeholder": "İstemci gizli anahtarını girin",
    "Enter the client secret": "İstemci gizli anahtarını girin",
    "integrations.sso.email_domains": "Şirket e-posta alan adları",
    "Company email domains": "Şirket e-posta alan adları",
    "integrations.sso.email_domains_placeholder": "example.com, example.eu",
    "example.com, example.eu": "example.com, example.eu",
    "integrations.sso.domain_help": "Personelin zaten bir ArcticWhale hesabı ve bu kiracıya erişimi olmalıdır. Kuruluşunuza ait alan adlarını kullanın.",
    "Staff must already have an ArcticWhale account and access to this tenant. Use domains owned by your organization.": "Personelin zaten bir ArcticWhale hesabı ve bu kiracıya erişimi olmalıdır. Kuruluşunuza ait alan adlarını kullanın.",
    "integrations.sso.callback_url": "OIDC geri çağırma URL’si",
    "OIDC callback URL": "OIDC geri çağırma URL’si",
    "integrations.sso.loading_callback_url": "Geri çağırma URL’si yükleniyor…",
    "Loading callback URL…": "Geri çağırma URL’si yükleniyor…",
    "integrations.sso.callback_help": "Bu URL’yi kimlik sağlayıcı uygulamasına Web yönlendirme URI’si olarak aynen ekleyin.",
    "Add this exact URL to the identity provider application as a Web redirect URI.": "Bu URL’yi kimlik sağlayıcı uygulamasına Web yönlendirme URI’si olarak aynen ekleyin.",
    "integrations.sso.enable": "Şirket SSO girişini etkinleştir",
    "Enable company SSO sign-in": "Şirket SSO girişini etkinleştir",
    "integrations.sso.checking": "Kontrol ediliyor…",
    "integrations.sso.test_issuer": "Yayıncıyı test et",
    "Test issuer": "Yayıncıyı test et",
    "integrations.sso.saving": "Kaydediliyor…",
    "integrations.sso.save": "SSO ayarlarını kaydet",
    "Save SSO settings": "SSO ayarlarını kaydet",
    "integrations.sso.security_help": "İstemci gizli anahtarı kaydedilmeden önce şifrelenir. SSO kuruluş girişi seçeneği ekler; bu kurulumda parola ile giriş değişmez.",
    "The client secret is encrypted before it is stored. SSO adds an organization sign-in option; password sign-in is unchanged in this setup.": "İstemci gizli anahtarı kaydedilmeden önce şifrelenir. SSO kuruluş girişi seçeneği ekler; bu kurulumda parola ile giriş değişmez.",
    "integrations.sso.load_error": "Kurumsal SSO ayarları yüklenemedi.",
    "Unable to load enterprise SSO settings.": "Kurumsal SSO ayarları yüklenemedi.",
    "integrations.sso.save_error": "Kurumsal SSO ayarları kaydedilemedi.",
    "Unable to save enterprise SSO settings.": "Kurumsal SSO ayarları kaydedilemedi.",
    "integrations.sso.saved": "Kurumsal SSO ayarları kaydedildi.",
    "Enterprise SSO settings saved.": "Kurumsal SSO ayarları kaydedildi.",
    "integrations.sso.connection_ok": "Kimlik sağlayıcı keşif uç noktasına erişilebiliyor.",
    "Identity provider discovery is reachable.": "Kimlik sağlayıcı keşif uç noktasına erişilebiliyor.",
    "integrations.sso.connection_error": "Kimlik sağlayıcıya bağlanılamadı.",
    "Unable to connect to the identity provider.": "Kimlik sağlayıcıya bağlanılamadı.",
    "listing_configs.maximum_quantity_per_listing": "İlan başına en fazla miktar",
    "listing_configs.example_quantity": "(Örnek: 100)",
    "listing_configs.enter_maximum_quantity": "İlan başına maksimum miktarı girin",
    "Enter maximum quantity per listing": "İlan başına maksimum miktarı girin",
    "listing_configs.minimum_listing_price": "En düşük ilan fiyatı",
    "listing_configs.example_price": "(Örnek: $5)",
    "listing_configs.enter_minimum_price": "En düşük ilan fiyatını girin",
    "Enter minimum listing price": "En düşük ilan fiyatını girin",
    "listing_configs.picture_count": "Yüklenebilecek görsel sayısı",
    "listing_configs.enter_picture_count": "Görsel sayısını girin",
    "Enter Pictures count": "Görsel sayısını girin",
    "listing_configs.feature_activation": "ÖZELLİK ETKİNLEŞTİRME",
    "FEATURE ACTIVATION": "ÖZELLİK ETKİNLEŞTİRME",
    "listing_configs.example_landmark": "(Örnek: Yer işareti)",
    "listing_configs.enter_address_label": "Adres etiketini girin",
    "Enter address Label": "Adres etiketini girin",
    "listing_configs.legacy_switch_0": "İlanlar otomatik onaylansın mı?",
    "listing_configs.legacy_switch_1": "Teklif yüzdesi",
    "listing_configs.legacy_switch_2": "İlan düzeyinde maksimum miktar kısıtlamaları",
    "listing_configs.legacy_switch_3": "Kargo ücretleri",
    "listing_configs.legacy_switch_4": "Adres aramak yerine harita işaretçisini kullan",
    "Use map marker instead \nof searching address": "Adres aramak yerine harita işaretçisini kullan",
    "listing_configs.legacy_switch_5": "Etiketler",
    "listing_configs.legacy_switch_6": "Stoklar",
    "listing_configs.legacy_switch_7": "Coğrafi adres",
    "listing_configs.legacy_switch_8": "Stokta olmayan ilanları akışta göster",
    "listing_configs.legacy_switch_9": "İlan başlık kısa adı",
    "listing_configs.legacy_switch_10": "Varyantlar",
    "listing_configs.legacy_switch_11": "Meta başlığı",
    "listing_configs.legacy_switch_12": "Meta açıklaması",
    "listing_configs.legacy_switch_13": "Dijital ürün",
    "Digital Product": "Dijital ürün",
    "listing_configs.legacy_switch_14": "Composer’ı etkinleştir",
    "listing_configs.legacy_switch_15": "Ağırlığı etkinleştir",
    "listing_configs.legacy_switch_16": "Boyutları etkinleştir",
    "navigation.app_download.close": "Kapat",
    "navigation.app_download.eyebrow": "Mobil yardımcı uygulama",
    "Mobile companion": "Mobil yardımcı uygulama",
    "navigation.app_download.title": "Projenizi hareket halindeyken de yönetin.",
    "Keep your project moving.": "Projenizi hareket halindeyken de yönetin.",
    "navigation.app_download.description": "Telefonunuzdan temel işleri yönetin: yeni ilanları onaylayın, siparişleri kontrol edin ve işletmenizi takip edin.",
    "Handle the essentials from your phone—from approving new listings to checking orders and keeping your business on track.": "Telefonunuzdan temel işleri yönetin: yeni ilanları onaylayın, siparişleri kontrol edin ve işletmenizi takip edin.",
    "navigation.app_download.approve_listings": "İlanları onayla",
    "Approve listings": "İlanları onayla",
    "navigation.app_download.manage_orders": "Siparişleri yönet",
    "Manage orders": "Siparişleri yönet",
    "navigation.app_download.check_performance": "Performansı kontrol et",
    "Check performance": "Performansı kontrol et",
    "navigation.app_download.download_title": "SuperAdmin uygulamasını indir",
    "Download the SuperAdmin app": "SuperAdmin uygulamasını indir",
    "navigation.app_download.download_on": "Şuradan indirin:",
    "Download on the": "Şuradan indirin:",
    "navigation.app_download.app_store": "App Store",
    "navigation.app_download.get_it_on": "Şuradan edinin:",
    "Get it on": "Şuradan edinin:",
    "listing_configs.address_label": "Adres etiketi",
    "collections.add_another_condition": "＋ Başka koşul ekle",
    "collections.search": "Ara",
    "collections.status_inactive_active": "Durum (Etkin değil / Etkin)",
    "media_picker.add_photo": "Fotoğraf ekle",
    "payments.payment_intent_webhook_secret": "Ödeme amacı web kancası gizli anahtarı",
    "Payment Intent Webhook secret": "Ödeme amacı web kancası gizli anahtarı",
    "payments.subscription_webhook_secret": "Abonelik web kancası gizli anahtarı",
    "Subscription Webhook secret": "Abonelik web kancası gizli anahtarı",
    "payments.webhook_secret_autofilled": "Web kancası gizli anahtarı yukarıya otomatik dolduruldu — kaydetmek için formu gönderin.",
    "Webhook secret auto-filled above — save the form to persist.": "Web kancası gizli anahtarı yukarıya otomatik dolduruldu — kaydetmek için formu gönderin.",
    "app_customization.white_png_icon_help": "Simge beyaz ve PNG biçiminde olmalıdır",
    "icon should be white and in png format": "Simge beyaz ve PNG biçiminde olmalıdır",
    "app_customization.other_appearance": "Diğer görünüm ayarları",
    "Other appearance": "Diğer görünüm ayarları",
    "app_customization.notification_icon": "Bildirim simgesi",
    "Notification icon": "Bildirim simgesi",
    "app_customization.app_title_home": "Ana ekrandaki uygulama başlığı",
    "app_customization.enable_app_title_icon": "Metin yerine uygulama başlığı simgesini etkinleştir",
    "listings.quick_add.title": "Hızlı ilan ekle",
    "Quick Add Listing": "Hızlı ilan ekle",
    "listings.quick_add.success": "İlan başarıyla eklendi",
    "Listing Added Successfully": "İlan başarıyla eklendi",
    "listings.quick_add.image": "Görsel",
    "listings.quick_add.listing_name": "İlan adı",
    "Listing Name": "İlan adı",
    "listings.quick_add.title_placeholder": "ör. Premium Kablosuz Kulaklık",
    "e.g., Premium Wireless Headphones": "ör. Premium Kablosuz Kulaklık",
    "listings.quick_add.category": "Kategori",
    "listings.quick_add.select_category": "Kategori seç",
    "listings.quick_add.price": "Fiyat",
    "listings.quick_add.stock": "Stok",
    "listings.quick_add.description": "Açıklama",
    "listings.quick_add.description_placeholder": "Ürününüzün kısa açıklaması...",
    "Brief Description of your product...": "Ürününüzün kısa açıklaması...",
    "listings.quick_add.more_options": "Daha fazla seçeneğe mi ihtiyacınız var? Tam",
    "Need more options? Use the full": "Daha fazla seçeneğe mi ihtiyacınız var? Tam",
    "listings.quick_add.guided_form": "formu kullanın",
    "guided form": "formu kullanın",
    "listings.quick_add.instead": "yerine",
    "instead": "yerine",
    "listings.digital_product.title": "Dijital ürün ekle",
    "Add Digital Product": "Dijital ürün ekle",
    "listings.digital_product.select_file": "Dosya seç",
    "Select file": "Dosya seç",
    "listings.digital_product.name": "Başlık",
    "listings.digital_product.version": "Sürüm",
    "listings.digital_product.description": "Açıklama",
    "web_config.social_info": "Sosyal medya bilgileri",
    "Social Info": "Sosyal medya bilgileri",
    "web_config.social_facebook_pageurl": "Facebook sayfası URL’si",
    "Facebook page URL": "Facebook sayfası URL’si",
    "web_config.enter_social_facebook_pageurl": "Facebook sayfası URL’sini girin",
    "Enter Facebook page URL": "Facebook sayfası URL’sini girin",
    "web_config.social_twitter_handleurl": "Twitter kullanıcı URL’si",
    "Twitter handle URL": "Twitter kullanıcı URL’si",
    "web_config.enter_social_twitter_handleurl": "Twitter kullanıcı URL’sini girin",
    "Enter Twitter handle URL": "Twitter kullanıcı URL’sini girin",
    "web_config.social_instagram_url": "Instagram URL’si",
    "Instagram URL": "Instagram URL’si",
    "web_config.enter_social_instagram_url": "Instagram URL’sini girin",
    "Enter Instagram URL": "Instagram URL’sini girin",
    "web_config.social_youtube_channelurl": "YouTube kanal URL’si",
    "Youtube channel URL": "YouTube kanal URL’si",
    "web_config.enter_social_youtube_channelurl": "YouTube kanal URL’sini girin",
    "Enter Youtube channel URL": "YouTube kanal URL’sini girin",
    "web_config.social_tiktok_url": "TikTok URL’si",
    "Tiktok URL": "TikTok URL’si",
    "web_config.enter_social_tiktok_url": "TikTok URL’sini girin",
    "Enter Tiktok URL": "TikTok URL’sini girin",
    "web_config.social_spotify_url": "Spotify URL’si",
    "Spotify URL": "Spotify URL’si",
    "web_config.enter_social_spotify_url": "Spotify URL’sini girin",
    "Enter Spotify URL": "Spotify URL’sini girin",
    "web_config.social_whatsapp_number": "WhatsApp numarası",
    "Whatsapp number": "WhatsApp numarası",
    "web_config.enter_social_whatsapp_number": "WhatsApp numarasını girin",
    "Enter Whatsapp number": "WhatsApp numarasını girin",
    "web_config.social_telegram_url": "Telegram URL’si",
    "Telegram URL": "Telegram URL’si",
    "web_config.enter_social_telegram_url": "Telegram URL’sini girin",
    "Enter Telegram URL": "Telegram URL’sini girin",
    "web_config.social_snapchat": "Snapchat",
    "Snapchat": "Snapchat",
    "web_config.enter_social_snapchat": "Snapchat bilgisini girin",
    "Enter Snapchat": "Snapchat bilgisini girin",
    "payments.paydunya.title": "PayDunya entegrasyonu",
    "PayDunya Integration": "PayDunya entegrasyonu",
    "payments.paydunya.master_key": "Ana anahtar",
    "Master key": "Ana anahtar",
    "payments.paydunya.enter_master_key": "Ana anahtarı girin",
    "Enter master key": "Ana anahtarı girin",
    "payments.paydunya.public_key": "Genel anahtar",
    "Public key": "Genel anahtar",
    "payments.paydunya.enter_public_key": "Genel anahtarı girin",
    "payments.paydunya.private_key": "Özel anahtar",
    "Private key": "Özel anahtar",
    "payments.paydunya.enter_private_key": "Özel anahtarı girin",
    "Enter private key": "Özel anahtarı girin",
    "payments.paydunya.token": "Belirteç",
    "payments.paydunya.enter_token": "Belirteci girin",
    "payments.paydunya.uploaded_successfully": "Başarıyla yüklendi",
    "communications.email_stats_open": "{sent} gönderildi · açılma %{openRate}",
    "{sent} sent · {openRate}% open": "{sent} gönderildi · açılma %{openRate}",
    "communications.email_stats_full": "{sent} gönderildi · açılma %{openRate} · tıklama {clicks}",
    "{sent} sent · {openRate}% open · {clicks} clicks": "{sent} gönderildi · açılma %{openRate} · tıklama {clicks}",
    "navigation.mini_apps.title": "Mini uygulamalar",
    "Mini Apps": "Mini uygulamalar",
    "navigation.mini_apps.subtitle": "Tradly tarafından geliştirilen yardımcı araçlar — ayrıntı ve fiyatlandırma için bir karta dokunun",
    "Tradly-built companion tools — tap a card to see details and pricing": "Tradly tarafından geliştirilen yardımcı araçlar — ayrıntı ve fiyatlandırma için bir karta dokunun",
    "navigation.mini_apps.soon": "Yakında",
    "Soon": "Yakında",
    "navigation.mini_apps.included_in_paid_plan": "Ücretli plana dahil",
    "Included in a paid plan": "Ücretli plana dahil",
    "navigation.mini_apps.know_more": "Daha fazla bilgi",
    "Know more": "Daha fazla bilgi",
    "navigation.mini_apps.hide_details": "Ayrıntıları gizle",
    "Hide details": "Ayrıntıları gizle",
    "navigation.mini_apps.view_plans": "Planları görüntüle",
    "navigation.mini_apps.remove": "Kaldır",
    "navigation.mini_apps.add_to_sidebar": "Kenar çubuğuna ekle",
    "Add to sidebar": "Kenar çubuğuna ekle",
    "navigation.mini_apps.why_heading": "İşletmenizin buna neden ihtiyacı var",
    "Why your business needs it": "İşletmenizin buna neden ihtiyacı var",
    "navigation.mini_apps.coming_soon": "Çok yakında",
    "navigation.mini_apps.workflow.title": "Pazarlama",
    "navigation.mini_apps.workflow.description": "Kitlenizi büyütmek için e-posta kampanyaları, anlık bildirimler ve promosyonlar yürütün.",
    "Run email campaigns, push notifications, and promotions to grow your audience.": "Kitlenizi büyütmek için e-posta kampanyaları, anlık bildirimler ve promosyonlar yürütün.",
    "navigation.mini_apps.workflow.why_1": "Etkinliklerine göre alıcı ve satıcılara hedefli e-posta kampanyaları gönderin",
    "Send targeted email campaigns to buyers and sellers based on activity": "Etkinliklerine göre alıcı ve satıcılara hedefli e-posta kampanyaları gönderin",
    "navigation.mini_apps.workflow.why_2": "7 günden uzun süredir ziyaret etmeyen kullanıcıları anlık bildirimlerle yeniden etkileşime geçirin",
    "Push notifications to re-engage users who haven't visited in 7+ days": "7 günden uzun süredir ziyaret etmeyen kullanıcıları anlık bildirimlerle yeniden etkileşime geçirin",
    "navigation.mini_apps.workflow.why_3": "Mevsimsel etkinliklerinize göre zamanlanmış kupon kampanyaları düzenleyin",
    "Run promotions with coupon drops timed to your seasonal events": "Mevsimsel etkinliklerinize göre zamanlanmış kupon kampanyaları düzenleyin",
    "navigation.mini_apps.workflow.pricing_label": "Kredi tabanlı",
    "Credits-based": "Kredi tabanlı",
    "navigation.mini_apps.workflow.pricing_detail": "Gönderim başına ödeme — 1.000 e-posta 100 kredi tutar. Kredilerin süresi dolmaz.",
    "Pay per send — 1,000 emails costs 100 credits. Credits never expire.": "Gönderim başına ödeme — 1.000 e-posta 100 kredi tutar. Kredilerin süresi dolmaz.",
    "navigation.mini_apps.intelligence_section.title": "Analiz",
    "navigation.mini_apps.intelligence_section.description": "Analizler, dönüşüm hunileri ve yapay zeka destekli içgörülerle büyümenizi anlayın.",
    "Understand your growth with analytics, funnels, and AI-powered insights.": "Analizler, dönüşüm hunileri ve yapay zeka destekli içgörülerle büyümenizi anlayın.",
    "navigation.mini_apps.intelligence_section.why_1": "En yüksek GMV’yi hangi ilanların, hesapların ve kategorilerin sağladığını görün",
    "See which listings, accounts, and categories drive the most GMV": "En yüksek GMV’yi hangi ilanların, hesapların ve kategorilerin sağladığını görün",
    "navigation.mini_apps.intelligence_section.why_2": "Düşüş hunileri, alıcıların ödeme öncesinde tam olarak nerede ayrıldığını gösterir",
    "Drop-off funnels show exactly where buyers leave before checkout": "Düşüş hunileri, alıcıların ödeme öncesinde tam olarak nerede ayrıldığını gösterir",
    "navigation.mini_apps.intelligence_section.why_3": "Yapay zeka, ham verilerde gözden kaçabilecek anormallikleri ve fırsatları ortaya çıkarır",
    "AI surfaces anomalies and opportunities you'd miss in raw data": "Yapay zeka, ham verilerde gözden kaçabilecek anormallikleri ve fırsatları ortaya çıkarır",
    "navigation.mini_apps.intelligence_section.pricing_label": "Kredi tabanlı",
    "navigation.mini_apps.intelligence_section.pricing_detail": "Yapay zeka analizleri ve oluşturulan raporlar kredi tüketir. Veri görünümleri her zaman ücretsizdir.",
    "AI analysis and generated reports consume credits. Data views are always free.": "Yapay zeka analizleri ve oluşturulan raporlar kredi tüketir. Veri görünümleri her zaman ücretsizdir.",
    "navigation.mini_apps.subscription_section.title": "Abonelik",
    "navigation.mini_apps.subscription_section.description": "Kiracılarınız için planları, faturalandırma döngülerini ve özellik haklarını yönetin.",
    "Manage plans, billing cycles, and feature entitlements for your tenants.": "Kiracılarınız için planları, faturalandırma döngülerini ve özellik haklarını yönetin.",
    "navigation.mini_apps.subscription_section.why_1": "Özellik bazlı kısıtlamalar içeren kademeli planlar (Free / Pro / Enterprise) oluşturun",
    "Create tiered plans (Free / Pro / Enterprise) with per-feature gates": "Özellik bazlı kısıtlamalar içeren kademeli planlar (Free / Pro / Enterprise) oluşturun",
    "navigation.mini_apps.subscription_section.why_2": "Aylık, yıllık veya özel süreli faturalandırma döngülerini otomatikleştirin",
    "Automate billing cycles — monthly, annual, or custom durations": "Aylık, yıllık veya özel süreli faturalandırma döngülerini otomatikleştirin",
    "navigation.mini_apps.subscription_section.why_3": "Özellik hakları kiracılarınız genelinde özellikleri açar veya kısıtlar",
    "Entitlements unlock or restrict features across your tenant base": "Özellik hakları kiracılarınız genelinde özellikleri açar veya kısıtlar",
    "navigation.mini_apps.subscription_section.pricing_label": "Bağlantı",
    "navigation.mini_apps.subscription_section.pricing_detail": "Görev tabanlı ücretlendirme — abonelik olayı başına ücret alınır (yükseltme, yenileme, iptal).",
    "Task-based pricing — charged per subscription event (upgrade, renewal, cancellation).": "Görev tabanlı ücretlendirme — abonelik olayı başına ücret alınır (yükseltme, yenileme, iptal).",
    "navigation.mini_apps.membership_section.title": "Üyelik",
    "navigation.mini_apps.membership_section.description": "Üyelik programlarını, kayıtlı üyeleri, katkıları ve ödemeleri yönetin.",
    "Manage membership programs, enrolled members, contributions, and payment dues.": "Üyelik programlarını, kayıtlı üyeleri, katkıları ve ödemeleri yönetin.",
    "navigation.mini_apps.membership_section.why_1": "Üyelik programlarını ve kayıtlı üyeleri yönetin",
    "Manage membership programs and enrolled members": "Üyelik programlarını ve kayıtlı üyeleri yönetin",
    "navigation.mini_apps.membership_section.why_2": "Katkıları, ödenmesi gereken tutarları ve üyelik durumunu takip edin",
    "Track contributions, payment dues, and membership status": "Katkıları, ödenmesi gereken tutarları ve üyelik durumunu takip edin",
    "navigation.mini_apps.membership_section.why_3": "Üyelik katkılarını ilgili siparişlerle ilişkilendirin",
    "Connect membership contributions back to their orders": "Üyelik katkılarını ilgili siparişlerle ilişkilendirin",
    "navigation.mini_apps.membership_section.pricing_label": "Fiyat daha sonra belirlenecek",
    "Pricing TBC": "Fiyat daha sonra belirlenecek",
    "navigation.mini_apps.membership_section.pricing_detail": "Üyelik programlarını ve katkı geçmişini tek yerden yönetin.",
    "Manage membership programs and contribution history in one place.": "Üyelik programlarını ve katkı geçmişini tek yerden yönetin.",
    "navigation.mini_apps.reward_programs.title": "Ödüller",
    "navigation.mini_apps.reward_programs.description": "Kapsamlar, kurallar ve yeniden kullanılabilir ödül tarifleriyle ödül programları oluşturun.",
    "Create reward programs with scopes, rules, and reusable reward recipes.": "Kapsamlar, kurallar ve yeniden kullanılabilir ödül tarifleriyle ödül programları oluşturun.",
    "navigation.mini_apps.reward_programs.why_1": "Satış ortağı, yönlendirme, bölgesel veya mağaza ödül programları tanımlayın",
    "Define affiliate, referral, regional, or store reward programs": "Satış ortağı, yönlendirme, bölgesel veya mağaza ödül programları tanımlayın",
    "navigation.mini_apps.reward_programs.why_2": "Yeniden kullanılabilir komisyon ve ödül bileşenleriyle kurallar oluşturun",
    "Build rules from reusable commission and reward components": "Yeniden kullanılabilir komisyon ve ödül bileşenleriyle kurallar oluşturun",
    "navigation.mini_apps.reward_programs.why_3": "Ödül hesaplaması ve defter aktarımı ERP arka ucu tarafından yönetilir",
    "Keep reward calculation and ledger delivery managed by the ERP backend": "Ödül hesaplaması ve defter aktarımı ERP arka ucu tarafından yönetilir",
    "navigation.mini_apps.reward_programs.pricing_label": "Fiyat daha sonra belirlenecek",
    "navigation.mini_apps.reward_programs.pricing_detail": "Ödül programlarını yapılandırın ve ilişkilendirmeye bağlayın.",
    "Configure reward programs and connect them to attribution.": "Ödül programlarını yapılandırın ve ilişkilendirmeye bağlayın.",
    "navigation.mini_apps.bundles_app.title": "Paketler",
    "navigation.mini_apps.bundles_app.description": "Mevcut ilanlardan sabit ve karışık ürün paketleri oluşturun.",
    "Create fixed and mix-and-match bundles from existing listings.": "Mevcut ilanlardan sabit ve karışık ürün paketleri oluşturun.",
    "navigation.mini_apps.bundles_app.why_1": "Ürün verilerini çoğaltmadan mevcut ilanları birleştirin",
    "Combine existing listings without duplicating product data": "Ürün verilerini çoğaltmadan mevcut ilanları birleştirin",
    "navigation.mini_apps.bundles_app.why_2": "Sabit paketleri ve müşterilerin seçtiği karışık paketleri destekleyin",
    "Support fixed bundles and customer-selected mix-and-match bundles": "Sabit paketleri ve müşterilerin seçtiği karışık paketleri destekleyin",
    "navigation.mini_apps.bundles_app.why_3": "Ödeme ve teslimattan önce bileşen stoklarını doğrulayın",
    "Validate component stock before checkout and fulfilment": "Ödeme ve teslimattan önce bileşen stoklarını doğrulayın",
    "navigation.mini_apps.bundles_app.pricing_label": "Ücretli plan özelliği",
    "Paid package feature": "Ücretli plan özelliği",
    "navigation.mini_apps.bundles_app.pricing_detail": "Paket işlemlerini içeren planlarda kullanılabilir.",
    "Available on plans that include bundle operations.": "Paket işlemlerini içeren planlarda kullanılabilir.",
    "navigation.mini_apps.inventory_section.title": "Tedarik zinciri",
    "navigation.mini_apps.inventory_section.description": "Stok, satın alma siparişleri, depolar, tedarikçiler ve operasyonlar.",
    "Inventory, purchase orders, stock locations, suppliers, and operations.": "Stok, satın alma siparişleri, depolar, tedarikçiler ve operasyonlar.",
    "navigation.mini_apps.inventory_section.why_1": "Birden fazla depo ve mağaza konumundaki stok seviyelerini izleyin",
    "Track stock levels across multiple warehouses and store locations": "Birden fazla depo ve mağaza konumundaki stok seviyelerini izleyin",
    "navigation.mini_apps.inventory_section.why_2": "Tedarikçilere satın alma siparişi verin ve ürünleri teslim alın",
    "Raise purchase orders with suppliers and receive stock against them": "Tedarikçilere satın alma siparişi verin ve ürünleri teslim alın",
    "navigation.mini_apps.inventory_section.why_3": "Stok işlemlerini kaydedin: düzeltmeler, transferler ve stoktan düşmeler",
    "Record inventory operations — adjustments, transfers, and write-offs": "Stok işlemlerini kaydedin: düzeltmeler, transferler ve stoktan düşmeler",
    "navigation.mini_apps.inventory_section.pricing_label": "Dahil",
    "Included": "Dahil",
    "navigation.mini_apps.inventory_section.pricing_detail": "Tedarik Zinciri planınıza dahildir. Ek ücret alınmaz.",
    "Supply Chain is included in your plan. No additional charge.": "Tedarik Zinciri planınıza dahildir. Ek ücret alınmaz.",
    "navigation.mini_apps.people_app.title": "Çalışanlar",
    "navigation.mini_apps.people_app.description": "Personel dizini, departmanlar, iş profilleri ve ücret kademeleri.",
    "Staff directory, departments, job profiles, and pay grades.": "Personel dizini, departmanlar, iş profilleri ve ücret kademeleri.",
    "navigation.mini_apps.people_app.why_1": "Tüm personel profillerini, kodlarını ve çalışma türlerini tek dizinde tutun",
    "Keep every staff profile, code, and employment type in one directory": "Tüm personel profillerini, kodlarını ve çalışma türlerini tek dizinde tutun",
    "navigation.mini_apps.people_app.why_2": "Ekipleri standart iş profilleriyle departmanlara ayırın",
    "Organise teams into departments with standard job profiles": "Ekipleri standart iş profilleriyle departmanlara ayırın",
    "navigation.mini_apps.people_app.why_3": "Ücret kademelerini bir kez tanımlayın ve personele atayın",
    "Define pay grades once and assign them to staff": "Ücret kademelerini bir kez tanımlayın ve personele atayın",
    "navigation.mini_apps.people_app.pricing_label": "Fiyat daha sonra belirlenecek",
    "navigation.mini_apps.people_app.pricing_detail": "Workforce ve Payroll için gereklidir.",
    "Required by Workforce and Payroll.": "Workforce ve Payroll için gereklidir.",
    "navigation.mini_apps.workforce_app.title": "İşgücü",
    "navigation.mini_apps.workforce_app.description": "Ekibiniz için vardiya, devam takibi ve izin yönetimi.",
    "Shifts, attendance, and leave management for your team.": "Ekibiniz için vardiya, devam takibi ve izin yönetimi.",
    "navigation.mini_apps.workforce_app.why_1": "Personeli tarihe, saate ve konuma göre vardiyalara atayın",
    "Roster staff into shifts by date, time, and location": "Personeli tarihe, saate ve konuma göre vardiyalara atayın",
    "navigation.mini_apps.workforce_app.why_2": "Eksiksiz devam geçmişiyle işe giriş ve çıkış saatlerini kaydedin",
    "Clock in and out with a full attendance history": "Eksiksiz devam geçmişiyle işe giriş ve çıkış saatlerini kaydedin",
    "navigation.mini_apps.workforce_app.why_3": "İzin politikaları, bakiyeler ve onaylama/reddetme iş akışı",
    "Leave policies, balances, and an approve/reject workflow": "İzin politikaları, bakiyeler ve onaylama/reddetme iş akışı",
    "navigation.mini_apps.workforce_app.pricing_label": "Fiyat daha sonra belirlenecek",
    "navigation.mini_apps.workforce_app.pricing_detail": "People uygulamasını otomatik olarak etkinleştirir.",
    "Turns on People automatically.": "People uygulamasını otomatik olarak etkinleştirir.",
    "navigation.mini_apps.payroll_app.title": "Bordro",
    "navigation.mini_apps.payroll_app.description": "Bordro çalıştırma, onaylar, CSV dışa aktarma ve masraf iadeleri.",
    "Payroll runs, approvals, CSV export, and expense reimbursements.": "Bordro çalıştırma, onaylar, CSV dışa aktarma ve masraf iadeleri.",
    "navigation.mini_apps.payroll_app.why_1": "Personel ücret kademelerine göre dönemsel bordro oluşturun",
    "Create payroll runs per period from staff pay grades": "Personel ücret kademelerine göre dönemsel bordro oluşturun",
    "navigation.mini_apps.payroll_app.why_2": "Bordroları onaylayın ve bankanız veya muhasebeciniz için CSV olarak dışa aktarın",
    "Approve runs and export them as CSV for your bank or accountant": "Bordroları onaylayın ve bankanız veya muhasebeciniz için CSV olarak dışa aktarın",
    "navigation.mini_apps.payroll_app.why_3": "Personel masraf taleplerini gönderimden geri ödemeye kadar yönetin",
    "Staff expense claims from submission to reimbursement": "Personel masraf taleplerini gönderimden geri ödemeye kadar yönetin",
    "navigation.mini_apps.payroll_app.pricing_label": "Fiyat daha sonra belirlenecek",
    "navigation.mini_apps.payroll_app.pricing_detail": "People uygulamasını otomatik olarak etkinleştirir.",
    "navigation.mini_apps.unified_inbox.title": "Birleşik gelen kutusu",
    "Unified Inbox": "Birleşik gelen kutusu",
    "navigation.mini_apps.unified_inbox.description": "Tüm müşteri iletişimi — siparişler, destek ve sohbet — tek yerde.",
    "All your customer communication — orders, support, and chat — from one place.": "Tüm müşteri iletişimi — siparişler, destek ve sohbet — tek yerde.",
    "navigation.mini_apps.unified_inbox.why_1": "Sipariş soruları, destek talepleri ve alıcı mesajları tek bir ileti dizisinde",
    "Order queries, support tickets, and buyer messages in one thread view": "Sipariş soruları, destek talepleri ve alıcı mesajları tek bir ileti dizisinde",
    "navigation.mini_apps.unified_inbox.why_2": "Kataloğunuzla eğitilmiş yapay zeka yanıt önerileriyle cevap verin",
    "Reply with AI-suggested responses trained on your catalogue": "Kataloğunuzla eğitilmiş yapay zeka yanıt önerileriyle cevap verin",
    "navigation.mini_apps.unified_inbox.why_3": "Ekibinizle görüşmeleri etiketleyin, atayın ve sonuçlandırın",
    "Tag, assign, and resolve conversations across your team": "Ekibinizle görüşmeleri etiketleyin, atayın ve sonuçlandırın",
    "navigation.mini_apps.unified_inbox.pricing_label": "Bağlantı",
    "navigation.mini_apps.unified_inbox.pricing_detail": "Çözülen görüşme başına görev tabanlı ücretlendirme.",
    "Task-based pricing per resolved conversation.": "Çözülen görüşme başına görev tabanlı ücretlendirme.",
    "navigation.mini_apps.social_connect.title": "Sosyal bağlantı",
    "Social Connect": "Sosyal bağlantı",
    "navigation.mini_apps.social_connect.description": "İlanları belirlediğiniz programa göre sosyal kanallarda paylaşın.",
    "Share listings to social channels on a schedule you define.": "İlanları belirlediğiniz programa göre sosyal kanallarda paylaşın.",
    "navigation.mini_apps.social_connect.why_1": "İlan gönderilerini Instagram, Facebook ve X’te otomatik olarak planlayın",
    "Schedule listing posts to Instagram, Facebook, and X automatically": "İlan gönderilerini Instagram, Facebook ve X’te otomatik olarak planlayın",
    "navigation.mini_apps.social_connect.why_2": "Her kanal için günlük paylaşımlar, hızlı indirimler veya özel sıklıkta gönderi programı belirleyin",
    "Define posting schedules per channel — daily drops, flash sales, or custom cadence": "Her kanal için günlük paylaşımlar, hızlı indirimler veya özel sıklıkta gönderi programı belirleyin",
    "navigation.mini_apps.social_connect.why_3": "Kontrol panelinden her ilanın tıklama ve etkileşimlerini takip edin",
    "Track clicks and engagement back to each listing from the dashboard": "Kontrol panelinden her ilanın tıklama ve etkileşimlerini takip edin",
    "navigation.mini_apps.social_connect.pricing_label": "Bağlantı",
    "navigation.mini_apps.social_connect.pricing_detail": "Yayınlanan planlı gönderi başına görev tabanlı ücretlendirme.",
    "Task-based pricing per scheduled post delivered.": "Yayınlanan planlı gönderi başına görev tabanlı ücretlendirme.",
    "navigation.mini_apps.shopping_channels.title": "Alışveriş kanalları",
    "Shopping Channels": "Alışveriş kanalları",
    "navigation.mini_apps.shopping_channels.description": "Kataloğunuzu TikTok Shop, Shopee, Meta Catalog, Uber Eats ve diğerlerine bağlayın.",
    "Connect your catalogue to TikTok Shop, Shopee, Meta Catalog, Uber Eats, and more.": "Kataloğunuzu TikTok Shop, Shopee, Meta Catalog, Uber Eats ve diğerlerine bağlayın.",
    "navigation.mini_apps.shopping_channels.why_1": "İlanlarınızı TikTok Shop, Shopee ve Meta Catalog ile anında eşitleyin",
    "Sync your listings to TikTok Shop, Shopee, and Meta Catalog instantly": "İlanlarınızı TikTok Shop, Shopee ve Meta Catalog ile anında eşitleyin",
    "navigation.mini_apps.shopping_channels.why_2": "Yiyecek ve içecek kataloglarını Uber Eats ve Grab’e bağlayın",
    "Connect food & beverage catalogues to Uber Eats and Grab": "Yiyecek ve içecek kataloglarını Uber Eats ve Grab’e bağlayın",
    "navigation.mini_apps.shopping_channels.why_3": "Stok ve siparişler otomatik eşitlenir — tekrar veri girişi gerekmez",
    "Inventory and orders sync back automatically — no double-entry": "Stok ve siparişler otomatik eşitlenir — tekrar veri girişi gerekmez",
    "navigation.mini_apps.shopping_channels.pricing_label": "Bağlantı",
    "navigation.mini_apps.shopping_channels.pricing_detail": "Bağlı bir kanal üzerinden karşılanan sipariş başına görev tabanlı ücretlendirme.",
    "Task-based pricing per order fulfilled through a connected channel.": "Bağlı bir kanal üzerinden karşılanan sipariş başına görev tabanlı ücretlendirme.",
    "listing_configs.customize_table": "Tabloyu özelleştir",
    "Customize table": "Tabloyu özelleştir",
    "listing_configs.fields_visible": "Tabloda görünen alanlar",
    "Fields visible in table": "Tabloda görünen alanlar",
    "listing_configs.fields_hidden": "Tabloda gösterilmeyen alanlar",
    "Fields not shown in table": "Tabloda gösterilmeyen alanlar",
    "listing_configs.reset_default": "Varsayılana sıfırla",
    "listing_configs.column_title": "Başlık",
    "listing_configs.column_actions": "İşlemler",
    "listing_configs.column_website": "Web sitesi",
    "listing_configs.column_list_price": "Liste fiyatı",
    "listing_configs.column_offer_percent": "Teklif yüzdesi",
    "Offer Percent": "Teklif yüzdesi",
    "listing_configs.column_image": "Görsel",
    "listing_configs.column_offer_price": "Teklif fiyatı",
    "Offer Price": "Teklif fiyatı",
    "listing_configs.column_status": "Durum",
    "listing_configs.column_listing_id": "İlan Kimliği",
    "listing_configs.column_listing_status": "İlan durumu",
    "listing_configs.column_accounts": "Hesaplar",
    "listing_configs.column_currency": "Para birimi",
    "listing_configs.column_sold": "Satıldı",
    "listing_configs.column_goal_amount": "Hedef tutar",
    "Goal Amount": "Hedef tutar",
    "listing_configs.column_width": "Genişlik",
    "listing_configs.column_height": "Yükseklik",
    "listing_configs.column_weight": "Ağırlık",
    "listing_configs.column_volume": "Hacim",
    "Volume": "Hacim",
    "listing_configs.column_order_type": "Sipariş türü",
    "Order Type": "Sipariş türü",
    "navigation.apps_group": "Uygulamalar",
    "navigation.channels_group": "Kanallar",
    "navigation.manage_mini_apps": "Mini uygulamaları yönet",
    "Manage Mini Apps": "Mini uygulamaları yönet",
    "navigation.manage_channels": "Kanalları yönet",
    "Manage Channels": "Kanalları yönet",
    "listings.import.uploading": "Yükleniyor...",
    "listings.import.complete": "İçe aktarma tamamlandı",
    "listings.import.error": "Hata: {message}",
    "Error: {message}": "Hata: {message}",
    "listings.import.file_label": "Dosya:",
    "listings.import.select_file": "Dosya seç",
    "listings.import.response": "İçe aktarma yanıtı",
    "Import response": "İçe aktarma yanıtı",
    "listings.import.total_rows": "Toplam satır:",
    "Total rows:": "Toplam satır:",
    "listings.import.total_imported": "Toplam içe aktarılan:",
    "Total imported:": "Toplam içe aktarılan:",
    "listings.import.download_template": "İlan şablonunu indir",
    "Download listings template": "İlan şablonunu indir",
    "common.upload": "Yükle",
    "common.kanban_unavailable": "Pano görünümü geçici olarak kullanılamıyor",
    "Board view is temporarily unavailable": "Pano görünümü geçici olarak kullanılamıyor",
    "common.retry": "Yeniden dene",
    "Retry": "Yeniden dene",
    "listings.digital_assets.title": "Dijital varlıklar",
    "Digital assets": "Dijital varlıklar",
    "listings.digital_assets.not_found": "Dijital varlık bulunamadı",
    "Digital assets not found": "Dijital varlık bulunamadı",
    "listings.addon.saved": "Eklenti başarıyla kaydedildi.",
    "Add-on saved successfully.": "Eklenti başarıyla kaydedildi.",
    "listings.addon.title_required": "Lütfen bir başlık girin.",
    "Please enter a title.": "Lütfen bir başlık girin.",
    "listings.addon.price_required": "Lütfen bir fiyat girin.",
    "Please enter a price.": "Lütfen bir fiyat girin.",
    "listings.addon.no_media": "Medya dosyanız yok.",
    "listings.addon.price": "Fiyat",
    "listings.addon.offer_percentage": "Teklif yüzdesi",
    "Offer Percentage": "Teklif yüzdesi",
    "listings.addon.maximum_quantity": "Maksimum miktar",
    "Maximum Quantity": "Maksimum miktar",
    "listings.addon.stock": "Stok",
    "listings.addon.enter_price": "Fiyat girin",
    "Enter price": "Fiyat girin",
    "listings.addon.enter_offer_percentage": "Teklif yüzdesini girin",
    "Enter offer percentage": "Teklif yüzdesini girin",
    "listings.addon.enter_maximum_quantity": "Maksimum miktarı girin",
    "Enter maximum quantity": "Maksimum miktarı girin",
    "listings.addon.enter_stock": "Stok miktarını girin",
    "listings.addon.edit_title": "Eklentiyi düzenle",
    "Edit Add-on": "Eklentiyi düzenle",
    "listings.addon.add_title": "Eklenti ekle",
    "Add Add-on": "Eklenti ekle",
    "listings.addon.title": "Başlık",
    "listings.addon.enter_title": "Başlık girin",
    "listings.addon.status": "Durum (Etkin değil / Etkin)",
    "listings.addon.upload_media": "Medya yükle",
    "attributes.prefill_for": "Şunun için ön doldur",
    "Prefill for": "Şunun için ön doldur",
    "attributes.first_item": "İlk öğe",
    "First Item": "İlk öğe",
    "attributes.all_items": "Tüm öğeler",
    "All Items": "Tüm öğeler",
    "common.uploading": "Yükleniyor...",
    "common.uploading_named": "{title} yükleniyor",
    "Uploading {title}": "{title} yükleniyor",
    "common.please_wait_short": "Lütfen bekleyin",
    "Please wait": "Lütfen bekleyin",
    "attributes.select_option": "Seç",
    "attributes.select_value": "Değer seçin...",
    "Select value...": "Değer seçin...",
    "attributes.type_placeholder": "{name} yazın",
    "Type {name}": "{name} yazın",
    "attributes.multiple_values_placeholder": "Birden fazla değer girmek için virgül kullanın.",
    "Using a comma, you can enter several values.": "Birden fazla değer girmek için virgül kullanın.",
    "attributes.upload_attachment": "Ek yükle",
    "Upload Attachment": "Ek yükle",
    "attributes.upload_json_file": "JSON dosyası yükle",
    "Upload JSON File": "JSON dosyası yükle",
    "attributes.copied_value": "Değer kopyalandı",
    "Copied the value": "Değer kopyalandı",
    "attributes.latitude_longitude_placeholder": "Enlem,boylam girin (ör. 12.34,56.78)",
    "Enter latitude,longitude (e.g. 12.34,56.78)": "Enlem,boylam girin (ör. 12.34,56.78)",
    "navigation.sidebar_label": "Kenar çubuğu",
    "Side bar": "Kenar çubuğu",
    "checkout_settings.orders_option_0": "Sipariş takvimi görünümü",
    "Orders Calendar View": "Sipariş takvimi görünümü",
    "checkout_settings.show_cart_attributes": "Sepet özniteliklerini göster",
    "Show cart attributes": "Sepet özniteliklerini göster",
    "checkout_settings.select_order_status": "Sipariş durumunu seç",
    "Select order status": "Sipariş durumunu seç",
    "checkout_settings.order_status_0": "Başarıyla verildi",
    "Placed success": "Başarıyla verildi",
    "checkout_settings.order_status_1": "İşlemde",
    "In process": "İşlemde",
    "checkout_settings.order_status_2": "Kargoya verildi",
    "checkout_settings.order_status_3": "Teslim edildi",
    "checkout_settings.order_status_4": "Tamamlandı",
    "listing_form.no_categories_found": "Kategori bulunamadı. Yukarıdaki “{action}” seçeneğini kullanın.",
    "No categories found. Use “{action}” above.": "Kategori bulunamadı. Yukarıdaki “{action}” seçeneğini kullanın.",
    "common.learn_more": "Daha fazla bilgi",
    "Learn more": "Daha fazla bilgi",
    "common.show_information": "Bilgileri göster",
    "Show information": "Bilgileri göster",
    "common.paid_feature": "Ücretli özellik",
    "Paid Feature": "Ücretli özellik",
    "common.learn_more_about": "Daha fazla bilgi:",
    "Learn more about": "Daha fazla bilgi:",
    "attributes.categories": "Kategoriler",
    "attributes.edit_bulk_title": "Toplu düzenle: {title}",
    "{title} Edit Bulk": "Toplu düzenle: {title}",
    "common.enter_description": "Açıklama girin",
    "common.empty_fetch_message": "Burada henüz gösterilecek bir şey yok. İçerik olduğunda bu sayfada görünecektir.",
    "Nothing to show here yet. Once content is available, it will appear on this page.": "Burada henüz gösterilecek bir şey yok. İçerik olduğunda bu sayfada görünecektir.",
    "common.ai_credits_and_top_up": "Yapay zeka kredileri ve yükleme",
    "AI credits and top up": "Yapay zeka kredileri ve yükleme",
    "common.ai_credits_loading": "Yapay zeka kredileri yükleniyor",
    "Loading AI credits": "Yapay zeka kredileri yükleniyor",
    "common.ai_credits_unavailable": "Yapay zeka kredileri kullanılamıyor",
    "AI credits unavailable": "Yapay zeka kredileri kullanılamıyor",
    "common.ai_credits_available": "Kullanılabilir yapay zeka kredisi: {count}",
    "Available AI credits: {count}": "Kullanılabilir yapay zeka kredisi: {count}",
    "common.ai_credits_unavailable_top_up": "Yapay zeka kredileri kullanılamıyor — yüklemek için tıklayın",
    "AI credits unavailable — click to top up": "Yapay zeka kredileri kullanılamıyor — yüklemek için tıklayın",
    "common.ai_credits_available_top_up": "Kullanılabilir yapay zeka kredisi: {count} — kredi eklemek için tıklayın",
    "Available AI credits: {count} — click to add credits": "Kullanılabilir yapay zeka kredisi: {count} — kredi eklemek için tıklayın",
    "common.ai_credits_add": "Kredi ekle",
    "Add credits": "Kredi ekle",
    "navigation.switch_project": "Projeyi değiştir",
    "Switch Project": "Projeyi değiştir",
    "navigation.tenant_switch_failed": "Kiracı değiştirilemedi. Lütfen tekrar deneyin.",
    "Tenant switch failed. Please try again.": "Kiracı değiştirilemedi. Lütfen tekrar deneyin.",
    "navigation.select_project": "Proje seç",
    "Select Project": "Proje seç",
    "navigation.collapse_sidebar": "Kenar çubuğunu daralt",
    "Collapse sidebar": "Kenar çubuğunu daralt",
    "navigation.expand_sidebar": "Kenar çubuğunu genişlet",
    "Expand sidebar": "Kenar çubuğunu genişlet",
    "navigation.search": "Ara",
    "navigation.loading": "Gezinme yükleniyor",
    "Loading navigation": "Gezinme yükleniyor",
    "navigation.help_documentation": "Belgeler",
    "navigation.help_community": "Topluluk",
    "navigation.help_api_reference": "API başvurusu",
    "listings.quick_form": "Hızlı form",
    "Quick Form": "Hızlı form",
    "payments.notification_secret": "Bildirim gizli anahtarı",
    "Notification Secret": "Bildirim gizli anahtarı",
    "payments.user_type": "Kullanıcı türü",
    "User Type": "Kullanıcı türü",
    "payments.category_id": "Kategori Kimliği",
    "app_customization.other_settings": "Diğer ayarlar",
    "Other Settings": "Diğer ayarlar",
    "app_customization.other_hide_balances": "Diğer bölümünde bakiyeleri ve ödemeleri gizle",
    "app_customization.other_enable_logs": "Günlükleri etkinleştir",
    "Enable logs": "Günlükleri etkinleştir",
    "app_customization.other_signup_first": "Önce kaydolun",
    "common.beta": "(beta)",
    "(beta)": "(beta)",
    "common.selected_image": "Seçilen görsel",
    "Selected image": "Seçilen görsel",
    "common.ai_no_response_to_copy": "Kopyalanacak yanıt yok",
    "No response to copy": "Kopyalanacak yanıt yok",
    "common.copied_to_clipboard": "Panoya kopyalandı",
    "Copied to clipboard": "Panoya kopyalandı",
    "common.ai_suggestions": "Öneriler",
    "Suggestions": "Öneriler",
    "common.regenerate": "Yeniden oluştur",
    "Regenerate": "Yeniden oluştur",
    "common.esc": "ESC",
    "ESC": "ESC",
    "common.json_icon_alt": "JSON simgesi",
    "JSON icon": "JSON simgesi",
    "collections.generator_title": "Koleksiyon oluşturucu",
    "Collection Generator": "Koleksiyon oluşturucu",
    "collections.generator_create": "Koleksiyon oluştur",
    "collections.generator_json_placeholder": "JSON girdisi girin",
    "Enter JSON input": "JSON girdisi girin",
    "collections.generator_invalid_data": "Lütfen geçerli veri girin",
    "Please enter valid data": "Lütfen geçerli veri girin",
    "category.editor_select_from_media": "Medyadan seç",
    "payments.subscription": "Abonelik",
    "payments.subscription_setting_up": "Kuruluyor...",
    "Setting up...": "Kuruluyor...",
    "payments.subscription_webhook_configured": "Abonelik web kancası yapılandırıldı",
    "Subscription webhook configured": "Abonelik web kancası yapılandırıldı",
    "payments.subscription_retry_setup": "Kurulumu yeniden dene",
    "Retry setup": "Kurulumu yeniden dene",
    "payments.setup_subscription_webhook": "Abonelik web kancasını kur",
    "Setup Subscription Webhook": "Abonelik web kancasını kur",
    "orders.shipment_number": "Gönderi {number}",
    "Shipment {number}": "Gönderi {number}",
    "orders.quantity_short": "MİKTAR",
    "orders.shipment_status_1": "Gönderi oluşturuldu",
    "orders.shipment_status_2": "Gönderi işlemde",
    "orders.shipment_status_3": "Kargoya verildi",
    "orders.shipment_status_4": "Teslim alınmaya hazır",
    "orders.shipment_status_5": "Dağıtıma çıktı",
    "orders.shipment_status_6": "Teslim edilemeyen gönderi iade ediliyor",
    "orders.shipment_status_7": "Gönderi teslim edildi",
    "orders.shipment_status_8": "Gönderi teslimatı onaylandı",
    "orders.shipment_status_9": "İade başlatıldı",
    "orders.shipment_status_10": "Teslim alınmak üzere iade edildi",
    "orders.shipment_status_11": "Gönderi iadesi onaylandı",
    "orders.shipment_status_12": "Satıcı tarafından iptal edildi",
    "orders.shipment_status_13": "Müşteri tarafından iptal edildi",
    "orders.shipment_status_14": "Müşterinin konumuna ulaştı",
    "orders.shipment_status_15": "Yönetici tarafından iptal edildi",
    "attributes.metadata_title": "Meta veriler",
    "Metadata": "Meta veriler",
    "common.add_row": "Satır ekle",
    "common.no_access": "Erişiminiz yok",
    "You don't have access": "Erişiminiz yok",
    "common.error_404_message": "Üzgünüz, aradığınız sayfa şu anda kullanılamıyor. URL’yi kontrol edip tekrar deneyin veya daha sonra yeniden gelin. Sorun sürerse destek ekibiyle iletişime geçin.",
    "We're sorry, the page you are looking for is currently unavailable. Please check the URL and try again, or come back later. If you continue to experience this issue, please contact our support team for assistance. Thank you for your understanding.": "Üzgünüz, aradığınız sayfa şu anda kullanılamıyor. URL’yi kontrol edip tekrar deneyin veya daha sonra yeniden gelin. Sorun sürerse destek ekibiyle iletişime geçin.",
    "accounts.smart_upload_beta_label": "(Beta)",
    "orders.transaction_direction": "İşlem yönü",
    "Transaction direction": "İşlem yönü",
    "category.default_text": "Varsayılan metin",
    "collections.generator_open": "Koleksiyon oluşturucuyu aç",
    "Open collection generator": "Koleksiyon oluşturucuyu aç",
    "collections.duplicate_success": "Koleksiyon başarıyla çoğaltıldı",
    "Collection duplicated successfully": "Koleksiyon başarıyla çoğaltıldı",
    "collections.duplicate_failed": "Koleksiyon çoğaltılamadı",
    "Failed to duplicate collection": "Koleksiyon çoğaltılamadı",
    "listings.name_required": "İlan adı gereklidir",
    "Listing Name is required": "İlan adı gereklidir",
    "listings.category_required": "Kategori gereklidir",
    "Category is required": "Kategori gereklidir",
    "attribute_groups.edit_title": "Öznitelik grubunu düzenle",
    "Edit Attribute Group": "Öznitelik grubunu düzenle",
    "orders.create_order.validation.select_shipping_method": "Lütfen kargo yöntemini seçin",
    "Please select shipping method": "Lütfen kargo yöntemini seçin",
    "orders.create_order.validation.shipping_method_error": "Kargo yöntemi hatası",
    "Shipping Method Error": "Kargo yöntemi hatası",
    "orders.create_order.validation.select_shipping_address": "Lütfen teslimat adresini seçin",
    "Please select shipping address": "Lütfen teslimat adresini seçin",
    "orders.create_order.validation.shipping_address_error": "Teslimat adresi hatası",
    "Shipping Address Error": "Teslimat adresi hatası",
    "orders.create_order.validation.select_shipment_method": "Lütfen gönderim yöntemini seçin",
    "Please select shipment method": "Lütfen gönderim yöntemini seçin",
    "orders.create_order.validation.shipment_method_error": "Gönderim yöntemi hatası",
    "Shipment Method Error": "Gönderim yöntemi hatası",
    "orders.create_order.validation.select_payment_method": "Lütfen ödeme yöntemini seçin",
    "Please select payment method": "Lütfen ödeme yöntemini seçin",
    "orders.create_order.validation.payment_method_error": "Ödeme yöntemi hatası",
    "Payment Method Error": "Ödeme yöntemi hatası",
    "orders.create_order.validation.insufficient_balance": "Yetersiz bakiye",
    "Insufficient balance": "Yetersiz bakiye",
    "orders.create_order.validation.wallet_error": "Cüzdan hatası",
    "Wallet Error": "Cüzdan hatası",
    "attributes.value.preview_item": "Önizleme {count}",
    "Preview {count}": "Önizleme {count}",
    "attributes.value.click_to_upload": "{type} yüklemek için tıklayın",
    "Click to upload {type}": "{type} yüklemek için tıklayın",
    "attributes.value.image_upload_formats": "PNG, JPG, GIF en fazla 5 dosya",
    "PNG, JPG, GIF up to 5 files": "PNG, JPG, GIF en fazla 5 dosya",
    "attributes.value.audio_upload_formats": "MP3, WAV en fazla 1 dosya",
    "MP3, WAV up to 1 file": "MP3, WAV en fazla 1 dosya",
    "attributes.value.video_upload_formats": "MP4, MOV en fazla 1 dosya",
    "MP4, MOV up to 1 file": "MP4, MOV en fazla 1 dosya",
    "attributes.value.upload_limit": "{type} dosyası yükle (Maks. {count})",
    "Upload {type} files (Max {count})": "{type} dosyası yükle (Maks. {count})",
    "attributes.value.json_format_failed": "Geçersiz JSON - biçimlendirilemiyor",
    "Invalid JSON - cannot format": "Geçersiz JSON - biçimlendirilemiyor",
    "attributes.value.json_file_invalid": "Geçerli bir JSON dosyası seçin",
    "Please select a valid JSON file": "Geçerli bir JSON dosyası seçin",
    "attributes.value.file_empty": "Dosya boş",
    "File is empty": "Dosya boş",
    "attributes.value.json_file_parse_failed": "Geçersiz JSON dosyası: {message}",
    "Invalid JSON file: {message}": "Geçersiz JSON dosyası: {message}",
    "attributes.value.file_read_failed": "Dosya okunamadı",
    "Failed to read file": "Dosya okunamadı",
    "attributes.value.invalid_json": "Geçersiz JSON",
    "Invalid JSON": "Geçersiz JSON",
    "attributes.value.json_editor_help": "JSON dosyası yükleyin veya JSON’u doğrudan yazın/yapıştırın",
    "Upload a JSON file or type/paste JSON directly": "JSON dosyası yükleyin veya JSON’u doğrudan yazın/yapıştırın",
    "attributes.value.hex_color_code": "Onaltılık renk kodu",
    "Hex Color Code": "Onaltılık renk kodu",
    "attributes.value.multi_text_placeholder": "Yazıp eklemek için Enter veya virgüle basın",
    "Type and press Enter or comma to add": "Yazıp eklemek için Enter veya virgüle basın",
    "attributes.value.multi_text_help": "Her öğeyi eklemek için Enter veya virgüle basın",
    "Press Enter or comma to add each item": "Her öğeyi eklemek için Enter veya virgüle basın",
    "attributes.value.item_count": "{count} öğe",
    "{count} item": "{count} öğe",
    "attributes.value.items_count": "{count} öğe",
    "attributes.value.search_options": "{name} ara...",
    "Search {name}...": "{name} ara...",
    "attributes.value.selected_count": "{count} seçildi",
    "attributes.value.no_options_found": "Seçenek bulunamadı",
    "No options found": "Seçenek bulunamadı",
    "attributes.value.select_named_option": "{name} seç",
    "Select {name}": "{name} seç",
    "attributes.value.enable_option": "Bu seçeneği etkinleştir",
    "Enable this option": "Bu seçeneği etkinleştir",
    "attributes.value.enter_named_value": "{name} girin",
    "Enter {name}": "{name} girin",
    "common.valid": "Geçerli",
    "Valid": "Geçerli",
    "common.invalid": "Geçersiz",
    "Invalid": "Geçersiz",
    "common.go_back_home": "Ana sayfaya dön",
    "Go back home": "Ana sayfaya dön",
    "attributes.value.enter_named_text": "{name} girin...",
    "Enter {name}...": "{name} girin...",
    "listings.analytics.page_views": "Sayfa görüntülemeleri",
    "listings.analytics.unique_visitors": "Tekil ziyaretçiler",
    "listings.analytics.sessions": "Oturumlar",
    "listings.analytics.clicks": "Tıklamalar",
    "listings.analytics.goals": "Hedefler",
    "listings.analytics.bot_views": "Bot görüntülemeleri",
    "listings.detail_summary.buyers": "Alıcılar",
    "Buyers": "Alıcılar",
    "listings.detail_summary.orders": "Siparişler",
    "listings.detail_summary.revenue": "Gelir",
    "listings.detail_summary.average_order": "Ortalama sipariş",
    "listings.add_advanced": "Gelişmiş",
    "listings.add_audio": "Ses ekle",
    "Add Audio": "Ses ekle",
    "payments.updated_successfully": "Başarıyla güncellendi",
    "Updated successfully": "Başarıyla güncellendi",
    "users.deleted_successfully": "Kullanıcı silindi",
    "User deleted successfully": "Kullanıcı silindi",
    "users.deletion_failed": "Kullanıcı silinemedi",
    "User deletion failed": "Kullanıcı silinemedi",
    "accounts.flow.title": "Hesap deneyimini şekillendirin",
    "Shape the account experience": "Hesap deneyimini şekillendirin",
    "accounts.flow.description": "Hesap türlerini düzenleyin ve her hesap için gereken bilgileri belirleyin.",
    "Organize account types and define the information each account needs.": "Hesap türlerini düzenleyin ve her hesap için gereken bilgileri belirleyin.",
    "accounts.flow.lane_title": "Hesap temeli",
    "Account foundation": "Hesap temeli",
    "accounts.flow.badge": "Yapı",
    "Structure": "Yapı",
    "accounts.flow.node_accounts": "Hesaplar",
    "accounts.flow.node_categories": "Kategoriler",
    "accounts.flow.node_attributes": "Öznitelikler",
    "accounts.flow.lane_description": "Her hesaba net bir yer, tür ve yararlı bilgiler verin.",
    "Give every account a clear place, type, and set of useful details.": "Her hesaba net bir yer, tür ve yararlı bilgiler verin.",
    "accounts.flow.primary_action": "İlk hesabınızı ekleyin",
    "Add your first account": "İlk hesabınızı ekleyin",
    "listings.flow.title": "İlan kataloğunuzu oluşturun",
    "Build your listing catalog": "İlan kataloğunuzu oluşturun",
    "listings.flow.description": "Kategori, öznitelik ve varyantlardan oluşan düzenli bir katalog oluşturun.",
    "Create a structured catalog with categories, attributes, and variants.": "Kategori, öznitelik ve varyantlardan oluşan düzenli bir katalog oluşturun.",
    "listings.flow.lane_title": "Katalog yolu",
    "Catalog path": "Katalog yolu",
    "listings.flow.badge": "Oluştur",
    "Build": "Oluştur",
    "listings.flow.node_listings": "İlanlar",
    "listings.flow.node_categories": "Kategoriler",
    "listings.flow.node_attributes": "Öznitelikler",
    "listings.flow.node_variants": "Varyantlar",
    "listings.flow.lane_description": "Ne sattığınızı ve müşterilerin seçim yapması için gereken bilgileri belirleyin.",
    "Define what you sell and the information customers need to make a choice.": "Ne sattığınızı ve müşterilerin seçim yapması için gereken bilgileri belirleyin.",
    "listings.flow.primary_action": "İlk ilanınızı ekleyin",
    "Add your first listing": "İlk ilanınızı ekleyin",
    "collections.flow.title": "Pazar yeri içeriğinizi bir araya getirin",
    "Bring your marketplace content together": "Pazar yeri içeriğinizi bir araya getirin",
    "collections.flow.description": "İlanları ve hesapları keşfedilmesi ve yönetilmesi kolay koleksiyonlarda birleştirin.",
    "Group listings and accounts into curated collections that are easy to discover and manage.": "İlanları ve hesapları keşfedilmesi ve yönetilmesi kolay koleksiyonlarda birleştirin.",
    "collections.flow.lane_title": "Koleksiyon yolu",
    "Collection path": "Koleksiyon yolu",
    "collections.flow.badge": "Düzenle",
    "Curate": "Düzenle",
    "collections.flow.node_collections": "Koleksiyonlar",
    "collections.flow.node_rules": "Kurallar",
    "collections.flow.node_listings": "İlanlar",
    "collections.flow.lane_description": "Nelerin bir araya geleceğini seçin ve müşterilerin kolayca bulmasını sağlayın.",
    "Choose what belongs together and make it easy for customers to find.": "Nelerin bir araya geleceğini seçin ve müşterilerin kolayca bulmasını sağlayın.",
    "collections.flow.audience_lane_title": "Kitle yolu",
    "Audience path": "Kitle yolu",
    "collections.flow.audience_badge": "Bağla",
    "collections.flow.node_accounts": "Hesaplar",
    "collections.flow.node_users": "Kullanıcılar",
    "collections.flow.node_storefront": "Mağaza vitrini",
    "Storefront": "Mağaza vitrini",
    "collections.flow.audience_description": "Seçilen içerikleri hedeflenen kişiler ve vitrinlerle ilişkilendirin.",
    "Connect curated content to the people and storefronts it is meant for.": "Seçilen içerikleri hedeflenen kişiler ve vitrinlerle ilişkilendirin.",
    "collections.flow.primary_action": "İlk koleksiyonunuzu oluşturun",
    "listings.addon.image_limit": "Daha fazla görsel seçemezsiniz",
    "listings.schedule.start_time_before_end": "Başlangıç saati bitiş saatinden önce olmalıdır",
    "Start time must be before the end time": "Başlangıç saati bitiş saatinden önce olmalıdır",
    "listings.schedule.end_time_after_start": "Bitiş saati başlangıç saatinden sonra olmalıdır",
    "End time must be after the start time": "Bitiş saati başlangıç saatinden sonra olmalıdır",
    "listings.schedule.repeat_required": "Tekrarlama düzeni seçin",
    "Select a repeat pattern": "Tekrarlama düzeni seçin",
    "listing_variants.form.select_type": "Varyant türü seç",
    "Select variant type": "Varyant türü seç",
    "listing_variants.form.select_type_values": "Varyant değerlerini seç",
    "Select variant values": "Varyant değerlerini seç",
    "listing_variants.form.add_variant": "Varyant ekle",
    "listing_variants.form.edit_variant": "Varyantı düzenle",
    "Edit variant": "Varyantı düzenle",
    "listing_variants.form.variant_type": "Varyant türü",
    "Variant type": "Varyant türü",
    "listing_variants.form.variant_type_value": "Varyant değeri",
    "Variant value": "Varyant değeri",
    "listing_variants.form.variant_name": "Varyant adı",
    "Variant name": "Varyant adı",
    "listing_variants.form.description_placeholder": "Açıklama girin",
    "rewards.item_archived": "Arşivlendi",
    "listings.confirm_delete_variant": "Bu varyantı silmek istediğinizden emin misiniz?",
    "listings.confirm_delete_listing": "Bu ilanı silmek istediğinizden emin misiniz?",
    "listing_form.digital_delete_confirm": "Bu dijital içeriği silmek istediğinizden emin misiniz?",
    "Are you sure you want to delete this digital content?": "Bu dijital içeriği silmek istediğinizden emin misiniz?",
    "category.confirm_delete_attribute": "Bu özniteliği silmek istiyor musunuz?",
    "common.permission_required": "Bu işlemi gerçekleştirme izniniz yok.",
    "You do not have permission to perform this action.": "Bu işlemi gerçekleştirme izniniz yok.",
    "common.copied": "Kopyalandı",
    "attributes.editor_name_required": "Lütfen öznitelik adını girin",
    "onboarding.full_step.setup_payments.description": "Kullanıcıların işlemlerini kolayca tamamlayabilmesi için gerçek ödemeleri etkinleştirin.",
    "Enable real transactions so users can complete intent without friction.": "Kullanıcıların işlemlerini kolayca tamamlayabilmesi için gerçek ödemeleri etkinleştirin.",
    "onboarding.full_step.setup_payments.cta": "Ödemeleri ayarla",
    "Setup payments": "Ödemeleri ayarla",
    "onboarding.full_step.setup_payments.impact": "Gelir yolu etkinleştirildi.",
    "Revenue path enabled.": "Gelir yolu etkinleştirildi.",
    "onboarding.full_step.setup_payments.creator_description": "Kitlenizin satın alması veya çalışmalarınızı desteklemesi için gerekli yolu hazırlayın.",
    "Prepare the path for your audience to purchase or support your work.": "Kitlenizin satın alması veya çalışmalarınızı desteklemesi için gerekli yolu hazırlayın.",
    "onboarding.full_step.setup_delivery.description": "Kullanıcıların ödeme sürecinin öngörülebilir olması için siparişin nasıl karşılanacağını belirleyin.",
    "onboarding.full_step.setup_delivery.impact": "Sipariş karşılama yolu belirlendi.",
    "Fulfillment path clear.": "Sipariş karşılama yolu belirlendi.",
    "onboarding.full_step.add_promotion.description": "İlk oturumdaki dönüşümü artırmak için ilk promosyonunuzu oluşturun.",
    "Create your first promotion to increase first-session action rate.": "İlk oturumdaki dönüşümü artırmak için ilk promosyonunuzu oluşturun.",
    "onboarding.full_step.add_promotion.impact": "Başlangıçta daha güçlü dönüşüm.",
    "Stronger conversion during launch.": "Başlangıçta daha güçlü dönüşüm.",
    "onboarding.full_step.create_coupon.description": "İlk kez gelen alıcılar veya üyeler için indirimleri deneyin ve etkinleştirmeyi iyileştirin.",
    "Test discounts and improve activation for first-time buyers or members.": "İlk kez gelen alıcılar veya üyeler için indirimleri deneyin ve etkinleştirmeyi iyileştirin.",
    "onboarding.full_step.create_coupon.impact": "İlk teklif döngüsü açıldı.",
    "First-offer loop unlocked.": "İlk teklif döngüsü açıldı.",
    "onboarding.full_step.collections_setup.description": "Keşif ve gezinmeyi iyileştirmek için ilgi gören ilanları düzenleyin.",
    "Organize high-intent listings to improve discovery and browsing flow.": "Keşif ve gezinmeyi iyileştirmek için ilgi gören ilanları düzenleyin.",
    "onboarding.full_step.collections_setup.impact": "Gezinme ve keşif iyileştirildi.",
    "Navigation and discovery improved.": "Gezinme ve keşif iyileştirildi.",
    "onboarding.full_step.configure_comms.description": "Büyümeden önce kayıt ve sipariş sonrası bildirimleri kullanıma hazır hale getirin.",
    "Make post-signup and order notifications production-ready before growth.": "Büyümeden önce kayıt ve sipariş sonrası bildirimleri kullanıma hazır hale getirin.",
    "onboarding.full_step.configure_comms.impact": "Yaşam döngüsü mesajları hazır.",
    "Lifecycle messaging ready.": "Yaşam döngüsü mesajları hazır.",
    "onboarding.full_step.customize_attributes.description": "Kullanıcıların önemli bilgileri filtreleyip karşılaştırabilmesi için yapılandırılmış alanlar ekleyin.",
    "onboarding.full_step.customize_attributes.impact": "Arama ve dönüşüm iyileştirildi.",
    "Better search and conversion.": "Arama ve dönüşüm iyileştirildi.",
    "onboarding.full_step.customize_attributes.creator_description": "İnsanların ürettiklerinizi anlamasına ve karşılaştırmasına yardımcı olacak ayrıntıları ekleyin.",
    "Add the details that help people understand and compare what you create.": "İnsanların ürettiklerinizi anlamasına ve karşılaştırmasına yardımcı olacak ayrıntıları ekleyin.",
    "onboarding.full_step.add_digital_asset.description": "Kullanıcıların kaliteyi ve ürün çeşitliliğini değerlendirmesi için başlangıç kataloğunu genişletin.",
    "Expand initial catalog so users can evaluate quality and assortment.": "Kullanıcıların kaliteyi ve ürün çeşitliliğini değerlendirmesi için başlangıç kataloğunu genişletin.",
    "onboarding.full_step.add_digital_asset.impact": "Dijital katalog güvenilirliği artırıldı.",
    "Digital catalog credibility improved.": "Dijital katalog güvenilirliği artırıldı.",
    "onboarding.full_step.open_live_site.description": "Müşterilerin gördüklerinden başlayın. Böylece kurulum ayrıntılarına geçmeden ürün somut hale gelir.",
    "onboarding.full_step.open_live_site.impact": "Projenin zaten yayında olduğunu doğrular.",
    "onboarding.full_step.add_first_product.description": "Kitlenizin keşfetmesini istediğiniz ilk ürün, hizmet veya kaynağı yayınlayın.",
    "Publish the first product, service, or resource you want your audience to discover.": "Kitlenizin keşfetmesini istediğiniz ilk ürün, hizmet veya kaynağı yayınlayın.",
    "onboarding.full_step.add_first_product.impact": "Kitlenize yönelik ilk teklifiniz oluşturuldu.",
    "Creates your first audience-ready offer.": "Kitlenize yönelik ilk teklifiniz oluşturuldu.",
    "onboarding.full_step.customize_attributes.creator_impact": "Teklifinizin anlaşılması kolaylaştı.",
    "Makes your offer easier to understand.": "Teklifinizin anlaşılması kolaylaştı.",
    "onboarding.full_step.setup_payments.creator_impact": "Gelir elde etme yolu açıldı.",
    "listings.detail_preview_fx.title": "Döviz önizlemesi",
    "Preview FX": "Döviz önizlemesi",
    "listings.detail_preview_fx.base": "Temel para birimi",
    "Base": "Temel para birimi",
    "listings.detail_preview_fx.description": "Bu ilanı etkin her para biriminde görün.",
    "See this listing in each active currency.": "Bu ilanı etkin her para biriminde görün.",
    "listings.detail_preview_fx.refresh": "Önizlemeyi yenile",
    "Refresh preview": "Önizlemeyi yenile",
    "listings.detail_preview_fx.loading_rates": "Döviz kurları yükleniyor…",
    "Loading exchange rates…": "Döviz kurları yükleniyor…",
    "listings.detail_preview_fx.load_hint": "Güncel kurları yüklemek için Döviz önizlemesini seçin.",
    "Select Preview FX to load current rates.": "Güncel kurları yüklemek için Döviz önizlemesini seçin.",
    "listings.detail_preview_fx.preview_note": "Yalnızca önizleme. Kaydedilen ilan fiyatları değişmez.",
    "Preview only. Saved listing prices remain unchanged.": "Yalnızca önizleme. Kaydedilen ilan fiyatları değişmez.",
    "listings.detail_preview_fx.listing": "İlan",
    "listings.detail_preview_fx.variant": "Varyant",
    "Variant": "Varyant",
    "listings.detail_event_booking.event_details": "Etkinlik ayrıntıları",
    "Event Details": "Etkinlik ayrıntıları",
    "listings.detail_event_booking.booking_details": "Rezervasyon ayrıntıları",
    "Booking Details": "Rezervasyon ayrıntıları",
    "listings.unassigned_location": "Konum atanmamış",
    "Unassigned location": "Konum atanmamış",
    "listings.no_ratings_yet": "Henüz değerlendirme yok",
    "No ratings yet": "Henüz değerlendirme yok",
    "listing_form.loading_listing": "İlan yükleniyor…",
    "Loading listing…": "İlan yükleniyor…",
    "listing_form.preparing_form": "Form hazırlanıyor…",
    "Preparing form…": "Form hazırlanıyor…",
    "listing_form.edit_listing": "İlanı düzenle",
    "Edit Listing": "İlanı düzenle",
    "listing_form.add_new_listing": "Yeni ilan ekle",
    "Add New Listing": "Yeni ilan ekle",
    "workspace.catalog.templates": "Şablonlar",
    "Templates": "Şablonlar",
    "workspace.catalog.integrations": "Entegrasyonlar",
    "workspace.catalog.template": "Şablon",
    "Template": "Şablon",
    "workspace.catalog.integration": "Entegrasyon",
    "workspace.catalog.templates_heading": "Fikrinizi başlatmak için bir şablon seçin",
    "Choose a template to kickstart your Idea": "Fikrinizi başlatmak için bir şablon seçin",
    "workspace.catalog.integrations_heading": "Barındırılan web uygulamaları için entegrasyonlar",
    "Integrations for Hosted Web Apps": "Barındırılan web uygulamaları için entegrasyonlar",
    "workspace.catalog.templates_description": "Pazar yeriniz için önceden hazırlanmış bir şablonla başlayın.",
    "Start with a prebuilt template and customise it for your marketplace.": "Pazar yeriniz için önceden hazırlanmış bir şablonla başlayın.",
    "workspace.catalog.integrations_description": "Çalışma alanınızı kullandığınız araç ve hizmetlere bağlayın.",
    "Connect your workspace to the tools and services you already use.": "Çalışma alanınızı kullandığınız araç ve hizmetlere bağlayın.",
    "workspace.catalog.no_templates": "Şu anda kullanılabilir şablon yok.",
    "No templates available at the moment.": "Şu anda kullanılabilir şablon yok.",
    "workspace.catalog.no_integrations": "Şu anda kullanılabilir entegrasyon yok.",
    "No integrations available at the moment.": "Şu anda kullanılabilir entegrasyon yok.",
    "workspace.catalog.coming_soon": "Çok yakında",
    "Coming Soon": "Çok yakında",
    "workspace.catalog.configure": "Yapılandır",
    "workspace.catalog.custom_development": "Özel {type} geliştirme",
    "Custom {type} Development": "Özel {type} geliştirme",
    "workspace.catalog.custom_help": "Size özel bir şey mi gerekiyor? Teklif almak için bizimle iletişime geçin.",
    "Looking for something custom? Contact us for a quote.": "Size özel bir şey mi gerekiyor? Teklif almak için bizimle iletişime geçin.",
    "workspace.catalog.contact_quote": "Teklif için iletişime geçin",
    "Contact for a Quote": "Teklif için iletişime geçin",
    "users.select_user": "Kullanıcı seç",
    "Select User": "Kullanıcı seç",
    "developer.api_keys.paid_feature_title": "API erişimi ücretli bir özelliktir",
    "API access is a paid feature": "API erişimi ücretli bir özelliktir",
    "developer.api_keys.paid_feature_description": "Publishable ve Secret anahtarlarınızı görüntülemek, kopyalamak ve kullanmak için ücretli plan seçin.",
    "Choose a paid plan to view, copy, and use your Publishable and Secret Keys.": "Publishable ve Secret anahtarlarınızı görüntülemek, kopyalamak ve kullanmak için ücretli plan seçin.",
    "developer.api_keys.available_on_paid_plans": "Ücretli planlarda kullanılabilir",
    "Available on paid plans": "Ücretli planlarda kullanılabilir",
    "developer.api_keys.view_plans": "Planları görüntüle",
    "currency.rates.title": "Güncel döviz kurları",
    "Current FX rates": "Güncel döviz kurları",
    "currency.rates.base": "Temel para birimi:",
    "Base:": "Temel para birimi:",
    "currency.rates.source": "· Kaynak:",
    "· Source:": "· Kaynak:",
    "currency.rates.cached_up_to": "{hours} saate kadar önbelleğe alındı",
    "Cached up to {hours}h": "{hours} saate kadar önbelleğe alındı",
    "currency.rates.refresh": "Kurları yenile",
    "Refresh rates": "Kurları yenile",
    "currency.rates.currency": "Para birimi",
    "currency.rates.one_base_equals": "1 {code} eşittir",
    "1 {code} equals": "1 {code} eşittir",
    "currency.rates.empty": "Kurunu görmek için etkin bir para birimi ekleyin.",
    "Add an active currency to see its exchange rate.": "Kurunu görmek için etkin bir para birimi ekleyin.",
    "currency.rates.manual": "Manuel kurlar",
    "Manual rates": "Manuel kurlar",
    "currency.rates.load_error": "Döviz kurları yüklenemedi.",
    "Unable to load exchange rates.": "Döviz kurları yüklenemedi.",
    "chats.title": "Müşteri sohbeti",
    "Customer chat": "Müşteri sohbeti",
    "chats.conversations": "Görüşmeler",
    "Conversations": "Görüşmeler",
    "chats.empty_conversations": "Henüz müşteri görüşmesi yok.",
    "No customer conversations yet.": "Henüz müşteri görüşmesi yok.",
    "chats.customer_id": "Müşteri {id}",
    "Customer {id}": "Müşteri {id}",
    "chats.no_messages_yet": "Henüz mesaj yok",
    "No messages yet": "Henüz mesaj yok",
    "chats.conversation_id": "Görüşme #{id}",
    "Conversation #{id}": "Görüşme #{id}",
    "chats.status.closed": "kapalı",
    "closed": "kapalı",
    "chats.status.open": "açık",
    "chats.reopen": "Yeniden aç",
    "Reopen": "Yeniden aç",
    "chats.close_conversation": "Görüşmeyi kapat",
    "Close conversation": "Görüşmeyi kapat",
    "chats.your_team": "Ekibiniz",
    "Your team": "Ekibiniz",
    "chats.empty_messages": "Bu görüşmede henüz mesaj yok.",
    "No messages in this conversation yet.": "Bu görüşmede henüz mesaj yok.",
    "chats.write_reply": "Yanıt yaz",
    "Write a reply": "Yanıt yaz",
    "chats.send": "Gönder",
    "Send": "Gönder",
    "chats.select_conversation": "Mesajlarını görüntülemek için bir görüşme seçin.",
    "Select a conversation to view its messages.": "Mesajlarını görüntülemek için bir görüşme seçin.",
    "chats.error.session_not_ready": "Oturumunuz hazır değil. Sayfayı yenileyip tekrar deneyin.",
    "Your session is not ready. Refresh the page and try again.": "Oturumunuz hazır değil. Sayfayı yenileyip tekrar deneyin.",
    "chats.error.request_failed": "Sohbet isteği başarısız ({status})",
    "Chat request failed ({status})": "Sohbet isteği başarısız ({status})",
    "chats.error.load_conversations": "Görüşmeler yüklenemedi.",
    "Could not load conversations.": "Görüşmeler yüklenemedi.",
    "chats.error.load_messages": "Mesajlar yüklenemedi.",
    "Could not load messages.": "Mesajlar yüklenemedi.",
    "chats.error.send_message": "Mesaj gönderilemedi.",
    "Message could not be sent.": "Mesaj gönderilemedi.",
    "chats.error.update_status": "Görüşme durumu güncellenemedi.",
    "Conversation status could not be updated.": "Görüşme durumu güncellenemedi.",
    "accounts.select_account": "Hesap seç",
    "common.accounts": "Hesaplar",
    "common.listings": "İlanlar",
    "communications.loading_preview": "Önizleme yükleniyor…",
    "Loading preview…": "Önizleme yükleniyor…",
    "communications.no_preview": "Önizleme yok",
    "No preview": "Önizleme yok",
    "collections.choose_type": "{type} seç",
    "Choose {type}": "{type} seç",
    "collections.create_type_category_first": "Önce {type} kategorisi oluşturun",
    "Create {type} category first": "Önce {type} kategorisi oluşturun",
    "web_config.customisation": "Web özelleştirme",
    "web_config.configuration": "Web yapılandırması",
    "Web Configuration": "Web yapılandırması",
    "web_config.section_general": "Genel",
    "web_config.section_social": "Sosyal",
    "web_config.section_footer": "Altbilgi",
    "web_config.assets": "Varlıklar",
    "Assets": "Varlıklar",
    "web_config.small_logo": "Küçük logo",
    "Small logo": "Küçük logo",
    "attributes.edit_attribute": "Özniteliği düzenle",
    "currency.rate_managed_automatically": "Kur otomatik olarak yönetilir.",
    "Rate is managed automatically.": "Kur otomatik olarak yönetilir.",
    "navigation.add_or_manage_mini_apps": "Mini uygulama ekle veya yönet",
    "Add or manage Mini Apps": "Mini uygulama ekle veya yönet",
    "listings.import.download_type_template": "{type} şablonunu indir",
    "navigation.promo_banner": "Yalnızca ilk kez alışveriş yapan müşterilere %{percent} indirim! Kodu kullanın: {code}.",
    "Get {percent}% OFF! Only for first-time customers. Use code: {code}.": "Yalnızca ilk kez alışveriş yapan müşterilere %{percent} indirim! Kodu kullanın: {code}.",
    "orders.cash_refund_recorded": "Nakit iade kaydedildi. Muhasebe ters kaydı sıraya alındı.",
    "Cash refund recorded. The accounting reversal has been queued.": "Nakit iade kaydedildi. Muhasebe ters kaydı sıraya alındı.",
    "orders.cash_refund_failed": "Nakit iade kaydedilemedi. Sipariş ödeme durumunu ve iade geçmişini kontrol edin.",
    "Could not record the cash refund. Check the order payment status and refund history.": "Nakit iade kaydedilemedi. Sipariş ödeme durumunu ve iade geçmişini kontrol edin.",
    "orders.recording_cash_refund": "İade kaydediliyor…",
    "Recording refund…": "İade kaydediliyor…",
    "orders.record_cash_refund": "Nakit iadeyi kaydet",
    "Record cash refund": "Nakit iadeyi kaydet",
    "orders.confirm_cash_refund": "Nakit iadeyi onayla",
    "Confirm cash refund": "Nakit iadeyi onayla",
    "orders.cash_refund_order_amount": "{reference} siparişi için {amount} tutarında tam nakit iade kaydedilsin mi?",
    "Record a full cash refund of {amount} for order {reference}?": "{reference} siparişi için {amount} tutarında tam nakit iade kaydedilsin mi?",
    "orders.cash_refund_manual_notice": "Bu işlem manuel COD/nakit iadeyi kaydeder ve muhasebe ters kaydını sıraya alır. Ödeme sağlayıcısıyla iletişime geçilmez.",
    "This records a manual COD/cash refund and queues its accounting reversal. No payment provider will be contacted.": "Bu işlem manuel COD/nakit iadeyi kaydeder ve muhasebe ters kaydını sıraya alır. Ödeme sağlayıcısıyla iletişime geçilmez.",
    "currency_conversion.title": "Para birimi dönüştürme",
    "Currency conversion": "Para birimi dönüştürme",
    "currency_conversion.open_settings": "Dönüştürme ayarları",
    "Conversion settings": "Dönüştürme ayarları",
    "currency_conversion.load_failed": "Para birimi dönüştürme ayarları yüklenemedi.",
    "Could not load currency conversion settings.": "Para birimi dönüştürme ayarları yüklenemedi.",
    "currency_conversion.interval_error": "Yenileme aralığı 5 dakika ile 24 saat arasında olmalıdır.",
    "Refresh interval must be between 5 minutes and 24 hours.": "Yenileme aralığı 5 dakika ile 24 saat arasında olmalıdır.",
    "currency_conversion.save_failed": "Para birimi dönüştürme ayarları kaydedilemedi.",
    "Could not save currency conversion settings.": "Para birimi dönüştürme ayarları kaydedilemedi.",
    "currency_conversion.saved": "Para birimi dönüştürme ayarları kaydedildi.",
    "Currency conversion settings saved.": "Para birimi dönüştürme ayarları kaydedildi.",
    "currency_conversion.description": "Görüntülenen para birimi dönüştürmelerinin nasıl hesaplanacağını seçin.",
    "Choose how displayed currency conversions are calculated.": "Görüntülenen para birimi dönüştürmelerinin nasıl hesaplanacağını seçin.",
    "currency_conversion.manual_title": "Manuel kurlar",
    "currency_conversion.manual_help": "Aşağıda her para birimi için girilen kuru kullanın.",
    "Use the exchange rate entered for each currency below.": "Aşağıda her para birimi için girilen kuru kullanın.",
    "currency_conversion.frankfurter_title": "Frankfurter (varsayılan)",
    "Frankfurter (default)": "Frankfurter (varsayılan)",
    "currency_conversion.frankfurter_help": "Ücretsiz günlük döviz kurları. Sağlayıcı API anahtarı gerekmez.",
    "Free daily exchange rates. No provider API key is required.": "Ücretsiz günlük döviz kurları. Sağlayıcı API anahtarı gerekmez.",
    "currency_conversion.fixer_title": "Fixer",
    "Fixer": "Fixer",
    "currency_conversion.fixer_help": "Platform tarafından yönetilen Fixer hizmetini kullanın. Kur güncellemeleri sağlayıcı planına bağlıdır.",
    "Use the platform-managed Fixer service. Rate updates depend on the provider plan.": "Platform tarafından yönetilen Fixer hizmetini kullanın. Kur güncellemeleri sağlayıcı planına bağlıdır.",
    "currency_conversion.refresh_interval": "Kur yeniden kontrol aralığı (dakika)",
    "Rate re-check interval (minutes)": "Kur yeniden kontrol aralığı (dakika)",
    "workspace.currency_search_code": "Ara veya seç",
    "Search or select": "Ara veya seç",
    "workspace.currency_preset_hint": "Önerilen varsayılanlar uygulandı. Dilediğiniz alanı düzenleyebilirsiniz.",
    "Recommended defaults applied. You can edit any field.": "Önerilen varsayılanlar uygulandı. Dilediğiniz alanı düzenleyebilirsiniz.",
    "developer.api_keys.copy_unavailable": "Anahtar henüz kullanılamıyor.",
    "Key is not available yet.": "Anahtar henüz kullanılamıyor.",
    "developer.api_keys.copy_failed": "Anahtar kopyalanamadı. Tekrar deneyin.",
    "Unable to copy the key. Try again.": "Anahtar kopyalanamadı. Tekrar deneyin.",
    "payroll.action.export_pdf": "PDF olarak dışa aktar",
    "Export PDF": "PDF olarak dışa aktar",
    "cms.category.name_prompt": "Kategori adı",
    "cms.field.cover_image": "Kapak görseli",
    "Cover Image": "Kapak görseli",
    "cms.action.add_cover_photo": "Kapak fotoğrafı ekle",
    "Add cover photo": "Kapak fotoğrafı ekle",
    "cms.field.category": "Kategori",
    "cms.category.none": "Kategori yok",
    "No category": "Kategori yok",
    "cms.advanced": "Gelişmiş",
    "media_picker.action.select_image": "Görsel seç",
    "Select image": "Görsel seç",
    "orders.confirm_record_cash_refund": "İadeyi kaydet",
    "Record refund": "İadeyi kaydet",
    "listing_form.no_repeat": "Tekrarlama yok",
    "No repeat": "Tekrarlama yok",
    "listing_form.custom_repeat_days": "Özel: {days}",
    "Custom: {days}": "Özel: {days}",
    "common.sending": "Gönderiliyor…",
    "listings.detail.unique_name": "Benzersiz ad",
    "Unique Name": "Benzersiz ad",
    "app_customization.username": "Kullanıcı adı",
    "workspace.templates.name_required": "Şablon adı gereklidir.",
    "Template name is required.": "Şablon adı gereklidir.",
    "workspace.templates.saved": "Rol şablonu kaydedildi.",
    "Role template saved.": "Rol şablonu kaydedildi.",
    "workspace.templates.confirm_delete": "“{name}” şablonu silinsin mi?",
    "Delete template \"{name}\"?": "“{name}” şablonu silinsin mi?",
    "workspace.templates.deleted": "Şablon silindi.",
    "Template deleted.": "Şablon silindi.",
    "workspace.members.tab_members": "Üyeler",
    "workspace.templates.tab": "Rol şablonları",
    "Role Templates": "Rol şablonları",
    "workspace.templates.title": "Rol şablonları",
    "workspace.templates.new": "Yeni şablon",
    "New Template": "Yeni şablon",
    "workspace.templates.name": "Ad",
    "workspace.templates.empty": "Henüz rol şablonu yok.",
    "No role templates yet.": "Henüz rol şablonu yok.",
    "workspace.templates.edit": "Şablonu düzenle",
    "Edit Template": "Şablonu düzenle",
    "workspace.templates.name_label": "Şablon adı",
    "Template name": "Şablon adı",
    "workspace.templates.name_placeholder": "ör. İçerik Yöneticisi",
    "e.g. Content Manager": "ör. İçerik Yöneticisi",
    "listings.import.unknown_error": "Kategoriler içe aktarılamadı. CSV dosyasını kontrol edip tekrar deneyin.",
    "The categories could not be imported. Please check the CSV and try again.": "Kategoriler içe aktarılamadı. CSV dosyasını kontrol edip tekrar deneyin.",
    "common.no_access_to_page": "Erişim yok",
    "No access": "Erişim yok",
    "common.permission_to_view_page_denied": "Bu sayfayı görüntüleme izniniz yok.",
    "You do not have permission to view this page.": "Bu sayfayı görüntüleme izniniz yok.",
    "common.loading_permissions": "İzinler yükleniyor…",
    "Loading permissions…": "İzinler yükleniyor…",
    "attributes.added_successfully": "Harika 🎉, öznitelikler başarıyla eklendi",
    "Nice 🎉, Successfully added attributes": "Harika 🎉, öznitelikler başarıyla eklendi",
    "attributes.add_attribute_values": "Öznitelik değerleri ekle",
    "attributes.attribute": "Öznitelik",
    "attributes.optional": "İsteğe bağlı",
    "attributes.private": "Özel",
    "attributes.hidden_field": "Gizli alan",
    "attributes.show_in_filter": "Filtrede göster",
    "attributes.status_not_active_active": "Durum (Etkin değil / Etkin)",
    "attributes.add_metadata": "Meta veri ekle",
    "Add metadata": "Meta veri ekle",
    "attributes.select_date_time": "Tarih ve saat seç",
    "listings.addons.column_title": "Başlık",
    "listings.addons.column_image": "Görsel",
    "listings.addons.column_price": "Fiyat",
    "listings.addons.column_max_quantity": "Maksimum miktar",
    "Max Quantity": "Maksimum miktar",
    "listings.addons.column_offer": "Teklif",
    "listings.addons.column_stock": "Stok",
    "listings.addons.column_action": "İşlem",
    "listings.addons.column_status": "Durum",
    "listings.addons.confirm_delete": "Bu eklenti türü silinsin mi?",
    "Do you want to delete this add-on type?": "Bu eklenti türü silinsin mi?",
    "common.share_collection": "Koleksiyonu paylaş",
    "Share collection": "Koleksiyonu paylaş",
    "communications.view_modes": "İletişim görüntüleme modları",
    "Communication view modes": "İletişim görüntüleme modları",
    "payments.accessibility.gateway_logo": "Ödeme ağ geçidi logosu",
    "Payment gateway logo": "Ödeme ağ geçidi logosu",
    "common.build_version": "Derleme sürümü",
    "Build version": "Derleme sürümü",
    "common.build_label": "derleme",
    "build": "derleme",
    "listings.under_category_title": "{category} kategorisindeki ilanlar",
    "Listings under {category}": "{category} kategorisindeki ilanlar",
    "attributes.signup": "Kaydol",
    "Signup": "Kaydol",
    "common.toast.please_check_action": "Lütfen bu işlemi kontrol edin",
    "Please check this action": "Lütfen bu işlemi kontrol edin",
    "common.information": "Bilgi",
    "listing_form.error.load_listing_data": "İlan verileri yüklenemedi",
    "Failed to load listing data": "İlan verileri yüklenemedi",
    "listing_form.error.load_digital_contents": "Dijital içerikler yüklenemedi",
    "Failed to load digital contents": "Dijital içerikler yüklenemedi",
    "listing_form.validation.audio_file_or_url_required": "Bölümü oluşturmadan önce bir ses dosyası veya herkese açık ses URL’si ekleyin.",
    "Add an audio file or public audio URL before creating the episode.": "Bölümü oluşturmadan önce bir ses dosyası veya herkese açık ses URL’si ekleyin.",
    "listing_form.validation.rental_rate_greater_than_zero": "0’dan büyük bir kiralama ücreti girin.",
    "Enter a rental rate greater than 0.": "0’dan büyük bir kiralama ücreti girin.",
    "listing_form.validation.maximum_duration_gte_minimum": "Maksimum süre, minimum süreye eşit veya daha uzun olmalıdır.",
    "Maximum duration must be greater than or equal to minimum duration.": "Maksimum süre, minimum süreye eşit veya daha uzun olmalıdır.",
    "listing_form.updated_successfully": "İlan başarıyla güncellendi!",
    "Listing updated successfully!": "İlan başarıyla güncellendi!",
    "listing_form.created_successfully": "İlan başarıyla oluşturuldu!",
    "Listing created successfully!": "İlan başarıyla oluşturuldu!",
    "listing_form.error.save_failed": "İlan kaydedilemedi. Lütfen tekrar deneyin.",
    "Failed to save listing. Please try again.": "İlan kaydedilemedi. Lütfen tekrar deneyin.",
    "listing_form.error.delete_variant_failed": "Varyant silinemedi: {title}",
    "Failed to delete variant: {title}": "Varyant silinemedi: {title}",
    "listing_form.error.variant_action_failed": "Varyant {title} için {action} işlemi başarısız oldu",
    "Failed to {action} variant: {title}": "Varyant {title} için {action} işlemi başarısız oldu",
    "listing_form.error.digital_content_action_failed": "Dijital içerik {title} için {action} işlemi başarısız oldu",
    "Failed to {action} digital content: {title}": "Dijital içerik {title} için {action} işlemi başarısız oldu",
    "listing_form.action.create": "oluştur",
    "listing_form.action.update": "güncelle",
    "listing_form.action.delete": "sil",
    "delete": "sil",
    "listing_form.error.save_request_failed": "İlan kaydedilemedi",
    "Failed to save listing": "İlan kaydedilemedi",
    "listing_form.error.rental_settings_save_failed": "İlan kaydedildi ancak kiralama ayarları kaydedilemedi.",
    "Listing saved, but rental settings could not be saved.": "İlan kaydedildi ancak kiralama ayarları kaydedilemedi.",
    "users.action_failed": "İşlem başarısız oldu. Lütfen tekrar deneyin.",
    "Action failed. Please try again.": "İşlem başarısız oldu. Lütfen tekrar deneyin.",
    "common.successfully_added": "Başarıyla eklendi",
    "Successfully added": "Başarıyla eklendi",
    "listing_form.validation.title_min_length": "Başlık en az {count} karakter olmalıdır",
    "Title must be at least {count} characters": "Başlık en az {count} karakter olmalıdır",
    "listing_form.validation.title_max_length": "Başlık {count} karakteri aşmamalıdır",
    "Title must not exceed {count} characters": "Başlık {count} karakteri aşmamalıdır",
    "listing_form.validation.price_minimum": "Fiyat en az {amount} olmalıdır",
    "Price must be at least {amount}": "Fiyat en az {amount} olmalıdır",
    "listing_form.validation.attribute_required": "{attribute} gereklidir",
    "listings.error.load_failed": "İlanlar yüklenemedi",
    "Unable to load listings": "İlanlar yüklenemedi",
    "communications.from_email_required_before_verification": "Doğrulamadan önce gönderen e-posta adresini girin.",
    "Please enter From email address before verifying.": "Doğrulamadan önce gönderen e-posta adresini girin.",
    "communications.verification_email_sent": "Doğrulama e-postası gönderildi. Gelen kutunuzu kontrol edin ve bu e-posta adresini doğrulamak için talimatları izleyin.",
    "A verification email has been sent. Please check your inbox and follow the instructions to verify this email address.": "Doğrulama e-postası gönderildi. Gelen kutunuzu kontrol edin ve bu e-posta adresini doğrulamak için talimatları izleyin.",
    "communications.verification_start_failed": "Doğrulama başlatılamadı. Lütfen tekrar deneyin.",
    "Unable to start verification. Please try again.": "Doğrulama başlatılamadı. Lütfen tekrar deneyin.",
    "common.uploaded_successfully": "Başarıyla yüklendi",
    "upgrade_page.panel.yearly": "Yıllık",
    "upgrade_page.panel.monthly": "Aylık",
    "orders.advance_paid": "Avans ödendi",
    "Advance paid": "Avans ödendi",
    "orders.balance_due": "Kalan tutar",
    "Balance due": "Kalan tutar",
    "orders.advance_invalid": "Sipariş toplamından daha düşük bir tutar girin.",
    "Enter an amount less than the order total.": "Sipariş toplamından daha düşük bir tutar girin.",
    "orders.advance_failed": "Avans kaydedilemedi.",
    "Could not save the advance.": "Avans kaydedilemedi.",
    "orders.edit_advance": "Avansı düzenle",
    "Edit advance": "Avansı düzenle",
    "orders.record_advance": "Avans kaydet",
    "Record advance": "Avans kaydet",
    "orders.advance_notice": "Müşterinin şimdiye kadar ödediği tutar, {total} sipariş toplamından düşük olmalıdır. Kalan tutarı ödendi olarak işaretleyene kadar sipariş ödenmemiş kalır. Avansı kaldırmak için 0 girin.",
    "Amount the customer has paid so far, less than the order total of {total}. The order stays unpaid until you mark the balance as paid. Enter 0 to remove the advance.": "Müşterinin şimdiye kadar ödediği tutar, {total} sipariş toplamından düşük olmalıdır. Kalan tutarı ödendi olarak işaretleyene kadar sipariş ödenmemiş kalır. Avansı kaldırmak için 0 girin.",
    "orders.save_advance": "Kaydet",
    "common.hide": "Gizle",
    "listings.repeat.daily": "Her gün",
    "listings.repeat.weekdays": "Hafta içi (Pzt-Cum)",
    "Weekdays (Mon-Fri)": "Hafta içi (Pzt-Cum)",
    "listings.repeat.weekend": "Hafta sonu (Cmt-Paz)",
    "Weekend (Sat-Sun)": "Hafta sonu (Cmt-Paz)",
    "listings.repeat.custom": "Özel",
    "listings.weekday.sun": "Paz",
    "Sun": "Paz",
    "listings.weekday.mon": "Pzt",
    "Mon": "Pzt",
    "listings.weekday.tue": "Sal",
    "Tue": "Sal",
    "listings.weekday.wed": "Çar",
    "Wed": "Çar",
    "listings.weekday.thu": "Per",
    "Thu": "Per",
    "listings.weekday.fri": "Cum",
    "Fri": "Cum",
    "listings.weekday.sat": "Cmt",
    "Sat": "Cmt",
    "orders.pay_balance": "Kalanı öde {amount}",
    "Pay balance {amount}": "Kalanı öde {amount}",
    "orders.partially_paid": "Kısmen ödendi",
    "Partially paid": "Kısmen ödendi",
    "orders.balance_amount": "Bakiye {amount}",
    "Balance {amount}": "Bakiye {amount}",
    "delivery.get_started.add_branch": "Şube ekle",
    "Add branch": "Şube ekle",
    "delivery.get_started.add_fleet": "Filo ekle",
    "Add fleet": "Filo ekle",
    "delivery.get_started.api_documentation": "API belgeleri",
    "API Documentation": "API belgeleri",
    "delivery.get_started.add_driver": "Sürücü ekle",
    "Add driver": "Sürücü ekle",
    "delivery.get_started.branch_title": "Şubenizi ekleyin",
    "Add your branch": "Şubenizi ekleyin",
    "delivery.get_started.branch_description": "Bir şubede birden fazla filo ve sürücü olabilir",
    "A branch can have many fleets and drivers": "Bir şubede birden fazla filo ve sürücü olabilir",
    "delivery.get_started.fleet_title": "Filonuzu ekleyin",
    "Add your fleet": "Filonuzu ekleyin",
    "delivery.get_started.fleet_description": "Bir filo bir sürücüye atanabilir",
    "A fleet can be assigned to a driver": "Bir filo bir sürücüye atanabilir",
    "delivery.get_started.driver_title": "Sürücünüzü ekleyin",
    "Add your driver": "Sürücünüzü ekleyin",
    "delivery.get_started.driver_description": "Sürücü siparişinizi teslim edecek",
    "The driver will deliver your order": "Sürücü siparişinizi teslim edecek",
    "delivery.get_started.order_title": "İlk siparişinizi oluşturun",
    "Create your first order": "İlk siparişinizi oluşturun",
    "delivery.get_started.order_description": "Siparişler API üzerinden oluşturulabilir",
    "Orders can be created through the API": "Siparişler API üzerinden oluşturulabilir",
    "delivery.get_started.progress.branches": "Şubeler",
    "Branches": "Şubeler",
    "delivery.get_started.progress.fleets": "Filolar",
    "Fleets": "Filolar",
    "delivery.get_started.progress.drivers": "Sürücüler",
    "Drivers": "Sürücüler",
    "delivery.get_started.progress.orders": "Teslimat siparişleri",
    "Delivery Orders": "Teslimat siparişleri",
    "delivery.get_started.welcome": "Hoş geldiniz:",
    "Welcome to": "Hoş geldiniz:",
    "delivery.get_started.question": "Ne yapmak istersiniz?",
    "What would you like to do?": "Ne yapmak istersiniz?",
    "workspace.templates.built_in": "Yerleşik",
    "Built-in": "Yerleşik",
    "workspace.templates.copy_of": "{name} kopyası",
    "Copy of {name}": "{name} kopyası",
    "workspace.members.role": "Rol",
    "Role": "Rol",
    "workspace.members.role_full_access": "Tam erişim",
    "Full access": "Tam erişim",
    "workspace.templates.duplicate": "Çoğalt",
    "workspace.members.role_custom": "Özel (aşağıda ayarlayın)",
    "Custom (set below)": "Özel (aşağıda ayarlayın)"
  }
};
